/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "./frontend/" + ({"0":"app"}[chunkId]||chunkId) + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(2);
	
	__webpack_require__(325);
	
	__webpack_require__(326);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(57);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(70);
	__webpack_require__(72);
	__webpack_require__(74);
	__webpack_require__(76);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(85);
	__webpack_require__(87);
	__webpack_require__(89);
	__webpack_require__(92);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(168);
	__webpack_require__(169);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(189);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(206);
	__webpack_require__(216);
	__webpack_require__(220);
	__webpack_require__(221);
	__webpack_require__(223);
	__webpack_require__(224);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(323);
	__webpack_require__(324);
	module.exports = __webpack_require__(9);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(6);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var META = __webpack_require__(22).KEY;
	var $fails = __webpack_require__(7);
	var shared = __webpack_require__(23);
	var setToStringTag = __webpack_require__(24);
	var uid = __webpack_require__(19);
	var wks = __webpack_require__(25);
	var wksExt = __webpack_require__(26);
	var wksDefine = __webpack_require__(27);
	var keyOf = __webpack_require__(29);
	var enumKeys = __webpack_require__(42);
	var isArray = __webpack_require__(45);
	var anObject = __webpack_require__(12);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(16);
	var createDesc = __webpack_require__(17);
	var _create = __webpack_require__(46);
	var gOPNExt = __webpack_require__(49);
	var $GOPD = __webpack_require__(51);
	var $DP = __webpack_require__(11);
	var $keys = __webpack_require__(30);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(50).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(44).f = $propertyIsEnumerable;
	  __webpack_require__(43).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(28)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key) {
	    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var hide = __webpack_require__(10);
	var redefine = __webpack_require__(18);
	var ctx = __webpack_require__(20);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	module.exports = __webpack_require__(6) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var toPrimitive = __webpack_require__(16);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(7)(function () {
	  return Object.defineProperty(__webpack_require__(15)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(4).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var has = __webpack_require__(5);
	var SRC = __webpack_require__(19)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(9).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(21);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(19)('meta');
	var isObject = __webpack_require__(13);
	var has = __webpack_require__(5);
	var setDesc = __webpack_require__(11).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f;
	var has = __webpack_require__(5);
	var TAG = __webpack_require__(25)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(23)('wks');
	var uid = __webpack_require__(19);
	var Symbol = __webpack_require__(4).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(25);


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var LIBRARY = __webpack_require__(28);
	var wksExt = __webpack_require__(26);
	var defineProperty = __webpack_require__(11).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(30);
	var toIObject = __webpack_require__(32);
	module.exports = function (object, el) {
	  var O = toIObject(object);
	  var keys = getKeys(O);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) if (O[key = keys[index++]] === el) return key;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(31);
	var enumBugKeys = __webpack_require__(41);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(5);
	var toIObject = __webpack_require__(32);
	var arrayIndexOf = __webpack_require__(36)(false);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(33);
	var defined = __webpack_require__(35);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(37);
	var toAbsoluteIndex = __webpack_require__(39);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(38);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(23)('keys');
	var uid = __webpack_require__(19);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(30);
	var gOPS = __webpack_require__(43);
	var pIE = __webpack_require__(44);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(12);
	var dPs = __webpack_require__(47);
	var enumBugKeys = __webpack_require__(41);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(15)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(48).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var anObject = __webpack_require__(12);
	var getKeys = __webpack_require__(30);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(4).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32);
	var gOPN = __webpack_require__(50).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(31);
	var hiddenKeys = __webpack_require__(41).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(44);
	var createDesc = __webpack_require__(17);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(16);
	var has = __webpack_require__(5);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(46) });


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperties: __webpack_require__(47) });


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(32);
	var $getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	__webpack_require__(56)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var fails = __webpack_require__(7);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(58);
	var $getPrototypeOf = __webpack_require__(59);
	
	__webpack_require__(56)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(35);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(5);
	var toObject = __webpack_require__(58);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(58);
	var $keys = __webpack_require__(30);
	
	__webpack_require__(56)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(56)('getOwnPropertyNames', function () {
	  return __webpack_require__(49).f;
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(69) });


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(30);
	var gOPS = __webpack_require__(43);
	var pIE = __webpack_require__(44);
	var toObject = __webpack_require__(58);
	var IObject = __webpack_require__(33);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { is: __webpack_require__(71) });


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(73).set });


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(20)(Function.call, __webpack_require__(51).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(75);
	var test = {};
	test[__webpack_require__(25)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(18)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34);
	var TAG = __webpack_require__(25)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', { bind: __webpack_require__(77) });


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(21);
	var isObject = __webpack_require__(13);
	var invoke = __webpack_require__(78);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(13);
	var getPrototypeOf = __webpack_require__(59);
	var HAS_INSTANCE = __webpack_require__(25)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(11).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(82);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt;
	var $trim = __webpack_require__(83).trim;
	var ws = __webpack_require__(84);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var defined = __webpack_require__(35);
	var fails = __webpack_require__(7);
	var spaces = __webpack_require__(84);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(86);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat;
	var $trim = __webpack_require__(83).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(84) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var cof = __webpack_require__(34);
	var inheritIfRequired = __webpack_require__(88);
	var toPrimitive = __webpack_require__(16);
	var fails = __webpack_require__(7);
	var gOPN = __webpack_require__(50).f;
	var gOPD = __webpack_require__(51).f;
	var dP = __webpack_require__(11).f;
	var $trim = __webpack_require__(83).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(46)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(6) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(18)(global, NUMBER, $Number);
	}


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var setPrototypeOf = __webpack_require__(73).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toInteger = __webpack_require__(38);
	var aNumberValue = __webpack_require__(90);
	var repeat = __webpack_require__(91);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(38);
	var defined = __webpack_require__(35);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $fails = __webpack_require__(7);
	var aNumberValue = __webpack_require__(90);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(8);
	var _isFinite = __webpack_require__(4).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(96) });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(8);
	var isInteger = __webpack_require__(96);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(86);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(82);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8);
	var log1p = __webpack_require__(104);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8);
	var sign = __webpack_require__(108);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8);
	var $expm1 = __webpack_require__(112);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { fround: __webpack_require__(114) });


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(108);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(104) });


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { sign: __webpack_require__(108) });


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(112);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(112);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(39);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(37);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(83)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(128)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(129)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var defined = __webpack_require__(35);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(28);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var hide = __webpack_require__(10);
	var has = __webpack_require__(5);
	var Iterators = __webpack_require__(130);
	var $iterCreate = __webpack_require__(131);
	var setToStringTag = __webpack_require__(24);
	var getPrototypeOf = __webpack_require__(59);
	var ITERATOR = __webpack_require__(25)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(46);
	var descriptor = __webpack_require__(17);
	var setToStringTag = __webpack_require__(24);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(25)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(128)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(37);
	var context = __webpack_require__(134);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(135);
	var defined = __webpack_require__(35);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13);
	var cof = __webpack_require__(34);
	var MATCH = __webpack_require__(25)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(25)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(8);
	var context = __webpack_require__(134);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(91)
	});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(37);
	var context = __webpack_require__(134);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(141)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(35);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(141)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(141)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(141)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(141)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(141)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(141)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(141)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(141)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(141)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(141)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(141)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(141)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var toPrimitive = __webpack_require__(16);
	
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8);
	var toISOString = __webpack_require__(157);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(7);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(18)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(25)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(10)(proto, TO_PRIMITIVE, __webpack_require__(160));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(45) });


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(20);
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var call = __webpack_require__(163);
	var isArrayIter = __webpack_require__(164);
	var toLength = __webpack_require__(37);
	var createProperty = __webpack_require__(165);
	var getIterFn = __webpack_require__(166);
	
	$export($export.S + $export.F * !__webpack_require__(167)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(130);
	var ITERATOR = __webpack_require__(25)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(75);
	var ITERATOR = __webpack_require__(25)('iterator');
	var Iterators = __webpack_require__(130);
	module.exports = __webpack_require__(9).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(25)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var createProperty = __webpack_require__(165);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(32);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(33) != Object || !__webpack_require__(170)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var html = __webpack_require__(48);
	var cof = __webpack_require__(34);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(21);
	var toObject = __webpack_require__(58);
	var fails = __webpack_require__(7);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(170)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $forEach = __webpack_require__(174)(0);
	var STRICT = __webpack_require__(170)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(20);
	var IObject = __webpack_require__(33);
	var toObject = __webpack_require__(58);
	var toLength = __webpack_require__(37);
	var asc = __webpack_require__(175);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(176);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var isArray = __webpack_require__(45);
	var SPECIES = __webpack_require__(25)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $map = __webpack_require__(174)(1);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $filter = __webpack_require__(174)(2);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $some = __webpack_require__(174)(3);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $every = __webpack_require__(174)(4);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(182);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21);
	var toObject = __webpack_require__(58);
	var IObject = __webpack_require__(33);
	var toLength = __webpack_require__(37);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(182);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $indexOf = __webpack_require__(36)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(170)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(32);
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(37);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(170)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(187) });
	
	__webpack_require__(188)('copyWithin');


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(25)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { fill: __webpack_require__(190) });
	
	__webpack_require__(188)('fill');


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(174)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(188)(KEY);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(174)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(188)(KEY);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(194)('Array');


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var dP = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(6);
	var SPECIES = __webpack_require__(25)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(188);
	var step = __webpack_require__(196);
	var Iterators = __webpack_require__(130);
	var toIObject = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(129)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var inheritIfRequired = __webpack_require__(88);
	var dP = __webpack_require__(11).f;
	var gOPN = __webpack_require__(50).f;
	var isRegExp = __webpack_require__(135);
	var $flags = __webpack_require__(198);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(7)(function () {
	  re2[__webpack_require__(25)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(18)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(194)('RegExp');


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(200);
	var anObject = __webpack_require__(12);
	var $flags = __webpack_require__(198);
	var DESCRIPTORS = __webpack_require__(6);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(6) && /./g.flags != 'g') __webpack_require__(11).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(198)
	});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(202)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(10);
	var redefine = __webpack_require__(18);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(35);
	var wks = __webpack_require__(25);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(202)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(202)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(202)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(135);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(28);
	var global = __webpack_require__(4);
	var ctx = __webpack_require__(20);
	var classof = __webpack_require__(75);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var anInstance = __webpack_require__(207);
	var forOf = __webpack_require__(208);
	var speciesConstructor = __webpack_require__(209);
	var task = __webpack_require__(210).set;
	var microtask = __webpack_require__(211)();
	var newPromiseCapabilityModule = __webpack_require__(212);
	var perform = __webpack_require__(213);
	var promiseResolve = __webpack_require__(214);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(25)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var sameConstructor = LIBRARY ? function (a, b) {
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	} : function (a, b) {
	  return a === b;
	};
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(215)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return sameConstructor($Promise, C)
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(24)($Promise, PROMISE);
	__webpack_require__(194)(PROMISE);
	Wrapper = __webpack_require__(9)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
	    return promiseResolve(this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(167)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(20);
	var call = __webpack_require__(163);
	var isArrayIter = __webpack_require__(164);
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(37);
	var getIterFn = __webpack_require__(166);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(21);
	var SPECIES = __webpack_require__(25)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(20);
	var invoke = __webpack_require__(78);
	var html = __webpack_require__(48);
	var cel = __webpack_require__(15);
	var global = __webpack_require__(4);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(34)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var macrotask = __webpack_require__(210).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(21);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var newPromiseCapability = __webpack_require__(212);
	
	module.exports = function (C, x) {
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(18);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(217);
	var validate = __webpack_require__(218);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(219)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(11).f;
	var create = __webpack_require__(46);
	var redefineAll = __webpack_require__(215);
	var ctx = __webpack_require__(20);
	var anInstance = __webpack_require__(207);
	var forOf = __webpack_require__(208);
	var $iterDefine = __webpack_require__(129);
	var step = __webpack_require__(196);
	var setSpecies = __webpack_require__(194);
	var DESCRIPTORS = __webpack_require__(6);
	var fastKey = __webpack_require__(22).fastKey;
	var validate = __webpack_require__(218);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var redefineAll = __webpack_require__(215);
	var meta = __webpack_require__(22);
	var forOf = __webpack_require__(208);
	var anInstance = __webpack_require__(207);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var $iterDetect = __webpack_require__(167);
	var setToStringTag = __webpack_require__(24);
	var inheritIfRequired = __webpack_require__(88);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(217);
	var validate = __webpack_require__(218);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(219)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(174)(0);
	var redefine = __webpack_require__(18);
	var meta = __webpack_require__(22);
	var assign = __webpack_require__(69);
	var weak = __webpack_require__(222);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var validate = __webpack_require__(218);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(219)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(215);
	var getWeak = __webpack_require__(22).getWeak;
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var anInstance = __webpack_require__(207);
	var forOf = __webpack_require__(208);
	var createArrayMethod = __webpack_require__(174);
	var $has = __webpack_require__(5);
	var validate = __webpack_require__(218);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(222);
	var validate = __webpack_require__(218);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(219)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $typed = __webpack_require__(225);
	var buffer = __webpack_require__(226);
	var anObject = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	var isObject = __webpack_require__(13);
	var ArrayBuffer = __webpack_require__(4).ArrayBuffer;
	var speciesConstructor = __webpack_require__(209);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(194)(ARRAY_BUFFER);


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var uid = __webpack_require__(19);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(6);
	var LIBRARY = __webpack_require__(28);
	var $typed = __webpack_require__(225);
	var hide = __webpack_require__(10);
	var redefineAll = __webpack_require__(215);
	var fails = __webpack_require__(7);
	var anInstance = __webpack_require__(207);
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(37);
	var toIndex = __webpack_require__(227);
	var gOPN = __webpack_require__(50).f;
	var dP = __webpack_require__(11).f;
	var arrayFill = __webpack_require__(190);
	var setToStringTag = __webpack_require__(24);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(37);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(225).ABV, {
	  DataView: __webpack_require__(226).DataView
	});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(6)) {
	  var LIBRARY = __webpack_require__(28);
	  var global = __webpack_require__(4);
	  var fails = __webpack_require__(7);
	  var $export = __webpack_require__(8);
	  var $typed = __webpack_require__(225);
	  var $buffer = __webpack_require__(226);
	  var ctx = __webpack_require__(20);
	  var anInstance = __webpack_require__(207);
	  var propertyDesc = __webpack_require__(17);
	  var hide = __webpack_require__(10);
	  var redefineAll = __webpack_require__(215);
	  var toInteger = __webpack_require__(38);
	  var toLength = __webpack_require__(37);
	  var toIndex = __webpack_require__(227);
	  var toAbsoluteIndex = __webpack_require__(39);
	  var toPrimitive = __webpack_require__(16);
	  var has = __webpack_require__(5);
	  var classof = __webpack_require__(75);
	  var isObject = __webpack_require__(13);
	  var toObject = __webpack_require__(58);
	  var isArrayIter = __webpack_require__(164);
	  var create = __webpack_require__(46);
	  var getPrototypeOf = __webpack_require__(59);
	  var gOPN = __webpack_require__(50).f;
	  var getIterFn = __webpack_require__(166);
	  var uid = __webpack_require__(19);
	  var wks = __webpack_require__(25);
	  var createArrayMethod = __webpack_require__(174);
	  var createArrayIncludes = __webpack_require__(36);
	  var speciesConstructor = __webpack_require__(209);
	  var ArrayIterators = __webpack_require__(195);
	  var Iterators = __webpack_require__(130);
	  var $iterDetect = __webpack_require__(167);
	  var setSpecies = __webpack_require__(194);
	  var arrayFill = __webpack_require__(190);
	  var arrayCopyWithin = __webpack_require__(187);
	  var $DP = __webpack_require__(11);
	  var $GOPD = __webpack_require__(51);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(21);
	var anObject = __webpack_require__(12);
	var rApply = (__webpack_require__(4).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(8);
	var create = __webpack_require__(46);
	var aFunction = __webpack_require__(21);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var bind = __webpack_require__(77);
	var rConstruct = (__webpack_require__(4).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(11);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(8);
	var gOPD = __webpack_require__(51).f;
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(131)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(51);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(51);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(8);
	var getProto = __webpack_require__(59);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(250) });


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(50);
	var gOPS = __webpack_require__(43);
	var anObject = __webpack_require__(12);
	var Reflect = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(11);
	var gOPD = __webpack_require__(51);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var createDesc = __webpack_require__(17);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(8);
	var setProto = __webpack_require__(73);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(8);
	var $includes = __webpack_require__(36)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(188)('includes');


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(256);
	var toObject = __webpack_require__(58);
	var toLength = __webpack_require__(37);
	var aFunction = __webpack_require__(21);
	var arraySpeciesCreate = __webpack_require__(175);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(188)('flatMap');


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(45);
	var isObject = __webpack_require__(13);
	var toLength = __webpack_require__(37);
	var ctx = __webpack_require__(20);
	var IS_CONCAT_SPREADABLE = __webpack_require__(25)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(256);
	var toObject = __webpack_require__(58);
	var toLength = __webpack_require__(37);
	var toInteger = __webpack_require__(38);
	var arraySpeciesCreate = __webpack_require__(175);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(188)('flatten');


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(128)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(260);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(37);
	var repeat = __webpack_require__(91);
	var defined = __webpack_require__(35);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(260);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(8);
	var defined = __webpack_require__(35);
	var toLength = __webpack_require__(37);
	var isRegExp = __webpack_require__(135);
	var getFlags = __webpack_require__(198);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(27)('asyncIterator');


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(27)('observable');


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(8);
	var ownKeys = __webpack_require__(250);
	var toIObject = __webpack_require__(32);
	var gOPD = __webpack_require__(51);
	var createProperty = __webpack_require__(165);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $values = __webpack_require__(269)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(30);
	var toIObject = __webpack_require__(32);
	var isEnum = __webpack_require__(44).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $entries = __webpack_require__(269)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var aFunction = __webpack_require__(21);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(272), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(28) || !__webpack_require__(7)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(4)[K];
	});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var aFunction = __webpack_require__(21);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(272), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(272), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(272), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(277)('Map') });


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(75);
	var from = __webpack_require__(278);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(208);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(277)('Set') });


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(281)('Map');


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(281)('Set');


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(281)('WeakMap');


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(281)('WeakSet');


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(286)('Map');


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(21);
	var ctx = __webpack_require__(20);
	var forOf = __webpack_require__(208);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(286)('Set');


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(286)('WeakMap');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(286)('WeakSet');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.G, { global: __webpack_require__(4) });


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', { global: __webpack_require__(4) });


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8);
	var cof = __webpack_require__(34);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var scale = __webpack_require__(297);
	var fround = __webpack_require__(114);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { scale: __webpack_require__(297) });


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var global = __webpack_require__(4);
	var speciesConstructor = __webpack_require__(209);
	var promiseResolve = __webpack_require__(214);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(212);
	var perform = __webpack_require__(213);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(216);
	var $export = __webpack_require__(8);
	var shared = __webpack_require__(23)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(221))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(220);
	var from = __webpack_require__(278);
	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(309);
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(21);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(8);
	var microtask = __webpack_require__(211)();
	var process = __webpack_require__(4).process;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(8);
	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var microtask = __webpack_require__(211)();
	var OBSERVABLE = __webpack_require__(25)('observable');
	var aFunction = __webpack_require__(21);
	var anObject = __webpack_require__(12);
	var anInstance = __webpack_require__(207);
	var redefineAll = __webpack_require__(215);
	var hide = __webpack_require__(10);
	var forOf = __webpack_require__(208);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(194)('Observable');


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var invoke = __webpack_require__(78);
	var partial = __webpack_require__(321);
	var navigator = global.navigator;
	var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return MSIE ? function (fn, time /* , ...args */) {
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      // eslint-disable-next-line no-new-func
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path = __webpack_require__(322);
	var invoke = __webpack_require__(78);
	var aFunction = __webpack_require__(21);
	module.exports = function (/* ...pargs */) {
	  var fn = aFunction(this);
	  var length = arguments.length;
	  var pargs = Array(length);
	  var i = 0;
	  var _ = path._;
	  var holder = false;
	  while (length > i) if ((pargs[i] = arguments[i++]) === _) holder = true;
	  return function (/* ...args */) {
	    var that = this;
	    var aLen = arguments.length;
	    var j = 0;
	    var k = 0;
	    var args;
	    if (!holder && !aLen) return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if (holder) for (;length > j; j++) if (args[j] === _) args[j] = arguments[k++];
	    while (aLen > k) args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $task = __webpack_require__(210);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(195);
	var getKeys = __webpack_require__(30);
	var redefine = __webpack_require__(18);
	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var Iterators = __webpack_require__(130);
	var wks = __webpack_require__(25);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(327);
	module.exports = __webpack_require__(9).RegExp.escape;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(328)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 329 */,
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(331);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(332);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.5.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2020-05-04T22:49Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.5.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.5
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2020-03-14
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
						dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px";
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = (
						dataPriv.get( cur, "events" ) || Object.create( null )
					)[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script
				if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				if ( typeof props.top === "number" ) {
					props.top += "px";
				}
				if ( typeof props.left === "number" ) {
					props.left += "px";
				}
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		} );
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(334);
	module.exports = angular;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.6
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index];
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.6/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest
	* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.6',
	  major: 1,
	  minor: 6,
	  dot: 6,
	  codeName: 'interdimensional-cable'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.6.6' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (' ' + (element.getAttribute('class') || '') + ' ')
	          .replace(/[\n\t]/g, ' ')
	          .replace(' ' + trim(cssClass) + ' ', ' '))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key === this._lastKey) {
	      return this._lastIndex;
	    }
	    this._lastKey = key;
	    this._lastIndex = this._keys.indexOf(key);
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
	   * current strictComponentBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
	   * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
	   * on the component's HTML tag.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, fnCamelCaseReplace);
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest (`complete`, `error`, `timeout` or `abort`).
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, key) {
	      if (/[&?][^=]+=JSON_CALLBACK/.test(url)) {
	        // Throw if the url already contains a reference to JSON_CALLBACK
	        throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	      }
	
	      var callbackParamRegex = new RegExp('[&?]' + key + '=');
	      if (callbackParamRegex.test(url)) {
	        // Throw if the callback param was already provided
	        throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', key, url);
	      }
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + key + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestAborted;
	      xhr.ontimeout = requestTimeout;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        markQExceptionHandled(intervals[promise.$$intervalId].promise);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = trimEmptyHash($browser.url());
	        var newUrl = trimEmptyHash($location.absUrl());
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = oldUrl !== newUrl ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.ast.ast(text);
	    var fn = this.astCompiler.compile(ast);
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      return unwatch;
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      useInputs = !parsedExpression.inputs;
	      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      if (fn.inputs) {
	        fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // potentially non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  markQStateExceptionHandled(q.$$state);
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * `$watchGroup` is more performant than watching each expression individually, and should be
	       * used when the listener does not need to know which expression has changed.
	       * If the listener needs to know which expression has changed,
	       * {@link ng.$rootScope.Scope#$watch $watch()} or
	       * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`.
	       *
	       *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
	       *    expression, and not the difference of the values between each call of the listener.
	       *    That means the difference between `newValues` and `oldValues` cannot be used to determine
	       *    which expression has changed / remained stable:
	       *
	       *    ```js
	       *
	       *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
	       *      console.log(newValues, oldValues);
	       *    });
	       *
	       *    // newValues, oldValues initially
	       *    // [undefined, undefined], [undefined, undefined]
	       *
	       *    $scope.v1 = 'a';
	       *    $scope.v2 = 'a';
	       *
	       *    // ['a', 'a'], [undefined, undefined]
	       *
	       *    $scope.v2 = 'b'
	       *
	       *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
	       *    // ['a', 'b'], [undefined, 'a']
	       *
	       *    ```
	       *
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it does not refer to a resource that loads code. Currently
	  // unused in AngularJS.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	      // has no corresponding sinks.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        // RESOURCE_URL uses a whitelist.
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ## Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ## In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes Angular accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services.Angular comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for Angular:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, Angular will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var expression = attr[name].trim();
	        var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');
	
	        var watchInterceptor = isOneTime ? toFlatValue : toClassString;
	        var watchExpression = $parse(expression, watchInterceptor);
	        var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;
	
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch(watchExpression, watchAction, isOneTime);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClass[OneTime]WatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassOneTimeWatchAction(newClassValue) {
	          var newClassString = toClassString(newClassValue);
	
	          if (newClassString !== oldClassString) {
	            ngClassWatchAction(newClassString);
	          }
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	
	  function toFlatValue(classValue) {
	    var flatValue = classValue;
	
	    if (isArray(classValue)) {
	      flatValue = classValue.map(toFlatValue);
	    } else if (isObject(classValue)) {
	      var hasUndefined = false;
	
	      flatValue = Object.keys(classValue).filter(function(key) {
	        var value = classValue[key];
	
	        if (!hasUndefined && isUndefined(value)) {
	          hasUndefined = true;
	        }
	
	        return value;
	      });
	
	      if (hasUndefined) {
	        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
	        // the watcher, by including at least one `undefined` value.
	        flatValue.push(undefined);
	      }
	    }
	
	    return flatValue;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * Angular has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell Angular not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect Angular:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function MainController() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  try {
	                    eval('1+2'); // eslint-disable-line no-eval
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // NOTE:
	          // We expose the powerful `$event` object on the scope that provides access to the Window,
	          // etc. This is OK, because expressions are not sandboxed any more (and the expression
	          // sandbox was never meant to be a security feature anyway).
	          var fn = $parse(attr[directiveName]);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event: event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  // https://github.com/angular/angular.js/issues/15833
	  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	  Object.defineProperty(this, '$$scope', {value: $scope});
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	        // eslint-disable-next-line no-self-compare
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      ctrl.$$parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        // It is possible that model and view value have been updated during render
	        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by Angular when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options.getOption('updateOn')) {
	            element.on(modelCtrl.$options.getOption('updateOn'), function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an Angular expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div "ng-model-options"="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example name="ng-non-bindable">
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have a unique identifier property, you should track
	 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 *
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * Avoid using `track by $index` when the repeated template contains
	 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
	 * element will always be matched with the `nth` item of the array, so the bindings on that element
	 * will not be updated even when the corresponding item changes, essentially causing the view to get
	 * out-of-sync with the underlying data.
	 * </div>
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression.
	 *     </div>
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span ng-if="myForm.testSelect.$error.unknownValue">Error: The current model doesn't match any option</span>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @knownIssue
	 *
	 * In Firefox, the select model is only updated when the select element is blurred. For example,
	 * when switching between options with the keyboard, the select model is only set to the
	 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
	 * outside the select.
	 *
	 * This is due to an ambiguity in the select element specification. See the
	 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
	 * for more information, and this
	 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(336);
	module.exports = 'ngAnimate';


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.1
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var helpers = {
	  blockTransitions: function(node, duration) {
	    // we use a negative delay value since it performs blocking
	    // yet it doesn't kill any existing transitions running on the
	    // same element which makes this safe for class-based animations
	    var value = duration ? '-' + duration + 's' : '';
	    applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	    return [TRANSITION_DELAY_PROP, value];
	  }
	};
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="MainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('MainController', function MainController() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	/* exported $AnimateCssProvider */
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## General Use
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) === 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$animateCache',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,   $$animateCache,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
	      var timings = $$animateCache.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // if a css animation has no duration we
	      // should mark that so that repeated addClass/removeClass calls are skipped
	      var hasDuration = allowNoDuration || (timings.transitionDuration > 0 || timings.animationDuration > 0);
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      $$animateCache.put(cacheKey, timings, hasDuration);
	
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	      var staggerCacheKey = 'stagger-' + cacheKey;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if ($$animateCache.count(cacheKey) > 0) {
	        stagger = $$animateCache.get(staggerCacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          $$animateCache.put(staggerCacheKey, stagger, true);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        $$animateCache.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey, allowNoDuration) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
	      if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
	        preparationClasses = null;
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : $$animateCache.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== 'boolean') {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        helpers.blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) {
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (preparationClasses && !options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	
	        if (activeClasses) {
	          $$jqLite.removeClass(element, activeClasses);
	        }
	
	        blockKeyframeAnimations(node, false);
	        helpers.blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            if (value) {
	              node.style.setProperty(prop, value);
	            } else {
	              node.style.removeProperty(prop);
	            }
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          helpers.blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        if (ev.target !== node) {
	          // Since TransitionEvent / AnimationEvent bubble up,
	          // we have to ignore events by finished child animations
	          return;
	        }
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              if (animationPaused) {
	                temporaryStyles.push(value);
	              } else {
	                removeFromArray(temporaryStyles, value);
	              }
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
	            cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
	
	            timings = computeTimings(node, fullClassName, cacheKey, false);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event === 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a, b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          if (runners.length) {
	            $$AnimateRunner.all(runners, callback);
	          }  else {
	            callback();
	          }
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              if (reject) {
	                runner.cancel();
	              } else {
	                runner.end();
	              }
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i = 0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function getEventData(options) {
	    return {
	      addClass: options.addClass,
	      removeClass: options.removeClass,
	      from: options.from,
	      to: options.to
	    };
	  }
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event === 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	               '$$isDocumentHidden',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
	                $$isDocumentHidden) {
	
	    var activeAnimationsLookup = new $$Map();
	    var disabledElementsLookup = new $$Map();
	    var animationsEnabled = null;
	
	    function removeFromDisabledElementsLookup(evt) {
	      disabledElementsLookup.delete(evt.target);
	    }
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the `customFilter`/`classNameFilter` are set during the
	    // provider/config stage therefore we can optimize here and setup helper functions
	    var customFilter = $animateProvider.customFilter();
	    var classNameFilter = $animateProvider.classNameFilter();
	    var returnTrue = function() { return true; };
	
	    var isAnimatableByFilter = customFilter || returnTrue;
	    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
	      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
	      return classNameFilter.test(className);
	    };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
	      // eslint-disable-next-line no-bitwise
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	    };
	
	    function findCallbacks(targetParentNode, targetNode, event) {
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, node) {
	      if (phase === 'close' && !node.parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(node);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              if (!disabledElementsLookup.has(node)) {
	                // The element is added to the map for the first time.
	                // Create a listener to remove it on `$destroy` (to avoid memory leak).
	                jqLite(element).on('$destroy', removeFromDisabledElementsLookup);
	              }
	              disabledElementsLookup.set(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(originalElement, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var element = stripCommentsFromElement(originalElement);
	      var node = getDomNode(element);
	      var parentNode = node && node.parentNode;
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // If animations are hard-disabled for the whole application there is no need to continue.
	      // There are also situations where a directive issues an animation for a jqLite wrapper that
	      // contains only comment nodes. In this case, there is no way we can perform an animation.
	      if (!animationsEnabled ||
	          !node ||
	          !isAnimatableByFilter(node, event, initialOptions) ||
	          !isAnimatableClassName(node, options)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $$isDocumentHidden();
	
	      // This is a hard disable of all animations the element itself, therefore  there is no need to
	      // continue further past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start', getEventData(options));
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close', getEventData(options));
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(node);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(node);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
	        // happen if the animated element is a transcluded clone and also has a `templateUrl`
	        // directive on it. Therefore, we must recreate `element` in order to interact with the
	        // actual DOM nodes.
	        // Note: We still need to use the old `node` for certain things, such as looking up in
	        //       HashMaps where it was used as the key.
	
	        element = stripCommentsFromElement(originalElement);
	
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(node);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(node, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', getEventData(options));
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(node);
	          }
	          notifyProgress(runner, event, 'close', getEventData(options));
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parentNode, node, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, node);
	            });
	          } else {
	            cleanupEventListeners(phase, node);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) {
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(node) {
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.delete(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(node) {
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.delete(node);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(node, parentNode, event) {
	      var bodyNode = $document[0].body;
	      var rootNode = getDomNode($rootElement);
	
	      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
	      var rootNodeDetected = (node === rootNode);
	      var parentAnimationDetected = false;
	      var elementDisabled = disabledElementsLookup.get(node);
	      var animateChildren;
	
	      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentNode = getDomNode(parentHost);
	      }
	
	      while (parentNode) {
	        if (!rootNodeDetected) {
	          // AngularJS doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootNodeDetected = (parentNode === rootNode);
	        }
	
	        if (parentNode.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentNode) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentNodeDisabled = disabledElementsLookup.get(parentNode);
	
	          if (parentNodeDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentNodeDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyNodeDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyNodeDetected = (parentNode === bodyNode);
	        }
	
	        if (bodyNodeDetected && rootNodeDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootNodeDetected) {
	          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
	          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentNode = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentNode = parentNode.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootNodeDetected && bodyNodeDetected;
	    }
	
	    function markElementAnimationState(node, state, details) {
	      details = details || {};
	      details.state = state;
	
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.set(node, newValue);
	    }
	  }];
	}];
	
	/** @this */
	var $$AnimateCacheProvider = function() {
	
	  var KEY = '$$ngAnimateParentKey';
	  var parentCounter = 0;
	  var cache = Object.create(null);
	
	  this.$get = [function() {
	    return {
	      cacheKey: function(node, method, addClass, removeClass) {
	        var parentNode = node.parentNode;
	        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	        var parts = [parentID, method, node.getAttribute('class')];
	        if (addClass) {
	          parts.push(addClass);
	        }
	        if (removeClass) {
	          parts.push(removeClass);
	        }
	        return parts.join(' ');
	      },
	
	      containsCachedAnimationWithoutDuration: function(key) {
	        var entry = cache[key];
	
	        // nothing cached, so go ahead and animate
	        // otherwise it should be a valid animation
	        return (entry && !entry.isValid) || false;
	      },
	
	      flush: function() {
	        cache = Object.create(null);
	      },
	
	      count: function(key) {
	        var entry = cache[key];
	        return entry ? entry.total : 0;
	      },
	
	      get: function(key) {
	        var entry = cache[key];
	        return entry && entry.value;
	      },
	
	      put: function(key, value, isValid) {
	        if (!cache[key]) {
	          cache[key] = { total: 1, value: value, isValid: isValid };
	        } else {
	          cache[key].total++;
	          cache[key].value = value;
	        }
	      }
	    };
	  }];
	};
	
	/* exported $$AnimationProvider */
	
	var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	  var PREPARE_CLASSES_KEY = '$$animatePrepareClasses';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', '$$animateCache',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler, $$animateCache) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$Map();
	
	      // this is done first beforehand so that the map
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.set(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          element: animation.element,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.set(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      if (isStructural) {
	        element.data(PREPARE_CLASSES_KEY, 'ng-' + event + PREPARE_CLASS_SUFFIX);
	      }
	
	      setRunner(element, runner);
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
	          var extraClasses = options.addClass;
	
	          extraClasses = (extraClasses ? (extraClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
	          var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);
	
	          toBeSortedAnimations.push({
	            element: element,
	            domNode: getDomNode(element),
	            fn: function triggerAnimationStart() {
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that we've cached the animation status for this element
	              // and it's in fact an invalid animation (something that has duration = 0)
	              // then we should skip all the heavy work from here on
	              if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
	                closeFn();
	                return;
	              }
	
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        var finalAnimations = sortAnimations(toBeSortedAnimations);
	        for (var i = 0; i < finalAnimations.length; i++) {
	          var innerArray = finalAnimations[i];
	          for (var j = 0; j < innerArray.length; j++) {
	            var entry = innerArray[j];
	            var element = entry.element;
	
	            // the RAFScheduler code only uses functions
	            finalAnimations[i][j] = entry.fn;
	
	            // the first row of elements shouldn't have a prepare-class added to them
	            // since the elements are at the top of the animation hierarchy and they
	            // will be applied without a RAF having to pass...
	            if (i === 0) {
	              element.removeData(PREPARE_CLASSES_KEY);
	              continue;
	            }
	
	            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
	            if (prepareClassName) {
	              $$jqLite.addClass(element, prepareClassName);
	            }
	          }
	        }
	
	        $$rAFScheduler(finalAnimations);
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        tempClasses = (tempClasses ? (tempClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
	        $$jqLite.addClass(element, tempClasses);
	
	        var prepareClassName = element.data(PREPARE_CLASSES_KEY);
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) {
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 550, // We use 550 here to ensure that the directive is caught before others,
	                   // but after `ngIf` (at priority 600).
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          $transclude(function(clone, childScope) {
	            previousElement = clone;
	            previousScope = childScope;
	            $animate.enter(clone, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
	 *
	 * ## Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                     | Supported Animations                                                      |
	 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
	 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
	 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
	 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
	 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
	 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
	 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
	 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
	 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
	 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
	 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
	 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
	 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
	 *
	 * (More information can be found by visiting the documentation associated with each directive.)
	 *
	 * For a full breakdown of the steps involved during each animation event, refer to the
	 * {@link ng.$animate `$animate` API docs}.
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 *
	 *   /&#42; if you are using animations instead of transitions you should configure as follows:
	 *     animation-delay: 0.1s;
	 *     animation-duration: 0s; &#42;/
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 * ```
	 *
	 * ### Animating between value changes
	 *
	 * Sometimes you need to animate between different expression states, whose values
	 * don't necessary need to be known or referenced in CSS styles.
	 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
	 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
	 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
	 *
	 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
	 * creates a new instance of the element (including any other/child directives it may have) and
	 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
	 * (e.g. for performance reasons, or when you wish to retain internal state on the original
	 * element instance).
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that AngularJS
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#!/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id: 1, title: 'Miss Beulah Roob' },
	            { id: 2, title: 'Trent Morissette' },
	            { id: 3, title: 'Miss Ava Pouros' },
	            { id: 4, title: 'Rod Pouros' },
	            { id: 5, title: 'Abdul Rice' },
	            { id: 6, title: 'Laurie Rutherford Sr.' },
	            { id: 7, title: 'Nakia McLaughlin' },
	            { id: 8, title: 'Jordon Blanda DVM' },
	            { id: 9, title: 'Rhoda Hand' },
	            { id: 10, title: 'Alexandrea Sauer' }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams',
	            function ProfileController($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#!/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from AngularJS core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .info({ angularVersion: '1.8.1' })
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animateCache', $$AnimateCacheProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(338);
	module.exports = 'ngTouch';


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.1
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngTouch
	 * @description
	 *
	 * The `ngTouch` module provides helpers for touch-enabled devices.
	 * The implementation is based on jQuery Mobile touch event handling
	 * ([jquerymobile.com](http://jquerymobile.com/)). *
	 *
	 * See {@link ngTouch.$swipe `$swipe`} for usage.
	 *
	 * @deprecated
	 * sinceVersion="1.7.0"
	 * The ngTouch module with the {@link ngTouch.$swipe `$swipe`} service and
	 * the {@link ngTouch.ngSwipeLeft} and {@link ngTouch.ngSwipeRight} directives are
	 * deprecated. Instead, stand-alone libraries for touch handling and gesture interaction
	 * should be used, for example [HammerJS](https://hammerjs.github.io/) (which is also used by
	 * Angular).
	 */
	
	// define ngTouch module
	/* global ngTouch */
	var ngTouch = angular.module('ngTouch', []);
	
	ngTouch.info({ angularVersion: '1.8.1' });
	
	function nodeName_(element) {
	  return angular.$$lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	/* global ngTouch: false */
	
	    /**
	     * @ngdoc service
	     * @name $swipe
	     *
	     * @deprecated
	     * sinceVersion="1.7.0"
	     *
	     * See the {@link ngTouch module} documentation for more information.
	     *
	     * @description
	     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
	     * behavior, to make implementing swipe-related directives more convenient.
	     *
	     * Requires the {@link ngTouch `ngTouch`} module to be installed.
	     *
	     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
	     *
	     * # Usage
	     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
	     * which is to be watched for swipes, and an object with four handler functions. See the
	     * documentation for `bind` below.
	     */
	
	ngTouch.factory('$swipe', [function() {
	  // The total distance in any direction before we make the call on swipe vs. scroll.
	  var MOVE_BUFFER_RADIUS = 10;
	
	  var POINTER_EVENTS = {
	    'mouse': {
	      start: 'mousedown',
	      move: 'mousemove',
	      end: 'mouseup'
	    },
	    'touch': {
	      start: 'touchstart',
	      move: 'touchmove',
	      end: 'touchend',
	      cancel: 'touchcancel'
	    },
	    'pointer': {
	      start: 'pointerdown',
	      move: 'pointermove',
	      end: 'pointerup',
	      cancel: 'pointercancel'
	    }
	  };
	
	  function getCoordinates(event) {
	    var originalEvent = event.originalEvent || event;
	    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
	    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];
	
	    return {
	      x: e.clientX,
	      y: e.clientY
	    };
	  }
	
	  function getEvents(pointerTypes, eventType) {
	    var res = [];
	    angular.forEach(pointerTypes, function(pointerType) {
	      var eventName = POINTER_EVENTS[pointerType][eventType];
	      if (eventName) {
	        res.push(eventName);
	      }
	    });
	    return res.join(' ');
	  }
	
	  return {
	    /**
	     * @ngdoc method
	     * @name $swipe#bind
	     *
	     * @description
	     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
	     * object containing event handlers.
	     * The pointer types that should be used can be specified via the optional
	     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
	     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
	     *
	     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
	     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
	     * `event`. `cancel` receives the raw `event` as its single parameter.
	     *
	     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
	     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
	     * distance moved in either dimension exceeds a small threshold.
	     *
	     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
	     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
	     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
	     *   A `cancel` event is sent.
	     *
	     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
	     * a swipe is in progress.
	     *
	     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
	     *
	     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
	     * as described above.
	     *
	     */
	    bind: function(element, eventHandlers, pointerTypes) {
	      // Absolute total movement, used to control swipe vs. scroll.
	      var totalX, totalY;
	      // Coordinates of the start position.
	      var startCoords;
	      // Last event's position.
	      var lastPos;
	      // Whether a swipe is active.
	      var active = false;
	
	      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
	      element.on(getEvents(pointerTypes, 'start'), function(event) {
	        startCoords = getCoordinates(event);
	        active = true;
	        totalX = 0;
	        totalY = 0;
	        lastPos = startCoords;
	        if (eventHandlers['start']) {
	          eventHandlers['start'](startCoords, event);
	        }
	      });
	      var events = getEvents(pointerTypes, 'cancel');
	      if (events) {
	        element.on(events, function(event) {
	          active = false;
	          if (eventHandlers['cancel']) {
	            eventHandlers['cancel'](event);
	          }
	        });
	      }
	
	      element.on(getEvents(pointerTypes, 'move'), function(event) {
	        if (!active) return;
	
	        // Android will send a touchcancel if it thinks we're starting to scroll.
	        // So when the total distance (+ or - or both) exceeds 10px in either direction,
	        // we either:
	        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
	        // - On totalY > totalX, we let the browser handle it as a scroll.
	
	        if (!startCoords) return;
	        var coords = getCoordinates(event);
	
	        totalX += Math.abs(coords.x - lastPos.x);
	        totalY += Math.abs(coords.y - lastPos.y);
	
	        lastPos = coords;
	
	        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
	          return;
	        }
	
	        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
	        if (totalY > totalX) {
	          // Allow native scrolling to take over.
	          active = false;
	          if (eventHandlers['cancel']) {
	            eventHandlers['cancel'](event);
	          }
	          return;
	        } else {
	          // Prevent the browser from scrolling.
	          event.preventDefault();
	          if (eventHandlers['move']) {
	            eventHandlers['move'](coords, event);
	          }
	        }
	      });
	
	      element.on(getEvents(pointerTypes, 'end'), function(event) {
	        if (!active) return;
	        active = false;
	        if (eventHandlers['end']) {
	          eventHandlers['end'](getCoordinates(event), event);
	        }
	      });
	    }
	  };
	}]);
	
	/* global ngTouch: false */
	
	/**
	 * @ngdoc directive
	 * @name ngSwipeLeft
	 *
	 * @deprecated
	 * sinceVersion="1.7.0"
	 *
	 * See the {@link ngTouch module} documentation for more information.
	 *
	 * @description
	 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
	 * A leftward swipe is a quick, right-to-left slide of the finger.
	 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
	 * too.
	 *
	 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
	 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * @element ANY
	 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
	 * upon left swipe. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
	      <file name="index.html">
	        <div ng-show="!showActions" ng-swipe-left="showActions = true">
	          Some list content, like an email in the inbox
	        </div>
	        <div ng-show="showActions" ng-swipe-right="showActions = false">
	          <button ng-click="reply()">Reply</button>
	          <button ng-click="delete()">Delete</button>
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngSwipeLeftExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSwipeRight
	 *
	 * @deprecated
	 * sinceVersion="1.7.0"
	 *
	 * See the {@link ngTouch module} documentation for more information.
	 *
	 * @description
	 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
	 * A rightward swipe is a quick, left-to-right slide of the finger.
	 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
	 * too.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * @element ANY
	 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
	 * upon right swipe. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
	      <file name="index.html">
	        <div ng-show="!showActions" ng-swipe-left="showActions = true">
	          Some list content, like an email in the inbox
	        </div>
	        <div ng-show="showActions" ng-swipe-right="showActions = false">
	          <button ng-click="reply()">Reply</button>
	          <button ng-click="delete()">Delete</button>
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngSwipeRightExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	function makeSwipeDirective(directiveName, direction, eventName) {
	  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
	    // The maximum vertical delta for a swipe should be less than 75px.
	    var MAX_VERTICAL_DISTANCE = 75;
	    // Vertical distance should not be more than a fraction of the horizontal distance.
	    var MAX_VERTICAL_RATIO = 0.3;
	    // At least a 30px lateral motion is necessary for a swipe.
	    var MIN_HORIZONTAL_DISTANCE = 30;
	
	    return function(scope, element, attr) {
	      var swipeHandler = $parse(attr[directiveName]);
	
	      var startCoords, valid;
	
	      function validSwipe(coords) {
	        // Check that it's within the coordinates.
	        // Absolute vertical distance must be within tolerances.
	        // Horizontal distance, we take the current X - the starting X.
	        // This is negative for leftward swipes and positive for rightward swipes.
	        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
	        // (ie. same direction as the directive wants) will have a positive delta and
	        // illegal ones a negative delta.
	        // Therefore this delta must be positive, and larger than the minimum.
	        if (!startCoords) return false;
	        var deltaY = Math.abs(coords.y - startCoords.y);
	        var deltaX = (coords.x - startCoords.x) * direction;
	        return valid && // Short circuit for already-invalidated swipes.
	            deltaY < MAX_VERTICAL_DISTANCE &&
	            deltaX > 0 &&
	            deltaX > MIN_HORIZONTAL_DISTANCE &&
	            deltaY / deltaX < MAX_VERTICAL_RATIO;
	      }
	
	      var pointerTypes = ['touch'];
	      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
	        pointerTypes.push('mouse');
	      }
	      $swipe.bind(element, {
	        'start': function(coords, event) {
	          startCoords = coords;
	          valid = true;
	        },
	        'cancel': function(event) {
	          valid = false;
	        },
	        'end': function(coords, event) {
	          if (validSwipe(coords)) {
	            scope.$apply(function() {
	              element.triggerHandler(eventName);
	              swipeHandler(scope, {$event: event});
	            });
	          }
	        }
	      }, pointerTypes);
	    };
	  }]);
	}
	
	// Left is negative X-coordinate, right is positive.
	makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
	makeSwipeDirective('ngSwipeRight', 1, 'swiperight');
	
	
	
	})(window, window.angular);


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340),__webpack_require__(341)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0,b1) {
	      return (root['textAngular.name'] = factory(a0,b1));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("rangy"),require("rangy/lib/rangy-selectionsaverestore"));
	  } else {
	    root['textAngular'] = factory(rangy);
	  }
	}(this, function (rangy) {
	
	
	// tests against the current jqLite/jquery implementation if this can be an element
	function validElementString(string){
	    try{
	        return angular.element(string).length !== 0;
	    }catch(any){
	        return false;
	    }
	}
	// setup the global contstant functions for setting up the toolbar
	
	// all tool definitions
	var taTools = {};
	/*
	    A tool definition is an object with the following key/value parameters:
	        action: [function(deferred, restoreSelection)]
	                a function that is executed on clicking on the button - this will allways be executed using ng-click and will
	                overwrite any ng-click value in the display attribute.
	                The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
	                manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
	                restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
	                selection in the WYSIWYG editor.
	        display: [string]?
	                Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
	                If set this will cause buttontext and iconclass to be ignored
	        class: [string]?
	                Optional, if set will override the taOptions.classes.toolbarButton class.
	        buttontext: [string]?
	                if this is defined it will replace the contents of the element contained in the `display` element
	        iconclass: [string]?
	                if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
	        tooltiptext: [string]?
	                Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
	        activestate: [function(commonElement)]?
	                this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
	                will be applied to the `display` element, else the class will be removed
	        disabled: [function()]?
	                if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	    Other functions available on the scope are:
	        name: [string]
	                the name of the tool, this is the first parameter passed into taRegisterTool
	        isDisabled: [function()]
	                returns true if the tool is disabled, false if it isn't
	        displayActiveToolClass: [function(boolean)]
	                returns true if the tool is 'active' in the currently focussed toolbar
	        onElementSelect: [Object]
	                This object contains the following key/value pairs and is used to trigger the ta-element-select event
	                element: [String]
	                    an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
	                filter: [function(element)]?
	                    an optional filter that returns a boolean, if true it will trigger the onElementSelect.
	                action: [function(event, element, editorScope)]
	                    the action that should be executed if the onElementSelect function runs
	*/
	// name and toolDefinition to add into the tools available to be added on the toolbar
	function registerTextAngularTool(name, toolDefinition){
	    if(!name || name === '' || taTools.hasOwnProperty(name)) throw('textAngular Error: A unique name is required for a Tool Definition');
	    if(
	        (toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display))) ||
	        (!toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass)
	    )
	        throw('textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value');
	    taTools[name] = toolDefinition;
	}
	
	angular.module('textAngularSetup', [])
	.constant('taRegisterTool', registerTextAngularTool)
	.value('taTools', taTools)
	// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
	.value('taOptions',  {
	    //////////////////////////////////////////////////////////////////////////////////////
	    // forceTextAngularSanitize
	    // set false to allow the textAngular-sanitize provider to be replaced
	    // with angular-sanitize or a custom provider.
	    forceTextAngularSanitize: true,
	    ///////////////////////////////////////////////////////////////////////////////////////
	    // keyMappings
	    // allow customizable keyMappings for specialized key boards or languages
	    //
	    // keyMappings provides key mappings that are attached to a given commandKeyCode.
	    // To modify a specific keyboard binding, simply provide function which returns true
	    // for the event you wish to map to.
	    // Or to disable a specific keyboard binding, provide a function which returns false.
	    // Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
	    // At present, the following commandKeyCodes are in use:
	    // 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
	    //
	    // To map to an new commandKeyCode, add a new key mapping such as:
	    // {commandKeyCode: 'CustomKey', testForKey: function (event) {
	    //  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
	    // } }
	    // to the keyMappings. This example maps ctrl+9 to 'CustomKey'
	    // Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
	    // tool will be bound to ctrl+9.
	    //
	    // To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
	    // {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
	    // {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
	    // to disable them.
	    //
	    keyMappings : [],
	    toolbar: [
	        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
	        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
	        ['justifyLeft','justifyCenter','justifyRight','justifyFull','indent','outdent'],
	        ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
	    ],
	    classes: {
	        focussed: "focussed",
	        toolbar: "btn-toolbar",
	        toolbarGroup: "btn-group",
	        toolbarButton: "btn btn-default",
	        toolbarButtonActive: "active",
	        disabled: "disabled",
	        textEditor: 'form-control',
	        htmlEditor: 'form-control'
	    },
	    defaultTagAttributes : {
	        a: {target:""}
	    },
	    setup: {
	        // wysiwyg mode
	        textEditorSetup: function($element){ /* Do some processing here */ },
	        // raw html
	        htmlEditorSetup: function($element){ /* Do some processing here */ }
	    },
	    defaultFileDropHandler:
	        /* istanbul ignore next: untestable image processing */
	        function(file, insertAction){
	            var reader = new FileReader();
	            if(file.type.substring(0, 5) === 'image'){
	                reader.onload = function() {
	                    if(reader.result !== '') insertAction('insertImage', reader.result, true);
	                };
	
	                reader.readAsDataURL(file);
	                // NOTE: For async procedures return a promise and resolve it when the editor should update the model.
	                return true;
	            }
	            return false;
	        }
	})
	
	// This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
	// these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
	// div is only used as div.ta-insert-video caught in filter.
	.value('taSelectableElements', ['a','img'])
	
	// This is an array of objects with the following options:
	//				selector: <string> a jqLite or jQuery selector string
	//				customAttribute: <string> an attribute to search for
	//				renderLogic: <function(element)>
	// Both or one of selector and customAttribute must be defined.
	.value('taCustomRenderers', [
	    {
	        // Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
	        // To correct video element. For now only support youtube
	        selector: 'img',
	        customAttribute: 'ta-insert-video',
	        renderLogic: function(element){
	            var iframe = angular.element('<iframe></iframe>');
	            var attributes = element.prop("attributes");
	            // loop through element attributes and apply them on iframe
	            angular.forEach(attributes, function(attr) {
	                iframe.attr(attr.name, attr.value);
	            });
	            iframe.attr('src', iframe.attr('ta-insert-video'));
	            element.replaceWith(iframe);
	        }
	    }
	])
	
	.value('taTranslations', {
	    // moved to sub-elements
	    //toggleHTML: "Toggle HTML",
	    //insertImage: "Please enter a image URL to insert",
	    //insertLink: "Please enter a URL to insert",
	    //insertVideo: "Please enter a youtube URL to embed",
	    html: {
	        tooltip: 'Toggle html / Rich Text'
	    },
	    // tooltip for heading - might be worth splitting
	    heading: {
	        tooltip: 'Heading '
	    },
	    p: {
	        tooltip: 'Paragraph'
	    },
	    pre: {
	        tooltip: 'Preformatted text'
	    },
	    ul: {
	        tooltip: 'Unordered List'
	    },
	    ol: {
	        tooltip: 'Ordered List'
	    },
	    quote: {
	        tooltip: 'Quote/unquote selection or paragraph'
	    },
	    undo: {
	        tooltip: 'Undo'
	    },
	    redo: {
	        tooltip: 'Redo'
	    },
	    bold: {
	        tooltip: 'Bold'
	    },
	    italic: {
	        tooltip: 'Italic'
	    },
	    underline: {
	        tooltip: 'Underline'
	    },
	    strikeThrough:{
	        tooltip: 'Strikethrough'
	    },
	    justifyLeft: {
	        tooltip: 'Align text left'
	    },
	    justifyRight: {
	        tooltip: 'Align text right'
	    },
	    justifyFull: {
	        tooltip: 'Justify text'
	    },
	    justifyCenter: {
	        tooltip: 'Center'
	    },
	    indent: {
	        tooltip: 'Increase indent'
	    },
	    outdent: {
	        tooltip: 'Decrease indent'
	    },
	    clear: {
	        tooltip: 'Clear formatting'
	    },
	    insertImage: {
	        dialogPrompt: 'Please enter an image URL to insert',
	        tooltip: 'Insert image',
	        hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
	    },
	    insertVideo: {
	        tooltip: 'Insert video',
	        dialogPrompt: 'Please enter a youtube URL to embed'
	    },
	    insertLink: {
	        tooltip: 'Insert / edit link',
	        dialogPrompt: "Please enter a URL to insert"
	    },
	    editLink: {
	        reLinkButton: {
	            tooltip: "Relink"
	        },
	        unLinkButton: {
	            tooltip: "Unlink"
	        },
	        targetToggle: {
	            buttontext: "Open in New Window"
	        }
	    },
	    wordcount: {
	        tooltip: 'Display words Count'
	    },
	        charcount: {
	        tooltip: 'Display characters Count'
	    }
	})
	.factory('taToolFunctions', ['$window','taTranslations', function($window, taTranslations) {
	    return {
	        imgOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
	            var finishEdit = function(){
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            };
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '375px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
	            fullButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '100%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
	            halfButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '50%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
	            quartButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '25%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
	            resetButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    width: '',
	                    height: ''
	                });
	                finishEdit();
	            });
	            buttonGroup.append(fullButton);
	            buttonGroup.append(halfButton);
	            buttonGroup.append(quartButton);
	            buttonGroup.append(resetButton);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
	            floatLeft.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'left');
	                // firefox
	                $element.css('cssFloat', 'left');
	                // IE < 8
	                $element.css('styleFloat', 'left');
	                finishEdit();
	            });
	            var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
	            floatRight.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'right');
	                // firefox
	                $element.css('cssFloat', 'right');
	                // IE < 8
	                $element.css('styleFloat', 'right');
	                finishEdit();
	            });
	            var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
	            floatNone.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', '');
	                // firefox
	                $element.css('cssFloat', '');
	                // IE < 8
	                $element.css('styleFloat', '');
	                finishEdit();
	            });
	            buttonGroup.append(floatLeft);
	            buttonGroup.append(floatNone);
	            buttonGroup.append(floatRight);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group">');
	            var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
	            remove.on('click', function(event){
	                event.preventDefault();
	                $element.remove();
	                finishEdit();
	            });
	            buttonGroup.append(remove);
	            container.append(buttonGroup);
	
	            editorScope.showPopover($element);
	            editorScope.showResizeOverlay($element);
	        },
	        aOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '436px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            container.css('line-height', '28px');
	            var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
	            link.css({
	                'display': 'inline-block',
	                'max-width': '200px',
	                'overflow': 'hidden',
	                'text-overflow': 'ellipsis',
	                'white-space': 'nowrap',
	                'vertical-align': 'middle'
	            });
	            container.append(link);
	            var buttonGroup = angular.element('<div class="btn-group pull-right">');
	            var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
	            reLinkButton.on('click', function(event){
	                event.preventDefault();
	                var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
	                if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                    $element.attr('href', urlLink);
	                    editorScope.updateTaBindtaTextElement();
	                }
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(reLinkButton);
	            var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
	            // directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
	            unLinkButton.on('click', function(event){
	                event.preventDefault();
	                $element.replaceWith($element.contents());
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(unLinkButton);
	            var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
	            if($element.attr('target') === '_blank'){
	                targetToggle.addClass('active');
	            }
	            targetToggle.on('click', function(event){
	                event.preventDefault();
	                $element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
	                targetToggle.toggleClass('active');
	                editorScope.updateTaBindtaTextElement();
	            });
	            buttonGroup.append(targetToggle);
	            container.append(buttonGroup);
	            editorScope.showPopover($element);
	        },
	        extractYoutubeVideoId: function(url) {
	            var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
	            var match = url.match(re);
	            return (match && match[1]) || null;
	        }
	    };
	}])
	.run(['taRegisterTool', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', '$log',
	    function(taRegisterTool, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions, $log){
	    // test for the version of $sanitize that is in use
	    // You can disable this check by setting taOptions.textAngularSanitize == false
	    var gv = {}; $sanitize('', gv);
	    /* istanbul ignore next, throws error */
	    if ((taOptions.forceTextAngularSanitize===true) && (gv.version !== 'taSanitize')) {
	        throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
	    }
	    taRegisterTool("html", {
	        iconclass: 'fa fa-code',
	        tooltiptext: taTranslations.html.tooltip,
	        action: function(){
	            this.$editor().switchView();
	        },
	        activeState: function(){
	            return this.$editor().showHtml;
	        }
	    });
	    // add the Header tools
	    // convenience functions so that the loop works correctly
	    var _retActiveStateFunction = function(q){
	        return function(){ return this.$editor().queryFormatBlockState(q); };
	    };
	    var headerAction = function(){
	        return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() +">");
	    };
	    angular.forEach(['h1','h2','h3','h4','h5','h6'], function(h){
	        taRegisterTool(h.toLowerCase(), {
	            buttontext: h.toUpperCase(),
	            tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
	            action: headerAction,
	            activeState: _retActiveStateFunction(h.toLowerCase())
	        });
	    });
	    taRegisterTool('p', {
	        buttontext: 'P',
	        tooltiptext: taTranslations.p.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<P>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('p'); }
	    });
	    // key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
	    taRegisterTool('pre', {
	        buttontext: 'pre',
	        tooltiptext: taTranslations.pre.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<PRE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('pre'); }
	    });
	    taRegisterTool('ul', {
	        iconclass: 'fa fa-list-ul',
	        tooltiptext: taTranslations.ul.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertUnorderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertUnorderedList'); }
	    });
	    taRegisterTool('ol', {
	        iconclass: 'fa fa-list-ol',
	        tooltiptext: taTranslations.ol.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertOrderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertOrderedList'); }
	    });
	    taRegisterTool('quote', {
	        iconclass: 'fa fa-quote-right',
	        tooltiptext: taTranslations.quote.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('blockquote'); }
	    });
	    taRegisterTool('undo', {
	        iconclass: 'fa fa-undo',
	        tooltiptext: taTranslations.undo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("undo", null);
	        }
	    });
	    taRegisterTool('redo', {
	        iconclass: 'fa fa-repeat',
	        tooltiptext: taTranslations.redo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("redo", null);
	        }
	    });
	    taRegisterTool('bold', {
	        iconclass: 'fa fa-bold',
	        tooltiptext: taTranslations.bold.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("bold", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('bold');
	        },
	        commandKeyCode: 98
	    });
	    taRegisterTool('justifyLeft', {
	        iconclass: 'fa fa-align-left',
	        tooltiptext: taTranslations.justifyLeft.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyLeft", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if (commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result =
	                        commonElement.css('text-align') === 'left' ||
	                        commonElement.attr('align') === 'left' ||
	                        (
	                            commonElement.css('text-align') !== 'right' &&
	                            commonElement.css('text-align') !== 'center' &&
	                            commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter')
	                        ) && !this.$editor().queryCommandState('justifyFull');
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyLeft');
	            return result;
	        }
	    });
	    taRegisterTool('justifyRight', {
	        iconclass: 'fa fa-align-right',
	        tooltiptext: taTranslations.justifyRight.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyRight", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'right';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyRight');
	            return result;
	        }
	    });
	    taRegisterTool('justifyFull', {
	        iconclass: 'fa fa-align-justify',
	        tooltiptext: taTranslations.justifyFull.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyFull", null);
	        },
	        activeState: function(commonElement){
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'justify';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyFull');
	            return result;
	        }
	    });
	    taRegisterTool('justifyCenter', {
	        iconclass: 'fa fa-align-center',
	        tooltiptext: taTranslations.justifyCenter.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyCenter", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'center';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	
	            }
	            result = result || this.$editor().queryCommandState('justifyCenter');
	            return result;
	        }
	    });
	    taRegisterTool('indent', {
	        iconclass: 'fa fa-indent',
	        tooltiptext: taTranslations.indent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("indent", null);
	        },
	        activeState: function(){
	            return this.$editor().queryFormatBlockState('blockquote');
	        },
	        commandKeyCode: 'TabKey'
	    });
	    taRegisterTool('outdent', {
	        iconclass: 'fa fa-outdent',
	        tooltiptext: taTranslations.outdent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("outdent", null);
	        },
	        activeState: function(){
	            return false;
	        },
	        commandKeyCode: 'ShiftTabKey'
	    });
	    taRegisterTool('italics', {
	        iconclass: 'fa fa-italic',
	        tooltiptext: taTranslations.italic.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("italic", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('italic');
	        },
	        commandKeyCode: 105
	    });
	    taRegisterTool('underline', {
	        iconclass: 'fa fa-underline',
	        tooltiptext: taTranslations.underline.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("underline", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('underline');
	        },
	        commandKeyCode: 117
	    });
	    taRegisterTool('strikeThrough', {
	        iconclass: 'fa fa-strikethrough',
	        tooltiptext: taTranslations.strikeThrough.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("strikeThrough", null);
	        },
	        activeState: function(){
	            return document.queryCommandState('strikeThrough');
	        }
	    });
	    taRegisterTool('clear', {
	        iconclass: 'fa fa-ban',
	        tooltiptext: taTranslations.clear.tooltip,
	        action: function(deferred, restoreSelection){
	            var i, selectedElements, elementsSeen;
	
	            this.$editor().wrapSelection("removeFormat", null);
	            var possibleNodes = angular.element(taSelection.getSelectionElement());
	            selectedElements = taSelection.getAllSelectedElements();
	            //$log.log('selectedElements:', selectedElements);
	            // remove lists
	            var removeListElements = function(list, pe){
	                list = angular.element(list);
	                var prevElement = pe;
	                if (!pe) {
	                    prevElement = list;
	                }
	                angular.forEach(list.children(), function(liElem){
	                    if (liElem.tagName.toLowerCase() === 'ul' ||
	                        liElem.tagName.toLowerCase() === 'ol') {
	                        prevElement = removeListElements(liElem, prevElement);
	                    } else {
	                        var newElem = angular.element('<p></p>');
	                        newElem.html(angular.element(liElem).html());
	                        prevElement.after(newElem);
	                        prevElement = newElem;
	                    }
	                });
	                list.remove();
	                return prevElement;
	            };
	
	            angular.forEach(selectedElements, function(element) {
	                if (element.nodeName.toLowerCase() === 'ul' ||
	                    element.nodeName.toLowerCase() === 'ol') {
	                    //console.log('removeListElements', element);
	                    removeListElements(element);
	                }
	            });
	
	            angular.forEach(possibleNodes.find("ul"), removeListElements);
	            angular.forEach(possibleNodes.find("ol"), removeListElements);
	
	            // clear out all class attributes. These do not seem to be cleared via removeFormat
	            var $editor = this.$editor();
	            var recursiveRemoveClass = function(node){
	                node = angular.element(node);
	                /* istanbul ignore next: this is not triggered in tests any longer since we now never select the whole displayELement */
	                if(node[0] !== $editor.displayElements.text[0]) {
	                    node.removeAttr('class');
	                }
	                angular.forEach(node.children(), recursiveRemoveClass);
	            };
	            angular.forEach(possibleNodes, recursiveRemoveClass);
	            // check if in list. If not in list then use formatBlock option
	            if(possibleNodes[0] && possibleNodes[0].tagName.toLowerCase() !== 'li' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ol' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ul' &&
	                possibleNodes[0].getAttribute("contenteditable") !== "true") {
	                this.$editor().wrapSelection("formatBlock", "default");
	            }
	            restoreSelection();
	        }
	    });
	
	        /* jshint -W099 */
	    /****************************
	     //  we don't use this code - since the previous way CLEAR is expected to work does not clear partially selected <li>
	
	     var removeListElement = function(listE){
	                console.log(listE);
	                var _list = listE.parentNode.childNodes;
	                console.log('_list', _list);
	                var _preLis = [], _postLis = [], _found = false;
	                for (i = 0; i < _list.length; i++) {
	                    if (_list[i] === listE) {
	                        _found = true;
	                    } else if (!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(listE.parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(listE).html());
	                if (_preLis.length === 0 || _postLis.length === 0) {
	                    if (_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(listE).remove();
	                } else {
	                    var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    for (i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for (i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            };
	
	     elementsSeen = [];
	     if (selectedElements.length !==0) console.log(selectedElements);
	     angular.forEach(selectedElements, function (element) {
	                if (elementsSeen.indexOf(element) !== -1 || elementsSeen.indexOf(element.parentElement) !== -1) {
	                    return;
	                }
	                elementsSeen.push(element);
	                if (element.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element);
	                    removeListElement(element);
	                }
	                else if (element.parentElement && element.parentElement.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element.parentElement);
	                    elementsSeen.push(element.parentElement);
	                    removeListElement(element.parentElement);
	                }
	            });
	     **********************/
	
	    /**********************
	     if(possibleNodes[0].tagName.toLowerCase() === 'li'){
	                var _list = possibleNodes[0].parentNode.childNodes;
	                var _preLis = [], _postLis = [], _found = false;
	                for(i = 0; i < _list.length; i++){
	                    if(_list[i] === possibleNodes[0]){
	                        _found = true;
	                    }else if(!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(possibleNodes[0].parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(possibleNodes[0]).html());
	                if(_preLis.length === 0 || _postLis.length === 0){
	                    if(_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if(_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(possibleNodes[0]).remove();
	                }else{
	                    var _firstList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    var _secondList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    for(i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for(i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            }
	     *******************/
	
	
	    /* istanbul ignore next: if it's javascript don't worry - though probably should show some kind of error message */
	    var blockJavascript = function (link) {
	        if (link.toLowerCase().indexOf('javascript')!==-1) {
	            return true;
	        }
	        return false;
	    };
	
	    taRegisterTool('insertImage', {
	        iconclass: 'fa fa-picture-o',
	        tooltiptext: taTranslations.insertImage.tooltip,
	        action: function(){
	            var imageLink;
	            imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
	            if(imageLink && imageLink !== '' && imageLink !== 'http://'){
	                /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                // block javascript here
	                if (!blockJavascript(imageLink)) {
	                    if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                        // due to differences in implementation between FireFox and Chrome, we must move the
	                        // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                        // With this change, both FireFox and Chrome behave the same way!
	                        taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                    }
	                    // In the past we used the simple statement:
	                    //return this.$editor().wrapSelection('insertImage', imageLink, true);
	                    //
	                    // However on Firefox only, when the content is empty this is a problem
	                    // See Issue #1201
	                    // Investigation reveals that Firefox only inserts a <p> only!!!!
	                    // So now we use insertHTML here and all is fine.
	                    // NOTE: this is what 'insertImage' is supposed to do anyway!
	                    var embed = '<img src="' + imageLink + '">';
	                    return this.$editor().wrapSelection('insertHTML', embed, true);
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertVideo', {
	        iconclass: 'fa fa-youtube-play',
	        tooltiptext: taTranslations.insertVideo.tooltip,
	        action: function(){
	            var urlPrompt;
	            urlPrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, 'https://');
	            // block javascript here
	            /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	            if (!blockJavascript(urlPrompt)) {
	
	                if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
	
	                    videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);
	
	                    /* istanbul ignore else: if it's invalid don't worry - though probably should show some kind of error message */
	                    if (videoId) {
	                        // create the embed link
	                        var urlLink = "https://www.youtube.com/embed/" + videoId;
	                        // create the HTML
	                        // for all options see: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
	                        // maxresdefault.jpg seems to be undefined on some.
	                        var embed = '<img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" contenteditable="false" allowfullscreen="true" frameborder="0" />';
	                        /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                        if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                            // due to differences in implementation between FireFox and Chrome, we must move the
	                            // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                            // With this change, both FireFox and Chrome behave the same way!
	                            taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                        }
	                        // insert
	                        return this.$editor().wrapSelection('insertHTML', embed, true);
	                    }
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            onlyWithAttrs: ['ta-insert-video'],
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertLink', {
	        tooltiptext: taTranslations.insertLink.tooltip,
	        iconclass: 'fa fa-link',
	        action: function(){
	            var urlLink;
	            // if this link has already been set, we need to just edit the existing link
	            /* istanbul ignore if: we do not test this */
	            if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, taSelection.getSelectionElement().href);
	            } else {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
	            }
	            if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                // block javascript here
	                /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	                if (!blockJavascript(urlLink)) {
	                    return this.$editor().wrapSelection('createLink', urlLink, true);
	                }
	            }
	        },
	        activeState: function(commonElement){
	            if(commonElement) return commonElement[0].tagName === 'A';
	            return false;
	        },
	        onElementSelect: {
	            element: 'a',
	            action: taToolFunctions.aOnSelectAction
	        }
	    });
	    taRegisterTool('wordcount', {
	        display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
	        disabled: true,
	        wordcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            /* istanbul ignore next: will default to '' when undefined */
	            var workingHTML = textElement[0].innerHTML || '';
	            var noOfWords = 0;
	
	            /* istanbul ignore if: will default to '' when undefined */
	            if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
	                if (workingHTML.trim() !== '') {
	                    noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
	                        .replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
	                        .replace(/(<[^>]*?>)/ig, '') // remove any singular tags
	                        .replace(/\s+/ig, ' ') // condense spacing
	                        .match(/\S+/g).length; // count remaining non-space strings
	                }
	            }
	
	            //Set current scope
	            this.wordcount = noOfWords;
	            //Set editor scope
	            this.$editor().wordcount = noOfWords;
	
	            return false;
	        }
	    });
	    taRegisterTool('charcount', {
	        display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
	        disabled: true,
	        charcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.
	
	            // Caculate number of chars
	            var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm,"").replace(/^\s+/g,' ').replace(/\s+$/g, ' ').length;
	            //Set current scope
	            this.charcount = noOfChars;
	            //Set editor scope
	            this.$editor().charcount = noOfChars;
	            return false;
	        }
	    });
	}]);
	
	/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.5.16
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/
	
	/*
	Commonjs package manager support (eg componentjs).
	*/
	
	
	"use strict";// NOTE: textAngularVersion must match the Gruntfile.js 'setVersion' task.... and have format v/d+./d+./d+
	var textAngularVersion = 'v1.5.16';   // This is automatically updated during the build process to the current release!
	
	
	// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
	// We need this as IE sometimes plays funny tricks with the contenteditable.
	// ----------------------------------------------------------
	// If you're not in IE (or IE version is less than 5) then:
	// ie === undefined
	// If you're in IE (>=5) then you can determine which version:
	// ie === 7; // IE7
	// Thus, to detect IE:
	// if (ie) {}
	// And to detect the version:
	// ie === 6 // IE6
	// ie > 7 // IE8, IE9, IE10 ...
	// ie < 9 // Anything less than IE9
	// ----------------------------------------------------------
	/* istanbul ignore next: untestable browser check */
	var _browserDetect = {
		ie: (function(){
			var undef,
				v = 3,
				div = document.createElement('div'),
				all = div.getElementsByTagName('i');
	
			while (
				div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
				all[0]
			);
	
			return v > 4 ? v : undef;
		}()),
		webkit: /AppleWebKit\/([\d.]+)/i.test(navigator.userAgent),
		isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1
	};
	
	// Global to textAngular to measure performance where needed
	/* istanbul ignore next: untestable browser check */
	var performance = performance || {};
	/* istanbul ignore next: untestable browser check */
	performance.now = (function() {
		return performance.now       ||
			performance.mozNow    ||
			performance.msNow     ||
			performance.oNow      ||
			performance.webkitNow ||
			function() { return new Date().getTime(); };
	})();
	// usage is:
	// var t0 = performance.now();
	// doSomething();
	// var t1 = performance.now();
	// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to do something!');
	//
	
	// turn html into pure text that shows visiblity
	function stripHtmlToText(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		var res = tmp.textContent || tmp.innerText || '';
		res.replace('\u200B', ''); // zero width space
		res = res.trim();
		return res;
	}
	// get html
	function getDomFromHtml(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp;
	}
	
	
	// Global to textAngular REGEXP vars for block and list elements.
	
	var BLOCKELEMENTS = /^(address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;
	var LISTELEMENTS = /^(ul|li|ol)$/i;
	// updated VALIDELEMENTS to include #text and span so that we can use nodeName instead of tagName
	var VALIDELEMENTS = /^(#text|span|address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;
	
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
	/* istanbul ignore next: trim shim for older browsers */
	if (!String.prototype.trim) {
		String.prototype.trim = function () {
			return this.replace(/^\s+|\s+$/g, '');
		};
	}
	
	/*
		Custom stylesheet for the placeholders rules.
		Credit to: http://davidwalsh.name/add-rules-stylesheets
	*/
	var sheet, addCSSRule, removeCSSRule, _addCSSRule, _removeCSSRule, _getRuleIndex;
	/* istanbul ignore else: IE <8 test*/
	if(_browserDetect.ie > 8 || _browserDetect.ie === undefined){
		var _sheets = document.styleSheets;
		/* istanbul ignore next: preference for stylesheet loaded externally */
		for(var i = 0; i < _sheets.length; i++){
			if(_sheets[i].media.length === 0 || _sheets[i].media.mediaText.match(/(all|screen)/ig)){
				if(_sheets[i].href){
					if(_sheets[i].href.match(/textangular\.(min\.|)css/ig)){
						sheet = _sheets[i];
						break;
					}
				}
			}
		}
		/* istanbul ignore next: preference for stylesheet loaded externally */
		if(!sheet){
			// this sheet is used for the placeholders later on.
			sheet = (function() {
				// Create the <style> tag
				var style = document.createElement("style");
				/* istanbul ignore else : WebKit hack :( */
				if(_browserDetect.webkit) style.appendChild(document.createTextNode(""));
	
				// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
				document.getElementsByTagName('head')[0].appendChild(style);
	
				return style.sheet;
			})();
		}
	
		// use as: addCSSRule("header", "float: left");
		addCSSRule = function(selector, rules) {
			return _addCSSRule(sheet, selector, rules);
		};
		_addCSSRule = function(_sheet, selector, rules){
			var insertIndex;
			var insertedRule;
			// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
			/* istanbul ignore next: browser catches */
			if(_sheet.cssRules) insertIndex = Math.max(_sheet.cssRules.length - 1, 0);
			else if(_sheet.rules) insertIndex = Math.max(_sheet.rules.length - 1, 0);
	
			/* istanbul ignore else: untestable IE option */
			if(_sheet.insertRule) {
				_sheet.insertRule(selector + "{" + rules + "}", insertIndex);
			}
			else {
				_sheet.addRule(selector, rules, insertIndex);
			}
			/* istanbul ignore next: browser catches */
			if(sheet.rules) insertedRule = sheet.rules[insertIndex];
			else if(sheet.cssRules) insertedRule = sheet.cssRules[insertIndex];
			// return the inserted stylesheet rule
			return insertedRule;
		};
	
		_getRuleIndex = function(rule, rules) {
			var i, ruleIndex;
			for (i=0; i < rules.length; i++) {
				/* istanbul ignore else: check for correct rule */
				if (rules[i].cssText === rule.cssText) {
					ruleIndex = i;
					break;
				}
			}
			return ruleIndex;
		};
	
		removeCSSRule = function(rule){
			_removeCSSRule(sheet, rule);
		};
		/* istanbul ignore next: tests are browser specific */
		_removeCSSRule = function(sheet, rule){
			var rules = sheet.cssRules || sheet.rules;
			if(!rules || rules.length === 0) return;
			var ruleIndex = _getRuleIndex(rule, rules);
			if(sheet.removeRule){
				sheet.removeRule(ruleIndex);
			}else{
				sheet.deleteRule(ruleIndex);
			}
		};
	}
	
	angular.module('textAngular.factories', [])
	.factory('taBrowserTag', [function(){
	    return function(tag){
	        /* istanbul ignore next: ie specific test */
	        if(!tag) return (_browserDetect.ie <= 8)? 'P' : 'p';
	        else if(tag === '') return (_browserDetect.ie === undefined)? 'div' : (_browserDetect.ie <= 8)? 'P' : 'p';
	        else return (_browserDetect.ie <= 8)? tag.toUpperCase() : tag;
	    };
	}]).factory('taApplyCustomRenderers', ['taCustomRenderers', 'taDOM', function(taCustomRenderers, taDOM){
	    return function(val){
	        var element = angular.element('<div></div>');
	        element[0].innerHTML = val;
	
	        angular.forEach(taCustomRenderers, function(renderer){
	            var elements = [];
	            // get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
	            if(renderer.selector && renderer.selector !== '')
	                elements = element.find(renderer.selector);
	            /* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
	            else if(renderer.customAttribute && renderer.customAttribute !== '')
	                elements = taDOM.getByAttribute(element, renderer.customAttribute);
	            // process elements if any found
	            angular.forEach(elements, function(_element){
	                _element = angular.element(_element);
	                if(renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== ''){
	                    if(_element.attr(renderer.customAttribute) !== undefined) renderer.renderLogic(_element);
	                } else renderer.renderLogic(_element);
	            });
	        });
	
	        return element[0].innerHTML;
	    };
	}]).factory('taFixChrome', function(){
	    // get whaterever rubbish is inserted in chrome
	    // should be passed an html string, returns an html string
	    var taFixChrome = function(html, keepStyles){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // grab all elements with a style attibute
	        // a betterSpanMatch matches only a style=... with matching quotes
	        // this captures the whole:
	        // 'style="background-color: rgb(255, 255, 255);"'
	        var betterSpanMatch = /style\s?=\s?(["'])(?:(?=(\\?))\2.)*?\1/ig;
	        // where the original spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        // captures too much and includes the front tag!
	        var spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        var appleConvertedSpaceMatch = /<span class="Apple-converted-space">([^<]+)<\/span>/ig;
	        var match, styleVal, appleSpaceVal, newTag, finalHtml = '', lastIndex = 0;
	        // remove all the Apple-converted-space spans and replace with the content of the span
	        //console.log('before:', html);
	        /* istanbul ignore next: apple-contereted-space span match */
	        while(match = appleConvertedSpaceMatch.exec(html)){
	            appleSpaceVal = match[1];
	            appleSpaceVal = appleSpaceVal.replace(/&nbsp;/ig, ' ');
	            finalHtml += html.substring(lastIndex, match.index) + appleSpaceVal;
	            lastIndex = match.index + match[0].length;
	        }
	        /* istanbul ignore next: apple-contereted-space span has matched */
	        if (lastIndex) {
	            // modified....
	            finalHtml += html.substring(lastIndex);
	            html=finalHtml;
	            finalHtml='';
	            lastIndex=0;
	        }
	        /////////////////////////////////////////////////////////////
	        //
	        // Allow control of this modification
	        // taKeepStyles: False - removes these modification
	        //
	        // taFixChrome removes the following styles:
	        //    font-family: inherit;
	        //    line-height: <number>
	        //    color: inherit;
	        //    color: rgb( <rgb-component>#{3} )
	        //    background-color: rgb( <rgb-component>#{3} )
	        //
	        /////////////////////////////////////////////////////////////
	        if (!keepStyles) {
	            while (match = betterSpanMatch.exec(html)) {
	                finalHtml += html.substring(lastIndex, match.index-1);
	                styleVal = match[0];
	                // test for chrome inserted junk
	                match = /font-family: inherit;|line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;|color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/gi.exec(styleVal);
	                if (match) {
	                    styleVal = styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;|( |)color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|( |)background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/ig, '');
	                    //console.log(styleVal, styleVal.length);
	                    if (styleVal.length > 8) {
	                        finalHtml += ' ' + styleVal;
	                    }
	                } else {
	                    finalHtml += ' ' + styleVal;
	                }
	                lastIndex = betterSpanMatch.lastIndex;
	            }
	            finalHtml += html.substring(lastIndex);
	        }
	        //console.log('final:', finalHtml);
	        // only replace when something has changed, else we get focus problems on inserting lists
	        if(lastIndex > 0){
	            // replace all empty strings
	            var fe = finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig, '$1');
	            return fe;
	        } else return html;
	    };
	    return taFixChrome;
	}).factory('taSanitize', ['$sanitize', function taSanitizeFactory($sanitize){
	
	    var convert_infos = [
	        {
	            property: 'font-weight',
	            values: [ 'bold' ],
	            tag: 'b'
	        },
	        {
	            property: 'font-style',
	            values: [ 'italic' ],
	            tag: 'i'
	        }
	    ];
	
	    var styleMatch = [];
	    for(var i = 0; i < convert_infos.length; i++){
	        var _partialStyle = '(' + convert_infos[i].property + ':\\s*(';
	        for(var j = 0; j < convert_infos[i].values.length; j++){
	            /* istanbul ignore next: not needed to be tested yet */
	            if(j > 0) _partialStyle += '|';
	            _partialStyle += convert_infos[i].values[j];
	        }
	        _partialStyle += ');)';
	        styleMatch.push(_partialStyle);
	    }
	    var styleRegexString = '(' + styleMatch.join('|') + ')';
	
	    function wrapNested(html, wrapTag) {
	        var depth = 0;
	        var lastIndex = 0;
	        var match;
	        var tagRegex = /<[^>]*>/ig;
	        while(match = tagRegex.exec(html)){
	            lastIndex = match.index;
	            if(match[0].substr(1, 1) === '/'){
	                if(depth === 0) break;
	                else depth--;
	            }else depth++;
	        }
	        return wrapTag +
	            html.substring(0, lastIndex) +
	            // get the start tags reversed - this is safe as we construct the strings with no content except the tags
	            angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length) +
	            html.substring(lastIndex);
	    }
	
	    function transformLegacyStyles(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        var i;
	        var styleElementMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, subMatch, styleVal, newTag, lastNewTag = '', newHtml, finalHtml = '', lastIndex = 0;
	        while(match = styleElementMatch.exec(html)){
	            // one of the quoted values ' or "
	            /* istanbul ignore next: quotations match */
	            styleVal = match[3] || match[4];
	            var styleRegex = new RegExp(styleRegexString, 'i');
	            // test for style values to change
	            if(angular.isString(styleVal) && styleRegex.test(styleVal)){
	                // remove build tag list
	                newTag = '';
	                // init regex here for exec
	                var styleRegexExec = new RegExp(styleRegexString, 'ig');
	                // find relevand tags and build a string of them
	                while(subMatch = styleRegexExec.exec(styleVal)){
	                    for(i = 0; i < convert_infos.length; i++){
	                        if(!!subMatch[(i*2) + 2]){
	                            newTag += '<' + convert_infos[i].tag + '>';
	                        }
	                    }
	                }
	                // recursively find more legacy styles in html before this tag and after the previous match (if any)
	                newHtml = transformLegacyStyles(html.substring(lastIndex, match.index));
	                // build up html
	                if(lastNewTag.length > 0){
	                    finalHtml += wrapNested(newHtml, lastNewTag);
	                }else finalHtml += newHtml;
	                // grab the style val without the transformed values
	                styleVal = styleVal.replace(new RegExp(styleRegexString, 'ig'), '');
	                // build the html tag
	                finalHtml += '<' + match[1].trim();
	                if(styleVal.length > 0) finalHtml += ' style="' + styleVal + '"';
	                finalHtml += match[5] + '>';
	                // update the start index to after this tag
	                lastIndex = match.index + match[0].length;
	                lastNewTag = newTag;
	            }
	        }
	        if(lastNewTag.length > 0){
	            finalHtml += wrapNested(html.substring(lastIndex), lastNewTag);
	        }
	        else finalHtml += html.substring(lastIndex);
	        return finalHtml;
	    }
	
	    function transformLegacyAttributes(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // replace all align='...' tags with text-align attributes
	        var attrElementMatch = /<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, finalHtml = '', lastIndex = 0;
	        // match all attr tags
	        while(match = attrElementMatch.exec(html)){
	            // add all html before this tag
	            finalHtml += html.substring(lastIndex, match.index);
	            // record last index after this tag
	            lastIndex = match.index + match[0].length;
	            // construct tag without the align attribute
	            var newTag = '<' + match[1] + match[5];
	            // add the style attribute
	            if(/style=("([^"]+)"|'([^']+)')/ig.test(newTag)){
	                /* istanbul ignore next: quotations match */
	                newTag = newTag.replace(/style=("([^"]+)"|'([^']+)')/i, 'style="$2$3 text-align:' + (match[3] || match[4]) + ';"');
	            }else{
	                /* istanbul ignore next: quotations match */
	                newTag += ' style="text-align:' + (match[3] || match[4]) + ';"';
	            }
	            newTag += '>';
	            // add to html
	            finalHtml += newTag;
	        }
	        // return with remaining html
	        return finalHtml + html.substring(lastIndex);
	    }
	
	    // use precompiled regexp for speed
	    var rsb1 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	    var rsb2 = new RegExp(/<span class="rangySelectionBoundary" id="selectionBoundary_\d+_\d+">[^<>]+?<\/span>/ig);
	    var rsb3 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	
	    return function taSanitize(unsafe, oldsafe, ignore){
	        // unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
	        if ( !ignore ) {
	            try {
	                unsafe = transformLegacyStyles(unsafe);
	            } catch (e) {
	            }
	        }
	
	        // unsafe and oldsafe should be valid HTML strings
	        // any exceptions (lets say, color for example) should be made here but with great care
	        // setup unsafe element for modification
	        unsafe = transformLegacyAttributes(unsafe);
	
	        // we had an issue in the past, where we dumped a whole bunch of <span>'s into the content...
	        // so we remove them here
	        // IN A FUTURE release this can be removed after all have updated through release 1.5.9
	        if (unsafe) {
	            try {
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb2, '');
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb3, '');
	            } catch (e) {
	            }
	        }
	
	        var safe;
	        try {
	            safe = $sanitize(unsafe);
	            // do this afterwards, then the $sanitizer should still throw for bad markup
	            if(ignore) safe = unsafe;
	        } catch (e){
	            safe = oldsafe || '';
	        }
	
	        // Do processing for <pre> tags, removing tabs and return carriages outside of them
	
	        var _preTags = safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);
	        var processedSafe = safe.replace(/(&#(9|10);)*/ig, '');
	        var re = /<pre[^>]*>.*?<\/pre[^>]*>/ig;
	        var index = 0;
	        var lastIndex = 0;
	        var origTag;
	        safe = '';
	        while((origTag = re.exec(processedSafe)) !== null && index < _preTags.length){
	            safe += processedSafe.substring(lastIndex, origTag.index) + _preTags[index];
	            lastIndex = origTag.index + origTag[0].length;
	            index++;
	        }
	        return safe + processedSafe.substring(lastIndex);
	    };
	}]).factory('taToolExecuteAction', ['$q', '$log', function($q, $log){
	    // this must be called on a toolScope or instance
	    return function(editor){
	        if(editor !== undefined) this.$editor = function(){ return editor; };
	        var deferred = $q.defer(),
	            promise = deferred.promise,
	            _editor = this.$editor();
	        // pass into the action the deferred function and also the function to reload the current selection if rangy available
	        var result;
	        try{
	            result = this.action(deferred, _editor.startAction());
	            // We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
	            promise['finally'](function(){
	                _editor.endAction.call(_editor);
	            });
	        }catch(exc){
	            $log.error(exc);
	        }
	        if(result || result === undefined){
	            // if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
	            deferred.resolve();
	        }
	    };
	}]);
	
	angular.module('textAngular.DOM', ['textAngular.factories'])
	.factory('taExecCommand', ['taSelection', 'taBrowserTag', '$document', function(taSelection, taBrowserTag, $document){
	    var listToDefault = function(listElement, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements and convert to taDefaultWrap tags
	        var children = listElement.find('li');
	        for(i = children.length - 1; i >= 0; i--){
	            $target = angular.element('<' + defaultWrap + '>' + children[i].innerHTML + '</' + defaultWrap + '>');
	            listElement.after($target);
	        }
	        listElement.remove();
	        taSelection.setSelectionToElementEnd($target[0]);
	    };
	    var listElementToSelfTag = function(list, listElement, selfTag, bDefault, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements
	        var priorElement;
	        var nextElement;
	        var children = list.find('li');
	        var foundIndex;
	        for (i = 0; i<children.length; i++) {
	            if (children[i].outerHTML === listElement[0].outerHTML) {
	                // found it...
	                foundIndex = i;
	                if (i>0) {
	                    priorElement = children[i-1];
	                }
	                if (i+1<children.length) {
	                    nextElement = children[i+1];
	                }
	                break;
	            }
	        }
	        //console.log('listElementToSelfTag', list, listElement, selfTag, bDefault, priorElement, nextElement);
	        // un-list the listElement
	        var html = '';
	        if (bDefault) {
	            html += '<' + defaultWrap + '>' + listElement[0].innerHTML + '</' + defaultWrap + '>';
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            html += '<li>' + listElement[0].innerHTML + '</li>';
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        //console.log('$target', $target[0]);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            listElement.remove();
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!nextElement) {
	            // this is the last in the list, so we just remove it..
	            listElement.remove();
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	        } else {
	            var p = list.parent();
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndex; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndex+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            //console.log(html1, $target[0], html2);
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******XXX*****', p[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var listElementsToSelfTag = function(list, listElements, selfTag, bDefault, defaultWrap){
	        var $target, i, j, p;
	        // grab all li elements
	        var priorElement;
	        var afterElement;
	        //console.log('list:', list, 'listElements:', listElements, 'selfTag:', selfTag, 'bDefault:', bDefault);
	        var children = list.find('li');
	        var foundIndexes = [];
	        for (i = 0; i<children.length; i++) {
	            for (j = 0; j<listElements.length; j++) {
	                if (children[i].isEqualNode(listElements[j])) {
	                    // found it...
	                    foundIndexes[j] = i;
	                }
	            }
	        }
	        if (foundIndexes[0] > 0) {
	            priorElement = children[foundIndexes[0] - 1];
	        }
	        if (foundIndexes[listElements.length-1] + 1 < children.length) {
	            afterElement = children[foundIndexes[listElements.length-1] + 1];
	        }
	        //console.log('listElementsToSelfTag', list, listElements, selfTag, bDefault, !priorElement, !afterElement, foundIndexes[listElements.length-1], children.length);
	        // un-list the listElements
	        var html = '';
	        if (bDefault) {
	            for (j = 0; j < listElements.length; j++) {
	                html += '<' + defaultWrap + '>' + listElements[j].innerHTML + '</' + defaultWrap + '>';
	                listElements[j].remove();
	            }
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            for (j = 0; j < listElements.length; j++) {
	                html += listElements[j].outerHTML;
	                listElements[j].remove();
	            }
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!afterElement) {
	            // this is the last in the list, so we just remove it..
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else {
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndexes[0]; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndexes[listElements.length-1]+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******YYY*****', list.parent()[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var selectLi = function(liElement){
	        if(/(<br(|\/)>)$/i.test(liElement.innerHTML.trim())) taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);
	        else taSelection.setSelectionToElementEnd(liElement);
	    };
	    var listToList = function(listElement, newListTag){
	        var $target = angular.element('<' + newListTag + '>' + listElement[0].innerHTML + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var childElementsToList = function(elements, listElement, newListTag){
	        var html = '';
	        for(var i = 0; i < elements.length; i++){
	            html += '<' + taBrowserTag('li') + '>' + elements[i].innerHTML + '</' + taBrowserTag('li') + '>';
	        }
	        var $target = angular.element('<' + newListTag + '>' + html + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var turnBlockIntoBlocks = function(element, options) {
	        for(var i = 0; i<element.childNodes.length; i++) {
	            var _n = element.childNodes[i];
	            /* istanbul ignore next - more complex testing*/
	            if (_n.tagName && _n.tagName.match(BLOCKELEMENTS)) {
	                turnBlockIntoBlocks(_n, options);
	            }
	        }
	        /* istanbul ignore next - very rare condition that we do not test*/
	        if (element.parentNode === null) {
	            // nothing left to do..
	            return element;
	        }
	        /* istanbul ignore next - not sure have to test this */
	        if (options === '<br>'){
	            return element;
	        }
	        else {
	            var $target = angular.element(options);
	            $target[0].innerHTML = element.innerHTML;
	            element.parentNode.insertBefore($target[0], element);
	            element.parentNode.removeChild(element);
	            return $target;
	        }
	    };
	    return function(taDefaultWrap, topNode){
	        // NOTE: here we are dealing with the html directly from the browser and not the html the user sees.
	        // IF you want to modify the html the user sees, do it when the user does a switchView
	        taDefaultWrap = taBrowserTag(taDefaultWrap);
	        return function(command, showUI, options, defaultTagAttributes){
	            var i, $target, html, _nodes, next, optionsTagName, selectedElement, ourSelection;
	            var defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	            try{
	                if (taSelection.getSelection) {
	                    ourSelection = taSelection.getSelection();
	                }
	                selectedElement = taSelection.getSelectionElement();
	                // special checks and fixes when we are selecting the whole container
	                var __h, _innerNode;
	                /* istanbul ignore next */
	                if (selectedElement.tagName !== undefined) {
	                    if (selectedElement.tagName.toLowerCase() === 'div' &&
	                        /taTextElement.+/.test(selectedElement.id) &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // opps we are actually selecting the whole container!
	                        //console.log('selecting whole container!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner whole container', selectedElement.childNodes);
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                    } else if (selectedElement.tagName.toLowerCase() === 'span' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // just a span -- this is a problem...
	                        //console.log('selecting span!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner span', selectedElement.childNodes);
	                        // we wrap this in a <div> because otherwise the browser get confused when we attempt to select the whole node
	                        // and the focus is not set correctly no matter what we do
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                        //console.log(selectedElement.innerHTML);
	                    } else if (selectedElement.tagName.toLowerCase() === 'p' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        //console.log('p special');
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                            selectedElement.innerHTML = __h;
	                        }
	                    } else if (selectedElement.tagName.toLowerCase() === 'li' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === ourSelection.end.offset) {
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '');  // nothing
	                            selectedElement.innerHTML = __h;
	                        }
	                    }
	                }
	            }catch(e){}
	            //console.log('************** selectedElement:', selectedElement);
	            /* istanbul ignore if: */
	            if (!selectedElement){return;}
	            var $selected = angular.element(selectedElement);
	            var tagName = (selectedElement && selectedElement.tagName && selectedElement.tagName.toLowerCase()) ||
	                /* istanbul ignore next: */ "";
	            if(command.toLowerCase() === 'insertorderedlist' || command.toLowerCase() === 'insertunorderedlist'){
	                var selfTag = taBrowserTag((command.toLowerCase() === 'insertorderedlist')? 'ol' : 'ul');
	                var selectedElements = taSelection.getOnlySelectedElements();
	                //console.log('PPPPPPPPPPPPP', tagName, selfTag, selectedElements, tagName.match(BLOCKELEMENTS), $selected.hasClass('ta-bind'), $selected.parent()[0].tagName);
	                if (selectedElements.length>1 && (tagName === 'ol' ||  tagName === 'ul' )) {
	                    return listElementsToSelfTag($selected, selectedElements, selfTag, selfTag===tagName, taDefaultWrap);
	                }
	                if(tagName === selfTag){
	                    // if all selected then we should remove the list
	                    // grab all li elements and convert to taDefaultWrap tags
	                    //console.log('tagName===selfTag');
	                    if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                        $selected = angular.element(selectedElements[0]);
	                        return listElementToSelfTag($selected.parent(), $selected, selfTag, true, taDefaultWrap);
	                    } else {
	                        return listToDefault($selected, taDefaultWrap);
	                    }
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() === selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToDefault($selected.parent(), taDefaultWrap);
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() !== selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToList($selected.parent(), selfTag);
	                }else if(tagName.match(BLOCKELEMENTS) && !$selected.hasClass('ta-bind')){
	                    // if it's one of those block elements we have to change the contents
	                    // if it's a ol/ul we are changing from one to the other
	                    if (selectedElements.length) {
	                        if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                            //console.log('&&&&&&&&&&&&&&& --------- &&&&&&&&&&&&&&&&', selectedElements[0], $selected[0].childNodes);
	                            $selected = angular.element(selectedElements[0]);
	                            return listElementToSelfTag($selected.parent(), $selected, selfTag, selfTag===tagName, taDefaultWrap);
	                        }
	                    }
	                    if(tagName === 'ol' || tagName === 'ul'){
	                        // now if this is a set of selected elements... behave diferently
	                        return listToList($selected, selfTag);
	                    }else{
	                        var childBlockElements = false;
	                        angular.forEach($selected.children(), function(elem){
	                            if(elem.tagName.match(BLOCKELEMENTS)) {
	                                childBlockElements = true;
	                            }
	                        });
	                        if(childBlockElements){
	                            return childElementsToList($selected.children(), $selected, selfTag);
	                        }else{
	                            return childElementsToList([angular.element('<div>' + selectedElement.innerHTML + '</div>')[0]], $selected, selfTag);
	                        }
	                    }
	                }else if(tagName.match(BLOCKELEMENTS)){
	                    // if we get here then the contents of the ta-bind are selected
	                    _nodes = taSelection.getOnlySelectedElements();
	                    //console.log('_nodes', _nodes, tagName);
	                    if(_nodes.length === 0){
	                        // here is if there is only text in ta-bind ie <div ta-bind>test content</div>
	                        $target = angular.element('<' + selfTag + '><li>' + selectedElement.innerHTML + '</li></' + selfTag + '>');
	                        $selected.html('');
	                        $selected.append($target);
	                    }else if(_nodes.length === 1 && (_nodes[0].tagName.toLowerCase() === 'ol' || _nodes[0].tagName.toLowerCase() === 'ul')){
	                        if(_nodes[0].tagName.toLowerCase() === selfTag){
	                            // remove
	                            return listToDefault(angular.element(_nodes[0]), taDefaultWrap);
	                        }else{
	                            return listToList(angular.element(_nodes[0]), selfTag);
	                        }
	                    }else{
	                        html = '';
	                        var $nodes = [];
	                        for(i = 0; i < _nodes.length; i++){
	                            /* istanbul ignore else: catch for real-world can't make it occur in testing */
	                            if(_nodes[i].nodeType !== 3){
	                                var $n = angular.element(_nodes[i]);
	                                /* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
	                                if(_nodes[i].tagName.toLowerCase() === 'li') continue;
	                                else if(_nodes[i].tagName.toLowerCase() === 'ol' || _nodes[i].tagName.toLowerCase() === 'ul'){
	                                    html += $n[0].innerHTML; // if it's a list, add all it's children
	                                }else if(_nodes[i].tagName.toLowerCase() === 'span' && (_nodes[i].childNodes[0].tagName.toLowerCase() === 'ol' || _nodes[i].childNodes[0].tagName.toLowerCase() === 'ul')){
	                                    html += $n[0].childNodes[0].innerHTML; // if it's a list, add all it's children
	                                }else{
	                                    html += '<' + taBrowserTag('li') + '>' + $n[0].innerHTML + '</' + taBrowserTag('li') + '>';
	                                }
	                                $nodes.unshift($n);
	                            }
	                        }
	                        //console.log('$nodes', $nodes);
	                        $target = angular.element('<' + selfTag + '>' + html + '</' + selfTag + '>');
	                        $nodes.pop().replaceWith($target);
	                        angular.forEach($nodes, function($node){ $node.remove(); });
	                    }
	                    taSelection.setSelectionToElementEnd($target[0]);
	                    return;
	                }
	            }else if(command.toLowerCase() === 'formatblock'){
	                optionsTagName = options.toLowerCase().replace(/[<>]/ig, '');
	                if(optionsTagName.trim() === 'default') {
	                    optionsTagName = taDefaultWrap;
	                    options = '<' + taDefaultWrap + '>';
	                }
	                if(tagName === 'li') {
	                    $target = $selected.parent();
	                }
	                else {
	                    $target = $selected;
	                }
	                // find the first blockElement
	                while(!$target[0].tagName || !$target[0].tagName.match(BLOCKELEMENTS) && !$target.parent().attr('contenteditable')){
	                    $target = $target.parent();
	                    /* istanbul ignore next */
	                    tagName = ($target[0].tagName || '').toLowerCase();
	                }
	                if(tagName === optionsTagName){
	                    // $target is wrap element
	                    _nodes = $target.children();
	                    var hasBlock = false;
	                    for(i = 0; i < _nodes.length; i++){
	                        hasBlock = hasBlock || _nodes[i].tagName.match(BLOCKELEMENTS);
	                    }
	                    if(hasBlock){
	                        $target.after(_nodes);
	                        next = $target.next();
	                        $target.remove();
	                        $target = next;
	                    }else{
	                        defaultWrapper.append($target[0].childNodes);
	                        $target.after(defaultWrapper);
	                        $target.remove();
	                        $target = defaultWrapper;
	                    }
	                }else if($target.parent()[0].tagName.toLowerCase() === optionsTagName &&
	                    !$target.parent().hasClass('ta-bind')){
	                    //unwrap logic for parent
	                    var blockElement = $target.parent();
	                    var contents = blockElement.contents();
	                    for(i = 0; i < contents.length; i ++){
	                        /* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
	                        if(blockElement.parent().hasClass('ta-bind') && contents[i].nodeType === 3){
	                            defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	                            defaultWrapper[0].innerHTML = contents[i].outerHTML;
	                            contents[i] = defaultWrapper[0];
	                        }
	                        blockElement.parent()[0].insertBefore(contents[i], blockElement[0]);
	                    }
	                    blockElement.remove();
	                }else if(tagName.match(LISTELEMENTS)){
	                    // wrapping a list element
	                    $target.wrap(options);
	                }else{
	                    // default wrap behaviour
	                    _nodes = taSelection.getOnlySelectedElements();
	                    if(_nodes.length === 0) {
	                        // no nodes at all....
	                        _nodes = [$target[0]];
	                    }
	                    // find the parent block element if any of the nodes are inline or text
	                    for(i = 0; i < _nodes.length; i++){
	                        if(_nodes[i].nodeType === 3 || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                            while(_nodes[i].nodeType === 3 || !_nodes[i].tagName || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                                _nodes[i] = _nodes[i].parentNode;
	                            }
	                        }
	                    }
	                    // remove any duplicates from the array of _nodes!
	                    _nodes = _nodes.filter(function(value, index, self) {
	                        return self.indexOf(value) === index;
	                    });
	                    // remove all whole taTextElement if it is here... unless it is the only element!
	                    if (_nodes.length>1) {
	                        _nodes = _nodes.filter(function (value, index, self) {
	                            return !(value.nodeName.toLowerCase() === 'div' && /^taTextElement/.test(value.id));
	                        });
	                    }
	                    if(angular.element(_nodes[0]).hasClass('ta-bind')){
	                        $target = angular.element(options);
	                        $target[0].innerHTML = _nodes[0].innerHTML;
	                        _nodes[0].innerHTML = $target[0].outerHTML;
	                    }else if(optionsTagName === 'blockquote'){
	                        // blockquotes wrap other block elements
	                        html = '';
	                        for(i = 0; i < _nodes.length; i++){
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0],_nodes[0]);
	                        for(i = _nodes.length - 1; i >= 0; i--){
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    } else /* istanbul ignore next: not tested since identical to blockquote */
	                    if (optionsTagName === 'pre' && taSelection.getStateShiftKey()) {
	                        //console.log('shift pre', _nodes);
	                        // pre wrap other block elements
	                        html = '';
	                        for (i = 0; i < _nodes.length; i++) {
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0], _nodes[0]);
	                        for (i = _nodes.length - 1; i >= 0; i--) {
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    }
	                    else {
	                        //console.log(optionsTagName, _nodes);
	                        // regular block elements replace other block elements
	                        for (i = 0; i < _nodes.length; i++) {
	                            var newBlock = turnBlockIntoBlocks(_nodes[i], options);
	                            if (_nodes[i] === $target[0]) {
	                                $target = angular.element(newBlock);
	                            }
	                        }
	                    }
	                }
	                taSelection.setSelectionToElementEnd($target[0]);
	                // looses focus when we have the whole container selected and no text!
	                // refocus on the shown display element, this fixes a bug when using firefox
	                $target[0].focus();
	                return;
	            }else if(command.toLowerCase() === 'createlink'){
	                /* istanbul ignore next: firefox specific fix */
	                if (tagName === 'a') {
	                    // already a link!!! we are just replacing it...
	                    taSelection.getSelectionElement().href = options;
	                    return;
	                }
	                var tagBegin = '<a href="' + options + '" target="' +
	                        (defaultTagAttributes.a.target ? defaultTagAttributes.a.target : '') +
	                        '">',
	                    tagEnd = '</a>',
	                    _selection = taSelection.getSelection();
	                if(_selection.collapsed){
	                    //console.log('collapsed');
	                    // insert text at selection, then select then just let normal exec-command run
	                    taSelection.insertHtml(tagBegin + options + tagEnd, topNode);
	                }else if(rangy.getSelection().getRangeAt(0).canSurroundContents()){
	                    var node = angular.element(tagBegin + tagEnd)[0];
	                    rangy.getSelection().getRangeAt(0).surroundContents(node);
	                }
	                return;
	            }else if(command.toLowerCase() === 'inserthtml'){
	                //console.log('inserthtml');
	                taSelection.insertHtml(options, topNode);
	                return;
	            }
	            try{
	                $document[0].execCommand(command, showUI, options);
	            }catch(e){}
	        };
	    };
	}]).service('taSelection', ['$document', 'taDOM', '$log',
	/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
	function($document, taDOM, $log){
	    // need to dereference the document else the calls don't work correctly
	    var _document = $document[0];
	    var bShiftState;
	    var brException = function (element, offset) {
	        /* check if selection is a BR element at the beginning of a container. If so, get
	        * the parentNode instead.
	        * offset should be zero in this case. Otherwise, return the original
	        * element.
	        */
	        if (element.tagName && element.tagName.match(/^br$/i) && offset === 0 && !element.previousSibling) {
	            return {
	                element: element.parentNode,
	                offset: 0
	            };
	        } else {
	            return {
	                element: element,
	                offset: offset
	            };
	        }
	    };
	    var api = {
	        getSelection: function(){
	            var range;
	            try {
	                // catch any errors from rangy and ignore the issue
	                range = rangy.getSelection().getRangeAt(0);
	            } catch(e) {
	                //console.info(e);
	                return undefined;
	            }
	            var container = range.commonAncestorContainer;
	            var selection = {
	                start: brException(range.startContainer, range.startOffset),
	                end: brException(range.endContainer, range.endOffset),
	                collapsed: range.collapsed
	            };
	            // This has problems under Firefox.
	            // On Firefox with
	            // <p>Try me !</p>
	            // <ul>
	            // <li>line 1</li>
	            // <li>line 2</li>
	            // </ul>
	            // <p>line 3</p>
	            // <ul>
	            // <li>line 4</li>
	            // <li>line 5</li>
	            // </ul>
	            // <p>Hello textAngular</p>
	            // WITH the cursor after the 3 on line 3, it gets the commonAncestorContainer as:
	            // <TextNode textContent='line 3'>
	            // AND Chrome gets the commonAncestorContainer as:
	            // <p>line 3</p>
	            //
	            // Check if the container is a text node and return its parent if so
	            // unless this is the whole taTextElement.  If so we return the textNode
	            if (container.nodeType === 3) {
	                if (container.parentNode.nodeName.toLowerCase() === 'div' &&
	                    /^taTextElement/.test(container.parentNode.id)) {
	                    // textNode where the parent is the whole <div>!!!
	                    //console.log('textNode ***************** container:', container);
	                } else {
	                    container = container.parentNode;
	                }
	            }
	            if (container.nodeName.toLowerCase() === 'div' &&
	                /^taTextElement/.test(container.id)) {
	                //console.log('*********taTextElement************');
	                //console.log('commonAncestorContainer:', container);
	                selection.start.element = container.childNodes[selection.start.offset];
	                selection.end.element = container.childNodes[selection.end.offset];
	                selection.container = container;
	            } else {
	                if (container.parentNode === selection.start.element ||
	                    container.parentNode === selection.end.element) {
	                    selection.container = container.parentNode;
	                } else {
	                    selection.container = container;
	                }
	            }
	            //console.log('***selection container:', selection.container.nodeName, selection.start.offset, selection.container);
	            return selection;
	        },
	        // if we use the LEFT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        // Chrome and Firefox behave differently so so fix this for Firefox here.  No adjustment needed for Chrome.
	        updateLeftArrowKey: function(element) {
	            var range = rangy.getSelection().getRangeAt(0);
	            if (range && range.collapsed) {
	                var _nodes = api.getFlattenedDom(range);
	                if (!_nodes.findIndex) return;
	                var _node = range.startContainer;
	                var indexStartContainer = _nodes.findIndex(function(element, index){
	                    if (element.node===_node) return true;
	                    var _indexp = element.parents.indexOf(_node);
	                    return (_indexp !== -1);
	                });
	                var m;
	                var nextNodeToRight;
	                //console.log('indexStartContainer', indexStartContainer, _nodes.length, 'startContainer:', _node, _node === _nodes[indexStartContainer].node);
	                _nodes.forEach(function (n, i) {
	                    //console.log(i, n.node);
	                    n.parents.forEach(function (nn, j){
	                        //console.log(i, j, nn);
	                    });
	                });
	                if (indexStartContainer+1 < _nodes.length) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToRight = _nodes[indexStartContainer+1].node;
	                    //console.log(nextNodeToRight, range.startContainer);
	                }
	                //console.log('updateLeftArrowKey', range.startOffset, range.startContainer.textContent);
	                // this first section handles the case for Chrome browser
	                // if the first character of the nextNode is a \ufeff we know that we are just before the special span...
	                // and so we most left by one character
	                if (nextNodeToRight && nextNodeToRight.textContent) {
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToRight.textContent);
	                    if (m) {
	                        // we are before the special node with begins with a \ufeff character
	                        //console.log('LEFT ...found it...', 'startOffset:', range.startOffset, m[0].length, m[1].length);
	                        // no need to change anything in this case
	                        return;
	                    }
	                }
	                var nextNodeToLeft;
	                if (indexStartContainer > 0) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToLeft = _nodes[indexStartContainer-1].node;
	                    //console.log(nextNodeToLeft, nextNodeToLeft);
	                }
	                if (range.startOffset === 0 && nextNodeToLeft) {
	                    //console.log(nextNodeToLeft, range.startOffset, nextNodeToLeft.textContent);
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToLeft.textContent);
	                    if (m) {
	                        //console.log('LEFT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', nextNodeToLeft, m[0].length, m[1].length);
	                        // move over to the left my one -- Firefox triggers this case
	                        api.setSelectionToElementEnd(nextNodeToLeft);
	                        return;
	                    }
	                }
	            }
	            return;
	        },
	        // if we use the RIGHT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        updateRightArrowKey: function(element) {
	            // we do not need to make any adjustments here, so we ignore all this code
	            if (false) {
	                var range = rangy.getSelection().getRangeAt(0);
	                if (range && range.collapsed) {
	                    var _nodes = api.getFlattenedDom(range);
	                    if (!_nodes.findIndex) return;
	                    var _node = range.startContainer;
	                    var indexStartContainer = _nodes.findIndex(function (element, index) {
	                        if (element.node === _node) return true;
	                        var _indexp = element.parents.indexOf(_node);
	                        return (_indexp !== -1);
	                    });
	                    var _sel;
	                    var i;
	                    var m;
	
	                    // if the last character is a \ufeff we know that we are just before the special span...
	                    // and so we most right by one character
	                    var indexFound = _nodes.findIndex(function (n, index) {
	                        if (n.textContent) {
	                            var m = /^\ufeff([^\ufeff]*)$/.exec(n.textContent);
	                            if (m) {
	                                return true;
	                            } else {
	                                return false;
	                            }
	                        } else {
	                            return false;
	                        }
	                    });
	                    if (indexFound === -1) {
	                        return;
	                    }
	                    //console.log(indexFound, range.startContainer, range.startOffset);
	                    _node = _nodes[indexStartContainer];
	                    //console.log('indexStartContainer', indexStartContainer);
	                    if (_node && _node.textContent) {
	                        m = /^\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                        if (m && range.startOffset - 1 === m[1].length) {
	                            //console.log('RIGHT found it...&&&&&&&&&&&', range.startOffset);
	                            // no need to make any adjustment
	                            return;
	                        }
	                    }
	                    //console.log(range.startOffset);
	                    if (_nodes && range.startOffset === 0) {
	                        indexStartContainer = _nodes.indexOf(range.startContainer);
	                        if (indexStartContainer !== -1 && indexStartContainer > 0) {
	                            _node = _nodes[indexStartContainer - 1];
	                            if (_node.textContent) {
	                                m = /\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                                if (m && true || range.startOffset === m[1].length + 1) {
	                                    //console.log('RIGHT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', range.startOffset, m[1].length);
	                                    // no need to make any adjustment
	                                    return;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        getFlattenedDom: function(range) {
	            var parent = range.commonAncestorContainer.parentNode;
	            if (!parent) {
	                return range.commonAncestorContainer.childNodes;
	            }
	            var nodes = Array.prototype.slice.call(parent.childNodes); // converts NodeList to Array
	            var indexStartContainer = nodes.indexOf(range.startContainer);
	            // make sure that we have a big enough set of nodes
	            if (indexStartContainer+1 < nodes.length && indexStartContainer > 0) {
	                // we are good
	                // we can go down one node or up one node
	            } else {
	                if (parent.parentNode) {
	                    parent = parent.parentNode;
	                }
	            }
	            // now walk the parent
	            nodes = [];
	            function addNodes(_set) {
	                if (_set.node.childNodes.length) {
	                    var childNodes = Array.prototype.slice.call(_set.node.childNodes); // converts NodeList to Array
	                    childNodes.forEach(function(n) {
	                        var _t = _set.parents.slice();
	                        if (_t.slice(-1)[0]!==_set.node) {
	                            _t.push(_set.node);
	                        }
	                        addNodes({parents: _t, node: n});
	                    });
	                } else {
	                    nodes.push({parents: _set.parents, node: _set.node});
	                }
	            }
	            addNodes({parents: [parent], node: parent});
	            return nodes;
	        },
	        getOnlySelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            return range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	        },
	        // this includes the container element if all children are selected
	        getAllSelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            var selectedNodes = range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	            var innerHtml = container.innerHTML;
	            // remove the junk that rangy has put down
	            innerHtml = innerHtml.replace(/<span id=.selectionBoundary[^>]+>\ufeff?<\/span>/ig, '');
	            //console.log(innerHtml);
	            //console.log(range.toHtml());
	            //console.log(innerHtml === range.toHtml());
	            if (innerHtml === range.toHtml() &&
	                // not the whole taTextElement
	                (!(container.nodeName.toLowerCase() === 'div' &&  /^taTextElement/.test(container.id)))
	            ) {
	                var arr = [];
	                for(var i = selectedNodes.length; i--; arr.unshift(selectedNodes[i]));
	                selectedNodes = arr;
	                selectedNodes.push(container);
	                //$log.debug(selectedNodes);
	            }
	            return selectedNodes;
	        },
	        // Some basic selection functions
	        getSelectionElement: function () {
	            var s = api.getSelection();
	            if (s) {
	                return api.getSelection().container;
	            } else {
	                return undefined;
	            }
	        },
	        setSelection: function(elStart, elEnd, start, end){
	            var range = rangy.createRange();
	
	            range.setStart(elStart, start);
	            range.setEnd(elEnd, end);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionBeforeElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionAfterElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(false);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementStart: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementEnd: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(false);
	            if(el.childNodes && el.childNodes[el.childNodes.length - 1] && el.childNodes[el.childNodes.length - 1].nodeName === 'br'){
	                range.startOffset = range.endOffset = range.startOffset - 1;
	            }
	            rangy.getSelection().setSingleRange(range);
	        },
	        setStateShiftKey: function(bS) {
	            bShiftState = bS;
	        },
	        getStateShiftKey: function() {
	            return bShiftState;
	        },
	        // from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
	        // topNode is the contenteditable normally, all manipulation MUST be inside this.
	        insertHtml: function(html, topNode){
	            var parent, secondParent, _childI, nodes, i, lastNode, _tempFrag;
	            var element = angular.element("<div>" + html + "</div>");
	            var range = rangy.getSelection().getRangeAt(0);
	            var frag = _document.createDocumentFragment();
	            var children = element[0].childNodes;
	            var isInline = true;
	
	            if(children.length > 0){
	                // NOTE!! We need to do the following:
	                // check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
	                // If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
	                nodes = [];
	                for(_childI = 0; _childI < children.length; _childI++){
	                    var _cnode = children[_childI];
	                    if (_cnode.nodeName.toLowerCase() === 'p' &&
	                        _cnode.innerHTML.trim() === '') { // empty p element
	                        continue;
	                    }
	                    /****************
	                     *  allow any text to be inserted...
	                    if((   _cnode.nodeType === 3 &&
	                           _cnode.nodeValue === '\ufeff'[0] &&
	                           _cnode.nodeValue.trim() === '') // empty no-space space element
	                        ) {
	                        // no change to isInline
	                        nodes.push(_cnode);
	                        continue;
	                    }
	                    if(_cnode.nodeType === 3 &&
	                         _cnode.nodeValue.trim() === '') { // empty text node
	                        continue;
	                    }
	                    *****************/
	                    isInline = isInline && !BLOCKELEMENTS.test(_cnode.nodeName);
	                    nodes.push(_cnode);
	                }
	                for(var _n = 0; _n < nodes.length; _n++) {
	                    lastNode = frag.appendChild(nodes[_n]);
	                }
	                if( !isInline &&
	                    range.collapsed &&
	                    /^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML) ) {
	                    range.selectNode(range.startContainer);
	                }
	            }else{
	                isInline = true;
	                // paste text of some sort
	                lastNode = frag = _document.createTextNode(html);
	            }
	
	            // Other Edge case - selected data spans multiple blocks.
	            if(isInline){
	                range.deleteContents();
	            }else{ // not inline insert
	                if(range.collapsed && range.startContainer !== topNode){
	                    if(range.startContainer.innerHTML && range.startContainer.innerHTML.match(/^<[^>]*>$/i)){
	                        // this log is to catch when innerHTML is something like `<img ...>`
	                        parent = range.startContainer;
	                        if(range.startOffset === 1){
	                            // before single tag
	                            range.setStartAfter(parent);
	                            range.setEndAfter(parent);
	                        }else{
	                            // after single tag
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                        }
	                    }else{
	                        // split element into 2 and insert block element in middle
	                        if(range.startContainer.nodeType === 3 && range.startContainer.parentNode !== topNode){ // if text node
	                            parent = range.startContainer.parentNode;
	                            secondParent = parent.cloneNode();
	                            // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, range.startContainer, range.startOffset);
	
	                            // Escape out of the inline tags like b
	                            while(!VALIDELEMENTS.test(parent.nodeName)){
	                                angular.element(parent).after(secondParent);
	                                parent = parent.parentNode;
	                                var _lastSecondParent = secondParent;
	                                secondParent = parent.cloneNode();
	                                // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                                taDOM.splitNodes(parent.childNodes, parent, secondParent, _lastSecondParent);
	                            }
	                        }else{
	                            parent = range.startContainer;
	                            secondParent = parent.cloneNode();
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, undefined, undefined, range.startOffset);
	                        }
	
	                        angular.element(parent).after(secondParent);
	                        // put cursor to end of inserted content
	                        //console.log('setStartAfter', parent);
	                        range.setStartAfter(parent);
	                        range.setEndAfter(parent);
	
	                        if(/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())){
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                            angular.element(parent).remove();
	                        }
	                        if(/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim())) angular.element(secondParent).remove();
	                        if(parent.nodeName.toLowerCase() === 'li'){
	                            _tempFrag = _document.createDocumentFragment();
	                            for(i = 0; i < frag.childNodes.length; i++){
	                                element = angular.element('<li>');
	                                taDOM.transferChildNodes(frag.childNodes[i], element[0]);
	                                taDOM.transferNodeAttributes(frag.childNodes[i], element[0]);
	                                _tempFrag.appendChild(element[0]);
	                            }
	                            frag = _tempFrag;
	                            if(lastNode){
	                                lastNode = frag.childNodes[frag.childNodes.length - 1];
	                                lastNode = lastNode.childNodes[lastNode.childNodes.length - 1];
	                            }
	                        }
	                    }
	                }else{
	                    range.deleteContents();
	                }
	            }
	
	            range.insertNode(frag);
	            if(lastNode){
	                api.setSelectionToElementEnd(lastNode);
	            }
	        }
	
	        /* NOT FUNCTIONAL YET
	         // under Firefox, we may have a selection that needs to be normalized
	         isSelectionContainerWhole_taTextElement: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         if (container.nodeName.toLowerCase() === 'div' &&
	         /^taTextElement/.test(container.id)) {
	         // container is the whole taTextElement
	         return true;
	         }
	         return false;
	         },
	         setNormalizedSelection: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         console.log(range);
	         console.log(container.childNodes);
	         if (range.collapsed) {
	         // we know what to do...
	         console.log(container.childNodes[range.startOffset]);
	         api.setSelectionToElementStart(container.childNodes[range.startOffset]);
	         }
	         },
	         */
	    };
	    return api;
	}]).service('taDOM', function(){
	    var taDOM = {
	        // recursive function that returns an array of angular.elements that have the passed attribute set on them
	        getByAttribute: function(element, attribute){
	            var resultingElements = [];
	            var childNodes = element.children();
	            if(childNodes.length){
	                angular.forEach(childNodes, function(child){
	                    resultingElements = resultingElements.concat(taDOM.getByAttribute(angular.element(child), attribute));
	                });
	            }
	            if(element.attr(attribute) !== undefined) resultingElements.push(element);
	            return resultingElements;
	        },
	
	        transferChildNodes: function(source, target){
	            // clear out target
	            target.innerHTML = '';
	            while(source.childNodes.length > 0) target.appendChild(source.childNodes[0]);
	            return target;
	        },
	
	        splitNodes: function(nodes, target1, target2, splitNode, subSplitIndex, splitIndex){
	            if(!splitNode && isNaN(splitIndex)) throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');
	            var startNodes = document.createDocumentFragment();
	            var endNodes = document.createDocumentFragment();
	            var index = 0;
	
	            while(nodes.length > 0 && (isNaN(splitIndex) || splitIndex !== index) && nodes[0] !== splitNode){
	                startNodes.appendChild(nodes[0]); // this removes from the nodes array (if proper childNodes object.
	                index++;
	            }
	
	            if(!isNaN(subSplitIndex) && subSplitIndex >= 0 && nodes[0]){
	                startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0, subSplitIndex)));
	                nodes[0].nodeValue = nodes[0].nodeValue.substring(subSplitIndex);
	            }
	            while(nodes.length > 0) endNodes.appendChild(nodes[0]);
	
	            taDOM.transferChildNodes(startNodes, target1);
	            taDOM.transferChildNodes(endNodes, target2);
	        },
	
	        transferNodeAttributes: function(source, target){
	            for(var i = 0; i < source.attributes.length; i++) target.setAttribute(source.attributes[i].name, source.attributes[i].value);
	            return target;
	        }
	    };
	    return taDOM;
	});
	
	angular.module('textAngular.validators', [])
	.directive('taMaxText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var max = parseInt(scope.$eval(attrs.taMaxText));
	            if (isNaN(max)){
	                throw('Max text must be an integer');
	            }
	            attrs.$observe('taMaxText', function(value){
	                max = parseInt(value);
	                if (isNaN(max)){
	                    throw('Max text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMaxText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return source.text().length <= max;
	            };
	        }
	    };
	}).directive('taMinText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var min = parseInt(scope.$eval(attrs.taMinText));
	            if (isNaN(min)){
	                throw('Min text must be an integer');
	            }
	            attrs.$observe('taMinText', function(value){
	                min = parseInt(value);
	                if (isNaN(min)){
	                    throw('Min text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMinText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return !source.text().length || source.text().length >= min;
	            };
	        }
	    };
	});
	angular.module('textAngular.taBind', ['textAngular.factories', 'textAngular.DOM'])
	.service('_taBlankTest', [function(){
	    return function(_blankVal){
	        // we radically restructure this code.
	        // what was here before was incredibly fragile.
	        // What we do now is to check that the html is non-blank visually
	        // which we check by looking at html->text
	        if(!_blankVal) return true;
	        // find first non-tag match - ie start of string or after tag that is not whitespace
	        // var t0 = performance.now();
	        // Takes a small fraction of a mSec to do this...
	        var _text_ = stripHtmlToText(_blankVal);
	        // var t1 = performance.now();
	        // console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to generate:');
	        if (_text_=== '') {
	            // img generates a visible item so it is not blank!
	            if (/<img[^>]+>/.test(_blankVal)) {
	                return false;
	            }
	            return true;
	        } else {
	            return false;
	        }
	    };
	}])
	.directive('taButton', [function(){
	    return {
	        link: function(scope, element, attrs){
	            element.attr('unselectable', 'on');
	            element.on('mousedown', function(e, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(e, eventData);
	                // this prevents focusout from firing on the editor when clicking toolbar buttons
	                e.preventDefault();
	                return false;
	            });
	        }
	    };
	}])
	.directive('taBind', [
	        'taSanitize', '$timeout', '$document', 'taFixChrome', 'taBrowserTag',
	        'taSelection', 'taSelectableElements', 'taApplyCustomRenderers', 'taOptions',
	        '_taBlankTest', '$parse', 'taDOM', 'textAngularManager',
	        function(
	            taSanitize, $timeout, $document, taFixChrome, taBrowserTag,
	            taSelection, taSelectableElements, taApplyCustomRenderers, taOptions,
	            _taBlankTest, $parse, taDOM, textAngularManager){
	    // Uses for this are textarea or input with ng-model and ta-bind='text'
	    // OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	    return {
	        priority: 2, // So we override validators correctly
	        require: ['ngModel','?ngModelOptions'],
	        link: function(scope, element, attrs, controller){
	            var ngModel = controller[0];
	            var ngModelOptions = controller[1] || {};
	            // the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
	            var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
	            var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
	            var _isReadonly = false;
	            var _focussed = false;
	            var _skipRender = false;
	            var _disableSanitizer = attrs.taUnsafeSanitizer || taOptions.disableSanitizer;
	            var _keepStyles = attrs.taKeepStyles || taOptions.keepStyles;
	            var _lastKey;
	            // see http://www.javascripter.net/faq/keycodes.htm for good information
	            // NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
	            // BLOCKED_KEYS are special keys...
	            // Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
	            // Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
	            // f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
	            // NumLock, ScrollLock
	            var BLOCKED_KEYS = /^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;
	            // UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
	            // Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
	            // Numpad +, Numpad -, (; :), (= +),
	            // (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
	            // NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
	            var UNDO_TRIGGER_KEYS = /^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;
	            var _pasteHandler;
	
	            // defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
	            // non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
	            var _defaultVal, _defaultTest;
	
	            var _CTRL_KEY = 0x0001;
	            var _META_KEY = 0x0002;
	            var _ALT_KEY = 0x0004;
	            var _SHIFT_KEY = 0x0008;
	            // KEYCODEs we use
	            var _ENTER_KEYCODE = 13;
	            var _SHIFT_KEYCODE = 16;
	            var _TAB_KEYCODE = 9;
	            var _LEFT_ARROW_KEYCODE = 37;
	            var _RIGHT_ARROW_KEYCODE = 39;
	            // map events to special keys...
	            // mappings is an array of maps from events to specialKeys as declared in textAngularSetup
	            var _keyMappings = [
	                //		ctrl/command + z
	                {
	                    specialKey: 'UndoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + shift + z
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY, _SHIFT_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + y
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 89
	                },
	                //		TabKey
	                {
	                    specialKey: 'TabKey',
	                    forbiddenModifiers: _META_KEY + _SHIFT_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [],
	                    keyCode: _TAB_KEYCODE
	                },
	                //		shift + TabKey
	                {
	                    specialKey: 'ShiftTabKey',
	                    forbiddenModifiers: _META_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [_SHIFT_KEY],
	                    keyCode: _TAB_KEYCODE
	                }
	            ];
	            function _mapKeys(event) {
	                var specialKey;
	                _keyMappings.forEach(function (map){
	                    if (map.keyCode === event.keyCode) {
	                        var netModifiers = (event.metaKey ? _META_KEY: 0) +
	                            (event.ctrlKey ? _CTRL_KEY: 0) +
	                            (event.shiftKey ? _SHIFT_KEY: 0) +
	                            (event.altKey ? _ALT_KEY: 0);
	                        if (map.forbiddenModifiers & netModifiers) return;
	                        if (map.mustHaveModifiers.every(function (modifier) { return netModifiers & modifier; })){
	                            specialKey = map.specialKey;
	                        }
	                    }
	                });
	                return specialKey;
	            }
	
	            // set the default to be a paragraph value
	            if(attrs.taDefaultWrap === undefined) attrs.taDefaultWrap = 'p';
	            /* istanbul ignore next: ie specific test */
	            if(attrs.taDefaultWrap === ''){
	                _defaultVal = '';
	                _defaultTest = (_browserDetect.ie === undefined)? '<div><br></div>' : (_browserDetect.ie >= 11)? '<p><br></p>' : (_browserDetect.ie <= 8)? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
	            }else{
	                _defaultVal = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<BR><BR>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
	                _defaultTest = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<br><br>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
	            }
	
	            /* istanbul ignore else */
	            if(!ngModelOptions.$options) ngModelOptions.$options = {}; // ng-model-options support
	
	            var _ensureContentWrapped = function(value) {
	                if (_taBlankTest(value)) return value;
	                var domTest = angular.element("<div>" + value + "</div>");
	                //console.log('domTest.children().length():', domTest.children().length);
	                //console.log('_ensureContentWrapped', domTest.children());
	                //console.log(value, attrs.taDefaultWrap);
	                if (domTest.children().length === 0) {
	                    // if we have a <br> and the attrs.taDefaultWrap is a <p> we need to remove the <br>
	                    //value = value.replace(/<br>/i, '');
	                    value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                } else {
	                    var _children = domTest[0].childNodes;
	                    var i;
	                    var _foundBlockElement = false;
	                    for (i = 0; i < _children.length; i++) {
	                        if (_foundBlockElement = _children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) break;
	                    }
	                    if (!_foundBlockElement) {
	                        value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                    }
	                    else{
	                        value = "";
	                        for(i = 0; i < _children.length; i++){
	                            var node = _children[i];
	                            var nodeName = node.nodeName.toLowerCase();
	                            //console.log('node#:', i, 'name:', nodeName);
	                            if(nodeName === '#comment') {
	                                value += '<!--' + node.nodeValue + '-->';
	                            } else if(nodeName === '#text') {
	                                // determine if this is all whitespace, if so, we will leave it as it is.
	                                // otherwise, we will wrap it as it is
	                                var text = node.textContent;
	                                if (!text.trim()) {
	                                    // just whitespace
	                                    value += text;
	                                } else {
	                                    // not pure white space so wrap in <p>...</p> or whatever attrs.taDefaultWrap is set to.
	                                    value += "<" + attrs.taDefaultWrap + ">" + text + "</" + attrs.taDefaultWrap + ">";
	                                }
	                            } else if(!nodeName.match(BLOCKELEMENTS)){
	                                /* istanbul ignore  next: Doesn't seem to trigger on tests */
	                                var _subVal = (node.outerHTML || node.nodeValue);
	                                /* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
	                                if(_subVal.trim() !== '')
	                                    value += "<" + attrs.taDefaultWrap + ">" + _subVal + "</" + attrs.taDefaultWrap + ">";
	                                else value += _subVal;
	                            } else {
	                                value += node.outerHTML;
	                            }
	                            //console.log(value);
	                        }
	                    }
	                }
	                //console.log(value);
	                return value;
	            };
	
	            if(attrs.taPaste) {
	                _pasteHandler = $parse(attrs.taPaste);
	            }
	
	            element.addClass('ta-bind');
	
	            var _undoKeyupTimeout;
	
	            scope['$undoManager' + (attrs.id || '')] = ngModel.$undoManager = {
	                _stack: [],
	                _index: 0,
	                _max: 1000,
	                push: function(value){
	                    if((typeof value === "undefined" || value === null) ||
	                        ((typeof this.current() !== "undefined" && this.current() !== null) && value === this.current())) return value;
	                    if(this._index < this._stack.length - 1){
	                        this._stack = this._stack.slice(0,this._index+1);
	                    }
	                    this._stack.push(value);
	                    if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                    if(this._stack.length > this._max) this._stack.shift();
	                    this._index = this._stack.length - 1;
	                    return value;
	                },
	                undo: function(){
	                    return this.setToIndex(this._index-1);
	                },
	                redo: function(){
	                    return this.setToIndex(this._index+1);
	                },
	                setToIndex: function(index){
	                    if(index < 0 || index > this._stack.length - 1){
	                        return undefined;
	                    }
	                    this._index = index;
	                    return this.current();
	                },
	                current: function(){
	                    return this._stack[this._index];
	                }
	            };
	
	            // in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
	            var _compileHtml = function(){
	                if(_isContentEditable) {
	                    return element[0].innerHTML;
	                }
	                if(_isInputFriendly) {
	                    return element.val();
	                }
	                throw ('textAngular Error: attempting to update non-editable taBind');
	            };
	
	            var selectorClickHandler = function(event){
	                // emit the element-select event, pass the element
	                scope.$emit('ta-element-select', this);
	                event.preventDefault();
	                return false;
	            };
	
	            //used for updating when inserting wrapped elements
	            var _reApplyOnSelectorHandlers = scope['reApplyOnSelectorHandlers' + (attrs.id || '')] = function(){
	                /* istanbul ignore else */
	                if(!_isReadonly) angular.forEach(taSelectableElements, function(selector){
	                    // check we don't apply the handler twice
	                    element.find(selector)
	                        .off('click', selectorClickHandler)
	                        .on('click', selectorClickHandler);
	                });
	            };
	
	            var _setViewValue = function(_val, triggerUndo, skipRender){
	                _skipRender = skipRender || false;
	                if(typeof triggerUndo === "undefined" || triggerUndo === null) triggerUndo = true && _isContentEditable; // if not contentEditable then the native undo/redo is fine
	                if(typeof _val === "undefined" || _val === null) _val = _compileHtml();
	                if(_taBlankTest(_val)){
	                    // this avoids us from tripping the ng-pristine flag if we click in and out with out typing
	                    if(ngModel.$viewValue !== '') ngModel.$setViewValue('');
	                    if(triggerUndo && ngModel.$undoManager.current() !== '') ngModel.$undoManager.push('');
	                }else{
	                    _reApplyOnSelectorHandlers();
	                    if(ngModel.$viewValue !== _val){
	                        ngModel.$setViewValue(_val);
	                        if(triggerUndo) ngModel.$undoManager.push(_val);
	                    }
	                }
	                ngModel.$render();
	            };
	
	            var _setInnerHTML = function(newval){
	                element[0].innerHTML = newval;
	            };
	
	            var _redoUndoTimeout;
	            var _undo = scope['$undoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.undo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            var _redo = scope['$redoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.redo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        /* istanbul ignore next */
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            //used for updating when inserting wrapped elements
	            scope['updateTaBind' + (attrs.id || '')] = function(){
	                if(!_isReadonly) _setViewValue(undefined, undefined, true);
	            };
	
	            // catch DOM XSS via taSanitize
	            // Sanitizing both ways is identical
	            var _sanitize = function(unsafe){
	                return (ngModel.$oldViewValue = taSanitize(taFixChrome(unsafe, _keepStyles), ngModel.$oldViewValue, _disableSanitizer));
	            };
	
	            // trigger the validation calls
	            if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                return !_taBlankTest(modelValue || viewValue);
	            };
	            // parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
	            ngModel.$parsers.push(_sanitize);
	            ngModel.$parsers.unshift(_ensureContentWrapped);
	            // because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
	            ngModel.$formatters.push(_sanitize);
	            ngModel.$formatters.unshift(_ensureContentWrapped);
	            ngModel.$formatters.unshift(function(value){
	                return ngModel.$undoManager.push(value || '');
	            });
	
	            //this code is used to update the models when data is entered/deleted
	            if(_isInputFriendly){
	                scope.events = {};
	                if(!_isContentEditable){
	                    // if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
	                    element.on('change blur', scope.events.change = scope.events.blur = function(){
	                        if(!_isReadonly) ngModel.$setViewValue(_compileHtml());
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        // Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
	                        /* istanbul ignore else: otherwise normal functionality */
	                        if(event.keyCode === _TAB_KEYCODE){ // tab was pressed
	                            // get caret position/selection
	                            var start = this.selectionStart;
	                            var end = this.selectionEnd;
	
	                            var value = element.val();
	                            if(event.shiftKey){
	                                // find \t
	                                var _linebreak = value.lastIndexOf('\n', start), _tab = value.lastIndexOf('\t', start);
	                                if(_tab !== -1 && _tab >= _linebreak){
	                                    // set textarea value to: text before caret + tab + text after caret
	                                    element.val(value.substring(0, _tab) + value.substring(_tab + 1));
	
	                                    // put caret at right position again (add one for the tab)
	                                    this.selectionStart = this.selectionEnd = start - 1;
	                                }
	                            }else{
	                                // set textarea value to: text before caret + tab + text after caret
	                                element.val(value.substring(0, start) + "\t" + value.substring(end));
	
	                                // put caret at right position again (add one for the tab)
	                                this.selectionStart = this.selectionEnd = start + 1;
	                            }
	                            // prevent the focus lose
	                            event.preventDefault();
	                        }
	                    });
	
	                    var _repeat = function(string, n){
	                        var result = '';
	                        for(var _n = 0; _n < n; _n++) result += string;
	                        return result;
	                    };
	
	                    // add a forEach function that will work on a NodeList, etc..
	                    var forEach = function (array, callback, scope) {
	                        for (var i= 0; i<array.length; i++) {
	                            callback.call(scope, i, array[i]);
	                        }
	                    };
	
	                    // handle <ul> or <ol> nodes
	                    var recursiveListFormat = function(listNode, tablevel){
	                        var _html = '';
	                        var _subnodes = listNode.childNodes;
	                        tablevel++;
	                        // tab out and add the <ul> or <ol> html piece
	                        _html += _repeat('\t', tablevel-1) + listNode.outerHTML.substring(0, 4);
	                        forEach(_subnodes, function (index, node) {
	                            /* istanbul ignore next: browser catch */
	                            var nodeName = node.nodeName.toLowerCase();
	                            if (nodeName === '#comment') {
	                                _html += '<!--' + node.nodeValue + '-->';
	                                return;
	                            }
	                            if (nodeName === '#text') {
	                                _html += node.textContent;
	                                return;
	                            }
	                            /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                            if(!node.outerHTML) {
	                                // no html to add
	                                return;
	                            }
	                            if(nodeName === 'ul' || nodeName === 'ol') {
	                                _html += '\n' + recursiveListFormat(node, tablevel);
	                            }
	                            else {
	                                // no reformatting within this subnode, so just do the tabing...
	                                _html += '\n' + _repeat('\t', tablevel) + node.outerHTML;
	                            }
	                        });
	                        // now add on the </ol> or </ul> piece
	                        _html += '\n' + _repeat('\t', tablevel-1) + listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));
	                        return _html;
	                    };
	                    // handle formating of something like:
	                    // <ol><!--First comment-->
	                    //  <li>Test Line 1<!--comment test list 1--></li>
	                    //    <ul><!--comment ul-->
	                    //      <li>Nested Line 1</li>
	                    //        <!--comment between nested lines--><li>Nested Line 2</li>
	                    //    </ul>
	                    //  <li>Test Line 3</li>
	                    // </ol>
	                    ngModel.$formatters.unshift(function(htmlValue){
	                        // tabulate the HTML so it looks nicer
	                        //
	                        // first get a list of the nodes...
	                        // we do this by using the element parser...
	                        //
	                        // doing this -- which is simpiler -- breaks our tests...
	                        //var _nodes=angular.element(htmlValue);
	                        var _nodes = angular.element('<div>' + htmlValue + '</div>')[0].childNodes;
	                        if(_nodes.length > 0){
	                            // do the reformatting of the layout...
	                            htmlValue = '';
	                            forEach(_nodes, function (index, node) {
	                                var nodeName = node.nodeName.toLowerCase();
	                                if (nodeName === '#comment') {
	                                    htmlValue += '<!--' + node.nodeValue + '-->';
	                                    return;
	                                }
	                                if (nodeName === '#text') {
	                                    htmlValue += node.textContent;
	                                    return;
	                                }
	                                /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                                if(!node.outerHTML)
	                                {
	                                    // nothing to format!
	                                    return;
	                                }
	                                if(htmlValue.length > 0) {
	                                    // we aready have some content, so drop to a new line
	                                    htmlValue += '\n';
	                                }
	                                if(nodeName === 'ul' || nodeName === 'ol') {
	                                    // okay a set of list stuff we want to reformat in a nested way
	                                    htmlValue += '' + recursiveListFormat(node, 0);
	                                }
	                                else {
	                                    // just use the original without any additional formating
	                                    htmlValue += '' + node.outerHTML;
	                                }
	                            });
	                        }
	                        return htmlValue;
	                    });
	                }else{
	                    // all the code specific to contenteditable divs
	                    var _processingPaste = false;
	                    /* istanbul ignore next: phantom js cannot test this for some reason */
	                    var processpaste = function(text) {
	                       var _isOneNote = text!==undefined? text.match(/content=["']*OneNote.File/i): false;
	                        /* istanbul ignore else: don't care if nothing pasted */
	                        //console.log(text);
	                        if(text && text.trim().length){
	                            // test paste from word/microsoft product
	                            if(text.match(/class=["']*Mso(Normal|List)/i) || text.match(/content=["']*Word.Document/i) || text.match(/content=["']*OneNote.File/i)){
	                                var textFragment = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);
	                                if(!textFragment) textFragment = text;
	                                else textFragment = textFragment[1];
	                                textFragment = textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig, '').replace(/class=(["']|)MsoNormal(["']|)/ig, '');
	                                var dom = angular.element("<div>" + textFragment + "</div>");
	                                var targetDom = angular.element("<div></div>");
	                                var _list = {
	                                    element: null,
	                                    lastIndent: [],
	                                    lastLi: null,
	                                    isUl: false
	                                };
	                                _list.lastIndent.peek = function(){
	                                    var n = this.length;
	                                    if (n>0) return this[n-1];
	                                };
	                                var _resetList = function(isUl){
	                                    _list.isUl = isUl;
	                                    _list.element = angular.element(isUl ? "<ul>" : "<ol>");
	                                    _list.lastIndent = [];
	                                    _list.lastIndent.peek = function(){
	                                        var n = this.length;
	                                        if (n>0) return this[n-1];
	                                    };
	                                    _list.lastLevelMatch = null;
	                                };
	                                for(var i = 0; i <= dom[0].childNodes.length; i++){
	                                    if(!dom[0].childNodes[i] || dom[0].childNodes[i].nodeName === "#text"){
	                                        continue;
	                                    } else {
	                                        var tagName = dom[0].childNodes[i].tagName.toLowerCase();
	                                        if(tagName !== 'p' &&
	                                            tagName !== 'ul' &&
	                                            tagName !== 'h1' &&
	                                            tagName !== 'h2' &&
	                                            tagName !== 'h3' &&
	                                            tagName !== 'h4' &&
	                                            tagName !== 'h5' &&
	                                            tagName !== 'h6' &&
	                                            tagName !== 'table'){
	                                            continue;
	                                        }
	                                    }
	                                    var el = angular.element(dom[0].childNodes[i]);
	                                    var _listMatch = (el.attr('class') || '').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);
	
	                                    if(_listMatch){
	                                        if(el[0].childNodes.length < 2 || el[0].childNodes[1].childNodes.length < 1){
	                                            continue;
	                                        }
	                                        var isUl = _listMatch[1].toLowerCase() === 'bullet' || (_listMatch[1].toLowerCase() !== 'number' && !(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML) || /^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML)));
	                                        var _indentMatch = (el.attr('style') || '').match(/margin-left:([\-\.0-9]*)/i);
	                                        var indent = parseFloat((_indentMatch)?_indentMatch[1]:0);
	                                        var _levelMatch = (el.attr('style') || '').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);
	                                        // prefers the mso-list syntax
	
	                                        if(_levelMatch && _levelMatch[2]) indent = parseInt(_levelMatch[2]);
	
	                                        if ((_levelMatch && (!_list.lastLevelMatch || _levelMatch[1] !== _list.lastLevelMatch[1])) || !_listMatch[3] || _listMatch[3].toLowerCase() === 'first' || (_list.lastIndent.peek() === null) || (_list.isUl !== isUl && _list.lastIndent.peek() === indent)) {
	                                            _resetList(isUl);
	                                            targetDom.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() < indent){
	                                            _list.element = angular.element(isUl ? '<ul>' : '<ol>');
	                                            _list.lastLi.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                            while(_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                                if(_list.element.parent()[0].tagName.toLowerCase() === 'li'){
	                                                    _list.element = _list.element.parent();
	                                                    continue;
	                                                }else if(/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())){
	                                                    _list.element = _list.element.parent();
	                                                }else{ // else it's it should be a sibling
	                                                    break;
	                                                }
	                                                _list.lastIndent.pop();
	                                            }
	                                            _list.isUl = _list.element[0].tagName.toLowerCase() === 'ul';
	                                            if (isUl !== _list.isUl) {
	                                                _resetList(isUl);
	                                                targetDom.append(_list.element);
	                                            }
	                                        }
	
	                                        _list.lastLevelMatch = _levelMatch;
	                                        if(indent !== _list.lastIndent.peek()) _list.lastIndent.push(indent);
	                                        _list.lastLi = angular.element('<li>');
	                                        _list.element.append(_list.lastLi);
	                                        _list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig, ''));
	                                        el.remove();
	                                    }else{
	                                        _resetList(false);
	                                        targetDom.append(el);
	                                    }
	                                }
	                                var _unwrapElement = function(node){
	                                    node = angular.element(node);
	                                    for(var _n = node[0].childNodes.length - 1; _n >= 0; _n--) node.after(node[0].childNodes[_n]);
	                                    node.remove();
	                                };
	
	                                angular.forEach(targetDom.find('span'), function(node){
	                                    node.removeAttribute('lang');
	                                    if(node.attributes.length <= 0) _unwrapElement(node);
	                                });
	                                angular.forEach(targetDom.find('font'), _unwrapElement);
	
	                                text = targetDom.html();
	                                if(_isOneNote){
	                                    text = targetDom.html() || dom.html();
	                                }
	                                // LF characters instead of spaces in some spots and they are replaced by '/n', so we need to just swap them to spaces
	                                text = text.replace(/\n/g, ' ');
	                            }else{
	                                // remove unnecessary chrome insert
	                                text = text.replace(/<(|\/)meta[^>]*?>/ig, '');
	                                if(text.match(/<[^>]*?(ta-bind)[^>]*?>/)){
	                                    // entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
	                                    if(text.match(/<[^>]*?(text-angular)[^>]*?>/)){
	                                        var _el = angular.element('<div>' + text + '</div>');
	                                        _el.find('textarea').remove();
	                                        for(var _b = 0; _b < binds.length; _b++){
	                                            var _target = binds[_b][0].parentNode.parentNode;
	                                            for(var _c = 0; _c < binds[_b][0].childNodes.length; _c++){
	                                                _target.parentNode.insertBefore(binds[_b][0].childNodes[_c], _target);
	                                            }
	                                            _target.parentNode.removeChild(_target);
	                                        }
	                                        text = _el.html().replace('<br class="Apple-interchange-newline">', '');
	                                    }
	                                }else if(text.match(/^<span/)){
	                                    // in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
	                                    // if we remove the '<span class="Apple-converted-space"> </span>' here we destroy the spacing
	                                    // on paste from even ourselves!
	                                    if (!text.match(/<span class=(\"Apple-converted-space\"|\'Apple-converted-space\')>.<\/span>/ig)) {
	                                        text = text.replace(/<(|\/)span[^>]*?>/ig, '');
	                                    }
	                                }
	                                // Webkit on Apple tags
	                                text = text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig, '').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig, '&nbsp;');
	                            }
	
	                            if (/<li(\s.*)?>/i.test(text) && /(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text) === false) {
	                                // insert missing parent of li element
	                                text = text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i, '<ul>$&</ul>');
	                            }
	
	                            // parse whitespace from plaintext input, starting with preceding spaces that get stripped on paste
	                            text = text.replace(/^[ |\u00A0]+/gm, function (match) {
	                                var result = '';
	                                for (var i = 0; i < match.length; i++) {
	                                    result += '&nbsp;';
	                                }
	                                return result;
	                            }).replace(/\n|\r\n|\r/g, '<br />').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
	
	                            if(_pasteHandler) text = _pasteHandler(scope, {$html: text}) || text;
	
	                            // turn span vertical-align:super into <sup></sup>
	                            text = text.replace(/<span style=("|')([^<]*?)vertical-align\s*:\s*super;?([^>]*?)("|')>([^<]+?)<\/span>/g, "<sup style='$2$3'>$5</sup>");
	
	                            text = taSanitize(text, '', _disableSanitizer);
	                            //console.log('DONE\n', text);
	
	                            taSelection.insertHtml(text, element[0]);
	                            $timeout(function(){
	                                ngModel.$setViewValue(_compileHtml());
	                                _processingPaste = false;
	                                element.removeClass('processing-paste');
	                            }, 0);
	                        }else{
	                            _processingPaste = false;
	                            element.removeClass('processing-paste');
	                        }
	                    };
	
	                    element.on('paste', scope.events.paste = function(e, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(e, eventData);
	                        if(_isReadonly || _processingPaste){
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	
	                        // Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
	                        _processingPaste = true;
	                        element.addClass('processing-paste');
	                        var pastedContent;
	                        var clipboardData = (e.originalEvent || e).clipboardData;
	                        /* istanbul ignore next: Handle legacy IE paste */
	                        if ( !clipboardData && window.clipboardData && window.clipboardData.getData ){
	                            pastedContent = window.clipboardData.getData("Text");
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	                        if (clipboardData && clipboardData.getData && clipboardData.types.length > 0) {// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
	                            var _types = "";
	                            for(var _t = 0; _t < clipboardData.types.length; _t++){
	                                _types += " " + clipboardData.types[_t];
	                            }
	                            /* istanbul ignore next: browser tests */
	                            if (/text\/html/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/html');
	                            } else if (/text\/plain/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/plain');
	                            }
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        } else {// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
	                            var _savedSelection = rangy.saveSelection(),
	                                _tempDiv = angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');
	                            $document.find('body').append(_tempDiv);
	                            _tempDiv[0].focus();
	                            $timeout(function(){
	                                // restore selection
	                                rangy.restoreSelection(_savedSelection);
	                                processpaste(_tempDiv[0].innerHTML);
	                                element[0].focus();
	                                _tempDiv.remove();
	                            }, 0);
	                        }
	                    });
	                    element.on('cut', scope.events.cut = function(e){
	                        // timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
	                        if(!_isReadonly) $timeout(function(){
	                            ngModel.$setViewValue(_compileHtml());
	                        }, 0);
	                        else e.preventDefault();
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        if (event.keyCode === _SHIFT_KEYCODE) {
	                            taSelection.setStateShiftKey(true);
	                        } else {
	                            taSelection.setStateShiftKey(false);
	                        }
	                        event.specialKey = _mapKeys(event);
	                        var userSpecialKey;
	                        /* istanbul ignore next: difficult to test */
	                        taOptions.keyMappings.forEach(function (mapping) {
	                            if (event.specialKey === mapping.commandKeyCode) {
	                                // taOptions has remapped this binding... so
	                                // we disable our own
	                                event.specialKey = undefined;
	                            }
	                            if (mapping.testForKey(event)) {
	                                userSpecialKey = mapping.commandKeyCode;
	                            }
	                            if ((mapping.commandKeyCode === 'UndoKey') || (mapping.commandKeyCode === 'RedoKey')) {
	                                // this is necessary to fully stop the propagation.
	                                if (!mapping.enablePropagation) {
	                                    event.preventDefault();
	                                }
	                            }
	                        });
	                        /* istanbul ignore next: difficult to test */
	                        if (typeof userSpecialKey !== 'undefined') {
	                            event.specialKey = userSpecialKey;
	                        }
	                        /* istanbul ignore next: difficult to test as can't seem to select */
	                        if ((typeof event.specialKey !== 'undefined') && (
	                                event.specialKey !== 'UndoKey' || event.specialKey !== 'RedoKey'
	                            )) {
	                            event.preventDefault();
	                            textAngularManager.sendKeyCommand(scope, event);
	                        }
	                        /* istanbul ignore else: readonly check */
	                        if(!_isReadonly){
	                            if (event.specialKey==='UndoKey') {
	                                _undo();
	                                event.preventDefault();
	                            }
	                            if (event.specialKey==='RedoKey') {
	                                _redo();
	                                event.preventDefault();
	                            }
	                            /* istanbul ignore next: difficult to test as can't seem to select */
	                            if(event.keyCode === _ENTER_KEYCODE && !event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey)
	                            {
	                                var contains = function(a, obj) {
	                                    for (var i = 0; i < a.length; i++) {
	                                        if (a[i] === obj) {
	                                            return true;
	                                        }
	                                    }
	                                    return false;
	                                };
	                                var $selection;
	                                var selection = taSelection.getSelectionElement();
	                                // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                if(!selection.nodeName.match(VALIDELEMENTS)) return;
	                                var _new = angular.element(_defaultVal);
	                                // if we are in the last element of a blockquote, or ul or ol and the element is blank
	                                // we need to pull the element outside of the said type
	                                var moveOutsideElements = ['blockquote', 'ul', 'ol'];
	                                if (contains(moveOutsideElements, selection.parentNode.tagName.toLowerCase())) {
	                                    if (/^<br(|\/)>$/i.test(selection.innerHTML.trim()) && !selection.nextSibling) {
	                                        // if last element is blank, pull element outside.
	                                        $selection = angular.element(selection);
	                                        var _parent = $selection.parent();
	                                        _parent.after(_new);
	                                        $selection.remove();
	                                        if (_parent.children().length === 0) _parent.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                    if (/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim())) {
	                                        $selection = angular.element(selection);
	                                        $selection.after(_new);
	                                        $selection.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                }
	                            }
	                        }
	                    });
	                    var _keyupTimeout;
	                    element.on('keyup', scope.events.keyup = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        taSelection.setStateShiftKey(false);	// clear the ShiftKey state
	                        /* istanbul ignore next: FF specific bug fix */
	                        if (event.keyCode === _TAB_KEYCODE) {
	                            var _selection = taSelection.getSelection();
	                            if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                            return;
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _LEFT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateLeftArrowKey(element);
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _RIGHT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateRightArrowKey(element);
	                        }
	                        if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                        if(!_isReadonly && !BLOCKED_KEYS.test(event.keyCode)){
	                            /* istanbul ignore next: Ignore any _ENTER_KEYCODE that has ctrlKey, metaKey or alKey */
	                            if (event.keyCode === _ENTER_KEYCODE && (event.ctrlKey || event.metaKey || event.altKey)) {
	                                // we ignore any ENTER_	KEYCODE that is anything but plain or a shift one...
	                            } else {
	                                // if enter - insert new taDefaultWrap, if shift+enter insert <br/>
	                                if(_defaultVal !== '' && _defaultVal !== '<BR><BR>' && event.keyCode === _ENTER_KEYCODE && !event.ctrlKey && !event.metaKey && !event.altKey){
	                                    var selection = taSelection.getSelectionElement();
	                                    while(!selection.nodeName.match(VALIDELEMENTS) && selection !== element[0]){
	                                        selection = selection.parentNode;
	                                    }
	                                    if(!event.shiftKey){
	                                        // new paragraph, br should be caught correctly
	                                        // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                        //console.log('Enter', selection.nodeName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        if(selection.tagName.toLowerCase() !==
	                                            attrs.taDefaultWrap &&
	                                            selection.nodeName.toLowerCase() !== 'li' &&
	                                            (selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')
	                                        ) {
	                                            // Chrome starts with a <div><br></div> after an EnterKey
	                                            // so we replace this with the _defaultVal
	                                            var _new = angular.element(_defaultVal);
	                                            angular.element(selection).replaceWith(_new);
	                                            taSelection.setSelectionToElementStart(_new[0]);
	                                        }
	                                    } else {
	                                        // shift + Enter
	                                        var tagName = selection.tagName.toLowerCase();
	                                        //console.log('Shift+Enter', selection.tagName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        // For an LI: We see: LI p ....<br><br>
	                                        // For a P: We see: P p ....<br><br>
	                                        // on Safari, the browser ignores the Shift+Enter and acts just as an Enter Key
	                                        // For an LI: We see: LI p <br>
	                                        // For a P: We see: P p <br>
	                                        if((tagName === attrs.taDefaultWrap ||
	                                            tagName === 'li' ||
	                                            tagName === 'pre' ||
	                                            tagName === 'div') &&
	                                            !/.+<br><br>/.test(selection.innerHTML.trim())) {
	                                            var ps = selection.previousSibling;
	                                            //console.log('wrong....', ps);
	                                            // we need to remove this selection and fix the previousSibling up...
	                                            if (ps) {
	                                                ps.innerHTML = ps.innerHTML + '<br><br>';
	                                                angular.element(selection).remove();
	                                                taSelection.setSelectionToElementEnd(ps);
	                                            }
	                                        }
	                                    }
	                                }
	                                var val = _compileHtml();
	                                if(_defaultVal !== '' && (val.trim() === '' || val.trim() === '<br>')){
	                                    _setInnerHTML(_defaultVal);
	                                    taSelection.setSelectionToElementStart(element.children()[0]);
	                                }else if(val.substring(0, 1) !== '<' && attrs.taDefaultWrap !== ''){
	                                    /* we no longer do this, since there can be comments here and white space
	                                     var _savedSelection = rangy.saveSelection();
	                                     val = _compileHtml();
	                                     val = "<" + attrs.taDefaultWrap + ">" + val + "</" + attrs.taDefaultWrap + ">";
	                                     _setInnerHTML(val);
	                                     rangy.restoreSelection(_savedSelection);
	                                     */
	                                }
	                                var triggerUndo = _lastKey !== event.keyCode && UNDO_TRIGGER_KEYS.test(event.keyCode);
	                                if(_keyupTimeout) $timeout.cancel(_keyupTimeout);
	                                _keyupTimeout = $timeout(function() {
	                                    _setViewValue(val, triggerUndo, true);
	                                }, ngModelOptions.$options.debounce || 400);
	                                if(!triggerUndo) _undoKeyupTimeout = $timeout(function(){ ngModel.$undoManager.push(val); }, 250);
	                                _lastKey = event.keyCode;
	                            }
	                        }
	                    });
	
	                    // when there is a change from a spelling correction in the browser, the only
	                    // change that is seen is a 'input' and the $watch('html') sees nothing... So
	                    // we added this element.on('input') to catch this change and call the _setViewValue()
	                    // so the ngModel is updated and all works as it should.
	                    var _inputTimeout;
	                    element.on('input', function() {
	                        if (_compileHtml() !== ngModel.$viewValue) {
	                            // we wait a time now to allow the natural $watch('html') to handle this change
	                            // and then after a 1 second delay, if there is still a difference we will do the
	                            // _setViewValue() call.
	                            /* istanbul ignore if: can't test */
	                            if(_inputTimeout) $timeout.cancel(_inputTimeout);
	                            /* istanbul ignore next: cant' test? */
	                            _inputTimeout = $timeout(function() {
	                                var _savedSelection = rangy.saveSelection();
	                                var _val = _compileHtml();
	                                if (_val !== ngModel.$viewValue) {
	                                    //console.log('_setViewValue');
	                                    //console.log('old:', ngModel.$viewValue);
	                                    //console.log('new:', _val);
	                                    _setViewValue(_val, true);
	                                }
	                                // if the savedSelection marker is gone at this point, we cannot restore the selection!!!
	                                //console.log('rangy.restoreSelection', ngModel.$viewValue.length, _savedSelection);
	                                if (ngModel.$viewValue.length !== 0) {
	                                    rangy.restoreSelection(_savedSelection);
	                                }
	                            }, 1000);
	                        }
	                    });
	
	                    element.on('blur', scope.events.blur = function(){
	                        _focussed = false;
	                        /* istanbul ignore else: if readonly don't update model */
	                        if(!_isReadonly){
	                            _setViewValue(undefined, undefined, true);
	                        }else{
	                            _skipRender = true; // don't redo the whole thing, just check the placeholder logic
	                            ngModel.$render();
	                        }
	                    });
	
	                    // Placeholders not supported on ie 8 and below
	                    if(attrs.placeholder && (_browserDetect.ie > 8 || _browserDetect.ie === undefined)){
	                        var rule;
	                        if(attrs.id) rule = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');
	                        else throw('textAngular Error: An unique ID is required for placeholders to work');
	
	                        scope.$on('$destroy', function(){
	                            removeCSSRule(rule);
	                        });
	                    }
	
	                    element.on('focus', scope.events.focus = function(){
	                        _focussed = true;
	                        element.removeClass('placeholder-text');
	                        _reApplyOnSelectorHandlers();
	                    });
	
	                    element.on('mouseup', scope.events.mouseup = function(){
	                        var _selection = taSelection.getSelection();
	                        if(_selection && _selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                    });
	
	                    // prevent propagation on mousedown in editor, see #206
	                    element.on('mousedown', scope.events.mousedown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        event.stopPropagation();
	                    });
	                }
	            }
	
	            var fileDropHandler = function(event, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(event, eventData);
	                // emit the drop event, pass the element, preventing should be done elsewhere
	                if(!dropFired && !_isReadonly){
	                    dropFired = true;
	                    var dataTransfer;
	                    if(event.originalEvent) dataTransfer = event.originalEvent.dataTransfer;
	                    else dataTransfer = event.dataTransfer;
	                    scope.$emit('ta-drop-event', this, event, dataTransfer);
	                    $timeout(function(){
	                        dropFired = false;
	                        _setViewValue(undefined, undefined, true);
	                    }, 100);
	                }
	            };
	
	            var _renderTimeout;
	            var _renderInProgress = false;
	            // changes to the model variable from outside the html/text inputs
	            ngModel.$render = function(){
	                /* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
	                if(_renderInProgress) return;
	                else _renderInProgress = true;
	                // catch model being null or undefined
	                var val = ngModel.$viewValue || '';
	                // if the editor isn't focused it needs to be updated, otherwise it's receiving user input
	                if(!_skipRender){
	                    /* istanbul ignore else: in other cases we don't care */
	                    if(_isContentEditable && _focussed){
	                        // update while focussed
	                        element.removeClass('placeholder-text');
	                        /* istanbul ignore next: don't know how to test this */
	                        if(_renderTimeout) $timeout.cancel(_renderTimeout);
	                        _renderTimeout = $timeout(function(){
	                            /* istanbul ignore if: Can't be bothered testing this... */
	                            if(!_focussed){
	                                element[0].focus();
	                                taSelection.setSelectionToElementEnd(element.children()[element.children().length - 1]);
	                            }
	                            _renderTimeout = undefined;
	                        }, 1);
	                    }
	                    if(_isContentEditable){
	                        // WYSIWYG Mode
	                        if(attrs.placeholder){
	                            if(val === ''){
	                                // blank
	                                _setInnerHTML(_defaultVal);
	                            }else{
	                                // not-blank
	                                _setInnerHTML(val);
	                            }
	                        }else{
	                            _setInnerHTML((val === '') ? _defaultVal : val);
	                        }
	                        // if in WYSIWYG and readOnly we kill the use of links by clicking
	                        if(!_isReadonly){
	                            _reApplyOnSelectorHandlers();
	                            element.on('drop', fileDropHandler);
	                        }else{
	                            element.off('drop', fileDropHandler);
	                        }
	                    }else if(element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input'){
	                        // make sure the end user can SEE the html code as a display. This is a read-only display element
	                        _setInnerHTML(taApplyCustomRenderers(val));
	                    }else{
	                        // only for input and textarea inputs
	                        element.val(val);
	                    }
	                }
	                if(_isContentEditable && attrs.placeholder){
	                    if(val === ''){
	                        if(_focussed) element.removeClass('placeholder-text');
	                        else element.addClass('placeholder-text');
	                    }else{
	                        element.removeClass('placeholder-text');
	                    }
	                }
	                _renderInProgress = _skipRender = false;
	            };
	
	            if(attrs.taReadonly){
	                //set initial value
	                _isReadonly = scope.$eval(attrs.taReadonly);
	                if(_isReadonly){
	                    element.addClass('ta-readonly');
	                    // we changed to readOnly mode (taReadonly='true')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.attr('disabled', 'disabled');
	                    }
	                    if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                        element.removeAttr('contenteditable');
	                    }
	                }else{
	                    element.removeClass('ta-readonly');
	                    // we changed to NOT readOnly mode (taReadonly='false')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.removeAttr('disabled');
	                    }else if(_isContentEditable){
	                        element.attr('contenteditable', 'true');
	                    }
	                }
	                // taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
	                // Otherwise it is readonly by default
	                scope.$watch(attrs.taReadonly, function(newVal, oldVal){
	                    if(oldVal === newVal) return;
	                    if(newVal){
	                        element.addClass('ta-readonly');
	                        // we changed to readOnly mode (taReadonly='true')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.attr('disabled', 'disabled');
	                        }
	                        if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                            element.removeAttr('contenteditable');
	                        }
	                        // turn ON selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).on('click', selectorClickHandler);
	                        });
	                        element.off('drop', fileDropHandler);
	                    }else{
	                        element.removeClass('ta-readonly');
	                        // we changed to NOT readOnly mode (taReadonly='false')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.removeAttr('disabled');
	                        }else if(_isContentEditable){
	                            element.attr('contenteditable', 'true');
	                        }
	                        // remove the selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).off('click', selectorClickHandler);
	                        });
	                        element.on('drop', fileDropHandler);
	                    }
	                    _isReadonly = newVal;
	                });
	            }
	
	            // Initialise the selectableElements
	            // if in WYSIWYG and readOnly we kill the use of links by clicking
	            if(_isContentEditable && !_isReadonly){
	                angular.forEach(taSelectableElements, function(selector){
	                    element.find(selector).on('click', selectorClickHandler);
	                });
	                element.on('drop', fileDropHandler);
	            }
	        }
	    };
	}]);
	
	// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
	var dropFired = false;
	var textAngular = angular.module("textAngular", ['ngSanitize', 'textAngularSetup', 'textAngular.factories', 'textAngular.DOM', 'textAngular.validators', 'textAngular.taBind']); //This makes ngSanitize required
	
	textAngular.config([function(){
	    // clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	    angular.forEach(taTools, function(value, key){ delete taTools[key];	});
	}]);
	
	textAngular.directive("textAngular", [
	    '$compile', '$timeout', 'taOptions', 'taSelection', 'taExecCommand',
	    'textAngularManager', '$document', '$animate', '$log', '$q', '$parse',
	    function($compile, $timeout, taOptions, taSelection, taExecCommand,
	        textAngularManager, $document, $animate, $log, $q, $parse){
	        return {
	            require: '?ngModel',
	            scope: {},
	            restrict: "EA",
	            priority: 2, // So we override validators correctly
	            link: function(scope, element, attrs, ngModel){
	                // all these vars should not be accessable outside this directive
	                var _keydown, _keyup, _keypress, _mouseup, _focusin, _focusout,
	                    _originalContents, _editorFunctions,
	                    _serial = (attrs.serial) ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
	                    _taExecCommand, _resizeMouseDown, _updateSelectedStylesTimeout;
	                var _resizeTimeout;
	
	                scope._name = (attrs.name) ? attrs.name : 'textAngularEditor' + _serial;
	
	                var oneEvent = function(_element, event, action){
	                    $timeout(function(){
	                        _element.one(event, action);
	                    }, 100);
	                };
	                _taExecCommand = taExecCommand(attrs.taDefaultWrap);
	                // get the settings from the defaults and add our specific functions that need to be on the scope
	                angular.extend(scope, angular.copy(taOptions), {
	                    // wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
	                    wrapSelection: function(command, opt, isSelectableElementTool){
	                        // we restore the saved selection that was saved when focus was lost
	                        /* NOT FUNCTIONAL YET */
	                        /* textAngularManager.restoreFocusSelection(scope._name, scope); */
	                        if(command.toLowerCase() === "undo"){
	                            scope['$undoTaBindtaTextElement' + _serial]();
	                        }else if(command.toLowerCase() === "redo"){
	                            scope['$redoTaBindtaTextElement' + _serial]();
	                        }else{
	                            // catch errors like FF erroring when you try to force an undo with nothing done
	                            _taExecCommand(command, false, opt, scope.defaultTagAttributes);
	                            if(isSelectableElementTool){
	                                // re-apply the selectable tool events
	                                scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                            }
	                            // refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
	                            // You still have focus on the text/html input it just doesn't show up
	                            scope.displayElements.text[0].focus();
	                        }
	                    },
	                    showHtml: scope.$eval(attrs.taShowHtml) || false
	                });
	                // setup the options from the optional attributes
	                if(attrs.taFocussedClass)			scope.classes.focussed = attrs.taFocussedClass;
	                if(attrs.taTextEditorClass)			scope.classes.textEditor = attrs.taTextEditorClass;
	                if(attrs.taHtmlEditorClass)			scope.classes.htmlEditor = attrs.taHtmlEditorClass;
	                if(attrs.taDefaultTagAttributes){
	                    try	{
	                        //	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
	                        angular.extend(scope.defaultTagAttributes, angular.fromJson(attrs.taDefaultTagAttributes));
	                    } catch (error) {
	                        $log.error(error);
	                    }
	                }
	                // optional setup functions
	                if(attrs.taTextEditorSetup)			scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
	                if(attrs.taHtmlEditorSetup)			scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
	                // optional fileDropHandler function
	                if(attrs.taFileDrop)				scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);
	                else								scope.fileDropHandler = scope.defaultFileDropHandler;
	
	                _originalContents = element[0].innerHTML;
	                // clear the original content
	                element[0].innerHTML = '';
	
	                // Setup the HTML elements as variable references for use later
	                scope.displayElements = {
	                    // we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
	                    // wheras the input will ALLWAYS have the correct value.
	                    forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
	                    html: angular.element("<textarea></textarea>"),
	                    text: angular.element("<div></div>"),
	                    // other toolbased elements
	                    scrollWindow: angular.element("<div class='ta-scroll-window'></div>"),
	                    popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),
	                    popoverArrow: angular.element('<div class="arrow"></div>'),
	                    popoverContainer: angular.element('<div class="popover-content"></div>'),
	                    resize: {
	                        overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
	                        background: angular.element('<div class="ta-resizer-handle-background"></div>'),
	                        anchors: [
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')
	                        ],
	                        info: angular.element('<div class="ta-resizer-handle-info"></div>')
	                    }
	                };
	
	                // Setup the popover
	                scope.displayElements.popover.append(scope.displayElements.popoverArrow);
	                scope.displayElements.popover.append(scope.displayElements.popoverContainer);
	                scope.displayElements.scrollWindow.append(scope.displayElements.popover);
	
	                scope.displayElements.popover.on('mousedown', function(e, eventData){
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(e, eventData);
	                    // this prevents focusout from firing on the editor when clicking anything in the popover
	                    e.preventDefault();
	                    return false;
	                });
	
	                /* istanbul ignore next: popover resize and scroll events handled */
	                scope.handlePopoverEvents = function() {
	                    if (scope.displayElements.popover.css('display')==='block') {
	                        if(_resizeTimeout) $timeout.cancel(_resizeTimeout);
	                        _resizeTimeout = $timeout(function() {
	                            //console.log('resize', scope.displayElements.popover.css('display'));
	                            scope.reflowPopover(scope.resizeElement);
	                            scope.reflowResizeOverlay(scope.resizeElement);
	                        }, 100);
	                    }
	                };
	
	                /* istanbul ignore next: browser resize check */
	                angular.element(window).on('resize', scope.handlePopoverEvents);
	
	                /* istanbul ignore next: browser scroll check */
	                angular.element(window).on('scroll', scope.handlePopoverEvents);
	
	                // we want to know if a given node has a scrollbar!
	                // credit to lotif on http://stackoverflow.com/questions/4880381/check-whether-html-element-has-scrollbars
	                var isScrollable = function(node) {
	                    var cs;
	                    var _notScrollable = {
	                        vertical: false,
	                        horizontal: false,
	                    };
	                    try {
	                        cs = window.getComputedStyle(node);
	                        if (cs === null) {
	                            return _notScrollable;
	                        }
	                    } catch (e) {
	                        /* istanbul ignore next: error handler */
	                        return _notScrollable;
	                    }
	                    var overflowY = cs['overflow-y'];
	                    var overflowX = cs['overflow-x'];
	                    return {
	                        vertical: (overflowY === 'scroll' || overflowY === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollHeight > node.clientHeight,
	                        horizontal: (overflowX === 'scroll' || overflowX === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollWidth > node.clientWidth,
	                    };
	                };
	
	                // getScrollTop
	                //
	                // we structure this so that it can climb the parents of the _el and when it finds
	                // one with scrollbars, it adds an EventListener, so that no matter how the
	                // DOM is structured in the user APP, if there is a scrollbar not as part of the
	                // ta-scroll-window, we will still capture the 'scroll' events...
	                // and handle the scroll event properly and do the resize, etc.
	                //
	                scope.getScrollTop = function (_el, bAddListener) {
	                    var scrollTop = _el.scrollTop;
	                    if (typeof scrollTop === 'undefined') {
	                        scrollTop = 0;
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar */
	                    if (bAddListener && isScrollable(_el).vertical) {
	                        // remove element eventListener
	                        _el.removeEventListener('scroll', scope._scrollListener, false);
	                        _el.addEventListener('scroll', scope._scrollListener, false);
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar and scrolled */
	                    if (scrollTop !== 0) {
	                        return { node:_el.nodeName, top:scrollTop };
	                    }
	                    /* istanbul ignore else: catches only if no scroll */
	                    if (_el.parentNode) {
	                        return scope.getScrollTop(_el.parentNode, bAddListener);
	                    } else {
	                        return { node:'<none>', top:0 };
	                    }
	                };
	
	                // define the popover show and hide functions
	                scope.showPopover = function(_el){
	                    scope.getScrollTop(scope.displayElements.scrollWindow[0], true);
	                    scope.displayElements.popover.css('display', 'block');
	                    // we must use a $timeout here, or the css change to the
	                    // displayElements.resize.overlay will not take!!!
	                    // WHY???
	                    $timeout(function() {
	                        scope.displayElements.resize.overlay.css('display', 'block');
	                    });
	                    scope.resizeElement = _el;
	                    scope.reflowPopover(_el);
	                    $animate.addClass(scope.displayElements.popover, 'in');
	                    oneEvent($document.find('body'), 'click keyup', function(){scope.hidePopover();});
	                };
	
	                /* istanbul ignore next: browser scroll event handler */
	                scope._scrollListener = function (e, eventData){
	                    scope.handlePopoverEvents();
	                };
	
	                scope.reflowPopover = function(_el){
	                    var scrollTop = scope.getScrollTop(scope.displayElements.scrollWindow[0], false);
	                    var spaceAboveImage = _el[0].offsetTop-scrollTop.top;
	                    //var spaceBelowImage = scope.displayElements.text[0].offsetHeight - _el[0].offsetHeight - spaceAboveImage;
	                    //console.log(spaceAboveImage, spaceBelowImage);
	
	                    /* istanbul ignore if: catches only if near bottom of editor */
	                    if(spaceAboveImage < 51) {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('top').addClass('bottom');
	                    } else {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('bottom').addClass('top');
	                    }
	                    var _maxLeft = scope.displayElements.text[0].offsetWidth - scope.displayElements.popover[0].offsetWidth;
	                    var _targetLeft = _el[0].offsetLeft + (_el[0].offsetWidth / 2.0) - (scope.displayElements.popover[0].offsetWidth / 2.0);
	                    var _rleft = Math.max(0, Math.min(_maxLeft, _targetLeft));
	                    var _marginLeft = (Math.min(_targetLeft, (Math.max(0, _targetLeft - _maxLeft))) - 11);
	                    _rleft += window.scrollX;
	                    _marginLeft -= window.scrollX;
	                    scope.displayElements.popover.css('left', _rleft + 'px');
	                    scope.displayElements.popoverArrow.css('margin-left', _marginLeft + 'px');
	                };
	                scope.hidePopover = function(){
	                    scope.displayElements.popover.css('display', 'none');
	                    scope.displayElements.popoverContainer.attr('style', '');
	                    scope.displayElements.popoverContainer.attr('class', 'popover-content');
	                    scope.displayElements.popover.removeClass('in');
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // setup the resize overlay
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
	                angular.forEach(scope.displayElements.resize.anchors, function(anchor){ scope.displayElements.resize.overlay.append(anchor);});
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
	                scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);
	
	                // A click event on the resize.background will now shift the focus to the editor
	                /* istanbul ignore next: click on the resize.background to focus back to editor */
	                scope.displayElements.resize.background.on('click', function(e) {
	                    scope.displayElements.text[0].focus();
	                });
	
	                // define the show and hide events
	                scope.reflowResizeOverlay = function(_el){
	                    _el = angular.element(_el)[0];
	                    scope.displayElements.resize.overlay.css({
	                        'display': 'block',
	                        'left': _el.offsetLeft - 5 + 'px',
	                        'top': _el.offsetTop - 5 + 'px',
	                        'width': _el.offsetWidth + 10 + 'px',
	                        'height': _el.offsetHeight + 10 + 'px'
	                    });
	                    scope.displayElements.resize.info.text(_el.offsetWidth + ' x ' + _el.offsetHeight);
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.showResizeOverlay = function(_el){
	                    var _body = $document.find('body');
	                    _resizeMouseDown = function(event){
	                        var startPosition = {
	                            width: parseInt(_el.attr('width')),
	                            height: parseInt(_el.attr('height')),
	                            x: event.clientX,
	                            y: event.clientY
	                        };
	                        if(startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
	                        if(startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
	                        scope.hidePopover();
	                        var ratio = startPosition.height / startPosition.width;
	                        var mousemove = function(event){
	                            // calculate new size
	                            var pos = {
	                                x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
	                                y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
	                            };
	
	                            // DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
	                            //
	                            // attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
	                            var bForceAspectRatio = (attrs.taResizeForceAspectRatio !== undefined);
	                            // attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
	                            // unless the Shift key is pressed
	                            var bFlipKeyBinding = attrs.taResizeMaintainAspectRatio;
	                            var bKeepRatio =  bForceAspectRatio || (bFlipKeyBinding && !event.shiftKey);
	                            if(bKeepRatio) {
	                                var newRatio = pos.y / pos.x;
	                                pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
	                                pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
	                            }
	                            var el = angular.element(_el);
	                            function roundedMaxVal(val) {
	                                return Math.round(Math.max(0, val));
	                            }
	                            el.css('height', roundedMaxVal(pos.y) + 'px');
	                            el.css('width', roundedMaxVal(pos.x) + 'px');
	
	                            // reflow the popover tooltip
	                            scope.reflowResizeOverlay(_el);
	                        };
	                        _body.on('mousemove', mousemove);
	                        oneEvent(_body, 'mouseup', function(event){
	                            event.preventDefault();
	                            event.stopPropagation();
	                            _body.off('mousemove', mousemove);
	                            // at this point, we need to force the model to update! since the css has changed!
	                            // this fixes bug: #862 - we now hide the popover -- as this seems more consitent.
	                            // there are still issues under firefox, the window does not repaint. -- not sure
	                            // how best to resolve this, but clicking anywhere works.
	                            scope.$apply(function (){
	                                scope.hidePopover();
	                                scope.updateTaBindtaTextElement();
	                            }, 100);
	                        });
	                        event.stopPropagation();
	                        event.preventDefault();
	                    };
	
	                    scope.displayElements.resize.anchors[3].off('mousedown');
	                    scope.displayElements.resize.anchors[3].on('mousedown', _resizeMouseDown);
	
	                    scope.reflowResizeOverlay(_el);
	                    oneEvent(_body, 'click', function(){scope.hideResizeOverlay();});
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.hideResizeOverlay = function(){
	                    scope.displayElements.resize.anchors[3].off('mousedown', _resizeMouseDown);
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // allow for insertion of custom directives on the textarea and div
	                scope.setup.htmlEditorSetup(scope.displayElements.html);
	                scope.setup.textEditorSetup(scope.displayElements.text);
	                scope.displayElements.html.attr({
	                    'id': 'taHtmlElement' + _serial,
	                    'ng-show': 'showHtml',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.text.attr({
	                    'id': 'taTextElement' + _serial,
	                    'contentEditable': 'true',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.scrollWindow.attr({'ng-hide': 'showHtml'});
	                if(attrs.taDefaultWrap) {
	                    // taDefaultWrap is only applied to the text and not the html view
	                    scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);
	                }
	
	                if(attrs.taUnsafeSanitizer){
	                    scope.displayElements.text.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                    scope.displayElements.html.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                }
	
	                if(attrs.taKeepStyles){
	                    scope.displayElements.text.attr('ta-keep-styles', attrs.taKeepStyles);
	                    scope.displayElements.html.attr('ta-keep-styles', attrs.taKeepStyles);
	                }
	
	                // add the main elements to the origional element
	                scope.displayElements.scrollWindow.append(scope.displayElements.text);
	                element.append(scope.displayElements.scrollWindow);
	                element.append(scope.displayElements.html);
	
	                scope.displayElements.forminput.attr('name', scope._name);
	                element.append(scope.displayElements.forminput);
	
	                if(attrs.tabindex){
	                    element.removeAttr('tabindex');
	                    scope.displayElements.text.attr('tabindex', attrs.tabindex);
	                    scope.displayElements.html.attr('tabindex', attrs.tabindex);
	                }
	
	                if (attrs.placeholder) {
	                    scope.displayElements.text.attr('placeholder', attrs.placeholder);
	                    scope.displayElements.html.attr('placeholder', attrs.placeholder);
	                }
	
	                if(attrs.taDisabled){
	                    scope.displayElements.text.attr('ta-readonly', 'disabled');
	                    scope.displayElements.html.attr('ta-readonly', 'disabled');
	                    scope.disabled = scope.$parent.$eval(attrs.taDisabled);
	                    scope.$parent.$watch(attrs.taDisabled, function(newVal){
	                        scope.disabled = newVal;
	                        if(scope.disabled){
	                            element.addClass(scope.classes.disabled);
	                        }else{
	                            element.removeClass(scope.classes.disabled);
	                        }
	                    });
	                }
	
	                if(attrs.taPaste){
	                    scope._pasteHandler = function(_html){
	                        return $parse(attrs.taPaste)(scope.$parent, {$html: _html});
	                    };
	                    scope.displayElements.text.attr('ta-paste', '_pasteHandler($html)');
	                }
	
	                // compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
	                $compile(scope.displayElements.scrollWindow)(scope);
	                $compile(scope.displayElements.html)(scope);
	
	                scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
	                scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];
	
	                // add the classes manually last
	                element.addClass("ta-root");
	                scope.displayElements.scrollWindow.addClass("ta-text ta-editor " + scope.classes.textEditor);
	                scope.displayElements.html.addClass("ta-html ta-editor " + scope.classes.htmlEditor);
	
	                var testAndSet = function(choice, beforeState) {
	                    /* istanbul ignore next: this is only here because of a bug in rangy where rangy.saveSelection() has cleared the state */
	                    if (beforeState !== $document[0].queryCommandState(choice)) {
	                        $document[0].execCommand(choice, false, null);
	                    }
	                };
	                // used in the toolbar actions
	                scope._actionRunning = false;
	                var _savedSelection = false;
	                scope.startAction = function(){
	                    var _beforeStateBold = false;
	                    var _beforeStateItalic = false;
	                    var _beforeStateUnderline = false;
	                    var _beforeStateStrikethough = false;
	                    scope._actionRunning = true;
	                    _beforeStateBold = $document[0].queryCommandState('bold');
	                    _beforeStateItalic = $document[0].queryCommandState('italic');
	                    _beforeStateUnderline = $document[0].queryCommandState('underline');
	                    _beforeStateStrikethough = $document[0].queryCommandState('strikeThrough');
	                    //console.log('B', _beforeStateBold, 'I', _beforeStateItalic, '_', _beforeStateUnderline, 'S', _beforeStateStrikethough);
	                    // if rangy library is loaded return a function to reload the current selection
	                    _savedSelection = rangy.saveSelection();
	                    // rangy.saveSelection() clear the state of bold, italic, underline, strikethrough
	                    // so we reset them here....!!!
	                    // this fixes bugs #423, #1129, #1105, #693 which are actually rangy bugs!
	                    testAndSet('bold', _beforeStateBold);
	                    testAndSet('italic', _beforeStateItalic);
	                    testAndSet('underline', _beforeStateUnderline);
	                    testAndSet('strikeThrough', _beforeStateStrikethough);
	                    //console.log('B', $document[0].queryCommandState('bold'), 'I', $document[0].queryCommandState('italic'), '_', $document[0].queryCommandState('underline'), 'S', $document[0].queryCommandState('strikeThrough') );
	                    return function(){
	                        if(_savedSelection) rangy.restoreSelection(_savedSelection);
	                        // perhaps if we restore the selections here, we would do better overall???
	                        // BUT what we do above does well in 90% of the cases...
	                    };
	                };
	                scope.endAction = function(){
	                    scope._actionRunning = false;
	                    if(_savedSelection){
	                        if(scope.showHtml){
	                            scope.displayElements.html[0].focus();
	                        }else{
	                            scope.displayElements.text[0].focus();
	                        }
	                        // rangy.restoreSelection(_savedSelection);
	                        rangy.removeMarkers(_savedSelection);
	                    }
	                    _savedSelection = false;
	                    scope.updateSelectedStyles();
	                    // only update if in text or WYSIWYG mode
	                    if(!scope.showHtml) scope['updateTaBindtaTextElement' + _serial]();
	                };
	
	                // note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
	                // cascades to displayElements.text and displayElements.html automatically.
	                _focusin = function(e){
	                    scope.focussed = true;
	                    element.addClass(scope.classes.focussed);
	/*******  NOT FUNCTIONAL YET
	                    if (e.target.id === 'taTextElement' + _serial) {
	                        console.log('_focusin taTextElement');
	                        // we only do this if NOT focussed
	                        textAngularManager.restoreFocusSelection(scope._name);
	                    }
	*******/
	                    _editorFunctions.focus();
	                    element.triggerHandler('focus');
	                    // we call editorScope.updateSelectedStyles() here because we want the toolbar to be focussed
	                    // as soon as we have focus.  Otherwise this only happens on mousedown or keydown etc...
	                    /* istanbul ignore else: don't run if already running */
	                    if(scope.updateSelectedStyles && !scope._bUpdateSelectedStyles){
	                        // we don't set editorScope._bUpdateSelectedStyles here, because we do not want the
	                        // updateSelectedStyles() to run twice which it will do after 200 msec if we have
	                        // set editorScope._bUpdateSelectedStyles
	                        //
	                        // WOW, normally I would do a scope.$apply here, but this causes ERRORs when doing tests!
	                        $timeout(function () {
	                            scope.updateSelectedStyles();
	                        }, 0);
	                    }
	                };
	                scope.displayElements.html.on('focus', _focusin);
	                scope.displayElements.text.on('focus', _focusin);
	                _focusout = function(e){
	                    /****************** NOT FUNCTIONAL YET
	                    try {
	                        var _s = rangy.getSelection();
	                        if (_s) {
	                            // we save the selection when we loose focus so that if do a wrapSelection, the
	                            // apropriate selection in the editor is restored before action.
	                            var _savedFocusRange = rangy.saveRange(_s.getRangeAt(0));
	                            textAngularManager.saveFocusSelection(scope._name, _savedFocusRange);
	                        }
	                    } catch(error) { }
	                    *****************/
	                    // if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
	                    if(!scope._actionRunning &&
	                        $document[0].activeElement !== scope.displayElements.html[0] &&
	                        $document[0].activeElement !== scope.displayElements.text[0])
	                    {
	                        element.removeClass(scope.classes.focussed);
	                        _editorFunctions.unfocus();
	                        // to prevent multiple apply error defer to next seems to work.
	                        $timeout(function(){
	                            scope._bUpdateSelectedStyles = false;
	                            element.triggerHandler('blur');
	                            scope.focussed = false;
	                        }, 0);
	                    }
	                    e.preventDefault();
	                    return false;
	                };
	                scope.displayElements.html.on('blur', _focusout);
	                scope.displayElements.text.on('blur', _focusout);
	
	                scope.displayElements.text.on('paste', function(event){
	                    element.triggerHandler('paste', event);
	                });
	
	                // Setup the default toolbar tools, this way allows the user to add new tools like plugins.
	                // This is on the editor for future proofing if we find a better way to do this.
	                scope.queryFormatBlockState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return !scope.showHtml && command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
	                };
	                scope.queryCommandState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return (!scope.showHtml) ? $document[0].queryCommandState(command) : '';
	                };
	                scope.switchView = function(){
	                    scope.showHtml = !scope.showHtml;
	                    $animate.enabled(false, scope.displayElements.html);
	                    $animate.enabled(false, scope.displayElements.text);
	                    //Show the HTML view
	                    /* istanbul ignore next: ngModel exists check */
	/* THIS is not the correct thing to do, here....
	   The ngModel is correct, but it is not formatted as the user as done it...
	                    var _model;
	                    if (ngModel) {
	                        _model = ngModel.$viewValue;
	                    } else {
	                        _model = scope.html;
	                    }
	                    var _html = scope.displayElements.html[0].value;
	                    if (getDomFromHtml(_html).childElementCount !== getDomFromHtml(_model).childElementCount) {
	                        // the model and the html do not agree
	                        // they can get out of sync and when they do, we correct that here...
	                        scope.displayElements.html.val(_model);
	                    }
	*/
	                    if(scope.showHtml){
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.html[0].focus();
	                        }, 100);
	                    }else{
	                        //Show the WYSIWYG view
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.text[0].focus();
	                        }, 100);
	                    }
	                };
	
	                // changes to the model variable from outside the html/text inputs
	                // if no ngModel, then the only input is from inside text-angular
	                if(attrs.ngModel){
	                    var _firstRun = true;
	                    ngModel.$render = function(){
	                        if(_firstRun){
	                            // we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
	                            _firstRun = false;
	                            // if view value is null or undefined initially and there was original content, set to the original content
	                            var _initialValue = scope.$parent.$eval(attrs.ngModel);
	                            if((_initialValue === undefined || _initialValue === null) && (_originalContents && _originalContents !== '')){
	                                // on passing through to taBind it will be sanitised
	                                ngModel.$setViewValue(_originalContents);
	                            }
	                        }
	                        scope.displayElements.forminput.val(ngModel.$viewValue);
	                        // if the editors aren't focused they need to be updated, otherwise they are doing the updating
	                        scope.html = ngModel.$viewValue || '';
	                    };
	                    // trigger the validation calls
	                    if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                        var value = modelValue || viewValue;
	                        return !(!value || value.trim() === '');
	                    };
	                }else{
	                    // if no ngModel then update from the contents of the origional html.
	                    scope.displayElements.forminput.val(_originalContents);
	                    scope.html = _originalContents;
	                }
	
	                // changes from taBind back up to here
	                scope.$watch('html', function(newValue, oldValue){
	                    if(newValue !== oldValue){
	                        if(attrs.ngModel && ngModel.$viewValue !== newValue) {
	                            ngModel.$setViewValue(newValue);
	                        }
	                        scope.displayElements.forminput.val(newValue);
	                    }
	                });
	
	                if(attrs.taTargetToolbars) {
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, attrs.taTargetToolbars.split(','));
	                }
	                else{
	                    var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
	                    // passthrough init of toolbar options
	                    if(attrs.taToolbar)						_toolbar.attr('ta-toolbar', attrs.taToolbar);
	                    if(attrs.taToolbarClass)				_toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
	                    if(attrs.taToolbarGroupClass)			_toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
	                    if(attrs.taToolbarButtonClass)			_toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
	                    if(attrs.taToolbarActiveButtonClass)	_toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
	                    if(attrs.taFocussedClass)				_toolbar.attr('ta-focussed-class', attrs.taFocussedClass);
	
	                    element.prepend(_toolbar);
	                    $compile(_toolbar)(scope.$parent);
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, ['textAngularToolbar' + _serial]);
	                }
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterEditor(scope._name);
	                    angular.element(window).off('blur');
	                    angular.element(window).off('resize', scope.handlePopoverEvents);
	                    angular.element(window).off('scroll', scope.handlePopoverEvents);
	                });
	
	                // catch element select event and pass to toolbar tools
	                scope.$on('ta-element-select', function(event, element){
	                    if(_editorFunctions.triggerElementSelect(event, element)){
	                        scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                    }
	                });
	
	/******************* no working fully
	                var distanceFromPoint = function (px, py, x, y) {
	                    return Math.sqrt((px-x)*(px-x)+(py-y)*(py-y));
	                };
	                // because each object is a rectangle and we have a single point,
	                // we need to give priority if the point is inside the rectangle
	                var getPositionDistance = function(el, x, y) {
	                    var range = document.createRange();
	                    range.selectNode(el);
	                    var rect = range.getBoundingClientRect();
	                    console.log(el, rect);
	                    range.detach();
	                    var bcr = rect;
	                    // top left
	                    var d1 = distanceFromPoint(bcr.left, bcr.top, x, y);
	                    // bottom left
	                    var d2 = distanceFromPoint(bcr.left, bcr.bottom, x, y);
	                    // top right
	                    var d3 = distanceFromPoint(bcr.right, bcr.top, x, y);
	                    // bottom right
	                    var d4 = distanceFromPoint(bcr.right, bcr.bottom, x, y);
	                    return Math.min(d1, d2, d3, d4);
	                };
	                var findClosest = function(el, minElement, maxDistance, x, y) {
	                    var _d=0;
	                    for (var i = 0; i < el.childNodes.length; i++) {
	                        var _n = el.childNodes[i];
	                        if (!_n.childNodes.length) {
	                            _d = getPositionDistance(_n, x, y);
	                            //console.log(_n, _n.childNodes, _d);
	                            if (_d < maxDistance) {
	                                maxDistance = _d;
	                                minElement = _n;
	                            }
	                        }
	                        var res = findClosest(_n, minElement, maxDistance, x, y);
	                        if (res.max < maxDistance) {
	                            maxDistance = res.max;
	                            minElement = res.min;
	                        }
	                    }
	                    return { max: maxDistance, min: minElement };
	                };
	                var getClosestElement = function (el, x, y) {
	                    return findClosest(el, null, 12341234124, x, y);
	                };
	****************/
	
	                scope.$on('ta-drop-event', function(event, element, dropEvent, dataTransfer){
	                    if(dataTransfer && dataTransfer.files && dataTransfer.files.length > 0){
	                        scope.displayElements.text[0].focus();
	                        // we must set the location of the drop!
	                        //console.log(dropEvent.clientX, dropEvent.clientY, dropEvent.target);
	                        taSelection.setSelectionToElementEnd(dropEvent.target);
	                        angular.forEach(dataTransfer.files, function(file){
	                            // taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
	                            // If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
	                            // Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
	                            try{
	                                $q.when(scope.fileDropHandler(file, scope.wrapSelection) ||
	                                    (scope.fileDropHandler !== scope.defaultFileDropHandler &&
	                                    $q.when(scope.defaultFileDropHandler(file, scope.wrapSelection)))).then(function(){
	                                        scope['updateTaBindtaTextElement' + _serial]();
	                                    });
	                            }catch(error){
	                                $log.error(error);
	                            }
	                        });
	                        dropEvent.preventDefault();
	                        dropEvent.stopPropagation();
	                    /* istanbul ignore else, the updates if moved text */
	                    }else{
	                        $timeout(function(){
	                            scope['updateTaBindtaTextElement' + _serial]();
	                        }, 0);
	                    }
	                });
	
	                // the following is for applying the active states to the tools that support it
	                scope._bUpdateSelectedStyles = false;
	                /* istanbul ignore next: browser window/tab leave check */
	                angular.element(window).on('blur', function(){
	                    scope._bUpdateSelectedStyles = false;
	                    scope.focussed = false;
	                });
	                // loop through all the tools polling their activeState function if it exists
	                scope.updateSelectedStyles = function(){
	                    var _selection;
	                    /* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
	                    if(_updateSelectedStylesTimeout) $timeout.cancel(_updateSelectedStylesTimeout);
	                    // test if the common element ISN'T the root ta-text node
	                    if((_selection = taSelection.getSelectionElement()) !== undefined && _selection.parentNode !== scope.displayElements.text[0]){
	                        _editorFunctions.updateSelectedStyles(angular.element(_selection));
	                    }else _editorFunctions.updateSelectedStyles();
	                    // used to update the active state when a key is held down, ie the left arrow
	                    /* istanbul ignore else: browser only check */
	                    if(scope._bUpdateSelectedStyles) _updateSelectedStylesTimeout = $timeout(scope.updateSelectedStyles, 200);
	                };
	                // start updating on keydown
	                _keydown = function(){
	                    /* istanbul ignore next: ie catch */
	                    if(!scope.focussed){
	                        scope._bUpdateSelectedStyles = false;
	                        return;
	                    }
	                    /* istanbul ignore else: don't run if already running */
	                    if(!scope._bUpdateSelectedStyles){
	                        scope._bUpdateSelectedStyles = true;
	                        scope.$apply(function(){
	                            scope.updateSelectedStyles();
	                        });
	                    }
	                };
	                scope.displayElements.html.on('keydown', _keydown);
	                scope.displayElements.text.on('keydown', _keydown);
	                // stop updating on key up and update the display/model
	                _keyup = function(){
	                    scope._bUpdateSelectedStyles = false;
	                };
	                scope.displayElements.html.on('keyup', _keyup);
	                scope.displayElements.text.on('keyup', _keyup);
	                // stop updating on key up and update the display/model
	                _keypress = function(event, eventData){
	                    // bug fix for Firefox.  If we are selecting a <a> already, any characters will
	                    // be added within the <a> which is bad!
	                    /* istanbul ignore next: don't see how to test this... */
	                    if (taSelection.getSelection) {
	                        var _selection = taSelection.getSelection();
	                        // in a weird case (can't reproduce) taSelection.getSelectionElement() can be undefined!!
	                        // this comes from range.commonAncestorContainer;
	                        // so I check for this here which fixes the error case
	                        if (taSelection.getSelectionElement() && taSelection.getSelectionElement().nodeName.toLowerCase() === 'a') {
	                            // check and see if we are at the edge of the <a>
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.element.textContent.length === _selection.end.offset) {
	                                // we are at the end of the <a>!!!
	                                // so move the selection to after the <a>!!
	                                taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                            }
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.offset === 0) {
	                                // we are at the start of the <a>!!!
	                                // so move the selection before the <a>!!
	                                taSelection.setSelectionBeforeElement(taSelection.getSelectionElement());
	                            }
	                        }
	                    }
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(event, eventData);
	                    scope.$apply(function(){
	                        if(_editorFunctions.sendKeyCommand(event)){
	                            /* istanbul ignore else: don't run if already running */
	                            if(!scope._bUpdateSelectedStyles){
	                                scope.updateSelectedStyles();
	                            }
	                            event.preventDefault();
	                            return false;
	                        }
	                    });
	                };
	                scope.displayElements.html.on('keypress', _keypress);
	                scope.displayElements.text.on('keypress', _keypress);
	                // update the toolbar active states when we click somewhere in the text/html boxed
	                _mouseup = function(){
	                    // ensure only one execution of updateSelectedStyles()
	                    scope._bUpdateSelectedStyles = false;
	                    // for some reason, unless we do a $timeout here, after a _mouseup when the line is
	                    // highlighted, and instead use a scope.$apply(function(){ scope.updateSelectedStyles(); });
	                    // doesn't work properly, so we replaced this with:
	                    /* istanbul ignore next: not tested  */
	                    $timeout(function() { scope.updateSelectedStyles(); }, 0);
	                };
	                scope.displayElements.html.on('mouseup', _mouseup);
	                scope.displayElements.text.on('mouseup', _mouseup);
	            }
	        };
	    }
	]);
	textAngular.service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool', '$interval', '$rootScope', '$log',
	    function(taToolExecuteAction, taTools, taRegisterTool, $interval, $rootScope, $log){
	    // this service is used to manage all textAngular editors and toolbars.
	    // All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	    // these contain references to all the editors and toolbars that have been initialised in this app
	    var toolbars = {}, editors = {};
	    // we touch the time any change occurs through register of an editor or tool so that we
	    // in the future will fire and event to trigger an updateSelection
	    var timeRecentModification = 0;
	    var updateStyles = function(selectedElement){
	        angular.forEach(editors, function(editor) {
	            editor.editorFunctions.updateSelectedStyles(selectedElement);
	        });
	    };
	    var triggerInterval = 50;
	    var triggerIntervalTimer;
	    var setupTriggerUpdateStyles = function() {
	        timeRecentModification = Date.now();
	        /* istanbul ignore next: setup a one time updateStyles() */
	        triggerIntervalTimer = $interval(function() {
	            updateStyles();
	            triggerIntervalTimer = undefined;
	        }, triggerInterval, 1); // only trigger once
	    };
	    /* istanbul ignore next: make sure clean up on destroy */
	    $rootScope.$on('destroy', function() {
	        if (triggerIntervalTimer) {
	            $interval.cancel(triggerIntervalTimer);
	            triggerIntervalTimer = undefined;
	        }
	    });
	    var touchModification = function() {
	        if (Math.abs(Date.now() - timeRecentModification) > triggerInterval) {
	            // we have already triggered the updateStyles a long time back... so setup it again...
	            setupTriggerUpdateStyles();
	        }
	    };
	    // when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	    // We also need to set the tools to be updated to be the toolbars...
	    return {
	        // register an editor and the toolbars that it is affected by
	        registerEditor: function(editorName, editorScope, targetToolbars){
	            // NOTE: name === editorScope._name
	            // targetToolbars is an [] of 'toolbar name's
	            // targetToolbars are optional, we don't require a toolbar to function
	            if(!editorName || editorName === '') throw('textAngular Error: An editor requires a name');
	            if(!editorScope) throw('textAngular Error: An editor requires a scope');
	            if(editors[editorName]) throw('textAngular Error: An Editor with name "' + editorName + '" already exists');
	            editors[editorName] = {
	                scope: editorScope,
	                toolbars: targetToolbars,
	                // toolbarScopes used by this editor
	                toolbarScopes: [],
	                _registerToolbarScope: function(toolbarScope){
	                    // add to the list late
	                    if(this.toolbars.indexOf(toolbarScope.name) >= 0) {
	                        // if this toolbarScope is being used by this editor we add it as one of the scopes
	                        this.toolbarScopes.push(toolbarScope);
	                    }
	                },
	                // this is a suite of functions the editor should use to update all it's linked toolbars
	                editorFunctions: {
	                    disable: function(){
	                        // disable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                        });
	                    },
	                    enable: function(){
	                        // enable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = false;
	                        });
	                    },
	                    focus: function(){
	                        // this should be called when the editor is focussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope._parent = editorScope;
	                            toolbarScope.disabled = false;
	                            toolbarScope.focussed = true;
	                        });
	                        editorScope.focussed = true;
	                    },
	                    unfocus: function(){
	                        // this should be called when the editor becomes unfocussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                            toolbarScope.focussed = false;
	                        });
	                        editorScope.focussed = false;
	                    },
	                    updateSelectedStyles: function(selectedElement){
	                        // update the active state of all buttons on liked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            angular.forEach(toolbarScope.tools, function(toolScope){
	                                if(toolScope.activeState){
	                                    toolbarScope._parent = editorScope;
	                                    // selectedElement may be undefined if nothing selected
	                                    toolScope.active = toolScope.activeState(selectedElement);
	                                }
	                            });
	                        });
	                    },
	                    sendKeyCommand: function(event){
	                        // we return true if we applied an action, false otherwise
	                        var result = false;
	                        if(event.ctrlKey || event.metaKey || event.specialKey) angular.forEach(taTools, function(tool, name){
	                            if(tool.commandKeyCode && (tool.commandKeyCode === event.which || tool.commandKeyCode === event.specialKey)){
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        taToolExecuteAction.call(editors[editorName].toolbarScopes[_t].tools[name], editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                            }
	                        });
	                        return result;
	                    },
	                    triggerElementSelect: function(event, element){
	                        // search through the taTools to see if a match for the tag is made.
	                        // if there is, see if the tool is on a registered toolbar and not disabled.
	                        // NOTE: This can trigger on MULTIPLE tools simultaneously.
	                        var elementHasAttrs = function(_element, attrs){
	                            var result = true;
	                            for(var i = 0; i < attrs.length; i++) result = result && _element.attr(attrs[i]);
	                            return result;
	                        };
	                        var workerTools = [];
	                        var unfilteredTools = {};
	                        var result = false;
	                        element = angular.element(element);
	                        // get all valid tools by element name, keep track if one matches the
	                        var onlyWithAttrsFilter = false;
	                        angular.forEach(taTools, function(tool, name){
	                            if(
	                                tool.onElementSelect &&
	                                tool.onElementSelect.element &&
	                                tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() &&
	                                (!tool.onElementSelect.filter || tool.onElementSelect.filter(element))
	                            ){
	                                // this should only end up true if the element matches the only attributes
	                                onlyWithAttrsFilter = onlyWithAttrsFilter ||
	                                    (angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs));
	                                if(!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) unfilteredTools[name] = tool;
	                            }
	                        });
	                        // if we matched attributes to filter on, then filter, else continue
	                        if(onlyWithAttrsFilter){
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                if(tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) workerTools.push({'name': name, 'tool': tool});
	                            });
	                            // sort most specific (most attrs to find) first
	                            workerTools.sort(function(a,b){
	                                return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
	                            });
	                        }else{
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                workerTools.push({'name': name, 'tool': tool});
	                            });
	                        }
	                        // Run the actions on the first visible filtered tool only
	                        if(workerTools.length > 0){
	                            for(var _i = 0; _i < workerTools.length; _i++){
	                                var tool = workerTools[_i].tool;
	                                var name = workerTools[_i].name;
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        tool.onElementSelect.action.call(editors[editorName].toolbarScopes[_t].tools[name], event, element, editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                                if(result) break;
	                            }
	                        }
	                        return result;
	                    }
	                }
	            };
	            angular.forEach(targetToolbars, function(_name){
	                if(toolbars[_name]) {
	                    editors[editorName].toolbarScopes.push(toolbars[_name]);
	                }
	                // if it doesn't exist it may not have been compiled yet and it will be added later
	            });
	            touchModification();
	            return editors[editorName].editorFunctions;
	        },
	        // retrieve editor by name, largely used by testing suites only
	        retrieveEditor: function(name){
	            return editors[name];
	        },
	        unregisterEditor: function(name){
	            delete editors[name];
	            touchModification();
	        },
	        // registers a toolbar such that it can be linked to editors
	        registerToolbar: function(toolbarScope){
	            if(!toolbarScope) throw('textAngular Error: A toolbar requires a scope');
	            if(!toolbarScope.name || toolbarScope.name === '') throw('textAngular Error: A toolbar requires a name');
	            if(toolbars[toolbarScope.name]) throw('textAngular Error: A toolbar with name "' + toolbarScope.name + '" already exists');
	            toolbars[toolbarScope.name] = toolbarScope;
	            // walk all the editors and connect this toolbarScope to the editors.... if we need to.  This way, it does
	            // not matter if we register the editors after the toolbars or not
	            // Note the editor will ignore this toolbarScope if it is not connected to it...
	            angular.forEach(editors, function(_editor){
	                _editor._registerToolbarScope(toolbarScope);
	            });
	            touchModification();
	        },
	        // retrieve toolbar by name, largely used by testing suites only
	        retrieveToolbar: function(name){
	            return toolbars[name];
	        },
	        // retrieve toolbars by editor name, largely used by testing suites only
	        retrieveToolbarsViaEditor: function(name){
	            var result = [], _this = this;
	            angular.forEach(this.retrieveEditor(name).toolbars, function(name){
	                result.push(_this.retrieveToolbar(name));
	            });
	            return result;
	        },
	        unregisterToolbar: function(name){
	            delete toolbars[name];
	            touchModification();
	        },
	        // functions for updating the toolbar buttons display
	        updateToolsDisplay: function(newTaTools){
	            // pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
	            var _this = this;
	            angular.forEach(newTaTools, function(_newTool, key){
	                _this.updateToolDisplay(key, _newTool);
	            });
	        },
	        // this function resets all toolbars to their default tool definitions
	        resetToolsDisplay: function(){
	            var _this = this;
	            angular.forEach(taTools, function(_newTool, key){
	                _this.resetToolDisplay(key);
	            });
	            touchModification();
	        },
	        // update a tool on all toolbars
	        updateToolDisplay: function(toolKey, _newTool){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
	            });
	            touchModification();
	        },
	        // resets a tool to the default/starting state on all toolbars
	        resetToolDisplay: function(toolKey){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.resetToolbarToolDisplay(toolbarKey, toolKey);
	            });
	            touchModification();
	        },
	        // update a tool on a specific toolbar
	        updateToolbarToolDisplay: function(toolbarKey, toolKey, _newTool){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // reset a tool on a specific toolbar to it's default starting value
	        resetToolbarToolDisplay: function(toolbarKey, toolKey){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // removes a tool from all toolbars and it's definition
	        removeTool: function(toolKey){
	            delete taTools[toolKey];
	            angular.forEach(toolbars, function(toolbarScope){
	                delete toolbarScope.tools[toolKey];
	                for(var i = 0; i < toolbarScope.toolbar.length; i++){
	                    var toolbarIndex;
	                    for(var j = 0; j < toolbarScope.toolbar[i].length; j++){
	                        if(toolbarScope.toolbar[i][j] === toolKey){
	                            toolbarIndex = {
	                                group: i,
	                                index: j
	                            };
	                            break;
	                        }
	                        if(toolbarIndex !== undefined) break;
	                    }
	                    if(toolbarIndex !== undefined){
	                        toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
	                        toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
	                    }
	                }
	            });
	            touchModification();
	        },
	        // toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
	        addTool: function(toolKey, toolDefinition, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            angular.forEach(toolbars, function(toolbarScope){
	                toolbarScope.addTool(toolKey, toolDefinition, group, index);
	            });
	            touchModification();
	        },
	        // adds a Tool but only to one toolbar not all
	        addToolToToolbar: function(toolKey, toolDefinition, toolbarKey, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
	            touchModification();
	        },
	        // this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
	        // this will call a $digest if not already happening
	        refreshEditor: function(name){
	            if(editors[name]){
	                editors[name].scope.updateTaBindtaTextElement();
	                /* istanbul ignore else: phase catch */
	                if(!editors[name].scope.$$phase) editors[name].scope.$digest();
	            }else throw('textAngular Error: No Editor with name "' + name + '" exists');
	            touchModification();
	        },
	        // this is used by taBind to send a key command in response to a special key event
	        sendKeyCommand: function(scope, event){
	            var _editor = editors[scope._name];
	            /* istanbul ignore else: if nothing to do, do nothing */
	            if (_editor && _editor.editorFunctions.sendKeyCommand(event)) {
	                /* istanbul ignore else: don't run if already running */
	                if(!scope._bUpdateSelectedStyles){
	                    scope.updateSelectedStyles();
	                }
	                event.preventDefault();
	                return false;
	            }
	        },
	        //
	        // When a toolbar and tools are created, it isn't until there is a key event or mouse event
	        // that the updateSelectedStyles() is called behind the scenes.
	        // This function forces an update through the existing editors to help the application make sure
	        // the inital state is correct.
	        //
	        updateStyles: updateStyles,
	        // return the current version of textAngular in use to the user
	        getVersion: function () { return textAngularVersion; },
	        // for testing
	        getToolbarScopes: function () {
	            var tmp=[];
	            angular.forEach(editors, function (_editor) {
	                tmp = tmp.concat(_editor.toolbarScopes);
	            });
	            return tmp;
	        }
	/********************** not functional yet
	        // save the selection ('range') for the given editor
	        saveFocusSelection: function (name, range) {
	            editors[name].savedFocusRange = range;
	        },
	        // restore the saved selection from when the focus was lost
	        restoreFocusSelection: function(name, scope) {
	            // we only do this if NOT focussed and saved...
	            if (editors[name].savedFocusRange && !scope.focussed) {
	                try {
	                    var _r = rangy.restoreRange(editors[name].savedFocusRange);
	                    var _sel = rangy.getSelection();
	                    _sel.addRange(_r);
	                } catch(e) {}
	            }
	        }
	*************/
	    };
	}]);
	textAngular.directive('textAngularToolbar', [
	    '$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window',
	    function($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window){
	        return {
	            scope: {
	                name: '@' // a name IS required
	            },
	            restrict: "EA",
	            link: function(scope, element, attrs){
	                if(!scope.name || scope.name === '') throw('textAngular Error: A toolbar requires a name');
	                angular.extend(scope, angular.copy(taOptions));
	                if(attrs.taToolbar)						scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
	                if(attrs.taToolbarClass)				scope.classes.toolbar = attrs.taToolbarClass;
	                if(attrs.taToolbarGroupClass)			scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
	                if(attrs.taToolbarButtonClass)			scope.classes.toolbarButton = attrs.taToolbarButtonClass;
	                if(attrs.taToolbarActiveButtonClass)	scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
	                if(attrs.taFocussedClass)				scope.classes.focussed = attrs.taFocussedClass;
	
	                scope.disabled = true;
	                scope.focussed = false;
	                scope._$element = element;
	                element[0].innerHTML = '';
	                element.addClass("ta-toolbar " + scope.classes.toolbar);
	
	                scope.$watch('focussed', function(){
	                    if(scope.focussed) element.addClass(scope.classes.focussed);
	                    else element.removeClass(scope.classes.focussed);
	                });
	
	                var setupToolElement = function(toolDefinition, toolScope){
	                    var toolElement;
	                    if(toolDefinition && toolDefinition.display){
	                        toolElement = angular.element(toolDefinition.display);
	                    }
	                    else toolElement = angular.element("<button type='button'>");
	
	                    if(toolDefinition && toolDefinition["class"]) toolElement.addClass(toolDefinition["class"]);
	                    else toolElement.addClass(scope.classes.toolbarButton);
	
	                    toolElement.attr('name', toolScope.name);
	                    // important to not take focus from the main text/html entry
	                    toolElement.attr('ta-button', 'ta-button');
	                    toolElement.attr('ng-disabled', 'isDisabled()');
	                    toolElement.attr('tabindex', '-1');
	                    toolElement.attr('ng-click', 'executeAction()');
	                    toolElement.attr('ng-class', 'displayActiveToolClass(active)');
	
	                    if (toolDefinition && toolDefinition.tooltiptext) {
	                        toolElement.attr('title', toolDefinition.tooltiptext);
	                    }
	                    if(toolDefinition && !toolDefinition.display && !toolScope._display){
	                        // first clear out the current contents if any
	                        toolElement[0].innerHTML = '';
	                        // add the buttonText
	                        if(toolDefinition.buttontext) toolElement[0].innerHTML = toolDefinition.buttontext;
	                        // add the icon to the front of the button if there is content
	                        if(toolDefinition.iconclass){
	                            var icon = angular.element('<i>'), content = toolElement[0].innerHTML;
	                            icon.addClass(toolDefinition.iconclass);
	                            toolElement[0].innerHTML = '';
	                            toolElement.append(icon);
	                            if(content && content !== '') toolElement.append('&nbsp;' + content);
	                        }
	                    }
	
	                    toolScope._lastToolDefinition = angular.copy(toolDefinition);
	
	                    return $compile(toolElement)(toolScope);
	                };
	
	                // Keep a reference for updating the active states later
	                scope.tools = {};
	                // create the tools in the toolbar
	                // default functions and values to prevent errors in testing and on init
	                scope._parent = {
	                    disabled: true,
	                    showHtml: false,
	                    queryFormatBlockState: function(){ return false; },
	                    queryCommandState: function(){ return false; }
	                };
	                var defaultChildScope = {
	                    $window: $window,
	                    $editor: function(){
	                        // dynamically gets the editor as it is set
	                        return scope._parent;
	                    },
	                    isDisabled: function(){
	                        // view selection button is always enabled since it doesn not depend on a selction!
	                        if (this.name === 'html' && scope._parent.startAction) {
	                            return false;
	                        }
	                        // to set your own disabled logic set a function or boolean on the tool called 'disabled'
	                        return ( // this bracket is important as without it it just returns the first bracket and ignores the rest
	                            // when the button's disabled function/value evaluates to true
	                            (typeof this.$eval('disabled') !== 'function' && this.$eval('disabled')) || this.$eval('disabled()') ||
	                            // all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
	                            (this.name !== 'html' && this.$editor().showHtml) ||
	                            // if the toolbar is disabled
	                            this.$parent.disabled ||
	                            // if the current editor is disabled
	                            this.$editor().disabled
	                        );
	                    },
	                    displayActiveToolClass: function(active){
	                        return (active)? scope.classes.toolbarButtonActive : '';
	                    },
	                    executeAction: taToolExecuteAction
	                };
	
	                angular.forEach(scope.toolbar, function(group){
	                    // setup the toolbar group
	                    var groupElement = angular.element("<div>");
	                    groupElement.addClass(scope.classes.toolbarGroup);
	                    angular.forEach(group, function(tool){
	                        // init and add the tools to the group
	                        // a tool name (key name from taTools struct)
	                        //creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
	                        // reference to the scope and element kept
	                        scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {name: tool});
	                        scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
	                        // append the tool compiled with the childScope to the group element
	                        groupElement.append(scope.tools[tool].$element);
	                    });
	                    // append the group to the toolbar
	                    element.append(groupElement);
	                });
	
	                // update a tool
	                // if a value is set to null, remove from the display
	                // when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
	                // to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
	                scope.updateToolDisplay = function(key, _newTool, forceNew){
	                    var toolInstance = scope.tools[key];
	                    if(toolInstance){
	                        // get the last toolDefinition, then override with the new definition
	                        if(toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
	                        if(_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null)
	                            throw('textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value');
	
	                        // if tool is defined on this toolbar, update/redo the tool
	                        if(_newTool.buttontext === null){
	                            delete _newTool.buttontext;
	                        }
	                        if(_newTool.iconclass === null){
	                            delete _newTool.iconclass;
	                        }
	                        if(_newTool.display === null){
	                            delete _newTool.display;
	                        }
	
	                        var toolElement = setupToolElement(_newTool, toolInstance);
	                        toolInstance.$element.replaceWith(toolElement);
	                        toolInstance.$element = toolElement;
	                    }
	                };
	
	                // we assume here that all values passed are valid and correct
	                scope.addTool = function(key, _newTool, groupIndex, index){
	                    scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, {name: key});
	                    scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
	                    var group;
	                    if(groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
	                    group = angular.element(element.children()[groupIndex]);
	
	                    if(index === undefined){
	                        group.append(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
	                    }else{
	                        group.children().eq(index).after(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][index] = key;
	                    }
	                };
	
	                textAngularManager.registerToolbar(scope);
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterToolbar(scope.name);
	                });
	            }
	        };
	    }
	]);
	textAngular.directive('textAngularVersion', ['textAngularManager',
	    function(textAngularManager) {
	        var version = textAngularManager.getVersion();
	        return {
	            restrict: "EA",
	            link: function (scope, element, attrs) {
	                element.html(version);
	            }
	        };
	    }
	]);
	
	return textAngular.name;
	
	}));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory();
	    } else {
	        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
	        root.rangy = factory();
	    }
	})(function() {
	
	    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";
	
	    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	        "commonAncestorContainer"];
	
	    // Minimal set of methods required for DOM Level 2 Range compliance
	    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
	        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
	        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];
	
	    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];
	
	    // Subset of TextRange's full set of methods that we're interested in
	    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
	        "setEndPoint", "getBoundingClientRect"];
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Trio of functions taken from Peter Michaux's article:
	    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	    function isHostMethod(o, p) {
	        var t = typeof o[p];
	        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
	    }
	
	    function isHostObject(o, p) {
	        return !!(typeof o[p] == OBJECT && o[p]);
	    }
	
	    function isHostProperty(o, p) {
	        return typeof o[p] != UNDEFINED;
	    }
	
	    // Creates a convenience function to save verbose repeated calls to tests functions
	    function createMultiplePropertyTest(testFunc) {
	        return function(o, props) {
	            var i = props.length;
	            while (i--) {
	                if (!testFunc(o, props[i])) {
	                    return false;
	                }
	            }
	            return true;
	        };
	    }
	
	    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	    var areHostMethods = createMultiplePropertyTest(isHostMethod);
	    var areHostObjects = createMultiplePropertyTest(isHostObject);
	    var areHostProperties = createMultiplePropertyTest(isHostProperty);
	
	    function isTextRange(range) {
	        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
	    }
	
	    function getBody(doc) {
	        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
	    }
	
	    var forEach = [].forEach ?
	        function(arr, func) {
	            arr.forEach(func);
	        } :
	        function(arr, func) {
	            for (var i = 0, len = arr.length; i < len; ++i) {
	                func(arr[i], i);
	            }
	        };
	
	    var modules = {};
	
	    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);
	
	    var util = {
	        isHostMethod: isHostMethod,
	        isHostObject: isHostObject,
	        isHostProperty: isHostProperty,
	        areHostMethods: areHostMethods,
	        areHostObjects: areHostObjects,
	        areHostProperties: areHostProperties,
	        isTextRange: isTextRange,
	        getBody: getBody,
	        forEach: forEach
	    };
	
	    var api = {
	        version: "1.3.0",
	        initialized: false,
	        isBrowser: isBrowser,
	        supported: true,
	        util: util,
	        features: {},
	        modules: modules,
	        config: {
	            alertOnFail: false,
	            alertOnWarn: false,
	            preferTextRange: false,
	            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
	        }
	    };
	
	    function consoleLog(msg) {
	        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
	            console.log(msg);
	        }
	    }
	
	    function alertOrLog(msg, shouldAlert) {
	        if (isBrowser && shouldAlert) {
	            alert(msg);
	        } else  {
	            consoleLog(msg);
	        }
	    }
	
	    function fail(reason) {
	        api.initialized = true;
	        api.supported = false;
	        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
	    }
	
	    api.fail = fail;
	
	    function warn(msg) {
	        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
	    }
	
	    api.warn = warn;
	
	    // Add utility extend() method
	    var extend;
	    if ({}.hasOwnProperty) {
	        util.extend = extend = function(obj, props, deep) {
	            var o, p;
	            for (var i in props) {
	                if (props.hasOwnProperty(i)) {
	                    o = obj[i];
	                    p = props[i];
	                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
	                        extend(o, p, true);
	                    }
	                    obj[i] = p;
	                }
	            }
	            // Special case for toString, which does not show up in for...in loops in IE <= 8
	            if (props.hasOwnProperty("toString")) {
	                obj.toString = props.toString;
	            }
	            return obj;
	        };
	
	        util.createOptions = function(optionsParam, defaults) {
	            var options = {};
	            extend(options, defaults);
	            if (optionsParam) {
	                extend(options, optionsParam);
	            }
	            return options;
	        };
	    } else {
	        fail("hasOwnProperty not supported");
	    }
	
	    // Test whether we're in a browser and bail out if not
	    if (!isBrowser) {
	        fail("Rangy can only run in a browser");
	    }
	
	    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	    (function() {
	        var toArray;
	
	        if (isBrowser) {
	            var el = document.createElement("div");
	            el.appendChild(document.createElement("span"));
	            var slice = [].slice;
	            try {
	                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
	                    toArray = function(arrayLike) {
	                        return slice.call(arrayLike, 0);
	                    };
	                }
	            } catch (e) {}
	        }
	
	        if (!toArray) {
	            toArray = function(arrayLike) {
	                var arr = [];
	                for (var i = 0, len = arrayLike.length; i < len; ++i) {
	                    arr[i] = arrayLike[i];
	                }
	                return arr;
	            };
	        }
	
	        util.toArray = toArray;
	    })();
	
	    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	    // normalization of event properties
	    var addListener;
	    if (isBrowser) {
	        if (isHostMethod(document, "addEventListener")) {
	            addListener = function(obj, eventType, listener) {
	                obj.addEventListener(eventType, listener, false);
	            };
	        } else if (isHostMethod(document, "attachEvent")) {
	            addListener = function(obj, eventType, listener) {
	                obj.attachEvent("on" + eventType, listener);
	            };
	        } else {
	            fail("Document does not have required addEventListener or attachEvent method");
	        }
	
	        util.addListener = addListener;
	    }
	
	    var initListeners = [];
	
	    function getErrorDesc(ex) {
	        return ex.message || ex.description || String(ex);
	    }
	
	    // Initialization
	    function init() {
	        if (!isBrowser || api.initialized) {
	            return;
	        }
	        var testRange;
	        var implementsDomRange = false, implementsTextRange = false;
	
	        // First, perform basic feature tests
	
	        if (isHostMethod(document, "createRange")) {
	            testRange = document.createRange();
	            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
	                implementsDomRange = true;
	            }
	        }
	
	        var body = getBody(document);
	        if (!body || body.nodeName.toLowerCase() != "body") {
	            fail("No body element found");
	            return;
	        }
	
	        if (body && isHostMethod(body, "createTextRange")) {
	            testRange = body.createTextRange();
	            if (isTextRange(testRange)) {
	                implementsTextRange = true;
	            }
	        }
	
	        if (!implementsDomRange && !implementsTextRange) {
	            fail("Neither Range nor TextRange are available");
	            return;
	        }
	
	        api.initialized = true;
	        api.features = {
	            implementsDomRange: implementsDomRange,
	            implementsTextRange: implementsTextRange
	        };
	
	        // Initialize modules
	        var module, errorMessage;
	        for (var moduleName in modules) {
	            if ( (module = modules[moduleName]) instanceof Module ) {
	                module.init(module, api);
	            }
	        }
	
	        // Call init listeners
	        for (var i = 0, len = initListeners.length; i < len; ++i) {
	            try {
	                initListeners[i](api);
	            } catch (ex) {
	                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
	                consoleLog(errorMessage);
	            }
	        }
	    }
	
	    function deprecationNotice(deprecated, replacement, module) {
	        if (module) {
	            deprecated += " in module " + module.name;
	        }
	        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
	        replacement + " instead.");
	    }
	
	    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
	        owner[deprecated] = function() {
	            deprecationNotice(deprecated, replacement, module);
	            return owner[replacement].apply(owner, util.toArray(arguments));
	        };
	    }
	
	    util.deprecationNotice = deprecationNotice;
	    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;
	
	    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
	    api.init = init;
	
	    // Execute listener immediately if already initialized
	    api.addInitListener = function(listener) {
	        if (api.initialized) {
	            listener(api);
	        } else {
	            initListeners.push(listener);
	        }
	    };
	
	    var shimListeners = [];
	
	    api.addShimListener = function(listener) {
	        shimListeners.push(listener);
	    };
	
	    function shim(win) {
	        win = win || window;
	        init();
	
	        // Notify listeners
	        for (var i = 0, len = shimListeners.length; i < len; ++i) {
	            shimListeners[i](win);
	        }
	    }
	
	    if (isBrowser) {
	        api.shim = api.createMissingNativeApi = shim;
	        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
	    }
	
	    function Module(name, dependencies, initializer) {
	        this.name = name;
	        this.dependencies = dependencies;
	        this.initialized = false;
	        this.supported = false;
	        this.initializer = initializer;
	    }
	
	    Module.prototype = {
	        init: function() {
	            var requiredModuleNames = this.dependencies || [];
	            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
	                moduleName = requiredModuleNames[i];
	
	                requiredModule = modules[moduleName];
	                if (!requiredModule || !(requiredModule instanceof Module)) {
	                    throw new Error("required module '" + moduleName + "' not found");
	                }
	
	                requiredModule.init();
	
	                if (!requiredModule.supported) {
	                    throw new Error("required module '" + moduleName + "' not supported");
	                }
	            }
	
	            // Now run initializer
	            this.initializer(this);
	        },
	
	        fail: function(reason) {
	            this.initialized = true;
	            this.supported = false;
	            throw new Error(reason);
	        },
	
	        warn: function(msg) {
	            api.warn("Module " + this.name + ": " + msg);
	        },
	
	        deprecationNotice: function(deprecated, replacement) {
	            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
	                replacement + " instead");
	        },
	
	        createError: function(msg) {
	            return new Error("Error in Rangy " + this.name + " module: " + msg);
	        }
	    };
	
	    function createModule(name, dependencies, initFunc) {
	        var newModule = new Module(name, dependencies, function(module) {
	            if (!module.initialized) {
	                module.initialized = true;
	                try {
	                    initFunc(api, module);
	                    module.supported = true;
	                } catch (ex) {
	                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
	                    consoleLog(errorMessage);
	                    if (ex.stack) {
	                        consoleLog(ex.stack);
	                    }
	                }
	            }
	        });
	        modules[name] = newModule;
	        return newModule;
	    }
	
	    api.createModule = function(name) {
	        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	        var initFunc, dependencies;
	        if (arguments.length == 2) {
	            initFunc = arguments[1];
	            dependencies = [];
	        } else {
	            initFunc = arguments[2];
	            dependencies = arguments[1];
	        }
	
	        var module = createModule(name, dependencies, initFunc);
	
	        // Initialize the module immediately if the core is already initialized
	        if (api.initialized && api.supported) {
	            module.init();
	        }
	    };
	
	    api.createCoreModule = function(name, dependencies, initFunc) {
	        createModule(name, dependencies, initFunc);
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	
	    function RangePrototype() {}
	    api.RangePrototype = RangePrototype;
	    api.rangePrototype = new RangePrototype();
	
	    function SelectionPrototype() {}
	    api.selectionPrototype = new SelectionPrototype();
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // DOM utility methods used by Rangy
	    api.createCoreModule("DomUtil", [], function(api, module) {
	        var UNDEF = "undefined";
	        var util = api.util;
	        var getBody = util.getBody;
	
	        // Perform feature tests
	        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
	            module.fail("document missing a Node creation method");
	        }
	
	        if (!util.isHostMethod(document, "getElementsByTagName")) {
	            module.fail("document missing getElementsByTagName method");
	        }
	
	        var el = document.createElement("div");
	        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
	            module.fail("Incomplete Element implementation");
	        }
	
	        // innerHTML is required for Range's createContextualFragment method
	        if (!util.isHostProperty(el, "innerHTML")) {
	            module.fail("Element is missing innerHTML property");
	        }
	
	        var textNode = document.createTextNode("test");
	        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
	                !util.areHostProperties(textNode, ["data"]))) {
	            module.fail("Incomplete Text Node implementation");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	        // contains just the document as a single element and the value searched for is the document.
	        var arrayContains = /*Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val) > -1;
	            }:*/
	
	            function(arr, val) {
	                var i = arr.length;
	                while (i--) {
	                    if (arr[i] === val) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	        function isHtmlNamespace(node) {
	            var ns;
	            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
	        }
	
	        function parentElement(node) {
	            var parent = node.parentNode;
	            return (parent.nodeType == 1) ? parent : null;
	        }
	
	        function getNodeIndex(node) {
	            var i = 0;
	            while( (node = node.previousSibling) ) {
	                ++i;
	            }
	            return i;
	        }
	
	        function getNodeLength(node) {
	            switch (node.nodeType) {
	                case 7:
	                case 10:
	                    return 0;
	                case 3:
	                case 8:
	                    return node.length;
	                default:
	                    return node.childNodes.length;
	            }
	        }
	
	        function getCommonAncestor(node1, node2) {
	            var ancestors = [], n;
	            for (n = node1; n; n = n.parentNode) {
	                ancestors.push(n);
	            }
	
	            for (n = node2; n; n = n.parentNode) {
	                if (arrayContains(ancestors, n)) {
	                    return n;
	                }
	            }
	
	            return null;
	        }
	
	        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
	            var n = selfIsAncestor ? descendant : descendant.parentNode;
	            while (n) {
	                if (n === ancestor) {
	                    return true;
	                } else {
	                    n = n.parentNode;
	                }
	            }
	            return false;
	        }
	
	        function isOrIsAncestorOf(ancestor, descendant) {
	            return isAncestorOf(ancestor, descendant, true);
	        }
	
	        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
	            var p, n = selfIsAncestor ? node : node.parentNode;
	            while (n) {
	                p = n.parentNode;
	                if (p === ancestor) {
	                    return n;
	                }
	                n = p;
	            }
	            return null;
	        }
	
	        function isCharacterDataNode(node) {
	            var t = node.nodeType;
	            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
	        }
	
	        function isTextOrCommentNode(node) {
	            if (!node) {
	                return false;
	            }
	            var t = node.nodeType;
	            return t == 3 || t == 8 ; // Text or Comment
	        }
	
	        function insertAfter(node, precedingNode) {
	            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
	            if (nextNode) {
	                parent.insertBefore(node, nextNode);
	            } else {
	                parent.appendChild(node);
	            }
	            return node;
	        }
	
	        // Note that we cannot use splitText() because it is bugridden in IE 9.
	        function splitDataNode(node, index, positionsToPreserve) {
	            var newNode = node.cloneNode(false);
	            newNode.deleteData(0, index);
	            node.deleteData(index, node.length - index);
	            insertAfter(newNode, node);
	
	            // Preserve positions
	            if (positionsToPreserve) {
	                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
	                    // Handle case where position was inside the portion of node after the split point
	                    if (position.node == node && position.offset > index) {
	                        position.node = newNode;
	                        position.offset -= index;
	                    }
	                    // Handle the case where the position is a node offset within node's parent
	                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
	                        ++position.offset;
	                    }
	                }
	            }
	            return newNode;
	        }
	
	        function getDocument(node) {
	            if (node.nodeType == 9) {
	                return node;
	            } else if (typeof node.ownerDocument != UNDEF) {
	                return node.ownerDocument;
	            } else if (typeof node.document != UNDEF) {
	                return node.document;
	            } else if (node.parentNode) {
	                return getDocument(node.parentNode);
	            } else {
	                throw module.createError("getDocument: no document found for node");
	            }
	        }
	
	        function getWindow(node) {
	            var doc = getDocument(node);
	            if (typeof doc.defaultView != UNDEF) {
	                return doc.defaultView;
	            } else if (typeof doc.parentWindow != UNDEF) {
	                return doc.parentWindow;
	            } else {
	                throw module.createError("Cannot get a window object for node");
	            }
	        }
	
	        function getIframeDocument(iframeEl) {
	            if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument;
	            } else if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow.document;
	            } else {
	                throw module.createError("getIframeDocument: No Document object found for iframe element");
	            }
	        }
	
	        function getIframeWindow(iframeEl) {
	            if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow;
	            } else if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument.defaultView;
	            } else {
	                throw module.createError("getIframeWindow: No Window object found for iframe element");
	            }
	        }
	
	        // This looks bad. Is it worth it?
	        function isWindow(obj) {
	            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
	        }
	
	        function getContentDocument(obj, module, methodName) {
	            var doc;
	
	            if (!obj) {
	                doc = document;
	            }
	
	            // Test if a DOM node has been passed and obtain a document object for it if so
	            else if (util.isHostProperty(obj, "nodeType")) {
	                doc = (obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
	                    getIframeDocument(obj) : getDocument(obj);
	            }
	
	            // Test if the doc parameter appears to be a Window object
	            else if (isWindow(obj)) {
	                doc = obj.document;
	            }
	
	            if (!doc) {
	                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
	            }
	
	            return doc;
	        }
	
	        function getRootContainer(node) {
	            var parent;
	            while ( (parent = node.parentNode) ) {
	                node = parent;
	            }
	            return node;
	        }
	
	        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
	            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	            var nodeC, root, childA, childB, n;
	            if (nodeA == nodeB) {
	                // Case 1: nodes are the same
	                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
	                // Case 2: node C (container B or an ancestor) is a child node of A
	                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
	                // Case 3: node C (container A or an ancestor) is a child node of B
	                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
	            } else {
	                root = getCommonAncestor(nodeA, nodeB);
	                if (!root) {
	                    throw new Error("comparePoints error: nodes have no common ancestor");
	                }
	
	                // Case 4: containers are siblings or descendants of siblings
	                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
	                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);
	
	                if (childA === childB) {
	                    // This shouldn't be possible
	                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
	                } else {
	                    n = root.firstChild;
	                    while (n) {
	                        if (n === childA) {
	                            return -1;
	                        } else if (n === childB) {
	                            return 1;
	                        }
	                        n = n.nextSibling;
	                    }
	                }
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	        var crashyTextNodes = false;
	
	        function isBrokenNode(node) {
	            var n;
	            try {
	                n = node.parentNode;
	                return false;
	            } catch (e) {
	                return true;
	            }
	        }
	
	        (function() {
	            var el = document.createElement("b");
	            el.innerHTML = "1";
	            var textNode = el.firstChild;
	            el.innerHTML = "<br />";
	            crashyTextNodes = isBrokenNode(textNode);
	
	            api.features.crashyTextNodes = crashyTextNodes;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function inspectNode(node) {
	            if (!node) {
	                return "[No node]";
	            }
	            if (crashyTextNodes && isBrokenNode(node)) {
	                return "[Broken node]";
	            }
	            if (isCharacterDataNode(node)) {
	                return '"' + node.data + '"';
	            }
	            if (node.nodeType == 1) {
	                var idAttr = node.id ? ' id="' + node.id + '"' : "";
	                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
	            }
	            return node.nodeName;
	        }
	
	        function fragmentFromNodeChildren(node) {
	            var fragment = getDocument(node).createDocumentFragment(), child;
	            while ( (child = node.firstChild) ) {
	                fragment.appendChild(child);
	            }
	            return fragment;
	        }
	
	        var getComputedStyleProperty;
	        if (typeof window.getComputedStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return getWindow(el).getComputedStyle(el, null)[propName];
	            };
	        } else if (typeof document.documentElement.currentStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return el.currentStyle ? el.currentStyle[propName] : "";
	            };
	        } else {
	            module.fail("No means of obtaining computed style properties found");
	        }
	
	        function createTestElement(doc, html, contentEditable) {
	            var body = getBody(doc);
	            var el = doc.createElement("div");
	            el.contentEditable = "" + !!contentEditable;
	            if (html) {
	                el.innerHTML = html;
	            }
	
	            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	            var bodyFirstChild = body.firstChild;
	            if (bodyFirstChild) {
	                body.insertBefore(el, bodyFirstChild);
	            } else {
	                body.appendChild(el);
	            }
	
	            return el;
	        }
	
	        function removeNode(node) {
	            return node.parentNode.removeChild(node);
	        }
	
	        function NodeIterator(root) {
	            this.root = root;
	            this._next = root;
	        }
	
	        NodeIterator.prototype = {
	            _current: null,
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                var n = this._current = this._next;
	                var child, next;
	                if (this._current) {
	                    child = n.firstChild;
	                    if (child) {
	                        this._next = child;
	                    } else {
	                        next = null;
	                        while ((n !== this.root) && !(next = n.nextSibling)) {
	                            n = n.parentNode;
	                        }
	                        this._next = next;
	                    }
	                }
	                return this._current;
	            },
	
	            detach: function() {
	                this._current = this._next = this.root = null;
	            }
	        };
	
	        function createIterator(root) {
	            return new NodeIterator(root);
	        }
	
	        function DomPosition(node, offset) {
	            this.node = node;
	            this.offset = offset;
	        }
	
	        DomPosition.prototype = {
	            equals: function(pos) {
	                return !!pos && this.node === pos.node && this.offset == pos.offset;
	            },
	
	            inspect: function() {
	                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
	            },
	
	            toString: function() {
	                return this.inspect();
	            }
	        };
	
	        function DOMException(codeName) {
	            this.code = this[codeName];
	            this.codeName = codeName;
	            this.message = "DOMException: " + this.codeName;
	        }
	
	        DOMException.prototype = {
	            INDEX_SIZE_ERR: 1,
	            HIERARCHY_REQUEST_ERR: 3,
	            WRONG_DOCUMENT_ERR: 4,
	            NO_MODIFICATION_ALLOWED_ERR: 7,
	            NOT_FOUND_ERR: 8,
	            NOT_SUPPORTED_ERR: 9,
	            INVALID_STATE_ERR: 11,
	            INVALID_NODE_TYPE_ERR: 24
	        };
	
	        DOMException.prototype.toString = function() {
	            return this.message;
	        };
	
	        api.dom = {
	            arrayContains: arrayContains,
	            isHtmlNamespace: isHtmlNamespace,
	            parentElement: parentElement,
	            getNodeIndex: getNodeIndex,
	            getNodeLength: getNodeLength,
	            getCommonAncestor: getCommonAncestor,
	            isAncestorOf: isAncestorOf,
	            isOrIsAncestorOf: isOrIsAncestorOf,
	            getClosestAncestorIn: getClosestAncestorIn,
	            isCharacterDataNode: isCharacterDataNode,
	            isTextOrCommentNode: isTextOrCommentNode,
	            insertAfter: insertAfter,
	            splitDataNode: splitDataNode,
	            getDocument: getDocument,
	            getWindow: getWindow,
	            getIframeWindow: getIframeWindow,
	            getIframeDocument: getIframeDocument,
	            getBody: getBody,
	            isWindow: isWindow,
	            getContentDocument: getContentDocument,
	            getRootContainer: getRootContainer,
	            comparePoints: comparePoints,
	            isBrokenNode: isBrokenNode,
	            inspectNode: inspectNode,
	            getComputedStyleProperty: getComputedStyleProperty,
	            createTestElement: createTestElement,
	            removeNode: removeNode,
	            fragmentFromNodeChildren: fragmentFromNodeChildren,
	            createIterator: createIterator,
	            DomPosition: DomPosition
	        };
	
	        api.DOMException = DOMException;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Pure JavaScript implementation of DOM Range
	    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DOMException = api.DOMException;
	
	        var isCharacterDataNode = dom.isCharacterDataNode;
	        var getNodeIndex = dom.getNodeIndex;
	        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
	        var getDocument = dom.getDocument;
	        var comparePoints = dom.comparePoints;
	        var splitDataNode = dom.splitDataNode;
	        var getClosestAncestorIn = dom.getClosestAncestorIn;
	        var getNodeLength = dom.getNodeLength;
	        var arrayContains = dom.arrayContains;
	        var getRootContainer = dom.getRootContainer;
	        var crashyTextNodes = api.features.crashyTextNodes;
	
	        var removeNode = dom.removeNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Utility functions
	
	        function isNonTextPartiallySelected(node, range) {
	            return (node.nodeType != 3) &&
	                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
	        }
	
	        function getRangeDocument(range) {
	            return range.document || getDocument(range.startContainer);
	        }
	
	        function getRangeRoot(range) {
	            return getRootContainer(range.startContainer);
	        }
	
	        function getBoundaryBeforeNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node));
	        }
	
	        function getBoundaryAfterNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
	        }
	
	        function insertNodeAtPosition(node, n, o) {
	            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
	            if (isCharacterDataNode(n)) {
	                if (o == n.length) {
	                    dom.insertAfter(node, n);
	                } else {
	                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
	                }
	            } else if (o >= n.childNodes.length) {
	                n.appendChild(node);
	            } else {
	                n.insertBefore(node, n.childNodes[o]);
	            }
	            return firstNodeInserted;
	        }
	
	        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
	            assertRangeValid(rangeA);
	            assertRangeValid(rangeB);
	
	            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	
	            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
	                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);
	
	            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	        }
	
	        function cloneSubtree(iterator) {
	            var partiallySelected;
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	                partiallySelected = iterator.isPartiallySelectedSubtree();
	                node = node.cloneNode(!partiallySelected);
	                if (partiallySelected) {
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(cloneSubtree(subIterator));
	                    subIterator.detach();
	                }
	
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function iterateSubtree(rangeIterator, func, iteratorState) {
	            var it, n;
	            iteratorState = iteratorState || { stop: false };
	            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
	                if (rangeIterator.isPartiallySelectedSubtree()) {
	                    if (func(node) === false) {
	                        iteratorState.stop = true;
	                        return;
	                    } else {
	                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	                        // the node selected by the Range.
	                        subRangeIterator = rangeIterator.getSubtreeIterator();
	                        iterateSubtree(subRangeIterator, func, iteratorState);
	                        subRangeIterator.detach();
	                        if (iteratorState.stop) {
	                            return;
	                        }
	                    }
	                } else {
	                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	                    // descendants
	                    it = dom.createIterator(node);
	                    while ( (n = it.next()) ) {
	                        if (func(n) === false) {
	                            iteratorState.stop = true;
	                            return;
	                        }
	                    }
	                }
	            }
	        }
	
	        function deleteSubtree(iterator) {
	            var subIterator;
	            while (iterator.next()) {
	                if (iterator.isPartiallySelectedSubtree()) {
	                    subIterator = iterator.getSubtreeIterator();
	                    deleteSubtree(subIterator);
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	            }
	        }
	
	        function extractSubtree(iterator) {
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	
	                if (iterator.isPartiallySelectedSubtree()) {
	                    node = node.cloneNode(false);
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(extractSubtree(subIterator));
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function getNodesInRange(range, nodeTypes, filter) {
	            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
	            var filterExists = !!filter;
	            if (filterNodeTypes) {
	                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
	            }
	
	            var nodes = [];
	            iterateSubtree(new RangeIterator(range, false), function(node) {
	                if (filterNodeTypes && !regex.test(node.nodeType)) {
	                    return;
	                }
	                if (filterExists && !filter(node)) {
	                    return;
	                }
	                // Don't include a boundary container if it is a character data node and the range does not contain any
	                // of its character data. See issue 190.
	                var sc = range.startContainer;
	                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
	                    return;
	                }
	
	                var ec = range.endContainer;
	                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
	                    return;
	                }
	
	                nodes.push(node);
	            });
	            return nodes;
	        }
	
	        function inspect(range) {
	            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
	            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
	                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	
	        function RangeIterator(range, clonePartiallySelectedTextNodes) {
	            this.range = range;
	            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;
	
	
	            if (!range.collapsed) {
	                this.sc = range.startContainer;
	                this.so = range.startOffset;
	                this.ec = range.endContainer;
	                this.eo = range.endOffset;
	                var root = range.commonAncestorContainer;
	
	                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
	                    this.isSingleCharacterDataNode = true;
	                    this._first = this._last = this._next = this.sc;
	                } else {
	                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
	                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
	                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
	                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
	                }
	            }
	        }
	
	        RangeIterator.prototype = {
	            _current: null,
	            _next: null,
	            _first: null,
	            _last: null,
	            isSingleCharacterDataNode: false,
	
	            reset: function() {
	                this._current = null;
	                this._next = this._first;
	            },
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                // Move to next node
	                var current = this._current = this._next;
	                if (current) {
	                    this._next = (current !== this._last) ? current.nextSibling : null;
	
	                    // Check for partially selected text nodes
	                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
	                        if (current === this.ec) {
	                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
	                        }
	                        if (this._current === this.sc) {
	                            (current = current.cloneNode(true)).deleteData(0, this.so);
	                        }
	                    }
	                }
	
	                return current;
	            },
	
	            remove: function() {
	                var current = this._current, start, end;
	
	                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
	                    start = (current === this.sc) ? this.so : 0;
	                    end = (current === this.ec) ? this.eo : current.length;
	                    if (start != end) {
	                        current.deleteData(start, end - start);
	                    }
	                } else {
	                    if (current.parentNode) {
	                        removeNode(current);
	                    } else {
	                    }
	                }
	            },
	
	            // Checks if the current node is partially selected
	            isPartiallySelectedSubtree: function() {
	                var current = this._current;
	                return isNonTextPartiallySelected(current, this.range);
	            },
	
	            getSubtreeIterator: function() {
	                var subRange;
	                if (this.isSingleCharacterDataNode) {
	                    subRange = this.range.cloneRange();
	                    subRange.collapse(false);
	                } else {
	                    subRange = new Range(getRangeDocument(this.range));
	                    var current = this._current;
	                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);
	
	                    if (isOrIsAncestorOf(current, this.sc)) {
	                        startContainer = this.sc;
	                        startOffset = this.so;
	                    }
	                    if (isOrIsAncestorOf(current, this.ec)) {
	                        endContainer = this.ec;
	                        endOffset = this.eo;
	                    }
	
	                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
	                }
	                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
	            },
	
	            detach: function() {
	                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
	            }
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
	        var rootContainerNodeTypes = [2, 9, 11];
	        var readonlyNodeTypes = [5, 6, 10, 12];
	        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
	        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
	
	        function createAncestorFinder(nodeTypes) {
	            return function(node, selfIsAncestor) {
	                var t, n = selfIsAncestor ? node : node.parentNode;
	                while (n) {
	                    t = n.nodeType;
	                    if (arrayContains(nodeTypes, t)) {
	                        return n;
	                    }
	                    n = n.parentNode;
	                }
	                return null;
	            };
	        }
	
	        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
	        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
	        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );
	
	        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
	            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidNodeType(node, invalidTypes) {
	            if (!arrayContains(invalidTypes, node.nodeType)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        function assertSameDocumentOrFragment(node1, node2) {
	            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertNodeNotReadOnly(node) {
	            if (getReadonlyAncestor(node, true)) {
	                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
	            }
	        }
	
	        function assertNode(node, codeName) {
	            if (!node) {
	                throw new DOMException(codeName);
	            }
	        }
	
	        function isValidOffset(node, offset) {
	            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
	        }
	
	        function isRangeValid(range) {
	            return (!!range.startContainer && !!range.endContainer &&
	                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
	                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
	                    isValidOffset(range.startContainer, range.startOffset) &&
	                    isValidOffset(range.endContainer, range.endOffset));
	        }
	
	        function assertRangeValid(range) {
	            if (!isRangeValid(range)) {
	                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test the browser's innerHTML support to decide how to implement createContextualFragment
	        var styleEl = document.createElement("style");
	        var htmlParsingConforms = false;
	        try {
	            styleEl.innerHTML = "<b>x</b>";
	            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
	        } catch (e) {
	            // IE 6 and 7 throw
	        }
	
	        api.features.htmlParsingConforms = htmlParsingConforms;
	
	        var createContextualFragment = htmlParsingConforms ?
	
	            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	            // discussion and base code for this implementation at issue 67.
	            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	            // Thanks to Aleks Williams.
	            function(fragmentStr) {
	                // "Let node the context object's start's node."
	                var node = this.startContainer;
	                var doc = getDocument(node);
	
	                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
	                // exception and abort these steps."
	                if (!node) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // "Let element be as follows, depending on node's interface:"
	                // Document, Document Fragment: null
	                var el = null;
	
	                // "Element: node"
	                if (node.nodeType == 1) {
	                    el = node;
	
	                // "Text, Comment: node's parentElement"
	                } else if (isCharacterDataNode(node)) {
	                    el = dom.parentElement(node);
	                }
	
	                // "If either element is null or element's ownerDocument is an HTML document
	                // and element's local name is "html" and element's namespace is the HTML
	                // namespace"
	                if (el === null || (
	                    el.nodeName == "HTML" &&
	                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
	                    dom.isHtmlNamespace(el)
	                )) {
	
	                // "let element be a new Element with "body" as its local name and the HTML
	                // namespace as its namespace.""
	                    el = doc.createElement("body");
	                } else {
	                    el = el.cloneNode(false);
	                }
	
	                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	                // "In either case, the algorithm must be invoked with fragment as the input
	                // and element as the context element."
	                el.innerHTML = fragmentStr;
	
	                // "If this raises an exception, then abort these steps. Otherwise, let new
	                // children be the nodes returned."
	
	                // "Let fragment be a new DocumentFragment."
	                // "Append all new children to fragment."
	                // "Return fragment."
	                return dom.fragmentFromNodeChildren(el);
	            } :
	
	            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	            // previous versions of Rangy used (with the exception of using a body element rather than a div)
	            function(fragmentStr) {
	                var doc = getRangeDocument(this);
	                var el = doc.createElement("body");
	                el.innerHTML = fragmentStr;
	
	                return dom.fragmentFromNodeChildren(el);
	            };
	
	        function splitRangeBoundaries(range, positionsToPreserve) {
	            assertRangeValid(range);
	
	            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
	            var startEndSame = (sc === ec);
	
	            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
	                splitDataNode(ec, eo, positionsToPreserve);
	            }
	
	            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
	                sc = splitDataNode(sc, so, positionsToPreserve);
	                if (startEndSame) {
	                    eo -= so;
	                    ec = sc;
	                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
	                    eo++;
	                }
	                so = 0;
	            }
	            range.setStartAndEnd(sc, so, ec, eo);
	        }
	
	        function rangeToHtml(range) {
	            assertRangeValid(range);
	            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
	            container.appendChild( range.cloneContents() );
	            return container.innerHTML;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	            "commonAncestorContainer"];
	
	        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
	        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;
	
	        util.extend(api.rangePrototype, {
	            compareBoundaryPoints: function(how, range) {
	                assertRangeValid(this);
	                assertSameDocumentOrFragment(this.startContainer, range.startContainer);
	
	                var nodeA, offsetA, nodeB, offsetB;
	                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
	                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
	                nodeA = this[prefixA + "Container"];
	                offsetA = this[prefixA + "Offset"];
	                nodeB = range[prefixB + "Container"];
	                offsetB = range[prefixB + "Offset"];
	                return comparePoints(nodeA, offsetA, nodeB, offsetB);
	            },
	
	            insertNode: function(node) {
	                assertRangeValid(this);
	                assertValidNodeType(node, insertableNodeTypes);
	                assertNodeNotReadOnly(this.startContainer);
	
	                if (isOrIsAncestorOf(node, this.startContainer)) {
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	
	                // No check for whether the container of the start of the Range is of a type that does not allow
	                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
	                // to add the node
	
	                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                this.setStartBefore(firstNodeInserted);
	            },
	
	            cloneContents: function() {
	                assertRangeValid(this);
	
	                var clone, frag;
	                if (this.collapsed) {
	                    return getRangeDocument(this).createDocumentFragment();
	                } else {
	                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
	                        clone = this.startContainer.cloneNode(true);
	                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
	                        frag = getRangeDocument(this).createDocumentFragment();
	                        frag.appendChild(clone);
	                        return frag;
	                    } else {
	                        var iterator = new RangeIterator(this, true);
	                        clone = cloneSubtree(iterator);
	                        iterator.detach();
	                    }
	                    return clone;
	                }
	            },
	
	            canSurroundContents: function() {
	                assertRangeValid(this);
	                assertNodeNotReadOnly(this.startContainer);
	                assertNodeNotReadOnly(this.endContainer);
	
	                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                // no non-text nodes.
	                var iterator = new RangeIterator(this, true);
	                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
	                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                iterator.detach();
	                return !boundariesInvalid;
	            },
	
	            surroundContents: function(node) {
	                assertValidNodeType(node, surroundNodeTypes);
	
	                if (!this.canSurroundContents()) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // Extract the contents
	                var content = this.extractContents();
	
	                // Clear the children of the node
	                if (node.hasChildNodes()) {
	                    while (node.lastChild) {
	                        node.removeChild(node.lastChild);
	                    }
	                }
	
	                // Insert the new node and add the extracted contents
	                insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                node.appendChild(content);
	
	                this.selectNode(node);
	            },
	
	            cloneRange: function() {
	                assertRangeValid(this);
	                var range = new Range(getRangeDocument(this));
	                var i = rangeProperties.length, prop;
	                while (i--) {
	                    prop = rangeProperties[i];
	                    range[prop] = this[prop];
	                }
	                return range;
	            },
	
	            toString: function() {
	                assertRangeValid(this);
	                var sc = this.startContainer;
	                if (sc === this.endContainer && isCharacterDataNode(sc)) {
	                    return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
	                } else {
	                    var textParts = [], iterator = new RangeIterator(this, true);
	                    iterateSubtree(iterator, function(node) {
	                        // Accept only text or CDATA nodes, not comments
	                        if (node.nodeType == 3 || node.nodeType == 4) {
	                            textParts.push(node.data);
	                        }
	                    });
	                    iterator.detach();
	                    return textParts.join("");
	                }
	            },
	
	            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	            // been removed from Mozilla.
	
	            compareNode: function(node) {
	                assertRangeValid(this);
	
	                var parent = node.parentNode;
	                var nodeIndex = getNodeIndex(node);
	
	                if (!parent) {
	                    throw new DOMException("NOT_FOUND_ERR");
	                }
	
	                var startComparison = this.comparePoint(parent, nodeIndex),
	                    endComparison = this.comparePoint(parent, nodeIndex + 1);
	
	                if (startComparison < 0) { // Node starts before
	                    return (endComparison > 0) ? n_b_a : n_b;
	                } else {
	                    return (endComparison > 0) ? n_a : n_i;
	                }
	            },
	
	            comparePoint: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
	                    return -1;
	                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
	                    return 1;
	                }
	                return 0;
	            },
	
	            createContextualFragment: createContextualFragment,
	
	            toHtml: function() {
	                return rangeToHtml(this);
	            },
	
	            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	            intersectsNode: function(node, touchingIsIntersecting) {
	                assertRangeValid(this);
	                if (getRootContainer(node) != getRangeRoot(this)) {
	                    return false;
	                }
	
	                var parent = node.parentNode, offset = getNodeIndex(node);
	                if (!parent) {
	                    return true;
	                }
	
	                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
	                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);
	
	                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	            },
	
	            isPointInRange: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
	                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
	            },
	
	            // The methods below are non-standard and invented by me.
	
	            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
	            intersectsRange: function(range) {
	                return rangesIntersect(this, range, false);
	            },
	
	            // Sharing a boundary start-to-end or end-to-start does count as intersection.
	            intersectsOrTouchesRange: function(range) {
	                return rangesIntersect(this, range, true);
	            },
	
	            intersection: function(range) {
	                if (this.intersectsRange(range)) {
	                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
	                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);
	
	                    var intersectionRange = this.cloneRange();
	                    if (startComparison == -1) {
	                        intersectionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (endComparison == 1) {
	                        intersectionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return intersectionRange;
	                }
	                return null;
	            },
	
	            union: function(range) {
	                if (this.intersectsOrTouchesRange(range)) {
	                    var unionRange = this.cloneRange();
	                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
	                        unionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
	                        unionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return unionRange;
	                } else {
	                    throw new DOMException("Ranges do not intersect");
	                }
	            },
	
	            containsNode: function(node, allowPartial) {
	                if (allowPartial) {
	                    return this.intersectsNode(node, false);
	                } else {
	                    return this.compareNode(node) == n_i;
	                }
	            },
	
	            containsNodeContents: function(node) {
	                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
	            },
	
	            containsRange: function(range) {
	                var intersection = this.intersection(range);
	                return intersection !== null && range.equals(intersection);
	            },
	
	            containsNodeText: function(node) {
	                var nodeRange = this.cloneRange();
	                nodeRange.selectNode(node);
	                var textNodes = nodeRange.getNodes([3]);
	                if (textNodes.length > 0) {
	                    nodeRange.setStart(textNodes[0], 0);
	                    var lastTextNode = textNodes.pop();
	                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
	                    return this.containsRange(nodeRange);
	                } else {
	                    return this.containsNodeContents(node);
	                }
	            },
	
	            getNodes: function(nodeTypes, filter) {
	                assertRangeValid(this);
	                return getNodesInRange(this, nodeTypes, filter);
	            },
	
	            getDocument: function() {
	                return getRangeDocument(this);
	            },
	
	            collapseBefore: function(node) {
	                this.setEndBefore(node);
	                this.collapse(false);
	            },
	
	            collapseAfter: function(node) {
	                this.setStartAfter(node);
	                this.collapse(true);
	            },
	
	            getBookmark: function(containerNode) {
	                var doc = getRangeDocument(this);
	                var preSelectionRange = api.createRange(doc);
	                containerNode = containerNode || dom.getBody(doc);
	                preSelectionRange.selectNodeContents(containerNode);
	                var range = this.intersection(preSelectionRange);
	                var start = 0, end = 0;
	                if (range) {
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;
	                    end = start + range.toString().length;
	                }
	
	                return {
	                    start: start,
	                    end: end,
	                    containerNode: containerNode
	                };
	            },
	
	            moveToBookmark: function(bookmark) {
	                var containerNode = bookmark.containerNode;
	                var charIndex = 0;
	                this.setStart(containerNode, 0);
	                this.collapse(true);
	                var nodeStack = [containerNode], node, foundStart = false, stop = false;
	                var nextCharIndex, i, childNodes;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType == 3) {
	                        nextCharIndex = charIndex + node.length;
	                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
	                            this.setStart(node, bookmark.start - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
	                            this.setEnd(node, bookmark.end - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        childNodes = node.childNodes;
	                        i = childNodes.length;
	                        while (i--) {
	                            nodeStack.push(childNodes[i]);
	                        }
	                    }
	                }
	            },
	
	            getName: function() {
	                return "DomRange";
	            },
	
	            equals: function(range) {
	                return Range.rangesEqual(this, range);
	            },
	
	            isValid: function() {
	                return isRangeValid(this);
	            },
	
	            inspect: function() {
	                return inspect(this);
	            },
	
	            detach: function() {
	                // In DOM4, detach() is now a no-op.
	            }
	        });
	
	        function copyComparisonConstantsToObject(obj) {
	            obj.START_TO_START = s2s;
	            obj.START_TO_END = s2e;
	            obj.END_TO_END = e2e;
	            obj.END_TO_START = e2s;
	
	            obj.NODE_BEFORE = n_b;
	            obj.NODE_AFTER = n_a;
	            obj.NODE_BEFORE_AND_AFTER = n_b_a;
	            obj.NODE_INSIDE = n_i;
	        }
	
	        function copyComparisonConstants(constructor) {
	            copyComparisonConstantsToObject(constructor);
	            copyComparisonConstantsToObject(constructor.prototype);
	        }
	
	        function createRangeContentRemover(remover, boundaryUpdater) {
	            return function() {
	                assertRangeValid(this);
	
	                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;
	
	                var iterator = new RangeIterator(this, true);
	
	                // Work out where to position the range after content removal
	                var node, boundary;
	                if (sc !== root) {
	                    node = getClosestAncestorIn(sc, root, true);
	                    boundary = getBoundaryAfterNode(node);
	                    sc = boundary.node;
	                    so = boundary.offset;
	                }
	
	                // Check none of the range is read-only
	                iterateSubtree(iterator, assertNodeNotReadOnly);
	
	                iterator.reset();
	
	                // Remove the content
	                var returnValue = remover(iterator);
	                iterator.detach();
	
	                // Move to the new position
	                boundaryUpdater(this, sc, so, sc, so);
	
	                return returnValue;
	            };
	        }
	
	        function createPrototypeRange(constructor, boundaryUpdater) {
	            function createBeforeAfterNodeSetter(isBefore, isStart) {
	                return function(node) {
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);
	
	                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
	                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
	                };
	            }
	
	            function setRangeStart(range, node, offset) {
	                var ec = range.endContainer, eo = range.endOffset;
	                if (node !== range.startContainer || offset !== range.startOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
	                        ec = node;
	                        eo = offset;
	                    }
	                    boundaryUpdater(range, node, offset, ec, eo);
	                }
	            }
	
	            function setRangeEnd(range, node, offset) {
	                var sc = range.startContainer, so = range.startOffset;
	                if (node !== range.endContainer || offset !== range.endOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
	                        sc = node;
	                        so = offset;
	                    }
	                    boundaryUpdater(range, sc, so, node, offset);
	                }
	            }
	
	            // Set up inheritance
	            var F = function() {};
	            F.prototype = api.rangePrototype;
	            constructor.prototype = new F();
	
	            util.extend(constructor.prototype, {
	                setStart: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeStart(this, node, offset);
	                },
	
	                setEnd: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeEnd(this, node, offset);
	                },
	
	                /**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */
	                setStartAndEnd: function() {
	                    var args = arguments;
	                    var sc = args[0], so = args[1], ec = sc, eo = so;
	
	                    switch (args.length) {
	                        case 3:
	                            eo = args[2];
	                            break;
	                        case 4:
	                            ec = args[2];
	                            eo = args[3];
	                            break;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                setBoundary: function(node, offset, isStart) {
	                    this["set" + (isStart ? "Start" : "End")](node, offset);
	                },
	
	                setStartBefore: createBeforeAfterNodeSetter(true, true),
	                setStartAfter: createBeforeAfterNodeSetter(false, true),
	                setEndBefore: createBeforeAfterNodeSetter(true, false),
	                setEndAfter: createBeforeAfterNodeSetter(false, false),
	
	                collapse: function(isStart) {
	                    assertRangeValid(this);
	                    if (isStart) {
	                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
	                    } else {
	                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
	                    }
	                },
	
	                selectNodeContents: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	
	                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
	                },
	
	                selectNode: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, false);
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	
	                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
	                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
	                },
	
	                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),
	
	                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),
	
	                canSurroundContents: function() {
	                    assertRangeValid(this);
	                    assertNodeNotReadOnly(this.startContainer);
	                    assertNodeNotReadOnly(this.endContainer);
	
	                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                    // no non-text nodes.
	                    var iterator = new RangeIterator(this, true);
	                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
	                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                    iterator.detach();
	                    return !boundariesInvalid;
	                },
	
	                splitBoundaries: function() {
	                    splitRangeBoundaries(this);
	                },
	
	                splitBoundariesPreservingPositions: function(positionsToPreserve) {
	                    splitRangeBoundaries(this, positionsToPreserve);
	                },
	
	                normalizeBoundaries: function() {
	                    assertRangeValid(this);
	
	                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
	
	                    var mergeForward = function(node) {
	                        var sibling = node.nextSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            ec = node;
	                            eo = node.length;
	                            node.appendData(sibling.data);
	                            removeNode(sibling);
	                        }
	                    };
	
	                    var mergeBackward = function(node) {
	                        var sibling = node.previousSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            sc = node;
	                            var nodeLength = node.length;
	                            so = sibling.length;
	                            node.insertData(0, sibling.data);
	                            removeNode(sibling);
	                            if (sc == ec) {
	                                eo += so;
	                                ec = sc;
	                            } else if (ec == node.parentNode) {
	                                var nodeIndex = getNodeIndex(node);
	                                if (eo == nodeIndex) {
	                                    ec = node;
	                                    eo = nodeLength;
	                                } else if (eo > nodeIndex) {
	                                    eo--;
	                                }
	                            }
	                        }
	                    };
	
	                    var normalizeStart = true;
	                    var sibling;
	
	                    if (isCharacterDataNode(ec)) {
	                        if (eo == ec.length) {
	                            mergeForward(ec);
	                        } else if (eo == 0) {
	                            sibling = ec.previousSibling;
	                            if (sibling && sibling.nodeType == ec.nodeType) {
	                                eo = sibling.length;
	                                if (sc == ec) {
	                                    normalizeStart = false;
	                                }
	                                sibling.appendData(ec.data);
	                                removeNode(ec);
	                                ec = sibling;
	                            }
	                        }
	                    } else {
	                        if (eo > 0) {
	                            var endNode = ec.childNodes[eo - 1];
	                            if (endNode && isCharacterDataNode(endNode)) {
	                                mergeForward(endNode);
	                            }
	                        }
	                        normalizeStart = !this.collapsed;
	                    }
	
	                    if (normalizeStart) {
	                        if (isCharacterDataNode(sc)) {
	                            if (so == 0) {
	                                mergeBackward(sc);
	                            } else if (so == sc.length) {
	                                sibling = sc.nextSibling;
	                                if (sibling && sibling.nodeType == sc.nodeType) {
	                                    if (ec == sibling) {
	                                        ec = sc;
	                                        eo += sc.length;
	                                    }
	                                    sc.appendData(sibling.data);
	                                    removeNode(sibling);
	                                }
	                            }
	                        } else {
	                            if (so < sc.childNodes.length) {
	                                var startNode = sc.childNodes[so];
	                                if (startNode && isCharacterDataNode(startNode)) {
	                                    mergeBackward(startNode);
	                                }
	                            }
	                        }
	                    } else {
	                        sc = ec;
	                        so = eo;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                collapseToPoint: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	                    this.setStartAndEnd(node, offset);
	                }
	            });
	
	            copyComparisonConstants(constructor);
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Updates commonAncestorContainer and collapsed after boundary change
	        function updateCollapsedAndCommonAncestor(range) {
	            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	            range.commonAncestorContainer = range.collapsed ?
	                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
	        }
	
	        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
	            range.startContainer = startContainer;
	            range.startOffset = startOffset;
	            range.endContainer = endContainer;
	            range.endOffset = endOffset;
	            range.document = dom.getDocument(startContainer);
	
	            updateCollapsedAndCommonAncestor(range);
	        }
	
	        function Range(doc) {
	            this.startContainer = doc;
	            this.startOffset = 0;
	            this.endContainer = doc;
	            this.endOffset = 0;
	            this.document = doc;
	            updateCollapsedAndCommonAncestor(this);
	        }
	
	        createPrototypeRange(Range, updateBoundaries);
	
	        util.extend(Range, {
	            rangeProperties: rangeProperties,
	            RangeIterator: RangeIterator,
	            copyComparisonConstants: copyComparisonConstants,
	            createPrototypeRange: createPrototypeRange,
	            inspect: inspect,
	            toHtml: rangeToHtml,
	            getRangeDocument: getRangeDocument,
	            rangesEqual: function(r1, r2) {
	                return r1.startContainer === r2.startContainer &&
	                    r1.startOffset === r2.startOffset &&
	                    r1.endContainer === r2.endContainer &&
	                    r1.endOffset === r2.endOffset;
	            }
	        });
	
	        api.DomRange = Range;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wrappers for the browser's native DOM Range and/or TextRange implementation
	    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
	        var WrappedRange, WrappedTextRange;
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DomRange = api.DomRange;
	        var getBody = dom.getBody;
	        var getContentDocument = dom.getContentDocument;
	        var isCharacterDataNode = dom.isCharacterDataNode;
	
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        if (api.features.implementsDomRange) {
	            // This is a wrapper around the browser's native DOM Range. It has two aims:
	            // - Provide workarounds for specific browser bugs
	            // - provide convenient extensions, which are inherited from Rangy's DomRange
	
	            (function() {
	                var rangeProto;
	                var rangeProperties = DomRange.rangeProperties;
	
	                function updateRangeProperties(range) {
	                    var i = rangeProperties.length, prop;
	                    while (i--) {
	                        prop = rangeProperties[i];
	                        range[prop] = range.nativeRange[prop];
	                    }
	                    // Fix for broken collapsed property in IE 9.
	                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	                }
	
	                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
	                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
	                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
	                    var nativeRangeDifferent = !range.equals(range.nativeRange);
	
	                    // Always set both boundaries for the benefit of IE9 (see issue 35)
	                    if (startMoved || endMoved || nativeRangeDifferent) {
	                        range.setEnd(endContainer, endOffset);
	                        range.setStart(startContainer, startOffset);
	                    }
	                }
	
	                var createBeforeAfterNodeSetter;
	
	                WrappedRange = function(range) {
	                    if (!range) {
	                        throw module.createError("WrappedRange: Range must be specified");
	                    }
	                    this.nativeRange = range;
	                    updateRangeProperties(this);
	                };
	
	                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);
	
	                rangeProto = WrappedRange.prototype;
	
	                rangeProto.selectNode = function(node) {
	                    this.nativeRange.selectNode(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneContents = function() {
	                    return this.nativeRange.cloneContents();
	                };
	
	                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	                // insertNode() is never delegated to the native range.
	
	                rangeProto.surroundContents = function(node) {
	                    this.nativeRange.surroundContents(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.collapse = function(isStart) {
	                    this.nativeRange.collapse(isStart);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneRange = function() {
	                    return new WrappedRange(this.nativeRange.cloneRange());
	                };
	
	                rangeProto.refresh = function() {
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.toString = function() {
	                    return this.nativeRange.toString();
	                };
	
	                // Create test range and node for feature detection
	
	                var testTextNode = document.createTextNode("test");
	                getBody(document).appendChild(testTextNode);
	                var range = document.createRange();
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	                // correct for it
	
	                range.setStart(testTextNode, 0);
	                range.setEnd(testTextNode, 0);
	
	                try {
	                    range.setStart(testTextNode, 1);
	
	                    rangeProto.setStart = function(node, offset) {
	                        this.nativeRange.setStart(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        this.nativeRange.setEnd(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name) {
	                        return function(node) {
	                            this.nativeRange[name](node);
	                            updateRangeProperties(this);
	                        };
	                    };
	
	                } catch(ex) {
	
	                    rangeProto.setStart = function(node, offset) {
	                        try {
	                            this.nativeRange.setStart(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setEnd(node, offset);
	                            this.nativeRange.setStart(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        try {
	                            this.nativeRange.setEnd(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setStart(node, offset);
	                            this.nativeRange.setEnd(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name, oppositeName) {
	                        return function(node) {
	                            try {
	                                this.nativeRange[name](node);
	                            } catch (ex) {
	                                this.nativeRange[oppositeName](node);
	                                this.nativeRange[name](node);
	                            }
	                            updateRangeProperties(this);
	                        };
	                    };
	                }
	
	                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
	                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
	                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
	                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	                // whether the native implementation can be trusted
	                rangeProto.selectNodeContents = function(node) {
	                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
	                };
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	
	                range.selectNodeContents(testTextNode);
	                range.setEnd(testTextNode, 3);
	
	                var range2 = document.createRange();
	                range2.selectNodeContents(testTextNode);
	                range2.setEnd(testTextNode, 4);
	                range2.setStart(testTextNode, 2);
	
	                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
	                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
	                    // This is the wrong way round, so correct for it
	
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        range = range.nativeRange || range;
	                        if (type == range.START_TO_END) {
	                            type = range.END_TO_START;
	                        } else if (type == range.END_TO_START) {
	                            type = range.START_TO_END;
	                        }
	                        return this.nativeRange.compareBoundaryPoints(type, range);
	                    };
	                } else {
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	
	                var el = document.createElement("div");
	                el.innerHTML = "123";
	                var textNode = el.firstChild;
	                var body = getBody(document);
	                body.appendChild(el);
	
	                range.setStart(textNode, 1);
	                range.setEnd(textNode, 2);
	                range.deleteContents();
	
	                if (textNode.data == "13") {
	                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	                    // extractContents()
	                    rangeProto.deleteContents = function() {
	                        this.nativeRange.deleteContents();
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.extractContents = function() {
	                        var frag = this.nativeRange.extractContents();
	                        updateRangeProperties(this);
	                        return frag;
	                    };
	                } else {
	                }
	
	                body.removeChild(el);
	                body = null;
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for existence of createContextualFragment and delegate to it if it exists
	                if (util.isHostMethod(range, "createContextualFragment")) {
	                    rangeProto.createContextualFragment = function(fragmentStr) {
	                        return this.nativeRange.createContextualFragment(fragmentStr);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Clean up
	                getBody(document).removeChild(testTextNode);
	
	                rangeProto.getName = function() {
	                    return "WrappedRange";
	                };
	
	                api.WrappedRange = WrappedRange;
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return doc.createRange();
	                };
	            })();
	        }
	
	        if (api.features.implementsTextRange) {
	            /*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	
	            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	
	            var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	
	            This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */
	            var getTextRangeContainerElement = function(textRange) {
	                var parentEl = textRange.parentElement();
	                var range = textRange.duplicate();
	                range.collapse(true);
	                var startEl = range.parentElement();
	                range = textRange.duplicate();
	                range.collapse(false);
	                var endEl = range.parentElement();
	                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);
	
	                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
	            };
	
	            var textRangeIsCollapsed = function(textRange) {
	                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
	            };
	
	            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	            // bugs, handling for inputs and images, plus optimizations.
	            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
	                var workingRange = textRange.duplicate();
	                workingRange.collapse(isStart);
	                var containerElement = workingRange.parentElement();
	
	                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	                // check for that
	                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
	                    containerElement = wholeRangeContainerElement;
	                }
	
	
	                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	                if (!containerElement.canHaveHTML) {
	                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
	                    return {
	                        boundaryPosition: pos,
	                        nodeInfo: {
	                            nodeIndex: pos.offset,
	                            containerElement: pos.node
	                        }
	                    };
	                }
	
	                var workingNode = dom.getDocument(containerElement).createElement("span");
	
	                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	                if (workingNode.parentNode) {
	                    dom.removeNode(workingNode);
	                }
	
	                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
	                var previousNode, nextNode, boundaryPosition, boundaryNode;
	                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
	                var childNodeCount = containerElement.childNodes.length;
	                var end = childNodeCount;
	
	                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
	                // after the range boundary.
	                var nodeIndex = end;
	
	                while (true) {
	                    if (nodeIndex == childNodeCount) {
	                        containerElement.appendChild(workingNode);
	                    } else {
	                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
	                    }
	                    workingRange.moveToElementText(workingNode);
	                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
	                    if (comparison == 0 || start == end) {
	                        break;
	                    } else if (comparison == -1) {
	                        if (end == start + 1) {
	                            // We know the endth child node is after the range boundary, so we must be done.
	                            break;
	                        } else {
	                            start = nodeIndex;
	                        }
	                    } else {
	                        end = (end == start + 1) ? start : nodeIndex;
	                    }
	                    nodeIndex = Math.floor((start + end) / 2);
	                    containerElement.removeChild(workingNode);
	                }
	
	
	                // We've now reached or gone past the boundary of the text range we're interested in
	                // so have identified the node we want
	                boundaryNode = workingNode.nextSibling;
	
	                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
	                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	                    // the node containing the text range's boundary, so we move the end of the working range to the
	                    // boundary point and measure the length of its text to get the boundary's offset within the node.
	                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);
	
	                    var offset;
	
	                    if (/[\r\n]/.test(boundaryNode.data)) {
	                        /*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	
	                        - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	
	                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	
	                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	
	                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */
	                        var tempRange = workingRange.duplicate();
	                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;
	
	                        offset = tempRange.moveStart("character", rangeLength);
	                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
	                            offset++;
	                            tempRange.moveStart("character", 1);
	                        }
	                    } else {
	                        offset = workingRange.text.length;
	                    }
	                    boundaryPosition = new DomPosition(boundaryNode, offset);
	                } else {
	
	                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
	                    // a position within that, and likewise for a start boundary preceding a character data node
	                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
	                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
	                    if (nextNode && isCharacterDataNode(nextNode)) {
	                        boundaryPosition = new DomPosition(nextNode, 0);
	                    } else if (previousNode && isCharacterDataNode(previousNode)) {
	                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
	                    } else {
	                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
	                    }
	                }
	
	                // Clean up
	                dom.removeNode(workingNode);
	
	                return {
	                    boundaryPosition: boundaryPosition,
	                    nodeInfo: {
	                        nodeIndex: nodeIndex,
	                        containerElement: containerElement
	                    }
	                };
	            };
	
	            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	            // (http://code.google.com/p/ierange/)
	            var createBoundaryTextRange = function(boundaryPosition, isStart) {
	                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
	                var doc = dom.getDocument(boundaryPosition.node);
	                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
	                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);
	
	                if (nodeIsDataNode) {
	                    boundaryNode = boundaryPosition.node;
	                    boundaryParent = boundaryNode.parentNode;
	                } else {
	                    childNodes = boundaryPosition.node.childNodes;
	                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
	                    boundaryParent = boundaryPosition.node;
	                }
	
	                // Position the range immediately before the node containing the boundary
	                workingNode = doc.createElement("span");
	
	                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	                // the element rather than immediately before or after it
	                workingNode.innerHTML = "&#feff;";
	
	                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	                if (boundaryNode) {
	                    boundaryParent.insertBefore(workingNode, boundaryNode);
	                } else {
	                    boundaryParent.appendChild(workingNode);
	                }
	
	                workingRange.moveToElementText(workingNode);
	                workingRange.collapse(!isStart);
	
	                // Clean up
	                boundaryParent.removeChild(workingNode);
	
	                // Move the working range to the text offset, if required
	                if (nodeIsDataNode) {
	                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
	                }
	
	                return workingRange;
	            };
	
	            /*------------------------------------------------------------------------------------------------------------*/
	
	            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	            // prototype
	
	            WrappedTextRange = function(textRange) {
	                this.textRange = textRange;
	                this.refresh();
	            };
	
	            WrappedTextRange.prototype = new DomRange(document);
	
	            WrappedTextRange.prototype.refresh = function() {
	                var start, end, startBoundary;
	
	                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	                var rangeContainerElement = getTextRangeContainerElement(this.textRange);
	
	                if (textRangeIsCollapsed(this.textRange)) {
	                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
	                        true).boundaryPosition;
	                } else {
	                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
	                    start = startBoundary.boundaryPosition;
	
	                    // An optimization used here is that if the start and end boundaries have the same parent element, the
	                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
	                    // the start boundary
	                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
	                        startBoundary.nodeInfo).boundaryPosition;
	                }
	
	                this.setStart(start.node, start.offset);
	                this.setEnd(end.node, end.offset);
	            };
	
	            WrappedTextRange.prototype.getName = function() {
	                return "WrappedTextRange";
	            };
	
	            DomRange.copyComparisonConstants(WrappedTextRange);
	
	            var rangeToTextRange = function(range) {
	                if (range.collapsed) {
	                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                } else {
	                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
	                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
	                    textRange.setEndPoint("StartToStart", startRange);
	                    textRange.setEndPoint("EndToEnd", endRange);
	                    return textRange;
	                }
	            };
	
	            WrappedTextRange.rangeToTextRange = rangeToTextRange;
	
	            WrappedTextRange.prototype.toTextRange = function() {
	                return rangeToTextRange(this);
	            };
	
	            api.WrappedTextRange = WrappedTextRange;
	
	            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	            // implementation to use by default.
	            if (!api.features.implementsDomRange || api.config.preferTextRange) {
	                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	                var globalObj = (function(f) { return f("return this;")(); })(Function);
	                if (typeof globalObj.Range == "undefined") {
	                    globalObj.Range = WrappedTextRange;
	                }
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return getBody(doc).createTextRange();
	                };
	
	                api.WrappedRange = WrappedTextRange;
	            }
	        }
	
	        api.createRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRange");
	            return new api.WrappedRange(api.createNativeRange(doc));
	        };
	
	        api.createRangyRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRangyRange");
	            return new DomRange(doc);
	        };
	
	        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
	        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");
	
	        api.addShimListener(function(win) {
	            var doc = win.document;
	            if (typeof doc.createRange == "undefined") {
	                doc.createRange = function() {
	                    return api.createRange(doc);
	                };
	            }
	            doc = win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	    // in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
	    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
	        api.config.checkSelectionRanges = true;
	
	        var BOOLEAN = "boolean";
	        var NUMBER = "number";
	        var dom = api.dom;
	        var util = api.util;
	        var isHostMethod = util.isHostMethod;
	        var DomRange = api.DomRange;
	        var WrappedRange = api.WrappedRange;
	        var DOMException = api.DOMException;
	        var DomPosition = dom.DomPosition;
	        var getNativeSelection;
	        var selectionIsCollapsed;
	        var features = api.features;
	        var CONTROL = "Control";
	        var getDocument = dom.getDocument;
	        var getBody = dom.getBody;
	        var rangesEqual = DomRange.rangesEqual;
	
	
	        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	        // "forward" or "forwards") or a Boolean (true for backwards).
	        function isDirectionBackward(dir) {
	            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
	        }
	
	        function getWindow(win, methodName) {
	            if (!win) {
	                return window;
	            } else if (dom.isWindow(win)) {
	                return win;
	            } else if (win instanceof WrappedSelection) {
	                return win.win;
	            } else {
	                var doc = dom.getContentDocument(win, module, methodName);
	                return dom.getWindow(doc);
	            }
	        }
	
	        function getWinSelection(winParam) {
	            return getWindow(winParam, "getWinSelection").getSelection();
	        }
	
	        function getDocSelection(winParam) {
	            return getWindow(winParam, "getDocSelection").document.selection;
	        }
	
	        function winSelectionIsBackward(sel) {
	            var backward = false;
	            if (sel.anchorNode) {
	                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
	            }
	            return backward;
	        }
	
	        // Test for the Range/TextRange and Selection features required
	        // Test for ability to retrieve selection
	        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
	            implementsDocSelection = util.isHostObject(document, "selection");
	
	        features.implementsWinGetSelection = implementsWinGetSelection;
	        features.implementsDocSelection = implementsDocSelection;
	
	        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);
	
	        if (useDocumentSelection) {
	            getNativeSelection = getDocSelection;
	            api.isSelectionValid = function(winParam) {
	                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;
	
	                // Check whether the selection TextRange is actually contained within the correct document
	                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
	            };
	        } else if (implementsWinGetSelection) {
	            getNativeSelection = getWinSelection;
	            api.isSelectionValid = function() {
	                return true;
	            };
	        } else {
	            module.fail("Neither document.selection or window.getSelection() detected.");
	            return false;
	        }
	
	        api.getNativeSelection = getNativeSelection;
	
	        var testSelection = getNativeSelection();
	
	        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
	        if (!testSelection) {
	            module.fail("Native selection was null (possibly issue 138?)");
	            return false;
	        }
	
	        var testRange = api.createNativeRange(document);
	        var body = getBody(document);
	
	        // Obtaining a range from a selection
	        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
	            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);
	
	        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;
	
	        // Test for existence of native selection extend() method
	        var selectionHasExtend = isHostMethod(testSelection, "extend");
	        features.selectionHasExtend = selectionHasExtend;
	
	        // Test if rangeCount exists
	        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
	        features.selectionHasRangeCount = selectionHasRangeCount;
	
	        var selectionSupportsMultipleRanges = false;
	        var collapsedNonEditableSelectionsSupported = true;
	
	        var addRangeBackwardToNative = selectionHasExtend ?
	            function(nativeSelection, range) {
	                var doc = DomRange.getRangeDocument(range);
	                var endRange = api.createRange(doc);
	                endRange.collapseToPoint(range.endContainer, range.endOffset);
	                nativeSelection.addRange(getNativeRange(endRange));
	                nativeSelection.extend(range.startContainer, range.startOffset);
	            } : null;
	
	        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
	                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {
	
	            (function() {
	                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	                // performed on the current document's selection. See issue 109.
	
	                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	                // will result in the selection direction begin reversed if the original selection was backwards and the
	                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	                var sel = window.getSelection();
	                if (sel) {
	                    // Store the current selection
	                    var originalSelectionRangeCount = sel.rangeCount;
	                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
	                    var originalSelectionRanges = [];
	                    var originalSelectionBackward = winSelectionIsBackward(sel);
	                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
	                        originalSelectionRanges[i] = sel.getRangeAt(i);
	                    }
	
	                    // Create some test elements
	                    var testEl = dom.createTestElement(document, "", false);
	                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );
	
	                    // Test whether the native selection will allow a collapsed selection within a non-editable element
	                    var r1 = document.createRange();
	
	                    r1.setStart(textNode, 1);
	                    r1.collapse(true);
	                    sel.removeAllRanges();
	                    sel.addRange(r1);
	                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
	                    sel.removeAllRanges();
	
	                    // Test whether the native selection is capable of supporting multiple ranges.
	                    if (!selectionHasMultipleRanges) {
	                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
	                        // sniff. I'm not happy about it. See
	                        // https://code.google.com/p/chromium/issues/detail?id=399791
	                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
	                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
	                            selectionSupportsMultipleRanges = false;
	                        } else {
	                            var r2 = r1.cloneRange();
	                            r1.setStart(textNode, 0);
	                            r2.setEnd(textNode, 3);
	                            r2.setStart(textNode, 2);
	                            sel.addRange(r1);
	                            sel.addRange(r2);
	                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
	                        }
	                    }
	
	                    // Clean up
	                    dom.removeNode(testEl);
	                    sel.removeAllRanges();
	
	                    for (i = 0; i < originalSelectionRangeCount; ++i) {
	                        if (i == 0 && originalSelectionBackward) {
	                            if (addRangeBackwardToNative) {
	                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
	                            } else {
	                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
	                                sel.addRange(originalSelectionRanges[i]);
	                            }
	                        } else {
	                            sel.addRange(originalSelectionRanges[i]);
	                        }
	                    }
	                }
	            })();
	        }
	
	        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
	        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;
	
	        // ControlRanges
	        var implementsControlRange = false, testControlRange;
	
	        if (body && isHostMethod(body, "createControlRange")) {
	            testControlRange = body.createControlRange();
	            if (util.areHostProperties(testControlRange, ["item", "add"])) {
	                implementsControlRange = true;
	            }
	        }
	        features.implementsControlRange = implementsControlRange;
	
	        // Selection collapsedness
	        if (selectionHasAnchorAndFocus) {
	            selectionIsCollapsed = function(sel) {
	                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
	            };
	        } else {
	            selectionIsCollapsed = function(sel) {
	                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
	            };
	        }
	
	        function updateAnchorAndFocusFromRange(sel, range, backward) {
	            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
	            sel.anchorNode = range[anchorPrefix + "Container"];
	            sel.anchorOffset = range[anchorPrefix + "Offset"];
	            sel.focusNode = range[focusPrefix + "Container"];
	            sel.focusOffset = range[focusPrefix + "Offset"];
	        }
	
	        function updateAnchorAndFocusFromNativeSelection(sel) {
	            var nativeSel = sel.nativeSelection;
	            sel.anchorNode = nativeSel.anchorNode;
	            sel.anchorOffset = nativeSel.anchorOffset;
	            sel.focusNode = nativeSel.focusNode;
	            sel.focusOffset = nativeSel.focusOffset;
	        }
	
	        function updateEmptySelection(sel) {
	            sel.anchorNode = sel.focusNode = null;
	            sel.anchorOffset = sel.focusOffset = 0;
	            sel.rangeCount = 0;
	            sel.isCollapsed = true;
	            sel._ranges.length = 0;
	        }
	
	        function getNativeRange(range) {
	            var nativeRange;
	            if (range instanceof DomRange) {
	                nativeRange = api.createNativeRange(range.getDocument());
	                nativeRange.setEnd(range.endContainer, range.endOffset);
	                nativeRange.setStart(range.startContainer, range.startOffset);
	            } else if (range instanceof WrappedRange) {
	                nativeRange = range.nativeRange;
	            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
	                nativeRange = range;
	            }
	            return nativeRange;
	        }
	
	        function rangeContainsSingleElement(rangeNodes) {
	            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
	                return false;
	            }
	            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
	                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function getSingleElementFromRange(range) {
	            var nodes = range.getNodes();
	            if (!rangeContainsSingleElement(nodes)) {
	                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
	            }
	            return nodes[0];
	        }
	
	        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	        function isTextRange(range) {
	            return !!range && typeof range.text != "undefined";
	        }
	
	        function updateFromTextRange(sel, range) {
	            // Create a Range from the selected TextRange
	            var wrappedRange = new WrappedRange(range);
	            sel._ranges = [wrappedRange];
	
	            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
	            sel.rangeCount = 1;
	            sel.isCollapsed = wrappedRange.collapsed;
	        }
	
	        function updateControlSelection(sel) {
	            // Update the wrapped selection based on what's now in the native selection
	            sel._ranges.length = 0;
	            if (sel.docSelection.type == "None") {
	                updateEmptySelection(sel);
	            } else {
	                var controlRange = sel.docSelection.createRange();
	                if (isTextRange(controlRange)) {
	                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
	                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	                    // ControlRange have been removed from the ControlRange and removed from the document.
	                    updateFromTextRange(sel, controlRange);
	                } else {
	                    sel.rangeCount = controlRange.length;
	                    var range, doc = getDocument(controlRange.item(0));
	                    for (var i = 0; i < sel.rangeCount; ++i) {
	                        range = api.createRange(doc);
	                        range.selectNode(controlRange.item(i));
	                        sel._ranges.push(range);
	                    }
	                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
	                }
	            }
	        }
	
	        function addRangeToControlSelection(sel, range) {
	            var controlRange = sel.docSelection.createRange();
	            var rangeElement = getSingleElementFromRange(range);
	
	            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	            // contained by the supplied range
	            var doc = getDocument(controlRange.item(0));
	            var newControlRange = getBody(doc).createControlRange();
	            for (var i = 0, len = controlRange.length; i < len; ++i) {
	                newControlRange.add(controlRange.item(i));
	            }
	            try {
	                newControlRange.add(rangeElement);
	            } catch (ex) {
	                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
	            }
	            newControlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        var getSelectionRangeAt;
	
	        if (isHostMethod(testSelection, "getRangeAt")) {
	            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	            // lesson to us all, especially me.
	            getSelectionRangeAt = function(sel, index) {
	                try {
	                    return sel.getRangeAt(index);
	                } catch (ex) {
	                    return null;
	                }
	            };
	        } else if (selectionHasAnchorAndFocus) {
	            getSelectionRangeAt = function(sel) {
	                var doc = getDocument(sel.anchorNode);
	                var range = api.createRange(doc);
	                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);
	
	                // Handle the case when the selection was selected backwards (from the end to the start in the
	                // document)
	                if (range.collapsed !== this.isCollapsed) {
	                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
	                }
	
	                return range;
	            };
	        }
	
	        function WrappedSelection(selection, docSelection, win) {
	            this.nativeSelection = selection;
	            this.docSelection = docSelection;
	            this._ranges = [];
	            this.win = win;
	            this.refresh();
	        }
	
	        WrappedSelection.prototype = api.selectionPrototype;
	
	        function deleteProperties(sel) {
	            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
	            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
	            sel.detached = true;
	        }
	
	        var cachedRangySelections = [];
	
	        function actOnCachedSelection(win, action) {
	            var i = cachedRangySelections.length, cached, sel;
	            while (i--) {
	                cached = cachedRangySelections[i];
	                sel = cached.selection;
	                if (action == "deleteAll") {
	                    deleteProperties(sel);
	                } else if (cached.win == win) {
	                    if (action == "delete") {
	                        cachedRangySelections.splice(i, 1);
	                        return true;
	                    } else {
	                        return sel;
	                    }
	                }
	            }
	            if (action == "deleteAll") {
	                cachedRangySelections.length = 0;
	            }
	            return null;
	        }
	
	        var getSelection = function(win) {
	            // Check if the parameter is a Rangy Selection object
	            if (win && win instanceof WrappedSelection) {
	                win.refresh();
	                return win;
	            }
	
	            win = getWindow(win, "getNativeSelection");
	
	            var sel = actOnCachedSelection(win);
	            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
	            if (sel) {
	                sel.nativeSelection = nativeSel;
	                sel.docSelection = docSel;
	                sel.refresh();
	            } else {
	                sel = new WrappedSelection(nativeSel, docSel, win);
	                cachedRangySelections.push( { win: win, selection: sel } );
	            }
	            return sel;
	        };
	
	        api.getSelection = getSelection;
	
	        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");
	
	        var selProto = WrappedSelection.prototype;
	
	        function createControlSelection(sel, ranges) {
	            // Ensure that the selection becomes of type "Control"
	            var doc = getDocument(ranges[0].startContainer);
	            var controlRange = getBody(doc).createControlRange();
	            for (var i = 0, el, len = ranges.length; i < len; ++i) {
	                el = getSingleElementFromRange(ranges[i]);
	                try {
	                    controlRange.add(el);
	                } catch (ex) {
	                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
	                }
	            }
	            controlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        // Selecting a range
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
	            selProto.removeAllRanges = function() {
	                this.nativeSelection.removeAllRanges();
	                updateEmptySelection(this);
	            };
	
	            var addRangeBackward = function(sel, range) {
	                addRangeBackwardToNative(sel.nativeSelection, range);
	                sel.refresh();
	            };
	
	            if (selectionHasRangeCount) {
	                selProto.addRange = function(range, direction) {
	                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                        addRangeToControlSelection(this, range);
	                    } else {
	                        if (isDirectionBackward(direction) && selectionHasExtend) {
	                            addRangeBackward(this, range);
	                        } else {
	                            var previousRangeCount;
	                            if (selectionSupportsMultipleRanges) {
	                                previousRangeCount = this.rangeCount;
	                            } else {
	                                this.removeAllRanges();
	                                previousRangeCount = 0;
	                            }
	                            // Clone the native range so that changing the selected range does not affect the selection.
	                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
	                            // issue 80.
	                            var clonedNativeRange = getNativeRange(range).cloneRange();
	                            try {
	                                this.nativeSelection.addRange(clonedNativeRange);
	                            } catch (ex) {
	                            }
	
	                            // Check whether adding the range was successful
	                            this.rangeCount = this.nativeSelection.rangeCount;
	
	                            if (this.rangeCount == previousRangeCount + 1) {
	                                // The range was added successfully
	
	                                // Check whether the range that we added to the selection is reflected in the last range extracted from
	                                // the selection
	                                if (api.config.checkSelectionRanges) {
	                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
	                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
	                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
	                                        range = new WrappedRange(nativeRange);
	                                    }
	                                }
	                                this._ranges[this.rangeCount - 1] = range;
	                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
	                                this.isCollapsed = selectionIsCollapsed(this);
	                            } else {
	                                // The range was not added successfully. The simplest thing is to refresh
	                                this.refresh();
	                            }
	                        }
	                    }
	                };
	            } else {
	                selProto.addRange = function(range, direction) {
	                    if (isDirectionBackward(direction) && selectionHasExtend) {
	                        addRangeBackward(this, range);
	                    } else {
	                        this.nativeSelection.addRange(getNativeRange(range));
	                        this.refresh();
	                    }
	                };
	            }
	
	            selProto.setRanges = function(ranges) {
	                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
	                    createControlSelection(this, ranges);
	                } else {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        this.addRange(ranges[i]);
	                    }
	                }
	            };
	        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
	                   implementsControlRange && useDocumentSelection) {
	
	            selProto.removeAllRanges = function() {
	                // Added try/catch as fix for issue #21
	                try {
	                    this.docSelection.empty();
	
	                    // Check for empty() not working (issue #24)
	                    if (this.docSelection.type != "None") {
	                        // Work around failure to empty a control selection by instead selecting a TextRange and then
	                        // calling empty()
	                        var doc;
	                        if (this.anchorNode) {
	                            doc = getDocument(this.anchorNode);
	                        } else if (this.docSelection.type == CONTROL) {
	                            var controlRange = this.docSelection.createRange();
	                            if (controlRange.length) {
	                                doc = getDocument( controlRange.item(0) );
	                            }
	                        }
	                        if (doc) {
	                            var textRange = getBody(doc).createTextRange();
	                            textRange.select();
	                            this.docSelection.empty();
	                        }
	                    }
	                } catch(ex) {}
	                updateEmptySelection(this);
	            };
	
	            selProto.addRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    addRangeToControlSelection(this, range);
	                } else {
	                    api.WrappedTextRange.rangeToTextRange(range).select();
	                    this._ranges[0] = range;
	                    this.rangeCount = 1;
	                    this.isCollapsed = this._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(this, range, false);
	                }
	            };
	
	            selProto.setRanges = function(ranges) {
	                this.removeAllRanges();
	                var rangeCount = ranges.length;
	                if (rangeCount > 1) {
	                    createControlSelection(this, ranges);
	                } else if (rangeCount) {
	                    this.addRange(ranges[0]);
	                }
	            };
	        } else {
	            module.fail("No means of selecting a Range or TextRange was found");
	            return false;
	        }
	
	        selProto.getRangeAt = function(index) {
	            if (index < 0 || index >= this.rangeCount) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            } else {
	                // Clone the range to preserve selection-range independence. See issue 80.
	                return this._ranges[index].cloneRange();
	            }
	        };
	
	        var refreshSelection;
	
	        if (useDocumentSelection) {
	            refreshSelection = function(sel) {
	                var range;
	                if (api.isSelectionValid(sel.win)) {
	                    range = sel.docSelection.createRange();
	                } else {
	                    range = getBody(sel.win.document).createTextRange();
	                    range.collapse(true);
	                }
	
	                if (sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else if (isTextRange(range)) {
	                    updateFromTextRange(sel, range);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
	            refreshSelection = function(sel) {
	                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else {
	                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
	                    if (sel.rangeCount) {
	                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
	                        }
	                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
	                        sel.isCollapsed = selectionIsCollapsed(sel);
	                    } else {
	                        updateEmptySelection(sel);
	                    }
	                }
	            };
	        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
	            refreshSelection = function(sel) {
	                var range, nativeSel = sel.nativeSelection;
	                if (nativeSel.anchorNode) {
	                    range = getSelectionRangeAt(nativeSel, 0);
	                    sel._ranges = [range];
	                    sel.rangeCount = 1;
	                    updateAnchorAndFocusFromNativeSelection(sel);
	                    sel.isCollapsed = selectionIsCollapsed(sel);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else {
	            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
	            return false;
	        }
	
	        selProto.refresh = function(checkForChanges) {
	            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
	            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;
	
	            refreshSelection(this);
	            if (checkForChanges) {
	                // Check the range count first
	                var i = oldRanges.length;
	                if (i != this._ranges.length) {
	                    return true;
	                }
	
	                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	                // ranges after this
	                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
	                    return true;
	                }
	
	                // Finally, compare each range in turn
	                while (i--) {
	                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        };
	
	        // Removal of a single range
	        var removeRangeManually = function(sel, range) {
	            var ranges = sel.getAllRanges();
	            sel.removeAllRanges();
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                if (!rangesEqual(range, ranges[i])) {
	                    sel.addRange(ranges[i]);
	                }
	            }
	            if (!sel.rangeCount) {
	                updateEmptySelection(sel);
	            }
	        };
	
	        if (implementsControlRange && implementsDocSelection) {
	            selProto.removeRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    var controlRange = this.docSelection.createRange();
	                    var rangeElement = getSingleElementFromRange(range);
	
	                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
	                    // element contained by the supplied range
	                    var doc = getDocument(controlRange.item(0));
	                    var newControlRange = getBody(doc).createControlRange();
	                    var el, removed = false;
	                    for (var i = 0, len = controlRange.length; i < len; ++i) {
	                        el = controlRange.item(i);
	                        if (el !== rangeElement || removed) {
	                            newControlRange.add(controlRange.item(i));
	                        } else {
	                            removed = true;
	                        }
	                    }
	                    newControlRange.select();
	
	                    // Update the wrapped selection based on what's now in the native selection
	                    updateControlSelection(this);
	                } else {
	                    removeRangeManually(this, range);
	                }
	            };
	        } else {
	            selProto.removeRange = function(range) {
	                removeRangeManually(this, range);
	            };
	        }
	
	        // Detecting if a selection is backward
	        var selectionIsBackward;
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
	            selectionIsBackward = winSelectionIsBackward;
	
	            selProto.isBackward = function() {
	                return selectionIsBackward(this);
	            };
	        } else {
	            selectionIsBackward = selProto.isBackward = function() {
	                return false;
	            };
	        }
	
	        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	        selProto.isBackwards = selProto.isBackward;
	
	        // Selection stringifier
	        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	        // The current spec does not yet define this method.
	        selProto.toString = function() {
	            var rangeTexts = [];
	            for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                rangeTexts[i] = "" + this._ranges[i];
	            }
	            return rangeTexts.join("");
	        };
	
	        function assertNodeInSameDocument(sel, node) {
	            if (sel.win.document != getDocument(node)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	        selProto.collapse = function(node, offset) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.collapseToPoint(node, offset);
	            this.setSingleRange(range);
	            this.isCollapsed = true;
	        };
	
	        selProto.collapseToStart = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[0];
	                this.collapse(range.startContainer, range.startOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        selProto.collapseToEnd = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[this.rangeCount - 1];
	                this.collapse(range.endContainer, range.endOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	        // specified so the native implementation is never used by Rangy.
	        selProto.selectAllChildren = function(node) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.selectNodeContents(node);
	            this.setSingleRange(range);
	        };
	
	        selProto.deleteFromDocument = function() {
	            // Sepcial behaviour required for IE's control selections
	            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                var controlRange = this.docSelection.createRange();
	                var element;
	                while (controlRange.length) {
	                    element = controlRange.item(0);
	                    controlRange.remove(element);
	                    dom.removeNode(element);
	                }
	                this.refresh();
	            } else if (this.rangeCount) {
	                var ranges = this.getAllRanges();
	                if (ranges.length) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        ranges[i].deleteContents();
	                    }
	                    // The spec says nothing about what the selection should contain after calling deleteContents on each
	                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
	                    this.addRange(ranges[len - 1]);
	                }
	            }
	        };
	
	        // The following are non-standard extensions
	        selProto.eachRange = function(func, returnValue) {
	            for (var i = 0, len = this._ranges.length; i < len; ++i) {
	                if ( func( this.getRangeAt(i) ) ) {
	                    return returnValue;
	                }
	            }
	        };
	
	        selProto.getAllRanges = function() {
	            var ranges = [];
	            this.eachRange(function(range) {
	                ranges.push(range);
	            });
	            return ranges;
	        };
	
	        selProto.setSingleRange = function(range, direction) {
	            this.removeAllRanges();
	            this.addRange(range, direction);
	        };
	
	        selProto.callMethodOnEachRange = function(methodName, params) {
	            var results = [];
	            this.eachRange( function(range) {
	                results.push( range[methodName].apply(range, params || []) );
	            } );
	            return results;
	        };
	
	        function createStartOrEndSetter(isStart) {
	            return function(node, offset) {
	                var range;
	                if (this.rangeCount) {
	                    range = this.getRangeAt(0);
	                    range["set" + (isStart ? "Start" : "End")](node, offset);
	                } else {
	                    range = api.createRange(this.win.document);
	                    range.setStartAndEnd(node, offset);
	                }
	                this.setSingleRange(range, this.isBackward());
	            };
	        }
	
	        selProto.setStart = createStartOrEndSetter(true);
	        selProto.setEnd = createStartOrEndSetter(false);
	
	        // Add select() method to Range prototype. Any existing selection will be removed.
	        api.rangePrototype.select = function(direction) {
	            getSelection( this.getDocument() ).setSingleRange(this, direction);
	        };
	
	        selProto.changeEachRange = function(func) {
	            var ranges = [];
	            var backward = this.isBackward();
	
	            this.eachRange(function(range) {
	                func(range);
	                ranges.push(range);
	            });
	
	            this.removeAllRanges();
	            if (backward && ranges.length == 1) {
	                this.addRange(ranges[0], "backward");
	            } else {
	                this.setRanges(ranges);
	            }
	        };
	
	        selProto.containsNode = function(node, allowPartial) {
	            return this.eachRange( function(range) {
	                return range.containsNode(node, allowPartial);
	            }, true ) || false;
	        };
	
	        selProto.getBookmark = function(containerNode) {
	            return {
	                backward: this.isBackward(),
	                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
	            };
	        };
	
	        selProto.moveToBookmark = function(bookmark) {
	            var selRanges = [];
	            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
	                range = api.createRange(this.win);
	                range.moveToBookmark(rangeBookmark);
	                selRanges.push(range);
	            }
	            if (bookmark.backward) {
	                this.setSingleRange(selRanges[0], "backward");
	            } else {
	                this.setRanges(selRanges);
	            }
	        };
	
	        selProto.saveRanges = function() {
	            return {
	                backward: this.isBackward(),
	                ranges: this.callMethodOnEachRange("cloneRange")
	            };
	        };
	
	        selProto.restoreRanges = function(selRanges) {
	            this.removeAllRanges();
	            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
	                this.addRange(range, (selRanges.backward && i == 0));
	            }
	        };
	
	        selProto.toHtml = function() {
	            var rangeHtmls = [];
	            this.eachRange(function(range) {
	                rangeHtmls.push( DomRange.toHtml(range) );
	            });
	            return rangeHtmls.join("");
	        };
	
	        if (features.implementsTextRange) {
	            selProto.getNativeTextRange = function() {
	                var sel, textRange;
	                if ( (sel = this.docSelection) ) {
	                    var range = sel.createRange();
	                    if (isTextRange(range)) {
	                        return range;
	                    } else {
	                        throw module.createError("getNativeTextRange: selection is a control selection");
	                    }
	                } else if (this.rangeCount > 0) {
	                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
	                } else {
	                    throw module.createError("getNativeTextRange: selection contains no range");
	                }
	            };
	        }
	
	        function inspect(sel) {
	            var rangeInspects = [];
	            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
	            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
	            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";
	
	            if (typeof sel.rangeCount != "undefined") {
	                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
	                }
	            }
	            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
	                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
	        }
	
	        selProto.getName = function() {
	            return "WrappedSelection";
	        };
	
	        selProto.inspect = function() {
	            return inspect(this);
	        };
	
	        selProto.detach = function() {
	            actOnCachedSelection(this.win, "delete");
	            deleteProperties(this);
	        };
	
	        WrappedSelection.detachAll = function() {
	            actOnCachedSelection(null, "deleteAll");
	        };
	
	        WrappedSelection.inspect = inspect;
	        WrappedSelection.isDirectionBackward = isDirectionBackward;
	
	        api.Selection = WrappedSelection;
	
	        api.selectionPrototype = selProto;
	
	        api.addShimListener(function(win) {
	            if (typeof win.getSelection == "undefined") {
	                win.getSelection = function() {
	                    return getSelection(win);
	                };
	            }
	            win = null;
	        });
	    });
	    
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wait for document to load before initializing
	    var docReady = false;
	
	    var loadHandler = function(e) {
	        if (!docReady) {
	            docReady = true;
	            if (!api.initialized && api.config.autoInitialize) {
	                init();
	            }
	        }
	    };
	
	    if (isBrowser) {
	        // Test whether the document has already been loaded and initialize immediately if so
	        if (document.readyState == "complete") {
	            loadHandler();
	        } else {
	            if (isHostMethod(document, "addEventListener")) {
	                document.addEventListener("DOMContentLoaded", loadHandler, false);
	            }
	
	            // Add a fallback in case the DOMContentLoaded event isn't supported
	            addListener(window, "load", loadHandler);
	        }
	    }
	
	    return api;
	}, this);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Selection save and restore module for Rangy.
	 * Saves and restores user selections using marker invisible elements in the DOM.
	 *
	 * Part of Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Depends on Rangy core.
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module with a dependency on Rangy.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory( require("rangy") );
	    } else {
	        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
	        factory(root.rangy);
	    }
	})(function(rangy) {
	    rangy.createModule("SaveRestore", ["WrappedRange"], function(api, module) {
	        var dom = api.dom;
	        var removeNode = dom.removeNode;
	        var isDirectionBackward = api.Selection.isDirectionBackward;
	        var markerTextChar = "\ufeff";
	
	        function gEBI(id, doc) {
	            return (doc || document).getElementById(id);
	        }
	
	        function insertRangeBoundaryMarker(range, atStart) {
	            var markerId = "selectionBoundary_" + (+new Date()) + "_" + ("" + Math.random()).slice(2);
	            var markerEl;
	            var doc = dom.getDocument(range.startContainer);
	
	            // Clone the Range and collapse to the appropriate boundary point
	            var boundaryRange = range.cloneRange();
	            boundaryRange.collapse(atStart);
	
	            // Create the marker element containing a single invisible character using DOM methods and insert it
	            markerEl = doc.createElement("span");
	            markerEl.id = markerId;
	            markerEl.style.lineHeight = "0";
	            markerEl.style.display = "none";
	            markerEl.className = "rangySelectionBoundary";
	            markerEl.appendChild(doc.createTextNode(markerTextChar));
	
	            boundaryRange.insertNode(markerEl);
	            return markerEl;
	        }
	
	        function setRangeBoundary(doc, range, markerId, atStart) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                range[atStart ? "setStartBefore" : "setEndBefore"](markerEl);
	                removeNode(markerEl);
	            } else {
	                module.warn("Marker element has been removed. Cannot restore selection.");
	            }
	        }
	
	        function compareRanges(r1, r2) {
	            return r2.compareBoundaryPoints(r1.START_TO_START, r1);
	        }
	
	        function saveRange(range, direction) {
	            var startEl, endEl, doc = api.DomRange.getRangeDocument(range), text = range.toString();
	            var backward = isDirectionBackward(direction);
	
	            if (range.collapsed) {
	                endEl = insertRangeBoundaryMarker(range, false);
	                return {
	                    document: doc,
	                    markerId: endEl.id,
	                    collapsed: true
	                };
	            } else {
	                endEl = insertRangeBoundaryMarker(range, false);
	                startEl = insertRangeBoundaryMarker(range, true);
	
	                return {
	                    document: doc,
	                    startMarkerId: startEl.id,
	                    endMarkerId: endEl.id,
	                    collapsed: false,
	                    backward: backward,
	                    toString: function() {
	                        return "original text: '" + text + "', new text: '" + range.toString() + "'";
	                    }
	                };
	            }
	        }
	
	        function restoreRange(rangeInfo, normalize) {
	            var doc = rangeInfo.document;
	            if (typeof normalize == "undefined") {
	                normalize = true;
	            }
	            var range = api.createRange(doc);
	            if (rangeInfo.collapsed) {
	                var markerEl = gEBI(rangeInfo.markerId, doc);
	                if (markerEl) {
	                    markerEl.style.display = "inline";
	                    var previousNode = markerEl.previousSibling;
	
	                    // Workaround for issue 17
	                    if (previousNode && previousNode.nodeType == 3) {
	                        removeNode(markerEl);
	                        range.collapseToPoint(previousNode, previousNode.length);
	                    } else {
	                        range.collapseBefore(markerEl);
	                        removeNode(markerEl);
	                    }
	                } else {
	                    module.warn("Marker element has been removed. Cannot restore selection.");
	                }
	            } else {
	                setRangeBoundary(doc, range, rangeInfo.startMarkerId, true);
	                setRangeBoundary(doc, range, rangeInfo.endMarkerId, false);
	            }
	
	            if (normalize) {
	                range.normalizeBoundaries();
	            }
	
	            return range;
	        }
	
	        function saveRanges(ranges, direction) {
	            var rangeInfos = [], range, doc;
	            var backward = isDirectionBackward(direction);
	
	            // Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched
	            ranges = ranges.slice(0);
	            ranges.sort(compareRanges);
	
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                rangeInfos[i] = saveRange(ranges[i], backward);
	            }
	
	            // Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie
	            // between its markers
	            for (i = len - 1; i >= 0; --i) {
	                range = ranges[i];
	                doc = api.DomRange.getRangeDocument(range);
	                if (range.collapsed) {
	                    range.collapseAfter(gEBI(rangeInfos[i].markerId, doc));
	                } else {
	                    range.setEndBefore(gEBI(rangeInfos[i].endMarkerId, doc));
	                    range.setStartAfter(gEBI(rangeInfos[i].startMarkerId, doc));
	                }
	            }
	
	            return rangeInfos;
	        }
	
	        function saveSelection(win) {
	            if (!api.isSelectionValid(win)) {
	                module.warn("Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.");
	                return null;
	            }
	            var sel = api.getSelection(win);
	            var ranges = sel.getAllRanges();
	            var backward = (ranges.length == 1 && sel.isBackward());
	
	            var rangeInfos = saveRanges(ranges, backward);
	
	            // Ensure current selection is unaffected
	            if (backward) {
	                sel.setSingleRange(ranges[0], backward);
	            } else {
	                sel.setRanges(ranges);
	            }
	
	            return {
	                win: win,
	                rangeInfos: rangeInfos,
	                restored: false
	            };
	        }
	
	        function restoreRanges(rangeInfos) {
	            var ranges = [];
	
	            // Ranges are in reverse order of appearance in the DOM. We want to restore earliest first to avoid
	            // normalization affecting previously restored ranges.
	            var rangeCount = rangeInfos.length;
	
	            for (var i = rangeCount - 1; i >= 0; i--) {
	                ranges[i] = restoreRange(rangeInfos[i], true);
	            }
	
	            return ranges;
	        }
	
	        function restoreSelection(savedSelection, preserveDirection) {
	            if (!savedSelection.restored) {
	                var rangeInfos = savedSelection.rangeInfos;
	                var sel = api.getSelection(savedSelection.win);
	                var ranges = restoreRanges(rangeInfos), rangeCount = rangeInfos.length;
	
	                if (rangeCount == 1 && preserveDirection && api.features.selectionHasExtend && rangeInfos[0].backward) {
	                    sel.removeAllRanges();
	                    sel.addRange(ranges[0], true);
	                } else {
	                    sel.setRanges(ranges);
	                }
	
	                savedSelection.restored = true;
	            }
	        }
	
	        function removeMarkerElement(doc, markerId) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                removeNode(markerEl);
	            }
	        }
	
	        function removeMarkers(savedSelection) {
	            var rangeInfos = savedSelection.rangeInfos;
	            for (var i = 0, len = rangeInfos.length, rangeInfo; i < len; ++i) {
	                rangeInfo = rangeInfos[i];
	                if (rangeInfo.collapsed) {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.markerId);
	                } else {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.startMarkerId);
	                    removeMarkerElement(savedSelection.doc, rangeInfo.endMarkerId);
	                }
	            }
	        }
	
	        api.util.extend(api, {
	            saveRange: saveRange,
	            restoreRange: restoreRange,
	            saveRanges: saveRanges,
	            restoreRanges: restoreRanges,
	            saveSelection: saveSelection,
	            restoreSelection: restoreSelection,
	            removeMarkerElement: removeMarkerElement,
	            removeMarkers: removeMarkers
	        });
	    });
	    
	    return rangy;
	}, this);

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.10
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function $SanitizeProvider() {
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    return function(html) {
	      if (typeof arguments[1] != 'undefined') {
	        arguments[1].version = 'taSanitize';
	      }
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var START_TAG_REGEXP =
	       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	  BEGIN_TAG_REGEXP = /^</,
	  BEGING_END_TAGE_REGEXP = /^<\//,
	  COMMENT_REGEXP = /<!--(.*?)-->/g,
	  SINGLE_COMMENT_REGEXP = /(^<!--.*?-->)/,
	  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g,
	  WHITE_SPACE_REGEXP = /^(\s+)/;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = makeMap("area,br,col,hr,img,wbr,input");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = makeMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	var svgElements = makeMap("animate,animateColor,animateMotion,animateTransform,circle,defs," +
	        "desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient," +
	        "line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set," +
	        "stop,svg,switch,text,title,tspan,use");
	
	// Special Elements (can contain anything)
	var specialElements = makeMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements,
	                                   svgElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");
	
	var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,'+
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,'+
	    'id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,'+
	    'scope,scrolling,shape,size,span,start,summary,target,title,type,'+
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,' +
	    'color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,' +
	    'font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,' +
	    'gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,' +
	    'keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,' +
	    'markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,' +
	    'overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,' +
	    'repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,' +
	    'stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,' +
	    'stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,' +
	    'stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,' +
	    'underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,' +
	    'viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,' +
	    'xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,' +
	    'zoomAndPan');
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) obj[items[i]] = true;
	  return obj;
	}
	
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (typeof html !== 'string') {
	    if (html === null || typeof html === 'undefined') {
	      html = '';
	    } else {
	      html = '' + html;
	    }
	  }
	  var index, chars, match, stack = [], last = html, text;
	  stack.last = function() { return stack[ stack.length - 1 ]; };
	
	  while (html) {
	    text = '';
	    chars = true;
	
	    // Make sure we're not in a script or style element
	    if (!stack.last() || !specialElements[ stack.last() ]) {
	
	      // White space
	      if (WHITE_SPACE_REGEXP.test(html)) {
	        match = html.match(WHITE_SPACE_REGEXP);
	
	        if (match) {
	          var mat = match[0];
	          if (handler.whitespace) handler.whitespace(match[0]);
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      //Comment
	      } else if (SINGLE_COMMENT_REGEXP.test(html)) {
	        match = html.match(SINGLE_COMMENT_REGEXP);
	
	        if (match) {
	          if (handler.comment) handler.comment(match[1]);
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // DOCTYPE
	      } else if (DOCTYPE_REGEXP.test(html)) {
	        match = html.match(DOCTYPE_REGEXP);
	
	        if (match) {
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // end tag
	      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
	        match = html.match(END_TAG_REGEXP);
	
	        if (match) {
	          html = html.substring(match[0].length);
	          match[0].replace(END_TAG_REGEXP, parseEndTag);
	          chars = false;
	        }
	
	      // start tag
	      } else if (BEGIN_TAG_REGEXP.test(html)) {
	        match = html.match(START_TAG_REGEXP);
	
	        if (match) {
	          // We only have a valid start-tag if there is a '>'.
	          if (match[4]) {
	            html = html.substring(match[0].length);
	            match[0].replace(START_TAG_REGEXP, parseStartTag);
	          }
	          chars = false;
	        } else {
	          // no ending tag found --- this piece should be encoded as an entity.
	          text += '<';
	          html = html.substring(1);
	        }
	      }
	
	      if (chars) {
	        index = html.indexOf("<");
	
	        text += index < 0 ? html : html.substring(0, index);
	        html = index < 0 ? "" : html.substring(index);
	
	        if (handler.chars) handler.chars(decodeEntities(text));
	      }
	
	    } else {
	      html = html.replace(new RegExp("([^]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
	        function(all, text) {
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	
	          return "";
	      });
	
	      parseEndTag("", stack.last());
	    }
	
	    if (html == last) {
	      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
	                                        "of html: {0}", html);
	    }
	    last = html;
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function parseStartTag(tag, tagName, rest, unary) {
	    tagName = angular.lowercase(tagName);
	    if (blockElements[ tagName ]) {
	      while (stack.last() && inlineElements[ stack.last() ]) {
	        parseEndTag("", stack.last());
	      }
	    }
	
	    if (optionalEndTagElements[ tagName ] && stack.last() == tagName) {
	      parseEndTag("", tagName);
	    }
	
	    unary = voidElements[ tagName ] || !!unary;
	
	    if (!unary)
	      stack.push(tagName);
	
	    var attrs = {};
	
	    rest.replace(ATTR_REGEXP,
	      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue
	          || singleQuotedValue
	          || unquotedValue
	          || '';
	
	        attrs[name] = decodeEntities(value);
	    });
	    if (handler.start) handler.start(tagName, attrs, unary);
	  }
	
	  function parseEndTag(tag, tagName) {
	    var pos = 0, i;
	    tagName = angular.lowercase(tagName);
	    if (tagName)
	      // Find the closest opened tag of the same type
	      for (pos = stack.length - 1; pos >= 0; pos--)
	        if (stack[ pos ] == tagName)
	          break;
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (i = stack.length - 1; i >= pos; i--)
	        if (handler.end) handler.end(stack[ i ]);
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	    }
	  }
	}
	
	var hiddenPre=document.createElement("pre");
	var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;
	/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function decodeEntities(value) {
	  if (!value) { return ''; }
	
	  // Note: IE8 does not preserve spaces at the start/end of innerHTML
	  // so we must capture them and reattach them afterward
	  var parts = spaceRe.exec(value);
	  var spaceBefore = parts[1];
	  var spaceAfter = parts[3];
	  var content = parts[2];
	  if (content) {
	    hiddenPre.innerHTML=content.replace(/</g,"&lt;");
	    // innerText depends on styling as it doesn't display hidden elements.
	    // Therefore, it's better to use textContent not to cause unnecessary
	    // reflows. However, IE<9 don't support textContent so the innerText
	    // fallback is necessary.
	    content = 'textContent' in hiddenPre ?
	      hiddenPre.textContent : hiddenPre.innerText;
	  }
	  return spaceBefore + content + spaceAfter;
	}
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      // unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
	      // decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
	      var c = value.charCodeAt(0);
	      // if unsafe character encode
	      if(c <= 159 ||
	        c == 173 ||
	        (c >= 1536 && c <= 1540) ||
	        c == 1807 ||
	        c == 6068 ||
	        c == 6069 ||
	        (c >= 8204 && c <= 8207) ||
	        (c >= 8232 && c <= 8239) ||
	        (c >= 8288 && c <= 8303) ||
	        c == 65279 ||
	        (c >= 65520 && c <= 65535)) return '&#' + c + ';';
	      return value; // avoids multilingual issues
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	var trim = (function() {
	  // native trim is way faster: http://jsperf.com/angular-trim-test
	  // but IE doesn't have it... :-(
	  // TODO: we should move this into IE/ES5 polyfill
	  if (!String.prototype.trim) {
	    return function(value) {
	      return angular.isString(value) ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value;
	    };
	  }
	  return function(value) {
	    return angular.isString(value) ? value.trim() : value;
	  };
	})();
	
	// Custom logic for accepting certain style options only - textAngular
	// Currently allows only the color, background-color, text-align, float, width and height attributes
	// all other attributes should be easily done through classes.
	function validStyles(styleAttr){
		var result = '';
		var styleArray = styleAttr.split(';');
		angular.forEach(styleArray, function(value){
			var v = value.split(':');
			if(v.length == 2){
				var key = trim(angular.lowercase(v[0]));
				var value = trim(angular.lowercase(v[1]));
				if(
					(key === 'color' || key === 'background-color') && (
						value.match(/^rgb\([0-9%,\. ]*\)$/i)
						|| value.match(/^rgba\([0-9%,\. ]*\)$/i)
						|| value.match(/^hsl\([0-9%,\. ]*\)$/i)
						|| value.match(/^hsla\([0-9%,\. ]*\)$/i)
						|| value.match(/^#[0-9a-f]{3,6}$/i)
						|| value.match(/^[a-z]*$/i)
					)
				||
					key === 'text-align' && (
						value === 'left'
						|| value === 'right'
						|| value === 'center'
						|| value === 'justify'
					)
				||
	        key === 'text-decoration' && (
	            value === 'underline'
	            || value === 'line-through'
	        )
	      || 
	        key === 'font-weight' && (
	            value === 'bold'
	        )
	      ||
	        key === 'font-style' && (
	          value === 'italic'
	        )
	      ||
	        key === 'float' && (
	            value === 'left'
	            || value === 'right'
	            || value === 'none'
	        )
	      ||
	        key === 'vertical-align' && (
	            value === 'baseline'
	            || value === 'sub'
	            || value === 'super'
	            || value === 'test-top'
	            || value === 'text-bottom'
	            || value === 'middle'
	            || value === 'top'
	            || value === 'bottom'
	            || value.match(/[0-9]*(px|em)/)
	            || value.match(/[0-9]+?%/)
	        )
	      ||
	        key === 'font-size' && (
	            value === 'xx-small'
	            || value === 'x-small'
	            || value === 'small'
	            || value === 'medium'
	            || value === 'large'
	            || value === 'x-large'
	            || value === 'xx-large'
	            || value === 'larger'
	            || value === 'smaller'
	            || value.match(/[0-9]*\.?[0-9]*(px|em|rem|mm|q|cm|in|pt|pc|%)/)
	                               )
				||
					(key === 'width' || key === 'height') && (
						value.match(/[0-9\.]*(px|em|rem|%)/)
					)
				|| // Reference #520
					(key === 'direction' && value.match(/^ltr|rtl|initial|inherit$/))
				) result += key + ': ' + value + ';';
			}
		});
		return result;
	}
	
	// this function is used to manually allow specific attributes on specific tags with certain prerequisites
	function validCustomTag(tag, attrs, lkey, value){
		// catch the div placeholder for the iframe replacement
	    if (tag === 'img' && attrs['ta-insert-video']){
	        if(lkey === 'ta-insert-video' || lkey === 'allowfullscreen' || lkey === 'frameborder' || (lkey === 'contenteditable' && value === 'false')) return true;
	    }
	    return false;
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignore = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs, unary) {
	      tag = angular.lowercase(tag);
	      if (!ignore && specialElements[tag]) {
	        ignore = tag;
	      }
	      if (!ignore && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage=(tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if ((lkey === 'style' && (value = validStyles(value)) !== '') || validCustomTag(tag, attrs, lkey, value) || validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out(unary ? '/>' : '>');
	      }
	    },
	    comment: function (com) {
	      out(com);
	    },
	    whitespace: function (ws) {
	      out(encodeEntities(ws));
	    },
	    end: function(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	    chars: function(chars) {
	        if (!ignore) {
	          out(encodeEntities(chars));
	        }
	      }
	  };
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,
	      MAILTO_REGEXP = /^mailto:/;
	
	  return function(text, target) {
	    if (!text) return text;
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      html.push('<a ');
	      if (angular.isDefined(target)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 343 */,
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(345);
	module.exports = 'ui.grid';


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/*!
	 * ui-grid - v4.9.0 - 2020-09-27
	 * Copyright (c) 2020 ; License: MIT 
	 */
	
	(function() {
		'use strict';
	
		angular.module('ui.grid.i18n', []);
		angular.module('ui.grid', ['ui.grid.i18n']);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.autoResize
	   *
	   *  @description
	   *
	   *  #ui.grid.autoResize
	   *
	   *  <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   *  This module provides auto-resizing functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.autoResize', ['ui.grid']);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.autoResize.directive:uiGridAutoResize
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of the ui-grid directive and
	   *  adds the a watch to the grid's height and width which refreshes
	   *  the grid content whenever its dimensions change.
	   *
	   */
	  module.directive('uiGridAutoResize', ['gridUtil', function(gridUtil) {
	    return {
	      require: 'uiGrid',
	      scope: false,
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var debouncedRefresh;
	
	        function getDimensions() {
	          return {
	            width: gridUtil.elementWidth($elm),
	            height: gridUtil.elementHeight($elm)
	          };
	        }
	
	        function refreshGrid(prevWidth, prevHeight, width, height) {
	          if ($elm[0].offsetParent !== null) {
	            uiGridCtrl.grid.gridWidth = width;
	            uiGridCtrl.grid.gridHeight = height;
	            uiGridCtrl.grid.queueGridRefresh()
	              .then(function() {
	                uiGridCtrl.grid.api.core.raise.gridDimensionChanged(prevHeight, prevWidth, height, width);
	              });
	          }
	        }
	
	        debouncedRefresh = gridUtil.debounce(refreshGrid, 400);
	
	        $scope.$watchCollection(getDimensions, function(newValues, oldValues) {
	          if (!angular.equals(newValues, oldValues)) {
	            debouncedRefresh(oldValues.width, oldValues.height, newValues.width, newValues.height);
	          }
	        });
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.cellNav
	   *
	   *  @description
	
	      #ui.grid.cellNav
	
	      <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	
	      This module provides cell navigation functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.cellNav', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.cellNav.constant:uiGridCellNavConstants
	   *
	   *  @description constants available in cellNav
	   */
	  module.constant('uiGridCellNavConstants', {
	    FEATURE_NAME: 'gridCellNav',
	    CELL_NAV_EVENT: 'cellNav',
	    direction: {LEFT: 0, RIGHT: 1, UP: 2, DOWN: 3, PG_UP: 4, PG_DOWN: 5},
	    EVENT_TYPE: {
	      KEYDOWN: 0,
	      CLICK: 1,
	      CLEAR: 2
	    }
	  });
	
	
	  module.factory('uiGridCellNavFactory', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', 'GridRowColumn', '$q',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, GridRowColumn, $q) {
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.object:CellNav
	       *  @description returns a CellNav prototype function
	       *  @param {object} rowContainer container for rows
	       *  @param {object} colContainer parent column container
	       *  @param {object} leftColContainer column container to the left of parent
	       *  @param {object} rightColContainer column container to the right of parent
	       */
	      var UiGridCellNav = function UiGridCellNav(rowContainer, colContainer, leftColContainer, rightColContainer) {
	        this.rows = rowContainer.visibleRowCache;
	        this.columns = colContainer.visibleColumnCache;
	        this.leftColumns = leftColContainer ? leftColContainer.visibleColumnCache : [];
	        this.rightColumns = rightColContainer ? rightColContainer.visibleColumnCache : [];
	        this.bodyContainer = rowContainer;
	      };
	
	      /** returns focusable columns of all containers */
	      UiGridCellNav.prototype.getFocusableCols = function () {
	        var allColumns = this.leftColumns.concat(this.columns, this.rightColumns);
	
	        return allColumns.filter(function (col) {
	          return col.colDef.allowCellFocus;
	        });
	      };
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.api:GridRow
	       *
	       *  @description GridRow settings for cellNav feature, these are available to be
	       *  set only internally (for example, by other features)
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name allowCellFocus
	       *  @propertyOf  ui.grid.cellNav.api:GridRow
	       *  @description Enable focus on a cell within this row.  If set to false then no cells
	       *  in this row can be focused - group header rows as an example would set this to false.
	       *  <br/>Defaults to true
	       */
	      /** returns focusable rows */
	      UiGridCellNav.prototype.getFocusableRows = function () {
	        return this.rows.filter(function(row) {
	          return row.allowCellFocus !== false;
	        });
	      };
	
	      UiGridCellNav.prototype.getNextRowCol = function (direction, curRow, curCol) {
	        switch (direction) {
	          case uiGridCellNavConstants.direction.LEFT:
	            return this.getRowColLeft(curRow, curCol);
	          case uiGridCellNavConstants.direction.RIGHT:
	            return this.getRowColRight(curRow, curCol);
	          case uiGridCellNavConstants.direction.UP:
	            return this.getRowColUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.DOWN:
	            return this.getRowColDown(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_UP:
	            return this.getRowColPageUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_DOWN:
	            return this.getRowColPageDown(curRow, curCol);
	        }
	      };
	
	      UiGridCellNav.prototype.initializeSelection = function () {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        if (focusableCols.length === 0 || focusableRows.length === 0) {
	          return null;
	        }
	
	        return new GridRowColumn(focusableRows[0], focusableCols[0]); // return same row
	      };
	
	      UiGridCellNav.prototype.getRowColLeft = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 1
	        if (curColIndex === -1) {
	          curColIndex = 1;
	        }
	
	        var nextColIndex = curColIndex === 0 ? focusableCols.length - 1 : curColIndex - 1;
	
	        // get column to left
	        if (nextColIndex >= curColIndex) {
	          // On the first row
	          // if (curRowIndex === 0 && curColIndex === 0) {
	          //   return null;
	          // }
	          if (curRowIndex === 0) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); // return same row
	          }
	          else {
	            // up one row and far right column
	            return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	
	
	      UiGridCellNav.prototype.getRowColRight = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	        var nextColIndex = curColIndex === focusableCols.length - 1 ? 0 : curColIndex + 1;
	
	        if (nextColIndex <= curColIndex) {
	          if (curRowIndex === focusableRows.length - 1) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); // return same row
	          }
	          else {
	            // down one row and far left column
	            return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === focusableRows.length - 1) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); // return same row
	        }
	        else {
	          // down one row
	          return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex >= focusableRows.length - pageSize) {
	          return new GridRowColumn(focusableRows[focusableRows.length - 1], focusableCols[curColIndex]); // return last row
	        }
	        else {
	          // down one page
	          return new GridRowColumn(focusableRows[curRowIndex + pageSize], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === 0) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); // return same row
	        }
	        else {
	          // up one row
	          return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        // could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex - pageSize < 0) {
	          return new GridRowColumn(focusableRows[0], focusableCols[curColIndex]); // return first row
	        }
	        else {
	          // up one page
	          return new GridRowColumn(focusableRows[curRowIndex - pageSize], focusableCols[curColIndex]);
	        }
	      };
	      return UiGridCellNav;
	    }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.cellNav.service:uiGridCellNavService
	   *
	   *  @description Services for cell navigation features. If you don't like the key maps we use,
	   *  or the direction cells navigation, override with a service decorator (see angular docs)
	   */
	  module.service('uiGridCellNavService', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', '$q', 'uiGridCellNavFactory', 'GridRowColumn', 'ScrollEvent',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, $q, UiGridCellNav, GridRowColumn, ScrollEvent) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	          grid.registerColumnBuilder(service.cellNavColumnBuilder);
	
	
	          /**
	           * @ngdoc object
	           * @name ui.grid.cellNav.Grid:cellNav
	           * @description cellNav properties added to grid class
	           */
	          grid.cellNav = {};
	          grid.cellNav.lastRowCol = null;
	          grid.cellNav.focusedCells = [];
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:PublicApi
	           *
	           *  @description Public Api for cellNav feature
	           */
	          var publicApi = {
	            events: {
	              cellNav: {
	                /**
	                 * @ngdoc event
	                 * @name navigate
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description raised when the active cell is changed
	                 * <pre>
	                 *      gridApi.cellNav.on.navigate(scope,function(newRowcol, oldRowCol) {})
	                 * </pre>
	                 * @param {object} newRowCol new position
	                 * @param {object} oldRowCol old position
	                 */
	                navigate: function (newRowCol, oldRowCol) {},
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyDown
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyDown event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keydown event on a cell
	                 * <br/>
	                 * @param {object} event keydown event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyDown: function (event, rowCol) {},
	
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyPress
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyPress event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keypress event on a cell
	                 * <br/>
	                 * @param {object} event keypress event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyPress: function (event, rowCol) {}
	              }
	            },
	            methods: {
	              cellNav: {
	                /**
	                 * @ngdoc function
	                 * @name scrollToFocus
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description brings the specified row and column into view, and sets focus
	                 * to that cell
	                 * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus
	                 * @param {object} colDef to make visible and set focus
	                 * @returns {promise} a promise that is resolved after any scrolling is finished
	                 */
	                scrollToFocus: function (rowEntity, colDef) {
	                  return service.scrollToFocus(grid, rowEntity, colDef);
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getFocusedCell
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the current (or last if Grid does not have focus) focused row and column
	                 * <br> value is null if no selection has occurred
	                 */
	                getFocusedCell: function () {
	                  return grid.cellNav.lastRowCol;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getCurrentSelection
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns an array containing the current selection
	                 * <br> array is empty if no selection has occurred
	                 */
	                getCurrentSelection: function () {
	                  return grid.cellNav.focusedCells;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name rowColSelectIndex
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the index in the order in which the GridRowColumn was selected, returns -1 if the GridRowColumn
	                 * isn't selected
	                 * @param {object} rowCol the rowCol to evaluate
	                 */
	                rowColSelectIndex: function (rowCol) {
	                  // return gridUtil.arrayContainsObjectWithProperty(grid.cellNav.focusedCells, 'col.uid', rowCol.col.uid) &&
	                  var index = -1;
	                  for (var i = 0; i < grid.cellNav.focusedCells.length; i++) {
	                    if (grid.cellNav.focusedCells[i].col.uid === rowCol.col.uid &&
	                      grid.cellNav.focusedCells[i].row.uid === rowCol.row.uid) {
	                      index = i;
	                      break;
	                    }
	                  }
	                  return index;
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:GridOptions
	           *
	           *  @description GridOptions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelectCells
	           *  @propertyOf  ui.grid.cellNav.api:GridOptions
	           *  @description Enable multiple cell selection only when using the ctrlKey or shiftKey.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelectCells = gridOptions.modifierKeysToMultiSelectCells === true;
	
	          /**
	           *  @ngdoc array
	           *  @name keyDownOverrides
	           *  @propertyOf  ui.grid.cellNav.api:GridOptions
	           *  @description An array of event objects to override on keydown. If an event is overridden, the viewPortKeyDown event will
	           *               be raised with the overridden events, allowing custom keydown behavior.
	           *  <br/>Defaults to []
	           */
	          gridOptions.keyDownOverrides = gridOptions.keyDownOverrides || [];
	
	        },
	
	        /**
	         * @ngdoc service
	         * @name decorateRenderContainers
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  decorates grid renderContainers with cellNav functions
	         */
	        decorateRenderContainers: function (grid) {
	
	          var rightContainer = grid.hasRightContainer() ? grid.renderContainers.right : null;
	          var leftContainer = grid.hasLeftContainer() ? grid.renderContainers.left : null;
	
	          if (leftContainer !== null) {
	            grid.renderContainers.left.cellNav = new UiGridCellNav(grid.renderContainers.body, leftContainer, rightContainer, grid.renderContainers.body);
	          }
	          if (rightContainer !== null) {
	            grid.renderContainers.right.cellNav = new UiGridCellNav(grid.renderContainers.body, rightContainer, grid.renderContainers.body, leftContainer);
	          }
	
	          grid.renderContainers.body.cellNav = new UiGridCellNav(grid.renderContainers.body, grid.renderContainers.body, leftContainer, rightContainer);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getDirection
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  determines which direction to for a given keyDown event
	         * @returns {uiGridCellNavConstants.direction} direction
	         */
	        getDirection: function (evt) {
	          if (evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey)) {
	            return uiGridCellNavConstants.direction.LEFT;
	          }
	          if (evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB) {
	            return uiGridCellNavConstants.direction.RIGHT;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ) {
	            return uiGridCellNavConstants.direction.UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_UP) {
	            return uiGridCellNavConstants.direction.PG_UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER && !(evt.ctrlKey || evt.altKey)) {
	            return uiGridCellNavConstants.direction.DOWN;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_DOWN) {
	            return uiGridCellNavConstants.direction.PG_DOWN;
	          }
	
	          return null;
	        },
	
	        /**
	         * @ngdoc service
	         * @name cellNavColumnBuilder
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description columnBuilder function that adds cell navigation properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        cellNavColumnBuilder: function (colDef, col, gridOptions) {
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:ColumnDef
	           *
	           *  @description Column Definitions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name allowCellFocus
	           *  @propertyOf  ui.grid.cellNav.api:ColumnDef
	           *  @description Enable focus on a cell within this column.
	           *  <br/>Defaults to true
	           */
	          colDef.allowCellFocus = colDef.allowCellFocus === undefined ? true : colDef.allowCellFocus;
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name scrollToFocus
	         * @description Scroll the grid such that the specified
	         * row and column is in view, and set focus to the cell in that row and column
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus to
	         * @param {object} colDef to make visible and set focus to
	         * @returns {promise} a promise that is resolved after any scrolling is finished
	         */
	        scrollToFocus: function (grid, rowEntity, colDef) {
	          var gridRow = null, gridCol = null;
	
	          if (typeof(rowEntity) !== 'undefined' && rowEntity !== null) {
	            gridRow = grid.getRow(rowEntity);
	          }
	
	          if (typeof(colDef) !== 'undefined' && colDef !== null) {
	            gridCol = grid.getColumn(colDef.name ? colDef.name : colDef.field);
	          }
	          return grid.api.core.scrollToIfNecessary(gridRow, gridCol).then(function () {
	            var rowCol = { row: gridRow, col: gridCol };
	
	            // Broadcast the navigation
	            if (gridRow !== null && gridCol !== null) {
	              grid.cellNav.broadcastCellNav(rowCol, null, null);
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name getLeftWidth
	         * @description Get the current drawn width of the columns in the
	         * grid up to the numbered column, and add an apportionment for the
	         * column that we're on.  So if we are on column 0, we want to scroll
	         * 0% (i.e. exclude this column from calc).  If we're on the last column
	         * we want to scroll to 100% (i.e. include this column in the calc). So
	         * we include (thisColIndex / totalNumberCols) % of this column width
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {GridColumn} upToCol the column to total up to and including
	         */
	        getLeftWidth: function (grid, upToCol) {
	          var width = 0;
	
	          if (!upToCol) {
	            return width;
	          }
	
	          var lastIndex = grid.renderContainers.body.visibleColumnCache.indexOf( upToCol );
	
	          // total column widths up-to but not including the passed in column
	          grid.renderContainers.body.visibleColumnCache.forEach( function( col, index ) {
	            if ( index < lastIndex ) {
	              width += col.drawnWidth;
	            }
	          });
	
	          // pro-rata the final column based on % of total columns.
	          var percentage = lastIndex === 0 ? 0 : (lastIndex + 1) / grid.renderContainers.body.visibleColumnCache.length;
	          width += upToCol.drawnWidth * percentage;
	
	          return width;
	        }
	      };
	
	      return service;
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiCellNav
	   *  @element div
	   *  @restrict EA
	   *
	   *  @description Adds cell navigation features to the grid columns
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.cellNav']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'title'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-cellnav></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridCellnav', ['gridUtil', 'uiGridCellNavService', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn', '$timeout', '$compile', 'i18nService',
	    function (gridUtil, uiGridCellNavService, uiGridCellNavConstants, uiGridConstants, GridRowColumn, $timeout, $compile, i18nService) {
	      return {
	        replace: true,
	        priority: -150,
	        require: '^uiGrid',
	        scope: false,
	        controller: function () {},
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var _scope = $scope;
	
	              var grid = uiGridCtrl.grid;
	              uiGridCellNavService.initializeGrid(grid);
	
	              uiGridCtrl.cellNav = {};
	
	              // Ensure that the object has all of the methods we expect it to
	              uiGridCtrl.cellNav.makeRowCol = function (obj) {
	                if (!(obj instanceof GridRowColumn)) {
	                  obj = new GridRowColumn(obj.row, obj.col);
	                }
	                return obj;
	              };
	
	              uiGridCtrl.cellNav.getActiveCell = function () {
	                var elms = $elm[0].getElementsByClassName('ui-grid-cell-focus');
	                if (elms.length > 0) {
	                  return elms[0];
	                }
	
	                return undefined;
	              };
	
	              uiGridCtrl.cellNav.broadcastCellNav = grid.cellNav.broadcastCellNav = function (newRowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                newRowCol = uiGridCtrl.cellNav.makeRowCol(newRowCol);
	
	                uiGridCtrl.cellNav.broadcastFocus(newRowCol, modifierDown, originEvt);
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT, newRowCol, modifierDown, originEvt);
	              };
	
	              uiGridCtrl.cellNav.clearFocus = grid.cellNav.clearFocus = function () {
	                grid.cellNav.focusedCells = [];
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT);
	              };
	
	              uiGridCtrl.cellNav.broadcastFocus = function (rowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                rowCol = uiGridCtrl.cellNav.makeRowCol(rowCol);
	
	                var row = rowCol.row,
	                  col = rowCol.col;
	
	                var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	
	                if (grid.cellNav.lastRowCol === null || rowColSelectIndex === -1 || (grid.cellNav.lastRowCol.col === col && grid.cellNav.lastRowCol.row === row)) {
	                  var newRowCol = new GridRowColumn(row, col);
	
	                  if (grid.cellNav.lastRowCol === null || grid.cellNav.lastRowCol.row !== newRowCol.row || grid.cellNav.lastRowCol.col !== newRowCol.col || grid.options.enableCellEditOnFocus) {
	                    grid.api.cellNav.raise.navigate(newRowCol, grid.cellNav.lastRowCol, originEvt);
	                    grid.cellNav.lastRowCol = newRowCol;
	                  }
	                  if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells && modifierDown) {
	                    grid.cellNav.focusedCells.push(rowCol);
	                  } else {
	                    grid.cellNav.focusedCells = [rowCol];
	                  }
	                } else if (grid.options.modifierKeysToMultiSelectCells && modifierDown &&
	                  rowColSelectIndex >= 0) {
	
	                  grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                }
	              };
	
	              uiGridCtrl.cellNav.handleKeyDown = function (evt) {
	                var direction = uiGridCellNavService.getDirection(evt);
	                if (direction === null) {
	                  return null;
	                }
	
	                var containerId = 'body';
	                if (evt.uiGridTargetRenderContainerId) {
	                  containerId = evt.uiGridTargetRenderContainerId;
	                }
	
	                // Get the last-focused row+col combo
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol) {
	                  // Figure out which new row+combo we're navigating to
	                  var rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(direction, lastRowCol.row, lastRowCol.col);
	                  var focusableCols = uiGridCtrl.grid.renderContainers[containerId].cellNav.getFocusableCols();
	                  var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	                  // Shift+tab on top-left cell should exit cellnav on render container
	                  if (
	                    // Navigating left
	                    direction === uiGridCellNavConstants.direction.LEFT &&
	                    // New col is last col (i.e. wrap around)
	                    rowCol.col === focusableCols[focusableCols.length - 1] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	                  // Tab on bottom-right cell should exit cellnav on render container
	                  else if (
	                    direction === uiGridCellNavConstants.direction.RIGHT &&
	                    // New col is first col (i.e. wrap around)
	                    rowCol.col === focusableCols[0] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    !evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	
	                  // Scroll to the new cell, if it's not completely visible within the render container's viewport
	                  grid.scrollToIfNecessary(rowCol.row, rowCol.col).then(function () {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol, null, evt);
	                  });
	
	
	                  evt.stopPropagation();
	                  evt.preventDefault();
	
	                  return false;
	                }
	              };
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var grid = uiGridCtrl.grid;
	              var usesAria = true;
	
	              // Detect whether we are using ngAria
	              // (if ngAria module is not used then the stuff inside addAriaLiveRegion
	              // is not used and provides extra fluff)
	              try {
	                angular.module('ngAria');
	              }
	              catch (err) {
	                usesAria = false;
	              }
	
	              function addAriaLiveRegion() {
	                // Thanks to google docs for the inspiration behind how to do this
	                // XXX: Why is this entire mess nessasary?
	                // Because browsers take a lot of coercing to get them to read out live regions
	                // http://www.paciellogroup.com/blog/2012/06/html5-accessibility-chops-aria-rolealert-browser-support/
	                var ariaNotifierDomElt = '<div ' +
	                                           'id="' + grid.id +'-aria-speakable" ' +
	                                           'class="ui-grid-a11y-ariascreenreader-speakable ui-grid-offscreen" ' +
	                                           'aria-live="assertive" ' +
	                                           'role="alert" ' +
	                                           'aria-atomic="true" ' +
	                                           'aria-hidden="false" ' +
	                                           'aria-relevant="additions" ' +
	                                           '>' +
	                                           '&nbsp;' +
	                                         '</div>';
	
	                var ariaNotifier = $compile(ariaNotifierDomElt)($scope);
	                $elm.prepend(ariaNotifier);
	                $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, function (evt, rowCol, modifierDown, originEvt) {
	                  /*
	                   * If the cell nav event was because of a focus event then we don't want to
	                   * change the notifier text.
	                   * Reasoning: Voice Over fires a focus events when moving arround the grid.
	                   * If the screen reader is handing the grid nav properly then we don't need to
	                   * use the alert to notify the user of the movement.
	                   * In all other cases we do want a notification event.
	                   */
	                  if (originEvt && originEvt.type === 'focus') {return;}
	
	                  function setNotifyText(text) {
	                    if (text === ariaNotifier.text().trim()) {return;}
	                    ariaNotifier[0].style.clip = 'rect(0px,0px,0px,0px)';
	                    /*
	                     * This is how google docs handles clearing the div. Seems to work better than setting the text of the div to ''
	                     */
	                    ariaNotifier[0].innerHTML = "";
	                    ariaNotifier[0].style.visibility = 'hidden';
	                    ariaNotifier[0].style.visibility = 'visible';
	                    if (text !== '') {
	                      ariaNotifier[0].style.clip = 'auto';
	                      /*
	                       * The space after the text is something that google docs does.
	                       */
	                      ariaNotifier[0].appendChild(document.createTextNode(text + " "));
	                      ariaNotifier[0].style.visibility = 'hidden';
	                      ariaNotifier[0].style.visibility = 'visible';
	                    }
	                  }
	
	                  function getAppendedColumnHeaderText(col) {
	                    return ', ' + i18nService.getSafeText('headerCell.aria.column') + ' ' + col.displayName;
	                  }
	
	                  function getCellDisplayValue(currentRowColumn) {
	                    if (currentRowColumn.col.field === 'selectionRowHeaderCol') {
	                      // This is the case when the 'selection' feature is used in the grid and the user has moved
	                      // to or inside of the left grid container which holds the checkboxes for selecting rows.
	                      // This is necessary for Accessibility. Without this a screen reader cannot determine if the row
	                      // is or is not currently selected.
	                        return currentRowColumn.row.isSelected ? i18nService.getSafeText('search.aria.selected') : i18nService.getSafeText('search.aria.notSelected');
	                      } else {
	                        return grid.getCellDisplayValue(currentRowColumn.row, currentRowColumn.col);
	                      }
	                    }
	
	                  var values = [];
	                  var currentSelection = grid.api.cellNav.getCurrentSelection();
	                  for (var i = 0; i < currentSelection.length; i++) {
	                    var cellDisplayValue = getCellDisplayValue(currentSelection[i]) + getAppendedColumnHeaderText(currentSelection[i].col);
	                    values.push(cellDisplayValue);
	                  }
	                  var cellText = values.toString();
	                  setNotifyText(cellText);
	
	                });
	              }
	              // Only add the ngAria stuff it will be used
	              if (usesAria) {
	                addAriaLiveRegion();
	              }
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridRenderContainer', ['$timeout', '$document', 'gridUtil', 'uiGridConstants', 'uiGridCellNavService', '$compile','uiGridCellNavConstants',
	    function ($timeout, $document, gridUtil, uiGridConstants, uiGridCellNavService, $compile, uiGridCellNavConstants) {
	      return {
	        replace: true,
	        priority: -99999, // this needs to run very last
	        require: ['^uiGrid', 'uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                 renderContainerCtrl = controllers[1],
	                 uiGridCellnavCtrl = controllers[2];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	
	              var grid = uiGridCtrl.grid;
	
	              // run each time a render container is created
	              uiGridCellNavService.decorateRenderContainers(grid);
	
	              // focusser only created for body
	              if (containerId !== 'body') {
	                return;
	              }
	
	              if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells) {
	                $elm.attr('aria-multiselectable', true);
	              }
	              else {
	                $elm.attr('aria-multiselectable', false);
	              }
	
	              // add an element with no dimensions that can be used to set focus and capture keystrokes
	              var focuser = $compile('<div class="ui-grid-focuser" role="region" aria-live="assertive" aria-atomic="false" tabindex="0" aria-controls="' + grid.id +'-aria-speakable '+ grid.id + '-grid-container' +'" aria-owns="' + grid.id + '-grid-container' + '"></div>')($scope);
	              $elm.append(focuser);
	
	              focuser.on('focus', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (rowCol === null) {
	                  rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(uiGridCellNavConstants.direction.DOWN, null, null);
	                  if (rowCol.row && rowCol.col) {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol);
	                  }
	                }
	              });
	
	              uiGridCellnavCtrl.setAriaActivedescendant = function(id) {
	                $elm.attr('aria-activedescendant', id);
	              };
	
	              uiGridCellnavCtrl.removeAriaActivedescendant = function(id) {
	                if ($elm.attr('aria-activedescendant') === id) {
	                  $elm.attr('aria-activedescendant', '');
	                }
	              };
	
	
	              uiGridCtrl.focus = function () {
	                gridUtil.focus.byElement(focuser[0]);
	                // allow for first time grid focus
	              };
	
	              var viewPortKeyDownWasRaisedForRowCol = null;
	              // Bind to keydown events in the render container
	              focuser.on('keydown', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                var raiseViewPortKeyDown = uiGridCtrl.grid.options.keyDownOverrides.some(function (override) {
	                  return Object.keys(override).every( function (property) {
	                      return override[property] === evt[property];
	                  });
	                });
	                var result = raiseViewPortKeyDown ? null : uiGridCtrl.cellNav.handleKeyDown(evt);
	                if (result === null) {
	                  uiGridCtrl.grid.api.cellNav.raise.viewPortKeyDown(evt, rowCol, uiGridCtrl.cellNav.handleKeyDown);
	                  viewPortKeyDownWasRaisedForRowCol = rowCol;
	                }
	              });
	              // Bind to keypress events in the render container
	              // keypress events are needed by edit function so the key press
	              // that initiated an edit is not lost
	              // must fire the event in a timeout so the editor can
	              // initialize and subscribe to the event on another event loop
	              focuser.on('keypress', function (evt) {
	                if (viewPortKeyDownWasRaisedForRowCol) {
	                  $timeout(function () {
	                    uiGridCtrl.grid.api.cellNav.raise.viewPortKeyPress(evt, viewPortKeyDownWasRaisedForRowCol);
	                  }, 4);
	
	                  viewPortKeyDownWasRaisedForRowCol = null;
	                }
	              });
	
	              $scope.$on('$destroy', function() {
	                // Remove all event handlers associated with this focuser.
	                focuser.off();
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridViewport',
	    function () {
	      return {
	        replace: true,
	        priority: -99999, // this needs to run very last
	        require: ['^uiGrid', '^uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                renderContainerCtrl = controllers[1];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	              // no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              var grid = uiGridCtrl.grid;
	
	              grid.api.core.on.scrollBegin($scope, function () {
	
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                // if not in my container, move on
	                // todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.clearFocus();
	
	              });
	
	              grid.api.core.on.scrollEnd($scope, function (args) {
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                // if not in my container, move on
	                // todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.broadcastCellNav(lastRowCol);
	              });
	
	              grid.api.cellNav.on.navigate($scope, function () {
	                // focus again because it can be lost
	                 uiGridCtrl.focus();
	              });
	            }
	          };
	        }
	      };
	    });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *  @description Stacks on top of ui.grid.uiGridCell to provide cell navigation
	   */
	  module.directive('uiGridCell', ['$timeout', '$document', 'uiGridCellNavService', 'gridUtil', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn',
	    function ($timeout, $document, uiGridCellNavService, gridUtil, uiGridCellNavConstants, uiGridConstants, GridRowColumn) {
	      return {
	        priority: -150, // run after default uiGridCell directive and ui.grid.edit uiGridCell
	        restrict: 'A',
	        require: ['^uiGrid', '?^uiGridCellnav'],
	        scope: false,
	        link: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0],
	              uiGridCellnavCtrl = controllers[1];
	          // Skip attaching cell-nav specific logic if the directive is not attached above us
	          if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	          if (!$scope.col.colDef.allowCellFocus) {
	            return;
	          }
	
	          // Convinience local variables
	          var grid = uiGridCtrl.grid;
	          $scope.focused = false;
	
	          // Make this cell focusable but only with javascript/a mouse click
	          $elm.attr('tabindex', -1);
	
	          // When a cell is clicked, broadcast a cellNav event saying that this row+col combo is now focused
	          $elm.find('div').on('click', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), evt.ctrlKey || evt.metaKey, evt);
	
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	
	          /*
	           * XXX Hack for screen readers.
	           * This allows the grid to focus using only the screen reader cursor.
	           * Since the focus event doesn't include key press information we can't use it
	           * as our primary source of the event.
	           */
	          $elm.on('mousedown', preventMouseDown);
	
	          // turn on and off for edit events
	          if (uiGridCtrl.grid.api.edit) {
	            uiGridCtrl.grid.api.edit.on.beginCellEdit($scope, function () {
	              $elm.off('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.afterCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.cancelCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	          }
	
	          // In case we created a new row, and we are the new created row by ngRepeat
	          // then this cell content might have been selected previously
	          refreshCellFocus();
	
	          function preventMouseDown(evt) {
	            // Prevents the foucus event from firing if the click event is already going to fire.
	            // If both events fire it will cause bouncing behavior.
	            evt.preventDefault();
	          }
	
	          // You can only focus on elements with a tabindex value
	          $elm.on('focus', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), false, evt);
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	          // This event is fired for all cells.  If the cell matches, then focus is set
	          $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, refreshCellFocus);
	
	          // Refresh cell focus when a new row id added to the grid
	          var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(function (grid) {
	            // Clear the focus if it's set to avoid the wrong cell getting focused during
	            // a short period of time (from now until $timeout function executed)
	            clearFocus();
	
	            $scope.$applyAsync(refreshCellFocus);
	          }, [uiGridConstants.dataChange.ROW]);
	
	          function refreshCellFocus() {
	            var isFocused = grid.cellNav.focusedCells.some(function (focusedRowCol, index) {
	              return (focusedRowCol.row === $scope.row && focusedRowCol.col === $scope.col);
	            });
	            if (isFocused) {
	              setFocused();
	            } else {
	              clearFocus();
	            }
	          }
	
	          function setFocused() {
	            if (!$scope.focused) {
	              var div = $elm.find('div');
	              div.addClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', true);
	              uiGridCellnavCtrl.setAriaActivedescendant($elm.attr('id'));
	              $scope.focused = true;
	            }
	          }
	
	          function clearFocus() {
	            if ($scope.focused) {
	              var div = $elm.find('div');
	              div.removeClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', false);
	              uiGridCellnavCtrl.removeAriaActivedescendant($elm.attr('id'));
	              $scope.focused = false;
	            }
	          }
	
	          $scope.$on('$destroy', function () {
	            dataChangeDereg();
	
	            // .off withouth paramaters removes all handlers
	            $elm.find('div').off();
	            $elm.off();
	          });
	        }
	      };
	    }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.service:uiGridConstants
	   * @description Constants for use across many grid features
	   *
	   */
	
	
	  angular.module('ui.grid').constant('uiGridConstants', {
	    LOG_DEBUG_MESSAGES: true,
	    LOG_WARN_MESSAGES: true,
	    LOG_ERROR_MESSAGES: true,
	    CUSTOM_FILTERS: /CUSTOM_FILTERS/g,
	    COL_FIELD: /COL_FIELD/g,
	    MODEL_COL_FIELD: /MODEL_COL_FIELD/g,
	    TOOLTIP: /title=\"TOOLTIP\"/g,
	    DISPLAY_CELL_TEMPLATE: /DISPLAY_CELL_TEMPLATE/g,
	    TEMPLATE_REGEXP: /<.+>/,
	    FUNC_REGEXP: /(\([^)]*\))?$/,
	    DOT_REGEXP: /\./g,
	    APOS_REGEXP: /'/g,
	    BRACKET_REGEXP: /^(.*)((?:\s*\[\s*\d+\s*\]\s*)|(?:\s*\[\s*"(?:[^"\\]|\\.)*"\s*\]\s*)|(?:\s*\[\s*'(?:[^'\\]|\\.)*'\s*\]\s*))(.*)$/,
	    COL_CLASS_PREFIX: 'ui-grid-col',
	    ENTITY_BINDING: '$$this',
	    events: {
	      GRID_SCROLL: 'uiGridScroll',
	      COLUMN_MENU_SHOWN: 'uiGridColMenuShown',
	      ITEM_DRAGGING: 'uiGridItemDragStart', // For any item being dragged
	      COLUMN_HEADER_CLICK: 'uiGridColumnHeaderClick'
	    },
	    // copied from http://www.lsauer.com/2011/08/javascript-keymap-keycodes-in-json.html
	    keymap: {
	      TAB: 9,
	      STRG: 17,
	      CAPSLOCK: 20,
	      CTRL: 17,
	      CTRLRIGHT: 18,
	      CTRLR: 18,
	      SHIFT: 16,
	      RETURN: 13,
	      ENTER: 13,
	      BACKSPACE: 8,
	      BCKSP: 8,
	      ALT: 18,
	      ALTR: 17,
	      ALTRIGHT: 17,
	      SPACE: 32,
	      WIN: 91,
	      MAC: 91,
	      FN: null,
	      PG_UP: 33,
	      PG_DOWN: 34,
	      UP: 38,
	      DOWN: 40,
	      LEFT: 37,
	      RIGHT: 39,
	      ESC: 27,
	      DEL: 46,
	      F1: 112,
	      F2: 113,
	      F3: 114,
	      F4: 115,
	      F5: 116,
	      F6: 117,
	      F7: 118,
	      F8: 119,
	      F9: 120,
	      F10: 121,
	      F11: 122,
	      F12: 123
	    },
	     /**
	     * @ngdoc object
	     * @name ASC
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
	     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
	     * to configure the sorting direction of the column
	     */
	    ASC: 'asc',
	     /**
	     * @ngdoc object
	     * @name DESC
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
	     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
	     * to configure the sorting direction of the column
	     */
	    DESC: 'desc',
	
	
	     /**
	     * @ngdoc object
	     * @name filter
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_filter columnDef.filter}
	     * to configure filtering on the column
	     *
	     * `SELECT` and `INPUT` are used with the `type` property of the filter, the rest are used to specify
	     * one of the built-in conditions.
	     *
	     * Available `condition` options are:
	     * - `uiGridConstants.filter.STARTS_WITH`
	     * - `uiGridConstants.filter.ENDS_WITH`
	     * - `uiGridConstants.filter.CONTAINS`
	     * - `uiGridConstants.filter.GREATER_THAN`
	     * - `uiGridConstants.filter.GREATER_THAN_OR_EQUAL`
	     * - `uiGridConstants.filter.LESS_THAN`
	     * - `uiGridConstants.filter.LESS_THAN_OR_EQUAL`
	     * - `uiGridConstants.filter.NOT_EQUAL`
	     *
	     *
	     * Available `type` options are:
	     * - `uiGridConstants.filter.SELECT` - use a dropdown box for the cell header filter field
	     * - `uiGridConstants.filter.INPUT` - use a text box for the cell header filter field
	     */
	    filter: {
	      STARTS_WITH: 2,
	      ENDS_WITH: 4,
	      EXACT: 8,
	      CONTAINS: 16,
	      GREATER_THAN: 32,
	      GREATER_THAN_OR_EQUAL: 64,
	      LESS_THAN: 128,
	      LESS_THAN_OR_EQUAL: 256,
	      NOT_EQUAL: 512,
	      SELECT: 'select',
	      INPUT: 'input'
	    },
	
	    /**
	     * @ngdoc object
	     * @name aggregationTypes
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_aggregationType columnDef.aggregationType}
	     * to specify the type of built-in aggregation the column should use.
	     *
	     * Available options are:
	     * - `uiGridConstants.aggregationTypes.sum` - add the values in this column to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.count` - count the number of rows to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.avg` - average the values in this column to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.min` - use the minimum value in this column as the aggregated value
	     * - `uiGridConstants.aggregationTypes.max` - use the maximum value in this column as the aggregated value
	     */
	    aggregationTypes: {
	      sum: 2,
	      count: 4,
	      avg: 8,
	      min: 16,
	      max: 32
	    },
	
	    /**
	     * @ngdoc array
	     * @name CURRENCY_SYMBOLS
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description A list of all presently circulating currency symbols that was copied from
	     * https://en.wikipedia.org/wiki/Currency_symbol#List_of_presently-circulating_currency_symbols
	     *
	     * Can be used on {@link ui.grid.class:rowSorter} to create a number string regex that ignores currency symbols.
	     */
	    CURRENCY_SYMBOLS: ['¤', '؋', 'Ar', 'Ƀ', '฿', 'B/.', 'Br', 'Bs.', 'Bs.F.', 'GH₵', '¢', 'c', 'Ch.', '₡', 'C$', 'D', 'ден',
	      'دج', '.د.ب', 'د.ع', 'JD', 'د.ك', 'ل.د', 'дин', 'د.ت', 'د.م.', 'د.إ', 'Db', '$', '₫', 'Esc', '€', 'ƒ', 'Ft', 'FBu',
	      'FCFA', 'CFA', 'Fr', 'FRw', 'G', 'gr', '₲', 'h', '₴', '₭', 'Kč', 'kr', 'kn', 'MK', 'ZK', 'Kz', 'K', 'L', 'Le', 'лв',
	      'E', 'lp', 'M', 'KM', 'MT', '₥', 'Nfk', '₦', 'Nu.', 'UM', 'T$', 'MOP$', '₱', 'Pt.', '£', 'ج.م.', 'LL', 'LS', 'P', 'Q',
	      'q', 'R', 'R$', 'ر.ع.', 'ر.ق', 'ر.س', '៛', 'RM', 'p', 'Rf.', '₹', '₨', 'SRe', 'Rp', '₪', 'Ksh', 'Sh.So.', 'USh', 'S/',
	      'SDR', 'сом', '৳	', 'WS$', '₮', 'VT', '₩', '¥', 'zł'],
	
	    /**
	     * @ngdoc object
	     * @name scrollDirection
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Set on {@link ui.grid.class:Grid#properties_scrollDirection Grid.scrollDirection},
	     * to indicate the direction the grid is currently scrolling in
	     *
	     * Available options are:
	     * - `uiGridConstants.scrollDirection.UP` - set when the grid is scrolling up
	     * - `uiGridConstants.scrollDirection.DOWN` - set when the grid is scrolling down
	     * - `uiGridConstants.scrollDirection.LEFT` - set when the grid is scrolling left
	     * - `uiGridConstants.scrollDirection.RIGHT` - set when the grid is scrolling right
	     * - `uiGridConstants.scrollDirection.NONE` - set when the grid is not scrolling, this is the default
	     */
	    scrollDirection: {
	      UP: 'up',
	      DOWN: 'down',
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: 'none'
	
	    },
	
	    /**
	     * @ngdoc object
	     * @name dataChange
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used with {@link ui.grid.api:PublicApi#methods_notifyDataChange PublicApi.notifyDataChange},
	     * {@link ui.grid.class:Grid#methods_callDataChangeCallbacks Grid.callDataChangeCallbacks},
	     * and {@link ui.grid.class:Grid#methods_registerDataChangeCallback Grid.registerDataChangeCallback}
	     * to specify the type of the event(s).
	     *
	     * Available options are:
	     * - `uiGridConstants.dataChange.ALL` - listeners fired on any of these events, fires listeners on all events.
	     * - `uiGridConstants.dataChange.EDIT` - fired when the data in a cell is edited
	     * - `uiGridConstants.dataChange.ROW` - fired when a row is added or removed
	     * - `uiGridConstants.dataChange.COLUMN` - fired when the column definitions are modified
	     * - `uiGridConstants.dataChange.OPTIONS` - fired when the grid options are modified
	     */
	    dataChange: {
	      ALL: 'all',
	      EDIT: 'edit',
	      ROW: 'row',
	      COLUMN: 'column',
	      OPTIONS: 'options'
	    },
	
	    /**
	     * @ngdoc object
	     * @name scrollbars
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used with {@link ui.grid.class:GridOptions#properties_enableHorizontalScrollbar GridOptions.enableHorizontalScrollbar}
	     * and {@link ui.grid.class:GridOptions#properties_enableVerticalScrollbar GridOptions.enableVerticalScrollbar}
	     * to specify the scrollbar policy for that direction.
	     *
	     * Available options are:
	     * - `uiGridConstants.scrollbars.NEVER` - never show scrollbars in this direction
	     * - `uiGridConstants.scrollbars.ALWAYS` - always show scrollbars in this direction
	     * - `uiGridConstants.scrollbars.WHEN_NEEDED` - shows scrollbars in this direction when needed
	     */
	
	    scrollbars: {
	      NEVER: 0,
	      ALWAYS: 1,
	      WHEN_NEEDED: 2
	    }
	  });
	
	})();
	
	angular.module('ui.grid').directive('uiGridCell', ['$compile', '$parse', 'gridUtil', 'uiGridConstants', function ($compile, $parse, gridUtil, uiGridConstants) {
	  return {
	    priority: 0,
	    scope: false,
	    require: '?^uiGrid',
	    compile: function() {
	      return {
	        pre: function($scope, $elm, $attrs, uiGridCtrl) {
	          function compileTemplate() {
	            var compiledElementFn = $scope.col.compiledElementFn;
	
	            compiledElementFn($scope, function(clonedElement, scope) {
	              $elm.append(clonedElement);
	            });
	          }
	
	          // If the grid controller is present, use it to get the compiled cell template function
	          if (uiGridCtrl && $scope.col.compiledElementFn) {
	             compileTemplate();
	          }
	
	          // No controller, compile the element manually (for unit tests)
	          else {
	            if ( uiGridCtrl && !$scope.col.compiledElementFn ) {
	              $scope.col.getCompiledElementFn()
	                .then(function (compiledElementFn) {
	                  compiledElementFn($scope, function(clonedElement, scope) {
	                    $elm.append(clonedElement);
	                  });
	                }).catch(angular.noop);
	            }
	            else {
	              var html = $scope.col.cellTemplate
	                .replace(uiGridConstants.MODEL_COL_FIELD, 'row.entity.' + gridUtil.preEval($scope.col.field))
	                .replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var cellElement = $compile(html)($scope);
	              $elm.append(cellElement);
	            }
	          }
	        },
	        post: function($scope, $elm) {
	          var initColClass = $scope.col.getColClass(false),
	            classAdded;
	
	          $elm.addClass(initColClass);
	
	          function updateClass( grid ) {
	            var contents = $elm;
	
	            if ( classAdded ) {
	              contents.removeClass( classAdded );
	              classAdded = null;
	            }
	
	            if (angular.isFunction($scope.col.cellClass)) {
	              classAdded = $scope.col.cellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	            }
	            else {
	              classAdded = $scope.col.cellClass;
	            }
	            contents.addClass(classAdded);
	          }
	
	          if ($scope.col.cellClass) {
	            updateClass();
	          }
	
	          // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	          var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN, uiGridConstants.dataChange.EDIT]);
	
	          // watch the col and row to see if they change - which would indicate that we've scrolled or sorted or otherwise
	          // changed the row/col that this cell relates to, and we need to re-evaluate cell classes and maybe other things
	          function cellChangeFunction( n, o ) {
	            if ( n !== o ) {
	              if ( classAdded || $scope.col.cellClass ) {
	                updateClass();
	              }
	
	              // See if the column's internal class has changed
	              var newColClass = $scope.col.getColClass(false);
	
	              if (newColClass !== initColClass) {
	                $elm.removeClass(initColClass);
	                $elm.addClass(newColClass);
	                initColClass = newColClass;
	              }
	            }
	          }
	
	          // TODO(c0bra): Turn this into a deep array watch
	          var rowWatchDereg = $scope.$watch( 'row', cellChangeFunction );
	
	          function deregisterFunction() {
	            dataChangeDereg();
	            rowWatchDereg();
	          }
	
	          $scope.$on('$destroy', deregisterFunction);
	          $elm.on('$destroy', deregisterFunction);
	        }
	      };
	    }
	  };
	}]);
	
	(function() {
	
	angular.module('ui.grid')
	.service('uiGridColumnMenuService', [ 'i18nService', 'uiGridConstants', 'gridUtil',
	function ( i18nService, uiGridConstants, gridUtil ) {
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:uiGridColumnMenuService
	 *
	 *  @description Services for working with column menus, factored out
	 *  to make the code easier to understand
	 */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name initialize
	     * @description  Sets defaults, puts a reference to the $scope on
	     * the uiGridController
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {controller} uiGridCtrl the uiGridController for the grid
	     * we're on
	     *
	     */
	    initialize: function( $scope, uiGridCtrl ) {
	      $scope.grid = uiGridCtrl.grid;
	
	      // Store a reference to this link/controller in the main uiGrid controller
	      // to allow showMenu later
	      uiGridCtrl.columnMenuScope = $scope;
	
	      // Save whether we're shown or not so the columns can check
	      $scope.menuShown = false;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name setColMenuItemWatch
	     * @description  Setup a watch on $scope.col.menuItems, and update
	     * menuItems based on this.  $scope.col needs to be set by the column
	     * before calling the menu.
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     */
	    setColMenuItemWatch: function ( $scope ) {
	      var deregFunction = $scope.$watch('col.menuItems', function (n) {
	        if (typeof(n) !== 'undefined' && n && angular.isArray(n)) {
	          n.forEach(function (item) {
	            if (typeof(item.context) === 'undefined' || !item.context) {
	              item.context = {};
	            }
	            item.context.col = $scope.col;
	          });
	
	          $scope.menuItems = $scope.defaultMenuItems.concat(n);
	        }
	        else {
	          $scope.menuItems = $scope.defaultMenuItems;
	        }
	      });
	
	      $scope.$on( '$destroy', deregFunction );
	    },
	
	
	    /**
	     * @ngdoc boolean
	     * @name enableSorting
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When enabled, this setting adds sort
	     * widgets to the column header, allowing sorting of the data in the individual column.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name sortable
	     * @description  determines whether this column is sortable
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    sortable: function( $scope ) {
	      return Boolean( $scope.grid.options.enableSorting && typeof($scope.col) !== 'undefined' && $scope.col && $scope.col.enableSorting);
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name isActiveSort
	     * @description  determines whether the requested sort direction is current active, to
	     * allow highlighting in the menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {string} direction the direction that we'd have selected for us to be active
	     *
	     */
	    isActiveSort: function( $scope, direction ) {
	      return Boolean(typeof($scope.col) !== 'undefined' && typeof($scope.col.sort) !== 'undefined' &&
	              typeof($scope.col.sort.direction) !== 'undefined' && $scope.col.sort.direction === direction);
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name suppressRemoveSort
	     * @description  determines whether we should suppress the removeSort option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    suppressRemoveSort: function( $scope ) {
	      return Boolean($scope.col && $scope.col.suppressRemoveSort);
	    },
	
	
	    /**
	     * @ngdoc boolean
	     * @name enableHiding
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When set to false, this setting prevents a user from hiding the column
	     * using the column menu or the grid menu.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name hideable
	     * @description  determines whether a column can be hidden, by checking the enableHiding columnDef option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    hideable: function( $scope ) {
	      return !(typeof($scope.col) !== 'undefined' && $scope.col && $scope.col.colDef && $scope.col.colDef.enableHiding === false );
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getDefaultMenuItems
	     * @description  returns the default menu items for a column menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    getDefaultMenuItems: function( $scope ) {
	      return [
	        {
	          title: function() {return i18nService.getSafeText('sort.ascending');},
	          icon: 'ui-grid-icon-sort-alt-up',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.ASC);
	          },
	          shown: function () {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.ASC);
	          }
	        },
	        {
	          title: function() {return i18nService.getSafeText('sort.descending');},
	          icon: 'ui-grid-icon-sort-alt-down',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.DESC);
	          },
	          shown: function() {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.DESC);
	          }
	        },
	        {
	          title: function() {return i18nService.getSafeText('sort.remove');},
	          icon: 'ui-grid-icon-cancel',
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.unsortColumn();
	          },
	          shown: function() {
	            return service.sortable( $scope ) &&
	                   typeof($scope.col) !== 'undefined' && (typeof($scope.col.sort) !== 'undefined' &&
	                   typeof($scope.col.sort.direction) !== 'undefined') && $scope.col.sort.direction !== null &&
	                  !service.suppressRemoveSort( $scope );
	          }
	        },
	        {
	          title: function() {return i18nService.getSafeText('column.hide');},
	          icon: 'ui-grid-icon-cancel',
	          shown: function() {
	            return service.hideable( $scope );
	          },
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.hideColumn();
	          }
	        }
	      ];
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getColumnElementPosition
	     * @description  gets the position information needed to place the column
	     * menu below the column header
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridColumn} column the column we want to position below
	     * @param {element} $columnElement the column element we want to position below
	     * @returns {hash} containing left, top, offset, height, width
	     *
	     */
	    getColumnElementPosition: function( $scope, column, $columnElement ) {
	      var positionData = {};
	
	      positionData.left = $columnElement[0].offsetLeft;
	      positionData.top = $columnElement[0].offsetTop;
	      positionData.parentLeft = $columnElement[0].offsetParent.offsetLeft;
	
	      // Get the grid scrollLeft
	      positionData.offset = 0;
	      if (column.grid.options.offsetLeft) {
	        positionData.offset = column.grid.options.offsetLeft;
	      }
	
	      positionData.height = gridUtil.elementHeight($columnElement, true);
	      positionData.width = gridUtil.elementWidth($columnElement, true);
	
	      return positionData;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name repositionMenu
	     * @description  Reposition the menu below the new column.  If the menu has no child nodes
	     * (i.e. it's not currently visible) then we guess it's width at 100, we'll be called again
	     * later to fix it
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridColumn} column the column we want to position below
	     * @param {hash} positionData a hash containing left, top, offset, height, width
	     * @param {element} $elm the column menu element that we want to reposition
	     * @param {element} $columnElement the column element that we want to reposition underneath
	     *
	     */
	    repositionMenu: function( $scope, column, positionData, $elm, $columnElement ) {
	      var menu = $elm[0].querySelectorAll('.ui-grid-menu');
	
	      // It's possible that the render container of the column we're attaching to is
	      // offset from the grid (i.e. pinned containers), we need to get the difference in the offsetLeft
	      // between the render container and the grid
	      var renderContainerElm = gridUtil.closestElm($columnElement, '.ui-grid-render-container'),
	        renderContainerOffset = renderContainerElm.getBoundingClientRect().left - $scope.grid.element[0].getBoundingClientRect().left,
	        containerScrollLeft = renderContainerElm.querySelectorAll('.ui-grid-viewport')[0].scrollLeft;
	
	      // repositionMenu is now always called after it's visible in the DOM,
	      // allowing us to simply get the width every time the menu is opened
	      var myWidth = gridUtil.elementWidth(menu, true),
	        paddingRight = column.lastMenuPaddingRight ? column.lastMenuPaddingRight : ( $scope.lastMenuPaddingRight ? $scope.lastMenuPaddingRight : 10);
	
	      if ( menu.length !== 0 ) {
	        var mid = menu[0].querySelectorAll('.ui-grid-menu-mid');
	
	        if ( mid.length !== 0 ) {
	          // TODO(c0bra): use padding-left/padding-right based on document direction (ltr/rtl), place menu on proper side
	          // Get the column menu right padding
	          paddingRight = parseInt(gridUtil.getStyles(angular.element(menu)[0])['paddingRight'], 10);
	          $scope.lastMenuPaddingRight = paddingRight;
	          column.lastMenuPaddingRight = paddingRight;
	        }
	      }
	
	      var left = positionData.left + renderContainerOffset - containerScrollLeft + positionData.parentLeft + positionData.width + paddingRight;
	
	      if (left < positionData.offset + myWidth) {
	        left = Math.max(positionData.left - containerScrollLeft + positionData.parentLeft - paddingRight + myWidth, positionData.offset + myWidth);
	      }
	
	      $elm.css('left', left + 'px');
	      $elm.css('top', (positionData.top + positionData.height) + 'px');
	    }
	  };
	  return service;
	}])
	
	
	.directive('uiGridColumnMenu', ['$timeout', 'gridUtil', 'uiGridConstants', 'uiGridColumnMenuService', '$document',
	function ($timeout, gridUtil, uiGridConstants, uiGridColumnMenuService, $document) {
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridColumnMenu
	 * @description  Provides the column menu framework, leverages uiGridMenu underneath
	 *
	 */
	
	  return {
	    priority: 0,
	    scope: true,
	    require: '^uiGrid',
	    templateUrl: 'ui-grid/uiGridColumnMenu',
	    replace: true,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      uiGridColumnMenuService.initialize( $scope, uiGridCtrl );
	
	      $scope.defaultMenuItems = uiGridColumnMenuService.getDefaultMenuItems( $scope );
	
	      // Set the menu items for use with the column menu. The user can later add additional items via the watch
	      $scope.menuItems = $scope.defaultMenuItems;
	      uiGridColumnMenuService.setColMenuItemWatch( $scope );
	
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name showMenu
	       * @description Shows the column menu.  If the menu is already displayed it
	       * calls the menu to ask it to hide (it will animate), then it repositions the menu
	       * to the right place whilst hidden (it will make an assumption on menu width),
	       * then it asks the menu to show (it will animate), then it repositions the menu again
	       * once we can calculate it's size.
	       * @param {GridColumn} column the column we want to position below
	       * @param {element} $columnElement the column element we want to position below
	       */
	      $scope.showMenu = function(column, $columnElement, event) {
	        // Swap to this column
	        $scope.col = column;
	
	        // Get the position information for the column element
	        var colElementPosition = uiGridColumnMenuService.getColumnElementPosition( $scope, column, $columnElement );
	
	        if ($scope.menuShown) {
	          // we want to hide, then reposition, then show, but we want to wait for animations
	          // we set a variable, and then rely on the menu-hidden event to call the reposition and show
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.hideThenShow = true;
	
	          $scope.$broadcast('hide-menu', { originalEvent: event });
	        } else {
	          $scope.menuShown = true;
	
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.$broadcast('show-menu', { originalEvent: event });
	        }
	      };
	
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name hideMenu
	       * @description Hides the column menu.
	       * @param {boolean} broadcastTrigger true if we were triggered by a broadcast
	       * from the menu itself - in which case don't broadcast again as we'll get
	       * an infinite loop
	       */
	      $scope.hideMenu = function( broadcastTrigger ) {
	        $scope.menuShown = false;
	        if ( !broadcastTrigger ) {
	          $scope.$broadcast('hide-menu');
	        }
	      };
	
	
	      $scope.$on('menu-hidden', function() {
	        var menuItems = angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0];
	
	        $elm[0].removeAttribute('style');
	
	        if ( $scope.hideThenShow ) {
	          delete $scope.hideThenShow;
	
	          $scope.$broadcast('show-menu');
	
	          $scope.menuShown = true;
	        } else {
	          $scope.hideMenu( true );
	
	          if ($scope.col && $scope.col.visible) {
	            // Focus on the menu button
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + $scope.col.getColClass()+ ' .ui-grid-column-menu-button', $scope.col.grid, false)
	                .catch(angular.noop);
	          }
	        }
	
	        if (menuItems) {
	          menuItems.onkeydown = null;
	          angular.forEach(menuItems.children, function removeHandlers(item) {
	            item.onkeydown = null;
	          });
	        }
	      });
	
	      $scope.$on('menu-shown', function() {
	        $timeout(function() {
	          uiGridColumnMenuService.repositionMenu( $scope, $scope.col, $scope.colElementPosition, $elm, $scope.colElement );
	
	          var hasVisibleMenuItems = $scope.menuItems.some(function (menuItem) {
	              return menuItem.shown();
	          });
	
	          // automatically set the focus to the first button element in the now open menu.
	          if (hasVisibleMenuItems) {
	            gridUtil.focus.bySelector($document, '.ui-grid-menu-items .ui-grid-menu-item:not(.ng-hide)', true)
	                .catch(angular.noop);
	          }
	
	          delete $scope.colElementPosition;
	          delete $scope.columnElement;
	          addKeydownHandlersToMenu();
	        });
	      });
	
	
	      /* Column methods */
	      $scope.sortColumn = function (event, dir) {
	        event.stopPropagation();
	
	        $scope.grid.sortColumn($scope.col, dir, true)
	          .then(function () {
	            $scope.grid.refresh();
	            $scope.hideMenu();
	          }).catch(angular.noop);
	      };
	
	      $scope.unsortColumn = function () {
	        $scope.col.unsort();
	
	        $scope.grid.refresh();
	        $scope.hideMenu();
	      };
	
	      function addKeydownHandlersToMenu() {
	        var menu = angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0],
	          menuItems,
	          visibleMenuItems = [];
	
	        if (menu) {
	          menu.onkeydown = function closeMenu(event) {
	            if (event.keyCode === uiGridConstants.keymap.ESC) {
	              event.preventDefault();
	              $scope.hideMenu();
	            }
	          };
	
	          menuItems = menu.querySelectorAll('.ui-grid-menu-item:not(.ng-hide)');
	          angular.forEach(menuItems, function filterVisibleItems(item) {
	            if (item.offsetParent !== null) {
	              this.push(item);
	            }
	          }, visibleMenuItems);
	
	          if (visibleMenuItems.length) {
	            if (visibleMenuItems.length === 1) {
	              visibleMenuItems[0].onkeydown = function singleItemHandler(event) {
	                circularFocusHandler(event, true);
	              };
	            } else {
	              visibleMenuItems[0].onkeydown = function firstItemHandler(event) {
	                circularFocusHandler(event, false, event.shiftKey, visibleMenuItems.length - 1);
	              };
	              visibleMenuItems[visibleMenuItems.length - 1].onkeydown = function lastItemHandler(event) {
	                circularFocusHandler(event, false, !event.shiftKey, 0);
	              };
	            }
	          }
	        }
	
	        function circularFocusHandler(event, isSingleItem, shiftKeyStatus, index) {
	          if (event.keyCode === uiGridConstants.keymap.TAB) {
	            if (isSingleItem) {
	              event.preventDefault();
	            } else if (shiftKeyStatus) {
	              event.preventDefault();
	              visibleMenuItems[index].focus();
	            }
	          }
	        }
	      }
	
	      // Since we are hiding this column the default hide action will fail so we need to focus somewhere else.
	      var setFocusOnHideColumn = function() {
	        $timeout(function() {
	          // Get the UID of the first
	          var focusToGridMenu = function() {
	            return gridUtil.focus.byId('grid-menu', $scope.grid);
	          };
	
	          var thisIndex;
	          $scope.grid.columns.some(function(element, index) {
	            if (angular.equals(element, $scope.col)) {
	              thisIndex = index;
	              return true;
	            }
	          });
	
	          var previousVisibleCol;
	          // Try and find the next lower or nearest column to focus on
	          $scope.grid.columns.some(function(element, index) {
	            if (!element.visible) {
	              return false;
	            } // This columns index is below the current column index
	            else if ( index < thisIndex) {
	              previousVisibleCol = element;
	            } // This elements index is above this column index and we haven't found one that is lower
	            else if ( index > thisIndex && !previousVisibleCol) {
	              // This is the next best thing
	              previousVisibleCol = element;
	              // We've found one so use it.
	              return true;
	            } // We've reached an element with an index above this column and the previousVisibleCol variable has been set
	            else if (index > thisIndex && previousVisibleCol) {
	              // We are done.
	              return true;
	            }
	          });
	          // If found then focus on it
	          if (previousVisibleCol) {
	            var colClass = previousVisibleCol.getColClass();
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + colClass+ ' .ui-grid-header-cell-primary-focus', true).then(angular.noop, function(reason) {
	              if (reason !== 'canceled') { // If this is canceled then don't perform the action
	                // The fallback action is to focus on the grid menu
	                return focusToGridMenu();
	              }
	            }).catch(angular.noop);
	          } else {
	            // Fallback action to focus on the grid menu
	            focusToGridMenu();
	          }
	        });
	      };
	
	      $scope.hideColumn = function () {
	        $scope.col.colDef.visible = false;
	        $scope.col.visible = false;
	
	        $scope.grid.queueGridRefresh();
	        $scope.hideMenu();
	        $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	        $scope.grid.api.core.raise.columnVisibilityChanged( $scope.col );
	
	        // We are hiding so the default action of focusing on the button that opened this menu will fail.
	        setFocusOnHideColumn();
	      };
	    },
	
	    controller: ['$scope', function ($scope) {
	      var self = this;
	
	      $scope.$watch('menuItems', function (n) {
	        self.menuItems = n;
	      });
	    }]
	  };
	}]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFilter', ['$compile', '$templateCache', 'i18nService', 'gridUtil', function ($compile, $templateCache, i18nService, gridUtil) {
	
	    return {
	      compile: function() {
	        return {
	          pre: function ($scope, $elm) {
	            $scope.col.updateFilters = function( filterable ) {
	              $elm.children().remove();
	              if ( filterable ) {
	                var template = $scope.col.filterHeaderTemplate;
	                if (template === undefined && $scope.col.providedFilterHeaderTemplate !== '') {
	                  if ($scope.col.filterHeaderTemplatePromise) {
	                    $scope.col.filterHeaderTemplatePromise.then(function () {
	                      template = $scope.col.filterHeaderTemplate;
	                      $elm.append($compile(template)($scope));
	                    });
	                  }
	                }
	                else {
	                  $elm.append($compile(template)($scope));
	                }
	              }
	            };
	
	            $scope.$on( '$destroy', function() {
	              delete $scope.col.filterable;
	              delete $scope.col.updateFilters;
	            });
	          },
	          post: function ($scope, $elm) {
	            $scope.aria = i18nService.getSafeText('headerCell.aria');
	            $scope.removeFilter = function(colFilter, index) {
	              colFilter.term = null;
	              // Set the focus to the filter input after the action disables the button
	              gridUtil.focus.bySelector($elm, '.ui-grid-filter-input-' + index);
	            };
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooterCell', ['$timeout', 'gridUtil', 'uiGridConstants', '$compile',
	  function ($timeout, gridUtil, uiGridConstants, $compile) {
	    return {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      replace: true,
	      require: '^uiGrid',
	      compile: function compile() {
	        return {
	          pre: function ($scope, $elm) {
	            var template = $scope.col.footerCellTemplate;
	
	            if (template === undefined && $scope.col.providedFooterCellTemplate !== '') {
	              if ($scope.col.footerCellTemplatePromise) {
	                $scope.col.footerCellTemplatePromise.then(function () {
	                  template = $scope.col.footerCellTemplate;
	                  $elm.append($compile(template)($scope));
	                });
	              }
	            }
	            else {
	              $elm.append($compile(template)($scope));
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            // $elm.addClass($scope.col.getColClass(false));
	            $scope.grid = uiGridCtrl.grid;
	
	            var initColClass = $scope.col.getColClass(false);
	
	            $elm.addClass(initColClass);
	
	            // apply any footerCellClass
	            var classAdded;
	
	            var updateClass = function() {
	              var contents = $elm;
	
	              if ( classAdded ) {
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	
	              if (angular.isFunction($scope.col.footerCellClass)) {
	                classAdded = $scope.col.footerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.footerCellClass;
	              }
	              contents.addClass(classAdded);
	            };
	
	            if ($scope.col.footerCellClass) {
	              updateClass();
	            }
	
	            $scope.col.updateAggregationValue();
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN]);
	
	            // listen for visible rows change and update aggregation values
	            $scope.grid.api.core.on.rowsRendered( $scope, $scope.col.updateAggregationValue );
	            $scope.grid.api.core.on.rowsRendered( $scope, updateClass );
	            $scope.$on( '$destroy', dataChangeDereg );
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', function ($templateCache, $compile, uiGridConstants, gridUtil, $timeout) {
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      // priority: 1000,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            containerCtrl.footer = $elm;
	
	            var footerTemplate = $scope.grid.options.footerTemplate;
	            gridUtil.getTemplate(footerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.append(newElm);
	
	                if (containerCtrl) {
	                  // Inject a reference to the footer viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	
	                  if (footerViewport) {
	                    containerCtrl.footerViewport = footerViewport;
	                  }
	                }
	              }).catch(angular.noop);
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-footer link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate footer cells
	            gridUtil.disableAnimations($elm);
	
	            containerCtrl.footer = $elm;
	
	            var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	            if (footerViewport) {
	              containerCtrl.footerViewport = footerViewport;
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function() {
		'use strict';
	
		angular.module('ui.grid').directive('uiGridGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil',
			function($templateCache, $compile, uiGridConstants, gridUtil) {
				return {
					restrict: 'EA',
					replace: true,
					require: '^uiGrid',
					scope: true,
					compile: function() {
						return {
							pre: function($scope, $elm, $attrs, uiGridCtrl) {
								$scope.grid = uiGridCtrl.grid;
	
								var footerTemplate = $scope.grid.options.gridFooterTemplate;
	
								gridUtil.getTemplate(footerTemplate)
									.then(function(contents) {
										var template = angular.element(contents),
											newElm = $compile(template)($scope);
	
										$elm.append(newElm);
									}).catch(angular.noop);
							}
						};
					}
				};
			}]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeaderCell', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'ScrollEvent', 'i18nService', '$rootScope',
	  function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, ScrollEvent, i18nService, $rootScope) {
	    // Do stuff after mouse has been down this many ms on the header cell
	    var mousedownTimeout = 500,
	      changeModeTimeout = 500; // length of time between a touch event and a mouse event being recognised again, and vice versa
	
	    return {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      replace: true,
	      compile: function() {
	        return {
	          pre: function ($scope, $elm) {
	            var template = $scope.col.headerCellTemplate;
	            if (template === undefined && $scope.col.providedHeaderCellTemplate !== '') {
	              if ($scope.col.headerCellTemplatePromise) {
	                $scope.col.headerCellTemplatePromise.then(function () {
	                  template = $scope.col.headerCellTemplate;
	                  $elm.append($compile(template)($scope));
	                });
	              }
	            }
	            else {
	              $elm.append($compile(template)($scope));
	            }
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var renderContainerCtrl = controllers[1];
	
	            $scope.i18n = {
	              headerCell: i18nService.getSafeText('headerCell'),
	              sort: i18nService.getSafeText('sort')
	            };
	            $scope.isSortPriorityVisible = function() {
	              // show sort priority if column is sorted and there is at least one other sorted column
	              return $scope.col && $scope.col.sort && angular.isNumber($scope.col.sort.priority) && $scope.grid.columns.some(function(element, index) {
	                  return angular.isNumber(element.sort.priority) && element !== $scope.col;
	                });
	            };
	            $scope.getSortDirectionAriaLabel = function() {
	              var col = $scope.col;
	              // Trying to recreate this sort of thing but it was getting messy having it in the template.
	              // Sort direction {{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending': 'none')}}.
	              // {{col.sort.priority ? {{columnPriorityText}} {{col.sort.priority}} : ''}
	              var label = col.sort && col.sort.direction === uiGridConstants.ASC ? $scope.i18n.sort.ascending : ( col.sort && col.sort.direction === uiGridConstants.DESC ? $scope.i18n.sort.descending : $scope.i18n.sort.none);
	
	              if ($scope.isSortPriorityVisible()) {
	                label = label + '. ' + $scope.i18n.headerCell.priority + ' ' + (col.sort.priority + 1);
	              }
	              return label;
	            };
	
	            $scope.grid = uiGridCtrl.grid;
	
	            $scope.renderContainer = uiGridCtrl.grid.renderContainers[renderContainerCtrl.containerId];
	
	            var initColClass = $scope.col.getColClass(false);
	            $elm.addClass(initColClass);
	
	            // Hide the menu by default
	            $scope.menuShown = false;
	
	            // Put asc and desc sort directions in scope
	            $scope.asc = uiGridConstants.ASC;
	            $scope.desc = uiGridConstants.DESC;
	
	            // Store a reference to menu element
	            var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	
	            // apply any headerCellClass
	            var classAdded,
	              previousMouseX;
	
	            // filter watchers
	            var filterDeregisters = [];
	
	
	            /*
	             * Our basic approach here for event handlers is that we listen for a down event (mousedown or touchstart).
	             * Once we have a down event, we need to work out whether we have a click, a drag, or a
	             * hold.  A click would sort the grid (if sortable).  A drag would be used by moveable, so
	             * we ignore it.  A hold would open the menu.
	             *
	             * So, on down event, we put in place handlers for move and up events, and a timer.  If the
	             * timer expires before we see a move or up, then we have a long press and hence a column menu open.
	             * If the up happens before the timer, then we have a click, and we sort if the column is sortable.
	             * If a move happens before the timer, then we are doing column move, so we do nothing, the moveable feature
	             * will handle it.
	             *
	             * To deal with touch enabled devices that also have mice, we only create our handlers when
	             * we get the down event, and we create the corresponding handlers - if we're touchstart then
	             * we get touchmove and touchend, if we're mousedown then we get mousemove and mouseup.
	             *
	             * We also suppress the click action whilst this is happening - otherwise after the mouseup there
	             * will be a click event and that can cause the column menu to close
	             *
	             */
	            $scope.downFn = function( event ) {
	              event.stopPropagation();
	
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Don't show the menu if it's not the left button
	              if (event.button && event.button !== 0) {
	                return;
	              }
	              previousMouseX = event.pageX;
	
	              $scope.mousedownStartTime = (new Date()).getTime();
	              $scope.mousedownTimeout = $timeout(function() { }, mousedownTimeout);
	
	              $scope.mousedownTimeout.then(function () {
	                if ( $scope.colMenu ) {
	                  uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm, event);
	                }
	              }).catch(angular.noop);
	
	              uiGridCtrl.fireEvent(uiGridConstants.events.COLUMN_HEADER_CLICK, {event: event, columnName: $scope.col.colDef.name});
	
	              $scope.offAllEvents();
	              if ( event.type === 'touchstart') {
	                $document.on('touchend', $scope.upFn);
	                $document.on('touchmove', $scope.moveFn);
	              } else if ( event.type === 'mousedown' ) {
	                $document.on('mouseup', $scope.upFn);
	                $document.on('mousemove', $scope.moveFn);
	              }
	            };
	
	            $scope.upFn = function( event ) {
	              event.stopPropagation();
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	
	              var mousedownEndTime = (new Date()).getTime();
	              var mousedownTime = mousedownEndTime - $scope.mousedownStartTime;
	
	              if (mousedownTime > mousedownTimeout) {
	                // long click, handled above with mousedown
	              }
	              else {
	                // short click
	                if ( $scope.sortable ) {
	                  $scope.handleClick(event);
	                }
	              }
	            };
	
	            $scope.handleKeyDown = function(event) {
	              if (event.keyCode === 32 || event.keyCode === 13) {
	                event.preventDefault();
	                $scope.handleClick(event);
	              }
	            };
	
	            $scope.moveFn = function( event ) {
	              // Chrome is known to fire some bogus move events.
	              var changeValue = event.pageX - previousMouseX;
	              if ( changeValue === 0 ) { return; }
	
	              // we're a move, so do nothing and leave for column move (if enabled) to take over
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	            };
	
	            $scope.clickFn = function ( event ) {
	              event.stopPropagation();
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	
	            $scope.offAllEvents = function() {
	              $contentsElm.off('touchstart', $scope.downFn);
	              $contentsElm.off('mousedown', $scope.downFn);
	
	              $document.off('touchend', $scope.upFn);
	              $document.off('mouseup', $scope.upFn);
	
	              $document.off('touchmove', $scope.moveFn);
	              $document.off('mousemove', $scope.moveFn);
	
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	            $scope.onDownEvents = function( type ) {
	              // If there is a previous event, then wait a while before
	              // activating the other mode - i.e. if the last event was a touch event then
	              // don't enable mouse events for a wee while (500ms or so)
	              // Avoids problems with devices that emulate mouse events when you have touch events
	
	              switch (type) {
	                case 'touchmove':
	                case 'touchend':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $timeout(function() {
	                    $contentsElm.on('mousedown', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                case 'mousemove':
	                case 'mouseup':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	                  $timeout(function() {
	                    $contentsElm.on('touchstart', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                default:
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	              }
	            };
	
	            var setFilter = function (updateFilters) {
	              if ( updateFilters ) {
	                if ( typeof($scope.col.updateFilters) !== 'undefined' ) {
	                  $scope.col.updateFilters($scope.col.filterable);
	                }
	
	                // if column is filterable add a filter watcher
	                if ($scope.col.filterable) {
	                  $scope.col.filters.forEach( function(filter, i) {
	                    filterDeregisters.push($scope.$watch('col.filters[' + i + '].term', function(n, o) {
	                      if (n !== o) {
	                        uiGridCtrl.grid.api.core.raise.filterChanged( $scope.col );
	                        uiGridCtrl.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	                        uiGridCtrl.grid.queueGridRefresh();
	                      }
	                    }));
	                  });
	                  $scope.$on('$destroy', function() {
	                    filterDeregisters.forEach( function(filterDeregister) {
	                      filterDeregister();
	                    });
	                  });
	                } else {
	                  filterDeregisters.forEach( function(filterDeregister) {
	                    filterDeregister();
	                  });
	                }
	              }
	            };
	
	            var updateHeaderOptions = function() {
	              var contents = $elm;
	
	              if ( classAdded ) {
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	
	              if (angular.isFunction($scope.col.headerCellClass)) {
	                classAdded = $scope.col.headerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.headerCellClass;
	              }
	              contents.addClass(classAdded);
	
	              $scope.$applyAsync(function() {
	                var rightMostContainer = $scope.grid.renderContainers['right'] && $scope.grid.renderContainers['right'].visibleColumnCache.length ?
	                $scope.grid.renderContainers['right'] : $scope.grid.renderContainers['body'];
	                $scope.isLastCol = uiGridCtrl.grid.options && uiGridCtrl.grid.options.enableGridMenu &&
	                  $scope.col === rightMostContainer.visibleColumnCache[ rightMostContainer.visibleColumnCache.length - 1 ];
	              });
	
	              // Figure out whether this column is sortable or not
	              $scope.sortable = Boolean($scope.col.enableSorting);
	
	              // Figure out whether this column is filterable or not
	              var oldFilterable = $scope.col.filterable;
	              $scope.col.filterable = Boolean(uiGridCtrl.grid.options.enableFiltering && $scope.col.enableFiltering);
	
	              $scope.$applyAsync(function () {
	                setFilter(oldFilterable !== $scope.col.filterable);
	              });
	
	              // figure out whether we support column menus
	              $scope.colMenu = ($scope.col.grid.options && $scope.col.grid.options.enableColumnMenus !== false &&
	                      $scope.col.colDef && $scope.col.colDef.enableColumnMenu !== false);
	
	              /**
	               * @ngdoc property
	               * @name enableColumnMenu
	               * @propertyOf ui.grid.class:GridOptions.columnDef
	               * @description if column menus are enabled, controls the column menus for this specific
	               * column (i.e. if gridOptions.enableColumnMenus, then you can control column menus
	               * using this option. If gridOptions.enableColumnMenus === false then you get no column
	               * menus irrespective of the value of this option ).  Defaults to true.
	               *
	               * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
	               *
	               * <pre>
	               *  .ui-grid-column-menu-button {
	               *    display: block;
	               *  }
	               * </pre>
	               */
	              /**
	              * @ngdoc property
	              * @name enableColumnMenus
	              * @propertyOf ui.grid.class:GridOptions.columnDef
	              * @description Override for column menus everywhere - if set to false then you get no
	              * column menus.  Defaults to true.
	              *
	              */
	
	              $scope.offAllEvents();
	
	              if ($scope.sortable || $scope.colMenu) {
	                $scope.onDownEvents();
	
	                $scope.$on('$destroy', function () {
	                  $scope.offAllEvents();
	                });
	              }
	            };
	
	            updateHeaderOptions();
	
	            if ($scope.col.filterContainer === 'columnMenu' && $scope.col.filterable) {
	              $rootScope.$on('menu-shown', function() {
	                $scope.$applyAsync(function () {
	                  setFilter($scope.col.filterable);
	                });
	              });
	            }
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateHeaderOptions, [uiGridConstants.dataChange.COLUMN]);
	
	            $scope.$on( '$destroy', dataChangeDereg );
	
	            $scope.handleClick = function(event) {
	              // If the shift key is being held down, add this column to the sort
	              var add = false;
	              if (event.shiftKey) {
	                add = true;
	              }
	
	              // Sort this column then rebuild the grid's rows
	              uiGridCtrl.grid.sortColumn($scope.col, add)
	                .then(function () {
	                  if (uiGridCtrl.columnMenuScope) { uiGridCtrl.columnMenuScope.hideMenu(); }
	                  uiGridCtrl.grid.refresh();
	                }).catch(angular.noop);
	            };
	
	            $scope.headerCellArrowKeyDown = function(event) {
	              if (event.keyCode === 32 || event.keyCode === 13) {
	                event.preventDefault();
	                $scope.toggleMenu(event);
	              }
	            };
	
	            $scope.toggleMenu = function(event) {
	
	              event.stopPropagation();
	
	              // If the menu is already showing...
	              if (uiGridCtrl.columnMenuScope.menuShown) {
	                // ... and we're the column the menu is on...
	                if (uiGridCtrl.columnMenuScope.col === $scope.col) {
	                  // ... hide it
	                  uiGridCtrl.columnMenuScope.hideMenu();
	                }
	                // ... and we're NOT the column the menu is on
	                else {
	                  // ... move the menu to our column
	                  uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm);
	                }
	              }
	              // If the menu is NOT showing
	              else {
	                // ... show it on our column
	                uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm);
	              }
	            };
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeader', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', 'ScrollEvent',
	    function($templateCache, $compile, uiGridConstants, gridUtil, $timeout, ScrollEvent) {
	    var defaultTemplate = 'ui-grid/ui-grid-header',
	      emptyTemplate = 'ui-grid/ui-grid-no-header';
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function() {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0],
	              containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            updateHeaderReferences();
	
	            var headerTemplate;
	            if (!$scope.grid.options.showHeader) {
	              headerTemplate = emptyTemplate;
	            }
	            else {
	              headerTemplate = ($scope.grid.options.headerTemplate) ? $scope.grid.options.headerTemplate : defaultTemplate;
	            }
	
	            gridUtil.getTemplate(headerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.replaceWith(newElm);
	
	                // And update $elm to be the new element
	                $elm = newElm;
	
	                updateHeaderReferences();
	
	                if (containerCtrl) {
	                  // Inject a reference to the header viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	
	
	                  if (headerViewport) {
	                    containerCtrl.headerViewport = headerViewport;
	                    angular.element(headerViewport).on('scroll', scrollHandler);
	                    $scope.$on('$destroy', function () {
	                      angular.element(headerViewport).off('scroll', scrollHandler);
	                    });
	                  }
	                }
	
	                $scope.grid.queueRefresh();
	              }).catch(angular.noop);
	
	            function updateHeaderReferences() {
	              containerCtrl.header = containerCtrl.colContainer.header = $elm;
	
	              var headerCanvases = $elm[0].getElementsByClassName('ui-grid-header-canvas');
	
	              if (headerCanvases.length > 0) {
	                containerCtrl.headerCanvas = containerCtrl.colContainer.headerCanvas = headerCanvases[0];
	              }
	              else {
	                containerCtrl.headerCanvas = null;
	              }
	            }
	
	            function scrollHandler() {
	              if (uiGridCtrl.grid.isScrollingHorizontally) {
	                return;
	              }
	              var newScrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.headerViewport, uiGridCtrl.grid);
	              var horizScrollPercentage = containerCtrl.colContainer.scrollHorizontal(newScrollLeft);
	
	              var scrollEvent = new ScrollEvent(uiGridCtrl.grid, null, containerCtrl.colContainer, ScrollEvent.Sources.ViewPortScroll);
	              scrollEvent.newScrollLeft = newScrollLeft;
	              if ( horizScrollPercentage > -1 ) {
	                scrollEvent.x = { percentage: horizScrollPercentage };
	              }
	
	              uiGridCtrl.grid.scrollContainers(null, scrollEvent);
	            }
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-header link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate header cells
	            gridUtil.disableAnimations($elm);
	
	            function updateColumnWidths() {
	              // this styleBuilder always runs after the renderContainer, so we can rely on the column widths
	              // already being populated correctly
	
	              var columnCache = containerCtrl.colContainer.visibleColumnCache;
	
	              // Build the CSS
	              // uiGridCtrl.grid.columns.forEach(function (column) {
	              var ret = '';
	              var canvasWidth = 0;
	              columnCache.forEach(function (column) {
	                ret = ret + column.getColClassDefinition();
	                canvasWidth += column.drawnWidth;
	              });
	
	              containerCtrl.colContainer.canvasWidth = canvasWidth;
	
	              // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	              return ret;
	            }
	
	            containerCtrl.header = $elm;
	
	            var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	            if (headerViewport) {
	              containerCtrl.headerViewport = headerViewport;
	            }
	
	            // todo: remove this if by injecting gridCtrl into unit tests
	            if (uiGridCtrl) {
	              uiGridCtrl.grid.registerStyleComputation({
	                priority: 15,
	                func: updateColumnWidths
	              });
	            }
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.service('uiGridGridMenuService', [ 'gridUtil', 'i18nService', 'uiGridConstants', function( gridUtil, i18nService, uiGridConstants ) {
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.uiGridGridMenuService
	   *
	   *  @description Methods for working with the grid menu
	   */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name initialize
	     * @description Sets up the gridMenu. Most importantly, sets our
	     * scope onto the grid object as grid.gridMenuScope, allowing us
	     * to operate when passed only the grid.  Second most importantly,
	     * we register the 'addToGridMenu' and 'removeFromGridMenu' methods
	     * on the core api.
	     * @param {$scope} $scope the scope of this gridMenu
	     * @param {Grid} grid the grid to which this gridMenu is associated
	     */
	    initialize: function( $scope, grid ) {
	      grid.gridMenuScope = $scope;
	      $scope.grid = grid;
	      $scope.registeredMenuItems = [];
	
	      // not certain this is needed, but would be bad to create a memory leak
	      $scope.$on('$destroy', function() {
	        if ( $scope.grid && $scope.grid.gridMenuScope ) {
	          $scope.grid.gridMenuScope = null;
	        }
	        if ( $scope.grid ) {
	          $scope.grid = null;
	        }
	        if ( $scope.registeredMenuItems ) {
	          $scope.registeredMenuItems = null;
	        }
	      });
	
	      $scope.registeredMenuItems = [];
	
	      /**
	       * @ngdoc function
	       * @name addToGridMenu
	       * @methodOf ui.grid.api:PublicApi
	       * @description add items to the grid menu.  Used by features
	       * to add their menu items if they are enabled, can also be used by
	       * end users to add menu items.  This method has the advantage of allowing
	       * remove again, which can simplify management of which items are included
	       * in the menu when.  (Noting that in most cases the shown and active functions
	       * provide a better way to handle visibility of menu items)
	       * @param {Grid} grid the grid on which we are acting
	       * @param {array} items menu items in the format as described in the tutorial, with
	       * the added note that if you want to use remove you must also specify an `id` field,
	       * which is provided when you want to remove an item.  The id should be unique.
	       *
	       */
	      grid.api.registerMethod( 'core', 'addToGridMenu', service.addToGridMenu );
	
	      /**
	       * @ngdoc function
	       * @name removeFromGridMenu
	       * @methodOf ui.grid.api:PublicApi
	       * @description Remove an item from the grid menu based on a provided id. Assumes
	       * that the id is unique, removes only the last instance of that id. Does nothing if
	       * the specified id is not found
	       * @param {Grid} grid the grid on which we are acting
	       * @param {string} id the id we'd like to remove from the menu
	       *
	       */
	      grid.api.registerMethod( 'core', 'removeFromGridMenu', service.removeFromGridMenu );
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name addToGridMenu
	     * @propertyOf ui.grid.uiGridGridMenuService
	     * @description add items to the grid menu.  Used by features
	     * to add their menu items if they are enabled, can also be used by
	     * end users to add menu items.  This method has the advantage of allowing
	     * remove again, which can simplify management of which items are included
	     * in the menu when.  (Noting that in most cases the shown and active functions
	     * provide a better way to handle visibility of menu items)
	     * @param {Grid} grid the grid on which we are acting
	     * @param {array} menuItems menu items in the format as described in the tutorial, with
	     * the added note that if you want to use remove you must also specify an `id` field,
	     * which is provided when you want to remove an item.  The id should be unique.
	     *
	     */
	    addToGridMenu: function( grid, menuItems ) {
	      if ( !angular.isArray( menuItems ) ) {
	        gridUtil.logError( 'addToGridMenu: menuItems must be an array, and is not, not adding any items');
	      } else {
	        if ( grid.gridMenuScope ) {
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems ? grid.gridMenuScope.registeredMenuItems : [];
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems.concat( menuItems );
	        } else {
	          gridUtil.logError( 'Asked to addToGridMenu, but gridMenuScope not present.  Timing issue?  Please log issue with ui-grid');
	        }
	      }
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name removeFromGridMenu
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @description Remove an item from the grid menu based on a provided id.  Assumes
	     * that the id is unique, removes only the last instance of that id.  Does nothing if
	     * the specified id is not found.  If there is no gridMenuScope or registeredMenuItems
	     * then do nothing silently - the desired result is those menu items not be present and they
	     * aren't.
	     * @param {Grid} grid the grid on which we are acting
	     * @param {string} id the id we'd like to remove from the menu
	     *
	     */
	    removeFromGridMenu: function( grid, id ) {
	      var foundIndex = -1;
	
	      if ( grid && grid.gridMenuScope ) {
	        grid.gridMenuScope.registeredMenuItems.forEach( function( value, index ) {
	          if ( value.id === id ) {
	            if (foundIndex > -1) {
	              gridUtil.logError( 'removeFromGridMenu: found multiple items with the same id, removing only the last' );
	            } else {
	
	              foundIndex = index;
	            }
	          }
	        });
	      }
	
	      if ( foundIndex > -1 ) {
	        grid.gridMenuScope.registeredMenuItems.splice( foundIndex, 1 );
	      }
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuCustomItems
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) An array of menu items that should be added to
	     * the gridMenu.  Follow the format documented in the tutorial for column
	     * menu customisation.  The context provided to the action function will
	     * include context.grid.  An alternative if working with dynamic menus is to use the
	     * provided api - core.addToGridMenu and core.removeFromGridMenu, which handles
	     * some of the management of items for you.
	     *
	     */
	    /**
	     * @ngdoc boolean
	     * @name gridMenuShowHideColumns
	     * @propertyOf ui.grid.class:GridOptions
	     * @description true by default, whether the grid menu should allow hide/show
	     * of columns
	     *
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name getMenuItems
	     * @description Decides the menu items to show in the menu.  This is a
	     * combination of:
	     *
	     * - the default menu items that are always included,
	     * - any menu items that have been provided through the addMenuItem api. These
	     *   are typically added by features within the grid
	     * - any menu items included in grid.options.gridMenuCustomItems.  These can be
	     *   changed dynamically, as they're always recalculated whenever we show the
	     *   menu
	     * @param {$scope} $scope the scope of this gridMenu, from which we can find all
	     * the information that we need
	     * @returns {Array} an array of menu items that can be shown
	     */
	    getMenuItems: function( $scope ) {
	      var menuItems = [
	        // this is where we add any menu items we want to always include
	      ];
	
	      if ( $scope.grid.options.gridMenuCustomItems ) {
	        if ( !angular.isArray( $scope.grid.options.gridMenuCustomItems ) ) {
	          gridUtil.logError( 'gridOptions.gridMenuCustomItems must be an array, and is not');
	        } else {
	          menuItems = menuItems.concat( $scope.grid.options.gridMenuCustomItems );
	        }
	      }
	
	      var clearFilters = [{
	        title: i18nService.getSafeText('gridMenu.clearAllFilters'),
	        action: function ($event) {
	          $scope.grid.clearAllFilters();
	        },
	        shown: function() {
	          return $scope.grid.options.enableFiltering;
	        },
	        order: 100
	      }];
	      menuItems = menuItems.concat( clearFilters );
	
	      menuItems = menuItems.concat( $scope.registeredMenuItems );
	
	      if ( $scope.grid.options.gridMenuShowHideColumns !== false ) {
	        menuItems = menuItems.concat( service.showHideColumns( $scope ) );
	      }
	
	      menuItems.sort(function(a, b) {
	        return a.order - b.order;
	      });
	
	      return menuItems;
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuTitleFilter
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) A function that takes a title string
	     * (usually the col.displayName), and converts it into a display value.  The function
	     * must return either a string or a promise.
	     *
	     * Used for internationalization of the grid menu column names - for angular-translate
	     * you can pass $translate as the function, for i18nService you can pass getSafeText as the
	     * function
	     * @example
	     * <pre>
	     *   gridOptions = {
	     *     gridMenuTitleFilter: $translate
	     *   }
	     * </pre>
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name showHideColumns
	     * @description Adds two menu items for each of the columns in columnDefs.  One
	     * menu item for hide, one menu item for show.  Each is visible when appropriate
	     * (show when column is not visible, hide when column is visible).  Each toggles
	     * the visible property on the columnDef using toggleColumnVisibility
	     * @param {$scope} $scope of a gridMenu, which contains a reference to the grid
	     */
	    showHideColumns: function( $scope ) {
	      var showHideColumns = [];
	      if ( !$scope.grid.options.columnDefs || $scope.grid.options.columnDefs.length === 0 || $scope.grid.columns.length === 0 ) {
	        return showHideColumns;
	      }
	
	      function isColumnVisible(colDef) {
	        return colDef.visible === true || colDef.visible === undefined;
	      }
	
	      function getColumnIcon(colDef) {
	        return isColumnVisible(colDef) ? 'ui-grid-icon-ok' : 'ui-grid-icon-cancel';
	      }
	
	      // add header for columns
	      showHideColumns.push({
	        title: i18nService.getSafeText('gridMenu.columns'),
	        order: 300,
	        templateUrl: 'ui-grid/ui-grid-menu-header-item'
	      });
	
	      $scope.grid.options.gridMenuTitleFilter = $scope.grid.options.gridMenuTitleFilter ? $scope.grid.options.gridMenuTitleFilter : function( title ) { return title; };
	
	      $scope.grid.options.columnDefs.forEach( function( colDef, index ) {
	        if ( colDef.enableHiding !== false ) {
	          // add hide menu item - shows an OK icon as we only show when column is already visible
	          var menuItem = {
	            icon: getColumnIcon(colDef),
	            action: function($event) {
	              $event.stopPropagation();
	
	              service.toggleColumnVisibility( this.context.gridCol );
	
	              if ($event.target && $event.target.firstChild) {
	                if (angular.element($event.target)[0].nodeName === 'I') {
	                  $event.target.className = getColumnIcon(this.context.gridCol.colDef);
	                }
	                else {
	                  $event.target.firstChild.className = getColumnIcon(this.context.gridCol.colDef);
	                }
	              }
	            },
	            shown: function() {
	              return this.context.gridCol.colDef.enableHiding !== false;
	            },
	            context: { gridCol: $scope.grid.getColumn(colDef.name || colDef.field) },
	            leaveOpen: true,
	            order: 301 + index
	          };
	          service.setMenuItemTitle( menuItem, colDef, $scope.grid );
	          showHideColumns.push( menuItem );
	        }
	      });
	      return showHideColumns;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name setMenuItemTitle
	     * @description Handles the response from gridMenuTitleFilter, adding it directly to the menu
	     * item if it returns a string, otherwise waiting for the promise to resolve or reject then
	     * putting the result into the title
	     * @param {object} menuItem the menuItem we want to put the title on
	     * @param {object} colDef the colDef from which we can get displayName, name or field
	     * @param {Grid} grid the grid, from which we can get the options.gridMenuTitleFilter
	     *
	     */
	    setMenuItemTitle: function( menuItem, colDef, grid ) {
	      var title = grid.options.gridMenuTitleFilter( colDef.displayName || gridUtil.readableColumnName(colDef.name) || colDef.field );
	
	      if ( typeof(title) === 'string' ) {
	        menuItem.title = title;
	      } else if ( title.then ) {
	        // must be a promise
	        menuItem.title = "";
	        title.then( function( successValue ) {
	          menuItem.title = successValue;
	        }, function( errorValue ) {
	          menuItem.title = errorValue;
	        }).catch(angular.noop);
	      } else {
	        gridUtil.logError('Expected gridMenuTitleFilter to return a string or a promise, it has returned neither, bad config');
	        menuItem.title = 'badconfig';
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name toggleColumnVisibility
	     * @description Toggles the visibility of an individual column.  Expects to be
	     * provided a context that has on it a gridColumn, which is the column that
	     * we'll operate upon.  We change the visibility, and refresh the grid as appropriate
	     * @param {GridColumn} gridCol the column that we want to toggle
	     *
	     */
	    toggleColumnVisibility: function( gridCol ) {
	      gridCol.colDef.visible = !( gridCol.colDef.visible === true || gridCol.colDef.visible === undefined );
	
	      gridCol.grid.refresh();
	      gridCol.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	      gridCol.grid.api.core.raise.columnVisibilityChanged( gridCol );
	    }
	  };
	
	  return service;
	}])
	
	.directive('uiGridMenuButton', ['gridUtil', 'uiGridConstants', 'uiGridGridMenuService', 'i18nService',
	function (gridUtil, uiGridConstants, uiGridGridMenuService, i18nService) {
	
	  return {
	    priority: 0,
	    scope: true,
	    require: ['^uiGrid'],
	    templateUrl: 'ui-grid/ui-grid-menu-button',
	    replace: true,
	
	    link: function ($scope, $elm, $attrs, controllers) {
	      var uiGridCtrl = controllers[0];
	
	      // For the aria label
	      $scope.i18n = {
	        aria: i18nService.getSafeText('gridMenu.aria')
	      };
	
	      uiGridGridMenuService.initialize($scope, uiGridCtrl.grid);
	
	      $scope.shown = false;
	
	      $scope.toggleMenu = function () {
	        if ( $scope.shown ) {
	          $scope.$broadcast('hide-menu');
	          $scope.shown = false;
	        } else {
	          $scope.menuItems = uiGridGridMenuService.getMenuItems( $scope );
	          $scope.$broadcast('show-menu');
	          $scope.shown = true;
	        }
	      };
	
	      $scope.$on('menu-hidden', function() {
	        $scope.shown = false;
	        gridUtil.focus.bySelector($elm, '.ui-grid-icon-container');
	      });
	    }
	  };
	}]);
	})();
	
	(function() {
	
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridMenu
	 * @element style
	 * @restrict A
	 *
	 * @description
	 * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	 *
	 * @example
	 <doc:example module="app">
	 <doc:source>
	 <script>
	 var app = angular.module('app', ['ui.grid']);
	
	 app.controller('MainCtrl', ['$scope', function ($scope) {
	
	 }]);
	 </script>
	
	 <div ng-controller="MainCtrl">
	   <div ui-grid-menu shown="true"  ></div>
	 </div>
	 </doc:source>
	 <doc:scenario>
	 </doc:scenario>
	 </doc:example>
	 */
	angular.module('ui.grid')
	
	.directive('uiGridMenu', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'i18nService',
	function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, i18nService) {
	  return {
	    priority: 0,
	    scope: {
	      // shown: '&',
	      menuItems: '=',
	      autoHide: '=?',
	      col: '=?'
	    },
	    require: '?^uiGrid',
	    templateUrl: 'ui-grid/uiGridMenu',
	    replace: false,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      $scope.dynamicStyles = '';
	      if (uiGridCtrl && uiGridCtrl.grid && uiGridCtrl.grid.options && uiGridCtrl.grid.options.gridMenuTemplate) {
	        var gridMenuTemplate = uiGridCtrl.grid.options.gridMenuTemplate;
	        gridUtil.getTemplate(gridMenuTemplate).then(function (contents) {
	          var template = angular.element(contents);
	          var newElm = $compile(template)($scope);
	          $elm.replaceWith(newElm);
	        }).catch(angular.noop);
	      }
	
	      var setupHeightStyle = function(gridHeight) {
	        // menu appears under header row, so substract that height from it's total
	        // additional 20px for general padding
	        var gridMenuMaxHeight = gridHeight - uiGridCtrl.grid.headerHeight - 20;
	        $scope.dynamicStyles = [
	          '.grid' + uiGridCtrl.grid.id + ' .ui-grid-menu-mid {',
	          'max-height: ' + gridMenuMaxHeight + 'px;',
	          '}'
	        ].join(' ');
	      };
	
	      if (uiGridCtrl) {
	        setupHeightStyle(uiGridCtrl.grid.gridHeight);
	        uiGridCtrl.grid.api.core.on.gridDimensionChanged($scope, function(oldGridHeight, oldGridWidth, newGridHeight, newGridWidth) {
	          setupHeightStyle(newGridHeight);
	        });
	      }
	
	      $scope.i18n = {
	        close: i18nService.getSafeText('columnMenu.close')
	      };
	
	    // *** Show/Hide functions ******
	      $scope.showMenu = function(event, args) {
	        if ( !$scope.shown ) {
	
	          /*
	           * In order to animate cleanly we remove the ng-if, wait a digest cycle, then
	           * animate the removal of the ng-hide.  We can't successfully (so far as I can tell)
	           * animate removal of the ng-if, as the menu items aren't there yet.  And we don't want
	           * to rely on ng-show only, as that leaves elements in the DOM that are needlessly evaluated
	           * on scroll events.
	           *
	           * Note when testing animation that animations don't run on the tutorials.  When debugging it looks
	           * like they do, but angular has a default $animate provider that is just a stub, and that's what's
	           * being called.  ALso don't be fooled by the fact that your browser has actually loaded the
	           * angular-translate.js, it's not using it.  You need to test animations in an external application.
	           */
	          $scope.shown = true;
	
	          // Must be a timeout in order to work properly in Firefox. Issue #6533
	          $timeout(function() {
	            $scope.shownMid = true;
	            $scope.$emit('menu-shown');
	          });
	        } else if ( !$scope.shownMid ) {
	          // we're probably doing a hide then show, so we don't need to wait for ng-if
	          $scope.shownMid = true;
	          $scope.$emit('menu-shown');
	        }
	
	        var docEventType = 'click';
	        if (args && args.originalEvent && args.originalEvent.type && args.originalEvent.type === 'touchstart') {
	          docEventType = args.originalEvent.type;
	        }
	
	        // Turn off an existing document click handler
	        angular.element(document).off('click touchstart', applyHideMenu);
	        $elm.off('keyup', checkKeyUp);
	        $elm.off('keydown', checkKeyDown);
	
	        // Turn on the document click handler, but in a timeout so it doesn't apply to THIS click if there is one
	        $timeout(function() {
	          angular.element(document).on(docEventType, applyHideMenu);
	          $elm.on('keyup', checkKeyUp);
	          $elm.on('keydown', checkKeyDown);
	        });
	      };
	
	
	      $scope.hideMenu = function(event) {
	        if ( $scope.shown ) {
	          /*
	           * In order to animate cleanly we animate the addition of ng-hide, then use a $timeout to
	           * set the ng-if (shown = false) after the animation runs.  In theory we can cascade off the
	           * callback on the addClass method, but it is very unreliable with unit tests for no discernable reason.
	           *
	           * The user may have clicked on the menu again whilst
	           * we're waiting, so we check that the mid isn't shown before applying the ng-if.
	           */
	          $scope.shownMid = false;
	          $timeout( function() {
	            if ( !$scope.shownMid ) {
	              $scope.shown = false;
	              $scope.$emit('menu-hidden');
	            }
	          }, 40);
	        }
	
	        angular.element(document).off('click touchstart', applyHideMenu);
	        $elm.off('keyup', checkKeyUp);
	        $elm.off('keydown', checkKeyDown);
	      };
	
	      $scope.$on('hide-menu', function (event, args) {
	        $scope.hideMenu(event, args);
	      });
	
	      $scope.$on('show-menu', function (event, args) {
	        $scope.showMenu(event, args);
	      });
	
	
	    // *** Auto hide when click elsewhere ******
	      var applyHideMenu = function(event) {
	        if ($scope.shown) {
	          if ($scope.col && $scope.col.filterContainer === 'columnMenu') {
	            var elm = document.querySelector('.ui-grid-column-menu').querySelector('[ui-grid-filter]');
	            if (elm && elm.contains(event.target)) {
	              return false;
	            }
	          }
	
	          $scope.$apply(function () {
	            $scope.hideMenu();
	          });
	        }
	      };
	
	      // close menu on ESC and keep tab cyclical
	      var checkKeyUp = function(event) {
	        if (event.keyCode === 27) {
	          $scope.hideMenu();
	        }
	      };
	
	      var checkKeyDown = function(event) {
	        var setFocus = function(elm) {
	          elm.focus();
	          event.preventDefault();
	          return false;
	        };
	        if (event.keyCode === 9) {
	          var firstMenuItem, lastMenuItem;
	          var menuItemButtons = $elm[0].querySelectorAll('button:not(.ng-hide)');
	          if (menuItemButtons.length > 0) {
	            firstMenuItem = menuItemButtons[0];
	            lastMenuItem = menuItemButtons[menuItemButtons.length - 1];
	            if (event.target === lastMenuItem && !event.shiftKey) {
	              setFocus(firstMenuItem);
	            } else if (event.target === firstMenuItem && event.shiftKey) {
	              setFocus(lastMenuItem);
	            }
	          }
	        }
	      };
	
	      if (typeof($scope.autoHide) === 'undefined' || $scope.autoHide === undefined) {
	        $scope.autoHide = true;
	      }
	
	      if ($scope.autoHide) {
	        angular.element($window).on('resize', applyHideMenu);
	      }
	
	      $scope.$on('$destroy', function unbindEvents() {
	        angular.element($window).off('resize', applyHideMenu);
	        angular.element(document).off('click touchstart', applyHideMenu);
	        $elm.off('keyup', checkKeyUp);
	        $elm.off('keydown', checkKeyDown);
	      });
	
	      if (uiGridCtrl) {
	       $scope.$on('$destroy', uiGridCtrl.grid.api.core.on.scrollBegin($scope, applyHideMenu ));
	      }
	
	      $scope.$on('$destroy', $scope.$on(uiGridConstants.events.ITEM_DRAGGING, applyHideMenu ));
	    }
	  };
	}])
	
	.directive('uiGridMenuItem', ['gridUtil', '$compile', 'i18nService', function (gridUtil, $compile, i18nService) {
	  return {
	    priority: 0,
	    scope: {
	      name: '=',
	      active: '=',
	      action: '=',
	      icon: '=',
	      shown: '=',
	      context: '=',
	      templateUrl: '=',
	      leaveOpen: '=',
	      screenReaderOnly: '='
	    },
	    require: ['?^uiGrid'],
	    templateUrl: 'ui-grid/uiGridMenuItem',
	    replace: false,
	    compile: function() {
	      return {
	        pre: function ($scope, $elm) {
	          if ($scope.templateUrl) {
	            gridUtil.getTemplate($scope.templateUrl)
	                .then(function (contents) {
	                  var template = angular.element(contents);
	
	                  var newElm = $compile(template)($scope);
	                  $elm.replaceWith(newElm);
	                }).catch(angular.noop);
	          }
	        },
	        post: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0];
	
	          // TODO(c0bra): validate that shown and active are functions if they're defined. An exception is already thrown above this though
	          // if (typeof($scope.shown) !== 'undefined' && $scope.shown && typeof($scope.shown) !== 'function') {
	          //   throw new TypeError("$scope.shown is defined but not a function");
	          // }
	          if (typeof($scope.shown) === 'undefined' || $scope.shown === null) {
	            $scope.shown = function() { return true; };
	          }
	
	          $scope.itemShown = function () {
	            var context = {};
	            if ($scope.context) {
	              context.context = $scope.context;
	            }
	
	            if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	              context.grid = uiGridCtrl.grid;
	            }
	
	            return $scope.shown.call(context);
	          };
	
	          $scope.itemAction = function($event, title) {
	            $event.stopPropagation();
	
	            if (typeof($scope.action) === 'function') {
	              var context = {};
	
	              if ($scope.context) {
	                context.context = $scope.context;
	              }
	
	              // Add the grid to the function call context if the uiGrid controller is present
	              if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	                context.grid = uiGridCtrl.grid;
	              }
	
	              $scope.action.call(context, $event, title);
	
	              if ( !$scope.leaveOpen ) {
	                $scope.$emit('hide-menu');
	              } else {
	                // Maintain focus on the selected item
	                var correctParent = $event.target.parentElement;
	
	                // nodeName of 'I' means target is i element, need the next parent
	                if (angular.element($event.target)[0].nodeName === 'I') {
	                  correctParent = correctParent.parentElement;
	                }
	
	                gridUtil.focus.bySelector(correctParent, 'button[type=button]', true);
	              }
	            }
	          };
	
	          $scope.label = function() {
	            var toBeDisplayed = $scope.name;
	
	            if (typeof($scope.name) === 'function') {
	              toBeDisplayed = $scope.name.call();
	            }
	
	            return toBeDisplayed;
	          };
	
	          $scope.i18n = i18nService.get();
	        }
	      };
	    }
	  };
	}]);
	
	})();
	
	(function() {
	  'use strict';
	  /**
	   * @ngdoc overview
	   * @name ui.grid.directive:uiGridOneBind
	   * @summary A group of directives that provide a one time bind to a dom element.
	   * @description A group of directives that provide a one time bind to a dom element.
	   * As one time bindings are not supported in Angular 1.2.* this directive provdes this capability.
	   * This is done to reduce the number of watchers on the dom.
	   * <br/>
	   * <h2>Short Example ({@link ui.grid.directive:uiGridOneBindSrc ui-grid-one-bind-src})</h2>
	   * <pre>
	        <div ng-init="imageName = 'myImageDir.jpg'">
	          <img ui-grid-one-bind-src="imageName"></img>
	        </div>
	     </pre>
	   * Will become:
	   * <pre>
	       <div ng-init="imageName = 'myImageDir.jpg'">
	         <img ui-grid-one-bind-src="imageName" src="myImageDir.jpg"></img>
	       </div>
	     </pre>
	     </br>
	     <h2>Short Example ({@link ui.grid.directive:uiGridOneBindText ui-grid-one-bind-text})</h2>
	   * <pre>
	        <div ng-init="text='Add this text'" ui-grid-one-bind-text="text"></div>
	     </pre>
	   * Will become:
	   * <pre>
	   <div ng-init="text='Add this text'" ui-grid-one-bind-text="text">Add this text</div>
	     </pre>
	     </br>
	   * <b>Note:</b> This behavior is slightly different for the {@link ui.grid.directive:uiGridOneBindIdGrid uiGridOneBindIdGrid}
	   * and {@link ui.grid.directive:uiGridOneBindAriaLabelledbyGrid uiGridOneBindAriaLabelledbyGrid} directives.
	   *
	   */
	  // https://github.com/joshkurz/Black-Belt-AngularJS-Directives/blob/master/directives/Optimization/oneBind.js
	  var oneBinders = angular.module('ui.grid');
	  angular.forEach([
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindSrc
	       * @memberof ui.grid.directive:uiGridOneBind
	       * @element img
	       * @restrict A
	       * @param {String} uiGridOneBindSrc The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the src dom tag.
	       *
	       */
	      {tag: 'Src', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindText
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindText The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the text dom tag.
	       */
	      {tag: 'Text', method: 'text'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHref
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHref The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the href dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Href', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindClass
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindClass The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @param {Object} uiGridOneBindClass The object that you want to bind. At least one of the values in the object must be something other than null or undefined for the watcher to be removed.
	       *                                    this is to prevent the watcher from being removed before the scope is initialized.
	       * @param {Array} uiGridOneBindClass An array of classes to bind to this element.
	       * @description One time binding for the class dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Class', method: 'addClass'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHtml
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHtml The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the html method on a dom element. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Html', method: 'html'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAlt
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAlt The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the alt dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Alt', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindStyle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindStyle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the style dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Style', method: 'css'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindValue
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindValue The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Value', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindId
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindId The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Id', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindIdGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindIdGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the id dom tag.
	       * <h1>Important Note!</h1>
	       * If the id tag passed as a parameter does <b>not</b> contain the grid id as a substring
	       * then the directive will search the scope and the parent controller (if it is a uiGridController) for the grid.id value.
	       * If this value is found then it is appended to the begining of the id tag. If the grid is not found then the directive throws an error.
	       * This is done in order to ensure uniqueness of id tags across the grid.
	       * This is to prevent two grids in the same document having duplicate id tags.
	       */
	      {tag: 'Id', directiveName: 'IdGrid', method: 'attr', appendGridId: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindTitle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindTitle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the title dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Title', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabel
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabel The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-label dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text" aria-label="Add this text"></div>
	         </pre>
	       */
	      {tag: 'Label', method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledby
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId" aria-labelledby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledbyGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId" aria-labelledby-Grid="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', directiveName: 'LabelledbyGrid', appendGridId: true, method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedby
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-describedby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId" aria-describedby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', method: 'attr', aria: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedbyGrid
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId" aria-describedby="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', directiveName: 'DescribedbyGrid', appendGridId: true, method: 'attr', aria: true}],
	    function(v) {
	
	      var baseDirectiveName = 'uiGridOneBind';
	      // If it is an aria tag then append the aria label seperately
	      // This is done because the aria tags are formatted aria-* and the directive name can't have a '-' character in it.
	      // If the diretiveName has to be overridden then it does so here. This is because the tag being modified and the directive sometimes don't
	      // match up.
	      var directiveName = (v.aria ? baseDirectiveName + 'Aria' : baseDirectiveName) + (v.directiveName ? v.directiveName : v.tag);
	      oneBinders.directive(directiveName, ['gridUtil', function(gridUtil) {
	        return {
	          restrict: 'A',
	          require: ['?uiGrid','?^uiGrid'],
	          link: function(scope, iElement, iAttrs, controllers) {
	            /* Appends the grid id to the beginning of the value. */
	            var appendGridId = function(val) {
	              var grid; // Get an instance of the grid if its available
	
	              // If its available in the scope then we don't need to try to find it elsewhere
	              if (scope.grid) {
	                grid = scope.grid;
	              }
	
	              // Another possible location to try to find the grid
	              else if (scope.col && scope.col.grid) {
	                grid = scope.col.grid;
	              }
	
	              // Last ditch effort: Search through the provided controllers.
	              else if (!controllers.some( // Go through the controllers till one has the element we need
	                function(controller) {
	                  if (controller && controller.grid) {
	                    grid = controller.grid;
	                    return true; // We've found the grid
	                  }
	              })) {
	                // We tried our best to find it for you
	                gridUtil.logError("["+directiveName+"] A valid grid could not be found to bind id. Are you using this directive " +
	                                 "within the correct scope? Trying to generate id: [gridID]-" + val);
	                throw new Error("No valid grid could be found");
	              }
	
	              if (grid) {
	                var idRegex = new RegExp(grid.id.toString());
	
	                // If the grid id hasn't been appended already in the template declaration
	                if (!idRegex.test(val)) {
	                  val = grid.id.toString() + '-' + val;
	                }
	              }
	              return val;
	            };
	
	            // The watch returns a function to remove itself.
	            var rmWatcher = scope.$watch(iAttrs[directiveName], function(newV) {
	              if (newV) {
	                // If we are trying to add an id element then we also apply the grid id if it isn't already there
	                if (v.appendGridId) {
	                  var newIdString = null;
	
	                  // Append the id to all of the new ids.
	                  angular.forEach( newV.split(' '), function(s) {
	                    newIdString = (newIdString ? (newIdString + ' ') : '') +  appendGridId(s);
	                  });
	                  newV = newIdString;
	                }
	
	                // Append this newValue to the dom element.
	                switch (v.method) {
	                  case 'attr': // The attr method takes two paraams the tag and the value
	                    if (v.aria) {
	                      // If it is an aria element then append the aria prefix
	                      iElement[v.method]('aria-' + v.tag.toLowerCase(),newV);
	                    } else {
	                      iElement[v.method](v.tag.toLowerCase(),newV);
	                    }
	                    break;
	                  case 'addClass':
	                    // Pulled from https://github.com/Pasvaz/bindonce/blob/master/bindonce.js
	                    if (angular.isObject(newV) && !angular.isArray(newV)) {
	                      var results = [],
	                        nonNullFound = false; // We don't want to remove the binding unless the key is actually defined
	
	                      angular.forEach(newV, function (value, index) {
	                        if (value !== null && typeof(value) !== "undefined") {
	                          nonNullFound = true; // A non null value for a key was found so the object must have been initialized
	                          if (value) {results.push(index);}
	                        }
	                      });
	                      // A non null value for a key wasn't found so assume that the scope values haven't been fully initialized
	                      if (!nonNullFound) {
	                        return; // If not initialized then the watcher should not be removed yet.
	                      }
	                      newV = results;
	                    }
	
	                    if (newV) {
	                      iElement.addClass(angular.isArray(newV) ? newV.join(' ') : newV);
	                    } else {
	                      return;
	                    }
	                    break;
	                  default:
	                    iElement[v.method](newV);
	                    break;
	                }
	
	                // Removes the watcher on itself after the bind
	                rmWatcher();
	              }
	            // True ensures that equality is determined using angular.equals instead of ===
	            }, true); // End rm watchers
	          } // End compile function
	        }; // End directive return
	      } // End directive function
	    ]); // End directive
	  }); // End angular foreach
	})();
	
	(function() {
		'use strict';
	
		var module = angular.module('ui.grid');
	
		module.directive('uiGridRenderContainer', ['$timeout', '$document', 'uiGridConstants', 'gridUtil', 'ScrollEvent',
			function($timeout, $document, uiGridConstants, gridUtil, ScrollEvent) {
				return {
					replace: true,
					transclude: true,
					templateUrl: 'ui-grid/uiGridRenderContainer',
					require: ['^uiGrid', 'uiGridRenderContainer'],
					scope: {
						containerId: '=',
						rowContainerName: '=',
						colContainerName: '=',
						bindScrollHorizontal: '=',
						bindScrollVertical: '=',
						enableVerticalScrollbar: '=',
						enableHorizontalScrollbar: '='
					},
					controller: 'uiGridRenderContainer as RenderContainer',
					compile: function() {
						return {
							pre: function prelink($scope, $elm, $attrs, controllers) {
								var rowContainer, colContainer,
									uiGridCtrl = controllers[0],
									containerCtrl = controllers[1],
									grid = $scope.grid = uiGridCtrl.grid;
	
								// Verify that the render container for this element exists
								if (!$scope.rowContainerName) {
									throw new Error('No row render container name specified');
								}
								if (!$scope.colContainerName) {
									throw new Error('No column render container name specified');
								}
	
								if (!grid.renderContainers[$scope.rowContainerName]) {
									throw new Error('Row render container "' + $scope.rowContainerName + '" is not registered.');
								}
								if (!grid.renderContainers[$scope.colContainerName]) {
									throw new Error('Column render container "' + $scope.colContainerName + '" is not registered.');
								}
	
								rowContainer = $scope.rowContainer = grid.renderContainers[$scope.rowContainerName];
								colContainer = $scope.colContainer = grid.renderContainers[$scope.colContainerName];
	
								containerCtrl.containerId = $scope.containerId;
								containerCtrl.rowContainer = rowContainer;
								containerCtrl.colContainer = colContainer;
							},
							post: function postlink($scope, $elm, $attrs, controllers) {
								var uiGridCtrl = controllers[0],
									containerCtrl = controllers[1],
									grid = uiGridCtrl.grid,
									rowContainer = containerCtrl.rowContainer,
									colContainer = containerCtrl.colContainer,
									scrollTop = null,
									scrollLeft = null,
									renderContainer = grid.renderContainers[$scope.containerId];
	
								// Put the container name on this element as a class
								$elm.addClass('ui-grid-render-container-' + $scope.containerId);
	
								// Scroll the render container viewport when the mousewheel is used
								gridUtil.on.mousewheel($elm, function(event) {
									var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.RenderContainerMouseWheel);
	
									if (event.deltaY !== 0) {
										var scrollYAmount = event.deltaY * -1 * event.deltaFactor;
	
										scrollTop = containerCtrl.viewport[0].scrollTop;
	
										// Get the scroll percentage
										scrollEvent.verticalScrollLength = rowContainer.getVerticalScrollLength();
										var scrollYPercentage = (scrollTop + scrollYAmount) / scrollEvent.verticalScrollLength;
	
										// If we should be scrolled 100%, make sure the scrollTop matches the maximum scroll length
										//   Viewports that have "overflow: hidden" don't let the mousewheel scroll all the way to the bottom without this check
										if (scrollYPercentage >= 1 && scrollTop < scrollEvent.verticalScrollLength) {
											containerCtrl.viewport[0].scrollTop = scrollEvent.verticalScrollLength;
										}
	
										// Keep scrollPercentage within the range 0-1.
										if (scrollYPercentage < 0) { scrollYPercentage = 0; }
										else if (scrollYPercentage > 1) { scrollYPercentage = 1; }
	
										scrollEvent.y = {percentage: scrollYPercentage, pixels: scrollYAmount};
									}
									if (event.deltaX !== 0) {
										var scrollXAmount = event.deltaX * event.deltaFactor;
	
										// Get the scroll percentage
										scrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.viewport, grid);
										scrollEvent.horizontalScrollLength = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
										var scrollXPercentage = (scrollLeft + scrollXAmount) / scrollEvent.horizontalScrollLength;
	
										// Keep scrollPercentage within the range 0-1.
										if (scrollXPercentage < 0) { scrollXPercentage = 0; }
										else if (scrollXPercentage > 1) { scrollXPercentage = 1; }
	
										scrollEvent.x = {percentage: scrollXPercentage, pixels: scrollXAmount};
									}
	
									// Let the parent container scroll if the grid is already at the top/bottom
									if (!((event.deltaY !== 0 && (scrollEvent.atTop(scrollTop) || scrollEvent.atBottom(scrollTop))) ||
										(event.deltaX !== 0 && (scrollEvent.atLeft(scrollLeft) || scrollEvent.atRight(scrollLeft))))) {
										event.preventDefault();
										event.stopPropagation();
										scrollEvent.fireThrottledScrollingEvent('', scrollEvent);
									}
								});
	
								$elm.bind('$destroy', function() {
									$elm.unbind('keydown');
	
									['touchstart', 'touchmove', 'touchend', 'keydown', 'wheel', 'mousewheel',
										'DomMouseScroll', 'MozMousePixelScroll'].forEach(function(eventName) {
										$elm.unbind(eventName);
									});
								});
	
								// TODO(c0bra): Handle resizing the inner canvas based on the number of elements
								function update() {
									var ret = '';
	
									var canvasWidth = colContainer.canvasWidth;
									var viewportWidth = colContainer.getViewportWidth();
	
									var canvasHeight = rowContainer.getCanvasHeight();
	
									var viewportHeight = rowContainer.getViewportHeight();
									// shorten the height to make room for a scrollbar placeholder
									if (colContainer.needsHScrollbarPlaceholder()) {
										viewportHeight -= grid.scrollbarHeight;
									}
	
									var headerViewportWidth,
										footerViewportWidth;
									headerViewportWidth = footerViewportWidth = colContainer.getHeaderViewportWidth();
	
									// Set canvas dimensions
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-canvas { width: ' + canvasWidth + 'px; height: ' + canvasHeight + 'px; }';
	
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-header-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
	
									if (renderContainer.explicitHeaderCanvasHeight) {
										// get height from body container
										var reHCHeight = document.querySelector(
											'.grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-body .ui-grid-header-canvas');
	
										if (reHCHeight) {
											renderContainer.explicitHeaderCanvasHeight = reHCHeight.offsetHeight;
										}
	
										ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
											+ ' .ui-grid-header-canvas { height: ' + renderContainer.explicitHeaderCanvasHeight + 'px; }';
									}
									else {
										ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
											+ ' .ui-grid-header-canvas { height: inherit; }';
									}
	
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-viewport { width: ' + viewportWidth + 'px; height: ' + viewportHeight + 'px; }';
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-header-viewport { width: ' + headerViewportWidth + 'px; }';
	
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-footer-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
									ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId
										+ ' .ui-grid-footer-viewport { width: ' + footerViewportWidth + 'px; }';
	
									return ret;
								}
	
								uiGridCtrl.grid.registerStyleComputation({
									priority: 6,
									func: update
								});
							}
						};
					}
				};
			}]);
	
		module.controller('uiGridRenderContainer', ['$scope', 'gridUtil', function($scope, gridUtil) {
		}]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridRow', function() {
	    return {
	      replace: true,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: {
	         row: '=uiGridRow',
	         // rowRenderIndex is added to scope to give the true visual index of the row to any directives that need it
	         rowRenderIndex: '='
	      },
	      compile: function() {
	        return {
	          pre: function($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            // Function for attaching the template to this scope
	            var clonedElement, cloneScope;
	            function compileTemplate() {
	              $scope.row.getRowTemplateFn.then(function (compiledElementFn) {
	                // var compiledElementFn = $scope.row.compiledElementFn;
	
	                // Create a new scope for the contents of this row, so we can destroy it later if need be
	                var newScope = $scope.$new();
	
	                compiledElementFn(newScope, function (newElm, scope) {
	                  // If we already have a cloned element, we need to remove it and destroy its scope
	                  if (clonedElement) {
	                    clonedElement.remove();
	                    cloneScope.$destroy();
	                  }
	
	                  // Empty the row and append the new element
	                  $elm.empty().append(newElm);
	
	                  // Save the new cloned element and scope
	                  clonedElement = newElm;
	                  cloneScope = newScope;
	                });
	              }).catch(angular.noop);
	            }
	
	            // Initially attach the compiled template to this scope
	            compileTemplate();
	
	            // If the row's compiled element function changes, we need to replace this element's contents with the new compiled template
	            $scope.$watch('row.getRowTemplateFn', function (newFunc, oldFunc) {
	              if (newFunc !== oldFunc) {
	                compileTemplate();
	              }
	            });
	          },
	          post: function($scope, $elm) {
	            $scope.row.element = $elm;
	          }
	        };
	      }
	    };
	  });
	})();
	
	(function() {
	// 'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.directive:uiGridStyle
	   * @element style
	   * @restrict A
	   *
	   * @description
	   * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.myStyle = '.blah { border: 1px solid }';
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <style ui-grid-style>{{ myStyle }}</style>
	   <span class="blah">I am in a box.</span>
	   </div>
	   </doc:source>
	   <doc:scenario>
	      xit('should apply the right class to the element', function () {
	        element(by.css('.blah')).getCssValue('border-top-width')
	          .then(function(c) {
	            expect(c).toContain('1px');
	          });
	      });
	   </doc:scenario>
	   </doc:example>
	   */
	
	
	  angular.module('ui.grid').directive('uiGridStyle', ['gridUtil', '$interpolate', function(gridUtil, $interpolate) {
	    return {
	      link: function($scope, $elm) {
	        var interpolateFn = $interpolate($elm.text(), true);
	
	        if (interpolateFn) {
	          $scope.$watch(interpolateFn, function(value) {
	            $elm.text(value);
	          });
	        }
	      }
	    };
	  }]);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridViewport', ['gridUtil', 'ScrollEvent',
	    function(gridUtil, ScrollEvent) {
	      return {
	        replace: true,
	        scope: {},
	        controllerAs: 'Viewport',
	        templateUrl: 'ui-grid/uiGridViewport',
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        link: function($scope, $elm, $attrs, controllers) {
	          // gridUtil.logDebug('viewport post-link');
	
	          var uiGridCtrl = controllers[0];
	          var containerCtrl = controllers[1];
	
	          $scope.containerCtrl = containerCtrl;
	
	          var rowContainer = containerCtrl.rowContainer;
	          var colContainer = containerCtrl.colContainer;
	
	          var grid = uiGridCtrl.grid;
	
	          $scope.grid = uiGridCtrl.grid;
	
	          // Put the containers in scope so we can get rows and columns from them
	          $scope.rowContainer = containerCtrl.rowContainer;
	          $scope.colContainer = containerCtrl.colContainer;
	
	          // Register this viewport with its container
	          containerCtrl.viewport = $elm;
	
	          /**
	           * @ngdoc function
	           * @name customScroller
	           * @methodOf ui.grid.class:GridOptions
	           * @description (optional) uiGridViewport.on('scroll', scrollHandler) by default.
	           * A function that allows you to provide your own scroller function. It is particularly helpful if you want to use third party scrollers
	           * as this allows you to do that.
	           *
	           * <div class="alert alert-info" role="alert"> <strong>NOTE:</strong> It is important to remember to always pass in an event object to
	           * the scrollHandler as the grid scrolling behavior will break without it.</div>
	           * <h5>Example</h5>
	           * <pre>
	           *   $scope.gridOptions = {
	           *       customScroller: function myScrolling(uiGridViewport, scrollHandler) {
	           *           uiGridViewport.on('scroll', function myScrollingOverride(event) {
	           *               // Do something here
	           *
	           *               scrollHandler(event);
	           *           });
	           *       }
	           *   };
	           * </pre>
	           * @param {object} uiGridViewport Element being scrolled. (this gets passed in by the grid).
	           * @param {function} scrollHandler Function that needs to be called when scrolling happens. (this gets passed in by the grid).
	           */
	          if (grid && grid.options && grid.options.customScroller) {
	            grid.options.customScroller($elm, scrollHandler);
	          } else {
	            $elm.on('scroll', scrollHandler);
	          }
	
	          var ignoreScroll = false;
	
	          function scrollHandler() {
	            var newScrollTop = $elm[0].scrollTop;
	            var newScrollLeft = gridUtil.normalizeScrollLeft($elm, grid);
	
	            var vertScrollPercentage = rowContainer.scrollVertical(newScrollTop);
	            var horizScrollPercentage = colContainer.scrollHorizontal(newScrollLeft);
	
	            var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.ViewPortScroll);
	            scrollEvent.newScrollLeft = newScrollLeft;
	            scrollEvent.newScrollTop = newScrollTop;
	            if ( horizScrollPercentage > -1 ) {
	              scrollEvent.x = { percentage: horizScrollPercentage };
	            }
	
	            if ( vertScrollPercentage > -1 ) {
	              scrollEvent.y = { percentage: vertScrollPercentage };
	            }
	
	            grid.scrollContainers($scope.$parent.containerId, scrollEvent);
	          }
	
	          if ($scope.$parent.bindScrollVertical) {
	            grid.addVerticalScrollSync($scope.$parent.containerId, syncVerticalScroll);
	          }
	
	          if ($scope.$parent.bindScrollHorizontal) {
	            grid.addHorizontalScrollSync($scope.$parent.containerId, syncHorizontalScroll);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'header', syncHorizontalHeader);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'footer', syncHorizontalFooter);
	          }
	
	          function syncVerticalScroll(scrollEvent) {
	            containerCtrl.prevScrollArgs = scrollEvent;
	            $elm[0].scrollTop = scrollEvent.getNewScrollTop(rowContainer,containerCtrl.viewport);
	          }
	
	          function syncHorizontalScroll(scrollEvent) {
	            containerCtrl.prevScrollArgs = scrollEvent;
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	
	            $elm[0].scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	          }
	
	          function syncHorizontalHeader(scrollEvent) {
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	
	            if (containerCtrl.headerViewport) {
	              containerCtrl.headerViewport.scrollLeft = gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	          function syncHorizontalFooter(scrollEvent) {
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	
	            if (containerCtrl.footerViewport) {
	              containerCtrl.footerViewport.scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	          $scope.$on('$destroy', function unbindEvents() {
	            $elm.off();
	          });
	        },
	        controller: ['$scope', function ($scope) {
	          this.rowStyle = function () {
	            var rowContainer = $scope.rowContainer;
	            var colContainer = $scope.colContainer;
	
	            var styles = {};
	
	            if (rowContainer.currentTopRow !== 0) {
	              // top offset based on hidden rows count
	              var translateY = "translateY("+ (rowContainer.currentTopRow * rowContainer.grid.options.rowHeight)  +"px)";
	
	              styles['transform'] = translateY;
	              styles['-webkit-transform'] = translateY;
	              styles['-ms-transform'] = translateY;
	            }
	
	            if (colContainer.currentFirstColumn !== 0) {
	              if (colContainer.grid.isRTL()) {
	                styles['margin-right'] = colContainer.columnOffset + 'px';
	              }
	              else {
	                styles['margin-left'] = colContainer.columnOffset + 'px';
	              }
	            }
	
	            return styles;
	          };
	        }]
	      };
	    }
	  ]);
	
	})();
	
	(function() {
		angular.module('ui.grid')
			.directive('uiGridVisible', function uiGridVisibleAction() {
				return function($scope, $elm, $attr) {
					$scope.$watch($attr.uiGridVisible, function(visible) {
						$elm[visible ? 'removeClass' : 'addClass']('ui-grid-invisible');
					});
				};
			});
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').controller('uiGridController', ['$scope', '$element', '$attrs', 'gridUtil', '$q', 'uiGridConstants',
	                    'gridClassFactory', '$parse', '$compile',
	    function ($scope, $elm, $attrs, gridUtil, $q, uiGridConstants,
	              gridClassFactory, $parse, $compile) {
	      // gridUtil.logDebug('ui-grid controller');
	      var self = this;
	      var deregFunctions = [];
	
	      self.grid = gridClassFactory.createGrid($scope.uiGrid);
	
	      // assign $scope.$parent if appScope not already assigned
	      self.grid.appScope = self.grid.appScope || $scope.$parent;
	
	      $elm.addClass('grid' + self.grid.id);
	      self.grid.rtl = gridUtil.getStyles($elm[0])['direction'] === 'rtl';
	
	
	      // angular.extend(self.grid.options, );
	
	      // all properties of grid are available on scope
	      $scope.grid = self.grid;
	
	      if ($attrs.uiGridColumns) {
	        deregFunctions.push( $attrs.$observe('uiGridColumns', function(value) {
	          self.grid.options.columnDefs = angular.isString(value) ? angular.fromJson(value) : value;
	          self.grid.buildColumns()
	            .then(function() {
	              self.grid.preCompileCellTemplates();
	
	              self.grid.refreshCanvas(true);
	            }).catch(angular.noop);
	        }) );
	      }
	
	      // prevents an error from being thrown when the array is not defined yet and fastWatch is on
	      function getSize(array) {
	        return array ? array.length : 0;
	      }
	
	      // if fastWatch is set we watch only the length and the reference, not every individual object
	      if (self.grid.options.fastWatch) {
	        self.uiGrid = $scope.uiGrid;
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watch($scope.uiGrid.data, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() {
	            if ( self.grid.appScope[$scope.uiGrid.data] ) {
	              return self.grid.appScope[$scope.uiGrid.data].length;
	            } else {
	              return undefined;
	            }
	          }, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() { return getSize($scope.uiGrid.data); }, function() { dataWatchFunction($scope.uiGrid.data); }) );
	        }
	        deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	        deregFunctions.push( $scope.$parent.$watch(function() { return getSize($scope.uiGrid.columnDefs); }, function() { columnDefsWatchFunction($scope.uiGrid.columnDefs); }) );
	      } else {
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watchCollection($scope.uiGrid.data, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	        }
	        deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	      }
	
	
	      function columnDefsWatchFunction(n, o) {
	        if (n && n !== o) {
	          self.grid.options.columnDefs = $scope.uiGrid.columnDefs;
	          self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.COLUMN, {
	            orderByColumnDefs: true,
	            preCompileCellTemplates: true
	          });
	        }
	      }
	
	      var mostRecentData;
	
	      function dataWatchFunction(newData) {
	        // gridUtil.logDebug('dataWatch fired');
	        var promises = [];
	
	        if ( self.grid.options.fastWatch ) {
	          if (angular.isString($scope.uiGrid.data)) {
	            newData = self.grid.appScope.$eval($scope.uiGrid.data);
	          } else {
	            newData = $scope.uiGrid.data;
	          }
	        }
	
	        mostRecentData = newData;
	
	        if (newData) {
	          // columns length is greater than the number of row header columns, which don't count because they're created automatically
	          var hasColumns = self.grid.columns.length > (self.grid.rowHeaderColumns ? self.grid.rowHeaderColumns.length : 0);
	
	          if (
	            // If we have no columns
	            !hasColumns &&
	            // ... and we don't have a ui-grid-columns attribute, which would define columns for us
	            !$attrs.uiGridColumns &&
	            // ... and we have no pre-defined columns
	            self.grid.options.columnDefs.length === 0 &&
	            // ... but we DO have data
	            newData.length > 0
	          ) {
	            // ... then build the column definitions from the data that we have
	            self.grid.buildColumnDefsFromData(newData);
	          }
	
	          // If we haven't built columns before and either have some columns defined or some data defined
	          if (!hasColumns && (self.grid.options.columnDefs.length > 0 || newData.length > 0)) {
	            // Build the column set, then pre-compile the column cell templates
	            promises.push(self.grid.buildColumns()
	              .then(function() {
	                self.grid.preCompileCellTemplates();
	              }).catch(angular.noop));
	          }
	
	          $q.all(promises).then(function() {
	            // use most recent data, rather than the potentially outdated data passed into watcher handler
	            self.grid.modifyRows(mostRecentData)
	              .then(function () {
	                // if (self.viewport) {
	                  self.grid.redrawInPlace(true);
	                // }
	
	                $scope.$evalAsync(function() {
	                  self.grid.refreshCanvas(true);
	                  self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.ROW);
	                });
	              }).catch(angular.noop);
	          }).catch(angular.noop);
	        }
	      }
	
	      var styleWatchDereg = $scope.$watch(function () { return self.grid.styleComputations; }, function() {
	        self.grid.refreshCanvas(true);
	      });
	
	      $scope.$on('$destroy', function() {
	        deregFunctions.forEach( function( deregFn ) { deregFn(); });
	        styleWatchDereg();
	      });
	
	      self.fireEvent = function(eventName, args) {
	        args = args || {};
	
	        // Add the grid to the event arguments if it's not there
	        if (angular.isUndefined(args.grid)) {
	          args.grid = self.grid;
	        }
	
	        $scope.$broadcast(eventName, args);
	      };
	
	      self.innerCompile = function innerCompile(elm) {
	        $compile(elm)($scope);
	      };
	    }]);
	
	/**
	 *  @ngdoc directive
	 *  @name ui.grid.directive:uiGrid
	 *  @element div
	 *  @restrict EA
	 *  @param {Object} uiGrid Options for the grid to use
	 *
	 *  @description Create a very basic grid.
	 *
	 *  @example
	    <example module="app">
	      <file name="app.js">
	        var app = angular.module('app', ['ui.grid']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.data = [
	            { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	          ];
	        }]);
	      </file>
	      <file name="index.html">
	        <div ng-controller="MainCtrl">
	          <div ui-grid="{ data: data }"></div>
	        </div>
	      </file>
	    </example>
	 */
	angular.module('ui.grid').directive('uiGrid', uiGridDirective);
	
	uiGridDirective.$inject = ['$window', 'gridUtil', 'uiGridConstants'];
	function uiGridDirective($window, gridUtil, uiGridConstants) {
	  return {
	    templateUrl: 'ui-grid/ui-grid',
	    scope: {
	      uiGrid: '='
	    },
	    replace: true,
	    transclude: true,
	    controller: 'uiGridController',
	    compile: function () {
	      return {
	        post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var grid = uiGridCtrl.grid;
	          // Initialize scrollbars (TODO: move to controller??)
	          uiGridCtrl.scrollbars = [];
	          grid.element = $elm;
	
	
	          // See if the grid has a rendered width, if not, wait a bit and try again
	          var sizeCheckInterval = 100; // ms
	          var maxSizeChecks = 20; // 2 seconds total
	          var sizeChecks = 0;
	
	          // Setup (event listeners) the grid
	          setup();
	
	          // And initialize it
	          init();
	
	          // Mark rendering complete so API events can happen
	          grid.renderingComplete();
	
	          // If the grid doesn't have size currently, wait for a bit to see if it gets size
	          checkSize();
	
	          /*-- Methods --*/
	
	          function checkSize() {
	            // If the grid has no width and we haven't checked more than <maxSizeChecks> times, check again in <sizeCheckInterval> milliseconds
	            if ($elm[0].offsetWidth <= 0 && sizeChecks < maxSizeChecks) {
	              setTimeout(checkSize, sizeCheckInterval);
	              sizeChecks++;
	            } else {
	              $scope.$applyAsync(init);
	            }
	          }
	
	          // Setup event listeners and watchers
	          function setup() {
	            var deregisterLeftWatcher, deregisterRightWatcher;
	
	            // Bind to window resize events
	            angular.element($window).on('resize', gridResize);
	
	            // Unbind from window resize events when the grid is destroyed
	            $elm.on('$destroy', function () {
	              angular.element($window).off('resize', gridResize);
	              deregisterLeftWatcher();
	              deregisterRightWatcher();
	            });
	
	            // If we add a left container after render, we need to watch and react
	            deregisterLeftWatcher = $scope.$watch(function () { return grid.hasLeftContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	
	            // If we add a right container after render, we need to watch and react
	            deregisterRightWatcher = $scope.$watch(function () { return grid.hasRightContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	          }
	
	          // Initialize the directive
	          function init() {
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	
	            // Default canvasWidth to the grid width, in case we don't get any column definitions to calculate it from
	            grid.canvasWidth = uiGridCtrl.grid.gridWidth;
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            // If the grid isn't tall enough to fit a single row, it's kind of useless. Resize it to fit a minimum number of rows
	            if (grid.gridHeight - grid.scrollbarHeight <= grid.options.rowHeight && grid.options.enableMinHeightCheck) {
	              autoAdjustHeight();
	            }
	
	            // Run initial canvas refresh
	            grid.refreshCanvas(true);
	          }
	
	          // Set the grid's height ourselves in the case that its height would be unusably small
	          function autoAdjustHeight() {
	            // Figure out the new height
	            var contentHeight = grid.options.minRowsToShow * grid.options.rowHeight;
	            var headerHeight = grid.options.showHeader ? grid.options.headerRowHeight : 0;
	            var footerHeight = grid.calcFooterHeight();
	
	            var scrollbarHeight = 0;
	            if (grid.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	              scrollbarHeight = gridUtil.getScrollbarWidth();
	            }
	
	            var maxNumberOfFilters = 0;
	            // Calculates the maximum number of filters in the columns
	            angular.forEach(grid.options.columnDefs, function(col) {
	              if (col.hasOwnProperty('filter')) {
	                if (maxNumberOfFilters < 1) {
	                    maxNumberOfFilters = 1;
	                }
	              }
	              else if (col.hasOwnProperty('filters')) {
	                if (maxNumberOfFilters < col.filters.length) {
	                    maxNumberOfFilters = col.filters.length;
	                }
	              }
	            });
	
	            if (grid.options.enableFiltering  && !maxNumberOfFilters) {
	              var allColumnsHaveFilteringTurnedOff = grid.options.columnDefs.length && grid.options.columnDefs.every(function(col) {
	                return col.enableFiltering === false;
	              });
	
	              if (!allColumnsHaveFilteringTurnedOff) {
	                maxNumberOfFilters = 1;
	              }
	            }
	
	            var filterHeight = maxNumberOfFilters * headerHeight;
	
	            var newHeight = headerHeight + contentHeight + footerHeight + scrollbarHeight + filterHeight;
	
	            $elm.css('height', newHeight + 'px');
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	          }
	
	          // Resize the grid on window resize events
	          function gridResize() {
	            if (!gridUtil.isVisible($elm)) {
	              return;
	            }
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            grid.refreshCanvas(true);
	          }
	        }
	      };
	    }
	  };
	}
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridPinnedContainer', ['gridUtil', function (gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      template: '<div class="ui-grid-pinned-container">'
	              + '<div ui-grid-render-container container-id="side"'
	              + ' row-container-name="\'body\'" col-container-name="side"'
	              + ' bind-scroll-vertical="true"'
	              + ' class="{{ side }} ui-grid-render-container-{{ side }}"></div>'
	              + '</div>',
	      scope: {
	        side: '=uiGridPinnedContainer'
	      },
	      require: '^uiGrid',
	      compile: function compile() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            // gridUtil.logDebug('ui-grid-pinned-container ' + $scope.side + ' link');
	
	            var grid = uiGridCtrl.grid;
	
	            var myWidth = 0;
	
	            $elm.addClass('ui-grid-pinned-container-' + $scope.side);
	
	            // Monkey-patch the viewport width function
	            if ($scope.side === 'left' || $scope.side === 'right') {
	              grid.renderContainers[$scope.side].getViewportWidth = monkeyPatchedGetViewportWidth;
	            }
	
	            function monkeyPatchedGetViewportWidth() {
	              /*jshint validthis: true */
	              var self = this;
	
	              var viewportWidth = 0;
	              self.visibleColumnCache.forEach(function (column) {
	                viewportWidth += column.drawnWidth;
	              });
	
	              var adjustment = self.getViewportAdjustment();
	
	              viewportWidth = viewportWidth + adjustment.width;
	
	              return viewportWidth;
	            }
	
	            function updateContainerWidth() {
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                var cols = grid.renderContainers[$scope.side].visibleColumnCache;
	                var width = 0;
	                for (var i = 0; i < cols.length; i++) {
	                  var col = cols[i];
	                  width += col.drawnWidth || col.width || 0;
	                }
	
	                return width;
	              }
	            }
	
	            function updateContainerDimensions() {
	              var ret = '';
	
	              // Column containers
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                myWidth = updateContainerWidth();
	
	                // gridUtil.logDebug('myWidth', myWidth);
	
	                // TODO(c0bra): Subtract sum of col widths from grid viewport width and update it
	                $elm.attr('style', null);
	
	             //   var myHeight = grid.renderContainers.body.getViewportHeight(); // + grid.horizontalScrollbarHeight;
	
	                ret += '.grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ', .grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ' .ui-grid-render-container-' + $scope.side + ' .ui-grid-viewport { width: ' + myWidth + 'px; } ';
	              }
	
	              return ret;
	            }
	
	            grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	              myWidth = updateContainerWidth();
	
	              // Subtract our own width
	              adjustment.width -= myWidth;
	              adjustment.side = $scope.side;
	
	              return adjustment;
	            });
	
	            // Register style computation to adjust for columns in `side`'s render container
	            grid.registerStyleComputation({
	              priority: 15,
	              func: updateContainerDimensions
	            });
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('en', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter for column',
	            removeFilter: 'Remove Filter',
	            columnMenuButtonLabel: 'Column Menu',
	            column: 'Column'
	          },
	          priority: 'Priority:',
	          filterLabel: "Filter for column: "
	        },
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Drag a column header here and drop it to group by that column.'
	        },
	        search: {
	          aria: {
	            selected: 'Row selected',
	            notSelected: 'Row not selected'
	          },
	          placeholder: 'Search...',
	          showingItems: 'Showing Items:',
	          selectedItems: 'Selected Items:',
	          totalItems: 'Total Items:',
	          size: 'Page Size:',
	          first: 'First Page',
	          next: 'Next Page',
	          previous: 'Previous Page',
	          last: 'Last Page'
	        },
	        menu: {
	          text: 'Choose Columns:'
	        },
	        sort: {
	          ascending: 'Sort Ascending',
	          descending: 'Sort Descending',
	          none: 'Sort None',
	          remove: 'Remove Sort'
	        },
	        column: {
	          hide: 'Hide Column'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Pin Left',
	          pinRight: 'Pin Right',
	          unpin: 'Unpin'
	        },
	        columnMenu: {
	          close: 'Close'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          exporterAllAsExcel: 'Export all data as excel',
	          exporterVisibleAsExcel: 'Export visible data as excel',
	          exporterSelectedAsExcel: 'Export selected data as excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Page to first',
	            pageBack: 'Page back',
	            pageSelected: 'Selected page',
	            pageForward: 'Page forward',
	            pageToLast: 'Page to last'
	          },
	          sizes: 'items per page',
	          totalItems: 'items',
	          through: 'through',
	          of: 'of'
	        },
	        grouping: {
	          group: 'Group',
	          ungroup: 'Ungroup',
	          aggregate_count: 'Agg: Count',
	          aggregate_sum: 'Agg: Sum',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Avg',
	          aggregate_remove: 'Agg: Remove'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'Value should be at least THRESHOLD characters long.',
	          maxLength: 'Value should be at most THRESHOLD characters long.',
	          required: 'A value is needed.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.factory('Grid', ['$q', '$compile', '$parse', 'gridUtil', 'uiGridConstants', 'GridOptions', 'GridColumn', 'GridRow', 'GridApi', 'rowSorter', 'rowSearcher', 'GridRenderContainer', '$timeout','ScrollEvent',
	    function($q, $compile, $parse, gridUtil, uiGridConstants, GridOptions, GridColumn, GridRow, GridApi, rowSorter, rowSearcher, GridRenderContainer, $timeout, ScrollEvent) {
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.api:PublicApi
	   * @description Public Api for the core grid features
	   *
	   */
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:Grid
	   * @description Grid is the main viewModel.  Any properties or methods needed to maintain state are defined in
	   * this prototype.  One instance of Grid is created per Grid directive instance.
	   * @param {object} options Object map of options to pass into the grid. An 'id' property is expected.
	   */
	  var Grid = function Grid(options) {
	    var self = this;
	    // Get the id out of the options, then remove it
	    if (options !== undefined && typeof(options.id) !== 'undefined' && options.id) {
	      if (!/^[_a-zA-Z0-9-]+$/.test(options.id)) {
	        throw new Error("Grid id '" + options.id + '" is invalid. It must follow CSS selector syntax rules.');
	      }
	    }
	    else {
	      throw new Error('No ID provided. An ID must be given when creating a grid.');
	    }
	
	    self.id = options.id;
	    delete options.id;
	
	    // Get default options
	    self.options = GridOptions.initialize( options );
	
	    /**
	     * @ngdoc object
	     * @name appScope
	     * @propertyOf ui.grid.class:Grid
	     * @description reference to the application scope (the parent scope of the ui-grid element).  Assigned in ui-grid controller
	     * <br/>
	     * use gridOptions.appScopeProvider to override the default assignment of $scope.$parent with any reference
	     */
	    self.appScope = self.options.appScopeProvider;
	
	    self.headerHeight = self.options.headerRowHeight;
	
	
	    /**
	     * @ngdoc object
	     * @name footerHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total footer height gridFooter + columnFooter
	     */
	    self.footerHeight = self.calcFooterHeight();
	
	
	    /**
	     * @ngdoc object
	     * @name columnFooterHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total column footer height
	     */
	    self.columnFooterHeight = self.calcColumnFooterHeight();
	
	    self.rtl = false;
	    self.gridHeight = 0;
	    self.gridWidth = 0;
	    self.columnBuilders = [];
	    self.rowBuilders = [];
	    self.rowsProcessors = [];
	    self.columnsProcessors = [];
	    self.styleComputations = [];
	    self.viewportAdjusters = [];
	    self.rowHeaderColumns = [];
	    self.dataChangeCallbacks = {};
	    self.verticalScrollSyncCallBackFns = {};
	    self.horizontalScrollSyncCallBackFns = {};
	
	    // self.visibleRowCache = [];
	
	    // Set of 'render' containers for self grid, which can render sets of rows
	    self.renderContainers = {};
	
	    // Create a
	    self.renderContainers.body = new GridRenderContainer('body', self);
	
	    self.cellValueGetterCache = {};
	
	    // Cached function to use with custom row templates
	    self.getRowTemplateFn = null;
	
	
	    // representation of the rows on the grid.
	    // these are wrapped references to the actual data rows (options.data)
	    self.rows = [];
	
	    // represents the columns on the grid
	    self.columns = [];
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingVertically
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling vertically. Set to false via debounced method
	     */
	    self.isScrollingVertically = false;
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingHorizontally
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling horizontally. Set to false via debounced method
	     */
	    self.isScrollingHorizontally = false;
	
	    /**
	     * @ngdoc property
	     * @name scrollDirection
	     * @propertyOf ui.grid.class:Grid
	     * @description set one of the {@link ui.grid.service:uiGridConstants#properties_scrollDirection uiGridConstants.scrollDirection}
	     *  values (UP, DOWN, LEFT, RIGHT, NONE), which tells us which direction we are scrolling.
	     * Set to NONE via debounced method
	     */
	    self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	
	    // if true, grid will not respond to any scroll events
	    self.disableScrolling = false;
	
	
	    function vertical (scrollEvent) {
	      self.isScrollingVertically = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedVertical = gridUtil.debounce(vertical, self.options.scrollDebounce);
	    var debouncedVerticalMinDelay = gridUtil.debounce(vertical, 0);
	
	    function horizontal (scrollEvent) {
	      self.isScrollingHorizontally = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedHorizontal = gridUtil.debounce(horizontal, self.options.scrollDebounce);
	    var debouncedHorizontalMinDelay = gridUtil.debounce(horizontal, 0);
	
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingVertically
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingVertically to true and sets it to false in a debounced function
	     */
	    self.flagScrollingVertically = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingVertically = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedVerticalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedVertical(scrollEvent);
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingHorizontally
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingHorizontally to true and sets it to false in a debounced function
	     */
	    self.flagScrollingHorizontally = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingHorizontally = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedHorizontalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedHorizontal(scrollEvent);
	      }
	    };
	
	    self.scrollbarHeight = 0;
	    self.scrollbarWidth = 0;
	    if (self.options.enableHorizontalScrollbar !== uiGridConstants.scrollbars.NEVER) {
	      self.scrollbarHeight = gridUtil.getScrollbarWidth();
	    }
	
	    if (self.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER) {
	      self.scrollbarWidth = gridUtil.getScrollbarWidth();
	    }
	
	    self.api = new GridApi(self);
	
	    /**
	     * @ngdoc function
	     * @name refresh
	     * @methodOf ui.grid.api:PublicApi
	     * @description Refresh the rendered grid on screen.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     * If you only want to resize the grid, not regenerate all the rows
	     * and columns, you should consider directly calling refreshCanvas instead.
	     *
	     * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed
	     */
	    self.api.registerMethod( 'core', 'refresh', this.refresh );
	
	    /**
	     * @ngdoc function
	     * @name queueGridRefresh
	     * @methodOf ui.grid.api:PublicApi
	     * @description Request a refresh of the rendered grid on screen, if multiple
	     * calls to queueGridRefresh are made within a digest cycle only one will execute.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     */
	    self.api.registerMethod( 'core', 'queueGridRefresh', this.queueGridRefresh );
	
	    /**
	     * @ngdoc function
	     * @name refreshRows
	     * @methodOf ui.grid.api:PublicApi
	     * @description Runs only the rowProcessors, columns remain as they were.
	     * It then calls redrawInPlace and refreshCanvas, which adjust the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'refreshRows', this.refreshRows );
	
	    /**
	     * @ngdoc function
	     * @name queueRefresh
	     * @methodOf ui.grid.api:PublicApi
	     * @description Requests execution of refreshCanvas, if multiple requests are made
	     * during a digest cycle only one will run.  RefreshCanvas updates the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'queueRefresh', this.queueRefresh );
	
	    /**
	     * @ngdoc function
	     * @name handleWindowResize
	     * @methodOf ui.grid.api:PublicApi
	     * @description Trigger a grid resize, normally this would be picked
	     * up by a watch on window size, but in some circumstances it is necessary
	     * to call this manually
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'handleWindowResize', this.handleWindowResize );
	
	
	    /**
	     * @ngdoc function
	     * @name addRowHeaderColumn
	     * @methodOf ui.grid.api:PublicApi
	     * @description adds a row header column to the grid
	     * @param {object} column def
	     * @param {number} order Determines order of header column on grid.  Lower order means header
	     * is positioned to the left of higher order headers
	     *
	     */
	    self.api.registerMethod( 'core', 'addRowHeaderColumn', this.addRowHeaderColumn );
	
	    /**
	     * @ngdoc function
	     * @name scrollToIfNecessary
	     * @methodOf ui.grid.api:PublicApi
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridColumn} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     *
	     */
	    self.api.registerMethod( 'core', 'scrollToIfNecessary', function(gridRow, gridCol) { return self.scrollToIfNecessary(gridRow, gridCol);} );
	
	    /**
	     * @ngdoc function
	     * @name scrollTo
	     * @methodOf ui.grid.api:PublicApi
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    self.api.registerMethod( 'core', 'scrollTo', function (rowEntity, colDef) { return self.scrollTo(rowEntity, colDef);}  );
	
	    /**
	     * @ngdoc function
	     * @name registerRowsProcessor
	     * @methodOf ui.grid.api:PublicApi
	     * @description
	     * Register a "rows processor" function. When the rows are updated,
	     * the grid calls each registered "rows processor", which has a chance
	     * to alter the set of rows (sorting, etc) as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedRowsToProcess, columns )} processorFunction rows processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated rows list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, sort manipulations running at 60-65, filter is running at 100,
	     * sort is at 200, grouping and treeview at 400-410, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerRowsProcessor', this.registerRowsProcessor  );
	
	    /**
	     * @ngdoc function
	     * @name registerColumnsProcessor
	     * @methodOf ui.grid.api:PublicApi
	     * @description
	     * Register a "columns processor" function. When the columns are updated,
	     * the grid calls each registered "columns processor", which has a chance
	     * to alter the set of columns as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedColumnsToProcess, rows )} processorFunction columns processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated columns list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerColumnsProcessor', this.registerColumnsProcessor  );
	
	    /**
	     * @ngdoc function
	     * @name sortHandleNulls
	     * @methodOf ui.grid.api:PublicApi
	     * @description A null handling method that can be used when building custom sort
	     * functions
	     * @example
	     * <pre>
	     *   mySortFn = function(a, b) {
	     *   var nulls = $scope.gridApi.core.sortHandleNulls(a, b);
	     *   if ( nulls !== null ) {
	     *     return nulls;
	     *   } else {
	     *     // your code for sorting here
	     *   };
	     * </pre>
	     * @param {object} a sort value a
	     * @param {object} b sort value b
	     * @returns {number} null if there were no nulls/undefineds, otherwise returns
	     * a sort value that should be passed back from the sort function
	     *
	     */
	    self.api.registerMethod( 'core', 'sortHandleNulls', rowSorter.handleNulls );
	
	    /**
	     * @ngdoc function
	     * @name sortChanged
	     * @methodOf  ui.grid.api:PublicApi
	     * @description The sort criteria on one or more columns has
	     * changed.  Provides as parameters the grid and the output of
	     * getColumnSorting, which is an array of gridColumns
	     * that have sorting on them, sorted in priority order.
	     *
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back the grid and an array of
	     * columns with sorts on them, in priority order.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.sortChanged( $scope, function(grid, sortColumns) {
	     *        // do something
	     *      });
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'sortChanged' );
	
	      /**
	     * @ngdoc function
	     * @name columnVisibilityChanged
	     * @methodOf  ui.grid.api:PublicApi
	     * @description The visibility of a column has changed,
	     * the column itself is passed out as a parameter of the event.
	     *
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back the GridCol that has changed.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.columnVisibilityChanged( $scope, function (column) {
	     *        // do something
	     *      } );
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'columnVisibilityChanged' );
	
	    /**
	     * @ngdoc method
	     * @name notifyDataChange
	     * @methodOf ui.grid.api:PublicApi
	     * @description Notify the grid that a data or config change has occurred,
	     * where that change isn't something the grid was otherwise noticing.  This
	     * might be particularly relevant where you've changed values within the data
	     * and you'd like cell classes to be re-evaluated, or changed config within
	     * the columnDef and you'd like headerCellClasses to be re-evaluated.
	     * @param {string} type one of the
	     * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	     * values (ALL, ROW, EDIT, COLUMN, OPTIONS), which tells us which refreshes to fire.
	     *
	     * - ALL: listeners fired on any of these events, fires listeners on all events.
	     * - ROW: fired when a row is added or removed.
	     * - EDIT: fired when the data in a cell is edited.
	     * - COLUMN: fired when the column definitions are modified.
	     * - OPTIONS: fired when the grid options are modified.
	     */
	    self.api.registerMethod( 'core', 'notifyDataChange', this.notifyDataChange );
	
	    /**
	     * @ngdoc method
	     * @name clearAllFilters
	     * @methodOf ui.grid.api:PublicApi
	     * @description Clears all filters and optionally refreshes the visible rows.
	     * @param {object} refreshRows Defaults to true.
	     * @param {object} clearConditions Defaults to false.
	     * @param {object} clearFlags Defaults to false.
	     * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	     */
	    self.api.registerMethod('core', 'clearAllFilters', this.clearAllFilters);
	
	    self.registerDataChangeCallback( self.columnRefreshCallback, [uiGridConstants.dataChange.COLUMN]);
	    self.registerDataChangeCallback( self.processRowsCallback, [uiGridConstants.dataChange.EDIT]);
	    self.registerDataChangeCallback( self.updateFooterHeightCallback, [uiGridConstants.dataChange.OPTIONS]);
	
	    self.registerStyleComputation({
	      priority: 10,
	      func: self.getFooterStyles
	    });
	  };
	
	   Grid.prototype.calcFooterHeight = function () {
	     if (!this.hasFooter()) {
	       return 0;
	     }
	
	     var height = 0;
	     if (this.options.showGridFooter) {
	       height += this.options.gridFooterHeight;
	     }
	
	     height += this.calcColumnFooterHeight();
	
	     return height;
	   };
	
	   Grid.prototype.calcColumnFooterHeight = function () {
	     var height = 0;
	
	     if (this.options.showColumnFooter) {
	       height += this.options.columnFooterHeight;
	     }
	
	     return height;
	   };
	
	   Grid.prototype.getFooterStyles = function () {
	     var style = '.grid' + this.id + ' .ui-grid-footer-aggregates-row { height: ' + this.options.columnFooterHeight + 'px; }';
	     style += ' .grid' + this.id + ' .ui-grid-footer-info { height: ' + this.options.gridFooterHeight + 'px; }';
	     return style;
	   };
	
	  Grid.prototype.hasFooter = function () {
	   return this.options.showGridFooter || this.options.showColumnFooter;
	  };
	
	  /**
	   * @ngdoc function
	   * @name isRTL
	   * @methodOf ui.grid.class:Grid
	   * @description Returns true if grid is RightToLeft
	   */
	  Grid.prototype.isRTL = function () {
	    return this.rtl;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name registerColumnBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates columns from column definitions, the columnbuilders will be called to add
	   * additional properties to the column.
	   * @param {function(colDef, col, gridOptions)} columnBuilder function to be called
	   */
	  Grid.prototype.registerColumnBuilder = function registerColumnBuilder(columnBuilder) {
	    this.columnBuilders.push(columnBuilder);
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumnDefsFromData
	   * @methodOf ui.grid.class:Grid
	   * @description Populates columnDefs from the provided data
	   * @param {function(colDef, col, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.buildColumnDefsFromData = function (dataRows) {
	    this.options.columnDefs =  gridUtil.getColumnsFromData(dataRows, this.options.excludeProperties);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerRowBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates rows from gridOptions.data, the rowBuilders will be called to add
	   * additional properties to the row.
	   * @param {function(row, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.registerRowBuilder = function registerRowBuilder(rowBuilder) {
	    this.rowBuilders.push(rowBuilder);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerDataChangeCallback
	   * @methodOf ui.grid.class:Grid
	   * @description When a data change occurs, the data change callbacks of the specified type
	   * will be called.  The rules are:
	   *
	   * - when the data watch fires, that is considered a ROW change (the data watch only notices
	   *   added or removed rows)
	   * - when the api is called to inform us of a change, the declared type of that change is used
	   * - when a cell edit completes, the EDIT callbacks are triggered
	   * - when the columnDef watch fires, the COLUMN callbacks are triggered
	   * - when the options watch fires, the OPTIONS callbacks are triggered
	   *
	   * For a given event:
	   * - ALL calls ROW, EDIT, COLUMN, OPTIONS and ALL callbacks
	   * - ROW calls ROW and ALL callbacks
	   * - EDIT calls EDIT and ALL callbacks
	   * - COLUMN calls COLUMN and ALL callbacks
	   * - OPTIONS calls OPTIONS and ALL callbacks
	   *
	   * @param {function(grid)} callback function to be called
	   * @param {array} types the types of data change you want to be informed of.  Values from
	   * the {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	   *  values ( ALL, EDIT, ROW, COLUMN, OPTIONS ).  Optional and defaults to ALL
	   * @returns {function} deregister function - a function that can be called to deregister this callback
	   */
	  Grid.prototype.registerDataChangeCallback = function registerDataChangeCallback(callback, types, _this) {
	    var self = this,
	      uid = gridUtil.nextUid();
	
	    if ( !types ) {
	      types = [uiGridConstants.dataChange.ALL];
	    }
	    if ( !Array.isArray(types)) {
	      gridUtil.logError("Expected types to be an array or null in registerDataChangeCallback, value passed was: " + types );
	    }
	    this.dataChangeCallbacks[uid] = { callback: callback, types: types, _this: _this };
	
	    return function() {
	      delete self.dataChangeCallbacks[uid];
	    };
	  };
	
	  /**
	   * @ngdoc function
	   * @name callDataChangeCallbacks
	   * @methodOf ui.grid.class:Grid
	   * @description Calls the callbacks based on the type of data change that
	   * has occurred. Always calls the ALL callbacks, calls the ROW, EDIT, COLUMN and OPTIONS callbacks if the
	   * event type is matching, or if the type is ALL.
	   * @param {string} type the type of event that occurred - one of the
	   * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	   *  values (ALL, ROW, EDIT, COLUMN, OPTIONS)
	   */
	  Grid.prototype.callDataChangeCallbacks = function callDataChangeCallbacks(type, options) {
	    angular.forEach( this.dataChangeCallbacks, function( callback, uid ) {
	      if ( callback.types.indexOf( uiGridConstants.dataChange.ALL ) !== -1 ||
	           callback.types.indexOf( type ) !== -1 ||
	           type === uiGridConstants.dataChange.ALL ) {
	        if (callback._this) {
	           callback.callback.apply(callback._this, this, options);
	        }
	        else {
	          callback.callback(this, options);
	        }
	      }
	    }, this);
	  };
	
	  /**
	   * @ngdoc function
	   * @name notifyDataChange
	   * @methodOf ui.grid.class:Grid
	   * @description Notifies us that a data change has occurred, used in the public
	   * api for users to tell us when they've changed data or some other event that
	   * our watches cannot pick up
	   * @param {string} type the type of event that occurred - one of the
	   * uiGridConstants.dataChange values (ALL, ROW, EDIT, COLUMN, OPTIONS)
	   *
	   * - ALL: listeners fired on any of these events, fires listeners on all events.
	   * - ROW: fired when a row is added or removed.
	   * - EDIT: fired when the data in a cell is edited.
	   * - COLUMN: fired when the column definitions are modified.
	   * - OPTIONS: fired when the grid options are modified.
	   */
	  Grid.prototype.notifyDataChange = function notifyDataChange(type) {
	    var constants = uiGridConstants.dataChange;
	
	    if ( type === constants.ALL ||
	         type === constants.COLUMN ||
	         type === constants.EDIT ||
	         type === constants.ROW ||
	         type === constants.OPTIONS ) {
	      this.callDataChangeCallbacks( type );
	    }
	    else {
	      gridUtil.logError("Notified of a data change, but the type was not recognised, so no action taken, type was: " + type);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name columnRefreshCallback
	   * @methodOf ui.grid.class:Grid
	   * @description refreshes the grid when a column refresh
	   * is notified, which triggers handling of the visible flag.
	   * This is called on uiGridConstants.dataChange.COLUMN, and is
	   * registered as a dataChangeCallback in grid.js
	   * @param {object} grid The grid object.
	   * @param {object} options Any options passed into the callback.
	   */
	  Grid.prototype.columnRefreshCallback = function columnRefreshCallback(grid, options) {
	    grid.buildColumns(options);
	    grid.queueGridRefresh();
	  };
	
	  /**
	   * @ngdoc function
	   * @name processRowsCallback
	   * @methodOf ui.grid.class:Grid
	   * @description calls the row processors, specifically
	   * intended to reset the sorting when an edit is called,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.EDIT
	   * @param {object} grid The grid object.
	   */
	  Grid.prototype.processRowsCallback = function processRowsCallback( grid ) {
	    grid.queueGridRefresh();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateFooterHeightCallback
	   * @methodOf ui.grid.class:Grid
	   * @description recalculates the footer height,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.OPTIONS
	   * @param {object} grid The grid object.
	   */
	  Grid.prototype.updateFooterHeightCallback = function updateFooterHeightCallback( grid ) {
	    grid.footerHeight = grid.calcFooterHeight();
	    grid.columnFooterHeight = grid.calcColumnFooterHeight();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid column for the column name
	   * @param {string} name column name
	   */
	  Grid.prototype.getColumn = function getColumn(name) {
	    var columns = this.columns.filter(function (column) {
	      return column.colDef.name === name;
	    });
	
	    return columns.length > 0 ? columns[0] : null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColDef
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid colDef for the column name
	   * @param {string} name column.field
	   */
	  Grid.prototype.getColDef = function getColDef(name) {
	    var colDefs = this.options.columnDefs.filter(function (colDef) {
	      return colDef.name === name;
	    });
	    return colDefs.length > 0 ? colDefs[0] : null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name assignTypes
	   * @methodOf ui.grid.class:Grid
	   * @description uses the first row of data to assign colDef.type for any types not defined.
	   */
	  /**
	   * @ngdoc property
	   * @name type
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description the type of the column, used in sorting.  If not provided then the
	   * grid will guess the type.  Add this only if the grid guessing is not to your
	   * satisfaction.  One of:
	   * - 'string'
	   * - 'boolean'
	   * - 'number'
	   * - 'date'
	   * - 'object'
	   * - 'numberStr'
	   * Note that if you choose date, your dates should be in a javascript date type
	   *
	   */
	  Grid.prototype.assignTypes = function() {
	    var self = this;
	
	    self.options.columnDefs.forEach(function (colDef, index) {
	      // Assign colDef type if not specified
	      if (!colDef.type) {
	        var col = new GridColumn(colDef, index, self);
	        var firstRow = self.rows.length > 0 ? self.rows[0] : null;
	        if (firstRow) {
	          colDef.type = gridUtil.guessType(self.getCellValue(firstRow, col));
	        }
	        else {
	          colDef.type = 'string';
	        }
	      }
	    });
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name isRowHeaderColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if the column is a row Header
	   * @param {object} column column
	   */
	  Grid.prototype.isRowHeaderColumn = function isRowHeaderColumn(column) {
	    return this.rowHeaderColumns.indexOf(column) !== -1;
	  };
	
	  /**
	  * @ngdoc function
	  * @name addRowHeaderColumn
	  * @methodOf ui.grid.class:Grid
	  * @description adds a row header column to the grid
	  * @param {object} colDef Column definition object.
	  * @param {float} order Number that indicates where the column should be placed in the grid.
	  * @param {boolean} stopColumnBuild Prevents the buildColumn callback from being triggered. This is useful to improve
	  * performance of the grid during initial load.
	  */
	  Grid.prototype.addRowHeaderColumn = function addRowHeaderColumn(colDef, order, stopColumnBuild) {
	    var self = this;
	
	    // default order
	    if (order === undefined) {
	      order = 0;
	    }
	
	    var rowHeaderCol = new GridColumn(colDef, gridUtil.nextUid(), self);
	    rowHeaderCol.isRowHeader = true;
	    if (self.isRTL()) {
	      self.createRightContainer();
	      rowHeaderCol.renderContainer = 'right';
	    }
	    else {
	      self.createLeftContainer();
	      rowHeaderCol.renderContainer = 'left';
	    }
	
	    // relies on the default column builder being first in array, as it is instantiated
	    // as part of grid creation
	    self.columnBuilders[0](colDef,rowHeaderCol,self.options)
	      .then(function() {
	        rowHeaderCol.enableFiltering = false;
	        rowHeaderCol.enableSorting = false;
	        rowHeaderCol.enableHiding = false;
	        rowHeaderCol.headerPriority = order;
	        self.rowHeaderColumns.push(rowHeaderCol);
	        self.rowHeaderColumns = self.rowHeaderColumns.sort(function (a, b) {
	          return a.headerPriority - b.headerPriority;
	        });
	
	        if (!stopColumnBuild) {
	          self.buildColumns()
	            .then(function() {
	              self.preCompileCellTemplates();
	              self.queueGridRefresh();
	            }).catch(angular.noop);
	        }
	      }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name getOnlyDataColumns
	   * @methodOf ui.grid.class:Grid
	   * @description returns all columns except for rowHeader columns
	   */
	  Grid.prototype.getOnlyDataColumns = function getOnlyDataColumns() {
	    var self = this,
	      cols = [];
	
	    self.columns.forEach(function (col) {
	      if (self.rowHeaderColumns.indexOf(col) === -1) {
	        cols.push(col);
	      }
	    });
	    return cols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumns
	   * @methodOf ui.grid.class:Grid
	   * @description creates GridColumn objects from the columnDefinition.  Calls each registered
	   * columnBuilder to further process the column
	   * @param {object} opts An object contains options to use when building columns
	   *
	   * * **orderByColumnDefs**: defaults to **false**. When true, `buildColumns` will reorder existing columns according to the order within the column definitions.
	   *
	   * @returns {Promise} a promise to load any needed column resources
	   */
	  Grid.prototype.buildColumns = function buildColumns(opts) {
	    var options = {
	      orderByColumnDefs: false
	    };
	
	    angular.extend(options, opts);
	
	    // gridUtil.logDebug('buildColumns');
	    var self = this;
	    var builderPromises = [];
	    var headerOffset = self.rowHeaderColumns.length;
	    var i;
	
	    // Remove any columns for which a columnDef cannot be found
	    // Deliberately don't use forEach, as it doesn't like splice being called in the middle
	    // Also don't cache columns.length, as it will change during this operation
	    for (i = 0; i < self.columns.length; i++) {
	      if (!self.getColDef(self.columns[i].name)) {
	        self.columns.splice(i, 1);
	        i--;
	      }
	    }
	
	    // add row header columns to the grid columns array _after_ columns without columnDefs have been removed
	    // rowHeaderColumns is ordered by priority so insert in reverse
	    for (var j = self.rowHeaderColumns.length - 1; j >= 0; j--) {
	      self.columns.unshift(self.rowHeaderColumns[j]);
	    }
	
	    // look at each column def, and update column properties to match.  If the column def
	    // doesn't have a column, then splice in a new gridCol
	    self.options.columnDefs.forEach(function (colDef, index) {
	      self.preprocessColDef(colDef);
	      var col = self.getColumn(colDef.name);
	
	      if (!col) {
	        col = new GridColumn(colDef, gridUtil.nextUid(), self);
	        self.columns.splice(index + headerOffset, 0, col);
	      }
	      else {
	        // tell updateColumnDef that the column was pre-existing
	        col.updateColumnDef(colDef, false);
	      }
	
	      self.columnBuilders.forEach(function (builder) {
	        builderPromises.push(builder.call(self, colDef, col, self.options));
	      });
	    });
	
	    /*** Reorder columns if necessary ***/
	    if (!!options.orderByColumnDefs) {
	      // Create a shallow copy of the columns as a cache
	      var columnCache = self.columns.slice(0);
	
	      // We need to allow for the "row headers" when mapping from the column defs array to the columns array
	      //   If we have a row header in columns[0] and don't account for it   we'll overwrite it with the column in columnDefs[0]
	
	      // Go through all the column defs, use the shorter of columns length and colDefs.length because if a user has given two columns the same name then
	      // columns will be shorter than columnDefs.  In this situation we'll avoid an error, but the user will still get an unexpected result
	      var len = Math.min(self.options.columnDefs.length, self.columns.length);
	      for (i = 0; i < len; i++) {
	        // If the column at this index has a different name than the column at the same index in the column defs...
	        if (self.columns[i + headerOffset].name !== self.options.columnDefs[i].name) {
	          // Replace the one in the cache with the appropriate column
	          columnCache[i + headerOffset] = self.getColumn(self.options.columnDefs[i].name);
	        }
	        else {
	          // Otherwise just copy over the one from the initial columns
	          columnCache[i + headerOffset] = self.columns[i + headerOffset];
	        }
	      }
	
	      // Empty out the columns array, non-destructively
	      self.columns.length = 0;
	
	      // And splice in the updated, ordered columns from the cache
	      Array.prototype.splice.apply(self.columns, [0, 0].concat(columnCache));
	    }
	
	    return $q.all(builderPromises).then(function() {
	      if (self.rows.length > 0) {
	        self.assignTypes();
	      }
	      if (options.preCompileCellTemplates) {
	        self.preCompileCellTemplates();
	      }
	    }).catch(angular.noop);
	  };
	
	  Grid.prototype.preCompileCellTemplate = function(col) {
	    var self = this;
	    var html = col.cellTemplate.replace(uiGridConstants.MODEL_COL_FIELD, self.getQualifiedColField(col));
	    html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	    col.compiledElementFn = $compile(html);
	
	    if (col.compiledElementFnDefer) {
	      col.compiledElementFnDefer.resolve(col.compiledElementFn);
	    }
	  };
	
	/**
	 * @ngdoc function
	 * @name preCompileCellTemplates
	 * @methodOf ui.grid.class:Grid
	 * @description precompiles all cell templates
	 */
	  Grid.prototype.preCompileCellTemplates = function() {
	    var self = this;
	    self.columns.forEach(function (col) {
	      if ( col.cellTemplate ) {
	        self.preCompileCellTemplate( col );
	      } else if ( col.cellTemplatePromise ) {
	        col.cellTemplatePromise.then( function() {
	          self.preCompileCellTemplate( col );
	        }).catch(angular.noop);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getGridQualifiedColField
	   * @methodOf ui.grid.class:Grid
	   * @description Returns the $parse-able accessor for a column within its $scope
	   * @param {GridColumn} col col object
	   */
	  Grid.prototype.getQualifiedColField = function (col) {
	    var base = 'row.entity';
	    if ( col.field === uiGridConstants.ENTITY_BINDING ) {
	      return base;
	    }
	    return gridUtil.preEval(base + '.' + col.field);
	  };
	
	  /**
	   * @ngdoc function
	   * @name createLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the left render container if it doesn't already exist
	   */
	  Grid.prototype.createLeftContainer = function() {
	    if (!this.hasLeftContainer()) {
	      this.renderContainers.left = new GridRenderContainer('left', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name createRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the right render container if it doesn't already exist
	   */
	  Grid.prototype.createRightContainer = function() {
	    if (!this.hasRightContainer()) {
	      this.renderContainers.right = new GridRenderContainer('right', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if leftContainer exists
	   */
	  Grid.prototype.hasLeftContainer = function() {
	    return this.renderContainers.left !== undefined;
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if rightContainer exists
	   */
	  Grid.prototype.hasRightContainer = function() {
	    return this.renderContainers.right !== undefined;
	  };
	
	
	      /**
	   * undocumented function
	   * @name preprocessColDef
	   * @methodOf ui.grid.class:Grid
	   * @description defaults the name property from field to maintain backwards compatibility with 2.x
	   * validates that name or field is present
	   */
	  Grid.prototype.preprocessColDef = function preprocessColDef(colDef) {
	    var self = this;
	
	    if (!colDef.field && !colDef.name) {
	      throw new Error('colDef.name or colDef.field property is required');
	    }
	
	    // maintain backwards compatibility with 2.x
	    // field was required in 2.x.  now name is required
	    if (colDef.name === undefined && colDef.field !== undefined) {
	      // See if the column name already exists:
	      var newName = colDef.field,
	        counter = 2;
	      while (self.getColumn(newName)) {
	        newName = colDef.field + counter.toString();
	        counter++;
	      }
	      colDef.name = newName;
	    }
	  };
	
	  // Return a list of items that exist in the `n` array but not the `o` array. Uses optional property accessors passed as third & fourth parameters
	  Grid.prototype.newInN = function newInN(o, n, oAccessor, nAccessor) {
	    var self = this;
	
	    var t = [];
	    for (var i = 0; i < n.length; i++) {
	      var nV = nAccessor ? n[i][nAccessor] : n[i];
	
	      var found = false;
	      for (var j = 0; j < o.length; j++) {
	        var oV = oAccessor ? o[j][oAccessor] : o[j];
	        if (self.options.rowEquality(nV, oV)) {
	          found = true;
	          break;
	        }
	      }
	      if (!found) {
	        t.push(nV);
	      }
	    }
	
	    return t;
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRow
	   * @methodOf ui.grid.class:Grid
	   * @description returns the GridRow that contains the rowEntity
	   * @param {object} rowEntity the gridOptions.data array element instance
	   * @param {array} lookInRows [optional] the rows to look in - if not provided then
	   * looks in grid.rows
	   */
	  Grid.prototype.getRow = function getRow(rowEntity, lookInRows) {
	    var self = this;
	
	    lookInRows = typeof(lookInRows) === 'undefined' ? self.rows : lookInRows;
	
	    var rows = lookInRows.filter(function (row) {
	      return self.options.rowEquality(row.entity, rowEntity);
	    });
	    return rows.length > 0 ? rows[0] : null;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name modifyRows
	   * @methodOf ui.grid.class:Grid
	   * @description creates or removes GridRow objects from the newRawData array.  Calls each registered
	   * rowBuilder to further process the row
	   * @param {array} newRawData Modified set of data
	   *
	   * This method aims to achieve three things:
	   * 1. the resulting rows array is in the same order as the newRawData, we'll call
	   * rowsProcessors immediately after to sort the data anyway
	   * 2. if we have row hashing available, we try to use the rowHash to find the row
	   * 3. no memory leaks - rows that are no longer in newRawData need to be garbage collected
	   *
	   * The basic logic flow makes use of the newRawData, oldRows and oldHash, and creates
	   * the newRows and newHash
	   *
	   * ```
	   * newRawData.forEach newEntity
	   *   if (hashing enabled)
	   *     check oldHash for newEntity
	   *   else
	   *     look for old row directly in oldRows
	   *   if !oldRowFound     // must be a new row
	   *     create newRow
	   *   append to the newRows and add to newHash
	   *   run the processors
	   * ```
	   *
	   * Rows are identified using the hashKey if configured.  If not configured, then rows
	   * are identified using the gridOptions.rowEquality function
	   *
	   * This method is useful when trying to select rows immediately after loading data without
	   * using a $timeout/$interval, e.g.:
	   *
	   *   $scope.gridOptions.data =  someData;
	   *   $scope.gridApi.grid.modifyRows($scope.gridOptions.data);
	   *   $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
	   *
	   * OR to persist row selection after data update (e.g. rows selected, new data loaded, want
	   * originally selected rows to be re-selected))
	   */
	  Grid.prototype.modifyRows = function modifyRows(newRawData) {
	    var self = this;
	    var oldRows = self.rows.slice(0);
	    var oldRowHash = self.rowHashMap || self.createRowHashMap();
	    var allRowsSelected = true;
	    self.rowHashMap = self.createRowHashMap();
	    self.rows.length = 0;
	
	    newRawData.forEach( function( newEntity, i ) {
	      var newRow, oldRow;
	
	      if ( self.options.enableRowHashing ) {
	        // if hashing is enabled, then this row will be in the hash if we already know about it
	        oldRow = oldRowHash.get( newEntity );
	      } else {
	        // otherwise, manually search the oldRows to see if we can find this row
	        oldRow = self.getRow(newEntity, oldRows);
	      }
	
	      // update newRow to have an entity
	      if ( oldRow ) {
	        newRow = oldRow;
	        newRow.entity = newEntity;
	      }
	
	      // if we didn't find the row, it must be new, so create it
	      if ( !newRow ) {
	        newRow = self.processRowBuilders(new GridRow(newEntity, i, self));
	      }
	
	      self.rows.push( newRow );
	      self.rowHashMap.put( newEntity, newRow );
	      if (!newRow.isSelected) {
	        allRowsSelected = false;
	      }
	    });
	
	    if (self.selection && self.rows.length) {
	      self.selection.selectAll = allRowsSelected;
	    }
	
	    self.assignTypes();
	
	    var p1 = $q.when(self.processRowsProcessors(self.rows))
	      .then(function (renderableRows) {
	        return self.setVisibleRows(renderableRows);
	      }).catch(angular.noop);
	
	    var p2 = $q.when(self.processColumnsProcessors(self.columns))
	      .then(function (renderableColumns) {
	        return self.setVisibleColumns(renderableColumns);
	      }).catch(angular.noop);
	
	    return $q.all([p1, p2]);
	  };
	
	
	  /**
	   * Private Undocumented Method
	   * @name addRows
	   * @methodOf ui.grid.class:Grid
	   * @description adds the newRawData array of rows to the grid and calls all registered
	   * rowBuilders. this keyword will reference the grid
	   */
	  Grid.prototype.addRows = function addRows(newRawData) {
	    var self = this,
	      existingRowCount = self.rows.length;
	
	    for (var i = 0; i < newRawData.length; i++) {
	      var newRow = self.processRowBuilders(new GridRow(newRawData[i], i + existingRowCount, self));
	
	      if (self.options.enableRowHashing) {
	        var found = self.rowHashMap.get(newRow.entity);
	        if (found) {
	          found.row = newRow;
	        }
	      }
	
	      self.rows.push(newRow);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name processRowBuilders
	   * @methodOf ui.grid.class:Grid
	   * @description processes all RowBuilders for the gridRow
	   * @param {GridRow} gridRow reference to gridRow
	   * @returns {GridRow} the gridRow with all additional behavior added
	   */
	  Grid.prototype.processRowBuilders = function processRowBuilders(gridRow) {
	    var self = this;
	
	    self.rowBuilders.forEach(function (builder) {
	      builder.call(self, gridRow, self.options);
	    });
	
	    return gridRow;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerStyleComputation
	   * @methodOf ui.grid.class:Grid
	   * @description registered a styleComputation function
	   *
	   * If the function returns a value it will be appended into the grid's `<style>` block
	   * @param {function($scope)} styleComputationInfo function
	   */
	  Grid.prototype.registerStyleComputation = function registerStyleComputation(styleComputationInfo) {
	    this.styleComputations.push(styleComputationInfo);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @description
	   *
	   * Register a "rows processor" function. When the rows are updated,
	   * the grid calls each registered "rows processor", which has a chance
	   * to alter the set of rows (sorting, etc) as long as the count is not
	   * modified.
	   *
	   * @param {function(renderedRowsToProcess, columns )} processor rows processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and must
	   * return the updated rows list, which is passed to the next processor in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   *
	   */
	  Grid.prototype.registerRowsProcessor = function registerRowsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.rowsProcessors.push({processor: processor, priority: priority});
	    this.rowsProcessors.sort(function sortByPriority( a, b ) {
	      return a.priority - b.priority;
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderableRows)} processor processor function
	   * @description Remove a registered rows processor
	   */
	  Grid.prototype.removeRowsProcessor = function removeRowsProcessor(processor) {
	    var idx = -1;
	    this.rowsProcessors.forEach(function(rowsProcessor, index) {
	      if ( rowsProcessor.processor === processor ) {
	        idx = index;
	      }
	    });
	
	    if ( idx !== -1 ) {
	      this.rowsProcessors.splice(idx, 1);
	    }
	  };
	
	  /**
	   * Private Undocumented Method
	   * @name processRowsProcessors
	   * @methodOf ui.grid.class:Grid
	   * @param {Array[GridRow]} renderableRows The array of "renderable" rows
	   * @description Run all the registered rows processors on the array of renderable rows
	   */
	  Grid.prototype.processRowsProcessors = function processRowsProcessors(renderableRows) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableRows = renderableRows.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.rowsProcessors.length === 0) {
	      return $q.when(myRenderableRows);
	    }
	
	    // Counter for iterating through rows processors
	    var i = 0;
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedRowsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.rowsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedRowsToProcess, self.columns) )
	        .then(function handleProcessedRows(processedRows) {
	          // Check for errors
	          if (!processedRows) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedRows)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.rowsProcessors.length - 1) {
	            return startProcessor(i, processedRows);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(processedRows);
	          }
	        }).catch(function(error) {
	          throw error;
	        });
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableRows);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleRows = function setVisibleRows(rows) {
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.canvasHeightShouldUpdate = true;
	
	      if ( typeof(container.visibleRowCache) === 'undefined' ) {
	        container.visibleRowCache = [];
	      } else {
	        container.visibleRowCache.length = 0;
	      }
	    }
	
	    // rows.forEach(function (row) {
	    for (var ri = 0; ri < rows.length; ri++) {
	      var row = rows[ri];
	
	      var targetContainer = (typeof(row.renderContainer) !== 'undefined' && row.renderContainer) ? row.renderContainer : 'body';
	
	      // If the row is visible
	      if (row.visible) {
	        self.renderContainers[targetContainer].visibleRowCache.push(row);
	      }
	    }
	    self.api.core.raise.rowsVisibleChanged(this.api);
	    self.api.core.raise.rowsRendered(this.api);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerColumnsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderedColumnsToProcess, rows)} processor column processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and
	   * which must return an updated renderedColumnsToProcess which can be passed to the next processor
	   * in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   * @description
	
	     Register a "columns processor" function. When the columns are updated,
	     the grid calls each registered "columns processor", which has a chance
	     to alter the set of columns, as long as the count is not modified.
	   */
	  Grid.prototype.registerColumnsProcessor = function registerColumnsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.columnsProcessors.push({processor: processor, priority: priority});
	    this.columnsProcessors.sort(function sortByPriority( a, b ) {
	      return a.priority - b.priority;
	    });
	  };
	
	  Grid.prototype.removeColumnsProcessor = function removeColumnsProcessor(processor) {
	    var idx = this.columnsProcessors.indexOf(processor);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.columnsProcessors.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.processColumnsProcessors = function processColumnsProcessors(renderableColumns) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableColumns = renderableColumns.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.columnsProcessors.length === 0) {
	      return $q.when(myRenderableColumns);
	    }
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedColumnsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.columnsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedColumnsToProcess, self.rows) )
	        .then(function handleProcessedRows(processedColumns) {
	          // Check for errors
	          if (!processedColumns) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedColumns)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.columnsProcessors.length - 1) {
	            return startProcessor(i, myRenderableColumns);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(myRenderableColumns);
	          }
	        }).catch(angular.noop);
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableColumns);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleColumns = function setVisibleColumns(columns) {
	    // gridUtil.logDebug('setVisibleColumns');
	
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.visibleColumnCache.length = 0;
	    }
	
	    for (var ci = 0; ci < columns.length; ci++) {
	      var column = columns[ci];
	
	      // If the column is visible
	      if (column.visible) {
	        // If the column has a container specified
	        if (typeof(column.renderContainer) !== 'undefined' && column.renderContainer) {
	          self.renderContainers[column.renderContainer].visibleColumnCache.push(column);
	        }
	        // If not, put it into the body container
	        else {
	          self.renderContainers.body.visibleColumnCache.push(column);
	        }
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name handleWindowResize
	   * @methodOf ui.grid.class:Grid
	   * @description Triggered when the browser window resizes; automatically resizes the grid
	   * @returns {Promise} A resolved promise once the window resize has completed.
	   */
	  Grid.prototype.handleWindowResize = function handleWindowResize($event) {
	    var self = this;
	
	    self.gridWidth = gridUtil.elementWidth(self.element);
	    self.gridHeight = gridUtil.elementHeight(self.element);
	
	    return self.queueRefresh();
	  };
	
	  /**
	   * @ngdoc function
	   * @name queueRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refreshCanvas, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueRefresh = function queueRefresh() {
	    var self = this;
	
	    if (self.refreshCanceller) {
	      $timeout.cancel(self.refreshCanceller);
	    }
	
	    self.refreshCanceller = $timeout(function () {
	      self.refreshCanvas(true);
	    });
	
	    self.refreshCanceller.then(function () {
	      self.refreshCanceller = null;
	    }).catch(angular.noop);
	
	    return self.refreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name queueGridRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refresh, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueGridRefresh = function queueGridRefresh() {
	    var self = this;
	
	    if (self.gridRefreshCanceller) {
	      $timeout.cancel(self.gridRefreshCanceller);
	    }
	
	    self.gridRefreshCanceller = $timeout(function () {
	      self.refresh(true);
	    });
	
	    self.gridRefreshCanceller.then(function () {
	      self.gridRefreshCanceller = null;
	    }).catch(angular.noop);
	
	    return self.gridRefreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateCanvasHeight
	   * @methodOf ui.grid.class:Grid
	   * @description flags all render containers to update their canvas height
	   */
	  Grid.prototype.updateCanvasHeight = function updateCanvasHeight() {
	    var self = this;
	
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	        container.canvasHeightShouldUpdate = true;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildStyles
	   * @methodOf ui.grid.class:Grid
	   * @description calls each styleComputation function
	   */
	  Grid.prototype.buildStyles = function buildStyles() {
	    var self = this;
	
	    // gridUtil.logDebug('buildStyles');
	
	    self.customStyles = '';
	
	    self.styleComputations
	      .sort(function(a, b) {
	        if (a.priority === null) { return 1; }
	        if (b.priority === null) { return -1; }
	        if (a.priority === null && b.priority === null) { return 0; }
	        return a.priority - b.priority;
	      })
	      .forEach(function (compInfo) {
	        // this used to provide $scope as a second parameter, but I couldn't find any
	        // style builders that used it, so removed it as part of moving to grid from controller
	        var ret = compInfo.func.call(self);
	
	        if (angular.isString(ret)) {
	          self.customStyles += '\n' + ret;
	        }
	      });
	  };
	
	
	  Grid.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewport = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	    self.columns.forEach(function(col, i) {
	      if (totalWidth < viewport) {
	        totalWidth += col.drawnWidth;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.columns[j].drawnWidth;
	        }
	        if (currWidth < viewport) {
	          min++;
	        }
	      }
	    });
	
	    return min;
	  };
	
	  Grid.prototype.getBodyHeight = function getBodyHeight() {
	    return this.getViewportHeight();
	  };
	
	  // NOTE: viewport drawable height is the height of the grid minus the header row height (including any border)
	  // TODO(c0bra): account for footer height
	  Grid.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var viewPortHeight = this.gridHeight - this.headerHeight - this.footerHeight;
	
	    // Account for native horizontal scrollbar, if present
	    // if (typeof(this.horizontalScrollbarHeight) !== 'undefined' && this.horizontalScrollbarHeight !== undefined && this.horizontalScrollbarHeight > 0) {
	    //   viewPortHeight = viewPortHeight - this.horizontalScrollbarHeight;
	    // }
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    // gridUtil.logDebug('viewPortHeight', viewPortHeight);
	
	    return viewPortHeight;
	  };
	
	  Grid.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewPortWidth = this.gridWidth;
	
	    // if (typeof(this.verticalScrollbarWidth) !== 'undefined' && this.verticalScrollbarWidth !== undefined && this.verticalScrollbarWidth > 0) {
	    //   viewPortWidth = viewPortWidth - this.verticalScrollbarWidth;
	    // }
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortWidth = viewPortWidth + adjustment.width;
	
	    // gridUtil.logDebug('getviewPortWidth', viewPortWidth);
	
	    return viewPortWidth;
	  };
	
	  Grid.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    return this.getViewportWidth();
	  };
	
	  Grid.prototype.addVerticalScrollSync = function (containerId, callBackFn) {
	    this.verticalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	  Grid.prototype.addHorizontalScrollSync = function (containerId, callBackFn) {
	    this.horizontalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	/**
	 * Scroll needed containers by calling their ScrollSyncs
	 * @param sourceContainerId the containerId that has already set it's top/left.
	 *         can be empty string which means all containers need to set top/left
	 * @param scrollEvent
	 */
	  Grid.prototype.scrollContainers = function (sourceContainerId, scrollEvent) {
	    if (scrollEvent.y) {
	      // default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var verts = ['body','left', 'right'];
	
	      this.flagScrollingVertically(scrollEvent);
	
	      if (sourceContainerId === 'body') {
	        verts = ['left', 'right'];
	      }
	      else if (sourceContainerId === 'left') {
	        verts = ['body', 'right'];
	      }
	      else if (sourceContainerId === 'right') {
	        verts = ['body', 'left'];
	      }
	
	      for (var i = 0; i < verts.length; i++) {
	        var id = verts[i];
	        if (this.verticalScrollSyncCallBackFns[id]) {
	          this.verticalScrollSyncCallBackFns[id](scrollEvent);
	        }
	      }
	
	    }
	
	    if (scrollEvent.x) {
	      // default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var horizs = ['body','bodyheader', 'bodyfooter'];
	
	      this.flagScrollingHorizontally(scrollEvent);
	      if (sourceContainerId === 'body') {
	        horizs = ['bodyheader', 'bodyfooter'];
	      }
	
	      for (var j = 0; j < horizs.length; j++) {
	        var idh = horizs[j];
	        if (this.horizontalScrollSyncCallBackFns[idh]) {
	          this.horizontalScrollSyncCallBackFns[idh](scrollEvent);
	        }
	      }
	    }
	  };
	
	  Grid.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  Grid.prototype.removeViewportAdjuster = function registerViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  Grid.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleRowCache.length;
	  };
	
	   Grid.prototype.getVisibleRows = function getVisibleRows() {
	    return this.renderContainers.body.visibleRowCache;
	   };
	
	  Grid.prototype.getVisibleColumnCount = function getVisibleColumnCount() {
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleColumnCache.length;
	  };
	
	
	  Grid.prototype.searchRows = function searchRows(renderableRows) {
	    return rowSearcher.search(this, renderableRows, this.columns);
	  };
	
	  Grid.prototype.sortByColumn = function sortByColumn(renderableRows) {
	    return rowSorter.sort(this, renderableRows, this.columns);
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the value of a cell for a particular row and column
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellValue = function getCellValue(row, col) {
	    if ( typeof(row.entity[ '$$' + col.uid ]) !== 'undefined' ) {
	      return row.entity[ '$$' + col.uid].rendered;
	    }
	    else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined' ) {
	      return row.entity[col.field];
	    }
	    else {
	      if (!col.cellValueGetterCache) {
	        col.cellValueGetterCache = $parse(row.getEntityQualifiedColField(col));
	      }
	
	      return col.cellValueGetterCache(row);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellDisplayValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the displayed value of a cell after applying any the `cellFilter`
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellDisplayValue = function getCellDisplayValue(row, col) {
	    if ( !col.cellDisplayGetterCache ) {
	      var custom_filter = col.cellFilter ? " | " + col.cellFilter : "";
	
	      if (typeof(row.entity['$$' + col.uid]) !== 'undefined') {
	        col.cellDisplayGetterCache = $parse(row.entity['$$' + col.uid].rendered + custom_filter);
	      }
	      else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined') {
	        var colField = col.field.replace(/(')|(\\)/g, "\\$&");
	
	        col.cellDisplayGetterCache = $parse('entity[\'' + colField + '\']' + custom_filter);
	      }
	      else {
	        col.cellDisplayGetterCache = $parse(row.getEntityQualifiedColField(col) + custom_filter);
	      }
	    }
	
	    var rowWithCol = angular.extend({}, row, {col: col});
	
	    return col.cellDisplayGetterCache(rowWithCol);
	  };
	
	
	  Grid.prototype.getNextColumnSortPriority = function getNextColumnSortPriority() {
	    var self = this,
	        p = 0;
	
	    self.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority >= p) {
	        p = col.sort.priority + 1;
	      }
	    });
	
	    return p;
	  };
	
	  /**
	   * @ngdoc function
	   * @name resetColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @param {GridColumn} [excludedColumn] Optional GridColumn to exclude from having its sorting reset
	   */
	  Grid.prototype.resetColumnSorting = function resetColumnSorting(excludeCol) {
	    var self = this;
	
	    self.columns.forEach(function (col) {
	      if (col !== excludeCol && !col.suppressRemoveSort) {
	        col.sort = {};
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @returns {Array[GridColumn]} An array of GridColumn objects
	   */
	  Grid.prototype.getColumnSorting = function getColumnSorting() {
	    var self = this;
	
	    var sortedCols = [], myCols;
	
	    // Iterate through all the columns, sorted by priority
	    // Make local copy of column list, because sorting is in-place and we do not want to
	    // change the original sequence of columns
	    myCols = self.columns.slice(0);
	    myCols.sort(rowSorter.prioritySort).forEach(function (col) {
	      if (col.sort && typeof(col.sort.direction) !== 'undefined' && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortedCols.push(col);
	      }
	    });
	
	    return sortedCols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name sortColumn
	   * @methodOf ui.grid.class:Grid
	   * @description Set the sorting on a given column, optionally resetting any existing sorting on the Grid.
	   * Emits the sortChanged event whenever the sort criteria are changed.
	   * @param {GridColumn} column Column to set the sorting on
	   * @param {uiGridConstants.ASC|uiGridConstants.DESC} [direction] Direction to sort by, either descending or ascending.
	   *   If not provided, the column will iterate through the sort directions
	   *   specified in the {@link ui.grid.class:GridOptions.columnDef#sortDirectionCycle sortDirectionCycle} attribute.
	   * @param {boolean} [add] Add this column to the sorting. If not provided or set to `false`, the Grid will reset any existing sorting and sort
	   *   by this column only
	   * @returns {Promise} A resolved promise that supplies the column.
	   */
	
	  Grid.prototype.sortColumn = function sortColumn(column, directionOrAdd, add) {
	    var self = this,
	        direction = null;
	
	    if (typeof(column) === 'undefined' || !column) {
	      throw new Error('No column parameter provided');
	    }
	
	    // Second argument can either be a direction or whether to add this column to the existing sort.
	    //   If it's a boolean, it's an add, otherwise, it's a direction
	    if (typeof(directionOrAdd) === 'boolean') {
	      add = directionOrAdd;
	    }
	    else {
	      direction = directionOrAdd;
	    }
	
	    if (!add) {
	      self.resetColumnSorting(column);
	      column.sort.priority = undefined;
	      // Get the actual priority since there may be columns which have suppressRemoveSort set
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	    else if (column.sort.priority === undefined) {
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	
	    if (!direction) {
	      // Find the current position in the cycle (or -1).
	      var i = column.sortDirectionCycle.indexOf(column.sort && column.sort.direction ? column.sort.direction : null);
	      // Proceed to the next position in the cycle (or start at the beginning).
	      i = (i+1) % column.sortDirectionCycle.length;
	      // If suppressRemoveSort is set, and the next position in the cycle would
	      // remove the sort, skip it.
	      if (column.colDef && column.suppressRemoveSort && !column.sortDirectionCycle[i]) {
	        i = (i+1) % column.sortDirectionCycle.length;
	      }
	
	      if (column.sortDirectionCycle[i]) {
	        column.sort.direction = column.sortDirectionCycle[i];
	      } else {
	        removeSortOfColumn(column, self);
	      }
	    }
	    else {
	      column.sort.direction = direction;
	    }
	
	    self.api.core.raise.sortChanged( self, self.getColumnSorting() );
	
	    return $q.when(column);
	  };
	
	  var removeSortOfColumn = function removeSortOfColumn(column, grid) {
	    // Decrease priority for every col where priority is higher than the removed sort's priority.
	    grid.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority > column.sort.priority) {
	        col.sort.priority -= 1;
	      }
	    });
	
	    // Remove sort
	    column.sort = {};
	  };
	
	  /**
	   * communicate to outside world that we are done with initial rendering
	   */
	  Grid.prototype.renderingComplete = function() {
	    if (angular.isFunction(this.options.onRegisterApi)) {
	      this.options.onRegisterApi(this.api);
	    }
	    this.api.core.raise.renderingComplete( this.api );
	  };
	
	  Grid.prototype.createRowHashMap = function createRowHashMap() {
	    var self = this;
	
	    var hashMap = new RowHashMap();
	    hashMap.grid = self;
	
	    return hashMap;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name refresh
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered grid on screen.
	   * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed.
	   */
	  Grid.prototype.refresh = function refresh(rowsAltered) {
	    var self = this;
	
	    var p1 = self.processRowsProcessors(self.rows).then(function (renderableRows) {
	      self.setVisibleRows(renderableRows);
	    }).catch(angular.noop);
	
	    var p2 = self.processColumnsProcessors(self.columns).then(function (renderableColumns) {
	      self.setVisibleColumns(renderableColumns);
	    }).catch(angular.noop);
	
	    return $q.all([p1, p2]).then(function () {
	      self.refreshCanvas(true);
	      self.redrawInPlace(rowsAltered);
	    }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshRows
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered rows on screen?  Note: not functional at present
	   * @returns {promise} promise that is resolved when render completes?
	   *
	   */
	  Grid.prototype.refreshRows = function refreshRows() {
	    var self = this;
	
	    return self.processRowsProcessors(self.rows)
	      .then(function (renderableRows) {
	        self.setVisibleRows(renderableRows);
	
	        self.redrawInPlace();
	
	        self.refreshCanvas( true );
	      }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshCanvas
	   * @methodOf ui.grid.class:Grid
	   * @description Builds all styles and recalculates much of the grid sizing
	   * @param {object} buildStyles optional parameter.  Use TBD
	   * @returns {promise} promise that is resolved when the canvas
	   * has been refreshed
	   *
	   */
	  Grid.prototype.refreshCanvas = function(buildStyles) {
	    var self = this;
	
	    // gridUtil.logDebug('refreshCanvas');
	
	    var p = $q.defer();
	
	    // Get all the header heights
	    var containerHeadersToRecalc = [];
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	
	        // Skip containers that have no canvasWidth set yet
	        if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	          continue;
	        }
	
	        if (container.header || container.headerCanvas) {
	          container.explicitHeaderHeight = container.explicitHeaderHeight || null;
	          container.explicitHeaderCanvasHeight = container.explicitHeaderCanvasHeight || null;
	
	          containerHeadersToRecalc.push(container);
	        }
	      }
	    }
	
	    // Build the styles without the explicit header heights
	    if (buildStyles) {
	      self.buildStyles();
	    }
	
	    /*
	     *
	     * Here we loop through the headers, measuring each element as well as any header "canvas" it has within it.
	     *
	     * If any header is less than the largest header height, it will be resized to that so that we don't have headers
	     * with different heights, which looks like a rendering problem
	     *
	     * We'll do the same thing with the header canvases, and give the header CELLS an explicit height if their canvas
	     * is smaller than the largest canvas height. That was header cells without extra controls like filtering don't
	     * appear shorter than other cells.
	     *
	     */
	    if (containerHeadersToRecalc.length > 0) {
	      // Putting in a timeout as it's not calculating after the grid element is rendered and filled out
	      $timeout(function() {
	        // var oldHeaderHeight = self.grid.headerHeight;
	        // self.grid.headerHeight = gridUtil.outerElementHeight(self.header);
	
	        var rebuildStyles = false;
	
	        // Get all the header heights
	        var maxHeaderHeight = 0;
	        var maxHeaderCanvasHeight = 0;
	        var i, container;
	        var getHeight = function(oldVal, newVal) {
	          if ( oldVal !== newVal) {
	            rebuildStyles = true;
	          }
	          return newVal;
	        };
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          // Skip containers that have no canvasWidth set yet
	          if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	            continue;
	          }
	
	          if (container.header) {
	            var headerHeight = container.headerHeight = getHeight(container.headerHeight, gridUtil.outerElementHeight(container.header));
	
	            // Get the "inner" header height, that is the height minus the top and bottom borders, if present. We'll use it to make sure all the headers have a consistent height
	            var topBorder = gridUtil.getBorderSize(container.header, 'top');
	            var bottomBorder = gridUtil.getBorderSize(container.header, 'bottom');
	            var innerHeaderHeight = parseInt(headerHeight - topBorder - bottomBorder, 10);
	
	            innerHeaderHeight  = innerHeaderHeight < 0 ? 0 : innerHeaderHeight;
	
	            container.innerHeaderHeight = innerHeaderHeight;
	
	            // If the header doesn't have an explicit height set, save the largest header height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderHeight && innerHeaderHeight > maxHeaderHeight) {
	              maxHeaderHeight = innerHeaderHeight;
	            }
	          }
	
	          if (container.headerCanvas) {
	            var headerCanvasHeight = container.headerCanvasHeight = getHeight(container.headerCanvasHeight, parseInt(gridUtil.outerElementHeight(container.headerCanvas), 10));
	
	
	            // If the header doesn't have an explicit canvas height, save the largest header canvas height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderCanvasHeight && headerCanvasHeight > maxHeaderCanvasHeight) {
	              maxHeaderCanvasHeight = headerCanvasHeight;
	            }
	          }
	        }
	
	        // Go through all the headers
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          /* If:
	              1. We have a max header height
	              2. This container has a header height defined
	              3. And either this container has an explicit header height set, OR its header height is less than the max
	
	              then:
	
	              Give this container's header an explicit height so it will line up with the tallest header
	          */
	          if (
	            maxHeaderHeight > 0 && typeof(container.headerHeight) !== 'undefined' && container.headerHeight !== null &&
	            (container.explicitHeaderHeight || container.headerHeight < maxHeaderHeight)
	          ) {
	            container.explicitHeaderHeight = getHeight(container.explicitHeaderHeight, maxHeaderHeight);
	          }
	
	          // Do the same as above except for the header canvas
	          if (
	            maxHeaderCanvasHeight > 0 && typeof(container.headerCanvasHeight) !== 'undefined' && container.headerCanvasHeight !== null &&
	            (container.explicitHeaderCanvasHeight || container.headerCanvasHeight < maxHeaderCanvasHeight)
	          ) {
	            container.explicitHeaderCanvasHeight = getHeight(container.explicitHeaderCanvasHeight, maxHeaderCanvasHeight);
	          }
	        }
	
	        // Rebuild styles if the header height has changed
	        //   The header height is used in body/viewport calculations and those are then used in other styles so we need it to be available
	        if (buildStyles && rebuildStyles) {
	          self.buildStyles();
	        }
	
	        p.resolve();
	      });
	    }
	    else {
	      // Timeout still needs to be here to trigger digest after styles have been rebuilt
	      $timeout(function() {
	        p.resolve();
	      });
	    }
	
	    return p.promise;
	  };
	
	  function getPrevScrollValue(rowsAdded, prevScrollVal) {
	    return rowsAdded || prevScrollVal > 0 ? prevScrollVal : null;
	  }
	
	  /**
	   * @ngdoc function
	   * @name redrawInPlace
	   * @methodOf ui.grid.class:Grid
	   * @description Redraw the rows and columns based on our current scroll position
	   * @param {boolean} [rowsAdded] Optional to indicate rows are added and the scroll percentage must be recalculated
	   *
	   */
	  Grid.prototype.redrawInPlace = function redrawInPlace(rowsAdded) {
	    // gridUtil.logDebug('redrawInPlace');
	
	    var self = this;
	
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i],
	        prevScrollTop = getPrevScrollValue(rowsAdded, container.prevScrollTop),
	        prevScrollLeft = getPrevScrollValue(rowsAdded, container.prevScrollLeft),
	        prevScrolltopPercentage = rowsAdded || prevScrollTop > 0 ? null : container.prevScrolltopPercentage,
	        prevScrollleftPercentage = rowsAdded || prevScrollLeft > 0 ? null : container.prevScrollleftPercentage;
	
	      // gridUtil.logDebug('redrawing container', i);
	
	      container.adjustRows(prevScrollTop, prevScrolltopPercentage);
	      container.adjustColumns(prevScrollLeft, prevScrollleftPercentage);
	    }
	  };
	
	    /**
	     * @ngdoc function
	     * @name hasLeftContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if leftContainer has columns
	     */
	    Grid.prototype.hasLeftContainerColumns = function () {
	      return this.hasLeftContainer() && this.renderContainers.left.renderedColumns.length > 0;
	    };
	
	    /**
	     * @ngdoc function
	     * @name hasRightContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if rightContainer has columns
	     */
	    Grid.prototype.hasRightContainerColumns = function () {
	      return this.hasRightContainer() && this.renderContainers.right.renderedColumns.length > 0;
	    };
	
	    // Turn the scroll position into a percentage and make it an argument for a scroll event
	    function getScrollPercentage(scrollPixels, scrollLength) {
	      var percentage = scrollPixels / scrollLength;
	
	      // if the percentage is greater than 1, set it to 1
	      return percentage <= 1 ? percentage : 1;
	    }
	
	    // Only returns the scroll Y position if the percentage is different from the previous
	    function getScrollY(scrollPixels, scrollLength, prevScrolltopPercentage) {
	      var scrollPercentage = getScrollPercentage(scrollPixels, scrollLength);
	
	      if (scrollPercentage !== prevScrolltopPercentage) {
	        return { percentage: getScrollPercentage(scrollPixels, scrollLength) };
	      }
	
	      return undefined;
	    }
	
	    // Only returns the scroll X position if the percentage is different from the previous
	    function getScrollX(horizScrollPixels, horizScrollLength, prevScrollleftPercentage) {
	      var horizPercentage = horizScrollPixels / horizScrollLength;
	      horizPercentage = (horizPercentage > 1) ? 1 : horizPercentage;
	
	      if (horizPercentage !== prevScrollleftPercentage) {
	        return { percentage: horizPercentage  };
	      }
	
	      return undefined;
	    }
	
	    /**
	     * @ngdoc method
	     * @methodOf  ui.grid.class:Grid
	     * @name scrollToIfNecessary
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridColumn} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     */
	    Grid.prototype.scrollToIfNecessary = function (gridRow, gridCol) {
	      var self = this;
	
	      var scrollEvent = new ScrollEvent(self, 'uiGrid.scrollToIfNecessary');
	
	      // Alias the visible row and column caches
	      var visRowCache = self.renderContainers.body.visibleRowCache;
	      var visColCache = self.renderContainers.body.visibleColumnCache;
	
	      /*-- Get the top, left, right, and bottom "scrolled" edges of the grid --*/
	
	      // The top boundary is the current Y scroll position
	      var topBound = self.renderContainers.body.prevScrollTop;
	
	      // Don't the let top boundary be less than 0
	      topBound = (topBound < 0) ? 0 : topBound;
	
	      // The left boundary is the current X scroll position
	      var leftBound = self.renderContainers.body.prevScrollLeft;
	
	      // The bottom boundary is the current Y scroll position, plus the height of the grid, but minus the header height.
	      //   Basically this is the viewport height added on to the scroll position
	      var bottomBound = self.renderContainers.body.prevScrollTop + self.gridHeight - self.renderContainers.body.headerHeight - self.footerHeight -  self.scrollbarHeight;
	
	      // If there's a horizontal scrollbar, remove its height from the bottom boundary, otherwise we'll be letting it obscure rows
	      // if (self.horizontalScrollbarHeight) {
	      //   bottomBound = bottomBound - self.horizontalScrollbarHeight;
	      // }
	
	      // The right position is the current X scroll position minus the grid width
	      var rightBound = self.renderContainers.body.prevScrollLeft + Math.ceil(self.renderContainers.body.getViewportWidth());
	
	      // If there's a vertical scrollbar, subtract it from the right boundary or we'll allow it to obscure cells
	      // if (self.verticalScrollbarWidth) {
	      //   rightBound = rightBound - self.verticalScrollbarWidth;
	      // }
	
	      // We were given a row to scroll to
	      if (gridRow !== null) {
	        // This is the index of the row we want to scroll to, within the list of rows that can be visible
	        var seekRowIndex = visRowCache.indexOf(gridRow);
	
	        // Total vertical scroll length of the grid
	        var scrollLength = (self.renderContainers.body.getCanvasHeight() - self.renderContainers.body.getViewportHeight());
	
	        // Add the height of the native horizontal scrollbar to the scroll length, if it's there. Otherwise it will mask over the final row
	        // if (self.horizontalScrollbarHeight && self.horizontalScrollbarHeight > 0) {
	        //   scrollLength = scrollLength + self.horizontalScrollbarHeight;
	        // }
	
	        // This is the minimum amount of pixels we need to scroll vertical in order to see this row.
	        var pixelsToSeeRow = (seekRowIndex * self.options.rowHeight);
	
	        // Don't let the pixels required to see the row be less than zero
	        pixelsToSeeRow = (pixelsToSeeRow < 0) ? 0 : pixelsToSeeRow;
	
	        var scrollPixels;
	
	        // If the scroll position we need to see the row is LESS than the top boundary, i.e. obscured above the top of the self...
	        if (pixelsToSeeRow < Math.floor(topBound)) {
	          // Get the different between the top boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          scrollPixels = self.renderContainers.body.prevScrollTop - (topBound - pixelsToSeeRow);
	
	          // Since scrollIfNecessary is called multiple times when enableCellEditOnFocus is true we need to make sure the scrollbarWidth and
	          // footerHeight is accounted for to not cause a loop.
	          if (gridCol && gridCol.colDef && gridCol.colDef.enableCellEditOnFocus) {
	            scrollPixels = scrollPixels - self.footerHeight - self.scrollbarHeight;
	          }
	
	          scrollEvent.y = getScrollY(scrollPixels, scrollLength, self.renderContainers.body.prevScrolltopPercentage);
	        }
	        // Otherwise if the scroll position we need to see the row is MORE than the bottom boundary, i.e. obscured below the bottom of the self...
	        else if (pixelsToSeeRow > Math.ceil(bottomBound)) {
	          // Get the different between the bottom boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          scrollPixels = pixelsToSeeRow - bottomBound + self.renderContainers.body.prevScrollTop;
	
	          // Scroll to full position plus the height of one row since scrollPixels points to the top pixel of the row
	          scrollEvent.y = getScrollY(scrollPixels + self.options.rowHeight, scrollLength, self.renderContainers.body.prevScrolltopPercentage);
	        }
	      }
	
	      // We were given a column to scroll to
	      if (gridCol !== null) {
	        // This is the index of the column we want to scroll to, within the list of columns that can be visible
	        var seekColumnIndex = visColCache.indexOf(gridCol);
	
	        // Total horizontal scroll length of the grid
	        var horizScrollLength = (self.renderContainers.body.getCanvasWidth() - self.renderContainers.body.getViewportWidth());
	
	        // This is the minimum amount of pixels we need to scroll horizontal in order to see this column
	        var columnLeftEdge = 0;
	        for (var i = 0; i < seekColumnIndex; i++) {
	          var col = visColCache[i];
	          columnLeftEdge += col.drawnWidth;
	        }
	        columnLeftEdge = (columnLeftEdge < 0) ? 0 : columnLeftEdge;
	
	        var columnRightEdge = columnLeftEdge + gridCol.drawnWidth;
	
	        // Don't let the pixels required to see the column be less than zero
	        columnRightEdge = (columnRightEdge < 0) ? 0 : columnRightEdge;
	
	        var horizScrollPixels;
	
	        // If the scroll position we need to see the column is LESS than the left boundary, i.e. obscured before the left of the self...
	        if (columnLeftEdge < leftBound) {
	          // Get the different between the left boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          horizScrollPixels = self.renderContainers.body.prevScrollLeft - (leftBound - columnLeftEdge);
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          scrollEvent.x = getScrollX(horizScrollPixels, horizScrollLength, self.renderContainers.body.prevScrollleftPercentage);
	        }
	        // Otherwise if the scroll position we need to see the column is MORE than the right boundary, i.e. obscured after the right of the self...
	        else if (columnRightEdge > rightBound) {
	          // Get the different between the right boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          horizScrollPixels = columnRightEdge - rightBound + self.renderContainers.body.prevScrollLeft;
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          scrollEvent.x = getScrollX(horizScrollPixels, horizScrollLength, self.renderContainers.body.prevScrollleftPercentage);
	        }
	      }
	
	      var deferred = $q.defer();
	
	      // If we need to scroll on either the x or y axes, fire a scroll event
	      if (scrollEvent.y || scrollEvent.x) {
	        scrollEvent.withDelay = false;
	        self.scrollContainers('',scrollEvent);
	        var dereg = self.api.core.on.scrollEnd(null,function() {
	          deferred.resolve(scrollEvent);
	          dereg();
	        });
	      }
	      else {
	        deferred.resolve();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.class:Grid
	     * @name scrollTo
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    Grid.prototype.scrollTo = function (rowEntity, colDef) {
	      var gridRow = null, gridCol = null;
	
	      if (rowEntity !== null && typeof(rowEntity) !== 'undefined' ) {
	        gridRow = this.getRow(rowEntity);
	      }
	
	      if (colDef !== null && typeof(colDef) !== 'undefined' ) {
	        gridCol = this.getColumn(colDef.name ? colDef.name : colDef.field);
	      }
	      return this.scrollToIfNecessary(gridRow, gridCol);
	    };
	
	  /**
	   * @ngdoc function
	   * @name clearAllFilters
	   * @methodOf ui.grid.class:Grid
	   * @description Clears all filters and optionally refreshes the visible rows.
	   * @param {object} refreshRows Defaults to true.
	   * @param {object} clearConditions Defaults to false.
	   * @param {object} clearFlags Defaults to false.
	   * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	   */
	  Grid.prototype.clearAllFilters = function clearAllFilters(refreshRows, clearConditions, clearFlags) {
	    // Default `refreshRows` to true because it will be the most commonly desired behaviour.
	    if (refreshRows === undefined) {
	      refreshRows = true;
	    }
	    if (clearConditions === undefined) {
	      clearConditions = false;
	    }
	    if (clearFlags === undefined) {
	      clearFlags = false;
	    }
	
	    this.columns.forEach(function(column) {
	      column.filters.forEach(function(filter) {
	        filter.term = undefined;
	
	        if (clearConditions) {
	          filter.condition = undefined;
	        }
	
	        if (clearFlags) {
	          filter.flags = undefined;
	        }
	      });
	    });
	
	    if (refreshRows) {
	      return this.refreshRows();
	    }
	  };
	
	
	      // Blatantly stolen from Angular as it isn't exposed (yet? 2.0?)
	  function RowHashMap() {}
	
	  RowHashMap.prototype = {
	    /**
	     * Store key value pair
	     * @param key key to store can be any type
	     * @param value value to store can be any type
	     */
	    put: function(key, value) {
	      this[this.grid.options.rowIdentity(key)] = value;
	    },
	
	    /**
	     * @param key
	     * @returns {Object} the value for the key
	     */
	    get: function(key) {
	      return this[this.grid.options.rowIdentity(key)];
	    },
	
	    /**
	     * Remove the key/value pair
	     * @param key
	     */
	    remove: function(key) {
	      var value = this[key = this.grid.options.rowIdentity(key)];
	      delete this[key];
	      return value;
	    }
	  };
	
	  return Grid;
	}]);
	})();
	
	(function () {
	
	  angular.module('ui.grid')
	    .factory('GridApi', ['$q', '$rootScope', 'gridUtil', 'uiGridConstants', 'GridRow',
	      function ($q, $rootScope, gridUtil, uiGridConstants, GridRow) {
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:GridApi
	         * @description GridApi provides the ability to register public methods events inside the grid and allow
	         * for other components to use the api via featureName.raise.methodName and featureName.on.eventName(function(args) {}.
	         * <br/>
	         * To listen to events, you must add a callback to gridOptions.onRegisterApi
	         * <pre>
	         *   $scope.gridOptions.onRegisterApi = function(gridApi) {
	         *      gridApi.cellNav.on.navigate($scope,function(newRowCol, oldRowCol) {
	         *          $log.log('navigation event');
	         *      });
	         *   };
	         * </pre>
	         * @param {object} grid grid that owns api
	         */
	        var GridApi = function GridApi(grid) {
	          this.grid = grid;
	          this.listeners = [];
	
	          /**
	           * @ngdoc function
	           * @name renderingComplete
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Rendering is complete, called at the same
	           * time as `onRegisterApi`, but provides a way to obtain
	           * that same event within features without stopping end
	           * users from getting at the onRegisterApi method.
	           *
	           * Included in gridApi so that it's always there - otherwise
	           * there is still a timing problem with when a feature can
	           * call this.
	           *
	           * @param {GridApi} gridApi the grid api, as normally
	           * returned in the onRegisterApi method
	           *
	           * @example
	           * <pre>
	           *      gridApi.core.on.renderingComplete( grid );
	           * </pre>
	           */
	          this.registerEvent( 'core', 'renderingComplete' );
	
	          /**
	           * @ngdoc event
	           * @name filterChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised after the filter is changed.  The nature
	           * of the watch expression doesn't allow notification of what changed,
	           * so the receiver of this event will need to re-extract the filter
	           * conditions from the columns.
	           *
	           */
	          this.registerEvent( 'core', 'filterChanged' );
	
	          /**
	           * @ngdoc function
	           * @name setRowInvisible
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Sets an override on the row to make it always invisible,
	           * which will override any filtering or other visibility calculations.
	           * If the row is currently visible then sets it to invisible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * @param {GridRow} row the row we want to make invisible
	           */
	          this.registerMethod( 'core', 'setRowInvisible', GridRow.prototype.setRowInvisible );
	
	          /**
	           * @ngdoc function
	           * @name clearRowInvisible
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Clears any override on visibility for the row so that it returns to
	           * using normal filtering and other visibility calculations.
	           * If the row is currently invisible then sets it to visible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * TODO: if a filter is active then we can't just set it to visible?
	           * @param {GridRow} row the row we want to make visible
	           */
	          this.registerMethod( 'core', 'clearRowInvisible', GridRow.prototype.clearRowInvisible );
	
	          /**
	           * @ngdoc function
	           * @name getVisibleRows
	           * @methodOf  ui.grid.api:PublicApi
	           * @description Returns all visible rows
	           * @param {Grid} grid the grid you want to get visible rows from
	           * @returns {array} an array of gridRow
	           */
	          this.registerMethod( 'core', 'getVisibleRows', this.grid.getVisibleRows );
	
	          /**
	           * @ngdoc event
	           * @name rowsVisibleChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised after the rows that are visible
	           * change.  The filtering is zero-based, so it isn't possible
	           * to say which rows changed (unlike in the selection feature).
	           * We can plausibly know which row was changed when setRowInvisible
	           * is called, but in that situation the user already knows which row
	           * they changed.  When a filter runs we don't know what changed,
	           * and that is the one that would have been useful.
	           *
	           */
	          this.registerEvent( 'core', 'rowsVisibleChanged' );
	
	          /**
	           * @ngdoc event
	           * @name rowsRendered
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised after the cache of visible rows is changed.
	           */
	          this.registerEvent( 'core', 'rowsRendered' );
	
	
	          /**
	           * @ngdoc event
	           * @name scrollBegin
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when scroll begins.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollBegin' );
	
	          /**
	           * @ngdoc event
	           * @name scrollEnd
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when scroll has finished.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollEnd' );
	
	          /**
	           * @ngdoc event
	           * @name canvasHeightChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when the canvas height has changed
	           * <br/>
	           * arguments: oldHeight, newHeight
	           */
	          this.registerEvent( 'core', 'canvasHeightChanged');
	
	          /**
	           * @ngdoc event
	           * @name gridDimensionChanged
	           * @eventOf  ui.grid.api:PublicApi
	           * @description  is raised when the grid dimensions have changed (when autoResize is on)
	           * <br/>
	           * arguments: oldGridHeight, oldGridWidth, newGridHeight, newGridWidth
	           */
	          this.registerEvent( 'core', 'gridDimensionChanged');
	        };
	
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:suppressEvents
	         * @methodOf ui.grid.class:GridApi
	         * @description Used to execute a function while disabling the specified event listeners.
	         * Disables the listenerFunctions, executes the callbackFn, and then enables
	         * the listenerFunctions again
	         * @param {object} listenerFuncs listenerFunc or array of listenerFuncs to suppress. These must be the same
	         * functions that were used in the .on.eventName method
	         * @param {object} callBackFn function to execute
	         * @example
	         * <pre>
	         *    var navigate = function (newRowCol, oldRowCol) {
	         *       //do something on navigate
	         *    }
	         *
	         *    gridApi.cellNav.on.navigate(scope,navigate);
	         *
	         *
	         *    //call the scrollTo event and suppress our navigate listener
	         *    //scrollTo will still raise the event for other listeners
	         *    gridApi.suppressEvents(navigate, function() {
	         *       gridApi.cellNav.scrollTo(aRow, aCol);
	         *    });
	         *
	         * </pre>
	         */
	        GridApi.prototype.suppressEvents = function (listenerFuncs, callBackFn) {
	          var self = this,
	            listeners = angular.isArray(listenerFuncs) ? listenerFuncs : [listenerFuncs];
	
	          // find all registered listeners
	          var foundListeners = self.listeners.filter(function(listener) {
	            return listeners.some(function(l) {
	              return listener.handler === l;
	            });
	          });
	
	          // deregister all the listeners
	          foundListeners.forEach(function(l) {
	            l.dereg();
	          });
	
	          callBackFn();
	
	          // reregister all the listeners
	          foundListeners.forEach(function(l) {
	              l.dereg = registerEventWithAngular(l.eventId, l.handler, self.grid, l._this);
	          });
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerEvent
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature.  The event will get a
	         * .raise and .on prepended to it
	         * <br>
	         * .raise.eventName() - takes no arguments
	         * <br/>
	         * <br/>
	         * .on.eventName(scope, callBackFn, _this)
	         * <br/>
	         * scope - a scope reference to add a deregister call to the scopes .$on('destroy').  Scope is optional and can be a null value,
	         * but in this case you must deregister it yourself via the returned deregister function
	         * <br/>
	         * callBackFn - The function to call
	         * <br/>
	         * _this - optional this context variable for callbackFn. If omitted, grid.api will be used for the context
	         * <br/>
	         * .on.eventName returns a dereg funtion that will remove the listener.  It's not necessary to use it as the listener
	         * will be removed when the scope is destroyed.
	         * @param {string} featureName name of the feature that raises the event
	         * @param {string} eventName  name of the event
	         */
	        GridApi.prototype.registerEvent = function (featureName, eventName) {
	          var self = this;
	          if (!self[featureName]) {
	            self[featureName] = {};
	          }
	
	          var feature = self[featureName];
	          if (!feature.on) {
	            feature.on = {};
	            feature.raise = {};
	          }
	
	          var eventId = self.grid.id + featureName + eventName;
	
	          // gridUtil.logDebug('Creating raise event method ' + featureName + '.raise.' + eventName);
	          feature.raise[eventName] = function () {
	            $rootScope.$emit.apply($rootScope, [eventId].concat(Array.prototype.slice.call(arguments)));
	          };
	
	          // gridUtil.logDebug('Creating on event method ' + featureName + '.on.' + eventName);
	          feature.on[eventName] = function (scope, handler, _this) {
	            if ( scope !== null && typeof(scope.$on) === 'undefined' ) {
	              gridUtil.logError('asked to listen on ' + featureName + '.on.' + eventName + ' but scope wasn\'t passed in the input parameters.  It is legitimate to pass null, but you\'ve passed something else, so you probably forgot to provide scope rather than did it deliberately, not registering');
	              return;
	            }
	            var deregAngularOn = registerEventWithAngular(eventId, handler, self.grid, _this);
	
	            // track our listener so we can turn off and on
	            var listener = {handler: handler, dereg: deregAngularOn, eventId: eventId, scope: scope, _this: _this};
	
	            self.listeners.push(listener);
	
	            var removeListener = function() {
	              listener.dereg();
	              var index = self.listeners.indexOf(listener);
	              self.listeners.splice(index,1);
	            };
	
	            // destroy tracking when scope is destroyed
	            if (scope) {
	              scope.$on('$destroy', function() {
	                removeListener();
	              });
	            }
	
	            return removeListener;
	          };
	        };
	
	        function registerEventWithAngular(eventId, handler, grid, _this) {
	          return $rootScope.$on(eventId, function (event) {
	            var args = Array.prototype.slice.call(arguments);
	            args.splice(0, 1); // remove evt argument
	            handler.apply(_this ? _this : grid.api, args);
	          });
	        }
	
	        /**
	         * @ngdoc function
	         * @name registerEventsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and events from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <pre>
	         * {featureName:
	         *        {
	         *          eventNameOne:function(args) {},
	         *          eventNameTwo:function(args) {}
	         *        }
	         *  }
	         * </pre>
	         * @param {object} eventObjectMap map of feature/event names
	         */
	        GridApi.prototype.registerEventsFromObject = function (eventObjectMap) {
	          var self = this,
	            features = [];
	
	          angular.forEach(eventObjectMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, events: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.events.push(propName);
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.events.forEach(function (event) {
	              self.registerEvent(feature.name, event);
	            });
	          });
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethod
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature
	         * @param {string} featureName name of the feature
	         * @param {string} methodName  name of the method
	         * @param {object} callBackFn function to execute
	         * @param {object} _this binds callBackFn 'this' to _this.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethod = function (featureName, methodName, callBackFn, _this) {
	          if (!this[featureName]) {
	            this[featureName] = {};
	          }
	
	          var feature = this[featureName];
	
	          feature[methodName] = gridUtil.createBoundedWrapper(_this || this.grid, callBackFn);
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethodsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and methods from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <br>
	         * {featureName:
	         *        {
	         *          methodNameOne:function(args) {},
	         *          methodNameTwo:function(args) {}
	         *        }
	         * @param {object} methodMap map of feature/event names
	         * @param {object} _this binds this to _this for all functions.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethodsFromObject = function (methodMap, _this) {
	          var self = this;
	          var features = [];
	          angular.forEach(methodMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, methods: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.methods.push({name: propName, fn: prop});
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.methods.forEach(function (method) {
	              self.registerMethod(feature.name, method.name, method.fn, _this);
	            });
	          });
	
	        };
	
	        return GridApi;
	      }]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.factory('GridColumn', ['gridUtil', 'uiGridConstants', 'i18nService', function(gridUtil, uiGridConstants, i18nService) {
	
	  /**
	   * ******************************************************************************************
	   * PaulL1: Ugly hack here in documentation.  These properties are clearly properties of GridColumn,
	   * and need to be noted as such for those extending and building ui-grid itself.
	   * However, from an end-developer perspective, they interact with all these through columnDefs,
	   * and they really need to be documented there.  I feel like they're relatively static, and
	   * I can't find an elegant way for ngDoc to reference to both....so I've duplicated each
	   * comment block.  Ugh.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridColumn
	   * @description (mandatory) Each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present.
	   *
	   * Important - This must be unique to each column on a web page since it can
	   * be used as a key for retrieving information such as custom sort algorithms.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description (mandatory) Each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present.
	   *
	   * Important - This must be unique to each column on a web page since it can
	   * be used as a key for retrieving information such as custom sort algorithms.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Column name that will be shown in the header. If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Column name that will be shown in the header. If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridColumn
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.
	   * See the angular docs on binding expressions.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.    * See the angular docs on binding expressions.    *
	   */
	
	  /**
	   * @ngdoc property
	   * @name filter
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filter on this column.
	   *
	   * Available built-in conditions and types are listed under {@link jui.grid.service:uiGridConstants#properties_filter uiGridOptions.filter}
	   * @example
	   * <pre>{ term: 'text', condition: uiGridConstants.filter.STARTS_WITH, placeholder: 'type to filter...', ariaLabel: 'Filter for text', flags: { caseSensitive: false }, type: uiGridConstants.filter.SELECT, [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ] }</pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name extraStyle
	   * @propertyOf ui.grid.class:GridColumn
	   * @description additional on this column.
	   * @example
	   * <pre>{extraStyle: {display: 'table-cell'}}</pre>
	   *
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridColumn
	   * @description Represents the viewModel for each column.  Any state or methods needed for a Grid Column
	   * are defined on this prototype
	   * @param {ColumnDef} colDef the column def to associate with this column
	   * @param {number} uid the unique and immutable uid we'd like to allocate to this column
	   * @param {Grid} grid the grid we'd like to create this column in
	   */
	  function GridColumn(colDef, uid, grid) {
	    var self = this;
	
	    self.grid = grid;
	    self.uid = uid;
	
	    self.updateColumnDef(colDef, true);
	
	    self.aggregationValue = undefined;
	
	    // The footer cell registers to listen for the rowsRendered event, and calls this.  Needed to be
	    // in something with a scope so that the dereg would get called
	    self.updateAggregationValue = function() {
	
	     // gridUtil.logDebug('getAggregationValue for Column ' + self.colDef.name);
	
	      /**
	       * @ngdoc property
	       * @name aggregationType
	       * @propertyOf ui.grid.class:GridOptions.columnDef
	       * @description The aggregation that you'd like to show in the columnFooter for this
	       * column.  Valid values are in
	       * {@link ui.grid.service:uiGridConstants#properties_aggregationTypes uiGridConstants.aggregationTypes},
	       * and currently include `uiGridConstants.aggregationTypes.count`,
	       * `uiGridConstants.aggregationTypes.sum`, `uiGridConstants.aggregationTypes.avg`, `uiGridConstants.aggregationTypes.min`,
	       * `uiGridConstants.aggregationTypes.max`.
	       *
	       * You can also provide a function as the aggregation type, in this case your function needs to accept the full
	       * set of visible rows, and return a value that should be shown
	       */
	      if (!self.aggregationType) {
	        self.aggregationValue = undefined;
	        return;
	      }
	
	      var result = 0;
	      var visibleRows = self.grid.getVisibleRows();
	
	      var cellValues = function() {
	        var values = [];
	        visibleRows.forEach(function (row) {
	          var cellValue = self.grid.getCellValue(row, self);
	          var cellNumber = Number(cellValue);
	          if (!isNaN(cellNumber)) {
	            values.push(cellNumber);
	          }
	        });
	        return values;
	      };
	
	      if (angular.isFunction(self.aggregationType)) {
	        self.aggregationValue = self.aggregationType(visibleRows, self);
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.count) {
	        self.aggregationValue = self.grid.getVisibleRowCount();
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.sum) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.avg) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        result = result / cellValues().length;
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.min) {
	        self.aggregationValue = Math.min.apply(null, cellValues());
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.max) {
	        self.aggregationValue = Math.max.apply(null, cellValues());
	      }
	      else {
	        self.aggregationValue = '\u00A0';
	      }
	    };
	
	//     var throttledUpdateAggregationValue = gridUtil.throttle(updateAggregationValue, self.grid.options.aggregationCalcThrottle, { trailing: true, context: self.name });
	
	    /**
	     * @ngdoc function
	     * @name getAggregationValue
	     * @methodOf ui.grid.class:GridColumn
	     * @description gets the aggregation value based on the aggregation type for this column.
	     * Debounced using scrollDebounce option setting
	     */
	    this.getAggregationValue =  function() {
	//      if (!self.grid.isScrollingVertically && !self.grid.isScrollingHorizontally) {
	//        throttledUpdateAggregationValue();
	//      }
	
	      return self.aggregationValue;
	    };
	  }
	
	  /**
	   * @ngdoc function
	   * @name hideColumn
	   * @methodOf ui.grid.class:GridColumn
	   * @description Hides the column by setting colDef.visible = false
	   */
	  GridColumn.prototype.hideColumn = function() {
	    this.colDef.visible = false;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name setPropertyOrDefault
	   * @description Sets a property on the column using the passed in columnDef, and
	   * setting the defaultValue if the value cannot be found on the colDef
	   * @param {GridColumn} colDef the column def to look in for the property value
	   * @param {string} propName the property name we'd like to set
	   * @param {object} defaultValue the value to use if the colDef doesn't provide the setting
	   */
	  GridColumn.prototype.setPropertyOrDefault = function (colDef, propName, defaultValue) {
	    var self = this;
	
	    // Use the column definition filter if we were passed it
	    if (typeof(colDef[propName]) !== 'undefined' && colDef[propName]) {
	      self[propName] = colDef[propName];
	    }
	    // Otherwise use our own if it's set
	    else if (typeof(self[propName]) !== 'undefined') {
	      self[propName] = self[propName];
	    }
	    // Default to empty object for the filter
	    else {
	      self[propName] = defaultValue ? defaultValue : {};
	    }
	  };
	
	
	
	  /**
	   * @ngdoc property
	   * @name width
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the column width.  Can be either
	   * a number or a percentage, or an * for auto.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', width: 100},
	   *                                          { field: 'field2', width: '20%'},
	   *                                          { field: 'field3', width: '*' }]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name minWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Sets the minimum column width.  Should be a number.
	   * Defaults to gridOptions.minimumColumnSize if minWidth is not provided.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', minWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name maxWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the maximum column width.  Should be a number.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', maxWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name visible
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets whether or not the column is visible
	   * </br>Default is true
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *     { field: 'field1', visible: true},
	   *     { field: 'field2', visible: false }
	   *   ]; </pre>
	   *
	   */
	
	 /**
	  * @ngdoc property
	  * @name sort
	  * @propertyOf ui.grid.class:GridOptions.columnDef
	  * @description An object of sort information, attributes are:
	  *
	  * - direction: values are {@link ui.grid.service:uiGridConstants#properties_ASC uiGridConstants.ASC}
	  *  or {@link ui.grid.service:uiGridConstants#properties_DESC uiGridConstants.DESC}
	  * - ignoreSort: if set to true this sort is ignored (used by tree to manipulate the sort functionality)
	  * - priority: says what order to sort the columns in (lower priority gets sorted first). Starts from 0.
	  * @example
	  * <pre>
	  *   $scope.gridOptions.columnDefs = [{
	  *     field: 'field1',
	  *     sort: {
	  *       direction: uiGridConstants.ASC,
	  *       ignoreSort: true,
	  *       priority: 0
	  *      }
	  *   }];
	  * </pre>
	  */
	
	
	  /**
	   * @ngdoc property
	   * @name sortingAlgorithm
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Algorithm to use for sorting this column. Takes 'a' and 'b' parameters
	   * like any normal sorting function with additional 'rowA', 'rowB', and 'direction' parameters
	   * that are the row objects and the current direction of the sort respectively.
	   *
	   */
	
	   /**
	    * @ngdoc property
	    * @name defaultSort
	    * @propertyOf ui.grid.class:GridOptions.columnDef
	    * @description An object of sort information, provides a hidden default ordering of the data
	    * when no user sorts are applied, or when a user-provided sort deems two rows to be equal.
	    *
	    * May be combined with a regular {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}
	    * to explicitly sort by that column by default.
	    *
	    * Shares the same object format as {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}.
	    *
	    * Note that a defaultSort can never take priority over an explicit sort.
	    * @example
	    * <pre>
	    *   $scope.gridOptions.columnDefs = [{
	    *     field: 'field1',
	    *     defaultSort: {
	    *       direction: uiGridConstants.ASC,
	    *       priority: 0
	    *      }
	    *   }];
	    * </pre>
	    */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Specify multiple filter fields.
	   * @example
	   * <pre>$scope.gridOptions.columnDefs = [
	   *   {
	   *     field: 'field1', filters: [
	   *       {
	   *         term: 'aa',
	   *         condition: uiGridConstants.filter.STARTS_WITH,
	   *         placeholder: 'starts with...',
	   *         ariaLabel: 'Filter for field1',
	   *         flags: { caseSensitive: false },
	   *         type: uiGridConstants.filter.SELECT,
	   *         selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *       },
	   *       {
	   *         condition: uiGridConstants.filter.ENDS_WITH,
	   *         placeholder: 'ends with...'
	   *       }
	   *     ]
	   *   }
	   * ]; </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filters for this column. Includes 'term' property bound to filter input elements.
	   * @example
	   * <pre>[
	   *   {
	   *     term: 'foo', // ngModel for <input>
	   *     condition: uiGridConstants.filter.STARTS_WITH,
	   *     placeholder: 'starts with...',
	   *     ariaLabel: 'Filter for foo',
	   *     flags: { caseSensitive: false },
	   *     type: uiGridConstants.filter.SELECT,
	   *     selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *   },
	   *   {
	   *     term: 'baz',
	   *     condition: uiGridConstants.filter.ENDS_WITH,
	   *     placeholder: 'ends with...'
	   *   }
	   * ] </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name menuItems
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description used to add menu items to a column.  Refer to the tutorial on this
	   * functionality.  A number of settings are supported:
	   *
	   * - title: controls the title that is displayed in the menu
	   * - icon: the icon shown alongside that title
	   * - action: the method to call when the menu is clicked
	   * - shown: a function to evaluate to determine whether or not to show the item
	   * - active: a function to evaluate to determine whether or not the item is currently selected
	   * - context: context to pass to the action function, available in this.context in your handler
	   * - leaveOpen: if set to true, the menu should stay open after the action, defaults to false
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *   { field: 'field1', menuItems: [
	   *     {
	   *       title: 'Outer Scope Alert',
	   *       icon: 'ui-grid-icon-info-circled',
	   *       action: function($event) {
	   *         this.context.blargh(); // $scope.blargh() would work too, this is just an example
	   *       },
	   *       shown: function() { return true; },
	   *       active: function() { return true; },
	   *       context: $scope
	   *     },
	   *     {
	   *       title: 'Grid ID',
	   *       action: function() {
	   *         alert('Grid ID: ' + this.grid.id);
	   *       }
	   *     }
	   *   ] }]; </pre>
	   *
	   */
	
	  // Use colDef.displayName as long as it's not undefined, otherwise default to the field name
	  function getDisplayName(colDef) {
	    return (colDef.displayName === undefined)
	      ? gridUtil.readableColumnName(colDef.name)
	      : colDef.displayName;
	  }
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name updateColumnDef
	   * @description Moves settings from the columnDef down onto the column,
	   * and sets properties as appropriate
	   * @param {GridColumn} colDef the column def to look in for the property value
	   * @param {boolean} isNew whether the column is being newly created, if not
	   * we're updating an existing column, and some items such as the sort shouldn't
	   * be copied down
	   */
	  GridColumn.prototype.updateColumnDef = function(colDef, isNew) {
	    var self = this;
	
	    self.colDef = colDef;
	
	    if (colDef.name === undefined) {
	      throw new Error('colDef.name is required for column at index ' + self.grid.options.columnDefs.indexOf(colDef));
	    }
	
	    self.displayName = getDisplayName(colDef);
	
	    if (!angular.isNumber(self.width) || !self.hasCustomWidth || colDef.allowCustomWidthOverride) {
	      var colDefWidth = colDef.width;
	      var parseErrorMsg = "Cannot parse column width '" + colDefWidth + "' for column named '" + colDef.name + "'";
	      self.hasCustomWidth = false;
	
	      if (!angular.isString(colDefWidth) && !angular.isNumber(colDefWidth)) {
	        self.width = '*';
	      } else if (angular.isString(colDefWidth)) {
	        // See if it ends with a percent
	        if (gridUtil.endsWith(colDefWidth, '%')) {
	          // If so we should be able to parse the non-percent-sign part to a number
	          var percentStr = colDefWidth.replace(/%/g, '');
	          var percent = parseInt(percentStr, 10);
	          if (isNaN(percent)) {
	            throw new Error(parseErrorMsg);
	          }
	          self.width = colDefWidth;
	        }
	        // And see if it's a number string
	        else if (colDefWidth.match(/^(\d+)$/)) {
	          self.width = parseInt(colDefWidth.match(/^(\d+)$/)[1], 10);
	        }
	        // Otherwise it should be a string of asterisks
	        else if (colDefWidth.match(/^\*+$/)) {
	          self.width = colDefWidth;
	        }
	        // No idea, throw an Error
	        else {
	          throw new Error(parseErrorMsg);
	        }
	      }
	      // Is a number, use it as the width
	      else {
	        self.width = colDefWidth;
	      }
	    }
	
	    function isValidWidthValue(value) {
	      return angular.isString(value) || angular.isNumber(value);
	    }
	
	    ['minWidth', 'maxWidth'].forEach(function (name) {
	      var minOrMaxWidth = colDef[name];
	      var parseErrorMsg = "Cannot parse column " + name + " '" + minOrMaxWidth + "' for column named '" + colDef.name + "'";
	
	      // default minWidth to the minimumColumnSize
	      if (name === 'minWidth' && !isValidWidthValue(minOrMaxWidth) && angular.isDefined(self.grid.options.minimumColumnSize)) {
	        minOrMaxWidth = self.grid.options.minimumColumnSize;
	      }
	
	      if (!isValidWidthValue(minOrMaxWidth)) {
	        // Sets default minWidth and maxWidth values
	        self[name] = ((name === 'minWidth') ? 30 : 9000);
	      } else if (angular.isString(minOrMaxWidth)) {
	        if (minOrMaxWidth.match(/^(\d+)$/)) {
	          self[name] = parseInt(minOrMaxWidth.match(/^(\d+)$/)[1], 10);
	        } else {
	          throw new Error(parseErrorMsg);
	        }
	      } else {
	        self[name] = minOrMaxWidth;
	      }
	    });
	
	    // use field if it is defined; name if it is not
	    self.field = (colDef.field === undefined) ? colDef.name : colDef.field;
	
	    if ( typeof( self.field ) !== 'string' ) {
	      gridUtil.logError( 'Field is not a string, this is likely to break the code, Field is: ' + self.field );
	    }
	
	    self.name = colDef.name;
	    self.displayName = getDisplayName(colDef);
	
	    // self.originalIndex = index;
	
	    self.aggregationType = angular.isDefined(colDef.aggregationType) ? colDef.aggregationType : null;
	    self.footerCellTemplate = angular.isDefined(colDef.footerCellTemplate) ? colDef.footerCellTemplate : null;
	
	    /**
	     * @ngdoc property
	     * @name cellTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the cell.
	     * If set to false, no tooltip.  If true, the cell value is shown in the tooltip (useful
	     * if you have long values in your cells), if a function then that function is called
	     * passing in the row and the col `cellTooltip( row, col )`, and the return value is shown in the tooltip,
	     * if it is a static string then displays that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.cellTooltip) === 'undefined' || colDef.cellTooltip === false ) {
	      self.cellTooltip = false;
	    } else if ( colDef.cellTooltip === true ) {
	      self.cellTooltip = function(row, col) {
	        return self.grid.getCellValue( row, col );
	      };
	    } else if (typeof(colDef.cellTooltip) === 'function' ) {
	      self.cellTooltip = colDef.cellTooltip;
	    } else {
	      self.cellTooltip = function ( row, col ) {
	        return col.colDef.cellTooltip;
	      };
	    }
	
	    /**
	     * @ngdoc property
	     * @name headerTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the header cell.
	     * If set to false, no tooltip.  If true, the displayName is shown in the tooltip (useful
	     * if you have long values in your headers), if a function then that function is called
	     * passing in the row and the col `headerTooltip( col )`, and the return value is shown in the tooltip,
	     * if a static string then shows that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.headerTooltip) === 'undefined' || colDef.headerTooltip === false ) {
	      self.headerTooltip = false;
	    }
	    else if ( colDef.headerTooltip === true ) {
	      self.headerTooltip = function(col) {
	        return col.displayName;
	      };
	    }
	    else if (typeof(colDef.headerTooltip) === 'function' ) {
	      self.headerTooltip = colDef.headerTooltip;
	    }
	    else {
	      self.headerTooltip = function ( col ) {
	        return col.colDef.headerTooltip;
	      };
	    }
	
	
	    /**
	     * @ngdoc property
	     * @name footerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.footerCellClass = colDef.footerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.cellClass = colDef.cellClass;
	
	    /**
	     * @ngdoc property
	     * @name headerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.headerCellClass = colDef.headerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellFilter is a filter to apply to the content of each cell
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].cellFilter = 'date'
	     *
	     */
	    self.cellFilter = colDef.cellFilter ? colDef.cellFilter : "";
	
	    /**
	     * @ngdoc boolean
	     * @name sortCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * sorting the data. Note that when using this option uiGrid will assume that the displayed value is
	     * a string, and use the {@link ui.grid.class:RowSorter#sortAlpha sortAlpha} `sortFn`. It is possible
	     * to return a non-string value from an angularjs filter, in which case you should define a {@link ui.grid.class:GridOptions.columnDef#sortingAlgorithm sortingAlgorithm}
	     * for the column which hanldes the returned type. You may specify one of the `sortingAlgorithms`
	     * found in the {@link ui.grid.RowSorter rowSorter} service.
	     */
	    self.sortCellFiltered = colDef.sortCellFiltered ? true : false;
	
	    /**
	     * @ngdoc boolean
	     * @name filterCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * applying "search" `filters`.
	     */
	    self.filterCellFiltered = colDef.filterCellFiltered ? true : false;
	
	    /**
	     * @ngdoc property
	     * @name headerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellFilter is a filter to apply to the content of the column header
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].headerCellFilter = 'translate'
	     *
	     */
	    self.headerCellFilter = colDef.headerCellFilter ? colDef.headerCellFilter : "";
	
	    /**
	     * @ngdoc property
	     * @name footerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellFilter is a filter to apply to the content of the column footer
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].footerCellFilter = 'date'
	     *
	     */
	    self.footerCellFilter = colDef.footerCellFilter ? colDef.footerCellFilter : "";
	
	    self.visible = gridUtil.isNullOrUndefined(colDef.visible) || colDef.visible;
	
	    self.headerClass = colDef.headerClass;
	    // self.cursor = self.sortable ? 'pointer' : 'default';
	
	    // Turn on sorting by default
	    self.enableSorting = typeof(colDef.enableSorting) !== 'undefined' ? colDef.enableSorting : self.grid.options.enableSorting;
	    self.sortingAlgorithm = colDef.sortingAlgorithm;
	
	    /**
	     * @ngdoc property
	     * @name sortDirectionCycle
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) An array of {@link ui.grid.service:uiGridConstants#properties_ASC sort directions},
	     * specifying the order that they should cycle through as the user repeatedly clicks on the column heading.
	     * The default is `[null, uiGridConstants.ASC, uiGridConstants.DESC]`. Null
	     * refers to the unsorted state. This does not affect the initial sort
	     * direction; use the {@link ui.grid.class:GridOptions.columnDef#sort sort}
	     * property for that. If
	     * {@link ui.grid.class:GridOptions.columnDef#suppressRemoveSort suppressRemoveSort}
	     * is also set, the unsorted state will be skipped even if it is listed here.
	     * Each direction may not appear in the list more than once (e.g. `[ASC,
	     * DESC, DESC]` is not allowed), and the list may not be empty.
	     */
	    self.sortDirectionCycle = typeof(colDef.sortDirectionCycle) !== 'undefined' ?
	      colDef.sortDirectionCycle :
	      [null, uiGridConstants.ASC, uiGridConstants.DESC];
	
	    /**
	     * @ngdoc boolean
	     * @name suppressRemoveSort
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When enabled, this setting hides the removeSort option
	     * in the menu, and prevents users from manually removing the sort
	     */
	    if ( typeof(self.suppressRemoveSort) === 'undefined') {
	      self.suppressRemoveSort = typeof(colDef.suppressRemoveSort) !== 'undefined' ? colDef.suppressRemoveSort : false;
	    }
	
	    /**
	     * @ngdoc property
	     * @name enableFiltering
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description turn off filtering for an individual column, where
	     * you've turned on filtering for the overall grid
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].enableFiltering = false;
	     *
	     */
	    // Turn on filtering by default (it's disabled by default at the Grid level)
	    self.enableFiltering = typeof(colDef.enableFiltering) !== 'undefined' ? colDef.enableFiltering : true;
	
	    // Place the filter in the header cell by default
	    self.filterContainer = typeof(colDef.filterContainer) !== 'undefined' ? colDef.filterContainer : self.grid.options.filterContainer;
	
	    // self.menuItems = colDef.menuItems;
	    self.setPropertyOrDefault(colDef, 'menuItems', []);
	
	    // Use the column definition sort if we were passed it, but only if this is a newly added column
	    if ( isNew ) {
	      self.setPropertyOrDefault(colDef, 'sort');
	    }
	
	    // Use the column definition defaultSort always, unlike normal sort
	    self.setPropertyOrDefault(colDef, 'defaultSort');
	
	    // Set up default filters array for when one is not provided.
	    //   In other words, this (in column def):
	    //
	    //       filter: { term: 'something', flags: {}, condition: [CONDITION] }
	    //
	    //   is just shorthand for this:
	    //
	    //       filters: [{ term: 'something', flags: {}, condition: [CONDITION] }]
	    //
	    var defaultFilters = [];
	    if (colDef.filter) {
	      defaultFilters.push(colDef.filter);
	    }
	    else if ( colDef.filters ) {
	      defaultFilters = colDef.filters;
	    }
	    else {
	      // Add an empty filter definition object, which will
	      // translate to a guessed condition and no pre-populated
	      // value for the filter <input>.
	      defaultFilters.push({});
	    }
	
	    /**
	     * @ngdoc property
	     * @name filter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Specify a single filter field on this column.
	     *
	     * A filter consists of a condition, a term, and a placeholder:
	     *
	     * - condition defines how rows are chosen as matching the filter term. This can be set to
	     * one of the constants in {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter},
	     * or you can supply a custom filter function
	     * that gets passed the following arguments: [searchTerm, cellValue, row, column].
	     * - term: If set, the filter field will be pre-populated
	     * with this value.
	     * - placeholder: String that will be set to the `<input>.placeholder` attribute.
	     * - ariaLabel: String that will be set to the `<input>.ariaLabel` attribute. This is what is read as a label to screen reader users.
	     * - noTerm: set this to true if you have defined a custom function in condition, and
	     * your custom function doesn't require a term (so it can run even when the term is null)
	     * - rawTerm: set this to true if you have defined a custom function in condition, and
	     * your custom function requires access to the raw unmodified search term that was entered
	     * - flags: only flag currently available is `caseSensitive`, set to false if you don't want
	     * case sensitive matching
	     * - type: defaults to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.INPUT},
	     * which gives a text box.  If set to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.SELECT}
	     * then a select box will be shown with options selectOptions
	     * - selectOptions: options in the format `[ { value: 1, label: 'male' }]`.  No i18n filter is provided, you need
	     * to perform the i18n on the values before you provide them
	     * - disableCancelFilterButton: defaults to false. If set to true then the 'x' button that cancels/clears the filter
	     * will not be shown.
	     * @example
	     * <pre>$scope.gridOptions.columnDefs = [
	     *   {
	     *     field: 'field1',
	     *     filter: {
	     *       term: 'xx',
	     *       condition: uiGridConstants.filter.STARTS_WITH,
	     *       placeholder: 'starts with...',
	     *       ariaLabel: 'Starts with filter for field1',
	     *       flags: { caseSensitive: false },
	     *       type: uiGridConstants.filter.SELECT,
	     *       selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ],
	     *       disableCancelFilterButton: true
	     *     }
	     *   }
	     * ]; </pre>
	     *
	     */
	
	    // Only set filter if this is a newly added column, if we're updating an existing
	    // column then we don't want to put the default filter back if the user may have already
	    // removed it.
	    // However, we do want to keep the settings if they change, just not the term
	    if ( isNew ) {
	      self.setPropertyOrDefault(colDef, 'filter');
	      self.setPropertyOrDefault(colDef, 'extraStyle');
	      self.setPropertyOrDefault(colDef, 'filters', defaultFilters);
	    } else if ( self.filters.length === defaultFilters.length ) {
	      self.filters.forEach( function( filter, index ) {
	        if (typeof(defaultFilters[index].placeholder) !== 'undefined') {
	          filter.placeholder = defaultFilters[index].placeholder;
	        }
	        if (typeof(defaultFilters[index].ariaLabel) !== 'undefined') {
	          filter.ariaLabel = defaultFilters[index].ariaLabel;
	        }
	        if (typeof(defaultFilters[index].flags) !== 'undefined') {
	          filter.flags = defaultFilters[index].flags;
	        }
	        if (typeof(defaultFilters[index].type) !== 'undefined') {
	          filter.type = defaultFilters[index].type;
	        }
	        if (typeof(defaultFilters[index].selectOptions) !== 'undefined') {
	          filter.selectOptions = defaultFilters[index].selectOptions;
	        }
	      });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name unsort
	   * @methodOf ui.grid.class:GridColumn
	   * @description Removes column from the grid sorting
	   */
	  GridColumn.prototype.unsort = function () {
	    // Decrease priority for every col where priority is higher than the removed sort's priority.
	    var thisPriority = this.sort.priority;
	
	    this.grid.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority > thisPriority) {
	        col.sort.priority -= 1;
	      }
	    });
	
	    this.sort = {};
	    this.grid.api.core.raise.sortChanged( this.grid, this.grid.getColumnSorting() );
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColClass
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class name for the column
	   * @param {bool} prefixDot  if true, will return .className instead of className
	   */
	  GridColumn.prototype.getColClass = function (prefixDot) {
	    var cls = uiGridConstants.COL_CLASS_PREFIX + this.uid;
	
	    return prefixDot ? '.' + cls : cls;
	  };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedLeft
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the left render container
	     */
	    GridColumn.prototype.isPinnedLeft = function () {
	      return this.renderContainer === 'left';
	    };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedRight
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the right render container
	     */
	    GridColumn.prototype.isPinnedRight = function () {
	      return this.renderContainer === 'right';
	    };
	
	
	    /**
	   * @ngdoc function
	   * @name getColClassDefinition
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class definition for th column
	   */
	  GridColumn.prototype.getColClassDefinition = function () {
	    return ' .grid' + this.grid.id + ' ' + this.getColClass(true) + ' { min-width: ' + this.drawnWidth + 'px; max-width: ' + this.drawnWidth + 'px; }';
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRenderContainer
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the render container object that this column belongs to.
	   *
	   * Columns will be default be in the `body` render container if they aren't allocated to one specifically.
	   */
	  GridColumn.prototype.getRenderContainer = function getRenderContainer() {
	    var self = this;
	
	    var containerId = self.renderContainer;
	
	    if (containerId === null || containerId === '' || containerId === undefined) {
	      containerId = 'body';
	    }
	
	    return self.grid.renderContainers[containerId];
	  };
	
	  /**
	   * @ngdoc function
	   * @name showColumn
	   * @methodOf ui.grid.class:GridColumn
	   * @description Makes the column visible by setting colDef.visible = true
	   */
	  GridColumn.prototype.showColumn = function() {
	      this.colDef.visible = true;
	  };
	
	
	  /**
	   * @ngdoc property
	   * @name aggregationHideLabel
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description defaults to false, if set to true hides the label text
	   * in the aggregation footer, so only the value is displayed.
	   *
	   */
	  /**
	   * @ngdoc function
	   * @name getAggregationText
	   * @methodOf ui.grid.class:GridColumn
	   * @description Gets the aggregation label from colDef.aggregationLabel if
	   * specified or by using i18n, including deciding whether or not to display
	   * based on colDef.aggregationHideLabel.
	   *
	   * @param {string} label the i18n lookup value to use for the column label
	   *
	   */
	  GridColumn.prototype.getAggregationText = function () {
	    var self = this;
	    if ( self.colDef.aggregationHideLabel ) {
	      return '';
	    }
	    else if ( self.colDef.aggregationLabel ) {
	      return self.colDef.aggregationLabel;
	    }
	    else {
	      switch ( self.colDef.aggregationType ) {
	        case uiGridConstants.aggregationTypes.count:
	          return i18nService.getSafeText('aggregation.count');
	        case uiGridConstants.aggregationTypes.sum:
	          return i18nService.getSafeText('aggregation.sum');
	        case uiGridConstants.aggregationTypes.avg:
	          return i18nService.getSafeText('aggregation.avg');
	        case uiGridConstants.aggregationTypes.min:
	          return i18nService.getSafeText('aggregation.min');
	        case uiGridConstants.aggregationTypes.max:
	          return i18nService.getSafeText('aggregation.max');
	        default:
	          return '';
	      }
	    }
	  };
	
	  GridColumn.prototype.getCellTemplate = function () {
	    var self = this;
	
	    return self.cellTemplatePromise;
	  };
	
	  GridColumn.prototype.getCompiledElementFn = function () {
	    var self = this;
	
	    return self.compiledElementFnDefer.promise;
	  };
	
	  return GridColumn;
	}]);
	
	})();
	
	(function() {
	angular.module('ui.grid')
	.factory('GridOptions', ['gridUtil','uiGridConstants', function(gridUtil, uiGridConstants) {
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridOptions
	   * @description Default GridOptions class.  GridOptions are defined by the application developer and overlaid
	   * over this object.  Setting gridOptions within your controller is the most common method for an application
	   * developer to configure the behaviour of their ui-grid
	   *
	   * @example To define your gridOptions within your controller:
	   * <pre>$scope.gridOptions = {
	   *   data: $scope.myData,
	   *   columnDefs: [
	   *     { name: 'field1', displayName: 'pretty display name' },
	   *     { name: 'field2', visible: false }
	   *  ]
	   * };</pre>
	   *
	   * You can then use this within your html template, when you define your grid:
	   * <pre>&lt;div ui-grid="gridOptions"&gt;&lt;/div&gt;</pre>
	   *
	   * To provide default options for all of the grids within your application, use an angular
	   * decorator to modify the GridOptions factory.
	   * <pre>
	   * app.config(function($provide) {
	   *   $provide.decorator('GridOptions',function($delegate) {
	   *     var gridOptions;
	   *     gridOptions = angular.copy($delegate);
	   *     gridOptions.initialize = function(options) {
	   *       var initOptions;
	   *       initOptions = $delegate.initialize(options);
	   *       initOptions.enableColumnMenus = false;
	   *       return initOptions;
	   *     };
	   *     return gridOptions;
	   *   });
	   * });
	   * </pre>
	   */
	  return {
	    initialize: function( baseOptions ) {
	      /**
	       * @ngdoc function
	       * @name onRegisterApi
	       * @propertyOf ui.grid.class:GridOptions
	       * @description A callback that returns the gridApi once the grid is instantiated, which is
	       * then used to interact with the grid programatically.
	       *
	       * Note that the gridApi.core.renderingComplete event is identical to this
	       * callback, but has the advantage that it can be called from multiple places
	       * if needed
	       *
	       * @example
	       * <pre>
	       *   $scope.gridOptions.onRegisterApi = function ( gridApi ) {
	       *     $scope.gridApi = gridApi;
	       *     $scope.gridApi.selection.selectAllRows( $scope.gridApi.grid );
	       *   };
	       * </pre>
	       *
	       */
	      baseOptions.onRegisterApi = baseOptions.onRegisterApi || angular.noop();
	
	      /**
	       * @ngdoc object
	       * @name data
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (mandatory) Array of data to be rendered into the grid, providing the data source or data binding for
	       * the grid.
	       *
	       * Most commonly the data is an array of objects, where each object has a number of attributes.
	       * Each attribute automatically becomes a column in your grid.  This array could, for example, be sourced from
	       * an angularJS $resource query request.  The array can also contain complex objects, refer the binding tutorial
	       * for examples of that.
	       *
	       * The most flexible usage is to set your data on $scope:
	       *
	       * `$scope.data = data;`
	       *
	       * And then direct the grid to resolve whatever is in $scope.data:
	       *
	       * `$scope.gridOptions.data = 'data';`
	       *
	       * This is the most flexible approach as it allows you to replace $scope.data whenever you feel like it without
	       * getting pointer issues.
	       *
	       * Alternatively you can directly set the data array:
	       *
	       * `$scope.gridOptions.data = [ ];`
	       * or
	       *
	       * `$http.get('/data/100.json')
	       * .success(function(data) {
	       *   $scope.myData = data;
	       *   $scope.gridOptions.data = $scope.myData;
	       *  });`
	       *
	       * Where you do this, you need to take care in updating the data - you can't just update `$scope.myData` to some other
	       * array, you need to update $scope.gridOptions.data to point to that new array as well.
	       *
	       */
	      baseOptions.data = baseOptions.data || [];
	
	      /**
	       * @ngdoc array
	       * @name columnDefs
	       * @propertyOf  ui.grid.class:GridOptions
	       * @description Array of columnDef objects.  Only required property is name.
	       * The individual options available in columnDefs are documented in the
	       * {@link ui.grid.class:GridOptions.columnDef columnDef} section
	       * </br>_field property can be used in place of name for backwards compatibility with 2.x_
	       *  @example
	       *
	       * <pre>var columnDefs = [{name: 'field1'}, {name: 'field2'}];</pre>
	       *
	       */
	      baseOptions.columnDefs = baseOptions.columnDefs || [];
	
	      /**
	       * @ngdoc object
	       * @name ui.grid.class:GridOptions.columnDef
	       * @description Definition / configuration of an individual column, which would typically be
	       * one of many column definitions within the gridOptions.columnDefs array
	       * @example
	       * <pre>{name: 'field1', field: 'field1', filter: { term: 'xxx' }}</pre>
	       *
	       */
	
	      /**
	       * @ngdoc object
	       * @name enableGridMenu
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Takes a boolean that adds a settings icon in the top right of the grid, which floats above
	       * the column header, when true. The menu by default gives access to show/hide columns, but can be
	       * customised to show additional actions.
	       *
	       * See the {@link #!/tutorial/121_grid_menu Grid Menu tutorial} for more detailed information.
	       */
	
	      /**
	       * @ngdoc array
	       * @name excludeProperties
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Array of property names in data to ignore when auto-generating column names.  Provides the
	       * inverse of columnDefs - columnDefs is a list of columns to include, excludeProperties is a list of columns
	       * to exclude.
	       *
	       * If columnDefs is defined, this will be ignored.
	       *
	       * Defaults to ['$$hashKey']
	       */
	
	      baseOptions.excludeProperties = baseOptions.excludeProperties || ['$$hashKey'];
	
	      /**
	       * @ngdoc boolean
	       * @name enableRowHashing
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting allows uiGrid to add
	       * `$$hashKey`-type properties (similar to Angular) to elements in the `data` array. This allows
	       * the grid to maintain state while vastly speeding up the process of altering `data` by adding/moving/removing rows.
	       *
	       * Note that this DOES add properties to your data that you may not want, but they are stripped out when using `angular.toJson()`. IF
	       * you do not want this at all you can disable this setting but you will take a performance hit if you are using large numbers of rows
	       * and are altering the data set often.
	       */
	      baseOptions.enableRowHashing = baseOptions.enableRowHashing !== false;
	
	      /**
	       * @ngdoc function
	       * @name rowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function is used to get and, if necessary, set the value uniquely identifying this row (i.e. if an identity is not present it will set one).
	       *
	       * By default it returns the `$$hashKey` property if it exists. If it doesn't it uses gridUtil.nextUid() to generate one
	       */
	      baseOptions.rowIdentity = baseOptions.rowIdentity || function rowIdentity(row) {
	        return gridUtil.hashKey(row);
	      };
	
	      /**
	       * @ngdoc function
	       * @name getRowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function returns the identity value uniquely identifying this row, if one is not present it does not set it.
	       *
	       * By default it returns the `$$hashKey` property but can be overridden to use any property or set of properties you want.
	       */
	      baseOptions.getRowIdentity = baseOptions.getRowIdentity || function getRowIdentity(row) {
	        return row.$$hashKey;
	      };
	
	      /**
	       * @ngdoc property
	       * @name flatEntityAccess
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Set to true if your columns are all related directly to fields in a flat object structure - i.e.
	       * each of your columns associate directly with a property on each of the entities in your data array.
	       *
	       * In that situation we can avoid all the logic associated with complex binding to functions or to properties of sub-objects,
	       * which can provide a significant speed improvement with large data sets when filtering or sorting.
	       *
	       * By default false
	       */
	      baseOptions.flatEntityAccess = baseOptions.flatEntityAccess === true;
	
	      /**
	       * @ngdoc property
	       * @name showHeader
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When set to false, this setting will replace the
	       * standard header template with '<div></div>', resulting in no header being shown.
	       */
	      baseOptions.showHeader = typeof(baseOptions.showHeader) !== "undefined" ? baseOptions.showHeader : true;
	
	      /**
	       * @ngdoc property
	       * @name headerRowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the header in pixels, defaults to 30.
	       * Although, we recommend that you alter header height with CSS rather than using this option:
	       *
	       * <pre>
	       *     .grid .ui-grid-header-cell {
	       *         height: 60px;
	       *     }
	       * </pre>
	       **/
	      if (!baseOptions.showHeader) {
	        baseOptions.headerRowHeight = 0;
	      }
	      else {
	        baseOptions.headerRowHeight = typeof(baseOptions.headerRowHeight) !== "undefined" ? baseOptions.headerRowHeight : 30;
	      }
	
	      /**
	       * @ngdoc property
	       * @name rowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the row in pixels,  Can be passed as integer or string. defaults to 30.
	       *
	       */
	
	      if (typeof baseOptions.rowHeight === "string") {
	        baseOptions.rowHeight = parseInt(baseOptions.rowHeight) || 30;
	      }
	
	      else {
	        baseOptions.rowHeight = baseOptions.rowHeight || 30;
	      }
	
	      /**
	       * @ngdoc integer
	       * @name minRowsToShow
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Minimum number of rows to show when the grid doesn't have a defined height. Defaults to "10".
	       */
	      baseOptions.minRowsToShow = typeof(baseOptions.minRowsToShow) !== "undefined" ? baseOptions.minRowsToShow : 10;
	
	      /**
	       * @ngdoc property
	       * @name showGridFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the footer, defaults to false
	       * The footer display Total Rows and Visible Rows (filtered rows)
	       */
	      baseOptions.showGridFooter = baseOptions.showGridFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name showColumnFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the column footer, defaults to false
	       * The column footer displays column aggregates
	       */
	      baseOptions.showColumnFooter = baseOptions.showColumnFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name columnFooterHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the footer rows (column footer and grid footer) in pixels
	       *
	       */
	      baseOptions.columnFooterHeight = typeof(baseOptions.columnFooterHeight) !== "undefined" ? baseOptions.columnFooterHeight : 30;
	      baseOptions.gridFooterHeight = typeof(baseOptions.gridFooterHeight) !== "undefined" ? baseOptions.gridFooterHeight : 30;
	
	      baseOptions.columnWidth = typeof(baseOptions.columnWidth) !== "undefined" ? baseOptions.columnWidth : 50;
	
	      /**
	       * @ngdoc property
	       * @name maxVisibleColumnCount
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 200
	       *
	       */
	      baseOptions.maxVisibleColumnCount = typeof(baseOptions.maxVisibleColumnCount) !== "undefined" ? baseOptions.maxVisibleColumnCount : 200;
	
	      /**
	       * @ngdoc property
	       * @name virtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of data elements goes over this number, defaults to 20
	       */
	      baseOptions.virtualizationThreshold = typeof(baseOptions.virtualizationThreshold) !== "undefined" ? baseOptions.virtualizationThreshold : 20;
	
	      /**
	       * @ngdoc property
	       * @name columnVirtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of columns goes over this number, defaults to 10
	       */
	      baseOptions.columnVirtualizationThreshold = typeof(baseOptions.columnVirtualizationThreshold) !== "undefined" ? baseOptions.columnVirtualizationThreshold : 10;
	
	      /**
	       * @ngdoc property
	       * @name excessRows
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra rows to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessRows = typeof(baseOptions.excessRows) !== "undefined" ? baseOptions.excessRows : 4;
	
	      /**
	       * @ngdoc property
	       * @name scrollThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Throttles the grid scrolling by the amount of rows set, which helps with smoothness of scrolling.
	       * Defaults to 4.
	       */
	      baseOptions.scrollThreshold = typeof(baseOptions.scrollThreshold) !== "undefined" ? baseOptions.scrollThreshold : 4;
	
	      /**
	       * @ngdoc property
	       * @name excessColumns
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra columns to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessColumns = typeof(baseOptions.excessColumns) !== "undefined" ? baseOptions.excessColumns : 4;
	
	      /**
	       * @ngdoc property
	       * @name aggregationCalcThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle aggregation calcuations, defaults to 500ms
	       */
	      baseOptions.aggregationCalcThrottle = typeof(baseOptions.aggregationCalcThrottle) !== "undefined" ? baseOptions.aggregationCalcThrottle : 500;
	
	      /**
	       * @ngdoc property
	       * @name wheelScrollThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle scroll events to, defaults to 70ms
	       */
	      baseOptions.wheelScrollThrottle = typeof(baseOptions.wheelScrollThrottle) !== "undefined" ? baseOptions.wheelScrollThrottle : 70;
	
	
	      /**
	       * @ngdoc property
	       * @name scrollDebounce
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to debounce scroll events, defaults to 300ms
	       */
	      baseOptions.scrollDebounce = typeof(baseOptions.scrollDebounce) !== "undefined" ? baseOptions.scrollDebounce : 300;
	
	      /**
	       * @ngdoc boolean
	       * @name enableSorting
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting adds sort
	       * widgets to the column headers, allowing sorting of the data for the entire grid.
	       * Sorting can then be disabled / enabled on individual columns using the columnDefs,
	       * if it set, it will override GridOptions enableSorting setting.
	       */
	      baseOptions.enableSorting = baseOptions.enableSorting !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableFiltering
	       * @propertyOf ui.grid.class:GridOptions
	       * @description False by default. When enabled, this setting adds filter
	       * boxes to each column header, allowing filtering within the column for the entire grid.
	       * Filtering can then be disabled on individual columns using the columnDefs.
	       */
	      baseOptions.enableFiltering = baseOptions.enableFiltering === true;
	
	      /**
	       * @ngdoc string
	       * @name filterContainer
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Sets the parent element for the column filter. `headerCell` places
	       * it in the header cell. `columnMenu` places it in the column menu.
	       * Can be changed for individual columns using the columnDefs.
	       * Defaults to `headerCell`
	       */
	      baseOptions.filterContainer = typeof(baseOptions.filterContainer) !== "undefined" ? baseOptions.filterContainer : "headerCell";
	
	      /**
	       * @ngdoc boolean
	       * @name enableColumnMenus
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting displays a column
	       * menu within each column.
	       * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
	       *
	       * <pre>
	       *  .ui-grid-column-menu-button {
	       *    display: block;
	       *  }
	       * </pre>
	       */
	      baseOptions.enableColumnMenus = baseOptions.enableColumnMenus !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableVerticalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
	       * This settings controls the vertical scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
	       */
	      baseOptions.enableVerticalScrollbar = typeof(baseOptions.enableVerticalScrollbar) !== "undefined" ? baseOptions.enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableHorizontalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
	       * This settings controls the horizontal scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
	       */
	      baseOptions.enableHorizontalScrollbar = typeof(baseOptions.enableHorizontalScrollbar) !== "undefined" ? baseOptions.enableHorizontalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableMinHeightCheck
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, a newly initialized grid will check to see if it is tall enough to display
	       * at least one row of data.  If the grid is not tall enough, it will resize the DOM element to display minRowsToShow number
	       * of rows.
	       */
	       baseOptions.enableMinHeightCheck = baseOptions.enableMinHeightCheck !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name minimumColumnSize
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Sets the default minimum column width, in other words,
	       * it defines the default value for a column minWidth attribute if that is not otherwise specified.
	       * Should be a number. Defaults to 30 pixels.
	       */
	      baseOptions.minimumColumnSize = typeof(baseOptions.minimumColumnSize) !== "undefined" ? baseOptions.minimumColumnSize : 30;
	
	      /**
	       * @ngdoc function
	       * @name rowEquality
	       * @methodOf ui.grid.class:GridOptions
	       * @description By default, rows are compared using object equality.  This option can be overridden
	       * to compare on any data item property or function
	       * @param {object} entityA First Data Item to compare
	       * @param {object} entityB Second Data Item to compare
	       */
	      baseOptions.rowEquality = baseOptions.rowEquality || function(entityA, entityB) {
	        return entityA === entityB;
	      };
	
	      /**
	       * @ngdoc string
	       * @name headerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Null by default. When provided, this setting uses a custom header
	       * template, rather than the default template. Can be set to either the name of a template file:
	       * <pre>  $scope.gridOptions.headerTemplate = 'header_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.headerTemplate = '<div class="ui-grid-top-panel" style="text-align: center">I am a Custom Grid Header</div>'</pre>
	       * or the id of a precompiled template (TBD how to use this).
	       * </br>Refer to the custom header tutorial for more information.
	       * If you want no header at all, you can set to an empty div:
	       * <pre>  $scope.gridOptions.headerTemplate = '<div></div>';</pre>
	       *
	       * If you want to only have a static header, then you can set to static content.  If
	       * you want to tailor the existing column headers, then you should look at the
	       * current 'ui-grid-header.html' template in github as your starting point.
	       *
	       */
	      baseOptions.headerTemplate = baseOptions.headerTemplate || null;
	
	      /**
	       * @ngdoc string
	       * @name footerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-footer by default.  This footer shows the per-column
	       * aggregation totals.
	       * When provided, this setting uses a custom footer template. Can be set to either the name of a template file 'footer_template.html', inline html
	       * <pre>'<div class="ui-grid-bottom-panel" style="text-align: center">I am a Custom Grid Footer</div>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.footerTemplate = baseOptions.footerTemplate || 'ui-grid/ui-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name gridFooterTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-grid-footer by default. This template by default shows the
	       * total items at the bottom of the grid, and the selected items if selection is enabled.
	       */
	      baseOptions.gridFooterTemplate = baseOptions.gridFooterTemplate || 'ui-grid/ui-grid-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name rowTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/ui-grid-row' by default. When provided, this setting uses a
	       * custom row template.  Can be set to either the name of a template file:
	       * <pre> $scope.gridOptions.rowTemplate = 'row_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.rowTemplate = '<div style="background-color: aquamarine" ng-click="grid.appScope.fnOne(row)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';</pre>
	       * or the id of a precompiled template (TBD how to use this) can be provided.
	       * </br>Refer to the custom row template tutorial for more information.
	       */
	      baseOptions.rowTemplate = baseOptions.rowTemplate || 'ui-grid/ui-grid-row';
	
	      /**
	      * @ngdoc string
	      * @name gridMenuTemplate
	      * @propertyOf ui.grid.class:GridOptions
	      * @description 'ui-grid/uiGridMenu' by default. When provided, this setting uses a
	      * custom grid menu template.
	      */
	      baseOptions.gridMenuTemplate = baseOptions.gridMenuTemplate || 'ui-grid/uiGridMenu';
	
	            /**
	       * @ngdoc string
	       * @name menuButtonTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/ui-grid-menu-button' by default. When provided, this setting uses a custom grid menu button
	       * template. Can be set to either the name of a template file 'menuButton_template.html', inline html
	       * <pre>'<div class="ui-grid-menu-button" ng-click="customToggleMenu()"><div class="ui-grid-icon-container"><i class="ui-grid-icon=menu">&nbsp;</i></div></div><div ui-grid-menu menu-items="menuItems"></div>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.menuButtonTemplate = baseOptions.menuButtonTemplate || 'ui-grid/ui-grid-menu-button';
	
	      /**
	       * @ngdoc string
	       * @name menuItemTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/uiGridMenuItem' by default. When provided, this setting uses a custom grid menu item
	       * template. Can be set to either the name of a template file 'menuItem_template.html', inline html
	       * <pre>'<li class="ui-grid-menu-item"><label>{{name}}</label></li>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.menuItemTemplate = baseOptions.menuItemTemplate || 'ui-grid/uiGridMenuItem';
	
	      /**
	       * @ngdoc object
	       * @name appScopeProvider
	       * @propertyOf ui.grid.class:GridOptions
	       * @description by default, the parent scope of the ui-grid element will be assigned to grid.appScope
	       * this property allows you to assign any reference you want to grid.appScope
	       */
	      baseOptions.appScopeProvider = baseOptions.appScopeProvider || null;
	
	      return baseOptions;
	    }
	  };
	}]);
	})();
	
	(function() {
	
	angular.module('ui.grid')
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridRenderContainer
	   * @description The grid has render containers, allowing the ability to have pinned columns.  If the grid
	   * is right-to-left then there may be a right render container, if left-to-right then there may
	   * be a left render container.  There is always a body render container.
	   * @param {string} name The name of the render container ('body', 'left', or 'right')
	   * @param {Grid} grid the grid the render container is in
	   * @param {object} options the render container options
	   */
	.factory('GridRenderContainer', ['gridUtil', 'uiGridConstants', function(gridUtil, uiGridConstants) {
	  function GridRenderContainer(name, grid, options) {
	    var self = this;
	
	    // if (gridUtil.type(grid) !== 'Grid') {
	    //   throw new Error('Grid argument is not a Grid object');
	    // }
	
	    self.name = name;
	
	    self.grid = grid;
	
	    // self.rowCache = [];
	    // self.columnCache = [];
	
	    self.visibleRowCache = [];
	    self.visibleColumnCache = [];
	
	    self.renderedRows = [];
	    self.renderedColumns = [];
	
	    self.prevScrollTop = 0;
	    self.prevScrolltopPercentage = 0;
	    self.prevRowScrollIndex = 0;
	
	    self.prevScrollLeft = 0;
	    self.prevScrollleftPercentage = 0;
	    self.prevColumnScrollIndex = 0;
	
	    self.columnStyles = '';
	
	    self.viewportAdjusters = [];
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasHScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a horizontal scrollbar
	     */
	    self.hasHScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasVScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a vertical scrollbar
	     */
	    self.hasVScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeightShouldUpdate
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container should recalculate the canvas size
	     */
	    self.canvasHeightShouldUpdate = true;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeight
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description last calculated canvas height value
	     */
	    self.$$canvasHeight = 0;
	
	    if (options && angular.isObject(options)) {
	      angular.extend(self, options);
	    }
	
	    grid.registerStyleComputation({
	      priority: 5,
	      func: function () {
	        self.updateColumnWidths();
	        return self.columnStyles;
	      }
	    });
	  }
	
	
	  GridRenderContainer.prototype.reset = function reset() {
	    // this.rowCache.length = 0;
	    // this.columnCache.length = 0;
	
	    this.visibleColumnCache.length = 0;
	    this.visibleRowCache.length = 0;
	
	    this.renderedRows.length = 0;
	    this.renderedColumns.length = 0;
	  };
	
	  // TODO(c0bra): calculate size?? Should this be in a stackable directive?
	
	
	  GridRenderContainer.prototype.containsColumn = function (col) {
	     return this.visibleColumnCache.indexOf(col) !== -1;
	  };
	
	  GridRenderContainer.prototype.minRowsToRender = function minRowsToRender() {
	    var self = this;
	    var minRows = 0;
	    var rowAddedHeight = 0;
	    var viewPortHeight = self.getViewportHeight();
	    for (var i = self.visibleRowCache.length - 1; rowAddedHeight < viewPortHeight && i >= 0; i--) {
	      rowAddedHeight += self.visibleRowCache[i].height;
	      minRows++;
	    }
	    return minRows;
	  };
	
	  GridRenderContainer.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewportWidth = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	
	    for (var i = 0; i < self.visibleColumnCache.length; i++) {
	      var col = self.visibleColumnCache[i];
	
	      if (totalWidth < viewportWidth) {
	        totalWidth += col.drawnWidth ? col.drawnWidth : 0;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.visibleColumnCache[j].drawnWidth ? self.visibleColumnCache[j].drawnWidth : 0;
	        }
	        if (currWidth < viewportWidth) {
	          min++;
	        }
	      }
	    }
	
	    return min;
	  };
	
	  GridRenderContainer.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    return this.visibleRowCache.length;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Registers an adjuster to the render container's available width or height.  Adjusters are used
	   * to tell the render container that there is something else consuming space, and to adjust it's size
	   * appropriately.
	   * @param {function} func the adjuster function we want to register
	   */
	
	  GridRenderContainer.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Removes an adjuster, should be used when your element is destroyed
	   * @param {function} func the adjuster function we want to remove
	   */
	  GridRenderContainer.prototype.removeViewportAdjuster = function removeViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (idx > -1) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getViewportAdjustment
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Gets the adjustment based on the viewportAdjusters.
	   * @returns {object} a hash of { height: x, width: y }.  Usually the values will be negative
	   */
	  GridRenderContainer.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  GridRenderContainer.prototype.getMargin = function getMargin(side) {
	    var self = this;
	
	    var amount = 0;
	
	    self.viewportAdjusters.forEach(function (func) {
	      var adjustment = func.call(this, { height: 0, width: 0 });
	
	      if (adjustment.side && adjustment.side === side) {
	        amount += adjustment.width * -1;
	      }
	    });
	
	    return amount;
	  };
	
	  GridRenderContainer.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var headerHeight = (self.headerHeight) ? self.headerHeight : self.grid.headerHeight;
	
	    var viewPortHeight = self.grid.gridHeight - headerHeight - self.grid.footerHeight;
	
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    return viewPortHeight;
	  };
	
	  GridRenderContainer.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewportWidth = self.grid.gridWidth;
	
	    // if (typeof(self.grid.verticalScrollbarWidth) !== 'undefined' && self.grid.verticalScrollbarWidth !== undefined &&
	    //  self.grid.verticalScrollbarWidth > 0) {
	    //   viewPortWidth = viewPortWidth - self.grid.verticalScrollbarWidth;
	    // }
	
	    // var viewportWidth = 0;\
	    // self.visibleColumnCache.forEach(function (column) {
	    //   viewportWidth += column.drawnWidth;
	    // });
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewportWidth = viewportWidth + adjustment.width;
	
	    return viewportWidth;
	  };
	
	  GridRenderContainer.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    return this.getViewportWidth();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getCanvasHeight
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Returns the total canvas height.   Only recalculates if canvasHeightShouldUpdate = false
	   * @returns {number} total height of all the visible rows in the container
	   */
	  GridRenderContainer.prototype.getCanvasHeight = function getCanvasHeight() {
	    var self = this;
	
	    if (!self.canvasHeightShouldUpdate) {
	      return self.$$canvasHeight;
	    }
	
	    var oldCanvasHeight = self.$$canvasHeight;
	
	    self.$$canvasHeight = 0;
	
	    self.visibleRowCache.forEach(function(row) {
	      self.$$canvasHeight += row.height;
	    });
	
	
	    self.canvasHeightShouldUpdate = false;
	
	    self.grid.api.core.raise.canvasHeightChanged(oldCanvasHeight, self.$$canvasHeight);
	
	    return self.$$canvasHeight;
	  };
	
	  GridRenderContainer.prototype.getVerticalScrollLength = function getVerticalScrollLength() {
	    return this.getCanvasHeight() - this.getViewportHeight() + this.grid.scrollbarHeight !== 0 ? this.getCanvasHeight() - this.getViewportHeight() + this.grid.scrollbarHeight : -1;
	  };
	
	  GridRenderContainer.prototype.getHorizontalScrollLength = function getHorizontalScrollLength() {
	    return this.getCanvasWidth() - this.getViewportWidth() + this.grid.scrollbarWidth !== 0 ? this.getCanvasWidth() - this.getViewportWidth() + this.grid.scrollbarWidth : -1;
	  };
	
	  GridRenderContainer.prototype.getCanvasWidth = function getCanvasWidth() {
	    var self = this;
	
	    return self.canvasWidth;
	  };
	
	  GridRenderContainer.prototype.setRenderedRows = function setRenderedRows(newRows) {
	    this.renderedRows.length = newRows.length;
	    for (var i = 0; i < newRows.length; i++) {
	      this.renderedRows[i] = newRows[i];
	    }
	  };
	
	  GridRenderContainer.prototype.setRenderedColumns = function setRenderedColumns(newColumns) {
	    // OLD:
	    this.renderedColumns.length = newColumns.length;
	    for (var i = 0; i < newColumns.length; i++) {
	      this.renderedColumns[i] = newColumns[i];
	    }
	
	    this.updateColumnOffset();
	  };
	
	  GridRenderContainer.prototype.updateColumnOffset = function updateColumnOffset() {
	    // Calculate the width of the columns on the left side that are no longer rendered.
	    //  That will be the offset for the columns as we scroll horizontally.
	    var hiddenColumnsWidth = 0;
	    for (var i = 0; i < this.currentFirstColumn; i++) {
	      hiddenColumnsWidth += this.visibleColumnCache[i].drawnWidth;
	    }
	
	    this.columnOffset = hiddenColumnsWidth;
	  };
	
	  GridRenderContainer.prototype.scrollVertical = function (newScrollTop) {
	    var vertScrollPercentage = -1;
	
	    if (newScrollTop !== this.prevScrollTop) {
	      var yDiff = newScrollTop - this.prevScrollTop;
	
	      if (yDiff > 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.DOWN; }
	      if (yDiff < 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.UP; }
	
	      var vertScrollLength = this.getVerticalScrollLength();
	
	      vertScrollPercentage = newScrollTop / vertScrollLength;
	
	      if (vertScrollPercentage > 1) { vertScrollPercentage = 1; }
	      if (vertScrollPercentage < 0) { vertScrollPercentage = 0; }
	
	      this.adjustScrollVertical(newScrollTop, vertScrollPercentage);
	      return vertScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.scrollHorizontal = function(newScrollLeft) {
	    var horizScrollPercentage = -1;
	
	    // Handle RTL here
	    if (newScrollLeft !== this.prevScrollLeft) {
	      var xDiff = newScrollLeft - this.prevScrollLeft;
	
	      if (xDiff > 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.RIGHT; }
	      if (xDiff < 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.LEFT; }
	
	      var horizScrollLength = this.getHorizontalScrollLength();
	      if (horizScrollLength !== 0) {
	        horizScrollPercentage = newScrollLeft / horizScrollLength;
	      }
	      else {
	        horizScrollPercentage = 0;
	      }
	
	      this.adjustScrollHorizontal(newScrollLeft, horizScrollPercentage);
	      return horizScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.adjustScrollVertical = function adjustScrollVertical(scrollTop, scrollPercentage, force) {
	    if (this.prevScrollTop === scrollTop && !force) {
	      return;
	    }
	
	    if (typeof(scrollTop) === 'undefined' || scrollTop === undefined || scrollTop === null) {
	      scrollTop = (this.getCanvasHeight() - this.getViewportHeight()) * scrollPercentage;
	    }
	
	    this.adjustRows(scrollTop, scrollPercentage, false);
	
	    this.prevScrollTop = scrollTop;
	    this.prevScrolltopPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustScrollHorizontal = function adjustScrollHorizontal(scrollLeft, scrollPercentage, force) {
	    if (this.prevScrollLeft === scrollLeft && !force) {
	      return;
	    }
	
	    if (typeof(scrollLeft) === 'undefined' || scrollLeft === undefined || scrollLeft === null) {
	      scrollLeft = (this.getCanvasWidth() - this.getViewportWidth()) * scrollPercentage;
	    }
	
	    this.adjustColumns(scrollLeft, scrollPercentage);
	
	    this.prevScrollLeft = scrollLeft;
	    this.prevScrollleftPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustRows = function adjustRows(scrollTop, scrollPercentage, postDataLoaded) {
	    var self = this;
	
	    var minRows = self.minRowsToRender();
	
	    var rowCache = self.visibleRowCache;
	
	    var maxRowIndex = rowCache.length - minRows;
	
	    // Calculate the scroll percentage according to the scrollTop location, if no percentage was provided
	    if ((typeof(scrollPercentage) === 'undefined' || scrollPercentage === null) && scrollTop) {
	      scrollPercentage = scrollTop / self.getVerticalScrollLength();
	    }
	
	    var rowIndex = Math.ceil(Math.min(maxRowIndex, maxRowIndex * scrollPercentage));
	
	    // Define a max row index that we can't scroll past
	    if (rowIndex > maxRowIndex) {
	      rowIndex = maxRowIndex;
	    }
	
	    var newRange = [];
	    if (rowCache.length > self.grid.options.virtualizationThreshold) {
	      if (!(typeof(scrollTop) === 'undefined' || scrollTop === null)) {
	        // Have we hit the threshold going down?
	        if ( !self.grid.suppressParentScrollDown && self.prevScrollTop < scrollTop && rowIndex < self.prevRowScrollIndex + self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	        // Have we hit the threshold going up?
	        if ( !self.grid.suppressParentScrollUp && self.prevScrollTop > scrollTop && rowIndex > self.prevRowScrollIndex - self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	      }
	
	      var rangeStart = Math.max(0, rowIndex - self.grid.options.excessRows);
	      var rangeEnd = Math.min(rowCache.length, rowIndex + minRows + self.grid.options.excessRows);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleRowCache.length;
	      newRange = [0, Math.max(maxLen, minRows + self.grid.options.excessRows)];
	    }
	
	    self.updateViewableRowRange(newRange);
	
	    self.prevRowScrollIndex = rowIndex;
	  };
	
	  GridRenderContainer.prototype.adjustColumns = function adjustColumns(scrollLeft, scrollPercentage) {
	    var self = this;
	
	    var minCols = self.minColumnsToRender();
	
	    var columnCache = self.visibleColumnCache;
	    var maxColumnIndex = columnCache.length - minCols;
	
	    // Calculate the scroll percentage according to the scrollLeft location, if no percentage was provided
	    if ((typeof(scrollPercentage) === 'undefined' || scrollPercentage === null) && scrollLeft) {
	      scrollPercentage = scrollLeft / self.getHorizontalScrollLength();
	    }
	
	    var colIndex = Math.ceil(Math.min(maxColumnIndex, maxColumnIndex * scrollPercentage));
	
	    // Define a max row index that we can't scroll past
	    if (colIndex > maxColumnIndex) {
	      colIndex = maxColumnIndex;
	    }
	
	    var newRange = [];
	    if (columnCache.length > self.grid.options.columnVirtualizationThreshold && self.getCanvasWidth() > self.getViewportWidth()) {
	      var rangeStart = Math.max(0, colIndex - self.grid.options.excessColumns);
	      var rangeEnd = Math.min(columnCache.length, colIndex + minCols + self.grid.options.excessColumns);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleColumnCache.length;
	
	      newRange = [0, Math.max(maxLen, minCols + self.grid.options.excessColumns)];
	    }
	
	    self.updateViewableColumnRange(newRange);
	
	    self.prevColumnScrollIndex = colIndex;
	  };
	
	  // Method for updating the visible rows
	  GridRenderContainer.prototype.updateViewableRowRange = function updateViewableRowRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var rowArr = uiGridCtrl.grid.rows.slice(renderedRange[0], renderedRange[1]);
	    var rowArr = this.visibleRowCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the top-most rendered row
	    this.currentTopRow = renderedRange[0];
	
	    this.setRenderedRows(rowArr);
	  };
	
	  // Method for updating the visible columns
	  GridRenderContainer.prototype.updateViewableColumnRange = function updateViewableColumnRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var columnArr = uiGridCtrl.grid.columns.slice(renderedRange[0], renderedRange[1]);
	    var columnArr = this.visibleColumnCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the left-most rendered columns
	    this.currentFirstColumn = renderedRange[0];
	
	    this.setRenderedColumns(columnArr);
	  };
	
	  GridRenderContainer.prototype.headerCellWrapperStyle = function () {
	    var self = this;
	
	    if (self.currentFirstColumn !== 0) {
	      var offset = self.columnOffset;
	
	      if (self.grid.isRTL()) {
	        return { 'margin-right': offset + 'px' };
	      }
	      else {
	        return { 'margin-left': offset + 'px' };
	      }
	    }
	
	    return null;
	  };
	
	    /**
	     *  @ngdoc boolean
	     *  @name updateColumnWidths
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description Determine the appropriate column width of each column across all render containers.
	     *
	     *  Column width is easy when each column has a specified width.  When columns are variable width (i.e.
	     *  have an * or % of the viewport) then we try to calculate so that things fit in.  The problem is that
	     *  we have multiple render containers, and we don't want one render container to just take the whole viewport
	     *  when it doesn't need to - we want things to balance out across the render containers.
	     *
	     *  To do this, we use this method to calculate all the renderContainers, recognising that in a given render
	     *  cycle it'll get called once per render container, so it needs to return the same values each time.
	     *
	     *  The constraints on this method are therefore:
	     *  - must return the same value when called multiple times, to do this it needs to rely on properties of the
	     *    columns, but not properties that change when this is called (so it shouldn't rely on drawnWidth)
	     *
	     *  The general logic of this method is:
	     *  - calculate our total available width
	     *  - look at all the columns across all render containers, and work out which have widths and which have
	     *    constraints such as % or * or something else
	     *  - for those with *, count the total number of * we see and add it onto a running total, add this column to an * array
	     *  - for those with a %, allocate the % as a percentage of the viewport, having consideration of min and max
	     *  - for those with manual width (in pixels) we set the drawnWidth to the specified width
	     *  - we end up with an asterisks array still to process
	     *  - we look at our remaining width.  If it's greater than zero, we divide it up among the asterisk columns, then process
	     *    them for min and max width constraints
	     *  - if it's zero or less, we set the asterisk columns to their minimum widths
	     *  - we use parseInt quite a bit, as we try to make all our column widths integers
	     */
	  GridRenderContainer.prototype.updateColumnWidths = function () {
	    var self = this;
	
	    var asterisksArray = [],
	        asteriskNum = 0,
	        usedWidthSum = 0,
	        ret = '',
	        pinRightColumn = false,
	        fixedNumberArray = [],
	        percentageArray = [],
	        totalPercentage = 0;
	
	    // Get the width of the viewport
	    var availableWidth = self.grid.getViewportWidth() - self.grid.scrollbarWidth;
	
	    // get all the columns across all render containers, we have to calculate them all or one render container
	    // could consume the whole viewport
	    var columnCache = [];
	    angular.forEach(self.grid.renderContainers, function (container) {
	      columnCache = columnCache.concat(container.visibleColumnCache);
	    });
	
	    // look at each column, process any manual values or %, put the * into an array to look at later
	    columnCache.forEach(function (column) {
	      var width = 0;
	      // Skip hidden columns
	      if (!column.visible) { return; }
	
	      if (pinRightColumn) {
	        availableWidth += self.grid.scrollbarWidth;
	      }
	
	      if (!pinRightColumn && column.colDef.pinnedRight) {
	        pinRightColumn = true;
	      }
	
	      if (angular.isNumber(column.width)) {
	        // pixel width, set to this value
	        width = parseInt(column.width, 10);
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	
	        fixedNumberArray.push(column);
	      } else if (gridUtil.endsWith(column.width, '%')) {
	        // percentage width, set to percentage of the viewport
	        // round down to int - some browsers don't play nice with float maxWidth
	        var percentageIntegerValue = parseInt(column.width.replace(/%/g, ''), 10);
	        width = parseInt(percentageIntegerValue / 100 * availableWidth);
	
	        if (width > column.maxWidth) {
	          width = column.maxWidth;
	        }
	
	        if (width < column.minWidth) {
	          width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	
	        totalPercentage = totalPercentage + percentageIntegerValue;
	        percentageArray.push(column);
	      } else if (angular.isString(column.width) && column.width.indexOf('*') !== -1) {
	        // is an asterisk column, the gridColumn already checked the string consists only of '****'
	        asteriskNum = asteriskNum + column.width.length;
	        asterisksArray.push(column);
	      }
	    });
	
	    // Get the remaining width (available width subtracted by the used widths sum)
	    var remainingWidth = availableWidth - usedWidthSum;
	
	    if (asterisksArray.length > 0) {
	      // the width that each asterisk value would be assigned (this can be negative)
	      var asteriskVal = remainingWidth / asteriskNum;
	
	      asterisksArray.forEach(function (column) {
	        var width = parseInt(column.width.length * asteriskVal, 10);
	
	        if (width > column.maxWidth) {
	            width = column.maxWidth;
	        }
	
	        if (width < column.minWidth) {
	            width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	      });
	    }
	
	    // If there are no columns with asterisk widths then check if there are any with % widths and
	    // use them as a fallback for adjusting column widths up or down if we have remaining grid width
	    // or need to claw some width back
	    var variableWidthColumnArray;
	    if (asterisksArray.length > 0) {
	      variableWidthColumnArray = asterisksArray;
	    } else if (percentageArray.length > 0 && fixedNumberArray.length === 0 && totalPercentage === 100) {
	      variableWidthColumnArray = percentageArray;
	    }
	
	    if (!angular.isUndefined(variableWidthColumnArray)) {
	      // If the grid width didn't divide evenly into the column widths and we have pixels left over, or our
	      // calculated widths would have the grid narrower than the available space,
	      // dole the remainder out one by one to make everything fit
	      var processColumnUpwards = function (column) {
	        if (column.drawnWidth < column.maxWidth && leftoverWidth > 0) {
	          column.drawnWidth++;
	          usedWidthSum++;
	          leftoverWidth--;
	          columnsToChange = true;
	        }
	      };
	
	      var leftoverWidth = availableWidth - usedWidthSum;
	      var columnsToChange = true;
	
	      while (leftoverWidth > 0 && columnsToChange) {
	        columnsToChange = false;
	        variableWidthColumnArray.forEach(processColumnUpwards);
	      }
	
	      // We can end up with too much width even though some columns aren't at their max width, in this situation
	      // we can trim the columns a little
	      var processColumnDownwards = function (column) {
	        if (column.drawnWidth > column.minWidth && excessWidth > 0) {
	          column.drawnWidth--;
	          usedWidthSum--;
	          excessWidth--;
	          columnsToChange = true;
	        }
	      };
	
	      var excessWidth = usedWidthSum - availableWidth;
	      columnsToChange = true;
	
	      while (excessWidth > 0 && columnsToChange) {
	        columnsToChange = false;
	        variableWidthColumnArray.forEach(processColumnDownwards);
	      }
	    }
	
	    // all that was across all the renderContainers, now we need to work out what that calculation decided for
	    // our renderContainer
	    var canvasWidth = 0;
	    self.visibleColumnCache.forEach(function(column) {
	      if ( column.visible ) {
	        canvasWidth = canvasWidth + column.drawnWidth;
	      }
	    });
	
	    // Build the CSS
	    columnCache.forEach(function (column) {
	      ret = ret + column.getColClassDefinition();
	    });
	
	    self.canvasWidth = canvasWidth;
	
	    // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	    // return ret;
	
	    // Set this render container's column styles so they can be used in style computation
	    this.columnStyles = ret;
	  };
	
	  GridRenderContainer.prototype.needsHScrollbarPlaceholder = function () {
	    var self = this,
	      containerBody;
	
	    if (self.name === 'left' || self.name === 'right' && !this.hasHScrollbar && !this.grid.disableScrolling) {
	      if (self.grid.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	        return true;
	      }
	      containerBody = this.grid.element[0].querySelector('.ui-grid-render-container-body .ui-grid-viewport');
	      return containerBody.scrollWidth > containerBody.offsetWidth;
	    }
	    return false;
	  };
	
	  GridRenderContainer.prototype.getViewportStyle = function () {
	    var self = this;
	    var styles = {};
	    var scrollbarVisibility = {};
	
	    scrollbarVisibility[uiGridConstants.scrollbars.ALWAYS] = 'scroll';
	    scrollbarVisibility[uiGridConstants.scrollbars.WHEN_NEEDED] = 'auto';
	
	    self.hasHScrollbar = false;
	    self.hasVScrollbar = false;
	
	    if (self.grid.disableScrolling) {
	      styles['overflow-x'] = 'hidden';
	      styles['overflow-y'] = 'hidden';
	      return styles;
	    }
	
	    if (self.name === 'body') {
	      self.hasHScrollbar = self.grid.options.enableHorizontalScrollbar !== uiGridConstants.scrollbars.NEVER;
	      if (!self.grid.isRTL()) {
	        if (!self.grid.hasRightContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	      else {
	        if (!self.grid.hasLeftContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	    }
	    else if (self.name === 'left') {
	      self.hasVScrollbar = self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	    else {
	      self.hasVScrollbar = !self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	
	    styles['overflow-x'] = self.hasHScrollbar ? scrollbarVisibility[self.grid.options.enableHorizontalScrollbar] : 'hidden';
	    styles['overflow-y'] = self.hasVScrollbar ? scrollbarVisibility[self.grid.options.enableVerticalScrollbar] : 'hidden';
	
	    return styles;
	  };
	
	  return GridRenderContainer;
	}]);
	
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.factory('GridRow', ['gridUtil', 'uiGridConstants', function(gridUtil, uiGridConstants) {
	
	   /**
	   * @class GridRow
	   * @ngdoc function
	   * @name ui.grid.class:GridRow
	   * @description GridRow is the viewModel for one logical row on the grid.  A grid Row is not necessarily a one-to-one
	   * relation to gridOptions.data.
	   * @param {object} entity the array item from GridOptions.data
	   * @param {number} index the current position of the row in the array
	   * @param {Grid} grid reference to the parent grid
	   */
	  function GridRow(entity, index, grid) {
	
	     /**
	      *  @ngdoc object
	      *  @name grid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference back to the grid
	      */
	     this.grid = grid;
	
	     /**
	      *  @ngdoc object
	      *  @name entity
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference to an item in gridOptions.data[]
	      */
	    this.entity = entity;
	
	     /**
	      *  @ngdoc object
	      *  @name uid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description  UniqueId of row
	      */
	     this.uid = gridUtil.nextUid();
	
	     /**
	      *  @ngdoc object
	      *  @name visible
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description If true, the row will be rendered
	      */
	    // Default to true
	    this.visible = true;
	
	     /**
	      *  @ngdoc object
	      *  @name isSelected
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description Marks if the row has been selected
	      */
	     // Default to false
	     this.isSelected = false;
	
	
	    this.$$height = grid.options.rowHeight;
	
	  }
	
	    /**
	     *  @ngdoc object
	     *  @name height
	     *  @propertyOf ui.grid.class:GridRow
	     *  @description height of each individual row. changing the height will flag all
	     *  row renderContainers to recalculate their canvas height
	     */
	    Object.defineProperty(GridRow.prototype, 'height', {
	      get: function() {
	        return this.$$height;
	      },
	      set: function(height) {
	        if (height !== this.$$height) {
	          this.grid.updateCanvasHeight();
	          this.$$height = height;
	        }
	      }
	    });
	
	  /**
	   * @ngdoc function
	   * @name getQualifiedColField
	   * @methodOf ui.grid.class:GridRow
	   * @description returns the qualified field name as it exists on scope
	   * ie: row.entity.fieldA
	   * @param {GridColumn} col column instance
	   * @returns {string} resulting name that can be evaluated on scope
	   */
	    GridRow.prototype.getQualifiedColField = function(col) {
	      return 'row.' + this.getEntityQualifiedColField(col);
	    };
	
	    /**
	     * @ngdoc function
	     * @name getEntityQualifiedColField
	     * @methodOf ui.grid.class:GridRow
	     * @description returns the qualified field name minus the row path
	     * ie: entity.fieldA
	     * @param {GridColumn} col column instance
	     * @returns {string} resulting name that can be evaluated against a row
	     */
	  GridRow.prototype.getEntityQualifiedColField = function(col) {
	    var base = 'entity';
	    if ( col.field === uiGridConstants.ENTITY_BINDING ) {
	      return base;
	    }
	    return gridUtil.preEval(base + '.' + col.field);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   *
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.setRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.setThisRowInvisible().
	   *
	   * @param {GridRow} row the row we want to set to invisible
	   *
	   */
	  GridRow.prototype.setRowInvisible = function ( row ) {
	    if (row && row.setThisRowInvisible) {
	      row.setThisRowInvisible( 'user' );
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Clears an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   *
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.clearRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.clearThisRowInvisible().
	   *
	   * @param {GridRow} row the row we want to clear the invisible flag
	   *
	   */
	  GridRow.prototype.clearRowInvisible = function ( row ) {
	    if (row && row.clearThisRowInvisible) {
	      row.clearThisRowInvisible( 'user' );
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setThisRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility
	   *
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.setThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if ( !this.invisibleReason ) {
	      this.invisibleReason = {};
	    }
	    this.invisibleReason[reason] = true;
	    this.evaluateRowVisibility( fromRowsProcessor);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf ui.grid.class:GridRow
	   * @description Clears any override on the row visibility, returning it
	   * to normal visibility calculations.  Emits the rowsVisibleChanged
	   * event
	   *
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.clearThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if (typeof(this.invisibleReason) !== 'undefined' ) {
	      delete this.invisibleReason[reason];
	    }
	    this.evaluateRowVisibility( fromRowsProcessor );
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name evaluateRowVisibility
	   * @methodOf ui.grid.class:GridRow
	   * @description Determines whether the row should be visible based on invisibleReason,
	   * and if it changes the row visibility, then emits the rowsVisibleChanged event.
	   *
	   * Queues a grid refresh, but doesn't call it directly to avoid hitting lots of grid refreshes.
	   * @param {boolean} fromRowProcessor if true, then it won't raise events or queue the refresh, the
	   * row processor does that already
	   */
	  GridRow.prototype.evaluateRowVisibility = function ( fromRowProcessor ) {
	    var newVisibility = true;
	    if ( typeof(this.invisibleReason) !== 'undefined' ) {
	      angular.forEach(this.invisibleReason, function( value, key ) {
	        if ( value ) {
	          newVisibility = false;
	        }
	      });
	    }
	
	    if ( typeof(this.visible) === 'undefined' || this.visible !== newVisibility ) {
	      this.visible = newVisibility;
	      if ( !fromRowProcessor ) {
	        this.grid.queueGridRefresh();
	        this.grid.api.core.raise.rowsVisibleChanged(this);
	      }
	    }
	  };
	
	
	  return GridRow;
	}]);
	
	})();
	
	(function() {
	  'use strict';
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridRowColumn
	   * @param {GridRow} row The row for this pair
	   * @param {GridColumn} column The column for this pair
	   * @description A row and column pair that represents the intersection of these two entities.
	   * Must be instantiated as a constructor using the `new` keyword.
	   */
	  angular.module('ui.grid')
	  .factory('GridRowColumn', ['$parse', '$filter',
	    function GridRowColumnFactory($parse, $filter) {
	      var GridRowColumn = function GridRowColumn(row, col) {
	        if ( !(this instanceof GridRowColumn)) {
	          throw "Using GridRowColumn as a function insead of as a constructor. Must be called with `new` keyword";
	        }
	
	        /**
	         * @ngdoc object
	         * @name row
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridRow }
	         */
	        this.row = row;
	        /**
	         * @ngdoc object
	         * @name col
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridColumn }
	         */
	        this.col = col;
	      };
	
	      /**
	       * @ngdoc function
	       * @name getIntersectionValueRaw
	       * @methodOf ui.grid.class:GridRowColumn
	       * @description Gets the intersection of where the row and column meet.
	       * @returns {String|Number|Object} The value from the grid data that this GridRowColumn points too.
	       *          If the column has a cellFilter this will NOT return the filtered value.
	       */
	      GridRowColumn.prototype.getIntersectionValueRaw = function() {
	        var getter = $parse(this.row.getEntityQualifiedColField(this.col));
	        var context = this.row;
	        return getter(context);
	      };
	      return GridRowColumn;
	    }
	  ]);
	})();
	
	(function () {
	  angular.module('ui.grid')
	    .factory('ScrollEvent', ['gridUtil', function (gridUtil) {
	
	      /**
	       * @ngdoc function
	       * @name ui.grid.class:ScrollEvent
	       * @description Model for all scrollEvents
	       * @param {Grid} grid that owns the scroll event
	       * @param {GridRenderContainer} sourceRowContainer that owns the scroll event. Can be null
	       * @param {GridRenderContainer} sourceColContainer that owns the scroll event. Can be null
	       * @param {string} source the source of the event - from uiGridConstants.scrollEventSources or a string value of directive/service/factory.functionName
	       */
	      function ScrollEvent(grid, sourceRowContainer, sourceColContainer, source) {
	        var self = this;
	        if (!grid) {
	          throw new Error("grid argument is required");
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grid
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description A reference back to the grid
	         */
	         self.grid = grid;
	
	
	
	        /**
	         *  @ngdoc object
	         *  @name source
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description the source of the scroll event. limited to values from uiGridConstants.scrollEventSources
	         */
	        self.source = source;
	
	
	        /**
	         *  @ngdoc object
	         *  @name noDelay
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description most scroll events from the mouse or trackpad require delay to operate properly
	         *  set to false to eliminate delay.  Useful for scroll events that the grid causes, such as scrolling to make a row visible.
	         */
	        self.withDelay = true;
	
	        self.sourceRowContainer = sourceRowContainer;
	        self.sourceColContainer = sourceColContainer;
	
	        self.newScrollLeft = null;
	        self.newScrollTop = null;
	        self.x = null;
	        self.y = null;
	
	        self.verticalScrollLength = -9999999;
	        self.horizontalScrollLength = -999999;
	
	
	        /**
	         *  @ngdoc function
	         *  @name fireThrottledScrollingEvent
	         *  @methodOf  ui.grid.class:ScrollEvent
	         *  @description fires a throttled event using grid.api.core.raise.scrollEvent
	         */
	        self.fireThrottledScrollingEvent = gridUtil.throttle(function(sourceContainerId) {
	          self.grid.scrollContainers(sourceContainerId, self);
	        }, self.grid.options.wheelScrollThrottle, {trailing: true});
	
	      }
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollLeft
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollLeft property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollLeft = function(colContainer, viewport) {
	        var self = this;
	
	        if (!self.newScrollLeft) {
	          var scrollWidth = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
	
	          var oldScrollLeft = gridUtil.normalizeScrollLeft(viewport, self.grid);
	
	          var scrollXPercentage;
	          if (typeof(self.x.percentage) !== 'undefined' && self.x.percentage !== undefined) {
	            scrollXPercentage = self.x.percentage;
	          }
	          else if (typeof(self.x.pixels) !== 'undefined' && self.x.pixels !== undefined) {
	            scrollXPercentage = self.x.percentage = (oldScrollLeft + self.x.pixels) / scrollWidth;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event X axis");
	          }
	
	          return Math.max(0, scrollXPercentage * scrollWidth);
	        }
	
	        return self.newScrollLeft;
	      };
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollTop
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollTop property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollTop = function(rowContainer, viewport) {
	        var self = this;
	
	
	        if (!self.newScrollTop) {
	          var scrollLength = rowContainer.getVerticalScrollLength();
	
	          var oldScrollTop = viewport[0].scrollTop;
	
	          var scrollYPercentage;
	          if (typeof(self.y.percentage) !== 'undefined' && self.y.percentage !== undefined) {
	            scrollYPercentage = self.y.percentage;
	          }
	          else if (typeof(self.y.pixels) !== 'undefined' && self.y.pixels !== undefined) {
	            scrollYPercentage = self.y.percentage = (oldScrollTop + self.y.pixels) / scrollLength;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event Y axis");
	          }
	
	          return Math.max(0, scrollYPercentage * scrollLength);
	        }
	
	        return self.newScrollTop;
	      };
	
	      ScrollEvent.prototype.atTop = function(scrollTop) {
	        return (this.y && (this.y.percentage === 0 || this.verticalScrollLength < 0) && scrollTop === 0);
	      };
	
	      ScrollEvent.prototype.atBottom = function(scrollTop) {
	        return (this.y && (this.y.percentage === 1 || this.verticalScrollLength === 0) && scrollTop > 0);
	      };
	
	      ScrollEvent.prototype.atLeft = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 0 || this.horizontalScrollLength < 0) && scrollLeft === 0);
	      };
	
	      ScrollEvent.prototype.atRight = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 1 || this.horizontalScrollLength ===0) && scrollLeft > 0);
	      };
	
	
	      ScrollEvent.Sources = {
	        ViewPortScroll: 'ViewPortScroll',
	        RenderContainerMouseWheel: 'RenderContainerMouseWheel',
	        RenderContainerTouchMove: 'RenderContainerTouchMove',
	        Other: 99
	      };
	
	      return ScrollEvent;
	    }]);
	
	
	
	})();
	
	(function () {
	  'use strict';
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.service:gridClassFactory
	   *
	   *  @description factory to return dom specific instances of a grid
	   *
	   */
	  angular.module('ui.grid').service('gridClassFactory', ['gridUtil', '$q', '$compile', '$templateCache', 'uiGridConstants', 'Grid', 'GridColumn', 'GridRow',
	    function (gridUtil, $q, $compile, $templateCache, uiGridConstants, Grid, GridColumn, GridRow) {
	
	      var service = {
	        /**
	         * @ngdoc method
	         * @name createGrid
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Creates a new grid instance. Each instance will have a unique id
	         * @param {object} options An object map of options to pass into the created grid instance.
	         * @returns {Grid} grid
	         */
	        createGrid : function(options) {
	          options = (typeof(options) !== 'undefined') ? options : {};
	          options.id = gridUtil.newId();
	          var grid = new Grid(options);
	
	          // NOTE/TODO: rowTemplate should always be defined...
	          if (grid.options.rowTemplate) {
	            var rowTemplateFnPromise = $q.defer();
	            grid.getRowTemplateFn = rowTemplateFnPromise.promise;
	
	            gridUtil.getTemplate(grid.options.rowTemplate)
	              .then(
	                function (template) {
	                  var rowTemplateFn = $compile(template);
	                  rowTemplateFnPromise.resolve(rowTemplateFn);
	                },
	                function () {
	                  // Todo handle response error here?
	                  throw new Error("Couldn't fetch/use row template '" + grid.options.rowTemplate + "'");
	                }).catch(angular.noop);
	          }
	
	          grid.registerColumnBuilder(service.defaultColumnBuilder);
	
	          // Row builder for custom row templates
	          grid.registerRowBuilder(service.rowTemplateAssigner);
	
	          // Reset all rows to visible initially
	          grid.registerRowsProcessor(function allRowsVisible(rows) {
	            rows.forEach(function (row) {
	              row.evaluateRowVisibility( true );
	            });
	
	            return rows;
	          }, 50);
	
	          grid.registerColumnsProcessor(function applyColumnVisibility(columns) {
	            columns.forEach(function (column) {
	              column.visible = angular.isDefined(column.colDef.visible) ? column.colDef.visible : true;
	            });
	
	            return columns;
	          }, 50);
	
	          grid.registerRowsProcessor(grid.searchRows, 100);
	
	          // Register the default row processor, it sorts rows by selected columns
	          if (grid.options.externalSort && angular.isFunction(grid.options.externalSort)) {
	            grid.registerRowsProcessor(grid.options.externalSort, 200);
	          }
	          else {
	            grid.registerRowsProcessor(grid.sortByColumn, 200);
	          }
	
	          return grid;
	        },
	
	        /**
	         * @ngdoc function
	         * @name defaultColumnBuilder
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Processes designTime column definitions and applies them to col for the
	         *              core grid features
	         * @param {object} colDef reference to column definition
	         * @param {GridColumn} col reference to gridCol
	         * @param {object} gridOptions reference to grid options
	         */
	        defaultColumnBuilder: function (colDef, col, gridOptions) {
	
	          var templateGetPromises = [];
	
	          // Abstracts the standard template processing we do for every template type.
	          var processTemplate = function( templateType, providedType, defaultTemplate, filterType, tooltipType ) {
	            if ( !colDef[templateType] ) {
	              col[providedType] = defaultTemplate;
	            } else {
	              col[providedType] = colDef[templateType];
	            }
	
	            var templatePromise = gridUtil.getTemplate(col[providedType])
	              .then(
	                function (template) {
	                  if ( angular.isFunction(template) ) { template = template(); }
	                  var tooltipCall = ( tooltipType === 'cellTooltip' )
	                      ? 'col.cellTooltip(row,col)'
	                      : 'col.headerTooltip(col)';
	                  if ( tooltipType && col[tooltipType] === false ) {
	                    template = template.replace(uiGridConstants.TOOLTIP, '');
	                  } else if ( tooltipType && col[tooltipType] ) {
	                    template = template.replace(uiGridConstants.TOOLTIP, 'title="{{' + tooltipCall + ' CUSTOM_FILTERS }}"');
	                  }
	
	                  if ( filterType ) {
	                    col[templateType] = template.replace(uiGridConstants.CUSTOM_FILTERS, function() {
	                      return col[filterType] ? "|" + col[filterType] : "";
	                    });
	                  } else {
	                    col[templateType] = template;
	                  }
	                },
	                function () {
	                  throw new Error("Couldn't fetch/use colDef." + templateType + " '" + colDef[templateType] + "'");
	                }).catch(angular.noop);
	
	            templateGetPromises.push(templatePromise);
	
	            return templatePromise;
	          };
	
	
	          /**
	           * @ngdoc property
	           * @name cellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for each cell in this column.  The default
	           * is ui-grid/uiGridCell.  If you are using the cellNav feature, this template
	           * must contain a div that can receive focus.
	           *
	           */
	          col.cellTemplatePromise = processTemplate( 'cellTemplate', 'providedCellTemplate', 'ui-grid/uiGridCell', 'cellFilter', 'cellTooltip' );
	
	          /**
	           * @ngdoc property
	           * @name headerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the header for this column.  The default
	           * is ui-grid/uiGridHeaderCell
	           *
	           */
	          col.headerCellTemplatePromise = processTemplate( 'headerCellTemplate', 'providedHeaderCellTemplate', 'ui-grid/uiGridHeaderCell', 'headerCellFilter', 'headerTooltip' );
	
	          /**
	           * @ngdoc property
	           * @name footerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the footer for this column.  The default
	           * is ui-grid/uiGridFooterCell
	           *
	           */
	          col.footerCellTemplatePromise = processTemplate( 'footerCellTemplate', 'providedFooterCellTemplate', 'ui-grid/uiGridFooterCell', 'footerCellFilter' );
	
	          /**
	           * @ngdoc property
	           * @name filterHeaderTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the filter input.  The default is ui-grid/ui-grid-filter
	           *
	           */
	          col.filterHeaderTemplatePromise = processTemplate( 'filterHeaderTemplate', 'providedFilterHeaderTemplate', 'ui-grid/ui-grid-filter' );
	
	          // Create a promise for the compiled element function
	          col.compiledElementFnDefer = $q.defer();
	
	          return $q.all(templateGetPromises);
	        },
	
	        rowTemplateAssigner: function rowTemplateAssigner(row) {
	          var grid = this;
	
	          // Row has no template assigned to it
	          if (!row.rowTemplate) {
	            // Use the default row template from the grid
	            row.rowTemplate = grid.options.rowTemplate;
	
	            // Use the grid's function for fetching the compiled row template function
	            row.getRowTemplateFn = grid.getRowTemplateFn;
	          }
	          // Row has its own template assigned
	          else {
	            // Create a promise for the compiled row template function
	            var perRowTemplateFnPromise = $q.defer();
	            row.getRowTemplateFn = perRowTemplateFnPromise.promise;
	
	            // Get the row template
	            gridUtil.getTemplate(row.rowTemplate)
	              .then(function (template) {
	                // Compile the template
	                var rowTemplateFn = $compile(template);
	
	                // Resolve the compiled template function promise
	                perRowTemplateFnPromise.resolve(rowTemplateFn);
	              },
	              function () {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use row template '" + row.rowTemplate + "'");
	              });
	          }
	
	          return row.getRowTemplateFn;
	        }
	      };
	
	      // class definitions (moved to separate factories)
	
	      return service;
	    }]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
	
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:rowSearcher
	 *
	 *  @description Service for searching/filtering rows based on column value conditions.
	 */
	module.service('rowSearcher', ['gridUtil', 'uiGridConstants', function (gridUtil, uiGridConstants) {
	  var defaultCondition = uiGridConstants.filter.CONTAINS;
	
	  var rowSearcher = {};
	
	  /**
	   * @ngdoc function
	   * @name getTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Get the term from a filter
	   * Trims leading and trailing whitespace
	   * @param {object} filter object to use
	   * @returns {object} Parsed term
	   */
	  rowSearcher.getTerm = function getTerm(filter) {
	    if (typeof(filter.term) === 'undefined') { return filter.term; }
	
	    var term = filter.term;
	
	    // Strip leading and trailing whitespace if the term is a string
	    if (typeof(term) === 'string') {
	      term = term.trim();
	    }
	
	    return term;
	  };
	
	  /**
	   * @ngdoc function
	   * @name stripTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Remove leading and trailing asterisk (*) from the filter's term
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.stripTerm = function stripTerm(filter) {
	    var term = rowSearcher.getTerm(filter);
	
	    if (typeof(term) === 'string') {
	      return escapeRegExp(term.replace(/(^\*|\*$)/g, ''));
	    }
	    else {
	      return term;
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name guessCondition
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Guess the condition for a filter based on its term
	   * <br>
	   * Defaults to STARTS_WITH. Uses CONTAINS for strings beginning and ending with *s (*bob*).
	   * Uses STARTS_WITH for strings ending with * (bo*). Uses ENDS_WITH for strings starting with * (*ob).
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.guessCondition = function guessCondition(filter) {
	    if (typeof(filter.term) === 'undefined' || !filter.term) {
	      return defaultCondition;
	    }
	
	    var term = rowSearcher.getTerm(filter);
	
	    if (/\*/.test(term)) {
	      var regexpFlags = '';
	      if (!filter.flags || !filter.flags.caseSensitive) {
	        regexpFlags += 'i';
	      }
	
	      var reText = term.replace(/(\\)?\*/g, function ($0, $1) { return $1 ? $0 : '[\\s\\S]*?'; });
	      return new RegExp('^' + reText + '$', regexpFlags);
	    }
	    // Otherwise default to default condition
	    else {
	      return defaultCondition;
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setupFilters
	   * @methodOf ui.grid.service:rowSearcher
	   * @description For a given columns filters (either col.filters, or [col.filter] can be passed in),
	   * do all the parsing and pre-processing and store that data into a new filters object.  The object
	   * has the condition, the flags, the stripped term, and a parsed reg exp if there was one.
	   *
	   * We could use a forEach in here, since it's much less performance sensitive, but since we're using
	   * for loops everywhere else in this module...
	   *
	   * @param {array} filters the filters from the column (col.filters or [col.filter])
	   * @returns {array} An array of parsed/preprocessed filters
	   */
	  rowSearcher.setupFilters = function setupFilters( filters ) {
	    var newFilters = [];
	
	    var filtersLength = filters.length;
	    for ( var i = 0; i < filtersLength; i++ ) {
	      var filter = filters[i];
	
	      if ( filter.noTerm || !gridUtil.isNullOrUndefined(filter.term) ) {
	        var newFilter = {};
	
	        var regexpFlags = '';
	        if (!filter.flags || !filter.flags.caseSensitive) {
	          regexpFlags += 'i';
	        }
	
	        if ( !gridUtil.isNullOrUndefined(filter.term) ) {
	          // it is possible to have noTerm.
	          if ( filter.rawTerm ) {
	            newFilter.term = filter.term;
	          } else {
	            newFilter.term = rowSearcher.stripTerm(filter);
	          }
	        }
	        newFilter.noTerm = filter.noTerm;
	
	        if ( filter.condition ) {
	          newFilter.condition = filter.condition;
	        } else {
	          newFilter.condition = rowSearcher.guessCondition(filter);
	        }
	
	        newFilter.flags = angular.extend( { caseSensitive: false, date: false }, filter.flags );
	
	        if (newFilter.condition === uiGridConstants.filter.STARTS_WITH) {
	          newFilter.startswithRE = new RegExp('^' + newFilter.term, regexpFlags);
	        }
	
	         if (newFilter.condition === uiGridConstants.filter.ENDS_WITH) {
	          newFilter.endswithRE = new RegExp(newFilter.term + '$', regexpFlags);
	        }
	
	        if (newFilter.condition === uiGridConstants.filter.CONTAINS) {
	          newFilter.containsRE = new RegExp(newFilter.term, regexpFlags);
	        }
	
	        if (newFilter.condition === uiGridConstants.filter.EXACT) {
	          newFilter.exactRE = new RegExp('^' + newFilter.term + '$', regexpFlags);
	        }
	
	        newFilters.push(newFilter);
	      }
	    }
	    return newFilters;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name runColumnFilter
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Runs a single pre-parsed filter against a cell, returning true
	   * if the cell matches that one filter.
	   *
	   * @param {Grid} grid the grid we're working against
	   * @param {GridRow} row the row we're matching against
	   * @param {GridColumn} column the column that we're working against
	   * @param {object} filter the specific, preparsed, filter that we want to test
	   * @returns {boolean} true if we match (row stays visible)
	   */
	  rowSearcher.runColumnFilter = function runColumnFilter(grid, row, column, filter) {
	    // Cache typeof condition
	    var conditionType = typeof(filter.condition);
	
	    // Term to search for.
	    var term = filter.term;
	
	    // Get the column value for this row
	    var value;
	    if ( column.filterCellFiltered ) {
	      value = grid.getCellDisplayValue(row, column);
	    } else {
	      value = grid.getCellValue(row, column);
	    }
	
	
	    // If the filter's condition is a RegExp, then use it
	    if (filter.condition instanceof RegExp) {
	      return filter.condition.test(value);
	    }
	
	    // If the filter's condition is a function, run it
	    if (conditionType === 'function') {
	      return filter.condition(term, value, row, column);
	    }
	
	    if (filter.startswithRE) {
	      return filter.startswithRE.test(value);
	    }
	
	    if (filter.endswithRE) {
	      return filter.endswithRE.test(value);
	    }
	
	    if (filter.containsRE) {
	      return filter.containsRE.test(value);
	    }
	
	    if (filter.exactRE) {
	      return filter.exactRE.test(value);
	    }
	
	    if (filter.condition === uiGridConstants.filter.NOT_EQUAL) {
	      var regex = new RegExp('^' + term + '$');
	      return !regex.exec(value);
	    }
	
	    if (typeof(value) === 'number' && typeof(term) === 'string' ) {
	      // if the term has a decimal in it, it comes through as '9\.4', we need to take out the \
	      // the same for negative numbers
	      // TODO: I suspect the right answer is to look at escapeRegExp at the top of this code file, maybe it's not needed?
	      var tempFloat = parseFloat(term.replace(/\\\./,'.').replace(/\\\-/,'-'));
	      if (!isNaN(tempFloat)) {
	        term = tempFloat;
	      }
	    }
	
	    if (filter.flags.date === true) {
	      value = new Date(value);
	      // If the term has a dash in it, it comes through as '\-' -- we need to take out the '\'.
	      term = new Date(term.replace(/\\/g, ''));
	    }
	
	    if (filter.condition === uiGridConstants.filter.GREATER_THAN) {
	      return (value > term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.GREATER_THAN_OR_EQUAL) {
	      return (value >= term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.LESS_THAN) {
	      return (value < term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.LESS_THAN_OR_EQUAL) {
	      return (value <= term);
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc boolean
	   * @name useExternalFiltering
	   * @propertyOf ui.grid.class:GridOptions
	   * @description False by default. When enabled, this setting suppresses the internal filtering.
	   * All UI logic will still operate, allowing filter conditions to be set and modified.
	   *
	   * The external filter logic can listen for the `filterChange` event, which fires whenever
	   * a filter has been adjusted.
	   */
	  /**
	   * @ngdoc function
	   * @name searchColumn
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Process provided filters on provided column against a given row. If the row meets
	   * the conditions on all the filters, return true.
	   * @param {Grid} grid Grid to search in
	   * @param {GridRow} row Row to search on
	   * @param {GridColumn} column Column with the filters to use
	   * @param {array} filters array of pre-parsed/preprocessed filters to apply
	   * @returns {boolean} Whether the column matches or not.
	   */
	  rowSearcher.searchColumn = function searchColumn(grid, row, column, filters) {
	    if (grid.options.useExternalFiltering) {
	      return true;
	    }
	
	    var filtersLength = filters.length;
	    for (var i = 0; i < filtersLength; i++) {
	      var filter = filters[i];
	
	      if ( !gridUtil.isNullOrUndefined(filter.term) && filter.term !== '' || filter.noTerm ) {
	        var ret = rowSearcher.runColumnFilter(grid, row, column, filter);
	        if (!ret) {
	          return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name search
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Run a search across the given rows and columns, marking any rows that don't
	   * match the stored col.filters or col.filter as invisible.
	   * @param {Grid} grid Grid instance to search inside
	   * @param {Array[GridRow]} rows GridRows to filter
	   * @param {Array[GridColumn]} columns GridColumns with filters to process
	   */
	  rowSearcher.search = function search(grid, rows, columns) {
	    /*
	     * Added performance optimisations into this code base, as this logic creates deeply nested
	     * loops and is therefore very performance sensitive.  In particular, avoiding forEach as
	     * this impacts some browser optimisers (particularly Chrome), using iterators instead
	     */
	
	    // Don't do anything if we weren't passed any rows
	    if (!rows) {
	      return;
	    }
	
	    // don't filter if filtering currently disabled
	    if (!grid.options.enableFiltering) {
	      return rows;
	    }
	
	    // Build list of filters to apply
	    var filterData = [];
	
	    var colsLength = columns.length;
	
	    var hasTerm = function( filters ) {
	      var hasTerm = false;
	
	      filters.forEach( function (filter) {
	        if ( !gridUtil.isNullOrUndefined(filter.term) && filter.term !== '' || filter.noTerm ) {
	          hasTerm = true;
	        }
	      });
	
	      return hasTerm;
	    };
	
	    for (var i = 0; i < colsLength; i++) {
	      var col = columns[i];
	
	      if (typeof(col.filters) !== 'undefined' && hasTerm(col.filters) ) {
	        filterData.push( { col: col, filters: rowSearcher.setupFilters(col.filters) } );
	      }
	    }
	
	    if (filterData.length > 0) {
	      // define functions outside the loop, performance optimisation
	      var foreachRow = function(grid, row, col, filters) {
	        if ( row.visible && !rowSearcher.searchColumn(grid, row, col, filters) ) {
	          row.visible = false;
	        }
	      };
	
	      var foreachFilterCol = function(grid, filterData) {
	        var rowsLength = rows.length;
	        for ( var i = 0; i < rowsLength; i++) {
	          foreachRow(grid, rows[i], filterData.col, filterData.filters);
	        }
	      };
	
	      // nested loop itself - foreachFilterCol, which in turn calls foreachRow
	      var filterDataLength = filterData.length;
	      for ( var j = 0; j < filterDataLength; j++) {
	        foreachFilterCol( grid, filterData[j] );
	      }
	
	      if (grid.api.core.raise.rowsVisibleChanged) {
	        grid.api.core.raise.rowsVisibleChanged();
	      }
	
	      // drop any invisible rows
	      // keeping these, as needed with filtering for trees - we have to come back and make parent nodes visible if child nodes are selected in the filter
	      // rows = rows.filter(function(row) { return row.visible; });
	
	    }
	
	    return rows;
	  };
	
	  return rowSearcher;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	/**
	 * @ngdoc object
	 * @name ui.grid.class:rowSorter
	 * @description rowSorter provides the default sorting mechanisms,
	 * including guessing column types and applying appropriate sort
	 * algorithms
	 *
	 */
	
	module.service('rowSorter', ['$parse', 'uiGridConstants', function ($parse, uiGridConstants) {
	  var currencyRegexStr =
	    '(' +
	    uiGridConstants.CURRENCY_SYMBOLS
	      .map(function (a) { return '\\' + a; }) // Escape all the currency symbols ($ at least will jack up this regex)
	      .join('|') + // Join all the symbols together with |s
	    ')?';
	
	  // /^[-+]?[£$¤¥]?[\d,.]+%?$/
	  var numberStrRegex = new RegExp('^[-+]?' + currencyRegexStr + '[\\d,.]+' + currencyRegexStr + '%?$');
	
	  var rowSorter = {
	    // Cache of sorting functions. Once we create them, we don't want to keep re-doing it
	    //   this takes a piece of data from the cell and tries to determine its type and what sorting
	    //   function to use for it
	    colSortFnCache: {}
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name guessSortFn
	   * @description Assigns a sort function to use based on the itemType in the column
	   * @param {string} itemType one of 'number', 'boolean', 'string', 'date', 'object'.  And
	   * error will be thrown for any other type.
	   * @returns {function} a sort function that will sort that type
	   */
	  rowSorter.guessSortFn = function guessSortFn(itemType) {
	    switch (itemType) {
	      case "number":
	        return rowSorter.sortNumber;
	      case "numberStr":
	        return rowSorter.sortNumberStr;
	      case "boolean":
	        return rowSorter.sortBool;
	      case "string":
	        return rowSorter.sortAlpha;
	      case "date":
	        return rowSorter.sortDate;
	      case "object":
	        return rowSorter.basicSort;
	      default:
	        throw new Error('No sorting function found for type: ' + itemType);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name handleNulls
	   * @description Sorts nulls and undefined to the bottom (top when
	   * descending).  Called by each of the internal sorters before
	   * attempting to sort.  Note that this method is available on the core api
	   * via gridApi.core.sortHandleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} null if there were no nulls/undefineds, otherwise returns
	   * a sort value that should be passed back from the sort function
	   */
	  rowSorter.handleNulls = function handleNulls(a, b) {
	    // We want to allow zero values and false values to be evaluated in the sort function
	    if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
	      // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
	      if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
	        return 0;
	      }
	      else if (!a && a !== 0 && a !== false) {
	        return 1;
	      }
	      else if (!b && b !== 0 && b !== false) {
	        return -1;
	      }
	    }
	    return null;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name basicSort
	   * @description Sorts any values that provide the < method, including strings
	   * or numbers.  Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.basicSort = function basicSort(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ) {
	      return nulls;
	    } else {
	      if (a === b) {
	        return 0;
	      }
	      if (a < b) {
	        return -1;
	      }
	      return 1;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortNumber
	   * @description Sorts numerical values.  Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumber = function sortNumber(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ) {
	      return nulls;
	    } else {
	      return a - b;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortNumberStr
	   * @description Sorts numerical values that are stored in a string (i.e. parses them to numbers first).
	   * Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumberStr = function sortNumberStr(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ) {
	      return nulls;
	    } else {
	      var numA, // The parsed number form of 'a'
	          numB, // The parsed number form of 'b'
	          badA = false,
	          badB = false;
	
	      // Try to parse 'a' to a float
	      numA = parseFloat(a.replace(/[^0-9.-]/g, ''));
	
	      // If 'a' couldn't be parsed to float, flag it as bad
	      if (isNaN(numA)) {
	          badA = true;
	      }
	
	      // Try to parse 'b' to a float
	      numB = parseFloat(b.replace(/[^0-9.-]/g, ''));
	
	      // If 'b' couldn't be parsed to float, flag it as bad
	      if (isNaN(numB)) {
	          badB = true;
	      }
	
	      // We want bad ones to get pushed to the bottom... which effectively is "greater than"
	      if (badA && badB) {
	          return 0;
	      }
	
	      if (badA) {
	          return 1;
	      }
	
	      if (badB) {
	          return -1;
	      }
	
	      return numA - numB;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortAlpha
	   * @description Sorts string values. Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortAlpha = function sortAlpha(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ) {
	      return nulls;
	    } else {
	      var strA = a.toString().toLowerCase(),
	          strB = b.toString().toLowerCase();
	
	      return strA === strB ? 0 : strA.localeCompare(strB);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortDate
	   * @description Sorts date values. Handles nulls and undefined through calling handleNulls.
	   * Handles date strings by converting to Date object if not already an instance of Date
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortDate = function sortDate(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ) {
	      return nulls;
	    } else {
	      if (!(a instanceof Date)) {
	        a = new Date(a);
	      }
	      if (!(b instanceof Date)) {
	        b = new Date(b);
	      }
	      var timeA = a.getTime(),
	          timeB = b.getTime();
	
	      return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortBool
	   * @description Sorts boolean values, true is considered larger than false.
	   * Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortBool = function sortBool(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ) {
	      return nulls;
	    } else {
	      if (a && b) {
	        return 0;
	      }
	
	      if (!a && !b) {
	        return 0;
	      }
	      else {
	        return a ? 1 : -1;
	      }
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name getSortFn
	   * @description Get the sort function for the column.  Looks first in
	   * rowSorter.colSortFnCache using the column name, failing that it
	   * looks at col.sortingAlgorithm (and puts it in the cache), failing that
	   * it guesses the sort algorithm based on the data type.
	   *
	   * The cache currently seems a bit pointless, as none of the work we do is
	   * processor intensive enough to need caching.  Presumably in future we might
	   * inspect the row data itself to guess the sort function, and in that case
	   * it would make sense to have a cache, the infrastructure is in place to allow
	   * that.
	   *
	   * @param {Grid} grid the grid to consider
	   * @param {GridColumn} col the column to find a function for
	   * @param {array} rows an array of grid rows.  Currently unused, but presumably in future
	   * we might inspect the rows themselves to decide what sort of data might be there
	   * @returns {function} the sort function chosen for the column
	   */
	  rowSorter.getSortFn = function getSortFn(grid, col, rows) {
	    var sortFn, item;
	
	    // See if we already figured out what to use to sort the column and have it in the cache
	    if (rowSorter.colSortFnCache[col.colDef.name]) {
	      sortFn = rowSorter.colSortFnCache[col.colDef.name];
	    }
	    // If the column has its OWN sorting algorithm, use that
	    else if (col.sortingAlgorithm !== undefined) {
	      sortFn = col.sortingAlgorithm;
	      rowSorter.colSortFnCache[col.colDef.name] = col.sortingAlgorithm;
	    }
	    // Always default to sortAlpha when sorting after a cellFilter
	    else if ( col.sortCellFiltered && col.cellFilter ) {
	      sortFn = rowSorter.sortAlpha;
	      rowSorter.colSortFnCache[col.colDef.name] = sortFn;
	    }
	    // Try and guess what sort function to use
	    else {
	      // Guess the sort function
	      sortFn = rowSorter.guessSortFn(col.colDef.type);
	
	      // If we found a sort function, cache it
	      if (sortFn) {
	        rowSorter.colSortFnCache[col.colDef.name] = sortFn;
	      }
	      else {
	        // We assign the alpha sort because anything that is null/undefined will never get passed to
	        // the actual sorting function. It will get caught in our null check and returned to be sorted
	        // down to the bottom
	        sortFn = rowSorter.sortAlpha;
	      }
	    }
	
	    return sortFn;
	  };
	
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name prioritySort
	   * @description Used where multiple columns are present in the sort criteria,
	   * we determine which column should take precedence in the sort by sorting
	   * the columns based on their sort.priority
	   *
	   * @param {gridColumn} a column a
	   * @param {gridColumn} b column b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.prioritySort = function (a, b) {
	    // Both columns have a sort priority
	    if (a.sort && a.sort.priority !== undefined && b.sort && b.sort.priority !== undefined) {
	      // A is higher priority
	      if (a.sort.priority < b.sort.priority) {
	        return -1;
	      }
	      // Equal
	      else if (a.sort.priority === b.sort.priority) {
	        return 0;
	      }
	      // B is higher
	      else {
	        return 1;
	      }
	    }
	    // Only A has a priority
	    else if (a.sort && a.sort.priority !== undefined) {
	      return -1;
	    }
	    // Only B has a priority
	    else if (b.sort && b.sort.priority !== undefined) {
	      return 1;
	    }
	    // Neither has a priority
	    else {
	      return 0;
	    }
	  };
	
	
	  /**
	   * @ngdoc object
	   * @name useExternalSorting
	   * @propertyOf ui.grid.class:GridOptions
	   * @description Prevents the internal sorting from executing.  Events will
	   * still be fired when the sort changes, and the sort information on
	   * the columns will be updated, allowing an external sorter (for example,
	   * server sorting) to be implemented.  Defaults to false.
	   *
	   */
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sort
	   * @description sorts the grid
	   * @param {Object} grid the grid itself
	   * @param {array} rows the rows to be sorted
	   * @param {array} columns the columns in which to look
	   * for sort criteria
	   * @returns {array} sorted rows
	   */
	  rowSorter.sort = function rowSorterSort(grid, rows, columns) {
	    // first make sure we are even supposed to do work
	    if (!rows) {
	      return;
	    }
	
	    if (grid.options.useExternalSorting) {
	      return rows;
	    }
	
	    // Build the list of columns to sort by
	    var sortCols = [];
	    var defaultSortCols = [];
	    columns.forEach(function (col) {
	      if (col.sort && !col.sort.ignoreSort && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortCols.push({
	          col: col,
	          sort: col.sort
	        });
	      } else if ( col.defaultSort && col.defaultSort.direction && (col.defaultSort.direction === uiGridConstants.ASC || col.defaultSort.direction === uiGridConstants.DESC) ) {
	        defaultSortCols.push({
	          col: col,
	          sort: col.defaultSort
	        });
	      }
	    });
	
	    // Sort the "sort columns" by their sort priority
	    sortCols = sortCols.sort(rowSorter.prioritySort);
	    defaultSortCols = defaultSortCols.sort(rowSorter.prioritySort);
	    sortCols = sortCols.concat(defaultSortCols);
	
	    // Now rows to sort by, maintain original order
	    if (sortCols.length === 0) {
	      return rows;
	    }
	
	    // Re-usable variables
	    var col, direction;
	
	    // put a custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    var setIndex = function( row, idx ) {
	      row.entity.$$uiGridIndex = idx;
	    };
	    rows.forEach(setIndex);
	
	    // IE9-11 HACK.... the 'rows' variable would be empty where we call rowSorter.getSortFn(...) below. We have to use a separate reference
	    // var d = data.slice(0);
	    var r = rows.slice(0);
	
	    // Now actually sort the data
	    var rowSortFn = function (rowA, rowB) {
	      var tem = 0,
	          idx = 0,
	          sortFn;
	
	      while (tem === 0 && idx < sortCols.length) {
	        // grab the metadata for the rest of the logic
	        col = sortCols[idx].col;
	        direction = sortCols[idx].sort.direction;
	
	        sortFn = rowSorter.getSortFn(grid, col, r);
	
	        // Webpack's compress will hoist and combine propA, propB into one var and break sorting functionality
	        // Wrapping in function prevents that unexpected behavior
	        var props = getCellValues(grid, rowA, rowB, col);
	        var propA = props[0];
	        var propB = props[1];
	        tem = sortFn(propA, propB, rowA, rowB, direction, col);
	
	        idx++;
	      }
	
	      // Chrome doesn't implement a stable sort function.  If our sort returns 0
	      // (i.e. the items are equal), and we're at the last sort column in the list,
	      // then return the previous order using our custom
	      // index variable
	      if (tem === 0 ) {
	        return rowA.entity.$$uiGridIndex - rowB.entity.$$uiGridIndex;
	      }
	
	      // Made it this far, we don't have to worry about null & undefined
	      if (direction === uiGridConstants.ASC) {
	        return tem;
	      } else {
	        return 0 - tem;
	      }
	    };
	
	    var newRows = rows.sort(rowSortFn);
	
	    // remove the custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    var clearIndex = function( row, idx ) {
	       delete row.entity.$$uiGridIndex;
	    };
	    rows.forEach(clearIndex);
	
	    return newRows;
	  };
	
	  function getCellValues(grid, rowA, rowB, col) {
	    var propA, propB;
	
	    if ( col.sortCellFiltered ) {
	      propA = grid.getCellDisplayValue(rowA, col);
	      propB = grid.getCellDisplayValue(rowB, col);
	    } else {
	      propA = grid.getCellValue(rowA, col);
	      propB = grid.getCellValue(rowB, col);
	    }
	
	    return [propA, propB];
	  }
	
	  return rowSorter;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	var bindPolyfill;
	if (typeof Function.prototype.bind !== "function") {
	  bindPolyfill = function() {
	    var slice = Array.prototype.slice;
	    return function(context) {
	      var fn = this,
	        args = slice.call(arguments, 1);
	      if (args.length) {
	        return function() {
	          return arguments.length ? fn.apply(context, args.concat(slice.call(arguments))) : fn.apply(context, args);
	        };
	      }
	      return function() {
	        return arguments.length ? fn.apply(context, arguments) : fn.call(context);
	      };
	    };
	  };
	}
	
	function  getStyles (elem) {
	  var e = elem;
	  if (typeof(e.length) !== 'undefined' && e.length) {
	    e = elem[0];
	  }
	
	  return e.ownerDocument.defaultView.getComputedStyle(e, null);
	}
	
	var rnumnonpx = new RegExp( "^(" + (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source + ")(?!px)[a-z%]+$", "i" ),
	    // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	    // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	    rdisplayswap = /^(block|none|table(?!-c[ea]).+)/,
	    cssShow = { position: "absolute", visibility: "hidden", display: "block" };
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	  var i = extra === ( isBorderBox ? 'border' : 'content' ) ?
	          // If we already have the right measurement, avoid augmentation
	          4 :
	          // Otherwise initialize for horizontal or vertical properties
	          name === 'width' ? 1 : 0,
	
	          val = 0;
	
	  var sides = ['Top', 'Right', 'Bottom', 'Left'];
	
	  for ( ; i < 4; i += 2 ) {
	    var side = sides[i];
	    // dump('side', side);
	
	    // both box models exclude margin, so add it if we want it
	    if ( extra === 'margin' ) {
	      var marg = parseFloat(styles[extra + side]);
	      if (!isNaN(marg)) {
	        val += marg;
	      }
	    }
	    // dump('val1', val);
	
	    if ( isBorderBox ) {
	      // border-box includes padding, so remove it if we want content
	      if ( extra === 'content' ) {
	        var padd = parseFloat(styles['padding' + side]);
	        if (!isNaN(padd)) {
	          val -= padd;
	          // dump('val2', val);
	        }
	      }
	
	      // at this point, extra isn't border nor margin, so remove border
	      if ( extra !== 'margin' ) {
	        var bordermarg = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(bordermarg)) {
	          val -= bordermarg;
	          // dump('val3', val);
	        }
	      }
	    }
	    else {
	      // at this point, extra isn't content, so add padding
	      var nocontentPad = parseFloat(styles['padding' + side]);
	      if (!isNaN(nocontentPad)) {
	        val += nocontentPad;
	        // dump('val4', val);
	      }
	
	      // at this point, extra isn't content nor padding, so add border
	      if ( extra !== 'padding') {
	        var nocontentnopad = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(nocontentnopad)) {
	          val += nocontentnopad;
	          // dump('val5', val);
	        }
	      }
	    }
	  }
	
	  // dump('augVal', val);
	
	  return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	  // Start with offset property, which is equivalent to the border-box value
	  var valueIsBorderBox = true,
	          val, // = name === 'width' ? elem.offsetWidth : elem.offsetHeight,
	          styles = getStyles(elem),
	          isBorderBox = styles['boxSizing'] === 'border-box';
	
	  // some non-html elements return undefined for offsetWidth, so check for null/undefined
	  // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	  // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	  if ( val <= 0 || val == null ) {
	    // Fall back to computed then uncomputed css if necessary
	    val = styles[name];
	    if ( val < 0 || val == null ) {
	      val = elem.style[ name ];
	    }
	
	    // Computed unit is not pixels. Stop here and return.
	    if ( rnumnonpx.test(val) ) {
	      return val;
	    }
	
	    // we need the check for style in case a browser which returns unreliable values
	    // for getComputedStyle silently falls back to the reliable elem.style
	    valueIsBorderBox = isBorderBox &&
	            ( true || val === elem.style[ name ] ); // use 'true' instead of 'support.boxSizingReliable()'
	
	    // Normalize "", auto, and prepare for extra
	    val = parseFloat( val ) || 0;
	  }
	
	  // use the active box-sizing model to add/subtract irrelevant styles
	  var ret = ( val +
	    augmentWidthOrHeight(
	      elem,
	      name,
	      extra || ( isBorderBox ? "border" : "content" ),
	      valueIsBorderBox,
	      styles
	    )
	  );
	
	  // dump('ret', ret, val);
	  return ret;
	}
	
	function getLineHeight(elm) {
	  elm = angular.element(elm)[0];
	  var parent = elm.parentElement;
	
	  if (!parent) {
	    parent = document.getElementsByTagName('body')[0];
	  }
	
	  return parseInt( getStyles(parent).fontSize ) || parseInt( getStyles(elm).fontSize ) || 16;
	}
	
	var uid = ['0', '0', '0', '0'];
	var uidPrefix = 'uiGrid-';
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:GridUtil
	 *
	 *  @description Grid utility functions
	 */
	module.service('gridUtil', ['$log', '$window', '$document', '$http', '$templateCache', '$timeout', '$interval', '$injector', '$q', '$interpolate', 'uiGridConstants',
	  function ($log, $window, $document, $http, $templateCache, $timeout, $interval, $injector, $q, $interpolate, uiGridConstants) {
	  var s = {
	
	    augmentWidthOrHeight: augmentWidthOrHeight,
	
	    getStyles: getStyles,
	
	    /**
	     * @ngdoc method
	     * @name createBoundedWrapper
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {object} object to bind 'this' to
	     * @param {method} method to bind
	     * @returns {Function} The wrapper that performs the binding
	     *
	     * @description
	     * Binds given method to given object.
	     *
	     * By means of a wrapper, ensures that ``method`` is always bound to
	     * ``object`` regardless of its calling environment.
	     * Iow, inside ``method``, ``this`` always points to ``object``.
	     *
	     * See http://alistapart.com/article/getoutbindingsituations
	     *
	     */
	    createBoundedWrapper: function(object, method) {
	        return function() {
	            return method.apply(object, arguments);
	        };
	    },
	
	
	    /**
	     * @ngdoc method
	     * @name readableColumnName
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} columnName Column name as a string
	     * @returns {string} Column name appropriately capitalized and split apart
	     *
	       @example
	       <example module="app">
	        <file name="app.js">
	          var app = angular.module('app', ['ui.grid']);
	
	          app.controller('MainCtrl', ['$scope', 'gridUtil', function ($scope, gridUtil) {
	            $scope.name = 'firstName';
	            $scope.columnName = function(name) {
	              return gridUtil.readableColumnName(name);
	            };
	          }]);
	        </file>
	        <file name="index.html">
	          <div ng-controller="MainCtrl">
	            <strong>Column name:</strong> <input ng-model="name" />
	            <br>
	            <strong>Output:</strong> <span ng-bind="columnName(name)"></span>
	          </div>
	        </file>
	      </example>
	     */
	    readableColumnName: function (columnName) {
	      // Convert underscores to spaces
	      if (typeof(columnName) === 'undefined' || columnName === undefined || columnName === null) { return columnName; }
	
	      if (typeof(columnName) !== 'string') {
	        columnName = String(columnName);
	      }
	
	      return columnName.replace(/_+/g, ' ')
	        // Replace a completely all-capsed word with a first-letter-capitalized version
	        .replace(/^[A-Z]+$/, function (match) {
	          return match.toLowerCase();
	        })
	        // Capitalize the first letter of words
	        .replace(/([\w\u00C0-\u017F]+)/g, function (match) {
	          return match.charAt(0).toUpperCase() + match.slice(1);
	        })
	        // Put a space in between words that have partial capilizations (i.e. 'firstName' becomes 'First Name')
	        // .replace(/([A-Z]|[A-Z]\w+)([A-Z])/g, "$1 $2");
	        // .replace(/(\w+?|\w)([A-Z])/g, "$1 $2");
	        .replace(/(\w+?(?=[A-Z]))/g, '$1 ');
	    },
	
	    /**
	     * @ngdoc method
	     * @name getColumnsFromData
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a list of column names, given a data set
	     *
	     * @param {string} data Data array for grid
	     * @returns {Object} Column definitions with field accessor and column name
	     *
	     * @example
	       <pre>
	         var data = [
	           { firstName: 'Bob', lastName: 'Jones' },
	           { firstName: 'Frank', lastName: 'Smith' }
	         ];
	
	         var columnDefs = GridUtil.getColumnsFromData(data, excludeProperties);
	
	         columnDefs == [
	          {
	            field: 'firstName',
	            name: 'First Name'
	          },
	          {
	            field: 'lastName',
	            name: 'Last Name'
	          }
	         ];
	       </pre>
	     */
	    getColumnsFromData: function (data, excludeProperties) {
	      var columnDefs = [];
	
	      if (!data || typeof(data[0]) === 'undefined' || data[0] === undefined) { return []; }
	      if (angular.isUndefined(excludeProperties)) { excludeProperties = []; }
	
	      var item = data[0];
	
	      angular.forEach(item,function (prop, propName) {
	        if ( excludeProperties.indexOf(propName) === -1) {
	          columnDefs.push({
	            name: propName
	          });
	        }
	      });
	
	      return columnDefs;
	    },
	
	    /**
	     * @ngdoc method
	     * @name newId
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a unique ID string
	     *
	     * @returns {string} Unique string
	     *
	     * @example
	       <pre>
	        var id = GridUtil.newId();
	
	        # 1387305700482;
	       </pre>
	     */
	    newId: (function() {
	      var seedId = new Date().getTime();
	      return function() {
	          return seedId += 1;
	      };
	    })(),
	
	
	    /**
	     * @ngdoc method
	     * @name getTemplate
	     * @methodOf ui.grid.service:GridUtil
	     * @description Get's template from cache / element / url
	     *
	     * @param {string|element|promise} template Either a string representing the template id, a string representing the template url,
	     *   an jQuery/Angualr element, or a promise that returns the template contents to use.
	     * @returns {object} a promise resolving to template contents
	     *
	     * @example
	     <pre>
	     GridUtil.getTemplate(url).then(function (contents) {
	          alert(contents);
	        })
	     </pre>
	     */
	    getTemplate: function (template) {
	      // Try to fetch the template out of the templateCache
	      if ($templateCache.get(template)) {
	        return s.postProcessTemplate($templateCache.get(template));
	      }
	
	      // See if the template is itself a promise
	      if (angular.isFunction(template.then)) {
	        return template.then(s.postProcessTemplate).catch(angular.noop);
	      }
	
	      // If the template is an element, return the element
	      try {
	        if (angular.element(template).length > 0) {
	          return $q.when(template).then(s.postProcessTemplate).catch(angular.noop);
	        }
	      }
	      catch (err) {
	        // do nothing; not valid html
	      }
	
	      // s.logDebug('fetching url', template);
	
	      // Default to trying to fetch the template as a url with $http
	      return $http({ method: 'GET', url: template})
	        .then(
	          function (result) {
	            var templateHtml = result.data.trim();
	            // put in templateCache for next call
	            $templateCache.put(template, templateHtml);
	            return templateHtml;
	          },
	          function (err) {
	            throw new Error("Could not get template " + template + ": " + err);
	          }
	        )
	        .then(s.postProcessTemplate).catch(angular.noop);
	    },
	
	    //
	    postProcessTemplate: function (template) {
	      var startSym = $interpolate.startSymbol(),
	          endSym = $interpolate.endSymbol();
	
	      // If either of the interpolation symbols have been changed, we need to alter this template
	      if (startSym !== '{{' || endSym !== '}}') {
	        template = template.replace(/\{\{/g, startSym);
	        template = template.replace(/\}\}/g, endSym);
	      }
	
	      return $q.when(template);
	    },
	
	    /**
	     * @ngdoc method
	     * @name guessType
	     * @methodOf ui.grid.service:GridUtil
	     * @description guesses the type of an argument
	     *
	     * @param {string/number/bool/object} item variable to examine
	     * @returns {string} one of the following
	     * - 'string'
	     * - 'boolean'
	     * - 'number'
	     * - 'date'
	     * - 'object'
	     */
	    guessType : function (item) {
	      var itemType = typeof(item);
	
	      // Check for numbers and booleans
	      switch (itemType) {
	        case "number":
	        case "boolean":
	        case "string":
	          return itemType;
	        default:
	          if (angular.isDate(item)) {
	            return "date";
	          }
	          return "object";
	      }
	    },
	
	
	  /**
	    * @ngdoc method
	    * @name elementWidth
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} elem DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element width in pixels, accounting for any borders, etc.
	    */
	    elementWidth: function (elem) {
	
	    },
	
	    /**
	    * @ngdoc method
	    * @name elementHeight
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} elem DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element height in pixels, accounting for any borders, etc.
	    */
	    elementHeight: function (elem) {
	
	    },
	
	    isVisible: function (elem) {
	      return !!( elem[0].offsetWidth || elem[0].offsetHeight || elem[0].getClientRects().length )
	    },
	
	    // Thanks to http://stackoverflow.com/a/13382873/888165
	    getScrollbarWidth: function() {
	        var outer = document.createElement("div");
	
	        outer.style.visibility = "hidden";
	        outer.style.width = "100px";
	        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	
	        document.body.appendChild(outer);
	
	        var widthNoScroll = outer.offsetWidth;
	        // force scrollbars
	        outer.style.overflow = "scroll";
	        outer.style.position = "absolute"; // force Firefox to draw a scrollbar
	
	        // add innerdiv
	        var inner = document.createElement("div");
	        inner.style.width = "100%";
	        outer.appendChild(inner);
	
	        var widthWithScroll = inner.offsetWidth;
	
	        // remove divs
	        outer.parentNode.removeChild(outer);
	
	        return widthNoScroll - widthWithScroll;
	    },
	
	    swap: function( elem, options, callback, args ) {
	      var ret, name,
	              old = {};
	
	      // Remember the old values, and insert the new ones
	      for ( name in options ) {
	        old[ name ] = elem.style[ name ];
	        elem.style[ name ] = options[ name ];
	      }
	
	      ret = callback.apply( elem, args || [] );
	
	      // Revert the old values
	      for ( name in options ) {
	        elem.style[ name ] = old[ name ];
	      }
	
	      return ret;
	    },
	
	    fakeElement: function( elem, options, callback, args ) {
	      var ret, name,
	          newElement = angular.element(elem).clone()[0];
	
	      for ( name in options ) {
	        newElement.style[ name ] = options[ name ];
	      }
	
	      angular.element(document.body).append(newElement);
	
	      ret = callback.call( newElement, newElement );
	
	      angular.element(newElement).remove();
	
	      return ret;
	    },
	
	    /**
	    * @ngdoc method
	    * @name normalizeWheelEvent
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {event} event A mouse wheel event
	    *
	    * @returns {event} A normalized event
	    *
	    * @description
	    * Given an event from this list:
	    *
	    * `wheel, mousewheel, DomMouseScroll, MozMousePixelScroll`
	    *
	    * "normalize" it
	    * so that it stays consistent no matter what browser it comes from (i.e. scale it correctly and make sure the direction is right.)
	    */
	    normalizeWheelEvent: function (event) {
	      // var toFix = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'];
	      // var toBind = 'onwheel' in document || document.documentMode >= 9 ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'];
	      var lowestDelta, lowestDeltaXY;
	
	      var orgEvent   = event || window.event,
	          args       = [].slice.call(arguments, 1),
	          delta      = 0,
	          deltaX     = 0,
	          deltaY     = 0,
	          absDelta   = 0,
	          absDeltaXY = 0,
	          fn;
	
	      // event = $.event.fix(orgEvent);
	      // event.type = 'mousewheel';
	
	      // NOTE: jQuery masks the event and stores it in the event as originalEvent
	      if (orgEvent.originalEvent) {
	        orgEvent = orgEvent.originalEvent;
	      }
	
	      // Old school scrollwheel delta
	      if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta; }
	      if ( orgEvent.detail )     { delta = orgEvent.detail * -1; }
	
	      // At a minimum, setup the deltaY to be delta
	      deltaY = delta;
	
	      // Firefox < 17 related to DOMMouseScroll event
	      if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
	          deltaY = 0;
	          deltaX = delta * -1;
	      }
	
	      // New school wheel delta (wheel event)
	      if ( orgEvent.deltaY ) {
	          deltaY = orgEvent.deltaY * -1;
	          delta  = deltaY;
	      }
	      if ( orgEvent.deltaX ) {
	          deltaX = orgEvent.deltaX;
	          delta  = deltaX * -1;
	      }
	
	      // Webkit
	      if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY; }
	      if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = orgEvent.wheelDeltaX; }
	
	      // Look for lowest delta to normalize the delta values
	      absDelta = Math.abs(delta);
	      if ( !lowestDelta || absDelta < lowestDelta ) { lowestDelta = absDelta; }
	      absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
	      if ( !lowestDeltaXY || absDeltaXY < lowestDeltaXY ) { lowestDeltaXY = absDeltaXY; }
	
	      // Get a whole value for the deltas
	      fn     = delta > 0 ? 'floor' : 'ceil';
	      delta  = Math[fn](delta  / lowestDelta);
	      deltaX = Math[fn](deltaX / lowestDeltaXY);
	      deltaY = Math[fn](deltaY / lowestDeltaXY);
	
	      return {
	        delta: delta,
	        deltaX: deltaX,
	        deltaY: deltaY
	      };
	    },
	
	    // Stolen from Modernizr
	    // TODO: make this, and everythign that flows from it, robust
	    // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
	    isTouchEnabled: function() {
	      var bool;
	
	      if (('ontouchstart' in $window) || $window.DocumentTouch && $document instanceof DocumentTouch) {
	        bool = true;
	      }
	
	      return bool;
	    },
	
	    isNullOrUndefined: function(obj) {
	      return (obj === undefined || obj === null);
	    },
	
	    endsWith: function(str, suffix) {
	      if (!str || !suffix || typeof str !== "string") {
	        return false;
	      }
	      return str.indexOf(suffix, str.length - suffix.length) !== -1;
	    },
	
	    arrayContainsObjectWithProperty: function(array, propertyName, propertyValue) {
	        var found = false;
	        angular.forEach(array, function (object) {
	            if (object[propertyName] === propertyValue) {
	                found = true;
	            }
	        });
	        return found;
	    },
	
	    numericAndNullSort: function (a, b) {
	      if (a === null) { return 1; }
	      if (b === null) { return -1; }
	      if (a === null && b === null) { return 0; }
	      return a - b;
	    },
	
	    // Disable ngAnimate animations on an element
	    disableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, false);
	        } else {
	          $animate.enabled(false, element);
	        }
	      }
	      catch (e) {}
	    },
	
	    enableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, true);
	        } else {
	          $animate.enabled(true, element);
	        }
	        return $animate;
	      }
	      catch (e) {}
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet)
	    nextUid: function nextUid() {
	      var index = uid.length;
	      var digit;
	
	      while (index) {
	        index--;
	        digit = uid[index].charCodeAt(0);
	        if (digit === 57 /*'9'*/) {
	          uid[index] = 'A';
	          return uidPrefix + uid.join('');
	        }
	        if (digit === 90  /*'Z'*/) {
	          uid[index] = '0';
	        } else {
	          uid[index] = String.fromCharCode(digit + 1);
	          return uidPrefix + uid.join('');
	        }
	      }
	      uid.unshift('0');
	
	      return uidPrefix + uid.join('');
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet)
	    hashKey: function hashKey(obj) {
	      var objType = typeof obj,
	          key;
	
	      if (objType === 'object' && obj !== null) {
	        if (typeof (key = obj.$$hashKey) === 'function') {
	          // must invoke on object to keep the right this
	          key = obj.$$hashKey();
	        }
	        else if (typeof(obj.$$hashKey) !== 'undefined' && obj.$$hashKey) {
	          key = obj.$$hashKey;
	        }
	        else if (key === undefined) {
	          key = obj.$$hashKey = s.nextUid();
	        }
	      }
	      else {
	        key = obj;
	      }
	
	      return objType + ': ' + key;
	    },
	
	    resetUids: function () {
	      uid = ['0', '0', '0'];
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logError
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * error messages if uiGridConstants.LOG_ERROR_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logError: function( logMessage ) {
	      if ( uiGridConstants.LOG_ERROR_MESSAGES ) {
	        $log.error( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logWarn
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * warning messages if uiGridConstants.LOG_WARN_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logWarn: function( logMessage ) {
	      if ( uiGridConstants.LOG_WARN_MESSAGES ) {
	        $log.warn( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logDebug
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * debug messages if uiGridConstants.LOG_DEBUG_MESSAGES is set to true
	     *
	     */
	    logDebug: function() {
	      if ( uiGridConstants.LOG_DEBUG_MESSAGES ) {
	        $log.debug.apply($log, arguments);
	      }
	    }
	
	  };
	
	  /**
	   * @ngdoc object
	   * @name focus
	   * @propertyOf ui.grid.service:GridUtil
	   * @description Provides a set of methods to set the document focus inside the grid.
	   * See {@link ui.grid.service:GridUtil.focus} for more information.
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.service:GridUtil.focus
	   * @description Provides a set of methods to set the document focus inside the grid.
	   * Timeouts are utilized to ensure that the focus is invoked after any other event has been triggered.
	   * e.g. click events that need to run before the focus or
	   * inputs elements that are in a disabled state but are enabled when those events
	   * are triggered.
	   */
	  s.focus = {
	    queue: [],
	    // http://stackoverflow.com/questions/25596399/set-element-focus-in-angular-way
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byId
	     * @description Sets the focus of the document to the given id value.
	     * If provided with the grid object it will automatically append the grid id.
	     * This is done to encourage unique dom id's as it allows for multiple grids on a
	     * page.
	     * @param {String} id the id of the dom element to set the focus on
	     * @param {Object=} Grid the grid object for this grid instance. See: {@link ui.grid.class:Grid}
	     * @param {Number} Grid.id the unique id for this grid. Already set on an initialized grid object.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byId: function (id, Grid) {
	      this._purgeQueue();
	      var promise = $timeout(function() {
	        var elementID = (Grid && Grid.id ? Grid.id + '-' : '') + id;
	        var element = $window.document.getElementById(elementID);
	        if (element) {
	          element.focus();
	        } else {
	          s.logWarn('[focus.byId] Element id ' + elementID + ' was not found.');
	        }
	      }, 0, false);
	      this.queue.push(promise);
	      return promise;
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byElement
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} element the DOM element to set the focus on
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byElement: function(element) {
	      if (!angular.isElement(element)) {
	        s.logWarn("Trying to focus on an element that isn\'t an element.");
	        return $q.reject('not-element');
	      }
	      element = angular.element(element);
	      this._purgeQueue();
	      var promise = $timeout(function() {
	        if (element) {
	          element[0].focus();
	        }
	      }, 0, false);
	      this.queue.push(promise);
	      return promise;
	    },
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name bySelector
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} parentElement the parent/ancestor of the dom element that you are selecting using the query selector
	     * @param {String} querySelector finds the dom element using the {@link http://www.w3schools.com/jsref/met_document_queryselector.asp querySelector}
	     * @param {boolean} [aSync=false] If true then the selector will be querried inside of a timeout. Otherwise the selector will be querried imidately
	     * then the focus will be called.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    bySelector: function(parentElement, querySelector, aSync) {
	      var self = this;
	      if (!angular.isElement(parentElement)) {
	        throw new Error("The parent element is not an element.");
	      }
	      // Ensure that this is an angular element.
	      // It is fine if this is already an angular element.
	      parentElement = angular.element(parentElement);
	      var focusBySelector = function() {
	        var element = parentElement[0].querySelector(querySelector);
	        return self.byElement(element);
	      };
	      this._purgeQueue();
	      if (aSync) { // Do this asynchronysly
	        var promise = $timeout(focusBySelector, 0, false);
	        this.queue.push(promise);
	        return promise;
	      } else {
	        return focusBySelector();
	      }
	    },
	    _purgeQueue: function() {
	      this.queue.forEach(function(element) {
	        $timeout.cancel(element);
	      });
	      this.queue = [];
	    }
	  };
	
	
	  ['width', 'height'].forEach(function (name) {
	    var capsName = name.charAt(0).toUpperCase() + name.substr(1);
	
	    s['element' + capsName] = function (elem, extra) {
	      var e = elem;
	      if (e && typeof(e.length) !== 'undefined' && e.length) {
	        e = elem[0];
	      }
	
	      if (e && e !== null) {
	        var styles = getStyles(e);
	        return e.offsetWidth === 0 && rdisplayswap.test(styles.display) ?
	          s.swap(e, cssShow, function() {
	            return getWidthOrHeight(e, name, extra );
	          }) :
	          getWidthOrHeight( e, name, extra );
	      } else {
	        return null;
	      }
	    };
	
	    s['outerElement' + capsName] = function (elem, margin) {
	      return elem ? s['element' + capsName].call(this, elem, margin ? 'margin' : 'border') : null;
	    };
	  });
	
	  // http://stackoverflow.com/a/24107550/888165
	  s.closestElm = function closestElm(el, selector) {
	    if (typeof(el.length) !== 'undefined' && el.length) {
	      el = el[0];
	    }
	
	    var matchesFn;
	
	    // find vendor prefix
	    ['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
	        if (typeof document.body[fn] === 'function') {
	            matchesFn = fn;
	            return true;
	        }
	        return false;
	    });
	
	    // traverse parents
	    var parent;
	    while (el !== null) {
	      parent = el.parentElement;
	      if (parent !== null && parent[matchesFn](selector)) {
	          return parent;
	      }
	      el = parent;
	    }
	
	    return null;
	  };
	
	  s.type = function (obj) {
	    var text = Function.prototype.toString.call(obj.constructor);
	    return text.match(/function (.*?)\(/)[1];
	  };
	
	  s.getBorderSize = function getBorderSize(elem, borderType) {
	    if (typeof(elem.length) !== 'undefined' && elem.length) {
	      elem = elem[0];
	    }
	
	    var styles = getStyles(elem);
	
	    // If a specific border is supplied, like 'top', read the 'borderTop' style property
	    if (borderType) {
	      borderType = 'border' + borderType.charAt(0).toUpperCase() + borderType.slice(1);
	    }
	    else {
	      borderType = 'border';
	    }
	
	    borderType += 'Width';
	
	    var val = parseInt(styles[borderType], 10);
	
	    if (isNaN(val)) {
	      return 0;
	    }
	    else {
	      return val;
	    }
	  };
	
	  // http://stackoverflow.com/a/22948274/888165
	  // TODO: Opera? Mobile?
	  s.detectBrowser = function detectBrowser() {
	    var userAgent = $window.navigator.userAgent;
	
	    var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer|trident\//i};
	
	    for (var key in browsers) {
	      if (browsers[key].test(userAgent)) {
	        return key;
	      }
	    }
	
	    return 'unknown';
	  };
	
	  // Borrowed from https://github.com/othree/jquery.rtl-scroll-type
	  // Determine the scroll "type" this browser is using for RTL
	  s.rtlScrollType = function rtlScrollType() {
	    if (rtlScrollType.type) {
	      return rtlScrollType.type;
	    }
	
	    var definer = angular.element('<div dir="rtl" style="font-size: 14px; width: 1px; height: 1px; position: absolute; top: -1000px; overflow: scroll">A</div>')[0],
	        type = 'reverse';
	
	    document.body.appendChild(definer);
	
	    if (definer.scrollLeft > 0) {
	      type = 'default';
	    }
	    else {
	      definer.scrollLeft = 1;
	      if (definer.scrollLeft === 0) {
	        type = 'negative';
	      }
	    }
	
	    angular.element(definer).remove();
	    rtlScrollType.type = type;
	
	    return type;
	  };
	
	    /**
	     * @ngdoc method
	     * @name normalizeScrollLeft
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {element} element The element to get the `scrollLeft` from.
	     * @param {grid} grid -  grid used to normalize (uses the rtl property)
	     *
	     * @returns {number} A normalized scrollLeft value for the current browser.
	     *
	     * @description
	     * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method normalizes them
	     */
	  s.normalizeScrollLeft = function normalizeScrollLeft(element, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    var scrollLeft = element.scrollLeft;
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          return element.scrollWidth - scrollLeft - element.clientWidth;
	        case 'negative':
	          return Math.abs(scrollLeft);
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	  /**
	  * @ngdoc method
	  * @name denormalizeScrollLeft
	  * @methodOf ui.grid.service:GridUtil
	  *
	  * @param {element} element The element to normalize the `scrollLeft` value for
	  * @param {number} scrollLeft The `scrollLeft` value to denormalize.
	  * @param {grid} grid The grid that owns the scroll event.
	  *
	  * @returns {number} A normalized scrollLeft value for the current browser.
	  *
	  * @description
	  * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method denormalizes a value for the current browser.
	  */
	  s.denormalizeScrollLeft = function denormalizeScrollLeft(element, scrollLeft, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          // Get the max scroll for the element
	          var maxScrollLeft = element.scrollWidth - element.clientWidth;
	
	          // Subtract the current scroll amount from the max scroll
	          return maxScrollLeft - scrollLeft;
	        case 'negative':
	          return scrollLeft * -1;
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	    /**
	     * @ngdoc method
	     * @name preEval
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} path Path to evaluate
	     *
	     * @returns {string} A path that is normalized.
	     *
	     * @description
	     * Takes a field path and converts it to bracket notation to allow for special characters in path
	     * @example
	     * <pre>
	     * gridUtil.preEval('property') == 'property'
	     * gridUtil.preEval('nested.deep.prop-erty') = "nested['deep']['prop-erty']"
	     * </pre>
	     */
	  s.preEval = function (path) {
	    var m = uiGridConstants.BRACKET_REGEXP.exec(path);
	    if (m) {
	      return (m[1] ? s.preEval(m[1]) : m[1]) + m[2] + (m[3] ? s.preEval(m[3]) : m[3]);
	    } else {
	      path = path.replace(uiGridConstants.APOS_REGEXP, '\\\'');
	      var parts = path.split(uiGridConstants.DOT_REGEXP);
	      var preparsed = [parts.shift()];    // first item must be var notation, thus skip
	      angular.forEach(parts, function (part) {
	        preparsed.push(part.replace(uiGridConstants.FUNC_REGEXP, '\']$1'));
	      });
	      return preparsed.join('[\'');
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name debounce
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to debounce
	   * @param {number} wait milliseconds to delay
	   * @param {boolean} immediate execute before delay
	   *
	   * @returns {function} A function that can be executed as debounced function
	   *
	   * @description
	   * Copied from https://github.com/shahata/angular-debounce
	   * Takes a function, decorates it to execute only 1 time after multiple calls, and returns the decorated function
	   * @example
	   * <pre>
	   * var debouncedFunc =  gridUtil.debounce(function() {alert('debounced');}, 500);
	   * debouncedFunc();
	   * debouncedFunc();
	   * debouncedFunc();
	   * </pre>
	   */
	  s.debounce =  function (func, wait, immediate) {
	    var timeout, args, context, result;
	    function debounce() {
	      /* jshint validthis: true */
	      context = this;
	      args = arguments;
	      var later = function () {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	        }
	      };
	      var callNow = immediate && !timeout;
	      if (timeout) {
	        $timeout.cancel(timeout);
	      }
	      timeout = $timeout(later, wait, false);
	      if (callNow) {
	        result = func.apply(context, args);
	      }
	      return result;
	    }
	    debounce.cancel = function () {
	      $timeout.cancel(timeout);
	      timeout = null;
	    };
	    return debounce;
	  };
	
	  /**
	   * @ngdoc method
	   * @name throttle
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to throttle
	   * @param {number} wait milliseconds to delay after first trigger
	   * @param {Object} options to use in throttle.
	   *
	   * @returns {function} A function that can be executed as throttled function
	   *
	   * @description
	   * Adapted from debounce function (above)
	   * Potential keys for Params Object are:
	   *    trailing (bool) - whether to trigger after throttle time ends if called multiple times
	   * Updated to use $interval rather than $timeout, as protractor (e2e tests) is able to work with $interval,
	   * but not with $timeout
	   *
	   * Note that when using throttle, you need to use throttle to create a new function upfront, then use the function
	   * return from that call each time you need to call throttle.  If you call throttle itself repeatedly, the lastCall
	   * variable will get overwritten and the throttling won't work
	   *
	   * @example
	   * <pre>
	   * var throttledFunc =  gridUtil.throttle(function() {console.log('throttled');}, 500, {trailing: true});
	   * throttledFunc(); //=> logs throttled
	   * throttledFunc(); //=> queues attempt to log throttled for ~500ms (since trailing param is truthy)
	   * throttledFunc(); //=> updates arguments to keep most-recent request, but does not do anything else.
	   * </pre>
	   */
	  s.throttle = function(func, wait, options) {
	    options = options || {};
	    var lastCall = 0, queued = null, context, args;
	
	    function runFunc(endDate) {
	      lastCall = +new Date();
	      func.apply(context, args);
	      $interval(function() {queued = null; }, 0, 1, false);
	    }
	
	    return function() {
	      /* jshint validthis: true */
	      context = this;
	      args = arguments;
	      if (queued === null) {
	        var sinceLast = +new Date() - lastCall;
	        if (sinceLast > wait) {
	          runFunc();
	        }
	        else if (options.trailing) {
	          queued = $interval(runFunc, wait - sinceLast, 1, false);
	        }
	      }
	    };
	  };
	
	  s.on = {};
	  s.off = {};
	  s._events = {};
	
	  s.addOff = function (eventName) {
	    s.off[eventName] = function (elm, fn) {
	      var idx = s._events[eventName].indexOf(fn);
	      if (idx > 0) {
	        s._events[eventName].removeAt(idx);
	      }
	    };
	  };
	
	  var mouseWheeltoBind = ( 'onwheel' in document || document.documentMode >= 9 ) ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	      nullLowestDeltaTimeout,
	      lowestDelta;
	
	  s.on.mousewheel = function (elm, fn) {
	    if (!elm || !fn) { return; }
	
	    var $elm = angular.element(elm);
	
	    // Store the line height and page height for this particular element
	    $elm.data('mousewheel-line-height', getLineHeight($elm));
	    $elm.data('mousewheel-page-height', s.elementHeight($elm));
	    if (!$elm.data('mousewheel-callbacks')) { $elm.data('mousewheel-callbacks', {}); }
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    cbs[fn] = (Function.prototype.bind || bindPolyfill).call(mousewheelHandler, $elm[0], fn);
	
	    // Bind all the mousew heel events
	    for ( var i = mouseWheeltoBind.length; i; ) {
	      $elm.on(mouseWheeltoBind[--i], cbs[fn]);
	    }
	    $elm.on('$destroy', function unbindEvents() {
	      for ( var i = mouseWheeltoBind.length; i; ) {
	        $elm.off(mouseWheeltoBind[--i], cbs[fn]);
	      }
	    });
	  };
	  s.off.mousewheel = function (elm, fn) {
	    var $elm = angular.element(elm);
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    var handler = cbs[fn];
	
	    if (handler) {
	      for ( var i = mouseWheeltoBind.length; i; ) {
	        $elm.off(mouseWheeltoBind[--i], handler);
	      }
	    }
	
	    delete cbs[fn];
	
	    if (Object.keys(cbs).length === 0) {
	      $elm.removeData('mousewheel-line-height');
	      $elm.removeData('mousewheel-page-height');
	      $elm.removeData('mousewheel-callbacks');
	    }
	  };
	
	  function mousewheelHandler(fn, event) {
	    var $elm = angular.element(this);
	
	    var delta      = 0,
	        deltaX     = 0,
	        deltaY     = 0,
	        absDelta   = 0,
	        offsetX    = 0,
	        offsetY    = 0;
	
	    // jQuery masks events
	    if (event.originalEvent) { event = event.originalEvent; }
	
	    if ( 'detail'      in event ) { deltaY = event.detail * -1;      }
	    if ( 'wheelDelta'  in event ) { deltaY = event.wheelDelta;       }
	    if ( 'wheelDeltaY' in event ) { deltaY = event.wheelDeltaY;      }
	    if ( 'wheelDeltaX' in event ) { deltaX = event.wheelDeltaX * -1; }
	
	    // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	    if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	      deltaX = deltaY * -1;
	      deltaY = 0;
	    }
	
	    // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	    delta = deltaY === 0 ? deltaX : deltaY;
	
	    // New school wheel delta (wheel event)
	    if ( 'deltaY' in event ) {
	      deltaY = event.deltaY * -1;
	      delta  = deltaY;
	    }
	    if ( 'deltaX' in event ) {
	      deltaX = event.deltaX;
	      if ( deltaY === 0 ) { delta  = deltaX * -1; }
	    }
	
	    // No change actually happened, no reason to go any further
	    if ( deltaY === 0 && deltaX === 0 ) { return; }
	
	    // Need to convert lines and pages to pixels if we aren't already in pixels
	    // There are three delta modes:
	    //   * deltaMode 0 is by pixels, nothing to do
	    //   * deltaMode 1 is by lines
	    //   * deltaMode 2 is by pages
	    if ( event.deltaMode === 1 ) {
	        var lineHeight = $elm.data('mousewheel-line-height');
	        delta  *= lineHeight;
	        deltaY *= lineHeight;
	        deltaX *= lineHeight;
	    }
	    else if ( event.deltaMode === 2 ) {
	        var pageHeight = $elm.data('mousewheel-page-height');
	        delta  *= pageHeight;
	        deltaY *= pageHeight;
	        deltaX *= pageHeight;
	    }
	
	    // Store lowest absolute delta to normalize the delta values
	    absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );
	
	    if ( !lowestDelta || absDelta < lowestDelta ) {
	      lowestDelta = absDelta;
	
	      // Adjust older deltas if necessary
	      if ( shouldAdjustOldDeltas(event, absDelta) ) {
	        lowestDelta /= 40;
	      }
	    }
	
	    // Get a whole, normalized value for the deltas
	    delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	    deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	    deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);
	
	    var newEvent = {
	      originalEvent: event,
	      deltaX: deltaX,
	      deltaY: deltaY,
	      deltaFactor: lowestDelta,
	      preventDefault: function () { event.preventDefault(); },
	      stopPropagation: function () { event.stopPropagation(); }
	    };
	
	    // Clearout lowestDelta after sometime to better
	    // handle multiple device types that give
	    // a different lowestDelta
	    // Ex: trackpad = 3 and mouse wheel = 120
	    if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
	    nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
	
	    fn.call($elm[0], newEvent);
	  }
	
	  function nullLowestDelta() {
	    lowestDelta = null;
	  }
	
	  function shouldAdjustOldDeltas(orgEvent, absDelta) {
	    // If this is an older event and the delta is divisable by 120,
	    // then we are assuming that the browser is treating this as an
	    // older mouse wheel event and that we should divide the deltas
	    // by 40 to try and get a more usable deltaFactor.
	    // Side note, this actually impacts the reported scroll distance
	    // in older browsers and can cause scrolling to be slower than native.
	    // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	    return orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
	  }
	
	  return s;
	}]);
	
	// Add 'px' to the end of a number string if it doesn't have it already
	module.filter('px', function() {
	  return function(str) {
	    if (str.match(/^[\d\.]+$/)) {
	      return str + 'px';
	    }
	    else {
	      return str;
	    }
	  };
	});
	
	})();
	
	/**
	 * @ngdoc overview
	 * @name ui.grid.i18n
	 * @description
	 *
	 *  # ui.grid.i18n
	 * This module provides i18n functions to ui.grid and any application that wants to use it
	
	 *
	 * <div doc-module-components="ui.grid.i18n"></div>
	 */
	
	(function () {
	  var DIRECTIVE_ALIASES = ['uiT', 'uiTranslate'];
	  var FILTER_ALIASES = ['t', 'uiTranslate'];
	
	  var module = angular.module('ui.grid.i18n');
	
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.i18n.constant:i18nConstants
	   *
	   *  @description constants available in i18n module
	   */
	  module.constant('i18nConstants', {
	    MISSING: '[MISSING]',
	    UPDATE_EVENT: '$uiI18n',
	
	    LOCALE_DIRECTIVE_ALIAS: 'uiI18n',
	    // default to english
	    DEFAULT_LANG: 'en'
	  });
	
	//    module.config(['$provide', function($provide) {
	//        $provide.decorator('i18nService', ['$delegate', function($delegate) {}])}]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.i18n.service:i18nService
	   *
	   *  @description Services for i18n
	   */
	  module.service('i18nService', ['$log', '$parse', 'i18nConstants', '$rootScope',
	    function ($log, $parse, i18nConstants, $rootScope) {
	
	      var langCache = {
	        _langs: {},
	        current: null,
	        fallback: i18nConstants.DEFAULT_LANG,
	        get: function (lang) {
	          var self = this,
	            fallbackLang = self.getFallbackLang();
	
	          if (lang !== self.fallback) {
	            return angular.extend({}, self._langs[fallbackLang],
	              self._langs[lang.toLowerCase()]);
	          }
	
	          return self._langs[lang.toLowerCase()];
	        },
	        add: function (lang, strings) {
	          var lower = lang.toLowerCase();
	          if (!this._langs[lower]) {
	            this._langs[lower] = {};
	          }
	          angular.merge(this._langs[lower], strings);
	        },
	        getAllLangs: function () {
	          var langs = [];
	          if (!this._langs) {
	            return langs;
	          }
	
	          for (var key in this._langs) {
	            langs.push(key);
	          }
	
	          return langs;
	        },
	        setCurrent: function (lang) {
	          this.current = lang.toLowerCase();
	        },
	        setFallback: function (lang) {
	          this.fallback = lang.toLowerCase();
	        },
	        getCurrentLang: function () {
	          return this.current;
	        },
	        getFallbackLang: function () {
	          return this.fallback.toLowerCase();
	        }
	      };
	
	      function getMissingText(path) {
	        $log.warn(i18nConstants.MISSING + path);
	        return '';
	      }
	
	      var service = {
	
	        /**
	         * @ngdoc service
	         * @name add
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  Adds the languages and strings to the cache. Decorate this service to
	         * add more translation strings
	         * @param {string} langs languages to add
	         * @param {object} stringMaps of strings to add grouped by property names
	         * @example
	         * <pre>
	         *      i18nService.add('en', {
	         *         aggregate: {
	         *                 label1: 'items',
	         *                 label2: 'some more items'
	         *                 }
	         *         },
	         *         groupPanel: {
	         *              description: 'Drag a column header here and drop it to group by that column.'
	         *           }
	         *      }
	         * </pre>
	         */
	        add: function (langs, stringMaps) {
	          if (typeof(langs) === 'object') {
	            angular.forEach(langs, function (lang) {
	              if (lang) {
	                langCache.add(lang, stringMaps);
	              }
	            });
	          } else {
	            langCache.add(langs, stringMaps);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getAllLangs
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @returns {array} string
	         */
	        getAllLangs: function () {
	          return langCache.getAllLangs();
	        },
	
	        /**
	         * @ngdoc service
	         * @name get
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @param {string} lang to return.  If not specified, returns current language
	         * @returns {object} the translation string maps for the language
	         */
	        get: function (lang) {
	          var language = lang ? lang : service.getCurrentLang();
	          return langCache.get(language);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getSafeText
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  returns the text specified in the path or a Missing text if text is not found
	         * @param {String} path property path to use for retrieving text from string map
	         * @param {String} [lang] to return.  If not specified, returns current language
	         * @returns {object} the translation for the path
	         * @example
	         * <pre>
	         * i18nService.getSafeText('sort.ascending')
	         * </pre>
	         */
	        getSafeText: function (path, lang) {
	          var language = lang || service.getCurrentLang(),
	            trans = langCache.get(language),
	            getter = $parse(path);
	
	          if (!trans) {
	            return getMissingText(path);
	          }
	
	          return getter(trans) || getMissingText(path);
	        },
	
	        /**
	         * @ngdoc service
	         * @name setCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description sets the current language to use in the application
	         * $broadcasts the i18nConstants.UPDATE_EVENT on the $rootScope
	         * @param {string} lang to set
	         * @example
	         * <pre>
	         * i18nService.setCurrentLang('fr');
	         * </pre>
	         */
	        setCurrentLang: function (lang) {
	          if (lang) {
	            langCache.setCurrent(lang);
	            $rootScope.$broadcast(i18nConstants.UPDATE_EVENT);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name setFallbackLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description sets the fallback language to use in the application.
	         * The default fallback language is english.
	         * @param {string} lang to set
	         * @example
	         * <pre>
	         * i18nService.setFallbackLang('en');
	         * </pre>
	         */
	        setFallbackLang: function (lang) {
	          if (lang) {
	            langCache.setFallback(lang);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description returns the current language used in the application
	         */
	        getCurrentLang: function () {
	          var lang = langCache.getCurrentLang();
	          if (!lang) {
	            lang = i18nConstants.DEFAULT_LANG;
	            langCache.setCurrent(lang);
	          }
	          return lang;
	        },
	
	        /**
	         * @ngdoc service
	         * @name getFallbackLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description returns the fallback language used in the application
	         */
	        getFallbackLang: function () {
	          return langCache.getFallbackLang();
	        }
	      };
	
	      return service;
	    }]);
	
	  function localeDirective(i18nService, i18nConstants) {
	    return {
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var alias = i18nConstants.LOCALE_DIRECTIVE_ALIAS;
	            // check for watchable property
	            var lang = $scope.$eval($attrs[alias]);
	            if (lang) {
	              $scope.$watch($attrs[alias], function () {
	                i18nService.setCurrentLang(lang);
	              });
	            } else if ($attrs.$$observers) {
	              $attrs.$observe(alias, function () {
	                i18nService.setCurrentLang($attrs[alias] || i18nConstants.DEFAULT_LANG);
	              });
	            }
	          }
	        };
	      }
	    };
	  }
	
	  module.directive('uiI18n', ['i18nService', 'i18nConstants', localeDirective]);
	
	  // directive syntax
	  function uitDirective(i18nService, i18nConstants) {
	    return {
	      restrict: 'EA',
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var listener, observer, prop,
	              alias1 = DIRECTIVE_ALIASES[0],
	              alias2 = DIRECTIVE_ALIASES[1],
	              token = $attrs[alias1] || $attrs[alias2] || $elm.html();
	
	            function translateToken(property) {
	              var safeText = i18nService.getSafeText(property);
	
	              $elm.html(safeText);
	            }
	
	            if ($attrs.$$observers) {
	              prop = $attrs[alias1] ? alias1 : alias2;
	              observer = $attrs.$observe(prop, function (result) {
	                if (result) {
	                  translateToken(result);
	                }
	              });
	            }
	
	            listener = $scope.$on(i18nConstants.UPDATE_EVENT, function() {
	              if (observer) {
	                observer($attrs[alias1] || $attrs[alias2]);
	              } else {
	                // set text based on i18n current language
	                translateToken(token);
	              }
	            });
	            $scope.$on('$destroy', listener);
	
	            translateToken(token);
	          }
	        };
	      }
	    };
	  }
	
	  angular.forEach(DIRECTIVE_ALIASES, function ( alias ) {
	    module.directive(alias, ['i18nService', 'i18nConstants', uitDirective]);
	  });
	
	  // optional filter syntax
	  function uitFilter(i18nService) {
	    return function (data, lang) {
	      // set text based on i18n current language
	      return i18nService.getSafeText(data, lang);
	    };
	  }
	
	  angular.forEach(FILTER_ALIASES, function ( alias ) {
	    module.filter(alias, ['i18nService', uitFilter]);
	  });
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.edit
	   * @description
	   *
	   * # ui.grid.edit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides cell editing capability to ui.grid. The goal was to emulate keying data in a spreadsheet via
	   * a keyboard.
	   * <br/>
	   * <br/>
	   * To really get the full spreadsheet-like data entry, the ui.grid.cellNav module should be used. This will allow the
	   * user to key data and then tab, arrow, or enter to the cells beside or below.
	   *
	   * <div doc-module-components="ui.grid.edit"></div>
	   */
	
	  var module = angular.module('ui.grid.edit', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.constant:uiGridEditConstants
	   *
	   *  @description constants available in edit module
	   */
	  module.constant('uiGridEditConstants', {
	    EDITABLE_CELL_TEMPLATE: /EDITABLE_CELL_TEMPLATE/g,
	    // must be lowercase because template bulder converts to lower
	    EDITABLE_CELL_DIRECTIVE: /editable_cell_directive/g,
	    events: {
	      BEGIN_CELL_EDIT: 'uiGridEventBeginCellEdit',
	      END_CELL_EDIT: 'uiGridEventEndCellEdit',
	      CANCEL_CELL_EDIT: 'uiGridEventCancelCellEdit'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.edit.service:uiGridEditService
	   *
	   *  @description Services for editing features
	   */
	  module.service('uiGridEditService', ['$q', 'uiGridConstants', 'gridUtil',
	    function ($q, uiGridConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          service.defaultGridOptions(grid.options);
	
	          grid.registerColumnBuilder(service.editColumnBuilder);
	          grid.edit = {};
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:PublicApi
	           *
	           *  @description Public Api for edit feature
	           */
	          var publicApi = {
	            events: {
	              edit: {
	                /**
	                 * @ngdoc event
	                 * @name afterCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is complete
	                 * <pre>
	                 *      gridApi.edit.on.afterCellEdit(scope,function(rowEntity, colDef) {})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} newValue new value
	                 * @param {object} oldValue old value
	                 */
	                afterCellEdit: function (rowEntity, colDef, newValue, oldValue) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name beginCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing starts on a cell
	                 * <pre>
	                 *      gridApi.edit.on.beginCellEdit(scope,function(rowEntity, colDef) {})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} triggerEvent the event that triggered the edit.  Useful to prevent losing keystrokes on some
	                 *                 complex editors
	                 */
	                beginCellEdit: function (rowEntity, colDef, triggerEvent) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name cancelCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is cancelled on a cell
	                 * <pre>
	                 *      gridApi.edit.on.cancelCellEdit(scope,function(rowEntity, colDef) {})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 */
	                cancelCellEdit: function (rowEntity, colDef) {
	                }
	              }
	            },
	            methods: {
	              edit: { }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          // grid.api.registerMethodsFromObject(publicApi.methods);
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:GridOptions
	           *
	           *  @description Options for configuring the edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If defined, sets the default value for the editable flag on each individual colDefs
	           *  if their individual enableCellEdit configuration is not defined. Defaults to undefined.
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, either a value or function to be used by all columns before editing.
	           *  If false, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope, triggerEvent) {
	           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          gridOptions.cellEditableCondition = gridOptions.cellEditableCondition === undefined ? true : gridOptions.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, cellTemplate to use as the editor for all columns.
	           *  <br/> defaults to 'ui-grid/cellTextEditor'
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br/>_requires cellNav feature and the edit feature to be enabled_
	           */
	            // enableCellEditOnFocus can only be used if cellnav module is used
	          gridOptions.enableCellEditOnFocus = gridOptions.enableCellEditOnFocus === undefined ? false : gridOptions.enableCellEditOnFocus;
	        },
	
	        /**
	         * @ngdoc service
	         * @name editColumnBuilder
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description columnBuilder function that adds edit properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        editColumnBuilder: function (colDef, col, gridOptions) {
	
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:ColumnDef
	           *
	           *  @description Column Definition for edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description enable editing on column
	           */
	          colDef.enableCellEdit = colDef.enableCellEdit === undefined ? (gridOptions.enableCellEdit === undefined ?
	            (colDef.type !== 'object') : gridOptions.enableCellEdit) : colDef.enableCellEdit;
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description If specified, either a value or function evaluated before editing cell.  If falsy, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope, triggerEvent) {
	           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          colDef.cellEditableCondition = colDef.cellEditableCondition === undefined ? gridOptions.cellEditableCondition :  colDef.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description cell template to be used when editing this column. Can be Url or text template
	           *  <br/>Defaults to gridOptions.editableCellTemplate
	           */
	          if (colDef.enableCellEdit) {
	            colDef.editableCellTemplate = colDef.editableCellTemplate || gridOptions.editableCellTemplate || 'ui-grid/cellEditor';
	
	            promises.push(gridUtil.getTemplate(colDef.editableCellTemplate)
	              .then(
	              function (template) {
	                col.editableCellTemplate = template;
	              },
	              function (res) {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use colDef.editableCellTemplate '" + colDef.editableCellTemplate + "'");
	              }));
	          }
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @requires ui.grid.cellNav
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br>_requires both the cellNav feature and the edit feature to be enabled_
	           */
	            // enableCellEditOnFocus can only be used if cellnav module is used
	          colDef.enableCellEditOnFocus = colDef.enableCellEditOnFocus === undefined ? gridOptions.enableCellEditOnFocus : colDef.enableCellEditOnFocus;
	
	
	          /**
	           *  @ngdoc string
	           *  @name editModelField
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description a bindable string value that is used when binding to edit controls instead of colDef.field
	           *  <br/> example: You have a complex property on and object like state:{abbrev: 'MS',name: 'Mississippi'}.  The
	           *  grid should display state.name in the cell and sort/filter based on the state.name property but the editor
	           *  requires the full state object.
	           *  <br/>colDef.field = 'state.name'
	           *  <br/>colDef.editModelField = 'state'
	           */
	          // colDef.editModelField
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc service
	         * @name isStartEditKey
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description  Determines if a keypress should start editing.  Decorate this service to override with your
	         * own key events.  See service decorator in angular docs.
	         * @param {Event} evt keydown event
	         * @returns {boolean} true if an edit should start
	         */
	        isStartEditKey: function (evt) {
	          return !(evt.metaKey ||
	              evt.keyCode === uiGridConstants.keymap.ESC ||
	              evt.keyCode === uiGridConstants.keymap.SHIFT ||
	              evt.keyCode === uiGridConstants.keymap.CTRL ||
	              evt.keyCode === uiGridConstants.keymap.ALT ||
	              evt.keyCode === uiGridConstants.keymap.WIN ||
	              evt.keyCode === uiGridConstants.keymap.CAPSLOCK ||
	
	             evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB ||
	
	            evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER);
	        }
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds editing features to the ui-grid directive.
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.edit']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridEdit', ['gridUtil', 'uiGridEditService', function (gridUtil, uiGridEditService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridEditService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridRenderContainer
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds keydown listeners to renderContainer element so we can capture when to begin edits
	   *
	   */
	  module.directive('uiGridViewport', [ 'uiGridEditConstants',
	    function ( uiGridEditConstants) {
	      return {
	        replace: true,
	        priority: -99998, // run before cellNav
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0];
	
	              // Skip attaching if edit and cellNav is not enabled
	              if (!uiGridCtrl.grid.api.edit || !uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId =  controllers[1].containerId;
	              // no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              // refocus on the grid
	              $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	              $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide in-line editing capabilities to the cell
	   *  Editing Actions.
	   *
	   *  Binds edit start events to the uiGridCell element.  When the events fire, the gridCell element is appended
	   *  with the columnDef.editableCellTemplate element ('cellEditor.html' by default).
	   *
	   *  The editableCellTemplate should respond to uiGridEditConstants.events.BEGIN\_CELL\_EDIT angular event
	   *  and do the initial steps needed to edit the cell (setfocus on input element, etc).
	   *
	   *  When the editableCellTemplate recognizes that the editing is ended (blur event, Enter key, etc.)
	   *  it should emit the uiGridEditConstants.events.END\_CELL\_EDIT event.
	   *
	   *  If editableCellTemplate recognizes that the editing has been cancelled (esc key)
	   *  it should emit the uiGridEditConstants.events.CANCEL\_CELL\_EDIT event.  The original value
	   *  will be set back on the model by the uiGridCell directive.
	   *
	   *  Events that invoke editing:
	   *    - dblclick
	   *    - F2 keydown (when using cell selection)
	   *
	   *  Events that end editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be Esc keydown
	   *
	   *  Grid Events that end editing:
	   *    - uiGridConstants.events.GRID_SCROLL
	   *
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.api:GridRow
	   *
	   *  @description GridRow options for edit feature, these are available to be
	   *  set internally only, by other features
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name enableCellEdit
	   *  @propertyOf  ui.grid.edit.api:GridRow
	   *  @description enable editing on row, grouping for example might disable editing on group header rows
	   */
	
	  module.directive('uiGridCell',
	    ['$compile', '$injector', '$timeout', 'uiGridConstants', 'uiGridEditConstants', 'gridUtil', '$parse', 'uiGridEditService', '$rootScope', '$q',
	      function ($compile, $injector, $timeout, uiGridConstants, uiGridEditConstants, gridUtil, $parse, uiGridEditService, $rootScope, $q) {
	        var touchstartTimeout = 500;
	        if ($injector.has('uiGridCellNavService')) {
	          var uiGridCellNavService = $injector.get('uiGridCellNavService');
	        }
	
	        return {
	          priority: -100, // run after default uiGridCell directive
	          restrict: 'A',
	          scope: false,
	          require: '?^uiGrid',
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var html,
	              origCellValue,
	              cellModel,
	              cancelTouchstartTimeout,
	              inEdit = false;
	
	            var editCellScope;
	
	            if (!$scope.col.colDef.enableCellEdit) {
	              return;
	            }
	
	            var cellNavNavigateDereg = function() {};
	            var viewPortKeyDownDereg = function() {};
	
	
	            var setEditable = function() {
	              if ($scope.col.colDef.enableCellEdit && $scope.row.enableCellEdit !== false) {
	                if (!$scope.beginEditEventsWired) { // prevent multiple attachments
	                  registerBeginEditEvents();
	                }
	              } else {
	                if ($scope.beginEditEventsWired) {
	                  cancelBeginEditEvents();
	                }
	              }
	            };
	
	            setEditable();
	
	            var rowWatchDereg = $scope.$watch('row', function (n, o) {
	              if (n !== o) {
	                setEditable();
	              }
	            });
	
	
	            $scope.$on('$destroy', function destroyEvents() {
	              rowWatchDereg();
	              // unbind all jquery events in order to avoid memory leaks
	              $elm.off();
	            });
	
	            function registerBeginEditEvents() {
	              $elm.on('dblclick', beginEdit);
	
	              // Add touchstart handling. If the users starts a touch and it doesn't end after X milliseconds, then start the edit
	              $elm.on('touchstart', touchStart);
	
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	
	                viewPortKeyDownDereg = uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                  if (rowCol === null) {
	                    return;
	                  }
	
	                  if (rowCol.row === $scope.row && rowCol.col === $scope.col && !$scope.col.colDef.enableCellEditOnFocus) {
	                    // important to do this before scrollToIfNecessary
	                    beginEditKeyDown(evt);
	                  }
	                });
	
	                cellNavNavigateDereg = uiGridCtrl.grid.api.cellNav.on.navigate($scope, function (newRowCol, oldRowCol, evt) {
	                  if ($scope.col.colDef.enableCellEditOnFocus) {
	                    // Don't begin edit if the cell hasn't changed
	                    if (newRowCol.row === $scope.row && newRowCol.col === $scope.col &&
	                      (evt === null || (evt && (evt.type === 'click' || evt.type === 'keydown')))) {
	                      $timeout(function() {
	                        beginEdit(evt);
	                      });
	                    }
	                  }
	                });
	              }
	
	              $scope.beginEditEventsWired = true;
	            }
	
	            function touchStart(event) {
	              // jQuery masks events
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Bind touchend handler
	              $elm.on('touchend', touchEnd);
	
	              // Start a timeout
	              cancelTouchstartTimeout = $timeout(function() { }, touchstartTimeout);
	
	              // Timeout's done! Start the edit
	              cancelTouchstartTimeout.then(function () {
	                // Use setTimeout to start the edit because beginEdit expects to be outside of $digest
	                setTimeout(beginEdit, 0);
	
	                // Undbind the touchend handler, we don't need it anymore
	                $elm.off('touchend', touchEnd);
	              }).catch(angular.noop);
	            }
	
	            // Cancel any touchstart timeout
	            function touchEnd() {
	              $timeout.cancel(cancelTouchstartTimeout);
	              $elm.off('touchend', touchEnd);
	            }
	
	            function cancelBeginEditEvents() {
	              $elm.off('dblclick', beginEdit);
	              $elm.off('keydown', beginEditKeyDown);
	              $elm.off('touchstart', touchStart);
	              cellNavNavigateDereg();
	              viewPortKeyDownDereg();
	              $scope.beginEditEventsWired = false;
	            }
	
	            function beginEditKeyDown(evt) {
	              if (uiGridEditService.isStartEditKey(evt)) {
	                beginEdit(evt);
	              }
	            }
	
	            function shouldEdit(col, row, triggerEvent) {
	              return !row.isSaving &&
	                ( angular.isFunction(col.colDef.cellEditableCondition) ?
	                    col.colDef.cellEditableCondition($scope, triggerEvent) :
	                    col.colDef.cellEditableCondition );
	            }
	
	
	            function beginEdit(triggerEvent) {
	              // we need to scroll the cell into focus before invoking the editor
	              $scope.grid.api.core.scrollToIfNecessary($scope.row, $scope.col)
	                .then(function () {
	                  beginEditAfterScroll(triggerEvent);
	                });
	            }
	
	            /**
	             *  @ngdoc property
	             *  @name editDropdownOptionsArray
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description an array of values in the format
	             *  [ {id: xxx, value: xxx} ], which is populated
	             *  into the edit dropdown
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownIdLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "id" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'id'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownRowEntityOptionsArrayPath
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description a path to a property on row.entity containing an
	             *  array of values in the format
	             *  [ {id: xxx, value: xxx} ], which will be used to populate
	             *  the edit dropdown.  This can be used when the dropdown values are dependent on
	             *  the backing row entity.
	             *  If this property is set then editDropdownOptionsArray will be ignored.
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownRowEntityOptionsArrayPath: 'foo.bars[0].baz',
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc service
	             *  @name editDropdownOptionsFunction
	             *  @methodOf ui.grid.edit.api:ColumnDef
	             *  @description a function returning an array of values in the format
	             *  [ {id: xxx, value: xxx} ], which will be used to populate
	             *  the edit dropdown.  This can be used when the dropdown values are dependent on
	             *  the backing row entity with some kind of algorithm.
	             *  If this property is set then both editDropdownOptionsArray and
	             *  editDropdownRowEntityOptionsArrayPath will be ignored.
	             *  @param {object} rowEntity the options.data element that the returned array refers to
	             *  @param {object} colDef the column that implements this dropdown
	             *  @returns {object} an array of values in the format
	             *  [ {id: xxx, value: xxx} ] used to populate the edit dropdown
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsFunction: function(rowEntity, colDef) {
	             *            if (rowEntity.foo === 'bar') {
	             *              return [{id: 'bar1', value: 'BAR 1'},
	             *                      {id: 'bar2', value: 'BAR 2'},
	             *                      {id: 'bar3', value: 'BAR 3'}];
	             *            } else {
	             *              return [{id: 'foo1', value: 'FOO 1'},
	             *                      {id: 'foo2', value: 'FOO 2'}];
	             *            }
	             *          },
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownValueLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "value" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'value'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownFilter
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description A filter that you would like to apply to the values in the options list
	             *  of the dropdown.  For example if you were using angular-translate you might set this
	             *  to `'translate'`
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status', editDropdownFilter: 'translate' }
	             *      ],
	             *  </pre>
	             *
	             */
	            function beginEditAfterScroll(triggerEvent) {
	              // If we are already editing, then just skip this so we don't try editing twice...
	              if (inEdit) {
	                return;
	              }
	
	              if (!shouldEdit($scope.col, $scope.row, triggerEvent)) {
	                return;
	              }
	
	              var modelField = $scope.row.getQualifiedColField($scope.col);
	              if ($scope.col.colDef.editModelField) {
	                modelField = gridUtil.preEval('row.entity.' + $scope.col.colDef.editModelField);
	              }
	
	              cellModel = $parse(modelField);
	
	              // get original value from the cell
	              origCellValue = cellModel($scope);
	
	              html = $scope.col.editableCellTemplate;
	              html = html.replace(uiGridConstants.MODEL_COL_FIELD, modelField);
	              html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var optionFilter = $scope.col.colDef.editDropdownFilter ? '|' + $scope.col.colDef.editDropdownFilter : '';
	              html = html.replace(uiGridConstants.CUSTOM_FILTERS, optionFilter);
	
	              var inputType = 'text';
	              switch ($scope.col.colDef.type) {
	                case 'boolean':
	                  inputType = 'checkbox';
	                  break;
	                case 'number':
	                  inputType = 'number';
	                  break;
	                case 'date':
	                  inputType = 'date';
	                  break;
	              }
	              html = html.replace('INPUT_TYPE', inputType);
	
	              // In order to fill dropdown options we use:
	              // - A function/promise or
	              // - An array inside of row entity if no function exists or
	              // - A single array for the whole column if none of the previous exists.
	              var editDropdownOptionsFunction = $scope.col.colDef.editDropdownOptionsFunction;
	              if (editDropdownOptionsFunction) {
	                $q.when(editDropdownOptionsFunction($scope.row.entity, $scope.col.colDef))
	                        .then(function(result) {
	                  $scope.editDropdownOptionsArray = result;
	                });
	              } else {
	                var editDropdownRowEntityOptionsArrayPath = $scope.col.colDef.editDropdownRowEntityOptionsArrayPath;
	                if (editDropdownRowEntityOptionsArrayPath) {
	                  $scope.editDropdownOptionsArray =  resolveObjectFromPath($scope.row.entity, editDropdownRowEntityOptionsArrayPath);
	                }
	                else {
	                  $scope.editDropdownOptionsArray = $scope.col.colDef.editDropdownOptionsArray;
	                }
	              }
	              $scope.editDropdownIdLabel = $scope.col.colDef.editDropdownIdLabel ? $scope.col.colDef.editDropdownIdLabel : 'id';
	              $scope.editDropdownValueLabel = $scope.col.colDef.editDropdownValueLabel ? $scope.col.colDef.editDropdownValueLabel : 'value';
	
	              var createEditor = function() {
	                inEdit = true;
	                cancelBeginEditEvents();
	                var cellElement = angular.element(html);
	                $elm.append(cellElement);
	                editCellScope = $scope.$new();
	                $compile(cellElement)(editCellScope);
	                var gridCellContentsEl = angular.element($elm.children()[0]);
	                gridCellContentsEl.addClass('ui-grid-cell-contents-hidden');
	              };
	              if (!$rootScope.$$phase) {
	                $scope.$apply(createEditor);
	              } else {
	                createEditor();
	              }
	
	              // stop editing when grid is scrolled
	              var deregOnGridScroll = $scope.col.grid.api.core.on.scrollBegin($scope, function () {
	                if ($scope.grid.disableScrolling) {
	                  return;
	                }
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	                deregOnCancelCellEdit();
	              });
	
	              // end editing
	              var deregOnEndCellEdit = $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnEndCellEdit();
	                deregOnGridScroll();
	                deregOnCancelCellEdit();
	              });
	
	              // cancel editing
	              var deregOnCancelCellEdit = $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                cancelEdit();
	                deregOnCancelCellEdit();
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	              });
	
	              $scope.$broadcast(uiGridEditConstants.events.BEGIN_CELL_EDIT, triggerEvent);
	              $timeout(function () {
	                // execute in a timeout to give any complex editor templates a cycle to completely render
	                $scope.grid.api.edit.raise.beginCellEdit($scope.row.entity, $scope.col.colDef, triggerEvent);
	              });
	            }
	
	            function endEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	
	              // sometimes the events can't keep up with the keyboard and grid focus is lost, so always focus
	              // back to grid here. The focus call needs to be before the $destroy and removal of the control,
	              // otherwise ng-model-options of UpdateOn: 'blur' will not work.
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                uiGridCtrl.focus();
	              }
	
	              var gridCellContentsEl = angular.element($elm.children()[0]);
	              // remove edit element
	              editCellScope.$destroy();
	              var children = $elm.children();
	              for (var i = 1; i < children.length; i++) {
	                angular.element(children[i]).remove();
	              }
	              gridCellContentsEl.removeClass('ui-grid-cell-contents-hidden');
	              inEdit = false;
	              registerBeginEditEvents();
	              $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.EDIT );
	            }
	
	            function cancelEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	              cellModel.assign($scope, origCellValue);
	              $scope.$apply();
	
	              $scope.grid.api.edit.raise.cancelCellEdit($scope.row.entity, $scope.col.colDef);
	              endEdit();
	            }
	
	            // resolves a string path against the given object
	            // shamelessly borrowed from
	            // http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key
	            function resolveObjectFromPath(object, path) {
	              path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
	              path = path.replace(/^\./, '');           // strip a leading dot
	              var a = path.split('.');
	              while (a.length) {
	                  var n = a.shift();
	                  if (n in object) {
	                      object = object[n];
	                  } else {
	                      return;
	                  }
	              }
	              return object;
	            }
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditor
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditor',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants','$timeout', 'uiGridEditService',
	      function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl, renderContainerCtrl, ngModel;
	                if (controllers[0]) { uiGridCtrl = controllers[0]; }
	                if (controllers[1]) { renderContainerCtrl = controllers[1]; }
	                if (controllers[2]) { ngModel = controllers[2]; }
	
	                // set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  // must be in a timeout since it requires a new digest cycle
	                  $timeout(function () {
	                    $elm[0].focus();
	                    // only select text if it is not being replaced below in the cellNav viewPortKeyPress
	                    if ($elm[0].select && ($scope.col.colDef.enableCellEditOnFocus || !(uiGridCtrl && uiGridCtrl.grid.api.cellNav))) {
	                      $elm[0].select();
	                    }
	                    else {
	                      // some browsers (Chrome) stupidly, imo, support the w3 standard that number, email, ...
	                      // fields should not allow setSelectionRange.  We ignore the error for those browsers
	                      // https://www.w3.org/Bugs/Public/show_bug.cgi?id=24796
	                      try {
	                        $elm[0].setSelectionRange($elm[0].value.length, $elm[0].value.length);
	                      }
	                      catch (ex) {
	                        // ignore
	                      }
	                    }
	                  });
	
	                  // set the keystroke that started the edit event
	                  // we must do this because the BeginEdit is done in a different event loop than the intitial
	                  // keydown event
	                  // fire this event for the keypress that is received
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    var viewPortKeyDownUnregister = uiGridCtrl.grid.api.cellNav.on.viewPortKeyPress($scope, function (evt, rowCol) {
	                      if (uiGridEditService.isStartEditKey(evt)) {
	                        var code = typeof evt.which === 'number' ? evt.which : evt.keyCode;
	                        if (code > 0) {
	                          ngModel.$setViewValue(String.fromCharCode(code), evt);
	                          ngModel.$render();
	                        }
	                      }
	                      viewPortKeyDownUnregister();
	                    });
	                  }
	
	                  // macOS will blur the checkbox when clicked in Safari and Firefox,
	                  // to get around this, we disable the blur handler on mousedown,
	                  // and then focus the checkbox and re-enable the blur handler after $timeout
	                  $elm.on('mousedown', function(evt) {
	                    if ($elm[0].type === 'checkbox') {
	                      $elm.off('blur', $scope.stopEdit);
	                      $timeout(function() {
	                        $elm[0].focus();
	                        $elm.on('blur', $scope.stopEdit);
	                      });
	                    }
	                  });
	
	                  if ($elm[0]) {
	                    $elm[0].focus();
	                  }
	                  $elm.on('blur', $scope.stopEdit);
	                });
	
	
	                $scope.deepEdit = false;
	
	                $scope.stopEdit = function (evt) {
	                  if ($scope.inputForm && !$scope.inputForm.$valid) {
	                    evt.stopPropagation();
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                  else {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  }
	                  $scope.deepEdit = false;
	                };
	
	
	                $elm.on('click', function (evt) {
	                  if ($elm[0].type !== 'checkbox') {
	                    $scope.deepEdit = true;
	                    $scope.$applyAsync(function () {
	                      $scope.grid.disableScrolling = true;
	                    });
	                  }
	                });
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	
	                  if ($scope.deepEdit &&
	                    (evt.keyCode === uiGridConstants.keymap.LEFT ||
	                     evt.keyCode === uiGridConstants.keymap.RIGHT ||
	                     evt.keyCode === uiGridConstants.keymap.UP ||
	                     evt.keyCode === uiGridConstants.keymap.DOWN)) {
	                    evt.stopPropagation();
	                  }
	                  // Pass the keydown event off to the cellNav service, if it exists
	                  else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    // handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	
	                  return true;
	                });
	
	                $scope.$on('$destroy', function unbindEvents() {
	                  // unbind all jquery events in order to avoid memory leaks
	                  $elm.off();
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:input
	   *  @element input
	   *  @restrict E
	   *
	   *  @description directive to provide binding between input[date] value and ng-model for angular 1.2
	   *  It is similar to input[date] directive of angular 1.3
	   *
	   *  Supported date format for input is 'yyyy-MM-dd'
	   *  The directive will set the $valid property of input element and the enclosing form to false if
	   *  model is invalid date or value of input is entered wrong.
	   *
	   */
	    module.directive('uiGridEditor', ['$filter', function ($filter) {
	      function parseDateString(dateString) {
	        if (typeof(dateString) === 'undefined' || dateString === '') {
	          return null;
	        }
	        var parts = dateString.split('-');
	        if (parts.length !== 3) {
	          return null;
	        }
	        var year = parseInt(parts[0], 10);
	        var month = parseInt(parts[1], 10);
	        var day = parseInt(parts[2], 10);
	
	        if (month < 1 || year < 1 || day < 1) {
	          return null;
	        }
	        return new Date(year, (month - 1), day);
	      }
	      return {
	        priority: -100, // run after default uiGridEditor directive
	        require: '?ngModel',
	        link: function (scope, element, attrs, ngModel) {
	          if (angular.version.minor === 2 && attrs.type && attrs.type === 'date' && ngModel) {
	            ngModel.$formatters.push(function (modelValue) {
	              ngModel.$setValidity(null,(!modelValue || !isNaN(modelValue.getTime())));
	              return $filter('date')(modelValue, 'yyyy-MM-dd');
	            });
	
	            ngModel.$parsers.push(function (viewValue) {
	              if (viewValue && viewValue.length > 0) {
	                var dateValue = parseDateString(viewValue);
	                ngModel.$setValidity(null, (dateValue && !isNaN(dateValue.getTime())));
	                return dateValue;
	              }
	              else {
	                ngModel.$setValidity(null, true);
	                return null;
	              }
	            });
	          }
	        }
	      };
	    }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditDropdown
	   *  @element div
	   *  @restrict A
	   *
	   *  @description dropdown editor for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown, and any left/right nav
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditDropdown',
	    ['uiGridConstants', 'uiGridEditConstants', '$timeout',
	      function (uiGridConstants, uiGridEditConstants, $timeout) {
	        return {
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          scope: true,
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl = controllers[0];
	                var renderContainerCtrl = controllers[1];
	
	                // set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $timeout(function() {
	                    $elm[0].focus();
	                  });
	
	                  $elm[0].style.width = ($elm[0].parentElement.offsetWidth - 1) + 'px';
	                  $elm.on('blur', function (evt) {
	                    $scope.stopEdit(evt);
	                  });
	                });
	
	
	                $scope.stopEdit = function (evt) {
	                  // no need to validate a dropdown - invalid values shouldn't be
	                  // available in the list
	                  $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                };
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    // handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	                  return true;
	                });
	
	                $scope.$on('$destroy', function unbindEvents() {
	                  // unbind jquery events to prevent memory leaks
	                  $elm.off();
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditFileChooser
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditFileChooser',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants',
	      function (gridUtil, uiGridConstants, uiGridEditConstants) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm) {
	                function handleFileSelect(event) {
	                  var target = event.srcElement || event.target;
	
	                  if (target && target.files && target.files.length > 0) {
	                    /**
	                     *  @ngdoc property
	                     *  @name editFileChooserCallback
	                     *  @propertyOf  ui.grid.edit.api:ColumnDef
	                     *  @description A function that should be called when any files have been chosen
	                     *  by the user.  You should use this to process the files appropriately for your
	                     *  application.
	                     *
	                     *  It passes the gridCol, the gridRow (from which you can get gridRow.entity),
	                     *  and the files.  The files are in the format as returned from the file chooser,
	                     *  an array of files, with each having useful information such as:
	                     *  - `files[0].lastModifiedDate`
	                     *  - `files[0].name`
	                     *  - `files[0].size`  (appears to be in bytes)
	                     *  - `files[0].type`  (MIME type by the looks)
	                     *
	                     *  Typically you would do something with these files - most commonly you would
	                     *  use the filename or read the file itself in.  The example function does both.
	                     *
	                     *  @example
	                     *  <pre>
	                     *  editFileChooserCallBack: function(gridRow, gridCol, files ) {
	                     *    // ignore all but the first file, it can only choose one anyway
	                     *    // set the filename into this column
	                     *    gridRow.entity.filename = file[0].name;
	                     *
	                     *    // read the file and set it into a hidden column, which we may do stuff with later
	                     *    var setFile = function(fileContent) {
	                     *      gridRow.entity.file = fileContent.currentTarget.result;
	                     *    };
	                     *    var reader = new FileReader();
	                     *    reader.onload = setFile;
	                     *    reader.readAsText( files[0] );
	                     *  }
	                     *  </pre>
	                     */
	                    if ( typeof($scope.col.colDef.editFileChooserCallback) === 'function' ) {
	                      $scope.col.colDef.editFileChooserCallback($scope.row, $scope.col, target.files);
	                    } else {
	                      gridUtil.logError('You need to set colDef.editFileChooserCallback to use the file chooser');
	                    }
	
	                    target.form.reset();
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  } else {
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                  $elm[0].removeEventListener('change', handleFileSelect, false);
	                }
	
	                $elm[0].addEventListener('change', handleFileSelect, false);
	
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $elm[0].focus();
	                  $elm[0].select();
	
	                  $elm.on('blur', function () {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                    $elm.off();
	                  });
	                });
	              }
	            };
	          }
	        };
	      }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.emptyBaseLayer
	   * @description
	   *
	   * # ui.grid.emptyBaseLayer
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to have the background of the ui-grid be empty rows, this would be displayed in the case were
	   * the grid height is greater then the amount of rows displayed.
	   *
	   * <div doc-module-components="ui.grid.emptyBaseLayer"></div>
	   */
	  var module = angular.module('ui.grid.emptyBaseLayer', ['ui.grid']);
	
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.emptyBaseLayer.service:uiGridBaseLayerService
	   *
	   *  @description Services for the empty base layer grid
	   */
	  module.service('uiGridBaseLayerService', ['gridUtil', '$compile', function (gridUtil, $compile) {
	    return {
	      initializeGrid: function (grid, disableEmptyBaseLayer) {
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.emptyBaseLayer.api:GridOptions
	         *
	         *  @description GridOptions for emptyBaseLayer feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        grid.baseLayer = {
	          emptyRows: []
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name enableEmptyGridBaseLayer
	         *  @propertyOf  ui.grid.emptyBaseLayer.api:GridOptions
	         *  @description Enable empty base layer, which shows empty rows as background on the entire grid
	         *  <br/>Defaults to true, if the directive is used.
	         *  <br/>Set to false either by setting this attribute or passing false to the directive.
	         */
	        // default option to true unless it was explicitly set to false
	        if (grid.options.enableEmptyGridBaseLayer !== false) {
	          grid.options.enableEmptyGridBaseLayer = !disableEmptyBaseLayer;
	        }
	      },
	
	      setNumberOfEmptyRows: function(viewportHeight, grid) {
	        var rowHeight = grid.options.rowHeight,
	          rows = Math.ceil(viewportHeight / rowHeight);
	
	        if (rows > 0) {
	          grid.baseLayer.emptyRows = [];
	          for (var i = 0; i < rows; i++) {
	            grid.baseLayer.emptyRows.push({});
	          }
	        }
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.emptyBaseLayer.directive:uiGridEmptyBaseLayer
	   *  @description Shows empty rows in the background of the ui-grid, these span
	   *  the full height of the ui-grid, so that there won't be blank space below the shown rows.
	   *  @example
	   *  <pre>
	   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer></div>
	   *  </pre>
	   *  Or you can enable/disable it dynamically by passing in true or false. It doesn't
	   *  the value, so it would only be set on initial render.
	   *  <pre>
	   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer="false"></div>
	   *  </pre>
	   */
	  module.directive('uiGridEmptyBaseLayer', ['gridUtil', 'uiGridBaseLayerService',
	      '$parse',
	    function (gridUtil, uiGridBaseLayerService, $parse) {
	      return {
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var disableEmptyBaseLayer = $parse($attrs.uiGridEmptyBaseLayer)($scope) === false;
	
	              uiGridBaseLayerService.initializeGrid(uiGridCtrl.grid, disableEmptyBaseLayer);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              if (!uiGridCtrl.grid.options.enableEmptyGridBaseLayer) {
	                return;
	              }
	
	              var renderBodyContainer = uiGridCtrl.grid.renderContainers.body,
	                viewportHeight = renderBodyContainer.getViewportHeight();
	
	              function heightHasChanged() {
	                var newViewPortHeight = renderBodyContainer.getViewportHeight();
	
	                if (newViewPortHeight !== viewportHeight) {
	                  viewportHeight = newViewPortHeight;
	                  return true;
	                }
	                return false;
	              }
	
	              function getEmptyBaseLayerCss(viewportHeight) {
	                // Set ui-grid-empty-base-layer height
	                return '.grid' + uiGridCtrl.grid.id +
	                  ' .ui-grid-render-container ' +
	                  '.ui-grid-empty-base-layer-container.ui-grid-canvas ' +
	                  '{ height: ' + viewportHeight + 'px; }';
	              }
	
	              uiGridCtrl.grid.registerStyleComputation({
	                func: function() {
	                  if (heightHasChanged()) {
	                    uiGridBaseLayerService.setNumberOfEmptyRows(viewportHeight, uiGridCtrl.grid);
	                  }
	                  return getEmptyBaseLayerCss(viewportHeight);
	                }
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.emptyBaseLayer.directive:uiGridViewport
	   *  @description stacks on the uiGridViewport directive to append the empty grid base layer html elements to the
	   *  default gridRow template
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm) {
	            var emptyBaseLayerContainer = $templateCache.get('ui-grid/emptyBaseLayerContainer');
	            $elm.prepend(emptyBaseLayerContainer);
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.expandable
	   * @description
	   *
	   * # ui.grid.expandable
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to create subgrids with the ability to expand a row
	   * to show the subgrid.
	   *
	   * <div doc-module-components="ui.grid.expandable"></div>
	   */
	  var module = angular.module('ui.grid.expandable', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.expandable.service:uiGridExpandableService
	   *
	   *  @description Services for the expandable grid
	   */
	  module.service('uiGridExpandableService', ['gridUtil', function (gridUtil) {
	    var service = {
	      initializeGrid: function (grid) {
	
	        grid.expandable = {};
	        grid.expandable.expandedAll = false;
	
	        /**
	         *  @ngdoc boolean
	         *  @name enableOnDblClickExpand
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      onDblClickExpand: false
	         *    }
	         *  </pre>
	         */
	        grid.options.enableOnDblClickExpand = grid.options.enableOnDblClickExpand !== false;
	        /**
	         *  @ngdoc boolean
	         *  @name enableExpandable
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Whether or not to use expandable feature, allows you to turn off expandable on specific grids
	         *  within your application, or in specific modes on _this_ grid. Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      enableExpandable: false
	         *    }
	         *  </pre>
	         */
	        grid.options.enableExpandable = grid.options.enableExpandable !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name showExpandAllButton
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Whether or not to display the expand all button, allows you to hide expand all button on specific grids
	         *  within your application, or in specific modes on _this_ grid. Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      showExpandAllButton: false
	         *    }
	         *  </pre>
	         */
	        grid.options.showExpandAllButton = grid.options.showExpandAllButton !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowHeight
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Height in pixels of the expanded subgrid.  Defaults to
	         *  150
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeight: 150
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeight = grid.options.expandableRowHeight || 150;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowHeaderWidth
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Width in pixels of the expandable column. Defaults to 40
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeaderWidth: 40
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeaderWidth = grid.options.expandableRowHeaderWidth || 40;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowTemplate
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Mandatory. The template for your expanded row
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowTemplate: 'expandableRowTemplate.html'
	         *    }
	         *  </pre>
	         */
	        if ( grid.options.enableExpandable && !grid.options.expandableRowTemplate ) {
	          gridUtil.logError( 'You have not set the expandableRowTemplate, disabling expandable module' );
	          grid.options.enableExpandable = false;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:PublicApi
	         *
	         *  @description Public Api for expandable feature
	         */
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:GridRow
	         *
	         *  @description Additional properties added to GridRow when using the expandable module
	         */
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:GridOptions
	         *
	         *  @description Options for configuring the expandable feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        var publicApi = {
	          events: {
	            expandable: {
	              /**
	               * @ngdoc event
	               * @name rowExpandedBeforeStateChanged
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when row is expanding or collapsing
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedBeforeStateChanged(scope,function(row, event) {})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               * @param {Event} evt object if raised from an event
	               */
	              rowExpandedBeforeStateChanged: function(scope, row, evt) {},
	
	              /**
	               * @ngdoc event
	               * @name rowExpandedStateChanged
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when row expanded or collapsed
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedStateChanged(scope,function(row, event) {})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               * @param {Event} evt object if raised from an event
	               */
	              rowExpandedStateChanged: function (scope, row, evt) {},
	
	              /**
	               * @ngdoc event
	               * @name rowExpandedRendered
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when expanded row is rendered
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedRendered(scope,function(row, event) {})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               * @param {Event} evt object if raised from an event
	               */
	              rowExpandedRendered: function (scope, row, evt) {}
	            }
	          },
	
	          methods: {
	            expandable: {
	              /**
	               * @ngdoc method
	               * @name toggleRowExpansion
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle a specific row
	               * <pre>
	               *      gridApi.expandable.toggleRowExpansion(rowEntity, event);
	               * </pre>
	               * @param {object} rowEntity the data entity for the row you want to expand
	               * @param {Event} [e] event (if exist)
	               */
	              toggleRowExpansion: function (rowEntity, e) {
	                var row = grid.getRow(rowEntity);
	
	                if (row !== null) {
	                  service.toggleRowExpansion(grid, row, e);
	                }
	              },
	
	              /**
	               * @ngdoc method
	               * @name expandAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Expand all subgrids.
	               * <pre>
	               *      gridApi.expandable.expandAllRows();
	               * </pre>
	               */
	              expandAllRows: function() {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name collapseAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Collapse all subgrids.
	               * <pre>
	               *      gridApi.expandable.collapseAllRows();
	               * </pre>
	               */
	              collapseAllRows: function() {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name toggleAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle all subgrids.
	               * <pre>
	               *      gridApi.expandable.toggleAllRows();
	               * </pre>
	               */
	              toggleAllRows: function() {
	                service.toggleAllRows(grid);
	              },
	              /**
	               * @ngdoc function
	               * @name expandRow
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Expand the data row
	               * @param {object} rowEntity gridOptions.data[] array instance
	               */
	              expandRow: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	
	                if (row !== null && !row.isExpanded) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	              /**
	               * @ngdoc function
	               * @name collapseRow
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Collapse the data row
	               * @param {object} rowEntity gridOptions.data[] array instance
	               */
	              collapseRow: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	
	                if (row !== null && row.isExpanded) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	              /**
	               * @ngdoc function
	               * @name getExpandedRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description returns all expandedRow's entity references
	               */
	              getExpandedRows: function () {
	                return service.getExpandedRows(grid).map(function (gridRow) {
	                  return gridRow.entity;
	                });
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      /**
	       *
	       * @param grid
	       * @param row
	       * @param {Event} [e] event (if exist)
	       */
	      toggleRowExpansion: function (grid, row, e) {
	        // trigger the "before change" event. Can change row height dynamically this way.
	        grid.api.expandable.raise.rowExpandedBeforeStateChanged(row);
	        /**
	         *  @ngdoc object
	         *  @name isExpanded
	         *  @propertyOf  ui.grid.expandable.api:GridRow
	         *  @description Whether or not the row is currently expanded.
	         *  @example
	         *  <pre>
	         *    $scope.api.expandable.on.rowExpandedStateChanged($scope, function (row) {
	         *      if (row.isExpanded) {
	         *        //...
	         *      }
	         *    });
	         *  </pre>
	         */
	        row.isExpanded = !row.isExpanded;
	        if (angular.isUndefined(row.expandedRowHeight)) {
	          row.expandedRowHeight = grid.options.expandableRowHeight;
	        }
	
	        if (row.isExpanded) {
	          row.height = row.grid.options.rowHeight + row.expandedRowHeight;
	          grid.expandable.expandedAll = service.getExpandedRows(grid).length === grid.rows.length;
	        }
	        else {
	          row.height = row.grid.options.rowHeight;
	          grid.expandable.expandedAll = false;
	        }
	        grid.api.expandable.raise.rowExpandedStateChanged(row, e);
	
	        // fire event on render complete
	        function _tWatcher() {
	          if (row.expandedRendered) {
	            grid.api.expandable.raise.rowExpandedRendered(row, e);
	          }
	          else {
	            window.setTimeout(_tWatcher, 1e2);
	          }
	        }
	        _tWatcher();
	      },
	
	      expandAllRows: function(grid) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (!row.isExpanded && !(row.entity.subGridOptions && row.entity.subGridOptions.disableRowExpandable)) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = true;
	        grid.queueGridRefresh();
	      },
	
	      collapseAllRows: function(grid) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (row.isExpanded) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = false;
	        grid.queueGridRefresh();
	      },
	
	      toggleAllRows: function(grid) {
	        if (grid.expandable.expandedAll) {
	          service.collapseAllRows(grid);
	        }
	        else {
	          service.expandAllRows(grid);
	        }
	      },
	
	      getExpandedRows: function (grid) {
	        return grid.rows.filter(function (row) {
	          return row.isExpanded;
	        });
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc object
	   *  @name enableExpandableRowHeader
	   *  @propertyOf  ui.grid.expandable.api:GridOptions
	   *  @description Show a rowHeader to provide the expandable buttons.  If set to false then implies
	   *  you're going to use a custom method for expanding and collapsing the subgrids. Defaults to true.
	   *  @example
	   *  <pre>
	   *    $scope.gridOptions = {
	   *      enableExpandableRowHeader: false
	   *    }
	   *  </pre>
	   */
	
	  module.directive('uiGridExpandable', ['uiGridExpandableService', '$templateCache',
	    function (uiGridExpandableService, $templateCache) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridExpandableService.initializeGrid(uiGridCtrl.grid);
	
	              if (!uiGridCtrl.grid.options.enableExpandable) {
	                return;
	              }
	
	              if (uiGridCtrl.grid.options.enableExpandableRowHeader !== false ) {
	                var expandableRowHeaderColDef = {
	                  name: 'expandableButtons',
	                  displayName: '',
	                  exporterSuppressExport: true,
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  width: uiGridCtrl.grid.options.expandableRowHeaderWidth || 30
	                };
	
	                expandableRowHeaderColDef.cellTemplate = $templateCache.get('ui-grid/expandableRowHeader');
	                expandableRowHeaderColDef.headerCellTemplate = $templateCache.get('ui-grid/expandableTopRowHeader');
	                uiGridCtrl.grid.addRowHeaderColumn(expandableRowHeaderColDef, -90);
	              }
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {}
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGrid
	   *  @description stacks on the uiGrid directive to register child grid with parent row when child is created
	   */
	  module.directive('uiGrid',
	    function () {
	      return {
	        replace: true,
	        priority: 599,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              uiGridCtrl.grid.api.core.on.renderingComplete($scope, function() {
	                // if a parent grid row is on the scope, then add the parentRow property to this childGrid
	                if ($scope.row && $scope.row.grid && $scope.row.grid.options
	                  && $scope.row.grid.options.enableExpandable) {
	
	                  /**
	                   *  @ngdoc directive
	                   *  @name ui.grid.expandable.class:Grid
	                   *  @description Additional Grid properties added by expandable module
	                   */
	
	                  /**
	                   *  @ngdoc object
	                   *  @name parentRow
	                   *  @propertyOf ui.grid.expandable.class:Grid
	                   *  @description reference to the expanded parent row that owns this grid
	                   */
	                  uiGridCtrl.grid.parentRow = $scope.row;
	
	                  // todo: adjust height on parent row when child grid height changes. we need some sort of gridHeightChanged event
	                 // uiGridCtrl.grid.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
	                 //   uiGridCtrl.grid.parentRow = newHeight;
	                 // });
	                }
	              });
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {}
	          };
	        }
	      };
	    });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridExpandableRow
	   *  @description directive to render the Row template on Expand
	   */
	  module.directive('uiGridExpandableRow',
	  ['uiGridExpandableService', '$compile', 'uiGridConstants','gridUtil',
	    function (uiGridExpandableService, $compile, uiGridConstants, gridUtil) {
	
	      return {
	        replace: false,
	        priority: 0,
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm) {
	              gridUtil.getTemplate($scope.grid.options.expandableRowTemplate).then(
	                function (template) {
	                  if ($scope.grid.options.expandableRowScope) {
	                    /**
	                     *  @ngdoc object
	                     *  @name expandableRowScope
	                     *  @propertyOf  ui.grid.expandable.api:GridOptions
	                     *  @description  Variables of object expandableScope will be available in the scope of the expanded subgrid
	                     *  @example
	                     *  <pre>
	                     *    $scope.gridOptions = {
	                     *      expandableRowScope: expandableScope
	                     *    }
	                     *  </pre>
	                     */
	                    var expandableRowScope = $scope.grid.options.expandableRowScope;
	
	                    for (var property in expandableRowScope) {
	                      if (expandableRowScope.hasOwnProperty(property)) {
	                        $scope[property] = expandableRowScope[property];
	                      }
	                    }
	                  }
	                  var expandedRowElement = angular.element(template);
	
	                  expandedRowElement = $compile(expandedRowElement)($scope);
	                  $elm.append(expandedRowElement);
	                  $scope.row.element = $elm;
	                  $scope.row.expandedRendered = true;
	              });
	            },
	
	            post: function ($scope, $elm) {
	              $scope.row.element = $elm;
	              $scope.$on('$destroy', function() {
	                $scope.row.expandedRendered = false;
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridRow
	   *  @description stacks on the uiGridRow directive to add support for expandable rows
	   */
	  module.directive('uiGridRow',
	      function () {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function () {
	            return {
	              pre: function ($scope, $elm) {
	                if (!$scope.grid.options.enableExpandable) {
	                  return;
	                }
	
	                $scope.expandableRow = {};
	
	                $scope.expandableRow.shouldRenderExpand = function () {
	                  return $scope.colContainer.name === 'body'
	                    && $scope.grid.options.enableExpandable !== false
	                    && $scope.row.isExpanded
	                    && (!$scope.grid.isScrollingVertically || $scope.row.expandedRendered);
	                };
	
	                $scope.expandableRow.shouldRenderFiller = function () {
	                  return $scope.row.isExpanded
	                    && (
	                      $scope.colContainer.name !== 'body'
	                      || ($scope.grid.isScrollingVertically && !$scope.row.expandedRendered));
	                };
	
	                if ($scope.grid.options.enableOnDblClickExpand) {
	                  $elm.on('dblclick', function (event) {
	                    // if necessary, it is possible for everyone to stop the processing of a single click OR
	                    // Inside the Config in the output agent to enter a line:
	                    // event.stopPropagation()
	                    $scope.grid.api.expandable.toggleRowExpansion($scope.row.entity, event);
	                  });
	                }
	              },
	              post: function ($scope, $elm, $attrs, controllers) {}
	            };
	          }
	        };
	      });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridViewport
	   *  @description stacks on the uiGridViewport directive to append the expandable row html elements to the
	   *  default gridRow template
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm) {
	
	             // todo: this adds ng-if watchers to each row even if the grid is not using expandable directive
	             //      or options.enableExpandable == false
	             //      The alternative is to compile the template and append to each row in a uiGridRow directive
	
	            var rowRepeatDiv = angular.element($elm.children().children()[0]),
	              expandedRowFillerElement = $templateCache.get('ui-grid/expandableScrollFiller'),
	              expandedRowElement = $templateCache.get('ui-grid/expandableRow');
	
	            rowRepeatDiv.append(expandedRowElement);
	            rowRepeatDiv.append(expandedRowFillerElement);
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	/* global ExcelBuilder */
	/* global console */
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.exporter
	   * @description
	   *
	   * # ui.grid.exporter
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to export data from the grid.
	   *
	   * Data can be exported in a range of formats, and all data, visible
	   * data, or selected rows can be exported, with all columns or visible
	   * columns.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate, or enable the gridMenu
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.exporter"></div>
	   */
	
	  var module = angular.module('ui.grid.exporter', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.exporter.constant:uiGridExporterConstants
	   *
	   *  @description constants available in exporter module
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name ALL
	   * @description export all data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name VISIBLE
	   * @description export only visible data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name SELECTED
	   * @description export all data, including data not visible.  Can
	   * be set only for rowTypes, selection of only some columns is
	   * not supported
	   */
	  module.constant('uiGridExporterConstants', {
	    featureName: 'exporter',
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    selectionRowHeaderColName: 'selectionRowHeaderCol',
	    ALL: 'all',
	    VISIBLE: 'visible',
	    SELECTED: 'selected',
	    CSV_CONTENT: 'CSV_CONTENT',
	    BUTTON_LABEL: 'BUTTON_LABEL',
	    FILE_NAME: 'FILE_NAME'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.exporter.service:uiGridExporterService
	   *
	   *  @description Services for exporter feature
	   */
	  module.service('uiGridExporterService', ['$filter', '$q', 'uiGridExporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService',
	    function ($filter, $q, uiGridExporterConstants, gridUtil, $compile, $interval, i18nService) {
	      var service = {
	
	        delay: 100,
	
	        initializeGrid: function (grid) {
	
	          // add feature namespace and any properties to grid for needed state
	          grid.exporter = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.exporter.api:PublicApi
	           *
	           *  @description Public Api for exporter feature
	           */
	          var publicApi = {
	            events: {
	              exporter: {
	              }
	            },
	            methods: {
	              exporter: {
	                /**
	                 * @ngdoc function
	                 * @name csvExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in csv format,
	                 * the data exported is selected based on the provided options
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                csvExport: function (rowTypes, colTypes) {
	                  service.csvExport(grid, rowTypes, colTypes);
	                },
	                /**
	                 * @ngdoc function
	                 * @name pdfExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in pdf format,
	                 * the data exported is selected based on the provided options
	                 * Note that this function has a dependency on pdfMake, all
	                 * going well this has been installed for you.
	                 * The resulting pdf opens in a new browser window.
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                pdfExport: function (rowTypes, colTypes) {
	                  service.pdfExport(grid, rowTypes, colTypes);
	                },
	                /**
	                 * @ngdoc function
	                 * @name excelExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in excel format,
	                 * the data exported is selected based on the provided options
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                excelExport: function (rowTypes, colTypes) {
	                  service.excelExport(grid, rowTypes, colTypes);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if (grid.api.core.addToGridMenu) {
	            service.addToMenu( grid );
	          } else {
	            // order of registration is not guaranteed, register in a little while
	            $interval( function() {
	              if (grid.api.core.addToGridMenu) {
	                service.addToMenu( grid );
	              }
	            }, this.delay, 1);
	          }
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:GridOptions
	           *
	           * @description GridOptions for exporter feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:ColumnDef
	           * @description ColumnDef settings for exporter
	           */
	          /**
	           * @ngdoc object
	           * @name exporterSuppressMenu
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Don't show the export menu button, implying the user
	           * will roll their own UI for calling the exporter
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterSuppressMenu = gridOptions.exporterSuppressMenu === true;
	          /**
	           * @ngdoc object
	           * @name exporterMenuLabel
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The text to show on the exporter menu button
	           * link
	           * <br/>Defaults to 'Export'
	           */
	          gridOptions.exporterMenuLabel = gridOptions.exporterMenuLabel ? gridOptions.exporterMenuLabel : 'Export';
	          /**
	           * @ngdoc object
	           * @name exporterSuppressColumns
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Columns that should not be exported.  The selectionRowHeader is already automatically
	           * suppressed, but if you had a button column or some other "system" column that shouldn't be shown in the
	           * output then add it in this list.  You should provide an array of column names.
	           * <br/>Defaults to: []
	           * <pre>
	           *   gridOptions.exporterSuppressColumns = [ 'buttons' ];
	           * </pre>
	           */
	          gridOptions.exporterSuppressColumns = gridOptions.exporterSuppressColumns ? gridOptions.exporterSuppressColumns : [];
	          /**
	           * @ngdoc object
	           * @name exporterCsvColumnSeparator
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The character to use as column separator
	           * link
	           * <br/>Defaults to ','
	           */
	          gridOptions.exporterCsvColumnSeparator = gridOptions.exporterCsvColumnSeparator ? gridOptions.exporterCsvColumnSeparator : ',';
	          /**
	           * @ngdoc object
	           * @name exporterCsvFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded csv.
	           * This will only work in some browsers.
	           * <br/>Defaults to 'download.csv'
	           */
	          gridOptions.exporterCsvFilename = gridOptions.exporterCsvFilename ? gridOptions.exporterCsvFilename : 'download.csv';
	          /**
	           * @ngdoc object
	           * @name exporterPdfFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded pdf, only used in IE (other browsers open pdfs in a new window)
	           * <br/>Defaults to 'download.pdf'
	           */
	          gridOptions.exporterPdfFilename = gridOptions.exporterPdfFilename ? gridOptions.exporterPdfFilename : 'download.pdf';
	          /**
	           * @ngdoc object
	           * @name exporterExcelFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded excel, only used in IE (other browsers open excels in a new window)
	           * <br/>Defaults to 'download.xlsx'
	           */
	          gridOptions.exporterExcelFilename = gridOptions.exporterExcelFilename ? gridOptions.exporterExcelFilename : 'download.xlsx';
	
	          /**
	           * @ngdoc object
	           * @name exporterExcelSheetName
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default sheetname to use when saving the downloaded to excel
	           * <br/>Defaults to 'Sheet1'
	           */
	          gridOptions.exporterExcelSheetName = gridOptions.exporterExcelSheetName ? gridOptions.exporterExcelSheetName : 'Sheet1';
	
	          /**
	           * @ngdoc object
	           * @name exporterOlderExcelCompatibility
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Some versions of excel don't like the utf-16 BOM on the front, and it comes
	           * through as ï»¿ in the first column header.  Setting this option to false will suppress this, at the
	           * expense of proper utf-16 handling in applications that do recognise the BOM
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterOlderExcelCompatibility = gridOptions.exporterOlderExcelCompatibility === true;
	          /**
	           * @ngdoc object
	           * @name exporterIsExcelCompatible
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Separator header, used to set a custom column separator in a csv file, only works on MS Excel.
	           * Used it on other programs will make csv content display unproperly. Setting this option to false won't add this header.
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterIsExcelCompatible = gridOptions.exporterIsExcelCompatible === true;
	          /**
	           * @ngdoc object
	           * @name exporterMenuItemOrder
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description An option to determine the starting point for the menu items created by the exporter
	           * <br/>Defaults to 200
	           */
	          gridOptions.exporterMenuItemOrder = gridOptions.exporterMenuItemOrder ? gridOptions.exporterMenuItemOrder : 200;
	          /**
	           * @ngdoc object
	           * @name exporterPdfDefaultStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     fontSize: 11
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfDefaultStyle = gridOptions.exporterPdfDefaultStyle ? gridOptions.exporterPdfDefaultStyle : { fontSize: 11 };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The table style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     margin: [0, 5, 0, 15]
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableStyle = gridOptions.exporterPdfTableStyle ? gridOptions.exporterPdfTableStyle : { margin: [0, 5, 0, 15] };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableHeaderStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The tableHeader style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     bold: true,
	           *     fontSize: 12,
	           *     color: 'black'
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableHeaderStyle = gridOptions.exporterPdfTableHeaderStyle ? gridOptions.exporterPdfTableHeaderStyle : { bold: true, fontSize: 12, color: 'black' };
	          /**
	           * @ngdoc object
	           * @name exporterPdfHeader
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = 'My Header';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfHeader: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfHeader = gridOptions.exporterPdfHeader ? gridOptions.exporterPdfHeader : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfFooter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = 'My Footer';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfFooter: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfFooter = gridOptions.exporterPdfFooter ? gridOptions.exporterPdfFooter : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfOrientation
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake value,
	           * 'landscape' or 'portrait'
	           * <br/>Defaults to landscape
	           */
	          gridOptions.exporterPdfOrientation = gridOptions.exporterPdfOrientation ? gridOptions.exporterPdfOrientation : 'landscape';
	          /**
	           * @ngdoc object
	           * @name exporterPdfPageSize
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake
	           * paper size, usually 'A4' or 'LETTER'
	           * {@link https://github.com/bpampuch/pdfmake/blob/master/src/standardPageSizes.js pdfMake page sizes}
	           * <br/>Defaults to A4
	           */
	          gridOptions.exporterPdfPageSize = gridOptions.exporterPdfPageSize ? gridOptions.exporterPdfPageSize : 'A4';
	          /**
	           * @ngdoc object
	           * @name exporterPdfMaxGridWidth
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The maxium grid width - the current grid width
	           * will be scaled to match this, with any fixed width columns
	           * being adjusted accordingly.
	           * <br/>Defaults to 720 (for A4 landscape), use 670 for LETTER
	           */
	          gridOptions.exporterPdfMaxGridWidth = gridOptions.exporterPdfMaxGridWidth ? gridOptions.exporterPdfMaxGridWidth : 720;
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableLayout
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A tableLayout in pdfMake format,
	           * controls gridlines and the like.  We use the default
	           * layout usually.
	           * <br/>Defaults to null, which means no layout
	           */
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuAllData
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add export all data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuAllData = gridOptions.exporterMenuAllData !== undefined ? gridOptions.exporterMenuAllData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuVisibleData
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add export visible data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuVisibleData = gridOptions.exporterMenuVisibleData !== undefined ? gridOptions.exporterMenuVisibleData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuSelectedData
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add export selected data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuSelectedData = gridOptions.exporterMenuSelectedData !== undefined ? gridOptions.exporterMenuSelectedData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuCsv
	           * @propertyOf ui.grid.exporter.api:GridOptions
	           * @description Add csv export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuCsv = gridOptions.exporterMenuCsv !== undefined ? gridOptions.exporterMenuCsv : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuPdf
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add pdf export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuPdf = gridOptions.exporterMenuPdf !== undefined ? gridOptions.exporterMenuPdf : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuExcel
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add excel export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuExcel = gridOptions.exporterMenuExcel !== undefined ? gridOptions.exporterMenuExcel : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterPdfCustomFormatter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A custom callback routine that changes the pdf document, adding any
	           * custom styling or content that is supported by pdfMake.  Takes in the complete docDefinition, and
	           * must return an updated docDefinition ready for pdfMake.
	           * @example
	           * In this example we add a style to the style array, so that we can use it in our
	           * footer definition.
	           * <pre>
	           *   gridOptions.exporterPdfCustomFormatter = function ( docDefinition ) {
	           *     docDefinition.styles.footerStyle = { bold: true, fontSize: 10 };
	           *     return docDefinition;
	           *   }
	           *
	           *   gridOptions.exporterPdfFooter = { text: 'My footer', style: 'footerStyle' }
	           * </pre>
	           */
	          gridOptions.exporterPdfCustomFormatter = ( gridOptions.exporterPdfCustomFormatter && typeof( gridOptions.exporterPdfCustomFormatter ) === 'function' ) ? gridOptions.exporterPdfCustomFormatter : function ( docDef ) { return docDef; };
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilterUseName
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Defaults to false, which leads to `displayName` being passed into the headerFilter.
	           * If set to true, then will pass `name` instead.
	           *
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilterUseName = true;
	           * </pre>
	           */
	          gridOptions.exporterHeaderFilterUseName = gridOptions.exporterHeaderFilterUseName === true;
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to apply to the header displayNames before exporting.  Useful for internationalisation,
	           * for example if you were using angular-translate you'd set this to `$translate.instant`.  Note that this
	           * call must be synchronous, it cannot be a call that returns a promise.
	           *
	           * Behaviour can be changed to pass in `name` instead of `displayName` through use of `exporterHeaderFilterUseName: true`.
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = function( displayName ) { return 'col: ' + name; };
	           * </pre>
	           * OR
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = $translate.instant;
	           * </pre>
	           */
	
	          /**
	           * @ngdoc function
	           * @name exporterFieldCallback
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call for each field before exporting it.  Allows
	           * massaging of raw data into a display format, for example if you have applied
	           * filters to convert codes into decodes, or you require
	           * a specific date format in the exported content.
	           *
	           * The method is called once for each field exported, and provides the grid, the
	           * gridCol and the GridRow for you to use as context in massaging the data.
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {GridRow} row the row from which the data comes
	           * @param {GridColumn} col the column from which the data comes
	           * @param {object} value the value for your massaging
	           * @returns {object} you must return the massaged value ready for exporting
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
	           *     if ( col.name === 'status' ) {
	           *       value = decodeStatus( value );
	           *     }
	           *     return value;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterFieldCallback = gridOptions.exporterFieldCallback ? gridOptions.exporterFieldCallback : defaultExporterFieldCallback;
	
	          /**
	           * @ngdoc function
	           * @name exporterFieldFormatCallback
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call for each field before exporting it.  Allows
	           * general object to be return to modify the format of a cell in the case of
	           * excel exports
	           *
	           * The method is called once for each field exported, and provides the grid, the
	           * gridCol and the GridRow for you to use as context in massaging the data.
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {GridRow} row the row from which the data comes
	           * @param {GridColumn} col the column from which the data comes
	           * @param {object} value the value for your massaging
	           * @returns {object} you must return the massaged value ready for exporting
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
	           *     if ( col.name === 'status' ) {
	           *       value = decodeStatus( value );
	           *     }
	           *     return value;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterFieldFormatCallback = gridOptions.exporterFieldFormatCallback ? gridOptions.exporterFieldFormatCallback : function( grid, row, col, value ) { return null; };
	
	          /**
	           * @ngdoc function
	           * @name exporterExcelCustomFormatters
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call to setup formatters and store on docDefinition.
	           *
	           * The method is called at the start and can setup all the formatters to export to excel
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {Workbook} row the row from which the data comes
	           * @param {docDefinition} The docDefinition that will have styles as a object to store formatters
	           * @returns {docDefinition} Updated docDefinition with formatter styles
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterExcelCustomFormatters = function(grid, workbook, docDefinition) {
	           *     const formatters = {};
	           *     const stylesheet = workbook.getStyleSheet();
	           *     const headerFormatDefn = {
	           *       'font': { 'size': 11, 'fontName': 'Calibri', 'bold': true },
	           *       'alignment': { 'wrapText': false }
	           *     };
	           *
	           *     formatters['header'] = headerFormatter;
	           *     Object.assign(docDefinition.styles , formatters);
	           *     grid.docDefinition = docDefinition;
	           *     return docDefinition;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterExcelCustomFormatters = gridOptions.exporterExcelCustomFormatters ? gridOptions.exporterExcelCustomFormatters : function( grid, workbook, docDefinition ) { return docDefinition; };
	
	          /**
	           * @ngdoc function
	           * @name exporterExcelHeader
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to write formatted header data to sheet.
	           *
	           * The method is called to provide custom header building for Excel. This data comes before the grid header
	           *
	           * @param {grid} grid provides the grid in case you have need of it
	           * @param {Workbook} row the row from which the data comes
	           * @param {Sheet} the sheet to insert data
	           * @param {docDefinition} The docDefinition that will have styles as a object to store formatters
	           * @returns {docDefinition} Updated docDefinition with formatter styles
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterExcelCustomFormatters = function (grid, workbook, sheet, docDefinition) {
	           *      const headerFormatter = docDefinition.styles['header'];
	           *      let cols = [];
	           *      // push data in A1 cell with metadata formatter
	           *      cols.push({ value: 'Summary Report', metadata: {style: headerFormatter.id} });
	           *      sheet.data.push(cols);
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterExcelHeader = gridOptions.exporterExcelHeader ? gridOptions.exporterExcelHeader : function( grid, workbook, sheet, docDefinition ) { return null; };
	
	
	          /**
	           * @ngdoc object
	           * @name exporterColumnScaleFactor
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A scaling factor to divide the drawnwidth of a column to convert to target excel column
	           * format size
	           * @example
	           * In this example we add a number to divide the drawnwidth of a column to get the excel width.
	           * <br/>Defaults to 3.5
	           */
	          gridOptions.exporterColumnScaleFactor = gridOptions.exporterColumnScaleFactor ? gridOptions.exporterColumnScaleFactor : 3.5;
	
	          /**
	           * @ngdoc object
	           * @name exporterFieldApplyFilters
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Defaults to false, which leads to filters being evaluated on export           *
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldApplyFilters = true;
	           * </pre>
	           */
	          gridOptions.exporterFieldApplyFilters = gridOptions.exporterFieldApplyFilters === true;
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataFn
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description This promise is needed when exporting all rows,
	           * and the data need to be provided by server side. Default is null.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterAllDataFn = gridOptions.exporterAllDataFn ? gridOptions.exporterAllDataFn : null;
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataPromise
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description DEPRECATED - exporterAllDataFn used to be
	           * called this, but it wasn't a promise, it was a function that returned
	           * a promise.  Deprecated, but supported for backward compatibility, use
	           * exporterAllDataFn instead.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          if ( gridOptions.exporterAllDataFn === null && gridOptions.exporterAllDataPromise ) {
	            gridOptions.exporterAllDataFn = gridOptions.exporterAllDataPromise;
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Adds export items to the grid menu,
	         * allowing the user to select export options
	         * @param {Grid} grid the grid from which data should be exported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsCsv'),
	              action: function () {
	                grid.api.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsCsv'),
	              action: function () {
	                grid.api.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 1
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsCsv'),
	              action: function () {
	                grid.api.exporter.csvExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuSelectedData &&
	                       ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 2
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsPdf'),
	              action: function () {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder + 3
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsPdf'),
	              action: function () {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 4
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsPdf'),
	              action: function () {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuSelectedData &&
	                       ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 5
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsExcel'),
	              action: function () {
	                grid.api.exporter.excelExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder + 6
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsExcel'),
	              action: function () {
	                grid.api.exporter.excelExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 7
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsExcel'),
	              action: function () {
	                grid.api.exporter.excelExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuSelectedData &&
	                  ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 8
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name csvExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in csv format,
	         * the data exported is selected based on the provided options
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        csvExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function() {
	            var exportColumnHeaders = grid.options.showHeader ? self.getColumnHeaders(grid, colTypes) : [];
	            var exportData = self.getData(grid, rowTypes, colTypes);
	            var csvContent = self.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
	
	            self.downloadFile (grid.options.exporterCsvFilename, csvContent, grid.options.exporterCsvColumnSeparator, grid.options.exporterOlderExcelCompatibility, grid.options.exporterIsExcelCompatible);
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name loadAllDataIfNeeded
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description When using server side pagination, use exporterAllDataFn to
	         * load all data before continuing processing.
	         * When using client side pagination, return a resolved promise so processing
	         * continues immediately
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        loadAllDataIfNeeded: function (grid, rowTypes, colTypes) {
	          if ( rowTypes === uiGridExporterConstants.ALL && grid.rows.length !== grid.options.totalItems && grid.options.exporterAllDataFn) {
	            return grid.options.exporterAllDataFn()
	              .then(function(allData) {
	                grid.modifyRows(allData);
	              });
	          } else {
	            var deferred = $q.defer();
	            deferred.resolve();
	            return deferred.promise;
	          }
	        },
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterSuppressExport
	         * @description Suppresses export for this column.  Used by selection and expandable.
	         */
	
	        /**
	         * @ngdoc function
	         * @name getColumnHeaders
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets the column headers from the grid to use
	         * as a title row for the exported file, all headers have
	         * headerCellFilters applied as appropriate.
	         *
	         * Column headers are an array of objects, each object has
	         * name, displayName, width and align attributes.  Only name is
	         * used for csv, all attributes are used for pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        getColumnHeaders: function (grid, colTypes) {
	          var headers = [],
	            columns;
	
	          if ( colTypes === uiGridExporterConstants.ALL ) {
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [],
	              bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [],
	              rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns, rightColumns);
	          }
	
	          columns.forEach( function( gridCol ) {
	            // $$hashKey check since when grouping and sorting pragmatically this ends up in export. Filtering it out
	            if ( gridCol.colDef.exporterSuppressExport !== true  && gridCol.field !== '$$hashKey' &&
	                 grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ) {
	              var headerEntry = {
	                name: gridCol.field,
	                displayName: getDisplayName(grid, gridCol),
	                width: gridCol.drawnWidth ? gridCol.drawnWidth : gridCol.width,
	                align: gridCol.colDef.align ? gridCol.colDef.align : (gridCol.colDef.type === 'number' ? 'right' : 'left')
	              };
	
	              headers.push(headerEntry);
	            }
	          });
	
	          return headers;
	        },
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterPdfAlign
	         * @description the alignment you'd like for this specific column when
	         * exported into a pdf.  Can be 'left', 'right', 'center' or any other
	         * valid pdfMake alignment option.
	         */
	
	        /**
	         * @ngdoc object
	         * @name ui.grid.exporter.api:GridRow
	         * @description GridRow settings for exporter
	         */
	
	        /**
	         * @ngdoc object
	         * @name exporterEnableExporting
	         * @propertyOf  ui.grid.exporter.api:GridRow
	         * @description If set to false, then don't export this row, notwithstanding visible or
	         * other settings
	         * <br/>Defaults to true
	         */
	
	        /**
	         * @ngdoc function
	         * @name getRowsFromNode
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets rows from a node. If the node is grouped it will
	         * recurse down into the children to get to the raw data element
	         * which is a row without children (a leaf).
	         * @param {Node} aNode the tree node on the grid
	         * @returns {Array} an array of leaf nodes
	         */
	        getRowsFromNode: function(aNode) {
	          var rows = [];
	          for (var i = 0; i<aNode.children.length; i++) {
	            if (aNode.children[i].children && aNode.children[i].children.length === 0) {
	              rows.push(aNode.children[i]);
	            } else {
	              var nodeRows = this.getRowsFromNode(aNode.children[i]);
	              rows = rows.concat(nodeRows);
	            }
	          }
	          return rows;
	        },
	
	        /**
	         * @ngdoc function
	         * @name getDataSorted
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets rows from a node. If the node is grouped it will
	         * recurse down into the children to get to the raw data element
	         * which is a row without children (a leaf). If the grid is not
	         * grouped this will return just the raw rows
	         * @param {Grid} grid the grid from which data should be exported
	         * @returns {Array} an array of leaf nodes
	         */
	        getDataSorted: function (grid) {
	          if (!grid.treeBase || grid.treeBase.numberLevels === 0) {
	            return grid.rows;
	          }
	          var rows = [];
	
	          for (var i = 0; i< grid.treeBase.tree.length; i++) {
	            var nodeRows = this.getRowsFromNode(grid.treeBase.tree[i]);
	
	            for (var j = 0; j<nodeRows.length; j++) {
	              rows.push(nodeRows[j].row);
	            }
	          }
	          return rows;
	        },
	
	        /**
	         * @ngdoc function
	         * @name getData
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets data from the grid based on the provided options,
	         * all cells have cellFilters applied as appropriate.  Any rows marked
	         * `exporterEnableExporting: false` will not be exported
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {boolean} applyCellFilters whether or not to get the display value or the raw value of the data
	         */
	        getData: function (grid, rowTypes, colTypes, applyCellFilters) {
	          var data = [],
	            rows,
	            columns;
	
	          switch ( rowTypes ) {
	            case uiGridExporterConstants.ALL:
	              rows = this.getDataSorted(grid, rowTypes, colTypes, applyCellFilters);
	              break;
	            case uiGridExporterConstants.VISIBLE:
	              rows = grid.getVisibleRows();
	              break;
	            case uiGridExporterConstants.SELECTED:
	              if ( grid.api.selection ) {
	                rows = grid.api.selection.getSelectedGridRows();
	              } else {
	                gridUtil.logError('selection feature must be enabled to allow selected rows to be exported');
	              }
	              break;
	          }
	
	          if ( colTypes === uiGridExporterConstants.ALL ) {
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	            var bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	            var rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ) { return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns, rightColumns);
	          }
	
	          rows.forEach(function( row ) {
	            if (row.exporterEnableExporting !== false) {
	              var extractedRow = [];
	
	              columns.forEach( function( gridCol ) {
	                // $$hashKey check since when grouping and sorting programmatically this ends up in export. Filtering it out
	                if ( (gridCol.visible || colTypes === uiGridExporterConstants.ALL ) &&
	                     gridCol.colDef.exporterSuppressExport !== true && gridCol.field !== '$$hashKey' &&
	                     grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ) {
	                  var cellValue = applyCellFilters ? grid.getCellDisplayValue( row, gridCol ) : grid.getCellValue( row, gridCol ),
	                    extractedField = { value: grid.options.exporterFieldCallback( grid, row, gridCol, cellValue ) },
	                    extension = grid.options.exporterFieldFormatCallback( grid, row, gridCol, cellValue );
	
	                  if (extension) {
	                    Object.assign(extractedField, extension);
	                  }
	                  if ( gridCol.colDef.exporterPdfAlign ) {
	                    extractedField.alignment = gridCol.colDef.exporterPdfAlign;
	                  }
	                  extractedRow.push(extractedField);
	                }
	              });
	
	              data.push(extractedRow);
	            }
	          });
	
	          return data;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Formats the column headers and data as a CSV,
	         * and sends that data to the user
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @param {string} separator a string that represents the separator to be used in the csv file
	         * @returns {string} csv the formatted csv as a string
	         */
	        formatAsCsv: function (exportColumnHeaders, exportData, separator) {
	          var self = this,
	            bareHeaders = exportColumnHeaders.map(function(header) { return { value: header.displayName };}),
	            csv = bareHeaders.length > 0 ? (self.formatRowAsCsv(this, separator)(bareHeaders) + '\n') : '';
	
	          csv += exportData.map(this.formatRowAsCsv(this, separator)).join('\n');
	
	          return csv;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {exporterService} exporter pass in exporter
	         * @param {string} separator the string to be used to join the row data
	         * @returns {function} A function that returns a csv-ified version of the row
	         */
	        formatRowAsCsv: function (exporter, separator) {
	          return function (row) {
	            return row.map(exporter.formatFieldAsCsv).join(separator);
	          };
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {field} field the field to be turned into a csv string,
	         * may be of any type
	         * @returns {string} a csv-ified version of the field
	         */
	        formatFieldAsCsv: function (field) {
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            return '';
	          }
	          if (typeof(field.value) === 'number') {
	            return field.value;
	          }
	          if (typeof(field.value) === 'boolean') {
	            return (field.value ? 'TRUE' : 'FALSE') ;
	          }
	          if (typeof(field.value) === 'string') {
	            return '"' + field.value.replace(/"/g,'""') + '"';
	          }
	          if (typeof(field.value) === 'object' && !(field.value instanceof Date)) {
	            return '"' + JSON.stringify(field.value).replace(/"/g,'""') + '"';
	          }
	          // if field type is date, numberStr
	          return JSON.stringify(field.value);
	        },
	
	        /**
	         * @ngdoc function
	         * @name isIE
	         * @methodOf ui.grid.exporter.service:uiGridExporterService
	         * @description Checks whether current browser is IE and returns it's version if it is
	        */
	        isIE: function () {
	          var match = navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/);
	          var isIE = false;
	
	          if (match !== -1) {
	            isIE = true;
	          }
	
	          return isIE;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadFile
	         * @methodOf ui.grid.exporter.service:uiGridExporterService
	         * @description Triggers download of a csv file.  Logic provided
	         * by @cssensei (from his colleagues at https://github.com/ifeelgoods) in issue #2391
	         * @param {string} fileName the filename we'd like our file to be
	         * given
	         * @param {string} csvContent the csv content that we'd like to
	         * download as a file
	         * @param {string} columnSeparator The separator to be used by the columns
	         * @param {boolean} exporterOlderExcelCompatibility whether or not we put a utf-16 BOM on the from (\uFEFF)
	          * @param {boolean} exporterIsExcelCompatible whether or not we add separator header ('sep=X')
	         */
	        downloadFile: function (fileName, csvContent, columnSeparator, exporterOlderExcelCompatibility, exporterIsExcelCompatible) {
	          var D = document,
	            a = D.createElement('a'),
	            strMimeType = 'application/octet-stream;charset=utf-8',
	            rawFile,
	            ieVersion = this.isIE();
	
	          if (exporterIsExcelCompatible) {
	              csvContent = 'sep=' + columnSeparator + '\r\n' + csvContent;
	          }
	
	          // IE10+
	          if (navigator.msSaveBlob) {
	            return navigator.msSaveOrOpenBlob(
	              new Blob(
	                [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	                { type: strMimeType } ),
	              fileName
	            );
	          }
	
	          if (ieVersion) {
	            var frame = D.createElement('iframe');
	
	            document.body.appendChild(frame);
	
	            frame.contentWindow.document.open('text/html', 'replace');
	            frame.contentWindow.document.write(csvContent);
	            frame.contentWindow.document.close();
	            frame.contentWindow.focus();
	            frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	            document.body.removeChild(frame);
	            return true;
	          }
	
	          // html5 A[download]
	          if ('download' in a) {
	            var blob = new Blob(
	              [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	              { type: strMimeType }
	            );
	            rawFile = URL.createObjectURL(blob);
	            a.setAttribute('download', fileName);
	          } else {
	            rawFile = 'data: ' + strMimeType + ',' + encodeURIComponent(csvContent);
	            a.setAttribute('target', '_blank');
	          }
	
	          a.href = rawFile;
	          a.setAttribute('style', 'display:none;');
	          D.body.appendChild(a);
	          setTimeout(function() {
	            if (a.click) {
	              a.click();
	              // Workaround for Safari 5
	            } else if (document.createEvent) {
	              var eventObj = document.createEvent('MouseEvents');
	              eventObj.initEvent('click', true, true);
	              a.dispatchEvent(eventObj);
	            }
	            D.body.removeChild(a);
	
	          }, this.delay);
	        },
	
	        /**
	         * @ngdoc function
	         * @name pdfExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in pdf format,
	         * the data exported is selected based on the provided options.
	         * Note that this function has a dependency on pdfMake, which must
	         * be installed.  The resulting pdf opens in a new
	         * browser window.
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        pdfExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function () {
	            var exportColumnHeaders = self.getColumnHeaders(grid, colTypes),
	              exportData = self.getData(grid, rowTypes, colTypes),
	              docDefinition = self.prepareAsPdf(grid, exportColumnHeaders, exportData);
	
	            if (self.isIE() || navigator.appVersion.indexOf('Edge') !== -1) {
	              self.downloadPDF(grid.options.exporterPdfFilename, docDefinition);
	            } else {
	              pdfMake.createPdf(docDefinition).open();
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Generates and retrieves the pdf as a blob, then downloads
	         * it as a file.  Only used in IE, in all other browsers we use the native
	         * pdfMake.open function to just open the PDF
	         * @param {string} fileName the filename to give to the pdf, can be set
	         * through exporterPdfFilename
	         * @param {object} docDefinition a pdf docDefinition that we can generate
	         * and get a blob from
	         */
	        downloadPDF: function (fileName, docDefinition) {
	          var D = document,
	            a = D.createElement('a'),
	            ieVersion;
	
	          ieVersion = this.isIE(); // This is now a boolean value
	          var doc = pdfMake.createPdf(docDefinition);
	          var blob;
	
	          doc.getBuffer( function (buffer) {
	            blob = new Blob([buffer]);
	
	            // IE10+
	            if (navigator.msSaveBlob) {
	              return navigator.msSaveBlob(
	                blob, fileName
	              );
	            }
	
	            // Previously:  && ieVersion < 10
	            // ieVersion now returns a boolean for the
	            // sake of sanity. We just check `msSaveBlob` first.
	            if (ieVersion) {
	              var frame = D.createElement('iframe');
	              document.body.appendChild(frame);
	
	              frame.contentWindow.document.open('text/html', 'replace');
	              frame.contentWindow.document.write(blob);
	              frame.contentWindow.document.close();
	              frame.contentWindow.focus();
	              frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	              document.body.removeChild(frame);
	              return true;
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name renderAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders the data into a pdf, and opens that pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @returns {object} a pdfMake format document definition, ready
	         * for generation
	         */
	        prepareAsPdf: function(grid, exportColumnHeaders, exportData) {
	          var headerWidths = this.calculatePdfHeaderWidths( grid, exportColumnHeaders );
	
	          var headerColumns = exportColumnHeaders.map( function( header ) {
	            return { text: header.displayName, style: 'tableHeader' };
	          });
	
	          var stringData = exportData.map(this.formatRowAsPdf(this));
	
	          var allData = [headerColumns].concat(stringData);
	
	          var docDefinition = {
	            pageOrientation: grid.options.exporterPdfOrientation,
	            pageSize: grid.options.exporterPdfPageSize,
	            content: [{
	              style: 'tableStyle',
	              table: {
	                headerRows: 1,
	                widths: headerWidths,
	                body: allData
	              }
	            }],
	            styles: {
	              tableStyle: grid.options.exporterPdfTableStyle,
	              tableHeader: grid.options.exporterPdfTableHeaderStyle
	            },
	            defaultStyle: grid.options.exporterPdfDefaultStyle
	          };
	
	          if ( grid.options.exporterPdfLayout ) {
	            docDefinition.layout = grid.options.exporterPdfLayout;
	          }
	
	          if ( grid.options.exporterPdfHeader ) {
	            docDefinition.header = grid.options.exporterPdfHeader;
	          }
	
	          if ( grid.options.exporterPdfFooter ) {
	            docDefinition.footer = grid.options.exporterPdfFooter;
	          }
	
	          if ( grid.options.exporterPdfCustomFormatter ) {
	            docDefinition = grid.options.exporterPdfCustomFormatter( docDefinition );
	          }
	          return docDefinition;
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name calculatePdfHeaderWidths
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Determines the column widths base on the
	         * widths we got from the grid.  If the column is drawn
	         * then we have a drawnWidth.  If the column is not visible
	         * then we have '*', 'x%' or a width.  When columns are
	         * not visible they don't contribute to the overall gridWidth,
	         * so we need to adjust to allow for extra columns
	         *
	         * Our basic heuristic is to take the current gridWidth, plus
	         * numeric columns and call this the base gridwidth.
	         *
	         * To that we add 100 for any '*' column, and x% of the base gridWidth
	         * for any column that is a %
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportHeaders array of header information
	         * @returns {object} an array of header widths
	         */
	        calculatePdfHeaderWidths: function ( grid, exportHeaders ) {
	          var baseGridWidth = 0;
	
	          exportHeaders.forEach(function(value) {
	            if (typeof(value.width) === 'number') {
	              baseGridWidth += value.width;
	            }
	          });
	
	          var extraColumns = 0;
	
	          exportHeaders.forEach(function(value) {
	            if (value.width === '*') {
	              extraColumns += 100;
	            }
	            if (typeof(value.width) === 'string' && value.width.match(/(\d)*%/)) {
	              var percent = parseInt(value.width.match(/(\d)*%/)[0]);
	
	              value.width = baseGridWidth * percent / 100;
	              extraColumns += value.width;
	            }
	          });
	
	          var gridWidth = baseGridWidth + extraColumns;
	
	          return exportHeaders.map(function( header ) {
	            return header.width === '*' ? header.width : header.width * grid.options.exporterPdfMaxGridWidth / gridWidth;
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a row in a format consumable by PDF,
	         * mainly meaning casting everything to a string
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a csv string
	         * @returns {string} a csv-ified version of the row
	         */
	        formatRowAsPdf: function ( exporter ) {
	          return function( row ) {
	            return row.map(exporter.formatFieldAsPdfString);
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a pdf-able field, which
	         * is different from a csv field only in that strings don't have quotes
	         * around them
	         * @param {field} field the field to be turned into a pdf string,
	         * may be of any type
	         * @returns {string} a string-ified version of the field
	         */
	        formatFieldAsPdfString: function (field) {
	          var returnVal;
	
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            returnVal = '';
	          } else if (typeof(field.value) === 'number') {
	            returnVal = field.value.toString();
	          } else if (typeof(field.value) === 'boolean') {
	            returnVal = (field.value ? 'TRUE' : 'FALSE') ;
	          } else if (typeof(field.value) === 'string') {
	            returnVal = field.value.replace(/"/g,'""');
	          } else if (field.value instanceof Date) {
	            returnVal = JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');
	          } else if (typeof(field.value) === 'object') {
	            returnVal = field.value;
	          } else {
	            returnVal = JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');
	          }
	
	          if (field.alignment && typeof(field.alignment) === 'string' ) {
	            returnVal = { text: returnVal, alignment: field.alignment };
	          }
	
	          return returnVal;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Formats the column headers and data as a excel,
	         * and sends that data to the user
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @param {string} separator a string that represents the separator to be used in the csv file
	         * @returns {string} csv the formatted excel as a string
	         */
	        formatAsExcel: function (exportColumnHeaders, exportData, workbook, sheet, docDefinition) {
	          var bareHeaders = exportColumnHeaders.map(function(header) {return { value: header.displayName };});
	
	          var sheetData = [];
	          var headerData = [];
	          for (var i = 0; i < bareHeaders.length; i++) {
	            // TODO - probably need callback to determine header value and header styling
	            var exportStyle = 'header';
	            switch (exportColumnHeaders[i].align) {
	              case 'center':
	                exportStyle = 'headerCenter';
	                break;
	              case 'right':
	                exportStyle = 'headerRight';
	                break;
	            }
	            var metadata = (docDefinition.styles && docDefinition.styles[exportStyle]) ? {style: docDefinition.styles[exportStyle].id} : null;
	            headerData.push({value: bareHeaders[i].value, metadata: metadata});
	          }
	          sheetData.push(headerData);
	
	          var result = exportData.map(this.formatRowAsExcel(this, workbook, sheet));
	          for (var j = 0; j<result.length; j++) {
	            sheetData.push(result[j]);
	          }
	          return sheetData;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a excel string
	         * @returns {array} array of cell objects (i.e. {value: x, metadata: y})
	         */
	        formatRowAsExcel: function (exporter, workbook, sheet) {
	          return function (row) {
	            var values = [];
	            for (var i = 0; i<row.length; i++) {
	              var value = exporter.formatFieldAsExcel(row[i], workbook, sheet);
	              values.push({value: value, metadata: row[i].metadata});
	            }
	            return values;
	          };
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a excel-ified field
	         * @param {field} field the field to be excel-ified,
	         * may be of any type
	         * @returns {string} a excel-ified version of the field
	         */
	        formatFieldAsExcel: function (field, workbook, sheet, formatters) {
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            return '';
	          }
	          if ((typeof(field.value) === 'number') || (typeof(field.value) === 'string')) {
	            return field.value;
	          }
	          if (typeof(field.value) === 'boolean') {
	            return (field.value ? 'TRUE' : 'FALSE') ;
	          }
	
	          return JSON.stringify(field.value);
	        },
	
	        prepareAsExcel: function(grid, workbook, sheet) {
	          var docDefinition = {
	            styles: {
	
	            }
	          };
	
	          if ( grid.options.exporterExcelCustomFormatters ) {
	            docDefinition = grid.options.exporterExcelCustomFormatters( grid, workbook, docDefinition );
	          }
	          if ( grid.options.exporterExcelHeader ) {
	            if (angular.isFunction( grid.options.exporterExcelHeader )) {
	              grid.options.exporterExcelHeader(grid, workbook, sheet, docDefinition);
	            } else {
	              var headerText = grid.options.exporterExcelHeader.text;
	              var style = grid.options.exporterExcelHeader.style;
	              sheet.data.push([{value: headerText, metadata: {style: docDefinition.styles[style].id}}]);
	            }
	          }
	
	          return docDefinition;
	        },
	
	        excelExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function() {
	            var exportColumnHeaders = grid.options.showHeader ? self.getColumnHeaders(grid, colTypes) : [];
	
	            var workbook = new ExcelBuilder.Workbook();
	            var aName = grid.options.exporterExcelSheetName ? grid.options.exporterExcelSheetName : 'Sheet1';
	            var sheet = new ExcelBuilder.Worksheet({name: aName});
	            workbook.addWorksheet(sheet);
	            var docDefinition = self.prepareAsExcel(grid, workbook, sheet);
	
	            // The standard column width in Microsoft Excel 2000 is 8.43 characters based on fixed-width Courier font
	            // Width of 10 in excel is 75 pixels
	            var colWidths = [];
	            var startDataIndex = grid.treeBase ? grid.treeBase.numberLevels : (grid.enableRowSelection ? 1 : 0);
	            for (var i = startDataIndex; i < grid.columns.length; i++) {
	              if (grid.columns[i].field !== uiGridExporterConstants.rowHeaderColName &&
	                grid.columns[i].field !== uiGridExporterConstants.selectionRowHeaderColName) {
	
	                colWidths.push({width: (grid.columns[i].drawnWidth / grid.options.exporterColumnScaleFactor)});
	              }
	            }
	            sheet.setColumns(colWidths);
	
	            var exportData = self.getData(grid, rowTypes, colTypes, grid.options.exporterFieldApplyFilters);
	
	            var excelContent = self.formatAsExcel(exportColumnHeaders, exportData, workbook, sheet, docDefinition);
	            sheet.setData(sheet.data.concat(excelContent));
	
	            ExcelBuilder.Builder.createFile(workbook, {type: 'blob'}).then(function(result) {
	              self.downloadFile (grid.options.exporterExcelFilename, result, grid.options.exporterCsvColumnSeparator,
	                grid.options.exporterOlderExcelCompatibility);
	            });
	          });
	        }
	      };
	
	      function getDisplayName(grid, gridCol) {
	        if (grid.options.exporterHeaderFilter) {
	          return grid.options.exporterHeaderFilterUseName ?
	            grid.options.exporterHeaderFilter(gridCol.name) :
	            grid.options.exporterHeaderFilter(gridCol.displayName);
	        }
	
	        return gridCol.headerCellFilter ?
	          $filter(gridCol.headerCellFilter)(gridCol.displayName) :
	          gridCol.displayName;
	      }
	
	      function defaultExporterFieldCallback(grid, row, col, value) {
	        // fix to handle cases with 'number : 1' or 'date:MM-dd-YYYY', etc.. We needed to split the string
	        if (col.cellFilter) {
						var args, filter, arg1, arg2;
						// remove space, single/double to mantein retro-compatibility
						args = col.cellFilter.replace(/[\'\"\s]/g, "").split(':');
						filter = args[0] ? args[0] : null;
						arg1 = args[1] ? args[1] : null;
						arg2 = args[2] ? args[2] : null;
	          return $filter(filter)(value, arg1, arg2);
	        } else {
	          return value;
	        }
	      }
	
	      return service;
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.exporter.directive:uiGridExporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds exporter features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.exporter']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        enableGridMenu: true,
	        exporterMenuCsv: false,
	        columnDefs: [
	          {name: 'name', enableCellEdit: true},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-exporter></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridExporter', ['uiGridExporterConstants', 'uiGridExporterService', 'gridUtil', '$compile',
	    function (uiGridExporterConstants, uiGridExporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridExporterService.initializeGrid(uiGridCtrl.grid);
	          uiGridCtrl.grid.exporter.$scope = $scope;
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.grouping
	   * @description
	   *
	   * # ui.grid.grouping
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides grouping of rows based on the data in them, similar
	   * in concept to excel grouping.  You can group multiple columns, resulting in
	   * nested grouping.
	   *
	   * In concept this feature is similar to sorting + grid footer/aggregation, it
	   * sorts the data based on the grouped columns, then creates group rows that
	   * reflect a break in the data.  Each of those group rows can have aggregations for
	   * the data within that group.
	   *
	   * This feature leverages treeBase to provide the tree functionality itself,
	   * the key thing this feature does therefore is to set treeLevels on the rows
	   * and insert the group headers.
	   *
	   * Design information:
	   * -------------------
	   *
	   * Each column will get new menu items - group by, and aggregate by.  Group by
	   * will cause this column to be sorted (if not already), and will move this column
	   * to the front of the sorted columns (i.e. grouped columns take precedence over
	   * sorted columns).  It will respect the sort order already set if there is one,
	   * and it will allow the sorting logic to change that sort order, it just forces
	   * the column to the front of the sorting.  You can group by multiple columns, the
	   * logic will add this column to the sorting after any already grouped columns.
	   *
	   * Once a grouping is defined, grouping logic is added to the rowsProcessors.  This
	   * will process the rows, identifying a break in the data value, and inserting a grouping row.
	   * Grouping rows have specific attributes on them:
	   *
	   *  - internalRow = true: tells us that this isn't a real row, so we can ignore it
	   *    from any processing that it looking at core data rows.  This is used by the core
	   *    logic (or will be one day), as it's not grouping specific
	   *  - groupHeader = true: tells us this is a groupHeader.  This is used by the grouping logic
	   *    to know if this is a groupHeader row or not
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  In order to avoid the row instantiation
	   * time, and to preserve state across invocations, we hold a cache of the rows that we created
	   * last time, and we use them again this time if we can.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.grouping"></div>
	   */
	
	  var module = angular.module('ui.grid.grouping', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.grouping.constant:uiGridGroupingConstants
	   *
	   *  @description constants available in grouping module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridGroupingConstants', {
	    featureName: "grouping",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.grouping.service:uiGridGroupingService
	   *
	   *  @description Services for grouping features
	   */
	  module.service('uiGridGroupingService', ['$q', 'uiGridGroupingConstants', 'gridUtil', 'rowSorter', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'uiGridTreeBaseService',
	  function ($q, uiGridGroupingConstants, gridUtil, rowSorter, GridRow, gridClassFactory, i18nService, uiGridConstants, uiGridTreeBaseService) {
	    var service = {
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        // add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.grid:grouping
	         *
	         *  @description Grid properties and functions added for grouping
	         */
	        grid.grouping = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.grouping.grid:grouping
	         *  @name groupHeaderCache
	         *
	         *  @description Cache that holds the group header rows we created last time, we'll
	         *  reuse these next time, not least because they hold our expanded states.
	         *
	         *  We need to take care with these that they don't become a memory leak, we
	         *  create a new cache each time using the values from the old cache.  This works
	         *  so long as we're creating group rows for invisible rows as well.
	         *
	         *  The cache is a nested hash, indexed on the value we grouped by.  So if we
	         *  grouped by gender then age, we'd maybe have something like:
	         *  ```
	         *    {
	         *      male: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          22: { row: <pointer to the old row> },
	         *          31: { row: <pointer to the old row> }
	         *      },
	         *      female: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          28: { row: <pointer to the old row> },
	         *          55: { row: <pointer to the old row> }
	         *      }
	         *    }
	         *  ```
	         *
	         *  We create new rows for any missing rows, this means that they come in as collapsed.
	         *
	         */
	        grid.grouping.groupHeaderCache = {};
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.groupRows, 400);
	
	        grid.registerColumnBuilder( service.groupingColumnBuilder);
	
	        grid.registerColumnsProcessor(service.groupingColumnProcessor, 400);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:PublicApi
	         *
	         *  @description Public Api for grouping feature
	         */
	        var publicApi = {
	          events: {
	            grouping: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name aggregationChanged
	               * @description raised whenever aggregation is changed, added or removed from a column
	               *
	               * <pre>
	               *      gridApi.grouping.on.aggregationChanged(scope,function(col) {})
	               * </pre>
	               * @param {GridColumn} col the column on which aggregation changed. The aggregation
	               * type is available as `col.treeAggregation.type`
	               */
	              aggregationChanged: {},
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name groupingChanged
	               * @description raised whenever the grouped columns changes
	               *
	               * <pre>
	               *      gridApi.grouping.on.groupingChanged(scope,function(col) {})
	               * </pre>
	               * @param {GridColumn} col the column on which grouping changed. The new grouping is
	               * available as `col.grouping`
	               */
	              groupingChanged: {}
	            }
	          },
	          methods: {
	            grouping: {
	              /**
	               * @ngdoc function
	               * @name getGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Get the grouping configuration for this grid,
	               * used by the saveState feature.  Adds expandedState to the information
	               * provided by the internal getGrouping, and removes any aggregations that have a source
	               * of grouping (i.e. will be automatically reapplied when we regroup the column)
	               * Returned grouping is an object
	               *   `{ grouping: groupArray, treeAggregations: aggregateArray, expandedState: hash }`
	               * where grouping contains an array of objects:
	               *   `{ field: column.field, colName: column.name, groupPriority: column.grouping.groupPriority }`
	               * and aggregations contains an array of objects:
	               *   `{ field: column.field, colName: column.name, aggregation: column.grouping.aggregation }`
	               * and expandedState is a hash of the currently expanded nodes
	               *
	               * The groupArray will be sorted by groupPriority.
	               *
	               * @param {boolean} getExpanded whether or not to return the expanded state
	               * @returns {object} grouping configuration
	               */
	              getGrouping: function ( getExpanded ) {
	                var grouping = service.getGrouping(grid);
	
	                grouping.grouping.forEach( function( group ) {
	                  group.colName = group.col.name;
	                  delete group.col;
	                });
	
	                grouping.aggregations.forEach( function( aggregation ) {
	                  aggregation.colName = aggregation.col.name;
	                  delete aggregation.col;
	                });
	
	                grouping.aggregations = grouping.aggregations.filter( function( aggregation ) {
	                  return !aggregation.aggregation.source || aggregation.aggregation.source !== 'grouping';
	                });
	
	                if ( getExpanded ) {
	                  grouping.rowExpandedStates = service.getRowExpandedStates( grid.grouping.groupingHeaderCache );
	                }
	
	                return grouping;
	              },
	
	              /**
	               * @ngdoc function
	               * @name setGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Set the grouping configuration for this grid,
	               * used by the saveState feature, but can also be used by any
	               * user to specify a combined grouping and aggregation configuration
	               * @param {object} config the config you want to apply, in the format
	               * provided out by getGrouping
	               */
	              setGrouping: function ( config ) {
	                service.setGrouping(grid, config);
	              },
	
	              /**
	               * @ngdoc function
	               * @name groupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Adds this column to the existing grouping, at the end of the priority order.
	               * If the column doesn't have a sort, adds one, by default ASC
	               *
	               * This column will move to the left of any non-group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to group
	               */
	              groupColumn: function(columnName) {
	                var column = grid.getColumn(columnName);
	
	                service.groupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name ungroupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Removes the groupPriority from this column.  If the
	               * column was previously aggregated the aggregation will come back.
	               * The sort will remain.
	               *
	               * This column will move to the right of any other group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to ungroup
	               */
	              ungroupColumn: function(columnName) {
	                var column = grid.getColumn(columnName);
	
	                service.ungroupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name clearGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	               * as we don't know whether that sorting was added by grouping or was there beforehand
	               *
	               */
	              clearGrouping: function() {
	                service.clearGrouping(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name aggregateColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Sets the aggregation type on a column, if the
	               * column is currently grouped then it removes the grouping first.
	               * If the aggregationDef is null then will result in the aggregation
	               * being removed
	               *
	               * @param {string} columnName the column we want to aggregate
	               * @param {string|function} aggregationDef one of the recognised types
	               * from uiGridGroupingConstants or a custom aggregation function.
	               * @param {string} aggregationLabel (optional) The label to use for this aggregation.
	               */
	              aggregateColumn: function(columnName, aggregationDef, aggregationLabel) {
	                var column = grid.getColumn(columnName);
	
	                service.aggregateColumn(grid, column, aggregationDef, aggregationLabel);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	        grid.api.core.on.sortChanged($scope, service.tidyPriorities);
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:GridOptions
	         *
	         *  @description GridOptions for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Enable row grouping for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableGrouping = gridOptions.enableGrouping !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowCounts
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description shows counts on the groupHeader rows. Not that if you are using a cellFilter or a
	         *  sortingAlgorithm which relies on a specific format or data type, showing counts may cause that
	         *  to break, since the group header rows will always be a string with groupingShowCounts enabled.
	         *  <br/>Defaults to true except on columns of types 'date' and 'object'
	         */
	        gridOptions.groupingShowCounts = gridOptions.groupingShowCounts !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingNullLabel
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description The string to use for the grouping header row label on rows which contain a null or undefined value in the grouped column.
	         *  <br/>Defaults to "Null"
	         */
	        gridOptions.groupingNullLabel = typeof(gridOptions.groupingNullLabel) === 'undefined' ? 'Null' : gridOptions.groupingNullLabel;
	
	        /**
	         *  @ngdoc object
	         *  @name enableGroupHeaderSelection
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Allows group header rows to be selected.
	         *  <br/>Defaults to false
	         */
	        gridOptions.enableGroupHeaderSelection = gridOptions.enableGroupHeaderSelection === true;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnBuilder
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the grouping defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridColumn} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      groupingColumnBuilder: function (colDef, col, gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:ColumnDef
	         *
	         *  @description ColumnDef for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Enable grouping on this column
	         *  <br/>Defaults to true.
	         */
	        if (colDef.enableGrouping === false) {
	          return;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Set the grouping for a column.  Format is:
	         *  ```
	         *    {
	         *      groupPriority: <number, starts at 0, if less than 0 or undefined then we're aggregating in this column>
	         *    }
	         *  ```
	         *
	         *  **Note that aggregation used to be included in grouping, but is now separately set on the column via treeAggregation
	         *  setting in treeBase**
	         *
	         *  We group in the priority order given, this will also put these columns to the high order of the sort irrespective
	         *  of the sort priority given them.  If there is no sort defined then we sort ascending, if there is a sort defined then
	         *  we use that sort.
	         *
	         *  If the groupPriority is undefined or less than 0, then we expect to be aggregating, and we look at the
	         *  aggregation types to determine what sort of aggregation we can do.  Values are in the constants file, but
	         *  include SUM, COUNT, MAX, MIN
	         *
	         *  groupPriorities should generally be sequential, if they're not then the next time getGrouping is called
	         *  we'll renumber them to be sequential.
	         *  <br/>Defaults to undefined.
	         */
	
	        if ( typeof(col.grouping) === 'undefined' && typeof(colDef.grouping) !== 'undefined') {
	          col.grouping = angular.copy(colDef.grouping);
	          if ( typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority > -1 ) {
	            col.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	            col.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	          }
	        } else if (typeof(col.grouping) === 'undefined') {
	          col.grouping = {};
	        }
	
	        if (typeof(col.grouping) !== 'undefined' && typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority >= 0) {
	          col.suppressRemoveSort = true;
	        }
	
	        var groupColumn = {
	          name: 'ui.grid.grouping.group',
	          title: i18nService.get().grouping.group,
	          icon: 'ui-grid-icon-indent-right',
	          shown: function () {
	            return typeof(this.context.col.grouping) === 'undefined' ||
	                   typeof(this.context.col.grouping.groupPriority) === 'undefined' ||
	                   this.context.col.grouping.groupPriority < 0;
	          },
	          action: function () {
	            service.groupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var ungroupColumn = {
	          name: 'ui.grid.grouping.ungroup',
	          title: i18nService.get().grouping.ungroup,
	          icon: 'ui-grid-icon-indent-left',
	          shown: function () {
	            return typeof(this.context.col.grouping) !== 'undefined' &&
	                   typeof(this.context.col.grouping.groupPriority) !== 'undefined' &&
	                   this.context.col.grouping.groupPriority >= 0;
	          },
	          action: function () {
	            service.ungroupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var aggregateRemove = {
	          name: 'ui.grid.grouping.aggregateRemove',
	          title: i18nService.get().grouping.aggregate_remove,
	          shown: function () {
	            return typeof(this.context.col.treeAggregationFn) !== 'undefined';
	          },
	          action: function () {
	            service.aggregateColumn( this.context.col.grid, this.context.col, null);
	          }
	        };
	
	        // generic adder for the aggregation menus, which follow a pattern
	        var addAggregationMenu = function(type, title) {
	          title = title || i18nService.get().grouping['aggregate_' + type] || type;
	          var menuItem = {
	            name: 'ui.grid.grouping.aggregate' + type,
	            title: title,
	            shown: function () {
	              return typeof(this.context.col.treeAggregation) === 'undefined' ||
	                     typeof(this.context.col.treeAggregation.type) === 'undefined' ||
	                     this.context.col.treeAggregation.type !== type;
	            },
	            action: function () {
	              service.aggregateColumn( this.context.col.grid, this.context.col, type);
	            }
	          };
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregate' + type)) {
	            col.menuItems.push(menuItem);
	          }
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowGroupingMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the grouping (group and ungroup items) menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowGroupingMenu !== false ) {
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.group')) {
	            col.menuItems.push(groupColumn);
	          }
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.ungroup')) {
	            col.menuItems.push(ungroupColumn);
	          }
	        }
	
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowAggregationMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the aggregation menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowAggregationMenu !== false ) {
	          angular.forEach(uiGridTreeBaseService.nativeAggregations(), function(aggregationDef, name) {
	            addAggregationMenu(name);
	          });
	          angular.forEach(gridOptions.treeCustomAggregations, function(aggregationDef, name) {
	            addAggregationMenu(name, aggregationDef.menuTitle);
	          });
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregateRemove')) {
	            col.menuItems.push(aggregateRemove);
	          }
	        }
	      },
	
	
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnProcessor
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the columns around based on which are grouped
	       *
	       * @param {array} columns the columns to consider rendering
	       * @param {array} rows the grid rows, which we don't use but are passed to us
	       * @returns {array} updated columns array
	       */
	      groupingColumnProcessor: function( columns, rows ) {
	        columns = service.moveGroupColumns(this, columns, rows);
	        return columns;
	      },
	
	      /**
	       * @ngdoc function
	       * @name groupedFinalizerFn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Used on group columns to display the rendered value and optionally
	       * display the count of rows.
	       *
	       * @param {aggregation} aggregation The aggregation entity for a grouped column
	       */
	      groupedFinalizerFn: function( aggregation ) {
	        var col = this;
	
	        if ( typeof(aggregation.groupVal) !== 'undefined') {
	          aggregation.rendered = aggregation.groupVal;
	          if ( col.grid.options.groupingShowCounts && col.colDef.type !== 'date' && col.colDef.type !== 'object' ) {
	            aggregation.rendered += (' (' + aggregation.value + ')');
	          }
	        } else {
	          aggregation.rendered = null;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name moveGroupColumns
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the column order so that the grouped columns are lined up
	       * to the left (well, unless you're RTL, then it's the right).  By doing this in
	       * the columnsProcessor, we make it transient - when the column is ungrouped it'll
	       * go back to where it was.
	       *
	       * Does nothing if the option `moveGroupColumns` is set to false.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} columns the columns that we should process/move
	       * @returns {array} updated columns
	       */
	      moveGroupColumns: function( grid, columns ) {
	        if ( grid.options.moveGroupColumns === false) {
	          return columns;
	        }
	
	        columns.forEach(function(column, index) {
	          // position used to make stable sort in moveGroupColumns
	          column.groupingPosition = index;
	        });
	
	        columns.sort(function(a, b) {
	          var a_group, b_group;
	
	          if (a.isRowHeader) {
	            a_group = a.headerPriority;
	          }
	          else if ( typeof(a.grouping) === 'undefined' || typeof(a.grouping.groupPriority) === 'undefined' || a.grouping.groupPriority < 0) {
	            a_group = null;
	          }
	          else {
	            a_group = a.grouping.groupPriority;
	          }
	
	          if (b.isRowHeader) {
	            b_group = b.headerPriority;
	          }
	          else if ( typeof(b.grouping) === 'undefined' || typeof(b.grouping.groupPriority) === 'undefined' || b.grouping.groupPriority < 0) {
	            b_group = null;
	          }
	          else {
	            b_group = b.grouping.groupPriority;
	          }
	
	          // groups get sorted to the top
	          if ( a_group !== null && b_group === null) { return -1; }
	          if ( b_group !== null && a_group === null) { return 1; }
	          if ( a_group !== null && b_group !== null) {return a_group - b_group; }
	
	          return a.groupingPosition - b.groupingPosition;
	        });
	
	        columns.forEach( function(column) {
	          delete column.groupingPosition;
	        });
	
	        return columns;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Adds this column to the existing grouping, at the end of the priority order.
	       * If the column doesn't have a sort, adds one, by default ASC
	       *
	       * This column will move to the left of any non-group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to group
	       */
	      groupColumn: function( grid, column) {
	        if ( typeof(column.grouping) === 'undefined' ) {
	          column.grouping = {};
	        }
	
	        // set the group priority to the next number in the hierarchy
	        var existingGrouping = service.getGrouping( grid );
	        column.grouping.groupPriority = existingGrouping.grouping.length;
	
	        // save sort in order to restore it when column is ungrouped
	        column.previousSort = angular.copy(column.sort);
	
	        // add sort if not present
	        if ( !column.sort ) {
	          column.sort = { direction: uiGridConstants.ASC };
	        } else if ( typeof(column.sort.direction) === 'undefined' || column.sort.direction === null ) {
	          column.sort.direction = uiGridConstants.ASC;
	        }
	
	        column.treeAggregation = { type: uiGridGroupingConstants.aggregation.COUNT, source: 'grouping' };
	
	        if ( column.colDef && angular.isFunction(column.colDef.customTreeAggregationFn) ) {
	          column.treeAggregationFn = column.colDef.customTreeAggregationFn;
	        } else {
	          column.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	        }
	
	        column.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	
	        grid.api.grouping.raise.groupingChanged(column);
	        // This indirectly calls service.tidyPriorities( grid );
	        grid.api.core.raise.sortChanged(grid, grid.getColumnSorting());
	
	        grid.queueGridRefresh();
	      },
	
	
	       /**
	       * @ngdoc function
	       * @name ungroupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Removes the groupPriority from this column.  If the
	       * column was previously aggregated the aggregation will come back.
	       * The sort will remain.
	       *
	       * This column will move to the right of any other group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to ungroup
	       */
	      ungroupColumn: function( grid, column) {
	        if ( typeof(column.grouping) === 'undefined' ) {
	          return;
	        }
	
	        delete column.grouping.groupPriority;
	        delete column.treeAggregation;
	        delete column.customTreeAggregationFinalizer;
	
	        if (column.previousSort) {
	          column.sort = column.previousSort;
	          delete column.previousSort;
	        }
	
	        service.tidyPriorities( grid );
	
	        grid.api.grouping.raise.groupingChanged(column);
	        grid.api.core.raise.sortChanged(grid, grid.getColumnSorting());
	
	        grid.queueGridRefresh();
	      },
	
	      /**
	       * @ngdoc function
	       * @name aggregateColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the aggregation type on a column, if the
	       * column is currently grouped then it removes the grouping first.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to aggregate
	       * @param {string} aggregationType of the recognised types from uiGridGroupingConstants or one of the custom aggregations from gridOptions
	       * @param {string} aggregationLabel to be used instead of the default label. If empty string is passed, label is omitted
	       */
	      aggregateColumn: function( grid, column, aggregationType, aggregationLabel ) {
	        if (typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0) {
	          service.ungroupColumn( grid, column );
	        }
	
	        var aggregationDef = {};
	
	        if ( typeof(grid.options.treeCustomAggregations[aggregationType]) !== 'undefined' ) {
	          aggregationDef = grid.options.treeCustomAggregations[aggregationType];
	        } else if ( typeof(uiGridTreeBaseService.nativeAggregations()[aggregationType]) !== 'undefined' ) {
	          aggregationDef = uiGridTreeBaseService.nativeAggregations()[aggregationType];
	        }
	
	        column.treeAggregation = {
	          type: aggregationType,
	          label: ( typeof aggregationLabel === 'string') ?
	            aggregationLabel :
	            i18nService.get().aggregation[aggregationDef.label] || aggregationDef.label
	        };
	        column.treeAggregationFn = aggregationDef.aggregationFn;
	        column.treeAggregationFinalizerFn = aggregationDef.finalizerFn;
	
	        grid.api.grouping.raise.aggregationChanged(column);
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set the grouping based on a config object, used by the save state feature
	       * (more specifically, by the restore function in that feature )
	       *
	       * @param {Grid} grid grid object
	       * @param {object} config the config we want to set, same format as that returned by getGrouping
	       */
	      setGrouping: function ( grid, config ) {
	        if ( typeof(config) === 'undefined' ) {
	          return;
	        }
	
	        // first remove any existing grouping
	        service.clearGrouping(grid);
	
	        if ( config.grouping && config.grouping.length && config.grouping.length > 0 ) {
	          config.grouping.forEach( function( group ) {
	            var col = grid.getColumn(group.colName);
	
	            if ( col ) {
	              service.groupColumn( grid, col );
	            }
	          });
	        }
	
	        if ( config.aggregations && config.aggregations.length ) {
	          config.aggregations.forEach( function( aggregation ) {
	            var col = grid.getColumn(aggregation.colName);
	
	            if ( col ) {
	              service.aggregateColumn( grid, col, aggregation.aggregation.type );
	            }
	          });
	        }
	
	        if ( config.rowExpandedStates ) {
	          service.applyRowExpandedStates( grid.grouping.groupingHeaderCache, config.rowExpandedStates );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name clearGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	       * as we don't know whether that sorting was added by grouping or was there beforehand
	       *
	       * @param {Grid} grid grid object
	       */
	      clearGrouping: function( grid ) {
	        var currentGrouping = service.getGrouping(grid);
	
	        if ( currentGrouping.grouping.length > 0 ) {
	          currentGrouping.grouping.forEach( function( group ) {
	            if (!group.col) {
	              // should have a group.colName if there's no col
	              group.col = grid.getColumn(group.colName);
	            }
	            service.ungroupColumn(grid, group.col);
	          });
	        }
	
	        if ( currentGrouping.aggregations.length > 0 ) {
	          currentGrouping.aggregations.forEach( function( aggregation ) {
	            if (!aggregation.col) {
	              // should have a group.colName if there's no col
	              aggregation.col = grid.getColumn(aggregation.colName);
	            }
	            service.aggregateColumn(grid, aggregation.col, null);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name tidyPriorities
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Renumbers groupPriority and sortPriority such that
	       * groupPriority is contiguous, and sortPriority either matches
	       * groupPriority (for group columns), and otherwise is contiguous and
	       * higher than groupPriority.
	       *
	       * @param {Grid} grid grid object
	       */
	      tidyPriorities: function( grid ) {
	        // if we're called from sortChanged, grid is in this, not passed as param, the param can be a column or undefined
	        if ( ( typeof(grid) === 'undefined' || typeof(grid.grid) !== 'undefined' ) && typeof(this.grid) !== 'undefined' ) {
	          grid = this.grid;
	        }
	
	        var groupArray = [],
	          sortArray = [];
	
	        grid.columns.forEach( function(column, index) {
	          if ( typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0) {
	            groupArray.push(column);
	          }
	          else if ( typeof(column.sort) !== 'undefined' && typeof(column.sort.priority) !== 'undefined' && column.sort.priority >= 0) {
	            sortArray.push(column);
	          }
	        });
	
	        groupArray.sort(function(a, b) { return a.grouping.groupPriority - b.grouping.groupPriority; });
	        groupArray.forEach( function(column, index) {
	          column.grouping.groupPriority = index;
	          column.suppressRemoveSort = true;
	          if ( typeof(column.sort) === 'undefined') {
	            column.sort = {};
	          }
	          column.sort.priority = index;
	        });
	
	        var i = groupArray.length;
	
	        sortArray.sort(function(a, b) { return a.sort.priority - b.sort.priority; });
	        sortArray.forEach(function(column) {
	          column.sort.priority = i;
	          column.suppressRemoveSort = column.colDef.suppressRemoveSort;
	          i++;
	        });
	      },
	
	      /**
	       * @ngdoc function
	       * @name groupRows
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description The rowProcessor that creates the groupHeaders (i.e. does
	       * the actual grouping).
	       *
	       * Assumes it is always called after the sorting processor, guaranteed by the priority setting
	       *
	       * Processes all the rows in order, inserting a groupHeader row whenever there is a change
	       * in value of a grouped row, based on the sortAlgorithm used for the column.  The group header row
	       * is looked up in the groupHeaderCache, and used from there if there is one. The entity is reset
	       * to {} if one is found.
	       *
	       * As it processes it maintains a `processingState` array. This records, for each level of grouping we're
	       * working with, the following information:
	       * ```
	       *   {
	       *     fieldName: name,
	       *     col: col,
	       *     initialised: boolean,
	       *     currentValue: value,
	       *     currentRow: gridRow,
	       *   }
	       * ```
	       * We look for changes in the currentValue at any of the levels.  Where we find a change we:
	       *
	       * - create a new groupHeader row in the array
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows, including our new group rows
	       */
	      groupRows: function( renderableRows ) {
	        if (renderableRows.length === 0) {
	          return renderableRows;
	        }
	
	        var grid = this;
	        grid.grouping.oldGroupingHeaderCache = grid.grouping.groupingHeaderCache || {};
	        grid.grouping.groupingHeaderCache = {};
	
	        var processingState = service.initialiseProcessingState( grid );
	
	        // processes each of the fields we are grouping by, checks if the value has changed and inserts a groupHeader
	        // Broken out as shouldn't create functions in a loop.
	        var updateProcessingState = function( groupFieldState, stateIndex ) {
	          var fieldValue = grid.getCellValue(row, groupFieldState.col);
	
	          // look for change of value - and insert a header
	          if ( !groupFieldState.initialised || rowSorter.getSortFn(grid, groupFieldState.col, renderableRows)(fieldValue, groupFieldState.currentValue) !== 0 ) {
	            service.insertGroupHeader( grid, renderableRows, i, processingState, stateIndex );
	            i++;
	          }
	        };
	
	        // use a for loop because it's tolerant of the array length changing whilst we go - we can
	        // manipulate the iterator when we insert groupHeader rows
	        for (var i = 0; i < renderableRows.length; i++ ) {
	          var row = renderableRows[i];
	
	          if ( row.visible ) {
	            processingState.forEach( updateProcessingState );
	          }
	        }
	
	        delete grid.grouping.oldGroupingHeaderCache;
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name initialiseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Creates the processing state array that is used
	       * for groupRows.
	       *
	       * @param {Grid} grid grid object
	       * @returns {array} an array in the format described in the groupRows method,
	       * initialised with blank values
	       */
	      initialiseProcessingState: function( grid ) {
	        var processingState = [];
	        var columnSettings = service.getGrouping( grid );
	
	        columnSettings.grouping.forEach( function( groupItem, index) {
	          processingState.push({
	            fieldName: groupItem.field,
	            col: groupItem.col,
	            initialised: false,
	            currentValue: null,
	            currentRow: null
	          });
	        });
	
	        return processingState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Get the grouping settings from the columns.  As a side effect
	       * this always renumbers the grouping starting at 0
	       * @param {Grid} grid grid object
	       * @returns {array} an array of the group fields, in order of priority
	       */
	      getGrouping: function( grid ) {
	        var groupArray = [],
	          aggregateArray = [];
	
	        // get all the grouping
	        grid.columns.forEach(function(column) {
	          if ( column.grouping ) {
	            if ( typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0) {
	              groupArray.push({ field: column.field, col: column, groupPriority: column.grouping.groupPriority, grouping: column.grouping });
	            }
	          }
	          if ( column.treeAggregation && column.treeAggregation.type ) {
	            aggregateArray.push({ field: column.field, col: column, aggregation: column.treeAggregation });
	          }
	        });
	
	        // sort grouping into priority order
	        groupArray.sort( function(a, b) {
	          return a.groupPriority - b.groupPriority;
	        });
	
	        // renumber the priority in case it was somewhat messed up, then remove the grouping reference
	        groupArray.forEach( function( group, index) {
	          group.grouping.groupPriority = index;
	          group.groupPriority = index;
	          delete group.grouping;
	        });
	
	        return { grouping: groupArray, aggregations: aggregateArray };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name insertGroupHeader
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Create a group header row, and link it to the various configuration
	       * items that we use.
	       *
	       * Look for the row in the oldGroupingHeaderCache, write the row into the new groupingHeaderCache.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} renderableRows the rows that we are processing
	       * @param {number} rowIndex the row we were up to processing
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header -
	       * i.e. the column that we want to create a header for
	       */
	      insertGroupHeader: function( grid, renderableRows, rowIndex, processingState, stateIndex ) {
	        // set the value that caused the end of a group into the header row and the processing state
	        var col = processingState[stateIndex].col,
	          newValue = grid.getCellValue(renderableRows[rowIndex], col),
	          newDisplayValue = newValue;
	
	        if ( typeof(newValue) === 'undefined' || newValue === null ) {
	          newDisplayValue = grid.options.groupingNullLabel;
	        }
	
	        function getKeyAsValueForCacheMap(key) {
	          return angular.isObject(key) ? JSON.stringify(key) : key;
	        }
	
	        var cacheItem = grid.grouping.oldGroupingHeaderCache;
	
	        for ( var i = 0; i < stateIndex; i++ ) {
	          if ( cacheItem && cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)] ) {
	            cacheItem = cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;
	          }
	        }
	
	        var headerRow;
	
	        if ( cacheItem && cacheItem[getKeyAsValueForCacheMap(newValue)]) {
	          headerRow = cacheItem[getKeyAsValueForCacheMap(newValue)].row;
	          headerRow.entity = {};
	        } else {
	          headerRow = new GridRow( {}, null, grid );
	          gridClassFactory.rowTemplateAssigner.call(grid, headerRow);
	        }
	
	        headerRow.entity['$$' + processingState[stateIndex].col.uid] = { groupVal: newDisplayValue };
	        headerRow.treeLevel = stateIndex;
	        headerRow.groupHeader = true;
	        headerRow.internalRow = true;
	        headerRow.enableCellEdit = false;
	        headerRow.enableSelection = grid.options.enableGroupHeaderSelection;
	        processingState[stateIndex].initialised = true;
	        processingState[stateIndex].currentValue = newValue;
	        processingState[stateIndex].currentRow = headerRow;
	
	        // set all processing states below this one to not be initialised - change of this state
	        // means all those need to start again
	        service.finaliseProcessingState( processingState, stateIndex + 1);
	
	        // insert our new header row
	        renderableRows.splice(rowIndex, 0, headerRow);
	
	        // add our new header row to the cache
	        cacheItem = grid.grouping.groupingHeaderCache;
	        for ( i = 0; i < stateIndex; i++ ) {
	          cacheItem = cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;
	        }
	        cacheItem[getKeyAsValueForCacheMap(newValue)] = { row: headerRow, children: {} };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name finaliseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set all processing states lower than the one that had a break in value to
	       * no longer be initialised.  Render the counts into the entity ready for display.
	       *
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header, all
	       * processing states after this need to be finalised
	       */
	      finaliseProcessingState: function( processingState, stateIndex ) {
	        for ( var i = stateIndex; i < processingState.length; i++) {
	          processingState[i].initialised = false;
	          processingState[i].currentRow = null;
	          processingState[i].currentValue = null;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Extract the groupHeaderCache hash, pulling out only the states.
	       *
	       * The example below shows a grid that is grouped by gender then age
	       *
	       * <pre>
	       *   {
	       *     male: {
	       *       state: 'expanded',
	       *       children: {
	       *         22: { state: 'expanded' },
	       *         30: { state: 'collapsed' }
	       *       }
	       *     },
	       *     female: {
	       *       state: 'expanded',
	       *       children: {
	       *         28: { state: 'expanded' },
	       *         55: { state: 'collapsed' }
	       *       }
	       *     }
	       *   }
	       * </pre>
	       *
	       * @param {object} treeChildren The tree children elements object
	       * @returns {object} the expanded states as an object
	       */
	      getRowExpandedStates: function(treeChildren) {
	        if ( typeof(treeChildren) === 'undefined' ) {
	          return {};
	        }
	
	        var newChildren = {};
	
	        angular.forEach( treeChildren, function( value, key ) {
	          newChildren[key] = { state: value.row.treeNode.state };
	          if ( value.children ) {
	            newChildren[key].children = service.getRowExpandedStates( value.children );
	          } else {
	            newChildren[key].children = {};
	          }
	        });
	
	        return newChildren;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name applyRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Take a hash in the format as created by getRowExpandedStates,
	       * and apply it to the grid.grouping.groupHeaderCache.
	       *
	       * Takes a treeSubset, and applies to a treeSubset - so can be called
	       * recursively.
	       *
	       * @param {object} currentNode can be grid.grouping.groupHeaderCache, or any of
	       * the children of that hash
	       * @param {object} expandedStates can be the full expanded states, or children
	       * of that expanded states (which hopefully matches the subset of the groupHeaderCache)
	       */
	      applyRowExpandedStates: function( currentNode, expandedStates ) {
	        if ( typeof(expandedStates) === 'undefined' ) {
	          return;
	        }
	
	        angular.forEach(expandedStates, function( value, key ) {
	          if ( currentNode[key] ) {
	            currentNode[key].row.treeNode.state = value.state;
	
	            if (value.children && currentNode[key].children) {
	              service.applyRowExpandedStates( currentNode[key].children, value.children );
	            }
	          }
	        });
	      }
	
	
	    };
	
	    return service;
	
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.grouping.directive:uiGridGrouping
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds grouping features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.grouping']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-grouping></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridGrouping', ['uiGridGroupingConstants', 'uiGridGroupingService',
	  function (uiGridGroupingConstants, uiGridGroupingService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableGrouping !== false) {
	              uiGridGroupingService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('ar', {
					"headerCell": {
						"aria": {
							"defaultFilterLabel": "التصفيه بالعمود",
							"removeFilter": "محو التصفيه",
							"columnMenuButtonLabel": "قاءمه الاعمده"
						},
						"priority": "أولويه : ",
						"filterLabel": "تصفيه بالاعمده :"
					},
					"aggregate": {
						"label": "العناصر"
					},
					"groupPanel": {
						"description": "اسحب رأس العمود هنا وأسقطه لإنشاء مجموعه"
					},
					"search": {
						"placeholder": "بحث  ...",
						"showingItems": "العناصر الظاهره :",
						"selectedItems": "العناصر المحدده :",
						"totalItems": "عدد العناصر :",
						"size": "حجم الصفحه :",
						"first": "اول صفحه",
						"next": "الصفحه التاليه",
						"previous": "الصفحه الصابقه",
						"last": "الصفحه الاخيره"
					},
					"menu": {
						"text": "اختيار العمود :"
					},
					"sort": {
						"ascending": "ترتيب تصاعدى",
						"descending": "ترتيب تنازلى",
						"none": "عدم التحديد",
						"remove": "حذف الترتيب"
					},
					"column": {
						"hide": "إخفاء عمود"
					},
					"aggregation": {
						"count": "عدد الصفوف: ",
						"sum": "جمع: ",
						"avg": "المتوسط الحسابى: ",
						"min": "الادنى: ",
						"max": "الاقصى: "
					},
					"pinning": {
						"pinLeft": "تثبيت لليسار",
						"pinRight": "تثبيت لليمين",
						"unpin": "فك التثبيت"
					},
					"columnMenu": {
						"close": "غلق"
					},
					"gridMenu": {
						"aria": {
							"buttonLabel": "قائمه الجدول"
						},
						"columns": "الاعمده:",
						"importerTitle": "إدخال ملف",
						"exporterAllAsCsv": "إخراج كل البيانات ك(csv)",
						"exporterVisibleAsCsv": "إخراج كل البيانات الواضحه ك (csv)",
						"exporterSelectedAsCsv": "إخراج كل البيانات المحدده ك (csv)",
						"exporterAllAsPdf": "إخراج كل البيانات ك(pdf)",
						"exporterVisibleAsPdf": "إخراج كل البيانات الواضحه ك (pdf)",
						"exporterSelectedAsPdf": "إخراج كل البيانات المحدده ك (pdf)",
						"clearAllFilters": "محو كل الترشيح"
					},
					"importer": {
						"noHeaders": "اسماء هؤلاء الاعمده غير واضحه، هل يوجد رأس للملف؟",
						"noObjects": "Objects were not able to be derived, was there data in the file other than headers?",
						"invalidCsv": "الملف غير قادر على الاتمام ، هل ال (CSV) صحيح؟",
						"invalidJson": "الملف غير قادر على الاتمام ، هل ال (JSON) صحيح؟",
						"jsonNotArray": "Imported json file must contain an array, aborting."
					},
					"pagination": {
						"aria": {
							"pageToFirst": "الصفحه الاولى",
							"pageBack": "الصفه السابقه",
							"pageSelected": "الصفحه المحدده",
							"pageForward": "الصفحه التاليه",
							"pageToLast": "الصفحه الاخيره"
						},
						"sizes": "عدد العناصر فى الصفحه",
						"totalItems": "عناصر",
						"through": "إلى",
						"of": "من"
					},
					"grouping": {
						"group": "جمع",
						"ungroup": "فك الجمع",
						"aggregate_count": "جمله : العدد",
						"aggregate_sum": "جمله : الحاصل",
						"aggregate_max": "جمله : الاقصى",
						"aggregate_min": "جمله : الاقل",
						"aggregate_avg": "جمله :المتوسط ",
						"aggregate_remove": "جمله : حذف"
					},
					"validate": {
						"error": "خطأ :",
						"minLength": "القيمه لابد ان لا تقل عن THRESHOLD حرف.",
						"maxLength": "القيمه لابد ان لا تزيد عن THRESHOLD حرف.",
						"required": "مطلوب قيمه"
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('bg', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Филттър за колоната',
	            removeFilter: 'Премахни филтър',
	            columnMenuButtonLabel: 'Меню на колоната'
	          },
	          priority: 'Приоритет:',
	          filterLabel: "Филтър за колоната: "
	        },
	        aggregate: {
	          label: 'обекти'
	        },
	        search: {
	          placeholder: 'Търсене...',
	          showingItems: 'Показани обекти:',
	          selectedItems: 'избрани обекти:',
	          totalItems: 'Общо:',
	          size: 'Размер на страницата:',
	          first: 'Първа страница',
	          next: 'Следваща страница',
	          previous: 'Предишна страница',
	          last: 'Последна страница'
	        },
	        menu: {
	          text: 'Избери колони:'
	        },
	        sort: {
	          ascending: 'Сортиране по възходящ ред',
	          descending: 'Сортиране по низходящ ред',
	          none: 'Без сортиране',
	          remove: 'Премахни сортирането'
	        },
	        column: {
	          hide: 'Скрий колоната'
	        },
	        aggregation: {
	          count: 'Общо редове: ',
	          sum: 'общо: ',
	          avg: 'средно: ',
	          min: 'най-малко: ',
	          max: 'най-много: '
	        },
	        pinning: {
	          pinLeft: 'Прикрепи вляво',
	          pinRight: 'Прикрепи вдясно',
	          unpin: 'Премахване'
	        },
	        columnMenu: {
	          close: 'Затвори'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню на таблицата'
	          },
	          columns: 'Колони:',
	          importerTitle: 'Импортиране на файл',
	          exporterAllAsCsv: 'Експортиране на данните като csv',
	          exporterVisibleAsCsv: 'Експортиране на видимите данни като csv',
	          exporterSelectedAsCsv: 'Експортиране на избраните данни като csv',
	          exporterAllAsPdf: 'Експортиране на данните като pdf',
	          exporterVisibleAsPdf: 'Експортиране на видимите данни като pdf',
	          exporterSelectedAsPdf: 'Експортиране на избраните данни като pdf',
	          clearAllFilters: 'Премахни всички филтри'
	        },
	        importer: {
	          noHeaders: 'Имената на колоните не успяха да бъдат извлечени, файлът има ли хедър?',
	          noObjects: 'Обектите не успяха да бъдат извлечени, файлът съдържа ли данни, различни от хедър?',
	          invalidCsv: 'Файлът не може да бъде обработеб, уверете се, че е валиден CSV файл',
	          invalidJson: 'Файлът не може да бъде обработеб, уверете се, че е валиден JSON файл',
	          jsonNotArray: 'Импортираният JSON файл трябва да съдържа масив, прекратяване.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Към първа страница',
	            pageBack: 'Страница назад',
	            pageSelected: 'Избрана страница',
	            pageForward: 'Страница напред',
	            pageToLast: 'Към последна страница'
	          },
	          sizes: 'обекта на страница',
	          totalItems: 'обекта',
	          through: 'до',
	          of: 'от'
	        },
	        grouping: {
	          group: 'Групиране',
	          ungroup: 'Премахване на групирането',
	          aggregate_count: 'Сбор: Брой',
	          aggregate_sum: 'Сбор: Сума',
	          aggregate_max: 'Сбор: Максимум',
	          aggregate_min: 'Сбор: Минимум',
	          aggregate_avg: 'Сбор: Средно',
	          aggregate_remove: 'Сбор: Премахване'
	        },
	        validate: {
	          error: 'Грешка:',
	          minLength: 'Стойността трябва да съдържа поне THRESHOLD символа.',
	          maxLength: 'Стойността не трябва да съдържа повече от THRESHOLD символа.',
	          required: 'Необходима е стойност.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      var lang = {
	              aggregate: {
	                  label: 'položky'
	              },
	              groupPanel: {
	                  description: 'Přesuňte záhlaví zde pro vytvoření skupiny dle sloupce.'
	              },
	              search: {
	                  placeholder: 'Hledat...',
	                  showingItems: 'Zobrazuji položky:',
	                  selectedItems: 'Vybrané položky:',
	                  totalItems: 'Celkem položek:',
	                  size: 'Velikost strany:',
	                  first: 'První strana',
	                  next: 'Další strana',
	                  previous: 'Předchozí strana',
	                  last: 'Poslední strana'
	              },
	              menu: {
	                  text: 'Vyberte sloupec:'
	              },
	              sort: {
	                  ascending: 'Seřadit od A-Z',
	                  descending: 'Seřadit od Z-A',
	                  remove: 'Odebrat seřazení'
	              },
	              column: {
	                  hide: 'Schovat sloupec'
	              },
	              aggregation: {
	                  count: 'celkem řádků: ',
	                  sum: 'celkem: ',
	                  avg: 'avg: ',
	                  min: 'min.: ',
	                  max: 'max.: '
	              },
	              pinning: {
	                  pinLeft: 'Zamknout vlevo',
	                  pinRight: 'Zamknout vpravo',
	                  unpin: 'Odemknout'
	              },
	              gridMenu: {
	                  columns: 'Sloupce:',
	                  importerTitle: 'Importovat soubor',
	                  exporterAllAsCsv: 'Exportovat všechna data do csv',
	                  exporterVisibleAsCsv: 'Exportovat viditelná data do csv',
	                  exporterSelectedAsCsv: 'Exportovat vybraná data do csv',
	                  exporterAllAsPdf: 'Exportovat všechna data do pdf',
	                  exporterVisibleAsPdf: 'Exportovat viditelná data do pdf',
	                  exporterSelectedAsPdf: 'Exportovat vybraná data do pdf',
	                  exporterAllAsExcel: 'Exportovat všechna data do excel',
	                  exporterVisibleAsExcel: 'Exportovat viditelná data do excel',
	                  exporterSelectedAsExcel: 'Exportovat vybraná data do excel',
	                  clearAllFilters: 'Odstranit všechny filtry'
	              },
	              importer: {
	                  noHeaders: 'Názvy sloupců se nepodařilo získat, obsahuje soubor záhlaví?',
	                  noObjects: 'Data se nepodařilo zpracovat, obsahuje soubor řádky mimo záhlaví?',
	                  invalidCsv: 'Soubor nelze zpracovat, jedná se o CSV?',
	                  invalidJson: 'Soubor nelze zpracovat, je to JSON?',
	                  jsonNotArray: 'Soubor musí obsahovat json. Ukončuji..'
	              },
	              pagination: {
	                  sizes: 'položek na stránku',
	                  totalItems: 'položek'
	              },
	              grouping: {
	                  group: 'Seskupit',
	                  ungroup: 'Odebrat seskupení',
	                  aggregate_count: 'Agregace: Count',
	                  aggregate_sum: 'Agregace: Sum',
	                  aggregate_max: 'Agregace: Max',
	                  aggregate_min: 'Agregace: Min',
	                  aggregate_avg: 'Agregace: Avg',
	                  aggregate_remove: 'Agregace: Odebrat'
	              }
	          };
	
	          // support varianty of different czech keys.
	          $delegate.add('cs', lang);
	          $delegate.add('cz', lang);
	          $delegate.add('cs-cz', lang);
	          $delegate.add('cs-CZ', lang);
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('da', {
					aggregate: {
						label: 'artikler'
					},
					groupPanel: {
						description: 'Grupér rækker udfra en kolonne ved at trække dens overskift hertil.'
					},
					search: {
						placeholder: 'Søg...',
						showingItems: 'Viste rækker:',
						selectedItems: 'Valgte rækker:',
						totalItems: 'Rækker totalt:',
						size: 'Side størrelse:',
						first: 'Første side',
						next: 'Næste side',
						previous: 'Forrige side',
						last: 'Sidste side'
					},
					menu: {
						text: 'Vælg kolonner:'
					},
					sort: {
						ascending: 'Sorter stigende',
						descending: 'Sorter faldende',
						none: 'Sorter ingen',
						remove: 'Fjern sortering'
					},
					column: {
						hide: 'Skjul kolonne'
					},
					aggregation: {
						count: 'antal rækker: ',
						sum: 'sum: ',
						avg: 'gns: ',
						min: 'min: ',
						max: 'max: '
					},
					pinning: {
						pinLeft: 'Fastgør til venstre',
						pinRight: 'Fastgør til højre',
						unpin: 'Frigør'
					},
					gridMenu: {
						columns: 'Kolonner:',
						importerTitle: 'Importer fil',
						exporterAllAsCsv: 'Eksporter alle data som csv',
						exporterVisibleAsCsv: 'Eksporter synlige data som csv',
						exporterSelectedAsCsv: 'Eksporter markerede data som csv',
						exporterAllAsPdf: 'Eksporter alle data som pdf',
						exporterVisibleAsPdf: 'Eksporter synlige data som pdf',
						exporterSelectedAsPdf: 'Eksporter markerede data som pdf',
						exporterAllAsExcel: 'Eksporter alle data som excel',
						exporterVisibleAsExcel: 'Eksporter synlige data som excel',
						exporterSelectedAsExcel: 'Eksporter markerede data som excel',
						clearAllFilters: 'Clear all filters'
					},
					importer: {
						noHeaders: 'Column names were unable to be derived, does the file have a header?',
						noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
						invalidCsv: 'File was unable to be processed, is it valid CSV?',
						invalidJson: 'File was unable to be processed, is it valid Json?',
						jsonNotArray: 'Imported json file must contain an array, aborting.'
					},
					pagination: {
						aria: {
							pageToFirst: 'Gå til første',
							pageBack: 'Gå tilbage',
							pageSelected: 'Valgte side',
							pageForward: 'Gå frem',
							pageToLast: 'Gå til sidste'
						},
						sizes: 'genstande per side',
						totalItems: 'genstande',
						through: 'gennem',
						of: 'af'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('de', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter für Spalte',
	            removeFilter: 'Filter löschen',
	            columnMenuButtonLabel: 'Spaltenmenü',
	            column: 'Spalte'
	          },
	          priority: 'Priorität:',
	          filterLabel: "Filter für Spalte: "
	        },
	        aggregate: {
	          label: 'Eintrag'
	        },
	        groupPanel: {
	          description: 'Ziehen Sie eine Spaltenüberschrift hierhin, um nach dieser Spalte zu gruppieren.'
	        },
	        search: {
	          aria: {
	            selected: 'Zeile markiert',
	            notSelected: 'Zeile nicht markiert'
	          },
	          placeholder: 'Suche...',
	          showingItems: 'Zeige Einträge:',
	          selectedItems: 'Ausgewählte Einträge:',
	          totalItems: 'Einträge gesamt:',
	          size: 'Einträge pro Seite:',
	          first: 'Erste Seite',
	          next: 'Nächste Seite',
	          previous: 'Vorherige Seite',
	          last: 'Letzte Seite'
	        },
	        menu: {
	          text: 'Spalten auswählen:'
	        },
	        sort: {
	          ascending: 'aufsteigend sortieren',
	          descending: 'absteigend sortieren',
	          none: 'keine Sortierung',
	          remove: 'Sortierung zurücksetzen'
	        },
	        column: {
	          hide: 'Spalte ausblenden'
	        },
	        aggregation: {
	          count: 'Zeilen insgesamt: ',
	          sum: 'gesamt: ',
	          avg: 'Durchschnitt: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	            pinLeft: 'Links anheften',
	            pinRight: 'Rechts anheften',
	            unpin: 'Lösen'
	        },
	        columnMenu: {
	          close: 'Schließen'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Tabellenmenü'
	          },
	          columns: 'Spalten:',
	          importerTitle: 'Datei importieren',
	          exporterAllAsCsv: 'Alle Daten als CSV exportieren',
	          exporterVisibleAsCsv: 'Sichtbare Daten als CSV exportieren',
	          exporterSelectedAsCsv: 'Markierte Daten als CSV exportieren',
	          exporterAllAsPdf: 'Alle Daten als PDF exportieren',
	          exporterVisibleAsPdf: 'Sichtbare Daten als PDF exportieren',
	          exporterSelectedAsPdf: 'Markierte Daten als PDF exportieren',
	          exporterAllAsExcel: 'Alle Daten als Excel exportieren',
	          exporterVisibleAsExcel: 'Sichtbare Daten als Excel exportieren',
	          exporterSelectedAsExcel: 'Markierte Daten als Excel exportieren',
	          clearAllFilters: 'Alle Filter zurücksetzen'
	        },
	        importer: {
	          noHeaders: 'Es konnten keine Spaltennamen ermittelt werden. Sind in der Datei Spaltendefinitionen enthalten?',
	          noObjects: 'Es konnten keine Zeileninformationen gelesen werden, Sind in der Datei außer den Spaltendefinitionen auch Daten enthalten?',
	          invalidCsv: 'Die Datei konnte nicht eingelesen werden, ist es eine gültige CSV-Datei?',
	          invalidJson: 'Die Datei konnte nicht eingelesen werden. Enthält sie gültiges JSON?',
	          jsonNotArray: 'Die importierte JSON-Datei muß ein Array enthalten. Breche Import ab.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Zum Anfang',
	            pageBack: 'Seite zurück',
	            pageSelected: 'Ausgewählte Seite',
	            pageForward: 'Seite vor',
	            pageToLast: 'Zum Ende'
	          },
	          sizes: 'Einträge pro Seite',
	          totalItems: 'Einträgen',
	          through: 'bis',
	          of: 'von'
	        },
	        grouping: {
	            group: 'Gruppieren',
	            ungroup: 'Gruppierung aufheben',
	            aggregate_count: 'Agg: Anzahl',
	            aggregate_sum: 'Agg: Summe',
	            aggregate_max: 'Agg: Maximum',
	            aggregate_min: 'Agg: Minimum',
	            aggregate_avg: 'Agg: Mittelwert',
	            aggregate_remove: 'Aggregation entfernen'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('es-ct', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtre per columna',
	            removeFilter: 'Elimina el filtre',
	            columnMenuButtonLabel: 'Menú de Columna',
	            column: 'Columna'
	          },
	          priority: 'Priority:',
	          filterLabel: 'Filtre per columna: '
	        },
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Arrossegueu una capçalera de columna aquí i deixeu-lo anar per agrupar per aquesta columna.'
	        },
	        search: {
	          aria: {
	            selected: 'Fila seleccionada',
	            notSelected: 'Fila no seleccionada'
	          },
	          placeholder: 'Cerca...',
	          showingItems: 'Ítems Mostrats:',
	          selectedItems: 'Ítems Seleccionats:',
	          totalItems: 'Ítems Totals:',
	          size: 'Mida de la pàgina:',
	          first: 'Primera Pàgina',
	          next: 'Propera Pàgina',
	          previous: 'Pàgina Anterior',
	          last: 'Última Pàgina'
	        },
	        menu: {
	          text: 'Triar Columnes:'
	        },
	        sort: {
	          ascending: 'Ordena Ascendent',
	          descending: 'Ordena Descendent',
	          none: 'Sense Ordre',
	          remove: 'Eliminar Ordre'
	        },
	        column: {
	          hide: 'Amaga la Columna'
	        },
	        aggregation: {
	          count: 'Files Totals: ',
	          sum: 'total: ',
	          avg: 'mitjà: ',
	          min: 'mín: ',
	          max: 'màx: '
	        },
	        pinning: {
	          pinLeft: "Fixar a l'Esquerra",
	          pinRight: 'Fixar a la Dreta',
	          unpin: 'Treure Fixació'
	        },
	        columnMenu: {
	          close: 'Tanca'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menú de Quadrícula'
	          },
	          columns: 'Columnes:',
	          importerTitle: 'Importa el fitxer',
	          exporterAllAsCsv: 'Exporta tot com CSV',
	          exporterVisibleAsCsv: 'Exporta les dades visibles com a CSV',
	          exporterSelectedAsCsv: 'Exporta les dades seleccionades com a CSV',
	          exporterAllAsPdf: 'Exporta tot com PDF',
	          exporterVisibleAsPdf: 'Exporta les dades visibles com a PDF',
	          exporterSelectedAsPdf: 'Exporta les dades seleccionades com a PDF',
	          exporterAllAsExcel: 'Exporta tot com Excel',
	          exporterVisibleAsExcel: 'Exporta les dades visibles com Excel',
	          exporterSelectedAsExcel: 'Exporta les dades seleccionades com Excel',
	          clearAllFilters: 'Netejar tots els filtres'
	        },
	        importer: {
	          noHeaders: "No va ser possible derivar els noms de les columnes, té encapçalats l'arxiu?",
	          noObjects: "No va ser possible obtenir registres, conté dades l'arxiu, a part de les capçaleres?",
	          invalidCsv: "No va ser possible processar l'arxiu, ¿és un CSV vàlid?",
	          invalidJson: "No va ser possible processar l'arxiu, ¿és un JSON vàlid?",
	          jsonNotArray: 'El fitxer json importat ha de contenir una matriu, avortant.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Page to first',
	            pageBack: 'Page back',
	            pageSelected: 'Selected page',
	            pageForward: 'Page forward',
	            pageToLast: 'Page to last'
	          },
	          sizes: 'ítems per pàgina',
	          totalItems: 'ítems',
	          through: 'a',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Compte',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Máx',
	          aggregate_min: 'Agr: Mín',
	          aggregate_avg: 'Agr: Mitjà',
	          aggregate_remove: 'Agr: Treure'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'El valor ha de tenir almenys caràcters THRESHOLD.',
	          maxLength: 'El valor ha de tenir com a màxim caràcters THRESHOLD.',
	          required: 'Un valor és necessari.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('es', {
	        aggregate: {
	          label: 'Artículos'
	        },
	        groupPanel: {
	          description: 'Arrastre un encabezado de columna aquí y suéltelo para agrupar por esa columna.'
	        },
	        search: {
	          placeholder: 'Buscar...',
	          showingItems: 'Artículos Mostrados:',
	          selectedItems: 'Artículos Seleccionados:',
	          totalItems: 'Artículos Totales:',
	          size: 'Tamaño de Página:',
	          first: 'Primera Página',
	          next: 'Página Siguiente',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Elegir columnas:'
	        },
	        sort: {
	          ascending: 'Orden Ascendente',
	          descending: 'Orden Descendente',
	          remove: 'Sin Ordenar'
	        },
	        column: {
	          hide: 'Ocultar la columna'
	        },
	        aggregation: {
	          count: 'filas totales: ',
	          sum: 'total: ',
	          avg: 'media: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fijar a la Izquierda',
	          pinRight: 'Fijar a la Derecha',
	          unpin: 'Quitar Fijación'
	        },
	        gridMenu: {
	          columns: 'Columnas:',
	          importerTitle: 'Importar archivo',
	          exporterAllAsCsv: 'Exportar todo como csv',
	          exporterVisibleAsCsv: 'Exportar vista como csv',
	          exporterSelectedAsCsv: 'Exportar selección como csv',
	          exporterAllAsPdf: 'Exportar todo como pdf',
	          exporterVisibleAsPdf: 'Exportar vista como pdf',
	          exporterSelectedAsPdf: 'Exportar selección como pdf',
	          exporterAllAsExcel: 'Exportar todo como excel',
	          exporterVisibleAsExcel: 'Exportar vista como excel',
	          exporterSelectedAsExcel: 'Exportar selección como excel',
	          clearAllFilters: 'Limpiar todos los filtros'
	        },
	        importer: {
	          noHeaders: 'No fue posible derivar los nombres de las columnas, ¿tiene encabezados el archivo?',
	          noObjects: 'No fue posible obtener registros, ¿contiene datos el archivo, aparte de los encabezados?',
	          invalidCsv: 'No fue posible procesar el archivo, ¿es un CSV válido?',
	          invalidJson: 'No fue posible procesar el archivo, ¿es un Json válido?',
	          jsonNotArray: 'El archivo json importado debe contener un array, abortando.'
	        },
	        pagination: {
	          aria: {
											pageToFirst: 'Página para primero',
											pageBack: 'Página atrás',
											pageSelected: 'Página seleccionada',
											pageForward: 'Avance de página',
											pageToLast: 'Página para durar'
										},
	          through: 'mediante',
	          sizes: 'registros por página',
	          totalItems: 'registros',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Cont',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Máx',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Prom',
	          aggregate_remove: 'Agr: Quitar'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	/**
	 * Translated by: R. Salarmehr
	 *                M. Hosseynzade
	 *                Using Vajje.com online dictionary.
	 */
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('fa', {
	        aggregate: {
	          label: 'قلم'
	        },
	        groupPanel: {
	          description: 'عنوان یک ستون را بگیر و به گروهی از آن ستون رها کن.'
	        },
	        search: {
	          placeholder: 'جستجو...',
	          showingItems: 'نمایش اقلام:',
	          selectedItems: 'قلم\u200cهای انتخاب شده:',
	          totalItems: 'مجموع اقلام:',
	          size: 'اندازه\u200cی صفحه:',
	          first: 'اولین صفحه',
	          next: 'صفحه\u200cی\u200cبعدی',
	          previous: 'صفحه\u200cی\u200c قبلی',
	          last: 'آخرین صفحه'
	        },
	        menu: {
	          text: 'ستون\u200cهای انتخابی:'
	        },
	        sort: {
	          ascending: 'ترتیب صعودی',
	          descending: 'ترتیب نزولی',
	          remove: 'حذف مرتب کردن'
	        },
	        column: {
	          hide: 'پنهان\u200cکردن ستون'
	        },
	        aggregation: {
	          count: 'تعداد: ',
	          sum: 'مجموع: ',
	          avg: 'میانگین: ',
	          min: 'کمترین: ',
	          max: 'بیشترین: '
	        },
	        pinning: {
	          pinLeft: 'پین کردن سمت چپ',
	          pinRight: 'پین کردن سمت راست',
	          unpin: 'حذف پین'
	        },
	        gridMenu: {
	          columns: 'ستون\u200cها:',
	          importerTitle: 'وارد کردن فایل',
	          exporterAllAsCsv: 'خروجی تمام داده\u200cها در فایل csv',
	          exporterVisibleAsCsv: 'خروجی داده\u200cهای قابل مشاهده در فایل csv',
	          exporterSelectedAsCsv: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل csv',
	          exporterAllAsPdf: 'خروجی تمام داده\u200cها در فایل pdf',
	          exporterVisibleAsPdf: 'خروجی داده\u200cهای قابل مشاهده در فایل pdf',
	          exporterSelectedAsPdf: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل pdf',
	          clearAllFilters: 'پاک کردن تمام فیلتر'
	        },
	        importer: {
	          noHeaders: 'نام ستون قابل استخراج نیست. آیا فایل عنوان دارد؟',
	          noObjects: 'اشیا قابل استخراج نیستند. آیا به جز عنوان\u200cها در فایل داده وجود دارد؟',
	          invalidCsv: 'فایل قابل پردازش نیست. آیا فرمت  csv  معتبر است؟',
	          invalidJson: 'فایل قابل پردازش نیست. آیا فرمت json   معتبر است؟',
	          jsonNotArray: 'فایل json وارد شده باید حاوی آرایه باشد. عملیات ساقط شد.'
	        },
	        pagination: {
	          sizes: 'اقلام در هر صفحه',
	          totalItems: 'اقلام',
	          of: 'از'
	        },
	        grouping: {
	          group: 'گروه\u200cبندی',
	          ungroup: 'حذف گروه\u200cبندی',
	          aggregate_count: 'Agg: تعداد',
	          aggregate_sum: 'Agg: جمع',
	          aggregate_max: 'Agg: بیشینه',
	          aggregate_min: 'Agg: کمینه',
	          aggregate_avg: 'Agg: میانگین',
	          aggregate_remove: 'Agg: حذف'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fi', {
	        aggregate: {
	          label: 'rivit'
	        },
	        groupPanel: {
	          description: 'Raahaa ja pudota otsikko tähän ryhmittääksesi sarakkeen mukaan.'
	        },
	        search: {
	          placeholder: 'Hae...',
	          showingItems: 'Näytetään rivejä:',
	          selectedItems: 'Valitut rivit:',
	          totalItems: 'Rivejä yht.:',
	          size: 'Näytä:',
	          first: 'Ensimmäinen sivu',
	          next: 'Seuraava sivu',
	          previous: 'Edellinen sivu',
	          last: 'Viimeinen sivu'
	        },
	        menu: {
	          text: 'Valitse sarakkeet:'
	        },
	        sort: {
	          ascending: 'Järjestä nouseva',
	          descending: 'Järjestä laskeva',
	          remove: 'Poista järjestys'
	        },
	        column: {
	          hide: 'Piilota sarake'
	        },
	        aggregation: {
	          count: 'Rivejä yht.: ',
	          sum: 'Summa: ',
	          avg: 'K.a.: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	         pinLeft: 'Lukitse vasemmalle',
	          pinRight: 'Lukitse oikealle',
	          unpin: 'Poista lukitus'
	        },
	        gridMenu: {
	          columns: 'Sarakkeet:',
	          importerTitle: 'Tuo tiedosto',
	          exporterAllAsCsv: 'Vie tiedot csv-muodossa',
	          exporterVisibleAsCsv: 'Vie näkyvä tieto csv-muodossa',
	          exporterSelectedAsCsv: 'Vie valittu tieto csv-muodossa',
	          exporterAllAsPdf: 'Vie tiedot pdf-muodossa',
	          exporterVisibleAsPdf: 'Vie näkyvä tieto pdf-muodossa',
	          exporterSelectedAsPdf: 'Vie valittu tieto pdf-muodossa',
	          exporterAllAsExcel: 'Vie tiedot excel-muodossa',
	          exporterVisibleAsExcel: 'Vie näkyvä tieto excel-muodossa',
	          exporterSelectedAsExcel: 'Vie valittu tieto excel-muodossa',
	          clearAllFilters: 'Puhdista kaikki suodattimet'
	        },
	        importer: {
	          noHeaders: 'Sarakkeen nimiä ei voitu päätellä, onko tiedostossa otsikkoriviä?',
	          noObjects: 'Tietoja ei voitu lukea, onko tiedostossa muuta kuin otsikkot?',
	          invalidCsv: 'Tiedostoa ei voitu käsitellä, oliko se CSV-muodossa?',
	          invalidJson: 'Tiedostoa ei voitu käsitellä, oliko se JSON-muodossa?',
	          jsonNotArray: 'Tiedosto ei sisältänyt taulukkoa, lopetetaan.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fr', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtre de la colonne',
	            removeFilter: 'Supprimer le filtre',
	            columnMenuButtonLabel: 'Menu de la colonne'
	          },
	          priority: 'Priorité:',
	          filterLabel: "Filtre de la colonne: "
	        },
	        aggregate: {
	          label: 'éléments'
	        },
	        groupPanel: {
	          description: 'Faites glisser une en-tête de colonne ici pour créer un groupe de colonnes.'
	        },
	        search: {
	          placeholder: 'Recherche...',
	          showingItems: 'Affichage des éléments :',
	          selectedItems: 'Éléments sélectionnés :',
	          totalItems: 'Nombre total d\'éléments:',
	          size: 'Taille de page:',
	          first: 'Première page',
	          next: 'Page Suivante',
	          previous: 'Page précédente',
	          last: 'Dernière page'
	        },
	        menu: {
	          text: 'Choisir des colonnes :'
	        },
	        sort: {
	          ascending: 'Trier par ordre croissant',
	          descending: 'Trier par ordre décroissant',
	          none: 'Aucun tri',
	          remove: 'Enlever le tri'
	        },
	        column: {
	          hide: 'Cacher la colonne'
	        },
	        aggregation: {
	          count: 'lignes totales: ',
	          sum: 'total: ',
	          avg: 'moy: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Épingler à gauche',
	          pinRight: 'Épingler à droite',
	          unpin: 'Détacher'
	        },
	        columnMenu: {
	          close: 'Fermer'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu du tableau'
	          },
	          columns: 'Colonnes:',
	          importerTitle: 'Importer un fichier',
	          exporterAllAsCsv: 'Exporter toutes les données en CSV',
	          exporterVisibleAsCsv: 'Exporter les données visibles en CSV',
	          exporterSelectedAsCsv: 'Exporter les données sélectionnées en CSV',
	          exporterAllAsPdf: 'Exporter toutes les données en PDF',
	          exporterVisibleAsPdf: 'Exporter les données visibles en PDF',
	          exporterSelectedAsPdf: 'Exporter les données sélectionnées en PDF',
	          exporterAllAsExcel: 'Exporter toutes les données en Excel',
	          exporterVisibleAsExcel: 'Exporter les données visibles en Excel',
	          exporterSelectedAsExcel: 'Exporter les données sélectionnées en Excel',
	          clearAllFilters: 'Nettoyez tous les filtres'
	        },
	        importer: {
	          noHeaders: 'Impossible de déterminer le nom des colonnes, le fichier possède-t-il une en-tête ?',
	          noObjects: 'Aucun objet trouvé, le fichier possède-t-il des données autres que l\'en-tête ?',
	          invalidCsv: 'Le fichier n\'a pas pu être traité, le CSV est-il valide ?',
	          invalidJson: 'Le fichier n\'a pas pu être traité, le JSON est-il valide ?',
	          jsonNotArray: 'Le fichier JSON importé doit contenir un tableau, abandon.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Aller à la première page',
	            pageBack: 'Page précédente',
	            pageSelected: 'Page sélectionnée',
	            pageForward: 'Page suivante',
	            pageToLast: 'Aller à la dernière page'
	          },
	          sizes: 'éléments par page',
	          totalItems: 'éléments',
	          through: 'à',
	          of: 'sur'
	        },
	        grouping: {
	          group: 'Grouper',
	          ungroup: 'Dégrouper',
	          aggregate_count: 'Agg: Compter',
	          aggregate_sum: 'Agg: Somme',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Moy',
	          aggregate_remove: 'Agg: Retirer'
	        },
	        validate: {
	          error: 'Erreur:',
	          minLength: 'La valeur doit être supérieure ou égale à THRESHOLD caractères.',
	          maxLength: 'La valeur doit être inférieure ou égale à THRESHOLD caractères.',
	          required: 'Une valeur est nécéssaire.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('he', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'גרור עמודה לכאן ושחרר בכדי לקבץ עמודה זו.'
	        },
	        search: {
	          placeholder: 'חפש...',
	          showingItems: 'מציג:',
	          selectedItems: 'סה"כ נבחרו:',
	          totalItems: 'סה"כ רשומות:',
	          size: 'תוצאות בדף:',
	          first: 'דף ראשון',
	          next: 'דף הבא',
	          previous: 'דף קודם',
	          last: 'דף אחרון'
	        },
	        menu: {
	          text: 'בחר עמודות:'
	        },
	        sort: {
	          ascending: 'סדר עולה',
	          descending: 'סדר יורד',
	          remove: 'בטל'
	        },
	        column: {
	          hide: 'טור הסתר'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          exporterAllAsExcel: 'Export all data as excel',
	          exporterVisibleAsExcel: 'Export visible data as excel',
	          exporterSelectedAsExcel: 'Export selected data as excel',
	          clearAllFilters: 'Clean all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('hy', {
	        aggregate: {
	          label: 'տվյալներ'
	        },
	        groupPanel: {
	          description: 'Ըստ սյան խմբավորելու համար քաշեք և գցեք վերնագիրն այստեղ։'
	        },
	        search: {
	          placeholder: 'Փնտրում...',
	          showingItems: 'Ցուցադրված տվյալներ՝',
	          selectedItems: 'Ընտրված:',
	          totalItems: 'Ընդամենը՝',
	          size: 'Տողերի քանակը էջում՝',
	          first: 'Առաջին էջ',
	          next: 'Հաջորդ էջ',
	          previous: 'Նախորդ էջ',
	          last: 'Վերջին էջ'
	        },
	        menu: {
	          text: 'Ընտրել սյուները:'
	        },
	        sort: {
	          ascending: 'Աճման կարգով',
	          descending: 'Նվազման կարգով',
	          remove: 'Հանել '
	        },
	        column: {
	          hide: 'Թաքցնել սյունը'
	        },
	        aggregation: {
	          count: 'ընդամենը տող՝ ',
	          sum: 'ընդամենը՝ ',
	          avg: 'միջին՝ ',
	          min: 'մին՝ ',
	          max: 'մաքս՝ '
	        },
	        pinning: {
	          pinLeft: 'Կպցնել ձախ կողմում',
	          pinRight: 'Կպցնել աջ կողմում',
	          unpin: 'Արձակել'
	        },
	        gridMenu: {
	          columns: 'Սյուներ:',
	          importerTitle: 'Ներմուծել ֆայլ',
	          exporterAllAsCsv: 'Արտահանել ամբողջը CSV',
	          exporterVisibleAsCsv: 'Արտահանել երևացող տվյալները CSV',
	          exporterSelectedAsCsv: 'Արտահանել ընտրված տվյալները CSV',
	          exporterAllAsPdf: 'Արտահանել PDF',
	          exporterVisibleAsPdf: 'Արտահանել երևացող տվյալները PDF',
	          exporterSelectedAsPdf: 'Արտահանել ընտրված տվյալները PDF',
	          exporterAllAsExcel: 'Արտահանել excel',
	          exporterVisibleAsExcel: 'Արտահանել երևացող տվյալները excel',
	          exporterSelectedAsExcel: 'Արտահանել ընտրված տվյալները excel',
	          clearAllFilters: 'Մաքրել բոլոր ֆիլտրերը'
	        },
	        importer: {
	          noHeaders: 'Հնարավոր չեղավ որոշել սյան վերնագրերը։ Արդյո՞ք ֆայլը ունի վերնագրեր։',
	          noObjects: 'Հնարավոր չեղավ կարդալ տվյալները։ Արդյո՞ք ֆայլում կան տվյալներ։',
	          invalidCsv: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր CSV է։',
	          invalidJson: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր Json է։',
	          jsonNotArray: 'Ներմուծված json ֆայլը պետք է պարունակի զանգված, կասեցվում է։'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('is', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Sía fyrir dálk',
	            removeFilter: 'Fjarlægja síu',
	            columnMenuButtonLabel: 'Dálkavalmynd'
	          },
	          priority: 'Forgangsröðun:',
	          filterLabel: "Sía fyrir dálka: "
	        },
	        aggregate: {
	          label: 'hlutir'
	        },
	        groupPanel: {
	          description: 'Dragðu dálkhaus hingað til að flokka saman eftir þeim dálki.'
	        },
	        search: {
	          placeholder: 'Leita...',
	          showingItems: 'Sýni hluti:',
	          selectedItems: 'Valdir hlutir:',
	          totalItems: 'Hlutir alls:',
	          size: 'Stærð síðu:',
	          first: 'Fyrsta síða',
	          next: 'Næsta síða',
	          previous: 'Fyrri síða',
	          last: 'Síðasta síða'
	        },
	        menu: {
	          text: 'Veldu dálka:'
	        },
	        sort: {
	          ascending: 'Raða hækkandi',
	          descending: 'Raða lækkandi',
	          none: 'Engin röðun',
	          remove: 'Fjarlægja röðun'
	        },
	        column: {
	          hide: 'Fela dálk'
	        },
	        aggregation: {
	          count: 'fjöldi raða: ',
	          sum: 'summa: ',
	          avg: 'meðaltal: ',
	          min: 'lágmark: ',
	          max: 'hámark: '
	        },
	        pinning: {
	          pinLeft: 'Festa til vinstri',
	          pinRight: 'Festa til hægri',
	          unpin: 'Losa'
	        },
	        columnMenu: {
	          close: 'Loka'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Töflu valmynd'
	          },
	          columns: 'Dálkar:',
	          importerTitle: 'Flytja inn skjal',
	          exporterAllAsCsv: 'Flytja út gögn sem csv',
	          exporterVisibleAsCsv: 'Flytja út sýnileg gögn sem csv',
	          exporterSelectedAsCsv: 'Flytja út valin gögn sem csv',
	          exporterAllAsPdf: 'Flytja út öll gögn sem pdf',
	          exporterVisibleAsPdf: 'Flytja út sýnileg gögn sem pdf',
	          exporterSelectedAsPdf: 'Flytja út valin gögn sem pdf',
	          clearAllFilters: 'Hreinsa allar síur'
	        },
	        importer: {
	          noHeaders: 'Ekki hægt að vinna dálkanöfn úr skjalinu, er skjalið örugglega með haus?',
	          noObjects: 'Ekki hægt að vinna hluti úr skjalinu, voru örugglega gögn í skjalinu önnur en hausinn?',
	          invalidCsv: 'Tókst ekki að vinna skjal, er það örggulega gilt CSV?',
	          invalidJson: 'Tókst ekki að vinna skjal, er það örugglega gilt Json?',
	          jsonNotArray: 'Innflutt json skjal verður að innihalda fylki, hætti við.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Fletta að fyrstu',
	            pageBack: 'Fletta til baka',
	            pageSelected: 'Valin síða',
	            pageForward: 'Fletta áfram',
	            pageToLast: 'Fletta að síðustu'
	          },
	          sizes: 'hlutir á síðu',
	          totalItems: 'hlutir',
	          through: 'gegnum',
	          of: 'af'
	        },
	        grouping: {
	          group: 'Flokka',
	          ungroup: 'Sundurliða',
	          aggregate_count: 'Fjöldi: ',
	          aggregate_sum: 'Summa: ',
	          aggregate_max: 'Hámark: ',
	          aggregate_min: 'Lágmark: ',
	          aggregate_avg: 'Meðaltal: ',
	          aggregate_remove: 'Fjarlægja: '
	        },
	        validate: {
	          error: 'Villa:',
	          minLength: 'Gildi ætti að vera a.m.k. THRESHOLD stafa langt.',
	          maxLength: 'Gildi ætti að vera í mesta lagi THRESHOLD stafa langt.',
	          required: 'Þarf að hafa gildi.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('it', {
	        aggregate: {
	          label: 'elementi'
	        },
	        groupPanel: {
	          description: 'Trascina un\'intestazione all\'interno del gruppo della colonna.'
	        },
	        search: {
	          placeholder: 'Ricerca...',
	          showingItems: 'Mostra:',
	          selectedItems: 'Selezionati:',
	          totalItems: 'Totali:',
	          size: 'Tot Pagine:',
	          first: 'Prima',
	          next: 'Prossima',
	          previous: 'Precedente',
	          last: 'Ultima'
	        },
	        menu: {
	          text: 'Scegli le colonne:'
	        },
	        sort: {
	          ascending: 'Asc.',
	          descending: 'Desc.',
	          remove: 'Annulla ordinamento'
	        },
	        column: {
	          hide: 'Nascondi'
	        },
	        aggregation: {
	          count: 'righe totali: ',
	          sum: 'tot: ',
	          avg: 'media: ',
	          min: 'minimo: ',
	          max: 'massimo: '
	        },
	        pinning: {
	         pinLeft: 'Blocca a sx',
	          pinRight: 'Blocca a dx',
	          unpin: 'Blocca in alto'
	        },
	        gridMenu: {
	          columns: 'Colonne:',
	          importerTitle: 'Importa',
	          exporterAllAsCsv: 'Esporta tutti i dati in CSV',
	          exporterVisibleAsCsv: 'Esporta i dati visibili in CSV',
	          exporterSelectedAsCsv: 'Esporta i dati selezionati in CSV',
	          exporterAllAsPdf: 'Esporta tutti i dati in PDF',
	          exporterVisibleAsPdf: 'Esporta i dati visibili in PDF',
	          exporterSelectedAsPdf: 'Esporta i dati selezionati in PDF',
	          exporterAllAsExcel: 'Esporta tutti i dati in excel',
	          exporterVisibleAsExcel: 'Esporta i dati visibili in excel',
	          exporterSelectedAsExcel: 'Esporta i dati selezionati in excel',
	          clearAllFilters: 'Pulire tutti i filtri'
	        },
	        importer: {
	          noHeaders: 'Impossibile reperire i nomi delle colonne, sicuro che siano indicati all\'interno del file?',
	          noObjects: 'Impossibile reperire gli oggetti, sicuro che siano indicati all\'interno del file?',
	          invalidCsv: 'Impossibile elaborare il file, sicuro che sia un CSV?',
	          invalidJson: 'Impossibile elaborare il file, sicuro che sia un JSON valido?',
	          jsonNotArray: 'Errore! Il file JSON da importare deve contenere un array.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Prima',
	            pageBack: 'Indietro',
	            pageSelected: 'Pagina selezionata',
	            pageForward: 'Avanti',
	            pageToLast: 'Ultima'
	          },
	          sizes: 'elementi per pagina',
	          totalItems: 'elementi',
	          through: 'a',
	          of: 'di'
	        },
	        grouping: {
	          group: 'Raggruppa',
	          ungroup: 'Separa',
	          aggregate_count: 'Agg: N. Elem.',
	          aggregate_sum: 'Agg: Somma',
	          aggregate_max: 'Agg: Massimo',
	          aggregate_min: 'Agg: Minimo',
	          aggregate_avg: 'Agg: Media',
	          aggregate_remove: 'Agg: Rimuovi'
	        },
	        validate: {
	          error: 'Errore:',
	          minLength: 'Lunghezza minima pari a THRESHOLD caratteri.',
	          maxLength: 'Lunghezza massima pari a THRESHOLD caratteri.',
	          required: 'Necessario inserire un valore.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ja', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: '列のフィルター',
	            removeFilter: 'フィルターの解除',
	            columnMenuButtonLabel: '列のメニュー'
	          },
	          priority: '優先度:',
	          filterLabel: "列フィルター: "
	        },
	        aggregate: {
	          label: '項目'
	        },
	        groupPanel: {
	          description: 'ここに列ヘッダをドラッグアンドドロップして、その列でグループ化します。'
	        },
	        search: {
	          placeholder: '検索...',
	          showingItems: '表示中の項目:',
	          selectedItems: '選択した項目:',
	          totalItems: '項目の総数:',
	          size: 'ページサイズ:',
	          first: '最初のページ',
	          next: '次のページ',
	          previous: '前のページ',
	          last: '前のページ'
	        },
	        menu: {
	          text: '列の選択:'
	        },
	        sort: {
	          ascending: '昇順に並べ替え',
	          descending: '降順に並べ替え',
	          none: '並べ替え無し',
	          remove: '並べ替えの解除'
	        },
	        column: {
	          hide: '列の非表示'
	        },
	        aggregation: {
	          count: '行数: ',
	          sum: '合計: ',
	          avg: '平均: ',
	          min: '最小: ',
	          max: '最大: '
	        },
	        pinning: {
	          pinLeft: '左に固定',
	          pinRight: '右に固定',
	          unpin: '固定解除'
	        },
	        columnMenu: {
	          close: '閉じる'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'グリッドメニュー'
	          },
	          columns: '列の表示/非表示:',
	          importerTitle: 'ファイルのインポート',
	          exporterAllAsCsv: 'すべてのデータをCSV形式でエクスポート',
	          exporterVisibleAsCsv: '表示中のデータをCSV形式でエクスポート',
	          exporterSelectedAsCsv: '選択したデータをCSV形式でエクスポート',
	          exporterAllAsPdf: 'すべてのデータをPDF形式でエクスポート',
	          exporterVisibleAsPdf: '表示中のデータをPDF形式でエクスポート',
	          exporterSelectedAsPdf: '選択したデータをPDF形式でエクスポート',
	          clearAllFilters: 'すべてのフィルタをクリア'
	        },
	        importer: {
	          noHeaders: '列名を取得できません。ファイルにヘッダが含まれていることを確認してください。',
	          noObjects: 'オブジェクトを取得できません。ファイルにヘッダ以外のデータが含まれていることを確認してください。',
	          invalidCsv: 'ファイルを処理できません。ファイルが有効なCSV形式であることを確認してください。',
	          invalidJson: 'ファイルを処理できません。ファイルが有効なJSON形式であることを確認してください。',
	          jsonNotArray: 'インポートしたJSONファイルには配列が含まれている必要があります。処理を中止します。'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: '最初のページ',
	            pageBack: '前のページ',
	            pageSelected: '現在のページ',
	            pageForward: '次のページ',
	            pageToLast: '最後のページ'
	          },
	          sizes: '件/ページ',
	          totalItems: '件',
	          through: 'から',
	          of: '件/全'
	        },
	        grouping: {
	          group: 'グループ化',
	          ungroup: 'グループ化の解除',
	          aggregate_count: '集計表示: 行数',
	          aggregate_sum: '集計表示: 合計',
	          aggregate_max: '集計表示: 最大',
	          aggregate_min: '集計表示: 最小',
	          aggregate_avg: '集計表示: 平均',
	          aggregate_remove: '集計表示: 解除'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'THRESHOLD 文字以上で入力してください。',
	          maxLength: 'THRESHOLD 文字以下で入力してください。',
	          required: '値が必要です。'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ko', {
	        aggregate: {
	          label: '아이템'
	        },
	        groupPanel: {
	          description: '컬럼으로 그룹핑하기 위해서는 컬럼 헤더를 끌어 떨어뜨려 주세요.'
	        },
	        search: {
	          placeholder: '검색...',
	          showingItems: '항목 보여주기:',
	          selectedItems: '선택 항목:',
	          totalItems: '전체 항목:',
	          size: '페이지 크기:',
	          first: '첫번째 페이지',
	          next: '다음 페이지',
	          previous: '이전 페이지',
	          last: '마지막 페이지'
	        },
	        menu: {
	          text: '컬럼을 선택하세요:'
	        },
	        sort: {
	          ascending: '오름차순 정렬',
	          descending: '내림차순 정렬',
	          remove: '소팅 제거'
	        },
	        column: {
	          hide: '컬럼 제거'
	        },
	        aggregation: {
	          count: '전체 갯수: ',
	          sum: '전체: ',
	          avg: '평균: ',
	          min: '최소: ',
	          max: '최대: '
	        },
	        pinning: {
	         pinLeft: '왼쪽 핀',
	          pinRight: '오른쪽 핀',
	          unpin: '핀 제거'
	        },
	        gridMenu: {
	          columns: '컬럼:',
	          importerTitle: '파일 가져오기',
	          exporterAllAsCsv: 'csv로 모든 데이터 내보내기',
	          exporterVisibleAsCsv: 'csv로 보이는 데이터 내보내기',
	          exporterSelectedAsCsv: 'csv로 선택된 데이터 내보내기',
	          exporterAllAsPdf: 'pdf로 모든 데이터 내보내기',
	          exporterVisibleAsPdf: 'pdf로 보이는 데이터 내보내기',
	          exporterSelectedAsPdf: 'pdf로 선택 데이터 내보내기',
	          clearAllFilters: '모든 필터를 청소'
	        },
	        importer: {
	          noHeaders: '컬럼명이 지정되어 있지 않습니다. 파일에 헤더가 명시되어 있는지 확인해 주세요.',
	          noObjects: '데이터가 지정되어 있지 않습니다. 데이터가 파일에 있는지 확인해 주세요.',
	          invalidCsv: '파일을 처리할 수 없습니다. 올바른 csv인지 확인해 주세요.',
	          invalidJson: '파일을 처리할 수 없습니다. 올바른 json인지 확인해 주세요.',
	          jsonNotArray: 'json 파일은 배열을 포함해야 합니다.'
	        },
	        pagination: {
	          sizes: '페이지당 항목',
	          totalItems: '전체 항목'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('nl', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Sleep hier een kolomnaam heen om op te groeperen.'
	        },
	        search: {
	          placeholder: 'Zoeken...',
	          showingItems: 'Getoonde items:',
	          selectedItems: 'Geselecteerde items:',
	          totalItems: 'Totaal aantal items:',
	          size: 'Items per pagina:',
	          first: 'Eerste pagina',
	          next: 'Volgende pagina',
	          previous: 'Vorige pagina',
	          last: 'Laatste pagina'
	        },
	        menu: {
	          text: 'Kies kolommen:'
	        },
	        sort: {
	          ascending: 'Sorteer oplopend',
	          descending: 'Sorteer aflopend',
	          remove: 'Verwijder sortering'
	        },
	        column: {
	          hide: 'Verberg kolom'
	        },
	        aggregation: {
	          count: 'Aantal rijen: ',
	          sum: 'Som: ',
	          avg: 'Gemiddelde: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Zet links vast',
	          pinRight: 'Zet rechts vast',
	          unpin: 'Maak los'
	        },
	        gridMenu: {
	          columns: 'Kolommen:',
	          importerTitle: 'Importeer bestand',
	          exporterAllAsCsv: 'Exporteer alle data als csv',
	          exporterVisibleAsCsv: 'Exporteer zichtbare data als csv',
	          exporterSelectedAsCsv: 'Exporteer geselecteerde data als csv',
	          exporterAllAsPdf: 'Exporteer alle data als pdf',
	          exporterVisibleAsPdf: 'Exporteer zichtbare data als pdf',
	          exporterSelectedAsPdf: 'Exporteer geselecteerde data als pdf',
	          exporterAllAsExcel: 'Exporteer alle data als excel',
	          exporterVisibleAsExcel: 'Exporteer zichtbare data als excel',
	          exporterSelectedAsExcel: 'Exporteer alle data als excel',
	          clearAllFilters: 'Alle filters wissen'
	        },
	        importer: {
	          noHeaders: 'Kolomnamen kunnen niet worden afgeleid. Heeft het bestand een header?',
	          noObjects: 'Objecten kunnen niet worden afgeleid. Bevat het bestand data naast de headers?',
	          invalidCsv: 'Het bestand kan niet verwerkt worden. Is het een valide csv bestand?',
	          invalidJson: 'Het bestand kan niet verwerkt worden. Is het valide json?',
	          jsonNotArray: 'Het json bestand moet een array bevatten. De actie wordt geannuleerd.'
	        },
	        pagination: {
	            sizes: 'items per pagina',
	            totalItems: 'items',
	            of: 'van de'
	        },
	        grouping: {
	            group: 'Groepeer',
	            ungroup: 'Groepering opheffen',
	            aggregate_count: 'Agg: Aantal',
	            aggregate_sum: 'Agg: Som',
	            aggregate_max: 'Agg: Max',
	            aggregate_min: 'Agg: Min',
	            aggregate_avg: 'Agg: Gem',
	            aggregate_remove: 'Agg: Verwijder'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('no', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter for kolonne',
	            removeFilter: 'Fjern filter',
	            columnMenuButtonLabel: 'Kolonnemeny'
	          },
	          priority: 'Prioritet:',
	          filterLabel: "Filter for kolonne: "
	        },
	        aggregate: {
	          label: 'elementer'
	        },
	        groupPanel: {
	          description: 'Trekk en kolonneoverskrift hit og slipp den for å gruppere etter den kolonnen.'
	        },
	        search: {
	          placeholder: 'Søk...',
	          showingItems: 'Viste elementer:',
	          selectedItems: 'Valgte elementer:',
	          totalItems: 'Antall elementer:',
	          size: 'Sidestørrelse:',
	          first: 'Første side',
	          next: 'Neste side',
	          previous: 'Forrige side',
	          last: 'Siste side'
	        },
	        menu: {
	          text: 'Velg kolonner:'
	        },
	        sort: {
	          ascending: 'Sortere stigende',
	          descending: 'Sortere fallende',
	          none: 'Ingen sortering',
	          remove: 'Fjern sortering'
	        },
	        column: {
	          hide: 'Skjul kolonne'
	        },
	        aggregation: {
	          count: 'antall rader: ',
	          sum: 'total: ',
	          avg: 'gjennomsnitt: ',
	          min: 'minimum: ',
	          max: 'maksimum: '
	        },
	        pinning: {
	          pinLeft: 'Fest til venstre',
	          pinRight: 'Fest til høyre',
	          unpin: 'Løsne'
	        },
	        columnMenu: {
	          close: 'Lukk'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Kolonner:',
	          importerTitle: 'Importer fil',
	          exporterAllAsCsv: 'Eksporter alle data som csv',
	          exporterVisibleAsCsv: 'Eksporter synlige data som csv',
	          exporterSelectedAsCsv: 'Eksporter utvalgte data som csv',
	          exporterAllAsPdf: 'Eksporter alle data som pdf',
	          exporterVisibleAsPdf: 'Eksporter synlige data som pdf',
	          exporterSelectedAsPdf: 'Eksporter utvalgte data som pdf',
	          exporterAllAsExcel: 'Eksporter alle data som excel',
	          exporterVisibleAsExcel: 'Eksporter synlige data som excel',
	          exporterSelectedAsExcel: 'Eksporter utvalgte data som excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Kolonnenavn kunne ikke avledes. Har filen en overskrift?',
	          noObjects: 'Objekter kunne ikke avledes. Er der andre data i filen enn overskriften?',
	          invalidCsv: 'Filen kunne ikke behandles. Er den gyldig CSV?',
	          invalidJson: 'Filen kunne ikke behandles. Er den gyldig JSON?',
	          jsonNotArray: 'Importert JSON-fil må inneholde en liste. Avbryter.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Gå til første side',
	            pageBack: 'Gå til forrige side',
	            pageSelected: 'Valgte side',
	            pageForward: 'Gå til neste side',
	            pageToLast: 'Gå til siste side'
	          },
	          sizes: 'elementer per side',
	          totalItems: 'elementer',
	          through: 'til',
	          of: 'av'
	        },
	        grouping: {
	          group: 'Gruppere',
	          ungroup: 'Fjerne gruppering',
	          aggregate_count: 'Agr: Antall',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Maksimum',
	          aggregate_min: 'Agr: Minimum',
	          aggregate_avg: 'Agr: Gjennomsnitt',
	          aggregate_remove: 'Agr: Fjern'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pl', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtr dla kolumny',
	            removeFilter: 'Usuń filtr',
	            columnMenuButtonLabel: 'Opcje kolumny',
	            column: 'Kolumna'
	          },
	          priority: 'Priorytet:',
	          filterLabel: "Filtr dla kolumny: "
	        },
	        aggregate: {
	          label: 'pozycji'
	        },
	        groupPanel: {
	          description: 'Przeciągnij nagłówek kolumny tutaj, aby pogrupować według niej.'
	        },
	        search: {
	          aria: {
	            selected: 'Wiersz zaznaczony',
	            notSelected: 'Wiersz niezaznaczony'
	          },
	          placeholder: 'Szukaj...',
	          showingItems: 'Widoczne pozycje:',
	          selectedItems: 'Zaznaczone pozycje:',
	          totalItems: 'Wszystkich pozycji:',
	          size: 'Rozmiar strony:',
	          first: 'Pierwsza strona',
	          next: 'Następna strona',
	          previous: 'Poprzednia strona',
	          last: 'Ostatnia strona'
	        },
	        menu: {
	          text: 'Wybierz kolumny:'
	        },
	        sort: {
	          ascending: 'Sortuj rosnąco',
	          descending: 'Sortuj malejąco',
	          none: 'Brak sortowania',
	          remove: 'Wyłącz sortowanie'
	        },
	        column: {
	          hide: 'Ukryj kolumnę'
	        },
	        aggregation: {
	          count: 'Razem pozycji: ',
	            sum: 'Razem: ',
	            avg: 'Średnia: ',
	            min: 'Min: ',
	            max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Przypnij do lewej',
	          pinRight: 'Przypnij do prawej',
	          unpin: 'Odepnij'
	        },
	        columnMenu: {
	          close: 'Zamknij'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Opcje tabeli'
	          },
	          columns: 'Kolumny:',
	          importerTitle: 'Importuj plik',
	          exporterAllAsCsv: 'Eksportuj wszystkie dane do csv',
	          exporterVisibleAsCsv: 'Eksportuj widoczne dane do csv',
	          exporterSelectedAsCsv: 'Eksportuj zaznaczone dane do csv',
	          exporterAllAsPdf: 'Eksportuj wszystkie dane do pdf',
	          exporterVisibleAsPdf: 'Eksportuj widoczne dane do pdf',
	          exporterSelectedAsPdf: 'Eksportuj zaznaczone dane do pdf',
	          exporterAllAsExcel: 'Eksportuj wszystkie dane do excel',
	          exporterVisibleAsExcel: 'Eksportuj widoczne dane do excel',
	          exporterSelectedAsExcel: 'Eksportuj zaznaczone dane do excel',
	          clearAllFilters: 'Wyczyść filtry'
	        },
	        importer: {
	          noHeaders: 'Nie udało się wczytać nazw kolumn. Czy plik posiada nagłówek?',
	          noObjects: 'Nie udalo się wczytać pozycji. Czy plik zawiera dane?',
	          invalidCsv: 'Nie udało się przetworzyć pliku. Czy to prawidłowy plik CSV?',
	          invalidJson: 'Nie udało się przetworzyć pliku. Czy to prawidłowy plik JSON?',
	          jsonNotArray: 'Importowany plik JSON musi zawierać tablicę. Importowanie przerwane.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Pierwsza strona',
	            pageBack: 'Poprzednia strona',
	            pageSelected: 'Wybrana strona',
	            pageForward: 'Następna strona',
	            pageToLast: 'Ostatnia strona'
	          },
	          sizes: 'pozycji na stronę',
	          totalItems: 'pozycji',
	          through: 'do',
	          of: 'z'
	        },
	        grouping: {
	          group: 'Grupuj',
	          ungroup: 'Rozgrupuj',
	          aggregate_count: 'Zbiorczo: Razem',
	          aggregate_sum: 'Zbiorczo: Suma',
	          aggregate_max: 'Zbiorczo: Max',
	          aggregate_min: 'Zbiorczo: Min',
	          aggregate_avg: 'Zbiorczo: Średnia',
	          aggregate_remove: 'Zbiorczo: Usuń'
	        },
	        validate: {
	          error: 'Błąd:',
	          minLength: 'Wartość powinna składać się z co najmniej THRESHOLD znaków.',
	          maxLength: 'Wartość powinna składać się z przynajmniej THRESHOLD znaków.',
	          required: 'Wartość jest wymagana.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt-br', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtro por coluna',
	            removeFilter: 'Remover filtro',
	            columnMenuButtonLabel: 'Menu coluna',
	            column: 'Coluna'
	          },
	          priority: 'Prioridade:',
	          filterLabel: "Filtro por coluna: "
	        },
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          aria: {
	            selected: 'Linha selecionada',
	            notSelected: 'Linha não está selecionada'
	          },
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Items Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          none: 'Nenhuma Ordem',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        columnMenu: {
	          close: 'Fechar'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu Grid'
	          },
	          columns: 'Colunas:',
	          importerTitle: 'Importar arquivo',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          exporterAllAsExcel: 'Exportar todos os dados como excel',
	          exporterVisibleAsExcel: 'Exportar dados visíveis como excel',
	          exporterSelectedAsExcel: 'Exportar dados selecionados como excel',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O arquivo tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no arquivo, além dos cabeçalhos?',
	          invalidCsv: 'Arquivo não pode ser processado. É um CSV válido?',
	          invalidJson: 'Arquivo não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Arquivo json importado tem que conter um array. Abortando.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Primeira página',
	            pageBack: 'Página anterior',
	            pageSelected: 'Página Selecionada',
	            pageForward: 'Proxima',
	            pageToLast: 'Anterior'
	          },
	          sizes: 'itens por página',
	          totalItems: 'itens',
	          through: 'através dos',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        },
	        validate: {
	          error: 'Erro:',
	          minLength: 'O valor deve ter, no minimo, THRESHOLD caracteres.',
	          maxLength: 'O valor deve ter, no máximo, THRESHOLD caracteres.',
	          required: 'Um valor é necessário.'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtro por coluna',
	            removeFilter: 'Remover filtro',
	            columnMenuButtonLabel: 'Menu coluna',
	            column: 'Coluna'
	          },
	          priority: 'Prioridade:',
	          filterLabel: "Filtro por coluna: "
	        },
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          aria: {
	            selected: 'Linha selecionada',
	            notSelected: 'Linha não está selecionada'
	          },
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Itens Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          none: 'Nenhuma Ordem',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        columnMenu: {
	          close: 'Fechar'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu Grid'
	          },
	          columns: 'Colunas:',
	          importerTitle: 'Importar ficheiro',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          exporterAllAsExcel: 'Exportar todos os dados como excel',
	          exporterVisibleAsExcel: 'Exportar dados visíveis como excel',
	          exporterSelectedAsExcel: 'Exportar dados selecionados como excel',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O ficheiro tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no ficheiro, além dos cabeçalhos?',
	          invalidCsv: 'Ficheiro não pode ser processado. É um CSV válido?',
	          invalidJson: 'Ficheiro não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Ficheiro json importado tem que conter um array. Interrompendo.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Primeira página',
	            pageBack: 'Página anterior',
	            pageSelected: 'Página Selecionada',
	            pageForward: 'Próxima',
	            pageToLast: 'Anterior'
	          },
	          sizes: 'itens por página',
	          totalItems: 'itens',
	          through: 'a',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        },
	        validate: {
	          error: 'Erro:',
	          minLength: 'O valor deve ter, no minimo, THRESHOLD caracteres.',
	          maxLength: 'O valor deve ter, no máximo, THRESHOLD caracteres.',
	          required: 'Um valor é necessário.'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ro', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtru pentru coloana',
	            removeFilter: 'Sterge filtru',
	            columnMenuButtonLabel: 'Column Menu'
	          },
	          priority: 'Prioritate:',
	          filterLabel: "Filtru pentru coloana:"
	        },
	        aggregate: {
	          label: 'Elemente'
	        },
	        groupPanel: {
	          description: 'Trage un cap de coloana aici pentru a grupa elementele dupa coloana respectiva'
	        },
	        search: {
	          placeholder: 'Cauta...',
	          showingItems: 'Arata elementele:',
	          selectedItems: 'Elementele selectate:',
	          totalItems: 'Total elemente:',
	          size: 'Marime pagina:',
	          first: 'Prima pagina',
	          next: 'Pagina urmatoare',
	          previous: 'Pagina anterioara',
	          last: 'Ultima pagina'
	        },
	        menu: {
	          text: 'Alege coloane:'
	        },
	        sort: {
	          ascending: 'Ordoneaza crescator',
	          descending: 'Ordoneaza descrescator',
	          none: 'Fara ordonare',
	          remove: 'Sterge ordonarea'
	        },
	        column: {
	          hide: 'Ascunde coloana'
	        },
	        aggregation: {
	          count: 'total linii: ',
	          sum: 'total: ',
	          avg: 'medie: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Pin la stanga',
	          pinRight: 'Pin la dreapta',
	          unpin: 'Sterge pinul'
	        },
	        columnMenu: {
	          close: 'Inchide'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Coloane:',
	          importerTitle: 'Incarca fisier',
	          exporterAllAsCsv: 'Exporta toate datele ca csv',
	          exporterVisibleAsCsv: 'Exporta datele vizibile ca csv',
	          exporterSelectedAsCsv: 'Exporta datele selectate ca csv',
	          exporterAllAsPdf: 'Exporta toate datele ca pdf',
	          exporterVisibleAsPdf: 'Exporta datele vizibile ca pdf',
	          exporterSelectedAsPdf: 'Exporta datele selectate ca csv pdf',
	          clearAllFilters: 'Sterge toate filtrele'
	        },
	        importer: {
	          noHeaders: 'Numele coloanelor nu a putut fi incarcat, acest fisier are un header?',
	          noObjects: 'Datele nu au putut fi incarcate, exista date in fisier in afara numelor de coloane?',
	          invalidCsv: 'Fisierul nu a putut fi procesat, ati incarcat un CSV valid ?',
	          invalidJson: 'Fisierul nu a putut fi procesat, ati incarcat un Json valid?',
	          jsonNotArray: 'Json-ul incarcat trebuie sa contina un array, inchidere.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Prima pagina',
	            pageBack: 'O pagina inapoi',
	            pageSelected: 'Pagina selectata',
	            pageForward: 'O pagina inainte',
	            pageToLast: 'Ultima pagina'
	          },
	          sizes: 'Elemente per pagina',
	          totalItems: 'elemente',
	          through: 'prin',
	          of: 'of'
	        },
	        grouping: {
	          group: 'Grupeaza',
	          ungroup: 'Opreste gruparea',
	          aggregate_count: 'Agg: Count',
	          aggregate_sum: 'Agg: Sum',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Avg',
	          aggregate_remove: 'Agg: Remove'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('rs-lat', {
					headerCell: {
						aria: {
							defaultFilterLabel: 'Filter za kolonu',
							removeFilter: 'Ukloni Filter',
							columnMenuButtonLabel: 'Meni Kolone',
							column: 'Kolona'
						},
						priority: 'Prioritet:',
						filterLabel: "Filter za kolonu: "
					},
					aggregate: {
						label: 'stavke'
					},
					groupPanel: {
						description: 'Ovde prevuci zaglavlje kolone i spusti do grupe pored te kolone.'
					},
					search: {
						aria: {
							selected: 'Red odabran',
							notSelected: 'Red nije odabran'
						},
						placeholder: 'Pretraga...',
						showingItems: 'Prikazane Stavke:',
						selectedItems: 'Odabrane Stavke:',
						totalItems: 'Ukupno Stavki:',
						size: 'Veličina Stranice:',
						first: 'Prva Stranica',
						next: 'Sledeća Stranica',
						previous: 'Prethodna Stranica',
						last: 'Poslednja Stranica'
					},
					menu: {
						text: 'Odaberite kolonu:'
					},
					sort: {
						ascending: 'Sortiraj po rastućem redosledu',
						descending: 'Sortiraj po opadajućem redosledu',
						none: 'Bez Sortiranja',
						remove: 'Ukloni Sortiranje'
					},
					column: {
						hide: 'Sakrij Kolonu'
					},
					aggregation: {
						count: 'ukupno redova: ',
						sum: 'ukupno: ',
						avg: 'prosecno: ',
						min: 'minimum: ',
						max: 'maksimum: '
					},
					pinning: {
						pinLeft: 'Zakači Levo',
						pinRight: 'Zakači Desno',
						unpin: 'Otkači'
					},
					columnMenu: {
						close: 'Zatvori'
					},
					gridMenu: {
						aria: {
							buttonLabel: 'Rešetkasti Meni'
						},
						columns: 'Kolone:',
						importerTitle: 'Importuj fajl',
						exporterAllAsCsv: 'Eksportuj sve podatke kao csv',
						exporterVisibleAsCsv: 'Eksportuj vidljive podatke kao csv',
						exporterSelectedAsCsv: 'Eksportuj obeležene podatke kao csv',
						exporterAllAsPdf: 'Eksportuj sve podatke kao pdf',
						exporterVisibleAsPdf: 'Eksportuj vidljive podake kao pdf',
						exporterSelectedAsPdf: 'Eksportuj odabrane podatke kao pdf',
						exporterAllAsExcel: 'Eksportuj sve podatke kao excel',
						exporterVisibleAsExcel: 'Eksportuj vidljive podatke kao excel',
						exporterSelectedAsExcel: 'Eksportuj odabrane podatke kao excel',
						clearAllFilters: 'Obriši sve filtere'
					},
					importer: {
						noHeaders: 'Kolone se nisu mogle podeliti, da li fajl poseduje heder?',
						noObjects: 'Objecti nisu mogli biti podeljeni, da li je bilo i drugih podataka sem hedera?',
						invalidCsv: 'Fajl nije bilo moguće procesirati, da li je ispravni CSV?',
						invalidJson: 'Fajl nije bilo moguće procesirati, da li je ispravni JSON',
						jsonNotArray: 'Importovani json fajl mora da sadrži niz, prekidam operaciju.'
					},
					pagination: {
						aria: {
							pageToFirst: 'Prva stranica',
							pageBack: 'Stranica pre',
							pageSelected: 'Odabrana stranica',
							pageForward: 'Sledeća stranica',
							pageToLast: 'Poslednja stranica'
						},
						sizes: 'stavki po stranici',
						totalItems: 'stavke',
						through: 'kroz',
						of: 'od'
					},
					grouping: {
						group: 'Grupiši',
						ungroup: 'Odrupiši',
						aggregate_count: 'Agg: Broj',
						aggregate_sum: 'Agg: Suma',
						aggregate_max: 'Agg: Maksimum',
						aggregate_min: 'Agg: Minimum',
						aggregate_avg: 'Agg: Prosečna',
						aggregate_remove: 'Agg: Ukloni'
					},
					validate: {
						error: 'Greška:',
						minLength: 'Vrednost bi trebala da bude duga bar THRESHOLD karaktera.',
						maxLength: 'Vrednost bi trebalo da bude najviše duga THRESHOLD karaktera.',
						required: 'Portreba je vrednost.'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ru', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Фильтр столбца',
	            removeFilter: 'Удалить фильтр',
	            columnMenuButtonLabel: 'Меню столбца'
	          },
	          priority: 'Приоритет:',
	          filterLabel: "Фильтр столбца: "
	        },
	        aggregate: {
	          label: 'элементы'
	        },
	        groupPanel: {
	          description: 'Для группировки по столбцу перетащите сюда его название.'
	        },
	        search: {
	          placeholder: 'Поиск...',
	          showingItems: 'Показать элементы:',
	          selectedItems: 'Выбранные элементы:',
	          totalItems: 'Всего элементов:',
	          size: 'Размер страницы:',
	          first: 'Первая страница',
	          next: 'Следующая страница',
	          previous: 'Предыдущая страница',
	          last: 'Последняя страница'
	        },
	        menu: {
	          text: 'Выбрать столбцы:'
	        },
	        sort: {
	          ascending: 'По возрастанию',
	          descending: 'По убыванию',
	          none: 'Без сортировки',
	          remove: 'Убрать сортировку'
	        },
	        column: {
	          hide: 'Спрятать столбец'
	        },
	        aggregation: {
	          count: 'всего строк: ',
	          sum: 'итого: ',
	          avg: 'среднее: ',
	          min: 'мин: ',
	          max: 'макс: '
	        },
					pinning: {
						pinLeft: 'Закрепить слева',
						pinRight: 'Закрепить справа',
						unpin: 'Открепить'
					},
	        columnMenu: {
	          close: 'Закрыть'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню'
	          },
	          columns: 'Столбцы:',
	          importerTitle: 'Импортировать файл',
	          exporterAllAsCsv: 'Экспортировать всё в CSV',
	          exporterVisibleAsCsv: 'Экспортировать видимые данные в CSV',
	          exporterSelectedAsCsv: 'Экспортировать выбранные данные в CSV',
	          exporterAllAsPdf: 'Экспортировать всё в PDF',
	          exporterVisibleAsPdf: 'Экспортировать видимые данные в PDF',
	          exporterSelectedAsPdf: 'Экспортировать выбранные данные в PDF',
	          exporterAllAsExcel: 'Экспортировать всё в Excel',
	          exporterVisibleAsExcel: 'Экспортировать видимые данные в Excel',
	          exporterSelectedAsExcel: 'Экспортировать выбранные данные в Excel',
	          clearAllFilters: 'Очистить все фильтры'
	        },
	        importer: {
	          noHeaders: 'Не удалось получить названия столбцов, есть ли в файле заголовок?',
	          noObjects: 'Не удалось получить данные, есть ли в файле строки кроме заголовка?',
	          invalidCsv: 'Не удалось обработать файл, это правильный CSV-файл?',
	          invalidJson: 'Не удалось обработать файл, это правильный JSON?',
	          jsonNotArray: 'Импортируемый JSON-файл должен содержать массив, операция отменена.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Первая страница',
	            pageBack: 'Предыдущая страница',
	            pageSelected: 'Выбранная страница',
	            pageForward: 'Следующая страница',
	            pageToLast: 'Последняя страница'
	          },
	          sizes: 'строк на страницу',
	          totalItems: 'строк',
	          through: 'по',
	          of: 'из'
	        },
	        grouping: {
	          group: 'Группировать',
	          ungroup: 'Разгруппировать',
	          aggregate_count: 'Группировать: Count',
	          aggregate_sum: 'Для группы: Сумма',
	          aggregate_max: 'Для группы: Максимум',
	          aggregate_min: 'Для группы: Минимум',
	          aggregate_avg: 'Для группы: Среднее',
	          aggregate_remove: 'Для группы: Пусто'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('sk', {
					headerCell: {
						aria: {
							defaultFilterLabel: 'Filter pre stĺpec',
							removeFilter: 'Odstrániť filter',
							columnMenuButtonLabel: 'Menu pre stĺpec',
							column: 'Stĺpec'
						},
						priority: 'Priorita:',
						filterLabel: "Filter pre stĺpec: "
					},
					aggregate: {
						label: 'položky'
					},
					groupPanel: {
						description: 'Pretiahni sem názov stĺpca pre zoskupenie podľa toho stĺpca.'
					},
					search: {
						aria: {
							selected: 'Označený riadok',
							notSelected: 'Neoznačený riadok'
						},
						placeholder: 'Hľadaj...',
						showingItems: 'Zobrazujem položky:',
						selectedItems: 'Vybraté položky:',
						totalItems: 'Počet položiek:',
						size: 'Počet:',
						first: 'Prvá strana',
						next: 'Ďalšia strana',
						previous: 'Predchádzajúca strana',
						last: 'Posledná strana'
					},
					menu: {
						text: 'Vyberte stĺpce:'
					},
					sort: {
						ascending: 'Zotriediť vzostupne',
						descending: 'Zotriediť zostupne',
						none: 'Nezotriediť',
						remove: 'Vymazať triedenie'
					},
					column: {
						hide: 'Skryť stĺpec'
					},
					aggregation: {
						count: 'počet riadkov: ',
						sum: 'spolu: ',
						avg: 'avg: ',
						min: 'min: ',
						max: 'max: '
					},
					pinning: {
						pinLeft: 'Pripnúť vľavo',
						pinRight: 'Pripnúť vpravo',
						unpin: 'Odopnúť'
					},
					columnMenu: {
						close: 'Zavrieť'
					},
					gridMenu: {
						aria: {
							buttonLabel: 'Grid Menu'
						},
						columns: 'Stĺpce:',
						importerTitle: 'Importovať súbor',
						exporterAllAsCsv: 'Exportovať všetky údaje ako CSV',
						exporterVisibleAsCsv: 'Exportovť viditeľné údaje ako CSV',
						exporterSelectedAsCsv: 'Exportovať označené údaje ako CSV',
						exporterAllAsPdf: 'Exportovať všetky údaje ako pdf',
						exporterVisibleAsPdf: 'Exportovať viditeľné údaje ako pdf',
						exporterSelectedAsPdf: 'Exportovať označené údaje ako pdf',
						exporterAllAsExcel: 'Exportovať všetky údaje ako excel',
						exporterVisibleAsExcel: 'Exportovať viditeľné údaje ako excel',
						exporterSelectedAsExcel: 'Exportovať označené údaje ako excel',
						clearAllFilters: 'Zrušiť všetky filtre'
					},
					importer: {
						noHeaders: 'Názvy stĺpcov sa nedali odvodiť, má súbor hlavičku?',
						noObjects: 'Objekty nebolo možné odvodiť, existovali iné údaje v súbore ako hlavičky?',
						invalidCsv: 'Súbor sa nepodarilo spracovať, je to platný súbor CSV?',
						invalidJson: 'Súbor nebolo možné spracovať, je to platný súbor typu Json?',
						jsonNotArray: 'Importovaný súbor json musí obsahovať pole, ukončujem.'
					},
					pagination: {
						aria: {
							pageToFirst: 'Strana na začiatok',
							pageBack: 'Strana dozadu',
							pageSelected: 'Označená strana',
							pageForward: 'Strana dopredu',
							pageToLast: 'Strana na koniec'
						},
						sizes: 'položky na stranu',
						totalItems: 'položky spolu',
						through: 'do konca',
						of: 'z'
					},
					grouping: {
						group: 'Zoskupiť',
						ungroup: 'Zrušiť zoskupenie',
						aggregate_count: 'Agg: Počet',
	
						aggregate_sum: 'Agg: Suma',
						aggregate_max: 'Agg: Max',
						aggregate_min: 'Agg: Min',
						aggregate_avg: 'Agg: Avg',
						aggregate_remove: 'Agg: Zrušiť'
					},
					validate: {
						error: 'Chyba:',
						minLength: 'Hodnota by mala mať aspoň THRESHOLD znakov dlhá.',
						maxLength: 'Hodnota by mala byť maximálne THRESHOLD znakov dlhá.',
						required: 'Vyžaduje sa hodnota.'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('sv', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Kolumnfilter',
	            removeFilter: 'Ta bort filter',
	            columnMenuButtonLabel: 'Kolumnmeny',
	            column: 'Kolumn'
	          },
	          priority: 'Prioritet:',
	          filterLabel: "Filter för kolumn: "
	        },
	        aggregate: {
	          label: 'Poster'
	        },
	        groupPanel: {
	          description: 'Dra en kolumnrubrik hit och släpp den för att gruppera efter den kolumnen.'
	        },
	        search: {
	          aria: {
	            selected: 'Rad är vald',
	            notSelected: 'Rad är inte vald'
	          },
	          placeholder: 'Sök...',
	          showingItems: 'Visar:',
	          selectedItems: 'Valda:',
	          totalItems: 'Antal:',
	          size: 'Sidstorlek:',
	          first: 'Första sidan',
	          next: 'Nästa sida',
	          previous: 'Föregående sida',
	          last: 'Sista sidan'
	        },
	        menu: {
	          text: 'Välj kolumner:'
	        },
	        sort: {
	          ascending: 'Sortera stigande',
	          descending: 'Sortera fallande',
	          none: 'Ingen sortering',
	          remove: 'Inaktivera sortering'
	        },
	        column: {
	          hide: 'Göm kolumn'
	        },
	        aggregation: {
	          count: 'Antal rader: ',
	          sum: 'Summa: ',
	          avg: 'Genomsnitt: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Fäst vänster',
	          pinRight: 'Fäst höger',
	          unpin: 'Lösgör'
	        },
	        columnMenu: {
	          close: 'Stäng'
	        },
	        gridMenu: {
	          aria: {
	              buttonLabel: 'Meny'
	          },
	          columns: 'Kolumner:',
	          importerTitle: 'Importera fil',
	          exporterAllAsCsv: 'Exportera all data som CSV',
	          exporterVisibleAsCsv: 'Exportera synlig data som CSV',
	          exporterSelectedAsCsv: 'Exportera markerad data som CSV',
	          exporterAllAsPdf: 'Exportera all data som PDF',
	          exporterVisibleAsPdf: 'Exportera synlig data som PDF',
	          exporterSelectedAsPdf: 'Exportera markerad data som PDF',
	          exporterAllAsExcel: 'Exportera all data till Excel',
	          exporterVisibleAsExcel: 'Exportera synlig data till Excel',
	          exporterSelectedAsExcel: 'Exportera markerad data till Excel',
	          clearAllFilters: 'Nollställ alla filter'
	        },
	        importer: {
	          noHeaders: 'Kolumnnamn kunde inte härledas. Har filen ett sidhuvud?',
	          noObjects: 'Objekt kunde inte härledas. Har filen data undantaget sidhuvud?',
	          invalidCsv: 'Filen kunde inte behandlas, är den en giltig CSV?',
	          invalidJson: 'Filen kunde inte behandlas, är den en giltig JSON?',
	          jsonNotArray: 'Importerad JSON-fil måste innehålla ett fält. Import avbruten.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Gå till första sidan',
	            pageBack: 'Gå en sida bakåt',
	            pageSelected: 'Vald sida',
	            pageForward: 'Gå en sida framåt',
	            pageToLast: 'Gå till sista sidan'
	          },
	          sizes: 'Poster per sida',
	          totalItems: 'Poster',
	          through: 'genom',
	          of: 'av'
	        },
	        grouping: {
	          group: 'Gruppera',
	          ungroup: 'Dela upp',
	          aggregate_count: 'Agg: Antal',
	          aggregate_sum: 'Agg: Summa',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Genomsnitt',
	          aggregate_remove: 'Agg: Ta bort'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'Värdet borde vara minst THRESHOLD tecken långt.',
	          maxLength: 'Värdet borde vara max THRESHOLD tecken långt.',
	          required: 'Ett värde krävs.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ta', {
	        aggregate: {
	          label: 'உருப்படிகள்'
	        },
	        groupPanel: {
	          description: 'ஒரு பத்தியை குழுவாக அமைக்க அப்பத்தியின் தலைப்பை இங்கே  இழுத்து வரவும் '
	        },
	        search: {
	          placeholder: 'தேடல் ...',
	          showingItems: 'உருப்படிகளை காண்பித்தல்:',
	          selectedItems: 'தேர்ந்தெடுக்கப்பட்ட  உருப்படிகள்:',
	          totalItems: 'மொத்த உருப்படிகள்:',
	          size: 'பக்க அளவு: ',
	          first: 'முதல் பக்கம்',
	          next: 'அடுத்த பக்கம்',
	          previous: 'முந்தைய பக்கம் ',
	          last: 'இறுதி பக்கம்'
	        },
	        menu: {
	          text: 'பத்திகளை தேர்ந்தெடு:'
	        },
	        sort: {
	          ascending: 'மேலிருந்து கீழாக',
	          descending: 'கீழிருந்து மேலாக',
	          remove: 'வரிசையை நீக்கு'
	        },
	        column: {
	          hide: 'பத்தியை மறைத்து வை '
	        },
	        aggregation: {
	          count: 'மொத்த வரிகள்:',
	          sum: 'மொத்தம்: ',
	          avg: 'சராசரி: ',
	          min: 'குறைந்தபட்ச: ',
	          max: 'அதிகபட்ச: '
	        },
	        pinning: {
	         pinLeft: 'இடதுபுறமாக தைக்க ',
	          pinRight: 'வலதுபுறமாக தைக்க',
	          unpin: 'பிரி'
	        },
	        gridMenu: {
	          columns: 'பத்திகள்:',
	          importerTitle: 'கோப்பு : படித்தல்',
	          exporterAllAsCsv: 'எல்லா தரவுகளையும் கோப்பாக்கு: csv',
	          exporterVisibleAsCsv: 'இருக்கும் தரவுகளை கோப்பாக்கு: csv',
	          exporterSelectedAsCsv: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: csv',
	          exporterAllAsPdf: 'எல்லா தரவுகளையும் கோப்பாக்கு: pdf',
	          exporterVisibleAsPdf: 'இருக்கும் தரவுகளை கோப்பாக்கு: pdf',
	          exporterSelectedAsPdf: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: pdf',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'பத்தியின் தலைப்புகளை பெற இயலவில்லை, கோப்பிற்கு தலைப்பு உள்ளதா?',
	          noObjects: 'இலக்குகளை உருவாக்க முடியவில்லை, கோப்பில் தலைப்புகளை தவிர தரவு ஏதேனும் உள்ளதா? ',
	          invalidCsv:	'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - csv',
	          invalidJson: 'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - json',
	          jsonNotArray: 'படித்த கோப்பில் வரிசைகள் உள்ளது, நடைமுறை ரத்து செய் : json'
	        },
	        pagination: {
	          sizes		: 'உருப்படிகள் / பக்கம்',
	          totalItems	: 'உருப்படிகள் '
	        },
	        grouping: {
	          group	: 'குழு',
	          ungroup : 'பிரி',
	          aggregate_count	: 'மதிப்பீட்டு : எண்ணு',
	          aggregate_sum : 'மதிப்பீட்டு : கூட்டல்',
	          aggregate_max	: 'மதிப்பீட்டு : அதிகபட்சம்',
	          aggregate_min	: 'மதிப்பீட்டு : குறைந்தபட்சம்',
	          aggregate_avg	: 'மதிப்பீட்டு : சராசரி',
	          aggregate_remove : 'மதிப்பீட்டு : நீக்கு'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
		angular.module('ui.grid').config(['$provide', function($provide) {
			$provide.decorator('i18nService', ['$delegate', function($delegate) {
				$delegate.add('tr', {
					headerCell: {
						aria: {
							defaultFilterLabel: 'Sütun için filtre',
							removeFilter: 'Filtreyi Kaldır',
							columnMenuButtonLabel: 'Sütun Menüsü'
						},
						priority: 'Öncelik:',
						filterLabel: "Sütun için filtre: "
					},
					aggregate: {
						label: 'kayıtlar'
					},
					groupPanel: {
						description: 'Sütuna göre gruplamak için sütun başlığını buraya sürükleyin ve bırakın.'
					},
					search: {
						placeholder: 'Arama...',
						showingItems: 'Gösterilen Kayıt:',
						selectedItems: 'Seçili Kayıt:',
						totalItems: 'Toplam Kayıt:',
						size: 'Sayfa Boyutu:',
						first: 'İlk Sayfa',
						next: 'Sonraki Sayfa',
						previous: 'Önceki Sayfa',
						last: 'Son Sayfa'
					},
					menu: {
						text: 'Sütunları Seç:'
					},
					sort: {
						ascending: 'Artan Sırada Sırala',
						descending: 'Azalan Sırada Sırala',
						none: 'Sıralama Yapma',
						remove: 'Sıralamayı Kaldır'
					},
					column: {
						hide: 'Sütunu Gizle'
					},
					aggregation: {
						count: 'toplam satır: ',
						sum: 'toplam: ',
						avg: 'ort: ',
						min: 'min: ',
						max: 'maks: '
					},
					pinning: {
						pinLeft: 'Sola Sabitle',
						pinRight: 'Sağa Sabitle',
						unpin: 'Sabitlemeyi Kaldır'
					},
					columnMenu: {
						close: 'Kapat'
					},
					gridMenu: {
						aria: {
							buttonLabel: 'Tablo Menü'
						},
						columns: 'Sütunlar:',
						importerTitle: 'Dosya içeri aktar',
						exporterAllAsCsv: 'Bütün veriyi CSV olarak dışarı aktar',
						exporterVisibleAsCsv: 'Görünen veriyi CSV olarak dışarı aktar',
						exporterSelectedAsCsv: 'Seçili veriyi CSV olarak dışarı aktar',
						exporterAllAsPdf: 'Bütün veriyi PDF olarak dışarı aktar',
						exporterVisibleAsPdf: 'Görünen veriyi PDF olarak dışarı aktar',
						exporterSelectedAsPdf: 'Seçili veriyi PDF olarak dışarı aktar',
						clearAllFilters: 'Bütün filtreleri kaldır'
					},
					importer: {
						noHeaders: 'Sütun isimleri üretilemiyor, dosyanın bir başlığı var mı?',
						noObjects: 'Nesneler üretilemiyor, dosyada başlıktan başka bir veri var mı?',
						invalidCsv: 'Dosya işlenemedi, geçerli bir CSV dosyası mı?',
						invalidJson: 'Dosya işlenemedi, geçerli bir Json dosyası mı?',
						jsonNotArray: 'Alınan Json dosyasında bir dizi bulunmalıdır, işlem iptal ediliyor.'
					},
					pagination: {
						aria: {
							pageToFirst: 'İlk sayfaya',
							pageBack: 'Geri git',
							pageSelected: 'Seçili sayfa',
							pageForward: 'İleri git',
							pageToLast: 'Sona git'
						},
						sizes: 'Sayfadaki nesne sayısı',
						totalItems: 'kayıtlar',
						through: '', // note(fsw) : turkish dont have this preposition
						of: '' // note(fsw) : turkish dont have this preposition
					},
					grouping: {
						group: 'Grupla',
						ungroup: 'Gruplama',
						aggregate_count: 'Yekun: Sayı',
						aggregate_sum: 'Yekun: Toplam',
						aggregate_max: 'Yekun: Maks',
						aggregate_min: 'Yekun: Min',
						aggregate_avg: 'Yekun: Ort',
						aggregate_remove: 'Yekun: Sil'
					}
				});
				return $delegate;
			}]);
		}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ua', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Фільтр стовпчика',
	            removeFilter: 'Видалити фільтр',
	            columnMenuButtonLabel: 'Меню ствпчика'
	          },
	          priority: 'Пріоритет:',
	          filterLabel: "Фільтр стовпчика: "
	        },
	        aggregate: {
	          label: 'елементи'
	        },
	        groupPanel: {
	          description: 'Для групування за стовпчиком перетягніть сюди його назву.'
	        },
	        search: {
	          placeholder: 'Пошук...',
	          showingItems: 'Показати елементи:',
	          selectedItems: 'Обрані елементи:',
	          totalItems: 'Усього елементів:',
	          size: 'Розмір сторінки:',
	          first: 'Перша сторінка',
	          next: 'Наступна сторінка',
	          previous: 'Попередня сторінка',
	          last: 'Остання сторінка'
	        },
	        menu: {
	          text: 'Обрати ствпчики:'
	        },
	        sort: {
	          ascending: 'За зростанням',
	          descending: 'За спаданням',
	          none: 'Без сортування',
	          remove: 'Прибрати сортування'
	        },
	        column: {
	          hide: 'Приховати стовпчик'
	        },
	        aggregation: {
	          count: 'усього рядків: ',
	          sum: 'ітого: ',
	          avg: 'середнє: ',
	          min: 'мін: ',
	          max: 'макс: '
	        },
					pinning: {
						pinLeft: 'Закріпити ліворуч',
						pinRight: 'Закріпити праворуч',
						unpin: 'Відкріпити'
					},
	        columnMenu: {
	          close: 'Закрити'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню'
	          },
	          columns: 'Стовпчики:',
	          importerTitle: 'Імпортувати файл',
	          exporterAllAsCsv: 'Експортувати все в CSV',
	          exporterVisibleAsCsv: 'Експортувати видимі дані в CSV',
	          exporterSelectedAsCsv: 'Експортувати обрані дані в CSV',
	          exporterAllAsPdf: 'Експортувати все в PDF',
	          exporterVisibleAsPdf: 'Експортувати видимі дані в PDF',
	          exporterSelectedAsPdf: 'Експортувати обрані дані в PDF',
	          clearAllFilters: 'Очистити всі фільтри'
	        },
	        importer: {
	          noHeaders: 'Не вдалося отримати назви стовпчиків, чи є в файлі заголовок?',
	          noObjects: 'Не вдалося отримати дані, чи є в файлі рядки окрім заголовка?',
	          invalidCsv: 'Не вдалося обробити файл, чи це коректний CSV-файл?',
	          invalidJson: 'Не вдалося обробити файл, чи це коректний JSON?',
	          jsonNotArray: 'JSON-файл що імпортується повинен містити масив, операцію скасовано.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Перша сторінка',
	            pageBack: 'Попередня сторінка',
	            pageSelected: 'Обрана сторінка',
	            pageForward: 'Наступна сторінка',
	            pageToLast: 'Остання сторінка'
	          },
	          sizes: 'рядків на сторінку',
	          totalItems: 'рядків',
	          through: 'по',
	          of: 'з'
	        },
	        grouping: {
	          group: 'Групувати',
	          ungroup: 'Розгрупувати',
	          aggregate_count: 'Групувати: Кількість',
	          aggregate_sum: 'Для групи: Сума',
	          aggregate_max: 'Для групи: Максимум',
	          aggregate_min: 'Для групи: Мінімум',
	          aggregate_avg: 'Для групи: Серднє',
	          aggregate_remove: 'Для групи: Пусто'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-cn', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: '列过滤器',
	            removeFilter: '移除过滤器',
	            columnMenuButtonLabel: '列菜单'
	          },
	          priority: '优先级:',
	          filterLabel: "列过滤器: "
	        },
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表头到此处进行分组'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已显示行数：',
	          selectedItems: '已选择行数：',
	          totalItems: '总行数：',
	          size: '每页显示行数：',
	          first: '首页',
	          next: '下一页',
	          previous: '上一页',
	          last: '末页'
	        },
	        menu: {
	          text: '选择列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          none: '无序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隐藏列'
	        },
	        aggregation: {
	          count: '计数：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左侧固定',
	          pinRight: '右侧固定',
	          unpin: '取消固定'
	        },
	        columnMenu: {
	          close: '关闭'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: '表格菜单'
	          },
	          columns: '列：',
	          importerTitle: '导入文件',
	          exporterAllAsCsv: '导出全部数据到CSV',
	          exporterVisibleAsCsv: '导出可见数据到CSV',
	          exporterSelectedAsCsv: '导出已选数据到CSV',
	          exporterAllAsPdf: '导出全部数据到PDF',
	          exporterVisibleAsPdf: '导出可见数据到PDF',
	          exporterSelectedAsPdf: '导出已选数据到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '无法获取列名，确定文件包含表头？',
	          noObjects: '无法获取数据，确定文件包含数据？',
	          invalidCsv: '无法处理文件，确定是合法的CSV文件？',
	          invalidJson: '无法处理文件，确定是合法的JSON文件？',
	          jsonNotArray: '导入的文件不是JSON数组！'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: '第一页',
	            pageBack: '上一页',
	            pageSelected: '当前页',
	            pageForward: '下一页',
	            pageToLast: '最后一页'
	          },
	          sizes: '行每页',
	          totalItems: '行',
	          through: '至',
	          of: '共'
	        },
	        grouping: {
	          group: '分组',
	          ungroup: '取消分组',
	          aggregate_count: '合计: 计数',
	          aggregate_sum: '合计: 求和',
	          aggregate_max: '合计: 最大',
	          aggregate_min: '合计: 最小',
	          aggregate_avg: '合计: 平均',
	          aggregate_remove: '合计: 移除'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-tw', {
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表頭到此處進行分組'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已顯示行數：',
	          selectedItems: '已選擇行數：',
	          totalItems: '總行數：',
	          size: '每頁顯示行數：',
	          first: '首頁',
	          next: '下壹頁',
	          previous: '上壹頁',
	          last: '末頁'
	        },
	        menu: {
	          text: '選擇列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隱藏列'
	        },
	        aggregation: {
	          count: '計數：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左側固定',
	          pinRight: '右側固定',
	          unpin: '取消固定'
	        },
	        gridMenu: {
	          columns: '列：',
	          importerTitle: '導入文件',
	          exporterAllAsCsv: '導出全部數據到CSV',
	          exporterVisibleAsCsv: '導出可見數據到CSV',
	          exporterSelectedAsCsv: '導出已選數據到CSV',
	          exporterAllAsPdf: '導出全部數據到PDF',
	          exporterVisibleAsPdf: '導出可見數據到PDF',
	          exporterSelectedAsPdf: '導出已選數據到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '無法獲取列名，確定文件包含表頭？',
	          noObjects: '無法獲取數據，確定文件包含數據？',
	          invalidCsv: '無法處理文件，確定是合法的CSV文件？',
	          invalidJson: '無法處理文件，確定是合法的JSON文件？',
	          jsonNotArray: '導入的文件不是JSON數組！'
	        },
	        pagination: {
	          sizes: '行每頁',
	          totalItems: '行'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.importer
	   * @description
	   *
	   * # ui.grid.importer
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to import data into the grid. It
	   * uses the column defs to work out which data belongs in which column,
	   * and creates entities from a configured class (typically a $resource).
	   *
	   * If the rowEdit feature is enabled, it also calls save on those newly
	   * created objects, and then displays any errors in the imported data.
	   *
	   * Currently the importer imports only CSV and json files, although provision has been
	   * made to process other file formats, and these can be added over time.
	   *
	   * For json files, the properties within each object in the json must match the column names
	   * (to put it another way, the importer doesn't process the json, it just copies the objects
	   * within the json into a new instance of the specified object type)
	   *
	   * For CSV import, the default column identification relies on each column in the
	   * header row matching a column.name or column.displayName. Optionally, a column identification
	   * callback can be used.  This allows matching using other attributes, which is particularly
	   * useful if your application has internationalised column headings (i.e. the headings that
	   * the user sees don't match the column names).
	   *
	   * The importer makes use of the grid menu as the UI for requesting an
	   * import.
	   *
	   * <div ui-grid-importer></div>
	   */
	
	  var module = angular.module('ui.grid.importer', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.importer.constant:uiGridImporterConstants
	   *
	   *  @description constants available in importer module
	   */
	
	  module.constant('uiGridImporterConstants', {
	    featureName: 'importer'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.importer.service:uiGridImporterService
	   *
	   *  @description Services for importer feature
	   */
	  module.service('uiGridImporterService', ['$q', 'uiGridConstants', 'uiGridImporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService', '$window',
	    function ($q, uiGridConstants, uiGridImporterConstants, gridUtil, $compile, $interval, i18nService, $window) {
	
	      var service = {
	
	        initializeGrid: function ($scope, grid) {
	
	          // add feature namespace and any properties to grid for needed state
	          grid.importer = {
	            $scope: $scope
	          };
	
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.importer.api:PublicApi
	           *
	           *  @description Public Api for importer feature
	           */
	          var publicApi = {
	            events: {
	              importer: {
	              }
	            },
	            methods: {
	              importer: {
	                /**
	                 * @ngdoc function
	                 * @name importFile
	                 * @methodOf  ui.grid.importer.api:PublicApi
	                 * @description Imports a file into the grid using the file object
	                 * provided.  Bypasses the grid menu
	                 * @param {File} fileObject the file we want to import, as a javascript
	                 * File object
	                 */
	                importFile: function ( fileObject ) {
	                  service.importThisFile( grid, fileObject );
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if ( grid.options.enableImporter && grid.options.importerShowMenu ) {
	            if ( grid.api.core.addToGridMenu ) {
	              service.addToMenu( grid );
	            } else {
	              // order of registration is not guaranteed, register in a little while
	              $interval( function() {
	                if (grid.api.core.addToGridMenu) {
	                  service.addToMenu( grid );
	                }
	              }, 100, 1);
	            }
	          }
	        },
	
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.importer.api:GridOptions
	           *
	           * @description GridOptions for importer feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name enableImporter
	           * @description Whether or not importer is enabled.  Automatically set
	           * to false if the user's browser does not support the required fileApi.
	           * Otherwise defaults to true.
	           *
	           */
	          if (gridOptions.enableImporter  || gridOptions.enableImporter === undefined) {
	            if ( !($window.hasOwnProperty('File') && $window.hasOwnProperty('FileReader') && $window.hasOwnProperty('FileList') && $window.hasOwnProperty('Blob')) ) {
	              gridUtil.logError('The File APIs are not fully supported in this browser, grid importer cannot be used.');
	              gridOptions.enableImporter = false;
	            } else {
	              gridOptions.enableImporter = true;
	            }
	          } else {
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerProcessHeaders
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will process headers using custom
	           * logic.  Set this callback function if the headers that your user will provide in their
	           * import file don't necessarily match the grid header or field names.  This might commonly
	           * occur where your application is internationalised, and therefore the field names
	           * that the user recognises are in a different language than the field names that
	           * ui-grid knows about.
	           *
	           * Defaults to the internal `processHeaders` method, which seeks to match using both
	           * displayName and column.name.  Any non-matching columns are discarded.
	           *
	           * Your callback routine should respond by processing the header array, and returning an array
	           * of matching column names.  A null value in any given position means "don't import this column"
	           *
	           * <pre>
	           *      gridOptions.importerProcessHeaders: function( grid, headerArray ) {
	           *        var myHeaderColumns = [];
	           *        var thisCol;
	           *        headerArray.forEach( function( value, index ) {
	           *          thisCol = mySpecialLookupFunction( value );
	           *          myHeaderColumns.push( thisCol.name );
	           *        });
	           *
	           *        return myHeaderCols;
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into
	           * @param {array} headerArray an array of the text from the first row of the csv file,
	           * which you need to match to column.names
	           * @returns {array} array of matching column names, in the same order as the headerArray
	           *
	           */
	          gridOptions.importerProcessHeaders = gridOptions.importerProcessHeaders || service.processHeaders;
	
	          /**
	           * @ngdoc method
	           * @name importerHeaderFilter
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will filter (usually translate) a single
	           * header.  Used when you want to match the passed in column names to the column
	           * displayName after the header filter.
	           *
	           * Your callback routine needs to return the filtered header value.
	           * <pre>
	           *      gridOptions.importerHeaderFilter: function( displayName ) {
	           *        return $translate.instant( displayName );
	           *      })
	           * </pre>
	           *
	           * or:
	           * <pre>
	           *      gridOptions.importerHeaderFilter: $translate.instant
	           * </pre>
	           * @param {string} displayName the displayName that we'd like to translate
	           * @returns {string} the translated name
	           *
	           */
	          gridOptions.importerHeaderFilter = gridOptions.importerHeaderFilter || function( displayName ) { return displayName; };
	
	          /**
	           * @ngdoc method
	           * @name importerErrorCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that provides custom error handling, rather
	           * than the standard grid behaviour of an alert box and a console message.  You
	           * might use this to internationalise the console log messages, or to write to a
	           * custom logging routine that returned errors to the server.
	           *
	           * <pre>
	           *      gridOptions.importerErrorCallback: function( grid, errorKey, consoleMessage, context ) {
	           *        myUserDisplayRoutine( errorKey );
	           *        myLoggingRoutine( consoleMessage, context );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful if you're positioning messages
	           * in some way
	           * @param {string} errorKey one of the i18n keys the importer can return - importer.noHeaders,
	           * importer.noObjects, importer.invalidCsv, importer.invalidJson, importer.jsonNotArray
	           * @param {string} consoleMessage the English console message that importer would have written
	           * @param {object} context the context data that importer would have appended to that console message,
	           * often the file content itself or the element that is in error
	           *
	           */
	          if ( !gridOptions.importerErrorCallback ||  typeof(gridOptions.importerErrorCallback) !== 'function' ) {
	            delete gridOptions.importerErrorCallback;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerDataAddCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A mandatory callback function that adds data to the source data array.  The grid
	           * generally doesn't add rows to the source data array, it is tidier to handle this through a user
	           * callback.
	           *
	           * <pre>
	           *      gridOptions.importerDataAddCallback: function( grid, newObjects ) {
	           *        $scope.myData = $scope.myData.concat( newObjects );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful in some way
	           * @param {array} newObjects an array of new objects that you should add to your data
	           *
	           */
	          if ( gridOptions.enableImporter === true && !gridOptions.importerDataAddCallback ) {
	            gridUtil.logError("You have not set an importerDataAddCallback, importer is disabled");
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc object
	           * @name importerNewObject
	           * @propertyOf  ui.grid.importer.api:GridOptions
	           * @description An object on which we call `new` to create each new row before inserting it into
	           * the data array.  Typically this would be a $resource entity, which means that if you're using
	           * the rowEdit feature, you can directly call save on this entity when the save event is triggered.
	           *
	           * Defaults to a vanilla javascript object
	           *
	           * @example
	           * <pre>
	           *   gridOptions.importerNewObject = MyRes;
	           * </pre>
	           *
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name importerShowMenu
	           * @description Whether or not to show an item in the grid menu.  Defaults to true.
	           *
	           */
	          gridOptions.importerShowMenu = gridOptions.importerShowMenu !== false;
	
	          /**
	           * @ngdoc method
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @name importerObjectCallback
	           * @description A callback that massages the data for each object.  For example,
	           * you might have data stored as a code value, but display the decode.  This callback
	           * can be used to change the decoded value back into a code.  Defaults to doing nothing.
	           * @param {Grid} grid in case you need it
	           * @param {object} newObject the new object as importer has created it, modify it
	           * then return the modified version
	           * @returns {object} the modified object
	           * @example
	           * <pre>
	           *   gridOptions.importerObjectCallback = function ( grid, newObject ) {
	           *     switch newObject.status {
	           *       case 'Active':
	           *         newObject.status = 1;
	           *         break;
	           *       case 'Inactive':
	           *         newObject.status = 2;
	           *         break;
	           *     }
	           *     return newObject;
	           *   };
	           * </pre>
	           */
	          gridOptions.importerObjectCallback = gridOptions.importerObjectCallback || function( grid, newObject ) { return newObject; };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.importer.service:uiGridImporterService
	         * @description Adds import menu item to the grid menu,
	         * allowing the user to request import of a file
	         * @param {Grid} grid the grid into which data should be imported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.importerTitle'),
	              order: 150
	            },
	            {
	              templateUrl: 'ui-grid/importerMenuItemContainer',
	              action: function () {
	                this.grid.api.importer.importAFile( grid );
	              },
	              order: 151
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importThisFile
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Imports the provided file into the grid using the file object
	         * provided.  Bypasses the grid menu
	         * @param {Grid} grid the grid we're importing into
	         * @param {File} fileObject the file we want to import, as returned from the File
	         * javascript object
	         */
	        importThisFile: function ( grid, fileObject ) {
	          if (!fileObject) {
	            gridUtil.logError( 'No file object provided to importThisFile, should be impossible, aborting');
	            return;
	          }
	
	          var reader = new FileReader();
	
	          switch ( fileObject.type ) {
	            case 'application/json':
	              reader.onload = service.importJsonClosure( grid );
	              break;
	            default:
	              reader.onload = service.importCsvClosure( grid );
	              break;
	          }
	
	          reader.readAsText( fileObject );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a json file into the grid.
	         * The json data is imported into new objects of type `gridOptions.importerNewObject`,
	         * and if the rowEdit feature is enabled the rows are marked as dirty
	         * @param {Grid} grid the grid we want to import into
	         * @return {function} Function that receives the file that we want to import, as
	         * a FileObject as an argument
	         */
	        importJsonClosure: function( grid ) {
	          return function( importFile ) {
	            var newObjects = [],
	              newObject,
	              importArray = service.parseJson( grid, importFile );
	
	            if (importArray === null) {
	              return;
	            }
	            importArray.forEach(  function( value ) {
	              newObject = service.newObject( grid );
	              angular.extend( newObject, value );
	              newObject = grid.options.importerObjectCallback( grid, newObject );
	              newObjects.push( newObject );
	            });
	
	            service.addObjects( grid, newObjects );
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a json file, returns the parsed data.
	         * Displays an error if file doesn't parse
	         * @param {Grid} grid the grid that we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a FileObject
	         * @returns {array} array of objects from the imported json
	         */
	        parseJson: function( grid, importFile ) {
	          var loadedObjects;
	
	          try {
	            loadedObjects = JSON.parse( importFile.target.result );
	          } catch (e) {
	            service.alertError( grid, 'importer.invalidJson', 'File could not be processed, is it valid json? Content was: ', importFile.target.result );
	            return;
	          }
	
	          if ( !Array.isArray( loadedObjects ) ) {
	            service.alertError( grid, 'importer.jsonNotarray', 'Import failed, file is not an array, file was: ', importFile.target.result );
	            return [];
	          } else {
	            return loadedObjects;
	          }
	        },
	
	
	
	        /**
	         * @ngdoc function
	         * @name importCsvClosure
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a csv file into the grid
	         * (allowing it to be used in the reader.onload event)
	         * @param {Grid} grid the grid that we want to import into
	         * @return {function} Function that receives the file that we want to import, as
	         * a file object
	         */
	        importCsvClosure: function( grid ) {
	          return function( importFile ) {
	            var importArray = service.parseCsv( importFile );
	
	            if ( !importArray || importArray.length < 1 ) {
	              service.alertError( grid, 'importer.invalidCsv', 'File could not be processed, is it valid csv? Content was: ', importFile.target.result );
	              return;
	            }
	
	            var newObjects = service.createCsvObjects( grid, importArray );
	
	            if ( !newObjects || newObjects.length === 0 ) {
	              service.alertError( grid, 'importer.noObjects', 'Objects were not able to be derived, content was: ', importFile.target.result );
	              return;
	            }
	
	            service.addObjects( grid, newObjects );
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseCsv
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a csv file into an array of arrays, with the first
	         * array being the headers, and the remaining arrays being the data.
	         * The logic for this comes from https://github.com/thetalecrafter/excel.js/blob/master/src/csv.js,
	         * which is noted as being under the MIT license.  The code is modified to pass the jscs yoda condition
	         * checker
	         * @param {FileObject} importFile the file that we want to import, as a
	         * file object
	         */
	        parseCsv: function( importFile ) {
	          var csv = importFile.target.result;
	
	          // use the CSV-JS library to parse
	          return CSV.parse(csv);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name createCsvObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Converts an array of arrays (representing the csv file)
	         * into a set of objects.  Uses the provided `gridOptions.importerNewObject`
	         * to create the objects, and maps the header row into the individual columns
	         * using either `gridOptions.importerProcessHeaders`, or by using a native method
	         * of matching to either the displayName, column name or column field of
	         * the columns in the column defs.  The resulting objects will have attributes
	         * that are named based on the column.field or column.name, in that order.
	         * @param {Grid} grid the grid that we want to import into
	         * @param {Array} importArray the data that we want to import, as an array
	         */
	        createCsvObjects: function( grid, importArray ) {
	          // pull off header row and turn into headers
	          var headerMapping = grid.options.importerProcessHeaders( grid, importArray.shift() );
	
	          if ( !headerMapping || headerMapping.length === 0 ) {
	            service.alertError( grid, 'importer.noHeaders', 'Column names could not be derived, content was: ', importArray );
	            return [];
	          }
	
	          var newObjects = [],
	            newObject;
	
	          importArray.forEach( function( row ) {
	            newObject = service.newObject( grid );
	            if ( row !== null ) {
	              row.forEach( function( field, index ) {
	                if ( headerMapping[index] !== null ) {
	                  newObject[ headerMapping[index] ] = field;
	                }
	              });
	            }
	            newObject = grid.options.importerObjectCallback( grid, newObject );
	            newObjects.push( newObject );
	          });
	
	          return newObjects;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name processHeaders
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Determines the columns that the header row from
	         * a csv (or other) file represents.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         * @returns {array} an array of the attribute names that should be used
	         * for that column, based on matching the headers or creating the headers
	         *
	         */
	        processHeaders: function( grid, headerRow ) {
	          var headers = [];
	
	          if ( !grid.options.columnDefs || grid.options.columnDefs.length === 0 ) {
	            // we are going to create new columnDefs for all these columns, so just remove
	            // spaces from the names to create fields
	            headerRow.forEach( function( value ) {
	              headers.push( value.replace( /[^0-9a-zA-Z\-_]/g, '_' ) );
	            });
	            return headers;
	          }
	          else {
	            var lookupHash = service.flattenColumnDefs( grid, grid.options.columnDefs );
	            headerRow.forEach(  function( value ) {
	              if ( lookupHash[value] ) {
	                headers.push( lookupHash[value] );
	              }
	              else if ( lookupHash[ value.toLowerCase() ] ) {
	                headers.push( lookupHash[ value.toLowerCase() ] );
	              }
	              else {
	                headers.push( null );
	              }
	            });
	            return headers;
	          }
	        },
	
	
	        /**
	         * @name flattenColumnDefs
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Runs through the column defs and creates a hash of
	         * the displayName, name and field, and of each of those values forced to lower case,
	         * with each pointing to the field or name
	         * (whichever is present).  Used to lookup column headers and decide what
	         * attribute name to give to the resulting field.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} columnDefs the columnDefs that we should flatten
	         * @returns {hash} the flattened version of the column def information, allowing
	         * us to look up a value by `flattenedHash[ headerValue ]`
	         */
	        flattenColumnDefs: function( grid, columnDefs ) {
	          var flattenedHash = {};
	
	          columnDefs.forEach(  function( columnDef) {
	            if ( columnDef.name ) {
	              flattenedHash[ columnDef.name ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.name.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.field ) {
	              flattenedHash[ columnDef.field ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.field.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName ) {
	              flattenedHash[ columnDef.displayName ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.displayName.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName && grid.options.importerHeaderFilter ) {
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName) ] = columnDef.field || columnDef.name;
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName).toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	          });
	
	          return flattenedHash;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Inserts our new objects into the grid data, and
	         * sets the rows to dirty if the rowEdit feature is being used
	         *
	         * Does this by registering a watch on dataChanges, which essentially
	         * is waiting on the result of the grid data watch, and downstream processing.
	         *
	         * When the callback is called, it deregisters itself - we don't want to run
	         * again next time data is added.
	         *
	         * If we never get called, we deregister on destroy.
	         *
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} newObjects the objects we want to insert into the grid data
	         * @returns {object} the new object
	         */
	        addObjects: function( grid, newObjects ) {
	          if ( grid.api.rowEdit ) {
	            var dataChangeDereg = grid.registerDataChangeCallback( function() {
	              grid.api.rowEdit.setRowsDirty( newObjects );
	              dataChangeDereg();
	            }, [uiGridConstants.dataChange.ROW] );
	
	            grid.importer.$scope.$on( '$destroy', dataChangeDereg );
	          }
	
	          grid.importer.$scope.$apply( grid.options.importerDataAddCallback( grid, newObjects ) );
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name newObject
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Makes a new object based on `gridOptions.importerNewObject`,
	         * or based on an empty object if not present
	         * @param {Grid} grid the grid we're importing into
	         * @returns {object} the new object
	         */
	        newObject: function( grid ) {
	          if ( typeof(grid.options) !== "undefined" && typeof(grid.options.importerNewObject) !== "undefined" ) {
	            return new grid.options.importerNewObject();
	          }
	          else {
	            return {};
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name alertError
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Provides an internationalised user alert for the failure,
	         * and logs a console message including diagnostic content.
	         * Optionally, if the the `gridOptions.importerErrorCallback` routine
	         * is defined, then calls that instead, allowing user specified error routines
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         */
	        alertError: function( grid, alertI18nToken, consoleMessage, context ) {
	          if ( grid.options.importerErrorCallback ) {
	            grid.options.importerErrorCallback( grid, alertI18nToken, consoleMessage, context );
	          }
	          else {
	            $window.alert(i18nService.getSafeText( alertI18nToken ));
	            gridUtil.logError(consoleMessage + context );
	          }
	        }
	      };
	
	      return service;
	
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds importer features to grid
	   *
	   */
	  module.directive('uiGridImporter', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridImporterService.initializeGrid($scope, uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporterMenuItem
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Handles the processing from the importer menu item - once a file is
	   *  selected
	   *
	   */
	  module.directive('uiGridImporterMenuItem', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '?^uiGrid',
	        scope: false,
	        templateUrl: 'ui-grid/importerMenuItem',
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var grid;
	
	          function handleFileSelect(event) {
	            var target = event.srcElement || event.target;
	
	            if (target && target.files && target.files.length === 1) {
	              var fileObject = target.files[0];
	
	              // Define grid if the uiGrid controller is present
	              if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	                grid = uiGridCtrl.grid;
	
	                uiGridImporterService.importThisFile( grid, fileObject );
	                target.form.reset();
	              }
	              else {
	                gridUtil.logError('Could not import file because UI Grid was not found.');
	              }
	            }
	          }
	
	          var fileChooser = $elm[0].querySelectorAll('.ui-grid-importer-file-chooser');
	
	          if ( fileChooser.length !== 1 ) {
	            gridUtil.logError('Found > 1 or < 1 file choosers within the menu item, error, cannot continue');
	          }
	          else {
	            fileChooser[0].addEventListener('change', handleFileSelect, false);
	          }
	        }
	      };
	    }
	  ]);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.infiniteScroll
	   *
	   *  @description
	   *
	   * #ui.grid.infiniteScroll
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides infinite scroll functionality to ui-grid
	   *
	   */
	  var module = angular.module('ui.grid.infiniteScroll', ['ui.grid']);
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	   *
	   *  @description Service for infinite scroll features
	   */
	  module.service('uiGridInfiniteScrollService', ['gridUtil', '$compile', '$rootScope', 'uiGridConstants', 'ScrollEvent', '$q', function (gridUtil, $compile, $rootScope, uiGridConstants, ScrollEvent, $q) {
	    var service = {
	
	      /**
	       * @ngdoc function
	       * @name initializeGrid
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This method register events and methods into grid public API
	       */
	
	      initializeGrid: function(grid, $scope) {
	        service.defaultGridOptions(grid.options);
	
	        if (!grid.options.enableInfiniteScroll) {
	          return;
	        }
	
	        grid.infiniteScroll = { dataLoading: false };
	        service.setScrollDirections( grid, grid.options.infiniteScrollUp, grid.options.infiniteScrollDown );
	          grid.api.core.on.scrollEnd($scope, service.handleScroll);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:PublicAPI
	         *
	         *  @description Public API for infinite scroll feature
	         */
	        var publicApi = {
	          events: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreData
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches bottom percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreData: function ($scope, fn) {
	              },
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreDataTop
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches top percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreDataTop: function ($scope, fn) {
	              }
	            }
	          },
	          methods: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc function
	               * @name dataLoaded
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have loaded the additional data
	               * requested.  You should set scrollUp and scrollDown to indicate
	               * whether there are still more pages in each direction.
	               *
	               * If you call dataLoaded without first calling `saveScrollPercentage` then we will
	               * scroll the user to the start of the newly loaded data, which usually gives a smooth scroll
	               * experience, but can give a jumpy experience with large `infiniteScrollRowsFromEnd` values, and
	               * on variable speed internet connections.  Using `saveScrollPercentage` as demonstrated in the tutorial
	               * should give a smoother scrolling experience for users.
	               *
	               * See infinite_scroll tutorial for example of usage
	               * @param {boolean} scrollUp if set to false flags that there are no more pages upwards, so don't fire
	               * any more infinite scroll events upward
	               * @param {boolean} scrollDown if set to false flags that there are no more pages downwards, so don't
	               * fire any more infinite scroll events downward
	               * @returns {promise} a promise that is resolved when the grid scrolling is fully adjusted.  If you're
	               * planning to remove pages, you should wait on this promise first, or you'll break the scroll positioning
	               */
	              dataLoaded: function( scrollUp, scrollDown ) {
	                service.setScrollDirections(grid, scrollUp, scrollDown);
	
	                return service.adjustScroll(grid).then(function() {
	                  grid.infiniteScroll.dataLoading = false;
	                });
	              },
	
	              /**
	               * @ngdoc function
	               * @name resetScroll
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have taken some action that makes the current
	               * scroll position invalid.  For example, if you're using external sorting and you've resorted
	               * then you might reset the scroll, or if you've otherwise substantially changed the data, perhaps
	               * you've reused an existing grid for a new data set
	               *
	               * You must tell us whether there is data upwards or downwards after the reset
	               *
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              resetScroll: function( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown);
	
	                service.adjustInfiniteScrollPosition(grid, 0);
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name saveScrollPercentage
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Saves the scroll percentage and number of visible rows before you adjust the data,
	               * used if you're subsequently going to call `dataRemovedTop` or `dataRemovedBottom`
	               */
	              saveScrollPercentage: function() {
	                grid.infiniteScroll.prevScrollTop = grid.renderContainers.body.prevScrollTop;
	                grid.infiniteScroll.previousVisibleRows = grid.getVisibleRowCount();
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedTop
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the top
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedTop: function( scrollUp, scrollDown ) {
	                service.dataRemovedTop( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedBottom
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the bottom
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedBottom: function( scrollUp, scrollDown ) {
	                service.dataRemovedBottom( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name setScrollDirections
	               * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	               * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	               * and also sets the grid.suppressParentScroll
	               * @param {boolean} scrollUp whether there are pages available up - defaults to false
	               * @param {boolean} scrollDown whether there are pages available down - defaults to true
	               */
	              setScrollDirections:  function ( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown );
	              }
	
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:GridOptions
	         *
	         *  @description GridOptions for infinite scroll feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableInfiniteScroll
	         *  @propertyOf  ui.grid.infiniteScroll.api:GridOptions
	         *  @description Enable infinite scrolling for this grid
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableInfiniteScroll = gridOptions.enableInfiniteScroll !== false;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollRowsFromEnd
	         * @propertyOf ui.grid.class:GridOptions
	         * @description This setting controls how close to the end of the dataset a user gets before
	         * more data is requested by the infinite scroll, whether scrolling up or down.  This allows you to
	         * 'prefetch' rows before the user actually runs out of scrolling.
	         *
	         * Note that if you set this value too high it may give jumpy scrolling behaviour, if you're getting
	         * this behaviour you could use the `saveScrollPercentageMethod` right before loading your data, and we'll
	         * preserve that scroll position
	         *
	         * <br> Defaults to 20
	         */
	        gridOptions.infiniteScrollRowsFromEnd = gridOptions.infiniteScrollRowsFromEnd || 20;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollUp
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll up, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreDataTop event when the user hits the top of the scrollbar.
	         * <br> Defaults to false
	         */
	        gridOptions.infiniteScrollUp = gridOptions.infiniteScrollUp === true;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollDown
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll down, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreData event when the user hits the bottom of the scrollbar.
	         * <br> Defaults to true
	         */
	        gridOptions.infiniteScrollDown = gridOptions.infiniteScrollDown !== false;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setScrollDirections
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	       * and also sets the grid.suppressParentScroll
	       * @param {grid} grid the grid we're operating on
	       * @param {boolean} scrollUp whether there are pages available up - defaults to false
	       * @param {boolean} scrollDown whether there are pages available down - defaults to true
	       */
	      setScrollDirections:  function ( grid, scrollUp, scrollDown ) {
	        grid.infiniteScroll.scrollUp = ( scrollUp === true );
	        grid.suppressParentScrollUp = ( scrollUp === true );
	
	        grid.infiniteScroll.scrollDown = ( scrollDown !== false);
	        grid.suppressParentScrollDown = ( scrollDown !== false);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name handleScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Called whenever the grid scrolls, determines whether the scroll should
	       * trigger an infinite scroll request for more data
	       * @param {object} args the args from the event
	       */
	      handleScroll:  function (args) {
	        // don't request data if already waiting for data, or if source is coming from ui.grid.adjustInfiniteScrollPosition() function
	        if ( args.grid.infiniteScroll && args.grid.infiniteScroll.dataLoading || args.source === 'ui.grid.adjustInfiniteScrollPosition' ) {
	          return;
	        }
	
	        if (args.y) {
	
	          // If the user is scrolling very quickly all the way to the top/bottom, the scroll handler can get confused
	          // about the direction. First we check if they've gone all the way, and data always is loaded in this case.
	          if (args.y.percentage === 0) {
	            args.grid.scrollDirection = uiGridConstants.scrollDirection.UP;
	            service.loadData(args.grid);
	          }
	          else if (args.y.percentage === 1) {
	            args.grid.scrollDirection = uiGridConstants.scrollDirection.DOWN;
	            service.loadData(args.grid);
	          }
	          else { // Scroll position is somewhere in between top/bottom, so determine whether it's far enough to load more data.
	            var percentage,
	              targetPercentage = args.grid.options.infiniteScrollRowsFromEnd / args.grid.renderContainers.body.visibleRowCache.length;
	
	            if (args.grid.scrollDirection === uiGridConstants.scrollDirection.UP ) {
	              percentage = args.y.percentage;
	              if (percentage <= targetPercentage) {
	                service.loadData(args.grid);
	              }
	            }
	            else if (args.grid.scrollDirection === uiGridConstants.scrollDirection.DOWN) {
	              percentage = 1 - args.y.percentage;
	              if (percentage <= targetPercentage) {
	                service.loadData(args.grid);
	              }
	            }
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name loadData
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * and whether there are more pages upwards or downwards.  It also stores the number of rows that we had previously,
	       * and clears out any saved scroll position so that we know whether or not the user calls `saveScrollPercentage`
	       * @param {Grid} grid the grid we're working on
	       */
	      loadData: function (grid) {
	        // save number of currently visible rows to calculate new scroll position later - we know that we want
	        // to be at approximately the row we're currently at
	        grid.infiniteScroll.previousVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        grid.infiniteScroll.direction = grid.scrollDirection;
	        delete grid.infiniteScroll.prevScrollTop;
	
	        if (grid.scrollDirection === uiGridConstants.scrollDirection.UP && grid.infiniteScroll.scrollUp ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreDataTop();
	        }
	        else if (grid.scrollDirection === uiGridConstants.scrollDirection.DOWN && grid.infiniteScroll.scrollDown ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreData();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Once we are informed that data has been loaded, adjust the scroll position to account for that
	       * addition and to make things look clean.
	       *
	       * If we're scrolling up we scroll to the first row of the old data set -
	       * so we're assuming that you would have gotten to the top of the grid (from the 20% need more data trigger) by
	       * the time the data comes back.  If we're scrolling down we scroll to the last row of the old data set - so we're
	       * assuming that you would have gotten to the bottom of the grid (from the 80% need more data trigger) by the time
	       * the data comes back.
	       *
	       * Neither of these are good assumptions, but making this a smoother experience really requires
	       * that trigger to not be a percentage, and to be much closer to the end of the data (say, 5 rows off the end).  Even then
	       * it'd be better still to actually run into the end.  But if the data takes a while to come back, they may have scrolled
	       * somewhere else in the mean-time, in which case they'll get a jump back to the new data.  Anyway, this will do for
	       * now, until someone wants to do better.
	       * @param {Grid} grid the grid we're working on
	       * @returns {promise} a promise that is resolved when scrolling has finished
	       */
	      adjustScroll: function(grid) {
	        var promise = $q.defer();
	        $rootScope.$applyAsync(function () {
	          var viewportHeight, rowHeight, newVisibleRows, oldTop, newTop;
	
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight;
	          rowHeight = grid.options.rowHeight;
	
	          if ( grid.infiniteScroll.direction === undefined ) {
	            // called from initialize, tweak our scroll up a little
	            service.adjustInfiniteScrollPosition(grid, 0);
	          }
	
	          newVisibleRows = grid.getVisibleRowCount();
	
	          // in case not enough data is loaded to enable scroller - load more data
	          var canvasHeight = rowHeight * newVisibleRows;
	          if (grid.infiniteScroll.scrollDown && (viewportHeight > canvasHeight)) {
	            grid.api.infiniteScroll.raise.needLoadMoreData();
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.UP ) {
	            oldTop = grid.infiniteScroll.prevScrollTop || 0;
	            newTop = oldTop + (newVisibleRows - grid.infiniteScroll.previousVisibleRows)*rowHeight;
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $rootScope.$applyAsync( function() {
	              promise.resolve();
	            });
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.DOWN ) {
	            newTop = grid.infiniteScroll.prevScrollTop || (grid.infiniteScroll.previousVisibleRows*rowHeight - viewportHeight);
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $rootScope.$applyAsync( function() {
	              promise.resolve();
	            });
	          }
	        }, 0);
	
	        return promise.promise;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustInfiniteScrollPosition
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * @param {Grid} grid the grid we're working on
	       * @param {number} scrollTop the position through the grid that we want to scroll to
	       */
	      adjustInfiniteScrollPosition: function (grid, scrollTop) {
	        var scrollEvent = new ScrollEvent(grid, null, null, 'ui.grid.adjustInfiniteScrollPosition'),
	          visibleRows = grid.getVisibleRowCount(),
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight,
	          rowHeight = grid.options.rowHeight,
	          scrollHeight = visibleRows*rowHeight-viewportHeight;
	
	        // for infinite scroll, if there are pages upwards then never allow it to be at the zero position so the up button can be active
	        if (scrollTop === 0 && grid.infiniteScroll.scrollUp) {
	          // using pixels results in a relative scroll, hence we have to use percentage
	          scrollEvent.y = {pixels: 1};
	        }
	        else {
	          scrollEvent.y = {percentage: scrollTop/scrollHeight};
	        }
	        grid.scrollContainers('', scrollEvent);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedTop
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the top. You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       */
	      dataRemovedTop: function( grid, scrollUp, scrollDown ) {
	        var newVisibleRows, oldTop, newTop, rowHeight;
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        oldTop = grid.infiniteScroll.prevScrollTop;
	        rowHeight = grid.options.rowHeight;
	
	        // since we removed from the top, our new scroll row will be the old scroll row less the number
	        // of rows removed
	        newTop = oldTop - ( grid.infiniteScroll.previousVisibleRows - newVisibleRows )*rowHeight;
	
	        service.adjustInfiniteScrollPosition( grid, newTop );
	      },
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedBottom
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the bottom.  You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       */
	      dataRemovedBottom: function( grid, scrollUp, scrollDown ) {
	        var newTop;
	
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newTop = grid.infiniteScroll.prevScrollTop;
	
	        service.adjustInfiniteScrollPosition( grid, newTop );
	      }
	    };
	    return service;
	  }]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.infiniteScroll.directive:uiGridInfiniteScroll
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds infinite scroll features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.infiniteScroll']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	            { name: 'Sam', car: 'Lexus' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'car'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-infinite-scroll="20"></div>
	   </div>
	   </file>
	   </example>
	   */
	
	  module.directive('uiGridInfiniteScroll', ['uiGridInfiniteScrollService',
	    function (uiGridInfiniteScrollService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: '^uiGrid',
	        compile: function() {
	          return {
	            pre: function($scope, $elm, $attr, uiGridCtrl) {
	              uiGridInfiniteScrollService.initializeGrid(uiGridCtrl.grid, $scope);
	            },
	            post: function($scope, $elm, $attr) {
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.moveColumns
	   * @description
	   *
	   * # ui.grid.moveColumns
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides column moving capability to ui.grid. It enables to change the position of columns.
	   * <div doc-module-components="ui.grid.moveColumns"></div>
	   */
	  var module = angular.module('ui.grid.moveColumns', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.moveColumns.service:uiGridMoveColumnService
	   *  @description Service for column moving feature.
	   */
	  module.service('uiGridMoveColumnService', ['$q', '$rootScope', '$log', 'ScrollEvent', 'uiGridConstants', 'gridUtil', function ($q, $rootScope, $log, ScrollEvent, uiGridConstants, gridUtil) {
	    var service = {
	      initializeGrid: function (grid) {
	        var self = this;
	        this.registerPublicApi(grid);
	        this.defaultGridOptions(grid.options);
	        grid.moveColumns = {orderCache: []}; // Used to cache the order before columns are rebuilt
	        grid.registerColumnBuilder(self.movableColumnBuilder);
	        grid.registerDataChangeCallback(self.verifyColumnOrder, [uiGridConstants.dataChange.COLUMN]);
	      },
	      registerPublicApi: function (grid) {
	        var self = this;
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:PublicApi
	         *  @description Public Api for column moving feature.
	         */
	        var publicApi = {
	          events: {
	            /**
	             * @ngdoc event
	             * @name columnPositionChanged
	             * @eventOf  ui.grid.moveColumns.api:PublicApi
	             * @description raised when column is moved
	             * <pre>
	             *      gridApi.colMovable.on.columnPositionChanged(scope,function(colDef, originalPosition, newPosition) {})
	             * </pre>
	             * @param {object} colDef the column that was moved
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              columnPositionChanged: function (colDef, originalPosition, newPosition) {
	              }
	            }
	          },
	          methods: {
	            /**
	             * @ngdoc method
	             * @name moveColumn
	             * @methodOf  ui.grid.moveColumns.api:PublicApi
	             * @description Method can be used to change column position.
	             * <pre>
	             *      gridApi.colMovable.moveColumn(oldPosition, newPosition)
	             * </pre>
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              moveColumn: function (originalPosition, finalPosition) {
	                var columns = grid.columns;
	                if (!angular.isNumber(originalPosition) || !angular.isNumber(finalPosition)) {
	                  gridUtil.logError('MoveColumn: Please provide valid values for originalPosition and finalPosition');
	                  return;
	                }
	                var nonMovableColumns = 0;
	                for (var i = 0; i < columns.length; i++) {
	                  if ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true) {
	                    nonMovableColumns++;
	                  }
	                }
	                if (originalPosition >= (columns.length - nonMovableColumns) || finalPosition >= (columns.length - nonMovableColumns)) {
	                  gridUtil.logError('MoveColumn: Invalid values for originalPosition, finalPosition');
	                  return;
	                }
	                var findPositionForRenderIndex = function (index) {
	                  var position = index;
	                  for (var i = 0; i <= position; i++) {
	                    if (angular.isDefined(columns[i]) && ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true)) {
	                      position++;
	                    }
	                  }
	                  return position;
	                };
	                self.redrawColumnAtPosition(grid, findPositionForRenderIndex(originalPosition), findPositionForRenderIndex(finalPosition));
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	      defaultGridOptions: function (gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:GridOptions
	         *
	         *  @description Options for configuring the move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:GridOptions
	         *  @description If defined, sets the default value for the colMovable flag on each individual colDefs
	         *  if their individual enableColumnMoving configuration is not defined. Defaults to true.
	         */
	        gridOptions.enableColumnMoving = gridOptions.enableColumnMoving !== false;
	      },
	      movableColumnBuilder: function (colDef, col, gridOptions) {
	        var promises = [];
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:ColumnDef
	         *
	         *  @description Column Definition for move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:ColumnDef
	         *  @description Enable column moving for the column.
	         */
	        colDef.enableColumnMoving = colDef.enableColumnMoving === undefined ? gridOptions.enableColumnMoving
	          : colDef.enableColumnMoving;
	        return $q.all(promises);
	      },
	      /**
	       * @ngdoc method
	       * @name updateColumnCache
	       * @methodOf  ui.grid.moveColumns
	       * @description Cache the current order of columns, so we can restore them after new columnDefs are defined
	       */
	      updateColumnCache: function(grid) {
	        grid.moveColumns.orderCache = grid.getOnlyDataColumns();
	      },
	      /**
	       * @ngdoc method
	       * @name verifyColumnOrder
	       * @methodOf  ui.grid.moveColumns
	       * @description dataChangeCallback which uses the cached column order to restore the column order
	       * when it is reset by altering the columnDefs array.
	       */
	      verifyColumnOrder: function(grid) {
	        var headerRowOffset = grid.rowHeaderColumns.length;
	        var newIndex;
	
	        angular.forEach(grid.moveColumns.orderCache, function(cacheCol, cacheIndex) {
	          newIndex = grid.columns.indexOf(cacheCol);
	          if ( newIndex !== -1 && newIndex - headerRowOffset !== cacheIndex ) {
	            var column = grid.columns.splice(newIndex, 1)[0];
	            grid.columns.splice(cacheIndex + headerRowOffset, 0, column);
	          }
	        });
	      },
	      redrawColumnAtPosition: function (grid, originalPosition, newPosition) {
	        var columns = grid.columns;
	
	        if (originalPosition === newPosition) {
	          return;
	        }
	
	        // check columns in between move-range to make sure they are visible columns
	        var pos = (originalPosition < newPosition) ? originalPosition + 1 : originalPosition - 1;
	        var i0 = Math.min(pos, newPosition);
	        for (i0; i0 <= Math.max(pos, newPosition); i0++) {
	          if (columns[i0].visible) {
	            break;
	          }
	        }
	        if (i0 > Math.max(pos, newPosition)) {
	          // no visible column found, column did not visibly move
	          return;
	        }
	
	        var originalColumn = columns[originalPosition];
	        if (originalColumn.colDef.enableColumnMoving) {
	          if (originalPosition > newPosition) {
	            for (var i1 = originalPosition; i1 > newPosition; i1--) {
	              columns[i1] = columns[i1 - 1];
	            }
	          }
	          else if (newPosition > originalPosition) {
	            for (var i2 = originalPosition; i2 < newPosition; i2++) {
	              columns[i2] = columns[i2 + 1];
	            }
	          }
	          columns[newPosition] = originalColumn;
	          service.updateColumnCache(grid);
	          grid.queueGridRefresh();
	          $rootScope.$applyAsync(function () {
	            grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	            grid.api.colMovable.raise.columnPositionChanged(originalColumn.colDef, originalPosition, newPosition);
	          });
	        }
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridMoveColumns
	   *  @element div
	   *  @restrict A
	   *  @description Adds column moving features to the ui-grid directive.
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.moveColumns']);
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	        $scope.data = [
	          { name: 'Bob', title: 'CEO', age: 45 },
	          { name: 'Frank', title: 'Lowly Developer', age: 25 },
	          { name: 'Jenny', title: 'Highly Developer', age: 35 }
	        ];
	        $scope.columnDefs = [
	          {name: 'name'},
	          {name: 'title'},
	          {name: 'age'}
	        ];
	      }]);
	   </file>
	   <file name="main.css">
	   .grid {
	      width: 100%;
	      height: 150px;
	    }
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div class="grid" ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-move-columns></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridMoveColumns', ['uiGridMoveColumnService', function (uiGridMoveColumnService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridMoveColumnService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridHeaderCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridHeaderCell to provide capability to be able to move it to reposition column.
	   *
	   *  On receiving mouseDown event headerCell is cloned, now as the mouse moves the cloned header cell also moved in the grid.
	   *  In case the moving cloned header cell reaches the left or right extreme of grid, grid scrolling is triggered (if horizontal scroll exists).
	   *  On mouseUp event column is repositioned at position where mouse is released and cloned header cell is removed.
	   *
	   *  Events that invoke cloning of header cell:
	   *    - mousedown
	   *
	   *  Events that invoke movement of cloned header cell:
	   *    - mousemove
	   *
	   *  Events that invoke repositioning of column:
	   *    - mouseup
	   */
	  module.directive('uiGridHeaderCell', ['$q', 'gridUtil', 'uiGridMoveColumnService', '$document', '$log', 'uiGridConstants', 'ScrollEvent',
	    function ($q, gridUtil, uiGridMoveColumnService, $document, $log, uiGridConstants, ScrollEvent) {
	      return {
	        priority: -10,
	        require: '^uiGrid',
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              if ($scope.col.colDef.enableColumnMoving) {
	
	                /*
	                 * Our general approach to column move is that we listen to a touchstart or mousedown
	                 * event over the column header.  When we hear one, then we wait for a move of the same type
	                 * - if we are a touchstart then we listen for a touchmove, if we are a mousedown we listen for
	                 * a mousemove (i.e. a drag) before we decide that there's a move underway.  If there's never a move,
	                 * and we instead get a mouseup or a touchend, then we just drop out again and do nothing.
	                 *
	                 */
	                var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	                var gridLeft;
	                var previousMouseX;
	                var totalMouseMovement;
	                var rightMoveLimit;
	                var elmCloned = false;
	                var movingElm;
	                var reducedWidth;
	                var moveOccurred = false;
	
	                var downFn = function( event ) {
	                  // Setting some variables required for calculations.
	                  gridLeft = $scope.grid.element[0].getBoundingClientRect().left;
	                  if ( $scope.grid.hasLeftContainer() ) {
	                    gridLeft += $scope.grid.renderContainers.left.header[0].getBoundingClientRect().width;
	                  }
	
	                  previousMouseX = event.pageX || (event.originalEvent ? event.originalEvent.pageX : 0);
	                  totalMouseMovement = 0;
	                  rightMoveLimit = gridLeft + $scope.grid.getViewportWidth();
	
	                  if ( event.type === 'mousedown' ) {
	                    $document.on('mousemove', moveFn);
	                    $document.on('mouseup', upFn);
	                  }
	                  else if ( event.type === 'touchstart' ) {
	                    $document.on('touchmove', moveFn);
	                    $document.on('touchend', upFn);
	                  }
	                };
	
	                var moveFn = function( event ) {
	                  var pageX = event.pageX || (event.originalEvent ? event.originalEvent.pageX : 0);
	                  var changeValue = pageX - previousMouseX;
	                  if ( changeValue === 0 ) { return; }
	                  // Disable text selection in Chrome during column move
	                  document.onselectstart = function() { return false; };
	
	                  moveOccurred = true;
	
	                  if (!elmCloned) {
	                    cloneElement();
	                  }
	                  else if (elmCloned) {
	                    moveElement(changeValue);
	                    previousMouseX = pageX;
	                  }
	                };
	
	                var upFn = function( event ) {
	                  // Re-enable text selection after column move
	                  document.onselectstart = null;
	
	                  // Remove the cloned element on mouse up.
	                  if (movingElm) {
	                    movingElm.remove();
	                    elmCloned = false;
	                  }
	
	                  offAllEvents();
	                  onDownEvents();
	
	                  if (!moveOccurred) {
	                    return;
	                  }
	
	                  var columns = $scope.grid.columns;
	                  var columnIndex = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (columns[i].colDef.name !== $scope.col.colDef.name) {
	                      columnIndex++;
	                    }
	                    else {
	                      break;
	                    }
	                  }
	
	                  var targetIndex;
	
	                  // Case where column should be moved to a position on its left
	                  if (totalMouseMovement < 0) {
	                    var totalColumnsLeftWidth = 0;
	                    var il;
	                    if ( $scope.grid.isRTL() ) {
	                      for (il = columnIndex + 1; il < columns.length; il++) {
	                        if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                          totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                          if (totalColumnsLeftWidth > Math.abs(totalMouseMovement)) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, il - 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	                    else {
	                      for (il = columnIndex - 1; il >= 0; il--) {
	                        if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                          totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                          if (totalColumnsLeftWidth > Math.abs(totalMouseMovement)) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, il + 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	
	                    // Case where column should be moved to beginning (or end in RTL) of the grid.
	                    if (totalColumnsLeftWidth < Math.abs(totalMouseMovement)) {
	                      targetIndex = 0;
	                      if ( $scope.grid.isRTL() ) {
	                        targetIndex = columns.length - 1;
	                      }
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, targetIndex);
	                    }
	                  }
	
	                  // Case where column should be moved to a position on its right
	                  else if (totalMouseMovement > 0) {
	                    var totalColumnsRightWidth = 0;
	                    var ir;
	                    if ( $scope.grid.isRTL() ) {
	                      for (ir = columnIndex - 1; ir > 0; ir--) {
	                        if (angular.isUndefined(columns[ir].colDef.visible) || columns[ir].colDef.visible === true) {
	                          totalColumnsRightWidth += columns[ir].drawnWidth || columns[ir].width || columns[ir].colDef.width;
	                          if (totalColumnsRightWidth > totalMouseMovement) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, ir);
	                            break;
	                          }
	                        }
	                      }
	                    }
	                    else {
	                      for (ir = columnIndex + 1; ir < columns.length; ir++) {
	                        if (angular.isUndefined(columns[ir].colDef.visible) || columns[ir].colDef.visible === true) {
	                          totalColumnsRightWidth += columns[ir].drawnWidth || columns[ir].width || columns[ir].colDef.width;
	                          if (totalColumnsRightWidth > totalMouseMovement) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, ir - 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	
	
	                    // Case where column should be moved to end (or beginning in RTL) of the grid.
	                    if (totalColumnsRightWidth < totalMouseMovement) {
	                      targetIndex = columns.length - 1;
	                      if ( $scope.grid.isRTL() ) {
	                        targetIndex = 0;
	                      }
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, targetIndex);
	                    }
	                  }
	
	
	
	                };
	
	                var onDownEvents = function() {
	                  $contentsElm.on('touchstart', downFn);
	                  $contentsElm.on('mousedown', downFn);
	                };
	
	                var offAllEvents = function() {
	                  $contentsElm.off('touchstart', downFn);
	                  $contentsElm.off('mousedown', downFn);
	
	                  $document.off('mousemove', moveFn);
	                  $document.off('touchmove', moveFn);
	
	                  $document.off('mouseup', upFn);
	                  $document.off('touchend', upFn);
	                };
	
	                onDownEvents();
	
	
	                var cloneElement = function () {
	                  elmCloned = true;
	
	                  // Cloning header cell and appending to current header cell.
	                  movingElm = $elm.clone();
	                  $elm.parent().append(movingElm);
	
	                  // Left of cloned element should be aligned to original header cell.
	                  movingElm.addClass('movingColumn');
	                  var movingElementStyles = {};
	                  movingElementStyles.left = $elm[0].offsetLeft + 'px';
	                  var gridRight = $scope.grid.element[0].getBoundingClientRect().right;
	                  var elmRight = $elm[0].getBoundingClientRect().right;
	                  if (elmRight > gridRight) {
	                    reducedWidth = $scope.col.drawnWidth + (gridRight - elmRight);
	                    movingElementStyles.width = reducedWidth + 'px';
	                  }
	                  movingElm.css(movingElementStyles);
	                };
	
	                var moveElement = function (changeValue) {
	                  // Calculate total column width
	                  var columns = $scope.grid.columns;
	                  var totalColumnWidth = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (angular.isUndefined(columns[i].colDef.visible) || columns[i].colDef.visible === true) {
	                      totalColumnWidth += columns[i].drawnWidth || columns[i].width || columns[i].colDef.width;
	                    }
	                  }
	
	                  // Calculate new position of left of column
	                  var currentElmLeft = movingElm[0].getBoundingClientRect().left - 1;
	                  var currentElmRight = movingElm[0].getBoundingClientRect().right;
	                  var newElementLeft;
	
	                  newElementLeft = currentElmLeft - gridLeft + changeValue;
	                  newElementLeft = newElementLeft < rightMoveLimit ? newElementLeft : rightMoveLimit;
	
	                  // Update css of moving column to adjust to new left value or fire scroll in case column has reached edge of grid
	                  if ((currentElmLeft >= gridLeft || changeValue > 0) && (currentElmRight <= rightMoveLimit || changeValue < 0)) {
	                    movingElm.css({visibility: 'visible', 'left': (movingElm[0].offsetLeft +
	                    (newElementLeft < rightMoveLimit ? changeValue : (rightMoveLimit - currentElmLeft))) + 'px'});
	                  }
	                  else if (totalColumnWidth > Math.ceil(uiGridCtrl.grid.gridWidth)) {
	                    changeValue *= 8;
	                    var scrollEvent = new ScrollEvent($scope.col.grid, null, null, 'uiGridHeaderCell.moveElement');
	                    scrollEvent.x = {pixels: changeValue};
	                    scrollEvent.grid.scrollContainers('',scrollEvent);
	                  }
	
	                  // Calculate total width of columns on the left of the moving column and the mouse movement
	                  var totalColumnsLeftWidth = 0;
	                  for (var il = 0; il < columns.length; il++) {
	                    if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                      if (columns[il].colDef.name !== $scope.col.colDef.name) {
	                        totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                      }
	                      else {
	                        break;
	                      }
	                    }
	                  }
	                  if ($scope.newScrollLeft === undefined) {
	                    totalMouseMovement += changeValue;
	                  }
	                  else {
	                    totalMouseMovement = $scope.newScrollLeft + newElementLeft - totalColumnsLeftWidth;
	                  }
	
	                  // Increase width of moving column, in case the rightmost column was moved and its width was
	                  // decreased because of overflow
	                  if (reducedWidth < $scope.col.drawnWidth) {
	                    reducedWidth += Math.abs(changeValue);
	                    movingElm.css({'width': reducedWidth + 'px'});
	                  }
	                };
	
	                $scope.$on('$destroy', offAllEvents);
	              }
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pagination
	   *
	   * @description
	   *
	   * # ui.grid.pagination
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides pagination support to ui-grid
	   */
	  var module = angular.module('ui.grid.pagination', ['ng', 'ui.grid']);
	
	  /**
	   * @ngdoc service
	   * @name ui.grid.pagination.service:uiGridPaginationService
	   *
	   * @description Service for the pagination feature
	   */
	  module.service('uiGridPaginationService', ['gridUtil',
	    function (gridUtil) {
	      var service = {
	        /**
	         * @ngdoc method
	         * @name initializeGrid
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @description Attaches the service to a certain grid
	         * @param {Grid} grid The grid we want to work with
	         */
	        initializeGrid: function (grid) {
	          service.defaultGridOptions(grid.options);
	
	          /**
	          * @ngdoc object
	          * @name ui.grid.pagination.api:PublicAPI
	          *
	          * @description Public API for the pagination feature
	          */
	          var publicApi = {
	            events: {
	              pagination: {
	              /**
	               * @ngdoc event
	               * @name paginationChanged
	               * @eventOf ui.grid.pagination.api:PublicAPI
	               * @description This event fires when the pageSize or currentPage changes
	               * @param {int} currentPage requested page number
	               * @param {int} pageSize requested page size
	               */
	                paginationChanged: function (currentPage, pageSize) { }
	              }
	            },
	            methods: {
	              pagination: {
	                /**
	                 * @ngdoc method
	                 * @name getPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the number of the current page
	                 */
	                getPage: function () {
	                  return grid.options.enablePagination ? grid.options.paginationCurrentPage : null;
	                },
	                /**
	                 * @ngdoc method
	                 * @name getFirstRowIndex
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the index of the first row of the current page.
	                 */
	                getFirstRowIndex: function () {
	                  if (grid.options.useCustomPagination) {
	                    return grid.options.paginationPageSizes.reduce(function(result, size, index) {
	                      return index < grid.options.paginationCurrentPage - 1 ? result + size : result;
	                    }, 0);
	                  }
	                  return ((grid.options.paginationCurrentPage - 1) * grid.options.paginationPageSize);
	                },
	                /**
	                 * @ngdoc method
	                 * @name getLastRowIndex
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the index of the last row of the current page.
	                 */
	                getLastRowIndex: function () {
	                  if (grid.options.useCustomPagination) {
	                    return publicApi.methods.pagination.getFirstRowIndex() + grid.options.paginationPageSizes[grid.options.paginationCurrentPage - 1] - 1;
	                  }
	                  return Math.min(grid.options.paginationCurrentPage * grid.options.paginationPageSize, grid.options.totalItems) - 1;
	                },
	                /**
	                 * @ngdoc method
	                 * @name getTotalPages
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the total number of pages
	                 */
	                getTotalPages: function () {
	                  if (!grid.options.enablePagination) {
	                    return null;
	                  }
	
	                  if (grid.options.useCustomPagination) {
	                    return grid.options.paginationPageSizes.length;
	                  }
	
	                  return (grid.options.totalItems === 0) ? 1 : Math.ceil(grid.options.totalItems / grid.options.paginationPageSize);
	                },
	                /**
	                 * @ngdoc method
	                 * @name nextPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the next page, if possible
	                 */
	                nextPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  if (grid.options.totalItems > 0) {
	                    grid.options.paginationCurrentPage = Math.min(
	                      grid.options.paginationCurrentPage + 1,
	                      publicApi.methods.pagination.getTotalPages()
	                    );
	                  }
	                  else {
	                    grid.options.paginationCurrentPage++;
	                  }
	                },
	                /**
	                 * @ngdoc method
	                 * @name previousPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the previous page, if we're not on the first page
	                 */
	                previousPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.max(grid.options.paginationCurrentPage - 1, 1);
	                },
	                /**
	                 * @ngdoc method
	                 * @name seek
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the requested page
	                 * @param {int} page The number of the page that should be displayed
	                 */
	                seek: function (page) {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	                  if (!angular.isNumber(page) || page < 1) {
	                    throw 'Invalid page number: ' + page;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.min(page, publicApi.methods.pagination.getTotalPages());
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          var processPagination = function( renderableRows ) {
	            if (grid.options.useExternalPagination || !grid.options.enablePagination) {
	              return renderableRows;
	            }
	            // client side pagination
	            var pageSize = parseInt(grid.options.paginationPageSize, 10);
	            var currentPage = parseInt(grid.options.paginationCurrentPage, 10);
	
	            var visibleRows = renderableRows.filter(function (row) { return row.visible; });
	            grid.options.totalItems = visibleRows.length;
	
	            var firstRow = publicApi.methods.pagination.getFirstRowIndex();
	            var lastRow  = publicApi.methods.pagination.getLastRowIndex();
	
	            if (firstRow > visibleRows.length) {
	              currentPage = grid.options.paginationCurrentPage = 1;
	              firstRow = (currentPage - 1) * pageSize;
	            }
	            return visibleRows.slice(firstRow, lastRow + 1);
	          };
	
	          grid.registerRowsProcessor(processPagination, 900 );
	
	        },
	        defaultGridOptions: function (gridOptions) {
	          /**
	           * @ngdoc object
	           * @name ui.grid.pagination.api:GridOptions
	           *
	           * @description GridOptions for the pagination feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @name enablePagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables pagination.  Defaults to true.
	           */
	          gridOptions.enablePagination = gridOptions.enablePagination !== false;
	          /**
	           * @ngdoc property
	           * @name enablePaginationControls
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables the paginator at the bottom of the grid. Turn this off if you want to implement your
	           *              own controls outside the grid.
	           */
	          gridOptions.enablePaginationControls = gridOptions.enablePaginationControls !== false;
	          /**
	           * @ngdoc property
	           * @name useExternalPagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Disables client side pagination. When true, handle the paginationChanged event and set data
	           *              and totalItems.  Defaults to `false`
	           */
	          gridOptions.useExternalPagination = gridOptions.useExternalPagination === true;
	
	          /**
	           * @ngdoc property
	           * @name useCustomPagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Disables client-side pagination. When true, handle the `paginationChanged` event and set `data`,
	           *              `firstRowIndex`, `lastRowIndex`, and `totalItems`.  Defaults to `false`.
	           */
	          gridOptions.useCustomPagination = gridOptions.useCustomPagination === true;
	
	          /**
	           * @ngdoc property
	           * @name totalItems
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Total number of items, set automatically when using client side pagination, but needs set by user
	           *              for server side pagination
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.totalItems)) {
	            gridOptions.totalItems = 0;
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSizes
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Array of page sizes, defaults to `[250, 500, 1000]`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSizes)) {
	            gridOptions.paginationPageSizes = [250, 500, 1000];
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSize
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Page size, defaults to the first item in paginationPageSizes, or 0 if paginationPageSizes is empty
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSize)) {
	            if (gridOptions.paginationPageSizes.length > 0) {
	              gridOptions.paginationPageSize = gridOptions.paginationPageSizes[0];
	            }
	            else {
	              gridOptions.paginationPageSize = 0;
	            }
	          }
	          /**
	           * @ngdoc property
	           * @name paginationCurrentPage
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Current page number, defaults to 1
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationCurrentPage)) {
	            gridOptions.paginationCurrentPage = 1;
	          }
	
	          /**
	           * @ngdoc property
	           * @name paginationTemplate
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description A custom template for the pager, defaults to `ui-grid/pagination`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationTemplate)) {
	            gridOptions.paginationTemplate = 'ui-grid/pagination';
	          }
	        },
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @name uiGridPaginationService
	         * @description  Raises paginationChanged and calls refresh for client side pagination
	         * @param {Grid} grid the grid for which the pagination changed
	         * @param {int} currentPage requested page number
	         * @param {int} pageSize requested page size
	         */
	        onPaginationChanged: function (grid, currentPage, pageSize) {
	          grid.api.pagination.raise.paginationChanged(currentPage, pageSize);
	          if (!grid.options.useExternalPagination) {
	            grid.queueGridRefresh(); // client side pagination
	          }
	        }
	      };
	
	      return service;
	    }
	  ]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPagination
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds pagination features to grid
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.pagination']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	        { name: 'Sam', car: 'Lexus' },
	        { name: 'Joe', car: 'Dodge' },
	        { name: 'Bob', car: 'Buick' },
	        { name: 'Cindy', car: 'Ford' },
	        { name: 'Brian', car: 'Audi' },
	        { name: 'Malcom', car: 'Mercedes Benz' },
	        { name: 'Dave', car: 'Ford' },
	        { name: 'Stacey', car: 'Audi' },
	        { name: 'Amy', car: 'Acura' },
	        { name: 'Scott', car: 'Toyota' },
	        { name: 'Ryan', car: 'BMW' },
	      ];
	
	      $scope.gridOptions = {
	        data: 'data',
	        paginationPageSizes: [5, 10, 25],
	        paginationPageSize: 5,
	        columnDefs: [
	          {name: 'name'},
	          {name: 'car'}
	        ]
	       }
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-pagination></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridPagination', ['gridUtil', 'uiGridPaginationService',
	    function (gridUtil, uiGridPaginationService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: 'uiGrid',
	        link: {
	          pre: function ($scope, $elm, $attr, uiGridCtrl) {
	            uiGridPaginationService.initializeGrid(uiGridCtrl.grid);
	
	            gridUtil.getTemplate(uiGridCtrl.grid.options.paginationTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                $elm.append(template);
	                uiGridCtrl.innerCompile(template);
	              });
	          }
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPager
	   *  @element div
	   *
	   *  @description Panel for handling pagination
	   */
	  module.directive('uiGridPager', ['uiGridPaginationService', 'uiGridConstants', 'gridUtil', 'i18nService', 'i18nConstants',
	    function (uiGridPaginationService, uiGridConstants, gridUtil, i18nService, i18nConstants) {
	      return {
	        priority: -200,
	        scope: true,
	        require: '^uiGrid',
	        link: function ($scope, $elm, $attr, uiGridCtrl) {
	          var defaultFocusElementSelector = '.ui-grid-pager-control-input';
	
	          $scope.aria = i18nService.getSafeText('pagination.aria'); // Returns an object with all of the aria labels
	
	          var updateLabels = function() {
	            $scope.paginationApi = uiGridCtrl.grid.api.pagination;
	            $scope.sizesLabel = i18nService.getSafeText('pagination.sizes');
	            $scope.totalItemsLabel = i18nService.getSafeText('pagination.totalItems');
	            $scope.paginationOf = i18nService.getSafeText('pagination.of');
	            $scope.paginationThrough = i18nService.getSafeText('pagination.through');
	          };
	
	          updateLabels();
	
	          $scope.$on(i18nConstants.UPDATE_EVENT, updateLabels);
	
	          var options = uiGridCtrl.grid.options;
	
	          uiGridCtrl.grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	            if (options.enablePaginationControls) {
	              adjustment.height = adjustment.height - gridUtil.elementHeight($elm, "padding");
	            }
	            return adjustment;
	          });
	
	          var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(function (grid) {
	            if (!grid.options.useExternalPagination) {
	              grid.options.totalItems = grid.rows.length;
	            }
	          }, [uiGridConstants.dataChange.ROW]);
	
	          $scope.$on('$destroy', dataChangeDereg);
	
	          var deregP = $scope.$watch('grid.options.paginationCurrentPage + grid.options.paginationPageSize', function (newValues, oldValues) {
	            if (newValues === oldValues || oldValues === undefined) {
	              return;
	            }
	
	            if (!angular.isNumber(options.paginationCurrentPage) || options.paginationCurrentPage < 1) {
	              options.paginationCurrentPage = 1;
	              return;
	            }
	
	            if (options.totalItems > 0 && options.paginationCurrentPage > $scope.paginationApi.getTotalPages()) {
	              options.paginationCurrentPage = $scope.paginationApi.getTotalPages();
	              return;
	            }
	
	            uiGridPaginationService.onPaginationChanged($scope.grid, options.paginationCurrentPage, options.paginationPageSize);
	          });
	
	          $scope.$on('$destroy', function() {
	            deregP();
	          });
	
	          $scope.cantPageForward = function () {
	            if ($scope.paginationApi.getTotalPages()) {
	              return $scope.cantPageToLast();
	            }
	            else {
	              return options.data.length < 1;
	            }
	          };
	
	          $scope.cantPageToLast = function () {
	            var totalPages = $scope.paginationApi.getTotalPages();
	
	            return !totalPages || options.paginationCurrentPage >= totalPages;
	          };
	
	          $scope.cantPageBackward = function () {
	            return options.paginationCurrentPage <= 1;
	          };
	
	          var focusToInputIf = function(condition) {
	            if (condition) {
	              gridUtil.focus.bySelector($elm, defaultFocusElementSelector);
	            }
	          };
	
	          // Takes care of setting focus to the middle element when focus is lost
	          $scope.pageFirstPageClick = function () {
	            $scope.paginationApi.seek(1);
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pagePreviousPageClick = function () {
	            $scope.paginationApi.previousPage();
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pageNextPageClick = function () {
	            $scope.paginationApi.nextPage();
	            focusToInputIf($scope.cantPageForward());
	          };
	
	          $scope.pageLastPageClick = function () {
	            $scope.paginationApi.seek($scope.paginationApi.getTotalPages());
	            focusToInputIf($scope.cantPageToLast());
	          };
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pinning
	   * @description
	   *
	   * # ui.grid.pinning
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides column pinning to the end user via menu options in the column header
	   *
	   * <div doc-module-components="ui.grid.pinning"></div>
	   */
	
	  var module = angular.module('ui.grid.pinning', ['ui.grid']);
	
	  module.constant('uiGridPinningConstants', {
	    container: {
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: ''
	    }
	  });
	
	  module.service('uiGridPinningService', ['gridUtil', 'GridRenderContainer', 'i18nService', 'uiGridPinningConstants', function (gridUtil, GridRenderContainer, i18nService, uiGridPinningConstants) {
	    var service = {
	
	      initializeGrid: function (grid) {
	        service.defaultGridOptions(grid.options);
	
	        // Register a column builder to add new menu items for pinning left and right
	        grid.registerColumnBuilder(service.pinningColumnBuilder);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:PublicApi
	         *
	         *  @description Public Api for pinning feature
	         */
	        var publicApi = {
	          events: {
	            pinning: {
	              /**
	               * @ngdoc event
	               * @name columnPinned
	               * @eventOf ui.grid.pinning.api:PublicApi
	               * @description raised when column pin state has changed
	               * <pre>
	               *   gridApi.pinning.on.columnPinned(scope, function(colDef){})
	               * </pre>
	               * @param {object} colDef the column that was changed
	               * @param {string} container the render container the column is in ('left', 'right', '')
	               */
	              columnPinned: function(colDef, container) {
	              }
	            }
	          },
	          methods: {
	            pinning: {
	              /**
	               * @ngdoc function
	               * @name pinColumn
	               * @methodOf ui.grid.pinning.api:PublicApi
	               * @description pin column left, right, or none
	               * <pre>
	               *   gridApi.pinning.pinColumn(col, uiGridPinningConstants.container.LEFT)
	               * </pre>
	               * @param {gridColumn} col the column being pinned
	               * @param {string} container one of the recognised types
	               * from uiGridPinningConstants
	               */
	              pinColumn: function(col, container) {
	                service.pinColumn(grid, col, container);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:GridOptions
	         *
	         *  @description GridOptions for pinning feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Enable pinning for the entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enablePinning = gridOptions.enablePinning !== false;
	        /**
	         *  @ngdoc object
	         *  @name hidePinLeft
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Hide Pin Left for the entire grid.
	         *  <br/>Defaults to false
	         */
	        gridOptions.hidePinLeft = gridOptions.enablePinning && gridOptions.hidePinLeft;
	        /**
	         *  @ngdoc object
	         *  @name hidePinRight
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Hide Pin Right pinning for the entire grid.
	         *  <br/>Defaults to false
	         */
	        gridOptions.hidePinRight = gridOptions.enablePinning && gridOptions.hidePinRight;
	      },
	
	      pinningColumnBuilder: function (colDef, col, gridOptions) {
	        // default to true unless gridOptions or colDef is explicitly false
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:ColumnDef
	         *
	         *  @description ColumnDef for pinning feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Enable pinning for the individual column.
	         *  <br/>Defaults to true
	         */
	        colDef.enablePinning = colDef.enablePinning === undefined ? gridOptions.enablePinning : colDef.enablePinning;
	        /**
	         *  @ngdoc object
	         *  @name hidePinLeft
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Hide Pin Left for the individual column.
	         *  <br/>Defaults to false
	         */
	        colDef.hidePinLeft = colDef.hidePinLeft === undefined ? gridOptions.hidePinLeft : colDef.hidePinLeft;
	        /**
	         *  @ngdoc object
	         *  @name hidePinRight
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Hide Pin Right for the individual column.
	         *  <br/>Defaults to false
	         */
	        colDef.hidePinRight = colDef.hidePinRight === undefined ? gridOptions.hidePinRight : colDef.hidePinRight;
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedLeft
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned left when grid is rendered
	         *  <br/>Defaults to false
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedRight
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned right when grid is rendered
	         *  <br/>Defaults to false
	         */
	        if (colDef.pinnedLeft) {
	          col.renderContainer = 'left';
	          col.grid.createLeftContainer();
	        }
	        else if (colDef.pinnedRight) {
	          col.renderContainer = 'right';
	          col.grid.createRightContainer();
	        }
	
	        if (!colDef.enablePinning) {
	          return;
	        }
	
	        var pinColumnLeftAction = {
	          name: 'ui.grid.pinning.pinLeft',
	          title: i18nService.get().pinning.pinLeft,
	          icon: 'ui-grid-icon-left-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'left';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.LEFT);
	          }
	        };
	
	        var pinColumnRightAction = {
	          name: 'ui.grid.pinning.pinRight',
	          title: i18nService.get().pinning.pinRight,
	          icon: 'ui-grid-icon-right-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'right';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.RIGHT);
	          }
	        };
	
	        var removePinAction = {
	          name: 'ui.grid.pinning.unpin',
	          title: i18nService.get().pinning.unpin,
	          icon: 'ui-grid-icon-cancel',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) !== 'undefined' && this.context.col.renderContainer !== null && this.context.col.renderContainer !== 'body';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.NONE);
	          }
	        };
	
	        // Skip from menu if hidePinLeft or hidePinRight is true
	        if (!colDef.hidePinLeft && !gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinLeft')) {
	          col.menuItems.push(pinColumnLeftAction);
	        }
	        if (!colDef.hidePinRight && !gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinRight')) {
	          col.menuItems.push(pinColumnRightAction);
	        }
	        if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.unpin')) {
	          col.menuItems.push(removePinAction);
	        }
	      },
	
	      pinColumn: function(grid, col, container) {
	        if (container === uiGridPinningConstants.container.NONE) {
	          col.renderContainer = null;
	          col.colDef.pinnedLeft = col.colDef.pinnedRight = false;
	        }
	        else {
	          col.renderContainer = container;
	          if (container === uiGridPinningConstants.container.LEFT) {
	            grid.createLeftContainer();
	          }
	          else if (container === uiGridPinningConstants.container.RIGHT) {
	            grid.createRightContainer();
	          }
	        }
	
	        grid.refresh()
	        .then(function() {
	          grid.api.pinning.raise.columnPinned( col.colDef, container );
	        });
	      }
	    };
	
	    return service;
	  }]);
	
	  module.directive('uiGridPinning', ['gridUtil', 'uiGridPinningService',
	    function (gridUtil, uiGridPinningService) {
	      return {
	        require: 'uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridPinningService.initializeGrid(uiGridCtrl.grid);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.resizeColumns
	   * @description
	   *
	   * # ui.grid.resizeColumns
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module allows columns to be resized.
	   */
	  var module = angular.module('ui.grid.resizeColumns', ['ui.grid']);
	
	  module.service('uiGridResizeColumnsService', ['gridUtil', '$q', '$rootScope',
	    function (gridUtil, $q, $rootScope) {
	      return {
	        defaultGridOptions: function(gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:GridOptions
	           *
	           *  @description GridOptions for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:GridOptions
	           *  @description Enable column resizing on the entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableColumnResizing = gridOptions.enableColumnResizing !== false;
	
	          // legacy support
	          // use old name if it is explicitly false
	          if (gridOptions.enableColumnResize === false) {
	            gridOptions.enableColumnResizing = false;
	          }
	        },
	
	        colResizerColumnBuilder: function (colDef, col, gridOptions) {
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:ColumnDef
	           *
	           *  @description ColumnDef for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:ColumnDef
	           *  @description Enable column resizing on an individual column
	           *  <br/>Defaults to GridOptions.enableColumnResizing
	           */
	          // default to true unless gridOptions or colDef is explicitly false
	          colDef.enableColumnResizing = colDef.enableColumnResizing === undefined ? gridOptions.enableColumnResizing : colDef.enableColumnResizing;
	
	
	          // legacy support of old option name
	          if (colDef.enableColumnResize === false) {
	            colDef.enableColumnResizing = false;
	          }
	
	          return $q.all(promises);
	        },
	
	        registerPublicApi: function (grid) {
	            /**
	             *  @ngdoc object
	             *  @name ui.grid.resizeColumns.api:PublicApi
	             *  @description Public Api for column resize feature.
	             */
	            var publicApi = {
	              events: {
	                /**
	                 * @ngdoc event
	                 * @name columnSizeChanged
	                 * @eventOf  ui.grid.resizeColumns.api:PublicApi
	                 * @description raised when column is resized
	                 * <pre>
	                 *      gridApi.colResizable.on.columnSizeChanged(scope,function(colDef, deltaChange) {})
	                 * </pre>
	                 * @param {object} colDef the column that was resized
	                 * @param {integer} delta of the column size change
	                 */
	                colResizable: {
	                  columnSizeChanged: function (colDef, deltaChange) {
	                  }
	                }
	              }
	            };
	            grid.api.registerEventsFromObject(publicApi.events);
	        },
	
	        fireColumnSizeChanged: function (grid, colDef, deltaChange) {
	          $rootScope.$applyAsync(function () {
	            if ( grid.api.colResizable ) {
	              grid.api.colResizable.raise.columnSizeChanged(colDef, deltaChange);
	            } else {
	              gridUtil.logError("The resizeable api is not registered, this may indicate that you've included the module but not added the 'ui-grid-resize-columns' directive to your grid definition.  Cannot raise any events.");
	            }
	          });
	        },
	
	        // get either this column, or the column next to this column, to resize,
	        // returns the column we're going to resize
	        findTargetCol: function(col, position, rtlMultiplier) {
	          var renderContainer = col.getRenderContainer();
	
	          if (position === 'left') {
	            // Get the column to the left of this one
	            var colIndex = renderContainer.visibleColumnCache.indexOf(col);
	            if (colIndex === 0) {
	              return renderContainer.visibleColumnCache[0];
	            }
	            return renderContainer.visibleColumnCache[colIndex - 1 * rtlMultiplier];
	          } else {
	            return col;
	          }
	        }
	      };
	    }]);
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridResizeColumns
	   * @element div
	   * @restrict A
	   * @description
	   * Enables resizing for all columns on the grid. If, for some reason, you want to use the ui-grid-resize-columns directive, but not allow column resizing, you can explicitly set the
	   * option to false. This prevents resizing for the entire grid, regardless of individual columnDef options.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <div class="testGrid" ui-grid="gridOpts" ui-grid-resize-columns ></div>
	   </div>
	   </doc:source>
	   <doc:scenario>
	
	   </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridResizeColumns', ['gridUtil', 'uiGridResizeColumnsService', function (gridUtil, uiGridResizeColumnsService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridResizeColumnsService.defaultGridOptions(uiGridCtrl.grid.options);
	            uiGridCtrl.grid.registerColumnBuilder( uiGridResizeColumnsService.colResizerColumnBuilder);
	            uiGridResizeColumnsService.registerPublicApi(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  // Extend the uiGridHeaderCell directive
	  module.directive('uiGridHeaderCell', ['gridUtil', '$templateCache', '$compile', '$q', 'uiGridResizeColumnsService', 'uiGridConstants', function (gridUtil, $templateCache, $compile, $q, uiGridResizeColumnsService, uiGridConstants) {
	    return {
	      // Run after the original uiGridHeaderCell
	      priority: -10,
	      require: '^uiGrid',
	      // scope: false,
	      compile: function() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var grid = uiGridCtrl.grid;
	
	            if (grid.options.enableColumnResizing) {
	              var columnResizerElm = $templateCache.get('ui-grid/columnResizer');
	
	              var rtlMultiplier = 1;
	              // when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	              if (grid.isRTL()) {
	                $scope.position = 'left';
	                rtlMultiplier = -1;
	              }
	
	              var displayResizers = function() {
	
	                // remove any existing resizers.
	                var resizers = $elm[0].getElementsByClassName('ui-grid-column-resizer');
	                for ( var i = 0; i < resizers.length; i++ ) {
	                  angular.element(resizers[i]).remove();
	                }
	
	                // get the target column for the left resizer
	                var otherCol = uiGridResizeColumnsService.findTargetCol($scope.col, 'left', rtlMultiplier);
	                var renderContainer = $scope.col.getRenderContainer();
	
	                // Don't append the left resizer if this is the first column or the column to the left of this one has resizing disabled
	                if (otherCol && renderContainer.visibleColumnCache.indexOf($scope.col) !== 0 && otherCol.colDef.enableColumnResizing !== false) {
	                  var resizerLeft = angular.element(columnResizerElm).clone();
	                  resizerLeft.attr('position', 'left');
	
	                  $elm.prepend(resizerLeft);
	                  $compile(resizerLeft)($scope);
	                }
	
	                // Don't append the right resizer if this column has resizing disabled
	                if ($scope.col.colDef.enableColumnResizing !== false) {
	                  var resizerRight = angular.element(columnResizerElm).clone();
	                  resizerRight.attr('position', 'right');
	
	                  $elm.append(resizerRight);
	                  $compile(resizerRight)($scope);
	                }
	              };
	
	              displayResizers();
	
	              var waitDisplay = function() {
	                $scope.$applyAsync(displayResizers);
	              };
	
	              var dataChangeDereg = grid.registerDataChangeCallback( waitDisplay, [uiGridConstants.dataChange.COLUMN] );
	
	              $scope.$on( '$destroy', dataChangeDereg );
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridColumnResizer
	   * @element div
	   * @restrict A
	   *
	   * @description
	   * Draggable handle that controls column resizing.
	   *
	   * @example
	   <doc:example module="app">
	     <doc:source>
	       <script>
	        var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            enableColumnResizing: true,
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	       </script>
	
	       <div ng-controller="MainCtrl">
	        <div class="testGrid" ui-grid="gridOpts"></div>
	       </div>
	     </doc:source>
	     <doc:scenario>
	      // TODO: e2e specs?
	
	      // TODO: post-resize a horizontal scroll event should be fired
	     </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridColumnResizer', ['$document', 'gridUtil', 'uiGridConstants', 'uiGridResizeColumnsService', function ($document, gridUtil, uiGridConstants, uiGridResizeColumnsService) {
	    var resizeOverlay = angular.element('<div class="ui-grid-resize-overlay"></div>');
	
	    return {
	      priority: 0,
	      scope: {
	        col: '=',
	        position: '@',
	        renderIndex: '='
	      },
	      require: '?^uiGrid',
	      link: function ($scope, $elm, $attrs, uiGridCtrl) {
	        var startX = 0,
	            x = 0,
	            gridLeft = 0,
	            rtlMultiplier = 1;
	
	        // when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	        if (uiGridCtrl.grid.isRTL()) {
	          $scope.position = 'left';
	          rtlMultiplier = -1;
	        }
	
	        if ($scope.position === 'left') {
	          $elm.addClass('left');
	        }
	        else if ($scope.position === 'right') {
	          $elm.addClass('right');
	        }
	
	        // Refresh the grid canvas
	        //   takes an argument representing the diff along the X-axis that the resize had
	        function refreshCanvas(xDiff) {
	          // Then refresh the grid canvas, rebuilding the styles so that the scrollbar updates its size
	          uiGridCtrl.grid.refreshCanvas(true).then( function() {
	            uiGridCtrl.grid.queueGridRefresh();
	          });
	        }
	
	        // Check that the requested width isn't wider than the maxWidth, or narrower than the minWidth
	        // Returns the new recommended with, after constraints applied
	        function constrainWidth(col, width) {
	          var newWidth = width;
	
	          // If the new width would be less than the column's allowably minimum width, don't allow it
	          if (col.minWidth && newWidth < col.minWidth) {
	            newWidth = col.minWidth;
	          }
	          else if (col.maxWidth && newWidth > col.maxWidth) {
	            newWidth = col.maxWidth;
	          }
	
	          return newWidth;
	        }
	
	
	        /*
	         * Our approach to event handling aims to deal with both touch devices and mouse devices
	         * We register down handlers on both touch and mouse.  When a touchstart or mousedown event
	         * occurs, we register the corresponding touchmove/touchend, or mousemove/mouseend events.
	         *
	         * This way we can listen for both without worrying about the fact many touch devices also emulate
	         * mouse events - basically whichever one we hear first is what we'll go with.
	         */
	        function moveFunction(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          x = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          if (x < 0) { x = 0; }
	          else if (x > uiGridCtrl.grid.gridWidth) { x = uiGridCtrl.grid.gridWidth; }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          if (!uiGridCtrl.grid.element.hasClass('column-resizing')) {
	            uiGridCtrl.grid.element.addClass('column-resizing');
	          }
	
	          // Get the diff along the X axis
	          var xDiff = x - startX;
	
	          // Get the width that this mouse would give the column
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          x = x + ( constrainWidth(col, newWidth) - newWidth ) * rtlMultiplier;
	
	          resizeOverlay.css({ left: x + 'px' });
	
	          uiGridCtrl.fireEvent(uiGridConstants.events.ITEM_DRAGGING);
	        }
	
	
	        function upFunction(event) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          uiGridCtrl.grid.element.removeClass('column-resizing');
	
	          resizeOverlay.remove();
	
	          // Resize the column
	          x = (event.changedTouches ? event.changedTouches[0] : event).clientX - gridLeft;
	          var xDiff = x - startX;
	
	          if (xDiff === 0) {
	            // no movement, so just reset event handlers, including turning back on both
	            // down events - we turned one off when this event started
	            offAllEvents();
	            onDownEvents();
	            return;
	          }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Get the new width
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          col.width = constrainWidth(col, newWidth);
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);
	
	          // stop listening of up and move events - wait for next down
	          // reset the down events - we will have turned one off when this event started
	          offAllEvents();
	          onDownEvents();
	        }
	
	
	        var downFunction = function(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.stopPropagation();
	
	          // Get the left offset of the grid
	          // gridLeft = uiGridCtrl.grid.element[0].offsetLeft;
	          gridLeft = uiGridCtrl.grid.element[0].getBoundingClientRect().left;
	
	          // Get the starting X position, which is the X coordinate of the click minus the grid's offset
	          startX = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          // Append the resizer overlay
	          uiGridCtrl.grid.element.append(resizeOverlay);
	
	          // Place the resizer overlay at the start position
	          resizeOverlay.css({ left: startX });
	
	          // Add handlers for move and up events - if we were mousedown then we listen for mousemove and mouseup, if
	          // we were touchdown then we listen for touchmove and touchup.  Also remove the handler for the equivalent
	          // down event - so if we're touchdown, then remove the mousedown handler until this event is over, if we're
	          // mousedown then remove the touchdown handler until this event is over, this avoids processing duplicate events
	          if ( event.type === 'touchstart' ) {
	            $document.on('touchend', upFunction);
	            $document.on('touchmove', moveFunction);
	            $elm.off('mousedown', downFunction);
	          }
	          else {
	            $document.on('mouseup', upFunction);
	            $document.on('mousemove', moveFunction);
	            $elm.off('touchstart', downFunction);
	          }
	        };
	
	        var onDownEvents = function() {
	          $elm.on('mousedown', downFunction);
	          $elm.on('touchstart', downFunction);
	        };
	
	        var offAllEvents = function() {
	          $document.off('mouseup', upFunction);
	          $document.off('touchend', upFunction);
	          $document.off('mousemove', moveFunction);
	          $document.off('touchmove', moveFunction);
	          $elm.off('mousedown', downFunction);
	          $elm.off('touchstart', downFunction);
	        };
	
	        onDownEvents();
	
	
	        // On doubleclick, resize to fit all rendered cells
	        var dblClickFn = function(event, args) {
	          event.stopPropagation();
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Go through the rendered rows and find out the max size for the data in this column
	          var maxWidth = 0;
	
	          // Get the parent render container element
	          var renderContainerElm = gridUtil.closestElm($elm, '.ui-grid-render-container');
	
	          // Get the cell contents so we measure correctly. For the header cell we have to account for the sort icon and the menu buttons, if present
	          var cells = renderContainerElm.querySelectorAll('.' + uiGridConstants.COL_CLASS_PREFIX + col.uid + ' .ui-grid-cell-contents');
	          Array.prototype.forEach.call(cells, function (cell) {
	              // Get the cell width
	              // gridUtil.logDebug('width', gridUtil.elementWidth(cell));
	
	              // Account for the menu button if it exists
	              var menuButton;
	              if (angular.element(cell).parent().hasClass('ui-grid-header-cell')) {
	                menuButton = angular.element(cell).parent()[0].querySelectorAll('.ui-grid-column-menu-button');
	              }
	
	              gridUtil.fakeElement(cell, {}, function(newElm) {
	                // Make the element float since it's a div and can expand to fill its container
	                var e = angular.element(newElm);
	                e.attr('style', 'float: left');
	
	                var width = gridUtil.elementWidth(e);
	
	                if (menuButton) {
	                  var menuButtonWidth = gridUtil.elementWidth(menuButton);
	                  width = width + menuButtonWidth;
	                }
	
	                if (width > maxWidth) {
	                  maxWidth = width;
	                }
	              });
	            });
	
	          // check we're not outside the allowable bounds for this column
	          var newWidth = constrainWidth(col, maxWidth);
	          var xDiff = newWidth - col.drawnWidth;
	          col.width = newWidth;
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);        };
	        $elm.on('dblclick', dblClickFn);
	
	        $elm.on('$destroy', function() {
	          $elm.off('dblclick', dblClickFn);
	          offAllEvents();
	        });
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.rowEdit
	   * @description
	   *
	   * # ui.grid.rowEdit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module extends the edit feature to provide tracking and saving of rows
	   * of data.  The tutorial provides more information on how this feature is best
	   * used {@link tutorial/205_row_editable here}.
	   * <br/>
	   * This feature depends on usage of the ui-grid-edit feature, and also benefits
	   * from use of ui-grid-cellNav to provide the full spreadsheet-like editing
	   * experience
	   *
	   */
	
	  var module = angular.module('ui.grid.rowEdit', ['ui.grid', 'ui.grid.edit', 'ui.grid.cellNav']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.rowEdit.constant:uiGridRowEditConstants
	   *
	   *  @description constants available in row edit module
	   */
	  module.constant('uiGridRowEditConstants', {
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.rowEdit.service:uiGridRowEditService
	   *
	   *  @description Services for row editing features
	   */
	  module.service('uiGridRowEditService', ['$interval', '$q', 'uiGridConstants', 'uiGridRowEditConstants', 'gridUtil',
	    function ($interval, $q, uiGridConstants, uiGridRowEditConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (scope, grid) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:PublicApi
	           *
	           *  @description Public Api for rowEdit feature
	           */
	
	          grid.rowEdit = {};
	
	          var publicApi = {
	            events: {
	              rowEdit: {
	                /**
	                 * @ngdoc event
	                 * @eventOf ui.grid.rowEdit.api:PublicApi
	                 * @name saveRow
	                 * @description raised when a row is ready for saving.  Once your
	                 * row has saved you may need to use angular.extend to update the
	                 * data entity with any changed data from your save (for example,
	                 * lock version information if you're using optimistic locking,
	                 * or last update time/user information).
	                 *
	                 * Your method should call setSavePromise somewhere in the body before
	                 * returning control.  The feature will then wait, with the gridRow greyed out
	                 * whilst this promise is being resolved.
	                 *
	                 * <pre>
	                 *      gridApi.rowEdit.on.saveRow(scope,function(rowEntity) {})
	                 * </pre>
	                 * and somewhere within the event handler:
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise( rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @returns {promise} Your saveRow method should return a promise, the
	                 * promise should either be resolved (implying successful save), or
	                 * rejected (implying an error).
	                 */
	                saveRow: function (rowEntity) {
	                }
	              }
	            },
	            methods: {
	              rowEdit: {
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setSavePromise
	                 * @description Sets the promise associated with the row save, mandatory that
	                 * the saveRow event handler calls this method somewhere before returning.
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise(rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity a data row from the grid for which a save has
	                 * been initiated
	                 * @param {promise} savePromise the promise that will be resolved when the
	                 * save is successful, or rejected if the save fails
	                 *
	                 */
	                setSavePromise: function ( rowEntity, savePromise) {
	                  service.setSavePromise(grid, rowEntity, savePromise);
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getDirtyRows
	                 * @description Returns all currently dirty rows
	                 * <pre>
	                 *      gridApi.rowEdit.getDirtyRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently dirty
	                 *
	                 */
	                getDirtyRows: function () {
	                  return grid.rowEdit.dirtyRows ? grid.rowEdit.dirtyRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getErrorRows
	                 * @description Returns all currently errored rows
	                 * <pre>
	                 *      gridApi.rowEdit.getErrorRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently in error
	                 *
	                 */
	                getErrorRows: function () {
	                  return grid.rowEdit.errorRows ? grid.rowEdit.errorRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name flushDirtyRows
	                 * @description Triggers a save event for all currently dirty rows, could
	                 * be used where user presses a save button or navigates away from the page
	                 * <pre>
	                 *      gridApi.rowEdit.flushDirtyRows(grid)
	                 * </pre>
	                 * @returns {promise} a promise that represents the aggregate of all
	                 * of the individual save promises - i.e. it will be resolved when all
	                 * the individual save promises have been resolved.
	                 *
	                 */
	                flushDirtyRows: function () {
	                  return service.flushDirtyRows(grid);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsDirty
	                 * @description Sets each of the rows passed in dataRows
	                 * to be dirty. Note that if you have only just inserted the
	                 * rows into your data you will need to wait for a $digest cycle
	                 * before the gridRows are present - so often you would wrap this
	                 * call in a $interval or $timeout. Also, you must pass row.entity
	                 * into this function rather than row objects themselves.
	                 * <pre>
	                 *      $interval( function() {
	                 *        gridApi.rowEdit.setRowsDirty(myDataRows);
	                 *      }, 0, 1);
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set dirty.
	                 *
	                 */
	                setRowsDirty: function ( dataRows) {
	                  service.setRowsDirty(grid, dataRows);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsClean
	                 * @description Sets each of the rows passed in dataRows
	                 * to be clean, removing them from the dirty cache and the error cache,
	                 * and clearing the error flag and the dirty flag
	                 * <pre>
	                 *      var gridRows = $scope.gridApi.rowEdit.getDirtyRows();
	                 *      var dataRows = gridRows.map( function( gridRow ) { return gridRow.entity; });
	                 *      $scope.gridApi.rowEdit.setRowsClean( dataRows );
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set clean.
	                 *
	                 */
	                setRowsClean: function ( dataRows) {
	                  service.setRowsClean(grid, dataRows);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          grid.api.core.on.renderingComplete( scope, function ( gridApi ) {
	            grid.api.edit.on.afterCellEdit( scope, service.endEditCell );
	            grid.api.edit.on.beginCellEdit( scope, service.beginEditCell );
	            grid.api.edit.on.cancelCellEdit( scope, service.cancelEditCell );
	
	            if ( grid.api.cellNav ) {
	              grid.api.cellNav.on.navigate( scope, service.navigate );
	            }
	          });
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:GridOptions
	           *
	           *  @description Options for configuring the rowEdit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name saveRow
	         * @description  Returns a function that saves the specified row from the grid,
	         * and returns a promise
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @param {GridRow} gridRow the row that should be saved
	         * @returns {function} the saveRow function returns a function.  That function
	         * in turn, when called, returns a promise relating to the save callback
	         */
	        saveRow: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            gridRow.isSaving = true;
	
	            if ( gridRow.rowEditSavePromise ) {
	              // don't save the row again if it's already saving - that causes stale object exceptions
	              return gridRow.rowEditSavePromise;
	            }
	
	            var promise = grid.api.rowEdit.raise.saveRow( gridRow.entity );
	
	            if ( gridRow.rowEditSavePromise ) {
	              gridRow.rowEditSavePromise.then( self.processSuccessPromise( grid, gridRow ), self.processErrorPromise( grid, gridRow ));
	            } else {
	              gridUtil.logError( 'A promise was not returned when saveRow event was raised, either nobody is listening to event, or event handler did not return a promise' );
	            }
	            return promise;
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf  ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setSavePromise
	         * @description Sets the promise associated with the row save, mandatory that
	         * the saveRow event handler calls this method somewhere before returning.
	         * <pre>
	         *      gridApi.rowEdit.setSavePromise(grid, rowEntity)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be returned
	         * @param {object} rowEntity a data row from the grid for which a save has
	         * been initiated
	         * @param {promise} savePromise the promise that will be resolved when the
	         * save is successful, or rejected if the save fails
	         *
	         */
	        setSavePromise: function (grid, rowEntity, savePromise) {
	          var gridRow = grid.getRow( rowEntity );
	          gridRow.rowEditSavePromise = savePromise;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processSuccessPromise
	         * @description  Returns a function that processes the successful
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that has been saved
	         * @returns {function} the success handling function
	         */
	        processSuccessPromise: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.isDirty;
	            delete gridRow.isError;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	            self.removeRow( grid.rowEdit.errorRows, gridRow );
	            self.removeRow( grid.rowEdit.dirtyRows, gridRow );
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processErrorPromise
	         * @description  Returns a function that processes the failed
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that is now in error
	         * @returns {function} the error handling function
	         */
	        processErrorPromise: function ( grid, gridRow ) {
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	
	            gridRow.isError = true;
	
	            if (!grid.rowEdit.errorRows) {
	              grid.rowEdit.errorRows = [];
	            }
	            if (!service.isRowPresent( grid.rowEdit.errorRows, gridRow ) ) {
	              grid.rowEdit.errorRows.push( gridRow );
	            }
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name removeRow
	         * @description  Removes a row from a cache of rows - either
	         * grid.rowEdit.errorRows or grid.rowEdit.dirtyRows.  If the row
	         * is not present silently does nothing.
	         * @param {array} rowArray the array from which to remove the row
	         * @param {GridRow} gridRow the row that should be removed
	         */
	        removeRow: function( rowArray, removeGridRow ) {
	          if (typeof(rowArray) === 'undefined' || rowArray === null) {
	            return;
	          }
	
	          rowArray.forEach( function( gridRow, index ) {
	            if ( gridRow.uid === removeGridRow.uid ) {
	              rowArray.splice( index, 1);
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name isRowPresent
	         * @description  Checks whether a row is already present
	         * in the given array
	         * @param {array} rowArray the array in which to look for the row
	         * @param {GridRow} gridRow the row that should be looked for
	         */
	        isRowPresent: function( rowArray, removeGridRow ) {
	          var present = false;
	          rowArray.forEach( function( gridRow, index ) {
	            if ( gridRow.uid === removeGridRow.uid ) {
	              present = true;
	            }
	          });
	          return present;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name flushDirtyRows
	         * @description Triggers a save event for all currently dirty rows, could
	         * be used where user presses a save button or navigates away from the page
	         * <pre>
	         *      gridApi.rowEdit.flushDirtyRows(grid)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @returns {promise} a promise that represents the aggregate of all
	         * of the individual save promises - i.e. it will be resolved when all
	         * the individual save promises have been resolved.
	         *
	         */
	        flushDirtyRows: function(grid) {
	          var promises = [];
	          grid.api.rowEdit.getDirtyRows().forEach( function( gridRow ) {
	            service.cancelTimer( grid, gridRow );
	            service.saveRow( grid, gridRow )();
	            promises.push( gridRow.rowEditSavePromise );
	          });
	
	          return $q.all( promises );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name endEditCell
	         * @description Receives an afterCellEdit event from the edit function,
	         * and sets flags as appropriate.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * was edited
	         */
	        endEditCell: function( rowEntity, colDef, newValue, previousValue ) {
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ) { gridUtil.logError( 'Unable to find rowEntity in grid data, dirty flag cannot be set' ); return; }
	
	          if ( newValue !== previousValue || gridRow.isDirty ) {
	            if ( !grid.rowEdit.dirtyRows ) {
	              grid.rowEdit.dirtyRows = [];
	            }
	
	            if ( !gridRow.isDirty ) {
	              gridRow.isDirty = true;
	              grid.rowEdit.dirtyRows.push( gridRow );
	            }
	
	            delete gridRow.isError;
	
	            service.considerSetTimer( grid, gridRow );
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name beginEditCell
	         * @description Receives a beginCellEdit event from the edit function,
	         * and cancels any rowEditSaveTimers if present, as the user is still editing
	         * this row.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * editing has commenced
	         */
	        beginEditCell: function( rowEntity, colDef ) {
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ) { gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be cancelled' ); return; }
	
	          service.cancelTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelEditCell
	         * @description Receives a cancelCellEdit event from the edit function,
	         * and if the row was already dirty, restarts the save timer.  If the row
	         * was not already dirty, then it's not dirty now either and does nothing.
	         *
	         * Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         *
	         * @param {object} rowEntity the data entity for which the cell
	         * editing was cancelled
	         */
	        cancelEditCell: function( rowEntity, colDef ) {
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ) { gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be set' ); return; }
	
	          service.considerSetTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name navigate
	         * @description cellNav tells us that the selected cell has changed.  If
	         * the new row had a timer running, then stop it similar to in a beginCellEdit
	         * call.  If the old row is dirty and not the same as the new row, then
	         * start a timer on it.
	         * @param {object} newRowCol the row and column that were selected
	         * @param {object} oldRowCol the row and column that was left
	         *
	         */
	        navigate: function( newRowCol, oldRowCol ) {
	          var grid = this.grid;
	          if ( newRowCol.row.rowEditSaveTimer ) {
	            service.cancelTimer( grid, newRowCol.row );
	          }
	
	          if ( oldRowCol && oldRowCol.row && oldRowCol.row !== newRowCol.row ) {
	            service.considerSetTimer( grid, oldRowCol.row );
	          }
	        },
	
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.rowEdit.api:GridOptions
	         * @name rowEditWaitInterval
	         * @description How long the grid should wait for another change on this row
	         * before triggering a save (in milliseconds).  If set to -1, then saves are
	         * never triggered by timer (implying that the user will call flushDirtyRows()
	         * manually)
	         *
	         * @example
	         * Setting the wait interval to 4 seconds
	         * <pre>
	         *   $scope.gridOptions = { rowEditWaitInterval: 4000 }
	         * </pre>
	         *
	         */
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name considerSetTimer
	         * @description Consider setting a timer on this row (if it is dirty).  if there is a timer running
	         * on the row and the row isn't currently saving, cancel it, using cancelTimer, then if the row is
	         * dirty and not currently saving then set a new timer
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        considerSetTimer: function( grid, gridRow ) {
	          service.cancelTimer( grid, gridRow );
	
	          if ( gridRow.isDirty && !gridRow.isSaving ) {
	            if ( grid.options.rowEditWaitInterval !== -1 ) {
	              var waitTime = grid.options.rowEditWaitInterval ? grid.options.rowEditWaitInterval : 2000;
	              gridRow.rowEditSaveTimer = $interval( service.saveRow( grid, gridRow ), waitTime, 1);
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelTimer
	         * @description cancel the $interval for any timer running on this row
	         * then delete the timer itself
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        cancelTimer: function( grid, gridRow ) {
	          if ( gridRow.rowEditSaveTimer && !gridRow.isSaving ) {
	            $interval.cancel(gridRow.rowEditSaveTimer);
	            delete gridRow.rowEditSaveTimer;
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsDirty
	         * @description Sets each of the rows passed in dataRows
	         * to be dirty.  note that if you have only just inserted the
	         * rows into your data you will need to wait for a $digest cycle
	         * before the gridRows are present - so often you would wrap this
	         * call in a $interval or $timeout
	         * <pre>
	         *      $interval( function() {
	         *        gridApi.rowEdit.setRowsDirty( myDataRows);
	         *      }, 0, 1);
	         * </pre>
	         * @param {object} grid the grid for which rows should be set dirty
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set dirty.
	         *
	         */
	        setRowsDirty: function( grid, myDataRows ) {
	          var gridRow;
	          myDataRows.forEach( function( value, index ) {
	            gridRow = grid.getRow( value );
	            if ( gridRow ) {
	              if ( !grid.rowEdit.dirtyRows ) {
	                grid.rowEdit.dirtyRows = [];
	              }
	
	              if ( !gridRow.isDirty ) {
	                gridRow.isDirty = true;
	                grid.rowEdit.dirtyRows.push( gridRow );
	              }
	
	              delete gridRow.isError;
	
	              service.considerSetTimer( grid, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsDirty, row was: " + value );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsClean
	         * @description Sets each of the rows passed in dataRows
	         * to be clean, clearing the dirty flag and the error flag, and removing
	         * the rows from the dirty and error caches.
	         * @param {object} grid the grid for which rows should be set clean
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set clean.
	         *
	         */
	        setRowsClean: function( grid, myDataRows ) {
	          var gridRow;
	
	          myDataRows.forEach( function( value, index ) {
	            gridRow = grid.getRow( value );
	            if ( gridRow ) {
	              delete gridRow.isDirty;
	              service.removeRow( grid.rowEdit.dirtyRows, gridRow );
	              service.cancelTimer( grid, gridRow );
	
	              delete gridRow.isError;
	              service.removeRow( grid.rowEdit.errorRows, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsClean, row was: " + value );
	            }
	          });
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds row editing features to the ui-grid-edit directive.
	   *
	   */
	  module.directive('uiGridRowEdit', ['gridUtil', 'uiGridRowEditService', 'uiGridEditConstants',
	  function (gridUtil, uiGridRowEditService, uiGridEditConstants) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridRowEditService.initializeGrid($scope, uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row to allow coloring of saving and error rows
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'uiGridConstants', 'gridUtil', '$parse',
	      function ($compile, uiGridConstants, gridUtil, $parse) {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	            var existingNgClass = rowRepeatDiv.attr("ng-class");
	            var newNgClass = '';
	            if ( existingNgClass ) {
	              newNgClass = existingNgClass.slice(0, -1) + ", 'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            } else {
	              newNgClass = "{'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            }
	            rowRepeatDiv.attr("ng-class", newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.saveState
	   * @description
	   *
	   * # ui.grid.saveState
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to save the grid state, and restore
	   * it when the user returns to the page.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate. Usually the navigate events would be used to save
	   * the grid state and restore it.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.save-state"></div>
	   */
	
	  var module = angular.module('ui.grid.saveState', ['ui.grid', 'ui.grid.selection', 'ui.grid.cellNav', 'ui.grid.grouping', 'ui.grid.pinning', 'ui.grid.treeView']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.saveState.constant:uiGridSaveStateConstants
	   *
	   *  @description constants available in save state module
	   */
	
	  module.constant('uiGridSaveStateConstants', {
	    featureName: 'saveState'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.saveState.service:uiGridSaveStateService
	   *
	   *  @description Services for saveState feature
	   */
	  module.service('uiGridSaveStateService',
	    function () {
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          // add feature namespace and any properties to grid for needed state
	          grid.saveState = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.saveState.api:PublicApi
	           *
	           *  @description Public Api for saveState feature
	           */
	          var publicApi = {
	            events: {
	              saveState: {
	              }
	            },
	            methods: {
	              saveState: {
	                /**
	                 * @ngdoc function
	                 * @name save
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Packages the current state of the grid into
	                 * an object, and provides it to the user for saving
	                 * @returns {object} the state as a javascript object that can be saved
	                 */
	                save: function () {
	                  return service.save(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name restore
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Restores the provided state into the grid
	                 * @param {scope} $scope a scope that we can broadcast on
	                 * @param {object} state the state that should be restored into the grid
	                 * @returns {object} the promise created by refresh
	                 */
	                restore: function ( $scope, state) {
	                  return service.restore(grid, $scope, state);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.saveState.api:GridOptions
	           *
	           * @description GridOptions for saveState feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name saveWidths
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current column widths.  Note that unless
	           * you've provided the user with some way to resize their columns (say
	           * the resize columns feature), then this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveWidths = gridOptions.saveWidths !== false;
	          /**
	           * @ngdoc object
	           * @name saveOrder
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Restore the current column order.  Note that unless
	           * you've provided the user with some way to reorder their columns (for
	           * example the move columns feature), this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveOrder = gridOptions.saveOrder !== false;
	          /**
	           * @ngdoc object
	           * @name saveScroll
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current scroll position.  Note that this
	           * is saved as the percentage of the grid scrolled - so if your
	           * user returns to a grid with a significantly different number of
	           * rows (perhaps some data has been deleted) then the scroll won't
	           * actually show the same rows as before.  If you want to scroll to
	           * a specific row then you should instead use the saveFocus option, which
	           * is the default.
	           *
	           * Note that this element will only be saved if the cellNav feature is
	           * enabled
	           * <br/>Defaults to false
	           */
	          gridOptions.saveScroll = gridOptions.saveScroll === true;
	          /**
	           * @ngdoc object
	           * @name saveFocus
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current focused cell.  On returning
	           * to this focused cell we'll also scroll.  This option is
	           * preferred to the saveScroll option, so is set to true by
	           * default.  If saveScroll is set to true then this option will
	           * be disabled.
	           *
	           * By default this option saves the current row number and column
	           * number, and returns to that row and column.  However, if you define
	           * a saveRowIdentity function, then it will return you to the currently
	           * selected column within that row (in a business sense - so if some
	           * rows have been deleted, it will still find the same data, presuming it
	           * still exists in the list.  If it isn't in the list then it will instead
	           * return to the same row number - i.e. scroll percentage)
	           *
	           * Note that this option will do nothing if the cellNav
	           * feature is not enabled.
	           *
	           * <br/>Defaults to true (unless saveScroll is true)
	           */
	          gridOptions.saveFocus = gridOptions.saveScroll !== true && gridOptions.saveFocus !== false;
	          /**
	           * @ngdoc object
	           * @name saveRowIdentity
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description A function that can be called, passing in a rowEntity,
	           * and that will return a unique id for that row.  This might simply
	           * return the `id` field from that row (if you have one), or it might
	           * concatenate some fields within the row to make a unique value.
	           *
	           * This value will be used to find the same row again and set the focus
	           * to it, if it exists when we return.
	           *
	           * <br/>Defaults to undefined
	           */
	          /**
	           * @ngdoc object
	           * @name saveVisible
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save whether or not columns are visible.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveVisible = gridOptions.saveVisible !== false;
	          /**
	           * @ngdoc object
	           * @name saveSort
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current sort state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSort = gridOptions.saveSort !== false;
	          /**
	           * @ngdoc object
	           * @name saveFilter
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current filter state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveFilter = gridOptions.saveFilter !== false;
	          /**
	           * @ngdoc object
	           * @name saveSelection
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the currently selected rows.  If the `saveRowIdentity` callback
	           * is defined, then it will save the id of the row and select that.  If not, then
	           * it will attempt to select the rows by row number, which will give the wrong results
	           * if the data set has changed in the mean-time.
	           *
	           * Note that this option only does anything
	           * if the selection feature is enabled.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSelection = gridOptions.saveSelection !== false;
	          /**
	           * @ngdoc object
	           * @name saveGrouping
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping configuration.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveGrouping = gridOptions.saveGrouping !== false;
	          /**
	           * @ngdoc object
	           * @name saveGroupingExpandedStates
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping row expanded states.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * This can be quite a bit of data, in many cases you wouldn't want to save this
	           * information.
	           *
	           * <br/>Defaults to false
	           */
	          gridOptions.saveGroupingExpandedStates = gridOptions.saveGroupingExpandedStates === true;
	          /**
	           * @ngdoc object
	           * @name savePinning
	           * @propertyOf ui.grid.saveState.api:GridOptions
	           * @description Save pinning state for columns.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.savePinning = gridOptions.savePinning !== false;
	          /**
	           * @ngdoc object
	           * @name saveTreeView
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the treeView configuration.  If set to true and the
	           * treeView feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveTreeView = gridOptions.saveTreeView !== false;
	        },
	
	        /**
	         * @ngdoc function
	         * @name save
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the current grid state into an object, and
	         * passes that object back to the caller
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the state ready to be saved
	         */
	        save: function (grid) {
	          var savedState = {};
	
	          savedState.columns = service.saveColumns( grid );
	          savedState.scrollFocus = service.saveScrollFocus( grid );
	          savedState.selection = service.saveSelection( grid );
	          savedState.grouping = service.saveGrouping( grid );
	          savedState.treeView = service.saveTreeView( grid );
	          savedState.pagination = service.savePagination( grid );
	
	          return savedState;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restore
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Applies the provided state to the grid
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} state the state we'd like to restore
	         * @returns {object} the promise created by refresh
	         */
	        restore: function( grid, $scope, state ) {
	          if ( state.columns ) {
	            service.restoreColumns( grid, state.columns );
	          }
	
	          if ( state.scrollFocus ) {
	            service.restoreScrollFocus( grid, $scope, state.scrollFocus );
	          }
	
	          if ( state.selection ) {
	            service.restoreSelection( grid, state.selection );
	          }
	
	          if ( state.grouping ) {
	            service.restoreGrouping( grid, state.grouping );
	          }
	
	          if ( state.treeView ) {
	            service.restoreTreeView( grid, state.treeView );
	          }
	
	          if ( state.pagination ) {
	            service.restorePagination( grid, state.pagination );
	          }
	
	          return grid.refresh();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the column setup, including sort, filters, ordering,
	         * pinning and column widths.
	         *
	         * Works through the current columns, storing them in order.  Stores the
	         * column name, then the visible flag, width, sort and filters for each column.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the columns state ready to be saved
	         */
	        saveColumns: function( grid ) {
	          var columns = [];
	
	          grid.getOnlyDataColumns().forEach( function( column ) {
	            var savedColumn = {};
	            savedColumn.name = column.name;
	
	            if ( grid.options.saveVisible ) {
	              savedColumn.visible = column.visible;
	            }
	
	            if ( grid.options.saveWidths ) {
	              savedColumn.width = column.width;
	            }
	
	            // these two must be copied, not just pointed too - otherwise our saved state is pointing to the same object as current state
	            if ( grid.options.saveSort ) {
	              savedColumn.sort = angular.copy( column.sort );
	            }
	
	            if ( grid.options.saveFilter ) {
	              savedColumn.filters = [];
	              column.filters.forEach( function( filter ) {
	                var copiedFilter = {};
	                angular.forEach( filter, function( value, key) {
	                  if ( key !== 'condition' && key !== '$$hashKey' && key !== 'placeholder') {
	                    copiedFilter[key] = value;
	                  }
	                });
	                savedColumn.filters.push(copiedFilter);
	              });
	            }
	
	            if ( !!grid.api.pinning && grid.options.savePinning ) {
	              savedColumn.pinned = column.renderContainer ? column.renderContainer : '';
	            }
	
	            columns.push( savedColumn );
	          });
	
	          return columns;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently scroll or focus.
	         *
	         * If cellNav isn't present then does nothing - we can't return
	         * to the scroll position without cellNav anyway.
	         *
	         * If the cellNav module is present, and saveFocus is true, then
	         * it saves the currently focused cell.  If rowIdentity is present
	         * then saves using rowIdentity, otherwise saves visibleRowNum.
	         *
	         * If the cellNav module is not present, and saveScroll is true, then
	         * it approximates the current scroll row and column, and saves that.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the selection state ready to be saved
	         */
	        saveScrollFocus: function( grid ) {
	          if ( !grid.api.cellNav ) {
	            return {};
	          }
	
	          var scrollFocus = {};
	          if ( grid.options.saveFocus ) {
	            scrollFocus.focus = true;
	            var rowCol = grid.api.cellNav.getFocusedCell();
	            if ( rowCol !== null ) {
	              if ( rowCol.col !== null ) {
	                scrollFocus.colName = rowCol.col.colDef.name;
	              }
	              if ( rowCol.row !== null ) {
	                scrollFocus.rowVal = service.getRowVal( grid, rowCol.row );
	              }
	            }
	          }
	
	          if ( grid.options.saveScroll || grid.options.saveFocus && !scrollFocus.colName && !scrollFocus.rowVal ) {
	            scrollFocus.focus = false;
	            if ( grid.renderContainers.body.prevRowScrollIndex ) {
	              scrollFocus.rowVal = service.getRowVal( grid, grid.renderContainers.body.visibleRowCache[ grid.renderContainers.body.prevRowScrollIndex ]);
	            }
	
	            if ( grid.renderContainers.body.prevColScrollIndex ) {
	              scrollFocus.colName = grid.renderContainers.body.visibleColumnCache[ grid.renderContainers.body.prevColScrollIndex ].name;
	            }
	          }
	
	          return scrollFocus;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently selected rows, if the selection feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the selection state ready to be saved
	         */
	        saveSelection: function( grid ) {
	          if ( !grid.api.selection || !grid.options.saveSelection ) {
	            return [];
	          }
	
	          return grid.api.selection.getSelectedGridRows().map( function( gridRow ) {
	            return service.getRowVal( grid, gridRow );
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the grouping state, if the grouping feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the grouping state ready to be saved
	         */
	        saveGrouping: function( grid ) {
	          if ( !grid.api.grouping || !grid.options.saveGrouping ) {
	            return {};
	          }
	
	          return grid.api.grouping.getGrouping( grid.options.saveGroupingExpandedStates );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name savePagination
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the pagination state, if the pagination feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the pagination state ready to be saved
	         */
	        savePagination: function( grid ) {
	          if ( !grid.api.pagination || !grid.options.paginationPageSize ) {
	            return {};
	          }
	
	          return {
	            paginationCurrentPage: grid.options.paginationCurrentPage,
	            paginationPageSize: grid.options.paginationPageSize
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the tree view state, if the tree feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the tree view state ready to be saved
	         */
	        saveTreeView: function( grid ) {
	          if ( !grid.api.treeView || !grid.options.saveTreeView ) {
	            return {};
	          }
	
	          return grid.api.treeView.getTreeView();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name getRowVal
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Helper function that gets either the rowNum or
	         * the saveRowIdentity, given a gridRow
	         * @param {Grid} grid the grid the row is in
	         * @param {GridRow} gridRow the row we want the rowNum for
	         * @returns {object} an object containing { identity: true/false, row: rowNumber/rowIdentity }
	         *
	         */
	        getRowVal: function( grid, gridRow ) {
	          if ( !gridRow ) {
	            return null;
	          }
	
	          var rowVal = {};
	          if ( grid.options.saveRowIdentity ) {
	            rowVal.identity = true;
	            rowVal.row = grid.options.saveRowIdentity( gridRow.entity );
	          }
	          else {
	            rowVal.identity = false;
	            rowVal.row = grid.renderContainers.body.visibleRowCache.indexOf( gridRow );
	          }
	          return rowVal;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the columns, including order, visible, width,
	         * pinning, sort and filters.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} columnsState the list of columns we had before, with their state
	         */
	        restoreColumns: function( grid, columnsState ) {
	          var isSortChanged = false;
	
	          columnsState.forEach( function( columnState, index ) {
	            var currentCol = grid.getColumn( columnState.name );
	
	            if ( currentCol && !grid.isRowHeaderColumn(currentCol) ) {
	              if ( grid.options.saveVisible &&
	                   ( currentCol.visible !== columnState.visible ||
	                     currentCol.colDef.visible !== columnState.visible ) ) {
	                currentCol.visible = columnState.visible;
	                currentCol.colDef.visible = columnState.visible;
	                grid.api.core.raise.columnVisibilityChanged(currentCol);
	              }
	
	              if ( grid.options.saveWidths && currentCol.width !== columnState.width) {
	                currentCol.width = columnState.width;
	                currentCol.hasCustomWidth = true;
	              }
	
	              if ( grid.options.saveSort &&
	                   !angular.equals(currentCol.sort, columnState.sort) &&
	                   !( currentCol.sort === undefined && angular.isEmpty(columnState.sort) ) ) {
	                currentCol.sort = angular.copy( columnState.sort );
	                isSortChanged = true;
	              }
	
	              if ( grid.options.saveFilter &&
	                   !angular.equals(currentCol.filters, columnState.filters ) ) {
	                columnState.filters.forEach( function( filter, index ) {
	                  angular.extend( currentCol.filters[index], filter );
	                  if ( typeof(filter.term) === 'undefined' || filter.term === null ) {
	                    delete currentCol.filters[index].term;
	                  }
	                });
	                grid.api.core.raise.filterChanged( currentCol );
	              }
	
	              if ( !!grid.api.pinning && grid.options.savePinning && currentCol.renderContainer !== columnState.pinned ) {
	                grid.api.pinning.pinColumn(currentCol, columnState.pinned);
	              }
	
	              var currentIndex = grid.getOnlyDataColumns().indexOf( currentCol );
	              if (currentIndex !== -1) {
	                if (grid.options.saveOrder && currentIndex !== index) {
	                  var column = grid.columns.splice(currentIndex + grid.rowHeaderColumns.length, 1)[0];
	                  grid.columns.splice(index + grid.rowHeaderColumns.length, 0, column);
	                }
	              }
	            }
	          });
	
	          if ( isSortChanged ) {
	            grid.api.core.raise.sortChanged( grid, grid.getColumnSorting() );
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Scrolls to the position that was saved.  If focus is true, then
	         * sets focus to the specified row/col.  If focus is false, then scrolls to the
	         * specified row/col.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} scrollFocusState the scroll/focus state ready to be restored
	         */
	        restoreScrollFocus: function( grid, $scope, scrollFocusState ) {
	          if ( !grid.api.cellNav ) {
	            return;
	          }
	
	          var colDef, row;
	          if ( scrollFocusState.colName ) {
	            var colDefs = grid.options.columnDefs.filter( function( colDef ) { return colDef.name === scrollFocusState.colName; });
	            if ( colDefs.length > 0 ) {
	              colDef = colDefs[0];
	            }
	          }
	
	          if ( scrollFocusState.rowVal && scrollFocusState.rowVal.row ) {
	            if ( scrollFocusState.rowVal.identity ) {
	              row = service.findRowByIdentity( grid, scrollFocusState.rowVal );
	            }
	            else {
	              row = grid.renderContainers.body.visibleRowCache[ scrollFocusState.rowVal.row ];
	            }
	          }
	
	          var entity = row && row.entity ? row.entity : null ;
	
	          if ( colDef || entity ) {
	            if (scrollFocusState.focus ) {
	              grid.api.cellNav.scrollToFocus( entity, colDef );
	            }
	            else {
	              grid.scrollTo( entity, colDef );
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Selects the rows that are provided in the selection
	         * state.  If you are using `saveRowIdentity` and more than one row matches the identity
	         * function then only the first is selected.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} selectionState the selection state ready to be restored
	         */
	        restoreSelection: function( grid, selectionState ) {
	          if ( !grid.api.selection ) {
	            return;
	          }
	
	          grid.api.selection.clearSelectedRows();
	
	          selectionState.forEach(function( rowVal ) {
	            if ( rowVal.identity ) {
	              var foundRow = service.findRowByIdentity( grid, rowVal );
	
	              if ( foundRow ) {
	                grid.api.selection.selectRow( foundRow.entity );
	              }
	
	            }
	            else {
	              grid.api.selection.selectRowByVisibleIndex( rowVal.row );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the grouping configuration, if the grouping feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} groupingState the grouping state ready to be restored
	         */
	        restoreGrouping: function( grid, groupingState ) {
	          if ( !grid.api.grouping || typeof(groupingState) === 'undefined' || groupingState === null || angular.equals(groupingState, {}) ) {
	            return;
	          }
	
	          grid.api.grouping.setGrouping( groupingState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name restoreTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the tree view configuration, if the tree view feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} treeViewState the tree view state ready to be restored
	         */
	        restoreTreeView: function( grid, treeViewState ) {
	          if ( !grid.api.treeView || typeof(treeViewState) === 'undefined' || treeViewState === null || angular.equals(treeViewState, {}) ) {
	            return;
	          }
	
	          grid.api.treeView.setTreeView( treeViewState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name restorePagination
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the pagination information, if pagination is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} pagination the pagination object to be restored
	         * @param {number} pagination.paginationCurrentPage the page number to restore
	         * @param {number} pagination.paginationPageSize the number of items displayed per page
	         */
	        restorePagination: function( grid, pagination ) {
	          if ( !grid.api.pagination || !grid.options.paginationPageSize ) {
	            return;
	          }
	
	          grid.options.paginationCurrentPage = pagination.paginationCurrentPage;
	          grid.options.paginationPageSize = pagination.paginationPageSize;
	        },
	
	        /**
	         * @ngdoc function
	         * @name findRowByIdentity
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Finds a row given it's identity value, returns the first found row
	         * if any are found, otherwise returns null if no rows are found.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} rowVal the row we'd like to find
	         * @returns {gridRow} the found row, or null if none found
	         */
	        findRowByIdentity: function( grid, rowVal ) {
	          if ( !grid.options.saveRowIdentity ) {
	            return null;
	          }
	
	          var filteredRows = grid.rows.filter( function( gridRow ) {
	            return ( grid.options.saveRowIdentity( gridRow.entity ) === rowVal.row );
	          });
	
	          if ( filteredRows.length > 0 ) {
	            return filteredRows[0];
	          } else {
	            return null;
	          }
	        }
	      };
	
	      return service;
	    }
	  );
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.saveState.directive:uiGridSaveState
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds saveState features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.saveState']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	        { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        columnDefs: [
	          {name: 'name'},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-save-state></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSaveState', ['uiGridSaveStateConstants', 'uiGridSaveStateService', 'gridUtil', '$compile',
	    function (uiGridSaveStateConstants, uiGridSaveStateService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridSaveStateService.initializeGrid(uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.selection
	   * @description
	   *
	   * # ui.grid.selection
	   * This module provides row selection
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * <div doc-module-components="ui.grid.selection"></div>
	   */
	
	  var module = angular.module('ui.grid.selection', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.selection.constant:uiGridSelectionConstants
	   *
	   *  @description constants available in selection module
	   */
	  module.constant('uiGridSelectionConstants', {
	    featureName: 'selection',
	    selectionRowHeaderColName: 'selectionRowHeaderCol'
	  });
	
	  // add methods to GridRow
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('GridRow', ['$delegate', function ($delegate) {
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.selection.api:GridRow
	       *
	       *  @description GridRow prototype functions added for selection
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name enableSelection
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Enable row selection for this row, only settable by internal code.
	       *
	       *  The grouping feature, for example, might set group header rows to not be selectable.
	       *  <br/>Defaults to true
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name isSelected
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Selected state of row. Should be readonly. Make any changes to selected state using setSelected().
	       *  <br/>Defaults to false
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name isFocused
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Focused state of row. Should be readonly. Make any changes to focused state using setFocused().
	       *  <br/>Defaults to false
	       */
	
	      /**
	       * @ngdoc function
	       * @name setSelected
	       * @methodOf ui.grid.selection.api:GridRow
	       * @description Sets the isSelected property and updates the selectedCount
	       * Changes to isSelected state should only be made via this function
	       * @param {Boolean} selected value to set
	       */
	      $delegate.prototype.setSelected = function (selected) {
	        if (selected !== this.isSelected) {
	          this.isSelected = selected;
	          this.grid.selection.selectedCount += selected ? 1 : -1;
	        }
	      };
	
	      /**
	       * @ngdoc function
	       * @name setFocused
	       * @methodOf ui.grid.selection.api:GridRow
	       * @description Sets the isFocused property
	       * Changes to isFocused state should only be made via this function
	       * @param {Boolean} val value to set
	       */
	      $delegate.prototype.setFocused = function(val) {
	        if (val !== this.isFocused) {
	          this.grid.selection.focusedRow && (this.grid.selection.focusedRow.isFocused = false);
	          this.grid.selection.focusedRow = val ? this : null;
	          this.isFocused = val;
	        }
	      };
	
	      return $delegate;
	    }]);
	  }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.selection.service:uiGridSelectionService
	   *
	   *  @description Services for selection features
	   */
	  module.service('uiGridSelectionService',
	    function () {
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          // add feature namespace and any properties to grid for needed
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.grid:selection
	           *
	           *  @description Grid properties and functions added for selection
	           */
	          grid.selection = {
	            lastSelectedRow: null,
	            /**
	             *  @ngdoc object
	             *  @name focusedRow
	             *  @propertyOf  ui.grid.selection.grid:selection
	             *  @description Focused row.
	             */
	            focusedRow: null,
	            selectAll: false
	          };
	
	
	          /**
	           *  @ngdoc object
	           *  @name selectedCount
	           *  @propertyOf  ui.grid.selection.grid:selection
	           *  @description Current count of selected rows
	           *  @example
	           *  var count = grid.selection.selectedCount
	           */
	          grid.selection.selectedCount = 0;
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:PublicApi
	           *
	           *  @description Public Api for selection feature
	           */
	          var publicApi = {
	            events: {
	              selection: {
	                /**
	                 * @ngdoc event
	                 * @name rowFocusChanged
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isFocused state is changed
	                 * @param {object} scope the scope associated with the grid
	                 * @param {GridRow} row the row that was focused/unfocused
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowFocusChanged: function (scope, row, evt) {},
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChanged
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * @param {object} scope the scope associated with the grid
	                 * @param {GridRow} row the row that was selected/deselected
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowSelectionChanged: function (scope, row, evt) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChangedBatch
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * in bulk, if the `enableSelectionBatchEvent` option is set to true
	                 * (which it is by default).  This allows more efficient processing
	                 * of bulk events.
	                 * @param {object} scope the scope associated with the grid
	                 * @param {array} rows the rows that were selected/deselected
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowSelectionChangedBatch: function (scope, rows, evt) {
	                }
	              }
	            },
	            methods: {
	              selection: {
	                /**
	                 * @ngdoc function
	                 * @name toggleRowSelection
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Toggles data row as selected or unselected
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                toggleRowSelection: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRowByVisibleIndex
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the specified row by visible index (i.e. if you
	                 * specify row 0 you'll get the first visible row selected).  In this context
	                 * visible means of those rows that are theoretically visible (i.e. not filtered),
	                 * rather than rows currently rendered on the screen.
	                 * @param {number} rowNum index within the rowsVisible array
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectRowByVisibleIndex: function (rowNum, evt) {
	                  var row = grid.renderContainers.body.visibleRowCache[rowNum];
	                  if (row !== null && typeof (row) !== 'undefined' && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description UnSelect the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                unSelectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null && row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRowByVisibleIndex
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Unselect the specified row by visible index (i.e. if you
	                 * specify row 0 you'll get the first visible row unselected).  In this context
	                 * visible means of those rows that are theoretically visible (i.e. not filtered),
	                 * rather than rows currently rendered on the screen.
	                 * @param {number} rowNum index within the rowsVisible array
	                 * @param {Event} evt object if raised from an event
	                 */
	                unSelectRowByVisibleIndex: function (rowNum, evt) {
	                  var row = grid.renderContainers.body.visibleRowCache[rowNum];
	                  if (row !== null && typeof (row) !== 'undefined' && row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all rows.  Does nothing if multiSelect = false
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectAllRows: function (evt) {
	                  if (grid.options.multiSelect !== false) {
	                    var changedRows = [];
	                    grid.rows.forEach(function (row) {
	                      if (!row.isSelected && row.enableSelection !== false && grid.options.isRowSelectable(row) !== false) {
	                        row.setSelected(true);
	                        service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                      }
	                    });
	                    grid.selection.selectAll = true;
	                    service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllVisibleRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all visible rows.  Does nothing if multiSelect = false
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectAllVisibleRows: function (evt) {
	                  if (grid.options.multiSelect !== false) {
	                    var changedRows = [];
	                    grid.rows.forEach(function(row) {
	                      if (row.visible) {
	                        if (!row.isSelected && row.enableSelection !== false && grid.options.isRowSelectable(row) !== false) {
	                          row.setSelected(true);
	                          service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                        }
	                      } else if (row.isSelected) {
	                        row.setSelected(false);
	                        service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                      }
	                    });
	                    grid.selection.selectAll = true;
	                    service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name clearSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Unselects all rows
	                 * @param {Event} evt object if raised from an event
	                 */
	                clearSelectedRows: function (evt) {
	                  service.clearSelectedRows(grid, evt);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selectedRow's entity references
	                 */
	                getSelectedRows: function () {
	                  return service.getSelectedRows(grid).map(function (gridRow) {
	                    return gridRow.entity;
	                  }).filter(function (entity) {
	                    return entity.hasOwnProperty('$$hashKey') || !angular.isObject(entity);
	                  });
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedGridRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selectedRow's as gridRows
	                 */
	                getSelectedGridRows: function () {
	                  return service.getSelectedRows(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedCount
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns the number of rows selected
	                 */
	                getSelectedCount: function () {
	                  return grid.selection.selectedCount;
	                },
	                /**
	                 * @ngdoc function
	                 * @name setMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.multiSelect to true or false
	                 * @param {bool} multiSelect true to allow multiple rows
	                 */
	                setMultiSelect: function (multiSelect) {
	                  grid.options.multiSelect = multiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name setModifierKeysToMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.modifierKeysToMultiSelect to true or false
	                 * @param {bool} modifierKeysToMultiSelect true to only allow multiple rows when using ctrlKey or shiftKey is used
	                 */
	                setModifierKeysToMultiSelect: function (modifierKeysToMultiSelect) {
	                  grid.options.modifierKeysToMultiSelect = modifierKeysToMultiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectAllState
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Returns whether or not the selectAll checkbox is currently ticked.  The
	                 * grid doesn't automatically select rows when you add extra data - so when you add data
	                 * you need to explicitly check whether the selectAll is set, and then call setVisible rows
	                 * if it is
	                 */
	                getSelectAllState: function () {
	                  return grid.selection.selectAll;
	                }
	
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          // default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:GridOptions
	           *
	           *  @description GridOptions for selection feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable row selection for entire grid.
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowSelection = gridOptions.enableRowSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name multiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection for entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.multiSelect = gridOptions.multiSelect !== false;
	          /**
	           *  @ngdoc object
	           *  @name noUnselect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Prevent a row from being unselected.  Works in conjunction
	           *  with `multiselect = false` and `gridApi.selection.selectRow()` to allow
	           *  you to create a single selection only grid - a row is always selected, you
	           *  can only select different rows, you can't unselect the row.
	           *  <br/>Defaults to false
	           */
	          gridOptions.noUnselect = gridOptions.noUnselect === true;
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection only when using the ctrlKey or shiftKey. Requires multiSelect to be true.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelect = gridOptions.modifierKeysToMultiSelect === true;
	          /**
	           *  @ngdoc object
	           *  @name enableRowHeaderSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable a row header to be used for selection
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowHeaderSelection = gridOptions.enableRowHeaderSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableFullRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable selection by clicking anywhere on the row.  Defaults to
	           *  false if `enableRowHeaderSelection` is true, otherwise defaults to true.
	           */
	          if (typeof (gridOptions.enableFullRowSelection) === 'undefined') {
	            gridOptions.enableFullRowSelection = !gridOptions.enableRowHeaderSelection;
	          }
	          /**
	           *  @ngdoc object
	           *  @name enableFocusRowOnRowHeaderClick
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable focuse row by clicking on the row header.  Defaults to
	           *  true if `enableRowHeaderSelection` is true, otherwise defaults to false.
	           */
	          gridOptions.enableFocusRowOnRowHeaderClick = (gridOptions.enableFocusRowOnRowHeaderClick !== false)
	            || !gridOptions.enableRowHeaderSelection;
	          /**
	           *  @ngdoc object
	           *  @name enableSelectRowOnFocus
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable focuse row by clicking on the row anywhere.  Defaults true.
	           */
	          gridOptions.enableSelectRowOnFocus = (gridOptions.enableSelectRowOnFocus !== false);
	          /**
	           *  @ngdoc object
	           *  @name enableSelectAll
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable the select all checkbox at the top of the selectionRowHeader
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectAll = gridOptions.enableSelectAll !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableSelectionBatchEvent
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description If selected rows are changed in bulk, either via the API or
	           *  via the selectAll checkbox, then a separate event is fired.  Setting this
	           *  option to false will cause the rowSelectionChanged event to be called multiple times
	           *  instead
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectionBatchEvent = gridOptions.enableSelectionBatchEvent !== false;
	          /**
	           *  @ngdoc object
	           *  @name selectionRowHeaderWidth
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description can be used to set a custom width for the row header selection column
	           *  <br/>Defaults to 30px
	           */
	          gridOptions.selectionRowHeaderWidth = angular.isDefined(gridOptions.selectionRowHeaderWidth) ? gridOptions.selectionRowHeaderWidth : 30;
	          /**
	           *  @ngdoc object
	           *  @name enableFooterTotalSelected
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Shows the total number of selected items in footer if true.
	           *  <br/>Defaults to true.
	           *  <br/>GridOptions.showGridFooter must also be set to true.
	           */
	          gridOptions.enableFooterTotalSelected = gridOptions.enableFooterTotalSelected !== false;
	
	          /**
	           *  @ngdoc object
	           *  @name isRowSelectable
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Makes it possible to specify a method that evaluates for each row and sets its "enableSelection" property.
	           */
	          gridOptions.isRowSelectable = angular.isDefined(gridOptions.isRowSelectable) ? gridOptions.isRowSelectable : angular.noop;
	        },
	
	        /**
	         * @ngdoc function
	         * @name toggleRowSelection
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Toggles row as selected or unselected
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row to select or deselect
	         * @param {Event} evt object if resulting from event
	         * @param {bool} multiSelect if false, only one row at time can be selected
	         * @param {bool} noUnselect if true then rows cannot be unselected
	         */
	        toggleRowSelection: function (grid, row, evt, multiSelect, noUnselect) {
	          if ( row.enableSelection === false ) {
	            return;
	          }
	
	          var selected = row.isSelected,
	            selectedRows;
	
	          if (!multiSelect) {
	            if (!selected) {
	              service.clearSelectedRows(grid, evt);
	            }
	            else {
	              selectedRows = service.getSelectedRows(grid);
	              if (selectedRows.length > 1) {
	                selected = false; // Enable reselect of the row
	                service.clearSelectedRows(grid, evt);
	              }
	            }
	          }
	
	          // only select row in this case
	          if (!(selected && noUnselect)) {
	            row.setSelected(!selected);
	            if (row.isSelected === true) {
	              grid.selection.lastSelectedRow = row;
	            }
	
	            selectedRows = service.getSelectedRows(grid);
	            grid.selection.selectAll = grid.rows.length === selectedRows.length;
	
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          }
	        },
	        /**
	         * @ngdoc function
	         * @name shiftSelect
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description selects a group of rows from the last selected row using the shift key
	         * @param {Grid} grid grid object
	         * @param {GridRow} row clicked row
	         * @param {Event} evt object if raised from an event
	         * @param {bool} multiSelect if false, does nothing this is for multiSelect only
	         */
	        shiftSelect: function (grid, row, evt, multiSelect) {
	          if (!multiSelect) {
	            return;
	          }
	          var selectedRows = service.getSelectedRows(grid);
	          var fromRow = selectedRows.length > 0 ? grid.renderContainers.body.visibleRowCache.indexOf(grid.selection.lastSelectedRow) : 0;
	          var toRow = grid.renderContainers.body.visibleRowCache.indexOf(row);
	          // reverse select direction
	          if (fromRow > toRow) {
	            var tmp = fromRow;
	            fromRow = toRow;
	            toRow = tmp;
	          }
	
	          var changedRows = [];
	          for (var i = fromRow; i <= toRow; i++) {
	            var rowToSelect = grid.renderContainers.body.visibleRowCache[i];
	            if (rowToSelect) {
	              if (!rowToSelect.isSelected && rowToSelect.enableSelection !== false) {
	                rowToSelect.setSelected(true);
	                grid.selection.lastSelectedRow = rowToSelect;
	                service.decideRaiseSelectionEvent(grid, rowToSelect, changedRows, evt);
	              }
	            }
	          }
	          service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	        },
	        /**
	         * @ngdoc function
	         * @name getSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Returns all the selected rows
	         * @param {Grid} grid grid object
	         */
	        getSelectedRows: function (grid) {
	          return grid.rows.filter(function (row) {
	            return row.isSelected;
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name clearSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Clears all selected rows
	         * @param {Grid} grid grid object
	         * @param {Event} evt object if raised from an event
	         */
	        clearSelectedRows: function (grid, evt) {
	          var changedRows = [];
	          service.getSelectedRows(grid).forEach(function (row) {
	            if (row.isSelected) {
	              row.setSelected(false);
	              service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	            }
	          });
	          grid.selection.selectAll = false;
	          grid.selection.selectedCount = 0;
	          service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	        },
	
	        /**
	         * @ngdoc function
	         * @name decideRaiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether to raise a single event or a batch event
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row that has changed
	         * @param {array} changedRows an array to which we can append the changed
	         * @param {Event} evt object if raised from an event
	         * row if we're doing batch events
	         */
	        decideRaiseSelectionEvent: function (grid, row, changedRows, evt) {
	          if (!grid.options.enableSelectionBatchEvent) {
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          }
	          else {
	            changedRows.push(row);
	          }
	        },
	
	        /**
	         * @ngdoc function
	         * @name raiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether we need to raise a batch event, and
	         * raises it if we do.
	         * @param {Grid} grid grid object
	         * @param {array} changedRows an array of changed rows, only populated
	         * @param {Event} evt object if raised from an event
	         * if we're doing batch events
	         */
	        decideRaiseSelectionBatchEvent: function (grid, changedRows, evt) {
	          if (changedRows.length > 0) {
	            grid.api.selection.raise.rowSelectionChangedBatch(changedRows, evt);
	          }
	        }
	      };
	
	      return service;
	    });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridSelection
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds selection features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.selection']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-selection></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSelection', ['uiGridSelectionConstants', 'uiGridSelectionService', 'uiGridConstants',
	    function (uiGridSelectionConstants, uiGridSelectionService, uiGridConstants) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridSelectionService.initializeGrid(uiGridCtrl.grid);
	              if (uiGridCtrl.grid.options.enableRowHeaderSelection) {
	                var selectionRowHeaderDef = {
	                  name: uiGridSelectionConstants.selectionRowHeaderColName,
	                  displayName: '',
	                  width: uiGridCtrl.grid.options.selectionRowHeaderWidth,
	                  minWidth: 10,
	                  cellTemplate: 'ui-grid/selectionRowHeader',
	                  headerCellTemplate: 'ui-grid/selectionHeaderCell',
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  exporterSuppressExport: true,
	                  allowCellFocus: true
	                };
	
	                uiGridCtrl.grid.addRowHeaderColumn(selectionRowHeaderDef, 0);
	              }
	
	              var processorSet = false;
	
	              var processSelectableRows = function (rows) {
	                rows.forEach(function (row) {
	                  row.enableSelection = uiGridCtrl.grid.options.isRowSelectable(row);
	                });
	                return rows;
	              };
	
	              var updateOptions = function () {
	                if (uiGridCtrl.grid.options.isRowSelectable !== angular.noop && processorSet !== true) {
	                  uiGridCtrl.grid.registerRowsProcessor(processSelectableRows, 500);
	                  processorSet = true;
	                }
	              };
	
	              updateOptions();
	
	              var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(updateOptions, [uiGridConstants.dataChange.OPTIONS]);
	
	              $scope.$on('$destroy', dataChangeDereg);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionRowHeaderButtons', ['$templateCache', 'uiGridSelectionService', 'gridUtil',
	    function ($templateCache, uiGridSelectionService, gridUtil) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionRowHeaderButtons'),
	        scope: true,
	        require: '^uiGrid',
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var self = uiGridCtrl.grid;
	          $scope.selectButtonClick = selectButtonClick;
	          $scope.selectButtonKeyDown = selectButtonKeyDown;
	
	          // On IE, prevent mousedowns on the select button from starting a selection.
	          // If this is not done and you shift+click on another row, the browser will select a big chunk of text
	          if (gridUtil.detectBrowser() === 'ie') {
	            $elm.on('mousedown', selectButtonMouseDown);
	          }
	
	          function selectButtonKeyDown(row, evt) {
	            if (evt.keyCode === 32 || evt.keyCode === 13) {
	              evt.preventDefault();
	              selectButtonClick(row, evt);
	            }
	          }
	
	          function selectButtonClick(row, evt) {
	            evt.stopPropagation();
	
	            if (evt.shiftKey) {
	              uiGridSelectionService.shiftSelect(self, row, evt, self.options.multiSelect);
	            }
	            else if (evt.ctrlKey || evt.metaKey) {
	              uiGridSelectionService.toggleRowSelection(self, row, evt,
	                self.options.multiSelect, self.options.noUnselect);
	            }
	            else if (row.groupHeader) {
	              uiGridSelectionService.toggleRowSelection(self, row, evt, self.options.multiSelect, self.options.noUnselect);
	              for (var i = 0; i < row.treeNode.children.length; i++) {
	                uiGridSelectionService.toggleRowSelection(self, row.treeNode.children[i].row, evt, self.options.multiSelect, self.options.noUnselect);
	              }
	            }
	            else {
	              uiGridSelectionService.toggleRowSelection(self, row, evt,
	                (self.options.multiSelect && !self.options.modifierKeysToMultiSelect), self.options.noUnselect);
	            }
	            self.options.enableFocusRowOnRowHeaderClick && row.setFocused(!row.isFocused) && self.api.selection.raise.rowFocusChanged(row, evt);
	          }
	
	          function selectButtonMouseDown(evt) {
	            if (evt.ctrlKey || evt.shiftKey) {
	              evt.target.onselectstart = function () { return false; };
	              window.setTimeout(function () { evt.target.onselectstart = null; }, 0);
	            }
	          }
	
	          $scope.$on('$destroy', function unbindEvents() {
	            $elm.off();
	          });
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionSelectAllButtons', ['$templateCache', 'uiGridSelectionService',
	    function ($templateCache, uiGridSelectionService) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionSelectAllButtons'),
	        scope: false,
	        link: function ($scope) {
	          var self = $scope.col.grid;
	
	          $scope.headerButtonKeyDown = function (evt) {
	            if (evt.keyCode === 32 || evt.keyCode === 13) {
	              evt.preventDefault();
	              $scope.headerButtonClick(evt);
	            }
	          };
	
	          $scope.headerButtonClick = function (evt) {
	            if (self.selection.selectAll) {
	              uiGridSelectionService.clearSelectedRows(self, evt);
	              if (self.options.noUnselect) {
	                self.api.selection.selectRowByVisibleIndex(0, evt);
	              }
	              self.selection.selectAll = false;
	            }
	            else if (self.options.multiSelect) {
	              self.api.selection.selectAllVisibleRows(evt);
	              self.selection.selectAll = true;
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row
	   */
	  module.directive('uiGridViewport',
	      function () {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm) {
	            var rowRepeatDiv = angular.element($elm[0].querySelector('.ui-grid-canvas:not(.ui-grid-empty-base-layer-container)').children[0]),
	              newNgClass = "'ui-grid-row-selected': row.isSelected, 'ui-grid-row-focused': row.isFocused}",
	              existingNgClass = rowRepeatDiv.attr('ng-class');
	
	            if (existingNgClass) {
	              newNgClass = existingNgClass.slice(0, -1) + ',' + newNgClass;
	            } else {
	              newNgClass = '{' + newNgClass;
	            }
	            rowRepeatDiv.attr('ng-class', newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {},
	              post: function ($scope, $elm, $attrs, controllers) {}
	            };
	          }
	        };
	      });
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide selection feature
	   */
	  module.directive('uiGridCell',
	    ['uiGridConstants', 'uiGridSelectionService',
	      function (uiGridConstants, uiGridSelectionService) {
	        return {
	          priority: -200, // run after default uiGridCell directive
	          restrict: 'A',
	          require: '?^uiGrid',
	          scope: false,
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var touchStartTime = 0,
	              touchStartPos = {},
	              touchTimeout = 300,
	              touchPosDiff = 100;
	
	            // Bind to keydown events in the render container
	            if (uiGridCtrl.grid.api.cellNav) {
	              uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                if (rowCol === null ||
	                  rowCol.row !== $scope.row ||
	                  rowCol.col !== $scope.col) {
	                  return;
	                }
	
	                if (evt.keyCode === uiGridConstants.keymap.SPACE && $scope.col.colDef.name === 'selectionRowHeaderCol') {
	                  evt.preventDefault();
	                  uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt,
	                    ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect),
	                    $scope.grid.options.noUnselect);
	                  $scope.$apply();
	                }
	              });
	            }
	
	            var selectCells = function (evt) {
	              // if you click on expandable icon doesn't trigger selection
	              if (evt.target.className === "ui-grid-icon-minus-squared" || evt.target.className === "ui-grid-icon-plus-squared") {
	                return;
	              }
	
	              // if we get a click, then stop listening for touchend
	              $elm.off('touchend', touchEnd);
	
	              if (evt.shiftKey) {
	                uiGridSelectionService.shiftSelect($scope.grid, $scope.row, evt, $scope.grid.options.multiSelect);
	              }
	              else if (evt.ctrlKey || evt.metaKey) {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt,
	                  $scope.grid.options.multiSelect, $scope.grid.options.noUnselect);
	              }
	              else if ($scope.grid.options.enableSelectRowOnFocus) {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt,
	                  ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect),
	                  $scope.grid.options.noUnselect);
	              }
	              $scope.row.setFocused(!$scope.row.isFocused);
	              $scope.grid.api.selection.raise.rowFocusChanged($scope.row, evt);
	              $scope.$apply();
	
	              // don't re-enable the touchend handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the mouse to the screen if you have both modes of input
	              window.setTimeout(function () {
	                $elm.on('touchend', touchEnd);
	              }, touchTimeout);
	            };
	
	            var touchStart = function (evt) {
	              touchStartTime = (new Date()).getTime();
	              touchStartPos = evt.changedTouches[0];
	
	              // if we get a touch event, then stop listening for click
	              $elm.off('click', selectCells);
	            };
	
	            var touchEnd = function (evt) {
	              var touchEndTime = (new Date()).getTime();
	              var touchEndPos = evt.changedTouches[0];
	              var touchTime = touchEndTime - touchStartTime;
	              var touchXDiff = Math.abs(touchStartPos.clientX - touchEndPos.clientX)
	              var touchYDiff = Math.abs(touchStartPos.clientY - touchEndPos.clientY)
	
	
	              if (touchXDiff < touchPosDiff && touchYDiff < touchPosDiff) {
	                if (touchTime < touchTimeout) {
	                // short touch
	                  selectCells(evt);
	                }
	              }
	
	              // don't re-enable the click handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the screen to the mouse if you have both modes of input
	              window.setTimeout(function () {
	                $elm.on('click', selectCells);
	              }, touchTimeout);
	            };
	
	            function registerRowSelectionEvents() {
	              if ($scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection && $scope.col.colDef.name !== 'selectionRowHeaderCol') {
	                $elm.addClass('ui-grid-disable-selection');
	                $elm.on('touchstart', touchStart);
	                $elm.on('touchend', touchEnd);
	                $elm.on('click', selectCells);
	
	                $scope.registered = true;
	              }
	            }
	
	            function unregisterRowSelectionEvents() {
	              if ($scope.registered) {
	                $elm.removeClass('ui-grid-disable-selection');
	                $elm.off('touchstart', touchStart);
	                $elm.off('touchend', touchEnd);
	                $elm.off('click', selectCells);
	
	                $scope.registered = false;
	              }
	            }
	
	            registerRowSelectionEvents();
	
	            // register a dataChange callback so that we can change the selection configuration dynamically
	            // if the user changes the options
	            var dataChangeUnreg = $scope.grid.registerDataChangeCallback(function () {
	              if ($scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection &&
	                !$scope.registered) {
	                registerRowSelectionEvents();
	              }
	              else if ((!$scope.grid.options.enableRowSelection || !$scope.grid.options.enableFullRowSelection) &&
	                $scope.registered) {
	                unregisterRowSelectionEvents();
	              }
	            }, [uiGridConstants.dataChange.OPTIONS]);
	
	            $elm.on('$destroy', dataChangeUnreg);
	          }
	        };
	      }]);
	
	  module.directive('uiGridGridFooter', ['$compile', 'gridUtil', function ($compile, gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      priority: -1000,
	      require: '^uiGrid',
	      scope: true,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (!uiGridCtrl.grid.options.showGridFooter) {
	              return;
	            }
	
	            gridUtil.getTemplate('ui-grid/gridFooterSelectedItems')
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	
	                angular.element($elm[0].getElementsByClassName('ui-grid-grid-footer')[0]).append(newElm);
	              });
	          },
	          post: function ($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeBase
	   * @description
	   *
	   * # ui.grid.treeBase
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides base tree handling functions that are shared by other features, notably grouping
	   * and treeView.  It provides a tree view of the data, with nodes in that
	   * tree and leaves.
	   *
	   * Design information:
	   * -------------------
	   *
	   * The raw data that is provided must come with a $$treeLevel on any non-leaf node.  Grouping will create
	   * these on all the group header rows, treeView will expect these to be set in the raw data by the user.
	   * TreeBase will run a rowsProcessor that:
	   *  - builds `treeBase.tree` out of the provided rows
	   *  - permits a recursive sort of the tree
	   *  - maintains the expand/collapse state of each node
	   *  - provides the expand/collapse all button and the expand/collapse buttons
	   *  - maintains the count of children for each node
	   *
	   * Each row is updated with a link to the tree node that represents it.  Refer {@link ui.grid.treeBase.grid:treeBase.tree tree documentation}
	   * for information.
	   *
	   *  TreeBase adds information to the rows
	   *  - treeLevel: if present and > -1 tells us the level (level 0 is the top level)
	   *  - treeNode: pointer to the node in the grid.treeBase.tree that refers
	   *    to this row, allowing us to manipulate the state
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  We recall the expanded state
	   * across invocations of the rowsProcessors by the reference to the treeNode on the individual
	   * rows.  We rebuild the tree itself quite frequently, when we do this we use the saved treeNodes to
	   * get the state, but we overwrite the other data in that treeNode.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * We rely on the rowsProcessors to do the actual expanding and collapsing, so we set the flags we want into
	   * grid.treeBase.tree, then call refresh.  This is because we can't easily change the visible
	   * row cache without calling the processors, and once we've built the logic into the rowProcessors we may as
	   * well use it all the time.
	   *
	   * Tree base provides sorting (on non-grouped columns).
	   *
	   * Sorting works in two passes.  The standard sorting is performed for any columns that are important to building
	   * the tree (for example, any grouped columns).  Then after the tree is built, a recursive tree sort is performed
	   * for the remaining sort columns (including the original sort) - these columns are sorted within each tree level
	   * (so all the level 1 nodes are sorted, then all the level 2 nodes within each level 1 node etc).
	   *
	   * To achieve this we make use of the `ignoreSort` property on the sort configuration.  The parent feature (treeView or grouping)
	   * must provide a rowsProcessor that runs with very low priority (typically in the 60-65 range), and that sets
	   * the `ignoreSort`on any sort that it wants to run on the tree.  TreeBase will clear the ignoreSort on all sorts - so it
	   * will turn on any sorts that haven't run.  It will then call a recursive sort on the tree.
	   *
	   * Tree base provides treeAggregation.  It checks the treeAggregation configuration on each column, and aggregates based on
	   * the logic provided as it builds the tree. Footer aggregation from the uiGrid core should not be used with treeBase aggregation,
	   * since it operates on all visible rows, as opposed to to leaf nodes only. Setting `showColumnFooter: true` will show the
	   * treeAggregations in the column footer.  Aggregation information will be collected in the format:
	   *
	   * ```
	   *   {
	   *     type: 'count',
	   *     value: 4,
	   *     label: 'count: ',
	   *     rendered: 'count: 4'
	   *   }
	   * ```
	   *
	   * A callback is provided to format the value once it is finalised (aka a valueFilter).
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeBase"></div>
	   */
	
	  var module = angular.module('ui.grid.treeBase', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.constant:uiGridTreeBaseConstants
	   *
	   *  @description constants available in treeBase module.
	   *
	   *  These constants are manually copied into grouping and treeView,
	   *  as I haven't found a way to simply include them, and it's not worth
	   *  investing time in for something that changes very infrequently.
	   *
	   */
	  module.constant('uiGridTreeBaseConstants', {
	    featureName: "treeBase",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeBase.service:uiGridTreeBaseService
	   *
	   *  @description Services for treeBase feature
	   */
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.api:ColumnDef
	   *
	   *  @description ColumnDef for tree feature, these are available to be
	   *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	   */
	
	  module.service('uiGridTreeBaseService', ['$q', 'uiGridTreeBaseConstants', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'rowSorter',
	  function ($q, uiGridTreeBaseConstants, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants, rowSorter) {
	
	    var service = {
	
	      initializeGrid: function (grid) {
	
	        // add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.grid:treeBase
	         *
	         *  @description Grid properties and functions added for treeBase
	         */
	        grid.treeBase = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name numberLevels
	         *
	         *  @description Total number of tree levels currently used, calculated by the rowsProcessor by
	         *  retaining the highest tree level it sees
	         */
	        grid.treeBase.numberLevels = 0;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name expandAll
	         *
	         *  @description Whether or not the expandAll box is selected
	         */
	        grid.treeBase.expandAll = false;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name tree
	         *
	         *  @description Tree represented as a nested array that holds the state of each node, along with a
	         *  pointer to the row.  The array order is material - we will display the children in the order
	         *  they are stored in the array
	         *
	         *  Each node stores:
	         *
	         *    - the state of this node
	         *    - an array of children of this node
	         *    - a pointer to the parent of this node (reverse pointer, allowing us to walk up the tree)
	         *    - the number of children of this node
	         *    - aggregation information calculated from the nodes
	         *
	         *  ```
	         *    [{
	         *      state: 'expanded',
	         *      row: <reference to row>,
	         *      parentRow: null,
	         *      aggregations: [{
	         *        type: 'count',
	         *        col: <gridCol>,
	         *        value: 2,
	         *        label: 'count: ',
	         *        rendered: 'count: 2'
	         *      }],
	         *      children: [
	         *        {
	         *          state: 'expanded',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: '<gridCol>,
	         *            value: 4,
	         *            label: 'count: ',
	         *            rendered: 'count: 4'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        },
	         *        {
	         *          state: 'collapsed',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: <gridCol>,
	         *            value: 3,
	         *            label: 'count: ',
	         *            rendered: 'count: 3'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        }
	         *      ]
	         *    }, {<another level 0 node maybe>} ]
	         *  ```
	         *  Missing state values are false - meaning they aren't expanded.
	         *
	         *  This is used because the rowProcessors run every time the grid is refreshed, so
	         *  we'd lose the expanded state every time the grid was refreshed.  This instead gives
	         *  us a reliable lookup that persists across rowProcessors.
	         *
	         *  This tree is rebuilt every time we run the rowsProcessors.  Since each row holds a pointer
	         *  to it's tree node we can persist expand/collapse state across calls to rowsProcessor, we discard
	         *  all transient information on the tree (children, childCount) and recalculate it
	         *
	         */
	        grid.treeBase.tree = [];
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.treeRows, 410);
	
	        grid.registerColumnBuilder( service.treeBaseColumnBuilder );
	
	        service.createRowHeader( grid );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:PublicApi
	         *
	         *  @description Public Api for treeBase feature
	         */
	        var publicApi = {
	          events: {
	            treeBase: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowExpanded
	               * @description raised whenever a row is expanded.  If you are dynamically
	               * rendering your tree you can listen to this event, and then retrieve
	               * the children of this row and load them into the grid data.
	               *
	               * When the data is loaded the grid will automatically refresh to show these new rows
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowExpanded(scope,function(row) {})
	               * </pre>
	               * @param {gridRow} row the row that was expanded.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowExpanded: {},
	
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowCollapsed
	               * @description raised whenever a row is collapsed.  Doesn't really have
	               * a purpose at the moment, included for symmetry
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowCollapsed(scope,function(row) {})
	               * </pre>
	               * @param {gridRow} row the row that was collapsed.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowCollapsed: {}
	            }
	          },
	
	          methods: {
	            treeBase: {
	              /**
	               * @ngdoc function
	               * @name expandAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Expands all tree rows
	               */
	              expandAllRows: function () {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all tree rows
	               */
	              collapseAllRows: function () {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name toggleRowTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description  call expand if the row is collapsed, collapse if it is expanded
	               * @param {gridRow} row the row you wish to toggle
	               */
	              toggleRowTreeState: function (row) {
	                service.toggleRowTreeState(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand the immediate children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               * @param {boolean} recursive true if you wish to expand the row's ancients
	               */
	              expandRow: function (row, recursive) {
	                service.expandRow(grid, row, recursive);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand all children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               */
	              expandRowChildren: function (row) {
	                service.expandRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse  the specified row.  When
	               * you expand the row again, all grandchildren will retain their state
	               * @param {gridRow} row the row you wish to collapse
	               */
	              collapseRow: function ( row ) {
	                service.collapseRow(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all children of the specified row.  When
	               * you expand the row again, all grandchildren will be collapsed
	               * @param {gridRow} row the row you wish to collapse children for
	               */
	              collapseRowChildren: function ( row ) {
	                service.collapseRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name getTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the tree state for this grid,
	               * used by the saveState feature
	               * Returned treeState as an object
	               *   `{ expandedState: { uid: 'expanded', uid: 'collapsed' } }`
	               * where expandedState is a hash of row uid and the current expanded state
	               *
	               * @returns {object} tree state
	               *
	               * TODO - this needs work - we need an identifier that persists across instantiations,
	               * not uid.  This really means we need a row identity defined, but that won't work for
	               * grouping.  Perhaps this needs to be moved up to treeView and grouping, rather than
	               * being in base.
	               */
	              getTreeExpandedState: function () {
	                return { expandedState: service.getTreeState(grid) };
	              },
	
	              /**
	               * @ngdoc function
	               * @name setTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Set the expanded states of the tree
	               * @param {object} config the config you want to apply, in the format
	               * provided by getTreeState
	               */
	              setTreeState: function ( config ) {
	                service.setTreeState( grid, config );
	              },
	
	              /**
	               * @ngdoc function
	               * @name getRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the children of the specified row
	               * @param {GridRow} row the row you want the children of
	               * @returns {Array} array of children of this row, the children
	               * are all gridRows
	               */
	              getRowChildren: function ( row ) {
	                return row.treeNode.children.map( function( childNode ) {
	                  return childNode.row;
	                });
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:GridOptions
	         *
	         *  @description GridOptions for treeBase feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderBaseWidth
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Base width of the tree header, provides for a single level of tree.  This
	         *  is incremented by `treeIndent` for each extra level
	         *  <br/>Defaults to 30
	         */
	        gridOptions.treeRowHeaderBaseWidth = gridOptions.treeRowHeaderBaseWidth || 30;
	
	        /**
	         *  @ngdoc object
	         *  @name treeIndent
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Number of pixels of indent for the icon at each tree level, wider indents are visually more pleasing,
	         *  but will make the tree row header wider
	         *  <br/>Defaults to 10
	         */
	        gridOptions.treeIndent = (gridOptions.treeIndent != null) ? gridOptions.treeIndent : 10;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeRowHeader
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to false, don't create the row header.  You'll need to programmatically control the expand
	         *  states
	         *  <br/>Defaults to true
	         */
	        gridOptions.showTreeRowHeader = gridOptions.showTreeRowHeader !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeExpandNoChildren
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, show the expand/collapse button even if there are no
	         *  children of a node.  You'd use this if you're planning to dynamically load the children
	         *
	         *  <br/>Defaults to true, grouping overrides to false
	         */
	        gridOptions.showTreeExpandNoChildren = gridOptions.showTreeExpandNoChildren !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderAlwaysVisible
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, row header even if there are no tree nodes
	         *
	         *  <br/>Defaults to true
	         */
	        gridOptions.treeRowHeaderAlwaysVisible = gridOptions.treeRowHeaderAlwaysVisible !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeCustomAggregations
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Define custom aggregation functions. The properties of this object will be
	         *  aggregation types available for use on columnDef with {@link ui.grid.treeBase.api:ColumnDef treeAggregationType} or through the column menu.
	         *  If a function defined here uses the same name as one of the native aggregations, this one will take precedence.
	         *  The object format is:
	         *
	         *  <pre>
	         *    {
	         *      aggregationName: {
	         *        label: (optional) string,
	         *        aggregationFn: function( aggregation, fieldValue, numValue, row ) {...},
	         *        finalizerFn: (optional) function( aggregation ) {...}
	         *      },
	         *      mean: {
	         *        label: 'mean',
	         *        aggregationFn: function( aggregation, fieldValue, numValue ) {
	         *          aggregation.count = (aggregation.count || 1) + 1;
	         *          aggregation.sum = (aggregation.sum || 0) + numValue;
	         *        },
	         *        finalizerFn: function( aggregation ) {
	         *          aggregation.value = aggregation.sum / aggregation.count
	         *        }
	         *      }
	         *    }
	         *  </pre>
	         *
	         *  <br/>The `finalizerFn` may be used to manipulate the value before rendering, or to
	         *  apply a custom rendered value. If `aggregation.rendered` is left undefined, the value will be
	         *  rendered. Note that the native aggregation functions use an `finalizerFn` to concatenate
	         *  the label and the value.
	         *
	         *  <br/>Defaults to {}
	         */
	        gridOptions.treeCustomAggregations = gridOptions.treeCustomAggregations || {};
	
	        /**
	         *  @ngdoc object
	         *  @name enableExpandAll
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Enable the expand all button at the top of the row header
	         *
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableExpandAll = gridOptions.enableExpandAll !== false;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeBaseColumnBuilder
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Sets the tree defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridColumn} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      treeBaseColumnBuilder: function (colDef, col, gridOptions) {
	
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that aggregates rows into some form of
	         *  total.  Aggregations run row-by-row, the function needs to be capable of
	         *  creating a running total.
	         *
	         *  The function will be provided the aggregation item (in which you can store running
	         *  totals), the row value that is to be aggregated, and that same row value converted to
	         *  a number (most aggregations work on numbers)
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFn = function ( aggregation, fieldValue, numValue, row ) {
	         *      // calculates the average of the squares of the values
	         *      if ( typeof(aggregation.count) === 'undefined' ) {
	         *        aggregation.count = 0;
	         *      }
	         *      aggregation.count++;
	         *
	         *      if ( !isNaN(numValue) ) {
	         *        if ( typeof(aggregation.total) === 'undefined' ) {
	         *          aggregation.total = 0;
	         *        }
	         *        aggregation.total = aggregation.total + numValue * numValue;
	         *      }
	         *
	         *      aggregation.value = aggregation.total / aggregation.count;
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined. May be overwritten by treeAggregationType, the two options should not be used together.
	         */
	        if ( typeof(colDef.customTreeAggregationFn) !== 'undefined' ) {
	          col.treeAggregationFn = colDef.customTreeAggregationFn;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationType
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Use one of the native or grid-level aggregation methods for calculating aggregations on this column.
	         *  Native method are in the constants file and include: SUM, COUNT, MIN, MAX, AVG. This may also be the property the
	         *  name of an aggregation function defined with {@link ui.grid.treeBase.api:GridOptions treeCustomAggregations}.
	         *
	         *  <pre>
	         *      treeAggregationType = uiGridTreeBaseConstants.aggregation.SUM,
	         *    }
	         *  </pre>
	         *
	         *  If you are using aggregations you should either:
	         *
	         *   - also use grouping, in which case the aggregations are displayed in the group header, OR
	         *   - use treeView, in which case you can set `treeAggregationUpdateEntity: true` in the colDef, and
	         *     treeBase will store the aggregation information in the entity, or you can set `treeAggregationUpdateEntity: false`
	         *     in the colDef, and you need to manual retrieve the calculated aggregations from the row.treeNode.aggregations
	         *
	         *  <br/>Takes precendence over a treeAggregationFn, the two options should not be used together.
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(colDef.treeAggregationType) !== 'undefined' ) {
	          col.treeAggregation = { type: colDef.treeAggregationType };
	          if ( typeof(gridOptions.treeCustomAggregations[colDef.treeAggregationType]) !== 'undefined' ) {
	            col.treeAggregationFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregationFinalizerFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].finalizerFn;
	            col.treeAggregation.label = gridOptions.treeCustomAggregations[colDef.treeAggregationType].label;
	          }
	          else if ( typeof(service.nativeAggregations()[colDef.treeAggregationType]) !== 'undefined' ) {
	            col.treeAggregationFn = service.nativeAggregations()[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregation.label = service.nativeAggregations()[colDef.treeAggregationType].label;
	          }
	        }
	
	         /**
	         *  @ngdoc object
	         *  @name treeAggregationLabel
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom label to use for this aggregation. If provided we don't use native i18n.
	         */
	        if ( typeof(colDef.treeAggregationLabel) !== 'undefined' ) {
	          if (typeof(col.treeAggregation) === 'undefined' ) {
	            col.treeAggregation = {};
	          }
	          col.treeAggregation.label = colDef.treeAggregationLabel;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationUpdateEntity
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Store calculated aggregations into the entity, allowing them
	         *  to be displayed in the grid using a standard cellTemplate.  This defaults to true,
	         *  if you are using grouping then you shouldn't set it to false, as then the aggregations won't
	         *  display.
	         *
	         *  If you are using treeView in most cases you'll want to set this to true.  This will result in
	         *  getCellValue returning the aggregation rather than whatever was stored in the cell attribute on
	         *  the entity.  If you want to render the underlying entity value (and do something else with the aggregation)
	         *  then you could use a custom cellTemplate to display `row.entity.myAttribute`, rather than using getCellValue.
	         *
	         *  <br/>Defaults to true
	         *
	         *  @example
	         *  <pre>
	         *    gridOptions.columns = [{
	         *      name: 'myCol',
	         *      treeAggregation: { type: uiGridTreeBaseConstants.aggregation.SUM },
	         *      treeAggregationUpdateEntity: true
	         *      cellTemplate: '<div>{{row.entity.myCol + " " + row.treeNode.aggregations[0].rendered}}</div>'
	         *    }];
	         * </pre>
	         */
	        col.treeAggregationUpdateEntity = colDef.treeAggregationUpdateEntity !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFinalizerFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that populates aggregation.rendered, this is called when
	         *  a particular aggregation has been fully calculated, and we want to render the value.
	         *
	         *  With the native aggregation options we just concatenate `aggregation.label` and
	         *  `aggregation.value`, but if you wanted to apply a filter or otherwise manipulate the label
	         *  or the value, you can do so with this function. This function will be called after the
	         *  the default `finalizerFn`.
	         *
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFinalizerFn = function ( aggregation ) {
	         *      aggregation.rendered = aggregation.label + aggregation.value / 100 + '%';
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(col.customTreeAggregationFinalizerFn) === 'undefined' ) {
	          col.customTreeAggregationFinalizerFn = colDef.customTreeAggregationFinalizerFn;
	        }
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createRowHeader
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Create the rowHeader.  If treeRowHeaderAlwaysVisible then
	       * set it to visible, otherwise set it to invisible
	       *
	       * @param {Grid} grid grid object
	       */
	      createRowHeader: function( grid ) {
	        var rowHeaderColumnDef = {
	          name: uiGridTreeBaseConstants.rowHeaderColName,
	          displayName: '',
	          width:  grid.options.treeRowHeaderBaseWidth,
	          minWidth: 10,
	          cellTemplate: 'ui-grid/treeBaseRowHeader',
	          headerCellTemplate: 'ui-grid/treeBaseHeaderCell',
	          enableColumnResizing: false,
	          enableColumnMenu: false,
	          exporterSuppressExport: true,
	          allowCellFocus: true
	        };
	
	        rowHeaderColumnDef.visible = grid.options.treeRowHeaderAlwaysVisible;
	        grid.addRowHeaderColumn(rowHeaderColumnDef, -100);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      expandAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.EXPANDED);
	        });
	        grid.treeBase.expandAll = true;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      collapseAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.COLLAPSED);
	        });
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setAllNodes
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Works through a subset of grid.treeBase.rowExpandedStates, setting
	       * all child nodes (and their descendents) of the provided node to the given state.
	       *
	       * Calls itself recursively on all nodes so as to achieve this.
	       *
	       * @param {Grid} grid the grid we're operating on (so we can raise events)
	       * @param {object} treeNode a node in the tree that we want to update
	       * @param {string} targetState the state we want to set it to
	       */
	      setAllNodes: function (grid, treeNode, targetState) {
	        if ( typeof(treeNode.state) !== 'undefined' && treeNode.state !== targetState ) {
	          treeNode.state = targetState;
	
	          if ( targetState === uiGridTreeBaseConstants.EXPANDED ) {
	            grid.api.treeBase.raise.rowExpanded(treeNode.row);
	          }
	          else {
	            grid.api.treeBase.raise.rowCollapsed(treeNode.row);
	          }
	        }
	
	        // set all child nodes
	        if ( treeNode.children ) {
	          treeNode.children.forEach(function( childNode ) {
	            service.setAllNodes(grid, childNode, targetState);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name toggleRowTreeState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Toggles the expand or collapse state of this grouped row, if
	       * it's a parent row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to toggle
	       */
	      toggleRowTreeState: function ( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        if (row.treeNode.state === uiGridTreeBaseConstants.EXPANDED) {
	          service.collapseRow(grid, row);
	        }
	        else {
	          service.expandRow(grid, row, false);
	        }
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing only immediate children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       * @param {boolean} recursive true if you wish to expand the row's ancients
	       */
	      expandRow: function ( grid, row, recursive ) {
	        if ( recursive ) {
	          var parents = [];
	          while ( row && typeof(row.treeLevel) !== 'undefined' && row.treeLevel !== null && row.treeLevel >= 0 && row.treeNode.state !== uiGridTreeBaseConstants.EXPANDED ) {
	            parents.push(row);
	            row = row.treeNode.parentRow;
	          }
	
	          if ( parents.length > 0 ) {
	            row = parents.pop();
	            while ( row ) {
	                row.treeNode.state = uiGridTreeBaseConstants.EXPANDED;
	                grid.api.treeBase.raise.rowExpanded(row);
	                row = parents.pop();
	            }
	
	            grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	            grid.queueGridRefresh();
	          }
	        }
	        else {
	          if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	            return;
	          }
	
	          if ( row.treeNode.state !== uiGridTreeBaseConstants.EXPANDED ) {
	            row.treeNode.state = uiGridTreeBaseConstants.EXPANDED;
	            grid.api.treeBase.raise.rowExpanded(row);
	            grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	            grid.queueGridRefresh();
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing all children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       */
	      expandRowChildren: function ( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.EXPANDED);
	        grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRow: function( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        if ( row.treeNode.state !== uiGridTreeBaseConstants.COLLAPSED ) {
	          row.treeNode.state = uiGridTreeBaseConstants.COLLAPSED;
	          grid.treeBase.expandAll = false;
	          grid.api.treeBase.raise.rowCollapsed(row);
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row and all children
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRowChildren: function( grid, row ) {
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) {
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.COLLAPSED);
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name allExpanded
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Returns true if all rows are expanded, false
	       * if they're not.  Walks the tree to determine this.  Used
	       * to set the expandAll state.
	       *
	       * If the node has no children, then return true (it's immaterial
	       * whether it is expanded).  If the node has children, then return
	       * false if this node is collapsed, or if any child node is not all expanded
	       *
	       * @param {object} tree the grid to check
	       * @returns {boolean} whether or not the tree is all expanded
	       */
	      allExpanded: function( tree ) {
	        var allExpanded = true;
	
	        tree.forEach(function( node ) {
	          if ( !service.allExpandedInternal( node ) ) {
	            allExpanded = false;
	          }
	        });
	        return allExpanded;
	      },
	
	      allExpandedInternal: function( treeNode ) {
	        if ( treeNode.children && treeNode.children.length > 0 ) {
	          if ( treeNode.state === uiGridTreeBaseConstants.COLLAPSED ) {
	            return false;
	          }
	          var allExpanded = true;
	          treeNode.children.forEach( function( node ) {
	            if ( !service.allExpandedInternal( node ) ) {
	              allExpanded = false;
	            }
	          });
	          return allExpanded;
	        }
	        else {
	          return true;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description The rowProcessor that adds the nodes to the tree, and sets the visible
	       * state of each row based on it's parent state
	       *
	       * Assumes it is always called after the sorting processor, and the grouping processor if there is one.
	       * Performs any tree sorts itself after having built the tree
	       *
	       * Processes all the rows in order, setting the group level based on the $$treeLevel in the associated
	       * entity, and setting the visible state based on the parent's state.
	       *
	       * Calculates the deepest level of tree whilst it goes, and updates that so that the header column can be correctly
	       * sized.
	       *
	       * Aggregates if necessary along the way.
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows
	       */
	      treeRows: function( renderableRows ) {
	        var grid = this;
	
	        if (renderableRows.length === 0) {
	          service.updateRowHeaderWidth( grid );
	          return renderableRows;
	        }
	
	        grid.treeBase.tree = service.createTree( grid, renderableRows );
	        service.updateRowHeaderWidth( grid );
	
	        service.sortTree( grid );
	        service.fixFilter( grid );
	
	        return service.renderTree( grid.treeBase.tree );
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createOrUpdateRowHeaderWidth
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Calculates the rowHeader width.
	       *
	       * If rowHeader is always present, updates the width.
	       *
	       * If rowHeader is only sometimes present (`treeRowHeaderAlwaysVisible: false`), determines whether there
	       * should be one, then creates or removes it as appropriate, with the created rowHeader having the
	       * right width.
	       *
	       * If there's never a rowHeader then never creates one: `showTreeRowHeader: false`
	       *
	       * @param {Grid} grid the grid we want to set the row header on
	       */
	      updateRowHeaderWidth: function( grid ) {
	        var rowHeader = grid.getColumn(uiGridTreeBaseConstants.rowHeaderColName),
	          newWidth = grid.options.treeRowHeaderBaseWidth + grid.options.treeIndent * Math.max(grid.treeBase.numberLevels - 1, 0);
	
	        if ( rowHeader && newWidth !== rowHeader.width ) {
	          rowHeader.width = newWidth;
	          grid.queueRefresh();
	        }
	
	        var newVisibility = true;
	
	        if ( grid.options.showTreeRowHeader === false ) {
	          newVisibility = false;
	        }
	        if ( grid.options.treeRowHeaderAlwaysVisible === false && grid.treeBase.numberLevels <= 0 ) {
	          newVisibility = false;
	        }
	        if ( rowHeader  && rowHeader.visible !== newVisibility ) {
	          rowHeader.visible = newVisibility;
	          rowHeader.colDef.visible = newVisibility;
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name renderTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates an array of rows based on the tree, exporting only
	       * the visible nodes and leaves
	       *
	       * @param {array} nodeList The list of nodes - can be grid.treeBase.tree, or can be node.children when
	       * we're calling recursively
	       * @returns {array} renderable rows
	       */
	      renderTree: function( nodeList ) {
	        var renderableRows = [];
	
	        nodeList.forEach( function ( node ) {
	          if ( node.row.visible ) {
	            renderableRows.push( node.row );
	          }
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ) {
	            renderableRows = renderableRows.concat( service.renderTree( node.children ) );
	          }
	        });
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree from the renderableRows
	       *
	       * @param {Grid} grid The grid
	       * @param {array} renderableRows The rows we want to create a tree from
	       * @returns {object} The tree we've build
	       */
	      createTree: function( grid, renderableRows ) {
	        var currentLevel = -1,
	          parents = [],
	          currentState;
	
	        grid.treeBase.tree = [];
	        grid.treeBase.numberLevels = 0;
	
	        var aggregations = service.getAggregations( grid );
	
	        function createNode( row ) {
	          if ( !row.internalRow && row.treeLevel !== row.entity.$$treeLevel ) {
	            row.treeLevel = row.entity.$$treeLevel;
	          }
	
	          if ( row.treeLevel <= currentLevel ) {
	            // pop any levels that aren't parents of this level, formatting the aggregation at the same time
	            while ( row.treeLevel <= currentLevel ) {
	              var lastParent = parents.pop();
	              service.finaliseAggregations( lastParent );
	              currentLevel--;
	            }
	
	            // reset our current state based on the new parent, set to expanded if this is a level 0 node
	            if ( parents.length > 0 ) {
	              currentState = service.setCurrentState(parents);
	            }
	            else {
	              currentState = uiGridTreeBaseConstants.EXPANDED;
	            }
	          }
	
	          // aggregate if this is a leaf node
	          if ( ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) && row.visible  ) {
	            service.aggregate( grid, row, parents );
	          }
	
	          // add this node to the tree
	          service.addOrUseNode(grid, row, parents, aggregations);
	
	          if ( typeof(row.treeLevel) !== 'undefined' && row.treeLevel !== null && row.treeLevel >= 0 ) {
	            parents.push(row);
	            currentLevel++;
	            currentState = service.setCurrentState(parents);
	          }
	
	          // update the tree number of levels, so we can set header width if we need to
	          if ( grid.treeBase.numberLevels < row.treeLevel + 1) {
	            grid.treeBase.numberLevels = row.treeLevel + 1;
	          }
	        }
	
	        renderableRows.forEach( createNode );
	
	        // finalize remaining aggregations
	        while ( parents.length > 0 ) {
	          var lastParent = parents.pop();
	          service.finaliseAggregations( lastParent );
	        }
	
	        return grid.treeBase.tree;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name addOrUseNode
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree node for this row.  If this row already has a treeNode
	       * recorded against it, preserves the state, but otherwise overwrites the data.
	       *
	       * @param {grid} grid The grid we're operating on
	       * @param {gridRow} row The row we want to set
	       * @param {array} parents An array of the parents this row should have
	       * @param {array} aggregationBase Empty aggregation information
	       * @returns {undefined} Updates the parents array, updates the row to have a treeNode, and updates the
	       * grid.treeBase.tree
	       */
	      addOrUseNode: function( grid, row, parents, aggregationBase ) {
	        var newAggregations = [];
	        aggregationBase.forEach( function(aggregation) {
	          newAggregations.push(service.buildAggregationObject(aggregation.col));
	        });
	
	        var newNode = { state: uiGridTreeBaseConstants.COLLAPSED, row: row, parentRow: null, aggregations: newAggregations, children: [] };
	        if ( row.treeNode ) {
	          newNode.state = row.treeNode.state;
	        }
	        if ( parents.length > 0 ) {
	          newNode.parentRow = parents[parents.length - 1];
	        }
	        row.treeNode = newNode;
	
	        if ( parents.length === 0 ) {
	          grid.treeBase.tree.push( newNode );
	        } else {
	          parents[parents.length - 1].treeNode.children.push( newNode );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setCurrentState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks at the parents array to determine our current state.
	       * If any node in the hierarchy is collapsed, then return collapsed, otherwise return
	       * expanded.
	       *
	       * @param {array} parents An array of the parents this row should have
	       * @returns {string} The state we should be setting to any nodes we see
	       */
	      setCurrentState: function( parents ) {
	        var currentState = uiGridTreeBaseConstants.EXPANDED;
	
	        parents.forEach( function(parent) {
	          if ( parent.treeNode.state === uiGridTreeBaseConstants.COLLAPSED ) {
	            currentState = uiGridTreeBaseConstants.COLLAPSED;
	          }
	        });
	        return currentState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name sortTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Performs a recursive sort on the tree nodes, sorting the
	       * children of each node and putting them back into the children array.
	       *
	       * Before doing this it turns back on all the sortIgnore - things that were previously
	       * ignored we process now.  Since we're sorting within the nodes, presumably anything
	       * that was already sorted is how we derived the nodes, we can keep those sorts too.
	       *
	       * We only sort tree nodes that are expanded - no point in wasting effort sorting collapsed
	       * nodes
	       *
	       * @param {Grid} grid The grid to get the aggregation information from
	       * @returns {array} The aggregation information
	       */
	      sortTree: function( grid ) {
	        grid.columns.forEach( function( column ) {
	          if ( column.sort && column.sort.ignoreSort ) {
	            delete column.sort.ignoreSort;
	          }
	        });
	
	        grid.treeBase.tree = service.sortInternal( grid, grid.treeBase.tree );
	      },
	
	      sortInternal: function( grid, treeList ) {
	        var rows = treeList.map( function( node ) {
	          return node.row;
	        });
	
	        rows = rowSorter.sort( grid, rows, grid.columns );
	
	        var treeNodes = rows.map( function( row ) {
	          return row.treeNode;
	        });
	
	        treeNodes.forEach( function( node ) {
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ) {
	            node.children = service.sortInternal( grid, node.children );
	          }
	        });
	
	        return treeNodes;
	      },
	
	      /**
	       * @ngdoc function
	       * @name fixFilter
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description After filtering has run, we need to go back through the tree
	       * and make sure the parent rows are always visible if any of the child rows
	       * are visible (filtering may make a child visible, but the parent may not
	       * match the filter criteria)
	       *
	       * This has a risk of being computationally expensive, we do it by walking
	       * the tree and remembering whether there are any invisible nodes on the
	       * way down.
	       *
	       * @param {Grid} grid the grid to fix filters on
	       */
	      fixFilter: function( grid ) {
	        var parentsVisible;
	
	        grid.treeBase.tree.forEach( function( node ) {
	          if ( node.children && node.children.length > 0 ) {
	            parentsVisible = node.row.visible;
	            service.fixFilterInternal( node.children, parentsVisible );
	          }
	        });
	      },
	
	      fixFilterInternal: function( nodes, parentsVisible) {
	        nodes.forEach(function( node ) {
	          if ( node.row.visible && !parentsVisible ) {
	            service.setParentsVisible( node );
	            parentsVisible = true;
	          }
	
	          if ( node.children && node.children.length > 0 ) {
	            if ( service.fixFilterInternal( node.children, ( parentsVisible && node.row.visible ) ) ) {
	              parentsVisible = true;
	            }
	          }
	        });
	
	        return parentsVisible;
	      },
	
	      setParentsVisible: function( node ) {
	        while ( node.parentRow ) {
	          node.parentRow.visible = true;
	          node = node.parentRow.treeNode;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name buildAggregationObject
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Build the object which is stored on the column for holding meta-data about the aggregation.
	       * This method should only be called with columns which have an aggregation.
	       *
	       * @param {GridColumn} column The column which this object relates to
	       * @returns {object} {col: GridColumn object, label: string, type: string (optional)}
	       */
	      buildAggregationObject: function( column ) {
	        var newAggregation = { col: column };
	
	        if ( column.treeAggregation && column.treeAggregation.type ) {
	          newAggregation.type = column.treeAggregation.type;
	        }
	
	        if ( column.treeAggregation && column.treeAggregation.label ) {
	          newAggregation.label = column.treeAggregation.label;
	        }
	
	        return newAggregation;
	      },
	
	      /**
	       * @ngdoc function
	       * @name getAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks through the grid columns to find those with aggregations,
	       * and collates the aggregation information into an array, returns that array
	       *
	       * @param {Grid} grid the grid to get the aggregation information from
	       * @returns {array} the aggregation information
	       */
	      getAggregations: function( grid ) {
	        var aggregateArray = [];
	
	        grid.columns.forEach( function(column) {
	          if ( typeof(column.treeAggregationFn) !== 'undefined' ) {
	            aggregateArray.push( service.buildAggregationObject(column) );
	
	            if ( grid.options.showColumnFooter && typeof(column.colDef.aggregationType) === 'undefined' && column.treeAggregation ) {
	              // Add aggregation object for footer
	              column.treeFooterAggregation = service.buildAggregationObject(column);
	              column.aggregationType = service.treeFooterAggregationType;
	            }
	          }
	        });
	        return aggregateArray;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name aggregate
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Accumulate the data from this row onto the aggregations for each parent
	       *
	       * Iterate over the parents, then iterate over the aggregations for each of those parents,
	       * and perform the aggregation for each individual aggregation
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to set grouping visibility on
	       * @param {array} parents the parents that we would want to aggregate onto
	       */
	      aggregate: function( grid, row, parents ) {
	        if (parents.length === 0 && row.treeNode && row.treeNode.aggregations) {
	          row.treeNode.aggregations.forEach(function(aggregation) {
	            // Calculate aggregations for footer even if there are no grouped rows
	            if (typeof(aggregation.col.treeFooterAggregation) !== 'undefined') {
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              if (aggregation.col.treeAggregationFn) {
	                aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	              } else {
	                aggregation.col.treeFooterAggregation.value = undefined;
	              }
	            }
	          });
	        }
	
	        parents.forEach( function( parent, index ) {
	          if (parent.treeNode.aggregations) {
	            parent.treeNode.aggregations.forEach( function( aggregation ) {
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              aggregation.col.treeAggregationFn(aggregation, fieldValue, numValue, row);
	
	              if (index === 0 && typeof(aggregation.col.treeFooterAggregation) !== 'undefined') {
	                if (aggregation.col.treeAggregationFn) {
	                  aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	                } else {
	                  aggregation.col.treeFooterAggregation.value = undefined;
	                }
	              }
	            });
	          }
	        });
	      },
	
	
	      // Aggregation routines - no doco needed as self evident
	      nativeAggregations: function() {
	        return {
	          count: {
	            label: i18nService.get().aggregation.count,
	            menuTitle: i18nService.get().grouping.aggregate_count,
	            aggregationFn: function (aggregation, fieldValue, numValue) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = 1;
	              } else {
	                aggregation.value++;
	              }
	            }
	          },
	
	          sum: {
	            label: i18nService.get().aggregation.sum,
	            menuTitle: i18nService.get().grouping.aggregate_sum,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (!isNaN(numValue)) {
	                if (typeof(aggregation.value) === 'undefined') {
	                  aggregation.value = numValue;
	                } else {
	                  aggregation.value += numValue;
	                }
	              }
	            }
	          },
	
	          min: {
	            label: i18nService.get().aggregation.min,
	            menuTitle: i18nService.get().grouping.aggregate_min,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = fieldValue;
	              } else {
	                if (typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue < aggregation.value || aggregation.value === null)) {
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          max: {
	            label: i18nService.get().aggregation.max,
	            menuTitle: i18nService.get().grouping.aggregate_max,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if ( typeof(aggregation.value) === 'undefined' ) {
	                aggregation.value = fieldValue;
	              } else {
	                if ( typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue > aggregation.value || aggregation.value === null)) {
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          avg: {
	            label: i18nService.get().aggregation.avg,
	            menuTitle: i18nService.get().grouping.aggregate_avg,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if ( typeof(aggregation.count) === 'undefined' ) {
	                aggregation.count = 1;
	              } else {
	                aggregation.count++;
	              }
	
	              if ( isNaN(numValue) ) {
	                return;
	              }
	
	              if ( typeof(aggregation.value) === 'undefined' || typeof(aggregation.sum) === 'undefined' ) {
	                aggregation.value = numValue;
	                aggregation.sum = numValue;
	              } else {
	                aggregation.sum += numValue;
	                aggregation.value = aggregation.sum / aggregation.count;
	              }
	            }
	          }
	        };
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregation
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Helper function used to finalize aggregation nodes and footer cells
	       *
	       * @param {gridRow} row The parent we're finalising
	       * @param {aggregation} aggregation The aggregation object manipulated by the aggregationFn
	       */
	      finaliseAggregation: function(row, aggregation) {
	        if ( aggregation.col.treeAggregationUpdateEntity && typeof(row) !== 'undefined' && typeof(row.entity[ '$$' + aggregation.col.uid ]) !== 'undefined' ) {
	          angular.extend( aggregation, row.entity[ '$$' + aggregation.col.uid ]);
	        }
	
	        if ( typeof(aggregation.col.treeAggregationFinalizerFn) === 'function' ) {
	          aggregation.col.treeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.col.customTreeAggregationFinalizerFn) === 'function' ) {
	          aggregation.col.customTreeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.rendered) === 'undefined' ) {
	          aggregation.rendered = aggregation.label ? aggregation.label + aggregation.value : aggregation.value;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Format the data from the aggregation into the rendered text
	       * e.g. if we had label: 'sum: ' and value: 25, we'd create 'sum: 25'.
	       *
	       * As part of this we call any formatting callback routines we've been provided.
	       *
	       * We write our aggregation out to the row.entity if treeAggregationUpdateEntity is
	       * set on the column - we don't overwrite any information that's already there, we append
	       * to it so that grouping can have set the groupVal beforehand without us overwriting it.
	       *
	       * We need to copy the data from the row.entity first before we finalise the aggregation,
	       * we need that information for the finaliserFn
	       *
	       * @param {gridRow} row the parent we're finalising
	       */
	      finaliseAggregations: function( row ) {
	        if ( row == null || typeof(row.treeNode.aggregations) === 'undefined' ) {
	          return;
	        }
	
	        row.treeNode.aggregations.forEach( function( aggregation ) {
	          service.finaliseAggregation(row, aggregation);
	
	          if ( aggregation.col.treeAggregationUpdateEntity ) {
	            var aggregationCopy = {};
	
	            angular.forEach( aggregation, function( value, key ) {
	              if ( aggregation.hasOwnProperty(key) && key !== 'col' ) {
	                aggregationCopy[key] = value;
	              }
	            });
	
	            row.entity[ '$$' + aggregation.col.uid ] = aggregationCopy;
	          }
	        });
	      },
	
	      /**
	       * @ngdoc function
	       * @name treeFooterAggregationType
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Uses the tree aggregation functions and finalizers to set the
	       * column footer aggregations.
	       *
	       * @param {rows} rows The visible rows. not used, but accepted to match signature of GridColumn.aggregationType
	       * @param {GridColumn} column The column we are finalizing
	       */
	      treeFooterAggregationType: function( rows, column ) {
	        service.finaliseAggregation(undefined, column.treeFooterAggregation);
	        if ( typeof(column.treeFooterAggregation.value) === 'undefined' || column.treeFooterAggregation.rendered === null ) {
	          // The was apparently no aggregation performed (perhaps this is a grouped column
	          return '';
	        }
	        return column.treeFooterAggregation.rendered;
	      }
	    };
	
	    return service;
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeRowHeaderButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse button on rows
	   */
	  module.directive('uiGridTreeBaseRowHeaderButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseRowHeaderButtons'),
	      scope: true,
	      require: '^uiGrid',
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var self = uiGridCtrl.grid;
	        $scope.treeButtonClass = function(row) {
	          if ( ( self.options.showTreeExpandNoChildren && row.treeLevel > -1 ) || ( row.treeNode.children && row.treeNode.children.length > 0 ) ) {
	            if (row.treeNode.state === 'expanded' ) {
	              return 'ui-grid-icon-minus-squared';
	            }
	            if (row.treeNode.state === 'collapsed' ) {
	              return 'ui-grid-icon-plus-squared';
	            }
	          }
	        };
	        $scope.treeButtonClick = function(row, evt) {
	          evt.stopPropagation();
	          uiGridTreeBaseService.toggleRowTreeState(self, row, evt);
	        };
	        $scope.treeButtonKeyDown = function (row, evt) {
	          if (evt.keyCode === 32 || evt.keyCode === 13) {
	            $scope.treeButtonClick(row, evt);
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeBaseExpandAllButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse all button
	   */
	  module.directive('uiGridTreeBaseExpandAllButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseExpandAllButtons'),
	      scope: false,
	      link: function($scope) {
	        var self = $scope.col.grid;
	        $scope.headerButtonClass = function() {
	          if (self.treeBase.numberLevels > 0 && self.treeBase.expandAll) {
	            return 'ui-grid-icon-minus-squared';
	          }
	          if (self.treeBase.numberLevels > 0 && !self.treeBase.expandAll) {
	            return 'ui-grid-icon-plus-squared';
	          }
	        };
	        $scope.headerButtonClick = function(row, evt) {
	          if ( self.treeBase.expandAll ) {
	            uiGridTreeBaseService.collapseAllRows(self, evt);
	          } else {
	            uiGridTreeBaseService.expandAllRows(self, evt);
	          }
	        };
	        $scope.headerButtonKeyDown = function (evt) {
	          if (evt.keyCode === 32 || evt.keyCode === 13) {
	            $scope.headerButtonClick(self, evt);
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to set formatting on a tree header row
	   */
	  module.directive('uiGridViewport',
	    function () {
	      return {
	        priority: -200, // run after default  directive
	        scope: false,
	        compile: function ($elm) {
	          var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	          var existingNgClass = rowRepeatDiv.attr("ng-class");
	          var newNgClass = '';
	          if ( existingNgClass ) {
	            newNgClass = existingNgClass.slice(0, -1) + ",'ui-grid-tree-header-row': row.treeLevel > -1}";
	          } else {
	            newNgClass = "{'ui-grid-tree-header-row': row.treeLevel > -1}";
	          }
	          rowRepeatDiv.attr("ng-class", newNgClass);
	
	          return {
	            pre: function ($scope, $elm, $attrs, controllers) {
	
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	            }
	          };
	        }
	      };
	    });
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeView
	   * @description
	   *
	   * # ui.grid.treeView
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides a tree view of the data that it is provided, with nodes in that
	   * tree and leaves.  Unlike grouping, the tree is an inherent property of the data and must
	   * be provided with your data array.
	   *
	   * Design information:
	   * -------------------
	   *
	   * TreeView uses treeBase for the underlying functionality, and is a very thin wrapper around
	   * that logic.  Most of the design information has now moved to treebase.
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeView"></div>
	   */
	
	  var module = angular.module('ui.grid.treeView', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeView.constant:uiGridTreeViewConstants
	   *
	   *  @description constants available in treeView module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridTreeViewConstants', {
	    featureName: "treeView",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeView.service:uiGridTreeViewService
	   *
	   *  @description Services for treeView features
	   */
	  module.service('uiGridTreeViewService', ['$q', 'uiGridTreeViewConstants', 'uiGridTreeBaseConstants', 'uiGridTreeBaseService', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants',
	  function ($q, uiGridTreeViewConstants, uiGridTreeBaseConstants, uiGridTreeBaseService, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.grid:treeView
	         *
	         *  @description Grid properties and functions added for treeView
	         */
	        grid.treeView = {};
	
	        grid.registerRowsProcessor(service.adjustSorting, 60);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:PublicApi
	         *
	         *  @description Public Api for treeView feature
	         */
	        var publicApi = {
	          events: {
	            treeView: {
	            }
	          },
	          methods: {
	            treeView: {
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        // default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:GridOptions
	         *
	         *  @description GridOptions for treeView feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         *
	         *  Many tree options are set on treeBase, make sure to look at that feature in
	         *  conjunction with these options.
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableTreeView
	         *  @propertyOf  ui.grid.treeView.api:GridOptions
	         *  @description Enable row tree view for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableTreeView = gridOptions.enableTreeView !== false;
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustSorting
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Trees cannot be sorted the same as flat lists of rows -
	       * trees are sorted recursively within each level - so the children of each
	       * node are sorted, but not the full set of rows.
	       *
	       * To achieve this, we suppress the normal sorting by setting ignoreSort on
	       * each of the sort columns.  When the treeBase rowsProcessor runs it will then
	       * unignore these, and will perform a recursive sort against the tree that it builds.
	       *
	       * @param {array} renderableRows the rows that we need to pass on through
	       * @returns {array} renderableRows that we passed on through
	       */
	      adjustSorting: function( renderableRows ) {
	        var grid = this;
	
	        grid.columns.forEach( function( column ) {
	          if ( column.sort ) {
	            column.sort.ignoreSort = true;
	          }
	        });
	
	        return renderableRows;
	      }
	    };
	
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeView.directive:uiGridTreeView
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds treeView features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.treeView']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-tree-view></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridTreeView', ['uiGridTreeViewConstants', 'uiGridTreeViewService', '$templateCache',
	  function (uiGridTreeViewConstants, uiGridTreeViewService, $templateCache) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableTreeView !== false) {
	              uiGridTreeViewService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.validate
	   * @description
	   *
	   * # ui.grid.validate
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to validate cells upon change.
	   *
	   * Design information:
	   * -------------------
	   *
	   * Validation is not based on angularjs validation, since it would work only when editing the field.
	   *
	   * Instead it adds custom properties to any field considered as invalid.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.expandable"></div>
	   */
	  var module = angular.module('ui.grid.validate', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.validate.service:uiGridValidateService
	   *
	   *  @description Services for validation features
	   */
	  module.service('uiGridValidateService', ['$sce', '$q', '$http', 'i18nService', 'uiGridConstants', function ($sce, $q, $http, i18nService, uiGridConstants) {
	
	    var service = {
	
	      /**
	       *  @ngdoc object
	       *  @name validatorFactories
	       *  @propertyOf ui.grid.validate.service:uiGridValidateService
	       *  @description object containing all the factories used to validate data.<br/>
	       *  These factories will be in the form <br/>
	       *  ```
	       *  {
	       *    validatorFactory: function(argument) {
	       *                        return function(newValue, oldValue, rowEntity, colDef) {
	       *                          return true || false || promise
	       *                        }
	       *                      },
	       *    messageFunction: function(argument) {
	       *                       return string
	       *                     }
	       *  }
	       *  ```
	       *
	       * Promises should return true or false as result according to the result of validation.
	       */
	      validatorFactories: {},
	
	      /**
	       * @ngdoc service
	       * @name setExternalFactoryFunction
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Adds a way to retrieve validators from an external service
	       * <p>Validators from this external service have a higher priority than default
	       * ones
	       * @param {function} externalFactoryFunction a function that accepts name and argument to pass to a
	       * validator factory and that returns an object with the same properties as
	       * you can see in {@link ui.grid.validate.service:uiGridValidateService#properties_validatorFactories validatorFactories}
	       */
	      setExternalFactoryFunction: function(externalFactoryFunction) {
	        service.externalFactoryFunction = externalFactoryFunction;
	      },
	
	      /**
	       * @ngdoc service
	       * @name clearExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Removes any link to external factory from this service
	       */
	      clearExternalFactory: function() {
	        delete service.externalFactoryFunction;
	      },
	
	      /**
	       * @ngdoc service
	       * @name getValidatorFromExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Retrieves a validator by executing a validatorFactory
	       * stored in an external service.
	       * @param {string} name the name of the validator to retrieve
	       * @param {object} argument an argument to pass to the validator factory
	       */
	      getValidatorFromExternalFactory: function(name, argument) {
	        return service.externalFactoryFunction(name, argument).validatorFactory(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name getMessageFromExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Retrieves a message stored in an external service.
	       * @param {string} name the name of the validator
	       * @param {object} argument an argument to pass to the message function
	       */
	      getMessageFromExternalFactory: function(name, argument) {
	        return service.externalFactoryFunction(name, argument).messageFunction(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name setValidator
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description  Adds a new validator to the service
	       * @param {string} name the name of the validator, must be unique
	       * @param {function} validatorFactory a factory that return a validatorFunction
	       * @param {function} messageFunction a function that return the error message
	       */
	      setValidator: function(name, validatorFactory, messageFunction) {
	        service.validatorFactories[name] = {
	          validatorFactory: validatorFactory,
	          messageFunction: messageFunction
	        };
	      },
	
	      /**
	       * @ngdoc service
	       * @name getValidator
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns a validator registered to the service
	       * or retrieved from the external factory
	       * @param {string} name the name of the validator to retrieve
	       * @param {object} argument an argument to pass to the validator factory
	       * @returns {object} the validator function
	       */
	      getValidator: function(name, argument) {
	        if (service.externalFactoryFunction) {
	          var validator = service.getValidatorFromExternalFactory(name, argument);
	          if (validator) {
	            return validator;
	          }
	        }
	        if (!service.validatorFactories[name]) {
	          throw ("Invalid validator name: " + name);
	        }
	        return service.validatorFactories[name].validatorFactory(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name getMessage
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns the error message related to the validator
	       * @param {string} name the name of the validator
	       * @param {object} argument an argument to pass to the message function
	       * @returns {string} the error message related to the validator
	       */
	      getMessage: function(name, argument) {
	        if (service.externalFactoryFunction) {
	          var message = service.getMessageFromExternalFactory(name, argument);
	          if (message) {
	            return message;
	          }
	        }
	        return service.validatorFactories[name].messageFunction(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name isInvalid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns true if the cell (identified by rowEntity, colDef) is invalid
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @returns {boolean} true if the cell is invalid
	       */
	      isInvalid: function (rowEntity, colDef) {
	        return rowEntity['$$invalid'+colDef.name];
	      },
	
	      /**
	       * @ngdoc service
	       * @name setInvalid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Makes the cell invalid by adding the proper field to the entity
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       */
	      setInvalid: function (rowEntity, colDef) {
	        rowEntity['$$invalid'+colDef.name] = true;
	      },
	
	      /**
	       * @ngdoc service
	       * @name setValid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Makes the cell valid by removing the proper error field from the entity
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       */
	      setValid: function (rowEntity, colDef) {
	        delete rowEntity['$$invalid'+colDef.name];
	      },
	
	      /**
	       * @ngdoc service
	       * @name setError
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Adds the proper error to the entity errors field
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @param {string} validatorName the name of the validator that is failing
	       */
	      setError: function(rowEntity, colDef, validatorName) {
	        if (!rowEntity['$$errors'+colDef.name]) {
	          rowEntity['$$errors'+colDef.name] = {};
	        }
	        rowEntity['$$errors'+colDef.name][validatorName] = true;
	      },
	
	      /**
	       * @ngdoc service
	       * @name clearError
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Removes the proper error from the entity errors field
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @param {string} validatorName the name of the validator that is failing
	       */
	      clearError: function(rowEntity, colDef, validatorName) {
	        if (!rowEntity['$$errors'+colDef.name]) {
	          return;
	        }
	        if (validatorName in rowEntity['$$errors'+colDef.name]) {
	            delete rowEntity['$$errors'+colDef.name][validatorName];
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name getErrorMessages
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description returns an array of i18n-ed error messages.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {array} An array of strings containing all the error messages for the cell
	       */
	      getErrorMessages: function(rowEntity, colDef) {
	        var errors = [];
	
	        if (!rowEntity['$$errors'+colDef.name] || Object.keys(rowEntity['$$errors'+colDef.name]).length === 0) {
	          return errors;
	        }
	
	        Object.keys(rowEntity['$$errors'+colDef.name]).sort().forEach(function(validatorName) {
	          errors.push(service.getMessage(validatorName, colDef.validators[validatorName]));
	        });
	
	        return errors;
	      },
	
	      /**
	       * @ngdoc function
	       * @name getFormattedErrors
	       * @methodOf  ui.grid.validate.service:uiGridValidateService
	       * @description returns the error i18n-ed and formatted in html to be shown inside the page.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	       * message inside the page (i.e. inside a div)
	       */
	      getFormattedErrors: function(rowEntity, colDef) {
	        var msgString = "",
	          errors = service.getErrorMessages(rowEntity, colDef);
	
	        if (!errors.length) {
	          return;
	        }
	
	        errors.forEach(function(errorMsg) {
	          msgString += errorMsg + "<br/>";
	        });
	
	        return $sce.trustAsHtml('<p><b>' + i18nService.getSafeText('validate.error') + '</b></p>' + msgString );
	      },
	
	      /**
	       * @ngdoc function
	       * @name getTitleFormattedErrors
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html
	       * title attribute.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	       * message inside an html title attribute
	       */
	      getTitleFormattedErrors: function(rowEntity, colDef) {
	        var newLine = "\n",
	          msgString = "",
	          errors = service.getErrorMessages(rowEntity, colDef);
	
	        if (!errors.length) {
	          return;
	        }
	
	        errors.forEach(function(errorMsg) {
	          msgString += errorMsg + newLine;
	        });
	
	        return $sce.trustAsHtml(i18nService.getSafeText('validate.error') + newLine + msgString);
	      },
	
	      /**
	       * @ngdoc function
	       * @name getTitleFormattedErrors
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Executes all validators on a cell (identified by row entity and column definition) and sets or clears errors
	       * @param {object} rowEntity the row entity of the cell we want to run the validators on
	       * @param {object} colDef the column definition of the cell we want to run the validators on
	       * @param {object} newValue the value the user just entered
	       * @param {object} oldValue the value the field had before
	       */
	      runValidators: function(rowEntity, colDef, newValue, oldValue, grid) {
	        if (newValue === oldValue) {
	          // If the value has not changed we perform no validation
	          return;
	        }
	
	        if (typeof(colDef.name) === 'undefined' || !colDef.name) {
	          throw new Error('colDef.name is required to perform validation');
	        }
	
	        service.setValid(rowEntity, colDef);
	
	        var validateClosureFactory = function(rowEntity, colDef, validatorName) {
	          return function(value) {
	            if (!value) {
	              service.setInvalid(rowEntity, colDef);
	              service.setError(rowEntity, colDef, validatorName);
	              if (grid) {
	                grid.api.validate.raise.validationFailed(rowEntity, colDef, newValue, oldValue);
	              }
	            }
	          };
	        };
	
	        var promises = [];
	
	        for (var validatorName in colDef.validators) {
	          service.clearError(rowEntity, colDef, validatorName);
	          var validatorFunction = service.getValidator(validatorName, colDef.validators[validatorName]);
	
	          // We pass the arguments as oldValue, newValue so they are in the same order
	          // as ng-model validators (modelValue, viewValue)
	          var promise = $q.when(validatorFunction(oldValue, newValue, rowEntity, colDef))
	            .then(validateClosureFactory(rowEntity, colDef, validatorName));
	
	          promises.push(promise);
	        }
	
	        return $q.all(promises);
	      },
	
	      /**
	       * @ngdoc function
	       * @name createDefaultValidators
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description adds the basic validators to the list of service validators
	       */
	      createDefaultValidators: function() {
	        service.setValidator('minLength', function (argument) {
	          return function (oldValue, newValue) {
	            if (newValue === undefined || newValue === null || newValue === '') {
	              return true;
	            }
	            return newValue.length >= argument;
	          };
	        }, function(argument) {
	          return i18nService.getSafeText('validate.minLength').replace('THRESHOLD', argument);
	        });
	
	        service.setValidator('maxLength', function (argument) {
	          return function (oldValue, newValue) {
	            if (newValue === undefined || newValue === null || newValue === '') {
	              return true;
	            }
	            return newValue.length <= argument;
	          };
	        }, function(threshold) {
	          return i18nService.getSafeText('validate.maxLength').replace('THRESHOLD', threshold);
	        });
	
	        service.setValidator('required', function (argument) {
	          return function (oldValue, newValue) {
	            if (argument) {
	              return !(newValue === undefined || newValue === null || newValue === '');
	            }
	            return true;
	          };
	        }, function() {
	          return i18nService.getSafeText('validate.required');
	        });
	      },
	
	      initializeGrid: function (scope, grid) {
	        grid.validate = {
	
	          isInvalid: service.isInvalid,
	
	          getErrorMessages: service.getErrorMessages,
	
	          getFormattedErrors: service.getFormattedErrors,
	
	          getTitleFormattedErrors: service.getTitleFormattedErrors,
	
	          runValidators: service.runValidators
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.validate.api:PublicApi
	         *
	         *  @description Public Api for validation feature
	         */
	        var publicApi = {
	          events: {
	            validate: {
	              /**
	               * @ngdoc event
	               * @name validationFailed
	               * @eventOf ui.grid.validate.api:PublicApi
	               * @description raised when one or more failure happened during validation
	               * <pre>
	               *      gridApi.validate.on.validationFailed(scope, function(rowEntity, colDef, newValue, oldValue){...})
	               * </pre>
	               * @param {object} rowEntity the options.data element whose validation failed
	               * @param {object} colDef the column whose validation failed
	               * @param {object} newValue new value
	               * @param {object} oldValue old value
	               */
	              validationFailed: function (rowEntity, colDef, newValue, oldValue) {
	              }
	            }
	          },
	          methods: {
	            validate: {
	              /**
	               * @ngdoc function
	               * @name isInvalid
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description checks if a cell (identified by rowEntity, colDef) is invalid
	               * @param {object} rowEntity gridOptions.data[] array instance we want to check
	               * @param {object} colDef the column whose errors we want to check
	               * @returns {boolean} true if the cell value is not valid
	               */
	              isInvalid: function(rowEntity, colDef) {
	                return grid.validate.isInvalid(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getErrorMessages
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description returns an array of i18n-ed error messages.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {array} An array of strings containing all the error messages for the cell
	               */
	              getErrorMessages: function (rowEntity, colDef) {
	                return grid.validate.getErrorMessages(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getFormattedErrors
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description returns the error i18n-ed and formatted in html to be shown inside the page.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	               * message inside the page (i.e. inside a div)
	               */
	              getFormattedErrors: function (rowEntity, colDef) {
	                return grid.validate.getFormattedErrors(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getTitleFormattedErrors
	               * @methodOf ui.grid.validate.api:PublicApi
	               * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html
	               * title attribute.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	               * message inside an html title attribute
	               */
	              getTitleFormattedErrors: function (rowEntity, colDef) {
	                return grid.validate.getTitleFormattedErrors(rowEntity, colDef);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	        if (grid.edit) {
	          grid.api.edit.on.afterCellEdit(scope, function(rowEntity, colDef, newValue, oldValue) {
	            grid.validate.runValidators(rowEntity, colDef, newValue, oldValue, grid);
	          });
	        }
	
	        service.createDefaultValidators();
	      }
	    };
	
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.validate.directive:uiGridValidate
	   *  @element div
	   *  @restrict A
	   *  @description Adds validating features to the ui-grid directive.
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.edit', 'ui.grid.validate']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true, validators: {minLength: 3, maxLength: 9}, cellTemplate: 'ui-grid/cellTitleValidator'},
	        {name: 'title', enableCellEdit: true, validators: {required: true}, cellTemplate: 'ui-grid/cellTitleValidator'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit ui-grid-validate></div>
	   </div>
	   </file>
	   </example>
	   */
	
	  module.directive('uiGridValidate', ['gridUtil', 'uiGridValidateService', function (gridUtil, uiGridValidateService) {
	    return {
	      priority: 0,
	      replace: true,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridValidateService.initializeGrid($scope, uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	angular.module('ui.grid').run(['$templateCache', function($templateCache) {
	  'use strict';
	
	  $templateCache.put('ui-grid/ui-grid-filter',
	    "<div class=\"ui-grid-filter-container\" ng-style=\"col.extraStyle\" ng-repeat=\"colFilter in col.filters\" ng-class=\"{'ui-grid-filter-cancel-button-hidden' : colFilter.disableCancelFilterButton === true }\"><div ng-if=\"colFilter.type !== 'select'\"><input type=\"text\" class=\"ui-grid-filter-input ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\"><div role=\"button\" class=\"ui-grid-filter-button\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== ''\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div><div ng-if=\"colFilter.type === 'select'\"><select class=\"ui-grid-filter-select ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-show=\"colFilter.selectOptions.length > 0\" ng-attr-placeholder=\"{{colFilter.placeholder || aria.defaultFilterLabel}}\" aria-label=\"{{colFilter.ariaLabel || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div role=\"button\" class=\"ui-grid-filter-button-select\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-footer',
	    "<div class=\"ui-grid-footer-panel ui-grid-footer-aggregates-row\"><!-- tfooter --><div class=\"ui-grid-footer ui-grid-footer-viewport\"><div class=\"ui-grid-footer-canvas\"><div class=\"ui-grid-footer-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-footer-cell-row\"><div ui-grid-footer-cell role=\"gridcell\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" col=\"col\" render-index=\"$index\" class=\"ui-grid-footer-cell ui-grid-clearfix\"></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-grid-footer',
	    "<div class=\"ui-grid-footer-info ui-grid-grid-footer\"><span>{{'search.totalItems' | t}} {{grid.rows.length}}</span> <span ng-if=\"grid.renderContainers.body.visibleRowCache.length !== grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-header',
	    "<div role=\"rowgroup\" class=\"ui-grid-header\"><!-- theader --><div class=\"ui-grid-top-panel\"><div class=\"ui-grid-header-viewport\"><div class=\"ui-grid-header-canvas\"><div class=\"ui-grid-header-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-header-cell-row\"><div role=\"columnheader\" class=\"ui-grid-header-cell ui-grid-clearfix\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" ui-grid-header-cell col=\"col\" render-index=\"$index\"></div></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-menu-button',
	    "<div class=\"ui-grid-menu-button\"><div role=\"button\" ui-grid-one-bind-id-grid=\"'grid-menu'\" class=\"ui-grid-icon-container\" ng-click=\"toggleMenu()\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-menu\" ui-grid-one-bind-aria-label=\"i18n.aria.buttonLabel\">&nbsp;</i></div><div ui-grid-menu menu-items=\"menuItems\"></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-menu-header-item',
	    "<li role=\"menuitem\"><div class=\"ui-grid-menu-item\" role=\"heading\" aria-level=\"2\" ng-show=\"itemShown()\"><i aria-hidden=\"true\">&nbsp; </i><span ng-bind=\"label()\"></span></div></li>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-no-header',
	    "<div class=\"ui-grid-top-panel\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-row',
	    "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid',
	    "<div ui-i18n=\"en\" class=\"ui-grid\"><!-- TODO (c0bra): add \"scoped\" attr here, eventually? --><style ui-grid-style>.grid{{ grid.id }} {\n" +
	    "      /* Styles for the grid */\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row, .grid{{ grid.id }} .ui-grid-cell, .grid{{ grid.id }} .ui-grid-cell .ui-grid-vertical-bar {\n" +
	    "      height: {{ grid.options.rowHeight }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row:last-child .ui-grid-cell {\n" +
	    "      border-bottom-width: {{ (((grid.getVisibleRowCount() * grid.options.rowHeight) < grid.getViewportHeight()) && '1') || '0' }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    {{ grid.verticalScrollbarStyles }}\n" +
	    "    {{ grid.horizontalScrollbarStyles }}\n" +
	    "\n" +
	    "    /*\n" +
	    "    .ui-grid[dir=rtl] .ui-grid-viewport {\n" +
	    "      padding-left: {{ grid.verticalScrollbarWidth }}px;\n" +
	    "    }\n" +
	    "    */\n" +
	    "\n" +
	    "    {{ grid.customStyles }}</style><div class=\"ui-grid-contents-wrapper\" role=\"grid\"><div ui-grid-menu-button ng-if=\"grid.options.enableGridMenu\"></div><div ng-if=\"grid.hasLeftContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'left'\"></div><div ui-grid-render-container container-id=\"'body'\" col-container-name=\"'body'\" row-container-name=\"'body'\" bind-scroll-horizontal=\"true\" bind-scroll-vertical=\"true\" enable-horizontal-scrollbar=\"grid.options.enableHorizontalScrollbar\" enable-vertical-scrollbar=\"grid.options.enableVerticalScrollbar\"></div><div ng-if=\"grid.hasRightContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'right'\"></div><div ui-grid-grid-footer ng-if=\"grid.options.showGridFooter\"></div><div ui-grid-column-menu ng-if=\"grid.options.enableColumnMenus\"></div><div ng-transclude></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridCell',
	    "<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridColumnMenu',
	    "<div class=\"ui-grid-column-menu\"><div ui-grid-menu menu-items=\"menuItems\" col=\"col\"><!-- <div class=\"ui-grid-column-menu\">\n" +
	    "    <div class=\"inner\" ng-show=\"menuShown\">\n" +
	    "      <ul>\n" +
	    "        <div ng-show=\"grid.options.enableSorting\">\n" +
	    "          <li ng-click=\"sortColumn($event, asc)\" ng-class=\"{ 'selected' : col.sort.direction == asc }\"><i class=\"ui-grid-icon-sort-alt-up\"></i> Sort Ascending</li>\n" +
	    "          <li ng-click=\"sortColumn($event, desc)\" ng-class=\"{ 'selected' : col.sort.direction == desc }\"><i class=\"ui-grid-icon-sort-alt-down\"></i> Sort Descending</li>\n" +
	    "          <li ng-show=\"col.sort.direction\" ng-click=\"unsortColumn()\"><i class=\"ui-grid-icon-cancel\"></i> Remove Sort</li>\n" +
	    "        </div>\n" +
	    "      </ul>\n" +
	    "    </div>\n" +
	    "  </div> --></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridFooterCell',
	    "<div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><div>{{ col.getAggregationText() + ( col.getAggregationValue() CUSTOM_FILTERS ) }}</div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridHeaderCell',
	    "<div role=\"columnheader\" ng-class=\"{ 'sortable': sortable, 'ui-grid-header-cell-last-col': isLastCol }\" ui-grid-one-bind-aria-labelledby-grid=\"col.uid + '-header-text ' + col.uid + '-sortdir-text'\" aria-sort=\"{{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending' : (!col.sort.direction ? 'none' : 'other'))}}\"><div role=\"button\" tabindex=\"0\" ng-keydown=\"handleKeyDown($event)\" class=\"ui-grid-cell-contents ui-grid-header-cell-primary-focus\" col-index=\"renderIndex\" title=\"TOOLTIP\"><span class=\"ui-grid-header-cell-label\" ui-grid-one-bind-id-grid=\"col.uid + '-header-text'\">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-one-bind-id-grid=\"col.uid + '-sortdir-text'\" ui-grid-visible=\"col.sort.direction\" aria-label=\"{{getSortDirectionAriaLabel()}}\"><i ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\" title=\"{{isSortPriorityVisible() ? i18n.headerCell.priority + ' ' + ( col.sort.priority + 1 )  : null}}\" aria-hidden=\"true\"></i> <sub ui-grid-visible=\"isSortPriorityVisible()\" class=\"ui-grid-sort-priority-number\">{{col.sort.priority + 1}}</sub></span></div><div role=\"button\" tabindex=\"0\" ui-grid-one-bind-id-grid=\"col.uid + '-menu-button'\" class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event)\" ng-keydown=\"headerCellArrowKeyDown($event)\" ui-grid-one-bind-aria-label=\"i18n.headerCell.aria.columnMenuButtonLabel\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-angle-down\" aria-hidden=\"true\">&nbsp;</i></div><div ui-grid-filter ng-if=\"col.filterContainer === 'headerCell'\"></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenu',
	    "<div class=\"ui-grid-menu\" ng-show=\"shown\"><style ui-grid-style>{{dynamicStyles}}</style><div class=\"ui-grid-menu-mid\" ng-show=\"shownMid\"><div class=\"ui-grid-menu-inner\" ng-if=\"shown\"><ul role=\"menu\" class=\"ui-grid-menu-items\"><li ng-repeat=\"item in menuItems\" role=\"menuitem\" ui-grid-menu-item ui-grid-one-bind-id=\"'menuitem-'+$index\" action=\"item.action\" name=\"item.title\" active=\"item.active\" icon=\"item.icon\" shown=\"item.shown\" context=\"item.context\" template-url=\"item.templateUrl\" leave-open=\"item.leaveOpen\" screen-reader-only=\"item.screenReaderOnly\"></li><li ng-if=\"col.filterable && col.filterContainer === 'columnMenu'\"><div ui-grid-filter></div></li></ul></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenuItem',
	    "<button type=\"button\" class=\"ui-grid-menu-item\" ng-click=\"itemAction($event, title)\" ng-show=\"itemShown()\" ng-class=\"{ 'ui-grid-menu-item-active': active(), 'ui-grid-sr-only': (!focus && screenReaderOnly) }\" aria-pressed=\"{{active()}}\" tabindex=\"0\" ng-focus=\"focus=true\" ng-blur=\"focus=false\"><i ng-class=\"icon\" aria-hidden=\"true\">&nbsp; </i>{{ label() }}</button>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridRenderContainer',
	    "<div role=\"presentation\" ui-grid-one-bind-id-grid=\"containerId + '-grid-container'\" class=\"ui-grid-render-container\" ng-style=\"{ 'margin-left': colContainer.getMargin('left') + 'px', 'margin-right': colContainer.getMargin('right') + 'px' }\"><!-- All of these dom elements are replaced in place --><div ui-grid-header></div><div ui-grid-viewport></div><div ng-if=\"colContainer.needsHScrollbarPlaceholder()\" class=\"ui-grid-scrollbar-placeholder\" ng-style=\"{height: colContainer.grid.scrollbarHeight + 'px'}\"></div><ui-grid-footer ng-if=\"grid.options.showColumnFooter\"></ui-grid-footer></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridViewport',
	    "<div role=\"rowgroup\" class=\"ui-grid-viewport\" ng-style=\"colContainer.getViewportStyle()\"><!-- tbody --><div class=\"ui-grid-canvas\"><div ng-repeat=\"(rowRenderIndex, row) in rowContainer.renderedRows track by $index\" class=\"ui-grid-row\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div role=\"row\" ui-grid-row=\"row\" row-render-index=\"rowRenderIndex\"></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellEditor',
	    "<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-class=\"'colt' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/dropdownEditor',
	    "<div><form name=\"inputForm\"><select ng-class=\"'colt' + col.uid\" ui-grid-edit-dropdown ng-model=\"MODEL_COL_FIELD\" ng-options=\"field[editDropdownIdLabel] as field[editDropdownValueLabel] CUSTOM_FILTERS for field in editDropdownOptionsArray\"></select></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/fileChooserEditor',
	    "<div><form name=\"inputForm\"><input ng-class=\"'colt' + col.uid\" ui-grid-edit-file-chooser type=\"file\" id=\"files\" name=\"files[]\" ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/emptyBaseLayerContainer',
	    "<div class=\"ui-grid-empty-base-layer-container ui-grid-canvas\"><div class=\"ui-grid-row\" ng-repeat=\"(rowRenderIndex, row) in grid.baseLayer.emptyRows track by $index\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div><div><div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" class=\"ui-grid-cell {{ col.getColClass(false) }}\"></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRow',
	    "<div ui-grid-expandable-row ng-if=\"expandableRow.shouldRenderExpand()\" class=\"expandableRow\" style=\"float:left; margin-top: 1px; margin-bottom: 1px\" ng-style=\"{width: (grid.renderContainers.body.getCanvasWidth()) + 'px', height: row.expandedRowHeight + 'px'}\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><i class=\"clickable\" ng-if=\"!(row.groupHeader==true || row.entity.subGridOptions.disableRowExpandable)\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !row.isExpanded, 'ui-grid-icon-minus-squared' : row.isExpanded }\" ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity, $event)\"></i></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableScrollFiller',
	    "<div ng-if=\"expandableRow.shouldRenderFiller()\" ng-class=\"{scrollFiller: true, scrollFillerClass:(colContainer.name === 'body')}\" ng-style=\"{ width: (grid.getViewportWidth()) + 'px', height: row.expandedRowHeight + 2 + 'px', 'margin-left': grid.options.rowHeader.rowHeaderWidth + 'px' }\">&nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableTopRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><span class=\"ui-grid-cell-empty\" ng-if=\"!grid.options.showExpandAllButton\"></span> <button type=\"button\" class=\"ui-grid-icon-button clickable\" ng-if=\"grid.options.showExpandAllButton\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !grid.expandable.expandedAll, 'ui-grid-icon-minus-squared' : grid.expandable.expandedAll }\" ng-click=\"grid.api.expandable.toggleAllRows()\"></button></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/csvLink',
	    "<span class=\"ui-grid-exporter-csv-link-span\"><a href=\"data:text/csv;charset=UTF-8,CSV_CONTENT\" download=\"FILE_NAME\">LINK_LABEL</a></span>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItem',
	    "<li class=\"ui-grid-menu-item\"><form><input class=\"ui-grid-importer-file-chooser\" type=\"file\" id=\"files\" name=\"files[]\"></form></li>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItemContainer',
	    "<div ui-grid-importer-menu-item></div>"
	  );
	
	
	  $templateCache.put('ui-grid/pagination',
	    "<div class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div class=\"ui-grid-pager-control\"><button type=\"button\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle' : 'first-triangle'\"><div ng-class=\"grid.isRTL() ? 'last-bar-rtl' : 'first-bar'\"></div></div></button> <button type=\"button\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle prev-triangle' : 'first-triangle prev-triangle'\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" step=\"1\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/ </abbr>{{ paginationApi.getTotalPages() }} </span><button type=\"button\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div ng-class=\"grid.isRTL() ? 'first-triangle next-triangle' : 'last-triangle next-triangle'\"></div></button> <button type=\"button\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div ng-class=\"grid.isRTL() ? 'first-triangle' : 'last-triangle'\"><div ng-class=\"grid.isRTL() ? 'first-bar-rtl' : 'last-bar'\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1 && !grid.options.useCustomPagination\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select> <span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{ 1 + paginationApi.getFirstRowIndex() }} <abbr ui-grid-one-bind-title=\"paginationThrough\">- </abbr>{{ 1 + paginationApi.getLastRowIndex() }} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/columnResizer',
	    "<div ui-grid-column-resizer ng-if=\"grid.options.enableColumnResizing\" class=\"ui-grid-column-resizer\" col=\"col\" position=\"right\" render-index=\"renderIndex\" unselectable=\"on\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/gridFooterSelectedItems',
	    "<span ng-if=\"grid.selection.selectedCount !== 0 && grid.options.enableFooterTotalSelected\">({{\"search.selectedItems\" | t}} {{grid.selection.selectedCount}})</span>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionHeaderCell',
	    "<div><!-- <div class=\"ui-grid-vertical-bar\">&nbsp;</div> --><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-selection-select-all-buttons ng-if=\"grid.options.enableSelectAll\" role=\"checkbox\" ng-model=\"grid.selection.selectAll\"></ui-grid-selection-select-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeader',
	    "<div class=\"ui-grid-cell-contents ui-grid-disable-selection clickable\"><ui-grid-selection-row-header-buttons></ui-grid-selection-row-header-buttons></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeaderButtons',
	    "<div class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok clickable\" ng-class=\"{'ui-grid-row-selected': row.isSelected}\" tabindex=\"0\" ng-click=\"selectButtonClick(row, $event)\" ng-keydown=\"selectButtonKeyDown(row, $event)\" role=\"checkbox\" ng-model=\"row.isSelected\">&nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionSelectAllButtons',
	    "<div role=\"button\" tabindex=\"0\" class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok\" ng-class=\"{'ui-grid-all-selected': grid.selection.selectAll}\" ng-click=\"headerButtonClick($event)\" ng-keydown=\"headerButtonKeyDown($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseExpandAllButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" tabindex=\"0\" ng-class=\"headerButtonClass()\" ng-click=\"headerButtonClick($event)\" ng-keydown=\"headerButtonKeyDown($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseHeaderCell',
	    "<div><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-tree-base-expand-all-buttons ng-if=\"grid.options.enableExpandAll\"></ui-grid-tree-base-expand-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeader',
	    "<div class=\"ui-grid-cell-contents\"><ui-grid-tree-base-row-header-buttons></ui-grid-tree-base-row-header-buttons></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeaderButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" ng-class=\"{'ui-grid-tree-base-header': row.treeLevel > -1 }\" tabindex=\"0\" ng-keydown=\"treeButtonKeyDown(row, $event)\" ng-click=\"treeButtonClick(row, $event)\"><i ng-class=\"treeButtonClass(row)\" ng-style=\"{'padding-left': grid.options.treeIndent * row.treeLevel + 'px'}\"></i> &nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellTitleValidator',
	    "<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" title=\"{{grid.validate.getTitleFormattedErrors(row.entity,col.colDef)}}\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellTooltipValidator',
	    "<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" tooltip-html-unsafe=\"{{grid.validate.getFormattedErrors(row.entity,col.colDef)}}\" tooltip-enable=\"grid.validate.isInvalid(row.entity,col.colDef)\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	}]);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(347);
	module.exports = 'toastr';
	


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	
	  angular.module('toastr', [])
	    .factory('toastr', toastr);
	
	  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];
	
	  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
	    var container;
	    var index = 0;
	    var toasts = [];
	
	    var previousToastMessage = '';
	    var openToasts = {};
	
	    var containerDefer = $q.defer();
	
	    var toast = {
	      active: active,
	      clear: clear,
	      error: error,
	      info: info,
	      remove: remove,
	      success: success,
	      warning: warning,
	      refreshTimer: refreshTimer
	    };
	
	    return toast;
	
	    /* Public API */
	    function active() {
	      return toasts.length;
	    }
	
	    function clear(toast) {
	      // Bit of a hack, I will remove this soon with a BC
	      if (arguments.length === 1 && !toast) { return; }
	
	      if (toast) {
	        remove(toast.toastId);
	      } else {
	        for (var i = 0; i < toasts.length; i++) {
	          remove(toasts[i].toastId);
	        }
	      }
	    }
	
	    function error(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.error;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function info(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.info;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function success(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.success;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function warning(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.warning;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function refreshTimer(toast, newTime) {
	      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
	          toast.scope.refreshTimer(newTime);
	      }
	    }
	
	    function remove(toastId, wasClicked) {
	      var toast = findToast(toastId);
	
	      if (toast && ! toast.deleting) { // Avoid clicking when fading out
	        toast.deleting = true;
	        toast.isOpened = false;
	        $animate.leave(toast.el).then(function() {
	          if (toast.scope.options.onHidden) {
	            toast.scope.options.onHidden(!!wasClicked, toast);
	          }
	          toast.scope.$destroy();
	          var index = toasts.indexOf(toast);
	          delete openToasts[toast.scope.message];
	          toasts.splice(index, 1);
	          var maxOpened = toastrConfig.maxOpened;
	          if (maxOpened && toasts.length >= maxOpened) {
	            toasts[maxOpened - 1].open.resolve();
	          }
	          if (lastToast()) {
	            container.remove();
	            container = null;
	            containerDefer = $q.defer();
	          }
	        });
	      }
	
	      function findToast(toastId) {
	        for (var i = 0; i < toasts.length; i++) {
	          if (toasts[i].toastId === toastId) {
	            return toasts[i];
	          }
	        }
	      }
	
	      function lastToast() {
	        return !toasts.length;
	      }
	    }
	
	    /* Internal functions */
	    function _buildNotification(type, message, title, optionsOverride) {
	      if (angular.isObject(title)) {
	        optionsOverride = title;
	        title = null;
	      }
	
	      return _notify({
	        iconClass: type,
	        message: message,
	        optionsOverride: optionsOverride,
	        title: title
	      });
	    }
	
	    function _getOptions() {
	      return angular.extend({}, toastrConfig);
	    }
	
	    function _createOrGetContainer(options) {
	      if(container) { return containerDefer.promise; }
	
	      container = angular.element('<div></div>');
	      container.attr('id', options.containerId);
	      container.addClass(options.positionClass);
	      container.css({'pointer-events': 'auto'});
	
	      var target = angular.element(document.querySelector(options.target));
	
	      if ( ! target || ! target.length) {
	        throw 'Target for toasts doesn\'t exist';
	      }
	
	      $animate.enter(container, target).then(function() {
	        containerDefer.resolve();
	      });
	
	      return containerDefer.promise;
	    }
	
	    function _notify(map) {
	      var options = _getOptions();
	
	      if (shouldExit()) { return; }
	
	      var newToast = createToast();
	
	      toasts.push(newToast);
	
	      if (ifMaxOpenedAndAutoDismiss()) {
	        var oldToasts = toasts.slice(0, (toasts.length - options.maxOpened));
	        for (var i = 0, len = oldToasts.length; i < len; i++) {
	          remove(oldToasts[i].toastId);
	        }
	      }
	
	      if (maxOpenedNotReached()) {
	        newToast.open.resolve();
	      }
	
	      newToast.open.promise.then(function() {
	        _createOrGetContainer(options).then(function() {
	          newToast.isOpened = true;
	          if (options.newestOnTop) {
	            $animate.enter(newToast.el, container).then(function() {
	              newToast.scope.init();
	            });
	          } else {
	            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
	            $animate.enter(newToast.el, container, sibling).then(function() {
	              newToast.scope.init();
	            });
	          }
	        });
	      });
	
	      return newToast;
	
	      function ifMaxOpenedAndAutoDismiss() {
	        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
	      }
	
	      function createScope(toast, map, options) {
	        if (options.allowHtml) {
	          toast.scope.allowHtml = true;
	          toast.scope.title = $sce.trustAsHtml(map.title);
	          toast.scope.message = $sce.trustAsHtml(map.message);
	        } else {
	          toast.scope.title = map.title;
	          toast.scope.message = map.message;
	        }
	
	        toast.scope.toastType = toast.iconClass;
	        toast.scope.toastId = toast.toastId;
	        toast.scope.extraData = options.extraData;
	
	        toast.scope.options = {
	          extendedTimeOut: options.extendedTimeOut,
	          messageClass: options.messageClass,
	          onHidden: options.onHidden,
	          onShown: generateEvent('onShown'),
	          onTap: generateEvent('onTap'),
	          progressBar: options.progressBar,
	          tapToDismiss: options.tapToDismiss,
	          timeOut: options.timeOut,
	          titleClass: options.titleClass,
	          toastClass: options.toastClass
	        };
	
	        if (options.closeButton) {
	          toast.scope.options.closeHtml = options.closeHtml;
	        }
	
	        function generateEvent(event) {
	          if (options[event]) {
	            return function() {
	              options[event](toast);
	            };
	          }
	        }
	      }
	
	      function createToast() {
	        var newToast = {
	          toastId: index++,
	          isOpened: false,
	          scope: $rootScope.$new(),
	          open: $q.defer()
	        };
	        newToast.iconClass = map.iconClass;
	        if (map.optionsOverride) {
	          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
	          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
	        }
	
	        createScope(newToast, map, options);
	
	        newToast.el = createToastEl(newToast.scope);
	
	        return newToast;
	
	        function cleanOptionsOverride(options) {
	          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop',
	                            'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
	          for (var i = 0, l = badOptions.length; i < l; i++) {
	            delete options[badOptions[i]];
	          }
	
	          return options;
	        }
	      }
	
	      function createToastEl(scope) {
	        var angularDomEl = angular.element('<div toast></div>'),
	          $compile = $injector.get('$compile');
	        return $compile(angularDomEl)(scope);
	      }
	
	      function maxOpenedNotReached() {
	        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
	      }
	
	      function shouldExit() {
	        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
	        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];
	
	        if (isDuplicateOfLast || isDuplicateOpen) {
	          return true;
	        }
	
	        previousToastMessage = map.message;
	        openToasts[map.message] = true;
	
	        return false;
	      }
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .constant('toastrConfig', {
	      allowHtml: false,
	      autoDismiss: false,
	      closeButton: false,
	      closeHtml: '<button>&times;</button>',
	      containerId: 'toast-container',
	      extendedTimeOut: 1000,
	      iconClasses: {
	        error: 'toast-error',
	        info: 'toast-info',
	        success: 'toast-success',
	        warning: 'toast-warning'
	      },
	      maxOpened: 0,
	      messageClass: 'toast-message',
	      newestOnTop: true,
	      onHidden: null,
	      onShown: null,
	      onTap: null,
	      positionClass: 'toast-top-right',
	      preventDuplicates: false,
	      preventOpenDuplicates: false,
	      progressBar: false,
	      tapToDismiss: true,
	      target: 'body',
	      templates: {
	        toast: 'directives/toast/toast.html',
	        progressbar: 'directives/progressbar/progressbar.html'
	      },
	      timeOut: 5000,
	      titleClass: 'toast-title',
	      toastClass: 'toast'
	    });
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('progressBar', progressBar);
	
	  progressBar.$inject = ['toastrConfig'];
	
	  function progressBar(toastrConfig) {
	    return {
	      require: '^toast',
	      templateUrl: function() {
	        return toastrConfig.templates.progressbar;
	      },
	      link: linkFunction
	    };
	
	    function linkFunction(scope, element, attrs, toastCtrl) {
	      var intervalId, currentTimeOut, hideTime;
	
	      toastCtrl.progressBar = scope;
	
	      scope.start = function(duration) {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	
	        currentTimeOut = parseFloat(duration);
	        hideTime = new Date().getTime() + currentTimeOut;
	        intervalId = setInterval(updateProgress, 10);
	      };
	
	      scope.stop = function() {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	      };
	
	      function updateProgress() {
	        var percentage = ((hideTime - (new Date().getTime())) / currentTimeOut) * 100;
	        element.css('width', percentage + '%');
	      }
	
	      scope.$on('$destroy', function() {
	        // Failsafe stop
	        clearInterval(intervalId);
	      });
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .controller('ToastController', ToastController);
	
	  function ToastController() {
	    this.progressBar = null;
	
	    this.startProgressBar = function(duration) {
	      if (this.progressBar) {
	        this.progressBar.start(duration);
	      }
	    };
	
	    this.stopProgressBar = function() {
	      if (this.progressBar) {
	        this.progressBar.stop();
	      }
	    };
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('toast', toast);
	
	  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];
	
	  function toast($injector, $interval, toastrConfig, toastr) {
	    return {
	      templateUrl: function() {
	        return toastrConfig.templates.toast;
	      },
	      controller: 'ToastController',
	      link: toastLinkFunction
	    };
	
	    function toastLinkFunction(scope, element, attrs, toastCtrl) {
	      var timeout;
	
	      scope.toastClass = scope.options.toastClass;
	      scope.titleClass = scope.options.titleClass;
	      scope.messageClass = scope.options.messageClass;
	      scope.progressBar = scope.options.progressBar;
	
	      if (wantsCloseButton()) {
	        var button = angular.element(scope.options.closeHtml),
	          $compile = $injector.get('$compile');
	        button.addClass('toast-close-button');
	        button.attr('ng-click', 'close(true, $event)');
	        $compile(button)(scope);
	        element.children().prepend(button);
	      }
	
	      scope.init = function() {
	        if (scope.options.timeOut) {
	          timeout = createTimeout(scope.options.timeOut);
	        }
	        if (scope.options.onShown) {
	          scope.options.onShown();
	        }
	      };
	
	      element.on('mouseenter', function() {
	        hideAndStopProgressBar();
	        if (timeout) {
	          $interval.cancel(timeout);
	        }
	      });
	
	      scope.tapToast = function () {
	        if (angular.isFunction(scope.options.onTap)) {
	          scope.options.onTap();
	        }
	        if (scope.options.tapToDismiss) {
	          scope.close(true);
	        }
	      };
	
	      scope.close = function (wasClicked, $event) {
	        if ($event && angular.isFunction($event.stopPropagation)) {
	          $event.stopPropagation();
	        }
	        toastr.remove(scope.toastId, wasClicked);
	      };
	      
	      scope.refreshTimer = function(newTime) {
	        if (timeout) {
	          $interval.cancel(timeout);
	          timeout = createTimeout(newTime || scope.options.timeOut);
	        }
	      };
	
	      element.on('mouseleave', function() {
	        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) { return; }
	        scope.$apply(function() {
	          scope.progressBar = scope.options.progressBar;
	        });
	        timeout = createTimeout(scope.options.extendedTimeOut);
	      });
	
	      function createTimeout(time) {
	        toastCtrl.startProgressBar(time);
	        return $interval(function() {
	          toastCtrl.stopProgressBar();
	          toastr.remove(scope.toastId);
	        }, time, 1);
	      }
	
	      function hideAndStopProgressBar() {
	        scope.progressBar = false;
	        toastCtrl.stopProgressBar();
	      }
	
	      function wantsCloseButton() {
	        return scope.options.closeHtml;
	      }
	    }
	  }
	}());
	
	angular.module("toastr").run(["$templateCache", function($templateCache) {$templateCache.put("directives/progressbar/progressbar.html","<div class=\"toast-progress\"></div>\n");
	$templateCache.put("directives/toast/toast.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");}]);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(349);
	
	module.exports = 'ui.bootstrap';


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 2.5.6 - 2017-10-14
	 * License: MIT
	 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', [])
	
	  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed),
	          horizontal = false,
	          css = {},
	          cssTo = {};
	
	        init();
	
	        function init() {
	          horizontal = !!('horizontal' in attrs);
	          if (horizontal) {
	            css = {
	              width: ''
	            };
	            cssTo = {width: '0'};
	          } else {
	            css = {
	              height: ''
	            };
	            cssTo = {height: '0'};
	          }
	          if (!scope.$eval(attrs.uibCollapse)) {
	            element.addClass('in')
	              .addClass('collapse')
	              .attr('aria-expanded', true)
	              .attr('aria-hidden', false)
	              .css(css);
	          }
	        }
	
	        function getScrollFromElement(element) {
	          if (horizontal) {
	            return {width: element.scrollWidth + 'px'};
	          }
	          return {height: element.scrollHeight + 'px'};
	        }
	
	        function expand() {
	          if (element.hasClass('collapse') && element.hasClass('in')) {
	            return;
	          }
	
	          $q.resolve(expandingExpr(scope))
	            .then(function() {
	              element.removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', true)
	                .attr('aria-hidden', false);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  addClass: 'in',
	                  easing: 'ease',
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).start()['finally'](expandDone);
	              } else {
	                $animate.addClass(element, 'in', {
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).then(expandDone);
	              }
	            }, angular.noop);
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse')
	            .css(css);
	          expandedExpr(scope);
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          $q.resolve(collapsingExpr(scope))
	            .then(function() {
	              element
	              // IMPORTANT: The width must be set before adding "collapsing" class.
	              // Otherwise, the browser attempts to animate from width 0 (in
	              // collapsing class) to the given width here.
	                .css(getScrollFromElement(element[0]))
	                // initially all panel collapse have the collapse class, this removal
	                // prevents the animation from jumping to collapsed state
	                .removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', false)
	                .attr('aria-hidden', true);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: 'in',
	                  to: cssTo
	                }).start()['finally'](collapseDone);
	              } else {
	                $animate.removeClass(element, 'in', {
	                  to: cssTo
	                }).then(collapseDone);
	              }
	            }, angular.noop);
	        }
	
	        function collapseDone() {
	          element.css(cssTo); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	          collapsedExpr(scope);
	        }
	
	        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.tabindex', [])
	
	.directive('uibTabindexToggle', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      attrs.$observe('disabled', function(disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])
	
	.constant('uibAccordionConfig', {
	  closeOthers: true
	})
	
	.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function(group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function(event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function() {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function() {
	  return {
	    require: '^uibAccordion',         // We need this directive to be inside an accordion
	    transclude: true,              // It transcludes the contents of the directive into the template
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      panelClass: '@?',           // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      element.addClass('panel');
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function(value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function() {
	  return {
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function() {
	  return {
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, controller) {
	      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	
	  function getHeaderSelectors() {
	      return 'uib-accordion-header,' +
	          'data-uib-accordion-header,' +
	          'x-uib-accordion-header,' +
	          'uib\\:accordion-header,' +
	          '[uib-accordion-header],' +
	          '[data-uib-accordion-header],' +
	          '[x-uib-accordion-header]';
	  }
	});
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	  $element.addClass('alert');
	  $attrs.$set('role', 'alert');
	  if ($scope.closeable) {
	    $element.addClass('alert-dismissible');
	  }
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
	    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function() {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}])
	
	.directive('uibAlert', function() {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    scope: {
	      close: '&'
	    }
	  };
	});
	
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('uibBtnRadio', ['$parse', function($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({display: 'none'});
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function(uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}])
	
	.directive('uibBtnCheckbox', function() {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.carousel', [])
	
	.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = $scope.active,
	    currentInterval, isPlaying;
	
	  var destroyed = false;
	  $element.addClass('carousel');
	
	  self.addSlide = function(slide, element) {
	    slides.push({
	      slide: slide,
	      element: element
	    });
	    slides.sort(function(a, b) {
	      return +a.slide.index - +b.slide.index;
	    });
	    //if this is the first slide or the slide is set to active, select it
	    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
	      if ($scope.$currentTransition) {
	        $scope.$currentTransition = null;
	      }
	
	      currentIndex = slide.index;
	      $scope.active = slide.index;
	      setActive(currentIndex);
	      self.select(slides[findSlideIndex(slide)]);
	      if (slides.length === 1) {
	        $scope.play();
	      }
	    }
	  };
	
	  self.getCurrentIndex = function() {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide.index === currentIndex) {
	        return i;
	      }
	    }
	  };
	
	  self.next = $scope.next = function() {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'next');
	  };
	
	  self.prev = $scope.prev = function() {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'prev');
	  };
	
	  self.removeSlide = function(slide) {
	    var index = findSlideIndex(slide);
	
	    //get the index of the slide inside the carousel
	    slides.splice(index, 1);
	    if (slides.length > 0 && currentIndex === index) {
	      if (index >= slides.length) {
	        currentIndex = slides.length - 1;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[slides.length - 1]);
	      } else {
	        currentIndex = index;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	      $scope.active = currentIndex;
	    }
	
	    //clean the active value when no more slide
	    if (slides.length === 0) {
	      currentIndex = null;
	      $scope.active = null;
	    }
	  };
	
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = findSlideIndex(nextSlide.slide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide.slide.index !== currentIndex &&
	      !$scope.$currentTransition) {
	      goNext(nextSlide.slide, nextIndex, direction);
	    }
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function(slide) {
	    return +slide.slide.index;
	  };
	
	  $scope.isActive = function(slide) {
	    return $scope.active === slide.slide.index;
	  };
	
	  $scope.isPrevDisabled = function() {
	    return $scope.active === 0 && $scope.noWrap();
	  };
	
	  $scope.isNextDisabled = function() {
	    return $scope.active === slides.length - 1 && $scope.noWrap();
	  };
	
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	
	  $element.on('mouseenter', $scope.pause);
	  $element.on('mouseleave', $scope.play);
	
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	    resetTimer();
	  });
	
	  $scope.$watch('noTransition', function(noTransition) {
	    $animate.enabled($element, !noTransition);
	  });
	
	  $scope.$watch('interval', restartTimer);
	
	  $scope.$watchCollection('slides', resetTransition);
	
	  $scope.$watch('active', function(index) {
	    if (angular.isNumber(index) && currentIndex !== index) {
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].slide.index === index) {
	          index = i;
	          break;
	        }
	      }
	
	      var slide = slides[index];
	      if (slide) {
	        setActive(index);
	        self.select(slides[index]);
	        currentIndex = index;
	      }
	    }
	  });
	
	  function getSlideByIndex(index) {
	    for (var i = 0, l = slides.length; i < l; ++i) {
	      if (slides[i].index === index) {
	        return slides[i];
	      }
	    }
	  }
	
	  function setActive(index) {
	    for (var i = 0; i < slides.length; i++) {
	      slides[i].slide.active = i === index;
	    }
	  }
	
	  function goNext(slide, index, direction) {
	    if (destroyed) {
	      return;
	    }
	
	    angular.extend(slide, {direction: direction});
	    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
	    if ($animate.enabled($element) && !$scope.$currentTransition &&
	      slides[index].element && self.slides.length > 1) {
	      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
	      var currentIdx = self.getCurrentIndex();
	
	      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
	        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      $animate.on('addClass', slides[index].element, function(element, phase) {
	        if (phase === 'close') {
	          $scope.$currentTransition = null;
	          $animate.off('addClass', element);
	        }
	      });
	    }
	
	    $scope.active = slide.index;
	    currentIndex = slide.index;
	    setActive(index);
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  function findSlideIndex(slide) {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide === slide) {
	        return i;
	      }
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function resetTransition(slides) {
	    if (!slides.length) {
	      $scope.$currentTransition = null;
	    }
	  }
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	}])
	
	.directive('uibCarousel', function() {
	  return {
	    transclude: true,
	    controller: 'UibCarouselController',
	    controllerAs: 'carousel',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
	    },
	    scope: {
	      active: '=',
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	})
	
	.directive('uibSlide', ['$animate', function($animate) {
	  return {
	    require: '^uibCarousel',
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/slide.html';
	    },
	    scope: {
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      element.addClass('item');
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
	      });
	    }
	  };
	}])
	
	.animation('.item', ['$animateCss',
	function($animateCss) {
	  var SLIDE_DIRECTION = 'uib-slideDirection';
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function(element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function (element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function() {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [
	      {
	        key: 'yyyy',
	        regex: '\\d{4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yyyy');
	        }
	      },
	      {
	        key: 'yy',
	        regex: '\\d{2}',
	        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yy');
	        }
	      },
	      {
	        key: 'y',
	        regex: '\\d{1,4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'y');
	        }
	      },
	      {
	        key: 'M!',
	        regex: '0?[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) {
	          var value = date.getMonth();
	          if (/^[0-9]$/.test(value)) {
	            return dateFilter(date, 'MM');
	          }
	
	          return dateFilter(date, 'M');
	        }
	      },
	      {
	        key: 'MMMM',
	        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMMM'); }
	      },
	      {
	        key: 'MMM',
	        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMM'); }
	      },
	      {
	        key: 'MM',
	        regex: '0[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'MM'); }
	      },
	      {
	        key: 'M',
	        regex: '[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'M'); }
	      },
	      {
	        key: 'd!',
	        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) {
	          var value = date.getDate();
	          if (/^[1-9]$/.test(value)) {
	            return dateFilter(date, 'dd');
	          }
	
	          return dateFilter(date, 'd');
	        }
	      },
	      {
	        key: 'dd',
	        regex: '[0-2][0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'dd'); }
	      },
	      {
	        key: 'd',
	        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'd'); }
	      },
	      {
	        key: 'EEEE',
	        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEEE'); }
	      },
	      {
	        key: 'EEE',
	        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEE'); }
	      },
	      {
	        key: 'HH',
	        regex: '(?:0|1)[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'HH'); }
	      },
	      {
	        key: 'hh',
	        regex: '0[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'hh'); }
	      },
	      {
	        key: 'H',
	        regex: '1?[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'H'); }
	      },
	      {
	        key: 'h',
	        regex: '[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'h'); }
	      },
	      {
	        key: 'mm',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'mm'); }
	      },
	      {
	        key: 'm',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'm'); }
	      },
	      {
	        key: 'sss',
	        regex: '[0-9][0-9][0-9]',
	        apply: function(value) { this.milliseconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'sss'); }
	      },
	      {
	        key: 'ss',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'ss'); }
	      },
	      {
	        key: 's',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 's'); }
	      },
	      {
	        key: 'a',
	        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	        apply: function(value) {
	          if (this.hours === 12) {
	            this.hours = 0;
	          }
	
	          if (value === 'PM') {
	            this.hours += 12;
	          }
	        },
	        formatter: function(date) { return dateFilter(date, 'a'); }
	      },
	      {
	        key: 'Z',
	        regex: '[+-]\\d{4}',
	        apply: function(value) {
	          var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	          this.hours += toInt(sign + hours);
	          this.minutes += toInt(sign + minutes);
	        },
	        formatter: function(date) {
	          return dateFilter(date, 'Z');
	        }
	      },
	      {
	        key: 'ww',
	        regex: '[0-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'ww'); }
	      },
	      {
	        key: 'w',
	        regex: '[0-9]|[1-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'w'); }
	      },
	      {
	        key: 'GGGG',
	        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	        formatter: function(date) { return dateFilter(date, 'GGGG'); }
	      },
	      {
	        key: 'GGG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GGG'); }
	      },
	      {
	        key: 'GG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GG'); }
	      },
	      {
	        key: 'G',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'G'); }
	      }
	    ];
	
	    if (angular.version.major >= 1 && angular.version.minor > 4) {
	      formatCodeToRegex.push({
	        key: 'LLLL',
	        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'LLLL'); }
	      });
	    }
	  };
	
	  this.init();
	
	  function getFormatCodeToRegex(key) {
	    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
	  }
	
	  this.getParser = function (key) {
	    var f = getFormatCodeToRegex(key);
	    return f && f.apply || null;
	  };
	
	  this.overrideParser = function (key, parser) {
	    var f = getFormatCodeToRegex(key);
	    if (f && angular.isFunction(parser)) {
	      this.parsers = {};
	      f.apply = parser;
	    }
	  }.bind(this);
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
	              format[i+1] = '$';
	              regex[i+1] = '';
	            } else { // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') { // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function(data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data.apply,
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  function createFormatter(format) {
	    var formatters = [];
	    var i = 0;
	    var formatter, literalIdx;
	    while (i < format.length) {
	      if (angular.isNumber(literalIdx)) {
	        if (format.charAt(i) === '\'') {
	          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
	            formatters.push(constructLiteralFormatter(format, literalIdx, i));
	            literalIdx = null;
	          }
	        } else if (i === format.length) {
	          while (literalIdx < format.length) {
	            formatter = constructFormatterFromIdx(format, literalIdx);
	            formatters.push(formatter);
	            literalIdx = formatter.endIdx;
	          }
	        }
	
	        i++;
	        continue;
	      }
	
	      if (format.charAt(i) === '\'') {
	        literalIdx = i;
	        i++;
	        continue;
	      }
	
	      formatter = constructFormatterFromIdx(format, i);
	
	      formatters.push(formatter.parser);
	      i = formatter.endIdx;
	    }
	
	    return formatters;
	  }
	
	  function constructLiteralFormatter(format, literalIdx, endIdx) {
	    return function() {
	      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
	    };
	  }
	
	  function constructFormatterFromIdx(format, i) {
	    var currentPosStr = format.substr(i);
	    for (var j = 0; j < formatCodeToRegex.length; j++) {
	      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
	        var data = formatCodeToRegex[j];
	        return {
	          endIdx: i + data.key.length,
	          parser: data.formatter
	        };
	      }
	    }
	
	    return {
	      endIdx: i + 1,
	      parser: function() {
	        return currentPosStr.charAt(0);
	      }
	    };
	  }
	
	  this.filter = function(date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createFormatter(format);
	    }
	
	    var formatters = this.formatters[format];
	
	    return formatters.reduce(function(str, formatter) {
	      return str + formatter(date);
	    }, '');
	  };
	
	  this.parse = function(input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
	        Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours :
	        Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes,
	            fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
	            fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    timezone = timezone.replace(/:/g, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	}]);
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', [])
	.directive('uibIsClass', [
	         '$animate',
	function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function(exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function(compareWithVal) {
	            var newActivated = null;
	            instances.some(function(instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function(data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])
	
	.value('$datepickerSuppressError', false)
	
	.value('$datepickerLiteralWarning', true)
	
	.constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  monthColumns: 3,
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	})
	
	.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
	  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
	      ngModelOptions = {},
	      watchListeners = [];
	
	  $element.addClass('uib-datepicker');
	  $attrs.$set('role', 'application');
	
	  if (!$scope.datepickerOptions) {
	    $scope.datepickerOptions = {};
	  }
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  [
	    'customClass',
	    'dateDisabled',
	    'datepickerMode',
	    'formatDay',
	    'formatDayHeader',
	    'formatDayTitle',
	    'formatMonth',
	    'formatMonthTitle',
	    'formatYear',
	    'maxDate',
	    'maxMode',
	    'minDate',
	    'minMode',
	    'monthColumns',
	    'showWeeks',
	    'shortcutPropagation',
	    'startingDay',
	    'yearColumns',
	    'yearRows'
	  ].forEach(function(key) {
	    switch (key) {
	      case 'customClass':
	      case 'dateDisabled':
	        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	        break;
	      case 'datepickerMode':
	        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
	          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	        break;
	      case 'formatDay':
	      case 'formatDayHeader':
	      case 'formatDayTitle':
	      case 'formatMonth':
	      case 'formatMonthTitle':
	      case 'formatYear':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
	          datepickerConfig[key];
	        break;
	      case 'monthColumns':
	      case 'showWeeks':
	      case 'shortcutPropagation':
	      case 'yearColumns':
	      case 'yearRows':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $scope.datepickerOptions[key] : datepickerConfig[key];
	        break;
	      case 'startingDay':
	        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	          self.startingDay = $scope.datepickerOptions.startingDay;
	        } else if (angular.isNumber(datepickerConfig.startingDay)) {
	          self.startingDay = datepickerConfig.startingDay;
	        } else {
	          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	        }
	
	        break;
	      case 'maxDate':
	      case 'minDate':
	        $scope.$watch('datepickerOptions.' + key, function(value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
	            } else {
	              if ($datepickerLiteralWarning) {
	                $log.warn('Literal date support has been deprecated, please switch to date object usage');
	              }
	
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = datepickerConfig[key] ?
	              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
	              null;
	          }
	
	          self.refreshView();
	        });
	
	        break;
	      case 'maxMode':
	      case 'minMode':
	        if ($scope.datepickerOptions[key]) {
	          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
	              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	              $scope.datepickerOptions.datepickerMode = self[key];
	            }
	          });
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	
	        break;
	    }
	  });
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = extractOptions(ngModelCtrl);
	
	    if ($scope.datepickerOptions.initDate) {
	      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
	      $scope.$watch('datepickerOptions.initDate', function(initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
	          self.refreshView();
	        }
	      });
	    } else {
	      self.activeDate = new Date();
	    }
	
	    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
	    this.activeDate = !isNaN(date) ?
	      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
	      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setValidity('dateDisabled', !date ||
	        this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function(date) {
	    return $scope.disabled ||
	      this.minDate && this.compare(date, this.minDate) < 0 ||
	      this.maxDate && this.compare(date, this.maxDate) > 0 ||
	      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	
	    $scope.$broadcast('uib:datepicker.focus');
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
	      $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $element.on('keydown', function(evt) {
	    $scope.$apply(function() {
	      $scope.keydown(evt);
	    });
	  });
	
	  $scope.$on('$destroy', function() {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    $scope.datepickerOptions.datepickerMode = mode;
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = ngModelCtrl.$options ||
	        $scope.datepickerOptions.ngModelOptions ||
	        datepickerConfig.ngModelOptions ||
	        {};
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
	      var timezone = ngModelCtrl.$options.getOption('timezone') ||
	        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
	        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);
	
	      // values passed to createChild override existing values
	      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
	        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
	        .createChild($scope.datepickerOptions.ngModelOptions)
	        .createChild(ngModelCtrl.$options) // highest precedence
	        .createChild({timezone: timezone}); // to keep from squashing a non-null value
	    }
	
	    return ngModelOptions;
	  }
	}])
	
	.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 &&
	      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function(startDate, n) {
	    var dates = new Array(n), current = new Date(startDate), i = 0, date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function() {
	    var year = this.activeDate.getFullYear(),
	      month = this.activeDate.getMonth(),
	      firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	      numDisplayedFromPreviousMonth = difference > 0 ?
	        7 - difference : - difference,
	      firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i ++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(
	          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}])
	
	.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function() {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, this.monthColumns);
	    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - this.monthColumns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + this.monthColumns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}])
	
	.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function() {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function() {
	    var years = new Array(range), date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function(date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? - 1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}])
	
	.directive('uibDatepicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerOptions: '=?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    restrict: 'A',
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	})
	
	.directive('uibDaypicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    restrict: 'A',
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibMonthpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    restrict: 'A',
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibYearpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    restrict: 'A',
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	});
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    /**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */
	    var SCROLLBAR_WIDTH;
	    /**
	     * scrollbar on body and html element in IE and Edge overlay
	     * content and should be considered 0 width.
	     */
	    var BODY_SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/
	    };
	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/
	    };
	    var BODY_REGEX = /(HTML|BODY)/;
	
	    return {
	
	      /**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */
	      getRawNode: function(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },
	
	      /**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */
	      parseStyle: function(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },
	
	      /**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */
	      offsetParent: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }
	
	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        return offsetParent || $document[0].documentElement;
	      },
	
	      /**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       * In IE and Edge, scollbar on body and html element overlay and should
	       * return a width of 0.
	       *
	       * @returns {number} The width of the browser scollbar.
	       */
	      scrollbarWidth: function(isBody) {
	        if (isBody) {
	          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	            var bodyElem = $document.find('body');
	            bodyElem.addClass('uib-position-body-scrollbar-measure');
	            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	            bodyElem.removeClass('uib-position-body-scrollbar-measure');
	          }
	          return BODY_SCROLLBAR_WIDTH;
	        }
	
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }
	
	        return SCROLLBAR_WIDTH;
	      },
	
	      /**
	       * Provides the padding required on an element to replace the scrollbar.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	       *     <li>**widthOverflow**: whether the the width is overflowing</li>
	       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	       *     <li>**heightOverflow**: whether the the height is overflowing</li>
	       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	       *   </ul>
	       */
	      scrollbarPadding: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemStyle = $window.getComputedStyle(elem);
	        var paddingRight = this.parseStyle(elemStyle.paddingRight);
	        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	        var scrollParent = this.scrollParent(elem, false, true);
	        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	        return {
	          scrollbarWidth: scrollbarWidth,
	          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	          right: paddingRight + scrollbarWidth,
	          originalRight: paddingRight,
	          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	          bottom: paddingBottom + scrollbarWidth,
	          originalBottom: paddingBottom
	         };
	      },
	
	      /**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */
	      isScrollable: function(elem, includeHidden) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },
	
	      /**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       * @param {boolean=} [includeSelf=false] - Should the element being passed be
	       * included in the scrollable llokup.
	       *
	       * @returns {element} A HTML element.
	       */
	      scrollParent: function(elem, includeHidden, includeSelf) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	          return elem;
	        }
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;
	
	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }
	
	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }
	
	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }
	
	        return scrollParent;
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */
	      position: function(elem, includeMagins) {
	        elem = this.getRawNode(elem);
	
	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = {top: 0, left: 0};
	
	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }
	
	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left)
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */
	      offset: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	        };
	      },
	
	      /**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */
	      viewportOffset: function(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;
	
	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};
	
	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }
	
	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right)
	        };
	      },
	
	      /**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */
	      parsePlacement: function(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }
	
	        placement = placement.split('-');
	
	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }
	
	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }
	
	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }
	
	        return placement;
	      },
	
	      /**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */
	      positionElements: function(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);
	
	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	        placement = this.parsePlacement(placement);
	
	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = {top: 0, left: 0, placement: ''};
	
	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	          };
	
	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	                         placement[0];
	
	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	                         placement[1];
	
	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }
	
	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;
	        }
	
	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;
	        }
	
	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	        return targetElemPos;
	      },
	
	      /**
	       * Provides a way to adjust the top positioning after first
	       * render to correctly align element to top after content
	       * rendering causes resized element height
	       *
	       * @param {array} placementClasses - The array of strings of classes
	       * element should have.
	       * @param {object} containerPosition - The object with container
	       * position information
	       * @param {number} initialHeight - The initial height for the elem.
	       * @param {number} currentHeight - The current height for the elem.
	       */
	      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
	        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	          return {
	            top: containerPosition.top - currentHeight + 'px'
	          };
	        }
	      },
	
	      /**
	       * Provides a way for positioning tooltip & dropdown
	       * arrows when using placement options beyond the standard
	       * left, right, top, or bottom.
	       *
	       * @param {element} elem - The tooltip/dropdown element.
	       * @param {string} placement - The placement for the elem.
	       */
	      positionArrow: function(elem, placement) {
	        elem = this.getRawNode(elem);
	
	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }
	
	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }
	
	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: ''
	        };
	
	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }
	
	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;
	        }
	
	        arrowCss[placement[1]] = borderRadius;
	
	        angular.element(arrowElem).css(arrowCss);
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])
	
	.value('$datepickerPopupLiteralWarning', true)
	
	.constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	})
	
	.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
	function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
	  var cache = {},
	    isHtml5DateInput = false;
	  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
	    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
	    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];
	
	  this.init = function(_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = extractOptions(ngModel);
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
	      $scope.$parent.$eval($attrs.closeOnDateSelection) :
	      datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
	      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
	      datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
	      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
	      $attrs.datepickerPopupTemplateUrl :
	      datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
	      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
	      $scope.$parent.$eval($attrs.altInputFormats) :
	      datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
	      $scope.$parent.$eval($attrs.showButtonBar) :
	      datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (!$scope.datepickerOptions) {
	      $scope.datepickerOptions = {};
	    }
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        $scope.datepickerOptions.datepickerMode = 'month';
	        $scope.datepickerOptions.minMode = 'month';
	      }
	    }
	
	    datepickerEl.attr('datepicker-options', 'datepickerOptions');
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function(value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function(value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function() {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function() {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function() {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function(date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	    }
	
	    var dates = {};
	    angular.forEach(['minDate', 'maxDate'], function(key) {
	      if (!$scope.datepickerOptions[key]) {
	        dates[key] = null;
	      } else if (angular.isDate($scope.datepickerOptions[key])) {
	        dates[key] = new Date($scope.datepickerOptions[key]);
	      } else {
	        if ($datepickerPopupLiteralWarning) {
	          $log.warn('Literal date support has been deprecated, please switch to date object usage');
	        }
	
	        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
	      }
	    });
	
	    return $scope.datepickerOptions &&
	      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
	      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
	  };
	
	  $scope.compare = function(date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function(dt) {
	    $scope.date = dt;
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function(evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function(date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function(evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function(value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function() {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
	      }
	    }
	
	    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(value));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
	        ngModelCtrl.$options :
	        {
	          timezone: null
	        };
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      ngModelOptions = ngModelCtrl.$options;
	    }
	
	    return ngModelOptions;
	  }
	
	  $scope.$on('uib:datepicker.mode', function() {
	    $timeout(positionPopup, 0, false);
	  });
	}])
	
	.directive('uibDatepickerPopup', function() {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	})
	
	.directive('uibDatepickerPopupWrap', function() {
	  return {
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
	    }
	  };
	});
	
	angular.module('ui.bootstrap.debounce', [])
	/**
	 * A helper, internal service that debounces a function
	 */
	  .factory('$$debounce', ['$timeout', function($timeout) {
	    return function(callback, debounceTime) {
	      var timeoutPromise;
	
	      return function() {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function() {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  });
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])
	
	.constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	})
	
	.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function(dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function(dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function(dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function(dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled') { return; }
	
	    if (evt && evt.which === 3) { return; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function(evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    appendToOpenClass = dropdownConfig.appendToOpenClass,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    keynavEnabled = false,
	    selectedOption = null,
	    body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function(open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      angular.element(self.dropdownMenu).find('a') :
	      $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = self.selectedOption === elems.length - 1 ?
	            self.selectedOption :
	            self.selectedOption + 1;
	        }
	        break;
	      }
	      case 38: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    var appendTo = null,
	      appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	        css,
	        rightalign,
	        scrollbarPadding,
	        scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth -
	          (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth -
	            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}])
	
	.directive('uibDropdown', function() {
	  return {
	    controller: 'UibDropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	})
	
	.directive('uibDropdownMenu', function() {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('uibDropdownToggle', function() {
	  return {
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.pop();
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	  .provider('$uibResolve', function() {
	    var resolve = this;
	    this.resolver = null;
	
	    this.setResolver = function(resolver) {
	      this.resolver = resolver;
	    };
	
	    this.$get = ['$injector', '$q', function($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }
	
	          var promises = [];
	
	          angular.forEach(invocables, function(value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });
	
	          return $q.all(promises).then(function(resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function(value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });
	
	            return resolveObj;
	          });
	        }
	      };
	    }];
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
	  function($animate, $injector, $modalStack) {
	    return {
	      restrict: 'A',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animate.addClass(element, attrs.modalInClass);
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
	  function($modalStack, $q, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@'
	      },
	      restrict: 'A',
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	            modal.value.backdrop !== 'static' &&
	            evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is rendered.
	        var modalRenderDeferObj = $q.defer();
	        // Resolve render promise post-digest
	        scope.$$postDigest(function() {
	          modalRenderDeferObj.resolve();
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	
	            /**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus) then there's no need to try to focus anything.
	             */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function(clone) {
	          element.empty();
	          $animate.enter(clone, element);
	        });
	      }
	    };
	  }])
	
	  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
	    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	      var topModalIndex = 0;
	      var previousTopOpenedModal = null;
	      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	      //Modal focus behavior
	      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
	        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
	        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	      var scrollbarPadding;
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	      // TODO: extract into common dependency with tooltip
	      function snake_case(name) {
	        var separator = '-';
	        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	          return (pos ? separator : '') + letter.toLowerCase();
	        });
	      }
	
	      function isVisible(element) {
	        return !!(element.offsetWidth ||
	          element.offsetHeight ||
	          element.getClientRects().length);
	      }
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	
	        // If any backdrop exist, ensure that it's index is always
	        // right below the top modal
	        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	          topBackdropIndex = topModalIndex;
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        var appendToElement = modalWindow.appendTo;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	        previousTopOpenedModal = openedWindows.top();
	        if (previousTopOpenedModal) {
	          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	        }
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	            if (scrollbarPadding.originalRight) {
	              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
	            } else {
	              appendToElement.css({paddingRight: ''});
	            }
	            scrollbarPadding = null;
	          }
	          toggleTopWindowClass(true);
	        }, modalWindow.closedDeferred);
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else if (appendToElement.focus) {
	          appendToElement.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          $animate.leave(domEl).then(function() {
	            if (done) {
	              done();
	            }
	
	            domEl.remove();
	            if (closedDeferred) {
	              closedDeferred.resolve();
	            }
	          });
	
	          scope.$destroy();
	        }
	      }
	
	      $document.on('keydown', keydownListener);
	
	      $rootScope.$on('$destroy', function() {
	        $document.off('keydown', keydownListener);
	      });
	
	      function keydownListener(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal) {
	          switch (evt.which) {
	            case 27: {
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function() {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	            case 9: {
	              var list = $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement(list);
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt, list)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement(list);
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        // Store the current top first, to determine what index we ought to use
	        // for the current top modal
	        previousTopOpenedModal = openedWindows.top();
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          closedDeferred: modal.closedDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass,
	          animation: modal.animation,
	          appendTo: modal.appendTo
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var appendToElement = modal.appendTo,
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.modalOptions = modal;
	          backdropScope.index = currBackdropIndex;
	          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          backdropDomEl.attr({
	            'class': 'modal-backdrop',
	            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	            'uib-modal-animation-class': 'fade',
	            'modal-in-class': 'in'
	          });
	          if (modal.backdropClass) {
	            backdropDomEl.addClass(modal.backdropClass);
	          }
	
	          if (modal.animation) {
	            backdropDomEl.attr('modal-animation', 'true');
	          }
	          $compile(backdropDomEl)(backdropScope);
	          $animate.enter(backdropDomEl, appendToElement);
	          if ($uibPosition.isScrollable(appendToElement)) {
	            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
	            }
	          }
	        }
	
	        var content;
	        if (modal.component) {
	          content = document.createElement(snake_case(modal.component.name));
	          content = angular.element(content);
	          content.attr({
	            resolve: '$resolve',
	            'modal-instance': '$uibModalInstance',
	            close: '$close($value)',
	            dismiss: '$dismiss($value)'
	          });
	        } else {
	          content = modal.content;
	        }
	
	        // Set the top modal index based on the index of the previous top modal
	        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'class': 'modal',
	          'template-url': modal.windowTemplateUrl,
	          'window-top-class': modal.windowTopClass,
	          'role': 'dialog',
	          'aria-labelledby': modal.ariaLabelledBy,
	          'aria-describedby': modal.ariaDescribedBy,
	          'size': modal.size,
	          'index': topModalIndex,
	          'animate': 'animate',
	          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	          'tabindex': -1,
	          'uib-modal-animation-class': 'fade',
	          'modal-in-class': 'in'
	        }).append(content);
	        if (modal.windowClass) {
	          angularDomEl.addClass(modal.windowClass);
	        }
	
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        appendToElement.addClass(modalBodyClass);
	        if (modal.scope) {
	          // we need to explicitly add the modal index to the modal scope
	          // because it is needed by ngStyle to compute the zIndex property.
	          modal.scope.$$topModalIndex = topModalIndex;
	        }
	        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	        openedWindows.top().value.modalDomEl = angularDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	
	        applyAriaHidden(angularDomEl);
	
	        function applyAriaHidden(el) {
	          if (!el || el[0].tagName === 'BODY') {
	            return;
	          }
	
	          getSiblings(el).forEach(function(sibling) {
	            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	            if (!ariaHiddenCount) {
	              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	            }
	
	            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	            sibling.setAttribute('aria-hidden', 'true');
	          });
	
	          return applyAriaHidden(el.parent());
	
	          function getSiblings(el) {
	            var children = el.parent() ? el.parent().children() : [];
	
	            return Array.prototype.filter.call(children, function(child) {
	              return child !== el[0];
	            });
	          }
	        }
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      function unhideBackgroundElements() {
	        Array.prototype.forEach.call(
	          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
	          function(hiddenEl) {
	            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	              newHiddenCount = ariaHiddenCount - 1;
	            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	            if (!newHiddenCount) {
	              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	              hiddenEl.removeAttribute('aria-hidden');
	            }
	          }
	        );
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[0].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.focusLastFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[list.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isModalFocused = function(evt, modalWindow) {
	        if (evt && modalWindow) {
	          var modalDomEl = modalWindow.value.modalDomEl;
	          if (modalDomEl && modalDomEl.length) {
	            return (evt.target || evt.srcElement) === modalDomEl[0];
	          }
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[list.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	            return elements ?
	              Array.prototype.filter.call(elements, function(element) {
	                return isVisible(element);
	              }) : elements;
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ?
	                options.templateUrl() : options.templateUrl);
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalClosedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              closed: modalClosedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	            if (!modalOptions.appendTo.length) {
	              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	            }
	
	            //verify options
	            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of component or template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise;
	            if (modalOptions.component) {
	              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	            } else {
	              templateAndResolvePromise =
	                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	            }
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	                var providedScope = modalOptions.scope || $rootScope;
	
	                var modalScope = providedScope.$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var modal = {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  closedDeferred: modalClosedDeferred,
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  ariaLabelledBy: modalOptions.ariaLabelledBy,
	                  ariaDescribedBy: modalOptions.ariaDescribedBy,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass,
	                  appendTo: modalOptions.appendTo
	                };
	
	                var component = {};
	                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};
	
	                if (modalOptions.component) {
	                  constructLocals(component, false, true, false);
	                  component.name = modalOptions.component;
	                  modal.component = component;
	                } else if (modalOptions.controller) {
	                  constructLocals(ctrlLocals, true, false, true);
	
	                  // the third param will make the controller instantiate later,private api
	                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	                  if (modalOptions.controllerAs && modalOptions.bindToController) {
	                    ctrlInstance = ctrlInstantiate.instance;
	                    ctrlInstance.$close = modalScope.$close;
	                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                    angular.extend(ctrlInstance, {
	                      $resolve: ctrlLocals.$scope.$resolve
	                    }, providedScope);
	                  }
	
	                  ctrlInstance = ctrlInstantiate();
	
	                  if (angular.isFunction(ctrlInstance.$onInit)) {
	                    ctrlInstance.$onInit();
	                  }
	                }
	
	                if (!modalOptions.component) {
	                  modal.content = tplAndVars[0];
	                }
	
	                $modalStack.open(modalInstance, modal);
	                modalOpenedDeferred.resolve(true);
	
	                function constructLocals(obj, template, instanceOnScope, injectable) {
	                  obj.$scope = modalScope;
	                  obj.$scope.$resolve = {};
	                  if (instanceOnScope) {
	                    obj.$scope.$uibModalInstance = modalInstance;
	                  } else {
	                    obj.$uibModalInstance = modalInstance;
	                  }
	
	                  var resolves = template ? tplAndVars[1] : tplAndVars;
	                  angular.forEach(resolves, function(value, key) {
	                    if (injectable) {
	                      obj[key] = value;
	                    }
	
	                    obj.$scope.$resolve[key] = value;
	                  });
	                }
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })['finally'](function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });
	
	angular.module('ui.bootstrap.paging', [])
	/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */
	.factory('uibPaging', ['$parse', function($parse) {
	  return {
	    create: function(ctrl, $scope, $attrs) {
	      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	      ctrl._watchers = [];
	
	      ctrl.init = function(ngModelCtrl, config) {
	        ctrl.ngModelCtrl = ngModelCtrl;
	        ctrl.config = config;
	
	        ngModelCtrl.$render = function() {
	          ctrl.render();
	        };
	
	        if ($attrs.itemsPerPage) {
	          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
	            ctrl.itemsPerPage = parseInt(value, 10);
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }));
	        } else {
	          ctrl.itemsPerPage = config.itemsPerPage;
	        }
	
	        $scope.$watch('totalItems', function(newTotal, oldTotal) {
	          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }
	        });
	      };
	
	      ctrl.calculateTotalPages = function() {
	        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	      };
	
	      ctrl.render = function() {
	        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	      };
	
	      $scope.selectPage = function(page, evt) {
	        if (evt) {
	          evt.preventDefault();
	        }
	
	        var clickAllowed = !$scope.ngDisabled || !evt;
	        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	          if (evt && evt.target) {
	            evt.target.blur();
	          }
	          ctrl.ngModelCtrl.$setViewValue(page);
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.getText = function(key) {
	        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	      };
	
	      $scope.noPrevious = function() {
	        return $scope.page === 1;
	      };
	
	      $scope.noNext = function() {
	        return $scope.page === $scope.totalPages;
	      };
	
	      ctrl.updatePage = function() {
	        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable
	
	        if ($scope.page > $scope.totalPages) {
	          $scope.selectPage($scope.totalPages);
	        } else {
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.$on('$destroy', function() {
	        while (ctrl._watchers.length) {
	          ctrl._watchers.shift()();
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	
	.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
	  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;
	
	  uibPaging.create(this, $scope, $attrs);
	}])
	
	.constant('uibPagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPager', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPagerController',
	    controllerAs: 'pager',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pager/pager.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pager');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	        return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	  var ctrl = this;
	  // Setup configuration parameters
	  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
	  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
	  $attrs.$set('role', 'menu');
	
	  uibPaging.create(this, $scope, $attrs);
	
	  if ($attrs.maxSize) {
	    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
	      maxSize = parseInt(value, 10);
	      ctrl.render();
	    }));
	  }
	
	  // Create page object used in template
	  function makePage(number, text, isActive) {
	    return {
	      number: number,
	      text: text,
	      active: isActive
	    };
	  }
	
	  function getPages(currentPage, totalPages) {
	    var pages = [];
	
	    // Default page limits
	    var startPage = 1, endPage = totalPages;
	    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	    // recompute if maxSize
	    if (isMaxSized) {
	      if (rotate) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	        endPage = startPage + maxSize - 1;
	
	        // Adjust if limit is exceeded
	        if (endPage > totalPages) {
	          endPage = totalPages;
	          startPage = endPage - maxSize + 1;
	        }
	      } else {
	        // Visible pages are paginated with maxSize
	        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
	
	        // Adjust last page if limit is exceeded
	        endPage = Math.min(startPage + maxSize - 1, totalPages);
	      }
	    }
	
	    // Add page number links
	    for (var number = startPage; number <= endPage; number++) {
	      var page = makePage(number, pageLabel(number), number === currentPage);
	      pages.push(page);
	    }
	
	    // Add links to move between page sets
	    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	      if (startPage > 1) {
	        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
	        var previousPageSet = makePage(startPage - 1, '...', false);
	        pages.unshift(previousPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
	            var secondPageLink = makePage(2, '2', false);
	            pages.unshift(secondPageLink);
	          }
	          //add the first page
	          var firstPageLink = makePage(1, '1', false);
	          pages.unshift(firstPageLink);
	        }
	      }
	
	      if (endPage < totalPages) {
	        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
	        var nextPageSet = makePage(endPage + 1, '...', false);
	        pages.push(nextPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
	            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	            pages.push(secondToLastPageLink);
	          }
	          //add the last page
	          var lastPageLink = makePage(totalPages, totalPages, false);
	          pages.push(lastPageLink);
	        }
	      }
	    }
	    return pages;
	  }
	
	  var originalRender = this.render;
	  this.render = function() {
	    originalRender();
	    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	      $scope.pages = getPages($scope.page, $scope.totalPages);
	    }
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  boundaryLinkNumbers: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true,
	  forceEllipses: false
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pagination');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup ' +
	          'uib-title="' + startSym + 'title' + endSym + '" ' +
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'origin-scope="origScope" ' +
	          'class="uib-position-measure ' + prefix + '" ' +
	          'tooltip-animation-class="fade"' +
	          'uib-tooltip-classes ' +
	          'ng-class="{ in: isOpen }" ' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function() {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	                
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	              
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [], hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function(key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('uibTooltipPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])
	
	.directive('uibPopoverTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	})
	
	.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', uibTitle: '@' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	})
	
	.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', content: '@' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	})
	
	.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = getMaxOrDefault();
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = getMaxOrDefault();
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  //$attrs.$observe('maxParam', function(maxParam) {
	  $scope.$watch('maxParam', function(maxParam) {
	    self.bars.forEach(function(bar) {
	      bar.max = getMaxOrDefault();
	      bar.recalculatePercentage();
	    });
	  });
	
	  function getMaxOrDefault () {
	    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	  }
	}])
	
	.directive('uibProgress', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      maxParam: '=?max'
	    },
	    templateUrl: 'uib/template/progressbar/progress.html'
	  };
	})
	
	.directive('uibBar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	})
	
	.directive('uibProgressbar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      maxParam: '=?max',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	});
	
	angular.module('ui.bootstrap.rating', [])
	
	.constant('uibRatingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  enableReset: true,
	  titles: ['one', 'two', 'three', 'four', 'five']
	})
	
	.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl = { $setViewValue: angular.noop },
	    self = this;
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function(value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    this.enableReset = angular.isDefined($attrs.enableReset) ?
	      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
	    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	
	  this.getTitle = function(index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    }
	
	    return this.titles[index];
	  };
	
	  $scope.rate = function(value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
	      ngModelCtrl.$setViewValue(newViewValue);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.title = self.getTitle($scope.value - 1);
	  };
	}])
	
	.directive('uibRating', function() {
	  return {
	    require: ['uibRating', 'ngModel'],
	    restrict: 'A',
	    scope: {
	      readonly: '=?readOnly',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'UibRatingController',
	    templateUrl: 'uib/template/rating/rating.html',
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	});
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	    oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function(index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function(t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
	        index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function(val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}])
	
	.directive('uibTabset', function() {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ?
	        scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ?
	        scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	.directive('uibTab', ['$parse', function($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function(evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function() {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}])
	
	.directive('uibTabHeadingTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	})
	
	.directive('uibTabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (
	      node.hasAttribute('uib-tab-heading') ||
	      node.hasAttribute('data-uib-tab-heading') ||
	      node.hasAttribute('x-uib-tab-heading') ||
	      node.tagName.toLowerCase() === 'uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'uib:tab-heading'
	    );
	  }
	});
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	})
	
	.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
	  var selected = new Date(),
	    watchers = [],
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function(ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function(modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    hoursModelCtrl = hoursInputEl.controller('ngModel');
	    minutesModelCtrl = minutesInputEl.controller('ngModel');
	    secondsModelCtrl = secondsInputEl.controller('ngModel');
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function() {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function() {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function() {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function() {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function() {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function() {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function() {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
	      hours >= 0 && hours < 24;
	    if (!valid || $scope.hours === '') {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    var valid = minutes >= 0 && minutes < 60;
	    if (!valid || $scope.minutes === '') {
	      return undefined;
	    }
	    return minutes;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
	      '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	     secondsInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	        if (hoursModelCtrl) {
	          hoursModelCtrl.$setValidity('hours', false);
	        }
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	        if (minutesModelCtrl) {
	          minutesModelCtrl.$setValidity('minutes', false);
	        }
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	        if (secondsModelCtrl) {
	          secondsModelCtrl.$setValidity('seconds', false);
	        }
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function() {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function() {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function() {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.on('blur', function(e) {
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply( function() {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    if (hoursModelCtrl) {
	      hoursModelCtrl.$setValidity('hours', true);
	    }
	
	    if (minutesModelCtrl) {
	      minutesModelCtrl.$setValidity('minutes', true);
	    }
	
	    if (secondsModelCtrl) {
	      secondsModelCtrl.$setValidity('seconds', true);
	    }
	
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	        minutes = selected.getMinutes(),
	        seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes*60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  function modelIsEmpty() {
	    return ($scope.hours === null || $scope.hours === '') &&
	      ($scope.minutes === null || $scope.minutes === '') &&
	      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function() {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function() {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function() {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function() {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function() {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function() {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function() {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function() {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function() {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}])
	
	.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    restrict: 'A',
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('uibTypeaheadParser', ['$parse', function($parse) {
	    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
	    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	    return {
	      parse: function(input) {
	        var match = input.match(TYPEAHEAD_REGEXP);
	        if (!match) {
	          throw new Error(
	            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	              ' but got "' + input + '".');
	        }
	
	        return {
	          itemName: match[3],
	          source: $parse(match[4]),
	          viewMapper: $parse(match[2] || match[1]),
	          modelMapper: $parse(match[1])
	        };
	      }
	    };
	  }])
	
	  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
	    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    var modelCtrl, ngModelOptions;
	    //SUPPORTED ATTRIBUTES (OPTIONS)
	
	    //minimal no of characters that needs to be entered before typeahead kicks-in
	    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	    if (!minLength && minLength !== 0) {
	      minLength = 1;
	    }
	
	    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
	        minLength = !newVal && newVal !== 0 ? 1 : newVal;
	    });
	
	    //minimal wait time after last character typed before typeahead kicks-in
	    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	    //should it restrict model values to the ones selected from the popup only?
	    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
	      isEditable = newVal !== false;
	    });
	
	    //binding to a variable that indicates if matches are being retrieved asynchronously
	    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	    //a function to determine if an event should cause selection
	    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
	      var evt = vals.$event;
	      return evt.which === 13 || evt.which === 9;
	    };
	
	    //a callback executed when a match is selected
	    var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	    //should it select highlighted popup value when losing focus?
	    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	    //binding to a variable that indicates if there were no results after the query is completed
	    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	    var appendTo = attrs.typeaheadAppendTo ?
	      originalScope.$eval(attrs.typeaheadAppendTo) : null;
	
	    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	    //If input matches an item of the list exactly, select it automatically
	    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	    //binding to a variable that indicates if dropdown is open
	    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;
	
	    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;
	
	    //INTERNAL VARIABLES
	
	    //model setter executed upon match selection
	    var parsedModel = $parse(attrs.ngModel);
	    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	    var $setModelValue = function(scope, newValue) {
	      if (angular.isFunction(parsedModel(originalScope)) &&
	        ngModelOptions.getOption('getterSetter')) {
	        return invokeModelSetter(scope, {$$$p: newValue});
	      }
	
	      return parsedModel.assign(scope, newValue);
	    };
	
	    //expressions used by typeahead
	    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
	
	    var hasFocus;
	
	    //Used to avoid bug in iOS webview where iOS keyboard does not fire
	    //mousedown & mouseup events
	    //Issue #3699
	    var selected;
	
	    //create a child scope for the typeahead directive so we are not polluting original scope
	    //with typeahead-specific data (matches, query etc.)
	    var scope = originalScope.$new();
	    var offDestroy = originalScope.$on('$destroy', function() {
	      scope.$destroy();
	    });
	    scope.$on('$destroy', offDestroy);
	
	    // WAI-ARIA
	    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	    element.attr({
	      'aria-autocomplete': 'list',
	      'aria-expanded': false,
	      'aria-owns': popupId
	    });
	
	    var inputsContainer, hintInputElem;
	    //add read-only input to show hint
	    if (showHint) {
	      inputsContainer = angular.element('<div></div>');
	      inputsContainer.css('position', 'relative');
	      element.after(inputsContainer);
	      hintInputElem = element.clone();
	      hintInputElem.attr('placeholder', '');
	      hintInputElem.attr('tabindex', '-1');
	      hintInputElem.val('');
	      hintInputElem.css({
	        'position': 'absolute',
	        'top': '0px',
	        'left': '0px',
	        'border-color': 'transparent',
	        'box-shadow': 'none',
	        'opacity': 1,
	        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
	        'color': '#999'
	      });
	      element.css({
	        'position': 'relative',
	        'vertical-align': 'top',
	        'background-color': 'transparent'
	      });
	
	      if (hintInputElem.attr('id')) {
	        hintInputElem.removeAttr('id'); // remove duplicate id if present.
	      }
	      inputsContainer.append(hintInputElem);
	      hintInputElem.after(element);
	    }
	
	    //pop-up element used to display matches
	    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	    popUpEl.attr({
	      id: popupId,
	      matches: 'matches',
	      active: 'activeIdx',
	      select: 'select(activeIdx, evt)',
	      'move-in-progress': 'moveInProgress',
	      query: 'query',
	      position: 'position',
	      'assign-is-open': 'assignIsOpen(isOpen)',
	      debounce: 'debounceUpdate'
	    });
	    //custom item template
	    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	    }
	
	    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	    }
	
	    var resetHint = function() {
	      if (showHint) {
	        hintInputElem.val('');
	      }
	    };
	
	    var resetMatches = function() {
	      scope.matches = [];
	      scope.activeIdx = -1;
	      element.attr('aria-expanded', false);
	      resetHint();
	    };
	
	    var getMatchId = function(index) {
	      return popupId + '-option-' + index;
	    };
	
	    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	    // This attribute is added or removed automatically when the `activeIdx` changes.
	    scope.$watch('activeIdx', function(index) {
	      if (index < 0) {
	        element.removeAttr('aria-activedescendant');
	      } else {
	        element.attr('aria-activedescendant', getMatchId(index));
	      }
	    });
	
	    var inputIsExactMatch = function(inputValue, index) {
	      if (scope.matches.length > index && inputValue) {
	        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	      }
	
	      return false;
	    };
	
	    var getMatchesAsync = function(inputValue, evt) {
	      var locals = {$viewValue: inputValue};
	      isLoadingSetter(originalScope, true);
	      isNoResultsSetter(originalScope, false);
	      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	        //it might happen that several async queries were in progress if a user were typing fast
	        //but we are interested only in responses that correspond to the current view value
	        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
	        if (onCurrentRequest && hasFocus) {
	          if (matches && matches.length > 0) {
	            scope.activeIdx = focusFirst ? 0 : -1;
	            isNoResultsSetter(originalScope, false);
	            scope.matches.length = 0;
	
	            //transform labels
	            for (var i = 0; i < matches.length; i++) {
	              locals[parserResult.itemName] = matches[i];
	              scope.matches.push({
	                id: getMatchId(i),
	                label: parserResult.viewMapper(scope, locals),
	                model: matches[i]
	              });
	            }
	
	            scope.query = inputValue;
	            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	            //due to other elements being rendered
	            recalculatePosition();
	
	            element.attr('aria-expanded', true);
	
	            //Select the single remaining option if user input matches
	            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(0, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(0, evt);
	              }
	            }
	
	            if (showHint) {
	              var firstLabel = scope.matches[0].label;
	              if (angular.isString(inputValue) &&
	                inputValue.length > 0 &&
	                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
	                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
	              } else {
	                hintInputElem.val('');
	              }
	            }
	          } else {
	            resetMatches();
	            isNoResultsSetter(originalScope, true);
	          }
	        }
	        if (onCurrentRequest) {
	          isLoadingSetter(originalScope, false);
	        }
	      }, function() {
	        resetMatches();
	        isLoadingSetter(originalScope, false);
	        isNoResultsSetter(originalScope, true);
	      });
	    };
	
	    // bind events only if appendToBody params exist - performance feature
	    if (appendToBody) {
	      angular.element($window).on('resize', fireRecalculating);
	      $document.find('body').on('scroll', fireRecalculating);
	    }
	
	    // Declare the debounced function outside recalculating for
	    // proper debouncing
	    var debouncedRecalculate = $$debounce(function() {
	      // if popup is visible
	      if (scope.matches.length) {
	        recalculatePosition();
	      }
	
	      scope.moveInProgress = false;
	    }, eventDebounceTime);
	
	    // Default progress type
	    scope.moveInProgress = false;
	
	    function fireRecalculating() {
	      if (!scope.moveInProgress) {
	        scope.moveInProgress = true;
	        scope.$digest();
	      }
	
	      debouncedRecalculate();
	    }
	
	    // recalculate actual position and set new values to scope
	    // after digest loop is popup in right position
	    function recalculatePosition() {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top += element.prop('offsetHeight');
	    }
	
	    //we need to propagate user's query so we can higlight matches
	    scope.query = undefined;
	
	    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutPromise;
	
	    var scheduleSearchWithTimeout = function(inputValue) {
	      timeoutPromise = $timeout(function() {
	        getMatchesAsync(inputValue);
	      }, waitTime);
	    };
	
	    var cancelPreviousTimeout = function() {
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	    };
	
	    resetMatches();
	
	    scope.assignIsOpen = function (isOpen) {
	      isOpenSetter(originalScope, isOpen);
	    };
	
	    scope.select = function(activeIdx, evt) {
	      //called from within the $digest() cycle
	      var locals = {};
	      var model, item;
	
	      selected = true;
	      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	      model = parserResult.modelMapper(originalScope, locals);
	      $setModelValue(originalScope, model);
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);
	
	      onSelectCallback(originalScope, {
	        $item: item,
	        $model: model,
	        $label: parserResult.viewMapper(originalScope, locals),
	        $event: evt
	      });
	
	      resetMatches();
	
	      //return focus to the input element if a match was selected via a mouse click event
	      // use timeout to avoid $rootScope:inprog error
	      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	        $timeout(function() { element[0].focus(); }, 0, false);
	      }
	    };
	
	    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	    element.on('keydown', function(evt) {
	      //typeahead is open and an "interesting" key was pressed
	      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	        return;
	      }
	
	      var shouldSelect = isSelectEvent(originalScope, {$event: evt});
	
	      /**
	       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
	       * or
	       * shift + tab is pressed to bring focus to the previous element
	       * then clear the results
	       */
	      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
	        resetMatches();
	        scope.$digest();
	        return;
	      }
	
	      evt.preventDefault();
	      var target;
	      switch (evt.which) {
	        case 27: // escape
	          evt.stopPropagation();
	
	          resetMatches();
	          originalScope.$digest();
	          break;
	        case 38: // up arrow
	          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        case 40: // down arrow
	          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        default:
	          if (shouldSelect) {
	            scope.$apply(function() {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(scope.activeIdx, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(scope.activeIdx, evt);
	              }
	            });
	          }
	      }
	    });
	
	    element.on('focus', function (evt) {
	      hasFocus = true;
	      if (minLength === 0 && !modelCtrl.$viewValue) {
	        $timeout(function() {
	          getMatchesAsync(modelCtrl.$viewValue, evt);
	        }, 0);
	      }
	    });
	
	    element.on('blur', function(evt) {
	      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	        selected = true;
	        scope.$apply(function() {
	          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
	            $$debounce(function() {
	              scope.select(scope.activeIdx, evt);
	            }, scope.debounceUpdate.blur);
	          } else {
	            scope.select(scope.activeIdx, evt);
	          }
	        });
	      }
	      if (!isEditable && modelCtrl.$error.editable) {
	        modelCtrl.$setViewValue();
	        scope.$apply(function() {
	          // Reset validity as we are clearing
	          modelCtrl.$setValidity('editable', true);
	          modelCtrl.$setValidity('parse', true);
	        });
	        element.val('');
	      }
	      hasFocus = false;
	      selected = false;
	    });
	
	    // Keep reference to click handler to unbind it.
	    var dismissClickHandler = function(evt) {
	      // Issue #3973
	      // Firefox treats right click as a click on document
	      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	        resetMatches();
	        if (!$rootScope.$$phase) {
	          originalScope.$digest();
	        }
	      }
	    };
	
	    $document.on('click', dismissClickHandler);
	
	    originalScope.$on('$destroy', function() {
	      $document.off('click', dismissClickHandler);
	      if (appendToBody || appendTo) {
	        $popup.remove();
	      }
	
	      if (appendToBody) {
	        angular.element($window).off('resize', fireRecalculating);
	        $document.find('body').off('scroll', fireRecalculating);
	      }
	      // Prevent jQuery cache memory leak
	      popUpEl.remove();
	
	      if (showHint) {
	          inputsContainer.remove();
	      }
	    });
	
	    var $popup = $compile(popUpEl)(scope);
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else if (appendTo) {
	      angular.element(appendTo).eq(0).append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    this.init = function(_modelCtrl) {
	      modelCtrl = _modelCtrl;
	      ngModelOptions = extractOptions(modelCtrl);
	
	      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function(inputValue) {
	        hasFocus = true;
	
	        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        }
	
	        if (!inputValue) {
	          // Reset in case user had typed something previously.
	          modelCtrl.$setValidity('editable', true);
	          return null;
	        }
	
	        modelCtrl.$setValidity('editable', false);
	        return undefined;
	      });
	
	      modelCtrl.$formatters.push(function(modelValue) {
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        // The validity may be set to false via $parsers (see above) if
	        // the model is restricted to selected values. If the model
	        // is set manually it is considered to be valid.
	        if (!isEditable) {
	          modelCtrl.$setValidity('editable', true);
	        }
	
	        if (inputFormatter) {
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	        }
	
	        //it might happen that we don't have enough info to properly render input value
	        //we need to check for this situation and simply return model value if we can't apply custom formatting
	        locals[parserResult.itemName] = modelValue;
	        candidateViewValue = parserResult.viewMapper(originalScope, locals);
	        locals[parserResult.itemName] = undefined;
	        emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	      });
	    };
	
	    function extractOptions(ngModelCtrl) {
	      var ngModelOptions;
	
	      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	        // guarantee a value
	        ngModelOptions = ngModelCtrl.$options || {};
	
	        // mimic 1.6+ api
	        ngModelOptions.getOption = function (key) {
	          return ngModelOptions[key];
	        };
	      } else { // in angular >=1.6 $options is always present
	        ngModelOptions = ngModelCtrl.$options;
	      }
	
	      return ngModelOptions;
	    }
	  }])
	
	  .directive('uibTypeahead', function() {
	    return {
	      controller: 'UibTypeaheadController',
	      require: ['ngModel', 'uibTypeahead'],
	      link: function(originalScope, element, attrs, ctrls) {
	        ctrls[1].init(ctrls[0]);
	      }
	    };
	  })
	
	  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&',
	        assignIsOpen: '&',
	        debounce: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          var isDropdownOpen = scope.matches.length > 0;
	          scope.assignIsOpen({ isOpen: isDropdownOpen });
	          return isDropdownOpen;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active === matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx, evt) {
	          var debounce = scope.debounce();
	          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
	            $$debounce(function() {
	              scope.select({activeIdx: activeIdx, evt: evt});
	            }, angular.isNumber(debounce) ? debounce : debounce['default']);
	          } else {
	            scope.select({activeIdx: activeIdx, evt: evt});
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
	    return {
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link: function(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          var tplEl = angular.element(tplContent.trim());
	          element.replaceWith(tplEl);
	          $compile(tplEl)(scope);
	        });
	      }
	    };
	  }])
	
	  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html",
	    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "  <h4 class=\"panel-title\">\n" +
	    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "  </h4>\n" +
	    "</div>\n" +
	    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
	    "  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html",
	    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html",
	    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
	    "  <span aria-hidden=\"true\">&times;</span>\n" +
	    "  <span class=\"sr-only\">Close</span>\n" +
	    "</button>\n" +
	    "<div ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/carousel.html",
	    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
	    "  <span class=\"sr-only\">previous</span>\n" +
	    "</a>\n" +
	    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
	    "  <span class=\"sr-only\">next</span>\n" +
	    "</a>\n" +
	    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
	    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
	    "  </li>\n" +
	    "</ol>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/slide.html",
	    "<div class=\"text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\">\n" +
	    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
	    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
	    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/datepicker/popup.html",
	    "<div>\n" +
	    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "    <li ng-transclude></li>\n" +
	    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "      <span class=\"btn-group pull-left\">\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "      </span>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "    </li>\n" +
	    "  </ul>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepickerPopup/popup.html",
	    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "  <li ng-transclude></li>\n" +
	    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "    <span class=\"btn-group pull-left\">\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "    </span>\n" +
	    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "  </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/modal/backdrop.html",
	    "<div class=\"modal-backdrop\"\n" +
	    "     uib-modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html",
	    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pager/pager.html",
	    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pagination/pagination.html",
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\"\n" +
	    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\"\n" +
	    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);
	
	angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
	    "</span>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html",
	    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
	    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\"\n" +
	    "         ng-repeat=\"tab in tabset.tabs\"\n" +
	    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
	    "         uib-tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html",
	    "<table class=\"uib-timepicker\">\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
	    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-match.html",
	    "<a href\n" +
	    "   tabindex=\"-1\"\n" +
	    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
	    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
	angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
	angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
	angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
	angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
	angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
	angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * State-based routing for AngularJS 1.x
	 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
	 * @version v1.0.28
	 * @link https://ui-router.github.io
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(333), __webpack_require__(351)) :
	    typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']));
	}(this, (function (exports, ng_from_import, core) { 'use strict';
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */ var ng_from_global = angular;
	    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
	
	    /** @publicapi @module ng1 */ /** */
	    /** @internalapi */
	    function getNg1ViewConfigFactory() {
	        var templateFactory = null;
	        return function (path, view) {
	            templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
	            return [new Ng1ViewConfig(path, view, templateFactory)];
	        };
	    }
	    /** @internalapi */
	    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false); };
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `views`.
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
	     *
	     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	     * and applies the state-level configuration to a view named `$default`.
	     *
	     * @internalapi
	     */
	    function ng1ViewsBuilder(state) {
	        // Do not process root state
	        if (!state.parent)
	            return {};
	        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
	        // Do not allow a state to have both state-level props and also a `views: {}` property.
	        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
	        // However, the `$default` approach should not be mixed with a separate `views: ` block.
	        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
	            throw new Error("State '" + state.name + "' has a 'views' object. " +
	                "It cannot also have \"view properties\" at the state level.  " +
	                "Move the following properties into a view (in the 'views' object): " +
	                (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(', ')));
	        }
	        var views = {}, viewsObject = state.views || { $default: core.pick(state, allViewKeys) };
	        core.forEach(viewsObject, function (config, name) {
	            // Account for views: { "": { template... } }
	            name = name || '$default';
	            // Account for views: { header: "headerComponent" }
	            if (core.isString(config))
	                config = { component: config };
	            // Make a shallow copy of the config object
	            config = core.extend({}, config);
	            // Do not allow a view to mix props for component-style view with props for template/controller-style view
	            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
	            }
	            config.resolveAs = config.resolveAs || '$resolve';
	            config.$type = 'ng1';
	            config.$context = state;
	            config.$name = name;
	            var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	            config.$uiViewName = normalized.uiViewName;
	            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	            views[name] = config;
	        });
	        return views;
	    }
	    /** @hidden */
	    var id = 0;
	    /** @internalapi */
	    var Ng1ViewConfig = /** @class */ (function () {
	        function Ng1ViewConfig(path, viewDecl, factory) {
	            var _this = this;
	            this.path = path;
	            this.viewDecl = viewDecl;
	            this.factory = factory;
	            this.$id = id++;
	            this.loaded = false;
	            this.getTemplate = function (uiView, context) {
	                return _this.component
	                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
	                    : _this.template;
	            };
	        }
	        Ng1ViewConfig.prototype.load = function () {
	            var _this = this;
	            var $q = core.services.$q;
	            var context = new core.ResolveContext(this.path);
	            var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
	            var promises = {
	                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	                controller: $q.when(this.getController(context)),
	            };
	            return $q.all(promises).then(function (results) {
	                core.trace.traceViewServiceEvent('Loaded', _this);
	                _this.controller = results.controller;
	                core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	                return _this;
	            });
	        };
	        /**
	         * Gets the controller for a view configuration.
	         *
	         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	         */
	        Ng1ViewConfig.prototype.getController = function (context) {
	            var provider = this.viewDecl.controllerProvider;
	            if (!core.isInjectable(provider))
	                return this.viewDecl.controller;
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        return Ng1ViewConfig;
	    }());
	
	    /** @publicapi @module view */ /** */
	    /**
	     * Service which manages loading of templates from a ViewConfig.
	     */
	    var TemplateFactory = /** @class */ (function () {
	        function TemplateFactory() {
	            var _this = this;
	            /** @hidden */ this._useHttp = ng.version.minor < 3;
	            /** @hidden */ this.$get = [
	                '$http',
	                '$templateCache',
	                '$injector',
	                function ($http, $templateCache, $injector) {
	                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                    _this.$http = $http;
	                    _this.$templateCache = $templateCache;
	                    return _this;
	                },
	            ];
	        }
	        /** @hidden */
	        TemplateFactory.prototype.useHttpService = function (value) {
	            this._useHttp = value;
	        };
	        /**
	         * Creates a template from a configuration object.
	         *
	         * @param config Configuration object for which to load a template.
	         * The following properties are search in the specified order, and the first one
	         * that is defined is used to create the template:
	         *
	         * @param params  Parameters to pass to the template function.
	         * @param context The resolve context associated with the template's view
	         *
	         * @return {string|object}  The template html as a string, or a promise for
	         * that string,or `null` if no template is configured.
	         */
	        TemplateFactory.prototype.fromConfig = function (config, params, context) {
	            var defaultTemplate = '<ui-view></ui-view>';
	            var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	            var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	            return core.isDefined(config.template)
	                ? asTemplate(this.fromString(config.template, params))
	                : core.isDefined(config.templateUrl)
	                    ? asTemplate(this.fromUrl(config.templateUrl, params))
	                    : core.isDefined(config.templateProvider)
	                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
	                        : core.isDefined(config.component)
	                            ? asComponent(config.component)
	                            : core.isDefined(config.componentProvider)
	                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
	                                : asTemplate(defaultTemplate);
	        };
	        /**
	         * Creates a template from a string or a function returning a string.
	         *
	         * @param template html template as a string or function that returns an html template as a string.
	         * @param params Parameters to pass to the template function.
	         *
	         * @return {string|object} The template html as a string, or a promise for that
	         * string.
	         */
	        TemplateFactory.prototype.fromString = function (template, params) {
	            return core.isFunction(template) ? template(params) : template;
	        };
	        /**
	         * Loads a template from the a URL via `$http` and `$templateCache`.
	         *
	         * @param {string|Function} url url of the template to load, or a function
	         * that returns a url.
	         * @param {Object} params Parameters to pass to the url function.
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromUrl = function (url, params) {
	            if (core.isFunction(url))
	                url = url(params);
	            if (url == null)
	                return null;
	            if (this._useHttp) {
	                return this.$http
	                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                    .then(function (response) {
	                    return response.data;
	                });
	            }
	            return this.$templateRequest(url);
	        };
	        /**
	         * Creates a template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a component's template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a template from a component's name
	         *
	         * This implements route-to-component.
	         * It works by retrieving the component (directive) metadata from the injector.
	         * It analyses the component's bindings, then constructs a template that instantiates the component.
	         * The template wires input and output bindings to resolves or from the parent component.
	         *
	         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	         * @param component {string} Component's name in camel case.
	         * @param bindings An object defining the component's bindings: {foo: '<'}
	         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	            bindings = bindings || {};
	            // Bind once prefix
	            var prefix = ng.version.minor >= 3 ? '::' : '';
	            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
	            var kebob = function (camelCase) {
	                var kebobed = core.kebobString(camelCase);
	                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
	            };
	            var attributeTpl = function (input) {
	                var name = input.name, type = input.type;
	                var attrName = kebob(name);
	                // If the ui-view has an attribute which matches a binding on the routed component
	                // then pass that attribute through to the routed component template.
	                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	                if (uiView.attr(attrName) && !bindings[name])
	                    return attrName + "='" + uiView.attr(attrName) + "'";
	                var resolveName = bindings[name] || name;
	                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	                // some-attr="{{ ::$resolve.someResolveName }}"
	                if (type === '@')
	                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	                // Wire "&" callbacks to resolves that return a callback function
	                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	                // some-attr="$resolve.someResolveResultName(foo, bar)"
	                if (type === '&') {
	                    var res = context.getResolvable(resolveName);
	                    var fn = res && res.data;
	                    var args = (fn && core.services.$injector.annotate(fn)) || [];
	                    // account for array style injection, i.e., ['foo', function(foo) {}]
	                    var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
	                }
	                // some-attr="::$resolve.someResolveName"
	                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	            };
	            var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
	            var kebobName = kebob(component);
	            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	        };
	        return TemplateFactory;
	    }());
	    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	    function getComponentBindings(name) {
	        var cmpDefs = core.services.$injector.get(name + 'Directive'); // could be multiple
	        if (!cmpDefs || !cmpDefs.length)
	            throw new Error("Unable to find component named '" + name + "'");
	        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
	    }
	    // Given a directive definition, find its object input attributes
	    // Use different properties, depending on the type of directive (component, bindToController, normal)
	    var getBindings = function (def) {
	        if (core.isObject(def.bindToController))
	            return scopeBindings(def.bindToController);
	        return scopeBindings(def.scope);
	    };
	    // for ng 1.2 style, process the scope: { input: "=foo" }
	    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	    var scopeBindings = function (bindingsObj) {
	        return Object.keys(bindingsObj || {})
	            // [ 'input', [ '=foo', '=', 'foo' ] ]
	            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	            // skip malformed values
	            .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
	            // { name: ('foo' || 'input'), type: '=' }
	            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * The Angular 1 `StateProvider`
	     *
	     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	     * on state.
	     *
	     * A state corresponds to a "place" in the application in terms of the overall UI and
	     * navigation. A state describes (via the controller / template / view properties) what
	     * the UI looks like and does at that place.
	     *
	     * States often have things in common, and the primary way of factoring out these
	     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	     * nested states.
	     *
	     * The `$stateProvider` provides interfaces to declare these states for your app.
	     */
	    var StateProvider = /** @class */ (function () {
	        function StateProvider(stateRegistry, stateService) {
	            this.stateRegistry = stateRegistry;
	            this.stateService = stateService;
	            core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
	        }
	        /**
	         * Decorates states when they are registered
	         *
	         * Allows you to extend (carefully) or override (at your own peril) the
	         * `stateBuilder` object used internally by [[StateRegistry]].
	         * This can be used to add custom functionality to ui-router,
	         * for example inferring templateUrl based on the state name.
	         *
	         * When passing only a name, it returns the current (original or decorated) builder
	         * function that matches `name`.
	         *
	         * The builder functions that can be decorated are listed below. Though not all
	         * necessarily have a good use case for decoration, that is up to you to decide.
	         *
	         * In addition, users can attach custom decorators, which will generate new
	         * properties within the state's internal definition. There is currently no clear
	         * use-case for this beyond accessing internal states (i.e. $state.$current),
	         * however, expect this to become increasingly relevant as we introduce additional
	         * meta-programming features.
	         *
	         * **Warning**: Decorators should not be interdependent because the order of
	         * execution of the builder functions in non-deterministic. Builder functions
	         * should only be dependent on the state definition object and super function.
	         *
	         *
	         * Existing builder functions and current return values:
	         *
	         * - **parent** `{object}` - returns the parent state object.
	         * - **data** `{object}` - returns state data, including any inherited data that is not
	         *   overridden by own values (if any).
	         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	         *   or `null`.
	         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	         *   navigable).
	         * - **params** `{object}` - returns an array of state params that are ensured to
	         *   be a super-set of parent's params.
	         * - **views** `{object}` - returns a views object where each key is an absolute view
	         *   name (i.e. "viewName@stateName") and each value is the config object
	         *   (template, controller) for the view. Even when you don't use the views object
	         *   explicitly on a state config, one is still created for you internally.
	         *   So by decorating this builder function you have access to decorating template
	         *   and controller properties.
	         * - **ownParams** `{object}` - returns an array of params that belong to the state,
	         *   not including any params defined by ancestor states.
	         * - **path** `{string}` - returns the full path from the root down to this state.
	         *   Needed for state activation.
	         * - **includes** `{object}` - returns an object that includes every state that
	         *   would pass a `$state.includes()` test.
	         *
	         * #### Example:
	         * Override the internal 'views' builder with a function that takes the state
	         * definition, and a reference to the internal function being overridden:
	         * ```js
	         * $stateProvider.decorator('views', function (state, parent) {
	         *   let result = {},
	         *       views = parent(state);
	         *
	         *   angular.forEach(views, function (config, name) {
	         *     let autoName = (state.name + '.' + name).replace('.', '/');
	         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	         *     result[name] = config;
	         *   });
	         *   return result;
	         * });
	         *
	         * $stateProvider.state('home', {
	         *   views: {
	         *     'contact.list': { controller: 'ListController' },
	         *     'contact.item': { controller: 'ItemController' }
	         *   }
	         * });
	         * ```
	         *
	         *
	         * ```js
	         * // Auto-populates list and item views with /partials/home/contact/list.html,
	         * // and /partials/home/contact/item.html, respectively.
	         * $state.go('home');
	         * ```
	         *
	         * @param {string} name The name of the builder function to decorate.
	         * @param {object} func A function that is responsible for decorating the original
	         * builder function. The function receives two parameters:
	         *
	         *   - `{object}` - state - The state config object.
	         *   - `{object}` - super - The original builder function.
	         *
	         * @return {object} $stateProvider - $stateProvider instance
	         */
	        StateProvider.prototype.decorator = function (name, func) {
	            return this.stateRegistry.decorator(name, func) || this;
	        };
	        StateProvider.prototype.state = function (name, definition) {
	            if (core.isObject(name)) {
	                definition = name;
	            }
	            else {
	                definition.name = name;
	            }
	            this.stateRegistry.register(definition);
	            return this;
	        };
	        /**
	         * Registers an invalid state handler
	         *
	         * This is a passthrough to [[StateService.onInvalid]] for ng1.
	         */
	        StateProvider.prototype.onInvalid = function (callback) {
	            return this.stateService.onInvalid(callback);
	        };
	        return StateProvider;
	    }());
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
	     *
	     * @internalapi
	     */
	    var getStateHookBuilder = function (hookName) {
	        return function stateHookBuilder(stateObject) {
	            var hook = stateObject[hookName];
	            var pathname = hookName === 'onExit' ? 'from' : 'to';
	            function decoratedNg1Hook(trans, state) {
	                var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
	                var subContext = resolveContext.subContext(state.$$state());
	                var locals = core.extend(getLocals(subContext), { $state$: state, $transition$: trans });
	                return core.services.$injector.invoke(hook, this, locals);
	            }
	            return hook ? decoratedNg1Hook : undefined;
	        };
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	     * @internalapi
	     */
	    var Ng1LocationServices = /** @class */ (function () {
	        function Ng1LocationServices($locationProvider) {
	            // .onChange() registry
	            this._urlListeners = [];
	            this.$locationProvider = $locationProvider;
	            var _lp = core.val($locationProvider);
	            core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	        }
	        /**
	         * Applys ng1-specific path parameter encoding
	         *
	         * The Angular 1 `$location` service is a bit weird.
	         * It doesn't allow slashes to be encoded/decoded bi-directionally.
	         *
	         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	         *
	         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	         *
	         * @param router
	         */
	        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	            var pathType = router.urlMatcherFactory.type('path');
	            pathType.encode = function (x) {
	                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
	            };
	            pathType.decode = function (x) {
	                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
	            };
	        };
	        // eslint-disable-next-line @typescript-eslint/no-empty-function
	        Ng1LocationServices.prototype.dispose = function () { };
	        Ng1LocationServices.prototype.onChange = function (callback) {
	            var _this = this;
	            this._urlListeners.push(callback);
	            return function () { return core.removeFrom(_this._urlListeners)(callback); };
	        };
	        Ng1LocationServices.prototype.html5Mode = function () {
	            var html5Mode = this.$locationProvider.html5Mode();
	            html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	            return html5Mode && this.$sniffer.history;
	        };
	        Ng1LocationServices.prototype.baseHref = function () {
	            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
	        };
	        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	            if (replace === void 0) { replace = false; }
	            if (core.isDefined(newUrl))
	                this.$location.url(newUrl);
	            if (replace)
	                this.$location.replace();
	            if (state)
	                this.$location.state(state);
	            return this.$location.url();
	        };
	        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
	            var _this = this;
	            this.$location = $location;
	            this.$sniffer = $sniffer;
	            this.$browser = $browser;
	            this.$window = $window;
	            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	            var _loc = core.val($location);
	            // Bind these LocationService functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
	            // Bind these LocationConfig functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        };
	        return Ng1LocationServices;
	    }());
	
	    /** @publicapi @module url */ /** */
	    /**
	     * Manages rules for client-side URL
	     *
	     * ### Deprecation warning:
	     * This class is now considered to be an internal API
	     * Use the [[UrlService]] instead.
	     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
	     *
	     * This class manages the router rules for what to do when the URL changes.
	     *
	     * This provider remains for backwards compatibility.
	     *
	     * @internalapi
	     * @deprecated
	     */
	    var UrlRouterProvider = /** @class */ (function () {
	        /** @hidden */
	        function UrlRouterProvider(/** @hidden */ router) {
	            this.router = router;
	        }
	        UrlRouterProvider.injectableHandler = function (router, handler) {
	            return function (match) { return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
	        };
	        /** @hidden */
	        UrlRouterProvider.prototype.$get = function () {
	            var urlService = this.router.urlService;
	            this.router.urlRouter.update(true);
	            if (!urlService.interceptDeferred)
	                urlService.listen();
	            return this.router.urlRouter;
	        };
	        /**
	         * Registers a url handler function.
	         *
	         * Registers a low level url handler (a `rule`).
	         * A rule detects specific URL patterns and returns a redirect, or performs some action.
	         *
	         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Here's an example of how you might allow case insensitive urls
	         *   $urlRouterProvider.rule(function ($injector, $location) {
	         *     var path = $location.path(),
	         *         normalized = path.toLowerCase();
	         *
	         *     if (path !== normalized) {
	         *       return normalized;
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param ruleFn
	         * Handler function that takes `$injector` and `$location` services as arguments.
	         * You can use them to detect a url and return a different url as a string.
	         *
	         * @return [[UrlRouterProvider]] (`this`)
	         */
	        UrlRouterProvider.prototype.rule = function (ruleFn) {
	            var _this = this;
	            if (!core.isFunction(ruleFn))
	                throw new Error("'rule' must be a function");
	            var match = function () { return ruleFn(core.services.$injector, _this.router.locationService); };
	            var rule = new core.BaseUrlRule(match, core.identity);
	            this.router.urlService.rules.rule(rule);
	            return this;
	        };
	        /**
	         * Defines the path or behavior to use when no url can be matched.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // if the path doesn't match any of the urls you configured
	         *   // otherwise will take care of routing the user to the
	         *   // specified url
	         *   $urlRouterProvider.otherwise('/index');
	         *
	         *   // Example of using function rule as param
	         *   $urlRouterProvider.otherwise(function ($injector, $location) {
	         *     return '/a/valid/url';
	         *   });
	         * });
	         * ```
	         *
	         * @param rule
	         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	         *
	         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	         */
	        UrlRouterProvider.prototype.otherwise = function (rule) {
	            var _this = this;
	            var urlRules = this.router.urlService.rules;
	            if (core.isString(rule)) {
	                urlRules.otherwise(rule);
	            }
	            else if (core.isFunction(rule)) {
	                urlRules.otherwise(function () { return rule(core.services.$injector, _this.router.locationService); });
	            }
	            else {
	                throw new Error("'rule' must be a string or function");
	            }
	            return this;
	        };
	        /**
	         * Registers a handler for a given url matching.
	         *
	         * If the handler is a string, it is
	         * treated as a redirect, and is interpolated according to the syntax of match
	         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	         *
	         * If the handler is a function, it is injectable.
	         * It gets invoked if `$location` matches.
	         * You have the option of inject the match object as `$match`.
	         *
	         * The handler can return
	         *
	         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	         *   will continue trying to find another one that matches.
	         * - **string** which is treated as a redirect and passed to `$location.url()`
	         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	         *     if ($state.$current.navigable !== state ||
	         *         !equalForKeys($match, $stateParams) {
	         *      $state.transitionTo(state, $match, false);
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	         * @param handler The path (or function that returns a path) that you want to redirect your user to.
	         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	         *
	         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	         */
	        UrlRouterProvider.prototype.when = function (what, handler) {
	            if (core.isArray(handler) || core.isFunction(handler)) {
	                handler = UrlRouterProvider.injectableHandler(this.router, handler);
	            }
	            this.router.urlService.rules.when(what, handler);
	            return this;
	        };
	        /**
	         * Disables monitoring of the URL.
	         *
	         * Call this method before UI-Router has bootstrapped.
	         * It will stop UI-Router from performing the initial url sync.
	         *
	         * This can be useful to perform some asynchronous initialization before the router starts.
	         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Prevent $urlRouter from automatically intercepting URL changes;
	         *   $urlRouterProvider.deferIntercept();
	         * })
	         *
	         * app.run(function (MyService, $urlRouter, $http) {
	         *   $http.get("/stuff").then(function(resp) {
	         *     MyService.doStuff(resp.data);
	         *     $urlRouter.listen();
	         *     $urlRouter.sync();
	         *   });
	         * });
	         * ```
	         *
	         * @param defer Indicates whether to defer location change interception.
	         *        Passing no parameter is equivalent to `true`.
	         */
	        UrlRouterProvider.prototype.deferIntercept = function (defer) {
	            this.router.urlService.deferIntercept(defer);
	        };
	        return UrlRouterProvider;
	    }());
	
	    /* eslint-disable @typescript-eslint/no-empty-function */
	    ng.module('ui.router.angular1', []);
	    var mod_init = ng.module('ui.router.init', ['ng']);
	    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
	    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
	    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
	    var router = null;
	    $uiRouterProvider.$inject = ['$locationProvider'];
	    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	    function $uiRouterProvider($locationProvider) {
	        // Create a new instance of the Router when the $uiRouterProvider is initialized
	        router = this.router = new core.UIRouter();
	        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
	        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	        router.stateRegistry.decorator('views', ng1ViewsBuilder);
	        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
	        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
	        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
	        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
	        // Disable decoding of params by UrlMatcherFactory because $location already handles this
	        router.urlService.config._decodeParams = false;
	        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
	        Ng1LocationServices.monkeyPatchPathParameterType(router);
	        // backwards compat: also expose router instance as $uiRouterProvider.router
	        router['router'] = router;
	        router['$get'] = $get;
	        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
	        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
	            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
	            delete router['router'];
	            delete router['$get'];
	            return router;
	        }
	        return router;
	    }
	    var getProviderFor = function (serviceName) { return [
	        '$uiRouterProvider',
	        function ($urp) {
	            var service = $urp.router[serviceName];
	            service['$get'] = function () { return service; };
	            return service;
	        },
	    ]; };
	    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	    function runBlock($injector, $q, $uiRouter) {
	        core.services.$injector = $injector;
	        core.services.$q = $q;
	        // https://github.com/angular-ui/ui-router/issues/3678
	        if (!Object.prototype.hasOwnProperty.call($injector, 'strictDi')) {
	            try {
	                $injector.invoke(function (checkStrictDi) { });
	            }
	            catch (error) {
	                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
	            }
	        }
	        // The $injector is now available.
	        // Find any resolvables that had dependency annotation deferred
	        $uiRouter.stateRegistry
	            .get()
	            .map(function (x) { return x.$$state().resolvables; })
	            .reduce(core.unnestR, [])
	            .filter(function (x) { return x.deps === 'deferred'; })
	            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
	    }
	    // $urlRouter service and $urlRouterProvider
	    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
	    // $state service and $stateProvider
	    // $urlRouter service and $urlRouterProvider
	    var getStateProvider = function () { return core.extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
	    watchDigests.$inject = ['$rootScope'];
	    function watchDigests($rootScope) {
	        $rootScope.$watch(function () {
	            core.trace.approximateDigests++;
	        });
	    }
	    mod_init.provider('$uiRouter', $uiRouterProvider);
	    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	    mod_util.provider('$urlService', getProviderFor('urlService'));
	    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
	    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	    mod_state.provider('$transitions', getProviderFor('transitionService'));
	    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	    mod_main.factory('$view', function () { return router.viewService; });
	    mod_main.service('$trace', function () { return core.trace; });
	    mod_main.run(watchDigests);
	    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	    mod_state.run(['$state', function ($state) { }]);
	    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	    mod_init.run(runBlock);
	    /** @hidden TODO: find a place to move this */
	    var getLocals = function (ctx) {
	        var tokens = ctx.getTokens().filter(core.isString);
	        var tuples = tokens.map(function (key) {
	            var resolvable = ctx.getResolvable(key);
	            var waitPolicy = ctx.getPolicy(resolvable).async;
	            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	        });
	        return tuples.reduce(core.applyPairs, {});
	    };
	
	    /* eslint-disable @typescript-eslint/no-empty-interface */
	    /** @hidden */
	    function parseStateRef(ref) {
	        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
	        if (paramsOnly)
	            ref = '(' + paramsOnly[1] + ')';
	        var parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	        if (!parsed || parsed.length !== 4)
	            throw new Error("Invalid state ref '" + ref + "'");
	        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	    }
	    /** @hidden */
	    function stateContext(el) {
	        var $uiView = el.parent().inheritedData('$uiView');
	        var path = core.parse('$cfg.path')($uiView);
	        return path ? core.tail(path).state.name : undefined;
	    }
	    /** @hidden */
	    function processedDef($state, $element, def) {
	        var uiState = def.uiState || $state.current.name;
	        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	    }
	    /** @hidden */
	    function getTypeInfo(el) {
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	        var isForm = el[0].nodeName === 'FORM';
	        return {
	            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
	            isAnchor: el.prop('tagName').toUpperCase() === 'A',
	            clickable: !isForm,
	        };
	    }
	    /** @hidden */
	    function clickHook(el, $state, $timeout, type, getDef) {
	        return function (e) {
	            var button = e.which || e.button, target = getDef();
	            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr('target'))) {
	                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	                var transition_1 = $timeout(function () {
	                    if (!el.attr('disabled')) {
	                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	                    }
	                });
	                e.preventDefault();
	                // if the state has no URL, ignore one preventDefault from the <a> directive.
	                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
	                e.preventDefault = function () {
	                    if (ignorePreventDefaultCount_1-- <= 0)
	                        $timeout.cancel(transition_1);
	                };
	            }
	        };
	    }
	    /** @hidden */
	    function defaultOpts(el, $state) {
	        return {
	            relative: stateContext(el) || $state.$current,
	            inherit: true,
	            source: 'sref',
	        };
	    }
	    /** @hidden */
	    function bindEvents(element, scope, hookFn, uiStateOpts) {
	        var events;
	        if (uiStateOpts) {
	            events = uiStateOpts.events;
	        }
	        if (!core.isArray(events)) {
	            events = ['click'];
	        }
	        var on = element.on ? 'on' : 'bind';
	        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
	            var event_1 = events_1[_i];
	            element[on](event_1, hookFn);
	        }
	        scope.$on('$destroy', function () {
	            var off = element.off ? 'off' : 'unbind';
	            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
	                var event_2 = events_2[_i];
	                element[off](event_2, hookFn);
	            }
	        });
	    }
	    /**
	     * `ui-sref`: A directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of the `ui-sref` is the name of the state to link to.
	     *
	     * #### Example:
	     * This will activate the `home` state when the link is clicked.
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * ```
	     *
	     * ### Relative Links
	     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create a relative `ui-sref` which always targets the same destination.
	     *
	     * #### Example:
	     * Both these links are relative to the parent state, even when a child state is currently active.
	     * ```html
	     * <a ui-sref=".child1">child 1 state</a>
	     * <a ui-sref=".child2">child 2 state</a>
	     * ```
	     *
	     * This link activates the parent state.
	     * ```html
	     * <a ui-sref="^">Return</a>
	     * ```
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * #### Example:
	     * Assuming the `users` state has a url of `/users/`
	     * ```html
	     * <a ui-sref="users" href="/users/">Users</a>
	     * ```
	     *
	     * ### Parameter Values
	     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	     * The content inside the parentheses is an expression, evaluated to the parameter values.
	     *
	     * #### Example:
	     * This example renders a list of links to users.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="user in users">
	     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * Note:
	     * The parameter values expression is `$watch`ed for updates.
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-sref-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Examples
	     * If you have the following template:
	     *
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * <a ui-sref="about">About</a>
	     * <a ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	     *     </li>
	     * </ul>
	     * ```
	     *
	     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	     *
	     * ```html
	     * <a href="#/home" ui-sref="home">Home</a>
	     * <a href="#/about" ui-sref="about">About</a>
	     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	     *     </li>
	     * </ul>
	     *
	     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	     * ```
	     *
	     * ### Notes
	     *
	     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-sref="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     *
	     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	     */
	    var uiSrefDirective;
	    uiSrefDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var ref = parseStateRef(attrs.uiSref);
	                    rawDef.uiState = ref.state;
	                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    if (ref.paramExpr) {
	                        scope.$watch(ref.paramExpr, function (val) {
	                            rawDef.uiStateParams = core.extend({}, val);
	                            update();
	                        }, true);
	                        rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
	                    }
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    var hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-state`: A fully dynamic directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	     *
	     * #### Example:
	     * Create a list of links.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Relative Links
	     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create relative `ui-state` which always targets the same destination.
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * ### Parameter Values
	     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	     * Param values should be provided using the `ui-state-params` attribute.
	     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * This example renders a list of links with param values.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-state-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Notes
	     *
	     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	     *   However, it might be simpler to use [[uiSref]] parameter-only links.
	     *
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     * ```
	     */
	    var uiStateDirective;
	    uiStateDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDynamicDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = core.noop), acc); }, {});
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    inputAttrs.forEach(function (field) {
	                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                        attrs.$observe(field, function (expr) {
	                            watchDeregFns[field]();
	                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                                rawDef[field] = newval;
	                                update();
	                            }, true);
	                        });
	                    });
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	     *
	     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	     * related directive's state is active (and remove them when it is inactive).
	     *
	     * The primary use-case is to highlight the active link in navigation menus,
	     * distinguishing it from the inactive menu items.
	     *
	     * ### Linking to a `ui-sref` or `ui-state`
	     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	     *
	     * ### Matching
	     *
	     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	     * This is a "fuzzy match" which uses [[StateService.includes]].
	     *
	     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	     * This is an "exact match" which uses [[StateService.is]].
	     *
	     * ### Parameter values
	     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	     *
	     * #### Example:
	     * ```html
	     * <li ng-repeat="user in users" ui-sref-active="active">
	     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Examples
	     *
	     * Given the following template:
	     * #### Example:
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item">
	     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * When the app state is `app.user` (or any child state),
	     * and contains the state parameter "user" with value "bilbobaggins",
	     * the resulting HTML will appear as (note the 'active' class):
	     *
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item active">
	     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * ### Glob mode
	     *
	     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	     * The objects keys represent active class names and values represent the respective state names/globs.
	     * `ui-sref-active` will match if the current active state **includes** any of
	     * the specified state names/globs, even the abstract ones.
	     *
	     * #### Example:
	     * Given the following template, with "admin" being an abstract state:
	     * ```html
	     * <div ui-sref-active="{'active': 'admin.**'}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * Arrays are also supported as values in the `ngClass`-like interface.
	     * This allows multiple states to add `active` class.
	     *
	     * #### Example:
	     * Given the following template, with "admin.roles" being the current state, the class will be added too:
	     * ```html
	     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
	     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	     *
	     * ### Notes:
	     *
	     * - The class name is interpolated **once** during the directives link time (any further changes to the
	     * interpolated value are ignored).
	     *
	     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	     */
	    var uiSrefActiveDirective;
	    uiSrefActiveDirective = [
	        '$state',
	        '$stateParams',
	        '$interpolate',
	        '$uiRouter',
	        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	            return {
	                restrict: 'A',
	                controller: [
	                    '$scope',
	                    '$element',
	                    '$attrs',
	                    function ($scope, $element, $attrs) {
	                        var states = [];
	                        var activeEqClass;
	                        var uiSrefActive;
	                        // There probably isn't much point in $observing this
	                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                        // slight difference in logic routing
	                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                        try {
	                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                        }
	                        catch (e) {
	                            // Do nothing. uiSrefActive is not a valid expression.
	                            // Fall back to using $interpolate below
	                        }
	                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                        setStatesFromDefinitionObject(uiSrefActive);
	                        // Allow uiSref to communicate with uiSrefActive[Equals]
	                        this.$$addStateInfo = function (newState, newParams) {
	                            // we already got an explicit state provided by ui-sref-active, so we
	                            // shadow the one that comes from ui-sref
	                            if (core.isObject(uiSrefActive) && states.length > 0) {
	                                return;
	                            }
	                            var deregister = addState(newState, newParams, uiSrefActive);
	                            update();
	                            return deregister;
	                        };
	                        function updateAfterTransition(trans) {
	                            trans.promise.then(update, core.noop);
	                        }
	                        $scope.$on('$destroy', setupEventListeners());
	                        if ($uiRouter.globals.transition) {
	                            updateAfterTransition($uiRouter.globals.transition);
	                        }
	                        function setupEventListeners() {
	                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
	                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
	                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
	                            return function cleanUp() {
	                                deregisterStatesChangedListener();
	                                deregisterOnStartListener();
	                                deregisterStateChangeSuccessListener();
	                            };
	                        }
	                        function handleStatesChanged() {
	                            setStatesFromDefinitionObject(uiSrefActive);
	                        }
	                        function setStatesFromDefinitionObject(statesDefinition) {
	                            if (core.isObject(statesDefinition)) {
	                                states = [];
	                                core.forEach(statesDefinition, function (stateOrName, activeClass) {
	                                    // Helper function to abstract adding state.
	                                    var addStateForClass = function (stateOrName, activeClass) {
	                                        var ref = parseStateRef(stateOrName);
	                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                                    };
	                                    if (core.isString(stateOrName)) {
	                                        // If state is string, just add it.
	                                        addStateForClass(stateOrName, activeClass);
	                                    }
	                                    else if (core.isArray(stateOrName)) {
	                                        // If state is an array, iterate over it and add each array item individually.
	                                        core.forEach(stateOrName, function (stateOrName) {
	                                            addStateForClass(stateOrName, activeClass);
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        function addState(stateName, stateParams, activeClass) {
	                            var state = $state.get(stateName, stateContext($element));
	                            var stateInfo = {
	                                state: state || { name: stateName },
	                                params: stateParams,
	                                activeClass: activeClass,
	                            };
	                            states.push(stateInfo);
	                            return function removeState() {
	                                core.removeFrom(states)(stateInfo);
	                            };
	                        }
	                        // Update route state
	                        function update() {
	                            var splitClasses = function (str) { return str.split(/\s/).filter(core.identity); };
	                            var getClasses = function (stateList) {
	                                return stateList
	                                    .map(function (x) { return x.activeClass; })
	                                    .map(splitClasses)
	                                    .reduce(core.unnestR, []);
	                            };
	                            var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core.uniqR, []);
	                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
	                            var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
	                            $scope.$evalAsync(function () {
	                                addClasses.forEach(function (className) { return $element.addClass(className); });
	                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                            });
	                        }
	                        update();
	                    },
	                ],
	            };
	        },
	    ];
	    ng
	        .module('ui.router.state')
	        .directive('uiSref', uiSrefDirective)
	        .directive('uiSrefActive', uiSrefActiveDirective)
	        .directive('uiSrefActiveEq', uiSrefActiveDirective)
	        .directive('uiState', uiStateDirective);
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * `isState` Filter: truthy if the current state is the parameter
	     *
	     * Translates to [[StateService.is]] `$state.is("stateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
	     * ```
	     */
	    $IsStateFilter.$inject = ['$state'];
	    function $IsStateFilter($state) {
	        var isFilter = function (state, params, options) {
	            return $state.is(state, params, options);
	        };
	        isFilter.$stateful = true;
	        return isFilter;
	    }
	    /**
	     * `includedByState` Filter: truthy if the current state includes the parameter
	     *
	     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
	     * ```
	     */
	    $IncludedByStateFilter.$inject = ['$state'];
	    function $IncludedByStateFilter($state) {
	        var includesFilter = function (state, params, options) {
	            return $state.includes(state, params, options);
	        };
	        includesFilter.$stateful = true;
	        return includesFilter;
	    }
	    ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
	
	    /** @publicapi @module directives */ /** */
	    /**
	     * `ui-view`: A viewport directive which is filled in by a view from the active state.
	     *
	     * ### Attributes
	     *
	     * - `name`: (Optional) A view name.
	     *   The name should be unique amongst the other views in the same state.
	     *   You can have views of the same name that live in different states.
	     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	     *
	     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	     *   Uses [[$uiViewScroll]] to do the scrolling.
	     *
	     * - `onload`: Expression to evaluate whenever the view updates.
	     *
	     * #### Example:
	     * A view can be unnamed or named.
	     * ```html
	     * <!-- Unnamed -->
	     * <div ui-view></div>
	     *
	     * <!-- Named -->
	     * <div ui-view="viewName"></div>
	     *
	     * <!-- Named (different style) -->
	     * <ui-view name="viewName"></ui-view>
	     * ```
	     *
	     * You can only have one unnamed view within any template (or root html). If you are only using a
	     * single view and it is unnamed then you can populate it like so:
	     *
	     * ```html
	     * <div ui-view></div>
	     * $stateProvider.state("home", {
	     *   template: "<h1>HELLO!</h1>"
	     * })
	     * ```
	     *
	     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
	     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * But typically you'll only use the views property if you name your view or have more than one view
	     * in the same template. There's not really a compelling reason to name a view if its the only one,
	     * but you could if you wanted, like so:
	     *
	     * ```html
	     * <div ui-view="main"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "main": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * Really though, you'll use views to set up multiple views:
	     *
	     * ```html
	     * <div ui-view></div>
	     * <div ui-view="chart"></div>
	     * <div ui-view="data"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     },
	     *     "chart": {
	     *       template: "<chart_thing/>"
	     *     },
	     *     "data": {
	     *       template: "<data_thing/>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * #### Examples for `autoscroll`:
	     * ```html
	     * <!-- If autoscroll present with no expression,
	     *      then scroll ui-view into view -->
	     * <ui-view autoscroll/>
	     *
	     * <!-- If autoscroll present with valid expression,
	     *      then scroll ui-view into view if expression evaluates to true -->
	     * <ui-view autoscroll='true'/>
	     * <ui-view autoscroll='false'/>
	     * <ui-view autoscroll='scopeVariable'/>
	     * ```
	     *
	     * Resolve data:
	     *
	     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	     *
	     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	     * depends on `$resolve` data.
	     *
	     * #### Example:
	     * ```js
	     * $stateProvider.state('home', {
	     *   template: '<my-component user="$resolve.user"></my-component>',
	     *   resolve: {
	     *     user: function(UserService) { return UserService.fetchUser(); }
	     *   }
	     * });
	     * ```
	     */
	    var uiView;
	    // eslint-disable-next-line prefer-const
	    uiView = [
	        '$view',
	        '$animate',
	        '$uiViewScroll',
	        '$interpolate',
	        '$q',
	        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	            function getRenderer() {
	                return {
	                    enter: function (element, target, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.enter(element, null, target).then(cb);
	                        }
	                        else {
	                            $animate.enter(element, null, target, cb);
	                        }
	                    },
	                    leave: function (element, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.leave(element).then(cb);
	                        }
	                        else {
	                            $animate.leave(element, cb);
	                        }
	                    },
	                };
	            }
	            function configsEqual(config1, config2) {
	                return config1 === config2;
	            }
	            var rootData = {
	                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	                $uiView: {},
	            };
	            var directive = {
	                count: 0,
	                restrict: 'ECA',
	                terminal: true,
	                priority: 400,
	                transclude: 'element',
	                compile: function (tElement, tAttrs, $transclude) {
	                    return function (scope, $element, attrs) {
	                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                        var previousEl, currentEl, currentScope, viewConfig;
	                        var activeUIView = {
	                            $type: 'ng1',
	                            id: directive.count++,
	                            name: name,
	                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
	                            config: null,
	                            configUpdated: configUpdatedCallback,
	                            get creationContext() {
	                                // The context in which this ui-view "tag" was created
	                                var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
	                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
	                                // See https://github.com/angular-ui/ui-router/issues/3355
	                                var fromParentTag = core.parse('$uiView.creationContext')(inherited);
	                                return fromParentTagConfig || fromParentTag;
	                            },
	                        };
	                        core.trace.traceUIViewEvent('Linking', activeUIView);
	                        function configUpdatedCallback(config) {
	                            if (config && !(config instanceof Ng1ViewConfig))
	                                return;
	                            if (configsEqual(viewConfig, config))
	                                return;
	                            core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                            viewConfig = config;
	                            updateView(config);
	                        }
	                        $element.data('$uiView', { $uiView: activeUIView });
	                        updateView();
	                        var unregister = $view.registerUIView(activeUIView);
	                        scope.$on('$destroy', function () {
	                            core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
	                            unregister();
	                        });
	                        function cleanupLastView() {
	                            if (previousEl) {
	                                core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
	                                previousEl.remove();
	                                previousEl = null;
	                            }
	                            if (currentScope) {
	                                core.trace.traceUIViewEvent('Destroying scope', activeUIView);
	                                currentScope.$destroy();
	                                currentScope = null;
	                            }
	                            if (currentEl) {
	                                var _viewData_1 = currentEl.data('$uiViewAnim');
	                                core.trace.traceUIViewEvent('Animate out', _viewData_1);
	                                renderer.leave(currentEl, function () {
	                                    _viewData_1.$$animLeave.resolve();
	                                    previousEl = null;
	                                });
	                                previousEl = currentEl;
	                                currentEl = null;
	                            }
	                        }
	                        function updateView(config) {
	                            var newScope = scope.$new();
	                            var animEnter = $q.defer(), animLeave = $q.defer();
	                            var $uiViewData = {
	                                $cfg: config,
	                                $uiView: activeUIView,
	                            };
	                            var $uiViewAnim = {
	                                $animEnter: animEnter.promise,
	                                $animLeave: animLeave.promise,
	                                $$animLeave: animLeave,
	                            };
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoading
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description
	                             *
	                             * Fired once the view **begins loading**, *before* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             * @param {string} viewName Name of the view.
	                             */
	                            newScope.$emit('$viewContentLoading', name);
	                            var cloned = $transclude(newScope, function (clone) {
	                                clone.data('$uiViewAnim', $uiViewAnim);
	                                clone.data('$uiView', $uiViewData);
	                                renderer.enter(clone, $element, function onUIViewEnter() {
	                                    animEnter.resolve();
	                                    if (currentScope)
	                                        currentScope.$emit('$viewContentAnimationEnded');
	                                    if ((core.isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
	                                        $uiViewScroll(clone);
	                                    }
	                                });
	                                cleanupLastView();
	                            });
	                            currentEl = cloned;
	                            currentScope = newScope;
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description           *
	                             * Fired once the view is **loaded**, *after* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             */
	                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                            currentScope.$eval(onloadExp);
	                        }
	                    };
	                },
	            };
	            return directive;
	        },
	    ];
	    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q'];
	    /** @hidden */
	    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
	        var getControllerAs = core.parse('viewDecl.controllerAs');
	        var getResolveAs = core.parse('viewDecl.resolveAs');
	        return {
	            restrict: 'ECA',
	            priority: -400,
	            compile: function (tElement) {
	                var initial = tElement.html();
	                tElement.empty();
	                return function (scope, $element) {
	                    var data = $element.data('$uiView');
	                    if (!data) {
	                        $element.html(initial);
	                        $compile($element.contents())(scope);
	                        return;
	                    }
	                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
	                    var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
	                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                    core.trace.traceUIViewFill(data.$uiView, $element.html());
	                    var link = $compile($element.contents());
	                    var controller = cfg.controller;
	                    var controllerAs = getControllerAs(cfg);
	                    var resolveAs = getResolveAs(cfg);
	                    var locals = resolveCtx && getLocals(resolveCtx);
	                    scope[resolveAs] = locals;
	                    if (controller) {
	                        var controllerInstance = ($controller(controller, core.extend({}, locals, { $scope: scope, $element: $element })));
	                        if (controllerAs) {
	                            scope[controllerAs] = controllerInstance;
	                            scope[controllerAs][resolveAs] = locals;
	                        }
	                        // TODO: Use $view service as a central point for registering component-level hooks
	                        // Then, when a component is created, tell the $view service, so it can invoke hooks
	                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                        $element.data('$ngControllerController', controllerInstance);
	                        $element.children().data('$ngControllerController', controllerInstance);
	                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
	                    }
	                    // Wait for the component to appear in the DOM
	                    if (core.isString(cfg.component)) {
	                        var kebobName = core.kebobString(cfg.component);
	                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
	                        var getComponentController = function () {
	                            var directiveEl = [].slice
	                                .call($element[0].children)
	                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
	                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
	                        };
	                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                            if (!ctrlInstance)
	                                return;
	                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
	                            deregisterWatch_1();
	                        });
	                    }
	                    link(scope);
	                };
	            },
	        };
	    }
	    /** @hidden */
	    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
	    /** @hidden incrementing id */
	    var _uiCanExitId = 0;
	    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
	        // Call $onInit() ASAP
	        if (core.isFunction(controllerInstance.$onInit) &&
	            !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && hasComponentImpl)) {
	            controllerInstance.$onInit();
	        }
	        var viewState = core.tail(cfg.path).state.self;
	        var hookOptions = { bind: controllerInstance };
	        // Add component-level hook for onUiParamsChanged
	        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
	            var resolveContext = new core.ResolveContext(cfg.path);
	            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	            // Fire callback on any successful transition
	            var paramsUpdated = function ($transition$) {
	                // Exit early if the $transition$ is the same as the view was created within.
	                // Exit early if the $transition$ will exit the state the view is for.
	                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                    return;
	                var toParams = $transition$.params('to');
	                var fromParams = $transition$.params('from');
	                var getNodeSchema = function (node) { return node.paramSchema; };
	                var toSchema = $transition$.treeChanges('to').map(getNodeSchema).reduce(core.unnestR, []);
	                var fromSchema = $transition$.treeChanges('from').map(getNodeSchema).reduce(core.unnestR, []);
	                // Find the to params that have different values than the from params
	                var changedToParams = toSchema.filter(function (param) {
	                    var idx = fromSchema.indexOf(param);
	                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	                });
	                // Only trigger callback if a to param has changed or is new
	                if (changedToParams.length) {
	                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                    var newValues = core.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
	                }
	            };
	            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	        }
	        // Add component-level hook for uiCanExit
	        if (core.isFunction(controllerInstance.uiCanExit)) {
	            var id_1 = _uiCanExitId++;
	            var cacheProp_1 = '_uiCanExitIds';
	            // Returns true if a redirect transition already answered truthy
	            var prevTruthyAnswer_1 = function (trans) {
	                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
	            };
	            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
	            var wrappedHook = function (trans) {
	                var promise;
	                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
	                if (!prevTruthyAnswer_1(trans)) {
	                    promise = $q.when(controllerInstance.uiCanExit(trans));
	                    promise.then(function (val) { return (ids[id_1] = val !== false); });
	                }
	                return promise;
	            };
	            var criteria = { exiting: viewState.name };
	            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
	        }
	    }
	    ng.module('ui.router.state').directive('uiView', uiView);
	    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */
	    function $ViewScrollProvider() {
	        var useAnchorScroll = false;
	        this.useAnchorScroll = function () {
	            useAnchorScroll = true;
	        };
	        this.$get = [
	            '$anchorScroll',
	            '$timeout',
	            function ($anchorScroll, $timeout) {
	                if (useAnchorScroll) {
	                    return $anchorScroll;
	                }
	                return function ($element) {
	                    return $timeout(function () {
	                        $element[0].scrollIntoView();
	                    }, 0, false);
	                };
	            },
	        ];
	    }
	    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	    /**
	     * Main entry point for angular 1.x build
	     * @publicapi @module ng1
	     */ /** */
	    var index = 'ui.router';
	
	    Object.keys(core).forEach(function (k) {
	        if (k !== 'default') Object.defineProperty(exports, k, {
	            enumerable: true,
	            get: function () {
	                return core[k];
	            }
	        });
	    });
	    exports.core = core;
	    exports.Ng1ViewConfig = Ng1ViewConfig;
	    exports.StateProvider = StateProvider;
	    exports.UrlRouterProvider = UrlRouterProvider;
	    exports.default = index;
	    exports.getLocals = getLocals;
	    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	    exports.ng1ViewsBuilder = ng1ViewsBuilder;
	    exports.watchDigests = watchDigests;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=ui-router-angularjs.js.map


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(352), exports);
	__exportStar(__webpack_require__(363), exports);
	__exportStar(__webpack_require__(369), exports);
	__exportStar(__webpack_require__(373), exports);
	__exportStar(__webpack_require__(377), exports);
	__exportStar(__webpack_require__(412), exports);
	__exportStar(__webpack_require__(413), exports);
	__exportStar(__webpack_require__(415), exports);
	__exportStar(__webpack_require__(398), exports);
	__exportStar(__webpack_require__(392), exports);
	__exportStar(__webpack_require__(417), exports);
	__exportStar(__webpack_require__(430), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(353), exports);
	__exportStar(__webpack_require__(356), exports);
	__exportStar(__webpack_require__(357), exports);
	__exportStar(__webpack_require__(355), exports);
	__exportStar(__webpack_require__(354), exports);
	__exportStar(__webpack_require__(358), exports);
	__exportStar(__webpack_require__(359), exports);
	__exportStar(__webpack_require__(361), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.silentRejection = exports.silenceUncaughtInPromise = exports._extend = exports.copy = exports.tail = exports.applyPairs = exports.arrayTuples = exports.pairs = exports.assertFn = exports.assertMap = exports.assertPredicate = exports.flatten = exports.unnest = exports.uniqR = exports.pushR = exports.flattenR = exports.unnestR = exports.anyTrueR = exports.allTrueR = exports.values = exports.map = exports.mapObj = exports.find = exports.filter = exports.pluck = exports.omit = exports.pick = exports.ancestors = exports.mergeR = exports.defaults = exports.deregAll = exports._pushTo = exports.pushTo = exports._removeFrom = exports.removeFrom = exports._inArray = exports.inArray = exports.inherit = exports.createProxyFunctions = exports.noop = exports.identity = exports.equals = exports.extend = exports.forEach = exports.toJson = exports.fromJson = exports.root = void 0;
	/**
	 * Random utility functions used in the UI-Router code
	 *
	 * These functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 * @preferred
	 */
	var predicates_1 = __webpack_require__(354);
	var hof_1 = __webpack_require__(355);
	var coreservices_1 = __webpack_require__(356);
	exports.root = (typeof self === 'object' && self.self === self && self) ||
	    (typeof global === 'object' && global.global === global && global) ||
	    this;
	var angular = exports.root.angular || {};
	exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
	exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
	exports.forEach = angular.forEach || _forEach;
	exports.extend = Object.assign || _extend;
	exports.equals = angular.equals || _equals;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	function noop() { }
	exports.noop = noop;
	/**
	 * Builds proxy functions on the `to` object which pass through to the `from` object.
	 *
	 * For each key in `fnNames`, creates a proxy function on the `to` object.
	 * The proxy function calls the real function on the `from` object.
	 *
	 *
	 * #### Example:
	 * This example creates an new class instance whose functions are prebound to the new'd object.
	 * ```js
	 * class Foo {
	 *   constructor(data) {
	 *     // Binds all functions from Foo.prototype to 'this',
	 *     // then copies them to 'this'
	 *     bindFunctions(Foo.prototype, this, this);
	 *     this.data = data;
	 *   }
	 *
	 *   log() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * let myFoo = new Foo([1,2,3]);
	 * var logit = myFoo.log;
	 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
	 * ```
	 *
	 * #### Example:
	 * This example creates a bound version of a service function, and copies it to another object
	 * ```
	 *
	 * var SomeService = {
	 *   this.data = [3, 4, 5];
	 *   this.log = function() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * // Constructor fn
	 * function OtherThing() {
	 *   // Binds all functions from SomeService to SomeService,
	 *   // then copies them to 'this'
	 *   bindFunctions(SomeService, this, SomeService);
	 * }
	 *
	 * let myOtherThing = new OtherThing();
	 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
	 * ```
	 *
	 * @param source A function that returns the source object which contains the original functions to be bound
	 * @param target A function that returns the target object which will receive the bound functions
	 * @param bind A function that returns the object which the functions will be bound to
	 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
	 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
	 */
	function createProxyFunctions(source, target, bind, fnNames, latebind) {
	    if (latebind === void 0) { latebind = false; }
	    var bindFunction = function (fnName) { return source()[fnName].bind(bind()); };
	    var makeLateRebindFn = function (fnName) {
	        return function lateRebindFunction() {
	            target[fnName] = bindFunction(fnName);
	            return target[fnName].apply(null, arguments);
	        };
	    };
	    fnNames = fnNames || Object.keys(source());
	    return fnNames.reduce(function (acc, name) {
	        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
	        return acc;
	    }, target);
	}
	exports.createProxyFunctions = createProxyFunctions;
	/**
	 * prototypal inheritance helper.
	 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
	 */
	exports.inherit = function (parent, extra) { return exports.extend(Object.create(parent), extra); };
	/** Given an array, returns true if the object is found in the array, (using indexOf) */
	exports.inArray = hof_1.curry(_inArray);
	function _inArray(array, obj) {
	    return array.indexOf(obj) !== -1;
	}
	exports._inArray = _inArray;
	/**
	 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
	 * The same array is returned
	 */
	exports.removeFrom = hof_1.curry(_removeFrom);
	function _removeFrom(array, obj) {
	    var idx = array.indexOf(obj);
	    if (idx >= 0)
	        array.splice(idx, 1);
	    return array;
	}
	exports._removeFrom = _removeFrom;
	/** pushes a values to an array and returns the value */
	exports.pushTo = hof_1.curry(_pushTo);
	function _pushTo(arr, val) {
	    return arr.push(val), val;
	}
	exports._pushTo = _pushTo;
	/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
	exports.deregAll = function (functions) {
	    return functions.slice().forEach(function (fn) {
	        typeof fn === 'function' && fn();
	        exports.removeFrom(functions, fn);
	    });
	};
	/**
	 * Applies a set of defaults to an options object.  The options object is filtered
	 * to only those properties of the objects in the defaultsList.
	 * Earlier objects in the defaultsList take precedence when applying defaults.
	 */
	function defaults(opts) {
	    var defaultsList = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        defaultsList[_i - 1] = arguments[_i];
	    }
	    var defaultVals = exports.extend.apply(void 0, __spreadArrays([{}], defaultsList.reverse()));
	    return exports.extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
	}
	exports.defaults = defaults;
	/** Reduce function that merges each element of the list into a single object, using extend */
	exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	    var path = [];
	    // tslint:disable-next-line:forin
	    for (var n in first.path) {
	        if (first.path[n] !== second.path[n])
	            break;
	        path.push(first.path[n]);
	    }
	    return path;
	}
	exports.ancestors = ancestors;
	/**
	 * Return a copy of the object only containing the whitelisted properties.
	 *
	 * #### Example:
	 * ```
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the whitelisted property names
	 */
	function pick(obj, propNames) {
	    var objCopy = {};
	    for (var _prop in obj) {
	        if (propNames.indexOf(_prop) !== -1) {
	            objCopy[_prop] = obj[_prop];
	        }
	    }
	    return objCopy;
	}
	exports.pick = pick;
	/**
	 * Return a copy of the object omitting the blacklisted properties.
	 *
	 * @example
	 * ```
	 *
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the blacklisted property names
	 */
	function omit(obj, propNames) {
	    return Object.keys(obj)
	        .filter(hof_1.not(exports.inArray(propNames)))
	        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
	}
	exports.omit = omit;
	/**
	 * Maps an array, or object to a property (by name)
	 */
	function pluck(collection, propName) {
	    return map(collection, hof_1.prop(propName));
	}
	exports.pluck = pluck;
	/** Filters an Array or an Object's properties based on a predicate */
	function filter(collection, callback) {
	    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
	    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return (result[key] = x); };
	    exports.forEach(collection, function (item, i) {
	        if (callback(item, i))
	            accept(item, i);
	    });
	    return result;
	}
	exports.filter = filter;
	/** Finds an object from an array, or a property of an object, that matches a predicate */
	function find(collection, callback) {
	    var result;
	    exports.forEach(collection, function (item, i) {
	        if (result)
	            return;
	        if (callback(item, i))
	            result = item;
	    });
	    return result;
	}
	exports.find = find;
	/** Given an object, returns a new object, where each property is transformed by the callback function */
	exports.mapObj = map;
	/** Maps an array or object properties using a callback function */
	function map(collection, callback, target) {
	    target = target || (predicates_1.isArray(collection) ? [] : {});
	    exports.forEach(collection, function (item, i) { return (target[i] = callback(item, i)); });
	    return target;
	}
	exports.map = map;
	/**
	 * Given an object, return its enumerable property values
	 *
	 * @example
	 * ```
	 *
	 * let foo = { a: 1, b: 2, c: 3 }
	 * let vals = values(foo); // [ 1, 2, 3 ]
	 * ```
	 */
	exports.values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
	/**
	 * Reduce function that returns true if all of the values are truthy.
	 *
	 * @example
	 * ```
	 *
	 * let vals = [ 1, true, {}, "hello world"];
	 * vals.reduce(allTrueR, true); // true
	 *
	 * vals.push(0);
	 * vals.reduce(allTrueR, true); // false
	 * ```
	 */
	exports.allTrueR = function (memo, elem) { return memo && elem; };
	/**
	 * Reduce function that returns true if any of the values are truthy.
	 *
	 *  * @example
	 * ```
	 *
	 * let vals = [ 0, null, undefined ];
	 * vals.reduce(anyTrueR, true); // false
	 *
	 * vals.push("hello world");
	 * vals.reduce(anyTrueR, true); // true
	 * ```
	 */
	exports.anyTrueR = function (memo, elem) { return memo || elem; };
	/**
	 * Reduce function which un-nests a single level of arrays
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnestR = function (memo, elem) { return memo.concat(elem); };
	/**
	 * Reduce function which recursively un-nests all arrays
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flattenR = function (memo, elem) {
	    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
	};
	/**
	 * Reduce function that pushes an object to an array, then returns the array.
	 * Mostly just for [[flattenR]] and [[uniqR]]
	 */
	function pushR(arr, obj) {
	    arr.push(obj);
	    return arr;
	}
	exports.pushR = pushR;
	/** Reduce function that filters out duplicates */
	exports.uniqR = function (acc, token) { return (exports.inArray(acc, token) ? acc : pushR(acc, token)); };
	/**
	 * Return a new array with a single level of arrays unnested.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
	/**
	 * Return a completely flattened version of an array.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
	/**
	 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
	 * @example
	 * ```
	 *
	 * let isNumber = (obj) => typeof(obj) === 'number';
	 * let allNumbers = [ 1, 2, 3, 4, 5 ];
	 * allNumbers.filter(assertPredicate(isNumber)); //OK
	 *
	 * let oneString = [ 1, 2, 3, 4, "5" ];
	 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
	 * ```
	 */
	exports.assertPredicate = assertFn;
	/**
	 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
	 * @example
	 * ```
	 *
	 * var data = { foo: 1, bar: 2 };
	 *
	 * let keys = [ 'foo', 'bar' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // values is [1, 2]
	 *
	 * let keys = [ 'foo', 'bar', 'baz' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // throws Error("Key not found")
	 * ```
	 */
	exports.assertMap = assertFn;
	function assertFn(predicateOrMap, errMsg) {
	    if (errMsg === void 0) { errMsg = 'assert failure'; }
	    return function (obj) {
	        var result = predicateOrMap(obj);
	        if (!result) {
	            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
	        }
	        return result;
	    };
	}
	exports.assertFn = assertFn;
	/**
	 * Like _.pairs: Given an object, returns an array of key/value pairs
	 *
	 * @example
	 * ```
	 *
	 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
	 * ```
	 */
	exports.pairs = function (obj) { return Object.keys(obj).map(function (key) { return [key, obj[key]]; }); };
	/**
	 * Given two or more parallel arrays, returns an array of tuples where
	 * each tuple is composed of [ a[i], b[i], ... z[i] ]
	 *
	 * @example
	 * ```
	 *
	 * let foo = [ 0, 2, 4, 6 ];
	 * let bar = [ 1, 3, 5, 7 ];
	 * let baz = [ 10, 30, 50, 70 ];
	 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
	 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
	 * ```
	 */
	function arrayTuples() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    if (args.length === 0)
	        return [];
	    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
	    var result = [];
	    var _loop_1 = function (i) {
	        // This is a hot function
	        // Unroll when there are 1-4 arguments
	        switch (args.length) {
	            case 1:
	                result.push([args[0][i]]);
	                break;
	            case 2:
	                result.push([args[0][i], args[1][i]]);
	                break;
	            case 3:
	                result.push([args[0][i], args[1][i], args[2][i]]);
	                break;
	            case 4:
	                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
	                break;
	            default:
	                result.push(args.map(function (array) { return array[i]; }));
	                break;
	        }
	    };
	    for (var i = 0; i < maxArrayLen; i++) {
	        _loop_1(i);
	    }
	    return result;
	}
	exports.arrayTuples = arrayTuples;
	/**
	 * Reduce function which builds an object from an array of [key, value] pairs.
	 *
	 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
	 *
	 * Each keyValueTuple should be an array with values [ key: string, value: any ]
	 *
	 * @example
	 * ```
	 *
	 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
	 *
	 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 *
	 * // Or, more simply:
	 * var pairsToObj = pairs.reduce(applyPairs, {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 * ```
	 */
	function applyPairs(memo, keyValTuple) {
	    var key, value;
	    if (predicates_1.isArray(keyValTuple))
	        key = keyValTuple[0], value = keyValTuple[1];
	    if (!predicates_1.isString(key))
	        throw new Error('invalid parameters to applyPairs');
	    memo[key] = value;
	    return memo;
	}
	exports.applyPairs = applyPairs;
	/** Get the last element of an array */
	function tail(arr) {
	    return (arr.length && arr[arr.length - 1]) || undefined;
	}
	exports.tail = tail;
	/**
	 * shallow copy from src to dest
	 */
	function copy(src, dest) {
	    if (dest)
	        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
	    if (!dest)
	        dest = {};
	    return exports.extend(dest, src);
	}
	exports.copy = copy;
	/** Naive forEach implementation works with Objects or Arrays */
	function _forEach(obj, cb, _this) {
	    if (predicates_1.isArray(obj))
	        return obj.forEach(cb, _this);
	    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
	}
	function _extend(toObj) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = arguments[i];
	        if (!obj)
	            continue;
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; j++) {
	            toObj[keys[j]] = obj[keys[j]];
	        }
	    }
	    return toObj;
	}
	exports._extend = _extend;
	function _equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2;
	    if (t1 !== t2 || t1 !== 'object')
	        return false;
	    var tup = [o1, o2];
	    if (hof_1.all(predicates_1.isArray)(tup))
	        return _arraysEq(o1, o2);
	    if (hof_1.all(predicates_1.isDate)(tup))
	        return o1.getTime() === o2.getTime();
	    if (hof_1.all(predicates_1.isRegExp)(tup))
	        return o1.toString() === o2.toString();
	    if (hof_1.all(predicates_1.isFunction)(tup))
	        return true; // meh
	    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
	    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
	        return false;
	    var keys = {};
	    // tslint:disable-next-line:forin
	    for (var key in o1) {
	        if (!_equals(o1[key], o2[key]))
	            return false;
	        keys[key] = true;
	    }
	    for (var key in o2) {
	        if (!keys[key])
	            return false;
	    }
	    return true;
	}
	function _arraysEq(a1, a2) {
	    if (a1.length !== a2.length)
	        return false;
	    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
	}
	// issue #2676
	exports.silenceUncaughtInPromise = function (promise) { return promise.catch(function (e) { return 0; }) && promise; };
	exports.silentRejection = function (error) { return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error)); };
	//# sourceMappingURL=common.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isPromise = exports.isInjectable = exports.isRegExp = exports.isDate = exports.isArray = exports.isObject = exports.isString = exports.isNumber = exports.isFunction = exports.isNullOrUndefined = exports.isNull = exports.isDefined = exports.isUndefined = void 0;
	/**
	 * Predicates
	 *
	 * These predicates return true/false based on the input.
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(355);
	var toStr = Object.prototype.toString;
	var tis = function (t) { return function (x) { return typeof x === t; }; };
	exports.isUndefined = tis('undefined');
	exports.isDefined = hof_1.not(exports.isUndefined);
	exports.isNull = function (o) { return o === null; };
	exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
	exports.isFunction = tis('function');
	exports.isNumber = tis('number');
	exports.isString = tis('string');
	exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
	exports.isArray = Array.isArray;
	exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
	exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
	/**
	 * Predicate which checks if a value is injectable
	 *
	 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
	 * where all the elements in the array are Strings, except the last one, which is a Function
	 */
	function isInjectable(val) {
	    if (exports.isArray(val) && val.length) {
	        var head = val.slice(0, -1), tail = val.slice(-1);
	        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
	    }
	    return exports.isFunction(val);
	}
	exports.isInjectable = isInjectable;
	/**
	 * Predicate which checks if a value looks like a Promise
	 *
	 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
	 */
	exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
	//# sourceMappingURL=predicates.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Higher order functions
	 *
	 * These utility functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pattern = exports.invoke = exports.val = exports.eq = exports.is = exports.any = exports.all = exports.or = exports.and = exports.not = exports.parse = exports.propEq = exports.prop = exports.pipe = exports.compose = exports.curry = void 0;
	/**
	 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
	 *
	 * Given a function with N parameters, returns a new function that supports partial application.
	 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
	 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
	 * accept more parameters until all N parameters have been supplied.
	 *
	 *
	 * This contrived example uses a partially applied function as an predicate, which returns true
	 * if an object is found in both arrays.
	 * @example
	 * ```
	 * // returns true if an object is in both of the two arrays
	 * function inBoth(array1, array2, object) {
	 *   return array1.indexOf(object) !== -1 &&
	 *          array2.indexOf(object) !== 1;
	 * }
	 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
	 * let foos = [obj1, obj3]
	 * let bars = [obj3, obj4, obj5]
	 *
	 * // A curried "copy" of inBoth
	 * let curriedInBoth = curry(inBoth);
	 * // Partially apply both the array1 and array2
	 * let inFoosAndBars = curriedInBoth(foos, bars);
	 *
	 * // Supply the final argument; since all arguments are
	 * // supplied, the original inBoth function is then called.
	 * let obj1InBoth = inFoosAndBars(obj1); // false
	 *
	 * // Use the inFoosAndBars as a predicate.
	 * // Filter, on each iteration, supplies the final argument
	 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
	 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
	 *
	 * ```
	 *
	 * @param fn
	 * @returns {*|function(): (*|any)}
	 */
	function curry(fn) {
	    return function curried() {
	        if (arguments.length >= fn.length) {
	            return fn.apply(this, arguments);
	        }
	        var args = Array.prototype.slice.call(arguments);
	        return curried.bind.apply(curried, __spreadArrays([this], args));
	    };
	}
	exports.curry = curry;
	/**
	 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
	 * given: f(x), g(x), h(x)
	 * let composed = compose(f,g,h)
	 * then, composed is: f(g(h(x)))
	 */
	function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start, result = args[start].apply(this, arguments);
	        while (i--)
	            result = args[i].call(this, result);
	        return result;
	    };
	}
	exports.compose = compose;
	/**
	 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
	 * given: f(x), g(x), h(x)
	 * let piped = pipe(f,g,h);
	 * then, piped is: h(g(f(x)))
	 */
	function pipe() {
	    var funcs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        funcs[_i] = arguments[_i];
	    }
	    return compose.apply(null, [].slice.call(arguments).reverse());
	}
	exports.pipe = pipe;
	/**
	 * Given a property name, returns a function that returns that property from an object
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = prop("name");
	 * getName(obj) === "blarg"
	 */
	exports.prop = function (name) { return function (obj) { return obj && obj[name]; }; };
	/**
	 * Given a property name and a value, returns a function that returns a boolean based on whether
	 * the passed object has a property that matches the value
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = propEq("name", "blarg");
	 * getName(obj) === true
	 */
	exports.propEq = curry(function (name, _val, obj) { return obj && obj[name] === _val; });
	/**
	 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
	 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
	 * let getName = prop("nestedObj.name");
	 * getName(obj) === "blarg"
	 * let propNotFound = prop("this.property.doesnt.exist");
	 * propNotFound(obj) === undefined
	 */
	exports.parse = function (name) { return pipe.apply(null, name.split('.').map(exports.prop)); };
	/**
	 * Given a function that returns a truthy or falsey value, returns a
	 * function that returns the opposite (falsey or truthy) value given the same inputs
	 */
	exports.not = function (fn) { return function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return !fn.apply(null, args);
	}; };
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if both functions return truthy for the given arguments
	 */
	function and(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) && fn2.apply(null, args);
	    };
	}
	exports.and = and;
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if at least one of the functions returns truthy for the given arguments
	 */
	function or(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) || fn2.apply(null, args);
	    };
	}
	exports.or = or;
	/**
	 * Check if all the elements of an array match a predicate function
	 *
	 * @param fn1 a predicate function `fn1`
	 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
	 */
	exports.all = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); }; };
	// tslint:disable-next-line:variable-name
	exports.any = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); }; };
	/** Given a class, returns a Predicate function that returns true if the object is of that class */
	exports.is = function (ctor) { return function (obj) {
	    return (obj != null && obj.constructor === ctor) || obj instanceof ctor;
	}; };
	/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
	exports.eq = function (value) { return function (other) { return value === other; }; };
	/** Given a value, returns a function which returns the value */
	exports.val = function (v) { return function () { return v; }; };
	function invoke(fnName, args) {
	    return function (obj) { return obj[fnName].apply(obj, args); };
	}
	exports.invoke = invoke;
	/**
	 * Sorta like Pattern Matching (a functional programming conditional construct)
	 *
	 * See http://c2.com/cgi/wiki?PatternMatching
	 *
	 * This is a conditional construct which allows a series of predicates and output functions
	 * to be checked and then applied.  Each predicate receives the input.  If the predicate
	 * returns truthy, then its matching output function (mapping function) is provided with
	 * the input and, then the result is returned.
	 *
	 * Each combination (2-tuple) of predicate + output function should be placed in an array
	 * of size 2: [ predicate, mapFn ]
	 *
	 * These 2-tuples should be put in an outer array.
	 *
	 * @example
	 * ```
	 *
	 * // Here's a 2-tuple where the first element is the isString predicate
	 * // and the second element is a function that returns a description of the input
	 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
	 *
	 * // Second tuple: predicate "isNumber", mapfn returns a description
	 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
	 *
	 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
	 *
	 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
	 *
	 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
	 *
	 * console.log(descriptionOf(undefined)); // 'notdefined'
	 * console.log(descriptionOf(55)); // '(55) That's a number!'
	 * console.log(descriptionOf("foo")); // 'Here's your string foo'
	 * ```
	 *
	 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
	 * with a Predicate and a mapping/output function
	 * @returns {function(any): *}
	 */
	function pattern(struct) {
	    return function (x) {
	        for (var i = 0; i < struct.length; i++) {
	            if (struct[i][0](x))
	                return struct[i][1](x);
	        }
	    };
	}
	exports.pattern = pattern;
	//# sourceMappingURL=hof.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.services = exports.makeStub = void 0;
	var noImpl = function (fnname) { return function () {
	    throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
	}; };
	exports.makeStub = function (service, methods) {
	    return methods.reduce(function (acc, key) { return ((acc[key] = noImpl(service + "." + key + "()")), acc); }, {});
	};
	var services = {
	    $q: undefined,
	    $injector: undefined,
	};
	exports.services = services;
	//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Glob = void 0;
	/**
	 * Matches state names using glob-like pattern strings.
	 *
	 * Globs can be used in specific APIs including:
	 *
	 * - [[StateService.is]]
	 * - [[StateService.includes]]
	 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
	 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
	 *
	 * A `Glob` string is a pattern which matches state names.
	 * Nested state names are split into segments (separated by a dot) when processing.
	 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
	 *
	 * Globs work according to the following rules:
	 *
	 * ### Exact match:
	 *
	 * The glob `'A.B'` matches the state named exactly `'A.B'`.
	 *
	 * | Glob        |Matches states named|Does not match state named|
	 * |:------------|:--------------------|:---------------------|
	 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
	 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
	 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
	 *
	 * ### Single star (`*`)
	 *
	 * A single star (`*`) is a wildcard that matches exactly one segment.
	 *
	 * | Glob        |Matches states named  |Does not match state named |
	 * |:------------|:---------------------|:--------------------------|
	 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
	 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
	 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
	 *
	 * ### Double star (`**`)
	 *
	 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
	 *
	 * | Glob        |Matches states named                           |Does not match state named         |
	 * |:------------|:----------------------------------------------|:----------------------------------|
	 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
	 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
	 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
	 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
	 *
	 * @packageDocumentation
	 */
	var Glob = /** @class */ (function () {
	    function Glob(text) {
	        this.text = text;
	        this.glob = text.split('.');
	        var regexpString = this.text
	            .split('.')
	            .map(function (seg) {
	            if (seg === '**')
	                return '(?:|(?:\\.[^.]*)*)';
	            if (seg === '*')
	                return '\\.[^.]*';
	            return '\\.' + seg;
	        })
	            .join('');
	        this.regexp = new RegExp('^' + regexpString + '$');
	    }
	    /** Returns true if the string has glob-like characters in it */
	    Glob.is = function (text) {
	        return !!/[!,*]+/.exec(text);
	    };
	    /** Returns a glob from the string, or null if the string isn't Glob-like */
	    Glob.fromString = function (text) {
	        return Glob.is(text) ? new Glob(text) : null;
	    };
	    Glob.prototype.matches = function (name) {
	        return this.regexp.test('.' + name);
	    };
	    return Glob;
	}());
	exports.Glob = Glob;
	//# sourceMappingURL=glob.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Queue = void 0;
	var common_1 = __webpack_require__(353);
	var Queue = /** @class */ (function () {
	    function Queue(_items, _limit) {
	        if (_items === void 0) { _items = []; }
	        if (_limit === void 0) { _limit = null; }
	        this._items = _items;
	        this._limit = _limit;
	        this._evictListeners = [];
	        this.onEvict = common_1.pushTo(this._evictListeners);
	    }
	    Queue.prototype.enqueue = function (item) {
	        var items = this._items;
	        items.push(item);
	        if (this._limit && items.length > this._limit)
	            this.evict();
	        return item;
	    };
	    Queue.prototype.evict = function () {
	        var item = this._items.shift();
	        this._evictListeners.forEach(function (fn) { return fn(item); });
	        return item;
	    };
	    Queue.prototype.dequeue = function () {
	        if (this.size())
	            return this._items.splice(0, 1)[0];
	    };
	    Queue.prototype.clear = function () {
	        var current = this._items;
	        this._items = [];
	        return current;
	    };
	    Queue.prototype.size = function () {
	        return this._items.length;
	    };
	    Queue.prototype.remove = function (item) {
	        var idx = this._items.indexOf(item);
	        return idx > -1 && this._items.splice(idx, 1)[0];
	    };
	    Queue.prototype.peekTail = function () {
	        return this._items[this._items.length - 1];
	    };
	    Queue.prototype.peekHead = function () {
	        if (this.size())
	            return this._items[0];
	    };
	    return Queue;
	}());
	exports.Queue = Queue;
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Functions that manipulate strings
	 *
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.joinNeighborsR = exports.splitOnDelim = exports.trimHashVal = exports.splitEqual = exports.splitQuery = exports.splitHash = exports.stripLastPathElement = exports.hostRegex = exports.beforeAfterSubstr = exports.stringify = exports.fnToString = exports.functionToString = exports.kebobString = exports.padString = exports.maxLength = void 0;
	var predicates_1 = __webpack_require__(354);
	var rejectFactory_1 = __webpack_require__(360);
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	/**
	 * Returns a string shortened to a maximum length
	 *
	 * If the string is already less than the `max` length, return the string.
	 * Else return the string, shortened to `max - 3` and append three dots ("...").
	 *
	 * @param max the maximum length of the string to return
	 * @param str the input string
	 */
	function maxLength(max, str) {
	    if (str.length <= max)
	        return str;
	    return str.substr(0, max - 3) + '...';
	}
	exports.maxLength = maxLength;
	/**
	 * Returns a string, with spaces added to the end, up to a desired str length
	 *
	 * If the string is already longer than the desired length, return the string.
	 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
	 *
	 * @param length the desired length of the string to return
	 * @param str the input string
	 */
	function padString(length, str) {
	    while (str.length < length)
	        str += ' ';
	    return str;
	}
	exports.padString = padString;
	function kebobString(camelCase) {
	    return camelCase
	        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
	        .replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); }); // replace rest
	}
	exports.kebobString = kebobString;
	function functionToString(fn) {
	    var fnStr = fnToString(fn);
	    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
	    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
	    var fnName = fn['name'] || '';
	    if (fnName && toStr.match(/function \(/)) {
	        return 'function ' + fnName + toStr.substr(9);
	    }
	    return toStr;
	}
	exports.functionToString = functionToString;
	function fnToString(fn) {
	    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
	    return (_fn && _fn.toString()) || 'undefined';
	}
	exports.fnToString = fnToString;
	var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
	var hasToString = function (obj) {
	    return predicates_1.isObject(obj) && !predicates_1.isArray(obj) && obj.constructor !== Object && predicates_1.isFunction(obj.toString);
	};
	var stringifyPattern = hof_1.pattern([
	    [predicates_1.isUndefined, hof_1.val('undefined')],
	    [predicates_1.isNull, hof_1.val('null')],
	    [predicates_1.isPromise, hof_1.val('[Promise]')],
	    [isRejection, function (x) { return x._transitionRejection.toString(); }],
	    [hasToString, function (x) { return x.toString(); }],
	    [predicates_1.isInjectable, functionToString],
	    [hof_1.val(true), common_1.identity],
	]);
	function stringify(o) {
	    var seen = [];
	    function format(value) {
	        if (predicates_1.isObject(value)) {
	            if (seen.indexOf(value) !== -1)
	                return '[circular ref]';
	            seen.push(value);
	        }
	        return stringifyPattern(value);
	    }
	    if (predicates_1.isUndefined(o)) {
	        // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
	        // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
	        // manually stringifying it.
	        return format(o);
	    }
	    return JSON.stringify(o, function (key, value) { return format(value); }).replace(/\\"/g, '"');
	}
	exports.stringify = stringify;
	/** Returns a function that splits a string on a character or substring */
	exports.beforeAfterSubstr = function (char) { return function (str) {
	    if (!str)
	        return ['', ''];
	    var idx = str.indexOf(char);
	    if (idx === -1)
	        return [str, ''];
	    return [str.substr(0, idx), str.substr(idx + 1)];
	}; };
	exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
	exports.stripLastPathElement = function (str) { return str.replace(/\/[^/]*$/, ''); };
	exports.splitHash = exports.beforeAfterSubstr('#');
	exports.splitQuery = exports.beforeAfterSubstr('?');
	exports.splitEqual = exports.beforeAfterSubstr('=');
	exports.trimHashVal = function (str) { return (str ? str.replace(/^#/, '') : ''); };
	/**
	 * Splits on a delimiter, but returns the delimiters in the array
	 *
	 * #### Example:
	 * ```js
	 * var splitOnSlashes = splitOnDelim('/');
	 * splitOnSlashes("/foo"); // ["/", "foo"]
	 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
	 * ```
	 */
	function splitOnDelim(delim) {
	    var re = new RegExp('(' + delim + ')', 'g');
	    return function (str) { return str.split(re).filter(common_1.identity); };
	}
	exports.splitOnDelim = splitOnDelim;
	/**
	 * Reduce fn that joins neighboring strings
	 *
	 * Given an array of strings, returns a new array
	 * where all neighboring strings have been joined.
	 *
	 * #### Example:
	 * ```js
	 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
	 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
	 * ```
	 */
	function joinNeighborsR(acc, x) {
	    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
	        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
	    return common_1.pushR(acc, x);
	}
	exports.joinNeighborsR = joinNeighborsR;
	//# sourceMappingURL=strings.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Rejection = exports.RejectType = void 0;
	var common_1 = __webpack_require__(353);
	var strings_1 = __webpack_require__(359);
	var hof_1 = __webpack_require__(355);
	/** An enum for Transition Rejection reasons */
	var RejectType;
	(function (RejectType) {
	    /**
	     * A new transition superseded this one.
	     *
	     * While this transition was running, a new transition started.
	     * This transition is cancelled because it was superseded by new transition.
	     */
	    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
	    /**
	     * The transition was aborted
	     *
	     * The transition was aborted by a hook which returned `false`
	     */
	    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
	    /**
	     * The transition was invalid
	     *
	     * The transition was never started because it was invalid
	     */
	    RejectType[RejectType["INVALID"] = 4] = "INVALID";
	    /**
	     * The transition was ignored
	     *
	     * The transition was ignored because it would have no effect.
	     *
	     * Either:
	     *
	     * - The transition is targeting the current state and parameter values
	     * - The transition is targeting the same state and parameter values as the currently running transition.
	     */
	    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
	    /**
	     * The transition errored.
	     *
	     * This generally means a hook threw an error or returned a rejected promise
	     */
	    RejectType[RejectType["ERROR"] = 6] = "ERROR";
	})(RejectType || (RejectType = {}));
	exports.RejectType = RejectType;
	/** @internal */
	var id = 0;
	var Rejection = /** @class */ (function () {
	    function Rejection(type, message, detail) {
	        /** @internal */
	        this.$id = id++;
	        this.type = type;
	        this.message = message;
	        this.detail = detail;
	    }
	    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
	    Rejection.isRejectionPromise = function (obj) {
	        return obj && typeof obj.then === 'function' && hof_1.is(Rejection)(obj._transitionRejection);
	    };
	    /** Returns a Rejection due to transition superseded */
	    Rejection.superseded = function (detail, options) {
	        var message = 'The transition has been superseded by a different transition';
	        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
	        if (options && options.redirected) {
	            rejection.redirected = true;
	        }
	        return rejection;
	    };
	    /** Returns a Rejection due to redirected transition */
	    Rejection.redirected = function (detail) {
	        return Rejection.superseded(detail, { redirected: true });
	    };
	    /** Returns a Rejection due to invalid transition */
	    Rejection.invalid = function (detail) {
	        var message = 'This transition is invalid';
	        return new Rejection(RejectType.INVALID, message, detail);
	    };
	    /** Returns a Rejection due to ignored transition */
	    Rejection.ignored = function (detail) {
	        var message = 'The transition was ignored';
	        return new Rejection(RejectType.IGNORED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.aborted = function (detail) {
	        var message = 'The transition has been aborted';
	        return new Rejection(RejectType.ABORTED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.errored = function (detail) {
	        var message = 'The transition errored';
	        return new Rejection(RejectType.ERROR, message, detail);
	    };
	    /**
	     * Returns a Rejection
	     *
	     * Normalizes a value as a Rejection.
	     * If the value is already a Rejection, returns it.
	     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
	     *
	     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
	     */
	    Rejection.normalize = function (detail) {
	        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
	    };
	    Rejection.prototype.toString = function () {
	        var detailString = function (d) { return (d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d)); };
	        var detail = detailString(this.detail);
	        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
	        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
	    };
	    Rejection.prototype.toPromise = function () {
	        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
	    };
	    return Rejection;
	}());
	exports.Rejection = Rejection;
	//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.trace = exports.Trace = exports.Category = void 0;
	/**
	 * # Transition tracing (debug)
	 *
	 * Enable transition tracing to print transition information to the console,
	 * in order to help debug your application.
	 * Tracing logs detailed information about each Transition to your console.
	 *
	 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
	 *
	 * ### ES6
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
	 * ```
	 *
	 * ### CJS
	 * ```js
	 * let trace = require("@uirouter/core").trace;
	 * trace.enable("TRANSITION", "VIEWCONFIG");
	 * ```
	 *
	 * ### Globals
	 * ```js
	 * let trace = window["@uirouter/core"].trace;
	 * trace.enable(); // Trace everything (very verbose)
	 * ```
	 *
	 * ### Angular 1:
	 * ```js
	 * app.run($trace => $trace.enable());
	 * ```
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(355);
	var predicates_1 = __webpack_require__(354);
	var strings_1 = __webpack_require__(359);
	var safeConsole_1 = __webpack_require__(362);
	function uiViewString(uiview) {
	    if (!uiview)
	        return 'ui-view (defunct)';
	    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
	    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
	}
	var viewConfigString = function (viewConfig) {
	    var view = viewConfig.viewDecl;
	    var state = view.$context.name || '(root)';
	    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
	};
	function normalizedCat(input) {
	    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
	}
	/**
	 * Trace categories Enum
	 *
	 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
	 *
	 * `trace.enable(Category.TRANSITION)`
	 *
	 * These can also be provided using a matching string, or position ordinal
	 *
	 * `trace.enable("TRANSITION")`
	 *
	 * `trace.enable(1)`
	 */
	var Category;
	(function (Category) {
	    Category[Category["RESOLVE"] = 0] = "RESOLVE";
	    Category[Category["TRANSITION"] = 1] = "TRANSITION";
	    Category[Category["HOOK"] = 2] = "HOOK";
	    Category[Category["UIVIEW"] = 3] = "UIVIEW";
	    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
	})(Category || (Category = {}));
	exports.Category = Category;
	var _tid = hof_1.parse('$id');
	var _rid = hof_1.parse('router.$id');
	var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
	/**
	 * Prints UI-Router Transition trace information to the console.
	 */
	var Trace = /** @class */ (function () {
	    /** @internal */
	    function Trace() {
	        /** @internal */
	        this._enabled = {};
	        this.approximateDigests = 0;
	    }
	    /** @internal */
	    Trace.prototype._set = function (enabled, categories) {
	        var _this = this;
	        if (!categories.length) {
	            categories = Object.keys(Category)
	                .map(function (k) { return parseInt(k, 10); })
	                .filter(function (k) { return !isNaN(k); })
	                .map(function (key) { return Category[key]; });
	        }
	        categories.map(normalizedCat).forEach(function (category) { return (_this._enabled[category] = enabled); });
	    };
	    Trace.prototype.enable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(true, categories);
	    };
	    Trace.prototype.disable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(false, categories);
	    };
	    /**
	     * Retrieves the enabled stateus of a [[Category]]
	     *
	     * ```js
	     * trace.enabled("VIEWCONFIG"); // true or false
	     * ```
	     *
	     * @returns boolean true if the category is enabled
	     */
	    Trace.prototype.enabled = function (category) {
	        return !!this._enabled[normalizedCat(category)];
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionStart = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionIgnored = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookInvocation = function (step, trans, options) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.functionToString(step.registeredHook.callback);
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvePath = function (path, when, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceError = function (reason, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceSuccess = function (finalState, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
	        if (extra === void 0) { extra = ''; }
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        safeConsole_1.safeConsole.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewFill = function (viewData, html) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Fill', viewData, " with: " + strings_1.maxLength(200, html));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewSync = function (pairs) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        var uivheader = 'uiview component fqn';
	        var cfgheader = 'view config state (view name)';
	        var mapping = pairs
	            .map(function (_a) {
	            var _b;
	            var uiView = _a.uiView, viewConfig = _a.viewConfig;
	            var uiv = uiView && uiView.fqn;
	            var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
	            return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
	        })
	            .sort(function (a, b) { return (a[uivheader] || '').localeCompare(b[uivheader] || ''); });
	        safeConsole_1.safeConsole.table(mapping);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
	    };
	    return Trace;
	}());
	exports.Trace = Trace;
	/**
	 * The [[Trace]] singleton
	 *
	 * #### Example:
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5);
	 * ```
	 */
	var trace = new Trace();
	exports.trace = trace;
	//# sourceMappingURL=trace.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeConsole = void 0;
	/**
	 * workaround for missing console object in IE9 when dev tools haven't been opened o_O
	 * @packageDocumentation
	 */
	/* tslint:disable:no-console */
	var common_1 = __webpack_require__(353);
	var noopConsoleStub = { log: common_1.noop, error: common_1.noop, table: common_1.noop };
	function ie9Console(console) {
	    var bound = function (fn) { return Function.prototype.bind.call(fn, console); };
	    return {
	        log: bound(console.log),
	        error: bound(console.log),
	        table: bound(console.log),
	    };
	}
	function fallbackConsole(console) {
	    var log = console.log.bind(console);
	    var error = console.error ? console.error.bind(console) : log;
	    var table = console.table ? console.table.bind(console) : log;
	    return { log: log, error: error, table: table };
	}
	function getSafeConsole() {
	    // @ts-ignore
	    var isIE9 = typeof document !== 'undefined' && document.documentMode && document.documentMode === 9;
	    if (isIE9) {
	        return window && window.console ? ie9Console(window.console) : noopConsoleStub;
	    }
	    else if (!console.table || !console.error) {
	        return fallbackConsole(console);
	    }
	    else {
	        return console;
	    }
	}
	exports.safeConsole = getSafeConsole();
	//# sourceMappingURL=safeConsole.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This module contains code for State Parameters.
	 *
	 * See [[ParamDeclaration]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(364), exports);
	__exportStar(__webpack_require__(365), exports);
	__exportStar(__webpack_require__(367), exports);
	__exportStar(__webpack_require__(368), exports);
	__exportStar(__webpack_require__(366), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Param = exports.DefType = void 0;
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var predicates_1 = __webpack_require__(354);
	var coreservices_1 = __webpack_require__(356);
	var paramType_1 = __webpack_require__(366);
	var hasOwn = Object.prototype.hasOwnProperty;
	var isShorthand = function (cfg) {
	    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
	};
	var DefType;
	(function (DefType) {
	    DefType[DefType["PATH"] = 0] = "PATH";
	    DefType[DefType["SEARCH"] = 1] = "SEARCH";
	    DefType[DefType["CONFIG"] = 2] = "CONFIG";
	})(DefType || (DefType = {}));
	exports.DefType = DefType;
	function getParamDeclaration(paramName, location, state) {
	    var noReloadOnSearch = (state.reloadOnSearch === false && location === DefType.SEARCH) || undefined;
	    var dynamic = common_1.find([state.dynamic, noReloadOnSearch], predicates_1.isDefined);
	    var defaultConfig = predicates_1.isDefined(dynamic) ? { dynamic: dynamic } : {};
	    var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
	    return common_1.extend(defaultConfig, paramConfig);
	}
	function unwrapShorthand(cfg) {
	    cfg = isShorthand(cfg) ? { value: cfg } : cfg;
	    getStaticDefaultValue['__cacheable'] = true;
	    function getStaticDefaultValue() {
	        return cfg.value;
	    }
	    var $$fn = predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
	    return common_1.extend(cfg, { $$fn: $$fn });
	}
	function getType(cfg, urlType, location, id, paramTypes) {
	    if (cfg.type && urlType && urlType.name !== 'string')
	        throw new Error("Param '" + id + "' has two type configurations.");
	    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
	        return paramTypes.type(cfg.type);
	    if (urlType)
	        return urlType;
	    if (!cfg.type) {
	        var type = location === DefType.CONFIG
	            ? 'any'
	            : location === DefType.PATH
	                ? 'path'
	                : location === DefType.SEARCH
	                    ? 'query'
	                    : 'string';
	        return paramTypes.type(type);
	    }
	    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
	}
	/** returns false, true, or the squash value to indicate the "default parameter url squash policy". */
	function getSquashPolicy(config, isOptional, defaultPolicy) {
	    var squash = config.squash;
	    if (!isOptional || squash === false)
	        return false;
	    if (!predicates_1.isDefined(squash) || squash == null)
	        return defaultPolicy;
	    if (squash === true || predicates_1.isString(squash))
	        return squash;
	    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	}
	function getReplace(config, arrayMode, isOptional, squash) {
	    var defaultPolicy = [
	        { from: '', to: isOptional || arrayMode ? undefined : '' },
	        { from: null, to: isOptional || arrayMode ? undefined : '' },
	    ];
	    var replace = predicates_1.isArray(config.replace) ? config.replace : [];
	    if (predicates_1.isString(squash))
	        replace.push({ from: squash, to: undefined });
	    var configuredKeys = common_1.map(replace, hof_1.prop('from'));
	    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
	}
	var Param = /** @class */ (function () {
	    function Param(id, type, location, urlConfig, state) {
	        var config = getParamDeclaration(id, location, state);
	        type = getType(config, type, location, id, urlConfig.paramTypes);
	        var arrayMode = getArrayMode();
	        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
	        var isOptional = config.value !== undefined || location === DefType.SEARCH;
	        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
	        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
	        var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
	        var replace = getReplace(config, arrayMode, isOptional, squash);
	        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
	        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	        function getArrayMode() {
	            var arrayDefaults = { array: location === DefType.SEARCH ? 'auto' : false };
	            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
	        }
	        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
	    }
	    Param.values = function (params, values) {
	        if (values === void 0) { values = {}; }
	        var paramValues = {};
	        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
	            var param = params_1[_i];
	            paramValues[param.id] = param.value(values[param.id]);
	        }
	        return paramValues;
	    };
	    /**
	     * Finds [[Param]] objects which have different param values
	     *
	     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
	     *
	     * @param params: The list of Param objects to filter
	     * @param values1: The first set of parameter values
	     * @param values2: the second set of parameter values
	     *
	     * @returns any Param objects whose values were different between values1 and values2
	     */
	    Param.changed = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
	    };
	    /**
	     * Checks if two param value objects are equal (for a set of [[Param]] objects)
	     *
	     * @param params The list of [[Param]] objects to check
	     * @param values1 The first set of param values
	     * @param values2 The second set of param values
	     *
	     * @returns true if the param values in values1 and values2 are equal
	     */
	    Param.equals = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return Param.changed(params, values1, values2).length === 0;
	    };
	    /** Returns true if a the parameter values are valid, according to the Param definitions */
	    Param.validates = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
	    };
	    Param.prototype.isDefaultValue = function (value) {
	        return this.isOptional && this.type.equals(this.value(), value);
	    };
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    Param.prototype.value = function (value) {
	        var _this = this;
	        /**
	         * [Internal] Get the default value of a parameter, which may be an injectable function.
	         */
	        var getDefaultValue = function () {
	            if (_this._defaultValueCache)
	                return _this._defaultValueCache.defaultValue;
	            if (!coreservices_1.services.$injector)
	                throw new Error('Injectable functions cannot be called at configuration time');
	            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
	            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
	                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
	            if (_this.config.$$fn['__cacheable']) {
	                _this._defaultValueCache = { defaultValue: defaultValue };
	            }
	            return defaultValue;
	        };
	        var replaceSpecialValues = function (val) {
	            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
	                var tuple = _a[_i];
	                if (tuple.from === val)
	                    return tuple.to;
	            }
	            return val;
	        };
	        value = replaceSpecialValues(value);
	        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
	    };
	    Param.prototype.isSearch = function () {
	        return this.location === DefType.SEARCH;
	    };
	    Param.prototype.validates = function (value) {
	        // There was no parameter value, but the param is optional
	        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
	            return true;
	        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
	        var normalized = this.type.$normalize(value);
	        if (!this.type.is(normalized))
	            return false;
	        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
	        var encoded = this.type.encode(normalized);
	        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
	    };
	    Param.prototype.toString = function () {
	        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
	    };
	    return Param;
	}());
	exports.Param = Param;
	//# sourceMappingURL=param.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamType = void 0;
	var common_1 = __webpack_require__(353);
	var predicates_1 = __webpack_require__(354);
	/**
	 * An internal class which implements [[ParamTypeDefinition]].
	 *
	 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
	 * When a param type definition is registered, an instance of this class is created internally.
	 *
	 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
	 *
	 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
	 *
	 * #### Example:
	 * ```js
	 * var paramTypeDef = {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 *
	 * var paramType = new ParamType(paramTypeDef);
	 * ```
	 */
	var ParamType = /** @class */ (function () {
	    /**
	     * @param def  A configuration object which contains the custom type definition.  The object's
	     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
	     * @returns a new ParamType object
	     */
	    function ParamType(def) {
	        /** @inheritdoc */
	        this.pattern = /.*/;
	        /** @inheritdoc */
	        this.inherit = true;
	        common_1.extend(this, def);
	    }
	    // consider these four methods to be "abstract methods" that should be overridden
	    /** @inheritdoc */
	    ParamType.prototype.is = function (val, key) {
	        return true;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.encode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.decode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.equals = function (a, b) {
	        // tslint:disable-next-line:triple-equals
	        return a == b;
	    };
	    ParamType.prototype.$subPattern = function () {
	        var sub = this.pattern.toString();
	        return sub.substr(1, sub.length - 2);
	    };
	    ParamType.prototype.toString = function () {
	        return "{ParamType:" + this.name + "}";
	    };
	    /** Given an encoded string, or a decoded object, returns a decoded object */
	    ParamType.prototype.$normalize = function (val) {
	        return this.is(val) ? val : this.decode(val);
	    };
	    /**
	     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
	     * e.g.:
	     * - urlmatcher pattern "/path?{queryParam[]:int}"
	     * - url: "/path?queryParam=1&queryParam=2
	     * - $stateParams.queryParam will be [1, 2]
	     * if `mode` is "auto", then
	     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	     */
	    ParamType.prototype.$asArray = function (mode, isSearch) {
	        if (!mode)
	            return this;
	        if (mode === 'auto' && !isSearch)
	            throw new Error("'auto' array mode is for query parameters only");
	        return new ArrayType(this, mode);
	    };
	    return ParamType;
	}());
	exports.ParamType = ParamType;
	/** Wraps up a `ParamType` object to handle array values. */
	function ArrayType(type, mode) {
	    var _this = this;
	    // Wrap non-array value as array
	    function arrayWrap(val) {
	        return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
	    }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	        switch (val.length) {
	            case 0:
	                return undefined;
	            case 1:
	                return mode === 'auto' ? val[0] : val;
	            default:
	                return val;
	        }
	    }
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	            if (predicates_1.isArray(val) && val.length === 0)
	                return val;
	            var arr = arrayWrap(val);
	            var result = common_1.map(arr, callback);
	            return allTruthyMode === true ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
	        };
	    }
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	            var left = arrayWrap(val1), right = arrayWrap(val2);
	            if (left.length !== right.length)
	                return false;
	            for (var i = 0; i < left.length; i++) {
	                if (!callback(left[i], right[i]))
	                    return false;
	            }
	            return true;
	        };
	    }
	    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
	        var paramTypeFn = type[name].bind(type);
	        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
	        _this[name] = wrapperFn(paramTypeFn);
	    });
	    common_1.extend(this, {
	        dynamic: type.dynamic,
	        name: type.name,
	        pattern: type.pattern,
	        inherit: type.inherit,
	        raw: type.raw,
	        is: arrayHandler(type.is.bind(type), true),
	        $arrayMode: mode,
	    });
	}
	//# sourceMappingURL=paramType.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamTypes = void 0;
	var common_1 = __webpack_require__(353);
	var predicates_1 = __webpack_require__(354);
	var hof_1 = __webpack_require__(355);
	var coreservices_1 = __webpack_require__(356);
	var paramType_1 = __webpack_require__(366);
	/**
	 * A registry for parameter types.
	 *
	 * This registry manages the built-in (and custom) parameter types.
	 *
	 * The built-in parameter types are:
	 *
	 * - [[string]]
	 * - [[path]]
	 * - [[query]]
	 * - [[hash]]
	 * - [[int]]
	 * - [[bool]]
	 * - [[date]]
	 * - [[json]]
	 * - [[any]]
	 *
	 * To register custom parameter types, use [[UrlConfig.type]], i.e.,
	 *
	 * ```js
	 * router.urlService.config.type(customType)
	 * ```
	 */
	var ParamTypes = /** @class */ (function () {
	    function ParamTypes() {
	        this.enqueue = true;
	        this.typeQueue = [];
	        this.defaultTypes = common_1.pick(ParamTypes.prototype, [
	            'hash',
	            'string',
	            'query',
	            'path',
	            'int',
	            'bool',
	            'date',
	            'json',
	            'any',
	        ]);
	        // Register default types. Store them in the prototype of this.types.
	        var makeType = function (definition, name) { return new paramType_1.ParamType(common_1.extend({ name: name }, definition)); };
	        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
	    }
	    ParamTypes.prototype.dispose = function () {
	        this.types = {};
	    };
	    /**
	     * Registers a parameter type
	     *
	     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
	     */
	    ParamTypes.prototype.type = function (name, definition, definitionFn) {
	        if (!predicates_1.isDefined(definition))
	            return this.types[name];
	        if (this.types.hasOwnProperty(name))
	            throw new Error("A type named '" + name + "' has already been defined.");
	        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        if (definitionFn) {
	            this.typeQueue.push({ name: name, def: definitionFn });
	            if (!this.enqueue)
	                this._flushTypeQueue();
	        }
	        return this;
	    };
	    ParamTypes.prototype._flushTypeQueue = function () {
	        while (this.typeQueue.length) {
	            var type = this.typeQueue.shift();
	            if (type.pattern)
	                throw new Error("You cannot override a type's .pattern at runtime.");
	            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
	        }
	    };
	    return ParamTypes;
	}());
	exports.ParamTypes = ParamTypes;
	function initDefaultTypes() {
	    var makeDefaultType = function (def) {
	        var valToString = function (val) { return (val != null ? val.toString() : val); };
	        var defaultTypeBase = {
	            encode: valToString,
	            decode: valToString,
	            is: hof_1.is(String),
	            pattern: /.*/,
	            // tslint:disable-next-line:triple-equals
	            equals: function (a, b) { return a == b; },
	        };
	        return common_1.extend({}, defaultTypeBase, def);
	    };
	    // Default Parameter Type Definitions
	    common_1.extend(ParamTypes.prototype, {
	        string: makeDefaultType({}),
	        path: makeDefaultType({
	            pattern: /[^/]*/,
	        }),
	        query: makeDefaultType({}),
	        hash: makeDefaultType({
	            inherit: false,
	        }),
	        int: makeDefaultType({
	            decode: function (val) { return parseInt(val, 10); },
	            is: function (val) {
	                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
	            },
	            pattern: /-?\d+/,
	        }),
	        bool: makeDefaultType({
	            encode: function (val) { return (val && 1) || 0; },
	            decode: function (val) { return parseInt(val, 10) !== 0; },
	            is: hof_1.is(Boolean),
	            pattern: /0|1/,
	        }),
	        date: makeDefaultType({
	            encode: function (val) {
	                return !this.is(val)
	                    ? undefined
	                    : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
	            },
	            decode: function (val) {
	                if (this.is(val))
	                    return val;
	                var match = this.capture.exec(val);
	                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	            },
	            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
	            equals: function (l, r) {
	                return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
	            },
	            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
	        }),
	        json: makeDefaultType({
	            encode: common_1.toJson,
	            decode: common_1.fromJson,
	            is: hof_1.is(Object),
	            equals: common_1.equals,
	            pattern: /[^/]*/,
	        }),
	        // does not encode/decode
	        any: makeDefaultType({
	            encode: common_1.identity,
	            decode: common_1.identity,
	            is: function () { return true; },
	            equals: common_1.equals,
	        }),
	    });
	}
	initDefaultTypes();
	//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateParams = void 0;
	var common_1 = __webpack_require__(353);
	var StateParams = /** @class */ (function () {
	    function StateParams(params) {
	        if (params === void 0) { params = {}; }
	        common_1.extend(this, params);
	    }
	    /**
	     * Merges a set of parameters with all parameters inherited between the common parents of the
	     * current state and a given destination state.
	     *
	     * @param {Object} newParams The set of parameters which will be composited with inherited params.
	     * @param {Object} $current Internal definition of object representing the current state.
	     * @param {Object} $to Internal definition of object representing state to transition to.
	     */
	    StateParams.prototype.$inherit = function (newParams, $current, $to) {
	        var parentParams;
	        var parents = common_1.ancestors($current, $to), inherited = {}, inheritList = [];
	        for (var i in parents) {
	            if (!parents[i] || !parents[i].params)
	                continue;
	            parentParams = Object.keys(parents[i].params);
	            if (!parentParams.length)
	                continue;
	            for (var j in parentParams) {
	                if (inheritList.indexOf(parentParams[j]) >= 0)
	                    continue;
	                inheritList.push(parentParams[j]);
	                inherited[parentParams[j]] = this[parentParams[j]];
	            }
	        }
	        return common_1.extend({}, inherited, newParams);
	    };
	    return StateParams;
	}());
	exports.StateParams = StateParams;
	//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(370), exports);
	__exportStar(__webpack_require__(371), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathNode = void 0;
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var param_1 = __webpack_require__(365);
	/**
	 * A node in a [[TreeChanges]] path
	 *
	 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
	 * Each PathNode corresponds to a state being entered, exited, or retained.
	 * The stateful information includes parameter values and resolve data.
	 */
	var PathNode = /** @class */ (function () {
	    function PathNode(stateOrNode) {
	        if (stateOrNode instanceof PathNode) {
	            var node = stateOrNode;
	            this.state = node.state;
	            this.paramSchema = node.paramSchema.slice();
	            this.paramValues = common_1.extend({}, node.paramValues);
	            this.resolvables = node.resolvables.slice();
	            this.views = node.views && node.views.slice();
	        }
	        else {
	            var state = stateOrNode;
	            this.state = state;
	            this.paramSchema = state.parameters({ inherit: false });
	            this.paramValues = {};
	            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
	        }
	    }
	    PathNode.prototype.clone = function () {
	        return new PathNode(this);
	    };
	    /** Sets [[paramValues]] for the node, from the values of an object hash */
	    PathNode.prototype.applyRawParams = function (params) {
	        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
	        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
	        return this;
	    };
	    /** Gets a specific [[Param]] metadata that belongs to the node */
	    PathNode.prototype.parameter = function (name) {
	        return common_1.find(this.paramSchema, hof_1.propEq('id', name));
	    };
	    /**
	     * @returns true if the state and parameter values for another PathNode are
	     * equal to the state and param values for this PathNode
	     */
	    PathNode.prototype.equals = function (node, paramsFn) {
	        var diff = this.diff(node, paramsFn);
	        return diff && diff.length === 0;
	    };
	    /**
	     * Finds Params with different parameter values on another PathNode.
	     *
	     * Given another node (of the same state), finds the parameter values which differ.
	     * Returns the [[Param]] (schema objects) whose parameter values differ.
	     *
	     * Given another node for a different state, returns `false`
	     *
	     * @param node The node to compare to
	     * @param paramsFn A function that returns which parameters should be compared.
	     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
	     */
	    PathNode.prototype.diff = function (node, paramsFn) {
	        if (this.state !== node.state)
	            return false;
	        var params = paramsFn ? paramsFn(this) : this.paramSchema;
	        return param_1.Param.changed(params, this.paramValues, node.paramValues);
	    };
	    /**
	     * Returns a clone of the PathNode
	     * @deprecated use instance method `node.clone()`
	     */
	    PathNode.clone = function (node) { return node.clone(); };
	    return PathNode;
	}());
	exports.PathNode = PathNode;
	//# sourceMappingURL=pathNode.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathUtils = void 0;
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var targetState_1 = __webpack_require__(372);
	var pathNode_1 = __webpack_require__(370);
	/**
	 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
	 */
	var PathUtils = /** @class */ (function () {
	    function PathUtils() {
	    }
	    /** Given a PathNode[], create an TargetState */
	    PathUtils.makeTargetState = function (registry, path) {
	        var state = common_1.tail(path).state;
	        return new targetState_1.TargetState(registry, state, path.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}), {});
	    };
	    PathUtils.buildPath = function (targetState) {
	        var toParams = targetState.params();
	        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
	    };
	    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
	    PathUtils.buildToPath = function (fromPath, targetState) {
	        var toPath = PathUtils.buildPath(targetState);
	        if (targetState.options().inherit) {
	            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
	        }
	        return toPath;
	    };
	    /**
	     * Creates ViewConfig objects and adds to nodes.
	     *
	     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
	     */
	    PathUtils.applyViewConfigs = function ($view, path, states) {
	        // Only apply the viewConfigs to the nodes for the given states
	        path
	            .filter(function (node) { return common_1.inArray(states, node.state); })
	            .forEach(function (node) {
	            var viewDecls = common_1.values(node.state.views || {});
	            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
	            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
	            node.views = viewConfigs.reduce(common_1.unnestR, []);
	        });
	    };
	    /**
	     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
	     *
	     * For a parameter in a node to be inherited from the from path:
	     * - The toPath's node must have a matching node in the fromPath (by state).
	     * - The parameter name must not be found in the toKeys parameter array.
	     *
	     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
	     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
	     * it is not inherited from the fromPath.
	     */
	    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
	        if (toKeys === void 0) { toKeys = []; }
	        function nodeParamVals(path, state) {
	            var node = common_1.find(path, hof_1.propEq('state', state));
	            return common_1.extend({}, node && node.paramValues);
	        }
	        var noInherit = fromPath
	            .map(function (node) { return node.paramSchema; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (param) { return !param.inherit; })
	            .map(hof_1.prop('id'));
	        /**
	         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
	         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
	         */
	        function makeInheritedParamsNode(toNode) {
	            // All param values for the node (may include default key/vals, when key was not found in toParams)
	            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
	            // limited to only those keys found in toParams
	            var incomingParamVals = common_1.pick(toParamVals, toKeys);
	            toParamVals = common_1.omit(toParamVals, toKeys);
	            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
	            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
	            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
	            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
	        }
	        // The param keys specified by the incoming toParams
	        return toPath.map(makeInheritedParamsNode);
	    };
	    /**
	     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
	     */
	    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
	        var max = Math.min(fromPath.length, toPath.length);
	        var keep = 0;
	        var nodesMatch = function (node1, node2) { return node1.equals(node2, PathUtils.nonDynamicParams); };
	        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
	            keep++;
	        }
	        /** Given a retained node, return a new node which uses the to node's param values */
	        function applyToParams(retainedNode, idx) {
	            var cloned = retainedNode.clone();
	            cloned.paramValues = toPath[idx].paramValues;
	            return cloned;
	        }
	        var from, retained, exiting, entering, to;
	        from = fromPath;
	        retained = from.slice(0, keep);
	        exiting = from.slice(keep);
	        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
	        var retainedWithToParams = retained.map(applyToParams);
	        entering = toPath.slice(keep);
	        to = retainedWithToParams.concat(entering);
	        return { from: from, to: to, retained: retained, retainedWithToParams: retainedWithToParams, exiting: exiting, entering: entering };
	    };
	    /**
	     * Returns a new path which is: the subpath of the first path which matches the second path.
	     *
	     * The new path starts from root and contains any nodes that match the nodes in the second path.
	     * It stops before the first non-matching node.
	     *
	     * Nodes are compared using their state property and their parameter values.
	     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
	     *
	     * @param pathA the first path
	     * @param pathB the second path
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     *
	     * @returns an array of PathNodes from the first path which match the nodes in the second path
	     */
	    PathUtils.matching = function (pathA, pathB, paramsFn) {
	        var done = false;
	        var tuples = common_1.arrayTuples(pathA, pathB);
	        return tuples.reduce(function (matching, _a) {
	            var nodeA = _a[0], nodeB = _a[1];
	            done = done || !nodeA.equals(nodeB, paramsFn);
	            return done ? matching : matching.concat(nodeA);
	        }, []);
	    };
	    /**
	     * Returns true if two paths are identical.
	     *
	     * @param pathA
	     * @param pathB
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     * @returns true if the the states and parameter values for both paths are identical
	     */
	    PathUtils.equals = function (pathA, pathB, paramsFn) {
	        return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
	    };
	    /**
	     * Return a subpath of a path, which stops at the first matching node
	     *
	     * Given an array of nodes, returns a subset of the array starting from the first node,
	     * stopping when the first node matches the predicate.
	     *
	     * @param path a path of [[PathNode]]s
	     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
	     * @returns a subpath up to the matching node, or undefined if no match is found
	     */
	    PathUtils.subPath = function (path, predicate) {
	        var node = common_1.find(path, predicate);
	        var elementIdx = path.indexOf(node);
	        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
	    };
	    PathUtils.nonDynamicParams = function (node) {
	        return node.state.parameters({ inherit: false }).filter(function (param) { return !param.dynamic; });
	    };
	    /** Gets the raw parameter values from a path */
	    PathUtils.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
	    return PathUtils;
	}());
	exports.PathUtils = PathUtils;
	//# sourceMappingURL=pathUtils.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TargetState = void 0;
	var predicates_1 = __webpack_require__(354);
	var strings_1 = __webpack_require__(359);
	var common_1 = __webpack_require__(352);
	/**
	 * Encapsulate the target (destination) state/params/options of a [[Transition]].
	 *
	 * This class is frequently used to redirect a transition to a new destination.
	 *
	 * See:
	 *
	 * - [[HookResult]]
	 * - [[TransitionHookFn]]
	 * - [[TransitionService.onStart]]
	 *
	 * To create a `TargetState`, use [[StateService.target]].
	 *
	 * ---
	 *
	 * This class wraps:
	 *
	 * 1) an identifier for a state
	 * 2) a set of parameters
	 * 3) and transition options
	 * 4) the registered state object (the [[StateDeclaration]])
	 *
	 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
	 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
	 * The `TargetState` class normalizes those options.
	 *
	 * A `TargetState` may be valid (the state being targeted exists in the registry)
	 * or invalid (the state being targeted is not registered).
	 */
	var TargetState = /** @class */ (function () {
	    /**
	     * The TargetState constructor
	     *
	     * Note: Do not construct a `TargetState` manually.
	     * To create a `TargetState`, use the [[StateService.target]] factory method.
	     *
	     * @param _stateRegistry The StateRegistry to use to look up the _definition
	     * @param _identifier An identifier for a state.
	     *    Either a fully-qualified state name, or the object used to define the state.
	     * @param _params Parameters for the target state
	     * @param _options Transition options.
	     *
	     * @internal
	     */
	    function TargetState(_stateRegistry, _identifier, _params, _options) {
	        this._stateRegistry = _stateRegistry;
	        this._identifier = _identifier;
	        this._identifier = _identifier;
	        this._params = common_1.extend({}, _params || {});
	        this._options = common_1.extend({}, _options || {});
	        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
	    }
	    /** The name of the state this object targets */
	    TargetState.prototype.name = function () {
	        return (this._definition && this._definition.name) || this._identifier;
	    };
	    /** The identifier used when creating this TargetState */
	    TargetState.prototype.identifier = function () {
	        return this._identifier;
	    };
	    /** The target parameter values */
	    TargetState.prototype.params = function () {
	        return this._params;
	    };
	    /** The internal state object (if it was found) */
	    TargetState.prototype.$state = function () {
	        return this._definition;
	    };
	    /** The internal state declaration (if it was found) */
	    TargetState.prototype.state = function () {
	        return this._definition && this._definition.self;
	    };
	    /** The target options */
	    TargetState.prototype.options = function () {
	        return this._options;
	    };
	    /** True if the target state was found */
	    TargetState.prototype.exists = function () {
	        return !!(this._definition && this._definition.self);
	    };
	    /** True if the object is valid */
	    TargetState.prototype.valid = function () {
	        return !this.error();
	    };
	    /** If the object is invalid, returns the reason why */
	    TargetState.prototype.error = function () {
	        var base = this.options().relative;
	        if (!this._definition && !!base) {
	            var stateName = base.name ? base.name : base;
	            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
	        }
	        if (!this._definition)
	            return "No such state '" + this.name() + "'";
	        if (!this._definition.self)
	            return "State '" + this.name() + "' has an invalid definition";
	    };
	    TargetState.prototype.toString = function () {
	        return "'" + this.name() + "'" + strings_1.stringify(this.params());
	    };
	    /**
	     * Returns a copy of this TargetState which targets a different state.
	     * The new TargetState has the same parameter values and transition options.
	     *
	     * @param state The new state that should be targeted
	     */
	    TargetState.prototype.withState = function (state) {
	        return new TargetState(this._stateRegistry, state, this._params, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified parameter values.
	     *
	     * @param params the new parameter values to use
	     * @param replace When false (default) the new parameter values will be merged with the current values.
	     *                When true the parameter values will be used instead of the current values.
	     */
	    TargetState.prototype.withParams = function (params, replace) {
	        if (replace === void 0) { replace = false; }
	        var newParams = replace ? params : common_1.extend({}, this._params, params);
	        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified Transition Options.
	     *
	     * @param options the new options to use
	     * @param replace When false (default) the new options will be merged with the current options.
	     *                When true the options will be used instead of the current options.
	     */
	    TargetState.prototype.withOptions = function (options, replace) {
	        if (replace === void 0) { replace = false; }
	        var newOpts = replace ? options : common_1.extend({}, this._options, options);
	        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
	    };
	    /** Returns true if the object has a state property that might be a state or state name */
	    TargetState.isDef = function (obj) {
	        return obj && obj.state && (predicates_1.isString(obj.state) || (predicates_1.isObject(obj.state) && predicates_1.isString(obj.state.name)));
	    };
	    return TargetState;
	}());
	exports.TargetState = TargetState;
	//# sourceMappingURL=targetState.js.map

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(374), exports);
	__exportStar(__webpack_require__(375), exports);
	__exportStar(__webpack_require__(376), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.resolvePolicies = void 0;
	exports.resolvePolicies = {
	    when: {
	        LAZY: 'LAZY',
	        EAGER: 'EAGER',
	    },
	    async: {
	        WAIT: 'WAIT',
	        NOWAIT: 'NOWAIT',
	    },
	};
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Resolvable = exports.defaultResolvePolicy = void 0;
	var common_1 = __webpack_require__(353);
	var coreservices_1 = __webpack_require__(356);
	var trace_1 = __webpack_require__(361);
	var strings_1 = __webpack_require__(359);
	var predicates_1 = __webpack_require__(354);
	var predicates_2 = __webpack_require__(354);
	// TODO: explicitly make this user configurable
	exports.defaultResolvePolicy = {
	    when: 'LAZY',
	    async: 'WAIT',
	};
	/**
	 * The basic building block for the resolve system.
	 *
	 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
	 * and the unwrapped-when-complete (.data) result of the resolveFn.
	 *
	 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
	 * resolveFn) and returns the resulting promise.
	 *
	 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
	 * parameter to those fns.
	 */
	var Resolvable = /** @class */ (function () {
	    function Resolvable(arg1, resolveFn, deps, policy, data) {
	        this.resolved = false;
	        this.promise = undefined;
	        if (arg1 instanceof Resolvable) {
	            common_1.extend(this, arg1);
	        }
	        else if (predicates_1.isFunction(resolveFn)) {
	            if (predicates_2.isNullOrUndefined(arg1))
	                throw new Error('new Resolvable(): token argument is required');
	            if (!predicates_1.isFunction(resolveFn))
	                throw new Error('new Resolvable(): resolveFn argument must be a function');
	            this.token = arg1;
	            this.policy = policy;
	            this.resolveFn = resolveFn;
	            this.deps = deps || [];
	            this.data = data;
	            this.resolved = data !== undefined;
	            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
	        }
	        else if (predicates_1.isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
	            var literal = arg1;
	            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
	        }
	    }
	    Resolvable.prototype.getPolicy = function (state) {
	        var thisPolicy = this.policy || {};
	        var statePolicy = (state && state.resolvePolicy) || {};
	        return {
	            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
	            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
	        };
	    };
	    /**
	     * Asynchronously resolve this Resolvable's data
	     *
	     * Given a ResolveContext that this Resolvable is found in:
	     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
	     * and update the Resolvable's state
	     */
	    Resolvable.prototype.resolve = function (resolveContext, trans) {
	        var _this = this;
	        var $q = coreservices_1.services.$q;
	        // Gets all dependencies from ResolveContext and wait for them to be resolved
	        var getResolvableDependencies = function () {
	            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) { return resolvable.get(resolveContext, trans); }));
	        };
	        // Invokes the resolve function passing the resolved dependencies as arguments
	        var invokeResolveFn = function (resolvedDeps) { return _this.resolveFn.apply(null, resolvedDeps); };
	        var node = resolveContext.findNode(this);
	        var state = node && node.state;
	        var asyncPolicy = this.getPolicy(state).async;
	        var customAsyncPolicy = predicates_1.isFunction(asyncPolicy) ? asyncPolicy : common_1.identity;
	        // After the final value has been resolved, update the state of the Resolvable
	        var applyResolvedValue = function (resolvedValue) {
	            _this.data = resolvedValue;
	            _this.resolved = true;
	            _this.resolveFn = null;
	            trace_1.trace.traceResolvableResolved(_this, trans);
	            return _this.data;
	        };
	        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
	        return (this.promise = $q
	            .when()
	            .then(getResolvableDependencies)
	            .then(invokeResolveFn)
	            .then(customAsyncPolicy)
	            .then(applyResolvedValue));
	    };
	    /**
	     * Gets a promise for this Resolvable's data.
	     *
	     * Fetches the data and returns a promise.
	     * Returns the existing promise if it has already been fetched once.
	     */
	    Resolvable.prototype.get = function (resolveContext, trans) {
	        return this.promise || this.resolve(resolveContext, trans);
	    };
	    Resolvable.prototype.toString = function () {
	        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
	    };
	    Resolvable.prototype.clone = function () {
	        return new Resolvable(this);
	    };
	    Resolvable.fromData = function (token, data) { return new Resolvable(token, function () { return data; }, null, null, data); };
	    return Resolvable;
	}());
	exports.Resolvable = Resolvable;
	//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResolveContext = exports.NATIVE_INJECTOR_TOKEN = void 0;
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var trace_1 = __webpack_require__(361);
	var coreservices_1 = __webpack_require__(356);
	var interface_1 = __webpack_require__(374);
	var resolvable_1 = __webpack_require__(375);
	var pathUtils_1 = __webpack_require__(371);
	var strings_1 = __webpack_require__(359);
	var common_2 = __webpack_require__(352);
	var whens = interface_1.resolvePolicies.when;
	var ALL_WHENS = [whens.EAGER, whens.LAZY];
	var EAGER_WHENS = [whens.EAGER];
	// tslint:disable-next-line:no-inferrable-types
	exports.NATIVE_INJECTOR_TOKEN = 'Native Injector';
	/**
	 * Encapsulates Dependency Injection for a path of nodes
	 *
	 * UI-Router states are organized as a tree.
	 * A nested state has a path of ancestors to the root of the tree.
	 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
	 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
	 *
	 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
	 */
	var ResolveContext = /** @class */ (function () {
	    function ResolveContext(_path) {
	        this._path = _path;
	    }
	    /** Gets all the tokens found in the resolve context, de-duplicated */
	    ResolveContext.prototype.getTokens = function () {
	        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
	    };
	    /**
	     * Gets the Resolvable that matches the token
	     *
	     * Gets the last Resolvable that matches the token in this context, or undefined.
	     * Throws an error if it doesn't exist in the ResolveContext
	     */
	    ResolveContext.prototype.getResolvable = function (token) {
	        var matching = this._path
	            .map(function (node) { return node.resolvables; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (r) { return r.token === token; });
	        return common_1.tail(matching);
	    };
	    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
	    ResolveContext.prototype.getPolicy = function (resolvable) {
	        var node = this.findNode(resolvable);
	        return resolvable.getPolicy(node.state);
	    };
	    /**
	     * Returns a ResolveContext that includes a portion of this one
	     *
	     * Given a state, this method creates a new ResolveContext from this one.
	     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
	     *
	     * #### Why
	     *
	     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
	     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
	     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
	     * This method is used to create a narrower context when injecting ancestor nodes.
	     *
	     * @example
	     * `let ABCD = new ResolveContext([A, B, C, D]);`
	     *
	     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
	     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
	     * However, `B` should only be able to access resolvables from `A`, `B`.
	     *
	     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
	     * `let AB = ABCD.subcontext(a)`
	     */
	    ResolveContext.prototype.subContext = function (state) {
	        return new ResolveContext(pathUtils_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
	    };
	    /**
	     * Adds Resolvables to the node that matches the state
	     *
	     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
	     * The resolvable is added to the node matching the `state` parameter.
	     *
	     * These new resolvables are not automatically fetched.
	     * The calling code should either fetch them, fetch something that depends on them,
	     * or rely on [[resolvePath]] being called when some state is being entered.
	     *
	     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
	     *
	     * @param newResolvables the new Resolvables
	     * @param state Used to find the node to put the resolvable on
	     */
	    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
	        var node = common_1.find(this._path, hof_1.propEq('state', state));
	        var keys = newResolvables.map(function (r) { return r.token; });
	        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
	    };
	    /**
	     * Returns a promise for an array of resolved path Element promises
	     *
	     * @param when
	     * @param trans
	     * @returns {Promise<any>|any}
	     */
	    ResolveContext.prototype.resolvePath = function (when, trans) {
	        var _this = this;
	        if (when === void 0) { when = 'LAZY'; }
	        // This option determines which 'when' policy Resolvables we are about to fetch.
	        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : 'LAZY';
	        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
	        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
	        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
	        // get the subpath to the state argument, if provided
	        trace_1.trace.traceResolvePath(this._path, when, trans);
	        var matchesPolicy = function (acceptedVals, whenOrAsync) { return function (resolvable) {
	            return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
	        }; };
	        // Trigger all the (matching) Resolvables in the path
	        // Reduce all the "WAIT" Resolvables into an array
	        var promises = this._path.reduce(function (acc, node) {
	            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
	            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
	            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
	            // For the matching Resolvables, start their async fetch process.
	            var subContext = _this.subContext(node.state);
	            var getResult = function (r) {
	                return r
	                    .get(subContext, trans)
	                    // Return a tuple that includes the Resolvable's token
	                    .then(function (value) { return ({ token: r.token, value: value }); });
	            };
	            nowait.forEach(getResult);
	            return acc.concat(wait.map(getResult));
	        }, []);
	        // Wait for all the "WAIT" resolvables
	        return coreservices_1.services.$q.all(promises);
	    };
	    ResolveContext.prototype.injector = function () {
	        return this._injector || (this._injector = new UIInjectorImpl(this));
	    };
	    ResolveContext.prototype.findNode = function (resolvable) {
	        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
	    };
	    /**
	     * Gets the async dependencies of a Resolvable
	     *
	     * Given a Resolvable, returns its dependencies as a Resolvable[]
	     */
	    ResolveContext.prototype.getDependencies = function (resolvable) {
	        var _this = this;
	        var node = this.findNode(resolvable);
	        // Find which other resolvables are "visible" to the `resolvable` argument
	        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
	        var subPath = pathUtils_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
	        var availableResolvables = subPath
	            .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) // all of subpath's resolvables
	            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
	        var getDependency = function (token) {
	            var matching = availableResolvables.filter(function (r) { return r.token === token; });
	            if (matching.length)
	                return common_1.tail(matching);
	            var fromInjector = _this.injector().getNative(token);
	            if (common_2.isUndefined(fromInjector)) {
	                throw new Error('Could not find Dependency Injection token: ' + strings_1.stringify(token));
	            }
	            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
	        };
	        return resolvable.deps.map(getDependency);
	    };
	    return ResolveContext;
	}());
	exports.ResolveContext = ResolveContext;
	/** @internal */
	var UIInjectorImpl = /** @class */ (function () {
	    function UIInjectorImpl(context) {
	        this.context = context;
	        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
	    }
	    UIInjectorImpl.prototype.get = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable) {
	            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
	                return resolvable.get(this.context);
	            }
	            if (!resolvable.resolved) {
	                throw new Error('Resolvable async .get() not complete:' + strings_1.stringify(resolvable.token));
	            }
	            return resolvable.data;
	        }
	        return this.getNative(token);
	    };
	    UIInjectorImpl.prototype.getAsync = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable)
	            return resolvable.get(this.context);
	        return coreservices_1.services.$q.when(this.native.get(token));
	    };
	    UIInjectorImpl.prototype.getNative = function (token) {
	        return this.native && this.native.get(token);
	    };
	    return UIInjectorImpl;
	}());
	//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # The state subsystem
	 *
	 * This subsystem implements the ui-router state tree
	 *
	 * - The [[StateService]] has state-related service methods such as:
	 *   - [[StateService.get]]: Get a registered [[StateDeclaration]] object
	 *   - [[StateService.go]]: Transition from the current state to a new state
	 *   - [[StateService.reload]]: Reload the current state
	 *   - [[StateService.target]]: Get a [[TargetState]] (useful when redirecting from a Transition Hook)
	 *   - [[StateService.onInvalid]]: Register a callback for when a transition to an invalid state is started
	 *   - [[StateService.defaultErrorHandler]]: Register a global callback for when a transition errors
	 * - The [[StateDeclaration]] interface defines the shape of a state declaration
	 * - The [[StateRegistry]] contains all the registered states
	 *   - States can be added/removed using the [[StateRegistry.register]] and [[StateRegistry.deregister]]
	 *     - Note: Bootstrap state registration differs by front-end framework.
	 *   - Get notified of state registration/deregistration using [[StateRegistry.onStatesChanged]].
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(378), exports);
	__exportStar(__webpack_require__(379), exports);
	__exportStar(__webpack_require__(380), exports);
	__exportStar(__webpack_require__(381), exports);
	__exportStar(__webpack_require__(382), exports);
	__exportStar(__webpack_require__(383), exports);
	__exportStar(__webpack_require__(384), exports);
	__exportStar(__webpack_require__(372), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateBuilder = exports.resolvablesBuilder = void 0;
	var common_1 = __webpack_require__(353);
	var predicates_1 = __webpack_require__(354);
	var strings_1 = __webpack_require__(359);
	var hof_1 = __webpack_require__(355);
	var resolvable_1 = __webpack_require__(375);
	var coreservices_1 = __webpack_require__(356);
	var parseUrl = function (url) {
	    if (!predicates_1.isString(url))
	        return false;
	    var root = url.charAt(0) === '^';
	    return { val: root ? url.substring(1) : url, root: root };
	};
	function nameBuilder(state) {
	    return state.name;
	}
	function selfBuilder(state) {
	    state.self.$$state = function () { return state; };
	    return state.self;
	}
	function dataBuilder(state) {
	    if (state.parent && state.parent.data) {
	        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
	    }
	    return state.data;
	}
	var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
	    return function urlBuilder(stateObject) {
	        var stateDec = stateObject.self;
	        // For future states, i.e., states whose name ends with `.**`,
	        // match anything that starts with the url prefix
	        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
	            var newStateDec = {};
	            common_1.copy(stateDec, newStateDec);
	            newStateDec.url += '{remainder:any}'; // match any path (.*)
	            stateDec = newStateDec;
	        }
	        var parent = stateObject.parent;
	        var parsed = parseUrl(stateDec.url);
	        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, { state: stateDec });
	        if (!url)
	            return null;
	        if (!$urlMatcherFactoryProvider.isMatcher(url))
	            throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
	        return parsed && parsed.root ? url : ((parent && parent.navigable) || root()).url.append(url);
	    };
	};
	var getNavigableBuilder = function (isRoot) {
	    return function navigableBuilder(state) {
	        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
	    };
	};
	var getParamsBuilder = function (paramFactory) {
	    return function paramsBuilder(state) {
	        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, state.self); };
	        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
	        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
	        return urlParams
	            .concat(nonUrlParams)
	            .map(function (p) { return [p.id, p]; })
	            .reduce(common_1.applyPairs, {});
	    };
	};
	function pathBuilder(state) {
	    return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
	}
	function includesBuilder(state) {
	    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
	    includes[state.name] = true;
	    return includes;
	}
	/**
	 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	 * validates the `resolve` property and converts it to a [[Resolvable]] array.
	 *
	 * resolve: input value can be:
	 *
	 * {
	 *   // analyzed but not injected
	 *   myFooResolve: function() { return "myFooData"; },
	 *
	 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
	 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
	 *
	 *   // Array split; "DependencyName" dep as string
	 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
	 *
	 *   // Array split; DependencyType dep as token (compared using ===)
	 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
	 *
	 *   // val.$inject used as deps
	 *   // where:
	 *   //     corgeResolve.$inject = ["DependencyName"];
	 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
	 *   // then "DependencyName" dep as string
	 *   myCorgeResolve: corgeResolve,
	 *
	 *  // inject service by name
	 *  // When a string is found, desugar creating a resolve that injects the named service
	 *   myGraultResolve: "SomeService"
	 * }
	 *
	 * or:
	 *
	 * [
	 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
	 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
	 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
	 * ]
	 */
	function resolvablesBuilder(state) {
	    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
	    var objects2Tuples = function (resolveObj, resolvePolicies) {
	        return Object.keys(resolveObj || {}).map(function (token) { return ({
	            token: token,
	            val: resolveObj[token],
	            deps: undefined,
	            policy: resolvePolicies[token],
	        }); });
	    };
	    /** fetch DI annotations from a function or ng1-style array */
	    var annotate = function (fn) {
	        var $injector = coreservices_1.services.$injector;
	        // ng1 doesn't have an $injector until runtime.
	        // If the $injector doesn't exist, use "deferred" literal as a
	        // marker indicating they should be annotated when runtime starts
	        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || 'deferred';
	    };
	    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
	    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
	    /** true if the object looks like a provide literal, or a ng2 Provider */
	    var isLikeNg2Provider = function (obj) {
	        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
	    };
	    /** true if the object looks like a tuple from obj2Tuples */
	    var isTupleFromObj = function (obj) {
	        return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
	    };
	    /** extracts the token from a Provider or provide literal */
	    var getToken = function (p) { return p.provide || p.token; };
	    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
	    var literal2Resolvable = hof_1.pattern([
	        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.resolveFn, p.deps, p.policy); }],
	        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy); }],
	        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return new p.useClass(); }, [], p.policy); }],
	        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
	        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(getToken(p), common_1.identity, [p.useExisting], p.policy); }],
	    ]);
	    // prettier-ignore
	    var tuple2Resolvable = hof_1.pattern([
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
	    ]);
	    // prettier-ignore
	    var item2Resolvable = hof_1.pattern([
	        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
	        [isResolveLiteral, literal2Resolvable],
	        [isLikeNg2Provider, literal2Resolvable],
	        [isTupleFromObj, tuple2Resolvable],
	        [hof_1.val(true), function (obj) { throw new Error('Invalid resolve value: ' + strings_1.stringify(obj)); },],
	    ]);
	    // If resolveBlock is already an array, use it as-is.
	    // Otherwise, assume it's an object and convert to an Array of tuples
	    var decl = state.resolve;
	    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
	    return items.map(item2Resolvable);
	}
	exports.resolvablesBuilder = resolvablesBuilder;
	/**
	 * A internal global service
	 *
	 * StateBuilder is a factory for the internal [[StateObject]] objects.
	 *
	 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
	 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
	 * [[StateObject]] object, which has an API and is used internally.
	 *
	 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
	 * using the [[builder]] method.
	 */
	var StateBuilder = /** @class */ (function () {
	    function StateBuilder(matcher, urlMatcherFactory) {
	        this.matcher = matcher;
	        var self = this;
	        var root = function () { return matcher.find(''); };
	        var isRoot = function (state) { return state.name === ''; };
	        function parentBuilder(state) {
	            if (isRoot(state))
	                return null;
	            return matcher.find(self.parentName(state)) || root();
	        }
	        this.builders = {
	            name: [nameBuilder],
	            self: [selfBuilder],
	            parent: [parentBuilder],
	            data: [dataBuilder],
	            // Build a URLMatcher if necessary, either via a relative or absolute URL
	            url: [getUrlBuilder(urlMatcherFactory, root)],
	            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	            navigable: [getNavigableBuilder(isRoot)],
	            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
	            // Each framework-specific ui-router implementation should define its own `views` builder
	            // e.g., src/ng1/statebuilders/views.ts
	            views: [],
	            // Keep a full path from the root down to this state as this is needed for state activation.
	            path: [pathBuilder],
	            // Speed up $state.includes() as it's used a lot
	            includes: [includesBuilder],
	            resolvables: [resolvablesBuilder],
	        };
	    }
	    StateBuilder.prototype.builder = function (name, fn) {
	        var builders = this.builders;
	        var array = builders[name] || [];
	        // Backwards compat: if only one builder exists, return it, else return whole arary.
	        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
	            return array.length > 1 ? array : array[0];
	        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
	            return;
	        builders[name] = array;
	        builders[name].push(fn);
	        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
	    };
	    /**
	     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
	     * properties and API built.
	     *
	     * @param state an uninitialized State object
	     * @returns the built State object
	     */
	    StateBuilder.prototype.build = function (state) {
	        var _a = this, matcher = _a.matcher, builders = _a.builders;
	        var parent = this.parentName(state);
	        if (parent && !matcher.find(parent, undefined, false)) {
	            return null;
	        }
	        for (var key in builders) {
	            if (!builders.hasOwnProperty(key))
	                continue;
	            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
	            state[key] = chain(state);
	        }
	        return state;
	    };
	    StateBuilder.prototype.parentName = function (state) {
	        // name = 'foo.bar.baz.**'
	        var name = state.name || '';
	        // segments = ['foo', 'bar', 'baz', '.**']
	        var segments = name.split('.');
	        // segments = ['foo', 'bar', 'baz']
	        var lastSegment = segments.pop();
	        // segments = ['foo', 'bar'] (ignore .** segment for future states)
	        if (lastSegment === '**')
	            segments.pop();
	        if (segments.length) {
	            if (state.parent) {
	                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
	            }
	            // 'foo.bar'
	            return segments.join('.');
	        }
	        if (!state.parent)
	            return '';
	        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	    };
	    StateBuilder.prototype.name = function (state) {
	        var name = state.name;
	        if (name.indexOf('.') !== -1 || !state.parent)
	            return name;
	        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	        return parentName ? parentName + '.' + name : name;
	    };
	    return StateBuilder;
	}());
	exports.StateBuilder = StateBuilder;
	//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateObject = void 0;
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var glob_1 = __webpack_require__(357);
	var predicates_1 = __webpack_require__(354);
	/**
	 * Internal representation of a UI-Router state.
	 *
	 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
	 *
	 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
	 *
	 * This class prototypally inherits from the corresponding [[StateDeclaration]].
	 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
	 */
	var StateObject = /** @class */ (function () {
	    /** @deprecated use State.create() */
	    function StateObject(config) {
	        return StateObject.create(config || {});
	    }
	    /**
	     * Create a state object to put the private/internal implementation details onto.
	     * The object's prototype chain looks like:
	     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
	     *
	     * @param stateDecl the user-supplied State Declaration
	     * @returns {StateObject} an internal State object
	     */
	    StateObject.create = function (stateDecl) {
	        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
	        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
	        stateDecl.$$state = function () { return state; };
	        state.self = stateDecl;
	        state.__stateObjectCache = {
	            nameGlob: glob_1.Glob.fromString(state.name),
	        };
	        return state;
	    };
	    /**
	     * Returns true if the provided parameter is the same state.
	     *
	     * Compares the identity of the state against the passed value, which is either an object
	     * reference to the actual `State` instance, the original definition object passed to
	     * `$stateProvider.state()`, or the fully-qualified name.
	     *
	     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
	     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
	     * @returns Returns `true` if `ref` matches the current `State` instance.
	     */
	    StateObject.prototype.is = function (ref) {
	        return this === ref || this.self === ref || this.fqn() === ref;
	    };
	    /**
	     * @deprecated this does not properly handle dot notation
	     * @returns Returns a dot-separated name of the state.
	     */
	    StateObject.prototype.fqn = function () {
	        if (!this.parent || !(this.parent instanceof this.constructor))
	            return this.name;
	        var name = this.parent.fqn();
	        return name ? name + '.' + this.name : this.name;
	    };
	    /**
	     * Returns the root node of this state's tree.
	     *
	     * @returns The root of this state's tree.
	     */
	    StateObject.prototype.root = function () {
	        return (this.parent && this.parent.root()) || this;
	    };
	    /**
	     * Gets the state's `Param` objects
	     *
	     * Gets the list of [[Param]] objects owned by the state.
	     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
	     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
	     *
	     * @param opts options
	     */
	    StateObject.prototype.parameters = function (opts) {
	        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
	        var inherited = (opts.inherit && this.parent && this.parent.parameters()) || [];
	        return inherited
	            .concat(common_1.values(this.params))
	            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
	    };
	    /**
	     * Returns a single [[Param]] that is owned by the state
	     *
	     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
	     * @param id the name of the [[Param]] to return
	     * @param opts options
	     */
	    StateObject.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        return ((this.url && this.url.parameter(id, opts)) ||
	            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
	            (opts.inherit && this.parent && this.parent.parameter(id)));
	    };
	    StateObject.prototype.toString = function () {
	        return this.fqn();
	    };
	    /** Predicate which returns true if the object is an class with @State() decorator */
	    StateObject.isStateClass = function (stateDecl) {
	        return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
	    };
	    /** Predicate which returns true if the object is a [[StateDeclaration]] object */
	    StateObject.isStateDeclaration = function (obj) { return predicates_1.isFunction(obj['$$state']); };
	    /** Predicate which returns true if the object is an internal [[StateObject]] object */
	    StateObject.isState = function (obj) { return predicates_1.isObject(obj['__stateObjectCache']); };
	    return StateObject;
	}());
	exports.StateObject = StateObject;
	//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateMatcher = void 0;
	var predicates_1 = __webpack_require__(354);
	var common_1 = __webpack_require__(353);
	var safeConsole_1 = __webpack_require__(362);
	var StateMatcher = /** @class */ (function () {
	    function StateMatcher(_states) {
	        this._states = _states;
	    }
	    StateMatcher.prototype.isRelative = function (stateName) {
	        stateName = stateName || '';
	        return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
	    };
	    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
	        if (matchGlob === void 0) { matchGlob = true; }
	        if (!stateOrName && stateOrName !== '')
	            return undefined;
	        var isStr = predicates_1.isString(stateOrName);
	        var name = isStr ? stateOrName : stateOrName.name;
	        if (this.isRelative(name))
	            name = this.resolvePath(name, base);
	        var state = this._states[name];
	        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	            return state;
	        }
	        else if (isStr && matchGlob) {
	            var _states = common_1.values(this._states);
	            var matches = _states.filter(function (_state) { return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name); });
	            if (matches.length > 1) {
	                safeConsole_1.safeConsole.error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
	            }
	            return matches[0];
	        }
	        return undefined;
	    };
	    StateMatcher.prototype.resolvePath = function (name, base) {
	        if (!base)
	            throw new Error("No reference point given for path '" + name + "'");
	        var baseState = this.find(base);
	        var splitName = name.split('.');
	        var pathLength = splitName.length;
	        var i = 0, current = baseState;
	        for (; i < pathLength; i++) {
	            if (splitName[i] === '' && i === 0) {
	                current = baseState;
	                continue;
	            }
	            if (splitName[i] === '^') {
	                if (!current.parent)
	                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
	                current = current.parent;
	                continue;
	            }
	            break;
	        }
	        var relName = splitName.slice(i).join('.');
	        return current.name + (current.name && relName ? '.' : '') + relName;
	    };
	    return StateMatcher;
	}());
	exports.StateMatcher = StateMatcher;
	//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateQueueManager = void 0;
	var common_1 = __webpack_require__(352);
	var stateObject_1 = __webpack_require__(380);
	var StateQueueManager = /** @class */ (function () {
	    function StateQueueManager(router, states, builder, listeners) {
	        this.router = router;
	        this.states = states;
	        this.builder = builder;
	        this.listeners = listeners;
	        this.queue = [];
	    }
	    StateQueueManager.prototype.dispose = function () {
	        this.queue = [];
	    };
	    StateQueueManager.prototype.register = function (stateDecl) {
	        var queue = this.queue;
	        var state = stateObject_1.StateObject.create(stateDecl);
	        var name = state.name;
	        if (!common_1.isString(name))
	            throw new Error('State must have a valid name');
	        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(common_1.prop('name')), name))
	            throw new Error("State '" + name + "' is already defined");
	        queue.push(state);
	        this.flush();
	        return state;
	    };
	    StateQueueManager.prototype.flush = function () {
	        var _this = this;
	        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
	        var registered = [], // states that got registered
	        orphans = [], // states that don't yet have a parent registered
	        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
	        var getState = function (name) { return _this.states.hasOwnProperty(name) && _this.states[name]; };
	        var notifyListeners = function () {
	            if (registered.length) {
	                _this.listeners.forEach(function (listener) {
	                    return listener('registered', registered.map(function (s) { return s.self; }));
	                });
	            }
	        };
	        while (queue.length > 0) {
	            var state = queue.shift();
	            var name_1 = state.name;
	            var result = builder.build(state);
	            var orphanIdx = orphans.indexOf(state);
	            if (result) {
	                var existingState = getState(name_1);
	                if (existingState && existingState.name === name_1) {
	                    throw new Error("State '" + name_1 + "' is already defined");
	                }
	                var existingFutureState = getState(name_1 + '.**');
	                if (existingFutureState) {
	                    // Remove future state of the same name
	                    this.router.stateRegistry.deregister(existingFutureState);
	                }
	                states[name_1] = state;
	                this.attachRoute(state);
	                if (orphanIdx >= 0)
	                    orphans.splice(orphanIdx, 1);
	                registered.push(state);
	                continue;
	            }
	            var prev = previousQueueLength[name_1];
	            previousQueueLength[name_1] = queue.length;
	            if (orphanIdx >= 0 && prev === queue.length) {
	                // Wait until two consecutive iterations where no additional states were dequeued successfully.
	                // throw new Error(`Cannot register orphaned state '${name}'`);
	                queue.push(state);
	                notifyListeners();
	                return states;
	            }
	            else if (orphanIdx < 0) {
	                orphans.push(state);
	            }
	            queue.push(state);
	        }
	        notifyListeners();
	        return states;
	    };
	    StateQueueManager.prototype.attachRoute = function (state) {
	        if (state.abstract || !state.url)
	            return;
	        var rulesApi = this.router.urlService.rules;
	        rulesApi.rule(rulesApi.urlRuleFactory.create(state));
	    };
	    return StateQueueManager;
	}());
	exports.StateQueueManager = StateQueueManager;
	//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateRegistry = void 0;
	var stateMatcher_1 = __webpack_require__(381);
	var stateBuilder_1 = __webpack_require__(379);
	var stateQueueManager_1 = __webpack_require__(382);
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	/**
	 * A registry for all of the application's [[StateDeclaration]]s
	 *
	 * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
	 */
	var StateRegistry = /** @class */ (function () {
	    /** @internal */
	    function StateRegistry(router) {
	        this.router = router;
	        this.states = {};
	        /** @internal */
	        this.listeners = [];
	        this.matcher = new stateMatcher_1.StateMatcher(this.states);
	        this.builder = new stateBuilder_1.StateBuilder(this.matcher, router.urlMatcherFactory);
	        this.stateQueue = new stateQueueManager_1.StateQueueManager(router, this.states, this.builder, this.listeners);
	        this._registerRoot();
	    }
	    /** @internal */
	    StateRegistry.prototype._registerRoot = function () {
	        var rootStateDef = {
	            name: '',
	            url: '^',
	            views: null,
	            params: {
	                '#': { value: null, type: 'hash', dynamic: true },
	            },
	            abstract: true,
	        };
	        var _root = (this._root = this.stateQueue.register(rootStateDef));
	        _root.navigable = null;
	    };
	    /** @internal */
	    StateRegistry.prototype.dispose = function () {
	        var _this = this;
	        this.stateQueue.dispose();
	        this.listeners = [];
	        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
	    };
	    /**
	     * Listen for a State Registry events
	     *
	     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
	     *
	     * #### Example:
	     * ```js
	     * let allStates = registry.get();
	     *
	     * // Later, invoke deregisterFn() to remove the listener
	     * let deregisterFn = registry.onStatesChanged((event, states) => {
	     *   switch(event) {
	     *     case: 'registered':
	     *       states.forEach(state => allStates.push(state));
	     *       break;
	     *     case: 'deregistered':
	     *       states.forEach(state => {
	     *         let idx = allStates.indexOf(state);
	     *         if (idx !== -1) allStates.splice(idx, 1);
	     *       });
	     *       break;
	     *   }
	     * });
	     * ```
	     *
	     * @param listener a callback function invoked when the registered states changes.
	     *        The function receives two parameters, `event` and `state`.
	     *        See [[StateRegistryListener]]
	     * @return a function that deregisters the listener
	     */
	    StateRegistry.prototype.onStatesChanged = function (listener) {
	        this.listeners.push(listener);
	        return function deregisterListener() {
	            common_1.removeFrom(this.listeners)(listener);
	        }.bind(this);
	    };
	    /**
	     * Gets the implicit root state
	     *
	     * Gets the root of the state tree.
	     * The root state is implicitly created by UI-Router.
	     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
	     *
	     * @return the root [[StateObject]]
	     */
	    StateRegistry.prototype.root = function () {
	        return this._root;
	    };
	    /**
	     * Adds a state to the registry
	     *
	     * Registers a [[StateDeclaration]] or queues it for registration.
	     *
	     * Note: a state will be queued if the state's parent isn't yet registered.
	     *
	     * @param stateDefinition the definition of the state to register.
	     * @returns the internal [[StateObject]] object.
	     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
	     *          If the state was only queued, then the object is not fully built.
	     */
	    StateRegistry.prototype.register = function (stateDefinition) {
	        return this.stateQueue.register(stateDefinition);
	    };
	    /** @internal */
	    StateRegistry.prototype._deregisterTree = function (state) {
	        var _this = this;
	        var all = this.get().map(function (s) { return s.$$state(); });
	        var getChildren = function (states) {
	            var _children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
	            return _children.length === 0 ? _children : _children.concat(getChildren(_children));
	        };
	        var children = getChildren([state]);
	        var deregistered = [state].concat(children).reverse();
	        deregistered.forEach(function (_state) {
	            var rulesApi = _this.router.urlService.rules;
	            // Remove URL rule
	            rulesApi
	                .rules()
	                .filter(hof_1.propEq('state', _state))
	                .forEach(function (rule) { return rulesApi.removeRule(rule); });
	            // Remove state from registry
	            delete _this.states[_state.name];
	        });
	        return deregistered;
	    };
	    /**
	     * Removes a state from the registry
	     *
	     * This removes a state from the registry.
	     * If the state has children, they are are also removed from the registry.
	     *
	     * @param stateOrName the state's name or object representation
	     * @returns {StateObject[]} a list of removed states
	     */
	    StateRegistry.prototype.deregister = function (stateOrName) {
	        var _state = this.get(stateOrName);
	        if (!_state)
	            throw new Error("Can't deregister state; not found: " + stateOrName);
	        var deregisteredStates = this._deregisterTree(_state.$$state());
	        this.listeners.forEach(function (listener) {
	            return listener('deregistered', deregisteredStates.map(function (s) { return s.self; }));
	        });
	        return deregisteredStates;
	    };
	    StateRegistry.prototype.get = function (stateOrName, base) {
	        var _this = this;
	        if (arguments.length === 0)
	            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
	        var found = this.matcher.find(stateOrName, base);
	        return (found && found.self) || null;
	    };
	    /**
	     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
	     * More than one BuilderFunction can be registered for a given property.
	     *
	     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
	     *
	     * @param property The name of the State property being registered for.
	     * @param builderFunction The BuilderFunction which will be used to build the State property
	     * @returns a function which deregisters the BuilderFunction
	     */
	    StateRegistry.prototype.decorator = function (property, builderFunction) {
	        return this.builder.builder(property, builderFunction);
	    };
	    return StateRegistry;
	}());
	exports.StateRegistry = StateRegistry;
	//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateService = void 0;
	var common_1 = __webpack_require__(353);
	var predicates_1 = __webpack_require__(354);
	var queue_1 = __webpack_require__(358);
	var coreservices_1 = __webpack_require__(356);
	var pathUtils_1 = __webpack_require__(371);
	var pathNode_1 = __webpack_require__(370);
	var transitionService_1 = __webpack_require__(385);
	var rejectFactory_1 = __webpack_require__(360);
	var targetState_1 = __webpack_require__(372);
	var param_1 = __webpack_require__(365);
	var glob_1 = __webpack_require__(357);
	var resolveContext_1 = __webpack_require__(376);
	var lazyLoad_1 = __webpack_require__(408);
	var hof_1 = __webpack_require__(355);
	/**
	 * Provides services related to ui-router states.
	 *
	 * This API is located at `router.stateService` ([[UIRouter.stateService]])
	 */
	var StateService = /** @class */ (function () {
	    /** @internal */
	    function StateService(/** @internal */ router) {
	        this.router = router;
	        /** @internal */
	        this.invalidCallbacks = [];
	        /** @internal */
	        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
	            if ($error$ instanceof Error && $error$.stack) {
	                console.error($error$);
	                console.error($error$.stack);
	            }
	            else if ($error$ instanceof rejectFactory_1.Rejection) {
	                console.error($error$.toString());
	                if ($error$.detail && $error$.detail.stack)
	                    console.error($error$.detail.stack);
	            }
	            else {
	                console.error($error$);
	            }
	        };
	        var getters = ['current', '$current', 'params', 'transition'];
	        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
	        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
	    }
	    Object.defineProperty(StateService.prototype, "transition", {
	        /**
	         * The [[Transition]] currently in progress (or null)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
	         */
	        get: function () {
	            return this.router.globals.transition;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "params", {
	        /**
	         * The latest successful state parameters
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
	         */
	        get: function () {
	            return this.router.globals.params;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "current", {
	        /**
	         * The current [[StateDeclaration]]
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
	         */
	        get: function () {
	            return this.router.globals.current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "$current", {
	        /**
	         * The current [[StateObject]] (an internal API)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
	         */
	        get: function () {
	            return this.router.globals.$current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @internal */
	    StateService.prototype.dispose = function () {
	        this.defaultErrorHandler(common_1.noop);
	        this.invalidCallbacks = [];
	    };
	    /**
	     * Handler for when [[transitionTo]] is called with an invalid state.
	     *
	     * Invokes the [[onInvalid]] callbacks, in natural order.
	     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
	     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
	     *
	     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
	     *
	     * @internal
	     */
	    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
	        var _this = this;
	        var fromState = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
	        var globals = this.router.globals;
	        var latestThing = function () { return globals.transitionHistory.peekTail(); };
	        var latest = latestThing();
	        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
	        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
	        var checkForRedirect = function (result) {
	            if (!(result instanceof targetState_1.TargetState)) {
	                return;
	            }
	            var target = result;
	            // Recreate the TargetState, in case the state is now defined.
	            target = _this.target(target.identifier(), target.params(), target.options());
	            if (!target.valid()) {
	                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
	            }
	            if (latestThing() !== latest) {
	                return rejectFactory_1.Rejection.superseded().toPromise();
	            }
	            return _this.transitionTo(target.identifier(), target.params(), target.options());
	        };
	        function invokeNextCallback() {
	            var nextCallback = callbackQueue.dequeue();
	            if (nextCallback === undefined)
	                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
	            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
	            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
	        }
	        return invokeNextCallback();
	    };
	    /**
	     * Registers an Invalid State handler
	     *
	     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
	     * has been called with an invalid state reference parameter
	     *
	     * Example:
	     * ```js
	     * stateService.onInvalid(function(to, from, injector) {
	     *   if (to.name() === 'foo') {
	     *     let lazyLoader = injector.get('LazyLoadService');
	     *     return lazyLoader.load('foo')
	     *         .then(() => stateService.target('foo'));
	     *   }
	     * });
	     * ```
	     *
	     * @param {function} callback invoked when the toState is invalid
	     *   This function receives the (invalid) toState, the fromState, and an injector.
	     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
	     *   If one is returned, it is treated as a redirect.
	     *
	     * @returns a function which deregisters the callback
	     */
	    StateService.prototype.onInvalid = function (callback) {
	        this.invalidCallbacks.push(callback);
	        return function deregisterListener() {
	            common_1.removeFrom(this.invalidCallbacks)(callback);
	        }.bind(this);
	    };
	    /**
	     * Reloads the current state
	     *
	     * A method that force reloads the current state, or a partial state hierarchy.
	     * All resolves are re-resolved, and components reinstantiated.
	     *
	     * #### Example:
	     * ```js
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * ```
	     *
	     * Note: `reload()` is just an alias for:
	     *
	     * ```js
	     * $state.transitionTo($state.current, $state.params, {
	     *   reload: true, inherit: false
	     * });
	     * ```
	     *
	     * @param reloadState A state name or a state object.
	     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
	     *
	     * #### Example:
	     * ```js
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
	     * //and current state is 'contacts.detail.item'
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * ```
	     *
	     * @returns A promise representing the state of the new transition. See [[StateService.go]]
	     */
	    StateService.prototype.reload = function (reloadState) {
	        return this.transitionTo(this.current, this.params, {
	            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
	            inherit: false,
	            notify: false,
	        });
	    };
	    /**
	     * Transition to a different state and/or parameters
	     *
	     * Convenience method for transitioning to a new state.
	     *
	     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
	     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
	     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
	     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
	     * inherit from the current parameter values (because of `inherit: true`).
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to Absolute state name, state object, or relative state path (relative to current state).
	     *
	     * Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to the parent state
	     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
	     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
	     *
	     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
	     *
	     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
	     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
	     *
	     * @param options Transition options
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     */
	    StateService.prototype.go = function (to, params, options) {
	        var defautGoOpts = { relative: this.$current, inherit: true };
	        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
	        return this.transitionTo(to, params, transOpts);
	    };
	    /**
	     * Creates a [[TargetState]]
	     *
	     * This is a factory method for creating a TargetState
	     *
	     * This may be returned from a Transition Hook to redirect a transition, for example.
	     */
	    StateService.prototype.target = function (identifier, params, options) {
	        if (options === void 0) { options = {}; }
	        // If we're reloading, find the state object to reload from
	        if (predicates_1.isObject(options.reload) && !options.reload.name)
	            throw new Error('Invalid reload state object');
	        var reg = this.router.stateRegistry;
	        options.reloadState =
	            options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
	        if (options.reload && !options.reloadState)
	            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
	        return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
	    };
	    /** @internal */
	    StateService.prototype.getCurrentPath = function () {
	        var _this = this;
	        var globals = this.router.globals;
	        var latestSuccess = globals.successfulTransitions.peekTail();
	        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
	        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
	    };
	    /**
	     * Low-level method for transitioning to a new state.
	     *
	     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to State name or state object.
	     * @param toParams A map of the parameters that will be sent to the state,
	     *      will populate $stateParams.
	     * @param options Transition options
	     *
	     * @returns A promise representing the state of the new transition. See [[go]]
	     */
	    StateService.prototype.transitionTo = function (to, toParams, options) {
	        var _this = this;
	        if (toParams === void 0) { toParams = {}; }
	        if (options === void 0) { options = {}; }
	        var router = this.router;
	        var globals = router.globals;
	        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
	        var getCurrent = function () { return globals.transition; };
	        options = common_1.extend(options, { current: getCurrent });
	        var ref = this.target(to, toParams, options);
	        var currentPath = this.getCurrentPath();
	        if (!ref.exists())
	            return this._handleInvalidTargetState(currentPath, ref);
	        if (!ref.valid())
	            return common_1.silentRejection(ref.error());
	        if (options.supercede === false && getCurrent()) {
	            return (rejectFactory_1.Rejection.ignored('Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.').toPromise());
	        }
	        /**
	         * Special handling for Ignored, Aborted, and Redirected transitions
	         *
	         * The semantics for the transition.run() promise and the StateService.transitionTo()
	         * promise differ. For instance, the run() promise may be rejected because it was
	         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
	         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
	         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
	         */
	        var rejectedTransitionHandler = function (trans) { return function (error) {
	            if (error instanceof rejectFactory_1.Rejection) {
	                var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
	                if (error.type === rejectFactory_1.RejectType.IGNORED) {
	                    isLatest && router.urlRouter.update();
	                    // Consider ignored `Transition.run()` as a successful `transitionTo`
	                    return coreservices_1.services.$q.when(globals.current);
	                }
	                var detail = error.detail;
	                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
	                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
	                    // by returning the promise for the new (redirect) `Transition.run()`.
	                    var redirect = trans.redirect(detail);
	                    return redirect.run().catch(rejectedTransitionHandler(redirect));
	                }
	                if (error.type === rejectFactory_1.RejectType.ABORTED) {
	                    isLatest && router.urlRouter.update();
	                    return coreservices_1.services.$q.reject(error);
	                }
	            }
	            var errorHandler = _this.defaultErrorHandler();
	            errorHandler(error);
	            return coreservices_1.services.$q.reject(error);
	        }; };
	        var transition = this.router.transitionService.create(currentPath, ref);
	        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
	        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
	        // Return a promise for the transition, which also has the transition object on it.
	        return common_1.extend(transitionToPromise, { transition: transition });
	    };
	    /**
	     * Checks if the current state *is* the provided state
	     *
	     * Similar to [[includes]] but only checks for the full state name.
	     * If params is supplied then it will be tested for strict equality against the current
	     * active params object, so all params must match with none missing and no extras.
	     *
	     * #### Example:
	     * ```js
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     * ```
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * ```html
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * ```
	     *
	     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns Returns true if it is the state.
	     */
	    StateService.prototype.is = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (this.$current !== state)
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Checks if the current state *includes* the provided state
	     *
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * #### Example when `$state.$current.name === 'contacts.details.item'`
	     * ```js
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     * ```
	     *
	     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
	     * ```js
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * ```
	     *
	     * @param stateOrName A partial name, relative name, glob pattern,
	     *   or state object to be searched for within the current state name.
	     * @param params A param object, e.g. `{sectionId: section.id}`,
	     *   that you'd like to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    StateService.prototype.includes = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
	        if (glob) {
	            if (!glob.matches(this.$current.name))
	                return false;
	            stateOrName = this.$current.name;
	        }
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (!predicates_1.isDefined(include[state.name]))
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Generates a URL for a state and parameters
	     *
	     * Returns the url for the given state populated with the given params.
	     *
	     * #### Example:
	     * ```js
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * ```
	     *
	     * @param stateOrName The state name or state object you'd like to generate a url from.
	     * @param params An object of parameter values to fill the state's required parameters.
	     * @param options Options object. The options are:
	     *
	     * @returns {string} compiled state url
	     */
	    StateService.prototype.href = function (stateOrName, params, options) {
	        var defaultHrefOpts = {
	            lossy: true,
	            inherit: true,
	            absolute: false,
	            relative: this.$current,
	        };
	        options = common_1.defaults(options, defaultHrefOpts);
	        params = params || {};
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return null;
	        if (options.inherit)
	            params = this.params.$inherit(params, this.$current, state);
	        var nav = state && options.lossy ? state.navigable : state;
	        if (!nav || nav.url === undefined || nav.url === null) {
	            return null;
	        }
	        return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
	    };
	    /**
	     * Sets or gets the default [[transitionTo]] error handler.
	     *
	     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
	     * This includes errors caused by resolves and transition hooks.
	     *
	     * Note:
	     * This handler does not receive certain Transition rejections.
	     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
	     *
	     * The built-in default error handler logs the error to the console.
	     *
	     * You can provide your own custom handler.
	     *
	     * #### Example:
	     * ```js
	     * stateService.defaultErrorHandler(function() {
	     *   // Do not log transitionTo errors
	     * });
	     * ```
	     *
	     * @param handler a global error handler function
	     * @returns the current global error handler
	     */
	    StateService.prototype.defaultErrorHandler = function (handler) {
	        return (this._defaultErrorHandler = handler || this._defaultErrorHandler);
	    };
	    StateService.prototype.get = function (stateOrName, base) {
	        var reg = this.router.stateRegistry;
	        if (arguments.length === 0)
	            return reg.get();
	        return reg.get(stateOrName, base || this.$current);
	    };
	    /**
	     * Lazy loads a state
	     *
	     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
	     *
	     * @param stateOrName the state that should be lazy loaded
	     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
	     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
	     * This noop transition is not actually run.
	     *
	     * @returns a promise to lazy load
	     */
	    StateService.prototype.lazyLoad = function (stateOrName, transition) {
	        var state = this.get(stateOrName);
	        if (!state || !state.lazyLoad)
	            throw new Error('Can not lazy load ' + stateOrName);
	        var currentPath = this.getCurrentPath();
	        var target = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
	        transition = transition || this.router.transitionService.create(currentPath, target);
	        return lazyLoad_1.lazyLoadState(transition, state);
	    };
	    return StateService;
	}());
	exports.StateService = StateService;
	//# sourceMappingURL=stateService.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionService = exports.defaultTransOpts = void 0;
	var interface_1 = __webpack_require__(386);
	var transition_1 = __webpack_require__(387);
	var hookRegistry_1 = __webpack_require__(389);
	var coreResolvables_1 = __webpack_require__(391);
	var redirectTo_1 = __webpack_require__(402);
	var onEnterExitRetain_1 = __webpack_require__(403);
	var resolve_1 = __webpack_require__(404);
	var views_1 = __webpack_require__(405);
	var updateGlobals_1 = __webpack_require__(406);
	var url_1 = __webpack_require__(407);
	var lazyLoad_1 = __webpack_require__(408);
	var transitionEventType_1 = __webpack_require__(409);
	var transitionHook_1 = __webpack_require__(388);
	var predicates_1 = __webpack_require__(354);
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var ignoredTransition_1 = __webpack_require__(410);
	var invalidTransition_1 = __webpack_require__(411);
	/**
	 * The default [[Transition]] options.
	 *
	 * Include this object when applying custom defaults:
	 * let reloadOpts = { reload: true, notify: true }
	 * let options = defaults(theirOpts, customDefaults, defaultOptions);
	 */
	exports.defaultTransOpts = {
	    location: true,
	    relative: null,
	    inherit: false,
	    notify: true,
	    reload: false,
	    supercede: true,
	    custom: {},
	    current: function () { return null; },
	    source: 'unknown',
	};
	/**
	 * This class provides services related to Transitions.
	 *
	 * - Most importantly, it allows global Transition Hooks to be registered.
	 * - It allows the default transition error handler to be set.
	 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
	 *
	 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
	 *
	 * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
	 */
	var TransitionService = /** @class */ (function () {
	    /** @internal */
	    function TransitionService(_router) {
	        /** @internal */
	        this._transitionCount = 0;
	        /** The transition hook types, such as `onEnter`, `onStart`, etc */
	        this._eventTypes = [];
	        /** @internal The registered transition hooks */
	        this._registeredHooks = {};
	        /** The  paths on a criteria object */
	        this._criteriaPaths = {};
	        this._router = _router;
	        this.$view = _router.viewService;
	        this._deregisterHookFns = {};
	        this._pluginapi = (common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
	            '_definePathType',
	            '_defineEvent',
	            '_getPathTypes',
	            '_getEvents',
	            'getHooks',
	        ]));
	        this._defineCorePaths();
	        this._defineCoreEvents();
	        this._registerCoreTransitionHooks();
	        _router.globals.successfulTransitions.onEvict(coreResolvables_1.treeChangesCleanup);
	    }
	    /**
	     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
	     *
	     * Registers a transition lifecycle hook, which is invoked during transition construction.
	     *
	     * This low level hook should only be used by plugins.
	     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
	     * The Sticky States plugin uses this hook to modify the treechanges.
	     *
	     * ### Lifecycle
	     *
	     * `onCreate` hooks are invoked *while a transition is being constructed*.
	     *
	     * ### Return value
	     *
	     * The hook's return value is ignored
	     *
	     * @internal
	     * @param criteria defines which Transitions the Hook should be invoked for.
	     * @param callback the hook function which will be invoked.
	     * @param options the registration options
	     * @returns a function which deregisters the hook.
	     */
	    TransitionService.prototype.onCreate = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /**
	     * dispose
	     * @internal
	     */
	    TransitionService.prototype.dispose = function (router) {
	        common_1.values(this._registeredHooks).forEach(function (hooksArray) {
	            return hooksArray.forEach(function (hook) {
	                hook._deregistered = true;
	                common_1.removeFrom(hooksArray, hook);
	            });
	        });
	    };
	    /**
	     * Creates a new [[Transition]] object
	     *
	     * This is a factory function for creating new Transition objects.
	     * It is used internally by the [[StateService]] and should generally not be called by application code.
	     *
	     * @internal
	     * @param fromPath the path to the current state (the from state)
	     * @param targetState the target state (destination)
	     * @returns a Transition
	     */
	    TransitionService.prototype.create = function (fromPath, targetState) {
	        return new transition_1.Transition(fromPath, targetState, this._router);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCoreEvents = function () {
	        var Phase = interface_1.TransitionHookPhase;
	        var TH = transitionHook_1.TransitionHook;
	        var paths = this._criteriaPaths;
	        var NORMAL_SORT = false, REVERSE_SORT = true;
	        var SYNCHRONOUS = true;
	        this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
	        this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
	        this._defineEvent('onStart', Phase.RUN, 0, paths.to);
	        this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
	        this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
	        this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
	        this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
	        this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	        this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCorePaths = function () {
	        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
	        this._definePathType('to', TRANSITION);
	        this._definePathType('from', TRANSITION);
	        this._definePathType('exiting', STATE);
	        this._definePathType('retained', STATE);
	        this._definePathType('entering', STATE);
	    };
	    /** @internal */
	    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
	        this._eventTypes.push(eventType);
	        hookRegistry_1.makeEvent(this, this, eventType);
	    };
	    /** @internal */
	    TransitionService.prototype._getEvents = function (phase) {
	        var transitionHookTypes = predicates_1.isDefined(phase)
	            ? this._eventTypes.filter(function (type) { return type.hookPhase === phase; })
	            : this._eventTypes.slice();
	        return transitionHookTypes.sort(function (l, r) {
	            var cmpByPhase = l.hookPhase - r.hookPhase;
	            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
	        });
	    };
	    /**
	     * Adds a Path to be used as a criterion against a TreeChanges path
	     *
	     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
	     * Each state in the exiting path is checked against the criteria and returned as part of the match.
	     *
	     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
	     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
	     *
	     * @internal
	     */
	    TransitionService.prototype._definePathType = function (name, hookScope) {
	        this._criteriaPaths[name] = { name: name, scope: hookScope };
	    };
	    /** @internal */
	    // tslint:disable-next-line
	    TransitionService.prototype._getPathTypes = function () {
	        return this._criteriaPaths;
	    };
	    /** @internal */
	    TransitionService.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    /** @internal */
	    TransitionService.prototype._registerCoreTransitionHooks = function () {
	        var fns = this._deregisterHookFns;
	        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
	        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
	        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
	        // Wire up redirectTo hook
	        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
	        // Wire up onExit/Retain/Enter state hooks
	        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
	        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
	        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
	        // Wire up Resolve hooks
	        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
	        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
	        fns.resolveAll = resolve_1.registerResolveRemaining(this);
	        // Wire up the View management hooks
	        fns.loadViews = views_1.registerLoadEnteringViews(this);
	        fns.activateViews = views_1.registerActivateViews(this);
	        // Updates global state after a transition
	        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
	        // After globals.current is updated at priority: 10000
	        fns.updateUrl = url_1.registerUpdateUrl(this);
	        // Lazy load state trees
	        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
	    };
	    return TransitionService;
	}());
	exports.TransitionService = TransitionService;
	//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHookScope = exports.TransitionHookPhase = void 0;
	var TransitionHookPhase;
	(function (TransitionHookPhase) {
	    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
	    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
	    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
	    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
	    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
	})(TransitionHookPhase || (TransitionHookPhase = {}));
	exports.TransitionHookPhase = TransitionHookPhase;
	var TransitionHookScope;
	(function (TransitionHookScope) {
	    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
	    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
	})(TransitionHookScope || (TransitionHookScope = {}));
	exports.TransitionHookScope = TransitionHookScope;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Transition = void 0;
	var trace_1 = __webpack_require__(361);
	var coreservices_1 = __webpack_require__(356);
	var strings_1 = __webpack_require__(359);
	var common_1 = __webpack_require__(353);
	var predicates_1 = __webpack_require__(354);
	var hof_1 = __webpack_require__(355);
	var interface_1 = __webpack_require__(386); // has or is using
	var transitionHook_1 = __webpack_require__(388);
	var hookRegistry_1 = __webpack_require__(389);
	var hookBuilder_1 = __webpack_require__(390);
	var pathUtils_1 = __webpack_require__(371);
	var param_1 = __webpack_require__(365);
	var resolvable_1 = __webpack_require__(375);
	var resolveContext_1 = __webpack_require__(376);
	var rejectFactory_1 = __webpack_require__(360);
	var common_2 = __webpack_require__(352);
	/** @internal */
	var stateSelf = hof_1.prop('self');
	/**
	 * Represents a transition between two states.
	 *
	 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
	 *
	 * This object contains all contextual information about the to/from states, parameters, resolves.
	 * It has information about all states being entered and exited as a result of the transition.
	 */
	var Transition = /** @class */ (function () {
	    /**
	     * Creates a new Transition object.
	     *
	     * If the target state is not valid, an error is thrown.
	     *
	     * @internal
	     *
	     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
	     *        encapsulates the "from state".
	     * @param targetState The target state and parameters being transitioned to (also, the transition options)
	     * @param router The [[UIRouter]] instance
	     * @internal
	     */
	    function Transition(fromPath, targetState, router) {
	        var _this = this;
	        /** @internal */
	        this._deferred = coreservices_1.services.$q.defer();
	        /**
	         * This promise is resolved or rejected based on the outcome of the Transition.
	         *
	         * When the transition is successful, the promise is resolved
	         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
	         */
	        this.promise = this._deferred.promise;
	        /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */
	        this._registeredHooks = {};
	        /** @internal */
	        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
	        /** Checks if this transition is currently active/running. */
	        this.isActive = function () { return _this.router.globals.transition === _this; };
	        this.router = router;
	        this._targetState = targetState;
	        if (!targetState.valid()) {
	            throw new Error(targetState.error());
	        }
	        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
	        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
	        this.$id = router.transitionService._transitionCount++;
	        var toPath = pathUtils_1.PathUtils.buildToPath(fromPath, targetState);
	        this._treeChanges = pathUtils_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
	        this.createTransitionHookRegFns();
	        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
	        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
	        this.applyViewConfigs(router);
	    }
	    /** @internal */
	    Transition.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /** @internal
	     * Creates the transition-level hook registration functions
	     * (which can then be used to register hooks)
	     */
	    Transition.prototype.createTransitionHookRegFns = function () {
	        var _this = this;
	        this.router.transitionService._pluginapi
	            ._getEvents()
	            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
	            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
	    };
	    /** @internal */
	    Transition.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    Transition.prototype.applyViewConfigs = function (router) {
	        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
	        pathUtils_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
	    };
	    /**
	     * @internal
	     * @returns the internal from [State] object
	     */
	    Transition.prototype.$from = function () {
	        return common_1.tail(this._treeChanges.from).state;
	    };
	    /**
	     * @internal
	     * @returns the internal to [State] object
	     */
	    Transition.prototype.$to = function () {
	        return common_1.tail(this._treeChanges.to).state;
	    };
	    /**
	     * Returns the "from state"
	     *
	     * Returns the state that the transition is coming *from*.
	     *
	     * @returns The state declaration object for the Transition's ("from state").
	     */
	    Transition.prototype.from = function () {
	        return this.$from().self;
	    };
	    /**
	     * Returns the "to state"
	     *
	     * Returns the state that the transition is going *to*.
	     *
	     * @returns The state declaration object for the Transition's target state ("to state").
	     */
	    Transition.prototype.to = function () {
	        return this.$to().self;
	    };
	    /**
	     * Gets the Target State
	     *
	     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
	     *
	     * @returns the [[TargetState]] of this Transition
	     */
	    Transition.prototype.targetState = function () {
	        return this._targetState;
	    };
	    /**
	     * Determines whether two transitions are equivalent.
	     * @deprecated
	     */
	    Transition.prototype.is = function (compare) {
	        if (compare instanceof Transition) {
	            // TODO: Also compare parameters
	            return this.is({ to: compare.$to().name, from: compare.$from().name });
	        }
	        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to, this)) ||
	            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from, this)));
	    };
	    Transition.prototype.params = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}));
	    };
	    Transition.prototype.paramsChanged = function () {
	        var fromParams = this.params('from');
	        var toParams = this.params('to');
	        // All the parameters declared on both the "to" and "from" paths
	        var allParamDescriptors = []
	            .concat(this._treeChanges.to)
	            .concat(this._treeChanges.from)
	            .map(function (pathNode) { return pathNode.paramSchema; })
	            .reduce(common_2.flattenR, [])
	            .reduce(common_2.uniqR, []);
	        var changedParamDescriptors = param_1.Param.changed(allParamDescriptors, fromParams, toParams);
	        return changedParamDescriptors.reduce(function (changedValues, descriptor) {
	            changedValues[descriptor.id] = toParams[descriptor.id];
	            return changedValues;
	        }, {});
	    };
	    /**
	     * Creates a [[UIInjector]] Dependency Injector
	     *
	     * Returns a Dependency Injector for the Transition's target state (to state).
	     * The injector provides resolve values which the target state has access to.
	     *
	     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
	     *
	     * #### Example:
	     * ```js
	     * .onEnter({ entering: 'myState' }, trans => {
	     *   var myResolveValue = trans.injector().get('myResolve');
	     *   // Inject a global service from the global/native injector (if it exists)
	     *   var MyService = trans.injector().get('MyService');
	     * })
	     * ```
	     *
	     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
	     * You can use [[UIInjector.getAsync]] to get a promise for the data.
	     * #### Example:
	     * ```js
	     * .onBefore({}, trans => {
	     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
	     *     return myResolveValue !== 'ABORT';
	     *   });
	     * });
	     * ```
	     *
	     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
	     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
	     * #### Example:
	     * ```js
	     * .onEnter({ to: 'foo.bar' }, trans => {
	     *   // returns result of `foo` state's `myResolve` resolve
	     *   // even though `foo.bar` also has a `myResolve` resolve
	     *   var fooData = trans.injector('foo').get('myResolve');
	     * });
	     * ```
	     *
	     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
	     * The resolve data from the `from` path will be returned.
	     * #### Example:
	     * ```js
	     * .onExit({ exiting: 'foo.bar' }, trans => {
	     *   // Gets the resolve value of `myResolve` from the state being exited
	     *   var fooData = trans.injector(null, 'from').get('myResolve');
	     * });
	     * ```
	     *
	     *
	     * @param state Limits the resolves provided to only the resolves the provided state has access to.
	     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
	     *
	     * @returns a [[UIInjector]]
	     */
	    Transition.prototype.injector = function (state, pathName) {
	        if (pathName === void 0) { pathName = 'to'; }
	        var path = this._treeChanges[pathName];
	        if (state)
	            path = pathUtils_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
	        return new resolveContext_1.ResolveContext(path).injector();
	    };
	    /**
	     * Gets all available resolve tokens (keys)
	     *
	     * This method can be used in conjunction with [[injector]] to inspect the resolve values
	     * available to the Transition.
	     *
	     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
	     * in the Transition's [[TreeChanges.to]] path.
	     *
	     * #### Example:
	     * This example logs all resolve values
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
	     * ```
	     *
	     * #### Example:
	     * This example creates promises for each resolve value.
	     * This triggers fetches of resolves (if any have not yet been fetched).
	     * When all promises have all settled, it logs the resolve values.
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * let promise = tokens.map(token => trans.injector().getAsync(token));
	     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
	     * ```
	     *
	     * Note: Angular 1 users whould use `$q.all()`
	     *
	     * @param pathname resolve context's path name (e.g., `to` or `from`)
	     *
	     * @returns an array of resolve tokens (keys)
	     */
	    Transition.prototype.getResolveTokens = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
	    };
	    /**
	     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
	     *
	     * Allows a transition hook to dynamically add a Resolvable to this Transition.
	     *
	     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
	     *
	     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
	     * If no `state` is provided then the root state is used.
	     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
	     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
	     *
	     * The `state` argument also scopes the resolved data.
	     * The resolved data is available from the injector for that `state` and any children states.
	     *
	     * #### Example:
	     * ```js
	     * transitionService.onBefore({}, transition => {
	     *   transition.addResolvable({
	     *     token: 'myResolve',
	     *     deps: ['MyService'],
	     *     resolveFn: myService => myService.getData()
	     *   });
	     * });
	     * ```
	     *
	     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
	     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
	     */
	    Transition.prototype.addResolvable = function (resolvable, state) {
	        if (state === void 0) { state = ''; }
	        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
	        var stateName = typeof state === 'string' ? state : state.name;
	        var topath = this._treeChanges.to;
	        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
	        var resolveContext = new resolveContext_1.ResolveContext(topath);
	        resolveContext.addResolvables([resolvable], targetNode.state);
	    };
	    /**
	     * Gets the transition from which this transition was redirected.
	     *
	     * If the current transition is a redirect, this method returns the transition that was redirected.
	     *
	     * #### Example:
	     * ```js
	     * let transitionA = $state.go('A').transition
	     * transitionA.onStart({}, () => $state.target('B'));
	     * $transitions.onSuccess({ to: 'B' }, (trans) => {
	     *   trans.to().name === 'B'; // true
	     *   trans.redirectedFrom() === transitionA; // true
	     * });
	     * ```
	     *
	     * @returns The previous Transition, or null if this Transition is not the result of a redirection
	     */
	    Transition.prototype.redirectedFrom = function () {
	        return this._options.redirectedFrom || null;
	    };
	    /**
	     * Gets the original transition in a redirect chain
	     *
	     * A transition might belong to a long chain of multiple redirects.
	     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
	     *
	     * #### Example:
	     * ```js
	     * // states
	     * registry.register({ name: 'A', redirectTo: 'B' });
	     * registry.register({ name: 'B', redirectTo: 'C' });
	     * registry.register({ name: 'C', redirectTo: 'D' });
	     * registry.register({ name: 'D' });
	     *
	     * let transitionA = $state.go('A').transition
	     *
	     * $transitions.onSuccess({ to: 'D' }, (trans) => {
	     *   trans.to().name === 'D'; // true
	     *   trans.redirectedFrom().to().name === 'C'; // true
	     *   trans.originalTransition() === transitionA; // true
	     *   trans.originalTransition().to().name === 'A'; // true
	     * });
	     * ```
	     *
	     * @returns The original Transition that started a redirect chain
	     */
	    Transition.prototype.originalTransition = function () {
	        var rf = this.redirectedFrom();
	        return (rf && rf.originalTransition()) || this;
	    };
	    /**
	     * Get the transition options
	     *
	     * @returns the options for this Transition.
	     */
	    Transition.prototype.options = function () {
	        return this._options;
	    };
	    /**
	     * Gets the states being entered.
	     *
	     * @returns an array of states that will be entered during this transition.
	     */
	    Transition.prototype.entering = function () {
	        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Gets the states being exited.
	     *
	     * @returns an array of states that will be exited during this transition.
	     */
	    Transition.prototype.exiting = function () {
	        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
	    };
	    /**
	     * Gets the states being retained.
	     *
	     * @returns an array of states that are already entered from a previous Transition, that will not be
	     *    exited during this Transition
	     */
	    Transition.prototype.retained = function () {
	        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Get the [[ViewConfig]]s associated with this Transition
	     *
	     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
	     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
	     *
	     * @param pathname the name of the path to fetch views for:
	     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
	     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
	     *
	     * @returns a list of ViewConfig objects for the given path.
	     */
	    Transition.prototype.views = function (pathname, state) {
	        if (pathname === void 0) { pathname = 'entering'; }
	        var path = this._treeChanges[pathname];
	        path = !state ? path : path.filter(hof_1.propEq('state', state));
	        return path.map(hof_1.prop('views')).filter(common_1.identity).reduce(common_1.unnestR, []);
	    };
	    Transition.prototype.treeChanges = function (pathname) {
	        return pathname ? this._treeChanges[pathname] : this._treeChanges;
	    };
	    /**
	     * Creates a new transition that is a redirection of the current one.
	     *
	     * This transition can be returned from a [[TransitionService]] hook to
	     * redirect a transition to a new state and/or set of parameters.
	     *
	     * @internal
	     *
	     * @returns Returns a new [[Transition]] instance.
	     */
	    Transition.prototype.redirect = function (targetState) {
	        var redirects = 1, trans = this;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((trans = trans.redirectedFrom()) != null) {
	            if (++redirects > 20)
	                throw new Error("Too many consecutive Transition redirects (20+)");
	        }
	        var redirectOpts = { redirectedFrom: this, source: 'redirect' };
	        // If the original transition was caused by URL sync, then use { location: 'replace' }
	        // on the new transition (unless the target state explicitly specifies location: false).
	        // This causes the original url to be replaced with the url for the redirect target
	        // so the original url disappears from the browser history.
	        if (this.options().source === 'url' && targetState.options().location !== false) {
	            redirectOpts.location = 'replace';
	        }
	        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
	        targetState = targetState.withOptions(newOptions, true);
	        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
	        var originalEnteringNodes = this._treeChanges.entering;
	        var redirectEnteringNodes = newTransition._treeChanges.entering;
	        // --- Re-use resolve data from original transition ---
	        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
	        // (because of the redirect), the resolves fetched by the original transition are still valid in the
	        // redirected transition.
	        //
	        // This allows you to define a redirect on a parent state which depends on an async resolve value.
	        // You can wait for the resolve, then redirect to a child state based on the result.
	        // The redirected transition does not have to re-fetch the resolve.
	        // ---------------------------------------------------------
	        var nodeIsReloading = function (reloadState) { return function (node) {
	            return reloadState && node.state.includes[reloadState.name];
	        }; };
	        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
	        var matchingEnteringNodes = pathUtils_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathUtils_1.PathUtils.nonDynamicParams).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
	        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
	        matchingEnteringNodes.forEach(function (node, idx) {
	            node.resolvables = originalEnteringNodes[idx].resolvables;
	        });
	        return newTransition;
	    };
	    /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
	    Transition.prototype._changedParams = function () {
	        var tc = this._treeChanges;
	        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
	        // If user explicitly wants a reload
	        if (this._options.reload)
	            return undefined;
	        // If any states are exiting or entering
	        if (tc.exiting.length || tc.entering.length)
	            return undefined;
	        // If to/from path lengths differ
	        if (tc.to.length !== tc.from.length)
	            return undefined;
	        // If the to/from paths are different
	        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
	            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
	            .reduce(common_1.anyTrueR, false);
	        if (pathsDiffer)
	            return undefined;
	        // Find any parameter values that differ
	        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
	        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
	        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
	        return tuples.map(function (_a) {
	            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
	            return param_1.Param.changed(schema, toVals, fromVals);
	        }).reduce(common_1.unnestR, []);
	    };
	    /**
	     * Returns true if the transition is dynamic.
	     *
	     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
	     *
	     * @returns true if the Transition is dynamic
	     */
	    Transition.prototype.dynamic = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
	    };
	    /**
	     * Returns true if the transition is ignored.
	     *
	     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
	     *
	     * @returns true if the Transition is ignored.
	     */
	    Transition.prototype.ignored = function () {
	        return !!this._ignoredReason();
	    };
	    /** @internal */
	    Transition.prototype._ignoredReason = function () {
	        var pending = this.router.globals.transition;
	        var reloadState = this._options.reloadState;
	        var same = function (pathA, pathB) {
	            if (pathA.length !== pathB.length)
	                return false;
	            var matching = pathUtils_1.PathUtils.matching(pathA, pathB);
	            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
	        };
	        var newTC = this.treeChanges();
	        var pendTC = pending && pending.treeChanges();
	        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
	            return 'SameAsPending';
	        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
	            return 'SameAsCurrent';
	    };
	    /**
	     * Runs the transition
	     *
	     * This method is generally called from the [[StateService.transitionTo]]
	     *
	     * @internal
	     *
	     * @returns a promise for a successful transition.
	     */
	    Transition.prototype.run = function () {
	        var _this = this;
	        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
	        // Gets transition hooks array for the given phase
	        var getHooksFor = function (phase) { return _this._hookBuilder.buildHooksForPhase(phase); };
	        // When the chain is complete, then resolve or reject the deferred
	        var transitionSuccess = function () {
	            trace_1.trace.traceSuccess(_this.$to(), _this);
	            _this.success = true;
	            _this._deferred.resolve(_this.to());
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
	        };
	        var transitionError = function (reason) {
	            trace_1.trace.traceError(reason, _this);
	            _this.success = false;
	            _this._deferred.reject(reason);
	            _this._error = reason;
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
	        };
	        var runTransition = function () {
	            // Wait to build the RUN hook chain until the BEFORE hooks are done
	            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
	            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
	            var done = function () { return coreservices_1.services.$q.when(undefined); };
	            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
	        };
	        var startTransition = function () {
	            var globals = _this.router.globals;
	            globals.lastStartedTransitionId = _this.$id;
	            globals.transition = _this;
	            globals.transitionHistory.enqueue(_this);
	            trace_1.trace.traceTransitionStart(_this);
	            return coreservices_1.services.$q.when(undefined);
	        };
	        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
	        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
	            .then(runTransition)
	            .then(transitionSuccess, transitionError);
	        return this.promise;
	    };
	    /**
	     * Checks if the Transition is valid
	     *
	     * @returns true if the Transition is valid
	     */
	    Transition.prototype.valid = function () {
	        return !this.error() || this.success !== undefined;
	    };
	    /**
	     * Aborts this transition
	     *
	     * Imperative API to abort a Transition.
	     * This only applies to Transitions that are not yet complete.
	     */
	    Transition.prototype.abort = function () {
	        // Do not set flag if the transition is already complete
	        if (predicates_1.isUndefined(this.success)) {
	            this._aborted = true;
	        }
	    };
	    /**
	     * The Transition error reason.
	     *
	     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
	     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
	     *
	     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
	     */
	    Transition.prototype.error = function () {
	        var state = this.$to();
	        if (state.self.abstract) {
	            return rejectFactory_1.Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
	        }
	        var paramDefs = state.parameters();
	        var values = this.params();
	        var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
	        if (invalidParams.length) {
	            var invalidValues = invalidParams.map(function (param) { return "[" + param.id + ":" + strings_1.stringify(values[param.id]) + "]"; }).join(', ');
	            var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
	            return rejectFactory_1.Rejection.invalid(detail);
	        }
	        if (this.success === false)
	            return this._error;
	    };
	    /**
	     * A string representation of the Transition
	     *
	     * @returns A string representation of the Transition
	     */
	    Transition.prototype.toString = function () {
	        var fromStateOrName = this.from();
	        var toStateOrName = this.to();
	        var avoidEmptyHash = function (params) {
	            return params['#'] !== null && params['#'] !== undefined ? params : common_1.omit(params, ['#']);
	        };
	        // (X) means the to state is invalid.
	        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? '' : '(X) ', to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = strings_1.stringify(avoidEmptyHash(this.params()));
	        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
	    };
	    /** @internal */
	    Transition.diToken = Transition;
	    return Transition;
	}());
	exports.Transition = Transition;
	//# sourceMappingURL=transition.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHook = void 0;
	var interface_1 = __webpack_require__(386);
	var common_1 = __webpack_require__(353);
	var strings_1 = __webpack_require__(359);
	var predicates_1 = __webpack_require__(354);
	var hof_1 = __webpack_require__(355);
	var trace_1 = __webpack_require__(361);
	var coreservices_1 = __webpack_require__(356);
	var rejectFactory_1 = __webpack_require__(360);
	var targetState_1 = __webpack_require__(372);
	var defaultOptions = {
	    current: common_1.noop,
	    transition: null,
	    traceData: {},
	    bind: null,
	};
	var TransitionHook = /** @class */ (function () {
	    function TransitionHook(transition, stateContext, registeredHook, options) {
	        var _this = this;
	        this.transition = transition;
	        this.stateContext = stateContext;
	        this.registeredHook = registeredHook;
	        this.options = options;
	        this.isSuperseded = function () { return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive(); };
	        this.options = common_1.defaults(options, defaultOptions);
	        this.type = registeredHook.eventType;
	    }
	    /**
	     * Chains together an array of TransitionHooks.
	     *
	     * Given a list of [[TransitionHook]] objects, chains them together.
	     * Each hook is invoked after the previous one completes.
	     *
	     * #### Example:
	     * ```js
	     * var hooks: TransitionHook[] = getHooks();
	     * let promise: Promise<any> = TransitionHook.chain(hooks);
	     *
	     * promise.then(handleSuccess, handleError);
	     * ```
	     *
	     * @param hooks the list of hooks to chain together
	     * @param waitFor if provided, the chain is `.then()`'ed off this promise
	     * @returns a `Promise` for sequentially invoking the hooks (in order)
	     */
	    TransitionHook.chain = function (hooks, waitFor) {
	        // Chain the next hook off the previous
	        var createHookChainR = function (prev, nextHook) { return prev.then(function () { return nextHook.invokeHook(); }); };
	        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
	    };
	    /**
	     * Invokes all the provided TransitionHooks, in order.
	     * Each hook's return value is checked.
	     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
	     * If no hook returns a promise, then all hooks are processed synchronously.
	     *
	     * @param hooks the list of TransitionHooks to invoke
	     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
	     *
	     * @returns a promise for the async result, or the result of the callback
	     */
	    TransitionHook.invokeHooks = function (hooks, doneCallback) {
	        for (var idx = 0; idx < hooks.length; idx++) {
	            var hookResult = hooks[idx].invokeHook();
	            if (predicates_1.isPromise(hookResult)) {
	                var remainingHooks = hooks.slice(idx + 1);
	                return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
	            }
	        }
	        return doneCallback();
	    };
	    /**
	     * Run all TransitionHooks, ignoring their return value.
	     */
	    TransitionHook.runAllHooks = function (hooks) {
	        hooks.forEach(function (hook) { return hook.invokeHook(); });
	    };
	    TransitionHook.prototype.logError = function (err) {
	        this.transition.router.stateService.defaultErrorHandler()(err);
	    };
	    TransitionHook.prototype.invokeHook = function () {
	        var _this = this;
	        var hook = this.registeredHook;
	        if (hook._deregistered)
	            return;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        var options = this.options;
	        trace_1.trace.traceHookInvocation(this, this.transition, options);
	        var invokeCallback = function () { return hook.callback.call(options.bind, _this.transition, _this.stateContext); };
	        var normalizeErr = function (err) { return rejectFactory_1.Rejection.normalize(err).toPromise(); };
	        var handleError = function (err) { return hook.eventType.getErrorHandler(_this)(err); };
	        var handleResult = function (result) { return hook.eventType.getResultHandler(_this)(result); };
	        try {
	            var result = invokeCallback();
	            if (!this.type.synchronous && predicates_1.isPromise(result)) {
	                return result.catch(normalizeErr).then(handleResult, handleError);
	            }
	            else {
	                return handleResult(result);
	            }
	        }
	        catch (err) {
	            // If callback throws (synchronously)
	            return handleError(rejectFactory_1.Rejection.normalize(err));
	        }
	        finally {
	            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
	                hook.deregister();
	            }
	        }
	    };
	    /**
	     * This method handles the return value of a Transition Hook.
	     *
	     * A hook can return false (cancel), a TargetState (redirect),
	     * or a promise (which may later resolve to false or a redirect)
	     *
	     * This also handles "transition superseded" -- when a new transition
	     * was started while the hook was still running
	     */
	    TransitionHook.prototype.handleHookResult = function (result) {
	        var _this = this;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        // Hook returned a promise
	        if (predicates_1.isPromise(result)) {
	            // Wait for the promise, then reprocess with the resulting value
	            return result.then(function (val) { return _this.handleHookResult(val); });
	        }
	        trace_1.trace.traceHookResult(result, this.transition, this.options);
	        // Hook returned false
	        if (result === false) {
	            // Abort this Transition
	            return rejectFactory_1.Rejection.aborted('Hook aborted transition').toPromise();
	        }
	        var isTargetState = hof_1.is(targetState_1.TargetState);
	        // hook returned a TargetState
	        if (isTargetState(result)) {
	            // Halt the current Transition and redirect (a new Transition) to the TargetState.
	            return rejectFactory_1.Rejection.redirected(result).toPromise();
	        }
	    };
	    /**
	     * Return a Rejection promise if the transition is no longer current due
	     * to a stopped router (disposed), or a new transition has started and superseded this one.
	     */
	    TransitionHook.prototype.getNotCurrentRejection = function () {
	        var router = this.transition.router;
	        // The router is stopped
	        if (router._disposed) {
	            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
	        }
	        if (this.transition._aborted) {
	            return rejectFactory_1.Rejection.aborted().toPromise();
	        }
	        // This transition is no longer current.
	        // Another transition started while this hook was still running.
	        if (this.isSuperseded()) {
	            // Abort this transition
	            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
	        }
	    };
	    TransitionHook.prototype.toString = function () {
	        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.fnToString(registeredHook.callback);
	        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
	    };
	    /**
	     * These GetResultHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
	        return hook.handleHookResult(result);
	    }; };
	    /**
	     * If the result is a promise rejection, log it.
	     * Otherwise, ignore the result.
	     */
	    TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
	        predicates_1.isPromise(result) && result.catch(function (err) { return hook.logError(rejectFactory_1.Rejection.normalize(err)); });
	        return undefined;
	    }; };
	    /**
	     * These GetErrorHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.LOG_ERROR = function (hook) { return function (error) { return hook.logError(error); }; };
	    TransitionHook.REJECT_ERROR = function (hook) { return function (error) { return common_1.silentRejection(error); }; };
	    TransitionHook.THROW_ERROR = function (hook) { return function (error) {
	        throw error;
	    }; };
	    return TransitionHook;
	}());
	exports.TransitionHook = TransitionHook;
	//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.makeEvent = exports.RegisteredHook = exports.matchState = void 0;
	var common_1 = __webpack_require__(352);
	var interface_1 = __webpack_require__(386);
	/**
	 * Determines if the given state matches the matchCriteria
	 *
	 * @internal
	 *
	 * @param state a State Object to test against
	 * @param criterion
	 * - If a string, matchState uses the string as a glob-matcher against the state name
	 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
	 *   and returns a positive match if any of the globs match.
	 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
	 * @returns {boolean}
	 */
	function matchState(state, criterion, transition) {
	    var toMatch = common_1.isString(criterion) ? [criterion] : criterion;
	    function matchGlobs(_state) {
	        var globStrings = toMatch;
	        for (var i = 0; i < globStrings.length; i++) {
	            var glob = new common_1.Glob(globStrings[i]);
	            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var matchFn = (common_1.isFunction(toMatch) ? toMatch : matchGlobs);
	    return !!matchFn(state, transition);
	}
	exports.matchState = matchState;
	/**
	 * The registration data for a registered transition hook
	 */
	var RegisteredHook = /** @class */ (function () {
	    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
	        if (options === void 0) { options = {}; }
	        this.tranSvc = tranSvc;
	        this.eventType = eventType;
	        this.callback = callback;
	        this.matchCriteria = matchCriteria;
	        this.removeHookFromRegistry = removeHookFromRegistry;
	        this.invokeCount = 0;
	        this._deregistered = false;
	        this.priority = options.priority || 0;
	        this.bind = options.bind || null;
	        this.invokeLimit = options.invokeLimit;
	    }
	    /**
	     * Gets the matching [[PathNode]]s
	     *
	     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
	     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
	     *
	     * Returning `null` is significant to distinguish between the default
	     * "match-all criterion value" of `true` compared to a `() => true` function,
	     * when the nodes is an empty array.
	     *
	     * This is useful to allow a transition match criteria of `entering: true`
	     * to still match a transition, even when `entering === []`.  Contrast that
	     * with `entering: (state) => true` which only matches when a state is actually
	     * being entered.
	     */
	    RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
	        if (criterion === true)
	            return nodes;
	        var matching = nodes.filter(function (node) { return matchState(node.state, criterion, transition); });
	        return matching.length ? matching : null;
	    };
	    /**
	     * Gets the default match criteria (all `true`)
	     *
	     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
	     *
	     * ```js
	     * {
	     *   to: true,
	     *   from: true,
	     *   entering: true,
	     *   exiting: true,
	     *   retained: true,
	     * }
	     */
	    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
	        return common_1.mapObj(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
	    };
	    /**
	     * Gets matching nodes as [[IMatchingNodes]]
	     *
	     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
	     *
	     * ```js
	     * let matches: IMatchingNodes = {
	     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
	     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
	     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
	     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
	     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
	     * };
	     * ```
	     */
	    RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
	        var _this = this;
	        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
	        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
	        return paths.reduce(function (mn, pathtype) {
	            // STATE scope criteria matches against every node in the path.
	            // TRANSITION scope criteria matches against only the last node in the path
	            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
	            var path = treeChanges[pathtype.name] || [];
	            var nodes = isStateHook ? path : [common_1.tail(path)];
	            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
	            return mn;
	        }, {});
	    };
	    /**
	     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
	     *
	     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
	     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
	     */
	    RegisteredHook.prototype.matches = function (treeChanges, transition) {
	        var matches = this._getMatchingNodes(treeChanges, transition);
	        // Check if all the criteria matched the TreeChanges object
	        var allMatched = common_1.values(matches).every(common_1.identity);
	        return allMatched ? matches : null;
	    };
	    RegisteredHook.prototype.deregister = function () {
	        this.removeHookFromRegistry(this);
	        this._deregistered = true;
	    };
	    return RegisteredHook;
	}());
	exports.RegisteredHook = RegisteredHook;
	/** Return a registration function of the requested type. */
	function makeEvent(registry, transitionService, eventType) {
	    // Create the object which holds the registered transition hooks.
	    var _registeredHooks = (registry._registeredHooks = registry._registeredHooks || {});
	    var hooks = (_registeredHooks[eventType.name] = []);
	    var removeHookFn = common_1.removeFrom(hooks);
	    // Create hook registration function on the IHookRegistry for the event
	    registry[eventType.name] = hookRegistrationFn;
	    function hookRegistrationFn(matchObject, callback, options) {
	        if (options === void 0) { options = {}; }
	        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
	        hooks.push(registeredHook);
	        return registeredHook.deregister.bind(registeredHook);
	    }
	    return hookRegistrationFn;
	}
	exports.makeEvent = makeEvent;
	//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HookBuilder = void 0;
	var common_1 = __webpack_require__(353);
	var predicates_1 = __webpack_require__(354);
	var interface_1 = __webpack_require__(386);
	var transitionHook_1 = __webpack_require__(388);
	/**
	 * This class returns applicable TransitionHooks for a specific Transition instance.
	 *
	 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
	 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
	 * determined by the type of hook)
	 *
	 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
	 *
	 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
	 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
	 * in the Transition class, so we must also provide the Transition's _treeChanges)
	 */
	var HookBuilder = /** @class */ (function () {
	    function HookBuilder(transition) {
	        this.transition = transition;
	    }
	    HookBuilder.prototype.buildHooksForPhase = function (phase) {
	        var _this = this;
	        var $transitions = this.transition.router.transitionService;
	        return $transitions._pluginapi
	            ._getEvents(phase)
	            .map(function (type) { return _this.buildHooks(type); })
	            .reduce(common_1.unnestR, [])
	            .filter(common_1.identity);
	    };
	    /**
	     * Returns an array of newly built TransitionHook objects.
	     *
	     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
	     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
	     * - For each of the [[PathNode]]s, creates a TransitionHook
	     *
	     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
	     */
	    HookBuilder.prototype.buildHooks = function (hookType) {
	        var transition = this.transition;
	        var treeChanges = transition.treeChanges();
	        // Find all the matching registered hooks for a given hook type
	        var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
	        if (!matchingHooks)
	            return [];
	        var baseHookOptions = {
	            transition: transition,
	            current: transition.options().current,
	        };
	        var makeTransitionHooks = function (hook) {
	            // Fetch the Nodes that caused this hook to match.
	            var matches = hook.matches(treeChanges, transition);
	            // Select the PathNode[] that will be used as TransitionHook context objects
	            var matchingNodes = matches[hookType.criteriaMatchPath.name];
	            // Return an array of HookTuples
	            return matchingNodes.map(function (node) {
	                var _options = common_1.extend({
	                    bind: hook.bind,
	                    traceData: { hookType: hookType.name, context: node },
	                }, baseHookOptions);
	                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
	                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
	                return { hook: hook, node: node, transitionHook: transitionHook };
	            });
	        };
	        return matchingHooks
	            .map(makeTransitionHooks)
	            .reduce(common_1.unnestR, [])
	            .sort(tupleSort(hookType.reverseSort))
	            .map(function (tuple) { return tuple.transitionHook; });
	    };
	    /**
	     * Finds all RegisteredHooks from:
	     * - The Transition object instance hook registry
	     * - The TransitionService ($transitions) global hook registry
	     *
	     * which matched:
	     * - the eventType
	     * - the matchCriteria (to, from, exiting, retained, entering)
	     *
	     * @returns an array of matched [[RegisteredHook]]s
	     */
	    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
	        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
	        // Instance and Global hook registries
	        var $transitions = this.transition.router.transitionService;
	        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
	        return registries
	            .map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
	            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
	            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
	            .filter(function (hook) { return hook.matches(treeChanges, transition); }); // Only those satisfying matchCriteria
	    };
	    return HookBuilder;
	}());
	exports.HookBuilder = HookBuilder;
	/**
	 * A factory for a sort function for HookTuples.
	 *
	 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
	 * the EventHook priority.
	 *
	 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
	 * @returns a tuple sort function
	 */
	function tupleSort(reverseDepthSort) {
	    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
	    return function nodeDepthThenPriority(l, r) {
	        var factor = reverseDepthSort ? -1 : 1;
	        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
	        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
	    };
	}
	//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.treeChangesCleanup = exports.registerAddCoreResolvables = void 0;
	var transition_1 = __webpack_require__(387);
	var router_1 = __webpack_require__(392);
	var resolve_1 = __webpack_require__(373);
	var common_1 = __webpack_require__(352);
	function addCoreResolvables(trans) {
	    trans.addResolvable(resolve_1.Resolvable.fromData(router_1.UIRouter, trans.router), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData(transition_1.Transition, trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$transition$', trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$stateParams', trans.params()), '');
	    trans.entering().forEach(function (state) {
	        trans.addResolvable(resolve_1.Resolvable.fromData('$state$', state), state);
	    });
	}
	exports.registerAddCoreResolvables = function (transitionService) {
	    return transitionService.onCreate({}, addCoreResolvables);
	};
	var TRANSITION_TOKENS = ['$transition$', transition_1.Transition];
	var isTransition = common_1.inArray(TRANSITION_TOKENS);
	// References to Transition in the treeChanges pathnodes makes all
	// previous Transitions reachable in memory, causing a memory leak
	// This function removes resolves for '$transition$' and `Transition` from the treeChanges.
	// Do not use this on current transitions, only on old ones.
	exports.treeChangesCleanup = function (trans) {
	    var nodes = common_1.values(trans.treeChanges()).reduce(common_1.unnestR, []).reduce(common_1.uniqR, []);
	    // If the resolvable is a Transition, return a new resolvable with null data
	    var replaceTransitionWithNull = function (r) {
	        return isTransition(r.token) ? resolve_1.Resolvable.fromData(r.token, null) : r;
	    };
	    nodes.forEach(function (node) {
	        node.resolvables = node.resolvables.map(replaceTransitionWithNull);
	    });
	};
	//# sourceMappingURL=coreResolvables.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouter = void 0;
	var urlMatcherFactory_1 = __webpack_require__(393);
	var urlRouter_1 = __webpack_require__(395);
	var transitionService_1 = __webpack_require__(385);
	var view_1 = __webpack_require__(397);
	var stateRegistry_1 = __webpack_require__(383);
	var stateService_1 = __webpack_require__(384);
	var globals_1 = __webpack_require__(398);
	var common_1 = __webpack_require__(353);
	var predicates_1 = __webpack_require__(354);
	var urlService_1 = __webpack_require__(399);
	var trace_1 = __webpack_require__(361);
	var common_2 = __webpack_require__(352);
	/** @internal */
	var _routerInstance = 0;
	/** @internal */
	var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
	/** @internal */
	var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
	/** @internal */
	var locationServiceStub = common_2.makeStub('LocationServices', locSvcFns);
	/** @internal */
	var locationConfigStub = common_2.makeStub('LocationConfig', locCfgFns);
	/**
	 * An instance of UI-Router.
	 *
	 * This object contains references to service APIs which define your application's routing behavior.
	 */
	var UIRouter = /** @class */ (function () {
	    /**
	     * Creates a new `UIRouter` object
	     *
	     * @param locationService a [[LocationServices]] implementation
	     * @param locationConfig a [[LocationConfig]] implementation
	     * @internal
	     */
	    function UIRouter(locationService, locationConfig) {
	        if (locationService === void 0) { locationService = locationServiceStub; }
	        if (locationConfig === void 0) { locationConfig = locationConfigStub; }
	        this.locationService = locationService;
	        this.locationConfig = locationConfig;
	        /** @internal */ this.$id = _routerInstance++;
	        /** @internal */ this._disposed = false;
	        /** @internal */ this._disposables = [];
	        /** Enable/disable tracing to the javascript console */
	        this.trace = trace_1.trace;
	        /** Provides services related to ui-view synchronization */
	        this.viewService = new view_1.ViewService(this);
	        /** An object that contains global router state, such as the current state and params */
	        this.globals = new globals_1.UIRouterGlobals();
	        /** A service that exposes global Transition Hooks */
	        this.transitionService = new transitionService_1.TransitionService(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlRouter = new urlRouter_1.UrlRouter(this);
	        /** Provides services related to the URL */
	        this.urlService = new urlService_1.UrlService(this);
	        /** Provides a registry for states, and related registration services */
	        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
	        /** Provides services related to states */
	        this.stateService = new stateService_1.StateService(this);
	        /** @internal plugin instances are registered here */
	        this._plugins = {};
	        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
	        this.globals.$current = this.stateRegistry.root();
	        this.globals.current = this.globals.$current.self;
	        this.disposable(this.globals);
	        this.disposable(this.stateService);
	        this.disposable(this.stateRegistry);
	        this.disposable(this.transitionService);
	        this.disposable(this.urlService);
	        this.disposable(locationService);
	        this.disposable(locationConfig);
	    }
	    /** Registers an object to be notified when the router is disposed */
	    UIRouter.prototype.disposable = function (disposable) {
	        this._disposables.push(disposable);
	    };
	    /**
	     * Disposes this router instance
	     *
	     * When called, clears resources retained by the router by calling `dispose(this)` on all
	     * registered [[disposable]] objects.
	     *
	     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
	     *
	     * @internal
	     * @param disposable (optional) the disposable to dispose
	     */
	    UIRouter.prototype.dispose = function (disposable) {
	        var _this = this;
	        if (disposable && predicates_1.isFunction(disposable.dispose)) {
	            disposable.dispose(this);
	            return undefined;
	        }
	        this._disposed = true;
	        this._disposables.slice().forEach(function (d) {
	            try {
	                typeof d.dispose === 'function' && d.dispose(_this);
	                common_1.removeFrom(_this._disposables, d);
	            }
	            catch (ignored) { }
	        });
	    };
	    /**
	     * Adds a plugin to UI-Router
	     *
	     * This method adds a UI-Router Plugin.
	     * A plugin can enhance or change UI-Router behavior using any public API.
	     *
	     * #### Example:
	     * ```js
	     * import { MyCoolPlugin } from "ui-router-cool-plugin";
	     *
	     * var plugin = router.addPlugin(MyCoolPlugin);
	     * ```
	     *
	     * ### Plugin authoring
	     *
	     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
	     *
	     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
	     * For example, it may configure router options or add a Transition Hook.
	     *
	     * The plugin can then be published as a separate module.
	     *
	     * #### Example:
	     * ```js
	     * export class MyAuthPlugin implements UIRouterPlugin {
	     *   constructor(router: UIRouter, options: any) {
	     *     this.name = "MyAuthPlugin";
	     *     let $transitions = router.transitionService;
	     *     let $state = router.stateService;
	     *
	     *     let authCriteria = {
	     *       to: (state) => state.data && state.data.requiresAuth
	     *     };
	     *
	     *     function authHook(transition: Transition) {
	     *       let authService = transition.injector().get('AuthService');
	     *       if (!authService.isAuthenticated()) {
	     *         return $state.target('login');
	     *       }
	     *     }
	     *
	     *     $transitions.onStart(authCriteria, authHook);
	     *   }
	     * }
	     * ```
	     *
	     * @param plugin one of:
	     *        - a plugin class which implements [[UIRouterPlugin]]
	     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
	     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
	     * @param options options to pass to the plugin class/factory
	     * @returns the registered plugin instance
	     */
	    UIRouter.prototype.plugin = function (plugin, options) {
	        if (options === void 0) { options = {}; }
	        var pluginInstance = new plugin(this, options);
	        if (!pluginInstance.name)
	            throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
	        this._disposables.push(pluginInstance);
	        return (this._plugins[pluginInstance.name] = pluginInstance);
	    };
	    UIRouter.prototype.getPlugin = function (pluginName) {
	        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
	    };
	    return UIRouter;
	}());
	exports.UIRouter = UIRouter;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcherFactory = exports.ParamFactory = void 0;
	var common_1 = __webpack_require__(352);
	var urlMatcher_1 = __webpack_require__(394);
	var params_1 = __webpack_require__(363);
	var ParamFactory = /** @class */ (function () {
	    function ParamFactory(router) {
	        this.router = router;
	    }
	    ParamFactory.prototype.fromConfig = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.CONFIG, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromPath = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.PATH, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromSearch = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.SEARCH, this.router.urlService.config, state);
	    };
	    return ParamFactory;
	}());
	exports.ParamFactory = ParamFactory;
	/**
	 * Factory for [[UrlMatcher]] instances.
	 *
	 * The factory is available to ng1 services as
	 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
	 */
	var UrlMatcherFactory = /** @class */ (function () {
	    // TODO: move implementations to UrlConfig (urlService.config)
	    function UrlMatcherFactory(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** Creates a new [[Param]] for a given location (DefType) */
	        this.paramFactory = new ParamFactory(this.router);
	        // TODO: Check if removal of this will break anything, then remove these
	        this.UrlMatcher = urlMatcher_1.UrlMatcher;
	        this.Param = params_1.Param;
	        /** @deprecated use [[UrlConfig.caseInsensitive]] */
	        this.caseInsensitive = function (value) { return _this.router.urlService.config.caseInsensitive(value); };
	        /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
	        this.defaultSquashPolicy = function (value) { return _this.router.urlService.config.defaultSquashPolicy(value); };
	        /** @deprecated use [[UrlConfig.strictMode]] */
	        this.strictMode = function (value) { return _this.router.urlService.config.strictMode(value); };
	        /** @deprecated use [[UrlConfig.type]] */
	        this.type = function (name, definition, definitionFn) {
	            return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
	        };
	    }
	    /**
	     * Creates a [[UrlMatcher]] for the specified pattern.
	     *
	     * @param pattern  The URL pattern.
	     * @param config  The config object hash.
	     * @returns The UrlMatcher.
	     */
	    UrlMatcherFactory.prototype.compile = function (pattern, config) {
	        var urlConfig = this.router.urlService.config;
	        // backward-compatible support for config.params -> config.state.params
	        var params = config && !config.state && config.params;
	        config = params ? __assign({ state: { params: params } }, config) : config;
	        var globalConfig = {
	            strict: urlConfig._isStrictMode,
	            caseInsensitive: urlConfig._isCaseInsensitive,
	            decodeParams: urlConfig._decodeParams,
	        };
	        return new urlMatcher_1.UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, common_1.extend(globalConfig, config));
	    };
	    /**
	     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
	     *
	     * @param object  The object to perform the type check against.
	     * @returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    UrlMatcherFactory.prototype.isMatcher = function (object) {
	        // TODO: typeof?
	        if (!common_1.isObject(object))
	            return false;
	        var result = true;
	        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
	            if (common_1.isFunction(val))
	                result = result && common_1.isDefined(object[name]) && common_1.isFunction(object[name]);
	        });
	        return result;
	    };
	    /** @internal */
	    UrlMatcherFactory.prototype.$get = function () {
	        var urlConfig = this.router.urlService.config;
	        urlConfig.paramTypes.enqueue = false;
	        urlConfig.paramTypes._flushTypeQueue();
	        return this;
	    };
	    return UrlMatcherFactory;
	}());
	exports.UrlMatcherFactory = UrlMatcherFactory;
	//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcher = void 0;
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var predicates_1 = __webpack_require__(354);
	var param_1 = __webpack_require__(365);
	var strings_1 = __webpack_require__(359);
	var common_2 = __webpack_require__(352);
	function quoteRegExp(str, param) {
	    var surroundPattern = ['', ''], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
	    if (!param)
	        return result;
	    switch (param.squash) {
	        case false:
	            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
	            break;
	        case true:
	            result = result.replace(/\/$/, '');
	            surroundPattern = ['(?:/(', ')|/)?'];
	            break;
	        default:
	            surroundPattern = ["(" + param.squash + "|", ')?'];
	            break;
	    }
	    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
	}
	var memoizeTo = function (obj, _prop, fn) { return (obj[_prop] = obj[_prop] || fn()); };
	var splitOnSlash = strings_1.splitOnDelim('/');
	var defaultConfig = {
	    state: { params: {} },
	    strict: true,
	    caseInsensitive: true,
	    decodeParams: true,
	};
	/**
	 * Matches URLs against patterns.
	 *
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL.
	 *
	 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
	 * parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by [[UrlMatcher.exec]].
	 *
	 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
	 * or colon placeholders (`/somePath/:param`).
	 *
	 * - *A parameter RegExp* may be defined for a param after a colon
	 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
	 * The regexp must match for the url to be matched.
	 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
	 *
	 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
	 *   See [[UrlMatcherFactory.type]] for more information.
	 *
	 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
	 *   A catch-all * parameter value will contain the remainder of the URL.
	 *
	 * ---
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters).
	 * A path parameter matches any number of characters other than '/'. For catch-all
	 * placeholders the path parameter matches any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 */
	var UrlMatcher = /** @class */ (function () {
	    /**
	     * @param pattern The pattern to compile into a matcher.
	     * @param paramTypes The [[ParamTypes]] registry
	     * @param paramFactory A [[ParamFactory]] object
	     * @param config  A [[UrlMatcherCompileConfig]] configuration object
	     */
	    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
	        var _this = this;
	        /** @internal */
	        this._cache = { path: [this] };
	        /** @internal */
	        this._children = [];
	        /** @internal */
	        this._params = [];
	        /** @internal */
	        this._segments = [];
	        /** @internal */
	        this._compiled = [];
	        this.config = config = common_2.defaults(config, defaultConfig);
	        this.pattern = pattern;
	        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	        //   '*' name
	        //   ':' name
	        //   '{' name '}'
	        //   '{' name ':' regexp '}'
	        // The regular expression is somewhat complicated due to the need to allow curly braces
	        // inside the regular expression. The placeholder regexp breaks down as follows:
	        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	        //    [^{}\\]+                       - anything other than curly braces or backslash
	        //    \\.                            - a backslash escape
	        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var patterns = [];
	        var last = 0;
	        var matchArray;
	        var checkParamErrors = function (id) {
	            if (!UrlMatcher.nameValidator.test(id))
	                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	            if (common_1.find(_this._params, hof_1.propEq('id', id)))
	                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	        };
	        // Split into static segments separated by path parameter placeholders.
	        // The number of segments is always 1 more than the number of parameters.
	        var matchDetails = function (m, isSearch) {
	            // IE[78] returns '' for unmatched groups instead of null
	            var id = m[2] || m[3];
	            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
	            var makeRegexpType = function (str) {
	                return common_1.inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
	                    pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined),
	                });
	            };
	            return {
	                id: id,
	                regexp: regexp,
	                segment: pattern.substring(last, m.index),
	                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp),
	            };
	        };
	        var details;
	        var segment;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((matchArray = placeholder.exec(pattern))) {
	            details = matchDetails(matchArray, false);
	            if (details.segment.indexOf('?') >= 0)
	                break; // we're into the search part
	            checkParamErrors(details.id);
	            this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
	            this._segments.push(details.segment);
	            patterns.push([details.segment, common_1.tail(this._params)]);
	            last = placeholder.lastIndex;
	        }
	        segment = pattern.substring(last);
	        // Find any search parameter names and remove them from the last segment
	        var i = segment.indexOf('?');
	        if (i >= 0) {
	            var search = segment.substring(i);
	            segment = segment.substring(0, i);
	            if (search.length > 0) {
	                last = 0;
	                // tslint:disable-next-line:no-conditional-assignment
	                while ((matchArray = searchPlaceholder.exec(search))) {
	                    details = matchDetails(matchArray, true);
	                    checkParamErrors(details.id);
	                    this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
	                    last = placeholder.lastIndex;
	                    // check if ?&
	                }
	            }
	        }
	        this._segments.push(segment);
	        this._compiled = patterns.map(function (_pattern) { return quoteRegExp.apply(null, _pattern); }).concat(quoteRegExp(segment));
	    }
	    /** @internal */
	    UrlMatcher.encodeDashes = function (str) {
	        // Replace dashes with encoded "\-"
	        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */
	    UrlMatcher.pathSegmentsAndParams = function (matcher) {
	        var staticSegments = matcher._segments;
	        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
	        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
	            .reduce(common_1.unnestR, [])
	            .filter(function (x) { return x !== '' && predicates_1.isDefined(x); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's query params */
	    UrlMatcher.queryParams = function (matcher) {
	        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
	    };
	    /**
	     * Compare two UrlMatchers
	     *
	     * This comparison function converts a UrlMatcher into static and dynamic path segments.
	     * Each static path segment is a static string between a path separator (slash character).
	     * Each dynamic segment is a path parameter.
	     *
	     * The comparison function sorts static segments before dynamic ones.
	     */
	    UrlMatcher.compare = function (a, b) {
	        /**
	         * Turn a UrlMatcher and all its parent matchers into an array
	         * of slash literals '/', string literals, and Param objects
	         *
	         * This example matcher matches strings like "/foo/:param/tail":
	         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
	         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
	         *
	         * Caches the result as `matcher._cache.segments`
	         */
	        var segments = function (matcher) {
	            return (matcher._cache.segments =
	                matcher._cache.segments ||
	                    matcher._cache.path
	                        .map(UrlMatcher.pathSegmentsAndParams)
	                        .reduce(common_1.unnestR, [])
	                        .reduce(strings_1.joinNeighborsR, [])
	                        .map(function (x) { return (predicates_1.isString(x) ? splitOnSlash(x) : x); })
	                        .reduce(common_1.unnestR, []));
	        };
	        /**
	         * Gets the sort weight for each segment of a UrlMatcher
	         *
	         * Caches the result as `matcher._cache.weights`
	         */
	        var weights = function (matcher) {
	            return (matcher._cache.weights =
	                matcher._cache.weights ||
	                    segments(matcher).map(function (segment) {
	                        // Sort slashes first, then static strings, the Params
	                        if (segment === '/')
	                            return 1;
	                        if (predicates_1.isString(segment))
	                            return 2;
	                        if (segment instanceof param_1.Param)
	                            return 3;
	                    }));
	        };
	        /**
	         * Pads shorter array in-place (mutates)
	         */
	        var padArrays = function (l, r, padVal) {
	            var len = Math.max(l.length, r.length);
	            while (l.length < len)
	                l.push(padVal);
	            while (r.length < len)
	                r.push(padVal);
	        };
	        var weightsA = weights(a), weightsB = weights(b);
	        padArrays(weightsA, weightsB, 0);
	        var _pairs = common_1.arrayTuples(weightsA, weightsB);
	        var cmp, i;
	        for (i = 0; i < _pairs.length; i++) {
	            cmp = _pairs[i][0] - _pairs[i][1];
	            if (cmp !== 0)
	                return cmp;
	        }
	        return 0;
	    };
	    /**
	     * Creates a new concatenated UrlMatcher
	     *
	     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
	     *
	     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
	     */
	    UrlMatcher.prototype.append = function (url) {
	        this._children.push(url);
	        url._cache = {
	            path: this._cache.path.concat(url),
	            parent: this,
	            pattern: null,
	        };
	        return url;
	    };
	    /** @internal */
	    UrlMatcher.prototype.isRoot = function () {
	        return this._cache.path[0] === this;
	    };
	    /** Returns the input pattern string */
	    UrlMatcher.prototype.toString = function () {
	        return this.pattern;
	    };
	    UrlMatcher.prototype._getDecodedParamValue = function (value, param) {
	        if (predicates_1.isDefined(value)) {
	            if (this.config.decodeParams && !param.type.raw && !predicates_1.isArray(value)) {
	                value = decodeURIComponent(value);
	            }
	            value = param.type.decode(value);
	        }
	        return param.value(value);
	    };
	    /**
	     * Tests the specified url/path against this matcher.
	     *
	     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
	     * parameter values.  Returns null if the path does not match.
	     *
	     * The returned object contains the values
	     * of any search parameters that are mentioned in the pattern, but their value may be null if
	     * they are not present in `search`. This means that search parameters are always treated
	     * as optional.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	     *   x: '1', q: 'hello'
	     * });
	     * // returns { id: 'bob', q: 'hello', r: null }
	     * ```
	     *
	     * @param path    The URL path to match, e.g. `$location.path()`.
	     * @param search  URL search parameters, e.g. `$location.search()`.
	     * @param hash    URL hash e.g. `$location.hash()`.
	     * @param options
	     *
	     * @returns The captured parameter values.
	     */
	    UrlMatcher.prototype.exec = function (path, search, hash, options) {
	        var _this = this;
	        if (search === void 0) { search = {}; }
	        if (options === void 0) { options = {}; }
	        var match = memoizeTo(this._cache, 'pattern', function () {
	            return new RegExp([
	                '^',
	                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
	                _this.config.strict === false ? '/?' : '',
	                '$',
	            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
	        }).exec(path);
	        if (!match)
	            return null;
	        // options = defaults(options, { isolate: false });
	        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
	        if (nPathSegments !== match.length - 1)
	            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
	        function decodePathArray(paramVal) {
	            var reverseString = function (str) { return str.split('').reverse().join(''); };
	            var unquoteDashes = function (str) { return str.replace(/\\-/g, '-'); };
	            var split = reverseString(paramVal).split(/-(?!\\)/);
	            var allReversed = common_1.map(split, reverseString);
	            return common_1.map(allReversed, unquoteDashes).reverse();
	        }
	        for (var i = 0; i < nPathSegments; i++) {
	            var param = pathParams[i];
	            var value = match[i + 1];
	            // if the param value matches a pre-replace pair, replace the value before decoding.
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (value && param.array === true)
	                value = decodePathArray(value);
	            values[param.id] = this._getDecodedParamValue(value, param);
	        }
	        searchParams.forEach(function (param) {
	            var value = search[param.id];
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            values[param.id] = _this._getDecodedParamValue(value, param);
	        });
	        if (hash)
	            values['#'] = hash;
	        return values;
	    };
	    /**
	     * @internal
	     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
	     *
	     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
	     *    pattern has no parameters, an empty array is returned.
	     */
	    UrlMatcher.prototype.parameters = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        if (opts.inherit === false)
	            return this._params;
	        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
	    };
	    /**
	     * @internal
	     * Returns a single parameter from this UrlMatcher by id
	     *
	     * @param id
	     * @param opts
	     * @returns {T|Param|any|boolean|UrlMatcher|null}
	     */
	    UrlMatcher.prototype.parameter = function (id, opts) {
	        var _this = this;
	        if (opts === void 0) { opts = {}; }
	        var findParam = function () {
	            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
	                var param = _a[_i];
	                if (param.id === id)
	                    return param;
	            }
	        };
	        var parent = this._cache.parent;
	        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
	    };
	    /**
	     * Validates the input parameter values against this UrlMatcher
	     *
	     * Checks an object hash of parameters to validate their correctness according to the parameter
	     * types of this `UrlMatcher`.
	     *
	     * @param params The object hash of parameters to validate.
	     * @returns Returns `true` if `params` validates, otherwise `false`.
	     */
	    UrlMatcher.prototype.validates = function (params) {
	        var validParamVal = function (param, val) { return !param || param.validates(val); };
	        params = params || {};
	        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
	        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
	        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
	    };
	    /**
	     * Given a set of parameter values, creates a URL from this UrlMatcher.
	     *
	     * Creates a URL that matches this pattern by substituting the specified values
	     * for the path and search parameters.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	     * // returns '/user/bob?q=yes'
	     * ```
	     *
	     * @param values  the values to substitute for the parameters in this pattern.
	     * @returns the formatted URL (path and optionally search part).
	     */
	    UrlMatcher.prototype.format = function (values) {
	        if (values === void 0) { values = {}; }
	        // Build the full path of UrlMatchers (including all parent UrlMatchers)
	        var urlMatchers = this._cache.path;
	        // Extract all the static segments and Params (processed as ParamDetails)
	        // into an ordered array
	        var pathSegmentsAndParams = urlMatchers
	            .map(UrlMatcher.pathSegmentsAndParams)
	            .reduce(common_1.unnestR, [])
	            .map(function (x) { return (predicates_1.isString(x) ? x : getDetails(x)); });
	        // Extract the query params into a separate array
	        var queryParams = urlMatchers
	            .map(UrlMatcher.queryParams)
	            .reduce(common_1.unnestR, [])
	            .map(getDetails);
	        var isInvalid = function (param) { return param.isValid === false; };
	        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
	            return null;
	        }
	        /**
	         * Given a Param, applies the parameter value, then returns detailed information about it
	         */
	        function getDetails(param) {
	            // Normalize to typed value
	            var value = param.value(values[param.id]);
	            var isValid = param.validates(value);
	            var isDefaultValue = param.isDefaultValue(value);
	            // Check if we're in squash mode for the parameter
	            var squash = isDefaultValue ? param.squash : false;
	            // Allow the Parameter's Type to encode the value
	            var encoded = param.type.encode(value);
	            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
	        }
	        // Build up the path-portion from the list of static segments and parameters
	        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
	            // The element is a static segment (a raw string); just append it
	            if (predicates_1.isString(x))
	                return acc + x;
	            // Otherwise, it's a ParamDetails.
	            var squash = x.squash, encoded = x.encoded, param = x.param;
	            // If squash is === true, try to remove a slash from the path
	            if (squash === true)
	                return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
	            // If squash is a string, use the string for the param value
	            if (predicates_1.isString(squash))
	                return acc + squash;
	            if (squash !== false)
	                return acc; // ?
	            if (encoded == null)
	                return acc;
	            // If this parameter value is an array, encode the value using encodeDashes
	            if (predicates_1.isArray(encoded))
	                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join('-');
	            // If the parameter type is "raw", then do not encodeURIComponent
	            if (param.raw)
	                return acc + encoded;
	            // Encode the value
	            return acc + encodeURIComponent(encoded);
	        }, '');
	        // Build the query string by applying parameter values (array or regular)
	        // then mapping to key=value, then flattening and joining using "&"
	        var queryString = queryParams
	            .map(function (paramDetails) {
	            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
	            if (encoded == null || (isDefaultValue && squash !== false))
	                return;
	            if (!predicates_1.isArray(encoded))
	                encoded = [encoded];
	            if (encoded.length === 0)
	                return;
	            if (!param.raw)
	                encoded = common_1.map(encoded, encodeURIComponent);
	            return encoded.map(function (val) { return param.id + "=" + val; });
	        })
	            .filter(common_1.identity)
	            .reduce(common_1.unnestR, [])
	            .join('&');
	        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
	        return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
	    };
	    /** @internal */
	    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
	    return UrlMatcher;
	}());
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRouter = void 0;
	var common_1 = __webpack_require__(352);
	var urlRule_1 = __webpack_require__(396);
	function appendBasePath(url, isHtml5, absolute, baseHref) {
	    if (baseHref === '/')
	        return url;
	    if (isHtml5)
	        return common_1.stripLastPathElement(baseHref) + url;
	    if (absolute)
	        return baseHref.slice(1) + url;
	    return url;
	}
	/**
	 * Updates URL and responds to URL changes
	 *
	 * ### Deprecation warning:
	 * This class is now considered to be an internal API
	 * Use the [[UrlService]] instead.
	 * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
	 */
	var UrlRouter = /** @class */ (function () {
	    /** @internal */
	    function UrlRouter(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        // Delegate these calls to [[UrlService]]
	        /** @deprecated use [[UrlService.sync]]*/
	        this.sync = function (evt) { return _this.router.urlService.sync(evt); };
	        /** @deprecated use [[UrlService.listen]]*/
	        this.listen = function (enabled) { return _this.router.urlService.listen(enabled); };
	        /** @deprecated use [[UrlService.deferIntercept]]*/
	        this.deferIntercept = function (defer) { return _this.router.urlService.deferIntercept(defer); };
	        /** @deprecated use [[UrlService.match]]*/
	        this.match = function (urlParts) { return _this.router.urlService.match(urlParts); };
	        // Delegate these calls to [[UrlRules]]
	        /** @deprecated use [[UrlRules.initial]]*/
	        this.initial = function (handler) {
	            return _this.router.urlService.rules.initial(handler);
	        };
	        /** @deprecated use [[UrlRules.otherwise]]*/
	        this.otherwise = function (handler) {
	            return _this.router.urlService.rules.otherwise(handler);
	        };
	        /** @deprecated use [[UrlRules.removeRule]]*/
	        this.removeRule = function (rule) { return _this.router.urlService.rules.removeRule(rule); };
	        /** @deprecated use [[UrlRules.rule]]*/
	        this.rule = function (rule) { return _this.router.urlService.rules.rule(rule); };
	        /** @deprecated use [[UrlRules.rules]]*/
	        this.rules = function () { return _this.router.urlService.rules.rules(); };
	        /** @deprecated use [[UrlRules.sort]]*/
	        this.sort = function (compareFn) { return _this.router.urlService.rules.sort(compareFn); };
	        /** @deprecated use [[UrlRules.when]]*/
	        this.when = function (matcher, handler, options) { return _this.router.urlService.rules.when(matcher, handler, options); };
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** Internal API. */
	    UrlRouter.prototype.update = function (read) {
	        var $url = this.router.locationService;
	        if (read) {
	            this.location = $url.url();
	            return;
	        }
	        if ($url.url() === this.location)
	            return;
	        $url.url(this.location, true);
	    };
	    /**
	     * Internal API.
	     *
	     * Pushes a new location to the browser history.
	     *
	     * @internal
	     * @param urlMatcher
	     * @param params
	     * @param options
	     */
	    UrlRouter.prototype.push = function (urlMatcher, params, options) {
	        var replace = options && !!options.replace;
	        this.router.urlService.url(urlMatcher.format(params || {}), replace);
	    };
	    /**
	     * Builds and returns a URL with interpolated parameters
	     *
	     * #### Example:
	     * ```js
	     * matcher = $umf.compile("/about/:person");
	     * params = { person: "bob" };
	     * $bob = $urlRouter.href(matcher, params);
	     * // $bob == "/about/bob";
	     * ```
	     *
	     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
	     * @param params An object of parameter values to fill the matcher's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	     */
	    UrlRouter.prototype.href = function (urlMatcher, params, options) {
	        var url = urlMatcher.format(params);
	        if (url == null)
	            return null;
	        options = options || { absolute: false };
	        var cfg = this.router.urlService.config;
	        var isHtml5 = cfg.html5Mode();
	        if (!isHtml5 && url !== null) {
	            url = '#' + cfg.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
	        if (!options.absolute || !url) {
	            return url;
	        }
	        var slash = !isHtml5 && url ? '/' : '';
	        var cfgPort = cfg.port();
	        var port = (cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort);
	        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
	    };
	    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
	        /** @deprecated use [[UrlService.interceptDeferred]]*/
	        get: function () {
	            return this.router.urlService.interceptDeferred;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return UrlRouter;
	}());
	exports.UrlRouter = UrlRouter;
	//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseUrlRule = exports.UrlRuleFactory = void 0;
	var urlMatcher_1 = __webpack_require__(394);
	var predicates_1 = __webpack_require__(354);
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var stateObject_1 = __webpack_require__(380);
	/**
	 * Creates a [[UrlRule]]
	 *
	 * Creates a [[UrlRule]] from a:
	 *
	 * - `string`
	 * - [[UrlMatcher]]
	 * - `RegExp`
	 * - [[StateObject]]
	 */
	var UrlRuleFactory = /** @class */ (function () {
	    function UrlRuleFactory(router) {
	        this.router = router;
	    }
	    UrlRuleFactory.prototype.compile = function (str) {
	        return this.router.urlMatcherFactory.compile(str);
	    };
	    UrlRuleFactory.prototype.create = function (what, handler) {
	        var _this = this;
	        var isState = stateObject_1.StateObject.isState, isStateDeclaration = stateObject_1.StateObject.isStateDeclaration;
	        var makeRule = hof_1.pattern([
	            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
	            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
	            [hof_1.or(isState, isStateDeclaration), function (_what) { return _this.fromState(_what, _this.router); }],
	            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
	            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
	        ]);
	        var rule = makeRule(what);
	        if (!rule)
	            throw new Error("invalid 'what' in when()");
	        return rule;
	    };
	    /**
	     * A UrlRule which matches based on a UrlMatcher
	     *
	     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     *
	     * ## Handler as UrlMatcher
	     *
	     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
	     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
	     * The url is replaced with the result.
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var handler = $umf.compile("/home/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
	        var _handler = handler;
	        if (predicates_1.isString(handler))
	            handler = this.router.urlMatcherFactory.compile(handler);
	        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
	            _handler = function (match) { return handler.format(match); };
	        function matchUrlParamters(url) {
	            var params = urlMatcher.exec(url.path, url.search, url.hash);
	            return urlMatcher.validates(params) && params;
	        }
	        // Prioritize URLs, lowest to highest:
	        // - Some optional URL parameters, but none matched
	        // - No optional parameters in URL
	        // - Some optional parameters, some matched
	        // - Some optional parameters, all matched
	        function matchPriority(params) {
	            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
	            if (!optional.length)
	                return 0.000001;
	            var matched = optional.filter(function (param) { return params[param.id]; });
	            return matched.length / optional.length;
	        }
	        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: 'URLMATCHER' };
	        return common_1.extend(new BaseUrlRule(matchUrlParamters, _handler), details);
	    };
	    /**
	     * A UrlRule which matches a state by its url
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromState($state.get('foo'), router);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match);
	     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
	     * ```
	     */
	    UrlRuleFactory.prototype.fromState = function (stateOrDecl, router) {
	        var state = stateObject_1.StateObject.isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
	        /**
	         * Handles match by transitioning to matched state
	         *
	         * First checks if the router should start a new transition.
	         * A new transition is not required if the current state's URL
	         * and the new URL are already identical
	         */
	        var handler = function (match) {
	            var $state = router.stateService;
	            var globals = router.globals;
	            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
	                $state.transitionTo(state, match, { inherit: true, source: 'url' });
	            }
	        };
	        var details = { state: state, type: 'STATE' };
	        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
	    };
	    /**
	     * A UrlRule which matches based on a regular expression
	     *
	     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - regexp match array (from `regexp`)
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     *
	     * ## Handler as string
	     *
	     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
	     * The string is first interpolated using `string.replace()` style pattern.
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
	        if (regexp.global || regexp.sticky)
	            throw new Error('Rule RegExp must not be global or sticky');
	        /**
	         * If handler is a string, the url will be replaced by the string.
	         * If the string has any String.replace() style variables in it (like `$2`),
	         * they will be replaced by the captures from [[match]]
	         */
	        var redirectUrlTo = function (match) {
	            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
	            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) { return match[what === '$' ? 0 : Number(what)]; });
	        };
	        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
	        var matchParamsFromRegexp = function (url) { return regexp.exec(url.path); };
	        var details = { regexp: regexp, type: 'REGEXP' };
	        return common_1.extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
	    };
	    UrlRuleFactory.isUrlRule = function (obj) { return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); }); };
	    return UrlRuleFactory;
	}());
	exports.UrlRuleFactory = UrlRuleFactory;
	/**
	 * A base rule which calls `match`
	 *
	 * The value from the `match` function is passed through to the `handler`.
	 * @internal
	 */
	var BaseUrlRule = /** @class */ (function () {
	    function BaseUrlRule(match, handler) {
	        var _this = this;
	        this.match = match;
	        this.type = 'RAW';
	        this.matchPriority = function (match) { return 0 - _this.$id; };
	        this.handler = handler || common_1.identity;
	    }
	    return BaseUrlRule;
	}());
	exports.BaseUrlRule = BaseUrlRule;
	//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ViewService = void 0;
	var common_1 = __webpack_require__(353);
	var hof_1 = __webpack_require__(355);
	var predicates_1 = __webpack_require__(354);
	var trace_1 = __webpack_require__(361);
	/**
	 * The View service
	 *
	 * This service pairs existing `ui-view` components (which live in the DOM)
	 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
	 *
	 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
	 *   The views from exited states are deactivated via [[deactivateViewConfig]].
	 *   (See: the [[registerActivateViews]] Transition Hook)
	 *
	 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
	 *
	 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
	 * are configured with the matching [[ViewConfig]](s)
	 *
	 */
	var ViewService = /** @class */ (function () {
	    /** @internal */
	    function ViewService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this._uiViews = [];
	        /** @internal */ this._viewConfigs = [];
	        /** @internal */ this._viewConfigFactories = {};
	        /** @internal */ this._listeners = [];
	        /** @internal */
	        this._pluginapi = {
	            _rootViewContext: this._rootViewContext.bind(this),
	            _viewConfigFactory: this._viewConfigFactory.bind(this),
	            _registeredUIView: function (id) { return common_1.find(_this._uiViews, function (view) { return _this.router.$id + "." + view.id === id; }); },
	            _registeredUIViews: function () { return _this._uiViews; },
	            _activeViewConfigs: function () { return _this._viewConfigs; },
	            _onSync: function (listener) {
	                _this._listeners.push(listener);
	                return function () { return common_1.removeFrom(_this._listeners, listener); };
	            },
	        };
	    }
	    /**
	     * Normalizes a view's name from a state.views configuration block.
	     *
	     * This should be used by a framework implementation to calculate the values for
	     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
	     *
	     * @param context the context object (state declaration) that the view belongs to
	     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
	     *
	     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
	     */
	    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
	        if (rawViewName === void 0) { rawViewName = ''; }
	        // TODO: Validate incoming view name with a regexp to allow:
	        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
	        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
	        var viewAtContext = rawViewName.split('@');
	        var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
	        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
	        // Handle relative view-name sugar syntax.
	        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
	        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
	        if (relativeViewNameSugar) {
	            // Clobbers existing contextAnchor (rawViewName validation will fix this)
	            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
	            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
	        }
	        if (uiViewName.charAt(0) === '!') {
	            uiViewName = uiViewName.substr(1);
	            uiViewContextAnchor = ''; // target absolutely from root
	        }
	        // handle parent relative targeting "^.^.^"
	        var relativeMatch = /^(\^(?:\.\^)*)$/;
	        if (relativeMatch.exec(uiViewContextAnchor)) {
	            var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) { return anchor.parent; }, context);
	            uiViewContextAnchor = anchorState.name;
	        }
	        else if (uiViewContextAnchor === '.') {
	            uiViewContextAnchor = context.name;
	        }
	        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
	    };
	    /** @internal */
	    ViewService.prototype._rootViewContext = function (context) {
	        return (this._rootContext = context || this._rootContext);
	    };
	    /** @internal */
	    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
	        this._viewConfigFactories[viewType] = factory;
	    };
	    ViewService.prototype.createViewConfig = function (path, decl) {
	        var cfgFactory = this._viewConfigFactories[decl.$type];
	        if (!cfgFactory)
	            throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
	        var cfgs = cfgFactory(path, decl);
	        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
	    };
	    /**
	     * Deactivates a ViewConfig.
	     *
	     * This function deactivates a `ViewConfig`.
	     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
	     *
	     * @param viewConfig The ViewConfig view to deregister.
	     */
	    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('<- Removing', viewConfig);
	        common_1.removeFrom(this._viewConfigs, viewConfig);
	    };
	    ViewService.prototype.activateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('-> Registering', viewConfig);
	        this._viewConfigs.push(viewConfig);
	    };
	    ViewService.prototype.sync = function () {
	        var _this = this;
	        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
	        // Return a weighted depth value for a uiView.
	        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
	        // plus the depth of the state that is populating the uiView
	        function uiViewDepth(uiView) {
	            var stateDepth = function (context) { return (context && context.parent ? stateDepth(context.parent) + 1 : 1); };
	            return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
	        }
	        // Return the ViewConfig's context's depth in the context tree.
	        function viewConfigDepth(config) {
	            var context = config.viewDecl.$context, count = 0;
	            while (++count && context.parent)
	                context = context.parent;
	            return count;
	        }
	        // Given a depth function, returns a compare function which can return either ascending or descending order
	        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
	        var matchingConfigPair = function (uiView) {
	            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
	            if (matchingConfigs.length > 1) {
	                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
	                // Sort by depth and return the match from the deepest child
	                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
	                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
	            }
	            return { uiView: uiView, viewConfig: matchingConfigs[0] };
	        };
	        var configureUIView = function (tuple) {
	            // If a parent ui-view is reconfigured, it could destroy child ui-views.
	            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
	            if (_this._uiViews.indexOf(tuple.uiView) !== -1)
	                tuple.uiView.configUpdated(tuple.viewConfig);
	        };
	        // Sort views by FQN and state depth. Process uiviews nearest the root first.
	        var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
	        var matchedViewConfigs = uiViewTuples.map(function (tuple) { return tuple.viewConfig; });
	        var unmatchedConfigTuples = this._viewConfigs
	            .filter(function (config) { return !common_1.inArray(matchedViewConfigs, config); })
	            .map(function (viewConfig) { return ({ uiView: undefined, viewConfig: viewConfig }); });
	        uiViewTuples.forEach(configureUIView);
	        var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
	        this._listeners.forEach(function (cb) { return cb(allTuples); });
	        trace_1.trace.traceViewSync(allTuples);
	    };
	    /**
	     * Registers a `ui-view` component
	     *
	     * When a `ui-view` component is created, it uses this method to register itself.
	     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
	     *
	     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
	     * and what the view's state context is.
	     *
	     * Note: There is no corresponding `deregisterUIView`.
	     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
	     *
	     * @param uiView The metadata for a UIView
	     * @return a de-registration function used when the view is destroyed.
	     */
	    ViewService.prototype.registerUIView = function (uiView) {
	        trace_1.trace.traceViewServiceUIViewEvent('-> Registering', uiView);
	        var uiViews = this._uiViews;
	        var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
	        if (uiViews.filter(fqnAndTypeMatches).length)
	            trace_1.trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
	        uiViews.push(uiView);
	        this.sync();
	        return function () {
	            var idx = uiViews.indexOf(uiView);
	            if (idx === -1) {
	                trace_1.trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
	                return;
	            }
	            trace_1.trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
	            common_1.removeFrom(uiViews)(uiView);
	        };
	    };
	    /**
	     * Returns the list of views currently available on the page, by fully-qualified name.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.available = function () {
	        return this._uiViews.map(hof_1.prop('fqn'));
	    };
	    /**
	     * Returns the list of views on the page containing loaded content.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.active = function () {
	        return this._uiViews.filter(hof_1.prop('$config')).map(hof_1.prop('name'));
	    };
	    /**
	     * Given a ui-view and a ViewConfig, determines if they "match".
	     *
	     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
	     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
	     *
	     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
	     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
	     *
	     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
	     *
	     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
	     * - the ui-view's name matches the ViewConfig's target name
	     * - the ui-view's context matches the ViewConfig's anchor
	     *
	     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
	     * - There exists a parent ui-view where:
	     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
	     *    - the parent ui-view's context matches the ViewConfig's anchor
	     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
	     *
	     * Example:
	     *
	     * DOM:
	     * <ui-view>                        <!-- created in the root context (name: "") -->
	     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
	     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
	     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
	     *       </ui-view>
	     *     </ui-view>
	     *   </ui-view>
	     * </ui-view>
	     *
	     * uiViews: [
	     *  { fqn: "$default",                  creationContext: { name: "" } },
	     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
	     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
	     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
	     * ]
	     *
	     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
	     *
	     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
	     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
	     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
	     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
	     *
	     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
	     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
	     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
	     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
	     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
	     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
	     *   the tail of the ui-view's fqn "default.bar"
	     *
	     * @internal
	     */
	    ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
	        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
	        if (uiView.$type !== viewConfig.viewDecl.$type)
	            return false;
	        // Split names apart from both viewConfig and uiView into segments
	        var vc = viewConfig.viewDecl;
	        var vcSegments = vc.$uiViewName.split('.');
	        var uivSegments = uiView.fqn.split('.');
	        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
	        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
	        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
	            return false;
	        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
	        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
	        var negOffset = 1 - vcSegments.length || undefined;
	        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
	        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
	        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
	    }; };
	    return ViewService;
	}());
	exports.ViewService = ViewService;
	//# sourceMappingURL=view.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterGlobals = void 0;
	var stateParams_1 = __webpack_require__(368);
	var queue_1 = __webpack_require__(358);
	/**
	 * Global router state
	 *
	 * This is where we hold the global mutable state such as current state, current
	 * params, current transition, etc.
	 */
	var UIRouterGlobals = /** @class */ (function () {
	    function UIRouterGlobals() {
	        /**
	         * Current parameter values
	         *
	         * The parameter values from the latest successful transition
	         */
	        this.params = new stateParams_1.StateParams();
	        /** @internal */
	        this.lastStartedTransitionId = -1;
	        /** @internal */
	        this.transitionHistory = new queue_1.Queue([], 1);
	        /** @internal */
	        this.successfulTransitions = new queue_1.Queue([], 1);
	    }
	    UIRouterGlobals.prototype.dispose = function () {
	        this.transitionHistory.clear();
	        this.successfulTransitions.clear();
	        this.transition = null;
	    };
	    return UIRouterGlobals;
	}());
	exports.UIRouterGlobals = UIRouterGlobals;
	//# sourceMappingURL=globals.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlService = void 0;
	var common_1 = __webpack_require__(352);
	var urlRules_1 = __webpack_require__(400);
	var urlConfig_1 = __webpack_require__(401);
	var state_1 = __webpack_require__(377);
	/**
	 * API for URL management
	 */
	var UrlService = /** @class */ (function () {
	    /** @internal */
	    function UrlService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.interceptDeferred = false;
	        /**
	         * The nested [[UrlRules]] API for managing URL rules and rewrites
	         *
	         * See: [[UrlRules]] for details
	         */
	        this.rules = new urlRules_1.UrlRules(this.router);
	        /**
	         * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
	         *
	         * See: [[UrlConfig]] for details
	         */
	        this.config = new urlConfig_1.UrlConfig(this.router);
	        // Delegate these calls to the current LocationServices implementation
	        /**
	         * Gets the current url, or updates the url
	         *
	         * ### Getting the current URL
	         *
	         * When no arguments are passed, returns the current URL.
	         * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
	         *
	         * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
	         * have a base HREF prepended ([[PushStateLocationServices]]).
	         *
	         * The raw URL in the browser might be:
	         *
	         * ```
	         * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * or
	         *
	         * ```
	         * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * then this method returns:
	         *
	         * ```
	         * /internal/path/123?param1=foo#anchor
	         * ```
	         *
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url(); // "/some/path?query=value#anchor"
	         * ```
	         *
	         * ### Updating the URL
	         *
	         * When `newurl` arguments is provided, changes the URL to reflect `newurl`
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url("/some/path?query=value#anchor", true);
	         * ```
	         *
	         * @param newurl The new value for the URL.
	         *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
	         *               It should not include the protocol, site, port, or base path of an absolute HREF.
	         * @param replace When true, replaces the current history entry (instead of appending it) with this new url
	         * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
	         *
	         * @return the url (after potentially being processed)
	         */
	        this.url = function (newurl, replace, state) {
	            return _this.router.locationService.url(newurl, replace, state);
	        };
	        /**
	         * Gets the path part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
	         *
	         * @return the path portion of the url
	         */
	        this.path = function () { return _this.router.locationService.path(); };
	        /**
	         * Gets the search part of the current url as an object
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
	         *
	         * @return the search (query) portion of the url, as an object
	         */
	        this.search = function () { return _this.router.locationService.search(); };
	        /**
	         * Gets the hash part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
	         *
	         * @return the hash (anchor) portion of the url
	         */
	        this.hash = function () { return _this.router.locationService.hash(); };
	        /**
	         * @internal
	         *
	         * Registers a low level url change handler
	         *
	         * Note: Because this is a low level handler, it's not recommended for general use.
	         *
	         * #### Example:
	         * ```js
	         * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
	         * ```
	         *
	         * @param callback a function that will be called when the url is changing
	         * @return a function that de-registers the callback
	         */
	        this.onChange = function (callback) { return _this.router.locationService.onChange(callback); };
	    }
	    /** @internal */
	    UrlService.prototype.dispose = function () {
	        this.listen(false);
	        this.rules.dispose();
	    };
	    /**
	     * Gets the current URL parts
	     *
	     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
	     */
	    UrlService.prototype.parts = function () {
	        return { path: this.path(), search: this.search(), hash: this.hash() };
	    };
	    /**
	     * Activates the best rule for the current URL
	     *
	     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
	     * This method is called internally any time the URL has changed.
	     *
	     * This effectively activates the state (or redirect, etc) which matches the current URL.
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   // Find the matching URL and invoke the handler.
	     *   urlService.sync();
	     * });
	     * ```
	     */
	    UrlService.prototype.sync = function (evt) {
	        if (evt && evt.defaultPrevented)
	            return;
	        var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
	        var url = { path: urlService.path(), search: urlService.search(), hash: urlService.hash() };
	        var best = this.match(url);
	        var applyResult = common_1.pattern([
	            [common_1.isString, function (newurl) { return urlService.url(newurl, true); }],
	            [state_1.TargetState.isDef, function (def) { return stateService.go(def.state, def.params, def.options); }],
	            [common_1.is(state_1.TargetState), function (target) { return stateService.go(target.state(), target.params(), target.options()); }],
	        ]);
	        applyResult(best && best.rule.handler(best.match, url, this.router));
	    };
	    /**
	     * Starts or stops listening for URL changes
	     *
	     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
	     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
	     *
	     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   // Start responding to URL changes
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param enabled `true` or `false` to start or stop listening to URL changes
	     */
	    UrlService.prototype.listen = function (enabled) {
	        var _this = this;
	        if (enabled === false) {
	            this._stopListeningFn && this._stopListeningFn();
	            delete this._stopListeningFn;
	        }
	        else {
	            return (this._stopListeningFn =
	                this._stopListeningFn || this.router.urlService.onChange(function (evt) { return _this.sync(evt); }));
	        }
	    };
	    /**
	     * Disables monitoring of the URL.
	     *
	     * Call this method before UI-Router has bootstrapped.
	     * It will stop UI-Router from performing the initial url sync.
	     *
	     * This can be useful to perform some asynchronous initialization before the router starts.
	     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	     *
	     * #### Example:
	     * ```js
	     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param defer Indicates whether to defer location change interception.
	     *        Passing no parameter is equivalent to `true`.
	     */
	    UrlService.prototype.deferIntercept = function (defer) {
	        if (defer === undefined)
	            defer = true;
	        this.interceptDeferred = defer;
	    };
	    /**
	     * Matches a URL
	     *
	     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
	     * Return the result as a [[MatchResult]].
	     */
	    UrlService.prototype.match = function (url) {
	        var _this = this;
	        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
	        var rules = this.rules.rules();
	        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
	        var checkRule = function (rule) {
	            var match = rule.match(url, _this.router);
	            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
	        };
	        // The rules are pre-sorted.
	        // - Find the first matching rule.
	        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
	        // - Choose the rule with the highest match weight.
	        var best;
	        for (var i = 0; i < rules.length; i++) {
	            // Stop when there is a 'best' rule and the next rule sorts differently than it.
	            if (best && best.rule._group !== rules[i]._group)
	                break;
	            var current = checkRule(rules[i]);
	            // Pick the best MatchResult
	            best = !best || (current && current.weight > best.weight) ? current : best;
	        }
	        return best;
	    };
	    return UrlService;
	}());
	exports.UrlService = UrlService;
	//# sourceMappingURL=urlService.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRules = void 0;
	var state_1 = __webpack_require__(377);
	var urlMatcher_1 = __webpack_require__(394);
	var common_1 = __webpack_require__(352);
	var urlRule_1 = __webpack_require__(396);
	var prioritySort = function (a, b) { return (b.priority || 0) - (a.priority || 0); };
	var typeSort = function (a, b) {
	    var weights = { STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1 };
	    return (weights[a.type] || 0) - (weights[b.type] || 0);
	};
	var urlMatcherSort = function (a, b) {
	    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
	};
	var idSort = function (a, b) {
	    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
	    var useMatchPriority = { STATE: true, URLMATCHER: true };
	    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
	    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
	};
	/**
	 * Default rule priority sorting function.
	 *
	 * Sorts rules by:
	 *
	 * - Explicit priority (set rule priority using [[UrlRules.when]])
	 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
	 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
	 * - Rule registration order (for rule types other than STATE and URLMATCHER)
	 *   - Equally sorted State and UrlMatcher rules will each match the URL.
	 *     Then, the *best* match is chosen based on how many parameter values were matched.
	 */
	var defaultRuleSortFn;
	defaultRuleSortFn = function (a, b) {
	    var cmp = prioritySort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = typeSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = urlMatcherSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    return idSort(a, b);
	};
	function getHandlerFn(handler) {
	    if (!common_1.isFunction(handler) && !common_1.isString(handler) && !common_1.is(state_1.TargetState)(handler) && !state_1.TargetState.isDef(handler)) {
	        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
	    }
	    return common_1.isFunction(handler) ? handler : common_1.val(handler);
	}
	/**
	 * API for managing URL rules
	 *
	 * This API is used to create and manage URL rules.
	 * URL rules are a mechanism to respond to specific URL patterns.
	 *
	 * The most commonly used methods are [[otherwise]] and [[when]].
	 *
	 * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
	 */
	var UrlRules = /** @class */ (function () {
	    /** @internal */
	    function UrlRules(/** @internal */ router) {
	        this.router = router;
	        /** @internal */ this._sortFn = defaultRuleSortFn;
	        /** @internal */ this._rules = [];
	        /** @internal */ this._id = 0;
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** @internal */
	    UrlRules.prototype.dispose = function (router) {
	        this._rules = [];
	        delete this._otherwiseFn;
	    };
	    /**
	     * Defines the initial state, path, or behavior to use when the app starts.
	     *
	     * This rule defines the initial/starting state for the application.
	     *
	     * This rule is triggered the first time the URL is checked (when the app initially loads).
	     * The rule is triggered only when the url matches either `""` or `"/"`.
	     *
	     * Note: The rule is intended to be used when the root of the application is directly linked to.
	     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
	     * This allows 404-like behavior when an unknown URL is deep-linked.
	     *
	     * #### Example:
	     * Start app at `home` state.
	     * ```js
	     * .initial({ state: 'home' });
	     * ```
	     *
	     * #### Example:
	     * Start app at `/home` (by url)
	     * ```js
	     * .initial('/home');
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .initial((matchValue, url, router) => {
	     *   console.log('initial state');
	     *   return { state: 'home' };
	     * })
	     * ```
	     *
	     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
	     */
	    UrlRules.prototype.initial = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        var matchFn = function (urlParts, router) {
	            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
	        };
	        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
	    };
	    /**
	     * Defines the state, url, or behavior to use when no other rule matches the URL.
	     *
	     * This rule is matched when *no other rule* matches.
	     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
	     *
	     * - If `handler` a string, it is treated as a url redirect
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `/index`
	     * ```js
	     * .otherwise('/index');
	     * ```
	     *
	     * - If `handler` is an object with a `state` property, the state is activated.
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
	     * ```js
	     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
	     * ```
	     *
	     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
	     *   The function can perform actions, and/or return a value.
	     *
	     * #### Example:
	     * When no other url rule matches, manually trigger a transition to the `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   router.stateService.go('home');
	     * });
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   return { state: 'home' };
	     * });
	     * ```
	     *
	     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
	     */
	    UrlRules.prototype.otherwise = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        this._otherwiseFn = this.urlRuleFactory.create(common_1.val(true), handlerFn);
	        this._sorted = false;
	    };
	    /**
	     * Remove a rule previously registered
	     *
	     * @param rule the matcher rule that was previously registered using [[rule]]
	     */
	    UrlRules.prototype.removeRule = function (rule) {
	        common_1.removeFrom(this._rules, rule);
	    };
	    /**
	     * Manually adds a URL Rule.
	     *
	     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
	     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
	     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
	     *
	     * A rule should have a `match` function which returns truthy if the rule matched.
	     * It should also have a `handler` function which is invoked if the rule is the best match.
	     *
	     * @return a function that deregisters the rule
	     */
	    UrlRules.prototype.rule = function (rule) {
	        var _this = this;
	        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
	            throw new Error('invalid rule');
	        rule.$id = this._id++;
	        rule.priority = rule.priority || 0;
	        this._rules.push(rule);
	        this._sorted = false;
	        return function () { return _this.removeRule(rule); };
	    };
	    /**
	     * Gets all registered rules
	     *
	     * @returns an array of all the registered rules
	     */
	    UrlRules.prototype.rules = function () {
	        this.ensureSorted();
	        return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
	    };
	    /**
	     * Defines URL Rule priorities
	     *
	     * More than one rule ([[UrlRule]]) might match a given URL.
	     * This `compareFn` is used to sort the rules by priority.
	     * Higher priority rules should sort earlier.
	     *
	     * The [[defaultRuleSortFn]] is used by default.
	     *
	     * You only need to call this function once.
	     * The `compareFn` will be used to sort the rules as each is registered.
	     *
	     * If called without any parameter, it will re-sort the rules.
	     *
	     * ---
	     *
	     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
	     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
	     * The `$id` is is the order in which the rule was registered.
	     *
	     * The sort function should use these data, or data found on a specific type
	     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
	     *
	     * #### Example:
	     * This compare function prioritizes rules by the order in which the rules were registered.
	     * A rule registered earlier has higher priority.
	     *
	     * ```js
	     * function compareFn(a, b) {
	     *   return a.$id - b.$id;
	     * }
	     * ```
	     *
	     * @param compareFn a function that compares to [[UrlRule]] objects.
	     *    The `compareFn` should abide by the `Array.sort` compare function rules.
	     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
	     *    Return a positive number if `b` should be higher priority.
	     *    Return `0` if the rules are identical.
	     *
	     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
	     *    for details.
	     */
	    UrlRules.prototype.sort = function (compareFn) {
	        var sorted = this.stableSort(this._rules, (this._sortFn = compareFn || this._sortFn));
	        // precompute _sortGroup values and apply to each rule
	        var group = 0;
	        for (var i = 0; i < sorted.length; i++) {
	            sorted[i]._group = group;
	            if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
	                group++;
	            }
	        }
	        this._rules = sorted;
	        this._sorted = true;
	    };
	    /** @internal */
	    UrlRules.prototype.ensureSorted = function () {
	        this._sorted || this.sort();
	    };
	    /** @internal */
	    UrlRules.prototype.stableSort = function (arr, compareFn) {
	        var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
	        arrOfWrapper.sort(function (wrapperA, wrapperB) {
	            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
	            return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
	        });
	        return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
	    };
	    /**
	     * Registers a `matcher` and `handler` for custom URLs handling.
	     *
	     * The `matcher` can be:
	     *
	     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
	     * - a `string`: The string is compiled to a [[UrlMatcher]]
	     * - a `RegExp`: The regexp is used to match the url.
	     *
	     * The `handler` can be:
	     *
	     * - a string: The url is redirected to the value of the string.
	     * - a function: The url is redirected to the return value of the function.
	     *
	     * ---
	     *
	     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
	     * string is interpolated with parameter values.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when("/foo/:param1", "/bar/:param1")
	     * ```
	     *
	     * ---
	     *
	     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
	     * interpolated with capture groups from the RegExp.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
	     * ```
	     *
	     * ---
	     *
	     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
	     * The "matched value" differs based on the `matcher`.
	     * For [[UrlMatcher]]s, it will be the matched state params.
	     * For `RegExp`, it will be the match array from `regexp.exec()`.
	     *
	     * If the handler returns a string, the URL is redirected to the string.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
	     * ```
	     *
	     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
	     *
	     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
	     * @param handler The path to redirect to, or a function that returns the path.
	     * @param options `{ priority: number }`
	     *
	     * @return the registered [[UrlRule]]
	     */
	    UrlRules.prototype.when = function (matcher, handler, options) {
	        var rule = this.urlRuleFactory.create(matcher, handler);
	        if (common_1.isDefined(options && options.priority))
	            rule.priority = options.priority;
	        this.rule(rule);
	        return rule;
	    };
	    return UrlRules;
	}());
	exports.UrlRules = UrlRules;
	//# sourceMappingURL=urlRules.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlConfig = void 0;
	var params_1 = __webpack_require__(363);
	var common_1 = __webpack_require__(352);
	/**
	 * An API to customize the URL behavior and retrieve URL configuration
	 *
	 * This API is used to customize the behavior of the URL.
	 * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
	 * and custom parameter encoding (custom [[type]]).
	 *
	 * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
	 * This information can be used to build absolute URLs, such as
	 * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
	 *
	 * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
	 */
	var UrlConfig = /** @class */ (function () {
	    /** @internal */ function UrlConfig(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.paramTypes = new params_1.ParamTypes();
	        /** @internal */ this._decodeParams = true;
	        /** @internal */ this._isCaseInsensitive = false;
	        /** @internal */ this._isStrictMode = true;
	        /** @internal */ this._defaultSquashPolicy = false;
	        /** @internal */ this.dispose = function () { return _this.paramTypes.dispose(); };
	        // Delegate these calls to the current LocationConfig implementation
	        /**
	         * Gets the base Href, e.g., `http://localhost/approot/`
	         *
	         * @return the application's base href
	         */
	        this.baseHref = function () { return _this.router.locationConfig.baseHref(); };
	        /**
	         * Gets or sets the hashPrefix
	         *
	         * This only applies when not running in [[html5Mode]] (pushstate mode)
	         *
	         * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
	         *
	         * @return the hash prefix
	         */
	        this.hashPrefix = function (newprefix) { return _this.router.locationConfig.hashPrefix(newprefix); };
	        /**
	         * Gets the host, e.g., `localhost`
	         *
	         * @return the protocol
	         */
	        this.host = function () { return _this.router.locationConfig.host(); };
	        /**
	         * Returns true when running in pushstate mode
	         *
	         * @return true when running in html5 mode (pushstate mode).
	         */
	        this.html5Mode = function () { return _this.router.locationConfig.html5Mode(); };
	        /**
	         * Gets the port, e.g., `80`
	         *
	         * @return the port number
	         */
	        this.port = function () { return _this.router.locationConfig.port(); };
	        /**
	         * Gets the protocol, e.g., `http`
	         *
	         * @return the protocol
	         */
	        this.protocol = function () { return _this.router.locationConfig.protocol(); };
	    }
	    /**
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * #### Example:
	     * ```js
	     * // Allow case insensitive url matches
	     * urlService.config.caseInsensitive(true);
	     * ```
	     *
	     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns the current value of caseInsensitive
	     */
	    UrlConfig.prototype.caseInsensitive = function (value) {
	        return (this._isCaseInsensitive = common_1.isDefined(value) ? value : this._isCaseInsensitive);
	    };
	    /**
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * #### Example:
	     * ```js
	     * // Remove default parameter values from the url
	     * urlService.config.defaultSquashPolicy(true);
	     * ```
	     *
	     * @param value A string that defines the default parameter URL squashing behavior.
	     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *      the parameter value from the URL and replace it with this string.
	     * @returns the current value of defaultSquashPolicy
	     */
	    UrlConfig.prototype.defaultSquashPolicy = function (value) {
	        if (common_1.isDefined(value) && value !== true && value !== false && !common_1.isString(value))
	            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	        return (this._defaultSquashPolicy = common_1.isDefined(value) ? value : this._defaultSquashPolicy);
	    };
	    /**
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * #### Example:
	     * ```js
	     * // Allow optional trailing slashes
	     * urlService.config.strictMode(false);
	     * ```
	     *
	     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns the current value of strictMode
	     */
	    UrlConfig.prototype.strictMode = function (value) {
	        return (this._isStrictMode = common_1.isDefined(value) ? value : this._isStrictMode);
	    };
	    /**
	     * Creates and registers a custom [[ParamType]] object
	     *
	     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
	     *
	     * #### Note: Register custom types *before using them* in a state definition.
	     *
	     * #### Example:
	     * ```js
	     * // Encode object parameter as JSON string
	     * urlService.config.type('myjson', {
	     *   encode: (obj) => JSON.stringify(obj),
	     *   decode: (str) => JSON.parse(str),
	     *   is: (val) => typeof(val) === 'object',
	     *   pattern: /[^/]+/,
	     *   equals: (a, b) => _.isEqual(a, b),
	     * });
	     * ```
	     *
	     * See [[ParamTypeDefinition]] for more examples
	     *
	     * @param name The type name.
	     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
	     * @param definitionFn A function that is injected before the app runtime starts.
	     *        The result of this function should be a [[ParamTypeDefinition]].
	     *        The result is merged into the existing `definition`.
	     *        See [[ParamType]] for information on the values accepted.
	     *
	     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
	     */
	    UrlConfig.prototype.type = function (name, definition, definitionFn) {
	        var type = this.paramTypes.type(name, definition, definitionFn);
	        return !common_1.isDefined(definition) ? type : this;
	    };
	    return UrlConfig;
	}());
	exports.UrlConfig = UrlConfig;
	//# sourceMappingURL=urlConfig.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerRedirectToHook = void 0;
	var predicates_1 = __webpack_require__(354);
	var coreservices_1 = __webpack_require__(356);
	var targetState_1 = __webpack_require__(372);
	/**
	 * A [[TransitionHookFn]] that redirects to a different state or params
	 *
	 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
	 *
	 * See [[StateDeclaration.redirectTo]]
	 */
	var redirectToHook = function (trans) {
	    var redirect = trans.to().redirectTo;
	    if (!redirect)
	        return;
	    var $state = trans.router.stateService;
	    function handleResult(result) {
	        if (!result)
	            return;
	        if (result instanceof targetState_1.TargetState)
	            return result;
	        if (predicates_1.isString(result))
	            return $state.target(result, trans.params(), trans.options());
	        if (result['state'] || result['params'])
	            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
	    }
	    if (predicates_1.isFunction(redirect)) {
	        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
	    }
	    return handleResult(redirect);
	};
	exports.registerRedirectToHook = function (transitionService) {
	    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
	};
	//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerOnEnterHook = exports.registerOnRetainHook = exports.registerOnExitHook = void 0;
	/**
	 * A factory which creates an onEnter, onExit or onRetain transition hook function
	 *
	 * The returned function invokes the (for instance) state.onEnter hook when the
	 * state is being entered.
	 */
	function makeEnterExitRetainHook(hookName) {
	    return function (transition, state) {
	        var _state = state.$$state();
	        var hookFn = _state[hookName];
	        return hookFn(transition, state);
	    };
	}
	/**
	 * The [[TransitionStateHookFn]] for onExit
	 *
	 * When the state is being exited, the state's .onExit function is invoked.
	 *
	 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
	 *
	 * See: [[IHookRegistry.onExit]]
	 */
	var onExitHook = makeEnterExitRetainHook('onExit');
	exports.registerOnExitHook = function (transitionService) {
	    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onRetain
	 *
	 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
	 *
	 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
	 *
	 * See: [[IHookRegistry.onRetain]]
	 */
	var onRetainHook = makeEnterExitRetainHook('onRetain');
	exports.registerOnRetainHook = function (transitionService) {
	    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onEnter
	 *
	 * When the state is being entered, the state's .onEnter function is invoked.
	 *
	 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
	 *
	 * See: [[IHookRegistry.onEnter]]
	 */
	var onEnterHook = makeEnterExitRetainHook('onEnter');
	exports.registerOnEnterHook = function (transitionService) {
	    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerResolveRemaining = exports.registerLazyResolveState = exports.registerEagerResolvePath = exports.RESOLVE_HOOK_PRIORITY = void 0;
	var common_1 = __webpack_require__(353);
	var resolveContext_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(355);
	exports.RESOLVE_HOOK_PRIORITY = 1000;
	/**
	 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
	 *
	 * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var eagerResolvePath = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(common_1.noop);
	};
	exports.registerEagerResolvePath = function (transitionService) {
	    return transitionService.onStart({}, eagerResolvePath, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
	 *
	 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
	 *
	 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var lazyResolveState = function (trans, state) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerLazyResolveState = function (transitionService) {
	    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
	 *
	 * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * After all entering states have been entered, this hook resolves any remaining Resolvables.
	 * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var resolveRemaining = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerResolveRemaining = function (transitionService) {
	    return transitionService.onFinish({}, resolveRemaining, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	//# sourceMappingURL=resolve.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerActivateViews = exports.registerLoadEnteringViews = void 0;
	var common_1 = __webpack_require__(353);
	var coreservices_1 = __webpack_require__(356);
	/**
	 * A [[TransitionHookFn]] which waits for the views to load
	 *
	 * Registered using `transitionService.onStart({}, loadEnteringViews);`
	 *
	 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
	 * In angular 1, this includes loading the templates.
	 */
	var loadEnteringViews = function (transition) {
	    var $q = coreservices_1.services.$q;
	    var enteringViews = transition.views('entering');
	    if (!enteringViews.length)
	        return;
	    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
	};
	exports.registerLoadEnteringViews = function (transitionService) {
	    return transitionService.onFinish({}, loadEnteringViews);
	};
	/**
	 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
	 *
	 * Registered using `transitionService.onSuccess({}, activateViews);`
	 *
	 * After a transition is complete, this hook deactivates the old views from the previous state,
	 * and activates the new views from the destination state.
	 *
	 * See [[ViewService]]
	 */
	var activateViews = function (transition) {
	    var enteringViews = transition.views('entering');
	    var exitingViews = transition.views('exiting');
	    if (!enteringViews.length && !exitingViews.length)
	        return;
	    var $view = transition.router.viewService;
	    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
	    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
	    $view.sync();
	};
	exports.registerActivateViews = function (transitionService) {
	    return transitionService.onSuccess({}, activateViews);
	};
	//# sourceMappingURL=views.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateGlobalState = void 0;
	var common_1 = __webpack_require__(353);
	/**
	 * A [[TransitionHookFn]] which updates global UI-Router state
	 *
	 * Registered using `transitionService.onBefore({}, updateGlobalState);`
	 *
	 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
	 * After a successful [[Transition]], updates the global values of "the current state"
	 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
	 *
	 * See also the deprecated properties:
	 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
	 */
	var updateGlobalState = function (trans) {
	    var globals = trans.router.globals;
	    var transitionSuccessful = function () {
	        globals.successfulTransitions.enqueue(trans);
	        globals.$current = trans.$to();
	        globals.current = globals.$current.self;
	        common_1.copy(trans.params(), globals.params);
	    };
	    var clearCurrentTransition = function () {
	        // Do not clear globals.transition if a different transition has started in the meantime
	        if (globals.transition === trans)
	            globals.transition = null;
	    };
	    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
	    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
	};
	exports.registerUpdateGlobalState = function (transitionService) {
	    return transitionService.onCreate({}, updateGlobalState);
	};
	//# sourceMappingURL=updateGlobals.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateUrl = void 0;
	/**
	 * A [[TransitionHookFn]] which updates the URL after a successful transition
	 *
	 * Registered using `transitionService.onSuccess({}, updateUrl);`
	 */
	var updateUrl = function (transition) {
	    var options = transition.options();
	    var $state = transition.router.stateService;
	    var $urlRouter = transition.router.urlRouter;
	    // Dont update the url in these situations:
	    // The transition was triggered by a URL sync (options.source === 'url')
	    // The user doesn't want the url to update (options.location === false)
	    // The destination state, and all parents have no navigable url
	    if (options.source !== 'url' && options.location && $state.$current.navigable) {
	        var urlOptions = { replace: options.location === 'replace' };
	        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
	    }
	    $urlRouter.update(true);
	};
	exports.registerUpdateUrl = function (transitionService) {
	    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
	};
	//# sourceMappingURL=url.js.map

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lazyLoadState = exports.registerLazyLoadHook = void 0;
	var coreservices_1 = __webpack_require__(356);
	/**
	 * A [[TransitionHookFn]] that performs lazy loading
	 *
	 * When entering a state "abc" which has a `lazyLoad` function defined:
	 * - Invoke the `lazyLoad` function (unless it is already in process)
	 *   - Flag the hook function as "in process"
	 *   - The function should return a promise (that resolves when lazy loading is complete)
	 * - Wait for the promise to settle
	 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
	 *   - Flag the hook function as "not in process"
	 * - If the hook was successful
	 *   - Remove the `lazyLoad` function from the state declaration
	 * - If all the hooks were successful
	 *   - Retry the transition (by returning a TargetState)
	 *
	 * ```
	 * .state('abc', {
	 *   component: 'fooComponent',
	 *   lazyLoad: () => import('./fooComponent')
	 *   });
	 * ```
	 *
	 * See [[StateDeclaration.lazyLoad]]
	 */
	var lazyLoadHook = function (transition) {
	    var router = transition.router;
	    function retryTransition() {
	        if (transition.originalTransition().options().source !== 'url') {
	            // The original transition was not triggered via url sync
	            // The lazy state should be loaded now, so re-try the original transition
	            var orig = transition.targetState();
	            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
	        }
	        // The original transition was triggered via url sync
	        // Run the URL rules and find the best match
	        var $url = router.urlService;
	        var result = $url.match($url.parts());
	        var rule = result && result.rule;
	        // If the best match is a state, redirect the transition (instead
	        // of calling sync() which supersedes the current transition)
	        if (rule && rule.type === 'STATE') {
	            var state = rule.state;
	            var params = result.match;
	            return router.stateService.target(state, params, transition.options());
	        }
	        // No matching state found, so let .sync() choose the best non-state match/otherwise
	        router.urlService.sync();
	    }
	    var promises = transition
	        .entering()
	        .filter(function (state) { return !!state.$$state().lazyLoad; })
	        .map(function (state) { return lazyLoadState(transition, state); });
	    return coreservices_1.services.$q.all(promises).then(retryTransition);
	};
	exports.registerLazyLoadHook = function (transitionService) {
	    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
	};
	/**
	 * Invokes a state's lazy load function
	 *
	 * @param transition a Transition context
	 * @param state the state to lazy load
	 * @returns A promise for the lazy load result
	 */
	function lazyLoadState(transition, state) {
	    var lazyLoadFn = state.$$state().lazyLoad;
	    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
	    var promise = lazyLoadFn['_promise'];
	    if (!promise) {
	        var success = function (result) {
	            delete state.lazyLoad;
	            delete state.$$state().lazyLoad;
	            delete lazyLoadFn['_promise'];
	            return result;
	        };
	        var error = function (err) {
	            delete lazyLoadFn['_promise'];
	            return coreservices_1.services.$q.reject(err);
	        };
	        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q
	            .when(lazyLoadFn(transition, state))
	            .then(updateStateRegistry)
	            .then(success, error);
	    }
	    /** Register any lazy loaded state definitions */
	    function updateStateRegistry(result) {
	        if (result && Array.isArray(result.states)) {
	            result.states.forEach(function (_state) { return transition.router.stateRegistry.register(_state); });
	        }
	        return result;
	    }
	    return promise;
	}
	exports.lazyLoadState = lazyLoadState;
	//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionEventType = void 0;
	var transitionHook_1 = __webpack_require__(388);
	/**
	 * This class defines a type of hook, such as `onBefore` or `onEnter`.
	 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
	 */
	var TransitionEventType = /** @class */ (function () {
	    /* tslint:disable:no-inferrable-types */
	    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        this.name = name;
	        this.hookPhase = hookPhase;
	        this.hookOrder = hookOrder;
	        this.criteriaMatchPath = criteriaMatchPath;
	        this.reverseSort = reverseSort;
	        this.getResultHandler = getResultHandler;
	        this.getErrorHandler = getErrorHandler;
	        this.synchronous = synchronous;
	    }
	    return TransitionEventType;
	}());
	exports.TransitionEventType = TransitionEventType;
	//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerIgnoredTransitionHook = void 0;
	var trace_1 = __webpack_require__(361);
	var rejectFactory_1 = __webpack_require__(360);
	/**
	 * A [[TransitionHookFn]] that skips a transition if it should be ignored
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 *
	 * If the transition should be ignored (because no parameter or states changed)
	 * then the transition is ignored and not processed.
	 */
	function ignoredHook(trans) {
	    var ignoredReason = trans._ignoredReason();
	    if (!ignoredReason)
	        return;
	    trace_1.trace.traceTransitionIgnored(trans);
	    var pending = trans.router.globals.transition;
	    // The user clicked a link going back to the *current state* ('A')
	    // However, there is also a pending transition in flight (to 'B')
	    // Abort the transition to 'B' because the user now wants to be back at 'A'.
	    if (ignoredReason === 'SameAsCurrent' && pending) {
	        pending.abort();
	    }
	    return rejectFactory_1.Rejection.ignored().toPromise();
	}
	exports.registerIgnoredTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
	};
	//# sourceMappingURL=ignoredTransition.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerInvalidTransitionHook = void 0;
	/**
	 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 * If the transition is invalid (for example, param values do not validate)
	 * then the transition is rejected.
	 */
	function invalidTransitionHook(trans) {
	    if (!trans.valid()) {
	        throw new Error(trans.error().toString());
	    }
	}
	exports.registerInvalidTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
	};
	//# sourceMappingURL=invalidTransition.js.map

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # Transition subsystem
	 *
	 * This module contains APIs related to a Transition.
	 *
	 * See:
	 * - [[TransitionService]]
	 * - [[Transition]]
	 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(386), exports);
	__exportStar(__webpack_require__(390), exports);
	__exportStar(__webpack_require__(389), exports);
	__exportStar(__webpack_require__(360), exports);
	__exportStar(__webpack_require__(387), exports);
	__exportStar(__webpack_require__(388), exports);
	__exportStar(__webpack_require__(409), exports);
	__exportStar(__webpack_require__(385), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(414), exports);
	__exportStar(__webpack_require__(394), exports);
	__exportStar(__webpack_require__(393), exports);
	__exportStar(__webpack_require__(395), exports);
	__exportStar(__webpack_require__(396), exports);
	__exportStar(__webpack_require__(399), exports);
	var urlRules_1 = __webpack_require__(400);
	Object.defineProperty(exports, "UrlRules", { enumerable: true, get: function () { return urlRules_1.UrlRules; } });
	var urlConfig_1 = __webpack_require__(401);
	Object.defineProperty(exports, "UrlConfig", { enumerable: true, get: function () { return urlConfig_1.UrlConfig; } });
	//# sourceMappingURL=index.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(416), exports);
	__exportStar(__webpack_require__(397), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(418), exports);
	//# sourceMappingURL=vanilla.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Naive, pure JS implementation of core ui-router services
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(419), exports);
	__exportStar(__webpack_require__(420), exports);
	__exportStar(__webpack_require__(421), exports);
	__exportStar(__webpack_require__(422), exports);
	__exportStar(__webpack_require__(424), exports);
	__exportStar(__webpack_require__(425), exports);
	__exportStar(__webpack_require__(426), exports);
	__exportStar(__webpack_require__(427), exports);
	__exportStar(__webpack_require__(428), exports);
	__exportStar(__webpack_require__(423), exports);
	__exportStar(__webpack_require__(429), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$q = void 0;
	var index_1 = __webpack_require__(352);
	/**
	 * An angular1-like promise api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This API provides native ES6 promise support wrapped as a $q-like API.
	 * Internally, UI-Router uses this $q object to perform promise operations.
	 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
	 *
	 * $q-like promise api
	 */
	exports.$q = {
	    /** Normalizes a value as a promise */
	    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
	    /** Normalizes a value as a promise rejection */
	    reject: function (val) {
	        return new Promise(function (resolve, reject) {
	            reject(val);
	        });
	    },
	    /** @returns a deferred object, which has `resolve` and `reject` functions */
	    defer: function () {
	        var deferred = {};
	        deferred.promise = new Promise(function (resolve, reject) {
	            deferred.resolve = resolve;
	            deferred.reject = reject;
	        });
	        return deferred;
	    },
	    /** Like Promise.all(), but also supports object key/promise notation like $q */
	    all: function (promises) {
	        if (index_1.isArray(promises)) {
	            return Promise.all(promises);
	        }
	        if (index_1.isObject(promises)) {
	            // Convert promises map to promises array.
	            // When each promise resolves, map it to a tuple { key: key, val: val }
	            var chain = Object.keys(promises).map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
	            // Then wait for all promises to resolve, and convert them back to an object
	            return exports.$q.all(chain).then(function (values) {
	                return values.reduce(function (acc, tuple) {
	                    acc[tuple.key] = tuple.val;
	                    return acc;
	                }, {});
	            });
	        }
	    },
	};
	//# sourceMappingURL=q.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$injector = void 0;
	var index_1 = __webpack_require__(352);
	// globally available injectables
	var globals = {};
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
	var ARGUMENT_NAMES = /([^\s,]+)/g;
	/**
	 * A basic angular1-like injector api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This object provides a naive implementation of a globally scoped dependency injection system.
	 * It supports the following DI approaches:
	 *
	 * ### Function parameter names
	 *
	 * A function's `.toString()` is called, and the parameter names are parsed.
	 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
	 *
	 * ```js
	 * function injectedFunction(FooService, BarService) {
	 *   // FooService and BarService are injected
	 * }
	 * ```
	 *
	 * ### Function annotation
	 *
	 * A function may be annotated with an array of dependency names as the `$inject` property.
	 *
	 * ```js
	 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
	 * function injectedFunction(fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }
	 * ```
	 *
	 * ### Array notation
	 *
	 * An array provides the names of the dependencies to inject (as strings).
	 * The function is the last element of the array.
	 *
	 * ```js
	 * [ 'FooService', 'BarService', function (fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }]
	 * ```
	 *
	 * @type {$InjectorLike}
	 */
	exports.$injector = {
	    /** Gets an object from DI based on a string token */
	    get: function (name) { return globals[name]; },
	    /** Returns true if an object named `name` exists in global DI */
	    has: function (name) { return exports.$injector.get(name) != null; },
	    /**
	     * Injects a function
	     *
	     * @param fn the function to inject
	     * @param context the function's `this` binding
	     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
	     */
	    invoke: function (fn, context, locals) {
	        var all = index_1.extend({}, globals, locals || {});
	        var params = exports.$injector.annotate(fn);
	        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
	        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
	        if (index_1.isFunction(fn))
	            return fn.apply(context, args);
	        else
	            return fn.slice(-1)[0].apply(context, args);
	    },
	    /**
	     * Returns a function's dependencies
	     *
	     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
	     * @return an array of `string`s
	     */
	    annotate: function (fn) {
	        if (!index_1.isInjectable(fn))
	            throw new Error("Not an injectable function: " + fn);
	        if (fn && fn.$inject)
	            return fn.$inject;
	        if (index_1.isArray(fn))
	            return fn.slice(0, -1);
	        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
	        return result || [];
	    },
	};
	//# sourceMappingURL=injector.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseLocationServices = void 0;
	var common_1 = __webpack_require__(352);
	var utils_1 = __webpack_require__(423);
	/** A base `LocationServices` */
	var BaseLocationServices = /** @class */ (function () {
	    function BaseLocationServices(router, fireAfterUpdate) {
	        var _this = this;
	        this.fireAfterUpdate = fireAfterUpdate;
	        this._listeners = [];
	        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
	        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
	        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
	        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
	        this._location = common_1.root.location;
	        this._history = common_1.root.history;
	    }
	    BaseLocationServices.prototype.url = function (url, replace) {
	        if (replace === void 0) { replace = true; }
	        if (common_1.isDefined(url) && url !== this._get()) {
	            this._set(null, null, url, replace);
	            if (this.fireAfterUpdate) {
	                this._listeners.forEach(function (cb) { return cb({ url: url }); });
	            }
	        }
	        return utils_1.buildUrl(this);
	    };
	    BaseLocationServices.prototype.onChange = function (cb) {
	        var _this = this;
	        this._listeners.push(cb);
	        return function () { return common_1.removeFrom(_this._listeners, cb); };
	    };
	    BaseLocationServices.prototype.dispose = function (router) {
	        common_1.deregAll(this._listeners);
	    };
	    return BaseLocationServices;
	}());
	exports.BaseLocationServices = BaseLocationServices;
	//# sourceMappingURL=baseLocationService.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.locationPluginFactory = exports.buildUrl = exports.parseUrl = exports.getParams = exports.keyValsToObjectR = void 0;
	var common_1 = __webpack_require__(352);
	exports.keyValsToObjectR = function (accum, _a) {
	    var key = _a[0], val = _a[1];
	    if (!accum.hasOwnProperty(key)) {
	        accum[key] = val;
	    }
	    else if (common_1.isArray(accum[key])) {
	        accum[key].push(val);
	    }
	    else {
	        accum[key] = [accum[key], val];
	    }
	    return accum;
	};
	exports.getParams = function (queryString) {
	    return queryString.split('&').filter(common_1.identity).map(common_1.splitEqual).reduce(exports.keyValsToObjectR, {});
	};
	function parseUrl(url) {
	    var orEmptyString = function (x) { return x || ''; };
	    var _a = common_1.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
	    var _b = common_1.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
	    return { path: path, search: search, hash: hash, url: url };
	}
	exports.parseUrl = parseUrl;
	exports.buildUrl = function (loc) {
	    var path = loc.path();
	    var searchObject = loc.search();
	    var hash = loc.hash();
	    var search = Object.keys(searchObject)
	        .map(function (key) {
	        var param = searchObject[key];
	        var vals = common_1.isArray(param) ? param : [param];
	        return vals.map(function (val) { return key + '=' + val; });
	    })
	        .reduce(common_1.unnestR, [])
	        .join('&');
	    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	};
	function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
	    return function (uiRouter) {
	        var service = (uiRouter.locationService = new serviceClass(uiRouter));
	        var configuration = (uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5));
	        function dispose(router) {
	            router.dispose(service);
	            router.dispose(configuration);
	        }
	        return { name: name, service: service, configuration: configuration, dispose: dispose };
	    };
	}
	exports.locationPluginFactory = locationPluginFactory;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HashLocationService = void 0;
	var common_1 = __webpack_require__(352);
	var baseLocationService_1 = __webpack_require__(422);
	/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
	var HashLocationService = /** @class */ (function (_super) {
	    __extends(HashLocationService, _super);
	    function HashLocationService(router) {
	        var _this = _super.call(this, router, false) || this;
	        common_1.root.addEventListener('hashchange', _this._listener, false);
	        return _this;
	    }
	    HashLocationService.prototype._get = function () {
	        return common_1.trimHashVal(this._location.hash);
	    };
	    HashLocationService.prototype._set = function (state, title, url, replace) {
	        this._location.hash = url;
	    };
	    HashLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('hashchange', this._listener);
	    };
	    return HashLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.HashLocationService = HashLocationService;
	//# sourceMappingURL=hashLocationService.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(422);
	/** A `LocationServices` that gets/sets the current location from an in-memory object */
	var MemoryLocationService = /** @class */ (function (_super) {
	    __extends(MemoryLocationService, _super);
	    function MemoryLocationService(router) {
	        return _super.call(this, router, true) || this;
	    }
	    MemoryLocationService.prototype._get = function () {
	        return this._url;
	    };
	    MemoryLocationService.prototype._set = function (state, title, url, replace) {
	        this._url = url;
	    };
	    return MemoryLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.MemoryLocationService = MemoryLocationService;
	//# sourceMappingURL=memoryLocationService.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PushStateLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(422);
	var common_1 = __webpack_require__(352);
	/**
	 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
	 *
	 * Uses `history.pushState` and `history.replaceState`
	 */
	var PushStateLocationService = /** @class */ (function (_super) {
	    __extends(PushStateLocationService, _super);
	    function PushStateLocationService(router) {
	        var _this = _super.call(this, router, true) || this;
	        _this._config = router.urlService.config;
	        common_1.root.addEventListener('popstate', _this._listener, false);
	        return _this;
	    }
	    /**
	     * Gets the base prefix without:
	     * - trailing slash
	     * - trailing filename
	     * - protocol and hostname
	     *
	     * If <base href='/base/'>, this returns '/base'.
	     * If <base href='/foo/base/'>, this returns '/foo/base'.
	     * If <base href='/base/index.html'>, this returns '/base'.
	     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
	     * If <base href='/base'>, this returns ''.
	     * If <base href='http://localhost:8080'>, this returns ''.
	     * If <base href='http://localhost:8080/'>, this returns ''.
	     *
	     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
	     */
	    PushStateLocationService.prototype._getBasePrefix = function () {
	        return common_1.stripLastPathElement(this._config.baseHref());
	    };
	    PushStateLocationService.prototype._get = function () {
	        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
	        search = common_1.splitQuery(search)[1]; // strip ? if found
	        hash = common_1.splitHash(hash)[1]; // strip # if found
	        var basePrefix = this._getBasePrefix();
	        var exactBaseHrefMatch = pathname === this._config.baseHref();
	        var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
	        pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
	        return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	    };
	    PushStateLocationService.prototype._set = function (state, title, url, replace) {
	        var basePrefix = this._getBasePrefix();
	        var slash = url && url[0] !== '/' ? '/' : '';
	        var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
	        if (replace) {
	            this._history.replaceState(state, title, fullUrl);
	        }
	        else {
	            this._history.pushState(state, title, fullUrl);
	        }
	    };
	    PushStateLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('popstate', this._listener);
	    };
	    return PushStateLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.PushStateLocationService = PushStateLocationService;
	//# sourceMappingURL=pushStateLocationService.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationConfig = void 0;
	var predicates_1 = __webpack_require__(354);
	var common_1 = __webpack_require__(353);
	/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
	var MemoryLocationConfig = /** @class */ (function () {
	    function MemoryLocationConfig() {
	        var _this = this;
	        this.dispose = common_1.noop;
	        this._baseHref = '';
	        this._port = 80;
	        this._protocol = 'http';
	        this._host = 'localhost';
	        this._hashPrefix = '';
	        this.port = function () { return _this._port; };
	        this.protocol = function () { return _this._protocol; };
	        this.host = function () { return _this._host; };
	        this.baseHref = function () { return _this._baseHref; };
	        this.html5Mode = function () { return false; };
	        this.hashPrefix = function (newval) { return (predicates_1.isDefined(newval) ? (_this._hashPrefix = newval) : _this._hashPrefix); };
	    }
	    return MemoryLocationConfig;
	}());
	exports.MemoryLocationConfig = MemoryLocationConfig;
	//# sourceMappingURL=memoryLocationConfig.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BrowserLocationConfig = void 0;
	var predicates_1 = __webpack_require__(354);
	/** A `LocationConfig` that delegates to the browser's `location` object */
	var BrowserLocationConfig = /** @class */ (function () {
	    function BrowserLocationConfig(router, _isHtml5) {
	        if (_isHtml5 === void 0) { _isHtml5 = false; }
	        this._isHtml5 = _isHtml5;
	        this._baseHref = undefined;
	        this._hashPrefix = '';
	    }
	    BrowserLocationConfig.prototype.port = function () {
	        if (location.port) {
	            return Number(location.port);
	        }
	        return this.protocol() === 'https' ? 443 : 80;
	    };
	    BrowserLocationConfig.prototype.protocol = function () {
	        return location.protocol.replace(/:/g, '');
	    };
	    BrowserLocationConfig.prototype.host = function () {
	        return location.hostname;
	    };
	    BrowserLocationConfig.prototype.html5Mode = function () {
	        return this._isHtml5;
	    };
	    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
	        return predicates_1.isDefined(newprefix) ? (this._hashPrefix = newprefix) : this._hashPrefix;
	    };
	    BrowserLocationConfig.prototype.baseHref = function (href) {
	        if (predicates_1.isDefined(href))
	            this._baseHref = href;
	        if (predicates_1.isUndefined(this._baseHref))
	            this._baseHref = this.getBaseHref();
	        return this._baseHref;
	    };
	    BrowserLocationConfig.prototype.getBaseHref = function () {
	        var baseTag = document.getElementsByTagName('base')[0];
	        if (baseTag && baseTag.href) {
	            return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
	        }
	        return this._isHtml5 ? '/' : location.pathname || '/';
	    };
	    BrowserLocationConfig.prototype.dispose = function () { };
	    return BrowserLocationConfig;
	}());
	exports.BrowserLocationConfig = BrowserLocationConfig;
	//# sourceMappingURL=browserLocationConfig.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.memoryLocationPlugin = exports.pushStateLocationPlugin = exports.hashLocationPlugin = exports.servicesPlugin = void 0;
	var browserLocationConfig_1 = __webpack_require__(428);
	var hashLocationService_1 = __webpack_require__(424);
	var utils_1 = __webpack_require__(423);
	var pushStateLocationService_1 = __webpack_require__(426);
	var memoryLocationService_1 = __webpack_require__(425);
	var memoryLocationConfig_1 = __webpack_require__(427);
	var injector_1 = __webpack_require__(421);
	var q_1 = __webpack_require__(420);
	var coreservices_1 = __webpack_require__(356);
	function servicesPlugin(router) {
	    coreservices_1.services.$injector = injector_1.$injector;
	    coreservices_1.services.$q = q_1.$q;
	    return { name: 'vanilla.services', $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
	}
	exports.servicesPlugin = servicesPlugin;
	/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
	exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
	exports.pushStateLocationPlugin = utils_1.locationPluginFactory('vanilla.pushStateLocation', true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
	exports.memoryLocationPlugin = utils_1.locationPluginFactory('vanilla.memoryLocation', false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
	//# sourceMappingURL=plugins.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterPluginBase = void 0;
	var UIRouterPluginBase = /** @class */ (function () {
	    function UIRouterPluginBase() {
	    }
	    UIRouterPluginBase.prototype.dispose = function (router) { };
	    return UIRouterPluginBase;
	}());
	exports.UIRouterPluginBase = UIRouterPluginBase;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! VelocityJS.org (1.5.2). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
	
	/*************************
	 Velocity jQuery Shim
	 *************************/
	
	/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
	
	/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
	/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
	/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */
	
	(function(window) {
		"use strict";
		/***************
		 Setup
		 ***************/
	
		/* If jQuery is already loaded, there's no point in loading this shim. */
		if (window.jQuery) {
			return;
		}
	
		/* jQuery base. */
		var $ = function(selector, context) {
			return new $.fn.init(selector, context);
		};
	
		/********************
		 Private Methods
		 ********************/
	
		/* jQuery */
		$.isWindow = function(obj) {
			/* jshint eqeqeq: false */
			return obj && obj === obj.window;
		};
	
		/* jQuery */
		$.type = function(obj) {
			if (!obj) {
				return obj + "";
			}
	
			return typeof obj === "object" || typeof obj === "function" ?
					class2type[toString.call(obj)] || "object" :
					typeof obj;
		};
	
		/* jQuery */
		$.isArray = Array.isArray || function(obj) {
			return $.type(obj) === "array";
		};
	
		/* jQuery */
		function isArraylike(obj) {
			var length = obj.length,
					type = $.type(obj);
	
			if (type === "function" || $.isWindow(obj)) {
				return false;
			}
	
			if (obj.nodeType === 1 && length) {
				return true;
			}
	
			return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
		}
	
		/***************
		 $ Methods
		 ***************/
	
		/* jQuery: Support removed for IE<9. */
		$.isPlainObject = function(obj) {
			var key;
	
			if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
				return false;
			}
	
			try {
				if (obj.constructor &&
						!hasOwn.call(obj, "constructor") &&
						!hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
					return false;
				}
			} catch (e) {
				return false;
			}
	
			for (key in obj) {
			}
	
			return key === undefined || hasOwn.call(obj, key);
		};
	
		/* jQuery */
		$.each = function(obj, callback, args) {
			var value,
					i = 0,
					length = obj.length,
					isArray = isArraylike(obj);
	
			if (args) {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.apply(obj[i], args);
	
						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.apply(obj[i], args);
	
						if (value === false) {
							break;
						}
					}
				}
	
			} else {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.call(obj[i], i, obj[i]);
	
						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.call(obj[i], i, obj[i]);
	
						if (value === false) {
							break;
						}
					}
				}
			}
	
			return obj;
		};
	
		/* Custom */
		$.data = function(node, key, value) {
			/* $.getData() */
			if (value === undefined) {
				var getId = node[$.expando],
						store = getId && cache[getId];
	
				if (key === undefined) {
					return store;
				} else if (store) {
					if (key in store) {
						return store[key];
					}
				}
				/* $.setData() */
			} else if (key !== undefined) {
				var setId = node[$.expando] || (node[$.expando] = ++$.uuid);
	
				cache[setId] = cache[setId] || {};
				cache[setId][key] = value;
	
				return value;
			}
		};
	
		/* Custom */
		$.removeData = function(node, keys) {
			var id = node[$.expando],
					store = id && cache[id];
	
			if (store) {
				// Cleanup the entire store if no keys are provided.
				if (!keys) {
					delete cache[id];
				} else {
					$.each(keys, function(_, key) {
						delete store[key];
					});
				}
			}
		};
	
		/* jQuery */
		$.extend = function() {
			var src, copyIsArray, copy, name, options, clone,
					target = arguments[0] || {},
					i = 1,
					length = arguments.length,
					deep = false;
	
			if (typeof target === "boolean") {
				deep = target;
	
				target = arguments[i] || {};
				i++;
			}
	
			if (typeof target !== "object" && $.type(target) !== "function") {
				target = {};
			}
	
			if (i === length) {
				target = this;
				i--;
			}
	
			for (; i < length; i++) {
				if ((options = arguments[i])) {
					for (name in options) {
						if (!options.hasOwnProperty(name)) {
							continue;
						}
						src = target[name];
						copy = options[name];
	
						if (target === copy) {
							continue;
						}
	
						if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && $.isArray(src) ? src : [];
	
							} else {
								clone = src && $.isPlainObject(src) ? src : {};
							}
	
							target[name] = $.extend(deep, clone, copy);
	
						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}
	
			return target;
		};
	
		/* jQuery 1.4.3 */
		$.queue = function(elem, type, data) {
			function $makeArray(arr, results) {
				var ret = results || [];
	
				if (arr) {
					if (isArraylike(Object(arr))) {
						/* $.merge */
						(function(first, second) {
							var len = +second.length,
									j = 0,
									i = first.length;
	
							while (j < len) {
								first[i++] = second[j++];
							}
	
							if (len !== len) {
								while (second[j] !== undefined) {
									first[i++] = second[j++];
								}
							}
	
							first.length = i;
	
							return first;
						})(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						[].push.call(ret, arr);
					}
				}
	
				return ret;
			}
	
			if (!elem) {
				return;
			}
	
			type = (type || "fx") + "queue";
	
			var q = $.data(elem, type);
	
			if (!data) {
				return q || [];
			}
	
			if (!q || $.isArray(data)) {
				q = $.data(elem, type, $makeArray(data));
			} else {
				q.push(data);
			}
	
			return q;
		};
	
		/* jQuery 1.4.3 */
		$.dequeue = function(elems, type) {
			/* Custom: Embed element iteration. */
			$.each(elems.nodeType ? [elems] : elems, function(i, elem) {
				type = type || "fx";
	
				var queue = $.queue(elem, type),
						fn = queue.shift();
	
				if (fn === "inprogress") {
					fn = queue.shift();
				}
	
				if (fn) {
					if (type === "fx") {
						queue.unshift("inprogress");
					}
	
					fn.call(elem, function() {
						$.dequeue(elem, type);
					});
				}
			});
		};
	
		/******************
		 $.fn Methods
		 ******************/
	
		/* jQuery */
		$.fn = $.prototype = {
			init: function(selector) {
				/* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
				if (selector.nodeType) {
					this[0] = selector;
	
					return this;
				} else {
					throw new Error("Not a DOM node.");
				}
			},
			offset: function() {
				/* jQuery altered code: Dropped disconnected DOM node checking. */
				var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {top: 0, left: 0};
	
				return {
					top: box.top + (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
					left: box.left + (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
				};
			},
			position: function() {
				/* jQuery */
				function offsetParentFn(elem) {
					var offsetParent = elem.offsetParent;
	
					while (offsetParent && (offsetParent.nodeName.toLowerCase() !== "html" && offsetParent.style && offsetParent.style.position.toLowerCase() === "static")) {
						offsetParent = offsetParent.offsetParent;
					}
	
					return offsetParent || document;
				}
	
				/* Zepto */
				var elem = this[0],
						offsetParent = offsetParentFn(elem),
						offset = this.offset(),
						parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? {top: 0, left: 0} : $(offsetParent).offset();
	
				offset.top -= parseFloat(elem.style.marginTop) || 0;
				offset.left -= parseFloat(elem.style.marginLeft) || 0;
	
				if (offsetParent.style) {
					parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0;
					parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0;
				}
	
				return {
					top: offset.top - parentOffset.top,
					left: offset.left - parentOffset.left
				};
			}
		};
	
		/**********************
		 Private Variables
		 **********************/
	
		/* For $.data() */
		var cache = {};
		$.expando = "velocity" + (new Date().getTime());
		$.uuid = 0;
	
		/* For $.queue() */
		var class2type = {},
				hasOwn = class2type.hasOwnProperty,
				toString = class2type.toString;
	
		var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
		for (var i = 0; i < types.length; i++) {
			class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
		}
	
		/* Makes $(node) possible, without having to call init. */
		$.fn.init.prototype = $.fn;
	
		/* Globalize Velocity onto the window, and assign its Utilities property. */
		window.Velocity = {Utilities: $};
	})(window);
	
	/******************
	 Velocity.js
	 ******************/
	
	(function(factory) {
		"use strict";
		/* CommonJS module. */
		if (typeof module === "object" && typeof module.exports === "object") {
			module.exports = factory();
			/* AMD module. */
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			/* Browser globals. */
		} else {
			factory();
		}
	}(function() {
		"use strict";
		return function(global, window, document, undefined) {
	
			/***************
			 Summary
			 ***************/
	
			/*
			 - CSS: CSS stack that works independently from the rest of Velocity.
			 - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
			 - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
			 - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
			 Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
			 - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
			 - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
			 - completeCall(): Handles the cleanup process for each Velocity call.
			 */
	
			/*********************
			 Helper Functions
			 *********************/
	
			/* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
			var IE = (function() {
				if (document.documentMode) {
					return document.documentMode;
				} else {
					for (var i = 7; i > 4; i--) {
						var div = document.createElement("div");
	
						div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";
	
						if (div.getElementsByTagName("span").length) {
							div = null;
	
							return i;
						}
					}
				}
	
				return undefined;
			})();
	
			/* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
			var rAFShim = (function() {
				var timeLast = 0;
	
				return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
					var timeCurrent = (new Date()).getTime(),
							timeDelta;
	
					/* Dynamically set delay on a per-tick basis to match 60fps. */
					/* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
					timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
					timeLast = timeCurrent + timeDelta;
	
					return setTimeout(function() {
						callback(timeCurrent + timeDelta);
					}, timeDelta);
				};
			})();
	
			var performance = (function() {
				var perf = window.performance || {};
	
				if (typeof perf.now !== "function") {
					var nowOffset = perf.timing && perf.timing.navigationStart ? perf.timing.navigationStart : (new Date()).getTime();
	
					perf.now = function() {
						return (new Date()).getTime() - nowOffset;
					};
				}
				return perf;
			})();
	
			/* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
			function compactSparseArray(array) {
				var index = -1,
						length = array ? array.length : 0,
						result = [];
	
				while (++index < length) {
					var value = array[index];
	
					if (value) {
						result.push(value);
					}
				}
	
				return result;
			}
	
			/**
			 * Shim for "fixing" IE's lack of support (IE < 9) for applying slice
			 * on host objects like NamedNodeMap, NodeList, and HTMLCollection
			 * (technically, since host objects have been implementation-dependent,
			 * at least before ES2015, IE hasn't needed to work this way).
			 * Also works on strings, fixes IE < 9 to allow an explicit undefined
			 * for the 2nd argument (as in Firefox), and prevents errors when
			 * called on other DOM objects.
			 */
			var _slice = (function() {
				var slice = Array.prototype.slice;
	
				try {
					// Can't be used with DOM elements in IE < 9
					slice.call(document.documentElement);
					return slice;
				} catch (e) { // Fails in IE < 9
	
					// This will work for genuine arrays, array-like objects, 
					// NamedNodeMap (attributes, entities, notations),
					// NodeList (e.g., getElementsByTagName), HTMLCollection (e.g., childNodes),
					// and will not fail on other DOM objects (as do DOM elements in IE < 9)
					return function(begin, end) {
						var len = this.length;
	
						if (typeof begin !== "number") {
							begin = 0;
						}
						// IE < 9 gets unhappy with an undefined end argument
						if (typeof end !== "number") {
							end = len;
						}
						// For native Array objects, we use the native slice function
						if (this.slice) {
							return slice.call(this, begin, end);
						}
						// For array like object we handle it ourselves.
						var i,
								cloned = [],
								// Handle negative value for "begin"
								start = (begin >= 0) ? begin : Math.max(0, len + begin),
								// Handle negative value for "end"
								upTo = end < 0 ? len + end : Math.min(end, len),
								// Actual expected size of the slice
								size = upTo - start;
	
						if (size > 0) {
							cloned = new Array(size);
							if (this.charAt) {
								for (i = 0; i < size; i++) {
									cloned[i] = this.charAt(start + i);
								}
							} else {
								for (i = 0; i < size; i++) {
									cloned[i] = this[start + i];
								}
							}
						}
						return cloned;
					};
				}
			})();
	
			/* .indexOf doesn't exist in IE<9 */
			var _inArray = (function() {
				if (Array.prototype.includes) {
					return function(arr, val) {
						return arr.includes(val);
					};
				}
				if (Array.prototype.indexOf) {
					return function(arr, val) {
						return arr.indexOf(val) >= 0;
					};
				}
				return function(arr, val) {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i] === val) {
							return true;
						}
					}
					return false;
				};
			});
	
			function sanitizeElements(elements) {
				/* Unwrap jQuery/Zepto objects. */
				if (Type.isWrapped(elements)) {
					elements = _slice.call(elements);
					/* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
				} else if (Type.isNode(elements)) {
					elements = [elements];
				}
	
				return elements;
			}
	
			var Type = {
				isNumber: function(variable) {
					return (typeof variable === "number");
				},
				isString: function(variable) {
					return (typeof variable === "string");
				},
				isArray: Array.isArray || function(variable) {
					return Object.prototype.toString.call(variable) === "[object Array]";
				},
				isFunction: function(variable) {
					return Object.prototype.toString.call(variable) === "[object Function]";
				},
				isNode: function(variable) {
					return variable && variable.nodeType;
				},
				/* Determine if variable is an array-like wrapped jQuery, Zepto or similar element, or even a NodeList etc. */
				/* NOTE: HTMLFormElements also have a length. */
				isWrapped: function(variable) {
					return variable
							&& variable !== window
							&& Type.isNumber(variable.length)
							&& !Type.isString(variable)
							&& !Type.isFunction(variable)
							&& !Type.isNode(variable)
							&& (variable.length === 0 || Type.isNode(variable[0]));
				},
				isSVG: function(variable) {
					return window.SVGElement && (variable instanceof window.SVGElement);
				},
				isEmptyObject: function(variable) {
					for (var name in variable) {
						if (variable.hasOwnProperty(name)) {
							return false;
						}
					}
	
					return true;
				}
			};
	
			/*****************
			 Dependencies
			 *****************/
	
			var $,
					isJQuery = false;
	
			if (global.fn && global.fn.jquery) {
				$ = global;
				isJQuery = true;
			} else {
				$ = window.Velocity.Utilities;
			}
	
			if (IE <= 8 && !isJQuery) {
				throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
			} else if (IE <= 7) {
				/* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
				jQuery.fn.velocity = jQuery.fn.animate;
	
				/* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
				return;
			}
	
			/*****************
			 Constants
			 *****************/
	
			var DURATION_DEFAULT = 400,
					EASING_DEFAULT = "swing";
	
			/*************
			 State
			 *************/
	
			var Velocity = {
				/* Container for page-wide Velocity state data. */
				State: {
					/* Detect mobile devices to determine if mobileHA should be turned on. */
					isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent),
					/* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
					isAndroid: /Android/i.test(window.navigator.userAgent),
					isGingerbread: /Android 2\.3\.[3-7]/i.test(window.navigator.userAgent),
					isChrome: window.chrome,
					isFirefox: /Firefox/i.test(window.navigator.userAgent),
					/* Create a cached element for re-use when checking for CSS property prefixes. */
					prefixElement: document.createElement("div"),
					/* Cache every prefix match to avoid repeating lookups. */
					prefixMatches: {},
					/* Cache the anchor used for animating window scrolling. */
					scrollAnchor: null,
					/* Cache the browser-specific property names associated with the scroll anchor. */
					scrollPropertyLeft: null,
					scrollPropertyTop: null,
					/* Keep track of whether our RAF tick is running. */
					isTicking: false,
					/* Container for every in-progress call to Velocity. */
					calls: [],
					delayedElements: {
						count: 0
					}
				},
				/* Velocity's custom CSS stack. Made global for unit testing. */
				CSS: {/* Defined below. */},
				/* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
				Utilities: $,
				/* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
				Redirects: {/* Manually registered by the user. */},
				Easings: {/* Defined below. */},
				/* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
				Promise: window.Promise,
				/* Velocity option defaults, which can be overriden by the user. */
				defaults: {
					queue: "",
					duration: DURATION_DEFAULT,
					easing: EASING_DEFAULT,
					begin: undefined,
					complete: undefined,
					progress: undefined,
					display: undefined,
					visibility: undefined,
					loop: false,
					delay: false,
					mobileHA: true,
					/* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
					_cacheValues: true,
					/* Advanced: Set to false if the promise should always resolve on empty element lists. */
					promiseRejectEmpty: true
				},
				/* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
				init: function(element) {
					$.data(element, "velocity", {
						/* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
						isSVG: Type.isSVG(element),
						/* Keep track of whether the element is currently being animated by Velocity.
						 This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
						isAnimating: false,
						/* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
						computedStyle: null,
						/* Tween data is cached for each animation on the element so that data can be passed across calls --
						 in particular, end values are used as subsequent start values in consecutive Velocity calls. */
						tweensContainer: null,
						/* The full root property values of each CSS hook being animated on this element are cached so that:
						 1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
						 2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
						rootPropertyValueCache: {},
						/* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
						transformCache: {}
					});
				},
				/* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
				hook: null, /* Defined below. */
				/* Velocity-wide animation time remapping for testing purposes. */
				mock: false,
				version: {major: 1, minor: 5, patch: 2},
				/* Set to 1 or 2 (most verbose) to output debug info to console. */
				debug: false,
				/* Use rAF high resolution timestamp when available */
				timestamp: true,
				/* Pause all animations */
				pauseAll: function(queueName) {
					var currentTime = (new Date()).getTime();
	
					$.each(Velocity.State.calls, function(i, activeCall) {
	
						if (activeCall) {
	
							/* If we have a queueName and this call is not on that queue, skip */
							if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
								return true;
							}
	
							/* Set call to paused */
							activeCall[5] = {
								resume: false
							};
						}
					});
	
					/* Pause timers on any currently delayed calls */
					$.each(Velocity.State.delayedElements, function(k, element) {
						if (!element) {
							return;
						}
						pauseDelayOnElement(element, currentTime);
					});
				},
				/* Resume all animations */
				resumeAll: function(queueName) {
					var currentTime = (new Date()).getTime();
	
					$.each(Velocity.State.calls, function(i, activeCall) {
	
						if (activeCall) {
	
							/* If we have a queueName and this call is not on that queue, skip */
							if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
								return true;
							}
	
							/* Set call to resumed if it was paused */
							if (activeCall[5]) {
								activeCall[5].resume = true;
							}
						}
					});
					/* Resume timers on any currently delayed calls */
					$.each(Velocity.State.delayedElements, function(k, element) {
						if (!element) {
							return;
						}
						resumeDelayOnElement(element, currentTime);
					});
				}
			};
	
			/* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
			if (window.pageYOffset !== undefined) {
				Velocity.State.scrollAnchor = window;
				Velocity.State.scrollPropertyLeft = "pageXOffset";
				Velocity.State.scrollPropertyTop = "pageYOffset";
			} else {
				Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
				Velocity.State.scrollPropertyLeft = "scrollLeft";
				Velocity.State.scrollPropertyTop = "scrollTop";
			}
	
			/* Shorthand alias for jQuery's $.data() utility. */
			function Data(element) {
				/* Hardcode a reference to the plugin name. */
				var response = $.data(element, "velocity");
	
				/* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
				return response === null ? undefined : response;
			}
	
			/**************
			 Delay Timer
			 **************/
	
			function pauseDelayOnElement(element, currentTime) {
				/* Check for any delay timers, and pause the set timeouts (while preserving time data)
				 to be resumed when the "resume" command is issued */
				var data = Data(element);
				if (data && data.delayTimer && !data.delayPaused) {
					data.delayRemaining = data.delay - currentTime + data.delayBegin;
					data.delayPaused = true;
					clearTimeout(data.delayTimer.setTimeout);
				}
			}
	
			function resumeDelayOnElement(element, currentTime) {
				/* Check for any paused timers and resume */
				var data = Data(element);
				if (data && data.delayTimer && data.delayPaused) {
					/* If the element was mid-delay, re initiate the timeout with the remaining delay */
					data.delayPaused = false;
					data.delayTimer.setTimeout = setTimeout(data.delayTimer.next, data.delayRemaining);
				}
			}
	
	
	
			/**************
			 Easing
			 **************/
	
			/* Step easing generator. */
			function generateStep(steps) {
				return function(p) {
					return Math.round(p * steps) * (1 / steps);
				};
			}
	
			/* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			function generateBezier(mX1, mY1, mX2, mY2) {
				var NEWTON_ITERATIONS = 4,
						NEWTON_MIN_SLOPE = 0.001,
						SUBDIVISION_PRECISION = 0.0000001,
						SUBDIVISION_MAX_ITERATIONS = 10,
						kSplineTableSize = 11,
						kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
						float32ArraySupported = "Float32Array" in window;
	
				/* Must contain four arguments. */
				if (arguments.length !== 4) {
					return false;
				}
	
				/* Arguments must be numbers. */
				for (var i = 0; i < 4; ++i) {
					if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
						return false;
					}
				}
	
				/* X values must be in the [0, 1] range. */
				mX1 = Math.min(mX1, 1);
				mX2 = Math.min(mX2, 1);
				mX1 = Math.max(mX1, 0);
				mX2 = Math.max(mX2, 0);
	
				var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	
				function A(aA1, aA2) {
					return 1.0 - 3.0 * aA2 + 3.0 * aA1;
				}
				function B(aA1, aA2) {
					return 3.0 * aA2 - 6.0 * aA1;
				}
				function C(aA1) {
					return 3.0 * aA1;
				}
	
				function calcBezier(aT, aA1, aA2) {
					return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
				}
	
				function getSlope(aT, aA1, aA2) {
					return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
				}
	
				function newtonRaphsonIterate(aX, aGuessT) {
					for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
						var currentSlope = getSlope(aGuessT, mX1, mX2);
	
						if (currentSlope === 0.0) {
							return aGuessT;
						}
	
						var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
						aGuessT -= currentX / currentSlope;
					}
	
					return aGuessT;
				}
	
				function calcSampleValues() {
					for (var i = 0; i < kSplineTableSize; ++i) {
						mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
					}
				}
	
				function binarySubdivide(aX, aA, aB) {
					var currentX, currentT, i = 0;
	
					do {
						currentT = aA + (aB - aA) / 2.0;
						currentX = calcBezier(currentT, mX1, mX2) - aX;
						if (currentX > 0.0) {
							aB = currentT;
						} else {
							aA = currentT;
						}
					} while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	
					return currentT;
				}
	
				function getTForX(aX) {
					var intervalStart = 0.0,
							currentSample = 1,
							lastSample = kSplineTableSize - 1;
	
					for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
						intervalStart += kSampleStepSize;
					}
	
					--currentSample;
	
					var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]),
							guessForT = intervalStart + dist * kSampleStepSize,
							initialSlope = getSlope(guessForT, mX1, mX2);
	
					if (initialSlope >= NEWTON_MIN_SLOPE) {
						return newtonRaphsonIterate(aX, guessForT);
					} else if (initialSlope === 0.0) {
						return guessForT;
					} else {
						return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
					}
				}
	
				var _precomputed = false;
	
				function precompute() {
					_precomputed = true;
					if (mX1 !== mY1 || mX2 !== mY2) {
						calcSampleValues();
					}
				}
	
				var f = function(aX) {
					if (!_precomputed) {
						precompute();
					}
					if (mX1 === mY1 && mX2 === mY2) {
						return aX;
					}
					if (aX === 0) {
						return 0;
					}
					if (aX === 1) {
						return 1;
					}
	
					return calcBezier(getTForX(aX), mY1, mY2);
				};
	
				f.getControlPoints = function() {
					return [{x: mX1, y: mY1}, {x: mX2, y: mY2}];
				};
	
				var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
				f.toString = function() {
					return str;
				};
	
				return f;
			}
	
			/* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			/* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
			 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
			var generateSpringRK4 = (function() {
				function springAccelerationForState(state) {
					return (-state.tension * state.x) - (state.friction * state.v);
				}
	
				function springEvaluateStateWithDerivative(initialState, dt, derivative) {
					var state = {
						x: initialState.x + derivative.dx * dt,
						v: initialState.v + derivative.dv * dt,
						tension: initialState.tension,
						friction: initialState.friction
					};
	
					return {dx: state.v, dv: springAccelerationForState(state)};
				}
	
				function springIntegrateState(state, dt) {
					var a = {
						dx: state.v,
						dv: springAccelerationForState(state)
					},
							b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
							c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
							d = springEvaluateStateWithDerivative(state, dt, c),
							dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
							dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
	
					state.x = state.x + dxdt * dt;
					state.v = state.v + dvdt * dt;
	
					return state;
				}
	
				return function springRK4Factory(tension, friction, duration) {
	
					var initState = {
						x: -1,
						v: 0,
						tension: null,
						friction: null
					},
							path = [0],
							time_lapsed = 0,
							tolerance = 1 / 10000,
							DT = 16 / 1000,
							have_duration, dt, last_state;
	
					tension = parseFloat(tension) || 500;
					friction = parseFloat(friction) || 20;
					duration = duration || null;
	
					initState.tension = tension;
					initState.friction = friction;
	
					have_duration = duration !== null;
	
					/* Calculate the actual time it takes for this animation to complete with the provided conditions. */
					if (have_duration) {
						/* Run the simulation without a duration. */
						time_lapsed = springRK4Factory(tension, friction);
						/* Compute the adjusted time delta. */
						dt = time_lapsed / duration * DT;
					} else {
						dt = DT;
					}
	
					while (true) {
						/* Next/step function .*/
						last_state = springIntegrateState(last_state || initState, dt);
						/* Store the position. */
						path.push(1 + last_state.x);
						time_lapsed += 16;
						/* If the change threshold is reached, break. */
						if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
							break;
						}
					}
	
					/* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
					 computed path and returns a snapshot of the position according to a given percentComplete. */
					return !have_duration ? time_lapsed : function(percentComplete) {
						return path[ (percentComplete * (path.length - 1)) | 0 ];
					};
				};
			}());
	
			/* jQuery easings. */
			Velocity.Easings = {
				linear: function(p) {
					return p;
				},
				swing: function(p) {
					return 0.5 - Math.cos(p * Math.PI) / 2;
				},
				/* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
				spring: function(p) {
					return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6));
				}
			};
	
			/* CSS3 and Robert Penner easings. */
			$.each(
					[
						["ease", [0.25, 0.1, 0.25, 1.0]],
						["ease-in", [0.42, 0.0, 1.00, 1.0]],
						["ease-out", [0.00, 0.0, 0.58, 1.0]],
						["ease-in-out", [0.42, 0.0, 0.58, 1.0]],
						["easeInSine", [0.47, 0, 0.745, 0.715]],
						["easeOutSine", [0.39, 0.575, 0.565, 1]],
						["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
						["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
						["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
						["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
						["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
						["easeOutCubic", [0.215, 0.61, 0.355, 1]],
						["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
						["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
						["easeOutQuart", [0.165, 0.84, 0.44, 1]],
						["easeInOutQuart", [0.77, 0, 0.175, 1]],
						["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
						["easeOutQuint", [0.23, 1, 0.32, 1]],
						["easeInOutQuint", [0.86, 0, 0.07, 1]],
						["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
						["easeOutExpo", [0.19, 1, 0.22, 1]],
						["easeInOutExpo", [1, 0, 0, 1]],
						["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
						["easeOutCirc", [0.075, 0.82, 0.165, 1]],
						["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]]
					], function(i, easingArray) {
				Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
			});
	
			/* Determine the appropriate easing type given an easing input. */
			function getEasing(value, duration) {
				var easing = value;
	
				/* The easing option can either be a string that references a pre-registered easing,
				 or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
				if (Type.isString(value)) {
					/* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
					if (!Velocity.Easings[value]) {
						easing = false;
					}
				} else if (Type.isArray(value) && value.length === 1) {
					easing = generateStep.apply(null, value);
				} else if (Type.isArray(value) && value.length === 2) {
					/* springRK4 must be passed the animation's duration. */
					/* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
					 function generated with default tension and friction values. */
					easing = generateSpringRK4.apply(null, value.concat([duration]));
				} else if (Type.isArray(value) && value.length === 4) {
					/* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
					easing = generateBezier.apply(null, value);
				} else {
					easing = false;
				}
	
				/* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
				 if the Velocity-wide default has been incorrectly modified. */
				if (easing === false) {
					if (Velocity.Easings[Velocity.defaults.easing]) {
						easing = Velocity.defaults.easing;
					} else {
						easing = EASING_DEFAULT;
					}
				}
	
				return easing;
			}
	
			/*****************
			 CSS Stack
			 *****************/
	
			/* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
			 It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
			/* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
			var CSS = Velocity.CSS = {
				/*************
				 RegEx
				 *************/
	
				RegEx: {
					isHex: /^#([A-f\d]{3}){1,2}$/i,
					/* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
					valueUnwrap: /^[A-z]+\((.*)\)$/i,
					wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
					/* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
					valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
				},
				/************
				 Lists
				 ************/
	
				Lists: {
					colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
					transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
					transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
					units: [
						"%", // relative
						"em", "ex", "ch", "rem", // font relative
						"vw", "vh", "vmin", "vmax", // viewport relative
						"cm", "mm", "Q", "in", "pc", "pt", "px", // absolute lengths
						"deg", "grad", "rad", "turn", // angles
						"s", "ms" // time
					],
					colorNames: {
						"aliceblue": "240,248,255",
						"antiquewhite": "250,235,215",
						"aquamarine": "127,255,212",
						"aqua": "0,255,255",
						"azure": "240,255,255",
						"beige": "245,245,220",
						"bisque": "255,228,196",
						"black": "0,0,0",
						"blanchedalmond": "255,235,205",
						"blueviolet": "138,43,226",
						"blue": "0,0,255",
						"brown": "165,42,42",
						"burlywood": "222,184,135",
						"cadetblue": "95,158,160",
						"chartreuse": "127,255,0",
						"chocolate": "210,105,30",
						"coral": "255,127,80",
						"cornflowerblue": "100,149,237",
						"cornsilk": "255,248,220",
						"crimson": "220,20,60",
						"cyan": "0,255,255",
						"darkblue": "0,0,139",
						"darkcyan": "0,139,139",
						"darkgoldenrod": "184,134,11",
						"darkgray": "169,169,169",
						"darkgrey": "169,169,169",
						"darkgreen": "0,100,0",
						"darkkhaki": "189,183,107",
						"darkmagenta": "139,0,139",
						"darkolivegreen": "85,107,47",
						"darkorange": "255,140,0",
						"darkorchid": "153,50,204",
						"darkred": "139,0,0",
						"darksalmon": "233,150,122",
						"darkseagreen": "143,188,143",
						"darkslateblue": "72,61,139",
						"darkslategray": "47,79,79",
						"darkturquoise": "0,206,209",
						"darkviolet": "148,0,211",
						"deeppink": "255,20,147",
						"deepskyblue": "0,191,255",
						"dimgray": "105,105,105",
						"dimgrey": "105,105,105",
						"dodgerblue": "30,144,255",
						"firebrick": "178,34,34",
						"floralwhite": "255,250,240",
						"forestgreen": "34,139,34",
						"fuchsia": "255,0,255",
						"gainsboro": "220,220,220",
						"ghostwhite": "248,248,255",
						"gold": "255,215,0",
						"goldenrod": "218,165,32",
						"gray": "128,128,128",
						"grey": "128,128,128",
						"greenyellow": "173,255,47",
						"green": "0,128,0",
						"honeydew": "240,255,240",
						"hotpink": "255,105,180",
						"indianred": "205,92,92",
						"indigo": "75,0,130",
						"ivory": "255,255,240",
						"khaki": "240,230,140",
						"lavenderblush": "255,240,245",
						"lavender": "230,230,250",
						"lawngreen": "124,252,0",
						"lemonchiffon": "255,250,205",
						"lightblue": "173,216,230",
						"lightcoral": "240,128,128",
						"lightcyan": "224,255,255",
						"lightgoldenrodyellow": "250,250,210",
						"lightgray": "211,211,211",
						"lightgrey": "211,211,211",
						"lightgreen": "144,238,144",
						"lightpink": "255,182,193",
						"lightsalmon": "255,160,122",
						"lightseagreen": "32,178,170",
						"lightskyblue": "135,206,250",
						"lightslategray": "119,136,153",
						"lightsteelblue": "176,196,222",
						"lightyellow": "255,255,224",
						"limegreen": "50,205,50",
						"lime": "0,255,0",
						"linen": "250,240,230",
						"magenta": "255,0,255",
						"maroon": "128,0,0",
						"mediumaquamarine": "102,205,170",
						"mediumblue": "0,0,205",
						"mediumorchid": "186,85,211",
						"mediumpurple": "147,112,219",
						"mediumseagreen": "60,179,113",
						"mediumslateblue": "123,104,238",
						"mediumspringgreen": "0,250,154",
						"mediumturquoise": "72,209,204",
						"mediumvioletred": "199,21,133",
						"midnightblue": "25,25,112",
						"mintcream": "245,255,250",
						"mistyrose": "255,228,225",
						"moccasin": "255,228,181",
						"navajowhite": "255,222,173",
						"navy": "0,0,128",
						"oldlace": "253,245,230",
						"olivedrab": "107,142,35",
						"olive": "128,128,0",
						"orangered": "255,69,0",
						"orange": "255,165,0",
						"orchid": "218,112,214",
						"palegoldenrod": "238,232,170",
						"palegreen": "152,251,152",
						"paleturquoise": "175,238,238",
						"palevioletred": "219,112,147",
						"papayawhip": "255,239,213",
						"peachpuff": "255,218,185",
						"peru": "205,133,63",
						"pink": "255,192,203",
						"plum": "221,160,221",
						"powderblue": "176,224,230",
						"purple": "128,0,128",
						"red": "255,0,0",
						"rosybrown": "188,143,143",
						"royalblue": "65,105,225",
						"saddlebrown": "139,69,19",
						"salmon": "250,128,114",
						"sandybrown": "244,164,96",
						"seagreen": "46,139,87",
						"seashell": "255,245,238",
						"sienna": "160,82,45",
						"silver": "192,192,192",
						"skyblue": "135,206,235",
						"slateblue": "106,90,205",
						"slategray": "112,128,144",
						"snow": "255,250,250",
						"springgreen": "0,255,127",
						"steelblue": "70,130,180",
						"tan": "210,180,140",
						"teal": "0,128,128",
						"thistle": "216,191,216",
						"tomato": "255,99,71",
						"turquoise": "64,224,208",
						"violet": "238,130,238",
						"wheat": "245,222,179",
						"whitesmoke": "245,245,245",
						"white": "255,255,255",
						"yellowgreen": "154,205,50",
						"yellow": "255,255,0"
					}
				},
				/************
				 Hooks
				 ************/
	
				/* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
				 (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
				/* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
				 tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
				Hooks: {
					/********************
					 Registration
					 ********************/
	
					/* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
					/* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
					templates: {
						"textShadow": ["Color X Y Blur", "black 0px 0px 0px"],
						"boxShadow": ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
						"clip": ["Top Right Bottom Left", "0px 0px 0px 0px"],
						"backgroundPosition": ["X Y", "0% 0%"],
						"transformOrigin": ["X Y Z", "50% 50% 0px"],
						"perspectiveOrigin": ["X Y", "50% 50%"]
					},
					/* A "registered" hook is one that has been converted from its template form into a live,
					 tweenable property. It contains data to associate it with its root property. */
					registered: {
						/* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
						 which consists of the subproperty's name, the associated root property's name,
						 and the subproperty's position in the root's value. */
					},
					/* Convert the templates into individual hooks then append them to the registered object above. */
					register: function() {
						/* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
						 currently set to "transparent" default to their respective template below when color-animated,
						 and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
						 which is almost always set closer to black than white. */
						for (var i = 0; i < CSS.Lists.colors.length; i++) {
							var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
							CSS.Hooks.templates[CSS.Lists.colors[i]] = ["Red Green Blue Alpha", rgbComponents];
						}
	
						var rootProperty,
								hookTemplate,
								hookNames;
	
						/* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
						 Thus, we re-arrange the templates accordingly. */
						if (IE) {
							for (rootProperty in CSS.Hooks.templates) {
								if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
									continue;
								}
								hookTemplate = CSS.Hooks.templates[rootProperty];
								hookNames = hookTemplate[0].split(" ");
	
								var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);
	
								if (hookNames[0] === "Color") {
									/* Reposition both the hook's name and its default value to the end of their respective strings. */
									hookNames.push(hookNames.shift());
									defaultValues.push(defaultValues.shift());
	
									/* Replace the existing template for the hook's root property. */
									CSS.Hooks.templates[rootProperty] = [hookNames.join(" "), defaultValues.join(" ")];
								}
							}
						}
	
						/* Hook registration. */
						for (rootProperty in CSS.Hooks.templates) {
							if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
								continue;
							}
							hookTemplate = CSS.Hooks.templates[rootProperty];
							hookNames = hookTemplate[0].split(" ");
	
							for (var j in hookNames) {
								if (!hookNames.hasOwnProperty(j)) {
									continue;
								}
								var fullHookName = rootProperty + hookNames[j],
										hookPosition = j;
	
								/* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
								 and the hook's position in its template's default value string. */
								CSS.Hooks.registered[fullHookName] = [rootProperty, hookPosition];
							}
						}
					},
					/*****************************
					 Injection and Extraction
					 *****************************/
	
					/* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
					/* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
					getRoot: function(property) {
						var hookData = CSS.Hooks.registered[property];
	
						if (hookData) {
							return hookData[0];
						} else {
							/* If there was no hook match, return the property name untouched. */
							return property;
						}
					},
					getUnit: function(str, start) {
						var unit = (str.substr(start || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
	
						if (unit && _inArray(CSS.Lists.units, unit)) {
							return unit;
						}
						return "";
					},
					fixColors: function(str) {
						return str.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function($0, $1, $2) {
							if (CSS.Lists.colorNames.hasOwnProperty($2)) {
								return ($1 ? $1 : "rgba(") + CSS.Lists.colorNames[$2] + ($1 ? "" : ",1)");
							}
							return $1 + $2;
						});
					},
					/* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
					 the targeted hook can be injected or extracted at its standard position. */
					cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
						/* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
						if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
							rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
						}
	
						/* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
						 default to the root's default value as defined in CSS.Hooks.templates. */
						/* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
						 zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
						if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
							rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
						}
	
						return rootPropertyValue;
					},
					/* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
					extractValue: function(fullHookName, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];
	
						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1];
	
							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
							/* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
							return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					},
					/* Inject the hook's value into its root property's value. This is used to piece back together the root property
					 once Velocity has updated one of its individually hooked values through tweening. */
					injectValue: function(fullHookName, hookValue, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];
	
						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1],
									rootPropertyValueParts,
									rootPropertyValueUpdated;
	
							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
							/* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
							 then reconstruct the rootPropertyValue string. */
							rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
							rootPropertyValueParts[hookPosition] = hookValue;
							rootPropertyValueUpdated = rootPropertyValueParts.join(" ");
	
							return rootPropertyValueUpdated;
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					}
				},
				/*******************
				 Normalizations
				 *******************/
	
				/* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
				 and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
				Normalizations: {
					/* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
					 the targeted element (which may need to be queried), and the targeted property value. */
					registered: {
						clip: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return "clip";
									/* Clip needs to be unwrapped and stripped of its commas during extraction. */
								case "extract":
									var extracted;
	
									/* If Velocity also extracted this value, skip extraction. */
									if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
										extracted = propertyValue;
									} else {
										/* Remove the "rect()" wrapper. */
										extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);
	
										/* Strip off commas. */
										extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
									}
	
									return extracted;
									/* Clip needs to be re-wrapped during injection. */
								case "inject":
									return "rect(" + propertyValue + ")";
							}
						},
						blur: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
								case "extract":
									var extracted = parseFloat(propertyValue);
	
									/* If extracted is NaN, meaning the value isn't already extracted. */
									if (!(extracted || extracted === 0)) {
										var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
	
										/* If the filter string had a blur component, return just the blur value and unit type. */
										if (blurComponent) {
											extracted = blurComponent[1];
											/* If the component doesn't exist, default blur to 0. */
										} else {
											extracted = 0;
										}
									}
	
									return extracted;
									/* Blur needs to be re-wrapped during injection. */
								case "inject":
									/* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
									if (!parseFloat(propertyValue)) {
										return "none";
									} else {
										return "blur(" + propertyValue + ")";
									}
							}
						},
						/* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
						opacity: function(type, element, propertyValue) {
							if (IE <= 8) {
								switch (type) {
									case "name":
										return "filter";
									case "extract":
										/* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
										 Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
										var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);
	
										if (extracted) {
											/* Convert to decimal value. */
											propertyValue = extracted[1] / 100;
										} else {
											/* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
											propertyValue = 1;
										}
	
										return propertyValue;
									case "inject":
										/* Opacified elements are required to have their zoom property set to a non-zero value. */
										element.style.zoom = 1;
	
										/* Setting the filter property on elements with certain font property combinations can result in a
										 highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
										 value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
										if (parseFloat(propertyValue) >= 1) {
											return "";
										} else {
											/* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
											return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
										}
								}
								/* With all other browsers, normalization is not required; return the same values that were passed in. */
							} else {
								switch (type) {
									case "name":
										return "opacity";
									case "extract":
										return propertyValue;
									case "inject":
										return propertyValue;
								}
							}
						}
					},
					/*****************************
					 Batched Registrations
					 *****************************/
	
					/* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
					register: function() {
	
						/*****************
						 Transforms
						 *****************/
	
						/* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
						 so that they can be referenced in a properties map by their individual names. */
						/* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
						 setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
						 Transform setting is batched in this way to improve performance: the transform style only needs to be updated
						 once when multiple transform subproperties are being animated simultaneously. */
						/* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
						 transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
						 from being normalized for these browsers so that tweening skips these properties altogether
						 (since it will ignore them as being unsupported by the browser.) */
						if ((!IE || IE > 9) && !Velocity.State.isGingerbread) {
							/* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
							 share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
							CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
						}
	
						for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
							/* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
							 paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
							(function() {
								var transformName = CSS.Lists.transformsBase[i];
	
								CSS.Normalizations.registered[transformName] = function(type, element, propertyValue) {
									switch (type) {
										/* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
										case "name":
											return "transform";
											/* Transform values are cached onto a per-element transformCache object. */
										case "extract":
											/* If this transform has yet to be assigned a value, return its null value. */
											if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
												/* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
												return /^scale/i.test(transformName) ? 1 : 0;
												/* When transform values are set, they are wrapped in parentheses as per the CSS spec.
												 Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
											}
											return Data(element).transformCache[transformName].replace(/[()]/g, "");
										case "inject":
											var invalid = false;
	
											/* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
											 Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
											/* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
											switch (transformName.substr(0, transformName.length - 1)) {
												/* Whitelist unit types for each transform. */
												case "translate":
													invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
													break;
													/* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
												case "scal":
												case "scale":
													/* Chrome on Android has a bug in which scaled elements blur if their initial scale
													 value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
													 and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
													if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
														propertyValue = 1;
													}
	
													invalid = !/(\d)$/i.test(propertyValue);
													break;
												case "skew":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
												case "rotate":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
											}
	
											if (!invalid) {
												/* As per the CSS spec, wrap the value in parentheses. */
												Data(element).transformCache[transformName] = "(" + propertyValue + ")";
											}
	
											/* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
											return Data(element).transformCache[transformName];
									}
								};
							})();
						}
	
						/*************
						 Colors
						 *************/
	
						/* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
						 Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
						for (var j = 0; j < CSS.Lists.colors.length; j++) {
							/* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
							 (Otherwise, all functions would take the final for loop's colorName.) */
							(function() {
								var colorName = CSS.Lists.colors[j];
	
								/* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
								CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
									switch (type) {
										case "name":
											return colorName;
											/* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
										case "extract":
											var extracted;
	
											/* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
											if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
												extracted = propertyValue;
											} else {
												var converted,
														colorNames = {
															black: "rgb(0, 0, 0)",
															blue: "rgb(0, 0, 255)",
															gray: "rgb(128, 128, 128)",
															green: "rgb(0, 128, 0)",
															red: "rgb(255, 0, 0)",
															white: "rgb(255, 255, 255)"
														};
	
												/* Convert color names to rgb. */
												if (/^[A-z]+$/i.test(propertyValue)) {
													if (colorNames[propertyValue] !== undefined) {
														converted = colorNames[propertyValue];
													} else {
														/* If an unmatched color name is provided, default to black. */
														converted = colorNames.black;
													}
													/* Convert hex values to rgb. */
												} else if (CSS.RegEx.isHex.test(propertyValue)) {
													converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
													/* If the provided color doesn't match any of the accepted color formats, default to black. */
												} else if (!(/^rgba?\(/i.test(propertyValue))) {
													converted = colorNames.black;
												}
	
												/* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
												 repeated spaces (in case the value included spaces to begin with). */
												extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
											}
	
											/* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											if ((!IE || IE > 8) && extracted.split(" ").length === 3) {
												extracted += " 1";
											}
	
											return extracted;
										case "inject":
											/* If we have a pattern then it might already have the right values */
											if (/^rgb/.test(propertyValue)) {
												return propertyValue;
											}
	
											/* If this is IE<=8 and an alpha component exists, strip it off. */
											if (IE <= 8) {
												if (propertyValue.split(" ").length === 4) {
													propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
												}
												/* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											} else if (propertyValue.split(" ").length === 3) {
												propertyValue += " 1";
											}
	
											/* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
											 on all values but the fourth (R, G, and B only accept whole numbers). */
											return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
									}
								};
							})();
						}
	
						/**************
						 Dimensions
						 **************/
						function augmentDimension(name, element, wantInner) {
							var isBorderBox = CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box";
	
							if (isBorderBox === (wantInner || false)) {
								/* in box-sizing mode, the CSS width / height accessors already give the outerWidth / outerHeight. */
								var i,
										value,
										augment = 0,
										sides = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"],
										fields = ["padding" + sides[0], "padding" + sides[1], "border" + sides[0] + "Width", "border" + sides[1] + "Width"];
	
								for (i = 0; i < fields.length; i++) {
									value = parseFloat(CSS.getPropertyValue(element, fields[i]));
									if (!isNaN(value)) {
										augment += value;
									}
								}
								return wantInner ? -augment : augment;
							}
							return 0;
						}
						function getDimension(name, wantInner) {
							return function(type, element, propertyValue) {
								switch (type) {
									case "name":
										return name;
									case "extract":
										return parseFloat(propertyValue) + augmentDimension(name, element, wantInner);
									case "inject":
										return (parseFloat(propertyValue) - augmentDimension(name, element, wantInner)) + "px";
								}
							};
						}
						CSS.Normalizations.registered.innerWidth = getDimension("width", true);
						CSS.Normalizations.registered.innerHeight = getDimension("height", true);
						CSS.Normalizations.registered.outerWidth = getDimension("width");
						CSS.Normalizations.registered.outerHeight = getDimension("height");
					}
				},
				/************************
				 CSS Property Names
				 ************************/
	
				Names: {
					/* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
					 Camelcasing is used to normalize property names between and across calls. */
					camelCase: function(property) {
						return property.replace(/-(\w)/g, function(match, subMatch) {
							return subMatch.toUpperCase();
						});
					},
					/* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
					SVGAttribute: function(property) {
						var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
	
						/* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
						if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
							SVGAttributes += "|transform";
						}
	
						return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
					},
					/* Determine whether a property should be set with a vendor prefix. */
					/* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
					 If the property is not at all supported by the browser, return a false flag. */
					prefixCheck: function(property) {
						/* If this property has already been checked, return the cached value. */
						if (Velocity.State.prefixMatches[property]) {
							return [Velocity.State.prefixMatches[property], true];
						} else {
							var vendors = ["", "Webkit", "Moz", "ms", "O"];
	
							for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
								var propertyPrefixed;
	
								if (i === 0) {
									propertyPrefixed = property;
								} else {
									/* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
									propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) {
										return match.toUpperCase();
									});
								}
	
								/* Check if the browser supports this property as prefixed. */
								if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
									/* Cache the match. */
									Velocity.State.prefixMatches[property] = propertyPrefixed;
	
									return [propertyPrefixed, true];
								}
							}
	
							/* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
							return [property, false];
						}
					}
				},
				/************************
				 CSS Property Values
				 ************************/
	
				Values: {
					/* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
					hexToRgb: function(hex) {
						var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
								longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
								rgbParts;
	
						hex = hex.replace(shortformRegex, function(m, r, g, b) {
							return r + r + g + g + b + b;
						});
	
						rgbParts = longformRegex.exec(hex);
	
						return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0];
					},
					isCSSNullValue: function(value) {
						/* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
						 Thus, we check for both falsiness and these special strings. */
						/* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
						 templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
						/* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
						return (!value || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
					},
					/* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
					getUnitType: function(property) {
						if (/^(rotate|skew)/i.test(property)) {
							return "deg";
						} else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
							/* The above properties are unitless. */
							return "";
						} else {
							/* Default to px for all other properties. */
							return "px";
						}
					},
					/* HTML elements default to an associated display type when they're not set to display:none. */
					/* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
					getDisplayType: function(element) {
						var tagName = element && element.tagName.toString().toLowerCase();
	
						if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
							return "inline";
						} else if (/^(li)$/i.test(tagName)) {
							return "list-item";
						} else if (/^(tr)$/i.test(tagName)) {
							return "table-row";
						} else if (/^(table)$/i.test(tagName)) {
							return "table";
						} else if (/^(tbody)$/i.test(tagName)) {
							return "table-row-group";
							/* Default to "block" when no match is found. */
						} else {
							return "block";
						}
					},
					/* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
					addClass: function(element, className) {
						if (element) {
							if (element.classList) {
								element.classList.add(className);
							} else if (Type.isString(element.className)) {
								// Element.className is around 15% faster then set/getAttribute
								element.className += (element.className.length ? " " : "") + className;
							} else {
								// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
								var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";
	
								element.setAttribute("class", currentClass + (currentClass ? " " : "") + className);
							}
						}
					},
					removeClass: function(element, className) {
						if (element) {
							if (element.classList) {
								element.classList.remove(className);
							} else if (Type.isString(element.className)) {
								// Element.className is around 15% faster then set/getAttribute
								// TODO: Need some jsperf tests on performance - can we get rid of the regex and maybe use split / array manipulation?
								element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
							} else {
								// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
								var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";
	
								element.setAttribute("class", currentClass.replace(new RegExp("(^|\s)" + className.split(" ").join("|") + "(\s|$)", "gi"), " "));
							}
						}
					}
				},
				/****************************
				 Style Getting & Setting
				 ****************************/
	
				/* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				getPropertyValue: function(element, property, rootPropertyValue, forceStyleLookup) {
					/* Get an element's computed property value. */
					/* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
					 style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
					 *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
					function computePropertyValue(element, property) {
						/* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
						 element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
						 offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
						 We subtract border and padding to get the sum of interior + scrollbar. */
						var computedValue = 0;
	
						/* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
						 of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
						 codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
						 Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
						if (IE <= 8) {
							computedValue = $.css(element, property); /* GET */
							/* All other browsers support getComputedStyle. The returned live object reference is cached onto its
							 associated element so that it does not need to be refetched upon every GET. */
						} else {
							/* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
							 toggle display to the element type's default value. */
							var toggleDisplay = false;
	
							if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
								toggleDisplay = true;
								CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
							}
	
							var revertDisplay = function() {
								if (toggleDisplay) {
									CSS.setPropertyValue(element, "display", "none");
								}
							};
	
							if (!forceStyleLookup) {
								if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
									revertDisplay();
	
									return contentBoxHeight;
								} else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
									revertDisplay();
	
									return contentBoxWidth;
								}
							}
	
							var computedStyle;
	
							/* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
							 of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
							if (Data(element) === undefined) {
								computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If the computedStyle object has yet to be cached, do so now. */
							} else if (!Data(element).computedStyle) {
								computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If computedStyle is cached, use it. */
							} else {
								computedStyle = Data(element).computedStyle;
							}
	
							/* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
							 Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
							 So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
							if (property === "borderColor") {
								property = "borderTopColor";
							}
	
							/* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
							 instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
							if (IE === 9 && property === "filter") {
								computedValue = computedStyle.getPropertyValue(property); /* GET */
							} else {
								computedValue = computedStyle[property];
							}
	
							/* Fall back to the property's style value (if defined) when computedValue returns nothing,
							 which can happen when the element hasn't been painted. */
							if (computedValue === "" || computedValue === null) {
								computedValue = element.style[property];
							}
	
							revertDisplay();
						}
	
						/* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
						 defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
						 effect as being set to 0, so no conversion is necessary.) */
						/* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
						 property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
						 to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
						if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
							var position = computePropertyValue(element, "position"); /* GET */
	
							/* For absolute positioning, jQuery's $.position() only returns values for top and left;
							 right and bottom will have their "auto" value reverted to 0. */
							/* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
							 Not a big deal since we're currently in a GET batch anyway. */
							if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
								/* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
								computedValue = $(element).position()[property] + "px"; /* GET */
							}
						}
	
						return computedValue;
					}
	
					var propertyValue;
	
					/* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
					 extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
					if (CSS.Hooks.registered[property]) {
						var hook = property,
								hookRoot = CSS.Hooks.getRoot(hook);
	
						/* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
						 query the DOM for the root property's value. */
						if (rootPropertyValue === undefined) {
							/* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
							rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
						}
	
						/* If this root has a normalization registered, peform the associated normalization extraction. */
						if (CSS.Normalizations.registered[hookRoot]) {
							rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
						}
	
						/* Extract the hook's value. */
						propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);
	
						/* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
						 normalize the property's name and value, and handle the special case of transforms. */
						/* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
						 numerical and therefore do not require normalization extraction. */
					} else if (CSS.Normalizations.registered[property]) {
						var normalizedPropertyName,
								normalizedPropertyValue;
	
						normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);
	
						/* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
						 At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
						 This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
						 thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
						if (normalizedPropertyName !== "transform") {
							normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */
	
							/* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
							if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
								normalizedPropertyValue = CSS.Hooks.templates[property][1];
							}
						}
	
						propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
					}
	
					/* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
					if (!/^[\d-]/.test(propertyValue)) {
						/* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
						 their HTML attribute values instead of their CSS style values. */
						var data = Data(element);
	
						if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
							/* Since the height/width attribute values must be set manually, they don't reflect computed values.
							 Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
							if (/^(height|width)$/i.test(property)) {
								/* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
								try {
									propertyValue = element.getBBox()[property];
								} catch (error) {
									propertyValue = 0;
								}
								/* Otherwise, access the attribute value directly. */
							} else {
								propertyValue = element.getAttribute(property);
							}
						} else {
							propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
						}
					}
	
					/* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
					 convert CSS null-values to an integer of value 0. */
					if (CSS.Values.isCSSNullValue(propertyValue)) {
						propertyValue = 0;
					}
	
					if (Velocity.debug >= 2) {
						console.log("Get " + property + ": " + propertyValue);
					}
	
					return propertyValue;
				},
				/* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
					var propertyName = property;
	
					/* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
					if (property === "scroll") {
						/* If a container option is present, scroll the container instead of the browser window. */
						if (scrollData.container) {
							scrollData.container["scroll" + scrollData.direction] = propertyValue;
							/* Otherwise, Velocity defaults to scrolling the browser window. */
						} else {
							if (scrollData.direction === "Left") {
								window.scrollTo(propertyValue, scrollData.alternateValue);
							} else {
								window.scrollTo(scrollData.alternateValue, propertyValue);
							}
						}
					} else {
						/* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
						 Thus, for now, we merely cache transforms being SET. */
						if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
							/* Perform a normalization injection. */
							/* Note: The normalization logic handles the transformCache updating. */
							CSS.Normalizations.registered[property]("inject", element, propertyValue);
	
							propertyName = "transform";
							propertyValue = Data(element).transformCache[property];
						} else {
							/* Inject hooks. */
							if (CSS.Hooks.registered[property]) {
								var hookName = property,
										hookRoot = CSS.Hooks.getRoot(property);
	
								/* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
								rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */
	
								propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
								property = hookRoot;
							}
	
							/* Normalize names and values. */
							if (CSS.Normalizations.registered[property]) {
								propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
								property = CSS.Normalizations.registered[property]("name", element);
							}
	
							/* Assign the appropriate vendor prefix before performing an official style update. */
							propertyName = CSS.Names.prefixCheck(property)[0];
	
							/* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
							 Try/catch is avoided for other browsers since it incurs a performance overhead. */
							if (IE <= 8) {
								try {
									element.style[propertyName] = propertyValue;
								} catch (error) {
									if (Velocity.debug) {
										console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]");
									}
								}
								/* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
								/* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
							} else {
								var data = Data(element);
	
								if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
									/* Note: For SVG attributes, vendor-prefixed property names are never used. */
									/* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
									element.setAttribute(property, propertyValue);
								} else {
									element.style[propertyName] = propertyValue;
								}
							}
	
							if (Velocity.debug >= 2) {
								console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
							}
						}
					}
	
					/* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
					return [propertyName, propertyValue];
				},
				/* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
				/* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
				flushTransformCache: function(element) {
					var transformString = "",
							data = Data(element);
	
					/* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
					 (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
					if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && data && data.isSVG) {
						/* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
						 Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
						var getTransformFloat = function(transformProperty) {
							return parseFloat(CSS.getPropertyValue(element, transformProperty));
						};
	
						/* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
						 we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
						var SVGTransforms = {
							translate: [getTransformFloat("translateX"), getTransformFloat("translateY")],
							skewX: [getTransformFloat("skewX")], skewY: [getTransformFloat("skewY")],
							/* If the scale property is set (non-1), use that value for the scaleX and scaleY values
							 (this behavior mimics the result of animating all these properties at once on HTML elements). */
							scale: getTransformFloat("scale") !== 1 ? [getTransformFloat("scale"), getTransformFloat("scale")] : [getTransformFloat("scaleX"), getTransformFloat("scaleY")],
							/* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
							 defining the rotation's origin point. We ignore the origin values (default them to 0). */
							rotate: [getTransformFloat("rotateZ"), 0, 0]
						};
	
						/* Iterate through the transform properties in the user-defined property map order.
						 (This mimics the behavior of non-SVG transform animation.) */
						$.each(Data(element).transformCache, function(transformName) {
							/* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
							 properties so that they match up with SVG's accepted transform properties. */
							if (/^translate/i.test(transformName)) {
								transformName = "translate";
							} else if (/^scale/i.test(transformName)) {
								transformName = "scale";
							} else if (/^rotate/i.test(transformName)) {
								transformName = "rotate";
							}
	
							/* Check that we haven't yet deleted the property from the SVGTransforms container. */
							if (SVGTransforms[transformName]) {
								/* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
								transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";
	
								/* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
								 re-insert the same master property if we encounter another one of its axis-specific properties. */
								delete SVGTransforms[transformName];
							}
						});
					} else {
						var transformValue,
								perspective;
	
						/* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
						$.each(Data(element).transformCache, function(transformName) {
							transformValue = Data(element).transformCache[transformName];
	
							/* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
							if (transformName === "transformPerspective") {
								perspective = transformValue;
								return true;
							}
	
							/* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
							if (IE === 9 && transformName === "rotateZ") {
								transformName = "rotate";
							}
	
							transformString += transformName + transformValue + " ";
						});
	
						/* If present, set the perspective subproperty first. */
						if (perspective) {
							transformString = "perspective" + perspective + " " + transformString;
						}
					}
	
					CSS.setPropertyValue(element, "transform", transformString);
				}
			};
	
			/* Register hooks and normalizations. */
			CSS.Hooks.register();
			CSS.Normalizations.register();
	
			/* Allow hook setting in the same fashion as jQuery's $.css(). */
			Velocity.hook = function(elements, arg2, arg3) {
				var value;
	
				elements = sanitizeElements(elements);
	
				$.each(elements, function(i, element) {
					/* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
					if (Data(element) === undefined) {
						Velocity.init(element);
					}
	
					/* Get property value. If an element set was passed in, only return the value for the first element. */
					if (arg3 === undefined) {
						if (value === undefined) {
							value = CSS.getPropertyValue(element, arg2);
						}
						/* Set property value. */
					} else {
						/* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
						var adjustedSet = CSS.setPropertyValue(element, arg2, arg3);
	
						/* Transform properties don't automatically set. They have to be flushed to the DOM. */
						if (adjustedSet[0] === "transform") {
							Velocity.CSS.flushTransformCache(element);
						}
	
						value = adjustedSet;
					}
				});
	
				return value;
			};
	
			/*****************
			 Animation
			 *****************/
	
			var animate = function() {
				var opts;
	
				/******************
				 Call Chain
				 ******************/
	
				/* Logic for determining what to return to the call stack when exiting out of Velocity. */
				function getChain() {
					/* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
					 default to null instead of returning the targeted elements so that utility function's return value is standardized. */
					if (isUtility) {
						return promiseData.promise || null;
						/* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
					} else {
						return elementsWrapped;
					}
				}
	
				/*************************
				 Arguments Assignment
				 *************************/
	
				/* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
				 objects are defined on a container object that's passed in as Velocity's sole argument. */
				/* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
				var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
						/* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
						isUtility,
						/* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
						 passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
						elementsWrapped,
						argumentIndex;
	
				var elements,
						propertiesMap,
						options;
	
				/* Detect jQuery/Zepto elements being animated via the $.fn method. */
				if (Type.isWrapped(this)) {
					isUtility = false;
	
					argumentIndex = 0;
					elements = this;
					elementsWrapped = this;
					/* Otherwise, raw elements are being animated via the utility function. */
				} else {
					isUtility = true;
	
					argumentIndex = 1;
					elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
				}
	
				/***************
				 Promises
				 ***************/
	
				var promiseData = {
					promise: null,
					resolver: null,
					rejecter: null
				};
	
				/* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
				 promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
				 method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
				 call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
				/* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
				 triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
				 grouped together for the purposes of resolving and rejecting a promise. */
				if (isUtility && Velocity.Promise) {
					promiseData.promise = new Velocity.Promise(function(resolve, reject) {
						promiseData.resolver = resolve;
						promiseData.rejecter = reject;
					});
				}
	
				if (syntacticSugar) {
					propertiesMap = arguments[0].properties || arguments[0].p;
					options = arguments[0].options || arguments[0].o;
				} else {
					propertiesMap = arguments[argumentIndex];
					options = arguments[argumentIndex + 1];
				}
	
				elements = sanitizeElements(elements);
	
				if (!elements) {
					if (promiseData.promise) {
						if (!propertiesMap || !options || options.promiseRejectEmpty !== false) {
							promiseData.rejecter();
						} else {
							promiseData.resolver();
						}
					}
					return;
				}
	
				/* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
				 single raw DOM element is passed in (which doesn't contain a length property). */
				var elementsLength = elements.length,
						elementsIndex = 0;
	
				/***************************
				 Argument Overloading
				 ***************************/
	
				/* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
				 Overloading is detected by checking for the absence of an object being passed into options. */
				/* Note: The stop/finish/pause/resume actions do not accept animation options, and are therefore excluded from this check. */
				if (!/^(stop|finish|finishAll|pause|resume)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
					/* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
					var startingArgumentPosition = argumentIndex + 1;
	
					options = {};
	
					/* Iterate through all options arguments */
					for (var i = startingArgumentPosition; i < arguments.length; i++) {
						/* Treat a number as a duration. Parse it out. */
						/* Note: The following RegEx will return true if passed an array with a number as its first item.
						 Thus, arrays are skipped from this check. */
						if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
							options.duration = arguments[i];
							/* Treat strings and arrays as easings. */
						} else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
							options.easing = arguments[i];
							/* Treat a function as a complete callback. */
						} else if (Type.isFunction(arguments[i])) {
							options.complete = arguments[i];
						}
					}
				}
	
				/*********************
				 Action Detection
				 *********************/
	
				/* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
				 or they can be started, stopped, paused, resumed, or reversed . If a literal or referenced properties map is passed in as Velocity's
				 first argument, the associated action is "start". Alternatively, "scroll", "reverse", "pause", "resume" or "stop" can be passed in 
				 instead of a properties map. */
				var action;
	
				switch (propertiesMap) {
					case "scroll":
						action = "scroll";
						break;
	
					case "reverse":
						action = "reverse";
						break;
	
					case "pause":
	
						/*******************
						 Action: Pause
						 *******************/
	
						var currentTime = (new Date()).getTime();
	
						/* Handle delay timers */
						$.each(elements, function(i, element) {
							pauseDelayOnElement(element, currentTime);
						});
	
						/* Pause and Resume are call-wide (not on a per element basis). Thus, calling pause or resume on a 
						 single element will cause any calls that containt tweens for that element to be paused/resumed
						 as well. */
	
						/* Iterate through all calls and pause any that contain any of our elements */
						$.each(Velocity.State.calls, function(i, activeCall) {
	
							var found = false;
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									var queueName = (options === undefined) ? "" : options;
	
									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
										return true;
									}
	
									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
	
											/* Set call to paused */
											activeCall[5] = {
												resume: false
											};
	
											/* Once we match an element, we can bounce out to the next call entirely */
											found = true;
											return false;
										}
									});
	
									/* Proceed to check next call if we have already matched */
									if (found) {
										return false;
									}
								});
							}
	
						});
	
						/* Since pause creates no new tweens, exit out of Velocity. */
						return getChain();
	
					case "resume":
	
						/*******************
						 Action: Resume
						 *******************/
	
						/* Handle delay timers */
						$.each(elements, function(i, element) {
							resumeDelayOnElement(element, currentTime);
						});
	
						/* Pause and Resume are call-wide (not on a per elemnt basis). Thus, calling pause or resume on a 
						 single element will cause any calls that containt tweens for that element to be paused/resumed
						 as well. */
	
						/* Iterate through all calls and pause any that contain any of our elements */
						$.each(Velocity.State.calls, function(i, activeCall) {
							var found = false;
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									var queueName = (options === undefined) ? "" : options;
	
									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
										return true;
									}
	
									/* Skip any calls that have never been paused */
									if (!activeCall[5]) {
										return true;
									}
	
									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
	
											/* Flag a pause object to be resumed, which will occur during the next tick. In
											 addition, the pause object will at that time be deleted */
											activeCall[5].resume = true;
	
											/* Once we match an element, we can bounce out to the next call entirely */
											found = true;
											return false;
										}
									});
	
									/* Proceed to check next call if we have already matched */
									if (found) {
										return false;
									}
								});
							}
	
						});
	
						/* Since resume creates no new tweens, exit out of Velocity. */
						return getChain();
	
					case "finish":
					case "finishAll":
					case "stop":
						/*******************
						 Action: Stop
						 *******************/
	
						/* Clear the currently-active delay on each targeted element. */
						$.each(elements, function(i, element) {
							if (Data(element) && Data(element).delayTimer) {
								/* Stop the timer from triggering its cached next() function. */
								clearTimeout(Data(element).delayTimer.setTimeout);
	
								/* Manually call the next() function so that the subsequent queue items can progress. */
								if (Data(element).delayTimer.next) {
									Data(element).delayTimer.next();
								}
	
								delete Data(element).delayTimer;
							}
	
							/* If we want to finish everything in the queue, we have to iterate through it
							 and call each function. This will make them active calls below, which will
							 cause them to be applied via the duration setting. */
							if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
								/* Iterate through the items in the element's queue. */
								$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
									/* The queue array can contain an "inprogress" string, which we skip. */
									if (Type.isFunction(item)) {
										item();
									}
								});
	
								/* Clearing the $.queue() array is achieved by resetting it to []. */
								$.queue(element, Type.isString(options) ? options : "", []);
							}
						});
	
						var callsToStop = [];
	
						/* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
						 been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
						 is stopped, the next item in its animation queue is immediately triggered. */
						/* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
						 or a custom queue string can be passed in. */
						/* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
						 regardless of the element's current queue state. */
	
						/* Iterate through every active call. */
						$.each(Velocity.State.calls, function(i, activeCall) {
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									/* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
									 clear calls associated with the relevant queue. */
									/* Call stopping logic works as follows:
									 - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
									 - options === undefined --> stop current queue:"" call and all queue:false calls.
									 - options === false --> stop only queue:false calls.
									 - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
									var queueName = (options === undefined) ? "" : options;
	
									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
										return true;
									}
	
									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
											/* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
											 due to the queue-clearing above. */
											if (options === true || Type.isString(options)) {
												/* Iterate through the items in the element's queue. */
												$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
													/* The queue array can contain an "inprogress" string, which we skip. */
													if (Type.isFunction(item)) {
														/* Pass the item's callback a flag indicating that we want to abort from the queue call.
														 (Specifically, the queue will resolve the call's associated promise then abort.)  */
														item(null, true);
													}
												});
	
												/* Clearing the $.queue() array is achieved by resetting it to []. */
												$.queue(element, Type.isString(options) ? options : "", []);
											}
	
											if (propertiesMap === "stop") {
												/* Since "reverse" uses cached start values (the previous call's endValues), these values must be
												 changed to reflect the final value that the elements were actually tweened to. */
												/* Note: If only queue:false/queue:"custom" animations are currently running on an element, it won't have a tweensContainer
												 object. Also, queue:false/queue:"custom" animations can't be reversed. */
												var data = Data(element);
												if (data && data.tweensContainer && (queueName === true || queueName === "")) {
													$.each(data.tweensContainer, function(m, activeTween) {
														activeTween.endValue = activeTween.currentValue;
													});
												}
	
												callsToStop.push(i);
											} else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
												/* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
												 they finish upon the next rAf tick then proceed with normal call completion logic. */
												activeCall[2].duration = 1;
											}
										}
									});
								});
							}
						});
	
						/* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
						 that the complete callback and display:none setting should be skipped since we're completing prematurely. */
						if (propertiesMap === "stop") {
							$.each(callsToStop, function(i, j) {
								completeCall(j, true);
							});
	
							if (promiseData.promise) {
								/* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
								promiseData.resolver(elements);
							}
						}
	
						/* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
						return getChain();
	
					default:
						/* Treat a non-empty plain object as a literal properties map. */
						if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
							action = "start";
	
							/****************
							 Redirects
							 ****************/
	
							/* Check if a string matches a registered redirect (see Redirects above). */
						} else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
							opts = $.extend({}, options);
	
							var durationOriginal = opts.duration,
									delayOriginal = opts.delay || 0;
	
							/* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
							if (opts.backwards === true) {
								elements = $.extend(true, [], elements).reverse();
							}
	
							/* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
							$.each(elements, function(elementIndex, element) {
								/* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
								if (parseFloat(opts.stagger)) {
									opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
								} else if (Type.isFunction(opts.stagger)) {
									opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
								}
	
								/* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
								 the duration of each element's animation, using floors to prevent producing very short durations. */
								if (opts.drag) {
									/* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
									opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);
	
									/* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
									 B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
									 The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
									opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex / elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
								}
	
								/* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
								 reduce the opts checking logic required inside the redirect. */
								Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
							});
	
							/* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
							 (The performance overhead up to this point is virtually non-existant.) */
							/* Note: The jQuery call chain is kept intact by returning the complete element set. */
							return getChain();
						} else {
							var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";
	
							if (promiseData.promise) {
								promiseData.rejecter(new Error(abortError));
							} else if (window.console) {
								console.log(abortError);
							}
	
							return getChain();
						}
				}
	
				/**************************
				 Call-Wide Variables
				 **************************/
	
				/* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
				 being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
				 avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
				 conversion metrics across Velocity animations that are not immediately consecutively chained. */
				var callUnitConversionData = {
					lastParent: null,
					lastPosition: null,
					lastFontSize: null,
					lastPercentToPxWidth: null,
					lastPercentToPxHeight: null,
					lastEmToPx: null,
					remToPx: null,
					vwToPx: null,
					vhToPx: null
				};
	
				/* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
				 Velocity.State.calls array that is processed during animation ticking. */
				var call = [];
	
				/************************
				 Element Processing
				 ************************/
	
				/* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
				 1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
				 2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
				 3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
				 `elementArrayIndex` allows passing index of the element in the original array to value functions.
				 If `elementsIndex` were used instead the index would be determined by the elements' per-element queue.
				 */
				function processElement(element, elementArrayIndex) {
	
					/*************************
					 Part I: Pre-Queueing
					 *************************/
	
					/***************************
					 Element-Wide Variables
					 ***************************/
	
					var /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
							opts = $.extend({}, Velocity.defaults, options),
							/* A container for the processed data associated with each property in the propertyMap.
							 (Each property in the map produces its own "tween".) */
							tweensContainer = {},
							elementUnitConversionData;
	
					/******************
					 Element Init
					 ******************/
	
					if (Data(element) === undefined) {
						Velocity.init(element);
					}
	
					/******************
					 Option: Delay
					 ******************/
	
					/* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
					/* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
					 (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
					if (parseFloat(opts.delay) && opts.queue !== false) {
						$.queue(element, opts.queue, function(next, clearQueue) {
							if (clearQueue === true) {
								/* Do not continue with animation queueing. */
								return true;
							}
	
							/* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;
	
							/* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
							 The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command, and
							 delayBegin/delayTime is used to ensure we can "pause" and "resume" a tween that is still mid-delay. */
	
							/* Temporarily store delayed elements to facilite access for global pause/resume */
							var callIndex = Velocity.State.delayedElements.count++;
							Velocity.State.delayedElements[callIndex] = element;
	
							var delayComplete = (function(index) {
								return function() {
									/* Clear the temporary element */
									Velocity.State.delayedElements[index] = false;
	
									/* Finally, issue the call */
									next();
								};
							})(callIndex);
	
	
							Data(element).delayBegin = (new Date()).getTime();
							Data(element).delay = parseFloat(opts.delay);
							Data(element).delayTimer = {
								setTimeout: setTimeout(next, parseFloat(opts.delay)),
								next: delayComplete
							};
						});
					}
	
					/*********************
					 Option: Duration
					 *********************/
	
					/* Support for jQuery's named durations. */
					switch (opts.duration.toString().toLowerCase()) {
						case "fast":
							opts.duration = 200;
							break;
	
						case "normal":
							opts.duration = DURATION_DEFAULT;
							break;
	
						case "slow":
							opts.duration = 600;
							break;
	
						default:
							/* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
							opts.duration = parseFloat(opts.duration) || 1;
					}
	
					/************************
					 Global Option: Mock
					 ************************/
	
					if (Velocity.mock !== false) {
						/* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
						 Alternatively, a multiplier can be passed in to time remap all delays and durations. */
						if (Velocity.mock === true) {
							opts.duration = opts.delay = 1;
						} else {
							opts.duration *= parseFloat(Velocity.mock) || 1;
							opts.delay *= parseFloat(Velocity.mock) || 1;
						}
					}
	
					/*******************
					 Option: Easing
					 *******************/
	
					opts.easing = getEasing(opts.easing, opts.duration);
	
					/**********************
					 Option: Callbacks
					 **********************/
	
					/* Callbacks must functions. Otherwise, default to null. */
					if (opts.begin && !Type.isFunction(opts.begin)) {
						opts.begin = null;
					}
	
					if (opts.progress && !Type.isFunction(opts.progress)) {
						opts.progress = null;
					}
	
					if (opts.complete && !Type.isFunction(opts.complete)) {
						opts.complete = null;
					}
	
					/*********************************
					 Option: Display & Visibility
					 *********************************/
	
					/* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
					/* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
					if (opts.display !== undefined && opts.display !== null) {
						opts.display = opts.display.toString().toLowerCase();
	
						/* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
						if (opts.display === "auto") {
							opts.display = Velocity.CSS.Values.getDisplayType(element);
						}
					}
	
					if (opts.visibility !== undefined && opts.visibility !== null) {
						opts.visibility = opts.visibility.toString().toLowerCase();
					}
	
					/**********************
					 Option: mobileHA
					 **********************/
	
					/* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
					 on animating elements. HA is removed from the element at the completion of its animation. */
					/* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
					/* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
					opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);
	
					/***********************
					 Part II: Queueing
					 ***********************/
	
					/* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
					 In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
					/* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
					 the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
					function buildQueue(next) {
						var data, lastTweensContainer;
	
						/*******************
						 Option: Begin
						 *******************/
	
						/* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
						if (opts.begin && elementsIndex === 0) {
							/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
							try {
								opts.begin.call(elements, elements);
							} catch (error) {
								setTimeout(function() {
									throw error;
								}, 1);
							}
						}
	
						/*****************************************
						 Tween Data Construction (for Scroll)
						 *****************************************/
	
						/* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
						if (action === "scroll") {
							/* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
							var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
									scrollOffset = parseFloat(opts.offset) || 0,
									scrollPositionCurrent,
									scrollPositionCurrentAlternate,
									scrollPositionEnd;
	
							/* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
							 as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
							if (opts.container) {
								/* Ensure that either a jQuery object or a raw DOM element was passed in. */
								if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
									/* Extract the raw DOM element from the jQuery wrapper. */
									opts.container = opts.container[0] || opts.container;
									/* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
									 (due to the user's natural interaction with the page). */
									scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */
	
									/* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
									 -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
									 the scroll container's current scroll position. */
									scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
									/* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
								} else {
									opts.container = null;
								}
							} else {
								/* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
								 the appropriate cached property names (which differ based on browser type). */
								scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
								/* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
								scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */
	
								/* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
								 and therefore end values do not need to be compounded onto current values. */
								scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
							}
	
							/* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
							tweensContainer = {
								scroll: {
									rootPropertyValue: false,
									startValue: scrollPositionCurrent,
									currentValue: scrollPositionCurrent,
									endValue: scrollPositionEnd,
									unitType: "",
									easing: opts.easing,
									scrollData: {
										container: opts.container,
										direction: scrollDirection,
										alternateValue: scrollPositionCurrentAlternate
									}
								},
								element: element
							};
	
							if (Velocity.debug) {
								console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
							}
	
							/******************************************
							 Tween Data Construction (for Reverse)
							 ******************************************/
	
							/* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
							 that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
							 the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
							/* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
							/* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
							 there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
							 as reverting to the element's values as they were prior to the previous *Velocity* call. */
						} else if (action === "reverse") {
							data = Data(element);
	
							/* Abort if there is no prior animation data to reverse to. */
							if (!data) {
								return;
							}
	
							if (!data.tweensContainer) {
								/* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
								$.dequeue(element, opts.queue);
	
								return;
							} else {
								/*********************
								 Options Parsing
								 *********************/
	
								/* If the element was hidden via the display option in the previous call,
								 revert display to "auto" prior to reversal so that the element is visible again. */
								if (data.opts.display === "none") {
									data.opts.display = "auto";
								}
	
								if (data.opts.visibility === "hidden") {
									data.opts.visibility = "visible";
								}
	
								/* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
								 Further, remove the previous call's callback options; typically, users do not want these to be refired. */
								data.opts.loop = false;
								data.opts.begin = null;
								data.opts.complete = null;
	
								/* Since we're extending an opts object that has already been extended with the defaults options object,
								 we remove non-explicitly-defined properties that are auto-assigned values. */
								if (!options.easing) {
									delete opts.easing;
								}
	
								if (!options.duration) {
									delete opts.duration;
								}
	
								/* The opts object used for reversal is an extension of the options object optionally passed into this
								 reverse call plus the options used in the previous Velocity call. */
								opts = $.extend({}, data.opts, opts);
	
								/*************************************
								 Tweens Container Reconstruction
								 *************************************/
	
								/* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
								lastTweensContainer = $.extend(true, {}, data ? data.tweensContainer : null);
	
								/* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
								for (var lastTween in lastTweensContainer) {
									/* In addition to tween data, tweensContainers contain an element property that we ignore here. */
									if (lastTweensContainer.hasOwnProperty(lastTween) && lastTween !== "element") {
										var lastStartValue = lastTweensContainer[lastTween].startValue;
	
										lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
										lastTweensContainer[lastTween].endValue = lastStartValue;
	
										/* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
										 Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
										 The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
										if (!Type.isEmptyObject(options)) {
											lastTweensContainer[lastTween].easing = opts.easing;
										}
	
										if (Velocity.debug) {
											console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
										}
									}
								}
	
								tweensContainer = lastTweensContainer;
							}
	
							/*****************************************
							 Tween Data Construction (for Start)
							 *****************************************/
	
						} else if (action === "start") {
	
							/*************************
							 Value Transferring
							 *************************/
	
							/* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
							 while the element was in the process of being animated by Velocity, then this current call is safe to use
							 the end values from the prior call as its start values. Velocity attempts to perform this value transfer
							 process whenever possible in order to avoid requerying the DOM. */
							/* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
							 then the DOM is queried for the element's current values as a last resort. */
							/* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */
	
							data = Data(element);
	
							/* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
							 to transfer over end values to use as start values. If it's set to true and there is a previous
							 Velocity call to pull values from, do so. */
							if (data && data.tweensContainer && data.isAnimating === true) {
								lastTweensContainer = data.tweensContainer;
							}
	
							/***************************
							 Tween Data Calculation
							 ***************************/
	
							/* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
							/* Property map values can either take the form of 1) a single value representing the end value,
							 or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
							 The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
							 the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
							var parsePropertyValue = function(valueData, skipResolvingEasing) {
								var endValue, easing, startValue;
	
								/* If we have a function as the main argument then resolve it first, in case it returns an array that needs to be split */
								if (Type.isFunction(valueData)) {
									valueData = valueData.call(element, elementArrayIndex, elementsLength);
								}
	
								/* Handle the array format, which can be structured as one of three potential overloads:
								 A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
								if (Type.isArray(valueData)) {
									/* endValue is always the first item in the array. Don't bother validating endValue's value now
									 since the ensuing property cycling logic does that. */
									endValue = valueData[0];
	
									/* Two-item array format: If the second item is a number, function, or hex string, treat it as a
									 start value since easings can only be non-hex strings or arrays. */
									if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
										startValue = valueData[1];
										/* Two or three-item array: If the second item is a non-hex string easing name or an array, treat it as an easing. */
									} else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1]) && Velocity.Easings[valueData[1]]) || Type.isArray(valueData[1])) {
										easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);
	
										/* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
										startValue = valueData[2];
									} else {
										startValue = valueData[1] || valueData[2];
									}
									/* Handle the single-value format. */
								} else {
									endValue = valueData;
								}
	
								/* Default to the call's easing if a per-property easing type was not defined. */
								if (!skipResolvingEasing) {
									easing = easing || opts.easing;
								}
	
								/* If functions were passed in as values, pass the function the current element as its context,
								 plus the element's index and the element set's size as arguments. Then, assign the returned value. */
								if (Type.isFunction(endValue)) {
									endValue = endValue.call(element, elementArrayIndex, elementsLength);
								}
	
								if (Type.isFunction(startValue)) {
									startValue = startValue.call(element, elementArrayIndex, elementsLength);
								}
	
								/* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
								return [endValue || 0, easing, startValue];
							};
	
							var fixPropertyValue = function(property, valueData) {
								/* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
								var rootProperty = CSS.Hooks.getRoot(property),
										rootPropertyValue = false,
										/* Parse out endValue, easing, and startValue from the property's data. */
										endValue = valueData[0],
										easing = valueData[1],
										startValue = valueData[2],
										pattern;
	
								/**************************
								 Start Value Sourcing
								 **************************/
	
								/* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
								 inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
								 Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
								/* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
								 there is no way to check for their explicit browser support, and so we skip skip this check for them. */
								if ((!data || !data.isSVG) && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
									if (Velocity.debug) {
										console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
									}
									return;
								}
	
								/* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
								 animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
								 a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
								if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
									startValue = 0;
								}
	
								/* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
								 for all of the current call's properties that were *also* animated in the previous call. */
								/* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
								if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
									if (startValue === undefined) {
										startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
									}
	
									/* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
									 instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
									 attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
									rootPropertyValue = data.rootPropertyValueCache[rootProperty];
									/* If values were not transferred from a previous Velocity call, query the DOM as needed. */
								} else {
									/* Handle hooked properties. */
									if (CSS.Hooks.registered[property]) {
										if (startValue === undefined) {
											rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
											/* Note: The following getPropertyValue() call does not actually trigger a DOM query;
											 getPropertyValue() will extract the hook from rootPropertyValue. */
											startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
											/* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
											 just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
											 root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
											 to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
										} else {
											/* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
											rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
										}
										/* Handle non-hooked properties that haven't already been defined via forcefeeding. */
									} else if (startValue === undefined) {
										startValue = CSS.getPropertyValue(element, property); /* GET */
									}
								}
	
								/**************************
								 Value Data Extraction
								 **************************/
	
								var separatedValue,
										endValueUnitType,
										startValueUnitType,
										operator = false;
	
								/* Separates a property value into its numeric value and its unit type. */
								var separateValue = function(property, value) {
									var unitType,
											numericValue;
	
									numericValue = (value || "0")
											.toString()
											.toLowerCase()
											/* Match the unit type at the end of the value. */
											.replace(/[%A-z]+$/, function(match) {
												/* Grab the unit type. */
												unitType = match;
	
												/* Strip the unit type off of value. */
												return "";
											});
	
									/* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
									if (!unitType) {
										unitType = CSS.Values.getUnitType(property);
									}
	
									return [numericValue, unitType];
								};
	
								if (startValue !== endValue && Type.isString(startValue) && Type.isString(endValue)) {
									pattern = "";
									var iStart = 0, // index in startValue
											iEnd = 0, // index in endValue
											aStart = [], // array of startValue numbers
											aEnd = [], // array of endValue numbers
											inCalc = 0, // Keep track of being inside a "calc()" so we don't duplicate it
											inRGB = 0, // Keep track of being inside an RGB as we can't use fractional values
											inRGBA = 0; // Keep track of being inside an RGBA as we must pass fractional for the alpha channel
	
									startValue = CSS.Hooks.fixColors(startValue);
									endValue = CSS.Hooks.fixColors(endValue);
									while (iStart < startValue.length && iEnd < endValue.length) {
										var cStart = startValue[iStart],
												cEnd = endValue[iEnd];
	
										if (/[\d\.-]/.test(cStart) && /[\d\.-]/.test(cEnd)) {
											var tStart = cStart, // temporary character buffer
													tEnd = cEnd, // temporary character buffer
													dotStart = ".", // Make sure we can only ever match a single dot in a decimal
													dotEnd = "."; // Make sure we can only ever match a single dot in a decimal
	
											while (++iStart < startValue.length) {
												cStart = startValue[iStart];
												if (cStart === dotStart) {
													dotStart = ".."; // Can never match two characters
												} else if (!/\d/.test(cStart)) {
													break;
												}
												tStart += cStart;
											}
											while (++iEnd < endValue.length) {
												cEnd = endValue[iEnd];
												if (cEnd === dotEnd) {
													dotEnd = ".."; // Can never match two characters
												} else if (!/\d/.test(cEnd)) {
													break;
												}
												tEnd += cEnd;
											}
											var uStart = CSS.Hooks.getUnit(startValue, iStart), // temporary unit type
													uEnd = CSS.Hooks.getUnit(endValue, iEnd); // temporary unit type
	
											iStart += uStart.length;
											iEnd += uEnd.length;
											if (uStart === uEnd) {
												// Same units
												if (tStart === tEnd) {
													// Same numbers, so just copy over
													pattern += tStart + uStart;
												} else {
													// Different numbers, so store them
													pattern += "{" + aStart.length + (inRGB ? "!" : "") + "}" + uStart;
													aStart.push(parseFloat(tStart));
													aEnd.push(parseFloat(tEnd));
												}
											} else {
												// Different units, so put into a "calc(from + to)" and animate each side to/from zero
												var nStart = parseFloat(tStart),
														nEnd = parseFloat(tEnd);
	
												pattern += (inCalc < 5 ? "calc" : "") + "("
														+ (nStart ? "{" + aStart.length + (inRGB ? "!" : "") + "}" : "0") + uStart
														+ " + "
														+ (nEnd ? "{" + (aStart.length + (nStart ? 1 : 0)) + (inRGB ? "!" : "") + "}" : "0") + uEnd
														+ ")";
												if (nStart) {
													aStart.push(nStart);
													aEnd.push(0);
												}
												if (nEnd) {
													aStart.push(0);
													aEnd.push(nEnd);
												}
											}
										} else if (cStart === cEnd) {
											pattern += cStart;
											iStart++;
											iEnd++;
											// Keep track of being inside a calc()
											if (inCalc === 0 && cStart === "c"
													|| inCalc === 1 && cStart === "a"
													|| inCalc === 2 && cStart === "l"
													|| inCalc === 3 && cStart === "c"
													|| inCalc >= 4 && cStart === "("
													) {
												inCalc++;
											} else if ((inCalc && inCalc < 5)
													|| inCalc >= 4 && cStart === ")" && --inCalc < 5) {
												inCalc = 0;
											}
											// Keep track of being inside an rgb() / rgba()
											if (inRGB === 0 && cStart === "r"
													|| inRGB === 1 && cStart === "g"
													|| inRGB === 2 && cStart === "b"
													|| inRGB === 3 && cStart === "a"
													|| inRGB >= 3 && cStart === "("
													) {
												if (inRGB === 3 && cStart === "a") {
													inRGBA = 1;
												}
												inRGB++;
											} else if (inRGBA && cStart === ",") {
												if (++inRGBA > 3) {
													inRGB = inRGBA = 0;
												}
											} else if ((inRGBA && inRGB < (inRGBA ? 5 : 4))
													|| inRGB >= (inRGBA ? 4 : 3) && cStart === ")" && --inRGB < (inRGBA ? 5 : 4)) {
												inRGB = inRGBA = 0;
											}
										} else {
											inCalc = 0;
											// TODO: changing units, fixing colours
											break;
										}
									}
									if (iStart !== startValue.length || iEnd !== endValue.length) {
										if (Velocity.debug) {
											console.error("Trying to pattern match mis-matched strings [\"" + endValue + "\", \"" + startValue + "\"]");
										}
										pattern = undefined;
									}
									if (pattern) {
										if (aStart.length) {
											if (Velocity.debug) {
												console.log("Pattern found \"" + pattern + "\" -> ", aStart, aEnd, "[" + startValue + "," + endValue + "]");
											}
											startValue = aStart;
											endValue = aEnd;
											endValueUnitType = startValueUnitType = "";
										} else {
											pattern = undefined;
										}
									}
								}
	
								if (!pattern) {
									/* Separate startValue. */
									separatedValue = separateValue(property, startValue);
									startValue = separatedValue[0];
									startValueUnitType = separatedValue[1];
	
									/* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
									separatedValue = separateValue(property, endValue);
									endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
										operator = subMatch;
	
										/* Strip the operator off of the value. */
										return "";
									});
									endValueUnitType = separatedValue[1];
	
									/* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
									startValue = parseFloat(startValue) || 0;
									endValue = parseFloat(endValue) || 0;
	
									/***************************************
									 Property-Specific Value Conversion
									 ***************************************/
	
									/* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
									if (endValueUnitType === "%") {
										/* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
										 which is identical to the em unit's behavior, so we piggyback off of that. */
										if (/^(fontSize|lineHeight)$/.test(property)) {
											/* Convert % into an em decimal value. */
											endValue = endValue / 100;
											endValueUnitType = "em";
											/* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
										} else if (/^scale/.test(property)) {
											endValue = endValue / 100;
											endValueUnitType = "";
											/* For RGB components, take the defined percentage of 255 and strip off the unit type. */
										} else if (/(Red|Green|Blue)$/i.test(property)) {
											endValue = (endValue / 100) * 255;
											endValueUnitType = "";
										}
									}
								}
	
								/***************************
								 Unit Ratio Calculation
								 ***************************/
	
								/* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
								 %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
								 for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
								 from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
								 1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
								 2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
								/* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
								 setting values with the target unit type then comparing the returned pixel value. */
								/* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
								 of batching the SETs and GETs together upfront outweights the potential overhead
								 of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
								/* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
								var calculateUnitRatios = function() {
	
									/************************
									 Same Ratio Checks
									 ************************/
	
									/* The properties below are used to determine whether the element differs sufficiently from this call's
									 previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
									 of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
									 this is done to minimize DOM querying. */
									var sameRatioIndicators = {
										myParent: element.parentNode || document.body, /* GET */
										position: CSS.getPropertyValue(element, "position"), /* GET */
										fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
									},
											/* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
											samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
											/* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
											sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);
	
									/* Store these ratio indicators call-wide for the next element to compare against. */
									callUnitConversionData.lastParent = sameRatioIndicators.myParent;
									callUnitConversionData.lastPosition = sameRatioIndicators.position;
									callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;
	
									/***************************
									 Element-Specific Units
									 ***************************/
	
									/* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
									 of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
									var measurement = 100,
											unitRatios = {};
	
									if (!sameEmRatio || !samePercentRatio) {
										var dummy = data && data.isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");
	
										Velocity.init(dummy);
										sameRatioIndicators.myParent.appendChild(dummy);
	
										/* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
										 Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
										/* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
										$.each(["overflow", "overflowX", "overflowY"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, "hidden");
										});
										Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
										Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
										Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");
	
										/* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
										$.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
										});
										/* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
										Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");
	
										/* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
										unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */
	
										sameRatioIndicators.myParent.removeChild(dummy);
									} else {
										unitRatios.emToPx = callUnitConversionData.lastEmToPx;
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
									}
	
									/***************************
									 Element-Agnostic Units
									 ***************************/
	
									/* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
									 once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
									 that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
									 so we calculate it now. */
									if (callUnitConversionData.remToPx === null) {
										/* Default to browsers' default fontSize of 16px in the case of 0. */
										callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
									}
	
									/* Similarly, viewport units are %-relative to the window's inner dimensions. */
									if (callUnitConversionData.vwToPx === null) {
										callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
										callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
									}
	
									unitRatios.remToPx = callUnitConversionData.remToPx;
									unitRatios.vwToPx = callUnitConversionData.vwToPx;
									unitRatios.vhToPx = callUnitConversionData.vhToPx;
	
									if (Velocity.debug >= 1) {
										console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
									}
									return unitRatios;
								};
	
								/********************
								 Unit Conversion
								 ********************/
	
								/* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
								if (/[\/*]/.test(operator)) {
									endValueUnitType = startValueUnitType;
									/* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
									 is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
									 on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
									 would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
									/* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
								} else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
									/* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
									/* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
									 match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
									 which remains past the point of the animation's completion. */
									if (endValue === 0) {
										endValueUnitType = startValueUnitType;
									} else {
										/* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
										 If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
										elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();
	
										/* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
										/* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
										var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";
	
										/* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
										 1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
										switch (startValueUnitType) {
											case "%":
												/* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
												 Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
												 to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
												startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;
	
											case "px":
												/* px acts as our midpoint in the unit conversion process; do nothing. */
												break;
	
											default:
												startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
										}
	
										/* Invert the px ratios to convert into to the target unit. */
										switch (endValueUnitType) {
											case "%":
												startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;
	
											case "px":
												/* startValue is already in px, do nothing; we're done. */
												break;
	
											default:
												startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
										}
									}
								}
	
								/*********************
								 Relative Values
								 *********************/
	
								/* Operator logic must be performed last since it requires unit-normalized start and end values. */
								/* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
								 to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
								 50 points is added on top of the current % value. */
								switch (operator) {
									case "+":
										endValue = startValue + endValue;
										break;
	
									case "-":
										endValue = startValue - endValue;
										break;
	
									case "*":
										endValue = startValue * endValue;
										break;
	
									case "/":
										endValue = startValue / endValue;
										break;
								}
	
								/**************************
								 tweensContainer Push
								 **************************/
	
								/* Construct the per-property tween object, and push it to the element's tweensContainer. */
								tweensContainer[property] = {
									rootPropertyValue: rootPropertyValue,
									startValue: startValue,
									currentValue: startValue,
									endValue: endValue,
									unitType: endValueUnitType,
									easing: easing
								};
								if (pattern) {
									tweensContainer[property].pattern = pattern;
								}
	
								if (Velocity.debug) {
									console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
								}
							};
	
							/* Create a tween out of each property, and append its associated data to tweensContainer. */
							for (var property in propertiesMap) {
	
								if (!propertiesMap.hasOwnProperty(property)) {
									continue;
								}
								/* The original property name's format must be used for the parsePropertyValue() lookup,
								 but we then use its camelCase styling to normalize it for manipulation. */
								var propertyName = CSS.Names.camelCase(property),
										valueData = parsePropertyValue(propertiesMap[property]);
	
								/* Find shorthand color properties that have been passed a hex string. */
								/* Would be quicker to use CSS.Lists.colors.includes() if possible */
								if (_inArray(CSS.Lists.colors, propertyName)) {
									/* Parse the value data for each shorthand. */
									var endValue = valueData[0],
											easing = valueData[1],
											startValue = valueData[2];
	
									if (CSS.RegEx.isHex.test(endValue)) {
										/* Convert the hex strings into their RGB component arrays. */
										var colorComponents = ["Red", "Green", "Blue"],
												endValueRGB = CSS.Values.hexToRgb(endValue),
												startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;
	
										/* Inject the RGB component tweens into propertiesMap. */
										for (var i = 0; i < colorComponents.length; i++) {
											var dataArray = [endValueRGB[i]];
	
											if (easing) {
												dataArray.push(easing);
											}
	
											if (startValueRGB !== undefined) {
												dataArray.push(startValueRGB[i]);
											}
	
											fixPropertyValue(propertyName + colorComponents[i], dataArray);
										}
										/* If we have replaced a shortcut color value then don't update the standard property name */
										continue;
									}
								}
								fixPropertyValue(propertyName, valueData);
							}
	
							/* Along with its property data, store a reference to the element itself onto tweensContainer. */
							tweensContainer.element = element;
						}
	
						/*****************
						 Call Push
						 *****************/
	
						/* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
						 being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
						if (tweensContainer.element) {
							/* Apply the "velocity-animating" indicator class. */
							CSS.Values.addClass(element, "velocity-animating");
	
							/* The call array houses the tweensContainers for each element being animated in the current call. */
							call.push(tweensContainer);
	
							data = Data(element);
	
							if (data) {
								/* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
								if (opts.queue === "") {
	
									data.tweensContainer = tweensContainer;
									data.opts = opts;
								}
	
								/* Switch on the element's animating flag. */
								data.isAnimating = true;
							}
	
							/* Once the final element in this call's element set has been processed, push the call array onto
							 Velocity.State.calls for the animation tick to immediately begin processing. */
							if (elementsIndex === elementsLength - 1) {
								/* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
								 Anything on this call container is subjected to tick() processing. */
								Velocity.State.calls.push([call, elements, opts, null, promiseData.resolver, null, 0]);
	
								/* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
								if (Velocity.State.isTicking === false) {
									Velocity.State.isTicking = true;
	
									/* Start the tick loop. */
									tick();
								}
							} else {
								elementsIndex++;
							}
						}
					}
	
					/* When the queue option is set to false, the call skips the element's queue and fires immediately. */
					if (opts.queue === false) {
						/* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
						 we manually inject the delay property here with an explicit setTimeout. */
						if (opts.delay) {
	
							/* Temporarily store delayed elements to facilitate access for global pause/resume */
							var callIndex = Velocity.State.delayedElements.count++;
							Velocity.State.delayedElements[callIndex] = element;
	
							var delayComplete = (function(index) {
								return function() {
									/* Clear the temporary element */
									Velocity.State.delayedElements[index] = false;
	
									/* Finally, issue the call */
									buildQueue();
								};
							})(callIndex);
	
							Data(element).delayBegin = (new Date()).getTime();
							Data(element).delay = parseFloat(opts.delay);
							Data(element).delayTimer = {
								setTimeout: setTimeout(buildQueue, parseFloat(opts.delay)),
								next: delayComplete
							};
						} else {
							buildQueue();
						}
						/* Otherwise, the call undergoes element queueing as normal. */
						/* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
					} else {
						$.queue(element, opts.queue, function(next, clearQueue) {
							/* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
							 so it's fine if this is repeatedly triggered for each element in the associated call.) */
							if (clearQueue === true) {
								if (promiseData.promise) {
									promiseData.resolver(elements);
								}
	
								/* Do not continue with animation queueing. */
								return true;
							}
	
							/* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
							 See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;
	
							buildQueue(next);
						});
					}
	
					/*********************
					 Auto-Dequeuing
					 *********************/
	
					/* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
					 must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
					 for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
					 queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
					 first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
					/* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
					 each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
					/* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
					 Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
					if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
						$.dequeue(element);
					}
				}
	
				/**************************
				 Element Set Iteration
				 **************************/
	
				/* If the "nodeType" property exists on the elements variable, we're animating a single element.
				 Place it in an array so that $.each() can iterate over it. */
				$.each(elements, function(i, element) {
					/* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
					if (Type.isNode(element)) {
						processElement(element, i);
					}
				});
	
				/******************
				 Option: Loop
				 ******************/
	
				/* The loop option accepts an integer indicating how many times the element should loop between the values in the
				 current call's properties map and the element's property values prior to this call. */
				/* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
				 to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
				 which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
				opts = $.extend({}, Velocity.defaults, options);
				opts.loop = parseInt(opts.loop, 10);
				var reverseCallsCount = (opts.loop * 2) - 1;
	
				if (opts.loop) {
					/* Double the loop count to convert it into its appropriate number of "reverse" calls.
					 Subtract 1 from the resulting value since the current call is included in the total alternation count. */
					for (var x = 0; x < reverseCallsCount; x++) {
						/* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
						 isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
						 call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
						var reverseOptions = {
							delay: opts.delay,
							progress: opts.progress
						};
	
						/* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
						 so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
						if (x === reverseCallsCount - 1) {
							reverseOptions.display = opts.display;
							reverseOptions.visibility = opts.visibility;
							reverseOptions.complete = opts.complete;
						}
	
						animate(elements, "reverse", reverseOptions);
					}
				}
	
				/***************
				 Chaining
				 ***************/
	
				/* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
				return getChain();
			};
	
			/* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
			Velocity = $.extend(animate, Velocity);
			/* For legacy support, also expose the literal animate method. */
			Velocity.animate = animate;
	
			/**************
			 Timing
			 **************/
	
			/* Ticker function. */
			var ticker = window.requestAnimationFrame || rAFShim;
	
			/* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
			 To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
			 devices to avoid wasting battery power on inactive tabs. */
			/* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
			if (!Velocity.State.isMobile && document.hidden !== undefined) {
				var updateTicker = function() {
					/* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
					if (document.hidden) {
						ticker = function(callback) {
							/* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
							return setTimeout(function() {
								callback(true);
							}, 16);
						};
	
						/* The rAF loop has been paused by the browser, so we manually restart the tick. */
						tick();
					} else {
						ticker = window.requestAnimationFrame || rAFShim;
					}
				};
	
				/* Page could be sitting in the background at this time (i.e. opened as new tab) so making sure we use correct ticker from the start */
				updateTicker();
	
				/* And then run check again every time visibility changes */
				document.addEventListener("visibilitychange", updateTicker);
			}
	
			/************
			 Tick
			 ************/
	
			/* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
			function tick(timestamp) {
				/* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
				 We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
				 the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
				 calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
				 the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
				 by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
				if (timestamp) {
					/* We normally use RAF's high resolution timestamp but as it can be significantly offset when the browser is
					 under high stress we give the option for choppiness over allowing the browser to drop huge chunks of frames.
					 We use performance.now() and shim it if it doesn't exist for when the tab is hidden. */
					var timeCurrent = Velocity.timestamp && timestamp !== true ? timestamp : performance.now();
	
					/********************
					 Call Iteration
					 ********************/
	
					var callsLength = Velocity.State.calls.length;
	
					/* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
					 when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
					 has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
					if (callsLength > 10000) {
						Velocity.State.calls = compactSparseArray(Velocity.State.calls);
						callsLength = Velocity.State.calls.length;
					}
	
					/* Iterate through each active call. */
					for (var i = 0; i < callsLength; i++) {
						/* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
						if (!Velocity.State.calls[i]) {
							continue;
						}
	
						/************************
						 Call-Wide Variables
						 ************************/
	
						var callContainer = Velocity.State.calls[i],
								call = callContainer[0],
								opts = callContainer[2],
								timeStart = callContainer[3],
								firstTick = !timeStart,
								tweenDummyValue = null,
								pauseObject = callContainer[5],
								millisecondsEllapsed = callContainer[6];
	
	
	
						/* If timeStart is undefined, then this is the first time that this call has been processed by tick().
						 We assign timeStart now so that its value is as close to the real animation start time as possible.
						 (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
						 between that time and now would cause the first few frames of the tween to be skipped since
						 percentComplete is calculated relative to timeStart.) */
						/* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
						 first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
						 same style value as the element's current value. */
						if (!timeStart) {
							timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
						}
	
						/* If a pause object is present, skip processing unless it has been set to resume */
						if (pauseObject) {
							if (pauseObject.resume === true) {
								/* Update the time start to accomodate the paused completion amount */
								timeStart = callContainer[3] = Math.round(timeCurrent - millisecondsEllapsed - 16);
	
								/* Remove pause object after processing */
								callContainer[5] = null;
							} else {
								continue;
							}
						}
	
						millisecondsEllapsed = callContainer[6] = timeCurrent - timeStart;
	
						/* The tween's completion percentage is relative to the tween's start time, not the tween's start value
						 (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
						 Accordingly, we ensure that percentComplete does not exceed 1. */
						var percentComplete = Math.min((millisecondsEllapsed) / opts.duration, 1);
	
						/**********************
						 Element Iteration
						 **********************/
	
						/* For every call, iterate through each of the elements in its set. */
						for (var j = 0, callLength = call.length; j < callLength; j++) {
							var tweensContainer = call[j],
									element = tweensContainer.element;
	
							/* Check to see if this element has been deleted midway through the animation by checking for the
							 continued existence of its data cache. If it's gone, or the element is currently paused, skip animating this element. */
							if (!Data(element)) {
								continue;
							}
	
							var transformPropertyExists = false;
	
							/**********************************
							 Display & Visibility Toggling
							 **********************************/
	
							/* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
							 (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
							if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
								if (opts.display === "flex") {
									var flexValues = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
	
									$.each(flexValues, function(i, flexValue) {
										CSS.setPropertyValue(element, "display", flexValue);
									});
								}
	
								CSS.setPropertyValue(element, "display", opts.display);
							}
	
							/* Same goes with the visibility option, but its "none" equivalent is "hidden". */
							if (opts.visibility !== undefined && opts.visibility !== "hidden") {
								CSS.setPropertyValue(element, "visibility", opts.visibility);
							}
	
							/************************
							 Property Iteration
							 ************************/
	
							/* For every element, iterate through each property. */
							for (var property in tweensContainer) {
								/* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
								if (tweensContainer.hasOwnProperty(property) && property !== "element") {
									var tween = tweensContainer[property],
											currentValue,
											/* Easing can either be a pre-genereated function or a string that references a pre-registered easing
											 on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
											easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;
	
									/******************************
									 Current Value Calculation
									 ******************************/
	
									if (Type.isString(tween.pattern)) {
										var patternReplace = percentComplete === 1 ?
												function($0, index, round) {
													var result = tween.endValue[index];
	
													return round ? Math.round(result) : result;
												} :
												function($0, index, round) {
													var startValue = tween.startValue[index],
															tweenDelta = tween.endValue[index] - startValue,
															result = startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
	
													return round ? Math.round(result) : result;
												};
	
										currentValue = tween.pattern.replace(/{(\d+)(!)?}/g, patternReplace);
									} else if (percentComplete === 1) {
										/* If this is the last tick pass (if we've reached 100% completion for this tween),
										 ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
										currentValue = tween.endValue;
									} else {
										/* Otherwise, calculate currentValue based on the current delta from startValue. */
										var tweenDelta = tween.endValue - tween.startValue;
	
										currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
										/* If no value change is occurring, don't proceed with DOM updating. */
									}
									if (!firstTick && (currentValue === tween.currentValue)) {
										continue;
									}
	
									tween.currentValue = currentValue;
	
									/* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
									 it can be passed into the progress callback. */
									if (property === "tween") {
										tweenDummyValue = currentValue;
									} else {
										/******************
										 Hooks: Part I
										 ******************/
										var hookRoot;
	
										/* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
										 for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
										 rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
										 updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
										 subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
										if (CSS.Hooks.registered[property]) {
											hookRoot = CSS.Hooks.getRoot(property);
	
											var rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];
	
											if (rootPropertyValueCache) {
												tween.rootPropertyValue = rootPropertyValueCache;
											}
										}
	
										/*****************
										 DOM Update
										 *****************/
	
										/* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
										/* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
										var adjustedSetData = CSS.setPropertyValue(element, /* SET */
												property,
												tween.currentValue + (IE < 9 && parseFloat(currentValue) === 0 ? "" : tween.unitType),
												tween.rootPropertyValue,
												tween.scrollData);
	
										/*******************
										 Hooks: Part II
										 *******************/
	
										/* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
										if (CSS.Hooks.registered[property]) {
											/* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
											if (CSS.Normalizations.registered[hookRoot]) {
												Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
											} else {
												Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
											}
										}
	
										/***************
										 Transforms
										 ***************/
	
										/* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
										if (adjustedSetData[0] === "transform") {
											transformPropertyExists = true;
										}
	
									}
								}
							}
	
							/****************
							 mobileHA
							 ****************/
	
							/* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
							 It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
							if (opts.mobileHA) {
								/* Don't set the null transform hack if we've already done so. */
								if (Data(element).transformCache.translate3d === undefined) {
									/* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
									Data(element).transformCache.translate3d = "(0px, 0px, 0px)";
	
									transformPropertyExists = true;
								}
							}
	
							if (transformPropertyExists) {
								CSS.flushTransformCache(element);
							}
						}
	
						/* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
						 Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
						if (opts.display !== undefined && opts.display !== "none") {
							Velocity.State.calls[i][2].display = false;
						}
						if (opts.visibility !== undefined && opts.visibility !== "hidden") {
							Velocity.State.calls[i][2].visibility = false;
						}
	
						/* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
						if (opts.progress) {
							opts.progress.call(callContainer[1],
									callContainer[1],
									percentComplete,
									Math.max(0, (timeStart + opts.duration) - timeCurrent),
									timeStart,
									tweenDummyValue);
						}
	
						/* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
						if (percentComplete === 1) {
							completeCall(i);
						}
					}
				}
	
				/* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
				if (Velocity.State.isTicking) {
					ticker(tick);
				}
			}
	
			/**********************
			 Call Completion
			 **********************/
	
			/* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
			function completeCall(callIndex, isStopped) {
				/* Ensure the call exists. */
				if (!Velocity.State.calls[callIndex]) {
					return false;
				}
	
				/* Pull the metadata from the call. */
				var call = Velocity.State.calls[callIndex][0],
						elements = Velocity.State.calls[callIndex][1],
						opts = Velocity.State.calls[callIndex][2],
						resolver = Velocity.State.calls[callIndex][4];
	
				var remainingCallsExist = false;
	
				/*************************
				 Element Finalization
				 *************************/
	
				for (var i = 0, callLength = call.length; i < callLength; i++) {
					var element = call[i].element;
	
					/* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
					/* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
					/* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
					if (!isStopped && !opts.loop) {
						if (opts.display === "none") {
							CSS.setPropertyValue(element, "display", opts.display);
						}
	
						if (opts.visibility === "hidden") {
							CSS.setPropertyValue(element, "visibility", opts.visibility);
						}
					}
	
					/* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
					 a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
					 an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
					 we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
					 is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
					var data = Data(element);
	
					if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
						/* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
						if (data) {
							data.isAnimating = false;
							/* Clear the element's rootPropertyValueCache, which will become stale. */
							data.rootPropertyValueCache = {};
	
							var transformHAPropertyExists = false;
							/* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
							$.each(CSS.Lists.transforms3D, function(i, transformName) {
								var defaultValue = /^scale/.test(transformName) ? 1 : 0,
										currentValue = data.transformCache[transformName];
	
								if (data.transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
									transformHAPropertyExists = true;
	
									delete data.transformCache[transformName];
								}
							});
	
							/* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
							if (opts.mobileHA) {
								transformHAPropertyExists = true;
								delete data.transformCache.translate3d;
							}
	
							/* Flush the subproperty removals to the DOM. */
							if (transformHAPropertyExists) {
								CSS.flushTransformCache(element);
							}
	
							/* Remove the "velocity-animating" indicator class. */
							CSS.Values.removeClass(element, "velocity-animating");
						}
					}
	
					/*********************
					 Option: Complete
					 *********************/
	
					/* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
					/* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
					if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
						/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
						try {
							opts.complete.call(elements, elements);
						} catch (error) {
							setTimeout(function() {
								throw error;
							}, 1);
						}
					}
	
					/**********************
					 Promise Resolving
					 **********************/
	
					/* Note: Infinite loops don't return promises. */
					if (resolver && opts.loop !== true) {
						resolver(elements);
					}
	
					/****************************
					 Option: Loop (Infinite)
					 ****************************/
	
					if (data && opts.loop === true && !isStopped) {
						/* If a rotateX/Y/Z property is being animated by 360 deg with loop:true, swap tween start/end values to enable
						 continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
						$.each(data.tweensContainer, function(propertyName, tweenContainer) {
							if (/^rotate/.test(propertyName) && ((parseFloat(tweenContainer.startValue) - parseFloat(tweenContainer.endValue)) % 360 === 0)) {
								var oldStartValue = tweenContainer.startValue;
	
								tweenContainer.startValue = tweenContainer.endValue;
								tweenContainer.endValue = oldStartValue;
							}
	
							if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
								tweenContainer.endValue = 0;
								tweenContainer.startValue = 100;
							}
						});
	
						Velocity(element, "reverse", {loop: true, delay: opts.delay});
					}
	
					/***************
					 Dequeueing
					 ***************/
	
					/* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
					 which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
					 $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
					if (opts.queue !== false) {
						$.dequeue(element, opts.queue);
					}
				}
	
				/************************
				 Calls Array Cleanup
				 ************************/
	
				/* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
				 (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
				Velocity.State.calls[callIndex] = false;
	
				/* Iterate through the calls array to determine if this was the final in-progress animation.
				 If so, set a flag to end ticking and clear the calls array. */
				for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
					if (Velocity.State.calls[j] !== false) {
						remainingCallsExist = true;
	
						break;
					}
				}
	
				if (remainingCallsExist === false) {
					/* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
					Velocity.State.isTicking = false;
	
					/* Clear the calls array so that its length is reset. */
					delete Velocity.State.calls;
					Velocity.State.calls = [];
				}
			}
	
			/******************
			 Frameworks
			 ******************/
	
			/* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
			 If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
			 also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
			 accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
			 (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
			global.Velocity = Velocity;
	
			if (global !== window) {
				/* Assign the element function to Velocity's core animate() method. */
				global.fn.velocity = animate;
				/* Assign the object function's defaults to Velocity's global defaults object. */
				global.fn.velocity.defaults = Velocity.defaults;
			}
	
			/***********************
			 Packaged Redirects
			 ***********************/
	
			/* slideUp, slideDown */
			$.each(["Down", "Up"], function(i, direction) {
				Velocity.Redirects["slide" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							begin = opts.begin,
							complete = opts.complete,
							inlineValues = {},
							computedValues = {height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: ""};
	
					if (opts.display === undefined) {
						/* Show the element before slideDown begins and hide the element after slideUp completes. */
						/* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
						opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
					}
	
					opts.begin = function() {
						/* If the user passed in a begin callback, fire it now. */
						if (elementsIndex === 0 && begin) {
							begin.call(elements, elements);
						}
	
						/* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
						for (var property in computedValues) {
							if (!computedValues.hasOwnProperty(property)) {
								continue;
							}
							inlineValues[property] = element.style[property];
	
							/* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
							 use forcefeeding to start from computed values and animate down to 0. */
							var propertyValue = CSS.getPropertyValue(element, property);
							computedValues[property] = (direction === "Down") ? [propertyValue, 0] : [0, propertyValue];
						}
	
						/* Force vertical overflow content to clip so that sliding works as expected. */
						inlineValues.overflow = element.style.overflow;
						element.style.overflow = "hidden";
					};
	
					opts.complete = function() {
						/* Reset element to its pre-slide inline values once its slide animation is complete. */
						for (var property in inlineValues) {
							if (inlineValues.hasOwnProperty(property)) {
								element.style[property] = inlineValues[property];
							}
						}
	
						/* If the user passed in a complete callback, fire it now. */
						if (elementsIndex === elementsSize - 1) {
							if (complete) {
								complete.call(elements, elements);
							}
							if (promiseData) {
								promiseData.resolver(elements);
							}
						}
					};
	
					Velocity(element, computedValues, opts);
				};
			});
	
			/* fadeIn, fadeOut */
			$.each(["In", "Out"], function(i, direction) {
				Velocity.Redirects["fade" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							complete = opts.complete,
							propertiesMap = {opacity: (direction === "In") ? 1 : 0};
	
					/* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
					 callbacks by firing them only when the final element has been reached. */
					if (elementsIndex !== 0) {
						opts.begin = null;
					}
					if (elementsIndex !== elementsSize - 1) {
						opts.complete = null;
					} else {
						opts.complete = function() {
							if (complete) {
								complete.call(elements, elements);
							}
							if (promiseData) {
								promiseData.resolver(elements);
							}
						};
					}
	
					/* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
					/* Note: We allow users to pass in "null" to skip display setting altogether. */
					if (opts.display === undefined) {
						opts.display = (direction === "In" ? "auto" : "none");
					}
	
					Velocity(this, propertiesMap, opts);
				};
			});
	
			return Velocity;
		}((window.jQuery || window.Zepto || window), window, (window ? window.document : undefined));
	}));
	
	/******************
	 Known Issues
	 ******************/
	
	/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
	 Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
	 will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */


/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var exportedName = 'PhoneNumber$$module$src$index';
	
	module.exports =
	__webpack_require__(449)[exportedName] ||
	(
	typeof globalThis !== 'undefined' && globalThis ||
	typeof global !== 'undefined' && global ||
	typeof window !== 'undefined' && window ||
	typeof self !== 'undefined' && self || undefined)[
	
	exportedName];
	
	Object.defineProperty(
	module.exports,
	"__esModule",
	{
		value: true });
	
	
	
	module.exports.default = module.exports;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}}(function () {/*
	                                                                                                                                                                                                                     Copyright The Closure Library Authors.
	                                                                                                                                                                                                                     SPDX-License-Identifier: Apache-2.0
	                                                                                                                                                                                                                     */
	
	  var aa = this || self;function h(a, b) {function c() {}c.prototype = b.prototype;a.Ca = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.Ia = function (d, e, f) {for (var g = Array(arguments.length - 2), l = 2; l < arguments.length; l++) {g[l - 2] = arguments[l];}return b.prototype[e].apply(d, g);};};function ba(a) {var b = [];var c = 0;for (var d in a) {b[c++] = a[d];}return b;};function ca(a, b) {this.h = a;this.g = {};for (a = 0; a < b.length; a++) {var c = b[a];this.g[c.g] = c;}}function da(a) {a = ba(a.g);a.sort(function (b, c) {return b.g - c.g;});return a;};function ea(a, b) {this.g = a;this.l = !!b.fa;this.h = b.i;this.s = b.type;this.o = !1;switch (this.h) {case fa:case ha:case ia:case ja:case ka:case la:case ma:this.o = !0;}this.j = b.defaultValue;}var ma = 1,la = 2,fa = 3,ha = 4,ia = 6,ja = 16,ka = 18;function k() {this.h = {};this.j = this.m().g;this.g = this.l = null;}k.prototype.has = function (a) {return m(this, a.g);};k.prototype.get = function (a, b) {return n(this, a.g, b);};k.prototype.set = function (a, b) {p(this, a.g, b);};k.prototype.add = function (a, b) {na(this, a.g, b);};
	  function oa(a, b) {for (var c = da(a.m()), d = 0; d < c.length; d++) {var e = c[d],f = e.g;if (m(b, f)) {a.g && delete a.g[e.g];var g = 11 == e.h || 10 == e.h;if (e.l) {e = r(b, f);for (var l = 0; l < e.length; l++) {na(a, f, g ? e[l].clone() : e[l]);}} else e = t(b, f), g ? (g = t(a, f)) ? oa(g, e) : p(a, f, e.clone()) : p(a, f, e);}}}k.prototype.clone = function () {var a = new this.constructor();a != this && (a.h = {}, a.g && (a.g = {}), oa(a, this));return a;};function m(a, b) {return null != a.h[b];}
	  function t(a, b) {var c = a.h[b];if (null == c) return null;if (a.l) {if (!(b in a.g)) {var d = a.l,e = a.j[b];if (null != c) if (e.l) {for (var f = [], g = 0; g < c.length; g++) {f[g] = d.h(e, c[g]);}c = f;} else c = d.h(e, c);return a.g[b] = c;}return a.g[b];}return c;}function n(a, b, c) {var d = t(a, b);return a.j[b].l ? d[c || 0] : d;}function u(a, b) {if (m(a, b)) a = n(a, b, void 0);else a: {a = a.j[b];if (void 0 === a.j) if (b = a.s, b === Boolean) a.j = !1;else if (b === Number) a.j = 0;else if (b === String) a.j = a.o ? "0" : "";else {a = new b();break a;}a = a.j;}return a;}
	  function r(a, b) {return t(a, b) || [];}function v(a, b) {return a.j[b].l ? m(a, b) ? a.h[b].length : 0 : m(a, b) ? 1 : 0;}function p(a, b, c) {a.h[b] = c;a.g && (a.g[b] = c);}function na(a, b, c) {a.h[b] || (a.h[b] = []);a.h[b].push(c);a.g && delete a.g[b];}function w(a, b) {var c = [],d;for (d in b) {0 != d && c.push(new ea(d, b[d]));}return new ca(a, c);};function x() {}x.prototype.g = function (a) {new a.h();throw Error("Unimplemented");};x.prototype.h = function (a, b) {if (11 == a.h || 10 == a.h) return b instanceof k ? b : this.g(a.s.prototype.m(), b);if (14 == a.h) return "string" === typeof b && pa.test(b) && (a = Number(b), 0 < a) ? a : b;if (!a.o) return b;a = a.s;if (a === String) {if ("number" === typeof b) return String(b);} else if (a === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || pa.test(b))) return Number(b);return b;};var pa = /^-?[0-9]+$/;function qa() {}h(qa, x);qa.prototype.g = function (a, b) {a = new a.h();a.l = this;a.h = b;a.g = {};return a;};function y() {}h(y, qa);y.prototype.h = function (a, b) {return 8 == a.h ? !!b : x.prototype.h.apply(this, arguments);};y.prototype.g = function (a, b) {return y.Ca.g.call(this, a, b);};function z(a, b) {null != a && this.g.apply(this, arguments);}z.prototype.h = "";z.prototype.set = function (a) {this.h = "" + a;};z.prototype.g = function (a, b, c) {this.h += String(a);if (null != b) for (var d = 1; d < arguments.length; d++) {this.h += arguments[d];}return this;};function A(a) {a.h = "";}z.prototype.toString = function () {return this.h;}; /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Protocol Buffer 2 Copyright 2008 Google Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             All other code copyright its respective owners.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Copyright (C) 2010 The Libphonenumber Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */
	
	
	
	
	  function B() {k.call(this);}h(B, k);var ra = null;function C() {k.call(this);}h(C, k);var sa = null;function D() {k.call(this);}h(D, k);var ta = null;D.prototype.ha = function () {return n(this, 10);};
	  B.prototype.m = function () {var a = ra;a || (ra = a = w(B, { 0: { name: "NumberFormat", ma: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, i: 9, type: String }, 2: { name: "format", required: !0, i: 9, type: String }, 3: { name: "leading_digits_pattern", fa: !0, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } }));return a;};B.m = B.prototype.m;
	  C.prototype.m = function () {var a = sa;a || (sa = a = w(C, { 0: { name: "PhoneNumberDesc", ma: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", fa: !0, i: 5, type: Number }, 10: { name: "possible_length_local_only", fa: !0, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } }));return a;};C.m = C.prototype.m;
	  D.prototype.m = function () {var a = ta;a || (ta = a = w(D, { 0: { name: "PhoneMetadata", ma: "i18n.phonenumbers.PhoneMetadata" }, 1: { name: "general_desc", i: 11, type: C }, 2: { name: "fixed_line", i: 11, type: C }, 3: { name: "mobile", i: 11, type: C }, 4: { name: "toll_free", i: 11, type: C }, 5: { name: "premium_rate", i: 11, type: C }, 6: { name: "shared_cost", i: 11, type: C }, 7: { name: "personal_number", i: 11, type: C }, 8: { name: "voip", i: 11, type: C }, 21: { name: "pager", i: 11, type: C }, 25: { name: "uan", i: 11, type: C }, 27: { name: "emergency", i: 11, type: C }, 28: { name: "voicemail", i: 11, type: C },
	      29: { name: "short_code", i: 11, type: C }, 30: { name: "standard_rate", i: 11, type: C }, 31: { name: "carrier_specific", i: 11, type: C }, 33: { name: "sms_services", i: 11, type: C }, 24: { name: "no_international_dialling", i: 11, type: C }, 9: { name: "id", required: !0, i: 9, type: String }, 10: { name: "country_code", i: 5, type: Number }, 11: { name: "international_prefix", i: 9, type: String }, 17: { name: "preferred_international_prefix", i: 9, type: String }, 12: { name: "national_prefix", i: 9, type: String }, 13: { name: "preferred_extn_prefix", i: 9, type: String }, 15: { name: "national_prefix_for_parsing",
	        i: 9, type: String }, 16: { name: "national_prefix_transform_rule", i: 9, type: String }, 18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: !1, type: Boolean }, 19: { name: "number_format", fa: !0, i: 11, type: B }, 20: { name: "intl_number_format", fa: !0, i: 11, type: B }, 22: { name: "main_country_for_code", i: 8, defaultValue: !1, type: Boolean }, 23: { name: "leading_digits", i: 9, type: String }, 26: { name: "leading_zero_possible", i: 8, defaultValue: !1, type: Boolean } }));return a;};D.m = D.prototype.m;function E() {k.call(this);}h(E, k);var ua = null;E.prototype.ha = function () {return n(this, 1);};var va = { Ha: 0, Ga: 1, Fa: 5, Ea: 10, Da: 20 };
	  E.prototype.m = function () {var a = ua;a || (ua = a = w(E, { 0: { name: "PhoneNumber", ma: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: !0, i: 5, type: Number }, 2: { name: "national_number", required: !0, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: va }, 7: { name: "preferred_domestic_carrier_code",
	        i: 9, type: String } }));return a;};E.ctor = E;E.ctor.m = E.prototype.m; /*
	                                                                                 Copyright (C) 2010 The Libphonenumber Authors
	                                                                                 Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                 you may not use this file except in compliance with the License.
	                                                                                 You may obtain a copy of the License at
	                                                                                 http://www.apache.org/licenses/LICENSE-2.0
	                                                                                 Unless required by applicable law or agreed to in writing, software
	                                                                                 distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                 See the License for the specific language governing permissions and
	                                                                                 limitations under the License.
	                                                                                 */
	
	
	
	
	  var F = { 1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "), 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"],
	    86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"],
	    253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"],
	    386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"],
	    691: ["FM"], 692: ["MH"], 800: ["001"], 808: ["001"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 870: ["001"], 878: ["001"], 880: ["BD"], 881: ["001"], 882: ["001"], 883: ["001"], 886: ["TW"], 888: ["001"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 979: ["001"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] },G = { AC: [, [,, "(?:[01589]\\d|[46])\\d{4}",,,,,,,
	    [5, 6]], [,, "6[2-467]\\d{3}",,,, "62889",,, [5]], [,, "4\\d{4}",,,, "40123",,, [5]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AC", 247, "00",,,,,,,,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "(?:0[1-9]|[1589]\\d)\\d{4}",,,, "542011",,, [6]],,, [,,,,,,,,, [-1]]], AD: [, [,, "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",,,,,,, [6, 8, 9]], [,, "[78]\\d{5}",,,, "712345",,, [6]], [,, "690\\d{6}|[356]\\d{5}",,,, "312345",,, [6, 9]], [,, "180[02]\\d{4}",,,, "18001234",,, [8]], [,, "[19]\\d{5}",,,, "912345",,, [6]],
	    [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AD", 376, "00",,,,,,,, [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],, [,,,,,,,,, [-1]],,, [,, "1800\\d{4}",,,,,,, [8]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AE: [, [,, "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",,,,,,, [5, 6, 7, 8, 9, 10, 11, 12]], [,, "[2-4679][2-8]\\d{6}",,,, "22345678",,, [8], [7]], [,, "5[024-68]\\d{7}",,,, "501234567",,, [9]], [,, "400\\d{6}|800\\d{2,9}",,,, "800123456"],
	    [,, "900[02]\\d{5}",,,, "900234567",,, [9]], [,, "700[05]\\d{5}",,,, "700012345",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AE", 971, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "600[25]\\d{5}",,,, "600212345",,, [9]],,, [,,,,,,,,, [-1]]], AF: [, [,, "[2-7]\\d{8}",,,,,,, [9], [7]], [,, "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",,,,
	    "234567890",,,, [7]], [,, "7\\d{8}",,,, "701234567",,,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AF", 93, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AG: [, [,, "(?:268|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",,,, "2684601234",,,,
	    [7]], [,, "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",,,, "2684641234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,, "26848[01]\\d{4}",,,, "2684801234",,,, [7]],
	    "AG", 1, "011", "1",,, "1|([457]\\d{6})$", "268$1",,,,, [,, "26840[69]\\d{4}",,,, "2684061234",,,, [7]],, "268", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AI: [, [,, "(?:264|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "264(?:292|4(?:6[12]|9[78]))\\d{4}",,,, "2644612345",,,, [7]], [,, "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",,,, "2642351234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "AI", 1, "011", "1",,, "1|([2457]\\d{6})$", "264$1",,,,, [,, "264724\\d{4}",,,, "2647241234",,,, [7]],, "264", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AL: [, [,, "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",,,,,,, [6, 7, 8, 9], [5]], [,, "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",,,, "22345678",,, [8], [5, 6, 7]], [,, "6(?:[78][2-9]|9\\d)\\d{6}",,,, "672123456",,, [9]], [,, "800\\d{4}",,,, "8001234",,, [7]], [,, "900[1-9]\\d\\d",,,,
	    "900123",,, [6]], [,, "808[1-9]\\d\\d",,,, "808123",,, [6]], [,, "700[2-9]\\d{4}",,,, "70021234",,, [8]], [,,,,,,,,, [-1]], "AL", 355, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AM: [, [,, "(?:[1-489]\\d|55|60|77)\\d{6}",,,,,,,
	    [8], [5, 6]], [,, "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",,,, "10123456",,,, [5, 6]], [,, "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",,,, "77123456"], [,, "800\\d{5}",,,, "80012345"], [,, "90[016]\\d{5}",,,, "90012345"], [,, "80[1-4]\\d{5}",,,, "80112345"], [,,,,,,,,, [-1]], [,, "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}",,,, "60271234"], "AM", 374, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"],
	    "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AO: [, [,, "[29]\\d{8}",,,,,,, [9]], [,, "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",,,, "222123456"], [,, "9[1-49]\\d{7}",,,, "923123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AO", 244, "00",,,,,,,, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,,
	    [,,,,,,,,, [-1]]], AR: [, [,, "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",,,,,,, [10, 11], [6, 7, 8]], [,, "3888[013-9]\\d{5}|(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",,,,
	    "1123456789",,, [10], [6, 7, 8]], [,, "93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",,,,
	    "91123456789",,,, [6, 7, 8]], [,, "800\\d{7,8}",,,, "8001234567"], [,, "60[04579]\\d{7}",,,, "6001234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AR", 54, "00", "0",,, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
	    "9$1",,, [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
	    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
	    "0$1",, 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1",, 1], [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
	    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
	    "0$1"], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]], [[, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
	    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
	    "0$1",, 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1",, 1], [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
	    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"]],
	    [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]], [,,,,,,,,, [-1]],,, [,, "810\\d{7}",,,,,,, [10]], [,, "810\\d{7}",,,, "8101234567",,, [10]],,, [,,,,,,,,, [-1]]], AS: [, [,, "(?:[58]\\d\\d|684|900)\\d{7}",,,,,,, [10], [7]], [,, "6846(?:22|33|44|55|77|88|9[19])\\d{4}",,,, "6846221234",,,, [7]], [,, "684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}",,,, "6847331234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,
	    "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "AS", 1, "011", "1",,, "1|([267]\\d{6})$", "684$1",,,,, [,,,,,,,,, [-1]],, "684", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AT: [, [,, "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",,,,,,,
	    [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [3]], [,, "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",,,, "1234567890",,,, [3]], [,, "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",,,, "664123456",,, [7, 8, 9, 10, 11, 12, 13]], [,, "800\\d{6,10}",,,,
	    "800123456",,, [9, 10, 11, 12, 13]], [,, "9(?:0[01]|3[019])\\d{6,10}",,,, "900123456",,, [9, 10, 11, 12, 13]], [,, "8(?:10|2[018])\\d{6,10}|828\\d{5}",,,, "810123456",,, [8, 9, 10, 11, 12, 13]], [,,,,,,,,, [-1]], [,, "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",,,, "780123456",,, [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{3,10})",
	    "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})",
	    "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AU: [, [,, "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",,,,,,, [5, 6, 7, 8, 9, 10]], [,, "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",,,,
	    "212345678",,, [9], [8]], [,, "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",,,, "412345678",,, [9]], [,, "180(?:0\\d{3}|2)\\d{3}",,,, "1800123456",,, [7, 10]], [,, "190[0-26]\\d{6}",,,, "1900123456",,, [10]], [,, "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",,,, "1300123456",,, [6, 8, 10]], [,,,,,,,,, [-1]], [,, "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,, "147101234",,, [9]], "AU", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0",,, "0|(183[12])",, "0011",,
	    [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [,
	    "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], [,, "163\\d{2,6}",,,, "1631234",,, [5, 6, 7, 8, 9]], 1,, [,, "1[38]00\\d{6}|1(?:345[0-4]|802)\\d{3}|13\\d{4}",,,,,,, [6, 7, 8, 10]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AW: [, [,, "(?:[25-79]\\d\\d|800)\\d{4}",,,,,,, [7]], [,, "5(?:2\\d|8[1-9])\\d{4}",,,, "5212345"], [,, "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",,,,
	    "5601234"], [,, "800\\d{4}",,,, "8001234"], [,, "900\\d{4}",,,, "9001234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "(?:28\\d|501)\\d{4}",,,, "5011234"], "AW", 297, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], AX: [, [,, "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",,,,,,, [5, 6, 7, 8, 9, 10, 11, 12]], [,, "18[1-8]\\d{3,6}",,,, "181234567",,, [6, 7, 8, 9]], [,, "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,, "412345678",,,
	    [6, 7, 8, 9, 10]], [,, "800\\d{4,6}",,,, "800123456",,, [7, 8, 9]], [,, "[67]00\\d{5,6}",,,, "600123456",,, [8, 9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0",,, "0",, "00",,,, [,,,,,,,,, [-1]],, "18", [,,,,,,,,, [-1]], [,, "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",,,, "10112345"],,, [,,,,,,,,, [-1]]], AZ: [, [,, "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",,,,,,,
	    [9], [7]], [,, "(?:222[0-79]\\d|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}|(?:(?:1[28]|46)\\d|2(?:[045]2|1[24]|2[34]|33|6[23]))\\d{6}",,,, "123123456",,,, [7]], [,, "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",,,, "401234567"], [,, "88\\d{7}",,,, "881234567"], [,, "900200\\d{3}",,,, "900200123"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "AZ", 994, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365|46", "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365|46", "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,,
	    [-1]]], BA: [, [,, "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",,,,,,, [8, 9], [6]], [,, "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",,,, "30212345",,, [8], [6]], [,, "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",,,, "61123456"], [,, "8[08]\\d{6}",,,, "80123456",,, [8]], [,, "9[0246]\\d{6}",,,, "90123456",,, [8]], [,, "8[12]\\d{6}",,,, "82123456",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BA", 387, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3})",
	    "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",,,, "70341234",,,
	    [8]],,, [,,,,,,,,, [-1]]], BB: [, [,, "(?:246|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",,,, "2464123456",,,, [7]], [,, "246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}",,,, "2462501234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "(?:246976|900[2-9]\\d\\d)\\d{4}",,,, "9002123456",,,, [7]], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,, "24631\\d{5}",,,, "2463101234",,,, [7]], "BB", 1, "011", "1",,, "1|([2-9]\\d{6})$", "246$1",,,,, [,,,,,,,,, [-1]],, "246", [,,,,,,,,, [-1]], [,, "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}",,,, "2464301234",,,, [7]],,, [,,,,,,,,, [-1]]], BD: [, [,, "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",,,,,,, [6, 7, 8, 9, 10]], [,, "(?:465[3578]\\d{4}|8332[6-9])\\d\\d|465(?:(?:3|[57]\\d)\\d{3,4}|8\\d{3})|(?:3(?:03[56]|224)|422[25])\\d{3,4}|(?:4(?:31\\d\\d|423|65(?:28|4\\d))|5222)\\d{3}(?:\\d{2})?|(?:3(?:42[47]|529|823)|4(?:027|525)|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|56\\d)|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|627)|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:(?:[19]3|35|59|6[3-59])\\d\\d|4(?:25|[39]\\d\\d))|4(?:0(?:33|9\\d\\d)|(?:1|2[3-5]\\d)\\d|3(?:32|[459]\\d\\d)|4(?:2[246]|5[25])|6(?:2[35]|[349]\\d\\d|5(?:[019]\\d|2[0-79])|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:21(?:4\\d|7)|3[12]|[5-7]1)|9(?:[24]1|82\\d\\d))\\d{5}|(?:3(?:1(?:2[5-7]|[5-7])|822)|4(?:[257]1|[4689][18])|(?:5[2-57-9]|6[03-589])1)\\d{5}|(?:3[2-8]|[59])1\\d{5}",,,,
	    "27111234"], [,, "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",,,, "1812345678",,, [10]], [,, "80[03]\\d{7}",,,, "8001234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}",,,, "9604123456",,, [10]], "BD", 880, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1-$2", ["38[013-9]|4(?:6[168]|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|8(?:0[014-9]|1|2[1-3])|[34]7|7[2-589]|9[35]|(?:3[2-6]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[248])1|(?:44|66)[01346-9]",
	    "38[013-9]|4(?:6[168]|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|8(?:0[014-9]|1|2(?:1[78]|[23]))|[34]7|7[2-589]|9[35]|(?:3[2-6]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[248])1|(?:44|66)[01346-9]"], "0$1"], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BE: [, [,, "4\\d{8}|[1-9]\\d{7}",,,,,,, [8, 9]], [,, "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",,,, "12345678",,,
	    [8]], [,, "4[5-9]\\d{7}",,,, "470123456",,, [9]], [,, "800[1-9]\\d{4}",,,, "80012345",,, [8]], [,, "(?:70(?:2[0-57]|3[04-7]|44|69|7[0579])|90(?:0[0-8]|1[36]|2[0-3568]|3[013-689]|[47][2-68]|5[1-68]|6[0-378]|9[34679]))\\d{4}",,,, "90012345",,, [8]], [,, "7879\\d{4}",,,, "78791234",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BE", 32, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078]|9\\d)\\d{4}",,,, "78102345",,, [8]],,, [,,,,,,,,, [-1]]], BF: [, [,, "[025-7]\\d{7}",,,,,,, [8]], [,, "2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",,,, "20491234"], [,, "(?:0[1267]|5[1-8]|[67]\\d)\\d{6}",,,, "70123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],
	    [,,,,,,,,, [-1]], "BF", 226, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BG: [, [,, "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",,,,,,, [6, 7, 8, 9], [4, 5]], [,, "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",,,, "2123456",,, [6, 7, 8], [4, 5]], [,, "43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}",,,, "48123456",,, [8, 9]], [,, "800\\d{5}",,,, "80012345",,, [8]], [,, "90\\d{6}",,,,
	    "90123456",,, [8]], [,, "700\\d{5}",,,, "70012345",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BG", 359, "00", "0",,, "0",,,, [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"],
	    "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"],
	    [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BH: [, [,, "[136-9]\\d{7}",,,,,,, [8]], [,, "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}",,,, "17001234"], [,, "(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}",,,, "36001234"], [,, "80\\d{6}",,,, "80123456"], [,,
	    "(?:87|9[014578])\\d{6}",,,, "90123456"], [,, "84\\d{6}",,,, "84123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BH", 973, "00",,,,,,,, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BI: [, [,, "(?:[267]\\d|31)\\d{6}",,,,,,, [8]], [,, "22\\d{6}",,,, "22201234"], [,, "(?:29|31|6[1289]|7[125-9])\\d{6}",,,, "79561234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BI", 257, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["[2367]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BJ: [, [,, "[25689]\\d{7}",,,,,,, [8]], [,, "2(?:02|1[037]|2[45]|3[68])\\d{5}",,,, "20211234"], [,, "(?:5[1-35-8]|6\\d|9[013-9])\\d{6}",,,, "90011234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "857[58]\\d{4}",,,, "85751234"], "BJ", 229, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[25689]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "81\\d{6}",,,, "81123456"],,, [,,,,,,,,, [-1]]],
	    BL: [, [,, "(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,, [9]], [,, "590(?:2[7-9]|5[12]|87)\\d{4}",,,, "590271234"], [,, "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,, "690001234"], [,, "80[0-5]\\d{6}",,,, "800012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "976[01]\\d{5}",,,, "976012345"], "BL", 590, "00", "0",,, "0",,,,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BM: [, [,, "(?:441|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",,,, "4414123456",,,, [7]],
	    [,, "441(?:[2378]\\d|5[0-39])\\d{5}",,,, "4413701234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "BM", 1, "011", "1",,, "1|([2-8]\\d{6})$", "441$1",,,,, [,,,,,,,,, [-1]],,
	    "441", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BN: [, [,, "[2-578]\\d{6}",,,,,,, [7]], [,, "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",,,, "2345678"], [,, "(?:22[89]|[78]\\d\\d)\\d{4}",,,, "7123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "5[34]\\d{5}",,,, "5345678"], "BN", 673, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BO: [, [,, "(?:[2-467]\\d\\d|8001)\\d{5}",,,,,,, [8, 9], [7]], [,, "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",,,,
	    "22123456",,, [8], [7]], [,, "[67]\\d{7}",,,, "71234567",,, [8]], [,, "8001[07]\\d{4}",,,, "800171234",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BO", 591, "00(?:1\\d)?", "0",,, "0(1\\d)?",,,, [[, "(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"],, "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"],, "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"],, "0$CC $1"]],, [,,,,,,,,, [-1]],,, [,, "8001[07]\\d{4}",,,,,,, [9]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BQ: [, [,, "(?:[34]1|7\\d)\\d{5}",,,,,,, [7]], [,, "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",,,,
	    "7151234"], [,, "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",,,, "3181234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BQ", 599, "00",,,,,,,,,, [,,,,,,,,, [-1]],, "[347]", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BR: [, [,, "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",,,,,,, [8, 9, 10, 11]], [,, "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",,,, "1123456789",,, [10], [8]],
	    [,, "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",,,, "11961234567",,, [10, 11], [8, 9]], [,, "800\\d{6,7}",,,, "800123456",,, [9, 10]], [,, "300\\d{6}|[59]00\\d{6,7}",,,, "300123456",,, [9, 10]], [,, "300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}",,,, "40041234",,, [8, 10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0",,, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2",,, [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],
	    [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)",
	    "4(?:02|37)0|[34]00"]], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [,,,,,,,,, [-1]],,, [,, "4020\\d{4}|[34]00\\d{5}",,,,,,, [8]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BS: [, [,, "(?:242|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",,,,
	    "2423456789",,,, [7]], [,, "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}",,,, "2423591234",,,, [7]], [,, "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456",,,, [7]], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "BS", 1, "011", "1",,, "1|([3-8]\\d{6})$", "242$1",,,,, [,,,,,,,,, [-1]],, "242", [,,,,,,,,, [-1]], [,, "242225\\d{4}",,,, "2422250123"],,, [,,,,,,,,, [-1]]], BT: [, [,, "[17]\\d{7}|[2-8]\\d{6}",,,,,,, [7, 8], [6]], [,, "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",,,, "2345678",,, [7], [6]], [,, "(?:1[67]|77)\\d{6}",,,, "17123456",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BT", 975, "00",,,,,,,, [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{3})",
	    "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BW: [, [,, "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",,,,,,, [7, 8, 10]], [,, "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",,,,
	    "2401234",,, [7]], [,, "(?:321|7(?:[1-7]\\d|8[01]))\\d{5}",,,, "71123456",,, [8]], [,, "(?:0800|800\\d)\\d{6}",,,, "0800012345",,, [10]], [,, "90\\d{5}",,,, "9012345",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}",,,, "79101234",,, [8]], "BW", 267, "00",,,,,,,, [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3",
	    ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BY: [, [,, "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",,,,,,, [6, 7, 8, 9, 10, 11], [5]], [,, "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",,,, "152450911",,, [9], [5, 6, 7]], [,, "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",,,,
	    "294911911",,, [9]], [,, "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",,,, "8011234567"], [,, "(?:810|902)\\d{7}",,,, "9021234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "249\\d{6}",,,, "249123456",,, [9]], "BY", 375, "810", "8",,, "0|80?",, "8~10",, [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
	    "8 0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]],, [,,,,,,,,, [-1]],,, [,, "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], BZ: [, [,, "(?:0800\\d|[2-8])\\d{6}",,,,,,, [7, 11]], [,, "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",,,, "2221234",,, [7]], [,, "6[0-35-7]\\d{5}",,,,
	    "6221234",,, [7]], [,, "0800\\d{7}",,,, "08001234123",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "BZ", 501, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CA: [, [,, "(?:[2-8]\\d|90)\\d{8}",,,,,,, [10], [7]], [,, "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",,,,
	    "5062345678",,,, [7]], [,, "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",,,, "5062345678",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}",,,,
	    "5002345678"], [,, "600[2-9]\\d{6}",,,, "6002012345"], "CA", 1, "011", "1",,, "1",,, 1,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CC: [, [,, "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",,,,,,, [6, 7, 8, 9, 10]], [,, "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",,,, "891621234",,, [9], [8]], [,, "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",,,,
	    "412345678",,, [9]], [,, "180(?:0\\d{3}|2)\\d{3}",,,, "1800123456",,, [7, 10]], [,, "190[0-26]\\d{6}",,,, "1900123456",,, [10]], [,, "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",,,, "1300123456",,, [6, 8, 10]], [,,,,,,,,, [-1]], [,, "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,, "147101234",,, [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0",,, "0|([59]\\d{7})$", "8$1", "0011",,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CD: [, [,, "[189]\\d{8}|[1-68]\\d{6}",,,,,,, [7, 9]], [,, "12\\d{7}|[1-6]\\d{6}",,,,
	    "1234567"], [,, "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}",,,, "991234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CD", 243, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CF: [, [,, "(?:[27]\\d{3}|8776)\\d{4}",,,,,,,
	    [8]], [,, "2[12]\\d{6}",,,, "21612345"], [,, "7[0257]\\d{6}",,,, "70012345"], [,,,,,,,,, [-1]], [,, "8776\\d{4}",,,, "87761234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CF", 236, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CG: [, [,, "(?:0\\d\\d|222|800)\\d{6}",,,,,,, [9]], [,, "222[1-589]\\d{5}",,,, "222123456"], [,, "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",,,, "061234567"],
	    [,,,,,,,,, [-1]], [,, "800\\d{6}",,,, "800123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CG", 242, "00",,,,,,,, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CH: [, [,, "8\\d{11}|[2-9]\\d{8}",,,,,,, [9, 12]], [,, "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",,,, "212345678",,, [9]], [,, "7[35-9]\\d{7}",,,, "781234567",,, [9]], [,, "800\\d{6}",,,, "800123456",,, [9]], [,, "90[016]\\d{6}",,,,
	    "900123456",,, [9]], [,, "84[0248]\\d{6}",,,, "840123456",,, [9]], [,, "878\\d{6}",,,, "878123456",,, [9]], [,,,,,,,,, [-1]], "CH", 41, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]],, [,, "74[0248]\\d{6}",,,, "740123456",,, [9]],,, [,,,,,,,,, [-1]], [,, "5[18]\\d{7}",,,, "581234567",,, [9]],,, [,, "860\\d{9}",,,, "860123456789",,, [12]]], CI: [,
	    [,, "[02]\\d{9}",,,,,,, [10]], [,, "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|[23][45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",,,, "2123456789"], [,, "0704[0-7]\\d{5}|0(?:[15]\\d\\d|7(?:0[0-37-9]|[4-9][7-9]))\\d{6}",,,, "0123456789"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CI", 225, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]],
	    CK: [, [,, "[2-578]\\d{4}",,,,,,, [5]], [,, "(?:2\\d|3[13-7]|4[1-5])\\d{3}",,,, "21234"], [,, "[578]\\d{4}",,,, "71234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CK", 682, "00",,,,,,,, [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CL: [, [,, "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",,,,,,, [9, 10, 11]], [,, "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",,,,
	    "221234567",,, [9]], [,, "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",,,, "221234567",,, [9]], [,, "(?:123|8)00\\d{6}",,,, "800123456",,, [9, 11]], [,,,,,,,,, [-1]], [,, "600\\d{7,8}",,,, "6001234567",,,
	    [10, 11]], [,,,,,,,,, [-1]], [,, "44\\d{7}",,,, "441234567",,, [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",,,,,,, 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-3]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})",
	    "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-3]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})",
	    "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [,,,,,,,,, [-1]],,, [,, "600\\d{7,8}",,,,,,, [10, 11]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CM: [, [,, "[26]\\d{8}|88\\d{6,7}",,,,,,, [8, 9]], [,, "2(?:22|33)\\d{6}",,,, "222123456",,, [9]], [,, "(?:24[23]|6[5-9]\\d)\\d{6}",,,, "671234567",,, [9]], [,, "88\\d{6,7}",,,, "88012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CM", 237, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4 $5", ["[26]|88"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CN: [, [,, "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",,,,,,, [7, 8, 9, 10, 11, 12], [5, 6]], [,, "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",,,,
	    "1012345678",,, [7, 8, 9, 10, 11], [5, 6]], [,, "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}",,,, "13123456789",,, [11]], [,, "(?:(?:10|21)8|8)00\\d{7}",,,, "8001234567",,, [10, 12]], [,, "16[08]\\d{5}",,,, "16812345",,, [8]], [,, "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",,,,
	    "4001234567",,, [7, 8, 9, 10, 11], [5, 6]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0",,, "0|(1(?:[12]\\d|79)\\d\\d)",, "00",, [[, "(\\d{5,6})", "$1", ["96"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]], [, "(\\d{4})(\\d{4})",
	    "$1 $2", ["16[08]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
	    "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],
	    "0$1", "$CC $1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "26|3(?:[0268]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9])|(?:34|85[23])[0-8]|(?:1|58)[1-9]|(?:63|95)[06-9]|(?:33|85[23]9)[0-46-9]|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
	    "26|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:1|58|85[23]10)[1-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],
	    [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{7,8})",
	    "$1 $2", ["9"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"],, "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1",, 1]], [[, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
	    "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
	    "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
	    "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"],, "$CC $1"],
	    [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1",, 1]], [,,,,,,,,, [-1]],,, [,, "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",,,,,,, [10, 11, 12]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CO: [, [,, "(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",,,,,,, [8, 10, 11], [7]], [,, "60[124-8][2-9]\\d{6}|[124-8][2-9]\\d{6}",,,, "12345678",,, [8, 10], [7]], [,, "3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[2-6]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",,,, "3211234567",,, [10]], [,, "1800\\d{7}",,,,
	    "18001234567",,, [11]], [,, "19(?:0[01]|4[78])\\d{7}",,,, "19001234567",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0",,, "0([3579]|4(?:[14]4|56))?",,,, [[, "(\\d)(\\d{7})", "$1 $2", ["[146][2-9]|[2578]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["[39]"],, "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [[, "(\\d)(\\d{7})", "$1 $2", ["[146][2-9]|[2578]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2",
	    ["6"], "($1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["[39]"],, "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CR: [, [,, "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",,,,,,, [8, 10]], [,, "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",,,, "22123456",,, [8]], [,, "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",,,, "83123456",,, [8]], [,, "800\\d{7}",,,, "8001234567",,, [10]], [,, "90[059]\\d{7}",,,, "9001234567",,, [10]], [,,,,,,,,, [-1]],
	    [,,,,,,,,, [-1]], [,, "(?:210[0-6]|4\\d{3}|5100)\\d{4}",,,, "40001234",,, [8]], "CR", 506, "00",,,, "(19(?:0[0-2468]|1[09]|20|66|77|99))",,,, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"],, "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"],, "$CC $1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CU: [, [,, "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",,,,,,, [6, 7, 8, 10], [4, 5]], [,, "(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",,,, "71234567",,,,
	    [4, 5]], [,, "5\\d{7}",,,, "51234567",,, [8]], [,, "800\\d{7}",,,, "8001234567",,, [10]], [,,,,,,,,, [-1]], [,, "807\\d{7}",,,, "8071234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CU", 53, "119", "0",,, "0",,,, [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CV: [, [,, "(?:[2-59]\\d\\d|800)\\d{4}",,,,,,, [7]], [,, "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",,,,
	    "2211234"], [,, "(?:[34][36]|5[1-389]|9\\d)\\d{5}",,,, "9911234"], [,, "800\\d{4}",,,, "8001234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CV", 238, "0",,,,,,,, [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CW: [, [,, "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",,,,,,, [7, 8]], [,, "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",,,, "94351234"], [,, "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",,,,
	    "95181234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "60[0-2]\\d{4}",,,, "6001234",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "CW", 599, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]],, [,, "955\\d{5}",,,, "95581234",,, [8]], 1, "[69]", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CX: [, [,, "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",,,,,,, [6, 7, 8, 9, 10]], [,, "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",,,,
	    "891641234",,, [9], [8]], [,, "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",,,, "412345678",,, [9]], [,, "180(?:0\\d{3}|2)\\d{3}",,,, "1800123456",,, [7, 10]], [,, "190[0-26]\\d{6}",,,, "1900123456",,, [10]], [,, "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",,,, "1300123456",,, [6, 8, 10]], [,,,,,,,,, [-1]], [,, "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,, "147101234",,, [9]], "CX", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0",,, "0|([59]\\d{7})$", "8$1",
	    "0011",,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], CY: [, [,, "(?:[279]\\d|[58]0)\\d{6}",,,,,,, [8]], [,, "2[2-6]\\d{6}",,,, "22345678"], [,, "9[4-79]\\d{6}",,,, "96123456"], [,, "800\\d{5}",,,, "80001234"], [,, "90[09]\\d{5}",,,, "90012345"], [,, "80[1-9]\\d{5}",,,, "80112345"], [,, "700\\d{5}",,,, "70012345"], [,,,,,,,,, [-1]], "CY", 357, "00",,,,,,,, [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "(?:50|77)\\d{6}",,,, "77123456"],,, [,,,,,,,,, [-1]]], CZ: [, [,, "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",,,,,,,
	    [9, 10, 11, 12]], [,, "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",,,, "212345678",,, [9]], [,, "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}",,,, "601123456",,, [9]], [,, "800\\d{6}",,,, "800123456",,, [9]], [,, "9(?:0[05689]|76)\\d{6}",,,, "900123456",,, [9]], [,, "8[134]\\d{7}",,,, "811234567",,, [9]], [,, "70[01]\\d{6}",,,, "700123456",,, [9]], [,, "9[17]0\\d{6}",,,, "910123456",,, [9]], "CZ", 420, "00",,,,,,,, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]],
	    [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "9(?:5\\d|7[2-4])\\d{6}",,,, "972123456",,, [9]],,, [,, "9(?:3\\d{9}|6\\d{7,10})",,,, "93123456789"]], DE: [, [,, "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}",,,,,,, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [,, "32\\d{9,11}|49[2-6]\\d{10}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",,,,
	    "30123456",,, [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3, 4]], [,, "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",,,, "15123456789",,, [10, 11]], [,, "800\\d{7,12}",,,, "8001234567890",,, [10, 11, 12, 13, 14, 15]], [,, "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",,,, "9001234567",,, [10, 11]], [,, "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",,,, "18012345",,, [7, 8, 9, 10, 11, 12, 13, 14]], [,, "700\\d{8}",,,, "70012345678",,, [11]], [,,,,,,,,, [-1]], "DE", 49, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], [, "(\\d{3})(\\d{3,12})",
	    "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], [, "(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
	    "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], [, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
	    [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]],, [,, "16(?:4\\d{1,10}|[89]\\d{1,11})",,,, "16412345",,, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]],,, [,,,,,,,,, [-1]], [,, "18(?:1\\d{5,11}|[2-9]\\d{8})",,,, "18500123456",,, [8, 9, 10, 11, 12, 13, 14]],,, [,, "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",,,,
	    "177991234567",,, [12, 13]]], DJ: [, [,, "(?:2\\d|77)\\d{6}",,,,,,, [8]], [,, "2(?:1[2-5]|7[45])\\d{5}",,,, "21360003"], [,, "77\\d{6}",,,, "77831001"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "DJ", 253, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], DK: [, [,, "[2-9]\\d{7}",,,,,,, [8]], [,, "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",,,, "32123456"], [,, "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",,,,
	    "32123456"], [,, "80\\d{6}",,,, "80123456"], [,, "90\\d{6}",,,, "90123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "DK", 45, "00",,,,,,, 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], DM: [, [,, "(?:[58]\\d\\d|767|900)\\d{7}",,,,,,, [10], [7]], [,, "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",,,, "7674201234",,,, [7]], [,, "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",,,, "7672251234",,,, [7]],
	    [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "DM", 1, "011", "1",,, "1|([2-7]\\d{6})$", "767$1",,,,, [,,,,,,,,, [-1]],, "767", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]],
	    DO: [, [,, "(?:[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",,,, "8092345678",,,, [7]], [,, "8[024]9[2-9]\\d{6}",,,, "8092345678",,,, [7]], [,, "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",,,,
	    "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "DO", 1, "011", "1",,, "1",,,,,, [,,,,,,,,, [-1]],, "8001|8[024]9", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], DZ: [, [,, "(?:[1-4]|[5-79]\\d|80)\\d{7}",,,,,,, [8, 9]], [,,
	    "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}",,,, "12345678"], [,, "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",,,, "551234567",,, [9]], [,, "800\\d{6}",,,, "800123456",,, [9]], [,, "80[3-689]1\\d{5}",,,, "808123456",,, [9]], [,, "80[12]1\\d{5}",,,, "801123456",,, [9]], [,,,,,,,,, [-1]], [,, "98[23]\\d{6}",,,, "983123456",,, [9]], "DZ", 213, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
	    [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], EC: [, [,, "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",,,,,,, [8, 9, 10, 11], [7]], [,, "[2-7][2-7]\\d{6}",,,, "22123456",,, [8], [7]], [,, "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",,,, "991234567",,, [9]], [,, "1800\\d{7}|1[78]00\\d{6}",,,, "18001234567",,, [10, 11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "[2-7]890\\d{4}",,,, "28901234",,, [8]], "EC", 593, "00", "0",,,
	    "0",,,, [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], EE: [, [,, "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",,,,,,, [7, 8, 10]], [,, "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",,,,
	    "3212345",,, [7]], [,, "5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",,,, "51234567",,, [7, 8]], [,, "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",,,, "80012345"], [,, "(?:40\\d\\d|900)\\d{4}",,,, "9001234",,,
	    [7, 8]], [,,,,,,,,, [-1]], [,, "70[0-2]\\d{5}",,,, "70012345",,, [8]], [,,,,,,,,, [-1]], "EE", 372, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],, [,,,,,,,,, [-1]],,, [,, "800[2-9]\\d{3}",,,,,,, [7]], [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]]], EG: [, [,, "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",,,,,,, [8, 9, 10], [6, 7]], [,, "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",,,, "234567890",,, [8, 9], [6, 7]], [,, "1[0-25]\\d{8}",,,, "1001234567",,, [10]], [,, "800\\d{7}",,,, "8001234567",,, [10]], [,, "900\\d{7}",,,, "9001234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "EG", 20, "00", "0",,, "0",,,, [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"],
	    "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], EH: [, [,, "[5-8]\\d{8}",,,,,,, [9]], [,, "528[89]\\d{5}",,,, "528812345"], [,, "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-5]|6[1267]|7[0-57]))\\d{6}",,,, "650123456"], [,, "80\\d{7}",,,, "801234567"], [,, "89\\d{7}",,,, "891234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "592(?:4[0-2]|93)\\d{4}",,,, "592401234"], "EH", 212, "00", "0",,, "0",,,,,, [,,,,,,,,, [-1]],, "528[89]", [,,,,,,,,, [-1]],
	    [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], ER: [, [,, "[178]\\d{6}",,,,,,, [7], [6]], [,, "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",,,, "8370362",,,, [6]], [,, "(?:17[1-3]|7\\d\\d)\\d{4}",,,, "7123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "ER", 291, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], ES: [, [,, "[5-9]\\d{8}",,,,,,, [9]], [,, "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",,,,
	    "810123456"], [,, "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",,,, "612345678"], [,, "[89]00\\d{6}",,,, "800123456"], [,, "80[367]\\d{6}",,,, "803123456"], [,, "90[12]\\d{6}",,,, "901123456"], [,, "70\\d{7}",,,, "701234567"], [,,,,,,,,, [-1]], "ES", 34, "00",,,,,,,, [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
	    [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "51\\d{7}",,,, "511234567"],,, [,,,,,,,,, [-1]]], ET: [, [,, "(?:11|[2-59]\\d)\\d{7}",,,,,,, [9], [7]], [,, "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",,,,
	    "111112345",,,, [7]], [,, "9\\d{8}",,,, "911234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "ET", 251, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], FI: [, [,, "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",,,,,,, [5, 6, 7, 8, 9, 10, 11, 12]], [,, "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",,,, "131234567",,, [5, 6, 7, 8, 9]], [,, "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,
	    "412345678",,, [6, 7, 8, 9, 10]], [,, "800\\d{4,6}",,,, "800123456",,, [7, 8, 9]], [,, "[67]00\\d{5,6}",,,, "600123456",,, [8, 9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "FI", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0",,, "0",, "00",, [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [,
	    "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], [[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], [,,,,,,,,, [-1]], 1, "1[03-79]|[2-9]", [,, "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"], [,, "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",,,,
	    "10112345"],,, [,,,,,,,,, [-1]]], FJ: [, [,, "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",,,,,,, [7, 11]], [,, "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",,,, "3212345",,, [7]], [,, "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",,,, "7012345",,, [7]], [,, "0800\\d{7}",,,, "08001234567",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "FJ", 679, "0(?:0|52)",,,,,, "00",, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]]], FK: [, [,, "[2-7]\\d{4}",,,,,,, [5]], [,, "[2-47]\\d{4}",,,, "31234"], [,, "[56]\\d{4}",,,, "51234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "FK", 500, "00",,,,,,,,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], FM: [, [,, "(?:[39]\\d\\d|820)\\d{4}",,,,,,, [7]], [,, "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",,,, "3201234"], [,, "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",,,,
	    "3501234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "FM", 691, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], FO: [, [,, "[2-9]\\d{5}",,,,,,, [6]], [,, "(?:20|[34]\\d|8[19])\\d{4}",,,, "201234"], [,, "(?:[27][1-9]|5\\d|91)\\d{4}",,,, "211234"], [,, "80[257-9]\\d{3}",,,, "802123"], [,, "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",,,, "901123"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "(?:6[0-36]|88)\\d{4}",,,,
	    "601234"], "FO", 298, "00",,,, "(10(?:01|[12]0|88))",,,, [[, "(\\d{6})", "$1", ["[2-9]"],, "$CC $1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], FR: [, [,, "[1-9]\\d{8}",,,,,,, [9]], [,, "(?:[1-35]\\d|4[1-9])\\d{7}",,,, "123456789"], [,, "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7(?:00|[3-9]\\d))\\d{6}",,,, "612345678"], [,, "80[0-5]\\d{6}",,,, "801234567"], [,, "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",,,, "891123456"], [,, "8(?:1[01]|2[0156]|84)\\d{6}",,,,
	    "884012345"], [,,,,,,,,, [-1]], [,, "9\\d{8}",,,, "912345678"], "FR", 33, "00", "0",,, "0",,,, [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "80[6-9]\\d{6}",,,, "806123456"],,,
	    [,,,,,,,,, [-1]]], GA: [, [,, "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",,,,,,, [7, 8]], [,, "[01]1\\d{6}",,,, "01441234",,, [8]], [,, "(?:0[2-7]|6[256]|7[47])\\d{6}|[2-7]\\d{6}",,,, "06031234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "GA", 241, "00",,,, "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})", "$1",,, [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4",
	    ["0"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GB: [, [,, "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",,,,,,, [7, 9, 10], [4, 5, 6, 8]], [,, "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[02459]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",,,,
	    "1212345678",,, [9, 10], [4, 5, 6, 7, 8]], [,, "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",,,, "7400123456",,, [10]], [,, "80[08]\\d{7}|800\\d{6}|8001111",,,, "8001234567"], [,, "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",,,, "9012345678",,, [7, 10]], [,,,,,,,,, [-1]], [,, "70\\d{8}",,,, "7012345678",,, [10]], [,, "56\\d{8}",,,, "5612345678",,,
	    [10]], "GB", 44, "00", "0", " x",, "0",,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])",
	    "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]],, [,, "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",,,, "7640123456",,, [10]], 1,, [,,,,,,,,, [-1]], [,, "(?:3[0347]|55)\\d{8}",,,, "5512345678",,, [10]],,, [,,,,,,,,, [-1]]], GD: [, [,, "(?:473|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",,,,
	    "4732691234",,,, [7]], [,, "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}",,,, "4734031234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "GD",
	    1, "011", "1",,, "1|([2-9]\\d{6})$", "473$1",,,,, [,,,,,,,,, [-1]],, "473", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GE: [, [,, "(?:[3-57]\\d\\d|800)\\d{6}",,,,,,, [9], [6, 7]], [,, "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",,,, "322123456",,,, [6, 7]], [,, "5(?:(?:0555|1177)[5-9]|757(?:7[7-9]|8[01]))\\d{3}|5(?:0070|(?:11|33)33|[25]222)[0-4]\\d{3}|5(?:00(?:0\\d|50)|11(?:00|1\\d|2[0-4])|5200|75(?:00|[57]5)|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88)))\\d{4}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",,,,
	    "555123456"], [,, "800\\d{6}",,,, "800123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "70[67]\\d{6}",,,, "706123456"], "GE", 995, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,, "70[67]\\d{6}"], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GF: [, [,, "(?:[56]94|80\\d|976)\\d{6}",,,,,,,
	    [9]], [,, "594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[0-4])\\d{4}",,,, "594101234"], [,, "694(?:[0-249]\\d|3[0-48])\\d{4}",,,, "694201234"], [,, "80[0-5]\\d{6}",,,, "800012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "976\\d{6}",,,, "976012345"], "GF", 594, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GG: [, [,, "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",,,,,,,
	    [7, 9, 10], [6]], [,, "1481[25-9]\\d{5}",,,, "1481256789",,, [10], [6]], [,, "7(?:(?:781|839)\\d|911[17])\\d{5}",,,, "7781123456",,, [10]], [,, "80[08]\\d{7}|800\\d{6}|8001111",,,, "8001234567"], [,, "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",,,, "9012345678",,, [7, 10]], [,,,,,,,,, [-1]], [,, "70\\d{8}",,,, "7012345678",,, [10]], [,, "56\\d{8}",,,, "5612345678",,, [10]], "GG", 44, "00", "0",,, "0|([25-9]\\d{5})$", "1481$1",,,,, [,, "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",,,,
	    "7640123456",,, [10]],,, [,,,,,,,,, [-1]], [,, "(?:3[0347]|55)\\d{8}",,,, "5512345678",,, [10]],,, [,,,,,,,,, [-1]]], GH: [, [,, "(?:[235]\\d{3}|800)\\d{5}",,,,,,, [8, 9], [7]], [,, "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",,,, "302345678",,, [9], [7]], [,, "(?:2(?:[0346-8]\\d|5[67])|5(?:[0457]\\d|6[01]|9[1-9]))\\d{6}",,,, "231234567",,, [9]], [,, "800\\d{5}",,,, "80012345",,,
	    [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "GH", 233, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [,,,,,,,,, [-1]],,, [,, "800\\d{5}",,,,,,, [8]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GI: [, [,, "(?:[25]\\d\\d|606)\\d{5}",,,,,,, [8]], [,, "21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}",,,,
	    "20012345"], [,, "(?:5[146-8]\\d|606)\\d{5}",,,, "57123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "GI", 350, "00",,,,,,,, [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GL: [, [,, "(?:19|[2-689]\\d|70)\\d{4}",,,,,,, [6]], [,, "(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}",,,, "321000"], [,, "[245]\\d{5}",,,, "221234"], [,, "80\\d{4}",,,, "801234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "3[89]\\d{4}",,,,
	    "381234"], "GL", 299, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GM: [, [,, "[2-9]\\d{6}",,,,,,, [7]], [,, "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",,,, "5661234"], [,, "(?:[23679]\\d|5[0-389])\\d{5}",,,, "3012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "GM", 220, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2",
	    ["[2-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GN: [, [,, "722\\d{6}|(?:3|6\\d)\\d{7}",,,,,,, [8, 9]], [,, "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",,,, "30241234",,, [8]], [,, "6[0-356]\\d{7}",,,, "601123456",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "722\\d{6}",,,, "722123456",,, [9]], "GN", 224, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4",
	    ["[67]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GP: [, [,, "(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,, [9]], [,, "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}",,,, "590201234"], [,, "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,, "690001234"], [,, "80[0-5]\\d{6}",,,, "800012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "976[01]\\d{5}",,,, "976012345"], "GP", 590, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4",
	    ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],, [,,,,,,,,, [-1]], 1,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GQ: [, [,, "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",,,,,,, [9]], [,, "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",,,, "333091234"], [,, "(?:222|55\\d)\\d{6}",,,, "222123456"], [,, "80\\d[1-9]\\d{5}",,,, "800123456"], [,, "90\\d[1-9]\\d{5}",,,, "900123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "GQ", 240, "00",,,,,,,, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3",
	    ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GR: [, [,, "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",,,,,,, [10, 11, 12]], [,, "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",,,,
	    "2123456789",,, [10]], [,, "68[57-9]\\d{7}|(?:69|94)\\d{8}",,,, "6912345678",,, [10]], [,, "800\\d{7,9}",,,, "8001234567"], [,, "90[19]\\d{7}",,,, "9091234567",,, [10]], [,, "8(?:0[16]|12|[27]5|50)\\d{7}",,,, "8011234567",,, [10]], [,, "70\\d{8}",,,, "7012345678",,, [10]], [,,,,,,,,, [-1]], "GR", 30, "00",,,,,,,, [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [, "(\\d{3})(\\d{3,4})(\\d{5})",
	    "$1 $2 $3", ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "5005000\\d{3}",,,, "5005000123",,, [10]],,, [,,,,,,,,, [-1]]], GT: [, [,, "(?:1\\d{3}|[2-7])\\d{7}",,,,,,, [8, 11]], [,, "[267][2-9]\\d{6}",,,, "22456789",,, [8]], [,, "[3-5]\\d{7}",,,, "51234567",,, [8]], [,, "18[01]\\d{8}",,,, "18001112222",,, [11]], [,, "19\\d{9}",,,, "19001112222",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "GT", 502, "00",,,,,,,, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]],, [,,,,,,,,, [-1]],,,
	    [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GU: [, [,, "(?:[58]\\d\\d|671|900)\\d{7}",,,,,,, [10], [7]], [,, "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",,,, "6713001234",,,, [7]], [,, "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",,,,
	    "6713001234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "GU", 1, "011", "1",,, "1|([3-9]\\d{6})$", "671$1",, 1,,, [,,,,,,,,, [-1]],, "671", [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]]], GW: [, [,, "[49]\\d{8}|4\\d{6}",,,,,,, [7, 9]], [,, "443\\d{6}",,,, "443201234",,, [9]], [,, "9(?:5\\d|6[569]|77)\\d{6}",,,, "955012345",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "40\\d{5}",,,, "4012345",,, [7]], "GW", 245, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], GY: [, [,, "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",,,,,,, [7]],
	    [,, "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",,,, "2201234"], [,, "6\\d{6}",,,, "6091234"], [,, "(?:289|862)\\d{4}",,,, "2891234"], [,, "9008\\d{3}",,,, "9008123"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "GY", 592, "001",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], HK: [, [,, "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",,,,,,, [5,
	    6, 7, 8, 9, 11]], [,, "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-6]|5[0-5]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}",,,, "21234567",,, [8]], [,, "(?:46(?:[07][0-7]|1[0-6]|4[0-57-9]|5[0-8]|6[0-4])|5730|6(?:26[013-7]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|929[03-9])\\d{4}|(?:46[238]|5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",,,, "51234567",,, [8]], [,, "800\\d{6}",,,, "800123456",,,
	    [9]], [,, "900(?:[0-24-9]\\d{7}|3\\d{1,4})",,,, "90012345678",,, [5, 6, 7, 8, 11]], [,,,,,,,,, [-1]], [,, "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",,,, "81123456",,, [8]], [,,,,,,,,, [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)",,,,,, "00",, [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],, [,, "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",,,,
	    "71123456",,, [8]],,, [,,,,,,,,, [-1]], [,, "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",,,, "30161234",,, [8]],,, [,,,,,,,,, [-1]]], HN: [, [,, "8\\d{10}|[237-9]\\d{7}",,,,,,, [8, 11]], [,, "2(?:2(?:0[0-39]|1[1-367]|[23]\\d|4[03-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-9]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|74|80)|6(?:[056]\\d|17|2[067]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",,,, "22123456",,, [8]], [,, "[37-9]\\d{7}",,,,
	    "91234567",,, [8]], [,, "8002\\d{7}",,,, "80021234567",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "HN", 504, "00",,,,,,,, [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [,,,,,,,,, [-1]],,, [,, "8002\\d{7}",,,,,,, [11]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], HR: [, [,, "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",,,,,,, [6, 7, 8, 9]], [,, "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",,,,
	    "12345678",,, [8, 9], [6, 7]], [,, "9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}",,,, "921234567",,, [8, 9]], [,, "80[01]\\d{4,6}",,,, "800123456",,, [7, 8, 9]], [,, "6[01459]\\d{6}|6[01]\\d{4,5}",,,, "611234",,, [6, 7, 8]], [,,,,,,,,, [-1]], [,, "7[45]\\d{6}",,,, "74123456",,, [8]], [,,,,,,,,, [-1]], "HR", 385, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})",
	    "$1 $2 $3", ["[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "62\\d{6,7}|72\\d{6}",,,, "62123456",,, [8, 9]],,, [,,,,,,,,, [-1]]], HT: [, [,, "[2-489]\\d{7}",,,,,,, [8]], [,, "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",,,, "22453300"], [,, "[34]\\d{7}",,,, "34101234"], [,, "8\\d{7}",,,, "80012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",,,,
	    "98901234"], "HT", 509, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], HU: [, [,, "[235-7]\\d{8}|[1-9]\\d{7}",,,,,,, [8, 9], [6, 7]], [,, "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",,,, "12345678",,, [8], [6, 7]], [,, "(?:[257]0|3[01])\\d{7}",,,, "201234567",,, [9]], [,, "(?:[48]0\\d|6802)\\d{5}",,,, "80123456"], [,, "9[01]\\d{6}",,,, "90123456",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "21\\d{7}",,,,
	    "211234567",,, [9]], "HU", 36, "00", "06",,, "06",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]],, [,,,,,,,,, [-1]],,, [,, "(?:[48]0\\d|6802)\\d{5}"], [,, "38\\d{7}",,,, "381234567",,, [9]],,, [,,,,,,,,, [-1]]], ID: [, [,, "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",,,,,,, [7, 8, 9, 10, 11, 12, 13], [5, 6]], [,,
	    "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",,,, "218350123",,, [7, 8, 9, 10, 11], [5, 6]], [,, "8[1-35-9]\\d{7,10}",,,,
	    "812345678",,, [9, 10, 11, 12]], [,, "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",,,, "8001234567",,, [8, 9, 10, 11, 12, 13]], [,, "809\\d{7}",,,, "8091234567",,, [10]], [,, "804\\d{7}",,,, "8041234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "ID", 62, "00[89]", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3",
	    ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"],
	    [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [,,,,,,,,, [-1]],,, [,, "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}",,,,,,, [10, 12, 13]], [,, "(?:1500|8071\\d{3})\\d{3}",,,, "8071123456",,, [7, 10]],,, [,,,,,,,,, [-1]]], IE: [, [,, "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",,,,,,,
	    [7, 8, 9, 10], [5, 6]], [,, "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",,,, "2212345",,,, [5, 6]], [,, "8(?:22|[35-9]\\d)\\d{6}",,,, "850123456",,, [9]], [,, "1800\\d{6}",,,, "1800123456",,, [10]], [,, "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",,,, "1520123456",,, [10]], [,, "18[59]0\\d{6}",,,, "1850123456",,, [10]], [,, "700\\d{6}",,,, "700123456",,, [9]], [,, "76\\d{7}",,,, "761234567",,, [9]], "IE", 353, "00",
	    "0",,, "0",,,, [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})",
	    "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,, "18[59]0\\d{6}",,,,,,, [10]], [,, "818\\d{6}",,,, "818123456",,, [9]],,, [,, "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",,,, "8551234567",,, [10]]], IL: [, [,, "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",,,,,,, [7, 8, 9, 10, 11, 12]], [,, "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",,,, "21234567",,, [8, 11, 12], [7]], [,, "5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",,,,
	    "502345678",,, [9]], [,, "1(?:255|80[019]\\d{3})\\d{3}",,,, "1800123456",,, [7, 10]], [,, "1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}",,,, "1919123456",,, [8, 10]], [,, "1700\\d{6}",,,, "1700123456",,, [10]], [,,,,,,,,, [-1]], [,, "7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}",,,, "771234567",,, [9]], "IL", 972, "0(?:0|1[2-9])", "0",,, "0",,,, [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"],
	    [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]],, [,,,,,,,,, [-1]],,, [,, "1700\\d{6}",,,,,,, [10]], [,, "1599\\d{6}",,,, "1599123456",,, [10]],,, [,, "151\\d{8,9}",,,, "15112340000",,, [11, 12]]], IM: [, [,, "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,, [10], [6]], [,, "1624(?:230|[5-8]\\d\\d)\\d{3}",,,, "1624756789",,,,
	    [6]], [,, "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",,,, "7924123456"], [,, "808162\\d{4}",,,, "8081624567"], [,, "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",,,, "9016247890"], [,,,,,,,,, [-1]], [,, "70\\d{8}",,,, "7012345678"], [,, "56\\d{8}",,,, "5612345678"], "IM", 44, "00", "0",,, "0|([25-8]\\d{5})$", "1624$1",,,,, [,,,,,,,,, [-1]],, "74576|(?:16|7[56])24", [,,,,,,,,, [-1]], [,, "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",,,, "5512345678"],,, [,,,,,,,,, [-1]]],
	    IN: [, [,, "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",,,,,,, [8, 9, 10, 11, 12, 13], [6, 7]], [,, "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",,,,
	    "7410410123",,, [10], [6, 7, 8]], [,, "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",,,,
	    "8123456789",,, [10]], [,, "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",,,, "1800123456"], [,, "186[12]\\d{9}",,,, "1861123456789",,, [13]], [,, "1860\\d{7}",,,, "18603451234",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "IN", 91, "00", "0",,, "0",,,, [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,, 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"],,, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3",
	    ["140"],,, 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
	    "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
	    "0$1",, 1], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
	    "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1",, 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1",, 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"],,, 1], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
	    "$1 $2 $3 $4", ["0"]], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"],,, 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,, 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"],,, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"],,, 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
	    "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
	    "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
	    "0$1",, 1], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
	    "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1",, 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1",, 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"],,, 1], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
	    "$1 $2 $3 $4", ["18"],,, 1]], [,,,,,,,,, [-1]],,, [,, "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [,, "140\\d{7}",,,, "1409305260",,, [10]],,, [,,,,,,,,, [-1]]], IO: [, [,, "3\\d{6}",,,,,,, [7]], [,, "37\\d{5}",,,, "3709100"], [,, "38\\d{5}",,,, "3801234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "IO", 246, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], IQ: [, [,, "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",,,,,,,
	    [8, 9, 10], [6, 7]], [,, "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",,,, "12345678",,, [8, 9], [6, 7]], [,, "7[3-9]\\d{8}",,,, "7912345678",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "IQ", 964, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], IR: [,
	    [,, "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",,,,,,, [4, 5, 6, 7, 10], [8]], [,, "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}",,,, "2123456789",,, [6, 7, 10], [4, 5, 8]], [,, "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:(?:[0-3]\\d|4[0145])\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|[19]\\d|21|77|8[7-9])))\\d{5}",,,, "9123456789",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "IR", 98, "00", "0",,, "0",,,, [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,, "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",,,,,,, [4, 5, 10]], [,, "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",,,,
	    "9601",,, [4, 5]],,, [,,,,,,,,, [-1]]], IS: [, [,, "(?:38\\d|[4-9])\\d{6}",,,,,,, [7, 9]], [,, "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",,,, "4101234",,, [7]], [,, "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}",,,, "6111234"], [,, "80[08]\\d{4}",,,, "8001234",,, [7]], [,, "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",,,,
	    "9001234",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "49[0-24-79]\\d{4}",,,, "4921234",,, [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)",,,,,, "00",, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "809\\d{4}",,,, "8091234",,, [7]],,, [,, "(?:689|8(?:7[18]|80)|95[48])\\d{4}",,,, "6891234",,, [7]]], IT: [, [,, "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,, [6, 7, 8, 9, 10, 11, 12]], [,, "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",,,,
	    "0212345678",,, [6, 7, 8, 9, 10, 11]], [,, "3[1-9]\\d{8}|3[2-9]\\d{7}",,,, "3123456789",,, [9, 10]], [,, "80(?:0\\d{3}|3)\\d{3}",,,, "800123456",,, [6, 9]], [,, "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",,,, "899123456",,, [6, 8, 9, 10]], [,, "84(?:[08]\\d{3}|[17])\\d{3}",,,, "848123456",,, [6, 9]], [,, "1(?:78\\d|99)\\d{6}",,,, "1781234567",,, [9, 10]], [,, "55\\d{8}",,,, "5512345678",,, [10]], "IT", 39, "00",,,,,,,, [[, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
	    [, "(\\d{6})", "$1", ["1(?:1|92)"]], [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [, "(\\d{2})(\\d{4})(\\d{5})",
	    "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]],
	    [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [,,,,,,,,, [-1]], 1,, [,, "848\\d{6}",,,,,,, [9]], [,,,,,,,,, [-1]],,, [,, "3[2-8]\\d{9,10}",,,, "33101234501",,, [11, 12]]], JE: [, [,, "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,, [10], [6]], [,, "1534[0-24-8]\\d{5}",,,, "1534456789",,,, [6]], [,, "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",,,, "7797712345"],
	    [,, "80(?:07(?:35|81)|8901)\\d{4}",,,, "8007354567"], [,, "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",,,, "9018105678"], [,,,,,,,,, [-1]], [,, "701511\\d{4}",,,, "7015115678"], [,, "56\\d{8}",,,, "5612345678"], "JE", 44, "00", "0",,, "0|([0-24-8]\\d{5})$", "1534$1",,,,, [,, "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",,,, "7640123456"],,, [,,,,,,,,, [-1]], [,, "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",,,,
	    "5512345678"],,, [,,,,,,,,, [-1]]], JM: [, [,, "(?:[58]\\d\\d|658|900)\\d{7}",,,,,,, [10], [7]], [,, "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",,,, "8765230123",,,, [7]], [,, "(?:658295|876(?:2(?:0[6-9]|[14-9]\\d|2[013-9]|3[7-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",,,,
	    "8762101234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "JM", 1, "011", "1",,, "1",,,,,, [,,,,,,,,, [-1]],, "658|876", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,,
	    [-1]]], JO: [, [,, "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",,,,,,, [8, 9]], [,, "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",,,,
	    "62001234",,, [8]], [,, "7(?:[78][0-25-9]|9\\d)\\d{6}",,,, "790123456",,, [9]], [,, "80\\d{6}",,,, "80012345",,, [8]], [,, "9\\d{7}",,,, "90012345",,, [8]], [,, "85\\d{6}",,,, "85012345",,, [8]], [,, "70\\d{7}",,,, "700123456",,, [9]], [,,,,,,,,, [-1]], "JO", 962, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]],, [,, "74(?:66|77)\\d{5}",,,, "746612345",,,
	    [9]],,, [,,,,,,,,, [-1]], [,, "8(?:10|8\\d)\\d{5}",,,, "88101234",,, [8]],,, [,,,,,,,,, [-1]]], JP: [, [,, "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",,,,,,, [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [,, "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",,,, "312345678",,, [9]], [,, "[7-9]0[1-9]\\d{7}",,,,
	    "9012345678",,, [10]], [,, "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",,,, "120123456"], [,, "990\\d{6}",,,, "990123456",,, [9]], [,,,,,,,,, [-1]], [,, "60\\d{7}",,,, "601234567",,, [9]], [,, "50[1-9]\\d{7}",,,, "5012345678",,, [10]], "JP", 81, "010", "0",,, "0",,,, [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
	    "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],
	    "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
	    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
	    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
	    "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3",
	    ["0"]]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],
	    "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
	    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
	    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
	    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
	    "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [,, "20\\d{8}",,,, "2012345678",,, [10]],,, [,, "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [,, "570\\d{6}",,,, "570123456",,, [9]],,, [,,,,,,,,, [-1]]], KE: [, [,, "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",,,,,,, [7, 8, 9, 10]], [,, "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",,,,
	    "202012345",,, [7, 8, 9]], [,, "(?:1(?:0[0-6]|1[0-5]|2[014])|7\\d\\d)\\d{6}",,,, "712123456",,, [9]], [,, "800[24-8]\\d{5,6}",,,, "800223456",,, [9, 10]], [,, "900[02-9]\\d{5}",,,, "900223456",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "KE", 254, "000", "0",,, "0",,,, [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KG: [, [,, "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",,,,,,,
	    [9, 10], [5, 6]], [,, "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",,,, "312123456",,, [9], [5, 6]], [,, "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|880|99[05-9])\\d{6}",,,, "700123456",,, [9]], [,, "800\\d{6,7}",,,, "800123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]], [,,,,,,,,, [-1]], "KG", 996, "00", "0",,, "0",,,, [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KH: [, [,, "1\\d{9}|[1-9]\\d{7,8}",,,,,,, [8, 9, 10], [6, 7]], [,, "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",,,,
	    "23756789",,, [8, 9], [6, 7]], [,, "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",,,, "91234567",,, [8, 9]], [,, "1800(?:1\\d|2[019])\\d{4}",,,, "1800123456",,, [10]], [,, "1900(?:1\\d|2[09])\\d{4}",,,, "1900123456",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "KH", 855, "00[14-9]", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],,
	    [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KI: [, [,, "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",,,,,,, [5, 8]], [,, "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",,,, "31234"], [,, "(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}",,,, "72001234",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",,,, "30010000",,, [8]],
	    "KI", 686, "00", "0",,, "0",,,,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KM: [, [,, "[3478]\\d{6}",,,,,,, [7], [4]], [,, "7[4-7]\\d{5}",,,, "7712345",,,, [4]], [,, "[34]\\d{6}",,,, "3212345"], [,,,,,,,,, [-1]], [,, "8\\d{6}",,,, "8001234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "KM", 269, "00",,,,,,,, [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KN: [, [,, "(?:[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",,,,
	    "8692361234",,,, [7]], [,, "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",,,, "8697652917",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "KN", 1, "011", "1",,, "1|([2-7]\\d{6})$",
	    "869$1",,,,, [,,,,,,,,, [-1]],, "869", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KP: [, [,, "85\\d{6}|(?:19\\d|[2-7])\\d{7}",,,,,,, [8, 10], [6, 7]], [,, "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",,,, "21234567",,,, [6, 7]], [,, "19[1-3]\\d{7}",,,, "1921234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "KP", 850, "00|99", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})",
	    "$1 $2 $3", ["1"], "0$1"]],, [,,,,,,,,, [-1]],,, [,, "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",,,,,,, [8]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KR: [, [,, "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",,,,,,, [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [,, "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",,,, "22123456",,, [5, 6, 8, 9, 10], [3, 4, 7]], [,, "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",,,,
	    "1020000000",,, [9, 10]], [,, "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}",,,, "801234567",,, [9, 11, 12, 13, 14]], [,, "60[2-9]\\d{6}",,,, "602345678",,, [9]], [,,,,,,,,, [-1]], [,, "50\\d{8,9}",,,, "5012345678",,, [10, 11]], [,, "70\\d{8}",,,, "7012345678",,, [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0",,, "0(8(?:[1-46-8]|5\\d\\d))?",,,, [[, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1"], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [,
	    "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
	    "$1 $2 $3 $4", ["0"]]], [[, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]], [,, "15\\d{7,8}",,,, "1523456789",,,
	    [9, 10]],,, [,, "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",,,,,,, [11, 12, 13, 14]], [,, "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}",,,, "15441234",,, [8]],,, [,,,,,,,,, [-1]]], KW: [, [,, "(?:18|[2569]\\d\\d)\\d{5}",,,,,,, [7, 8]], [,, "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",,,, "22345678",,, [8]], [,, "(?:5(?:2(?:22|5[25])|7(?:55|77)|88[58])|6(?:222|333|444|70[013-9]|888|93[039])|9(?:11[01]|3(?:00|33)|500))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|[4679]\\d|55|8[057-9]))\\d{5}",,,,
	    "50012345",,, [8]], [,, "18\\d{5}",,,, "1801234",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "KW", 965, "00",,,,,,,, [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[25]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KY: [, [,, "(?:345|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}",,,,
	    "3452221234",,,, [7]], [,, "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",,,, "3453231234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002345678"], [,, "(?:345976|900[2-9]\\d\\d)\\d{4}",,,, "9002345678"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "KY", 1, "011", "1",,, "1|([2-9]\\d{6})$", "345$1",,,,, [,, "345849\\d{4}",,,, "3458491234"],, "345", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], KZ: [, [,, "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",,,,,,, [10, 14], [5, 6, 7]], [,, "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",,,,
	    "7123456789",,, [10], [5, 6, 7]], [,, "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",,,, "7710009998",,, [10]], [,, "8(?:00|108\\d{3})\\d{7}",,,, "8001234567"], [,, "809\\d{7}",,,, "8091234567",,, [10]], [,,,,,,,,, [-1]], [,, "808\\d{7}",,,, "8081234567",,, [10]], [,, "751\\d{7}",,,, "7511234567",,, [10]], "KZ", 7, "810", "8",,, "8",, "8~10",,,, [,,,,,,,,, [-1]],, "33|7", [,, "751\\d{7}",,,,,,, [10]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], LA: [, [,, "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",,,,,,, [8, 9, 10], [6]], [,, "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",,,,
	    "21212862",,, [8], [6]], [,, "(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}",,,, "2023123456",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LA", 856, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "30[013-9]\\d{6}",,,, "301234567",,, [9]],,, [,,,,,,,,,
	    [-1]]], LB: [, [,, "[27-9]\\d{7}|[13-9]\\d{6}",,,,,,, [7, 8]], [,, "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",,,, "1123456"], [,, "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",,,, "71123456"], [,,,,,,,,, [-1]], [,, "9[01]\\d{6}",,,, "90123456",,, [8]], [,, "80\\d{6}",,,, "80123456",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LB", 961, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
	    "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], LC: [, [,, "(?:[58]\\d\\d|758|900)\\d{7}",,,,,,, [10], [7]], [,, "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",,,, "7584305678",,,, [7]], [,, "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",,,, "7582845678",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]],
	    [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "LC", 1, "011", "1",,, "1|([2-8]\\d{6})$", "758$1",,,,, [,,,,,,,,, [-1]],, "758", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], LI: [, [,, "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",,,,,,, [7, 9]], [,, "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",,,,
	    "2345678",,, [7]], [,, "(?:6(?:4(?:69|[7-9]\\d)|5[0-4]\\d|6(?:[024]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",,,, "660234567"], [,, "80(?:02[28]|9\\d\\d)\\d\\d",,,, "8002222",,, [7]], [,, "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",,,, "9002222",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LI", 423, "00", "0",,, "0|(1001)",,,, [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"],, "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"],, "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"],,
	    "$CC $1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "870(?:28|87)\\d\\d",,,, "8702812",,, [7]],,, [,, "697(?:42|56|[78]\\d)\\d{4}",,,, "697861234",,, [9]]], LK: [, [,, "[1-9]\\d{8}",,,,,,, [9], [7]], [,, "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",,,, "112345678",,,, [7]], [,, "7(?:[0-25-8]\\d|4[01])\\d{6}",,,, "712345678"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LK", 94, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{4})",
	    "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "1973\\d{5}",,,, "197312345"],,, [,,,,,,,,, [-1]]], LR: [, [,, "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",,,,,,, [7, 8, 9]], [,, "(?:2\\d{3}|33333)\\d{4}",,,, "21234567",,, [8, 9]], [,, "(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",,,, "770123456",,, [7, 9]], [,,,,,,,,, [-1]], [,, "332(?:02|[34]\\d)\\d{4}",,,, "332021234",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LR", 231, "00", "0",,,
	    "0",,,, [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], LS: [, [,, "(?:[256]\\d\\d|800)\\d{5}",,,,,,, [8]], [,, "2\\d{7}",,,, "22123456"], [,, "[56]\\d{7}",,,, "50123456"], [,, "800[256]\\d{4}",,,, "80021234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LS", 266, "00",,,,,,,, [[, "(\\d{4})(\\d{4})", "$1 $2",
	    ["[2568]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], LT: [, [,, "(?:[3469]\\d|52|[78]0)\\d{6}",,,,,,, [8]], [,, "(?:3[1478]|4[124-6]|52)\\d{6}",,,, "31234567"], [,, "6\\d{7}",,,, "61234567"], [,, "80[02]\\d{5}",,,, "80012345"], [,, "9(?:0[0239]|10)\\d{5}",,,, "90012345"], [,, "808\\d{5}",,,, "80812345"], [,, "70[05]\\d{5}",,,, "70012345"], [,, "[89]01\\d{5}",,,, "80123456"], "LT", 370, "00", "8",,, "[08]",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)",, 1], [, "(\\d{3})(\\d{2})(\\d{3})",
	    "$1 $2 $3", ["[7-9]"], "8 $1",, 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)",, 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)",, 1]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "70[67]\\d{5}",,,, "70712345"],,, [,,,,,,,,, [-1]]], LU: [, [,, "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",,,,,,, [4, 5, 6, 7, 8, 9, 10, 11]], [,, "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",,,, "27123456"], [,, "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",,,,
	    "628123456",,, [9]], [,, "800\\d{5}",,,, "80012345",,, [8]], [,, "90[015]\\d{5}",,,, "90012345",,, [8]], [,, "801\\d{5}",,,, "80112345",,, [8]], [,,,,,,,,, [-1]], [,, "20(?:1\\d{5}|[2-689]\\d{1,7})",,,, "20201234",,, [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00",,,, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",,,, [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],,
	    "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"],, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"],, "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"],, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"],, "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"],, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"],, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4",
	    ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],, "$CC $1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], LV: [, [,, "(?:[268]\\d|90)\\d{6}",,,,,,, [8]], [,, "6\\d{7}",,,, "63123456"], [,, "2\\d{7}",,,, "21234567"], [,, "80\\d{6}",,,, "80123456"], [,, "90\\d{6}",,,, "90123456"], [,, "81\\d{6}",,,, "81123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LV", 371, "00",,,,,,,, [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]],
	    LY: [, [,, "[2-9]\\d{8}",,,,,,, [9], [7]], [,, "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",,,, "212345678",,,, [7]], [,, "9[1-6]\\d{7}",,,, "912345678"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "LY", 218, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]],
	    [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MA: [, [,, "[5-8]\\d{8}",,,,,,, [9]], [,, "5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",,,, "520123456"], [,, "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-5]|6[1267]|7[0-57]))\\d{6}",,,, "650123456"], [,, "80\\d{7}",,,, "801234567"], [,, "89\\d{7}",,,, "891234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "592(?:4[0-2]|93)\\d{4}",,,, "592401234"], "MA", 212, "00",
	    "0",,, "0",,,, [[, "(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]", "5(?:29|38)[89]0"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]],, [,,,,,,,,, [-1]], 1,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MC: [, [,, "(?:[3489]|6\\d)\\d{7}",,,,,,, [8, 9]], [,, "(?:870|9[2-47-9]\\d)\\d{5}",,,,
	    "99123456",,, [8]], [,, "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",,,, "612345678"], [,, "(?:800|90\\d)\\d{5}",,,, "90123456",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "MC", 377, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"],
	    "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [,,,,,,,,, [-1]],,, [,, "8[07]0\\d{5}",,,,,,, [8]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MD: [, [,, "(?:[235-7]\\d|[89]0)\\d{6}",,,,,,, [8]], [,, "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",,,, "22212345"], [,, "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",,,, "62112345"], [,, "800\\d{5}",,,, "80012345"], [,, "90[056]\\d{5}",,,, "90012345"], [,, "808\\d{5}",,,, "80812345"], [,,,,,,,,, [-1]],
	    [,, "3[08]\\d{6}",,,, "30123456"], "MD", 373, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "803\\d{5}",,,, "80312345"],,, [,,,,,,,,, [-1]]], ME: [, [,, "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",,,,,,, [8, 9], [6]], [,, "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",,,, "30234567",,, [8], [6]], [,, "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",,,,
	    "67622901",,, [8]], [,, "80(?:[0-2578]|9\\d)\\d{5}",,,, "80080002"], [,, "9(?:4[1568]|5[178])\\d{5}",,,, "94515151",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "78[1-49]\\d{5}",,,, "78108780",,, [8]], "ME", 382, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "77[1-9]\\d{5}",,,, "77273012",,, [8]],,, [,,,,,,,,, [-1]]], MF: [, [,, "(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,, [9]], [,, "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}",,,, "590271234"], [,, "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,
	    "690001234"], [,, "80[0-5]\\d{6}",,,, "800012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "976[01]\\d{5}",,,, "976012345"], "MF", 590, "00", "0",,, "0",,,,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MG: [, [,, "[23]\\d{8}",,,,,,, [9], [7]], [,, "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}",,,, "202123456",,,, [7]], [,, "3[2-489]\\d{7}",,,, "321234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "22\\d{7}",,,, "221234567"], "MG",
	    261, "00", "0",,, "0|([24-9]\\d{6})$", "20$1",,, [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MH: [, [,, "329\\d{4}|(?:[256]\\d|45)\\d{5}",,,,,,, [7]], [,, "(?:247|528|625)\\d{4}",,,, "2471234"], [,, "(?:(?:23|54)5|329|45[56])\\d{4}",,,, "2351234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "635\\d{4}",,,, "6351234"], "MH", 692, "011", "1",,, "1",,,, [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]],, [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MK: [, [,, "[2-578]\\d{7}",,,,,,, [8], [6, 7]], [,, "(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",,,, "22012345",,,, [6, 7]], [,, "7(?:3555|4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[2-4]|42|9[23])\\d{5}",,,, "72345678"], [,, "800\\d{5}",,,, "80012345"], [,, "5[02-9]\\d{6}",,,, "50012345"], [,, "8(?:0[1-9]|[1-9]\\d)\\d{5}",,,, "80123456"], [,,,,,,,,, [-1]],
	    [,,,,,,,,, [-1]], "MK", 389, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], ML: [, [,, "[24-9]\\d{7}",,,,,,, [8]], [,, "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",,,, "20212345"], [,, "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}",,,, "65012345"], [,, "80\\d{6}",,,,
	    "80012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "ML", 223, "00",,,,,,,, [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [,,,,,,,,, [-1]],,, [,, "80\\d{6}"], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MM: [, [,, "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",,,,,,, [6, 7, 8, 9, 10], [5]], [,, "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",,,,
	    "1234567",,, [6, 7, 8, 9], [5]], [,, "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",,,, "92123456",,, [7, 8, 9, 10]], [,, "80080(?:[01][1-9]|2\\d)\\d{3}",,,, "8008001234",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "1333\\d{4}|[12]468\\d{4}",,,, "13331234",,, [8]], "MM", 95, "00", "0",,, "0",,,, [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})",
	    "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]],, [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MN: [, [,, "[12]\\d{7,9}|[57-9]\\d{7}",,,,,,, [8, 9, 10], [4, 5, 6]], [,, "[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",,,, "53123456",,,, [4, 5, 6]], [,, "(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}",,,, "88123456",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "712[0-79]\\d{4}|7(?:1[013-9]|[5-8]\\d)\\d{5}",,,, "75123456",,, [8]], "MN", 976, "001",
	    "0",,, "0",,,, [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MO: [, [,, "0800\\d{3}|(?:28|[68]\\d)\\d{6}",,,,,,, [7, 8]], [,, "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",,,,
	    "28212345",,, [8]], [,, "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",,,, "66123456",,, [8]], [,, "0800\\d{3}",,,, "0800501",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "MO", 853, "00",,,,,,,, [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MP: [, [,, "[58]\\d{9}|(?:67|90)0\\d{7}",,,,,,, [10], [7]], [,, "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,,
	    "6702345678",,,, [7]], [,, "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,, "6702345678",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "MP", 1, "011", "1",,, "1|([2-9]\\d{6})$", "670$1",, 1,,, [,,,,,,,,, [-1]],, "670", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MQ: [, [,, "(?:69|80)\\d{7}|(?:59|97)6\\d{6}",,,,,,, [9]], [,, "596(?:0[0-8]|10|2[7-9]|3[04-9]|[4-7]\\d|8[09]|9[4-9])\\d{4}",,,, "596301234"], [,, "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}",,,, "696201234"], [,, "80[0-5]\\d{6}",,,, "800012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "976(?:6\\d|7[0-367])\\d{4}",,,, "976612345"], "MQ", 596, "00", "0",,,
	    "0",,,, [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MR: [, [,, "(?:[2-4]\\d\\d|800)\\d{5}",,,,,,, [8]], [,, "(?:25[08]|35\\d|45[1-7])\\d{5}",,,, "35123456"], [,, "[2-4][0-46-9]\\d{6}",,,, "22123456"], [,, "800\\d{5}",,,, "80012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "MR", 222, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["[2-48]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MS: [, [,, "(?:[58]\\d\\d|664|900)\\d{7}",,,,,,, [10], [7]], [,, "6644(?:1[0-3]|91)\\d{4}",,,, "6644912345",,,, [7]], [,, "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",,,, "6644923456",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "MS", 1, "011", "1",,, "1|([34]\\d{6})$", "664$1",,,,, [,,,,,,,,, [-1]],, "664", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MT: [, [,, "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",,,,,,, [8]], [,, "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",,,, "21001234"], [,, "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",,,, "96961234"], [,, "800[3467]\\d{4}",,,, "80071234"], [,, "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",,,, "50037123"],
	    [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "3550\\d{4}",,,, "35501234"], "MT", 356, "00",,,,,,,, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]],, [,, "7117\\d{4}",,,, "71171234"],,, [,,,,,,,,, [-1]], [,, "501\\d{5}",,,, "50112345"],,, [,,,,,,,,, [-1]]], MU: [, [,, "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",,,,,,, [7, 8, 10]], [,, "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",,,, "54480123",,, [7, 8]], [,, "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[5-9]|4[3-589]|[57]\\d|8[0-689]|9[0-8])\\d{5}",,,,
	    "52512345",,, [8]], [,, "802\\d{7}|80[0-2]\\d{4}",,,, "8001234",,, [7, 10]], [,, "30\\d{5}",,,, "3012345",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "3(?:20|9\\d)\\d{4}",,,, "3201234",,, [7]], "MU", 230, "0(?:0|[24-7]0|3[03])",,,,,, "020",, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["5"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MV: [, [,, "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",,,,,,, [7, 10]], [,, "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}",,,,
	    "6701234",,, [7]], [,, "46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}",,,, "7712345",,, [7]], [,, "800\\d{7}",,,, "8001234567",,, [10]], [,, "900\\d{7}",,,, "9001234567",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "MV", 960, "0(?:0|19)",,,,,, "00",, [[, "(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "4[05]0\\d{4}",,,, "4001234",,, [7]],,, [,,,,,,,,, [-1]]], MW: [, [,, "(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",,,,,,, [7, 9]], [,, "(?:1[2-9]|21\\d\\d)\\d{5}",,,,
	    "1234567"], [,, "111\\d{6}|(?:31|77|88|9[89])\\d{7}",,,, "991234567",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "MW", 265, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MX: [, [,, "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",,,,,,,
	    [10, 11], [7, 8]], [,, "6571\\d{6}|(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",,,, "2001234567",,, [10], [7, 8]], [,, "6571\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",,,,
	    "12221234567",,,, [7, 8]], [,, "8(?:00|88)\\d{7}",,,, "8001234567",,, [10]], [,, "900\\d{7}",,,, "9001234567",,, [10]], [,, "300\\d{7}",,,, "3001234567",,, [10]], [,, "500\\d{7}",,,, "5001234567",,, [10]], [,,,,,,,,, [-1]], "MX", 52, "0[09]", "01",,, "0(?:[12]|4[45])|1",, "00",, [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"],,, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"],,, 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"],,, 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})",
	    "$2 $3 $4", ["1"],,, 1]], [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"],,, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"],,, 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"],,, 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"],,, 1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MY: [, [,, "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",,,,,,, [8, 9, 10], [6, 7]], [,, "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",,,,
	    "323856789",,, [8, 9], [6, 7]], [,, "1(?:1888[69]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0134]\\d|2[1-9]|5[0-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}",,,, "123456789",,, [9, 10]], [,, "1[378]00\\d{6}",,,, "1300123456",,, [10]], [,, "1600\\d{6}",,,, "1600123456",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",,,,
	    "1546012345",,, [10]], "MY", 60, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9])|8"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], MZ: [, [,, "(?:2|8\\d)\\d{7}",,,,,,,
	    [8, 9]], [,, "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",,,, "21123456",,, [8]], [,, "8[2-79]\\d{7}",,,, "821234567",,, [9]], [,, "800\\d{6}",,,, "800123456",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "MZ", 258, "00",,,,,,,, [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], NA: [, [,, "[68]\\d{7,8}",,,,,,, [8, 9]], [,, "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",,,,
	    "61221234"], [,, "(?:60|8[1245])\\d{7}",,,, "811234567",,, [9]], [,, "80\\d{7}",,,, "800123456",,, [9]], [,, "8701\\d{5}",,,, "870123456",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "8(?:3\\d\\d|86)\\d{5}",,,, "88612345"], "NA", 264, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]]], NC: [, [,, "[2-57-9]\\d{5}",,,,,,, [6]], [,, "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",,,, "201234"], [,, "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",,,, "751234"], [,,,,,,,,, [-1]], [,, "36\\d{4}",,,, "366711"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NC", 687, "00",,,,,,,, [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], NE: [, [,, "[027-9]\\d{7}",,,,,,,
	    [8]], [,, "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",,,, "20201234"], [,, "(?:23|7[04]|[89]\\d)\\d{6}",,,, "93123456"], [,, "08\\d{6}",,,, "08123456"], [,, "09\\d{6}",,,, "09123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NE", 227, "00",,,,,,,, [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], NF: [, [,,
	    "[13]\\d{5}",,,,,,, [6], [5]], [,, "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",,,, "106609",,,, [5]], [,, "(?:14|3[58])\\d{4}",,,, "381234",,,, [5]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NF", 672, "00",,,, "([0-258]\\d{4})$", "3$1",,, [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], NG: [, [,, "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",,,,,,, [7, 8, 10, 11, 12, 13, 14], [5, 6]],
	    [,, "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",,,, "18040123",,, [7, 8], [5, 6]], [,, "(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|9(?:0[1-9]|1[2356]))\\d{7}",,,, "8021234567",,, [10]], [,, "800\\d{7,11}",,,, "80017591759",,, [10, 11, 12, 13, 14]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NG", 234, "009", "0",,, "0",,,, [[, "(\\d{2})(\\d{2})(\\d{3})",
	    "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "700\\d{7,11}",,,, "7001234567",,, [10, 11, 12, 13, 14]],,, [,,,,,,,,, [-1]]], NI: [, [,, "(?:1800|[25-8]\\d{3})\\d{4}",,,,,,, [8]], [,, "2\\d{7}",,,,
	    "21234567"], [,, "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",,,, "81234567"], [,, "1800\\d{4}",,,, "18001234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NI", 505, "00",,,,,,,, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], NL: [, [,, "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",,,,,,, [5, 6, 7, 8, 9, 10]], [,, "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",,,,
	    "101234567",,, [9]], [,, "6[1-58]\\d{7}",,,, "612345678",,, [9]], [,, "800\\d{4,7}",,,, "8001234",,, [7, 8, 9, 10]], [,, "90[069]\\d{4,7}",,,, "9061234",,, [7, 8, 9, 10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "(?:85|91)\\d{7}",,,, "851234567",,, [9]], "NL", 31, "00", "0",,, "0",,,, [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})",
	    "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]], [,, "66\\d{7}",,,, "662345678",,, [9]],,, [,, "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",,,,,,,
	    [5, 6]], [,, "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",,,, "14020",,, [5, 6, 9]],,, [,,,,,,,,, [-1]]], NO: [, [,, "(?:0|[2-9]\\d{3})\\d{4}",,,,,,, [5, 8]], [,, "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",,,, "21234567",,, [8]], [,, "(?:4[015-8]|59|9\\d)\\d{6}",,,, "40612345",,, [8]], [,, "80[01]\\d{5}",,,, "80012345",,, [8]], [,, "82[09]\\d{5}",,,, "82012345",,, [8]], [,, "810(?:0[0-6]|[2-8]\\d)\\d{3}",,,, "81021234",,, [8]], [,, "880\\d{5}",,,,
	    "88012345",,, [8]], [,, "85[0-5]\\d{5}",,,, "85012345",,, [8]], "NO", 47, "00",,,,,,,, [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]],, [,,,,,,,,, [-1]], 1, "[02-689]|7[0-8]", [,,,,,,,,, [-1]], [,, "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,, "02000"],,, [,, "81[23]\\d{5}",,,, "81212345",,, [8]]], NP: [, [,, "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",,,,,,, [8, 10, 11], [6, 7]], [,, "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",,,,
	    "14567890",,, [8], [6, 7]], [,, "9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}",,,, "9841234567",,, [10]], [,, "1(?:66001|800\\d\\d)\\d{5}",,,, "16600101234",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NP", 977, "00", "0",,, "0",,,, [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})",
	    "$1-$2", ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], NR: [, [,, "(?:444|(?:55|8\\d)\\d|666)\\d{4}",,,,,,, [7]], [,, "444\\d{4}",,,, "4441234"], [,, "(?:55[3-9]|666|8\\d\\d)\\d{4}",,,, "5551234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NR", 674, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]],
	    NU: [, [,, "(?:[47]|888\\d)\\d{3}",,,,,,, [4, 7]], [,, "[47]\\d{3}",,,, "7012",,, [4]], [,, "888[4-9]\\d{3}",,,, "8884012",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "NU", 683, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], NZ: [, [,, "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",,,,,,, [5, 6, 7, 8, 9, 10]], [,, "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",,,,
	    "32345678",,, [8], [7]], [,, "2[0-27-9]\\d{7,8}|21\\d{6}",,,, "211234567",,, [8, 9, 10]], [,, "508\\d{6,7}|80\\d{6,8}",,,, "800123456",,, [8, 9, 10]], [,, "(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",,,, "900123456",,, [7, 8, 9, 10]], [,,,,,,,,, [-1]], [,, "70\\d{7}",,,, "701234567",,, [9]], [,,,,,,,,, [-1]], "NZ", 64, "0(?:0|161)", "0",,, "0",, "00",, [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})",
	    "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]],, [,, "[28]6\\d{6,7}",,,, "26123456",,, [8, 9]],,, [,,,,,,,,, [-1]], [,, "8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}",,,, "83012378"],,, [,,,,,,,,, [-1]]], OM: [, [,, "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",,,,,,, [7, 8, 9]], [,, "2[2-6]\\d{6}",,,,
	    "23123456",,, [8]], [,, "1505\\d{4}|(?:7(?:[1289]\\d|70)|9(?:0[1-9]|[1-9]\\d))\\d{5}",,,, "92123456",,, [8]], [,, "8007\\d{4,5}|(?:500|800[05])\\d{4}",,,, "80071234"], [,, "900\\d{5}",,,, "90012345",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "OM", 968, "00",,,,,,,, [[, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PA: [, [,, "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",,,,,,,
	    [7, 8, 10, 11]], [,, "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[139])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-5]|33|4[0-79]|55|6[068]|7[03-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[6-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",,,, "2001234",,, [7]], [,, "(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-8])\\d|8(?:1[01]|7[23]))\\d{4}",,,,
	    "61234567",,, [7, 8]], [,, "800\\d{4,5}|(?:00800|800\\d)\\d{6}",,,, "8001234"], [,, "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",,,, "8601234",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "PA", 507, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PE: [, [,, "(?:[14-8]|9\\d)\\d{7}",,,,,,, [8, 9], [6, 7]], [,, "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",,,,
	    "11234567",,, [8], [6, 7]], [,, "9\\d{8}",,,, "912345678",,, [9]], [,, "800\\d{5}",,,, "80012345",,, [8]], [,, "805\\d{5}",,,, "80512345",,, [8]], [,, "801\\d{5}",,,, "80112345",,, [8]], [,, "80[24]\\d{5}",,,, "80212345",,, [8]], [,,,,,,,,, [-1]], "PE", 51, "19(?:1[124]|77|90)00", "0", " Anexo ",, "0",,,, [[, "(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]]], PF: [, [,, "4\\d{5}(?:\\d{2})?|8\\d{7,8}",,,,,,, [6, 8, 9]], [,, "4(?:0[4-689]|9[4-68])\\d{5}",,,, "40412345",,, [8]], [,, "8[7-9]\\d{6}",,,, "87123456",,, [8]], [,, "80[0-5]\\d{6}",,,, "800012345",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "499\\d{5}",,,, "49901234",,, [8]], "PF", 689, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],, [,,,,,,,,,
	    [-1]],,, [,, "44\\d{4}",,,,,,, [6]], [,, "44\\d{4}",,,, "440123",,, [6]],,, [,,,,,,,,, [-1]]], PG: [, [,, "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",,,,,,, [7, 8]], [,, "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",,,, "3123456",,, [7]], [,, "(?:7\\d|8[18])\\d{6}",,,, "70123456",,, [8]], [,, "180\\d{4}",,,, "1801234",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "2(?:0[0-47]|7[568])\\d{4}",,,, "2751234",,, [7]], "PG", 675, "00|140[1-3]",,,,,, "00",, [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]],
	    [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]],, [,, "27[01]\\d{4}",,,, "2700123",,, [7]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PH: [, [,, "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",,,,,,, [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [,, "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",,,, "232345678",,, [6, 8, 9, 10], [4, 5, 7]], [,, "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[2357]\\d|4[2-9]|6[0-35-9]|8[135-9]|9[1-9]))\\d{7}",,,, "9051234567",,, [10]], [,,
	    "1800\\d{7,9}",,,, "180012345678",,, [11, 12, 13]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "PH", 63, "00", "0",,, "0",,,, [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"],
	    [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PK: [, [,, "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",,,,,,,
	    [8, 9, 10, 11, 12], [5, 6, 7]], [,, "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",,,, "2123456789",,, [9, 10], [5, 6, 7, 8]], [,, "3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}",,,, "3012345678",,, [10]], [,, "800\\d{5}(?:\\d{3})?",,,, "80012345",,, [8, 11]], [,, "900\\d{5}",,,, "90012345",,, [8]], [,,,,,,,,, [-1]],
	    [,, "122\\d{6}",,,, "122044444",,, [9]], [,,,,,,,,, [-1]], "PK", 92, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
	    "(0$1)"], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",,,,
	    "21111825888",,, [11, 12]],,, [,,,,,,,,, [-1]]], PL: [, [,, "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",,,,,,, [6, 7, 8, 9, 10]], [,, "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",,,, "123456789",,, [7, 9]], [,, "211(?:1\\d|3[1-5])\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",,,, "512345678",,, [9]], [,, "800\\d{6,7}",,,, "800123456",,, [9, 10]], [,, "70[01346-8]\\d{6}",,,, "701234567",,, [9]], [,, "801\\d{6}",,,, "801234567",,,
	    [9]], [,,,,,,,,, [-1]], [,, "39\\d{7}",,,, "391234567",,, [9]], "PL", 48, "00",,,,,,,, [[, "(\\d{5})", "$1", ["19"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]],, [,, "64\\d{4,7}",,,, "641234567",,, [6, 7, 8, 9]],,, [,,,,,,,,, [-1]], [,, "804\\d{6}",,,, "804123456",,, [9]],,, [,,,,,,,,, [-1]]], PM: [, [,, "(?:[45]|80\\d\\d)\\d{5}",,,,,,, [6, 9]], [,, "(?:4[1-3]|50)\\d{4}",,,, "430123",,, [6]], [,, "(?:4[02-4]|5[05])\\d{4}",,,, "551234",,, [6]], [,, "80[0-5]\\d{6}",,,, "800012345",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "PM", 508, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{2})(\\d{2})",
	    "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PR: [, [,, "(?:[589]\\d\\d|787)\\d{7}",,,,,,, [10], [7]], [,, "(?:787|939)[2-9]\\d{6}",,,, "7872345678",,,, [7]], [,, "(?:787|939)[2-9]\\d{6}",,,, "7872345678",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002345678"], [,, "900[2-9]\\d{6}",,,, "9002345678"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "PR", 1, "011", "1",,, "1",,, 1,,, [,,,,,,,,, [-1]],, "787|939", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PS: [, [,, "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",,,,,,, [8, 9, 10], [7]], [,, "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",,,, "22234567",,, [8], [7]], [,, "5[69]\\d{7}",,,, "599123456",,, [9]], [,, "1800\\d{6}",,,, "1800123456",,, [10]], [,,,,,,,,, [-1]], [,, "1700\\d{6}",,,, "1700123456",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "PS", 970, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3",
	    ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PT: [, [,, "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",,,,,,, [9]], [,, "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}",,,, "212345678"], [,, "6[0356]92(?:30|9\\d)\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",,,, "912345678"], [,, "80[02]\\d{6}",,,, "800123456"], [,, "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",,,,
	    "760123456"], [,, "80(?:8\\d|9[1579])\\d{5}",,,, "808123456"], [,, "884[0-4689]\\d{5}",,,, "884123456"], [,, "30\\d{7}",,,, "301234567"], "PT", 351, "00",,,,,,,, [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "70(?:7\\d|8[17])\\d{5}",,,, "707123456"],,, [,, "600\\d{6}",,,, "600110000"]], PW: [, [,, "(?:[24-8]\\d\\d|345|900)\\d{4}",,,,,,, [7]], [,, "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",,,,
	    "2771234"], [,, "(?:46[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",,,, "6201234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "PW", 680, "01[12]",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], PY: [, [,, "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",,,,,,, [6, 7, 8, 9, 10, 11], [5]], [,, "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",,,,
	    "212345678",,, [7, 8, 9], [5, 6]], [,, "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",,,, "961456789",,, [9]], [,, "9800\\d{5,7}",,,, "98000123456",,, [9, 10, 11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "8700[0-4]\\d{4}",,,, "870012345",,, [9]], "PY", 595, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})",
	    "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "[2-9]0\\d{4,7}",,,, "201234567",,, [6, 7, 8, 9]],,, [,,,,,,,,, [-1]]], QA: [, [,, "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",,,,,,, [7, 8, 9]], [,, "4141\\d{4}|(?:23|4[04])\\d{6}",,,, "44123456",,,
	    [8]], [,, "(?:28|[35-7]\\d)\\d{6}",,,, "33123456",,, [8]], [,, "800\\d{4}(?:\\d{2})?",,,, "8001234",,, [7, 9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "QA", 974, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]],, [,, "2(?:[12]\\d|61)\\d{4}",,,, "2123456",,, [7]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], RE: [, [,, "9769\\d{5}|(?:26|[68]\\d)\\d{7}",,,,,,, [9]], [,, "26(?:2\\d\\d|30[0-5])\\d{4}",,,, "262161234"], [,, "(?:69(?:2\\d\\d|3(?:[06][0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}",,,,
	    "692123456"], [,, "80\\d{7}",,,, "801234567"], [,, "89[1-37-9]\\d{6}",,,, "891123456"], [,, "8(?:1[019]|2[0156]|84|90)\\d{6}",,,, "810123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "RE", 262, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]],, [,,,,,,,,, [-1]], 1, "26[23]|69|[89]", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], RO: [, [,, "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",,,,,,, [6, 9]], [,, "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",,,, "211234567"], [,, "7020\\d{5}|7(?:0[013-9]|1[0-2]|[2-7]\\d|8[03-8]|9[019])\\d{6}",,,,
	    "712034567",,, [9]], [,, "800\\d{6}",,,, "800123456",,, [9]], [,, "90[0136]\\d{6}",,,, "900123456",,, [9]], [,, "801\\d{6}",,,, "801123456",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "RO", 40, "00", "0", " int ",, "0",,,, [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "(?:37\\d|80[578])\\d{6}",,,, "372123456",,,
	    [9]],,, [,,,,,,,,, [-1]]], RS: [, [,, "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",,,,,,, [6, 7, 8, 9, 10, 11, 12], [4, 5]], [,, "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",,,, "10234567",,, [7, 8, 9, 10, 11, 12], [4, 5, 6]], [,, "6(?:[0-689]|7\\d)\\d{6,7}",,,, "601234567",,, [8, 9, 10]], [,, "800\\d{3,9}",,,, "80012345"], [,, "(?:78\\d|90[0169])\\d{3,7}",,,, "90012345",,, [6, 7, 8, 9, 10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]], "RS", 381, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "7[06]\\d{4,10}",,,, "700123456"],,, [,,,,,,,,, [-1]]], RU: [, [,, "8\\d{13}|[347-9]\\d{9}",,,,,,, [10, 14], [7]], [,, "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",,,, "3011234567",,, [10], [7]], [,, "9\\d{9}",,,,
	    "9123456789",,, [10]], [,, "8(?:0[04]|108\\d{3})\\d{7}",,,, "8001234567"], [,, "80[39]\\d{7}",,,, "8091234567",,, [10]], [,,,,,,,,, [-1]], [,, "808\\d{7}",,,, "8081234567",,, [10]], [,,,,,,,,, [-1]], "RU", 7, "810", "8",,, "8",, "8~10",, [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)",, 1], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)",, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)",, 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)",, 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
	    "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)",, 1], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
	    "8 ($1)",, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)",, 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)",, 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [,,,,,,,,, [-1]], 1, "3[04-689]|[489]", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], RW: [, [,, "(?:06|[27]\\d\\d|[89]00)\\d{6}",,,,,,, [8, 9]], [,, "(?:06|2[23568]\\d)\\d{6}",,,, "250123456"], [,, "7[2389]\\d{7}",,,, "720123456",,, [9]], [,, "800\\d{6}",,,, "800123456",,, [9]], [,,
	    "900\\d{6}",,,, "900123456",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "RW", 250, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SA: [, [,, "92\\d{7}|(?:[15]|8\\d)\\d{8}",,,,,,, [9, 10], [7]], [,, "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",,,, "112345678",,, [9], [7]], [,, "579[01]\\d{5}|5(?:[013-689]\\d|7[0-36-8])\\d{6}",,,,
	    "512345678",,, [9]], [,, "800\\d{7}",,,, "8001234567",,, [10]], [,, "925\\d{6}",,,, "925012345",,, [9]], [,, "920\\d{6}",,,, "920012345",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "SA", 966, "00", "0",,, "0",,,, [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "811\\d{7}",,,, "8110123456",,,
	    [10]],,, [,,,,,,,,, [-1]]], SB: [, [,, "(?:[1-6]|[7-9]\\d\\d)\\d{4}",,,,,,, [5, 7]], [,, "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",,,, "40123",,, [5]], [,, "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",,,, "7421234"], [,, "1[38]\\d{3}",,,, "18123",,, [5]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "5[12]\\d{3}",,,, "51123",,, [5]], "SB", 677, "0[01]",,,,,,,, [[, "(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],, [,,,,,,,,, [-1]],,,
	    [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SC: [, [,, "8000\\d{3}|(?:[249]\\d|64)\\d{5}",,,,,,, [7]], [,, "4[2-46]\\d{5}",,,, "4217123"], [,, "2[5-8]\\d{5}",,,, "2510123"], [,, "8000\\d{3}",,,, "8000000"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "971\\d{4}|(?:64|95)\\d{5}",,,, "6412345"], "SC", 248, "010|0[0-2]",,,,,, "00",, [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SD: [, [,, "[19]\\d{8}",,,,,,, [9]], [,, "1(?:5\\d|8[35-7])\\d{6}",,,,
	    "153123456"], [,, "(?:1[0-2]|9[0-3569])\\d{7}",,,, "911231234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "SD", 249, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SE: [, [,, "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",,,,,,, [6, 7, 8, 9, 10, 12]], [,, "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",,,,
	    "8123456",,, [7, 8, 9]], [,, "7[02369]\\d{7}",,,, "701234567",,, [9]], [,, "20\\d{4,7}",,,, "20123456",,, [6, 7, 8, 9]], [,, "649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}",,,, "9001234567",,, [7, 8, 9, 10]], [,, "77[0-7]\\d{6}",,,, "771234567",,, [9]], [,, "75[1-8]\\d{6}",,,, "751234567",,, [9]], [,,,,,,,,, [-1]], "SE", 46, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1"],
	    [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})",
	    "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["8"]], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [,, "74[02-9]\\d{6}",,,, "740123456",,, [9]],,, [,,,,,,,,, [-1]], [,, "10[1-8]\\d{6}",,,, "102345678",,, [9]],,, [,, "(?:25[245]|67[3-68])\\d{9}",,,, "254123456789",,, [12]]], SG: [, [,, "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",,,,,,, [8, 10, 11]], [,, "662[0-24-9]\\d{4}|6(?:[1-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",,,,
	    "61234567",,, [8]], [,, "(?:8(?:0(?:[13]\\d|2[013-9]|4[0-35-7])|[1-8]\\d\\d|9(?:[0-4]\\d|5[0-2]))|9[0-8]\\d\\d)\\d{4}",,,, "81234567",,, [8]], [,, "(?:18|8)00\\d{7}",,,, "18001234567",,, [10, 11]], [,, "1900\\d{7}",,,, "19001234567",,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "(?:3[12]\\d|666)\\d{5}",,,, "31234567",,, [8]], "SG", 65, "0[0-3]\\d",,,,,,,, [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-4]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3",
	    ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-4]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "7000\\d{7}",,,, "70001234567",,, [11]],,, [,,,,,,,,, [-1]]], SH: [, [,, "(?:[256]\\d|8)\\d{3}",,,,,,, [4, 5]], [,, "2(?:[0-57-9]\\d|6[4-9])\\d\\d",,,, "22158"], [,, "[56]\\d{4}",,,,
	    "51234",,, [5]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "262\\d\\d",,,, "26212",,, [5]], "SH", 290, "00",,,,,,,,,, [,,,,,,,,, [-1]], 1, "[256]", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SI: [, [,, "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",,,,,,, [5, 6, 7, 8]], [,, "(?:[1-357][2-8]|4[24-8])\\d{6}",,,, "12345678",,, [8], [7]], [,, "65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",,,, "31234567",,, [8]], [,, "80\\d{4,6}",,,, "80123456",,, [6, 7, 8]], [,, "89[1-3]\\d{2,5}|90\\d{4,6}",,,,
	    "90123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",,,, "59012345",,, [8]], "SI", 386, "00|10(?:22|66|88|99)", "0",,, "0",, "00",, [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,,
	    [-1]]], SJ: [, [,, "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",,,,,,, [5, 8]], [,, "79\\d{6}",,,, "79123456",,, [8]], [,, "(?:4[015-8]|59|9\\d)\\d{6}",,,, "41234567",,, [8]], [,, "80[01]\\d{5}",,,, "80012345",,, [8]], [,, "82[09]\\d{5}",,,, "82012345",,, [8]], [,, "810(?:0[0-6]|[2-8]\\d)\\d{3}",,,, "81021234",,, [8]], [,, "880\\d{5}",,,, "88012345",,, [8]], [,, "85[0-5]\\d{5}",,,, "85012345",,, [8]], "SJ", 47, "00",,,,,,,,,, [,,,,,,,,, [-1]],, "79", [,,,,,,,,, [-1]], [,, "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,, "02000"],,, [,, "81[23]\\d{5}",,,,
	    "81212345",,, [8]]], SK: [, [,, "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",,,,,,, [6, 7, 9]], [,, "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",,,, "221234567"], [,, "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",,,, "912123456",,, [9]], [,, "800\\d{6}",,,, "800123456",,, [9]], [,, "9(?:00|[78]\\d)\\d{6}",,,, "900123456",,, [9]], [,, "8[5-9]\\d{7}",,,, "850123456",,, [9]], [,,,,,,,,, [-1]], [,, "6(?:02|5[0-4]|9[0-6])\\d{6}",,,, "690123456",,,
	    [9]], "SK", 421, "00", "0",,, "0",,,, [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3",
	    ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [,, "9090\\d{3}",,,, "9090123",,, [7]],,, [,, "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",,,,,,, [7, 9]], [,, "96\\d{7}",,,, "961234567",,, [9]],,, [,,,,,,,,, [-1]]], SL: [, [,, "(?:[237-9]\\d|66)\\d{6}",,,,,,, [8], [6]], [,, "22[2-4][2-9]\\d{4}",,,, "22221234",,,, [6]], [,, "(?:25|3[0-5]|66|7[3-9]|8[08]|9[09])\\d{6}",,,,
	    "25123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "SL", 232, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SM: [, [,, "(?:0549|[5-7]\\d)\\d{6}",,,,,,, [8, 10], [6]], [,, "0549(?:8[0157-9]|9\\d)\\d{4}",,,, "0549886377",,, [10], [6]], [,, "6[16]\\d{6}",,,, "66661212",,, [8]], [,,,,,,,,, [-1]], [,, "7[178]\\d{6}",,,, "71123456",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "5[158]\\d{6}",,,,
	    "58001110",,, [8]], "SM", 378, "00",,,, "([89]\\d{5})$", "0549$1",,, [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SN: [, [,, "(?:[378]\\d|93)\\d{7}",,,,,,, [9]], [,, "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",,,, "301012345"], [,, "75(?:01|[38]3)\\d{5}|7(?:[06-8]\\d|21|5[4-7]|90)\\d{6}",,,,
	    "701234567"], [,, "800\\d{6}",,,, "800123456"], [,, "88[4689]\\d{6}",,,, "884123456"], [,, "81[02468]\\d{6}",,,, "810123456"], [,,,,,,,,, [-1]], [,, "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",,,, "933301234"], "SN", 221, "00",,,,,,,, [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SO: [, [,, "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",,,,,,, [6, 7, 8, 9]], [,,
	    "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",,,, "4012345",,, [6, 7]], [,, "(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:6\\d|7[1-9])\\d{6}",,,, "71123456",,, [7, 8, 9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "SO", 252, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [, "(\\d)(\\d{7})",
	    "$1 $2", ["24|[67]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SR: [, [,, "(?:[2-5]|68|[78]\\d)\\d{5}",,,,,,, [6, 7]], [,, "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",,,, "211234"], [,, "(?:7[124-7]|8[124-9])\\d{5}",,,, "7412345",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "56\\d{4}",,,, "561234",,, [6]], "SR", 597, "00",,,,,,,,
	    [[, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SS: [, [,, "[19]\\d{8}",,,,,,, [9]], [,, "1[89]\\d{7}",,,, "181234567"], [,, "(?:12|9[1257-9])\\d{7}",,,, "977123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "SS", 211, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,,
	    [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], ST: [, [,, "(?:22|9\\d)\\d{5}",,,,,,, [7]], [,, "22\\d{5}",,,, "2221234"], [,, "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",,,, "9812345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "ST", 239, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SV: [, [,, "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",,,,,,, [7, 8, 11]], [,, "2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}",,,, "21234567",,,
	    [8]], [,, "66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}",,,, "70123456",,, [8]], [,, "800\\d{4}(?:\\d{4})?",,,, "8001234",,, [7, 11]], [,, "900\\d{4}(?:\\d{4})?",,,, "9001234",,, [7, 11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "SV", 503, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SX: [, [,, "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",,,,,,,
	    [10], [7]], [,, "7215(?:4[2-8]|8[239]|9[056])\\d{4}",,,, "7215425678",,,, [7]], [,, "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",,,, "7215205678",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002123456"], [,, "900[2-9]\\d{6}",,,, "9002123456"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "SX", 1, "011", "1",,, "1|(5\\d{6})$", "721$1",,,,, [,,,,,,,,, [-1]],, "721", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SY: [, [,, "[1-39]\\d{8}|[1-5]\\d{7}",,,,,,, [8, 9], [6, 7]], [,, "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",,,, "112345678",,,, [6, 7]], [,, "9(?:22|[3-689]\\d)\\d{6}",,,, "944567890",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "SY", 963, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3})(\\d{3,4})",
	    "$1 $2 $3", ["[1-5]"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1",, 1]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], SZ: [, [,, "0800\\d{4}|(?:[237]\\d|900)\\d{6}",,,,,,, [8, 9]], [,, "[23][2-5]\\d{6}",,,, "22171234",,, [8]], [,, "7[6-9]\\d{6}",,,, "76123456",,, [8]], [,, "0800\\d{4}",,,, "08001234",,, [8]], [,, "900\\d{6}",,,, "900012345",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "70\\d{6}",,,, "70012345",,, [8]], "SZ", 268, "00",,,,,,,, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [,
	    "(\\d{5})(\\d{4})", "$1 $2", ["9"]]],, [,,,,,,,,, [-1]],,, [,, "0800\\d{4}",,,,,,, [8]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TA: [, [,, "8\\d{3}",,,,,,, [4]], [,, "8\\d{3}",,,, "8999"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TA", 290, "00",,,,,,,,,, [,,,,,,,,, [-1]],, "8", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TC: [, [,, "(?:[58]\\d\\d|649|900)\\d{7}",,,,,,, [10], [7]], [,, "649(?:266|712|9(?:4\\d|50))\\d{4}",,,, "6497121234",,,, [7]], [,, "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",,,,
	    "6492311234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002345678"], [,, "900[2-9]\\d{6}",,,, "9002345678"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,, "649(?:71[01]|966)\\d{4}",,,, "6497101234",,,, [7]], "TC", 1, "011", "1",,, "1|([2-479]\\d{6})$", "649$1",,,,, [,,,,,,,,,
	    [-1]],, "649", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TD: [, [,, "(?:22|[69]\\d|77)\\d{6}",,,,,,, [8]], [,, "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",,,, "22501234"], [,, "(?:6[023568]|77|9\\d)\\d{6}",,,, "63012345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TD", 235, "00|16",,,,,, "00",, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TG: [, [,, "[279]\\d{7}",,,,,,, [8]], [,, "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",,,,
	    "22212345"], [,, "(?:7[09]|9[0-36-9])\\d{6}",,,, "90112345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TG", 228, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TH: [, [,, "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",,,,,,, [8, 9, 10, 13]], [,, "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",,,, "21234567",,, [8]], [,, "671[0-3]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",,,, "812345678",,,
	    [9]], [,, "(?:001800\\d|1800)\\d{6}",,,, "1800123456",,, [10, 13]], [,, "1900\\d{6}",,,, "1900123456",,, [10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "6[08]\\d{7}",,,, "601234567",,, [9]], "TH", 66, "00[1-9]", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TJ: [, [,, "(?:00|11|[2-57-9]\\d)\\d{7}",,,,,,, [9], [3, 5, 6, 7]], [,, "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",,,,
	    "372123456",,,, [3, 5, 6, 7]], [,, "41[18]\\d{6}|(?:[034]0|11|2[02]|5[05]|7[07]|8[08]|9\\d)\\d{7}",,,, "917123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TJ", 992, "810", "8",,, "8",, "8~10",, [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"],,, 1], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"],,, 1], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"],,, 1], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02-57-9]|11"],,, 1]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]]], TK: [, [,, "[2-47]\\d{3,6}",,,,,,, [4, 5, 6, 7]], [,, "(?:2[2-4]|[34]\\d)\\d{2,5}",,,, "3101"], [,, "7[2-4]\\d{2,5}",,,, "7290"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TK", 690, "00",,,,,,,,,, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TL: [, [,, "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",,,,,,, [7, 8]], [,, "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",,,, "2112345",,, [7]], [,, "7[2-8]\\d{6}",,,, "77212345",,, [8]], [,, "80\\d{5}",,,, "8012345",,, [7]],
	    [,, "90\\d{5}",,,, "9012345",,, [7]], [,,,,,,,,, [-1]], [,, "70\\d{5}",,,, "7012345",,, [7]], [,,,,,,,,, [-1]], "TL", 670, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TM: [, [,, "[1-6]\\d{7}",,,,,,, [8]], [,, "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",,,, "12345678"], [,, "6\\d{7}",,,, "66123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TM", 993, "810", "8",,, "8",, "8~10",, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TN: [, [,, "[2-57-9]\\d{7}",,,,,,, [8]], [,, "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",,,, "30010123"], [,, "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",,,,
	    "20123456"], [,, "8010\\d{4}",,,, "80101234"], [,, "88\\d{6}",,,, "88123456"], [,, "8[12]10\\d{4}",,,, "81101234"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TN", 216, "00",,,,,,,, [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TO: [, [,, "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",,,,,,, [5, 7]], [,, "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",,,, "20123",,, [5]], [,, "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",,,,
	    "7715123",,, [7]], [,, "0800\\d{3}",,,, "0800222",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "55[0-37-9]\\d{4}",,,, "5510123",,, [7]], "TO", 676, "00",,,,,,,, [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TR: [, [,, "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",,,,,,, [7, 10, 12, 13]], [,, "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",,,,
	    "2123456789",,, [10]], [,, "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",,,, "5012345678",,, [10]], [,, "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",,,, "8001234567",,, [10, 12, 13]], [,, "(?:8[89]8|900)\\d{7}",,,, "9001234567",,, [10]], [,,,,,,,,, [-1]], [,, "592(?:21[12]|461)\\d{4}",,,, "5922121234",,, [10]], [,, "850\\d{7}",,,, "8500123456",,, [10]], "TR", 90, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"],,, 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
	    "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)",, 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1",, 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)",, 1], [, "(\\d{3})(\\d{3})(\\d{6,7})",
	    "$1 $2 $3", ["80"], "0$1",, 1]], [,, "512\\d{7}",,,, "5123456789",,, [10]],,, [,, "(?:444|811\\d{3})\\d{4}",,,,,,, [7, 10]], [,, "444\\d{4}",,,, "4441444",,, [7]],,, [,,,,,,,,, [-1]]], TT: [, [,, "(?:[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",,,, "8682211234",,,, [7]], [,, "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",,,, "8682911234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,
	    "8002345678"], [,, "900[2-9]\\d{6}",,,, "9002345678"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "TT", 1, "011", "1",,, "1|([2-46-8]\\d{6})$", "868$1",,,,, [,,,,,,,,, [-1]],, "868", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,, "868619\\d{4}",,,, "8686191234",,,, [7]]], TV: [, [,, "(?:2|7\\d\\d|90)\\d{4}",,,,,,,
	    [5, 6, 7]], [,, "2[02-9]\\d{3}",,,, "20123",,, [5]], [,, "(?:7[01]\\d|90)\\d{4}",,,, "901234",,, [6, 7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "TV", 688, "00",,,,,,,, [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], TW: [, [,, "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",,,,,,, [7, 8, 9, 10, 11]], [,, "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",,,,
	    "221234567",,, [8, 9]], [,, "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",,,, "912345678",,, [9]], [,, "80[0-79]\\d{6}|800\\d{5}",,,, "800123456",,, [8, 9]], [,, "20(?:[013-9]\\d\\d|2)\\d{4}",,,, "203123456",,, [7, 9]], [,,,,,,,,, [-1]], [,, "99\\d{7}",,,, "990123456",,, [9]], [,, "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",,,, "7012345678",,, [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#",, "0",,,, [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [, "(\\d)(\\d{3,4})(\\d{4})",
	    "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "50[0-46-9]\\d{6}",,,, "500123456",,, [9]],,, [,,,,,,,,, [-1]]], TZ: [, [,, "(?:[26-8]\\d|41|90)\\d{7}",,,,,,, [9]], [,, "2[2-8]\\d{7}",,,, "222345678"], [,, "77[2-9]\\d{6}|(?:6[1-9]|7[1-689])\\d{7}",,,, "621234567"], [,, "80[08]\\d{6}",,,, "800123456"], [,, "90\\d{7}",,,,
	    "900123456"], [,, "8(?:40|6[01])\\d{6}",,,, "840123456"], [,,,,,,,,, [-1]], [,, "41\\d{7}",,,, "412345678"], "TZ", 255, "00[056]", "0",,, "0",,,, [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,, "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], UA: [, [,, "[89]\\d{9}|[3-9]\\d{8}",,,,,,, [9, 10], [5, 6, 7]], [,, "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",,,,
	    "311234567",,, [9], [5, 6, 7]], [,, "(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}",,,, "501234567",,, [9]], [,, "800[1-8]\\d{5,6}",,,, "800123456"], [,, "900[239]\\d{5,6}",,,, "900212345"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "89[1-579]\\d{6}",,,, "891234567",,, [9]], "UA", 380, "00", "0",,, "0",, "0~0",, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3",
	    ["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]", "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], UG: [, [,, "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",,,,,,, [9], [5, 6, 7]], [,, "20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[0147]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",,,,
	    "312345678",,,, [5, 6, 7]], [,, "726[01]\\d{5}|7(?:[0157-9]\\d|20|36|[46][0-4])\\d{6}",,,, "712345678"], [,, "800[1-3]\\d{5}",,,, "800123456"], [,, "90[1-3]\\d{6}",,,, "901123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "UG", 256, "00[057]", "0",,, "0",,,, [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], US: [, [,, "[2-9]\\d{9}",,,,,,,
	    [10], [7]], [,, "5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-2]|[28]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",,,,
	    "2015550123",,,, [7]], [,, "5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-2]|[28]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",,,,
	    "2015550123",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002345678"], [,, "900[2-9]\\d{6}",,,, "9002345678"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "US", 1, "011", "1",,, "1",,, 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3",
	    ["[2-9]"],,, 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [,,,,,,,,, [-1]], 1,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], UY: [, [,, "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",,,,,,, [7, 8, 10]], [,, "(?:2\\d|4[2-7])\\d{6}",,,, "21231234",,, [8], [7]], [,, "9[1-9]\\d{6}",,,, "94231234",,, [8]], [,, "(?:4\\d{5}|80[05])\\d{4}|405\\d{4}",,,, "8001234",,, [7, 10]], [,, "90[0-8]\\d{4}",,,, "9001234",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ",, "0",, "00",, [[,
	    "(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[24]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], UZ: [, [,, "(?:33|55|[679]\\d|88)\\d{7}",,,,,,, [9]], [,, "(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",,,,
	    "669050123"], [,, "(?:(?:33|88|9[0-57-9])\\d{3}|55(?:50[013]|90\\d)|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",,,,
	    "912345678"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "UZ", 998, "810", "8",,, "8",, "8~10",, [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], VA: [, [,, "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,, [6, 7, 8, 9, 10, 11, 12]], [,, "06698\\d{1,6}",,,, "0669812345",,, [6, 7, 8, 9, 10, 11]], [,, "3[1-9]\\d{8}|3[2-9]\\d{7}",,,, "3123456789",,, [9, 10]], [,, "80(?:0\\d{3}|3)\\d{3}",,,,
	    "800123456",,, [6, 9]], [,, "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",,,, "899123456",,, [6, 8, 9, 10]], [,, "84(?:[08]\\d{3}|[17])\\d{3}",,,, "848123456",,, [6, 9]], [,, "1(?:78\\d|99)\\d{6}",,,, "1781234567",,, [9, 10]], [,, "55\\d{8}",,,, "5512345678",,, [10]], "VA", 39, "00",,,,,,,,,, [,,,,,,,,, [-1]],, "06698", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,, "3[2-8]\\d{9,10}",,,, "33101234501",,, [11, 12]]], VC: [, [,, "(?:[58]\\d\\d|784|900)\\d{7}",,,,,,, [10], [7]], [,, "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",,,,
	    "7842661234",,,, [7]], [,, "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",,,, "7844301234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002345678"], [,, "900[2-9]\\d{6}",,,, "9002345678"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "VC",
	    1, "011", "1",,, "1|([2-7]\\d{6})$", "784$1",,,,, [,,,,,,,,, [-1]],, "784", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], VE: [, [,, "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",,,,,,, [10], [7]], [,, "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",,,, "2121234567",,,, [7]], [,, "4(?:1[24-8]|2[46])\\d{7}",,,, "4121234567"], [,, "800\\d{7}",,,, "8001234567"], [,, "90[01]\\d{7}",,,, "9001234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "VE", 58, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"],
	    "0$1", "$CC $1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "501\\d{7}",,,, "5010123456",,,, [7]],,, [,,,,,,,,, [-1]]], VG: [, [,, "(?:284|[58]\\d\\d|900)\\d{7}",,,,,,, [10], [7]], [,, "284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",,,, "2842291234",,,, [7]], [,, "284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}",,,, "2843001234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002345678"], [,, "900[2-9]\\d{6}",,,, "9002345678"], [,,,,,,,,, [-1]],
	    [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,, "5002345678"], [,,,,,,,,, [-1]], "VG", 1, "011", "1",,, "1|([2-578]\\d{6})$", "284$1",,,,, [,,,,,,,,, [-1]],, "284", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], VI: [, [,, "[58]\\d{9}|(?:34|90)0\\d{7}",,,,,,, [10], [7]], [,, "340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",,,,
	    "3406421234",,,, [7]], [,, "340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",,,, "3406421234",,,, [7]], [,, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,, "8002345678"], [,, "900[2-9]\\d{6}",,,, "9002345678"], [,,,,,,,,, [-1]], [,, "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,
	    "5002345678"], [,,,,,,,,, [-1]], "VI", 1, "011", "1",,, "1|([2-9]\\d{6})$", "340$1",, 1,,, [,,,,,,,,, [-1]],, "340", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], VN: [, [,, "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",,,,,,, [7, 8, 9, 10]], [,, "2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}",,,, "2101234567",,, [10]], [,, "(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",,,, "912345678",,, [9]], [,, "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",,,,
	    "1800123456",,, [8, 9, 10]], [,, "1900\\d{4,6}",,,, "1900123456",,, [8, 9, 10]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "672\\d{6}",,,, "672012345",,, [9]], "VN", 84, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1",, 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1",, 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1",, 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"],,, 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1",, 1], [, "(\\d{2})(\\d{4})(\\d{4})",
	    "$1 $2 $3", ["2[48]"], "0$1",, 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1",, 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1",, 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"],,, 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1",, 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1",, 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1",, 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1",, 1]], [,,,,,,,,, [-1]],,, [,, "[17]99\\d{4}|69\\d{5,6}",,,,,,, [7, 8]], [,, "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",,,,
	    "1992000",,, [7, 8]],,, [,,,,,,,,, [-1]]], VU: [, [,, "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",,,,,,, [5, 7]], [,, "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",,,, "22123",,, [5]], [,, "(?:[58]\\d|7[013-7])\\d{5}",,,, "5912345",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "9(?:0[1-9]|1[01])\\d{4}",,,, "9010123",,, [7]], "VU", 678, "00",,,,,,,, [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "(?:3[03]|900\\d)\\d{3}",,,, "30123"],,, [,,,,,,,,, [-1]]], WF: [,
	    [,, "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",,,,,,, [6, 9]], [,, "72\\d{4}",,,, "721234",,, [6]], [,, "(?:72|8[23])\\d{4}",,,, "821234",,, [6]], [,, "80[0-5]\\d{6}",,,, "800012345",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "WF", 681, "00",,,,,,,, [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,, "[48]0\\d{4}",,,, "401234",,, [6]]], WS: [, [,, "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",,,,,,,
	    [5, 6, 7, 10]], [,, "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",,,, "22123",,, [5, 6]], [,, "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",,,, "7212345",,, [7, 10]], [,, "800\\d{3}",,,, "800123",,, [6]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "WS", 685, "0",,,,,,,, [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], XK: [, [,, "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",,,,,,, [8,
	    9]], [,, "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}",,,, "28012345"], [,, "4[3-9]\\d{6}",,,, "43201234",,, [8]], [,, "800\\d{5}",,,, "80001234",,, [8]], [,, "900\\d{5}",,,, "90001234",,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "XK", 383, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], YE: [, [,, "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",,,,,,,
	    [7, 8, 9], [6]], [,, "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",,,, "1234567",,, [7, 8], [6]], [,, "7[0137]\\d{7}",,,, "712345678",,, [9]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "YE", 967, "00", "0",,, "0",,,, [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], YT: [, [,, "80\\d{7}|(?:26|63)9\\d{6}",,,,,,,
	    [9]], [,, "269(?:0[67]|5[0-3]|6\\d|[78]0)\\d{4}",,,, "269601234"], [,, "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}",,,, "639012345"], [,, "80\\d{7}",,,, "801234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "YT", 262, "00", "0",,, "0",,,,,, [,,,,,,,,, [-1]],, "269|63", [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], ZA: [, [,, "[1-79]\\d{8}|8\\d{4,9}",,,,,,, [5, 6, 7, 8, 9, 10]], [,, "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",,,, "101234567",,,
	    [9]], [,, "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",,,, "711234567",,, [5, 6, 7, 8, 9]], [,, "80\\d{7}",,,, "801234567",,, [9]], [,, "(?:86[2-9]|9[0-2]\\d)\\d{6}",,,, "862345678",,, [9]], [,, "860\\d{6}",,,, "860123456",,, [9]], [,,,,,,,,, [-1]], [,, "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",,,,
	    "871234567",,, [9]], "ZA", 27, "00", "0",,, "0",,,, [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "861\\d{6,7}",,,, "861123456",,, [9, 10]],,, [,,,,,,,,, [-1]]], ZM: [, [,, "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",,,,,,, [9], [6]], [,, "21[1-8]\\d{6}",,,,
	    "211234567",,,, [6]], [,, "(?:7[679]|9[5-8])\\d{7}",,,, "955123456"], [,, "800\\d{6}",,,, "800123456"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "630\\d{6}",,,, "630012345"], "ZM", 260, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,,
	    [,,,,,,,,, [-1]]], ZW: [, [,, "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",,,,,,, [5, 6, 7, 8, 9, 10], [3, 4]], [,, "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",,,,
	    "1312345",,,, [3, 4]], [,, "7(?:[178]\\d|3[1-9])\\d{6}",,,, "712345678",,, [9]], [,, "80(?:[01]\\d|20|8[0-8])\\d{3}",,,, "8001234",,, [7]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",,,, "8686123456",,, [10]], "ZW", 263, "00", "0",,, "0",,,, [[, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
	    [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
	    "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], 800: [, [,, "(?:005|[1-9]\\d\\d)\\d{5}",,,,,,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "(?:005|[1-9]\\d\\d)\\d{5}",,,, "12345678"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "001", 800,,,,,,,, 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]],,, [,,,,,,,,, [-1]]], 808: [, [,, "[1-9]\\d{7}",,,,,,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "[1-9]\\d{7}",,,, "12345678"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "001", 808,,,,,,,, 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], 870: [, [,, "7\\d{11}|[35-7]\\d{8}",,,,,,, [9, 12]], [,,,,,,,,, [-1]], [,, "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",,,, "301234567"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]], [,,,,,,,,, [-1]], "001", 870,,,,,,,,, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], 878: [, [,, "10\\d{10}",,,,,,, [12]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "10\\d{10}",,,, "101234567890"], "001", 878,,,,,,,, 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], 881: [, [,, "[0-36-9]\\d{8}",,,,,,, [9]],
	    [,,,,,,,,, [-1]], [,, "[0-36-9]\\d{8}",,,, "612345678"], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "001", 881,,,,,,,,, [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], 882: [, [,, "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",,,,,,, [7, 8, 9, 10, 11, 12]], [,,,,,,,,, [-1]], [,, "342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",,,, "3421234",,, [7, 8, 9, 10, 12]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,,
	    [-1]], [,,,,,,,,, [-1]], [,, "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}",,,, "390123456789"], "001", 882,,,,,,,,, [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["4"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], [, "(\\d{3})(\\d{4})(\\d{4})",
	    "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,, "348[57]\\d{7}",,,, "34851234567",,, [11]]], 883: [, [,, "210\\d{7}|51\\d{7}(?:\\d{3})?",,,,,,, [9, 10, 12]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "(?:210|51[013]0\\d)\\d{7}|5100\\d{5}",,,, "510012345"], "001", 883,,,,,,,, 1, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2"]], [,
	    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["5"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]], 888: [, [,, "\\d{11}",,,,,,, [11]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "001", 888,,,,,,,, 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,, "\\d{11}",,,, "12345678901"],,, [,,,,,,,,, [-1]]], 979: [, [,, "[1359]\\d{8}",,,,,,, [9], [8]],
	    [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,, "[1359]\\d{8}",,,, "123456789",,,, [8]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], [,,,,,,,,, [-1]], "001", 979,,,,,,,, 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]],, [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]], [,,,,,,,,, [-1]],,, [,,,,,,,,, [-1]]] }; /*
	                                                                                                                                                                                                                                                                                                                          Copyright (C) 2010 The Libphonenumber Authors.
	                                                                                                                                                                                                                                                                                                                          Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                          you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                          You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                          http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                          Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                          distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                          WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                          See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                          limitations under the License.
	                                                                                                                                                                                                                                                                                                                          */
	
	
	
	
	  function H() {this.g = {};}H.g = void 0;H.h = function () {return H.g ? H.g : H.g = new H();};
	  var wa = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "\uFF10": "0", "\uFF11": "1", "\uFF12": "2", "\uFF13": "3", "\uFF14": "4", "\uFF15": "5", "\uFF16": "6", "\uFF17": "7", "\uFF18": "8", "\uFF19": "9", "\u0660": "0", "\u0661": "1", "\u0662": "2", "\u0663": "3", "\u0664": "4", "\u0665": "5", "\u0666": "6", "\u0667": "7", "\u0668": "8", "\u0669": "9", "\u06F0": "0", "\u06F1": "1", "\u06F2": "2", "\u06F3": "3", "\u06F4": "4", "\u06F5": "5", "\u06F6": "6", "\u06F7": "7", "\u06F8": "8", "\u06F9": "9" },xa = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6",
	    7: "7", 8: "8", 9: "9", "+": "+", "*": "*", "#": "#" },ya = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "\uFF10": "0", "\uFF11": "1", "\uFF12": "2", "\uFF13": "3", "\uFF14": "4", "\uFF15": "5", "\uFF16": "6", "\uFF17": "7", "\uFF18": "8", "\uFF19": "9", "\u0660": "0", "\u0661": "1", "\u0662": "2", "\u0663": "3", "\u0664": "4", "\u0665": "5", "\u0666": "6", "\u0667": "7", "\u0668": "8", "\u0669": "9", "\u06F0": "0", "\u06F1": "1", "\u06F2": "2", "\u06F3": "3", "\u06F4": "4", "\u06F5": "5", "\u06F6": "6", "\u06F7": "7", "\u06F8": "8", "\u06F9": "9", A: "2",
	    B: "2", C: "2", D: "3", E: "3", F: "3", G: "4", H: "4", I: "4", J: "5", K: "5", L: "5", M: "6", N: "6", O: "6", P: "7", Q: "7", R: "7", S: "7", T: "8", U: "8", V: "8", W: "9", X: "9", Y: "9", Z: "9" },za = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/,Aa = RegExp("[+\uFF0B]+"),I = RegExp("^[+\uFF0B]+"),Ba = RegExp("([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])"),Ca = RegExp("[+\uFF0B0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]"),Da = /[\\\/] *x/,Ea = RegExp("[^0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9A-Za-z#]+$"),Fa = /(?:.*?[A-Za-z]){3}.*/;
	  function J(a) {return "([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{1," + a + "})";}
	  function Ga() {return ";ext=" + J("20") + "|[ \xA0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)[:\\.\uFF0E]?[ \xA0\\t,-]*" + (J("20") + "#?|[ \xA0\\t,]*(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (J("9") + "#?|[- ]+") + (J("6") + "#|[ \xA0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (J("15") + "#?|[ \xA0\\t]*(?:,)+[:\\.\uFF0E]?[ \xA0\\t,-]*") + (J("9") + "#?");}
	  var Ha = new RegExp("(?:" + Ga() + ")$", "i"),Ia = new RegExp("^[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{2}$|^[+\uFF0B]*(?:[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*]*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]){3,}[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]*(?:" + Ga() + ")?$", "i"),Ja = /(\$\d)/,
	  Ka = /^\(?\$1\)?$/;function La(a) {return 2 > a.length ? !1 : K(Ia, a);}function Ma(a) {return K(Fa, a) ? L(a, ya) : L(a, wa);}function Na(a) {var b = Ma(a.toString());A(a);a.g(b);}function Oa() {return Object.keys(G).filter(function (a) {return isNaN(a);});}function Pa() {return Object.keys(G).filter(function (a) {return !isNaN(a);}).map(function (a) {return parseInt(a, 10);});}function Qa() {var a = Object.keys(F);return [].concat(_toConsumableArray(Pa()), _toConsumableArray(a.map(function (b) {return parseInt(b, 10);})));}function Ra(a) {return null != a && (1 != v(a, 9) || -1 != r(a, 9)[0]);}
	  function L(a, b) {for (var c = new z(), d, e = a.length, f = 0; f < e; ++f) {d = a.charAt(f), d = b[d.toUpperCase()], null != d && c.g(d);}return c.toString();}function Sa(a) {return 0 == a.length || Ka.test(a);}function M(a) {return null != a && isNaN(a) && a.toUpperCase() in G;}function N(a, b, c) {if (0 == n(b, 2) && m(b, 5)) {var d = u(b, 5);if (0 < d.length) return d;}d = u(b, 1);var e = O(b);if (0 == c) return Ta(d, 0, e, "");if (!(d in F)) return e;a = P(a, d, R(d));b = Ua(b, a, c);e = Va(e, a, c);return Ta(d, c, e, b);}function P(a, b, c) {return "001" == c ? S(a, "" + b) : S(a, c);}
	  function Wa(a, b) {var c = T;if (!M(b)) return N(c, a, 1);var d = u(a, 1),e = O(a);if (!(d in F)) return e;if (1 == d) {if (null != b && F[1].includes(b.toUpperCase())) return d + " " + N(c, a, 2);} else if (d == Xa(c, b)) return N(c, a, 2);var f = S(c, b),g = u(f, 11);b = "";m(f, 17) ? b = u(f, 17) : K(za, g) && (b = g);c = P(c, d, R(d));e = Va(e, c, 1);a = Ua(a, c, 1);return 0 < b.length ? b + " " + d + " " + e + a : Ta(d, 1, e, a);}function O(a) {if (!m(a, 2)) return "";var b = "" + n(a, 2);return m(a, 4) && n(a, 4) && 0 < u(a, 8) ? Array(u(a, 8) + 1).join("0") + b : b;}
	  function Ta(a, b, c, d) {switch (b) {case 0:return "+" + a + c + d;case 1:return "+" + a + " " + c + d;case 3:return "tel:+" + a + "-" + c + d;default:return c + d;}}
	  function Va(a, b, c) {a: {b = 0 == r(b, 20).length || 2 == c ? r(b, 19) : r(b, 20);for (var d, e = b.length, f = 0; f < e; ++f) {d = b[f];var g = v(d, 3);if (0 == g || 0 == a.search(n(d, 3, g - 1))) if (g = new RegExp(n(d, 1)), K(g, a)) {b = d;break a;}}b = null;}null == b ? c = a : (e = b, b = u(e, 2), d = new RegExp(n(e, 1)), u(e, 5), e = u(e, 4), a = 2 == c && null != e && 0 < e.length ? a.replace(d, b.replace(Ja, e)) : a.replace(d, b), 3 == c && (a = a.replace(RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+"), ""), a =
	    a.replace(RegExp("[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+", "g"), "-")), c = a);return c;}function Ya(a, b) {var c = T;if (!M(a)) return null;b = Za(S(c, a), b);try {if (m(b, 6)) {var d = n(b, 6);return $a(c, d, a);}} catch (e) {}return null;}function Ua(a, b, c) {return m(a, 3) && 0 != n(a, 3).length ? 3 == c ? ";ext=" + n(a, 3) : m(b, 13) ? n(b, 13) + u(a, 3) : " ext. " + u(a, 3) : "";}
	  function Za(a, b) {switch (b) {case 4:return n(a, 5);case 3:return n(a, 4);case 1:return n(a, 3);case 0:case 2:return n(a, 2);case 5:return n(a, 6);case 6:return n(a, 8);case 7:return n(a, 7);case 8:return n(a, 21);case 9:return n(a, 25);case 10:return n(a, 28);default:return n(a, 1);}}function ab(a, b) {return U(a, n(b, 1)) ? U(a, n(b, 5)) ? 4 : U(a, n(b, 4)) ? 3 : U(a, n(b, 6)) ? 5 : U(a, n(b, 8)) ? 6 : U(a, n(b, 7)) ? 7 : U(a, n(b, 21)) ? 8 : U(a, n(b, 25)) ? 9 : U(a, n(b, 28)) ? 10 : U(a, n(b, 2)) ? n(b, 18) || U(a, n(b, 3)) ? 2 : 0 : !n(b, 18) && U(a, n(b, 3)) ? 1 : -1 : -1;}
	  function S(a, b) {if (null == b) return null;b = b.toUpperCase();var c = a.g[b];if (null == c) {c = G[b];if (null == c) return null;c = new y().g(D.m(), c);a.g[b] = c;}return c;}function U(a, b) {var c = a.length;return 0 < v(b, 9) && -1 == r(b, 9).indexOf(c) ? !1 : K(u(b, 2), a);}function bb(a) {var b = T,c = cb(b, a);var d = u(a, 1);var e = P(b, d, c);null == e || "001" != c && d != Xa(b, c) ? e = !1 : (a = O(a), e = -1 != ab(a, e));return e;}
	  function cb(a, b) {if (null == b) return null;var c = u(b, 1);c = F[c];if (null == c) a = null;else if (1 == c.length) a = c[0];else a: {b = O(b);for (var d, e = c.length, f = 0; f < e; f++) {d = c[f];var g = S(a, d);if (m(g, 23)) {if (0 == b.search(n(g, 23))) {a = d;break a;}} else if (-1 != ab(b, g)) {a = d;break a;}}a = null;}return a;}function R(a) {a = F[a];return null == a ? "ZZ" : a[0];}function Xa(a, b) {a = S(a, b);if (null == a) throw Error("Invalid region code: " + b);return u(a, 10);}function db(a) {a = eb(a);return 0 == a || 4 == a;}
	  function fb(a, b, c, d) {var e = Za(c, d),f = 0 == v(e, 9) ? r(n(c, 1), 9) : r(e, 9);e = r(e, 10);if (2 == d) if (Ra(Za(c, 0))) a = Za(c, 1), Ra(a) && (f = f.concat(0 == v(a, 9) ? r(n(c, 1), 9) : r(a, 9)), f.sort(), 0 == e.length ? e = r(a, 10) : (e = e.concat(r(a, 10)), e.sort()));else return fb(a, b, c, 1);if (-1 == f[0]) return 5;b = b.length;if (-1 < e.indexOf(b)) return 4;c = f[0];return c == b ? 0 : c > b ? 2 : f[f.length - 1] < b ? 3 : -1 < f.indexOf(b, 1) ? 0 : 5;}function eb(a) {var b = T,c = O(a);a = u(a, 1);if (!(a in F)) return 1;a = P(b, a, R(a));return fb(b, c, a, -1);}
	  function gb(a, b) {a = a.toString();if (0 == a.length || "0" == a.charAt(0)) return 0;for (var c, d = a.length, e = 1; 3 >= e && e <= d; ++e) {if (c = parseInt(a.substring(0, e), 10), c in F) return b.g(a.substring(e)), c;}return 0;}
	  function hb(a, b, c, d, e) {if (0 == b.length) return 0;b = new z(b);var f;null != c && (f = n(c, 11));null == f && (f = "NonMatch");var g = b.toString();if (0 == g.length) f = 20;else if (I.test(g)) g = g.replace(I, ""), A(b), b.g(Ma(g)), f = 1;else {g = new RegExp(f);Na(b);f = b.toString();if (0 == f.search(g)) {g = f.match(g)[0].length;var l = f.substring(g).match(Ba);l && null != l[1] && 0 < l[1].length && "0" == L(l[1], wa) ? f = !1 : (A(b), b.g(f.substring(g)), f = !0);} else f = !1;f = f ? 5 : 20;}if (20 != f) {if (2 >= b.h.length) throw Error("Phone number too short after IDD");a = gb(b,
	      d);if (0 != a) return p(e, 1, a), a;throw Error("Invalid country calling code");}if (null != c && (f = u(c, 10), g = "" + f, l = b.toString(), 0 == l.lastIndexOf(g, 0) && (g = new z(l.substring(g.length)), l = n(c, 1), l = new RegExp(u(l, 2)), ib(g, c, null), g = g.toString(), !K(l, b.toString()) && K(l, g) || 3 == fb(a, b.toString(), c, -1)))) return d.g(g), p(e, 1, f), f;p(e, 1, 0);return 0;}
	  function ib(a, b, c) {var d = a.toString(),e = d.length,f = n(b, 15);if (0 != e && null != f && 0 != f.length) {var g = new RegExp("^(?:" + f + ")");if (e = g.exec(d)) {f = new RegExp(u(n(b, 1), 2));var l = K(f, d),q = e.length - 1;b = n(b, 16);if (null == b || 0 == b.length || null == e[q] || 0 == e[q].length) {if (!l || K(f, d.substring(e[0].length))) null != c && 0 < q && null != e[q] && c.g(e[1]), a.set(d.substring(e[0].length));} else if (d = d.replace(g, b), !l || K(f, d)) null != c && 0 < q && c.g(e[1]), a.set(d);}}}
	  function $a(a, b, c) {if (null == b) throw Error("The string supplied did not seem to be a phone number");if (250 < b.length) throw Error("The string supplied is too long to be a phone number");var d = new z(),e = b.indexOf(";phone-context=");if (0 <= e) {var f = e + 15;if ("+" == b.charAt(f)) {var g = b.indexOf(";", f);0 < g ? d.g(b.substring(f, g)) : d.g(b.substring(f));}f = b.indexOf("tel:");d.g(b.substring(0 <= f ? f + 4 : 0, e));} else e = d.g, f = b.search(Ca), 0 <= f ? (b = b.substring(f), b = b.replace(Ea, ""), f = b.search(Da), 0 <= f && (b = b.substring(0, f))) : b = "",
	    e.call(d, b);b = d.toString();e = b.indexOf(";isub=");0 < e && (A(d), d.g(b.substring(0, e)));if (!La(d.toString())) throw Error("The string supplied did not seem to be a phone number");b = d.toString();if (!(M(c) || null != b && 0 < b.length && I.test(b))) throw Error("Invalid country calling code");b = new E();a: {e = d.toString();f = e.search(Ha);if (0 <= f && La(e.substring(0, f))) {g = e.match(Ha);for (var l = g.length, q = 1; q < l; ++q) {if (null != g[q] && 0 < g[q].length) {A(d);d.g(e.substring(0, f));e = g[q];break a;}}}e = "";}0 < e.length && p(b, 3, e);f = S(a, c);e =
	    new z();g = 0;l = d.toString();try {g = hb(a, l, f, e, b);} catch (Q) {if ("Invalid country calling code" == Q.message && I.test(l)) {if (l = l.replace(I, ""), g = hb(a, l, f, e, b), 0 == g) throw Q;} else throw Q;}0 != g ? (d = R(g), d != c && (f = P(a, g, d))) : (Na(d), e.g(d.toString()), null != c && (g = u(f, 10), p(b, 1, g)));if (2 > e.h.length) throw Error("The string supplied is too short to be a phone number");null != f && (c = new z(e.toString()), ib(c, f, new z()), a = fb(a, c.toString(), f, -1), 2 != a && 4 != a && 5 != a && (e = c));a = e.toString();c = a.length;if (2 > c) throw Error("The string supplied is too short to be a phone number");
	    if (17 < c) throw Error("The string supplied is too long to be a phone number");if (1 < a.length && "0" == a.charAt(0)) {p(b, 4, !0);for (c = 1; c < a.length - 1 && "0" == a.charAt(c);) {c++;}1 != c && p(b, 8, c);}p(b, 2, parseInt(a, 10));return b;}H.prototype.ia = function (a) {var b = S(this, cb(this, a));if (null == b) return !0;a = O(a);return !U(a, n(b, 24));};function K(a, b) {return (a = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a)) && a[0].length == b.length ? !0 : !1;};function jb(a) {this.ja = RegExp("\u2008");this.ka = "";this.v = new z();this.ca = "";this.s = new z();this.aa = new z();this.u = !0;this.da = this.ba = this.na = !1;this.oa = H.h();this.$ = 0;this.h = new z();this.ga = !1;this.o = "";this.g = new z();this.j = [];this.la = a;this.va = this.l = kb(this, this.la);}var lb = new D();p(lb, 11, "NA");
	  var mb = RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*\\$1[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*(\\$\\d[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*)*$"),nb = /[- ]/;
	  function kb(a, b) {var c = a.oa;b = M(b) ? Xa(c, b) : 0;a = S(a.oa, R(b));return null != a ? a : lb;}function ob(a) {for (var b = a.j.length, c = 0; c < b; ++c) {var d = a.j[c],e = u(d, 1);if (a.ca == e) return !1;var f = a;var g = d,l = u(g, 1);A(f.v);var q = f;g = u(g, 2);var Q = "999999999999999".match(l)[0];Q.length < q.g.h.length ? q = "" : (q = Q.replace(new RegExp(l, "g"), g), q = q.replace(RegExp("9", "g"), "\u2008"));0 < q.length ? (f.v.g(q), f = !0) : f = !1;if (f) return a.ca = e, a.ga = nb.test(n(d, 4)), a.$ = 0, !0;}return a.u = !1;}
	  function pb(a, b) {for (var c = [], d = b.length - 3, e = a.j.length, f = 0; f < e; ++f) {var g = a.j[f];0 == v(g, 3) ? c.push(a.j[f]) : (g = n(g, 3, Math.min(d, v(g, 3) - 1)), 0 == b.search(g) && c.push(a.j[f]));}a.j = c;}
	  function qb(a, b) {a.s.g(b);var c = b;Ba.test(c) || 1 == a.s.h.length && Aa.test(c) ? ("+" == b ? (c = b, a.aa.g(b)) : (c = wa[b], a.aa.g(c), a.g.g(c)), b = c) : (a.u = !1, a.na = !0);if (!a.u) {if (!a.na) if (rb(a)) {if (sb(a)) return tb(a);} else if (0 < a.o.length && (b = a.g.toString(), A(a.g), a.g.g(a.o), a.g.g(b), b = a.h.toString(), c = b.lastIndexOf(a.o), A(a.h), a.h.g(b.substring(0, c))), a.o != ub(a)) return a.h.g(" "), tb(a);return a.s.toString();}switch (a.aa.h.length) {case 0:case 1:case 2:return a.s.toString();case 3:if (rb(a)) a.da = !0;else return a.o = ub(a),
	        vb(a);default:if (a.da) return sb(a) && (a.da = !1), a.h.toString() + a.g.toString();if (0 < a.j.length) {b = wb(a, b);c = xb(a);if (0 < c.length) return c;pb(a, a.g.toString());return ob(a) ? yb(a) : a.u ? zb(a, b) : a.s.toString();}return vb(a);}}function tb(a) {a.u = !0;a.da = !1;a.j = [];a.$ = 0;A(a.v);a.ca = "";return vb(a);}
	  function xb(a) {for (var b = a.g.toString(), c = a.j.length, d = 0; d < c; ++d) {var e = a.j[d],f = u(e, 1);if (new RegExp("^(?:" + f + ")$").test(b) && (a.ga = nb.test(n(e, 4)), e = b.replace(new RegExp(f, "g"), n(e, 2)), e = zb(a, e), L(e, xa) == a.aa)) return e;}return "";}function zb(a, b) {var c = a.h.h.length;return a.ga && 0 < c && " " != a.h.toString().charAt(c - 1) ? a.h + " " + b : a.h + b;}
	  function vb(a) {var b = a.g.toString();if (3 <= b.length) {for (var c = a.ba && 0 == a.o.length && 0 < v(a.l, 20) ? r(a.l, 20) : r(a.l, 19), d = c.length, e = 0; e < d; ++e) {var f = c[e];0 < a.o.length && Sa(u(f, 4)) && !n(f, 6) && !m(f, 5) || (0 != a.o.length || a.ba || Sa(u(f, 4)) || n(f, 6)) && mb.test(u(f, 2)) && a.j.push(f);}pb(a, b);b = xb(a);return 0 < b.length ? b : ob(a) ? yb(a) : a.s.toString();}return zb(a, b);}function yb(a) {var b = a.g.toString(),c = b.length;if (0 < c) {for (var d = "", e = 0; e < c; e++) {d = wb(a, b.charAt(e));}return a.u ? zb(a, d) : a.s.toString();}return a.h.toString();}
	  function ub(a) {var b = a.g.toString(),c = 0;if (1 != a.l.ha()) var d = !1;else d = a.g.toString(), d = "1" == d.charAt(0) && "0" != d.charAt(1) && "1" != d.charAt(1);d ? (c = 1, a.h.g("1").g(" "), a.ba = !0) : m(a.l, 15) && (d = new RegExp("^(?:" + n(a.l, 15) + ")"), d = b.match(d), null != d && null != d[0] && 0 < d[0].length && (a.ba = !0, c = d[0].length, a.h.g(b.substring(0, c))));A(a.g);a.g.g(b.substring(c));return b.substring(0, c);}
	  function rb(a) {var b = a.aa.toString(),c = new RegExp("^(?:\\+|" + n(a.l, 11) + ")");c = b.match(c);return null != c && null != c[0] && 0 < c[0].length ? (a.ba = !0, c = c[0].length, A(a.g), a.g.g(b.substring(c)), A(a.h), a.h.g(b.substring(0, c)), "+" != b.charAt(0) && a.h.g(" "), !0) : !1;}function sb(a) {if (0 == a.g.h.length) return !1;var b = new z(),c = gb(a.g, b);if (0 == c) return !1;A(a.g);a.g.g(b.toString());b = R(c);"001" == b ? a.l = S(a.oa, "" + c) : b != a.la && (a.l = kb(a, b));a.h.g("" + c).g(" ");a.o = "";return !0;}
	  function wb(a, b) {var c = a.v.toString();if (0 <= c.substring(a.$).search(a.ja)) {var d = c.search(a.ja);b = c.replace(a.ja, b);A(a.v);a.v.g(b);a.$ = d;return b.substring(0, a.$ + 1);}1 == a.j.length && (a.u = !1);a.ca = "";return a.s.toString();}; /*
	                                                                                                                                                                                                                                                            Copyright (C) 2018 The Libphonenumber Authors.
	                                                                                                                                                                                                                                                            Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                            you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                            You may obtain a copy of the License at
	                                                                                                                                                                                                                                                            http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                            Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                            distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                            See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                            limitations under the License.
	                                                                                                                                                                                                                                                            */
	
	
	
	
	  var T = H.h();function Ab(a) {var b = T,c = cb(b, a);b = P(b, u(a, 1), c);null == b ? a = -1 : (a = O(a), a = ab(a, b));switch (a) {case 0:return "fixed-line";case 2:return "fixed-line-or-mobile";case 1:return "mobile";case 8:return "pager";case 7:return "personal-number";case 4:return "premium-rate";case 5:return "shared-cost";case 3:return "toll-free";case 9:return "uan";case 6:return "voip";default:case -1:return "unknown";}}
	  function Bb(a) {switch (a) {case "fixed-line":return 0;case "fixed-line-or-mobile":return 2;case "mobile":return 1;case "pager":return 8;case "personal-number":return 7;case "premium-rate":return 4;case "shared-cost":return 5;case "toll-free":return 3;case "uan":return 9;case "voip":return 6;default:case "unknown":return -1;}}
	  function Cb(a) {try {switch (eb(a)) {case 0:return "is-possible";case 1:return "invalid-country-code";case 3:return "too-long";case 2:return "too-short";}if (db(a)) return "is-possible";} catch (b) {}return "unknown";}function Db(a) {if ("+" !== a.charAt(0)) return { parsed: b, ea: c };try {var b = $a(T, a, void 0);} catch (e) {}if (b) {var c = cb(T, b);if (null != c && "ZZ" !== c) return { parsed: b, ea: c };}for (var d = 1; 4 > d; ++d) {c = void 0;if (a.length < d + 1) return { parsed: b, ea: c };c = R(a.substring(1, d + 1));if ("ZZ" !== c) return { ea: c };}return { parsed: b, ea: void 0 };}
	  function V(a, b) {var _Db, _Db$ea;if (!(this instanceof V)) return new V(a, b);if ("string" === typeof a) var c = !1;else try {bb(a), c = !0;} catch (e) {c = !1;}var d = void 0;if (!c && "string" !== typeof a) throw Error("Invalid phone number, expected a string");if (!c && null != b && "string" !== typeof b) throw Error("Invalid region code, expected a string");c || (a = a.trim(), b && "+" === a.charAt(0) && (b = null), b || (_Db = Db(a), _Db$ea = _Db.ea, b = _Db$ea === undefined ? null : _Db$ea, d = _Db.parsed, _Db));this.g = { number: {}, regionCode: b, valid: !1, possible: !1 };if (c) this.h = a;else {this.h = null;this.g.number.input = a;if (!b) {this.g.possibility =
	        "invalid-country-code";return;}if (0 === Eb(b)) {this.g.possibility = "invalid-country-code";return;}try {this.h = d ? d : $a(T, a, b);} catch (e) {this.g.possibility = Cb(a);return;}}this.g.number.international = N(T, this.h, 1);this.g.number.national = N(T, this.h, 2);this.g.number.e164 = N(T, this.h, 0);this.g.number.rfc3966 = N(T, this.h, 3);this.g.number.significant = O(this.h);this.g.canBeInternationallyDialled = T.ia(this.h);this.g.possible = db(this.h);this.g.valid = bb(this.h);this.g.type = Ab(this.h);this.g.possibility = Cb(this.h);}
	  var W = ["PhoneNumber$$module$src$index"],X = aa;W[0] in X || "undefined" == typeof X.execScript || X.execScript("var " + W[0]);for (var Y; W.length && (Y = W.shift());) {W.length || void 0 === V ? X[Y] && X[Y] !== Object.prototype[Y] ? X = X[Y] : X = X[Y] = {} : X[Y] = V;}function Eb(a) {return M(a) ? Xa(T, a) : 0;}V.getCountryCodeForRegionCode = Eb;V.getRegionCodeForCountryCode = function (a) {return R(a);};function Fb(a) {var b = {};return a.filter(function (c) {if (b.hasOwnProperty(c)) return !1;b[c] = 1;return !0;});}V.getSupportedRegionCodes = function () {return Fb(Oa());};
	  V.getSupportedCallingCodes = function () {return Fb(Qa());};V.getExample = function (a, b) {var c;b ? c = Ya(a, Bb(b)) : c = Ya(a, 0);return new V(c, a);};V.getAsYouType = function (a) {return new Z(a);};V.prototype.toJSON = function () {return this.g;};V.prototype.toJSON = V.prototype.toJSON;V.prototype.ia = function () {return this.g.canBeInternationallyDialled;};V.prototype.canBeInternationallyDialled = V.prototype.ia;V.prototype.za = function () {return this.g.valid;};V.prototype.isValid = V.prototype.za;V.prototype.ya = function () {return this.g.possible;};
	  V.prototype.isPossible = V.prototype.ya;V.prototype.ua = function () {return this.g.type;};V.prototype.getType = V.prototype.ua;V.prototype.xa = function () {return "mobile" === this.g.type || "fixed-line-or-mobile" === this.g.type;};V.prototype.isMobile = V.prototype.xa;V.prototype.wa = function () {return "fixed-line" === this.g.type || "fixed-line-or-mobile" === this.g.type;};V.prototype.isFixedLine = V.prototype.wa;V.prototype.qa = function (a) {return this.g.number[null == a ? "e164" : a];};V.prototype.getNumber = V.prototype.qa;
	  V.prototype.ra = function (a) {return Wa(this.h, a);};V.prototype.getNumberFrom = V.prototype.ra;V.prototype.ta = function () {return this.g.regionCode;};V.prototype.getRegionCode = V.prototype.ta;V.prototype.ha = function () {return Eb(this.g.regionCode);};V.prototype.getCountryCode = V.prototype.ha;function Z(a) {this.l = a;this.j = new jb(a);this.g = this.h = "";}Z.prototype.pa = function (a) {this.h += a;var b = this.j;b.ka = qb(b, a);return this.g = b.ka;};Z.prototype.addChar = Z.prototype.pa;Z.prototype.Aa = function () {return this.g;};
	  Z.prototype.number = Z.prototype.Aa;Z.prototype.Ba = function () {return "" === this.h ? this.g : this.reset(this.h.slice(0, this.h.length - 1));};Z.prototype.removeChar = Z.prototype.Ba;Z.prototype.reset = function (a) {var b = this.j;b.ka = "";A(b.s);A(b.aa);A(b.v);b.$ = 0;b.ca = "";A(b.h);b.o = "";A(b.g);b.u = !0;b.na = !1;b.ba = !1;b.da = !1;b.j = [];b.ga = !1;b.l != b.va && (b.l = kb(b, b.la));this.g = this.h = "";if (a) {b = 0;for (var c = a.length; b < c; ++b) {this.pa(a.charAt(b));}}return this.g;};Z.prototype.reset = Z.prototype.reset;
	  Z.prototype.sa = function () {return new V(this.g, this.l);};Z.prototype.getPhoneNumber = Z.prototype.sa;}).call(
	typeof module !== 'undefined' && typeof module.exports !== 'undefined' && module.exports ||
	typeof globalThis !== 'undefined' && globalThis ||
	typeof global !== 'undefined' && global ||
	typeof window !== 'undefined' && window ||
	typeof self !== 'undefined' && self || undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(439)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}", ""]);
	
	// exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(439)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * ui-grid - v4.9.0 - 2020-09-27\n * Copyright (c) 2020 ; License: MIT \n */.ui-grid{border:1px solid #d4d4d4;box-sizing:content-box;border-radius:0;-webkit-transform:translateZ(0);transform:translateZ(0)}.ui-grid-vertical-bar{position:absolute;right:0;width:0}.ui-grid-cell:not(:last-child) .ui-grid-vertical-bar,.ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{width:1px}.ui-grid-scrollbar-placeholder{background-color:transparent}.ui-grid-cell:not(:last-child) .ui-grid-vertical-bar,.ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{background-color:#d4d4d4}.ui-grid-header-cell:last-child .ui-grid-vertical-bar{right:-1px;width:1px;background-color:#d4d4d4}.ui-grid-clearfix:after,.ui-grid-clearfix:before{content:\"\";display:table}.ui-grid-clearfix:after{clear:both}.ui-grid-invisible{visibility:hidden}.ui-grid-contents-wrapper{position:relative;height:100%;width:100%}.ui-grid-sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.ui-grid-icon-button{background-color:transparent;border:none;padding:0}.clickable{cursor:pointer}.ui-grid-top-panel-background{background-color:#f3f3f3}.ui-grid-header{border-bottom:1px solid #d4d4d4;box-sizing:border-box}.ui-grid-top-panel{position:relative;overflow:hidden;font-weight:700;background-color:#f3f3f3;-webkit-border-top-right-radius:-1px;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:-1px;-moz-border-radius-topright:-1px;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:-1px;border-top-right-radius:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:-1px;background-clip:padding-box}.ui-grid-header-viewport{overflow:hidden}.ui-grid-header-canvas:after,.ui-grid-header-canvas:before{content:\"\";display:-ms-flexbox;display:flex;line-height:0}.ui-grid-header-canvas:after{clear:both}.ui-grid-header-cell-wrapper{position:relative;display:-ms-flexbox;display:flex;box-sizing:border-box;height:100%;width:100%}.ui-grid-header-cell-row{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.ui-grid-header-cell{position:relative;box-sizing:border-box;background-color:inherit;border-right:1px solid;border-color:#d4d4d4;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:0}.ui-grid-header-cell:last-child{border-right:0}.ui-grid-header-cell .sortable{cursor:pointer}.ui-grid-header-cell .ui-grid-sort-priority-number{margin-left:-8px}.ui-grid-header-cell>div{-ms-flex-basis:100%;flex-basis:100%}.ui-grid-header .ui-grid-vertical-bar{top:0;bottom:0}.ui-grid-column-menu-button{position:absolute;right:1px;top:0}.ui-grid-column-menu-button .ui-grid-icon-angle-down{vertical-align:sub}.ui-grid-header-cell-last-col+.ui-grid-column-resizer.right,.ui-grid-header-cell-last-col .ui-grid-cell-contents,.ui-grid-header-cell-last-col .ui-grid-column-menu-button,.ui-grid-header-cell-last-col .ui-grid-filter-container{margin-right:13px}.ui-grid-render-container-right .ui-grid-header-cell-last-col+.ui-grid-column-resizer.right,.ui-grid-render-container-right .ui-grid-header-cell-last-col .ui-grid-cell-contents,.ui-grid-render-container-right .ui-grid-header-cell-last-col .ui-grid-column-menu-button,.ui-grid-render-container-right .ui-grid-header-cell-last-col .ui-grid-filter-container{margin-right:28px}.ui-grid-column-menu{position:absolute}.ui-grid-column-menu .ui-grid-menu .ui-grid-menu-mid.ng-hide-add,.ui-grid-column-menu .ui-grid-menu .ui-grid-menu-mid.ng-hide-remove{transition:all .04s linear;display:block!important}.ui-grid-column-menu .ui-grid-menu .ui-grid-menu-mid.ng-hide-add.ng-hide-add-active,.ui-grid-column-menu .ui-grid-menu .ui-grid-menu-mid.ng-hide-remove{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.ui-grid-column-menu .ui-grid-menu .ui-grid-menu-mid.ng-hide-add,.ui-grid-column-menu .ui-grid-menu .ui-grid-menu-mid.ng-hide-remove.ng-hide-remove-active{-webkit-transform:translateY(0);transform:translateY(0)}.ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid.ng-hide-add,.ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid.ng-hide-remove{transition:all .04s linear;display:block!important}.ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid.ng-hide-add.ng-hide-add-active,.ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid.ng-hide-remove{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid.ng-hide-add,.ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid.ng-hide-remove.ng-hide-remove-active{-webkit-transform:translateY(0);transform:translateY(0)}.ui-grid-filter-container{padding:4px 10px;position:relative}.ui-grid-filter-container .ui-grid-filter-button{position:absolute;top:0;bottom:0;right:0}.ui-grid-filter-container .ui-grid-filter-button [class^=ui-grid-icon]{position:absolute;top:50%;line-height:32px;margin-top:-16px;right:10px;opacity:.66}.ui-grid-filter-container .ui-grid-filter-button [class^=ui-grid-icon]:hover{opacity:1}.ui-grid-filter-container .ui-grid-filter-button-select{position:absolute;top:0;bottom:0;right:0}.ui-grid-filter-container .ui-grid-filter-button-select [class^=ui-grid-icon]{position:absolute;top:50%;line-height:32px;margin-top:-16px;right:0;opacity:.66}.ui-grid-filter-container .ui-grid-filter-button-select [class^=ui-grid-icon]:hover{opacity:1}input[type=text].ui-grid-filter-input{box-sizing:border-box;padding:0 18px 0 0;margin:0;width:100%;border:1px solid #d4d4d4;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}input[type=text].ui-grid-filter-input:hover{border:1px solid #d4d4d4}select.ui-grid-filter-select{padding:0;margin:0;border:0;width:90%;border:1px solid #d4d4d4;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}select.ui-grid-filter-select:hover{border:1px solid #d4d4d4}.ui-grid-filter-cancel-button-hidden select.ui-grid-filter-select{width:100%}.ui-grid-render-container{position:inherit;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}.ui-grid-render-container:focus{outline:none}.ui-grid-viewport{min-height:20px;position:relative;overflow-y:scroll;-webkit-overflow-scrolling:touch}.ui-grid-viewport:focus{outline:none!important}.ui-grid-canvas{position:relative;padding-top:1px}.ui-grid-row{clear:both}.ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:#fdfdfd}.ui-grid-row:nth-child(2n) .ui-grid-cell{background-color:#f3f3f3}.ui-grid-row:last-child .ui-grid-cell{border-bottom-color:#d4d4d4;border-bottom-style:solid}.ui-grid-row:hover>[ui-grid-row]>.ui-grid-cell:hover .ui-grid-cell,.ui-grid-row:nth-child(2n):hover .ui-grid-cell,.ui-grid-row:nth-child(odd):hover .ui-grid-cell{background-color:#d5eaee}.ui-grid-no-row-overlay{position:absolute;top:0;bottom:0;left:0;right:0;margin:10%;background-color:#f3f3f3;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box;border:1px solid #d4d4d4;font-size:2em;text-align:center}.ui-grid-no-row-overlay>*{position:absolute;display:table;margin:auto 0;width:100%;top:0;bottom:0;left:0;right:0;opacity:.66}.ui-grid-cell{overflow:hidden;float:left;background-color:inherit;border-right:1px solid;border-color:#d4d4d4;box-sizing:border-box}.ui-grid-cell:last-child{border-right:0}.ui-grid-cell-contents{padding:5px;box-sizing:border-box;white-space:nowrap;-ms-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;height:100%}.ui-grid-cell-contents-hidden{visibility:hidden;width:0;height:0;display:none}.ui-grid-row .ui-grid-cell.ui-grid-row-header-cell{background-color:#f0f0ee;border-bottom:1px solid #d4d4d4}.ui-grid-cell-empty{display:inline-block;width:10px;height:10px}.ui-grid-footer-info{padding:5px 10px}.ui-grid-footer-panel,.ui-grid-footer-panel-background{background-color:#f3f3f3}.ui-grid-footer-panel{position:relative;border-bottom:1px solid #d4d4d4;border-top:1px solid #d4d4d4;overflow:hidden;font-weight:700;-webkit-border-top-right-radius:-1px;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:-1px;-moz-border-radius-topright:-1px;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:-1px;border-top-right-radius:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:-1px;background-clip:padding-box}.ui-grid-grid-footer{float:left;width:100%}.ui-grid-footer-canvas,.ui-grid-footer-viewport{height:100%}.ui-grid-footer-viewport{overflow:hidden}.ui-grid-footer-canvas{position:relative}.ui-grid-footer-canvas:after,.ui-grid-footer-canvas:before{content:\"\";display:table;line-height:0}.ui-grid-footer-canvas:after{clear:both}.ui-grid-footer-cell-wrapper{position:relative;display:table;box-sizing:border-box;height:100%}.ui-grid-footer-cell-row{display:table-row}.ui-grid-footer-cell{overflow:hidden;background-color:inherit;border-right:1px solid;border-color:#d4d4d4;box-sizing:border-box;display:table-cell}.ui-grid-footer-cell:last-child{border-right:0}.ui-grid-menu-button{z-index:2;position:absolute;right:0;top:0;background:#f3f3f3;border:0;border-left:1px solid #d4d4d4;border-bottom:1px solid #d4d4d4;cursor:pointer;height:32px;font-weight:400}.ui-grid-menu-button .ui-grid-icon-container{margin-top:5px;margin-left:2px}.ui-grid-menu-button .ui-grid-menu{right:0}.ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid{overflow:scroll}.ui-grid-menu{overflow:hidden;max-width:320px;z-index:2;position:absolute;right:100%;padding:0 10px 20px;cursor:pointer;box-sizing:border-box}.ui-grid-menu-item{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ui-grid-menu .ui-grid-menu-inner{background:#fff;border:1px solid #d4d4d4;position:relative;white-space:nowrap;border-radius:0}.ui-grid-menu .ui-grid-menu-inner ul{margin:0;padding:0;list-style-type:none}.ui-grid-menu .ui-grid-menu-inner ul li{padding:0}.ui-grid-menu .ui-grid-menu-inner ul li .ui-grid-menu-item{color:#000;min-width:100%;padding:8px;text-align:left;background:transparent;border:none;cursor:default}.ui-grid-menu .ui-grid-menu-inner ul li button.ui-grid-menu-item{cursor:pointer}.ui-grid-menu .ui-grid-menu-inner ul li button.ui-grid-menu-item:focus,.ui-grid-menu .ui-grid-menu-inner ul li button.ui-grid-menu-item:hover{background-color:#b3c4c7}.ui-grid-menu .ui-grid-menu-inner ul li button.ui-grid-menu-item.ui-grid-menu-item-active{background-color:#9cb2b6}.ui-grid-menu .ui-grid-menu-inner ul li:not(:last-child)>.ui-grid-menu-item{border-bottom:1px solid #d4d4d4}.ui-grid-sortarrow{right:5px;position:absolute;width:20px;top:0;bottom:0;background-position:50%}.ui-grid-sortarrow.down{-webkit-transform:rotate(180deg);transform:rotate(180deg)}@font-face{font-family:ui-grid;src:url(" + __webpack_require__(543) + ");src:url(" + __webpack_require__(543) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(544) + ") format(\"woff\"),url(" + __webpack_require__(545) + ") format(\"truetype\"),url(" + __webpack_require__(546) + "?#ui-grid) format(\"svg\");font-weight:400;font-style:normal}[class*=\" ui-grid-icon\"]:before,[class^=ui-grid-icon]:before{font-family:ui-grid;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em}.ui-grid-icon-blank:before{width:1em;content:\" \"}.ui-grid-icon-plus-squared:before{content:\"\\C350\"}.ui-grid-icon-minus-squared:before{content:\"\\C351\"}.ui-grid-icon-search:before{content:\"\\C352\"}.ui-grid-icon-cancel:before{content:\"\\C353\"}.ui-grid-icon-info-circled:before{content:\"\\C354\"}.ui-grid-icon-lock:before{content:\"\\C355\"}.ui-grid-icon-lock-open:before{content:\"\\C356\"}.ui-grid-icon-pencil:before{content:\"\\C357\"}.ui-grid-icon-down-dir:before{content:\"\\C358\"}.ui-grid-icon-up-dir:before{content:\"\\C359\"}.ui-grid-icon-left-dir:before{content:\"\\C35A\"}.ui-grid-icon-right-dir:before{content:\"\\C35B\"}.ui-grid-icon-left-open:before{content:\"\\C35C\"}.ui-grid-icon-right-open:before{content:\"\\C35D\"}.ui-grid-icon-angle-down:before{content:\"\\C35E\"}.ui-grid-icon-filter:before{content:\"\\C35F\"}.ui-grid-icon-sort-alt-up:before{content:\"\\C360\"}.ui-grid-icon-sort-alt-down:before{content:\"\\C361\"}.ui-grid-icon-ok:before{content:\"\\C362\"}.ui-grid-icon-menu:before{content:\"\\C363\"}.ui-grid-icon-indent-left:before{content:\"\\E800\"}.ui-grid-icon-indent-right:before{content:\"\\E801\"}.ui-grid-icon-spin5:before{content:\"\\EA61\"}.ui-grid[dir=rtl] .ui-grid-cell,.ui-grid[dir=rtl] .ui-grid-footer-cell,.ui-grid[dir=rtl] .ui-grid-header-cell{float:right!important}.ui-grid[dir=rtl] .ui-grid-column-menu-button{position:absolute;left:1px;top:0;right:inherit}.ui-grid[dir=rtl] .ui-grid-cell:first-child,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child{border-right:0}.ui-grid[dir=rtl] .ui-grid-cell:last-child,.ui-grid[dir=rtl] .ui-grid-header-cell:last-child{border-right:1px solid #d4d4d4;border-left:0}.ui-grid[dir=rtl] .ui-grid-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child .ui-grid-vertical-bar{width:0}.ui-grid[dir=rtl] .ui-grid-menu-button{z-index:2;position:absolute;left:0;right:auto;background:#f3f3f3;border:1px solid #d4d4d4;cursor:pointer;min-height:27px;font-weight:400}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button,.ui-grid[dir=rtl] .ui-grid-menu-button .ui-grid-menu{left:0;right:auto}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button [class^=ui-grid-icon]{right:auto;left:10px}.ui-grid-animate-spin{-webkit-animation:ui-grid-spin 2s infinite linear;animation:ui-grid-spin 2s infinite linear;display:inline-block}@-webkit-keyframes ui-grid-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes ui-grid-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.ui-grid-cell-focus{outline:0;background-color:#b3c4c7}.ui-grid-focuser{position:absolute;left:0;top:0;z-index:-1;width:100%;height:100%}.ui-grid-focuser:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-grid-offscreen{display:block;position:absolute;left:-10000px;top:-10000px;clip:rect(0,0,0,0)}.ui-grid-cell input{border-radius:inherit;padding:0;width:100%;height:auto;font:inherit}.ui-grid-cell input,.ui-grid-cell input:focus{color:inherit;outline:none}.ui-grid-cell input[type=checkbox]{margin:9px 0 0 6px;width:auto}.ui-grid-cell input.ng-invalid{border:1px solid #fc8f8f}.ui-grid-cell input.ng-valid{border:1px solid #d4d4d4}.ui-grid-viewport .ui-grid-empty-base-layer-container{position:absolute;overflow:hidden;pointer-events:none;z-index:-1}.expandableRow .ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:#fdfdfd}.expandableRow .ui-grid-row:nth-child(2n) .ui-grid-cell{background-color:#f3f3f3}.ui-grid-cell.ui-grid-disable-selection.ui-grid-row-header-cell{pointer-events:none}.ui-grid-expandable-buttons-cell i{pointer-events:all}.scrollFiller{float:left;border:1px solid #d4d4d4}.movingColumn{position:absolute;top:0;border:1px solid #d4d4d4;box-shadow:inset 0 0 14px rgba(0,0,0,.2)}.movingColumn .ui-grid-icon-angle-down{display:none}.ui-grid-pager-panel{display:flex;justify-content:space-between;align-items:center;position:absolute;left:0;bottom:0;width:100%;padding-top:3px;padding-bottom:3px;box-sizing:content-box}.ui-grid-pager-container{float:left}.ui-grid-pager-control{padding:5px 0;display:flex;flex-flow:row nowrap;align-items:center;margin-right:10px;margin-left:10px;min-width:135px;float:left}.ui-grid-pager-control button,.ui-grid-pager-control input,.ui-grid-pager-control span{margin-right:4px}.ui-grid-pager-control button{height:25px;min-width:26px;display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background:#f3f3f3;border:1px solid #ccc;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#eee}.ui-grid-pager-control button:hover{border-color:#adadad;text-decoration:none}.ui-grid-pager-control button:focus{border-color:#8c8c8c;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.ui-grid-pager-control button:active{border-color:#adadad;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.ui-grid-pager-control button:active:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.ui-grid-pager-control button:active:focus,.ui-grid-pager-control button:active:hover{background-color:#c8c8c8;border-color:#8c8c8c}.ui-grid-pager-control button:active,.ui-grid-pager-control button:focus,.ui-grid-pager-control button:hover{color:#eee;background:#dadada}.ui-grid-pager-control button[disabled]{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}.ui-grid-pager-control button[disabled]:focus,.ui-grid-pager-control button[disabled]:hover{background-color:#f3f3f3;border-color:#ccc}.ui-grid-pager-control input{display:inline;height:26px;width:50px;vertical-align:top;color:#555;background:#fff;border:1px solid #ccc;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.ui-grid-pager-control input:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-grid-pager-control input::-moz-placeholder,.ui-grid-pager-control input[disabled],.ui-grid-pager-control input[readonly]{opacity:1}.ui-grid-pager-control input:-ms-input-placeholder,.ui-grid-pager-control input::-moz-placeholder,.ui-grid-pager-control input::-webkit-input-placeholder{color:#999}.ui-grid-pager-control input::-ms-expand{border:0;background-color:transparent}.ui-grid-pager-control input[disabled],.ui-grid-pager-control input[readonly]{background-color:#eee}.ui-grid-pager-control input[disabled]{cursor:not-allowed}.ui-grid-pager-control .ui-grid-pager-max-pages-number,.ui-grid-pager-control .ui-grid-pager-max-pages-number>*{vertical-align:bottom}.ui-grid-pager-control .ui-grid-pager-max-pages-number abbr{border-bottom:none;text-decoration:none}.ui-grid-pager-control .first-bar{width:10px;border-left:2px solid #4d4d4d;margin-top:-6px;height:12px;margin-left:-3px}.ui-grid-pager-control .first-bar-rtl{width:10px;border-left:2px solid #4d4d4d;margin-top:-6px;height:12px;margin-right:-7px}.ui-grid-pager-control .first-triangle{width:0;height:0;border-style:solid;border-width:5px 8.7px 5px 0;border-color:transparent #4d4d4d transparent transparent;margin-left:2px}.ui-grid-pager-control .next-triangle{margin-left:1px}.ui-grid-pager-control .prev-triangle{margin-left:0}.ui-grid-pager-control .last-triangle{width:0;height:0;border-style:solid;border-width:5px 0 5px 8.7px;border-color:transparent transparent transparent #4d4d4d;margin-left:-1px}.ui-grid-pager-control .last-bar{width:10px;border-left:2px solid #4d4d4d;margin-top:-6px;height:12px;margin-left:1px}.ui-grid-pager-control .last-bar-rtl{width:10px;border-left:2px solid #4d4d4d;margin-top:-6px;height:12px;margin-right:-11px}.ui-grid-pager-row-count-picker{float:left;padding:5px 10px}.ui-grid-pager-row-count-picker select{color:#555;background:#fff;border:1px solid #ccc;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px;height:25px;width:67px;display:inline;vertical-align:middle}.ui-grid-pager-row-count-picker select:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-grid-pager-row-count-picker select::-moz-placeholder,.ui-grid-pager-row-count-picker select[disabled],.ui-grid-pager-row-count-picker select[readonly]{opacity:1}.ui-grid-pager-row-count-picker select:-ms-input-placeholder,.ui-grid-pager-row-count-picker select::-moz-placeholder,.ui-grid-pager-row-count-picker select::-webkit-input-placeholder{color:#999}.ui-grid-pager-row-count-picker select::-ms-expand{border:0;background-color:transparent}.ui-grid-pager-row-count-picker select[disabled],.ui-grid-pager-row-count-picker select[readonly]{background-color:#eee}.ui-grid-pager-row-count-picker select[disabled]{cursor:not-allowed}.ui-grid-pager-row-count-picker .ui-grid-pager-row-count-label{margin-top:3px}.ui-grid-pager-count-container{float:right;margin-top:4px;min-width:50px}.ui-grid-pager-count-container .ui-grid-pager-count{margin-right:10px;margin-left:10px;float:right}.ui-grid-pager-count-container .ui-grid-pager-count abbr{border-bottom:none;text-decoration:none}.ui-grid-pinned-container{position:absolute;display:inline;top:0}.ui-grid-pinned-container.ui-grid-pinned-container-left{float:left;left:0}.ui-grid-pinned-container.ui-grid-pinned-container-right{float:right;right:0}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-cell:last-child,.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:last-child{box-sizing:border-box;border-right:1px solid;border-width:1px;border-right-color:#aeaeae}.ui-grid-pinned-container .ui-grid-cell:not(:last-child) .ui-grid-vertical-bar,.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{width:1px}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{background-color:#d4d4d4}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-cell:not(:last-child) .ui-grid-vertical-bar{background-color:#aeaeae}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:last-child .ui-grid-vertical-bar{right:-1px;width:1px;background-color:#aeaeae}.ui-grid-pinned-container.ui-grid-pinned-container-right .ui-grid-cell:first-child,.ui-grid-pinned-container.ui-grid-pinned-container-right .ui-grid-header-cell:first-child{box-sizing:border-box;border-left:1px solid;border-width:1px;border-left-color:#aeaeae}.ui-grid-pinned-container .ui-grid-cell:not(:first-child) .ui-grid-vertical-bar,.ui-grid-pinned-container.ui-grid-pinned-container-right .ui-grid-header-cell:not(:first-child) .ui-grid-vertical-bar{width:1px}.ui-grid-pinned-container.ui-grid-pinned-container-right .ui-grid-header-cell:not(:first-child) .ui-grid-vertical-bar{background-color:#d4d4d4}.ui-grid-pinned-container.ui-grid-pinned-container-right .ui-grid-cell:not(:last-child) .ui-grid-vertical-bar{background-color:#aeaeae}.ui-grid-pinned-container.ui-grid-pinned-container-first .ui-grid-header-cell:first-child .ui-grid-vertical-bar{left:-1px;width:1px;background-color:#aeaeae}.ui-grid-column-resizer{top:0;bottom:0;width:5px;position:absolute;cursor:col-resize}.ui-grid-column-resizer.left{left:0}.ui-grid-column-resizer.right{right:0}.ui-grid-header-cell:last-child .ui-grid-column-resizer.right{border-right:1px solid #d4d4d4}.ui-grid[dir=rtl] .ui-grid-header-cell:last-child .ui-grid-column-resizer.right{border-right:0}.ui-grid[dir=rtl] .ui-grid-header-cell:last-child .ui-grid-column-resizer.left{border-left:1px solid #d4d4d4}.ui-grid.column-resizing{cursor:col-resize;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui-grid.column-resizing .ui-grid-resize-overlay{position:absolute;top:0;height:100%;width:1px;background-color:#aeaeae}.ui-grid-row-saving .ui-grid-cell{color:#848484!important}.ui-grid-row-dirty .ui-grid-cell{color:#610b38}.ui-grid-row-error .ui-grid-cell{color:red!important}.ui-grid-row.ui-grid-row-selected>[ui-grid-row]>.ui-grid-cell{background-color:#c9dde1}.ui-grid-disable-selection{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.ui-grid-selection-row-header-buttons{display:flex;align-items:center;height:100%;cursor:pointer}.ui-grid-selection-row-header-buttons:before{opacity:.1}.ui-grid-selection-row-header-buttons.ui-grid-all-selected:before,.ui-grid-selection-row-header-buttons.ui-grid-row-selected:before{opacity:1}.ui-grid-tree-row-header-buttons.ui-grid-tree-header{cursor:pointer;opacity:1}.ui-grid-tree-header-row{font-weight:700!important}.ui-grid-tree-header-row .ui-grid-cell.ui-grid-disable-selection.ui-grid-row-header-cell{pointer-events:all}.ui-grid-cell-contents.invalid{border:1px solid #fc8f8f}", ""]);
	
	// exports


/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(439)();
	// imports
	
	
	// module
	exports.push([module.id, ".toast-title{font-weight:700}.toast-message{word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4}button.toast-close-button{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999}#toast-container *{box-sizing:border-box}#toast-container .toast{position:relative;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;border-radius:3px 3px 3px 3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:.8}#toast-container .toast:hover{box-shadow:0 0 12px #000;opacity:1;cursor:pointer}#toast-container .toast.toast-info{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=\")!important}#toast-container .toast.toast-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=\")!important}#toast-container .toast.toast-success{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==\")!important}#toast-container .toast.toast-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=\")!important}#toast-container.toast-bottom-center .toast,#toast-container.toast-top-center .toast{width:300px;margin-left:auto;margin-right:auto}#toast-container.toast-bottom-full-width .toast,#toast-container.toast-top-full-width .toast{width:96%;margin-left:auto;margin-right:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}progress-bar{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}div[toast]{opacity:1!important}div[toast].ng-enter{opacity:0!important;transition:opacity .3s linear}div[toast].ng-enter.ng-enter-active{opacity:1!important}div[toast].ng-leave{opacity:1;transition:opacity .3s linear}div[toast].ng-leave.ng-leave-active{opacity:0!important}@media (max-width:240px){#toast-container .toast.div{padding:8px 8px 8px 50px;width:11em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media (min-width:241px) and (max-width:480px){#toast-container .toast.div{padding:8px 8px 8px 50px;width:18em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media (min-width:481px) and (max-width:768px){#toast-container .toast.div{padding:15px 15px 15px 50px;width:25em}}", ""]);
	
	// exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(996);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 996:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(997), __webpack_require__(998), __webpack_require__(999), __webpack_require__(1000), __webpack_require__(1001)  ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "bundle all";
		    return window.kendo;
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 997:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(549);
	
	/***/ }),
	
	/***/ 998:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(741);
	
	/***/ }),
	
	/***/ 999:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(784);
	
	/***/ }),
	
	/***/ 1000:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 1001:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1354);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1000:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 1001:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1007:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(561);
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1009:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(572);
	
	/***/ }),
	
	/***/ 1010:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(576);
	
	/***/ }),
	
	/***/ 1011:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(577);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1021:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(562);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1023:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(570);
	
	/***/ }),
	
	/***/ 1028:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(578);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1037:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(579);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1039:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(580);
	
	/***/ }),
	
	/***/ 1042:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(581);
	
	/***/ }),
	
	/***/ 1047:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(564);
	
	/***/ }),
	
	/***/ 1048:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(565);
	
	/***/ }),
	
	/***/ 1053:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(582);
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1055:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(583);
	
	/***/ }),
	
	/***/ 1056:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(584);
	
	/***/ }),
	
	/***/ 1057:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(586);
	
	/***/ }),
	
	/***/ 1058:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1071:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(587);
	
	/***/ }),
	
	/***/ 1116:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(588);
	
	/***/ }),
	
	/***/ 1117:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(589);
	
	/***/ }),
	
	/***/ 1119:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(590);
	
	/***/ }),
	
	/***/ 1120:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(591);
	
	/***/ }),
	
	/***/ 1134:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(592);
	
	/***/ }),
	
	/***/ 1137:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(593);
	
	/***/ }),
	
	/***/ 1138:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1139:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(595);
	
	/***/ }),
	
	/***/ 1140:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(596);
	
	/***/ }),
	
	/***/ 1141:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(601);
	
	/***/ }),
	
	/***/ 1179:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(598);
	
	/***/ }),
	
	/***/ 1180:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(600);
	
	/***/ }),
	
	/***/ 1182:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(602);
	
	/***/ }),
	
	/***/ 1186:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(603);
	
	/***/ }),
	
	/***/ 1187:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(607);
	
	/***/ }),
	
	/***/ 1188:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(608);
	
	/***/ }),
	
	/***/ 1192:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(605);
	
	/***/ }),
	
	/***/ 1193:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(606);
	
	/***/ }),
	
	/***/ 1194:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(599);
	
	/***/ }),
	
	/***/ 1197:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(614);
	
	/***/ }),
	
	/***/ 1198:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(615);
	
	/***/ }),
	
	/***/ 1199:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(616);
	
	/***/ }),
	
	/***/ 1200:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(617);
	
	/***/ }),
	
	/***/ 1201:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(618);
	
	/***/ }),
	
	/***/ 1204:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(625);
	
	/***/ }),
	
	/***/ 1205:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(629);
	
	/***/ }),
	
	/***/ 1206:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(633);
	
	/***/ }),
	
	/***/ 1209:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(597);
	
	/***/ }),
	
	/***/ 1215:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(634);
	
	/***/ }),
	
	/***/ 1266:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(635);
	
	/***/ }),
	
	/***/ 1267:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(574);
	
	/***/ }),
	
	/***/ 1276:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(636);
	
	/***/ }),
	
	/***/ 1277:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(638);
	
	/***/ }),
	
	/***/ 1278:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(637);
	
	/***/ }),
	
	/***/ 1279:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(639);
	
	/***/ }),
	
	/***/ 1280:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(640);
	
	/***/ }),
	
	/***/ 1338:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(575);
	
	/***/ }),
	
	/***/ 1342:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(641);
	
	/***/ }),
	
	/***/ 1343:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(642);
	
	/***/ }),
	
	/***/ 1344:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(643);
	
	/***/ }),
	
	/***/ 1345:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(644);
	
	/***/ }),
	
	/***/ 1346:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(645);
	
	/***/ }),
	
	/***/ 1347:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(646);
	
	/***/ }),
	
	/***/ 1348:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(647);
	
	/***/ }),
	
	/***/ 1354:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1004),
		        __webpack_require__(1055),
		        __webpack_require__(1056),
		        __webpack_require__(1054),
		        __webpack_require__(1001),
		        __webpack_require__(1047),
		        __webpack_require__(1048),
		        __webpack_require__(1013),
		        __webpack_require__(1204),
		        __webpack_require__(1205),
		        __webpack_require__(1057),
		        __webpack_require__(1058),
		        __webpack_require__(1000),
		        __webpack_require__(1011),
		        __webpack_require__(1038),
		        __webpack_require__(1059),
		        __webpack_require__(1022),
		        __webpack_require__(1199),
		        __webpack_require__(1201),
		        __webpack_require__(1137),
		        __webpack_require__(1197),
		        __webpack_require__(1028),
		        __webpack_require__(1355),
		        __webpack_require__(1039),
		        __webpack_require__(1356),
		        __webpack_require__(1200),
		        __webpack_require__(1036),
		        __webpack_require__(1342),
		        __webpack_require__(1053),
		        __webpack_require__(1021),
		        __webpack_require__(1116),
		        __webpack_require__(1119),
		        __webpack_require__(1117),
		        __webpack_require__(1182),
		        __webpack_require__(1008),
		        __webpack_require__(1009),
		        __webpack_require__(1007),
		        __webpack_require__(1010),
		        __webpack_require__(1357),
		        __webpack_require__(1139),
		        __webpack_require__(1198),
		        __webpack_require__(1192),
		        __webpack_require__(1188),
		        __webpack_require__(1179),
		        __webpack_require__(1343),
		        __webpack_require__(1209),
		        __webpack_require__(1140),
		        __webpack_require__(1358),
		        __webpack_require__(1134),
		        __webpack_require__(1344),
		        __webpack_require__(1359),
		        __webpack_require__(1042),
		        __webpack_require__(1194),
		        __webpack_require__(1360),
		        __webpack_require__(1361),
		        __webpack_require__(1345),
		        __webpack_require__(1206),
		        __webpack_require__(1346),
		        __webpack_require__(1141),
		        __webpack_require__(1120),
		        __webpack_require__(1215),
		        __webpack_require__(1193),
		        __webpack_require__(1338),
		        __webpack_require__(1267),
		        __webpack_require__(1037),
		        __webpack_require__(1347),
		        __webpack_require__(1180),
		        __webpack_require__(1348),
		        __webpack_require__(1138),
		        __webpack_require__(1023),
		        __webpack_require__(1278),
		        __webpack_require__(1276),
		        __webpack_require__(1279),
		        __webpack_require__(1280),
		        __webpack_require__(1277),
		        __webpack_require__(1362),
		        __webpack_require__(1186),
		        __webpack_require__(1187),
		        __webpack_require__(1363),
		        __webpack_require__(1364),
		        __webpack_require__(1266),
		        __webpack_require__(1365),
		        __webpack_require__(1366),
		        __webpack_require__(1071)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "bundle all";
		    return window.kendo;
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1355:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(648);
	
	/***/ }),
	
	/***/ 1356:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(652);
	
	/***/ }),
	
	/***/ 1357:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(653);
	
	/***/ }),
	
	/***/ 1358:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(654);
	
	/***/ }),
	
	/***/ 1359:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(691);
	
	/***/ }),
	
	/***/ 1360:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(692);
	
	/***/ }),
	
	/***/ 1361:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(693);
	
	/***/ }),
	
	/***/ 1362:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(694);
	
	/***/ }),
	
	/***/ 1363:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(696);
	
	/***/ }),
	
	/***/ 1364:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(697);
	
	/***/ }),
	
	/***/ 1365:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(698);
	
	/***/ }),
	
	/***/ 1366:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(740);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1124);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1124:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1125),
		        __webpack_require__(1126),
		        __webpack_require__(1127),
		        __webpack_require__(1128),
		        __webpack_require__(1129)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    var __meta__ = { // jshint ignore:line
		        id: "drawing",
		        name: "Drawing API",
		        category: "framework",
		        description: "The Kendo UI low-level drawing API",
		        depends: [ "core", "color", "popup" ]
		    };
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 1125:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(551);
	
	/***/ }),
	
	/***/ 1126:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(553);
	
	/***/ }),
	
	/***/ 1127:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(556);
	
	/***/ }),
	
	/***/ 1128:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(558);
	
	/***/ }),
	
	/***/ 1129:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(559);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(929);
		module.exports = __webpack_require__(929);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 929:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		    function createPromise() {
		        return $.Deferred();
		    }
	
		    function promiseAll(promises) {
		        return $.when.apply($, promises);
		    }
	
		    kendo.drawing.util = kendo.drawing.util || {};
		    kendo.deepExtend(kendo.drawing.util, {
		        createPromise: createPromise,
		        promiseAll: promiseAll
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1045);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1045:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1003)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "core",
		    name: "Core",
		    category: "framework",
		    description: "The core of the Kendo framework."
		};
	
		/*jshint eqnull: true, loopfunc: true, evil: true, boss: true, freeze: false*/
		(function($, window, undefined) {
		    var kendo = window.kendo = window.kendo || { cultures: {} },
		        extend = $.extend,
		        each = $.each,
		        isArray = $.isArray,
		        proxy = $.proxy,
		        noop = $.noop,
		        math = Math,
		        Template,
		        JSON = window.JSON || {},
		        support = {},
		        percentRegExp = /%/,
		        formatRegExp = /\{(\d+)(:[^\}]+)?\}/g,
		        boxShadowRegExp = /(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+)?/i,
		        numberRegExp = /^(\+|-?)\d+(\.?)\d*$/,
		        FUNCTION = "function",
		        STRING = "string",
		        NUMBER = "number",
		        OBJECT = "object",
		        NULL = "null",
		        BOOLEAN = "boolean",
		        UNDEFINED = "undefined",
		        getterCache = {},
		        setterCache = {},
		        slice = [].slice;
	
		    kendo.version = "2018.3.1219".replace(/^\s+|\s+$/g, '');
	
		    function Class() {}
	
		    Class.extend = function(proto) {
		        var base = function() {},
		            member,
		            that = this,
		            subclass = proto && proto.init ? proto.init : function () {
		                that.apply(this, arguments);
		            },
		            fn;
	
		        base.prototype = that.prototype;
		        fn = subclass.fn = subclass.prototype = new base();
	
		        for (member in proto) {
		            if (proto[member] != null && proto[member].constructor === Object) {
		                // Merge object members
		                fn[member] = extend(true, {}, base.prototype[member], proto[member]);
		            } else {
		                fn[member] = proto[member];
		            }
		        }
	
		        fn.constructor = subclass;
		        subclass.extend = that.extend;
	
		        return subclass;
		    };
	
		    Class.prototype._initOptions = function(options) {
		        this.options = deepExtend({}, this.options, options);
		    };
	
		    var isFunction = kendo.isFunction = function(fn) {
		        return typeof fn === "function";
		    };
	
		    var preventDefault = function() {
		        this._defaultPrevented = true;
		    };
	
		    var isDefaultPrevented = function() {
		        return this._defaultPrevented === true;
		    };
	
		    var Observable = Class.extend({
		        init: function() {
		            this._events = {};
		        },
	
		        bind: function(eventName, handlers, one) {
		            var that = this,
		                idx,
		                eventNames = typeof eventName === STRING ? [eventName] : eventName,
		                length,
		                original,
		                handler,
		                handlersIsFunction = typeof handlers === FUNCTION,
		                events;
	
		            if (handlers === undefined) {
		                for (idx in eventName) {
		                    that.bind(idx, eventName[idx]);
		                }
		                return that;
		            }
	
		            for (idx = 0, length = eventNames.length; idx < length; idx++) {
		                eventName = eventNames[idx];
	
		                handler = handlersIsFunction ? handlers : handlers[eventName];
	
		                if (handler) {
		                    if (one) {
		                        original = handler;
		                        handler = function() {
		                            that.unbind(eventName, handler);
		                            original.apply(that, arguments);
		                        };
		                        handler.original = original;
		                    }
		                    events = that._events[eventName] = that._events[eventName] || [];
		                    events.push(handler);
		                }
		            }
	
		            return that;
		        },
	
		        one: function(eventNames, handlers) {
		            return this.bind(eventNames, handlers, true);
		        },
	
		        first: function(eventName, handlers) {
		            var that = this,
		                idx,
		                eventNames = typeof eventName === STRING ? [eventName] : eventName,
		                length,
		                handler,
		                handlersIsFunction = typeof handlers === FUNCTION,
		                events;
	
		            for (idx = 0, length = eventNames.length; idx < length; idx++) {
		                eventName = eventNames[idx];
	
		                handler = handlersIsFunction ? handlers : handlers[eventName];
	
		                if (handler) {
		                    events = that._events[eventName] = that._events[eventName] || [];
		                    events.unshift(handler);
		                }
		            }
	
		            return that;
		        },
	
		        trigger: function(eventName, e) {
		            var that = this,
		                events = that._events[eventName],
		                idx,
		                length;
	
		            if (events) {
		                e = e || {};
	
		                e.sender = that;
	
		                e._defaultPrevented = false;
	
		                e.preventDefault = preventDefault;
	
		                e.isDefaultPrevented = isDefaultPrevented;
	
		                events = events.slice();
	
		                for (idx = 0, length = events.length; idx < length; idx++) {
		                    events[idx].call(that, e);
		                }
	
		                return e._defaultPrevented === true;
		            }
	
		            return false;
		        },
	
		        unbind: function(eventName, handler) {
		            var that = this,
		                events = that._events[eventName],
		                idx;
	
		            if (eventName === undefined) {
		                that._events = {};
		            } else if (events) {
		                if (handler) {
		                    for (idx = events.length - 1; idx >= 0; idx--) {
		                        if (events[idx] === handler || events[idx].original === handler) {
		                            events.splice(idx, 1);
		                        }
		                    }
		                } else {
		                    that._events[eventName] = [];
		                }
		            }
	
		            return that;
		        }
		    });
	
	
		     function compilePart(part, stringPart) {
		         if (stringPart) {
		             return "'" +
		                 part.split("'").join("\\'")
		                     .split('\\"').join('\\\\\\"')
		                     .replace(/\n/g, "\\n")
		                     .replace(/\r/g, "\\r")
		                     .replace(/\t/g, "\\t") + "'";
		         } else {
		             var first = part.charAt(0),
		                 rest = part.substring(1);
	
		             if (first === "=") {
		                 return "+(" + rest + ")+";
		             } else if (first === ":") {
		                 return "+$kendoHtmlEncode(" + rest + ")+";
		             } else {
		                 return ";" + part + ";$kendoOutput+=";
		             }
		         }
		     }
	
		    var argumentNameRegExp = /^\w+/,
		        encodeRegExp = /\$\{([^}]*)\}/g,
		        escapedCurlyRegExp = /\\\}/g,
		        curlyRegExp = /__CURLY__/g,
		        escapedSharpRegExp = /\\#/g,
		        sharpRegExp = /__SHARP__/g,
		        zeros = ["", "0", "00", "000", "0000"];
	
		    Template = {
		        paramName: "data", // name of the parameter of the generated template
		        useWithBlock: true, // whether to wrap the template in a with() block
		        render: function(template, data) {
		            var idx,
		                length,
		                html = "";
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                html += template(data[idx]);
		            }
	
		            return html;
		        },
		        compile: function(template, options) {
		            var settings = extend({}, this, options),
		                paramName = settings.paramName,
		                argumentName = paramName.match(argumentNameRegExp)[0],
		                useWithBlock = settings.useWithBlock,
		                functionBody = "var $kendoOutput, $kendoHtmlEncode = kendo.htmlEncode;",
		                fn,
		                parts,
		                idx;
	
		            if (isFunction(template)) {
		                return template;
		            }
	
		            functionBody += useWithBlock ? "with(" + paramName + "){" : "";
	
		            functionBody += "$kendoOutput=";
	
		            parts = template
		                .replace(escapedCurlyRegExp, "__CURLY__")
		                .replace(encodeRegExp, "#=$kendoHtmlEncode($1)#")
		                .replace(curlyRegExp, "}")
		                .replace(escapedSharpRegExp, "__SHARP__")
		                .split("#");
	
		            for (idx = 0; idx < parts.length; idx ++) {
		                functionBody += compilePart(parts[idx], idx % 2 === 0);
		            }
	
		            functionBody += useWithBlock ? ";}" : ";";
	
		            functionBody += "return $kendoOutput;";
	
		            functionBody = functionBody.replace(sharpRegExp, "#");
	
		            try {
		                fn = new Function(argumentName, functionBody);
		                fn._slotCount = Math.floor(parts.length / 2);
		                return fn;
		            } catch(e) {
		                throw new Error(kendo.format("Invalid template:'{0}' Generated code:'{1}'", template, functionBody));
		            }
		        }
		    };
	
		function pad(number, digits, end) {
		    number = number + "";
		    digits = digits || 2;
		    end = digits - number.length;
	
		    if (end) {
		        return zeros[digits].substring(0, end) + number;
		    }
	
		    return number;
		}
	
		    //JSON stringify
		(function() {
		    var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
		        gap,
		        indent,
		        meta = {
		            "\b": "\\b",
		            "\t": "\\t",
		            "\n": "\\n",
		            "\f": "\\f",
		            "\r": "\\r",
		            "\"" : '\\"',
		            "\\": "\\\\"
		        },
		        rep,
		        toString = {}.toString;
	
	
		    if (typeof Date.prototype.toJSON !== FUNCTION) {
	
		        Date.prototype.toJSON = function () {
		            var that = this;
	
		            return isFinite(that.valueOf()) ?
		                pad(that.getUTCFullYear(), 4) + "-" +
		                pad(that.getUTCMonth() + 1)   + "-" +
		                pad(that.getUTCDate())        + "T" +
		                pad(that.getUTCHours())       + ":" +
		                pad(that.getUTCMinutes())     + ":" +
		                pad(that.getUTCSeconds())     + "Z" : null;
		        };
	
		        String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function () {
		            return this.valueOf();
		        };
		    }
	
		    function quote(string) {
		        escapable.lastIndex = 0;
		        return escapable.test(string) ? "\"" + string.replace(escapable, function (a) {
		            var c = meta[a];
		            return typeof c === STRING ? c :
		                "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
		        }) + "\"" : "\"" + string + "\"";
		    }
	
		    function str(key, holder) {
		        var i,
		            k,
		            v,
		            length,
		            mind = gap,
		            partial,
		            value = holder[key],
		            type;
	
		        if (value && typeof value === OBJECT && typeof value.toJSON === FUNCTION) {
		            value = value.toJSON(key);
		        }
	
		        if (typeof rep === FUNCTION) {
		            value = rep.call(holder, key, value);
		        }
	
		        type = typeof value;
		        if (type === STRING) {
		            return quote(value);
		        } else if (type === NUMBER) {
		            return isFinite(value) ? String(value) : NULL;
		        } else if (type === BOOLEAN || type === NULL) {
		            return String(value);
		        } else if (type === OBJECT) {
		            if (!value) {
		                return NULL;
		            }
		            gap += indent;
		            partial = [];
		            if (toString.apply(value) === "[object Array]") {
		                length = value.length;
		                for (i = 0; i < length; i++) {
		                    partial[i] = str(i, value) || NULL;
		                }
		                v = partial.length === 0 ? "[]" : gap ?
		                    "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" :
		                    "[" + partial.join(",") + "]";
		                gap = mind;
		                return v;
		            }
		            if (rep && typeof rep === OBJECT) {
		                length = rep.length;
		                for (i = 0; i < length; i++) {
		                    if (typeof rep[i] === STRING) {
		                        k = rep[i];
		                        v = str(k, value);
		                        if (v) {
		                            partial.push(quote(k) + (gap ? ": " : ":") + v);
		                        }
		                    }
		                }
		            } else {
		                for (k in value) {
		                    if (Object.hasOwnProperty.call(value, k)) {
		                        v = str(k, value);
		                        if (v) {
		                            partial.push(quote(k) + (gap ? ": " : ":") + v);
		                        }
		                    }
		                }
		            }
	
		            v = partial.length === 0 ? "{}" : gap ?
		                "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" :
		                "{" + partial.join(",") + "}";
		            gap = mind;
		            return v;
		        }
		    }
	
		    if (typeof JSON.stringify !== FUNCTION) {
		        JSON.stringify = function (value, replacer, space) {
		            var i;
		            gap = "";
		            indent = "";
	
		            if (typeof space === NUMBER) {
		                for (i = 0; i < space; i += 1) {
		                    indent += " ";
		                }
	
		            } else if (typeof space === STRING) {
		                indent = space;
		            }
	
		            rep = replacer;
		            if (replacer && typeof replacer !== FUNCTION && (typeof replacer !== OBJECT || typeof replacer.length !== NUMBER)) {
		                throw new Error("JSON.stringify");
		            }
	
		            return str("", {"": value});
		        };
		    }
		})();
	
		// Date and Number formatting
		(function() {
		    var dateFormatRegExp = /dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g,
		        standardFormatRegExp =  /^(n|c|p|e)(\d*)$/i,
		        literalRegExp = /(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g,
		        commaRegExp = /\,/g,
		        EMPTY = "",
		        POINT = ".",
		        COMMA = ",",
		        SHARP = "#",
		        ZERO = "0",
		        PLACEHOLDER = "??",
		        EN = "en-US",
		        objectToString = {}.toString;
	
		    //cultures
		    kendo.cultures["en-US"] = {
		        name: EN,
		        numberFormat: {
		            pattern: ["-n"],
		            decimals: 2,
		            ",": ",",
		            ".": ".",
		            groupSize: [3],
		            percent: {
		                pattern: ["-n %", "n %"],
		                decimals: 2,
		                ",": ",",
		                ".": ".",
		                groupSize: [3],
		                symbol: "%"
		            },
		            currency: {
		                name: "US Dollar",
		                abbr: "USD",
		                pattern: ["($n)", "$n"],
		                decimals: 2,
		                ",": ",",
		                ".": ".",
		                groupSize: [3],
		                symbol: "$"
		            }
		        },
		        calendars: {
		            standard: {
		                days: {
		                    names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
		                    namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		                    namesShort: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ]
		                },
		                months: {
		                    names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
		                    namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
		                },
		                AM: [ "AM", "am", "AM" ],
		                PM: [ "PM", "pm", "PM" ],
		                patterns: {
		                    d: "M/d/yyyy",
		                    D: "dddd, MMMM dd, yyyy",
		                    F: "dddd, MMMM dd, yyyy h:mm:ss tt",
		                    g: "M/d/yyyy h:mm tt",
		                    G: "M/d/yyyy h:mm:ss tt",
		                    m: "MMMM dd",
		                    M: "MMMM dd",
		                    s: "yyyy'-'MM'-'ddTHH':'mm':'ss",
		                    t: "h:mm tt",
		                    T: "h:mm:ss tt",
		                    u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
		                    y: "MMMM, yyyy",
		                    Y: "MMMM, yyyy"
		                },
		                "/": "/",
		                ":": ":",
		                firstDay: 0,
		                twoDigitYearMax: 2029
		            }
		        }
		    };
	
	
		     function findCulture(culture) {
		        if (culture) {
		            if (culture.numberFormat) {
		                return culture;
		            }
	
		            if (typeof culture === STRING) {
		                var cultures = kendo.cultures;
		                return cultures[culture] || cultures[culture.split("-")[0]] || null;
		            }
	
		            return null;
		        }
	
		        return null;
		    }
	
		    function getCulture(culture) {
		        if (culture) {
		            culture = findCulture(culture);
		        }
	
		        return culture || kendo.cultures.current;
		    }
	
		    kendo.culture = function(cultureName) {
		        var cultures = kendo.cultures, culture;
	
		        if (cultureName !== undefined) {
		            culture = findCulture(cultureName) || cultures[EN];
		            culture.calendar = culture.calendars.standard;
		            cultures.current = culture;
		        } else {
		            return cultures.current;
		        }
		    };
	
		    kendo.findCulture = findCulture;
		    kendo.getCulture = getCulture;
	
		    //set current culture to en-US.
		    kendo.culture(EN);
	
		    function formatDate(date, format, culture) {
		        culture = getCulture(culture);
	
		        var calendar = culture.calendars.standard,
		            days = calendar.days,
		            months = calendar.months;
	
		        format = calendar.patterns[format] || format;
	
		        return format.replace(dateFormatRegExp, function (match) {
		            var minutes;
		            var result;
		            var sign;
	
		            if (match === "d") {
		                result = date.getDate();
		            } else if (match === "dd") {
		                result = pad(date.getDate());
		            } else if (match === "ddd") {
		                result = days.namesAbbr[date.getDay()];
		            } else if (match === "dddd") {
		                result = days.names[date.getDay()];
		            } else if (match === "M") {
		                result = date.getMonth() + 1;
		            } else if (match === "MM") {
		                result = pad(date.getMonth() + 1);
		            } else if (match === "MMM") {
		                result = months.namesAbbr[date.getMonth()];
		            } else if (match === "MMMM") {
		                result = months.names[date.getMonth()];
		            } else if (match === "yy") {
		                result = pad(date.getFullYear() % 100);
		            } else if (match === "yyyy") {
		                result = pad(date.getFullYear(), 4);
		            } else if (match === "h" ) {
		                result = date.getHours() % 12 || 12;
		            } else if (match === "hh") {
		                result = pad(date.getHours() % 12 || 12);
		            } else if (match === "H") {
		                result = date.getHours();
		            } else if (match === "HH") {
		                result = pad(date.getHours());
		            } else if (match === "m") {
		                result = date.getMinutes();
		            } else if (match === "mm") {
		                result = pad(date.getMinutes());
		            } else if (match === "s") {
		                result = date.getSeconds();
		            } else if (match === "ss") {
		                result = pad(date.getSeconds());
		            } else if (match === "f") {
		                result = math.floor(date.getMilliseconds() / 100);
		            } else if (match === "ff") {
		                result = date.getMilliseconds();
		                if (result > 99) {
		                    result = math.floor(result / 10);
		                }
		                result = pad(result);
		            } else if (match === "fff") {
		                result = pad(date.getMilliseconds(), 3);
		            } else if (match === "tt") {
		                result = date.getHours() < 12 ? calendar.AM[0] : calendar.PM[0];
		            } else if (match === "zzz") {
		                minutes = date.getTimezoneOffset();
		                sign = minutes < 0;
	
		                result = math.abs(minutes / 60).toString().split(".")[0];
		                minutes = math.abs(minutes) - (result * 60);
	
		                result = (sign ? "+" : "-") + pad(result);
		                result += ":" + pad(minutes);
		            } else if (match === "zz" || match === "z") {
		                result = date.getTimezoneOffset() / 60;
		                sign = result < 0;
	
		                result = math.abs(result).toString().split(".")[0];
		                result = (sign ? "+" : "-") + (match === "zz" ? pad(result) : result);
		            }
	
		            return result !== undefined ? result : match.slice(1, match.length - 1);
		        });
		    }
	
		    //number formatting
		    function formatNumber(number, format, culture) {
		        culture = getCulture(culture);
	
		        var numberFormat = culture.numberFormat,
		            decimal = numberFormat[POINT],
		            precision = numberFormat.decimals,
		            pattern = numberFormat.pattern[0],
		            literals = [],
		            symbol,
		            isCurrency, isPercent,
		            customPrecision,
		            formatAndPrecision,
		            negative = number < 0,
		            integer,
		            fraction,
		            integerLength,
		            fractionLength,
		            replacement = EMPTY,
		            value = EMPTY,
		            idx,
		            length,
		            ch,
		            hasGroup,
		            hasNegativeFormat,
		            decimalIndex,
		            sharpIndex,
		            zeroIndex,
		            hasZero, hasSharp,
		            percentIndex,
		            currencyIndex,
		            startZeroIndex,
		            start = -1,
		            end;
	
		        //return empty string if no number
		        if (number === undefined) {
		            return EMPTY;
		        }
	
		        if (!isFinite(number)) {
		            return number;
		        }
	
		        //if no format then return number.toString() or number.toLocaleString() if culture.name is not defined
		        if (!format) {
		            return culture.name.length ? number.toLocaleString() : number.toString();
		        }
	
		        formatAndPrecision = standardFormatRegExp.exec(format);
	
		        // standard formatting
		        if (formatAndPrecision) {
		            format = formatAndPrecision[1].toLowerCase();
	
		            isCurrency = format === "c";
		            isPercent = format === "p";
	
		            if (isCurrency || isPercent) {
		                //get specific number format information if format is currency or percent
		                numberFormat = isCurrency ? numberFormat.currency : numberFormat.percent;
		                decimal = numberFormat[POINT];
		                precision = numberFormat.decimals;
		                symbol = numberFormat.symbol;
		                pattern = numberFormat.pattern[negative ? 0 : 1];
		            }
	
		            customPrecision = formatAndPrecision[2];
	
		            if (customPrecision) {
		                precision = +customPrecision;
		            }
	
		            //return number in exponential format
		            if (format === "e") {
		                var exp = customPrecision ? number.toExponential(precision) : number.toExponential(); // toExponential() and toExponential(undefined) differ in FF #653438.
	
		                return exp.replace(POINT, numberFormat[POINT]);
		            }
	
		            // multiply if format is percent
		            if (isPercent) {
		                number *= 100;
		            }
	
		            number = round(number, precision);
		            negative = number < 0;
		            number = number.split(POINT);
	
		            integer = number[0];
		            fraction = number[1];
	
		            //exclude "-" if number is negative.
		            if (negative) {
		                integer = integer.substring(1);
		            }
	
		            value = groupInteger(integer, 0, integer.length, numberFormat);
	
		            if (fraction) {
		                value += decimal + fraction;
		            }
	
		            if (format === "n" && !negative) {
		                return value;
		            }
	
		            number = EMPTY;
	
		            for (idx = 0, length = pattern.length; idx < length; idx++) {
		                ch = pattern.charAt(idx);
	
		                if (ch === "n") {
		                    number += value;
		                } else if (ch === "$" || ch === "%") {
		                    number += symbol;
		                } else {
		                    number += ch;
		                }
		            }
	
		            return number;
		        }
	
		        //custom formatting
		        //
		        //separate format by sections.
	
		        if (format.indexOf("'") > -1 || format.indexOf("\"") > -1 || format.indexOf("\\") > -1) {
		            format = format.replace(literalRegExp, function (match) {
		                var quoteChar = match.charAt(0).replace("\\", ""),
		                    literal = match.slice(1).replace(quoteChar, "");
	
		                literals.push(literal);
	
		                return PLACEHOLDER;
		            });
		        }
	
		        format = format.split(";");
		        if (negative && format[1]) {
		            //get negative format
		            format = format[1];
		            hasNegativeFormat = true;
		        } else if (number === 0 && format[2]) {
		            //format for zeros
		            format = format[2];
		            if (format.indexOf(SHARP) == -1 && format.indexOf(ZERO) == -1) {
		                //return format if it is string constant.
		                return format;
		            }
		        } else {
		            format = format[0];
		        }
	
		        percentIndex = format.indexOf("%");
		        currencyIndex = format.indexOf("$");
	
		        isPercent = percentIndex != -1;
		        isCurrency = currencyIndex != -1;
	
		        //multiply number if the format has percent
		        if (isPercent) {
		            number *= 100;
		        }
	
		        if (isCurrency && format[currencyIndex - 1] === "\\") {
		            format = format.split("\\").join("");
		            isCurrency = false;
		        }
	
		        if (isCurrency || isPercent) {
		            //get specific number format information if format is currency or percent
		            numberFormat = isCurrency ? numberFormat.currency : numberFormat.percent;
		            decimal = numberFormat[POINT];
		            precision = numberFormat.decimals;
		            symbol = numberFormat.symbol;
		        }
	
		        hasGroup = format.indexOf(COMMA) > -1;
		        if (hasGroup) {
		            format = format.replace(commaRegExp, EMPTY);
		        }
	
		        decimalIndex = format.indexOf(POINT);
		        length = format.length;
	
		        if (decimalIndex != -1) {
		            fraction = number.toString().split("e");
		            if (fraction[1]) {
		                fraction = round(number, Math.abs(fraction[1]));
		            } else {
		                fraction = fraction[0];
		            }
		            fraction = fraction.split(POINT)[1] || EMPTY;
		            zeroIndex = format.lastIndexOf(ZERO) - decimalIndex;
		            sharpIndex = format.lastIndexOf(SHARP) - decimalIndex;
		            hasZero = zeroIndex > -1;
		            hasSharp = sharpIndex > -1;
		            idx = fraction.length;
	
		            if (!hasZero && !hasSharp) {
		                format = format.substring(0, decimalIndex) + format.substring(decimalIndex + 1);
		                length = format.length;
		                decimalIndex = -1;
		                idx = 0;
		            }
	
		            if (hasZero && zeroIndex > sharpIndex) {
		                idx = zeroIndex;
		            } else if (sharpIndex > zeroIndex) {
		                if (hasSharp && idx > sharpIndex) {
		                    var rounded = round(number, sharpIndex, negative);
	
		                    while (rounded.charAt(rounded.length - 1) === ZERO && sharpIndex > 0 && sharpIndex > zeroIndex) {
		                        sharpIndex--;
	
		                        rounded = round(number, sharpIndex, negative);
		                    }
	
		                    idx = sharpIndex;
		                } else if (hasZero && idx < zeroIndex) {
		                    idx = zeroIndex;
		                }
		            }
		        }
	
		        number = round(number, idx, negative);
	
		        sharpIndex = format.indexOf(SHARP);
		        startZeroIndex = zeroIndex = format.indexOf(ZERO);
	
		        //define the index of the first digit placeholder
		        if (sharpIndex == -1 && zeroIndex != -1) {
		            start = zeroIndex;
		        } else if (sharpIndex != -1 && zeroIndex == -1) {
		            start = sharpIndex;
		        } else {
		            start = sharpIndex > zeroIndex ? zeroIndex : sharpIndex;
		        }
	
		        sharpIndex = format.lastIndexOf(SHARP);
		        zeroIndex = format.lastIndexOf(ZERO);
	
		        //define the index of the last digit placeholder
		        if (sharpIndex == -1 && zeroIndex != -1) {
		            end = zeroIndex;
		        } else if (sharpIndex != -1 && zeroIndex == -1) {
		            end = sharpIndex;
		        } else {
		            end = sharpIndex > zeroIndex ? sharpIndex : zeroIndex;
		        }
	
		        if (start == length) {
		            end = start;
		        }
	
		        if (start != -1) {
		            value = number.toString().split(POINT);
		            integer = value[0];
		            fraction = value[1] || EMPTY;
	
		            integerLength = integer.length;
		            fractionLength = fraction.length;
	
		            if (negative && (number * -1) >= 0) {
		                negative = false;
		            }
	
		            number = format.substring(0, start);
	
		            if (negative && !hasNegativeFormat) {
		                number += "-";
		            }
	
		            for (idx = start; idx < length; idx++) {
		                ch = format.charAt(idx);
	
		                if (decimalIndex == -1) {
		                    if (end - idx < integerLength) {
		                        number += integer;
		                        break;
		                    }
		                } else {
		                    if (zeroIndex != -1 && zeroIndex < idx) {
		                        replacement = EMPTY;
		                    }
	
		                    if ((decimalIndex - idx) <= integerLength && decimalIndex - idx > -1) {
		                        number += integer;
		                        idx = decimalIndex;
		                    }
	
		                    if (decimalIndex === idx) {
		                        number += (fraction ? decimal : EMPTY) + fraction;
		                        idx += end - decimalIndex + 1;
		                        continue;
		                    }
		                }
	
		                if (ch === ZERO) {
		                    number += ch;
		                    replacement = ch;
		                } else if (ch === SHARP) {
		                    number += replacement;
		                }
		            }
	
		            if (hasGroup) {
		                number = groupInteger(number, start + (negative && !hasNegativeFormat ? 1 : 0), Math.max(end, (integerLength + start)), numberFormat);
		            }
	
		            if (end >= start) {
		                number += format.substring(end + 1);
		            }
	
		            //replace symbol placeholders
		            if (isCurrency || isPercent) {
		                value = EMPTY;
		                for (idx = 0, length = number.length; idx < length; idx++) {
		                    ch = number.charAt(idx);
		                    value += (ch === "$" || ch === "%") ? symbol : ch;
		                }
		                number = value;
		            }
	
		            length = literals.length;
	
		            if (length) {
		                for (idx = 0; idx < length; idx++) {
		                    number = number.replace(PLACEHOLDER, literals[idx]);
		                }
		            }
		        }
	
		        return number;
		    }
	
		    var groupInteger = function(number, start, end, numberFormat) {
		        var decimalIndex = number.indexOf(numberFormat[POINT]);
		        var groupSizes = numberFormat.groupSize.slice();
		        var groupSize = groupSizes.shift();
		        var integer, integerLength;
		        var idx, parts, value;
		        var newGroupSize;
	
		        end = decimalIndex !== -1 ? decimalIndex : end + 1;
	
		        integer = number.substring(start, end);
		        integerLength = integer.length;
	
		        if (integerLength >= groupSize) {
		            idx = integerLength;
		            parts = [];
	
		            while (idx > -1) {
		                value = integer.substring(idx - groupSize, idx);
		                if (value) {
		                    parts.push(value);
		                }
		                idx -= groupSize;
		                newGroupSize = groupSizes.shift();
		                groupSize = newGroupSize !== undefined ? newGroupSize : groupSize;
	
		                if (groupSize === 0) {
		                    if (idx > 0) {
		                        parts.push(integer.substring(0, idx));
		                    }
		                    break;
		                }
		            }
	
		            integer = parts.reverse().join(numberFormat[COMMA]);
		            number = number.substring(0, start) + integer + number.substring(end);
		        }
	
		        return number;
		    };
	
		    var round = function(value, precision, negative) {
		        precision = precision || 0;
	
		        value = value.toString().split('e');
		        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + precision) : precision)));
	
		        if (negative) {
		            value = -value;
		        }
	
		        value = value.toString().split('e');
		        value = +(value[0] + 'e' + (value[1] ? (+value[1] - precision) : -precision));
	
		        return value.toFixed(Math.min(precision, 20));
		    };
	
		    var toString = function(value, fmt, culture) {
		        if (fmt) {
		            if (objectToString.call(value) === "[object Date]") {
		                return formatDate(value, fmt, culture);
		            } else if (typeof value === NUMBER) {
		                return formatNumber(value, fmt, culture);
		            }
		        }
	
		        return value !== undefined ? value : "";
		    };
	
		    kendo.format = function(fmt) {
		        var values = arguments;
	
		        return fmt.replace(formatRegExp, function(match, index, placeholderFormat) {
		            var value = values[parseInt(index, 10) + 1];
	
		            return toString(value, placeholderFormat ? placeholderFormat.substring(1) : "");
		        });
		    };
	
		    kendo._extractFormat = function (format) {
		        if (format.slice(0,3) === "{0:") {
		            format = format.slice(3, format.length - 1);
		        }
	
		        return format;
		    };
	
		    kendo._activeElement = function() {
		        try {
		            return document.activeElement;
		        } catch(e) {
		            return document.documentElement.activeElement;
		        }
		    };
	
		    kendo._round = round;
		    kendo._outerWidth = function (element, includeMargin) { return $(element).outerWidth(includeMargin || false) || 0; };
		    kendo._outerHeight = function (element, includeMargin) { return $(element).outerHeight(includeMargin || false) || 0; };
		    kendo.toString = toString;
		})();
	
	
		(function() {
		    var nonBreakingSpaceRegExp = /\u00A0/g,
		        exponentRegExp = /[eE][\-+]?[0-9]+/,
		        shortTimeZoneRegExp = /[+|\-]\d{1,2}/,
		        longTimeZoneRegExp = /[+|\-]\d{1,2}:?\d{2}/,
		        dateRegExp = /^\/Date\((.*?)\)\/$/,
		        offsetRegExp = /[+-]\d*/,
		        FORMATS_SEQUENCE = [ [], [ "G", "g", "F" ], [ "D", "d", "y", "m", "T", "t" ] ],
		        STANDARD_FORMATS = [
		            [
		            "yyyy-MM-ddTHH:mm:ss.fffffffzzz",
		            "yyyy-MM-ddTHH:mm:ss.fffffff",
		            "yyyy-MM-ddTHH:mm:ss.fffzzz",
		            "yyyy-MM-ddTHH:mm:ss.fff",
		            "ddd MMM dd yyyy HH:mm:ss",
		            "yyyy-MM-ddTHH:mm:sszzz",
		            "yyyy-MM-ddTHH:mmzzz",
		            "yyyy-MM-ddTHH:mmzz",
		            "yyyy-MM-ddTHH:mm:ss",
		            "yyyy-MM-dd HH:mm:ss",
		            "yyyy/MM/dd HH:mm:ss"
		            ], [
		            "yyyy-MM-ddTHH:mm",
		            "yyyy-MM-dd HH:mm",
		            "yyyy/MM/dd HH:mm"
		            ], [
		            "yyyy/MM/dd",
		            "yyyy-MM-dd",
		            "HH:mm:ss",
		            "HH:mm"
		            ]
		        ],
		        numberRegExp = {
		            2: /^\d{1,2}/,
		            3: /^\d{1,3}/,
		            4: /^\d{4}/
		        },
		        objectToString = {}.toString;
	
		    function outOfRange(value, start, end) {
		        return !(value >= start && value <= end);
		    }
	
		    function designatorPredicate(designator) {
		        return designator.charAt(0);
		    }
	
		    function mapDesignators(designators) {
		        return $.map(designators, designatorPredicate);
		    }
	
		    //if date's day is different than the typed one - adjust
		    function adjustDST(date, hours) {
		        if (!hours && date.getHours() === 23) {
		            date.setHours(date.getHours() + 2);
		        }
		    }
	
		    function lowerArray(data) {
		        var idx = 0,
		            length = data.length,
		            array = [];
	
		        for (; idx < length; idx++) {
		            array[idx] = (data[idx] + "").toLowerCase();
		        }
	
		        return array;
		    }
	
		    function lowerLocalInfo(localInfo) {
		        var newLocalInfo = {}, property;
	
		        for (property in localInfo) {
		            newLocalInfo[property] = lowerArray(localInfo[property]);
		        }
	
		        return newLocalInfo;
		    }
	
		    function parseExact(value, format, culture, strict) {
		        if (!value) {
		            return null;
		        }
	
		        var lookAhead = function (match) {
		                var i = 0;
		                while (format[idx] === match) {
		                    i++;
		                    idx++;
		                }
		                if (i > 0) {
		                    idx -= 1;
		                }
		                return i;
		            },
		            getNumber = function(size) {
		                var rg = numberRegExp[size] || new RegExp('^\\d{1,' + size + '}'),
		                    match = value.substr(valueIdx, size).match(rg);
	
		                if (match) {
		                    match = match[0];
		                    valueIdx += match.length;
		                    return parseInt(match, 10);
		                }
		                return null;
		            },
		            getIndexByName = function (names, lower) {
		                var i = 0,
		                    length = names.length,
		                    name, nameLength,
		                    matchLength = 0,
		                    matchIdx = 0,
		                    subValue;
	
		                for (; i < length; i++) {
		                    name = names[i];
		                    nameLength = name.length;
		                    subValue = value.substr(valueIdx, nameLength);
	
		                    if (lower) {
		                        subValue = subValue.toLowerCase();
		                    }
	
		                    if (subValue == name && nameLength > matchLength) {
		                        matchLength = nameLength;
		                        matchIdx = i;
		                    }
		                }
	
		                if (matchLength) {
		                    valueIdx += matchLength;
		                    return matchIdx + 1;
		                }
	
		                return null;
		            },
		            checkLiteral = function() {
		                var result = false;
		                if (value.charAt(valueIdx) === format[idx]) {
		                    valueIdx++;
		                    result = true;
		                }
		                return result;
		            },
		            calendar = culture.calendars.standard,
		            year = null,
		            month = null,
		            day = null,
		            hours = null,
		            minutes = null,
		            seconds = null,
		            milliseconds = null,
		            idx = 0,
		            valueIdx = 0,
		            literal = false,
		            date = new Date(),
		            twoDigitYearMax = calendar.twoDigitYearMax || 2029,
		            defaultYear = date.getFullYear(),
		            ch, count, length, pattern,
		            pmHour, UTC, matches,
		            amDesignators, pmDesignators,
		            hoursOffset, minutesOffset,
		            hasTime, match;
	
		        if (!format) {
		            format = "d"; //shord date format
		        }
	
		        //if format is part of the patterns get real format
		        pattern = calendar.patterns[format];
		        if (pattern) {
		            format = pattern;
		        }
	
		        format = format.split("");
		        length = format.length;
	
		        for (; idx < length; idx++) {
		            ch = format[idx];
	
		            if (literal) {
		                if (ch === "'") {
		                    literal = false;
		                } else {
		                    checkLiteral();
		                }
		            } else {
		                if (ch === "d") {
		                    count = lookAhead("d");
		                    if (!calendar._lowerDays) {
		                        calendar._lowerDays = lowerLocalInfo(calendar.days);
		                    }
	
		                    if (day !== null && count > 2) {
		                        continue;
		                    }
	
		                    day = count < 3 ? getNumber(2) : getIndexByName(calendar._lowerDays[count == 3 ? "namesAbbr" : "names"], true);
	
		                    if (day === null || outOfRange(day, 1, 31)) {
		                        return null;
		                    }
		                } else if (ch === "M") {
		                    count = lookAhead("M");
		                    if (!calendar._lowerMonths) {
		                        calendar._lowerMonths = lowerLocalInfo(calendar.months);
		                    }
		                    month = count < 3 ? getNumber(2) : getIndexByName(calendar._lowerMonths[count == 3 ? 'namesAbbr' : 'names'], true);
	
		                    if (month === null || outOfRange(month, 1, 12)) {
		                        return null;
		                    }
		                    month -= 1; //because month is zero based
		                } else if (ch === "y") {
		                    count = lookAhead("y");
		                    year = getNumber(count);
	
		                    if (year === null) {
		                        return null;
		                    }
	
		                    if (count == 2) {
		                        if (typeof twoDigitYearMax === "string") {
		                            twoDigitYearMax = defaultYear + parseInt(twoDigitYearMax, 10);
		                        }
	
		                        year = (defaultYear - defaultYear % 100) + year;
		                        if (year > twoDigitYearMax) {
		                            year -= 100;
		                        }
		                    }
		                } else if (ch === "h" ) {
		                    lookAhead("h");
		                    hours = getNumber(2);
		                    if (hours == 12) {
		                        hours = 0;
		                    }
		                    if (hours === null || outOfRange(hours, 0, 11)) {
		                        return null;
		                    }
		                } else if (ch === "H") {
		                    lookAhead("H");
		                    hours = getNumber(2);
		                    if (hours === null || outOfRange(hours, 0, 23)) {
		                        return null;
		                    }
		                } else if (ch === "m") {
		                    lookAhead("m");
		                    minutes = getNumber(2);
		                    if (minutes === null || outOfRange(minutes, 0, 59)) {
		                        return null;
		                    }
		                } else if (ch === "s") {
		                    lookAhead("s");
		                    seconds = getNumber(2);
		                    if (seconds === null || outOfRange(seconds, 0, 59)) {
		                        return null;
		                    }
		                } else if (ch === "f") {
		                    count = lookAhead("f");
	
		                    match = value.substr(valueIdx, count).match(numberRegExp[3]);
		                    milliseconds = getNumber(count); //move value index position
	
		                    if (milliseconds !== null) {
		                        milliseconds = parseFloat("0." + match[0], 10);
		                        milliseconds = kendo._round(milliseconds, 3);
		                        milliseconds *= 1000;
		                    }
	
		                    if (milliseconds === null || outOfRange(milliseconds, 0, 999)) {
		                        return null;
		                    }
	
		                } else if (ch === "t") {
		                    count = lookAhead("t");
		                    amDesignators = calendar.AM;
		                    pmDesignators = calendar.PM;
	
		                    if (count === 1) {
		                        amDesignators = mapDesignators(amDesignators);
		                        pmDesignators = mapDesignators(pmDesignators);
		                    }
	
		                    pmHour = getIndexByName(pmDesignators);
		                    if (!pmHour && !getIndexByName(amDesignators)) {
		                        return null;
		                    }
		                }
		                else if (ch === "z") {
		                    UTC = true;
		                    count = lookAhead("z");
	
		                    if (value.substr(valueIdx, 1) === "Z") {
		                        checkLiteral();
		                        continue;
		                    }
	
		                    matches = value.substr(valueIdx, 6)
		                                   .match(count > 2 ? longTimeZoneRegExp : shortTimeZoneRegExp);
	
		                    if (!matches) {
		                        return null;
		                    }
	
		                    matches = matches[0].split(":");
	
		                    hoursOffset = matches[0];
		                    minutesOffset = matches[1];
	
		                    if (!minutesOffset && hoursOffset.length > 3) { //(+|-)[hh][mm] format is used
		                        valueIdx = hoursOffset.length - 2;
		                        minutesOffset = hoursOffset.substring(valueIdx);
		                        hoursOffset = hoursOffset.substring(0, valueIdx);
		                    }
	
		                    hoursOffset = parseInt(hoursOffset, 10);
		                    if (outOfRange(hoursOffset, -12, 13)) {
		                        return null;
		                    }
	
		                    if (count > 2) {
		                        minutesOffset = matches[0][0] + minutesOffset;
		                        minutesOffset = parseInt(minutesOffset, 10);
		                        if (isNaN(minutesOffset) || outOfRange(minutesOffset, -59, 59)) {
		                            return null;
		                        }
		                    }
		                } else if (ch === "'") {
		                    literal = true;
		                    checkLiteral();
		                } else if (!checkLiteral()) {
		                    return null;
		                }
		            }
		        }
	
		        // if more characters follow, assume wrong format
		        // https://github.com/telerik/kendo-ui-core/issues/3476
		        if (strict && !/^\s*$/.test(value.substr(valueIdx))) {
		            return null;
		        }
	
		        hasTime = hours !== null || minutes !== null || seconds || null;
	
		        if (year === null && month === null && day === null && hasTime) {
		            year = defaultYear;
		            month = date.getMonth();
		            day = date.getDate();
		        } else {
		            if (year === null) {
		                year = defaultYear;
		            }
	
		            if (day === null) {
		                day = 1;
		            }
		        }
	
		        if (pmHour && hours < 12) {
		            hours += 12;
		        }
	
		        if (UTC) {
		            if (hoursOffset) {
		                hours += -hoursOffset;
		            }
	
		            if (minutesOffset) {
		                minutes += -minutesOffset;
		            }
	
		            value = new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
		        } else {
		            value = new Date(year, month, day, hours, minutes, seconds, milliseconds);
		            adjustDST(value, hours);
		        }
	
		        if (year < 100) {
		            value.setFullYear(year);
		        }
	
		        if (value.getDate() !== day && UTC === undefined) {
		            return null;
		        }
	
		        return value;
		    }
	
		    function parseMicrosoftFormatOffset(offset) {
		        var sign = offset.substr(0, 1) === "-" ? -1 : 1;
	
		        offset = offset.substring(1);
		        offset = (parseInt(offset.substr(0, 2), 10) * 60) + parseInt(offset.substring(2), 10);
	
		        return sign * offset;
		    }
	
		    function getDefaultFormats(culture) {
		        var length = math.max(FORMATS_SEQUENCE.length, STANDARD_FORMATS.length);
		        var calendar = culture.calendar || culture.calendars.standard;
		        var patterns = calendar.patterns;
		        var cultureFormats, formatIdx, idx;
		        var formats = [];
	
		        for (idx = 0; idx < length; idx++) {
		            cultureFormats = FORMATS_SEQUENCE[idx];
		            for (formatIdx = 0; formatIdx < cultureFormats.length; formatIdx++) {
		                formats.push(patterns[cultureFormats[formatIdx]]);
		            }
		            formats = formats.concat(STANDARD_FORMATS[idx]);
		        }
	
		        return formats;
		    }
	
		    function internalParseDate(value, formats, culture, strict) {
		        if (objectToString.call(value) === "[object Date]") {
		            return value;
		        }
	
		        var idx = 0;
		        var date = null;
		        var length;
		        var tzoffset;
	
		        if (value && value.indexOf("/D") === 0) {
		            date = dateRegExp.exec(value);
		            if (date) {
		                date = date[1];
		                tzoffset = offsetRegExp.exec(date.substring(1));
	
		                date = new Date(parseInt(date, 10));
	
		                if (tzoffset) {
		                    tzoffset = parseMicrosoftFormatOffset(tzoffset[0]);
		                    date = kendo.timezone.apply(date, 0);
		                    date = kendo.timezone.convert(date, 0, -1 * tzoffset);
		                }
	
		                return date;
		            }
		        }
	
		        culture = kendo.getCulture(culture);
	
		        if (!formats) {
		            formats = getDefaultFormats(culture);
		        }
	
		        formats = isArray(formats) ? formats: [formats];
		        length = formats.length;
	
		        for (; idx < length; idx++) {
		            date = parseExact(value, formats[idx], culture, strict);
		            if (date) {
		                return date;
		            }
		        }
	
		        return date;
		    }
	
		    kendo.parseDate = function(value, formats, culture) {
		        return internalParseDate(value, formats, culture, false);
		    };
	
		    kendo.parseExactDate = function(value, formats, culture) {
		        return internalParseDate(value, formats, culture, true);
		    };
	
		    kendo.parseInt = function(value, culture) {
		        var result = kendo.parseFloat(value, culture);
		        if (result) {
		            result = result | 0;
		        }
		        return result;
		    };
	
		    kendo.parseFloat = function(value, culture, format) {
		        if (!value && value !== 0) {
		           return null;
		        }
	
		        if (typeof value === NUMBER) {
		           return value;
		        }
	
		        value = value.toString();
		        culture = kendo.getCulture(culture);
	
		        var number = culture.numberFormat,
		            percent = number.percent,
		            currency = number.currency,
		            symbol = currency.symbol,
		            percentSymbol = percent.symbol,
		            negative = value.indexOf("-"),
		            parts, isPercent;
	
		        //handle exponential number
		        if (exponentRegExp.test(value)) {
		            value = parseFloat(value.replace(number["."], "."));
		            if (isNaN(value)) {
		                value = null;
		            }
		            return value;
		        }
	
		        if (negative > 0) {
		            return null;
		        } else {
		            negative = negative > -1;
		        }
	
		        if (value.indexOf(symbol) > -1 || (format && format.toLowerCase().indexOf("c") > -1)) {
		            number = currency;
		            parts = number.pattern[0].replace("$", symbol).split("n");
		            if (value.indexOf(parts[0]) > -1 && value.indexOf(parts[1]) > -1) {
		                value = value.replace(parts[0], "").replace(parts[1], "");
		                negative = true;
		            }
		        } else if (value.indexOf(percentSymbol) > -1) {
		            isPercent = true;
		            number = percent;
		            symbol = percentSymbol;
		        }
	
		        value = value.replace("-", "")
		                     .replace(symbol, "")
		                     .replace(nonBreakingSpaceRegExp, " ")
		                     .split(number[","].replace(nonBreakingSpaceRegExp, " ")).join("")
		                     .replace(number["."], ".");
	
		        value = parseFloat(value);
	
		        if (isNaN(value)) {
		            value = null;
		        } else if (negative) {
		            value *= -1;
		        }
	
		        if (value && isPercent) {
		            value /= 100;
		        }
	
		        return value;
		    };
		})();
	
		    function getShadows(element) {
		        var shadow = element.css(kendo.support.transitions.css + "box-shadow") || element.css("box-shadow"),
		            radius = shadow ? shadow.match(boxShadowRegExp) || [ 0, 0, 0, 0, 0 ] : [ 0, 0, 0, 0, 0 ],
		            blur = math.max((+radius[3]), +(radius[4] || 0));
	
		        return {
		            left: (-radius[1]) + blur,
		            right: (+radius[1]) + blur,
		            bottom: (+radius[2]) + blur
		        };
		    }
	
		    function wrap(element, autosize) {
		        var browser = support.browser,
		            percentage,
		            outerWidth = kendo._outerWidth,
		            outerHeight = kendo._outerHeight;
	
		        if (!element.parent().hasClass("k-animation-container")) {
		            var width = element[0].style.width,
		                height = element[0].style.height,
		                percentWidth = percentRegExp.test(width),
		                percentHeight = percentRegExp.test(height);
	
		            percentage = percentWidth || percentHeight;
	
		            if (!percentWidth && (!autosize || (autosize && width) || element.hasClass("k-tooltip"))) { width = autosize ? outerWidth(element) + 1 : outerWidth(element); }
		            if (!percentHeight && (!autosize || (autosize && height))) { height = outerHeight(element); }
	
		            element.wrap(
		                         $("<div/>")
		                         .addClass("k-animation-container")
		                         .css({
		                             width: width,
		                             height: height
		                         }));
	
		            if (percentage) {
		                element.css({
		                    width: "100%",
		                    height: "100%",
		                    boxSizing: "border-box",
		                    mozBoxSizing: "border-box",
		                    webkitBoxSizing: "border-box"
		                });
		            }
		        } else {
		            var wrapper = element.parent(".k-animation-container"),
		                wrapperStyle = wrapper[0].style;
	
		            if (wrapper.is(":hidden")) {
		                wrapper.css({
		                    display: "",
		                    position: ""
		                });
		            }
	
		            percentage = percentRegExp.test(wrapperStyle.width) || percentRegExp.test(wrapperStyle.height);
	
		            if (!percentage) {
		                wrapper.css({
		                    width: autosize ? outerWidth(element) + 1 : outerWidth(element),
		                    height: outerHeight(element),
		                    boxSizing: "content-box",
		                    mozBoxSizing: "content-box",
		                    webkitBoxSizing: "content-box"
		                });
		            }
		        }
	
		        if (browser.msie && math.floor(browser.version) <= 7) {
		            element.css({ zoom: 1 });
		            element.children(".k-menu").width(element.width());
		        }
	
		        return element.parent();
		    }
	
		    function deepExtend(destination) {
		        var i = 1,
		            length = arguments.length;
	
		        for (i = 1; i < length; i++) {
		            deepExtendOne(destination, arguments[i]);
		        }
	
		        return destination;
		    }
	
		    function deepExtendOne(destination, source) {
		        var ObservableArray = kendo.data.ObservableArray,
		            LazyObservableArray = kendo.data.LazyObservableArray,
		            DataSource = kendo.data.DataSource,
		            HierarchicalDataSource = kendo.data.HierarchicalDataSource,
		            property,
		            propValue,
		            propType,
		            propInit,
		            destProp;
	
		        for (property in source) {
		            propValue = source[property];
		            propType = typeof propValue;
	
		            if (propType === OBJECT && propValue !== null) {
		                propInit = propValue.constructor;
		            } else {
		                propInit = null;
		            }
	
		            if (propInit &&
		                propInit !== Array && propInit !== ObservableArray && propInit !== LazyObservableArray &&
		                propInit !== DataSource && propInit !== HierarchicalDataSource && propInit !== RegExp) {
	
		                if (propValue instanceof Date) {
		                    destination[property] = new Date(propValue.getTime());
		                } else if (isFunction(propValue.clone)) {
		                    destination[property] = propValue.clone();
		                } else {
		                    destProp = destination[property];
		                    if (typeof (destProp) === OBJECT) {
		                        destination[property] = destProp || {};
		                    } else {
		                        destination[property] = {};
		                    }
		                    deepExtendOne(destination[property], propValue);
		                }
		            } else if (propType !== UNDEFINED) {
		                destination[property] = propValue;
		            }
		        }
	
		        return destination;
		    }
	
		    function testRx(agent, rxs, dflt) {
		        for (var rx in rxs) {
		            if (rxs.hasOwnProperty(rx) && rxs[rx].test(agent)) {
		                return rx;
		            }
		        }
		        return dflt !== undefined ? dflt : agent;
		    }
	
		    function toHyphens(str) {
		        return str.replace(/([a-z][A-Z])/g, function (g) {
		            return g.charAt(0) + '-' + g.charAt(1).toLowerCase();
		        });
		    }
	
		    function toCamelCase(str) {
		        return str.replace(/\-(\w)/g, function (strMatch, g1) {
		            return g1.toUpperCase();
		        });
		    }
	
		    function getComputedStyles(element, properties) {
		        var styles = {}, computedStyle;
	
		        if (document.defaultView && document.defaultView.getComputedStyle) {
		            computedStyle = document.defaultView.getComputedStyle(element, "");
	
		            if (properties) {
		                $.each(properties, function(idx, value) {
		                    styles[value] = computedStyle.getPropertyValue(value);
		                });
		            }
		        } else {
		            computedStyle = element.currentStyle;
	
		            if (properties) {
		                $.each(properties, function(idx, value) {
		                    styles[value] = computedStyle[toCamelCase(value)];
		                });
		            }
		        }
	
		        if (!kendo.size(styles)) {
		            styles = computedStyle;
		        }
	
		        return styles;
		    }
	
		    function isScrollable(element) {
		        if (element && element.className && typeof(element.className) === "string" && element.className.indexOf("k-auto-scrollable") > -1) {
		            return true;
		        }
	
		        var overflow = getComputedStyles(element, ["overflow"]).overflow;
		        return overflow == "auto" || overflow == "scroll";
		    }
	
		    function scrollLeft(element, value) {
		        var webkit = support.browser.webkit;
		        var mozila = support.browser.mozilla;
		        var el = element instanceof $ ? element[0] : element;
		        var isRtl;
	
		        if (!element) {
		            return;
		        }
	
		        isRtl = support.isRtl(element);
	
		        if (value !== undefined) {
		            if (isRtl && webkit) {
		                el.scrollLeft = el.scrollWidth - el.clientWidth - value;
		            } else if (isRtl && mozila) {
		                el.scrollLeft = -value;
		            } else {
		                el.scrollLeft = value;
		            }
		        } else {
		            if (isRtl && webkit) {
		                return el.scrollWidth - el.clientWidth - el.scrollLeft;
		            } else {
		                return Math.abs(el.scrollLeft);
		            }
		        }
		    }
	
		    (function () {
		        support._scrollbar = undefined;
	
		        support.scrollbar = function (refresh) {
		            if (!isNaN(support._scrollbar) && !refresh) {
		                return support._scrollbar;
		            } else {
		                var div = document.createElement("div"),
		                    result;
	
		                div.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block";
		                div.innerHTML = "&nbsp;";
		                document.body.appendChild(div);
	
		                support._scrollbar = result = div.offsetWidth - div.scrollWidth;
	
		                document.body.removeChild(div);
	
		                return result;
		            }
		        };
	
		        support.isRtl = function(element) {
		            return $(element).closest(".k-rtl").length > 0;
		        };
	
		        var table = document.createElement("table");
	
		        // Internet Explorer does not support setting the innerHTML of TBODY and TABLE elements
		        try {
		            table.innerHTML = "<tr><td></td></tr>";
	
		            support.tbodyInnerHtml = true;
		        } catch (e) {
		            support.tbodyInnerHtml = false;
		        }
	
		        support.touch = "ontouchstart" in window;
	
		        var docStyle = document.documentElement.style;
		        var transitions = support.transitions = false,
		            transforms = support.transforms = false,
		            elementProto = "HTMLElement" in window ? HTMLElement.prototype : [];
	
		        support.hasHW3D = ("WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix()) || "MozPerspective" in docStyle || "msPerspective" in docStyle;
		        support.cssFlexbox = ("flexWrap" in docStyle) || ("WebkitFlexWrap" in docStyle) || ("msFlexWrap" in docStyle);
	
		        each([ "Moz", "webkit", "O", "ms" ], function () {
		            var prefix = this.toString(),
		                hasTransitions = typeof table.style[prefix + "Transition"] === STRING;
	
		            if (hasTransitions || typeof table.style[prefix + "Transform"] === STRING) {
		                var lowPrefix = prefix.toLowerCase();
	
		                transforms = {
		                    css: (lowPrefix != "ms") ? "-" + lowPrefix + "-" : "",
		                    prefix: prefix,
		                    event: (lowPrefix === "o" || lowPrefix === "webkit") ? lowPrefix : ""
		                };
	
		                if (hasTransitions) {
		                    transitions = transforms;
		                    transitions.event = transitions.event ? transitions.event + "TransitionEnd" : "transitionend";
		                }
	
		                return false;
		            }
		        });
	
		        table = null;
	
		        support.transforms = transforms;
		        support.transitions = transitions;
	
		        support.devicePixelRatio = window.devicePixelRatio === undefined ? 1 : window.devicePixelRatio;
	
		        try {
		            support.screenWidth = window.outerWidth || window.screen ? window.screen.availWidth : window.innerWidth;
		            support.screenHeight = window.outerHeight || window.screen ? window.screen.availHeight : window.innerHeight;
		        } catch(e) {
		            //window.outerWidth throws error when in IE showModalDialog.
		            support.screenWidth = window.screen.availWidth;
		            support.screenHeight = window.screen.availHeight;
		        }
	
		        support.detectOS = function (ua) {
		            var os = false, minorVersion, match = [],
		                notAndroidPhone = !/mobile safari/i.test(ua),
		                agentRxs = {
		                    wp: /(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,
		                    fire: /(Silk)\/(\d+)\.(\d+(\.\d+)?)/,
		                    android: /(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.?(\d+(\.\d+)?)?/,
		                    iphone: /(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,
		                    ipad: /(iPad).*OS\s+(\d+)[\._]([\d_]+)/,
		                    meego: /(MeeGo).+NokiaBrowser\/(\d+)\.([\d\._]+)/,
		                    webos: /(webOS)\/(\d+)\.(\d+(\.\d+)?)/,
		                    blackberry: /(BlackBerry|BB10).*?Version\/(\d+)\.(\d+(\.\d+)?)/,
		                    playbook: /(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,
		                    windows: /(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,
		                    tizen: /(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,
		                    sailfish: /(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i,
		                    ffos: /(Mobile).*rv:(\d+)\.(\d+(\.\d+)?).*Firefox/
		                },
		                osRxs = {
		                    ios: /^i(phone|pad|pod)$/i,
		                    android: /^android|fire$/i,
		                    blackberry: /^blackberry|playbook/i,
		                    windows: /windows/,
		                    wp: /wp/,
		                    flat: /sailfish|ffos|tizen/i,
		                    meego: /meego/
		                },
		                formFactorRxs = {
		                    tablet: /playbook|ipad|fire/i
		                },
		                browserRxs = {
		                    omini: /Opera\sMini/i,
		                    omobile: /Opera\sMobi/i,
		                    firefox: /Firefox|Fennec/i,
		                    mobilesafari: /version\/.*safari/i,
		                    ie: /MSIE|Windows\sPhone/i,
		                    chrome: /chrome|crios/i,
		                    webkit: /webkit/i
		                };
	
		            for (var agent in agentRxs) {
		                if (agentRxs.hasOwnProperty(agent)) {
		                    match = ua.match(agentRxs[agent]);
		                    if (match) {
		                        if (agent == "windows" && "plugins" in navigator) { return false; } // Break if not Metro/Mobile Windows
	
		                        os = {};
		                        os.device = agent;
		                        os.tablet = testRx(agent, formFactorRxs, false);
		                        os.browser = testRx(ua, browserRxs, "default");
		                        os.name = testRx(agent, osRxs);
		                        os[os.name] = true;
		                        os.majorVersion = match[2];
		                        os.minorVersion = (match[3] || "0").replace("_", ".");
		                        minorVersion = os.minorVersion.replace(".", "").substr(0, 2);
		                        os.flatVersion = os.majorVersion + minorVersion + (new Array(3 - (minorVersion.length < 3 ? minorVersion.length : 2)).join("0"));
		                        os.cordova = typeof window.PhoneGap !== UNDEFINED || typeof window.cordova !== UNDEFINED; // Use file protocol to detect appModes.
		                        os.appMode = window.navigator.standalone || (/file|local|wmapp/).test(window.location.protocol) || os.cordova; // Use file protocol to detect appModes.
	
		                        if (os.android && (support.devicePixelRatio < 1.5 && os.flatVersion < 400 || notAndroidPhone) && (support.screenWidth > 800 || support.screenHeight > 800)) {
		                            os.tablet = agent;
		                        }
	
		                        break;
		                    }
		                }
		            }
		            return os;
		        };
	
		        var mobileOS = support.mobileOS = support.detectOS(navigator.userAgent);
	
		        support.wpDevicePixelRatio = mobileOS.wp ? screen.width / 320 : 0;
	
		        support.hasNativeScrolling = false;
	
		        if (mobileOS.ios || (mobileOS.android && mobileOS.majorVersion > 2) || mobileOS.wp) {
		            support.hasNativeScrolling = mobileOS;
		        }
	
		        support.delayedClick = function() {
	
		            // only the mobile devices with touch events do this.
		            if (support.touch) {
		                // All iOS devices so far (by the time I am writing this, iOS 9.0.2 is the latest),
		                // delay their click events.
		                if (mobileOS.ios) {
		                    return true;
		                }
	
		                if (mobileOS.android) {
	
		                    if (!support.browser.chrome) { // older webkits and webviews delay the click
		                        return true;
		                    }
	
		                    // from here on, we deal with Chrome on Android.
		                    if (support.browser.version < 32) {
		                        return false;
		                    }
	
		                    // Chrome 32+ does conditional fast clicks if the view port is not user scalable.
		                    return !($("meta[name=viewport]").attr("content") || "").match(/user-scalable=no/i);
		                }
		            }
	
		            return false;
		        };
	
		        support.mouseAndTouchPresent = support.touch && !(support.mobileOS.ios || support.mobileOS.android);
	
		        support.detectBrowser = function(ua) {
		            var browser = false, match = [],
		                browserRxs = {
		                    edge: /(edge)[ \/]([\w.]+)/i,
		                    webkit: /(chrome|crios)[ \/]([\w.]+)/i,
		                    safari: /(webkit)[ \/]([\w.]+)/i,
		                    opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
		                    msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
		                    mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
		                };
	
		            for (var agent in browserRxs) {
		                if (browserRxs.hasOwnProperty(agent)) {
		                    match = ua.match(browserRxs[agent]);
		                    if (match) {
		                        browser = {};
		                        browser[agent] = true;
		                        browser[match[1].toLowerCase().split(" ")[0].split("/")[0]] = true;
		                        browser.version = parseInt(document.documentMode || match[2], 10);
	
		                        break;
		                    }
		                }
		            }
	
		            return browser;
		        };
	
		        support.browser = support.detectBrowser(navigator.userAgent);
	
		        support.detectClipboardAccess = function() {
		            var commands = {
		                copy: document.queryCommandSupported ? document.queryCommandSupported("copy") : false,
		                cut: document.queryCommandSupported ? document.queryCommandSupported("cut") : false,
		                paste : document.queryCommandSupported ? document.queryCommandSupported("paste") : false
		            };
	
		            if (support.browser.chrome) {
		                //not using queryCommandSupported due to chromium issues 476508 and 542948
		                commands.paste = false;
		                if(support.browser.version >= 43) {
		                    commands.copy = true;
		                    commands.cut = true;
		                }
		            }
	
		            return commands;
		        };
	
		        support.clipboard = support.detectClipboardAccess();
	
		        support.zoomLevel = function() {
		            try {
		                var browser = support.browser;
		                var ie11WidthCorrection = 0;
		                var docEl = document.documentElement;
	
		                if (browser.msie && browser.version == 11 && docEl.scrollHeight > docEl.clientHeight && !support.touch) {
		                    ie11WidthCorrection = support.scrollbar();
		                }
	
		                return support.touch ? (docEl.clientWidth / window.innerWidth) :
		                       browser.msie && browser.version >= 10 ? (((top || window).document.documentElement.offsetWidth + ie11WidthCorrection) / (top || window).innerWidth) : 1;
		            } catch(e) {
		                return 1;
		            }
		        };
	
		        support.cssBorderSpacing = typeof docStyle.borderSpacing != "undefined" && !(support.browser.msie && support.browser.version < 8);
	
		        (function(browser) {
		            // add browser-specific CSS class
		            var cssClass = "",
		                docElement = $(document.documentElement),
		                majorVersion = parseInt(browser.version, 10);
	
		            if (browser.msie) {
		                cssClass = "ie";
		            } else if (browser.mozilla) {
		                cssClass = "ff";
		            } else if (browser.safari) {
		                cssClass = "safari";
		            } else if (browser.webkit) {
		                cssClass = "webkit";
		            } else if (browser.opera) {
		                cssClass = "opera";
		            } else if (browser.edge) {
		                cssClass = "edge";
		            }
	
		            if (cssClass) {
		                cssClass = "k-" + cssClass + " k-" + cssClass + majorVersion;
		            }
		            if (support.mobileOS) {
		                cssClass += " k-mobile";
		            }
	
		            if (!support.cssFlexbox) {
		                cssClass += " k-no-flexbox";
		            }
	
		            docElement.addClass(cssClass);
		        })(support.browser);
	
		        support.eventCapture = document.documentElement.addEventListener;
	
		        var input = document.createElement("input");
	
		        support.placeholder = "placeholder" in input;
		        support.propertyChangeEvent = "onpropertychange" in input;
	
		        support.input = (function() {
		            var types = ["number", "date", "time", "month", "week", "datetime", "datetime-local"];
		            var length = types.length;
		            var value = "test";
		            var result = {};
		            var idx = 0;
		            var type;
	
		            for (;idx < length; idx++) {
		                type = types[idx];
		                input.setAttribute("type", type);
		                input.value = value;
	
		                result[type.replace("-", "")] = input.type !== "text" && input.value !== value;
		            }
	
		            return result;
		        })();
	
		        input.style.cssText = "float:left;";
	
		        support.cssFloat = !!input.style.cssFloat;
	
		        input = null;
	
		        support.stableSort = (function() {
		            // Chrome sort is not stable for more than *10* items
		            // IE9+ sort is not stable for than *512* items
		            var threshold = 513;
	
		            var sorted = [{
		                index: 0,
		                field: "b"
		            }];
	
		            for (var i = 1; i < threshold; i++) {
		                sorted.push({
		                    index: i,
		                    field: "a"
		                });
		            }
	
		            sorted.sort(function(a, b) {
		                return a.field > b.field ? 1 : (a.field < b.field ? -1 : 0);
		            });
	
		            return sorted[0].index === 1;
		        })();
	
		        support.matchesSelector = elementProto.webkitMatchesSelector || elementProto.mozMatchesSelector ||
		                                  elementProto.msMatchesSelector || elementProto.oMatchesSelector ||
		                                  elementProto.matchesSelector || elementProto.matches ||
		          function( selector ) {
		              var nodeList = document.querySelectorAll ? ( this.parentNode || document ).querySelectorAll( selector ) || [] : $(selector),
		                  i = nodeList.length;
	
		              while (i--) {
		                  if (nodeList[i] == this) {
		                      return true;
		                  }
		              }
	
		              return false;
		          };
	
		        support.matchMedia = "matchMedia" in window;
	
		        support.pushState = window.history && window.history.pushState;
	
		        var documentMode = document.documentMode;
	
		        support.hashChange = ("onhashchange" in window) && !(support.browser.msie && (!documentMode || documentMode <= 8)); // old IE detection
	
		        support.customElements = ("registerElement" in window.document);
	
		        var chrome = support.browser.chrome,
		            mozilla = support.browser.mozilla;
		        support.msPointers = !chrome && window.MSPointerEvent;
		        support.pointers = !chrome && !mozilla && window.PointerEvent;
		        support.kineticScrollNeeded = mobileOS && (support.touch || support.msPointers || support.pointers);
		    })();
	
	
		    function size(obj) {
		        var result = 0, key;
		        for (key in obj) {
		            if (obj.hasOwnProperty(key) && key != "toJSON") { // Ignore fake IE7 toJSON.
		                result++;
		            }
		        }
	
		        return result;
		    }
	
		    function getOffset(element, type, positioned) {
		        if (!type) {
		            type = "offset";
		        }
	
		        var offset = element[type]();
		        // clone ClientRect object to JS object (jQuery3)
		        var result = {
		            top: offset.top,
		            right: offset.right,
		            bottom: offset.bottom,
		            left: offset.left
		        };
	
		        // IE10 touch zoom is living in a separate viewport
		        if (support.browser.msie && (support.pointers || support.msPointers) && !positioned) {
		            var sign = support.isRtl(element) ? 1 : -1;
	
		            result.top -= (window.pageYOffset - (document.documentElement.scrollTop));
		            result.left -= (window.pageXOffset + (sign * document.documentElement.scrollLeft));
		        }
	
		        return result;
		    }
	
		    var directions = {
		        left: { reverse: "right" },
		        right: { reverse: "left" },
		        down: { reverse: "up" },
		        up: { reverse: "down" },
		        top: { reverse: "bottom" },
		        bottom: { reverse: "top" },
		        "in": { reverse: "out" },
		        out: { reverse: "in" }
		    };
	
		    function parseEffects(input) {
		        var effects = {};
	
		        each((typeof input === "string" ? input.split(" ") : input), function(idx) {
		            effects[idx] = this;
		        });
	
		        return effects;
		    }
	
		    function fx(element) {
		        return new kendo.effects.Element(element);
		    }
	
		    var effects = {};
	
		    $.extend(effects, {
		        enabled: true,
		        Element: function(element) {
		            this.element = $(element);
		        },
	
		        promise: function(element, options) {
		            if (!element.is(":visible")) {
		                element.css({ display: element.data("olddisplay") || "block" }).css("display");
		            }
	
		            if (options.hide) {
		                element.data("olddisplay", element.css("display")).hide();
		            }
	
		            if (options.init) {
		                options.init();
		            }
	
		            if (options.completeCallback) {
		                options.completeCallback(element); // call the external complete callback with the element
		            }
	
		            element.dequeue();
		        },
	
		        disable: function() {
		            this.enabled = false;
		            this.promise = this.promiseShim;
		        },
	
		        enable: function() {
		            this.enabled = true;
		            this.promise = this.animatedPromise;
		        }
		    });
	
		    effects.promiseShim = effects.promise;
	
		    function prepareAnimationOptions(options, duration, reverse, complete) {
		        if (typeof options === STRING) {
		            // options is the list of effect names separated by space e.g. animate(element, "fadeIn slideDown")
	
		            // only callback is provided e.g. animate(element, options, function() {});
		            if (isFunction(duration)) {
		                complete = duration;
		                duration = 400;
		                reverse = false;
		            }
	
		            if (isFunction(reverse)) {
		                complete = reverse;
		                reverse = false;
		            }
	
		            if (typeof duration === BOOLEAN){
		                reverse = duration;
		                duration = 400;
		            }
	
		            options = {
		                effects: options,
		                duration: duration,
		                reverse: reverse,
		                complete: complete
		            };
		        }
	
		        return extend({
		            //default options
		            effects: {},
		            duration: 400, //jQuery default duration
		            reverse: false,
		            init: noop,
		            teardown: noop,
		            hide: false
		        }, options, { completeCallback: options.complete, complete: noop }); // Move external complete callback, so deferred.resolve can be always executed.
	
		    }
	
		    function animate(element, options, duration, reverse, complete) {
		        var idx = 0,
		            length = element.length,
		            instance;
	
		        for (; idx < length; idx ++) {
		            instance = $(element[idx]);
		            instance.queue(function() {
		                effects.promise(instance, prepareAnimationOptions(options, duration, reverse, complete));
		            });
		        }
	
		        return element;
		    }
	
		    function toggleClass(element, classes, options, add) {
		        if (classes) {
		            classes = classes.split(" ");
	
		            each(classes, function(idx, value) {
		                element.toggleClass(value, add);
		            });
		        }
	
		        return element;
		    }
	
		    if (!("kendoAnimate" in $.fn)) {
		        extend($.fn, {
		            kendoStop: function(clearQueue, gotoEnd) {
		                return this.stop(clearQueue, gotoEnd);
		            },
	
		            kendoAnimate: function(options, duration, reverse, complete) {
		                return animate(this, options, duration, reverse, complete);
		            },
	
		            kendoAddClass: function(classes, options){
		                return kendo.toggleClass(this, classes, options, true);
		            },
	
		            kendoRemoveClass: function(classes, options){
		                return kendo.toggleClass(this, classes, options, false);
		            },
		            kendoToggleClass: function(classes, options, toggle){
		                return kendo.toggleClass(this, classes, options, toggle);
		            }
		        });
		    }
	
		    var ampRegExp = /&/g,
		        ltRegExp = /</g,
		        quoteRegExp = /"/g,
		        aposRegExp = /'/g,
		        gtRegExp = />/g;
		    function htmlEncode(value) {
		        return ("" + value).replace(ampRegExp, "&amp;").replace(ltRegExp, "&lt;").replace(gtRegExp, "&gt;").replace(quoteRegExp, "&quot;").replace(aposRegExp, "&#39;");
		    }
	
		    var eventTarget = function (e) {
		        return e.target;
		    };
	
		    if (support.touch) {
	
		        eventTarget = function(e) {
		            var touches = "originalEvent" in e ? e.originalEvent.changedTouches : "changedTouches" in e ? e.changedTouches : null;
	
		            return touches ? document.elementFromPoint(touches[0].clientX, touches[0].clientY) : e.target;
		        };
	
		        each(["swipe", "swipeLeft", "swipeRight", "swipeUp", "swipeDown", "doubleTap", "tap"], function(m, value) {
		            $.fn[value] = function(callback) {
		                return this.bind(value, callback);
		            };
		        });
		    }
	
		    if (support.touch) {
		        if (!support.mobileOS) {
		            support.mousedown = "mousedown touchstart";
		            support.mouseup = "mouseup touchend";
		            support.mousemove = "mousemove touchmove";
		            support.mousecancel = "mouseleave touchcancel";
		            support.click = "click";
		            support.resize = "resize";
		        } else {
		            support.mousedown = "touchstart";
		            support.mouseup = "touchend";
		            support.mousemove = "touchmove";
		            support.mousecancel = "touchcancel";
		            support.click = "touchend";
		            support.resize = "orientationchange";
		        }
		    } else if (support.pointers) {
		        support.mousemove = "pointermove";
		        support.mousedown = "pointerdown";
		        support.mouseup = "pointerup";
		        support.mousecancel = "pointercancel";
		        support.click = "pointerup";
		        support.resize = "orientationchange resize";
		    } else if (support.msPointers) {
		        support.mousemove = "MSPointerMove";
		        support.mousedown = "MSPointerDown";
		        support.mouseup = "MSPointerUp";
		        support.mousecancel = "MSPointerCancel";
		        support.click = "MSPointerUp";
		        support.resize = "orientationchange resize";
		    } else {
		        support.mousemove = "mousemove";
		        support.mousedown = "mousedown";
		        support.mouseup = "mouseup";
		        support.mousecancel = "mouseleave";
		        support.click = "click";
		        support.resize = "resize";
		    }
	
		    var wrapExpression = function(members, paramName) {
		        var result = paramName || "d",
		            index,
		            idx,
		            length,
		            member,
		            count = 1;
	
		        for (idx = 0, length = members.length; idx < length; idx++) {
		            member = members[idx];
		            if (member !== "") {
		                index = member.indexOf("[");
	
		                if (index !== 0) {
		                    if (index == -1) {
		                        member = "." + member;
		                    } else {
		                        count++;
		                        member = "." + member.substring(0, index) + " || {})" + member.substring(index);
		                    }
		                }
	
		                count++;
		                result += member + ((idx < length - 1) ? " || {})" : ")");
		            }
		        }
		        return new Array(count).join("(") + result;
		    },
		    localUrlRe = /^([a-z]+:)?\/\//i;
	
		    extend(kendo, {
		        widgets: [],
		        _widgetRegisteredCallbacks: [],
		        ui: kendo.ui || {},
		        fx: kendo.fx || fx,
		        effects: kendo.effects || effects,
		        mobile: kendo.mobile || { },
		        data: kendo.data || {},
		        dataviz: kendo.dataviz || {},
		        drawing: kendo.drawing || {},
		        spreadsheet: { messages: {} },
		        keys: {
		            INSERT: 45,
		            DELETE: 46,
		            BACKSPACE: 8,
		            TAB: 9,
		            ENTER: 13,
		            ESC: 27,
		            LEFT: 37,
		            UP: 38,
		            RIGHT: 39,
		            DOWN: 40,
		            END: 35,
		            HOME: 36,
		            SPACEBAR: 32,
		            PAGEUP: 33,
		            PAGEDOWN: 34,
		            F2: 113,
		            F10: 121,
		            F12: 123,
		            NUMPAD_PLUS: 107,
		            NUMPAD_MINUS: 109,
		            NUMPAD_DOT: 110
		        },
		        support: kendo.support || support,
		        animate: kendo.animate || animate,
		        ns: "",
		        attr: function(value) {
		            return "data-" + kendo.ns + value;
		        },
		        getShadows: getShadows,
		        wrap: wrap,
		        deepExtend: deepExtend,
		        getComputedStyles: getComputedStyles,
		        webComponents: kendo.webComponents || [],
		        isScrollable: isScrollable,
		        scrollLeft: scrollLeft,
		        size: size,
		        toCamelCase: toCamelCase,
		        toHyphens: toHyphens,
		        getOffset: kendo.getOffset || getOffset,
		        parseEffects: kendo.parseEffects || parseEffects,
		        toggleClass: kendo.toggleClass || toggleClass,
		        directions: kendo.directions || directions,
		        Observable: Observable,
		        Class: Class,
		        Template: Template,
		        template: proxy(Template.compile, Template),
		        render: proxy(Template.render, Template),
		        stringify: proxy(JSON.stringify, JSON),
		        eventTarget: eventTarget,
		        htmlEncode: htmlEncode,
		        isLocalUrl: function(url) {
		            return url && !localUrlRe.test(url);
		        },
	
		        expr: function(expression, safe, paramName) {
		            expression = expression || "";
	
		            if (typeof safe == STRING) {
		                paramName = safe;
		                safe = false;
		            }
	
		            paramName = paramName || "d";
	
		            if (expression && expression.charAt(0) !== "[") {
		                expression = "." + expression;
		            }
	
		            if (safe) {
		                expression = expression.replace(/"([^.]*)\.([^"]*)"/g,'"$1_$DOT$_$2"');
		                expression = expression.replace(/'([^.]*)\.([^']*)'/g,"'$1_$DOT$_$2'");
		                expression = wrapExpression(expression.split("."), paramName);
		                expression = expression.replace(/_\$DOT\$_/g, ".");
		            } else {
		                expression = paramName + expression;
		            }
	
		            return expression;
		        },
	
		        getter: function(expression, safe) {
		            var key = expression + safe;
		            return getterCache[key] = getterCache[key] || new Function("d", "return " + kendo.expr(expression, safe));
		        },
	
		        setter: function(expression) {
		            return setterCache[expression] = setterCache[expression] || new Function("d,value", kendo.expr(expression) + "=value");
		        },
	
		        accessor: function(expression) {
		            return {
		                get: kendo.getter(expression),
		                set: kendo.setter(expression)
		            };
		        },
	
		        guid: function() {
		            var id = "", i, random;
	
		            for (i = 0; i < 32; i++) {
		                random = math.random() * 16 | 0;
	
		                if (i == 8 || i == 12 || i == 16 || i == 20) {
		                    id += "-";
		                }
		                id += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
		            }
	
		            return id;
		        },
	
		        roleSelector: function(role) {
		            return role.replace(/(\S+)/g, "[" + kendo.attr("role") + "=$1],").slice(0, -1);
		        },
	
		        directiveSelector: function(directives) {
		            var selectors = directives.split(" ");
	
		            if (selectors) {
		                for (var i = 0; i < selectors.length; i++) {
		                    if (selectors[i] != "view") {
		                        selectors[i] = selectors[i].replace(/(\w*)(view|bar|strip|over)$/, "$1-$2");
		                    }
		                }
		            }
	
		            return selectors.join(" ").replace(/(\S+)/g, "kendo-mobile-$1,").slice(0, -1);
		        },
	
		        triggeredByInput: function(e) {
		            return (/^(label|input|textarea|select)$/i).test(e.target.tagName);
		        },
	
		        onWidgetRegistered: function(callback) {
		            for (var i = 0, len = kendo.widgets.length; i < len; i++) {
		                callback(kendo.widgets[i]);
		            }
	
		            kendo._widgetRegisteredCallbacks.push(callback);
		        },
	
		        logToConsole: function(message, type) {
		            var console = window.console;
	
		            if (!kendo.suppressLog && typeof(console) != "undefined" && console.log) {
		                console[type || "log"](message);
		            }
		        }
		    });
	
		    var Widget = Observable.extend( {
		        init: function(element, options) {
		            var that = this;
	
		            that.element = kendo.jQuery(element).handler(that);
	
		            that.angular("init", options);
	
		            Observable.fn.init.call(that);
	
		            var dataSource = options ? options.dataSource : null;
	
		            if (dataSource) {
		                // avoid deep cloning the data source
		                options = extend({}, options, { dataSource: {} });
		            }
	
		            options = that.options = extend(true, {}, that.options, options);
	
		            if (dataSource) {
		                options.dataSource = dataSource;
		            }
	
		            if (!that.element.attr(kendo.attr("role"))) {
		                that.element.attr(kendo.attr("role"), (options.name || "").toLowerCase());
		            }
	
		            that.element.data("kendo" + options.prefix + options.name, that);
	
		            that.bind(that.events, options);
		        },
	
		        events: [],
	
		        options: {
		            prefix: ""
		        },
	
		        _hasBindingTarget: function() {
		            return !!this.element[0].kendoBindingTarget;
		        },
	
		        _tabindex: function(target) {
		            target = target || this.wrapper;
	
		            var element = this.element,
		                TABINDEX = "tabindex",
		                tabindex = target.attr(TABINDEX) || element.attr(TABINDEX);
	
		            element.removeAttr(TABINDEX);
	
		            target.attr(TABINDEX, !isNaN(tabindex) ? tabindex : 0);
		        },
	
		        setOptions: function(options) {
		            this._setEvents(options);
		            $.extend(this.options, options);
		        },
	
		        _setEvents: function(options) {
		            var that = this,
		                idx = 0,
		                length = that.events.length,
		                e;
	
		            for (; idx < length; idx ++) {
		                e = that.events[idx];
		                if (that.options[e] && options[e]) {
		                    that.unbind(e, that.options[e]);
		                }
		            }
	
		            that.bind(that.events, options);
		        },
	
		        resize: function(force) {
		            var size = this.getSize(),
		                currentSize = this._size;
	
		            if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
		                this._size = size;
		                this._resize(size, force);
		                this.trigger("resize", size);
		            }
		        },
	
		        getSize: function() {
		            return kendo.dimensions(this.element);
		        },
	
		        size: function(size) {
		            if (!size) {
		                return this.getSize();
		            } else {
		                this.setSize(size);
		            }
		        },
	
		        setSize: $.noop,
		        _resize: $.noop,
	
		        destroy: function() {
		            var that = this;
	
		            that.element.removeData("kendo" + that.options.prefix + that.options.name);
		            that.element.removeData("handler");
		            that.unbind();
		        },
		        _destroy: function() {
		            this.destroy();
		        },
		        angular: function(){},
	
		        _muteAngularRebind: function(callback) {
		            this._muteRebind = true;
	
		            callback.call(this);
	
		            this._muteRebind = false;
		        }
		    });
	
		    var DataBoundWidget = Widget.extend({
		        // Angular consumes these.
		        dataItems: function() {
		            return this.dataSource.flatView();
		        },
	
		        _angularItems: function(cmd) {
		            var that = this;
		            that.angular(cmd, function(){
		                return {
		                    elements: that.items(),
		                    data: $.map(that.dataItems(), function(dataItem){
		                        return { dataItem: dataItem };
		                    })
		                };
		            });
		        }
		    });
	
		    kendo.dimensions = function(element, dimensions) {
		        var domElement = element[0];
	
		        if (dimensions) {
		            element.css(dimensions);
		        }
	
		        return { width: domElement.offsetWidth, height: domElement.offsetHeight };
		    };
	
		    kendo.notify = noop;
	
		    var templateRegExp = /template$/i,
		        jsonRegExp = /^\s*(?:\{(?:.|\r\n|\n)*\}|\[(?:.|\r\n|\n)*\])\s*$/,
		        jsonFormatRegExp = /^\{(\d+)(:[^\}]+)?\}|^\[[A-Za-z_]+\]$/,
		        dashRegExp = /([A-Z])/g;
	
		    function parseOption(element, option) {
		        var value;
	
		        if (option.indexOf("data") === 0) {
		            option = option.substring(4);
		            option = option.charAt(0).toLowerCase() + option.substring(1);
		        }
	
		        option = option.replace(dashRegExp, "-$1");
		        value = element.getAttribute("data-" + kendo.ns + option);
	
		        if (value === null) {
		            value = undefined;
		        } else if (value === "null") {
		            value = null;
		        } else if (value === "true") {
		            value = true;
		        } else if (value === "false") {
		            value = false;
		        } else if (numberRegExp.test(value) && option != "mask") {
		            value = parseFloat(value);
		        } else if (jsonRegExp.test(value) && !jsonFormatRegExp.test(value)) {
		            value = new Function("return (" + value + ")")();
		        }
	
		        return value;
		    }
	
		    function parseOptions(element, options, source) {
		        var result = {},
		            option,
		            value;
	
		        for (option in options) {
		            value = parseOption(element, option);
	
		            if (value !== undefined) {
	
		                if (templateRegExp.test(option)) {
		                    if(typeof value === "string") {
		                        if($("#" + value).length){
		                            value = kendo.template($("#" + value).html());
		                        }else if (source){
		                            value = kendo.template(source[value]);
		                        }
		                    } else {
		                        value = element.getAttribute(option);
		                    }
		                }
	
		                result[option] = value;
		            }
		        }
	
		        return result;
		    }
	
		    kendo.initWidget = function(element, options, roles) {
		        var result,
		            option,
		            widget,
		            idx,
		            length,
		            role,
		            value,
		            dataSource,
		            fullPath,
		            widgetKeyRegExp;
	
		        // Preserve backwards compatibility with (element, options, namespace) signature, where namespace was kendo.ui
		        if (!roles) {
		            roles = kendo.ui.roles;
		        } else if (roles.roles) {
		            roles = roles.roles;
		        }
	
		        element = element.nodeType ? element : element[0];
	
		        role = element.getAttribute("data-" + kendo.ns + "role");
	
		        if (!role) {
		            return;
		        }
	
		        fullPath = role.indexOf(".") === -1;
	
		        // look for any widget that may be already instantiated based on this role.
		        // The prefix used is unknown, hence the regexp
		        //
	
		        if (fullPath) {
		            widget = roles[role];
		        } else { // full namespace path - like kendo.ui.Widget
		            widget = kendo.getter(role)(window);
		        }
	
		        var data = $(element).data(),
		            widgetKey = widget ? "kendo" + widget.fn.options.prefix + widget.fn.options.name : "";
	
		        if (fullPath) {
		            widgetKeyRegExp = new RegExp("^kendo.*" + role + "$", "i");
		        } else { // full namespace path - like kendo.ui.Widget
		            widgetKeyRegExp = new RegExp("^" + widgetKey + "$", "i");
		        }
	
		        for(var key in data) {
		            if (key.match(widgetKeyRegExp)) {
		                // we have detected a widget of the same kind - save its reference, we will set its options
		                if (key === widgetKey) {
		                    result = data[key];
		                } else {
		                    return data[key];
		                }
		            }
		        }
	
		        if (!widget) {
		            return;
		        }
	
		        dataSource = parseOption(element, "dataSource");
	
		        options = $.extend({}, parseOptions(element, widget.fn.options), options);
	
		        if (dataSource) {
		            if (typeof dataSource === STRING) {
		                options.dataSource = kendo.getter(dataSource)(window);
		            } else {
		                options.dataSource = dataSource;
		            }
		        }
	
		        for (idx = 0, length = widget.fn.events.length; idx < length; idx++) {
		            option = widget.fn.events[idx];
	
		            value = parseOption(element, option);
	
		            if (value !== undefined) {
		                options[option] = kendo.getter(value)(window);
		            }
		        }
	
		        if (!result) {
		            result = new widget(element, options);
		        } else if (!$.isEmptyObject(options)) {
		            result.setOptions(options);
		        }
	
		        return result;
		    };
	
		    kendo.rolesFromNamespaces = function(namespaces) {
		        var roles = [],
		            idx,
		            length;
	
		        if (!namespaces[0]) {
		            namespaces = [kendo.ui, kendo.dataviz.ui];
		        }
	
		        for (idx = 0, length = namespaces.length; idx < length; idx ++) {
		            roles[idx] = namespaces[idx].roles;
		        }
	
		        return extend.apply(null, [{}].concat(roles.reverse()));
		    };
	
		    kendo.init = function(element) {
		        var roles = kendo.rolesFromNamespaces(slice.call(arguments, 1));
	
		        $(element).find("[data-" + kendo.ns + "role]").addBack().each(function(){
		            kendo.initWidget(this, {}, roles);
		        });
		    };
	
		    kendo.destroy = function(element) {
		        $(element).find("[data-" + kendo.ns + "role]").addBack().each(function(){
		            var data = $(this).data();
	
		            for (var key in data) {
		                if (key.indexOf("kendo") === 0 && typeof data[key].destroy === FUNCTION) {
		                    data[key].destroy();
		                }
		            }
		        });
		    };
	
		    function containmentComparer(a, b) {
		        return $.contains(a, b) ? -1 : 1;
		    }
	
		    function resizableWidget() {
		        var widget = $(this);
		        return ($.inArray(widget.attr("data-" + kendo.ns + "role"), ["slider", "rangeslider"]) > -1) || widget.is(":visible");
		    }
	
		    kendo.resize = function(element, force) {
		        var widgets = $(element).find("[data-" + kendo.ns + "role]").addBack().filter(resizableWidget);
	
		        if (!widgets.length) {
		            return;
		        }
	
		        // sort widgets based on their parent-child relation
		        var widgetsArray = $.makeArray(widgets);
		        widgetsArray.sort(containmentComparer);
	
		        // resize widgets
		        $.each(widgetsArray, function () {
		            var widget = kendo.widgetInstance($(this));
		            if (widget) {
		                widget.resize(force);
		            }
		        });
		    };
	
		    kendo.parseOptions = parseOptions;
	
		    extend(kendo.ui, {
		        Widget: Widget,
		        DataBoundWidget: DataBoundWidget,
		        roles: {},
		        progress: function(container, toggle, options) {
		            var mask = container.find(".k-loading-mask"),
		                support = kendo.support,
		                browser = support.browser,
		                isRtl, leftRight, webkitCorrection, containerScrollLeft, cssClass;
	
		                options = $.extend({}, {
		                    width: "100%",
		                    height: "100%",
		                    top: container.scrollTop(),
		                    opacity: false
		                }, options);
	
		                cssClass = options.opacity ? 'k-loading-mask k-opaque' : 'k-loading-mask';
	
		            if (toggle) {
		                if (!mask.length) {
		                    isRtl = support.isRtl(container);
		                    leftRight = isRtl ? "right" : "left";
		                    containerScrollLeft = container.scrollLeft();
		                    webkitCorrection = browser.webkit ? (!isRtl ? 0 : container[0].scrollWidth - container.width() - 2 * containerScrollLeft) : 0;
	
		                    mask = $(kendo.format("<div class='{0}'><span class='k-loading-text'>{1}</span><div class='k-loading-image'/><div class='k-loading-color'/></div>", cssClass, kendo.ui.progress.messages.loading))
		                        .width(options.width).height(options.height)
		                        .css("top", options.top)
		                        .css(leftRight, Math.abs(containerScrollLeft) + webkitCorrection)
		                        .prependTo(container);
		                }
		            } else if (mask) {
		                mask.remove();
		            }
		        },
		        plugin: function(widget, register, prefix) {
		            var name = widget.fn.options.name,
		                getter;
	
		            register = register || kendo.ui;
		            prefix = prefix || "";
	
		            register[name] = widget;
	
		            register.roles[name.toLowerCase()] = widget;
	
		            getter = "getKendo" + prefix + name;
		            name = "kendo" + prefix + name;
	
		            var widgetEntry = { name: name, widget: widget, prefix: prefix || "" };
		            kendo.widgets.push(widgetEntry);
	
		            for (var i = 0, len = kendo._widgetRegisteredCallbacks.length; i < len; i++) {
		                kendo._widgetRegisteredCallbacks[i](widgetEntry);
		            }
	
		            $.fn[name] = function(options) {
		                var value = this,
		                    args;
	
		                if (typeof options === STRING) {
		                    args = slice.call(arguments, 1);
	
		                    this.each(function(){
		                        var widget = $.data(this, name),
		                            method,
		                            result;
	
		                        if (!widget) {
		                            throw new Error(kendo.format("Cannot call method '{0}' of {1} before it is initialized", options, name));
		                        }
	
		                        method = widget[options];
	
		                        if (typeof method !== FUNCTION) {
		                            throw new Error(kendo.format("Cannot find method '{0}' of {1}", options, name));
		                        }
	
		                        result = method.apply(widget, args);
	
		                        if (result !== undefined) {
		                            value = result;
		                            return false;
		                        }
		                    });
		                } else {
		                    this.each(function() {
		                        return new widget(this, options);
		                    });
		                }
	
		                return value;
		            };
	
		            $.fn[name].widget = widget;
	
		            $.fn[getter] = function() {
		                return this.data(name);
		            };
		        }
		    });
	
		    kendo.ui.progress.messages = {
		        loading: "Loading..."
		    };
	
		    var ContainerNullObject = { bind: function () { return this; }, nullObject: true, options: {} };
	
		    var MobileWidget = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
		            this.element.autoApplyNS();
		            this.wrapper = this.element;
		            this.element.addClass("km-widget");
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.element.kendoDestroy();
		        },
	
		        options: {
		            prefix: "Mobile"
		        },
	
		        events: [],
	
		        view: function() {
		            var viewElement = this.element.closest(kendo.roleSelector("view splitview modalview drawer"));
		            return kendo.widgetInstance(viewElement, kendo.mobile.ui) || ContainerNullObject;
		        },
	
		        viewHasNativeScrolling: function() {
		            var view = this.view();
		            return view && view.options.useNativeScrolling;
		        },
	
		        container: function() {
		            var element = this.element.closest(kendo.roleSelector("view layout modalview drawer splitview"));
		            return kendo.widgetInstance(element.eq(0), kendo.mobile.ui) || ContainerNullObject;
		        }
		    });
	
		    extend(kendo.mobile, {
		        init: function(element) {
		            kendo.init(element, kendo.mobile.ui, kendo.ui, kendo.dataviz.ui);
		        },
	
		        appLevelNativeScrolling: function() {
		            return kendo.mobile.application && kendo.mobile.application.options && kendo.mobile.application.options.useNativeScrolling;
		        },
	
		        roles: {},
	
		        ui: {
		            Widget: MobileWidget,
		            DataBoundWidget: DataBoundWidget.extend(MobileWidget.prototype),
		            roles: {},
		            plugin: function(widget) {
		                kendo.ui.plugin(widget, kendo.mobile.ui, "Mobile");
		            }
		        }
		    });
	
		    deepExtend(kendo.dataviz, {
		        init: function(element) {
		            kendo.init(element, kendo.dataviz.ui);
		        },
		        ui: {
		            roles: {},
		            themes: {},
		            views: [],
		            plugin: function(widget) {
		                kendo.ui.plugin(widget, kendo.dataviz.ui);
		            }
		        },
		        roles: {}
		    });
	
		    kendo.touchScroller = function(elements, options) {
		        // return the first touch scroller
		        if (!options){ options = {}; }
	
		        options.useNative = true;
	
		        return $(elements).map(function(idx, element) {
		            element = $(element);
		            if (support.kineticScrollNeeded && kendo.mobile.ui.Scroller && !element.data("kendoMobileScroller")) {
		                element.kendoMobileScroller(options);
		                return element.data("kendoMobileScroller");
		            } else {
		                return false;
		            }
		        })[0];
		    };
	
		    kendo.preventDefault = function(e) {
		        e.preventDefault();
		    };
	
		    kendo.widgetInstance = function(element, suites) {
		        var role = element.data(kendo.ns + "role"),
		            widgets = [], i, length;
	
		        if (role) {
		            // HACK!!! mobile view scroller widgets are instantiated on data-role="content" elements. We need to discover them when resizing.
		            if (role === "content") {
		                role = "scroller";
		            }
	
		            // kendoEditorToolbar is not a public plugin, thus it does not exist in kendo.ui.roles.
		            // Therefore, this is needed in order to be resized when placed in Kendo Window.
		            if (role === "editortoolbar") {
		                var editorToolbar = element.data("kendoEditorToolbar");
		                if (editorToolbar) {
		                    return editorToolbar;
		                }
		            }
	
		            if (suites) {
		                if (suites[0]) {
		                    for (i = 0, length = suites.length; i < length; i ++) {
		                        widgets.push(suites[i].roles[role]);
		                    }
		                } else {
		                    widgets.push(suites.roles[role]);
		                }
		            }
		            else {
		                widgets = [ kendo.ui.roles[role], kendo.dataviz.ui.roles[role],  kendo.mobile.ui.roles[role] ];
		            }
	
		            if (role.indexOf(".") >= 0) {
		                widgets = [ kendo.getter(role)(window) ];
		            }
	
		            for (i = 0, length = widgets.length; i < length; i ++) {
		                var widget = widgets[i];
		                if (widget) {
		                    var instance = element.data("kendo" + widget.fn.options.prefix + widget.fn.options.name);
		                    if (instance) {
		                        return instance;
		                    }
		                }
		            }
		        }
		    };
	
		    kendo.onResize = function(callback) {
		        var handler = callback;
		        if (support.mobileOS.android) {
		            handler = function() { setTimeout(callback, 600); };
		        }
	
		        $(window).on(support.resize, handler);
		        return handler;
		    };
	
		    kendo.unbindResize = function(callback) {
		        $(window).off(support.resize, callback);
		    };
	
		    kendo.attrValue = function(element, key) {
		        return element.data(kendo.ns + key);
		    };
	
		    kendo.days = {
		        Sunday: 0,
		        Monday: 1,
		        Tuesday: 2,
		        Wednesday: 3,
		        Thursday: 4,
		        Friday: 5,
		        Saturday: 6
		    };
	
		    function focusable(element, isTabIndexNotNaN) {
		        var nodeName = element.nodeName.toLowerCase();
	
		        return (/input|select|textarea|button|object/.test(nodeName) ?
		                !element.disabled :
		                "a" === nodeName ?
		                element.href || isTabIndexNotNaN :
		                isTabIndexNotNaN
		               ) &&
		            visible(element);
		    }
	
		    function visible(element) {
		        return $.expr.filters.visible(element) &&
		            !$(element).parents().addBack().filter(function() {
		                return $.css(this,"visibility") === "hidden";
		            }).length;
		    }
	
		    $.extend($.expr[ ":" ], {
		        kendoFocusable: function(element) {
		            var idx = $.attr(element, "tabindex");
		            return focusable(element, !isNaN(idx) && idx > -1);
		        }
		    });
	
		    var MOUSE_EVENTS = ["mousedown", "mousemove", "mouseenter", "mouseleave", "mouseover", "mouseout", "mouseup", "click"];
		    var EXCLUDE_BUST_CLICK_SELECTOR = "label, input, [data-rel=external]";
	
		    var MouseEventNormalizer = {
		        setupMouseMute: function() {
		            var idx = 0,
		                length = MOUSE_EVENTS.length,
		                element = document.documentElement;
	
		            if (MouseEventNormalizer.mouseTrap || !support.eventCapture) {
		                return;
		            }
	
		            MouseEventNormalizer.mouseTrap = true;
	
		            MouseEventNormalizer.bustClick = false;
		            MouseEventNormalizer.captureMouse = false;
	
		            var handler = function(e) {
		                if (MouseEventNormalizer.captureMouse) {
		                    if (e.type === "click") {
		                        if (MouseEventNormalizer.bustClick && !$(e.target).is(EXCLUDE_BUST_CLICK_SELECTOR)) {
		                            e.preventDefault();
		                            e.stopPropagation();
		                        }
		                    } else {
		                        e.stopPropagation();
		                    }
		                }
		            };
	
		            for (; idx < length; idx++) {
		                element.addEventListener(MOUSE_EVENTS[idx], handler, true);
		            }
		        },
	
		        muteMouse: function(e) {
		            MouseEventNormalizer.captureMouse = true;
		            if (e.data.bustClick) {
		                MouseEventNormalizer.bustClick = true;
		            }
		            clearTimeout(MouseEventNormalizer.mouseTrapTimeoutID);
		        },
	
		        unMuteMouse: function() {
		            clearTimeout(MouseEventNormalizer.mouseTrapTimeoutID);
		            MouseEventNormalizer.mouseTrapTimeoutID = setTimeout(function() {
		                MouseEventNormalizer.captureMouse = false;
		                MouseEventNormalizer.bustClick = false;
		            }, 400);
		        }
		    };
	
		    var eventMap = {
		        down: "touchstart mousedown",
		        move: "mousemove touchmove",
		        up: "mouseup touchend touchcancel",
		        cancel: "mouseleave touchcancel"
		    };
	
		    if (support.touch && (support.mobileOS.ios || support.mobileOS.android)) {
		        eventMap = {
		            down: "touchstart",
		            move: "touchmove",
		            up: "touchend touchcancel",
		            cancel: "touchcancel"
		        };
		    } else if (support.pointers) {
		        eventMap = {
		            down: "pointerdown",
		            move: "pointermove",
		            up: "pointerup",
		            cancel: "pointercancel pointerleave"
		        };
		    } else if (support.msPointers) {
		        eventMap = {
		            down: "MSPointerDown",
		            move: "MSPointerMove",
		            up: "MSPointerUp",
		            cancel: "MSPointerCancel MSPointerLeave"
		        };
		    }
	
		    if (support.msPointers && !("onmspointerenter" in window)) { // IE10
		        // Create MSPointerEnter/MSPointerLeave events using mouseover/out and event-time checks
		        $.each({
		            MSPointerEnter: "MSPointerOver",
		            MSPointerLeave: "MSPointerOut"
		        }, function( orig, fix ) {
		            $.event.special[ orig ] = {
		                delegateType: fix,
		                bindType: fix,
	
		                handle: function( event ) {
		                    var ret,
		                        target = this,
		                        related = event.relatedTarget,
		                        handleObj = event.handleObj;
	
		                    // For mousenter/leave call the handler if related is outside the target.
		                    // NB: No relatedTarget if the mouse left/entered the browser window
		                    if ( !related || (related !== target && !$.contains( target, related )) ) {
		                        event.type = handleObj.origType;
		                        ret = handleObj.handler.apply( this, arguments );
		                        event.type = fix;
		                    }
		                    return ret;
		                }
		            };
		        });
		    }
	
	
		    var getEventMap = function(e) { return (eventMap[e] || e); },
		        eventRegEx = /([^ ]+)/g;
	
		    kendo.applyEventMap = function(events, ns) {
		        events = events.replace(eventRegEx, getEventMap);
	
		        if (ns) {
		            events = events.replace(eventRegEx, "$1." + ns);
		        }
	
		        return events;
		    };
	
		    var on = $.fn.on;
	
		    function kendoJQuery(selector, context) {
		        return new kendoJQuery.fn.init(selector, context);
		    }
	
		    extend(true, kendoJQuery, $);
	
		    kendoJQuery.fn = kendoJQuery.prototype = new $();
	
		    kendoJQuery.fn.constructor = kendoJQuery;
	
		    kendoJQuery.fn.init = function(selector, context) {
		        if (context && context instanceof $ && !(context instanceof kendoJQuery)) {
		            context = kendoJQuery(context);
		        }
	
		        return $.fn.init.call(this, selector, context, rootjQuery);
		    };
	
		    kendoJQuery.fn.init.prototype = kendoJQuery.fn;
	
		    var rootjQuery = kendoJQuery(document);
	
		    extend(kendoJQuery.fn, {
		        handler: function(handler) {
		            this.data("handler", handler);
		            return this;
		        },
	
		        autoApplyNS: function(ns) {
		            this.data("kendoNS", ns || kendo.guid());
		            return this;
		        },
	
		        on: function() {
		            var that = this,
		                ns = that.data("kendoNS");
	
		            // support for event map signature
		            if (arguments.length === 1) {
		                return on.call(that, arguments[0]);
		            }
	
		            var context = that,
		                args = slice.call(arguments);
	
		            if (typeof args[args.length -1] === UNDEFINED) {
		                args.pop();
		            }
	
		            var callback =  args[args.length - 1],
		                events = kendo.applyEventMap(args[0], ns);
	
		            // setup mouse trap
		            if (support.mouseAndTouchPresent && events.search(/mouse|click/) > -1 && this[0] !== document.documentElement) {
		                MouseEventNormalizer.setupMouseMute();
	
		                var selector = args.length === 2 ? null : args[1],
		                    bustClick = events.indexOf("click") > -1 && events.indexOf("touchend") > -1;
	
		                on.call(this,
		                    {
		                        touchstart: MouseEventNormalizer.muteMouse,
		                        touchend: MouseEventNormalizer.unMuteMouse
		                    },
		                    selector,
		                    {
		                        bustClick: bustClick
		                    });
		            }
	
		            if (typeof callback === STRING) {
		                context = that.data("handler");
		                callback = context[callback];
	
		                args[args.length - 1] = function(e) {
		                    callback.call(context, e);
		                };
		            }
	
		            args[0] = events;
	
		            on.apply(that, args);
	
		            return that;
		        },
	
		        kendoDestroy: function(ns) {
		            ns = ns || this.data("kendoNS");
	
		            if (ns) {
		                this.off("." + ns);
		            }
	
		            return this;
		        }
		    });
	
		    kendo.jQuery = kendoJQuery;
		    kendo.eventMap = eventMap;
	
		    kendo.timezone = (function(){
		        var months =  { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
		        var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
	
		        function ruleToDate(year, rule) {
		            var date;
		            var targetDay;
		            var ourDay;
		            var month = rule[3];
		            var on = rule[4];
		            var time = rule[5];
		            var cache = rule[8];
	
		            if (!cache) {
		                rule[8] = cache = {};
		            }
	
		            if (cache[year]) {
		                return cache[year];
		            }
	
		            if (!isNaN(on)) {
		                date = new Date(Date.UTC(year, months[month], on, time[0], time[1], time[2], 0));
		            } else if (on.indexOf("last") === 0) {
		                date = new Date(Date.UTC(year, months[month] + 1, 1, time[0] - 24, time[1], time[2], 0));
	
		                targetDay = days[on.substr(4, 3)];
		                ourDay = date.getUTCDay();
	
		                date.setUTCDate(date.getUTCDate() + targetDay - ourDay - (targetDay > ourDay ? 7 : 0));
		            } else if (on.indexOf(">=") >= 0) {
		                date = new Date(Date.UTC(year, months[month], on.substr(5), time[0], time[1], time[2], 0));
	
		                targetDay = days[on.substr(0, 3)];
		                ourDay = date.getUTCDay();
	
		                date.setUTCDate(date.getUTCDate() + targetDay - ourDay + (targetDay < ourDay ? 7 : 0));
		            }
	
		            return cache[year] = date;
		        }
	
		        function findRule(utcTime, rules, zone) {
		            rules = rules[zone];
	
		            if (!rules) {
		                var time = zone.split(":");
		                var offset = 0;
	
		                if (time.length > 1) {
		                    offset = time[0] * 60 + Number(time[1]);
		                }
	
		                return [-1000000, 'max', '-', 'Jan', 1, [0, 0, 0], offset, '-'];
		            }
	
		            var year = new Date(utcTime).getUTCFullYear();
	
		            rules = jQuery.grep(rules, function(rule) {
		                var from = rule[0];
		                var to = rule[1];
	
		                return from <= year && (to >= year || (from == year && to == "only") || to == "max");
		            });
	
		            rules.push(utcTime);
	
		            rules.sort(function(a, b) {
		                if (typeof a != "number") {
		                    a = Number(ruleToDate(year, a));
		                }
	
		                if (typeof b != "number") {
		                    b = Number(ruleToDate(year, b));
		                }
	
		                return a - b;
		            });
	
		            var rule = rules[jQuery.inArray(utcTime, rules) - 1] || rules[rules.length - 1];
	
		            return isNaN(rule) ? rule : null;
		        }
	
		        function findZone(utcTime, zones, timezone) {
		            var zoneRules = zones[timezone];
	
		            if (typeof zoneRules === "string") {
		                zoneRules = zones[zoneRules];
		            }
	
		            if (!zoneRules) {
		                throw new Error('Timezone "' + timezone + '" is either incorrect, or kendo.timezones.min.js is not included.');
		            }
	
		            for (var idx = zoneRules.length - 1; idx >= 0; idx--) {
		                var until = zoneRules[idx][3];
	
		                if (until && utcTime > until) {
		                    break;
		                }
		            }
	
		            var zone = zoneRules[idx + 1];
	
		            if (!zone) {
		                throw new Error('Timezone "' + timezone + '" not found on ' + utcTime + ".");
		            }
	
		            return zone;
		        }
	
		        function zoneAndRule(utcTime, zones, rules, timezone) {
		            if (typeof utcTime != NUMBER) {
		                utcTime = Date.UTC(utcTime.getFullYear(), utcTime.getMonth(),
		                    utcTime.getDate(), utcTime.getHours(), utcTime.getMinutes(),
		                    utcTime.getSeconds(), utcTime.getMilliseconds());
		            }
	
		            var zone = findZone(utcTime, zones, timezone);
	
		            return {
		                zone: zone,
		                rule: findRule(utcTime, rules, zone[1])
		            };
		        }
	
		        function offset(utcTime, timezone) {
		            if (timezone == "Etc/UTC" || timezone == "Etc/GMT") {
		                return 0;
		            }
	
		            var info = zoneAndRule(utcTime, this.zones, this.rules, timezone);
		            var zone = info.zone;
		            var rule = info.rule;
	
		            return kendo.parseFloat(rule? zone[0] - rule[6] : zone[0]);
		        }
	
		        function abbr(utcTime, timezone) {
		            var info = zoneAndRule(utcTime, this.zones, this.rules, timezone);
		            var zone = info.zone;
		            var rule = info.rule;
	
		            var base = zone[2];
	
		            if (base.indexOf("/") >= 0) {
		                return base.split("/")[rule && +rule[6] ? 1 : 0];
		            } else if (base.indexOf("%s") >= 0) {
		                return base.replace("%s", (!rule || rule[7] == "-") ? '' : rule[7]);
		            }
	
		            return base;
		        }
	
		        function convert(date, fromOffset, toOffset) {
		            var tempToOffset = toOffset;
		            var diff;
	
		            if (typeof fromOffset == STRING) {
		                fromOffset = this.offset(date, fromOffset);
		            }
	
		            if (typeof toOffset == STRING) {
		                toOffset = this.offset(date, toOffset);
		            }
	
		            var fromLocalOffset = date.getTimezoneOffset();
	
		            date = new Date(date.getTime() + (fromOffset - toOffset) * 60000);
	
		            var toLocalOffset = date.getTimezoneOffset();
	
		            if (typeof tempToOffset == STRING) {
		                tempToOffset = this.offset(date, tempToOffset);
		            }
	
		            diff = (toLocalOffset - fromLocalOffset) + (toOffset - tempToOffset);
	
		            return new Date(date.getTime() + diff * 60000);
		        }
	
		        function apply(date, timezone) {
		           return this.convert(date, date.getTimezoneOffset(), timezone);
		        }
	
		        function remove(date, timezone) {
		           return this.convert(date, timezone, date.getTimezoneOffset());
		        }
	
		        function toLocalDate(time) {
		            return this.apply(new Date(time), "Etc/UTC");
		        }
	
		        return {
		           zones: {},
		           rules: {},
		           offset: offset,
		           convert: convert,
		           apply: apply,
		           remove: remove,
		           abbr: abbr,
		           toLocalDate: toLocalDate
		        };
		    })();
	
		    kendo.date = (function(){
		        var MS_PER_MINUTE = 60000,
		            MS_PER_DAY = 86400000;
	
		        function adjustDST(date, hours) {
		            if (hours === 0 && date.getHours() === 23) {
		                date.setHours(date.getHours() + 2);
		                return true;
		            }
	
		            return false;
		        }
	
		        function setDayOfWeek(date, day, dir) {
		            var hours = date.getHours();
	
		            dir = dir || 1;
		            day = ((day - date.getDay()) + (7 * dir)) % 7;
	
		            date.setDate(date.getDate() + day);
		            adjustDST(date, hours);
		        }
	
		        function dayOfWeek(date, day, dir) {
		            date = new Date(date);
		            setDayOfWeek(date, day, dir);
		            return date;
		        }
	
		        function firstDayOfMonth(date) {
		            return new Date(
		                date.getFullYear(),
		                date.getMonth(),
		                1
		            );
		        }
	
		        function lastDayOfMonth(date) {
		            var last = new Date(date.getFullYear(), date.getMonth() + 1, 0),
		                first = firstDayOfMonth(date),
		                timeOffset = Math.abs(last.getTimezoneOffset() - first.getTimezoneOffset());
	
		            if (timeOffset) {
		                last.setHours(first.getHours() + (timeOffset / 60));
		            }
	
		            return last;
		        }
	
		        function moveDateToWeekStart(date, weekStartDay) {
		            if (weekStartDay !== 1) {
		                return addDays(dayOfWeek(date, weekStartDay, -1), 4);
		            }
	
		            return addDays(date, (4 - (date.getDay() || 7)));
		        }
	
		        function calcWeekInYear(date, weekStartDay) {
		            var firstWeekInYear = new Date(date.getFullYear(), 0, 1, -6);
	
		            var newDate = moveDateToWeekStart(date, weekStartDay);
	
		            var diffInMS = newDate.getTime() - firstWeekInYear.getTime();
	
		            var days = Math.floor(diffInMS / MS_PER_DAY);
	
		            return 1 + Math.floor(days / 7);
		        }
	
		        function weekInYear(date, weekStartDay) {
		            if(weekStartDay === undefined) {
		                weekStartDay = kendo.culture().calendar.firstDay;
		            }
	
		            var prevWeekDate = addDays(date, -7);
		            var nextWeekDate = addDays(date, 7);
	
		            var weekNumber = calcWeekInYear(date, weekStartDay);
	
		            if (weekNumber === 0) {
		                return calcWeekInYear(prevWeekDate, weekStartDay) + 1;
		            }
	
		            if (weekNumber === 53 && calcWeekInYear(nextWeekDate, weekStartDay) > 1) {
		                return 1;
		            }
	
		            return weekNumber;
		        }
	
		        function getDate(date) {
		            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
		            adjustDST(date, 0);
		            return date;
		        }
	
		        function toUtcTime(date) {
		            return Date.UTC(date.getFullYear(), date.getMonth(),
		                        date.getDate(), date.getHours(), date.getMinutes(),
		                        date.getSeconds(), date.getMilliseconds());
		        }
	
		        function getMilliseconds(date) {
		            return toInvariantTime(date).getTime() - getDate(toInvariantTime(date));
		        }
	
		        function isInTimeRange(value, min, max) {
		            var msMin = getMilliseconds(min),
		                msMax = getMilliseconds(max),
		                msValue;
	
		            if (!value || msMin == msMax) {
		                return true;
		            }
	
		            if (min >= max) {
		                max += MS_PER_DAY;
		            }
	
		            msValue = getMilliseconds(value);
	
		            if (msMin > msValue) {
		                msValue += MS_PER_DAY;
		            }
	
		            if (msMax < msMin) {
		                msMax += MS_PER_DAY;
		            }
	
		            return msValue >= msMin && msValue <= msMax;
		        }
	
		        function isInDateRange(value, min, max) {
		            var msMin = min.getTime(),
		                msMax = max.getTime(),
		                msValue;
	
		            if (msMin >= msMax) {
		                msMax += MS_PER_DAY;
		            }
	
		            msValue = value.getTime();
	
		            return msValue >= msMin && msValue <= msMax;
		        }
	
		        function addDays(date, offset) {
		            var hours = date.getHours();
		                date = new Date(date);
	
		            setTime(date, offset * MS_PER_DAY);
		            adjustDST(date, hours);
		            return date;
		        }
	
		        function setTime(date, milliseconds, ignoreDST) {
		            var offset = date.getTimezoneOffset();
		            var difference;
	
		            date.setTime(date.getTime() + milliseconds);
	
		            if (!ignoreDST) {
		                difference = date.getTimezoneOffset() - offset;
		                date.setTime(date.getTime() + difference * MS_PER_MINUTE);
		            }
		        }
	
		        function setHours(date, time) {
		            date = new Date(kendo.date.getDate(date).getTime() + kendo.date.getMilliseconds(time));
		            adjustDST(date, time.getHours());
		            return date;
		        }
	
		        function today() {
		            return getDate(new Date());
		        }
	
		        function isToday(date) {
		           return getDate(date).getTime() == today().getTime();
		        }
	
		        function toInvariantTime(date) {
		            var staticDate = new Date(1980, 1, 1, 0, 0, 0);
	
		            if (date) {
		                staticDate.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
		            }
	
		            return staticDate;
		        }
	
		        return {
		            adjustDST: adjustDST,
		            dayOfWeek: dayOfWeek,
		            setDayOfWeek: setDayOfWeek,
		            getDate: getDate,
		            isInDateRange: isInDateRange,
		            isInTimeRange: isInTimeRange,
		            isToday: isToday,
		            nextDay: function(date) {
		                return addDays(date, 1);
		            },
		            previousDay: function(date) {
		                return addDays(date, -1);
		            },
		            toUtcTime: toUtcTime,
		            MS_PER_DAY: MS_PER_DAY,
		            MS_PER_HOUR: 60 * MS_PER_MINUTE,
		            MS_PER_MINUTE: MS_PER_MINUTE,
		            setTime: setTime,
		            setHours: setHours,
		            addDays: addDays,
		            today: today,
		            toInvariantTime: toInvariantTime,
		            firstDayOfMonth: firstDayOfMonth,
		            lastDayOfMonth: lastDayOfMonth,
		            weekInYear: weekInYear,
		            getMilliseconds: getMilliseconds
		        };
		    })();
	
	
		    kendo.stripWhitespace = function(element) {
		        if (document.createNodeIterator) {
		            var iterator = document.createNodeIterator(element, NodeFilter.SHOW_TEXT, function(node) {
		                    return node.parentNode == element ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
		                }, false);
	
		            while (iterator.nextNode()) {
		                if (iterator.referenceNode && !iterator.referenceNode.textContent.trim()) {
		                    iterator.referenceNode.parentNode.removeChild(iterator.referenceNode);
		                }
		            }
		        } else { // IE7/8 support
		            for (var i = 0; i < element.childNodes.length; i++) {
		                var child = element.childNodes[i];
	
		                if (child.nodeType == 3 && !/\S/.test(child.nodeValue)) {
		                    element.removeChild(child);
		                    i--;
		                }
	
		                if (child.nodeType == 1) {
		                    kendo.stripWhitespace(child);
		                }
		            }
		        }
		    };
	
		    var animationFrame  = window.requestAnimationFrame       ||
		                          window.webkitRequestAnimationFrame ||
		                          window.mozRequestAnimationFrame    ||
		                          window.oRequestAnimationFrame      ||
		                          window.msRequestAnimationFrame     ||
		                          function(callback){ setTimeout(callback, 1000 / 60); };
	
		    kendo.animationFrame = function(callback) {
		        animationFrame.call(window, callback);
		    };
	
		    var animationQueue = [];
	
		    kendo.queueAnimation = function(callback) {
		        animationQueue[animationQueue.length] = callback;
		        if (animationQueue.length === 1) {
		            kendo.runNextAnimation();
		        }
		    };
	
		    kendo.runNextAnimation = function() {
		        kendo.animationFrame(function() {
		            if (animationQueue[0]) {
		                animationQueue.shift()();
		                if (animationQueue[0]) {
		                    kendo.runNextAnimation();
		                }
		            }
		        });
		    };
	
		    kendo.parseQueryStringParams = function(url) {
		        var queryString = url.split('?')[1] || "",
		            params = {},
		            paramParts = queryString.split(/&|=/),
		            length = paramParts.length,
		            idx = 0;
	
		        for (; idx < length; idx += 2) {
		            if(paramParts[idx] !== "") {
		                params[decodeURIComponent(paramParts[idx])] = decodeURIComponent(paramParts[idx + 1]);
		            }
		        }
	
		        return params;
		    };
	
		    kendo.elementUnderCursor = function(e) {
		        if (typeof e.x.client != "undefined") {
		            return document.elementFromPoint(e.x.client, e.y.client);
		        }
		    };
	
		    kendo.wheelDeltaY = function(jQueryEvent) {
		        var e = jQueryEvent.originalEvent,
		            deltaY = e.wheelDeltaY,
		            delta;
	
		            if (e.wheelDelta) { // Webkit and IE
		                if (deltaY === undefined || deltaY) { // IE does not have deltaY, thus always scroll (horizontal scrolling is treated as vertical)
		                    delta = e.wheelDelta;
		                }
		            } else if (e.detail && e.axis === e.VERTICAL_AXIS) { // Firefox and Opera
		                delta = (-e.detail) * 10;
		            }
	
		        return delta;
		    };
	
		    kendo.throttle = function(fn, delay) {
		        var timeout;
		        var lastExecTime = 0;
	
		        if (!delay || delay <= 0) {
		            return fn;
		        }
	
		        var throttled = function() {
		            var that = this;
		            var elapsed = +new Date() - lastExecTime;
		            var args = arguments;
	
		            function exec() {
		                fn.apply(that, args);
		                lastExecTime = +new Date();
		            }
	
		            // first execution
		            if (!lastExecTime) {
		                return exec();
		            }
	
		            if (timeout) {
		                clearTimeout(timeout);
		            }
	
		            if (elapsed > delay) {
		                exec();
		            } else {
		                timeout = setTimeout(exec, delay - elapsed);
		            }
		        };
	
		        throttled.cancel = function() {
		            clearTimeout(timeout);
		        };
	
		        return throttled;
		    };
	
	
		    kendo.caret = function (element, start, end) {
		        var rangeElement;
		        var isPosition = start !== undefined;
	
		        if (end === undefined) {
		            end = start;
		        }
	
		        if (element[0]) {
		            element = element[0];
		        }
	
		        if (isPosition && element.disabled) {
		            return;
		        }
	
		        try {
		            if (element.selectionStart !== undefined) {
		                if (isPosition) {
		                    element.focus();
		                    var mobile = support.mobileOS;
		                    if(mobile.wp || mobile.android) {// without the timeout the caret is at the end of the input
		                        setTimeout(function() { element.setSelectionRange(start, end); }, 0);
		                    }
		                    else {
		                        element.setSelectionRange(start, end);
		                    }
		                } else {
		                    start = [element.selectionStart, element.selectionEnd];
		                }
		            } else if (document.selection) {
		                if ($(element).is(":visible")) {
		                    element.focus();
		                }
	
		                rangeElement = element.createTextRange();
	
		                if (isPosition) {
		                    rangeElement.collapse(true);
		                    rangeElement.moveStart("character", start);
		                    rangeElement.moveEnd("character", end - start);
		                    rangeElement.select();
		                } else {
		                    var rangeDuplicated = rangeElement.duplicate(),
		                        selectionStart, selectionEnd;
	
		                        rangeElement.moveToBookmark(document.selection.createRange().getBookmark());
		                        rangeDuplicated.setEndPoint('EndToStart', rangeElement);
		                        selectionStart = rangeDuplicated.text.length;
		                        selectionEnd = selectionStart + rangeElement.text.length;
	
		                    start = [selectionStart, selectionEnd];
		                }
		            }
		        } catch(e) {
		            /* element is not focused or it is not in the DOM */
		            start = [];
		        }
	
		        return start;
		    };
	
		    kendo.compileMobileDirective = function(element, scope) {
		        var angular = window.angular;
	
		        element.attr("data-" + kendo.ns + "role", element[0].tagName.toLowerCase().replace('kendo-mobile-', '').replace('-', ''));
	
		        angular.element(element).injector().invoke(["$compile", function($compile) {
		            $compile(element)(scope);
	
		            if (!/^\$(digest|apply)$/.test(scope.$$phase)) {
		                scope.$digest();
		            }
		        }]);
	
		        return kendo.widgetInstance(element, kendo.mobile.ui);
		    };
	
		    kendo.antiForgeryTokens = function() {
		        var tokens = { },
		            csrf_token = $("meta[name=csrf-token],meta[name=_csrf]").attr("content"),
		            csrf_param = $("meta[name=csrf-param],meta[name=_csrf_header]").attr("content");
	
		        $("input[name^='__RequestVerificationToken']").each(function() {
		            tokens[this.name] = this.value;
		        });
	
		        if (csrf_param !== undefined && csrf_token !== undefined) {
		          tokens[csrf_param] = csrf_token;
		        }
	
		        return tokens;
		    };
	
		    kendo.cycleForm = function(form) {
		        var firstElement = form.find("input, .k-widget").first();
		        var lastElement = form.find("button, .k-button").last();
	
		        function focus(el) {
		            var widget = kendo.widgetInstance(el);
	
		            if (widget && widget.focus) {
		              widget.focus();
		            } else {
		              el.focus();
		            }
		        }
	
		        lastElement.on("keydown", function(e) {
		          if (e.keyCode == kendo.keys.TAB && !e.shiftKey) {
		            e.preventDefault();
		            focus(firstElement);
		          }
		        });
	
		        firstElement.on("keydown", function(e) {
		          if (e.keyCode == kendo.keys.TAB && e.shiftKey) {
		            e.preventDefault();
		            focus(lastElement);
		          }
		        });
		    };
	
		    kendo.focusElement = function(element) {
		        var scrollTopPositions = [];
		        var scrollableParents = element.parentsUntil("body")
		                .filter(function(index, element) {
		                    var computedStyle = kendo.getComputedStyles(element, ["overflow"]);
		                    return computedStyle.overflow !== "visible";
		                })
		                .add(window);
	
		        scrollableParents.each(function(index, parent) {
		            scrollTopPositions[index] = $(parent).scrollTop();
		        });
	
		        try {
		            //The setActive method does not cause the document to scroll to the active object in the current page
		            element[0].setActive();
		        } catch (e) {
		            element[0].focus();
		        }
	
		        scrollableParents.each(function(index, parent) {
		            $(parent).scrollTop(scrollTopPositions[index]);
		        });
		    };
	
		    kendo.matchesMedia = function(mediaQuery) {
		        var media = kendo._bootstrapToMedia(mediaQuery) || mediaQuery;
		        return support.matchMedia && window.matchMedia(media).matches;
		    };
	
		    kendo._bootstrapToMedia = function(bootstrapMedia) {
		        return {
		            "xs": "(max-width: 576px)",
		            "sm": "(min-width: 576px)",
		            "md": "(min-width: 768px)",
		            "lg": "(min-width: 992px)",
		            "xl": "(min-width: 1200px)"
		        }[bootstrapMedia];
		    };
	
		    // kendo.saveAs -----------------------------------------------
		    (function() {
		        function postToProxy(dataURI, fileName, proxyURL, proxyTarget) {
		            var form = $("<form>").attr({
		                action: proxyURL,
		                method: "POST",
		                target: proxyTarget
		            });
	
		            var data = kendo.antiForgeryTokens();
		            data.fileName = fileName;
	
		            var parts = dataURI.split(";base64,");
		            data.contentType = parts[0].replace("data:", "");
		            data.base64 = parts[1];
	
		            for (var name in data) {
		                if (data.hasOwnProperty(name)) {
		                    $('<input>').attr({
		                        value: data[name],
		                        name: name,
		                        type: "hidden"
		                    }).appendTo(form);
		                }
		            }
	
		            form.appendTo("body").submit().remove();
		        }
	
		        var fileSaver = document.createElement("a");
		        var downloadAttribute = "download" in fileSaver && !kendo.support.browser.edge;
	
		        function saveAsBlob(dataURI, fileName) {
		            var blob = dataURI; // could be a Blob object
	
		            if (typeof dataURI == "string") {
		                var parts = dataURI.split(";base64,");
		                var contentType = parts[0];
		                var base64 = atob(parts[1]);
		                var array = new Uint8Array(base64.length);
	
		                for (var idx = 0; idx < base64.length; idx++) {
		                    array[idx] = base64.charCodeAt(idx);
		                }
		                blob = new Blob([array.buffer], { type: contentType });
		            }
	
		            navigator.msSaveBlob(blob, fileName);
		        }
	
		        function saveAsDataURI(dataURI, fileName) {
		            if (window.Blob && dataURI instanceof Blob) {
		                dataURI = URL.createObjectURL(dataURI);
		            }
	
		            fileSaver.download = fileName;
		            fileSaver.href = dataURI;
	
		            var e = document.createEvent("MouseEvents");
		            e.initMouseEvent("click", true, false, window,
		                0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
		            fileSaver.dispatchEvent(e);
		            setTimeout(function(){
		                URL.revokeObjectURL(dataURI);
		            });
		        }
	
		        kendo.saveAs = function(options) {
		            var save = postToProxy;
	
		            if (!options.forceProxy) {
		                if (downloadAttribute) {
		                    save = saveAsDataURI;
		                } else if (navigator.msSaveBlob) {
		                    save = saveAsBlob;
		                }
		            }
	
		            save(options.dataURI, options.fileName, options.proxyURL, options.proxyTarget);
		        };
		    })();
	
		    // kendo proxySetters
		    kendo.proxyModelSetters = function proxyModelSetters(data) {
		        var observable = {};
	
		        Object.keys(data || {}).forEach(function(property) {
		          Object.defineProperty(observable, property, {
		            get: function() {
		              return data[property];
		            },
		            set: function(value) {
		              data[property] = value;
		              data.dirty = true;
		            }
		          });
		        });
	
		        return observable;
		    };
	
		})(jQuery, window);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(921);
		module.exports = __webpack_require__(921);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 921:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(922), __webpack_require__(923), __webpack_require__(924) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		/* jshint eqnull:true */
		/* jshint -W069 */
		/* jshint latedef: nofunc */
	
		window.kendo = window.kendo || {};
		var kendoDrawing = kendo.drawing;
		var kendoDrawingUtil = kendoDrawing.util;
		var Class = kendo.Class;
		var kendoUtil = kendo.util;
		var support = kendo.support;
		var supportBrowser = support.browser;
	
		var createPromise = kendoDrawingUtil.createPromise;
		var promiseAll = kendoDrawingUtil.promiseAll;
	
		var ObserversMixin = {
		    extend: function(proto) {
		        var this$1 = this;
	
		        for (var method in this) {
		            if (method !== "extend") {
		                proto[method] = this$1[method];
		            }
		        }
		    },
	
		    observers: function() {
		        this._observers = this._observers || [];
		        return this._observers;
		    },
	
		    addObserver: function(element) {
		        if (!this._observers) {
		            this._observers = [ element ];
		        } else {
		            this._observers.push(element);
		        }
		        return this;
		    },
	
		    removeObserver: function(element) {
		        var observers = this.observers();
		        var index = observers.indexOf(element);
		        if (index !== -1) {
		            observers.splice(index, 1);
		        }
		        return this;
		    },
	
		    trigger: function(methodName, event) {
		        var observers = this._observers;
	
		        if (observers && !this._suspended) {
		            for (var idx = 0; idx < observers.length; idx++) {
		                var observer = observers[idx];
		                if (observer[methodName]) {
		                    observer[methodName](event);
		                }
		            }
		        }
		        return this;
		    },
	
		    optionsChange: function(e) {
		        if (e === void 0) { e = {}; }
	
		        e.element = this;
		        this.trigger("optionsChange", e);
		    },
	
		    geometryChange: function() {
		        this.trigger("geometryChange", {
		            element: this
		        });
		    },
	
		    suspend: function() {
		        this._suspended = (this._suspended || 0) + 1;
		        return this;
		    },
	
		    resume: function() {
		        this._suspended = Math.max((this._suspended || 0) - 1, 0);
		        return this;
		    },
	
		    _observerField: function(field, value) {
		        if (this[field]) {
		            this[field].removeObserver(this);
		        }
		        this[field] = value;
		        value.addObserver(this);
		    }
		};
	
		function append(first, second) {
		    first.push.apply(first, second);
		    return first;
		}
	
		/* eslint-disable key-spacing,no-multi-spaces,no-param-reassign */
	
		var literals = {
		    1    : "i",       10   : "x",       100  : "c",
		    2    : "ii",      20   : "xx",      200  : "cc",
		    3    : "iii",     30   : "xxx",     300  : "ccc",
		    4    : "iv",      40   : "xl",      400  : "cd",
		    5    : "v",       50   : "l",       500  : "d",
		    6    : "vi",      60   : "lx",      600  : "dc",
		    7    : "vii",     70   : "lxx",     700  : "dcc",
		    8    : "viii",    80   : "lxxx",    800  : "dccc",
		    9    : "ix",      90   : "xc",      900  : "cm",
		    1000 : "m"
		};
	
		function arabicToRoman(n) {
		    var values = [ 1000,
		                   900 , 800, 700, 600, 500, 400, 300, 200, 100,
		                   90  , 80 , 70 , 60 , 50 , 40 , 30 , 20 , 10 ,
		                   9   , 8  , 7  , 6  , 5  , 4  , 3  , 2  , 1 ];
	
		    var roman = "";
		    while (n > 0) {
		        if (n < values[0]) {
		            values.shift();
		        } else {
		            roman += literals[values[0]];
		            n -= values[0];
		        }
		    }
		    return roman;
		}
	
		var UNDEFINED = "undefined";
	
		function defined(value) {
		    return typeof value !== UNDEFINED;
		}
	
		var defId = 1;
	
		function definitionId() {
		    return "kdef" + defId++;
		}
	
		var DEG_TO_RAD = Math.PI / 180;
		var MAX_NUM = Number.MAX_VALUE;
		var MIN_NUM = -Number.MAX_VALUE;
	
		function deg(radians) {
		    return radians / DEG_TO_RAD;
		}
	
		var KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
		var fromCharCode = String.fromCharCode;
	
		function encodeUTF8(input) {
		    var output = "";
	
		    for (var i = 0; i < input.length; i++) {
		        var c = input.charCodeAt(i);
	
		        if (c < 0x80) {
		            // One byte
		            output += fromCharCode(c);
		        } else if (c < 0x800) {
		            // Two bytes
		            output += fromCharCode(0xC0 | (c >>> 6));
		            output += fromCharCode(0x80 | (c & 0x3f));
		        } else if (c < 0x10000) {
		            // Three bytes
		            output += fromCharCode(0xE0 | (c >>> 12));
		            output += fromCharCode(0x80 | (c >>> 6 & 0x3f));
		            output += fromCharCode(0x80 | (c & 0x3f));
		        }
		    }
	
		    return output;
		}
	
		function encodeBase64(input) {
		    var output = "";
		    var i = 0;
	
		    var utfInput = encodeUTF8(input);
	
		    while (i < utfInput.length) {
		        var chr1 = utfInput.charCodeAt(i++);
		        var chr2 = utfInput.charCodeAt(i++);
		        var chr3 = utfInput.charCodeAt(i++);
	
		        var enc1 = chr1 >> 2;
		        var enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
		        var enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
		        var enc4 = chr3 & 63;
	
		        if (isNaN(chr2)) {
		            enc3 = enc4 = 64;
		        } else if (isNaN(chr3)) {
		            enc4 = 64;
		        }
	
		        output = output +
		            KEY_STR.charAt(enc1) + KEY_STR.charAt(enc2) +
		            KEY_STR.charAt(enc3) + KEY_STR.charAt(enc4);
		    }
	
		    return output;
		}
	
		function eventCoordinates(e) {
		    if (defined((e.x || {}).location)) {
		        return {
		            x: e.x.location,
		            y: e.y.location
		        };
		    }
	
		    return {
		        x: e.pageX || e.clientX || 0,
		        y: e.pageY || e.clientY || 0
		    };
		}
	
		function eventElement(e) {
		    if (e === void 0) { e = {}; }
	
		    return e.touch ? e.touch.initialTouch : e.target;
		}
	
		function isTransparent(color) {
		    return color === "" || color === null || color === "none" || color === "transparent" || !defined(color);
		}
	
		function last(array) {
		    if (array) {
		        return array[array.length - 1];
		    }
		}
	
		function limitValue(value, min, max) {
		    return Math.max(Math.min(value, max), min);
		}
	
		/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
		/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
		/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
		/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
		// mergeSort is stable.
		function mergeSort(a, cmp) {
		    if (a.length < 2) {
		        return a.slice();
		    }
		    function merge(a, b) {
		        var r = [], ai = 0, bi = 0, i = 0;
		        while (ai < a.length && bi < b.length) {
		            if (cmp(a[ai], b[bi]) <= 0) {
		                r[i++] = a[ai++];
		            } else {
		                r[i++] = b[bi++];
		            }
		        }
		        if (ai < a.length) {
		            r.push.apply(r, a.slice(ai));
		        }
		        if (bi < b.length) {
		            r.push.apply(r, b.slice(bi));
		        }
		        return r;
		    }
		    return (function sort(a) {
		        if (a.length <= 1) {
		            return a;
		        }
		        var m = Math.floor(a.length / 2);
		        var left = a.slice(0, m);
		        var right = a.slice(m);
		        left = sort(left);
		        right = sort(right);
		        return merge(left, right);
		    })(a);
		}
	
		function rad(degrees) {
		    return degrees * DEG_TO_RAD;
		}
	
		function pow(p) {
		    if (p) {
		        return Math.pow(10, p);
		    }
	
		    return 1;
		}
	
		function round(value, precision) {
		    var power = pow(precision);
		    return Math.round(value * power) / power;
		}
	
		function valueOrDefault(value, defaultValue) {
		    return defined(value) ? value : defaultValue;
		}
	
		function bindEvents(element, events) {
		    for (var eventName in events) {
		        var eventNames = eventName.trim().split(" ");
		        for (var idx = 0; idx < eventNames.length; idx++) {
		            element.addEventListener(eventNames[idx], events[eventName], false);
		        }
		    }
		}
	
		function elementOffset(element) {
		    var box = element.getBoundingClientRect();
	
		    var documentElement = document.documentElement;
	
		    return {
		        top: box.top + (window.pageYOffset || documentElement.scrollTop) - (documentElement.clientTop || 0),
		        left: box.left + (window.pageXOffset || documentElement.scrollLeft) - (documentElement.clientLeft || 0)
		    };
		}
	
		function elementStyles(element, styles) {
		    var result = {};
		    var style = window.getComputedStyle(element) || {};
		    var stylesArray = Array.isArray(styles) ? styles : [ styles ];
	
		    for (var idx = 0; idx < stylesArray.length; idx++) {
		        var field = stylesArray[idx];
		        result[field] = style[field];
		    }
	
		    return result;
		}
	
		function getPixels(value) {
		    if (isNaN(value)) {
		        return value;
		    }
		    return value + "px";
		}
	
		function elementSize(element, size) {
		    if (size) {
		        var width = size.width;
		        var height = size.height;
	
		        if (defined(width)) {
		            element.style.width = getPixels(width);
		        }
	
		        if (defined(height)) {
		            element.style.height = getPixels(height);
		        }
	
		    } else {
		        var size$1 = elementStyles(element, [ 'width', 'height' ]);
	
		        return {
		            width: parseInt(size$1.width, 10),
		            height: parseInt(size$1.height, 10)
		        };
		    }
		}
	
		function unbindEvents(element, events) {
		    if (events === void 0) { events = {}; }
	
		    for (var name in events) {
		        var eventNames = name.trim().split(" ");
		        for (var idx = 0; idx < eventNames.length; idx++) {
		            element.removeEventListener(eventNames[idx], events[name], false);
		        }
		    }
		}
	
		var util = {
			append: append,
			arabicToRoman: arabicToRoman,
			createPromise: createPromise,
			defined: defined,
			definitionId: definitionId,
			deg: deg,
			encodeBase64: encodeBase64,
			eventCoordinates: eventCoordinates,
			eventElement: eventElement,
			isTransparent: isTransparent,
			last: last,
			limitValue: limitValue,
			mergeSort: mergeSort,
			promiseAll: promiseAll,
			rad: rad,
			round: round,
			valueOrDefault: valueOrDefault,
			bindEvents: bindEvents,
			elementOffset: elementOffset,
			elementSize: elementSize,
			elementStyles: elementStyles,
			unbindEvents: unbindEvents,
			DEG_TO_RAD: DEG_TO_RAD,
			MAX_NUM: MAX_NUM,
			MIN_NUM: MIN_NUM
		};
	
		var toString = {}.toString;
	
		var OptionsStore = Class.extend({
		    init: function(options, prefix) {
		        var this$1 = this;
		        if (prefix === void 0) { prefix = ""; }
	
		        this.prefix = prefix;
	
		        for (var field in options) {
		            var member = options[field];
		            member = this$1._wrap(member, field);
		            this$1[field] = member;
		        }
		    },
	
		    get: function(field) {
		        var parts = field.split(".");
		        var result = this;
	
		        while (parts.length && result) {
		            var part = parts.shift();
		            result = result[part];
		        }
	
		        return result;
		    },
	
		    set: function(field, value) {
		        var current = this.get(field);
	
		        if (current !== value) {
		            this._set(field, this._wrap(value, field));
		            this.optionsChange({
		                field: this.prefix + field,
		                value: value
		            });
		        }
		    },
	
		    _set: function(field, value) {
		        var this$1 = this;
	
		        var composite = field.indexOf(".") >= 0;
		        var parentObj = this;
		        var fieldName = field;
	
		        if (composite) {
		            var parts = fieldName.split(".");
		            var prefix = this.prefix;
	
		            while (parts.length > 1) {
		                fieldName = parts.shift();
		                prefix += fieldName + ".";
	
		                var obj = parentObj[fieldName];
	
		                if (!obj) {
		                    obj = new OptionsStore({}, prefix);
		                    obj.addObserver(this$1);
		                    parentObj[fieldName] = obj;
		                }
		                parentObj = obj;
		            }
		            fieldName = parts[0];
		        }
	
		        parentObj._clear(fieldName);
		        parentObj[fieldName] = value;
		    },
	
		    _clear: function(field) {
		        var current = this[field];
		        if (current && current.removeObserver) {
		            current.removeObserver(this);
		        }
		    },
	
		    _wrap: function(object, field) {
		        var type = toString.call(object);
		        var wrapped = object;
	
		        if (wrapped !== null && defined(wrapped) && type === "[object Object]") {
		            if (!(object instanceof OptionsStore) && !(object instanceof Class)) {
		                wrapped = new OptionsStore(wrapped, this.prefix + field + ".");
		            }
	
		            wrapped.addObserver(this);
		        }
	
		        return wrapped;
		    }
		});
	
		ObserversMixin.extend(OptionsStore.prototype);
	
		function setAccessor(field) {
		    return function(value) {
		        if (this[field] !== value) {
		            this[field] = value;
		            this.geometryChange();
		        }
	
		        return this;
		    };
		}
	
		function getAccessor(field) {
		    return function() {
		        return this[field];
		    };
		}
	
		function defineAccessors(fn, fields) {
		    for (var i = 0; i < fields.length; i++) {
		        var name = fields[i];
		        var capitalized = name.charAt(0).toUpperCase() +
		                          name.substring(1, name.length);
	
		        fn["set" + capitalized] = setAccessor(name);
		        fn["get" + capitalized] = getAccessor(name);
		    }
		}
	
		var Matrix = Class.extend({
		    init: function(a, b, c, d, e, f) {
		        if (a === void 0) { a = 0; }
		        if (b === void 0) { b = 0; }
		        if (c === void 0) { c = 0; }
		        if (d === void 0) { d = 0; }
		        if (e === void 0) { e = 0; }
		        if (f === void 0) { f = 0; }
	
		        this.a = a;
		        this.b = b;
		        this.c = c;
		        this.d = d;
		        this.e = e;
		        this.f = f;
		    },
	
		    multiplyCopy: function(matrix) {
		        return new Matrix(
		            this.a * matrix.a + this.c * matrix.b,
		            this.b * matrix.a + this.d * matrix.b,
		            this.a * matrix.c + this.c * matrix.d,
		            this.b * matrix.c + this.d * matrix.d,
		            this.a * matrix.e + this.c * matrix.f + this.e,
		            this.b * matrix.e + this.d * matrix.f + this.f
		        );
		    },
	
		    invert: function() {
		        var ref = this;
		        var a = ref.a;
		        var b = ref.b;
		        var d = ref.c;
		        var e = ref.d;
		        var g = ref.e;
		        var h = ref.f;
		        var det = a * e - b * d;
	
		        if (det === 0) {
		            return null;
		        }
	
		        return new Matrix(e / det, -b / det, -d / det, a / det,
		                          (d * h - e * g) / det, (b * g - a * h) / det);
		    },
	
		    clone: function() {
		        return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
		    },
	
		    equals: function(other) {
		        if (!other) {
		            return false;
		        }
	
		        return this.a === other.a && this.b === other.b &&
		               this.c === other.c && this.d === other.d &&
		               this.e === other.e && this.f === other.f;
		    },
	
		    round: function(precision) {
		        this.a = round(this.a, precision);
		        this.b = round(this.b, precision);
		        this.c = round(this.c, precision);
		        this.d = round(this.d, precision);
		        this.e = round(this.e, precision);
		        this.f = round(this.f, precision);
	
		        return this;
		    },
	
		    toArray: function(precision) {
		        var result = [ this.a, this.b, this.c, this.d, this.e, this.f ];
	
		        if (defined(precision)) {
		            for (var i = 0; i < result.length; i++) {
		                result[i] = round(result[i], precision);
		            }
		        }
	
		        return result;
		    },
	
		    toString: function(precision, separator) {
		        if (separator === void 0) { separator = ","; }
	
		        return this.toArray(precision).join(separator);
		    }
		});
	
		Matrix.translate = function(x, y) {
		    return new Matrix(1, 0, 0, 1, x, y);
		};
	
		Matrix.unit = function() {
		    return new Matrix(1, 0, 0, 1, 0, 0);
		};
	
		Matrix.rotate = function(angle, x, y) {
		    var matrix = new Matrix();
		    matrix.a = Math.cos(rad(angle));
		    matrix.b = Math.sin(rad(angle));
		    matrix.c = -matrix.b;
		    matrix.d = matrix.a;
		    matrix.e = (x - x * matrix.a + y * matrix.b) || 0;
		    matrix.f = (y - y * matrix.a - x * matrix.b) || 0;
	
		    return matrix;
		};
	
		Matrix.scale = function(scaleX, scaleY) {
		    return new Matrix(scaleX, 0, 0, scaleY, 0, 0);
		};
	
		Matrix.IDENTITY = Matrix.unit();
	
		function toMatrix(transformation) {
		    if (transformation && typeof transformation.matrix === "function") {
		        return transformation.matrix();
		    }
	
		    return transformation;
		}
	
		var Point = Class.extend({
		    init: function(x, y) {
	
		        this.x = x || 0;
		        this.y = y || 0;
		    },
	
		    equals: function(other) {
		        return other && other.x === this.x && other.y === this.y;
		    },
	
		    clone: function() {
		        return new Point(this.x, this.y);
		    },
	
		    rotate: function(angle, origin) {
		        var originPoint = Point.create(origin) || Point.ZERO;
	
		        return this.transform(Matrix.rotate(angle, originPoint.x, originPoint.y));
		    },
	
		    translate: function(x, y) {
		        this.x += x;
		        this.y += y;
	
		        this.geometryChange();
	
		        return this;
		    },
	
		    translateWith: function(point) {
		        return this.translate(point.x, point.y);
		    },
	
		    move: function(x, y) {
		        this.x = this.y = 0;
		        return this.translate(x, y);
		    },
	
		    scale: function(scaleX, scaleY) {
		        if (scaleY === void 0) { scaleY = scaleX; }
	
		        this.x *= scaleX;
		        this.y *= scaleY;
	
		        this.geometryChange();
	
		        return this;
		    },
	
		    scaleCopy: function(scaleX, scaleY) {
		        return this.clone().scale(scaleX, scaleY);
		    },
	
		    transform: function(transformation) {
		        var matrix = toMatrix(transformation);
		        var ref = this;
		        var x = ref.x;
		        var y = ref.y;
	
		        this.x = matrix.a * x + matrix.c * y + matrix.e;
		        this.y = matrix.b * x + matrix.d * y + matrix.f;
	
		        this.geometryChange();
	
		        return this;
		    },
	
		    transformCopy: function(transformation) {
		        var point = this.clone();
	
		        if (transformation) {
		            point.transform(transformation);
		        }
	
		        return point;
		    },
	
		    distanceTo: function(point) {
		        var dx = this.x - point.x;
		        var dy = this.y - point.y;
	
		        return Math.sqrt(dx * dx + dy * dy);
		    },
	
		    round: function(digits) {
		        this.x = round(this.x, digits);
		        this.y = round(this.y, digits);
	
		        this.geometryChange();
	
		        return this;
		    },
	
		    toArray: function(digits) {
		        var doRound = defined(digits);
		        var x = doRound ? round(this.x, digits) : this.x;
		        var y = doRound ? round(this.y, digits) : this.y;
	
		        return [ x, y ];
		    },
	
		    toString: function(digits, separator) {
		        if (separator === void 0) { separator = " "; }
	
		        var ref = this;
		        var x = ref.x;
		        var y = ref.y;
	
		        if (defined(digits)) {
		            x = round(x, digits);
		            y = round(y, digits);
		        }
	
		        return x + separator + y;
		    }
		});
	
		Point.create = function(arg0, arg1) {
		    if (defined(arg0)) {
		        if (arg0 instanceof Point) {
		            return arg0;
		        } else if (arguments.length === 1 && arg0.length === 2) {
		            return new Point(arg0[0], arg0[1]);
		        }
	
		        return new Point(arg0, arg1);
		    }
		};
	
		Point.min = function() {
		    var arguments$1 = arguments;
	
		    var minX = MAX_NUM;
		    var minY = MAX_NUM;
	
		    for (var i = 0; i < arguments.length; i++) {
		        var point = arguments$1[i];
		        minX = Math.min(point.x, minX);
		        minY = Math.min(point.y, minY);
		    }
	
		    return new Point(minX, minY);
		};
	
		Point.max = function() {
		    var arguments$1 = arguments;
	
		    var maxX = MIN_NUM;
		    var maxY = MIN_NUM;
	
		    for (var i = 0; i < arguments.length; i++) {
		        var point = arguments$1[i];
		        maxX = Math.max(point.x, maxX);
		        maxY = Math.max(point.y, maxY);
		    }
	
		    return new Point(maxX, maxY);
		};
	
		Point.minPoint = function() {
		    return new Point(MIN_NUM, MIN_NUM);
		};
	
		Point.maxPoint = function() {
		    return new Point(MAX_NUM, MAX_NUM);
		};
	
		if (Object.defineProperties) {
		    Object.defineProperties(Point, {
		        ZERO: {
		            get: function() {
		                return new Point(0, 0);
		            }
		        }
		    });
		}
	
		defineAccessors(Point.prototype, [ "x", "y" ]);
		ObserversMixin.extend(Point.prototype);
	
		var Size = Class.extend({
		    init: function(width, height) {
	
		        this.width = width || 0;
		        this.height = height || 0;
		    },
	
		    equals: function(other) {
		        return other && other.width === this.width && other.height === this.height;
		    },
	
		    clone: function() {
		        return new Size(this.width, this.height);
		    },
	
		    toArray: function(digits) {
		        var doRound = defined(digits);
		        var width = doRound ? round(this.width, digits) : this.width;
		        var height = doRound ? round(this.height, digits) : this.height;
	
		        return [ width, height ];
		    }
		});
	
		Size.create = function(arg0, arg1) {
		    if (defined(arg0)) {
		        if (arg0 instanceof Size) {
		            return arg0;
		        } else if (arguments.length === 1 && arg0.length === 2) {
		            return new Size(arg0[0], arg0[1]);
		        }
	
		        return new Size(arg0, arg1);
		    }
		};
	
		if (Object.defineProperties) {
		    Object.defineProperties(Size, {
		        ZERO: {
		            get: function() {
		                return new Size(0, 0);
		            }
		        }
		    });
		}
	
		defineAccessors(Size.prototype, [ "width", "height" ]);
		ObserversMixin.extend(Size.prototype);
	
		var Rect = Class.extend({
		    init: function(origin, size) {
		        if (origin === void 0) { origin = new Point(); }
		        if (size === void 0) { size = new Size(); }
	
		        this.setOrigin(origin);
		        this.setSize(size);
		    },
	
		    clone: function() {
		        return new Rect(
		            this.origin.clone(),
		            this.size.clone()
		        );
		    },
	
		    equals: function(other) {
		        return other &&
		               other.origin.equals(this.origin) &&
		               other.size.equals(this.size);
		    },
	
		    setOrigin: function(value) {
		        this._observerField("origin", Point.create(value));
		        this.geometryChange();
		        return this;
		    },
	
		    getOrigin: function() {
		        return this.origin;
		    },
	
		    setSize: function(value) {
		        this._observerField("size", Size.create(value));
		        this.geometryChange();
		        return this;
		    },
	
		    getSize: function() {
		        return this.size;
		    },
	
		    width: function() {
		        return this.size.width;
		    },
	
		    height: function() {
		        return this.size.height;
		    },
	
		    topLeft: function() {
		        return this.origin.clone();
		    },
	
		    bottomRight: function() {
		        return this.origin.clone().translate(this.width(), this.height());
		    },
	
		    topRight: function() {
		        return this.origin.clone().translate(this.width(), 0);
		    },
	
		    bottomLeft: function() {
		        return this.origin.clone().translate(0, this.height());
		    },
	
		    center: function() {
		        return this.origin.clone().translate(this.width() / 2, this.height() / 2);
		    },
	
		    bbox: function(matrix) {
		        var tl = this.topLeft().transformCopy(matrix);
		        var tr = this.topRight().transformCopy(matrix);
		        var br = this.bottomRight().transformCopy(matrix);
		        var bl = this.bottomLeft().transformCopy(matrix);
	
		        return Rect.fromPoints(tl, tr, br, bl);
		    },
	
		    transformCopy: function(m) {
		        return Rect.fromPoints(
		            this.topLeft().transform(m),
		            this.bottomRight().transform(m)
		        );
		    },
	
		    expand: function(x, y) {
		        if (y === void 0) { y = x; }
	
		        this.size.width += 2 * x;
		        this.size.height += 2 * y;
	
		        this.origin.translate(-x, -y);
	
		        return this;
		    },
	
		    expandCopy: function(x, y) {
		        return this.clone().expand(x, y);
		    },
	
		    containsPoint: function(point) {
		        var origin = this.origin;
		        var bottomRight = this.bottomRight();
		        return !(point.x < origin.x || point.y < origin.y || bottomRight.x < point.x || bottomRight.y < point.y);
		    },
	
		    _isOnPath: function(point, width) {
		        var rectOuter = this.expandCopy(width, width);
		        var rectInner = this.expandCopy(-width, -width);
	
		        return rectOuter.containsPoint(point) && !rectInner.containsPoint(point);
		    }
		});
	
		Rect.fromPoints = function() {
		    var topLeft = Point.min.apply(null, arguments);
		    var bottomRight = Point.max.apply(null, arguments);
		    var size = new Size(
		        bottomRight.x - topLeft.x,
		        bottomRight.y - topLeft.y
		    );
	
		    return new Rect(topLeft, size);
		};
	
		Rect.union = function(a, b) {
		    return Rect.fromPoints(
		        Point.min(a.topLeft(), b.topLeft()),
		        Point.max(a.bottomRight(), b.bottomRight())
		    );
		};
	
		Rect.intersect = function(a, b) {
		    var rect1 = {
		        left: a.topLeft().x,
		        top: a.topLeft().y,
		        right: a.bottomRight().x,
		        bottom: a.bottomRight().y
		    };
	
		    var rect2 = {
		        left: b.topLeft().x,
		        top: b.topLeft().y,
		        right: b.bottomRight().x,
		        bottom: b.bottomRight().y
		    };
	
		    if (rect1.left <= rect2.right &&
		        rect2.left <= rect1.right &&
		        rect1.top <= rect2.bottom &&
		        rect2.top <= rect1.bottom) {
		        return Rect.fromPoints(
		            new Point(Math.max(rect1.left, rect2.left), Math.max(rect1.top, rect2.top)),
		            new Point(Math.min(rect1.right, rect2.right), Math.min(rect1.bottom, rect2.bottom))
		        );
		    }
		};
	
		ObserversMixin.extend(Rect.prototype);
	
		var Transformation = Class.extend({
		    init: function(matrix) {
		        if (matrix === void 0) { matrix = Matrix.unit(); }
	
		        this._matrix = matrix;
		    },
	
		    clone: function() {
		        return new Transformation(
		            this._matrix.clone()
		        );
		    },
	
		    equals: function(other) {
		        return other &&
		               other._matrix.equals(this._matrix);
		    },
	
		    translate: function(x, y) {
		        this._matrix = this._matrix.multiplyCopy(Matrix.translate(x, y));
	
		        this._optionsChange();
		        return this;
		    },
	
		    scale: function(scaleX, scaleY, origin) {
		        if (scaleY === void 0) { scaleY = scaleX; }
		        if (origin === void 0) { origin = null; }
	
		        var originPoint = origin;
	
		        if (originPoint) {
		            originPoint = Point.create(originPoint);
		            this._matrix = this._matrix.multiplyCopy(Matrix.translate(originPoint.x, originPoint.y));
		        }
	
		        this._matrix = this._matrix.multiplyCopy(Matrix.scale(scaleX, scaleY));
	
		        if (originPoint) {
		            this._matrix = this._matrix.multiplyCopy(Matrix.translate(-originPoint.x, -originPoint.y));
		        }
	
		        this._optionsChange();
		        return this;
		    },
	
		    rotate: function(angle, origin) {
		        var originPoint = Point.create(origin) || Point.ZERO;
	
		        this._matrix = this._matrix.multiplyCopy(Matrix.rotate(angle, originPoint.x, originPoint.y));
	
		        this._optionsChange();
		        return this;
		    },
	
		    multiply: function(transformation) {
		        var matrix = toMatrix(transformation);
	
		        this._matrix = this._matrix.multiplyCopy(matrix);
	
		        this._optionsChange();
		        return this;
		    },
	
		    matrix: function(value) {
		        if (value) {
		            this._matrix = value;
		            this._optionsChange();
		            return this;
		        }
	
		        return this._matrix;
		    },
	
		    _optionsChange: function() {
		        this.optionsChange({
		            field: "transform",
		            value: this
		        });
		    }
		});
	
		ObserversMixin.extend(Transformation.prototype);
	
		function transform(matrix) {
		    if (matrix === null) {
		        return null;
		    }
	
		    if (matrix instanceof Transformation) {
		        return matrix;
		    }
	
		    return new Transformation(matrix);
		}
	
		var Element$1 = Class.extend({
		    init: function(options) {
	
		        this._initOptions(options);
		    },
	
		    _initOptions: function(options) {
		        if (options === void 0) { options = {}; }
	
		        var clip = options.clip;
		        var transform$$1 = options.transform;
	
		        if (transform$$1) {
		            options.transform = transform(transform$$1);
		        }
	
		        if (clip && !clip.id) {
		            clip.id = definitionId();
		        }
	
		        this.options = new OptionsStore(options);
		        this.options.addObserver(this);
		    },
	
		    transform: function(value) {
		        if (defined(value)) {
		            this.options.set("transform", transform(value));
		        } else {
		            return this.options.get("transform");
		        }
		    },
	
		    parentTransform: function() {
		        var element = this;
		        var parentMatrix;
	
		        while (element.parent) {
		            element = element.parent;
		            var transformation = element.transform();
		            if (transformation) {
		                parentMatrix = transformation.matrix().multiplyCopy(parentMatrix || Matrix.unit());
		            }
		        }
	
		        if (parentMatrix) {
		            return transform(parentMatrix);
		        }
		    },
	
		    currentTransform: function(parentTransform) {
		        if (parentTransform === void 0) { parentTransform = this.parentTransform(); }
	
		        var elementTransform = this.transform();
		        var elementMatrix = toMatrix(elementTransform);
	
		        var parentMatrix = toMatrix(parentTransform);
		        var combinedMatrix;
	
		        if (elementMatrix && parentMatrix) {
		            combinedMatrix = parentMatrix.multiplyCopy(elementMatrix);
		        } else {
		            combinedMatrix = elementMatrix || parentMatrix;
		        }
	
		        if (combinedMatrix) {
		            return transform(combinedMatrix);
		        }
		    },
	
		    visible: function(value) {
		        if (defined(value)) {
		            this.options.set("visible", value);
		            return this;
		        }
	
		        return this.options.get("visible") !== false;
		    },
	
		    clip: function(value) {
		        var options = this.options;
		        if (defined(value)) {
		            if (value && !value.id) {
		                value.id = definitionId();
		            }
		            options.set("clip", value);
		            return this;
		        }
	
		        return options.get("clip");
		    },
	
		    opacity: function(value) {
		        if (defined(value)) {
		            this.options.set("opacity", value);
		            return this;
		        }
	
		        return valueOrDefault(this.options.get("opacity"), 1);
		    },
	
		    clippedBBox: function(transformation) {
		        var bbox = this._clippedBBox(transformation);
		        if (bbox) {
		            var clip = this.clip();
		            return clip ? Rect.intersect(bbox, clip.bbox(transformation)) : bbox;
		        }
		    },
	
		    containsPoint: function(point, parentTransform) {
		        if (this.visible()) {
		            var transform$$1 = this.currentTransform(parentTransform);
		            var transformedPoint = point;
		            if (transform$$1) {
		                transformedPoint = point.transformCopy(transform$$1.matrix().invert());
		            }
		            return (this._hasFill() && this._containsPoint(transformedPoint)) || (this._isOnPath && this._hasStroke() && this._isOnPath(transformedPoint));
		        }
		        return false;
		    },
	
		    _hasFill: function() {
		        var fill = this.options.fill;
		        return fill && !isTransparent(fill.color);
		    },
	
		    _hasStroke: function() {
		        var stroke = this.options.stroke;
		        return stroke && stroke.width > 0 && !isTransparent(stroke.color);
		    },
	
		    _clippedBBox: function(transformation) {
		        return this.bbox(transformation);
		    }
		});
	
		Element$1.prototype.nodeType = "Element";
	
		ObserversMixin.extend(Element$1.prototype);
	
		function ellipseExtremeAngles(center, rx, ry, matrix) {
		    var extremeX = 0;
		    var extremeY = 0;
	
		    if (matrix) {
		        extremeX = Math.atan2(matrix.c * ry, matrix.a * rx);
		        if (matrix.b !== 0) {
		            extremeY = Math.atan2(matrix.d * ry, matrix.b * rx);
		        }
		    }
	
		    return {
		        x: extremeX,
		        y: extremeY
		    };
		}
	
		var PI_DIV_2 = Math.PI / 2;
	
		var Circle$2 = Class.extend({
		    init: function(center, radius) {
		        if (center === void 0) { center = new Point(); }
		        if (radius === void 0) { radius = 0; }
	
		        this.setCenter(center);
		        this.setRadius(radius);
		    },
	
		    setCenter: function(value) {
		        this._observerField("center", Point.create(value));
		        this.geometryChange();
		        return this;
		    },
	
		    getCenter: function() {
		        return this.center;
		    },
	
		    equals: function(other) {
		        return other &&
		               other.center.equals(this.center) &&
		               other.radius === this.radius;
		    },
	
		    clone: function() {
		        return new Circle$2(this.center.clone(), this.radius);
		    },
	
		    pointAt: function(angle) {
		        return this._pointAt(rad(angle));
		    },
	
		    bbox: function(matrix) {
		        var this$1 = this;
	
		        var extremeAngles = ellipseExtremeAngles(this.center, this.radius, this.radius, matrix);
		        var minPoint = Point.maxPoint();
		        var maxPoint = Point.minPoint();
	
		        for (var i = 0; i < 4; i++) {
		            var currentPointX = this$1._pointAt(extremeAngles.x + i * PI_DIV_2).transformCopy(matrix);
		            var currentPointY = this$1._pointAt(extremeAngles.y + i * PI_DIV_2).transformCopy(matrix);
		            var currentPoint = new Point(currentPointX.x, currentPointY.y);
	
		            minPoint = Point.min(minPoint, currentPoint);
		            maxPoint = Point.max(maxPoint, currentPoint);
		        }
	
		        return Rect.fromPoints(minPoint, maxPoint);
		    },
	
		    _pointAt: function(angle) {
		        var ref = this;
		        var center = ref.center;
		        var radius = ref.radius;
	
		        return new Point(
		            center.x + radius * Math.cos(angle),
		            center.y + radius * Math.sin(angle)
		        );
		    },
	
		    containsPoint: function(point) {
		        var ref = this;
		        var center = ref.center;
		        var radius = ref.radius;
		        var inCircle = Math.pow(point.x - center.x, 2) +
		            Math.pow(point.y - center.y, 2) <= Math.pow(radius, 2);
		        return inCircle;
		    },
	
		    _isOnPath: function(point, width) {
		        var ref = this;
		        var center = ref.center;
		        var radius = ref.radius;
		        var pointDistance = center.distanceTo(point);
	
		        return radius - width <= pointDistance && pointDistance <= radius + width;
		    }
		});
	
		defineAccessors(Circle$2.prototype, [ "radius" ]);
		ObserversMixin.extend(Circle$2.prototype);
	
		var GRADIENT = "Gradient";
	
		var Paintable = {
		    extend: function(proto) {
		        proto.fill = this.fill;
		        proto.stroke = this.stroke;
		    },
	
		    fill: function(color, opacity) {
		        var options = this.options;
	
		        if (defined(color)) {
		            if (color && color.nodeType !== GRADIENT) {
		                var newFill = {
		                    color: color
		                };
		                if (defined(opacity)) {
		                    newFill.opacity = opacity;
		                }
		                options.set("fill", newFill);
		            } else {
		                options.set("fill", color);
		            }
	
		            return this;
		        }
	
		        return options.get("fill");
		    },
	
		    stroke: function(color, width, opacity) {
		        if (defined(color)) {
		            this.options.set("stroke.color", color);
	
		            if (defined(width)) {
		                this.options.set("stroke.width", width);
		            }
	
		            if (defined(opacity)) {
		                this.options.set("stroke.opacity", opacity);
		            }
	
		            return this;
		        }
	
		        return this.options.get("stroke");
		    }
		};
	
		var IDENTITY_MATRIX_HASH = Matrix.IDENTITY.toString();
	
		var Measurable = {
		    extend: function(proto) {
		        proto.bbox = this.bbox;
		        proto.geometryChange = this.geometryChange;
		    },
	
		    bbox: function(transformation) {
		        var combinedMatrix = toMatrix(this.currentTransform(transformation));
		        var matrixHash = combinedMatrix ? combinedMatrix.toString() : IDENTITY_MATRIX_HASH;
		        var bbox;
	
		        if (this._bboxCache && this._matrixHash === matrixHash) {
		            bbox = this._bboxCache.clone();
		        } else {
		            bbox = this._bbox(combinedMatrix);
		            this._bboxCache = bbox ? bbox.clone() : null;
		            this._matrixHash = matrixHash;
		        }
	
		        var strokeWidth = this.options.get("stroke.width");
		        if (strokeWidth && bbox) {
		            bbox.expand(strokeWidth / 2);
		        }
	
		        return bbox;
		    },
	
		    geometryChange: function() {
		        delete this._bboxCache;
		        this.trigger("geometryChange", {
		            element: this
		        });
		    }
		};
	
		function geometryAccessor(name) {
		    var fieldName = "_" + name;
		    return function(value) {
		        if (defined(value)) {
		            this._observerField(fieldName, value);
		            this.geometryChange();
		            return this;
		        }
	
		        return this[fieldName];
		    };
		}
	
		function defineGeometryAccessors(fn, names) {
		    for (var i = 0; i < names.length; i++) {
		        fn[names[i]] = geometryAccessor(names[i]);
		    }
		}
	
		var DEFAULT_STROKE = "#000";
	
		var Circle = Element$1.extend({
		    init: function(geometry, options) {
		        if (geometry === void 0) { geometry = new Circle$2(); }
		        if (options === void 0) { options = {}; }
	
		        Element$1.fn.init.call(this, options);
		        this.geometry(geometry);
	
		        if (!defined(this.options.stroke)) {
		            this.stroke(DEFAULT_STROKE);
		        }
		    },
	
		    rawBBox: function() {
		        return this._geometry.bbox();
		    },
	
		    _bbox: function(matrix) {
		        return this._geometry.bbox(matrix);
		    },
	
		    _containsPoint: function(point) {
		        return this.geometry().containsPoint(point);
		    },
	
		    _isOnPath: function(point) {
		        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
		    }
		});
	
		Circle.prototype.nodeType = "Circle";
	
		Paintable.extend(Circle.prototype);
		Measurable.extend(Circle.prototype);
		defineGeometryAccessors(Circle.prototype, [ "geometry" ]);
	
		var PRECISION = 10;
	
		function close(a, b, tolerance) {
		    if (tolerance === void 0) { tolerance = PRECISION; }
	
		    return round(Math.abs(a - b), tolerance) === 0;
		}
	
		function closeOrLess(a, b, tolerance) {
		    return a < b || close(a, b, tolerance);
		}
	
		function lineIntersection(p0, p1, p2, p3) {
		    var s1x = p1.x - p0.x;
		    var s2x = p3.x - p2.x;
		    var s1y = p1.y - p0.y;
		    var s2y = p3.y - p2.y;
		    var nx = p0.x - p2.x;
		    var ny = p0.y - p2.y;
		    var d = s1x * s2y - s2x * s1y;
		    var s = (s1x * ny - s1y * nx) / d;
		    var t = (s2x * ny - s2y * nx) / d;
	
		    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
		        return new Point(p0.x + t * s1x, p0.y + t * s1y);
		    }
		}
	
		var MAX_INTERVAL = 45;
		var pow$1 = Math.pow;
	
		var Arc$2 = Class.extend({
		    init: function(center, options) {
		        if (center === void 0) { center = new Point(); }
		        if (options === void 0) { options = {}; }
	
		        this.setCenter(center);
	
		        this.radiusX = options.radiusX;
		        this.radiusY = options.radiusY || options.radiusX;
		        this.startAngle = options.startAngle;
		        this.endAngle = options.endAngle;
		        this.anticlockwise = options.anticlockwise || false;
		        this.xRotation = options.xRotation;
		    },
	
		    clone: function() {
		        return new Arc$2(this.center, {
		            radiusX: this.radiusX,
		            radiusY: this.radiusY,
		            startAngle: this.startAngle,
		            endAngle: this.endAngle,
		            anticlockwise: this.anticlockwise
		        });
		    },
	
		    setCenter: function(value) {
		        this._observerField("center", Point.create(value));
		        this.geometryChange();
		        return this;
		    },
	
		    getCenter: function() {
		        return this.center;
		    },
	
		    pointAt: function(angle) {
		        var center = this.center;
		        var radian = rad(angle);
	
		        return new Point(
		            center.x + this.radiusX * Math.cos(radian),
		            center.y + this.radiusY * Math.sin(radian)
		        );
		    },
	
		    curvePoints: function() {
		        var this$1 = this;
	
		        var startAngle = this.startAngle;
		        var dir = this.anticlockwise ? -1 : 1;
		        var curvePoints = [ this.pointAt(startAngle) ];
		        var interval = this._arcInterval();
		        var intervalAngle = interval.endAngle - interval.startAngle;
		        var subIntervalsCount = Math.ceil(intervalAngle / MAX_INTERVAL);
		        var subIntervalAngle = intervalAngle / subIntervalsCount;
		        var currentAngle = startAngle;
		        var transformation;
		        if (this.xRotation) {
		            transformation = transform().rotate(this.xRotation, this.center);
		        }
	
		        for (var i = 1; i <= subIntervalsCount; i++) {
		            var nextAngle = currentAngle + dir * subIntervalAngle;
		            var points = this$1._intervalCurvePoints(currentAngle, nextAngle, transformation);
	
		            curvePoints.push(points.cp1, points.cp2, points.p2);
		            currentAngle = nextAngle;
		        }
	
		        return curvePoints;
		    },
	
		    bbox: function(matrix) {
		        var this$1 = this;
	
		        var interval = this._arcInterval();
		        var startAngle = interval.startAngle;
		        var endAngle = interval.endAngle;
		        var extremeAngles = ellipseExtremeAngles(this.center, this.radiusX, this.radiusY, matrix);
		        var extremeX = deg(extremeAngles.x);
		        var extremeY = deg(extremeAngles.y);
		        var endPoint = this.pointAt(endAngle).transformCopy(matrix);
		        var currentAngleX = bboxStartAngle(extremeX, startAngle);
		        var currentAngleY = bboxStartAngle(extremeY, startAngle);
		        var currentPoint = this.pointAt(startAngle).transformCopy(matrix);
		        var minPoint = Point.min(currentPoint, endPoint);
		        var maxPoint = Point.max(currentPoint, endPoint);
	
		        while (currentAngleX < endAngle || currentAngleY < endAngle) {
		            var currentPointX = (void 0);
		            if (currentAngleX < endAngle) {
		                currentPointX = this$1.pointAt(currentAngleX).transformCopy(matrix);
		                currentAngleX += 90;
		            }
	
		            var currentPointY = (void 0);
		            if (currentAngleY < endAngle) {
		                currentPointY = this$1.pointAt(currentAngleY).transformCopy(matrix);
		                currentAngleY += 90;
		            }
	
		            currentPoint = new Point(currentPointX.x, currentPointY.y);
		            minPoint = Point.min(minPoint, currentPoint);
		            maxPoint = Point.max(maxPoint, currentPoint);
		        }
	
		        return Rect.fromPoints(minPoint, maxPoint);
		    },
	
		    _arcInterval: function() {
		        var ref = this;
		        var startAngle = ref.startAngle;
		        var endAngle = ref.endAngle;
		        var anticlockwise = ref.anticlockwise;
	
		        if (anticlockwise) {
		            var oldStart = startAngle;
		            startAngle = endAngle;
		            endAngle = oldStart;
		        }
	
		        if (startAngle > endAngle || (anticlockwise && startAngle === endAngle)) {
		            endAngle += 360;
		        }
	
		        return {
		            startAngle: startAngle,
		            endAngle: endAngle
		        };
		    },
	
		    _intervalCurvePoints: function(startAngle, endAngle, transformation) {
		        var p1 = this.pointAt(startAngle);
		        var p2 = this.pointAt(endAngle);
		        var p1Derivative = this._derivativeAt(startAngle);
		        var p2Derivative = this._derivativeAt(endAngle);
		        var t = (rad(endAngle) - rad(startAngle)) / 3;
		        var cp1 = new Point(p1.x + t * p1Derivative.x, p1.y + t * p1Derivative.y);
		        var cp2 = new Point(p2.x - t * p2Derivative.x, p2.y - t * p2Derivative.y);
		        if (transformation) {
		            p1.transform(transformation);
		            p2.transform(transformation);
		            cp1.transform(transformation);
		            cp2.transform(transformation);
		        }
	
		        return {
		            p1: p1,
		            cp1: cp1,
		            cp2: cp2,
		            p2: p2
		        };
		    },
	
		    _derivativeAt: function(angle) {
		        var radian = rad(angle);
	
		        return new Point(-this.radiusX * Math.sin(radian), this.radiusY * Math.cos(radian));
		    },
	
		    containsPoint: function(point) {
		        var interval = this._arcInterval();
		        var intervalAngle = interval.endAngle - interval.startAngle;
		        var ref = this;
		        var center = ref.center;
		        var radiusX = ref.radiusX;
		        var radiusY = ref.radiusY;
		        var distance = center.distanceTo(point);
		        var angleRad = Math.atan2(point.y - center.y, point.x - center.x);
		        var pointRadius = (radiusX * radiusY) /
		            Math.sqrt(pow$1(radiusX, 2) * pow$1(Math.sin(angleRad), 2) + pow$1(radiusY, 2) * pow$1(Math.cos(angleRad), 2));
		        var startPoint = this.pointAt(this.startAngle).round(PRECISION);
		        var endPoint = this.pointAt(this.endAngle).round(PRECISION);
		        var intersection = lineIntersection(center, point.round(PRECISION), startPoint, endPoint);
		        var containsPoint;
	
		        if (intervalAngle < 180) {
		            containsPoint = intersection && closeOrLess(center.distanceTo(intersection), distance) && closeOrLess(distance, pointRadius);
		        } else {
		            var angle = calculateAngle(center.x, center.y, radiusX, radiusY, point.x, point.y);
		            if (angle !== 360) {
		                angle = (360 + angle) % 360;
		            }
	
		            var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;
		            containsPoint = (inAngleRange && closeOrLess(distance, pointRadius)) || (!inAngleRange && (!intersection || intersection.equals(point)));
		        }
		        return containsPoint;
		    },
	
		    _isOnPath: function(point, width) {
		        var interval = this._arcInterval();
		        var center = this.center;
		        var angle = calculateAngle(center.x, center.y, this.radiusX, this.radiusY, point.x, point.y);
		        if (angle !== 360) {
		            angle = (360 + angle) % 360;
		        }
	
		        var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;
	
		        return inAngleRange && this.pointAt(angle).distanceTo(point) <= width;
		    }
		});
	
		Arc$2.fromPoints = function(start, end, rx, ry, largeArc, swipe, rotation) {// eslint-disable-line max-params
		    var arcParameters = normalizeArcParameters({
		        x1: start.x,
		        y1: start.y,
		        x2: end.x,
		        y2: end.y,
		        rx: rx,
		        ry: ry,
		        largeArc: largeArc,
		        swipe: swipe,
		        rotation: rotation
		    });
	
		    return new Arc$2(arcParameters.center, {
		        startAngle: arcParameters.startAngle,
		        endAngle: arcParameters.endAngle,
		        radiusX: arcParameters.radiusX,
		        radiusY: arcParameters.radiusY,
		        xRotation: arcParameters.xRotation,
		        anticlockwise: swipe === 0
		    });
		};
	
		defineAccessors(Arc$2.prototype, [ "radiusX", "radiusY", "startAngle", "endAngle", "anticlockwise" ]);
		ObserversMixin.extend(Arc$2.prototype);
	
		function calculateAngle(cx, cy, rx, ry, x, y) {
		    var cos = round((x - cx) / rx, 3);
		    var sin = round((y - cy) / ry, 3);
	
		    return round(deg(Math.atan2(sin, cos)));
		}
	
		function normalizeArcParameters(parameters) {
		    var x1 = parameters.x1;
		    var y1 = parameters.y1;
		    var x2 = parameters.x2;
		    var y2 = parameters.y2;
		    var rx = parameters.rx;
		    var ry = parameters.ry;
		    var largeArc = parameters.largeArc;
		    var swipe = parameters.swipe;
		    var rotation = parameters.rotation; if (rotation === void 0) { rotation = 0; }
	
		    var radians = rad(rotation);
		    var cosine = Math.cos(radians);
		    var sine = Math.sin(radians);
	
		    var xT = cosine * (x1 - x2) / 2 + sine * (y1 - y2) / 2;
		    var yT = -sine * (x1 - x2) / 2 + cosine * (y1 - y2) / 2;
	
		    var sign = largeArc !== swipe ? 1 : -1;
	
		    var xt2 = Math.pow(xT, 2);
		    var yt2 = Math.pow(yT, 2);
		    var rx2 = Math.pow(rx, 2);
		    var ry2 = Math.pow(ry, 2);
	
		    var delta = xt2 / rx2 + yt2 / ry2;
	
		    if (delta > 1) {
		        delta = Math.sqrt(xt2 / rx2 + yt2 / ry2);
		        rx = delta * rx;
		        rx2 = Math.pow(rx, 2);
	
		        ry = delta * ry;
		        ry2 = Math.pow(ry, 2);
		    }
	
		    var constT = sign * Math.sqrt((rx2 * ry2 - rx2 * yt2 - ry2 * xt2) / (rx2 * yt2 + ry2 * xt2));
		    // due to rounding errors the value could become NaN even after radii correction
		    if (isNaN(constT)) {
		        constT = 0;
		    }
	
		    var cxT = constT * (rx * yT) / ry;
		    var cyT = - constT * (ry * xT) / rx;
	
		    var cx = cosine * cxT - sine * cyT + (x1 + x2) / 2;
		    var cy = sine * cxT + cosine * cyT + (y1 + y2) / 2;
	
		    var uX = (xT - cxT) / rx;
		    var uY = (yT - cyT) / ry;
		    var vX = -(xT + cxT) / rx;
		    var vY = -(yT + cyT) / ry;
	
		    var startAngle = (uY >= 0 ? 1 : -1) * deg(Math.acos(uX / Math.sqrt(uX * uX + uY * uY)));
	
		    var angleCosine = round((uX * vX + uY * vY) / (Math.sqrt(uX * uX + uY * uY) * Math.sqrt(vX * vX + vY * vY)), 10);
		    var angle = (uX * vY - uY * vX >= 0 ? 1 : -1) * deg(Math.acos(angleCosine));
	
		    if (!swipe && angle > 0) {
		        angle -= 360;
		    }
	
		    if (swipe && angle < 0) {
		        angle += 360;
		    }
		    var endAngle = startAngle + angle;
		    var signEndAngle = endAngle >= 0 ? 1 : -1;
		    endAngle = (Math.abs(endAngle) % 360) * signEndAngle;
	
		    return {
		        center: new Point(cx, cy),
		        startAngle: startAngle,
		        endAngle: endAngle,
		        radiusX: rx,
		        radiusY: ry,
		        xRotation: rotation
		    };
		}
	
		function bboxStartAngle(angle, start) {
		    var startAngle = angle;
	
		    while (startAngle < start) {
		        startAngle += 90;
		    }
	
		    return startAngle;
		}
	
		var push = [].push;
		var pop = [].pop;
		var splice = [].splice;
		var shift = [].shift;
		var slice = [].slice;
		var unshift = [].unshift;
	
		var ElementsArray = Class.extend({
		    init: function(array) {
		        if (array === void 0) { array = []; }
	
		        this.length = 0;
		        this._splice(0, array.length, array);
		    },
	
		    elements: function(value) {
		        if (value) {
		            this._splice(0, this.length, value);
	
		            this._change();
		            return this;
		        }
	
		        return this.slice(0);
		    },
	
		    push: function() {
		        var elements = arguments;
		        var result = push.apply(this, elements);
	
		        this._add(elements);
	
		        return result;
		    },
	
		    slice: function() {
		        return slice.call(this);
		    },
	
		    pop: function() {
		        var length = this.length;
		        var result = pop.apply(this);
	
		        if (length) {
		            this._remove([ result ]);
		        }
	
		        return result;
		    },
	
		    splice: function(index, howMany) {
		        var elements = slice.call(arguments, 2);
		        var result = this._splice(index, howMany, elements);
	
		        this._change();
	
		        return result;
		    },
	
		    shift: function() {
		        var length = this.length;
		        var result = shift.apply(this);
	
		        if (length) {
		            this._remove([ result ]);
		        }
	
		        return result;
		    },
	
		    unshift: function() {
		        var elements = arguments;
		        var result = unshift.apply(this, elements);
	
		        this._add(elements);
	
		        return result;
		    },
	
		    indexOf: function(element) {
		        var this$1 = this;
	
		        var length = this.length;
	
		        for (var idx = 0; idx < length; idx++) {
		            if (this$1[idx] === element) {
		                return idx;
		            }
		        }
		        return -1;
		    },
	
		    _splice: function(index, howMany, elements) {
		        var result = splice.apply(this, [ index, howMany ].concat(elements));
	
		        this._clearObserver(result);
		        this._setObserver(elements);
	
		        return result;
		    },
	
		    _add: function(elements) {
		        this._setObserver(elements);
		        this._change();
		    },
	
		    _remove: function(elements) {
		        this._clearObserver(elements);
		        this._change();
		    },
	
		    _setObserver: function(elements) {
		        var this$1 = this;
	
		        for (var idx = 0; idx < elements.length; idx++) {
		            elements[idx].addObserver(this$1);
		        }
		    },
	
		    _clearObserver: function(elements) {
		        var this$1 = this;
	
		        for (var idx = 0; idx < elements.length; idx++) {
		            elements[idx].removeObserver(this$1);
		        }
		    },
	
		    _change: function() {}
		});
	
		ObserversMixin.extend(ElementsArray.prototype);
	
		var GeometryElementsArray = ElementsArray.extend({
		    _change: function() {
		        this.geometryChange();
		    }
		});
	
		function pointAccessor(name) {
		    var fieldName = "_" + name;
		    return function(value) {
		        if (defined(value)) {
		            this._observerField(fieldName, Point.create(value));
		            this.geometryChange();
		            return this;
		        }
	
		        return this[fieldName];
		    };
		}
	
		function definePointAccessors(fn, names) {
		    for (var i = 0; i < names.length; i++) {
		        fn[names[i]] = pointAccessor(names[i]);
		    }
		}
	
		function isOutOfEndPoint(endPoint, controlPoint, point) {
		    var angle = deg(Math.atan2(controlPoint.y - endPoint.y, controlPoint.x - endPoint.x));
		    var rotatedPoint = point.transformCopy(transform().rotate(-angle, endPoint));
	
		    return rotatedPoint.x < endPoint.x;
		}
	
		function calculateCurveAt(t, field, points) {
		    var t1 = 1 - t;
		    return Math.pow(t1, 3) * points[0][field] +
		        3 * Math.pow(t1, 2) * t * points[1][field] +
		        3 * Math.pow(t, 2) * t1 * points[2][field] +
		        Math.pow(t, 3) * points[3][field];
		}
	
		function toCubicPolynomial(points, field) {
		    return [ -points[0][field] + 3 * points[1][field] - 3 * points[2][field] + points[3][field],
		        3 * (points[0][field] - 2 * points[1][field] + points[2][field]),
		        3 * (-points[0][field] + points[1][field]),
		        points[0][field]
		    ];
		}
	
		var ComplexNumber = Class.extend({
		    init: function(real, img) {
		        if (real === void 0) { real = 0; }
		        if (img === void 0) { img = 0; }
	
		        this.real = real;
		        this.img = img;
		    },
	
		    add: function(cNumber) {
		        return new ComplexNumber(round(this.real + cNumber.real, PRECISION), round(this.img + cNumber.img, PRECISION));
		    },
	
		    addConstant: function(value) {
		        return new ComplexNumber(this.real + value, this.img);
		    },
	
		    negate: function() {
		        return new ComplexNumber(-this.real, -this.img);
		    },
	
		    multiply: function(cNumber) {
		        return new ComplexNumber(this.real * cNumber.real - this.img * cNumber.img,
		            this.real * cNumber.img + this.img * cNumber.real);
		    },
	
		    multiplyConstant: function(value) {
		        return new ComplexNumber(this.real * value, this.img * value);
		    },
	
		    nthRoot: function(n) {
		        var rad$$1 = Math.atan2(this.img, this.real);
		        var r = Math.sqrt(Math.pow(this.img, 2) + Math.pow(this.real, 2));
		        var nthR = Math.pow(r, 1 / n);
	
		        return new ComplexNumber(nthR * Math.cos(rad$$1 / n), nthR * Math.sin(rad$$1 / n)); //Moivre's formula
		    },
	
		    equals: function(cNumber) {
		        return this.real === cNumber.real && this.img === cNumber.img;
		    },
	
		    isReal: function() {
		        return this.img === 0;
		    }
		});
	
		function numberSign(x) {
		    return x < 0 ? -1 : 1;
		}
	
		function solveQuadraticEquation(a, b, c) {
		    var squareRoot = Math.sqrt(Math.pow(b, 2) - 4 * a * c);
		    return [
		        (-b + squareRoot) / (2 * a),
		        (-b - squareRoot) / (2 * a)
		    ];
		}
	
		//Cardano's formula
		function solveCubicEquation(a, b, c, d) {
		    if (a === 0) {
		        return solveQuadraticEquation(b, c, d);
		    }
	
		    var p = (3 * a * c - Math.pow(b, 2)) / (3 * Math.pow(a, 2));
		    var q = (2 * Math.pow(b, 3) - 9 * a * b * c + 27 * Math.pow(a, 2) * d) / (27 * Math.pow(a, 3));
		    var Q = Math.pow(p / 3, 3) + Math.pow(q / 2, 2);
		    var i = new ComplexNumber(0,1);
		    var b3a = -b / (3 * a);
		    var x1, x2, y1, y2, y3, z1, z2;
	
		    if (Q < 0) {
		        x1 = new ComplexNumber(-q / 2, Math.sqrt(-Q)).nthRoot(3);
		        x2 = new ComplexNumber(-q / 2, - Math.sqrt(-Q)).nthRoot(3);
		    } else {
		        x1 = -q / 2 + Math.sqrt(Q);
		        x1 = new ComplexNumber(numberSign(x1) * Math.pow(Math.abs(x1), 1 / 3));
		        x2 = -q / 2 - Math.sqrt(Q);
		        x2 = new ComplexNumber(numberSign(x2) * Math.pow(Math.abs(x2), 1 / 3));
		    }
	
		    y1 = x1.add(x2);
	
		    z1 = x1.add(x2).multiplyConstant(-1 / 2);
		    z2 = x1.add(x2.negate()).multiplyConstant(Math.sqrt(3) / 2);
	
		    y2 = z1.add(i.multiply(z2));
		    y3 = z1.add(i.negate().multiply(z2));
	
		    var result = [];
	
		    if (y1.isReal()) {
		        result.push(round(y1.real + b3a, PRECISION));
		    }
		    if (y2.isReal()) {
		        result.push(round(y2.real + b3a, PRECISION));
		    }
		    if (y3.isReal()) {
		        result.push(round(y3.real + b3a, PRECISION));
		    }
	
		    return result;
		}
	
		function hasRootsInRange(points, point, field, rootField, range) {
		    var polynomial = toCubicPolynomial(points, rootField);
		    var roots = solveCubicEquation(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point[rootField]);
		    var intersection;
	
		    for (var idx = 0; idx < roots.length; idx++) {
		        if (0 <= roots[idx] && roots[idx] <= 1) {
		            intersection = calculateCurveAt(roots[idx], field, points);
		            if (Math.abs(intersection - point[field]) <= range) {
		                return true;
		            }
		        }
		    }
		}
	
		function curveIntersectionsCount(points, point, bbox) {
		    var polynomial = toCubicPolynomial(points, "x");
		    var roots = solveCubicEquation(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point.x);
		    var rayIntersection, intersectsRay;
		    var count = 0;
		    for (var i = 0; i < roots.length; i++) {
		        rayIntersection = calculateCurveAt(roots[i], "y", points);
		        intersectsRay = close(rayIntersection, point.y) || rayIntersection > point.y;
		        if (intersectsRay && (((roots[i] === 0 || roots[i] === 1) && bbox.bottomRight().x > point.x) || (0 < roots[i] && roots[i] < 1))) {
		            count++;
		        }
		    }
	
		    return count;
		}
	
		function lineIntersectionsCount(a, b, point) {
		    var intersects;
		    if (a.x !== b.x) {
		        var minX = Math.min(a.x, b.x);
		        var maxX = Math.max(a.x, b.x);
		        var minY = Math.min(a.y, b.y);
		        var maxY = Math.max(a.y, b.y);
		        var inRange = minX <= point.x && point.x < maxX;
	
		        if (minY === maxY) {
		            intersects = point.y <= minY && inRange;
		        } else {
		            intersects = inRange && (((maxY - minY) * ((a.x - b.x) * (a.y - b.y) > 0 ? point.x - minX : maxX - point.x)) / (maxX - minX) + minY - point.y) >= 0;
		        }
		    }
	
		    return intersects ? 1 : 0;
		}
	
		var Segment = Class.extend({
		    init: function(anchor, controlIn, controlOut) {
	
		        this.anchor(anchor || new Point());
		        this.controlIn(controlIn);
		        this.controlOut(controlOut);
		    },
	
		    bboxTo: function(toSegment, matrix) {
		        var segmentAnchor = this.anchor().transformCopy(matrix);
		        var toSegmentAnchor = toSegment.anchor().transformCopy(matrix);
		        var rect;
	
		        if (this.controlOut() && toSegment.controlIn()) {
		            rect = this._curveBoundingBox(
		                segmentAnchor, this.controlOut().transformCopy(matrix),
		                toSegment.controlIn().transformCopy(matrix), toSegmentAnchor
		            );
		        } else {
		            rect = this._lineBoundingBox(segmentAnchor, toSegmentAnchor);
		        }
	
		        return rect;
		    },
	
		    _lineBoundingBox: function(p1, p2) {
		        return Rect.fromPoints(p1, p2);
		    },
	
		    _curveBoundingBox: function(p1, cp1, cp2, p2) {
		        var points = [ p1, cp1, cp2, p2 ];
		        var extremesX = this._curveExtremesFor(points, "x");
		        var extremesY = this._curveExtremesFor(points, "y");
		        var xLimits = arrayLimits([ extremesX.min, extremesX.max, p1.x, p2.x ]);
		        var yLimits = arrayLimits([ extremesY.min, extremesY.max, p1.y, p2.y ]);
	
		        return Rect.fromPoints(new Point(xLimits.min, yLimits.min), new Point(xLimits.max, yLimits.max));
		    },
	
		    _curveExtremesFor: function(points, field) {
		        var extremes = this._curveExtremes(
		            points[0][field], points[1][field],
		            points[2][field], points[3][field]
		        );
	
		        return {
		            min: calculateCurveAt(extremes.min, field, points),
		            max: calculateCurveAt(extremes.max, field, points)
		        };
		    },
	
		    _curveExtremes: function(x1, x2, x3, x4) {
		        var a = x1 - 3 * x2 + 3 * x3 - x4;
		        var b = - 2 * (x1 - 2 * x2 + x3);
		        var c = x1 - x2;
		        var sqrt = Math.sqrt(b * b - 4 * a * c);
		        var t1 = 0;
		        var t2 = 1;
	
		        if (a === 0) {
		            if (b !== 0) {
		                t1 = t2 = -c / b;
		            }
		        } else if (!isNaN(sqrt)) {
		            t1 = (- b + sqrt) / (2 * a);
		            t2 = (- b - sqrt) / (2 * a);
		        }
	
		        var min = Math.max(Math.min(t1, t2), 0);
		        if (min < 0 || min > 1) {
		            min = 0;
		        }
	
		        var max = Math.min(Math.max(t1, t2), 1);
		        if (max > 1 || max < 0) {
		            max = 1;
		        }
	
		        return {
		            min: min,
		            max: max
		        };
		    },
	
		    _intersectionsTo: function(segment, point) {
		        var intersectionsCount;
		        if (this.controlOut() && segment.controlIn()) {
		            intersectionsCount = curveIntersectionsCount([ this.anchor(), this.controlOut(), segment.controlIn(), segment.anchor() ], point, this.bboxTo(segment));
		        } else {
		            intersectionsCount = lineIntersectionsCount(this.anchor(), segment.anchor(), point);
		        }
		        return intersectionsCount;
		    },
	
		    _isOnCurveTo: function(segment, point, width, endSegment) {
		        var bbox = this.bboxTo(segment).expand(width, width);
		        if (bbox.containsPoint(point)) {
		            var p1 = this.anchor();
		            var p2 = this.controlOut();
		            var p3 = segment.controlIn();
		            var p4 = segment.anchor();
	
		            if (endSegment === "start" && p1.distanceTo(point) <= width) {
		                return !isOutOfEndPoint(p1, p2, point);
		            } else if (endSegment === "end" && p4.distanceTo(point) <= width) {
		                return !isOutOfEndPoint(p4, p3, point);
		            }
	
		            //the approach is not entirely correct but is close and the alternatives are solving a 6th degree polynomial or testing the segment points
		            var points = [ p1, p2, p3, p4 ];
		            if (hasRootsInRange(points, point, "x", "y", width) || hasRootsInRange(points, point, "y", "x", width)) {
		                return true;
		            }
		            var rotation = transform().rotate(45, point);
		            var rotatedPoints = [ p1.transformCopy(rotation), p2.transformCopy(rotation), p3.transformCopy(rotation), p4.transformCopy(rotation) ];
		            return hasRootsInRange(rotatedPoints, point, "x", "y", width) || hasRootsInRange(rotatedPoints, point, "y", "x", width);
		        }
		    },
	
		    _isOnLineTo: function(segment, point, width) {
		        var p1 = this.anchor();
		        var p2 = segment.anchor();
		        var angle = deg(Math.atan2(p2.y - p1.y, p2.x - p1.x));
		        var rect = new Rect([ p1.x, p1.y - width / 2 ], [ p1.distanceTo(p2), width ]);
		        return rect.containsPoint(point.transformCopy(transform().rotate(-angle, p1)));
		    },
	
		    _isOnPathTo: function(segment, point, width, endSegment) {
		        var isOnPath;
		        if (this.controlOut() && segment.controlIn()) {
		            isOnPath = this._isOnCurveTo(segment, point, width / 2, endSegment);
		        } else {
		            isOnPath = this._isOnLineTo(segment, point, width);
		        }
		        return isOnPath;
		    }
		});
	
		definePointAccessors(Segment.prototype, [ "anchor", "controlIn", "controlOut" ]);
		ObserversMixin.extend(Segment.prototype);
	
		function arrayLimits(arr) {
		    var length = arr.length;
		    var min = MAX_NUM;
		    var max = MIN_NUM;
	
		    for (var i = 0; i < length; i ++) {
		        max = Math.max(max, arr[i]);
		        min = Math.min(min, arr[i]);
		    }
	
		    return {
		        min: min,
		        max: max
		    };
		}
	
		function elementsBoundingBox(elements, applyTransform, transformation) {
		    var boundingBox;
	
		    for (var i = 0; i < elements.length; i++) {
		        var element = elements[i];
		        if (element.visible()) {
		            var elementBoundingBox = applyTransform ? element.bbox(transformation) : element.rawBBox();
		            if (elementBoundingBox) {
		                if (boundingBox) {
		                    boundingBox = Rect.union(boundingBox, elementBoundingBox);
		                } else {
		                    boundingBox = elementBoundingBox;
		                }
		            }
		        }
		    }
	
		    return boundingBox;
		}
	
		function elementsClippedBoundingBox(elements, transformation) {
		    var boundingBox;
	
		    for (var i = 0; i < elements.length; i++) {
		        var element = elements[i];
		        if (element.visible()) {
		            var elementBoundingBox = element.clippedBBox(transformation);
		            if (elementBoundingBox) {
		                if (boundingBox) {
		                    boundingBox = Rect.union(boundingBox, elementBoundingBox);
		                } else {
		                    boundingBox = elementBoundingBox;
		                }
		            }
		        }
		    }
	
		    return boundingBox;
		}
	
		var MultiPath = Element$1.extend({
		    init: function(options) {
		        Element$1.fn.init.call(this, options);
		        this.paths = new GeometryElementsArray();
		        this.paths.addObserver(this);
	
		        if (!defined(this.options.stroke)) {
		            this.stroke("#000");
		        }
		    },
	
		    moveTo: function(x, y) {
		        var path = new Path();
		        path.moveTo(x, y);
	
		        this.paths.push(path);
	
		        return this;
		    },
	
		    lineTo: function(x, y) {
		        if (this.paths.length > 0) {
		            last(this.paths).lineTo(x, y);
		        }
	
		        return this;
		    },
	
		    curveTo: function(controlOut, controlIn, point) {
		        if (this.paths.length > 0) {
		            last(this.paths).curveTo(controlOut, controlIn, point);
		        }
	
		        return this;
		    },
	
		    arc: function(startAngle, endAngle, radiusX, radiusY, anticlockwise) {
		        if (this.paths.length > 0) {
		            last(this.paths).arc(startAngle, endAngle, radiusX, radiusY, anticlockwise);
		        }
	
		        return this;
		    },
	
		    arcTo: function(end, rx, ry, largeArc, swipe, rotation) {
		        if (this.paths.length > 0) {
		            last(this.paths).arcTo(end, rx, ry, largeArc, swipe, rotation);
		        }
	
		        return this;
		    },
	
		    close: function() {
		        if (this.paths.length > 0) {
		            last(this.paths).close();
		        }
	
		        return this;
		    },
	
		    _bbox: function(matrix) {
		        return elementsBoundingBox(this.paths, true, matrix);
		    },
	
		    rawBBox: function() {
		        return elementsBoundingBox(this.paths, false);
		    },
	
		    _containsPoint: function(point) {
		        var paths = this.paths;
	
		        for (var idx = 0; idx < paths.length; idx++) {
		            if (paths[idx]._containsPoint(point)) {
		                return true;
		            }
		        }
		        return false;
		    },
	
		    _isOnPath: function(point) {
		        var paths = this.paths;
		        var width = this.options.stroke.width;
	
		        for (var idx = 0; idx < paths.length; idx++) {
		            if (paths[idx]._isOnPath(point, width)) {
		                return true;
		            }
		        }
		        return false;
		    },
	
		    _clippedBBox: function(transformation) {
		        return elementsClippedBoundingBox(this.paths, this.currentTransform(transformation));
		    }
		});
	
		MultiPath.prototype.nodeType = "MultiPath";
	
		Paintable.extend(MultiPath.prototype);
		Measurable.extend(MultiPath.prototype);
	
		var ShapeMap = {
		    l: function(path, options) {
		        var parameters = options.parameters;
		        var position = options.position;
	
		        for (var i = 0; i < parameters.length; i += 2) {
		            var point = new Point(parameters[i], parameters[i + 1]);
	
		            if (options.isRelative) {
		                point.translateWith(position);
		            }
	
		            path.lineTo(point.x, point.y);
	
		            position.x = point.x;
		            position.y = point.y;
		        }
		    },
	
		    c: function(path, options) {
		        var parameters = options.parameters;
		        var position = options.position;
	
		        for (var i = 0; i < parameters.length; i += 6) {
		            var controlOut = new Point(parameters[i], parameters[i + 1]);
		            var controlIn = new Point(parameters[i + 2], parameters[i + 3]);
		            var point = new Point(parameters[i + 4], parameters[i + 5]);
		            if (options.isRelative) {
		                controlIn.translateWith(position);
		                controlOut.translateWith(position);
		                point.translateWith(position);
		            }
	
		            path.curveTo(controlOut, controlIn, point);
	
		            position.x = point.x;
		            position.y = point.y;
		        }
		    },
	
		    v: function(path, options) {
		        var value = options.isRelative ? 0 : options.position.x;
	
		        toLineParamaters(options.parameters, true, value);
		        this.l(path, options);
		    },
	
		    h: function(path, options) {
		        var value = options.isRelative ? 0 : options.position.y;
	
		        toLineParamaters(options.parameters, false, value);
		        this.l(path, options);
		    },
	
		    a: function(path, options) {
		        var parameters = options.parameters;
		        var position = options.position;
	
		        for (var i = 0; i < parameters.length; i += 7) {
		            var radiusX = parameters[i];
		            var radiusY = parameters[i + 1];
		            var rotation = parameters[i + 2];
		            var largeArc = parameters[i + 3];
		            var swipe = parameters[i + 4];
		            var endPoint = new Point(parameters[i + 5], parameters[i + 6]);
	
		            if (options.isRelative) {
		                endPoint.translateWith(position);
		            }
		            if (position.x !== endPoint.x || position.y !== endPoint.y) {
		                path.arcTo(endPoint, radiusX, radiusY, largeArc, swipe, rotation);
	
		                position.x = endPoint.x;
		                position.y = endPoint.y;
		            }
		        }
		    },
	
		    s: function(path, options) {
		        var parameters = options.parameters;
		        var position = options.position;
		        var previousCommand = options.previousCommand;
		        var lastControlIn;
	
		        if (previousCommand === "s" || previousCommand === "c") {
		            lastControlIn = last(last(path.paths).segments).controlIn();
		        }
	
		        for (var i = 0; i < parameters.length; i += 4) {
		            var controlIn = new Point(parameters[i], parameters[i + 1]);
		            var endPoint = new Point(parameters[i + 2], parameters[i + 3]);
		            var controlOut = (void 0);
	
		            if (options.isRelative) {
		                controlIn.translateWith(position);
		                endPoint.translateWith(position);
		            }
	
		            if (lastControlIn) {
		                controlOut = reflectionPoint(lastControlIn, position);
		            } else {
		                controlOut = position.clone();
		            }
	
		            lastControlIn = controlIn;
	
		            path.curveTo(controlOut, controlIn, endPoint);
	
		            position.x = endPoint.x;
		            position.y = endPoint.y;
		        }
		    },
	
		    q: function(path, options) {
		        var parameters = options.parameters;
		        var position = options.position;
	
		        for (var i = 0; i < parameters.length; i += 4) {
		            var controlPoint = new Point(parameters[i], parameters[i + 1]);
		            var endPoint = new Point(parameters[i + 2], parameters[i + 3]);
	
		            if (options.isRelative) {
		                controlPoint.translateWith(position);
		                endPoint.translateWith(position);
		            }
	
		            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);
	
		            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);
	
		            position.x = endPoint.x;
		            position.y = endPoint.y;
		        }
		    },
	
		    t: function(path, options) {
		        var parameters = options.parameters;
		        var position = options.position;
		        var previousCommand = options.previousCommand;
		        var controlPoint;
	
		        if (previousCommand === "q" || previousCommand === "t") {
		            var lastSegment = last(last(path.paths).segments);
		            controlPoint = lastSegment.controlIn().clone()
		                .translateWith(position.scaleCopy(-1 / 3))
		                .scale(3 / 2);
		        }
	
		        for (var i = 0; i < parameters.length; i += 2) {
		            var endPoint = new Point(parameters[i], parameters[i + 1]);
		            if (options.isRelative) {
		                endPoint.translateWith(position);
		            }
	
		            if (controlPoint) {
		                controlPoint = reflectionPoint(controlPoint, position);
		            } else {
		                controlPoint = position.clone();
		            }
	
		            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);
	
		            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);
	
		            position.x = endPoint.x;
		            position.y = endPoint.y;
		        }
		    }
		};
	
		function toLineParamaters(parameters, isVertical, value) {
		    var insertPosition = isVertical ? 0 : 1;
	
		    for (var i = 0; i < parameters.length; i += 2) {
		        parameters.splice(i + insertPosition, 0, value);
		    }
		}
	
		function reflectionPoint(point, center) {
		    if (point && center) {
		        return center.scaleCopy(2).translate(-point.x, -point.y);
		    }
		}
	
		var third = 1 / 3;
	
		function quadraticToCubicControlPoints(position, controlPoint, endPoint) {
		    var scaledPoint = controlPoint.clone().scale(2 / 3);
		    return {
		        controlOut: scaledPoint.clone().translateWith(position.scaleCopy(third)),
		        controlIn: scaledPoint.translateWith(endPoint.scaleCopy(third))
		    };
		}
	
		var SEGMENT_REGEX = /([a-df-z]{1})([^a-df-z]*)(z)?/gi;
		var SPLIT_REGEX = /[,\s]?([+\-]?(?:\d*\.\d+|\d+)(?:[eE][+\-]?\d+)?)/g;
		var MOVE = "m";
		var CLOSE = "z";
	
		function parseParameters(str) {
		    var parameters = [];
		    str.replace(SPLIT_REGEX, function(match, number) {
		        parameters.push(parseFloat(number));
		    });
		    return parameters;
		}
	
		var PathParser = Class.extend({
		    parse: function(str, options) {
		        var multiPath = new MultiPath(options);
		        var position = new Point();
		        var previousCommand;
	
		        str.replace(SEGMENT_REGEX, function (match, element, params, closePath) {
		            var command = element.toLowerCase();
		            var isRelative = command === element;
		            var parameters = parseParameters(params.trim());
	
		            if (command === MOVE) {
		                if (isRelative) {
		                    position.x += parameters[0];
		                    position.y += parameters[1];
		                } else {
		                    position.x = parameters[0];
		                    position.y = parameters[1];
		                }
	
		                multiPath.moveTo(position.x, position.y);
	
		                if (parameters.length > 2) {
		                    command = "l";
		                    parameters.splice(0, 2);
		                }
		            }
	
		            if (ShapeMap[command]) {
		                ShapeMap[command](
		                    multiPath, {
		                        parameters: parameters,
		                        position: position,
		                        isRelative: isRelative,
		                        previousCommand: previousCommand
		                    }
		                );
	
		                if (closePath && closePath.toLowerCase() === CLOSE) {
		                    multiPath.close();
		                }
		            } else if (command !== MOVE) {
		                throw new Error("Error while parsing SVG path. Unsupported command: " + command);
		            }
	
		            previousCommand = command;
		        });
	
		        return multiPath;
		    }
		});
	
		PathParser.current = new PathParser();
	
		var Path = Element$1.extend({
		    init: function(options) {
		        Element$1.fn.init.call(this, options);
		        this.segments = new GeometryElementsArray();
		        this.segments.addObserver(this);
	
		        if (!defined(this.options.stroke)) {
		            this.stroke("#000");
	
		            if (!defined(this.options.stroke.lineJoin)) {
		                this.options.set("stroke.lineJoin", "miter");
		            }
		        }
		    },
	
		    moveTo: function(x, y) {
		        this.suspend();
		        this.segments.elements([]);
		        this.resume();
	
		        this.lineTo(x, y);
	
		        return this;
		    },
	
		    lineTo: function(x, y) {
		        var point = defined(y) ? new Point(x, y) : x;
		        var segment = new Segment(point);
	
		        this.segments.push(segment);
	
		        return this;
		    },
	
		    curveTo: function(controlOut, controlIn, point) {
		        if (this.segments.length > 0) {
		            var lastSegment = last(this.segments);
		            var segment = new Segment(point, controlIn);
		            this.suspend();
		            lastSegment.controlOut(controlOut);
		            this.resume();
	
		            this.segments.push(segment);
		        }
	
		        return this;
		    },
	
		    arc: function(startAngle, endAngle, radiusX, radiusY, anticlockwise) {
		        if (this.segments.length > 0) {
		            var lastSegment = last(this.segments);
		            var anchor = lastSegment.anchor();
		            var start = rad(startAngle);
		            var center = new Point(anchor.x - radiusX * Math.cos(start),
		                anchor.y - radiusY * Math.sin(start));
		            var arc = new Arc$2(center, {
		                startAngle: startAngle,
		                endAngle: endAngle,
		                radiusX: radiusX,
		                radiusY: radiusY,
		                anticlockwise: anticlockwise
		            });
	
		            this._addArcSegments(arc);
		        }
	
		        return this;
		    },
	
		    arcTo: function(end, rx, ry, largeArc, swipe, rotation) {
		        if (this.segments.length > 0) {
		            var lastSegment = last(this.segments);
		            var anchor = lastSegment.anchor();
		            var arc = Arc$2.fromPoints(anchor, end, rx, ry, largeArc, swipe, rotation);
	
		            this._addArcSegments(arc);
		        }
		        return this;
		    },
	
		    _addArcSegments: function(arc) {
		        var this$1 = this;
	
		        this.suspend();
	
		        var curvePoints = arc.curvePoints();
	
		        for (var i = 1; i < curvePoints.length; i += 3) {
		            this$1.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
		        }
	
		        this.resume();
		        this.geometryChange();
		    },
	
		    close: function() {
		        this.options.closed = true;
		        this.geometryChange();
	
		        return this;
		    },
	
		    rawBBox: function() {
		        return this._bbox();
		    },
	
		    _containsPoint: function(point) {
		        var segments = this.segments;
		        var length = segments.length;
		        var intersectionsCount = 0;
		        var previous, current;
	
		        for (var idx = 1; idx < length; idx++) {
		            previous = segments[idx - 1];
		            current = segments[idx];
		            intersectionsCount += previous._intersectionsTo(current, point);
		        }
	
		        if (this.options.closed || !segments[0].anchor().equals(segments[length - 1].anchor())) {
		            intersectionsCount += lineIntersectionsCount(segments[0].anchor(), segments[length - 1].anchor(), point);
		        }
	
		        return intersectionsCount % 2 !== 0;
		    },
	
		    _isOnPath: function(point, width) {
		        var segments = this.segments;
		        var length = segments.length;
		        var pathWidth = width || this.options.stroke.width;
	
		        if (length > 1) {
		            if (segments[0]._isOnPathTo(segments[1], point, pathWidth, "start")) {
		                return true;
		            }
	
		            for (var idx = 2; idx <= length - 2; idx++) {
		                if (segments[idx - 1]._isOnPathTo(segments[idx], point, pathWidth)) {
		                    return true;
		                }
		            }
	
		            if (segments[length - 2]._isOnPathTo(segments[length - 1], point, pathWidth, "end")) {
		                return true;
		            }
		        }
		        return false;
		    },
	
		    _bbox: function(matrix) {
		        var segments = this.segments;
		        var length = segments.length;
		        var boundingBox;
	
		        if (length === 1) {
		            var anchor = segments[0].anchor().transformCopy(matrix);
		            boundingBox = new Rect(anchor, Size.ZERO);
		        } else if (length > 0) {
		            for (var i = 1; i < length; i++) {
		                var segmentBox = segments[i - 1].bboxTo(segments[i], matrix);
		                if (boundingBox) {
		                    boundingBox = Rect.union(boundingBox, segmentBox);
		                } else {
		                    boundingBox = segmentBox;
		                }
		            }
		        }
	
		        return boundingBox;
		    }
		});
	
		Path.fromRect = function(rect, options) {
		    return new Path(options)
		        .moveTo(rect.topLeft())
		        .lineTo(rect.topRight())
		        .lineTo(rect.bottomRight())
		        .lineTo(rect.bottomLeft())
		        .close();
		};
	
		Path.fromPoints = function(points, options) {
		    if (points) {
		        var path = new Path(options);
	
		        for (var i = 0; i < points.length; i++) {
		            var point = Point.create(points[i]);
		            if (point) {
		                if (i === 0) {
		                    path.moveTo(point);
		                } else {
		                    path.lineTo(point);
		                }
		            }
		        }
	
		        return path;
		    }
		};
	
		Path.fromArc = function(arc, options) {
		    var path = new Path(options);
		    var startAngle = arc.startAngle;
		    var start = arc.pointAt(startAngle);
		    path.moveTo(start.x, start.y);
		    path.arc(startAngle, arc.endAngle, arc.radiusX, arc.radiusY, arc.anticlockwise);
		    return path;
		};
	
		Path.prototype.nodeType = "Path";
	
		Paintable.extend(Path.prototype);
		Measurable.extend(Path.prototype);
	
		Path.parse = function(str, options) {
		    return PathParser.current.parse(str, options);
		};
	
		var DEFAULT_STROKE$1 = "#000";
	
		var Arc = Element$1.extend({
		    init: function(geometry, options) {
		        if (geometry === void 0) { geometry = new Arc$2(); }
		        if (options === void 0) { options = {}; }
	
		        Element$1.fn.init.call(this, options);
	
		        this.geometry(geometry);
	
		        if (!defined(this.options.stroke)) {
		            this.stroke(DEFAULT_STROKE$1);
		        }
		    },
	
		    _bbox: function(matrix) {
		        return this._geometry.bbox(matrix);
		    },
	
		    rawBBox: function() {
		        return this.geometry().bbox();
		    },
	
		    toPath: function() {
		        var path = new Path();
		        var curvePoints = this.geometry().curvePoints();
	
		        if (curvePoints.length > 0) {
		            path.moveTo(curvePoints[0].x, curvePoints[0].y);
	
		            for (var i = 1; i < curvePoints.length; i += 3) {
		                path.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
		            }
		        }
	
		        return path;
		    },
	
		    _containsPoint: function(point) {
		        return this.geometry().containsPoint(point);
		    },
	
		    _isOnPath: function(point) {
		        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
		    }
		});
	
		Arc.prototype.nodeType = "Arc";
	
		Paintable.extend(Arc.prototype);
		Measurable.extend(Arc.prototype);
		defineGeometryAccessors(Arc.prototype, [ "geometry" ]);
	
		var DEFAULT_FONT = "12px sans-serif";
		var DEFAULT_FILL = "#000";
	
		var Text = Element$1.extend({
		    init: function(content, position, options) {
		        if (position === void 0) { position = new Point(); }
		        if (options === void 0) { options = {}; }
	
		        Element$1.fn.init.call(this, options);
	
		        this.content(content);
		        this.position(position);
	
		        if (!this.options.font) {
		            this.options.font = DEFAULT_FONT;
		        }
	
		        if (!defined(this.options.fill)) {
		            this.fill(DEFAULT_FILL);
		        }
		    },
	
		    content: function(value) {
		        if (defined(value)) {
		            this.options.set("content", value);
		            return this;
		        }
	
		        return this.options.get("content");
		    },
	
		    measure: function() {
		        var metrics = kendoUtil.measureText(this.content(), {
		            font: this.options.get("font")
		        });
	
		        return metrics;
		    },
	
		    rect: function() {
		        var size = this.measure();
		        var pos = this.position().clone();
		        return new Rect(pos, [ size.width, size.height ]);
		    },
	
		    bbox: function(transformation) {
		        var combinedMatrix = toMatrix(this.currentTransform(transformation));
		        return this.rect().bbox(combinedMatrix);
		    },
	
		    rawBBox: function() {
		        return this.rect().bbox();
		    },
	
		    _containsPoint: function(point) {
		        return this.rect().containsPoint(point);
		    }
		});
	
		Text.prototype.nodeType = "Text";
	
		Paintable.extend(Text.prototype);
	
		definePointAccessors(Text.prototype, [ "position" ]);
	
		var Image$1 = Element$1.extend({
		    init: function(src, rect, options) {
		        if (rect === void 0) { rect = new Rect(); }
		        if (options === void 0) { options = {}; }
	
		        Element$1.fn.init.call(this, options);
	
		        this.src(src);
		        this.rect(rect);
		    },
	
		    src: function(value) {
		        if (defined(value)) {
		            this.options.set("src", value);
		            return this;
		        }
	
		        return this.options.get("src");
		    },
	
		    bbox: function(transformation) {
		        var combinedMatrix = toMatrix(this.currentTransform(transformation));
		        return this._rect.bbox(combinedMatrix);
		    },
	
		    rawBBox: function() {
		        return this._rect.bbox();
		    },
	
		    _containsPoint: function(point) {
		        return this._rect.containsPoint(point);
		    },
	
		    _hasFill: function() {
		        return this.src();
		    }
		});
	
		Image$1.prototype.nodeType = "Image";
	
		defineGeometryAccessors(Image$1.prototype, [ "rect" ]);
	
		var Traversable = {
		    extend: function(proto, childrenField) {
		        proto.traverse = function(callback) {
		            var children = this[childrenField];
	
		            for (var i = 0; i < children.length; i++) {
		                var child = children[i];
	
		                if (child.traverse) {
		                    child.traverse(callback);
		                } else {
		                    callback(child);
		                }
		            }
	
		            return this;
		        };
		    }
		};
	
		var Group = Element$1.extend({
		    init: function(options) {
		        Element$1.fn.init.call(this, options);
		        this.children = [];
		    },
	
		    childrenChange: function(action, items, index) {
		        this.trigger("childrenChange",{
		            action: action,
		            items: items,
		            index: index
		        });
		    },
	
		    append: function() {
		        append(this.children, arguments);
		        this._reparent(arguments, this);
	
		        this.childrenChange("add", arguments);
	
		        return this;
		    },
	
		    insert: function(index, element) {
		        this.children.splice(index, 0, element);
		        element.parent = this;
	
		        this.childrenChange("add", [ element ], index);
	
		        return this;
		    },
	
		    insertAt: function(element, index) {
		        return this.insert(index, element);
		    },
	
		    remove: function(element) {
		        var index = this.children.indexOf(element);
		        if (index >= 0) {
		            this.children.splice(index, 1);
		            element.parent = null;
		            this.childrenChange("remove", [ element ], index);
		        }
	
		        return this;
		    },
	
		    removeAt: function(index) {
		        if (0 <= index && index < this.children.length) {
		            var element = this.children[index];
		            this.children.splice(index, 1);
		            element.parent = null;
		            this.childrenChange("remove", [ element ], index);
		        }
	
		        return this;
		    },
	
		    clear: function() {
		        var items = this.children;
		        this.children = [];
		        this._reparent(items, null);
	
		        this.childrenChange("remove", items, 0);
	
		        return this;
		    },
	
		    bbox: function(transformation) {
		        return elementsBoundingBox(this.children, true, this.currentTransform(transformation));
		    },
	
		    rawBBox: function() {
		        return elementsBoundingBox(this.children, false);
		    },
	
		    _clippedBBox: function(transformation) {
		        return elementsClippedBoundingBox(this.children, this.currentTransform(transformation));
		    },
	
		    currentTransform: function(transformation) {
		        return Element$1.prototype.currentTransform.call(this, transformation) || null;
		    },
	
		    containsPoint: function(point, parentTransform) {
		        if (this.visible()) {
		            var children = this.children;
		            var transform = this.currentTransform(parentTransform);
		            for (var idx = 0; idx < children.length; idx++) {
		                if (children[idx].containsPoint(point, transform)) {
		                    return true;
		                }
		            }
		        }
		        return false;
		    },
	
		    _reparent: function(elements, newParent) {
		        var this$1 = this;
	
		        for (var i = 0; i < elements.length; i++) {
		            var child = elements[i];
		            var parent = child.parent;
		            if (parent && parent !== this$1 && parent.remove) {
		                parent.remove(child);
		            }
	
		            child.parent = newParent;
		        }
		    }
		});
	
		Group.prototype.nodeType = "Group";
	
		Traversable.extend(Group.prototype, "children");
	
		function translateToPoint(point, bbox, element) {
		    var transofrm = element.transform() || transform();
		    var matrix = transofrm.matrix();
		    matrix.e += point.x - bbox.origin.x;
		    matrix.f += point.y - bbox.origin.y;
	
		    transofrm.matrix(matrix);
		    element.transform(transofrm);
		}
	
		function alignStart(size, rect, align, axis, sizeField) {
		    var start;
		    if (align === "start") {
		        start = rect.origin[axis];
		    } else if (align === "end") {
		        start = rect.origin[axis] + rect.size[sizeField] - size;
		    } else {
		        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
		    }
	
		    return start;
		}
	
		function alignStartReverse(size, rect, align, axis, sizeField) {
		    var start;
		    if (align === "start") {
		        start = rect.origin[axis] + rect.size[sizeField] - size;
		    } else if (align === "end") {
		        start = rect.origin[axis];
		    } else {
		        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
		    }
	
		    return start;
		}
	
		var DEFAULT_OPTIONS = {
		    alignContent: "start",
		    justifyContent: "start",
		    alignItems: "start",
		    spacing: 0,
		    orientation: "horizontal",
		    lineSpacing: 0,
		    wrap: true,
		    revers: false
		};
	
		var forEach = function (elements, callback) {
		    elements.forEach(callback);
		};
	
		var forEachReverse = function (elements, callback) {
		    var length = elements.length;
	
		    for (var idx = length - 1; idx >= 0; idx--) {
		        callback(elements[idx], idx);
		    }
		};
	
		var Layout = Group.extend({
		    init: function(rect, options) {
		        Group.fn.init.call(this, $.extend({}, DEFAULT_OPTIONS, options));
		        this._rect = rect;
		        this._fieldMap = {};
		    },
	
		    rect: function(value) {
		        if (value) {
		            this._rect = value;
		            return this;
		        }
	
		        return this._rect;
		    },
	
		    _initMap: function() {
		        var options = this.options;
		        var fieldMap = this._fieldMap;
		        if (options.orientation === "horizontal") {
		            fieldMap.sizeField = "width";
		            fieldMap.groupsSizeField = "height";
		            fieldMap.groupAxis = "x";
		            fieldMap.groupsAxis = "y";
		        } else {
		            fieldMap.sizeField = "height";
		            fieldMap.groupsSizeField = "width";
		            fieldMap.groupAxis = "y";
		            fieldMap.groupsAxis = "x";
		        }
	
		        if (options.reverse) {
		            this.forEach = forEachReverse;
		            this.justifyAlign = alignStartReverse;
		        } else {
		            this.forEach = forEach;
		            this.justifyAlign = alignStart;
		        }
		    },
	
		    reflow: function() {
		        var this$1 = this;
	
		        if (!this._rect || this.children.length === 0) {
		            return;
		        }
		        this._initMap();
	
		        if (this.options.transform) {
		            this.transform(null);
		        }
	
		        var options = this.options;
		        var rect = this._rect;
		        var ref = this._initGroups();
		        var groups = ref.groups;
		        var groupsSize = ref.groupsSize;
		        var ref$1 = this._fieldMap;
		        var sizeField = ref$1.sizeField;
		        var groupsSizeField = ref$1.groupsSizeField;
		        var groupAxis = ref$1.groupAxis;
		        var groupsAxis = ref$1.groupsAxis;
		        var groupOrigin = new Point();
		        var elementOrigin = new Point();
		        var size = new Size();
		        var groupStart = alignStart(groupsSize, rect, options.alignContent, groupsAxis, groupsSizeField);
		        var elementStart, group, groupBox;
	
		        var arrangeElements = function (bbox, idx) {
		            var element = group.elements[idx];
	
		            elementOrigin[groupAxis] = elementStart;
		            elementOrigin[groupsAxis] = alignStart(bbox.size[groupsSizeField], groupBox, options.alignItems, groupsAxis, groupsSizeField);
		            translateToPoint(elementOrigin, bbox, element);
		            elementStart += bbox.size[sizeField] + options.spacing;
		        };
	
		        for (var groupIdx = 0; groupIdx < groups.length; groupIdx++) {
		            group = groups[groupIdx];
		            groupOrigin[groupAxis] = elementStart = this$1.justifyAlign(group.size, rect, options.justifyContent, groupAxis, sizeField);
		            groupOrigin[groupsAxis] = groupStart;
		            size[sizeField] = group.size;
		            size[groupsSizeField] = group.lineSize;
		            groupBox = new Rect(groupOrigin, size);
		            this$1.forEach(group.bboxes, arrangeElements);
	
		            groupStart += group.lineSize + options.lineSpacing;
		        }
	
		        if (!options.wrap && group.size > rect.size[sizeField]) {
		            var scale = rect.size[sizeField] / groupBox.size[sizeField];
		            var scaledStart = groupBox.topLeft().scale(scale, scale);
		            var scaledSize = groupBox.size[groupsSizeField] * scale;
		            var newStart = alignStart(scaledSize, rect, options.alignContent, groupsAxis, groupsSizeField);
		            var transform$$1 = transform();
		            if (groupAxis === "x") {
		                transform$$1.translate(rect.origin.x - scaledStart.x, newStart - scaledStart.y);
		            } else {
		                transform$$1.translate(newStart - scaledStart.x, rect.origin.y - scaledStart.y);
		            }
		            transform$$1.scale(scale, scale);
	
		            this.transform(transform$$1);
		        }
		    },
	
		    _initGroups: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var children = ref.children;
		        var lineSpacing = options.lineSpacing;
		        var wrap = options.wrap;
		        var spacing = options.spacing;
		        var sizeField = this._fieldMap.sizeField;
		        var group = this._newGroup();
		        var groups = [];
		        var addGroup = function() {
		            groups.push(group);
		            groupsSize += group.lineSize + lineSpacing;
		        };
		        var groupsSize = -lineSpacing;
	
		        for (var idx = 0; idx < children.length; idx++) {
		            var element = children[idx];
		            var bbox = children[idx].clippedBBox();
		            if (element.visible() && bbox) {
		                if (wrap && group.size + bbox.size[sizeField] + spacing > this$1._rect.size[sizeField]) {
		                    if (group.bboxes.length === 0) {
		                        this$1._addToGroup(group, bbox, element);
		                        addGroup();
		                        group = this$1._newGroup();
		                    } else {
		                        addGroup();
		                        group = this$1._newGroup();
		                        this$1._addToGroup(group, bbox, element);
		                    }
		                } else {
		                    this$1._addToGroup(group, bbox, element);
		                }
		            }
		        }
	
		        if (group.bboxes.length) {
		            addGroup();
		        }
	
		        return {
		            groups: groups,
		            groupsSize: groupsSize
		        };
		    },
	
		    _addToGroup: function(group, bbox, element) {
		        group.size += bbox.size[this._fieldMap.sizeField] + this.options.spacing;
		        group.lineSize = Math.max(bbox.size[this._fieldMap.groupsSizeField], group.lineSize);
		        group.bboxes.push(bbox);
		        group.elements.push(element);
		    },
	
		    _newGroup: function() {
		        return {
		            lineSize: 0,
		            size: -this.options.spacing,
		            bboxes: [],
		            elements: []
		        };
		    }
		});
	
		var Rect$2 = Element$1.extend({
		    init: function(geometry, options) {
		        if (geometry === void 0) { geometry = new Rect(); }
		        if (options === void 0) { options = {}; }
	
		        Element$1.fn.init.call(this, options);
		        this.geometry(geometry);
	
		        if (!defined(this.options.stroke)) {
		            this.stroke("#000");
		        }
		    },
	
		    _bbox: function(matrix) {
		        return this._geometry.bbox(matrix);
		    },
	
		    rawBBox: function() {
		        return this._geometry.bbox();
		    },
	
		    _containsPoint: function(point) {
		        return this._geometry.containsPoint(point);
		    },
	
		    _isOnPath: function(point) {
		        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
		    }
		});
	
		Rect$2.prototype.nodeType = "Rect";
	
		Paintable.extend(Rect$2.prototype);
		Measurable.extend(Rect$2.prototype);
		defineGeometryAccessors(Rect$2.prototype, [ "geometry" ]);
	
		function alignElements(elements, rect, alignment, axis, sizeField) {
		    for (var idx = 0; idx < elements.length; idx++) {
		        var bbox = elements[idx].clippedBBox();
		        if (bbox) {
		            var point = bbox.origin.clone();
		            point[axis] = alignStart(bbox.size[sizeField], rect, alignment || "start", axis, sizeField);
		            translateToPoint(point, bbox, elements[idx]);
		        }
		    }
		}
	
		function align(elements, rect, alignment) {
		    alignElements(elements, rect, alignment, "x", "width");
		}
	
		function vAlign(elements, rect, alignment) {
		    alignElements(elements, rect, alignment, "y", "height");
		}
	
		function stackElements(elements, stackAxis, otherAxis, sizeField) {
		    if (elements.length > 1) {
		        var origin = new Point();
		        var previousBBox = elements[0].bbox;
	
		        for (var idx = 1; idx < elements.length; idx++) {
		            var element = elements[idx].element;
		            var bbox = elements[idx].bbox;
		            origin[stackAxis] = previousBBox.origin[stackAxis] + previousBBox.size[sizeField];
		            origin[otherAxis] = bbox.origin[otherAxis];
		            translateToPoint(origin, bbox, element);
		            bbox.origin[stackAxis] = origin[stackAxis];
		            previousBBox = bbox;
		        }
		    }
		}
	
		function createStackElements(elements) {
		    var stackElements = [];
	
		    for (var idx = 0; idx < elements.length; idx++) {
		        var element = elements[idx];
		        var bbox = element.clippedBBox();
		        if (bbox) {
		            stackElements.push({
		                element: element,
		                bbox: bbox
		            });
		        }
		    }
	
		    return stackElements;
		}
	
		function stack(elements) {
		    stackElements(createStackElements(elements), "x", "y", "width");
		}
	
		function vStack(elements) {
		    stackElements(createStackElements(elements), "y", "x", "height");
		}
	
		function getStacks(elements, rect, sizeField) {
		    var maxSize = rect.size[sizeField];
		    var stacks = [];
		    var stack = [];
		    var stackSize = 0;
		    var element, bbox;
	
		    var addElementToStack = function() {
		        stack.push({
		            element: element,
		            bbox: bbox
		        });
		    };
	
		    for (var idx = 0; idx < elements.length; idx++) {
		        element = elements[idx];
	
		        bbox = element.clippedBBox();
		        if (bbox) {
		            var size = bbox.size[sizeField];
		            if (stackSize + size > maxSize) {
		                if (stack.length) {
		                    stacks.push(stack);
		                    stack = [];
		                    addElementToStack();
		                    stackSize = size;
		                } else {
		                    addElementToStack();
		                    stacks.push(stack);
		                    stack = [];
		                    stackSize = 0;
		                }
		            } else {
		                addElementToStack();
		                stackSize += size;
		            }
		        }
		    }
	
		    if (stack.length) {
		        stacks.push(stack);
		    }
	
		    return stacks;
		}
	
		function wrapElements(elements, rect, axis, otherAxis, sizeField) {
		    var stacks = getStacks(elements, rect, sizeField);
		    var origin = rect.origin.clone();
		    var result = [];
	
		    for (var idx = 0; idx < stacks.length; idx++) {
		        var stack = stacks[idx];
		        var startElement = stack[0];
		        origin[otherAxis] = startElement.bbox.origin[otherAxis];
		        translateToPoint(origin, startElement.bbox, startElement.element);
		        startElement.bbox.origin[axis] = origin[axis];
		        stackElements(stack, axis, otherAxis, sizeField);
		        result.push([]);
		        for (var elementIdx = 0; elementIdx < stack.length; elementIdx++) {
		            result[idx].push(stack[elementIdx].element);
		        }
		    }
		    return result;
		}
	
		function wrap(elements, rect) {
		    return wrapElements(elements, rect, "x", "y", "width");
		}
	
		function vWrap(elements, rect) {
		    return wrapElements(elements, rect, "y", "x", "height");
		}
	
		function fit(element, rect) {
		    var bbox = element.clippedBBox();
		    if (bbox) {
		        var elementSize = bbox.size;
		        var rectSize = rect.size;
		        if (rectSize.width < elementSize.width || rectSize.height < elementSize.height) {
		            var scale = Math.min(rectSize.width / elementSize.width, rectSize.height / elementSize.height);
		            var transform$$1 = element.transform() || transform();
		            transform$$1.scale(scale, scale);
		            element.transform(transform$$1);
		        }
		    }
		}
	
		var StopsArray = ElementsArray.extend({
		    _change: function() {
		        this.optionsChange({
		            field: "stops"
		        });
		    }
		});
	
		function optionsAccessor(name) {
		    return function(value) {
		        if (defined(value)) {
		            this.options.set(name, value);
		            return this;
		        }
	
		        return this.options.get(name);
		    };
		}
	
		function defineOptionsAccessors(fn, names) {
		    for (var i = 0; i < names.length; i++) {
		        fn[names[i]] = optionsAccessor(names[i]);
		    }
		}
	
		var GradientStop = Class.extend({
		    init: function(offset, color, opacity) {
	
		        this.options = new OptionsStore({
		            offset: offset,
		            color: color,
		            opacity: defined(opacity) ? opacity : 1
		        });
		        this.options.addObserver(this);
		    }
		});
	
		GradientStop.create = function(arg) {
		    if (defined(arg)) {
		        var stop;
		        if (arg instanceof GradientStop) {
		            stop = arg;
		        } else if (arg.length > 1) {
		            stop = new GradientStop(arg[0], arg[1], arg[2]);
		        } else {
		            stop = new GradientStop(arg.offset, arg.color, arg.opacity);
		        }
	
		        return stop;
		    }
		};
	
		defineOptionsAccessors(GradientStop.prototype, [ "offset", "color", "opacity" ]);
		ObserversMixin.extend(GradientStop.prototype);
	
		var Gradient = Class.extend({
		    init: function(options) {
		        if (options === void 0) { options = {}; }
	
		        this.stops = new StopsArray(this._createStops(options.stops));
		        this.stops.addObserver(this);
		        this._userSpace = options.userSpace;
		        this.id = definitionId();
		    },
	
		    userSpace: function(value) {
		        if (defined(value)) {
		            this._userSpace = value;
		            this.optionsChange();
		            return this;
		        }
	
		        return this._userSpace;
		    },
	
		    _createStops: function(stops) {
		        if (stops === void 0) { stops = []; }
	
		        var result = [];
		        for (var idx = 0; idx < stops.length; idx++) {
		            result.push(GradientStop.create(stops[idx]));
		        }
	
		        return result;
		    },
	
		    addStop: function(offset, color, opacity) {
		        this.stops.push(new GradientStop(offset, color, opacity));
		    },
	
		    removeStop: function(stop) {
		        var index = this.stops.indexOf(stop);
		        if (index >= 0) {
		            this.stops.splice(index, 1);
		        }
		    }
		});
	
		Gradient.prototype.nodeType = "Gradient";
	
		ObserversMixin.extend(Gradient.prototype);
	
		$.extend(Gradient.prototype, {
		    optionsChange: function(e) {
		        this.trigger("optionsChange", {
		            field: "gradient" + (e ? "." + e.field : ""),
		            value: this
		        });
		    },
	
		    geometryChange: function() {
		        this.optionsChange();
		    }
		});
	
		var LinearGradient = Gradient.extend({
		    init: function(options) {
		        if (options === void 0) { options = {}; }
	
		        Gradient.fn.init.call(this, options);
	
		        this.start(options.start || new Point());
	
		        this.end(options.end || new Point(1, 0));
		    }
		});
	
		definePointAccessors(LinearGradient.prototype, [ "start", "end" ]);
	
		var RadialGradient = Gradient.extend({
		    init: function(options) {
		        if (options === void 0) { options = {}; }
	
		        Gradient.fn.init.call(this, options);
	
		        this.center(options.center || new Point());
		        this._radius = defined(options.radius) ? options.radius : 1;
		        this._fallbackFill = options.fallbackFill;
		    },
	
		    radius: function(value) {
		        if (defined(value)) {
		            this._radius = value;
		            this.geometryChange();
		            return this;
		        }
	
		        return this._radius;
		    },
	
		    fallbackFill: function(value) {
		        if (defined(value)) {
		            this._fallbackFill = value;
		            this.optionsChange();
		            return this;
		        }
	
		        return this._fallbackFill;
		    }
		});
	
		definePointAccessors(RadialGradient.prototype, [ "center" ]);
	
		function swing(position) {
		    return 0.5 - Math.cos(position * Math.PI) / 2;
		}
	
		function linear(position) {
		    return position;
		}
	
		function easeOutElastic(position, time, start, diff) {
		    var s = 1.70158,
		        p = 0,
		        a = diff;
	
		    if (position === 0) {
		        return start;
		    }
	
		    if (position === 1) {
		        return start + diff;
		    }
	
		    if (!p) {
		        p = 0.5;
		    }
	
		    if (a < Math.abs(diff)) {
		        a = diff;
		        s = p / 4;
		    } else {
		        s = p / (2 * Math.PI) * Math.asin(diff / a);
		    }
	
		    return a * Math.pow(2, -10 * position) *
		           Math.sin((Number(position) - s) * (1.1 * Math.PI) / p) + diff + start;
		}
	
		var easingFunctions = {
			swing: swing,
			linear: linear,
			easeOutElastic: easeOutElastic
		};
	
		var AnimationFactory = Class.extend({
		    init: function() {
	
		        this._items = [];
		    },
	
		    register: function(name, type) {
		        this._items.push({
		            name: name,
		            type: type
		        });
		    },
	
		    create: function(element, options) {
		        var items = this._items;
		        var match;
	
		        if (options && options.type) {
		            var type = options.type.toLowerCase();
		            for (var i = 0; i < items.length; i++) {
		                if (items[i].name.toLowerCase() === type) {
		                    match = items[i];
		                    break;
		                }
		            }
		        }
	
		        if (match) {
		            return new match.type(element, options);
		        }
		    }
		});
	
		AnimationFactory.current = new AnimationFactory();
	
		var now = Date.now || function() {
		    return new Date().getTime();
		};
	
		var Animation = Class.extend({
		    init: function(element, options) {
	
		        this.options = $.extend({}, this.options, options);
		        this.element = element;
		    },
	
		    setup: function() {},
	
		    step: function() {},
	
		    play: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var duration = options.duration;
		        var delay = options.delay; if (delay === void 0) { delay = 0; }
		        var easing = easingFunctions[options.easing];
		        var start = now() + delay;
		        var finish = start + duration;
	
		        if (duration === 0) {
		            this.step(1);
		            this.abort();
		        } else {
		            setTimeout(function () {
		                var loop = function () {
		                    if (this$1._stopped) {
		                        return;
		                    }
	
		                    var wallTime = now();
	
		                    var time = limitValue(wallTime - start, 0, duration);
		                    var position = time / duration;
		                    var easingPosition = easing(position, time, 0, 1, duration);
	
		                    this$1.step(easingPosition);
	
		                    if (wallTime < finish) {
		                        kendo.animationFrame(loop);
		                    } else {
		                        this$1.abort();
		                    }
		                };
	
		                loop();
		            }, delay);
		        }
		    },
	
		    abort: function() {
		        this._stopped = true;
		    },
	
		    destroy: function() {
		        this.abort();
		    }
		});
	
		Animation.prototype.options = {
		    duration: 500,
		    easing: "swing"
		};
	
		Animation.create = function(type, element, options) {
		    return AnimationFactory.current.create(type, element, options);
		};
	
		var SurfaceFactory = Class.extend({
		    init: function() {
	
		        this._items = [];
		    },
	
		    register: function(name, type, order) {
		        var items = this._items;
		        var first = items[0];
		        var entry = {
		            name: name,
		            type: type,
		            order: order
		        };
	
		        if (!first || order < first.order) {
		            items.unshift(entry);
		        } else {
		            items.push(entry);
		        }
		    },
	
		    create: function(element, options) {
		        var items = this._items;
		        var match = items[0];
	
		        if (options && options.type) {
		            var preferred = options.type.toLowerCase();
		            for (var i = 0; i < items.length; i++) {
		                if (items[i].name === preferred) {
		                    match = items[i];
		                    break;
		                }
		            }
		        }
	
		        if (match) {
		            return new match.type(element, options);
		        }
	
		        kendo.logToConsole(
		            "Warning: Unable to create Kendo UI Drawing Surface. Possible causes:\n" +
		            "- The browser does not support SVG and Canvas. User agent: " + (navigator.userAgent));
		    }
		});
	
		SurfaceFactory.current = new SurfaceFactory();
	
		var events = [
		    "click",
		    "mouseenter",
		    "mouseleave",
		    "mousemove",
		    "resize"
		];
	
		var Surface = kendo.Observable.extend({
		    init: function(element, options) {
		        kendo.Observable.fn.init.call(this);
	
		        this.options = $.extend({}, options);
		        this.element = element;
		        this.element._kendoExportVisual = this.exportVisual.bind(this);
	
		        this._click = this._handler("click");
		        this._mouseenter = this._handler("mouseenter");
		        this._mouseleave = this._handler("mouseleave");
		        this._mousemove = this._handler("mousemove");
	
		        this._visual = new Group();
	
		        elementSize(element, this.options);
	
		        this.bind(events, this.options);
	
		        this._enableTracking();
		    },
	
		    draw: function(element) {
		        this._visual.children.push(element);
		    },
	
		    clear: function() {
		        this._visual.children = [];
		    },
	
		    destroy: function() {
		        this._visual = null;
		        this.element._kendoExportVisual = null;
		        this.unbind();
		    },
	
		    eventTarget: function(e) {
		        var this$1 = this;
	
		        var domNode = eventElement(e);
		        var node;
	
		        while (!node && domNode) {
		            node = domNode._kendoNode;
		            if (domNode === this$1.element) {
		                break;
		            }
	
		            domNode = domNode.parentElement;
		        }
	
		        if (node) {
		            return node.srcElement;
		        }
		    },
	
		    exportVisual: function() {
		        return this._visual;
		    },
	
		    getSize: function() {
		        return elementSize(this.element);
		    },
	
		    currentSize: function(size) {
		        if (size) {
		            this._size = size;
		        } else {
		            return this._size;
		        }
		    },
	
		    setSize: function(size) {
		        elementSize(this.element, size);
	
		        this.currentSize(size);
		        this._resize();
		    },
	
		    resize: function(force) {
		        var size = this.getSize();
		        var currentSize = this.currentSize();
	
		        if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
		            this.currentSize(size);
		            this._resize(size, force);
		            this.trigger("resize", size);
		        }
		    },
	
		    size: function(value) {
		        if (!value) {
		            return this.getSize();
		        }
	
		        this.setSize(value);
		    },
	
		    suspendTracking: function() {
		        this._suspendedTracking = true;
		    },
	
		    resumeTracking: function() {
		        this._suspendedTracking = false;
		    },
	
		    _enableTracking: function() {},
	
		    _resize: function() {},
	
		    _handler: function(eventName) {
		        var this$1 = this;
	
		        return function (e) {
		            var node = this$1.eventTarget(e);
		            if (node && !this$1._suspendedTracking) {
		                this$1.trigger(eventName, {
		                    element: node,
		                    originalEvent: e,
		                    type: eventName
		                });
		            }
		        };
		    },
	
		    _elementOffset: function() {
		        var element = this.element;
		        var ref = elementStyles(element, [ "paddingLeft", "paddingTop" ]);
		        var paddingLeft = ref.paddingLeft;
		        var paddingTop = ref.paddingTop;
		        var ref$1 = elementOffset(element);
		        var left = ref$1.left;
		        var top = ref$1.top;
	
		        return {
		            left: left + parseInt(paddingLeft, 10),
		            top: top + parseInt(paddingTop, 10)
		        };
		    },
	
		    _surfacePoint: function(e) {
		        var offset = this._elementOffset();
		        var coord = eventCoordinates(e);
		        var x = coord.x - offset.left;
		        var y = coord.y - offset.top;
	
		        return new Point(x, y);
		    }
		});
	
		Surface.create = function(element, options) {
		    return SurfaceFactory.current.create(element, options);
		};
	
		Surface.support = {};
	
		var BaseNode = Class.extend({
		    init: function(srcElement) {
	
		        this.childNodes = [];
		        this.parent = null;
	
		        if (srcElement) {
		            this.srcElement = srcElement;
		            this.observe();
		        }
		    },
	
		    destroy: function() {
		        var this$1 = this;
	
		        if (this.srcElement) {
		            this.srcElement.removeObserver(this);
		        }
	
		        var children = this.childNodes;
		        for (var i = 0; i < children.length; i++) {
		            this$1.childNodes[i].destroy();
		        }
	
		        this.parent = null;
		    },
	
		    load: function() {},
	
		    observe: function() {
		        if (this.srcElement) {
		            this.srcElement.addObserver(this);
		        }
		    },
	
		    append: function(node) {
		        this.childNodes.push(node);
		        node.parent = this;
		    },
	
		    insertAt: function(node, pos) {
		        this.childNodes.splice(pos, 0, node);
		        node.parent = this;
		    },
	
		    remove: function(index, count) {
		        var this$1 = this;
	
		        var end = index + count;
		        for (var i = index; i < end; i++) {
		            this$1.childNodes[i].removeSelf();
		        }
		        this.childNodes.splice(index, count);
		    },
	
		    removeSelf: function() {
		        this.clear();
		        this.destroy();
		    },
	
		    clear: function() {
		        this.remove(0, this.childNodes.length);
		    },
	
		    invalidate: function() {
		        if (this.parent) {
		            this.parent.invalidate();
		        }
		    },
	
		    geometryChange: function() {
		        this.invalidate();
		    },
	
		    optionsChange: function() {
		        this.invalidate();
		    },
	
		    childrenChange: function(e) {
		        if (e.action === "add") {
		            this.load(e.items, e.index);
		        } else if (e.action === "remove") {
		            this.remove(e.index, e.items.length);
		        }
	
		        this.invalidate();
		    }
		});
	
		function renderAttr(name, value) {
		    return (defined(value) && value !== null) ? (" " + name + "=\"" + value + "\" ") : "";
		}
	
		function renderAllAttr(attrs) {
		    var output = "";
		    for (var i = 0; i < attrs.length; i++) {
		        output += renderAttr(attrs[i][0], attrs[i][1]);
		    }
	
		    return output;
		}
	
		function renderStyle(attrs) {
		    var output = "";
		    for (var i = 0; i < attrs.length; i++) {
		        var value = attrs[i][1];
		        if (defined(value)) {
		            output += attrs[i][0] + ":" + value + ";";
		        }
		    }
	
		    if (output !== "") {
		        return output;
		    }
		}
	
		var NODE_MAP = {};
	
		var SVG_NS = "http://www.w3.org/2000/svg";
		var NONE = "none";
	
		var renderSVG = function(container, svg) {
		    container.innerHTML = svg;
		};
	
		if (typeof document !== "undefined") {
		    var testFragment = "<svg xmlns='" + SVG_NS + "'></svg>";
		    var testContainer = document.createElement("div");
		    var hasParser = typeof DOMParser !== "undefined";
	
		    testContainer.innerHTML = testFragment;
	
		    if (hasParser && testContainer.firstChild.namespaceURI !== SVG_NS) {
		        renderSVG = function(container, svg) {
		            var parser = new DOMParser();
		            var chartDoc = parser.parseFromString(svg, "text/xml");
		            var importedDoc = document.adoptNode(chartDoc.documentElement);
	
		            container.innerHTML = "";
		            container.appendChild(importedDoc);
		        };
		    }
		}
	
		var renderSVG$1 = renderSVG;
	
		var TRANSFORM = "transform";
		var DefinitionMap = {
		    clip: "clip-path",
		    fill: "fill"
		};
	
		function isDefinition(type, value) {
		    return type === "clip" || (type === "fill" && (!value || value.nodeType === "Gradient"));
		}
	
		function baseUrl() {
		    var base = document.getElementsByTagName("base")[0];
		    var href = document.location.href;
		    var url = "";
	
		    if (base && !supportBrowser.msie) {
		        var hashIndex = href.indexOf("#");
		        if (hashIndex !== -1) {
		            href = href.substring(0, hashIndex);
		        }
	
		        url = href;
		    }
	
		    return url;
		}
	
		var Node = BaseNode.extend({
		    init: function(srcElement, options) {
		        BaseNode.fn.init.call(this, srcElement);
		        this.definitions = {};
	
		        this.options = options;
		    },
	
		    destroy: function() {
		        if (this.element) {
		            this.element._kendoNode = null;
		            this.element = null;
		        }
	
		        this.clearDefinitions();
		        BaseNode.fn.destroy.call(this);
		    },
	
		    load: function(elements, pos) {
		        var this$1 = this;
	
		        for (var i = 0; i < elements.length; i++) {
		            var srcElement = elements[i];
		            var children = srcElement.children;
	
		            var childNode = new NODE_MAP[srcElement.nodeType](srcElement, this$1.options);
	
		            if (defined(pos)) {
		                this$1.insertAt(childNode, pos);
		            } else {
		                this$1.append(childNode);
		            }
	
		            childNode.createDefinitions();
	
		            if (children && children.length > 0) {
		                childNode.load(children);
		            }
	
		            var element = this$1.element;
		            if (element) {
		                childNode.attachTo(element, pos);
		            }
		        }
		    },
	
		    root: function() {
		        var root = this;
	
		        while (root.parent) {
		            root = root.parent;
		        }
	
		        return root;
		    },
	
		    attachTo: function(domElement, pos) {
		        var container = document.createElement("div");
		        renderSVG$1(container,
		            "<svg xmlns='" + SVG_NS + "' version='1.1'>" +
		                this.render() +
		            "</svg>"
		        );
	
		        var element = container.firstChild.firstChild;
		        if (element) {
		            if (defined(pos)) {
		                domElement.insertBefore(element, domElement.childNodes[pos] || null);
		            } else {
		                domElement.appendChild(element);
		            }
		            this.setElement(element);
		        }
		    },
	
		    setElement: function(element) {
		        if (this.element) {
		            this.element._kendoNode = null;
		        }
	
		        this.element = element;
		        this.element._kendoNode = this;
	
		        var nodes = this.childNodes;
		        for (var i = 0; i < nodes.length; i++) {
		            var childElement = element.childNodes[i];
		            nodes[i].setElement(childElement);
		        }
		    },
	
		    clear: function() {
		        this.clearDefinitions();
	
		        if (this.element) {
		            this.element.innerHTML = "";
		        }
	
		        var children = this.childNodes;
		        for (var i = 0; i < children.length; i++) {
		            children[i].destroy();
		        }
	
		        this.childNodes = [];
		    },
	
		    removeSelf: function() {
		        if (this.element) {
		            var parentNode = this.element.parentNode;
		            if (parentNode) {
		                parentNode.removeChild(this.element);
		            }
		            this.element = null;
		        }
	
		        BaseNode.fn.removeSelf.call(this);
		    },
	
		    template: function() {
		        return this.renderChildren();
		    },
	
		    render: function() {
		        return this.template();
		    },
	
		    renderChildren: function() {
		        var nodes = this.childNodes;
		        var output = "";
	
		        for (var i = 0; i < nodes.length; i++) {
		            output += nodes[i].render();
		        }
	
		        return output;
		    },
	
		    optionsChange: function(e) {
		        var field = e.field;
		        var value = e.value;
	
		        if (field === "visible") {
		            this.css("display", value ? "" : NONE);
		        } else if (DefinitionMap[field] && isDefinition(field, value)) {
		            this.updateDefinition(field, value);
		        } else if (field === "opacity") {
		            this.attr("opacity", value);
		        } else if (field === "cursor") {
		            this.css("cursor", value);
		        } else if (field === "id") {
		            if (value) {
		                this.attr("id", value);
		            } else {
		                this.removeAttr("id");
		            }
		        }
	
		        BaseNode.fn.optionsChange.call(this, e);
		    },
	
		    attr: function(name, value) {
		        if (this.element) {
		            this.element.setAttribute(name, value);
		        }
		    },
	
		    allAttr: function(attrs) {
		        var this$1 = this;
	
		        for (var i = 0; i < attrs.length; i++) {
		            this$1.attr(attrs[i][0], attrs[i][1]);
		        }
		    },
	
		    css: function(name, value) {
		        if (this.element) {
		            this.element.style[name] = value;
		        }
		    },
	
		    allCss: function(styles) {
		        var this$1 = this;
	
		        for (var i = 0; i < styles.length; i++) {
		            this$1.css(styles[i][0], styles[i][1]);
		        }
		    },
	
		    removeAttr: function(name) {
		        if (this.element) {
		            this.element.removeAttribute(name);
		        }
		    },
	
		    mapTransform: function(transform) {
		        var attrs = [];
		        if (transform) {
		            attrs.push([
		                TRANSFORM,
		                "matrix(" + transform.matrix().toString(6) + ")"
		            ]);
		        }
	
		        return attrs;
		    },
	
		    renderTransform: function() {
		        return renderAllAttr(
		            this.mapTransform(this.srcElement.transform())
		        );
		    },
	
		    transformChange: function(value) {
		        if (value) {
		            this.allAttr(this.mapTransform(value));
		        } else {
		            this.removeAttr(TRANSFORM);
		        }
		    },
	
		    mapStyle: function() {
		        var options = this.srcElement.options;
		        var style = [ [ "cursor", options.cursor ] ];
	
		        if (options.visible === false) {
		            style.push([ "display", NONE ]);
		        }
	
		        return style;
		    },
	
		    renderStyle: function() {
		        return renderAttr("style", renderStyle(this.mapStyle(true)));
		    },
	
		    renderOpacity: function() {
		        return renderAttr("opacity", this.srcElement.options.opacity);
		    },
	
		    renderId: function() {
		        return renderAttr("id", this.srcElement.options.id);
		    },
	
		    createDefinitions: function() {
		        var srcElement = this.srcElement;
		        var definitions = this.definitions;
		        if (srcElement) {
		            var options = srcElement.options;
		            var hasDefinitions;
	
		            for (var field in DefinitionMap) {
		                var definition = options.get(field);
		                if (definition && isDefinition(field, definition)) {
		                    definitions[field] = definition;
		                    hasDefinitions = true;
		                }
		            }
		            if (hasDefinitions) {
		                this.definitionChange({
		                    action: "add",
		                    definitions: definitions
		                });
		            }
		        }
		    },
	
		    definitionChange: function(e) {
		        if (this.parent) {
		            this.parent.definitionChange(e);
		        }
		    },
	
		    updateDefinition: function(type, value) {
		        var definitions = this.definitions;
		        var current = definitions[type];
		        var attr = DefinitionMap[type];
		        var definition = {};
		        if (current) {
		            definition[type] = current;
		            this.definitionChange({
		                action: "remove",
		                definitions: definition
		            });
		            delete definitions[type];
		        }
	
		        if (!value) {
		            if (current) {
		                this.removeAttr(attr);
		            }
		        } else {
		            definition[type] = value;
		            this.definitionChange({
		                action: "add",
		                definitions: definition
		            });
		            definitions[type] = value;
		            this.attr(attr, this.refUrl(value.id));
		        }
		    },
	
		    clearDefinitions: function() {
		        var definitions = this.definitions;
	
		        this.definitionChange({
		            action: "remove",
		            definitions: definitions
		        });
		        this.definitions = {};
		    },
	
		    renderDefinitions: function() {
		        return renderAllAttr(this.mapDefinitions());
		    },
	
		    mapDefinitions: function() {
		        var this$1 = this;
	
		        var definitions = this.definitions;
		        var attrs = [];
	
		        for (var field in definitions) {
		            attrs.push([ DefinitionMap[field], this$1.refUrl(definitions[field].id) ]);
		        }
	
		        return attrs;
		    },
	
		    refUrl: function(id) {
		        var skipBaseHref = (this.options || {}).skipBaseHref;
		        var baseHref = this.baseUrl().replace(/'/g, "\\'");
		        var base = skipBaseHref ? '' : baseHref;
		        return ("url(" + base + "#" + id + ")");
		    },
	
		    baseUrl: function() {
		        return baseUrl();
		    }
		});
	
		var GradientStopNode = Node.extend({
		    template: function() {
		        return ("<stop " + (this.renderOffset()) + " " + (this.renderStyle()) + " />");
		    },
	
		    renderOffset: function() {
		        return renderAttr("offset", this.srcElement.offset());
		    },
	
		    mapStyle: function() {
		        var srcElement = this.srcElement;
		        return [
		            [ "stop-color", srcElement.color() ],
		            [ "stop-opacity", srcElement.opacity() ]
		        ];
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "offset") {
		            this.attr(e.field, e.value);
		        } else if (e.field === "color" || e.field === "opacity") {
		            this.css("stop-" + e.field, e.value);
		        }
		    }
		});
	
		var GradientNode = Node.extend({
		    init: function(srcElement) {
		        Node.fn.init.call(this, srcElement);
	
		        this.id = srcElement.id;
	
		        this.loadStops();
		    },
	
		    loadStops: function() {
		        var this$1 = this;
	
		        var stops = this.srcElement.stops;
		        var element = this.element;
	
		        for (var idx = 0; idx < stops.length; idx++) {
		            var stopNode = new GradientStopNode(stops[idx]);
		            this$1.append(stopNode);
		            if (element) {
		                stopNode.attachTo(element);
		            }
		        }
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "gradient.stops") {
		            BaseNode.prototype.clear.call(this);
		            this.loadStops();
		        } else if (e.field === "gradient") {
		            this.allAttr(this.mapCoordinates());
		        }
		    },
	
		    renderCoordinates: function() {
		        return renderAllAttr(this.mapCoordinates());
		    },
	
		    mapSpace: function() {
		        return [ "gradientUnits", this.srcElement.userSpace() ? "userSpaceOnUse" : "objectBoundingBox" ];
		    }
		});
	
		var LinearGradientNode = GradientNode.extend({
		    template: function() {
		        return ("<linearGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</linearGradient>");
		    },
	
		    mapCoordinates: function() {
		        var srcElement = this.srcElement;
		        var start = srcElement.start();
		        var end = srcElement.end();
		        var attrs = [
		            [ "x1", start.x ],
		            [ "y1", start.y ],
		            [ "x2", end.x ],
		            [ "y2", end.y ],
		            this.mapSpace()
		        ];
	
		        return attrs;
		    }
		});
	
		var RadialGradientNode = GradientNode.extend({
		    template: function() {
		        return ("<radialGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</radialGradient>");
		    },
	
		    mapCoordinates: function() {
		        var srcElement = this.srcElement;
		        var center = srcElement.center();
		        var radius = srcElement.radius();
		        var attrs = [
		            [ "cx", center.x ],
		            [ "cy", center.y ],
		            [ "r", radius ],
		            this.mapSpace()
		        ];
		        return attrs;
		    }
		});
	
		var ClipNode = Node.extend({
		    init: function(srcElement) {
		        Node.fn.init.call(this);
	
		        this.srcElement = srcElement;
		        this.id = srcElement.id;
	
		        this.load([ srcElement ]);
		    },
	
		    template: function() {
		        return ("<clipPath id='" + (this.id) + "'>" + (this.renderChildren()) + "</clipPath>");
		    }
		});
	
		var DefinitionNode = Node.extend({
		    init: function() {
		        Node.fn.init.call(this);
		        this.definitionMap = {};
		    },
	
		    attachTo: function(domElement) {
		        this.element = domElement;
		    },
	
		    template: function() {
		        return ("<defs>" + (this.renderChildren()) + "</defs>");
		    },
	
		    definitionChange: function(e) {
		        var definitions = e.definitions;
		        var action = e.action;
	
		        if (action === "add") {
		            this.addDefinitions(definitions);
		        } else if (action === "remove") {
		            this.removeDefinitions(definitions);
		        }
		    },
	
		    createDefinition: function(type, item) {
		        var nodeType;
		        if (type === "clip") {
		            nodeType = ClipNode;
		        } else if (type === "fill") {
		            if (item instanceof LinearGradient) {
		                nodeType = LinearGradientNode;
		            } else if (item instanceof RadialGradient) {
		                nodeType = RadialGradientNode;
		            }
		        }
		        return new nodeType(item);
		    },
	
		    addDefinitions: function(definitions) {
		        var this$1 = this;
	
		        for (var field in definitions) {
		            this$1.addDefinition(field, definitions[field]);
		        }
		    },
	
		    addDefinition: function(type, srcElement) {
		        var ref = this;
		        var element = ref.element;
		        var definitionMap = ref.definitionMap;
		        var id = srcElement.id;
		        var mapItem = definitionMap[id];
		        if (!mapItem) {
		            var node = this.createDefinition(type, srcElement);
		            definitionMap[id] = {
		                element: node,
		                count: 1
		            };
		            this.append(node);
		            if (element) {
		                node.attachTo(this.element);
		            }
		        } else {
		            mapItem.count++;
		        }
		    },
	
		    removeDefinitions: function(definitions) {
		        var this$1 = this;
	
		        for (var field in definitions) {
		            this$1.removeDefinition(definitions[field]);
		        }
		    },
	
		    removeDefinition: function(srcElement) {
		        var definitionMap = this.definitionMap;
		        var id = srcElement.id;
		        var mapItem = definitionMap[id];
	
		        if (mapItem) {
		            mapItem.count--;
		            if (mapItem.count === 0) {
		                this.remove(this.childNodes.indexOf(mapItem.element), 1);
		                delete definitionMap[id];
		            }
		        }
		    }
		});
	
		var RootNode = Node.extend({
		    init: function(options) {
		        Node.fn.init.call(this);
		        this.options = options;
		        this.defs = new DefinitionNode();
		    },
	
		    attachTo: function(domElement) {
		        this.element = domElement;
		        this.defs.attachTo(domElement.firstElementChild);
		    },
	
		    clear: function() {
		        BaseNode.prototype.clear.call(this);
		    },
	
		    template: function() {
		        return this.defs.render() + this.renderChildren();
		    },
	
		    definitionChange: function(e) {
		        this.defs.definitionChange(e);
		    }
		});
	
		var RTL = 'rtl';
	
		function alignToScreen(element) {
		    var ctm;
	
		    try {
		        ctm = element.getScreenCTM ? element.getScreenCTM() : null;
		    } catch (e) { } // eslint-disable-line no-empty
	
		    if (ctm) {
		        var left = - ctm.e % 1;
		        var top = - ctm.f % 1;
		        var style = element.style;
	
		        if (left !== 0 || top !== 0) {
		            style.left = left + "px";
		            style.top = top + "px";
		        }
		    }
		}
	
		var Surface$1 = Surface.extend({
		    init: function(element, options) {
		        Surface.fn.init.call(this, element, options);
	
		        this._root = new RootNode($.extend({
		            rtl: elementStyles(element, 'direction').direction === RTL
		        }, this.options));
	
		        renderSVG$1(this.element, this._template());
	
		        this._rootElement = this.element.firstElementChild;
	
		        alignToScreen(this._rootElement);
	
		        this._root.attachTo(this._rootElement);
	
		        bindEvents(this.element, {
		            click: this._click,
		            mouseover: this._mouseenter,
		            mouseout: this._mouseleave,
		            mousemove: this._mousemove
		        });
	
		        this.resize();
		    },
	
		    destroy: function() {
		        if (this._root) {
		            this._root.destroy();
		            this._root = null;
		            this._rootElement = null;
		            unbindEvents(this.element, {
		                click: this._click,
		                mouseover: this._mouseenter,
		                mouseout: this._mouseleave,
		                mousemove: this._mousemove
		            });
		        }
	
		        Surface.fn.destroy.call(this);
		    },
	
		    translate: function(offset) {
		        var viewBox = (Math.round(offset.x)) + " " + (Math.round(offset.y)) + " " + (this._size.width) + " " + (this._size.height);
	
		        this._offset = offset;
		        this._rootElement.setAttribute("viewBox", viewBox);
		    },
	
		    draw: function(element) {
		        Surface.fn.draw.call(this, element);
		        this._root.load([ element ]);
		    },
	
		    clear: function() {
		        Surface.fn.clear.call(this);
		        this._root.clear();
		    },
	
		    svg: function() {
		        return "<?xml version='1.0' ?>" + this._template();
		    },
	
		    exportVisual: function() {
		        var ref = this;
		        var visual = ref._visual;
		        var offset = ref._offset;
	
		        if (offset) {
		            var wrap = new Group();
		            wrap.children.push(visual);
	
		            wrap.transform(
		                transform().translate(-offset.x, -offset.y)
		            );
	
		            visual = wrap;
		        }
	
		        return visual;
		    },
	
		    _resize: function() {
		        if (this._offset) {
		            this.translate(this._offset);
		        }
		    },
	
		    _template: function() {
		        return ("<svg style='width: 100%; height: 100%; overflow: hidden;' xmlns='" + SVG_NS + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (this._root.render()) + "</svg>");
		    }
		});
	
		Surface$1.prototype.type = "svg";
	
		if (typeof document !== "undefined" && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")) {
		    Surface.support.svg = true;
		    SurfaceFactory.current.register("svg", Surface$1, 10);
		}
	
		var GroupNode = Node.extend({
		    template: function() {
		        return ("<g" + (this.renderId() + this.renderTransform() + this.renderStyle() + this.renderOpacity() + this.renderDefinitions()) + ">" + (this.renderChildren()) + "</g>");
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "transform") {
		            this.transformChange(e.value);
		        }
	
		        Node.fn.optionsChange.call(this, e);
		    }
		});
	
		NODE_MAP.Group = GroupNode;
	
		var DASH_ARRAYS = {
		    dot: [ 1.5, 3.5 ],
		    dash: [ 4, 3.5 ],
		    longdash: [ 8, 3.5 ],
		    dashdot: [ 3.5, 3.5, 1.5, 3.5 ],
		    longdashdot: [ 8, 3.5, 1.5, 3.5 ],
		    longdashdotdot: [ 8, 3.5, 1.5, 3.5, 1.5, 3.5 ]
		};
	
		var SOLID = "solid";
		var BUTT = "butt";
	
		var ATTRIBUTE_MAP = {
		    "fill.opacity": "fill-opacity",
		    "stroke.color": "stroke",
		    "stroke.width": "stroke-width",
		    "stroke.opacity": "stroke-opacity"
		};
		var SPACE = " ";
	
		var PathNode = Node.extend({
		    geometryChange: function() {
		        this.attr("d", this.renderData());
		        this.invalidate();
		    },
	
		    optionsChange: function(e) {
		        switch (e.field) {
		            case "fill":
		                if (e.value) {
		                    this.allAttr(this.mapFill(e.value));
		                } else {
		                    this.removeAttr("fill");
		                }
		                break;
	
		            case "fill.color":
		                this.allAttr(this.mapFill({ color: e.value }));
		                break;
	
		            case "stroke":
		                if (e.value) {
		                    this.allAttr(this.mapStroke(e.value));
		                } else {
		                    this.removeAttr("stroke");
		                }
		                break;
	
		            case "transform":
		                this.transformChange(e.value);
		                break;
	
		            default:
		                var name = ATTRIBUTE_MAP[e.field];
		                if (name) {
		                    this.attr(name, e.value);
		                }
		                break;
		        }
	
		        Node.fn.optionsChange.call(this, e);
		    },
	
		    content: function() {
		        if (this.element) {
		            this.element.textContent = this.srcElement.content();
		        }
		    },
	
		    renderData: function() {
		        return this.printPath(this.srcElement);
		    },
	
		    printPath: function(path) {
		        var this$1 = this;
	
		        var segments = path.segments;
		        var length = segments.length;
		        if (length > 0) {
		            var parts = [];
		            var output, currentType;
	
		            for (var i = 1; i < length; i++) {
		                var segmentType = this$1.segmentType(segments[i - 1], segments[i]);
		                if (segmentType !== currentType) {
		                    currentType = segmentType;
		                    parts.push(segmentType);
		                }
	
		                if (segmentType === "L") {
		                    parts.push(this$1.printPoints(segments[i].anchor()));
		                } else {
		                    parts.push(this$1.printPoints(segments[i - 1].controlOut(), segments[i].controlIn(), segments[i].anchor()));
		                }
		            }
	
		            output = "M" + this.printPoints(segments[0].anchor()) + SPACE + parts.join(SPACE);
		            if (path.options.closed) {
		                output += "Z";
		            }
	
		            return output;
		        }
		    },
	
		    printPoints: function() {
		        var points = arguments;
		        var length = points.length;
		        var result = [];
	
		        for (var i = 0; i < length; i++) {
		            result.push(points[i].toString(3));
		        }
	
		        return result.join(" ");
		    },
	
		    segmentType: function(segmentStart, segmentEnd) {
		        return segmentStart.controlOut() && segmentEnd.controlIn() ? "C" : "L";
		    },
	
		    mapStroke: function(stroke) {
		        var attrs = [];
	
		        if (stroke && !isTransparent(stroke.color)) {
		            attrs.push([ "stroke", stroke.color ]);
		            attrs.push([ "stroke-width", stroke.width ]);
		            attrs.push([ "stroke-linecap", this.renderLinecap(stroke) ]);
		            attrs.push([ "stroke-linejoin", stroke.lineJoin ]);
	
		            if (defined(stroke.opacity)) {
		                attrs.push([ "stroke-opacity", stroke.opacity ]);
		            }
	
		            if (defined(stroke.dashType)) {
		                attrs.push([ "stroke-dasharray", this.renderDashType(stroke) ]);
		            }
		        } else {
		            attrs.push([ "stroke", NONE ]);
		        }
	
		        return attrs;
		    },
	
		    renderStroke: function() {
		        return renderAllAttr(
		            this.mapStroke(this.srcElement.options.stroke)
		        );
		    },
	
		    renderDashType: function(stroke) {
		        var dashType = stroke.dashType;
		        var width = stroke.width; if (width === void 0) { width = 1; }
	
		        if (dashType && dashType !== SOLID) {
		            var dashArray = DASH_ARRAYS[dashType.toLowerCase()];
		            var result = [];
	
		            for (var i = 0; i < dashArray.length; i++) {
		                result.push(dashArray[i] * width);
		            }
	
		            return result.join(" ");
		        }
		    },
	
		    renderLinecap: function(stroke) {
		        var dashType = stroke.dashType;
		        var lineCap = stroke.lineCap;
	
		        return (dashType && dashType !== "solid") ? BUTT : lineCap;
		    },
	
		    mapFill: function(fill) {
		        var attrs = [];
		        if (!(fill && fill.nodeType === "Gradient")) {
		            if (fill && !isTransparent(fill.color)) {
		                attrs.push([ "fill", fill.color ]);
	
		                if (defined(fill.opacity)) {
		                    attrs.push([ "fill-opacity", fill.opacity ]);
		                }
		            } else {
		                attrs.push([ "fill", NONE ]);
		            }
		        }
	
		        return attrs;
		    },
	
		    renderFill: function() {
		        return renderAllAttr(
		            this.mapFill(this.srcElement.options.fill)
		        );
		    },
	
		    template: function() {
		        return "<path " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " " + (renderAttr('d', this.renderData())) +
		                    "" + (this.renderStroke()) + (this.renderFill()) + (this.renderDefinitions()) + (this.renderTransform()) + "></path>";
		    }
		});
	
		NODE_MAP.Path = PathNode;
	
		var ArcNode = PathNode.extend({
		    renderData: function() {
		        return this.printPath(this.srcElement.toPath());
		    }
		});
	
		NODE_MAP.Arc = ArcNode;
	
		var CircleNode = PathNode.extend({
		    geometryChange: function() {
		        var center = this.center();
		        this.attr("cx", center.x);
		        this.attr("cy", center.y);
		        this.attr("r", this.radius());
		        this.invalidate();
		    },
	
		    center: function() {
		        return this.srcElement.geometry().center;
		    },
	
		    radius: function() {
		        return this.srcElement.geometry().radius;
		    },
	
		    template: function() {
		        return "<circle " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
		                    "cx='" + (this.center().x) + "' cy='" + (this.center().y) + "' r='" + (this.radius()) + "'" +
		                    (this.renderStroke()) + " " + (this.renderFill()) + " " + (this.renderDefinitions()) +
		                    (this.renderTransform()) + " ></circle>";
		    }
		});
	
		NODE_MAP.Circle = CircleNode;
	
		var RectNode = PathNode.extend({
		    geometryChange: function() {
		        var geometry = this.srcElement.geometry();
		        this.attr("x", geometry.origin.x);
		        this.attr("y", geometry.origin.y);
		        this.attr("width", geometry.size.width);
		        this.attr("height", geometry.size.height);
		        this.invalidate();
		    },
	
		    size: function() {
		        return this.srcElement.geometry().size;
		    },
	
		    origin: function() {
		        return this.srcElement.geometry().origin;
		    },
	
		    template: function() {
		        return "<rect " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " x='" + (this.origin().x) + "' y='" + (this.origin().y) + "' " +
		                    "width='" + (this.size().width) + "' height='" + (this.size().height) + "' " + (this.renderStroke()) + " " +
		                    (this.renderFill()) + " " + (this.renderDefinitions()) + " " + (this.renderTransform()) + " />";
		    }
		});
	
		NODE_MAP.Rect = RectNode;
	
		var ImageNode = PathNode.extend({
		    geometryChange: function() {
		        this.allAttr(this.mapPosition());
		        this.invalidate();
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "src") {
		            this.allAttr(this.mapSource());
		        }
	
		        PathNode.fn.optionsChange.call(this, e);
		    },
	
		    mapPosition: function() {
		        var rect = this.srcElement.rect();
		        var tl = rect.topLeft();
	
		        return [
		            [ "x", tl.x ],
		            [ "y", tl.y ],
		            [ "width", rect.width() + "px" ],
		            [ "height", rect.height() + "px" ]
		        ];
		    },
	
		    renderPosition: function() {
		        return renderAllAttr(this.mapPosition());
		    },
	
		    mapSource: function(encode) {
		        var src = this.srcElement.src();
	
		        if (encode) {
		            src = kendo.htmlEncode(src);
		        }
	
		        return [ [ "xlink:href", src ] ];
		    },
	
		    renderSource: function() {
		        return renderAllAttr(this.mapSource(true));
		    },
	
		    template: function() {
		        return "<image preserveAspectRatio='none' " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderTransform()) + " " + (this.renderOpacity()) +
		               (this.renderPosition()) + " " + (this.renderSource()) + " " + (this.renderDefinitions()) + ">" +
		               "</image>";
		    }
		});
	
		NODE_MAP.Image = ImageNode;
	
		var ENTITY_REGEX = /&(?:[a-zA-Z]+|#\d+);/g;
	
		function decodeEntities(text) {
		    if (!text || typeof text !== "string" || !ENTITY_REGEX.test(text)) {
		        return text;
		    }
	
		    var element = decodeEntities._element;
		    ENTITY_REGEX.lastIndex = 0;
	
		    return text.replace(ENTITY_REGEX, function (match) {
		        element.innerHTML = match;
	
		        return element.textContent || element.innerText;
		    });
		}
	
		if (typeof document !== "undefined") {
		    decodeEntities._element = document.createElement("span");
		}
	
		var TextNode = PathNode.extend({
		    geometryChange: function() {
		        var pos = this.pos();
		        this.attr("x", pos.x);
		        this.attr("y", pos.y);
		        this.invalidate();
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "font") {
		            this.attr("style", renderStyle(this.mapStyle()));
		            this.geometryChange();
		        } else if (e.field === "content") {
		            PathNode.fn.content.call(this, this.srcElement.content());
		        }
	
		        PathNode.fn.optionsChange.call(this, e);
		    },
	
		    mapStyle: function(encode) {
		        var style = PathNode.fn.mapStyle.call(this, encode);
		        var font = this.srcElement.options.font;
	
		        if (encode) {
		            font = kendo.htmlEncode(font);
		        }
	
		        style.push([ "font", font ], [ "white-space", "pre" ]);
	
		        return style;
		    },
	
		    pos: function() {
		        var pos = this.srcElement.position();
		        var size = this.srcElement.measure();
		        return pos.clone().setY(pos.y + size.baseline);
		    },
	
		    renderContent: function() {
		        var content = this.srcElement.content();
		        content = decodeEntities(content);
		        content = kendo.htmlEncode(content);
	
		        return kendoUtil.normalizeText(content);
		    },
	
		    renderTextAnchor: function() {
		        var anchor;
	
		        if ((this.options || {}).rtl && !(supportBrowser.msie || supportBrowser.edge)) {
		            anchor = 'end';
		        }
	
		        return renderAttr("text-anchor", anchor);
		    },
	
		    template: function() {
		        return "<text " + (this.renderId()) + " " + (this.renderTextAnchor()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
		                    "x='" + (this.pos().x) + "' y='" + (this.pos().y) + "' " + (this.renderStroke()) + " " + (this.renderTransform()) + " " + (this.renderDefinitions()) +
		                    (this.renderFill()) + ">" + (this.renderContent()) + "</text>";
		    }
		});
	
		NODE_MAP.Text = TextNode;
	
		var MultiPathNode = PathNode.extend({
		    renderData: function() {
		        var this$1 = this;
	
		        var paths = this.srcElement.paths;
	
		        if (paths.length > 0) {
		            var result = [];
	
		            for (var i = 0; i < paths.length; i++) {
		                result.push(this$1.printPath(paths[i]));
		            }
	
		            return result.join(" ");
		        }
		    }
		});
	
		NODE_MAP.MultiPath = MultiPathNode;
	
		var geometry = {
			Circle: Circle$2,
			Arc: Arc$2,
			Rect: Rect,
			Point: Point,
			Segment: Segment,
			Matrix: Matrix,
			Size: Size,
			toMatrix: toMatrix,
			Transformation: Transformation,
			transform: transform
		};
	
		function exportGroup(group) {
		    var root = new RootNode({
		        skipBaseHref: true
		    });
		    var bbox = group.clippedBBox();
		    var rootGroup = group;
	
		    if (bbox) {
		        var origin = bbox.getOrigin();
		        var exportRoot = new Group();
		        exportRoot.transform(transform().translate(-origin.x, -origin.y));
		        exportRoot.children.push(group);
		        rootGroup = exportRoot;
		    }
	
		    root.load([ rootGroup ]);
	
		    var svg = "<?xml version='1.0' ?><svg xmlns='" + SVG_NS + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (root.render()) + "</svg>";
	
		    root.destroy();
	
		    return svg;
		}
	
		var svg = {
			Surface: Surface$1,
			RootNode: RootNode,
			Node: Node,
			GroupNode: GroupNode,
			ArcNode: ArcNode,
			CircleNode: CircleNode,
			RectNode: RectNode,
			ImageNode: ImageNode,
			TextNode: TextNode,
			PathNode: PathNode,
			MultiPathNode: MultiPathNode,
			DefinitionNode: DefinitionNode,
			ClipNode: ClipNode,
			GradientStopNode: GradientStopNode,
			LinearGradientNode: LinearGradientNode,
			RadialGradientNode: RadialGradientNode,
			exportGroup: exportGroup
		};
	
		var NODE_MAP$2 = {};
	
		function renderPath(ctx, path) {
		    var segments = path.segments;
	
		    if (segments.length === 0) {
		        return;
		    }
	
		    var segment = segments[0];
		    var anchor = segment.anchor();
		    ctx.moveTo(anchor.x, anchor.y);
	
		    for (var i = 1; i < segments.length; i++) {
		        segment = segments[i];
		        anchor = segment.anchor();
	
		        var prevSeg = segments[i - 1];
		        var prevOut = prevSeg.controlOut();
		        var controlIn = segment.controlIn();
	
		        if (prevOut && controlIn) {
		            ctx.bezierCurveTo(prevOut.x, prevOut.y,
		                              controlIn.x, controlIn.y,
		                              anchor.x, anchor.y);
		        } else {
		            ctx.lineTo(anchor.x, anchor.y);
		        }
		    }
	
		    if (path.options.closed) {
		        ctx.closePath();
		    }
		}
	
		var Node$2 = BaseNode.extend({
		    init: function(srcElement) {
		        BaseNode.fn.init.call(this, srcElement);
		        if (srcElement) {
		            this.initClip();
		        }
		    },
	
		    initClip: function() {
		        var clip = this.srcElement.clip();
		        if (clip) {
		            this.clip = clip;
		            clip.addObserver(this);
		        }
		    },
	
		    clear: function() {
		        if (this.srcElement) {
		            this.srcElement.removeObserver(this);
		        }
	
		        this.clearClip();
	
		        BaseNode.fn.clear.call(this);
		    },
	
		    clearClip: function() {
		        if (this.clip) {
		            this.clip.removeObserver(this);
		            delete this.clip;
		        }
		    },
	
		    setClip: function(ctx) {
		        if (this.clip) {
		            ctx.beginPath();
		            renderPath(ctx, this.clip);
		            ctx.clip();
		        }
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "clip") {
		            this.clearClip();
		            this.initClip();
		        }
	
		        BaseNode.fn.optionsChange.call(this, e);
		    },
	
		    setTransform: function(ctx) {
		        if (this.srcElement) {
		            var transform = this.srcElement.transform();
		            if (transform) {
		                ctx.transform.apply(ctx, transform.matrix().toArray(6));
		            }
		        }
		    },
	
		    loadElements: function(elements, pos, cors) {
		        var this$1 = this;
	
		        for (var i = 0; i < elements.length; i++) {
		            var srcElement = elements[i];
		            var children = srcElement.children;
	
		            var childNode = new NODE_MAP$2[srcElement.nodeType](srcElement, cors);
	
		            if (children && children.length > 0) {
		                childNode.load(children, pos, cors);
		            }
	
		            if (defined(pos)) {
		                this$1.insertAt(childNode, pos);
		            } else {
		                this$1.append(childNode);
		            }
		        }
		    },
	
		    load: function(elements, pos, cors) {
		        this.loadElements(elements, pos, cors);
	
		        this.invalidate();
		    },
	
		    setOpacity: function(ctx) {
		        if (this.srcElement) {
		            var opacity = this.srcElement.opacity();
		            if (defined(opacity)) {
		                this.globalAlpha(ctx, opacity);
		            }
		        }
		    },
	
		    globalAlpha: function(ctx, value) {
		        var opactity = value;
		        if (opactity && ctx.globalAlpha) {
		            opactity *= ctx.globalAlpha;
		        }
		        ctx.globalAlpha = opactity;
		    },
	
		    visible: function() {
		        var src = this.srcElement;
		        return !src || (src && src.options.visible !== false);
		    }
		});
	
		var GroupNode$2 = Node$2.extend({
		    renderTo: function(ctx) {
		        if (!this.visible()) {
		            return;
		        }
	
		        ctx.save();
	
		        this.setTransform(ctx);
		        this.setClip(ctx);
		        this.setOpacity(ctx);
	
		        var childNodes = this.childNodes;
		        for (var i = 0; i < childNodes.length; i++) {
		            var child = childNodes[i];
		            if (child.visible()) {
		                child.renderTo(ctx);
		            }
		        }
	
		        ctx.restore();
		    }
		});
	
		Traversable.extend(GroupNode$2.prototype, "childNodes");
	
		NODE_MAP$2.Group = GroupNode$2;
	
		var FRAME_DELAY = 1000 / 60;
	
		var RootNode$2 = GroupNode$2.extend({
		    init: function(canvas) {
		        GroupNode$2.fn.init.call(this);
	
		        this.canvas = canvas;
		        this.ctx = canvas.getContext("2d");
	
		        var invalidateHandler = this._invalidate.bind(this);
		        this.invalidate = kendo.throttle(function () {
		            kendo.animationFrame(invalidateHandler);
		        }, FRAME_DELAY);
		    },
	
		    destroy: function() {
		        GroupNode$2.fn.destroy.call(this);
		        this.canvas = null;
		        this.ctx = null;
		    },
	
		    load: function(elements, pos, cors) {
		        this.loadElements(elements, pos, cors);
		        this._invalidate();
		    },
	
		    _invalidate: function() {
		        if (!this.ctx) {
		            return;
		        }
		        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
		        this.renderTo(this.ctx);
		    }
		});
	
		Traversable.extend(RootNode$2.prototype, "childNodes");
	
		var QuadRoot = Class.extend({
		    init: function() {
	
		        this.shapes = [];
		    },
	
		    _add: function(shape, bbox) {
		        this.shapes.push({
		            bbox: bbox,
		            shape: shape
		        });
		        shape._quadNode = this;
		    },
	
		    pointShapes: function(point) {
		        var shapes = this.shapes;
		        var length = shapes.length;
		        var result = [];
		        for (var idx = 0; idx < length; idx++) {
		            if (shapes[idx].bbox.containsPoint(point)) {
		                result.push(shapes[idx].shape);
		            }
		        }
		        return result;
		    },
	
		    insert: function(shape, bbox) {
		        this._add(shape, bbox);
		    },
	
		    remove: function(shape) {
		        var shapes = this.shapes;
		        var length = shapes.length;
	
		        for (var idx = 0; idx < length; idx++) {
		            if (shapes[idx].shape === shape) {
		                shapes.splice(idx, 1);
		                break;
		            }
		        }
		    }
		});
	
		var QuadNode = QuadRoot.extend({
		    init: function(rect) {
		        QuadRoot.fn.init.call(this);
		        this.children = [];
		        this.rect = rect;
		    },
	
		    inBounds: function(rect) {
		        var nodeRect = this.rect;
		        var nodeBottomRight = nodeRect.bottomRight();
		        var bottomRight = rect.bottomRight();
		        var inBounds = nodeRect.origin.x <= rect.origin.x && nodeRect.origin.y <= rect.origin.y && bottomRight.x <= nodeBottomRight.x &&
		            bottomRight.y <= nodeBottomRight.y;
		        return inBounds;
		    },
	
		    pointShapes: function(point) {
		        var children = this.children;
		        var length = children.length;
		        var result = QuadRoot.fn.pointShapes.call(this, point);
		        for (var idx = 0; idx < length; idx++) {
		            append(result, children[idx].pointShapes(point));
		        }
		        return result;
		    },
	
		    insert: function(shape, bbox) {
		        var children = this.children;
		        var inserted = false;
	
		        if (this.inBounds(bbox)) {
		            if (this.shapes.length < 4) {
		                this._add(shape, bbox);
		            } else {
		                if (!children.length) {
		                    this._initChildren();
		                }
	
		                for (var idx = 0; idx < children.length; idx++) {
		                    if (children[idx].insert(shape, bbox)) {
		                        inserted = true;
		                        break;
		                    }
		                }
	
		                if (!inserted) {
		                    this._add(shape, bbox);
		                }
		            }
		            inserted = true;
		        }
	
		        return inserted;
		    },
	
		    _initChildren: function() {
		        var ref = this;
		        var rect = ref.rect;
		        var children = ref.children;
		        var center = rect.center();
		        var halfWidth = rect.width() / 2;
		        var halfHeight = rect.height() / 2;
	
		        children.push(
		            new QuadNode(new Rect([ rect.origin.x, rect.origin.y ], [ halfWidth, halfHeight ])),
		            new QuadNode(new Rect([ center.x, rect.origin.y ], [ halfWidth, halfHeight ])),
		            new QuadNode(new Rect([ rect.origin.x, center.y ], [ halfWidth, halfHeight ])),
		            new QuadNode(new Rect([ center.x, center.y ], [ halfWidth, halfHeight ]))
		        );
		    }
		});
	
		var ROOT_SIZE = 3000;
		var LEVEL_STEP = 10000;
		var MAX_LEVEL = 75;
	
		var ShapesQuadTree = Class.extend({
		    init: function() {
	
		        this.initRoots();
		    },
	
		    initRoots: function() {
		        this.rootMap = {};
		        this.root = new QuadRoot();
		        this.rootElements = [];
		    },
	
		    clear: function() {
		        var this$1 = this;
	
		        var rootElements = this.rootElements;
		        for (var idx = 0; idx < rootElements.length; idx++) {
		            this$1.remove(rootElements[idx]);
		        }
		        this.initRoots();
		    },
	
		    pointShape: function(point) {
		        var sectorRoot = ( this.rootMap[ Math.floor( point.x / ROOT_SIZE ) ] || {} )[ Math.floor( point.y / ROOT_SIZE ) ];
		        var result = this.root.pointShapes(point);
	
		        if (sectorRoot) {
		            result = result.concat(sectorRoot.pointShapes(point));
		        }
	
		        this.assignZindex(result);
	
		        result.sort(zIndexComparer);
		        for (var idx = 0; idx < result.length; idx++) {
		            if (result[idx].containsPoint(point)) {
		                return result[idx];
		            }
		        }
		    },
	
		    assignZindex: function(elements) {
		        var this$1 = this;
	
		        for (var idx = 0; idx < elements.length; idx++) {
		            var element = elements[idx];
		            var zIndex = 0;
		            var levelWeight = Math.pow(LEVEL_STEP, MAX_LEVEL);
		            var parents = [];
	
		            while (element) {
		                parents.push(element);
		                element = element.parent;
		            }
	
		            while (parents.length) {
		                element = parents.pop();
		                zIndex += ((element.parent ? element.parent.children : this$1.rootElements).indexOf(element) + 1) * levelWeight;
		                levelWeight /= LEVEL_STEP;
		            }
	
		            elements[idx]._zIndex = zIndex;
		        }
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "transform" || e.field === "stroke.width") {
		            this.bboxChange(e.element);
		        }
		    },
	
		    geometryChange: function(e) {
		        this.bboxChange(e.element);
		    },
	
		    bboxChange: function(element) {
		        var this$1 = this;
	
		        if (element.nodeType === "Group") {
		            for (var idx = 0; idx < element.children.length; idx++) {
		                this$1.bboxChange(element.children[idx]);
		            }
		        } else {
		            if (element._quadNode) {
		                element._quadNode.remove(element);
		            }
		            this._insertShape(element);
		        }
		    },
	
		    add: function(elements) {
		        var elementsArray = Array.isArray(elements) ? elements.slice(0) : [ elements ];
	
		        append(this.rootElements, elementsArray);
		        this._insert(elementsArray);
		    },
	
		    childrenChange: function(e) {
		        var this$1 = this;
	
		        if (e.action === "remove") {
		            for (var idx = 0; idx < e.items.length; idx++) {
		                this$1.remove(e.items[idx]);
		            }
		        } else {
		            this._insert(Array.prototype.slice.call(e.items, 0));
		        }
		    },
	
		    _insert: function(elements) {
		        var this$1 = this;
	
		        var element;
	
		        while (elements.length > 0) {
		            element = elements.pop();
		            element.addObserver(this$1);
		            if (element.nodeType === "Group") {
		                append(elements, element.children);
		            } else {
		                this$1._insertShape(element);
		            }
		        }
		    },
	
		    _insertShape: function(shape) {
		        var bbox = shape.bbox();
		        if (bbox) {
		            var sectors = this.getSectors(bbox);
		            var x = sectors[0][0];
		            var y = sectors[1][0];
	
		            if (this.inRoot(sectors)) {
		                this.root.insert(shape, bbox);
		            } else {
		                var rootMap = this.rootMap;
		                if (!rootMap[x]) {
		                    rootMap[x] = {};
		                }
	
		                if (!rootMap[x][y]) {
		                    rootMap[x][y] = new QuadNode(
		                        new Rect([ x * ROOT_SIZE, y * ROOT_SIZE ], [ ROOT_SIZE, ROOT_SIZE ])
		                    );
		                }
	
		                rootMap[x][y].insert(shape, bbox);
		            }
		        }
		    },
	
		    remove: function(element) {
		        var this$1 = this;
	
		        element.removeObserver(this);
	
		        if (element.nodeType === "Group") {
		            var children = element.children;
		            for (var idx = 0; idx < children.length; idx++) {
		                this$1.remove(children[idx]);
		            }
		        } else if (element._quadNode) {
		            element._quadNode.remove(element);
		            delete element._quadNode;
		        }
		    },
	
		    inRoot: function(sectors) {
		        return sectors[0].length > 1 || sectors[1].length > 1;
		    },
	
		    getSectors: function(rect) {
		        var bottomRight = rect.bottomRight();
		        var bottomX = Math.floor(bottomRight.x / ROOT_SIZE);
		        var bottomY = Math.floor(bottomRight.y / ROOT_SIZE);
		        var sectors = [ [], [] ];
		        for (var x = Math.floor(rect.origin.x / ROOT_SIZE); x <= bottomX; x++) {
		            sectors[0].push(x);
		        }
		        for (var y = Math.floor(rect.origin.y / ROOT_SIZE); y <= bottomY; y++) {
		            sectors[1].push(y);
		        }
		        return sectors;
		    }
		});
	
		function zIndexComparer(x1, x2) {
		    if (x1._zIndex < x2._zIndex) {
		        return 1;
		    }
		    if (x1._zIndex > x2._zIndex) {
		        return -1;
		    }
	
		    return 0;
		}
	
		var SurfaceCursor = Class.extend({
		    init: function(surface) {
		        surface.bind("mouseenter", this._mouseenter.bind(this));
		        surface.bind("mouseleave", this._mouseleave.bind(this));
	
		        this.element = surface.element;
		    },
	
		    clear: function() {
		        this._resetCursor();
		    },
	
		    destroy: function() {
		        this._resetCursor();
		        delete this.element;
		    },
	
		    _mouseenter: function(e) {
		        var cursor = this._shapeCursor(e);
	
		        if (!cursor) {
		            this._resetCursor();
		        } else {
		            if (!this._current) {
		                this._defaultCursor = this._getCursor();
		            }
	
		            this._setCursor(cursor);
		        }
		    },
	
		    _mouseleave: function() {
		        this._resetCursor();
		    },
	
		    _shapeCursor: function(e) {
		        var shape = e.element;
	
		        while (shape && !defined(shape.options.cursor)) {
		            shape = shape.parent;
		        }
	
		        if (shape) {
		            return shape.options.cursor;
		        }
		    },
	
		    _getCursor: function() {
		        if (this.element) {
		            return this.element.style.cursor;
		        }
		    },
	
		    _setCursor: function(cursor) {
		        if (this.element) {
		            this.element.style.cursor = cursor;
		            this._current = cursor;
		        }
		    },
	
		    _resetCursor: function() {
		        if (this._current) {
		            this._setCursor(this._defaultCursor || "");
		            delete this._current;
		        }
		    }
		});
	
		var Surface$3 = Surface.extend({
		    init: function(element, options) {
		        Surface.fn.init.call(this, element, options);
	
		        this.element.innerHTML = this._template(this);
	
		        var canvas = this.element.firstElementChild;
		        var size = elementSize(element);
	
		        canvas.width = size.width;
		        canvas.height = size.height;
	
		        this._rootElement = canvas;
	
		        this._root = new RootNode$2(canvas);
	
		        this._mouseTrackHandler = this._trackMouse.bind(this);
	
		        bindEvents(this.element, {
		            click: this._mouseTrackHandler,
		            mousemove: this._mouseTrackHandler
		        });
		    },
	
		    destroy: function() {
		        Surface.fn.destroy.call(this);
	
		        if (this._root) {
		            this._root.destroy();
		            this._root = null;
		        }
	
		        if (this._searchTree) {
		            this._searchTree.clear();
		            delete this._searchTree;
		        }
	
		        if (this._cursor) {
		            this._cursor.destroy();
		            delete this._cursor;
		        }
	
		        unbindEvents(this.element, {
		            click: this._mouseTrackHandler,
		            mousemove: this._mouseTrackHandler
		        });
		    },
	
		    draw: function(element) {
		        Surface.fn.draw.call(this, element);
		        this._root.load([ element ], undefined, this.options.cors);
	
		        if (this._searchTree) {
		            this._searchTree.add([ element ]);
		        }
		    },
	
		    clear: function() {
		        Surface.fn.clear.call(this);
		        this._root.clear();
	
		        if (this._searchTree) {
		            this._searchTree.clear();
		        }
	
		        if (this._cursor) {
		            this._cursor.clear();
		        }
		    },
	
		    eventTarget: function(e) {
		        if (this._searchTree) {
		            var point = this._surfacePoint(e);
		            var shape = this._searchTree.pointShape(point);
		            return shape;
		        }
		    },
	
		    image: function() {
		        var ref = this;
		        var root = ref._root;
		        var rootElement = ref._rootElement;
		        var loadingStates = [];
	
		        root.traverse(function (childNode) {
		            if (childNode.loading) {
		                loadingStates.push(childNode.loading);
		            }
		        });
	
		        var promise = createPromise();
		        var resolveDataURL = function () {
		            root._invalidate();
	
		            try {
		                var data = rootElement.toDataURL();
		                promise.resolve(data);
		            } catch (e) {
		                promise.reject(e);
		            }
		        };
	
		        promiseAll(loadingStates).then(resolveDataURL, resolveDataURL);
	
		        return promise;
		    },
	
		    suspendTracking: function() {
		        Surface.fn.suspendTracking.call(this);
		        if (this._searchTree) {
		            this._searchTree.clear();
		            delete this._searchTree;
		        }
		    },
	
		    resumeTracking: function() {
		        Surface.fn.resumeTracking.call(this);
		        if (!this._searchTree) {
		            this._searchTree = new ShapesQuadTree();
	
		            var childNodes = this._root.childNodes;
		            var rootElements = [];
		            for (var idx = 0; idx < childNodes.length; idx++) {
		                rootElements.push(childNodes[idx].srcElement);
		            }
		            this._searchTree.add(rootElements);
		        }
		    },
	
		    _resize: function() {
		        this._rootElement.width = this._size.width;
		        this._rootElement.height = this._size.height;
	
		        this._root.invalidate();
		    },
	
		    _template: function() {
		        return "<canvas style='width: 100%; height: 100%;'></canvas>";
		    },
	
		    _enableTracking: function() {
		        this._searchTree = new ShapesQuadTree();
		        this._cursor = new SurfaceCursor(this);
	
		        Surface.fn._enableTracking.call(this);
		    },
	
		    _trackMouse: function(e) {
		        if (this._suspendedTracking) {
		            return;
		        }
	
		        var shape = this.eventTarget(e);
	
		        if (e.type !== "click") {
		            var currentShape = this._currentShape;
		            if (currentShape && currentShape !== shape) {
		                this.trigger("mouseleave", {
		                    element: currentShape,
		                    originalEvent: e,
		                    type: "mouseleave"
		                });
		            }
	
		            if (shape && currentShape !== shape) {
		                this.trigger("mouseenter", {
		                    element: shape,
		                    originalEvent: e,
		                    type: "mouseenter"
		                });
		            }
	
		            this.trigger("mousemove", {
		                element: shape,
		                originalEvent: e,
		                type: "mousemove"
		            });
	
		            this._currentShape = shape;
		        } else if (shape) {
		            this.trigger("click", {
		                element: shape,
		                originalEvent: e,
		                type: "click"
		            });
		        }
		    }
		});
	
		Surface$3.prototype.type = "canvas";
	
		if (typeof document !== "undefined" && document.createElement("canvas").getContext) {
		    Surface.support.canvas = true;
		    SurfaceFactory.current.register("canvas", Surface$3, 20);
		}
	
		function addGradientStops(gradient, stops) {
		    for (var idx = 0; idx < stops.length; idx++) {
		        var stop = stops[idx];
		        var color = kendo.parseColor(stop.color());
	
		        color.a *= stop.opacity();
	
		        gradient.addColorStop(stop.offset(), color.toCssRgba());
		    }
		}
	
		var PathNode$2 = Node$2.extend({
		    renderTo: function(ctx) {
		        ctx.save();
	
		        this.setTransform(ctx);
		        this.setClip(ctx);
		        this.setOpacity(ctx);
	
		        ctx.beginPath();
	
		        this.renderPoints(ctx, this.srcElement);
	
		        this.setLineDash(ctx);
		        this.setLineCap(ctx);
		        this.setLineJoin(ctx);
	
		        this.setFill(ctx);
		        this.setStroke(ctx);
	
		        ctx.restore();
		    },
	
		    setFill: function(ctx) {
		        var fill = this.srcElement.options.fill;
		        var hasFill = false;
	
		        if (fill) {
		            if (fill.nodeType === "Gradient") {
		                this.setGradientFill(ctx, fill);
		                hasFill = true;
		            } else if (!isTransparent(fill.color)) {
		                ctx.fillStyle = fill.color;
	
		                ctx.save();
		                this.globalAlpha(ctx, fill.opacity);
		                ctx.fill();
		                ctx.restore();
	
		                hasFill = true;
		            }
		        }
	
		        return hasFill;
		    },
	
		    setGradientFill: function(ctx, fill) {
		        var bbox = this.srcElement.rawBBox();
		        var gradient;
	
		        if (fill instanceof LinearGradient) {
		            var start = fill.start();
		            var end = fill.end();
		            gradient = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
		        } else if (fill instanceof RadialGradient) {
		            var center = fill.center();
		            gradient = ctx.createRadialGradient(center.x, center.y, 0, center.x, center.y, fill.radius());
		        }
	
		        addGradientStops(gradient, fill.stops);
	
		        ctx.save();
	
		        if (!fill.userSpace()) {
		            ctx.transform(bbox.width(), 0, 0, bbox.height(), bbox.origin.x, bbox.origin.y);
		        }
		        ctx.fillStyle = gradient;
		        ctx.fill();
	
		        ctx.restore();
		    },
	
		    setStroke: function(ctx) {
		        var stroke = this.srcElement.options.stroke;
		        if (stroke && !isTransparent(stroke.color) && stroke.width > 0) {
		            ctx.strokeStyle = stroke.color;
		            ctx.lineWidth = valueOrDefault(stroke.width, 1);
	
		            ctx.save();
		            this.globalAlpha(ctx, stroke.opacity);
		            ctx.stroke();
		            ctx.restore();
	
		            return true;
		        }
		    },
	
		    dashType: function() {
		        var stroke = this.srcElement.options.stroke;
		        if (stroke && stroke.dashType) {
		            return stroke.dashType.toLowerCase();
		        }
		    },
	
		    setLineDash: function(ctx) {
		        var dashType = this.dashType();
		        if (dashType && dashType !== SOLID) {
		            var dashArray = DASH_ARRAYS[dashType];
		            if (ctx.setLineDash) {
		                ctx.setLineDash(dashArray);
		            } else {
		                ctx.mozDash = dashArray;
		                ctx.webkitLineDash = dashArray;
		            }
		        }
		    },
	
		    setLineCap: function(ctx) {
		        var dashType = this.dashType();
		        var stroke = this.srcElement.options.stroke;
		        if (dashType && dashType !== SOLID) {
		            ctx.lineCap = BUTT;
		        } else if (stroke && stroke.lineCap) {
		            ctx.lineCap = stroke.lineCap;
		        }
		    },
	
		    setLineJoin: function(ctx) {
		        var stroke = this.srcElement.options.stroke;
		        if (stroke && stroke.lineJoin) {
		            ctx.lineJoin = stroke.lineJoin;
		        }
		    },
	
		    renderPoints: function(ctx, path) {
		        renderPath(ctx, path);
		    }
		});
	
		NODE_MAP$2.Path = PathNode$2;
	
		var ArcNode$2 = PathNode$2.extend({
		    renderPoints: function(ctx) {
		        var path = this.srcElement.toPath();
		        renderPath(ctx, path);
		    }
		});
	
		NODE_MAP$2.Arc = ArcNode$2;
	
		var CircleNode$2 = PathNode$2.extend({
		    renderPoints: function(ctx) {
		        var ref = this.srcElement.geometry();
		        var center = ref.center;
		        var radius = ref.radius;
	
		        ctx.arc(center.x, center.y, radius, 0, Math.PI * 2);
		    }
		});
	
		NODE_MAP$2.Circle = CircleNode$2;
	
		var RectNode$2 = PathNode$2.extend({
		    renderPoints: function(ctx) {
		        var ref = this.srcElement.geometry();
		        var origin = ref.origin;
		        var size = ref.size;
	
		        ctx.rect(origin.x, origin.y, size.width, size.height);
		    }
		});
	
		NODE_MAP$2.Rect = RectNode$2;
	
		var ImageNode$2 = PathNode$2.extend({
		    init: function(srcElement, cors) {
		        PathNode$2.fn.init.call(this, srcElement);
	
		        this.onLoad = this.onLoad.bind(this);
		        this.onError = this.onError.bind(this);
	
		        this.loading = createPromise();
	
		        var img = this.img = new Image();
	
		        if (cors && !(/^data:/i.test(srcElement.src()))) {
		            img.crossOrigin = cors;
		        }
	
		        img.src = srcElement.src();
	
		        if (img.complete) {
		            this.onLoad();
		        } else {
		            img.onload = this.onLoad;
		            img.onerror = this.onError;
		        }
		    },
	
		    renderTo: function(ctx) {
		        if (this.loading.state() === "resolved") {
		            ctx.save();
	
		            this.setTransform(ctx);
		            this.setClip(ctx);
	
		            this.drawImage(ctx);
	
		            ctx.restore();
		        }
		    },
	
		    optionsChange: function(e) {
		        if (e.field === "src") {
		            this.loading = createPromise();
		            this.img.src = this.srcElement.src();
		        } else {
		            PathNode$2.fn.optionsChange.call(this, e);
		        }
		    },
	
		    onLoad: function() {
		        this.loading.resolve();
		        this.invalidate();
		    },
	
		    onError: function() {
		        this.loading.reject(new Error(
		            "Unable to load image '" + this.img.src +
		            "'. Check for connectivity and verify CORS headers."
		        ));
		    },
	
		    drawImage: function(ctx) {
		        var rect = this.srcElement.rect();
		        var topLeft = rect.topLeft();
	
		        ctx.drawImage(
		            this.img, topLeft.x, topLeft.y, rect.width(), rect.height()
		        );
		    }
		});
	
		NODE_MAP$2.Image = ImageNode$2;
	
		var TextNode$2 = PathNode$2.extend({
		    renderTo: function(ctx) {
		        var text = this.srcElement;
		        var pos = text.position();
		        var size = text.measure();
	
		        ctx.save();
	
		        this.setTransform(ctx);
		        this.setClip(ctx);
		        this.setOpacity(ctx);
	
		        ctx.beginPath();
	
		        ctx.font = text.options.font;
		        ctx.textAlign = 'left';
	
		        if (this.setFill(ctx)) {
		            ctx.fillText(text.content(), pos.x, pos.y + size.baseline);
		        }
	
		        if (this.setStroke(ctx)) {
		            this.setLineDash(ctx);
		            ctx.strokeText(text.content(), pos.x, pos.y + size.baseline);
		        }
	
		        ctx.restore();
		    }
		});
	
		NODE_MAP$2.Text = TextNode$2;
	
		var MultiPathNode$2 = PathNode$2.extend({
		    renderPoints: function(ctx) {
		        var paths = this.srcElement.paths;
		        for (var i = 0; i < paths.length; i++) {
		            renderPath(ctx, paths[i]);
		        }
		    }
		});
	
		NODE_MAP$2.MultiPath = MultiPathNode$2;
	
		var canvas = {
			Surface: Surface$3,
			RootNode: RootNode$2,
			Node: Node$2,
			GroupNode: GroupNode$2,
			ArcNode: ArcNode$2,
			CircleNode: CircleNode$2,
			RectNode: RectNode$2,
			ImageNode: ImageNode$2,
			TextNode: TextNode$2,
			PathNode: PathNode$2,
			MultiPathNode: MultiPathNode$2
		};
	
		function exportImage(group, options) {
		    var defaults = {
		        width: "800px", height: "600px",
		        cors: "Anonymous"
		    };
	
		    var exportRoot = group;
		    var bbox = group.clippedBBox();
	
		    if (bbox) {
		        var origin = bbox.getOrigin();
		        exportRoot = new Group();
		        exportRoot.transform(transform().translate(-origin.x, -origin.y));
		        exportRoot.children.push(group);
	
		        var size = bbox.getSize();
		        defaults.width = size.width + "px";
		        defaults.height = size.height + "px";
		    }
	
		    var surfaceOptions = $.extend(defaults, options);
	
		    var container = document.createElement("div");
		    var style = container.style;
	
		    style.display = "none";
		    style.width = surfaceOptions.width;
		    style.height = surfaceOptions.height;
		    document.body.appendChild(container);
	
		    var surface = new Surface$3(container, surfaceOptions);
		    surface.suspendTracking();
		    surface.draw(exportRoot);
	
		    var promise = surface.image();
		    var destroy = function () {
		        surface.destroy();
		        document.body.removeChild(container);
		    };
		    promise.then(destroy, destroy);
	
		    return promise;
		}
	
		function exportSVG(group, options) {
		    var svg = exportGroup(group);
	
		    if (!options || !options.raw) {
		        svg = "data:image/svg+xml;base64," + encodeBase64(svg);
		    }
	
		    return createPromise().resolve(svg);
		}
	
		/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
		/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
		/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty, yoda */
		/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
		var browser = supportBrowser;
		/*
	
		  XXX: to test:
	
		  - cloneNodes function:
		    - drawing document containing canvas with page breaking
		    - drawing document with named radio <input>-s (should not clear selection)
		    - IE9/IE10 don't support el.dataset; do they copy user data?
	
		  - repeating table headers/footers on page breaking
	
		  - forceBreak, keepTogether
	
		  - avoidLinks
	
		 */
	
		/* -----[ local vars ]----- */
	
		function slice$1(thing) {
		    return Array.prototype.slice.call(thing);
		}
	
		var KENDO_PSEUDO_ELEMENT = "KENDO-PSEUDO-ELEMENT";
	
		var IMAGE_CACHE = {};
	
		var nodeInfo = {};
		nodeInfo._root = nodeInfo;
	
		/* -----[ Custom Text node to speed up rendering in kendo.pdf ]----- */
	
		var inBrowser = typeof window !== 'undefined';
		var microsoft = inBrowser ? browser.msie || browser.edge : false;
	
		var TextRect = Text.extend({
		    init: function(str, rect, options) {
		        Text.fn.init.call(this, str, rect.getOrigin(), options);
		        this._pdfRect = rect;
		    },
	
		    rect: function() {
		        // this is the crux of it: we can avoid a call to
		        // measure(), which is what the base class does, since we
		        // already know the rect.  measure() is s-l-o-w.
		        return this._pdfRect;
		    },
	
		    rawBBox: function() {
		        // also let's avoid creating a new rectangle.
		        return this._pdfRect;
		    }
		});
	
		function addClass(el, cls) {
		    if (el.classList) {
		        el.classList.add(cls);
		    } else {
		        el.className += " " + cls;
		    }
		}
	
		function removeClass(el, cls) {
		    if (el.classList) {
		        el.classList.remove(cls);
		    } else {
		        el.className = el.className.split(/\s+/).reduce(function(a, word){
		            if (word != cls) {
		                a.push(word);
		            }
		            return a;
		        }, []).join(" ");
		    }
		}
	
		function setCSS(el, styles) {
		    Object.keys(styles).forEach(function(key){
		        el.style[key] = styles[key];
		    });
		}
	
		var matches = typeof Element !== "undefined" && Element.prototype && (function(p){
		    if (p.matches) {
		        return function(el, selector) { return el.matches(selector); };
		    }
		    if (p.webkitMatchesSelector) {
		        return function(el, selector) { return el.webkitMatchesSelector(selector); };
		    }
		    if (p.mozMatchesSelector) {
		        return function(el, selector) { return el.mozMatchesSelector(selector); };
		    }
		    if (p.msMatchesSelector) {
		        return function(el, selector) { return el.msMatchesSelector(selector); };
		    }
		    return function(s) {
			return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
		    };
		})(Element.prototype);
	
		function closest(el, selector) {
		    if (el.closest) {
		        return el.closest(selector);
		    }
		    // IE: stringifying rather than simply comparing with `document`,
		    // which is not iframe-proof and fails in editor export —
		    // https://github.com/telerik/kendo/issues/6721
		    while (el && !/^\[object (?:HTML)?Document\]$/.test(String(el))) {
		        if (el.nodeType == 1 /* Element */ && matches(el, selector)) {
		            return el;
		        }
		        el = el.parentNode;
		    }
		}
	
		// clone nodes ourselves, so that we redraw <canvas> (DOM or
		// jQuery clone will not)
		var cloneNodes = (function($){
		    if ($) {
		        // if we have Kendo and jQuery, use this version as it will
		        // maintain proper links between cloned element and Kendo
		        // widgets (i.e. it clones jQuery data(), which isn't the same
		        // as element's data attributes).
		        // https://github.com/telerik/kendo-ui-core/issues/2750
		        return function cloneNodes(el) {
		            var clone = el.cloneNode(false);
		            if (el.nodeType == 1 /* Element */) {
		                var $el = $(el), $clone = $(clone), i;
		                var data = $el.data();
		                for (i in data) {
		                    $clone.data(i, data[i]);
		                }
		                if (/^canvas$/i.test(el.tagName)) {
		                    clone.getContext("2d").drawImage(el, 0, 0);
		                } else if (/^(?:input|select|textarea|option)$/i.test(el.tagName)) {
		                    // drop the name attributes so that we don't affect the selection of the
		                    // original nodes (i.e. checked status of radio buttons) when we insert our copy
		                    // into the DOM.  https://github.com/telerik/kendo/issues/5409
		                    clone.removeAttribute("id");
		                    clone.removeAttribute("name");
		                    clone.value = el.value;
		                    clone.checked = el.checked;
		                    clone.selected = el.selected;
		                }
		                for (i = el.firstChild; i; i = i.nextSibling) {
		                    clone.appendChild(cloneNodes(i));
		                }
		            }
		            return clone;
		        };
		    } else {
		        // the no-jQuery version
		        return function cloneNodes(el) {
		            var clone = (function dive(node){
		                var clone = node.cloneNode(false);
		                if (node._kendoExportVisual) {
		                    clone._kendoExportVisual = node._kendoExportVisual;
		                }
		                for (var i = node.firstChild; i; i = i.nextSibling) {
		                    clone.appendChild(dive(i));
		                }
		                return clone;
		            })(el);
	
		            // re-draw canvases - https://github.com/telerik/kendo/issues/4872
		            var canvases = el.querySelectorAll("canvas");
		            if (canvases.length) {
		                slice$1(clone.querySelectorAll("canvas")).forEach(function (canvas$$1, i) {
		                    canvas$$1.getContext("2d").drawImage(canvases[i], 0, 0);
		                });
		            }
	
		            // remove "name" attributes from <input> elements -
		            // https://github.com/telerik/kendo/issues/5409
		            var orig = el.querySelectorAll("input, select, textarea, option");
		            slice$1(clone.querySelectorAll("input, select, textarea, option")).forEach(function (el, i) {
		                el.removeAttribute("id");
		                el.removeAttribute("name");
		                el.value = orig[i].value;
		                el.checked = orig[i].checked;
		                el.selected = orig[i].selected;
		            });
	
		            return clone;
		        };
		    }
		})(typeof window !== "undefined" && window.kendo && window.kendo.jQuery);
	
		function getXY(thing) {
		    if (typeof thing == "number") {
		        return { x: thing, y: thing };
		    }
		    if (Array.isArray(thing)) {
		        return { x: thing[0], y: thing[1] };
		    }
		    return { x: thing.x, y: thing.y };
		}
	
		function drawDOM(element, options) {
		    if (!options) {
		        options = {};
		    }
		    var promise = createPromise();
	
		    if (!element) {
		        return promise.reject("No element to export");
		    }
	
		    if (typeof window.getComputedStyle != "function") {
		        throw new Error("window.getComputedStyle is missing.  You are using an unsupported browser, or running in IE8 compatibility mode.  Drawing HTML is supported in Chrome, Firefox, Safari and IE9+.");
		    }
	
		    kendo.pdf.defineFont(getFontFaces(element.ownerDocument));
	
		    var scale = getXY(options.scale || 1);
	
		    function doOne(element) {
		        var group = new Group();
	
		        // translate to start of page
		        var pos = element.getBoundingClientRect();
		        setTransform(group, [
		            scale.x,
		            0,
		            0,
		            scale.y,
		            (-pos.left * scale.x),
		            (-pos.top * scale.y)
		        ]);
	
		        nodeInfo._clipbox = false;
		        nodeInfo._matrix = Matrix.unit();
		        nodeInfo._stackingContext = {
		            element: element,
		            group: group
		        };
	
		        if (options.avoidLinks === true) {
		            nodeInfo._avoidLinks = "a";
		        } else {
		            nodeInfo._avoidLinks = options.avoidLinks;
		        }
	
		        addClass(element, "k-pdf-export");
		        renderElement(element, group);
		        removeClass(element, "k-pdf-export");
	
		        return group;
		    }
	
		    cacheImages(element, function(){
		        var forceBreak = options && options.forcePageBreak;
		        var hasPaperSize = options && options.paperSize && options.paperSize != "auto";
		        var paperOptions = kendo.pdf.getPaperOptions(function(key, def){
		            if (key == "paperSize") {
		                // PDF.getPaperOptions croaks on "auto", just pass dummy A4 as we might
		                // still be interested in margins.
		                return hasPaperSize ? options[key] : "A4";
		            }
		            return key in options ? options[key] : def;
		        });
		        var pageWidth = hasPaperSize && paperOptions.paperSize[0];
		        var pageHeight = hasPaperSize && paperOptions.paperSize[1];
		        var margin = options.margin && paperOptions.margin;
		        var hasMargin = Boolean(margin);
		        if (forceBreak || pageHeight) {
		            if (!margin) {
		                margin = { left: 0, top: 0, right: 0, bottom: 0 };
		            }
	
		            // we want paper size and margin to be unaffected by
		            // scaling in the output, so we have to reverse-scale
		            // before our calculations begin.
		            if (pageWidth)  { pageWidth  /= scale.x; }
		            if (pageHeight) { pageHeight /= scale.y; }
		            margin.left   /= scale.x;
		            margin.right  /= scale.x;
		            margin.top    /= scale.y;
		            margin.bottom /= scale.y;
	
		            var group = new Group({
		                pdf: {
		                    multiPage     : true,
		                    paperSize     : hasPaperSize ? paperOptions.paperSize : "auto",
		                    _ignoreMargin : hasMargin // HACK!  see exportPDF in pdf/drawing.js
		                }
		            });
		            handlePageBreaks(
		                function(x) {
		                    if (options.progress) {
		                        var canceled = false, pageNum = 0;
		                        (function next(){
		                            if (pageNum < x.pages.length) {
		                                var page = doOne(x.pages[pageNum]);
		                                group.append(page);
		                                options.progress({
		                                    page: page,
		                                    pageNum: ++pageNum,
		                                    totalPages: x.pages.length,
		                                    cancel: function() {
		                                        canceled = true;
		                                    }
		                                });
		                                if (!canceled) {
		                                    setTimeout(next);
		                                } else {
		                                    // XXX: should we also fail() the deferred object?
		                                    x.container.parentNode.removeChild(x.container);
		                                }
		                            } else {
		                                x.container.parentNode.removeChild(x.container);
		                                promise.resolve(group);
		                            }
		                        })();
		                    } else {
		                        x.pages.forEach(function(page){
		                            group.append(doOne(page));
		                        });
		                        x.container.parentNode.removeChild(x.container);
		                        promise.resolve(group);
		                    }
		                },
		                element,
		                forceBreak,
		                pageWidth ? pageWidth - margin.left - margin.right : null,
		                pageHeight ? pageHeight - margin.top - margin.bottom : null,
		                margin,
		                options
		            );
		        } else {
		            promise.resolve(doOne(element));
		        }
		    });
	
		    function makeTemplate(template$$1) {
		        if (template$$1 != null) {
		            if (typeof template$$1 == "string") {
		                template$$1 = kendo.template(template$$1.replace(/^\s+|\s+$/g, ""));
		            }
		            if (typeof template$$1 == "function") {
		                return function(data) {
		                    var el = template$$1(data);
		                    if (el && typeof el == "string") {
		                        var div = document.createElement("div");
		                        div.innerHTML = el;
		                        el = div.firstElementChild;
		                    }
		                    return el;
		                };
		            }
		            // assumed DOM element
		            return function() {
		                return template$$1.cloneNode(true);
		            };
		        }
		    }
	
		    function handlePageBreaks(callback, element, forceBreak, pageWidth, pageHeight, margin, options) {
		        var template$$1 = makeTemplate(options.template);
		        var doc = element.ownerDocument;
		        var pages = [];
		        var copy = options._destructive ? element : cloneNodes(element);
		        var container = doc.createElement("KENDO-PDF-DOCUMENT");
		        var adjust = 0;
	
		        // make sure <tfoot> elements are at the end (Grid widget
		        // places TFOOT before TBODY, tricking our algorithm to
		        // insert a page break right after the header).
		        // https://github.com/telerik/kendo/issues/4699
		        slice$1(copy.querySelectorAll("tfoot")).forEach(function(tfoot){
		            tfoot.parentNode.appendChild(tfoot);
		        });
	
		        // remember the index of each LI from an ordered list.
		        // we'll use it to reconstruct the proper numbering.
		        slice$1(copy.querySelectorAll("ol")).forEach(function(ol){
		            slice$1(ol.children).forEach(function(li, index){
		                li.setAttribute("kendo-split-index", index);
		            });
		        });
	
		        setCSS(container, {
		            display   : "block",
		            position  : "absolute",
		            boxSizing : "content-box",
		            left      : "-10000px",
		            top       : "-10000px"
		        });
	
		        if (pageWidth) {
		            // subtle: if we don't set the width *and* margins here, the layout in this
		            // container will be different from the one in our final page elements, and we'll
		            // split at the wrong places.
		            setCSS(container, {
		                width        : pageWidth + "px",
		                paddingLeft  : margin.left + "px",
		                paddingRight : margin.right + "px"
		            });
	
		            // when the first element has a margin-top (i.e. a <h1>) the page will be
		            // inadvertently enlarged by that number (the browser will report the container's
		            // bounding box top to start at the element's top, rather than including its
		            // margin).  Adding overflow: hidden seems to fix it.
		            //
		            // to understand the difference, try the following snippets in your browser:
		            //
		            // 1. <div style="background: yellow">
		            //      <h1 style="margin: 3em">Foo</h1>
		            //    </div>
		            //
		            // 2. <div style="background: yellow; overflow: hidden">
		            //      <h1 style="margin: 3em">Foo</h1>
		            //    </div>
		            //
		            // this detail is not important when automatic page breaking is not requested, hence
		            // doing it only if pageWidth is defined.
		            setCSS(copy, { overflow: "hidden" });
		        }
	
		        element.parentNode.insertBefore(container, element);
		        container.appendChild(copy);
	
		        // we need the timeouts here, so that images dimensions are
		        // properly computed in DOM when we start our thing.
		        if (options.beforePageBreak) {
		            setTimeout(function(){
		                options.beforePageBreak(container, doPageBreak);
		            }, 15);
		        } else {
		            setTimeout(doPageBreak, 15);
		        }
	
		        function doPageBreak() {
		            if (forceBreak != "-" || pageHeight) {
		                splitElement(copy);
		            }
	
		            {
		                var page = makePage();
		                copy.parentNode.insertBefore(page, copy);
		                page.appendChild(copy);
		            }
	
		            if (template$$1) {
		                pages.forEach(function(page, i){
		                    var el = template$$1({
		                        element    : page,
		                        pageNum    : i + 1,
		                        totalPages : pages.length
		                    });
		                    if (el) {
		                        page.appendChild(el);
		                    }
		                });
		            }
	
		            cacheImages(pages, function() {
		                // Even though we already cached images, they simply won't be available
		                // immediately in the newly created DOM.  Previously we'd allow a 10ms timeout,
		                // but that's arbitrary and clearly not working in all cases
		                // (https://github.com/telerik/kendo/issues/5399), so this function will wait
		                // for their .complete attribute.
		                whenImagesAreActuallyLoaded(pages, function(){
		                    callback({ pages: pages, container: container });
		                });
		            });
		        }
	
		        function keepTogether(el) {
		            if (options.keepTogether && matches(el, options.keepTogether) && el.offsetHeight <= pageHeight - adjust) {
		                return true;
		            }
	
		            var tag = el.tagName;
		            if (/^h[1-6]$/i.test(tag) && el.offsetHeight >= pageHeight - adjust) {
		                return false;
		            }
	
		            return (el.getAttribute("data-kendo-chart") ||
		                    /^(?:img|tr|thead|th|tfoot|iframe|svg|object|canvas|input|textarea|select|video|h[1-6])/i.test(el.tagName));
		        }
	
		        function splitElement(element) {
		            if (element.tagName == "TABLE") {
		                setCSS(element, { tableLayout: "fixed" });
		            }
		            if (keepTogether(element)) {
		                return;
		            }
		            var style = getComputedStyle(element);
		            var bottomPadding = parseFloat(getPropertyValue(style, "padding-bottom"));
		            var bottomBorder = parseFloat(getPropertyValue(style, "border-bottom-width"));
		            var saveAdjust = adjust;
		            adjust += bottomPadding + bottomBorder;
		            var isFirst = true;
		            for (var el = element.firstChild; el; el = el.nextSibling) {
		                if (el.nodeType == 1 /* Element */) {
		                    isFirst = false;
		                    if (matches(el, forceBreak)) {
		                        breakAtElement(el);
		                        continue;
		                    }
		                    if (!pageHeight) {
		                        // we're in "manual breaks mode"
		                        splitElement(el);
		                        continue;
		                    }
		                    if (!/^(?:static|relative)$/.test(getPropertyValue(getComputedStyle(el), "position"))) {
		                        continue;
		                    }
		                    var fall = fallsOnMargin(el);
		                    if (fall == 1) {
		                        // element starts on next page, break before anyway.
		                        breakAtElement(el);
		                    }
		                    else if (fall) {
		                        // elements ends up on next page, or possibly doesn't fit on a page at
		                        // all.  break before it anyway if it's an <img> or <tr>, otherwise
		                        // attempt to split.
		                        if (keepTogether(el)) {
		                            breakAtElement(el);
		                        } else {
		                            splitElement(el);
		                        }
		                    }
		                    else {
		                        splitElement(el);
		                    }
		                }
		                else if (el.nodeType == 3 /* Text */ && pageHeight) {
		                    splitText(el, isFirst);
		                    isFirst = false;
		                }
		            }
		            adjust = saveAdjust;
		        }
	
		        function firstInParent(el) {
		            var p = el.parentNode, first = p.firstChild;
		            if (el === first) {
		                return true;
		            }
		            if (el === p.children[0]) {
		                if (first.nodeType == 7 /* comment */ ||
		                    first.nodeType == 8 /* processing instruction */) {
		                    return true;
		                }
		                if (first.nodeType == 3 /* text */) {
		                    // if whitespace only we can probably consider it's first
		                    return !/\S/.test(first.data);
		                }
		            }
		            return false;
		        }
	
		        function breakAtElement(el) {
		            if (el.nodeType == 1 && el !== copy && firstInParent(el)) {
		                return breakAtElement(el.parentNode);
		            }
		            var table, colgroup, thead, grid, gridHead;
		            table = closest(el, "table");
		            colgroup = table && table.querySelector("colgroup");
		            if (options.repeatHeaders) {
		                thead = table && table.querySelector("thead");
	
		                // If we break page in a Kendo Grid, repeat its header.  This ugly hack is
		                // necessary because a scrollable grid will keep the header in a separate
		                // <table> element from its content.
		                //
		                // XXX: This is likely to break as soon as the widget HTML is modified.
		                grid = closest(el, ".k-grid.k-widget");
		                if (grid && grid.querySelector(".k-auto-scrollable")) {
		                    gridHead = grid.querySelector(".k-grid-header");
		                }
		            }
		            var page = makePage();
		            var range = doc.createRange();
		            range.setStartBefore(copy);
		            range.setEndBefore(el);
		            page.appendChild(range.extractContents());
		            copy.parentNode.insertBefore(page, copy);
		            preventBulletOnListItem(el.parentNode);
		            if (table) {
		                table = closest(el, "table"); // that's the <table> on next page!
		                if (options.repeatHeaders && thead) {
		                    table.insertBefore(thead.cloneNode(true), table.firstChild);
		                }
		                if (colgroup) {
		                    table.insertBefore(colgroup.cloneNode(true), table.firstChild);
		                }
		            }
		            if (options.repeatHeaders && gridHead) {
		                grid = closest(el, ".k-grid.k-widget");
		                grid.insertBefore(gridHead.cloneNode(true), grid.firstChild);
		            }
		        }
	
		        function makePage() {
		            var page = doc.createElement("KENDO-PDF-PAGE");
		            setCSS(page, {
		                display  : "block",
		                boxSizing: "content-box",
		                width    : pageWidth ? (pageWidth + "px") : "auto",
		                padding  : (margin.top + "px " +
		                            margin.right + "px " +
		                            margin.bottom + "px " +
		                            margin.left + "px"),
	
		                // allow absolutely positioned elements to be relative to current page
		                position : "relative",
	
		                // without the following we might affect layout of subsequent pages
		                height   : pageHeight ? (pageHeight + "px") : "auto",
		                overflow : pageHeight || pageWidth ? "hidden" : "visible",
		                clear    : "both"
		            });
	
		            // debug
		            // $("<div>").css({
		            //     position  : "absolute",
		            //     left      : margin.left,
		            //     top       : margin.top,
		            //     width     : pageWidth,
		            //     height    : pageHeight,
		            //     boxSizing : "border-box",
		            //     background: "rgba(255, 255, 0, 0.5)"
		            //     //border    : "1px solid red"
		            // }).appendTo(page);
	
		            if (options && options.pageClassName) {
		                page.className = options.pageClassName;
		            }
		            pages.push(page);
		            return page;
		        }
	
		        function fallsOnMargin(thing) {
		            var box = thing.getBoundingClientRect();
		            if (box.width === 0 || box.height === 0) {
		                // I'd say an element with dimensions zero fits on current page.
		                return 0;
		            }
		            var top = copy.getBoundingClientRect().top;
		            var available = pageHeight - adjust;
		            return (box.height > available) ? 3
		                : (box.top - top > available) ? 1
		                : (box.bottom - top > available) ? 2
		                : 0;
		        }
	
		        function splitText(node, isFirst) {
		            if (!/\S/.test(node.data)) {
		                return;
		            }
	
		            var len = node.data.length;
		            var range = doc.createRange();
		            range.selectNodeContents(node);
		            var fall = fallsOnMargin(range);
		            if (!fall) {
		                return;     // the whole text fits on current page
		            }
	
		            var nextnode = node;
		            if (fall == 1) {
		                // starts on next page, break before anyway.
		                if (isFirst) {
		                    // avoid leaving an empty <p>, <li>, etc. on previous page.
		                    breakAtElement(node.parentNode);
		                } else {
		                    breakAtElement(node);
		                }
		            }
		            else {
		                (function findEOP(min, pos, max) {
		                    range.setEnd(node, pos);
		                    if (min == pos || pos == max) {
		                        return pos;
		                    }
		                    if (fallsOnMargin(range)) {
		                        return findEOP(min, (min + pos) >> 1, pos);
		                    } else {
		                        return findEOP(pos, (pos + max) >> 1, max);
		                    }
		                })(0, len >> 1, len);
	
		                if (!/\S/.test(range.toString()) && isFirst) {
		                    // avoid leaving an empty <p>, <li>, etc. on previous page.
		                    breakAtElement(node.parentNode);
		                } else {
		                    // This is only needed for IE, but it feels cleaner to do it anyway.  Without
		                    // it, IE will truncate a very long text (playground/pdf-long-text-2.html).
		                    nextnode = node.splitText(range.endOffset);
	
		                    var page = makePage();
		                    range.setStartBefore(copy);
		                    page.appendChild(range.extractContents());
		                    copy.parentNode.insertBefore(page, copy);
		                    preventBulletOnListItem(nextnode.parentNode);
		                }
		            }
	
		            splitText(nextnode);
		        }
	
		        function preventBulletOnListItem(el) {
		            // set a hint on continued LI elements, to tell the
		            // renderer not to draw the bullet again.
		            // https://github.com/telerik/kendo-ui-core/issues/2732
		            var li = closest(el, "li");
		            if (li) {
		                li.setAttribute("kendo-no-bullet", "1");
		                preventBulletOnListItem(li.parentNode);
		            }
		        }
		    }
	
		    return promise;
		}
	
		drawDOM.getFontFaces = getFontFaces;
	
		// This is needed for the Spreadsheet print functionality.  Since
		// there we only need to draw text, this cuts through the ceremony
		// of drawDOM/renderElement and renders the text node directly.
		drawDOM.drawText = function(element) {
		    var group = new Group();
		    nodeInfo._clipbox = false;
		    nodeInfo._matrix = Matrix.unit();
		    nodeInfo._stackingContext = {
		        element: element,
		        group: group
		    };
		    pushNodeInfo(element, getComputedStyle(element), group);
		    if (element.firstChild.nodeType == 3 /* Text */) {
		        // avoid the penalty of renderElement
		        renderText(element, element.firstChild, group);
		    } else {
		        _renderElement(element, group);
		    }
		    popNodeInfo();
		    return group;
		};
	
		var parseBackgroundImage = (function(){
		    var tok_linear_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?linear-gradient\s*)\(/;
		    //var tok_radial_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?radial-gradient\s*)\(/;
		    var tok_percent          = /^([-0-9.]+%)/;
		    var tok_length           = /^([-0-9.]+px)/;
		    var tok_keyword          = /^(left|right|top|bottom|to|center)\W/;
		    var tok_angle            = /^([-0-9.]+(deg|grad|rad|turn))/;
		    var tok_whitespace       = /^(\s+)/;
		    var tok_popen            = /^(\()/;
		    var tok_pclose           = /^(\))/;
		    var tok_comma            = /^(,)/;
		    var tok_url              = /^(url)\(/;
		    var tok_content          = /^(.*?)\)/;
	
		    var cache1 = {}, cache2 = {};
	
		    function parse(input) {
		        var orig = input;
		        if (hasOwnProperty(cache1, orig)) {
		            return cache1[orig];
		        }
		        function skip_ws() {
		            var m = tok_whitespace.exec(input);
		            if (m) {
		                input = input.substr(m[1].length);
		            }
		        }
		        function read(token) {
		            skip_ws();
		            var m = token.exec(input);
		            if (m) {
		                input = input.substr(m[1].length);
		                return m[1];
		            }
		        }
	
		        function read_stop() {
		            var color = kendo.parseColor(input, true);
		            var length, percent;
		            if (color) {
		                var match =
		                    /^#[0-9a-f]+/i.exec(input) ||
		                    /^rgba?\(.*?\)/i.exec(input) ||
		                    /^..*?\b/.exec(input); // maybe named color
		                input = input.substr(match[0].length);
		                color = color.toRGB();
		                if (!(length = read(tok_length))) {
		                    percent = read(tok_percent);
		                }
		                return { color: color, length: length, percent: percent };
		            }
		        }
	
		        function read_linear_gradient(propName) {
		            var angle;
		            var to1, to2;
		            var stops = [];
		            var reverse = false;
	
		            if (read(tok_popen)) {
		                // 1. [ <angle> || to <side-or-corner>, ]?
		                angle = read(tok_angle);
		                if (angle) {
		                    angle = parseAngle(angle);
		                    read(tok_comma);
		                }
		                else {
		                    to1 = read(tok_keyword);
		                    if (to1 == "to") {
		                        to1 = read(tok_keyword);
		                    } else if (to1 && /^-/.test(propName)) {
		                        reverse = true;
		                    }
		                    to2 = read(tok_keyword);
		                    read(tok_comma);
		                }
	
		                if (/-moz-/.test(propName) && angle == null && to1 == null) {
		                    var x = read(tok_percent), y = read(tok_percent);
		                    reverse = true;
		                    if (x == "0%") {
		                        to1 = "left";
		                    } else if (x == "100%") {
		                        to1 = "right";
		                    }
		                    if (y == "0%") {
		                        to2 = "top";
		                    } else if (y == "100%") {
		                        to2 = "bottom";
		                    }
		                    read(tok_comma);
		                }
	
		                // 2. color stops
		                while (input && !read(tok_pclose)) {
		                    var stop = read_stop();
		                    if (!stop) {
		                        break;
		                    }
		                    stops.push(stop);
		                    read(tok_comma);
		                }
	
		                return {
		                    type    : "linear",
		                    angle   : angle,
		                    to      : to1 && to2 ? to1 + " " + to2 : to1 ? to1 : to2 ? to2 : null,
		                    stops   : stops,
		                    reverse : reverse
		                };
		            }
		        }
	
		        function read_url() {
		            if (read(tok_popen)) {
		                var url = read(tok_content);
		                url = url.replace(/^['"]+|["']+$/g, "");
		                read(tok_pclose);
		                return { type: "url", url: url };
		            }
		        }
	
		        var tok;
	
		        if ((tok = read(tok_linear_gradient))) {
		            tok = read_linear_gradient(tok);
		        }
		        else if ((tok = read(tok_url))) {
		            tok = read_url();
		        }
	
		        return (cache1[orig] = tok || { type: "none" });
		    }
	
		    return function(input) {
		        if (hasOwnProperty(cache2, input)) {
		            return cache2[input];
		        }
		        return (cache2[input] = splitProperty(input).map(parse));
		    };
		})();
	
		var splitProperty = (function(){
		    var cache = {};
		    return function(input, separator) {
		        if (!separator) {
		            separator = /^\s*,\s*/;
		        }
	
		        var cacheKey = input + separator;
	
		        if (hasOwnProperty(cache, cacheKey)) {
		            return cache[cacheKey];
		        }
	
		        var ret = [];
		        var last$$1 = 0, pos = 0;
		        var in_paren = 0;
		        var in_string = false;
		        var m;
	
		        function looking_at(rx) {
		            return (m = rx.exec(input.substr(pos)));
		        }
	
		        function trim(str) {
		            return str.replace(/^\s+|\s+$/g, "");
		        }
	
		        while (pos < input.length) {
		            if (!in_string && looking_at(/^[\(\[\{]/)) {
		                in_paren++;
		                pos++;
		            }
		            else if (!in_string && looking_at(/^[\)\]\}]/)) {
		                in_paren--;
		                pos++;
		            }
		            else if (!in_string && looking_at(/^[\"\']/)) {
		                in_string = m[0];
		                pos++;
		            }
		            else if (in_string == "'" && looking_at(/^\\\'/)) {
		                pos += 2;
		            }
		            else if (in_string == '"' && looking_at(/^\\\"/)) {
		                pos += 2;
		            }
		            else if (in_string == "'" && looking_at(/^\'/)) {
		                in_string = false;
		                pos++;
		            }
		            else if (in_string == '"' && looking_at(/^\"/)) {
		                in_string = false;
		                pos++;
		            }
		            else if (looking_at(separator)) {
		                if (!in_string && !in_paren && pos > last$$1) {
		                    ret.push(trim(input.substring(last$$1, pos)));
		                    last$$1 = pos + m[0].length;
		                }
		                pos += m[0].length;
		            }
		            else {
		                pos++;
		            }
		        }
		        if (last$$1 < pos) {
		            ret.push(trim(input.substring(last$$1, pos)));
		        }
		        return (cache[cacheKey] = ret);
		    };
		})();
	
		var getFontURL = (function(cache){
		    return function(el){
		        // XXX: for IE we get here the whole cssText of the rule,
		        // because the computedStyle.src is empty.  Next time we need
		        // to fix these regexps we better write a CSS parser. :-\
		        var url = cache[el];
		        if (!url) {
		            var m;
		            if ((m = /url\((['"]?)([^'")]*?)\1\)\s+format\((['"]?)truetype\3\)/.exec(el))) {
		                url = cache[el] = m[2];
		            } else if ((m = /url\((['"]?)([^'")]*?\.ttf)\1\)/.exec(el))) {
		                url = cache[el] = m[2];
		            }
		        }
		        return url;
		    };
		})(Object.create ? Object.create(null) : {});
	
		var getFontHeight = (function(cache){
		    return function(font) {
		        var height = cache[font];
		        if (height == null) {
		            height = cache[font] = kendoUtil.measureText("Mapq", { font: font }).height;
		        }
		        return height;
		    };
		})(Object.create ? Object.create(null) : {});
	
		function getFontFaces(doc) {
		    if (doc == null) {
		        doc = document;
		    }
		    var result = {};
		    for (var i = 0; i < doc.styleSheets.length; ++i) {
		        doStylesheet(doc.styleSheets[i]);
		    }
		    return result;
		    function doStylesheet(ss) {
		        if (ss) {
		            var rules = null;
		            try {
		                rules = ss.cssRules;
		            } catch (ex) {}
		            if (rules) {
		                addRules(ss, rules);
		            }
		        }
		    }
		    function findFonts(rule) {
		        var src = getPropertyValue(rule.style, "src");
		        if (src) {
		            return splitProperty(src).reduce(function(a, el){
		                var font = getFontURL(el);
		                if (font) {
		                    a.push(font);
		                }
		                return a;
		            }, []);
		        } else {
		            // Internet Explorer
		            // XXX: this is gross.  should work though for valid CSS.
		            var font = getFontURL(rule.cssText);
		            return font ? [ font ] : [];
		        }
		    }
		    function addRules(styleSheet, rules) {
		        for (var i = 0; i < rules.length; ++i) {
		            var r = rules[i];
		            switch (r.type) {
		              case 3:       // CSSImportRule
		                doStylesheet(r.styleSheet);
		                break;
		              case 5:       // CSSFontFaceRule
		                var style  = r.style;
		                var family = splitProperty(getPropertyValue(style, "font-family"));
		                var bold   = /^([56789]00|bold)$/i.test(getPropertyValue(style, "font-weight"));
		                var italic = "italic" == getPropertyValue(style, "font-style");
		                var src    = findFonts(r);
		                if (src.length > 0) {
		                    addRule(styleSheet, family, bold, italic, src[0]);
		                }
		            }
		        }
		    }
		    function addRule(styleSheet, names, bold, italic, url) {
		        // We get full resolved absolute URLs in Chrome, but sadly
		        // not in Firefox.
		        if (!(/^data:/i.test(url))) {
		            if (!(/^[^\/:]+:\/\//.test(url) || /^\//.test(url))) {
		                url = String(styleSheet.href).replace(/[^\/]*$/, "") + url;
		            }
		        }
		        names.forEach(function(name){
		            name = name.replace(/^(['"]?)(.*?)\1$/, "$2"); // it's quoted
		            if (bold) {
		                name += "|bold";
		            }
		            if (italic) {
		                name += "|italic";
		            }
		            result[name] = url;
		        });
		    }
		}
	
		function hasOwnProperty(obj, key) {
		    return Object.prototype.hasOwnProperty.call(obj, key);
		}
	
		function getCounter(name) {
		    name = "_counter_" + name;
		    return nodeInfo[name];
		}
	
		function getAllCounters(name) {
		    var values = [], p = nodeInfo;
		    name = "_counter_" + name;
		    while (p) {
		        if (hasOwnProperty(p, name)) {
		            values.push(p[name]);
		        }
		        p = Object.getPrototypeOf(p);
		    }
		    return values.reverse();
		}
	
		function incCounter(name, inc) {
		    var p = nodeInfo;
		    name = "_counter_" + name;
		    while (p && !hasOwnProperty(p, name)) {
		        p = Object.getPrototypeOf(p);
		    }
		    if (!p) {
		        p = nodeInfo._root;
		    }
		    p[name] = (p[name] || 0) + (inc == null ? 1 : inc);
		}
	
		function resetCounter(name, val) {
		    name = "_counter_" + name;
		    nodeInfo[name] = val == null ? 0 : val;
		}
	
		function doCounters(a, f, def) {
		    for (var i = 0; i < a.length;) {
		        var name = a[i++];
		        var val = parseFloat(a[i]);
		        if (isNaN(val)) {
		            f(name, def);
		        } else {
		            f(name, val);
		            ++i;
		        }
		    }
		}
	
		function updateCounters(style) {
		    var counterReset = getPropertyValue(style, "counter-reset");
		    if (counterReset) {
		        doCounters(splitProperty(counterReset, /^\s+/), resetCounter, 0);
		    }
		    var counterIncrement = getPropertyValue(style, "counter-increment");
		    if (counterIncrement) {
		        doCounters(splitProperty(counterIncrement, /^\s+/), incCounter, 1);
		    }
		}
	
		function parseColor$1(str, css) {
		    var color = kendo.parseColor(str, true);
		    if (color) {
		        color = color.toRGB();
		        if (css) {
		            color = color.toCssRgba();
		        } else if (color.a === 0) {
		            color = null;
		        }
		    }
		    return color;
		}
	
		function whenImagesAreActuallyLoaded(elements, callback) {
		    var pending = 0;
		    elements.forEach(function(el){
		        var images = el.querySelectorAll("img");
		        for (var i = 0; i < images.length; ++i) {
		            var img = images[i];
		            if (!img.complete) {
		                pending++;
		                img.onload = img.onerror = next;
		            }
		        }
		    });
		    if (!pending) {
		        next();
		    }
		    function next() {
		        if (--pending <= 0) {
		            callback();
		        }
		    }
		}
	
		function cacheImages(element, callback) {
		    var urls = [];
		    function add(url) {
		        if (!IMAGE_CACHE[url]) {
		            IMAGE_CACHE[url] = true;
		            urls.push(url);
		        }
		    }
		    function dive(element){
		        if (/^img$/i.test(element.tagName)) {
		            add(element.src);
		        }
		        parseBackgroundImage(
		            getPropertyValue(
		                getComputedStyle(element), "background-image"
		            )
		        ).forEach(function(bg){
		            if (bg.type == "url") {
		                add(bg.url);
		            }
		        });
	
		        if (element.children) {
		            slice$1(element.children).forEach(dive);
		        }
		    }
	
		    if (Array.isArray(element)) {
		        element.forEach(dive);
		    } else {
		        dive(element);
		    }
	
		    var count = urls.length;
		    function next() {
		        if (--count <= 0) {
		            callback();
		        }
		    }
		    if (count === 0) {
		        next();
		    }
		    urls.forEach(function(url){
		        var img = IMAGE_CACHE[url] = new window.Image();
		        if (!(/^data:/i.test(url))) {
		            img.crossOrigin = "Anonymous";
		        }
		        img.src = url;
		        if (img.complete) {
		            next();
		        } else {
		            img.onload = next;
		            img.onerror = function() {
		                IMAGE_CACHE[url] = null;
		                next();
		            };
		        }
		    });
		}
	
		function alphaNumeral(n) {
		    var result = "";
		    do {
		        var r = n % 26;
		        result = String.fromCharCode(97 + r) + result;
		        n = Math.floor(n / 26);
		    } while (n > 0);
		    return result;
		}
	
		function pushNodeInfo(element, style, group) {
		    nodeInfo = Object.create(nodeInfo);
		    nodeInfo[element.tagName.toLowerCase()] = {
		        element: element,
		        style: style
		    };
		    var decoration = getPropertyValue(style, "text-decoration");
		    if (decoration && decoration != "none") {
		        var color = getPropertyValue(style, "color");
		        decoration.split(/\s+/g).forEach(function(name){
		            if (!nodeInfo[name]) {
		                nodeInfo[name] = color;
		            }
		        });
		    }
	
		    if (createsStackingContext(style)) {
		        nodeInfo._stackingContext = {
		            element: element,
		            group: group
		        };
		    }
		}
	
		function popNodeInfo() {
		    nodeInfo = Object.getPrototypeOf(nodeInfo);
		}
	
		function updateClipbox(path) {
		    if (nodeInfo._clipbox != null) {
		        var box = path.bbox(nodeInfo._matrix);
		        if (nodeInfo._clipbox) {
		            nodeInfo._clipbox = Rect.intersect(nodeInfo._clipbox, box);
		        } else {
		            nodeInfo._clipbox = box;
		        }
		    }
		}
	
		function emptyClipbox() {
		    var cb = nodeInfo._clipbox;
		    if (cb == null) {
		        return true;
		    }
		    if (cb) {
		        return cb.width() === 0 || cb.height() === 0;
		    }
		}
	
		function createsStackingContext(style) {
		    function prop(name) { return getPropertyValue(style, name); }
		    if (prop("transform") != "none" ||
		        prop("position") != "static" ||
		        prop("z-index") != "auto" ||
		        prop("opacity") < 1) {
		        return true;
		    }
		}
	
		function getComputedStyle(element, pseudoElt) {
		    return window.getComputedStyle(element, pseudoElt || null);
		}
	
		function getPropertyValue(style, prop, defa) {
		    var val = style.getPropertyValue(prop);
		    if (val == null || val === "") {
		        if (browser.webkit) {
		            val = style.getPropertyValue("-webkit-" + prop );
		        } else if (browser.mozilla) {
		            val = style.getPropertyValue("-moz-" + prop );
		        } else if (browser.opera) {
		            val = style.getPropertyValue("-o-" + prop);
		        } else if (microsoft) {
		            val = style.getPropertyValue("-ms-" + prop);
		        }
		    }
		    if (arguments.length > 2 && (val == null || val === "")) {
		        return defa;
		    } else {
		        return val;
		    }
		}
	
		function pleaseSetPropertyValue(style, prop, value, important) {
		    style.setProperty(prop, value, important);
		    if (browser.webkit) {
		        style.setProperty("-webkit-" + prop, value, important);
		    } else if (browser.mozilla) {
		        style.setProperty("-moz-" + prop, value, important);
		    } else if (browser.opera) {
		        style.setProperty("-o-" + prop, value, important);
		    } else if (microsoft) {
		        style.setProperty("-ms-" + prop, value, important);
		        prop = "ms" + prop.replace(/(^|-)([a-z])/g, function(s, p1, p2){
		            return p1 + p2.toUpperCase();
		        });
		        style[prop] = value;
		    }
		}
	
		function getBorder(style, side) {
		    side = "border-" + side;
		    return {
		        width: parseFloat(getPropertyValue(style, side + "-width")),
		        style: getPropertyValue(style, side + "-style"),
		        color: parseColor$1(getPropertyValue(style, side + "-color"), true)
		    };
		}
	
		function saveStyle(element, func) {
		    var prev = element.style.cssText;
		    var result = func();
		    element.style.cssText = prev;
		    return result;
		}
	
		function getBorderRadius(style, side) {
		    var r = getPropertyValue(style, "border-" + side + "-radius").split(/\s+/g).map(parseFloat);
		    if (r.length == 1) {
		        r.push(r[0]);
		    }
		    return sanitizeRadius({ x: r[0], y: r[1] });
		}
	
		function getContentBox(element) {
		    var box = element.getBoundingClientRect();
		    box = innerBox(box, "border-*-width", element);
		    box = innerBox(box, "padding-*", element);
		    return box;
		}
	
		function innerBox(box, prop, element) {
		    var style, wt, wr, wb, wl;
		    if (typeof prop == "string") {
		        style = getComputedStyle(element);
		        wt = parseFloat(getPropertyValue(style, prop.replace("*", "top")));
		        wr = parseFloat(getPropertyValue(style, prop.replace("*", "right")));
		        wb = parseFloat(getPropertyValue(style, prop.replace("*", "bottom")));
		        wl = parseFloat(getPropertyValue(style, prop.replace("*", "left")));
		    }
		    else if (typeof prop == "number") {
		        wt = wr = wb = wl = prop;
		    }
		    return {
		        top    : box.top + wt,
		        right  : box.right - wr,
		        bottom : box.bottom - wb,
		        left   : box.left + wl,
		        width  : box.right - box.left - wr - wl,
		        height : box.bottom - box.top - wb - wt
		    };
		}
	
		function getTransform(style) {
		    var transform$$1 = getPropertyValue(style, "transform");
		    if (transform$$1 == "none") {
		        return null;
		    }
		    var matrix = /^\s*matrix\(\s*(.*?)\s*\)\s*$/.exec(transform$$1);
		    if (matrix) {
		        var origin = getPropertyValue(style, "transform-origin");
		        matrix = matrix[1].split(/\s*,\s*/g).map(parseFloat);
		        origin = origin.split(/\s+/g).map(parseFloat);
		        return {
		            matrix: matrix,
		            origin: origin
		        };
		    }
		}
	
		function radiansToDegrees(radians) {
		    return ((180 * radians) / Math.PI) % 360;
		}
	
		function parseAngle(angle) {
		    var num = parseFloat(angle);
		    if (/grad$/.test(angle)) {
		        return Math.PI * num / 200;
		    }
		    else if (/rad$/.test(angle)) {
		        return num;
		    }
		    else if (/turn$/.test(angle)) {
		        return Math.PI * num * 2;
		    }
		    else if (/deg$/.test(angle)) {
		        return Math.PI * num / 180;
		    }
		}
	
		function setTransform(shape, m) {
		    m = new Matrix(m[0], m[1], m[2], m[3], m[4], m[5]);
		    shape.transform(m);
		    return m;
		}
	
		function setClipping(shape, clipPath) {
		    shape.clip(clipPath);
		}
	
		function addArcToPath(path, x, y, options) {
		    var points = new Arc$2([ x, y ], options).curvePoints(), i = 1;
		    while (i < points.length) {
		        path.curveTo(points[i++], points[i++], points[i++]);
		    }
		}
	
		function sanitizeRadius(r) {
		    if (r.x <= 0 || r.y <= 0) {
		        r.x = r.y = 0;
		    }
		    return r;
		}
	
		function adjustBorderRadiusForBox(box, rTL, rTR, rBR, rBL) {
		    // adjust border radiuses such that the sum of adjacent
		    // radiuses is not bigger than the length of the side.
		    // seems the correct algorithm is variant (3) from here:
		    // http://www.w3.org/Style/CSS/Tracker/issues/29?changelog
		    var tl_x = Math.max(0, rTL.x), tl_y = Math.max(0, rTL.y);
		    var tr_x = Math.max(0, rTR.x), tr_y = Math.max(0, rTR.y);
		    var br_x = Math.max(0, rBR.x), br_y = Math.max(0, rBR.y);
		    var bl_x = Math.max(0, rBL.x), bl_y = Math.max(0, rBL.y);
	
		    var f = Math.min(
		        box.width / (tl_x + tr_x),
		        box.height / (tr_y + br_y),
		        box.width / (br_x + bl_x),
		        box.height / (bl_y + tl_y)
		    );
	
		    if (f < 1) {
		        tl_x *= f; tl_y *= f;
		        tr_x *= f; tr_y *= f;
		        br_x *= f; br_y *= f;
		        bl_x *= f; bl_y *= f;
		    }
	
		    return {
		        tl: { x: tl_x, y: tl_y },
		        tr: { x: tr_x, y: tr_y },
		        br: { x: br_x, y: br_y },
		        bl: { x: bl_x, y: bl_y }
		    };
		}
	
		function elementRoundBox(element, box, type) {
		    var style = getComputedStyle(element);
	
		    var rTL = getBorderRadius(style, "top-left");
		    var rTR = getBorderRadius(style, "top-right");
		    var rBL = getBorderRadius(style, "bottom-left");
		    var rBR = getBorderRadius(style, "bottom-right");
	
		    if (type == "padding" || type == "content") {
		        var bt = getBorder(style, "top");
		        var br = getBorder(style, "right");
		        var bb = getBorder(style, "bottom");
		        var bl = getBorder(style, "left");
		        rTL.x -= bl.width; rTL.y -= bt.width;
		        rTR.x -= br.width; rTR.y -= bt.width;
		        rBR.x -= br.width; rBR.y -= bb.width;
		        rBL.x -= bl.width; rBL.y -= bb.width;
		        if (type == "content") {
		            var pt = parseFloat(getPropertyValue(style, "padding-top"));
		            var pr = parseFloat(getPropertyValue(style, "padding-right"));
		            var pb = parseFloat(getPropertyValue(style, "padding-bottom"));
		            var pl = parseFloat(getPropertyValue(style, "padding-left"));
		            rTL.x -= pl; rTL.y -= pt;
		            rTR.x -= pr; rTR.y -= pt;
		            rBR.x -= pr; rBR.y -= pb;
		            rBL.x -= pl; rBL.y -= pb;
		        }
		    }
	
		    if (typeof type == "number") {
		        rTL.x -= type; rTL.y -= type;
		        rTR.x -= type; rTR.y -= type;
		        rBR.x -= type; rBR.y -= type;
		        rBL.x -= type; rBL.y -= type;
		    }
	
		    return roundBox(box, rTL, rTR, rBR, rBL);
		}
	
		// Create a drawing.Path for a rounded rectangle.  Receives the
		// bounding box and the border-radiuses in CSS order (top-left,
		// top-right, bottom-right, bottom-left).  The radiuses must be
		// objects containing x (horiz. radius) and y (vertical radius).
		function roundBox(box, rTL0, rTR0, rBR0, rBL0) {
		    var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
		    var rTL = tmp.tl;
		    var rTR = tmp.tr;
		    var rBR = tmp.br;
		    var rBL = tmp.bl;
		    var path = new Path({ fill: null, stroke: null });
		    path.moveTo(box.left, box.top + rTL.y);
		    if (rTL.x) {
		        addArcToPath(path, box.left + rTL.x, box.top + rTL.y, {
		            startAngle: -180,
		            endAngle: -90,
		            radiusX: rTL.x,
		            radiusY: rTL.y
		        });
		    }
		    path.lineTo(box.right - rTR.x, box.top);
		    if (rTR.x) {
		        addArcToPath(path, box.right - rTR.x, box.top + rTR.y, {
		            startAngle: -90,
		            endAngle: 0,
		            radiusX: rTR.x,
		            radiusY: rTR.y
		        });
		    }
		    path.lineTo(box.right, box.bottom - rBR.y);
		    if (rBR.x) {
		        addArcToPath(path, box.right - rBR.x, box.bottom - rBR.y, {
		            startAngle: 0,
		            endAngle: 90,
		            radiusX: rBR.x,
		            radiusY: rBR.y
		        });
		    }
		    path.lineTo(box.left + rBL.x, box.bottom);
		    if (rBL.x) {
		        addArcToPath(path, box.left + rBL.x, box.bottom - rBL.y, {
		            startAngle: 90,
		            endAngle: 180,
		            radiusX: rBL.x,
		            radiusY: rBL.y
		        });
		    }
		    return path.close();
		}
	
		function formatCounter(val, style) {
		    var str = String(parseFloat(val));
		    switch (style) {
		      case "decimal-leading-zero":
		        if (str.length < 2) {
		            str = "0" + str;
		        }
		        return str;
		      case "lower-roman":
		        return arabicToRoman(val).toLowerCase();
		      case "upper-roman":
		        return arabicToRoman(val).toUpperCase();
		      case "lower-latin":
		      case "lower-alpha":
		        return alphaNumeral(val - 1);
		      case "upper-latin":
		      case "upper-alpha":
		        return alphaNumeral(val - 1).toUpperCase();
		      default:
		        return str;
		    }
		}
	
		function evalPseudoElementContent(element, content) {
		    function displayCounter(name, style, separator) {
		        if (!separator) {
		            return formatCounter(getCounter(name) || 0, style);
		        }
		        separator = separator.replace(/^\s*(["'])(.*)\1\s*$/, "$2");
		        return getAllCounters(name).map(function(val){
		            return formatCounter(val, style);
		        }).join(separator);
		    }
		    var a = splitProperty(content, /^\s+/);
		    var result = [], m;
		    a.forEach(function(el){
		        var tmp;
		        if ((m = /^\s*(["'])(.*)\1\s*$/.exec(el))) {
		            result.push(m[2].replace(/\\([0-9a-f]{4})/gi, function(s, p){
		                return String.fromCharCode(parseInt(p, 16));
		            }));
		        }
		        else if ((m = /^\s*counter\((.*?)\)\s*$/.exec(el))) {
		            tmp = splitProperty(m[1]);
		            result.push(displayCounter(tmp[0], tmp[1]));
		        }
		        else if ((m = /^\s*counters\((.*?)\)\s*$/.exec(el))) {
		            tmp = splitProperty(m[1]);
		            result.push(displayCounter(tmp[0], tmp[2], tmp[1]));
		        }
		        else if ((m = /^\s*attr\((.*?)\)\s*$/.exec(el))) {
		            result.push(element.getAttribute(m[1]) || "");
		        }
		        else {
		            result.push(el);
		        }
		    });
		    return result.join("");
		}
	
		function getCssText(style) {
		    if (style.cssText) {
		        return style.cssText;
		    }
		    // Status: NEW.  Report year: 2002.  Current year: 2014.
		    // Nice played, Mozillians.
		    // https://bugzilla.mozilla.org/show_bug.cgi?id=137687
		    var result = [];
		    for (var i = 0; i < style.length; ++i) {
		        result.push(style[i] + ": " + getPropertyValue(style, style[i]));
		    }
		    return result.join(";\n");
		}
	
		function _renderWithPseudoElements(element, group) {
		    if (element.tagName == KENDO_PSEUDO_ELEMENT) {
		        _renderElement(element, group);
		        return;
		    }
		    var fake = [];
		    function pseudo(kind, place) {
		        var style = getComputedStyle(element, kind), content = style.content;
		        updateCounters(style);
		        if (content && content != "normal" && content != "none" && style.width != "0px") {
		            var psel = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
		            psel.style.cssText = getCssText(style);
		            psel.textContent = evalPseudoElementContent(element, content);
		            element.insertBefore(psel, place);
		            fake.push(psel);
		        }
		    }
		    pseudo(":before", element.firstChild);
		    pseudo(":after", null);
		    if (fake.length > 0) {
		        var saveClass = element.className;
		        element.className += " kendo-pdf-hide-pseudo-elements";
		        _renderElement(element, group);
		        element.className = saveClass;
		        fake.forEach(function(el){ element.removeChild(el); });
		    } else {
		        _renderElement(element, group);
		    }
		}
	
		function _renderElement(element, group) {
		    var style = getComputedStyle(element);
	
		    var top = getBorder(style, "top");
		    var right = getBorder(style, "right");
		    var bottom = getBorder(style, "bottom");
		    var left = getBorder(style, "left");
	
		    var rTL0 = getBorderRadius(style, "top-left");
		    var rTR0 = getBorderRadius(style, "top-right");
		    var rBL0 = getBorderRadius(style, "bottom-left");
		    var rBR0 = getBorderRadius(style, "bottom-right");
	
		    var dir = getPropertyValue(style, "direction");
	
		    var backgroundColor = getPropertyValue(style, "background-color");
		    backgroundColor = parseColor$1(backgroundColor);
	
		    var backgroundImage = parseBackgroundImage( getPropertyValue(style, "background-image") );
		    var backgroundRepeat = splitProperty( getPropertyValue(style, "background-repeat") );
		    var backgroundPosition = splitProperty( getPropertyValue(style, "background-position") );
		    var backgroundOrigin = splitProperty( getPropertyValue(style, "background-origin") );
		    var backgroundSize = splitProperty( getPropertyValue(style, "background-size") );
	
		    if (browser.msie && browser.version < 10) {
		        // IE9 hacks.  getPropertyValue won't return the correct
		        // value.  Sucks that we have to do it here, I'd prefer to
		        // move it in getPropertyValue, but we don't have the
		        // element.
		        backgroundPosition = splitProperty(element.currentStyle.backgroundPosition);
		    }
	
		    var innerbox = innerBox(element.getBoundingClientRect(), "border-*-width", element);
	
		    // CSS "clip" property - if present, replace the group with a
		    // new one which is clipped.  This must happen before drawing
		    // the borders and background.
		    (function(){
		        var clip = getPropertyValue(style, "clip");
		        var m = /^\s*rect\((.*)\)\s*$/.exec(clip);
		        if (m) {
		            var a = m[1].split(/[ ,]+/g);
		            var top = a[0] == "auto" ? innerbox.top : parseFloat(a[0]) + innerbox.top;
		            var right = a[1] == "auto" ? innerbox.right : parseFloat(a[1]) + innerbox.left;
		            var bottom = a[2] == "auto" ? innerbox.bottom : parseFloat(a[2]) + innerbox.top;
		            var left = a[3] == "auto" ? innerbox.left : parseFloat(a[3]) + innerbox.left;
		            var tmp = new Group();
		            var clipPath = new Path()
		                .moveTo(left, top)
		                .lineTo(right, top)
		                .lineTo(right, bottom)
		                .lineTo(left, bottom)
		                .close();
		            setClipping(tmp, clipPath);
		            group.append(tmp);
		            group = tmp;
		            updateClipbox(clipPath);
		        }
		    })();
	
		    var boxes, i, cells;
		    var display = getPropertyValue(style, "display");
	
		    if (display == "table-row") {
		        // because of rowspan/colspan, we shouldn't draw background of table row elements on the
		        // box given by its getBoundingClientRect, because if we do we risk overwritting a
		        // previously rendered cell.  https://github.com/telerik/kendo/issues/4881
		        boxes = [];
		        for (i = 0, cells = element.children; i < cells.length; ++i) {
		            boxes.push(cells[i].getBoundingClientRect());
		        }
		    } else {
		        boxes = element.getClientRects();
		        if (boxes.length == 1) {
		            // Workaround the missing borders in Chrome!  getClientRects() boxes contains values
		            // rounded to integer.  getBoundingClientRect() appears to work fine.  We still need
		            // getClientRects() to support cases where there are more boxes (continued inline
		            // elements that might have border/background).
		            boxes = [ element.getBoundingClientRect() ];
		        }
		    }
	
		    // This function workarounds another Chrome bug, where boxes returned for a table with
		    // border-collapse: collapse will overlap the table border.  Our rendering is not perfect in
		    // such case anyway, but with this is better than without it.
		    boxes = adjustBoxes(boxes);
	
		    for (i = 0; i < boxes.length; ++i) {
		        drawOneBox(boxes[i], i === 0, i == boxes.length - 1);
		    }
	
		    // Render links as separate groups.  We can't use boxes returned by element's getClientRects
		    // because if display type is "inline" (default for <a>), boxes will not include the height of
		    // images inside.  https://github.com/telerik/kendo-ui-core/issues/3359
		    if (element.tagName == "A" && element.href && !/^#?$/.test(element.getAttribute("href"))) {
		        if (!nodeInfo._avoidLinks || !matches(element, nodeInfo._avoidLinks)) {
		            var r = document.createRange();
		            r.selectNodeContents(element);
		            slice$1(r.getClientRects()).forEach(function(box){
		                var g = new Group();
		                g._pdfLink = {
		                    url    : element.href,
		                    top    : box.top,
		                    right  : box.right,
		                    bottom : box.bottom,
		                    left   : box.left
		                };
		                group.append(g);
		            });
		        }
		    }
	
		    if (boxes.length > 0 && display == "list-item" && !element.getAttribute("kendo-no-bullet")) {
		        drawBullet(boxes[0]);
		    }
	
		    // overflow: hidden/auto - if present, replace the group with
		    // a new one clipped by the inner box.
		    (function(){
		        function clipit() {
		            var clipPath = elementRoundBox(element, innerbox, "padding");
		            var tmp = new Group();
		            setClipping(tmp, clipPath);
		            group.append(tmp);
		            group = tmp;
		            updateClipbox(clipPath);
		        }
		        if (isFormField(element)) {
		            clipit();
		        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow"))) {
		            clipit();
		        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-x"))) {
		            clipit();
		        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-y"))) {
		            clipit();
		        }
		    })();
	
		    if (!maybeRenderWidget(element, group)) {
		        renderContents(element, group);
		    }
	
		    return group; // only utility functions after this line.
	
		    function adjustBoxes(boxes) {
		        if (/^td$/i.test(element.tagName)) {
		            var table = nodeInfo.table;
		            if (table && getPropertyValue(table.style, "border-collapse") == "collapse") {
		                var tableBorderLeft = getBorder(table.style, "left").width;
		                var tableBorderTop = getBorder(table.style, "top").width;
		                // check if we need to adjust
		                if (tableBorderLeft === 0 && tableBorderTop === 0) {
		                    return boxes; // nope
		                }
		                var tableBox = table.element.getBoundingClientRect();
		                var firstCell = table.element.rows[0].cells[0];
		                var firstCellBox = firstCell.getBoundingClientRect();
		                if (firstCellBox.top == tableBox.top || firstCellBox.left == tableBox.left) {
		                    return slice$1(boxes).map(function(box){
		                        return {
		                            left   : box.left + tableBorderLeft,
		                            top    : box.top + tableBorderTop,
		                            right  : box.right + tableBorderLeft,
		                            bottom : box.bottom + tableBorderTop,
		                            height : box.height,
		                            width  : box.width
		                        };
		                    });
		                }
		            }
		        }
		        return boxes;
		    }
	
		    // this function will be called to draw each border.  it
		    // draws starting at origin and the resulted path must be
		    // translated/rotated to be placed in the proper position.
		    //
		    // arguments are named as if it draws the top border:
		    //
		    //    - `len` the length of the edge
		    //    - `Wtop` the width of the edge (i.e. border-top-width)
		    //    - `Wleft` the width of the left edge (border-left-width)
		    //    - `Wright` the width of the right edge
		    //    - `rl` and `rl` -- the border radius on the left and right
		    //      (objects containing x and y, for horiz/vertical radius)
		    //    - `transform` -- transformation to apply
		    //
		    function drawEdge(color, len, Wtop, Wleft, Wright, rl, rr, transform$$1) {
		        if (Wtop <= 0) {
		            return;
		        }
	
		        var path, edge = new Group();
		        setTransform(edge, transform$$1);
		        group.append(edge);
	
		        sanitizeRadius(rl);
		        sanitizeRadius(rr);
	
		        // draw main border.  this is the area without the rounded corners
		        path = new Path({
		            fill: { color: color },
		            stroke: null
		        });
		        edge.append(path);
		        path.moveTo(rl.x ? Math.max(rl.x, Wleft) : 0, 0)
		            .lineTo(len - (rr.x ? Math.max(rr.x, Wright) : 0), 0)
		            .lineTo(len - Math.max(rr.x, Wright), Wtop)
		            .lineTo(Math.max(rl.x, Wleft), Wtop)
		            .close();
	
		        if (rl.x) {
		            drawRoundCorner(Wleft, rl, [ -1, 0, 0, 1, rl.x, 0 ]);
		        }
	
		        if (rr.x) {
		            drawRoundCorner(Wright, rr, [ 1, 0, 0, 1, len - rr.x, 0 ]);
		        }
	
		        // draws one round corner, starting at origin (needs to be
		        // translated/rotated to be placed properly).
		        function drawRoundCorner(Wright, r, transform$$1) {
		            var angle = Math.PI/2 * Wright / (Wright + Wtop);
	
		            // not sanitizing this one, because negative values
		            // are useful to fill the box correctly.
		            var ri = {
		                x: r.x - Wright,
		                y: r.y - Wtop
		            };
	
		            var path = new Path({
		                fill: { color: color },
		                stroke: null
		            }).moveTo(0, 0);
	
		            setTransform(path, transform$$1);
	
		            addArcToPath(path, 0, r.y, {
		                startAngle: -90,
		                endAngle: -radiansToDegrees(angle),
		                radiusX: r.x,
		                radiusY: r.y
		            });
	
		            if (ri.x > 0 && ri.y > 0) {
		                path.lineTo(ri.x * Math.cos(angle), r.y - ri.y * Math.sin(angle));
		                addArcToPath(path, 0, r.y, {
		                    startAngle: -radiansToDegrees(angle),
		                    endAngle: -90,
		                    radiusX: ri.x,
		                    radiusY: ri.y,
		                    anticlockwise: true
		                });
		            }
		            else if (ri.x > 0) {
		                path.lineTo(ri.x, Wtop)
		                    .lineTo(0, Wtop);
		            }
		            else {
		                path.lineTo(ri.x, Wtop)
		                    .lineTo(ri.x, 0);
		            }
	
		            edge.append(path.close());
		        }
		    }
	
		    function drawBackground(box) {
		        var background = new Group();
		        setClipping(background, roundBox(box, rTL0, rTR0, rBR0, rBL0));
		        group.append(background);
	
		        if (backgroundColor) {
		            var path = new Path({
		                fill: { color: backgroundColor.toCssRgba() },
		                stroke: null
		            });
		            path.moveTo(box.left, box.top)
		                .lineTo(box.right, box.top)
		                .lineTo(box.right, box.bottom)
		                .lineTo(box.left, box.bottom)
		                .close();
		            background.append(path);
		        }
	
		        for (var i = backgroundImage.length; --i >= 0;) {
		            drawOneBackground(
		                background, box,
		                backgroundImage[i],
		                backgroundRepeat[i % backgroundRepeat.length],
		                backgroundPosition[i % backgroundPosition.length],
		                backgroundOrigin[i % backgroundOrigin.length],
		                backgroundSize[i % backgroundSize.length]
		            );
		        }
		    }
	
		    function drawOneBackground(group, box, background, backgroundRepeat, backgroundPosition, backgroundOrigin, backgroundSize) {
		        if (!background || (background == "none")) {
		            return;
		        }
	
		        if (background.type == "url") {
		            // SVG taints the canvas, can't draw it.
		            if (/^url\(\"data:image\/svg/i.test(background.url)) {
		                return;
		            }
		            var img = IMAGE_CACHE[background.url];
		            if (img && img.width > 0 && img.height > 0) {
		                drawBackgroundImage(group, box, img.width, img.height, function(group, rect){
		                    group.append(new Image$1(background.url, rect));
		                });
		            }
		        } else if (background.type == "linear") {
		            drawBackgroundImage(group, box, box.width, box.height, gradientRenderer(background));
		        } else {
		            return;
		        }
	
		        function drawBackgroundImage(group, box, img_width, img_height, renderBG) {
		            var aspect_ratio = img_width / img_height, f;
	
		            // for background-origin: border-box the box is already appropriate
		            var orgBox = box;
		            if (backgroundOrigin == "content-box") {
		                orgBox = innerBox(orgBox, "border-*-width", element);
		                orgBox = innerBox(orgBox, "padding-*", element);
		            } else if (backgroundOrigin == "padding-box") {
		                orgBox = innerBox(orgBox, "border-*-width", element);
		            }
	
		            if (!/^\s*auto(\s+auto)?\s*$/.test(backgroundSize)) {
		                if (backgroundSize == "contain") {
		                    f = Math.min(orgBox.width / img_width,
		                                 orgBox.height / img_height);
		                    img_width *= f;
		                    img_height *= f;
		                }
		                else if (backgroundSize == "cover") {
		                    f = Math.max(orgBox.width / img_width,
		                                 orgBox.height / img_height);
		                    img_width *= f;
		                    img_height *= f;
		                }
		                else {
		                    var size = backgroundSize.split(/\s+/g);
		                    // compute width
		                    if (/%$/.test(size[0])) {
		                        img_width = orgBox.width * parseFloat(size[0]) / 100;
		                    } else {
		                        img_width = parseFloat(size[0]);
		                    }
		                    // compute height
		                    if (size.length == 1 || size[1] == "auto") {
		                        img_height = img_width / aspect_ratio;
		                    } else if (/%$/.test(size[1])) {
		                        img_height = orgBox.height * parseFloat(size[1]) / 100;
		                    } else {
		                        img_height = parseFloat(size[1]);
		                    }
		                }
		            }
	
		            var pos = String(backgroundPosition);
	
		            // IE sometimes reports single-word positions
		            // https://github.com/telerik/kendo-ui-core/issues/2786
		            //
		            // it seems to switch to percentages when the horizontal
		            // position is not "center", therefore we don't handle
		            // multi-word cases here.  All other browsers return
		            // percentages or pixels instead of keywords.  At least
		            // for now...
		            switch (pos) {
		              case "bottom" : pos = "50% 100%"; break;
		              case "top"    : pos = "50% 0"; break;
		              case "left"   : pos = "0 50%"; break;
		              case "right"  : pos = "100% 50%"; break;
		              case "center" : pos = "50% 50%"; break;
		            }
	
		            pos = pos.split(/\s+/);
		            if (pos.length == 1) {
		                pos[1] = "50%";
		            }
	
		            if (/%$/.test(pos[0])) {
		                pos[0] = parseFloat(pos[0]) / 100 * (orgBox.width - img_width);
		            } else {
		                pos[0] = parseFloat(pos[0]);
		            }
		            if (/%$/.test(pos[1])) {
		                pos[1] = parseFloat(pos[1]) / 100 * (orgBox.height - img_height);
		            } else {
		                pos[1] = parseFloat(pos[1]);
		            }
	
		            var rect = new Rect([ orgBox.left + pos[0], orgBox.top + pos[1] ], [ img_width, img_height ]);
	
		            // XXX: background-repeat could be implemented more
		            //      efficiently as a fill pattern (at least for PDF
		            //      output, probably SVG too).
	
		            function rewX() {
		                while (rect.origin.x > box.left) {
		                    rect.origin.x -= img_width;
		                }
		            }
	
		            function rewY() {
		                while (rect.origin.y > box.top) {
		                    rect.origin.y -= img_height;
		                }
		            }
	
		            function repeatX() {
		                while (rect.origin.x < box.right) {
		                    renderBG(group, rect.clone());
		                    rect.origin.x += img_width;
		                }
		            }
	
		            if (backgroundRepeat == "no-repeat") {
		                renderBG(group, rect);
		            }
		            else if (backgroundRepeat == "repeat-x") {
		                rewX();
		                repeatX();
		            }
		            else if (backgroundRepeat == "repeat-y") {
		                rewY();
		                while (rect.origin.y < box.bottom) {
		                    renderBG(group, rect.clone());
		                    rect.origin.y += img_height;
		                }
		            }
		            else if (backgroundRepeat == "repeat") {
		                rewX();
		                rewY();
		                var origin = rect.origin.clone();
		                while (rect.origin.y < box.bottom) {
		                    rect.origin.x = origin.x;
		                    repeatX();
		                    rect.origin.y += img_height;
		                }
		            }
		        }
		    }
	
		    function drawBullet() {
		        var listStyleType = getPropertyValue(style, "list-style-type");
		        if (listStyleType == "none") {
		            return;
		        }
		        var listStylePosition = getPropertyValue(style, "list-style-position");
	
		        function _drawBullet(f) {
		            saveStyle(element, function(){
		                element.style.position = "relative";
		                var bullet = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
		                bullet.style.position = "absolute";
		                bullet.style.boxSizing = "border-box";
		                if (listStylePosition == "outside") {
		                    bullet.style.width = "6em";
		                    bullet.style.left = "-6.8em";
		                    bullet.style.textAlign = "right";
		                } else {
		                    bullet.style.left = "0px";
		                }
		                f(bullet);
		                element.insertBefore(bullet, element.firstChild);
		                renderElement(bullet, group);
		                element.removeChild(bullet);
		            });
		        }
	
		        function elementIndex(f) {
		            var a = element.parentNode.children;
		            var k = element.getAttribute("kendo-split-index");
		            if (k != null) {
		                return f(k|0, a.length);
		            }
		            for (var i = 0; i < a.length; ++i) {
		                if (a[i] === element) {
		                    return f(i, a.length);
		                }
		            }
		        }
	
		        switch (listStyleType) {
		          case "circle":
		          case "disc":
		          case "square":
		            _drawBullet(function(bullet){
		                // XXX: the science behind these values is called "trial and error".
		                bullet.style.fontSize = "60%";
		                bullet.style.lineHeight = "200%";
		                bullet.style.paddingRight = "0.5em";
		                bullet.style.fontFamily = "DejaVu Serif";
		                bullet.innerHTML = {
		                    "disc"   : "\u25cf",
		                    "circle" : "\u25ef",
		                    "square" : "\u25a0"
		                }[listStyleType];
		            });
		            break;
	
		          case "decimal":
		          case "decimal-leading-zero":
		            _drawBullet(function(bullet){
		                elementIndex(function(idx){
		                    ++idx;
		                    if (listStyleType == "decimal-leading-zero" && idx < 10) {
		                        idx = "0" + idx;
		                    }
		                    bullet.innerHTML = idx + ".";
		                });
		            });
		            break;
	
		          case "lower-roman":
		          case "upper-roman":
		            _drawBullet(function(bullet){
		                elementIndex(function(idx){
		                    idx = arabicToRoman(idx + 1);
		                    if (listStyleType == "upper-roman") {
		                        idx = idx.toUpperCase();
		                    }
		                    bullet.innerHTML = idx + ".";
		                });
		            });
		            break;
	
		          case "lower-latin":
		          case "lower-alpha":
		          case "upper-latin":
		          case "upper-alpha":
		            _drawBullet(function(bullet){
		                elementIndex(function(idx){
		                    idx = alphaNumeral(idx);
		                    if (/^upper/i.test(listStyleType)) {
		                        idx = idx.toUpperCase();
		                    }
		                    bullet.innerHTML = idx + ".";
		                });
		            });
		            break;
		        }
		    }
	
		    // draws a single border box
		    function drawOneBox(box, isFirst, isLast) {
		        if (box.width === 0 || box.height === 0) {
		            return;
		        }
	
		        drawBackground(box);
	
		        var shouldDrawLeft = (left.width > 0 && ((isFirst && dir == "ltr") || (isLast && dir == "rtl")));
		        var shouldDrawRight = (right.width > 0 && ((isLast && dir == "ltr") || (isFirst && dir == "rtl")));
	
		        // The most general case is that the 4 borders have different widths and border
		        // radiuses.  The way that is handled is by drawing 3 Paths for each border: the
		        // straight line, and two round corners which represent half of the entire rounded
		        // corner.  To simplify code those shapes are drawed at origin (by the drawEdge
		        // function), then translated/rotated into the right position.
		        //
		        // However, this leads to poor results due to rounding in the simpler cases where
		        // borders are straight lines.  Therefore we handle a few such cases separately with
		        // straight lines. C^wC^wC^w -- nope, scratch that.  poor rendering was because of a bug
		        // in Chrome (getClientRects() returns rounded integer values rather than exact floats.
		        // web dev is still a ghetto.)
	
		        // first, just in case there is no border...
		        if (top.width === 0 && left.width === 0 && right.width === 0 && bottom.width === 0) {
		            return;
		        }
	
		        // START paint borders
		        // if all borders have equal colors...
		        if (top.color == right.color && top.color == bottom.color && top.color == left.color) {
	
		            // if same widths too, we can draw the whole border by stroking a single path.
		            if (top.width == right.width && top.width == bottom.width && top.width == left.width)
		            {
		                if (shouldDrawLeft && shouldDrawRight) {
		                    // reduce box by half the border width, so we can draw it by stroking.
		                    box = innerBox(box, top.width/2);
	
		                    // adjust the border radiuses, again by top.width/2, and make the path element.
		                    var path = elementRoundBox(element, box, top.width/2);
		                    path.options.stroke = {
		                        color: top.color,
		                        width: top.width
		                    };
		                    group.append(path);
		                    return;
		                }
		            }
		        }
	
		        // if border radiuses are zero and widths are at most one pixel, we can again use simple
		        // paths.
		        if (rTL0.x === 0 && rTR0.x === 0 && rBR0.x === 0 && rBL0.x === 0) {
		            // alright, 1.9px will do as well.  the difference in color blending should not be
		            // noticeable.
		            if (top.width < 2 && left.width < 2 && right.width < 2 && bottom.width < 2) {
		                // top border
		                if (top.width > 0) {
		                    group.append(
		                        new Path({
		                            stroke: { width: top.width, color: top.color }
		                        })
		                            .moveTo(box.left, box.top + top.width/2)
		                            .lineTo(box.right, box.top + top.width/2)
		                    );
		                }
	
		                // bottom border
		                if (bottom.width > 0) {
		                    group.append(
		                        new Path({
		                            stroke: { width: bottom.width, color: bottom.color }
		                        })
		                            .moveTo(box.left, box.bottom - bottom.width/2)
		                            .lineTo(box.right, box.bottom - bottom.width/2)
		                    );
		                }
	
		                // left border
		                if (shouldDrawLeft) {
		                    group.append(
		                        new Path({
		                            stroke: { width: left.width, color: left.color }
		                        })
		                            .moveTo(box.left + left.width/2, box.top)
		                            .lineTo(box.left + left.width/2, box.bottom)
		                    );
		                }
	
		                // right border
		                if (shouldDrawRight) {
		                    group.append(
		                        new Path({
		                            stroke: { width: right.width, color: right.color }
		                        })
		                            .moveTo(box.right - right.width/2, box.top)
		                            .lineTo(box.right - right.width/2, box.bottom)
		                    );
		                }
	
		                return;
		            }
		        }
		        // END paint borders
	
		        var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
		        var rTL = tmp.tl;
		        var rTR = tmp.tr;
		        var rBR = tmp.br;
		        var rBL = tmp.bl;
	
		        // top border
		        drawEdge(top.color,
		                 box.width, top.width, left.width, right.width,
		                 rTL, rTR,
		                 [ 1, 0, 0, 1, box.left, box.top ]);
	
		        // bottom border
		        drawEdge(bottom.color,
		                 box.width, bottom.width, right.width, left.width,
		                 rBR, rBL,
		                 [ -1, 0, 0, -1, box.right, box.bottom ]);
	
		        // for left/right borders we need to invert the border-radiuses
		        function inv(p) {
		            return { x: p.y, y: p.x };
		        }
	
		        // left border
		        drawEdge(left.color,
		                 box.height, left.width, bottom.width, top.width,
		                 inv(rBL), inv(rTL),
		                 [ 0, -1, 1, 0, box.left, box.bottom ]);
	
		        // right border
		        drawEdge(right.color,
		                 box.height, right.width, top.width, bottom.width,
		                 inv(rTR), inv(rBR),
		                 [ 0, 1, -1, 0, box.right, box.top ]);
		    }
		}
	
		function gradientRenderer(gradient) {
		    return function(group, rect) {
		        var width = rect.width(), height = rect.height();
	
		        switch (gradient.type) {
		          case "linear":
	
		            // figure out the angle.
		            var angle = gradient.angle != null ? gradient.angle : Math.PI;
		            switch (gradient.to) {
		              case "top":
		                angle = 0;
		                break;
		              case "left":
		                angle = -Math.PI / 2;
		                break;
		              case "bottom":
		                angle = Math.PI;
		                break;
		              case "right":
		                angle = Math.PI / 2;
		                break;
		              case "top left": case "left top":
		                angle = -Math.atan2(height, width);
		                break;
		              case "top right": case "right top":
		                angle = Math.atan2(height, width);
		                break;
		              case "bottom left": case "left bottom":
		                angle = Math.PI + Math.atan2(height, width);
		                break;
		              case "bottom right": case "right bottom":
		                angle = Math.PI - Math.atan2(height, width);
		                break;
		            }
	
		            if (gradient.reverse) {
		                angle -= Math.PI;
		            }
	
		            // limit the angle between 0..2PI
		            angle %= 2 * Math.PI;
		            if (angle < 0) {
		                angle += 2 * Math.PI;
		            }
	
		            // compute gradient's start/end points.  here len is the length of the gradient line
		            // and x,y is the end point relative to the center of the rectangle in conventional
		            // (math) axis direction.
	
		            // this is the original (unscaled) length of the gradient line.  needed to deal with
		            // absolutely positioned color stops.  formula from the CSS spec:
		            // http://dev.w3.org/csswg/css-images-3/#linear-gradient-syntax
		            var pxlen = Math.abs(width * Math.sin(angle)) + Math.abs(height * Math.cos(angle));
	
		            // The math below is pretty simple, but it took a while to figure out.  We compute x
		            // and y, the *end* of the gradient line.  However, we want to transform them into
		            // element-based coordinates (SVG's gradientUnits="objectBoundingBox").  That means,
		            // x=0 is the left edge, x=1 is the right edge, y=0 is the top edge and y=1 is the
		            // bottom edge.
		            //
		            // A naive approach would use the original angle for these calculations.  Say we'd
		            // like to draw a gradient angled at 45deg in a 100x400 box.  When we use
		            // objectBoundingBox, the renderer will draw it in a 1x1 *square* box, and then
		            // scale that to the desired dimensions.  The 45deg angle will look more like 70deg
		            // after scaling.  SVG (http://www.w3.org/TR/SVG/pservers.html#LinearGradients) says
		            // the following:
		            //
		            //     When gradientUnits="objectBoundingBox" and 'gradientTransform' is the
		            //     identity matrix, the normal of the linear gradient is perpendicular to the
		            //     gradient vector in object bounding box space (i.e., the abstract coordinate
		            //     system where (0,0) is at the top/left of the object bounding box and (1,1) is
		            //     at the bottom/right of the object bounding box). When the object's bounding
		            //     box is not square, the gradient normal which is initially perpendicular to
		            //     the gradient vector within object bounding box space may render
		            //     non-perpendicular relative to the gradient vector in user space. If the
		            //     gradient vector is parallel to one of the axes of the bounding box, the
		            //     gradient normal will remain perpendicular. This transformation is due to
		            //     application of the non-uniform scaling transformation from bounding box space
		            //     to user space.
		            //
		            // which is an extremely long and confusing way to tell what I just said above.
		            //
		            // For this reason we need to apply the reverse scaling to the original angle, so
		            // that when it'll finally be rendered it'll actually be at the desired slope.  Now
		            // I'll let you figure out the math yourself.
	
		            var scaledAngle = Math.atan(width * Math.tan(angle) / height);
		            var sin = Math.sin(scaledAngle), cos = Math.cos(scaledAngle);
		            var len = Math.abs(sin) + Math.abs(cos);
		            var x = len/2 * sin;
		            var y = len/2 * cos;
	
		            // Because of the arctangent, our scaledAngle ends up between -PI/2..PI/2, possibly
		            // losing the intended direction of the gradient.  The following fixes it.
		            if (angle > Math.PI/2 && angle <= 3*Math.PI/2) {
		                x = -x;
		                y = -y;
		            }
	
		            // compute the color stops.
		            var implicit = [], right = 0;
		            var stops = gradient.stops.map(function(s, i){
		                var offset = s.percent;
		                if (offset) {
		                    offset = parseFloat(offset) / 100;
		                } else if (s.length) {
		                    offset = parseFloat(s.length) / pxlen;
		                } else if (i === 0) {
		                    offset = 0;
		                } else if (i == gradient.stops.length - 1) {
		                    offset = 1;
		                }
		                var stop = {
		                    color: s.color.toCssRgba(),
		                    offset: offset
		                };
		                if (offset != null) {
		                    right = offset;
		                    // fix implicit offsets
		                    implicit.forEach(function(s, i){
		                        var stop = s.stop;
		                        stop.offset = s.left + (right - s.left) * (i + 1) / (implicit.length + 1);
		                    });
		                    implicit = [];
		                } else {
		                    implicit.push({ left: right, stop: stop });
		                }
		                return stop;
		            });
	
		            var start = [ 0.5 - x, 0.5 + y ];
		            var end = [ 0.5 + x, 0.5 - y ];
	
		            // finally, draw it.
		            group.append(
		                Path.fromRect(rect)
		                    .stroke(null)
		                    .fill(new LinearGradient({
		                        start     : start,
		                        end       : end,
		                        stops     : stops,
		                        userSpace : false
		                    }))
		            );
		            break;
		          case "radial":
		            // XXX:
		            if (window.console && window.console.log) {
		                window.console.log("Radial gradients are not yet supported in HTML renderer");
		            }
		            break;
		        }
		    };
		}
	
		function maybeRenderWidget(element, group) {
		    var visual;
	
		    if (element._kendoExportVisual) {
		        visual = element._kendoExportVisual();
		    } else if (window.kendo && window.kendo.jQuery && element.getAttribute(window.kendo.attr("role"))) {
		        var widget = window.kendo.widgetInstance(window.kendo.jQuery(element));
		        if (widget && (widget.exportDOMVisual || widget.exportVisual)) {
		            if (widget.exportDOMVisual) {
		                visual = widget.exportDOMVisual();
		            } else {
		                visual = widget.exportVisual();
		            }
		        }
		    }
	
		    if (!visual) {
		        return false;
		    }
	
		    var wrap$$1 = new Group();
		    wrap$$1.children.push(visual);
	
		    var bbox = element.getBoundingClientRect();
		    wrap$$1.transform(transform().translate(bbox.left, bbox.top));
	
		    group.append(wrap$$1);
	
		    return true;
		}
	
		function renderImage(element, url, group) {
		    var box = getContentBox(element);
		    var rect = new Rect([ box.left, box.top ], [ box.width, box.height ]);
		    var image = new Image$1(url, rect);
		    setClipping(image, elementRoundBox(element, box, "content"));
		    group.append(image);
		}
	
		function zIndexSort(a, b) {
		    var sa = getComputedStyle(a);
		    var sb = getComputedStyle(b);
		    var za = parseFloat(getPropertyValue(sa, "z-index"));
		    var zb = parseFloat(getPropertyValue(sb, "z-index"));
		    var pa = getPropertyValue(sa, "position");
		    var pb = getPropertyValue(sb, "position");
		    if (isNaN(za) && isNaN(zb)) {
		        if ((/static|absolute/.test(pa)) && (/static|absolute/.test(pb))) {
		            return 0;
		        }
		        if (pa == "static") {
		            return -1;
		        }
		        if (pb == "static") {
		            return 1;
		        }
		        return 0;
		    }
		    if (isNaN(za)) {
		        return zb === 0 ? 0 : zb > 0 ? -1 : 1;
		    }
		    if (isNaN(zb)) {
		        return za === 0 ? 0 : za > 0 ? 1 : -1;
		    }
		    return parseFloat(za) - parseFloat(zb);
		}
	
		function isFormField(element) {
		    return /^(?:textarea|select|input)$/i.test(element.tagName);
		}
	
		function getSelectedOption(element) {
		    if (element.selectedOptions && element.selectedOptions.length > 0) {
		        return element.selectedOptions[0];
		    }
		    return element.options[element.selectedIndex];
		}
	
		function renderCheckbox(element, group) {
		    var style = getComputedStyle(element);
		    var color = getPropertyValue(style, "color");
		    var box = element.getBoundingClientRect();
		    if (element.type == "checkbox") {
		        group.append(
		            Path.fromRect(
		                new Rect([ box.left+1, box.top+1 ],
		                             [ box.width-2, box.height-2 ])
		            ).stroke(color, 1)
		        );
		        if (element.checked) {
		            // fill a rectangle inside?  looks kinda ugly.
		            // group.append(
		            //     Path.fromRect(
		            //         new geo.Rect([ box.left+4, box.top+4 ],
		            //                      [ box.width-8, box.height-8])
		            //     ).fill(color).stroke(null)
		            // );
	
		            // let's draw a checkmark instead.  artistic, eh?
		            group.append(
		                new Path()
		                    .stroke(color, 1.2)
		                    .moveTo(box.left + 0.22 * box.width,
		                            box.top + 0.55 * box.height)
		                    .lineTo(box.left + 0.45 * box.width,
		                            box.top + 0.75 * box.height)
		                    .lineTo(box.left + 0.78 * box.width,
		                            box.top + 0.22 * box.width)
		            );
		        }
		    } else {
		        group.append(
		            new Circle(
		                new Circle$2([
		                    (box.left + box.right) / 2,
		                    (box.top + box.bottom) / 2
		                ], Math.min(box.width-2, box.height-2) / 2)
		            ).stroke(color, 1)
		        );
		        if (element.checked) {
		            group.append(
		                new Circle(
		                    new Circle$2([
		                        (box.left + box.right) / 2,
		                        (box.top + box.bottom) / 2
		                    ], Math.min(box.width-8, box.height-8) / 2)
		                ).fill(color).stroke(null)
		            );
		        }
		    }
		}
	
		function renderFormField(element, group) {
		    var tag = element.tagName.toLowerCase();
		    if (tag == "input" && (element.type == "checkbox" || element.type == "radio")) {
		        return renderCheckbox(element, group);
		    }
		    var p = element.parentNode;
		    var doc = element.ownerDocument;
		    var el = doc.createElement(KENDO_PSEUDO_ELEMENT);
		    var option;
		    el.style.cssText = getCssText(getComputedStyle(element));
		    if (tag == "input") {
		        el.style.whiteSpace = "pre";
		    }
		    if (tag == "select" || tag == "textarea") {
		        el.style.overflow = "auto";
		    }
		    if (tag == "select") {
		        if (element.multiple) {
		            for (var i = 0; i < element.options.length; ++i) {
		                option = doc.createElement(KENDO_PSEUDO_ELEMENT);
		                option.style.cssText = getCssText(getComputedStyle(element.options[i]));
		                option.style.display = "block"; // IE9 messes up without this
		                option.textContent = element.options[i].textContent;
		                el.appendChild(option);
		            }
		        } else {
		            option = getSelectedOption(element);
		            if (option) {
		                el.textContent = option.textContent;
		            }
		        }
		    } else {
		        el.textContent = element.value;
		    }
		    p.insertBefore(el, element);
		    el.scrollLeft = element.scrollLeft;
		    el.scrollTop = element.scrollTop;
	
		    // must temporarily hide the original element, otherwise it
		    // may affect layout of the fake element we want to render.
		    element.style.display = "none";
	
		    renderContents(el, group);
		    element.style.display = "";
		    p.removeChild(el);
		}
	
		function renderContents(element, group) {
		    if (nodeInfo._stackingContext.element === element) {
		        // the group that was set in pushNodeInfo might have
		        // changed due to clipping/transforms, update it here.
		        nodeInfo._stackingContext.group = group;
		    }
		    switch (element.tagName.toLowerCase()) {
		      case "img":
		        renderImage(element, element.src, group);
		        break;
	
		      case "canvas":
		        try {
		            renderImage(element, element.toDataURL("image/png"), group);
		        } catch (ex) {
		            // tainted; can't draw it, ignore.
		        }
		        break;
	
		      case "textarea":
		      case "input":
		      case "select":
		        renderFormField(element, group);
		        break;
	
		      default:
		        var children = [], floats = [], positioned = [];
		        for (var i = element.firstChild; i; i = i.nextSibling) {
		            switch (i.nodeType) {
		              case 3:         // Text
		                if (/\S/.test(i.data)) {
		                    renderText(element, i, group);
		                }
		                break;
		              case 1:         // Element
		                var style = getComputedStyle(i);
		                var floating = getPropertyValue(style, "float");
		                var position = getPropertyValue(style, "position");
		                if (position != "static") {
		                    positioned.push(i);
		                }
		                else if (floating != "none") {
		                    floats.push(i);
		                } else {
		                    children.push(i);
		                }
		                break;
		            }
		        }
	
		        mergeSort(children, zIndexSort).forEach(function(el){ renderElement(el, group); });
		        mergeSort(floats, zIndexSort).forEach(function(el){ renderElement(el, group); });
		        mergeSort(positioned, zIndexSort).forEach(function(el){ renderElement(el, group); });
		    }
		}
	
		function renderText(element, node, group) {
		    if (emptyClipbox()) {
		        return;
		    }
		    var style = getComputedStyle(element);
	
		    if (parseFloat(getPropertyValue(style, "text-indent")) < -500) {
		        // assume it should not be displayed.  the slider's
		        // draggable handle displays a Drag text for some reason,
		        // having text-indent: -3333px.
		        return;
		    }
	
		    var text = node.data;
		    var start = 0;
		    var end = text.search(/\S\s*$/) + 1;
	
		    if (!end) {
		        return; // whitespace-only node
		    }
	
		    var fontSize = getPropertyValue(style, "font-size");
		    var lineHeight = getPropertyValue(style, "line-height");
	
		    // simply getPropertyValue("font") doesn't work in Firefox :-\
		    var font = [
		        getPropertyValue(style, "font-style"),
		        getPropertyValue(style, "font-variant"),
		        getPropertyValue(style, "font-weight"),
		        fontSize, // no need for line height here; it breaks layout in FF
		        getPropertyValue(style, "font-family")
		    ].join(" ");
	
		    fontSize = parseFloat(fontSize);
		    lineHeight = parseFloat(lineHeight);
	
		    if (fontSize === 0) {
		        return;
		    }
	
		    var color = getPropertyValue(style, "color");
		    var range = element.ownerDocument.createRange();
		    var align$$1 = getPropertyValue(style, "text-align");
		    var isJustified = align$$1 == "justify";
		    var columnCount = getPropertyValue(style, "column-count", 1);
		    var whiteSpace = getPropertyValue(style, "white-space");
		    var textTransform = getPropertyValue(style, "text-transform");
	
		    // IE shrinks the text with text-overflow: ellipsis,
		    // apparently because the returned bounding box for the range
		    // is limited to the visible area minus space for the dots,
		    // instead of being the full width of the text.
		    //
		    // https://github.com/telerik/kendo/issues/5232
		    var textOverflow, saveTextOverflow;
		    if (microsoft) {
		        textOverflow = style.textOverflow;             // computed style
		        if (textOverflow == "ellipsis") {
		            saveTextOverflow = element.style.textOverflow; // own style.
		            element.style.textOverflow = "clip";
		        }
		    }
	
		    // A line of 500px, with a font of 12px, contains an average of 80 characters, but since we
		    // err, we'd like to guess a bigger number rather than a smaller one.  Multiplying by 5
		    // seems to be a good option.
		    var estimateLineLength = element.getBoundingClientRect().width / fontSize * 5;
		    if (estimateLineLength === 0) {
		        estimateLineLength = 500;
		    }
	
		    // we'll maintain this so we can workaround bugs in Chrome's Range.getClientRects
		    // https://github.com/telerik/kendo/issues/5740
		    var prevLineBottom = null;
	
		    var underline = nodeInfo["underline"];
		    var lineThrough = nodeInfo["line-through"];
		    var overline = nodeInfo["overline"];
		    var hasDecoration = underline || lineThrough || overline;
	
		    // doChunk returns true when all text has been rendered
		    while (!doChunk()) {}
	
		    if (microsoft && textOverflow == "ellipsis") {
		        element.style.textOverflow = saveTextOverflow;
		    }
	
		    if (hasDecoration) {
		        range.selectNode(node);
		        slice$1(range.getClientRects()).forEach(decorate);
		    }
	
		    return;                 // only function declarations after this line
	
		    function actuallyGetRangeBoundingRect(range) {
		        // XXX: to be revised when this Chrome bug is fixed:
		        // https://bugs.chromium.org/p/chromium/issues/detail?id=612459
		        if (microsoft || browser.chrome) {
		            // Workaround browser bugs: IE and Chrome would sometimes
		            // return 0 or 1-width rectangles before or after the main
		            // one.  https://github.com/telerik/kendo/issues/4674
	
		            // Actually Chrome 50 got worse, since the rectangles can now have the width of a
		            // full character, making it hard to tell whether it's a bogus rectangle or valid
		            // selection location.  The workaround is to ignore rectangles that fall on the
		            // previous line.  https://github.com/telerik/kendo/issues/5740
		            var rectangles = range.getClientRects(), box = {
		                top    :  Infinity,
		                right  : -Infinity,
		                bottom : -Infinity,
		                left   :  Infinity
		            }, done = false;
		            for (var i = 0; i < rectangles.length; ++i) {
		                var b = rectangles[i];
		                if (b.width <= 1 || b.bottom === prevLineBottom) {
		                    continue;   // bogus rectangle
		                }
		                box.left   = Math.min(b.left   , box.left);
		                box.top    = Math.min(b.top    , box.top);
		                box.right  = Math.max(b.right  , box.right);
		                box.bottom = Math.max(b.bottom , box.bottom);
		                done = true;
		            }
		            if (!done) {
		                return range.getBoundingClientRect();
		            }
		            box.width = box.right - box.left;
		            box.height = box.bottom - box.top;
		            return box;
		        }
		        return range.getBoundingClientRect();
		    }
	
		    // Render a chunk of text, typically one line (but for justified text we render each word as
		    // a separate Text object, because spacing is variable).  Returns true when it finished the
		    // current node.  After each chunk it updates `start` to just after the last rendered
		    // character.
		    function doChunk() {
		        var origStart = start;
		        var box, pos = text.substr(start).search(/\S/);
		        start += pos;
		        if (pos < 0 || start >= end) {
		            return true;
		        }
	
		        // Select a single character to determine the height of a line of text.  The box.bottom
		        // will be essential for us to figure out where the next line begins.
		        range.setStart(node, start);
		        range.setEnd(node, start + 1);
		        box = actuallyGetRangeBoundingRect(range);
	
		        // for justified text we must split at each space, because space has variable width.
		        var found = false;
		        if (isJustified || columnCount > 1) {
		            pos = text.substr(start).search(/\s/);
		            if (pos >= 0) {
		                // we can only split there if it's on the same line, otherwise we'll fall back
		                // to the default mechanism (see findEOL below).
		                range.setEnd(node, start + pos);
		                var r = actuallyGetRangeBoundingRect(range);
		                if (r.bottom == box.bottom) {
		                    box = r;
		                    found = true;
		                    start += pos;
		                }
		            }
		        }
	
		        if (!found) {
		            // This code does three things: (1) it selects one line of text in `range`, (2) it
		            // leaves the bounding rect of that line in `box` and (3) it returns the position
		            // just after the EOL.  We know where the line starts (`start`) but we don't know
		            // where it ends.  To figure this out, we select a piece of text and look at the
		            // bottom of the bounding box.  If it changes, we have more than one line selected
		            // and should retry with a smaller selection.
		            //
		            // To speed things up, we first try to select all text in the node (`start` ->
		            // `end`).  If there's more than one line there, then select only half of it.  And
		            // so on.  When we find a value for `end` that fits in one line, we try increasing
		            // it (also in halves) until we get to the next line.  The algorithm stops when the
		            // right side of the bounding box does not change.
		            //
		            // One more thing to note is that everything happens in a single Text DOM node.
		            // There's no other tags inside it, therefore the left/top coordinates of the
		            // bounding box will not change.
		            pos = (function findEOL(min, eol, max){
		                range.setEnd(node, eol);
		                var r = actuallyGetRangeBoundingRect(range);
		                if (r.bottom != box.bottom && min < eol) {
		                    return findEOL(min, (min + eol) >> 1, eol);
		                } else if (r.right != box.right) {
		                    box = r;
		                    if (eol < max) {
		                        return findEOL(eol, (eol + max) >> 1, max);
		                    } else {
		                        return eol;
		                    }
		                } else {
		                    return eol;
		                }
		            })(start, Math.min(end, start + estimateLineLength), end);
	
		            if (pos == start) {
		                // if EOL is at the start, then no more text fits on this line.  Skip the
		                // remainder of this node entirely to avoid a stack overflow.
		                return true;
		            }
		            start = pos;
	
		            pos = range.toString().search(/\s+$/);
		            if (pos === 0) {
		                return false; // whitespace only; we should not get here.
		            }
		            if (pos > 0) {
		                // eliminate trailing whitespace
		                range.setEnd(node, range.startOffset + pos);
		                box = actuallyGetRangeBoundingRect(range);
		            }
		        }
	
		        // another workaround for IE: if we rely on getBoundingClientRect() we'll overlap with the bullet for LI
		        // elements.  Calling getClientRects() and using the *first* rect appears to give us the correct location.
		        // Note: not to be used in Chrome as it randomly returns a zero-width rectangle from the previous line.
		        if (microsoft) {
		            box = range.getClientRects()[0];
		        }
	
		        var str = range.toString();
		        if (!/^(?:pre|pre-wrap)$/i.test(whiteSpace)) {
		            // node with non-significant space -- collapse whitespace.
		            str = str.replace(/\s+/g, " ");
		        }
		        else if (/\t/.test(str)) {
		            // with significant whitespace we need to do something about literal TAB characters.
		            // There's no TAB glyph in a font so they would be rendered in PDF as an empty box,
		            // and the whole text will stretch to fill the original width.  The core PDF lib
		            // does not have sufficient context to deal with it.
	
		            // calculate the starting column here, since we initially discarded any whitespace.
		            var cc = 0;
		            for (pos = origStart; pos < range.startOffset; ++pos) {
		                var code = text.charCodeAt(pos);
		                if (code == 9) {
		                    // when we meet a TAB we must round up to the next tab stop.
		                    // in all browsers TABs seem to be 8 characters.
		                    cc += 8 - cc % 8;
		                } else if (code == 10 || code == 13) {
		                    // just in case we meet a newline we must restart.
		                    cc = 0;
		                } else {
		                    // ordinary character --> advance one column
		                    cc++;
		                }
		            }
	
		            // based on starting column, replace any TAB characters in the string we actually
		            // have to display with spaces so that they align to columns multiple of 8.
		            while ((pos = str.search("\t")) >= 0) {
		                var indent = "        ".substr(0, 8 - (cc + pos) % 8);
		                str = str.substr(0, pos) + indent + str.substr(pos + 1);
		            }
		        }
	
		        if (!found) {
		            prevLineBottom = box.bottom;
		        }
		        drawText(str, box);
		    }
	
		    function drawText(str, box) {
		        // In IE the box height will be approximately lineHeight, while in
		        // other browsers it'll (correctly) be the height of the bounding
		        // box for the current text/font.  Which is to say, IE sucks again.
		        // The only good solution I can think of is to measure the text
		        // ourselves and center the bounding box.
		        if (microsoft && !isNaN(lineHeight)) {
		            var height = getFontHeight(font);
		            var top = (box.top + box.bottom - height) / 2;
		            box = {
		                top    : top,
		                right  : box.right,
		                bottom : top + height,
		                left   : box.left,
		                height : height,
		                width  : box.right - box.left
		            };
		        }
	
		        // var path = new Path({ stroke: { color: "red" }});
		        // path.moveTo(box.left, box.top)
		        //     .lineTo(box.right, box.top)
		        //     .lineTo(box.right, box.bottom)
		        //     .lineTo(box.left, box.bottom)
		        //     .close();
		        // group.append(path);
	
		        switch (textTransform) {
		          case "uppercase":
		            str = str.toUpperCase();
		            break;
		          case "lowercase":
		            str = str.toLowerCase();
		            break;
		          case "capitalize":
		            str = str.replace(/(?:^|\s)\S/g, function (l) { return l.toUpperCase(); });
		            break;
		        }
	
		        var text = new TextRect(
		            str, new Rect([ box.left, box.top ],
		                              [ box.width, box.height ]),
		            {
		                font: font,
		                fill: { color: color }
		            }
		        );
		        group.append(text);
		    }
	
		    function decorate(box) {
		        line(underline, box.bottom);
		        line(lineThrough, box.bottom - box.height / 2.7);
		        line(overline, box.top);
		        function line(color, ypos) {
		            if (color) {
		                var width = fontSize / 12;
		                var path = new Path({ stroke: {
		                    width: width,
		                    color: color
		                }});
	
		                ypos -= width;
		                path.moveTo(box.left, ypos)
		                    .lineTo(box.right, ypos);
		                group.append(path);
		            }
		        }
		    }
		}
	
		function groupInStackingContext(element, group, zIndex) {
		    var main;
		    if (zIndex != "auto") {
		        // use the current stacking context
		        main = nodeInfo._stackingContext.group;
		        zIndex = parseFloat(zIndex);
		    } else {
		        // normal flow — use given container.  we still have to
		        // figure out where should we insert this element with the
		        // assumption that its z-index is zero, as the group might
		        // already contain elements with higher z-index.
		        main = group;
		        zIndex = 0;
		    }
		    var a = main.children;
		    for (var i = 0; i < a.length; ++i) {
		        if (a[i]._dom_zIndex != null && a[i]._dom_zIndex > zIndex) {
		            break;
		        }
		    }
	
		    var tmp = new Group();
		    main.insert(i, tmp);
		    tmp._dom_zIndex = zIndex;
	
		    if (main !== group) {
		        // console.log("Placing", element, "in", nodeInfo._stackingContext.element, "at position", i, " / ", a.length);
		        // console.log(a.slice(i+1));
	
		        // if (nodeInfo._matrix) {
		        //     tmp.transform(nodeInfo._matrix);
		        // }
		        if (nodeInfo._clipbox) {
		            var m = nodeInfo._matrix.invert();
		            var r = nodeInfo._clipbox.transformCopy(m);
		            setClipping(tmp, Path.fromRect(r));
		            // console.log(r);
		            // tmp.append(Path.fromRect(r));
		            // tmp.append(new Text(element.className || element.id, r.topLeft()));
		        }
		    }
	
		    return tmp;
		}
	
		function renderElement(element, container) {
		    var style = getComputedStyle(element);
	
		    updateCounters(style);
	
		    if (/^(style|script|link|meta|iframe|svg|col|colgroup)$/i.test(element.tagName)) {
		        return;
		    }
	
		    if (nodeInfo._clipbox == null) {
		        return;
		    }
	
		    var opacity = parseFloat(getPropertyValue(style, "opacity"));
		    var visibility = getPropertyValue(style, "visibility");
		    var display = getPropertyValue(style, "display");
	
		    if (opacity === 0 || visibility == "hidden" || display == "none") {
		        return;
		    }
	
		    var tr = getTransform(style);
		    var group;
	
		    var zIndex = getPropertyValue(style, "z-index");
		    if ((tr || opacity < 1) && zIndex == "auto") {
		        zIndex = 0;
		    }
		    group = groupInStackingContext(element, container, zIndex);
	
		    // XXX: remove at some point
		    // group._pdfElement = element;
		    // group.options._pdfDebug = "";
		    // if (element.id) {
		    //     group.options._pdfDebug = "#" + element.id;
		    // }
		    // if (element.className) {
		    //     group.options._pdfDebug += "." + element.className.split(" ").join(".");
		    // }
	
		    if (opacity < 1) {
		        group.opacity(opacity * group.opacity());
		    }
	
		    pushNodeInfo(element, style, group);
	
		    if (!tr) {
		        _renderWithPseudoElements(element, group);
		    }
		    else {
		        saveStyle(element, function(){
		            // must clear transform, so getBoundingClientRect returns correct values.
		            pleaseSetPropertyValue(element.style, "transform", "none", "important");
	
		            // must also clear transitions, so correct values are returned *immediately*
		            pleaseSetPropertyValue(element.style, "transition", "none", "important");
	
		            // the presence of any transform makes it behave like it had position: relative,
		            // because why not.
		            // http://meyerweb.com/eric/thoughts/2011/09/12/un-fixing-fixed-elements-with-css-transforms/
		            if (getPropertyValue(style, "position") == "static") {
		                // but only if it's not already positioned. :-/
		                pleaseSetPropertyValue(element.style, "position", "relative", "important");
		            }
	
		            // must translate to origin before applying the CSS
		            // transformation, then translate back.
		            var bbox = element.getBoundingClientRect();
		            var x = bbox.left + tr.origin[0];
		            var y = bbox.top + tr.origin[1];
		            var m = [ 1, 0, 0, 1, -x, -y ];
		            m = mmul(m, tr.matrix);
		            m = mmul(m, [ 1, 0, 0, 1, x, y ]);
		            m = setTransform(group, m);
	
		            nodeInfo._matrix = nodeInfo._matrix.multiplyCopy(m);
	
		            _renderWithPseudoElements(element, group);
		        });
		    }
	
		    popNodeInfo();
	
		    //drawDebugBox(element.getBoundingClientRect(), container);
		}
	
		// function drawDebugBox(box, group, color) {
		//     var path = Path.fromRect(new geo.Rect([ box.left, box.top ], [ box.width, box.height ]));
		//     if (color) {
		//         path.stroke(color);
		//     }
		//     group.append(path);
		// }
	
		// function dumpTextNode(node) {
		//     var txt = node.data.replace(/^\s+/, "");
		//     if (txt.length < 100) {
		//         console.log(node.data.length + ": |" + txt);
		//     } else {
		//         console.log(node.data.length + ": |" + txt.substr(0, 50) + "|...|" + txt.substr(-50));
		//     }
		// }
	
		function mmul(a, b) {
		    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
		    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
		    return [
		        a1*a2 + b1*c2,          a1*b2 + b1*d2,
		        c1*a2 + d1*c2,          c1*b2 + d1*d2,
		        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
		    ];
		}
	
		var drawing = {
			svg: svg,
			canvas: canvas,
			util: util,
			PathParser: PathParser,
			Surface: Surface,
			BaseNode: BaseNode,
			SurfaceFactory: SurfaceFactory,
			OptionsStore: OptionsStore,
			exportImage: exportImage,
			exportSVG: exportSVG,
			QuadNode: QuadNode,
			ShapesQuadTree: ShapesQuadTree,
			ObserversMixin: ObserversMixin,
			Element: Element$1,
			Circle: Circle,
			Arc: Arc,
			Path: Path,
			MultiPath: MultiPath,
			Text: Text,
			Image: Image$1,
			Group: Group,
			Layout: Layout,
			Rect: Rect$2,
			align: align,
			vAlign: vAlign,
			stack: stack,
			vStack: vStack,
			wrap: wrap,
			vWrap: vWrap,
			fit: fit,
			LinearGradient: LinearGradient,
			RadialGradient: RadialGradient,
			GradientStop: GradientStop,
			Gradient: Gradient,
			Animation: Animation,
			AnimationFactory: AnimationFactory,
			drawDOM: drawDOM
		};
	
		kendo.deepExtend(kendo, {
		    drawing: drawing,
		    geometry: geometry
		});
	
		kendo.drawing.Segment = kendo.geometry.Segment;
		kendo.dataviz.drawing = kendo.drawing;
		kendo.dataviz.geometry = kendo.geometry;
		kendo.drawing.util.measureText = kendo.util.measureText;
		kendo.drawing.util.objectKey = kendo.util.objectKey;
		kendo.drawing.Color = kendo.Color;
		kendo.util.encodeBase64 = kendo.drawing.util.encodeBase64;
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 922:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(551);
	
	/***/ }),
	
	/***/ 923:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(554);
	
	/***/ }),
	
	/***/ 924:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(555);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1033);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1033:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    var __meta__ = { // jshint ignore:line
		        id: "color",
		        name: "Color utils",
		        category: "framework",
		        advanced: true,
		        description: "Color utilities used across components",
		        depends: [ "core" ]
		    };
	
		/*jshint eqnull:true  */
	
		window.kendo = window.kendo || {};
	
		var Class = kendo.Class;
		var support = kendo.support;
	
		var namedColors = {
		    aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff",
		    aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc",
		    bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd",
		    blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a",
		    burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00",
		    chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed",
		    cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff",
		    darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b",
		    darkgray: "a9a9a9", darkgrey: "a9a9a9", darkgreen: "006400",
		    darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f",
		    darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000",
		    darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b",
		    darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1",
		    darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff",
		    dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff",
		    firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22",
		    fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff",
		    gold: "ffd700", goldenrod: "daa520", gray: "808080",
		    grey: "808080", green: "008000", greenyellow: "adff2f",
		    honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c",
		    indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c",
		    lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00",
		    lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080",
		    lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3",
		    lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1",
		    lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa",
		    lightslategray: "778899", lightslategrey: "778899", lightsteelblue: "b0c4de",
		    lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32",
		    linen: "faf0e6", magenta: "ff00ff", maroon: "800000",
		    mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3",
		    mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee",
		    mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585",
		    midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1",
		    moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080",
		    oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23",
		    orange: "ffa500", orangered: "ff4500", orchid: "da70d6",
		    palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee",
		    palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9",
		    peru: "cd853f", pink: "ffc0cb", plum: "dda0dd",
		    powderblue: "b0e0e6", purple: "800080", red: "ff0000",
		    rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513",
		    salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57",
		    seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0",
		    skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090",
		    slategrey: "708090", snow: "fffafa", springgreen: "00ff7f",
		    steelblue: "4682b4", tan: "d2b48c", teal: "008080",
		    thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0",
		    violet: "ee82ee", wheat: "f5deb3", white: "ffffff",
		    whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32"
		};
	
		var browser = support.browser;
	
		var matchNamedColor = function (color) {
		    var colorNames = Object.keys(namedColors);
		    colorNames.push("transparent");
	
		    var regexp = new RegExp("^(" + colorNames.join("|") + ")(\\W|$)", "i");
		    matchNamedColor = function (color) { return regexp.exec(color); };
	
		    return regexp.exec(color);
		};
	
		var BaseColor = Class.extend({
		    init: function() {  },
	
		    toHSV: function() { return this; },
	
		    toRGB: function() { return this; },
	
		    toHex: function() { return this.toBytes().toHex(); },
	
		    toBytes: function() { return this; },
	
		    toCss: function() { return "#" + this.toHex(); },
	
		    toCssRgba: function() {
		        var rgb = this.toBytes();
		        return ("rgba(" + (rgb.r) + ", " + (rgb.g) + ", " + (rgb.b) + ", " + (parseFloat((Number(this.a)).toFixed(3))) + ")");
		    },
	
		    toDisplay: function() {
		        if (browser.msie && browser.version < 9) {
		            return this.toCss(); // no RGBA support; does it support any opacity in colors?
		        }
		        return this.toCssRgba();
		    },
	
		    equals: function(c) {
		        return c === this || c !== null && this.toCssRgba() === parseColor(c).toCssRgba();
		    },
	
		    diff: function(other) {
		        if (other === null) {
		            return NaN;
		        }
	
		        var c1 = this.toBytes();
		        var c2 = other.toBytes();
	
		        return Math.sqrt(Math.pow((c1.r - c2.r) * 0.30, 2) +
		                         Math.pow((c1.g - c2.g) * 0.59, 2) +
		                         Math.pow((c1.b - c2.b) * 0.11, 2));
		    },
	
		    clone: function() {
		        var c = this.toBytes();
		        if (c === this) {
		            c = new Bytes(c.r, c.g, c.b, c.a);
		        }
	
		        return c;
		    }
		});
	
		var RGB = BaseColor.extend({
		    init: function(r, g, b, a) {
		        BaseColor.fn.init.call(this);
	
		        this.r = r;
		        this.g = g;
		        this.b = b;
		        this.a = a;
		    },
	
		    toHSV: function() {
		        var ref = this;
		        var r = ref.r;
		        var g = ref.g;
		        var b = ref.b;
		        var min = Math.min(r, g, b);
		        var max = Math.max(r, g, b);
		        var delta = max - min;
		        var v = max;
		        var h, s;
	
		        if (delta === 0) {
		            return new HSV(0, 0, v, this.a);
		        }
	
		        if (max !== 0) {
		            s = delta / max;
		            if (r === max) {
		                h = (g - b) / delta;
		            } else if (g === max) {
		                h = 2 + (b - r) / delta;
		            } else {
		                h = 4 + (r - g) / delta;
		            }
	
		            h *= 60;
		            if (h < 0) {
		                h += 360;
		            }
		        } else {
		            s = 0;
		            h = -1;
		        }
	
		        return new HSV(h, s, v, this.a);
		    },
	
		    toHSL: function() {
		        var ref = this;
		        var r = ref.r;
		        var g = ref.g;
		        var b = ref.b;
		        var max = Math.max(r, g, b);
		        var min = Math.min(r, g, b);
		        var h, s, l = (max + min) / 2;
	
		        if (max === min) {
		            h = s = 0;
		        } else {
		            var d = max - min;
		            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		            switch (max) {
		                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
		                case g: h = (b - r) / d + 2; break;
		                case b: h = (r - g) / d + 4; break;
		                default: break;
		            }
		        }
	
		        return new HSL(h * 60, s * 100, l * 100, this.a);
		    },
	
		    toBytes: function() {
		        return new Bytes(this.r * 255, this.g * 255, this.b * 255, this.a);
		    }
		});
	
		var Bytes = RGB.extend({
		    init: function(r, g, b, a) {
		        RGB.fn.init.call(this, Math.round(r), Math.round(g), Math.round(b), a);
		    },
	
		    toRGB: function() {
		        return new RGB(this.r / 255, this.g / 255, this.b / 255, this.a);
		    },
	
		    toHSV: function() {
		        return this.toRGB().toHSV();
		    },
	
		    toHSL: function() {
		        return this.toRGB().toHSL();
		    },
	
		    toHex: function() {
		        return hex(this.r, 2) + hex(this.g, 2) + hex(this.b, 2);
		    },
	
		    toBytes: function() {
		        return this;
		    }
		});
	
		function hex(n, width, pad) {
		    if (pad === void 0) { pad = "0"; }
	
		    var result = n.toString(16);
		    while (width > result.length) {
		        result = pad + result;
		    }
	
		    return result;
		}
	
		var HSV = BaseColor.extend({
		    init: function(h, s, v, a) {
		        BaseColor.fn.init.call(this);
	
		        this.h = h;
		        this.s = s;
		        this.v = v;
		        this.a = a;
		    },
	
		    toRGB: function() {
		        var ref = this;
		        var h = ref.h;
		        var s = ref.s;
		        var v = ref.v;
		        var r, g, b;
	
		        if (s === 0) {
		            r = g = b = v;
		        } else {
		            h /= 60;
	
		            var i = Math.floor(h);
		            var f = h - i;
		            var p = v * (1 - s);
		            var q = v * (1 - s * f);
		            var t = v * (1 - s * (1 - f));
	
		            switch (i) {
		                case 0: r = v; g = t; b = p; break;
		                case 1: r = q; g = v; b = p; break;
		                case 2: r = p; g = v; b = t; break;
		                case 3: r = p; g = q; b = v; break;
		                case 4: r = t; g = p; b = v; break;
		                default: r = v; g = p; b = q; break;
		            }
		        }
	
		        return new RGB(r, g, b, this.a);
		    },
	
		    toHSL: function() {
		        return this.toRGB().toHSL();
		    },
	
		    toBytes: function() {
		        return this.toRGB().toBytes();
		    }
		});
	
		var HSL = BaseColor.extend({
		    init: function(h, s, l, a) {
		        BaseColor.fn.init.call(this);
	
		        this.h = h;
		        this.s = s;
		        this.l = l;
		        this.a = a;
		    },
	
		    toRGB: function() {
		        var ref = this;
		        var h = ref.h / 360;
		        var s = ref.s / 100;
		        var l = ref.l / 100;
		        var r, g, b;
	
		        if (s === 0) {
		            r = g = b = l; // achromatic
		        } else {
		            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		            var p = 2 * l - q;
		            r = hue2rgb(p, q, h + 1 / 3);
		            g = hue2rgb(p, q, h);
		            b = hue2rgb(p, q, h - 1 / 3);
		        }
	
		        return new RGB(r, g, b, this.a);
		    },
	
		    toHSV: function() {
		        return this.toRGB().toHSV();
		    },
	
		    toBytes: function() {
		        return this.toRGB().toBytes();
		    }
		});
	
		function hue2rgb(p, q, s) {
		    var t = s;
	
		    if (t < 0) {
		        t += 1;
		    }
	
		    if (t > 1) {
		        t -= 1;
		    }
	
		    if (t < 1 / 6) {
		        return p + (q - p) * 6 * t;
		    }
	
		    if (t < 1 / 2) {
		        return q;
		    }
	
		    if (t < 2 / 3) {
		        return p + (q - p) * (2 / 3 - t) * 6;
		    }
	
		    return p;
		}
	
		function parseColor(value, safe) {
		    var m, ret;
	
		    if (value == null || value === "none") {
		        return null;
		    }
	
		    if (value instanceof BaseColor) {
		        return value;
		    }
	
		    var color = value.toLowerCase();
		    if ((m = matchNamedColor(color))) {
		        if (m[1] === "transparent") {
		            color = new RGB(1, 1, 1, 0);
		        } else {
		            color = parseColor(namedColors[m[1]], safe);
		        }
		        color.match = [ m[1] ];
		        return color;
		    }
		    if ((m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(color))) {
		        ret = new Bytes(parseInt(m[1], 16),
		                        parseInt(m[2], 16),
		                        parseInt(m[3], 16), 1);
		    } else if ((m = /^#?([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(color))) {
		        ret = new Bytes(parseInt(m[1] + m[1], 16),
		                        parseInt(m[2] + m[2], 16),
		                        parseInt(m[3] + m[3], 16), 1);
		    } else if ((m = /^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/.exec(color))) {
		        ret = new Bytes(parseInt(m[1], 10),
		                        parseInt(m[2], 10),
		                        parseInt(m[3], 10), 1);
		    } else if ((m = /^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
		        ret = new Bytes(parseInt(m[1], 10),
		                        parseInt(m[2], 10),
		                        parseInt(m[3], 10), parseFloat(m[4]));
		    } else if ((m = /^rgb\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*\)/.exec(color))) {
		        ret = new RGB(parseFloat(m[1]) / 100,
		                      parseFloat(m[2]) / 100,
		                      parseFloat(m[3]) / 100, 1);
		    } else if ((m = /^rgba\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
		        ret = new RGB(parseFloat(m[1]) / 100,
		                      parseFloat(m[2]) / 100,
		                      parseFloat(m[3]) / 100, parseFloat(m[4]));
		    }
	
		    if (ret) {
		        ret.match = m;
		    } else if (!safe) {
		        throw new Error("Cannot parse color: " + color);
		    }
	
		    return ret;
		}
	
		var Color = Class.extend({
		    init: function(value) {
		        var this$1 = this;
	
		        if (arguments.length === 1) {
		            var formats = Color.formats;
		            var resolvedColor = this.resolveColor(value);
	
		            for (var idx = 0; idx < formats.length; idx++) {
		                var formatRegex = formats[idx].re;
		                var processor = formats[idx].process;
		                var parts = formatRegex.exec(resolvedColor);
	
		                if (parts) {
		                    var channels = processor(parts);
		                    this$1.r = channels[0];
		                    this$1.g = channels[1];
		                    this$1.b = channels[2];
		                }
		            }
		        } else {
		            this.r = arguments[0];
		            this.g = arguments[1];
		            this.b = arguments[2];
		        }
	
		        this.r = this.normalizeByte(this.r);
		        this.g = this.normalizeByte(this.g);
		        this.b = this.normalizeByte(this.b);
		    },
	
		    toHex: function() {
		        var pad = this.padDigit;
		        var r = this.r.toString(16);
		        var g = this.g.toString(16);
		        var b = this.b.toString(16);
	
		        return "#" + pad(r) + pad(g) + pad(b);
		    },
	
		    resolveColor: function(value) {
		        var color = value || "black";
	
		        if (color.charAt(0) === "#") {
		            color = color.substr(1, 6);
		        }
	
		        color = color.replace(/ /g, "");
		        color = color.toLowerCase();
		        color = Color.namedColors[color] || color;
	
		        return color;
		    },
	
		    normalizeByte: function(value) {
		        if (value < 0 || isNaN(value)) {
		            return 0;
		        }
	
		        return value > 255 ? 255 : value;
		    },
	
		    padDigit: function(value) {
		        return (value.length === 1) ? "0" + value : value;
		    },
	
		    brightness: function(value) {
		        var round = Math.round;
	
		        this.r = round(this.normalizeByte(this.r * value));
		        this.g = round(this.normalizeByte(this.g * value));
		        this.b = round(this.normalizeByte(this.b * value));
	
		        return this;
		    },
	
		    percBrightness: function() {
		        return Math.sqrt(0.241 * this.r * this.r + 0.691 * this.g * this.g + 0.068 * this.b * this.b);
		    }
		});
	
		Color.fromBytes = function(r, g, b, a) {
		    return new Bytes(r, g, b, a != null ? a : 1);
		};
	
		Color.fromRGB = function(r, g, b, a) {
		    return new RGB(r, g, b, a != null ? a : 1);
		};
	
		Color.fromHSV = function(h, s, v, a) {
		    return new HSV(h, s, v, a != null ? a : 1);
		};
	
		Color.fromHSL = function(h, s, l, a) {
		    return new HSL(h, s, l, a != null ? a : 1);
		};
	
		Color.formats = [ {
		    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
		    process: function(parts) {
		        return [
		            parseInt(parts[1], 10), parseInt(parts[2], 10), parseInt(parts[3], 10)
		        ];
		    }
		}, {
		    re: /^(\w{2})(\w{2})(\w{2})$/,
		    process: function(parts) {
		        return [
		            parseInt(parts[1], 16), parseInt(parts[2], 16), parseInt(parts[3], 16)
		        ];
		    }
		}, {
		    re: /^(\w{1})(\w{1})(\w{1})$/,
		    process: function(parts) {
		        return [
		            parseInt(parts[1] + parts[1], 16),
		            parseInt(parts[2] + parts[2], 16),
		            parseInt(parts[3] + parts[3], 16)
		        ];
		    }
		} ];
	
		Color.namedColors = namedColors;
	
		kendo.deepExtend(kendo, {
		    parseColor: parseColor,
		    Color: Color
		});
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1515);
		module.exports = __webpack_require__(1515);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1515:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(19)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		window.kendo.util = window.kendo.util || {};
	
		var LRUCache = kendo.Class.extend({
		    init: function(size) {
	
		        this._size = size;
		        this._length = 0;
		        this._map = {};
		    },
	
		    put: function(key, value) {
		        var map = this._map;
		        var entry = { key: key, value: value };
	
		        map[key] = entry;
	
		        if (!this._head) {
		            this._head = this._tail = entry;
		        } else {
		            this._tail.newer = entry;
		            entry.older = this._tail;
		            this._tail = entry;
		        }
	
		        if (this._length >= this._size) {
		            map[this._head.key] = null;
		            this._head = this._head.newer;
		            this._head.older = null;
		        } else {
		            this._length++;
		        }
		    },
	
		    get: function(key) {
		        var entry = this._map[key];
	
		        if (entry) {
		            if (entry === this._head && entry !== this._tail) {
		                this._head = entry.newer;
		                this._head.older = null;
		            }
	
		            if (entry !== this._tail) {
		                if (entry.older) {
		                    entry.older.newer = entry.newer;
		                    entry.newer.older = entry.older;
		                }
	
		                entry.older = this._tail;
		                entry.newer = null;
	
		                this._tail.newer = entry;
		                this._tail = entry;
		            }
	
		            return entry.value;
		        }
		    }
		});
	
		var REPLACE_REGEX = /\r?\n|\r|\t/g;
		var SPACE = ' ';
	
		function normalizeText(text) {
		    return String(text).replace(REPLACE_REGEX, SPACE);
		}
	
		function objectKey(object) {
		    var parts = [];
		    for (var key in object) {
		        parts.push(key + object[key]);
		    }
	
		    return parts.sort().join("");
		}
	
		// Computes FNV-1 hash
		// See http://en.wikipedia.org/wiki/Fowler%E2%80%93Noll%E2%80%93Vo_hash_function
		function hashKey(str) {
		    // 32-bit FNV-1 offset basis
		    // See http://isthe.com/chongo/tech/comp/fnv/#FNV-param
		    var hash = 0x811C9DC5;
	
		    for (var i = 0; i < str.length; ++i) {
		        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
		        hash ^= str.charCodeAt(i);
		    }
	
		    return hash >>> 0;
		}
	
		function zeroSize() {
		    return { width: 0, height: 0, baseline: 0 };
		}
	
		var DEFAULT_OPTIONS = {
		    baselineMarkerSize: 1
		};
	
		var defaultMeasureBox;
	
		if (typeof document !== "undefined") {
		    defaultMeasureBox = document.createElement("div");
		    defaultMeasureBox.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;" +
		              "padding: 0 !important; margin: 0 !important; border: 0 !important;" +
		              "line-height: normal !important; visibility: hidden !important; white-space: pre!important;";
		}
	
		var TextMetrics = kendo.Class.extend({
		    init: function(options) {
	
		        this._cache = new LRUCache(1000);
		        this.options = $.extend({}, DEFAULT_OPTIONS, options);
		    },
	
		    measure: function(text, style, options) {
		        if (options === void 0) { options = {}; }
	
		        if (!text) {
		            return zeroSize();
		        }
	
		        var styleKey = objectKey(style);
		        var cacheKey = hashKey(text + styleKey);
		        var cachedResult = this._cache.get(cacheKey);
	
		        if (cachedResult) {
		            return cachedResult;
		        }
	
		        var size = zeroSize();
		        var measureBox = options.box || defaultMeasureBox;
		        var baselineMarker = this._baselineMarker().cloneNode(false);
	
		        for (var key in style) {
		            var value = style[key];
		            if (typeof value !== "undefined") {
		                measureBox.style[key] = value;
		            }
		        }
	
		        var textStr = options.normalizeText !== false ? normalizeText(text) : String(text);
	
		        measureBox.textContent = textStr;
		        measureBox.appendChild(baselineMarker);
		        document.body.appendChild(measureBox);
	
		        if (textStr.length) {
		            size.width = measureBox.offsetWidth - this.options.baselineMarkerSize;
		            size.height = measureBox.offsetHeight;
		            size.baseline = baselineMarker.offsetTop + this.options.baselineMarkerSize;
		        }
	
		        if (size.width > 0 && size.height > 0) {
		            this._cache.put(cacheKey, size);
		        }
	
		        measureBox.parentNode.removeChild(measureBox);
	
		        return size;
		    },
	
		    _baselineMarker: function() {
		        var marker = document.createElement("div");
		        marker.style.cssText = "display: inline-block; vertical-align: baseline;width: " +
		            this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;";
	
		        return marker;
		    }
		});
	
		TextMetrics.current = new TextMetrics();
	
		function measureText(text, style, measureBox) {
		    return TextMetrics.current.measure(text, style, measureBox);
		}
	
		kendo.deepExtend(kendo.util, {
		    LRUCache: LRUCache,
		    TextMetrics: TextMetrics,
		    measureText: measureText,
		    objectKey: objectKey,
		    hashKey: hashKey,
		    normalizeText: normalizeText
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(927);
		module.exports = __webpack_require__(927);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 920:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(553);
	
	/***/ }),
	
	/***/ 927:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(928), __webpack_require__(920) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		    var NS = ".kendo";
		    var kendo = window.kendo;
		    var deepExtend = kendo.deepExtend;
		    var utils = kendo.drawing.util;
		    var defined = utils.defined;
		    var limitValue = utils.limitValue;
		    var eventCoordinates = utils.eventCoordinates;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
		    var proxy = $.proxy;
	
		    var TOOLTIP_TEMPLATE = '<div class="k-tooltip">' +
		            '<div class="k-tooltip-content"></div>' +
		        '</div>';
		    var TOOLTIP_CLOSE_TEMPLATE = '<div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close">close</a></div>';
	
		    var SurfaceTooltip = kendo.Class.extend({
		        init: function(surface, options) {
		            this.element = $(TOOLTIP_TEMPLATE);
		            this.content = this.element.children(".k-tooltip-content");
	
		            options = options || {};
	
		            this.options = deepExtend({}, this.options, this._tooltipOptions(options));
		            this.popupOptions = {
		                appendTo: options.appendTo,
		                animation: options.animation,
		                copyAnchorStyles: false,
		                collision: "fit fit"
		            };
	
		            this._openPopupHandler = $.proxy(this._openPopup, this);
	
		            this.surface = surface;
		            this._bindEvents();
		        },
	
		        options: {
		            position: "top",
		            showOn: "mouseenter",
		            offset: 7,
		            autoHide: true,
		            hideDelay: 0,
		            showAfter: 100
		        },
	
		        _bindEvents: function() {
		            this._showHandler = proxy(this._showEvent, this);
		            this._surfaceLeaveHandler = proxy(this._surfaceLeave, this);
		            this._mouseleaveHandler = proxy(this._mouseleave, this);
		            this._mousemoveHandler = proxy(this._mousemove, this);
	
		            this.surface.bind("click", this._showHandler);
		            this.surface.bind("mouseenter", this._showHandler);
		            this.surface.bind("mouseleave", this._mouseleaveHandler);
		            this.surface.bind("mousemove", this._mousemoveHandler);
	
		            this.surface.element.on("mouseleave" + NS, this._surfaceLeaveHandler);
	
		            this.element.on("click" + NS, ".k-tooltip-button", proxy(this._hideClick, this));
		        },
	
		        getPopup: function() {
		            if (!this.popup) {
		                this.popup = new kendo.ui.Popup(this.element, this.popupOptions);
		            }
	
		            return this.popup;
		        },
	
		        destroy: function() {
		            var popup = this.popup;
	
		            this.surface.unbind("click", this._showHandler);
		            this.surface.unbind("mouseenter", this._showHandler);
		            this.surface.unbind("mouseleave", this._mouseleaveHandler);
		            this.surface.unbind("mousemove", this._mousemoveHandler);
	
		            this.surface.element.off("mouseleave" + NS, this._surfaceLeaveHandler);
		            this.element.off("click" + NS);
	
		            if (popup) {
		                popup.destroy();
		                delete this.popup;
		            }
		            delete this.popupOptions;
	
		            clearTimeout(this._timeout);
	
		            delete this.element;
		            delete this.content;
		            delete this.surface;
		        },
	
		        _tooltipOptions: function(options) {
		            options = options || {};
		            return {
		                position: options.position,
		                showOn: options.showOn,
		                offset: options.offset,
		                autoHide: options.autoHide,
		                width: options.width,
		                height: options.height,
		                content: options.content,
		                shared: options.shared,
		                hideDelay: options.hideDelay,
		                showAfter: options.showAfter
		            };
		        },
	
		        _tooltipShape: function(shape) {
		            while(shape && !shape.options.tooltip) {
		                shape = shape.parent;
		            }
		            return shape;
		        },
	
		        _updateContent: function(target, shape, options) {
		            var content = options.content;
		            if (kendo.isFunction(content)) {
		                content = content({
		                    element: shape,
		                    target: target
		                });
		            }
	
		            if (content) {
		                this.content.html(content);
		                return true;
		            }
		        },
	
		        _position: function(shape, options, elementSize, event) {
		            var position = options.position;
		            var tooltipOffset = options.offset || 0;
		            var surface = this.surface;
		            var offset = surface._instance._elementOffset();
		            var size = surface.getSize();
		            var surfaceOffset = surface._instance._offset;
		            var bbox = shape.bbox();
		            var width = elementSize.width;
		            var height = elementSize.height;
		            var left = 0, top = 0;
	
		            bbox.origin.translate(offset.left, offset.top);
		            if (surfaceOffset) {
		                bbox.origin.translate(-surfaceOffset.x, -surfaceOffset.y);
		            }
	
		            if (position == "cursor" && event) {
		                var coord = eventCoordinates(event);
		                left = coord.x - width / 2;
		                top = coord.y - height - tooltipOffset;
		            } else if (position == "left") {
		                left = bbox.origin.x - width - tooltipOffset;
		                top = bbox.center().y - height / 2;
		            } else if (position == "right") {
		                left = bbox.bottomRight().x + tooltipOffset;
		                top = bbox.center().y - height / 2;
		            } else if (position == "bottom") {
		                left = bbox.center().x - width / 2;
		                top = bbox.bottomRight().y + tooltipOffset;
		            } else {
		                left = bbox.center().x - width / 2;
		                top = bbox.origin.y - height - tooltipOffset;
		            }
	
		            return {
		                left: limitValue(left, offset.left, offset.left + size.width),
		                top: limitValue(top, offset.top, offset.top + size.height)
		            };
		        },
	
		        show: function(shape, options) {
		            this._show(shape, shape, deepExtend({}, this.options, this._tooltipOptions(shape.options.tooltip), options));
		        },
	
		        hide: function() {
		            var popup = this.popup;
		            var current = this._current;
		            delete this._current;
		            clearTimeout(this._showTimeout);
		            if (popup && popup.visible() && current &&
		                !this.surface.trigger("tooltipClose", { element: current.shape, target: current.target, popup: popup})) {
		                popup.close();
		            }
		        },
	
		        _hideClick: function(e) {
		            e.preventDefault();
		            this.hide();
		        },
	
		        _show: function(target, shape, options, event, delay) {
		            var current = this._current;
	
		            clearTimeout(this._timeout);
	
		            if (current && ((current.shape === shape && options.shared) || current.target === target)) {
		                return;
		            }
	
		            clearTimeout(this._showTimeout);
	
		            var popup = this.getPopup();
	
		            if (!this.surface.trigger("tooltipOpen", { element: shape, target: target, popup: popup }) &&
		                this._updateContent(target, shape, options)) {
	
		                this._autoHide(options);
		                var elementSize = this._measure(options);
	
		                if (popup.visible()) {
		                    popup.close(true);
		                }
	
		                this._current = {
		                    options: options,
		                    elementSize: elementSize,
		                    shape: shape,
		                    target: target,
		                    position: this._position(options.shared ? shape: target, options, elementSize, event)
		                };
	
		                if (delay) {
		                    this._showTimeout = setTimeout(this._openPopupHandler, options.showAfter || 0);
		                } else {
		                    this._openPopup();
		                }
		            }
		        },
	
		        _openPopup: function() {
		            var current = this._current;
		            var position = current.position;
	
		            this.getPopup().open(position.left, position.top);
		        },
	
		        _autoHide: function(options) {
		            if (options.autoHide && this._closeButton) {
		                this.element.removeClass("k-tooltip-closable");
		                this._closeButton.remove();
		                delete this._closeButton;
		            }
	
		            if (!options.autoHide && !this._closeButton) {
		                this.element.addClass("k-tooltip-closable");
		                this._closeButton = $(TOOLTIP_CLOSE_TEMPLATE).prependTo(this.element);
		            }
		        },
	
		        _showEvent: function(e) {
		            var shape = this._tooltipShape(e.element);
		            if (shape) {
		                var options = deepExtend({}, this.options, this._tooltipOptions(shape.options.tooltip));
	
		                if (options && options.showOn == e.type) {
		                    this._show(e.element, shape, options, e.originalEvent, true);
		                }
		            }
		        },
	
		        _measure: function(options) {
		            var popup = this.getPopup();
		            var width, height;
		            this.element.css({
		                width: "auto",
		                height: "auto"
		            });
		            var visible = popup.visible();
		            if (!visible) {
		                popup.wrapper.show();
		            }
	
		            this.element.css({
		                width: defined(options.width) ? options.width : "auto",
		                height: defined(options.height) ? options.height : "auto"
		            });
	
		            width = outerWidth(this.element);
		            height = outerHeight(this.element);
	
		            if (!visible) {
		                popup.wrapper.hide();
		            }
	
		            return {
		                width: width,
		                height: height
		            };
		        },
	
		        _mouseleave: function(e) {
		            if (this.popup && !this._popupRelatedTarget(e.originalEvent)) {
		                var tooltip = this;
		                var current = tooltip._current;
	
		                if (current && current.options.autoHide) {
		                    tooltip._timeout = setTimeout(function() {
		                        clearTimeout(tooltip._showTimeout);
		                        tooltip.hide();
		                    }, current.options.hideDelay || 0);
		                }
		            }
		        },
	
		        _mousemove: function(e) {
		            var current = this._current;
		            if (current && e.element) {
		                var options = current.options;
		                if (options.position == "cursor") {
		                    var position = this._position(e.element, options, current.elementSize, e.originalEvent);
		                    current.position = position;
		                    this.getPopup().wrapper.css({left: position.left, top: position.top});
		                }
		            }
		        },
	
		        _surfaceLeave: function(e) {
		            if (this.popup && !this._popupRelatedTarget(e)) {
		                clearTimeout(this._showTimeout);
		                this.hide();
		            }
		        },
	
		        _popupRelatedTarget: function(e) {
		            return e.relatedTarget && $(e.relatedTarget).closest(this.popup.wrapper).length;
		        }
		    });
	
		    kendo.drawing.SurfaceTooltip = SurfaceTooltip;
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 928:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1269);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1269:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "popup",
		    name: "Pop-up",
		    category: "framework",
		    depends: [ "core" ],
		    advanced: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        Class = kendo.Class,
		        support = kendo.support,
		        getOffset = kendo.getOffset,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        OPEN = "open",
		        CLOSE = "close",
		        DEACTIVATE = "deactivate",
		        ACTIVATE = "activate",
		        CENTER = "center",
		        LEFT = "left",
		        RIGHT = "right",
		        TOP = "top",
		        BOTTOM = "bottom",
		        ABSOLUTE = "absolute",
		        HIDDEN = "hidden",
		        BODY = "body",
		        LOCATION = "location",
		        POSITION = "position",
		        VISIBLE = "visible",
		        EFFECTS = "effects",
		        ACTIVE = "k-state-active",
		        ACTIVEBORDER = "k-state-border",
		        ACTIVEBORDERREGEXP = /k-state-border-(\w+)/,
		        ACTIVECHILDREN = ".k-picker-wrap, .k-dropdown-wrap, .k-link",
		        MOUSEDOWN = "down",
		        DOCUMENT_ELEMENT = $(document.documentElement),
		        proxy = $.proxy,
		        WINDOW = $(window),
		        SCROLL = "scroll",
		        cssPrefix = support.transitions.css,
		        TRANSFORM = cssPrefix + "transform",
		        extend = $.extend,
		        NS = ".kendoPopup",
		        styles = ["font-size",
		                  "font-family",
		                  "font-stretch",
		                  "font-style",
		                  "font-weight",
		                  "line-height"];
	
		    function contains(container, target) {
		        if (!container || !target) {
		            return false;
		        }
		        return container === target || $.contains(container, target);
		    }
	
		    var Popup = Widget.extend({
		        init: function(element, options) {
		            var that = this, parentPopup;
	
		            options = options || {};
	
		            if (options.isRtl) {
		                options.origin = options.origin || BOTTOM + " " + RIGHT;
		                options.position = options.position || TOP + " " + RIGHT;
		            }
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element;
		            options = that.options;
	
		            that.collisions = options.collision ? options.collision.split(" ") : [];
		            that.downEvent = kendo.applyEventMap(MOUSEDOWN, kendo.guid());
	
		            if (that.collisions.length === 1) {
		                that.collisions.push(that.collisions[0]);
		            }
	
		            parentPopup = $(that.options.anchor).closest(".k-popup,.k-group").filter(":not([class^=km-])"); // When popup is in another popup, make it relative.
	
		            options.appendTo = $($(options.appendTo)[0] || parentPopup[0] || document.body);
	
		            that.element.hide()
		                .addClass("k-popup k-group k-reset")
		                .toggleClass("k-rtl", !!options.isRtl)
		                .css({ position : ABSOLUTE })
		                .appendTo(options.appendTo)
		                .attr("aria-hidden", true)
		                .on("mouseenter" + NS, function() {
		                    that._hovered = true;
		                })
		                .on("wheel" + NS, function(e) {
		                    var list = $(e.target).find(".k-list");
		                    var scrollArea = list.parent();
		                    if (list.length && list.is(":visible") && ((scrollArea.scrollTop() === 0 && e.originalEvent.deltaY < 0) ||
		                        (scrollArea.scrollTop() === scrollArea.prop('scrollHeight') - scrollArea.prop('offsetHeight') && e.originalEvent.deltaY > 0))) {
		                           e.preventDefault();
		                    }
		                })
		                .on("mouseleave" + NS, function() {
		                    that._hovered = false;
		                });
	
		            that.wrapper = $();
	
		            if (options.animation === false) {
		                options.animation = { open: { effects: {} }, close: { hide: true, effects: {} } };
		            }
	
		            extend(options.animation.open, {
		                complete: function() {
		                    that.wrapper.css({ overflow: VISIBLE }); // Forcing refresh causes flickering in mobile.
		                    that._activated = true;
		                    that._trigger(ACTIVATE);
		                }
		            });
	
		            extend(options.animation.close, {
		                complete: function() {
		                    that._animationClose();
		                }
		            });
	
		            that._mousedownProxy = function(e) {
		                that._mousedown(e);
		            };
	
		            if (support.mobileOS.android) {
		                that._resizeProxy = function(e) {
		                    setTimeout(function() {
		                        that._resize(e);
		                    }, 600); //Logic from kendo.onResize
		                };
		            } else {
		                that._resizeProxy = function(e) {
		                    that._resize(e);
		                };
		            }
	
		            if (options.toggleTarget) {
		                $(options.toggleTarget).on(options.toggleEvent + NS, $.proxy(that.toggle, that));
		            }
		        },
	
		        events: [
		            OPEN,
		            ACTIVATE,
		            CLOSE,
		            DEACTIVATE
		        ],
	
		        options: {
		            name: "Popup",
		            toggleEvent: "click",
		            origin: BOTTOM + " " + LEFT,
		            position: TOP + " " + LEFT,
		            anchor: BODY,
		            appendTo: null,
		            collision: "flip fit",
		            viewport: window,
		            copyAnchorStyles: true,
		            autosize: false,
		            modal: false,
		            adjustSize: {
		                width: 0,
		                height: 0
		            },
		            animation: {
		                open: {
		                    effects: "slideIn:down",
		                    transition: true,
		                    duration: 200
		                },
		                close: { // if close animation effects are defined, they will be used instead of open.reverse
		                    duration: 100,
		                    hide: true
		                }
		            }
		        },
	
		        _animationClose: function() {
		            var that = this;
		            var location = that.wrapper.data(LOCATION);
	
		            that.wrapper.hide();
	
		            if (location) {
		                that.wrapper.css(location);
		            }
	
		            if (that.options.anchor != BODY) {
		                that._hideDirClass();
		            }
	
		            that._closing = false;
		            that._trigger(DEACTIVATE);
		        },
	
		        destroy: function() {
		            var that = this,
		                options = that.options,
		                element = that.element.off(NS),
		                parent;
	
		            Widget.fn.destroy.call(that);
	
		            if (options.toggleTarget) {
		                $(options.toggleTarget).off(NS);
		            }
	
		            if (!options.modal) {
		                DOCUMENT_ELEMENT.unbind(that.downEvent, that._mousedownProxy);
		                that._toggleResize(false);
		            }
	
		            kendo.destroy(that.element.children());
		            element.removeData();
	
		            if (options.appendTo[0] === document.body) {
		                parent = element.parent(".k-animation-container");
	
		                if (parent[0]) {
		                    parent.remove();
		                } else {
		                    element.remove();
		                }
		            }
		        },
	
		        open: function(x, y) {
		            var that = this,
		                fixed = { isFixed: !isNaN(parseInt(y,10)), x: x, y: y },
		                element = that.element,
		                options = that.options,
		                animation, wrapper,
		                anchor = $(options.anchor),
		                mobile = element[0] && element.hasClass("km-widget");
	
		            if (!that.visible()) {
		                if (options.copyAnchorStyles) {
		                    if (mobile && styles[0] == "font-size") {
		                        styles.shift();
		                    }
		                    element.css(kendo.getComputedStyles(anchor[0], styles));
		                }
	
		                if (element.data("animating") || that._trigger(OPEN)) {
		                    return;
		                }
	
		                that._activated = false;
	
		                if (!options.modal) {
		                    DOCUMENT_ELEMENT.unbind(that.downEvent, that._mousedownProxy)
		                                .bind(that.downEvent, that._mousedownProxy);
	
		                    // this binding hangs iOS in editor
		                    // all elements in IE7/8 fire resize event, causing mayhem
		                    that._toggleResize(false);
		                    that._toggleResize(true);
		                }
	
		                that.wrapper = wrapper = kendo.wrap(element, options.autosize)
		                                        .css({
		                                            overflow: HIDDEN,
		                                            display: "block",
		                                            position: ABSOLUTE
		                                        })
		                                        .attr("aria-hidden", false);
	
		                if (support.mobileOS.android) {
		                    wrapper.css(TRANSFORM, "translatez(0)"); // Android is VERY slow otherwise. Should be tested in other droids as well since it may cause blur.
		                }
	
		                wrapper.css(POSITION);
	
		                if ($(options.appendTo)[0] == document.body) {
		                    wrapper.css(TOP, "-10000px");
		                }
	
		                that.flipped = that._position(fixed);
		                animation = that._openAnimation();
	
		                if (options.anchor != BODY) {
		                    that._showDirClass(animation);
		                }
	
		                element.data(EFFECTS, animation.effects)
		                       .kendoStop(true)
		                       .kendoAnimate(animation)
		                       .attr("aria-hidden", false);
		            }
		        },
	
		        _location: function(isFixed) {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                wrapper,
		                anchor = $(options.anchor),
		                mobile = element[0] && element.hasClass("km-widget");
	
		            if (options.copyAnchorStyles) {
		                if (mobile && styles[0] == "font-size") {
		                    styles.shift();
		                }
		                element.css(kendo.getComputedStyles(anchor[0], styles));
		            }
	
		            that.wrapper = wrapper = kendo.wrap(element, options.autosize)
		                                    .css({
		                                        overflow: HIDDEN,
		                                        display: "block",
		                                        position: ABSOLUTE
		                                    });
	
		            if (support.mobileOS.android) {
		                wrapper.css(TRANSFORM, "translatez(0)"); // Android is VERY slow otherwise. Should be tested in other droids as well since it may cause blur.
		            }
	
		            wrapper.css(POSITION);
	
		            if ($(options.appendTo)[0] == document.body) {
		                wrapper.css(TOP, "-10000px");
		            }
	
		            that._position(isFixed || {});
	
		            var offset = wrapper.offset();
		            return {
		                width: kendo._outerWidth(wrapper),
		                height: kendo._outerHeight(wrapper),
		                left: offset.left,
		                top: offset.top
		            };
		        },
	
		        _openAnimation: function() {
		            var animation = extend(true, {}, this.options.animation.open);
		            animation.effects = kendo.parseEffects(animation.effects, this.flipped);
	
		            return animation;
		        },
	
		        _hideDirClass: function() {
		            var anchor = $(this.options.anchor);
		            var direction = ((anchor.attr("class") || "").match(ACTIVEBORDERREGEXP) || ["", "down"])[1];
		            var dirClass = ACTIVEBORDER + "-" + direction;
	
		            anchor
		                .removeClass(dirClass)
		                .children(ACTIVECHILDREN)
		                .removeClass(ACTIVE)
		                .removeClass(dirClass);
	
		            this.element.removeClass(ACTIVEBORDER + "-" + kendo.directions[direction].reverse);
		        },
	
		        _showDirClass: function(animation) {
		            var direction = animation.effects.slideIn ? animation.effects.slideIn.direction : "down";
		            var dirClass = ACTIVEBORDER + "-" + direction;
	
		            $(this.options.anchor)
		                .addClass(dirClass)
		                .children(ACTIVECHILDREN)
		                .addClass(ACTIVE)
		                .addClass(dirClass);
	
		            this.element.addClass(ACTIVEBORDER + "-" + kendo.directions[direction].reverse);
		        },
	
		        position: function() {
		            if (this.visible()) {
		                this.flipped = this._position();
		                //this._hideDirClass();
		                //this._showDirClass(this._openAnimation());
		            }
		        },
	
		        toggle: function() {
		            var that = this;
	
		            that[that.visible() ? CLOSE : OPEN]();
		        },
	
		        visible: function() {
		            return this.element.is(":" + VISIBLE);
		        },
	
		        close: function(skipEffects) {
		            var that = this,
		                options = that.options, wrap,
		                animation, openEffects, closeEffects;
	
		            if (that.visible()) {
		                wrap = (that.wrapper[0] ? that.wrapper : kendo.wrap(that.element).hide());
	
		                that._toggleResize(false);
	
		                if (that._closing || that._trigger(CLOSE)) {
		                    that._toggleResize(true);
		                    return;
		                }
	
		                // Close all inclusive popups.
		                that.element.find(".k-popup").each(function () {
		                    var that = $(this),
		                        popup = that.data("kendoPopup");
	
		                    if (popup) {
		                        popup.close(skipEffects);
		                    }
		                });
	
		                DOCUMENT_ELEMENT.unbind(that.downEvent, that._mousedownProxy);
	
		                if (skipEffects) {
		                    animation = { hide: true, effects: {} };
		                } else {
		                    animation = extend(true, {}, options.animation.close);
		                    openEffects = that.element.data(EFFECTS);
		                    closeEffects = animation.effects;
	
		                    if (!closeEffects && !kendo.size(closeEffects) && openEffects && kendo.size(openEffects)) {
		                        animation.effects = openEffects;
		                        animation.reverse = true;
		                    }
	
		                    that._closing = true;
		                }
	
		                that.element
		                        .kendoStop(true)
		                        .attr("aria-hidden", true);
		                wrap
		                    .css({ overflow: HIDDEN }) // stop callback will remove hidden overflow
		                    .attr("aria-hidden", true);
		                that.element.kendoAnimate(animation);
	
		                if (skipEffects) {
		                    that._animationClose();
		                }
		            }
		        },
	
		        _trigger: function(ev) {
		            return this.trigger(ev, { type: ev });
		        },
	
		        _resize: function(e) {
		            var that = this;
	
		            if (support.resize.indexOf(e.type) !== -1) {
		                clearTimeout(that._resizeTimeout);
		                that._resizeTimeout = setTimeout(function() {
		                    that._position();
		                    that._resizeTimeout = null;
		                }, 50);
		            } else {
		                if (!that._hovered || (that._activated && that.element.hasClass("k-list-container"))) {
		                    that.close();
		                }
		            }
		        },
	
		        _toggleResize: function(toggle) {
		            var method = toggle ? "on" : "off";
		            var eventNames = support.resize;
	
		            if (!(support.mobileOS.ios || support.mobileOS.android)) {
		                eventNames += " " + SCROLL;
		            }
	
		            this._scrollableParents()[method](SCROLL, this._resizeProxy);
		            WINDOW[method](eventNames, this._resizeProxy);
		        },
	
		        _mousedown: function(e) {
		            var that = this,
		                container = that.element[0],
		                options = that.options,
		                anchor = $(options.anchor)[0],
		                toggleTarget = options.toggleTarget,
		                target = kendo.eventTarget(e),
		                popup = $(target).closest(".k-popup"),
		                mobile = popup.parent().parent(".km-shim").length;
	
		            popup = popup[0];
		            if (!mobile && popup && popup !== that.element[0]){
		                return;
		            }
	
		            // This MAY result in popup not closing in certain cases.
		            if ($(e.target).closest("a").data("rel") === "popover") {
		                return;
		            }
	
		            if (!contains(container, target) && !contains(anchor, target) && !(toggleTarget && contains($(toggleTarget)[0], target))) {
		                that.close();
		            }
		        },
	
		        _fit: function(position, size, viewPortSize) {
		            var output = 0;
	
		            if (position + size > viewPortSize) {
		                output = viewPortSize - (position + size);
		            }
	
		            if (position < 0) {
		                output = -position;
		            }
	
		            return output;
		        },
	
		        _flip: function(offset, size, anchorSize, viewPortSize, origin, position, boxSize) {
		            var output = 0;
		                boxSize = boxSize || size;
	
		            if (position !== origin && position !== CENTER && origin !== CENTER) {
		                if (offset + boxSize > viewPortSize) {
		                    output += -(anchorSize + size);
		                }
	
		                if (offset + output < 0) {
		                    output += anchorSize + size;
		                }
		            }
		            return output;
		        },
	
		        _scrollableParents: function() {
		            return $(this.options.anchor)
		                       .parentsUntil("body")
		                       .filter(function(index, element) {
		                           return kendo.isScrollable(element);
		                       });
		        },
	
		        _position: function(fixed) {
		            var that = this,
		                //element = that.element.css(POSITION, ""), /* fixes telerik/kendo-ui-core#790, comes from telerik/kendo#615 */
		                element = that.element,
		                wrapper = that.wrapper,
		                options = that.options,
		                viewport = $(options.viewport),
		                zoomLevel = support.zoomLevel(),
		                isWindow = !!((viewport[0] == window) && window.innerWidth && (zoomLevel <= 1.02)),
		                anchor = $(options.anchor),
		                origins = options.origin.toLowerCase().split(" "),
		                positions = options.position.toLowerCase().split(" "),
		                collisions = that.collisions,
		                siblingContainer, parents,
		                parentZIndex, zIndex = 10002,
		                idx = 0,
		                docEl = document.documentElement,
		                length, viewportOffset, viewportWidth, viewportHeight;
	
		            if (options.viewport === window) {
		                viewportOffset = {
		                    top: (window.pageYOffset || document.documentElement.scrollTop || 0),
		                    left: (window.pageXOffset || document.documentElement.scrollLeft || 0)
		                };
		            } else {
		                viewportOffset = viewport.offset();
		            }
	
		            if (isWindow) {
		                viewportWidth = window.innerWidth;
		                viewportHeight = window.innerHeight;
		            } else {
		                viewportWidth = viewport.width();
		                viewportHeight = viewport.height();
		            }
	
		            if (isWindow && docEl.scrollHeight - docEl.clientHeight > 0) {
		                 var sign = options.isRtl ? -1 : 1;
	
		                 viewportWidth -= sign * kendo.support.scrollbar();
		            }
	
		            siblingContainer = anchor.parents().filter(wrapper.siblings());
	
		            if (siblingContainer[0]) {
		                parentZIndex = Math.max(Number(siblingContainer.css("zIndex")), 0);
	
		                // set z-index to be more than that of the container/sibling
		                // compensate with more units for window z-stack
		                if (parentZIndex) {
		                    zIndex = parentZIndex + 10;
		                } else {
		                    parents = anchor.parentsUntil(siblingContainer);
		                    for (length = parents.length; idx < length; idx++) {
		                        parentZIndex = Number($(parents[idx]).css("zIndex"));
		                        if (parentZIndex && zIndex < parentZIndex) {
		                            zIndex = parentZIndex + 10;
		                        }
		                    }
		                }
		            }
	
		            wrapper.css("zIndex", zIndex);
	
		            if (fixed && fixed.isFixed) {
		                wrapper.css({ left: fixed.x, top: fixed.y });
		            } else {
		                wrapper.css(that._align(origins, positions));
		            }
	
		            var pos = getOffset(wrapper, POSITION, anchor[0] === wrapper.offsetParent()[0]),
		                offset = getOffset(wrapper),
		                anchorParent = anchor.offsetParent().parent(".k-animation-container,.k-popup,.k-group"); // If the parent is positioned, get the current positions
	
		            if (anchorParent.length) {
		                pos = getOffset(wrapper, POSITION, true);
		                offset = getOffset(wrapper);
		            }
	
		            offset.top -= viewportOffset.top;
		            offset.left -= viewportOffset.left;
	
		            if (!that.wrapper.data(LOCATION)) { // Needed to reset the popup location after every closure - fixes the resize bugs.
		                wrapper.data(LOCATION, extend({}, pos));
		            }
	
		            var offsets = extend({}, offset),
		                location = extend({}, pos),
		                adjustSize = options.adjustSize;
	
		            if (collisions[0] === "fit") {
		                location.top += that._fit(offsets.top, outerHeight(wrapper) + adjustSize.height, viewportHeight / zoomLevel);
		            }
	
		            if (collisions[1] === "fit") {
		                location.left += that._fit(offsets.left, outerWidth(wrapper) + adjustSize.width, viewportWidth / zoomLevel);
		            }
	
		            var flipPos = extend({}, location);
		            var elementHeight = outerHeight(element);
		            var wrapperHeight =  outerHeight(wrapper);
	
		            if (!wrapper.height() && elementHeight) {
		                wrapperHeight = wrapperHeight + elementHeight;
		            }
	
		            if (collisions[0] === "flip") {
		                location.top += that._flip(offsets.top, elementHeight, outerHeight(anchor), viewportHeight / zoomLevel, origins[0], positions[0], wrapperHeight);
		            }
	
		            if (collisions[1] === "flip") {
		                location.left += that._flip(offsets.left, outerWidth(element), outerWidth(anchor), viewportWidth / zoomLevel, origins[1], positions[1], outerWidth(wrapper));
		            }
	
		            element.css(POSITION, ABSOLUTE);
		            wrapper.css(location);
	
		            return (location.left != flipPos.left || location.top != flipPos.top);
		        },
	
		        _align: function(origin, position) {
		            var that = this,
		                element = that.wrapper,
		                anchor = $(that.options.anchor),
		                verticalOrigin = origin[0],
		                horizontalOrigin = origin[1],
		                verticalPosition = position[0],
		                horizontalPosition = position[1],
		                anchorOffset = getOffset(anchor),
		                appendTo = $(that.options.appendTo),
		                appendToOffset,
		                width = outerWidth(element),
		                height = outerHeight(element) || outerHeight(element.children().first()),
		                anchorWidth = outerWidth(anchor),
		                anchorHeight = outerHeight(anchor),
		                top = anchorOffset.top,
		                left = anchorOffset.left,
		                round = Math.round;
	
		            if (appendTo[0] != document.body) {
		                appendToOffset = getOffset(appendTo);
		                top -= appendToOffset.top;
		                left -= appendToOffset.left;
		            }
	
	
		            if (verticalOrigin === BOTTOM) {
		                top += anchorHeight;
		            }
	
		            if (verticalOrigin === CENTER) {
		                top += round(anchorHeight / 2);
		            }
	
		            if (verticalPosition === BOTTOM) {
		                top -= height;
		            }
	
		            if (verticalPosition === CENTER) {
		                top -= round(height / 2);
		            }
	
		            if (horizontalOrigin === RIGHT) {
		                left += anchorWidth;
		            }
	
		            if (horizontalOrigin === CENTER) {
		                left += round(anchorWidth / 2);
		            }
	
		            if (horizontalPosition === RIGHT) {
		                left -= width;
		            }
	
		            if (horizontalPosition === CENTER) {
		                left -= round(width / 2);
		            }
	
		            return {
		                top: top,
		                left: left
		            };
		        }
		    });
	
		    ui.plugin(Popup);
	
		    var stableSort = kendo.support.stableSort;
		    var tabKeyTrapNS = "kendoTabKeyTrap";
		    var focusableNodesSelector = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], *[contenteditable]";
		    var TabKeyTrap = Class.extend({
		        init: function(element) {
		            this.element = $(element);
		            this.element.autoApplyNS(tabKeyTrapNS);
		        },
	
		        trap: function() {
		            this.element.on("keydown", proxy(this._keepInTrap, this));
		        },
	
		        removeTrap: function() {
		            this.element.kendoDestroy(tabKeyTrapNS);
		        },
	
		        destroy: function() {
		            this.element.kendoDestroy(tabKeyTrapNS);
		            this.element = undefined;
		        },
	
		        shouldTrap: function () {
		            return true;
		        },
	
		        _keepInTrap: function(e) {
		            if (e.which !== 9 || !this.shouldTrap() || e.isDefaultPrevented()) {
		                return;
		            }
	
		            var elements = this._focusableElements();
		            var sortedElements = this._sortFocusableElements(elements);
		            var next = this._nextFocusable(e, sortedElements);
	
		            this._focus(next);
	
		            e.preventDefault();
		        },
		        _focusableElements: function(){
		            var elements = this.element.find(focusableNodesSelector).filter(function(i, item){
		                return item.tabIndex >= 0 && $(item).is(':visible') && !$(item).is('[disabled]');
		            });
	
		            if (this.element.is("[tabindex]")) {
		                elements.push(this.element[0]);
		            }
	
		            return elements;
		        },
		        _sortFocusableElements: function(elements){
		            var sortedElements;
	
		            if (stableSort) {
		                sortedElements = elements.sort(function(prev, next) {
		                    return prev.tabIndex - next.tabIndex;
		                });
		            } else {
		                var attrName = "__k_index";
		                elements.each(function(i, item){
		                    item.setAttribute(attrName, i);
		                });
	
		                sortedElements = elements.sort(function(prev, next) {
		                    return prev.tabIndex === next.tabIndex ?
		                        parseInt(prev.getAttribute(attrName), 10) - parseInt(next.getAttribute(attrName), 10) :
		                        prev.tabIndex - next.tabIndex;
		                });
	
		                elements.removeAttr(attrName);
		            }
	
		            return sortedElements;
		        },
		        _nextFocusable: function(e, elements){
		            var count = elements.length;
		            var current = elements.index(e.target);
	
		            return elements.get((current + (e.shiftKey ? -1 : 1)) % count);
		        },
		        _focus: function(element){
		            if (element.nodeName == "IFRAME") {
		                element.contentWindow.document.body.focus();
		                return;
		            }
	
		            element.focus();
	
		            if (element.nodeName == "INPUT" && element.setSelectionRange && this._haveSelectionRange(element)) {
		                element.setSelectionRange(0, element.value.length);
		            }
		        },
		        _haveSelectionRange: function(element){
		            var elementType = element.type.toLowerCase();
	
		            return elementType === "text" || elementType === "search" ||
		            elementType === "url" || elementType === "tel" ||
		            elementType === "password";
		        }
		    });
		    ui.Popup.TabKeyTrap = TabKeyTrap;
		})(window.kendo.jQuery);
	
	
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(925);
		module.exports = __webpack_require__(925);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 920:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(553);
	
	/***/ }),
	
	/***/ 925:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(920), __webpack_require__(926) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		    var kendo = window.kendo;
		    var draw = kendo.drawing;
		    var DrawingSurface = draw.Surface;
		    var Widget = kendo.ui.Widget;
		    var deepExtend = kendo.deepExtend;
		    var proxy = $.proxy;
	
		    kendo.support.svg = DrawingSurface.support.svg;
		    kendo.support.canvas = DrawingSurface.support.canvas;
	
		    var Surface = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, {});
	
		            this.options = deepExtend({}, this.options, options);
	
		            this._instance = DrawingSurface.create(this.element[0], options);
		            if (this._instance.translate) {
		                this.translate = translate;
		            }
	
		            this._triggerInstanceHandler = proxy(this._triggerInstanceEvent, this);
		            this._bindHandler("click");
		            this._bindHandler("mouseenter");
		            this._bindHandler("mouseleave");
		            this._bindHandler("mousemove");
	
		            this._enableTracking();
		        },
	
		        options: {
		            name: "Surface",
		            tooltip: {}
		        },
	
		        events: [
		            "click",
		            "mouseenter",
		            "mouseleave",
		            "mousemove",
		            "resize",
		            "tooltipOpen",
		            "tooltipClose"
		        ],
	
		        _triggerInstanceEvent: function(e) {
		            this.trigger(e.type, e);
		        },
	
		        _bindHandler: function(event) {
		            this._instance.bind(event, this._triggerInstanceHandler);
		        },
	
		        draw: function(element) {
		            this._instance.draw(element);
		        },
	
		        clear: function() {
		            if (this._instance) {
		                this._instance.clear();
		            }
		            this.hideTooltip();
		        },
	
		        destroy: function() {
		            if (this._instance) {
		                this._instance.destroy();
		                delete this._instance;
		            }
	
		            if (this._tooltip) {
		                this._tooltip.destroy();
		                delete this._tooltip;
		            }
	
		            Widget.fn.destroy.call(this);
		        },
	
		        exportVisual: function() {
		            return this._instance.exportVisual();
		        },
	
		        eventTarget: function(e) {
		            return this._instance.eventTarget(e);
		        },
	
		        showTooltip: function(shape, options) {
		            if (this._tooltip) {
		                this._tooltip.show(shape, options);
		            }
		        },
	
		        hideTooltip: function() {
		            if (this._tooltip) {
		                this._tooltip.hide();
		            }
		        },
	
		        suspendTracking: function() {
		            this._instance.suspendTracking();
		            this.hideTooltip();
		        },
	
		        resumeTracking: function() {
		            this._instance.resumeTracking();
		        },
	
		        getSize: function() {
		            return {
		                width: this.element.width(),
		                height: this.element.height()
		            };
		        },
	
		        setSize: function(size) {
		            this.element.css({
		                width: size.width,
		                height: size.height
		            });
	
		            this._size = size;
		            this._instance.currentSize(size);
		            this._resize();
		        },
	
		        _resize: function() {
		            this._instance.currentSize(this._size);
		            this._instance._resize();
		        },
	
		        _enableTracking: function() {
		            if (kendo.ui.Popup) {
		                this._tooltip = new draw.SurfaceTooltip(this, this.options.tooltip || {});
		            }
		        }
		    });
	
		    kendo.ui.plugin(Surface);
	
		    Surface.create = function(element, options) {
		        return new Surface(element, options);
		    };
	
		    kendo.drawing.Surface = Surface;
	
		    function translate(offset) {
		        this._instance.translate(offset);
		    }
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 926:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(556);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(919);
		module.exports = __webpack_require__(919);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 919:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(920) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
		    
		    var kendo = window.kendo;
		    var drawing = kendo.drawing;
		    var drawDOM = drawing.drawDOM;
	
		    drawing.drawDOM = function(element, options) {
		        return drawDOM($(element)[0], options);
		    };
	
		    drawing.drawDOM.drawText = drawDOM.drawText;
		    drawing.drawDOM.getFontFaces = drawDOM.getFontFaces;
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 920:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(553);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1122);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1122:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dom",
		    name: "Virtual DOM",
		    category: "framework",
		    depends: [ "core" ],
		    advanced: true
		};
	
		(function(kendo) {
		    function Node() {
		        this.node = null;
		    }
	
		    Node.prototype = {
		        remove: function() {
		            if (this.node.parentNode) {
		                this.node.parentNode.removeChild(this.node);
		            }
		            this.attr = {};
		        },
		        attr: {},
		        text: function() {
		            return "";
		        }
		    };
	
		    function NullNode() {
		    }
	
		    NullNode.prototype = {
		        nodeName: "#null",
		        attr: { style: {} },
		        children: [],
		        remove: function() {
		        }
		    };
	
		    var NULL_NODE = new NullNode();
	
		    function Element(nodeName, attr, children) {
		        this.nodeName = nodeName;
	
		        this.attr = attr || {};
	
		        this.children = children || [];
		    }
	
		    Element.prototype = new Node();
	
		    Element.prototype.appendTo = function(parent) {
		        var node = document.createElement(this.nodeName);
	
		        var children = this.children;
	
		        for (var index = 0; index < children.length; index++) {
		            children[index].render(node, NULL_NODE);
		        }
	
		        parent.appendChild(node);
	
		        return node;
		    };
	
		    Element.prototype.render = function(parent, cached) {
		        var node;
	
		        if (cached.nodeName !== this.nodeName) {
		            cached.remove();
	
		            node = this.appendTo(parent);
		        } else {
		            node = cached.node;
	
		            var index;
	
		            var children = this.children;
	
		            var length = children.length;
	
		            var cachedChildren = cached.children;
	
		            var cachedLength = cachedChildren.length;
	
		            if (Math.abs(cachedLength - length) > 2) {
		                this.render({
		                    appendChild: function(node) {
		                        parent.replaceChild(node, cached.node);
		                    }
		                }, NULL_NODE);
	
		                return;
		            }
	
		            for (index = 0; index < length; index++) {
		                children[index].render(node, cachedChildren[index] || NULL_NODE);
		            }
	
		            for (index = length; index < cachedLength; index++) {
		                cachedChildren[index].remove();
		            }
		        }
	
		        this.node = node;
	
		        this.syncAttributes(cached.attr);
	
		        this.removeAttributes(cached.attr);
		    };
	
		    Element.prototype.syncAttributes = function(cachedAttr) {
		        var attr = this.attr;
	
		        for (var name in attr) {
		            var value = attr[name];
	
		            var cachedValue = cachedAttr[name];
	
		            if (name === "style") {
		                this.setStyle(value, cachedValue);
		            } else if (value !== cachedValue) {
		                this.setAttribute(name, value, cachedValue);
		            }
		        }
		    };
	
		    Element.prototype.setStyle = function(style, cachedValue) {
		        var node = this.node;
		        var key;
	
		        if (cachedValue) {
		            for (key in style) {
		                if (style[key] !== cachedValue[key]) {
		                    node.style[key] = style[key];
		                }
		            }
		        } else {
		            for (key in style) {
		                node.style[key] = style[key];
		            }
		        }
		    };
	
		    Element.prototype.removeStyle = function(cachedStyle) {
		        var style = this.attr.style || {};
		        var node = this.node;
	
		        for (var key in cachedStyle) {
		            if (style[key] === undefined) {
		                node.style[key] = "";
		            }
		        }
		    };
	
		    Element.prototype.removeAttributes = function(cachedAttr) {
		        var attr = this.attr;
	
		        for (var name in cachedAttr) {
		            if (name === "style") {
		                this.removeStyle(cachedAttr.style);
		            } else if (attr[name] === undefined) {
		                this.removeAttribute(name);
		            }
		        }
		    };
	
		    Element.prototype.removeAttribute = function(name) {
		        var node = this.node;
	
		        if (name === "style") {
		            node.style.cssText = "";
		        } else if (name === "className") {
		            node.className = "";
		        } else {
		            node.removeAttribute(name);
		        }
		    };
	
		    Element.prototype.setAttribute = function(name, value) {
		        var node = this.node;
	
		        if (node[name] !== undefined) {
		            node[name] = value;
		        } else {
		            node.setAttribute(name, value);
		        }
		    };
	
		    Element.prototype.text = function() {
		        var str = "";
		        for (var i = 0; i < this.children.length; ++i) {
		            str += this.children[i].text();
		        }
		        return str;
		    };
	
		    function TextNode(nodeValue) {
		        this.nodeValue = String(nodeValue);
		    }
	
		    TextNode.prototype = new Node();
	
		    TextNode.prototype.nodeName = "#text";
	
		    TextNode.prototype.render = function(parent, cached) {
		        var node;
	
		        if (cached.nodeName !== this.nodeName) {
		            cached.remove();
	
		            node = document.createTextNode(this.nodeValue);
	
		            parent.appendChild(node);
		        } else {
		            node = cached.node;
	
		            if (this.nodeValue !== cached.nodeValue) {
		                if (node.parentNode) {
		                    // sometimes in IE parentNode is null (reason unknown),
		                    // and IE throws an error when you try to set a
		                    // parentless' nodeValue, because why not.
		                    node.nodeValue = this.nodeValue;
		                }
		            }
		        }
	
		        this.node = node;
		    };
	
		    TextNode.prototype.text = function() {
		        return this.nodeValue;
		    };
	
		    function HtmlNode(html) {
		        this.html = html;
		    }
	
		    HtmlNode.prototype = {
		       nodeName: "#html",
		       attr: {},
		       remove: function() {
		           for (var index = 0; index < this.nodes.length; index++) {
		               var el = this.nodes[index];
		               if (el.parentNode) {
		                   el.parentNode.removeChild(el);
		               }
		           }
		       },
		       render: function(parent, cached) {
		           if (cached.nodeName !== this.nodeName || cached.html !== this.html) {
		               cached.remove();
	
		               var lastChild = parent.lastChild;
	
		               insertHtml(parent, this.html);
	
		               this.nodes = [];
	
		               for (var child = lastChild ? lastChild.nextSibling : parent.firstChild; child; child = child.nextSibling) {
		                   this.nodes.push(child);
		               }
		           } else {
		               this.nodes = cached.nodes.slice(0);
		           }
		       }
		    };
	
		    var HTML_CONTAINER = document.createElement("div");
	
		    function insertHtml(node, html) {
		        HTML_CONTAINER.innerHTML = html;
	
		        while (HTML_CONTAINER.firstChild) {
		            node.appendChild(HTML_CONTAINER.firstChild);
		        }
		    }
	
		    function html(value) {
		        return new HtmlNode(value);
		    }
	
		    function element(nodeName, attrs, children) {
		        return new Element(nodeName, attrs, children);
		    }
	
		    function text(value) {
		        return new TextNode(value);
		    }
	
		    function Tree(root) {
		       this.root = root;
		       this.children = [];
		    }
	
		    Tree.prototype = {
		        html: html,
		        element: element,
		        text: text,
		        render: function(children) {
		            var cachedChildren = this.children;
	
		            var index;
	
		            var length;
	
		            for (index = 0, length = children.length; index < length; index++) {
		                var cached = cachedChildren[index];
		                if (!cached) {
		                    cached = NULL_NODE;
		                } else if (!cached.node || !cached.node.parentNode) {
		                    cached.remove();
		                    cached = NULL_NODE;
		                }
		                children[index].render(this.root, cached);
		            }
	
		            for (index = length; index < cachedChildren.length; index++) {
		                cachedChildren[index].remove();
		            }
	
		            this.children = children;
		        }
		    };
	
		    kendo.dom = {
		        html: html,
		        text: text,
		        element: element,
		        Tree: Tree,
		        Node: Node
		    };
		})(window.kendo);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1044);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1021:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(562);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1023:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(570);
	
	/***/ }),
	
	/***/ 1044:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1021), __webpack_require__(1022), __webpack_require__(1023) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "combobox",
		    name: "ComboBox",
		    category: "web",
		    description: "The ComboBox widget allows the selection from pre-defined values or entering a new value.",
		    depends: [ "list" ],
		    features: [ {
		        id: "mobile-scroller",
		        name: "Mobile scroller",
		        description: "Support for kinetic scrolling in mobile device",
		        depends: [ "mobile.scroller" ]
		    }, {
		        id: "virtualization",
		        name: "VirtualList",
		        description: "Support for virtualization",
		        depends: [ "virtuallist" ]
		    } ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        List = ui.List,
		        Select = ui.Select,
		        caret = kendo.caret,
		        support = kendo.support,
		        placeholderSupported = support.placeholder,
		        activeElement = kendo._activeElement,
		        keys = kendo.keys,
		        ns = ".kendoComboBox",
		        nsFocusEvent = ns + "FocusEvent",
		        CLICK = "click" + ns,
		        MOUSEDOWN = "mousedown" + ns,
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        CHANGE = "change",
		        LOADING = "k-i-loading",
		        DEFAULT = "k-state-default",
		        FOCUSED = "k-state-focused",
		        STATEDISABLED = "k-state-disabled",
		        ARIA_DISABLED = "aria-disabled",
		        STATE_FILTER = "filter",
		        STATE_ACCEPT = "accept",
		        STATE_REBIND = "rebind",
		        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		        proxy = $.proxy,
		        newLineRegEx = /(\r\n|\n|\r)/gm;
	
		    var ComboBox = Select.extend({
		        init: function(element, options) {
		            var that = this, text, disabled;
	
		            that.ns = ns;
	
		            options = $.isArray(options) ? { dataSource: options } : options;
	
		            Select.fn.init.call(that, element, options);
	
		            options = that.options;
		            element = that.element.on("focus" + ns, proxy(that._focusHandler, that));
	
		            options.placeholder = options.placeholder || element.attr("placeholder");
	
		            that._reset();
	
		            that._wrapper();
	
		            that._input();
	
		            that._clearButton();
	
		            that._tabindex(that.input);
	
		            that._popup();
	
		            that._dataSource();
		            that._ignoreCase();
	
		            that._enable();
	
		            that._attachFocusEvents();
	
		            that._oldIndex = that.selectedIndex = -1;
	
		            that._aria();
	
		            that._initialIndex = options.index;
	
		            that.requireValueMapper(that.options);
		            that._initList();
	
		            that._cascade();
	
		            if (options.autoBind) {
		                that._filterSource();
		            } else {
		                text = options.text;
	
		                if (!text && that._isSelect) {
		                    text = element.children(":selected").text();
		                }
	
		                if (text) {
		                    that._setText(text);
		                }
		            }
	
		            if (!text) {
		                that._placeholder();
		            }
	
		            disabled = $(that.element).parents("fieldset").is(':disabled');
	
		            if (disabled) {
		                that.enable(false);
		            }
	
		            kendo.notify(that);
		            that._toggleCloseVisibility();
		        },
	
		        options: {
		            name: "ComboBox",
		            enabled: true,
		            index: -1,
		            text: null,
		            value: null,
		            autoBind: true,
		            delay: 200,
		            dataTextField: "",
		            dataValueField: "",
		            minLength: 1,
		            enforceMinLength: false,
		            height: 200,
		            highlightFirst: true,
		            filter: "none",
		            placeholder: "",
		            suggest: false,
		            cascadeFrom: "",
		            cascadeFromField: "",
		            cascadeFromParentField: "",
		            ignoreCase: true,
		            animation: {},
		            virtual: false,
		            template: null,
		            groupTemplate: "#:data#",
		            fixedGroupTemplate: "#:data#",
		            clearButton: true,
		            syncValueAndText: true,
		            autoWidth: false
		        },
	
		        events:[
		            "open",
		            "close",
		            CHANGE,
		            "select",
		            "filtering",
		            "dataBinding",
		            "dataBound",
		            "cascade",
		            "set"
		        ],
	
		        setOptions: function(options) {
		            var listOptions = this._listOptions(options);
	
		            Select.fn.setOptions.call(this, options);
	
		            this.listView.setOptions(listOptions);
	
		            this._accessors();
		            this._aria();
		            this._clearButton();
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.input.off(ns);
		            that.input.off(nsFocusEvent);
		            that.element.off(ns);
		            that._inputWrapper.off(ns);
		            clearTimeout(that._pasteTimeout);
	
		            that._arrow.off(CLICK + " " + MOUSEDOWN);
		            that._clear.off(CLICK + " " + MOUSEDOWN);
	
		            Select.fn.destroy.call(that);
		        },
	
		        _change: function() {
		            var that = this;
		            var text = that.text();
		            var hasText = text && text !== that._oldText && text !== that.options.placeholder;
		            var index = that.selectedIndex;
		            var isCustom = index === -1;
	
		            if (!that.options.syncValueAndText && !that.value() && isCustom && hasText) {
		                that._old = "";
		                that._oldIndex = index;
		                that._oldText = text;
	
		                if (!that._typing) {
		                    // trigger the DOM change event so any subscriber gets notified
		                    that.element.trigger(CHANGE);
		                }
	
		                that.trigger(CHANGE);
		                that._typing = false;
		                return;
		            }
	
		            Select.fn._change.call(that);
		            that._toggleCloseVisibility();
		        },
	
		        _attachFocusEvents: function() {
		            var that = this;
		            that.input.on("focus" + nsFocusEvent, proxy(that._inputFocus, that))
		                      .on("focusout" + nsFocusEvent, proxy(that._inputFocusout, that));
		        },
	
		        _focusHandler: function() {
		            this.input.focus();
		        },
	
		        _arrowClick: function() {
		            this._toggle();
		        },
	
		        _inputFocus: function() {
		            this._inputWrapper.addClass(FOCUSED);
		            this._placeholder(false);
		        },
	
		        _inputFocusout: function() {
		            var that = this;
		            var value = that.value();
	
		            that._userTriggered = true;
		            that._inputWrapper.removeClass(FOCUSED);
		            clearTimeout(that._typingTimeout);
		            that._typingTimeout = null;
	
		            that.text(that.text());
	
		            var item = that._focus();
		            var dataItem = this.listView.dataItemByIndex(this.listView.getElementIndex(item));
	
		            if (value !== that.value() && that.trigger("select", { dataItem: dataItem, item: item })) {
		                that.value(value);
		                return;
		            }
	
		            that._placeholder();
		            that._blur();
	
		            that.element.blur();
		        },
	
		        _inputPaste: function() {
		            var that = this;
		            clearTimeout(that._pasteTimeout);
		            that._pasteTimeout = null;
	
		            that._pasteTimeout = setTimeout(function() {
		                that.search();
		            });
		        },
	
		        _editable: function(options) {
		            var that = this,
		                disable = options.disable,
		                readonly = options.readonly,
		                wrapper = that._inputWrapper.off(ns),
		                input = that.element.add(that.input.off(ns)),
		                arrow = that._arrow.off(CLICK + " " + MOUSEDOWN),
		                clear = that._clear;
	
		            if (!readonly && !disable) {
		                wrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                input.removeAttr(DISABLED)
		                     .removeAttr(READONLY)
		                     .attr(ARIA_DISABLED, false);
	
		                arrow.on(CLICK, proxy(that._arrowClick, that))
		                     .on(MOUSEDOWN, function(e) { e.preventDefault(); });
	
		                clear.on(CLICK + " touchend" + ns, proxy(that._clearValue, that))
		                    .on(MOUSEDOWN, function(e) { e.preventDefault(); });
	
		                that.input
		                    .on("keydown" + ns, proxy(that._keydown, that))
		                    .on("input" + ns, proxy(that._search, that))
		                    .on("paste" + ns, proxy(that._inputPaste, that));
	
		            } else {
		                wrapper
		                    .addClass(disable ? STATEDISABLED : DEFAULT)
		                    .removeClass(disable ? DEFAULT : STATEDISABLED);
	
		                input.attr(DISABLED, disable)
		                     .attr(READONLY, readonly)
		                     .attr(ARIA_DISABLED, disable);
		            }
	
		            that._toggleCloseVisibility();
		        },
	
		        open: function() {
		            var that = this;
		            var state = that._state;
		            var isFiltered = that.dataSource.filter() ? that.dataSource.filter().filters.length > 0 : false;
		            var reinitialized = !that.ul.find(that.listView.focus()).length;
	
		            if (that.popup.visible()) {
		                return;
		            }
	
		            if ((!that.listView.bound() && state !== STATE_FILTER) || state === STATE_ACCEPT) {
		                that._open = true;
		                that._state = STATE_REBIND;
		                if ((that.options.minLength !== 1 && !isFiltered) || (isFiltered && that.value() && that.selectedIndex === -1 )) {
		                    that.refresh();
		                    that._openPopup();
		                    if (!this.options.virtual) {
		                        that.listView.bound(false);
		                    }
		                } else {
		                    that._filterSource();
		                }
		            } else if (that._allowOpening()) {
		                // In some cases when the popup is opened resize is triggered which will cause it to close
		                // Setting the below flag will prevent this from happening
		                that.popup._hovered = true;
		                that._openPopup();
		                if(that.options.virtual) {
		                    that._focusItem();
		                } else if (reinitialized && that.options.highlightFirst) {
		                    that.listView.focus(0);
		                }
		            }
		        },
	
		        _scrollToFocusedItem: function() {
		            var listView = this.listView;
	
		            listView.scrollToIndex(listView.getElementIndex(listView.focus()));
		        },
	
		        _openPopup: function() {
		            this.popup.one("activate", proxy(this._scrollToFocusedItem, this));
		            this.popup.open();
		        },
	
		        _updateSelectionState: function() {
		            var that = this;
		            var text = that.options.text;
		            var value = that.options.value;
	
		            if (that.listView.isFiltered()) {
		                return;
		            }
	
		            if (that.selectedIndex === -1) {
		                if (text === undefined || text === null) {
		                    text = value;
		                }
	
		                that._accessor(value);
		                that.input.val(text || that.input.val());
		                that._placeholder();
		            } else if (that._oldIndex === -1) {
		                that._oldIndex = that.selectedIndex;
		            }
		        },
	
		        _buildOptions: function(data) {
		            var that = this;
		            if (!that._isSelect) {
		                return;
		            }
	
		            var custom = that._customOption;
	
		            if (that._state === STATE_REBIND) {
		                that._state = "";
		            }
	
		            that._customOption = undefined;
		            that._options(data, "", that.value());
	
		            if (custom && custom[0].selected && !that.listView._emptySearch) {
		                that._custom(custom.val());
		            }
		        },
	
		        _updateSelection: function() {
		            var that = this;
		            var listView = that.listView;
		            var initialIndex = that._initialIndex;
		            var hasInitialIndex = initialIndex !== null && initialIndex > -1;
		            var filtered = that._state === STATE_FILTER;
	
		            if (filtered) {
		                $(listView.focus()).removeClass("k-state-selected");
		                return;
		            }
	
		            if (that._fetch) {
		                return;
		            }
	
		            if (!listView.value().length) {
		                if (hasInitialIndex) {
		                    that.select(initialIndex);
		                } else if (that._accessor()) {
		                    listView.value(that._accessor());
		                }
		            }
	
		            that._initialIndex = null;
		            var dataItem = listView.selectedDataItems()[0];
	
		            if (!dataItem) {
		                return;
		            }
	
		            if (that._value(dataItem) !== that.value()) {
		                that._custom(that._value(dataItem));
		            } else if (that._value(dataItem) !== that.element[0].value){
		                that._accessor(that._value(dataItem));
		            }
	
		            if (that.text() && that.text() !== that._text(dataItem)) {
		                that._selectValue(dataItem);
		            }
		        },
	
		        _updateItemFocus: function() {
		            var listView = this.listView;
	
		            if (!this.options.highlightFirst) {
		                listView.focus(-1);
		            } else if (!listView.focus() && !listView.focusIndex()) {
		                listView.focus(0);
		            }
		        },
	
		        _listBound: function() {
		            var that = this;
		            var isActive = that.input[0] === activeElement();
	
		            var data = that.dataSource.flatView();
		            var skip = that.listView.skip();
		            var length = data.length;
		            var groupsLength = that.dataSource._group ? that.dataSource._group.length : 0;
		            var isFirstPage = skip === undefined || skip === 0;
	
		            that._presetValue = false;
	
		            that._renderFooter();
		            that._renderNoData();
		            that._toggleNoData(!length);
		            that._toggleHeader(!!groupsLength && !!length);
	
		            that._resizePopup();
	
		            that.popup.position();
	
		            that._buildOptions(data);
	
		            that._makeUnselectable();
	
		            that._updateSelection();
	
		            if (data.length && isFirstPage) {
		                that._updateItemFocus();
	
		                if (that.options.suggest && isActive && that.input.val()) {
		                    that.suggest(data[0]);
		                }
		            }
	
		            if (that._open) {
		                that._open = false;
	
		                if (that._typingTimeout && !isActive) {
		                    that.popup.close();
		                } else {
		                    that.toggle(that._allowOpening());
		                }
	
		                that._typingTimeout = null;
		            }
	
		            that._hideBusy();
		            that.trigger("dataBound");
		        },
	
		        _listChange: function() {
		            this._selectValue(this.listView.selectedDataItems()[0]);
	
		            if (this._presetValue) {
		                this._oldIndex = this.selectedIndex;
		            }
		        },
	
		        _get: function(candidate) {
		            var data, found, idx;
	
		            if (typeof candidate === "function") {
		                data = this.dataSource.flatView();
	
		                for (idx = 0; idx < data.length; idx++) {
		                    if (candidate(data[idx])) {
		                        candidate = idx;
		                        found = true;
		                        break;
		                    }
		                }
	
		                if (!found) {
		                    candidate = -1;
		                }
		            }
	
		            return candidate;
		        },
	
		        _select: function(candidate, keepState) {
		            var that = this;
		            candidate = that._get(candidate);
	
		            if (candidate === -1) {
		                that.input[0].value = "";
		                that._accessor("");
		            }
	
		            return that.listView.select(candidate).done(function() {
		                if (!keepState && that._state === STATE_FILTER) {
		                    that._state = STATE_ACCEPT;
		                }
		                that._toggleCloseVisibility();
		            });
		        },
	
		        _selectValue: function(dataItem) {
		            var idx = this.listView.select();
		            var value = "";
		            var text = "";
	
		            idx = idx[idx.length - 1];
		            if (idx === undefined) {
		                idx = -1;
		            }
	
		            this.selectedIndex = idx;
	
		            if (this.listView.isFiltered() && idx !== -1) {
		                this._valueBeforeCascade = this._old;
		            }
	
		            if (idx === -1 && !dataItem) {
		                if (this.options.syncValueAndText) {
		                    if (this.options.dataTextField === this.options.dataValueField) {
		                        text = this._accessor();
		                    } else {
		                        text = this.input[0].value;
		                    }
		                    value = text;
		                }
		                else {
		                    text = this.text();
		                }
		                this.listView.focus(-1);
		            } else {
		                if (dataItem || dataItem === 0) {
		                    value = this._dataValue(dataItem);
		                    text = this._text(dataItem);
		                }
	
		                if (value === null) {
		                    value = "";
		                }
		            }
	
		            this._setDomInputValue(text);
		            this._accessor(value !== undefined ? value : text, idx);
	
		            this._placeholder();
		            this._triggerCascade();
		        },
	
		        _setDomInputValue: function(text){
		            var that = this;
		            var currentCaret = caret(this.input);
		            var caretStart;
	
		            if(currentCaret && currentCaret.length){
		                caretStart = currentCaret[0];
		            }
	
		            this._prev = this.input[0].value = text;
	
		            if(caretStart && this.selectedIndex === -1){
		                var mobile = support.mobileOS;
		                if(mobile.wp || mobile.android) {// without the timeout the caret is at the end of the input
		                    setTimeout(function() { that.input[0].setSelectionRange(caretStart, caretStart); }, 0);
		                }
		                else {
		                    this.input[0].setSelectionRange(caretStart, caretStart);
		                }
		            }
		        },
	
		        refresh: function() {
		            this.listView.refresh();
		        },
	
		        _toggleCloseVisibility: function() {
		            var preventShow = this.element.is(":disabled") || this.element.is("[readonly]");
	
		            if (this.text() && !preventShow) {
		                this._showClear();
		            } else {
		                this._hideClear();
		            }
		        },
	
		        suggest: function(word) {
		            var that = this;
		            var element = that.input[0];
		            var value = that.text();
		            var caretIdx = caret(element)[0];
		            var key = that._last;
		            var idx;
	
		            if (key == keys.BACKSPACE || key == keys.DELETE) {
		                that._last = undefined;
		                return;
		            }
	
		            word = word || "";
	
		            if (typeof word !== "string") {
		                if (word[0]) {
		                    word = that.dataSource.view()[List.inArray(word[0], that.ul[0])];
		                }
	
		                word = word ? that._text(word) : "";
		            }
	
		            if (caretIdx <= 0) {
		                caretIdx = value.toLowerCase().indexOf(word.toLowerCase()) + 1;
		            }
	
		            if (word) {
		                word = word.toString();
		                idx = word.toLowerCase().indexOf(value.toLowerCase());
		                if (idx > -1) {
		                    value += word.substring(idx + value.length);
		                }
		            } else {
		                value = value.substring(0, caretIdx);
		            }
	
		            if (value.length !== caretIdx || !word) {
		                element.value = value;
		                if (element === activeElement()) {
		                    caret(element, caretIdx, value.length);
		                }
		            }
		        },
	
		        text: function (text) {
		            text = text === null ? "" : text;
	
		            var that = this;
		            var input = that.input[0];
		            var ignoreCase = that.options.ignoreCase;
		            var loweredText = text;
		            var dataItem;
		            var value;
	
		            if (text === undefined) {
		                return input.value;
		            }
	
		            if (that.options.autoBind === false && !that.listView.bound()) {
		                that._setText(text);
		                return;
		            }
	
		            dataItem = that.dataItem();
	
		            if (dataItem && that._text(dataItem).replace && that._text(dataItem).replace(newLineRegEx,"") === text) {
		                value = that._value(dataItem);
	
		                if (value === List.unifyType(that._old, typeof value)) {
		                    that._triggerCascade();
		                    return;
		                }
		            }
	
		            if (ignoreCase) {
		                loweredText = loweredText.toLowerCase();
		            }
	
		            that._select(function(data) {
		                data = that._text(data);
		                if (ignoreCase) {
		                    data = (data + "").toLowerCase();
		                }
	
		                return data === loweredText;
		            }).done(function() {
		                if (that.selectedIndex < 0) {
		                    input.value = text;
	
		                    if (that.options.syncValueAndText) {
		                        that._accessor(text);
		                    }
	
		                    that._cascadeTriggered = true;
		                    that._triggerCascade();
		                }
	
		                that._prev = input.value;
		            });
	
		            that._toggleCloseVisibility();
		        },
	
		        toggle: function(toggle) {
		            this._toggle(toggle, true);
		        },
	
		        value: function(value) {
		            var that = this;
		            var options = that.options;
		            var listView = that.listView;
	
		            if (value === undefined) {
		                value = that._accessor() || that.listView.value()[0];
		                return value === undefined || value === null ? "" : value;
		            }
	
		            that.requireValueMapper(that.options, value);
	
		            that.trigger("set", { value: value });
	
		            if (value === options.value && that.input.val() === options.text) {
		                return;
		            }
	
		            that._accessor(value);
	
		            if (that._isFilterEnabled() && listView.bound() && listView.isFiltered()) {
		                that._clearFilter();
		            } else {
		                that._fetchData();
		            }
	
		            listView
		                .value(value)
		                .done(function() {
		                    if (that.selectedIndex === -1 && (!listView._selectedDataItems || !listView._selectedDataItems.length)) {
		                        that._accessor(value);
		                        that.input.val(value);
		                        that._placeholder(true);
		                    }
	
		                    that._old = that._accessor();
		                    that._oldIndex = that.selectedIndex;
	
		                    that._prev = that.input.val();
	
		                    if (that._state === STATE_FILTER) {
		                        that._state = STATE_ACCEPT;
		                    }
		                    that._toggleCloseVisibility();
		                });
		        },
	
		        _hideBusy: function () {
		            var that = this;
		            clearTimeout(that._busy);
		            that._arrowIcon.removeClass(LOADING);
		            that._focused.attr("aria-busy", false);
		            that._busy = null;
		            that._toggleCloseVisibility();
		        },
	
		        _click: function(e) {
		            var that = this;
		            var item = e.item;
		            var dataItem = that.listView.dataItemByIndex(that.listView.getElementIndex(item));
		            var shouldTrigger = true;
		            e.preventDefault();
	
		            if(dataItem){
		                shouldTrigger = that._value(dataItem) !==  List.unifyType(that.value(), typeof that._value(dataItem));
	
		                if(!shouldTrigger){
		                   that.input.val(that._text(dataItem));
		                }
		            }
	
		            if (shouldTrigger && that.trigger("select", { dataItem: dataItem, item: item })) {
		                that.close();
		                return;
		            }
	
		            that._userTriggered = true;
	
		            that._select(item).done(function() {
		                that._blur();
		            });
		        },
	
		        _syncValueAndText: function () {
		            return this.options.syncValueAndText;
		        },
	
		        _inputValue: function() {
		            return this.text();
		        },
	
		        _searchByWord: function(word) {
		            var that = this;
		            var options = that.options;
		            var dataSource = that.dataSource;
		            var ignoreCase = options.ignoreCase;
		            var predicate = function (dataItem) {
		                var text = that._text(dataItem);
		                if (text !== undefined) {
		                    text = text + "";
		                    if (text !== "" && word === "") {
		                        return false;
		                    }
	
		                    if (ignoreCase) {
		                        text = text.toLowerCase();
		                    }
	
		                    return text.indexOf(word) === 0;
		                }
		            };
	
		            if (ignoreCase) {
		                word = word.toLowerCase();
		            }
	
		            if (!that.ul[0].firstChild) {
		                dataSource.one(CHANGE, function () {
		                    if (dataSource.view()[0]) {
		                        that.search(word);
		                    }
		                }).fetch();
		                return;
		            }
	
		            this.listView.focus(this._get(predicate));
	
		            var current = this.listView.focus();
	
		            if (current) {
		                if (options.suggest) {
		                    that.suggest(current);
		                }
	
		                this.open();
		            }
	
		            if (this.options.highlightFirst && !word) {
		                this.listView.focusFirst();
		            }
		        },
	
		        _input: function() {
		            var that = this,
		                element = that.element.removeClass("k-input")[0],
		                accessKey = element.accessKey,
		                wrapper = that.wrapper,
		                SELECTOR = "input.k-input",
		                name = element.name || "",
		                input,
		                maxLength;
	
		            if (name) {
		                name = 'name="' + name + '_input" ';
		            }
	
		            input = wrapper.find(SELECTOR);
	
		            if (!input[0]) {
		                wrapper.append('<span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default"><input ' + name + 'class="k-input" type="text" autocomplete="off"/><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>')
		                    .append(that.element);
	
		                input = wrapper.find(SELECTOR);
		            }
	
		            input[0].style.cssText = element.style.cssText;
		            input[0].title = element.title;
	
		            maxLength = parseInt(this.element.prop("maxlength") || this.element.attr("maxlength"), 10);
		            if (maxLength > -1) {
		                input[0].maxLength = maxLength;
		            }
	
		            input.addClass(element.className)
		                 .css({
		                    width: "",
		                    height: element.style.height
		                 })
		                 .attr({
		                     "role": "combobox",
		                     "aria-expanded": false
		                 })
		                 .show();
	
		            if (placeholderSupported) {
		                input.attr("placeholder", that.options.placeholder);
		            }
	
		            if (accessKey) {
		                element.accessKey = "";
		                input[0].accessKey = accessKey;
		            }
	
		            that._focused = that.input = input;
		            that._inputWrapper = $(wrapper[0].firstChild);
		            that._arrow = wrapper.find(".k-select")
		                .attr({
		                    "role": "button",
		                    "tabIndex": -1
		                });
		            that._arrowIcon = that._arrow.find(".k-icon");
	
		            if (element.id) {
		                that._arrow.attr("aria-controls", that.ul[0].id);
		            }
		        },
	
		        _clearButton: function() {
		            List.fn._clearButton.call(this);
	
		            if (this.options.clearButton) {
		                this._clear.insertAfter(this.input);
		                this.wrapper.addClass("k-combobox-clearable");
		            }
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode;
	
		            that._last = key;
	
		            clearTimeout(that._typingTimeout);
		            that._typingTimeout = null;
	
		            if (key === keys.HOME) {
		                that._firstItem();
		            } else if (key === keys.END) {
		                that._lastItem();
		            } else if (key === keys.ENTER || (key === keys.TAB && that.popup.visible())) {
		                var current = that.listView.focus();
		                var dataItem = that.dataItem();
		                var shouldTrigger = true;
	
		                if (!that.popup.visible() && (!dataItem || that.text() !== that._text(dataItem))) {
		                    current = null;
		                }
	
		                if (current) {
		                    if (that.popup.visible()) {
		                        e.preventDefault();
		                    }
	
		                    dataItem = that.listView.dataItemByIndex(that.listView.getElementIndex(current));
	
		                    if(dataItem){
		                        shouldTrigger = that._value(dataItem) !==  List.unifyType(that.value(), typeof that._value(dataItem));
		                    }
	
		                    if (shouldTrigger && that.trigger("select", { dataItem: dataItem, item: current })) {
		                        return;
		                    }
	
		                    that._userTriggered = true;
	
		                    that._select(current).done(function() {
		                        that._blur();
		                        that._valueBeforeCascade = that._old = that.value();
		                    });
		                } else {
		                    if(that._syncValueAndText() || that._isSelect){
		                        that._accessor(that.input.val());
		                    }
	
		                    that.listView.value(that.input.val());
		                    that._blur();
		                }
		            } else if (key != keys.TAB && !that._move(e)) {
		               that._search();
		            } else if (key === keys.ESC && !that.popup.visible() && that.text()) {
		                that._clearValue();
		            }
		        },
	
		        _placeholder: function(show) {
		            if (placeholderSupported) {
		                return;
		            }
	
		            var that = this,
		                input = that.input,
		                placeholder = that.options.placeholder,
		                value;
	
		            if (placeholder) {
		                value = that.value();
	
		                if (show === undefined) {
		                    show = !value;
		                }
	
		                input.toggleClass("k-readonly", show);
	
		                if (!show) {
		                    if (!value) {
		                        placeholder = "";
		                    } else {
		                        return;
		                    }
		                }
	
		                input.val(placeholder);
	
		                if (!placeholder && input[0] === activeElement()) {
		                    caret(input[0], 0, 0);
		                }
		            }
		        },
	
		        _search: function() {
		            var that = this;
	
		            clearTimeout(that._typingTimeout);
	
		            that._typingTimeout = setTimeout(function() {
		                var value = that.text();
	
		                if (that._prev !== value) {
		                    that._prev = value;
	
		                    if (that.options.filter === "none" && that.options.virtual) {
		                        that.listView.select(-1);
		                    }
	
		                    that.search(value);
		                    that._toggleCloseVisibility();
		                }
	
		                that._typingTimeout = null;
		            }, that.options.delay);
		        },
	
		        _setText: function(text) {
		            this.input.val(text);
		            this._prev = text;
		        },
	
		        _wrapper: function() {
		            var that = this,
		                element = that.element,
		                wrapper = element.parent();
	
		            if (!wrapper.is("span.k-widget")) {
		                wrapper = element.hide().wrap("<span />").parent();
		                wrapper[0].style.cssText = element[0].style.cssText;
		            }
	
		            that.wrapper = wrapper.addClass("k-widget k-combobox")
		                .addClass(element[0].className)
		                .css("display", "");
		        },
	
		        _clearSelection: function(parent, isFiltered) {
		            var that = this;
		            var hasValue = parent.value();
		            var custom = hasValue && parent.selectedIndex === -1;
	
		            if (this.selectedIndex == -1 && this.value()) {
		                return;
		            }
	
		            if (isFiltered || !hasValue || custom) {
		                that.options.value = "";
		                that.value("");
		                // Reset selected value for cascading
		                that._selectedValue = null;
		            }
		        },
	
		        _preselect: function(value, text) {
		            this.input.val(text);
		            this._accessor(value);
	
		            this._old = this._accessor();
		            this._oldIndex = this.selectedIndex;
	
		            this.listView.setValue(value);
		            this._placeholder();
	
		            this._initialIndex = null;
		            this._presetValue = true;
		            this._toggleCloseVisibility();
		        }
		    });
	
		    ui.plugin(ComboBox);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1210);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1210:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013), __webpack_require__(1036) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "list",
		    name: "List",
		    category: "framework",
		    depends: [ "data", "popup" ],
		    hidden: true
		};
	
		/*jshint evil: true*/
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        outerHeight = kendo._outerHeight,
		        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
		        Widget = ui.Widget,
		        keys = kendo.keys,
		        support = kendo.support,
		        htmlEncode = kendo.htmlEncode,
		        activeElement = kendo._activeElement,
		        outerWidth = kendo._outerWidth,
		        ObservableArray = kendo.data.ObservableArray,
		        ID = "id",
		        CHANGE = "change",
		        FOCUSED = "k-state-focused",
		        HOVER = "k-state-hover",
		        LOADING = "k-i-loading",
		        GROUPHEADER = ".k-group-header",
		        ITEMSELECTOR = ".k-item",
		        LABELIDPART = "_label",
		        OPEN = "open",
		        CLOSE = "close",
		        CASCADE = "cascade",
		        SELECT = "select",
		        SELECTED = "selected",
		        REQUESTSTART = "requestStart",
		        REQUESTEND = "requestEnd",
		        extend = $.extend,
		        proxy = $.proxy,
		        isArray = $.isArray,
		        browser = support.browser,
		        HIDDENCLASS = "k-hidden",
		        WIDTH = "width",
		        isIE = browser.msie,
		        isIE8 = isIE && browser.version < 9,
		        quotRegExp = /"/g,
		        alternativeNames = {
		            "ComboBox": "DropDownList",
		            "DropDownList": "ComboBox"
		        };
	
		    var List = kendo.ui.DataBoundWidget.extend({
		        init: function(element, options) {
		            var that = this,
		                ns = that.ns,
		                id;
	
		            Widget.fn.init.call(that, element, options);
		            element = that.element;
		            options = that.options;
	
		            that._isSelect = element.is(SELECT);
	
		            if (that._isSelect && that.element[0].length) {
		                if (!options.dataSource) {
		                    options.dataTextField = options.dataTextField || "text";
		                    options.dataValueField = options.dataValueField || "value";
		                }
		            }
	
		            that.ul = $('<ul unselectable="on" class="k-list k-reset"/>')
		                        .attr({
		                            tabIndex: -1,
		                            "aria-hidden": true
		                        });
	
		            that.list = $("<div class='k-list-container'/>")
		                        .append(that.ul)
		                        .on("mousedown" + ns, proxy(that._listMousedown, that));
	
		            id = element.attr(ID);
	
		            if (id) {
		                that.list.attr(ID, id + "-list");
		                that.ul.attr(ID, id + "_listbox");
		            }
	
		            if (options.columns && options.columns.length) {
		                that.ul.removeClass("k-list").addClass("k-grid-list");
		                that._columnsHeader();
		            }
	
		            that._header();
		            that._noData();
		            that._footer();
		            that._accessors();
		            that._initValue();
		        },
	
		        options: {
		            valuePrimitive: false,
		            footerTemplate: "",
		            headerTemplate: "",
		            noDataTemplate: "No data found."
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
	
		            if (options && options.enable !== undefined) {
		                options.enabled = options.enable;
		            }
	
		            if (options.columns && options.columns.length) {
		                this._columnsHeader();
		            }
	
		            this._header();
		            this._noData();
		            this._footer();
	
		            this._renderFooter();
		            this._renderNoData();
		        },
	
		        focus: function() {
		            this._focused.focus();
		        },
	
		        readonly: function(readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		        },
	
		        enable: function(enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		        },
	
		        _header: function() {
		            var list = this;
		            var header = $(list.header);
		            var template = list.options.headerTemplate;
	
		            this._angularElement(header, "cleanup");
		            kendo.destroy(header);
		            header.remove();
	
		            if (!template) {
		                list.header = null;
		                return;
		            }
	
		            var headerTemplate = typeof template !== "function" ? kendo.template(template) : template;
		            header = $(headerTemplate({}));
	
		            list.header = header[0] ? header : null;
		            list.list.prepend(header);
	
		            this._angularElement(list.header, "compile");
		        },
	
		        _columnsHeader: function() {
		            var list = this;
		            var columnsHeader = $(list.columnsHeader);
	
		            this._angularElement(columnsHeader, "cleanup");
		            kendo.destroy(columnsHeader);
		            columnsHeader.remove();
	
		            var header = "<div class='k-grid-header'><div class='k-grid-header-wrap'><table>";
		            var colGroup = "<colgroup>";
		            var row = "<tr>";
	
		            for (var idx = 0; idx < this.options.columns.length; idx++) {
		                var currentColumn = this.options.columns[idx];
		                var title = currentColumn.title || currentColumn.field || "";
		                var template = currentColumn.headerTemplate || title;
		                var columnsHeaderTemplate = typeof template !== "function" ? kendo.template(template) : template;
		                var currentWidth = currentColumn.width;
		                var currentWidthInt = parseInt(currentWidth, 10);
		                var widthStyle = '';
	
		                if (currentWidth && !isNaN(currentWidthInt)) {
		                    widthStyle += "style='width:";
		                    widthStyle += currentWidthInt;
		                    widthStyle += percentageUnitsRegex.test(currentWidth) ? "%" : "px";
		                    widthStyle += ";'";
		                }
	
		                colGroup += "<col " + widthStyle + "/>";
	
		                row += "<th class='k-header'>";
		                row += columnsHeaderTemplate(currentColumn);
		                row += "</th>";
		            }
		            colGroup += "</colgroup>";
		            row += "</tr>";
		            header += colGroup;
		            header += row;
		            header += "</table></div></div>";
	
		            list.columnsHeader = columnsHeader = $(header);
		            list.list.prepend(columnsHeader);
	
		            this._angularElement(list.columnsHeader, "compile");
		        },
	
		        _noData: function() {
		            var list = this;
		            var noData = $(list.noData);
		            var template = list.options.noDataTemplate;
	
		            list.angular("cleanup", function() { return { elements: noData }; });
		            kendo.destroy(noData);
		            noData.remove();
	
		            if (!template) {
		                list.noData = null;
		                return;
		            }
	
		            list.noData = $('<div class="k-nodata" style="display:none"><div></div></div>').appendTo(list.list);
		            list.noDataTemplate = typeof template !== "function" ? kendo.template(template) : template;
		        },
	
		        _footer: function() {
		            var list = this;
		            var footer = $(list.footer);
		            var template = list.options.footerTemplate;
	
		            this._angularElement(footer, "cleanup");
		            kendo.destroy(footer);
		            footer.remove();
	
		            if (!template) {
		                list.footer = null;
		                return;
		            }
	
		            list.footer = $('<div class="k-footer"></div>').appendTo(list.list);
		            list.footerTemplate = typeof template !== "function" ? kendo.template(template) : template;
		        },
	
		        _listOptions: function(options) {
		            var that = this;
		            var currentOptions = that.options;
		            var virtual = currentOptions.virtual;
		            var changeEventOption = {change: proxy(that._listChange, that)};
		            var listBoundHandler = proxy(that._listBound, that);
	
		            virtual = typeof virtual === "object" ? virtual : {};
	
		            options = $.extend({
		                autoBind: false,
		                selectable: true,
		                dataSource: that.dataSource,
		                click: proxy(that._click, that),
		                activate: proxy(that._activateItem, that),
		                columns: currentOptions.columns,
		                deactivate: proxy(that._deactivateItem, that),
		                dataBinding: function() {
		                    that.trigger("dataBinding");
		                },
		                dataBound: listBoundHandler,
		                height: currentOptions.height,
		                dataValueField: currentOptions.dataValueField,
		                dataTextField: currentOptions.dataTextField,
		                groupTemplate: currentOptions.groupTemplate,
		                fixedGroupTemplate: currentOptions.fixedGroupTemplate,
		                template: currentOptions.template
		            }, options, virtual, changeEventOption);
	
		            if (!options.template) {
		                options.template = "#:" + kendo.expr(options.dataTextField, "data") + "#";
		            }
	
		            if (currentOptions.$angular) {
		                options.$angular = currentOptions.$angular;
		            }
	
		            return options;
		        },
	
		        _initList: function() {
		            var that = this;
		            var listOptions = that._listOptions({
		                selectedItemChange: proxy(that._listChange, that)
		            });
	
		            if (!that.options.virtual) {
		                that.listView = new kendo.ui.StaticList(that.ul, listOptions);
		            } else {
		                that.listView = new kendo.ui.VirtualList(that.ul, listOptions);
		            }
	
		            that.listView.bind("listBound", proxy(that._listBound, that));
		            that._setListValue();
		        },
	
		        _setListValue: function(value) {
		            value = value || this.options.value;
	
		            if (value !== undefined) {
		                this.listView.value(value)
		                    .done(proxy(this._updateSelectionState, this));
		            }
		        },
	
		        _updateSelectionState: $.noop,
	
		        _listMousedown: function(e) {
		            if (!this.filterInput || this.filterInput[0] !== e.target) {
		                e.preventDefault();
		            }
		        },
	
		        _isFilterEnabled: function() {
		            var filter = this.options.filter;
		            return filter && filter !== "none";
		        },
	
		        _hideClear: function() {
		            var list = this;
	
		            if (list._clear) {
		                list._clear.addClass(HIDDENCLASS);
		            }
		        },
	
		        _showClear: function() {
		            if (this._clear) {
		                this._clear.removeClass(HIDDENCLASS);
		            }
		        },
	
		        _clearValue: function() {
		            this._clearText();
		            this._accessor("");
		            this.listView.value([]);
	
		            if (this._isSelect) {
		                this._customOption = undefined;
		            }
	
		            if (this._isFilterEnabled() && !this.options.enforceMinLength) {
		                this._filter({word: "", open: false});
	
		                if (this.options.highlightFirst) {
		                    this.listView.focus(0);
		                }
		            }
		            this._change();
		        },
	
		        _clearText: function() {
		            this.text("");
		        },
	
		        _clearFilter: function() {
		            if (!this.options.virtual) {
		                this.listView.bound(false);
		            }
	
		            this._filterSource();
		        },
	
		        _filterSource: function(filter, force) {
		            var that = this;
		            var options = that.options;
		            var isMultiColumnFiltering = options.filterFields && filter && filter.logic && filter.filters && filter.filters.length;
		            var dataSource = that.dataSource;
		            var expression = extend({}, dataSource.filter() || {});
		            var resetPageSettings = filter || (expression.filters && expression.filters.length && !filter);
	
		            var removed = removeFiltersForField(expression, options.dataTextField);
	
		            this._clearFilterExpressions(expression);
	
		            if ((filter || removed) && that.trigger("filtering", { filter: filter })) {
		                return;
		            }
	
		            var newExpression = {
		                filters: [],
		                logic: "and"
		            };
	
		            if (isMultiColumnFiltering) {
		                newExpression.filters.push(filter);
		            } else {
		                this._pushFilterExpression(newExpression, filter);
		            }
	
		            if (isValidFilterExpr(expression)) {
		                if (newExpression.logic === expression.logic) {
		                    newExpression.filters = newExpression.filters.concat(expression.filters);
		                } else {
		                    newExpression.filters.push(expression);
		                }
		            }
	
		            if (that._cascading) {
		                this.listView.setDSFilter(newExpression);
		            }
	
		            var dataSourceState = extend({}, {
		                page: resetPageSettings ? 1 : dataSource.page(),
		                pageSize: resetPageSettings ? dataSource.options.pageSize : dataSource.pageSize(),
		                sort: dataSource.sort(),
		                filter: dataSource.filter(),
		                group: dataSource.group(),
		                aggregate: dataSource.aggregate()
		            }, { filter: newExpression });
	
		            return dataSource[force ? "read" : "query"](dataSource._mergeState(dataSourceState));
		        },
	
		        _pushFilterExpression: function (newExpression, filter) {
		            if (isValidFilterExpr(filter) && $.trim(filter.value).length) {
		                newExpression.filters.push(filter);
		            }
		        },
	
		        _clearFilterExpressions: function (expression) {
		            if (!expression.filters) {
		                return;
		            }
	
		            var filtersToRemove;
	
		            for(var i = 0; i < expression.filters.length; i++) {
		                if ("fromFilter" in expression.filters[i]) {
		                    filtersToRemove = i;
		                }
		            }
	
		            if (!isNaN(filtersToRemove)){
		                expression.filters.splice(filtersToRemove, 1);
		            }
		        },
	
		        _angularElement: function(element, action) {
		            if (!element) {
		                return;
		            }
	
		            this.angular(action, function() {
		                return { elements: element };
		            });
		        },
	
		        _renderNoData: function() {
		            var list = this;
		            var noData = list.noData;
	
		            if (!noData) {
		                return;
		            }
	
		            this._angularElement(noData, "cleanup");
		            noData.children(":first").html(list.noDataTemplate({ instance: list }));
		            this._angularElement(noData, "compile");
		        },
	
		        _toggleNoData: function(show) {
		            $(this.noData).toggle(show);
		        },
	
		        _toggleHeader: function(show) {
		            var groupHeader = this.listView.content.prev(GROUPHEADER);
		            groupHeader.toggle(show);
		        },
	
		        _renderFooter: function() {
		            var list = this;
		            var footer = list.footer;
	
		            if (!footer) {
		                return;
		            }
	
		            this._angularElement(footer, "cleanup");
		            footer.html(list.footerTemplate({ instance: list }));
		            this._angularElement(footer, "compile");
		        },
	
		        _allowOpening: function() {
		            return this.options.noDataTemplate || this.dataSource.flatView().length;
		        },
	
		        _initValue: function() {
		            var that = this,
		                value = that.options.value;
	
		            if (value !== null) {
		                that.element.val(value);
		            } else {
		                value = that._accessor();
		                that.options.value = value;
		            }
	
		            that._old = value;
		        },
	
		        _ignoreCase: function() {
		            var that = this,
		                model = that.dataSource.reader.model,
		                field;
	
		            if (model && model.fields) {
		                field = model.fields[that.options.dataTextField];
	
		                if (field && field.type && field.type !== "string") {
		                    that.options.ignoreCase = false;
		                }
		            }
		        },
	
		        _focus: function(candidate) {
		            return this.listView.focus(candidate);
		        },
	
		        _filter: function(options) {
		            var that = this;
		            var widgetOptions = that.options;
		            var word = options.word;
		            var filterFields = widgetOptions.filterFields;
		            var field = widgetOptions.dataTextField;
		            var expression;
	
		            if (filterFields && filterFields.length) {
		                expression = {
		                    logic: "or",
		                    filters: [],
		                    fromFilter: true
		                };
		                for(var i = 0; i < filterFields.length; i++) {
		                    this._pushFilterExpression(expression, that._buildExpression(word, filterFields[i]));
		                }
		            } else {
		                expression = that._buildExpression(word, field);
		            }
	
		            that._open = options.open;
		            that._filterSource(expression);
		        },
	
		        _buildExpression: function(value, field) {
		            var that = this;
		            var widgetOptions = that.options;
		            var ignoreCase = widgetOptions.ignoreCase;
	
		            return {
		                value: ignoreCase ? value.toLowerCase() : value,
		                field: field,
		                operator: widgetOptions.filter,
		                ignoreCase: ignoreCase
		            };
		        },
	
		        _clearButton: function() {
		            var list = this;
		            var clearTitle = (list.options.messages && list.options.messages.clear) ? list.options.messages.clear: "clear";
	
		            if (!list._clear){
		                list._clear = $('<span unselectable="on" class="k-icon k-clear-value k-i-close" title="' + clearTitle + '"></span>').attr({
		                    "role": "button",
		                    "tabIndex": -1
		                });
		            }
	
		            if (!list.options.clearButton) {
		                list._clear.remove();
		            }
		            this._hideClear();
		        },
	
		        search: function(word) {
		            var options = this.options;
	
		            word = typeof word === "string" ? word : this._inputValue();
	
		            clearTimeout(this._typingTimeout);
	
		            if ((!options.enforceMinLength && !word.length) || word.length >= options.minLength) {
		                this._state = "filter";
		                if (this.listView){
		                    this.listView._emptySearch = !$.trim(word).length;
		                }
	
		                if (!this._isFilterEnabled()) {
		                    this._searchByWord(word);
		                } else {
		                    this._filter({word: word, open: true});
		                }
		            }
		        },
	
		        current: function(candidate) {
		            return this._focus(candidate);
		        },
	
		        items: function() {
		            return this.ul[0].children;
		        },
	
		        destroy: function() {
		            var that = this;
		            var ns = that.ns;
	
		            Widget.fn.destroy.call(that);
	
		            that._unbindDataSource();
	
		            that.listView.destroy();
		            that.list.off(ns);
	
		            that.popup.destroy();
	
		            if (that._form) {
		                that._form.off("reset", that._resetHandler);
		            }
		        },
	
		        dataItem: function(index) {
		            var that = this;
	
		            if (index === undefined) {
		                return that.listView.selectedDataItems()[0];
		            }
	
		            if (typeof index !== "number") {
		                if (that.options.virtual) {
		                    return that.dataSource.getByUid($(index).data("uid"));
		                }
	
		                index = $(that.items()).index(index);
		            }
	
		            return that.dataSource.flatView()[index];
		        },
	
		        _activateItem: function() {
		            var current = this.listView.focus();
		            if (current) {
		                this._focused.add(this.filterInput).attr("aria-activedescendant", current.attr("id"));
		            }
		        },
	
		        _deactivateItem: function() {
		            this._focused.add(this.filterInput).removeAttr("aria-activedescendant");
		        },
	
		        _accessors: function() {
		            var that = this;
		            var element = that.element;
		            var options = that.options;
		            var getter = kendo.getter;
		            var textField = element.attr(kendo.attr("text-field"));
		            var valueField = element.attr(kendo.attr("value-field"));
	
		            if (!options.dataTextField && textField) {
		                options.dataTextField = textField;
		            }
	
		            if (!options.dataValueField && valueField) {
		                options.dataValueField = valueField;
		            }
	
		            that._text = getter(options.dataTextField);
		            that._value = getter(options.dataValueField);
		        },
	
		        _aria: function(id) {
		            var that = this,
		                options = that.options,
		                element = that._focused.add(that.filterInput);
	
		            if (options.suggest !== undefined) {
		                element.attr("aria-autocomplete", options.suggest ? "both" : "list");
		            }
	
		            id = id ? id + " " + that.ul[0].id : that.ul[0].id;
	
		            element.attr("aria-owns", id);
	
		            that.ul.attr("aria-live", !that._isFilterEnabled() ? "off" : "polite");
	
		            that._ariaLabel();
		        },
	
		        _ariaLabel: function(){
		            var that = this;
		            var focusedElm = that._focused;
		            var inputElm = that.element;
		            var inputId = inputElm.attr("id");
		            var labelElm = $("label[for=\"" + inputId  + "\"]");
		            var ariaLabel = inputElm.attr("aria-label");
		            var ariaLabelledBy = inputElm.attr("aria-labelledby");
	
		            if (focusedElm === inputElm) {
		                return;
		            }
	
		            if (ariaLabel) {
		                focusedElm.attr("aria-label", ariaLabel);
		            } else if (ariaLabelledBy){
		                focusedElm.attr("aria-labelledby", ariaLabelledBy);
		            } else if (labelElm.length){
		                var labelId = labelElm.attr("id") || that._generateLabelId(labelElm, inputId);
		                focusedElm.attr("aria-labelledby", labelId);
		            }
		        },
	
		        _generateLabelId: function(label, inputId){
		            var labelId = inputId + LABELIDPART;
		            label.attr("id", labelId);
	
		            return labelId;
		        },
	
		        _blur: function() {
		            var that = this;
	
		            that._change();
		            that.close();
		        },
	
		        _change: function() {
		            var that = this;
		            var index = that.selectedIndex;
		            var optionValue = that.options.value;
		            var value = that.value();
		            var trigger;
	
		            if (that._isSelect && !that.listView.bound() && optionValue) {
		                value = optionValue;
		            }
	
		            if (value !== unifyType(that._old, typeof value)) {
		                trigger = true;
		            } else if (that._valueBeforeCascade !== undefined && that._valueBeforeCascade !== unifyType(that._old, typeof that._valueBeforeCascade) && that._userTriggered) {
		                trigger = true;
		            } else if (index !== undefined && index !== that._oldIndex && !that.listView.isFiltered()) {
		                trigger = true;
		            }
	
		            if (trigger) {
		                if (that._old === null || that._old === "" || value === "") {
		                    that._valueBeforeCascade = that._old = value;
		                } else {
		                    if (that.dataItem()) {
		                        that._valueBeforeCascade = that._old = that.options.dataValueField ? that.dataItem()[that.options.dataValueField] : that.dataItem();
		                    } else {
		                        that._valueBeforeCascade = that._old = null;
		                    }
		                }
		                that._oldIndex = index;
	
		                if (!that._typing) {
		                    // trigger the DOM change event so any subscriber gets notified
		                    that.element.trigger(CHANGE);
		                }
	
		                that.trigger(CHANGE);
		            }
	
		            that.typing = false;
		        },
	
		        _data: function() {
		            return this.dataSource.view();
		        },
	
		        _enable: function() {
		            var that = this,
		                options = that.options,
		                disabled = that.element.is("[disabled]");
	
		            if (options.enable !== undefined) {
		                options.enabled = options.enable;
		            }
	
		            if (!options.enabled || disabled) {
		                that.enable(false);
		            } else {
		                that.readonly(that.element.is("[readonly]"));
		            }
		        },
	
		        _dataValue: function(dataItem) {
		            var value = this._value(dataItem);
	
		            if (value === undefined) {
		                value = this._text(dataItem);
		            }
	
		            return value;
		        },
	
		        _offsetHeight: function() {
		            var offsetHeight = 0;
		            var siblings = this.listView.content.prevAll(":visible");
	
		            siblings.each(function() {
		                var element = $(this);
	
		                offsetHeight += outerHeight(element, true);
		            });
	
		            return offsetHeight;
		        },
	
		        _height: function(length) {
		            var that = this;
		            var list = that.list;
		            var height = that.options.height;
		            var visible = that.popup.visible();
		            var offsetTop;
		            var popups;
		            var footerHeight;
	
		            if (length || that.options.noDataTemplate) {
		                popups = list.add(list.parent(".k-animation-container")).show();
	
		                if (!list.is(":visible")) {
		                    popups.hide();
		                    return;
		                }
	
		                height = that.listView.content[0].scrollHeight > height ? height : "auto";
	
		                popups.height(height);
	
		                if (height !== "auto") {
		                    offsetTop = that._offsetHeight();
		                    footerHeight = outerHeight($(that.footer)) || 0;
		                    height = height - offsetTop - footerHeight;
		                }
	
		                that.listView.content.height(height);
	
		                if (!visible) {
		                    popups.hide();
		                }
		            }
	
		            return height;
		        },
	
		        _openHandler: function(e) {
		            this._adjustListWidth();
	
		            if (this.trigger(OPEN)) {
		                e.preventDefault();
		            } else {
		                this._focused.attr("aria-expanded", true);
		                this.ul.attr("aria-hidden", false);
		            }
		        },
	
		        _adjustListWidth: function() {
		            var that = this,
		                list = that.list,
		                width = list[0].style.width,
		                wrapper = that.wrapper,
		                computedStyle, computedWidth;
	
		            if (!list.data(WIDTH) && width) {
		                return;
		            }
	
		            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
		            computedWidth = parseFloat(computedStyle  && computedStyle.width) || outerWidth(wrapper);
	
		            if (computedStyle && browser.msie) { // getComputedStyle returns different box in IE.
		                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
		            }
	
		            if (list.css("box-sizing") !== "border-box") {
		                width = computedWidth - (outerWidth(list) - list.width());
		            } else {
		                width = computedWidth;
		            }
	
		            list.css({
		                fontFamily: wrapper.css("font-family"),
		                width: that.options.autoWidth ? "auto" : width,
		                minWidth: width,
		                whiteSpace: that.options.autoWidth ? "nowrap" : "normal"
		            })
		            .data(WIDTH, width);
	
		            return true;
		        },
	
		        _closeHandler: function(e) {
		            if (this.trigger(CLOSE)) {
		                e.preventDefault();
		            } else {
		                this._focused.attr("aria-expanded", false);
		                this.ul.attr("aria-hidden", true);
		            }
		        },
	
		        _focusItem: function() {
		            var listView = this.listView;
		            var noFocusedItem = !listView.focus();
		            var index = last(listView.select());
	
		            if (index === undefined && this.options.highlightFirst && noFocusedItem) {
		                index = 0;
		            }
	
		            if (index !== undefined) {
		                listView.focus(index);
		            } else if (noFocusedItem) {
		                listView.scrollToIndex(0);
		            }
		        },
	
		        _calculateGroupPadding: function(height) {
		            var li = this.ul.children(".k-first:first");
		            var groupHeader = this.listView.content.prev(GROUPHEADER);
		            var padding = 0;
	
		            if (groupHeader[0] && groupHeader[0].style.display !== "none") {
		                if (height !== "auto") {
		                    padding = kendo.support.scrollbar();
		                }
	
		                padding += parseFloat(li.css("border-right-width"), 10) + parseFloat(li.children(".k-group").css("padding-right"), 10);
	
		                groupHeader.css("padding-right", padding);
		            }
		        },
	
		        _calculatePopupHeight: function(force) {
		            var height = this._height(this.dataSource.flatView().length || force);
		            this._calculateGroupPadding(height);
		            this._calculateColumnsHeaderPadding(height);
		        },
	
		        _calculateColumnsHeaderPadding: function(height){
		            if (this.options.columns && this.options.columns.length) {
		                var list = this;
		                var isRtl = support.isRtl(list.wrapper);
		                var scrollbar = kendo.support.scrollbar();
	
		                list.columnsHeader.css((isRtl ? "padding-left" : "padding-right"), height !== "auto" ? scrollbar : 0);
		            }
		        },
	
		        _resizePopup: function(force) {
		            if (this.options.virtual) {
		                return;
		            }
	
		            if (!this.popup.element.is(":visible")) {
		                this.popup.one("open", (function(force) {
		                    return proxy(function() {
		                        this._calculatePopupHeight(force);
		                    }, this);
		                }).call(this, force));
		            } else {
		                this._calculatePopupHeight(force);
		            }
		        },
	
		        _popup: function() {
		            var list = this;
	
		            list.popup = new ui.Popup(list.list, extend({}, list.options.popup, {
		                anchor: list.wrapper,
		                open: proxy(list._openHandler, list),
		                close: proxy(list._closeHandler, list),
		                animation: list.options.animation,
		                isRtl: support.isRtl(list.wrapper),
		                autosize :list.options.autoWidth
		            }));
		        },
	
		        _makeUnselectable: function() {
		            if (isIE8) {
		                this.list.find("*").not(".k-textbox").attr("unselectable", "on");
		            }
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
		        },
	
		        _toggle: function(open, preventFocus) {
		            var that = this;
		            var touchEnabled = support.mobileOS && (support.touch || support.MSPointers || support.pointers);
	
		            open = open !== undefined? open : !that.popup.visible();
	
		            if (!preventFocus && !touchEnabled && that._focused[0] !== activeElement()) {
		                that._prevent = true;
		                that._focused.focus();
		                that._prevent = false;
		            }
	
		            that[open ? OPEN : CLOSE]();
		        },
	
		        _triggerCascade: function() {
		            var that = this;
	
		            if (!that._cascadeTriggered || that.value() !== unifyType(that._cascadedValue, typeof that.value())) {
		                that._cascadedValue = that.value();
		                that._cascadeTriggered = true;
		                that.trigger(CASCADE, { userTriggered: that._userTriggered });
		            }
		        },
	
		        _triggerChange: function() {
		            if (this._valueBeforeCascade !== this.value()) {
		                this.trigger(CHANGE);
		            }
		        },
	
		        _unbindDataSource: function() {
		            var that = this;
	
		            that.dataSource.unbind(REQUESTSTART, that._requestStartHandler)
		                           .unbind(REQUESTEND, that._requestEndHandler)
		                           .unbind("error", that._errorHandler);
		        },
	
		        requireValueMapper: function(options, value) {
		            var hasValue = (options.value instanceof Array ? options.value.length : options.value) || (value instanceof Array ? value.length : value);
		            if (hasValue && options.virtual && typeof options.virtual.valueMapper !== "function") {
		                throw new Error("ValueMapper is not provided while the value is being set. See http://docs.telerik.com/kendo-ui/controls/editors/combobox/virtualization#the-valuemapper-function");
		            }
		        }
		    });
	
		    function unifyType(value, type) {
		        if (value !== undefined && value !== "" && value !== null) {
		            if (type === "boolean") {
		                value = Boolean(value);
		            } else if (type === "number") {
		                value = Number(value);
		            } else if (type === "string") {
		                value = value.toString();
		            }
		        }
	
		        return value;
		    }
	
		    extend(List, {
		        inArray: function(node, parentNode) {
		            var idx, length, siblings = parentNode.children;
	
		            if (!node || node.parentNode !== parentNode) {
		                return -1;
		            }
	
		            for (idx = 0, length = siblings.length; idx < length; idx++) {
		                if (node === siblings[idx]) {
		                    return idx;
		                }
		            }
	
		            return -1;
		        },
		        unifyType: unifyType
		    });
	
		    kendo.ui.List = List;
	
		    ui.Select = List.extend({
		        init: function(element, options) {
		            List.fn.init.call(this, element, options);
		            this._initial = this.element.val();
		        },
	
		        setDataSource: function(dataSource) {
		            var that = this;
		            var parent;
	
		            that.options.dataSource = dataSource;
	
		            that._dataSource();
	
		            if (that.listView.bound()) {
		                that._initialIndex = null;
		                that.listView._current = null;
		            }
	
		            that.listView.setDataSource(that.dataSource);
	
		            if (that.options.autoBind) {
		                that.dataSource.fetch();
		            }
	
		            parent = that._parentWidget();
	
		            if (parent) {
		                that._cascadeSelect(parent);
		            }
		        },
	
		        close: function() {
		            this.popup.close();
		        },
	
		        select: function(candidate) {
		            var that = this;
	
		            if (candidate === undefined) {
		                return that.selectedIndex;
		            } else {
		                return that._select(candidate).done(function() {
		                    that._cascadeValue = that._old = that._accessor();
		                    that._oldIndex = that.selectedIndex;
		                });
		            }
		        },
	
		        _accessor: function(value, idx) {
		            return this[this._isSelect ? "_accessorSelect" : "_accessorInput"](value, idx);
		        },
	
		        _accessorInput: function(value) {
		            var element = this.element[0];
	
		            if (value === undefined) {
		                return element.value;
		            } else {
		                if (value === null) {
		                    value = "";
		                }
		                element.value = value;
		            }
		        },
	
		        _accessorSelect: function(value, idx) {
		            var element = this.element[0];
		            var hasValue;
	
		            if (value === undefined) {
		                return getSelectedOption(element).value || "";
		            }
	
		            getSelectedOption(element).selected = false;
	
		            if (idx === undefined) {
		                idx = -1;
		            }
	
		            hasValue = (value !== null && value !== "");
	
		            if (hasValue && idx == -1) {
		                this._custom(value);
		            } else {
		                if (value) {
		                    element.value = value;
		                } else {
		                    element.selectedIndex = idx;
		                }
		            }
		        },
	
		        _syncValueAndText: function () {
		            return true;
		        },
	
		        _custom: function(value) {
		            var that = this;
		            var element = that.element;
		            var custom = that._customOption;
	
		            if (!custom) {
		                custom = $("<option/>");
		                that._customOption = custom;
	
		                element.append(custom);
		            }
	
		            custom.text(value);
		            custom[0].selected = true;
		        },
	
		        _hideBusy: function () {
		            var that = this;
		            clearTimeout(that._busy);
		            that._arrowIcon.removeClass(LOADING);
		            that._focused.attr("aria-busy", false);
		            that._busy = null;
		            that._showClear();
		        },
	
		        _showBusy: function (e) {
		            var that = this;
	
		            if (e.isDefaultPrevented()) {
		                return;
		            }
	
		            that._request = true;
	
		            if (that._busy) {
		                return;
		            }
	
		            that._busy = setTimeout(function () {
		                if (that._arrowIcon) { //destroyed after request start
		                    that._focused.attr("aria-busy", true);
		                    that._arrowIcon.addClass(LOADING);
		                    that._hideClear();
		                }
		            }, 100);
		        },
	
		        _requestEnd: function() {
		            this._request = false;
		            this._hideBusy();
		        },
	
		        _dataSource: function() {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                dataSource = options.dataSource || {},
		                idx;
	
		            dataSource = $.isArray(dataSource) ? {data: dataSource} : dataSource;
	
		            if (that._isSelect) {
		                idx = element[0].selectedIndex;
		                if (idx > -1) {
		                    options.index = idx;
		                }
	
		                dataSource.select = element;
		                dataSource.fields = [{ field: options.dataTextField },
		                                     { field: options.dataValueField }];
		            }
	
		            if (that.dataSource) {
		                that._unbindDataSource();
		            } else {
		                that._requestStartHandler = proxy(that._showBusy, that);
		                that._requestEndHandler = proxy(that._requestEnd, that);
		                that._errorHandler = proxy(that._hideBusy, that);
		            }
	
		            that.dataSource = kendo.data.DataSource.create(dataSource)
		                                   .bind(REQUESTSTART, that._requestStartHandler)
		                                   .bind(REQUESTEND, that._requestEndHandler)
		                                   .bind("error", that._errorHandler);
		        },
	
		        _firstItem: function() {
		            this.listView.focusFirst();
		        },
	
		        _lastItem: function() {
		            this.listView.focusLast();
		        },
	
		        _nextItem: function() {
		            this.listView.focusNext();
		        },
	
		        _prevItem: function() {
		            this.listView.focusPrev();
		        },
	
		        _move: function(e) {
		            var that = this;
		            var listView = that.listView;
		            var key = e.keyCode;
		            var down = key === keys.DOWN;
		            var dataItem;
		            var pressed;
		            var current;
	
		            if (key === keys.UP || down) {
		                if (e.altKey) {
		                    that.toggle(down);
		                } else {
		                    if (!listView.bound() && !that.ul[0].firstChild) {
		                        if (!that._fetch) {
		                            that.dataSource.one(CHANGE, function() {
		                                that._fetch = false;
		                                that._move(e);
		                            });
	
		                            that._fetch = true;
		                            that._filterSource();
		                        }
	
		                        e.preventDefault();
	
		                        return true; //pressed
		                    }
	
		                    current = that._focus();
	
		                    if (!that._fetch && (!current || current.hasClass("k-state-selected"))) {
		                        if (down) {
		                            that._nextItem();
	
		                            if (!that._focus()) {
		                                that._lastItem();
		                            }
		                        } else {
		                            that._prevItem();
	
		                            if (!that._focus()) {
		                                that._firstItem();
		                            }
		                        }
		                    }
	
		                    dataItem = listView.dataItemByIndex(listView.getElementIndex(that._focus()));
	
		                    if (that.trigger(SELECT, { dataItem: dataItem, item: that._focus() })) {
		                        that._focus(current);
		                        return;
		                    }
	
		                    that._select(that._focus(), true).done(function() {
		                        if (!that.popup.visible()) {
		                            that._blur();
		                        }
		                        if (that._cascadedValue === null) {
		                            that._cascadedValue = that.value();
		                        } else {
		                            that._cascadedValue = that.dataItem() ? that.dataItem()[that.options.dataValueField] || that.dataItem() : null;
		                        }
		                    });
		                }
	
		                e.preventDefault();
		                pressed = true;
		            } else if (key === keys.ENTER || key === keys.TAB) {
		                if (that.popup.visible()) {
		                    e.preventDefault();
		                }
	
		                current = that._focus();
		                dataItem = that.dataItem();
	
		                if (!that.popup.visible() && (!dataItem || that.text() !== that._text(dataItem))) {
		                    current = null;
		                }
	
		                var activeFilter = that.filterInput && that.filterInput[0] === activeElement();
	
		                if (current) {
		                    dataItem = listView.dataItemByIndex(listView.getElementIndex(current));
		                    var shouldTrigger = true;
	
		                    if (dataItem) {
		                        shouldTrigger = that._value(dataItem) !==  List.unifyType(that.value(), typeof that._value(dataItem));
		                    }
	
		                    if (shouldTrigger && that.trigger(SELECT, { dataItem: dataItem, item: current })) {
		                        return;
		                    }
	
		                    that._select(current);
		                } else if (that.input) {
		                    if (that._syncValueAndText() || that._isSelect) {
		                        that._accessor(that.input.val());
		                    }
		                    that.listView.value(that.input.val());
		                }
	
		                if (that._focusElement) {
		                    that._focusElement(that.wrapper);
		                }
	
		                if (activeFilter && key === keys.TAB) {
		                    that.wrapper.focusout();
		                } else {
		                    that._blur();
		                }
	
		                that.close();
		                pressed = true;
		            } else if (key === keys.ESC) {
		                if (that.popup.visible()) {
		                    e.preventDefault();
		                }
		                that.close();
		                pressed = true;
		            } else if (that.popup.visible() && (key === keys.PAGEDOWN || key === keys.PAGEUP)) {
		                e.preventDefault();
	
		                var direction = key === keys.PAGEDOWN ? 1 : -1;
		                listView.scrollWith(direction * listView.screenHeight());
	
		                pressed = true;
		            }
	
		            return pressed;
		        },
	
		        _fetchData: function() {
		            var that = this;
		            var hasItems = !!that.dataSource.view().length;
	
		            if (that._request || that.options.cascadeFrom) {
		                return;
		            }
	
		            if (!that.listView.bound() && !that._fetch && !hasItems) {
		                that._fetch = true;
		                that.dataSource.fetch().done(function() {
		                    that._fetch = false;
		                });
		            }
		        },
	
		        _options: function(data, optionLabel, value) {
		            var that = this,
		                element = that.element,
		                htmlElement = element[0],
		                length = data.length,
		                options = "",
		                option,
		                dataItem,
		                dataText,
		                dataValue,
		                idx = 0;
	
		            if (optionLabel) {
		                options = optionLabel;
		            }
	
		            for (; idx < length; idx++) {
		                option = "<option";
		                dataItem = data[idx];
		                dataText = that._text(dataItem);
		                dataValue = that._value(dataItem);
	
		                if (dataValue !== undefined) {
		                    dataValue += "";
	
		                    if (dataValue.indexOf('"') !== -1) {
		                        dataValue = dataValue.replace(quotRegExp, "&quot;");
		                    }
	
		                    option += ' value="' + dataValue + '"';
		                }
	
		                option += ">";
	
		                if (dataText !== undefined) {
		                    option += htmlEncode(dataText);
		                }
	
		                option += "</option>";
		                options += option;
		            }
	
		            element.html(options);
	
		            if (value !== undefined) {
		                htmlElement.value = value;
		                if (htmlElement.value && !value) {
		                    htmlElement.selectedIndex = -1;
		                }
		            }
	
		            if (htmlElement.selectedIndex !== -1) {
		                option = getSelectedOption(htmlElement);
	
		                if (option) {
		                    option.setAttribute(SELECTED, SELECTED);
		                }
		            }
		        },
	
		        _reset: function() {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    setTimeout(function() {
		                        that.value(that._initial);
		                    });
		                };
	
		                that._form = form.on("reset", that._resetHandler);
		            }
		        },
	
		        _parentWidget: function() {
		            var name = this.options.name;
	
		            if (!this.options.cascadeFrom) {
		                return;
		            }
	
		            var parentElement = $("#" + this.options.cascadeFrom);
		            var parent = parentElement.data("kendo" + name);
	
		            if (!parent) {
		                parent = parentElement.data("kendo" + alternativeNames[name]);
		            }
	
		            return parent;
		        },
	
		        _cascade: function() {
		            var that = this;
		            var options = that.options;
		            var cascade = options.cascadeFrom;
		            var parent;
	
		            if (cascade) {
		                parent = that._parentWidget();
	
		                if (!parent) {
		                    return;
		                }
	
		                that._cascadeHandlerProxy = proxy(that._cascadeHandler, that);
		                that._cascadeFilterRequests = [];
	
		                options.autoBind = false;
	
		                parent.bind("set", function() { //will cascade
		                    that.one("set", function(e) { //get your value
		                        that._selectedValue = e.value || that._accessor();
		                    });
		                });
	
		                parent.first(CASCADE, that._cascadeHandlerProxy);
	
		                //refresh was called
		                if (parent.listView.bound()) {
		                    that._toggleCascadeOnFocus();
		                    that._cascadeSelect(parent);
		                } else {
		                    parent.one("dataBound", function() {
		                        that._toggleCascadeOnFocus();
		                        if (parent.popup.visible()) {
		                            parent._focused.focus();
		                        }
		                    });
	
		                    if (!parent.value()) {
		                        that.enable(false);
		                    }
		                }
		            }
		        },
	
		        _toggleCascadeOnFocus: function() {
		            var that = this;
		            var parent = that._parentWidget();
		            var focusout = isIE ? "blur" : "focusout";
	
		            parent._focused.add(parent.filterInput).bind("focus", function() {
		                parent.unbind(CASCADE, that._cascadeHandlerProxy);
		                parent.first(CHANGE, that._cascadeHandlerProxy);
		            });
	
		            parent._focused.add(parent.filterInput).bind(focusout, function() {
		                parent.unbind(CHANGE, that._cascadeHandlerProxy);
		                parent.first(CASCADE, that._cascadeHandlerProxy);
		            });
		        },
	
		        _cascadeHandler: function(e) {
		            var parent = this._parentWidget();
		            var valueBeforeCascade = this.value();
	
		            this._userTriggered = e.userTriggered;
	
		            if (this.listView.bound()) {
		                this._clearSelection(parent, true);
		            }
	
		            this._cascadeSelect(parent, valueBeforeCascade);
		        },
	
		        _cascadeChange: function(parent) {
		            var that = this;
		            var value = that._accessor() || that._selectedValue;
	
		            if (!that._cascadeFilterRequests.length) {
		                that._selectedValue = null;
		            }
	
		            if (that._userTriggered) {
		                that._clearSelection(parent, true);
		            } else if (value) {
		                if (value !==  unifyType(that.listView.value()[0], typeof value)) {
		                    that.value(value);
		                }
	
		                if (!that.dataSource.view()[0] || that.selectedIndex === -1) {
		                    that._clearSelection(parent, true);
		                }
		            } else if (that.dataSource.flatView().length) {
		                that.select(that.options.index);
		            }
	
		            that.enable();
		            that._triggerCascade();
		            that._triggerChange();
		            that._userTriggered = false;
		        },
	
		        _cascadeSelect: function(parent, valueBeforeCascade) {
		            var that = this;
		            var dataItem = parent.dataItem();
		            var filterValue = dataItem ? dataItem[that.options.cascadeFromParentField] || parent._value(dataItem) : null;
		            var valueField = that.options.cascadeFromField || parent.options.dataValueField;
		            var expressions;
	
		            that._valueBeforeCascade = valueBeforeCascade !== undefined ? valueBeforeCascade : that.value();
	
		            if (filterValue || filterValue === 0) {
		                expressions = that.dataSource.filter() || {};
		                removeFiltersForField(expressions, valueField);
	
		                var handler = function () {
		                    var currentHandler = that._cascadeFilterRequests.shift();
		                    if (currentHandler) {
		                        that.unbind('dataBound', currentHandler);
		                    }
	
		                    currentHandler = that._cascadeFilterRequests[0];
		                    if (currentHandler) {
		                        that.first('dataBound', currentHandler);
		                    }
	
		                    that._cascadeChange(parent);
		                };
	
		                that._cascadeFilterRequests.push(handler);
	
		                if (that._cascadeFilterRequests.length === 1) {
		                    that.first('dataBound', handler);
		                }
	
		                that._cascading = true;
		                that._filterSource({
		                    field: valueField,
		                    operator: "eq",
		                    value: filterValue
		                });
		                that._cascading = false;
		            } else {
		                that.enable(false);
		                that._clearSelection(parent);
		                that._triggerCascade();
		                that._triggerChange();
		                that._userTriggered = false;
		            }
		        }
		    });
	
		    var STATIC_LIST_NS = ".StaticList";
	
		    var StaticList = kendo.ui.DataBoundWidget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this.element.attr("role", "listbox")
		                        .on("click" + STATIC_LIST_NS, "li", proxy(this._click, this))
		                        .on("mouseenter" + STATIC_LIST_NS, "li", function() { $(this).addClass(HOVER); })
		                        .on("mouseleave" + STATIC_LIST_NS, "li", function() { $(this).removeClass(HOVER); });
	
		            if (support.touch) {
		                this._touchHandlers();
		            }
	
		            if (this.options.selectable === "multiple") {
		                this.element.attr("aria-multiselectable", true);
		            }
	
		            this.content = this.element.wrap("<div class='k-list-scroller' unselectable='on'></div>").parent();
		            this.header = this.content.before('<div class="k-group-header" style="display:none"></div>').prev();
	
		            this.bound(false);
	
		            this._optionID = kendo.guid();
	
		            this._selectedIndices = [];
	
		            this._view = [];
		            this._dataItems = [];
		            this._values = [];
	
		            var value = this.options.value;
	
		            if (value) {
		                this._values = $.isArray(value) ? value.slice(0) : [value];
		            }
	
		            this._getter();
		            this._templates();
	
		            this.setDataSource(this.options.dataSource);
	
		            this._onScroll = proxy(function() {
		                var that = this;
		                clearTimeout(that._scrollId);
	
		                that._scrollId = setTimeout(function() {
		                    that._renderHeader();
		                }, 50);
		            }, this);
		        },
	
		        options: {
		            name: "StaticList",
		            dataValueField: null,
		            valuePrimitive: false,
		            selectable: true,
		            template: null,
		            groupTemplate: null,
		            fixedGroupTemplate: null
		        },
	
		        events: [
		           "click",
		            CHANGE,
		           "activate",
		           "deactivate",
		           "dataBinding",
		           "dataBound",
		           "selectedItemChange"
		        ],
	
		        setDataSource: function(source) {
		            var that = this;
		            var dataSource = source || {};
		            var value;
	
		            dataSource = $.isArray(dataSource) ? { data: dataSource } : dataSource;
		            dataSource = kendo.data.DataSource.create(dataSource);
	
		            if (that.dataSource) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
	
		                value = that.value();
	
		                that.value([]);
		                that.bound(false);
	
		                that.value(value);
		            } else {
		                that._refreshHandler = proxy(that.refresh, that);
		            }
	
		            that.setDSFilter(dataSource.filter());
	
		            that.dataSource = dataSource.bind(CHANGE, that._refreshHandler);
		            that._fixedHeader();
		        },
	
		        _touchHandlers: function () {
		            var that = this;
		            var startY;
		            var endY;
		            var tapPosition = function (event) {
		                return (event.originalEvent || event).changedTouches[0].pageY;
		            };
	
		            that.element.on("touchstart" + STATIC_LIST_NS, function (e) {
		                startY = tapPosition(e);
		            });
	
		            that.element.on("touchend" + STATIC_LIST_NS, function (e) {
		                if (e.isDefaultPrevented()) {
		                    return;
		                }
	
		                endY = tapPosition(e);
	
		                if (Math.abs(endY - startY) < 10) {
		                    e.preventDefault();
		                    that.trigger("click", { item: $(e.target.closest(ITEMSELECTOR)) });
		                }
		            });
		        },
	
		        skip: function() {
		            return this.dataSource.skip();
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
	
		            this._getter();
		            this._templates();
		            this._render();
		        },
	
		        destroy: function() {
		            this.element.off(STATIC_LIST_NS);
	
		            if (this._refreshHandler) {
		                this.dataSource.unbind(CHANGE, this._refreshHandler);
		            }
	
		            clearTimeout(this._scrollId);
	
		            Widget.fn.destroy.call(this);
		        },
	
		        dataItemByIndex: function(index) {
		            return this.dataSource.flatView()[index];
		        },
	
		        screenHeight: function() {
		            return this.content[0].clientHeight;
		        },
	
		        scrollToIndex: function(index) {
		            var item = this.element[0].children[index];
	
		            if (item) {
		                this.scroll(item);
		            }
		        },
	
		        scrollWith: function(value) {
		            this.content.scrollTop(this.content.scrollTop() + value);
		        },
	
		        scroll: function (item) {
		            if (!item) {
		                return;
		            }
	
		            if (item[0]) {
		                item = item[0];
		            }
	
		            var content = this.content[0],
		                itemOffsetTop = item.offsetTop,
		                itemOffsetHeight = item.offsetHeight,
		                contentScrollTop = content.scrollTop,
		                contentOffsetHeight = content.clientHeight,
		                bottomDistance = itemOffsetTop + itemOffsetHeight;
	
		                if (contentScrollTop > itemOffsetTop) {
		                    contentScrollTop = itemOffsetTop;
		                } else if (bottomDistance > (contentScrollTop + contentOffsetHeight)) {
		                    contentScrollTop = (bottomDistance - contentOffsetHeight);
		                }
	
		                content.scrollTop = contentScrollTop;
		        },
	
		        selectedDataItems: function(dataItems) {
		            if (dataItems === undefined) {
		                return this._dataItems.slice();
		            }
	
		            this._dataItems = dataItems;
		            this._values = this._getValues(dataItems);
		        },
	
		        _getValues: function(dataItems) {
		            var getter = this._valueGetter;
	
		            return $.map(dataItems, function(dataItem) {
		                return getter(dataItem);
		            });
		        },
	
		        focusNext: function() {
		            var current = this.focus();
	
		            if (!current) {
		                current = 0;
		            } else {
		                current = current.next();
		            }
	
		            this.focus(current);
		        },
	
		        focusPrev: function() {
		            var current = this.focus();
	
		            if (!current) {
		                current = this.element[0].children.length - 1;
		            } else {
		                current = current.prev();
		            }
	
		            this.focus(current);
		        },
	
		        focusFirst: function() {
		            this.focus(this.element[0].children[0]);
		        },
	
		        focusLast: function() {
		            this.focus(last(this.element[0].children));
		        },
	
		        focus: function(candidate) {
		            var that = this;
		            var id = that._optionID;
		            var hasCandidate;
	
		            if (candidate === undefined) {
		                return that._current;
		            }
	
		            candidate = last(that._get(candidate));
		            candidate = $(this.element[0].children[candidate]);
	
		            if (that._current) {
		                that._current
		                    .removeClass(FOCUSED)
		                    .removeAttr(ID);
	
		                that.trigger("deactivate");
		            }
	
		            hasCandidate = !!candidate[0];
	
		            if (hasCandidate) {
		                candidate.addClass(FOCUSED);
		                that.scroll(candidate);
	
		                candidate.attr("id", id);
		            }
	
		            that._current = hasCandidate ? candidate : null;
		            that.trigger("activate");
		        },
	
		        focusIndex: function() {
		            return this.focus() ? this.focus().index() : undefined;
		        },
	
		        skipUpdate: function(skipUpdate) {
		            this._skipUpdate = skipUpdate;
		        },
	
		        select: function(indices) {
		            var that = this;
		            var selectable = that.options.selectable;
		            var singleSelection = selectable !== "multiple" && selectable !== false;
		            var selectedIndices = that._selectedIndices;
	
		            var added = [];
		            var removed = [];
		            var result;
	
		            if (indices === undefined) {
		                return selectedIndices.slice();
		            }
	
		            indices = that._get(indices);
	
		            if (indices.length === 1 && indices[0] === -1) {
		                indices = [];
		            }
	
		            var deferred = $.Deferred().resolve();
		            var filtered = that.isFiltered();
	
		            if (filtered && !singleSelection && that._deselectFiltered(indices)) {
		                return deferred;
		            }
	
		            if (singleSelection && !filtered && $.inArray(last(indices), selectedIndices) !== -1) {
		                if (that._dataItems.length && that._view.length) {
		                    that._dataItems = [that._view[selectedIndices[0]].item];
		                }
	
		                return deferred;
		            }
	
		            result = that._deselect(indices);
	
		            removed = result.removed;
		            indices = result.indices;
	
		            if (indices.length) {
		                if (singleSelection) {
		                    indices = [last(indices)];
		                }
	
		                added = that._select(indices);
		            }
	
		            if (added.length || removed.length) {
		                that._valueComparer = null;
		                that.trigger(CHANGE, {
		                    added: added,
		                    removed: removed
		                });
		            }
	
		            return deferred;
		        },
	
		        removeAt: function(position) {
		            this._selectedIndices.splice(position, 1);
		            this._values.splice(position, 1);
		            this._valueComparer = null;
	
		            return {
		                position: position,
		                dataItem: this._dataItems.splice(position, 1)[0]
		            };
		        },
	
		        setValue: function(value) {
		            value = $.isArray(value) || value instanceof ObservableArray ? value.slice(0) : [value];
	
		            this._values = value;
	
		            this._valueComparer = null;
		        },
	
		        value: function(value) {
		            var that = this;
		            var deferred = that._valueDeferred;
		            var indices;
	
		            if (value === undefined) {
		                return that._values.slice();
		            }
	
		            that.setValue(value);
	
		            if (!deferred || deferred.state() === "resolved") {
		                that._valueDeferred = deferred = $.Deferred();
		            }
	
		            if (that.bound()) {
		                indices = that._valueIndices(that._values);
	
		                if (that.options.selectable === "multiple") {
		                    that.select(-1);
		                }
	
		                that.select(indices);
	
		                deferred.resolve();
		            }
	
		            that._skipUpdate = false;
	
		            return deferred;
		        },
	
		        items: function() {
		            return this.element.children(ITEMSELECTOR);
		        },
	
		        _click: function(e) {
		            if (!e.isDefaultPrevented()) {
		                if (!this.trigger("click", { item: $(e.currentTarget) })) {
		                    this.select(e.currentTarget);
		                }
		            }
		        },
	
		        _valueExpr: function(type, values) {
		            var that = this;
		            var idx = 0;
	
		            var body;
		            var comparer;
		            var normalized = [];
	
		            if (!that._valueComparer  || that._valueType !== type) {
		                that._valueType = type;
	
		                for (; idx < values.length; idx++) {
		                    normalized.push(unifyType(values[idx], type));
		                }
	
		                body = "for (var idx = 0; idx < " + normalized.length + "; idx++) {" +
		                        " if (current === values[idx]) {" +
		                        "   return idx;" +
		                        " }" +
		                        "} " +
		                        "return -1;";
	
		                comparer = new Function("current", "values", body);
	
		                that._valueComparer = function(current) {
		                    return comparer(current, normalized);
		                };
		            }
	
		            return that._valueComparer;
		        },
	
		        _dataItemPosition: function(dataItem, values) {
		            var value = this._valueGetter(dataItem);
	
		            var valueExpr = this._valueExpr(typeof value, values);
	
		            return valueExpr(value);
		        },
	
		        _getter: function() {
		            this._valueGetter = kendo.getter(this.options.dataValueField);
		        },
	
		        _deselect: function(indices) {
		            var that = this;
		            var children = that.element[0].children;
		            var selectable = that.options.selectable;
		            var selectedIndices = that._selectedIndices;
		            var dataItems = that._dataItems;
		            var values = that._values;
		            var removed = [];
		            var i = 0;
		            var j;
	
		            var index, selectedIndex;
		            var removedIndices = 0;
	
		            indices = indices.slice();
	
		            if (selectable === true || !indices.length) {
		                for (; i < selectedIndices.length; i++) {
		                    $(children[selectedIndices[i]]).removeClass("k-state-selected").attr("aria-selected", false);
	
		                    removed.push({
		                        position: i,
		                        dataItem: dataItems[i]
		                    });
		                }
	
		                that._values = [];
		                that._dataItems = [];
		                that._selectedIndices = [];
		            } else if (selectable === "multiple") {
		                for (; i < indices.length; i++) {
		                    index = indices[i];
	
		                    if (!$(children[index]).hasClass("k-state-selected")) {
		                        continue;
		                    }
	
		                    for (j = 0; j < selectedIndices.length; j++) {
		                        selectedIndex = selectedIndices[j];
	
		                        if (selectedIndex === index) {
		                            $(children[selectedIndex]).removeClass("k-state-selected").attr("aria-selected", false);
	
		                            removed.push({
		                                position: j + removedIndices,
		                                dataItem: dataItems.splice(j, 1)[0]
		                            });
	
		                            selectedIndices.splice(j, 1);
		                            indices.splice(i, 1);
		                            values.splice(j, 1);
	
		                            removedIndices += 1;
		                            i -= 1;
		                            j -= 1;
		                            break;
		                        }
		                    }
		                }
		            }
	
		            return {
		                indices: indices,
		                removed: removed
		            };
		        },
	
		        _deselectFiltered: function(indices) {
		            var children = this.element[0].children;
		            var dataItem, index, position;
		            var removed = [];
		            var idx = 0;
	
		            for (; idx < indices.length; idx++) {
		                index = indices[idx];
		                dataItem = this._view[index].item;
		                position = this._dataItemPosition(dataItem, this._values);
	
		                if (position > -1) {
		                    removed.push(this.removeAt(position));
		                    $(children[index]).removeClass("k-state-selected");
		                }
		            }
	
		            if (removed.length) {
		                this.trigger(CHANGE, {
		                    added: [],
		                    removed: removed
		                });
	
		                return true;
		            }
	
		            return false;
		        },
	
		        _select: function(indices) {
		            var that = this;
		            var children = that.element[0].children;
		            var data = that._view;
		            var dataItem, index;
		            var added = [];
		            var idx = 0;
	
		            if (last(indices) !== -1) {
		                that.focus(indices);
		            }
	
		            for (; idx < indices.length; idx++) {
		                index = indices[idx];
		                dataItem = data[index];
	
		                if (index === -1 || !dataItem) {
		                    continue;
		                }
	
		                dataItem = dataItem.item;
	
		                that._selectedIndices.push(index);
		                that._dataItems.push(dataItem);
		                that._values.push(that._valueGetter(dataItem));
	
		                $(children[index]).addClass("k-state-selected").attr("aria-selected", true);
	
		                added.push({
		                    dataItem: dataItem
		                });
		            }
	
		            return added;
		        },
	
		        getElementIndex: function(element) {
		            return $(element).data("offset-index");
		        },
	
		        _get: function(candidate) {
		            if (typeof candidate === "number") {
		                candidate = [candidate];
		            } else if (!isArray(candidate)) {
		                candidate = this.getElementIndex(candidate);
		                candidate = [candidate !== undefined ? candidate : -1];
		            }
	
		            return candidate;
		        },
	
		        _template: function() {
		            var that = this;
		            var options = that.options;
		            var template = options.template;
	
		            if (!template) {
		                template = kendo.template('<li tabindex="-1" role="option" unselectable="on" class="k-item">${' + kendo.expr(options.dataTextField, "data") + "}</li>", { useWithBlock: false });
		            } else {
		                template = kendo.template(template);
		                template = function(data) {
		                    return '<li tabindex="-1" role="option" unselectable="on" class="k-item">' + template(data) + "</li>";
		                };
		            }
	
		            return template;
		        },
	
		        _templates: function() {
		            var template;
		            var options = this.options;
		            var templates = {
		                template: options.template,
		                groupTemplate: options.groupTemplate,
		                fixedGroupTemplate: options.fixedGroupTemplate
		            };
	
		            if (options.columns) {
		                for (var i = 0; i < options.columns.length; i++) {
		                    var currentColumn = options.columns[i];
		                    var templateText = currentColumn.field ? currentColumn.field.toString(): "text";
	
		                    templates["column"+ i] = currentColumn.template || "#: " + templateText + "#";
		                }
		            }
	
		            for (var key in templates) {
		                template = templates[key];
		                if (template && typeof template !== "function") {
		                    templates[key] = kendo.template(template);
		                }
		            }
	
		            this.templates = templates;
		        },
	
		        _normalizeIndices: function(indices) {
		            var newIndices = [];
		            var idx = 0;
	
		            for (; idx < indices.length; idx++) {
		                if (indices[idx] !== undefined) {
		                    newIndices.push(indices[idx]);
		                }
		            }
	
		            return newIndices;
		        },
	
		        _valueIndices: function(values, indices) {
		            var data = this._view;
		            var idx = 0;
		            var index;
	
		            indices = indices ? indices.slice() : [];
	
		            if (!values.length) {
		                return [];
		            }
	
		            for (; idx < data.length; idx++) {
		                index = this._dataItemPosition(data[idx].item, values);
	
		                if (index !== -1) {
		                    indices[index] = idx;
		                }
		            }
	
		            return this._normalizeIndices(indices);
		        },
	
		        _firstVisibleItem: function() {
		            var element = this.element[0];
		            var content = this.content[0];
		            var scrollTop = content.scrollTop;
		            var itemHeight = $(element.children[0]).height();
		            var itemIndex = Math.floor(scrollTop / itemHeight) || 0;
		            var item = element.children[itemIndex] || element.lastChild;
		            var forward = item.offsetTop < scrollTop;
	
		            while (item) {
		                if (forward) {
		                    if ((item.offsetTop + itemHeight) > scrollTop || !item.nextSibling) {
		                        break;
		                    }
	
		                    item = item.nextSibling;
		                } else {
		                    if (item.offsetTop <= scrollTop || !item.previousSibling) {
		                        break;
		                    }
	
		                    item = item.previousSibling;
		                }
		            }
	
		            return this._view[$(item).data("offset-index")];
		        },
	
		        _fixedHeader: function() {
		            if (this.isGrouped() && this.templates.fixedGroupTemplate) {
		                this.header.show();
		                this.content.scroll(this._onScroll);
		            } else {
		                this.header.hide();
		                this.content.off("scroll", this._onScroll);
		            }
		        },
	
		        _renderHeader: function() {
		            var template = this.templates.fixedGroupTemplate;
		            if (!template) {
		                return;
		            }
	
		            var visibleItem = this._firstVisibleItem();
	
		            if (visibleItem && visibleItem.group) {
		                this.header.html(template(visibleItem.group));
		            }
		        },
	
		        _renderItem: function(context) {
		            var item = '<li tabindex="-1" role="option" unselectable="on" class="k-item';
	
		            var dataItem = context.item;
		            var notFirstItem = context.index !== 0;
		            var selected = context.selected;
		            var isGrouped = this.isGrouped();
		            var hasColumns = this.options.columns && this.options.columns.length;
	
		            if (notFirstItem && context.newGroup) {
		                item += ' k-first';
		            }
	
		            if (context.isLastGroupedItem && hasColumns) {
		                item += ' k-last';
		            }
	
		            if (selected) {
		                item += ' k-state-selected';
		            }
	
		            item += '" aria-selected="' + (selected ? "true" : "false") + '" data-offset-index="' + context.index + '">';
		            if (hasColumns) {
		                item += this._renderColumns(dataItem);
		            } else {
		                item += this.templates.template(dataItem);
		            }
	
		            if (notFirstItem && context.newGroup) {
		                if (hasColumns) {
		                    item += '<div class="k-cell k-group-cell"><span>' + this.templates.groupTemplate(context.group) + '</span></div>';
		                } else {
		                    item += '<div class="k-group">' + this.templates.groupTemplate(context.group) + '</div>';
		                }
		            } else if (isGrouped && hasColumns) {
		                item += "<div class='k-cell k-spacer-cell'></div>";
		            }
	
		            return item + "</li>";
		        },
	
		        _renderColumns: function(dataItem) {
		            var item = "";
	
		            for (var i = 0; i < this.options.columns.length; i++) {
		                var currentWidth = this.options.columns[i].width;
		                var currentWidthInt = parseInt(currentWidth, 10);
		                var widthStyle = '';
	
		                if (currentWidth && !isNaN(currentWidthInt)) {
		                    widthStyle += "style='width:";
		                    widthStyle += currentWidthInt;
		                    widthStyle += percentageUnitsRegex.test(currentWidth) ? "%" : "px";
		                    widthStyle += ";'";
		                }
		                item += "<span class='k-cell' " + widthStyle + ">";
		                item += this.templates["column"+ i](dataItem);
		                item += "</span>";
		            }
	
		            return item;
		        },
	
		        _render: function() {
		            var html = "";
	
		            var i = 0;
		            var idx = 0;
		            var context;
		            var dataContext = [];
		            var view = this.dataSource.view();
		            var values = this.value();
	
		            var group, newGroup, j;
		            var isGrouped = this.isGrouped();
	
		            if (isGrouped) {
		                for (i = 0; i < view.length; i++) {
		                    group = view[i];
		                    newGroup = true;
	
		                    for (j = 0; j < group.items.length; j++) {
		                        context = {
		                            selected: this._selected(group.items[j], values),
		                            item: group.items[j],
		                            group: group.value,
		                            newGroup: newGroup,
		                            isLastGroupedItem: j === group.items.length - 1,
		                            index: idx };
		                        dataContext[idx] = context;
		                        idx += 1;
	
		                        html += this._renderItem(context);
		                        newGroup = false;
		                    }
		                }
		            } else {
		                for (i = 0; i < view.length; i++) {
		                    context = { selected: this._selected(view[i], values), item: view[i], index: i };
	
		                    dataContext[i] = context;
	
		                    html += this._renderItem(context);
		                }
		            }
	
		            this._view = dataContext;
	
		            this.element[0].innerHTML = html;
	
		            if (isGrouped && dataContext.length) {
		                this._renderHeader();
		            }
		        },
	
		        _selected: function(dataItem, values) {
		            var select = !this.isFiltered() || this.options.selectable === "multiple";
		            return select && this._dataItemPosition(dataItem, values) !== -1;
		        },
	
		        setDSFilter: function(filter) {
		            this._lastDSFilter = extend({}, filter);
		        },
	
		        isFiltered: function() {
		            if (!this._lastDSFilter) {
		                this.setDSFilter(this.dataSource.filter());
		            }
	
		            return !kendo.data.Query.compareFilters(this.dataSource.filter(), this._lastDSFilter);
		        },
	
		        refresh: function(e) {
		            var that = this;
		            var action = e && e.action;
		            var skipUpdateOnBind = that.options.skipUpdateOnBind;
		            var isItemChange = action === "itemchange";
		            var result;
	
		            that.trigger("dataBinding");
		            that._angularItems("cleanup");
	
		            that._fixedHeader();
	
		            that._render();
	
		            that.bound(true);
	
		            if (isItemChange || action === "remove") {
		                result = mapChangedItems(that._dataItems, e.items);
	
		                if (result.changed.length) {
		                    if (isItemChange) {
		                        that.trigger("selectedItemChange", {
		                            items: result.changed
		                        });
		                    } else {
		                        that.value(that._getValues(result.unchanged));
		                    }
		                }
		            } else if (that.isFiltered() || that._skipUpdate || that._emptySearch) {
		                that.focus(0);
		                if (that._skipUpdate) {
		                    that._skipUpdate = false;
		                    that._selectedIndices = that._valueIndices(that._values, that._selectedIndices);
		                }
		            } else if (!skipUpdateOnBind && (!action || action === "add")) {
		                that.value(that._values);
		            }
	
		            if (that._valueDeferred) {
		                that._valueDeferred.resolve();
		            }
	
		            that._angularItems("compile");
		            that.trigger("dataBound");
		        },
	
		        bound: function(bound) {
		            if (bound === undefined) {
		                return this._bound;
		            }
	
		            this._bound = bound;
		        },
	
		        isGrouped: function() {
		            return (this.dataSource.group() || []).length;
		        }
		    });
	
		    ui.plugin(StaticList);
	
		    function last(list) {
		        return list[list.length - 1];
		    }
	
		    function getSelectedOption(select) {
		        var index = select.selectedIndex;
		        return index > -1 ? select.options[index] : {};
		    }
	
		    function mapChangedItems(selected, itemsToMatch) {
		        var itemsLength = itemsToMatch.length;
		        var selectedLength = selected.length;
		        var dataItem;
		        var found;
		        var i, j;
	
		        var changed = [];
		        var unchanged = [];
	
		        if (selectedLength) {
		            for (i = 0; i < selectedLength; i++) {
		                dataItem = selected[i];
		                found = false;
	
		                for (j = 0; j < itemsLength; j++) {
		                    if (dataItem === itemsToMatch[j]) {
		                        found = true;
		                        changed.push({ index: i, item: dataItem });
		                        break;
		                    }
		                }
	
		                if (!found) {
		                    unchanged.push(dataItem);
		                }
		            }
		        }
	
		        return {
		            changed: changed,
		            unchanged: unchanged
		        };
		    }
	
		    function isValidFilterExpr(expression) {
		        if (!expression || $.isEmptyObject(expression)) {
		            return false;
		        }
	
		        if (expression.filters && !expression.filters.length) {
		            return false;
		        }
	
		        return true;
		    }
	
		    function removeFiltersForField(expression, field) {
		        var filters;
		        var found = false;
	
		        if (expression.filters) {
		            filters = $.grep(expression.filters, function(filter) {
		                found = removeFiltersForField(filter, field);
		                if (filter.filters) {
		                    return filter.filters.length;
		                } else {
		                    return filter.field != field;
		                }
		            });
	
		            if (!found && expression.filters.length !== filters.length) {
		                found = true;
		            }
	
		            expression.filters = filters;
		        }
	
		        return found;
		    }
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1046);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1046:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1047), __webpack_require__(1048) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "data",
		    name: "Data source",
		    category: "framework",
		    description: "Powerful component for using local and remote data.Fully supports CRUD, Sorting, Paging, Filtering, Grouping, and Aggregates.",
		    depends: [ "core" ],
		    features: [ {
		        id: "data-odata",
		        name: "OData",
		        description: "Support for accessing Open Data Protocol (OData) services.",
		        depends: [ "data.odata" ]
		    }, {
		        id: "data-signalr",
		        name: "SignalR",
		        description: "Support for binding to SignalR hubs.",
		        depends: [ "data.signalr" ]
		    }, {
		        id: "data-XML",
		        name: "XML",
		        description: "Support for binding to XML.",
		        depends: [ "data.xml" ]
		    }]
		};
	
		/*jshint eqnull: true, loopfunc: true, evil: true */
		(function($, undefined) {
		    var extend = $.extend,
		        proxy = $.proxy,
		        isPlainObject = $.isPlainObject,
		        isEmptyObject = $.isEmptyObject,
		        isArray = $.isArray,
		        grep = $.grep,
		        ajax = $.ajax,
		        map,
		        each = $.each,
		        noop = $.noop,
		        kendo = window.kendo,
		        isFunction = kendo.isFunction,
		        Observable = kendo.Observable,
		        Class = kendo.Class,
		        STRING = "string",
		        FUNCTION = "function",
		        CREATE = "create",
		        READ = "read",
		        UPDATE = "update",
		        DESTROY = "destroy",
		        CHANGE = "change",
		        SYNC = "sync",
		        GET = "get",
		        ERROR = "error",
		        REQUESTSTART = "requestStart",
		        PROGRESS = "progress",
		        REQUESTEND = "requestEnd",
		        crud = [CREATE, READ, UPDATE, DESTROY],
		        identity = function(o) { return o; },
		        getter = kendo.getter,
		        stringify = kendo.stringify,
		        math = Math,
		        push = [].push,
		        join = [].join,
		        pop = [].pop,
		        splice = [].splice,
		        shift = [].shift,
		        slice = [].slice,
		        unshift = [].unshift,
		        toString = {}.toString,
		        stableSort = kendo.support.stableSort,
		        dateRegExp = /^\/Date\((.*?)\)\/$/;
	
		    var ObservableArray = Observable.extend({
		        init: function(array, type) {
		            var that = this;
	
		            that.type = type || ObservableObject;
	
		            Observable.fn.init.call(that);
	
		            that.length = array.length;
	
		            that.wrapAll(array, that);
		        },
	
		        at: function(index) {
		            return this[index];
		        },
	
		        toJSON: function() {
		            var idx, length = this.length, value, json = new Array(length);
	
		            for (idx = 0; idx < length; idx++){
		                value = this[idx];
	
		                if (value instanceof ObservableObject) {
		                    value = value.toJSON();
		                }
	
		                json[idx] = value;
		            }
	
		            return json;
		        },
	
		        parent: noop,
	
		        wrapAll: function(source, target) {
		            var that = this,
		                idx,
		                length,
		                parent = function() {
		                    return that;
		                };
	
		            target = target || [];
	
		            for (idx = 0, length = source.length; idx < length; idx++) {
		                target[idx] = that.wrap(source[idx], parent);
		            }
	
		            return target;
		        },
	
		        wrap: function(object, parent) {
		            var that = this,
		                observable;
	
		            if (object !== null && toString.call(object) === "[object Object]") {
		                observable = object instanceof that.type || object instanceof Model;
	
		                if (!observable) {
		                    object = object instanceof ObservableObject ? object.toJSON() : object;
		                    object = new that.type(object);
		                }
	
		                object.parent = parent;
	
		                object.bind(CHANGE, function(e) {
		                    that.trigger(CHANGE, {
		                        field: e.field,
		                        node: e.node,
		                        index: e.index,
		                        items: e.items || [this],
		                        action: e.node ? (e.action || "itemloaded") : "itemchange"
		                    });
		                });
		            }
	
		            return object;
		        },
	
		        push: function() {
		            var index = this.length,
		                items = this.wrapAll(arguments),
		                result;
	
		            result = push.apply(this, items);
	
		            this.trigger(CHANGE, {
		                action: "add",
		                index: index,
		                items: items
		            });
	
		            return result;
		        },
	
		        slice: slice,
	
		        sort: [].sort,
	
		        join: join,
	
		        pop: function() {
		            var length = this.length, result = pop.apply(this);
	
		            if (length) {
		                this.trigger(CHANGE, {
		                    action: "remove",
		                    index: length - 1,
		                    items:[result]
		                });
		            }
	
		            return result;
		        },
	
		        splice: function(index, howMany, item) {
		            var items = this.wrapAll(slice.call(arguments, 2)),
		                result, i, len;
	
		            result = splice.apply(this, [index, howMany].concat(items));
	
		            if (result.length) {
		                this.trigger(CHANGE, {
		                    action: "remove",
		                    index: index,
		                    items: result
		                });
	
		                for (i = 0, len = result.length; i < len; i++) {
		                    if (result[i] && result[i].children) {
		                        result[i].unbind(CHANGE);
		                    }
		                }
		            }
	
		            if (item) {
		                this.trigger(CHANGE, {
		                    action: "add",
		                    index: index,
		                    items: items
		                });
		            }
		            return result;
		        },
	
		        shift: function() {
		            var length = this.length, result = shift.apply(this);
	
		            if (length) {
		                this.trigger(CHANGE, {
		                    action: "remove",
		                    index: 0,
		                    items:[result]
		                });
		            }
	
		            return result;
		        },
	
		        unshift: function() {
		            var items = this.wrapAll(arguments),
		                result;
	
		            result = unshift.apply(this, items);
	
		            this.trigger(CHANGE, {
		                action: "add",
		                index: 0,
		                items: items
		            });
	
		            return result;
		        },
	
		        indexOf: function(item) {
		            var that = this,
		                idx,
		                length;
	
		            for (idx = 0, length = that.length; idx < length; idx++) {
		                if (that[idx] === item) {
		                    return idx;
		                }
		            }
		            return -1;
		        },
	
		        forEach: function(callback, thisArg) {
		            var idx = 0;
		            var length = this.length;
		            var context = thisArg || window;
	
		            for (; idx < length; idx++) {
		                callback.call(context, this[idx], idx, this);
		            }
		        },
	
		        map: function(callback, thisArg) {
		            var idx = 0;
		            var result = [];
		            var length = this.length;
		            var context = thisArg || window;
	
		            for (; idx < length; idx++) {
		                result[idx] = callback.call(context, this[idx], idx, this);
		            }
	
		            return result;
		        },
	
		        reduce: function(callback) {
		            var idx = 0,
		                result,
		                length = this.length;
	
		            if (arguments.length == 2) {
		                result = arguments[1];
		            } else if (idx < length) {
		                result = this[idx++];
		            }
	
		            for (; idx < length; idx++) {
		                result = callback(result, this[idx], idx, this);
		            }
	
		            return result;
		        },
	
		        reduceRight: function(callback) {
		            var idx = this.length - 1,
		                result;
	
		            if (arguments.length == 2) {
		                result = arguments[1];
		            } else if (idx > 0) {
		                result = this[idx--];
		            }
	
		            for (; idx >= 0; idx--) {
		                result = callback(result, this[idx], idx, this);
		            }
	
		            return result;
		        },
	
		        filter: function(callback, thisArg) {
		            var idx = 0;
		            var result = [];
		            var item;
		            var length = this.length;
		            var context = thisArg || window;
	
		            for (; idx < length; idx++) {
		                item = this[idx];
		                if (callback.call(context, item, idx, this)) {
		                    result[result.length] = item;
		                }
		            }
	
		            return result;
		        },
	
		        find: function(callback, thisArg) {
		            var idx = 0;
		            var item;
		            var length = this.length;
		            var context = thisArg || window;
	
		            for (; idx < length; idx++) {
		                item = this[idx];
		                if (callback.call(context, item, idx, this)) {
		                    return item;
		                }
		            }
		        },
	
		        every: function(callback, thisArg) {
		            var idx = 0;
		            var item;
		            var length = this.length;
		            var context = thisArg || window;
	
		            for (; idx < length; idx++) {
		                item = this[idx];
		                if (!callback.call(context, item, idx, this)) {
		                    return false;
		                }
		            }
	
		            return true;
		        },
	
		        some: function(callback, thisArg) {
		            var idx = 0;
		            var item;
		            var length = this.length;
		            var context = thisArg || window;
	
		            for (; idx < length; idx++) {
		                item = this[idx];
		                if (callback.call(context, item, idx, this)) {
		                    return true;
		                }
		            }
	
		            return false;
		        },
	
		        // non-standard collection methods
		        remove: function(item) {
		            var idx = this.indexOf(item);
	
		            if (idx !== -1) {
		                this.splice(idx, 1);
		            }
		        },
	
		        empty: function() {
		            this.splice(0, this.length);
		        }
		    });
	
		    // Polyfill for Symbol.iterator
		    if (typeof Symbol !== "undefined" && Symbol.iterator && !ObservableArray.prototype[Symbol.iterator]) {
		        ObservableArray.prototype[Symbol.iterator] = [][Symbol.iterator];
		    }
	
		    var LazyObservableArray = ObservableArray.extend({
		        init: function (data, type, events) {
		            Observable.fn.init.call(this);
	
		            this.type = type || ObservableObject;
	
		            if (events) {
		                this._events = events;
		            }
	
		            for (var idx = 0; idx < data.length; idx++) {
		                this[idx] = data[idx];
		            }
	
		            this.length = idx;
		            this._parent = proxy(function() { return this; }, this);
		        },
		        at: function(index) {
		            var item = this[index];
	
		            if (!(item instanceof this.type)) {
		                item = this[index] = this.wrap(item, this._parent);
		            } else {
		                item.parent = this._parent;
		            }
	
		            return item;
		        }
		    });
	
		    function eventHandler(context, type, field, prefix) {
		        return function(e) {
		            var event = {}, key;
	
		            for (key in e) {
		                event[key] = e[key];
		            }
	
		            if (prefix) {
		                event.field = field + "." + e.field;
		            } else {
		                event.field = field;
		            }
	
		            if (type == CHANGE && context._notifyChange) {
		                context._notifyChange(event);
		            }
	
		            context.trigger(type, event);
		        };
		    }
	
		    var ObservableObject = Observable.extend({
		        init: function(value) {
		            var that = this,
		                member,
		                field,
		                parent = function() {
		                    return that;
		                };
	
		            Observable.fn.init.call(this);
	
		            this._handlers = {};
	
		            for (field in value) {
		                member = value[field];
	
		                if (typeof member === "object" && member && !member.getTime && field.charAt(0) != "_") {
		                    member = that.wrap(member, field, parent);
		                }
	
		                that[field] = member;
		            }
	
		            that.uid = kendo.guid();
		        },
	
		        shouldSerialize: function(field) {
		            return this.hasOwnProperty(field) && field !== "_handlers" && field !== "_events" && typeof this[field] !== FUNCTION && field !== "uid";
		        },
	
		        forEach: function(f) {
		            for (var i in this) {
		                if (this.shouldSerialize(i)) {
		                    f(this[i], i);
		                }
		            }
		        },
	
		        toJSON: function() {
		            var result = {}, value, field;
	
		            for (field in this) {
		                if (this.shouldSerialize(field)) {
		                    value = this[field];
	
		                    if (value instanceof ObservableObject || value instanceof ObservableArray) {
		                        value = value.toJSON();
		                    }
	
		                    result[field] = value;
		                }
		            }
	
		            return result;
		        },
	
		        get: function(field) {
		            var that = this, result;
	
		            that.trigger(GET, { field: field });
	
		            if (field === "this") {
		                result = that;
		            } else {
		                result = kendo.getter(field, true)(that);
		            }
	
		            return result;
		        },
	
		        _set: function(field, value) {
		            var that = this;
		            var composite = field.indexOf(".") >= 0;
	
		            if (composite) {
		                var paths = field.split("."),
		                    path = "";
	
		                while (paths.length > 1) {
		                    path += paths.shift();
		                    var obj = kendo.getter(path, true)(that);
		                    if (obj instanceof ObservableObject) {
		                        obj.set(paths.join("."), value);
		                        return composite;
		                    }
		                    path += ".";
		                }
		            }
	
		            kendo.setter(field)(that, value);
	
		            return composite;
		        },
	
		        set: function(field, value) {
		            var that = this,
		                isSetPrevented = false,
		                composite = field.indexOf(".") >= 0,
		                current = kendo.getter(field, true)(that);
	
		            if (current !== value) {
		                if (current instanceof Observable && this._handlers[field]) {
		                    if (this._handlers[field].get) {
		                       current.unbind(GET, this._handlers[field].get);
		                    }
		                    current.unbind(CHANGE, this._handlers[field].change);
		                }
	
		                isSetPrevented = that.trigger("set", { field: field, value: value });
	
		                if (!isSetPrevented) {
		                    if (!composite) {
		                        value = that.wrap(value, field, function() { return that; });
		                    }
		                    if (!that._set(field, value) || field.indexOf("(") >= 0 || field.indexOf("[") >= 0) {
		                        that.trigger(CHANGE, { field: field });
		                    }
		                }
		            }
	
		            return isSetPrevented;
		        },
	
		        parent: noop,
	
		        wrap: function(object, field, parent) {
		            var that = this;
		            var get;
		            var change;
		            var type = toString.call(object);
	
		            if (object != null && (type === "[object Object]" || type === "[object Array]")) {
		                var isObservableArray = object instanceof ObservableArray;
		                var isDataSource = object instanceof DataSource;
	
		                if (type === "[object Object]" && !isDataSource && !isObservableArray) {
		                    if (!(object instanceof ObservableObject)) {
		                        object = new ObservableObject(object);
		                    }
	
		                    get = eventHandler(that, GET, field, true);
		                    object.bind(GET, get);
		                    change = eventHandler(that, CHANGE, field, true);
		                    object.bind(CHANGE, change);
	
		                    that._handlers[field] = { get: get, change: change };
		                } else if (type === "[object Array]" || isObservableArray || isDataSource) {
		                    if (!isObservableArray && !isDataSource) {
		                        object = new ObservableArray(object);
		                    }
	
		                    change = eventHandler(that, CHANGE, field, false);
	
		                    object.bind(CHANGE, change);
	
		                    that._handlers[field] = { change: change };
		                }
	
		                object.parent = parent;
		            }
	
		            return object;
		        }
		    });
	
		    function equal(x, y) {
		        if (x === y) {
		            return true;
		        }
	
		        var xtype = $.type(x), ytype = $.type(y), field;
	
		        if (xtype !== ytype) {
		            return false;
		        }
	
		        if (xtype === "date") {
		            return x.getTime() === y.getTime();
		        }
	
		        if (xtype !== "object" && xtype !== "array") {
		            return false;
		        }
	
		        for (field in x) {
		            if (!equal(x[field], y[field])) {
		                return false;
		            }
		        }
	
		        return true;
		    }
	
		    var parsers = {
		        "number": function(value) {
		            if (typeof value === STRING && value.toLowerCase() === "null") {
		                return null;
		            }
		            return kendo.parseFloat(value);
		        },
	
		        "date": function(value) {
		            if (typeof value === STRING && value.toLowerCase() === "null") {
		                return null;
		            }
		            return kendo.parseDate(value);
		        },
	
		        "boolean": function(value) {
		            if (typeof value === STRING) {
		                if (value.toLowerCase() === "null") {
		                    return null;
		                } else {
		                    return value.toLowerCase() === "true";
		                }
		            }
		            return value != null ? !!value : value;
		        },
	
		        "string": function(value) {
		            if (typeof value === STRING && value.toLowerCase() === "null") {
		                return null;
		            }
		            return value != null ? (value + "") : value;
		        },
	
		        "default": function(value) {
		            return value;
		        }
		    };
	
		    var defaultValues = {
		        "string": "",
		        "number": 0,
		        "date": new Date(),
		        "boolean": false,
		        "default": ""
		    };
	
		    function getFieldByName(obj, name) {
		        var field,
		            fieldName;
	
		        for (fieldName in obj) {
		            field = obj[fieldName];
		            if (isPlainObject(field) && field.field && field.field === name) {
		                return field;
		            } else if (field === name) {
		                return field;
		            }
		        }
		        return null;
		    }
	
		    var Model = ObservableObject.extend({
		        init: function(data) {
		            var that = this;
	
		            if (!data || $.isEmptyObject(data)) {
		                data = $.extend({}, that.defaults, data);
	
		                if (that._initializers) {
		                    for (var idx = 0; idx < that._initializers.length; idx++) {
		                         var name = that._initializers[idx];
		                         data[name] = that.defaults[name]();
		                    }
		                }
		            }
	
		            ObservableObject.fn.init.call(that, data);
	
		            that.dirty = false;
		            that.dirtyFields = {};
	
		            if (that.idField) {
		                that.id = that.get(that.idField);
	
		                if (that.id === undefined) {
		                    that.id = that._defaultId;
		                }
		            }
		        },
	
		        shouldSerialize: function(field) {
		            return ObservableObject.fn.shouldSerialize.call(this, field) &&
		                field !== "uid" && !(this.idField !== "id" && field === "id") &&
		                field !== "dirty" &&  field !== "dirtyFields" && field !== "_accessors";
		        },
	
		        _parse: function(field, value) {
		            var that = this,
		                fieldName = field,
		                fields = (that.fields || {}),
		                parse;
	
		            field = fields[field];
		            if (!field) {
		                field = getFieldByName(fields, fieldName);
		            }
		            if (field) {
		                parse = field.parse;
		                if (!parse && field.type) {
		                    parse = parsers[field.type.toLowerCase()];
		                }
		            }
	
		            return parse ? parse(value) : value;
		        },
	
		        _notifyChange: function(e) {
		            var action = e.action;
	
		            if (action == "add" || action == "remove") {
		                this.dirty = true;
		                this.dirtyFields[e.field] = true;
		            }
		        },
	
		        editable: function(field) {
		            field = (this.fields || {})[field];
		            return field ? field.editable !== false : true;
		        },
	
		        set: function(field, value, initiator) {
		            var that = this;
		            var dirty = that.dirty;
	
		            if (that.editable(field)) {
		                value = that._parse(field, value);
	
		                if (!equal(value, that.get(field))) {
		                    that.dirty = true;
		                    that.dirtyFields[field] = true;
	
		                    if (ObservableObject.fn.set.call(that, field, value, initiator) && !dirty) {
		                        that.dirty = dirty;
	
		                        if (!that.dirty) {
		                            that.dirtyFields[field] = false;
		                        }
		                    }
		                } else {
		                    that.trigger("equalSet", { field: field, value: value });
		                }
		            }
		        },
	
		        accept: function(data) {
		            var that = this,
		                parent = function() { return that; },
		                field;
	
		            for (field in data) {
		                var value = data[field];
	
		                if (field.charAt(0) != "_") {
		                    value = that.wrap(data[field], field, parent);
		                }
	
		                that._set(field, value);
		            }
	
		            if (that.idField) {
		                that.id = that.get(that.idField);
		            }
	
		            that.dirty = false;
		            that.dirtyFields = {};
		        },
	
		        isNew: function() {
		            return this.id === this._defaultId;
		        }
		    });
	
		    Model.define = function(base, options) {
		        if (options === undefined) {
		            options = base;
		            base = Model;
		        }
	
		        var model,
		            proto = extend({ defaults: {} }, options),
		            name,
		            field,
		            type,
		            value,
		            idx,
		            length,
		            fields = {},
		            originalName,
		            id = proto.id,
		            functionFields = [];
	
		        if (id) {
		            proto.idField = id;
		        }
	
		        if (proto.id) {
		            delete proto.id;
		        }
	
		        if (id) {
		            proto.defaults[id] = proto._defaultId = "";
		        }
	
		        if (toString.call(proto.fields) === "[object Array]") {
		            for (idx = 0, length = proto.fields.length; idx < length; idx++) {
		                field = proto.fields[idx];
		                if (typeof field === STRING) {
		                    fields[field] = {};
		                } else if (field.field) {
		                    fields[field.field] = field;
		                }
		            }
		            proto.fields = fields;
		        }
	
		        for (name in proto.fields) {
		            field = proto.fields[name];
		            type = field.type || "default";
		            value = null;
		            originalName = name;
	
		            name = typeof (field.field) === STRING ? field.field : name;
	
		            if (!field.nullable) {
		                value = proto.defaults[originalName !== name ? originalName : name] = field.defaultValue !== undefined ? field.defaultValue : defaultValues[type.toLowerCase()];
	
		                if (typeof value === "function") {
		                    functionFields.push(name);
		                }
		            }
	
		            if (options.id === name) {
		                proto._defaultId = value;
		            }
	
		            proto.defaults[originalName !== name ? originalName : name] = value;
	
		            field.parse = field.parse || parsers[type];
		        }
	
		        if (functionFields.length > 0) {
		            proto._initializers = functionFields;
		        }
	
		        model = base.extend(proto);
		        model.define = function(options) {
		            return Model.define(model, options);
		        };
	
		        if (proto.fields) {
		            model.fields = proto.fields;
		            model.idField = proto.idField;
		        }
	
		        return model;
		    };
	
		    var Comparer = {
		        selector: function(field) {
		            return isFunction(field) ? field : getter(field);
		        },
	
		        compare: function(field) {
		            var selector = this.selector(field);
		            return function (a, b) {
		                a = selector(a);
		                b = selector(b);
	
		                if (a == null && b == null) {
		                    return 0;
		                }
	
		                if (a == null) {
		                    return -1;
		                }
	
		                if (b == null) {
		                    return 1;
		                }
	
		                if (a.localeCompare) {
		                    return a.localeCompare(b);
		                }
	
		                return a > b ? 1 : (a < b ? -1 : 0);
		            };
		        },
	
		        create: function(sort) {
		            var compare = sort.compare || this.compare(sort.field);
	
		            if (sort.dir == "desc") {
		                return function(a, b) {
		                    return compare(b, a, true);
		                };
		            }
	
		            return compare;
		        },
	
		        combine: function(comparers) {
		            return function(a, b) {
		                var result = comparers[0](a, b),
		                    idx,
		                    length;
	
		                for (idx = 1, length = comparers.length; idx < length; idx ++) {
		                    result = result || comparers[idx](a, b);
		                }
	
		                return result;
		            };
		        }
		    };
	
		    var StableComparer = extend({}, Comparer, {
		        asc: function(field) {
		            var selector = this.selector(field);
		            return function (a, b) {
		                var valueA = selector(a);
		                var valueB = selector(b);
	
		                if (valueA && valueA.getTime && valueB && valueB.getTime) {
		                    valueA = valueA.getTime();
		                    valueB = valueB.getTime();
		                }
	
		                if (valueA === valueB) {
		                    return a.__position - b.__position;
		                }
	
		                if (valueA == null) {
		                    return -1;
		                }
	
		                if (valueB == null) {
		                    return 1;
		                }
	
		                if (valueA.localeCompare) {
		                    return valueA.localeCompare(valueB);
		                }
	
		                return valueA > valueB ? 1 : -1;
		            };
		        },
	
		        desc: function(field) {
		            var selector = this.selector(field);
		            return function (a, b) {
		                var valueA = selector(a);
		                var valueB = selector(b);
	
		                if (valueA && valueA.getTime && valueB && valueB.getTime) {
		                    valueA = valueA.getTime();
		                    valueB = valueB.getTime();
		                }
	
		                if (valueA === valueB) {
		                    return a.__position - b.__position;
		                }
	
		                if (valueA == null) {
		                    return 1;
		                }
	
		                if (valueB == null) {
		                    return -1;
		                }
	
		                if (valueB.localeCompare) {
		                    return valueB.localeCompare(valueA);
		                }
	
		                return valueA < valueB ? 1 : -1;
		            };
		        },
		        create: function(sort) {
		           return this[sort.dir](sort.field);
		        }
		    });
	
		    map = function (array, callback) {
		        var idx, length = array.length, result = new Array(length);
	
		        for (idx = 0; idx < length; idx++) {
		            result[idx] = callback(array[idx], idx, array);
		        }
	
		        return result;
		    };
	
		    var operators = (function(){
	
		        function quote(str) {
		            if (typeof str == "string") {
		                str = str.replace(/[\r\n]+/g, "");
		            }
		            return JSON.stringify(str);
		        }
	
		        function textOp(impl) {
		            return function(a, b, ignore) {
		                b += "";
		                if (ignore) {
		                    a = "(" + a + " || '').toString().toLowerCase()";
		                    b = b.toLowerCase();
		                }
		                return impl(a, quote(b), ignore);
		            };
		        }
	
		        function operator(op, a, b, ignore) {
		            if (b != null) {
		                if (typeof b === STRING) {
		                    var date = dateRegExp.exec(b);
		                    if (date) {
		                        b = new Date(+date[1]);
		                    } else if (ignore) {
		                        b = quote(b.toLowerCase());
		                        a = "((" + a + " || '')+'').toLowerCase()";
		                    } else {
		                        b = quote(b);
		                    }
		                }
	
		                if (b.getTime) {
		                    //b looks like a Date
		                    a = "(" + a + "&&" + a + ".getTime?" + a + ".getTime():" + a + ")";
		                    b = b.getTime();
		                }
		            }
	
		            return a + " " + op + " " + b;
		        }
	
		        function getMatchRegexp(pattern) {
		            // take a pattern, as supported by Excel match filter, and
		            // convert it to the equivalent JS regular expression.
		            // Excel patterns support:
		            //
		            //   * - match any sequence of characters
		            //   ? - match a single character
		            //
		            // to match a literal * or ?, they must be prefixed by a tilde (~)
		            for (var rx = "/^", esc = false, i = 0; i < pattern.length; ++i) {
		                var ch = pattern.charAt(i);
		                if (esc) {
		                    rx += "\\" + ch;
		                } else if (ch == "~") {
		                    esc = true;
		                    continue;
		                } else if (ch == "*") {
		                    rx += ".*";
		                } else if (ch == "?") {
		                    rx += ".";
		                } else if (".+^$()[]{}|\\/\n\r\u2028\u2029\xA0".indexOf(ch) >= 0) {
		                    rx += "\\" + ch;
		                } else {
		                    rx += ch;
		                }
		                esc = false;
		            }
		            return rx + "$/";
		        }
	
		        return {
		            quote: function(value) {
		                if (value && value.getTime) {
		                    return "new Date(" + value.getTime() + ")";
		                }
		                return quote(value);
		            },
		            eq: function(a, b, ignore) {
		                return operator("==", a, b, ignore);
		            },
		            neq: function(a, b, ignore) {
		                return operator("!=", a, b, ignore);
		            },
		            gt: function(a, b, ignore) {
		                return operator(">", a, b, ignore);
		            },
		            gte: function(a, b, ignore) {
		                return operator(">=", a, b, ignore);
		            },
		            lt: function(a, b, ignore) {
		                return operator("<", a, b, ignore);
		            },
		            lte: function(a, b, ignore) {
		                return operator("<=", a, b, ignore);
		            },
		            startswith: textOp(function(a, b) {
		                return a + ".lastIndexOf(" + b + ", 0) == 0";
		            }),
		            doesnotstartwith: textOp(function(a, b) {
		                return a + ".lastIndexOf(" + b + ", 0) == -1";
		            }),
		            endswith: textOp(function(a, b) {
		                var n = b ? b.length - 2 : 0;
		                return a + ".indexOf(" + b + ", " + a + ".length - " + n + ") >= 0";
		            }),
		            doesnotendwith: textOp(function(a, b) {
		                var n = b ? b.length - 2 : 0;
		                return a + ".indexOf(" + b + ", " + a + ".length - " + n + ") < 0";
		            }),
		            contains: textOp(function(a, b) {
		                return a + ".indexOf(" + b + ") >= 0";
		            }),
		            doesnotcontain: textOp(function(a, b) {
		                return a + ".indexOf(" + b + ") == -1";
		            }),
		            matches: textOp(function(a, b){
		                b = b.substring(1, b.length - 1);
		                return getMatchRegexp(b) + ".test(" + a + ")";
		            }),
		            doesnotmatch: textOp(function(a, b){
		                b = b.substring(1, b.length - 1);
		                return "!" + getMatchRegexp(b) + ".test(" + a + ")";
		            }),
		            isempty: function(a) {
		                return a + " === ''";
		            },
		            isnotempty: function(a) {
		                return a + " !== ''";
		            },
		            isnull: function(a) {
		                return "(" + a + " == null)";
		            },
		            isnotnull: function(a) {
		                return "(" + a + " != null)";
		            },
		            isnullorempty: function(a) {
		                return "(" + a + " === null) || (" + a + " === '')";
		            },
		            isnotnullorempty: function(a) {
		                return "(" + a + " !== null) && (" + a + " !== '')";
		            }
		        };
		    })();
	
		    function Query(data) {
		        this.data = data || [];
		    }
	
		    Query.filterExpr = function(expression) {
		        var expressions = [],
		            logic = { and: " && ", or: " || " },
		            idx,
		            length,
		            filter,
		            expr,
		            fieldFunctions = [],
		            operatorFunctions = [],
		            field,
		            operator,
		            filters = expression.filters;
	
		        for (idx = 0, length = filters.length; idx < length; idx++) {
		            filter = filters[idx];
		            field = filter.field;
		            operator = filter.operator;
	
		            if (filter.filters) {
		                expr = Query.filterExpr(filter);
		                //Nested function fields or operators - update their index e.g. __o[0] -> __o[1]
		                filter = expr.expression
		                .replace(/__o\[(\d+)\]/g, function(match, index) {
		                    index = +index;
		                    return "__o[" + (operatorFunctions.length + index) + "]";
		                })
		                .replace(/__f\[(\d+)\]/g, function(match, index) {
		                    index = +index;
		                    return "__f[" + (fieldFunctions.length + index) + "]";
		                });
	
		                operatorFunctions.push.apply(operatorFunctions, expr.operators);
		                fieldFunctions.push.apply(fieldFunctions, expr.fields);
		            } else {
		                if (typeof field === FUNCTION) {
		                    expr = "__f[" + fieldFunctions.length +"](d)";
		                    fieldFunctions.push(field);
		                } else {
		                    expr = kendo.expr(field);
		                }
	
		                if (typeof operator === FUNCTION) {
		                    filter = "__o[" + operatorFunctions.length + "](" + expr + ", " + operators.quote(filter.value) + ")";
		                    operatorFunctions.push(operator);
		                } else {
		                    filter = operators[(operator || "eq").toLowerCase()](expr, filter.value, filter.ignoreCase !== undefined? filter.ignoreCase : true);
		                }
		            }
	
		            expressions.push(filter);
		        }
	
		        return  { expression: "(" + expressions.join(logic[expression.logic]) + ")", fields: fieldFunctions, operators: operatorFunctions };
		    };
	
		    function normalizeSort(field, dir) {
		        if (field) {
		            var descriptor = typeof field === STRING ? { field: field, dir: dir } : field,
		            descriptors = isArray(descriptor) ? descriptor : (descriptor !== undefined ? [descriptor] : []);
	
		            return grep(descriptors, function(d) { return !!d.dir; });
		        }
		    }
	
		    var operatorMap = {
		        "==": "eq",
		        equals: "eq",
		        isequalto: "eq",
		        equalto: "eq",
		        equal: "eq",
		        "!=": "neq",
		        ne: "neq",
		        notequals: "neq",
		        isnotequalto: "neq",
		        notequalto: "neq",
		        notequal: "neq",
		        "<": "lt",
		        islessthan: "lt",
		        lessthan: "lt",
		        less: "lt",
		        "<=": "lte",
		        le: "lte",
		        islessthanorequalto: "lte",
		        lessthanequal: "lte",
		        ">": "gt",
		        isgreaterthan: "gt",
		        greaterthan: "gt",
		        greater: "gt",
		        ">=": "gte",
		        isgreaterthanorequalto: "gte",
		        greaterthanequal: "gte",
		        ge: "gte",
		        notsubstringof: "doesnotcontain",
		        isnull: "isnull",
		        isempty: "isempty",
		        isnotempty: "isnotempty"
		    };
	
		    function normalizeOperator(expression) {
		        var idx,
		        length,
		        filter,
		        operator,
		        filters = expression.filters;
	
		        if (filters) {
		            for (idx = 0, length = filters.length; idx < length; idx++) {
		                filter = filters[idx];
		                operator = filter.operator;
	
		                if (operator && typeof operator === STRING) {
		                    filter.operator = operatorMap[operator.toLowerCase()] || operator;
		                }
	
		                normalizeOperator(filter);
		            }
		        }
		    }
	
		    function normalizeFilter(expression) {
		        if (expression && !isEmptyObject(expression)) {
		            if (isArray(expression) || !expression.filters) {
		                expression = {
		                    logic: "and",
		                    filters: isArray(expression) ? expression : [expression]
		                };
		            }
	
		            normalizeOperator(expression);
	
		            return expression;
		        }
		    }
	
		    Query.normalizeFilter = normalizeFilter;
	
		    function compareDescriptor(f1, f2) {
		        if (f1.logic || f2.logic) {
		            return false;
		        }
	
		        return f1.field === f2.field && f1.value === f2.value && f1.operator === f2.operator;
		    }
	
		    function normalizeDescriptor(filter) {
		        filter = filter || {};
	
		        if (isEmptyObject(filter)) {
		            return { logic: "and", filters: [] };
		        }
	
		        return normalizeFilter(filter);
		    }
	
		    function fieldComparer(a, b) {
		        if (b.logic || (a.field > b.field)) {
		            return 1;
		        } else if (a.field < b.field) {
		            return -1;
		        } else {
		            return 0;
		        }
		    }
	
		    function compareFilters(expr1, expr2) {
		        expr1 = normalizeDescriptor(expr1);
		        expr2 = normalizeDescriptor(expr2);
	
		        if (expr1.logic !== expr2.logic) {
		            return false;
		        }
	
		        var f1, f2;
		        var filters1 = (expr1.filters || []).slice();
		        var filters2 = (expr2.filters || []).slice();
	
		        if (filters1.length !== filters2.length) {
		            return false;
		        }
	
		        filters1 = filters1.sort(fieldComparer);
		        filters2 = filters2.sort(fieldComparer);
	
		        for (var idx = 0; idx < filters1.length; idx++) {
		            f1 = filters1[idx];
		            f2 = filters2[idx];
	
		            if (f1.logic && f2.logic) {
		                if (!compareFilters(f1, f2)) {
		                    return false;
		                }
		            } else if (!compareDescriptor(f1, f2)) {
		                return false;
		            }
		        }
	
		        return true;
		    }
	
		    Query.compareFilters = compareFilters;
	
		    function normalizeAggregate(expressions) {
		        return isArray(expressions) ? expressions : [expressions];
		    }
	
		    function normalizeGroup(field, dir) {
		        var descriptor = typeof field === STRING ? { field: field, dir: dir } : field,
		        descriptors = isArray(descriptor) ? descriptor : (descriptor !== undefined ? [descriptor] : []);
	
		        return map(descriptors, function(d) { return { field: d.field, dir: d.dir || "asc", aggregates: d.aggregates }; });
		    }
	
		    Query.prototype = {
		        toArray: function () {
		            return this.data;
		        },
		        range: function(index, count) {
		            return new Query(this.data.slice(index, index + count));
		        },
		        skip: function (count) {
		            return new Query(this.data.slice(count));
		        },
		        take: function (count) {
		            return new Query(this.data.slice(0, count));
		        },
		        select: function (selector) {
		            return new Query(map(this.data, selector));
		        },
		        order: function(selector, dir, inPlace) {
		            var sort = { dir: dir };
	
		            if (selector) {
		                if (selector.compare) {
		                    sort.compare = selector.compare;
		                } else {
		                    sort.field = selector;
		                }
		            }
	
		            if (inPlace) {
		                return new Query(this.data.sort(Comparer.create(sort)));
		            }
		            return new Query(this.data.slice(0).sort(Comparer.create(sort)));
		        },
		        orderBy: function(selector, inPlace) {
		            return this.order(selector, "asc", inPlace);
		        },
		        orderByDescending: function(selector, inPlace) {
		            return this.order(selector, "desc", inPlace);
		        },
		        sort: function(field, dir, comparer, inPlace) {
		            var idx,
		            length,
		            descriptors = normalizeSort(field, dir),
		            comparers = [];
	
		            comparer = comparer || Comparer;
	
		            if (descriptors.length) {
		                for (idx = 0, length = descriptors.length; idx < length; idx++) {
		                    comparers.push(comparer.create(descriptors[idx]));
		                }
	
		                return this.orderBy({ compare: comparer.combine(comparers) }, inPlace);
		            }
	
		            return this;
		        },
	
		        filter: function(expressions) {
		            var idx,
		            current,
		            length,
		            compiled,
		            predicate,
		            data = this.data,
		            fields,
		            operators,
		            result = [],
		            filter;
	
		            expressions = normalizeFilter(expressions);
	
		            if (!expressions || expressions.filters.length === 0) {
		                return this;
		            }
	
		            compiled = Query.filterExpr(expressions);
		            fields = compiled.fields;
		            operators = compiled.operators;
	
		            predicate = filter = new Function("d, __f, __o", "return " + compiled.expression);
	
		            if (fields.length || operators.length) {
		                filter = function(d) {
		                    return predicate(d, fields, operators);
		                };
		            }
	
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                current = data[idx];
	
		                if (filter(current)) {
		                    result.push(current);
		                }
		            }
	
		            return new Query(result);
		        },
	
		        group: function(descriptors, allData) {
		            descriptors =  normalizeGroup(descriptors || []);
		            allData = allData || this.data;
	
		            var that = this,
		            result = new Query(that.data),
		            descriptor;
	
		            if (descriptors.length > 0) {
		                descriptor = descriptors[0];
		                result = result.groupBy(descriptor).select(function(group) {
		                    var data = new Query(allData).filter([ { field: group.field, operator: "eq", value: group.value, ignoreCase: false } ]);
		                    return {
		                        field: group.field,
		                        value: group.value,
		                        items: descriptors.length > 1 ? new Query(group.items).group(descriptors.slice(1), data.toArray()).toArray() : group.items,
		                        hasSubgroups: descriptors.length > 1,
		                        aggregates: data.aggregate(descriptor.aggregates)
		                    };
		                });
		            }
		            return result;
		        },
	
		        groupBy: function(descriptor) {
		            if (isEmptyObject(descriptor) || !this.data.length) {
		                return new Query([]);
		            }
	
		            var field = descriptor.field,
		                sorted = this._sortForGrouping(field, descriptor.dir || "asc"),
		                accessor = kendo.accessor(field),
		                item,
		                groupValue = accessor.get(sorted[0], field),
		                group = {
		                    field: field,
		                    value: groupValue,
		                    items: []
		                },
		                currentValue,
		                idx,
		                len,
		                result = [group];
	
		            for(idx = 0, len = sorted.length; idx < len; idx++) {
		                item = sorted[idx];
		                currentValue = accessor.get(item, field);
		                if(!groupValueComparer(groupValue, currentValue)) {
		                    groupValue = currentValue;
		                    group = {
		                        field: field,
		                        value: groupValue,
		                        items: []
		                    };
		                    result.push(group);
		                }
		                group.items.push(item);
		            }
		            return new Query(result);
		        },
	
		        _sortForGrouping: function(field, dir) {
		            var idx, length,
		                data = this.data;
	
		            if (!stableSort) {
		                for (idx = 0, length = data.length; idx < length; idx++) {
		                    data[idx].__position = idx;
		                }
	
		                data = new Query(data).sort(field, dir, StableComparer).toArray();
	
		                for (idx = 0, length = data.length; idx < length; idx++) {
		                    delete data[idx].__position;
		                }
		                return data;
		            }
		            return this.sort(field, dir).toArray();
		        },
	
		        aggregate: function (aggregates) {
		            var idx,
		                len,
		                result = {},
		                state = {};
	
		            if (aggregates && aggregates.length) {
		                for(idx = 0, len = this.data.length; idx < len; idx++) {
		                    calculateAggregate(result, aggregates, this.data[idx], idx, len, state);
		                }
		            }
		            return result;
		        }
		    };
	
		    function groupValueComparer(a, b) {
		        if (a && a.getTime && b && b.getTime) {
		            return a.getTime() === b.getTime();
		        }
		        return a === b;
		    }
	
		    function calculateAggregate(accumulator, aggregates, item, index, length, state) {
		        aggregates = aggregates || [];
		        var idx,
		            aggr,
		            functionName,
		            len = aggregates.length;
	
		        for (idx = 0; idx < len; idx++) {
		            aggr = aggregates[idx];
		            functionName = aggr.aggregate;
		            var field = aggr.field;
		            accumulator[field] = accumulator[field] || {};
		            state[field] = state[field] || {};
		            state[field][functionName] = state[field][functionName] || {};
		            accumulator[field][functionName] = functions[functionName.toLowerCase()](accumulator[field][functionName], item, kendo.accessor(field), index, length, state[field][functionName]);
		        }
		    }
	
		    var functions = {
		        sum: function(accumulator, item, accessor) {
		            var value = accessor.get(item);
	
		            if (!isNumber(accumulator)) {
		                accumulator = value;
		            } else if (isNumber(value)) {
		                accumulator += value;
		            }
	
		            return accumulator;
		        },
		        count: function(accumulator) {
		            return (accumulator || 0) + 1;
		        },
		        average: function(accumulator, item, accessor, index, length, state) {
		            var value = accessor.get(item);
	
		            if (state.count === undefined) {
		                state.count = 0;
		            }
	
		            if (!isNumber(accumulator)) {
		                accumulator = value;
		            } else if (isNumber(value)) {
		                accumulator += value;
		            }
	
		            if (isNumber(value)) {
		                state.count++;
		            }
	
		            if(index == length - 1 && isNumber(accumulator)) {
		                accumulator = accumulator / state.count;
		            }
		            return accumulator;
		        },
		        max: function(accumulator, item, accessor) {
		            var value = accessor.get(item);
	
		            if (!isNumber(accumulator) && !isDate(accumulator)) {
		                accumulator = value;
		            }
	
		            if(accumulator < value && (isNumber(value) || isDate(value))) {
		                accumulator = value;
		            }
		            return accumulator;
		        },
		        min: function(accumulator, item, accessor) {
		            var value = accessor.get(item);
	
		            if (!isNumber(accumulator) && !isDate(accumulator)) {
		                accumulator = value;
		            }
	
		            if(accumulator > value && (isNumber(value) || isDate(value))) {
		                accumulator = value;
		            }
		            return accumulator;
		        }
		    };
	
		    function isNumber(val) {
		        return typeof val === "number" && !isNaN(val);
		    }
	
		    function isDate(val) {
		        return val && val.getTime;
		    }
	
		    function toJSON(array) {
		        var idx, length = array.length, result = new Array(length);
	
		        for (idx = 0; idx < length; idx++) {
		            result[idx] = array[idx].toJSON();
		        }
	
		        return result;
		    }
	
		    Query.normalizeGroup = normalizeGroup;
		    Query.normalizeSort = normalizeSort;
	
		    Query.process = function(data, options, inPlace) {
		        options = options || {};
	
		        var query = new Query(data),
		            group = options.group,
		            sort = normalizeGroup(group || []).concat(normalizeSort(options.sort || [])),
		            total,
		            filterCallback = options.filterCallback,
		            filter = options.filter,
		            skip = options.skip,
		            take = options.take;
	
		        if (sort && inPlace) {
		            query = query.sort(sort, undefined, undefined, inPlace);
		        }
	
		        if (filter) {
		            query = query.filter(filter);
	
		            if (filterCallback) {
		                query = filterCallback(query);
		            }
	
		            total = query.toArray().length;
		        }
	
		        if (sort && !inPlace) {
		            query = query.sort(sort);
	
		            if (group) {
		                data = query.toArray();
		            }
		        }
	
		        if (skip !== undefined && take !== undefined) {
		            query = query.range(skip, take);
		        }
	
		        if (group) {
		            query = query.group(group, data);
		        }
	
		        return {
		            total: total,
		            data: query.toArray()
		        };
		    };
	
		    var LocalTransport = Class.extend({
		        init: function(options) {
		            this.data = options.data;
		        },
	
		        read: function(options) {
		            options.success(this.data);
		        },
		        update: function(options) {
		            options.success(options.data);
		        },
		        create: function(options) {
		            options.success(options.data);
		        },
		        destroy: function(options) {
		            options.success(options.data);
		        }
		    });
	
		    var RemoteTransport = Class.extend( {
		        init: function(options) {
		            var that = this, parameterMap;
	
		            options = that.options = extend({}, that.options, options);
	
		            each(crud, function(index, type) {
		                if (typeof options[type] === STRING) {
		                    options[type] = {
		                        url: options[type]
		                    };
		                }
		            });
	
		            that.cache = options.cache? Cache.create(options.cache) : {
		                find: noop,
		                add: noop
		            };
	
		            parameterMap = options.parameterMap;
	
		            if (options.submit) {
		                that.submit = options.submit;
		            }
	
		            if (isFunction(options.push)) {
		                that.push = options.push;
		            }
	
		            if (!that.push) {
		                that.push = identity;
		            }
	
		            that.parameterMap = isFunction(parameterMap) ? parameterMap : function(options) {
		                var result = {};
	
		                each(options, function(option, value) {
		                    if (option in parameterMap) {
		                        option = parameterMap[option];
		                        if (isPlainObject(option)) {
		                            value = option.value(value);
		                            option = option.key;
		                        }
		                    }
	
		                    result[option] = value;
		                });
	
		                return result;
		            };
		        },
	
		        options: {
		            parameterMap: identity
		        },
	
		        create: function(options) {
		            return ajax(this.setup(options, CREATE));
		        },
	
		        read: function(options) {
		            var that = this,
		                success,
		                error,
		                result,
		                cache = that.cache;
	
		            options = that.setup(options, READ);
	
		            success = options.success || noop;
		            error = options.error || noop;
	
		            result = cache.find(options.data);
	
		            if(result !== undefined) {
		                success(result);
		            } else {
		                options.success = function(result) {
		                    cache.add(options.data, result);
	
		                    success(result);
		                };
	
		                $.ajax(options);
		            }
		        },
	
		        update: function(options) {
		            return ajax(this.setup(options, UPDATE));
		        },
	
		        destroy: function(options) {
		            return ajax(this.setup(options, DESTROY));
		        },
	
		        setup: function(options, type) {
		            options = options || {};
	
		            var that = this,
		                parameters,
		                operation = that.options[type],
		                data = isFunction(operation.data) ? operation.data(options.data) : operation.data;
	
		            options = extend(true, {}, operation, options);
		            parameters = extend(true, {}, data, options.data);
	
		            options.data = that.parameterMap(parameters, type);
	
		            if (isFunction(options.url)) {
		                options.url = options.url(parameters);
		            }
	
		            return options;
		        }
		    });
	
		    var Cache = Class.extend({
		        init: function() {
		            this._store = {};
		        },
		        add: function(key, data) {
		            if(key !== undefined) {
		                this._store[stringify(key)] = data;
		            }
		        },
		        find: function(key) {
		            return this._store[stringify(key)];
		        },
		        clear: function() {
		            this._store = {};
		        },
		        remove: function(key) {
		            delete this._store[stringify(key)];
		        }
		    });
	
		    Cache.create = function(options) {
		        var store = {
		            "inmemory": function() { return new Cache(); }
		        };
	
		        if (isPlainObject(options) && isFunction(options.find)) {
		            return options;
		        }
	
		        if (options === true) {
		            return new Cache();
		        }
	
		        return store[options]();
		    };
	
		    function serializeRecords(data, getters, modelInstance, originalFieldNames, fieldNames) {
		        var record,
		            getter,
		            originalName,
		            idx,
		            setters = {},
		            length;
	
		        for (idx = 0, length = data.length; idx < length; idx++) {
		            record = data[idx];
		            for (getter in getters) {
		                originalName = fieldNames[getter];
	
		                if (originalName && originalName !== getter) {
		                    if (!setters[originalName]) {
		                        setters[originalName] = kendo.setter(originalName);
		                    }
		                    setters[originalName](record, getters[getter](record));
		                    delete record[getter];
		                }
		            }
		        }
		    }
	
		    function convertRecords(data, getters, modelInstance, originalFieldNames, fieldNames) {
		        var record,
		            getter,
		            originalName,
		            idx,
		            length;
	
		        for (idx = 0, length = data.length; idx < length; idx++) {
		            record = data[idx];
		            for (getter in getters) {
		                record[getter] = modelInstance._parse(getter, getters[getter](record));
	
		                originalName = fieldNames[getter];
		                if (originalName && originalName !== getter) {
		                    delete record[originalName];
		                }
		            }
		        }
		    }
	
		    function convertGroup(data, getters, modelInstance, originalFieldNames, fieldNames) {
		        var record,
		            idx,
		            fieldName,
		            length;
	
		        for (idx = 0, length = data.length; idx < length; idx++) {
		            record = data[idx];
	
		            fieldName = originalFieldNames[record.field];
		            if (fieldName && fieldName != record.field) {
		                record.field = fieldName;
		            }
	
		            record.value = modelInstance._parse(record.field, record.value);
	
		            if (record.hasSubgroups) {
		                convertGroup(record.items, getters, modelInstance, originalFieldNames, fieldNames);
		            } else {
		                convertRecords(record.items, getters, modelInstance, originalFieldNames, fieldNames);
		            }
		        }
		    }
	
		    function wrapDataAccess(originalFunction, model, converter, getters, originalFieldNames, fieldNames) {
		        return function(data) {
		            data = originalFunction(data);
	
		            return wrapDataAccessBase(model, converter, getters, originalFieldNames, fieldNames)(data);
		        };
		    }
	
		    function wrapDataAccessBase(model, converter, getters, originalFieldNames, fieldNames) {
		        return function(data) {
	
		            if (data && !isEmptyObject(getters)) {
		                if (toString.call(data) !== "[object Array]" && !(data instanceof ObservableArray)) {
		                    data = [data];
		                }
	
		                converter(data, getters, new model(), originalFieldNames, fieldNames);
		            }
	
		            return data || [];
		        };
		    }
	
		    var DataReader = Class.extend({
		        init: function(schema) {
		            var that = this, member, get, model, base;
	
		            schema = schema || {};
	
		            for (member in schema) {
		                get = schema[member];
	
		                that[member] = typeof get === STRING ? getter(get) : get;
		            }
	
		            base = schema.modelBase || Model;
	
		            if (isPlainObject(that.model)) {
		                that.model = model = base.define(that.model);
		            }
	
		            var dataFunction = proxy(that.data, that);
	
		            that._dataAccessFunction = dataFunction;
	
		            if (that.model) {
		                var groupsFunction = proxy(that.groups, that),
		                    serializeFunction = proxy(that.serialize, that),
		                    originalFieldNames = {},
		                    getters = {},
		                    serializeGetters = {},
		                    fieldNames = {},
		                    shouldSerialize = false,
		                    fieldName,
		                    name;
	
		                model = that.model;
	
		                if (model.fields) {
		                    each(model.fields, function(field, value) {
		                        var fromName;
	
		                        fieldName = field;
	
		                        if (isPlainObject(value) && value.field) {
		                            fieldName = value.field;
		                        } else if (typeof value === STRING) {
		                            fieldName = value;
		                        }
	
		                        if (isPlainObject(value) && value.from) {
		                            fromName = value.from;
		                        }
	
		                        shouldSerialize = shouldSerialize || (fromName && fromName !== field) || fieldName !== field;
		                        name = fromName || fieldName;
		                        getters[field] = name.indexOf(".") !== -1 ? getter(name, true) : getter(name);
		                        serializeGetters[field] = getter(field);
		                        originalFieldNames[fromName || fieldName] = field;
		                        fieldNames[field] = fromName || fieldName;
		                    });
	
		                    if (!schema.serialize && shouldSerialize) {
		                        that.serialize = wrapDataAccess(serializeFunction, model, serializeRecords, serializeGetters, originalFieldNames, fieldNames);
		                    }
		                }
	
		                that._dataAccessFunction = dataFunction;
		                that._wrapDataAccessBase = wrapDataAccessBase(model, convertRecords, getters, originalFieldNames, fieldNames);
		                that.data = wrapDataAccess(dataFunction, model, convertRecords, getters, originalFieldNames, fieldNames);
		                that.groups = wrapDataAccess(groupsFunction, model, convertGroup, getters, originalFieldNames, fieldNames);
		            }
		        },
		        errors: function(data) {
		            return data ? data.errors : null;
		        },
		        parse: identity,
		        data: identity,
		        total: function(data) {
		            return data.length;
		        },
		        groups: identity,
		        aggregates: function() {
		            return {};
		        },
		        serialize: function(data) {
		            return data;
		        }
		    });
	
		    function fillLastGroup(originalGroup, newGroup) {
		        var currOriginal;
		        var currentNew;
	
		        if (newGroup.items && newGroup.items.length) {
		            for (var i = 0; i < newGroup.items.length; i++) {
		                currOriginal = originalGroup.items[i];
		                currentNew = newGroup.items[i];
		                if (currOriginal && currentNew) {
		                    if (currOriginal.hasSubgroups) {
		                        fillLastGroup(currOriginal, currentNew);
		                    } else if (currOriginal.field && currOriginal.value == currentNew.value) {
		                        currOriginal.items.push.apply(currOriginal.items, currentNew.items);
		                    } else {
		                        originalGroup.items.push.apply(originalGroup.items, [currentNew]);
		                    }
		                } else if (currentNew) {
		                    originalGroup.items.push.apply(originalGroup.items, [currentNew]);
		                }
		            }
		        }
		    }
		    function mergeGroups(target, dest, skip, take) {
		        var group,
		            idx = 0,
		            items;
	
		        while (dest.length && take) {
		            group = dest[idx];
		            items = group.items;
	
		            var length = items.length;
	
		            if (target && target.field === group.field && target.value === group.value) {
		                if (target.hasSubgroups && target.items.length) {
		                    mergeGroups(target.items[target.items.length - 1], group.items, skip, take);
		                } else {
		                    items = items.slice(skip, skip + take);
		                    target.items = target.items.concat(items);
		                }
		                dest.splice(idx--, 1);
		            } else if (group.hasSubgroups && items.length) {
		                mergeGroups(group, items, skip, take);
		                if (!group.items.length) {
		                    dest.splice(idx--, 1);
		                }
		            } else {
		                items = items.slice(skip, skip + take);
		                group.items = items;
	
		                if (!group.items.length) {
		                    dest.splice(idx--, 1);
		                }
		            }
	
		            if (items.length === 0) {
		                skip -= length;
		            } else {
		                skip = 0;
		                take -= items.length;
		            }
	
		            if (++idx >= dest.length) {
		                break;
		            }
		        }
	
		        if (idx < dest.length) {
		            dest.splice(idx, dest.length - idx);
		        }
		    }
	
		    function flattenGroups(data) {
		        var idx,
		            result = [],
		            length,
		            items,
		            itemIndex;
	
		        for (idx = 0, length = data.length; idx < length; idx++) {
		            var group = data.at(idx);
		            if (group.hasSubgroups) {
		                result = result.concat(flattenGroups(group.items));
		            } else {
		                items = group.items;
		                for (itemIndex = 0; itemIndex < items.length; itemIndex++) {
		                    result.push(items.at(itemIndex));
		                }
		            }
		        }
		        return result;
		    }
	
		    function wrapGroupItems(data, model) {
		        var idx, length, group;
		        if (model) {
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                group = data.at(idx);
	
		                if (group.hasSubgroups) {
		                    wrapGroupItems(group.items, model);
		                } else {
		                    group.items = new LazyObservableArray(group.items, model, group.items._events);
		                }
		            }
		        }
		    }
	
		    function eachGroupItems(data, func) {
		        for (var idx = 0; idx < data.length; idx++) {
		            if (data[idx].hasSubgroups) {
		                if (eachGroupItems(data[idx].items, func)) {
		                    return true;
		                }
		            } else if (func(data[idx].items, data[idx])) {
		                return true;
		            }
		        }
		    }
	
		    function replaceInRanges(ranges, data, item, observable) {
		        for (var idx = 0; idx < ranges.length; idx++) {
		            if (ranges[idx].data === data) {
		                break;
		            }
		            if (replaceInRange(ranges[idx].data, item, observable)) {
		                break;
		            }
		        }
		    }
	
		    function replaceInRange(items, item, observable) {
		        for (var idx = 0, length = items.length; idx < length; idx++) {
		            if (items[idx] && items[idx].hasSubgroups) {
		                return replaceInRange(items[idx].items, item, observable);
		            } else if (items[idx] === item || items[idx] === observable) {
		               items[idx] = observable;
		               return true;
		            }
		        }
		    }
	
		    function replaceWithObservable(view, data, ranges, type, serverGrouping) {
		        for (var viewIndex = 0, length = view.length; viewIndex < length; viewIndex++) {
		            var item = view[viewIndex];
	
		            if (!item || item instanceof type) {
		                continue;
		            }
	
		            if (item.hasSubgroups !== undefined && !serverGrouping) {
		                replaceWithObservable(item.items, data, ranges, type, serverGrouping);
		            } else {
		                for (var idx = 0; idx < data.length; idx++) {
		                    if (data[idx] === item) {
		                        view[viewIndex] = data.at(idx);
		                        replaceInRanges(ranges, data, item, view[viewIndex]);
		                        break;
		                    }
		                }
		            }
		        }
		    }
	
		    function removeModel(data, model) {
		        var length = data.length;
		        var dataItem;
		        var idx;
	
		        for (idx = 0; idx < length; idx++) {
		            dataItem = data[idx];
	
		            if (dataItem.uid && dataItem.uid == model.uid) {
		                data.splice(idx, 1);
		                return dataItem;
		            }
		        }
		    }
	
		    function indexOfPristineModel(data, model) {
		        if (model) {
		            return indexOf(data, function(item) {
		                return (item.uid && item.uid == model.uid) || (item[model.idField] === model.id && model.id !== model._defaultId);
		            });
		        }
		        return -1;
		    }
	
		    function indexOfModel(data, model) {
		        if (model) {
		            return indexOf(data, function(item) {
		                return item.uid == model.uid;
		            });
		        }
		        return -1;
		    }
	
		    function indexOf(data, comparer) {
		        var idx, length;
	
		        for (idx = 0, length = data.length; idx < length; idx++) {
		            if (comparer(data[idx])) {
		                return idx;
		            }
		        }
	
		        return -1;
		    }
	
		    function fieldNameFromModel(fields, name) {
		        if (fields && !isEmptyObject(fields)) {
		            var descriptor = fields[name];
		            var fieldName;
		            if (isPlainObject(descriptor)) {
		                fieldName = descriptor.from || descriptor.field || name;
		            } else {
		                fieldName = fields[name] || name;
		            }
	
		            if (isFunction(fieldName)) {
		                return name;
		            }
	
		            return fieldName;
		        }
		        return name;
		    }
	
		    function convertFilterDescriptorsField(descriptor, model) {
		        var idx,
		            length,
		            target = {};
	
		        for (var field in descriptor) {
		            if (field !== "filters") {
		                target[field] = descriptor[field];
		            }
		        }
	
		        if (descriptor.filters) {
		            target.filters = [];
		            for (idx = 0, length = descriptor.filters.length; idx < length; idx++) {
		                target.filters[idx] = convertFilterDescriptorsField(descriptor.filters[idx], model);
		            }
		        } else {
		            target.field = fieldNameFromModel(model.fields, target.field);
		        }
		        return target;
		    }
	
		    function convertDescriptorsField(descriptors, model) {
		        var idx,
		            length,
		            result = [],
		            target,
		            descriptor;
	
		        for (idx = 0, length = descriptors.length; idx < length; idx ++) {
		            target = {};
	
		            descriptor = descriptors[idx];
	
		            for (var field in descriptor) {
		                target[field] = descriptor[field];
		            }
	
		            target.field = fieldNameFromModel(model.fields, target.field);
	
		            if (target.aggregates && isArray(target.aggregates)) {
		                target.aggregates = convertDescriptorsField(target.aggregates, model);
		            }
		            result.push(target);
		        }
		        return result;
		    }
	
		    var DataSource = Observable.extend({
		        init: function(options) {
		            var that = this, model, data;
	
		            if (options) {
		                data = options.data;
		            }
	
		            options = that.options = extend({}, that.options, options);
	
		            that._map = {};
		            that._prefetch = {};
		            that._data = [];
		            that._pristineData = [];
		            that._ranges = [];
		            that._view = [];
		            that._pristineTotal = 0;
		            that._destroyed = [];
		            that._pageSize = options.pageSize;
		            that._page = options.page  || (options.pageSize ? 1 : undefined);
		            that._sort = normalizeSort(options.sort);
		            that._filter = normalizeFilter(options.filter);
		            that._group = normalizeGroup(options.group);
		            that._aggregate = options.aggregate;
		            that._total = options.total;
	
		            that._shouldDetachObservableParents = true;
	
		            Observable.fn.init.call(that);
	
		            that.transport = Transport.create(options, data, that);
	
		            if (isFunction(that.transport.push)) {
		                that.transport.push({
		                    pushCreate: proxy(that._pushCreate, that),
		                    pushUpdate: proxy(that._pushUpdate, that),
		                    pushDestroy: proxy(that._pushDestroy, that)
		                });
		            }
	
		            if (options.offlineStorage != null) {
		                if (typeof options.offlineStorage == "string") {
		                    var key = options.offlineStorage;
	
		                    that._storage = {
		                        getItem: function() {
		                            return JSON.parse(localStorage.getItem(key));
		                        },
		                        setItem: function(item) {
		                            localStorage.setItem(key, stringify(that.reader.serialize(item)));
		                        }
		                    };
		                } else {
		                    that._storage = options.offlineStorage;
		                }
		            }
	
		            that.reader = new kendo.data.readers[options.schema.type || "json" ](options.schema);
	
		            model = that.reader.model || {};
	
		            that._detachObservableParents();
	
		            that._data = that._observe(that._data);
		            that._online = true;
	
		            that.bind(["push", ERROR, CHANGE, REQUESTSTART, SYNC, REQUESTEND, PROGRESS], options);
		        },
	
		        options: {
		            data: null,
		            schema: {
		               modelBase: Model
		            },
		            offlineStorage: null,
		            serverSorting: false,
		            serverPaging: false,
		            serverFiltering: false,
		            serverGrouping: false,
		            serverAggregates: false,
		            batch: false,
		            inPlaceSort: false
		        },
	
		        clone: function() {
		            return this;
		        },
	
		        online: function(value) {
		            if (value !== undefined) {
		                if (this._online != value) {
		                    this._online = value;
	
		                    if (value) {
		                        return this.sync();
		                    }
		                }
	
		                return $.Deferred().resolve().promise();
		            } else {
		                return this._online;
		            }
		        },
	
		        offlineData: function(state) {
		            if (this.options.offlineStorage == null) {
		                return null;
		            }
	
		            if (state !== undefined) {
		                return this._storage.setItem(state);
		            }
	
		            return this._storage.getItem() || [];
		        },
	
		        _isServerGrouped: function() {
		            var group = this.group() || [];
	
		            return this.options.serverGrouping && group.length;
		        },
	
		        _pushCreate: function(result) {
		            this._push(result, "pushCreate");
		        },
	
		        _pushUpdate: function(result) {
		            this._push(result, "pushUpdate");
		        },
	
		        _pushDestroy: function(result) {
		            this._push(result, "pushDestroy");
		        },
	
		        _push: function(result, operation) {
		            var data = this._readData(result);
	
		            if (!data) {
		                data = result;
		            }
	
		            this[operation](data);
		        },
	
		        _flatData: function(data, skip) {
		            if (data) {
		                if (this._isServerGrouped()) {
		                    return flattenGroups(data);
		                }
	
		                if (!skip) {
		                    for (var idx = 0; idx < data.length; idx++) {
		                        data.at(idx);
		                    }
		                }
		            }
	
		            return data;
		        },
	
		        parent: noop,
	
		        get: function(id) {
		            var idx, length, data = this._flatData(this._data, this.options.useRanges);
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if (data[idx].id == id) {
		                    return data[idx];
		                }
		            }
		        },
	
		        getByUid: function(id) {
		            return this._getByUid(id, this._data);
		        },
	
		        _getByUid: function(id, dataItems) {
		            var idx, length, data = this._flatData(dataItems, this.options.useRanges);
	
		            if (!data) {
		                return;
		            }
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if (data[idx].uid == id) {
		                    return data[idx];
		                }
		            }
		        },
	
		        indexOf: function(model) {
		            return indexOfModel(this._data, model);
		        },
	
		        at: function(index) {
		            return this._data.at(index);
		        },
	
		        data: function(value) {
		            var that = this;
		            if (value !== undefined) {
		                that._detachObservableParents();
		                that._data = this._observe(value);
	
		                that._pristineData = value.slice(0);
	
		                that._storeData();
	
		                that._ranges = [];
		                that.trigger("reset");
		                that._addRange(that._data);
	
		                that._total = that._data.length;
		                that._pristineTotal = that._total;
	
		                that._process(that._data);
		            } else {
		                if (that._data) {
		                    for (var idx = 0; idx < that._data.length; idx++) {
		                        that._data.at(idx);
		                    }
		                }
	
		                return that._data;
		            }
		        },
	
		        view: function(value) {
		            if (value === undefined) {
		                return this._view;
		            } else {
		                this._view = this._observeView(value);
		            }
		        },
	
		        _observeView: function(data) {
		            var that = this;
		            replaceWithObservable(data, that._data, that._ranges, that.reader.model || ObservableObject, that._isServerGrouped());
	
		            var view = new LazyObservableArray(data, that.reader.model);
		            view.parent = function() { return that.parent(); };
		            return view;
		        },
	
		        flatView: function() {
		            var groups = this.group() || [];
	
		            if (groups.length) {
		                return flattenGroups(this._view);
		            } else {
		                return this._view;
		            }
		        },
	
		        add: function(model) {
		            return this.insert(this._data.length, model);
		        },
	
		        _createNewModel: function(model) {
		            if (this.reader.model) {
		                return new this.reader.model(model);
		            }
	
		            if (model instanceof ObservableObject) {
		                return model;
		            }
	
		            return new ObservableObject(model);
		        },
	
		        insert: function(index, model) {
		            if (!model) {
		                model = index;
		                index = 0;
		            }
	
		            if (!(model instanceof Model)) {
		                model = this._createNewModel(model);
		            }
	
		            if (this._isServerGrouped()) {
		                this._data.splice(index, 0, this._wrapInEmptyGroup(model));
		            } else {
		                this._data.splice(index, 0, model);
		            }
	
		            this._insertModelInRange(index, model);
	
		            return model;
		        },
	
		        pushInsert: function(index, items) {
		            var that = this;
		            var rangeSpan = that._getCurrentRangeSpan();
	
		            if (!items) {
		                items = index;
		                index = 0;
		            }
	
		            if (!isArray(items)) {
		                items = [items];
		            }
	
		            var pushed = [];
		            var autoSync = this.options.autoSync;
		            this.options.autoSync = false;
	
		            try {
		                for (var idx = 0; idx < items.length; idx ++) {
		                    var item = items[idx];
	
		                    var result = this.insert(index, item);
	
		                    pushed.push(result);
	
		                    var pristine = result.toJSON();
	
		                    if (this._isServerGrouped()) {
		                        pristine = this._wrapInEmptyGroup(pristine);
		                    }
	
		                    this._pristineData.push(pristine);
	
		                    if (rangeSpan && rangeSpan.length) {
		                        $(rangeSpan).last()[0].pristineData.push(pristine);
		                    }
	
		                    index++;
		                }
		            } finally {
		                this.options.autoSync = autoSync;
		            }
	
		            if (pushed.length) {
		                this.trigger("push", {
		                    type: "create",
		                    items: pushed
		                });
		            }
		        },
	
		        pushCreate: function(items) {
		            this.pushInsert(this._data.length, items);
		        },
	
		        pushUpdate: function(items) {
		            if (!isArray(items)) {
		                items = [items];
		            }
	
		            var pushed = [];
	
		            for (var idx = 0; idx < items.length; idx ++) {
		                var item = items[idx];
		                var model = this._createNewModel(item);
	
		                var target = this.get(model.id);
	
		                if (target) {
		                    pushed.push(target);
	
		                    target.accept(item);
	
		                    target.trigger(CHANGE);
	
		                    this._updatePristineForModel(target, item);
		                } else {
		                    this.pushCreate(item);
		                }
		            }
	
		            if (pushed.length) {
		                this.trigger("push", {
		                    type: "update",
		                    items: pushed
		                });
		            }
		        },
	
		        pushDestroy: function(items) {
		            var pushed = this._removeItems(items);
	
		            if (pushed.length) {
		                this.trigger("push", {
		                    type: "destroy",
		                    items: pushed
		                });
		            }
		        },
	
		        _removeItems: function(items, removePristine) {
		            if (!isArray(items)) {
		                items = [items];
		            }
	
		            var shouldRemovePristine = typeof removePristine !== "undefined" ? removePristine : true;
	
		            var destroyed = [];
		            var autoSync = this.options.autoSync;
		            this.options.autoSync = false;
		            try {
		                for (var idx = 0; idx < items.length; idx ++) {
		                    var item = items[idx];
		                    var model = this._createNewModel(item);
		                    var found = false;
	
		                    this._eachItem(this._data, function(items){
		                        for (var idx = 0; idx < items.length; idx++) {
		                            var item = items.at(idx);
		                            if (item.id === model.id) {
		                                destroyed.push(item);
		                                items.splice(idx, 1);
		                                found = true;
		                                break;
		                            }
		                        }
		                    });
	
		                    if (found && shouldRemovePristine) {
		                        this._removePristineForModel(model);
		                        this._destroyed.pop();
		                    }
		                }
		            } finally {
		                this.options.autoSync = autoSync;
		            }
	
		            return destroyed;
		        },
	
		        remove: function(model) {
		            var result,
		                that = this,
		                hasGroups = that._isServerGrouped();
	
		            this._eachItem(that._data, function(items) {
		                result = removeModel(items, model);
	
		                if (result && hasGroups) {
		                    if (!result.isNew || !result.isNew()) {
		                        that._destroyed.push(result);
		                    }
		                    return true;
		                }
		            });
	
		            this._removeModelFromRanges(model);
	
		            return model;
		        },
	
		        destroyed: function() {
		            return this._destroyed;
		        },
	
		        created: function() {
		            var idx,
		                length,
		                result = [],
		                data = this._flatData(this._data, this.options.useRanges);
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if (data[idx].isNew && data[idx].isNew()) {
		                    result.push(data[idx]);
		                }
		            }
		            return result;
		        },
	
		        updated: function() {
		            var idx,
		                length,
		                result = [],
		                data = this._flatData(this._data, this.options.useRanges);
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if ((data[idx].isNew && !data[idx].isNew()) && data[idx].dirty) {
		                    result.push(data[idx]);
		                }
		            }
		            return result;
		        },
	
		        sync: function() {
		            var that = this,
		                created = [],
		                updated = [],
		                destroyed = that._destroyed;
	
		            var promise = $.Deferred().resolve().promise();
	
		            if (that.online()) {
	
		                if (!that.reader.model) {
		                    return promise;
		                }
	
		                created = that.created();
		                updated = that.updated();
	
		                var promises = [];
	
		                if (that.options.batch && that.transport.submit) {
		                    promises = that._sendSubmit(created, updated, destroyed);
		                } else {
		                    promises.push.apply(promises, that._send("create", created));
		                    promises.push.apply(promises, that._send("update", updated));
		                    promises.push.apply(promises, that._send("destroy", destroyed));
		                }
	
		                promise = $.when
		                 .apply(null, promises)
		                 .then(function() {
		                    var idx, length;
	
		                    for (idx = 0, length = arguments.length; idx < length; idx++){
		                        if (arguments[idx]) {
		                            that._accept(arguments[idx]);
		                        }
		                    }
	
		                    that._storeData(true);
	
		                    that._syncEnd();
	
		                    that._change({ action: "sync" });
	
		                    that.trigger(SYNC);
		                });
		            } else {
		                that._storeData(true);
	
		                that._syncEnd();
	
		                that._change({ action: "sync" });
		            }
	
		            return promise;
		        },
	
		        _syncEnd: noop,
	
		        cancelChanges: function(model) {
		            var that = this;
	
		            if (model instanceof kendo.data.Model) {
		                that._cancelModel(model);
		            } else {
		                that._destroyed = [];
		                that._detachObservableParents();
		                that._data = that._observe(that._pristineData);
		                if (that.options.serverPaging) {
		                    that._total = that._pristineTotal;
		                }
	
		                that._ranges = [];
		                that._addRange(that._data, 0);
	
		                that._changesCanceled();
	
		                that._change();
	
		                that._markOfflineUpdatesAsDirty();
		            }
		        },
	
		        _changesCanceled: noop,
	
		        _markOfflineUpdatesAsDirty: function() {
		            var that = this;
	
		            if (that.options.offlineStorage != null) {
		                that._eachItem(that._data, function(items) {
		                    for (var idx = 0; idx < items.length; idx++) {
		                        var item = items.at(idx);
		                        if (item.__state__ == "update" || item.__state__ == "create") {
		                            item.dirty = true;
		                        }
		                    }
		                });
		            }
		        },
	
		        hasChanges: function() {
		            var idx,
		                length,
		                data = this._flatData(this._data, this.options.useRanges);
	
		            if (this._destroyed.length) {
		                return true;
		            }
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if ((data[idx].isNew && data[idx].isNew()) || data[idx].dirty) {
		                    return true;
		                }
		            }
	
		            return false;
		        },
	
		        _accept: function(result) {
		            var that = this,
		                models = result.models,
		                response = result.response,
		                idx = 0,
		                serverGroup = that._isServerGrouped(),
		                pristine = that._pristineData,
		                type = result.type,
		                length;
	
		            that.trigger(REQUESTEND, { response: response, type: type });
	
		            if (response && !isEmptyObject(response)) {
		                response = that.reader.parse(response);
	
		                if (that._handleCustomErrors(response)) {
		                    return;
		                }
	
		                response = that.reader.data(response);
	
		                if (!isArray(response)) {
		                    response = [response];
		                }
		            } else {
		                response = $.map(models, function(model) { return model.toJSON(); } );
		            }
	
		            if (type === "destroy") {
		                that._destroyed = [];
		            }
	
		            for (idx = 0, length = models.length; idx < length; idx++) {
		                if (type !== "destroy") {
		                    models[idx].accept(response[idx]);
	
		                    if (type === "create") {
		                        pristine.push(serverGroup ? that._wrapInEmptyGroup(models[idx].toJSON()) : response[idx]);
		                    } else if (type === "update") {
		                        that._updatePristineForModel(models[idx], response[idx]);
		                    }
		                } else {
		                    that._removePristineForModel(models[idx]);
		                }
		            }
		        },
	
		        _updatePristineForModel: function(model, values) {
		            this._executeOnPristineForModel(model, function(index, items) {
		                kendo.deepExtend(items[index], values);
		            });
		        },
	
		        _executeOnPristineForModel: function(model, callback) {
		            this._eachPristineItem(
		                function(items) {
		                    var index = indexOfPristineModel(items, model);
		                    if (index > -1) {
		                        callback(index, items);
		                        return true;
		                    }
		                });
		        },
	
		        _removePristineForModel: function(model) {
		            this._executeOnPristineForModel(model, function(index, items) {
		                items.splice(index, 1);
		            });
		        },
	
		        _readData: function(data) {
		            var read = !this._isServerGrouped() ? this.reader.data : this.reader.groups;
		            return read.call(this.reader, data);
		        },
	
		        _eachPristineItem: function(callback) {
		            var that = this;
		            var options = that.options;
		            var rangeSpan = that._getCurrentRangeSpan();
	
		            that._eachItem(that._pristineData, callback);
	
		            if (options.serverPaging && options.useRanges) {
		                each(rangeSpan, function(i, range) {
		                    that._eachItem(range.pristineData, callback);
		                });
		            }
		        },
	
		       _eachItem: function(data, callback) {
		            if (data && data.length) {
		                if (this._isServerGrouped()) {
		                    eachGroupItems(data, callback);
		                } else {
		                    callback(data);
		                }
		            }
		        },
	
		        _pristineForModel: function(model) {
		            var pristine,
		                idx,
		                callback = function(items) {
		                    idx = indexOfPristineModel(items, model);
		                    if (idx > -1) {
		                        pristine = items[idx];
		                        return true;
		                    }
		                };
	
		            this._eachPristineItem(callback);
	
		            return pristine;
		        },
	
		        _cancelModel: function(model) {
		            var that = this;
		            var pristine = this._pristineForModel(model);
	
		            this._eachItem(this._data, function(items) {
		                var idx = indexOfModel(items, model);
		                if (idx >= 0) {
		                    if (pristine && (!model.isNew() || pristine.__state__)) {
		                        items[idx].accept(pristine);
	
		                        if (pristine.__state__ == "update") {
		                            items[idx].dirty = true;
		                        }
	
		                    } else {
		                        that._modelCanceled(model);
	
		                        items.splice(idx, 1);
	
		                        that._removeModelFromRanges(model);
		                    }
		                }
		            });
		        },
	
		        _modelCanceled: noop,
	
		        _submit: function(promises, data) {
		            var that = this;
	
		            that.trigger(REQUESTSTART, { type: "submit" });
	
		            that.trigger(PROGRESS);
	
		            that.transport.submit(extend({
		                success: function(response, type) {
		                    var promise = $.grep(promises, function(x) {
		                        return x.type == type;
		                    })[0];
	
		                    if (promise) {
		                        promise.resolve({
		                            response: response,
		                            models: promise.models,
		                            type: type
		                        });
		                    }
		                },
		                error: function(response, status, error) {
		                    for (var idx = 0; idx < promises.length; idx++) {
		                        promises[idx].reject(response);
		                    }
	
		                    that.error(response, status, error);
		                }
		            }, data));
		        },
	
		        _sendSubmit: function(created, updated, destroyed) {
		            var that = this,
		                promises = [];
	
		            if (that.options.batch) {
		                if (created.length) {
		                    promises.push($.Deferred(function(deferred) {
		                        deferred.type = "create";
		                        deferred.models = created;
		                    }));
		                }
	
		                if (updated.length) {
		                    promises.push($.Deferred(function(deferred) {
		                        deferred.type = "update";
		                        deferred.models = updated;
		                    }));
		                }
	
		                if (destroyed.length) {
		                    promises.push($.Deferred(function(deferred) {
		                        deferred.type = "destroy";
		                        deferred.models = destroyed;
		                    }));
		                }
	
		                that._submit(promises, {
		                    data: {
		                        created: that.reader.serialize(toJSON(created)),
		                        updated: that.reader.serialize(toJSON(updated)),
		                        destroyed: that.reader.serialize(toJSON(destroyed))
		                    }
		                });
		            }
	
		            return promises;
		        },
	
		        _promise: function(data, models, type) {
		            var that = this;
	
		            return $.Deferred(function(deferred) {
		                that.trigger(REQUESTSTART, { type: type });
	
		                that.trigger(PROGRESS);
	
		                that.transport[type].call(that.transport, extend({
		                    success: function(response) {
		                        deferred.resolve({
		                            response: response,
		                            models: models,
		                            type: type
		                        });
		                    },
		                    error: function(response, status, error) {
		                        deferred.reject(response);
		                        that.error(response, status, error);
		                    }
		                }, data));
		            }).promise();
		        },
	
		        _send: function(method, data) {
		            var that = this,
		                idx,
		                length,
		                promises = [],
		                converted = that.reader.serialize(toJSON(data));
	
		            if (that.options.batch) {
		                if (data.length) {
		                    promises.push(that._promise( { data: { models: converted } }, data , method));
		                }
		            } else {
		                for (idx = 0, length = data.length; idx < length; idx++) {
		                    promises.push(that._promise( { data: converted[idx] }, [ data[idx] ], method));
		                }
		            }
	
		            return promises;
		        },
	
		        read: function(data) {
		            var that = this, params = that._params(data);
		            var deferred = $.Deferred();
	
		            that._queueRequest(params, function() {
		                var isPrevented = that.trigger(REQUESTSTART, { type: "read" });
		                if (!isPrevented) {
		                    that.trigger(PROGRESS);
	
		                    that._ranges = [];
		                    that.trigger("reset");
		                    if (that.online()) {
		                        that.transport.read({
		                            data: params,
		                            success: function(data) {
		                                that._ranges = [];
		                                that.success(data, params);
	
		                                deferred.resolve();
		                            },
		                            error: function() {
		                                var args = slice.call(arguments);
	
		                                that.error.apply(that, args);
	
		                                deferred.reject.apply(deferred, args);
		                            }
		                        });
		                    } else if (that.options.offlineStorage != null){
		                        that.success(that.offlineData(), params);
	
		                        deferred.resolve();
		                    }
		                } else {
		                    that._dequeueRequest();
	
		                    deferred.resolve(isPrevented);
		                }
		            });
	
		            return deferred.promise();
		        },
	
		        _readAggregates: function(data) {
		            return this.reader.aggregates(data);
		        },
	
		        success: function(data) {
		            var that = this,
		                options = that.options,
		                items,
		                replaceSubset;
	
		            that.trigger(REQUESTEND, { response: data, type: "read" });
	
		            if (that.online()) {
		                data = that.reader.parse(data);
	
		                if (that._handleCustomErrors(data)) {
		                    that._dequeueRequest();
		                    return;
		                }
	
		                that._total = that.reader.total(data);
		                if (that._pageSize > that._total) {
		                    that._pageSize = that._total;
		                    if (that.options.pageSize && that.options.pageSize > that._pageSize) {
		                        that._pageSize = that.options.pageSize;
		                    }
		                }
	
		                if (that._aggregate && options.serverAggregates) {
		                    that._aggregateResult = that._readAggregates(data);
		                }
	
		                data = that._readData(data);
	
		                that._destroyed = [];
		            } else {
		                data = that._readData(data);
	
		                items = [];
		                var itemIds = {};
		                var model = that.reader.model;
		                var idField = model ? model.idField : "id";
		                var idx;
	
		                for (idx = 0; idx < this._destroyed.length; idx++) {
		                    var id = this._destroyed[idx][idField];
		                    itemIds[id] = id;
		                }
	
		                for (idx = 0; idx < data.length; idx++) {
		                    var item = data[idx];
		                    var state = item.__state__;
		                    if (state == "destroy") {
		                        if (!itemIds[item[idField]]) {
		                            this._destroyed.push(this._createNewModel(item));
		                        }
		                    } else {
		                        items.push(item);
		                    }
		                }
	
		                data = items;
	
		                that._total = data.length;
		            }
	
		            that._pristineTotal = that._total;
		            replaceSubset = that._skip && that._data.length && that._skip < that._data.length;
	
		            if (that.options.endless) {
		                if (replaceSubset) {
		                    that._pristineData.splice(that._skip, that._pristineData.length);
		                }
		                items = data.slice(0);
		                for (var j = 0; j < items.length; j++) {
		                    that._pristineData.push(items[j]);
		                }
		            } else {
		                that._pristineData = data.slice(0);
		            }
	
		            that._detachObservableParents();
	
		            if (that.options.endless) {
		                that._data.unbind(CHANGE, that._changeHandler);
	
		                if (that._isServerGrouped() && that._data[that._data.length - 1].value === data[0].value) {
		                    fillLastGroup(that._data[that._data.length - 1], data[0]);
		                    data.shift();
		                }
	
		                data = that._observe(data);
		                if (replaceSubset) {
		                    that._data.splice(that._skip, that._data.length);
		                }
		                for (var i = 0; i < data.length; i++) {
		                    that._data.push(data[i]);
		                }
		                that._data.bind(CHANGE, that._changeHandler);
		            } else {
		                that._data = that._observe(data);
		            }
	
		            that._markOfflineUpdatesAsDirty();
	
		            that._storeData();
	
		            that._addRange(that._data);
	
		            that._process(that._data);
	
		            that._dequeueRequest();
		        },
	
		        _detachObservableParents: function() {
		            if (this._data && this._shouldDetachObservableParents) {
		                for (var idx = 0; idx < this._data.length; idx++) {
		                    if (this._data[idx].parent) {
		                        this._data[idx].parent = noop;
		                    }
		                }
		            }
		        },
	
		        _storeData: function(updatePristine) {
		            var serverGrouping = this._isServerGrouped();
		            var model = this.reader.model;
	
		            function items(data) {
		                var state = [];
	
		                for (var idx = 0; idx < data.length; idx++) {
		                    var dataItem = data.at(idx);
		                    var item = dataItem.toJSON();
	
		                    if (serverGrouping && dataItem.items) {
		                        item.items = items(dataItem.items);
		                    } else {
		                        item.uid = dataItem.uid;
	
		                        if (model) {
		                            if (dataItem.isNew()) {
		                                item.__state__ = "create";
		                            } else if (dataItem.dirty) {
		                                item.__state__ = "update";
		                            }
		                        }
		                    }
		                    state.push(item);
		                }
	
		                return state;
		            }
	
		            if (this.options.offlineStorage != null) {
		                var state = items(this._data);
	
		                var destroyed = [];
	
		                for (var idx = 0; idx < this._destroyed.length; idx++) {
		                    var item = this._destroyed[idx].toJSON();
		                    item.__state__ = "destroy";
		                    destroyed.push(item);
		                }
	
		                this.offlineData(state.concat(destroyed));
	
		                if (updatePristine) {
		                    this._pristineData = this.reader.reader ? this.reader.reader._wrapDataAccessBase(state) : this.reader._wrapDataAccessBase(state);
		                }
		            }
		        },
	
		        _addRange: function(data, skip) {
		            var that = this,
		                start = typeof(skip) !== "undefined" ? skip : (that._skip || 0),
		                end = start + that._flatData(data, true).length;
	
		            that._ranges.push({
		                start: start,
		                end: end,
		                data: data,
		                pristineData: data.toJSON(),
		                timestamp: that._timeStamp()
		            });
	
		            that._sortRanges();
		        },
	
		        _sortRanges: function() {
		            this._ranges.sort(function(x, y) {
		                return x.start - y.start;
		            });
		        },
	
		        error: function(xhr, status, errorThrown) {
		            this._dequeueRequest();
		            this.trigger(REQUESTEND, { });
		            this.trigger(ERROR, { xhr: xhr, status: status, errorThrown: errorThrown });
		        },
	
		        _params: function(data) {
		            var that = this,
		                options =  extend({
		                    take: that.take(),
		                    skip: that.skip(),
		                    page: that.page(),
		                    pageSize: that.pageSize(),
		                    sort: that._sort,
		                    filter: that._filter,
		                    group: that._group,
		                    aggregate: that._aggregate
		                }, data);
	
		            if (!that.options.serverPaging) {
		                delete options.take;
		                delete options.skip;
		                delete options.page;
		                delete options.pageSize;
		            }
	
		            if (!that.options.serverGrouping) {
		                delete options.group;
		            } else if (that.reader.model && options.group) {
		                options.group = convertDescriptorsField(options.group, that.reader.model);
		            }
	
		            if (!that.options.serverFiltering) {
		                delete options.filter;
		            } else if (that.reader.model && options.filter) {
		               options.filter = convertFilterDescriptorsField(options.filter, that.reader.model);
		            }
	
		            if (!that.options.serverSorting) {
		                delete options.sort;
		            } else if (that.reader.model && options.sort) {
		                options.sort = convertDescriptorsField(options.sort, that.reader.model);
		            }
	
		            if (!that.options.serverAggregates) {
		                delete options.aggregate;
		            } else if (that.reader.model && options.aggregate) {
		                options.aggregate = convertDescriptorsField(options.aggregate, that.reader.model);
		            }
	
		            return options;
		        },
	
		        _queueRequest: function(options, callback) {
		            var that = this;
		            if (!that._requestInProgress) {
		                that._requestInProgress = true;
		                that._pending = undefined;
		                callback();
		            } else {
		                that._pending = { callback: proxy(callback, that), options: options };
		            }
		        },
	
		        _dequeueRequest: function() {
		            var that = this;
		            that._requestInProgress = false;
		            if (that._pending) {
		                that._queueRequest(that._pending.options, that._pending.callback);
		            }
		        },
	
		        _handleCustomErrors: function(response) {
		            if (this.reader.errors) {
		                var errors = this.reader.errors(response);
		                if (errors) {
		                    this.trigger(ERROR, { xhr: null, status: "customerror", errorThrown: "custom error", errors: errors });
		                    return true;
		                }
		            }
		            return false;
		        },
	
		        _shouldWrap: function(data) {
		            var model = this.reader.model;
	
		            if (model && data.length) {
		                return !(data[0] instanceof model);
		            }
	
		            return false;
		        },
	
		        _observe: function(data) {
		            var that = this,
		                model = that.reader.model;
	
		            that._shouldDetachObservableParents = true;
	
		            if (data instanceof ObservableArray) {
		                that._shouldDetachObservableParents = false;
		                if (that._shouldWrap(data)) {
		                    data.type = that.reader.model;
		                    data.wrapAll(data, data);
		                }
		            } else {
		                var arrayType = that.pageSize() && !that.options.serverPaging ? LazyObservableArray : ObservableArray;
		                data = new arrayType(data, that.reader.model);
		                data.parent = function() { return that.parent(); };
		            }
	
		            if (that._isServerGrouped()) {
		                wrapGroupItems(data, model);
		            }
	
		            if (that._changeHandler && that._data && that._data instanceof ObservableArray) {
		                that._data.unbind(CHANGE, that._changeHandler);
		            } else {
		                that._changeHandler = proxy(that._change, that);
		            }
	
		            return data.bind(CHANGE, that._changeHandler);
		        },
	
		        _updateTotalForAction: function(action, items) {
		            var that = this;
	
		            var total = parseInt(that._total, 10);
	
		            if (!isNumber(that._total)) {
		                total = parseInt(that._pristineTotal, 10);
		            }
		            if (action === "add") {
		                total += items.length;
		            } else if (action === "remove") {
		                total -= items.length;
		            } else if (action !== "itemchange" && action !== "sync" && !that.options.serverPaging) {
		                total = that._pristineTotal;
		            } else if (action === "sync") {
		                total = that._pristineTotal = parseInt(that._total, 10);
		            }
	
		            that._total = total;
		        },
	
		        _change: function(e) {
		            var that = this, idx, length, action = e ? e.action : "";
	
		            if (action === "remove") {
		                for (idx = 0, length = e.items.length; idx < length; idx++) {
		                    if (!e.items[idx].isNew || !e.items[idx].isNew()) {
		                        that._destroyed.push(e.items[idx]);
		                    }
		                }
		            }
	
		            if (that.options.autoSync && (action === "add" || action === "remove" || action === "itemchange")) {
	
		                var handler = function(args) {
		                    if (args.action === "sync") {
		                        that.unbind("change", handler);
		                        that._updateTotalForAction(action, e.items);
		                    }
		                };
	
		                that.first("change", handler);
	
		                that.sync();
	
		            } else {
		                that._updateTotalForAction(action, e ? e.items : []);
	
		                that._process(that._data, e);
		            }
		        },
	
		        _calculateAggregates: function (data, options) {
		            options = options || {};
	
		            var query = new Query(data),
		                aggregates = options.aggregate,
		                filter = options.filter;
	
		            if (filter) {
		                query = query.filter(filter);
		            }
	
		            return query.aggregate(aggregates);
		        },
	
		        _process: function (data, e) {
		            var that = this,
		                options = {},
		                result;
	
		            if (that.options.serverPaging !== true) {
		                options.skip = that._skip;
		                options.take = that._take || that._pageSize;
	
		                if(options.skip === undefined && that._page !== undefined && that._pageSize !== undefined) {
		                    options.skip = (that._page - 1) * that._pageSize;
		                }
	
		                if (that.options.useRanges) {
		                    options.skip = that.currentRangeStart();
		                }
		            }
	
		            if (that.options.serverSorting !== true) {
		                options.sort = that._sort;
		            }
	
		            if (that.options.serverFiltering !== true) {
		                options.filter = that._filter;
		            }
	
		            if (that.options.serverGrouping !== true) {
		                options.group = that._group;
		            }
	
		            if (that.options.serverAggregates !== true) {
		                options.aggregate = that._aggregate;
		            }
	
		            if (that.options.serverGrouping) {
		                that._clearEmptyGroups(data);
		            }
	
		            result = that._queryProcess(data, options);
	
		            if (that.options.serverAggregates !== true) {
		                // for performance reasons, calculate aggregates for part of the data only after query process
		                // this is necessary in the TreeList when paging
		                that._aggregateResult = that._calculateAggregates(result.dataToAggregate || data, options);
		            }
	
		            that.view(result.data);
	
		            that._setFilterTotal(result.total, false);
	
		            e = e || {};
	
		            e.items = e.items || that._view;
	
		            that.trigger(CHANGE, e);
		        },
	
		        _clearEmptyGroups: function(data) {
		            for (var idx = data.length - 1; idx >=0; idx--) {
		                var group = data[idx];
		                if (group.hasSubgroups) {
		                    this._clearEmptyGroups(group.items);
		                } else {
		                    if (group.items && !group.items.length) {
		                        splice.apply(group.parent(), [idx, 1]);
		                    }
		                }
		            }
		        },
	
		        _queryProcess: function(data, options) {
		            if (this.options.inPlaceSort) {
		                return Query.process(data, options, this.options.inPlaceSort);
		            }
		            else {
		                return Query.process(data, options);
		            }
		        },
	
		        _mergeState: function(options) {
		            var that = this;
	
		            if (options !== undefined) {
		                that._pageSize = options.pageSize;
		                that._page = options.page;
		                that._sort = options.sort;
		                that._filter = options.filter;
		                that._group = options.group;
		                that._aggregate = options.aggregate;
		                that._skip = that._currentRangeStart = options.skip;
		                that._take = options.take;
	
		                if(that._skip === undefined) {
		                    that._skip = that._currentRangeStart = that.skip();
		                    options.skip = that.skip();
		                }
	
		                if(that._take === undefined && that._pageSize !== undefined) {
		                    that._take = that._pageSize;
		                    options.take = that._take;
		                }
	
		                if (options.sort) {
		                    that._sort = options.sort = normalizeSort(options.sort);
		                }
	
		                if (options.filter) {
		                    that._filter = options.filter = normalizeFilter(options.filter);
		                }
	
		                if (options.group) {
		                    that._group = options.group = normalizeGroup(options.group);
		                }
		                if (options.aggregate) {
		                    that._aggregate = options.aggregate = normalizeAggregate(options.aggregate);
		                }
		            }
		            return options;
		        },
	
		        query: function(options) {
		            var result;
		            var remote = this.options.serverSorting || this.options.serverPaging || this.options.serverFiltering || this.options.serverGrouping || this.options.serverAggregates;
	
		            if (remote || ((this._data === undefined || this._data.length === 0) && !this._destroyed.length)) {
		                if (this.options.endless) {
		                    var moreItemsCount = options.pageSize - this.pageSize();
		                    if (moreItemsCount > 0) {
		                        moreItemsCount = this.pageSize();
		                        options.page = options.pageSize / moreItemsCount;
		                        options.pageSize = moreItemsCount;
		                    } else {
		                        options.page = 1;
		                        this.options.endless = false;
		                    }
		                }
		                return this.read(this._mergeState(options));
		            }
	
		            var isPrevented = this.trigger(REQUESTSTART, { type: "read" });
		            if (!isPrevented) {
		                this.trigger(PROGRESS);
	
		                result = this._queryProcess(this._data, this._mergeState(options));
	
		                this._setFilterTotal(result.total, true);
	
		                this._aggregateResult = this._calculateAggregates(result.dataToAggregate || this._data, options);
		                this.view(result.data);
		                this.trigger(REQUESTEND, { type: "read" });
		                this.trigger(CHANGE, { items: result.data });
		            }
	
		            return $.Deferred().resolve(isPrevented).promise();
		        },
	
		        _setFilterTotal: function(filterTotal, setDefaultValue) {
		            var that = this;
	
		            if (!that.options.serverFiltering) {
		                if (filterTotal !== undefined) {
		                    that._total = filterTotal;
		                } else if (setDefaultValue) {
		                    that._total = that._data.length;
		                }
		            }
		        },
	
		        fetch: function(callback) {
		            var that = this;
		            var fn = function(isPrevented) {
		                if (isPrevented !== true && isFunction(callback)) {
		                    callback.call(that);
		                }
		            };
	
		            return this._query().then(fn);
		        },
	
		        _query: function(options) {
		            var that = this;
	
		            return that.query(extend({}, {
		                page: that.page(),
		                pageSize: that.pageSize(),
		                sort: that.sort(),
		                filter: that.filter(),
		                group: that.group(),
		                aggregate: that.aggregate()
		            }, options));
		        },
	
		        next: function(options) {
		            var that = this,
		                page = that.page(),
		                total = that.total();
	
		            options = options || {};
	
		            if (!page || (total && page + 1 > that.totalPages())) {
		                return;
		            }
	
		            that._skip = that._currentRangeStart = page * that.take();
	
		            page += 1;
		            options.page = page;
	
		            that._query(options);
	
		            return page;
		        },
	
		        prev: function(options) {
		            var that = this,
		                page = that.page();
	
		            options = options || {};
	
		            if (!page || page === 1) {
		                return;
		            }
	
		            that._skip = that._currentRangeStart = that._skip - that.take();
	
		            page -= 1;
		            options.page = page;
	
		            that._query(options);
	
		            return page;
		        },
	
		        page: function(val) {
		            var that = this,
		            skip;
	
		            if(val !== undefined) {
		                val = math.max(math.min(math.max(val, 1), that.totalPages()), 1);
		                that._query(that._pageableQueryOptions({ page: val }));
		                return;
		            }
		            skip = that.skip();
	
		            return skip !== undefined ? math.round((skip || 0) / (that.take() || 1)) + 1 : undefined;
		        },
	
		        pageSize: function(val) {
		            var that = this;
	
		            if (val !== undefined) {
		                that._query(that._pageableQueryOptions({ pageSize: val, page: 1 }));
		                return;
		            }
	
		            return that.take();
		        },
	
		        sort: function(val) {
		            var that = this;
	
		            if(val !== undefined) {
		                that._query({ sort: val });
		                return;
		            }
	
		            return that._sort;
		        },
	
		        filter: function(val) {
		            var that = this;
	
		            if (val === undefined) {
		                return that._filter;
		            }
	
		            that.trigger("reset");
		            that._query({ filter: val, page: 1 });
		        },
	
		        group: function(val) {
		            var that = this;
	
		            if(val !== undefined) {
		                that._query({ group: val });
		                return;
		            }
	
		            return that._group;
		        },
	
		        total: function() {
		            return parseInt(this._total || 0, 10);
		        },
	
		        aggregate: function(val) {
		            var that = this;
	
		            if(val !== undefined) {
		                that._query({ aggregate: val });
		                return;
		            }
	
		            return that._aggregate;
		        },
	
		        aggregates: function() {
		            var result = this._aggregateResult;
	
		            if (isEmptyObject(result)) {
		                result = this._emptyAggregates(this.aggregate());
		            }
	
		            return result;
		        },
	
		        _emptyAggregates: function(aggregates) {
		            var result = {};
	
		            if (!isEmptyObject(aggregates)) {
		                var aggregate = {};
	
		                if (!isArray(aggregates)){
		                    aggregates = [aggregates];
		                }
	
		                for (var idx = 0; idx <aggregates.length; idx++) {
		                    aggregate[aggregates[idx].aggregate] = 0;
		                    result[aggregates[idx].field] = aggregate;
		                }
		            }
	
		            return result;
		        },
	
		        _pageableQueryOptions: function(options) {
		            return options;
		        },
	
		        _wrapInEmptyGroup: function(model) {
		            var groups = this.group(),
		                parent,
		                group,
		                idx,
		                length;
	
		            for (idx = groups.length-1, length = 0; idx >= length; idx--) {
		                group = groups[idx];
		                parent = {
		                    value: model.get ? model.get(group.field) : model[group.field],
		                    field: group.field,
		                    items: parent ? [parent] : [model],
		                    hasSubgroups: !!parent,
		                    aggregates: this._emptyAggregates(group.aggregates)
		                };
		            }
	
		            return parent;
		        },
	
		        totalPages: function() {
		            var that = this,
		            pageSize = that.pageSize() || that.total();
	
		            return math.ceil((that.total() || 0) / pageSize);
		        },
	
		        inRange: function(skip, take) {
		            var that = this,
		                end = math.min(skip + take, that.total());
	
		            if (!that.options.serverPaging && that._data.length > 0) {
		                return true;
		            }
	
		            return that._findRange(skip, end).length > 0;
		        },
	
		        lastRange: function() {
		            var ranges = this._ranges;
		            return ranges[ranges.length - 1] || { start: 0, end: 0, data: [] };
		        },
	
		        firstItemUid: function() {
		            var ranges = this._ranges;
		            return ranges.length && ranges[0].data.length && ranges[0].data[0].uid;
		        },
	
		        enableRequestsInProgress: function() {
		            this._skipRequestsInProgress = false;
		        },
	
		        _timeStamp: function() {
		            return new Date().getTime();
		        },
	
		        range: function(skip, take, callback) {
		            this._currentRequestTimeStamp = this._timeStamp();
		            this._skipRequestsInProgress = true;
	
		            skip = math.min(skip || 0, this.total());
		            callback = isFunction(callback) ? callback : noop;
	
		            var that = this,
		                pageSkip = math.max(math.floor(skip / take), 0) * take,
		                size = math.min(pageSkip + take, that.total()),
		                data;
	
		            data = that._findRange(skip, math.min(skip + take, that.total()));
	
		            if (data.length || that.total() === 0) {
		                that._processRangeData(data, skip, take, pageSkip, size);
		                callback();
		                return;
		            }
	
		            if (take !== undefined) {
		                if (!that._rangeExists(pageSkip, size)) {
		                    that.prefetch(pageSkip, take, function() {
		                        if (skip > pageSkip && size < that.total() && !that._rangeExists(size, math.min(size + take, that.total()))) {
		                            that.prefetch(size, take, function() {
		                                that.range(skip, take, callback );
		                            });
		                        } else {
		                            that.range(skip, take, callback);
		                        }
		                    });
		                } else if (pageSkip < skip) {
		                    that.prefetch(size, take, function() {
		                        that.range(skip, take, callback );
		                    });
		                }
		            }
		        },
	
		        _findRange: function(start, end) {
		            var that = this,
		                ranges = that._ranges,
		                range,
		                data = [],
		                skipIdx,
		                takeIdx,
		                startIndex,
		                endIndex,
		                rangeData,
		                rangeEnd,
		                processed,
		                options = that.options,
		                remote = options.serverSorting || options.serverPaging || options.serverFiltering || options.serverGrouping || options.serverAggregates,
		                flatData,
		                count,
		                length;
	
		            for (skipIdx = 0, length = ranges.length; skipIdx < length; skipIdx++) {
		                range = ranges[skipIdx];
		                if (start >= range.start && start <= range.end) {
		                    count = 0;
	
		                    for (takeIdx = skipIdx; takeIdx < length; takeIdx++) {
		                        range = ranges[takeIdx];
		                        flatData = that._flatData(range.data, true);
	
		                        if (flatData.length && start + count >= range.start) {
		                            rangeData = range.data;
		                            rangeEnd = range.end;
	
		                            if (!remote) {
		                                if (options.inPlaceSort) {
		                                    processed = that._queryProcess(range.data, { filter: that.filter() });
		                                } else {
		                                    var sort = normalizeGroup(that.group() || []).concat(normalizeSort(that.sort() || []));
		                                    processed = that._queryProcess(range.data, { sort: sort, filter: that.filter() });
		                                }
		                                flatData = rangeData = processed.data;
	
		                                if (processed.total !== undefined) {
		                                    rangeEnd = processed.total;
		                                }
		                            }
	
		                            startIndex = 0;
		                            if (start + count > range.start) {
		                                startIndex = (start + count) - range.start;
		                            }
		                            endIndex = flatData.length;
		                            if (rangeEnd > end) {
		                                endIndex = endIndex - (rangeEnd - end);
		                            }
		                            count += endIndex - startIndex;
		                            data = that._mergeGroups(data, rangeData, startIndex, endIndex);
	
		                            if (end <= range.end && count == end - start) {
		                                return data;
		                            }
		                        }
		                    }
		                    break;
		                }
		            }
		            return [];
		        },
	
		        _mergeGroups: function(data, range, skip, take) {
		            if (this._isServerGrouped()) {
		                var temp = range.toJSON(),
		                    prevGroup;
	
		                if (data.length) {
		                    prevGroup = data[data.length - 1];
		                }
	
		                mergeGroups(prevGroup, temp, skip, take);
	
		                return data.concat(temp);
		            }
		            return data.concat(range.slice(skip, take));
		        },
	
		        _processRangeData: function(data, skip, take, pageSkip, size) {
		            var that = this;
	
		            that._pending = undefined;
	
		            that._skip = skip > that.skip() ? math.min(size, (that.totalPages() - 1) * that.take()) : pageSkip;
	
		            that._currentRangeStart = skip;
	
		            that._take = take;
	
		            var paging = that.options.serverPaging;
		            var sorting = that.options.serverSorting;
		            var filtering = that.options.serverFiltering;
		            var aggregates = that.options.serverAggregates;
		            try {
		                that.options.serverPaging = true;
		                if (!that._isServerGrouped() && !(that.group() && that.group().length)) {
		                    that.options.serverSorting = true;
		                }
		                that.options.serverFiltering = true;
		                that.options.serverPaging = true;
		                that.options.serverAggregates = true;
	
		                if (paging) {
		                    that._detachObservableParents();
		                    that._data = data = that._observe(data);
		                }
		                that._process(data);
		            } finally {
		                that.options.serverPaging = paging;
		                that.options.serverSorting = sorting;
		                that.options.serverFiltering = filtering;
		                that.options.serverAggregates = aggregates;
		            }
		        },
	
		        skip: function() {
		            var that = this;
	
		            if (that._skip === undefined) {
		                return (that._page !== undefined ? (that._page  - 1) * (that.take() || 1) : undefined);
		            }
		            return that._skip;
		        },
	
		        currentRangeStart: function() {
		            return this._currentRangeStart || 0;
		        },
	
		        take: function() {
		            return this._take || this._pageSize;
		        },
	
		        _prefetchSuccessHandler: function (skip, size, callback, force) {
		            var that = this;
		            var timestamp = that._timeStamp();
	
		            return function(data) {
		                var found = false,
		                    range = { start: skip, end: size, data: [], timestamp: that._timeStamp() },
		                    idx,
		                    length,
		                    temp;
	
		                that._dequeueRequest();
	
		                that.trigger(REQUESTEND, { response: data, type: "read" });
	
		                data = that.reader.parse(data);
	
		                temp = that._readData(data);
	
		                if (temp.length) {
		                    for (idx = 0, length = that._ranges.length; idx < length; idx++) {
		                        if (that._ranges[idx].start === skip) {
		                            found = true;
		                            range = that._ranges[idx];
	
		                            range.pristineData = temp;
		                            range.data = that._observe(temp);
		                            range.end = range.start + that._flatData(range.data, true).length;
		                            that._sortRanges();
	
		                            break;
		                        }
		                    }
	
		                    if (!found) {
		                        that._addRange(that._observe(temp), skip);
		                    }
		                }
	
		                that._total = that.reader.total(data);
	
		                if (force || (timestamp >= that._currentRequestTimeStamp || !that._skipRequestsInProgress)) {
		                    if (callback && temp.length) {
		                        callback();
		                    } else {
		                        that.trigger(CHANGE, {});
		                    }
		                }
		            };
		        },
	
		        prefetch: function(skip, take, callback) {
		            var that = this,
		                size = math.min(skip + take, that.total()),
		                options = {
		                    take: take,
		                    skip: skip,
		                    page: skip / take + 1,
		                    pageSize: take,
		                    sort: that._sort,
		                    filter: that._filter,
		                    group: that._group,
		                    aggregate: that._aggregate
		                };
	
		            if (!that._rangeExists(skip, size)) {
		                clearTimeout(that._timeout);
	
		                that._timeout = setTimeout(function() {
		                    that._queueRequest(options, function() {
		                        if (!that.trigger(REQUESTSTART, { type: "read" })) {
		                            that.transport.read({
		                                data: that._params(options),
		                                success: that._prefetchSuccessHandler(skip, size, callback),
		                                error: function() {
		                                    var args = slice.call(arguments);
		                                    that.error.apply(that, args);
		                                }
		                            });
		                        } else {
		                            that._dequeueRequest();
		                        }
		                    });
		                }, 100);
		            } else if (callback) {
		                callback();
		            }
		        },
	
		        _multiplePrefetch: function(skip, take, callback) {
		            var that = this,
		                size = math.min(skip + take, that.total()),
		                options = {
		                    take: take,
		                    skip: skip,
		                    page: skip / take + 1,
		                    pageSize: take,
		                    sort: that._sort,
		                    filter: that._filter,
		                    group: that._group,
		                    aggregate: that._aggregate
		                };
	
		            if (!that._rangeExists(skip, size)) {
		                if (!that.trigger(REQUESTSTART, { type: "read" })) {
		                    that.transport.read({
		                        data: that._params(options),
		                        success: that._prefetchSuccessHandler(skip, size, callback, true)
		                    });
		                }
		            } else if (callback) {
		                callback();
		            }
		        },
	
		        _rangeExists: function(start, end) {
		            var that = this,
		                ranges = that._ranges,
		                idx,
		                length;
	
		            for (idx = 0, length = ranges.length; idx < length; idx++) {
		                if (ranges[idx].start <= start && ranges[idx].end >= end) {
		                    return true;
		                }
		            }
	
		            return false;
		        },
	
		        _getCurrentRangeSpan: function() {
		            var that = this;
		            var ranges = that._ranges;
		            var start = that.currentRangeStart();
		            var end = start + (that.take() || 0);
		            var rangeSpan = [];
		            var range;
		            var idx;
		            var length = ranges.length;
	
		            for (idx = 0; idx < length; idx++) {
		                range = ranges[idx];
	
		                if ((range.start <= start && range.end >= start) || (range.start >= start && range.start <= end)) {
		                    rangeSpan.push(range);
		                }
		            }
	
		            return rangeSpan;
		        },
	
		        _removeModelFromRanges: function(model) {
		            var that = this;
		            var result,
		                range;
	
		            for (var idx = 0, length = this._ranges.length; idx < length; idx++) {
		                range = this._ranges[idx];
	
		                this._eachItem(range.data, function(items) {
		                    result = removeModel(items, model);
		                });
	
		                if (result) {
		                    break;
		                }
		            }
	
		            that._updateRangesLength();
		        },
	
		        _insertModelInRange: function(index, model) {
		            var that = this;
		            var ranges = that._ranges || [];
		            var rangesLength = ranges.length;
		            var range;
		            var i;
	
		            for (i = 0; i < rangesLength; i++) {
		                range = ranges[i];
	
		                if (range.start <= index && range.end >= index) {
		                    if (!that._getByUid(model.uid, range.data)) {
		                        if (that._isServerGrouped()) {
		                            range.data.splice(index, 0, that._wrapInEmptyGroup(model));
		                        } else {
		                            range.data.splice(index, 0, model);
		                        }
		                    }
	
		                    break;
		                }
		            }
	
		            that._updateRangesLength();
		        },
	
		        _updateRangesLength: function() {
		            var that = this;
		            var ranges = that._ranges || [];
		            var rangesLength = ranges.length;
		            var mismatchFound = false;
		            var mismatchLength = 0;
		            var lengthDifference = 0;
		            var range;
		            var i;
	
		            for (i = 0; i < rangesLength; i++) {
		                range = ranges[i];
		                lengthDifference = that._flatData(range.data, true).length - math.abs(range.end - range.start);
	
		                if (!mismatchFound && lengthDifference !== 0) {
		                    mismatchFound = true;
		                    mismatchLength = lengthDifference;
		                    range.end += mismatchLength;
		                    continue;
		                }
	
		                if (mismatchFound) {
		                    range.start += mismatchLength;
		                    range.end += mismatchLength;
		                }
		            }
		        }
		    });
	
		    var Transport = {};
	
		    Transport.create = function(options, data, dataSource) {
		        var transport,
		            transportOptions = options.transport ? $.extend({}, options.transport) : null;
	
		        if (transportOptions) {
		            transportOptions.read = typeof transportOptions.read === STRING ? { url: transportOptions.read } : transportOptions.read;
	
		            if (options.type === "jsdo") {
		                transportOptions.dataSource = dataSource;
		            }
	
		            if (options.type) {
		                kendo.data.transports = kendo.data.transports || {};
		                kendo.data.schemas = kendo.data.schemas || {};
	
		                if (!kendo.data.transports[options.type]) {
		                    kendo.logToConsole("Unknown DataSource transport type '" + options.type + "'.\nVerify that registration scripts for this type are included after Kendo UI on the page.", "warn");
		                } else if (!isPlainObject(kendo.data.transports[options.type])) {
		                    transport = new kendo.data.transports[options.type](extend(transportOptions, { data: data }));
		                } else {
		                    transportOptions = extend(true, {}, kendo.data.transports[options.type], transportOptions);
		                }
	
		                options.schema = extend(true, {}, kendo.data.schemas[options.type], options.schema);
		            }
	
		            if (!transport) {
		                transport = isFunction(transportOptions.read) ? transportOptions : new RemoteTransport(transportOptions);
		            }
		        } else {
		            transport = new LocalTransport({ data: options.data || [] });
		        }
		        return transport;
		    };
	
		    DataSource.create = function(options) {
		        if (isArray(options) || options instanceof ObservableArray) {
		           options = { data: options };
		        }
	
		        var dataSource = options || {},
		            data = dataSource.data,
		            fields = dataSource.fields,
		            table = dataSource.table,
		            select = dataSource.select,
		            idx,
		            length,
		            model = {},
		            field;
	
		        if (!data && fields && !dataSource.transport) {
		            if (table) {
		                data = inferTable(table, fields);
		            } else if (select) {
		                data = inferSelect(select, fields);
	
		                if (dataSource.group === undefined && data[0] && data[0].optgroup !== undefined) {
		                    dataSource.group = "optgroup";
		                }
		            }
		        }
	
		        if (kendo.data.Model && fields && (!dataSource.schema || !dataSource.schema.model)) {
		            for (idx = 0, length = fields.length; idx < length; idx++) {
		                field = fields[idx];
		                if (field.type) {
		                    model[field.field] = field;
		                }
		            }
	
		            if (!isEmptyObject(model)) {
		                dataSource.schema = extend(true, dataSource.schema, { model:  { fields: model } });
		            }
		        }
	
		        dataSource.data = data;
	
		        select = null;
		        dataSource.select = null;
		        table = null;
		        dataSource.table = null;
	
		        return dataSource instanceof DataSource ? dataSource : new DataSource(dataSource);
		    };
	
		    function inferSelect(select, fields) {
		        select = $(select)[0];
		        var options = select.options;
		        var firstField = fields[0];
		        var secondField = fields[1];
	
		        var data = [];
		        var idx, length;
		        var optgroup;
		        var option;
		        var record;
		        var value;
	
		        for (idx = 0, length = options.length; idx < length; idx++) {
		            record = {};
		            option = options[idx];
		            optgroup = option.parentNode;
	
		            if (optgroup === select) {
		                optgroup = null;
		            }
	
		            if (option.disabled || (optgroup && optgroup.disabled)) {
		                continue;
		            }
	
		            if (optgroup) {
		                record.optgroup = optgroup.label;
		            }
	
		            record[firstField.field] = option.text;
	
		            value = option.attributes.value;
	
		            if (value && value.specified) {
		                value = option.value;
		            } else {
		                value = option.text;
		            }
	
		            record[secondField.field] = value;
	
		            data.push(record);
		        }
	
		        return data;
		    }
	
		    function inferTable(table, fields) {
		        var tbody = $(table)[0].tBodies[0],
		        rows = tbody ? tbody.rows : [],
		        idx,
		        length,
		        fieldIndex,
		        fieldCount = fields.length,
		        data = [],
		        cells,
		        record,
		        cell,
		        empty;
	
		        for (idx = 0, length = rows.length; idx < length; idx++) {
		            record = {};
		            empty = true;
		            cells = rows[idx].cells;
	
		            for (fieldIndex = 0; fieldIndex < fieldCount; fieldIndex++) {
		                cell = cells[fieldIndex];
		                if(cell.nodeName.toLowerCase() !== "th") {
		                    empty = false;
		                    record[fields[fieldIndex].field] = cell.innerHTML;
		                }
		            }
		            if(!empty) {
		                data.push(record);
		            }
		        }
	
		        return data;
		    }
	
		    var Node = Model.define({
		        idField: "id",
	
		        init: function(value) {
		            var that = this,
		                hasChildren = that.hasChildren || value && value.hasChildren,
		                childrenField = "items",
		                childrenOptions = {};
	
		            kendo.data.Model.fn.init.call(that, value);
	
		            if (typeof that.children === STRING) {
		                childrenField = that.children;
		            }
	
		            childrenOptions = {
		                schema: {
		                    data: childrenField,
		                    model: {
		                        hasChildren: hasChildren,
		                        id: that.idField,
		                        fields: that.fields
		                    }
		                }
		            };
	
		            if (typeof that.children !== STRING) {
		                extend(childrenOptions, that.children);
		            }
	
		            childrenOptions.data = value;
	
		            if (!hasChildren) {
		                hasChildren = childrenOptions.schema.data;
		            }
	
		            if (typeof hasChildren === STRING) {
		                hasChildren = kendo.getter(hasChildren);
		            }
	
		            if (isFunction(hasChildren)) {
		                var hasChildrenObject = hasChildren.call(that, that);
	
		                if(hasChildrenObject && hasChildrenObject.length === 0){
		                    that.hasChildren = false;
		                } else{
		                    that.hasChildren = !!hasChildrenObject;
		                }
		            }
	
		            that._childrenOptions = childrenOptions;
	
		            if (that.hasChildren) {
		                that._initChildren();
		            }
	
		            that._loaded = !!(value && value._loaded);
		        },
	
		        _initChildren: function() {
		            var that = this;
		            var children, transport, parameterMap;
	
		            if (!(that.children instanceof HierarchicalDataSource)) {
		                children = that.children = new HierarchicalDataSource(that._childrenOptions);
	
		                transport = children.transport;
		                parameterMap = transport.parameterMap;
	
		                transport.parameterMap = function(data, type) {
		                    data[that.idField || "id"] = that.id;
	
		                    if (parameterMap) {
		                        data = parameterMap(data, type);
		                    }
	
		                    return data;
		                };
	
		                children.parent = function(){
		                    return that;
		                };
	
		                children.bind(CHANGE, function(e){
		                    e.node = e.node || that;
		                    that.trigger(CHANGE, e);
		                });
	
		                children.bind(ERROR, function(e){
		                    var collection = that.parent();
	
		                    if (collection) {
		                        e.node = e.node || that;
		                        collection.trigger(ERROR, e);
		                    }
		                });
	
		                that._updateChildrenField();
		            }
		        },
	
		        append: function(model) {
		            this._initChildren();
		            this.loaded(true);
		            this.children.add(model);
		        },
	
		        hasChildren: false,
	
		        level: function() {
		            var parentNode = this.parentNode(),
		                level = 0;
	
		            while (parentNode && parentNode.parentNode) {
		                level++;
		                parentNode = parentNode.parentNode ? parentNode.parentNode() : null;
		            }
	
		            return level;
		        },
	
		        _updateChildrenField: function() {
		            var fieldName = this._childrenOptions.schema.data;
	
		            this[fieldName || "items"] = this.children.data();
		        },
	
		        _childrenLoaded: function() {
		            this._loaded = true;
	
		            this._updateChildrenField();
		        },
	
		        load: function() {
		            var options = {};
		            var method = "_query";
		            var children, promise;
	
		            if (this.hasChildren) {
		                this._initChildren();
	
		                children = this.children;
	
		                options[this.idField || "id"] = this.id;
	
		                if (!this._loaded) {
		                    children._data = undefined;
		                    method = "read";
		                }
	
		                children.one(CHANGE, proxy(this._childrenLoaded, this));
	
		                if(this._matchFilter){
		                    options.filter = { field: '_matchFilter', operator: 'eq', value: true };
		                }
	
		                promise = children[method](options);
		            } else {
		                this.loaded(true);
		            }
	
		            return promise || $.Deferred().resolve().promise();
		        },
	
		        parentNode: function() {
		            var array = this.parent();
	
		            return array.parent();
		        },
	
		        loaded: function(value) {
		            if (value !== undefined) {
		                this._loaded = value;
		            } else {
		                return this._loaded;
		            }
		        },
	
		        shouldSerialize: function(field) {
		            return Model.fn.shouldSerialize.call(this, field) &&
		                    field !== "children" &&
		                    field !== "_loaded" &&
		                    field !== "hasChildren" &&
		                    field !== "_childrenOptions";
		        }
		    });
	
		    function dataMethod(name) {
		        return function() {
		            var data = this._data,
		                result = DataSource.fn[name].apply(this, slice.call(arguments));
	
		            if (this._data != data) {
		                this._attachBubbleHandlers();
		            }
	
		            return result;
		        };
		    }
	
		    var HierarchicalDataSource = DataSource.extend({
		        init: function(options) {
		            var node = Node.define({
		                children: options
		            });
	
		            if(options.filter && !options.serverFiltering){
		                this._hierarchicalFilter = options.filter;
		                options.filter = null;
		            }
	
		            DataSource.fn.init.call(this, extend(true, {}, { schema: { modelBase: node, model: node } }, options));
	
		            this._attachBubbleHandlers();
		        },
	
		        _attachBubbleHandlers: function() {
		            var that = this;
	
		            that._data.bind(ERROR, function(e) {
		                that.trigger(ERROR, e);
		            });
		        },
	
		        read: function(data) {
		            var result = DataSource.fn.read.call(this, data);
	
		            if(this._hierarchicalFilter){
		                if(this._data && this._data.length > 0){
		                    this.filter(this._hierarchicalFilter);
		                }else{
		                    this.options.filter = this._hierarchicalFilter;
		                    this._filter = normalizeFilter(this.options.filter);
		                    this._hierarchicalFilter = null;
		                }
		            }
	
		            return result;
		        },
	
		        remove: function(node){
		            var parentNode = node.parentNode(),
		                dataSource = this,
		                result;
	
		            if (parentNode && parentNode._initChildren) {
		                dataSource = parentNode.children;
		            }
	
		            result = DataSource.fn.remove.call(dataSource, node);
	
		            if (parentNode && !dataSource.data().length) {
		                parentNode.hasChildren = false;
		            }
	
		            return result;
		        },
	
		        success: dataMethod("success"),
	
		        data: dataMethod("data"),
	
		        insert: function(index, model) {
		            var parentNode = this.parent();
	
		            if (parentNode && parentNode._initChildren) {
		                parentNode.hasChildren = true;
		                parentNode._initChildren();
		            }
	
		            return DataSource.fn.insert.call(this, index, model);
		        },
	
		        filter: function(val) {
		            if (val === undefined) {
		                 return this._filter;
		            }
	
		            if(!this.options.serverFiltering && this._markHierarchicalQuery(val)){
		                val = { logic: "or", filters: [val, {field:'_matchFilter', operator: 'equals', value: true }]};
		            }
	
		            this.trigger("reset");
		            this._query({ filter: val, page: 1 });
		        },
	
		        _markHierarchicalQuery: function(expressions){
		            var compiled;
		            var predicate;
		            var fields;
		            var operators;
		            var filter;
	
		            expressions = normalizeFilter(expressions);
	
		            if (!expressions || expressions.filters.length === 0) {
		                this._updateHierarchicalFilter(function(){return true;});
		                return false;
		            }
	
		            compiled = Query.filterExpr(expressions);
		            fields = compiled.fields;
		            operators = compiled.operators;
	
		            predicate = filter = new Function("d, __f, __o", "return " + compiled.expression);
	
		            if (fields.length || operators.length) {
		                filter = function(d) {
		                    return predicate(d, fields, operators);
		                };
		            }
	
		            this._updateHierarchicalFilter(filter);
		            return true;
		        },
	
		         _updateHierarchicalFilter: function(filter){
		            var current;
		            var data = this._data;
		            var result = false;
	
		            for (var idx = 0; idx < data.length; idx++) {
		                 current = data[idx];
	
		                 if(current.hasChildren){
		                     current._matchFilter = current.children._updateHierarchicalFilter(filter);
		                    if(!current._matchFilter){
		                        current._matchFilter = filter(current);
		                    }
		                }else{
		                    current._matchFilter = filter(current);
		                }
	
		                if(current._matchFilter){
		                    result = true;
		                }
		            }
		            return result;
		        },
	
		        _find: function(method, value) {
		            var idx, length, node, children;
		            var data = this._data;
	
		            if (!data) {
		                return;
		            }
	
		            node = DataSource.fn[method].call(this, value);
	
		            if (node) {
		                return node;
		            }
	
		            data = this._flatData(this._data);
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                children = data[idx].children;
	
		                if (!(children instanceof HierarchicalDataSource)) {
		                    continue;
		                }
	
		                node = children[method](value);
	
		                if (node) {
		                    return node;
		                }
		            }
		        },
	
		        get: function(id) {
		            return this._find("get", id);
		        },
	
		        getByUid: function(uid) {
		            return this._find("getByUid", uid);
		        }
		    });
	
		    function inferList(list, fields) {
		        var items = $(list).children(),
		            idx,
		            length,
		            data = [],
		            record,
		            textField = fields[0].field,
		            urlField = fields[1] && fields[1].field,
		            spriteCssClassField = fields[2] && fields[2].field,
		            imageUrlField = fields[3] && fields[3].field,
		            item,
		            id,
		            textChild,
		            className,
		            children;
	
		        function elements(collection, tagName) {
		            return collection.filter(tagName).add(collection.find(tagName));
		        }
	
		        for (idx = 0, length = items.length; idx < length; idx++) {
		            record = { _loaded: true };
		            item = items.eq(idx);
	
		            textChild = item[0].firstChild;
		            children = item.children();
		            list = children.filter("ul");
		            children = children.filter(":not(ul)");
	
		            id = item.attr("data-id");
	
		            if (id) {
		                record.id = id;
		            }
	
		            if (textChild) {
		                record[textField] = textChild.nodeType == 3 ? textChild.nodeValue : children.text();
		            }
	
		            if (urlField) {
		                record[urlField] = elements(children, "a").attr("href");
		            }
	
		            if (imageUrlField) {
		                record[imageUrlField] = elements(children, "img").attr("src");
		            }
	
		            if (spriteCssClassField) {
		                className = elements(children, ".k-sprite").prop("className");
		                record[spriteCssClassField] = className && $.trim(className.replace("k-sprite", ""));
		            }
	
		            if (list.length) {
		                record.items = inferList(list.eq(0), fields);
		            }
	
		            if (item.attr("data-hasChildren") == "true") {
		                record.hasChildren = true;
		            }
	
		            data.push(record);
		        }
	
		        return data;
		    }
	
		    HierarchicalDataSource.create = function(options) {
		        options = options && options.push ? { data: options } : options;
	
		        var dataSource = options || {},
		            data = dataSource.data,
		            fields = dataSource.fields,
		            list = dataSource.list;
	
		        if (data && data._dataSource) {
		            return data._dataSource;
		        }
	
		        if (!data && fields && !dataSource.transport) {
		            if (list) {
		                data = inferList(list, fields);
		            }
		        }
	
		        dataSource.data = data;
	
		        return dataSource instanceof HierarchicalDataSource ? dataSource : new HierarchicalDataSource(dataSource);
		    };
	
		    var Buffer = kendo.Observable.extend({
		        init: function(dataSource, viewSize, disablePrefetch) {
		            kendo.Observable.fn.init.call(this);
	
		            this._prefetching = false;
		            this.dataSource = dataSource;
		            this.prefetch = !disablePrefetch;
	
		            var buffer = this;
	
		            dataSource.bind("change", function() {
		                buffer._change();
		            });
	
		            dataSource.bind("reset", function() {
		                buffer._reset();
		            });
	
		            this._syncWithDataSource();
	
		            this.setViewSize(viewSize);
		        },
	
		        setViewSize: function(viewSize) {
		            this.viewSize = viewSize;
		            this._recalculate();
		        },
	
		        at: function(index)  {
		            var pageSize = this.pageSize,
		                itemPresent = true;
	
		            if (index >= this.total()) {
		                this.trigger("endreached", {index: index });
		                return null;
		            }
	
		            if (!this.useRanges) {
		               return this.dataSource.view()[index];
		            }
		            if (this.useRanges) {
		                // out of range request
		                if (index < this.dataOffset || index >= this.skip + pageSize) {
		                    itemPresent = this.range(Math.floor(index / pageSize) * pageSize);
		                }
	
		                // prefetch
		                if (index === this.prefetchThreshold) {
		                    this._prefetch();
		                }
	
		                // mid-range jump - prefetchThreshold and nextPageThreshold may be equal, do not change to else if
		                if (index === this.midPageThreshold) {
		                    this.range(this.nextMidRange, true);
		                }
		                // next range jump
		                else if (index === this.nextPageThreshold) {
		                    this.range(this.nextFullRange);
		                }
		                // pull-back
		                else if (index === this.pullBackThreshold) {
		                    if (this.offset === this.skip) { // from full range to mid range
		                        this.range(this.previousMidRange);
		                    } else { // from mid range to full range
		                        this.range(this.previousFullRange);
		                    }
		                }
	
		                if (itemPresent) {
		                    return this.dataSource.at(index - this.dataOffset);
		                } else {
		                    this.trigger("endreached", { index: index });
		                    return null;
		                }
		            }
		        },
	
		        indexOf: function(item) {
		            return this.dataSource.data().indexOf(item) + this.dataOffset;
		        },
	
		        total: function() {
		            return parseInt(this.dataSource.total(), 10);
		        },
	
		        next: function() {
		            var buffer = this,
		                pageSize = buffer.pageSize,
		                offset = buffer.skip - buffer.viewSize + pageSize,
		                pageSkip = math.max(math.floor(offset / pageSize), 0) * pageSize;
	
		            this.offset = offset;
		            this.dataSource.prefetch(pageSkip, pageSize, function() {
		                buffer._goToRange(offset, true);
		            });
		        },
	
		        range: function(offset, nextRange) {
		            if (this.offset === offset) {
		                return true;
		            }
	
		            var buffer = this,
		                pageSize = this.pageSize,
		                pageSkip = math.max(math.floor(offset / pageSize), 0) * pageSize,
		                dataSource = this.dataSource;
	
		            if (nextRange) {
		                pageSkip += pageSize;
		            }
	
		            if (dataSource.inRange(offset, pageSize)) {
		                this.offset = offset;
		                this._recalculate();
		                this._goToRange(offset);
		                return true;
		            } else if (this.prefetch) {
		                dataSource.prefetch(pageSkip, pageSize, function() {
		                    buffer.offset = offset;
		                    buffer._recalculate();
		                    buffer._goToRange(offset, true);
		                });
		                return false;
		            }
	
		            return true;
		        },
	
		        syncDataSource: function() {
		            var offset = this.offset;
		            this.offset = null;
		            this.range(offset);
		        },
	
		        destroy: function() {
		            this.unbind();
		        },
	
		        _prefetch: function() {
		            var buffer = this,
		                pageSize = this.pageSize,
		                prefetchOffset = this.skip + pageSize,
		                dataSource = this.dataSource;
	
		            if (!dataSource.inRange(prefetchOffset, pageSize) && !this._prefetching && this.prefetch) {
		                this._prefetching = true;
		                this.trigger("prefetching", { skip: prefetchOffset, take: pageSize });
	
		                dataSource.prefetch(prefetchOffset, pageSize, function() {
		                    buffer._prefetching = false;
		                    buffer.trigger("prefetched", { skip: prefetchOffset, take: pageSize });
		                });
		            }
		        },
	
		        _goToRange: function(offset, expanding) {
		            if (this.offset !== offset) {
		                return;
		            }
	
		            this.dataOffset = offset;
		            this._expanding = expanding;
		            this.dataSource.range(offset, this.pageSize);
		            this.dataSource.enableRequestsInProgress();
		        },
	
		        _reset: function() {
		            this._syncPending = true;
		        },
	
		        _change: function() {
		            var dataSource = this.dataSource;
	
		            this.length = this.useRanges ? dataSource.lastRange().end : dataSource.view().length;
	
		            if (this._syncPending) {
		                this._syncWithDataSource();
		                this._recalculate();
		                this._syncPending = false;
		                this.trigger("reset", { offset: this.offset });
		            }
	
		            this.trigger("resize");
	
		            if (this._expanding) {
		                this.trigger("expand");
		            }
	
		            delete this._expanding;
		        },
	
		        _syncWithDataSource: function() {
		            var dataSource = this.dataSource;
	
		            this._firstItemUid = dataSource.firstItemUid();
		            this.dataOffset = this.offset = dataSource.skip() || 0;
		            this.pageSize = dataSource.pageSize();
		            this.useRanges = dataSource.options.serverPaging;
		        },
	
		        _recalculate: function() {
		            var pageSize = this.pageSize,
		                offset = this.offset,
		                viewSize = this.viewSize,
		                skip = Math.ceil(offset / pageSize) * pageSize;
	
		            this.skip = skip;
		            this.midPageThreshold = skip + pageSize - 1;
		            this.nextPageThreshold = skip + viewSize - 1;
		            this.prefetchThreshold = skip + Math.floor(pageSize / 3 * 2);
		            this.pullBackThreshold = this.offset - 1;
	
		            this.nextMidRange = skip + pageSize - viewSize;
		            this.nextFullRange = skip;
		            this.previousMidRange = offset - viewSize;
		            this.previousFullRange = skip - pageSize;
		        }
		    });
	
		    var BatchBuffer = kendo.Observable.extend({
		        init: function(dataSource, batchSize) {
		            var batchBuffer = this;
	
		            kendo.Observable.fn.init.call(batchBuffer);
	
		            this.dataSource = dataSource;
		            this.batchSize = batchSize;
		            this._total = 0;
	
		            this.buffer = new Buffer(dataSource, batchSize * 3);
	
		            this.buffer.bind({
		                "endreached": function (e) {
		                    batchBuffer.trigger("endreached", { index: e.index });
		                },
		                "prefetching": function (e) {
		                    batchBuffer.trigger("prefetching", { skip: e.skip, take: e.take });
		                },
		                "prefetched": function (e) {
		                    batchBuffer.trigger("prefetched", { skip: e.skip, take: e.take });
		                },
		                "reset": function () {
		                    batchBuffer._total = 0;
		                    batchBuffer.trigger("reset");
		                },
		                "resize": function () {
		                    batchBuffer._total = Math.ceil(this.length / batchBuffer.batchSize);
		                    batchBuffer.trigger("resize", { total: batchBuffer.total(), offset: this.offset });
		                }
		            });
		        },
	
		        syncDataSource: function() {
		            this.buffer.syncDataSource();
		        },
	
		        at: function(index) {
		            var buffer = this.buffer,
		                skip = index * this.batchSize,
		                take = this.batchSize,
		                view = [],
		                item;
	
		            if (buffer.offset > skip) {
		                buffer.at(buffer.offset - 1);
		            }
	
		            for (var i = 0; i < take; i++) {
		                item = buffer.at(skip + i);
	
		                if (item === null) {
		                    break;
		                }
	
		                view.push(item);
		            }
	
		            return view;
		        },
	
		        total: function() {
		            return this._total;
		        },
	
		        destroy: function() {
		            this.buffer.destroy();
		            this.unbind();
		        }
		    });
	
		    extend(true, kendo.data, {
		        readers: {
		            json: DataReader
		        },
		        Query: Query,
		        DataSource: DataSource,
		        HierarchicalDataSource: HierarchicalDataSource,
		        Node: Node,
		        ObservableObject: ObservableObject,
		        ObservableArray: ObservableArray,
		        LazyObservableArray: LazyObservableArray,
		        LocalTransport: LocalTransport,
		        RemoteTransport: RemoteTransport,
		        Cache: Cache,
		        DataReader: DataReader,
		        Model: Model,
		        Buffer: Buffer,
		        BatchBuffer: BatchBuffer
		    });
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1047:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(564);
	
	/***/ }),
	
	/***/ 1048:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(565);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1049);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1049:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "data.odata",
		    name: "OData",
		    category: "framework",
		    depends: [ "core" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        extend = $.extend,
		        NEWLINE = "\r\n",
		        DOUBLELINE = "\r\n\r\n",
		        isFunction = kendo.isFunction,
		        odataFilters = {
		            eq: "eq",
		            neq: "ne",
		            gt: "gt",
		            gte: "ge",
		            lt: "lt",
		            lte: "le",
		            contains : "substringof",
		            doesnotcontain: "substringof",
		            endswith: "endswith",
		            startswith: "startswith",
		            isnull: "eq",
		            isnotnull: "ne",
		            isnullorempty: "eq",
		            isnotnullorempty: "ne",
		            isempty: "eq",
		            isnotempty: "ne"
		        },
		        odataFiltersVersionFour = extend({}, odataFilters, {
		            contains: "contains"
		        }),
		        mappers = {
		            pageSize: $.noop,
		            page: $.noop,
		            filter: function(params, filter, useVersionFour) {
		                if (filter) {
		                    filter = toOdataFilter(filter, useVersionFour);
		                    if (filter) {
		                        params.$filter = filter;
		                    }
		                }
		            },
		            sort: function(params, orderby) {
		                var expr = $.map(orderby, function(value) {
		                    var order = value.field.replace(/\./g, "/");
	
		                    if (value.dir === "desc") {
		                        order += " desc";
		                    }
	
		                    return order;
		                }).join(",");
	
		                if (expr) {
		                    params.$orderby = expr;
		                }
		            },
		            skip: function(params, skip) {
		                if (skip) {
		                    params.$skip = skip;
		                }
		            },
		            take: function(params, take) {
		                if (take) {
		                    params.$top = take;
		                }
		            }
		        },
		        defaultDataType = {
		            read: {
		                dataType: "jsonp"
		            }
		        };
	
		    function toOdataFilter(filter, useOdataFour) {
		        var result = [],
		            logic = filter.logic || "and",
		            idx,
		            length,
		            field,
		            type,
		            format,
		            operator,
		            value,
		            ignoreCase,
		            filters = filter.filters;
	
		        for (idx = 0, length = filters.length; idx < length; idx++) {
		            filter = filters[idx];
		            field = filter.field;
		            value = filter.value;
		            operator = filter.operator;
	
		            if (filter.filters) {
		                filter = toOdataFilter(filter, useOdataFour);
		            } else {
		                ignoreCase = filter.ignoreCase;
		                field = field.replace(/\./g, "/");
		                filter = odataFilters[operator];
		                if (useOdataFour) {
		                    filter = odataFiltersVersionFour[operator];
		                }
	
		                if (operator === "isnullorempty") {
		                    filter = kendo.format("{0} {1} null or {0} {1} ''", field, filter);
		                } else if(operator === "isnotnullorempty") {
		                    filter = kendo.format("{0} {1} null and {0} {1} ''", field, filter);
		                } else if (operator === "isnull" || operator === "isnotnull") {
		                    filter = kendo.format("{0} {1} null", field, filter);
		                } else if (operator === "isempty" || operator === "isnotempty") {
		                    filter = kendo.format("{0} {1} ''", field, filter);
		                } else if (filter && value !== undefined) {
		                    type = $.type(value);
		                    if (type === "string") {
		                        format = "'{1}'";
		                        value = value.replace(/'/g, "''");
	
		                        if (ignoreCase === true) {
		                            field = "tolower(" + field + ")";
		                        }
	
		                    } else if (type === "date") {
		                        if (useOdataFour) {
		                            format = "{1:yyyy-MM-ddTHH:mm:ss+00:00}";
		                            value = kendo.timezone.apply(value, 'Etc/UTC');
		                        } else {
		                            format = "datetime'{1:yyyy-MM-ddTHH:mm:ss}'";
		                        }
		                    } else {
		                        format = "{1}";
		                    }
	
		                    if (filter.length > 3) {
		                        if (filter !== "substringof") {
		                            format = "{0}({2}," + format + ")";
		                        } else {
		                            format = "{0}(" + format + ",{2})";
		                            if (operator === "doesnotcontain") {
		                                if (useOdataFour) {
		                                    format = "{0}({2},'{1}') eq -1";
		                                    filter = "indexof";
		                                } else {
		                                    format += " eq false";
		                                }
		                            }
		                        }
		                    } else {
		                        format = "{2} {0} " + format;
		                    }
	
		                    filter = kendo.format(format, filter, value, field);
		                }
		            }
	
		            result.push(filter);
		        }
	
		        filter = result.join(" " + logic + " ");
	
		        if (result.length > 1) {
		            filter = "(" + filter + ")";
		        }
	
		        return filter;
		    }
	
		    function stripMetadata(obj) {
		        for (var name in obj) {
		            if(name.indexOf("@odata") === 0) {
		                delete obj[name];
		            }
		        }
		    }
	
		    function hex16() {
		        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substr(1);
		    }
	
		    function createBoundary(prefix) {
		        return prefix + hex16() + '-' + hex16() + '-' + hex16();
		    }
	
		    function createDelimeter(boundary, close) {
		        var result = NEWLINE + "--" + boundary;
	
		        if (close) {
		            result += "--";
		        }
	
		        return result;
		    }
	
		    function createCommand(transport, item, httpVerb, command) {
		         var transportUrl = transport.options[command].url;
		         var commandPrefix = kendo.format("{0} ", httpVerb);
	
		         if (isFunction(transportUrl)) {
		             return commandPrefix + transportUrl(item);
		         } else {
		             return commandPrefix + transportUrl;
		         }
		    }
	
		    function getOperationHeader(changeset, changeId) {
		        var header = "";
	
		        header += createDelimeter(changeset, false);
		        header += NEWLINE + 'Content-Type: application/http';
		        header += NEWLINE + 'Content-Transfer-Encoding: binary';
		        header += NEWLINE + 'Content-ID: ' + changeId;
	
		        return header;
		    }
	
		    function getOperationContent(item) {
		        var content = "";
	
		        content += NEWLINE + "Content-Type: application/json;odata=minimalmetadata";
		        content += NEWLINE + "Prefer: return=representation";
		        content += DOUBLELINE + kendo.stringify(item);
	
		        return content;
		    }
	
		    function getOperations(collection, changeset, changeId, command, transport, skipContent) {
		        var requestBody = "";
	
		        for (var i = 0; i < collection.length; i++) {
		            requestBody += getOperationHeader(changeset, changeId);
		            requestBody += DOUBLELINE + createCommand(transport, collection[i], transport.options[command].type, command) + ' HTTP/1.1';
		            if (!skipContent) {
		                requestBody += getOperationContent(collection[i]);
		            }
		            requestBody += NEWLINE;
		            changeId++;
		        }
	
		        return requestBody;
		    }
	
		    function processCollection(colection, boundary, changeset, changeId, transport, command, skipContent) {
		        var requestBody = "";
	
		        requestBody += getBoundary(boundary, changeset);
		        requestBody += getOperations(colection, changeset, changeId, command, transport, skipContent);
		        requestBody += createDelimeter(changeset, true);
		        requestBody += NEWLINE;
	
		        return requestBody;
		    }
	
		    function getBoundary(boundary,changeset) {
		        var requestBody = "";
	
		        requestBody += "--" + boundary + NEWLINE;
		        requestBody += "Content-Type: multipart/mixed; boundary=" + changeset + NEWLINE;
	
		        return requestBody;
		    }
	
		    function createBatchRequest(transport, colections) {
		        var options = {};
		        var boundary = createBoundary("sf_batch_");
		        var requestBody = "";
		        var changeId = 0;
		        var batchURL = transport.options.batch.url;
		        var changeset = createBoundary("sf_changeset_");
	
		        options.type = transport.options.batch.type;
		        options.url = isFunction(batchURL) ? batchURL() : batchURL;
		        options.headers = {
		            "Content-Type": "multipart/mixed; boundary=" + boundary
		        };
	
		        if (colections.updated.length) {
		            requestBody += processCollection(colections.updated, boundary, changeset, changeId, transport, "update", false);
		            changeId += colections.updated.length;
		            changeset = createBoundary("sf_changeset_");
		        }
	
		        if (colections.destroyed.length) {
		            requestBody += processCollection(colections.destroyed, boundary, changeset, changeId, transport, "destroy", true);
		            changeId += colections.destroyed.length;
		            changeset = createBoundary("sf_changeset_");
		        }
	
		        if (colections.created.length) {
		            requestBody += processCollection(colections.created, boundary, changeset, changeId, transport, "create", false);
		        }
	
		        requestBody += createDelimeter(boundary, true);
	
		        options.data = requestBody;
	
		        return options;
		    }
	
		    function parseBatchResponse(responseText) {
		        var responseMarkers = responseText.match(/--changesetresponse_[a-z0-9-]+$/gm);
		        var markerIndex = 0;
		        var collections = [];
		        var changeBody;
		        var status;
		        var code;
		        var marker;
		        var jsonModel;
	
		        collections.push({ models: [], passed: true });
	
		        for (var i = 0; i < responseMarkers.length; i++) {
		            marker = responseMarkers[i];
		            if (marker.lastIndexOf('--', marker.length - 1)) {
		                if (i < responseMarkers.length - 1) {
		                    collections.push({ models: [], passed: true });
		                }
		                continue;
		            }
	
		            if (!markerIndex) {
		                markerIndex = responseText.indexOf(marker);
		            } else {
		                markerIndex = responseText.indexOf(marker, markerIndex + marker.length);
		            }
	
		            changeBody = responseText.substring(markerIndex, responseText.indexOf("--", markerIndex + 1));
		            status = changeBody.match(/^HTTP\/1\.\d (\d{3}) (.*)$/gm).pop();
		            code = kendo.parseFloat(status.match(/\d{3}/g).pop());
	
		            if (code >= 200 && code <= 299) {
		                jsonModel = changeBody.match(/\{.*\}/gm);
		                if (jsonModel) {
		                    collections[collections.length - 1].models.push(JSON.parse(jsonModel[0]));
		                }
		            } else {
		                collections[collections.length - 1].passed = false;
		            }
	
		        }
	
		        return collections;
		    }
	
		    extend(true, kendo.data, {
		        schemas: {
		            odata: {
		                type: "json",
		                data: function(data) {
		                    return data.d.results || [data.d];
		                },
		                total: "d.__count"
		            }
		        },
		        transports: {
		            odata: {
		                read: {
		                    cache: true, // to prevent jQuery from adding cache buster
		                    dataType: "jsonp",
		                    jsonp: "$callback"
		                },
		                update: {
		                    cache: true,
		                    dataType: "json",
		                    contentType: "application/json", // to inform the server the the request body is JSON encoded
		                    type: "PUT" // can be PUT or MERGE
		                },
		                create: {
		                    cache: true,
		                    dataType: "json",
		                    contentType: "application/json",
		                    type: "POST" // must be POST to create new entity
		                },
		                destroy: {
		                    cache: true,
		                    dataType: "json",
		                    type: "DELETE"
		                },
		                parameterMap: function(options, type, useVersionFour) {
		                    var params,
		                        value,
		                        option,
		                        dataType;
	
		                    options = options || {};
		                    type = type || "read";
		                    dataType = (this.options || defaultDataType)[type];
		                    dataType = dataType ? dataType.dataType : "json";
	
		                    if (type === "read") {
		                        params = {
		                            $inlinecount: "allpages"
		                        };
	
		                        if (dataType != "json") {
		                            params.$format = "json";
		                        }
	
		                        for (option in options) {
		                            if (mappers[option]) {
		                                mappers[option](params, options[option], useVersionFour);
		                            } else {
		                                params[option] = options[option];
		                            }
		                        }
		                    } else {
		                        if (dataType !== "json") {
		                            throw new Error("Only json dataType can be used for " + type + " operation.");
		                        }
	
		                        if (type !== "destroy") {
		                            for (option in options) {
		                                value = options[option];
		                                if (typeof value === "number") {
		                                    options[option] = value + "";
		                                }
		                            }
	
		                            params = kendo.stringify(options);
		                        }
		                    }
	
		                    return params;
		                }
		            }
		        }
		    });
	
		    extend(true, kendo.data, {
		        schemas: {
		            "odata-v4": {
		                type: "json",
		                data: function(data) {
		                    if ($.isArray(data)) {
		                        for (var i = 0; i < data.length; i++) {
		                            stripMetadata(data[i]);
		                        }
		                        return data;
		                    } else {
		                        data = $.extend({}, data);
		                        stripMetadata(data);
	
		                        if (data.value) {
		                            return data.value;
		                        }
		                        return [data];
		                    }
		                },
		                total: function(data) {
		                    return data["@odata.count"];
		                }
		            }
		        },
		        transports: {
		            "odata-v4": {
		                batch: {
		                    type: "POST"
		                },
		                read: {
		                    cache: true, // to prevent jQuery from adding cache buster
		                    dataType: "json"
		                },
		                update: {
		                    cache: true,
		                    dataType: "json",
		                    contentType: "application/json;IEEE754Compatible=true", // to inform the server the the request body is JSON encoded
		                    type: "PUT" // can be PUT or MERGE
		                },
		                create: {
		                    cache: true,
		                    dataType: "json",
		                    contentType: "application/json;IEEE754Compatible=true",
		                    type: "POST" // must be POST to create new entity
		                },
		                destroy: {
		                    cache: true,
		                    dataType: "json",
		                    type: "DELETE"
		                },
		                parameterMap: function(options, type) {
		                    var result = kendo.data.transports.odata.parameterMap(options, type, true);
		                    if (type == "read") {
		                        result.$count = true;
		                        delete result.$inlinecount;
		                    }
	
		                    return result;
		                },
		                submit: function(e) {
		                    var that = this;
		                    var options = createBatchRequest(that, e.data);
		                    var collections = e.data;
	
		                    if (!collections.updated.length && !collections.destroyed.length && !collections.created.length) {
		                        return;
		                    }
	
		                    $.ajax(extend(true, {}, {
		                        success: function (response) {
		                            var responses = parseBatchResponse(response);
		                            var index = 0;
		                            var current;
	
		                            if (collections.updated.length) {
		                                current = responses[index];
		                                if (current.passed) {
		                                    // Pass either the obtained models or an empty array if only status codes are returned.
		                                    e.success(current.models.length ? current.models : [], "update");
		                                }
		                                index++;
		                            }
		                            if (collections.destroyed.length) {
		                                current = responses[index];
		                                if (current.passed) {
		                                    // For delete operations OData returns only status codes.
		                                    // Passing empty array to datasource will force it to correctly remove the deleted items from the pristine collection.
		                                    e.success([], "destroy");
		                                }
		                                index++;
		                            }
		                            if (collections.created.length) {
		                                current = responses[index];
		                                if (current.passed) {
		                                    e.success(current.models, "create");
		                                }
		                            }
		                        },
		                        error: function (response, status, error) {
		                            e.error(response, status, error);
		                        }
		                    }, options));
		                }
		            }
		        }
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1051);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1051:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "data.xml",
		    name: "XML",
		    category: "framework",
		    depends: [ "core" ],
		    hidden: true
		};
	
		/*jshint  eqnull: true, boss: true */
		(function($, undefined) {
		    var kendo = window.kendo,
		        isArray = $.isArray,
		        isPlainObject = $.isPlainObject,
		        map = $.map,
		        each = $.each,
		        extend = $.extend,
		        getter = kendo.getter,
		        Class = kendo.Class;
	
		    var XmlDataReader = Class.extend({
		        init: function(options) {
		            var that = this,
		                total = options.total,
		                model = options.model,
		                parse = options.parse,
		                errors = options.errors,
		                serialize = options.serialize,
		                data = options.data;
	
		            if (model) {
		                if (isPlainObject(model)) {
		                    var base = options.modelBase || kendo.data.Model;
	
		                    if (model.fields) {
		                        each(model.fields, function(field, value) {
		                            if (isPlainObject(value) && value.field) {
		                                if (!$.isFunction(value.field)) {
		                                    value = extend(value, { field: that.getter(value.field) });
		                                }
		                            } else {
		                                value = { field: that.getter(value) };
		                            }
		                            model.fields[field] = value;
		                        });
		                    }
	
		                    var id = model.id;
		                    if (id) {
		                        var idField = {};
	
		                        idField[that.xpathToMember(id, true)] = { field : that.getter(id) };
		                        model.fields = extend(idField, model.fields);
		                        model.id = that.xpathToMember(id);
		                    }
		                    model = base.define(model);
		                }
	
		                that.model = model;
		            }
	
		            if (total) {
		                if (typeof total == "string") {
		                    total = that.getter(total);
		                    that.total = function(data) {
		                        return parseInt(total(data), 10);
		                    };
		                } else if (typeof total == "function"){
		                    that.total = total;
		                }
		            }
	
		            if (errors) {
		                if (typeof errors == "string") {
		                    errors = that.getter(errors);
		                    that.errors = function(data) {
		                        return errors(data) || null;
		                    };
		                } else if (typeof errors == "function"){
		                    that.errors = errors;
		                }
		            }
	
		            if (data) {
		                if (typeof data == "string") {
		                    data = that.xpathToMember(data);
		                    that.data = function(value) {
		                        var result = that.evaluate(value, data),
		                            modelInstance;
	
		                        result = isArray(result) ? result : [result];
	
		                        if (that.model && model.fields) {
		                            modelInstance = new that.model();
	
		                            return map(result, function(value) {
		                                if (value) {
		                                    var record = {}, field;
	
		                                    for (field in model.fields) {
		                                        record[field] = modelInstance._parse(field, model.fields[field].field(value));
		                                    }
	
		                                    return record;
		                                }
		                            });
		                        }
	
		                        return result;
		                    };
		                } else if (typeof data == "function") {
		                    that.data = data;
		                }
		            }
	
		            if (typeof parse == "function") {
		                var xmlParse = that.parse;
	
		                that.parse = function(data) {
		                    var xml = parse.call(that, data);
		                    return xmlParse.call(that, xml);
		                };
		            }
	
		            if (typeof serialize == "function") {
		                that.serialize = serialize;
		            }
		        },
		        total: function(result) {
		            return this.data(result).length;
		        },
		        errors: function(data) {
		            return data ? data.errors : null;
		        },
		        serialize: function(data) {
		            return data;
		        },
		        parseDOM: function(element) {
		            var result = {},
		                parsedNode,
		                node,
		                nodeType,
		                nodeName,
		                member,
		                attribute,
		                attributes = element.attributes,
		                attributeCount = attributes.length,
		                idx;
	
		            for (idx = 0; idx < attributeCount; idx++) {
		                attribute = attributes[idx];
		                result["@" + attribute.nodeName] = attribute.nodeValue;
		            }
	
		            for (node = element.firstChild; node; node = node.nextSibling) {
		                nodeType = node.nodeType;
	
		                if (nodeType === 3 || nodeType === 4) {
		                    // text nodes or CDATA are stored as #text field
		                    result["#text"] = node.nodeValue;
		                } else if (nodeType === 1) {
		                    // elements are stored as fields
		                    parsedNode = this.parseDOM(node);
	
		                    nodeName = node.nodeName;
	
		                    member = result[nodeName];
	
		                    if (isArray(member)) {
		                        // elements of same nodeName are stored as array
		                        member.push(parsedNode);
		                    } else if (member !== undefined) {
		                        member = [member, parsedNode];
		                    } else {
		                        member = parsedNode;
		                    }
	
		                    result[nodeName] = member;
		                }
		            }
		            return result;
		        },
	
		        evaluate: function(value, expression) {
		            var members = expression.split("."),
		                member,
		                result,
		                length,
		                intermediateResult,
		                idx;
	
		            while (member = members.shift()) {
		                value = value[member];
	
		                if (isArray(value)) {
		                    result = [];
		                    expression = members.join(".");
	
		                    for (idx = 0, length = value.length; idx < length; idx++) {
		                        intermediateResult = this.evaluate(value[idx], expression);
	
		                        intermediateResult = isArray(intermediateResult) ? intermediateResult : [intermediateResult];
	
		                        result.push.apply(result, intermediateResult);
		                    }
	
		                    return result;
		                }
		            }
	
		            return value;
		        },
	
		        parse: function(xml) {
		            var documentElement,
		                tree,
		                result = {};
	
		            documentElement = xml.documentElement || $.parseXML(xml).documentElement;
	
		            tree = this.parseDOM(documentElement);
	
		            result[documentElement.nodeName] = tree;
	
		            return result;
		        },
	
		        xpathToMember: function(member, raw) {
		            if (!member) {
		                return "";
		            }
	
		            member = member.replace(/^\//, "") // remove the first "/"
		                           .replace(/\//g, "."); // replace all "/" with "."
	
		            if (member.indexOf("@") >= 0) {
		                // replace @attribute with '["@attribute"]'
		                return member.replace(/\.?(@.*)/, raw? '$1':'["$1"]');
		            }
	
		            if (member.indexOf("text()") >= 0) {
		                // replace ".text()" with '["#text"]'
		                return member.replace(/(\.?text\(\))/, raw? '#text':'["#text"]');
		            }
	
		            return member;
		        },
		        getter: function(member) {
		            return getter(this.xpathToMember(member), true);
		        }
		    });
	
		    $.extend(true, kendo.data, {
		        XmlDataReader: XmlDataReader,
		        readers: {
		            xml: XmlDataReader
		        }
		    });
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1246);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1246:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1054), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.scroller",
		    name: "Scroller",
		    category: "mobile",
		    description: "The Kendo Mobile Scroller widget enables touch friendly kinetic scrolling for the contents of a given DOM element.",
		    depends: [ "fx", "draganddrop" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        fx = kendo.effects,
		        ui = mobile.ui,
		        proxy = $.proxy,
		        extend = $.extend,
		        Widget = ui.Widget,
		        Class = kendo.Class,
		        Movable = kendo.ui.Movable,
		        Pane = kendo.ui.Pane,
		        PaneDimensions = kendo.ui.PaneDimensions,
		        Transition = fx.Transition,
		        Animation = fx.Animation,
		        abs = Math.abs,
		        SNAPBACK_DURATION = 500,
		        SCROLLBAR_OPACITY = 0.7,
		        FRICTION = 0.96,
		        VELOCITY_MULTIPLIER = 10,
		        MAX_VELOCITY = 55,
		        OUT_OF_BOUNDS_FRICTION = 0.5,
		        ANIMATED_SCROLLER_PRECISION = 5,
		        RELEASECLASS = "km-scroller-release",
		        REFRESHCLASS = "km-scroller-refresh",
		        PULL = "pull",
		        CHANGE = "change",
		        RESIZE = "resize",
		        SCROLL = "scroll",
		        MOUSE_WHEEL_ID = 2;
	
		    var ZoomSnapBack = Animation.extend({
		        init: function(options) {
		            var that = this;
		            Animation.fn.init.call(that);
		            extend(that, options);
	
		            that.userEvents.bind("gestureend", proxy(that.start, that));
		            that.tapCapture.bind("press", proxy(that.cancel, that));
		        },
	
		        enabled: function() {
		          return this.movable.scale < this.dimensions.minScale;
		        },
	
		        done: function() {
		            return this.dimensions.minScale - this.movable.scale < 0.01;
		        },
	
		        tick: function() {
		            var movable = this.movable;
		            movable.scaleWith(1.1);
		            this.dimensions.rescale(movable.scale);
		        },
	
		        onEnd: function() {
		            var movable = this.movable;
		            movable.scaleTo(this.dimensions.minScale);
		            this.dimensions.rescale(movable.scale);
		        }
		    });
	
		    var DragInertia = Animation.extend({
		        init: function(options) {
		            var that = this;
	
		            Animation.fn.init.call(that);
	
		            extend(that, options, {
		                transition: new Transition({
		                    axis: options.axis,
		                    movable: options.movable,
		                    onEnd: function() { that._end(); }
		                })
		            });
	
		            that.tapCapture.bind("press", function() { that.cancel(); });
		            that.userEvents.bind("end", proxy(that.start, that));
		            that.userEvents.bind("gestureend", proxy(that.start, that));
		            that.userEvents.bind("tap", proxy(that.onEnd, that));
		        },
	
		        onCancel: function() {
		            this.transition.cancel();
		        },
	
		        freeze: function(location) {
		            var that = this;
		            that.cancel();
		            that._moveTo(location);
		        },
	
		        onEnd: function() {
		            var that = this;
		            if (that.paneAxis.outOfBounds()) {
		                that._snapBack();
		            } else {
		                that._end();
		            }
		        },
	
		        done: function() {
		            return abs(this.velocity) < 1;
		        },
	
		        start: function(e) {
		            var that = this,
		                velocity;
	
		            if (!that.dimension.enabled) { return; }
	
	
		            if (that.paneAxis.outOfBounds()) {
		                that._snapBack();
		            } else {
		                velocity = e.touch.id === MOUSE_WHEEL_ID ? 0 : e.touch[that.axis].velocity;
		                that.velocity = Math.max(Math.min(velocity * that.velocityMultiplier, MAX_VELOCITY), -MAX_VELOCITY);
	
		                that.tapCapture.captureNext();
		                Animation.fn.start.call(that);
		            }
		        },
	
		        tick: function() {
		            var that = this,
		                dimension = that.dimension,
		                friction = that.paneAxis.outOfBounds() ? OUT_OF_BOUNDS_FRICTION : that.friction,
		                delta = (that.velocity *= friction),
		                location = that.movable[that.axis] + delta;
	
		                if (!that.elastic && dimension.outOfBounds(location)) {
		                    location = Math.max(Math.min(location, dimension.max), dimension.min);
		                    that.velocity = 0;
		                }
	
		            that.movable.moveAxis(that.axis, location);
		        },
	
		        _end: function() {
		            this.tapCapture.cancelCapture();
		            this.end();
		        },
	
		        _snapBack: function() {
		            var that = this,
		                dimension = that.dimension,
		                snapBack = that.movable[that.axis] > dimension.max ? dimension.max : dimension.min;
		            that._moveTo(snapBack);
		        },
	
		        _moveTo: function(location) {
		            this.transition.moveTo({ location: location, duration: SNAPBACK_DURATION, ease: Transition.easeOutExpo });
		        }
		    });
	
		    var AnimatedScroller = Animation.extend({
		        init: function(options) {
		            var that = this;
	
		            kendo.effects.Animation.fn.init.call(this);
	
		            extend(that, options, {
		                origin: {},
		                destination: {},
		                offset: {}
		            });
		        },
	
		        tick: function() {
		            this._updateCoordinates();
		            this.moveTo(this.origin);
		        },
	
		        done: function() {
		            return abs(this.offset.y) < ANIMATED_SCROLLER_PRECISION && abs(this.offset.x) < ANIMATED_SCROLLER_PRECISION;
		        },
	
		        onEnd: function() {
		            this.moveTo(this.destination);
		            if (this.callback) {
		                this.callback.call();
		            }
		        },
	
		        setCoordinates: function(from, to) {
		            this.offset = {};
		            this.origin = from;
		            this.destination = to;
		        },
	
		        setCallback: function(callback) {
		            if (callback && kendo.isFunction(callback)) {
		                this.callback = callback;
		            } else {
		                callback = undefined;
		            }
		        },
	
		        _updateCoordinates: function() {
		            this.offset = {
		                x: (this.destination.x - this.origin.x) / 4,
		                y: (this.destination.y - this.origin.y) / 4
		            };
	
		            this.origin = {
		                y: this.origin.y + this.offset.y,
		                x: this.origin.x + this.offset.x
		            };
		        }
		    });
	
		    var ScrollBar = Class.extend({
		        init: function(options) {
		            var that = this,
		                horizontal = options.axis === "x",
		                element = $('<div class="km-touch-scrollbar km-' + (horizontal ? "horizontal" : "vertical") + '-scrollbar" />');
	
		            extend(that, options, {
		                element: element,
		                elementSize: 0,
		                movable: new Movable(element),
		                scrollMovable: options.movable,
		                alwaysVisible: options.alwaysVisible,
		                size: horizontal ? "width" : "height"
		            });
	
		            that.scrollMovable.bind(CHANGE, proxy(that.refresh, that));
		            that.container.append(element);
		            if (options.alwaysVisible) {
		                that.show();
		            }
		        },
	
		        refresh: function() {
		            var that = this,
		                axis = that.axis,
		                dimension = that.dimension,
		                paneSize = dimension.size,
		                scrollMovable = that.scrollMovable,
		                sizeRatio = paneSize / dimension.total,
		                position = Math.round(-scrollMovable[axis] * sizeRatio),
		                size = Math.round(paneSize * sizeRatio);
	
		                if (sizeRatio >= 1) {
		                    this.element.css("display", "none");
		                } else {
		                    this.element.css("display", "");
		                }
	
		                if (position + size > paneSize) {
		                    size = paneSize - position;
		                } else if (position < 0) {
		                    size += position;
		                    position = 0;
		                }
	
		            if (that.elementSize != size) {
		                that.element.css(that.size, size + "px");
		                that.elementSize = size;
		            }
	
		            that.movable.moveAxis(axis, position);
		        },
	
		        show: function() {
		            this.element.css({opacity: SCROLLBAR_OPACITY, visibility: "visible"});
		        },
	
		        hide: function() {
		            if (!this.alwaysVisible) {
		                this.element.css({opacity: 0});
		            }
		        }
		    });
	
		    var Scroller = Widget.extend({
		        init: function(element, options) {
		            var that = this;
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element;
	
		            that._native = that.options.useNative && kendo.support.hasNativeScrolling;
		            if (that._native) {
		                element.addClass("km-native-scroller")
		                    .prepend('<div class="km-scroll-header"/>');
	
		                extend(that, {
		                    scrollElement: element,
		                    fixedContainer: element.children().first()
		                });
	
		                return;
		            }
	
		            element
		                .css("overflow", "hidden")
		                .addClass("km-scroll-wrapper")
		                .wrapInner('<div class="km-scroll-container"/>')
		                .prepend('<div class="km-scroll-header"/>');
	
		            var inner = element.children().eq(1),
	
		                tapCapture = new kendo.TapCapture(element),
	
		                movable = new Movable(inner),
	
		                dimensions = new PaneDimensions({
		                    element: inner,
		                    container: element,
		                    forcedEnabled: that.options.zoom
		                }),
	
		                avoidScrolling = this.options.avoidScrolling,
	
		                userEvents = new kendo.UserEvents(element, {
		                    touchAction: "pan-y",
		                    fastTap: true,
		                    allowSelection: true,
		                    preventDragEvent: true,
		                    captureUpIfMoved: true,
		                    multiTouch: that.options.zoom,
		                    supportDoubleTap: that.options.supportDoubleTap,
		                    start: function(e) {
		                        dimensions.refresh();
	
		                        var velocityX = abs(e.x.velocity),
		                            velocityY = abs(e.y.velocity),
		                            horizontalSwipe  = velocityX * 2 >= velocityY,
		                            originatedFromFixedContainer = $.contains(that.fixedContainer[0], e.event.target),
		                            verticalSwipe = velocityY * 2 >= velocityX;
	
	
		                        if (!originatedFromFixedContainer && !avoidScrolling(e) && that.enabled && (dimensions.x.enabled && horizontalSwipe || dimensions.y.enabled && verticalSwipe)) {
		                            userEvents.capture();
		                        } else {
		                            userEvents.cancel();
		                        }
		                    }
		                }),
	
		                pane = new Pane({
		                    movable: movable,
		                    dimensions: dimensions,
		                    userEvents: userEvents,
		                    elastic: that.options.elastic
		                }),
	
		                zoomSnapBack = new ZoomSnapBack({
		                    movable: movable,
		                    dimensions: dimensions,
		                    userEvents: userEvents,
		                    tapCapture: tapCapture
		                }),
	
		                animatedScroller = new AnimatedScroller({
		                    moveTo: function(coordinates) {
		                        that.scrollTo(coordinates.x, coordinates.y);
		                    }
		                });
	
		            movable.bind(CHANGE, function() {
		                that.scrollTop = - movable.y;
		                that.scrollLeft = - movable.x;
	
		                that.trigger(SCROLL, {
		                    scrollTop: that.scrollTop,
		                    scrollLeft: that.scrollLeft
		                });
		            });
	
		            if (that.options.mousewheelScrolling) {
		                element.on("DOMMouseScroll mousewheel",  proxy(this, "_wheelScroll"));
		            }
	
		            extend(that, {
		                movable: movable,
		                dimensions: dimensions,
		                zoomSnapBack: zoomSnapBack,
		                animatedScroller: animatedScroller,
		                userEvents: userEvents,
		                pane: pane,
		                tapCapture: tapCapture,
		                pulled: false,
		                enabled: true,
		                scrollElement: inner,
		                scrollTop: 0,
		                scrollLeft: 0,
		                fixedContainer: element.children().first()
		            });
	
		            that._initAxis("x");
		            that._initAxis("y");
	
		            // build closure
		            that._wheelEnd = function() {
		                that._wheel = false;
		                that.userEvents.end(0, that._wheelY);
		            };
	
		            dimensions.refresh();
	
		            if (that.options.pullToRefresh) {
		                that._initPullToRefresh();
		            }
		        },
	
		        _wheelScroll: function(e) {
		            if (!this._wheel) {
		                this._wheel = true;
		                this._wheelY = 0;
		                this.userEvents.press(0, this._wheelY);
		            }
	
		            clearTimeout(this._wheelTimeout);
		            this._wheelTimeout = setTimeout(this._wheelEnd, 50);
	
		            var delta = kendo.wheelDeltaY(e);
	
		            if (delta) {
		                this._wheelY += delta;
		                this.userEvents.move(0, this._wheelY);
		            }
	
		            e.preventDefault();
		        },
	
		        makeVirtual: function() {
		            this.dimensions.y.makeVirtual();
		        },
	
		        virtualSize: function(min, max) {
		            this.dimensions.y.virtualSize(min, max);
		        },
	
		        height: function() {
		            return this.dimensions.y.size;
		        },
	
		        scrollHeight: function() {
		            return this.scrollElement[0].scrollHeight;
		        },
	
		        scrollWidth: function() {
		            return this.scrollElement[0].scrollWidth;
		        },
	
		        options: {
		            name: "Scroller",
		            zoom: false,
		            pullOffset: 140,
		            visibleScrollHints: false,
		            elastic: true,
		            useNative: false,
		            mousewheelScrolling: true,
		            avoidScrolling: function() { return false; },
		            pullToRefresh: false,
		            messages: {
		                pullTemplate: "Pull to refresh",
		                releaseTemplate: "Release to refresh",
		                refreshTemplate: "Refreshing"
		            }
		        },
	
		        events: [
		            PULL,
		            SCROLL,
		            RESIZE
		        ],
	
		        _resize: function() {
		            if (!this._native) {
		                this.contentResized();
		            }
		        },
	
		        setOptions: function(options) {
		            var that = this;
		            Widget.fn.setOptions.call(that, options);
		            if (options.pullToRefresh) {
		                that._initPullToRefresh();
		            }
		        },
	
		        reset: function() {
		            if (this._native) {
		                this.scrollElement.scrollTop(0);
		            } else {
		                this.movable.moveTo({x: 0, y: 0});
		                this._scale(1);
		            }
		        },
	
		        contentResized: function() {
		            this.dimensions.refresh();
		            if (this.pane.x.outOfBounds()) {
		                this.movable.moveAxis("x", this.dimensions.x.min);
		            }
	
		            if (this.pane.y.outOfBounds()) {
		                this.movable.moveAxis("y", this.dimensions.y.min);
		            }
		        },
	
		        zoomOut: function() {
		            var dimensions = this.dimensions;
		            dimensions.refresh();
		            this._scale(dimensions.fitScale);
		            this.movable.moveTo(dimensions.centerCoordinates());
		        },
	
		        enable: function() {
		            this.enabled = true;
		        },
	
		        disable: function() {
		            this.enabled = false;
		        },
	
		        scrollTo: function(x, y) {
		            if (this._native) {
		                this.scrollElement.scrollLeft(abs(x));
		                this.scrollElement.scrollTop(abs(y));
		            } else {
		                this.dimensions.refresh();
		                this.movable.moveTo({x: x, y: y});
		            }
		        },
	
		        animatedScrollTo: function(x, y, callback) {
		            var from,
		                to;
	
		            if(this._native) {
		                this.scrollTo(x, y);
		            } else {
		                from = { x: this.movable.x, y: this.movable.y };
		                to = { x: x, y: y };
	
		                this.animatedScroller.setCoordinates(from, to);
		                this.animatedScroller.setCallback(callback);
		                this.animatedScroller.start();
		            }
		        },
	
		        pullHandled: function() {
		            var that = this;
		            that.refreshHint.removeClass(REFRESHCLASS);
		            that.hintContainer.html(that.pullTemplate({}));
		            that.yinertia.onEnd();
		            that.xinertia.onEnd();
		            that.userEvents.cancel();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            if (this.userEvents) {
		                this.userEvents.destroy();
		            }
		        },
	
		        _scale: function(scale) {
		            this.dimensions.rescale(scale);
		            this.movable.scaleTo(scale);
		        },
	
		        _initPullToRefresh: function() {
		            var that = this;
	
		            that.dimensions.y.forceEnabled();
		            that.pullTemplate = kendo.template(that.options.messages.pullTemplate);
		            that.releaseTemplate = kendo.template(that.options.messages.releaseTemplate);
		            that.refreshTemplate = kendo.template(that.options.messages.refreshTemplate);
	
		            that.scrollElement.prepend('<span class="km-scroller-pull"><span class="km-icon"></span><span class="km-loading-left"></span><span class="km-loading-right"></span><span class="km-template">' + that.pullTemplate({}) + '</span></span>');
		            that.refreshHint = that.scrollElement.children().first();
		            that.hintContainer = that.refreshHint.children(".km-template");
	
		            that.pane.y.bind("change", proxy(that._paneChange, that));
		            that.userEvents.bind("end", proxy(that._dragEnd, that));
		        },
	
		        _dragEnd: function() {
		            var that = this;
	
		            if(!that.pulled) {
		                return;
		            }
	
		            that.pulled = false;
		            that.refreshHint.removeClass(RELEASECLASS).addClass(REFRESHCLASS);
		            that.hintContainer.html(that.refreshTemplate({}));
		            that.yinertia.freeze(that.options.pullOffset / 2);
		            that.trigger("pull");
		        },
	
		        _paneChange: function() {
		            var that = this;
	
		            if (that.movable.y / OUT_OF_BOUNDS_FRICTION > that.options.pullOffset) {
		                if (!that.pulled) {
		                    that.pulled = true;
		                    that.refreshHint.removeClass(REFRESHCLASS).addClass(RELEASECLASS);
		                    that.hintContainer.html(that.releaseTemplate({}));
		                }
		            } else if (that.pulled) {
		                that.pulled = false;
		                that.refreshHint.removeClass(RELEASECLASS);
		                that.hintContainer.html(that.pullTemplate({}));
		            }
		        },
	
		        _initAxis: function(axis) {
		            var that = this,
		                movable = that.movable,
		                dimension = that.dimensions[axis],
		                tapCapture = that.tapCapture,
		                paneAxis = that.pane[axis],
		                scrollBar = new ScrollBar({
		                    axis: axis,
		                    movable: movable,
		                    dimension: dimension,
		                    container: that.element,
		                    alwaysVisible: that.options.visibleScrollHints
		                });
	
		            dimension.bind(CHANGE, function() {
		                scrollBar.refresh();
		            });
	
		            paneAxis.bind(CHANGE, function() {
		                scrollBar.show();
		            });
	
		            that[axis + "inertia"] = new DragInertia({
		                axis: axis,
		                paneAxis: paneAxis,
		                movable: movable,
		                tapCapture: tapCapture,
		                userEvents: that.userEvents,
		                dimension: dimension,
		                elastic: that.options.elastic,
		                friction: that.options.friction || FRICTION,
		                velocityMultiplier: that.options.velocityMultiplier || VELOCITY_MULTIPLIER,
		                end: function() {
		                    scrollBar.hide();
		                    that.trigger("scrollEnd", {
		                        axis: axis,
		                        scrollTop: that.scrollTop,
		                        scrollLeft: that.scrollLeft
		                    });
		                }
		            });
		        }
		    });
	
		    ui.plugin(Scroller);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1184);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1184:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "fx",
		    name: "Effects",
		    category: "framework",
		    description: "Required for animation effects in all Kendo UI widgets.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        fx = kendo.effects,
		        each = $.each,
		        extend = $.extend,
		        proxy = $.proxy,
		        support = kendo.support,
		        browser = support.browser,
		        transforms = support.transforms,
		        transitions = support.transitions,
		        scaleProperties = { scale: 0, scalex: 0, scaley: 0, scale3d: 0 },
		        translateProperties = { translate: 0, translatex: 0, translatey: 0, translate3d: 0 },
		        hasZoom = (typeof document.documentElement.style.zoom !== "undefined") && !transforms,
		        matrix3dRegExp = /matrix3?d?\s*\(.*,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?/i,
		        cssParamsRegExp = /^(-?[\d\.\-]+)?[\w\s]*,?\s*(-?[\d\.\-]+)?[\w\s]*/i,
		        translateXRegExp = /translatex?$/i,
		        oldEffectsRegExp = /(zoom|fade|expand)(\w+)/,
		        singleEffectRegExp = /(zoom|fade|expand)/,
		        unitRegExp = /[xy]$/i,
		        transformProps = ["perspective", "rotate", "rotatex", "rotatey", "rotatez", "rotate3d", "scale", "scalex", "scaley", "scalez", "scale3d", "skew", "skewx", "skewy", "translate", "translatex", "translatey", "translatez", "translate3d", "matrix", "matrix3d"],
		        transform2d = ["rotate", "scale", "scalex", "scaley", "skew", "skewx", "skewy", "translate", "translatex", "translatey", "matrix"],
		        transform2units = { "rotate": "deg", scale: "", skew: "px", translate: "px" },
		        cssPrefix = transforms.css,
		        round = Math.round,
		        BLANK = "",
		        PX = "px",
		        NONE = "none",
		        AUTO = "auto",
		        WIDTH = "width",
		        HEIGHT = "height",
		        HIDDEN = "hidden",
		        ORIGIN = "origin",
		        ABORT_ID = "abortId",
		        OVERFLOW = "overflow",
		        TRANSLATE = "translate",
		        POSITION = "position",
		        COMPLETE_CALLBACK = "completeCallback",
		        TRANSITION = cssPrefix + "transition",
		        TRANSFORM = cssPrefix + "transform",
		        BACKFACE = cssPrefix + "backface-visibility",
		        PERSPECTIVE = cssPrefix + "perspective",
		        DEFAULT_PERSPECTIVE = "1500px",
		        TRANSFORM_PERSPECTIVE = "perspective(" + DEFAULT_PERSPECTIVE + ")",
		        directions = {
		            left: {
		                reverse: "right",
		                property: "left",
		                transition: "translatex",
		                vertical: false,
		                modifier: -1
		            },
		            right: {
		                reverse: "left",
		                property: "left",
		                transition: "translatex",
		                vertical: false,
		                modifier: 1
		            },
		            down: {
		                reverse: "up",
		                property: "top",
		                transition: "translatey",
		                vertical: true,
		                modifier: 1
		            },
		            up: {
		                reverse: "down",
		                property: "top",
		                transition: "translatey",
		                vertical: true,
		                modifier: -1
		            },
		            top: {
		                reverse: "bottom"
		            },
		            bottom: {
		                reverse: "top"
		            },
		            "in": {
		                reverse: "out",
		                modifier: -1
		            },
		            out: {
		                reverse: "in",
		                modifier: 1
		            },
	
		            vertical: {
		                reverse: "vertical"
		            },
	
		            horizontal: {
		                reverse: "horizontal"
		            }
		        };
	
		    kendo.directions = directions;
	
		    extend($.fn, {
		        kendoStop: function(clearQueue, gotoEnd) {
		            if (transitions) {
		                return fx.stopQueue(this, clearQueue || false, gotoEnd || false);
		            } else {
		                return this.stop(clearQueue, gotoEnd);
		            }
		        }
		    });
	
		    /* jQuery support for all transform animations (FF 3.5/3.6, Opera 10.x, IE9 */
	
		    if (transforms && !transitions) {
		        each(transform2d, function(idx, value) {
		            $.fn[value] = function(val) {
		                if (typeof val == "undefined") {
		                    return animationProperty(this, value);
		                } else {
		                    var that = $(this)[0],
		                        transformValue = value + "(" + val + transform2units[value.replace(unitRegExp, "")] + ")";
	
		                    if (that.style.cssText.indexOf(TRANSFORM) == -1) {
		                        $(this).css(TRANSFORM, transformValue);
		                    } else {
		                        that.style.cssText = that.style.cssText.replace(new RegExp(value + "\\(.*?\\)", "i"), transformValue);
		                    }
		                }
		                return this;
		            };
	
		            $.fx.step[value] = function (fx) {
		                $(fx.elem)[value](fx.now);
		            };
		        });
	
		        var curProxy = $.fx.prototype.cur;
		        $.fx.prototype.cur = function () {
		            if (transform2d.indexOf(this.prop) != -1) {
		                return parseFloat($(this.elem)[this.prop]());
		            }
	
		            return curProxy.apply(this, arguments);
		        };
		    }
	
		    kendo.toggleClass = function(element, classes, options, add) {
		        if (classes) {
		            classes = classes.split(" ");
	
		            if (transitions) {
		                options = extend({
		                    exclusive: "all",
		                    duration: 400,
		                    ease: "ease-out"
		                }, options);
	
		                element.css(TRANSITION, options.exclusive + " " + options.duration + "ms " + options.ease);
		                setTimeout(function() {
		                    element.css(TRANSITION, "").css(HEIGHT);
		                }, options.duration); // TODO: this should fire a kendoAnimate session instead.
		            }
	
		            each(classes, function(idx, value) {
		                element.toggleClass(value, add);
		            });
		        }
	
		        return element;
		    };
	
		    kendo.parseEffects = function(input, mirror) {
		        var effects = {};
	
		        if (typeof input === "string") {
		            each(input.split(" "), function(idx, value) {
		                var redirectedEffect = !singleEffectRegExp.test(value),
		                    resolved = value.replace(oldEffectsRegExp, function(match, $1, $2) {
		                        return $1 + ":" + $2.toLowerCase();
		                    }), // Support for old zoomIn/fadeOut style, now deprecated.
		                    effect = resolved.split(":"),
		                    direction = effect[1],
		                    effectBody = {};
	
		                if (effect.length > 1) {
		                    effectBody.direction = (mirror && redirectedEffect ? directions[direction].reverse : direction);
		                }
	
		                effects[effect[0]] = effectBody;
		            });
		        } else {
		            each(input, function(idx) {
		                var direction = this.direction;
	
		                if (direction && mirror && !singleEffectRegExp.test(idx)) {
		                    this.direction = directions[direction].reverse;
		                }
	
		                effects[idx] = this;
		            });
		        }
	
		        return effects;
		    };
	
		    function parseInteger(value) {
		        return parseInt(value, 10);
		    }
	
		    function parseCSS(element, property) {
		        return parseInteger(element.css(property));
		    }
	
		    function keys(obj) {
		        var acc = [];
		        for (var propertyName in obj) {
		            acc.push(propertyName);
		        }
		        return acc;
		    }
	
		    function strip3DTransforms(properties) {
		        for (var key in properties) {
		            if (transformProps.indexOf(key) != -1 && transform2d.indexOf(key) == -1) {
		                delete properties[key];
		            }
		        }
	
		        return properties;
		    }
	
		    function normalizeCSS(element, properties) {
		        var transformation = [], cssValues = {}, lowerKey, key, value, isTransformed;
	
		        for (key in properties) {
		            lowerKey = key.toLowerCase();
		            isTransformed = transforms && transformProps.indexOf(lowerKey) != -1;
	
		            if (!support.hasHW3D && isTransformed && transform2d.indexOf(lowerKey) == -1) {
		                delete properties[key];
		            } else {
		                value = properties[key];
	
		                if (isTransformed) {
		                    transformation.push(key + "(" + value + ")");
		                } else {
		                    cssValues[key] = value;
		                }
		            }
		        }
	
		        if (transformation.length) {
		            cssValues[TRANSFORM] = transformation.join(" ");
		        }
	
		        return cssValues;
		    }
	
		    if (transitions) {
		        extend(fx, {
		            transition: function(element, properties, options) {
		                var css,
		                    delay = 0,
		                    oldKeys = element.data("keys") || [],
		                    timeoutID;
	
		                options = extend({
		                        duration: 200,
		                        ease: "ease-out",
		                        complete: null,
		                        exclusive: "all"
		                    },
		                    options
		                );
	
		                var stopTransitionCalled = false;
	
		                var stopTransition = function() {
		                    if (!stopTransitionCalled) {
		                        stopTransitionCalled = true;
	
		                        if (timeoutID) {
		                            clearTimeout(timeoutID);
		                            timeoutID = null;
		                        }
	
		                        element
		                        .removeData(ABORT_ID)
		                        .dequeue()
		                        .css(TRANSITION, "")
		                        .css(TRANSITION);
	
		                        options.complete.call(element);
		                    }
		                };
	
		                options.duration = $.fx ? $.fx.speeds[options.duration] || options.duration : options.duration;
	
		                css = normalizeCSS(element, properties);
	
		                $.merge(oldKeys, keys(css));
		                element
		                    .data("keys", $.unique(oldKeys))
		                    .height();
	
		                element.css(TRANSITION, options.exclusive + " " + options.duration + "ms " + options.ease).css(TRANSITION);
		                element.css(css).css(TRANSFORM);
	
		                /**
		                 * Use transitionEnd event for browsers who support it - but duplicate it with setTimeout, as the transitionEnd event will not be triggered if no CSS properties change.
		                 * This should be cleaned up at some point (widget by widget), and refactored to widgets not relying on the complete callback if no transition occurs.
		                 *
		                 * For IE9 and below, resort to setTimeout.
		                 */
		                if (transitions.event) {
		                    element.one(transitions.event, stopTransition);
		                    if (options.duration !== 0) {
		                        delay = 500;
		                    }
		                }
	
		                timeoutID = setTimeout(stopTransition, options.duration + delay);
		                element.data(ABORT_ID, timeoutID);
		                element.data(COMPLETE_CALLBACK, stopTransition);
		            },
	
		            stopQueue: function(element, clearQueue, gotoEnd) {
		                var cssValues,
		                    taskKeys = element.data("keys"),
		                    retainPosition = (!gotoEnd && taskKeys),
		                    completeCallback = element.data(COMPLETE_CALLBACK);
	
		                if (retainPosition) {
		                    cssValues = kendo.getComputedStyles(element[0], taskKeys);
		                }
	
		                if (completeCallback) {
		                    completeCallback();
		                }
	
		                if (retainPosition) {
		                    element.css(cssValues);
		                }
	
		                return element
		                        .removeData("keys")
		                        .stop(clearQueue);
		            }
		        });
		    }
	
		    function animationProperty(element, property) {
		        if (transforms) {
		            var transform = element.css(TRANSFORM);
		            if (transform == NONE) {
		                return property == "scale" ? 1 : 0;
		            }
	
		            var match = transform.match(new RegExp(property + "\\s*\\(([\\d\\w\\.]+)")),
		                computed = 0;
	
		            if (match) {
		                computed = parseInteger(match[1]);
		            } else {
		                match = transform.match(matrix3dRegExp) || [0, 0, 0, 0, 0];
		                property = property.toLowerCase();
	
		                if (translateXRegExp.test(property)) {
		                    computed = parseFloat(match[3] / match[2]);
		                } else if (property == "translatey") {
		                    computed = parseFloat(match[4] / match[2]);
		                } else if (property == "scale") {
		                    computed = parseFloat(match[2]);
		                } else if (property == "rotate") {
		                    computed = parseFloat(Math.atan2(match[2], match[1]));
		                }
		            }
	
		            return computed;
		        } else {
		            return parseFloat(element.css(property));
		        }
		    }
	
		    var EffectSet = kendo.Class.extend({
		        init: function(element, options) {
		            var that = this;
	
		            that.element = element;
		            that.effects = [];
		            that.options = options;
		            that.restore = [];
		        },
	
		        run: function(effects) {
		            var that = this,
		                effect,
		                idx, jdx,
		                length = effects.length,
		                element = that.element,
		                options = that.options,
		                deferred = $.Deferred(),
		                start = {},
		                end = {},
		                target,
		                children,
		                childrenLength;
	
		            that.effects = effects;
	
		            deferred.done($.proxy(that, "complete"));
	
		            element.data("animating", true);
	
		            for (idx = 0; idx < length; idx ++) {
		                effect = effects[idx];
	
		                effect.setReverse(options.reverse);
		                effect.setOptions(options);
	
		                that.addRestoreProperties(effect.restore);
	
		                effect.prepare(start, end);
	
		                children = effect.children();
	
		                for (jdx = 0, childrenLength = children.length; jdx < childrenLength; jdx ++) {
		                    children[jdx].duration(options.duration).run();
		                }
		            }
	
		            // legacy support for options.properties
		            for (var effectName in options.effects) {
		                extend(end, options.effects[effectName].properties);
		            }
	
		            // Show the element initially
		            if (!element.is(":visible")) {
		                extend(start, { display: element.data("olddisplay") || "block" });
		            }
	
		            if (transforms && !options.reset) {
		                target = element.data("targetTransform");
	
		                if (target) {
		                    start = extend(target, start);
		                }
		            }
	
		            start = normalizeCSS(element, start);
	
		            if (transforms && !transitions) {
		                start = strip3DTransforms(start);
		            }
	
		            element.css(start)
		                   .css(TRANSFORM); // Nudge
	
		            for (idx = 0; idx < length; idx ++) {
		                effects[idx].setup();
		            }
	
		            if (options.init) {
		                options.init();
		            }
	
		            element.data("targetTransform", end);
		            fx.animate(element, end, extend({}, options, { complete: deferred.resolve }));
	
		            return deferred.promise();
		        },
	
		        stop: function() {
		            $(this.element).kendoStop(true, true);
		        },
	
		        addRestoreProperties: function(restore) {
		            var element = this.element,
		                value,
		                i = 0,
		                length = restore.length;
	
		            for (; i < length; i ++) {
		                value = restore[i];
	
		                this.restore.push(value);
	
		                if (!element.data(value)) {
		                    element.data(value, element.css(value));
		                }
		            }
		        },
	
		        restoreCallback: function() {
		            var element = this.element;
	
		            for (var i = 0, length = this.restore.length; i < length; i ++) {
		                var value = this.restore[i];
		                element.css(value, element.data(value));
		            }
		        },
	
		        complete: function() {
		            var that = this,
		                idx = 0,
		                element = that.element,
		                options = that.options,
		                effects = that.effects,
		                length = effects.length;
	
		            element
		                .removeData("animating")
		                .dequeue(); // call next animation from the queue
	
		            if (options.hide) {
		                element.data("olddisplay", element.css("display")).hide();
		            }
	
		            this.restoreCallback();
	
		            if (hasZoom && !transforms) {
		                setTimeout($.proxy(this, "restoreCallback"), 0); // Again jQuery callback in IE8-
		            }
	
		            for (; idx < length; idx ++) {
		                effects[idx].teardown();
		            }
	
		            if (options.completeCallback) {
		                options.completeCallback(element);
		            }
		        }
		    });
	
		    fx.promise = function(element, options) {
		        var effects = [],
		            effectClass,
		            effectSet = new EffectSet(element, options),
		            parsedEffects = kendo.parseEffects(options.effects),
		            effect;
	
		        options.effects = parsedEffects;
	
		        for (var effectName in parsedEffects) {
		            effectClass = fx[capitalize(effectName)];
	
		            if (effectClass) {
		                effect = new effectClass(element, parsedEffects[effectName].direction);
		                effects.push(effect);
		           }
		        }
	
		        if (effects[0]) {
		            effectSet.run(effects);
		        } else { // Not sure how would an fx promise reach this state - means that you call kendoAnimate with no valid effects? Why?
		            if (!element.is(":visible")) {
		                element.css({ display: element.data("olddisplay") || "block" }).css("display");
		            }
	
		            if (options.init) {
		                options.init();
		            }
	
		            element.dequeue();
		            effectSet.complete();
		        }
		    };
	
		    extend(fx, {
		        animate: function(elements, properties, options) {
		            var useTransition = options.transition !== false;
		            delete options.transition;
	
		            if (transitions && "transition" in fx && useTransition) {
		                fx.transition(elements, properties, options);
		            } else {
		                if (transforms) {
		                    elements.animate(strip3DTransforms(properties), { queue: false, show: false, hide: false, duration: options.duration, complete: options.complete }); // Stop animate from showing/hiding the element to be able to hide it later on.
		                } else {
		                    elements.each(function() {
		                        var element = $(this),
		                            multiple = {};
	
		                        each(transformProps, function(idx, value) { // remove transforms to avoid IE and older browsers confusion
		                            var params,
		                                currentValue = properties ? properties[value]+ " " : null; // We need to match
	
		                            if (currentValue) {
		                                var single = properties;
	
		                                if (value in scaleProperties && properties[value] !== undefined) {
		                                    params = currentValue.match(cssParamsRegExp);
		                                    if (transforms) {
		                                        extend(single, { scale: +params[0] });
		                                    }
		                                } else {
		                                    if (value in translateProperties && properties[value] !== undefined) {
		                                        var position = element.css(POSITION),
		                                            isFixed = (position == "absolute" || position == "fixed");
	
		                                        if (!element.data(TRANSLATE)) {
		                                            if (isFixed) {
		                                                element.data(TRANSLATE, {
		                                                    top: parseCSS(element, "top") || 0,
		                                                    left: parseCSS(element, "left") || 0,
		                                                    bottom: parseCSS(element, "bottom"),
		                                                    right: parseCSS(element, "right")
		                                                });
		                                            } else {
		                                                element.data(TRANSLATE, {
		                                                    top: parseCSS(element, "marginTop") || 0,
		                                                    left: parseCSS(element, "marginLeft") || 0
		                                                });
		                                            }
		                                        }
	
		                                        var originalPosition = element.data(TRANSLATE);
	
		                                        params = currentValue.match(cssParamsRegExp);
		                                        if (params) {
	
		                                            var dX = value == TRANSLATE + "y" ? +null : +params[1],
		                                                dY = value == TRANSLATE + "y" ? +params[1] : +params[2];
	
		                                            if (isFixed) {
		                                                if (!isNaN(originalPosition.right)) {
		                                                    if (!isNaN(dX)) { extend(single, { right: originalPosition.right - dX }); }
		                                                } else {
		                                                    if (!isNaN(dX)) { extend(single, { left: originalPosition.left + dX }); }
		                                                }
	
		                                                if (!isNaN(originalPosition.bottom)) {
		                                                    if (!isNaN(dY)) { extend(single, { bottom: originalPosition.bottom - dY }); }
		                                                } else {
		                                                    if (!isNaN(dY)) { extend(single, { top: originalPosition.top + dY }); }
		                                                }
		                                            } else {
		                                                if (!isNaN(dX)) { extend(single, { marginLeft: originalPosition.left + dX }); }
		                                                if (!isNaN(dY)) { extend(single, { marginTop: originalPosition.top + dY }); }
		                                            }
		                                        }
		                                    }
		                                }
	
		                                if (!transforms && value != "scale" && value in single) {
		                                    delete single[value];
		                                }
	
		                                if (single) {
		                                    extend(multiple, single);
		                                }
		                            }
		                        });
	
		                        if (browser.msie) {
		                            delete multiple.scale;
		                        }
	
		                        element.animate(multiple, { queue: false, show: false, hide: false, duration: options.duration, complete: options.complete }); // Stop animate from showing/hiding the element to be able to hide it later on.
		                    });
		                }
		            }
		        }
		    });
	
		    fx.animatedPromise = fx.promise;
	
		    var Effect = kendo.Class.extend({
		        init: function(element, direction) {
		            var that = this;
		            that.element = element;
		            that._direction = direction;
		            that.options = {};
		            that._additionalEffects = [];
	
		            if (!that.restore) {
		                that.restore = [];
		            }
		        },
	
		// Public API
		        reverse: function() {
		            this._reverse = true;
		            return this.run();
		        },
	
		        play: function() {
		            this._reverse = false;
		            return this.run();
		        },
	
		        add: function(additional) {
		            this._additionalEffects.push(additional);
		            return this;
		        },
	
		        direction: function(value) {
		            this._direction = value;
		            return this;
		        },
	
		        duration: function(duration) {
		            this._duration = duration;
		            return this;
		        },
	
		        compositeRun: function() {
		            var that = this,
		                effectSet = new EffectSet(that.element, { reverse: that._reverse, duration: that._duration }),
		                effects = that._additionalEffects.concat([ that ]);
	
		            return effectSet.run(effects);
		        },
	
		        run: function() {
		            if (this._additionalEffects && this._additionalEffects[0]) {
		                return this.compositeRun();
		            }
	
		            var that = this,
		                element = that.element,
		                idx = 0,
		                restore = that.restore,
		                length = restore.length,
		                value,
		                deferred = $.Deferred(),
		                start = {},
		                end = {},
		                target,
		                children = that.children(),
		                childrenLength = children.length;
	
		            deferred.done($.proxy(that, "_complete"));
	
		            element.data("animating", true);
	
		            for (idx = 0; idx < length; idx ++) {
		                value = restore[idx];
	
		                if (!element.data(value)) {
		                    element.data(value, element.css(value));
		                }
		            }
	
		            for (idx = 0; idx < childrenLength; idx ++) {
		                children[idx].duration(that._duration).run();
		            }
	
		            that.prepare(start, end);
	
		            if (!element.is(":visible")) {
		                extend(start, { display: element.data("olddisplay") || "block" });
		            }
	
		            if (transforms) {
		                target = element.data("targetTransform");
	
		                if (target) {
		                    start = extend(target, start);
		                }
		            }
	
		            start = normalizeCSS(element, start);
	
		            if (transforms && !transitions) {
		                start = strip3DTransforms(start);
		            }
	
		            element.css(start).css(TRANSFORM); // Trick webkit into re-rendering
	
		            that.setup();
	
		            element.data("targetTransform", end);
		            fx.animate(element, end, { duration: that._duration, complete: deferred.resolve });
	
		            return deferred.promise();
		        },
	
		        stop: function() {
		            var idx = 0,
		                children = this.children(),
		                childrenLength = children.length;
	
		            for (idx = 0; idx < childrenLength; idx ++) {
		                children[idx].stop();
		            }
	
		            $(this.element).kendoStop(true, true);
		            return this;
		        },
	
		        restoreCallback: function() {
		            var element = this.element;
	
		            for (var i = 0, length = this.restore.length; i < length; i ++) {
		                var value = this.restore[i];
		                element.css(value, element.data(value));
		            }
		        },
	
		        _complete: function() {
		            var that = this,
		                element = that.element;
	
		            element
		                .removeData("animating")
		                .dequeue(); // call next animation from the queue
	
		            that.restoreCallback();
	
		            if (that.shouldHide()) {
		                element.data("olddisplay", element.css("display")).hide();
		            }
	
		            if (hasZoom && !transforms) {
		                setTimeout($.proxy(that, "restoreCallback"), 0); // Again jQuery callback in IE8-
		            }
	
		            that.teardown();
		        },
	
		        /////////////////////////// Support for kendo.animate;
		        setOptions: function(options) {
		            extend(true, this.options, options);
		        },
	
		        children: function() {
		            return [];
		        },
	
		        shouldHide: $.noop,
	
		        setup: $.noop,
		        prepare: $.noop,
		        teardown: $.noop,
		        directions: [],
	
		        setReverse: function(reverse) {
		            this._reverse = reverse;
		            return this;
		        }
		    });
	
		    function capitalize(word) {
		        return word.charAt(0).toUpperCase() + word.substring(1);
		    }
	
		    function createEffect(name, definition) {
		        var effectClass = Effect.extend(definition),
		            directions = effectClass.prototype.directions;
	
		        fx[capitalize(name)] = effectClass;
	
		        fx.Element.prototype[name] = function(direction, opt1, opt2, opt3) {
		            return new effectClass(this.element, direction, opt1, opt2, opt3);
		        };
	
		        each(directions, function(idx, theDirection) {
		            fx.Element.prototype[name + capitalize(theDirection)] = function(opt1, opt2, opt3) {
		                return new effectClass(this.element, theDirection, opt1, opt2, opt3);
		            };
		        });
		    }
	
		    var FOUR_DIRECTIONS = ["left", "right", "up", "down"],
		        IN_OUT = ["in", "out"];
	
		    createEffect("slideIn", {
		        directions: FOUR_DIRECTIONS,
	
		        divisor: function(value) {
		            this.options.divisor = value;
		            return this;
		        },
	
		        prepare: function(start, end) {
		            var that = this,
		                tmp,
		                element = that.element,
		                outerWidth = kendo._outerWidth,
		                outerHeight = kendo._outerHeight,
		                direction = directions[that._direction],
		                offset = -direction.modifier * (direction.vertical ? outerHeight(element) : outerWidth(element)),
		                startValue = offset / (that.options && that.options.divisor || 1) + PX,
		                endValue = "0px";
	
		            if (that._reverse) {
		                tmp = start;
		                start = end;
		                end = tmp;
		            }
	
		            if (transforms) {
		                start[direction.transition] = startValue;
		                end[direction.transition] = endValue;
		            } else {
		                start[direction.property] = startValue;
		                end[direction.property] = endValue;
		            }
		        }
		    });
	
		    createEffect("tile", {
		        directions: FOUR_DIRECTIONS,
	
		        init: function(element, direction, previous) {
		            Effect.prototype.init.call(this, element, direction);
		            this.options = { previous: previous };
		        },
	
		        previousDivisor: function(value) {
		            this.options.previousDivisor = value;
		            return this;
		        },
	
		        children: function() {
		            var that = this,
		                reverse = that._reverse,
		                previous = that.options.previous,
		                divisor = that.options.previousDivisor || 1,
		                dir = that._direction;
	
		            var children = [ kendo.fx(that.element).slideIn(dir).setReverse(reverse) ];
	
		            if (previous) {
		                children.push( kendo.fx(previous).slideIn(directions[dir].reverse).divisor(divisor).setReverse(!reverse) );
		            }
	
		            return children;
		        }
		    });
	
		    function createToggleEffect(name, property, defaultStart, defaultEnd) {
		        createEffect(name, {
		            directions: IN_OUT,
	
		            startValue: function(value) {
		                this._startValue = value;
		                return this;
		            },
	
		            endValue: function(value) {
		                this._endValue = value;
		                return this;
		            },
	
		            shouldHide: function() {
		               return this._shouldHide;
		            },
	
		            prepare: function(start, end) {
		                var that = this,
		                    startValue,
		                    endValue,
		                    out = this._direction === "out",
		                    startDataValue = that.element.data(property),
		                    startDataValueIsSet = !(isNaN(startDataValue) || startDataValue == defaultStart);
	
		                if (startDataValueIsSet) {
		                    startValue = startDataValue;
		                } else if (typeof this._startValue !== "undefined") {
		                    startValue = this._startValue;
		                } else {
		                    startValue = out ? defaultStart : defaultEnd;
		                }
	
		                if (typeof this._endValue !== "undefined") {
		                    endValue = this._endValue;
		                } else {
		                    endValue = out ? defaultEnd : defaultStart;
		                }
	
		                if (this._reverse) {
		                    start[property] = endValue;
		                    end[property] = startValue;
		                } else {
		                    start[property] = startValue;
		                    end[property] = endValue;
		                }
	
		                that._shouldHide = end[property] === defaultEnd;
		            }
		        });
		    }
	
		    createToggleEffect("fade", "opacity", 1, 0);
		    createToggleEffect("zoom", "scale", 1, 0.01);
	
		    createEffect("slideMargin", {
		        prepare: function(start, end) {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                origin = element.data(ORIGIN),
		                offset = options.offset,
		                margin,
		                reverse = that._reverse;
	
		            if (!reverse && origin === null) {
		                element.data(ORIGIN, parseFloat(element.css("margin-" + options.axis)));
		            }
	
		            margin = (element.data(ORIGIN) || 0);
		            end["margin-" + options.axis] = !reverse ? margin + offset : margin;
		        }
		    });
	
		    createEffect("slideTo", {
		        prepare: function(start, end) {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                offset = options.offset.split(","),
		                reverse = that._reverse;
	
		            if (transforms) {
		                end.translatex = !reverse ? offset[0] : 0;
		                end.translatey = !reverse ? offset[1] : 0;
		            } else {
		                end.left = !reverse ? offset[0] : 0;
		                end.top = !reverse ? offset[1] : 0;
		            }
		            element.css("left");
		        }
		    });
	
		    createEffect("expand", {
		        directions: ["horizontal", "vertical"],
	
		        restore: [ OVERFLOW ],
	
		        prepare: function(start, end) {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                reverse = that._reverse,
		                property = that._direction === "vertical" ? HEIGHT : WIDTH,
		                setLength = element[0].style[property],
		                oldLength = element.data(property),
		                length = parseFloat(oldLength || setLength),
		                realLength = round(element.css(property, AUTO)[property]());
	
		            start.overflow = HIDDEN;
	
		            length = (options && options.reset) ? realLength || length : length || realLength;
	
		            end[property] = (reverse ? 0 : length) + PX;
		            start[property] = (reverse ? length : 0) + PX;
	
		            if (oldLength === undefined) {
		                element.data(property, setLength);
		            }
		        },
	
		        shouldHide: function() {
		           return this._reverse;
		        },
	
		        teardown: function() {
		            var that = this,
		                element = that.element,
		                property = that._direction === "vertical" ? HEIGHT : WIDTH,
		                length = element.data(property);
	
		            if (length == AUTO || length === BLANK) {
		                setTimeout(function() { element.css(property, AUTO).css(property); }, 0); // jQuery animate complete callback in IE is called before the last animation step!
		            }
		        }
		    });
	
		    var TRANSFER_START_STATE = { position: "absolute", marginLeft: 0, marginTop: 0, scale: 1 };
		    /**
		     * Intersection point formulas are taken from here - http://zonalandeducation.com/mmts/intersections/intersectionOfTwoLines1/intersectionOfTwoLines1.html
		     * Formula for a linear function from two points from here - http://demo.activemath.org/ActiveMath2/search/show.cmd?id=mbase://AC_UK_calculus/functions/ex_linear_equation_two_points
		     * The transform origin point is the intersection point of the two lines from the top left corners/top right corners of the element and target.
		     * The math and variables below MAY BE SIMPLIFIED (zeroes removed), but this would make the formula too cryptic.
		     */
		    createEffect("transfer", {
		        init: function(element, target) {
		            this.element = element;
		            this.options = { target: target };
		            this.restore = [];
		        },
	
		        setup: function() {
		            this.element.appendTo(document.body);
		        },
	
		        prepare: function(start, end) {
		            var that = this,
		                element = that.element,
		                outerBox = fx.box(element),
		                innerBox = fx.box(that.options.target),
		                currentScale = animationProperty(element, "scale"),
		                scale = fx.fillScale(innerBox, outerBox),
		                transformOrigin = fx.transformOrigin(innerBox, outerBox);
	
		            extend(start, TRANSFER_START_STATE);
		            end.scale = 1;
	
		            element.css(TRANSFORM, "scale(1)").css(TRANSFORM);
		            element.css(TRANSFORM, "scale(" + currentScale + ")");
	
		            start.top = outerBox.top;
		            start.left = outerBox.left;
		            start.transformOrigin = transformOrigin.x + PX + " " + transformOrigin.y + PX;
	
		            if (that._reverse) {
		                start.scale = scale;
		            } else {
		                end.scale = scale;
		            }
		        }
		    });
	
	
		    var CLIPS = {
		        top: "rect(auto auto $size auto)",
		        bottom: "rect($size auto auto auto)",
		        left: "rect(auto $size auto auto)",
		        right: "rect(auto auto auto $size)"
		    };
	
		    var ROTATIONS = {
		        top:    { start: "rotatex(0deg)", end: "rotatex(180deg)" },
		        bottom: { start: "rotatex(-180deg)", end: "rotatex(0deg)" },
		        left:   { start: "rotatey(0deg)", end: "rotatey(-180deg)" },
		        right:  { start: "rotatey(180deg)", end: "rotatey(0deg)" }
		    };
	
		    function clipInHalf(container, direction) {
		        var vertical = kendo.directions[direction].vertical,
		            size = (container[vertical ? HEIGHT : WIDTH]() / 2) + "px";
	
		        return CLIPS[direction].replace("$size", size);
		    }
	
		    createEffect("turningPage", {
		        directions: FOUR_DIRECTIONS,
	
		        init: function(element, direction, container) {
		            Effect.prototype.init.call(this, element, direction);
		            this._container = container;
		        },
	
		        prepare: function(start, end) {
		            var that = this,
		                reverse = that._reverse,
		                direction = reverse ? directions[that._direction].reverse : that._direction,
		                rotation = ROTATIONS[direction];
	
		            start.zIndex = 1;
	
		            if (that._clipInHalf) {
		               start.clip = clipInHalf(that._container, kendo.directions[direction].reverse);
		            }
	
		            start[BACKFACE] = HIDDEN;
	
		            end[TRANSFORM] = TRANSFORM_PERSPECTIVE + (reverse ? rotation.start : rotation.end);
		            start[TRANSFORM] = TRANSFORM_PERSPECTIVE + (reverse ? rotation.end : rotation.start);
		        },
	
		        setup: function() {
		            this._container.append(this.element);
		        },
	
		        face: function(value) {
		            this._face = value;
		            return this;
		        },
	
		        shouldHide: function() {
		            var that = this,
		                reverse = that._reverse,
		                face = that._face;
	
		            return (reverse && !face) || (!reverse && face);
		        },
	
		        clipInHalf: function(value) {
		            this._clipInHalf = value;
		            return this;
		        },
	
		        temporary: function() {
		            this.element.addClass('temp-page');
		            return this;
		        }
		    });
	
		    createEffect("staticPage", {
		        directions: FOUR_DIRECTIONS,
	
		        init: function(element, direction, container) {
		            Effect.prototype.init.call(this, element, direction);
		            this._container = container;
		        },
	
		        restore: ["clip"],
	
		        prepare: function(start, end) {
		            var that = this,
		                direction = that._reverse ? directions[that._direction].reverse : that._direction;
	
		            start.clip = clipInHalf(that._container, direction);
		            start.opacity = 0.999;
		            end.opacity = 1;
		        },
	
		        shouldHide: function() {
		            var that = this,
		                reverse = that._reverse,
		                face = that._face;
	
		            return (reverse && !face) || (!reverse && face);
		        },
	
		        face: function(value) {
		            this._face = value;
		            return this;
		        }
		    });
	
		    createEffect("pageturn", {
		        directions: ["horizontal", "vertical"],
	
		        init: function(element, direction, face, back) {
		            Effect.prototype.init.call(this, element, direction);
		            this.options = {};
		            this.options.face = face;
		            this.options.back = back;
		        },
	
		        children: function() {
		            var that = this,
		                options = that.options,
		                direction = that._direction === "horizontal" ? "left" : "top",
		                reverseDirection = kendo.directions[direction].reverse,
		                reverse = that._reverse,
		                temp,
		                faceClone = options.face.clone(true).removeAttr("id"),
		                backClone = options.back.clone(true).removeAttr("id"),
		                element = that.element;
	
		            if (reverse) {
		                temp = direction;
		                direction = reverseDirection;
		                reverseDirection = temp;
		            }
	
		            return [
		                kendo.fx(options.face).staticPage(direction, element).face(true).setReverse(reverse),
		                kendo.fx(options.back).staticPage(reverseDirection, element).setReverse(reverse),
		                kendo.fx(faceClone).turningPage(direction, element).face(true).clipInHalf(true).temporary().setReverse(reverse),
		                kendo.fx(backClone).turningPage(reverseDirection, element).clipInHalf(true).temporary().setReverse(reverse)
		            ];
		        },
	
		        prepare: function(start, end) {
		            start[PERSPECTIVE] = DEFAULT_PERSPECTIVE;
		            start.transformStyle = "preserve-3d";
		            // hack to trigger transition end.
		            start.opacity = 0.999;
		            end.opacity = 1;
		        },
	
		        teardown: function() {
		            this.element.find(".temp-page").remove();
		        }
		    });
	
		    createEffect("flip", {
		        directions: ["horizontal", "vertical"],
	
		        init: function(element, direction, face, back) {
		            Effect.prototype.init.call(this, element, direction);
		            this.options = {};
		            this.options.face = face;
		            this.options.back = back;
		        },
	
		        children: function() {
		            var that = this,
		                options = that.options,
		                direction = that._direction === "horizontal" ? "left" : "top",
		                reverseDirection = kendo.directions[direction].reverse,
		                reverse = that._reverse,
		                temp,
		                element = that.element;
	
		            if (reverse) {
		                temp = direction;
		                direction = reverseDirection;
		                reverseDirection = temp;
		            }
	
		            return [
		                kendo.fx(options.face).turningPage(direction, element).face(true).setReverse(reverse),
		                kendo.fx(options.back).turningPage(reverseDirection, element).setReverse(reverse)
		            ];
		        },
	
		        prepare: function(start) {
		            start[PERSPECTIVE] = DEFAULT_PERSPECTIVE;
		            start.transformStyle = "preserve-3d";
		        }
		    });
	
		    var RESTORE_OVERFLOW = !support.mobileOS.android;
		    var IGNORE_TRANSITION_EVENT_SELECTOR = ".km-touch-scrollbar, .km-actionsheet-wrapper";
	
		    createEffect("replace", {
		        _before: $.noop,
		        _after: $.noop,
		        init: function(element, previous, transitionClass) {
		            Effect.prototype.init.call(this, element);
		            this._previous = $(previous);
		            this._transitionClass = transitionClass;
		        },
	
		        duration: function() {
		            throw new Error("The replace effect does not support duration setting; the effect duration may be customized through the transition class rule");
		        },
	
		        beforeTransition: function(callback) {
		            this._before = callback;
		            return this;
		        },
	
		        afterTransition: function(callback) {
		            this._after = callback;
		            return this;
		        },
	
		        _both: function() {
		            return $().add(this._element).add(this._previous);
		        },
	
		        _containerClass: function() {
		            var direction = this._direction,
		                containerClass = "k-fx k-fx-start k-fx-" + this._transitionClass;
	
		            if (direction) {
		                containerClass += " k-fx-" + direction;
		            }
	
		            if (this._reverse) {
		                containerClass += " k-fx-reverse";
		            }
	
		            return containerClass;
		        },
	
		        complete: function(e) {
		            if (!this.deferred || (e && $(e.target).is(IGNORE_TRANSITION_EVENT_SELECTOR))) {
		                return;
		            }
	
		            var container = this.container;
	
		            container
		                .removeClass("k-fx-end")
		                .removeClass(this._containerClass())
		                .off(transitions.event, this.completeProxy);
	
		            this._previous.hide().removeClass("k-fx-current");
		            this.element.removeClass("k-fx-next");
	
		            if (RESTORE_OVERFLOW) {
		                container.css(OVERFLOW, "");
		            }
	
		            if (!this.isAbsolute) {
		                this._both().css(POSITION, "");
		            }
	
		            this.deferred.resolve();
		            delete this.deferred;
		        },
	
		        run: function() {
		            if (this._additionalEffects && this._additionalEffects[0]) {
		                return this.compositeRun();
		            }
	
		            var that = this,
		                element = that.element,
		                previous = that._previous,
		                container = element.parents().filter(previous.parents()).first(),
		                both = that._both(),
		                deferred = $.Deferred(),
		                originalPosition = element.css(POSITION),
		                originalOverflow;
	
		            // edge case for grid/scheduler, where the previous is already destroyed.
		            if (!container.length) {
		                container = element.parent();
		            }
	
		            this.container = container;
		            this.deferred = deferred;
		            this.isAbsolute = originalPosition  == "absolute";
	
		            if (!this.isAbsolute) {
		                both.css(POSITION, "absolute");
		            }
	
		            if (RESTORE_OVERFLOW) {
		                originalOverflow = container.css(OVERFLOW);
		                container.css(OVERFLOW, "hidden");
		            }
	
		            if (!transitions) {
		                this.complete();
		            } else {
		                element.addClass("k-fx-hidden");
	
		                container.addClass(this._containerClass());
	
		                this.completeProxy = $.proxy(this, "complete");
		                container.on(transitions.event, this.completeProxy);
	
		                kendo.animationFrame(function() {
		                    element.removeClass("k-fx-hidden").addClass("k-fx-next");
		                    previous.css("display", "").addClass("k-fx-current");
		                    that._before(previous, element);
		                    kendo.animationFrame(function() {
		                        container.removeClass("k-fx-start").addClass("k-fx-end");
		                        that._after(previous, element);
		                    });
		                });
		            }
	
		            return deferred.promise();
		        },
	
		        stop: function() {
		            this.complete();
		        }
		    });
	
		    var Animation = kendo.Class.extend({
		        init: function() {
		            var that = this;
		            that._tickProxy = proxy(that._tick, that);
		            that._started = false;
		        },
	
		        tick: $.noop,
		        done: $.noop,
		        onEnd: $.noop,
		        onCancel: $.noop,
	
		        start: function() {
		            if (!this.enabled()) {
		                return;
		            }
	
		            if (!this.done()) {
		                this._started = true;
		                kendo.animationFrame(this._tickProxy);
		            } else {
		                this.onEnd();
		            }
		        },
	
		        enabled: function() {
		            return true;
		        },
	
		        cancel: function() {
		            this._started = false;
		            this.onCancel();
		        },
	
		        _tick: function() {
		            var that = this;
		            if (!that._started) { return; }
	
		            that.tick();
	
		            if (!that.done()) {
		                kendo.animationFrame(that._tickProxy);
		            } else {
		                that._started = false;
		                that.onEnd();
		            }
		        }
		    });
	
		    var Transition = Animation.extend({
		        init: function(options) {
		            var that = this;
		            extend(that, options);
		            Animation.fn.init.call(that);
		        },
	
		        done: function() {
		            return this.timePassed() >= this.duration;
		        },
	
		        timePassed: function() {
		            return Math.min(this.duration, (new Date()) - this.startDate);
		        },
	
		        moveTo: function(options) {
		            var that = this,
		                movable = that.movable;
	
		            that.initial = movable[that.axis];
		            that.delta = options.location - that.initial;
	
		            that.duration = typeof options.duration == "number" ? options.duration : 300;
	
		            that.tick = that._easeProxy(options.ease);
	
		            that.startDate = new Date();
		            that.start();
		        },
	
		        _easeProxy: function(ease) {
		            var that = this;
	
		            return function() {
		                that.movable.moveAxis(that.axis, ease(that.timePassed(), that.initial, that.delta, that.duration));
		            };
		        }
		    });
	
		    extend(Transition, {
		        easeOutExpo: function (t, b, c, d) {
		            return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
		        },
	
		        easeOutBack: function (t, b, c, d, s) {
		            s = 1.70158;
		            return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
		        }
		    });
	
		    fx.Animation = Animation;
		    fx.Transition = Transition;
		    fx.createEffect = createEffect;
	
		    fx.box = function(element) {
		        element = $(element);
		        var result = element.offset();
		        result.width = kendo._outerWidth(element);
		        result.height = kendo._outerHeight(element);
		        return result;
		    };
	
		    fx.transformOrigin = function(inner, outer) {
		        var x = (inner.left - outer.left) * outer.width / (outer.width - inner.width),
		            y = (inner.top - outer.top) * outer.height / (outer.height - inner.height);
	
		        return {
		            x: isNaN(x) ? 0 : x,
		            y: isNaN(y) ? 0 : y
		        };
		    };
	
		    fx.fillScale = function(inner, outer) {
		        return Math.min(inner.width / outer.width, inner.height / outer.height);
		    };
	
		    fx.fitScale = function(inner, outer) {
		        return Math.max(inner.width / outer.width, inner.height / outer.height);
		    };
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1123);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1123:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1038) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "draganddrop",
		    name: "Drag & drop",
		    category: "framework",
		    description: "Drag & drop functionality for any DOM element.",
		    depends: [ "core", "userevents" ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        support = kendo.support,
		        document = window.document,
		        $window = $(window),
		        Class = kendo.Class,
		        Widget = kendo.ui.Widget,
		        Observable = kendo.Observable,
		        UserEvents = kendo.UserEvents,
		        proxy = $.proxy,
		        extend = $.extend,
		        getOffset = kendo.getOffset,
		        draggables = {},
		        dropTargets = {},
		        dropAreas = {},
		        lastDropTarget,
		        elementUnderCursor = kendo.elementUnderCursor,
		        KEYUP = "keyup",
		        CHANGE = "change",
	
		        // Draggable events
		        DRAGSTART = "dragstart",
		        HOLD = "hold",
		        DRAG = "drag",
		        DRAGEND = "dragend",
		        DRAGCANCEL = "dragcancel",
		        HINTDESTROYED = "hintDestroyed",
	
		        // DropTarget events
		        DRAGENTER = "dragenter",
		        DRAGLEAVE = "dragleave",
		        DROP = "drop";
	
		    function contains(parent, child) {
		        try {
		            return $.contains(parent, child) || parent == child;
		        } catch (e) {
		            return false;
		        }
		    }
	
		    function numericCssPropery(element, property) {
		        return parseInt(element.css(property), 10) || 0;
		    }
	
		    function within(value, range) {
		        return Math.min(Math.max(value, range.min), range.max);
		    }
	
		    function containerBoundaries(container, element) {
		        var offset = getOffset(container),
		            outerWidth = kendo._outerWidth,
		            outerHeight = kendo._outerHeight,
		            minX = offset.left + numericCssPropery(container, "borderLeftWidth") + numericCssPropery(container, "paddingLeft"),
		            minY = offset.top + numericCssPropery(container, "borderTopWidth") + numericCssPropery(container, "paddingTop"),
		            maxX = minX + container.width() - outerWidth(element, true),
		            maxY = minY + container.height() - outerHeight(element, true);
	
		        return {
		            x: { min: minX, max: maxX },
		            y: { min: minY, max: maxY }
		        };
		    }
	
		    function checkTarget(target, targets, areas) {
		        var theTarget, theFilter, i = 0,
		            targetLen = targets && targets.length,
		            areaLen = areas && areas.length;
	
		        while (target && target.parentNode) {
		            for (i = 0; i < targetLen; i ++) {
		                theTarget = targets[i];
		                if (theTarget.element[0] === target) {
		                    return { target: theTarget, targetElement: target };
		                }
		            }
	
		            for (i = 0; i < areaLen; i ++) {
		                theFilter = areas[i];
		                if ($.contains(theFilter.element[0], target) && support.matchesSelector.call(target, theFilter.options.filter)) {
		                    return { target: theFilter, targetElement: target };
		                }
		            }
	
		            target = target.parentNode;
		        }
	
		        return undefined;
		    }
	
		    var TapCapture = Observable.extend({
		        init: function(element, options) {
		            var that = this,
		                domElement = element[0];
	
		            that.capture = false;
	
		            if (domElement.addEventListener) {
		                $.each(kendo.eventMap.down.split(" "), function() {
		                    domElement.addEventListener(this, proxy(that._press, that), true);
		                });
		                $.each(kendo.eventMap.up.split(" "), function() {
		                    domElement.addEventListener(this, proxy(that._release, that), true);
		                });
		            } else {
		                $.each(kendo.eventMap.down.split(" "), function() {
		                    domElement.attachEvent(this, proxy(that._press, that));
		                });
		                $.each(kendo.eventMap.up.split(" "), function() {
		                    domElement.attachEvent(this, proxy(that._release, that));
		                });
		            }
	
		            Observable.fn.init.call(that);
	
		            that.bind(["press", "release"], options || {});
		        },
	
		        captureNext: function() {
		            this.capture = true;
		        },
	
		        cancelCapture: function() {
		            this.capture = false;
		        },
	
		        _press: function(e) {
		            var that = this;
		            that.trigger("press");
		            if (that.capture) {
		                e.preventDefault();
		            }
		        },
	
		        _release: function(e) {
		            var that = this;
		            that.trigger("release");
	
		            if (that.capture) {
		                e.preventDefault();
		                that.cancelCapture();
		            }
		        }
		    });
	
		    var PaneDimension = Observable.extend({
		        init: function(options) {
		            var that = this;
		            Observable.fn.init.call(that);
	
		            that.forcedEnabled = false;
	
		            $.extend(that, options);
	
		            that.scale = 1;
	
		            if (that.horizontal) {
		                that.measure = "offsetWidth";
		                that.scrollSize = "scrollWidth";
		                that.axis = "x";
		            } else {
		                that.measure = "offsetHeight";
		                that.scrollSize = "scrollHeight";
		                that.axis = "y";
		            }
		        },
	
		        makeVirtual: function() {
		            $.extend(this, {
		                virtual: true,
		                forcedEnabled: true,
		                _virtualMin: 0,
		                _virtualMax: 0
		            });
		        },
	
		        virtualSize: function(min, max) {
		            if (this._virtualMin !== min || this._virtualMax !== max) {
		                this._virtualMin = min;
		                this._virtualMax = max;
		                this.update();
		            }
		        },
	
		        outOfBounds: function(offset) {
		            return offset > this.max || offset < this.min;
		        },
	
		        forceEnabled: function() {
		            this.forcedEnabled = true;
		        },
	
		        getSize: function() {
		            return this.container[0][this.measure];
		        },
	
		        getTotal: function() {
		            return this.element[0][this.scrollSize];
		        },
	
		        rescale: function(scale) {
		            this.scale = scale;
		        },
	
		        update: function(silent) {
		            var that = this,
		                total = that.virtual ? that._virtualMax : that.getTotal(),
		                scaledTotal = total * that.scale,
		                size = that.getSize();
	
		            if (total === 0 && !that.forcedEnabled) {
		                return; // we are not visible.
		            }
	
		            that.max = that.virtual ? -that._virtualMin : 0;
		            that.size = size;
		            that.total = scaledTotal;
		            that.min = Math.min(that.max, size - scaledTotal);
		            that.minScale = size / total;
		            that.centerOffset = (scaledTotal - size) / 2;
	
		            that.enabled = that.forcedEnabled || (scaledTotal > size);
	
		            if (!silent) {
		                that.trigger(CHANGE, that);
		            }
		        }
		    });
	
		    var PaneDimensions = Observable.extend({
		        init: function(options) {
		            var that = this;
	
		            Observable.fn.init.call(that);
	
		            that.x = new PaneDimension(extend({horizontal: true}, options));
		            that.y = new PaneDimension(extend({horizontal: false}, options));
		            that.container = options.container;
		            that.forcedMinScale = options.minScale;
		            that.maxScale = options.maxScale || 100;
	
		            that.bind(CHANGE, options);
		        },
	
		        rescale: function(newScale) {
		            this.x.rescale(newScale);
		            this.y.rescale(newScale);
		            this.refresh();
		        },
	
		        centerCoordinates: function() {
		            return { x: Math.min(0, -this.x.centerOffset), y: Math.min(0, -this.y.centerOffset) };
		        },
	
		        refresh: function() {
		            var that = this;
		            that.x.update();
		            that.y.update();
		            that.enabled = that.x.enabled || that.y.enabled;
		            that.minScale = that.forcedMinScale || Math.min(that.x.minScale, that.y.minScale);
		            that.fitScale = Math.max(that.x.minScale, that.y.minScale);
		            that.trigger(CHANGE);
		        }
		    });
	
		    var PaneAxis = Observable.extend({
		        init: function(options) {
		            var that = this;
		            extend(that, options);
		            Observable.fn.init.call(that);
		        },
	
		        outOfBounds: function() {
		            return this.dimension.outOfBounds(this.movable[this.axis]);
		        },
	
		        dragMove: function(delta) {
		            var that = this,
		                dimension = that.dimension,
		                axis = that.axis,
		                movable = that.movable,
		                position = movable[axis] + delta;
	
		            if (!dimension.enabled) {
		                return;
		            }
	
		            if ((position < dimension.min && delta < 0) || (position > dimension.max && delta > 0)) {
		                delta *= that.resistance;
		            }
	
		            movable.translateAxis(axis, delta);
		            that.trigger(CHANGE, that);
		        }
		    });
	
		    var Pane = Class.extend({
	
		        init: function(options) {
		            var that = this,
		                x,
		                y,
		                resistance,
		                movable;
	
		            extend(that, {elastic: true}, options);
	
		            resistance = that.elastic ? 0.5 : 0;
		            movable = that.movable;
	
		            that.x = x = new PaneAxis({
		                axis: "x",
		                dimension: that.dimensions.x,
		                resistance: resistance,
		                movable: movable
		            });
	
		            that.y = y = new PaneAxis({
		                axis: "y",
		                dimension: that.dimensions.y,
		                resistance: resistance,
		                movable: movable
		            });
	
		            that.userEvents.bind(["press", "move", "end", "gesturestart", "gesturechange"], {
		                gesturestart: function(e) {
		                    that.gesture = e;
		                    that.offset = that.dimensions.container.offset();
		                },
	
		                press: function(e) {
		                    if ($(e.event.target).closest("a").is("[data-navigate-on-press=true]")) {
		                        e.sender.cancel();
		                    }
		                },
	
		                gesturechange: function(e) {
		                    var previousGesture = that.gesture,
		                        previousCenter = previousGesture.center,
	
		                        center = e.center,
	
		                        scaleDelta = e.distance / previousGesture.distance,
	
		                        minScale = that.dimensions.minScale,
		                        maxScale = that.dimensions.maxScale,
		                        coordinates;
	
		                    if (movable.scale <= minScale && scaleDelta < 1) {
		                        // Resist shrinking. Instead of shrinking from 1 to 0.5, it will shrink to 0.5 + (1 /* minScale */ - 0.5) * 0.8 = 0.9;
		                        scaleDelta += (1 - scaleDelta) * 0.8;
		                    }
	
		                    if (movable.scale * scaleDelta >= maxScale) {
		                        scaleDelta = maxScale / movable.scale;
		                    }
	
		                    var offsetX = movable.x + that.offset.left,
		                        offsetY = movable.y + that.offset.top;
	
		                    coordinates = {
		                        x: (offsetX - previousCenter.x) * scaleDelta + center.x - offsetX,
		                        y: (offsetY - previousCenter.y) * scaleDelta + center.y - offsetY
		                    };
	
		                    movable.scaleWith(scaleDelta);
	
		                    x.dragMove(coordinates.x);
		                    y.dragMove(coordinates.y);
	
		                    that.dimensions.rescale(movable.scale);
		                    that.gesture = e;
		                    e.preventDefault();
		                },
	
		                move: function(e) {
		                    if (e.event.target.tagName.match(/textarea|input/i)) {
		                        return;
		                    }
	
		                    if (x.dimension.enabled || y.dimension.enabled) {
		                        x.dragMove(e.x.delta);
		                        y.dragMove(e.y.delta);
		                        e.preventDefault();
		                    } else {
		                        e.touch.skip();
		                    }
		                },
	
		                end: function(e) {
		                    e.preventDefault();
		                }
		            });
		        }
		    });
	
		    var TRANSFORM_STYLE = support.transitions.prefix + "Transform",
		        translate;
	
	
		    if (support.hasHW3D) {
		        translate = function(x, y, scale) {
		            return "translate3d(" + x + "px," + y +"px,0) scale(" + scale + ")";
		        };
		    } else {
		        translate = function(x, y, scale) {
		            return "translate(" + x + "px," + y +"px) scale(" + scale + ")";
		        };
		    }
	
		    var Movable = Observable.extend({
		        init: function(element) {
		            var that = this;
	
		            Observable.fn.init.call(that);
	
		            that.element = $(element);
		            that.element[0].style.webkitTransformOrigin = "left top";
		            that.x = 0;
		            that.y = 0;
		            that.scale = 1;
		            that._saveCoordinates(translate(that.x, that.y, that.scale));
		        },
	
		        translateAxis: function(axis, by) {
		            this[axis] += by;
		            this.refresh();
		        },
	
		        scaleTo: function(scale) {
		            this.scale = scale;
		            this.refresh();
		        },
	
		        scaleWith: function(scaleDelta) {
		            this.scale *= scaleDelta;
		            this.refresh();
		        },
	
		        translate: function(coordinates) {
		            this.x += coordinates.x;
		            this.y += coordinates.y;
		            this.refresh();
		        },
	
		        moveAxis: function(axis, value) {
		            this[axis] = value;
		            this.refresh();
		        },
	
		        moveTo: function(coordinates) {
		            extend(this, coordinates);
		            this.refresh();
		        },
	
		        refresh: function() {
		            var that = this,
		                x = that.x,
		                y = that.y,
		                newCoordinates;
	
		            if (that.round) {
		                x = Math.round(x);
		                y = Math.round(y);
		            }
	
		            newCoordinates = translate(x, y, that.scale);
	
		            if (newCoordinates != that.coordinates) {
		                if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
		                    that.element[0].style.position = "absolute";
		                    that.element[0].style.left = that.x + "px";
		                    that.element[0].style.top = that.y + "px";
	
		                } else {
		                    that.element[0].style[TRANSFORM_STYLE] = newCoordinates;
		                }
		                that._saveCoordinates(newCoordinates);
		                that.trigger(CHANGE);
		            }
		        },
	
		        _saveCoordinates: function(coordinates) {
		            this.coordinates = coordinates;
		        }
		    });
	
		    function destroyDroppable(collection, widget) {
		        var groupName = widget.options.group,
		        droppables = collection[groupName],
		        i;
	
		        Widget.fn.destroy.call(widget);
	
		        if (droppables.length > 1) {
		            for (i = 0; i < droppables.length; i++) {
		                if (droppables[i] == widget) {
		                    droppables.splice(i, 1);
		                    break;
		                }
		            }
		        } else {
		            droppables.length = 0; // WTF, porting this from the previous destroyGroup
		            delete collection[groupName];
		        }
		    }
	
		    var DropTarget = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            var group = that.options.group;
	
		            if (!(group in dropTargets)) {
		                dropTargets[group] = [ that ];
		            } else {
		                dropTargets[group].push( that );
		            }
		        },
	
		        events: [
		            DRAGENTER,
		            DRAGLEAVE,
		            DROP
		        ],
	
		        options: {
		            name: "DropTarget",
		            group: "default"
		        },
	
		        destroy: function() {
		            destroyDroppable(dropTargets, this);
		        },
	
		        _trigger: function(eventName, e) {
		            var that = this,
		                draggable = draggables[that.options.group];
	
		            if (draggable) {
		                return that.trigger(eventName, extend({}, e.event, {
		                           draggable: draggable,
		                           dropTarget: e.dropTarget
		                       }));
		            }
		        },
	
		        _over: function(e) {
		            this._trigger(DRAGENTER, e);
		        },
	
		        _out: function(e) {
		            this._trigger(DRAGLEAVE, e);
		        },
	
		        _drop: function(e) {
		            var that = this,
		                draggable = draggables[that.options.group];
	
		            if (draggable) {
		                draggable.dropped = !that._trigger(DROP, e);
		            }
		        }
		    });
	
		    DropTarget.destroyGroup = function(groupName) {
		        var group = dropTargets[groupName] || dropAreas[groupName],
		            i;
	
		        if (group) {
		            for (i = 0; i < group.length; i++) {
		                Widget.fn.destroy.call(group[i]);
		            }
	
		            group.length = 0;
		            delete dropTargets[groupName];
		            delete dropAreas[groupName];
		        }
		    };
	
		    DropTarget._cache = dropTargets;
	
		    var DropTargetArea = DropTarget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            var group = that.options.group;
	
		            if (!(group in dropAreas)) {
		                dropAreas[group] = [ that ];
		            } else {
		                dropAreas[group].push( that );
		            }
		        },
	
		        destroy: function() {
		            destroyDroppable(dropAreas, this);
		        },
	
		        options: {
		            name: "DropTargetArea",
		            group: "default",
		            filter: null
		        }
		    });
	
		    var Draggable = Widget.extend({
		        init: function (element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            that._activated = false;
	
		            that.userEvents = new UserEvents(that.element, {
		                global: true,
		                allowSelection: true,
		                filter: that.options.filter,
		                threshold: that.options.distance,
		                start: proxy(that._start, that),
		                hold: proxy(that._hold, that),
		                move: proxy(that._drag, that),
		                end: proxy(that._end, that),
		                cancel: proxy(that._cancel, that),
		                select: proxy(that._select, that)
		            });
	
		            that._afterEndHandler = proxy(that._afterEnd, that);
		            that._captureEscape = proxy(that._captureEscape, that);
		        },
	
		        events: [
		            HOLD,
		            DRAGSTART,
		            DRAG,
		            DRAGEND,
		            DRAGCANCEL,
		            HINTDESTROYED
		        ],
	
		        options: {
		            name: "Draggable",
		            distance: ( kendo.support.touch ? 0 : 5),
		            group: "default",
		            cursorOffset: null,
		            axis: null,
		            container: null,
		            filter: null,
		            ignore: null,
		            holdToDrag: false,
		            autoScroll: false,
		            dropped: false
		        },
	
		        cancelHold: function() {
		            this._activated = false;
		        },
	
		        _captureEscape: function(e) {
		            var that = this;
	
		            if (e.keyCode === kendo.keys.ESC) {
		                that._trigger(DRAGCANCEL, { event: e });
		                that.userEvents.cancel();
		            }
		        },
	
		        _updateHint: function(e) {
		            var that = this,
		                coordinates,
		                options = that.options,
		                boundaries = that.boundaries,
		                axis = options.axis,
		                cursorOffset = that.options.cursorOffset;
	
		            if (cursorOffset) {
		               coordinates = { left: e.x.location + cursorOffset.left, top: e.y.location + cursorOffset.top };
		            } else {
		                that.hintOffset.left += e.x.delta;
		                that.hintOffset.top += e.y.delta;
		                coordinates = $.extend({}, that.hintOffset);
		            }
	
		            if (boundaries) {
		                coordinates.top = within(coordinates.top, boundaries.y);
		                coordinates.left = within(coordinates.left, boundaries.x);
		            }
	
		            if (axis === "x") {
		                delete coordinates.top;
		            } else if (axis === "y") {
		                delete coordinates.left;
		            }
	
		            that.hint.css(coordinates);
		        },
	
		        _shouldIgnoreTarget: function(target) {
		            var ignoreSelector = this.options.ignore;
		            return ignoreSelector && $(target).is(ignoreSelector);
		        },
	
		        _select: function(e) {
		            if (!this._shouldIgnoreTarget(e.event.target)) {
		                e.preventDefault();
		            }
		        },
	
		        _start: function(e) {
		            var that = this,
		                options = that.options,
		                container = options.container ? $(options.container): null,
		                hint = options.hint;
	
		            if (this._shouldIgnoreTarget(e.touch.initialTouch) || (options.holdToDrag && !that._activated)) {
		                that.userEvents.cancel();
		                return;
		            }
	
		            that.currentTarget = e.target;
		            that.currentTargetOffset = getOffset(that.currentTarget);
	
		            if (hint) {
		                if (that.hint) {
		                    that.hint.stop(true, true).remove();
		                }
	
		                that.hint = kendo.isFunction(hint) ? $(hint.call(that, that.currentTarget)) : hint;
	
		                var offset = getOffset(that.currentTarget);
		                that.hintOffset = offset;
	
		                that.hint.css( {
		                    position: "absolute",
		                    zIndex: 20000, // the Window's z-index is 10000 and can be raised because of z-stacking
		                    left: offset.left,
		                    top: offset.top
		                })
		                .appendTo(document.body);
	
		                that.angular("compile", function(){
		                    that.hint.removeAttr("ng-repeat");
		                    var scopeTarget = $(e.target);
	
		                    while (!scopeTarget.data("$$kendoScope") && scopeTarget.length) {
		                        scopeTarget = scopeTarget.parent();
		                    }
	
		                    return {
		                        elements: that.hint.get(),
		                        scopeFrom: scopeTarget.data("$$kendoScope")
		                    };
		                });
		            }
	
		            draggables[options.group] = that;
	
		            that.dropped = false;
	
		            if (container) {
		                that.boundaries = containerBoundaries(container, that.hint);
		            }
	
		            $(document).on(KEYUP, that._captureEscape);
	
		            if (that._trigger(DRAGSTART, e)) {
		                that.userEvents.cancel();
		                that._afterEnd();
		            }
	
		            that.userEvents.capture();
		        },
	
		        _hold: function(e) {
		            this.currentTarget = e.target;
	
		            if (this._trigger(HOLD, e)) {
		                this.userEvents.cancel();
		            } else {
		                this._activated = true;
		            }
		        },
	
		        _drag: function(e) {
		            e.preventDefault();
	
		            var cursorElement = this._elementUnderCursor(e);
	
		            if (this.options.autoScroll && this._cursorElement !== cursorElement) {
		                this._scrollableParent = findScrollableParent(cursorElement);
		                this._cursorElement = cursorElement;
		            }
	
		            this._lastEvent = e;
		            this._processMovement(e, cursorElement);
	
		            if (this.options.autoScroll) {
		                // chrome seems to trigger mousemove when mouse is moved outside of the window (over the Chrome), too.
		                if (this._scrollableParent[0]) {
		                    var velocity = autoScrollVelocity(e.x.location, e.y.location, scrollableViewPort(this._scrollableParent));
	
	
		                    this._scrollCompenstation = $.extend({}, this.hintOffset);
		                    this._scrollVelocity = velocity;
	
		                    if (velocity.y === 0 && velocity.x === 0) {
		                        clearInterval(this._scrollInterval);
		                        this._scrollInterval = null;
		                    } else if(!this._scrollInterval) {
		                        this._scrollInterval = setInterval($.proxy(this, "_autoScroll"), 50);
		                    }
		                }
		            }
	
		            if (this.hint) {
		                this._updateHint(e);
		            }
		        },
	
		        _processMovement: function(e, cursorElement) {
		            this._withDropTarget(cursorElement, function(target, targetElement) {
		                if (!target) {
		                    if (lastDropTarget) {
		                        lastDropTarget._trigger(DRAGLEAVE, extend(e, { dropTarget: $(lastDropTarget.targetElement) }));
		                        lastDropTarget = null;
		                    }
		                    return;
		                }
	
		                if (lastDropTarget) {
		                    if (targetElement === lastDropTarget.targetElement) {
		                        return;
		                    }
	
		                    lastDropTarget._trigger(DRAGLEAVE, extend(e, { dropTarget: $(lastDropTarget.targetElement) }));
		                }
	
		                target._trigger(DRAGENTER, extend(e, { dropTarget: $(targetElement) }));
		                lastDropTarget = extend(target, { targetElement: targetElement });
		            });
	
		            this._trigger(DRAG, extend(e, { dropTarget: lastDropTarget, elementUnderCursor: cursorElement }));
		        },
	
		        _autoScroll: function() {
		            var parent = this._scrollableParent[0],
		                velocity = this._scrollVelocity,
		                compensation = this._scrollCompenstation;
	
		            if (!parent) {
		                return;
		            }
	
		            var cursorElement = this._elementUnderCursor(this._lastEvent);
		            this._processMovement(this._lastEvent, cursorElement);
	
		            var yIsScrollable, xIsScrollable;
	
		            var isRootNode = parent === scrollableRoot()[0];
	
		            if (isRootNode) {
		                yIsScrollable = document.body.scrollHeight > $window.height();
		                xIsScrollable = document.body.scrollWidth > $window.width();
		            } else {
		                yIsScrollable = parent.offsetHeight <= parent.scrollHeight;
		                xIsScrollable = parent.offsetWidth <= parent.scrollWidth;
		            }
	
		            var yDelta = parent.scrollTop + velocity.y;
		            var yInBounds = yIsScrollable && yDelta > 0 && yDelta < parent.scrollHeight;
	
		            var xDelta = parent.scrollLeft + velocity.x;
		            var xInBounds = xIsScrollable && xDelta > 0 && xDelta < parent.scrollWidth;
	
		            if (yInBounds) {
		                parent.scrollTop += velocity.y;
		            }
	
		            if (xInBounds) {
		                parent.scrollLeft += velocity.x;
		            }
	
		            if (this.hint && isRootNode && (xInBounds || yInBounds)) {
		                if (yInBounds) {
		                    compensation.top += velocity.y;
		                }
	
		                if (xInBounds) {
		                    compensation.left += velocity.x;
		                }
	
		                this.hint.css(compensation);
		            }
		        },
	
		        _end: function(e) {
		            this._withDropTarget(this._elementUnderCursor(e), function(target, targetElement) {
		                if (target) {
		                    target._drop(extend({}, e, { dropTarget: $(targetElement) }));
		                    lastDropTarget = null;
		                }
		            });
	
		            this._cancel(this._trigger(DRAGEND, e));
		        },
	
		        _cancel: function(isDefaultPrevented) {
		            var that = this;
	
		            that._scrollableParent = null;
		            this._cursorElement = null;
		            clearInterval(this._scrollInterval);
		            that._activated = false;
	
		            if (that.hint && !that.dropped) {
		                setTimeout(function() {
		                    that.hint.stop(true, true);
	
		                    if (isDefaultPrevented) {
		                        that._afterEndHandler();
		                    } else {
		                        that.hint.animate(that.currentTargetOffset, "fast", that._afterEndHandler);
		                    }
		                }, 0);
	
		            } else {
		                that._afterEnd();
		            }
		        },
	
		        _trigger: function(eventName, e) {
		            var that = this;
	
		            return that.trigger(
		                eventName, extend(
		                {},
		                e.event,
		                {
		                    x: e.x,
		                    y: e.y,
		                    currentTarget: that.currentTarget,
		                    initialTarget: e.touch ? e.touch.initialTouch : null,
		                    dropTarget: e.dropTarget,
		                    elementUnderCursor: e.elementUnderCursor
		                }
		            ));
		        },
	
		        _elementUnderCursor: function(e) {
		            var target = elementUnderCursor(e),
		                hint = this.hint;
	
		            if (hint && contains(hint[0], target)) {
		                hint.hide();
		                target = elementUnderCursor(e);
		                // IE8 does not return the element in iframe from first attempt
		                if (!target) {
		                    target = elementUnderCursor(e);
		                }
		                hint.show();
		            }
	
		            return target;
		        },
	
		        _withDropTarget: function(element, callback) {
		            var result,
		                group = this.options.group,
		                targets = dropTargets[group],
		                areas = dropAreas[group];
	
		            if (targets && targets.length || areas && areas.length) {
		                result = checkTarget(element, targets, areas);
	
		                if (result) {
		                    callback(result.target, result.targetElement);
		                } else {
		                    callback();
		                }
		            }
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that._afterEnd();
	
		            that.userEvents.destroy();
	
		            this._scrollableParent = null;
		            this._cursorElement = null;
		            clearInterval(this._scrollInterval);
	
		            that.currentTarget = null;
		        },
	
		        _afterEnd: function() {
		            var that = this;
	
		            if (that.hint) {
		                that.hint.remove();
		            }
	
		            delete draggables[that.options.group];
	
		            that.trigger("destroy");
		            that.trigger(HINTDESTROYED);
		            $(document).off(KEYUP, that._captureEscape);
		        }
		    });
	
		    kendo.ui.plugin(DropTarget);
		    kendo.ui.plugin(DropTargetArea);
		    kendo.ui.plugin(Draggable);
		    kendo.TapCapture = TapCapture;
		    kendo.containerBoundaries = containerBoundaries;
	
		    extend(kendo.ui, {
		        Pane: Pane,
		        PaneDimensions: PaneDimensions,
		        Movable: Movable
		    });
	
		    function scrollableViewPort(element) {
		        var root = scrollableRoot()[0],
		            offset,
		            top,
		            left;
	
		        if (element[0] === root) {
		            top = root.scrollTop;
		            left = root.scrollLeft;
	
		            return {
		                top: top,
		                left: left,
		                bottom: top + $window.height(),
		                right: left + $window.width()
		            };
		        } else {
		            offset = element.offset();
		            offset.bottom = offset.top + element.height();
		            offset.right =  offset.left + element.width();
		            return offset;
		        }
		    }
	
		    function scrollableRoot() {
		        return $(kendo.support.browser.edge || kendo.support.browser.safari ? document.body : document.documentElement);
		    }
	
		    function findScrollableParent(element) {
		        var root = scrollableRoot();
	
		        if (!element || element === document.body || element === document.documentElement) {
		            return root;
		        }
	
		        var parent = $(element)[0];
	
		        while (parent && !kendo.isScrollable(parent) && parent !== document.body) {
		            parent = parent.parentNode;
		        }
	
		        if (parent === document.body) {
		            return root;
		        }
	
		        return $(parent);
		    }
	
		    function autoScrollVelocity(mouseX, mouseY, rect) {
		        var velocity = { x: 0, y: 0 };
	
		        var AUTO_SCROLL_AREA = 50;
	
		        if (mouseX - rect.left < AUTO_SCROLL_AREA) {
		            velocity.x = -(AUTO_SCROLL_AREA - (mouseX - rect.left));
		        } else if (rect.right - mouseX < AUTO_SCROLL_AREA) {
		            velocity.x = AUTO_SCROLL_AREA - (rect.right - mouseX);
		        }
	
		        if (mouseY - rect.top < AUTO_SCROLL_AREA) {
		            velocity.y = -(AUTO_SCROLL_AREA - (mouseY - rect.top));
		        } else if (rect.bottom - mouseY < AUTO_SCROLL_AREA) {
		            velocity.y = AUTO_SCROLL_AREA - (rect.bottom - mouseY);
		        }
	
		        return velocity;
		    }
	
		    // export for testing
		    kendo.ui.Draggable.utils = {
		        autoScrollVelocity: autoScrollVelocity,
		        scrollableViewPort: scrollableViewPort,
		        findScrollableParent: findScrollableParent
		    };
	
		 })(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1350);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1350:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "userevents",
		    name: "User Events",
		    category: "framework",
		    depends: [ "core" ],
		    hidden: true
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        support = kendo.support,
		        Class = kendo.Class,
		        Observable = kendo.Observable,
		        now = $.now,
		        extend = $.extend,
		        OS = support.mobileOS,
		        invalidZeroEvents = OS && OS.android,
		        DEFAULT_MIN_HOLD = 800,
		        CLICK_DELAY = 300,
		        DEFAULT_THRESHOLD = support.browser.msie ? 5 : 0, // WP8 and W8 are very sensitive and always report move.
	
		        // UserEvents events
		        PRESS = "press",
		        HOLD = "hold",
		        SELECT = "select",
		        START = "start",
		        MOVE = "move",
		        END = "end",
		        CANCEL = "cancel",
		        TAP = "tap",
		        DOUBLETAP = "doubleTap",
		        RELEASE = "release",
		        GESTURESTART = "gesturestart",
		        GESTURECHANGE = "gesturechange",
		        GESTUREEND = "gestureend",
		        GESTURETAP = "gesturetap";
	
		    var THRESHOLD = {
		        "api": 0,
		        "touch": 0,
		        "mouse": 9,
		        "pointer": 9
		    };
	
		    var ENABLE_GLOBAL_SURFACE = (!support.touch || support.mouseAndTouchPresent);
	
		    function touchDelta(touch1, touch2) {
		        var x1 = touch1.x.location,
		            y1 = touch1.y.location,
		            x2 = touch2.x.location,
		            y2 = touch2.y.location,
		            dx = x1 - x2,
		            dy = y1 - y2;
	
		        return {
		            center: {
		               x: (x1 + x2) / 2,
		               y: (y1 + y2) / 2
		            },
	
		            distance: Math.sqrt(dx*dx + dy*dy)
		        };
		    }
	
		    function getTouches(e) {
		        var touches = [],
		            originalEvent = e.originalEvent,
		            currentTarget = e.currentTarget,
		            idx = 0, length,
		            changedTouches,
		            touch;
	
		        if (e.api) {
		            touches.push({
		                id: 2,  // hardcoded ID for API call;
		                event: e,
		                target: e.target,
		                currentTarget: e.target,
		                location: e,
		                type: "api"
		            });
		        }
		        else if (e.type.match(/touch/)) {
		            changedTouches = originalEvent ? originalEvent.changedTouches : [];
		            for (length = changedTouches.length; idx < length; idx ++) {
		                touch = changedTouches[idx];
		                touches.push({
		                    location: touch,
		                    event: e,
		                    target: touch.target,
		                    currentTarget: currentTarget,
		                    id: touch.identifier,
		                    type: "touch"
		                });
		            }
		        }
		        else if (support.pointers || support.msPointers) {
		            touches.push({
		                location: originalEvent,
		                event: e,
		                target: e.target,
		                currentTarget: currentTarget,
		                id: originalEvent.pointerId,
		                type: "pointer"
		            });
		        } else {
		            touches.push({
		                id: 1, // hardcoded ID for mouse event;
		                event: e,
		                target: e.target,
		                currentTarget: currentTarget,
		                location: e,
		                type: "mouse"
		            });
		        }
	
		        return touches;
		    }
	
		    var TouchAxis = Class.extend({
		        init: function(axis, location) {
		            var that = this;
	
		            that.axis = axis;
	
		            that._updateLocationData(location);
	
		            that.startLocation = that.location;
		            that.velocity = that.delta = 0;
		            that.timeStamp = now();
		        },
	
		        move: function(location) {
		            var that = this,
		                offset = location["page" + that.axis],
		                timeStamp = now(),
		                timeDelta = (timeStamp - that.timeStamp) || 1; // Firing manually events in tests can make this 0;
	
		            if (!offset && invalidZeroEvents) {
		                return;
		            }
	
		            that.delta = offset - that.location;
	
		            that._updateLocationData(location);
	
		            that.initialDelta = offset - that.startLocation;
		            that.velocity = that.delta / timeDelta;
		            that.timeStamp = timeStamp;
		        },
	
		        _updateLocationData: function(location) {
		            var that = this, axis = that.axis;
	
		            that.location = location["page" + axis];
		            that.client = location["client" + axis];
		            that.screen = location["screen" + axis];
		        }
		    });
	
		    var Touch = Class.extend({
		        init: function(userEvents, target, touchInfo) {
		            extend(this, {
		                x: new TouchAxis("X", touchInfo.location),
		                y: new TouchAxis("Y", touchInfo.location),
		                type: touchInfo.type,
		                useClickAsTap: userEvents.useClickAsTap,
		                threshold: userEvents.threshold || THRESHOLD[touchInfo.type],
		                userEvents: userEvents,
		                target: target,
		                currentTarget: touchInfo.currentTarget,
		                initialTouch: touchInfo.target,
		                id: touchInfo.id,
		                pressEvent: touchInfo,
		                _clicks: userEvents._clicks,
		                supportDoubleTap: userEvents.supportDoubleTap,
		                _moved: false,
		                _finished: false
		            });
		        },
	
		        press: function() {
		            this._holdTimeout = setTimeout($.proxy(this, "_hold"), this.userEvents.minHold);
		            this._trigger(PRESS, this.pressEvent);
		        },
	
		        _tap: function(touchInfo) {
		            var that = this;
		            that.userEvents._clicks++;
		            if (that.userEvents._clicks == 1) {
		                that._clickTimeout = setTimeout(function() {
		                    if (that.userEvents._clicks == 1) {
		                        that._trigger(TAP, touchInfo);
		                    }
		                    else {
		                        that._trigger(DOUBLETAP, touchInfo);
		                    }
		                    that.userEvents._clicks = 0;
		                }, CLICK_DELAY);
		            }
		        },
	
		        _hold: function() {
		            this._trigger(HOLD, this.pressEvent);
		        },
	
		        move: function(touchInfo) {
		            var that = this;
	
		            if (that._finished) { return; }
	
		            that.x.move(touchInfo.location);
		            that.y.move(touchInfo.location);
	
		            if (!that._moved) {
		                if (that._withinIgnoreThreshold()) {
		                    return;
		                }
	
		                if (!UserEvents.current || UserEvents.current === that.userEvents) {
		                    that._start(touchInfo);
		                } else {
		                    return that.dispose();
		                }
		            }
	
		            // Event handlers may cancel the drag in the START event handler, hence the double check for pressed.
		            if (!that._finished) {
		                that._trigger(MOVE, touchInfo);
		            }
		        },
	
		        end: function(touchInfo) {
		            this.endTime = now();
	
		            if (this._finished) { return; }
	
		            // Mark the object as finished if there are blocking operations in the event handlers (alert/confirm)
		            this._finished = true;
	
		            this._trigger(RELEASE, touchInfo); // Release should be fired before TAP (as click is after mouseup/touchend)
	
		            if (this._moved) {
		                this._trigger(END, touchInfo);
		            } else {
		                if (!this.useClickAsTap) {
		                    if (this.supportDoubleTap) {
		                        this._tap(touchInfo);
		                    }
		                    else {
		                        this._trigger(TAP, touchInfo);
		                    }
		                }
		            }
	
		            clearTimeout(this._holdTimeout);
	
		            this.dispose();
		        },
	
		        dispose: function() {
		            var userEvents = this.userEvents,
		                activeTouches = userEvents.touches;
	
		            this._finished = true;
		            this.pressEvent = null;
		            clearTimeout(this._holdTimeout);
	
		            activeTouches.splice($.inArray(this, activeTouches), 1);
		        },
	
		        skip: function() {
		            this.dispose();
		        },
	
		        cancel: function() {
		            this.dispose();
		        },
	
		        isMoved: function() {
		            return this._moved;
		        },
	
		        _start: function(touchInfo) {
		            clearTimeout(this._holdTimeout);
	
		            this.startTime = now();
		            this._moved = true;
		            this._trigger(START, touchInfo);
		        },
	
		        _trigger: function(name, touchInfo) {
		            var that = this,
		                jQueryEvent = touchInfo.event,
		                data = {
		                    touch: that,
		                    x: that.x,
		                    y: that.y,
		                    target: that.target,
		                    event: jQueryEvent
		                };
	
		            if(that.userEvents.notify(name, data)) {
		                jQueryEvent.preventDefault();
		            }
		        },
	
		        _withinIgnoreThreshold: function() {
		            var xDelta = this.x.initialDelta,
		                yDelta = this.y.initialDelta;
	
		            return Math.sqrt(xDelta * xDelta + yDelta * yDelta) <= this.threshold;
		        }
		    });
	
		    function withEachUpEvent(callback) {
		        var downEvents = kendo.eventMap.up.split(" "),
		            idx = 0,
		            length = downEvents.length;
	
		        for(; idx < length; idx ++) {
		            callback(downEvents[idx]);
		        }
		    }
	
		    var UserEvents = Observable.extend({
		        init: function(element, options) {
		            var that = this,
		                filter,
		                ns = kendo.guid();
	
		            options = options || {};
		            filter = that.filter = options.filter;
		            that.threshold = options.threshold || DEFAULT_THRESHOLD;
		            that.minHold = options.minHold || DEFAULT_MIN_HOLD;
		            that.touches = [];
		            that._maxTouches = options.multiTouch ? 2 : 1;
		            that.allowSelection = options.allowSelection;
		            that.captureUpIfMoved = options.captureUpIfMoved;
		            that.useClickAsTap = !options.fastTap && !support.delayedClick();
		            that.eventNS = ns;
		            that._clicks = 0;
		            that.supportDoubleTap = options.supportDoubleTap;
	
		            element = $(element).handler(that);
		            Observable.fn.init.call(that);
	
		            extend(that, {
		                element: element,
		                // the touch events lock to the element anyway, so no need for the global setting
		                surface: options.global && ENABLE_GLOBAL_SURFACE ? $(element[0].ownerDocument.documentElement) : $(options.surface || element),
		                stopPropagation: options.stopPropagation,
		                pressed: false
		            });
	
		            that.surface.handler(that)
		                .on(kendo.applyEventMap("move", ns), "_move")
		                .on(kendo.applyEventMap("up cancel", ns), "_end");
	
		            element.on(kendo.applyEventMap("down", ns), filter, "_start");
	
		            if (that.useClickAsTap) {
		                element.on(kendo.applyEventMap("click", ns), filter, "_click");
		            }
	
		            if (support.pointers || support.msPointers) {
		                //touch-action:none will not work for IE10
		                if (support.browser.version < 11) {
		                    var defaultAction = "pinch-zoom double-tap-zoom";
		                    element.css("-ms-touch-action", options.touchAction && options.touchAction != "none" ? defaultAction + " " + options.touchAction : defaultAction);
		                } else {
		                    element.css("touch-action", options.touchAction || "none");
		                }
		            }
	
		            if (options.preventDragEvent) {
		                element.on(kendo.applyEventMap("dragstart", ns), kendo.preventDefault);
		            }
	
		            element.on(kendo.applyEventMap("mousedown", ns), filter, { root: element }, "_select");
	
		            if (that.captureUpIfMoved && support.eventCapture) {
		                var surfaceElement = that.surface[0],
		                    preventIfMovingProxy = $.proxy(that.preventIfMoving, that);
	
		                withEachUpEvent(function(eventName) {
		                    surfaceElement.addEventListener(eventName, preventIfMovingProxy, true);
		                });
		            }
	
		            that.bind([
		            PRESS,
		            HOLD,
		            TAP,
		            DOUBLETAP,
		            START,
		            MOVE,
		            END,
		            RELEASE,
		            CANCEL,
		            GESTURESTART,
		            GESTURECHANGE,
		            GESTUREEND,
		            GESTURETAP,
		            SELECT
		            ], options);
		        },
	
		        preventIfMoving: function(e) {
		            if (this._isMoved()) {
		                e.preventDefault();
		            }
		        },
	
		        destroy: function() {
		            var that = this;
	
		            if (that._destroyed) {
		                return;
		            }
	
		            that._destroyed = true;
	
		            if (that.captureUpIfMoved && support.eventCapture) {
		                var surfaceElement = that.surface[0];
		                withEachUpEvent(function(eventName) {
		                    surfaceElement.removeEventListener(eventName, that.preventIfMoving);
		                });
		            }
	
		            that.element.kendoDestroy(that.eventNS);
		            that.surface.kendoDestroy(that.eventNS);
		            that.element.removeData("handler");
		            that.surface.removeData("handler");
		            that._disposeAll();
	
		            that.unbind();
		            delete that.surface;
		            delete that.element;
		            delete that.currentTarget;
		        },
	
		        capture: function() {
		            UserEvents.current = this;
		        },
	
		        cancel: function() {
		            this._disposeAll();
		            this.trigger(CANCEL);
		        },
	
		        notify: function(eventName, data) {
		            var that = this,
		                touches = that.touches;
	
		            if (this._isMultiTouch()) {
		                switch(eventName) {
		                    case MOVE:
		                        eventName = GESTURECHANGE;
		                        break;
		                    case END:
		                        eventName = GESTUREEND;
		                        break;
		                    case TAP:
		                        eventName = GESTURETAP;
		                        break;
		                }
	
		                extend(data, {touches: touches}, touchDelta(touches[0], touches[1]));
		            }
	
		            return this.trigger(eventName, extend(data, {type: eventName}));
		        },
	
		        // API
		        press: function(x, y, target) {
		            this._apiCall("_start", x, y, target);
		        },
	
		        move: function(x, y) {
		            this._apiCall("_move", x, y);
		        },
	
		        end: function(x, y) {
		            this._apiCall("_end", x, y);
		        },
	
		        _isMultiTouch: function() {
		            return this.touches.length > 1;
		        },
	
		        _maxTouchesReached: function() {
		            return this.touches.length >= this._maxTouches;
		        },
	
		        _disposeAll: function() {
		            var touches = this.touches;
		            while (touches.length > 0) {
		                touches.pop().dispose();
		            }
		        },
	
		        _isMoved: function() {
		            return $.grep(this.touches, function(touch) {
		                return touch.isMoved();
		            }).length;
		        },
	
		        _select: function(e) {
		           if (!this.allowSelection || this.trigger(SELECT, { event: e })) {
		               e.preventDefault();
		           }
		        },
	
		        _start: function(e) {
		            var that = this,
		                idx = 0,
		                filter = that.filter,
		                target,
		                touches = getTouches(e),
		                length = touches.length,
		                touch,
		                which = e.which;
	
		            if ((which && which > 1) || (that._maxTouchesReached())){
		                return;
		            }
	
		            UserEvents.current = null;
	
		            that.currentTarget = e.currentTarget;
	
		            if (that.stopPropagation) {
		                e.stopPropagation();
		            }
	
		            for (; idx < length; idx ++) {
		                if (that._maxTouchesReached()) {
		                    break;
		                }
	
		                touch = touches[idx];
	
		                if (filter) {
		                    target = $(touch.currentTarget); // target.is(filter) ? target : target.closest(filter, that.element);
		                } else {
		                    target = that.element;
		                }
	
		                if (!target.length) {
		                    continue;
		                }
	
		                touch = new Touch(that, target, touch);
		                that.touches.push(touch);
		                touch.press();
	
		                if (that._isMultiTouch()) {
		                    that.notify("gesturestart", {});
		                }
		            }
		        },
	
		        _move: function(e) {
		            this._eachTouch("move", e);
		        },
	
		        _end: function(e) {
		            this._eachTouch("end", e);
		        },
	
		        _click: function(e) {
		            var data = {
		                touch: {
		                    initialTouch: e.target,
		                    target: $(e.currentTarget),
		                    endTime: now(),
		                    x: {
		                        location: e.pageX,
		                        client: e.clientX
		                    },
		                    y: {
		                        location: e.pageY,
		                        client: e.clientY
		                    }
		                },
		                x: e.pageX,
		                y: e.pageY,
		                target: $(e.currentTarget),
		                event: e,
		                type: "tap"
		            };
	
		            if (this.trigger("tap", data)) {
		                e.preventDefault();
		            }
		        },
	
		        _eachTouch: function(methodName, e) {
		            var that = this,
		                dict = {},
		                touches = getTouches(e),
		                activeTouches = that.touches,
		                idx,
		                touch,
		                touchInfo,
		                matchingTouch;
	
		            for (idx = 0; idx < activeTouches.length; idx ++) {
		                touch = activeTouches[idx];
		                dict[touch.id] = touch;
		            }
	
		            for (idx = 0; idx < touches.length; idx ++) {
		                touchInfo = touches[idx];
		                matchingTouch = dict[touchInfo.id];
	
		                if (matchingTouch) {
		                    matchingTouch[methodName](touchInfo);
		                }
		            }
		        },
	
		        _apiCall: function(type, x, y, target) {
		            this[type]({
		                api: true,
		                pageX: x,
		                pageY: y,
		                clientX: x,
		                clientY: y,
		                target: $(target || this.element)[0],
		                stopPropagation: $.noop,
		                preventDefault: $.noop
		            });
		        }
		    });
	
		    UserEvents.defaultThreshold = function(value) {
		        DEFAULT_THRESHOLD = value;
		    };
	
		    UserEvents.minHold = function(value) {
		        DEFAULT_MIN_HOLD = value;
		    };
	
		    kendo.getTouches = getTouches;
		    kendo.touchDelta = touchDelta;
		    kendo.UserEvents = UserEvents;
		 })(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1353);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1353:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "virtuallist",
		    name: "VirtualList",
		    category: "framework",
		    depends: [ "data" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        DataBoundWidget = ui.DataBoundWidget,
		        proxy = $.proxy,
		        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
		        WRAPPER = "k-virtual-wrap",
		        VIRTUALLIST = "k-virtual-list",
		        CONTENT = "k-virtual-content",
		        LIST = "k-list",
		        HEADER = "k-group-header",
		        VIRTUALITEM = "k-virtual-item",
		        ITEM = "k-item",
		        HEIGHTCONTAINER = "k-height-container",
		        GROUPITEM = "k-group",
	
		        SELECTED = "k-state-selected",
		        FOCUSED = "k-state-focused",
		        HOVER = "k-state-hover",
		        CHANGE = "change",
		        CLICK = "click",
		        LISTBOUND = "listBound",
		        ITEMCHANGE = "itemChange",
	
		        ACTIVATE = "activate",
		        DEACTIVATE = "deactivate",
	
		        VIRTUAL_LIST_NS = ".VirtualList";
	
		    function lastFrom(array) {
		        return array[array.length - 1];
		    }
	
		    function toArray(value) {
		        return value instanceof Array ? value : [value];
		    }
	
		    function isPrimitive(dataItem) {
		        return typeof dataItem === "string" || typeof dataItem === "number" || typeof dataItem === "boolean";
		    }
	
		    function getItemCount(screenHeight, listScreens, itemHeight) {
		        return Math.ceil(screenHeight * listScreens / itemHeight);
		    }
	
		    function appendChild(parent, className, tagName) {
		        var element = document.createElement(tagName || "div");
		        if (className) {
		            element.className = className;
		        }
		        parent.appendChild(element);
	
		        return element;
		    }
	
		    function getDefaultItemHeight() {
		        var mockList = $('<div class="k-popup"><ul class="k-list"><li class="k-item"><li></ul></div>'),
		            lineHeight;
		        mockList.css({
		            position: "absolute",
		            left: "-200000px",
		            visibility: "hidden"
		        });
		        mockList.appendTo(document.body);
		        lineHeight = parseFloat(kendo.getComputedStyles(mockList.find(".k-item")[0], ["line-height"])["line-height"]);
		        mockList.remove();
	
		        return lineHeight;
		    }
	
		    function bufferSizes(screenHeight, listScreens, opposite) { //in pixels
		        return {
		            down: screenHeight * opposite,
		            up: screenHeight * (listScreens - 1 - opposite)
		        };
		    }
	
		    function listValidator(options, screenHeight) {
		        var downThreshold = (options.listScreens - 1 - options.threshold) * screenHeight;
		        var upThreshold = options.threshold * screenHeight;
	
		        return function(list, scrollTop, lastScrollTop) {
		            if (scrollTop > lastScrollTop) {
		                return scrollTop - list.top < downThreshold;
		            } else {
		                return list.top === 0 || scrollTop - list.top > upThreshold;
		            }
		        };
		    }
	
		    function scrollCallback(element, callback) {
		        return function(force) {
		            return callback(element.scrollTop, force);
		        };
		    }
	
		    function syncList(reorder) {
		        return function(list, force) {
		            reorder(list.items, list.index, force);
		            return list;
		        };
		    }
	
		    function position(element, y) {
		        if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
		            element.style.top = y + "px";
		        } else {
		            element.style.webkitTransform = 'translateY(' + y + "px)";
		            element.style.transform = 'translateY(' + y + "px)";
		        }
		    }
	
		    function map2(callback, templates) {
		        return function(arr1, arr2) {
		            for (var i = 0, len = arr1.length; i < len; i++) {
		                callback(arr1[i], arr2[i], templates);
		                if (arr2[i].item) {
		                    this.trigger(ITEMCHANGE, { item: $(arr1[i]), data: arr2[i].item, ns: kendo.ui });
		                }
		            }
		        };
		    }
	
		    function reshift(items, diff) {
		        var range;
	
		        if (diff > 0) { // down
		            range = items.splice(0, diff);
		            items.push.apply(items, range);
		        } else { // up
		            range = items.splice(diff, -diff);
		            items.unshift.apply(items, range);
		        }
	
		        return range;
		    }
	
		    function render(element, data, templates) {
		        var itemTemplate = templates.template;
	
		        element = $(element);
	
		        if (!data.item) {
		            itemTemplate = templates.placeholderTemplate;
		        }
	
		         if (data.index === 0 && this.header && data.group) {
		             this.header.html(templates.fixedGroupTemplate(data.group));
		         }
	
		        this.angular("cleanup", function() {
		            return { elements: [ element ]};
		        });
	
		        element
		            .attr("data-uid", data.item ? data.item.uid : "")
		            .attr("data-offset-index", data.index);
	
		         if (this.options.columns && this.options.columns.length && data.item) {
		            element.html(renderColumns(this.options, data.item, templates));
		        } else {
		            element.html(itemTemplate(data.item || {}));
		        }
	
		        element.toggleClass(FOCUSED, data.current);
		        element.toggleClass(SELECTED, data.selected);
		        element.toggleClass("k-first", data.newGroup);
		        element.toggleClass("k-last", data.isLastGroupedItem);
		        element.toggleClass("k-loading-item", !data.item);
	
		        if (data.index !== 0 && data.newGroup) {
		            $("<div class=" + GROUPITEM + "></div>")
		                .appendTo(element)
		                .html(templates.groupTemplate(data.group));
		        }
	
		        if (data.top !== undefined) {
		            position(element[0], data.top);
		        }
	
		        this.angular("compile", function() {
		            return { elements: [ element ], data: [ { dataItem: data.item, group: data.group, newGroup: data.newGroup } ]};
		        });
		    }
	
		    function renderColumns(options, dataItem, templates) {
		        var item = "";
	
		        for (var i = 0; i < options.columns.length; i++) {
		            var currentWidth = options.columns[i].width;
		            var currentWidthInt = parseInt(currentWidth, 10);
		            var widthStyle = '';
	
		            if(currentWidth){
		                widthStyle += "style='width:";
		                widthStyle += currentWidthInt;
		                widthStyle += percentageUnitsRegex.test(currentWidth) ? "%" : "px";
		                widthStyle += ";'";
		            }
		            item += "<span class='k-cell' " + widthStyle + ">";
		            item += templates["column"+ i](dataItem);
		            item += "</span>";
		        }
	
		        return item;
		    }
	
		    function mapChangedItems(selected, itemsToMatch) {
		        var itemsLength = itemsToMatch.length;
		        var selectedLength = selected.length;
		        var dataItem;
		        var found;
		        var i, j;
	
		        var changed = [];
		        var unchanged = [];
	
		        if (selectedLength) {
		            for (i = 0; i < selectedLength; i++) {
		                dataItem = selected[i];
		                found = false;
	
		                for (j = 0; j < itemsLength; j++) {
		                    if (dataItem === itemsToMatch[j]) {
		                        found = true;
		                        changed.push({ index: i, item: dataItem });
		                        break;
		                    }
		                }
	
		                if (!found) {
		                    unchanged.push(dataItem);
		                }
		            }
		        }
	
		        return {
		            changed: changed,
		            unchanged: unchanged
		        };
		    }
	
		    function isActivePromise(promise) {
		        return promise && promise.state() !== "resolved";
		    }
	
		    var VirtualList = DataBoundWidget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            that.bound(false);
		            that._fetching = false;
	
		            Widget.fn.init.call(that, element, options);
	
		            if (!that.options.itemHeight) {
		                that.options.itemHeight = getDefaultItemHeight();
		            }
	
		            options = that.options;
	
		            that.element.addClass(LIST + " " + VIRTUALLIST).attr("role", "listbox");
		            that.content = that.element.wrap("<div unselectable='on' class='" + CONTENT + "'></div>").parent();
		            that.wrapper = that.content.wrap("<div class='" + WRAPPER + "'></div>").parent();
		            that.header = that.content.before("<div class='" + HEADER + "'></div>").prev();
	
		            if (options.columns && options.columns.length) {
		                that.element.removeClass(LIST);
		            }
	
		            that.element.on("mouseenter" + VIRTUAL_LIST_NS, "li:not(.k-loading-item)", function() { $(this).addClass(HOVER); })
		                        .on("mouseleave" + VIRTUAL_LIST_NS, "li", function() { $(this).removeClass(HOVER); });
	
		            that._values = toArray(that.options.value);
		            that._selectedDataItems = [];
		            that._selectedIndexes = [];
		            that._rangesList = {};
		            that._promisesList = [];
		            that._optionID = kendo.guid();
	
		            that._templates();
	
		            that.setDataSource(options.dataSource);
	
		            that.content.on("scroll" + VIRTUAL_LIST_NS, kendo.throttle(function() {
		                that._renderItems();
		                that._triggerListBound();
		            }, options.delay));
	
		            that._selectable();
		        },
	
		        options: {
		            name: "VirtualList",
		            autoBind: true,
		            delay: 100,
		            height: null,
		            listScreens: 4,
		            threshold: 0.5,
		            itemHeight: null,
		            oppositeBuffer: 1,
		            type: "flat",
		            selectable: false,
		            value: [],
		            dataValueField: null,
		            template: "#:data#",
		            placeholderTemplate: "loading...",
		            groupTemplate: "#:data#",
		            fixedGroupTemplate: "#:data#",
		            mapValueTo: "index",
		            valueMapper: null
		        },
	
		        events: [
		            CHANGE,
		            CLICK,
		            LISTBOUND,
		            ITEMCHANGE,
		            ACTIVATE,
		            DEACTIVATE
		        ],
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
	
		            if (this._selectProxy && this.options.selectable === false) {
		                this.element.off(CLICK, "." + VIRTUALITEM, this._selectProxy);
		            } else if (!this._selectProxy && this.options.selectable) {
		                this._selectable();
		            }
	
		            this._templates();
		            this.refresh();
		        },
	
		        items: function() {
		            return $(this._items);
		        },
	
		        destroy: function() {
		            this.wrapper.off(VIRTUAL_LIST_NS);
		            this.dataSource.unbind(CHANGE, this._refreshHandler);
		            Widget.fn.destroy.call(this);
		        },
	
		        setDataSource: function(source) {
		            var that = this;
		            var dataSource = source || {};
		            var value;
	
		            dataSource = $.isArray(dataSource) ? {data: dataSource} : dataSource;
		            dataSource = kendo.data.DataSource.create(dataSource);
	
		            if (that.dataSource) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
	
		                that._clean();
		                that.bound(false);
	
		                that._deferValueSet = true;
		                value = that.value();
	
		                that.value([]);
		                that.mute(function() {
		                    that.value(value);
		                });
		            } else {
		                that._refreshHandler = $.proxy(that.refresh, that);
		            }
	
		            that.dataSource = dataSource.bind(CHANGE, that._refreshHandler);
	
		            that.setDSFilter(dataSource.filter());
	
		            if (dataSource.view().length !== 0) {
		                that.refresh();
		            } else if (that.options.autoBind) {
		                dataSource.fetch();
		            }
		        },
	
		        skip: function() {
		            return this.dataSource.currentRangeStart();
		        },
	
		        _triggerListBound: function () {
		            var that = this;
		            var skip = that.skip();
	
		            if (that.bound() && !that._selectingValue && that._skip !== skip) {
		                that._skip = skip;
		                that.trigger(LISTBOUND);
		            }
		        },
	
		        _getValues: function(dataItems) {
		            var getter = this._valueGetter;
	
		            return $.map(dataItems, function(dataItem) {
		                return getter(dataItem);
		            });
		        },
	
		        _highlightSelectedItems: function () {
		            for (var i = 0; i < this._selectedDataItems.length; i++) {
		                var item = this._getElementByDataItem(this._selectedDataItems[i]);
		                if(item.length){
		                    item.addClass(SELECTED);
		                }
		            }
		        },
	
		        refresh: function(e) {
		            var that = this;
		            var action = e && e.action;
		            var isItemChange = action === "itemchange";
		            var filtered = this.isFiltered();
		            var result;
	
		            if (that._mute) { return; }
	
		            that._deferValueSet = false;
	
		            if (!that._fetching) {
		                if (filtered) {
		                    that.focus(0);
		                }
	
		                that._createList();
		                if (!action && that._values.length && !filtered &&
		                     !that.options.skipUpdateOnBind && !that._emptySearch) {
		                    that._selectingValue = true;
	
		                    that.bound(true);
		                    that.value(that._values, true).done(function () {
		                        that._selectingValue = false;
		                        that._triggerListBound();
		                    });
		                } else {
		                    that.bound(true);
		                    that._highlightSelectedItems();
		                    that._triggerListBound();
		                }
		            } else {
		                if (that._renderItems) {
		                    that._renderItems(true);
		                }
	
		                that._triggerListBound();
		            }
	
		            if (isItemChange || action === "remove") {
		                result = mapChangedItems(that._selectedDataItems, e.items);
		                if (result.changed.length) {
		                    if (isItemChange) {
		                        that.trigger("selectedItemChange", {
		                            items: result.changed
		                        });
		                    } else {
		                        that.value(that._getValues(result.unchanged));
		                    }
		                }
		            }
	
		            that._fetching = false;
		        },
	
		        removeAt: function(position) {
		            this._selectedIndexes.splice(position, 1);
		            this._values.splice(position, 1);
	
		            return {
		                position: position,
		                dataItem: this._selectedDataItems.splice(position, 1)[0]
		            };
		        },
	
		        setValue: function(value) {
		            this._values = toArray(value);
		        },
	
		        value: function(value, _forcePrefetch) {
		            var that = this;
	
		            if (value === undefined) {
		                return that._values.slice();
		            }
	
		            if (value === null) {
		                value = [];
		            }
	
		            value = toArray(value);
	
		            if (!that._valueDeferred || that._valueDeferred.state() === "resolved") {
		                that._valueDeferred = $.Deferred();
		            }
	
		            var shouldClear = that.options.selectable === "multiple" && that.select().length && value.length;
	
		            if (shouldClear || !value.length) {
		                that.select(-1);
		            }
	
		            that._values = value;
	
		            if ((that.bound() && !that._mute && !that._deferValueSet) || _forcePrefetch) {
		                that._prefetchByValue(value);
		            }
	
		            return that._valueDeferred;
		        },
	
		        _checkValuesOrder: function (value) {
		            if (this._removedAddedIndexes &&
		                this._removedAddedIndexes.length === value.length) {
		                    var newValue = this._removedAddedIndexes.slice();
		                    this._removedAddedIndexes = null;
		                return newValue;
		            }
	
		            return value;
		        },
	
		        _prefetchByValue: function(value) {
		            var that = this,
		                dataView = that._dataView,
		                valueGetter = that._valueGetter,
		                mapValueTo = that.options.mapValueTo,
		                item, match = false,
		                forSelection = [];
	
		            //try to find the items in the loaded data
		            for (var i = 0; i < value.length; i++) {
		                for (var idx = 0; idx < dataView.length; idx++) {
		                    item = dataView[idx].item;
		                    if (item) {
		                        match = isPrimitive(item) ? value[i] === item : value[i] === valueGetter(item);
	
		                        if (match) {
		                            forSelection.push(dataView[idx].index);
		                        }
		                    }
		                }
		            }
	
		            if (forSelection.length === value.length) {
		                that._values = [];
		                that.select(forSelection);
		                return;
		            }
	
		            //prefetch the items
		            if (typeof that.options.valueMapper === "function") {
		                that.options.valueMapper({
		                    value: (this.options.selectable === "multiple") ? value : value[0],
		                    success: function(response) {
		                        if (mapValueTo === "index") {
		                            that.mapValueToIndex(response);
		                        } else if (mapValueTo === "dataItem") {
		                            that.mapValueToDataItem(response);
		                        }
		                    }
		                });
		            } else {
		                 if (!that.value()[0]) {
		                     that.select([-1]);
		                 } else {
		                    that._selectingValue = false;
		                    that._triggerListBound();
		                 }
		            }
		        },
	
		        mapValueToIndex: function(indexes) {
		            if (indexes === undefined || indexes === -1 || indexes === null) {
		                indexes = [];
		            } else {
		                indexes = toArray(indexes);
		            }
	
		            if (!indexes.length) {
		                indexes = [-1];
		            } else {
		                var removed = this._deselect([]).removed;
		                if (removed.length) {
		                    this._triggerChange(removed, []);
		                }
		            }
	
		            this.select(indexes);
		        },
	
		        mapValueToDataItem: function(dataItems) {
		            var removed, added;
	
		            if (dataItems === undefined || dataItems === null) {
		                dataItems = [];
		            } else {
		                dataItems = toArray(dataItems);
		            }
	
		            if (!dataItems.length) {
		                this.select([-1]);
		            } else {
		                removed = $.map(this._selectedDataItems, function(item, index) {
		                    return { index: index, dataItem: item };
		                });
	
		                added = $.map(dataItems, function(item, index) {
		                    return { index: index, dataItem: item };
		                });
	
		                this._selectedDataItems = dataItems;
	
		                this._selectedIndexes = [];
	
		                for (var i = 0; i < this._selectedDataItems.length; i++) {
		                    var item = this._getElementByDataItem(this._selectedDataItems[i]);
		                    this._selectedIndexes.push(this._getIndecies(item)[0]);
		                    item.addClass(SELECTED);
		                }
	
		                this._triggerChange(removed, added);
	
		                if (this._valueDeferred) {
		                    this._valueDeferred.resolve();
		                }
		            }
		        },
	
		        deferredRange: function(index) {
		            var dataSource = this.dataSource;
		            var take = this.itemCount;
		            var ranges = this._rangesList;
		            var result = $.Deferred();
		            var defs = [];
	
		            var low = Math.floor(index / take) * take;
		            var high = Math.ceil(index / take) * take;
	
		            var pages = high === low ? [ high ] : [ low, high ];
	
		            $.each(pages, function(_, skip) {
		                var end = skip + take;
		                var existingRange = ranges[skip];
		                var deferred;
	
		                if (!existingRange || (existingRange.end !== end)) {
		                    deferred = $.Deferred();
		                    ranges[skip] = { end: end, deferred: deferred };
	
		                    dataSource._multiplePrefetch(skip, take, function() {
		                        deferred.resolve();
		                    });
		                } else {
		                    deferred = existingRange.deferred;
		                }
	
		                defs.push(deferred);
		            });
	
		            $.when.apply($, defs).then(function() {
		                result.resolve();
		            });
	
		            return result;
		        },
	
		        prefetch: function(indexes) {
		            var that = this,
		                take = this.itemCount,
		                isEmptyList = !that._promisesList.length;
	
		            if (!isActivePromise(that._activeDeferred)) {
		                that._activeDeferred = $.Deferred();
		                that._promisesList = [];
		            }
	
		            $.each(indexes, function(_, index) {
		                that._promisesList.push(that.deferredRange(that._getSkip(index, take)));
		            });
	
		            if (isEmptyList) {
		                $.when.apply($, that._promisesList).done(function() {
		                    that._promisesList = [];
		                    that._activeDeferred.resolve();
		                });
		            }
	
		            return that._activeDeferred;
		        },
	
		        _findDataItem: function(view, index) {
		            var group;
	
		            //find in grouped view
		            if (this.options.type === "group") {
		                for (var i = 0; i < view.length; i++) {
		                    group = view[i].items;
		                    if (group.length <= index) {
		                        index = index - group.length;
		                    } else {
		                        return group[index];
		                    }
		                }
		            }
	
		            //find in flat view
		            return view[index];
		        },
	
		        _getRange: function(skip, take) {
		            return this.dataSource._findRange(skip, Math.min(skip + take, this.dataSource.total()));
		        },
	
		        dataItemByIndex: function(index) {
		            var that = this;
		            var take = that.itemCount;
		            var skip = that._getSkip(index, take);
		            var view = this._getRange(skip, take);
	
		            //should not return item if data is not loaded
		            if (!that._getRange(skip, take).length) {
		                return null;
		            }
	
		            if (that.options.type === "group") {
		                kendo.ui.progress($(that.wrapper), true);
		                that.mute(function() {
		                    that.dataSource.range(skip, take, function () {
		                        kendo.ui.progress($(that.wrapper), false);
		                    });
		                    view = that.dataSource.view();
		                });
		            }
	
		            return that._findDataItem(view, [index - skip]);
		        },
	
		        selectedDataItems: function() {
		            return this._selectedDataItems.slice();
		        },
	
		        scrollWith: function(value) {
		            this.content.scrollTop(this.content.scrollTop() + value);
		        },
	
		        scrollTo: function(y) {
		            this.content.scrollTop(y); //works only if the element is visible
		        },
	
		        scrollToIndex: function(index) {
		            this.scrollTo(index * this.options.itemHeight);
		        },
	
		        focus: function(candidate) {
		            var element,
		                index,
		                data,
		                current,
		                itemHeight = this.options.itemHeight,
		                id = this._optionID,
		                triggerEvent = true;
	
		            if (candidate === undefined) {
		                current = this.element.find("." + FOCUSED);
		                return current.length ? current : null;
		            }
	
		            if (typeof candidate === "function") {
		                data = this.dataSource.flatView();
		                for (var idx = 0; idx < data.length; idx++) {
		                    if (candidate(data[idx])) {
		                        candidate = idx;
		                        break;
		                    }
		                }
		            }
	
		            if (candidate instanceof Array) {
		                candidate = lastFrom(candidate);
		            }
	
		            if (isNaN(candidate)) {
		                element = $(candidate);
		                index = parseInt($(element).attr("data-offset-index"), 10);
		            } else {
		                index = candidate;
		                element = this._getElementByIndex(index);
		            }
	
		            if (index === -1) {
		                this.element.find("." + FOCUSED).removeClass(FOCUSED);
		                this._focusedIndex = undefined;
		                return;
		            }
	
		            if (element.length) { /*focus rendered item*/
		                if (element.hasClass(FOCUSED)) {
		                    triggerEvent = false;
		                }
		                if (this._focusedIndex !== undefined) {
		                    current = this._getElementByIndex(this._focusedIndex);
		                    current
		                        .removeClass(FOCUSED)
		                        .removeAttr("id");
	
		                    if (triggerEvent) {
		                        this.trigger(DEACTIVATE);
		                    }
		                }
	
		                this._focusedIndex = index;
	
		                element
		                    .addClass(FOCUSED)
		                    .attr("id", id);
	
		                var position = this._getElementLocation(index);
	
		                if (position === "top") {
		                    this.scrollTo(index * itemHeight);
		                } else if (position === "bottom") {
		                    this.scrollTo((index * itemHeight + itemHeight) - this._screenHeight);
		                } else if (position === "outScreen") {
		                    this.scrollTo(index * itemHeight);
		                }
	
		                if (triggerEvent) {
		                    this.trigger(ACTIVATE);
		                }
		            } else { /*focus non rendered item*/
		                this._focusedIndex = index;
		                this.items().removeClass(FOCUSED);
		                this.scrollToIndex(index);
		            }
		        },
	
		        focusIndex: function() {
		            return this._focusedIndex;
		        },
	
		        focusFirst: function() {
		            this.scrollTo(0);
		            this.focus(0);
		        },
	
		        focusLast: function() {
		            var lastIndex = this.dataSource.total();
		            this.scrollTo(this.heightContainer.offsetHeight);
		            this.focus(lastIndex - 1);
		        },
	
		        focusPrev: function() {
		            var index = this._focusedIndex;
		            var current;
	
		            if (!isNaN(index) && index > 0) {
		                index -= 1;
		                this.focus(index);
	
		                current = this.focus();
		                if (current && current.hasClass("k-loading-item")) {
		                    index += 1;
		                    this.focus(index);
		                }
	
		                return index;
		            } else {
		                index = this.dataSource.total() - 1;
		                this.focus(index);
		                return index;
		            }
		        },
	
		        focusNext: function() {
		            var index = this._focusedIndex;
		            var lastIndex = this.dataSource.total() - 1;
		            var current;
	
		            if (!isNaN(index) && index < lastIndex) {
		                index += 1;
		                this.focus(index);
	
		                current = this.focus();
		                if (current && current.hasClass("k-loading-item")) {
		                    index -= 1;
		                    this.focus(index);
		                }
	
		                return index;
		            } else {
		                index = 0;
		                this.focus(index);
		                return index;
		            }
		        },
	
		        _triggerChange: function(removed, added) {
		            removed = removed || [];
		            added = added || [];
	
		            if (removed.length || added.length) {
		                this.trigger(CHANGE, {
		                    removed: removed,
		                    added: added
		                });
		            }
		        },
	
		        select: function(candidate) {
		            var that = this,
		                indices,
		                initialIndices,
		                singleSelection = that.options.selectable !== "multiple",
		                prefetchStarted = isActivePromise(that._activeDeferred),
		                filtered = this.isFiltered(),
		                isAlreadySelected,
		                deferred,
		                result,
		                removed = [];
	
		            if (candidate === undefined) {
		                return that._selectedIndexes.slice();
		            }
	
		            if (!that._selectDeferred || that._selectDeferred.state() === "resolved") {
		                that._selectDeferred = $.Deferred();
		            }
	
		            indices = that._getIndecies(candidate);
		            isAlreadySelected = singleSelection && !filtered && lastFrom(indices) === lastFrom(this._selectedIndexes);
		            removed = that._deselectCurrentValues(indices);
	
		            if (removed.length || !indices.length || isAlreadySelected) {
		                that._triggerChange(removed);
	
		                if (that._valueDeferred) {
		                    that._valueDeferred.resolve().promise();
		                }
	
		                return that._selectDeferred.resolve().promise();
		            }
	
		            if (indices.length === 1 && indices[0] === -1) {
		                indices = [];
		            }
	
		            initialIndices = indices;
		            result = that._deselect(indices);
		            removed = result.removed;
		            indices = result.indices;
	
		            if (singleSelection) {
		                prefetchStarted = false;
		                if (indices.length) {
		                    indices = [lastFrom(indices)];
		                }
		            }
	
		            var done = function() {
		                var added = that._select(indices);
	
		                if (initialIndices.length === indices.length || singleSelection) {
		                    that.focus(indices);
		                }
	
		                that._triggerChange(removed, added);
	
		                if (that._valueDeferred) {
		                    that._valueDeferred.resolve();
		                }
	
		                that._selectDeferred.resolve();
		            };
	
		            deferred = that.prefetch(indices);
	
		            if (!prefetchStarted) {
		                if (deferred) {
		                    deferred.done(done);
		                } else {
		                    done();
		                }
		            }
	
		            return that._selectDeferred.promise();
		        },
	
		        bound: function(bound) {
		            if (bound === undefined) {
		                return this._listCreated;
		            }
	
		            this._listCreated = bound;
		        },
	
		        mute: function(callback) {
		            this._mute = true;
		            proxy(callback(), this);
		            this._mute = false;
		        },
	
		        setDSFilter: function(filter) {
		            this._lastDSFilter = $.extend({}, filter);
		        },
	
		        isFiltered: function() {
		            if (!this._lastDSFilter) {
		                this.setDSFilter(this.dataSource.filter());
		            }
	
		            return !kendo.data.Query.compareFilters(this.dataSource.filter(), this._lastDSFilter);
		        },
	
		        skipUpdate: $.noop,
	
		        _getElementByIndex: function(index) {
		            return this.items().filter(function(idx, element) {
		                return index === parseInt($(element).attr("data-offset-index"), 10);
		            });
		        },
	
		        _getElementByDataItem: function(dataItem) {
		            var dataView = this._dataView,
		            valueGetter = this._valueGetter,
		                element, match;
	
		            for (var i = 0; i < dataView.length; i++) {
		                match = dataView[i].item && isPrimitive(dataView[i].item) ? dataView[i].item === dataItem : dataView[i].item && dataItem && valueGetter(dataView[i].item) == valueGetter(dataItem);
		                if (match) {
		                    element = dataView[i];
		                    break;
		                }
		            }
	
		            return element ? this._getElementByIndex(element.index) : $();
		        },
	
		        _clean: function() {
		            this.result = undefined;
		            this._lastScrollTop = undefined;
		            this._skip = undefined;
		            $(this.heightContainer).remove();
		            this.heightContainer = undefined;
		            this.element.empty();
		        },
	
		        _height: function() {
		            var hasData = !!this.dataSource.view().length,
		                height = this.options.height,
		                itemHeight = this.options.itemHeight,
		                total = this.dataSource.total();
	
		            if (!hasData) {
		                height = 0;
		            } else if (height/itemHeight > total) {
		                height = total * itemHeight;
		            }
	
		            return height;
		        },
	
		        setScreenHeight: function() {
		            var height = this._height();
	
		            this.content.height(height);
		            this._screenHeight = height;
		        },
	
		        screenHeight: function() {
		            return this._screenHeight;
		        },
	
		        _getElementLocation: function(index) {
		            var scrollTop = this.content.scrollTop(),
		                screenHeight = this._screenHeight,
		                itemHeight = this.options.itemHeight,
		                yPosition = index * itemHeight,
		                yDownPostion = yPosition + itemHeight,
		                screenEnd = scrollTop + screenHeight,
		                position;
	
		            if (yPosition === (scrollTop - itemHeight) || (yDownPostion > scrollTop && yPosition < scrollTop)) {
		                position = "top";
		            } else if (yPosition === screenEnd || (yPosition < screenEnd && screenEnd < yDownPostion)) {
		                position = "bottom";
		            } else if ((yPosition >= scrollTop) && (yPosition <= scrollTop + (screenHeight - itemHeight))) {
		                position = "inScreen";
		            } else {
		                position = "outScreen";
		            }
	
		            return position;
		        },
	
		        _templates: function() {
		            var options = this.options;
		            var templates = {
		                template: options.template,
		                placeholderTemplate: options.placeholderTemplate,
		                groupTemplate: options.groupTemplate,
		                fixedGroupTemplate: options.fixedGroupTemplate
		            };
	
		            if (options.columns) {
		                for (var i = 0; i < options.columns.length; i++) {
		                    var currentColumn = options.columns[i];
		                    var templateText = currentColumn.field ? currentColumn.field.toString(): "text";
	
		                    templates["column"+ i] = currentColumn.template || "#: " + templateText + "#";
		                }
		            }
	
		            for (var key in templates) {
		                if (typeof templates[key] !== "function") {
		                    templates[key] = kendo.template(templates[key] || "");
		                }
		            }
	
		            this.templates = templates;
		        },
	
		        _generateItems: function(element, count) {
		            var items = [],
		                item,
		                itemHeight = this.options.itemHeight + "px";
	
		            while(count-- > 0) {
		                item = document.createElement("li");
		                item.tabIndex = -1;
		                item.className = VIRTUALITEM + " " + ITEM;
		                item.setAttribute("role", "option");
		                item.style.height = itemHeight;
		                item.style.minHeight = itemHeight;
		                element.appendChild(item);
	
		                items.push(item);
		            }
	
		            return items;
		        },
	
		        _saveInitialRanges: function() {
		            var ranges = this.dataSource._ranges;
		            var deferred = $.Deferred();
		            deferred.resolve();
	
		            this._rangesList = {};
		            for (var i = 0; i < ranges.length; i++) {
		                this._rangesList[ranges[i].start] = { end: ranges[i].end, deferred: deferred };
		            }
		        },
	
		        _createList: function() {
		            var that = this,
		                content = that.content.get(0),
		                options = that.options,
		                dataSource = that.dataSource;
	
		            if (that.bound()) {
		                that._clean();
		            }
	
		            that._saveInitialRanges();
		            that._buildValueGetter();
		            that.setScreenHeight();
		            that.itemCount = getItemCount(that._screenHeight, options.listScreens, options.itemHeight);
	
		            if (that.itemCount > dataSource.total()) {
		                that.itemCount = dataSource.total();
		            }
	
		            that._items = that._generateItems(that.element[0], that.itemCount);
	
		            that._setHeight(options.itemHeight * dataSource.total());
		            that.options.type = (dataSource.group() || []).length ? "group" : "flat";
	
		            if (that.options.type === "flat") {
		                that.header.hide();
		            } else {
		                that.header.show();
		            }
	
		            that.getter = that._getter(function() {
		                that._renderItems(true);
		            });
	
		            that._onScroll = function(scrollTop, force) {
		                var getList = that._listItems(that.getter);
		                return that._fixedHeader(scrollTop, getList(scrollTop, force));
		            };
	
		            that._renderItems = that._whenChanged(
		                scrollCallback(content, that._onScroll),
		                syncList(that._reorderList(that._items, $.proxy(render, that)))
		            );
	
		            that._renderItems();
		            that._calculateGroupPadding(that._screenHeight);
		            that._calculateColumnsHeaderPadding();
		        },
	
		        _setHeight: function(height) {
		            var currentHeight,
		                heightContainer = this.heightContainer;
	
		            if (!heightContainer) {
		                heightContainer = this.heightContainer = appendChild(this.content[0], HEIGHTCONTAINER);
		            } else {
		                currentHeight = heightContainer.offsetHeight;
		            }
	
		            if (height !== currentHeight) {
		                heightContainer.innerHTML = "";
	
		                while (height > 0) {
		                    var padHeight = Math.min(height, 250000); //IE workaround, should not create elements with height larger than 250000px
		                    appendChild(heightContainer).style.height = padHeight + "px";
		                    height -= padHeight;
		                }
		            }
		        },
	
		        _getter: function() {
		            var lastRequestedRange = null,
		                dataSource = this.dataSource,
		                lastRangeStart = dataSource.skip(),
		                type = this.options.type,
		                pageSize = this.itemCount,
		                flatGroups = {};
	
		            if (dataSource.pageSize() < pageSize) {
		                this.mute(function() {
		                    dataSource.pageSize(pageSize);
		                });
		            }
	
		            return function(index, rangeStart) {
		                var that = this;
		                if (!dataSource.inRange(rangeStart, pageSize)) {
		                    if (lastRequestedRange !== rangeStart) {
		                        lastRequestedRange = rangeStart;
		                        lastRangeStart = rangeStart;
	
		                        if (that._getterDeferred) {
		                            that._getterDeferred.reject();
		                        }
	
		                        that._getterDeferred = that.deferredRange(rangeStart);
		                        that._getterDeferred.then(function() {
		                            var firstItemIndex = that._indexConstraint(that.content[0].scrollTop);
	
		                            that._getterDeferred = null;
	
		                            if (rangeStart <= firstItemIndex && firstItemIndex <= (rangeStart + pageSize)) {
		                                that._fetching = true;
		                                dataSource.range(rangeStart, pageSize);
		                            }
		                        });
		                    }
	
		                    return null;
		                } else {
		                    if (lastRangeStart !== rangeStart) {
		                        this.mute(function() {
		                            dataSource.range(rangeStart, pageSize);
		                            lastRangeStart = rangeStart;
		                        });
		                    }
	
		                    var result;
		                    if (type === "group") { //grouped list
		                        if (!flatGroups[rangeStart]) {
		                            var flatGroup = flatGroups[rangeStart] = [];
		                            var groups = dataSource.view();
		                            for (var i = 0, len = groups.length; i < len; i++) {
		                                var group = groups[i];
		                                for (var j = 0, groupLength = group.items.length; j < groupLength; j++) {
		                                    flatGroup.push({ item: group.items[j], group: group.value });
		                                }
		                            }
		                        }
	
		                        result = flatGroups[rangeStart][index - rangeStart];
		                    } else { //flat list
		                        result = dataSource.view()[index - rangeStart];
		                    }
	
		                    return result;
		                }
		            };
		        },
	
		        _fixedHeader: function(scrollTop, list) {
		            var group = this.currentVisibleGroup,
		                itemHeight = this.options.itemHeight,
		                firstVisibleDataItemIndex = Math.floor((scrollTop - list.top) / itemHeight),
		                firstVisibleDataItem = list.items[firstVisibleDataItemIndex];
	
		            if (firstVisibleDataItem && firstVisibleDataItem.item) {
		                var firstVisibleGroup = firstVisibleDataItem.group;
	
		                if (firstVisibleGroup !== group) {
		                    var fixedGroupText = firstVisibleGroup || "";
		                    this.header.html(this.templates.fixedGroupTemplate(fixedGroupText));
		                    this.currentVisibleGroup = firstVisibleGroup;
		                }
		            }
	
		            return list;
		        },
	
		        _itemMapper: function(item, index, value) {
		            var listType = this.options.type,
		                itemHeight = this.options.itemHeight,
		                currentIndex = this._focusedIndex,
		                selected = false,
		                current = false,
		                newGroup = false,
		                group = null,
		                match = false,
		                valueGetter = this._valueGetter;
	
		            if (listType === "group") {
		                if (item) {
		                    newGroup = index === 0 || (this._currentGroup && this._currentGroup !== item.group);
		                    this._currentGroup = item.group;
		                }
	
		                group = item ? item.group : null;
		                item = item ? item.item : null;
		            }
	
		            if (this.options.mapValueTo === "dataItem" && this._selectedDataItems.length && item) {
		                for (var i = 0; i < this._selectedDataItems.length; i++) {
		                    match = valueGetter(this._selectedDataItems[i]) === valueGetter(item);
		                    if (match) {
		                        selected = true;
		                        break;
		                    }
		                }
		            } else if (!this.isFiltered() && value.length && item) {
		                for (var j = 0; j < value.length; j++) {
		                    match = isPrimitive(item) ? value[j] === item : value[j] === valueGetter(item);
		                    if (match) {
		                        value.splice(j , 1);
		                        selected = true;
		                        break;
		                    }
		                }
		            }
	
		            if (currentIndex === index) {
		                current = true;
		            }
	
		            return {
		                item: item ? item : null,
		                group: group,
		                newGroup: newGroup,
		                selected: selected,
		                current: current,
		                index: index,
		                top: index * itemHeight
		            };
		        },
	
		        _range: function(index) {
		            var itemCount = this.itemCount,
		                value = this._values.slice(),
		                items = [],
		                item;
	
		            this._view = {};
		            this._currentGroup = null;
	
		            for (var i = index, length = index + itemCount; i < length; i++) {
		                item = this._itemMapper(this.getter(i, index), i, value);
		                if(items[items.length - 1]){
		                    items[items.length - 1].isLastGroupedItem = item.newGroup;
		                }
		                items.push(item);
		                this._view[item.index] = item;
		            }
	
		            this._dataView = items;
		            return items;
		        },
	
		        _getDataItemsCollection: function(scrollTop, lastScrollTop) {
		            var items = this._range(this._listIndex(scrollTop, lastScrollTop));
		            return {
		                index: items.length ? items[0].index : 0,
		                top: items.length ? items[0].top : 0,
		                items: items
		            };
		        },
	
		        _listItems: function() {
		            var screenHeight = this._screenHeight,
		                options = this.options;
	
		            var theValidator = listValidator(options, screenHeight);
	
		            return $.proxy(function(value, force) {
		                var result = this.result,
		                    lastScrollTop = this._lastScrollTop;
	
		                if (force || !result || !theValidator(result, value, lastScrollTop)) {
		                    result = this._getDataItemsCollection(value, lastScrollTop);
		                }
	
		                this._lastScrollTop = value;
		                this.result = result;
	
		                return result;
		            }, this);
		        },
	
		        _whenChanged: function(getter, callback) {
		            var current;
	
		            return function(force) {
		                var theNew = getter(force);
	
		                if (theNew !== current) {
		                    current = theNew;
		                    callback(theNew, force);
		                }
		            };
		        },
	
		        _reorderList: function(list, reorder) {
		            var that = this;
		            var length = list.length;
		            var currentOffset = -Infinity;
		            reorder = $.proxy(map2(reorder, this.templates), this);
	
		            return function(list2, offset, force) {
		                var diff = offset - currentOffset;
		                var range, range2;
	
		                if (force || Math.abs(diff) >= length) { // full reorder
		                    range = list;
		                    range2 = list2;
		                } else { // partial reorder
		                    range = reshift(list, diff);
		                    range2 = diff > 0 ? list2.slice(-diff) : list2.slice(0, -diff);
		                }
	
		                reorder(range, range2, that.bound());
	
		                currentOffset = offset;
		            };
		        },
	
		        _bufferSizes: function() {
		            var options = this.options;
	
		            return bufferSizes(this._screenHeight, options.listScreens, options.oppositeBuffer);
		        },
	
		        _indexConstraint: function(position) {
		            var itemCount = this.itemCount,
		                itemHeight = this.options.itemHeight,
		                total = this.dataSource.total();
	
		            return Math.min(Math.max(total - itemCount, 0), Math.max(0, Math.floor(position / itemHeight )));
		        },
	
		        _listIndex: function(scrollTop, lastScrollTop) {
		            var buffers = this._bufferSizes(),
		                position;
	
		            position = scrollTop - ((scrollTop > lastScrollTop) ? buffers.down : buffers.up);
	
		            return this._indexConstraint(position);
		        },
	
		        _selectable: function() {
		            if (this.options.selectable) {
		                this._selectProxy = $.proxy(this, "_clickHandler");
		                this.element.on(CLICK + VIRTUAL_LIST_NS, "." + VIRTUALITEM, this._selectProxy);
		            }
		        },
	
		        getElementIndex: function(element) {
		            if (!(element instanceof jQuery)) {
		                return undefined;
		            }
	
		            return parseInt(element.attr("data-offset-index"), 10);
		        },
	
		        _getIndecies: function(candidate) {
		            var result = [], data;
	
		            if (typeof candidate === "function") {
		                data = this.dataSource.flatView();
		                for (var idx = 0; idx < data.length; idx++) {
		                    if (candidate(data[idx])) {
		                        result.push(idx);
		                        break;
		                    }
		                }
		            }
	
		            if (typeof candidate === "number") {
		                result.push(candidate);
		            }
	
		            var elementIndex = this.getElementIndex(candidate);
		            if (!isNaN(elementIndex)) {
		                result.push(elementIndex);
		            }
	
		            if (candidate instanceof Array) {
		                result = candidate;
		            }
	
		            return result;
		        },
	
		        _deselect: function(indices) {
		            var removed = [],
		                selectedIndex,
		                dataItem,
		                selectedIndexes = this._selectedIndexes,
		                selectedDataItems = this._selectedDataItems,
		                position = 0,
		                selectable = this.options.selectable,
		                removedindexesCounter = 0,
		                valueGetter = this._valueGetter,
		                item, match,
		                result = null;
	
		            indices = indices.slice();
	
		            if (selectable === true || !indices.length) { //deselect everything
		                for (var idx = 0; idx < selectedIndexes.length; idx++) {
		                    if (selectedIndexes[idx] !== undefined) {
		                        this._getElementByIndex(selectedIndexes[idx]).removeClass(SELECTED);
		                    } else if (selectedDataItems[idx]) {
		                        this._getElementByDataItem(selectedDataItems[idx]).removeClass(SELECTED);
		                    }
	
		                    removed.push({
		                        index: selectedIndexes[idx],
		                        position: idx,
		                        dataItem: selectedDataItems[idx]
		                    });
		                }
	
		                this._values = [];
		                this._selectedDataItems = [];
		                this._selectedIndexes = [];
		            } else if (selectable === "multiple") {
		                for (var i = 0; i < indices.length; i++) {
		                    result = null;
		                    position = $.inArray(indices[i], selectedIndexes);
		                    dataItem = this.dataItemByIndex(indices[i]);
	
		                    if (position === -1 && dataItem) {
		                        for (var j = 0; j < selectedDataItems.length; j++) {
		                            match = isPrimitive(dataItem) ? selectedDataItems[j] === dataItem : valueGetter(selectedDataItems[j]) === valueGetter(dataItem);
		                            if (match) {
		                                item = this._getElementByIndex(indices[i]);
		                                result = this._deselectSingleItem(item, j, indices[i], removedindexesCounter);
		                            }
		                        }
		                    } else {
		                        selectedIndex = selectedIndexes[position];
	
		                        if (selectedIndex !== undefined) {
		                            item = this._getElementByIndex(selectedIndex);
		                            result = this._deselectSingleItem(item, position, selectedIndex, removedindexesCounter);
		                        }
		                    }
	
		                    if (result) {
		                        indices.splice(i, 1);
		                        removed.push(result);
	
		                        removedindexesCounter++;
		                        i--;
		                    }
		                }
		            }
	
		            return {
		                indices: indices,
		                removed: removed
		            };
		        },
	
		        _deselectSingleItem: function(item, position, selectedIndex, removedindexesCounter) {
		            var dataItem;
	
		            if (!item.hasClass("k-state-selected")) {
		                return;
		            }
	
		            item.removeClass(SELECTED);
		            this._values.splice(position, 1);
		            this._selectedIndexes.splice(position, 1);
		            dataItem = this._selectedDataItems.splice(position, 1)[0];
	
		            return {
		                index: selectedIndex,
		                position: position + removedindexesCounter,
		                dataItem: dataItem
		            };
		        },
	
		        _deselectCurrentValues: function(indices) {
		            var children = this.element[0].children;
		            var value, index, position;
		            var values = this._values;
		            var removed = [];
		            var idx = 0;
		            var j;
	
		            if (this.options.selectable !== "multiple" || !this.isFiltered()) {
		                return [];
		            }
	
		            if (indices[0] === -1) {
		                $(children).removeClass("k-state-selected");
		                removed = $.map(this._selectedDataItems.slice(0), function(dataItem, idx) {
		                   return {
		                      dataItem: dataItem,
		                      position: idx
		                   };
		                });
		                this._selectedIndexes = [];
		                this._selectedDataItems = [];
		                this._values = [];
		                return removed;
		            }
	
		            for (; idx < indices.length; idx++) {
		                position = -1;
		                index = indices[idx];
		                if (this.dataItemByIndex(index)) {
		                    value = this._valueGetter(this.dataItemByIndex(index));
		                }
	
		                for (j = 0; j < values.length; j++) {
		                    if (value == values[j]) {
		                        position = j;
		                        break;
		                    }
		                }
	
		                if (position > -1) {
		                    removed.push(this.removeAt(position));
		                    $(children[index]).removeClass("k-state-selected");
		                }
		            }
	
		            return removed;
		        },
	
		        _getSkip: function(index, take) {
		            var page = index < take ? 1 : Math.floor(index / take) + 1;
	
		            return (page - 1) * take;
		        },
	
		        _select: function(indexes) {
		            var that = this,
		                singleSelection = this.options.selectable !== "multiple",
		                dataSource = this.dataSource,
		                dataItem, oldSkip,
		                take = this.itemCount,
		                valueGetter = this._valueGetter,
		                added = [];
	
		            if (singleSelection) {
		                that._selectedIndexes = [];
		                that._selectedDataItems = [];
		                that._values = [];
		            }
	
		            oldSkip = dataSource.skip();
	
		            $.each(indexes, function(_, index) {
		                var skip = that._getSkip(index, take);
	
		                that.mute(function() {
		                    dataSource.range(skip, take); //switch the range to get the dataItem
	
		                    dataItem = that._findDataItem(dataSource.view(), [index - skip]);
		                    that._selectedIndexes.push(index);
		                    that._selectedDataItems.push(dataItem);
		                    that._values.push(isPrimitive(dataItem) ? dataItem : valueGetter(dataItem));
	
		                    added.push({
		                        index: index,
		                        dataItem: dataItem
		                    });
	
		                    that._getElementByIndex(index).addClass(SELECTED);
	
		                    dataSource.range(oldSkip, take); //switch back the range
		                });
		            });
	
		            that._values = that._checkValuesOrder(that._values);
	
		            return added;
		        },
	
		        _clickHandler: function(e) {
		            var item = $(e.currentTarget);
	
		            if (!e.isDefaultPrevented() && item.attr("data-uid")) {
		                this.trigger(CLICK, { item: item });
		            }
		        },
	
		        _buildValueGetter: function() {
		            this._valueGetter = kendo.getter(this.options.dataValueField);
		        },
	
		        _calculateGroupPadding: function (height) {
		            var firstItem = this.items().first(),
		                groupHeader = this.header,
		                padding = 0;
	
		            if (groupHeader[0] && groupHeader[0].style.display !== "none") {
		                if (height !== "auto") {
		                    padding = kendo.support.scrollbar();
		                }
	
		                padding += parseFloat(firstItem.css("border-right-width"), 10) + parseFloat(firstItem.children(".k-group").css("right"), 10);
	
		                groupHeader.css("padding-right", padding);
		            }
		        },
	
		        _calculateColumnsHeaderPadding: function () {
		            if(this.options.columns && this.options.columns.length){
		                var isRtl = kendo.support.isRtl(this.wrapper);
		                var scrollbar = kendo.support.scrollbar();
		                var columnsHeader = this.content.parent().parent().find(".k-grid-header");
		                var total = this.dataSource.total();
	
		                columnsHeader.css((isRtl ? "padding-left" : "padding-right"), total ? scrollbar : 0);
		            }
		        }
	
		    });
	
		    kendo.ui.VirtualList = VirtualList;
		    kendo.ui.plugin(VirtualList);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1130);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1021:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(562);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1023:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(570);
	
	/***/ }),
	
	/***/ 1130:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1021), __webpack_require__(1022), __webpack_require__(1023) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dropdownlist",
		    name: "DropDownList",
		    category: "web",
		    description: "The DropDownList widget displays a list of values and allows the selection of a single value from the list.",
		    depends: [ "list" ],
		    features: [ {
		        id: "mobile-scroller",
		        name: "Mobile scroller",
		        description: "Support for kinetic scrolling in mobile device",
		        depends: [ "mobile.scroller" ]
		    }, {
		        id: "virtualization",
		        name: "VirtualList",
		        description: "Support for virtualization",
		        depends: [ "virtuallist" ]
		    } ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        List = ui.List,
		        Select = ui.Select,
		        support = kendo.support,
		        activeElement = kendo._activeElement,
		        ObservableObject = kendo.data.ObservableObject,
		        keys = kendo.keys,
		        ns = ".kendoDropDownList",
		        nsFocusEvent = ns + "FocusEvent",
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        CHANGE = "change",
		        FOCUSED = "k-state-focused",
		        DEFAULT = "k-state-default",
		        STATEDISABLED = "k-state-disabled",
		        ARIA_DISABLED = "aria-disabled",
		        CLICKEVENTS = "click" + ns + " touchend" + ns,
		        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		        TABINDEX = "tabindex",
		        STATE_FILTER = "filter",
		        STATE_ACCEPT = "accept",
		        MSG_INVALID_OPTION_LABEL = "The `optionLabel` option is not valid due to missing fields. Define a custom optionLabel as shown here http://docs.telerik.com/kendo-ui/api/javascript/ui/dropdownlist#configuration-optionLabel",
		        proxy = $.proxy;
	
		    var DropDownList = Select.extend( {
		        init: function(element, options) {
		            var that = this;
		            var index = options && options.index;
		            var optionLabel, text, disabled;
	
		            that.ns = ns;
		            options = $.isArray(options) ? { dataSource: options } : options;
	
		            Select.fn.init.call(that, element, options);
	
		            options = that.options;
		            element = that.element.on("focus" + ns, proxy(that._focusHandler, that));
	
		            that._focusInputHandler = $.proxy(that._focusInput, that);
	
		            that.optionLabel = $();
		            that._optionLabel();
	
		            that._inputTemplate();
	
		            that._reset();
	
		            that._prev = "";
		            that._word = "";
	
		            that._wrapper();
	
		            that._tabindex();
		            that.wrapper.data(TABINDEX, that.wrapper.attr(TABINDEX));
	
		            that._span();
	
		            that._popup();
	
		            that._mobile();
	
		            that._dataSource();
	
		            that._ignoreCase();
	
		            that._filterHeader();
	
		            that._aria();
	
		            //should read changed value of closed dropdownlist
		            that.wrapper.attr("aria-live", "polite");
	
		            that._enable();
	
		            that._attachFocusHandlers();
	
		            that._oldIndex = that.selectedIndex = -1;
	
		            if (index !== undefined) {
		                options.index = index;
		            }
	
		            that._initialIndex = options.index;
	
		            that.requireValueMapper(that.options);
		            that._initList();
	
		            that._cascade();
	
		            that.one("set", function(e) {
		                if (!e.sender.listView.bound() && that.hasOptionLabel()) {
		                    that._textAccessor(that._optionLabelText());
		                }
		            });
	
		            if (options.autoBind) {
		                that.dataSource.fetch();
		            } else if (that.selectedIndex === -1) { //selectedIndex !== -1 when cascade functionality happens instantly
		                text = options.text || "";
		                if (!text) {
		                    optionLabel = options.optionLabel;
	
		                    if (optionLabel && options.index === 0) {
		                        text = optionLabel;
		                    } else if (that._isSelect) {
		                        text = element.children(":selected").text();
		                    }
		                }
	
		                that._textAccessor(text);
		            }
	
		            disabled = $(that.element).parents("fieldset").is(':disabled');
	
		            if (disabled) {
		                that.enable(false);
		            }
	
		            that.listView.bind("click", function(e) { e.preventDefault(); });
	
		            kendo.notify(that);
		        },
	
		        options: {
		            name: "DropDownList",
		            enabled: true,
		            autoBind: true,
		            index: 0,
		            text: null,
		            value: null,
		            delay: 500,
		            height: 200,
		            dataTextField: "",
		            dataValueField: "",
		            optionLabel: "",
		            cascadeFrom: "",
		            cascadeFromField: "",
		            cascadeFromParentField: "",
		            ignoreCase: true,
		            animation: {},
		            filter: "none",
		            minLength: 1,
		            enforceMinLength: false,
		            virtual: false,
		            template: null,
		            valueTemplate: null,
		            optionLabelTemplate: null,
		            groupTemplate: "#:data#",
		            fixedGroupTemplate: "#:data#",
		            autoWidth: false
		        },
	
		        events: [
		            "open",
		            "close",
		            CHANGE,
		            "select",
		            "filtering",
		            "dataBinding",
		            "dataBound",
		            "cascade",
		            "set"
		        ],
	
		        setOptions: function(options) {
		            Select.fn.setOptions.call(this, options);
	
		            this.listView.setOptions(this._listOptions(options));
	
		            this._optionLabel();
		            this._inputTemplate();
		            this._accessors();
		            this._filterHeader();
		            this._enable();
		            this._aria();
	
		            if (!this.value() && this.hasOptionLabel()) {
		                this.select(0);
		            }
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Select.fn.destroy.call(that);
	
		            that.wrapper.off(ns);
		            that.wrapper.off(nsFocusEvent);
		            that.element.off(ns);
		            that._inputWrapper.off(ns);
	
		            that._arrow.off();
		            that._arrow = null;
		            that._arrowIcon = null;
	
		            that.optionLabel.off();
	
		            if(that.filterInput){
		                that.filterInput.off(nsFocusEvent);
		            }
		        },
	
		        open: function() {
		            var that = this;
		            var isFiltered = that.dataSource.filter() ? that.dataSource.filter().filters.length > 0 : false;
	
		            if (that.popup.visible()) {
		                return;
		            }
	
		            if (!that.listView.bound() || that._state === STATE_ACCEPT) {
		                that._open = true;
		                that._state = "rebind";
	
		                if (that.filterInput) {
		                    that.filterInput.val("");
		                    that._prev = "";
		                }
	
		                if (that.filterInput && that.options.minLength !== 1 && !isFiltered) {
		                    that.refresh();
		                    that.popup.one("activate", that._focusInputHandler);
		                    that.popup.open();
		                    that._resizeFilterInput();
		                } else {
		                    that._filterSource();
		                }
		            } else if (that._allowOpening()) {
		                that._focusFilter = true;
		                that.popup.one("activate", that._focusInputHandler);
		                // In some cases when the popup is opened resize is triggered which will cause it to close
		                // Setting the below flag will prevent this from happening
		                that.popup._hovered = true;
		                that.popup.open();
		                that._resizeFilterInput();
		                that._focusItem();
		            }
		        },
	
		        _focusInput: function () {
		            this._focusElement(this.filterInput);
		        },
	
		        _resizeFilterInput: function () {
		            var filterInput = this.filterInput;
		            var originalPrevent = this._prevent;
	
		            if (!filterInput) {
		                return;
		            }
	
		            var isInputActive = this.filterInput[0] === activeElement();
		            var caret = kendo.caret(this.filterInput[0])[0];
	
		            this._prevent = true;
	
		            filterInput.css("display", "none")
		                       .css("width", this.popup.element.css("width"))
		                       .css("display", "inline-block");
	
		            if (isInputActive) {
		                filterInput.focus();
		                kendo.caret(filterInput[0], caret);
		            }
	
		            this._prevent = originalPrevent;
		        },
	
		        _allowOpening: function() {
		            return this.hasOptionLabel() || this.filterInput || Select.fn._allowOpening.call(this);
		        },
	
		        toggle: function(toggle) {
		            this._toggle(toggle, true);
		        },
	
		        current: function(candidate) {
		            var current;
	
		            if (candidate === undefined) {
		                current = this.listView.focus();
	
		                if (!current && this.selectedIndex === 0 && this.hasOptionLabel()) {
		                    return this.optionLabel;
		                }
	
		                return current;
		            }
	
		            this._focus(candidate);
		        },
	
		        dataItem: function(index) {
		            var that = this;
		            var dataItem = null;
	
		            if (index === null) { return index; }
	
		            if (index === undefined) {
		                dataItem = that.listView.selectedDataItems()[0];
		            } else {
		                if (typeof index !== "number") {
		                    if (that.options.virtual) {
		                        return that.dataSource.getByUid($(index).data("uid"));
		                    }
		                    if (index.hasClass("k-list-optionlabel")) {
		                        index = -1;
		                    } else {
		                        index = $(that.items()).index(index);
		                    }
		                } else if (that.hasOptionLabel()) {
		                    index -= 1;
		                }
	
		                dataItem = that.dataSource.flatView()[index];
		            }
	
		            if (!dataItem) {
		                dataItem = that._optionLabelDataItem();
		            }
	
		            return dataItem;
		        },
	
		        refresh: function() {
		            this.listView.refresh();
		        },
	
		        text: function (text) {
		            var that = this;
		            var loweredText;
		            var ignoreCase = that.options.ignoreCase;
	
		            text = text === null ? "" : text;
	
		            if (text !== undefined) {
		                if (typeof text !== "string") {
		                    that._textAccessor(text);
		                    return;
		                }
	
		                loweredText = ignoreCase ? text.toLowerCase() : text;
	
		                that._select(function(data) {
		                    data = that._text(data);
	
		                    if (ignoreCase) {
		                        data = (data + "").toLowerCase();
		                    }
	
		                    return data === loweredText;
		                }).done(function() {
		                    that._textAccessor(that.dataItem() || text);
		                });
	
		            } else {
		                return that._textAccessor();
		            }
		        },
	
		        _clearFilter: function() {
		            $(this.filterInput).val("");
		            Select.fn._clearFilter.call(this);
		        },
	
		        value: function(value) {
		            var that = this;
		            var listView = that.listView;
		            var dataSource = that.dataSource;
	
		            if (value === undefined) {
		                value = that._accessor() || that.listView.value()[0];
		                return value === undefined || value === null ? "" : value;
		            }
	
		            that.requireValueMapper(that.options, value);
	
		            if (value || !that.hasOptionLabel()) {
		                that._initialIndex = null;
		            }
	
		            this.trigger("set", { value: value });
	
		            if (that._request && that.options.cascadeFrom && that.listView.bound()) {
		                if (that._valueSetter) {
		                    dataSource.unbind(CHANGE, that._valueSetter);
		                }
	
		                that._valueSetter = proxy(function() { that.value(value); }, that);
	
		                dataSource.one(CHANGE, that._valueSetter);
		                return;
		            }
	
		            if (that._isFilterEnabled() && listView.bound() && listView.isFiltered()) {
		                that._clearFilter();
		            } else {
		                that._fetchData();
		            }
	
		            listView.value(value).done(function() {
		                that._old = that._accessor();
		                that._oldIndex = that.selectedIndex;
		            });
		        },
	
		        hasOptionLabel: function() {
		            return this.optionLabel && !!this.optionLabel[0];
		        },
	
		        _optionLabel: function() {
		            var that = this;
		            var options = that.options;
		            var optionLabel = options.optionLabel;
		            var template = options.optionLabelTemplate;
	
		            if (!optionLabel) {
		                that.optionLabel.off().remove();
		                that.optionLabel = $();
		                return;
		            }
	
		            if (!template) {
		                template = "#:";
	
		                if (typeof optionLabel === "string") {
		                    template += "data";
		                } else {
		                    template += kendo.expr(options.dataTextField, "data");
		                }
	
		                template += "#";
		            }
	
		            if (typeof template !== "function") {
		                template = kendo.template(template);
		            }
	
		            that.optionLabelTemplate = template;
	
		            if (!that.hasOptionLabel()) {
		                that.optionLabel = $('<div class="k-list-optionlabel"></div>').prependTo(that.list);
		            }
	
		            that.optionLabel.html(template(optionLabel))
		                            .off()
		                            .on(CLICKEVENTS, proxy(that._click, that))
		                            .on(HOVEREVENTS, that._toggleHover);
	
		            that.angular("compile", function() {
		                return { elements: that.optionLabel, data: [{ dataItem: that._optionLabelDataItem() }] };
		            });
		        },
	
		        _optionLabelText: function() {
		            var optionLabel = this.options.optionLabel;
		            return (typeof optionLabel === "string") ? optionLabel : this._text(optionLabel);
		        },
	
		        _optionLabelDataItem: function() {
		            var that = this;
		            var optionLabel = that.options.optionLabel;
	
		            if (that.hasOptionLabel()) {
		                return $.isPlainObject(optionLabel) ? new ObservableObject(optionLabel) : that._assignInstance(that._optionLabelText(), "");
		            }
	
		            return undefined;
		        },
	
		        _buildOptions: function(data) {
		            var that = this;
		            if (!that._isSelect) {
		                return;
		            }
	
		            var value = that.listView.value()[0];
		            var optionLabel = that._optionLabelDataItem();
		            var optionLabelValue = optionLabel && that._value(optionLabel);
	
		            if (value === undefined || value === null) {
		                value = "";
		            }
	
		            if (optionLabel) {
		                if (optionLabelValue === undefined || optionLabelValue === null) {
		                    optionLabelValue = "";
		                }
	
		                optionLabel = '<option value="' + optionLabelValue + '">' + that._text(optionLabel) + "</option>";
		            }
	
		            that._options(data, optionLabel, value);
	
		            if (value !== List.unifyType(that._accessor(), typeof value)) {
		                that._customOption = null;
		                that._custom(value);
		            }
		        },
	
		        _listBound: function() {
		            var that = this;
		            var initialIndex = that._initialIndex;
		            var filtered = that._state === STATE_FILTER;
	
		            var data = that.dataSource.flatView();
		            var dataItem;
	
		            that._presetValue = false;
	
		            that._renderFooter();
		            that._renderNoData();
		            that._toggleNoData(!data.length);
	
		            that._resizePopup(true);
	
		            that.popup.position();
	
		            that._buildOptions(data);
	
		            that._makeUnselectable();
	
		            if (!filtered) {
		                if (that._open) {
		                    that.toggle(that._allowOpening());
		                }
	
		                that._open = false;
	
		                if (!that._fetch) {
		                    if (data.length) {
		                        if (!that.listView.value().length && initialIndex > -1 && initialIndex !== null) {
		                            that.select(initialIndex);
		                        }
	
		                        that._initialIndex = null;
		                        dataItem = that.listView.selectedDataItems()[0];
		                        if (dataItem && that.text() !== that._text(dataItem)) {
		                            that._selectValue(dataItem);
		                        }
		                    } else if (that._textAccessor() !== that._optionLabelText()) {
		                        that.listView.value("");
		                        that._selectValue(null);
		                        that._oldIndex = that.selectedIndex;
		                    }
		                }
		            }
	
		            that._hideBusy();
		            that.trigger("dataBound");
		        },
	
		        _listChange: function() {
		            this._selectValue(this.listView.selectedDataItems()[0]);
	
		            if (this._presetValue || (this._old && this._oldIndex === -1)) {
		                this._oldIndex = this.selectedIndex;
		            }
		        },
	
		        _filterPaste: function() {
		            this._search();
		        },
	
		        _attachFocusHandlers: function() {
		            var that = this;
		            var wrapper = that.wrapper;
	
		            wrapper.on("focusin" + nsFocusEvent, proxy(that._focusinHandler, that))
		                   .on("focusout" + nsFocusEvent, proxy(that._focusoutHandler, that));
		            if(that.filterInput) {
		                that.filterInput.on("focusin" + nsFocusEvent, proxy(that._focusinHandler, that))
		                   .on("focusout" + nsFocusEvent, proxy(that._focusoutHandler, that));
		            }
		        },
	
		        _focusHandler: function() {
		            this.wrapper.focus();
		        },
	
		        _focusinHandler: function() {
		            this._inputWrapper.addClass(FOCUSED);
		            this._prevent = false;
		        },
	
		        _focusoutHandler: function() {
		            var that = this;
		            var isIFrame = window.self !== window.top;
	
		            if (!that._prevent) {
		                clearTimeout(that._typingTimeout);
	
		                if (support.mobileOS.ios && isIFrame) {
		                    that._change();
		                } else {
		                    that._blur();
		                }
	
		                that._inputWrapper.removeClass(FOCUSED);
		                that._prevent = true;
		                that._open = false;
		                that.element.blur();
		            }
		        },
	
		        _wrapperMousedown: function() {
		            this._prevent = !!this.filterInput;
		        },
	
		        _wrapperClick: function(e) {
		            e.preventDefault();
		            this.popup.unbind("activate", this._focusInputHandler);
		            this._focused = this.wrapper;
		            this._prevent = false;
		            this._toggle();
		        },
	
		        _editable: function(options) {
		            var that = this;
		            var element = that.element;
		            var disable = options.disable;
		            var readonly = options.readonly;
		            var wrapper = that.wrapper.add(that.filterInput).off(ns);
		            var dropDownWrapper = that._inputWrapper.off(HOVEREVENTS);
	
		            if (!readonly && !disable) {
		                element.removeAttr(DISABLED).removeAttr(READONLY);
	
		                dropDownWrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                wrapper
		                    .attr(TABINDEX, wrapper.data(TABINDEX))
		                    .attr(ARIA_DISABLED, false)
		                    .on("keydown" + ns, proxy(that._keydown, that))
		                    .on(kendo.support.mousedown + ns, proxy(that._wrapperMousedown, that))
		                    .on("paste" + ns, proxy(that._filterPaste, that));
	
		                that.wrapper.on("click" + ns, proxy(that._wrapperClick, that));
	
		                if (!that.filterInput) {
		                    wrapper.on("keypress" + ns, proxy(that._keypress, that));
		                } else {
		                    wrapper.on("input" + ns, proxy(that._search, that));
		                }
	
		            } else if (disable) {
		                wrapper.removeAttr(TABINDEX);
		                dropDownWrapper
		                    .addClass(STATEDISABLED)
		                    .removeClass(DEFAULT);
		            } else {
		                dropDownWrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED);
		            }
	
		            element.attr(DISABLED, disable)
		                   .attr(READONLY, readonly);
	
		            wrapper.attr(ARIA_DISABLED, disable);
		        },
	
		        _keydown: function(e) {
		            var that = this;
		            var key = e.keyCode;
		            var altKey = e.altKey;
		            var isInputActive;
		            var handled;
	
		            var isPopupVisible = that.popup.visible();
	
		            if (that.filterInput) {
		                isInputActive = that.filterInput[0] === activeElement();
		            }
	
		            if (key === keys.LEFT) {
		                key = keys.UP;
		                handled = true;
		            } else if (key === keys.RIGHT) {
		                key = keys.DOWN;
		                handled = true;
		            }
	
		            if (handled && isInputActive) {
		                return;
		            }
	
		            e.keyCode = key;
	
		            if ((altKey && key === keys.UP) || key === keys.ESC) {
		                that._focusElement(that.wrapper);
		            }
	
		            if (that._state === STATE_FILTER && key === keys.ESC) {
		                that._clearFilter();
		                that._open = false;
		                that._state = STATE_ACCEPT;
		            }
	
		            if (key === keys.ENTER && that._typingTimeout && that.filterInput && isPopupVisible) {
		                e.preventDefault();
		                return;
		            }
	
		            if (key === keys.SPACEBAR && !isInputActive) {
		                that.toggle(!isPopupVisible);
		                e.preventDefault();
		            }
	
		            handled = that._move(e);
	
		            if (handled) {
		                return;
		            }
	
		            if (!isPopupVisible || !that.filterInput) {
		                var current = that._focus();
	
		                if (key === keys.HOME) {
		                    handled = true;
		                    that._firstItem();
		                } else if (key === keys.END) {
		                    handled = true;
		                    that._lastItem();
		                }
	
		                if (handled) {
		                    if (that.trigger("select", { dataItem: that._getElementDataItem(that._focus()), item: that._focus() })) {
		                        that._focus(current);
		                        return;
		                    }
	
		                    that._select(that._focus(), true).done(function() {
		                        if (!isPopupVisible) {
		                            that._blur();
		                        }
		                    });
		                    e.preventDefault();
		                }
		            }
	
		            if (!altKey && !handled && that.filterInput) {
		                that._search();
		            }
		        },
	
		        _matchText: function(text, word) {
		            var ignoreCase = this.options.ignoreCase;
	
		            if (text === undefined || text === null) {
		                return false;
		            }
	
		            text = text + "";
	
		            if (ignoreCase) {
		                text = text.toLowerCase();
		            }
	
		            return text.indexOf(word) === 0;
		        },
	
		        _shuffleData: function(data, splitIndex) {
		            var optionDataItem = this._optionLabelDataItem();
	
		            if (optionDataItem) {
		                data = [optionDataItem].concat(data);
		            }
	
		            return data.slice(splitIndex).concat(data.slice(0, splitIndex));
		        },
	
		        _selectNext: function() {
		            var that = this;
		            var data = that.dataSource.flatView();
		            var dataLength = data.length + (that.hasOptionLabel() ? 1 : 0);
		            var isInLoop = sameCharsOnly(that._word, that._last);
		            var startIndex = that.selectedIndex;
		            var oldFocusedItem;
		            var text;
	
		            if (startIndex === -1) {
		                startIndex = 0;
		            } else {
		                startIndex += isInLoop ? 1 : 0;
		                startIndex = normalizeIndex(startIndex, dataLength);
		            }
	
		            data = data.toJSON ? data.toJSON() : data.slice();
		            data = that._shuffleData(data, startIndex);
	
		            for (var idx = 0; idx < dataLength; idx++) {
		                text = that._text(data[idx]);
	
		                if (isInLoop && that._matchText(text, that._last)) {
		                    break;
		                } else if (that._matchText(text, that._word)) {
		                    break;
		                }
		            }
	
		            if (idx !== dataLength) {
		                oldFocusedItem = that._focus();
	
		                that._select(normalizeIndex(startIndex + idx, dataLength)).done(function() {
		                    var done = function() {
		                        if (!that.popup.visible()) {
		                            that._change();
		                        }
		                    };
	
		                    if (that.trigger("select", { dataItem: that._getElementDataItem(that._focus()), item: that._focus() })) {
		                        that._select(oldFocusedItem).done(done);
		                    } else {
		                        done();
		                    }
		                });
		            }
		        },
	
		        _keypress: function(e) {
		            var that = this;
	
		            if (e.which === 0 || e.keyCode === kendo.keys.ENTER) {
		                return;
		            }
	
		            var character = String.fromCharCode(e.charCode || e.keyCode);
	
		            if (that.options.ignoreCase) {
		                character = character.toLowerCase();
		            }
	
		            if (character === " ") {
		                e.preventDefault();
		            }
	
		            that._word += character;
		            that._last = character;
	
		            that._search();
		        },
	
		        _popupOpen: function() {
		            var popup = this.popup;
	
		            popup.wrapper = kendo.wrap(popup.element);
	
		            if (popup.element.closest(".km-root")[0]) {
		                popup.wrapper.addClass("km-popup km-widget");
		                this.wrapper.addClass("km-widget");
		            }
		        },
	
		        _popup: function() {
		            Select.fn._popup.call(this);
		            this.popup.one("open", proxy(this._popupOpen, this));
		        },
	
		        _getElementDataItem: function(element) {
		            if (!element || !element[0]) {
		                return null;
		            }
	
		            if (element[0] === this.optionLabel[0]) {
		                return this._optionLabelDataItem();
		            }
	
		            return this.listView.dataItemByIndex(this.listView.getElementIndex(element));
		        },
	
		        _click: function (e) {
		            var that = this;
		            var item = e.item || $(e.currentTarget);
	
		            e.preventDefault();
	
		            if (that.trigger("select", { dataItem: that._getElementDataItem(item), item: item })) {
		                that.close();
		                return;
		            }
	
		            that._userTriggered = true;
	
		            that._select(item).done(function() {
		                that._focusElement(that.wrapper);
		                that._blur();
		            });
		        },
	
		        _focusElement: function(element) {
		            var active = activeElement();
		            var wrapper = this.wrapper;
		            var filterInput = this.filterInput;
		            var compareElement = element === filterInput ? wrapper : filterInput;
		            var touchEnabled = support.mobileOS && (support.touch || support.MSPointers || support.pointers);
	
		            if (filterInput && filterInput[0] === element[0] && touchEnabled) {
		                return;
		            }
	
		            if (filterInput && (compareElement[0] === active || this._focusFilter)) {
		                this._focusFilter = false;
		                this._prevent = true;
		                this._focused = element.focus();
		            }
		        },
	
		        _searchByWord: function(word) {
		            if (!word) {
		                return;
		            }
	
		            var that = this;
		            var ignoreCase = that.options.ignoreCase;
	
		            if (ignoreCase) {
		                word = word.toLowerCase();
		            }
	
		            that._select(function(dataItem) {
		                return that._matchText(that._text(dataItem), word);
		            });
		        },
	
		        _inputValue: function() {
		            return this.text();
		        },
	
		        _search: function() {
		            var that = this;
		            var dataSource = that.dataSource;
	
		            clearTimeout(that._typingTimeout);
	
		            if (that._isFilterEnabled()) {
		                that._typingTimeout = setTimeout(function() {
		                    var value = that.filterInput.val();
	
		                    if (that._prev !== value) {
		                        that._prev = value;
		                        that.search(value);
		                        that._resizeFilterInput();
		                    }
	
		                    that._typingTimeout = null;
		                }, that.options.delay);
		            } else {
		                that._typingTimeout = setTimeout(function() {
		                    that._word = "";
		                }, that.options.delay);
	
		                if (!that.listView.bound()) {
		                    dataSource.fetch().done(function () {
		                        that._selectNext();
		                    });
		                    return;
		                }
	
		                that._selectNext();
		            }
		        },
	
		        _get: function(candidate) {
		            var data, found, idx;
		            var isFunction = typeof candidate === "function";
		            var jQueryCandidate = !isFunction ? $(candidate) : $();
	
		            if (this.hasOptionLabel()) {
		                if (typeof candidate === "number") {
		                    if (candidate > -1) {
		                        candidate -= 1;
		                    }
		                } else if (jQueryCandidate.hasClass("k-list-optionlabel")) {
		                    candidate = -1;
		                }
		            }
	
		            if (isFunction) {
		                data = this.dataSource.flatView();
	
		                for (idx = 0; idx < data.length; idx++) {
		                    if (candidate(data[idx])) {
		                        candidate = idx;
		                        found = true;
		                        break;
		                    }
		                }
	
		                if (!found) {
		                    candidate = -1;
		                }
		            }
	
		            return candidate;
		        },
	
		        _firstItem: function() {
		            if (this.hasOptionLabel()) {
		                this._focus(this.optionLabel);
		            } else {
		                this.listView.focusFirst();
		            }
		        },
	
		        _lastItem: function() {
		            this._resetOptionLabel();
		            this.listView.focusLast();
		        },
	
		        _nextItem: function() {
		            if (this.optionLabel.hasClass("k-state-focused")) {
		                this._resetOptionLabel();
		                this.listView.focusFirst();
		            } else {
		                this.listView.focusNext();
		            }
		        },
	
		        _prevItem: function() {
		            if (this.optionLabel.hasClass("k-state-focused")) {
		                return;
		            }
	
		            this.listView.focusPrev();
		            if (!this.listView.focus()) {
		                this._focus(this.optionLabel);
		            }
		        },
	
		        _focusItem: function() {
		            var options = this.options;
		            var listView = this.listView;
		            var focusedItem = listView.focus();
		            var index = listView.select();
	
		            index = index[index.length - 1];
	
		            if (index === undefined && options.highlightFirst && !focusedItem) {
		                index = 0;
		            }
	
		            if (index !== undefined) {
		                listView.focus(index);
		            } else {
		                if (options.optionLabel && (!options.virtual || options.virtual.mapValueTo !== "dataItem")) {
		                    this._focus(this.optionLabel);
		                    this._select(this.optionLabel);
		                    this.listView.content.scrollTop(0);
		                } else {
		                    listView.scrollToIndex(0);
		                }
		            }
		        },
	
		        _resetOptionLabel: function(additionalClass) {
		            this.optionLabel.removeClass("k-state-focused" + (additionalClass || "")).removeAttr("id");
		        },
	
		        _focus: function(candidate) {
		            var listView = this.listView;
		            var optionLabel = this.optionLabel;
	
		            if (candidate === undefined) {
		                candidate = listView.focus();
	
		                if (!candidate && optionLabel.hasClass("k-state-focused")) {
		                    candidate = optionLabel;
		                }
	
		                return candidate;
		            }
	
		            this._resetOptionLabel();
	
		            candidate = this._get(candidate);
	
		            listView.focus(candidate);
	
		            if (candidate === -1) {
		                optionLabel.addClass("k-state-focused")
		                           .attr("id", listView._optionID);
	
		                this._focused.add(this.filterInput)
		                    .removeAttr("aria-activedescendant")
		                    .attr("aria-activedescendant", listView._optionID);
		            }
		        },
	
		        _select: function(candidate, keepState) {
		            var that = this;
	
		            candidate = that._get(candidate);
	
		            return that.listView.select(candidate).done(function() {
		                if (!keepState && that._state === STATE_FILTER) {
		                    that._state = STATE_ACCEPT;
		                }
	
		                if (candidate === -1) {
		                    that._selectValue(null);
		                }
		            });
		        },
	
		        _selectValue: function(dataItem) {
		            var that = this;
		            var optionLabel = that.options.optionLabel;
		            var idx = that.listView.select();
	
		            var value = "";
		            var text = "";
	
		            idx = idx[idx.length - 1];
		            if (idx === undefined) {
		                idx = -1;
		            }
	
		            this._resetOptionLabel(" k-state-selected");
	
		            if (dataItem || dataItem === 0) {
		                text = dataItem;
		                value = that._dataValue(dataItem);
		                if (optionLabel) {
		                    idx += 1;
		                }
		            } else if (optionLabel) {
		                that._focus(that.optionLabel.addClass("k-state-selected"));
	
		                text = that._optionLabelText();
	
		                if (typeof optionLabel === "string") {
		                    value = "";
		                } else {
		                    value = that._value(optionLabel);
		                }
	
		                idx = 0;
		            }
	
		            that.selectedIndex = idx;
	
		            if (value === null) {
		                value = "";
		            }
	
		            that._textAccessor(text);
		            that._accessor(value, idx);
	
		            that._triggerCascade();
		        },
	
		        _mobile: function() {
		            var that = this,
		                popup = that.popup,
		                mobileOS = support.mobileOS,
		                root = popup.element.parents(".km-root").eq(0);
	
		            if (root.length && mobileOS) {
		                popup.options.animation.open.effects = (mobileOS.android || mobileOS.meego) ? "fadeIn" : (mobileOS.ios || mobileOS.wp) ? "slideIn:up" : popup.options.animation.open.effects;
		            }
		        },
	
		        _filterHeader: function() {
		            var icon;
	
		            if (this.filterInput) {
		                this.filterInput
		                    .off(ns)
		                    .parent()
		                    .remove();
	
		                this.filterInput = null;
		            }
	
		            if (this._isFilterEnabled()) {
		                icon = '<span class="k-icon k-i-zoom"></span>';
	
		                this.filterInput = $('<input class="k-textbox"/>')
		                                      .attr({
		                                          placeholder: this.element.attr("placeholder"),
		                                          title: this.element.attr("title"),
		                                          role: "listbox",
		                                          "aria-haspopup": true,
		                                          "aria-expanded": false
		                                      });
		                this.list
		                    .prepend($('<span class="k-list-filter" />')
		                    .append(this.filterInput.add(icon)));
		            }
		        },
	
		        _span: function() {
		            var that = this,
		                wrapper = that.wrapper,
		                SELECTOR = "span.k-input",
		                span;
	
		            span = wrapper.find(SELECTOR);
	
		            if (!span[0]) {
		                wrapper.append('<span unselectable="on" class="k-dropdown-wrap k-state-default"><span unselectable="on" class="k-input">&nbsp;</span><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>')
		                       .append(that.element);
	
		                span = wrapper.find(SELECTOR);
		            }
	
		            that.span = span;
		            that._inputWrapper = $(wrapper[0].firstChild);
		            that._arrow = wrapper.find(".k-select");
		            that._arrowIcon = that._arrow.find(".k-icon");
		        },
	
		        _wrapper: function() {
		            var that = this,
		                element = that.element,
		                DOMelement = element[0],
		                wrapper;
	
		            wrapper = element.parent();
	
		            if (!wrapper.is("span.k-widget")) {
		                wrapper = element.wrap("<span />").parent();
		                wrapper[0].style.cssText = DOMelement.style.cssText;
		                wrapper[0].title = DOMelement.title;
		            }
	
		            that._focused = that.wrapper = wrapper
		                .addClass("k-widget k-dropdown")
		                .addClass(DOMelement.className)
		                .css("display", "")
		                .attr({
		                    accesskey: element.attr("accesskey"),
		                    unselectable: "on",
		                    role: "listbox",
		                    "aria-haspopup": true,
		                    "aria-expanded": false
		                });
	
		            element.hide().removeAttr("accesskey");
		        },
	
		        _clearSelection: function(parent) {
		            this.select(parent.value() ? 0 : -1);
		        },
	
		        _inputTemplate: function() {
		            var that = this,
		                template = that.options.valueTemplate;
	
	
		            if (!template) {
		                template = $.proxy(kendo.template('#:this._text(data)#', { useWithBlock: false }), that);
		            } else {
		                template = kendo.template(template);
		            }
	
		            that.valueTemplate = template;
	
		            if (that.hasOptionLabel() && !that.options.optionLabelTemplate) {
		                try {
		                    that.valueTemplate(that._optionLabelDataItem());
		                } catch(e) {
		                    throw new Error(MSG_INVALID_OPTION_LABEL);
		                }
		            }
		        },
	
		        _textAccessor: function(text) {
		            var dataItem = null;
		            var template = this.valueTemplate;
		            var optionLabelText = this._optionLabelText();
		            var span = this.span;
	
		            if (text === undefined) {
		                return span.text();
		            }
	
		            if ($.isPlainObject(text) || text instanceof ObservableObject) {
		                dataItem = text;
		            } else if (optionLabelText && optionLabelText === text) {
		                dataItem = this.options.optionLabel;
		            }
	
		            if (!dataItem) {
		                dataItem = this._assignInstance(text, this._accessor());
		            }
	
		            if (this.hasOptionLabel()) {
		                if (dataItem === optionLabelText || this._text(dataItem) === optionLabelText) {
		                    template = this.optionLabelTemplate;
	
		                    if (typeof this.options.optionLabel === "string" && !this.options.optionLabelTemplate) {
		                        dataItem = optionLabelText;
		                    }
		                }
		            }
	
		            var getElements = function(){
		                return {
		                    elements: span.get(),
		                    data: [ { dataItem: dataItem } ]
		                };
		            };
	
		            this.angular("cleanup", getElements);
	
		            try {
		                span.html(template(dataItem));
		            } catch(e) {
		                //dataItem has missing fields required in custom template
		                span.html("");
		            }
	
		            this.angular("compile", getElements);
		        },
	
		        _preselect: function(value, text) {
		            if (!value && !text) {
		                text = this._optionLabelText();
		            }
	
		            this._accessor(value);
		            this._textAccessor(text);
	
		            this._old = this._accessor();
		            this._oldIndex = this.selectedIndex;
	
		            this.listView.setValue(value);
	
		            this._initialIndex = null;
		            this._presetValue = true;
		        },
	
		        _assignInstance: function(text, value) {
		            var dataTextField = this.options.dataTextField;
		            var dataItem = {};
	
		            if (dataTextField) {
		                assign(dataItem, dataTextField.split("."), text);
		                assign(dataItem, this.options.dataValueField.split("."), value);
		                dataItem = new ObservableObject(dataItem);
		            } else {
		                dataItem = text;
		            }
	
		            return dataItem;
		        }
		    });
	
		    function assign(instance, fields, value) {
		        var idx = 0,
		            lastIndex = fields.length - 1,
		            field;
	
		        for (; idx < lastIndex; ++idx) {
		            field = fields[idx];
	
		            if (!(field in instance)) {
		                instance[field] = {};
		            }
	
		            instance = instance[field];
		        }
	
		        instance[fields[lastIndex]] = value;
		    }
	
		    function normalizeIndex(index, length) {
		        if (index >= length) {
		            index -= length;
		        }
		        return index;
		    }
	
		    function sameCharsOnly(word, character) {
		        for (var idx = 0; idx < word.length; idx++) {
		            if (word.charAt(idx) !== character) {
		                return false;
		            }
		        }
		        return true;
		    }
	
		    ui.plugin(DropDownList);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1131);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1131:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1132), __webpack_require__(1036) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dropdowntree",
		    name: "DropDownTree",
		    category: "web",
		    description: "The DropDownTree widget displays a hierarchy of items and allows the selection of single or multiple items.",
		    depends: [ "treeview", "popup" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        TreeView = ui._dropdowntree,
		        ObservableArray = kendo.data.ObservableArray,
		        ObservableObject = kendo.data.ObservableObject,
		        extend = $.extend,
		        activeElement = kendo._activeElement,
		        ns = ".kendoDropDownTree",
		        keys = kendo.keys,
		        support = kendo.support,
		        HIDDENCLASS = "k-hidden",
		        WIDTH = "width",
		        browser = support.browser,
		        outerWidth = kendo._outerWidth,
		        DOT = ".",
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        STATEDISABLED = "k-state-disabled",
		        ARIA_DISABLED = "aria-disabled",
		        HOVER = "k-state-hover",
		        FOCUSED = "k-state-focused",
		        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		        TABINDEX = "tabindex",
		        CLICK = "click",
		        OPEN = "open",
		        CLOSE = "close",
		        CHANGE = "change",
		        proxy = $.proxy;
	
		    var DropDownTree = kendo.ui.Widget.extend( {
		        init: function(element, options) {
		            this.ns = ns;
	
		            kendo.ui.Widget.fn.init.call(this, element, options);
		            this._selection = this._getSelection();
		            this._focusInputHandler = $.proxy(this._focusInput, this);
		            this._initial = this.element.val();
	
		            this._values = [];
	
		            var value = this.options.value;
	
		            if (value === null || !value.length) {
		                this._noInitialValue = true;
		            }
	
		            if (value) {
		                this._valueMethodCalled = true;
		                this._values = $.isArray(value) ? value.slice(0) : [value];
		            }
	
		            this._inputTemplate();
	
		            this._accessors();
		            this._setTreeViewOptions(this.options);
		            this._dataSource();
		            this._selection._initWrapper();
		            this._placeholder(true);
		            this._tabindex();
		            this.wrapper.data(TABINDEX, this.wrapper.attr(TABINDEX));
	
		            this.tree = $('<div/>')
		            .attr({
		                tabIndex: -1,
		                "aria-hidden": true
		            });
	
		            this.list = $("<div class='k-list-container'/>")
		                .append(this.tree);
	
		            this._header();
		            this._noData();
		            this._footer();
		            this._reset();
		            this._popup();
		            this.popup.one("open", proxy(this._popupOpen, this));
		            this._clearButton();
		            this._filterHeader();
		            this._treeview();
	
		            this._renderFooter();
	
		            this._checkAll();
		            this._enable();
		            this._toggleCloseVisibility();
	
		            if (!this.options.autoBind) {
		                var text = options.text || "";
		                if (options.value) {
		                    this._preselect(options.value);
		                } else if (text) {
		                    this._textAccessor(text);
		                } else if (options.placeholder) {
		                    this._placeholder(true);
		                }
		            }
	
		            var disabled = $(this.element).parents("fieldset").is(':disabled');
	
		            if (disabled) {
		                this.enable(false);
		            }
		            this._valueMethodCalled = false;
		            kendo.notify(this);
		        },
	
		        _preselect: function(data, value){
		            this._selection._preselect(data, value);
		        },
	
		        _setTreeViewOptions: function(options) {
		            var treeviewOptions = {
		                autoBind: options.autoBind,
		                checkboxes: options.checkboxes,
		                dataImageUrlField: options.dataImageUrlField,
		                dataSpriteCssClassField: options.dataSpriteCssClassField,
		                dataTextField: options.dataTextField,
		                dataUrlField: options.dataUrlField,
		                loadOnDemand: options.loadOnDemand
		            };
	
		            this.options.treeview = $.extend({}, treeviewOptions, this.options.treeview);
	
		            if (options.template) {
		                this.options.treeview.template = options.template;
		            }
		        },
	
		        _dataSource: function() {
		            var rootDataSource = this.options.dataSource;
	
		            this.dataSource = kendo.data.HierarchicalDataSource.create(rootDataSource);
		            if (rootDataSource) {
		                $.extend(this.options.treeview,{
		                    dataSource: this.dataSource
		                });
		            }
		        },
	
		        _popupOpen: function() {
		            var popup = this.popup;
		            popup.wrapper = kendo.wrap(popup.element);
		        },
	
		        _getSelection: function() {
		            if (this._isMultipleSelection()) {
		                return new ui.DropDownTree.MultipleSelection(this);
		            } else {
		                return new ui.DropDownTree.SingleSelection(this);
		            }
		        },
	
		        setDataSource: function(dataSource) {
		            this.dataSource = dataSource;
		            this.treeview.setDataSource(dataSource);
		        },
	
		        _isMultipleSelection: function() {
		            return this.options && (this.options.treeview.checkboxes || this.options.checkboxes);
		        },
	
		        options: {
		            name: "DropDownTree",
		            animation: {},
		            autoBind: true,
		            autoClose: true,
		            autoWidth: false,
		            clearButton: true,
		            dataTextField: "",
		            dataValueField: "",
		            dataImageUrlField: "",
		            dataSpriteCssClassField: "",
		            dataUrlField: "",
		            delay: 500,
		            enabled: true,
		            enforceMinLength: false,
		            filter: "none",
		            height: 200,
		            ignoreCase: true,
		            index: 0,
		            loadOnDemand: false,
		            messages: {
		                "singleTag": "item(s) selected",
		                "clear": "clear",
		                "deleteTag": "delete"
		            },
		            minLength: 1,
		            checkboxes: false,
		            noDataTemplate: "No data found.",
		            placeholder: "",
		            checkAll:false,
		            checkAllTemplate: "Check all",
		            tagMode: "multiple",
		            template: null,
		            text: null,
		            treeview: {},
		            valuePrimitive: false,
		            footerTemplate: "",
		            headerTemplate: "",
		            value: null,
		            valueTemplate: null
		        },
	
		        events: [
		            "open",
		            "close",
		            "dataBound",
		            CHANGE,
		            "select",
		            "filtering"
		        ],
	
		        focus: function() {
		            this.wrapper.focus();
		        },
	
		        dataItem: function (node){
		            return this.treeview.dataItem(node);
		        },
	
		        readonly: function(readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		            this._toggleCloseVisibility();
		        },
	
		        enable: function(enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		            this._toggleCloseVisibility();
		        },
	
		        toggle: function(open) {
		            this._toggle(open);
		        },
	
		        open: function() {
		            var popup = this.popup;
	
		            if(!this.options.autoBind && !this.dataSource.data().length){
		                this.treeview._progress(true);
		                if(this._isFilterEnabled()){
		                    this._search();
		                } else {
		                    this.dataSource.fetch();
		                }
		            }
	
		            if (popup.visible() || !this._allowOpening()) {
		                return;
		            }
	
		            if(this._isMultipleSelection()){
		                popup.element.addClass("k-multiple-selection");
		            }
		            popup.element.addClass("k-popup-dropdowntree");
	
		            popup.one("activate", this._focusInputHandler);
		            popup._hovered = true;
		            popup.open();
		        },
	
		        close: function() {
		            this.popup.close();
		        },
	
		        search: function(word) {
		            var options = this.options;
		            var filter;
		            clearTimeout(this._typingTimeout);
	
		            if ((!options.enforceMinLength && !word.length) || word.length >= options.minLength) {
		                filter = this._getFilter(word);
		                if(this.trigger("filtering", { filter: filter }) ||
		                 $.isArray(this.options.dataTextField)){
		                    return;
		                }
	
		                this._filtering = true;
		                this.treeview.dataSource.filter(filter);
		            }
		        },
	
		        _getFilter: function (word){
		            return {
		                field: this.options.dataTextField,
		                operator: this.options.filter,
		                value: word,
		                ignoreCase: this.options.ignoreCase
		              };
		        },
	
		        refresh: function() {
		            var data = this.treeview.dataSource.flatView();
		            this._renderFooter();
		            this._renderNoData();
		            if (this.filterInput && this.checkAll) {
		                this.checkAll.toggle(!this.filterInput.val().length);
		            }
	
		            this.tree.toggle(!!data.length);
		            $(this.noData).toggle(!data.length);
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
	
		            this._setTreeViewOptions(options);
		            this._dataSource();
		            if (this.options.treeview) {
		                this.treeview.setOptions(this.options.treeview);
		            }
	
		            if (options.height && this.tree) {
		                this.tree.css('max-height', options.height);
		            }
	
		            this._header();
		            this._noData();
		            this._footer();
	
		            this._renderFooter();
		            this._renderNoData();
		            if (this.span && (this._isMultipleSelection() || this.span.hasClass("k-readonly"))) {
		                this._placeholder(true);
		            }
		            this._inputTemplate();
		            this._accessors();
		            this._filterHeader();
		            this._checkAll();
		            this._enable();
		            if (options && (options.enable || options.enabled)) {
		                this.enable(true);
		            }
		            this._clearButton();
		        },
	
		        destroy: function() {
		            kendo.ui.Widget.fn.destroy.call(this);
		            if(this.treeview){
		                this.treeview.destroy();
		            }
		            this.popup.destroy();
	
		            this.wrapper.off(ns);
		            this._clear.off(ns);
		            this._inputWrapper.off(ns);
		            if (this.filterInput) {
		                this.filterInput.off(ns);
		            }
	
		            if(this.tagList){
		                this.tagList.off(ns);
		            }
	
		            kendo.unbind(this.tagList);
		            if (this.options.checkAll && this.checkAll) {
		                this.checkAll.off(ns);
		            }
	
		            if (this._form) {
		                this._form.off("reset", this._resetHandler);
		            }
		        },
	
		        setValue: function(value) {
		            value = $.isArray(value) || value instanceof ObservableArray ? value.slice(0) : [value];
	
		            this._values = value;
		        },
	
		        items: function() {
		            this.treeview.dataItems();
		        },
	
		        value: function(value) {
		            var that = this;
	
		            if(value){
		                if(that.filterInput && that.dataSource._filter){
		                    that._filtering = true;
		                    that.dataSource.filter({});
		                } else if (!that.dataSource.data().length){
		                    that.dataSource.fetch(function() {
		                        that._selection._setValue(value);
		                    });
	
		                    return;
		                }
		            }
	
		            return that._selection._setValue(value);
		        },
	
		        text: function(text) {
		            var loweredText;
		            var ignoreCase = this.options.ignoreCase;
	
		            text = text === null ? "" : text;
	
		            if (text !== undefined && !this._isMultipleSelection()) {
		                if (typeof text !== "string") {
		                    this._textAccessor(text);
		                    return;
		                }
	
		                loweredText = ignoreCase ? text : text.toLowerCase();
	
		                this._selectItemByText(loweredText);
	
		                this._textAccessor(loweredText);
		            } else {
		                return this._textAccessor();
		            }
		        },
	
		        _header: function() {
		            var list = this;
		            var header = $(list.header);
		            var template = list.options.headerTemplate;
	
		            this._angularElement(header, "cleanup");
		            kendo.destroy(header);
		            header.remove();
	
		            if (!template) {
		                list.header = null;
		                return;
		            }
	
		            var headerTemplate = typeof template !== "function" ? kendo.template(template) : template;
		            header = $(headerTemplate({}));
	
		            list.header = header[0] ? header : null;
		            list.list.prepend(header);
	
		            this._angularElement(list.header, "compile");
		        },
	
		        _noData: function() {
		            var list = this;
		            var noData = $(list.noData);
		            var template = list.options.noDataTemplate;
	
		            list.angular("cleanup", function() { return { elements: noData }; });
		            kendo.destroy(noData);
		            noData.remove();
	
		            if (!template) {
		                list.noData = null;
		                return;
		            }
	
		            list.noData = $('<div class="k-nodata" style="display:none"><div></div></div>').appendTo(list.list);
		            list.noDataTemplate = typeof template !== "function" ? kendo.template(template) : template;
		        },
	
		        _renderNoData: function() {
		            var list = this;
		            var noData = list.noData;
	
		            if (!noData) {
		                return;
		            }
	
		            this._angularElement(noData, "cleanup");
		            noData.children(":first").html(list.noDataTemplate({ instance: list }));
		            this._angularElement(noData, "compile");
		        },
	
		        _footer: function() {
		            var list = this;
		            var footer = $(list.footer);
		            var template = list.options.footerTemplate;
	
		            this._angularElement(footer, "cleanup");
		            kendo.destroy(footer);
		            footer.remove();
	
		            if (!template) {
		                list.footer = null;
		                return;
		            }
	
		            list.footer = $('<div class="k-footer"></div>').appendTo(list.list);
		            list.footerTemplate = typeof template !== "function" ? kendo.template(template) : template;
		        },
	
		        _renderFooter: function() {
		            var list = this;
		            var footer = list.footer;
	
		            if (!footer) {
		                return;
		            }
	
		            this._angularElement(footer, "cleanup");
		            footer.html(list.footerTemplate({ instance: list }));
		            this._angularElement(footer, "compile");
		        },
	
		        _enable: function() {
		            var that = this,
		                options = that.options,
		                disabled = that.element.is("[disabled]");
	
		            if (options.enable !== undefined) {
		                options.enabled = options.enable;
		            }
	
		            if (!options.enabled || disabled) {
		                that.enable(false);
		            } else {
		                that.readonly(that.element.is("[readonly]"));
		            }
		        },
	
		        _adjustListWidth: function() {
		            var that = this,
		                list = that.list,
		                width = list[0].style.width,
		                wrapper = that.wrapper,
		                computedStyle, computedWidth;
	
		            if (!list.data(WIDTH) && width) {
		                return;
		            }
	
		            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
		            computedWidth = parseFloat(computedStyle  && computedStyle.width) || outerWidth(wrapper);
	
		            if (computedStyle && browser.msie) { // getComputedStyle returns different box in IE.
		                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
		            }
	
		            if (list.css("box-sizing") !== "border-box") {
		                width = computedWidth - (outerWidth(list) - list.width());
		            } else {
		                width = computedWidth;
		            }
	
		            list.css({
		                fontFamily: wrapper.css("font-family"),
		                width: that.options.autoWidth ? "auto" : width,
		                minWidth: width,
		                whiteSpace: that.options.autoWidth ? "nowrap" : "normal"
		            })
		            .data(WIDTH, width);
	
		            return true;
		        },
	
		        _reset: function() {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    setTimeout(function() {
		                        that.value(that._initial);
		                    });
		                };
	
		                that._form = form.on("reset", that._resetHandler);
		            }
		        },
	
		        _popup: function() {
		            var list = this;
	
		            list.popup = new ui.Popup(list.list, extend({}, list.options.popup, {
		                anchor: list.wrapper,
		                open: proxy(list._openHandler, list),
		                close: proxy(list._closeHandler, list),
		                animation: list.options.animation,
		                isRtl: support.isRtl(list.wrapper),
		                autosize :list.options.autoWidth
		            }));
		        },
	
		        _angularElement: function(element, action) {
		            if (!element) {
		                return;
		            }
	
		            this.angular(action, function() {
		                return { elements: element };
		            });
		        },
	
		        _allowOpening: function() {
		            return this.options.noDataTemplate || this.treeview.dataSource.flatView().length;
		        },
	
		        _placeholder: function(show) {
		            if (this.span) {
		                this.span.toggleClass("k-readonly", show).text(show? this.options.placeholder: "");
		            }
		        },
	
		        _currentValue: function(dataItem) {
		            var currentValue = this._value(dataItem);
		            if (!currentValue && currentValue !== 0) {
		                currentValue = dataItem;
		            }
	
		            return currentValue;
		        },
	
		        _checkValue: function(dataItem) {
		            var value = "";
		            var indexOfValue = -1;
		            var currentValue = this.value();
		            var isMultiple = this.options.tagMode === "multiple";
	
		            if (dataItem || dataItem === 0) {
		                if(dataItem.level){
		                    dataItem._level = dataItem.level();
		                }
	
		                value = this._currentValue(dataItem);
	
		                indexOfValue = currentValue.indexOf(value);
		            }
	
		            if (dataItem.checked) {
		                var alreadyAddedTag = $.grep(this._tags, function( item ) {
		                    return item.uid === dataItem._tagUid;
		                });
	
		                if (alreadyAddedTag.length){
		                    return;
		                }
	
		                var itemToAdd = new ObservableObject(dataItem.toJSON());
		                dataItem._tagUid = itemToAdd.uid;
		                this._tags.push(itemToAdd);
	
		                if (this._tags.length === 1) {
		                    this.span.hide();
	
		                    if (!isMultiple) {
		                        this._multipleTags.push(itemToAdd);
		                    }
		                }
	
		                if (indexOfValue === -1) {
		                    currentValue.push(value);
		                    this.setValue(currentValue);
		                }
		            } else {
		                var itemToRemove = this._tags.find(function(item){
		                    return item.uid === dataItem._tagUid;
		                });
	
		                var idx = this._tags.indexOf(itemToRemove);
	
		                if (idx !== -1) {
		                    this._tags.splice(idx, 1);
		                } else {
		                    this._treeViewCheckAllCheck(dataItem);
		                    return;
		                }
	
		                if (this._tags.length === 0) {
		                    this.span.show();
		                    if (!isMultiple) {
		                        this._multipleTags.splice(0, 1);
		                    }
		                }
		                if (indexOfValue !== -1) {
		                    currentValue.splice(indexOfValue, 1);
		                    this.setValue(currentValue);
		                }
		            }
	
		            this._treeViewCheckAllCheck(dataItem);
		            if (!this._preventChangeTrigger && !this._valueMethodCalled && !this._noInitialValue) {
		                this.trigger(CHANGE);
		            }
	
		            if (this.options.autoClose && this.popup.visible()) {
		                this.close();
		                this.wrapper.focus();
		            }
		            this.popup.position();
		            this._toggleCloseVisibility();
		        },
	
		        _selectValue: function(dataItem) {
		            var value = "";
		            var text = "";
	
		            if (dataItem || dataItem === 0) {
		                if(dataItem.level){
		                    dataItem._level = dataItem.level();
		                }
		                text = this._text(dataItem) || dataItem;
		                value = this._currentValue(dataItem);
		            }
	
		            if (value === null) {
		                value = "";
		            }
		            this.setValue(value);
		            this._textAccessor(text, dataItem);
		            this._accessor(value);
	
		            if(!this._valueMethodCalled){
		                this.trigger(CHANGE);
		            }
		            this._valueMethodCalled = false;
	
		            if (this.options.autoClose && this.popup.visible()) {
		                this.close();
		                this.wrapper.focus();
		            }
		            this.popup.position();
		            this._toggleCloseVisibility();
		        },
	
		        _clearClick: function(e) {
		            e.stopPropagation();
		            this._clearTextAndValue();
		        },
	
		        _clearTextAndValue: function() {
		            this.setValue([]);
		            this._clearInput();
		            this._clearText();
		            this._selection._clearValue();
		            this.popup.position();
		            this._toggleCloseVisibility();
		        },
	
		        _clearText: function() {
		            if (this.options.placeholder) {
		                this._placeholder(true);
		            } else {
		                if (this.span) {
		                    this.span.html("");
		                }
		            }
		        },
	
		        _inputTemplate: function() {
		            var template = this.options.valueTemplate;
	
		            if (!template) {
		                template = $.proxy(kendo.template('#:this._text(data)#', { useWithBlock: false }), this);
		            } else {
		                template = kendo.template(template);
		            }
	
		            this.valueTemplate = template;
		        },
	
		        _assignInstance: function(text, value) {
		            var dataTextField = this.options.dataTextField;
		            var dataItem = {};
	
		            if (dataTextField) {
		                assign(dataItem, dataTextField.split(DOT), text);
		                assign(dataItem, this.options.dataValueField.split(DOT), value);
		                dataItem = new ObservableObject(dataItem);
		            } else {
		                dataItem = text;
		            }
	
		            return dataItem;
		        },
	
		        _textAccessor: function(text, dataItem) {
		            var valueTemplate = this.valueTemplate;
		            var span = this.span;
	
		            if (text === undefined) {
		                return span.text();
		            }
	
		            span.removeClass("k-readonly");
	
		            if (!dataItem && ($.isPlainObject(text) || text instanceof ObservableObject)) {
		                dataItem = text;
		            }
	
		            if (!dataItem) {
		                dataItem = this._assignInstance(text, this._accessor());
		            }
	
		            var getElements = function() {
		                return {
		                    elements: span.get(),
		                    data: [ { dataItem: dataItem } ]
		                };
		            };
	
		            this.angular("cleanup", getElements);
	
		            try {
		                span.html(valueTemplate(dataItem));
		            } catch(e) {
		                //dataItem has missing fields required in custom template
		                if (span) {
		                    span.html("");
		                }
		            }
	
		            this.angular("compile", getElements);
		        },
	
		        _accessors: function() {
		            var element = this.element;
		            var options = this.options;
		            var getter = kendo.getter;
		            var textField = element.attr(kendo.attr("text-field"));
		            var valueField = element.attr(kendo.attr("value-field"));
	
		            var getterFunction = function (field) {
		                if ($.isArray(field)) {
		                    var count = field.length;
		                    var levels = $.map(field, function(x) {
		                        return function(d){ return d[x];};
		                    });
	
		                    return function (dataItem) {
		                        var level = dataItem._level;
	
		                        if(!level && level !== 0){
		                            return;
		                        }
	
		                        return levels[Math.min(level, count-1)](dataItem);
		                    };
		                } else {
		                    return getter(field);
		                }
		            };
	
		            if (!options.dataTextField && textField) {
		                options.dataTextField = textField;
		            }
	
		            if (!options.dataValueField && valueField) {
		                options.dataValueField = valueField;
		            }
	
		            options.dataTextField = options.dataTextField || "text";
		            options.dataValueField = options.dataValueField || "value";
	
		            this._text = getterFunction(options.dataTextField);
		            this._value = getterFunction(options.dataValueField);
		        },
	
		        _accessor: function(value, idx) {
		            return this._accessorInput(value, idx);
		        },
	
		        _accessorInput: function(value) {
		            var element = this.element[0];
	
		            if (value === undefined) {
		                return element.value;
		            } else {
		                if (value === null) {
		                    value = "";
		                }
		                element.value = value;
		            }
		        },
	
		        _clearInput: function() {
		            var element = this.element[0];
		            element.value = "";
		        },
	
		        _clearButton: function() {
		            var clearTitle = (this.options.messages && this.options.messages.clear) ? this.options.messages.clear: "clear";
	
		            if(!this._clear){
		                this._clear = $('<span unselectable="on" class="k-icon k-clear-value k-i-close" title="' + clearTitle + '"></span>').attr({
		                    "role": "button",
		                    "tabIndex": -1
		                });
		            }
	
		            if (this.options.clearButton) {
		                this._clear.insertAfter(this.span);
		                this.wrapper.addClass("k-dropdowntree-clearable");
		            } else {
		                if (!this.options.clearButton) {
		                    this._clear.remove();
		                }
		            }
		        },
	
		        _toggleCloseVisibility: function() {
		            var isReadOnly = this.element.attr(READONLY);
		            var hasValue = (this.value() && !this._isMultipleSelection()) || this.value().length;
		            var valueDoesNotEqualPlaceHolder = this.element.val() && this.element.val() !== this.options.placeholder;
	
		            if ((!isReadOnly && (hasValue || valueDoesNotEqualPlaceHolder))) {
		                this._showClear();
		            } else {
		                this._hideClear();
		            }
		        },
	
		        _showClear: function() {
		            if(this._clear) {
		                this._clear.removeClass(HIDDENCLASS);
		            }
		        },
	
		        _hideClear: function() {
		            if(this._clear) {
		                this._clear.addClass(HIDDENCLASS);
		            }
		        },
	
		        _openHandler: function(e) {
		            this._adjustListWidth();
	
		            if (this.trigger(OPEN)) {
		                e.preventDefault();
		            } else {
		                 this.wrapper.attr("aria-expanded", true);
		                 this.tree.attr("aria-hidden", false).attr("role", "tree");
		            }
		        },
	
		        _closeHandler: function(e) {
		            if (this.trigger(CLOSE)) {
		                e.preventDefault();
		            } else {
		                 this.wrapper.attr("aria-expanded", false);
		                 this.tree.attr("aria-hidden", true);
		            }
		        },
	
		        _treeview: function() {
		            var that = this;
		            if (that.options.height) {
		                that.tree.css('max-height',that.options.height);
		            }
		            that.tree.attr('id', kendo.guid());
		            that.treeview = new TreeView(that.tree, 
		                extend({
		                    select: that.options.select
		                },that.options.treeview), that);
		            that.dataSource = that.treeview.dataSource;
		        },
	
		        _treeViewDataBound: function(e) {
		            if (e.node && this._prev && this._prev.length) {
		                e.sender.expand(e.node);
		            }
	
		            if(this._filtering){
		                if(!e.node){
		                    this._filtering = false;
		                }
		               
		                if (!this._isMultipleSelection()) {
		                    this._deselectItem(e);
		                }
		                return;
		            }
	
		            if (!this.treeview) {
		                this.treeview = e.sender;
		            }
	
		            if (!e.node) {
		                var rootItems = e.sender.dataSource.data();
		                this._checkLoadedItems(rootItems);
		                if(this._noInitialValue){
		                    this._noInitialValue = false;
		                }
		            } else {
		                var rootItem = e.sender.dataItem(e.node);
		                if (rootItem) {
		                    var subItems = rootItem.children.data();
		                    this._checkLoadedItems(subItems);
		                }
		            }
		            this.trigger("dataBound", e);
		        },
	
		        _deselectItem: function(e){
		            var items = [];
		            if (!e.node) {
		                items = e.sender.dataSource.data();
		            } else {
		                var rootItem = e.sender.dataItem(e.node);
		                if (rootItem) {
		                    items = rootItem.children.data();
		                }
		            }
	
		            for (var i = 0; i < items.length; i++) {
		                if (items[i].selected &&
		                    !this._valueComparer(items[i], this.value())) {
		                    items[i].set("selected", false);
		                }
		            }
		        },
	
		        _checkLoadedItems: function(items) {
		            var value = this.value();
	
		            if(!items){
		                return;
		            }
	
		            for (var idx = 0; idx < items.length; idx++) {
		                this._selection._checkLoadedItem(items[idx], value);
		            }
		        },
	
		        _treeViewCheckAllCheck: function(dataItem) {
		            if (this.options.checkAll && this.checkAll) {
		                this._getAllChecked();
	
		                if (dataItem.checked) {
		                    this._checkCheckAll();
		                } else {
		                    this._uncheckCheckAll();
		                }
		            }
		        },
	
		        _checkCheckAll: function() {
		            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
	
		            if (this._allItemsAreChecked) {
		                checkAllCheckbox.prop('checked', true)
		                                .prop('indeterminate', false);
		            } else {
		                checkAllCheckbox.prop('indeterminate', true);
		            }
		        },
	
		        _uncheckCheckAll: function() {
		            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
	
		            if (this._allItemsAreUnchecked) {
		                checkAllCheckbox.prop('checked', false)
		                                .prop('indeterminate', false);
		            } else {
		                checkAllCheckbox.prop('indeterminate', true);
		            }
		        },
	
		        _filterHeader: function() {
		            var icon;
	
		            if (this.filterInput) {
		                this.filterInput
		                    .off(ns)
		                    .parent()
		                    .remove();
	
		                this.filterInput = null;
		            }
	
		            if (this._isFilterEnabled()) {
		                this._disableCheckChildren();
	
		                icon = '<span class="k-icon k-i-zoom"></span>';
	
		                this.filterInput = $('<input class="k-textbox"/>')
		                                      .attr({
		                                          placeholder: this.element.attr("placeholder"),
		                                          title: this.element.attr("title"),
		                                          role: "listbox",
		                                          "aria-haspopup": true,
		                                          "aria-expanded": false
		                                      });
	
		                this.filterInput.on("input" , proxy(this._filterChange, this));
		                $('<span class="k-list-filter" />').insertBefore(this.tree)
		                    .append(this.filterInput.add(icon));
		            }
		        },
	
		        _filterChange: function() {
		            if (this.filterInput) {
		                this._search();
		            }
		        },
	
		        _disableCheckChildren: function() {
		            if (this._isMultipleSelection() && this.options.treeview.checkboxes && this.options.treeview.checkboxes.checkChildren) {
		                this.options.treeview.checkboxes.checkChildren = false;
		            }
		        },
	
		        _checkAll: function() {
		            if (this.checkAll) {
		                this.checkAll.find(".k-checkbox-label, .k-checkbox")
		                    .off(ns);
		                this.checkAll.remove();
	
		                this.checkAll = null;
		            }
	
		            if (this._isMultipleSelection() && this.options.checkAll) {
		                this.checkAll = $('<div class="k-check-all"><input type="checkbox" class="k-checkbox"/><span class="k-checkbox-label">Check All</span></div>').insertBefore(this.tree);
		                this.checkAll.find(".k-checkbox-label").html(kendo.template(this.options.checkAllTemplate)({ instance: this }));
		                this.checkAll.find(".k-checkbox-label").on(CLICK + ns, proxy(this._clickCheckAll, this));
		                this.checkAll.find(".k-checkbox")
		                                .on("change" + ns, proxy(this._changeCheckAll, this))
		                                .on("keydown" + ns, proxy(this._keydownCheckAll, this));
		                this._disabledCheckedItems = [];
		                this._disabledUnCheckedItems = [];
	
		                this._getAllChecked();
	
		                if (!this._allItemsAreUnchecked) {
		                    this._checkCheckAll();
		                }
		            }
		        },
	
		        _changeCheckAll: function() {
		            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
		            var isChecked = checkAllCheckbox.prop('checked');
	
		            if(!browser.msie && !browser.edge){
		                this._updateCheckAll(isChecked);
		            }
		        },
	
		        _updateCheckAll: function(isChecked) {
		            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
		            this._toggleCheckAllItems(isChecked);
		            checkAllCheckbox.prop('checked', isChecked);
		            if (this._disabledCheckedItems.length && this._disabledUnCheckedItems.length) {
		                checkAllCheckbox.prop('indeterminate', true);
		            } else if (this._disabledCheckedItems.length) {
		                checkAllCheckbox.prop('indeterminate', !isChecked);
		            } else if (this._disabledUnCheckedItems.length) {
		                checkAllCheckbox.prop('indeterminate', isChecked);
		            } else {
		                checkAllCheckbox.prop('indeterminate', false);
		            }
		            this._disabledCheckedItems = [];
		            this._disabledUnCheckedItems = [];
		        },
	
		        _keydownCheckAll: function(e) {
		            var key = e.keyCode;
		            var altKey = e.altKey;
	
		            if ((altKey && key === keys.UP) || key === keys.ESC) {
		                this.close();
		                this.wrapper.focus();
		                e.preventDefault();
		                return;
		            }
	
		            if (key === keys.UP) {
		                if (this.filterInput) {
		                    this.filterInput.focus();
		                } else {
		                    this.wrapper.focus();
		                }
	
		                e.preventDefault();
		            }
	
		            if (key === keys.DOWN) {
		                if (this.tree && this.tree.is(":visible")) {
		                    this.tree.focus();
		                }
	
		                e.preventDefault();
		            }
	
		            if (key === keys.SPACEBAR && (browser.msie || browser.edge)) {
		                this._clickCheckAll();
		                e.preventDefault();
		            }
		        },
	
		        _clickCheckAll: function() {
		            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
		            var isChecked = checkAllCheckbox.prop('checked');
	
		            this._updateCheckAll(!isChecked);
	
		            checkAllCheckbox.focus();
	
		        },
		        //treeview
		        _dfs: function(items, action, prop) {
		            for (var idx = 0; idx < items.length; idx++) {
		                if (!this[action](items[idx], prop)) {
		                    break;
		                }
		                this._traverceChildren(items[idx], action, prop);
		            }
		        },
	
		        _uncheckItemByUid: function(uid) {
		            this._dfs(this.dataSource.data(), '_uncheckItemEqualsUid', uid);
		        },
	
		        _uncheckItemEqualsUid: function(item, uid) {
		            if (item.enabled !== false && item._tagUid == uid) {
		                item.set("checked", false);
		                return false;
		            }
		            return true;
		        },
	
		        _selectItemByText: function(text) {
		            this._dfs(this.dataSource.data(), '_itemEqualsText', text);
		        },
	
		        _itemEqualsText: function(item, text) {
		            if (item.enabled !== false && this._text(item) === text) {
		                this.treeview.select(this.treeview.findByUid(item.uid));
		                this._selectValue(item);
		                return false;
		            }
		            return true;
		        },
	
		        _selectItemByValue: function(value) {
		            this._dfs(this.dataSource.data(), '_itemEqualsValue', value);
		        },
	
		        _itemEqualsValue: function(item, value) {
		            if (item.enabled !== false && this._valueComparer(item, value)) {
	
		                this.treeview.select(this.treeview.findByUid(item.uid));
	
		                return false;
		            }
		            return true;
		        },
	
		        _checkItemByValue: function(value) {
		            var items = this.treeview.dataItems();
		            for (var idx = 0; idx < value.length; idx++) {
		                this._dfs(items, '_checkItemEqualsValue', value[idx]);
		            }
		        },
	
		        _checkItemEqualsValue: function(item, value) {
		            if (item.enabled !== false && this._valueComparer(item, value)) {
		                    item.set("checked", true);
		                return false;
		            }
		            return true;
		        },
	
		        _valueComparer: function(item, value) {
		            var itemValue = this._value(item);
		            var itemText;
	
		            if (itemValue) {
		                if(!value){
		                    return false;
		                }
	
		                var newValue = this._value(value);
	
		                if(newValue){
		                    return itemValue == newValue;
		                }else{
		                    return itemValue == value;
		                }
		            }
	
		            itemText = this._text(item);
		            if (itemText) {
		                if (this._text(value)) {
		                    return itemText == this._text(value);
		                } else {
		                    return itemText == value;
		                }
		            }
	
		            return false;
		        },
	
		        _getAllChecked: function() {
		            this._allCheckedItems = [];
		            this._allItemsAreChecked = true;
		            this._allItemsAreUnchecked = true;
	
		            this._dfs(this.dataSource.data(), '_getAllCheckedItems');
	
		            return this._allCheckedItems;
		        },
	
		        _getAllCheckedItems: function(item) {
		            if (this._allItemsAreChecked) {
		                this._allItemsAreChecked =  item.checked;
		            }
	
		            if (this._allItemsAreUnchecked) {
		                this._allItemsAreUnchecked = !item.checked;
		            }
	
		            if (item.checked) {
		                this._allCheckedItems.push(item);
		            }
		            return true;
		        },
	
		        _traverceChildren: function(item, action, prop) {
		            var childrenField = (item._childrenOptions && item._childrenOptions.schema) ? item._childrenOptions.schema.data : null;
		            var subItems = item[childrenField] || item.items || item.children;
	
		            if (!subItems) {
		                return;
		            }
	
		            this._dfs(subItems, action, prop);
		        },
	
		        _toggleCheckAllItems: function(checked) {
		            this._dfs(this.dataSource.data(), '_checkAllCheckItem', checked);
		        },
	
		        _checkAllCheckItem: function(item, checked) {
		            if (item.enabled === false) {
		                if (item.checked) {
		                    this._disabledCheckedItems.push(item);
		                } else {
		                    this._disabledUnCheckedItems.push(item);
		                }
		            } else {
		                item.set("checked", checked);
		            }
		            return true;
		        },
	
		        _isFilterEnabled: function() {
		            var filter = this.options.filter;
		            return filter && filter !== "none";
		        },
	
		        _editable: function(options) {
		            var that = this;
		            var element = that.element;
		            var disable = options.disable;
		            var readonly = options.readonly;
		            var wrapper = that.wrapper.add(that.filterInput).off(ns);
		            var dropDownWrapper = that._inputWrapper.off(HOVEREVENTS);
		            if (that._isMultipleSelection()) {
		                that.tagList.off(CLICK + ns);
		            }
		            if (!readonly && !disable) {
		                element.removeAttr(DISABLED).removeAttr(READONLY);
	
		                dropDownWrapper
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                that._clear.on("click" + ns, proxy(that._clearClick, that));
		                wrapper
		                    .attr(TABINDEX, wrapper.data(TABINDEX))
		                    .attr(ARIA_DISABLED, false)
		                    .on("keydown" + ns, proxy(that._keydown, that))
		                    .on("focusin" + ns, proxy(that._focusinHandler, that))
		                    .on("focusout" + ns, proxy(that._focusoutHandler, that));
	
		                that.wrapper.on(CLICK + ns, proxy(that._wrapperClick, that));
	
		                if (this._isMultipleSelection()) {
		                    that.tagList.on(CLICK + ns, "li.k-button", function(e) {
		                        $(e.currentTarget).addClass(FOCUSED);
		                    });
	
		                    that.tagList.on(CLICK + ns, ".k-select", function(e) {
		                        that._removeTagClick(e);
		                    });
		                }
		            } else if (disable) {
		                wrapper.removeAttr(TABINDEX);
		                dropDownWrapper
		                    .addClass(STATEDISABLED);
		            } else {
		                wrapper
		                    .attr(TABINDEX, wrapper.data(TABINDEX));
	
		                dropDownWrapper
		                    .removeClass(STATEDISABLED);
	
		                wrapper
		                    .on("focusin" + ns, proxy(that._focusinHandler, that))
		                    .on("focusout" + ns, proxy(that._focusoutHandler, that));
		            }
	
		            element.attr(DISABLED, disable)
		                   .attr(READONLY, readonly);
	
		            wrapper.attr(ARIA_DISABLED, disable);
		        },
	
		        _focusinHandler: function() {
		            this._inputWrapper.addClass(FOCUSED);
		        },
	
		        _focusoutHandler: function() {
		            this._inputWrapper.removeClass(FOCUSED);
	
		            if (this._isMultipleSelection()) {
		                this.tagList.find(DOT + FOCUSED).removeClass(FOCUSED);
		            }
		        },
	
		        _toggle: function(open) {
		            open = open !== undefined ? open : !this.popup.visible();
	
		            this[open ? OPEN : CLOSE]();
		        },
	
		        _wrapperClick: function(e) {
		            e.preventDefault();
		            this.popup.unbind("activate", this._focusInputHandler);
		            this._focused = this.wrapper;
		            this._prevent = false;
		            this._toggle();
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
		        },
	
		        _focusInput: function() {
		            if (this.filterInput) {
		                this.filterInput.focus();
		            } else if (this.checkAll) {
		                this.checkAll.find(".k-checkbox").focus();
		            } else if (this.tree.is(":visible")) {
		                this.tree.focus();
		            }
		        },
	
		        _keydown: function(e) {
		            var key = e.keyCode;
		            var altKey = e.altKey;
		            var isFilterInputActive;
		            var isWrapperActive;
		            var focused, tagItem;
	
		            var isPopupVisible = this.popup.visible();
	
		            if (this.filterInput) {
		                isFilterInputActive = this.filterInput[0] === activeElement();
		            }
	
		            if (this.wrapper) {
		                isWrapperActive = this.wrapper[0] === activeElement();
		            }
	
		            if(isWrapperActive){
		                if (key === keys.ESC) {
		                    this._clearTextAndValue();
		                    e.preventDefault();
		                    return;
		                }
	
		                if(this._isMultipleSelection()){
		                    if (key === keys.LEFT) {
		                        this._focusPrevTag();
		                        e.preventDefault();
		                        return;
		                    }
	
		                    if (key === keys.RIGHT) {
		                        this._focusNextTag();
		                          e.preventDefault();
		                        return;
		                    }
	
		                    if (key === keys.HOME) {
		                        this._focusFirstTag();
		                        e.preventDefault();
		                        return;
		                    }
	
		                    if (key === keys.END) {
		                        this._focusLastTag();
		                        e.preventDefault();
		                        return;
		                    }
	
		                    if (key === keys.DELETE) {
		                        focused = this.tagList.find(DOT + FOCUSED).first();
		                        if(focused.length){
		                            tagItem = this._tags[focused.index()];
		                            this._removeTag(tagItem);
		                        }
		                        e.preventDefault();
		                        return;
		                    }
	
		                    if (key === keys.BACKSPACE) {
		                        focused = this.tagList.find(DOT + FOCUSED).first();
		                        if (focused.length) {
		                            tagItem = this._tags[focused.index()];
		                            this._removeTag(tagItem);
		                        } else {
		                            focused = this._focusLastTag();
		                            if (focused.length) {
		                                tagItem = this._tags[focused.index()];
		                                this._removeTag(tagItem);
		                            }
		                        }
		                        e.preventDefault();
		                        return;
		                    }
		                }
		            }
	
	
		            if (isFilterInputActive) {
		                if (key === keys.ESC) {
		                    this._clearFilter();
		                }
	
		                if ((key === keys.UP) && !altKey) {
		                    this.wrapper.focus();
		                    e.preventDefault();
		                }
	
		                if(browser.msie && browser.version < 10){
		                    if (key === keys.BACKSPACE || key === keys.DELETE) {
		                        this._search();
		                    }
		                }
		            }
	
		            if ((altKey && key === keys.UP) || key === keys.ESC) {
		                this.wrapper.focus();
		                this.close();
		                e.preventDefault();
		                return;
		            }
	
		            if (key === keys.ENTER && this._typingTimeout && this.filterInput && isPopupVisible) {
		                e.preventDefault();
		                return;
		            }
	
		            if (key === keys.SPACEBAR && !isFilterInputActive) {
		                this._toggle(!isPopupVisible);
		                e.preventDefault();
		            }
	
		            if ((altKey && key === keys.DOWN) && !isPopupVisible) {
		                this.open();
		                e.preventDefault();
		            }
	
		            if ((key === keys.DOWN) && isPopupVisible) {
		                if (this.filterInput && !isFilterInputActive) {
		                    this.filterInput.focus();
		                } else if (this.checkAll && this.checkAll.is(":visible")) {
		                    this.checkAll.find('input').focus();
		                } else if(this.tree.is(":visible")) {
		                    this.tree.focus();
		                }
		                e.preventDefault();
		            }
		        },
	
		        _focusPrevTag: function() {
		            var focused = this.tagList.find(DOT + FOCUSED);
		            if (focused.length) {
		                var activedescendant = this.wrapper.attr("aria-activedescendant");
		                focused.first()
		                    .removeClass(FOCUSED)
		                    .removeAttr("id")
		                    .prev().addClass(FOCUSED)
		                    .attr("id", activedescendant);
		                this.wrapper.attr("aria-activedescendant", activedescendant);
		            } else {
		                this._focusLastTag();
		            }
		        },
	
		        _focusNextTag: function() {
		            var focused = this.tagList.find(DOT + FOCUSED);
		            if (focused.length) {
		                var activedescendant = this.wrapper.attr("aria-activedescendant");
		                focused.first().removeClass(FOCUSED).removeAttr("id")
		                    .next().addClass(FOCUSED)
		                    .attr("id", activedescendant);
		                this.wrapper.attr("aria-activedescendant", activedescendant);
		            } else {
		                this._focusFirstTag();
		            }
		        },
	
		        _focusFirstTag: function() {
		            var activedescendant = this.wrapper.attr("aria-activedescendant");
		            this._clearDisabledTag();
	
		            var firstTag = this.tagList.children('li').first().addClass(FOCUSED)
		                .attr("id", activedescendant);
		            this.wrapper.attr("aria-activedescendant", activedescendant);
	
		            return firstTag;
		        },
	
		        _focusLastTag: function() {
		            var activedescendant = this.wrapper.attr("aria-activedescendant");
		            this._clearDisabledTag();
		            var lastTag = this.tagList.children('li').last().addClass(FOCUSED)
		                .attr("id", activedescendant);
		            this.wrapper.attr("aria-activedescendant", activedescendant);
	
		            return lastTag;
		        },
	
		        _clearDisabledTag: function() {
		            this.tagList.find(DOT + FOCUSED).removeClass(FOCUSED).removeAttr("id");
		        },
	
		        _search: function() {
		            var that = this;
		            clearTimeout(that._typingTimeout);
	
		            that._typingTimeout = setTimeout(function() {
		                var value = that.filterInput.val();
	
		                if (that._prev !== value) {
		                    that._prev = value;
		                    that.search(value);
		                }
	
		                that._typingTimeout = null;
		            }, that.options.delay);
		        },
	
		        _clearFilter: function() {
		            if(this.filterInput.val().length){
		                this.filterInput.val("");
		                this._prev = "";
		                this._filtering = true;
		                this.treeview.dataSource.filter({});
		            }
		        },
	
		        _removeTagClick: function(e) {
		            e.stopPropagation();
		            var tagItem = this._tags[$(e.currentTarget.parentElement).index()];
		            this._removeTag(tagItem);
		        },
	
		        _removeTag: function(tagItem) {
		           if(!tagItem){
		                return;
		           }
	
		           var uid = tagItem.uid;
		           this._uncheckItemByUid(uid);
		        }
		    });
	
		    function assign(instance, fields, value) {
		        var idx = 0,
		            lastIndex = fields.length - 1,
		            field;
	
		        for (; idx < lastIndex; ++idx) {
		            field = fields[idx];
	
		            if (!(field in instance)) {
		                instance[field] = {};
		            }
	
		            instance = instance[field];
		        }
	
		        instance[fields[lastIndex]] = value;
		    }
	
		    ui.plugin(DropDownTree);
	
		    var SingleSelection = kendo.Class.extend({
		        init: function(view) {
		            this._dropdowntree = view;
		        },
	
		        _initWrapper: function() {
		            this._wrapper();
		            this._span();
		        },
	
		        _preselect: function(data){
		            var dropdowntree = this._dropdowntree;
	
		            dropdowntree._selectValue(data);
		        },
	
		        _wrapper: function() {
		            var dropdowntree = this._dropdowntree,
		                element = dropdowntree.element,
		                DOMelement = element[0],
		                wrapper;
	
		            wrapper = element.parent();
	
		            if (!wrapper.is("span.k-widget")) {
		                wrapper = element.wrap("<span />").parent();
		                wrapper[0].style.cssText = DOMelement.style.cssText;
		                wrapper[0].title = DOMelement.title;
		            }
	
		            dropdowntree._focused = dropdowntree.wrapper = wrapper
		                              .addClass("k-widget k-dropdowntree")
		                              .addClass(DOMelement.className)
		                              .css("display", "")
		                              .attr({
		                                  accesskey: element.attr("accesskey"),
		                                  unselectable: "on",
		                                  role: "listbox",
		                                  "aria-haspopup": true,
		                                  "aria-expanded": false
		                              });
	
		            element.hide().removeAttr("accesskey");
		        },
	
		        _span: function() {
		            var dropdowntree = this._dropdowntree,
		                wrapper = dropdowntree.wrapper,
		                SELECTOR = "span.k-input",
		                span;
	
		            span = wrapper.find(SELECTOR);
	
		            if (!span[0]) {
		                wrapper.append('<span unselectable="on" class="k-dropdown-wrap k-state-default"><span unselectable="on" class="k-input">&nbsp;</span><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>')
		                       .append(dropdowntree.element);
	
		                span = wrapper.find(SELECTOR);
		            }
	
		            dropdowntree.span = span;
		            dropdowntree._inputWrapper = $(wrapper[0].firstChild);
		            dropdowntree._arrow = wrapper.find(".k-select");
		            dropdowntree._arrowIcon = dropdowntree._arrow.find(".k-icon");
		        },
	
		        _setValue: function(value) {
		            var dropdowntree = this._dropdowntree;
		            var currentValue;
	
		            if (value === undefined || value === null) {
		                currentValue = dropdowntree._values.slice()[0];
		                value = (typeof currentValue === "object") ? currentValue : dropdowntree._accessor() || currentValue;
		                return value === undefined || value === null ? "" : value;
		            }
		            dropdowntree._valueMethodCalled = true;
		            if (value.length === 0) {
		                dropdowntree._clearTextAndValue();
		                dropdowntree._valueMethodCalled = false;
		                return;
		            }
	
		            dropdowntree._selectItemByValue(value);
		            dropdowntree._toggleCloseVisibility();
		        },
	
		        _clearValue: function() {
		            var dropdowntree = this._dropdowntree;
		            var selectedNode = dropdowntree.treeview.select();
	
		            if (dropdowntree.treeview.dataItem(selectedNode)) {
		                dropdowntree.treeview.dataItem(selectedNode).set('selected', false);
		                if(!dropdowntree._valueMethodCalled){
		                    dropdowntree.trigger(CHANGE);
		                }
		            }
		        },
	
		        _checkLoadedItem: function(tempItem, value) {
		            var dropdowntree = this._dropdowntree;
	
		            if (value && dropdowntree._valueComparer(tempItem, value) || !value && tempItem.selected) {
	
		                dropdowntree.treeview.select(dropdowntree.treeview.findByUid(tempItem.uid));
		           }
		        }
		    });
	
		    var MultipleSelection = kendo.Class.extend({
		        init: function(view) {
		            this._dropdowntree = view;
		        },
	
		        _initWrapper: function() {
		            var dropdowntree = this._dropdowntree;
	
		            this._tagTemplate();
		            dropdowntree.element.attr("multiple", "multiple").hide();
		            this._wrapper();
		            dropdowntree._tags = new ObservableArray([]);
		            dropdowntree._multipleTags = new ObservableArray([]);
		            this._tagList();
		            dropdowntree.span = $('<span unselectable="on" class="k-input">&nbsp;</span>').insertAfter(dropdowntree.tagList);
		            dropdowntree._inputWrapper = $(dropdowntree.wrapper[0].firstChild);
		        },
	
		        _preselect: function(data, value){
		            var dropdowntree = this._dropdowntree;
		            var valueToSelect = value || dropdowntree.options.value;
	
		            if (!$.isArray(data) && !(data instanceof kendo.data.ObservableArray)) {
		                data = [data];
		            }
	
		            if ($.isPlainObject(data[0]) || data[0] instanceof kendo.data.ObservableObject || !dropdowntree.options.dataValueField) {
		                dropdowntree.dataSource.data(data);
	
		                dropdowntree.value(valueToSelect);
		            }
		        },
	
		        _tagTemplate: function() {
		            var dropdowntree = this._dropdowntree;
		            var options = dropdowntree.options;
		            var tagTemplate = options.valueTemplate;
		            var isMultiple = options.tagMode === "multiple";
		            var singleTag = options.messages.singleTag;
	
		            tagTemplate = tagTemplate ? kendo.template(tagTemplate) : dropdowntree.valueTemplate;
	
		            dropdowntree.valueTemplate = function(data) {
		                if (isMultiple) {
		                    return '<li class="k-button ' +
		                    ((data.enabled === false) ? "k-state-disabled" : "") +
		                    '" unselectable="on" role="option" ' +
		                    ((data.enabled === false) ? 'aria-disabled="true"' : '') +
		                    '>' +
		                        '<span unselectable="on">' + tagTemplate(data) + '</span>' +
		                        '<span title="' + dropdowntree.options.messages.deleteTag + '" aria-label="' + dropdowntree.options.messages.deleteTag + '" class="k-select">' +
		                            '<span class="k-icon k-i-close"></span>' +
		                        '</span>' +
		                    '</li>';
		                }
	
		                return '<li class="k-button" unselectable="on" role="option">' +
		                        '<span unselectable="on" data-bind="text: tags.length"></span>' +
		                        '<span unselectable="on">&nbsp;' + singleTag +'</span>' +
		                        '</li>';
		            };
		        },
	
		        _wrapper: function() {
		            var dropdowntree = this._dropdowntree,
		                element = dropdowntree.element,
		                wrapper = element.parent("span.k-dropdowntree");
	
		            if (!wrapper[0]) {
		                wrapper = element.wrap('<div class="k-widget k-dropdowntree" unselectable="on" />').parent();
		                wrapper[0].style.cssText = element[0].style.cssText;
		                wrapper[0].title = element[0].title;
	
		                $('<div class="k-multiselect-wrap k-floatwrap" unselectable="on" />').insertBefore(element);
		            }
	
		            dropdowntree.wrapper = wrapper.addClass(element[0].className).css("display", "")
		                                   .attr({
		                                        role: "listbox",
		                                        "aria-activedescendant": kendo.guid(),
		                                        "aria-haspopup": true,
		                                        "aria-expanded": false
		                                   });
		            dropdowntree._innerWrapper = $(wrapper[0].firstChild);
		        },
	
		        _tagList: function() {
		            var dropdowntree = this._dropdowntree,
		                tagList = dropdowntree._innerWrapper.children("ul");
	
		            if (!tagList[0]) {
		                var isMultiple = dropdowntree.options.tagMode === "multiple";
		                var tagCollection = isMultiple ? "tags": "multipleTag";
		                tagList = $('<ul role="listbox" unselectable="on" data-template="tagTemplate" data-bind="source: ' + tagCollection + '" class="k-reset"/>').appendTo(dropdowntree._innerWrapper);
		            }
	
		            dropdowntree.tagList = tagList;
		            dropdowntree.tagList.attr('id', kendo.guid() + "_tagList");
		            dropdowntree.wrapper.attr("aria-owns", dropdowntree.tagList.attr('id'));
		            var viewModel = kendo.observable({
		                multipleTag: dropdowntree._multipleTags,
		                tags: dropdowntree._tags,
		                tagTemplate: dropdowntree.valueTemplate
		            });
		            kendo.bind(dropdowntree.tagList, viewModel);
		            dropdowntree.tagList.attr("data-stop", true);
		        },
	
		        _setValue: function(value) {
		            var dropdowntree = this._dropdowntree;
		            var oldValues = dropdowntree._values;
		            if (value === undefined || value === null) {
		                return dropdowntree._values.slice();
		            }
	
		            dropdowntree.setValue(value);
		            dropdowntree._valueMethodCalled = true;
		            if (value.length) {
		                this._removeValues(oldValues, value);
	
		                dropdowntree._checkItemByValue(value);
		            } else {
		                dropdowntree._clearTextAndValue();
		            }
	
		            dropdowntree._valueMethodCalled = false;
		            dropdowntree._toggleCloseVisibility();
		        },
	
		        _removeValues: function(oldValues, value) {
		            var dropdowntree = this._dropdowntree;
		            var removedValues = this._getNewValues(oldValues, value);
	
		            for (var idx = 0; idx < removedValues.length; idx++) {
		                for (var j = 0; j < dropdowntree._tags.length; j++) {
		                    if (dropdowntree._valueComparer(dropdowntree._tags[j],removedValues[idx])){
		                        dropdowntree._uncheckItemByUid(dropdowntree._tags[j].uid);
		                    }
		                }
		            }
		        },
	
		        _getNewValues: function(oldValues, value){
		            var removedValues = [];
	
		            for (var idx = 0; idx < oldValues.length; idx++) {
		                if(value.indexOf(oldValues[idx]) === -1){
		                    removedValues.push(oldValues[idx]);
		                }
		            }
	
		            return removedValues;
		        },
	
		        _clearValue: function() {
		            var dropdowntree = this._dropdowntree;
		            var tagsArray = dropdowntree._tags.slice();
	
		            for (var idx = 0; idx < tagsArray.length; idx++) {
		                var uid = tagsArray[idx].uid;
		                dropdowntree._preventChangeTrigger = true;
		                dropdowntree._uncheckItemByUid(uid);
		            }
	
		            if (tagsArray.length) {
		                dropdowntree._preventChangeTrigger = false;
		                if(!dropdowntree._valueMethodCalled){
		                    dropdowntree.trigger(CHANGE);
		                }
		            }
		        },
	
		        _checkLoadedItem: function(tempItem, value) {
		            var dropdowntree = this._dropdowntree;
	
		            if (dropdowntree._noInitialValue && tempItem.checked) {
		                dropdowntree._checkValue(tempItem);
		                return;
		            }
	
		            if (value.length &&
		                (value.indexOf(dropdowntree._currentValue(tempItem)) !== -1 || value.indexOf(tempItem)) !== -1 &&
		                !this._findTag(dropdowntree._currentValue(tempItem))) {
		                if (tempItem.checked) {
		                    dropdowntree._checkValue(tempItem);
		                } else {
		                    tempItem.set("checked", true);
		                }
		            }
		        },
	
		        _findTag: function(tempItemValue) {
		            var dropdowntree = this._dropdowntree;
	
		            return dropdowntree._tags.find(function(item) {
		                return dropdowntree._valueComparer(item, tempItemValue);
		            });
		        }
		    });
	
		    kendo.ui.DropDownTree.SingleSelection = SingleSelection;
		    kendo.ui.DropDownTree.MultipleSelection = MultipleSelection;
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1132:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(573);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(930);
		module.exports = __webpack_require__(930);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 930:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(931) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        keys = kendo.keys,
		        DISABLED = "k-state-disabled",
		        SELECT = "select",
		        CHECKED = "checked",
		        proxy = $.proxy,
		        DATABOUND = "dataBound",
		        CLICK = "click",
		        NS = ".kendoTreeView",
		        INDETERMINATE = "indeterminate",
		        NAVIGATE = "navigate",
		        subGroup,
		        TreeView = ui.TreeView;
	
		        function contentChild(filter) {
		            return function(node) {
		                var result = node.children(".k-animation-container");
	
		                if (!result.length) {
		                    result = node;
		                }
	
		                return result.children(filter);
		            };
		        }
	
		        subGroup = contentChild(".k-group");
	
		    var Tree = TreeView.extend({
		        init: function(element, options, dropdowntree) {
		            var that = this;
	
		            that.dropdowntree = dropdowntree;
	
		            TreeView.fn.init.call(that, element, options);
		            if(that.dropdowntree._isMultipleSelection()){
		                that.wrapper.on(CLICK + NS, '.k-in.k-state-selected', proxy(that._clickSelectedItem, that));
		            }
		        },
	
		        _checkOnSelect: function (e) {
		            if (!e.isDefaultPrevented()) {
		                var dataItem = this.dataItem(e.node);
	
		                dataItem.set("checked", !dataItem.checked);
		            }
		        },
	
		        _setCheckedValue: function (node, value){
		            node.set(CHECKED, value);
		        },
	
		        _click: function (e) {
		            var that = this;
	
		            if(that.dropdowntree._isMultipleSelection()){
		                that.one("select", that._checkOnSelect);
		            }
		            TreeView.fn._click.call(that, e);
		        },
	
		        _clickSelectedItem: function (e) {
		            var that = this,
		            node = $(e.currentTarget);
	
		            that.one("select", that._checkOnSelect);
		            if (!that._trigger(SELECT, node)) {
		                that.dataItem(node).set("selected", false);
		            }
		        },
	
		        defaultrefresh: function(e) {
		            var node = e.node;
		            var action = e.action;
		            var items = e.items;
		            var parentNode = this.wrapper;
		            var options = this.options;
		            var loadOnDemand = options.loadOnDemand;
		            var checkChildren = options.checkboxes && options.checkboxes.checkChildren;
		            var i;
	
		            if (this._skip) {
		                return;
		            }
	
		            if (e.field) {
		                if (!items[0] || !items[0].level) {
		                    return;
		                }
	
		                return this._updateNodes(items, e.field);
		            }
	
		            if (node) {
		                parentNode = this.findByUid(node.uid);
		                this._progress(parentNode, false);
		            }
	
		            if (checkChildren && action != "remove") {
		                var bubble = false;
	
		                for (i = 0; i < items.length; i++) {
		                    if ("checked" in items[i]) {
		                        bubble = true;
		                        break;
		                    }
		                }
	
		                if (!bubble && node && node.checked) {
		                    for (i = 0; i < items.length; i++) {
		                        items[i].checked = true;
		                    }
		                }
		            }
	
		            if (action == "add") {
		                this._appendItems(e.index, items, parentNode);
		            } else if (action == "remove") {
		                this._remove(this.findByUid(items[0].uid), false);
		            } else if (action == "itemchange") {
		                this._updateNodes(items);
		            } else if (action == "itemloaded") {
		                this._refreshChildren(parentNode, items, e.index);
		            } else {
		                this._refreshRoot(items);
		            }
	
		            if (action != "remove") {
		                for (i = 0; i < items.length; i++) {
		                    if (!loadOnDemand || items[i].expanded) {
		                        items[i].load();
		                    }
		                }
		            }
	
		            this.trigger(DATABOUND, { node: node ? parentNode : undefined });
		            this.dropdowntree._treeViewDataBound({ node: node ? parentNode : undefined, sender: this });
		            if (this.options.checkboxes.checkChildren) {
		                this.updateIndeterminate();
		            }
		        },
	
		        _previousVisible: function(node) {
		            var that = this,
		                lastChild,
		                result;
	
		            if (!node.length || node.prev().length) {
		                if (node.length) {
		                    result = node.prev();
		                } else {
		                    result = that.root.children().last();
		                }
	
		                while (that._expanded(result)) {
		                    lastChild = subGroup(result).children().last();
	
		                    if (!lastChild.length) {
		                        break;
		                    }
	
		                    result = lastChild;
		                }
		            } else {
		                result = that.parent(node) || node;
	
		                if(!result.length){
		                    if (that.dropdowntree.checkAll && that.dropdowntree.checkAll.is(":visible")) {
		                        that.dropdowntree.checkAll.find(".k-checkbox").focus();
		                    } else if(that.dropdowntree.filterInput){
		                        that.dropdowntree.filterInput.focus();
		                    } else {
		                        that.dropdowntree.wrapper.focus();
		                    }
		                }
		            }
	
		            return result;
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode,
		                target,
		                focused = that.current(),
		                expanded = that._expanded(focused),
		                checkbox = focused.find(".k-checkbox-wrapper:first :checkbox"),
		                rtl = kendo.support.isRtl(that.element);
	
		            if (e.target != e.currentTarget) {
		                return;
		            }
	
		            if ((!rtl && key == keys.RIGHT) || (rtl && key == keys.LEFT)) {
		                if (expanded) {
		                    target = that._nextVisible(focused);
		                } else if (!focused.find(".k-in:first").hasClass(DISABLED)) {
		                    that.expand(focused);
		                }
		            } else if ((!rtl && key == keys.LEFT) || (rtl && key == keys.RIGHT)) {
		                if (expanded && !focused.find(".k-in:first").hasClass(DISABLED)) {
		                    that.collapse(focused);
		                } else {
		                    target = that.parent(focused);
	
		                    if (!that._enabled(target)) {
		                        target = undefined;
		                    }
		                }
		            } else if (key == keys.DOWN) {
		                target = that._nextVisible(focused);
		            } else if (key == keys.UP && !e.altKey) {
		                target = that._previousVisible(focused);
		            } else if (key == keys.HOME) {
		                target = that._nextVisible($());
		            } else if (key == keys.END) {
		                target = that._previousVisible($());
		            } else if (key == keys.ENTER && !focused.find(".k-in:first").hasClass(DISABLED)) {
		                if (!focused.find(".k-in:first").hasClass("k-state-selected")) {
		                    if (!that._trigger(SELECT, focused)) {
		                        that.select(focused);
		                    }
		                }
		            } else if (key == keys.SPACEBAR && checkbox.length && !focused.find(".k-in:first").hasClass(DISABLED)) {
		                checkbox.prop(CHECKED, !checkbox.prop(CHECKED))
		                    .data(INDETERMINATE, false)
		                    .prop(INDETERMINATE, false);
	
		                that._checkboxChange({ target: checkbox });
	
		                target = focused;
		            } else if ((e.altKey && key === keys.UP) || key === keys.ESC) {
		                that._closePopup();
		            }
	
		            if (target) {
		                e.preventDefault();
	
		                if (focused[0] != target[0]) {
		                    that._trigger(NAVIGATE, target);
		                    that.current(target);
		                }
		            }
		        },
	
		        _closePopup: function() {
		            this.dropdowntree.close();
		            this.dropdowntree.wrapper.focus();
		        },
	
		        refresh: function(e){
		            this.defaultrefresh(e);
	
		            if(this.dropdowntree.options.skipUpdateOnBind){
		                return;
		            }
	
		            if (e.action === "itemchange") {
		                if (this.dropdowntree._isMultipleSelection()) {
		                    if(e.field === "checked"){
		                        this.dropdowntree._checkValue(e.items[0]);
		                    }
		                } else {
		                    if(e.field !== "checked" && e.field !== "expanded" && e.items[0].selected){
		                        this.dropdowntree._selectValue(e.items[0]);
		                    }
		                }
		            } else {
		                this.dropdowntree.refresh(e);
		            }
		        }
	
		    });
	
		    kendo.ui._dropdowntree = Tree;
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 931:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(574);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1339);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1338:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(575);
	
	/***/ }),
	
	/***/ 1339:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013), __webpack_require__(1338) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "treeview",
		    name: "TreeView",
		    category: "web",
		    description: "The TreeView widget displays hierarchical data in a traditional tree structure,with support for interactive drag-and-drop operations.",
		    depends: [ "data" ],
		    features: [{
		        id: "treeview-dragging",
		        name: "Drag & Drop",
		        description: "Support for drag & drop",
		        depends: [ "treeview.draganddrop" ]
		    }]
		};
	
		/*jshint eqnull: true */
		(function($, undefined){
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        data = kendo.data,
		        extend = $.extend,
		        template = kendo.template,
		        isArray = $.isArray,
		        Widget = ui.Widget,
		        HierarchicalDataSource = data.HierarchicalDataSource,
		        proxy = $.proxy,
		        keys = kendo.keys,
		        NS = ".kendoTreeView",
		        TEMP_NS = ".kendoTreeViewTemp",
		        SELECT = "select",
		        CHECK = "check",
		        NAVIGATE = "navigate",
		        EXPAND = "expand",
		        CHANGE = "change",
		        ERROR = "error",
		        CHECKED = "checked",
		        INDETERMINATE = "indeterminate",
		        COLLAPSE = "collapse",
		        DRAGSTART = "dragstart",
		        DRAG = "drag",
		        DROP = "drop",
		        DRAGEND = "dragend",
		        DATABOUND = "dataBound",
		        CLICK = "click",
		        UNDEFINED = "undefined",
		        KSTATEHOVER = "k-state-hover",
		        KTREEVIEW = "k-treeview",
		        VISIBLE = ":visible",
		        NODE = ".k-item",
		        STRING = "string",
		        ARIACHECKED = "aria-checked",
		        ARIASELECTED = "aria-selected",
		        ARIADISABLED = "aria-disabled",
		        DISABLED = "k-state-disabled",
		        TreeView,
		        subGroup, nodeContents, nodeIcon,
		        spriteRe,
		        bindings = {
		            text: "dataTextField",
		            url: "dataUrlField",
		            spriteCssClass: "dataSpriteCssClassField",
		            imageUrl: "dataImageUrlField"
		        },
		        isJQueryInstance = function(obj) {
		            return (obj instanceof kendo.jQuery) || (obj instanceof window.jQuery);
		        },
		        isDomElement = function (o){
		            return (
		                typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
		                o && typeof o === "object" && o.nodeType === 1 && typeof o.nodeName === STRING
		            );
		        };
	
		    function contentChild(filter) {
		        return function(node) {
		            var result = node.children(".k-animation-container");
	
		            if (!result.length) {
		                result = node;
		            }
	
		            return result.children(filter);
		        };
		    }
	
		    function templateNoWith(code) {
		        return kendo.template(code, { useWithBlock: false });
		    }
	
		    subGroup = contentChild(".k-group");
		    nodeContents = contentChild(".k-group,.k-content");
		    nodeIcon = function(node) {
		        return node.children("div").children(".k-icon");
		    };
	
		    function checkboxes(node) {
		        return node.find(".k-checkbox-wrapper:first input[type=checkbox]");
		    }
	
		    function insertAction(indexOffset) {
		        return function (nodeData, referenceNode) {
		            referenceNode = referenceNode.closest(NODE);
	
		            var group = referenceNode.parent(),
		                parentNode;
	
		            if (group.parent().is("li")) {
		                parentNode = group.parent();
		            }
	
		            return this._dataSourceMove(nodeData, group, parentNode, function (dataSource, model) {
		                var referenceItem = this.dataItem(referenceNode);
		                var referenceNodeIndex = referenceItem ? referenceItem.parent().indexOf(referenceItem) : referenceNode.index();
	
		                return this._insert(dataSource.data(), model, referenceNodeIndex + indexOffset);
		            });
		        };
		    }
	
		    spriteRe = /k-sprite/;
	
		    function moveContents(node, container) {
		        var tmp;
	
		        while (node && node.nodeName.toLowerCase() != "ul") {
		            tmp = node;
		            node = node.nextSibling;
	
		            if (tmp.nodeType == 3) {
		                tmp.nodeValue = $.trim(tmp.nodeValue);
		            }
	
		            if (spriteRe.test(tmp.className)) {
		                container.insertBefore(tmp, container.firstChild);
		            } else {
		                container.appendChild(tmp);
		            }
		        }
		    }
	
		    function updateNodeHtml(node) {
		        var wrapper = node.children("div"),
		            group = node.children("ul"),
		            toggleButton = wrapper.children(".k-icon"),
		            checkbox = node.children("input[type=checkbox]"),
		            innerWrapper = wrapper.children(".k-in");
	
		        if (node.hasClass("k-treeview")) {
		            return;
		        }
	
		        if (!wrapper.length) {
		            wrapper = $("<div />").prependTo(node);
		        }
	
		        if (!toggleButton.length && group.length) {
		            toggleButton = $("<span class='k-icon' />").prependTo(wrapper);
		        } else if (!group.length || !group.children().length) {
		            toggleButton.remove();
		            group.remove();
		        }
	
		        if (checkbox.length) {
		            $("<span class='k-checkbox-wrapper' />").appendTo(wrapper).append(checkbox);
		        }
	
		        if (!innerWrapper.length) {
		            innerWrapper = node.children("a").eq(0).addClass("k-in k-link");
	
		            if (!innerWrapper.length) {
		                innerWrapper = $("<span class='k-in' />");
		            }
	
		            innerWrapper.appendTo(wrapper);
	
		            if (wrapper.length) {
		                moveContents(wrapper[0].nextSibling, innerWrapper[0]);
		            }
		        }
		    }
	
		    TreeView = kendo.ui.DataBoundWidget.extend({
		        init: function (element, options) {
		            var that = this,
		                inferred = false,
		                hasDataSource = options && !!options.dataSource,
		                list;
	
		            if (isArray(options)) {
		                options = { dataSource: options };
		            }
	
		            if (options && typeof options.loadOnDemand == UNDEFINED && isArray(options.dataSource)) {
		                options.loadOnDemand = false;
		            }
	
		            Widget.prototype.init.call(that, element, options);
	
		            element = that.element;
		            options = that.options;
	
		            that._dataSourceUids = {};
	
		            list = (element.is("ul") && element) ||
		                   (element.hasClass(KTREEVIEW) && element.children("ul"));
	
		            inferred = !hasDataSource && list.length;
	
		            if (inferred) {
		                options.dataSource.list = list;
		            }
	
		            that._animation();
	
		            that._accessors();
	
		            that._templates();
	
		            // render treeview if it's not already rendered
		            if (!element.hasClass(KTREEVIEW)) {
		                that._wrapper();
	
		                if (list) {
		                    that.root = element;
		                    that._group(that.wrapper);
		                }
		            } else {
		                // otherwise just initialize properties
		                that.wrapper = element;
		                that.root = element.children("ul").eq(0);
		            }
	
		            that._tabindex();
	
		            that.wrapper.attr("role", "tree");
	
		            that._dataSource(inferred);
	
		            that._attachEvents();
	
		            that._dragging();
	
		            if (!inferred) {
		                if (options.autoBind) {
		                    that._progress(true);
		                    that.dataSource.fetch();
		                }
		            } else {
		                that._syncHtmlAndDataSource();
		            }
	
		            if (options.checkboxes && options.checkboxes.checkChildren) {
		                that.updateIndeterminate();
		            }
	
		            if (that.element[0].id) {
		                that._ariaId = kendo.format("{0}_tv_active", that.element[0].id);
		            }
	
		            kendo.notify(that);
		        },
	
		        _attachEvents: function() {
		            var that = this,
		                clickableItems = ".k-in:not(.k-state-selected,.k-state-disabled)",
		                MOUSEENTER = "mouseenter";
	
		            that.wrapper
		                .on(MOUSEENTER + NS, ".k-in.k-state-selected", function(e) { e.preventDefault(); })
		                .on(MOUSEENTER + NS, clickableItems, function () { $(this).addClass(KSTATEHOVER); })
		                .on("mouseleave" + NS, clickableItems, function () { $(this).removeClass(KSTATEHOVER); })
		                .on(CLICK + NS, clickableItems, proxy(that._click, that))
		                .on("dblclick" + NS, ".k-in:not(.k-state-disabled)", proxy(that._toggleButtonClick, that))
		                .on(CLICK + NS, ".k-i-expand,.k-i-collapse", proxy(that._toggleButtonClick, that))
		                .on("keydown" + NS, proxy(that._keydown, that))
		                .on("keypress" + NS, proxy(that._keypress, that))
		                .on("focus" + NS, proxy(that._focus, that))
		                .on("blur" + NS, proxy(that._blur, that))
		                .on("mousedown" + NS, ".k-in,.k-checkbox-wrapper :checkbox,.k-i-expand,.k-i-collapse", proxy(that._mousedown, that))
		                .on("change" + NS, ".k-checkbox-wrapper :checkbox", proxy(that._checkboxChange, that))
		                .on("click" + NS, ".checkbox-span", proxy(that._checkboxLabelClick, that))
		                .on("click" + NS, ".k-request-retry", proxy(that._retryRequest, that))
		                .on("click" + NS, ".k-link.k-state-disabled", function(e) { e.preventDefault(); })
		                .on("click" + NS, function(e) {
		                    if (!$(e.target).is(":kendoFocusable")) {
		                        that.focus();
		                    }
		                });
		        },
	
		        _checkboxLabelClick: function(e) {
		            var checkbox = $(e.target.previousSibling);
	
		            if (checkbox.is("[disabled]")) {
		                return;
		            }
	
		            checkbox.prop('checked', !checkbox.prop('checked'));
		            checkbox.trigger('change');
		        },
	
		        _syncHtmlAndDataSource: function (root, dataSource) {
		            root = root || this.root;
		            dataSource = dataSource || this.dataSource;
		            var data = dataSource.view(),
		                uidAttr = kendo.attr("uid"),
		                expandedAttr = kendo.attr("expanded"),
		                checkboxesEnabled = this.options.checkboxes,
		                items = root.children("li"),
		                i,
		                item,
		                dataItem,
		                uid,
		                itemCheckbox;
	
		            for (i = 0; i < items.length; i++) {
		                dataItem = data[i];
		                uid = dataItem.uid;
		                item = items.eq(i);
		                item.attr("role", "treeitem")
		                    .attr(uidAttr, uid)
		                    .attr(ARIASELECTED, item.hasClass("k-state-selected"));
	
		                dataItem.expanded = item.attr(expandedAttr) === "true";
	
		                if (checkboxesEnabled) {
		                    itemCheckbox = checkboxes(item);
		                    dataItem.checked = itemCheckbox.prop(CHECKED);
		                    itemCheckbox.attr("id", "_" + uid);
		                    itemCheckbox.next(".k-checkbox-label").attr("for", "_" + uid);
		                }
	
		                this._syncHtmlAndDataSource(item.children("ul"), dataItem.children);
		            }
		        },
	
		        _animation: function() {
		            var options = this.options,
		                animationOptions = options.animation,
		                hasCollapseAnimation = animationOptions.collapse && "effects" in animationOptions.collapse,
		                collapse = extend({}, animationOptions.expand, animationOptions.collapse);
	
		            if (!hasCollapseAnimation) {
		                collapse = extend(collapse, {reverse: true});
		            }
	
		            if (animationOptions === false) {
		                animationOptions = {
		                    expand: { effects: {} },
		                    collapse: { hide: true, effects: {} }
		                };
		            }
	
		            animationOptions.collapse = extend(collapse, {hide: true});
		            options.animation = animationOptions;
		        },
	
		        _dragging: function() {
		            var enabled = this.options.dragAndDrop;
		            var dragging = this.dragging;
	
		            if (enabled && !dragging) {
		                var widget = this;
	
		                this.dragging = new ui.HierarchicalDragAndDrop(this.element, {
		                    reorderable: true,
		                    $angular: this.options.$angular,
		                    autoScroll: this.options.autoScroll,
		                    filter: "div:not(.k-state-disabled) .k-in",
		                    allowedContainers: ".k-treeview",
		                    itemSelector: ".k-treeview .k-item",
		                    hintText: proxy(this._hintText, this),
		                    contains: function(source, destination) {
		                        return $.contains(source, destination);
		                    },
		                    dropHintContainer: function(item) {
		                        return item;
		                    },
		                    itemFromTarget: function(target) {
		                        var item = target.closest(".k-top,.k-mid,.k-bot");
		                        return {
		                            item: item,
		                            content: target.closest(".k-in"),
		                            first: item.hasClass("k-top"),
		                            last: item.hasClass("k-bot")
		                        };
		                    },
		                    dropPositionFrom: function(dropHint) {
		                        return dropHint.prevAll(".k-in").length > 0 ? "after" : "before";
		                    },
		                    dragstart: function(source) {
		                        return widget.trigger(DRAGSTART, { sourceNode: source[0] });
		                    },
		                    drag: function(options) {
		                        widget.trigger(DRAG, {
		                            originalEvent: options.originalEvent,
		                            sourceNode: options.source[0],
		                            dropTarget: options.target[0],
		                            pageY: options.pageY,
		                            pageX: options.pageX,
		                            statusClass: options.status,
		                            setStatusClass: options.setStatus
		                        });
		                    },
		                    drop: function(options) {
		                        var dropTarget = $(options.dropTarget);
		                        var navigationTarget = dropTarget.closest("a");
	
		                        if(navigationTarget && navigationTarget.attr("href")) {
		                            widget._tempPreventNavigation(navigationTarget);
		                        }
	
		                        return widget.trigger(DROP, {
		                            originalEvent: options.originalEvent,
		                            sourceNode: options.source,
		                            destinationNode: options.destination,
		                            valid: options.valid,
		                            setValid: function(state) {
		                                this.valid = state;
		                                options.setValid(state);
		                            },
		                            dropTarget: options.dropTarget,
		                            dropPosition: options.position
		                        });
		                    },
		                    dragend: function(options) {
		                        var source = options.source;
		                        var destination = options.destination;
		                        var position = options.position;
	
		                        function triggerDragEnd(source) {
		                            if (widget.options.checkboxes && widget.options.checkboxes.checkChildren) {
		                                widget.updateIndeterminate();
		                            }
	
		                            widget.trigger(DRAGEND, {
		                                originalEvent: options.originalEvent,
		                                sourceNode: source && source[0],
		                                destinationNode: destination[0],
		                                dropPosition: position
		                            });
		                        }
	
		                        // perform reorder / move
		                        // different handling is necessary because append might be async in remote bound tree
		                        if (position == "over") {
		                            widget.append(source, destination, triggerDragEnd);
		                        } else {
		                            if (position == "before") {
		                                source = widget.insertBefore(source, destination);
		                            } else if (position == "after") {
		                                source = widget.insertAfter(source, destination);
		                            }
	
		                            triggerDragEnd(source);
		                        }
		                    }
		                });
		            } else if (!enabled && dragging) {
		                dragging.destroy();
		                this.dragging = null;
		            }
		        },
	
		        _tempPreventNavigation: function(node) {
		            node.on(CLICK + NS + TEMP_NS, function (ev) {
		                ev.preventDefault();
		                node.off(CLICK + NS + TEMP_NS);
		            });
		        },
	
		        _hintText: function(node) {
		            return this.templates.dragClue({
		                item: this.dataItem(node),
		                treeview: this.options
		            });
		        },
	
		        _templates: function() {
		            var that = this,
		                options = that.options,
		                fieldAccessor = proxy(that._fieldAccessor, that);
	
		            if (options.template && typeof options.template == STRING) {
		                options.template = template(options.template);
		            } else if (!options.template) {
		                options.template = templateNoWith(
		                    "# var text = " + fieldAccessor("text") + "(data.item); #" +
		                    "# if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {#" +
		                        "#= text #" +
		                    "# } else { #" +
		                        "#: text #" +
		                    "# } #"
		                );
		            }
	
		            that._checkboxes();
	
		            that.templates = {
		                wrapperCssClass: function (group, item) {
		                    var result = "k-item",
		                        index = item.index;
	
		                    if (group.firstLevel && index === 0) {
		                        result += " k-first";
		                    }
	
		                    if (index == group.length-1) {
		                        result += " k-last";
		                    }
	
		                    return result;
		                },
		                cssClass: function(group, item) {
		                    var result = "",
		                        index = item.index,
		                        groupLength = group.length - 1;
	
		                    if (group.firstLevel && index === 0) {
		                        result += "k-top ";
		                    }
	
		                    if (index === 0 && index != groupLength) {
		                        result += "k-top";
		                    } else if (index == groupLength) {
		                        result += "k-bot";
		                    } else {
		                        result += "k-mid";
		                    }
	
		                    return result;
		                },
		                textClass: function(item, isLink) {
		                    var result = "k-in";
	
		                    if (isLink) {
		                        result += " k-link";
		                    }
	
		                    if (item.enabled === false) {
		                        result += " k-state-disabled";
		                    }
	
		                    if (item.selected === true) {
		                        result += " k-state-selected";
		                    }
	
		                    return result;
		                },
		                toggleButtonClass: function(item) {
		                    var result = "k-icon";
	
		                    if (item.expanded !== true) {
		                        result += " k-i-expand";
		                    } else {
		                        result += " k-i-collapse";
		                    }
	
		                    return result;
		                },
		                groupAttributes: function(group) {
		                    var attributes = "";
	
		                    if (!group.firstLevel) {
		                        attributes = "role='group'";
		                    }
	
		                    return attributes + (group.expanded !== true ? " style='display:none'" : "");
		                },
		                groupCssClass: function(group) {
		                    var cssClass = "k-group";
	
		                    if (group.firstLevel) {
		                        cssClass += " k-treeview-lines";
		                    }
	
		                    return cssClass;
		                },
		                dragClue: templateNoWith(
		                    "#= data.treeview.template(data) #"
		                ),
		                group: templateNoWith(
		                    "<ul class='#= data.r.groupCssClass(data.group) #'#= data.r.groupAttributes(data.group) #>" +
		                        "#= data.renderItems(data) #" +
		                    "</ul>"
		                ),
		                itemContent: templateNoWith(
		                    "# var imageUrl = " + fieldAccessor("imageUrl") + "(data.item); #" +
		                    "# var spriteCssClass = " + fieldAccessor("spriteCssClass") + "(data.item); #" +
		                    "# if (imageUrl) { #" +
		                        "<img class='k-image' alt='' src='#= imageUrl #'>" +
		                    "# } #" +
	
		                    "# if (spriteCssClass) { #" +
		                        "<span class='k-sprite #= spriteCssClass #' />" +
		                    "# } #" +
	
		                    "#= data.treeview.template(data) #"
		                ),
		                itemElement: templateNoWith(
		                    "# var item = data.item, r = data.r; #" +
		                    "# var url = " + fieldAccessor("url") + "(item); #" +
		                    "<div class='#= r.cssClass(data.group, item) #'>" +
		                        "# if (item.hasChildren) { #" +
		                            "<span class='#= r.toggleButtonClass(item) #'/>" +
		                        "# } #" +
	
		                        "# if (data.treeview.checkboxes) { #" +
		                            "<span class='k-checkbox-wrapper' role='presentation'>" +
		                                "#= data.treeview.checkboxes.template(data) #" +
		                            "</span>" +
		                        "# } #" +
	
		                        "# var tag = url ? 'a' : 'span'; #" +
		                        "# var textAttr = url ? ' href=\\'' + url + '\\'' : ''; #" +
	
		                        "<#=tag# class='#= r.textClass(item, !!url) #'#= textAttr #>" +
		                            "#= r.itemContent(data) #" +
		                        "</#=tag#>" +
		                    "</div>"
		                ),
		                item: templateNoWith(
		                    "# var item = data.item, r = data.r; #" +
		                    "<li role='treeitem' class='#= r.wrapperCssClass(data.group, item) #'" +
		                        kendo.attr("uid") + "='#= item.uid #' " +
		                        "# if (data.treeview.checkboxes) { #" +
		                            "aria-checked='#= item.checked ? \"true\" : \"false\" #' " +
		                        "# } #" +
		                        "aria-selected='#= item.selected ? \"true\" : \"false\" #' " +
		                        "#=item.enabled === false ? \"aria-disabled='true'\" : ''#" +
		                        "aria-expanded='#= item.expanded ? \"true\" : \"false\" #' " +
		                        "data-expanded='#= item.expanded ? \"true\" : \"false\" #' " +
		                    ">" +
		                        "#= r.itemElement(data) #" +
		                    "</li>"
		                ),
		                loading: templateNoWith(
		                    "<div class='k-icon k-i-loading' /> #: data.messages.loading #"
		                ),
		                retry: templateNoWith(
		                    "#: data.messages.requestFailed # " +
		                    "<button class='k-button k-request-retry'>#: data.messages.retry #</button>"
		                )
		            };
		        },
	
		        items: function() {
		            return this.element.find(".k-item > div:first-child");
		        },
	
		        setDataSource: function(dataSource) {
		            var options = this.options;
	
		            options.dataSource = dataSource;
	
		            this._dataSourceUids = {};
	
		            this._dataSource();
	
		            if (options.checkboxes && options.checkboxes.checkChildren) {
		                this.dataSource.one("change", $.proxy(this.updateIndeterminate, this, null));
		            }
	
		            if (this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        },
	
		        _bindDataSource: function() {
		            this._refreshHandler = proxy(this.refresh, this);
		            this._errorHandler = proxy(this._error, this);
	
		            this.dataSource.bind(CHANGE, this._refreshHandler);
		            this.dataSource.bind(ERROR, this._errorHandler);
		        },
	
		        _unbindDataSource: function() {
		            var dataSource = this.dataSource;
	
		            if (dataSource) {
		                dataSource.unbind(CHANGE, this._refreshHandler);
		                dataSource.unbind(ERROR, this._errorHandler);
		            }
		        },
	
		        _dataSource: function(silentRead) {
		            var that = this,
		                options = that.options,
		                dataSource = options.dataSource;
	
		            function recursiveRead(data) {
		                for (var i = 0; i < data.length; i++) {
		                    data[i]._initChildren();
	
		                    data[i].children.fetch();
	
		                    recursiveRead(data[i].children.view());
		                }
		            }
	
		            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;
	
		            that._unbindDataSource();
	
		            if (!dataSource.fields) {
		                dataSource.fields = [
		                    { field: "text" },
		                    { field: "url" },
		                    { field: "spriteCssClass" },
		                    { field: "imageUrl" }
		                ];
		            }
	
		            that.dataSource = dataSource = HierarchicalDataSource.create(dataSource);
	
		            if (silentRead) {
		                dataSource.fetch();
	
		                recursiveRead(dataSource.view());
		            }
	
		            that._bindDataSource();
		        },
	
		        events: [
		            DRAGSTART,
		            DRAG,
		            DROP,
		            DRAGEND,
	
		            DATABOUND,
	
		            EXPAND,
		            COLLAPSE,
		            SELECT,
		            CHANGE,
		            NAVIGATE,
		            CHECK
		        ],
	
		        options: {
		            name: "TreeView",
		            dataSource: {},
		            animation: {
		                expand: {
		                    effects: "expand:vertical",
		                    duration: 200
		                }, collapse: {
		                    duration: 100
		                }
		            },
		            messages: {
		                loading: "Loading...",
		                requestFailed: "Request failed.",
		                retry: "Retry"
		            },
		            dragAndDrop: false,
		            checkboxes: false,
		            autoBind: true,
		            autoScroll: false,
		            loadOnDemand: true,
		            template: "",
		            dataTextField: null
		        },
	
		        _accessors: function() {
		            var that = this,
		                options = that.options,
		                i, field, textField,
		                element = that.element;
	
		            for (i in bindings) {
		                field = options[bindings[i]];
		                textField = element.attr(kendo.attr(i + "-field"));
	
		                if (!field && textField) {
		                    field = textField;
		                }
	
		                if (!field) {
		                    field = i;
		                }
	
		                if (!isArray(field)) {
		                    field = [field];
		                }
	
		                options[bindings[i]] = field;
		            }
		        },
	
		        // generates accessor function for a given field name, honoring the data*Field arrays
		        _fieldAccessor: function(fieldName) {
		            var fieldBindings = this.options[bindings[fieldName]],
		                count = fieldBindings.length,
		                result = "(function(item) {";
	
		            if (count === 0) {
		                result += "return item['" + fieldName + "'];";
		            } else {
		                result += "var levels = [" +
		                            $.map(fieldBindings, function(x) {
		                                return "function(d){ return " + kendo.expr(x) + "}";
		                            }).join(",") + "];";
	
		                result += "return levels[Math.min(item.level(), " + count + "-1)](item)";
		            }
	
		            result += "})";
	
		            return result;
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
	
		            this._animation();
	
		            this._dragging();
	
		            this._templates();
		        },
	
		        _trigger: function (eventName, node) {
		            return this.trigger(eventName, {
		                node: node.closest(NODE)[0]
		            });
		        },
	
		        _setChecked: function(datasource, value) {
		            if (!datasource || !$.isFunction(datasource.view)) {
		                return;
		            }
	
		            for (var i = 0, nodes = datasource.view(); i < nodes.length; i++) {
		                if(nodes[i].enabled !== false){
		                    this._setCheckedValue(nodes[i], value);
		                }
	
		                if (nodes[i].children) {
		                    this._setChecked(nodes[i].children, value);
		                }
		            }
		        },
	
		        _setCheckedValue: function (node, value){
		            node[CHECKED] = value;
		        },
	
		        _setIndeterminate: function(node) {
		            var group = subGroup(node),
		                siblings, length,
		                all = true,
		                i;
	
		            if (!group.length) {
		                return;
		            }
	
		            siblings = checkboxes(group.children());
	
		            length = siblings.length;
	
		            if (!length) {
		                return;
		            } else if (length > 1) {
		                for (i = 1; i < length; i++) {
		                    if (siblings[i].checked != siblings[i-1].checked ||
		                        siblings[i].indeterminate || siblings[i-1].indeterminate) {
		                        all = false;
		                        break;
		                    }
		                }
		            } else {
		                all = !siblings[0].indeterminate;
		            }
	
		            node.attr(ARIACHECKED, all ? siblings[0].checked : "mixed");
	
		            return checkboxes(node)
		                .data(INDETERMINATE, !all)
		                .prop(INDETERMINATE, !all)
		                .prop(CHECKED, all && siblings[0].checked);
		        },
	
		        updateIndeterminate: function(node) {
		            // top-down update of inital indeterminate state for all nodes
		            node = node || this.wrapper;
	
		            var subnodes = subGroup(node).children();
		            var i;
		            var checkbox;
		            var dataItem;
	
		            if (subnodes.length) {
		                for (i = 0; i < subnodes.length; i++) {
		                    this.updateIndeterminate(subnodes.eq(i));
		                }
	
		                if (node.is(".k-treeview")) {
		                    return;
		                }
	
		                checkbox = this._setIndeterminate(node);
	
		                dataItem = this.dataItem(node);
	
		                if (checkbox && checkbox.prop(CHECKED)) {
		                    dataItem.checked = true;
		                } else {
		                    if (dataItem) {
		                        delete dataItem.checked;
		                    }
		                }
		            }
		        },
	
		        _bubbleIndeterminate: function(node, skipDownward) {
		            // bottom-up setting of indeterminate state of parent nodes
		            if (!node.length) {
		                return;
		            }
	
		            if (!skipDownward) {
		                //update the indeterminate state of the node itself
		                this.updateIndeterminate(node);
		            }
	
		            var parentNode = this.parent(node),
		                checkbox;
	
		            if (parentNode.length) {
		                this._setIndeterminate(parentNode);
	
		                checkbox = parentNode.children("div").find(".k-checkbox-wrapper input[type=checkbox]");
	
		                this._skip = true;
		                if (checkbox.prop(INDETERMINATE) === false) {
		                    this.dataItem(parentNode).set(CHECKED, checkbox.prop(CHECKED));
		                } else {
		                    // delete this.dataItem(parentNode).checked;
		                    this.dataItem(parentNode).set(CHECKED, false);
		                }
	
		                this._skip = false;
	
		                this._bubbleIndeterminate(parentNode, true);
		            }
		        },
	
		        _checkboxChange: function(e) {
		            var checkbox = $(e.target);
		            var isChecked = checkbox.prop(CHECKED);
		            var node = checkbox.closest(NODE);
		            var dataItem = this.dataItem(node);
	
		            if (this._preventChange) {
		                return;
		            }
	
		            if (dataItem.checked != isChecked) {
		                dataItem.set(CHECKED, isChecked);
		                node.attr(ARIACHECKED, isChecked);
		                this._trigger(CHECK, node);
		            }
		        },
	
		        _toggleButtonClick: function (e) {
		            var node = $(e.currentTarget).closest(NODE);
	
		            if (node.is("[aria-disabled='true']")) {
		                return;
		            }
	
		            this.toggle(node);
		        },
	
		        _mousedown: function(e) {
		            var that = this;
		            var currentTarget = $(e.currentTarget);
		            var node = $(e.currentTarget).closest(NODE);
		            var browser = kendo.support.browser;
	
		            if (node.is("[aria-disabled='true']")) {
		                return;
		            }
	
		            //IE does not trigger change for indeterminate checkboxes
		            if ((browser.msie || browser.edge) && currentTarget.is(":checkbox")) {
		                if (currentTarget.prop(INDETERMINATE)) {
		                    that._preventChange = false;
	
		                    currentTarget.prop(CHECKED, !currentTarget.prop(CHECKED));
		                    currentTarget.trigger(CHANGE);
	
		                    currentTarget.on(CLICK + NS, function (e) {
		                        e.preventDefault();
		                    });
	
		                    that._preventChange = true;
		                } else {
		                    currentTarget.off(CLICK + NS);
		                    that._preventChange = false;
		                }
		            }
	
		            that._clickTarget = node;
		            that.current(node);
		        },
	
		        _focusable: function (node) {
		            return node && node.length && node.is(":visible") && !node.find(".k-in:first").hasClass(DISABLED);
		        },
	
		        _focus: function() {
		            var current = this.select(),
		                clickTarget = this._clickTarget;
	
		            // suppress initial focus state on touch devices (until keyboard is used)
		            if (kendo.support.touch) {
		                return;
		            }
	
		            if (clickTarget && clickTarget.length) {
		                current = clickTarget;
		            }
	
		            if (!this._focusable(current)) {
		                current = this.current();
		            }
	
		            if (!this._focusable(current)) {
		                current = this._nextVisible($());
		            }
	
		            this.current(current);
		        },
	
		        focus: function() {
		            var wrapper = this.wrapper,
		                scrollContainer = wrapper[0],
		                containers = [],
		                offsets = [],
		                documentElement = document.documentElement,
		                i;
	
		            do {
		                scrollContainer = scrollContainer.parentNode;
	
		                if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
		                    containers.push(scrollContainer);
		                    offsets.push(scrollContainer.scrollTop);
		                }
		            } while (scrollContainer != documentElement);
	
		            wrapper.focus();
	
		            for (i = 0; i < containers.length; i++) {
		                containers[i].scrollTop = offsets[i];
		            }
		        },
	
		        _blur: function() {
		            this.current().find(".k-in:first").removeClass("k-state-focused");
		        },
	
		        _enabled: function(node) {
		            return !node.children("div").children(".k-in").hasClass(DISABLED);
		        },
	
		        parent: function(node) {
		            var wrapperRe = /\bk-treeview\b/,
		                itemRe = /\bk-item\b/,
		                result,
		                skipSelf;
	
		            if (typeof node == STRING) {
		                node = this.element.find(node);
		            }
	
		            if (!isDomElement(node)) {
		                node = node[0];
		            }
	
		            skipSelf = itemRe.test(node.className);
	
		            do {
		                node = node.parentNode;
	
		                if (itemRe.test(node.className)) {
		                    if (skipSelf) {
		                        result = node;
		                    } else {
		                        skipSelf = true;
		                    }
		                }
		            } while (!wrapperRe.test(node.className) && !result);
	
		            return $(result);
		        },
	
		        _nextVisible: function(node) {
		            var that = this,
		                expanded = that._expanded(node),
		                result;
	
		            function nextParent(node) {
		                while (node.length && !node.next().length) {
		                    node = that.parent(node);
		                }
	
		                if (node.next().length) {
		                    return node.next();
		                } else {
		                    return node;
		                }
		            }
	
		            if (!node.length || !node.is(":visible")) {
		                result = that.root.children().eq(0);
		            } else if (expanded) {
		                result = subGroup(node).children().first();
	
		                // expanded node with no children
		                if (!result.length) {
		                    result = nextParent(node);
		                }
		            } else {
		                result = nextParent(node);
		            }
	
		            return result;
		        },
	
		        _previousVisible: function(node) {
		            var that = this,
		                lastChild,
		                result;
	
		            if (!node.length || node.prev().length) {
		                if (node.length) {
		                    result = node.prev();
		                } else {
		                    result = that.root.children().last();
		                }
	
		                while (that._expanded(result)) {
		                    lastChild = subGroup(result).children().last();
	
		                    if (!lastChild.length) {
		                        break;
		                    }
	
		                    result = lastChild;
		                }
		            } else {
		                result = that.parent(node) || node;
		            }
	
		            return result;
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode,
		                target,
		                focused = that.current(),
		                expanded = that._expanded(focused),
		                checkbox = focused.find(".k-checkbox-wrapper:first :checkbox"),
		                rtl = kendo.support.isRtl(that.element);
	
		            if (e.target != e.currentTarget) {
		                return;
		            }
	
		            if ((!rtl && key == keys.RIGHT) || (rtl && key == keys.LEFT)) {
		                if (expanded) {
		                    target = that._nextVisible(focused);
		                } else if (!focused.find(".k-in:first").hasClass(DISABLED)) {
		                    that.expand(focused);
		                }
		            } else if ((!rtl && key == keys.LEFT) || (rtl && key == keys.RIGHT)) {
		                if (expanded && !focused.find(".k-in:first").hasClass(DISABLED)) {
		                    that.collapse(focused);
		                } else {
		                    target = that.parent(focused);
	
		                    if (!that._enabled(target)) {
		                        target = undefined;
		                    }
		                }
		            } else if (key == keys.DOWN) {
		                target = that._nextVisible(focused);
		            } else if (key == keys.UP) {
		                target = that._previousVisible(focused);
		            } else if (key == keys.HOME) {
		                target = that._nextVisible($());
		            } else if (key == keys.END) {
		                target = that._previousVisible($());
		            } else if (key == keys.ENTER && !focused.find(".k-in:first").hasClass(DISABLED)) {
		                if (!focused.find(".k-in:first").hasClass("k-state-selected")) {
		                    if (!that._trigger(SELECT, focused)) {
		                        that.select(focused);
		                    }
		                }
		            } else if (key == keys.SPACEBAR && checkbox.length) {
		                if(!focused.find(".k-in:first").hasClass(DISABLED)){
		                    checkbox.prop(CHECKED, !checkbox.prop(CHECKED))
		                        .data(INDETERMINATE, false)
		                        .prop(INDETERMINATE, false);
	
		                    that._checkboxChange({ target: checkbox });
		                }
		                target = focused;
		            }
	
		            if (target) {
		                e.preventDefault();
	
		                if (focused[0] != target[0]) {
		                    that._trigger(NAVIGATE, target);
		                    that.current(target);
		                }
		            }
		        },
	
		        _keypress: function (e) {
		            var that = this;
		            var delay = 300;
		            var selectedNode = that._getSelectedNode();
		            var matchToSelect;
		            var key = e.key;
		            var isPrintable = key.length === 1;
	
		            if (!isPrintable) {
		                return;
		            }
	
		            if (!that._match) {
		                that._match = "";
		            }
	
		            that._match += key;
		            clearTimeout(that._matchTimer);
		            that._matchTimer = setTimeout(function() {
		                that._match = "";
		            }, delay);
	
		            matchToSelect = selectedNode &&
		                            that._matchNextByText(
		                                Array.prototype.indexOf.call(this.element.find(".k-item"),
		                                selectedNode[0]), that._match
		                            );
	
		            if (!matchToSelect) {
		                matchToSelect = that._matchNextByText(-1, that._match);
		            }
	
		            that.select(matchToSelect);
		        },
	
		        _matchNextByText: function(startIndex, text) {
		            return $(this.element).find(".k-in").filter(function(i, element) {
		                return (i > startIndex &&
		                        $(element).is(":visible") &&
		                        !$(element).hasClass(DISABLED) &&
		                        $(element).text().toLowerCase().indexOf(text) === 0);
		            }).closest(NODE)[0];
		        },
	
		        _click: function (e) {
		            var that = this,
		                node = $(e.currentTarget),
		                contents = nodeContents(node.closest(NODE)),
		                href = node.attr("href"),
		                shouldNavigate;
	
		            if (href) {
		                shouldNavigate = href == "#" || href.indexOf("#" + this.element.id + "-") >= 0;
		            } else {
		                shouldNavigate = contents.length && !contents.children().length;
		            }
	
		            if (shouldNavigate) {
		                e.preventDefault();
		            }
	
		            if (!node.hasClass(".k-state-selected") && !that._trigger(SELECT, node)) {
		                that.select(node);
		            }
		        },
	
		        _wrapper: function() {
		            var that = this,
		                element = that.element,
		                wrapper, root,
		                wrapperClasses = "k-widget k-treeview";
	
		            if (element.is("ul")) {
		                wrapper = element.wrap('<div />').parent();
		                root = element;
		            } else {
		                wrapper = element;
		                root = wrapper.children("ul").eq(0);
		            }
	
		            that.wrapper = wrapper.addClass(wrapperClasses);
		            that.root = root;
		        },
	
		        _getSelectedNode: function() {
		            return this.element.find(".k-state-selected").closest(NODE);
		        },
	
		        _group: function(item) {
		            var that = this,
		                firstLevel = item.hasClass(KTREEVIEW),
		                group = {
		                    firstLevel: firstLevel,
		                    expanded: firstLevel || that._expanded(item)
		                },
		                groupElement = item.children("ul");
	
		            groupElement
		                .addClass(that.templates.groupCssClass(group))
		                .css("display", group.expanded ? "" : "none");
	
		            that._nodes(groupElement, group);
		        },
	
		        _nodes: function(groupElement, groupData) {
		            var that = this,
		                nodes = groupElement.children("li"),
		                nodeData;
	
		            groupData = extend({ length: nodes.length }, groupData);
	
		            nodes.each(function(i, node) {
		                node = $(node);
	
		                nodeData = { index: i, expanded: that._expanded(node) };
	
		                updateNodeHtml(node);
	
		                that._updateNodeClasses(node, groupData, nodeData);
	
		                // iterate over child nodes
		                that._group(node);
		            });
		        },
	
		        _checkboxes: function() {
		            var options = this.options;
		            var checkboxes = options.checkboxes;
		            var defaultTemplate;
	
		            if (checkboxes) {
		                defaultTemplate = "<input type='checkbox' tabindex='-1' #= (item.enabled === false) ? 'disabled' : '' # #= item.checked ? 'checked' : '' #";
	
	
		                if (checkboxes.name) {
		                    defaultTemplate += " name='" + checkboxes.name + "'";
		                }
	
		                defaultTemplate += " id='_#= item.uid #' class='k-checkbox' /><span class='k-checkbox-label checkbox-span'></span>";
	
		                checkboxes = extend({
		                    template: defaultTemplate
		                }, options.checkboxes);
	
		                if (typeof checkboxes.template == STRING) {
		                    checkboxes.template = template(checkboxes.template);
		                }
	
		                options.checkboxes = checkboxes;
		            }
		        },
	
		        _updateNodeClasses: function (node, groupData, nodeData) {
		            var wrapper = node.children("div"),
		                group = node.children("ul"),
		                templates = this.templates;
	
		            if (node.hasClass("k-treeview")) {
		                return;
		            }
	
		            nodeData = nodeData || {};
		            nodeData.expanded = typeof nodeData.expanded != UNDEFINED ? nodeData.expanded : this._expanded(node);
		            nodeData.index = typeof nodeData.index != UNDEFINED ? nodeData.index : node.index();
		            nodeData.enabled = typeof nodeData.enabled != UNDEFINED ? nodeData.enabled : !wrapper.children(".k-in").hasClass("k-state-disabled");
	
		            groupData = groupData || {};
		            groupData.firstLevel = typeof groupData.firstLevel != UNDEFINED ? groupData.firstLevel : node.parent().parent().hasClass(KTREEVIEW);
		            groupData.length = typeof groupData.length != UNDEFINED ? groupData.length : node.parent().children().length;
	
		            // li
		            node.removeClass("k-first k-last")
		                .addClass(templates.wrapperCssClass(groupData, nodeData));
	
		            // div
		            wrapper.removeClass("k-top k-mid k-bot")
		                   .addClass(templates.cssClass(groupData, nodeData));
	
		            // span / a
		            var textWrap = wrapper.children(".k-in");
		            var isLink = textWrap[0] && textWrap[0].nodeName.toLowerCase() == "a";
		            textWrap.removeClass("k-in k-link k-state-default k-state-disabled")
		                .addClass(templates.textClass(nodeData, isLink));
	
		            // toggle button
		            if (group.length || node.attr("data-hasChildren") == "true") {
		                wrapper.children(".k-icon").removeClass("k-i-expand k-i-collapse")
		                    .addClass(templates.toggleButtonClass(nodeData));
	
		                group.addClass("k-group");
		            }
		        },
	
	
		        _processNodes: function(nodes, callback) {
		            var that = this;
		            var items = that.element.find(nodes);
		            for (var i = 0; i < items.length; i++) {
		                callback.call(that, i, $(items[i]).closest(NODE));
		            }
		        },
	
		        dataItem: function(node) {
		            var uid = $(node).closest(NODE).attr(kendo.attr("uid")),
		                dataSource = this.dataSource;
	
		            return dataSource && dataSource.getByUid(uid);
		        },
	
		        _dataItem: function(node) {
		            var uid = $(node).closest(NODE).attr(kendo.attr("uid")),
		                dataSource = this.dataSource;
	
		            return dataSource && this._dataSourceUids[uid];
		        },
	
		        _insertNode: function(nodeData, index, parentNode, insertCallback, collapsed) {
		            var that = this,
		                group = subGroup(parentNode),
		                updatedGroupLength = group.children().length + 1,
		                childrenData,
		                groupData = {
		                    firstLevel: parentNode.hasClass(KTREEVIEW),
		                    expanded: !collapsed,
		                    length: updatedGroupLength
		                }, node, i, item, nodeHtml = "", firstChild, lastChild,
		                append = function(item, group) {
		                    item.appendTo(group);
		                };
	
		            for (i = 0; i < nodeData.length; i++) {
		                item = nodeData[i];
	
		                item.index = index + i;
	
		                nodeHtml += that._renderItem({
		                    group: groupData,
		                    item: item
		                });
		            }
	
		            node = $(nodeHtml);
	
		            if (!node.length) {
		                return;
		            }
	
		            that.angular("compile", function(){
		                return {
		                    elements: node.get(),
		                    data: nodeData.map(function(item){
		                        return { dataItem: item };
		                    })
		                };
		            });
	
		            if (!group.length) {
		                group = $(that._renderGroup({
		                    group: groupData
		                })).appendTo(parentNode);
		            }
	
		            insertCallback(node, group);
	
		            if (parentNode.hasClass("k-item")) {
		                updateNodeHtml(parentNode);
		                that._updateNodeClasses(parentNode, groupData, {expanded: !collapsed});
		            }
	
		            firstChild = node.prev().first();
		            lastChild = node.next().last();
	
		            that._updateNodeClasses(firstChild, {}, {expanded: firstChild.attr("data-expanded")});
		            that._updateNodeClasses(lastChild, {}, {expanded: lastChild.attr("data-expanded")});
	
		            // render sub-nodes
		            for (i = 0; i < nodeData.length; i++) {
		                item = nodeData[i];
	
		                if (item.hasChildren) {
		                    childrenData = item.children.data();
	
		                    if (childrenData.length) {
		                        that._insertNode(childrenData, item.index, node.eq(i), append, !item.expanded);
		                    }
		                }
		            }
	
		            return node;
		        },
	
		        _updateNodes: function(items, field) {
		            var that = this;
		            var i, node, nodeWrapper, item, isChecked, isCollapsed;
		            var context = { treeview: that.options, item: item };
		            var render = field != "expanded" && field != "checked";
	
		            function setCheckedState(root, state) {
		                if (root.is(".k-group")) {
		                    root.find(".k-item:not([aria-disabled])").attr(ARIACHECKED, state);
		                }
	
		                root.find(".k-checkbox-wrapper input[type=checkbox]:not([disabled])")
		                    .prop(CHECKED, state)
		                    .data(INDETERMINATE, false)
		                    .prop(INDETERMINATE, false);
		            }
	
		            if (field == "selected") {
		                item = items[0];
	
		                node = that.findByUid(item.uid).find(".k-in:first")
		                        .removeClass("k-state-hover")
		                        .toggleClass("k-state-selected", item[field])
		                        .end();
	
		                if (item[field]) {
		                    that.current(node);
		                }
	
		                node.attr(ARIASELECTED, !!item[field]);
		            } else {
		                var elements = $.map(items, function(item) {
		                    return that.findByUid(item.uid).children("div");
		                });
	
		                if (render) {
		                    that.angular("cleanup", function() { return { elements: elements }; });
		                }
	
		                for (i = 0; i < items.length; i++) {
		                    context.item = item = items[i];
		                    nodeWrapper = elements[i];
		                    node = nodeWrapper.parent();
	
		                    if (render) {
		                        nodeWrapper.children(".k-in")
		                            .html(that.templates.itemContent(context));
		                    }
	
		                    if (field == CHECKED) {
		                        isChecked = item[field];
	
		                        setCheckedState(nodeWrapper, isChecked);
	
		                        node.attr(ARIACHECKED, isChecked);
	
		                        if (that.options.checkboxes.checkChildren) {
		                            setCheckedState(node.children(".k-group"), isChecked);
	
		                            that._setChecked(item.children, isChecked);
	
		                            that._bubbleIndeterminate(node);
		                        }
		                    } else if (field == "expanded") {
		                        that._toggle(node, item, item[field]);
		                    } else if (field == "enabled") {
		                        node.find(".k-checkbox-wrapper input[type=checkbox]").prop("disabled", !item[field]);
	
		                        isCollapsed = !nodeContents(node).is(VISIBLE);
	
		                        node.removeAttr(ARIADISABLED);
	
		                        if (!item[field]) {
		                            if (item.selected) {
		                                item.set("selected", false);
		                            }
	
		                            if (item.expanded) {
		                                item.set("expanded", false);
		                            }
	
		                            isCollapsed = true;
		                            node.attr(ARIASELECTED, false)
		                                .attr(ARIADISABLED, true);
		                        }
	
		                        that._updateNodeClasses(node, {}, { enabled: item[field], expanded: !isCollapsed });
		                    }
	
		                    if (nodeWrapper.length) {
		                        this.trigger("itemChange", { item: nodeWrapper, data: item, ns: ui });
		                    }
		                }
	
		                if (render) {
		                    that.angular("compile", function(){
		                        return {
		                            elements: elements,
		                            data: $.map(items, function(item) {
		                                return [{ dataItem: item }];
		                            })
		                        };
		                    });
		                }
		            }
		        },
	
		        _appendItems: function(index, items, parentNode) {
		            var group = subGroup(parentNode);
		            var children = group.children();
		            var collapsed = !this._expanded(parentNode);
	
		            if(this.element === parentNode){
		                var dataItems = this.dataSource.data();
		                var viewItems = this.dataSource.view();
		                var rootItems = viewItems.length < dataItems.length ? viewItems : dataItems;
		                index = rootItems.indexOf(items[0]);
		            } else if (items.length){
		                index = items[0].parent().indexOf(items[0]);
		            }
	
		            if (typeof index == UNDEFINED) {
		                index = children.length;
		            }
	
		            this._insertNode(items, index, parentNode, function(item, group) {
		                // insert node into DOM
		                if (index >= children.length) {
		                    item.appendTo(group);
		                } else {
		                    item.insertBefore(children.eq(index));
		                }
		            }, collapsed);
	
		            if (!collapsed) {
		                this._updateNodeClasses(parentNode, {}, {expanded: !collapsed});
		                subGroup(parentNode).css("display", "block");
		            }
		        },
	
		        _refreshChildren: function(parentNode, items, index) {
		            var i, children, child;
		            var options = this.options;
		            var loadOnDemand = options.loadOnDemand;
		            var checkChildren = options.checkboxes && options.checkboxes.checkChildren;
	
		            subGroup(parentNode).empty();
	
		            if (!items.length) {
		                updateNodeHtml(parentNode);
		            } else {
		                this._appendItems(index, items, parentNode);
	
		                children = subGroup(parentNode).children();
	
		                if (loadOnDemand && checkChildren) {
		                    this._bubbleIndeterminate(children.last());
		                }
	
		                for (i = 0; i < children.length; i++) {
		                    child = children.eq(i);
		                    this.trigger("itemChange", {
		                        item: child.children("div"),
		                        data: items[i],
		                        ns: ui
		                    });
		                }
		            }
		        },
	
		        _refreshRoot: function(items) {
		            var groupHtml = this._renderGroup({
		                    items: items,
		                    group: {
		                        firstLevel: true,
		                        expanded: true
		                    }
		                });
	
		            if (this.root.length) {
		                this._angularItems("cleanup");
	
		                var group = $(groupHtml);
	
		                this.root
		                    .attr("class", group.attr("class"))
		                    .html(group.html());
		            } else {
		                this.root = this.wrapper.html(groupHtml).children("ul");
		            }
	
		            var elements = this.root.children(".k-item");
		            for (var i = 0; i < items.length; i++) {
		                this.trigger("itemChange", {
		                    item: elements.eq(i),
		                    data: items[i],
		                    ns: ui
		                });
		            }
		            this._angularItems("compile");
		        },
	
		        refresh: function(e) {
		            var node = e.node;
		            var action = e.action;
		            var items = e.items;
		            var parentNode = this.wrapper;
		            var options = this.options;
		            var loadOnDemand = options.loadOnDemand;
		            var checkChildren = options.checkboxes && options.checkboxes.checkChildren;
		            var i;
	
		            if (this._skip) {
		                return;
		            }
	
		            for (i = 0; i < items.length; i++) {
		                this._dataSourceUids[items[i].uid] = items[i];
		            }
	
		            if (e.field) {
		                if (!items[0] || !items[0].level) {
		                    return;
		                }
	
		                return this._updateNodes(items, e.field);
		            }
	
		            if (node) {
		                parentNode = this.findByUid(node.uid);
		                this._progress(parentNode, false);
		            }
	
		            if (checkChildren && action != "remove") {
		                var bubble = false;
	
		                for (i = 0; i < items.length; i++) {
		                    if ("checked" in items[i]) {
		                        bubble = true;
		                        break;
		                    }
		                }
	
		                if (!bubble && node && node.checked) {
		                    for (i = 0; i < items.length; i++) {
		                        items[i].checked = true;
		                    }
		                }
		            }
	
		            if (action == "add") {
		                this._appendItems(e.index, items, parentNode);
		            } else if (action == "remove") {
		                this._remove(this.findByUid(items[0].uid), false);
		            } else if (action == "itemchange") {
		                this._updateNodes(items);
		            } else if (action == "itemloaded") {
		                this._refreshChildren(parentNode, items, e.index);
		            } else {
		                this._refreshRoot(items);
		            }
	
		            if (action != "remove") {
		                for (i = 0; i < items.length; i++) {
		                    if (!loadOnDemand || items[i].expanded || items[i]._loaded) {
		                        items[i].load();
		                    }
		                }
		            }
	
		            this.trigger(DATABOUND, { node: node ? parentNode : undefined });
		            if (this.dataSource.filter() && this.options.checkboxes.checkChildren) {
		                this.updateIndeterminate(parentNode);
		            }
		        },
	
		        _error: function(e) {
		            var node = e.node && this.findByUid(e.node.uid);
		            var retryHtml = this.templates.retry({ messages: this.options.messages });
	
		            if (node) {
		                this._progress(node, false);
		                this._expanded(node, false);
		                nodeIcon(node).addClass("k-i-reload");
		                e.node.loaded(false);
		            } else {
		                this._progress(false);
		                this.element.html(retryHtml);
		            }
		        },
	
		        _retryRequest: function(e) {
		            e.preventDefault();
	
		            this.dataSource.fetch();
		        },
	
		        expand: function (nodes) {
		            this._processNodes(nodes, function (index, item) {
		                this.toggle(item, true);
		            });
		        },
	
		        collapse: function (nodes) {
		            this._processNodes(nodes, function (index, item) {
		                this.toggle(item, false);
		            });
		        },
	
		        enable: function (nodes, enable) {
		            if (typeof nodes === "boolean") {
		                enable = nodes;
		                nodes = this.items();
		            } else {
		                enable = arguments.length == 2 ? !!enable : true;
		            }
	
		            this._processNodes(nodes, function (index, item) {
		                this.dataItem(item).set("enabled", enable);
		            });
		        },
	
		        current: function(node) {
		            var that = this,
		                current = that._current,
		                element = that.element,
		                id = that._ariaId;
	
		            if (arguments.length > 0 && node && node.length) {
		                if (current) {
		                    if (current[0].id === id) {
		                        current.removeAttr("id");
		                    }
	
		                    current.find(".k-in:first").removeClass("k-state-focused");
		                }
	
		                current = that._current = $(node, element).closest(NODE);
	
		                current.find(".k-in:first").addClass("k-state-focused");
	
		                id = current[0].id || id;
	
		                if (id) {
		                    that.wrapper.removeAttr("aria-activedescendant");
		                    current.attr("id", id);
		                    that.wrapper.attr("aria-activedescendant", id);
		                }
	
		                return;
		            }
	
		            if (!current) {
		                current = that._nextVisible($());
		            }
	
		            return current;
		        },
	
		        select: function (node) {
		            var that = this,
		                element = that.element;
	
		            if (!arguments.length) {
		                return element.find(".k-state-selected").closest(NODE);
		            }
	
		            node = $(node, element).closest(NODE);
	
		            element.find(".k-state-selected").each(function() {
		                var dataItem = that.dataItem(this);
		                if (dataItem) {
		                    dataItem.set("selected", false);
		                    delete dataItem.selected;
		                } else {
		                    $(this).removeClass("k-state-selected");
		                }
		            });
	
		            if (node.length) {
		                that.dataItem(node).set("selected", true);
		                that._clickTarget = node;
		            }
	
		            that.trigger(CHANGE);
		        },
	
		        _toggle: function(node, dataItem, expand) {
		            var options = this.options;
		            var contents = nodeContents(node);
		            var direction = expand ? "expand" : "collapse";
		            var loaded;
	
		            if (contents.data("animating")) {
		                return;
		            }
	
		            loaded = dataItem && dataItem.loaded();
	
		            if (expand && !loaded) {
		                if (options.loadOnDemand) {
		                    this._progress(node, true);
		                }
	
		                contents.remove();
		                dataItem.load();
		            } else {
		                this._updateNodeClasses(node, {}, { expanded: expand });
	
		                if (!expand) {
		                    contents.css("height", contents.height()).css("height");
		                }
	
		                contents
		                    .kendoStop(true, true)
		                    .kendoAnimate(extend(
		                        { reset: true },
		                        options.animation[direction],
		                        { complete: function() {
		                            if (expand) {
		                                contents.css("height", "");
		                            }
		                        } }
		                    ));
		            }
	
		        },
	
		        toggle: function (node, expand) {
		            node = $(node);
	
		            if (!nodeIcon(node).is(".k-i-expand, .k-i-collapse")) {
		                return;
		            }
	
		            if (arguments.length == 1) {
		                expand = !this._expanded(node);
		            }
	
		            this._expanded(node, expand);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.wrapper.off(NS);
		            that.wrapper.find(".k-checkbox-wrapper :checkbox").off(NS);
	
		            that._unbindDataSource();
	
		            if (that.dragging) {
		                that.dragging.destroy();
		            }
	
		            that._dataSourceUids = {};
	
		            kendo.destroy(that.element);
	
		            that.root = that.wrapper = that.element = null;
		        },
	
		        _expanded: function(node, value, force) {
		            var expandedAttr = kendo.attr("expanded");
		            var dataItem;
		            var expanded = value;
		            var direction = expanded ? "expand" : "collapse";
	
		            if (arguments.length == 1) {
		                dataItem = this._dataItem(node);
		                return node.attr(expandedAttr) === "true" || (dataItem && dataItem.expanded);
		            }
	
		            dataItem = this.dataItem(node);
	
		            if (nodeContents(node).data("animating")) {
		                return;
		            }
	
		            if (force || !this._trigger(direction, node)) {
		                if (expanded) {
		                    node.attr(expandedAttr, "true");
		                    node.attr("aria-expanded", "true");
		                } else {
		                    node.removeAttr(expandedAttr);
		                    node.attr("aria-expanded", "false");
		                }
	
		                if (dataItem) {
		                    dataItem.set("expanded", expanded);
		                    // necessary when expanding an item yields an error and the item is not expanded as a result
		                    expanded = dataItem.expanded;
		                }
		            }
		        },
	
		        _progress: function(node, showProgress) {
		            var element = this.element;
		            var loadingText = this.templates.loading({ messages: this.options.messages });
	
		            if (arguments.length == 1) {
		                showProgress = node;
	
		                if (showProgress) {
		                    element.html(loadingText);
		                } else {
		                    element.empty();
		                }
		            } else {
		                nodeIcon(node).toggleClass("k-i-loading", showProgress).removeClass("k-i-reload");
		            }
		        },
	
		        text: function (node, text) {
		            var dataItem = this.dataItem(node),
		                fieldBindings = this.options[bindings.text],
		                level = dataItem.level(),
		                length = fieldBindings.length,
		                field = fieldBindings[Math.min(level, length-1)];
	
		            if (text) {
		                dataItem.set(field, text);
		            } else {
		                return dataItem[field];
		            }
		        },
	
		        _objectOrSelf: function (node) {
		            return $(node).closest("[data-role=treeview]").data("kendoTreeView") || this;
		        },
	
		        _dataSourceMove: function(nodeData, group, parentNode, callback) {
		            var referenceDataItem,
		                destTreeview = this._objectOrSelf(parentNode || group),
		                destDataSource = destTreeview.dataSource;
		            var loadPromise = $.Deferred().resolve().promise();
	
		            if (parentNode && parentNode[0] != destTreeview.element[0]) {
		                referenceDataItem = destTreeview.dataItem(parentNode);
	
		                if (!referenceDataItem.loaded()) {
		                    destTreeview._progress(parentNode, true);
		                    loadPromise = referenceDataItem.load();
		                }
	
		                if (parentNode != this.root) {
		                    destDataSource = referenceDataItem.children;
	
		                    if (!destDataSource || !(destDataSource instanceof HierarchicalDataSource)) {
		                        referenceDataItem._initChildren();
		                        referenceDataItem.loaded(true);
		                        destDataSource = referenceDataItem.children;
		                    }
		                }
		            }
	
		            nodeData = this._toObservableData(nodeData);
	
		            return callback.call(destTreeview, destDataSource, nodeData, loadPromise);
		        },
	
		        _toObservableData: function(node) {
		            var dataItem = node, dataSource, uid;
	
		            if (isJQueryInstance(node) || isDomElement(node)) {
		                dataSource = this._objectOrSelf(node).dataSource;
		                uid = $(node).attr(kendo.attr("uid"));
		                dataItem = dataSource.getByUid(uid);
	
		                if (dataItem) {
		                    dataItem = dataSource.remove(dataItem);
		                }
		            }
	
		            return dataItem;
		        },
	
		        _insert: function(data, model, index) {
		            if (!(model instanceof kendo.data.ObservableArray)) {
		                if (!isArray(model)) {
		                    model = [model];
		                }
		            } else {
		                // items will be converted to new Node instances
		                model = model.toJSON();
		            }
	
		            var parentNode = data.parent();
	
		            if (parentNode && parentNode._initChildren) {
		                parentNode.hasChildren = true;
		                parentNode._initChildren();
		            }
	
		            data.splice.apply(data, [ index, 0 ].concat(model));
	
		            return this.findByUid(data[index].uid);
		        },
	
		        insertAfter: insertAction(1),
	
		        insertBefore: insertAction(0),
	
		        append: function (nodeData, parentNode, success) {
		            var group = this.root;
	
		            if(parentNode && nodeData instanceof jQuery && parentNode[0] === nodeData[0]){
		                return;
		            }
	
		            parentNode = parentNode && parentNode.length ? parentNode : null;
	
		            if (parentNode) {
		                group = subGroup(parentNode);
		            }
	
		            return this._dataSourceMove(nodeData, group, parentNode, function (dataSource, model, loadModel) {
		                var inserted;
		                var that = this;
	
		                function add() {
		                    if (parentNode) {
		                        that._expanded(parentNode, true, true);
		                    }
	
		                    var data = dataSource.data(),
		                        index = Math.max(data.length, 0);
	
		                    return that._insert(data, model, index);
		                }
	
		                loadModel.done(function() {
		                    inserted = add();
		                    success = success || $.noop;
		                    success(inserted);
		                });
	
		                return inserted || null;
		            });
		        },
	
		        _remove: function (node, keepData) {
		            var that = this,
		                parentNode,
		                prevSibling, nextSibling;
	
		            node = $(node, that.element);
	
		            this.angular("cleanup", function(){
		                return { elements: node.get() };
		            });
	
		            parentNode = node.parent().parent();
		            prevSibling = node.prev();
		            nextSibling = node.next();
	
		            node[keepData ? "detach" : "remove"]();
	
		            if (parentNode.hasClass("k-item")) {
		                updateNodeHtml(parentNode);
		                that._updateNodeClasses(parentNode);
		            }
	
		            that._updateNodeClasses(prevSibling);
		            that._updateNodeClasses(nextSibling);
	
		            return node;
		        },
	
		        remove: function (node) {
		            var dataItem = this.dataItem(node);
		            if (dataItem) {
		                this.dataSource.remove(dataItem);
		            }
		        },
	
		        detach: function (node) {
		            return this._remove(node, true);
		        },
	
		        findByText: function(text) {
		            return $(this.element).find(".k-in").filter(function(i, element) {
		                return $(element).text() == text;
		            }).closest(NODE);
		        },
	
		        findByUid: function(uid) {
		            var items = this.element.find(".k-item");
		            var uidAttr = kendo.attr("uid");
		            var result;
	
		            for (var i = 0; i < items.length; i++) {
		                if (items[i].getAttribute(uidAttr) == uid) {
		                    result = items[i];
		                    break;
		                }
		            }
	
		            return $(result);
		        },
	
		        expandPath: function(path, complete) {
		            var treeview = this;
		            var nodeIds = path.slice(0);
		            var callback = complete || $.noop;
	
		            function proceed() {
		                nodeIds.shift();
	
		                if (nodeIds.length) {
		                    expand(nodeIds[0]).then(proceed);
		                } else {
		                    callback.call(treeview);
		                }
		            }
	
		            function expand(id) {
		                var result = $.Deferred();
		                var node = treeview.dataSource.get(id);
	
		                if (node) {
		                    if (node.loaded()) {
		                        node.set("expanded", true);
		                        result.resolve();
		                    } else {
		                        // manually show progress of the node
		                        // should be moved to `refresh`
		                        // if the datasource starts triggering a `requestStart` event for nodes
		                        treeview._progress(treeview.findByUid(node.uid), true);
	
		                        node.load().then(function() {
		                            node.set("expanded", true);
		                            result.resolve();
		                        });
		                    }
		                } else {
		                    result.resolve();
		                }
	
		                return result.promise();
		            }
	
		            // expand async nodes
		            expand(nodeIds[0]).then(proceed);
		        },
	
		        _parentIds: function(node) {
		            var parent = node && node.parentNode();
		            var parents = [];
		            while (parent && parent.parentNode) {
		                parents.unshift(parent.id);
		                parent = parent.parentNode();
		            }
	
		            return parents;
		        },
	
		        expandTo: function(node) {
		            if (!(node instanceof kendo.data.Node)) {
		                node = this.dataSource.get(node);
		            }
	
		            var parents = this._parentIds(node);
	
		            this.expandPath(parents);
		        },
	
		        _renderItem: function (options) {
		            if (!options.group) {
		                options.group = {};
		            }
	
		            options.treeview = this.options;
	
		            options.r = this.templates;
	
		            return this.templates.item(options);
		        },
	
		        _renderGroup: function (options) {
		            var that = this;
	
		            options.renderItems = function(options) {
		                    var html = "",
		                        i = 0,
		                        items = options.items,
		                        len = items ? items.length : 0,
		                        group = options.group;
	
		                    group.length = len;
	
		                    for (; i < len; i++) {
		                        options.group = group;
		                        options.item = items[i];
		                        options.item.index = i;
		                        html += that._renderItem(options);
		                    }
	
		                    return html;
		                };
	
		            options.r = that.templates;
	
		            return that.templates.group(options);
		        }
		    });
	
		    ui.plugin(TreeView);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1340);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1340:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "treeview.draganddrop",
		    name: "Hierarchical Drag & Drop",
		    category: "framework",
		    depends: [ "core", "draganddrop" ],
		    advanced: true
		};
	
		(function($, undefined){
		    var kendo = window.kendo;
		    var ui = kendo.ui;
		    var proxy = $.proxy;
		    var extend = $.extend;
		    var VISIBILITY = "visibility";
		    var KSTATEHOVER = "k-state-hover";
		    var INPUTSELECTOR = "input,a:not(.k-in),textarea,.k-multiselect-wrap,select,button,a.k-button>.k-icon,button.k-button>.k-icon,span.k-icon.k-i-arrow-60-right,span.k-icon.k-i-arrow-45-down-right";
	
		    ui.HierarchicalDragAndDrop = kendo.Class.extend({
		        init: function (element, options) {
		            this.element = element;
		            this.hovered = element;
		            this.options = extend({
		                dragstart: $.noop, drag: $.noop, drop: $.noop, dragend: $.noop
		            }, options);
	
		            this._draggable = new ui.Draggable(element, {
		                ignore: INPUTSELECTOR,
		                filter: options.filter,
		                autoScroll: options.autoScroll,
		                cursorOffset: {
		                    left: 10,
		                    top: kendo.support.mobileOS ? -40 / kendo.support.zoomLevel() : 10
		                },
		                hint: proxy(this._hint, this),
		                dragstart: proxy(this.dragstart, this),
		                dragcancel: proxy(this.dragcancel, this),
		                drag: proxy(this.drag, this),
		                dragend: proxy(this.dragend, this),
		                $angular: options.$angular
		            });
		        },
	
		        _hint: function(element) {
		            return "<div class='k-header k-drag-clue'>" +
		                        "<span class='k-icon k-drag-status' />" +
		                        this.options.hintText(element) +
		                    "</div>";
		        },
	
		        _removeTouchHover: function() {
		            if (kendo.support.touch && this.hovered) {
		                this.hovered.find("." + KSTATEHOVER).removeClass(KSTATEHOVER);
		                this.hovered = false;
		            }
		        },
	
		        _hintStatus: function(newStatus) {
		            var statusElement = this._draggable.hint.find(".k-drag-status")[0];
	
		            if (newStatus) {
		                statusElement.className = "k-icon k-drag-status " + newStatus;
		            } else {
		                return $.trim(statusElement.className.replace(/(p|k)-(icon|drag-status)/g, ""));
		            }
		        },
	
		        dragstart: function (e) {
		            this.source = e.currentTarget.closest(this.options.itemSelector);
	
		            if (this.options.dragstart(this.source)) {
		                e.preventDefault();
		            }
	
		            if (this.options.reorderable) {
		                this.dropHint = $("<div class='k-i-drag-and-drop' />")
		                    .css(VISIBILITY, "hidden")
		                    .appendTo(this.element);
		            } else {
		                this.dropHint = $();
		            }
		        },
	
		        drag: function (e) {
		            var options = this.options;
		            var source = this.source;
		            var target = this.dropTarget = $(kendo.eventTarget(e));
		            var container = target.closest(options.allowedContainers);
		            var hoveredItem, itemHeight, itemTop, itemContent, delta;
		            var insertOnTop, insertOnBottom, addChild;
		            var itemData, position, status;
	
		            if (!container.length) {
		                // dragging outside of allowed elements
		                status = "k-i-cancel";
		                this._removeTouchHover();
		            } else if (source[0] == target[0] || options.contains(source[0], target[0])) {
		                // dragging item within itself
		                status = "k-i-cancel";
		            } else {
		                // moving or reordering item
		                status = "k-i-insert-middle";
	
		                itemData = options.itemFromTarget(target);
		                hoveredItem = itemData.item;
	
		                if (hoveredItem.length) {
		                    this._removeTouchHover();
		                    itemHeight = kendo._outerHeight(hoveredItem);
		                    itemContent = itemData.content;
	
		                    if (options.reorderable) {
		                        delta = itemHeight / (itemContent.length > 0 ? 4 : 2);
		                        itemTop = kendo.getOffset(hoveredItem).top;
	
		                        insertOnTop = e.y.location < (itemTop + delta);
		                        insertOnBottom = (itemTop + itemHeight - delta) < e.y.location;
		                        addChild = itemContent.length && !insertOnTop && !insertOnBottom;
		                    } else {
		                        addChild = true;
		                        insertOnTop = false;
		                        insertOnBottom = false;
		                    }
	
		                    this.hovered = addChild ? container : false;
	
		                    this.dropHint.css(VISIBILITY, addChild ? "hidden" : "visible");
	
		                    if (this._lastHover && this._lastHover[0] != itemContent[0]) {
		                        this._lastHover.removeClass(KSTATEHOVER);
		                    }
	
		                    this._lastHover = itemContent.toggleClass(KSTATEHOVER, addChild);
	
		                    if (addChild) {
		                        status = "k-i-plus";
		                    } else {
		                        position = hoveredItem.position();
		                        position.top += insertOnTop ? 0 : itemHeight;
	
		                        this.dropHint.css(position)
		                            [insertOnTop ? "prependTo" : "appendTo"]
		                            (options.dropHintContainer(hoveredItem));
	
		                        if (insertOnTop && itemData.first) {
		                            status = "k-i-insert-up";
		                        }
	
		                        if (insertOnBottom && itemData.last) {
		                            status = "k-i-insert-down";
		                        }
		                    }
		                } else if (target[0] != this.dropHint[0]) {
		                    if (this._lastHover) {
		                        this._lastHover.removeClass(KSTATEHOVER);
		                    }
	
		                    if (!$.contains(this.element[0], container[0])) {
		                        // moving node to different element
		                        status = "k-i-plus";
		                    } else {
		                        status = "k-i-cancel";
		                    }
		                }
		            }
	
		            this.options.drag({
		                originalEvent: e.originalEvent,
		                source: source,
		                target: target,
		                pageY: e.y.location,
		                pageX: e.x.location,
		                status: status.substring(2),
		                setStatus: function(value) {
		                    status = value;
		                }
		            });
	
		            if (status.indexOf("k-i-insert") !== 0) {
		                this.dropHint.css(VISIBILITY, "hidden");
		            }
	
		            this._hintStatus(status);
		        },
	
		        dragcancel: function() {
		            this.dropHint.remove();
		        },
	
		        dragend: function (e) {
		            var position = "over",
		                source = this.source,
		                destination,
		                dropHint = this.dropHint,
		                dropTarget = this.dropTarget,
		                eventArgs, dropPrevented;
	
		            if (dropHint.css(VISIBILITY) == "visible") {
		                position = this.options.dropPositionFrom(dropHint);
		                destination = dropHint.closest(this.options.itemSelector);
		            } else if (dropTarget) {
		                destination = dropTarget.closest(this.options.itemSelector);
	
		                // moving node to root element
		                if (!destination.length) {
		                    destination = dropTarget.closest(this.options.allowedContainers);
		                }
		            }
	
		            eventArgs = {
		                originalEvent: e.originalEvent,
		                source: source[0],
		                destination: destination[0],
		                valid: this._hintStatus() != "k-i-cancel",
		                setValid: function(newValid) {
		                    this.valid = newValid;
		                },
		                dropTarget: dropTarget[0],
		                position: position
		            };
	
		            dropPrevented = this.options.drop(eventArgs);
	
		            dropHint.remove();
		            this._removeTouchHover();
		            if (this._lastHover) {
		                this._lastHover.removeClass(KSTATEHOVER);
		            }
	
		            if (!eventArgs.valid || dropPrevented) {
		                this._draggable.dropped = eventArgs.valid;
		                return;
		            }
	
		            this._draggable.dropped = true;
	
		            this.options.dragend({
		                originalEvent: e.originalEvent,
		                source: source,
		                destination: destination,
		                position: position
		            });
		        },
	
		        destroy: function() {
		            this._lastHover = this.hovered = null;
		            this._draggable.destroy();
		        }
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1254);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1021:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(562);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1023:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(570);
	
	/***/ }),
	
	/***/ 1254:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1021), __webpack_require__(1022), __webpack_require__(1023) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "multiselect",
		    name: "MultiSelect",
		    category: "web",
		    description: "The MultiSelect widget allows the selection from pre-defined values.",
		    depends: [ "list" ],
		    features: [ {
		        id: "mobile-scroller",
		        name: "Mobile scroller",
		        description: "Support for kinetic scrolling in mobile device",
		        depends: [ "mobile.scroller" ]
		    }, {
		        id: "virtualization",
		        name: "VirtualList",
		        description: "Support for virtualization",
		        depends: [ "virtuallist" ]
		    } ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        List = ui.List,
		        keys = $.extend({ A: 65 }, kendo.keys),
		        activeElement = kendo._activeElement,
		        ObservableArray = kendo.data.ObservableArray,
		        proxy = $.proxy,
		        ID = "id",
		        LI = "li",
		        ACCEPT = "accept",
		        FILTER = "filter",
		        REBIND = "rebind",
		        OPEN = "open",
		        CLOSE = "close",
		        CHANGE = "change",
		        PROGRESS = "progress",
		        SELECT = "select",
		        DESELECT = "deselect",
		        ARIA_DISABLED = "aria-disabled",
		        FOCUSEDCLASS = "k-state-focused",
		        SELECTEDCLASS = "k-state-selected",
		        HIDDENCLASS = "k-hidden",
		        HOVERCLASS = "k-state-hover",
		        STATEDISABLED = "k-state-disabled",
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        ns = ".kendoMultiSelect",
		        CLICK = "click" + ns,
		        KEYDOWN = "keydown" + ns,
		        MOUSEENTER = "mouseenter" + ns,
		        MOUSELEAVE = "mouseleave" + ns,
		        HOVEREVENTS = MOUSEENTER + " " + MOUSELEAVE,
		        quotRegExp = /"/g,
		        isArray = $.isArray,
		        styles = ["font-family",
		                  "font-size",
		                  "font-stretch",
		                  "font-style",
		                  "font-weight",
		                  "letter-spacing",
		                  "text-transform",
		                  "line-height"];
	
		    var MultiSelect = List.extend({
		        init: function(element, options) {
		            var that = this, id, disabled;
	
		            that.ns = ns;
		            List.fn.init.call(that, element, options);
	
		            that._optionsMap = {};
		            that._customOptions = {};
	
		            that._wrapper();
		            that._tagList();
		            that._input();
		            that._textContainer();
		            that._loader();
		            that._clearButton();
	
		            that._tabindex(that.input);
	
		            element = that.element.attr("multiple", "multiple").hide();
		            options = that.options;
	
		            if (!options.placeholder) {
		                options.placeholder = element.data("placeholder");
		            }
	
		            id = element.attr(ID);
	
		            if (id) {
		                that._tagID = id + "_tag_active";
	
		                id = id + "_taglist";
		                that.tagList.attr(ID, id);
	
		                that.input.attr("aria-describedby", id);
		            }
	
		            that._initialOpen = true;
		            that._aria(id);
		            that._dataSource();
		            that._ignoreCase();
		            that._popup();
	
		            that._tagTemplate();
		            that.requireValueMapper(that.options);
		            that._initList();
	
		            that._reset();
		            that._enable();
		            that._placeholder();
	
		            if (options.autoBind) {
		                that.dataSource.fetch();
		            } else if (options.value) {
		                that._preselect(options.value);
		            }
	
		            disabled = $(that.element).parents("fieldset").is(':disabled');
	
		            if (disabled) {
		                that.enable(false);
		            }
	
		            kendo.notify(that);
		            that._toggleCloseVisibility();
		        },
	
		        options: {
		            name: "MultiSelect",
		            tagMode: "multiple",
		            enabled: true,
		            autoBind: true,
		            autoClose: true,
		            highlightFirst: true,
		            dataTextField: "",
		            dataValueField: "",
		            filter: "startswith",
		            ignoreCase: true,
		            minLength: 1,
		            enforceMinLength: false,
		            delay: 100,
		            value: null,
		            maxSelectedItems: null,
		            placeholder: "",
		            height: 200,
		            animation: {},
		            virtual: false,
		            itemTemplate: "",
		            tagTemplate: "",
		            groupTemplate: "#:data#",
		            fixedGroupTemplate: "#:data#",
		            clearButton: true,
		            autoWidth: false
		        },
	
		        events: [
		            OPEN,
		            CLOSE,
		            CHANGE,
		            SELECT,
		            DESELECT,
		            "filtering",
		            "dataBinding",
		            "dataBound"
		        ],
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
	
		            this._state = "";
		            this._dataSource();
	
		            this.persistTagList = false;
		            this.listView.setDataSource(this.dataSource);
	
		            if (this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        },
	
		        setOptions: function(options) {
		            var listOptions = this._listOptions(options);
	
		            List.fn.setOptions.call(this, options);
	
		            this.listView.setOptions(listOptions);
	
		            this._accessors();
		            this._aria(this.tagList.attr(ID));
		            this._tagTemplate();
		            this._placeholder();
		            this._clearButton();
		        },
	
		        currentTag: function(candidate) {
		            var that = this;
	
		            if (candidate !== undefined) {
		                if (that._currentTag) {
		                    that._currentTag
		                        .removeClass(FOCUSEDCLASS)
		                        .removeAttr(ID);
	
		                    that.input.removeAttr("aria-activedescendant");
		                }
	
		                if (candidate) {
		                    candidate.addClass(FOCUSEDCLASS).attr(ID, that._tagID);
	
		                    that.input
		                        .attr("aria-activedescendant", that._tagID);
		                }
	
		                that._currentTag = candidate;
		            } else {
		                return that._currentTag;
		            }
		        },
	
		        dataItems: function() {
		            return this.listView.selectedDataItems();
		        },
	
		        destroy: function() {
		            var that = this,
		                ns = that.ns;
	
		            clearTimeout(that._busy);
		            clearTimeout(that._typingTimeout);
	
		            that.wrapper.off(ns);
		            that.tagList.off(ns);
		            that.input.off(ns);
		            that._clear.off(ns);
	
		            List.fn.destroy.call(that);
		        },
	
		        _activateItem: function() {
		            if (this.popup.visible()) {
		                List.fn._activateItem.call(this);
		            }
		            this.currentTag(null);
		        },
	
		        _listOptions: function(options) {
		            var that = this;
		            var listOptions = List.fn._listOptions.call(that, $.extend(options, {
		                selectedItemChange: proxy(that._selectedItemChange, that),
		                selectable: "multiple"
		            }));
	
		            var itemTemplate = this.options.itemTemplate || this.options.template;
		            var template = listOptions.itemTemplate || itemTemplate || listOptions.template;
	
		            if (!template) {
		                template = "#:" + kendo.expr(listOptions.dataTextField, "data") + "#";
		            }
	
		            listOptions.template = template;
	
		            return listOptions;
		        },
	
		        _setListValue: function() {
		            List.fn._setListValue.call(this, this._initialValues.slice(0));
		        },
	
		        _listChange: function(e) {
		            var data = this.dataSource.flatView();
		            var optionsMap = this._optionsMap;
		            var valueGetter = this._value;
	
		            if (this._state === REBIND) {
		                this._state = "";
		            }
	
		            for (var i = 0; i < e.added.length; i++) {
		                if (optionsMap[valueGetter(e.added[i].dataItem)] === undefined) {
		                    this._render(data); //render select element <option> tags if the item does not persist in the current data view
		                    break;
		                }
		            }
	
		            this._selectValue(e.added, e.removed);
		        },
	
		        _selectedItemChange: function(e) {
		            var items = e.items;
		            var context;
		            var idx;
	
		            for (idx = 0; idx < items.length; idx++) {
		                context = items[idx];
		                this.tagList.children().eq(context.index).children("span:first").html(this.tagTextTemplate(context.item));
		            }
		        },
	
		        _wrapperMousedown: function(e) {
		            var that = this;
		            var notInput = e.target.nodeName.toLowerCase() !== "input";
		            var target = $(e.target);
		            var closeButton = target.hasClass("k-select") || target.hasClass("k-icon");
	
		            if (closeButton) {
		                closeButton = !target.closest(".k-select").children(".k-i-arrow-60-down").length;
		            }
	
		            if (notInput && !(closeButton && kendo.support.mobileOS)) {
		                e.preventDefault();
		            }
	
		            if (!closeButton) {
		                if (that.input[0] !== activeElement() && notInput) {
		                    that.input.focus();
		                }
	
		                if (that.options.minLength === 1) {
		                    that.open();
		                }
		            }
	
		        },
	
		        _inputFocus: function() {
		            this._placeholder(false);
		            this.wrapper.addClass(FOCUSEDCLASS);
		        },
	
		        _inputFocusout: function() {
		            var that = this;
	
		            clearTimeout(that._typingTimeout);
	
		            that.wrapper.removeClass(FOCUSEDCLASS);
	
		            that._placeholder(!that.listView.selectedDataItems()[0], true);
		            that.close();
	
		            if (that._state === FILTER) {
		                that._state = ACCEPT;
		                that.listView.skipUpdate(true);
		            }
	
		            if(that.listView.bound() && that.listView.isFiltered()) {
		                that.persistTagList = true;
		                that._clearFilter();
		            }
	
		            that.element.blur();
		        },
	
		        _removeTag: function(tag, shouldTrigger) {
		            var that = this;
		            var state = that._state;
		            var position = tag.index();
		            var listView = that.listView;
		            var value = listView.value()[position];
		            var dataItem = that.listView.selectedDataItems()[position];
		            var customIndex = that._customOptions[value];
		            var option;
	
		            if (that.trigger(DESELECT, { dataItem: dataItem, item: tag })) {
		                that._close();
		                return;
		            }
	
		            if (customIndex === undefined && (state === ACCEPT || state === FILTER)) {
		                customIndex = that._optionsMap[value];
		            }
	
		            var done = function() {
		                that.currentTag(null);
		                if (shouldTrigger) {
		                    that._change();
		                }
		                that._close();
		            };
	
		            if (customIndex === undefined) {
		                that.persistTagList = false;
		                listView.select(listView.select()[position]).done(done);
		            } else {
		                option = that.element[0].children[customIndex];
		                option.selected = false;
	
		                listView.removeAt(position);
		                tag.remove();
		                done();
		            }
		        },
	
		        _tagListClick: function(e) {
		            var target = $(e.currentTarget);
	
		            if (!target.children(".k-i-arrow-60-down").length) {
		                this._removeTag(target.closest(LI), true);
		            }
		        },
	
		        _clearClick: function() {
		            var that = this;
	
		            if (that.options.tagMode === "single"){
		                that.listView.value([]);
		            } else{
		                that.tagList.children().each(function(index, tag) {
		                    that._removeTag($(tag), false);
		                });
		            }
	
		            that.input.val("");
		            that._search();
		            that._change();
		            that.focus();
		            that._hideClear();
	
		            if (that._state === FILTER) {
		                that._state = ACCEPT;
		            }
		        },
	
		        _editable: function(options) {
		            var that = this,
		                disable = options.disable,
		                readonly = options.readonly,
		                wrapper = that.wrapper.off(ns),
		                tagList = that.tagList.off(ns),
		                input = that.element.add(that.input.off(ns));
	
		            if (!readonly && !disable) {
		                wrapper
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover)
		                    .on("mousedown" + ns + " touchend" + ns, proxy(that._wrapperMousedown, that));
	
		                that.input.on(KEYDOWN, proxy(that._keydown, that))
		                    .on("paste" + ns, proxy(that._search, that))
		                    .on("input" + ns, proxy(that._search, that))
		                    .on("focus" + ns, proxy(that._inputFocus, that))
		                    .on("focusout" + ns, proxy(that._inputFocusout, that));
	
		                that._clear.on(CLICK + ns + " touchend" + ns, proxy(that._clearClick, that));
		                input.removeAttr(DISABLED)
		                     .removeAttr(READONLY)
		                     .attr(ARIA_DISABLED, false);
	
		                tagList
		                    .on(MOUSEENTER, LI, function() { $(this).addClass(HOVERCLASS); })
		                    .on(MOUSELEAVE, LI, function() { $(this).removeClass(HOVERCLASS); })
		                    .on(CLICK, "li.k-button .k-select", proxy(that._tagListClick, that));
		            } else {
		                if (disable) {
		                    wrapper.addClass(STATEDISABLED);
		                } else {
		                    wrapper.removeClass(STATEDISABLED);
		                }
	
		                input.attr(DISABLED, disable)
		                     .attr(READONLY, readonly)
		                     .attr(ARIA_DISABLED, disable);
		            }
		        },
	
		        _close: function() {
		            var that = this;
		            if (that.options.autoClose) {
		                that.close();
		            } else {
		                that.popup.position();
		            }
		        },
	
		        _filterSource: function(filter, force) {
		            if(!force) {
		                force = this._retrieveData;
		            }
		            this._retrieveData = false;
		            List.fn._filterSource.call(this, filter, force);
		        },
	
		        close: function() {
		            this._activeItem = null;
		            this.input.removeAttr("aria-activedescendant");
	
		            this.popup.close();
		        },
	
		        open: function() {
		            var that = this;
	
		            if (that._request) {
		                that._retrieveData = false;
		            }
	
		            if (that._retrieveData || !that.listView.bound() || that._state === ACCEPT) {
		                that._open = true;
		                that._state = REBIND;
	
		                that.listView.skipUpdate(true);
	
		                that.persistTagList = that._initialOpen && !that.listView.bound() ? false : true;
		                that._filterSource();
		                that._focusItem();
		            } else if (that._allowOpening()) {
	
		                //selects values in autoBind false and non virtual scenario on initial load
		                if (that._initialOpen && !that.options.autoBind && !that.options.virtual && that.options.value && !$.isPlainObject(that.options.value[0])){
		                    that.value(that._initialValues);
		                }
	
		                // In some cases when the popup is opened resize is triggered which will cause it to close
		                // Setting the below flag will prevent this from happening
		                that.popup._hovered = true;
		                that._initialOpen = false;
		                that.popup.open();
		                that._focusItem();
		            }
		        },
	
		        toggle: function(toggle) {
		            toggle = toggle !== undefined ? toggle : !this.popup.visible();
	
		            this[toggle ? OPEN : CLOSE]();
		        },
	
		        refresh: function() {
		            this.listView.refresh();
		        },
	
		        _listBound: function() {
		            var that = this;
		            var data = that.dataSource.flatView();
		            var skip = that.listView.skip();
	
		            that._render(data);
	
		            that._renderFooter();
		            that._renderNoData();
		            that._toggleNoData(!data.length);
	
		            that._resizePopup();
	
		            if (that._open) {
		                that._open = false;
		                that.toggle(that._allowOpening());
		            }
	
		            that.popup.position();
	
		            if (that.options.highlightFirst && (skip === undefined || skip === 0)) {
		                that.listView.focusFirst();
		            }
	
		            if (that._touchScroller) {
		                that._touchScroller.reset();
		            }
	
		            that._hideBusy();
		            that._makeUnselectable();
	
		            that.trigger("dataBound");
		        },
	
		        _inputValue: function() {
		            var that = this;
		            var inputValue = that.input.val();
	
		            if (that.options.placeholder === inputValue) {
		                inputValue = "";
		            }
		            return inputValue;
		        },
	
		        value: function(value) {
		            var that = this;
		            var listView = that.listView;
		            var oldValue = listView.value().slice();
		            var maxSelectedItems = that.options.maxSelectedItems;
		            var clearFilters = listView.bound() && listView.isFiltered();
	
		            if (value === undefined) {
		                return oldValue;
		            }
	
		            that.persistTagList = false;
		            that.requireValueMapper(that.options, value);
	
		            value = that._normalizeValues(value);
	
		            if (maxSelectedItems !== null && value.length > maxSelectedItems) {
		                value = value.slice(0, maxSelectedItems);
		            }
	
		            if (clearFilters) {
		                that._clearFilter();
		            }
	
		            listView.value(value);
		            that._old = listView.value(); //get a new array reference
	
		            if (!clearFilters) {
		                that._fetchData();
		            }
		            that._toggleCloseVisibility();
		        },
	
		        _preselect: function(data, value) {
		            var that = this;
	
		            if (!isArray(data) && !(data instanceof kendo.data.ObservableArray)) {
		                data = [data];
		            }
	
		            if ($.isPlainObject(data[0]) || data[0] instanceof kendo.data.ObservableObject || !that.options.dataValueField) {
		                that.dataSource.data(data);
		                that.value(value || that._initialValues);
		                that._retrieveData = true;
		            }
		        },
	
		        _setOption: function(value, selected) {
		            var option = this.element[0].children[this._optionsMap[value]];
	
		            if (option) {
		                option.selected = selected;
		            }
		        },
	
		        _fetchData: function() {
		            var that = this;
		            var hasItems = !!that.dataSource.view().length;
		            var isEmptyArray = that.listView.value().length === 0;
	
		            if (isEmptyArray || that._request) {
		                return;
		            }
	
		            if (that._retrieveData || (!that._fetch && !hasItems)) {
		                that._fetch = true;
		                that._retrieveData = false;
		                that.dataSource.read().done(function() {
		                    that._fetch = false;
		                });
		            }
		        },
	
		        _isBound: function() {
		            return this.listView.bound() && !this._retrieveData;
		        },
	
		        _dataSource: function() {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                dataSource = options.dataSource || {};
	
		            dataSource = isArray(dataSource) ? {data: dataSource} : dataSource;
	
		            dataSource.select = element;
		            dataSource.fields = [{ field: options.dataTextField },
		                                 { field: options.dataValueField }];
	
		            if (that.dataSource && that._refreshHandler) {
		                that._unbindDataSource();
		            } else {
		                that._progressHandler = proxy(that._showBusy, that);
		                that._errorHandler = proxy(that._hideBusy, that);
		            }
	
		            that.dataSource = kendo.data.DataSource.create(dataSource)
		                                   .bind(PROGRESS, that._progressHandler)
		                                   .bind("error", that._errorHandler);
		        },
	
		        _reset: function() {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    setTimeout(function() {
		                        that.value(that._initialValues);
		                        that._placeholder();
		                    });
		                };
	
		                that._form = form.on("reset", that._resetHandler);
		            }
		        },
	
		        _initValue: function() {
		            var value = this.options.value || this.element.val();
	
		            this._old = this._initialValues = this._normalizeValues(value);
		        },
	
		        _normalizeValues: function(value) {
		            var that = this;
	
		            if (value === null) {
		                value = [];
		            } else if (value && $.isPlainObject(value)) {
		                value = [that._value(value)];
		            } else if (value && $.isPlainObject(value[0])) {
		                value = $.map(value, function(dataItem) { return that._value(dataItem); });
		            } else if (!isArray(value) && !(value instanceof ObservableArray)) {
		                value = [value];
		            } else if (isArray(value)) {
		                value = value.slice();
		            }
	
		            return value;
		        },
	
		        _change: function() {
		            var that = this,
		                value = that.value();
	
		            if (!compare(value, that._old)) {
		                that._old = value.slice();
	
		                that.trigger(CHANGE);
	
		                // trigger the DOM change event so any subscriber gets notified
		                that.element.trigger(CHANGE);
		            }
		            that.popup.position();
		            that._toggleCloseVisibility();
		        },
	
		        _click: function(e) {
		            var that = this;
		            var item = e.item;
	
		            e.preventDefault();
	
		            that._select(item).done(function() {
		                that._activeItem = item;
		                that._change();
		                that._close();
		            });
		        },
	
		        _getActiveItem: function() {
		            return this._activeItem || $(this.listView.items()[this._getSelectedIndices().length - 1]) || this.listView.focus();
		        },
	
		        _getSelectedIndices: function() {
		            return this.listView._selectedIndices || this.listView._selectedIndexes;
		        },
	
		        _keydown: function(e) {
		            var that = this;
		            var key = e.keyCode;
		            var tag = that._currentTag;
		            var listView = that.listView;
		            var hasValue = that.input.val();
		            var isRtl = kendo.support.isRtl(that.wrapper);
		            var visible = that.popup.visible();
		            var dir = 0;
		            var activeItemIdx;
		            var persistTagList;
	
		            if(key !== keys.ENTER) {
		                this._multipleSelection = false;
		            }
	
		             if (key === keys.DOWN) {
		                e.preventDefault();
	
		                if (!visible) {
		                    that.open();
	
		                    if (!listView.focus()) {
		                        listView.focusFirst();
		                    }
		                    return;
		                }
	
		                if (listView.focus()) {
		                    if (!that._activeItem && e.shiftKey) {
		                        that._activeItem = listView.focus();
		                        dir = -1;
		                    }
		                    activeItemIdx = listView.getElementIndex(that._getActiveItem().first());
	
		                    listView.focusNext();
		                    if (!listView.focus()) {
		                        listView.focusLast();
		                    } else {
		                        if (e.shiftKey) {
		                            this._multipleSelection = true;
		                            that._selectRange(activeItemIdx, listView.getElementIndex(listView.focus().first()) + dir);
		                        }
		                    }
		                } else {
		                    listView.focusFirst();
		                }
	
		            } else if (key === keys.UP) {
		                if (visible) {
		                    if (!that._activeItem && e.shiftKey) {
		                        that._activeItem = listView.focus();
		                        dir = 1;
		                    }
		                    activeItemIdx = listView.getElementIndex(that._getActiveItem().first());
		                    listView.focusPrev();
		                    if (!listView.focus()) {
		                        that.close();
		                    } else {
		                        if (e.shiftKey) {
		                            this._multipleSelection = true;
		                            that._selectRange(activeItemIdx, listView.getElementIndex(listView.focus().first()) + dir);
		                        }
		                    }
		                }
		                e.preventDefault();
		            } else if ((key === keys.LEFT && !isRtl) || (key === keys.RIGHT && isRtl)) {
		                if (!hasValue) {
		                    tag = tag ? tag.prev() : $(that.tagList[0].lastChild);
		                    if (tag[0]) {
		                        that.currentTag(tag);
		                    }
		                }
		            } else if ((key === keys.RIGHT && !isRtl) || (key === keys.LEFT && isRtl)) {
		                if (!hasValue && tag) {
		                    tag = tag.next();
		                    that.currentTag(tag[0] ? tag : null);
		                }
		            } else if (e.ctrlKey && !e.altKey && key === keys.A && visible && !that.options.virtual) {
		                this._multipleSelection = true;
		                if (this._getSelectedIndices().length === listView.items().length) {
		                    that._activeItem = null;
		                }
	
		                if (listView.items().length) {
		                    that._selectRange(0, listView.items().length -1);
		                }
		            } else if (key === keys.ENTER && visible) {
		                if (!listView.focus()) {
		                    return;
		                }
	
		                e.preventDefault();
	
		                if (this._multipleSelection) {
		                    this._multipleSelection = false;
		                     if (listView.focus().hasClass(SELECTEDCLASS)) {
		                        that._close();
		                        return;
		                    }
		                }
	
		                that._select(listView.focus()).done(function() {
		                    that._change();
		                    that._close();
		                });
		            } else if (key === keys.SPACEBAR && e.ctrlKey && visible) {
		                if (that._activeItem && listView.focus() && listView.focus()[0] === that._activeItem[0]) {
		                    that._activeItem = null;
		                }
		                if (!$(listView.focus()).hasClass(SELECTEDCLASS)) {
		                    that._activeItem = listView.focus();
		                }
		                that._select(listView.focus()).done(function () {
		                    that._change();
		                });
		                e.preventDefault();
		            } else if (key === keys.SPACEBAR && e.shiftKey && visible) {
		                var activeIndex = listView.getElementIndex(that._getActiveItem());
		                var currentIndex = listView.getElementIndex(listView.focus());
	
		                if (activeIndex !== undefined && currentIndex !== undefined) {
		                    that._selectRange(activeIndex, currentIndex);
		                }
	
		                e.preventDefault();
		            } else if (key === keys.ESC) {
		                if (visible) {
		                    e.preventDefault();
		                } else {
		                    that.tagList.children().each(function(index, tag) {
		                        that._removeTag($(tag), false);
		                    });
		                    that._change();
		                }
	
		                that.close();
		            } else if (key === keys.HOME) {
		                if (visible) {
		                    if (!listView.focus()) {
		                        that.close();
		                    } else {
		                        if (e.ctrlKey && e.shiftKey && !that.options.virtual) {
		                            that._selectRange(listView.getElementIndex(listView.focus()[0]), 0);
		                        }
		                        listView.focusFirst();
		                    }
		                } else if (!hasValue) {
		                    tag = that.tagList[0].firstChild;
	
		                    if (tag) {
		                        that.currentTag($(tag));
		                    }
		                }
		            } else if (key === keys.END) {
		                if (visible) {
		                    if (!listView.focus()) {
		                        that.close();
		                    } else {
		                        if (e.ctrlKey && e.shiftKey && !that.options.virtual) {
		                            that._selectRange(
		                                listView.getElementIndex(listView.focus()[0]),
		                                listView.element.children().length - 1
		                            );
		                        }
		                        listView.focusLast();
		                    }
		                } else if (!hasValue) {
		                    tag = that.tagList[0].lastChild;
	
		                    if (tag) {
		                        that.currentTag($(tag));
		                    }
		                }
		            } else if ((key === keys.DELETE || key === keys.BACKSPACE) && !hasValue) {
		                that._state = ACCEPT;
	
		                if (that.options.tagMode === "single") {
		                    persistTagList = that.persistTagList;
	
		                    if (persistTagList) {
		                        that.persistTagList = false;
		                    }
	
		                    listView.value([]);
		                    that._change();
		                    that._close();
	
		                    that.persistTagList = persistTagList;
		                    return;
		                }
	
		                if (key === keys.BACKSPACE && !tag) {
		                    tag = $(that.tagList[0].lastChild);
		                }
	
		                if (tag && tag[0]) {
		                    that._removeTag(tag, true);
		                }
		            } else if (that.popup.visible() && (key === keys.PAGEDOWN || key === keys.PAGEUP)) {
		                e.preventDefault();
	
		                var direction = key === keys.PAGEDOWN ? 1: -1;
		                listView.scrollWith(direction * listView.screenHeight());
		            } else {
		                clearTimeout(that._typingTimeout);
		                setTimeout(function() {
		                    that._scale();
		                });
		                that._search();
		            }
		        },
	
		        _hideBusy: function () {
		            var that = this;
		            clearTimeout(that._busy);
		            that.input.attr("aria-busy", false);
		            that._loading.addClass(HIDDENCLASS);
		            that._request = false;
		            that._busy = null;
	
		            that._toggleCloseVisibility();
		        },
	
		        _showBusyHandler: function() {
		            this.input.attr("aria-busy", true);
		            this._loading.removeClass(HIDDENCLASS);
		            this._hideClear();
		        },
	
		        _showBusy: function () {
		            var that = this;
	
		            that._request = true;
	
		            if (that._busy) {
		                return;
		            }
	
		            that._busy = setTimeout(proxy(that._showBusyHandler, that), 100);
		        },
	
		        _placeholder: function(show, skipCaret) {
		            var that = this;
		            var input = that.input;
		            var active = activeElement();
		            var placeholder = that.options.placeholder;
		            var inputValue = input.val();
		            var isActive = input[0] === active;
		            var caretPos = inputValue.length;
	
		            if (!isActive || that.options.autoClose || inputValue === placeholder) {
		                caretPos = 0;
		                inputValue = "";
		            }
	
		            if (show === undefined) {
		                show = false;
		                if (input[0] !== active) {
		                    show = !that.listView.selectedDataItems()[0];
		                }
		            }
	
		            that._prev = inputValue;
		            input.toggleClass("k-readonly", show).val(show ? placeholder : inputValue);
	
		            if (isActive && !skipCaret) {
		                kendo.caret(input[0], caretPos, caretPos);
		            }
	
		            that._scale();
		        },
	
		        _scale: function() {
		            var that = this,
		                wrapper = that.wrapper.find(".k-multiselect-wrap"),
		                wrapperWidth = wrapper.width(),
		                span = that._span.text(that.input.val()),
		                textWidth;
	
		            if (!wrapper.is(":visible")) {
		                span.appendTo(document.documentElement);
		                wrapperWidth = textWidth = span.width() + 25;
		                span.appendTo(wrapper);
		            } else {
		                textWidth = span.width() + 25;
		            }
	
		            that.input.width(textWidth > wrapperWidth ? wrapperWidth : textWidth);
		        },
	
		        _option: function(dataValue, dataText, selected) {
		            var option = "<option";
	
		            if (dataValue !== undefined) {
		                dataValue += "";
	
		                if (dataValue.indexOf('"') !== -1) {
		                    dataValue = dataValue.replace(quotRegExp, "&quot;");
		                }
	
		                option += ' value="' + dataValue + '"';
		            }
	
		            if (selected) {
		                option += ' selected';
		            }
	
		            option += ">";
	
		            if (dataText !== undefined) {
		                option += kendo.htmlEncode(dataText);
		            }
	
		            return option += "</option>";
		        },
	
		        _render: function(data) {
		            var selectedItems = this.listView.selectedDataItems();
		            var values = this.listView.value();
		            var length = data.length;
		            var selectedIndex;
		            var options = "";
		            var dataItem;
		            var value;
		            var idx;
	
		            if (values.length !== selectedItems.length) {
		                selectedItems = this._buildSelectedItems(values);
		            }
	
		            var custom = {};
		            var optionsMap = {};
	
		            for (idx = 0; idx < length; idx++) {
		                dataItem = data[idx];
		                value = this._value(dataItem);
	
		                selectedIndex = this._selectedItemIndex(value, selectedItems);
		                if (selectedIndex !== -1) {
		                    selectedItems.splice(selectedIndex, 1);
		                }
	
		                optionsMap[value] = idx;
		                options += this._option(value, this._text(dataItem), selectedIndex !== -1);
		            }
	
		            if (selectedItems.length) {
		                for (idx = 0; idx < selectedItems.length; idx++) {
		                    dataItem = selectedItems[idx];
	
		                    value = this._value(dataItem);
		                    custom[value] = length;
		                    optionsMap[value] = length;
	
		                    length += 1;
		                    options += this._option(value, this._text(dataItem), true);
		                }
		            }
	
		            this._customOptions = custom;
		            this._optionsMap = optionsMap;
	
		            this.element.html(options);
		        },
	
		        _buildSelectedItems: function(values) {
		            var valueField = this.options.dataValueField;
		            var textField = this.options.dataTextField;
		            var result = [];
		            var item;
	
		            for (var idx = 0; idx < values.length; idx++) {
		                item = {};
		                item[valueField] = values[idx];
		                item[textField] = values[idx];
	
		                result.push(item);
		            }
	
		            return result;
		        },
	
		        _selectedItemIndex: function(value, selectedItems) {
		            var valueGetter = this._value;
		            var idx = 0;
	
		            for (; idx < selectedItems.length; idx++) {
		                if (value === valueGetter(selectedItems[idx])) {
		                    return idx;
		                }
		            }
	
		            return -1;
		        },
	
		        _search: function() {
		            var that = this;
	
		            clearTimeout(that._typingTimeout);
	
		            that._typingTimeout = setTimeout(function() {
		                var value = that._inputValue();
		                if (that._prev !== value) {
		                    that._prev = value;
		                    that.search(value);
		                    that._toggleCloseVisibility();
		                }
		            }, that.options.delay);
		        },
	
		        _toggleCloseVisibility: function() {
		            if (this.value().length || (this.input.val() && this.input.val() !== this.options.placeholder)) {
		                this._showClear();
		            } else {
		                this._hideClear();
		            }
		        },
	
		        _allowOpening: function() {
		            return this._allowSelection() && List.fn._allowOpening.call(this);
		        },
	
		        _allowSelection: function() {
		            var max = this.options.maxSelectedItems;
		            return max === null || max > this.listView.value().length;
		        },
	
		        _angularTagItems: function(cmd) {
		            var that = this;
	
		            that.angular(cmd, function() {
		                return {
		                    elements: that.tagList[0].children,
		                    data: $.map(that.dataItems(), function(dataItem) {
		                        return { dataItem: dataItem };
		                    })
		                };
		            });
		        },
	
		        updatePersistTagList: function(added, removed){
		            if(this.persistTagList.added &&
		                this.persistTagList.added.length === removed.length &&
		                this.persistTagList.removed &&
		                this.persistTagList.removed.length === added.length){
		                    this.persistTagList = false;
		             }else{
		                 this.listView._removedAddedIndexes = this._old.slice();
		                 this.persistTagList = {
		                     added: added,
		                     removed: removed
		                 };
		             }
		        },
	
		        _selectValue: function (added, removed) {
		            var that = this;
		            var values = that.value();
		            var total = that.dataSource.total();
		            var tagList = that.tagList;
		            var getter = that._value;
		            var removedItem;
		            var addedItem;
		            var idx;
	
		            if(this.persistTagList){
		                this.updatePersistTagList(added, removed);
	
		                return;
		            }
	
		            that._angularTagItems("cleanup");
	
		            if (that.options.tagMode === "multiple") {
		                for (idx = removed.length - 1; idx > -1; idx--) {
		                    removedItem = removed[idx];
	
		                    if (tagList.children().length) {
		                        tagList[0].removeChild(tagList[0].children[removedItem.position]);
		                        that._setOption(getter(removedItem.dataItem), false);
		                    }
		                }
	
		                for (idx = 0; idx < added.length; idx++) {
		                    addedItem = added[idx];
	
		                    tagList.append(that.tagTemplate(addedItem.dataItem));
	
		                    that._setOption(getter(addedItem.dataItem), true);
		                }
		            } else {
		                if (!that._maxTotal || that._maxTotal < total) {
		                    that._maxTotal = total;
		                }
	
		                tagList.html("");
	
		                if (values.length) {
		                    tagList.append(that.tagTemplate({
		                        values: values,
		                        dataItems: that.dataItems(),
		                        maxTotal: that._maxTotal,
		                        currentTotal: total
		                    }));
		                }
	
		                for (idx = removed.length - 1; idx > -1; idx--) {
		                    that._setOption(getter(removed[idx].dataItem), false);
		                }
	
		                for (idx = 0; idx < added.length; idx++) {
		                    that._setOption(getter(added[idx].dataItem), true);
		                }
		            }
	
		            that._angularTagItems("compile");
		            that._placeholder();
		        },
	
		        _select: function(candidate) {
		            var resolved = $.Deferred().resolve();
	
		            if (!candidate) {
		                return resolved;
		            }
	
		            var that = this;
		            var listView = that.listView;
		            var dataItem = listView.dataItemByIndex(listView.getElementIndex(candidate));
		            var isSelected = candidate.hasClass("k-state-selected");
	
		            if (that._state === REBIND) {
		                that._state = "";
		            }
	
		            if (!that._allowSelection() && !isSelected) {
		                return resolved;
		            }
	
		            if (that.trigger(isSelected ? DESELECT : SELECT, { dataItem: dataItem, item: candidate })) {
		                that._close();
		                return resolved;
		            }
	
		            that.persistTagList = false;
		            return listView.select(candidate).done(function() {
		                that._placeholder();
	
		                if (that._state === FILTER) {
		                    that._state = ACCEPT;
		                    listView.skipUpdate(true);
		                }
		            });
		        },
	
		        _selectRange: function (startIndex, endIndex) {
		            var that = this;
		            var listView = this.listView;
		            var maxSelectedItems = this.options.maxSelectedItems;
		            var indices = this._getSelectedIndices().slice();
		            var indicesToSelect = [];
		            var i;
	
		            var selectIndices = function(indices) {
		                listView.select(indices).done(function() {
		                    indices.forEach(function(index) {
		                        var dataItem  = listView.dataItemByIndex(index);
		                        var candidate = listView.element.children()[index];
		                        var isSelected = $(candidate).hasClass("k-state-selected");
	
		                        that.trigger(isSelected ? SELECT : DESELECT, {dataItem: dataItem, item: $(candidate)});
		                    });
		                    that._change();
		                });
		            };
	
		            if (indices.length - 1 === endIndex - startIndex) {
		                return selectIndices(indices);
		            }
	
		            if (startIndex < endIndex) {
		                for (i = startIndex; i <= endIndex; i++) {
		                    indicesToSelect.push(i);
		                }
		            } else {
		                for (i = startIndex; i >= endIndex; i--) {
		                    indicesToSelect.push(i);
		                }
		            }
	
		            if (maxSelectedItems !== null && indicesToSelect.length > maxSelectedItems) {
		                indicesToSelect = indicesToSelect.slice(0, maxSelectedItems);
		            }
	
		            for (i = 0; i < indicesToSelect.length; i++) {
		                var index = indicesToSelect[i];
	
		                if (this._getSelectedIndices().indexOf(index) == -1) {
		                    indices.push(index);
		                } else {
		                    indices.splice(indices.indexOf(index), 1);
		                }
		            }
	
		            if (!indices.length) {
		                return;
		            }
	
		            that.persistTagList = false;
		            return selectIndices(indices);
		        },
	
		        _input: function() {
		            var that = this;
		            var element = that.element;
		            var accessKey = element[0].accessKey;
		            var input = that._innerWrapper.children("input.k-input");
	
		            if (!input[0]) {
		                input = $('<input class="k-input" style="width: 25px" />').appendTo(that._innerWrapper);
		            }
	
		            element.removeAttr("accesskey");
	
		            that._focused = that.input = input.attr({
		                "accesskey": accessKey,
		                "autocomplete": "off",
		                "role": "listbox",
		                "title": element[0].title,
		                "aria-expanded": false
		            });
		        },
	
		        _tagList: function() {
		            var that = this,
		                tagList = that._innerWrapper.children("ul");
	
		            if (!tagList[0]) {
		                tagList = $('<ul role="listbox" unselectable="on" class="k-reset"/>').appendTo(that._innerWrapper);
		            }
	
		            that.tagList = tagList;
		        },
	
		        _tagTemplate: function() {
		            var that = this;
		            var options = that.options;
		            var tagTemplate = options.tagTemplate;
		            var hasDataSource = options.dataSource;
		            var isMultiple = options.tagMode === "multiple";
		            var defaultTemplate;
	
		            if (that.element[0].length && !hasDataSource) {
		                options.dataTextField = options.dataTextField || "text";
		                options.dataValueField = options.dataValueField || "value";
		            }
	
		            defaultTemplate = isMultiple ? kendo.template("#:" + kendo.expr(options.dataTextField, "data") + "#", { useWithBlock: false }) : kendo.template("#:values.length# item(s) selected");
	
		            that.tagTextTemplate = tagTemplate = tagTemplate ? kendo.template(tagTemplate) : defaultTemplate;
	
		            that.tagTemplate = function(data) {
		                return '<li class="k-button" unselectable="on"><span unselectable="on">' +
		                        tagTemplate(data) +
		                        '</span><span unselectable="on" aria-label="' +
		                        (isMultiple ? "delete" : "open") +
		                        '" class="k-select"><span class="k-icon ' +
		                        (isMultiple ? "k-i-close" : "k-i-arrow-60-down") + '">' +
		                        '</span></span></li>';
		            };
		        },
	
		        _loader: function() {
		            this._loading = $('<span class="k-icon k-i-loading ' + HIDDENCLASS + '"></span>').insertAfter(this.input);
		        },
	
		        _clearButton: function() {
		            List.fn._clearButton.call(this);
	
		            if (this.options.clearButton) {
		                this._clear.insertAfter(this.input);
		                this.wrapper.addClass("k-multiselect-clearable");
		            }
		        },
	
		        _textContainer: function() {
		            var computedStyles = kendo.getComputedStyles(this.input[0], styles);
	
		            computedStyles.position = "absolute";
		            computedStyles.visibility = "hidden";
		            computedStyles.top = -3333;
		            computedStyles.left = -3333;
	
		            this._span = $("<span/>").css(computedStyles).appendTo(this.wrapper);
		        },
	
		        _wrapper: function() {
		            var that = this,
		                element = that.element,
		                wrapper = element.parent("span.k-multiselect");
	
		            if (!wrapper[0]) {
		                wrapper = element.wrap('<div class="k-widget k-multiselect" unselectable="on" />').parent();
		                wrapper[0].style.cssText = element[0].style.cssText;
		                wrapper[0].title = element[0].title;
	
		                $('<div class="k-multiselect-wrap k-floatwrap" unselectable="on" />').insertBefore(element);
		            }
	
		            that.wrapper = wrapper.addClass(element[0].className).css("display", "");
		            that._innerWrapper = $(wrapper[0].firstChild);
		        }
		    });
	
		    function compare(a, b) {
		        var length;
	
		        if ((a === null && b !== null) || (a !== null && b === null)) {
		            return false;
		        }
	
		        length = a.length;
		        if (length !== b.length) {
		            return false;
		        }
	
		        while (length--) {
		            if (a[length] !== b[length]) {
		                return false;
		            }
		        }
	
		        return true;
		    }
	
		    ui.plugin(MultiSelect);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1351);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1351:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "validator",
		    name: "Validator",
		    category: "web",
		    description: "The Validator offers an easy way to do a client-side form validation.",
		    depends: [ "core" ]
		};
	
		/* jshint eqnull: true */
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        NS = ".kendoValidator",
		        INVALIDMSG = "k-invalid-msg",
		        invalidMsgRegExp = new RegExp(INVALIDMSG,'i'),
		        INVALIDINPUT = "k-invalid",
		        VALIDINPUT = "k-valid",
		        emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i,
		        urlRegExp = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
		        INPUTSELECTOR = ":input:not(:button,[type=submit],[type=reset],[disabled],[readonly])",
		        CHECKBOXSELECTOR = ":checkbox:not([disabled],[readonly])",
		        NUMBERINPUTSELECTOR = "[type=number],[type=range]",
		        BLUR = "blur",
		        NAME = "name",
		        FORM = "form",
		        NOVALIDATE = "novalidate",
		        //events
		        VALIDATE = "validate",
		        CHANGE = "change",
		        VALIDATE_INPUT = "validateInput",
		        proxy = $.proxy,
		        patternMatcher = function(value, pattern) {
		            if (typeof pattern === "string") {
		                pattern = new RegExp('^(?:' + pattern + ')$');
		            }
		            return pattern.test(value);
		        },
		        matcher = function(input, selector, pattern) {
		            var value = input.val();
	
		            if (input.filter(selector).length && value !== "") {
		                return patternMatcher(value, pattern);
		            }
		            return true;
		        },
		        hasAttribute = function(input, name) {
		            if (input.length)  {
		                return input[0].attributes[name] != null;
		            }
		            return false;
		        };
	
		    if (!kendo.ui.validator) {
		        kendo.ui.validator = { rules: {}, messages: {} };
		    }
	
		    function resolveRules(element) {
		        var resolvers = kendo.ui.validator.ruleResolvers || {},
		            rules = {},
		            name;
	
		        for (name in resolvers) {
		            $.extend(true, rules, resolvers[name].resolve(element));
		        }
		        return rules;
		    }
	
		    function decode(value) {
		        return value.replace(/&amp/g, '&amp;')
		            .replace(/&quot;/g, '"')
		            .replace(/&#39;/g, "'")
		            .replace(/&lt;/g, '<')
		            .replace(/&gt;/g, '>');
		    }
	
		    function numberOfDecimalDigits(value) {
		        value = (value + "").split('.');
		        if (value.length > 1) {
		            return value[1].length;
		        }
		        return 0;
		    }
	
		    function parseHtml(text) {
		        if ($.parseHTML) {
		            return $($.parseHTML(text));
		        }
		        return $(text);
		    }
	
		    function searchForMessageContainer(elements, fieldName) {
		        var containers = $(),
		            element,
		            attr;
	
		        for (var idx = 0, length = elements.length; idx < length; idx++) {
		            element = elements[idx];
		            if (invalidMsgRegExp.test(element.className)) {
		                attr = element.getAttribute(kendo.attr("for"));
		                if (attr === fieldName) {
		                    containers = containers.add(element);
		                }
		            }
		        }
		        return containers;
		    }
	
		    var Validator = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                resolved = resolveRules(element),
		                validateAttributeSelector = "[" + kendo.attr("validate") + "!=false]";
	
		            options = options || {};
	
		            options.rules = $.extend({}, kendo.ui.validator.rules, resolved.rules, options.rules);
		            options.messages = $.extend({}, kendo.ui.validator.messages, resolved.messages, options.messages);
	
		            Widget.fn.init.call(that, element, options);
	
		            that._errorTemplate = kendo.template(that.options.errorTemplate);
	
		            if (that.element.is(FORM)) {
		                that.element.attr(NOVALIDATE, NOVALIDATE);
		            }
	
		            that._inputSelector = INPUTSELECTOR + validateAttributeSelector;
		            that._checkboxSelector = CHECKBOXSELECTOR + validateAttributeSelector;
	
		            that._errors = {};
		            that._attachEvents();
		            that._isValidated = false;
		        },
	
		        events: [ VALIDATE, CHANGE, VALIDATE_INPUT ],
	
		        options: {
		            name: "Validator",
		            errorTemplate: '<span class="k-widget k-tooltip k-tooltip-validation">' +
		                '<span class="k-icon k-i-warning"> </span> #=message#</span>',
		            messages: {
		                required: "{0} is required",
		                pattern: "{0} is not valid",
		                min: "{0} should be greater than or equal to {1}",
		                max: "{0} should be smaller than or equal to {1}",
		                step: "{0} is not valid",
		                email: "{0} is not valid email",
		                url: "{0} is not valid URL",
		                date: "{0} is not valid date",
		                dateCompare: "End date should be greater than or equal to the start date"
		            },
		            rules: {
		                required: function(input) {
		                    var checkbox = input.filter("[type=checkbox]").length && !input.is(":checked"),
		                        value = input.val();
	
		                    return !(hasAttribute(input, "required") && (!value || value === "" || value.length === 0 || checkbox));
		                },
		                pattern: function(input) {
		                    if (input.filter("[type=text],[type=email],[type=url],[type=tel],[type=search],[type=password]").filter("[pattern]").length && input.val() !== "") {
		                        return patternMatcher(input.val(), input.attr("pattern"));
		                    }
		                    return true;
		                },
		                min: function(input) {
		                    if (input.filter(NUMBERINPUTSELECTOR + ",[" + kendo.attr("type") + "=number]").filter("[min]").length && input.val() !== "") {
		                        var min = parseFloat(input.attr("min")) || 0,
		                            val = kendo.parseFloat(input.val());
	
		                        return min <= val;
		                    }
		                    return true;
		                },
		                max: function(input) {
		                    if (input.filter(NUMBERINPUTSELECTOR + ",[" + kendo.attr("type") + "=number]").filter("[max]").length && input.val() !== "") {
		                        var max = parseFloat(input.attr("max")) || 0,
		                            val = kendo.parseFloat(input.val());
	
		                        return max >= val;
		                    }
		                    return true;
		                },
		                step: function(input) {
		                    if (input.filter(NUMBERINPUTSELECTOR + ",[" + kendo.attr("type") + "=number]").filter("[step]").length && input.val() !== "") {
		                        var min = parseFloat(input.attr("min")) || 0,
		                            step = parseFloat(input.attr("step")) || 1,
		                            val = parseFloat(input.val()),
		                            decimals = numberOfDecimalDigits(step),
		                            raise;
	
		                        if (decimals) {
		                            raise = Math.pow(10, decimals);
		                            return ((Math.floor((val-min)*raise))%(step*raise)) / Math.pow(100, decimals) === 0;
		                        }
		                        return ((val-min)%step) === 0;
		                    }
		                    return true;
		                },
		                email: function(input) {
		                    return matcher(input, "[type=email],[" + kendo.attr("type") + "=email]", emailRegExp);
		                },
		                url: function(input) {
		                    return matcher(input, "[type=url],[" + kendo.attr("type") + "=url]", urlRegExp);
		                },
		                date: function(input) {
		                    if (input.filter("[type^=date],[" + kendo.attr("type") + "=date]").length && input.val() !== "") {
		                        return kendo.parseDate(input.val(), input.attr(kendo.attr("format"))) !== null;
		                    }
		                    return true;
		                }
		            },
		            validateOnBlur: true
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this.element.off(NS);
		        },
	
		        value: function() {
		            if (!this._isValidated) {
		                return false;
		            }
	
		            return this.errors().length === 0;
		        },
	
		        _submit: function(e) {
		            if (!this.validate()) {
		                e.stopPropagation();
		                e.stopImmediatePropagation();
		                e.preventDefault();
		                return false;
		            }
		            return true;
		        },
	
		        _checkElement: function(element) {
		            var state = this.value();
	
		            this.validateInput(element);
	
		            if (this.value() !== state) {
		                this.trigger(CHANGE);
		            }
		        },
	
		        _attachEvents: function() {
		            var that = this;
	
		            if (that.element.is(FORM)) {
		                that.element.on("submit" + NS, proxy(that._submit, that));
		            }
	
		            if (that.options.validateOnBlur) {
		                if (!that.element.is(INPUTSELECTOR)) {
		                    that.element.on(BLUR + NS, that._inputSelector, function() {
		                        that._checkElement($(this));
		                    });
	
		                    that.element.on("click" + NS, that._checkboxSelector, function() {
		                        that._checkElement($(this));
		                    });
		                } else {
		                    that.element.on(BLUR + NS, function() {
		                        that._checkElement(that.element);
		                    });
	
		                    if (that.element.is(CHECKBOXSELECTOR)) {
		                        that.element.on("click" + NS, function() {
		                            that._checkElement(that.element);
		                        });
		                    }
		                }
		            }
		        },
	
		        validate: function() {
		            var inputs;
		            var idx;
		            var result = false;
		            var length;
	
		            var isValid = this.value();
	
		            this._errors = {};
	
		            if (!this.element.is(INPUTSELECTOR)) {
		                var invalid = false;
	
		                inputs = this.element.find(this._inputSelector);
	
		                for (idx = 0, length = inputs.length; idx < length; idx++) {
		                    if (!this.validateInput(inputs.eq(idx))) {
		                        invalid = true;
		                    }
		                }
	
		                result = !invalid;
		            } else {
		                result = this.validateInput(this.element);
		            }
	
		            this.trigger(VALIDATE, { valid: result });
	
		            if (isValid !== result) {
		                this.trigger(CHANGE);
		            }
	
		            return result;
		        },
	
		        validateInput: function(input) {
		            input = $(input);
	
		            this._isValidated = true;
	
		            var that = this,
		                template = that._errorTemplate,
		                result = that._checkValidity(input),
		                valid = result.valid,
		                className = "." + INVALIDMSG,
		                fieldName = (input.attr(NAME) || ""),
		                lbl = that._findMessageContainer(fieldName).add(input.next(className).filter(function() {
		                    var element = $(this);
		                    if (element.filter("[" + kendo.attr("for") + "]").length) {
		                        return element.attr(kendo.attr("for")) === fieldName;
		                    }
	
		                    return true;
	
		                })).hide(),
		                messageText,
		                wasValid = !input.attr("aria-invalid");
		            input.removeAttr("aria-invalid");
	
		            if (!valid) {
		                messageText = that._extractMessage(input, result.key);
		                that._errors[fieldName] = messageText;
		                var messageLabel = parseHtml(template({ message: decode(messageText) }));
		                var lblId = lbl.attr('id');
	
		                that._decorateMessageContainer(messageLabel, fieldName);
	
		                if (lblId) {
		                    messageLabel.attr('id', lblId);
		                }
	
		                if (!lbl.replaceWith(messageLabel).length) {
		                    messageLabel.insertAfter(input);
		                }
		                messageLabel.show();
	
		                input.attr("aria-invalid", true);
		            } else {
		                delete that._errors[fieldName];
		            }
	
		            if (wasValid !== valid) {
		                this.trigger(VALIDATE_INPUT, { valid: valid, input: input });
		            }
	
		            input.toggleClass(INVALIDINPUT, !valid);
		            input.toggleClass(VALIDINPUT, valid);
	
		            return valid;
		        },
	
		        hideMessages: function() {
		            var that = this,
		                className = "." + INVALIDMSG,
		                element = that.element;
	
		            if (!element.is(INPUTSELECTOR)) {
		                element.find(className).hide();
		            } else {
		                element.next(className).hide();
		            }
		        },
	
		        _findMessageContainer: function(fieldName) {
		            var locators = kendo.ui.validator.messageLocators,
		                name,
		                containers = $();
	
		            for (var idx = 0, length = this.element.length; idx < length; idx++) {
		                containers = containers.add(searchForMessageContainer(this.element[idx].getElementsByTagName("*"), fieldName));
		            }
	
		            for (name in locators) {
		                containers = containers.add(locators[name].locate(this.element, fieldName));
		            }
	
		            return containers;
		        },
	
		        _decorateMessageContainer: function(container, fieldName) {
		            var locators = kendo.ui.validator.messageLocators,
		                name;
	
		            container.addClass(INVALIDMSG)
		                .attr(kendo.attr("for"), fieldName || "");
	
		            for (name in locators) {
		                locators[name].decorate(container, fieldName);
		            }
	
		            container.attr("role", "alert");
		        },
	
		        _extractMessage: function(input, ruleKey) {
		            var that = this,
		                customMessage = that.options.messages[ruleKey],
		                fieldName = input.attr(NAME),
		                nonDefaultMessage;
	
		            if (!kendo.ui.Validator.prototype.options.messages[ruleKey]) {
		                 nonDefaultMessage = kendo.isFunction(customMessage) ? customMessage(input) : customMessage;
		            }
	
		            customMessage = kendo.isFunction(customMessage) ? customMessage(input) : customMessage;
	
		            return kendo.format(input.attr(kendo.attr(ruleKey + "-msg")) || input.attr("validationMessage") || nonDefaultMessage || input.attr("title") || customMessage || "",
		                fieldName,
		                input.attr(ruleKey) || input.attr(kendo.attr(ruleKey)));
		        },
	
		        _checkValidity: function(input) {
		            var rules = this.options.rules,
		                rule;
	
		            for (rule in rules) {
		                if (!rules[rule].call(this, input)) {
		                    return { valid: false, key: rule };
		                }
		            }
	
		            return { valid: true };
		        },
	
		        errors: function() {
		            var results = [],
		                errors = this._errors,
		                error;
	
		            for (error in errors) {
		                results.push(errors[error]);
		            }
		            return results;
		        }
		    });
	
		    kendo.ui.plugin(Validator);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1288);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1288:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1038) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "selectable",
		    name: "Selectable",
		    category: "framework",
		    depends: [ "core", "userevents" ],
		    advanced: true
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        proxy = $.proxy,
		        abs = Math.abs,
		        ARIASELECTED = "aria-selected",
		        SELECTED = "k-state-selected",
		        ACTIVE = "k-state-selecting",
		        SELECTABLE = "k-selectable",
		        CHANGE = "change",
		        NS = ".kendoSelectable",
		        UNSELECTING = "k-state-unselecting",
		        INPUTSELECTOR = "input,a,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",
		        msie = kendo.support.browser.msie,
		        supportEventDelegation = false;
	
		        (function($) {
		            (function() {
		                $('<div class="parent"><span /></div>')
		                .on("click", ">*", function() {
		                    supportEventDelegation = true;
		                })
		                .find("span")
		                .click()
		                .end()
		                .off();
		            })();
		        })($);
	
		    var Selectable = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                multiple;
	
		            Widget.fn.init.call(that, element, options);
	
		            that._marquee = $("<div class='k-marquee'><div class='k-marquee-color'></div></div>");
		            that._lastActive = null;
		            that.element.addClass(SELECTABLE);
	
		            that.relatedTarget = that.options.relatedTarget;
	
		            multiple = that.options.multiple;
	
		            if (this.options.aria && multiple) {
		                that.element.attr("aria-multiselectable", true);
		            }
	
		            that.userEvents = new kendo.UserEvents(that.element, {
		                global: true,
		                allowSelection: true,
		                filter: (!supportEventDelegation ? "." + SELECTABLE + " " : "") + that.options.filter,
		                tap: proxy(that._tap, that),
		                touchAction: multiple ? "none" : "pan-x pan-y"
		            });
	
		            if (multiple) {
		                that.userEvents
		                   .bind("start", proxy(that._start, that))
		                   .bind("move", proxy(that._move, that))
		                   .bind("end", proxy(that._end, that))
		                   .bind("select", proxy(that._select, that));
		            }
		        },
	
		        events: [CHANGE],
	
		        options: {
		            name: "Selectable",
		            filter: ">*",
		            inputSelectors: INPUTSELECTOR,
		            multiple: false,
		            relatedTarget: $.noop
		        },
	
		        _isElement: function(target) {
		            var elements = this.element;
		            var idx, length = elements.length, result = false;
	
		            target = target[0];
	
		            for (idx = 0; idx < length; idx ++) {
		                if (elements[idx] === target) {
		                    result = true;
		                    break;
		                }
		            }
	
		            return result;
		        },
	
		        _tap: function(e) {
		            var target = $(e.target),
		                that = this,
		                ctrlKey = e.event.ctrlKey || e.event.metaKey,
		                multiple = that.options.multiple,
		                shiftKey = multiple && e.event.shiftKey,
		                selected,
		                whichCode = e.event.which,
		                buttonCode = e.event.button;
	
		            //in case of hierarchy or right-click
		            if (!that._isElement(target.closest("." + SELECTABLE)) || whichCode && whichCode == 3 || buttonCode && buttonCode == 2) {
		                return;
		            }
	
		            if (!this._allowSelection(e.event.target)) {
		                return;
		            }
	
		            selected = target.hasClass(SELECTED);
		            if (!multiple || !ctrlKey) {
		                that.clear();
		            }
	
		            target = target.add(that.relatedTarget(target));
	
		            if (shiftKey) {
		                that.selectRange(that._firstSelectee(), target, e);
		            } else {
		                if (selected && ctrlKey) {
		                    that._unselect(target);
		                    that._notify(CHANGE, e);
		                } else {
		                    that.value(target, e);
		                }
	
		                that._lastActive = that._downTarget = target;
		            }
		        },
	
		        _start: function(e) {
		            var that = this,
		                target = $(e.target),
		                selected = target.hasClass(SELECTED),
		                currentElement,
		                ctrlKey = e.event.ctrlKey || e.event.metaKey;
	
		            if (!this._allowSelection(e.event.target)) {
		                return;
		            }
	
		            that._downTarget = target;
	
		            //in case of hierarchy
		            if (!that._isElement(target.closest("." + SELECTABLE))) {
		                that.userEvents.cancel();
		                return;
		            }
	
		            if (that.options.useAllItems) {
		                that._items = that.element.find(that.options.filter);
		            } else {
		                currentElement = target.closest(that.element);
		                that._items = currentElement.find(that.options.filter);
		            }
	
		            e.sender.capture();
	
		            that._marquee
		                .appendTo(document.body)
		                .css({
		                    left: e.x.client + 1,
		                    top: e.y.client + 1,
		                    width: 0,
		                    height: 0
		                });
	
		            if (!ctrlKey) {
		                that.clear();
		            }
	
		            target = target.add(that.relatedTarget(target));
		            if (selected) {
		                that._selectElement(target, true);
		                if (ctrlKey) {
		                    target.addClass(UNSELECTING);
		                }
		            }
		        },
	
		        _move: function(e) {
		            var that = this,
		                position = {
		                    left: e.x.startLocation > e.x.location ? e.x.location : e.x.startLocation,
		                    top: e.y.startLocation > e.y.location ? e.y.location : e.y.startLocation,
		                    width: abs(e.x.initialDelta),
		                    height: abs(e.y.initialDelta)
		                };
	
		            that._marquee.css(position);
	
		            that._invalidateSelectables(position, (e.event.ctrlKey || e.event.metaKey));
	
		            e.preventDefault();
		        },
	
		        _end: function(e) {
		            var that = this;
	
		            that._marquee.remove();
	
		            that._unselect(that.element
		                .find(that.options.filter + "." + UNSELECTING))
		                .removeClass(UNSELECTING);
	
	
		            var target = that.element.find(that.options.filter + "." + ACTIVE);
		            target = target.add(that.relatedTarget(target));
	
		            that.value(target, e);
		            that._lastActive = that._downTarget;
		            that._items = null;
		        },
	
		        _invalidateSelectables: function(position, ctrlKey) {
		            var idx,
		                length,
		                target = this._downTarget[0],
		                items = this._items,
		                related,
		                toSelect;
	
		            for (idx = 0, length = items.length; idx < length; idx ++) {
		                toSelect = items.eq(idx);
		                related = toSelect.add(this.relatedTarget(toSelect));
	
		                if (collision(toSelect, position)) {
		                    if(toSelect.hasClass(SELECTED)) {
		                        if(ctrlKey && target !== toSelect[0]) {
		                            related.removeClass(SELECTED).addClass(UNSELECTING);
		                        }
		                    } else if (!toSelect.hasClass(ACTIVE) && !toSelect.hasClass(UNSELECTING)) {
		                        related.addClass(ACTIVE);
		                    }
		                } else {
		                    if (toSelect.hasClass(ACTIVE)) {
		                        related.removeClass(ACTIVE);
		                    } else if(ctrlKey && toSelect.hasClass(UNSELECTING)) {
		                        related.removeClass(UNSELECTING).addClass(SELECTED);
		                    }
		                }
		            }
		        },
	
		        value: function(val, e) {
		            var that = this,
		                selectElement = proxy(that._selectElement, that);
	
		            if(val) {
		                val.each(function() {
		                    selectElement(this);
		                });
	
		                that._notify(CHANGE, e);
		                return;
		            }
	
		            return that.element.find(that.options.filter + "." + SELECTED);
		        },
	
		        _firstSelectee: function() {
		            var that = this,
		                selected;
	
		            if(that._lastActive !== null) {
		                return that._lastActive;
		            }
	
		            selected = that.value();
		            return selected.length > 0 ?
		                    selected[0] :
		                    that.element.find(that.options.filter)[0];
		        },
	
		        _selectElement: function(element, preventNotify) {
		            var toSelect = $(element),
		                isPrevented =  !preventNotify && this._notify("select", { element: element });
	
		            toSelect.removeClass(ACTIVE);
		            if(!isPrevented) {
		                 toSelect.addClass(SELECTED);
	
		                if (this.options.aria) {
		                    toSelect.attr(ARIASELECTED, true);
		                }
		            }
		        },
	
		        _notify: function(name, args) {
		            args = args || { };
		            return this.trigger(name, args);
		        },
	
		        _unselect: function(element) {
		            element.removeClass(SELECTED);
	
		            if (this.options.aria) {
		                element.attr(ARIASELECTED, false);
		            }
	
		            return element;
		        },
	
		        _select: function(e) {
		            if (this._allowSelection(e.event.target)) {
		                if (!msie || (msie && !$(kendo._activeElement()).is(this.options.inputSelectors))) {
		                    e.preventDefault();
		                }
		            }
		        },
	
		        _allowSelection: function(target) {
		            if ($(target).is(this.options.inputSelectors)) {
		                this.userEvents.cancel();
		                this._downTarget = null;
		                return false;
		            }
	
		            return true;
		        },
	
		        resetTouchEvents: function() {
		            this.userEvents.cancel();
		        },
	
		        clear: function() {
		            var items = this.element.find(this.options.filter + "." + SELECTED);
		            this._unselect(items);
		        },
	
		        selectRange: function(start, end, e) {
		            var that = this,
		                idx,
		                tmp,
		                items;
	
		            that.clear();
	
		            if (that.element.length > 1) {
		                items = that.options.continuousItems();
		            }
	
		            if (!items || !items.length) {
		                items = that.element.find(that.options.filter);
		            }
	
		            start = $.inArray($(start)[0], items);
		            end = $.inArray($(end)[0], items);
	
		            if (start > end) {
		                tmp = start;
		                start = end;
		                end = tmp;
		            }
	
		            if (!that.options.useAllItems) {
		                end += that.element.length - 1;
		            }
	
		            for (idx = start; idx <= end; idx ++ ) {
		                that._selectElement(items[idx]);
		            }
	
		            that._notify(CHANGE, e);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.element.off(NS);
	
		            that.userEvents.destroy();
	
		            that._marquee = that._lastActive = that.element = that.userEvents = null;
		        }
		    });
	
		    Selectable.parseOptions = function(selectable) {
		        var asLowerString = typeof selectable === "string" && selectable.toLowerCase();
	
		        return {
		            multiple: asLowerString && asLowerString.indexOf("multiple") > -1,
		            cell: asLowerString && asLowerString.indexOf("cell") > -1
		        };
		    };
	
		    function collision(element, position) {
		        if (!element.is(":visible")) {
		            return false;
		        }
	
		        var elementPosition = kendo.getOffset(element),
		            right = position.left + position.width,
		            bottom = position.top + position.height;
	
		        elementPosition.right = elementPosition.left + kendo._outerWidth(element);
		        elementPosition.bottom = elementPosition.top + kendo._outerHeight(element);
	
		        return !(elementPosition.left > right||
		            elementPosition.right < position.left ||
		            elementPosition.top > bottom ||
		            elementPosition.bottom < position.top);
		    }
	
		    kendo.ui.plugin(Selectable);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1289);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1289:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "slider",
		    name: "Slider",
		    category: "web",
		    description: "The Slider widget provides a rich input for selecting values or ranges of values.",
		    depends: [ "draganddrop" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        Draggable = kendo.ui.Draggable,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        extend = $.extend,
		        format = kendo.format,
		        parse = kendo.parseFloat,
		        proxy = $.proxy,
		        isArray = $.isArray,
		        math = Math,
		        support = kendo.support,
		        pointers = support.pointers,
		        msPointers = support.msPointers,
		        CHANGE = "change",
		        SLIDE = "slide",
		        NS = ".slider",
		        MOUSE_DOWN = "touchstart" + NS + " mousedown" + NS,
		        TRACK_MOUSE_DOWN = pointers ? "pointerdown" + NS : (msPointers ? "MSPointerDown" + NS : MOUSE_DOWN),
		        MOUSE_UP = "touchend" + NS + " mouseup" + NS,
		        TRACK_MOUSE_UP = pointers ? "pointerup" : (msPointers ? "MSPointerUp" + NS : MOUSE_UP),
		        MOVE_SELECTION = "moveSelection",
		        KEY_DOWN = "keydown" + NS,
		        CLICK = "click" + NS,
		        MOUSE_OVER = "mouseover" + NS,
		        FOCUS = "focus" + NS,
		        BLUR = "blur" + NS,
		        DRAG_HANDLE = ".k-draghandle",
		        TRACK_SELECTOR = ".k-slider-track",
		        TICK_SELECTOR = ".k-tick",
		        STATE_SELECTED = "k-state-selected",
		        STATE_FOCUSED = "k-state-focused",
		        STATE_DEFAULT = "k-state-default",
		        STATE_DISABLED = "k-state-disabled",
		        DISABLED = "disabled",
		        UNDEFINED = "undefined",
		        TABINDEX = "tabindex",
		        getTouches = kendo.getTouches;
	
		    var SliderBase = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
		            that._isHorizontal = options.orientation == "horizontal";
		            that._isRtl = that._isHorizontal && kendo.support.isRtl(element);
		            that._position = that._isHorizontal ? "left" : "bottom";
		            that._sizeFn = that._isHorizontal ? "width" : "height";
		            that._outerSize = that._isHorizontal ? outerWidth : outerHeight;
	
		            options.tooltip.format = options.tooltip.enabled ? options.tooltip.format || "{0}" : "{0}";
	
		            if (options.smallStep <= 0) {
		                throw new Error('Kendo UI Slider smallStep must be a positive number.');
		            }
	
		            that._createHtml();
		            that.wrapper = that.element.closest(".k-slider");
		            that._trackDiv = that.wrapper.find(TRACK_SELECTOR);
	
		            that._setTrackDivWidth();
	
		            that._maxSelection = that._trackDiv[that._sizeFn]();
	
		            that._sliderItemsInit();
	
		            that._reset();
	
		            that._tabindex(that.wrapper.find(DRAG_HANDLE));
		            that[options.enabled ? "enable" : "disable"]();
	
		            var rtlDirectionSign = kendo.support.isRtl(that.wrapper) ? -1 : 1;
	
		            that._keyMap = {
		                37: step(-1 * rtlDirectionSign * options.smallStep), // left arrow
		                40: step(-options.smallStep), // down arrow
		                39: step(+1 * rtlDirectionSign * options.smallStep), // right arrow
		                38: step(+options.smallStep), // up arrow
		                35: setValue(options.max), // end
		                36: setValue(options.min), // home
		                33: step(+options.largeStep), // page up
		                34: step(-options.largeStep)  // page down
		            };
	
		            kendo.notify(that);
		        },
	
		        events: [
		            CHANGE,
		            SLIDE
		        ],
	
		        options: {
		            enabled: true,
		            min: 0,
		            max: 10,
		            smallStep: 1,
		            largeStep: 5,
		            orientation: "horizontal",
		            tickPlacement: "both",
		            tooltip: { enabled: true, format: "{0}" }
		        },
	
		        _distance: function(){
		            return round(this.options.max - this.options.min);
		        },
	
		        _resize: function() {
		            this._setTrackDivWidth();
		            this.wrapper.find(".k-slider-items").remove();
	
		            this._maxSelection = this._trackDiv[this._sizeFn]();
		            this._sliderItemsInit();
		            this._refresh();
	
		            if (this.options.enabled) {
		                this.enable(true);
		            }
		        },
	
		        _sliderItemsInit: function() {
		            var that = this,
		                options = that.options;
	
		            var sizeBetweenTicks = that._maxSelection / ((options.max - options.min) / options.smallStep);
		            var pixelWidths = that._calculateItemsWidth(math.floor(that._distance() / options.smallStep));
	
		            if (options.tickPlacement != "none" && sizeBetweenTicks >= 2) {
		                $(this.element).parent().find(".k-slider-items").remove();
		                that._trackDiv.before(createSliderItems(options, that._distance()));
		                that._setItemsWidth(pixelWidths);
		                that._setItemsTitle();
		            }
	
		            that._calculateSteps(pixelWidths);
	
		            if (options.tickPlacement != "none" && sizeBetweenTicks >= 2 &&
		                options.largeStep >= options.smallStep) {
		                that._setItemsLargeTick();
		            }
		        },
	
		        getSize: function() {
		            return kendo.dimensions(this.wrapper);
		        },
	
		        _setTrackDivWidth: function() {
		            var that = this,
		                trackDivPosition = parseFloat(that._trackDiv.css(that._isRtl ? "right" : that._position), 10) * 2;
	
		            that._trackDiv[that._sizeFn]((that.wrapper[that._sizeFn]() - 2) - trackDivPosition);
		        },
	
		        _setItemsWidth: function(pixelWidths) {
		            var that = this,
		                options = that.options,
		                first = 0,
		                last = pixelWidths.length - 1,
		                items = that.wrapper.find(TICK_SELECTOR),
		                i,
		                paddingTop = 0,
		                bordersWidth = 2,
		                count = items.length,
		                selection = 0;
	
		            for (i = 0; i < count - 2; i++) {
		                $(items[i + 1])[that._sizeFn](pixelWidths[i]);
		            }
	
		            if (that._isHorizontal) {
		                $(items[first]).addClass("k-first")[that._sizeFn](pixelWidths[last - 1]);
		                $(items[last]).addClass("k-last")[that._sizeFn](pixelWidths[last]);
		            } else {
		                $(items[last]).addClass("k-first")[that._sizeFn](pixelWidths[last]);
		                $(items[first]).addClass("k-last")[that._sizeFn](pixelWidths[last - 1]);
		            }
	
		            if (that._distance() % options.smallStep !== 0 && !that._isHorizontal) {
		                for (i = 0; i < pixelWidths.length; i++) {
		                    selection += pixelWidths[i];
		                }
	
		                paddingTop = that._maxSelection - selection;
		                paddingTop += parseFloat(that._trackDiv.css(that._position), 10) + bordersWidth;
	
		                that.wrapper.find(".k-slider-items").css("padding-top", paddingTop);
		            }
		        },
	
		        _setItemsTitle: function() {
		            var that = this,
		                options = that.options,
		                items = that.wrapper.find(TICK_SELECTOR),
		                titleNumber = options.min,
		                count = items.length,
		                i = that._isHorizontal && !that._isRtl ? 0 : count - 1,
		                limit = that._isHorizontal && !that._isRtl ? count : -1,
		                increment = that._isHorizontal && !that._isRtl ? 1 : -1;
	
		            for (; i - limit !== 0 ; i += increment) {
		                $(items[i]).attr("title", format(options.tooltip.format, round(titleNumber)));
		                titleNumber += options.smallStep;
		            }
		        },
	
		        _setItemsLargeTick: function() {
		            var that = this,
		                options = that.options,
		                items = that.wrapper.find(TICK_SELECTOR),
		                i = 0, item, value;
	
		            if (removeFraction(options.largeStep) % removeFraction(options.smallStep) === 0 || that._distance() / options.largeStep >= 3) {
		                if (!that._isHorizontal && !that._isRtl) {
		                    items = $.makeArray(items).reverse();
		                }
	
		                for (i = 0; i < items.length; i++) {
		                    item = $(items[i]);
		                    value = that._values[i];
		                    var valueWithoutFraction = round(removeFraction(value - this.options.min));
		                    if (valueWithoutFraction % removeFraction(options.smallStep) === 0 && valueWithoutFraction % removeFraction(options.largeStep) === 0) {
		                        item.addClass("k-tick-large")
		                            .html("<span class='k-label'>" + item.attr("title") + "</span>");
	
		                        if (i !== 0 && i !== items.length - 1) {
		                            item.css("line-height", item[that._sizeFn]() + "px");
		                        }
		                    }
		                }
		            }
		        },
	
		        _calculateItemsWidth: function(itemsCount) {
		            var that = this,
		                options = that.options,
		                trackDivSize = parseFloat(that._trackDiv.css(that._sizeFn)) + 1,
		                distance = that._distance(),
		                pixelStep = trackDivSize / distance,
		                itemWidth,
		                pixelWidths,
		                i;
	
		            if ((distance / options.smallStep) - math.floor(distance / options.smallStep) > 0) {
		                trackDivSize -= ((distance % options.smallStep) * pixelStep);
		            }
	
		            itemWidth = trackDivSize / itemsCount;
		            pixelWidths = [];
	
		            for (i = 0; i < itemsCount - 1; i++) {
		                pixelWidths[i] = itemWidth;
		            }
	
		            pixelWidths[itemsCount - 1] = pixelWidths[itemsCount] = itemWidth / 2;
		            return that._roundWidths(pixelWidths);
		        },
	
		        _roundWidths: function(pixelWidthsArray) {
		            var balance = 0,
		                count = pixelWidthsArray.length,
		                i;
	
		            for (i = 0; i < count; i++) {
		                balance += (pixelWidthsArray[i] - math.floor(pixelWidthsArray[i]));
		                pixelWidthsArray[i] = math.floor(pixelWidthsArray[i]);
		            }
	
		            balance = math.round(balance);
	
		            return this._addAdditionalSize(balance, pixelWidthsArray);
		        },
	
		        _addAdditionalSize: function(additionalSize, pixelWidthsArray) {
		            if (additionalSize === 0) {
		                return pixelWidthsArray;
		            }
	
		            //set step size
		            var step = parseFloat(pixelWidthsArray.length - 1) / parseFloat(additionalSize == 1 ? additionalSize : additionalSize - 1),
		                i;
	
		            for (i = 0; i < additionalSize; i++) {
		                pixelWidthsArray[parseInt(math.round(step * i), 10)] += 1;
		            }
	
		            return pixelWidthsArray;
		        },
	
		        _calculateSteps: function(pixelWidths) {
		            var that = this,
		                options = that.options,
		                val = options.min,
		                selection = 0,
		                distance = that._distance(),
		                itemsCount = math.ceil(distance / options.smallStep),
		                i = 1,
		                lastItem;
	
		            itemsCount += (distance / options.smallStep) % 1 === 0 ? 1 : 0;
		            pixelWidths.splice(0, 0, pixelWidths[itemsCount - 2] * 2);
		            pixelWidths.splice(itemsCount -1, 1, pixelWidths.pop() * 2);
	
		            that._pixelSteps = [selection];
		            that._values = [val];
	
		            if (itemsCount === 0) {
		                return;
		            }
	
		            while (i < itemsCount) {
		                selection += (pixelWidths[i - 1] + pixelWidths[i]) / 2;
		                that._pixelSteps[i] = selection;
		                val += options.smallStep;
		                that._values[i] = round(val);
	
		                i++;
		            }
	
		            lastItem = distance % options.smallStep === 0 ? itemsCount - 1 : itemsCount;
	
		            that._pixelSteps[lastItem] = that._maxSelection;
		            that._values[lastItem] = options.max;
	
		            if (that._isRtl) {
		                that._pixelSteps.reverse();
		                that._values.reverse();
		            }
		        },
	
		        _getValueFromPosition: function(mousePosition, dragableArea) {
		            var that = this,
		                options = that.options,
		                step = math.max(options.smallStep * (that._maxSelection / that._distance()), 0),
		                position = 0,
		                halfStep = (step / 2),
		                i;
	
		            if (that._isHorizontal) {
		                position = mousePosition - dragableArea.startPoint;
		                if (that._isRtl) {
		                    position = that._maxSelection - position;
		                }
		            } else {
		                position = dragableArea.startPoint - mousePosition;
		            }
	
		            if (that._maxSelection - ((parseInt(that._maxSelection % step, 10) - 3) / 2) < position) {
		                return options.max;
		            }
	
		            for (i = 0; i < that._pixelSteps.length; i++) {
		                if (math.abs(that._pixelSteps[i] - position) - 1 <= halfStep) {
		                    return round(that._values[i]);
		                }
		            }
		        },
	
		        _getFormattedValue: function(val, drag) {
		            var that = this,
		                html = "",
		                tooltip = that.options.tooltip,
		                tooltipTemplate,
		                selectionStart,
		                selectionEnd;
	
		            if (isArray(val)) {
		                selectionStart = val[0];
		                selectionEnd = val[1];
		            } else if (drag && drag.type) {
		                selectionStart = drag.selectionStart;
		                selectionEnd = drag.selectionEnd;
		            }
	
		            if (drag) {
		                tooltipTemplate = drag.tooltipTemplate;
		            }
	
		            if (!tooltipTemplate && tooltip.template) {
		                tooltipTemplate = kendo.template(tooltip.template);
		            }
	
		            if (isArray(val) || (drag && drag.type)) {
	
		                if (tooltipTemplate) {
		                    html = tooltipTemplate({
		                        selectionStart: selectionStart,
		                        selectionEnd: selectionEnd
		                    });
		                } else {
		                    selectionStart = format(tooltip.format, selectionStart);
		                    selectionEnd = format(tooltip.format, selectionEnd);
		                    html = selectionStart + " - " + selectionEnd;
		                }
		            } else {
		                if (drag) {
		                    drag.val = val;
		                }
	
		                if (tooltipTemplate) {
		                    html = tooltipTemplate({
		                        value: val
		                    });
		                } else {
		                    html = format(tooltip.format, val);
		                }
		            }
		            return html;
		        },
	
		        _getDraggableArea: function() {
		            var that = this,
		                offset = kendo.getOffset(that._trackDiv);
	
		            return {
		                startPoint: that._isHorizontal ? offset.left : offset.top + that._maxSelection,
		                endPoint: that._isHorizontal ? offset.left + that._maxSelection : offset.top
		            };
		        },
	
		        _createHtml: function() {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                inputs = element.find("input");
	
		            if (inputs.length == 2) {
		                inputs.eq(0).prop("value", formatValue(options.selectionStart));
		                inputs.eq(1).prop("value", formatValue(options.selectionEnd));
		            } else {
		                element.prop("value", formatValue(options.value));
		            }
	
		            element.wrap(createWrapper(options, element, that._isHorizontal)).hide();
	
		            if (options.showButtons) {
		                element.before(createButton(options, "increase", that._isHorizontal, that._isRtl))
		                       .before(createButton(options, "decrease", that._isHorizontal, that._isRtl));
		            }
	
		            element.before(createTrack(options, element));
		        },
	
		        _focus: function(e) {
		            var that = this,
		                target = e.target,
		                val = that.value(),
		                drag = that._drag;
	
		            if (!drag) {
		                if (target == that.wrapper.find(DRAG_HANDLE).eq(0)[0]) {
		                    drag = that._firstHandleDrag;
		                    that._activeHandle = 0;
		                } else {
		                    drag = that._lastHandleDrag;
		                    that._activeHandle = 1;
		                }
		                val = val[that._activeHandle];
		            }
	
		            $(target).addClass(STATE_FOCUSED + " " + STATE_SELECTED);
	
		            if (drag) {
		                that._activeHandleDrag = drag;
	
		                drag.selectionStart = that.options.selectionStart;
		                drag.selectionEnd = that.options.selectionEnd;
	
		                drag._updateTooltip(val);
		            }
		        },
	
		        _focusWithMouse: function(target) {
		            target = $(target);
	
		            var that = this,
		                idx = target.is(DRAG_HANDLE) ? target.index() : 0;
	
		            window.setTimeout(function(){
		                that.wrapper.find(DRAG_HANDLE)[idx == 2 ? 1 : 0].focus();
		            }, 1);
	
		            that._setTooltipTimeout();
		        },
	
		        _blur: function(e) {
		            var that = this,
		                drag = that._activeHandleDrag;
	
		            $(e.target).removeClass(STATE_FOCUSED + " " + STATE_SELECTED);
	
		            if (drag) {
		                drag._removeTooltip();
		                delete that._activeHandleDrag;
		                delete that._activeHandle;
		            }
		        },
	
		        _setTooltipTimeout: function() {
		            var that = this;
		            that._tooltipTimeout = window.setTimeout(function(){
		                var drag = that._drag || that._activeHandleDrag;
		                if (drag) {
		                    drag._removeTooltip();
		                }
		            }, 300);
		        },
	
		        _clearTooltipTimeout: function() {
		            var that = this;
		            window.clearTimeout(this._tooltipTimeout);
		            var drag = that._drag || that._activeHandleDrag;
		            if (drag && drag.tooltipDiv) {
		                drag.tooltipDiv.stop(true, false).css("opacity", 1);
		            }
		        },
	
		        _reset: function () {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._form = form.on("reset", proxy(that._formResetHandler, that));
		            }
		        },
	
		        min: function(value){
		            if(!value){
		                return this.options.min;
		            }
		            this.setOptions({"min":value});
		        },
	
		        max: function(value){
		            if(!value){
		                return this.options.max;
		            }
		            this.setOptions({"max":value});
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
		            this._sliderItemsInit();
		            this._refresh();
		        },
	
		        destroy: function () {
		            if (this._form) {
		                this._form.off("reset", this._formResetHandler);
		            }
		            Widget.fn.destroy.call(this);
		        }
		    });
	
		    function createWrapper (options, element, isHorizontal) {
		        var orientationCssClass = isHorizontal ? " k-slider-horizontal" : " k-slider-vertical",
		            style = options.style ? options.style : element.attr("style"),
		            cssClasses = element.attr("class") ? (" " + element.attr("class")) : "",
		            tickPlacementCssClass = "";
	
		        if (options.tickPlacement == "bottomRight") {
		            tickPlacementCssClass = " k-slider-bottomright";
		        } else if (options.tickPlacement == "topLeft") {
		            tickPlacementCssClass = " k-slider-topleft";
		        }
	
		        style = style ? " style='" + style + "'" : "";
	
		        return "<div class='k-widget k-slider" + orientationCssClass + cssClasses + "'" + style + ">" +
		               "<div class='k-slider-wrap" + (options.showButtons ? " k-slider-buttons" : "") + tickPlacementCssClass +
		               "'></div></div>";
		    }
	
		    function createButton (options, type, isHorizontal, isRtl) {
		        var buttonCssClass = "";
	
		        if(isHorizontal) {
		            if ((!isRtl && type == "increase") || (isRtl && type != "increase")) {
		                buttonCssClass = "k-i-arrow-60-right";
		            } else {
		                buttonCssClass = "k-i-arrow-60-left";
		            }
		        } else {
		            if (type == "increase") {
		                buttonCssClass = "k-i-arrow-60-up";
		            } else {
		                buttonCssClass = "k-i-arrow-60-down";
		            }
		        }
	
		        return "<a class='k-button k-button-" + type + "' " +
		                "title='" + options[type + "ButtonTitle"] + "' " +
		                "aria-label='" + options[type + "ButtonTitle"] + "'>" +
		                "<span class='k-icon " + buttonCssClass + "'></span></a>";
		    }
	
		    function createSliderItems (options, distance) {
		        var result = "<ul class='k-reset k-slider-items'>",
		            count = math.floor(round(distance / options.smallStep)) + 1,
		            i;
	
		        for(i = 0; i < count; i++) {
		            result += "<li class='k-tick' role='presentation'>&nbsp;</li>";
		        }
	
		        result += "</ul>";
	
		        return result;
		    }
	
		    function createTrack (options, element) {
		        var dragHandleCount = element.is("input") ? 1 : 2,
		            firstDragHandleTitle = dragHandleCount == 2 ? options.leftDragHandleTitle : options.dragHandleTitle;
	
		        return "<div class='k-slider-track'><div class='k-slider-selection'><!-- --></div>" +
		               "<a href='#' class='k-draghandle' title='" + firstDragHandleTitle + "' role='slider' aria-valuemin='" + options.min + "' aria-valuemax='" + options.max + "' aria-valuenow='" + (dragHandleCount > 1 ? (options.selectionStart || options.min) : options.value || options.min) + "'>Drag</a>" +
		               (dragHandleCount > 1 ? "<a href='#' class='k-draghandle' title='" + options.rightDragHandleTitle + "'role='slider' aria-valuemin='" + options.min + "' aria-valuemax='" + options.max + "' aria-valuenow='" + (options.selectionEnd || options.max) + "'>Drag</a>" : "") +
		               "</div>";
		    }
	
		    function step(stepValue) {
		        return function (value) {
		            return value + stepValue;
		        };
		    }
	
		    function setValue(value) {
		        return function () {
		            return value;
		        };
		    }
	
		    function formatValue(value) {
		        return (value + "").replace(".", kendo.cultures.current.numberFormat["."]);
		    }
	
		    function calculatePrecision(value) {
		        var number = value.toString();
		        var precision = 0;
	
		        number = number.split(".");
	
		        if (number[1]) {
		            precision = number[1].length;
		        }
	
		        precision = precision > 10 ? 10 : precision;
		        return precision;
		    }
	
		    function round(value) {
		        var precision, power;
	
		        value = parseFloat(value, 10);
		        precision = calculatePrecision(value);
		        power = math.pow(10, precision || 0);
	
		        return math.round(value * power) / power;
		    }
	
		    function parseAttr(element, name) {
		        var value = parse(element.getAttribute(name));
		        if (value === null) {
		            value = undefined;
		        }
		        return value;
		    }
	
		    function defined(value) {
		        return typeof value !== UNDEFINED;
		    }
	
		    function removeFraction(value) {
		        return value * 10000;
		    }
	
		    var Slider = SliderBase.extend({
		        init: function(element, options) {
		            var that = this,
		                dragHandle;
	
		            element.type = "text";
		            options = extend({}, {
		                value: parseAttr(element, "value"),
		                min: parseAttr(element, "min"),
		                max: parseAttr(element, "max"),
		                smallStep: parseAttr(element, "step")
		            }, options);
	
		            element = $(element);
	
		            if (options && options.enabled === undefined) {
		                options.enabled = !element.is("[disabled]");
		            }
	
		            SliderBase.fn.init.call(that, element, options);
		            options = that.options;
		            if (!defined(options.value) || options.value === null) {
		                options.value = options.min;
		                element.prop("value", formatValue(options.min));
		            }
		            options.value = math.max(math.min(options.value, options.max), options.min);
	
		            dragHandle = that.wrapper.find(DRAG_HANDLE);
	
		            this._selection = new Slider.Selection(dragHandle, that, options);
		            that._drag = new Slider.Drag(dragHandle, "", that, options);
		        },
	
		        options: {
		            name: "Slider",
		            showButtons: true,
		            increaseButtonTitle: "Increase",
		            decreaseButtonTitle: "Decrease",
		            dragHandleTitle: "drag",
		            tooltip: { format: "{0:#,#.##}" },
		            value: null
		        },
	
		        enable: function (enable) {
		            var that = this,
		                options = that.options,
		                clickHandler,
		                move;
	
		            that.disable();
		            if (enable === false) {
		                return;
		            }
	
		            that.wrapper
		                .removeClass(STATE_DISABLED)
		                .addClass(STATE_DEFAULT);
	
		            that.wrapper.find("input").removeAttr(DISABLED);
	
		            clickHandler = function (e) {
		                var touch = getTouches(e)[0];
	
		                if (!touch) {
		                    return;
		                }
	
		                var mousePosition = that._isHorizontal ? touch.location.pageX : touch.location.pageY,
		                    dragableArea = that._getDraggableArea(),
		                    target = $(e.target);
	
		                if (target.hasClass("k-draghandle")) {
		                    target.addClass(STATE_FOCUSED + " " + STATE_SELECTED);
		                    return;
		                }
	
		                that._update(that._getValueFromPosition(mousePosition, dragableArea));
	
		                that._focusWithMouse(e.target);
	
		                that._drag.dragstart(e);
		                e.preventDefault();
		            };
	
		            that.wrapper
		                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR)
		                    .on(TRACK_MOUSE_DOWN, clickHandler)
		                    .end()
		                    .on(TRACK_MOUSE_DOWN, function() {
		                        $(document.documentElement).one("selectstart", kendo.preventDefault);
		                    })
		                    .on(TRACK_MOUSE_UP, function() {
		                        that._drag._end();
		                    });
	
		            that.wrapper
		                .find(DRAG_HANDLE)
		                .attr(TABINDEX, 0)
		                .on(MOUSE_UP, function () {
		                    that._setTooltipTimeout();
		                })
		                .on(CLICK, function (e) {
		                    that._focusWithMouse(e.target);
		                    e.preventDefault();
		                })
		                .on(FOCUS, proxy(that._focus, that))
		                .on(BLUR, proxy(that._blur, that));
	
		            move = proxy(function (sign) {
		                var newVal = that._nextValueByIndex(that._valueIndex + (sign * 1));
		                that._setValueInRange(newVal);
		                that._drag._updateTooltip(newVal);
		            }, that);
	
		            if (options.showButtons) {
		                var mouseDownHandler = proxy(function(e, sign) {
		                    this._clearTooltipTimeout();
		                    if (e.which === 1 || (support.touch && e.which === 0)) {
		                        move(sign);
	
		                        this.timeout = setTimeout(proxy(function () {
		                            this.timer = setInterval(function () {
		                                move(sign);
		                            }, 60);
		                        }, this), 200);
		                    }
		                }, that);
	
		                that.wrapper.find(".k-button")
		                    .on(MOUSE_UP, proxy(function (e) {
		                        this._clearTimer();
		                        that._focusWithMouse(e.target);
		                    }, that))
		                    .on(MOUSE_OVER, function (e) {
		                        $(e.currentTarget).addClass("k-state-hover");
		                    })
		                    .on("mouseout" + NS, proxy(function (e) {
		                        $(e.currentTarget).removeClass("k-state-hover");
		                        this._clearTimer();
		                    }, that))
		                    .eq(0)
		                    .on(MOUSE_DOWN, proxy(function (e) {
		                        mouseDownHandler(e, 1);
		                    }, that))
		                    .click(false)
		                    .end()
		                    .eq(1)
		                    .on(MOUSE_DOWN, proxy(function (e) {
		                        mouseDownHandler(e, -1);
		                    }, that))
		                    .click(kendo.preventDefault);
		            }
	
		            that.wrapper
		                .find(DRAG_HANDLE)
		                .off(KEY_DOWN, false)
		                .on(KEY_DOWN, proxy(this._keydown, that));
	
		            options.enabled = true;
		        },
	
		        disable: function () {
		            var that = this;
	
		            that.wrapper
		                .removeClass(STATE_DEFAULT)
		                .addClass(STATE_DISABLED);
	
		            $(that.element).prop(DISABLED, DISABLED);
	
		            that.wrapper
		                .find(".k-button")
		                .off(MOUSE_DOWN)
		                .on(MOUSE_DOWN, function(e) {
		                    e.preventDefault();
		                    $(this).addClass("k-state-active");
		                })
		                .off(MOUSE_UP)
		                .on(MOUSE_UP, function(e) {
		                    e.preventDefault();
		                    $(this).removeClass("k-state-active");
		                })
		                .off("mouseleave" + NS)
		                .on("mouseleave" + NS, kendo.preventDefault)
		                .off(MOUSE_OVER)
		                .on(MOUSE_OVER, kendo.preventDefault);
	
		            that.wrapper
		                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(TRACK_MOUSE_DOWN).off(TRACK_MOUSE_UP);
	
		            that.wrapper
		                .find(DRAG_HANDLE)
		                .attr(TABINDEX, -1)
		                .off(MOUSE_UP)
		                .off(KEY_DOWN)
		                .off(CLICK)
		                .off(FOCUS)
		                .off(BLUR);
	
		            that.options.enabled = false;
		        },
	
		        _update: function (val) {
		            var that = this,
		                change = that.value() != val;
	
		            that.value(val);
	
		            if (change) {
		                that.trigger(CHANGE, { value: that.options.value });
		            }
		        },
	
		        value: function (value) {
		            var that = this,
		                options = that.options;
	
		            value = round(value);
		            if (isNaN(value)) {
		                return options.value;
		            }
	
		            if (value >= options.min && value <= options.max) {
		                if (options.value != value) {
		                    that.element.prop("value", formatValue(value));
		                    options.value = value;
		                    that._refreshAriaAttr(value);
		                    that._refresh();
		                }
		            }
		        },
	
		        _refresh: function () {
		            this.trigger(MOVE_SELECTION, { value: this.options.value });
		        },
	
		        _refreshAriaAttr: function(value) {
		            var that = this,
		                drag = that._drag,
		                formattedValue;
	
		            if (drag && drag._tooltipDiv) {
		                formattedValue = drag._tooltipDiv.text();
		            } else {
		                formattedValue = that._getFormattedValue(value, null);
		            }
		            this.wrapper.find(DRAG_HANDLE).attr("aria-valuenow", value).attr("aria-valuetext", formattedValue);
		        },
	
		        _clearTimer: function () {
		            clearTimeout(this.timeout);
		            clearInterval(this.timer);
		        },
	
		        _keydown: function (e) {
		            var that = this;
	
		            if (e.keyCode in that._keyMap) {
		                that._clearTooltipTimeout();
		                that._setValueInRange(that._keyMap[e.keyCode](that.options.value));
		                that._drag._updateTooltip(that.value());
		                e.preventDefault();
		            }
		        },
	
		        _setValueInRange: function (val) {
		            var that = this,
		                options = that.options;
	
		            val = round(val);
		            if (isNaN(val)) {
		                that._update(options.min);
		                return;
		            }
	
		            val = math.max(math.min(val, options.max), options.min);
		            that._update(val);
		        },
	
		        _nextValueByIndex: function (index) {
		            var count = this._values.length;
		            if (this._isRtl) {
		                index = count - 1 - index;
		            }
		            return this._values[math.max(0, math.min(index, count - 1))];
		        },
	
		        _formResetHandler: function () {
		            var that = this,
		                min = that.options.min;
	
		            setTimeout(function () {
		                var value = that.element[0].value;
		                that.value(value === "" || isNaN(value) ? min : value);
		            });
		        },
	
		        destroy: function() {
		            var that = this;
	
		            SliderBase.fn.destroy.call(that);
	
		            that.wrapper.off(NS)
		                .find(".k-button").off(NS)
		                .end()
		                .find(DRAG_HANDLE).off(NS)
		                .end()
		                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(NS)
		                .end();
	
		            that._drag.draggable.destroy();
		            that._drag._removeTooltip(true);
		        }
		    });
	
		    Slider.Selection = function (dragHandle, that, options) {
		        function moveSelection (val) {
		            var selectionValue = val - options.min,
		                index = that._valueIndex = math.ceil(round(selectionValue / options.smallStep)),
		                selection = parseInt(that._pixelSteps[index], 10),
		                selectionDiv = that._trackDiv.find(".k-slider-selection"),
	
		                halfDragHanndle = parseInt(that._outerSize(dragHandle) / 2, 10),
		                rtlCorrection = that._isRtl ? 2 : 0;
	
		            selectionDiv[that._sizeFn](that._isRtl ? that._maxSelection - selection : selection);
		            dragHandle.css(that._position, selection - halfDragHanndle - rtlCorrection);
		        }
	
		        moveSelection(options.value);
	
		        that.bind([SLIDE, MOVE_SELECTION], function (e) {
		            moveSelection(parseFloat(e.value, 10));
		        });
	
		        that.bind(CHANGE, function (e) {
		            moveSelection(parseFloat(e.sender.value(), 10));
		        });
		    };
	
		    Slider.Drag = function (element, type, owner, options) {
		        var that = this;
		        that.owner = owner;
		        that.options = options;
		        that.element = element;
		        that.type = type;
	
		        that.draggable = new Draggable(element, {
		            distance: 0,
		            dragstart: proxy(that._dragstart, that),
		            drag: proxy(that.drag, that),
		            dragend: proxy(that.dragend, that),
		            dragcancel: proxy(that.dragcancel, that)
		        });
	
		        element.click(false);
	
		        // Disable link dragging
		        element.on("dragstart", function(e){
		            e.preventDefault();
		        });
		    };
	
		    Slider.Drag.prototype = {
		        dragstart: function(e) {
		            // add reference to the last active drag handle.
		            this.owner._activeDragHandle = this;
		            // HACK to initiate click on the line
		            this.draggable.userEvents.cancel();
		            this._dragstart(e);
		            this.dragend();
		        },
	
		        _dragstart: function(e) {
		            var that = this,
		                owner = that.owner,
		                options = that.options;
	
		            if (!options.enabled) {
		                e.preventDefault();
		                return;
		            }
	
		            // add reference to the last active drag handle.
		            this.owner._activeDragHandle = this;
	
		            owner.element.off(MOUSE_OVER);
		            owner.wrapper.find("." + STATE_FOCUSED).removeClass(STATE_FOCUSED + " " + STATE_SELECTED);
		            that.element.addClass(STATE_FOCUSED + " " + STATE_SELECTED);
		            $(document.documentElement).css("cursor", "pointer");
	
		            that.dragableArea = owner._getDraggableArea();
		            that.step = math.max(options.smallStep * (owner._maxSelection / owner._distance()), 0);
	
		            if (that.type) {
		                that.selectionStart = options.selectionStart;
		                that.selectionEnd = options.selectionEnd;
		                owner._setZIndex(that.type);
		            } else {
		                that.oldVal = that.val = options.value;
		            }
	
		            that._removeTooltip(true);
		            that._createTooltip();
		        },
	
		        _createTooltip: function() {
		            var that = this,
		                owner = that.owner,
		                tooltip = that.options.tooltip,
		                html = '',
		                wnd = $(window),
		                tooltipTemplate, colloutCssClass;
	
		            if (!tooltip.enabled) {
		                return;
		            }
	
		            if (tooltip.template) {
		                tooltipTemplate = that.tooltipTemplate = kendo.template(tooltip.template);
		            }
	
		            $(".k-slider-tooltip").remove(); // if user changes window while tooltip is visible, a second one will be created
		            that.tooltipDiv = $("<div class='k-widget k-tooltip k-slider-tooltip'><!-- --></div>").appendTo(document.body);
	
		            html = owner._getFormattedValue(that.val || owner.value(), that);
	
		            if (!that.type) {
		                colloutCssClass = "k-callout-" + (owner._isHorizontal ? 's' : 'e');
		                that.tooltipInnerDiv = "<div class='k-callout " + colloutCssClass + "'><!-- --></div>";
		                html += that.tooltipInnerDiv;
		            }
	
		            that.tooltipDiv.html(html);
	
		            that._scrollOffset = {
		                top: wnd.scrollTop(),
		                left: wnd.scrollLeft()
		            };
	
		            that.moveTooltip();
		        },
	
		        drag: function (e) {
		            var that = this,
		                owner = that.owner,
		                x = e.x.location,
		                y = e.y.location,
		                startPoint = that.dragableArea.startPoint,
		                endPoint = that.dragableArea.endPoint,
		                slideParams;
	
		            e.preventDefault();
	
		            if (owner._isHorizontal) {
		                if (owner._isRtl) {
		                    that.val = that.constrainValue(x, startPoint, endPoint, x < endPoint);
		                } else {
		                    that.val = that.constrainValue(x, startPoint, endPoint, x >= endPoint);
		                }
		            } else {
		                that.val = that.constrainValue(y, endPoint, startPoint, y <= endPoint);
		            }
	
		            if (that.oldVal != that.val) {
		                that.oldVal = that.val;
	
		                if (that.type) {
		                    if (that.type == "firstHandle") {
		                        if (that.val < that.selectionEnd) {
		                            that.selectionStart = that.val;
		                        } else {
		                            that.selectionStart = that.selectionEnd = that.val;
		                        }
		                    } else {
		                        if (that.val > that.selectionStart) {
		                            that.selectionEnd = that.val;
		                        } else {
		                            that.selectionStart = that.selectionEnd = that.val;
		                        }
		                    }
		                    slideParams = {
		                        values: [that.selectionStart, that.selectionEnd],
		                        value: [that.selectionStart, that.selectionEnd]
		                    };
		                } else {
		                    slideParams = { value: that.val };
		                }
	
		                owner.trigger(SLIDE, slideParams);
		            }
		            that._updateTooltip(that.val);
		        },
	
		        _updateTooltip: function(val) {
		            var that = this,
		                options = that.options,
		                tooltip = options.tooltip,
		                html = "";
	
		            if (!tooltip.enabled) {
		                return;
		            }
	
		            if (!that.tooltipDiv) {
		                that._createTooltip();
		            }
	
		            html = that.owner._getFormattedValue(round(val), that);
	
		            if (!that.type) {
		                html += that.tooltipInnerDiv;
		            }
	
		            that.tooltipDiv.html(html);
		            that.moveTooltip();
		        },
	
		        dragcancel: function() {
		            this.owner._refresh();
		            $(document.documentElement).css("cursor", "");
		            return this._end();
		        },
	
		        dragend: function() {
		            var that = this,
		                owner = that.owner;
	
		            $(document.documentElement).css("cursor", "");
	
		            if (that.type) {
		                owner._update(that.selectionStart, that.selectionEnd);
		            } else {
		                owner._update(that.val);
		                that.draggable.userEvents._disposeAll();
		            }
	
		            that.draggable.userEvents.cancel();
		            return that._end();
		        },
	
		        _end: function() {
		            var that = this,
		                owner = that.owner;
	
		            owner._focusWithMouse(that.element);
	
		            owner.element.on(MOUSE_OVER);
	
		            return false;
		        },
	
		        _removeTooltip: function(noAnimation) {
		            var that = this,
		                owner = that.owner;
	
		            if (that.tooltipDiv && owner.options.tooltip.enabled && owner.options.enabled) {
		                if (noAnimation) {
		                    that.tooltipDiv.remove();
		                    that.tooltipDiv = null;
		                } else {
		                    that.tooltipDiv.fadeOut("slow", function(){
		                        $(this).remove();
		                        that.tooltipDiv = null;
		                    });
		                }
		            }
		        },
	
		        moveTooltip: function () {
		            var that = this,
		                owner = that.owner,
		                top = 0,
		                left = 0,
		                element = that.element,
		                offset = kendo.getOffset(element),
		                margin = 8,
		                viewport = $(window),
		                callout = that.tooltipDiv.find(".k-callout"),
		                width = outerWidth(that.tooltipDiv),
		                height = outerHeight(that.tooltipDiv),
		                dragHandles, sdhOffset, diff, anchorSize;
	
		            if (that.type) {
		                dragHandles = owner.wrapper.find(DRAG_HANDLE);
		                offset = kendo.getOffset(dragHandles.eq(0));
		                sdhOffset = kendo.getOffset(dragHandles.eq(1));
	
		                if (owner._isHorizontal) {
		                    top = sdhOffset.top;
		                    left = offset.left + ((sdhOffset.left - offset.left) / 2);
		                } else {
		                    top = offset.top + ((sdhOffset.top - offset.top) / 2);
		                    left = sdhOffset.left;
		                }
	
		                anchorSize = outerWidth(dragHandles.eq(0)) + 2 * margin;
		            } else {
		                top = offset.top;
		                left = offset.left;
		                anchorSize = outerWidth(element) + 2 * margin;
		            }
	
		            if (owner._isHorizontal) {
		                left -= parseInt((width - owner._outerSize(element)) / 2, 10);
		                top -= height + margin + (callout.length ? callout.height() : 0);
		            } else {
		                top -= parseInt((height - owner._outerSize(element)) / 2, 10);
		                left -= width + margin + (callout.length ? callout.width() : 0);
		            }
	
		            if (owner._isHorizontal) {
		                diff = that._flip(top, height, anchorSize, outerHeight(viewport) + that._scrollOffset.top);
		                top += diff;
		                left += that._fit(left, width, outerWidth(viewport) + that._scrollOffset.left);
		            } else {
		                diff = that._flip(left, width, anchorSize, outerWidth(viewport) + that._scrollOffset.left);
		                top += that._fit(top, height, outerHeight(viewport) + that._scrollOffset.top);
		                left += diff;
		            }
	
		            if (diff > 0 && callout) {
		                callout.removeClass();
		                callout.addClass("k-callout k-callout-" + (owner._isHorizontal ? "n" : "w"));
		            }
	
		            that.tooltipDiv.css({ top: top, left: left });
		        },
	
		        _fit: function(position, size, viewPortEnd) {
		            var output = 0;
	
		            if (position + size > viewPortEnd) {
		                output = viewPortEnd - (position + size);
		            }
	
		            if (position < 0) {
		                output = -position;
		            }
	
		            return output;
		        },
	
		        _flip: function(offset, size, anchorSize, viewPortEnd) {
		            var output = 0;
	
		            if (offset + size > viewPortEnd) {
		                output += -(anchorSize + size);
		            }
	
		            if (offset + output < 0) {
		                output += anchorSize + size;
		            }
	
		            return output;
		        },
	
		        constrainValue: function (position, min, max, maxOverflow) {
		            var that = this,
		                val = 0;
	
		            if (min < position && position < max) {
		                val = that.owner._getValueFromPosition(position, that.dragableArea);
		            } else {
		                if (maxOverflow ) {
		                    val = that.options.max;
		                } else {
		                    val = that.options.min;
		                }
		            }
	
		            return val;
		        }
	
		    };
	
		    kendo.ui.plugin(Slider);
	
		    var RangeSlider = SliderBase.extend({
		        init: function(element, options) {
		            var that = this,
		                inputs = $(element).find("input"),
		                firstInput = inputs.eq(0)[0],
		                secondInput = inputs.eq(1)[0];
	
		            firstInput.type = "text";
		            secondInput.type = "text";
	
		            if (options && options.showButtons) {
		                if (window.console) {
		                    window.console.warn("showbuttons option is not supported for the range slider, ignoring");
		                }
	
		                options.showButtons = false;
		            }
	
		            options = extend({}, {
		                selectionStart: parseAttr(firstInput, "value"),
		                min: parseAttr(firstInput, "min"),
		                max: parseAttr(firstInput, "max"),
		                smallStep: parseAttr(firstInput, "step")
		            }, {
		                selectionEnd: parseAttr(secondInput, "value"),
		                min: parseAttr(secondInput, "min"),
		                max: parseAttr(secondInput, "max"),
		                smallStep: parseAttr(secondInput, "step")
		            }, options);
	
		            if (options && options.enabled === undefined) {
		                options.enabled = !inputs.is("[disabled]");
		            }
	
		            SliderBase.fn.init.call(that, element, options);
		            options = that.options;
		            if (!defined(options.selectionStart) || options.selectionStart === null) {
		                options.selectionStart = options.min;
		                inputs.eq(0).prop("value", formatValue(options.min));
		            }
	
		            if (!defined(options.selectionEnd) || options.selectionEnd === null) {
		                options.selectionEnd = options.max;
		                inputs.eq(1).prop("value", formatValue(options.max));
		            }
	
		            var dragHandles = that.wrapper.find(DRAG_HANDLE);
	
		            this._selection = new RangeSlider.Selection(dragHandles, that, options);
		            that._firstHandleDrag = new Slider.Drag(dragHandles.eq(0), "firstHandle", that, options);
		            that._lastHandleDrag = new Slider.Drag(dragHandles.eq(1), "lastHandle" , that, options);
		        },
	
		        options: {
		            name: "RangeSlider",
		            leftDragHandleTitle: "drag",
		            rightDragHandleTitle: "drag",
		            tooltip: { format: "{0:#,#.##}" },
		            selectionStart: null,
		            selectionEnd: null
		        },
	
		        enable: function (enable) {
		            var that = this,
		                options = that.options,
		                clickHandler;
	
		            that.disable();
		            if (enable === false) {
		                return;
		            }
	
		            that.wrapper
		                .removeClass(STATE_DISABLED)
		                .addClass(STATE_DEFAULT);
	
		            that.wrapper.find("input").removeAttr(DISABLED);
	
		            clickHandler = function (e) {
		                var touch = getTouches(e)[0];
	
		                if (!touch) {
		                    return;
		                }
	
		                var mousePosition = that._isHorizontal ? touch.location.pageX : touch.location.pageY,
		                    dragableArea = that._getDraggableArea(),
		                    val = that._getValueFromPosition(mousePosition, dragableArea),
		                    target = $(e.target),
		                    from, to, drag;
	
		                if (target.hasClass("k-draghandle")) {
		                    that.wrapper.find("." + STATE_FOCUSED).removeClass(STATE_FOCUSED + " " + STATE_SELECTED);
		                    target.addClass(STATE_FOCUSED + " " + STATE_SELECTED);
		                    return;
		                }
	
		                if (val < options.selectionStart) {
		                    from = val;
		                    to = options.selectionEnd;
		                    drag = that._firstHandleDrag;
		                } else if (val > that.selectionEnd) {
		                    from = options.selectionStart;
		                    to = val;
		                    drag = that._lastHandleDrag;
		                } else {
		                    if (val - options.selectionStart <= options.selectionEnd - val) {
		                        from = val;
		                        to = options.selectionEnd;
		                        drag = that._firstHandleDrag;
		                    } else {
		                        from = options.selectionStart;
		                        to = val;
		                        drag = that._lastHandleDrag;
		                    }
		                }
	
		                drag.dragstart(e);
		                that._setValueInRange(from, to);
		                that._focusWithMouse(drag.element);
		            };
	
		            that.wrapper
		                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR)
		                    .on(TRACK_MOUSE_DOWN, clickHandler)
		                    .end()
		                    .on(TRACK_MOUSE_DOWN, function() {
		                        $(document.documentElement).one("selectstart", kendo.preventDefault);
		                    })
		                    .on(TRACK_MOUSE_UP, function() {
		                        if (that._activeDragHandle) {
		                            that._activeDragHandle._end();
		                        }
		                    });
	
		            that.wrapper
		                .find(DRAG_HANDLE)
		                .attr(TABINDEX, 0)
		                .on(MOUSE_UP, function () {
		                    that._setTooltipTimeout();
		                })
		                .on(CLICK, function (e) {
		                    that._focusWithMouse(e.target);
		                    e.preventDefault();
		                })
		                .on(FOCUS, proxy(that._focus, that))
		                .on(BLUR, proxy(that._blur, that));
	
		            that.wrapper.find(DRAG_HANDLE)
		                .off(KEY_DOWN, kendo.preventDefault)
		                .eq(0).on(KEY_DOWN,
		                    proxy(function(e) {
		                        this._keydown(e, "firstHandle");
		                    }, that)
		                )
		                .end()
		                .eq(1).on(KEY_DOWN,
		                    proxy(function(e) {
		                        this._keydown(e, "lastHandle");
		                    }, that)
		                );
	
		            that.options.enabled = true;
		        },
	
		        disable: function () {
		            var that = this;
	
		            that.wrapper
		                .removeClass(STATE_DEFAULT)
		                .addClass(STATE_DISABLED);
	
		            that.wrapper.find("input").prop(DISABLED, DISABLED);
	
		            that.wrapper
		                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(TRACK_MOUSE_DOWN).off(TRACK_MOUSE_UP);
	
		            that.wrapper
		                .find(DRAG_HANDLE)
		                .attr(TABINDEX, -1)
		                .off(MOUSE_UP)
		                .off(KEY_DOWN)
		                .off(CLICK)
		                .off(FOCUS)
		                .off(BLUR);
	
		            that.options.enabled = false;
		        },
	
		        _keydown: function (e, handle) {
		            var that = this,
		                selectionStartValue = that.options.selectionStart,
		                selectionEndValue = that.options.selectionEnd,
		                dragSelectionStart,
		                dragSelectionEnd,
		                activeHandleDrag;
	
		            if (e.keyCode in that._keyMap) {
	
		                that._clearTooltipTimeout();
	
		                if (handle == "firstHandle") {
		                    activeHandleDrag = that._activeHandleDrag = that._firstHandleDrag;
		                    selectionStartValue = that._keyMap[e.keyCode](selectionStartValue);
	
		                    if (selectionStartValue > selectionEndValue) {
		                        selectionEndValue = selectionStartValue;
		                    }
		                } else {
		                    activeHandleDrag = that._activeHandleDrag = that._lastHandleDrag;
		                    selectionEndValue = that._keyMap[e.keyCode](selectionEndValue);
	
		                    if (selectionStartValue > selectionEndValue) {
		                        selectionStartValue = selectionEndValue;
		                    }
		                }
	
		                that._setValueInRange(round(selectionStartValue), round(selectionEndValue));
	
		                dragSelectionStart = Math.max(selectionStartValue, that.options.selectionStart);
		                dragSelectionEnd = Math.min(selectionEndValue, that.options.selectionEnd);
	
		                activeHandleDrag.selectionEnd = Math.max(dragSelectionEnd, that.options.selectionStart);
		                activeHandleDrag.selectionStart = Math.min(dragSelectionStart, that.options.selectionEnd);
	
		                activeHandleDrag._updateTooltip(that.value()[that._activeHandle]);
	
		                e.preventDefault();
		            }
		        },
	
		        _update: function (selectionStart, selectionEnd) {
		            var that = this,
		                values = that.value();
	
		            var change = values[0] != selectionStart || values[1] != selectionEnd;
	
		            that.value([selectionStart, selectionEnd]);
	
		            if (change) {
		                that.trigger(CHANGE, {
		                    values: [selectionStart, selectionEnd],
		                    value: [selectionStart, selectionEnd]
		                });
		            }
		        },
	
		        value: function(value) {
		            if (value && value.length) {
		                return this._value(value[0], value[1]);
		            } else {
		                return this._value();
		            }
		        },
	
		        _value: function(start, end) {
		            var that = this,
		                options = that.options,
		                selectionStart = options.selectionStart,
		                selectionEnd = options.selectionEnd;
	
		            if (isNaN(start) && isNaN(end)) {
		                return [selectionStart, selectionEnd];
		            } else {
		                start = round(start);
		                end = round(end);
		            }
	
		            if (start >= options.min && start <= options.max &&
		                end >= options.min && end <= options.max && start <= end) {
		                if (selectionStart != start || selectionEnd != end) {
		                    that.element.find("input")
		                        .eq(0).prop("value", formatValue(start))
		                        .end()
		                        .eq(1).prop("value", formatValue(end));
	
		                    options.selectionStart = start;
		                    options.selectionEnd = end;
		                    that._refresh();
		                    that._refreshAriaAttr(start, end);
		                }
		            }
		        },
	
		        values: function (start, end) {
		            if (isArray(start)) {
		                return this._value(start[0], start[1]);
		            } else {
		                return this._value(start, end);
		            }
		        },
	
		        _refresh: function() {
		            var that = this,
		                options = that.options;
	
		            that.trigger(MOVE_SELECTION, {
		                values: [options.selectionStart, options.selectionEnd],
		                value: [options.selectionStart, options.selectionEnd]
		            });
	
		            if (options.selectionStart == options.max && options.selectionEnd == options.max) {
		                that._setZIndex("firstHandle");
		            }
		        },
	
		        _refreshAriaAttr: function(start, end) {
		            var that = this,
		                dragHandles = that.wrapper.find(DRAG_HANDLE),
		                drag = that._activeHandleDrag,
		                formattedValue;
	
		            formattedValue = that._getFormattedValue([start, end], drag);
	
		            dragHandles.eq(0).attr("aria-valuenow", start);
		            dragHandles.eq(1).attr("aria-valuenow", end);
		            dragHandles.attr("aria-valuetext", formattedValue);
		        },
	
		        _setValueInRange: function (selectionStart, selectionEnd) {
		            var options = this.options;
	
		            selectionStart = math.max(math.min(selectionStart, options.max), options.min);
	
		            selectionEnd = math.max(math.min(selectionEnd, options.max), options.min);
	
		            if (selectionStart == options.max && selectionEnd == options.max) {
		                this._setZIndex("firstHandle");
		            }
	
		            this._update(math.min(selectionStart, selectionEnd), math.max(selectionStart, selectionEnd));
		        },
	
		        _setZIndex: function (type) {
		            this.wrapper.find(DRAG_HANDLE).each(function (index) {
		                $(this).css("z-index", type == "firstHandle" ? 1 - index : index);
		            });
		        },
	
		        _formResetHandler: function () {
		            var that = this,
		                options = that.options;
	
		            setTimeout(function () {
		                var inputs = that.element.find("input");
		                var start = inputs[0].value;
		                var end = inputs[1].value;
		                that.values(start === "" || isNaN(start) ? options.min : start, end === "" || isNaN(end) ? options.max : end);
		            });
		        },
	
		        destroy: function() {
		            var that = this;
	
		            SliderBase.fn.destroy.call(that);
	
		            that.wrapper.off(NS)
		                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(NS)
		                .end()
		                .find(DRAG_HANDLE).off(NS);
	
		            that._firstHandleDrag.draggable.destroy();
		            that._lastHandleDrag.draggable.destroy();
		        }
		    });
	
		    RangeSlider.Selection = function (dragHandles, that, options) {
		        function moveSelection(value) {
		            value = value || [];
		            var selectionStartValue = value[0] - options.min,
		                selectionEndValue = value[1] - options.min,
		                selectionStartIndex = math.ceil(round(selectionStartValue / options.smallStep)),
		                selectionEndIndex = math.ceil(round(selectionEndValue / options.smallStep)),
		                selectionStart = that._pixelSteps[selectionStartIndex],
		                selectionEnd = that._pixelSteps[selectionEndIndex],
		                halfHandle = parseInt(that._outerSize(dragHandles.eq(0)) / 2, 10),
		                rtlCorrection = that._isRtl ? 2 : 0;
	
		            dragHandles.eq(0).css(that._position, selectionStart - halfHandle - rtlCorrection)
		                       .end()
		                       .eq(1).css(that._position, selectionEnd - halfHandle - rtlCorrection);
	
		            makeSelection(selectionStart, selectionEnd);
		        }
	
		        function makeSelection(selectionStart, selectionEnd) {
		            var selection,
		                selectionPosition,
		                selectionDiv = that._trackDiv.find(".k-slider-selection");
	
		            selection = math.abs(selectionStart - selectionEnd);
	
		            selectionDiv[that._sizeFn](selection);
		            if (that._isRtl) {
		                selectionPosition = math.max(selectionStart, selectionEnd);
		                selectionDiv.css("right", that._maxSelection - selectionPosition - 1);
		            } else {
		                selectionPosition = math.min(selectionStart, selectionEnd);
		                selectionDiv.css(that._position, selectionPosition - 1);
		            }
		        }
	
		        moveSelection(that.value());
	
		        that.bind([ CHANGE, SLIDE, MOVE_SELECTION ], function (e) {
		            moveSelection(e.values);
		        });
		    };
	
		    kendo.ui.plugin(RangeSlider);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1025);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1025:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "button",
		    name: "Button",
		    category: "web",
		    description: "The Button widget displays styled buttons.",
		    depends: [ "core" ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        proxy = $.proxy,
		        keys = kendo.keys,
		        CLICK = "click",
		        KBUTTON = "k-button",
		        KBUTTONICON = "k-button-icon",
		        KBUTTONICONTEXT = "k-button-icontext",
		        NS = ".kendoButton",
		        DISABLED = "disabled",
		        DISABLEDSTATE = "k-state-disabled",
		        FOCUSEDSTATE = "k-state-focused",
		        SELECTEDSTATE = "k-state-active";
	
		    var Button = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.wrapper = that.element;
		            options = that.options;
	
		            element.addClass(KBUTTON).attr("role", "button");
	
		            options.enable = options.enable && !element.attr(DISABLED);
		            that.enable(options.enable);
	
		            if (options.enable) {
		                that._tabindex();
		            }
	
		            that.iconElement();
	
		            element
		                .on(CLICK + NS, proxy(that._click, that))
		                .on("focus" + NS, proxy(that._focus, that))
		                .on("blur" + NS, proxy(that._blur, that))
		                .on("keydown" + NS, proxy(that._keydown, that))
		                .on("keyup" + NS, proxy(that._keyup, that));
	
		            kendo.notify(that);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.wrapper.off(NS);
	
		            Widget.fn.destroy.call(that);
		        },
	
		        events: [
		            CLICK
		        ],
	
		        options: {
		            name: "Button",
		            icon: "",
		            iconClass: "",
		            spriteCssClass: "",
		            imageUrl: "",
		            enable: true
		        },
	
		        _isNativeButton: function() {
		            return this.element.prop("tagName").toLowerCase() == "button";
		        },
	
		        _click: function(e) {
		            if (this.options.enable) {
		                if (this.trigger(CLICK, { event: e })) {
		                    e.preventDefault();
		                }
		            }
		        },
	
		        _focus: function() {
		            if (this.options.enable) {
		                this.element.addClass(FOCUSEDSTATE);
		            }
		        },
	
		        _blur: function() {
		            var that = this;
		            that.element.removeClass(FOCUSEDSTATE);
		            setTimeout(function() {
		                that.element.removeClass(SELECTEDSTATE);
		            });
		        },
	
		        _keydown: function(e) {
		            var that = this;
		            if (e.keyCode == keys.ENTER || e.keyCode == keys.SPACEBAR) {
		                if (that.options.enable) {
		                    that.element.addClass(SELECTEDSTATE);
		                }
	
		                if (!that._isNativeButton()) {
		                    if (e.keyCode == keys.SPACEBAR) {
		                        e.preventDefault();
		                    }
		                    that._click(e);
		                }
		            }
		        },
	
		        _keyup: function() {
		            this.element.removeClass(SELECTEDSTATE);
		        },
	
		        iconElement: function() {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                icon = options.icon,
		                iconClass = options.iconClass,
		                spriteCssClass = options.spriteCssClass,
		                imageUrl = options.imageUrl,
		                span, img, isEmpty;
	
		            if (spriteCssClass || imageUrl || icon || iconClass) {
		                isEmpty = true;
	
		                element.contents().filter(function() {
		                    return (!$(this).hasClass("k-sprite") && !$(this).hasClass("k-icon") && !$(this).hasClass("k-image"));
		                }).each(function(idx, el){
		                    if (el.nodeType == 1 || el.nodeType == 3 && $.trim(el.nodeValue).length > 0) {
		                        isEmpty = false;
		                    }
		                });
	
		                if (isEmpty) {
		                    element.addClass(KBUTTONICON);
		                } else {
		                    element.addClass(KBUTTONICONTEXT);
		                }
		            }
	
		            if (imageUrl) {
		                img = element.children("img.k-image").first();
		                if (!img[0]) {
		                    img = $('<img alt="icon" class="k-image" />').prependTo(element);
		                }
		                img.attr("src", imageUrl);
		            } else if (icon || iconClass) {
		                span = element.children("span.k-icon").first();
		                if (!span[0]) {
		                    span = $('<span></span>').prependTo(element);
		                }
		                span.attr("class", icon ? "k-icon k-i-" + icon : iconClass);
		            } else if (spriteCssClass) {
		                span = element.children("span.k-sprite").first();
		                if (!span[0]) {
		                    span = $('<span class="k-sprite"></span>').prependTo(element);
		                }
		                span.addClass(spriteCssClass);
		            }
		        },
	
		        enable: function(enable) {
		            var that = this,
		                element = that.element;
	
		            if (enable === undefined) {
		                enable = true;
		            }
	
		            enable = !!enable;
		            that.options.enable = enable;
		            element.toggleClass(DISABLEDSTATE, !enable)
		                   .attr("aria-disabled", !enable)
		                   .attr(DISABLED, !enable);
	
		            if (enable) {
		                that._tabindex();
		            }
	
		            // prevent 'Unspecified error' in IE when inside iframe
		            try {
		                element.blur();
		            } catch (err) {
		            }
		        }
		    });
	
		    kendo.ui.plugin(Button);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1216);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1216:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1036) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "menu",
		    name: "Menu",
		    category: "web",
		    description: "The Menu widget displays hierarchical data as a multi-level menu.",
		    depends: [ "popup" ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        activeElement = kendo._activeElement,
		        touch = (kendo.support.touch && kendo.support.mobileOS),
		        MOUSEDOWN = "mousedown",
		        CLICK = "click",
		        DELAY = 30,
		        SCROLLSPEED = 50,
		        extend = $.extend,
		        proxy = $.proxy,
		        each = $.each,
		        template = kendo.template,
		        keys = kendo.keys,
		        Widget = ui.Widget,
		        excludedNodesRegExp = /^(ul|a|div)$/i,
		        NS = ".kendoMenu",
		        IMG = "img",
		        OPEN = "open",
		        MENU = "k-menu",
		        LINK = "k-link k-menu-link",
		        LINK_SELECTOR = ".k-link",
		        LAST = "k-last",
		        CLOSE = "close",
		        TIMER = "timer",
		        FIRST = "k-first",
		        IMAGE = "k-image",
		        SELECT = "select",
		        ZINDEX = "zIndex",
		        ACTIVATE = "activate",
		        DEACTIVATE = "deactivate",
		        POINTERDOWN = "touchstart" + NS + " MSPointerDown" + NS + " pointerdown" + NS,
		        pointers = kendo.support.pointers,
		        msPointers = kendo.support.msPointers,
		        allPointers = msPointers || pointers,
		        TOUCHSTART = kendo.support.touch ? "touchstart" : "",
		        MOUSEENTER = pointers ? "pointerover" : (msPointers ? "MSPointerOver" : "mouseenter"),
		        MOUSELEAVE = pointers ? "pointerout" : (msPointers ? "MSPointerOut" : "mouseleave"),
		        MOUSEWHEEL = "DOMMouseScroll" + NS + " mousewheel" + NS,
		        RESIZE = kendo.support.resize + NS,
		        SCROLLWIDTH = "scrollWidth",
		        SCROLLHEIGHT = "scrollHeight",
		        OFFSETWIDTH = "offsetWidth",
		        OFFSETHEIGHT = "offsetHeight",
		        POPUP_ID_ATTR = "group",
		        POPUP_OPENER_ATTR = "groupparent",
		        DOCUMENT_ELEMENT = $(document.documentElement),
		        KENDOPOPUP = "kendoPopup",
		        DEFAULTSTATE = "k-state-default",
		        HOVERSTATE = "k-state-hover",
		        FOCUSEDSTATE = "k-state-focused",
		        DISABLEDSTATE = "k-state-disabled",
		        SELECTEDSTATE = "k-state-selected",
		        menuSelector = ".k-menu",
		        groupSelector = ".k-menu-group",
		        animationContainerSelector = ".k-animation-container",
		        popupSelector = groupSelector + "," + animationContainerSelector,
		        allItemsSelector = ":not(.k-list) > .k-item",
		        disabledSelector = ".k-item.k-state-disabled",
		        itemSelector = ".k-item",
		        availableItemsSelector = ".k-item:not(.k-state-disabled)",
		        linkSelector = ".k-item:not(.k-state-disabled) > .k-link",
		        exclusionSelector = ":not(.k-item.k-separator)",
		        nextSelector = itemSelector + exclusionSelector + ":eq(0)",
		        lastSelector = itemSelector + exclusionSelector + ":last",
		        templateSelector = "div:not(.k-animation-container,.k-list-container)",
		        scrollButtonSelector = ".k-menu-scroll-button",
		        touchPointerTypes = { "2": 1, "touch": 1 },
	
		        templates = {
		            content: template(
		                "<div #= contentCssAttributes(item) # tabindex='-1'>#= content(item) #</div>"
		            ),
		            group: template(
		                "<ul class='#= groupCssClass(group) #'#= groupAttributes(group) # role='menu' aria-hidden='true'>" +
		                    "#= renderItems(data) #" +
		                "</ul>"
		            ),
		            itemWrapper: template(
		                "<#= tag(item) # class='#= textClass(item) #'#= textAttributes(item) #>" +
		                    "#= image(data) ##= sprite(item) ##= text(item) #" +
		                    "#= arrow(data) #" +
		                "</#= tag(item) #>"
		            ),
		            item: template(
		                "<li class='#= wrapperCssClass(group, item) #' #= itemCssAttributes(item) # role='menuitem'  #=item.items ? \"aria-haspopup='true'\": \"\"#" +
		                    "#=item.enabled === false ? \"aria-disabled='true'\" : ''#>" +
		                    "#= itemWrapper(data) #" +
		                    "# if (item.items) { #" +
		                    "#= subGroup({ items: item.items, menu: menu, group: { expanded: item.expanded } }) #" +
		                    "# } else if (item.content || item.contentUrl) { #" +
		                    "#= renderContent(data) #" +
		                    "# } #" +
		                "</li>"
		            ),
		            scrollButton: template(
		                "<span class='k-button k-button-icon k-menu-scroll-button k-scroll-#= direction #' unselectable='on'>" +
		                "<span class='k-icon k-i-arrow-60-#= direction #'></span></span>"
		            ),
		            image: template("<img #= imageCssAttributes(item) # alt='' src='#= item.imageUrl #' />"), // class='k-image'
		            arrow: template("<span class='#= arrowClass(item, group) #'></span>"),
		            sprite: template("<span class='k-sprite #= spriteCssClass #'></span>"),
		            empty: template("")
		        },
	
		        rendering = {
	
		            wrapperCssClass: function (group, item) {
		                var result = "k-item",
		                    index = item.index;
	
		                if (item.enabled === false) {
		                    result += " k-state-disabled";
		                } else {
		                    result += " k-state-default";
		                }
	
		                if (group.firstLevel && index === 0) {
		                    result += " k-first";
		                }
	
		                if (index == group.length-1) {
		                    result += " k-last";
		                }
	
		                if (item.cssClass) {
		                    result += " " + item.cssClass;
		                }
	
		                if(item.attr && item.attr.hasOwnProperty("class")) {
		                    result += " " + item.attr["class"];
		                }
	
		                if(item.selected) {
		                    result += " " + SELECTEDSTATE;
		                }
	
		                return result;
		            },
	
		            itemCssAttributes: function (item) {
		                var result = "";
		                var attributes = item.attr || {};
	
		                for (var attr in attributes) {
		                    if(attributes.hasOwnProperty(attr) && attr !== "class") {
		                        result += attr + "=\"" + attributes[attr] + "\" ";
		                    }
		                }
	
		                return result;
		            },
	
		            imageCssAttributes: function (item) {
		                var result = "";
		                var attributes = item.imageAttr || {};
	
		                if (!attributes['class']) {
		                    attributes['class'] = IMAGE;
		                } else {
		                    attributes['class'] += " " + IMAGE;
		                }
	
		                for (var attr in attributes) {
		                    if(attributes.hasOwnProperty(attr)) {
		                        result += attr + "=\"" + attributes[attr] + "\" ";
		                    }
		                }
	
		                return result;
		            },
	
		            contentCssAttributes: function (item) {
		                var result = "";
		                var attributes = item.contentAttr || {};
		                var defaultClasses = "k-content k-group k-menu-group";
	
		                if (!attributes['class']) {
		                    attributes['class'] = defaultClasses;
		                } else {
		                    attributes['class'] += " " + defaultClasses;
		                }
	
		                for (var attr in attributes) {
		                    if(attributes.hasOwnProperty(attr)) {
		                        result += attr + "=\"" + attributes[attr] + "\" ";
		                    }
		                }
	
		                return result;
		            },
	
		            textClass: function() {
		                return LINK;
		            },
	
		            textAttributes: function(item) {
		                return item.url ? " href='" + item.url + "'" : "";
		            },
	
		            arrowClass: function(item, group) {
		                var result = "k-icon";
	
		                if (group.horizontal) {
		                    result += " k-i-arrow-60-down";
		                } else {
		                    result += " k-i-arrow-60-right";
		                }
	
		                return result;
		            },
	
		            text: function(item) {
		                return item.encoded === false ? item.text : kendo.htmlEncode(item.text);
		            },
	
		            tag: function(item) {
		                return item.url ? "a" : "span";
		            },
	
		            groupAttributes: function(group) {
		                return group.expanded !== true ? " style='display:none'" : "";
		            },
	
		            groupCssClass: function() {
		                return "k-group k-menu-group";
		            },
	
		            content: function(item) {
		                return item.content ? item.content : "&nbsp;";
		            }
		        };
	
		    function getEffectDirection(direction, root) {
		        direction = direction.split(" ")[!root+0] || direction;
		        return direction.replace("top", "up").replace("bottom", "down");
		    }
	
		    function parseDirection(direction, root, isRtl) {
		        direction = direction.split(" ")[!root+0] || direction;
		        var output = { origin: ["bottom", (isRtl ? "right" : "left")], position: ["top", (isRtl ? "right" : "left")] },
		            horizontal = /left|right/.test(direction);
	
		        if (horizontal) {
		            output.origin = [ "top", direction ];
		            output.position[1] = kendo.directions[direction].reverse;
		        } else {
		            output.origin[0] = direction;
		            output.position[0] = kendo.directions[direction].reverse;
		        }
	
		        output.origin = output.origin.join(" ");
		        output.position = output.position.join(" ");
	
		        return output;
		    }
	
		    function contains(parent, child) {
		        try {
		            return $.contains(parent, child);
		        } catch (e) {
		            return false;
		        }
		    }
	
		    function updateItemClasses (item) {
		        item = $(item);
	
		        item.addClass("k-item")
		            .children(IMG)
		            .addClass(IMAGE);
		        item
		            .children("a")
		            .addClass(LINK)
		            .children(IMG)
		            .addClass(IMAGE);
		        item
		            .filter(":not([disabled])")
		            .addClass(DEFAULTSTATE);
		        item
		            .filter(".k-separator")
		            .empty()
		            .append("&nbsp;");
		        item
		            .filter("li[disabled]")
		            .addClass(DISABLEDSTATE)
		            .removeAttr("disabled")
		            .attr("aria-disabled", true);
	
		        if (!item.filter("[role]").length) {
		            item.attr("role", "menuitem");
		        }
	
		        if (!item.children(LINK_SELECTOR).length) {
		            item
		                .contents()      // exclude groups, real links, templates and empty text nodes
		                .filter(function() { return (!this.nodeName.match(excludedNodesRegExp) && !(this.nodeType == 3 && !$.trim(this.nodeValue))); })
		                .wrapAll("<span class='" + LINK + "'/>");
		        }
	
		        updateArrow(item);
		        updateFirstLast(item);
		    }
	
		    function updateArrow (item) {
		        item = $(item);
	
		        item.find("> .k-link > [class*=k-i-arrow-60]:not(.k-sprite)").remove();
	
		        item.filter(":has(.k-menu-group)")
		            .children(".k-link:not(:has([class*=k-i-arrow]:not(.k-sprite)))")
		            .each(function () {
		                var item = $(this),
		                    arrowCssClass = getArrowCssClass(item);
	
		                item.append("<span class='k-icon" + arrowCssClass + " k-menu-expand-arrow'/>");
		            });
		    }
	
		    function getArrowCssClass (item) {
		        var arrowCssClass,
		            parent = item.parent().parent(),
		            isRtl = kendo.support.isRtl(parent);
	
		        if (parent.hasClass(MENU + "-horizontal")) {
		            arrowCssClass = " k-i-arrow-60-down";
		        } else {
		            if (isRtl) {
		                arrowCssClass = " k-i-arrow-60-left";
		            }
		            else {
		                arrowCssClass = " k-i-arrow-60-right";
		            }
		        }
		        return arrowCssClass;
		    }
	
		    function updateFirstLast (item) {
		        item = $(item);
	
		        item.filter(".k-first:not(:first-child)").removeClass(FIRST);
		        item.filter(".k-last:not(:last-child)").removeClass(LAST);
		        item.filter(":first-child").addClass(FIRST);
		        item.filter(":last-child").addClass(LAST);
		    }
	
		    function updateHasAriaPopup (parents) {
		        if (parents && parents.length) {
		            for (var index in parents) {
		                var parentLi = parents.eq(index);
		                if (parentLi.find("ul").length) {
		                    parentLi.attr("aria-haspopup", true);
		                } else {
		                    parentLi.removeAttr("aria-haspopup");
		                }
		            }
		        }
		    }
	
		    function getParentLiItems(group) {
		        if (!group.hasClass(MENU)) {
		            return group.parentsUntil("." + MENU, "li");
		        }
		    }
	
		    function storeItemSelectEventHandler (element, options) {
		        var selectHandler = getItemSelectEventHandler(options);
		        if(selectHandler) {
		            setItemData(element, selectHandler);
		        }
	
		        if (options.items) {
		            $(element).children("ul").children("li").each(function(i){
		                storeItemSelectEventHandler(this, options.items[i]);
		            });
		        }
		    }
	
		    function setItemData (element, selectHandler) {
		        $(element).children(".k-link").data({
		            selectHandler : selectHandler
		        });
		    }
	
		    function getItemSelectEventHandler (options) {
		        var selectHandler = options.select,
		            isFunction = kendo.isFunction;
	
		        if (selectHandler && isFunction(selectHandler)) {
		            return selectHandler;
		        }
		        return null;
		    }
	
		    function popupOpenerSelector(id){
		        return id ? "li[data-groupparent='" + id + "']" : "li[data-groupparent]";
		    }
		    function popupGroupSelector(id) {
		        return id ? "ul[data-group='" + id + "']" : "ul[data-group]";
		    }
		    function getChildPopups (currentPopup, overflowWrapper) {
		        var childPopupOpener = currentPopup.find(popupOpenerSelector());
		        var result = [];
		        childPopupOpener.each(function(i, opener){
		            opener = $(opener);
		            var popupId = opener.data(POPUP_OPENER_ATTR);
		            var popup = currentPopup;
		            while(popupId) {
		                popup = overflowWrapper.find(popupGroupSelector(popupId) + ":visible");
		                if (popup.length) {
		                    result.push(popup);
		                }
		                opener = popup.find(popupOpenerSelector());
		                popupId = opener.data(POPUP_OPENER_ATTR);
		            }
		        });
	
		        return result;
		    }
	
		    function popupParentItem(popupElement, overflowWrapper) {
		        var popupId = popupElement.data(POPUP_ID_ATTR);
		        return popupId ? overflowWrapper.find(popupOpenerSelector(popupId)) : $([]);
		    }
	
		    function itemPopup(item, overflowWrapper) {
		        var popupId = item.data(POPUP_OPENER_ATTR);
		        return popupId ? overflowWrapper.children(animationContainerSelector).children(popupGroupSelector(popupId)) : $([]);
		    }
	
		    function overflowMenuParents(current, overflowWrapper) {
		        var parents = [];
		        var getParents = function(item){
		            while (item.parentNode && !overflowWrapper.is(item.parentNode)) {
		                parents.push(item.parentNode);
		                item = item.parentNode;
		            }
		        };
		        var elem = current[0] || current;
		        getParents(elem);
		        var last = parents[parents.length - 1];
		        while($(last).is(animationContainerSelector)){
		            var popupElement = $(last).children("ul");
		            elem = popupParentItem(popupElement, overflowWrapper)[0];
		            if (!elem) {
		                break;
		            }
		            parents.push(elem);
		            getParents(elem);
		            last = parents[parents.length - 1];
		        }
		        return parents;
		    }
	
		    function mousewheelDelta(e) {
		        var delta = 0;
	
		        if (e.wheelDelta) {
		            delta = -e.wheelDelta / 120;
		            delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
		        }
	
		        if (e.detail) {
		            delta = Math.round(e.detail / 3);
		        }
	
		        return delta;
		    }
	
		    function parentsScroll(current, scrollDirection) {
		        var scroll = 0;
		        var parent = current.parentNode;
		        while(parent && !isNaN(parent[scrollDirection])) {
		            scroll += parent[scrollDirection];
		            parent = parent.parentNode;
		        }
		        return scroll;
		    }
	
		    function isPointerTouch(e){
		        return allPointers && e.originalEvent && e.originalEvent.pointerType in touchPointerTypes;
		    }
	
		    function isTouch(e){
		        var ev = e.originalEvent;
		        return touch && /touch/i.test(ev.type || "");
		    }
	
		    function removeSpacesBetweenItems(ul){
		        ul.contents().filter(function(){ return this.nodeName != "LI"; }).remove();
		    }
	
		    var Menu = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.wrapper = that.element;
		            options = that.options;
	
		            that._initData(options);
	
		            that._updateClasses();
	
		            that._animations(options);
	
		            that.nextItemZIndex = 100;
	
		            that._tabindex();
	
		            that._initOverflow(options);
	
		            that._attachMenuEventsHandlers();
	
		            if (options.openOnClick) {
		                that.clicked = false;
		            }
	
		            element.attr("role", "menubar");
	
		            if (element[0].id) {
		                that._ariaId = kendo.format("{0}_mn_active", element[0].id);
		            }
	
		            kendo.notify(that);
		        },
	
		        events: [
		            OPEN,
		            CLOSE,
		            ACTIVATE,
		            DEACTIVATE,
		            SELECT
		        ],
	
		        options: {
		            name: "Menu",
		            animation: {
		                open: {
		                    duration: 200
		                },
		                close: { // if close animation effects are defined, they will be used instead of open.reverse
		                    duration: 100
		                }
		            },
		            orientation: "horizontal",
		            direction: "default",
		            openOnClick: false,
		            closeOnClick: true,
		            hoverDelay: 100,
		            scrollable: false,
		            popupCollision: undefined
		        },
	
		        _initData: function(options) {
		            var that = this;
	
		            if (options.dataSource) {
		                that.angular("cleanup", function(){
		                    return {
		                        elements: that.element.children()
		                    };
		                });
		                that.element.empty();
		                that.append(options.dataSource, that.element);
		                that.angular("compile", function(){
		                    return {
		                        elements: that.element.children()
		                    };
		                });
		            }
		        },
	
		        _attachMenuEventsHandlers: function() {
		            var that = this;
		            var element = that.element;
		            var options = that.options;
		            var overflowWrapper = that._overflowWrapper();
	
		            (overflowWrapper || element).on(POINTERDOWN, itemSelector, proxy(that._focusHandler, that))
		                   .on(CLICK + NS, disabledSelector, false)
		                   .on(CLICK + NS, itemSelector, proxy(that._click , that))
		                   .on(POINTERDOWN + " " + MOUSEDOWN + NS, ".k-content", proxy(that._preventClose, that))
		                   .on(MOUSEENTER + NS, availableItemsSelector, proxy(that._mouseenter, that))
		                   .on(MOUSELEAVE + NS, availableItemsSelector, proxy(that._mouseleave, that))
		                   .on(MOUSEDOWN + NS, availableItemsSelector, proxy(that._mousedown, that))
		                   .on(TOUCHSTART + NS + " " + MOUSEENTER + NS + " " + MOUSELEAVE + NS + " " +
		                       MOUSEDOWN + NS + " " + CLICK + NS, linkSelector, proxy(that._toggleHover, that));
	
		            element.on("keydown" + NS, proxy(that._keydown, that))
		                   .on("focus" + NS, proxy(that._focus, that))
		                   .on("focus" + NS, ".k-content", proxy(that._focus, that))
		                   .on("blur" + NS, proxy(that._removeHoverItem, that))
		                   .on("blur" + NS, "[tabindex]", proxy(that._checkActiveElement, that));
	
		            if (overflowWrapper) {
		                overflowWrapper
		                    .on(MOUSELEAVE + NS, popupSelector, proxy(that._mouseleavePopup, that))
		                    .on(MOUSEENTER + NS, popupSelector, proxy(that._mouseenterPopup, that));
		            }
	
		            if (options.openOnClick) {
		                that._documentClickHandler = proxy(that._documentClick, that);
		                $(document).click(that._documentClickHandler);
		            }
		        },
	
		        _detachMenuEventsHandlers: function() {
		            var that = this;
		            var overflowWrapper = that._overflowWrapper();
	
		            if (overflowWrapper) {
		                overflowWrapper.off(NS);
		            }
	
		            that.element.off(NS);
	
		            if (that._documentClickHandler) {
		                $(document).unbind("click", that._documentClickHandler);
		            }
		        },
	
		        _initOverflow: function(options) {
		            var that = this;
		            var isHorizontal = options.orientation == "horizontal";
		            var backwardBtn, forwardBtn;
	
		            if (options.scrollable) {
		                that._openedPopups = {};
		                that._scrollWrapper = that.element.wrap("<div class='k-menu-scroll-wrapper " + options.orientation + "'></div>").parent();
		                if (isHorizontal) {
		                    removeSpacesBetweenItems(that.element);
		                }
	
		                backwardBtn = $(templates.scrollButton({direction: isHorizontal ? "left" : "up"}));
		                forwardBtn = $(templates.scrollButton({direction: isHorizontal ? "right": "down"}));
		                backwardBtn.add(forwardBtn).appendTo(that._scrollWrapper);
	
		                that._initScrolling(that.element, backwardBtn, forwardBtn, isHorizontal);
	
		                var initialWidth = that.element.outerWidth();
		                var initialCssWidth = that.element[0].style.width;
		                initialCssWidth = initialCssWidth === "auto" ? "" : initialCssWidth;
	
		                if (isHorizontal) {
		                    $(window).on(RESIZE, kendo.throttle(function(){
		                        that._setOverflowWrapperWidth(initialWidth, initialCssWidth);
		                        that._toggleScrollButtons(that.element, backwardBtn, forwardBtn, isHorizontal);
		                    }, 100));
		                }
	
		                that._setOverflowWrapperWidth(initialWidth, initialCssWidth);
		                that._toggleScrollButtons(that.element, backwardBtn, forwardBtn, isHorizontal);
		            }
		        },
	
		        _overflowWrapper: function(){
		            return this._scrollWrapper || this._popupsWrapper;
		        },
	
		        _setOverflowWrapperWidth: function(initialWidth, initialCssWidth) {
		            var that = this;
		            var wrapperCssWidth = that._scrollWrapper.css("width");
	
		            that._scrollWrapper.css({width: ""});
		            var wrapperWidth = that._scrollWrapper.outerWidth();
		            that._scrollWrapper.css({ width: wrapperCssWidth });
	
		            var menuWidth = that.element.outerWidth();
		            var borders = that.element[0].offsetWidth - that.element[0].clientWidth;
	
		            if (menuWidth != wrapperWidth && wrapperWidth > 0) {
		                var width = initialCssWidth ? Math.min(initialWidth, wrapperWidth) : wrapperWidth;
		                that.element.width(width - borders);
		                that._scrollWrapper.width(width);
		            }
		        },
	
		        _reinitOverflow: function(options) {
		            var that = this;
		            var overflowChanged = ((options.scrollable && !that.options.scrollable) || (!options.scrollable && that.options.scrollable)) ||
		                (options.scrollable && that.options.scrollable && options.scrollable.distance != that.options.scrollable.distance) ||
		                options.orientation != that.options.orientation;
	
		            if (overflowChanged) {
		                that._detachMenuEventsHandlers();
		                that._destroyOverflow();
		                that._initOverflow(options);
		                that._attachMenuEventsHandlers();
		            }
		        },
	
		        _destroyOverflow: function() {
		            var that = this;
		            var overflowWrapper = that._overflowWrapper();
		            if(overflowWrapper) {
		                overflowWrapper.off(NS);
		                overflowWrapper.find(scrollButtonSelector).off(NS).remove();
		                overflowWrapper.children(animationContainerSelector).each(function(i, popupWrapper){
		                    var ul = $(popupWrapper).children(groupSelector);
		                    ul.off(MOUSEWHEEL);
		                    var popupParentLi = popupParentItem(ul, overflowWrapper);
		                    if (popupParentLi.length) {
		                        popupParentLi.append(popupWrapper);
		                    }
		                });
	
		                overflowWrapper.find(popupOpenerSelector()).removeAttr("data-groupparent");
		                overflowWrapper.find(popupGroupSelector()).removeAttr("data-group");
		                that.element.off(MOUSEWHEEL);
		                $(window).off(RESIZE);
		                overflowWrapper.contents().unwrap();
	
		                that._scrollWrapper = that._popupsWrapper = that._openedPopups = undefined;
		            }
		        },
	
		        _initScrolling: function(scrollElement, backwardBtn, forwardBtn, isHorizontal) {
		            var that = this;
		            var scrollable = that.options.scrollable;
		            var distance =  $.isNumeric(scrollable.distance) ? scrollable.distance : SCROLLSPEED;
		            var mouseWheelDistance = distance / 2;
		            var backward = "-=" + distance;
		            var forward = "+=" + distance;
		            var backwardDouble = "-=" + distance * 2;
		            var forwardDouble = "+=" + distance * 2;
		            var scrolling = false;
		            var touchEvents = false;
	
		            var scroll = function(value) {
		                var scrollValue = isHorizontal ? {"scrollLeft": value} : { "scrollTop": value };
		                scrollElement.finish().animate(scrollValue, "fast", "linear", function () {
		                    if (scrolling) {
		                        scroll(value);
		                    }
		                });
		                that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
		            };
	
		            var mouseenterHandler = function(e) {
		                if (!scrolling && !touchEvents) {
		                    scroll(e.data.direction);
		                    scrolling = true;
		                }
		            };
	
		            var mousedownHandler = function(e) {
		                var scrollValue = isHorizontal ? {"scrollLeft": e.data.direction} : { "scrollTop": e.data.direction };
		                touchEvents = isTouch(e) || isPointerTouch(e);
		                scrollElement.stop().animate(scrollValue, "fast", "linear", function(){
		                    if (!touchEvents) {
		                        $(e.currentTarget).trigger(MOUSEENTER);
		                    } else {
		                         that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
		                         scrolling = true;
		                    }
		                });
		                scrolling = false;
	
		                e.stopPropagation();
		                e.preventDefault();
		            };
	
		            backwardBtn.on(MOUSEENTER + NS, {direction: backward}, mouseenterHandler)
		                .on(kendo.eventMap.down + NS, {direction: backwardDouble}, mousedownHandler);
	
		            forwardBtn.on(MOUSEENTER + NS, {direction: forward}, mouseenterHandler)
		                .on(kendo.eventMap.down + NS, {direction: forwardDouble}, mousedownHandler);
	
		            backwardBtn.add(forwardBtn)
		                .on(MOUSELEAVE + NS, function() {
		                    scrollElement.stop();
		                    scrolling = false;
		                    that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
		                });
	
		            scrollElement.on(MOUSEWHEEL, function(e){
		                if (!e.ctrlKey && !e.shiftKey && !e.altKey) {
		                    var wheelDelta = mousewheelDelta(e.originalEvent);
		                    var scrollSpeed = Math.abs(wheelDelta) * mouseWheelDistance;
		                    var value = (wheelDelta > 0 ? "+=" : "-=") + scrollSpeed;
		                    var scrollValue = isHorizontal ? {"scrollLeft": value} : {"scrollTop": value };
	
		                    that._closeChildPopups(scrollElement);
	
		                    scrollElement.finish().animate(scrollValue, "fast", "linear", function(){
		                        that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
		                    });
		                    e.preventDefault();
		                }
		            });
		        },
	
		        _toggleScrollButtons: function(scrollElement, backwardBtn, forwardBtn, horizontal) {
		            var currentScroll = horizontal ? scrollElement.scrollLeft() : scrollElement.scrollTop();
		            var scrollSize = horizontal ? SCROLLWIDTH : SCROLLHEIGHT;
		            var offset = horizontal ? OFFSETWIDTH : OFFSETHEIGHT;
	
		            backwardBtn.toggle(currentScroll !== 0);
		            forwardBtn.toggle(currentScroll < scrollElement[0][scrollSize] - scrollElement[0][offset] - 1);
		        },
	
		        setOptions: function(options) {
		            var animation = this.options.animation;
	
		            this._animations(options);
	
		            options.animation = extend(true, animation, options.animation);
	
		            if ("dataSource" in options) {
		                this._initData(options);
		            }
	
		            this._updateClasses();
		            this._reinitOverflow(options);
	
		            Widget.fn.setOptions.call(this, options);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that._detachMenuEventsHandlers();
	
		            that._destroyOverflow();
	
		            kendo.destroy(that.element);
		        },
	
		        enable: function (element, enable) {
		            this._toggleDisabled(element, enable !== false);
	
		            return this;
		        },
	
		        disable: function (element) {
		            this._toggleDisabled(element, false);
	
		            return this;
		        },
	
		        append: function (item, referenceItem) {
		            referenceItem = this.element.find(referenceItem);
	
		            var inserted = this._insert(item, referenceItem, referenceItem.length ? referenceItem.find("> .k-menu-group, > .k-animation-container > .k-menu-group") : null);
	
		            each(inserted.items, function (i) {
		                inserted.group.append(this);
		                updateArrow(this);
		                storeItemSelectEventHandler(this, item[i] || item);
		            });
	
		            updateArrow(referenceItem);
		            updateFirstLast(inserted.group.find(".k-first, .k-last").add(inserted.items));
		            updateHasAriaPopup(getParentLiItems(inserted.group));
	
		            return this;
		        },
	
		        insertBefore: function (item, referenceItem) {
		            referenceItem = this.element.find(referenceItem);
	
		            var inserted = this._insert(item, referenceItem, referenceItem.parent());
	
		            each(inserted.items, function (i) {
		                referenceItem.before(this);
		                updateArrow(this);
		                updateFirstLast(this);
		                storeItemSelectEventHandler(this, item[i] || item);
		            });
	
		            updateFirstLast(referenceItem);
	
		            return this;
		        },
	
		        insertAfter: function (item, referenceItem) {
		            referenceItem = this.element.find(referenceItem);
	
		            var inserted = this._insert(item, referenceItem, referenceItem.parent());
	
		            each(inserted.items, function (i) {
		                referenceItem.after(this);
		                updateArrow(this);
		                updateFirstLast(this);
		                storeItemSelectEventHandler(this, item[i] || item);
		            });
	
		            updateFirstLast(referenceItem);
	
		            return this;
		        },
	
		        _insert: function (item, referenceItem, parent) {
		            var that = this,
		                items, groups;
	
		            if (!referenceItem || !referenceItem.length) {
		                parent = that.element;
		            }
	
		            var plain = $.isPlainObject(item),
		                groupData = {
		                    firstLevel: parent.hasClass(MENU),
		                    horizontal: parent.hasClass(MENU + "-horizontal"),
		                    expanded: true,
		                    length: parent.children().length
		                };
	
		            if (referenceItem && !parent.length) {
		                parent = $(Menu.renderGroup({ group: groupData })).appendTo(referenceItem);
		            }
	
		            if (plain || $.isArray(item)) { // is JSON
		                items = $($.map(plain ? [ item ] : item, function (value, idx) {
		                            if (typeof value === "string") {
		                                return $(value).get();
		                            } else {
		                                return $(Menu.renderItem({
		                                    group: groupData,
		                                    item: extend(value, { index: idx })
		                                })).get();
		                            }
		                        }));
		            } else {
		                if (typeof item == "string" && item.charAt(0) != "<") {
		                    items = that.element.find(item);
		                } else {
		                    items = $(item);
		                }
	
		                groups = items.find("> ul")
		                                .addClass("k-menu-group")
		                                .attr("role", "menu");
	
		                items = items.filter("li");
	
		                items.add(groups.find("> li")).each(function () {
		                    updateItemClasses(this);
		                });
		            }
	
		            return { items: items, group: parent };
		        },
	
		        remove: function (element) {
		            element = this.element.find(element);
	
		            var that = this,
		                parent = element.parentsUntil(that.element, allItemsSelector),
		                group = element.parent("ul:not(.k-menu)");
	
		            element.remove();
	
		            if (group && !group.children(allItemsSelector).length) {
		                var parentItems = getParentLiItems(group);
	
		                var container = group.parent(animationContainerSelector);
	
		                if (container.length) {
		                    container.remove();
		                } else {
		                    group.remove();
		                }
	
		                updateHasAriaPopup(parentItems);
		            }
	
		            if (parent.length) {
		                parent = parent.eq(0);
	
		                updateArrow(parent);
		                updateFirstLast(parent);
		            }
	
		            return that;
		        },
	
		        open: function (element) {
		            var that = this;
		            var options = that.options;
		            var horizontal = options.orientation == "horizontal";
		            var direction = options.direction;
		            var isRtl = kendo.support.isRtl(that.wrapper);
		            var overflowWrapper = that._overflowWrapper();
		            element = (overflowWrapper || that.element).find(element);
	
		            if (/^(top|bottom|default)$/.test(direction)) {
		                if (isRtl) {
		                    direction = horizontal ? (direction + " left").replace("default", "bottom") : "left";
		                } else {
		                    direction = horizontal ? (direction + " right").replace("default", "bottom") : "right";
		                }
		            }
	
		            var visiblePopups = ">.k-popup:visible,>.k-animation-container>.k-popup:visible";
		            var closePopup = function () {
		                var popup = $(this).data(KENDOPOPUP);
		                if (popup) {
		                    // Use the built-in close method to play the hoverDelay from the options
		                    that.close($(this).closest("li.k-item"), true);
		                }
		            };
	
		            element.siblings()
		                   .find(visiblePopups)
		                   .each(closePopup);
	
		            if (overflowWrapper) {
		                element.find(visiblePopups).each(closePopup);
		            }
	
		            if (that.options.openOnClick) {
		                that.clicked = true;
		            }
	
		            element.each(function () {
		                var li = $(this);
	
		                clearTimeout(li.data(TIMER));
	
		                li.data(TIMER, setTimeout(function () {
		                    var ul = li.find(".k-menu-group:first:hidden");
		                    var popup;
		                    var overflowPopup;
	
		                    if  (!ul[0] && overflowWrapper) {
		                        overflowPopup = that._getPopup(li);
		                        ul = overflowPopup && overflowPopup.element;
		                    }
		                    if (ul.is(":visible")) {
		                        return;
		                    }
	
		                    if (ul[0] && that._triggerEvent({ item: li[0], type: OPEN }) === false) {
	
		                        if (!ul.find(".k-menu-group")[0] && ul.children(".k-item").length > 1) {
		                            var windowHeight = $(window).height(),
		                                setScrolling = function(){
		                                    ul.css({maxHeight: windowHeight - (kendo._outerHeight(ul) - ul.height()) - kendo.getShadows(ul).bottom, overflow: "auto"});
		                                };
	
		                            if (kendo.support.browser.msie && kendo.support.browser.version <= 7) {
		                                setTimeout(setScrolling, 0); // timeout required by IE7
		                            } else {
		                                setScrolling();
		                            }
		                        } else {
		                            ul.css({maxHeight: "", overflow: ""});
		                        }
	
		                        li.data(ZINDEX, li.css(ZINDEX));
		                        var nextZindex = that.nextItemZIndex++;
		                        li.css(ZINDEX, nextZindex);
	
		                        if (that.options.scrollable) {
		                            li.parent().siblings(scrollButtonSelector).css({zIndex: ++nextZindex});
		                        }
	
		                        popup = ul.data(KENDOPOPUP);
		                        var root = li.parent().hasClass(MENU),
		                            parentHorizontal = root && horizontal,
		                            directions = parseDirection(direction, root, isRtl),
		                            effects = options.animation.open.effects,
		                            openEffects = effects !== undefined ? effects : "slideIn:" + getEffectDirection(direction, root);
	
		                        if (!popup) {
		                            popup = ul.kendoPopup({
		                                activate: function() { that._triggerEvent({ item: this.wrapper.parent(), type: ACTIVATE }); },
		                                deactivate: function(e) {
		                                    e.sender.element // Restore opacity after fade.
		                                        .removeData("targetTransform")
		                                        .css({ opacity: "" });
		                                    that._triggerEvent({ item: this.wrapper.parent(), type: DEACTIVATE });
		                                },
		                                origin: directions.origin,
		                                position: directions.position,
		                                collision: options.popupCollision !== undefined ? options.popupCollision : (parentHorizontal ? "fit" : "fit flip"),
		                                anchor: li,
		                                appendTo: overflowWrapper || li,
		                                animation: {
		                                    open: extend(true, { effects: openEffects }, options.animation.open),
		                                    close: options.animation.close
		                                },
		                                open: proxy(that._popupOpen, that),
		                                close: function (e) {
		                                    var li = e.sender.wrapper.parent();
	
		                                    if (overflowWrapper) {
		                                        var popupId = e.sender.element.data(POPUP_ID_ATTR);
		                                        if (popupId) {
		                                            li = (overflowWrapper || that.element).find(popupOpenerSelector(popupId));
		                                        }
		                                        e.sender.wrapper.children(scrollButtonSelector).hide();
		                                    }
	
		                                    if (!that._triggerEvent({ item: li[0], type: CLOSE })) {
		                                        li.css(ZINDEX, li.data(ZINDEX));
		                                        li.removeData(ZINDEX);
	
		                                        if (that.options.scrollable) {
		                                            li.parent().siblings(scrollButtonSelector).css({zIndex: ""});
		                                        }
	
		                                        if (touch || allPointers || kendo.support.mouseAndTouchPresent) {
		                                            li.removeClass(HOVERSTATE);
		                                            that._removeHoverItem();
		                                        }
		                                    } else {
		                                        e.preventDefault();
		                                    }
		                                }
		                            }).data(KENDOPOPUP);
		                        } else {
		                            popup = ul.data(KENDOPOPUP);
		                            popup.options.origin = directions.origin;
		                            popup.options.position = directions.position;
		                            popup.options.animation.open.effects = openEffects;
		                        }
		                        ul.removeAttr("aria-hidden");
	
		                        that._configurePopupOverflow(popup, li);
	
		                        popup._hovered = true;
		                        popup.open();
	
		                        that._initPopupScrolling(popup);
		                    }
	
		                }, that.options.hoverDelay));
		            });
	
		            return that;
		        },
	
		        _configurePopupOverflow: function(popup, popupOpener) {
		            var that = this;
		           if (that.options.scrollable) {
		                that._wrapPopupElement(popup);
		                if (!popupOpener.attr("data-groupparent")) {
		                    var groupId = new Date().getTime();
		                    popupOpener.attr("data-groupparent", groupId);
		                    popup.element.attr("data-group", groupId);
		                }
		           }
		        },
	
		        _wrapPopupElement: function(popup){
		            if (!popup.element.parent().is(animationContainerSelector)) {
		                popup.wrapper = kendo.wrap(popup.element, popup.options.autosize)
		                    .css({
		                        overflow: "hidden",
		                        display: "block",
		                        position: "absolute"
		                    });
		            }
		        },
	
		        _initPopupScrolling: function(popup, isHorizontal, skipMouseEvents) {
		            var that = this;
	
		            if (that.options.scrollable && popup.element[0].scrollHeight > popup.element[0].offsetHeight) {
		                that._initPopupScrollButtons(popup, isHorizontal, skipMouseEvents);
		            }
		        },
	
		        _initPopupScrollButtons: function(popup, isHorizontal, skipMouseEvents) {
		            var that = this;
		            var scrollButtons = popup.wrapper.children(scrollButtonSelector);
		            var animation = that.options.animation;
		            var timeout = ((animation && animation.open && animation.open.duration) || 0) + DELAY;
		            setTimeout(function() {
		                if (!scrollButtons.length) {
		                    var backwardBtn = $(templates.scrollButton({direction: isHorizontal ? "left" : "up"}));
		                    var forwardBtn = $(templates.scrollButton({direction: isHorizontal ? "right": "down"}));
	
		                    scrollButtons = backwardBtn.add(forwardBtn).appendTo(popup.wrapper);
	
		                    that._initScrolling(popup.element, backwardBtn, forwardBtn, isHorizontal);
		                    if (!skipMouseEvents) {
		                        scrollButtons.on(MOUSEENTER + NS, function() {
		                            var overflowWrapper = that._overflowWrapper();
		                            $(getChildPopups(popup.element, overflowWrapper)).each(function(i, p){
		                                var popupOpener = overflowWrapper.find(popupOpenerSelector(p.data(POPUP_ID_ATTR)));
		                                that.close(popupOpener);
		                            });
		                        })
		                        .on(MOUSELEAVE + NS, function(){
		                            setTimeout(function(){
		                                if ($.isEmptyObject(that._openedPopups)) {
		                                    that._closeParentPopups(popup.element);
		                                }
		                            }, DELAY);
		                        });
		                    }
		                }
		                that._toggleScrollButtons(popup.element, scrollButtons.first(), scrollButtons.last(), isHorizontal);
		            }, timeout);
		        },
	
		        _popupOpen: function(e) {
		            if (!this._keyTriggered) {
		                e.sender.element.children("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
		            }
		            if (this.options.scrollable) {
		                this._setPopupHeight(e.sender);
		            }
		        },
	
		        _setPopupHeight: function(popup, isFixed){
		            var popupElement = popup.element;
		            var popups = popupElement.add(popupElement.parent(animationContainerSelector));
	
		            popups.height((popupElement.hasClass(MENU) && this._initialHeight) || "");
	
		            var location = popup._location(isFixed);
		            var windowHeight = $(window).height();
		            var popupOuterHeight = location.height;
		            var popupOffsetTop = isFixed ? 0 : Math.max(location.top, 0);
		            var scrollTop = isFixed ? 0 : parentsScroll(this._overflowWrapper()[0], "scrollTop");
		            var bottomScrollbar = window.innerHeight - windowHeight;
		            var maxHeight = windowHeight - kendo.getShadows(popupElement).bottom + bottomScrollbar;
		            var canFit = maxHeight + scrollTop > popupOuterHeight + popupOffsetTop;
	
		            if (!canFit) {
		                var height = Math.min(maxHeight, maxHeight - popupOffsetTop + scrollTop);
		                popups.css({overflow: "hidden", height: height + "px"});
		            }
		        },
	
		        close: function (items, dontClearClose) {
		            var that = this;
		            var overflowWrapper = that._overflowWrapper();
		            var element = (overflowWrapper || that.element);
	
		            items = element.find(items);
	
		            if (!items.length) {
		                items = element.find(">.k-item");
		            }
	
		            var hasChildPopupsHovered = function(currentPopup){
		                var result = false;
		                if ($.isEmptyObject(that._openedPopups)) {
		                    return result;
		                }
		                $(getChildPopups(currentPopup, overflowWrapper)).each(function(i, popup){
		                    result = !!that._openedPopups[popup.data(POPUP_ID_ATTR).toString()];
		                    return !result;
		                });
		                return result;
		            };
	
		            var isPopupMouseLeaved = function(opener) {
		                var groupId = opener.data(POPUP_OPENER_ATTR);
		                return (!overflowWrapper || !groupId || !that._openedPopups[groupId.toString()]);
		            };
	
		            items.each(function () {
		                var li = $(this);
	
		                if (!dontClearClose && that._isRootItem(li)) {
		                    that.clicked = false;
		                }
	
		                clearTimeout(li.data(TIMER));
	
		                li.data(TIMER, setTimeout(function () {
		                    var popup = that._getPopup(li);
		                    if (popup && (isPopupMouseLeaved(li) || that._forceClose)) {
		                        if (!that._forceClose && hasChildPopupsHovered(popup.element)) {
		                            return;
		                        }
	
		                        popup.close();
		                        popup.element.attr("aria-hidden", true);
	
		                        if (overflowWrapper) {
		                            if (that._forceClose && items.last().is(li[0])) {
		                                delete that._forceClose;
		                            }
		                        }
		                    }
		                }, that.options.hoverDelay));
		            });
	
		            return that;
		        },
	
		        _getPopup: function(li) {
		            var that = this;
		            var popup = li.find(".k-menu-group:not(.k-list-container):not(.k-calendar-container):first:visible").data(KENDOPOPUP);
		            var overflowWrapper = that._overflowWrapper();
	
		            if (!popup && overflowWrapper) {
		                var groupId = li.data(POPUP_OPENER_ATTR);
		                if (groupId) {
		                    var popupElement = overflowWrapper.find(popupGroupSelector(groupId));
		                    popup = popupElement.data(KENDOPOPUP);
		                }
		            }
		            return popup;
		        },
	
		        _toggleDisabled: function (items, enable) {
		            this.element.find(items).each(function () {
		                $(this)
		                    .toggleClass(DEFAULTSTATE, enable)
		                    .toggleClass(DISABLEDSTATE, !enable)
		                    .attr("aria-disabled", !enable);
		            });
		        },
	
		        _toggleHover: function(e) {
		            var target = $(kendo.eventTarget(e) || e.target).closest(allItemsSelector),
		                isEnter = e.type == MOUSEENTER || MOUSEDOWN.indexOf(e.type) !== -1;
	
		            target.siblings().removeClass(HOVERSTATE);
	
		            if (!target.parents("li." + DISABLEDSTATE).length) {
		                target.toggleClass(HOVERSTATE, isEnter || e.type == "mousedown" || e.type == "pointerover" || e.type == TOUCHSTART);
		            }
	
		            this._removeHoverItem();
		        },
	
		        _preventClose: function() {
		            if (!this.options.closeOnClick) {
		                this._closurePrevented = true;
		            }
		        },
	
		        _checkActiveElement: function(e) {
		            var that = this,
		                hoverItem = $(e ? e.currentTarget : this._hoverItem()),
		                target = that._findRootParent(hoverItem)[0];
	
		            if (!this._closurePrevented) {
		                setTimeout(function() {
		                    if (!document.hasFocus() || (!contains(target, kendo._activeElement()) && e && !contains(target, e.currentTarget))) {
		                        that.close(target);
		                    }
		                }, 0);
		            }
	
		            this._closurePrevented = false;
		        },
	
		        _removeHoverItem: function() {
		            var oldHoverItem = this._hoverItem();
	
		            if (oldHoverItem && oldHoverItem.hasClass(FOCUSEDSTATE)) {
		                oldHoverItem.removeClass(FOCUSEDSTATE);
		                this._oldHoverItem = null;
		            }
		        },
	
		        _updateClasses: function() {
		            var element = this.element,
		                nonContentGroupsSelector = ".k-menu-init div ul",
		                items;
	
		            element.removeClass("k-menu-horizontal k-menu-vertical");
		            element.addClass("k-widget k-reset k-header k-menu-init " + MENU).addClass(MENU + "-" + this.options.orientation);
	
		            element.find("li > ul")
		                   .filter(function() {
		                       return !kendo.support.matchesSelector.call(this, nonContentGroupsSelector);
		                   })
		                   .addClass("k-group k-menu-group")
		                   .attr("role", "menu")
		                   .attr("aria-hidden", element.is(":visible"))
		                   .parent("li")
		                   .attr("aria-haspopup", "true")
		                   .end()
		                   .find("li > div")
		                   .addClass("k-content")
		                   .attr("tabindex", "-1"); // Capture the focus before the Menu
	
		            items = element.find("> li,.k-menu-group > li");
	
		            element.removeClass("k-menu-init");
	
		            items.each(function () {
		                updateItemClasses(this);
		            });
		        },
	
		        _mouseenter: function (e) {
		            var that = this;
		            var element = $(e.currentTarget);
		            var hasChildren = that._itemHasChildren(element);
		            var popupId = element.data(POPUP_OPENER_ATTR) || element.parent().data(POPUP_ID_ATTR);
		            var pointerTouch = isPointerTouch(e);
	
		            if (popupId) {
		                that._openedPopups[popupId.toString()] = true;
		            }
	
		            if (e.delegateTarget != element.parents(menuSelector)[0] && e.delegateTarget != element.parents(".k-menu-scroll-wrapper,.k-popups-wrapper")[0]) {
		                return;
		            }
	
		            that._keyTriggered = false;
	
		            if ((that.options.openOnClick.rootMenuItems && that._isRootItem(element.closest(allItemsSelector))) ||
		                (that.options.openOnClick.subMenuItems && !that._isRootItem(element.closest(allItemsSelector)))) {
		                return;
		            }
	
		            if ((that.options.openOnClick === false ||
		                (that.options.openOnClick.rootMenuItems === false && that._isRootItem(element.closest(allItemsSelector))) ||
		                (that.options.openOnClick.subMenuItems === false && !that._isRootItem(element.closest(allItemsSelector))) || that.clicked) && !touch &&
		                !(pointerTouch && that._isRootItem(element.closest(allItemsSelector)))) {
		                if (!contains(e.currentTarget, e.relatedTarget) && hasChildren) {
		                    that.open(element);
		                }
		            }
	
		            if (that.options.openOnClick === true && that.clicked || touch) {
		                element.siblings().each(proxy(function (_, sibling) {
		                    that.close(sibling, true);
		                }, that));
		            }
		        },
	
		        _mousedown: function (e) {
		            var that = this;
		            var element = $(e.currentTarget);
		            // needs to close subMenuItems
		            if (that.options.openOnClick.subMenuItems && !that._isRootItem(element) || touch) {
		                element.siblings().each(proxy(function (_, sibling) {
		                    that.close(sibling, true);
		                }, that));
		            }
		        },
	
		        _mouseleave: function (e) {
		            var that = this;
		            var element = $(e.currentTarget);
		            var popupOpener = element.data(POPUP_OPENER_ATTR);
		            var hasChildren = (element.children(animationContainerSelector).length || element.children(groupSelector).length) || popupOpener;
		            var $window = $(window);
	
		            if (popupOpener) {
		                delete that._openedPopups[popupOpener.toString()];
		            }
	
		            if (element.parentsUntil(animationContainerSelector, ".k-list-container,.k-calendar-container")[0]) {
		                e.stopImmediatePropagation();
		                return;
		            }
	
		            if ((that.options.openOnClick === false || (!that.options.openOnClick.rootMenuItems && that._isRootItem(element)) ||
		                (!that.options.openOnClick.subMenuItems && !that._isRootItem(element))) && !touch && !isPointerTouch(e) &&
		                !contains(e.currentTarget, e.relatedTarget || e.target) && hasChildren &&
		                !contains(e.currentTarget, kendo._activeElement())) {
		                    that.close(element, true);
		                    return;
		            }
	
		            // Detect if cursor goes outside the viewport of the browser
		            if( (kendo.support.browser.msie && !e.toElement && !e.relatedTarget && !isPointerTouch(e)) ||
		                e.clientX < 0 || e.clientY < 0 ||
		                e.clientY > $window.height() ||
		                e.clientX > $window.width()){
		                that.close(element);
		            }
		        },
	
		        _mouseenterPopup: function(e){
		            var that = this;
		            var popupElement = $(e.currentTarget);
	
		            if (popupElement.parent().is(animationContainerSelector)) {
		                 return;
		            }
	
		            popupElement = popupElement.children("ul");
		            var popupId = popupElement.data(POPUP_ID_ATTR);
	
		            if (popupId) {
		                that._openedPopups[popupId.toString()] = true;
		            }
		        },
	
		        _mouseleavePopup: function (e) {
		            var that = this;
		            var popupElement = $(e.currentTarget);
	
		            if (!isPointerTouch(e) && popupElement.is(animationContainerSelector)) {
		                that._closePopups(popupElement.children("ul"));
		            }
		        },
	
		        _closePopups: function(rootPopup) {
		            var that = this;
		            var overflowWrapper = that._overflowWrapper();
		            var popupId = rootPopup.data(POPUP_ID_ATTR);
	
		            if (popupId) {
		                delete that._openedPopups[popupId.toString()];
		                var groupParent = overflowWrapper.find(popupOpenerSelector(popupId));
	
		                setTimeout(function() {
		                    if (that.options.openOnClick) {
		                        that._closeChildPopups(rootPopup);
		                    } else {
		                        if ($.isEmptyObject(that._openedPopups)) {
		                            var innerPopup = that._innerPopup(rootPopup);
		                            that._closeParentPopups(innerPopup);
		                        } else {
		                            that.close(groupParent, true);
		                        }
		                    }
		                }, 0);
		            }
		        },
	
		        _closeChildPopups: function(current){
		            var that = this;
		            var overflowWrapper = that._overflowWrapper();
		            $(getChildPopups(current, overflowWrapper)).each(function(){
		                var popupOpener = overflowWrapper.find(popupOpenerSelector(this.data(POPUP_ID_ATTR)));
		                that.close(popupOpener, true);
		            });
		        },
	
		        _innerPopup: function(current) {
		            var overflowWrapper = this._overflowWrapper();
		            var popups = getChildPopups(current, overflowWrapper);
		            return popups[popups.length - 1] || current;
		        },
	
		        _closeParentPopups: function (current) {
		            var that = this;
		            var overflowWrapper = that._overflowWrapper();
		            var popupId = current.data(POPUP_ID_ATTR);
		            var popupOpener = overflowWrapper.find(popupOpenerSelector(popupId));
		            popupId = popupOpener.parent().data(POPUP_ID_ATTR);
		            that.close(popupOpener, true);
		            while (popupId && !that._openedPopups[popupId]) {
		                if (popupOpener.parent().is(menuSelector)) {
		                    break;
		                }
		                popupOpener = overflowWrapper.find(popupOpenerSelector(popupId));
		                that.close(popupOpener, true);
		                popupId = popupOpener.parent().data(POPUP_ID_ATTR);
		            }
		        },
	
		        _click: function (e) {
		            var that = this, openHandle,
		                options = that.options,
		                target = $(kendo.eventTarget(e)),
		                targetElement = target[0],
		                nodeName = target[0] ? target[0].nodeName.toUpperCase() : "",
		                formNode = (nodeName == "INPUT" || nodeName == "SELECT" || nodeName == "BUTTON" || nodeName == "LABEL"),
		                link = target.closest(LINK_SELECTOR),
		                element = target.closest(allItemsSelector),
		                itemElement = element[0],
		                href = link.attr("href"), childGroup, childGroupVisible,
		                targetHref = target.attr("href"),
		                sampleHref = $("<a href='#' />").attr("href"),
		                isLink = (!!href && href !== sampleHref),
		                isLocalLink = isLink && !!href.match(/^#/),
		                isTargetLink = (!!targetHref && targetHref !== sampleHref),
		                overflowWrapper = that._overflowWrapper(),
		                shouldCloseTheRootItem;
	
		            while (targetElement && targetElement.parentNode != itemElement) {
		                targetElement = targetElement.parentNode;
		            }
	
		            if ($(targetElement).is(templateSelector)) {
		                return;
		            }
	
		            if (element.hasClass(DISABLEDSTATE)) {
		                e.preventDefault();
		                return;
		            }
	
		            if (!e.handled && that._triggerSelect(target, itemElement) && !formNode) { // We shouldn't stop propagation and shoudn't prevent form elements.
		                e.preventDefault();
		            }
	
		            e.handled = true;
	
		            childGroup = element.children(popupSelector);
		            if (overflowWrapper) {
		                var childPopupId = element.data(POPUP_OPENER_ATTR);
		                if (childPopupId) {
		                    childGroup = overflowWrapper.find(popupGroupSelector(childPopupId));
		                }
		            }
		            childGroupVisible = childGroup.is(":visible");
		            shouldCloseTheRootItem = options.openOnClick && childGroupVisible && that._isRootItem(element);
	
		            if (options.closeOnClick && (!isLink || isLocalLink) && (!childGroup.length || shouldCloseTheRootItem)) {
		                element.removeClass(HOVERSTATE).css("height"); // Force refresh for Chrome
		                that._oldHoverItem = that._findRootParent(element);
		                var item = that._parentsUntil(link, that.element, allItemsSelector);
		                that._forceClose = !!overflowWrapper;
		                that.close(item);
		                that.clicked = false;
		                if ("MSPointerUp".indexOf(e.type) != -1) {
		                    e.preventDefault();
		                }
		                return;
		            }
	
		            if (isLink && e.enterKey) {
		                link[0].click();
		            }
	
		            if (((!that._isRootItem(element) || options.openOnClick === false) && !options.openOnClick.subMenuItems) && !kendo.support.touch && !(isPointerTouch(e) && that._isRootItem(element.closest(allItemsSelector)))) {
		                return;
		            }
	
		            if (!isLink && !formNode && !isTargetLink) {
		                e.preventDefault();
		            }
	
		            that.clicked = true;
		            openHandle = childGroup.is(":visible") ? CLOSE : OPEN;
		            if (!options.closeOnClick && openHandle == CLOSE) {
		                return;
		            }
		            that[openHandle](element);
		        },
	
		        _parentsUntil: function(context, top, selector) {
		            var overflowWrapper = this._overflowWrapper();
		            if (!overflowWrapper) {
		                return context.parentsUntil(top, selector);
		            } else {
		                var parents = overflowMenuParents(context, overflowWrapper);
		                var result = [];
		                $(parents).each(function(){
		                    var parent = $(this);
		                    if (parent.is(top)) {
		                        return false;
		                    }
		                    if (parent.is(selector)) {
		                        result.push(this);
		                    }
		                });
		                return $(result);
		            }
		        },
	
		        _triggerSelect: function (target, itemElement) {
		            target = target.is(".k-link") ? target : target.closest(".k-link");
	
		            var selectHandler = target.data("selectHandler"),
		                itemSelectEventData;
	
		            if (selectHandler) {
		                itemSelectEventData = this._getEventData(target);
		                selectHandler.call(this, itemSelectEventData);
		            }
	
		            var isSelectItemDefaultPrevented = itemSelectEventData && itemSelectEventData.isDefaultPrevented();
		            var isSelectDefaultPrevented = this._triggerEvent({ item: itemElement, type: SELECT });
		            return isSelectItemDefaultPrevented || isSelectDefaultPrevented;
		        },
	
		        _getEventData: function (target) {
		            var eventData = {
		                sender: this,
		                target: target,
		                _defaultPrevented: false,
		                preventDefault: function () {
		                    this._defaultPrevented = true;
		                },
		                isDefaultPrevented: function () {
		                    return this._defaultPrevented;
		                }
		            };
		            return eventData;
		        },
	
		        _documentClick: function (e) {
		            var that = this;
	
		            if (contains((that._overflowWrapper() || that.element)[0], e.target)) {
		                return;
		            }
	
		            that.clicked = false;
		        },
	
		        _focus: function (e) {
		            var that = this,
		                target = e.target,
		                hoverItem = that._hoverItem(),
		                active = activeElement();
	
		            if (target != that.wrapper[0] && !$(target).is(":kendoFocusable")) {
		                e.stopPropagation();
		                $(target).closest(".k-content").closest(".k-menu-group").closest(".k-item").addClass(FOCUSEDSTATE);
		                that.wrapper.focus();
		                return;
		            }
	
		            if (active === e.currentTarget) {
		                if (hoverItem.length) {
		                    that._moveHover([], hoverItem);
		                } else if (!that._oldHoverItem) {
		                    that._moveHover([], that.wrapper.children().first());
		                }
		            }
		        },
	
		        _keydown: function (e) {
		            var that = this,
		                key = e.keyCode,
		                hoverItem = that._oldHoverItem,
		                target,
		                belongsToVertical,
		                hasChildren,
		                isRtl = kendo.support.isRtl(that.wrapper);
	
		            if (e.target != e.currentTarget && key != keys.ESC) {
		                return;
		            }
	
		            if (!hoverItem) {
		                hoverItem  = that._oldHoverItem = that._hoverItem();
		            }
	
		            belongsToVertical = that._itemBelongsToVertival(hoverItem);
		            hasChildren = that._itemHasChildren(hoverItem);
		            that._keyTriggered = true;
	
		            if (key == keys.RIGHT) {
		                target = that[isRtl ? "_itemLeft" : "_itemRight"](hoverItem, belongsToVertical, hasChildren);
		            } else if (key == keys.LEFT) {
		                target = that[isRtl ? "_itemRight" : "_itemLeft"](hoverItem, belongsToVertical, hasChildren);
		            } else if (key == keys.DOWN) {
		                target = that._itemDown(hoverItem, belongsToVertical, hasChildren);
		            } else if (key == keys.UP) {
		                target = that._itemUp(hoverItem, belongsToVertical, hasChildren);
		            } else if (key == keys.HOME) {
		                that._moveHover(hoverItem, hoverItem.parent().children().first());
		                e.preventDefault();
		            } else if (key == keys.END) {
		                that._moveHover(hoverItem, hoverItem.parent().children().last());
		                e.preventDefault();
		            } else if (key == keys.ESC) {
		                target = that._itemEsc(hoverItem, belongsToVertical);
		            } else if (key == keys.ENTER || key == keys.SPACEBAR) {
		                target = hoverItem.children(".k-link");
		                if (target.length > 0) {
		                    that._click({ target: target[0], preventDefault: function () {}, enterKey: true });
		                    if (hasChildren && !hoverItem.hasClass(DISABLEDSTATE)) {
		                        that.open(hoverItem);
		                        that._moveHover(hoverItem, that._childPopupElement(hoverItem).children().first());
		                    } else {
		                        that._moveHover(hoverItem, that._findRootParent(hoverItem));
		                    }
		                }
		            } else if (key == keys.TAB) {
		                target = that._findRootParent(hoverItem);
		                that._moveHover(hoverItem, target);
		                that._checkActiveElement();
		                return;
		            }
	
		            if (target && target[0]) {
		                e.preventDefault();
		                e.stopPropagation(); // needed to handle ESC in column menu only when a root item is focused
		            }
		        },
	
		        _hoverItem: function() {
		            return this.wrapper.find(".k-item.k-state-hover,.k-item.k-state-focused").filter(":visible");
		        },
	
		        _itemBelongsToVertival: function (item) {
		            var menuIsVertical = this.wrapper.hasClass("k-menu-vertical");
	
		            if (!item.length) {
		                return menuIsVertical;
		            }
		            return item.parent().hasClass("k-menu-group") || menuIsVertical;
		        },
	
		        _itemHasChildren: function (item) {
		            if (!item || !item.length || !item[0].nodeType) {
		                return false;
		            }
		            return item.children(".k-menu-group, div.k-animation-container").length > 0 ||
		                (!!item.data(POPUP_OPENER_ATTR) && !!this._overflowWrapper().children(popupGroupSelector(item.data(POPUP_OPENER_ATTR))));
		        },
	
		        _moveHover: function (item, nextItem) {
		            var that = this,
		                id = that._ariaId;
	
		            if (item.length && nextItem.length) {
		                item.removeClass(FOCUSEDSTATE);
		            }
	
		            if (nextItem.length) {
		                if (nextItem[0].id) {
		                    id = nextItem[0].id;
		                }
	
		                nextItem.addClass(FOCUSEDSTATE);
		                that._oldHoverItem = nextItem;
	
		                if (id) {
		                    that.element.removeAttr("aria-activedescendant");
		                    $("#" + id).removeAttr("id");
		                    nextItem.attr("id", id);
		                    that.element.attr("aria-activedescendant", id);
		                }
		                that._scrollToItem(nextItem);
		            }
		        },
	
		        _findRootParent: function (item) {
		            if (this._isRootItem(item)) {
		                return item;
		            } else {
		                return this._parentsUntil(item, menuSelector, "li.k-item").last();
		            }
		        },
	
		        _isRootItem: function (item) {
		            return item.parent().hasClass(MENU);
		        },
	
		        _itemRight: function (item, belongsToVertical, hasChildren) {
		            var that = this,
		                nextItem,
		                parentItem,
		                overflowWrapper;
	
		            if (!belongsToVertical) {
		                nextItem = item.nextAll(nextSelector);
		                if (!nextItem.length) {
		                    nextItem = item.prevAll(lastSelector);
		                }
		                that.close(item);
		            } else if (hasChildren && !item.hasClass(DISABLEDSTATE)) {
		                that.open(item);
		                nextItem = that._childPopupElement(item).children().first();
		            } else if (that.options.orientation == "horizontal") {
		                parentItem = that._findRootParent(item);
		                overflowWrapper = that._overflowWrapper();
		                if (overflowWrapper) {
		                    var rootPopup = itemPopup(parentItem, overflowWrapper);
		                    that._closeChildPopups(rootPopup);
		                }
		                that.close(parentItem);
		                nextItem = parentItem.nextAll(nextSelector);
		            }
	
		            if (nextItem && !nextItem.length) {
		                nextItem = that.wrapper.children(".k-item").first();
		            } else if (!nextItem) {
		                nextItem = [];
		            }
	
		            that._moveHover(item, nextItem);
		            return nextItem;
		        },
	
		        _itemLeft: function (item, belongsToVertical) {
		            var that = this,
		                nextItem,
		                overflowWrapper;
	
		            if (!belongsToVertical) {
		                nextItem = item.prevAll(nextSelector);
		                if (!nextItem.length) {
		                    nextItem = item.nextAll(lastSelector);
		                }
		                that.close(item);
		            } else {
		                nextItem = item.parent().closest(".k-item");
		                overflowWrapper = that._overflowWrapper();
		                if (!nextItem.length && overflowWrapper) {
		                    nextItem = popupParentItem(item.parent(), overflowWrapper);
		                }
		                that.close(nextItem);
		                if (that._isRootItem(nextItem) && that.options.orientation == "horizontal") {
		                    nextItem = nextItem.prevAll(nextSelector);
		                }
		            }
	
		            if (!nextItem.length) {
		                nextItem = that.wrapper.children(".k-item").last();
		            }
	
		            that._moveHover(item, nextItem);
		            return nextItem;
		        },
	
		        _itemDown: function (item, belongsToVertical, hasChildren) {
		            var that = this,
		                nextItem;
	
		            if (!belongsToVertical) {
		                if (!hasChildren || item.hasClass(DISABLEDSTATE)) {
		                    return;
		                } else {
		                    that.open(item);
		                    nextItem = that._childPopupElement(item).children().first();
		                }
		            } else {
		                nextItem = item.nextAll(nextSelector);
		            }
	
		            if (!nextItem.length && item.length) {
		                nextItem = item.parent().children().first();
		            } else if (!item.length) {
		                nextItem = that.wrapper.children(".k-item").first();
		            }
	
		            that._moveHover(item, nextItem);
		            return nextItem;
		        },
	
		        _itemUp: function (item, belongsToVertical) {
		            var that = this,
		                nextItem;
	
		            if (!belongsToVertical) {
		                return;
		            } else {
		                nextItem = item.prevAll(nextSelector);
		            }
	
		            if (!nextItem.length && item.length) {
		                nextItem = item.parent().children().last();
		            } else if (!item.length) {
		                nextItem = that.wrapper.children(".k-item").last();
		            }
	
		            that._moveHover(item, nextItem);
		            return nextItem;
		        },
	
		        _scrollToItem: function(item){
		            var that = this;
		            if (that.options.scrollable && item && item.length) {
		                var ul = item.parent();
		                var isHorizontal = ul.hasClass(MENU) ? that.options.orientation == "horizontal" : false;
		                var scrollDir = isHorizontal ? "scrollLeft" : "scrollTop";
		                var getSize = isHorizontal ? kendo._outerWidth : kendo._outerHeight;
		                var currentScrollOffset = ul[scrollDir]();
		                var itemSize = getSize(item);
		                var itemOffset = item[0][isHorizontal ? "offsetLeft" : "offsetTop"];
		                var ulSize = getSize(ul);
		                var scrollButtons = ul.siblings(scrollButtonSelector);
		                var scrollButtonSize = scrollButtons.length ? getSize(scrollButtons.first()) : 0;
		                var itemPosition;
	
		                if (currentScrollOffset + ulSize < itemOffset + itemSize + scrollButtonSize) {
		                    itemPosition = itemOffset + itemSize - ulSize + scrollButtonSize;
		                } else if (currentScrollOffset > itemOffset - scrollButtonSize) {
		                    itemPosition = itemOffset - scrollButtonSize;
		                }
	
		                if (!isNaN(itemPosition)) {
		                    var scrolling = {};
		                    scrolling[scrollDir] = itemPosition;
		                    ul.finish().animate(scrolling, "fast", "linear", function () {
		                        that._toggleScrollButtons(ul, scrollButtons.first(), scrollButtons.last(), isHorizontal);
		                    });
		                }
		            }
		        },
	
		        _itemEsc: function (item, belongsToVertical) {
		            var that = this,
		                nextItem;
	
		            if (!belongsToVertical) {
		                return item;
		            } else {
		                nextItem = item.parent().closest(".k-item");
		                that.close(nextItem);
		                that._moveHover(item, nextItem);
		            }
	
		            return nextItem;
		        },
	
		        _childPopupElement: function(item) {
		            var popupElement = item.find(".k-menu-group");
		            var wrapper = this._overflowWrapper();
		            if (!popupElement.length && wrapper) {
		                popupElement = itemPopup(item, wrapper);
		            }
		            return popupElement;
		        },
	
		        _triggerEvent: function(e) {
		            var that = this;
	
		            return that.trigger(e.type, { type: e.type, item: e.item });
		        },
	
		        _focusHandler: function (e) {
		            var that = this,
		                item = $(kendo.eventTarget(e)).closest(allItemsSelector);
	
		            if (item.hasClass(DISABLEDSTATE)) {
		                return;
		            }
	
		            setTimeout(function () {
		                that._moveHover([], item);
		                if (item.children(".k-content")[0]) {
		                    item.parent().closest(".k-item").removeClass(FOCUSEDSTATE);
		                }
		            }, 200);
		        },
	
		        _animations: function(options) {
		            if (options && ("animation" in options) && !options.animation) {
		                options.animation = { open: { effects: {} }, close: { hide: true, effects: {} } };
		            }
		        }
	
		    });
	
		    // client-side rendering
		    extend(Menu, {
		        renderItem: function (options) {
		            options = extend({ menu: {}, group: {} }, options);
	
		            var empty = templates.empty,
		                item = options.item;
	
		            return templates.item(extend(options, {
		                image: item.imageUrl ? templates.image : empty,
		                sprite: item.spriteCssClass ? templates.sprite : empty,
		                itemWrapper: templates.itemWrapper,
		                renderContent: Menu.renderContent,
		                arrow: item.items || item.content ? templates.arrow : empty,
		                subGroup: Menu.renderGroup
		            }, rendering));
		        },
	
		        renderGroup: function (options) {
		            return templates.group(extend({
		                renderItems: function(options) {
		                    var html = "",
		                        i = 0,
		                        items = options.items,
		                        len = items ? items.length : 0,
		                        group = extend({ length: len }, options.group);
	
		                    for (; i < len; i++) {
		                        html += Menu.renderItem(extend(options, {
		                            group: group,
		                            item: extend({ index: i }, items[i])
		                        }));
		                    }
	
		                    return html;
		                }
		            }, options, rendering));
		        },
	
		        renderContent: function (options) {
		            return templates.content(extend(options, rendering));
		        }
		    });
	
		    var ContextMenu = Menu.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Menu.fn.init.call(that, element, options);
	
		            that._marker = kendo.guid().substring(0, 8);
	
		            that.target = $(that.options.target);
	
		            that._popup();
		            that._wire();
		        },
	
		        _initOverflow: function(options){
		            var that = this;
		            if (options.scrollable && !that._overflowWrapper()) {
		                that._openedPopups = {};
	
		                that._popupsWrapper = (that.element.parent().is(animationContainerSelector) ? that.element.parent() : that.element)
		                    .wrap("<div class='k-popups-wrapper " + options.orientation + "'></div>").parent();
	
		                if (that.options.orientation == "horizontal") {
		                    removeSpacesBetweenItems(that.element);
		                }
	
		                if (options.appendTo) {
		                    options.appendTo.append(that._popupsWrapper);
		                }
	
		                that._initialHeight = that.element[0].style.height;
		                that._initialWidth = that.element[0].style.width;
		            }
		        },
	
		        options: {
		            name: "ContextMenu",
		            filter: null,
		            showOn: "contextmenu",
		            orientation: "vertical",
		            alignToAnchor: false,
		            target: "body"
		        },
	
		        events: [
		            OPEN,
		            CLOSE,
		            ACTIVATE,
		            DEACTIVATE,
		            SELECT
		        ],
	
		        setOptions: function(options) {
		            var that = this;
	
		            Menu.fn.setOptions.call(that, options);
	
		            that.target.off(that.showOn + NS + that._marker, that._showProxy);
	
		            if (that.userEvents) {
		                that.userEvents.destroy();
		            }
	
		            that.target = $(that.options.target);
		            if (options.orientation && that.popup.wrapper[0]) {
		                that.popup.element.unwrap();
		            }
	
		            that._wire();
	
		            Menu.fn.setOptions.call(this, options);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.target.off(that.options.showOn + NS + that._marker);
		            DOCUMENT_ELEMENT.off(kendo.support.mousedown + NS + that._marker, that._closeProxy);
	
		            if (that.userEvents) {
		                that.userEvents.destroy();
		            }
	
		            Menu.fn.destroy.call(that);
		        },
	
		        open: function(x, y) {
		            var that = this;
	
		            x = $(x)[0];
	
		            if (contains(that.element[0], $(x)[0]) || that._itemHasChildren($(x))) { // call parent open for children elements
		                Menu.fn.open.call(that, x);
		            } else {
		                if (that._triggerEvent({ item: that.element, type: OPEN }) === false) {
		                    if (that.popup.visible() && that.options.filter) {
		                        that.popup.close(true);
		                        that.popup.element.kendoStop(true);
		                    }
	
		                    if (y !== undefined) {
		                        var overflowWrapper = that._overflowWrapper();
		                        if (overflowWrapper) {
		                            var offset = overflowWrapper.offset();
		                            x -= offset.left;
		                            y -= offset.top;
		                        }
		                        that.popup.wrapper.hide();
		                        that._configurePopupScrolling(x, y);
		                        that.popup.open(x, y);
		                    } else {
		                        that.popup.options.anchor = (x ? x : that.popup.anchor) || that.target;
		                        that.popup.element.kendoStop(true);
		                        that._configurePopupScrolling();
		                        that.popup.open();
		                    }
	
		                    DOCUMENT_ELEMENT.off(that.popup.downEvent, that.popup._mousedownProxy);
		                    DOCUMENT_ELEMENT
		                        .on(kendo.support.mousedown + NS + that._marker, that._closeProxy);
		                }
		            }
	
		            return that;
		        },
	
		        _configurePopupScrolling: function(x, y){
		            var that = this;
		            var popup = that.popup;
		            var isHorizontal = that.options.orientation == "horizontal";
	
		            if (that.options.scrollable) {
		                that._wrapPopupElement(popup);
	
		                popup.element.parent().css({
		                    position: "",
		                    height: ""
		                });
	
		                popup.element.css({
		                    visibility: "hidden",
		                    display: "",
		                    position: ""
		                });
	
		                if (isHorizontal) {
		                    that._setPopupWidth(popup, isNaN(x) ? undefined : {isFixed: true, x: x, y: y});
		                } else {
		                    that._setPopupHeight(popup, isNaN(x) ? undefined : {isFixed: true, x: x, y: y});
		                }
	
		                popup.element.css({
		                    visibility: "",
		                    display: "none",
		                    position: "absolute"
		                });
	
		                that._initPopupScrollButtons(popup, isHorizontal, true);
		                popup.element.siblings(scrollButtonSelector).hide();
		            }
		        },
	
		        _setPopupWidth: function(popup, isFixed){
		            var popupElement = popup.element;
		            var popups = popupElement.add(popupElement.parent(animationContainerSelector));
	
		            popups.width(this._initialWidth || "");
	
		            var location = popup._location(isFixed);
		            var windowWidth = $(window).width();
		            var popupOuterWidth = location.width;
		            var popupOffsetLeft = Math.max(location.left, 0);
		            var scrollLeft = isFixed ? 0 : parentsScroll(this._overflowWrapper()[0], "scrollLeft");
		            var shadow = kendo.getShadows(popupElement);
		            var maxWidth = windowWidth - shadow.left - shadow.right;
		            var canFit = maxWidth + scrollLeft > popupOuterWidth + popupOffsetLeft;
	
		            if (!canFit) {
		                popups.css({overflow: "hidden", width: (maxWidth - popupOffsetLeft + scrollLeft) + "px"});
		            }
		        },
	
		        close: function() {
		            var that = this;
	
		            if (contains(that.element[0], $(arguments[0])[0]) || that._itemHasChildren(arguments[0])) {
		                Menu.fn.close.call(that, arguments[0]);
		            } else {
		                if (that.popup.visible()) {
		                    if (that._triggerEvent({ item: that.element, type: CLOSE }) === false) {
		                        that.popup.close();
		                        DOCUMENT_ELEMENT.off(kendo.support.mousedown + NS + that._marker, that._closeProxy);
		                        that.unbind(SELECT, that._closeTimeoutProxy);
		                    }
		                }
		            }
		        },
	
		        _showHandler: function (e) {
		            var ev = e, offset,
		                that = this,
		                options = that.options;
	
		            if (e.event) {
		                ev = e.event;
		                ev.pageX = e.x.location;
		                ev.pageY = e.y.location;
		            }
	
		            if (contains(that.element[0], e.relatedTarget || e.target)) {
		                return;
		            }
	
		            that._eventOrigin = ev;
	
		            ev.preventDefault();
		            ev.stopImmediatePropagation();
	
		            that.element.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
	
		            if ((options.filter && kendo.support.matchesSelector.call(ev.currentTarget, options.filter)) || !options.filter) {
		                if (options.alignToAnchor) {
		                    that.popup.options.anchor = ev.currentTarget;
		                    that.open(ev.currentTarget);
		                } else {
		                    that.popup.options.anchor = ev.currentTarget;
	
		                    if (that._targetChild) {
		                        offset = that.target.offset();
		                        that.open(ev.pageX - offset.left, ev.pageY - offset.top);
		                    } else {
		                        that.open(ev.pageX, ev.pageY);
		                    }
		                }
		            }
		        },
	
		        _closeHandler: function (e) {
		            var that = this,
		                target = $(e.relatedTarget || e.target),
		                sameTarget = target.closest(that.target.selector)[0] == that.target[0],
		                item = target.closest(itemSelector),
		                children = that._itemHasChildren(item),
		                overflowWrapper = that._overflowWrapper(),
		                containment = contains(that.element[0], target[0]) || (overflowWrapper && contains(overflowWrapper[0], target[0]));
	
		            that._eventOrigin = e;
	
		            var normalClick = e.which !== 3;
	
		            if (that.popup.visible() && ((normalClick && sameTarget) || !sameTarget) && ((that.options.closeOnClick && !children && containment) || !containment)) {
		                if (containment) {
		                    this.unbind(SELECT, this._closeTimeoutProxy);
		                    that.bind(SELECT, that._closeTimeoutProxy);
		                } else {
		                    that.close();
		                }
		            }
		        },
	
		        _wire: function() {
		            var that = this,
		                options = that.options,
		                target = that.target;
	
		            that._showProxy = proxy(that._showHandler, that);
		            that._closeProxy = proxy(that._closeHandler, that);
		            that._closeTimeoutProxy = proxy(that.close, that);
	
		            if (target[0]) {
		                if (kendo.support.mobileOS && options.showOn == "contextmenu") {
		                    that.userEvents = new kendo.UserEvents(target, {
		                        filter: options.filter,
		                        allowSelection: false
		                    });
	
		                    target.on(options.showOn + NS + that._marker, false);
		                    that.userEvents.bind("hold", that._showProxy);
		                } else {
		                    if (options.filter) {
		                        target.on(options.showOn + NS + that._marker, options.filter, that._showProxy);
		                    } else {
		                        target.on(options.showOn + NS + that._marker, that._showProxy);
		                    }
		                }
		            }
		        },
	
		        _triggerEvent: function(e) {
		            var that = this,
		                anchor = $(that.popup.options.anchor)[0],
		                origin = that._eventOrigin;
	
		            that._eventOrigin = undefined;
	
		            return that.trigger(e.type, extend({ type: e.type, item: e.item || this.element[0], target: anchor }, origin ? { event: origin } : {} ));
		        },
	
		        _popup: function() {
		            var that = this;
		            var overflowWrapper = that._overflowWrapper();
	
		            that._triggerProxy = proxy(that._triggerEvent, that);
	
		            that.popup = that.element
		                            .addClass("k-context-menu")
		                            .kendoPopup({
		                                anchor: that.target || "body",
		                                copyAnchorStyles: that.options.copyAnchorStyles,
		                                collision: that.options.popupCollision || "fit",
		                                animation: that.options.animation,
		                                activate: that._triggerProxy,
		                                deactivate: that._triggerProxy,
		                                appendTo: overflowWrapper || that.options.appendTo,
		                                close: !overflowWrapper ? $.noop : function(e) {
		                                    $(getChildPopups(e.sender.element, overflowWrapper)).each(function(i, p) {
		                                        var popup = p.data(KENDOPOPUP);
		                                        if (popup) {
		                                            popup.close(true);
		                                        }
		                                    });
		                                }
		                            }).data(KENDOPOPUP);
	
		            that._targetChild = contains(that.target[0], that.popup.element[0]);
		        }
		    });
	
		    ui.plugin(Menu);
		    ui.plugin(ContextMenu);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1335);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1335:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1036) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "tooltip",
		    name: "Tooltip",
		    category: "web",
		    description: "The Tooltip widget displays a popup hint for a given html element.",
		    depends: [ "core", "popup" ],
		    features: [ {
		        id: "tooltip-fx",
		        name: "Animation",
		        description: "Support for animation",
		        depends: [ "fx" ]
		    } ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        Popup = kendo.ui.Popup,
		        isFunction = kendo.isFunction,
		        isPlainObject = $.isPlainObject,
		        extend = $.extend,
		        proxy = $.proxy,
		        DOCUMENT = $(document),
		        isLocalUrl = kendo.isLocalUrl,
		        ARIAIDSUFFIX = "_tt_active",
		        DESCRIBEDBY = "aria-describedby",
		        SHOW = "show",
		        HIDE = "hide",
		        ERROR = "error",
		        CONTENTLOAD = "contentLoad",
		        REQUESTSTART = "requestStart",
		        KCONTENTFRAME = "k-content-frame",
		        TEMPLATE = '<div role="tooltip" class="k-widget k-tooltip#if (!autoHide) {# k-tooltip-closable#}#">#if (!autoHide) {# <div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close" title="Close"></a></div> #}#' +
		                '<div class="k-tooltip-content"></div>' +
		                '#if (callout){ #<div class="k-callout k-callout-#=dir#"></div>#}#' +
		            '</div>',
		        IFRAMETEMPLATE = kendo.template(
		        "<iframe frameborder='0' class='" + KCONTENTFRAME + "' " +
		                "src='#= content.url #'>" +
		                    "This page requires frames in order to show content" +
		        "</iframe>"),
		        NS = ".kendoTooltip",
		        POSITIONS = {
		            bottom: {
		                origin: "bottom center",
		                position: "top center"
		            },
		            top: {
		                origin: "top center",
		                position: "bottom center"
		            },
		            left: {
		                origin: "center left",
		                position: "center right",
		                collision: "fit flip"
		            },
		            right: {
		                origin: "center right",
		                position: "center left",
		                collision: "fit flip"
		            },
		            center: {
		                position: "center center",
		                origin: "center center"
		            }
		        },
		        REVERSE = {
		            "top": "bottom",
		            "bottom": "top",
		            "left": "right",
		            "right": "left",
		            "center": "center"
		        },
		        DIRCLASSES = {
		            bottom: "n",
		            top: "s",
		            left: "e",
		            right: "w",
		            center: "n"
		        },
		        DIMENSIONS = {
		            "horizontal": { offset: "top", size: "outerHeight" },
		            "vertical": { offset: "left", size: "outerWidth" }
		        },
		        DEFAULTCONTENT = function(e) {
		            return e.target.data(kendo.ns + "title");
		        };
	
		    function restoreTitle(element) {
		        while(element.length) {
		            if (restoreTitleAttributeForElement(element)) {
		                break;
		            }
		            element = element.parent();
		        }
		    }
	
		    function restoreTitleAttributeForElement(element) {
		        var title = element.data(kendo.ns + "title");
		        if (title) {
		            element.attr("title", title);
		            element.removeData(kendo.ns + "title");
		            return true;
		        }
		    }
	
		    function saveTitleAttributeForElement(element) {
		        var title = element.attr("title");
		        if (title) {
		            element.data(kendo.ns + "title", title);
		            element.attr("title", "");
		            return true;
		        }
		    }
	
		    function saveTitleAttributes(element) {
		        while(element.length && !element.is("body")) {
		            if (saveTitleAttributeForElement(element)) {
		                break;
		            }
		            element = element.parent();
		        }
		    }
	
		    var Tooltip = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                axis;
	
		            Widget.fn.init.call(that, element, options);
	
		            axis = that.options.position.match(/left|right/) ? "horizontal" : "vertical";
	
		            that.dimensions = DIMENSIONS[axis];
	
		            that._documentKeyDownHandler = proxy(that._documentKeyDown, that);
	
		            that.element.on(that.options.showOn + NS, that.options.filter, proxy(that._showOn, that));
	
		            if (this._isShownOnMouseEnter() || this._isShownOnClick()) {
		                that.element.on("mouseenter" + NS, that.options.filter, proxy(that._mouseenter, that));
		            }
	
		            if (this.options.autoHide && this._isShownOnMouseEnter()) {
		                that.element.on("mouseleave" + NS, that.options.filter, proxy(that._mouseleave, that));
		            }
	
		            if (this.options.autoHide && this._isShownOnFocus()) {
		                that.element.on("blur" + NS, that.options.filter, proxy(that._blur, that));
		            }
		        },
	
		        options: {
		            name: "Tooltip",
		            filter: "",
		            content: DEFAULTCONTENT,
		            showAfter: 100,
		            callout: true,
		            position: "bottom",
		            showOn: "mouseenter",
		            autoHide: true,
		            width: null,
		            height: null,
		            animation: {
		                open: {
		                    effects: "fade:in",
		                    duration: 0
		                },
		                close: {
		                    duration: 40,
		                    hide: true
		                }
		            }
		        },
	
		        events: [ SHOW, HIDE, CONTENTLOAD, ERROR, REQUESTSTART ],
	
		        _isShownOnFocus: function(){
		            return this.options.showOn && this.options.showOn.match(/focus/);
		        },
	
		        _isShownOnMouseEnter: function(){
		            return this.options.showOn && this.options.showOn.match(/mouseenter/);
		        },
	
		        _isShownOnClick: function(){
		            return this.options.showOn && this.options.showOn.match(/click/);
		        },
	
		        _mouseenter: function(e) {
		            saveTitleAttributes($(e.currentTarget));
		        },
	
		        _showOn: function(e) {
		            var that = this;
	
		            var currentTarget = $(e.currentTarget);
		            if (that._isShownOnClick() && !that._isShownOnMouseEnter()) {
		                that._show(currentTarget);
		            } else if (that._isShownOnFocus()) {
		                saveTitleAttributes(currentTarget);
		                that._show(currentTarget);
		            } else {
		                clearTimeout(that.timeout);
	
		                that.timeout = setTimeout(function() {
		                    that._show(currentTarget);
		                }, that.options.showAfter);
		            }
		        },
	
		        _appendContent: function(target) {
		            var that = this,
		                contentOptions = that.options.content,
		                element = that.content,
		                showIframe = that.options.iframe,
		                iframe;
	
		            if (isPlainObject(contentOptions) && contentOptions.url) {
		                if (!("iframe" in that.options)) {
		                    showIframe = !isLocalUrl(contentOptions.url);
		                }
	
		                that.trigger(REQUESTSTART, { options: contentOptions, target: target });
	
		                if (!showIframe) {
		                    element.empty();
		                    kendo.ui.progress(element, true);
	
		                    // perform AJAX request
		                    that._ajaxRequest(contentOptions);
		                } else {
		                    element.hide();
	
		                    iframe = element.find("." + KCONTENTFRAME)[0];
	
		                    if (iframe) {
		                        // refresh existing iframe
		                        iframe.src = contentOptions.url || iframe.src;
		                    } else {
		                        element.html(IFRAMETEMPLATE({ content: contentOptions }));
		                    }
	
		                    element.find("." + KCONTENTFRAME)
		                        .off("load" + NS)
		                        .on("load" + NS, function(){
		                            that.trigger(CONTENTLOAD);
		                            element.show();
		                        });
		                }
		            } else if (contentOptions && isFunction(contentOptions)) {
		                contentOptions = contentOptions({ sender: this, target: target });
		                element.html(contentOptions || "");
		            } else {
		                element.html(contentOptions);
		            }
	
		            that.angular("compile", function(){
		                return { elements: element };
		            });
		        },
	
		        _ajaxRequest: function(options) {
		            var that = this;
	
		            jQuery.ajax(extend({
		                type: "GET",
		                dataType: "html",
		                cache: false,
		                error: function (xhr, status) {
		                    kendo.ui.progress(that.content, false);
	
		                    that.trigger(ERROR, { status: status, xhr: xhr });
		                },
		                success: proxy(function (data) {
		                    kendo.ui.progress(that.content, false);
	
		                    that.content.html(data);
	
		                    that.trigger(CONTENTLOAD);
		                }, that)
		            }, options));
		        },
	
		        _documentKeyDown: function(e) {
		            if (e.keyCode === kendo.keys.ESC) {
		                this.hide();
		            }
		        },
	
		        refresh: function() {
		            var that = this,
		                popup = that.popup;
	
		            if (popup && popup.options.anchor) {
		                that._appendContent(popup.options.anchor);
		            }
		        },
	
		        hide: function() {
		            if (this.popup) {
		                this.popup.close();
		            }
		        },
	
		        show: function(target) {
		            target = target || this.element;
	
		            saveTitleAttributes(target);
		            this._show(target);
		        },
	
		        _show: function(target) {
		            var that = this,
		                current = that.target();
	
		            if (!that.popup) {
		                that._initPopup();
		            }
	
		            if (current && current[0] != target[0]) {
		                that.popup.close();
		                that.popup.element.kendoStop(true, true);// animation can be too long to hide the element before it is shown again
		            }
	
		            if (!current || current[0] != target[0]) {
		                that._appendContent(target);
		                that.popup.options.anchor = target;
		            }
	
		            that.popup.one("deactivate", function() {
		                restoreTitle(target);
		                target.removeAttr(DESCRIBEDBY);
	
		                this.element
		                    .removeAttr("id")
		                    .attr("aria-hidden", true);
	
		                DOCUMENT.off("keydown" + NS, that._documentKeyDownHandler);
		            });
	
		            that.popup.open();
		        },
	
		        _initPopup: function() {
		            var that = this,
		                options = that.options,
		                wrapper = $(kendo.template(TEMPLATE)({
		                    callout: options.callout && options.position !== "center",
		                    dir: DIRCLASSES[options.position],
		                    autoHide: options.autoHide
		                }));
	
		            that.popup = new Popup(wrapper, extend({
		                autosize:true,
		                activate: function() {
		                    var anchor = this.options.anchor,
		                        ariaId = anchor[0].id || that.element[0].id;
	
		                    if (ariaId) {
		                        anchor.attr(DESCRIBEDBY, ariaId + ARIAIDSUFFIX);
		                        this.element.attr("id", ariaId + ARIAIDSUFFIX);
		                    }
	
		                    if (options.callout) {
		                        that._positionCallout();
		                    }
	
		                    this.element.removeAttr("aria-hidden");
	
		                    DOCUMENT.on("keydown" + NS, that._documentKeyDownHandler);
	
		                    that.trigger(SHOW);
		                },
		                close: function() {
		                    that.trigger(HIDE);
		                },
		                copyAnchorStyles: false,
		                animation: options.animation
		            }, POSITIONS[options.position]));
	
		            wrapper.css({
		                width: options.width,
		                height: options.height
		            });
	
		            that.content = wrapper.find(".k-tooltip-content");
		            that.arrow = wrapper.find(".k-callout");
	
		            if (options.autoHide && this._isShownOnMouseEnter()) {
		                wrapper.on("mouseleave" + NS, proxy(that._mouseleave, that));
		            } else {
		                wrapper.on("click" + NS, ".k-tooltip-button", proxy(that._closeButtonClick, that));
		            }
		        },
	
		        _closeButtonClick: function(e) {
		            e.preventDefault();
		            this.hide();
		        },
	
		        _mouseleave: function(e) {
		            this._closePopup(e.currentTarget);
		            clearTimeout(this.timeout);
		        },
	
		        _blur: function(e){
		            this._closePopup(e.currentTarget);
		        },
	
		        _closePopup: function(target){
		            if (this.popup) {
		                this.popup.close();
		            } else {
		                restoreTitle($(target));
		            }
		        },
	
		        target: function() {
		            if (this.popup) {
		                return this.popup.options.anchor;
		            }
		            return null;
		        },
	
		        _positionCallout: function() {
		            var that = this,
		                position = that.options.position,
		                dimensions = that.dimensions,
		                offset = dimensions.offset,
		                popup = that.popup,
		                anchor = popup.options.anchor,
		                anchorOffset = $(anchor).offset(),
		                elementOffset = $(popup.element).offset(),
		                cssClass = DIRCLASSES[popup.flipped ? REVERSE[position] : position],
		                offsetAmount = anchorOffset[offset] - elementOffset[offset] + ($(anchor)[dimensions.size]() / 2);
	
		            that.arrow
		               .removeClass("k-callout-n k-callout-s k-callout-w k-callout-e")
		               .addClass("k-callout-" + cssClass)
		               .css(offset, offsetAmount);
		        },
	
		        destroy: function() {
		            var popup = this.popup;
	
		            if (popup) {
		                popup.element.off(NS);
		                popup.destroy();
		            }
	
		            clearTimeout(this.timeout);
	
		            this.element.off(NS);
	
		            DOCUMENT.off("keydown" + NS, this._documentKeyDownHandler);
	
		            Widget.fn.destroy.call(this);
		        }
		    });
	
		    kendo.ui.plugin(Tooltip);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1274);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1274:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "router",
		    name: "Router",
		    category: "framework",
		    description: "The Router class is responsible for tracking the application state and navigating between the application states.",
		    depends: [ "core" ],
		    hidden: false
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        CHANGE = "change",
		        BACK = "back",
		        SAME = "same",
		        support = kendo.support,
		        location = window.location,
		        history = window.history,
		        CHECK_URL_INTERVAL = 50,
		        BROKEN_BACK_NAV = kendo.support.browser.msie,
		        hashStrip = /^#*/,
		        document = window.document;
	
		    function absoluteURL(path, pathPrefix) {
		        if (!pathPrefix) {
		            return path;
		        }
	
		        if (path + "/" === pathPrefix) {
		            path = pathPrefix;
		        }
	
		        var regEx = new RegExp("^" + pathPrefix, "i");
	
		        if (!regEx.test(path)) {
		            path = pathPrefix + "/" + path;
		        }
	
		        return location.protocol + '//' + (location.host + "/" + path).replace(/\/\/+/g, '/');
		    }
	
		    function hashDelimiter(bang) {
		        return bang ? "#!" : "#";
		    }
	
		    function locationHash(hashDelimiter) {
		        var href = location.href;
	
		        // ignore normal anchors if in hashbang mode - however, still return "" if no hash present
		        if (hashDelimiter === "#!" && href.indexOf("#") > -1 && href.indexOf("#!") < 0) {
		            return null;
		        }
	
		        return href.split(hashDelimiter)[1] || "";
		    }
	
		    function stripRoot(root, url) {
		        if (url.indexOf(root) === 0) {
		            return (url.substr(root.length)).replace(/\/\//g, '/');
		        } else {
		            return url;
		        }
		    }
	
		    var HistoryAdapter = kendo.Class.extend({
		        back: function() {
		            if (BROKEN_BACK_NAV) {
		                setTimeout(function() { history.back(); });
		            } else {
		                history.back();
		            }
		        },
	
		        forward: function() {
		            if (BROKEN_BACK_NAV) {
		                setTimeout(function() { history.forward(); });
		            } else {
		                history.forward();
		            }
		        },
	
		        length: function() {
		            return history.length;
		        },
	
		        replaceLocation: function(url) {
		            location.replace(url);
		        }
		    });
	
		    var PushStateAdapter = HistoryAdapter.extend({
		        init: function(root) {
		            this.root = root;
		        },
	
		        navigate: function(to) {
		            history.pushState({}, document.title, absoluteURL(to, this.root));
		        },
	
		        replace: function(to) {
		            history.replaceState({}, document.title, absoluteURL(to, this.root));
		        },
	
		        normalize: function(url) {
		            return stripRoot(this.root, url);
		        },
	
		        current: function() {
		            var current = location.pathname;
	
		            if (location.search) {
		                current += location.search;
		            }
	
		            return stripRoot(this.root, current);
		        },
	
		        change: function(callback) {
		            $(window).bind("popstate.kendo", callback);
		        },
	
		        stop: function() {
		            $(window).unbind("popstate.kendo");
		        },
	
		        normalizeCurrent: function(options) {
		            var fixedUrl,
		                root = options.root,
		                pathname = location.pathname,
		                hash = locationHash(hashDelimiter(options.hashBang));
	
		            if (root === pathname + "/") {
		                fixedUrl = root;
		            }
	
		            if (root === pathname && hash) {
		                fixedUrl = absoluteURL(hash.replace(hashStrip, ''), root);
		            }
	
		            if (fixedUrl) {
		                history.pushState({}, document.title, fixedUrl);
		            }
		        }
		    });
	
		    function fixHash(url) {
		        return url.replace(/^(#)?/, "#");
		    }
	
		    function fixBang(url) {
		        return url.replace(/^(#(!)?)?/, "#!");
		    }
	
		    var HashAdapter = HistoryAdapter.extend({
		        init: function(bang) {
		            this._id = kendo.guid();
		            this.prefix = hashDelimiter(bang);
		            this.fix = bang ? fixBang : fixHash;
		        },
	
		        navigate: function(to) {
		            location.hash = this.fix(to);
		        },
	
		        replace: function(to) {
		            this.replaceLocation(this.fix(to));
		        },
	
		        normalize: function(url) {
		            if (url.indexOf(this.prefix) < 0) {
		               return url;
		            } else {
		                return url.split(this.prefix)[1];
		            }
		        },
	
		        change: function(callback) {
		            if (support.hashChange) {
		                $(window).on("hashchange." + this._id, callback);
		            } else {
		                this._interval = setInterval(callback, CHECK_URL_INTERVAL);
		            }
		        },
	
		        stop: function() {
		            $(window).off("hashchange." + this._id);
		            clearInterval(this._interval);
		        },
	
		        current: function() {
		            return locationHash(this.prefix);
		        },
	
		        normalizeCurrent: function(options) {
		            var pathname = location.pathname,
		                root = options.root;
	
		            if (options.pushState && root !== pathname) {
		                this.replaceLocation(root + this.prefix + stripRoot(root, pathname));
		                return true; // browser will reload at this point.
		            }
	
		            return false;
		        }
		    });
	
		    var History = kendo.Observable.extend({
		        start: function(options) {
		            options = options || {};
	
		            this.bind([CHANGE, BACK, SAME], options);
	
		            if (this._started) {
		                return;
		            }
	
		            this._started = true;
	
		            options.root = options.root || "/";
	
		            var adapter = this.createAdapter(options),
		                current;
	
		            // adapter may reload the document
		            if (adapter.normalizeCurrent(options)) {
		                return;
		            }
	
		            current = adapter.current();
	
		            $.extend(this, {
		                adapter: adapter,
		                root: options.root,
		                historyLength: adapter.length(),
		                current: current,
		                locations: [current]
		            });
	
		            adapter.change($.proxy(this, "_checkUrl"));
		        },
	
		        createAdapter:function(options) {
		           return support.pushState && options.pushState ? new PushStateAdapter(options.root) : new HashAdapter(options.hashBang);
		        },
	
		        stop: function() {
		            if (!this._started) {
		                return;
		            }
		            this.adapter.stop();
		            this.unbind(CHANGE);
		            this._started = false;
		        },
	
		        change: function(callback) {
		            this.bind(CHANGE, callback);
		        },
	
		        replace: function(to, silent) {
	
		            this._navigate(to, silent, function(adapter) {
		                adapter.replace(to);
		                this.locations[this.locations.length - 1] = this.current;
		            });
		        },
	
		        navigate: function(to, silent) {
		            if (to === "#:back") {
		                this.backCalled = true;
		                this.adapter.back();
		                return;
		            }
	
		            this._navigate(to, silent, function(adapter) {
		                adapter.navigate(to);
		                this.locations.push(this.current);
		            });
		        },
	
		        _navigate: function(to, silent, callback) {
		            var adapter = this.adapter;
	
		            to = adapter.normalize(to);
	
		            if (this.current === to || this.current === decodeURIComponent(to)) {
		                this.trigger(SAME);
		                return;
		            }
	
		            if (!silent) {
		                if (this.trigger(CHANGE, { url: to, decode: false })) {
		                    return;
		                }
		            }
	
		            this.current = to;
	
		            callback.call(this, adapter);
	
		            this.historyLength = adapter.length();
		        },
	
		        _checkUrl: function() {
		            var adapter = this.adapter,
		                current = adapter.current(),
		                newLength = adapter.length(),
		                navigatingInExisting = this.historyLength === newLength,
		                back = current === this.locations[this.locations.length - 2] && navigatingInExisting,
		                backCalled = this.backCalled,
		                prev = this.current;
	
		            if (current === null || this.current === current || this.current === decodeURIComponent(current)) {
		                return true;
		            }
	
		            this.historyLength = newLength;
		            this.backCalled = false;
	
		            this.current = current;
	
		            if (back && this.trigger("back", { url: prev, to: current })) {
		                adapter.forward();
		                this.current = prev;
		                return;
		            }
	
		            if (this.trigger(CHANGE, { url: current, backButtonPressed: !backCalled })) {
		                if (back) {
		                    adapter.forward();
		                } else {
		                    adapter.back();
		                    this.historyLength --;
		                }
		                this.current = prev;
		                return;
		            }
	
		            if (back) {
		                this.locations.pop();
		            } else {
		                this.locations.push(current);
		            }
		        }
		    });
	
		    kendo.History = History;
		    kendo.History.HistoryAdapter = HistoryAdapter;
		    kendo.History.HashAdapter = HashAdapter;
		    kendo.History.PushStateAdapter = PushStateAdapter;
		    kendo.absoluteURL = absoluteURL;
		    kendo.history = new History();
		})(window.kendo.jQuery);
	
		(function() {
		    var kendo = window.kendo,
		        history = kendo.history,
		        Observable = kendo.Observable,
		        INIT = "init",
		        ROUTE_MISSING = "routeMissing",
		        CHANGE = "change",
		        BACK = "back",
		        SAME = "same",
		        optionalParam = /\((.*?)\)/g,
		        namedParam = /(\(\?)?:\w+/g,
		        splatParam = /\*\w+/g,
		        escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
		    function namedParamReplace(match, optional) {
		        return optional ? match : '([^\/]+)';
		    }
	
		    function routeToRegExp(route, ignoreCase) {
		        return new RegExp('^' + route
		            .replace(escapeRegExp, '\\$&')
		            .replace(optionalParam, '(?:$1)?')
		            .replace(namedParam, namedParamReplace)
		            .replace(splatParam, '(.*?)') + '$', ignoreCase ? "i" : "");
		    }
	
		    function stripUrl(url) {
		        return url.replace(/(\?.*)|(#.*)/g, "");
		    }
	
		    var Route = kendo.Class.extend({
		        init: function(route, callback, ignoreCase) {
		            if (!(route instanceof RegExp)) {
		                route = routeToRegExp(route, ignoreCase);
		            }
	
		            this.route = route;
		            this._callback = callback;
		        },
	
		        callback: function(url, back, decode) {
		            var params,
		                idx = 0,
		                length,
		                queryStringParams = kendo.parseQueryStringParams(url);
		                queryStringParams._back = back;
	
		            url = stripUrl(url);
		            params = this.route.exec(url).slice(1);
		            length = params.length;
	
		            if (decode) {
		                for (; idx < length; idx ++) {
		                    if (typeof params[idx] !== 'undefined') {
		                        params[idx] = decodeURIComponent(params[idx]);
		                    }
		                }
		            }
	
		            params.push(queryStringParams);
	
		            this._callback.apply(null, params);
		        },
	
		        worksWith: function(url, back, decode) {
		            if (this.route.test(stripUrl(url))) {
		                this.callback(url, back, decode);
		                return true;
		            } else {
		                return false;
		            }
		        }
		    });
	
		    var Router = Observable.extend({
		        init: function(options) {
		            if (!options) {
		                options = {};
		            }
	
		            Observable.fn.init.call(this);
	
		            this.routes = [];
		            this.pushState = options.pushState;
		            this.hashBang = options.hashBang;
		            this.root = options.root;
		            this.ignoreCase = options.ignoreCase !== false;
	
		            this.bind([INIT, ROUTE_MISSING, CHANGE, SAME], options);
		        },
	
		        destroy: function() {
		            history.unbind(CHANGE, this._urlChangedProxy);
		            history.unbind(SAME, this._sameProxy);
		            history.unbind(BACK, this._backProxy);
		            this.unbind();
		        },
	
		        start: function() {
		            var that = this,
		                sameProxy = function() { that._same(); },
		                backProxy = function(e) { that._back(e); },
		                urlChangedProxy = function(e) { that._urlChanged(e); };
	
		            history.start({
		                same: sameProxy,
		                change: urlChangedProxy,
		                back: backProxy,
		                pushState: that.pushState,
		                hashBang: that.hashBang,
		                root: that.root
		            });
	
		            var initEventObject = { url: history.current || "/", preventDefault: $.noop };
	
		            if (!that.trigger(INIT, initEventObject)) {
		                that._urlChanged(initEventObject);
		            }
	
		            this._urlChangedProxy = urlChangedProxy;
		            this._backProxy = backProxy;
		        },
	
		        route: function(route, callback) {
		            this.routes.push(new Route(route, callback, this.ignoreCase));
		        },
	
		        navigate: function(url, silent) {
		            kendo.history.navigate(url, silent);
		        },
	
		        replace: function(url, silent) {
		            kendo.history.replace(url, silent);
		        },
	
		        _back: function(e) {
		            if (this.trigger(BACK, { url: e.url, to: e.to })) {
		                e.preventDefault();
		            }
		        },
	
		        _same: function() {
		            this.trigger(SAME);
		        },
	
		        _urlChanged: function(e) {
		            var url = e.url;
		            var decode = !!e.decode;
		            var back = e.backButtonPressed;
	
		            if (!url) {
		                url = "/";
		            }
	
		            if (this.trigger(CHANGE, { url: e.url, params: kendo.parseQueryStringParams(e.url), backButtonPressed: back })) {
		                e.preventDefault();
		                return;
		            }
	
		            var idx = 0,
		                routes = this.routes,
		                route,
		                length = routes.length;
	
		            for (; idx < length; idx ++) {
		                 route = routes[idx];
	
		                 if (route.worksWith(url, back, decode)) {
		                    return;
		                 }
		            }
	
		            if (this.trigger(ROUTE_MISSING, { url: url, params: kendo.parseQueryStringParams(url), backButtonPressed: back })) {
		                e.preventDefault();
		            }
		        }
		    });
	
		    kendo.Router = Router;
		})();
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1352);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1058:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1352:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1058), __webpack_require__(1054) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "view",
		    name: "View",
		    category: "framework",
		    description: "The View class instantiates and handles the events of a certain screen from the application.",
		    depends: [ "core", "binder", "fx" ],
		    hidden: false
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Observable = kendo.Observable,
		        SCRIPT = "SCRIPT",
		        INIT = "init",
		        SHOW = "show",
		        HIDE = "hide",
		        TRANSITION_START = "transitionStart",
		        TRANSITION_END = "transitionEnd",
	
		        ATTACH = "attach",
		        DETACH = "detach",
		        sizzleErrorRegExp = /unrecognized expression/;
	
		    var View = Observable.extend({
		        init: function(content, options) {
		            var that = this;
		            options = options || {};
	
		            Observable.fn.init.call(that);
		            that.content = content;
		            that.id = kendo.guid();
		            that.tagName = options.tagName || "div";
		            that.model = options.model;
		            that._wrap = options.wrap !== false;
		            this._evalTemplate = options.evalTemplate || false;
		            that._fragments = {};
	
		            that.bind([ INIT, SHOW, HIDE, TRANSITION_START, TRANSITION_END ], options);
		        },
	
		        render: function(container) {
		            var that = this,
		                notInitialized = !that.element;
	
		            // The order below matters - kendo.bind should happen when the element is in the DOM, and show should be triggered after init.
	
		            if (notInitialized) {
		                that.element = that._createElement();
		            }
	
		            if (container) {
		                $(container).append(that.element);
		            }
	
		            if (notInitialized) {
		                kendo.bind(that.element, that.model);
		                that.trigger(INIT);
		            }
	
		            if (container) {
		                that._eachFragment(ATTACH);
		                that.trigger(SHOW);
		            }
	
		            return that.element;
		        },
	
		        clone: function() {
		            return new ViewClone(this);
		        },
	
		        triggerBeforeShow: function() {
		            return true;
		        },
	
		        triggerBeforeHide: function() {
		            return true;
		        },
	
		        showStart: function() {
		            this.element.css("display", "");
		        },
	
		        showEnd: function() {
		        },
	
		        hideEnd: function() {
		            this.hide();
		        },
	
		        beforeTransition: function(type){
		            this.trigger(TRANSITION_START, { type: type });
		        },
	
		        afterTransition: function(type){
		            this.trigger(TRANSITION_END, { type: type });
		        },
	
		        hide: function() {
		            this._eachFragment(DETACH);
		            this.element.detach();
		            this.trigger(HIDE);
		        },
	
		        destroy: function() {
		            var element = this.element;
	
		            if (element) {
		                kendo.unbind(element);
		                kendo.destroy(element);
		                element.remove();
		            }
		        },
	
		        fragments: function(fragments) {
		            $.extend(this._fragments, fragments);
		        },
	
		        _eachFragment: function(methodName) {
		            for (var placeholder in this._fragments) {
		                this._fragments[placeholder][methodName](this, placeholder);
		            }
		        },
	
		        _createElement: function() {
		            var that = this,
		                wrapper = "<" + that.tagName + " />",
		                element,
		                content;
	
		            try {
		                content = $(document.getElementById(that.content) || that.content); // support passing id without #
	
		                if (content[0].tagName === SCRIPT) {
		                    content = content.html();
		                }
		            } catch(e) {
		                if (sizzleErrorRegExp.test(e.message)) {
		                    content = that.content;
		                }
		            }
	
		            if (typeof content === "string") {
		                content = content.replace(/^\s+|\s+$/g, '');
		                if (that._evalTemplate) {
		                    content = kendo.template(content)(that.model || {});
		                }
	
		                element = $(wrapper).append(content);
		                // drop the wrapper if asked - this seems like the easiest (although not very intuitive) way to avoid messing up templates with questionable content, like this one for instance:
		                // <script id="my-template">
		                // foo
		                // <span> Span </span>
		                // </script>
		                if (!that._wrap) {
		                   element = element.contents();
		                }
		            } else {
		                element = content;
		                if (that._evalTemplate) {
		                    var result = $(kendo.template($("<div />").append(element.clone(true)).html())(that.model || {}));
	
		                    // template uses DOM
		                    if ($.contains(document, element[0])) {
		                        element.replaceWith(result);
		                    }
	
		                    element = result;
		                }
		                if (that._wrap) {
		                    element = element.wrapAll(wrapper).parent();
		                }
		            }
	
		            return element;
		        }
		    });
	
		    var ViewClone = kendo.Class.extend({
		        init: function(view) {
		            $.extend(this, {
		                element: view.element.clone(true),
		                transition: view.transition,
		                id: view.id
		            });
	
		            view.element.parent().append(this.element);
		        },
	
		        hideEnd: function() {
		            this.element.remove();
		        },
	
		        beforeTransition: $.noop,
		        afterTransition: $.noop
		    });
	
		    var Layout = View.extend({
		        init: function(content, options) {
		            View.fn.init.call(this, content, options);
		            this.containers = {};
		        },
	
		        container: function(selector) {
		            var container = this.containers[selector];
	
		            if (!container) {
		                container = this._createContainer(selector);
		                this.containers[selector] = container;
		            }
	
		            return container;
		        },
	
		        showIn: function(selector, view, transition) {
		            this.container(selector).show(view, transition);
		        },
	
		        _createContainer: function(selector) {
		            var root = this.render(),
		                element = root.find(selector),
		                container;
	
		            if (!element.length && root.is(selector)) {
		                if (root.is(selector)) {
		                    element = root;
		                } else {
	
		                    throw new Error("can't find a container with the specified " + selector + " selector");
		                }
		            }
	
		            container = new ViewContainer(element);
	
		            container.bind("accepted", function(e) {
		                e.view.render(element);
		            });
	
		            return container;
		        }
		    });
	
		    var Fragment = View.extend({
		        attach: function(view, placeholder) {
		            view.element.find(placeholder).replaceWith(this.render());
		        },
	
		        detach: function() {
		        }
		    });
	
		    var transitionRegExp = /^(\w+)(:(\w+))?( (\w+))?$/;
	
		    function parseTransition(transition) {
		        if (!transition){
		            return {};
		        }
	
		        var matches = transition.match(transitionRegExp) || [];
	
		        return {
		            type: matches[1],
		            direction: matches[3],
		            reverse: matches[5] === "reverse"
		        };
		    }
	
		    var ViewContainer = Observable.extend({
		        init: function(container) {
		            Observable.fn.init.call(this);
		            this.container = container;
		            this.history = [];
		            this.view = null;
		            this.running = false;
		        },
	
		        after: function() {
		            this.running = false;
		            this.trigger("complete", {view: this.view});
		            this.trigger("after");
		        },
	
		        end: function() {
		            this.view.showEnd();
		            this.previous.hideEnd();
		            this.after();
		        },
	
		        show: function(view, transition, locationID) {
		            if (!view.triggerBeforeShow() || (this.view && !this.view.triggerBeforeHide())) {
		                this.trigger("after");
		                return false;
		            }
	
		            locationID = locationID || view.id;
	
		            var that = this,
		                current = (view === that.view) ? view.clone() : that.view,
		                history = that.history,
		                previousEntry = history[history.length - 2] || {},
		                back = previousEntry.id === locationID,
		                // If explicit transition is set, it will be with highest priority
		                // Next we will try using the history record transition or the view transition configuration
		                theTransition = transition || ( back ? history[history.length - 1].transition : view.transition ),
		                transitionData = parseTransition(theTransition);
	
		            if (that.running) {
		                that.effect.stop();
		            }
	
		            if (theTransition === "none") {
		                theTransition = null;
		            }
	
		            that.trigger("accepted", { view: view });
		            that.view = view;
		            that.previous = current;
		            that.running = true;
	
		            if (!back) {
		                history.push({ id: locationID, transition: theTransition });
		            } else {
		                history.pop();
		            }
	
		            if (!current) {
		                view.showStart();
		                view.showEnd();
		                that.after();
		                return true;
		            }
	
		            if (!theTransition || !kendo.effects.enabled) {
		                view.showStart();
		                that.end();
		            } else {
		                // hide the view element before init/show - prevents blinks on iPad
		                // the replace effect will remove this class
		                view.element.addClass("k-fx-hidden");
		                view.showStart();
		                // do not reverse the explicit transition
		                if (back && !transition) {
		                    transitionData.reverse = !transitionData.reverse;
		                }
	
		                that.effect = kendo.fx(view.element).replace(current.element, transitionData.type)
		                    .beforeTransition(function() {
		                        view.beforeTransition("show");
		                        current.beforeTransition("hide");
		                    })
		                    .afterTransition(function() {
		                        view.afterTransition("show");
		                        current.afterTransition("hide");
		                    })
		                    .direction(transitionData.direction)
		                    .setReverse(transitionData.reverse);
	
		                that.effect.run().then(function() { that.end(); });
		            }
	
		            return true;
		        }
		    });
	
		    kendo.ViewContainer = ViewContainer;
		    kendo.Fragment = Fragment;
		    kendo.Layout = Layout;
		    kendo.View = View;
		    kendo.ViewClone = ViewClone;
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1024);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1024:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "binder",
		    name: "MVVM",
		    category: "framework",
		    description: "Model View ViewModel (MVVM) is a design pattern which helps developers separate the Model (the data) from the View (the UI).",
		    depends: [ "core", "data" ]
		};
	
		/*jshint eqnull: true */
		(function ($, undefined) {
		    var kendo = window.kendo,
		        Observable = kendo.Observable,
		        ObservableObject = kendo.data.ObservableObject,
		        ObservableArray = kendo.data.ObservableArray,
		        toString = {}.toString,
		        binders = {},
		        Class = kendo.Class,
		        proxy = $.proxy,
		        VALUE = "value",
		        SOURCE = "source",
		        EVENTS = "events",
		        CHECKED = "checked",
		        CSS = "css",
		        deleteExpando = true,
		        FUNCTION = "function",
		        CHANGE = "change";
	
		    (function() {
		        var a = document.createElement("a");
	
		        try {
		            delete a.test;
		        } catch(e) {
		            deleteExpando = false;
		        }
		    })();
	
		    var Binding = Observable.extend( {
		        init: function(parents, path) {
		            var that = this;
	
		            Observable.fn.init.call(that);
	
		            that.source = parents[0];
		            that.parents = parents;
		            that.path = path;
		            that.dependencies = {};
		            that.dependencies[path] = true;
		            that.observable = that.source instanceof Observable;
	
		            that._access = function(e) {
		                that.dependencies[e.field] = true;
		            };
	
		            if (that.observable) {
		                that._change = function(e) {
		                    that.change(e);
		                };
	
		                that.source.bind(CHANGE, that._change);
		            }
		        },
	
		        _parents: function() {
		            var parents = this.parents;
		            var value = this.get();
	
		            if (value && typeof value.parent == "function") {
		                var parent = value.parent();
	
		                if ($.inArray(parent, parents) < 0) {
		                    parents = [parent].concat(parents);
		                }
		            }
	
		            return parents;
		        },
	
		        change: function(e) {
		            var dependency,
		                ch,
		                field = e.field,
		                that = this;
	
		            if (that.path === "this") {
		                that.trigger(CHANGE, e);
		            } else {
		                for (dependency in that.dependencies) {
		                    if (dependency.indexOf(field) === 0) {
		                       ch = dependency.charAt(field.length);
	
		                       if (!ch || ch === "." || ch === "[") {
		                            that.trigger(CHANGE, e);
		                            break;
		                       }
		                    }
		                }
		            }
		        },
	
		        start: function(source) {
		            source.bind("get", this._access);
		        },
	
		        stop: function(source) {
		            source.unbind("get", this._access);
		        },
	
		        get: function() {
	
		            var that = this,
		                source = that.source,
		                index = 0,
		                path = that.path,
		                result = source;
	
		            if (!that.observable) {
		                return result;
		            }
	
		            that.start(that.source);
	
		            result = source.get(path);
	
		            // Traverse the observable hierarchy if the binding is not resolved at the current level.
		            while (result === undefined && source) {
	
		                source = that.parents[++index];
	
		                if (source instanceof ObservableObject) {
		                    result = source.get(path);
		                }
		            }
	
		            // second pass try to get the parent from the object hierarchy
		            if (result === undefined) {
		                source = that.source; //get the initial source
	
		                while (result === undefined && source) {
		                    source = source.parent();
	
		                    if (source instanceof ObservableObject) {
		                        result = source.get(path);
		                    }
		                }
		            }
	
		            // If the result is a function - invoke it
		            if (typeof result === "function") {
		                index = path.lastIndexOf(".");
	
		                // If the function is a member of a nested observable object make that nested observable the context (this) of the function
		                if (index > 0) {
		                    source = source.get(path.substring(0, index));
		                }
	
		                // Invoke the function
		                that.start(source);
	
		                if (source !== that.source) {
		                    result = result.call(source, that.source);
		                } else {
		                    result = result.call(source);
		                }
	
		                that.stop(source);
		            }
	
		            // If the binding is resolved by a parent object
		            if (source && source !== that.source) {
	
		                that.currentSource = source; // save parent object
	
		                // Listen for changes in the parent object
		                source.unbind(CHANGE, that._change)
		                      .bind(CHANGE, that._change);
		            }
	
		            that.stop(that.source);
	
		            return result;
		        },
	
		        set: function(value) {
		            var source = this.currentSource || this.source;
	
		            var field = kendo.getter(this.path)(source);
	
		            if (typeof field === "function") {
		                if (source !== this.source) {
		                    field.call(source, this.source, value);
		                } else {
		                    field.call(source, value);
		                }
		            } else {
		                source.set(this.path, value);
		            }
		        },
	
		        destroy: function() {
		            if (this.observable) {
		                this.source.unbind(CHANGE, this._change);
		                if(this.currentSource) {
		                    this.currentSource.unbind(CHANGE, this._change);
		                }
		            }
	
		            this.unbind();
		        }
		    });
	
		    var EventBinding = Binding.extend( {
		        get: function() {
		            var source = this.source,
		                path = this.path,
		                index = 0,
		                handler;
	
		            handler = source.get(path);
	
		            while (!handler && source) {
		                source = this.parents[++index];
	
		                if (source instanceof ObservableObject) {
		                    handler = source.get(path);
		                }
		            }
	
		            return proxy(handler, source);
		        }
		    });
	
		    var TemplateBinding = Binding.extend( {
		        init: function(source, path, template) {
		            var that = this;
	
		            Binding.fn.init.call(that, source, path);
	
		            that.template = template;
		        },
	
		        render: function(value) {
		            var html;
	
		            this.start(this.source);
	
		            html = kendo.render(this.template, value);
	
		            this.stop(this.source);
	
		            return html;
		        }
		    });
	
		    var Binder = Class.extend({
		        init: function(element, bindings, options) {
		            this.element = element;
		            this.bindings = bindings;
		            this.options = options;
		        },
	
		        bind: function(binding, attribute) {
		            var that = this;
	
		            binding = attribute ? binding[attribute] : binding;
	
		            binding.bind(CHANGE, function(e) {
		                that.refresh(attribute || e);
		            });
	
		            that.refresh(attribute);
		        },
	
		        destroy: function() {
		        }
		    });
	
		    var TypedBinder = Binder.extend({
		        dataType: function() {
		            var dataType = this.element.getAttribute("data-type") || this.element.type || "text";
		            return dataType.toLowerCase();
		        },
	
		        parsedValue: function() {
		            return this._parseValue(this.element.value, this.dataType());
		        },
	
		        _parseValue: function (value, dataType){
		            if (dataType == "date") {
		                value = kendo.parseDate(value, "yyyy-MM-dd");
		            } else if (dataType == "datetime-local") {
		                value = kendo.parseDate(value, ["yyyy-MM-ddTHH:mm:ss", "yyyy-MM-ddTHH:mm"] );
		            } else if (dataType == "number") {
		                value = kendo.parseFloat(value);
		            } else if (dataType == "boolean"){
		                value = value.toLowerCase();
		                if(kendo.parseFloat(value) !== null){
		                    value = Boolean(kendo.parseFloat(value));
		                }else{
		                    value = (value.toLowerCase() === "true");
		                }
		            }
		            return value;
		        }
		    });
	
		    binders.attr = Binder.extend({
		        refresh: function(key) {
		            this.element.setAttribute(key, this.bindings.attr[key].get());
		        }
		    });
	
		    binders.css = Binder.extend({
		        init: function(element, bindings, options) {
		            Binder.fn.init.call(this, element, bindings, options);
		            this.classes = {};
		        },
		        refresh: function(className) {
		            var element = $(this.element),
		                binding = this.bindings.css[className],
		                hasClass = this.classes[className] = binding.get();
		            if(hasClass){
		                element.addClass(className);
		            }else{
		                element.removeClass(className);
		            }
		        }
		    });
	
		    binders.style = Binder.extend({
		        refresh: function(key) {
		            this.element.style[key] = this.bindings.style[key].get() || "";
		        }
		    });
	
		    binders.enabled = Binder.extend({
		        refresh: function() {
		            if (this.bindings.enabled.get()) {
		                this.element.removeAttribute("disabled");
		            } else {
		                this.element.setAttribute("disabled", "disabled");
		            }
		        }
		    });
	
		    binders.readonly = Binder.extend({
		       refresh: function() {
		            if (this.bindings.readonly.get()) {
		                this.element.setAttribute("readonly", "readonly");
		            } else {
		                this.element.removeAttribute("readonly");
		            }
		       }
		    });
	
		    binders.disabled = Binder.extend({
		        refresh: function() {
		            if (this.bindings.disabled.get()) {
		                this.element.setAttribute("disabled", "disabled");
		            } else {
		                this.element.removeAttribute("disabled");
		            }
		        }
		    });
	
		    binders.events = Binder.extend({
		        init: function(element, bindings, options) {
		            Binder.fn.init.call(this, element, bindings, options);
		            this.handlers = {};
		        },
	
		        refresh: function(key) {
		            var element = $(this.element),
		                binding = this.bindings.events[key],
		                handler = this.handlers[key];
	
		            if (handler) {
		                element.off(key, handler);
		            }
	
		            handler = this.handlers[key] = binding.get();
	
		            element.on(key, binding.source, handler);
		        },
	
		        destroy: function() {
		            var element = $(this.element),
		                handler;
	
		            for (handler in this.handlers) {
		                element.off(handler, this.handlers[handler]);
		            }
		        }
		    });
	
		    binders.text = Binder.extend({
		        refresh: function() {
		            var text = this.bindings.text.get();
		            var dataFormat = this.element.getAttribute("data-format") || "";
		            if (text == null) {
		                text = "";
		            }
	
		            $(this.element).text(kendo.toString(text, dataFormat));
		        }
		    });
	
		    binders.visible = Binder.extend({
		        refresh: function() {
		            if (this.bindings.visible.get()) {
		                this.element.style.display = "";
		            } else {
		                this.element.style.display = "none";
		            }
		        }
		    });
	
		    binders.invisible = Binder.extend({
		        refresh: function() {
		            if (!this.bindings.invisible.get()) {
		                this.element.style.display = "";
		            } else {
		                this.element.style.display = "none";
		            }
		        }
		  });
	
		    binders.html = Binder.extend({
		        refresh: function() {
		            this.element.innerHTML = this.bindings.html.get();
		        }
		    });
	
		    binders.value = TypedBinder.extend({
		        init: function(element, bindings, options) {
		            TypedBinder.fn.init.call(this, element, bindings, options);
	
		            this._change = proxy(this.change, this);
		            this.eventName = options.valueUpdate || CHANGE;
	
		            $(this.element).on(this.eventName, this._change);
	
		            this._initChange = false;
		        },
	
		        change: function() {
		            this._initChange = this.eventName != CHANGE;
	
		            this.bindings[VALUE].set(this.parsedValue());
	
		            this._initChange = false;
		        },
	
		        refresh: function() {
		            if (!this._initChange) {
		                var value = this.bindings[VALUE].get();
	
		                if (value == null) {
		                    value = "";
		                }
	
		                var type = this.dataType();
	
		                if (type == "date") {
		                    value = kendo.toString(value, "yyyy-MM-dd");
		                } else if (type == "datetime-local") {
		                    value = kendo.toString(value, "yyyy-MM-ddTHH:mm:ss");
		                }
	
		                this.element.value = value;
		            }
	
		            this._initChange = false;
		        },
	
		        destroy: function() {
		            $(this.element).off(this.eventName, this._change);
		        }
		    });
	
		    binders.source = Binder.extend({
		        init: function(element, bindings, options) {
		            Binder.fn.init.call(this, element, bindings, options);
	
		            var source = this.bindings.source.get();
	
		            if (source instanceof kendo.data.DataSource && options.autoBind !== false) {
		                source.fetch();
		            }
		        },
	
		        refresh: function(e) {
		            var that = this,
		                source = that.bindings.source.get();
	
		            if (source instanceof ObservableArray || source instanceof kendo.data.DataSource) {
		                e = e || {};
	
		                if (e.action == "add") {
		                    that.add(e.index, e.items);
		                } else if (e.action == "remove") {
		                    that.remove(e.index, e.items);
		                } else if (e.action != "itemchange") {
		                    that.render();
		                }
		            } else {
		                that.render();
		            }
		        },
	
		        container: function() {
		            var element = this.element;
	
		            if (element.nodeName.toLowerCase() == "table") {
		                if (!element.tBodies[0]) {
		                    element.appendChild(document.createElement("tbody"));
		                }
		                element = element.tBodies[0];
		            }
	
		            return element;
		        },
	
		        template: function() {
		            var options = this.options,
		                template = options.template,
		                nodeName = this.container().nodeName.toLowerCase();
	
		            if (!template) {
		                if (nodeName == "select") {
		                    if (options.valueField || options.textField) {
		                        template = kendo.format('<option value="#:{0}#">#:{1}#</option>',
		                            options.valueField || options.textField, options.textField || options.valueField);
		                    } else {
		                        template = "<option>#:data#</option>";
		                    }
		                } else if (nodeName == "tbody") {
		                    template = "<tr><td>#:data#</td></tr>";
		                } else if (nodeName == "ul" || nodeName == "ol") {
		                    template = "<li>#:data#</li>";
		                } else {
		                    template = "#:data#";
		                }
		                template = kendo.template(template);
		            }
	
		            return template;
		        },
	
		        add: function(index, items) {
		            var element = this.container(),
		                parents,
		                idx,
		                length,
		                child,
		                clone = element.cloneNode(false),
		                reference = element.children[index];
	
		            $(clone).html(kendo.render(this.template(), items));
	
		            if (clone.children.length) {
		                parents = this.bindings.source._parents();
	
		                for (idx = 0, length = items.length; idx < length; idx++) {
		                    child = clone.children[0];
		                    element.insertBefore(child, reference || null);
		                    bindElement(child, items[idx], this.options.roles, [items[idx]].concat(parents));
		                }
		            }
		        },
	
		        remove: function(index, items) {
		            var idx, element = this.container();
	
		            for (idx = 0; idx < items.length; idx++) {
		                var child = element.children[index];
		                unbindElementTree(child, true);
		                if (child.parentNode == element) {
		                    element.removeChild(child);
		                }
		            }
		        },
	
		        render: function() {
		            var source = this.bindings.source.get(),
		                parents,
		                idx,
		                length,
		                element = this.container(),
		                template = this.template();
	
		            if (source == null) {
		                return;
		            }
	
		            if (source instanceof kendo.data.DataSource) {
		                source = source.view();
		            }
	
		            if (!(source instanceof ObservableArray) && toString.call(source) !== "[object Array]") {
		                source = [source];
		            }
	
		            if (this.bindings.template) {
		                unbindElementChildren(element, true);
	
		                $(element).html(this.bindings.template.render(source));
	
		                if (element.children.length) {
		                    parents = this.bindings.source._parents();
	
		                    for (idx = 0, length = source.length; idx < length; idx++) {
		                        bindElement(element.children[idx], source[idx], this.options.roles, [source[idx]].concat(parents));
		                    }
		                }
		            } else {
		                $(element).html(kendo.render(template, source));
		            }
		        }
		    });
	
		    binders.input = {
		        checked: TypedBinder.extend({
		            init: function(element, bindings, options) {
		                TypedBinder.fn.init.call(this, element, bindings, options);
		                this._change = proxy(this.change, this);
	
		                $(this.element).change(this._change);
		            },
	
		            change: function() {
		                var element = this.element;
		                var value = this.value();
	
		                if (element.type == "radio") {
		                    value = this.parsedValue();
		                    this.bindings[CHECKED].set(value);
		                } else if (element.type == "checkbox") {
		                    var source = this.bindings[CHECKED].get();
		                    var index;
	
		                    if (source instanceof ObservableArray) {
		                        value = this.parsedValue();
		                        if (value instanceof Date) {
		                            for(var i = 0; i < source.length; i++){
		                                if(source[i] instanceof Date && +source[i] === +value){
		                                    index = i;
		                                    break;
		                                }
		                            }
		                        }else{
		                            index = source.indexOf(value);
		                        }
		                        if (index > -1) {
		                            source.splice(index, 1);
		                        } else {
		                            source.push(value);
		                        }
		                    } else {
		                        this.bindings[CHECKED].set(value);
		                    }
		                }
		            },
	
		            refresh: function() {
		                var value = this.bindings[CHECKED].get(),
		                    source = value,
		                    type = this.dataType(),
		                    element = this.element;
	
		                if (element.type == "checkbox") {
		                    if (source instanceof ObservableArray) {
		                        var index = -1;
		                        value = this.parsedValue();
		                        if(value instanceof Date){
		                            for(var i = 0; i < source.length; i++){
		                                if(source[i] instanceof Date && +source[i] === +value){
		                                    index = i;
		                                    break;
		                                }
		                            }
		                        }else{
		                            index = source.indexOf(value);
		                        }
		                        element.checked = (index >= 0);
		                    }else{
		                        element.checked = source;
		                    }
		                } else if (element.type == "radio") {
		                    if (type == "date") {
		                        value = kendo.toString(value, "yyyy-MM-dd");
		                    } else if (type == "datetime-local") {
		                        value = kendo.toString(value, "yyyy-MM-ddTHH:mm:ss");
		                    }
	
		                    if (value !== null && typeof(value) !== "undefined" && element.value === value.toString()) {
		                        element.checked = true;
		                    } else {
		                        element.checked = false;
		                    }
		                }
		            },
	
		            value: function() {
		                var element = this.element,
		                    value = element.value;
	
		                if (element.type == "checkbox") {
		                    value = element.checked;
		                }
	
		                return value;
		            },
		            destroy: function() {
		                $(this.element).off(CHANGE, this._change);
		            }
		        })
		    };
	
		    binders.select = {
		        source: binders.source.extend({
		            refresh: function(e) {
		                var that = this,
		                    source = that.bindings.source.get();
	
		                if (source instanceof ObservableArray || source instanceof kendo.data.DataSource) {
		                    e = e || {};
		                    if (e.action == "add") {
		                        that.add(e.index, e.items);
		                    } else if (e.action == "remove") {
		                        that.remove(e.index, e.items);
		                    } else if (e.action == "itemchange" || e.action === undefined) {
		                        that.render();
		                        if(that.bindings.value){
		                            if (that.bindings.value) {
		                                var val = retrievePrimitiveValues(that.bindings.value.get(), $(that.element).data("valueField"));
		                                if(val === null) {
		                                    that.element.selectedIndex = -1;
		                                } else {
		                                    that.element.value = val;
		                                }
		                            }
		                        }
		                    }
		                } else {
		                    that.render();
		                }
		            }
		        }),
		        value: TypedBinder.extend({
		            init: function(target, bindings, options) {
		                TypedBinder.fn.init.call(this, target, bindings, options);
	
		                this._change = proxy(this.change, this);
		                $(this.element).change(this._change);
		            },
	
		            parsedValue : function() {
		                var dataType = this.dataType();
		                var values = [];
		                var value, option, idx, length;
		                for (idx = 0, length = this.element.options.length; idx < length; idx++) {
		                    option = this.element.options[idx];
	
		                    if (option.selected) {
		                        value = option.attributes.value;
	
		                        if (value && value.specified) {
		                            value = option.value;
		                        } else {
		                            value = option.text;
		                        }
	
		                        values.push(this._parseValue(value, dataType));
		                    }
		                }
		                return values;
		            },
	
		            change: function() {
		                var values = [],
		                    element = this.element,
		                    source,
		                    field = this.options.valueField || this.options.textField,
		                    valuePrimitive = this.options.valuePrimitive,
		                    option,
		                    valueIndex,
		                    value,
		                    idx,
		                    length;
	
		                for (idx = 0, length = element.options.length; idx < length; idx++) {
		                    option = element.options[idx];
	
		                    if (option.selected) {
		                        value = option.attributes.value;
	
		                        if (value && value.specified) {
		                            value = option.value;
		                        } else {
		                            value = option.text;
		                        }
	
		                        if (field) {
		                            values.push(value);
		                        } else {
		                            values.push(this._parseValue(value, this.dataType()));
		                        }
	
		                    }
		                }
	
		                if (field) {
		                    source = this.bindings.source.get();
		                    if (source instanceof kendo.data.DataSource) {
		                        source = source.view();
		                    }
	
		                    for (valueIndex = 0; valueIndex < values.length; valueIndex++) {
		                        for (idx = 0, length = source.length; idx < length; idx++) {
		                            var sourceValue = source[idx].get(field);
		                            var match = (String(sourceValue) === values[valueIndex]);
		                            if (match) {
		                                values[valueIndex] = source[idx];
		                                break;
		                            }
		                        }
		                    }
		                }
	
		                value = this.bindings[VALUE].get();
		                if (value instanceof ObservableArray) {
		                    value.splice.apply(value, [0, value.length].concat(values));
		                } else if (!valuePrimitive && (value instanceof ObservableObject || value === null || value === undefined || !field)) {
		                    this.bindings[VALUE].set(values[0]);
		                } else {
		                    this.bindings[VALUE].set(values[0].get(field));
		                }
		            },
		            refresh: function() {
		                var optionIndex,
		                    element = this.element,
		                    options = element.options,
		                    value = this.bindings[VALUE].get(),
		                    values = value,
		                    field = this.options.valueField || this.options.textField,
		                    found = false,
		                    type = this.dataType(),
		                    optionValue;
	
		                if (!(values instanceof ObservableArray)) {
		                    values = new ObservableArray([value]);
		                }
	
		                element.selectedIndex = -1;
	
		                for (var valueIndex = 0; valueIndex < values.length; valueIndex++) {
		                    value = values[valueIndex];
	
	
		                    if (field && value instanceof ObservableObject) {
		                        value = value.get(field);
		                    }
	
		                    if (type == "date") {
		                        value = kendo.toString(values[valueIndex], "yyyy-MM-dd");
		                    } else if (type == "datetime-local") {
		                        value = kendo.toString(values[valueIndex], "yyyy-MM-ddTHH:mm:ss");
		                    }
	
		                    for (optionIndex = 0; optionIndex < options.length; optionIndex++) {
		                        optionValue = options[optionIndex].value;
	
		                        if (optionValue === "" && value !== "") {
		                            optionValue = options[optionIndex].text;
		                        }
	
		                        if (value != null && optionValue == value.toString()) {
		                            options[optionIndex].selected = true;
		                            found = true;
		                        }
		                    }
		                }
		            },
		            destroy: function() {
		                $(this.element).off(CHANGE, this._change);
		            }
		        })
		    };
	
		    function dataSourceBinding(bindingName, fieldName, setter) {
		        return Binder.extend({
		            init: function(widget, bindings, options) {
		                var that = this;
	
		                Binder.fn.init.call(that, widget.element[0], bindings, options);
	
		                that.widget = widget;
		                that._dataBinding = proxy(that.dataBinding, that);
		                that._dataBound = proxy(that.dataBound, that);
		                that._itemChange = proxy(that.itemChange, that);
		            },
	
		            itemChange: function(e) {
		                bindElement(e.item[0], e.data, this._ns(e.ns), [e.data].concat(this.bindings[bindingName]._parents()));
		            },
	
		            dataBinding: function(e) {
		                var idx,
		                    length,
		                    widget = this.widget,
		                    items = e.removedItems || widget.items();
	
		                for (idx = 0, length = items.length; idx < length; idx++) {
		                    unbindElementTree(items[idx], false);
		                }
		            },
	
		            _ns: function(ns) {
		                ns = ns || kendo.ui;
		                var all = [ kendo.ui, kendo.dataviz.ui, kendo.mobile.ui ];
		                all.splice($.inArray(ns, all), 1);
		                all.unshift(ns);
	
		                return kendo.rolesFromNamespaces(all);
		            },
	
		            dataBound: function(e) {
		                var idx,
		                    length,
		                    widget = this.widget,
		                    items = e.addedItems || widget.items(),
		                    dataSource = widget[fieldName],
		                    view,
		                    parents,
		                    hds = kendo.data.HierarchicalDataSource;
	
		                if (hds && dataSource instanceof hds) {
		                    // suppress binding of HDS items, because calling view() on root
		                    // will return only root items, and widget.items() returns all items
		                    return;
		                }
	
		                if (items.length) {
		                    view = e.addedDataItems || dataSource.flatView();
		                    parents = this.bindings[bindingName]._parents();
	
		                    for (idx = 0, length = view.length; idx < length; idx++) {
		                        if (items[idx]) {
		                            bindElement(items[idx], view[idx], this._ns(e.ns), [view[idx]].concat(parents));
		                        }
		                    }
		                }
		            },
	
		            refresh: function(e) {
		                var that = this,
		                    source,
		                    widget = that.widget,
		                    select, multiselect, dropdowntree;
	
		                e = e || {};
	
		                if (!e.action) {
		                    that.destroy();
	
		                    widget.bind("dataBinding", that._dataBinding);
		                    widget.bind("dataBound", that._dataBound);
		                    widget.bind("itemChange", that._itemChange);
	
		                    source = that.bindings[bindingName].get();
	
		                    if (widget[fieldName] instanceof kendo.data.DataSource && widget[fieldName] != source) {
		                        if (source instanceof kendo.data.DataSource) {
		                            widget[setter](source);
		                        } else if (source && source._dataSource) {
		                            widget[setter](source._dataSource);
		                        } else {
		                            select = kendo.ui.Select && widget instanceof kendo.ui.Select;
		                            multiselect = kendo.ui.MultiSelect && widget instanceof kendo.ui.MultiSelect;
		                            dropdowntree = kendo.ui.DropDownTree && widget instanceof kendo.ui.DropDownTree;
	
		                            if(!dropdowntree){
		                                widget[fieldName].data(source);
		                            }else{
		                                widget.treeview[fieldName].data(source);
		                            }
	
		                            if (that.bindings.value && (select || multiselect)) {
		                                widget.value(retrievePrimitiveValues(that.bindings.value.get(), widget.options.dataValueField));
		                            }
		                        }
		                    }
		                }
		            },
	
		            destroy: function() {
		                var widget = this.widget;
	
		                widget.unbind("dataBinding", this._dataBinding);
		                widget.unbind("dataBound", this._dataBound);
		                widget.unbind("itemChange", this._itemChange);
		            }
		        });
		    }
	
		    binders.widget = {
		        events : Binder.extend({
		            init: function(widget, bindings, options) {
		                Binder.fn.init.call(this, widget.element[0], bindings, options);
		                this.widget = widget;
		                this.handlers = {};
		            },
	
		            refresh: function(key) {
		                var binding = this.bindings.events[key],
		                    handler = this.handlers[key];
	
		                if (handler) {
		                    this.widget.unbind(key, handler);
		                }
	
		                handler = binding.get();
	
		                this.handlers[key] = function(e) {
		                    e.data = binding.source;
	
		                    handler(e);
	
		                    if (e.data === binding.source) {
		                        delete e.data;
		                    }
		                };
	
		                this.widget.bind(key, this.handlers[key]);
		            },
	
		            destroy: function() {
		                var handler;
	
		                for (handler in this.handlers) {
		                    this.widget.unbind(handler, this.handlers[handler]);
		                }
		            }
		        }),
	
		        checked: Binder.extend({
		            init: function(widget, bindings, options) {
		                Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                this.widget = widget;
		                this._change = proxy(this.change, this);
		                this.widget.bind(CHANGE, this._change);
		            },
		            change: function() {
		                this.bindings[CHECKED].set(this.value());
		            },
	
		            refresh: function() {
		                this.widget.check(this.bindings[CHECKED].get() === true);
		            },
	
		            value: function() {
		                var element = this.element,
		                    value = element.value;
	
		                if (value == "on" || value == "off") {
		                    value = element.checked;
		                }
	
		                return value;
		            },
	
		            destroy: function() {
		                this.widget.unbind(CHANGE, this._change);
		            }
		        }),
	
		        visible: Binder.extend({
		            init: function(widget, bindings, options) {
		                Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                this.widget = widget;
		            },
	
		            refresh: function() {
		                var visible = this.bindings.visible.get();
		                this.widget.wrapper[0].style.display = visible ? "" : "none";
		            }
		        }),
	
		        invisible: Binder.extend({
		            init: function(widget, bindings, options) {
		                Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                this.widget = widget;
		            },
	
		            refresh: function() {
		                var invisible = this.bindings.invisible.get();
		                this.widget.wrapper[0].style.display = invisible ? "none" : "";
		            }
		        }),
	
		        enabled: Binder.extend({
		            init: function(widget, bindings, options) {
		                Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                this.widget = widget;
		            },
	
		            refresh: function() {
		                if (this.widget.enable) {
		                    this.widget.enable(this.bindings.enabled.get());
		                }
		            }
		        }),
	
		        disabled: Binder.extend({
		            init: function(widget, bindings, options) {
		                Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                this.widget = widget;
		            },
	
		            refresh: function() {
		                if (this.widget.enable) {
		                    this.widget.enable(!this.bindings.disabled.get());
		                }
		            }
		        }),
	
		        source: dataSourceBinding("source", "dataSource", "setDataSource"),
	
		        value: Binder.extend({
		            init: function(widget, bindings, options) {
		                Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                this.widget = widget;
		                this._change = $.proxy(this.change, this);
		                this.widget.first(CHANGE, this._change);
	
		                var value = this.bindings.value.get();
	
		                this._valueIsObservableObject = !options.valuePrimitive && (value == null || value instanceof ObservableObject);
		                this._valueIsObservableArray = value instanceof ObservableArray;
		                this._initChange = false;
		            },
	
		            _source: function() {
		                var source;
	
		                if (this.widget.dataItem) {
		                    source = this.widget.dataItem();
		                    if (source && source instanceof ObservableObject) {
		                        return [source];
		                    }
		                }
	
		                if (this.bindings.source) {
		                    source = this.bindings.source.get();
		                }
	
		                if (!source || source instanceof kendo.data.DataSource) {
		                    source = this.widget.dataSource.flatView();
		                }
	
		                return source;
		            },
	
		            change: function() {
		                var value = this.widget.value(),
		                    field = this.options.dataValueField || this.options.dataTextField,
		                    isArray = toString.call(value) === "[object Array]",
		                    isObservableObject = this._valueIsObservableObject,
		                    valueIndex, valueLength, values = [],
		                    sourceItem, sourceValue,
		                    idx, length, source;
	
		                this._initChange = true;
	
		                if (field) {
	
		                    if (value === "" && (isObservableObject || this.options.valuePrimitive)) {
		                        value = null;
		                    } else {
		                        source = this._source();
	
		                        if (isArray) {
		                            valueLength = value.length;
		                            values = value.slice(0);
		                        }
	
		                        for (idx = 0, length = source.length; idx < length; idx++) {
		                            sourceItem = source[idx];
		                            sourceValue = sourceItem.get(field);
	
		                            if (isArray) {
		                                for (valueIndex = 0; valueIndex < valueLength; valueIndex++) {
		                                    if (sourceValue == values[valueIndex]) {
		                                        values[valueIndex] = sourceItem;
		                                        break;
		                                    }
		                                }
		                            } else if (sourceValue == value) {
		                                value = isObservableObject ? sourceItem : sourceValue;
		                                break;
		                            }
		                        }
	
		                        if (values[0]) {
		                            if (this._valueIsObservableArray) {
		                                value = values;
		                            } else if (isObservableObject || !field) {
		                                value = values[0];
		                            } else {
		                                value = values[0].get(field);
		                            }
		                        }
		                    }
		                }
	
		                this.bindings.value.set(value);
		                this._initChange = false;
		            },
	
		            refresh: function() {
		                if (!this._initChange) {
		                    var widget = this.widget;
		                    var options = widget.options;
		                    var textField = options.dataTextField;
		                    var valueField = options.dataValueField || textField;
		                    var value = this.bindings.value.get();
		                    var text = options.text || "";
		                    var idx = 0, length;
		                    var values = [];
	
		                    if (value === undefined) {
		                        value = null;
		                    }
	
		                    if (valueField) {
		                        if (value instanceof ObservableArray) {
		                            for (length = value.length; idx < length; idx++) {
		                                values[idx] = value[idx].get(valueField);
		                            }
		                            value = values;
		                        } else if (value instanceof ObservableObject) {
		                            text = value.get(textField);
		                            value = value.get(valueField);
		                        }
		                    }
	
		                    if (options.autoBind === false && !options.cascadeFrom && widget.listView && !widget.listView.bound()) {
		                        if (textField === valueField && !text) {
		                            text = value;
		                        }
	
		                        if (!text && (value || value === 0) && options.valuePrimitive) {
		                            widget.value(value);
		                        } else {
		                            widget._preselect(value, text);
		                        }
		                    } else {
		                        widget.value(value);
		                    }
		                }
	
		                this._initChange = false;
		            },
	
		            destroy: function() {
		                this.widget.unbind(CHANGE, this._change);
		            }
		        }),
		        dropdowntree: {
		            value: Binder.extend({
		                init: function(widget, bindings, options) {
		                    Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                    this.widget = widget;
		                    this._change = $.proxy(this.change, this);
		                    this.widget.first(CHANGE, this._change);
		                    this._initChange = false;
		                },
	
		                change: function() {
		                    var that = this,
		                        oldValues = that.bindings[VALUE].get(),
		                        valuePrimitive = that.options.valuePrimitive,
		                        selectedNode = that.widget.treeview.select(),
		                        nonPrimitiveValues = that.widget._isMultipleSelection() ? that.widget._getAllChecked(): (that.widget.treeview.dataItem(selectedNode) || that.widget.value()),
		                        newValues = (valuePrimitive || that.widget.options.autoBind === false) ? that.widget.value() : nonPrimitiveValues;
	
		                    var field = this.options.dataValueField || this.options.dataTextField;
	
		                    newValues = newValues.slice ? newValues.slice(0): newValues;
	
		                    that._initChange = true;
	
		                    if (oldValues instanceof ObservableArray) {
		                        var remove = [];
		                        var newLength = newValues.length;
		                        var i = 0, j = 0;
		                        var old = oldValues[i];
		                        var same = false;
		                        var removeIndex;
		                        var newValue;
		                        var found;
	
		                        while (old !== undefined) {
		                            found = false;
		                            for (j = 0; j < newLength; j++) {
		                                if (valuePrimitive) {
		                                    same = newValues[j] == old;
		                                } else {
		                                    newValue = newValues[j];
	
		                                    newValue = newValue.get ? newValue.get(field) : newValue;
		                                    same = newValue == (old.get ? old.get(field) : old);
		                                }
	
		                                if (same) {
		                                    newValues.splice(j, 1);
		                                    newLength -= 1;
		                                    found = true;
		                                    break;
		                                }
		                            }
	
		                            if (!found) {
		                                remove.push(old);
		                                arraySplice(oldValues, i, 1);
		                                removeIndex = i;
		                            } else {
		                                i += 1;
		                            }
	
		                            old = oldValues[i];
		                        }
	
		                        arraySplice(oldValues, oldValues.length, 0, newValues);
	
		                        if (remove.length) {
		                            oldValues.trigger("change", {
		                                action: "remove",
		                                items: remove,
		                                index: removeIndex
		                            });
		                        }
	
		                        if (newValues.length) {
		                            oldValues.trigger("change", {
		                                action: "add",
		                                items: newValues,
		                                index: oldValues.length - 1
		                            });
		                        }
		                    } else {
		                        that.bindings[VALUE].set(newValues);
		                    }
	
		                    that._initChange = false;
		                },
	
		                refresh: function() {
		                    if (!this._initChange) {
		                        var options = this.options,
		                            widget = this.widget,
		                            field = options.dataValueField || options.dataTextField,
		                            value = this.bindings.value.get(),
		                            data = value,
		                            idx = 0, length,
		                            values = [],
		                            selectedValue;
	
		                        if (field) {
		                            if (value instanceof ObservableArray) {
		                                for (length = value.length; idx < length; idx++) {
		                                    selectedValue = value[idx];
		                                    values[idx] = selectedValue.get ? selectedValue.get(field) : selectedValue;
		                                }
		                                value = values;
		                            } else if (value instanceof ObservableObject) {
		                                value = value.get(field);
		                            }
		                        }
		                        if (options.autoBind === false && options.valuePrimitive !== true) {
		                            widget._preselect(data, value);
		                        } else {
		                            widget.value(value);
		                        }
		                   }
		                },
	
		                destroy: function() {
		                    this.widget.unbind(CHANGE, this._change);
		                }
		            })
		        },
		        gantt: {
		            dependencies: dataSourceBinding("dependencies", "dependencies", "setDependenciesDataSource")
		        },
	
		        multiselect: {
		            value: Binder.extend({
		                init: function(widget, bindings, options) {
		                    Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                    this.widget = widget;
		                    this._change = $.proxy(this.change, this);
		                    this.widget.first(CHANGE, this._change);
		                    this._initChange = false;
		                },
	
		                change: function() {
		                    var that = this,
		                        oldValues = that.bindings[VALUE].get(),
		                        valuePrimitive = that.options.valuePrimitive,
		                        newValues = valuePrimitive ? that.widget.value() : that.widget.dataItems();
	
		                    var field = this.options.dataValueField || this.options.dataTextField;
	
		                    newValues = newValues.slice(0);
	
		                    that._initChange = true;
	
		                    if (oldValues instanceof ObservableArray) {
		                        var remove = [];
	
		                        var newLength = newValues.length;
	
		                        var i = 0, j = 0;
		                        var old = oldValues[i];
		                        var same = false;
		                        var removeIndex;
		                        var newValue;
		                        var found;
	
		                        while (old !== undefined) {
		                            found = false;
		                            for (j = 0; j < newLength; j++) {
		                                if (valuePrimitive) {
		                                    same = newValues[j] == old;
		                                } else {
		                                    newValue = newValues[j];
	
		                                    newValue = newValue.get ? newValue.get(field) : newValue;
		                                    same = newValue == (old.get ? old.get(field) : old);
		                                }
	
		                                if (same) {
		                                    newValues.splice(j, 1);
		                                    newLength -= 1;
		                                    found = true;
		                                    break;
		                                }
		                            }
	
		                            if (!found) {
		                                remove.push(old);
		                                arraySplice(oldValues, i, 1);
		                                removeIndex = i;
		                            } else {
		                                i += 1;
		                            }
	
		                            old = oldValues[i];
		                        }
	
		                        arraySplice(oldValues, oldValues.length, 0, newValues);
	
		                        if (remove.length) {
		                            oldValues.trigger("change", {
		                                action: "remove",
		                                items: remove,
		                                index: removeIndex
		                            });
		                        }
	
		                        if (newValues.length) {
		                            oldValues.trigger("change", {
		                                action: "add",
		                                items: newValues,
		                                index: oldValues.length - 1
		                            });
		                        }
		                    } else {
		                        that.bindings[VALUE].set(newValues);
		                    }
	
		                    that._initChange = false;
		                },
	
		                refresh: function() {
		                    if (!this._initChange) {
		                        var options = this.options,
		                            widget = this.widget,
		                            field = options.dataValueField || options.dataTextField,
		                            value = this.bindings.value.get(),
		                            data = value,
		                            idx = 0, length,
		                            values = [],
		                            selectedValue;
	
		                        if (value === undefined) {
		                            value = null;
		                        }
	
		                        if (field) {
		                            if (value instanceof ObservableArray) {
		                                for (length = value.length; idx < length; idx++) {
		                                    selectedValue = value[idx];
		                                    values[idx] = selectedValue.get ? selectedValue.get(field) : selectedValue;
		                                }
		                                value = values;
		                            } else if (value instanceof ObservableObject) {
		                                value = value.get(field);
		                            }
		                        }
	
		                        if (options.autoBind === false && options.valuePrimitive !== true && !widget._isBound()) {
		                            widget._preselect(data, value);
		                        } else {
		                            widget.value(value);
		                        }
		                    }
		                },
	
		                destroy: function() {
		                    this.widget.unbind(CHANGE, this._change);
		                }
	
		            })
		        },
		        scheduler: {
		            source: dataSourceBinding("source", "dataSource", "setDataSource").extend({
		                dataBound: function(e) {
		                    var idx;
		                    var length;
		                    var widget = this.widget;
		                    var elements = e.addedItems || widget.items();
		                    var data, parents;
	
		                    if (elements.length) {
		                        data = e.addedDataItems || widget.dataItems();
		                        parents = this.bindings.source._parents();
	
		                        for (idx = 0, length = data.length; idx < length; idx++) {
		                            bindElement(elements[idx], data[idx], this._ns(e.ns), [data[idx]].concat(parents));
		                        }
		                    }
		                }
		            })
		        }
		    };
	
		    var arraySplice = function(arr, idx, remove, add) {
		        add = add || [];
		        remove = remove || 0;
	
		        var addLength = add.length;
		        var oldLength = arr.length;
	
		        var shifted = [].slice.call(arr, idx + remove);
		        var shiftedLength = shifted.length;
		        var index;
	
		        if (addLength) {
		            addLength = idx + addLength;
		            index = 0;
	
		            for (; idx < addLength; idx++) {
		                arr[idx] = add[index];
		                index++;
		            }
	
		            arr.length = addLength;
		        } else if (remove) {
		            arr.length = idx;
	
		            remove += idx;
		            while (idx < remove) {
		                delete arr[--remove];
		            }
		        }
	
		        if (shiftedLength) {
		            shiftedLength = idx + shiftedLength;
		            index = 0;
	
		            for (; idx < shiftedLength; idx++) {
		                arr[idx] = shifted[index];
		                index++;
		            }
	
		            arr.length = shiftedLength;
		        }
	
		        idx = arr.length;
	
		        while (idx < oldLength) {
		            delete arr[idx];
		            idx++;
		        }
		    };
	
		    var BindingTarget = Class.extend( {
		        init: function(target, options) {
		            this.target = target;
		            this.options = options;
		            this.toDestroy = [];
		        },
	
		        bind: function(bindings) {
		            var key,
		                hasValue,
		                hasSource,
		                hasEvents,
		                hasChecked,
		                hasCss,
		                widgetBinding = this instanceof WidgetBindingTarget,
		                specificBinders = this.binders();
	
		            for (key in bindings) {
		                if (key == VALUE) {
		                    hasValue = true;
		                } else if (key == SOURCE) {
		                    hasSource = true;
		                } else if (key == EVENTS && !widgetBinding) {
		                    hasEvents = true;
		                } else if (key == CHECKED) {
		                    hasChecked = true;
		                } else if (key == CSS) {
		                    hasCss = true;
		                } else {
		                    this.applyBinding(key, bindings, specificBinders);
		                }
		            }
		            if (hasSource) {
		                this.applyBinding(SOURCE, bindings, specificBinders);
		            }
	
		            if (hasValue) {
		                this.applyBinding(VALUE, bindings, specificBinders);
		            }
	
		            if (hasChecked) {
		                this.applyBinding(CHECKED, bindings, specificBinders);
		            }
	
		            if (hasEvents && !widgetBinding) {
		                this.applyBinding(EVENTS, bindings, specificBinders);
		            }
	
		            if (hasCss && !widgetBinding) {
		                this.applyBinding(CSS, bindings, specificBinders);
		            }
		        },
	
		        binders: function() {
		            return binders[this.target.nodeName.toLowerCase()] || {};
		        },
	
		        applyBinding: function(name, bindings, specificBinders) {
		            var binder = specificBinders[name] || binders[name],
		                toDestroy = this.toDestroy,
		                attribute,
		                binding = bindings[name];
	
		            if (binder) {
		                binder = new binder(this.target, bindings, this.options);
	
		                toDestroy.push(binder);
	
		                if (binding instanceof Binding) {
		                    binder.bind(binding);
		                    toDestroy.push(binding);
		                } else {
		                    for (attribute in binding) {
		                        binder.bind(binding, attribute);
		                        toDestroy.push(binding[attribute]);
		                    }
		                }
		            } else if (name !== "template") {
		                throw new Error("The " + name + " binding is not supported by the " + this.target.nodeName.toLowerCase() + " element");
		            }
		        },
	
		        destroy: function() {
		            var idx,
		                length,
		                toDestroy = this.toDestroy;
	
		            for (idx = 0, length = toDestroy.length; idx < length; idx++) {
		                toDestroy[idx].destroy();
		            }
		        }
		    });
	
		    var WidgetBindingTarget = BindingTarget.extend( {
		        binders: function() {
		            return binders.widget[this.target.options.name.toLowerCase()] || {};
		        },
	
		        applyBinding: function(name, bindings, specificBinders) {
		            var binder = specificBinders[name] || binders.widget[name],
		                toDestroy = this.toDestroy,
		                attribute,
		                binding = bindings[name];
	
		            if (binder) {
		                binder = new binder(this.target, bindings, this.target.options);
	
		                toDestroy.push(binder);
	
	
		                if (binding instanceof Binding) {
		                    binder.bind(binding);
		                    toDestroy.push(binding);
		                } else {
		                    for (attribute in binding) {
		                        binder.bind(binding, attribute);
		                        toDestroy.push(binding[attribute]);
		                    }
		                }
		            } else {
		                throw new Error("The " + name + " binding is not supported by the " + this.target.options.name + " widget");
		            }
		        }
		    });
	
		    function bindingTargetForRole(element, roles) {
		        var widget = kendo.initWidget(element, {}, roles);
	
		        if (widget) {
		            return new WidgetBindingTarget(widget);
		        }
		    }
	
		    var keyValueRegExp = /[A-Za-z0-9_\-]+:(\{([^}]*)\}|[^,}]+)/g,
		        whiteSpaceRegExp = /\s/g;
	
		    function parseBindings(bind) {
		        var result = {},
		            idx,
		            length,
		            token,
		            colonIndex,
		            key,
		            value,
		            tokens;
	
		        tokens = bind.match(keyValueRegExp);
	
		        for (idx = 0, length = tokens.length; idx < length; idx++) {
		            token = tokens[idx];
		            colonIndex = token.indexOf(":");
	
		            key = token.substring(0, colonIndex);
		            value = token.substring(colonIndex + 1);
	
		            if (value.charAt(0) == "{") {
		                value = parseBindings(value);
		            }
	
		            result[key] = value;
		        }
	
		        return result;
		    }
	
		    function createBindings(bindings, source, type) {
		        var binding,
		            result = {};
	
		        for (binding in bindings) {
		            result[binding] = new type(source, bindings[binding]);
		        }
	
		        return result;
		    }
	
		    function bindElement(element, source, roles, parents) {
	
		        if(!element || element.getAttribute("data-" + kendo.ns + "stop")){
		            return;
		        }
	
		        var role = element.getAttribute("data-" + kendo.ns + "role"),
		            idx,
		            bind = element.getAttribute("data-" + kendo.ns + "bind"),
		            childrenCopy = [],
		            deep = true,
		            bindings,
		            options = {},
		            target;
	
		        parents = parents || [source];
	
		        if (role || bind) {
		            unbindElement(element, false);
		        }
	
		        if (role) {
		            target = bindingTargetForRole(element, roles);
		        }
	
		        if (bind) {
		            bind = parseBindings(bind.replace(whiteSpaceRegExp, ""));
	
		            if (!target) {
		                options = kendo.parseOptions(element, {textField: "", valueField: "", template: "", valueUpdate: CHANGE, valuePrimitive: false, autoBind: true}, source);
		                options.roles = roles;
		                target = new BindingTarget(element, options);
		            }
	
		            target.source = source;
	
		            bindings = createBindings(bind, parents, Binding);
	
		            if (options.template) {
		                bindings.template = new TemplateBinding(parents, "", options.template);
		            }
	
		            if (bindings.click) {
		                bind.events = bind.events || {};
		                bind.events.click = bind.click;
		                bindings.click.destroy();
		                delete bindings.click;
		            }
	
		            if (bindings.source) {
		                deep = false;
		            }
	
		            if (bind.attr) {
		                bindings.attr = createBindings(bind.attr, parents, Binding);
		            }
	
		            if (bind.style) {
		                bindings.style = createBindings(bind.style, parents, Binding);
		            }
	
		            if (bind.events) {
		                bindings.events = createBindings(bind.events, parents, EventBinding);
		            }
	
		            if (bind.css) {
		                bindings.css = createBindings(bind.css, parents, Binding);
		            }
	
		            target.bind(bindings);
		        }
	
		        if (target) {
		            element.kendoBindingTarget = target;
		        }
	
		        var children = element.children;
		        if (deep && children) {
		            // https://github.com/telerik/kendo/issues/1240 for the weirdness.
		            for (idx = 0; idx < children.length; idx++) {
		                childrenCopy[idx] = children[idx];
		            }
	
		            for (idx = 0; idx < childrenCopy.length; idx++) {
		                bindElement(childrenCopy[idx], source, roles, parents);
		            }
		        }
		    }
	
		    function bind(dom, object) {
		        var idx,
		            length,
		            node,
		            roles = kendo.rolesFromNamespaces([].slice.call(arguments, 2));
	
		        object = kendo.observable(object);
		        dom = $(dom);
	
		        for (idx = 0, length = dom.length; idx < length; idx++) {
		            node = dom[idx];
		            if (node.nodeType === 1) {
		                bindElement(node, object, roles);
		            }
		        }
		    }
	
		    function unbindElement(element, destroyWidget) {
		        var bindingTarget = element.kendoBindingTarget;
	
		        if (bindingTarget) {
		            bindingTarget.destroy();
	
		            if (deleteExpando) {
		                delete element.kendoBindingTarget;
		            } else if (element.removeAttribute) {
		                element.removeAttribute("kendoBindingTarget");
		            } else {
		                element.kendoBindingTarget = null;
		            }
		        }
	
		        if(destroyWidget) {
		            var widget = kendo.widgetInstance($(element));
		            if (widget && typeof widget.destroy === FUNCTION) {
		                widget.destroy();
		            }
		        }
		    }
	
		    function unbindElementTree(element, destroyWidgets) {
		        unbindElement(element, destroyWidgets);
	
		        unbindElementChildren(element, destroyWidgets);
		    }
	
		    function unbindElementChildren(element, destroyWidgets) {
		        var children = element.children;
	
		        if (children) {
		            for (var idx = 0, length = children.length; idx < length; idx++) {
		                unbindElementTree(children[idx], destroyWidgets);
		            }
		        }
		    }
	
		    function unbind(dom) {
		        var idx, length;
	
		        dom = $(dom);
	
		        for (idx = 0, length = dom.length; idx < length; idx++ ) {
		            unbindElementTree(dom[idx], false);
		        }
		    }
	
		    function notify(widget, namespace) {
		        var element = widget.element,
		            bindingTarget = element[0].kendoBindingTarget;
	
		        if (bindingTarget) {
		            bind(element, bindingTarget.source, namespace);
		        }
		    }
	
		    function retrievePrimitiveValues(value, valueField) {
		        var values = [];
		        var idx = 0;
		        var length;
		        var item;
	
		        if (!valueField) {
		            return value;
		        }
	
		        if (value instanceof ObservableArray) {
		            for (length = value.length; idx < length; idx++) {
		                item = value[idx];
		                values[idx] = item.get ? item.get(valueField) : item[valueField];
		            }
		            value = values;
		        } else if (value instanceof ObservableObject) {
		            value = value.get(valueField);
		        }
	
		        return value;
		    }
	
		    kendo.unbind = unbind;
		    kendo.bind = bind;
		    kendo.data.binders = binders;
		    kendo.data.Binder = Binder;
		    kendo.notify = notify;
	
		    kendo.observable = function(object) {
		        if (!(object instanceof ObservableObject)) {
		            object = new ObservableObject(object);
		        }
	
		        return object;
		    };
	
		    kendo.observableHierarchy = function(array) {
		        var dataSource = kendo.data.HierarchicalDataSource.create(array);
	
		        function recursiveRead(data) {
		            var i, children;
	
		            for (i = 0; i < data.length; i++) {
		                data[i]._initChildren();
	
		                children = data[i].children;
	
		                children.fetch();
	
		                data[i].items = children.data();
	
		                recursiveRead(data[i].items);
		            }
		        }
	
		        dataSource.fetch();
	
		        recursiveRead(dataSource.data());
	
		        dataSource._data._dataSource = dataSource;
	
		        return dataSource._data;
		    };
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1050);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1050:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "data.signalr",
		    name: "SignalR",
		    category: "framework",
		    depends: [ "data" ],
		    hidden: true
		};
	
		(function($) {
		    var kendo = window.kendo;
		    var isFunction = kendo.isFunction;
	
		    function isJQueryPromise(promise) {
		        return promise && isFunction(promise.done) && isFunction(promise.fail);
		    }
	
		    function isNativePromise(promise) {
		        return promise && isFunction(promise.then) && isFunction(promise.catch); // jshint ignore:line
		    }
	
		    var transport = kendo.data.RemoteTransport.extend({
		        init: function (options) {
		            var signalr = options && options.signalr ? options.signalr : {};
	
		            var promise = signalr.promise;
	
		            if (!promise) {
		                throw new Error('The "promise" option must be set.');
		            }
	
		            if (!isJQueryPromise(promise) && !isNativePromise(promise)) {
		                throw new Error('The "promise" option must be a Promise.');
		            }
	
		            this.promise = promise;
	
		            var hub = signalr.hub;
	
		            if (!hub) {
		                throw new Error('The "hub" option must be set.');
		            }
	
		            if (typeof hub.on != "function" || typeof hub.invoke != "function") {
		                throw new Error('The "hub" option is not a valid SignalR hub proxy.');
		            }
	
		            this.hub = hub;
	
		            kendo.data.RemoteTransport.fn.init.call(this, options);
		        },
	
		        push: function(callbacks) {
		            var client = this.options.signalr.client || {};
	
		            if (client.create) {
		                this.hub.on(client.create, callbacks.pushCreate);
		            }
	
		            if (client.update) {
		                this.hub.on(client.update, callbacks.pushUpdate);
		            }
	
		            if (client.destroy) {
		                this.hub.on(client.destroy, callbacks.pushDestroy);
		            }
		        },
	
		        _crud: function(options, type) {
		            var hub = this.hub;
		            var promise = this.promise;
		            var server = this.options.signalr.server;
	
		            if (!server || !server[type]) {
		                throw new Error(kendo.format('The "server.{0}" option must be set.', type));
		            }
	
		            var args = [server[type]];
	
		            var data = this.parameterMap(options.data, type);
	
		            if (!$.isEmptyObject(data)) {
		                args.push(data);
		            }
	
		            if (isJQueryPromise(promise)) {
		                promise.done(function() {
		                    hub.invoke.apply(hub, args)
		                              .done(options.success)
		                              .fail(options.error);
		                });
		            } else if (isNativePromise(promise)) {
		                promise.then(function() {
		                    hub.invoke.apply(hub, args)
		                              .then(options.success)
		                              .catch(options.error); // jshint ignore:line
		                });
		            }
		        },
	
		        read: function(options) {
		            this._crud(options, "read");
		        },
	
		        create: function(options) {
		            this._crud(options, "create");
		        },
	
		        update: function(options) {
		            this._crud(options, "update");
		        },
	
		        destroy: function(options) {
		            this._crud(options, "destroy");
		        }
		    });
	
		    $.extend(true, kendo.data, {
		        transports: {
		            signalr: transport
		        }
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1002);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1002:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		var __meta__ = { // jshint ignore:line
		    id: "angular",
		    name: "AngularJS Directives",
		    category: "framework",
		    description: "Adds Kendo UI for AngularJS directives",
		    depends: [ "core" ],
		    defer: true
		};
	
		(function ($, angular, undefined) {
		    "use strict";
	
		    // Angular2 exposes a global angular object, but it does not have an injector...
		    if (!angular || !angular.injector) {
		        return;
		    }
	
		    /*jshint eqnull:true,loopfunc:true,-W052,-W028  */
	
		    var module = angular.module('kendo.directives', []),
		        $injector = angular.injector(['ng']),
		        $parse = $injector.get('$parse'),
		        $timeout = $injector.get('$timeout'),
		        $defaultCompile,
		        $log = $injector.get('$log');
	
		    function withoutTimeout(f) {
		        var save = $timeout;
		        try {
		            $timeout = function(f){ return f(); };
		            return f();
		        } finally {
		            $timeout = save;
		        }
		    }
	
		    var OPTIONS_NOW;
	
		    var createDataSource = (function() {
		        var types = {
		            TreeList    : 'TreeListDataSource',
		            TreeView    : 'HierarchicalDataSource',
		            Scheduler   : 'SchedulerDataSource',
		            PivotGrid   : 'PivotDataSource',
		            PivotConfigurator   : 'PivotDataSource',
		            PanelBar    : 'HierarchicalDataSource',
		            Menu        : "$PLAIN",
		            ContextMenu : "$PLAIN"
		        };
		        var toDataSource = function(dataSource, type) {
		            if (type == '$PLAIN') {
		                return dataSource;
		            }
		            return kendo.data[type].create(dataSource);
		        };
		        return function(scope, element, role, source) {
		            var type = types[role] || 'DataSource';
		            var current = scope.$eval(source);
		            var ds = toDataSource(current, type);
	
		            scope.$watch(source, function(mew) {
		                var widget = kendoWidgetInstance(element);
	
		                if (widget && typeof widget.setDataSource == "function") {
		                    if (mew !== current && mew !== widget.dataSource) {
		                        var ds = toDataSource(mew, type);
		                        widget.setDataSource(ds);
		                        current = mew;
		                    }
		                }
		            });
		            return ds;
		        };
		    }());
	
		    var ignoredAttributes = {
		        kDataSource : true,
		        kOptions    : true,
		        kRebind     : true,
		        kNgModel    : true,
		        kNgDelay    : true
		    };
	
		    var ignoredOwnProperties = {
		        // XXX: other names to ignore here?
		        name    : true,
		        title   : true,
		        style   : true
		    };
	
		    function createWidget(scope, element, attrs, widget, origAttr, controllers) {
		        /* jshint latedef: false */
		        if (!(element instanceof jQuery)) {
		            throw new Error("The Kendo UI directives require jQuery to be available before AngularJS. Please include jquery before angular in the document.");
		        }
	
		        var kNgDelay = attrs.kNgDelay,
		            delayValue = scope.$eval(kNgDelay);
	
		        controllers = controllers || [];
	
		        var ngModel = controllers[0],
		            ngForm = controllers[1];
	
		        var ctor = $(element)[widget];
	
		        if (!ctor) {
		            window.console.error("Could not find: " + widget);
		            return null;
		        }
	
		        var parsed = parseOptions(scope, element, attrs, widget, ctor);
	
		        var options = parsed.options;
	
		        if (parsed.unresolved.length) {
		            var promises = [];
	
		            for (var i = 0, len = parsed.unresolved.length; i < len; i++) {
	
		                var unresolved = parsed.unresolved[i];
	
		                var promise = $.Deferred(function(d) {
		                    var unwatch = scope.$watch(unresolved.path, function(newValue) {
		                        if (newValue !== undefined) {
		                            unwatch();
		                            d.resolve();
		                        }
		                    });
		                }).promise();
	
		                promises.push(promise);
		            }
	
		            $.when.apply(null, promises).then(createIt);
	
		            return;
		        }
	
		        if (kNgDelay && !delayValue) {
		            var root = scope.$root || scope;
	
		            var register = function() {
		                var unregister = scope.$watch(kNgDelay, function(newValue) {
		                        if (newValue !== undefined) {
		                        unregister();
		                        // remove subsequent delays, to make ng-rebind work
		                        element.removeAttr(attrs.$attr.kNgDelay);
		                        kNgDelay = null;
		                        $timeout(createIt); // XXX: won't work without `timeout` ;-\
		                    }
		                });
		            };
	
		            // WARNING: the watchers should be registered in the digest cycle.
		            // the fork here is for the timeout/non-timeout initiated widgets.
		            if (/^\$(digest|apply)$/.test(root.$$phase)) {
		                register();
		            } else {
		                scope.$apply(register);
		            }
	
		            return;
		        } else {
		            return createIt();
		        }
	
		        function createIt() {
		            var originalElement;
	
		            if (attrs.kRebind) {
		                originalElement = $($(element)[0].cloneNode(true));
		            }
	
		            // re-parse the options here.
		            options = parseOptions(scope, element, attrs, widget, ctor).options;
	
		            if (element.is("select")) {
		                (function(options){
		                    if (options.length > 0) {
		                        var first = $(options[0]);
		                        if (!/\S/.test(first.text()) && /^\?/.test(first.val())) {
		                            first.remove();
		                        }
	
		                        for (var i = 0; i < options.length; i++) {
		                            $(options[i]).off("$destroy");
		                        }
		                    }
		                }(element[0].options));
		            }
	
		            var object = ctor.call(element, OPTIONS_NOW = options).data(widget);
	
		            exposeWidget(object, scope, attrs, widget, origAttr);
	
		            scope.$emit("kendoWidgetCreated", object);
	
		            var destroyRegister = destroyWidgetOnScopeDestroy(scope, object);
	
		            if (attrs.kRebind) {
		                setupRebind(object, scope, element, originalElement, attrs.kRebind, destroyRegister, attrs);
		            }
	
		            if (attrs.kNgDisabled) {
		                var kNgDisabled = attrs.kNgDisabled;
		                var isDisabled = scope.$eval(kNgDisabled);
		                if (isDisabled) {
		                    object.enable(!isDisabled);
		                }
		                bindToKNgDisabled(object, scope, element, kNgDisabled);
		            }
	
		            if (attrs.kNgReadonly) {
		                var kNgReadonly = attrs.kNgReadonly;
		                var isReadonly = scope.$eval(kNgReadonly);
		                if (isReadonly) {
		                    object.readonly(isReadonly);
		                }
		                bindToKNgReadonly(object, scope, element, kNgReadonly);
		            }
	
		            // kNgModel is used for the "logical" value
		            if (attrs.kNgModel) {
		                bindToKNgModel(object, scope, attrs.kNgModel);
		            }
	
		            // 2 way binding: ngModel <-> widget.value()
		            if (ngModel) {
		                bindToNgModel(object, scope, element, ngModel, ngForm);
		            }
	
		            if (object) {
		                propagateClassToWidgetWrapper(object, element);
		            }
	
		            return object;
		        }
		    }
	
	
		    function parseOptions(scope, element, attrs, widget, ctor) {
		        var role = widget.replace(/^kendo/, '');
		        var unresolved = [];
		        var optionsPath = attrs.kOptions || attrs.options;
		        var optionsValue = scope.$eval(optionsPath);
	
		        if (optionsPath && optionsValue === undefined) {
		            unresolved.push({ option: "options", path: optionsPath });
		        }
	
		        var options = angular.extend({}, attrs.defaultOptions, optionsValue);
	
		        function addOption(name, value) {
		            var scopeValue = angular.copy(scope.$eval(value));
		            if (scopeValue === undefined) {
		                unresolved.push({ option: name, path: value });
		            } else {
		                options[name] = scopeValue;
		            }
		        }
	
	
		        var widgetOptions = ctor.widget.prototype.options;
		        var widgetEvents = ctor.widget.prototype.events;
	
	
		        $.each(attrs, function(name, value) {
		            if (name === "source" || name === "kDataSource" || name === "kScopeField" || name === "scopeField") {
		                return;
		            }
	
		            var dataName = "data" + name.charAt(0).toUpperCase() + name.slice(1);
	
		            if (name.indexOf("on") === 0) { // let's search for such event.
		                var eventKey = name.replace(/^on./, function(prefix) {
		                    return prefix.charAt(2).toLowerCase();
		                });
	
		                if (widgetEvents.indexOf(eventKey) > -1) {
		                    options[eventKey] = value;
		                }
		            } // don't elsif here - there are on* options
	
		            if (widgetOptions.hasOwnProperty(dataName)) {
		                addOption(dataName, value);
		            } else if (widgetOptions.hasOwnProperty(name) && !ignoredOwnProperties[name]) {
		                addOption(name, value);
		            } else if (!ignoredAttributes[name]) {
		                var match = name.match(/^k(On)?([A-Z].*)/);
		                if (match) {
		                    var optionName = match[2].charAt(0).toLowerCase() + match[2].slice(1);
		                    if (match[1] && name != "kOnLabel" // XXX: k-on-label can be used on MobileSwitch :-\
		                    ) {
		                        options[optionName] = value;
		                    } else {
		                        if (name == "kOnLabel") {
		                            optionName = "onLabel"; // XXX: that's awful.
		                        }
		                        addOption(optionName, value);
		                    }
		                }
		            }
		        });
	
		        // parse the datasource attribute
		        var dataSource = attrs.kDataSource || attrs.source;
	
		        if (dataSource) {
		            options.dataSource = createDataSource(scope, element, role, dataSource);
		        }
	
		        // deepExtend in kendo.core (used in Editor) will fail with stack
		        // overflow if we don't put it in an array :-\
		        options.$angular = [ scope ];
	
		        return {
		            options: options,
		            unresolved: unresolved
		        };
		    }
	
		    function bindToKNgDisabled(widget, scope, element, kNgDisabled) {
		        if ((kendo.ui.PanelBar && widget instanceof kendo.ui.PanelBar) || (kendo.ui.Menu && widget instanceof kendo.ui.Menu)) {
		            $log.warn("k-ng-disabled specified on a widget that does not have the enable() method: " + (widget.options.name));
		            return;
		        }
		        scope.$watch(kNgDisabled, function(newValue, oldValue) {
		            if (newValue != oldValue) {
		                widget.enable(!newValue);
		            }
		        });
		    }
	
		    function bindToKNgReadonly(widget, scope, element, kNgReadonly) {
		        if (typeof widget.readonly != "function") {
		            $log.warn("k-ng-readonly specified on a widget that does not have the readonly() method: " + (widget.options.name));
		            return;
		        }
		        scope.$watch(kNgReadonly, function(newValue, oldValue) {
		            if (newValue != oldValue) {
		                widget.readonly(newValue);
		            }
		        });
		    }
	
		    function exposeWidget(widget, scope, attrs, kendoWidget, origAttr) {
		        if (attrs[origAttr]) {
		            var set = $parse(attrs[origAttr]).assign;
		            if (set) {
		                // set the value of the expression to the kendo widget object to expose its api
		                set(scope, widget);
		            } else {
		                throw new Error(origAttr + ' attribute used but expression in it is not assignable: ' + attrs[kendoWidget]);
		            }
		        }
		    }
	
		    function formValue(element) {
		        if (/checkbox|radio/i.test(element.attr("type"))) {
		            return element.prop("checked");
		        }
		        return element.val();
		    }
	
		    var formRegExp = /^(input|select|textarea)$/i;
	
		    function isForm(element) {
		        return formRegExp.test(element[0].tagName);
		    }
	
		    function bindToNgModel(widget, scope, element, ngModel, ngForm) {
		        if (!widget.value) {
		            return;
		        }
	
		        var value;
		        // Some widgets trigger "change" on the input field
		        // and this would result in two events sent (#135)
		        var haveChangeOnElement = false;
	
		        if (isForm(element)) {
		            value = function() {
		                return formValue(element);
		            };
		        } else {
		            value = function() {
		                return widget.value();
		            };
		        }
	
		        // Angular will invoke $render when the view needs to be updated with the view value.
		        var viewRender = function() {
		            // Update the widget with the view value.
	
		            // delaying with setTimout for cases where the datasource is set thereafter.
		            // https://github.com/kendo-labs/angular-kendo/issues/304
		            var val = ngModel.$viewValue;
		            if (val === undefined) {
		                val = ngModel.$modelValue;
		            }
	
		            if (val === undefined) {
		                val = null;
		            }
	
		            haveChangeOnElement = true;
		            setTimeout(function(){
		                haveChangeOnElement = false;
		                if (widget) { // might have been destroyed in between. :-(
		                    var kNgModel = scope[widget.element.attr("k-ng-model")];
	
		                    if (kNgModel) {
		                        val = kNgModel;
		                    }
	
		                    if (widget.options.autoBind === false && !widget.listView.bound()) {
		                        if (val) {
		                            widget.value(val);
		                        }
		                    } else {
		                        widget.value(val);
		                    }
		                }
		            }, 0);
		        };
	
		        ngModel.$render = viewRender;
		        setTimeout(function() {
		            if (ngModel.$render !== viewRender) {
		                ngModel.$render = viewRender;
		                ngModel.$render();
		            }
		        });
	
		        if (isForm(element)) {
		            element.on("change", function() {
		                haveChangeOnElement = true;
		            });
		        }
	
		        var onChange = function(pristine) {
		            return function() {
		                var formPristine;
		                if (haveChangeOnElement && !element.is("select")) {
		                    return;
		                }
		                if (pristine && ngForm) {
		                    formPristine = ngForm.$pristine;
		                }
		                ngModel.$setViewValue(value());
		                if (pristine) {
		                    ngModel.$setPristine();
		                    if (formPristine) {
		                        ngForm.$setPristine();
		                    }
		                }
		                digest(scope);
		            };
		        };
	
		        widget.first("change", onChange(false));
		        widget.first("spin", onChange(false));
	
		        if (!(kendo.ui.AutoComplete && widget instanceof kendo.ui.AutoComplete)) {
		            widget.first("dataBound", onChange(true));
		        }
	
		        var currentVal = value();
	
		        // if the model value is undefined, then we set the widget value to match ( == null/undefined )
		        // In telerik/kendo-ui-core#1027 we discovered that after the timeout the $viewValue arives as NaN in some weird, default form.
		        // Hence the check below.
		        if (!isNaN(ngModel.$viewValue) && currentVal != ngModel.$viewValue) {
		            if (!ngModel.$isEmpty(ngModel.$viewValue)) {
		                widget.value(ngModel.$viewValue);
		            } else if (currentVal != null && currentVal !== "" && currentVal != ngModel.$viewValue) {
		                ngModel.$setViewValue(currentVal);
		            }
		        }
	
		        ngModel.$setPristine();
		    }
	
		    function bindToKNgModel(widget, scope, kNgModel) {
		        if (typeof widget.value != "function") {
		            $log.warn("k-ng-model specified on a widget that does not have the value() method: " + (widget.options.name));
		            return;
		        }
	
		        var form  = $(widget.element).parents("ng-form, form").first();
		        var ngForm = kendo.getter(form.attr("name"), true)(scope);
		        var getter = $parse(kNgModel);
		        var setter = getter.assign;
		        var updating = false;
	
		        var valueIsCollection = kendo.ui.MultiSelect && widget instanceof kendo.ui.MultiSelect ||
		                                kendo.ui.RangeSlider && widget instanceof kendo.ui.RangeSlider;
	
		        var length = function(value) {
		            //length is irrelevant when value is not collection
		            return value && valueIsCollection ? value.length : 0;
		        };
	
		        var currentValueLength = length(getter(scope));
	
		        widget.$angular_setLogicValue(getter(scope));
	
		        // keep in sync
		        var watchHandler = function(newValue, oldValue) {
		            if (newValue === undefined) {
		                // because widget's value() method usually checks if the new value is undefined,
		                // in which case it returns the current value rather than clearing the field.
		                // https://github.com/telerik/kendo-ui-core/issues/299
		                newValue = null;
		            }
	
		            //compare values by reference if a collection
		            if (updating || (newValue == oldValue && length(newValue) == currentValueLength)) {
		                return;
		            }
	
		            currentValueLength = length(newValue);
		            widget.$angular_setLogicValue(newValue);
		        };
	
		        if (valueIsCollection) {
		            scope.$watchCollection(kNgModel, watchHandler);
		        } else {
		            scope.$watch(kNgModel, watchHandler);
		        }
	
		        var changeHandler = function() {
		            updating = true;
	
		            if (ngForm && ngForm.$pristine) {
		                ngForm.$setDirty();
		            }
	
		            digest(scope, function(){
		                setter(scope, widget.$angular_getLogicValue());
		                currentValueLength = length(getter(scope));
		            });
	
		            updating = false;
		        };
	
		        widget.first("change", changeHandler);
		        widget.first("spin", changeHandler);
		    }
	
		    function destroyWidgetOnScopeDestroy(scope, widget) {
		        var deregister = scope.$on("$destroy", function() {
		            deregister();
		            if (widget) {
		                kendo.destroy(widget.element);
		                widget = null;
		            }
		        });
	
		        return deregister;
		    }
	
		    // mutation observers - propagate the original
		    // element's class to the widget wrapper.
		    function propagateClassToWidgetWrapper(widget, element) {
		        if (!(window.MutationObserver && widget.wrapper)) {
		            return;
		        }
	
		        var prevClassList = [].slice.call($(element)[0].classList);
	
		        var mo = new MutationObserver(function(changes){
		            suspend();    // make sure we don't trigger a loop
		            if (!widget) {
		                return;
		            }
	
		            changes.forEach(function(chg){
		                var w = $(widget.wrapper)[0];
		                switch (chg.attributeName) {
	
		                    case "class":
		                        // sync classes to the wrapper element
		                        var currClassList = [].slice.call(chg.target.classList);
		                        currClassList.forEach(function(cls){
		                            if (prevClassList.indexOf(cls) < 0) {
		                                w.classList.add(cls);
		                                if (kendo.ui.ComboBox && widget instanceof kendo.ui.ComboBox) { // https://github.com/kendo-labs/angular-kendo/issues/356
		                                    widget.input[0].classList.add(cls);
		                                }
		                            }
		                        });
		                        prevClassList.forEach(function(cls){
		                            if (currClassList.indexOf(cls) < 0) {
		                                w.classList.remove(cls);
		                                if (kendo.ui.ComboBox && widget instanceof kendo.ui.ComboBox) { // https://github.com/kendo-labs/angular-kendo/issues/356
		                                    widget.input[0].classList.remove(cls);
		                                }
		                            }
		                        });
		                        prevClassList = currClassList;
		                        break;
	
		                    case "disabled":
		                        if (typeof widget.enable == "function" && !widget.element.attr("readonly")) {
		                            widget.enable(!$(chg.target).attr("disabled"));
		                        }
		                        break;
	
		                    case "readonly":
		                        if (typeof widget.readonly == "function" && !widget.element.attr("disabled")) {
		                            widget.readonly(!!$(chg.target).attr("readonly"));
		                        }
		                        break;
		                }
		            });
	
		            resume();
		        });
	
		        function suspend() {
		            mo.disconnect();
		        }
	
		        function resume() {
		            mo.observe($(element)[0], { attributes: true });
		        }
	
		        resume();
		        widget.first("destroy", suspend);
		    }
	
		    function setupRebind(widget, scope, element, originalElement, rebindAttr, destroyRegister, attrs) {
		        // watch for changes on the expression passed in the k-rebind attribute
		        var unregister = scope.$watch(rebindAttr, function(newValue, oldValue) {
		            if (!widget._muteRebind && newValue !== oldValue) {
		                unregister(); // this watcher will be re-added if we compile again!
	
		                if (attrs._cleanUp) {
		                    attrs._cleanUp();
		                }
	
		                var templateOptions = WIDGET_TEMPLATE_OPTIONS[widget.options.name];
	
		                if (templateOptions) {
		                    templateOptions.forEach(function(name) {
		                        var templateContents = scope.$eval(attrs["k" + name]);
	
		                        if (templateContents) {
		                            originalElement.append($(templateContents).attr(kendo.toHyphens("k" + name), ""));
		                        }
		                    });
		                }
	
		                var _wrapper = $(widget.wrapper)[0];
		                var _element = $(widget.element)[0];
		                var isUpload = widget.options.name === "Upload";
	
		                if (isUpload) {
		                    element = $(_element);
		                }
	
		                var compile = element.injector().get("$compile");
		                widget._destroy();
	
		                if (destroyRegister) {
		                    destroyRegister();
		                }
	
		                widget = null;
	
		                if (_element) {
		                    if (_wrapper) {
		                        _wrapper.parentNode.replaceChild(_element, _wrapper);
		                    }
		                    $(element).replaceWith(originalElement);
		                }
	
		                compile(originalElement)(scope);
		            }
		        }, true); // watch for object equality. Use native or simple values.
		        digest(scope);
		    }
	
		    function bind(f, obj) {
		        return function(a, b) {
		            return f.call(obj, a, b);
		        };
		    }
	
		    function setTemplate(key, value) {
		        this[key] = kendo.stringify(value); // jshint ignore:line
		    }
	
		    module.factory('directiveFactory', [ '$compile', function(compile) {
		        var kendoRenderedTimeout;
		        var RENDERED = false;
	
		        // caching $compile for the dirty hack upstairs. This is awful, but we happen to have elements outside of the bootstrapped root :(.
		        $defaultCompile = compile;
	
		        var create = function(role, origAttr) {
		            return {
		                // Parse the directive for attributes and classes
		                restrict: "AC",
		                require: [ "?ngModel", "^?form" ],
		                scope: false,
	
		                controller: [ '$scope', '$attrs', '$element', function($scope, $attrs) {
		                    this.template = bind(setTemplate, $attrs);
		                    $attrs._cleanUp = bind(function(){
		                        this.template = null;
		                        $attrs._cleanUp = null;
		                    }, this);
		                }],
	
		                link: function(scope, element, attrs, controllers) {
		                    var $element = $(element);
	
		                    // we must remove data-kendo-widget-name attribute because
		                    // it breaks kendo.widgetInstance; can generate all kinds
		                    // of funny issues like
		                    //
		                    //   https://github.com/kendo-labs/angular-kendo/issues/167
		                    //
		                    // but we still keep the attribute without the
		                    // `data-` prefix, so k-rebind would work.
		                    var roleattr = role.replace(/([A-Z])/g, "-$1");
	
		                    $element.attr(roleattr, $element.attr("data-" + roleattr));
		                    $element[0].removeAttribute("data-" + roleattr);
	
		                    var widget = createWidget(scope, element, attrs, role, origAttr, controllers);
	
		                    if (!widget) {
		                        return;
		                    }
	
		                    if (kendoRenderedTimeout) {
		                        clearTimeout(kendoRenderedTimeout);
		                    }
	
		                    kendoRenderedTimeout = setTimeout(function() {
		                        scope.$emit("kendoRendered");
		                        if (!RENDERED) {
		                            RENDERED = true;
		                            $("form").each(function(){
		                                var form = $(this).controller("form");
		                                if (form) {
		                                    form.$setPristine();
		                                }
		                            });
		                        }
		                    });
		                }
		            };
		        };
	
		        return {
		            create: create
		        };
		    }]);
	
		    var TAGNAMES = {
		        Editor         : "textarea",
		        NumericTextBox : "input",
		        DatePicker     : "input",
		        DateTimePicker : "input",
		        TimePicker     : "input",
		        AutoComplete   : "input",
		        ColorPicker    : "input",
		        MaskedTextBox  : "input",
		        MultiSelect    : "input",
		        Upload         : "input",
		        Validator      : "form",
		        Button         : "button",
		        MobileButton        : "a",
		        MobileBackButton    : "a",
		        MobileDetailButton  : "a",
		        ListView       : "ul",
		        MobileListView: "ul",
		        PanelBar       : "ul",
		        TreeView       : "ul",
		        Menu           : "ul",
		        ContextMenu    : "ul",
		        ActionSheet    : "ul"
		    };
	
		    var SKIP_SHORTCUTS = [
		        'MobileView',
		        'MobileDrawer',
		        'MobileLayout',
		        'MobileSplitView',
		        'MobilePane',
		        'MobileModalView'
		    ];
	
		    var MANUAL_DIRECTIVES = [
		        'MobileApplication',
		        'MobileView',
		        'MobileModalView',
		        'MobileLayout',
		        'MobileActionSheet',
		        'MobileDrawer',
		        'MobileSplitView',
		        'MobilePane',
		        'MobileScrollView',
		        'MobilePopOver'
		    ];
	
		    angular.forEach(['MobileNavBar', 'MobileButton', 'MobileBackButton', 'MobileDetailButton', 'MobileTabStrip', 'MobileScrollView', 'MobileScroller'], function(widget) {
		        MANUAL_DIRECTIVES.push(widget);
		        widget = "kendo" + widget;
		        module.directive(widget, function() {
		            return {
		                restrict: "A",
		                link: function(scope, element, attrs) {
		                    createWidget(scope, element, attrs, widget, widget);
		                }
		            };
		        });
		    });
	
		    function createDirectives(klass, isMobile) {
		        function make(directiveName, widgetName) {
		            module.directive(directiveName, [
		                "directiveFactory",
		                function(directiveFactory) {
		                    return directiveFactory.create(widgetName, directiveName);
		                }
		            ]);
		        }
	
		        var name = isMobile ? "Mobile" : "";
		        name += klass.fn.options.name;
	
		        var className = name;
		        var shortcut = "kendo" + name.charAt(0) + name.substr(1).toLowerCase();
		        name = "kendo" + name;
	
		        // <kendo-numerictextbox>-type directives
		        var dashed = name.replace(/([A-Z])/g, "-$1");
	
		        if (SKIP_SHORTCUTS.indexOf(name.replace("kendo", "")) == -1) {
		            var names = name === shortcut ? [ name ] : [ name, shortcut ];
		            angular.forEach(names, function(directiveName) {
		                module.directive(directiveName, function(){
		                    return {
		                        restrict : "E",
		                        replace  : true,
		                        template : function(element, attributes) {
		                            var tag = TAGNAMES[className] || "div";
		                            var scopeField = attributes.kScopeField || attributes.scopeField;
	
		                            return "<" + tag + " " + dashed + (scopeField ? ('="' + scopeField + '"') : "") + ">" + element.html() + "</" + tag + ">";
		                        }
		                    };
		                });
		            });
		        }
	
		        if (MANUAL_DIRECTIVES.indexOf(name.replace("kendo", "")) > -1) {
		            return;
		        }
	
		        // here name should be like kendoMobileListView so kendo-mobile-list-view works,
		        // and shortcut like kendoMobilelistview, for kendo-mobilelistview
	
		        make(name, name);
		        if (shortcut != name) {
		            make(shortcut, name);
		        }
	
		    }
	
		    /* -----[ utils ]----- */
	
		    function kendoWidgetInstance(el) {
		        el = $(el);
		        return kendo.widgetInstance(el, kendo.ui) ||
		            kendo.widgetInstance(el, kendo.mobile.ui) ||
		            kendo.widgetInstance(el, kendo.dataviz.ui);
		    }
	
		    function digest(scope, func) {
		        var root = scope.$root || scope;
		        var isDigesting = /^\$(digest|apply)$/.test(root.$$phase);
		        if (func) {
		            if (isDigesting) {
		                func();
		            } else {
		                root.$apply(func);
		            }
		        } else if (!isDigesting) {
		            root.$digest();
		        }
		    }
	
		    function destroyScope(scope, el) {
		        scope.$destroy();
		        if (el) {
		            // prevent leaks. https://github.com/kendo-labs/angular-kendo/issues/237
		            $(el)
		                .removeData("$scope")
		                .removeData("$$kendoScope")
		                .removeData("$isolateScope")
		                .removeData("$isolateScopeNoTemplate")
		                .removeClass("ng-scope");
		        }
		    }
	
		    var encode = kendo.htmlEncode;
		    var open = /{{/g;
		    var close = /}}/g;
		    var encOpen = '{&#8203;{';
		    var encClose = '}&#8203;}';
	
		    kendo.htmlEncode = function(str) {
		        return encode(str)
		            .replace(open, encOpen)
		            .replace(close, encClose);
		    };
	
		    var pendingPatches = [];
	
		    // defadvice will patch a class' method with another function.  That
		    // function will be called in a context containing `next` (to call
		    // the next method) and `object` (a reference to the original
		    // object).
		    function defadvice(klass, methodName, func) {
		        if ($.isArray(klass)) {
		            return angular.forEach(klass, function(klass){
		                defadvice(klass, methodName, func);
		            });
		        }
		        if (typeof klass == "string") {
		            var a = klass.split(".");
		            var x = kendo;
		            while (x && a.length > 0) {
		                x = x[a.shift()];
		            }
		            if (!x) {
		                pendingPatches.push([ klass, methodName, func ]);
		                return false;
		            }
		            klass = x.prototype;
		        }
		        var origMethod = klass[methodName];
		        klass[methodName] = function() {
		            var self = this, args = arguments;
		            return func.apply({
		                self: self,
		                next: function() {
		                    return origMethod.apply(self, arguments.length > 0 ? arguments : args);
		                }
		            }, args);
		        };
		        return true;
		    }
	
		    kendo.onWidgetRegistered(function(entry){
		        pendingPatches = $.grep(pendingPatches, function(args){
		            return !defadvice.apply(null, args);
		        });
		        createDirectives(entry.widget, entry.prefix == "Mobile");
		    });
	
		    /* -----[ Customize widgets for Angular ]----- */
	
		    defadvice([ "ui.Widget", "mobile.ui.Widget" ], "angular", function(cmd, arg){
		        var self = this.self;
		        if (cmd == "init") {
		            // `arg` here should be the widget options.
		            // the Chart doesn't send the options to Widget::init in constructor
		            // hence the OPTIONS_NOW hack (initialized in createWidget).
		            if (!arg && OPTIONS_NOW) {
		                arg = OPTIONS_NOW;
		            }
		            OPTIONS_NOW = null;
		            if (arg && arg.$angular) {
		                self.$angular_scope = arg.$angular[0];
		                self.$angular_init(self.element, arg);
		            }
		            return;
		        }
	
		        var scope = self.$angular_scope;
	
		        if (scope) {
		            withoutTimeout(function(){
		                var x = arg(), elements = x.elements, data = x.data;
		                if (elements.length > 0) {
		                    switch (cmd) {
	
		                      case "cleanup":
		                        angular.forEach(elements, function(el){
		                            var itemScope = $(el).data("$$kendoScope");
	
		                            if (itemScope && itemScope !== scope && itemScope.$$kendoScope) {
		                                destroyScope(itemScope, el);
		                            }
		                        });
		                        break;
	
		                      case "compile":
		                        var injector = self.element.injector();
		                        var compile = injector ? injector.get("$compile") : $defaultCompile;
	
		                        angular.forEach(elements, function(el, i){
		                            var itemScope;
		                            if (x.scopeFrom) {
		                                itemScope = x.scopeFrom;
		                            } else {
		                                var vars = data && data[i];
		                                if (vars !== undefined) {
		                                    itemScope = $.extend(scope.$new(), vars);
		                                    itemScope.$$kendoScope = true;
		                                } else {
		                                    itemScope = scope;
		                                }
		                            }
	
		                            $(el).data("$$kendoScope", itemScope);
		                            compile(el)(itemScope);
		                        });
		                        digest(scope);
		                        break;
		                    }
		                }
		            });
		        }
		    });
	
		    defadvice("ui.Widget", "$angular_getLogicValue", function(){
		        return this.self.value();
		    });
	
		    defadvice("ui.Widget", "$angular_setLogicValue", function(val){
		        this.self.value(val);
		    });
	
		    defadvice("ui.Select", "$angular_getLogicValue", function(){
		        var item = this.self.dataItem(),
		            valueField = this.self.options.dataValueField;
	
		        if (item) {
		            if (this.self.options.valuePrimitive) {
		                if (!!valueField) {
		                    return item[valueField];
		                } else {
		                    return item;
		                }
		            } else {
		                return item.toJSON();
		            }
		        } else {
		            return null;
		        }
		    });
	
		    defadvice("ui.Select", "$angular_setLogicValue", function(val){
		        var self = this.self;
		        var options = self.options;
		        var valueField = options.dataValueField;
		        var text = options.text || "";
	
		        if (val === undefined) {
		            val = "";
		        }
	
		        if (valueField && !options.valuePrimitive && val) {
		            text = val[options.dataTextField] || "";
		            val = val[valueField || options.dataTextField];
		        }
	
		        if (self.options.autoBind === false && !self.listView.bound()) {
		            if (!text && val && options.valuePrimitive) {
		                self.value(val);
		            } else {
		                self._preselect(val, text);
		            }
		        } else {
		            self.value(val);
		        }
		    });
	
		    defadvice("ui.MultiSelect", "$angular_getLogicValue", function() {
		        var value = this.self.dataItems().slice(0);
		        var valueField = this.self.options.dataValueField;
	
		        if (valueField && this.self.options.valuePrimitive) {
		            value = $.map(value, function(item) {
		                return item[valueField];
		            });
		        }
	
		        return value;
		    });
	
		    defadvice("ui.MultiSelect", "$angular_setLogicValue", function(val){
		        if (val == null) {
		            val = [];
		        }
	
		        var self = this.self;
		        var options = self.options;
		        var valueField = options.dataValueField;
		        var data = val;
	
		        if (valueField && !options.valuePrimitive) {
		            val = $.map(val, function(item) {
		                return item[valueField];
		            });
		        }
	
		        if (options.autoBind === false && !options.valuePrimitive && !self.listView.bound()) {
		            self._preselect(data, val);
		        } else {
		            self.value(val);
		        }
		    });
	
		    /* AutoComplete's getter and setter are removed!
		       By design, AutoComplete should be bound only to primitive string
		       value and data items are bound only to serve the list of suggestions.
	
		       Binding multiple data items is supported by the MultiSelect widget.
		    */
	
		    // All event handlers that are strings are compiled the Angular way.
		    defadvice("ui.Widget", "$angular_init", function(element, options) {
		        var self = this.self;
		        if (options && !$.isArray(options)) {
		            var scope = self.$angular_scope;
		            for (var i = self.events.length; --i >= 0;) {
		                var event = self.events[i];
		                var handler = options[event];
		                if (handler && typeof handler == "string") {
		                    options[event] = self.$angular_makeEventHandler(event, scope, handler);
		                }
		            }
		        }
		    });
	
		    // most handers will only contain a kendoEvent in the scope.
		    defadvice("ui.Widget", "$angular_makeEventHandler", function(event, scope, handler){
		        handler = $parse(handler);
		        return function(e) {
		            digest(scope, function() {
		                handler(scope, { kendoEvent: e });
		            });
		        };
		    });
	
		    // for the Grid and ListView we add `data` and `selected` too.
		    defadvice([ "ui.Grid", "ui.ListView", "ui.TreeView", "ui.PanelBar" ], "$angular_makeEventHandler", function(event, scope, handler){
		        if (event != "change") {
		            return this.next();
		        }
		        handler = $parse(handler);
		        return function(ev) {
		            var widget = ev.sender;
		            var options = widget.options;
		            var cell, multiple, locals = { kendoEvent: ev }, elems, items, columns, colIdx;
	
		            if (angular.isString(options.selectable)) {
		                cell = options.selectable.indexOf('cell') !== -1;
		                multiple = options.selectable.indexOf('multiple') !== -1;
		            }
		            if (widget._checkBoxSelection) {
		                multiple = true;
		            }
	
		            elems = locals.selected = this.select();
		            items = locals.data = [];
		            columns = locals.columns = [];
		            for (var i = 0; i < elems.length; i++) {
		                var item = cell ? elems[i].parentNode : elems[i];
		                var dataItem = widget.dataItem(item);
		                if (cell) {
		                    if (angular.element.inArray(dataItem, items) < 0) {
		                        items.push(dataItem);
		                    }
		                    colIdx = angular.element(elems[i]).index();
		                    if (angular.element.inArray(colIdx, columns) < 0 ) {
		                        columns.push(colIdx);
		                    }
		                } else {
		                    items.push(dataItem);
		                }
		            }
	
		            if (!multiple) {
		                locals.dataItem = locals.data = items[0];
		                locals.angularDataItem = kendo.proxyModelSetters(locals.dataItem);
		                locals.selected = elems[0];
		            }
	
		            digest(scope, function() {
		                handler(scope, locals);
		            });
		        };
		    });
	
		    // If no `template` is supplied for Grid columns, provide an Angular
		    // template.  The reason is that in this way AngularJS will take
		    // care to update the view as the data in scope changes.
		    defadvice("ui.Grid", "$angular_init", function(element, options){
		        this.next();
		        if (options.columns) {
		            var settings = $.extend({}, kendo.Template, options.templateSettings);
		            angular.forEach(options.columns, function(col){
		                if (col.field && !col.template && !col.format && !col.values && (col.encoded === undefined || col.encoded)) {
		                    col.template = "<span ng-bind='" +
		                        kendo.expr(col.field, "dataItem") + "'>#: " +
		                        kendo.expr(col.field, settings.paramName) + "#</span>";
		                }
		            });
		        }
		    });
	
		    {
		        // mobile/ButtonGroup does not have a "value" method, but looks
		        // like it would be useful.  We provide it here.
	
		        defadvice("mobile.ui.ButtonGroup", "value", function(mew){
		            var self = this.self;
		            if (mew != null) {
		                self.select(self.element.children("li.km-button").eq(mew));
		                self.trigger("change");
		                self.trigger("select", { index: self.selectedIndex });
		            }
		            return self.selectedIndex;
		        });
	
		        defadvice("mobile.ui.ButtonGroup", "_select", function(){
		            this.next();
		            this.self.trigger("change");
		        });
		    }
	
		    // mobile directives
		    module
		    .directive('kendoMobileApplication', function() {
		        return {
		            terminal: true,
		            link: function(scope, element, attrs) {
		                createWidget(scope, element, attrs, 'kendoMobileApplication', 'kendoMobileApplication');
		            }
		        };
		    }).directive('kendoMobileView', function() {
		        return {
		            scope: true,
		            link: {
		                pre: function(scope, element, attrs) {
		                    attrs.defaultOptions = scope.viewOptions;
		                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileView', 'kendoMobileView');
		                },
	
		                post: function(scope, element, attrs) {
		                    attrs._instance._layout();
		                    attrs._instance._scroller();
		                }
		            }
		        };
		    }).directive('kendoMobileDrawer', function() {
		        return {
		            scope: true,
		            link: {
		                pre: function(scope, element, attrs) {
		                    attrs.defaultOptions = scope.viewOptions;
		                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileDrawer', 'kendoMobileDrawer');
		                },
	
		                post: function(scope, element, attrs) {
		                    attrs._instance._layout();
		                    attrs._instance._scroller();
		                }
		            }
		        };
		    }).directive('kendoMobileModalView', function() {
		        return {
		            scope: true,
		            link: {
		                pre: function(scope, element, attrs) {
		                    attrs.defaultOptions = scope.viewOptions;
		                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileModalView', 'kendoMobileModalView');
		                },
	
		                post: function(scope, element, attrs) {
		                    attrs._instance._layout();
		                    attrs._instance._scroller();
		                }
		            }
		        };
		    }).directive('kendoMobileSplitView', function() {
		        return {
		            terminal: true,
		            link: {
		                pre: function(scope, element, attrs) {
		                    attrs.defaultOptions = scope.viewOptions;
		                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileSplitView', 'kendoMobileSplitView');
		                },
	
		                post: function(scope, element, attrs) {
		                    attrs._instance._layout();
		                }
		            }
		        };
		    }).directive('kendoMobilePane', function() {
		        return {
		            terminal: true,
		            link: {
		                pre: function(scope, element, attrs) {
		                    attrs.defaultOptions = scope.viewOptions;
		                    createWidget(scope, element, attrs, 'kendoMobilePane', 'kendoMobilePane');
		                }
		            }
		        };
		    }).directive('kendoMobileLayout', function() {
		        return {
		            link: {
		                pre: function (scope, element, attrs) {
		                    createWidget(scope, element, attrs, 'kendoMobileLayout', 'kendoMobileLayout');
		                }
		            }
		        };
		    }).directive('kendoMobileActionSheet', function() {
		        return {
		            restrict: "A",
		            link: function(scope, element, attrs) {
		                element.find("a[k-action]").each(function() {
		                    $(this).attr("data-" + kendo.ns + "action", $(this).attr("k-action"));
		                });
	
		                createWidget(scope, element, attrs, 'kendoMobileActionSheet', 'kendoMobileActionSheet');
		            }
		        };
		    }).directive('kendoMobilePopOver', function() {
		        return {
		            terminal: true,
		            link: {
		                pre: function(scope, element, attrs) {
		                    attrs.defaultOptions = scope.viewOptions;
		                    createWidget(scope, element, attrs, 'kendoMobilePopOver', 'kendoMobilePopOver');
		                }
		            }
		        };
		    }).directive('kendoViewTitle', function(){
		        return {
		            restrict : "E",
		            replace  : true,
		            template : function(element) {
		                return "<span data-" + kendo.ns + "role='view-title'>" + element.html() + "</span>";
		            }
		        };
		    }).directive('kendoMobileHeader', function() {
		            return {
		                restrict: "E",
		                link: function(scope, element) {
		                    element.addClass("km-header").attr("data-role", "header");
		                }
		            };
		    }).directive('kendoMobileFooter', function() {
		            return {
		                restrict: 'E',
		                link: function(scope, element) {
		                    element.addClass("km-footer").attr("data-role", "footer");
		                }
		            };
		    }).directive('kendoMobileScrollViewPage', function(){
		        return {
		            restrict : "E",
		            replace  : true,
		            template : function(element) {
		                return "<div data-" + kendo.ns + "role='page'>" + element.html() + "</div>";
		            }
		        };
		    });
	
		    angular.forEach(['align', 'icon', 'rel', 'transition', 'actionsheetContext'], function(attr) {
		          var kAttr = "k" + attr.slice(0, 1).toUpperCase() + attr.slice(1);
	
		          module.directive(kAttr, function() {
		              return {
		                  restrict: 'A',
		                  priority: 2,
		                  link: function(scope, element, attrs) {
		                      element.attr(kendo.attr(kendo.toHyphens(attr)), scope.$eval(attrs[kAttr]));
		                  }
		              };
		          });
		    });
	
		    var WIDGET_TEMPLATE_OPTIONS = {
		        "TreeMap": [ "Template" ],
		        "MobileListView": [ "HeaderTemplate", "Template" ],
		        "MobileScrollView": [ "EmptyTemplate", "Template" ],
		        "Grid": [ "AltRowTemplate", "DetailTemplate", "RowTemplate" ],
		        "ListView": [ "EditTemplate", "Template", "AltTemplate" ],
		        "Pager": [ "SelectTemplate", "LinkTemplate" ],
		        "PivotGrid": [ "ColumnHeaderTemplate", "DataCellTemplate", "RowHeaderTemplate" ],
		        "Scheduler": ["AllDayEventTemplate", "DateHeaderTemplate", "EventTemplate", "MajorTimeHeaderTemplate", "MinorTimeHeaderTemplate"],
		        "PanelBar": [ "Template" ],
		        "TreeView": [ "Template" ],
		        "Validator": [ "ErrorTemplate" ]
		    };
	
		    (function() {
		        var templateDirectives = {};
		        angular.forEach(WIDGET_TEMPLATE_OPTIONS, function(templates, widget) {
		            angular.forEach(templates, function(template) {
		                if (!templateDirectives[template]) {
		                    templateDirectives[template] = [ ];
		                }
		                templateDirectives[template].push("?^^kendo" + widget);
		            });
		        });
	
		        angular.forEach(templateDirectives, function(parents, directive) {
		            var templateName = "k" + directive;
		            var attrName = kendo.toHyphens(templateName);
	
		            module.directive(templateName, function() {
		                return {
		                    restrict: "A",
		                    require: parents,
		                    terminal: true,
		                    compile: function($element, $attrs) {
		                        if ($attrs[templateName] !== "") {
		                            return;
		                        }
	
		                        $element.removeAttr(attrName);
		                        var template = $element[0].outerHTML;
	
		                        return function(scope, element, attrs, controllers) {
		                            var controller;
	
		                            while(!controller && controllers.length) {
		                                controller = controllers.shift();
		                            }
	
		                            if (!controller) {
		                                $log.warn(attrName + " without a matching parent widget found. It can be one of the following: " + parents.join(", "));
		                            } else {
		                                controller.template(templateName, template);
		                                element.remove();
		                            }
		                        };
		                    }
		                };
		            });
		        });
	
		    })();
	
	
		})(window.kendo.jQuery, window.angular);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1027);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1027:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1028) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "calendar",
		    name: "Calendar",
		    category: "web",
		    description: "The Calendar widget renders a graphical calendar that supports navigation and selection.",
		    depends: [ "core", "selectable" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        support = kendo.support,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        keys = kendo.keys,
		        parse = kendo.parseDate,
		        adjustDST = kendo.date.adjustDST,
		        weekInYear = kendo.date.weekInYear,
		        Selectable = kendo.ui.Selectable,
		        extractFormat = kendo._extractFormat,
		        template = kendo.template,
		        getCulture = kendo.getCulture,
		        transitions = kendo.support.transitions,
		        transitionOrigin = transitions ? transitions.css + "transform-origin" : "",
		        cellTemplate = template('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link" href="\\#" data-#=data.ns#value="#=data.dateString#">#=data.value#</a></td>', { useWithBlock: false }),
		        emptyCellTemplate = template('<td role="gridcell">&nbsp;</td>', { useWithBlock: false }),
		        weekNumberTemplate = template('<td class="k-alt">#= data.weekNumber #</td>', { useWithBlock: false }),
		        browser = kendo.support.browser,
		        isIE8 = browser.msie && browser.version < 9,
		        outerHeight = kendo._outerHeight,
		        outerWidth = kendo._outerWidth,
		        ns = ".kendoCalendar",
		        CLICK = "click" + ns,
		        KEYDOWN_NS = "keydown" + ns,
		        ID = "id",
		        MIN = "min",
		        LEFT = "left",
		        SLIDE = "slideIn",
		        MONTH = "month",
		        CENTURY = "century",
		        CHANGE = "change",
		        NAVIGATE = "navigate",
		        VALUE = "value",
		        HOVER = "k-state-hover",
		        DISABLED = "k-state-disabled",
		        FOCUSED = "k-state-focused",
		        OTHERMONTH = "k-other-month",
		        OTHERMONTHCLASS = ' class="' + OTHERMONTH + '"',
		        TODAY = "k-nav-today",
		        CELLSELECTOR = "td:has(.k-link)",
		        CELLSELECTORVALID = "td:has(.k-link):not(." + DISABLED + ")",
		        WEEKCOLUMNSELECTOR = "td:not(:has(.k-link))",
		        SELECTED = "k-state-selected",
		        BLUR = "blur" + ns,
		        FOCUS = "focus",
		        FOCUS_WITH_NS = FOCUS + ns,
		        MOUSEENTER = support.touch ? "touchstart" : "mouseenter",
		        MOUSEENTER_WITH_NS = support.touch ? "touchstart" + ns : "mouseenter" + ns,
		        MOUSELEAVE = support.touch ? "touchend" + ns + " touchmove" + ns : "mouseleave" + ns,
		        MS_PER_MINUTE = 60000,
		        MS_PER_DAY = 86400000,
		        PREVARROW = "_prevArrow",
		        NEXTARROW = "_nextArrow",
		        ARIA_DISABLED = "aria-disabled",
		        ARIA_SELECTED = "aria-selected",
		        ARIA_LABEL = "aria-label",
		        proxy = $.proxy,
		        extend = $.extend,
		        DATE = Date,
		        views = {
		            month: 0,
		            year: 1,
		            decade: 2,
		            century: 3
		        };
	
		    var Calendar = Widget.extend({
		        init: function(element, options) {
		            var that = this, value, id;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.wrapper = that.element;
		            options = that.options;
	
		            options.url = window.unescape(options.url);
	
		            that.options.disableDates = getDisabledExpr(that.options.disableDates);
	
		            that._templates();
	
		            that._selectable();
	
		            that._header();
	
		            that._footer(that.footer);
	
		            id = element
		                    .addClass("k-widget k-calendar " + (options.weekNumber ? " k-week-number" : ""))
		                    .on(MOUSEENTER_WITH_NS + " " + MOUSELEAVE, CELLSELECTOR, mousetoggle)
		                    .on(KEYDOWN_NS, "table.k-content", proxy(that._move, that))
		                    .on(CLICK, CELLSELECTOR, function(e) {
		                        var link = e.currentTarget.firstChild,
		                            value = that._toDateObject(link);
	
		                        if (link.href.indexOf("#") != -1) {
		                            e.preventDefault();
		                        }
	
		                        if (that._view.name == "month" && that.options.disableDates(value)) {
		                            return;
		                        }
		                        if(that._view.name != "month" || options.selectable == "single") {
		                             that._click($(link));
		                        }
		                    })
		                    .on("mouseup" + ns, "table.k-content, .k-footer", function() {
		                        that._focusView(that.options.focusOnNav !== false);
		                    })
		                    .attr(ID);
	
		            if (id) {
		                that._cellID = id + "_cell_selected";
		            }
	
		            if(that._isMultipleSelection() && that.options.weekNumber) {
		                element.on(CLICK, WEEKCOLUMNSELECTOR, function(e) {
		                        var first = $(e.currentTarget).closest("tr").find(CELLSELECTORVALID).first(),
		                            last = that.selectable._lastActive = $(e.currentTarget).closest("tr").find(CELLSELECTORVALID).last();
		                        that.selectable.selectRange(first, last, { event: e});
		                        that._current = that._value = that._toDateObject(last.find("a"));
		                        that._class(FOCUSED, that._current);
		                });
		            }
	
		            normalize(options);
		            value = parse(options.value, options.format, options.culture);
		            that._selectDates = [];
	
		            that._index = views[options.start];
	
		            that._current = new DATE(+restrictValue(value, options.min, options.max));
	
		            that._addClassProxy = function() {
		                that._active = true;
	
		                if (that._cell.hasClass(DISABLED)) {
		                    var todayString = that._view.toDateString(getToday());
		                    that._cell = that._cellByDate(todayString);
		                }
	
		                that._cell.addClass(FOCUSED);
		            };
	
		            that._removeClassProxy = function() {
		                that._active = false;
		                that._cell.removeClass(FOCUSED);
		            };
	
		            that.value(value);
	
		            if(that._isMultipleSelection() && options.selectDates.length > 0) {
		                that.selectDates(options.selectDates);
		            }
		            kendo.notify(that);
		        },
	
		        options: {
		            name: "Calendar",
		            value: null,
		            min: new DATE(1900, 0, 1),
		            max: new DATE(2099, 11, 31),
		            dates: [],
		            disableDates: null,
		            url: "",
		            culture: "",
		            footer : "",
		            format : "",
		            month : {},
		            weekNumber: false,
		            selectable: "single",
		            selectDates: [],
		            start: MONTH,
		            depth: MONTH,
		            animation: {
		                horizontal: {
		                    effects: SLIDE,
		                    reverse: true,
		                    duration: 500,
		                    divisor: 2
		                },
		                vertical: {
		                    effects: "zoomIn",
		                    duration: 400
		                }
		            },
		            messages: {
		                weekColumnHeader: ""
		            }
		        },
	
		        events: [
		            CHANGE,
		            NAVIGATE
		        ],
	
		        setOptions: function(options) {
		            var that = this;
	
		            normalize(options);
	
		            options.disableDates = getDisabledExpr(options.disableDates);
	
		            Widget.fn.setOptions.call(that, options);
	
		            that._templates();
	
		            that._selectable();
	
		            that._footer(that.footer);
		            that._index = views[that.options.start];
	
		            that.navigate();
		        },
	
		        destroy: function() {
		            var that = this,
		            today = that._today;
	
		            that.element.off(ns);
		            that._title.off(ns);
		            that[PREVARROW].off(ns);
		            that[NEXTARROW].off(ns);
		            that._destroySelectable();
		            kendo.destroy(that._table);
	
		            if (today) {
		                kendo.destroy(today.off(ns));
		            }
	
		            Widget.fn.destroy.call(that);
		        },
	
		        current: function() {
		            return this._current;
		        },
	
		        view: function() {
		            return this._view;
		        },
	
		        focus: function(table) {
		            table = table || this._table;
		            this._bindTable(table);
		            table.focus();
		        },
	
		        min: function(value) {
		            return this._option(MIN, value);
		        },
	
		        max: function(value) {
		            return this._option("max", value);
		        },
	
		        navigateToPast: function() {
		            this._navigate(PREVARROW, -1);
		        },
	
		        navigateToFuture: function() {
		            this._navigate(NEXTARROW, 1);
		        },
	
		        navigateUp: function() {
		            var that = this,
		            index = that._index;
	
		            if (that._title.hasClass(DISABLED)) {
		                return;
		            }
	
		            that.navigate(that._current, ++index);
		        },
	
		        navigateDown: function(value) {
		            var that = this,
		            index = that._index,
		            depth = that.options.depth;
	
		            if (!value) {
		                return;
		            }
	
		            if (index === views[depth]) {
		                if (!isEqualDate(that._value, that._current) || !isEqualDate(that._value, value)) {
		                    that.value(value);
		                    that.trigger(CHANGE);
		                }
		                return;
		            }
	
		            that.navigate(value, --index);
		        },
	
		        navigate: function(value, view) {
		            view = isNaN(view) ? views[view] : view;
	
		            var that = this,
		                options = that.options,
		                culture = options.culture,
		                min = options.min,
		                max = options.max,
		                title = that._title,
		                from = that._table,
		                old = that._oldTable,
		                currentValue = that._current,
		                future = value && +value > +currentValue,
		                vertical = view !== undefined && view !== that._index,
		                to, currentView, compare,
		                disabled;
		            if (!value) {
		                value = currentValue;
		            }
	
		            that._current = value = new DATE(+restrictValue(value, min, max));
	
		            if (view === undefined) {
		                view = that._index;
		            } else {
		                that._index = view;
		            }
	
		            that._view = currentView = calendar.views[view];
		            compare = currentView.compare;
	
		            disabled = view === views[CENTURY];
		            title.toggleClass(DISABLED, disabled).attr(ARIA_DISABLED, disabled);
	
		            disabled = compare(value, min) < 1;
		            that[PREVARROW].toggleClass(DISABLED, disabled).attr(ARIA_DISABLED, disabled);
		            if (that[PREVARROW].hasClass(DISABLED)) {
		                that[PREVARROW].removeClass(HOVER);
		            }
	
		            disabled = compare(value, max) > -1;
		            that[NEXTARROW].toggleClass(DISABLED, disabled).attr(ARIA_DISABLED, disabled);
		            if (that[NEXTARROW].hasClass(DISABLED)) {
		                that[NEXTARROW].removeClass(HOVER);
		            }
	
		            if (from && old && old.data("animating")) {
		                old.kendoStop(true, true);
		                from.kendoStop(true, true);
		            }
	
		            that._oldTable = from;
	
		            if (!from || that._changeView) {
		                title.html(currentView.title(value, min, max, culture));
	
		                that._table = to = $(currentView.content(extend({
		                    min: min,
		                    max: max,
		                    date: value,
		                    url: options.url,
		                    dates: options.dates,
		                    format: options.format,
		                    culture: culture,
		                    disableDates: options.disableDates,
		                    isWeekColumnVisible: options.weekNumber,
		                    messages: options.messages
		                }, that[currentView.name])));
	
		                addClassToViewContainer(to, currentView.name);
		                makeUnselectable(to);
		                var replace = from && from.data("start") === to.data("start");
		                that._animate({
		                    from: from,
		                    to: to,
		                    vertical: vertical,
		                    future: future,
		                    replace: replace
		                });
	
		                that.trigger(NAVIGATE);
	
		                that._focus(value);
		            }
	
		            if (view === views[options.depth] && that._selectDates.length > 0) {
		                that._visualizeSelectedDatesInView();
		            }
	
		            if(that.options.selectable === "single") {
		                if (view === views[options.depth] && that._value && !that.options.disableDates(that._value)) {
		                that._class("k-state-selected", that._value);
		                }
		            }
	
		            that._class(FOCUSED, value);
	
		            if (!from && that._cell) {
		                that._cell.removeClass(FOCUSED);
		            }
	
		            that._changeView = true;
		        },
	
		        selectDates: function(dates) {
		            var that = this,
		                validSelectedDates,
		                datesUnique;
	
		            if(dates === undefined) {
		                return that._selectDates;
		            }
	
		            datesUnique = dates
		                .map(function (date) { return date.getTime(); })
		                .filter(function (date, position, array) {
		                    return array.indexOf(date) === position;
		                })
		                .map(function (time) { return new Date(time); });
	
		            validSelectedDates = $.grep(datesUnique, function(value) {
		                if(value) {
		                    return +that._validateValue(new Date(value.setHours(0, 0, 0, 0))) === +value;
		                }
		            });
		            that._selectDates = validSelectedDates.length > 0 ? validSelectedDates : (datesUnique.length === 0 ? datesUnique : that._selectDates);
		            that._visualizeSelectedDatesInView();
		        },
	
		        value: function(value) {
		            var that = this,
		                old = that._view,
		                view = that._view;
	
		            if (value === undefined) {
		                return that._value;
		            }
	
		            value = that._validateValue(value);
		            if(value && that._isMultipleSelection()) {
		                var date = new Date(+value);
		                date.setHours(0, 0, 0, 0);
		                that._selectDates = [date];
		                that.selectable._lastActive = null;
		            }
		            if (old && value === null && that._cell) {
		                that._cell.removeClass(SELECTED);
		            } else {
		                that._changeView = !value || view && view.compare(value, that._current) !== 0;
		                that.navigate(value);
		            }
		        },
	
		        _validateValue: function(value) {
		            var that = this,
		                options = that.options,
		                min = options.min,
		                max = options.max;
	
		            if (value === null) {
		                that._current = createDate(that._current.getFullYear(), that._current.getMonth(), that._current.getDate());
		            }
	
		            value = parse(value, options.format, options.culture);
	
		            if (value !== null) {
		                value = new DATE(+value);
	
		                if (!isInRange(value, min, max)) {
		                    value = null;
		                }
		            }
	
		            if (value === null || !that.options.disableDates(new Date(+value))) {
		                that._value = value;
		            } else if (that._value === undefined) {
		                that._value = null;
		            }
	
		            return that._value;
		        },
	
		        _visualizeSelectedDatesInView: function() {
		            var that = this;
	
		            var selectedDates = {};
		            $.each(that._selectDates, function(index, value) {
		                selectedDates[kendo.calendar.views[0].toDateString(value)] = value;
		            });
		            that.selectable.clear();
	
		            var cells = that._table
		                .find(CELLSELECTOR)
		                .filter(function(index, element) {
		                    return selectedDates[$(element.firstChild).attr(kendo.attr(VALUE))];
		                });
		            if(cells.length > 0) {
		                that.selectable._selectElement(cells, true);
		            }
		        },
	
		        _isMultipleSelection: function() {
		            var that = this;
		            return that.options.selectable === "multiple";
		        },
	
		        _selectable: function() {
		            var that = this;
		            if(!that._isMultipleSelection()) {
		                return;
		            }
	
		            var selectable = that.options.selectable,
		            selectableOptions = Selectable.parseOptions(selectable);
	
		            if (selectableOptions.multiple) {
		                that.element.attr("aria-multiselectable", "true");
		            }
		            that.selectable = new Selectable(that.wrapper, {
		                aria: true,
		                //excludes the anchor element
		                inputSelectors: "input,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",
		                multiple: selectableOptions.multiple,
		                filter: "table.k-month:eq(0) " + CELLSELECTORVALID,
		                change: proxy(that._onSelect, that),
		                relatedTarget: proxy(that._onRelatedTarget, that)
		            });
		        },
	
		        _onRelatedTarget: function(target) {
		            var that = this;
	
		            if(that.selectable.options.multiple && target.is(CELLSELECTORVALID)) {
		                that._current = that._toDateObject(target.find("a"));
		                that._class(FOCUSED, that._toDateObject(target.find("a")));
		            }
	
		        },
	
		        _onSelect: function(e) {
		            var that = this,
		                eventArgs = e,
		                selectableOptions = Selectable.parseOptions(that.options.selectable);
	
		            if(!selectableOptions.multiple) {
		                if($(eventArgs.event.currentTarget).is("td") && !$(eventArgs.event.currentTarget).hasClass("k-state-selected")) {
		                    $(eventArgs.event.currentTarget).addClass("k-state-selected");
		                }
		                else {
		                    that._click($(eventArgs.event.currentTarget).find("a"));
		                }
		                return;
		            }
	
		            if(eventArgs.event.ctrlKey || eventArgs.event.metaKey) {
		                if($(eventArgs.event.currentTarget).is(CELLSELECTORVALID)) {
		                    that._toggleSelection($(eventArgs.event.currentTarget));
		                }
		                else {
		                    that._cellsBySelector(CELLSELECTORVALID).each(function(index, element){
		                        var value = that._toDateObject($(element).find("a"));
		                        that._deselect(value);
		                    });
		                    that._addSelectedCellsToArray();
		                }
		            }
		            else if (eventArgs.event.shiftKey) {
		                that._rangeSelection(that._cell);
		            }
		            else if($(eventArgs.event.currentTarget).is(CELLSELECTOR)) {
		                that.value(that._toDateObject($(eventArgs.event.currentTarget).find("a")));
		            }
		            else {
		                that._selectDates = [];
		                that._addSelectedCellsToArray();
		            }
		             that.trigger(CHANGE);
		        },
	
		        _destroySelectable: function() {
		            var that = this;
	
		            if (that.selectable) {
		                that.selectable.destroy();
		                that.selectable = null;
		            }
		        },
	
		        //when ctrl key is clicked
		        _toggleSelection: function(currentCell) {
		            var that = this,
		                date = that._toDateObject(currentCell.find("a"));
		                if(currentCell.hasClass("k-state-selected")) {
		                    that._selectDates.push(date);
		                }
		                else {
		                    that._deselect(date);
		                }
		        },
	
		        //shift selection
		        _rangeSelection: function(toDateCell, startDate) {
		            var that = this,
		                fromDate  = startDate || that._toDateObject(that.selectable.value().first().find("a")),
		                toDate = that._toDateObject(toDateCell.find("a")),
		                daysDifference;
	
		            if(that.selectable._lastActive || that._value) {
		                fromDate = that.selectable._lastActive? that._toDateObject(that.selectable._lastActive.find("a")): new Date(+that._value);
		            } else {
		                that.selectable._lastActive = startDate? that._cellByDate(that._view.toDateString(startDate), CELLSELECTORVALID): that.selectable.value().first();
		            }
	
		            that._selectDates = [];
		            daysDifference = daysBetweenTwoDates(fromDate, toDate);
		            addDaysToArray(that._selectDates, daysDifference, fromDate, that.options.disableDates);
	
		            that._visualizeSelectedDatesInView();
		        },
	
		        _cellsBySelector: function(selector) {
		            var that = this;
		            return that._table.find(selector);
		        },
	
		        _addSelectedCellsToArray: function() {
		            var that = this;
		            that.selectable.value().each(function(index, item) {
		                var date = that._toDateObject($(item.firstChild));
		                if(!that.options.disableDates(date)) {
		                    that._selectDates.push(date);
		                }
		            });
		        },
	
		        _deselect: function(date) {
		            var that = this;
	
		            var currentDateIndex = that._selectDates.map(Number).indexOf(+date);
		            if(currentDateIndex != -1) {
		                that._selectDates.splice(currentDateIndex, 1);
		            }
		        },
	
		        _dateInView: function(date) {
		            var that = this,
		                firstDateInView = that._toDateObject(that._cellsBySelector(CELLSELECTOR + ":first").find("a")),
		                lastDateInView = that._toDateObject(that._cellsBySelector(CELLSELECTOR + ":last").find("a"));
	
		            return +date <= +lastDateInView && +date >= +firstDateInView;
		        },
	
	
	
		        _move: function(e) {
		            var that = this,
		                options = that.options,
		                key = e.keyCode,
		                view = that._view,
		                index = that._index,
		                min = that.options.min,
		                max = that.options.max,
		                currentValue = new DATE(+that._current),
		                isRtl = kendo.support.isRtl(that.wrapper),
		                isDisabled = that.options.disableDates,
		                value, prevent, method, temp;
	
		            if (e.target === that._table[0]) {
		                that._active = true;
		            }
	
		            if (key == keys.RIGHT && !isRtl || key == keys.LEFT && isRtl) {
		                value = 1;
		                prevent = true;
		            } else if (key == keys.LEFT && !isRtl || key == keys.RIGHT && isRtl) {
		                value = -1;
		                prevent = true;
		            } else if (key == keys.UP) {
		                value = index === 0 ? -7 : -4;
		                prevent = true;
		            } else if (key == keys.DOWN) {
		                value = index === 0 ? 7 : 4;
		                prevent = true;
		            }
		            else if(key == keys.SPACEBAR) {
		                value = 0;
		                prevent = true;
		            }
		            else if (key == keys.HOME || key == keys.END) {
		                method = key == keys.HOME ? "first" : "last";
		                temp = view[method](currentValue);
		                currentValue = new DATE(temp.getFullYear(), temp.getMonth(), temp.getDate(), currentValue.getHours(), currentValue.getMinutes(), currentValue.getSeconds(), currentValue.getMilliseconds());
		                currentValue.setFullYear(temp.getFullYear());
		                prevent = true;
		            }
	
		            if (e.ctrlKey || e.metaKey) {
		                if (key == keys.RIGHT && !isRtl || key == keys.LEFT && isRtl) {
		                    that.navigateToFuture();
		                    prevent = true;
		                } else if (key == keys.LEFT && !isRtl || key == keys.RIGHT && isRtl) {
		                    that.navigateToPast();
		                    prevent = true;
		                } else if (key == keys.UP) {
		                    that.navigateUp();
		                    prevent = true;
		                } else if (key == keys.DOWN) {
		                    that._click($(that._cell[0].firstChild));
		                    prevent = true;
		                }
		                  else if ((key == keys.ENTER || key == keys.SPACEBAR) && that._isMultipleSelection()) {
		                    that._keyboardToggleSelection(e);
	
		                    var focusedDate = that._toDateObject($(that._cell[0]).find("a"));
		                    that._class(FOCUSED, focusedDate);
	
		                }
		            } else if(e.shiftKey) {
		                if (value !== undefined || method) {
		                    if (!method) {
		                        view.setDate(currentValue, value);
		                    }
	
		                    if (!isInRange(currentValue, min, max)) {
		                        currentValue = restrictValue(currentValue, options.min, options.max);
		                    }
	
		                    if (isDisabled(currentValue)) {
		                        currentValue = that._nextNavigatable(currentValue, value);
		                    }
	
		                    min = createDate(min.getFullYear(), min.getMonth(), min.getDate());
		                    if(that._isMultipleSelection()) {
		                        that._keyboardRangeSelection(e, currentValue);
		                    }
		                    else {
		                        that._focus(currentValue);
		                    }
		                }
		            } else {
		                if (key == keys.ENTER || key == keys.SPACEBAR) {
		                    if(view.name == "month" && that._isMultipleSelection()) {
		                        that.value(that._toDateObject($(that._cell.find("a"))));
		                        that.selectable._lastActive = $(that._cell[0]);
		                        that.trigger(CHANGE);
		                    }
		                    else {
		                        that._click($(that._cell[0].firstChild));
		                    }
		                    prevent = true;
		                } else if (key == keys.PAGEUP) {
		                    prevent = true;
		                    that.navigateToPast();
		                } else if (key == keys.PAGEDOWN) {
		                    prevent = true;
		                    that.navigateToFuture();
		                }
	
		                if (value || method) {
		                    if (!method) {
		                        view.setDate(currentValue, value);
		                    }
	
		                    min = createDate(min.getFullYear(), min.getMonth(), min.getDate());
	
		                    if (!isInRange(currentValue, min, max)) {
		                        currentValue = restrictValue(currentValue, options.min, options.max);
		                    }
	
		                    if (isDisabled(currentValue)) {
		                        currentValue = that._nextNavigatable(currentValue, value);
		                    }
	
		                    if(that._isMultipleSelection()) {
		                        if(!that._dateInView(currentValue)) {
		                            that.navigate(currentValue);
		                        }
		                        else {
		                            that._current = currentValue;
		                            that._class(FOCUSED, currentValue);
		                        }
		                    }
		                    else {
		                        that._focus(currentValue);
		                    }
		                }
		            }
	
		            if (prevent) {
		                e.preventDefault();
		            }
	
		            return that._current;
		        },
	
		        _keyboardRangeSelection: function(event, currentValue) {
		            var that = this,
		                fromDate,
		                daysDifference;
	
		            if(!that._dateInView(currentValue)) {
		                that._selectDates = [];
	
		                fromDate = that.selectable._lastActive? that._toDateObject(that.selectable._lastActive.find("a")): currentValue;
		                daysDifference = daysBetweenTwoDates(fromDate, new Date(+currentValue));
	
		                addDaysToArray(that._selectDates, daysDifference, fromDate, that.options.disableDates);
	
		                that.navigate(currentValue);
		                that._current = currentValue;
		                that.selectable._lastActive = that.selectable._lastActive || that._cellByDate(that._view.toDateString(currentValue), CELLSELECTORVALID);
		                that.trigger(CHANGE);
		                return;
		            }
		            that.selectable.options.filter = that.wrapper.find("table").length > 1 && +currentValue > +that._current? "table.k-month:eq(1) " + CELLSELECTORVALID: "table.k-month:eq(0) " + CELLSELECTORVALID;
		            that._class(FOCUSED, currentValue);
		            that._current = currentValue;
	
		            that._rangeSelection(that._cellByDate(that._view.toDateString(currentValue), CELLSELECTORVALID), currentValue);
	
		            that.trigger(CHANGE);
	
		            that.selectable.options.filter = "table.k-month:eq(0) " + CELLSELECTORVALID;
		        },
	
		        _keyboardToggleSelection: function(event) {
		            var that = this;
	
		            event.currentTarget = that._cell[0];
		            that.selectable._lastActive = $(that._cell[0]);
	
		            if ($(that._cell[0]).hasClass(SELECTED)) {
		                that.selectable._unselect($(that._cell[0]));
		                that.selectable.trigger(CHANGE, { event: event});
		            }
		            else {
		                that.selectable.value($(that._cell[0]), { event: event});
		            }
		        },
	
		        _nextNavigatable: function(currentValue, value) {
		            var that = this,
		            disabled = true,
		            view = that._view,
		            min = that.options.min,
		            max = that.options.max,
		            isDisabled = that.options.disableDates,
		            navigatableDate = new Date(currentValue.getTime());
	
		            view.setDate(navigatableDate, -value);
	
		            while (disabled) {
		                view.setDate(currentValue, value);
	
		                if (!isInRange(currentValue, min, max)) {
		                    currentValue = navigatableDate;
		                    break;
		                }
		                disabled = isDisabled(currentValue);
		            }
		            return currentValue;
		        },
	
		        _animate: function(options) {
		            var that = this,
		            from = options.from,
		            to = options.to,
		            active = that._active;
	
		            if (!from) {
		                to.insertAfter(that.element[0].firstChild);
		                that._bindTable(to);
		            } else if (from.parent().data("animating")) {
		                from.off(ns);
		                from.parent().kendoStop(true, true).remove();
		                from.remove();
	
		                to.insertAfter(that.element[0].firstChild);
		                that._focusView(active);
		            } else if (!from.is(":visible") || that.options.animation === false || options.replace) {
		                to.insertAfter(from);
		                from.off(ns).remove();
	
		                that._focusView(active);
		            } else {
		                that[options.vertical ? "_vertical" : "_horizontal"](from, to, options.future);
		            }
		        },
	
		        _horizontal: function(from, to, future) {
		            var that = this,
		                active = that._active,
		                horizontal = that.options.animation.horizontal,
		                effects = horizontal.effects,
		                viewWidth = outerWidth(from);
	
		            if (effects && effects.indexOf(SLIDE) != -1) {
		                from.add(to).css({ width: viewWidth });
	
		                from.wrap("<div/>");
	
		                that._focusView(active, from);
	
		                from.parent()
		                .css({
		                    position: "relative",
		                    width: viewWidth * 2,
		                    "float": LEFT,
		                    "margin-left": future ? 0 : -viewWidth
		                });
	
		                to[future ? "insertAfter" : "insertBefore"](from);
	
		                extend(horizontal, {
		                    effects: SLIDE + ":" + (future ? "right" : LEFT),
		                    complete: function() {
		                        from.off(ns).remove();
		                        that._oldTable = null;
	
		                        to.unwrap();
	
		                        that._focusView(active);
	
		                    }
		                });
	
		                from.parent().kendoStop(true, true).kendoAnimate(horizontal);
		            }
		        },
	
		        _vertical: function(from, to) {
		            var that = this,
		                vertical = that.options.animation.vertical,
		                effects = vertical.effects,
		                active = that._active, //active state before from's blur
		                cell, position;
	
		            if (effects && effects.indexOf("zoom") != -1) {
		                to.css({
		                    position: "absolute",
		                    top: outerHeight(from.prev()),
		                    left: 0
		                }).insertBefore(from);
	
		                if (transitionOrigin) {
		                    cell = that._cellByDate(that._view.toDateString(that._current));
		                    position = cell.position();
		                    position = (position.left + parseInt(cell.width() / 2, 10)) + "px" + " " + (position.top + parseInt(cell.height() / 2, 10) + "px");
		                    to.css(transitionOrigin, position);
		                }
	
		                from.kendoStop(true, true).kendoAnimate({
		                    effects: "fadeOut",
		                    duration: 600,
		                    complete: function() {
		                        from.off(ns).remove();
		                        that._oldTable = null;
	
		                        to.css({
		                            position: "static",
		                            top: 0,
		                            left: 0
		                        });
	
		                        that._focusView(active);
		                    }
		                });
	
		                to.kendoStop(true, true).kendoAnimate(vertical);
		            }
		        },
	
		        _cellByDate: function(value, selector) {
		            return this._table.find(selector ? selector : "td:not(." + OTHERMONTH + ")")
		            .filter(function() {
		                return $(this.firstChild).attr(kendo.attr(VALUE)) === value;
		            });
		        },
	
		        _class: function(className, date) {
		            var that = this,
		                id = that._cellID,
		                cell = that._cell,
		                value = that._view.toDateString(date),
		                disabledDate;
	
		            if (cell) {
		                cell.removeAttr(ARIA_SELECTED)
		                .removeAttr(ARIA_LABEL)
		                .removeAttr(ID);
		                //.removeClass(className);
		            }
	
		            if (date && that._view.name == "month") {
		                disabledDate = that.options.disableDates(date);
		            }
		            that._cellsBySelector(that._isMultipleSelection() ? CELLSELECTOR: "td:not(." + OTHERMONTH + ")").removeClass(className);
		            cell = that._cellByDate(value, that.options.selectable == "multiple" ? CELLSELECTOR: "td:not(." + OTHERMONTH + ")")
		            .attr(ARIA_SELECTED, true);
	
		            if (className === FOCUSED && !that._active && that.options.focusOnNav !== false || disabledDate) {
		                className = "";
		            }
	
		            cell.addClass(className);
	
		            if (cell[0]) {
		                that._cell = cell;
		            }
	
		            if (id) {
		                cell.attr(ID, id);
		                that._table.removeAttr("aria-activedescendant").attr("aria-activedescendant", id);
		            }
		        },
	
		        _bindTable: function (table) {
		            table
		            .on(FOCUS_WITH_NS, this._addClassProxy)
		            .on(BLUR, this._removeClassProxy);
		        },
	
		        _click: function(link) {
		            var that = this,
		            options = that.options,
		            currentValue = new Date(+that._current),
		            value = that._toDateObject(link);
	
		            adjustDST(value, 0);
	
		            if (that._view.name == "month" && that.options.disableDates(value)) {
		                value = that._value;
		            }
	
		            that._view.setDate(currentValue, value);
	
		            that.navigateDown(restrictValue(currentValue, options.min, options.max));
		        },
	
		        _focus: function(value) {
		            var that = this,
		            view = that._view;
	
		            if (view.compare(value, that._current) !== 0) {
		                that.navigate(value);
		            } else {
		                that._current = value;
		                that._class(FOCUSED, value);
		            }
		        },
	
		        _focusView: function(active, table) {
		            if (active) {
		                this.focus(table);
		            }
		        },
	
		        _footer: function(template) {
		            var that = this,
		            today = getToday(),
		            element = that.element,
		            footer = element.find(".k-footer");
	
		            if (!template) {
		                that._toggle(false);
		                footer.hide();
		                return;
		            }
	
		            if (!footer[0]) {
		                footer = $('<div class="k-footer"><a href="#" class="k-link k-nav-today"></a></div>').appendTo(element);
		            }
	
		            that._today = footer.show()
		            .find(".k-link")
		            .html(template(today))
		            .attr("title", kendo.toString(today, "D", that.options.culture));
	
		            that._toggle();
		        },
	
		        _header: function() {
		            var that = this,
		            element = that.element,
		            links;
	
		            if (!element.find(".k-header")[0]) {
		                element.html('<div class="k-header">' +
		                    '<a href="#" role="button" class="k-link k-nav-prev" ' + ARIA_LABEL + '="Previous"><span class="k-icon k-i-arrow-60-left"></span></a>' +
		                    '<a href="#" role="button" aria-live="assertive" aria-atomic="true" class="k-link k-nav-fast"></a>' +
		                    '<a href="#" role="button" class="k-link k-nav-next" ' + ARIA_LABEL + '="Next"><span class="k-icon k-i-arrow-60-right"></span></a>' +
		                '</div>');
		            }
	
		            links = element.find(".k-link")
		            .on(MOUSEENTER_WITH_NS + " " + MOUSELEAVE + " " + FOCUS_WITH_NS + " " + BLUR, mousetoggle)
		            .click(false);
	
		            that._title = links.eq(1).on(CLICK, function() { that._active = that.options.focusOnNav !== false; that.navigateUp(); });
		            that[PREVARROW] = links.eq(0).on(CLICK, function() { that._active = that.options.focusOnNav !== false; that.navigateToPast(); });
		            that[NEXTARROW] = links.eq(2).on(CLICK, function() { that._active = that.options.focusOnNav !== false; that.navigateToFuture(); });
		        },
	
		        _navigate: function(arrow, modifier) {
		            var that = this,
		            index = that._index + 1,
		            currentValue = new DATE(+that._current);
	
		            if(that._isMultipleSelection()) {
		                var firstDayCurrentMonth = that._table.find("td:not(.k-other-month)").has(".k-link").first();
		                currentValue = that._toDateObject(firstDayCurrentMonth.find("a"));
		                that._current = new Date(+currentValue);
		            }
	
		            arrow = that[arrow];
	
		            if (!arrow.hasClass(DISABLED)) {
		                if (index > 3) {
		                    currentValue.setFullYear(currentValue.getFullYear() + 100 * modifier);
		                } else {
		                    calendar.views[index].setDate(currentValue, modifier);
		                }
	
		                that.navigate(currentValue);
		            }
		        },
	
		        _option: function(option, value) {
		            var that = this,
		                options = that.options,
		                currentValue = that._value || that._current,
		                isBigger;
	
		            if (value === undefined) {
		                return options[option];
		            }
	
		            value = parse(value, options.format, options.culture);
	
		            if (!value) {
		                return;
		            }
	
		            options[option] = new DATE(+value);
	
		            if (option === MIN) {
		                isBigger = value > currentValue;
		            } else {
		                isBigger = currentValue > value;
		            }
	
		            if (isBigger || isEqualMonth(currentValue, value)) {
		                if (isBigger) {
		                    that._value = null;
		                }
		                that._changeView = true;
		            }
	
		            if (!that._changeView) {
		                that._changeView = !!(options.month.content || options.month.empty);
		            }
	
		            that.navigate(that._value);
	
		            that._toggle();
		        },
	
		        _toggle: function(toggle) {
		            var that = this,
		                options = that.options,
		                isTodayDisabled = that.options.disableDates(getToday()),
		                link = that._today;
	
		            if (toggle === undefined) {
		                toggle = isInRange(getToday(), options.min, options.max);
		            }
	
		            if (link) {
		                link.off(CLICK);
	
		                if (toggle && !isTodayDisabled) {
		                    link.addClass(TODAY)
		                    .removeClass(DISABLED)
		                    .on(CLICK, proxy(that._todayClick, that));
		                } else {
		                    link.removeClass(TODAY)
		                    .addClass(DISABLED)
		                    .on(CLICK, prevent);
		                }
		            }
		        },
	
		        _todayClick: function(e) {
		            var that = this,
		            depth = views[that.options.depth],
		            disabled = that.options.disableDates,
		            today = getToday();
	
		            e.preventDefault();
	
		            if (disabled(today)) {
		                return;
		            }
	
		            if (that._view.compare(that._current, today) === 0 && that._index == depth) {
		                that._changeView = false;
		            }
	
		            if(that._isMultipleSelection()) {
		                that._selectDates = [today];
		                that.selectable._lastActive = null;
		            }
	
		            that._value = today;
		            that.navigate(today, depth);
	
		            that.trigger(CHANGE);
		        },
	
		        _toDateObject: function(link) {
		            var value = $(link).attr(kendo.attr(VALUE)).split("/");
		            //Safari cannot create correctly date from "1/1/2090"
		            value = createDate(value[0], value[1], value[2]);
	
		            return value;
		        },
	
		        _templates: function() {
		            var that = this,
		                options = that.options,
		                footer = options.footer,
		                month = options.month,
		                content = month.content,
		                weekNumber = month.weekNumber,
		                empty = month.empty,
		                footerTemplate = '#= kendo.toString(data,"D","' + options.culture +'") #';
	
		            that.month = {
		                content: template('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link#=data.linkClass#" href="#=data.url#" ' + kendo.attr(VALUE) + '="#=data.dateString#" title="#=data.title#">' + (content || "#=data.value#") + '</a></td>', { useWithBlock: !!content }),
		                empty: template('<td role="gridcell">' + (empty || "&nbsp;") + "</td>", { useWithBlock: !!empty }),
		                weekNumber: template('<td class="k-alt">' + (weekNumber || "#= data.weekNumber #") + "</td>", { useWithBlock: !!weekNumber })
		            };
	
		            if (footer && footer !== true) {
		                footerTemplate = footer;
		            }
	
		            that.footer = footer !== false ? template(footerTemplate, { useWithBlock: false }) : null;
		        }
		    });
	
		    ui.plugin(Calendar);
	
		    var calendar = {
		        firstDayOfMonth: function (date) {
		            return createDate(
		                date.getFullYear(),
		                date.getMonth(),
		                1
		            );
		        },
	
		        firstVisibleDay: function (date, calendarInfo) {
		            calendarInfo = calendarInfo || kendo.culture().calendar;
	
		            var firstDay = calendarInfo.firstDay,
		            firstVisibleDay = new DATE(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
		            firstVisibleDay.setFullYear(date.getFullYear());
	
		            while (firstVisibleDay.getDay() != firstDay) {
		                calendar.setTime(firstVisibleDay, -1 * MS_PER_DAY);
		            }
	
		            return firstVisibleDay;
		        },
	
		        setTime: function (date, time) {
		            var tzOffsetBefore = date.getTimezoneOffset(),
		            resultDATE = new DATE(date.getTime() + time),
		            tzOffsetDiff = resultDATE.getTimezoneOffset() - tzOffsetBefore;
	
		            date.setTime(resultDATE.getTime() + tzOffsetDiff * MS_PER_MINUTE);
		        },
		        views: [{
		            name: MONTH,
		            title: function(date, min, max, culture) {
		                return getCalendarInfo(culture).months.names[date.getMonth()] + " " + date.getFullYear();
		            },
		            content: function(options) {
		                var that = this,
		                idx = 0,
		                min = options.min,
		                max = options.max,
		                date = options.date,
		                dates = options.dates,
		                format = options.format,
		                culture = options.culture,
		                navigateUrl = options.url,
		                isWeekColumnVisible = options.isWeekColumnVisible,
		                hasUrl = navigateUrl && dates[0],
		                currentCalendar = getCalendarInfo(culture),
		                firstDayIdx = currentCalendar.firstDay,
		                days = currentCalendar.days,
		                names = shiftArray(days.names, firstDayIdx),
		                shortNames = shiftArray(days.namesShort, firstDayIdx),
		                start = calendar.firstVisibleDay(date, currentCalendar),
		                firstDayOfMonth = that.first(date),
		                lastDayOfMonth = that.last(date),
		                toDateString = that.toDateString,
		                today = getToday(),
		                html = '<table tabindex="0" role="grid" class="k-content" cellspacing="0" data-start="' + toDateString(start) + '"><thead><tr role="row">';
		                if (isWeekColumnVisible) {
		                    html += '<th scope="col" class="k-alt">' + options.messages.weekColumnHeader + '</th>';
		                }
	
		                for (; idx < 7; idx++) {
		                    html += '<th scope="col" title="' + names[idx] + '">' + shortNames[idx] + '</th>';
		                }
	
		                adjustDST(today, 0);
		                today = +today;
	
		                return view({
		                    cells: 42,
		                    perRow: 7,
		                    html: html += '</tr></thead><tbody><tr role="row">',
		                    start: start,
		                    isWeekColumnVisible: isWeekColumnVisible,
		                    weekNumber: options.weekNumber,
		                    min: createDate(min.getFullYear(), min.getMonth(), min.getDate()),
		                    max: createDate(max.getFullYear(), max.getMonth(), max.getDate()),
		                    content: options.content,
		                    empty: options.empty,
		                    setter: that.setDate,
		                    disableDates: options.disableDates,
		                    build: function(date, idx, disableDates) {
		                        var cssClass = [],
		                        day = date.getDay(),
		                        linkClass = "",
		                        url = "#";
	
		                        if (date < firstDayOfMonth || date > lastDayOfMonth) {
		                            cssClass.push(OTHERMONTH);
		                        }
	
		                        if (disableDates(date)) {
		                            cssClass.push(DISABLED);
		                        }
	
		                        if (+date === today) {
		                            cssClass.push("k-today");
		                        }
	
		                        if (day === 0 || day === 6) {
		                            cssClass.push("k-weekend");
		                        }
	
		                        if (hasUrl && inArray(+date, dates)) {
		                            url = navigateUrl.replace("{0}", kendo.toString(date, format, culture));
		                            linkClass = " k-action-link";
		                        }
	
		                        return {
		                            date: date,
		                            dates: dates,
		                            ns: kendo.ns,
		                            title: kendo.toString(date, "D", culture),
		                            value: date.getDate(),
		                            dateString: toDateString(date),
		                            cssClass: cssClass[0] ? ' class="' + cssClass.join(" ") + '"' : "",
		                            linkClass: linkClass,
		                            url: url
		                        };
		                    },
		                    weekNumberBuild: function(date) {
		                        return {
		                            weekNumber: weekInYear(date, kendo.culture().calendar.firstDay),
		                            currentDate: date
		                        };
		                    }
		                });
		            },
		            first: function(date) {
		                return calendar.firstDayOfMonth(date);
		            },
		            last: function(date) {
		                var last = createDate(date.getFullYear(), date.getMonth() + 1, 0),
		                first = calendar.firstDayOfMonth(date),
		                timeOffset = Math.abs(last.getTimezoneOffset() - first.getTimezoneOffset());
	
		                if (timeOffset) {
		                    last.setHours(first.getHours() + (timeOffset / 60));
		                }
	
		                return last;
		            },
		            compare: function(date1, date2) {
		                var result,
		                month1 = date1.getMonth(),
		                year1 = date1.getFullYear(),
		                month2 = date2.getMonth(),
		                year2 = date2.getFullYear();
	
		                if (year1 > year2) {
		                    result = 1;
		                } else if (year1 < year2) {
		                    result = -1;
		                } else {
		                    result = month1 == month2 ? 0 : month1 > month2 ? 1 : -1;
		                }
	
		                return result;
		            },
		            setDate: function(date, value) {
		                var hours = date.getHours();
		                if (value instanceof DATE) {
		                    date.setFullYear(value.getFullYear(), value.getMonth(), value.getDate());
		                } else {
		                    calendar.setTime(date, value * MS_PER_DAY);
		                }
		                adjustDST(date, hours);
		            },
		            toDateString: function(date) {
		                return date.getFullYear() + "/" + date.getMonth() + "/" + date.getDate();
		            }
		        },
		        {
		            name: "year",
		            title: function(date) {
		                return date.getFullYear();
		            },
		            content: function(options) {
		                var namesAbbr = getCalendarInfo(options.culture).months.namesAbbr,
		                toDateString = this.toDateString,
		                min = options.min,
		                max = options.max;
	
		                return view({
		                    min: createDate(min.getFullYear(), min.getMonth(), 1),
		                    max: createDate(max.getFullYear(), max.getMonth(), 1),
		                    start: createDate(options.date.getFullYear(), 0, 1),
		                    setter: this.setDate,
		                    build: function(date) {
		                        return {
		                            value: namesAbbr[date.getMonth()],
		                            ns: kendo.ns,
		                            dateString: toDateString(date),
		                            cssClass: ""
		                        };
		                    }
		                });
		            },
		            first: function(date) {
		                return createDate(date.getFullYear(), 0, date.getDate());
		            },
		            last: function(date) {
		                return createDate(date.getFullYear(), 11, date.getDate());
		            },
		            compare: function(date1, date2){
		                return compare(date1, date2);
		            },
		            setDate: function(date, value) {
		                var month,
		                hours = date.getHours();
	
		                if (value instanceof DATE) {
		                    month = value.getMonth();
	
		                    date.setFullYear(value.getFullYear(), month, date.getDate());
	
		                    if (month !== date.getMonth()) {
		                        date.setDate(0);
		                    }
		                } else {
		                    month = date.getMonth() + value;
	
		                    date.setMonth(month);
	
		                    if (month > 11) {
		                        month -= 12;
		                    }
	
		                    if (month > 0 && date.getMonth() != month) {
		                        date.setDate(0);
		                    }
		                }
	
		                adjustDST(date, hours);
		            },
		            toDateString: function(date) {
		                return date.getFullYear() + "/" + date.getMonth() + "/1";
		            }
		        },
		        {
		            name: "decade",
		            title: function(date, min, max) {
		                return title(date, min, max, 10);
		            },
		            content: function(options) {
		                var year = options.date.getFullYear(),
		                toDateString = this.toDateString;
	
		                return view({
		                    start: createDate(year - year % 10 - 1, 0, 1),
		                    min: createDate(options.min.getFullYear(), 0, 1),
		                    max: createDate(options.max.getFullYear(), 0, 1),
		                    setter: this.setDate,
		                    build: function(date, idx) {
		                        return {
		                            value: date.getFullYear(),
		                            ns: kendo.ns,
		                            dateString: toDateString(date),
		                            cssClass: idx === 0 || idx == 11 ? OTHERMONTHCLASS : ""
		                        };
		                    }
		                });
		            },
		            first: function(date) {
		                var year = date.getFullYear();
		                return createDate(year - year % 10, date.getMonth(), date.getDate());
		            },
		            last: function(date) {
		                var year = date.getFullYear();
		                return createDate(year - year % 10 + 9, date.getMonth(), date.getDate());
		            },
		            compare: function(date1, date2) {
		                return compare(date1, date2, 10);
		            },
		            setDate: function(date, value) {
		                setDate(date, value, 1);
		            },
		            toDateString: function(date) {
		                return date.getFullYear() + "/0/1";
		            }
		        },
		        {
		            name: CENTURY,
		            title: function(date, min, max) {
		                return title(date, min, max, 100);
		            },
		            content: function(options) {
		                var year = options.date.getFullYear(),
		                min = options.min.getFullYear(),
		                max = options.max.getFullYear(),
		                toDateString = this.toDateString,
		                minYear = min,
		                maxYear = max;
	
		                minYear = minYear - minYear % 10;
		                maxYear = maxYear - maxYear % 10;
	
		                if (maxYear - minYear < 10) {
		                    maxYear = minYear + 9;
		                }
	
		                return view({
		                    start: createDate(year - year % 100 - 10, 0, 1),
		                    min: createDate(minYear, 0, 1),
		                    max: createDate(maxYear, 0, 1),
		                    setter: this.setDate,
		                    build: function(date, idx) {
		                        var start = date.getFullYear(),
		                        end = start + 9;
	
		                        if (start < min) {
		                            start = min;
		                        }
	
		                        if (end > max) {
		                            end = max;
		                        }
	
		                        return {
		                            ns: kendo.ns,
		                            value: start + " - " + end,
		                            dateString: toDateString(date),
		                            cssClass: idx === 0 || idx == 11 ? OTHERMONTHCLASS : ""
		                        };
		                    }
		                });
		            },
		            first: function(date) {
		                var year = date.getFullYear();
		                return createDate(year - year % 100, date.getMonth(), date.getDate());
		            },
		            last: function(date) {
		                var year = date.getFullYear();
		                return createDate(year - year % 100 + 99, date.getMonth(), date.getDate());
		            },
		            compare: function(date1, date2) {
		                return compare(date1, date2, 100);
		            },
		            setDate: function(date, value) {
		                setDate(date, value, 10);
		            },
		            toDateString: function(date) {
		                var year = date.getFullYear();
		                return (year - year % 10) + "/0/1";
		            }
		        }]
		    };
	
		    function title(date, min, max, modular) {
		        var start = date.getFullYear(),
		            minYear = min.getFullYear(),
		            maxYear = max.getFullYear(),
		            end;
	
		        start = start - start % modular;
		        end = start + (modular - 1);
	
		        if (start < minYear) {
		            start = minYear;
		        }
		        if (end > maxYear) {
		            end = maxYear;
		        }
	
		        return start + "-" + end;
		    }
	
		    function view(options) {
		        var idx = 0,
		            data,
		            min = options.min,
		            max = options.max,
		            start = options.start,
		            setter = options.setter,
		            build = options.build,
		            weekNumberBuild = options.weekNumberBuild,
		            length = options.cells || 12,
		            isWeekColumnVisible = options.isWeekColumnVisible,
		            cellsPerRow = options.perRow || 4,
		            weekNumber = options.weekNumber || weekNumberTemplate,
		            content = options.content || cellTemplate,
		            empty = options.empty || emptyCellTemplate,
		            html = options.html || '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><tbody><tr role="row">';
		            if(isWeekColumnVisible) {
		                html += weekNumber(weekNumberBuild(start));
		            }
	
	
		        for(; idx < length; idx++) {
		            if (idx > 0 && idx % cellsPerRow === 0) {
		                html += '</tr><tr role="row">';
		                if(isWeekColumnVisible) {
		                    html += weekNumber(weekNumberBuild(start));
		                }
		            }
	
		            start = createDate(start.getFullYear(), start.getMonth(), start.getDate());
		            adjustDST(start, 0);
	
		            data = build(start, idx, options.disableDates);
	
		            html += isInRange(start, min, max) ? content(data) : empty(data);
	
		            setter(start, 1);
		        }
	
		        return html + "</tr></tbody></table>";
		    }
	
		    function compare(date1, date2, modifier) {
		        var year1 = date1.getFullYear(),
		            start  = date2.getFullYear(),
		            end = start,
		            result = 0;
	
		        if (modifier) {
		            start = start - start % modifier;
		            end = start - start % modifier + modifier - 1;
		        }
	
		        if (year1 > end) {
		            result = 1;
		        } else if (year1 < start) {
		            result = -1;
		        }
	
		        return result;
		    }
	
		    function getToday() {
		        var today = new DATE();
		        return new DATE(today.getFullYear(), today.getMonth(), today.getDate());
		    }
	
		    function restrictValue (value, min, max) {
		        var today = getToday();
	
		        if (value) {
		            today = new DATE(+value);
		        }
	
		        if (min > today) {
		            today = new DATE(+min);
		        } else if (max < today) {
		            today = new DATE(+max);
		        }
		        return today;
		    }
	
		    function isInRange(date, min, max) {
		        return +date >= +min && +date <= +max;
		    }
	
		    function shiftArray(array, idx) {
		        return array.slice(idx).concat(array.slice(0, idx));
		    }
	
		    function setDate(date, value, multiplier) {
		        value = value instanceof DATE ? value.getFullYear() : date.getFullYear() + multiplier * value;
		        date.setFullYear(value);
		    }
	
		    function daysBetweenTwoDates(startDate, endDate) {
		        if(+endDate < +startDate) {
		            var temp = +startDate;
		            calendar.views[0].setDate(startDate, endDate);
		            calendar.views[0].setDate(endDate, new Date(temp));
		        }
		        var fromDateUTC = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
		        var endDateUTC = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
	
		        return Math.ceil((+endDateUTC - +fromDateUTC) / kendo.date.MS_PER_DAY);
		    }
	
		    function addDaysToArray(array, numberOfDays, fromDate, disableDates) {
		        for(var i = 0; i <= numberOfDays; i++) {
		            var nextDay = new Date(fromDate.getTime());
		            nextDay = new Date(nextDay.setDate(nextDay.getDate() + i));
		            if(!disableDates(nextDay)) {
		                array.push(nextDay);
		            }
		        }
		    }
	
		    function mousetoggle(e) {
		        var disabled = $(this).hasClass("k-state-disabled");
	
		        if (!disabled) {
		            $(this).toggleClass(HOVER, MOUSEENTER.indexOf(e.type) > -1 || e.type == FOCUS);
		        }
		    }
	
		    function prevent (e) {
		        e.preventDefault();
		    }
	
		    // creates date with full year
		    function createDate(year, month, date) {
		        var dateObject = new DATE(year, month, date);
		        dateObject.setFullYear(year, month, date);
		        return dateObject;
		    }
	
		    function getCalendarInfo(culture) {
		        return getCulture(culture).calendars.standard;
		    }
	
		    function normalize(options) {
		        var start = views[options.start],
		            depth = views[options.depth],
		            culture = getCulture(options.culture);
	
		        options.format = extractFormat(options.format || culture.calendars.standard.patterns.d);
	
		        if (isNaN(start)) {
		            start = 0;
		            options.start = MONTH;
		        }
	
		        if (depth === undefined || depth > start) {
		            options.depth = MONTH;
		        }
	
		        if (options.dates === null) {
		            options.dates = [];
		        }
		    }
	
		    function makeUnselectable(element) {
		        if (isIE8) {
		            element.find("*").attr("unselectable", "on");
		        }
		    }
	
		    function addClassToViewContainer(element, currentView) {
		        element.addClass("k-" + currentView);
		    }
	
		    function inArray(date, dates) {
		        for(var i = 0, length = dates.length; i < length; i++) {
		            if (date === +dates[i]) {
		                return true;
		            }
		        }
		        return false;
		    }
	
		    function isEqualDatePart(value1, value2) {
		        if (value1) {
		            return value1.getFullYear() === value2.getFullYear() &&
		                value1.getMonth() === value2.getMonth() &&
		                value1.getDate() === value2.getDate();
		        }
	
		        return false;
		    }
	
		    function isEqualMonth(value1, value2) {
		        if (value1) {
		            return value1.getFullYear() === value2.getFullYear() &&
		                value1.getMonth() === value2.getMonth();
		        }
	
		        return false;
		    }
	
	
		    function getDisabledExpr(option) {
		        if (kendo.isFunction(option)) {
		            return option;
		        }
	
		        if ($.isArray(option)) {
		            return createDisabledExpr(option);
		        }
		        return $.noop;
		    }
	
		    function convertDatesArray(dates) {
		        var result = [];
		        for (var i = 0; i < dates.length; i++) {
		            result.push(dates[i].setHours(0, 0, 0, 0));
		        }
		        return result;
		    }
	
		    function createDisabledExpr(dates) {
		        var body, callback,
		            disabledDates = [],
		            days = ["su", "mo", "tu", "we", "th", "fr", "sa"],
		            searchExpression = "if (found) {"+
		                    " return true " +
		                "} else {" +
		                    "return false" +
		                "}";
	
		        if (dates[0] instanceof DATE) {
		            disabledDates = convertDatesArray(dates);
		            body = "var found = date && window.kendo.jQuery.inArray(date.setHours(0, 0, 0, 0),["+ disabledDates +"]) > -1;" + searchExpression;
		        } else {
		            for (var i = 0; i < dates.length; i++) {
		                var day = dates[i].slice(0,2).toLowerCase();
		                var index = $.inArray(day, days);
		                if (index > -1) {
		                    disabledDates.push(index);
		                }
		            }
		            body = "var found = date && window.kendo.jQuery.inArray(date.getDay(),["+ disabledDates +"]) > -1;" + searchExpression;
		        }
	
		        callback = new Function("date", body); //jshint ignore:line
	
		        return callback;
		    }
	
		    function isEqualDate(oldValue, newValue) {
		       if (oldValue instanceof Date && newValue instanceof Date) {
		           oldValue = oldValue.getTime();
		           newValue = newValue.getTime();
		       }
	
		       return oldValue === newValue;
		    }
	
		    calendar.isEqualDatePart = isEqualDatePart;
		    calendar.isEqualDate = isEqualDate;
		    calendar.makeUnselectable =  makeUnselectable;
		    calendar.restrictValue = restrictValue;
		    calendar.isInRange = isInRange;
		    calendar.addClassToViewContainer = addClassToViewContainer;
		    calendar.normalize = normalize;
		    calendar.viewsEnum = views;
		    calendar.disabled = getDisabledExpr;
	
		    kendo.calendar = calendar;
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1028:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(578);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1114);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1114:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dateinput",
		    name: "DateInput",
		    category: "web",
		    description: "The DateInput widget allows to edit date by typing.",
		    depends: [ "core" ]
		};
	
		(function ($, undefined) {
		    var global = window;
		    var kendo = global.kendo;
		    var caret = kendo.caret;
		    var ui = kendo.ui;
		    var Widget = ui.Widget;
		    var keys = kendo.keys;
		    var ns = ".kendoDateInput";
		    var proxy = $.proxy;
		    var objectToString = {}.toString;
	
		    var INPUT_EVENT_NAME = (kendo.support.propertyChangeEvent ? "propertychange.kendoDateInput input" : "input") + ns;
	
		    var STATEDISABLED = "k-state-disabled";
		    var STATEDEFAULT = "k-state-default";
		    // var STATEFOCUSED = "k-state-focused";
		    // var STATEHOVER = "k-state-hover";
		    var STATEINVALID = "k-state-invalid";
	
		    var DISABLED = "disabled";
		    var READONLY = "readonly";
		    var CHANGE = "change";
	
		    var knownSymbols = "dMyHhmftsz";
	
		    var DateInput = Widget.extend({
		        init: function (element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
		            element = that.element;
	
		            options = that.options;
		            options.format = kendo._extractFormat(options.format || kendo.getCulture(options.culture).calendars.standard.patterns.d);
		            options.min = kendo.parseDate(element.attr("min")) || kendo.parseDate(options.min);
		            options.max = kendo.parseDate(element.attr("max")) || kendo.parseDate(options.max);
	
		            var insidePicker = ((element.parent().attr("class") || "").indexOf("k-picker-wrap") >= 0);
		            if (insidePicker) {
		                that.wrapper = element.parent();
		            } else {
		                that.wrapper = element.wrap("<span class='k-widget k-dateinput'></span>").parent();
		                that.wrapper.addClass(element[0].className);
		                that.wrapper[0].style.cssText = element[0].style.cssText;
		                element.css({
		                    width: "100%",
		                    height: element[0].style.height
		                });
		            }
		            $("<span class='k-icon k-i-warning'></span>").insertAfter(element);
	
		            that._form();
	
		            that.element
		                .addClass(insidePicker ? " " : "k-textbox")
		                .attr("autocomplete", "off")
		                .on("focusout" + ns, function () {
		                    that._change();
		                });
	
		            try {
		                element[0].setAttribute("type", "text");
		            } catch (e) {
		                element[0].type = "text";
		            }
	
		            var disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
	
		            if (disabled) {
		                that.enable(false);
		            } else {
		                that.readonly(element.is("[readonly]"));
		            }
	
		            that.value(that.options.value || element.val());
	
		            kendo.notify(that);
		        },
	
		        options: {
		            name: "DateInput",
		            culture: "",
		            value: "",
		            format: "",
		            min: new Date(1900, 0, 1),
		            max: new Date(2099, 11, 31),
		            messages: {
		                "year": "year",
		                "month": "month",
		                "day": "day",
		                "weekday": "day of the week",
		                "hour": "hours",
		                "minute": "minutes",
		                "second": "seconds",
		                "dayperiod": "AM/PM"
		            }
		        },
	
		        events: [
		            CHANGE
		        ],
	
		        min: function (value) {
		            if (value !== undefined) {
		                this.options.min = value;
		            } else {
		                return this.options.min;
		            }
		        },
	
		        max: function (value) {
		            if (value !== undefined) {
		                this.options.max = value;
		            } else {
		                return this.options.max;
		            }
		        },
	
		        setOptions: function (options) {
		            var that = this;
		            Widget.fn.setOptions.call(that, options);
		            this._unbindInput();
		            this._bindInput();
		            this._updateElementValue();
		        },
	
		        destroy: function () {
		            var that = this;
		            that.element.off(ns);
	
		            if (that._formElement) {
		                that._formElement.off("reset", that._resetHandler);
		            }
	
		            Widget.fn.destroy.call(that);
		        },
	
		        value: function (value) {
		            if (value === undefined) {
		                return this._dateTime.getDateObject();
		            }
	
		            if (value === null) {
		                value = "";
		            }
	
		            if (objectToString.call(value) !== "[object Date]") {
		                value = kendo.parseDate(value, this.options.format, this.options.culture);
		            }
	
		            if (value && !value.getTime()) {
		                value = null;
		            }
	
		            this._dateTime = new customDateTime(value, this.options.format, this.options.culture, this.options.messages);
	
		            this._updateElementValue();
		            this._oldValue = value;
		        },
	
		        _updateElementValue: function () {
		            var stringAndFromat = this._dateTime.toPair(this.options.format, this.options.culture, this.options.messages);
		            this.element.val(stringAndFromat[0]);
		            this._oldText = stringAndFromat[0];
		            this._format = stringAndFromat[1];
		        },
	
		        readonly: function (readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		        },
	
		        enable: function (enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		        },
	
		        _bindInput: function () {
		            var that = this;
		            that.element
		                .on("paste" + ns, proxy(that._paste, that))
		                .on("keydown" + ns, proxy(that._keydown, that))
		                .on(INPUT_EVENT_NAME, proxy(that._input, that))
		                .on("mouseup" + ns, proxy(that._mouseUp, that))
		                .on("DOMMouseScroll" + ns + " mousewheel" + ns, proxy(that._scroll, that));
		        },
	
		        _unbindInput: function () {
		            this.element
		                .off("keydown" + ns)
		                .off("paste" + ns)
		                .off(INPUT_EVENT_NAME)
		                .off("mouseup" + ns)
		                .off("DOMMouseScroll" + ns + " mousewheel" + ns);
		        },
	
		        _editable: function (options) {
		            var that = this;
		            var element = that.element;
		            var disable = options.disable;
		            var readonly = options.readonly;
		            var wrapper = that.wrapper;
	
		            that._unbindInput();
	
		            if (!readonly && !disable) {
		                wrapper.addClass(STATEDEFAULT)
		                    .removeClass(STATEDISABLED);
	
		                element.removeAttr(DISABLED)
		                    .removeAttr(READONLY);
	
		                that._bindInput();
		            } else {
		                if (disable) {
		                    wrapper.addClass(STATEDISABLED)
		                    .removeClass(STATEDEFAULT);
		                    element.attr(DISABLED, disable);
		                    element.removeAttr(READONLY);
		                }
		                if (readonly) {
		                    element.attr(READONLY, readonly);
		                }
		            }
		        },
	
		        _change: function () {
		            var that = this;
		            var oldValue = that._oldValue;
		            var value = that.value();
	
		            if (value && that.min() && value < that.min()) {
		                that.value(that.min());
		                value = that.value();
		            }
		            if (value && that.max() && value > that.max()) {
		                that.value(that.max());
		                value = that.value();
		            }
	
		            if (oldValue && value && value.getTime() !== oldValue.getTime() ||
		                oldValue && !value ||
		                !oldValue && value
		            ) {
		                that._oldValue = value;
		                that.trigger(CHANGE);
		                that.element.trigger(CHANGE);
		            }
		        },
	
		        _input: function () {
		            var that = this;
		            var element = that.element[0];
		            var blinkInvalid = false;
	
		            if (kendo._activeElement() !== element) {
		                return;
		            }
	
		            var diff = approximateStringMatching(
		                this._oldText,
		                this._format,
		                this.element[0].value,
		                caret(this.element[0])[0]);
	
		            var navigationOnly = (diff.length === 1 && diff[0][1] === " ");
		            if (!navigationOnly) {
		                for (var i = 0; i < diff.length; i++) {
		                    var valid = this._dateTime.parsePart(diff[i][0], diff[i][1]);
		                    blinkInvalid = blinkInvalid || !valid;
		                }
		            }
		            this._updateElementValue();
	
		            if (diff.length && diff[0][0] !== " ") {
		                this._selectSegment(diff[0][0]);
	
		                //android fix
		                if (!navigationOnly) {
		                    var difSym = diff[0][0];
		                    setTimeout(function () { that._selectSegment(difSym); });
		                }
		            }
		            if (navigationOnly) {
		                var newEvent = { keyCode: 39, preventDefault: function () { } };
		                this._keydown(newEvent);
		            }
		            if (blinkInvalid) {
		                clearTimeout(that._blinkInvalidTimeout);
		                var stateInvalid = STATEINVALID;
		                that.wrapper.addClass(STATEINVALID);
		                that._blinkInvalidTimeout = setTimeout(function () { that.wrapper.removeClass(stateInvalid); }, 100);
		            }
		        },
	
		        _mouseUp: function () {
		            var selection = caret(this.element[0]);
		            if (selection[0] === selection[1]) {
		                this._selectNearestSegment();
		            }
		        },
	
		        _scroll: function (e) {
		            if (kendo._activeElement() !== this.element[0] || this.element.is("[readonly]")) {
		                return;
		            }
		            e = window.event || e;
	
		            var newEvent = { keyCode: 37, preventDefault: function () { } };
	
		            if (e.shiftKey) {
		                newEvent.keyCode = (e.wheelDelta || -e.detail) > 0 ? 37 : 39;
		            } else {
		                newEvent.keyCode = (e.wheelDelta || -e.detail) > 0 ? 38 : 40;
		            }
		            this._keydown(newEvent);
		            e.returnValue = false;
		            if (e.preventDefault) {
		                e.preventDefault();
		            }
		            if (e.stopPropagation) {
		                e.stopPropagation();
		            }
		        },
	
		        _form: function () {
		            var that = this;
		            var element = that.element;
		            var formId = element.attr("form");
		            var form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function () {
		                    setTimeout(function () {
		                        that.value(element[0].value);
		                    });
		                };
	
		                that._formElement = form.on("reset", that._resetHandler);
		            }
		        },
	
		        _paste: function (e) {
		            e.preventDefault();
		        },
	
		        _keydown: function (e) {
		            var key = e.keyCode;
		            var selection;
		            if (key == 37 || key == 39) { //left/right
		                e.preventDefault();
		                selection = caret(this.element[0]);
		                if (selection[0] != selection[1]) {
		                    this._selectNearestSegment();
		                }
		                var dir = (key == 37) ? -1 : 1;
		                var index = (dir == -1) ? caret(this.element[0])[0] - 1 : caret(this.element[0])[1] + 1;
		                while (index >= 0 && index < this._format.length) {
		                    if (knownSymbols.indexOf(this._format[index]) >= 0) {
		                        this._selectSegment(this._format[index]);
		                        break;
		                    }
		                    index += dir;
		                }
		            }
		            if (key == 38 || key == 40) { //up/down
		                e.preventDefault();
		                selection = caret(this.element[0]);
		                var symbol = this._format[selection[0]];
		                if (knownSymbols.indexOf(symbol) >= 0) {
		                    this._dateTime.modifyPart(symbol, key == 38 ? 1 : -1);
		                    this._updateElementValue();
		                    this._selectSegment(symbol);
		                    this.element.trigger(CHANGE);
		                }
		            }
		            if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
		                var keycode = e.keyCode ? e.keyCode : e.which;
		                if (keycode === 8 || keycode === 46) {
		                    var that = this;
		                    setTimeout(function () {
		                        that._input();
		                    }, 0);
		                }
		            }
		            if (key === keys.ENTER){
		                this._change();
		            }
		        },
	
		        _selectNearestSegment: function () {
		            var selection = caret(this.element[0]);
		            var start = selection[0];
		            for (var i = start, j = start - 1; i < this._format.length || j >= 0; i++ , j--) {
		                if (i < this._format.length && knownSymbols.indexOf(this._format[i]) !== -1) {
		                    this._selectSegment(this._format[i]);
		                    return;
		                }
		                if (j >= 0 && knownSymbols.indexOf(this._format[j]) !== -1) {
		                    this._selectSegment(this._format[j]);
		                    return;
		                }
		            }
		        },
	
		        _selectSegment: function (symbol) {
		            var begin = -1, end = 0;
		            for (var i = 0; i < this._format.length; i++) {
		                if (this._format[i] === symbol) {
		                    end = i + 1;
		                    if (begin === -1) {
		                        begin = i;
		                    }
		                }
		            }
		            if (begin < 0) {
		                begin = 0;
		            }
		            caret(this.element, begin, end);
		        }
	
		    });
	
		    ui.plugin(DateInput);
	
		    var customDateTime = function (initDate, initFormat, initCulture, initMessages) {
	
		        var value = null;
		        var year = true, month = true, date = true, hours = true, minutes = true, seconds = true, milliseconds = true;
		        var typedMonthPart = "";
		        var typedDayPeriodPart = "";
		        var placeholders = {};
	
		        //TODO: rewrite pad method
		        var zeros = ["", "0", "00", "000", "0000"];
		        function pad(number, digits, end) {
		            number = number + "";
		            digits = digits || 2;
		            end = digits - number.length;
	
		            if (end) {
		                return zeros[digits].substring(0, end) + number;
		            }
	
		            return number;
		        }
		        var dateFormatRegExp = /dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g;
		        var months = null, calendar = null, days = null, returnsFormat = false;
		        var matcher = function (match) {
		            var mins, sign;
		            var result;
	
		            switch (match) {
		                case ("d"): result = date ? value.getDate() : placeholders.day; break;
		                case ("dd"): result = date ? pad(value.getDate()) : placeholders.day; break;
		                case ("ddd"): result = date && month && year ? days.namesAbbr[value.getDay()] : placeholders.weekday; break;
		                case ("dddd"): result = date && month && year ? days.names[value.getDay()] : placeholders.weekday; break;
	
		                case ("M"): result = month ? value.getMonth() + 1 : placeholders.month; break;
		                case ("MM"): result = month ? pad(value.getMonth() + 1) : placeholders.month; break;
		                case ("MMM"): result = month ? months.namesAbbr[value.getMonth()] : placeholders.month; break;
		                case ("MMMM"): result = month ? months.names[value.getMonth()] : placeholders.month; break;
	
		                case ("yy"): result = year ? pad(value.getFullYear() % 100) : placeholders.year; break;
		                case ("yyyy"): result = year ? pad(value.getFullYear(), 4) : placeholders.year; break;
	
		                case ("h"): result = hours ? value.getHours() % 12 || 12 : placeholders.hour; break;
		                case ("hh"): result = hours ? pad(value.getHours() % 12 || 12) : placeholders.hour; break;
		                case ("H"): result = hours ? value.getHours() : placeholders.hour; break;
		                case ("HH"): result = hours ? pad(value.getHours()) : placeholders.hour; break;
	
		                case ("m"): result = minutes ? value.getMinutes() : placeholders.minute; break;
		                case ("mm"): result = minutes ? pad(value.getMinutes()) : placeholders.minute; break;
		                case ("s"): result = seconds ? value.getSeconds() : placeholders.second; break;
		                case ("ss"): result = seconds ? pad(value.getSeconds()) : placeholders.second; break;
		                case ("f"): result = milliseconds ? Math.floor(value.getMilliseconds() / 100) : milliseconds; break;
		                case ("ff"):
		                    result = value.getMilliseconds();
		                    if (result > 99) {
		                        result = Math.floor(result / 10);
		                    }
		                    result = milliseconds ? pad(result) : match;
		                    break;
		                case ("fff"): result = milliseconds ? pad(value.getMilliseconds(), 3) : match; break;
		                case ("tt"): result = hours ? (value.getHours() < 12 ? calendar.AM[0] : calendar.PM[0]) : placeholders.dayperiod; break;
		                case ("zzz"):
		                    mins = value.getTimezoneOffset();
		                    sign = mins < 0;
		                    result = Math.abs(mins / 60).toString().split(".")[0];
		                    mins = Math.abs(mins) - (result * 60);
		                    result = (sign ? "+" : "-") + pad(result);
		                    result += ":" + pad(mins);
		                    break;
		                case ("z"):
		                case ("zz"):
		                    result = value.getTimezoneOffset() / 60;
		                    sign = result < 0;
		                    result = Math.abs(result).toString().split(".")[0];
		                    result = (sign ? "+" : "-") + (match === "zz" ? pad(result) : result);
		                    break;
		            }
		            result = (result !== undefined ? result : match.slice(1, match.length - 1));
	
		            if (returnsFormat) {
		                result = "" + result;
		                var formatResult = "";
		                if (match == "ddd") { match = "EEE"; }
		                if (match == "dddd") { match = "EEEE"; }
		                for (var i = 0; i < result.length; i++) {
		                    formatResult += match[0];
		                }
		                return formatResult;
		            } else {
		                return result;
		            }
		        };
	
		        function generateMatcher(retFormat) {
		            returnsFormat = retFormat;
		            return matcher;
		        }
	
		        function setExisting(symbol, val) {
		            switch (symbol) {
		                case "y": year = val; break;
		                case "M": month = val;
		                    if (!val) {
		                        value.setMonth(0);
		                        typedMonthPart = "";
		                    }
		                    break;
		                case "d": date = val; break;
		                case "H":
		                case "h": hours = val;
		                    if (!val) {
		                        typedDayPeriodPart = "";
		                    }
		                    break;
		                case "m": minutes = val; break;
		                case "s": seconds = val; break;
		                default: return;
		            }
		        }
	
		        this.setValue = function (val) {
		            date = val;
		        };
	
		        this.getValue = function () {
		            return date;
		        };
	
		        this.modifyPart = function (symbol, offset) {
		            var newValue = new Date((value && value.getTime) ? value.getTime() : value);
		            switch (symbol) {
		                case "y": newValue.setFullYear(newValue.getFullYear() + offset); break;
		                case "M":
		                    var newMonth = newValue.getMonth() + offset;
		                    newValue.setMonth(newMonth);
		                    if (newValue.getMonth() % 12 !== (newMonth + 12) % 12) {
		                        //handle case when new month does not have such date
		                        newValue.setDate(1);
		                        newValue.setMonth(newMonth);
		                    }
		                    break;
		                case "d":
		                case "E": newValue.setDate(newValue.getDate() + offset); break;
		                case "H":
		                case "h": newValue.setHours(newValue.getHours() + offset); break;
		                case "m": newValue.setMinutes(newValue.getMinutes() + offset); break;
		                case "s": newValue.setSeconds(newValue.getSeconds() + offset); break;
		                case "t": newValue.setHours((newValue.getHours() + 12) % 24); break;
		                default: break;
		            }
		            if (newValue.getFullYear() > 0) {
		                setExisting(symbol, true);
		                value = newValue;
		            }
		        };
	
		        this.parsePart = function (symbol, currentChar) {
		            if (!currentChar) {
		                setExisting(symbol, false);
		                return true;
		            }
		            var newValue = new Date((value && value.getTime) ? value.getTime() : value);
		            var newHours;
		            switch (symbol) {
		                case "d":
		                    var newDate = (date ? newValue.getDate() * 10 : 0) + parseInt(currentChar, 10);
		                    if (isNaN(newDate)) { return; }
		                    while (newDate > 31) {
		                        newDate = parseInt(newDate.toString().slice(1), 10);
		                    }
		                    if (newDate < 1) {
		                        date = false;
		                    } else {
		                        newValue.setDate(newDate);
		                        if (newValue.getMonth() !== value.getMonth()) {
		                            return;
		                        }
		                        date = true;
		                    }
		                    break;
		                case "M":
		                    var newMonth = (month ? (newValue.getMonth() + 1) * 10 : 0) + parseInt(currentChar, 10);
		                    if (!isNaN(newMonth)) {
		                        while (newMonth > 12) {
		                            newMonth = parseInt(newMonth.toString().slice(1), 10);
		                        }
		                        if (newMonth < 1) {
		                            month = false;
		                        } else {
		                            newValue.setMonth(newMonth - 1);
		                            if (newValue.getMonth() !== newMonth - 1) {
		                                newValue.setDate(1);
		                                newValue.setMonth(newMonth - 1);
		                            }
		                            month = true;
		                        }
		                    }
		                    else {
		                        var monthNames = calendar.months.names;
		                        typedMonthPart += currentChar.toLowerCase();
	
		                        while (typedMonthPart.length > 0) {
		                            for (var i = 0; i < monthNames.length; i++) {
		                                if (monthNames[i].toLowerCase().indexOf(typedMonthPart) === 0) {
		                                    newValue.setMonth(i);
		                                    month = true;
		                                    value = newValue;
		                                    return true;
		                                }
		                            }
		                            typedMonthPart = typedMonthPart.substring(1, typedMonthPart.length);
		                        }
		                        return false;
		                    }
		                    break;
		                case "y":
		                    var newYear = (year ? (newValue.getFullYear()) * 10 : 0) + parseInt(currentChar, 10);
		                    if (isNaN(newYear)) {return;}
		                    while (newYear > 9999) {
		                        newYear = parseInt(newYear.toString().slice(1), 10);
		                    }
		                    if (newYear < 1) {
		                        year = false;
		                    } else {
		                        newValue.setFullYear(newYear);
		                        year = true;
		                    }
		                    break;
		                case "h":
		                    newHours = (hours ? (newValue.getHours() % 12 || 12) * 10 : 0) + parseInt(currentChar, 10);
		                    if (isNaN(newHours)) { return; }
		                    while (newHours > 12) {
		                        newHours = parseInt(newHours.toString().slice(1), 10);
		                    }
		                    newValue.setHours(Math.floor(newValue.getHours() / 12) * 12 + newHours % 12);
		                    hours = true;
		                    break;
		                case "H":
		                    newHours = (hours ? (newValue.getHours()) * 10 : 0) + parseInt(currentChar, 10);
		                    if (isNaN(newHours)) { return; }
		                    while (newHours > 23) {
		                        newHours = parseInt(newHours.toString().slice(1), 10);
		                    }
		                    newValue.setHours(newHours);
		                    hours = true;
		                    break;
		                case "m":
		                    var newMinutes = (minutes ? (newValue.getMinutes()) * 10 : 0) + parseInt(currentChar, 10);
		                    if (isNaN(newMinutes)) { return; }
		                    while (newMinutes > 59) {
		                        newMinutes = parseInt(newMinutes.toString().slice(1), 10);
		                    }
		                    newValue.setMinutes(newMinutes);
		                    minutes = true;
		                    break;
		                case "s":
		                    var newSeconds = (seconds ? (newValue.getSeconds()) * 10 : 0) + parseInt(currentChar, 10);
		                    if (isNaN(newSeconds)) { return; }
		                    while (newSeconds > 59) {
		                        newSeconds = parseInt(newSeconds.toString().slice(1), 10);
		                    }
		                    newValue.setSeconds(newSeconds);
		                    seconds = true;
		                    break;
		                case "t":
		                    if (hours) {
		                        typedDayPeriodPart += currentChar.toLowerCase();
		                        while (typedDayPeriodPart.length > 0) {
		                            if (calendar.AM[0].toLowerCase().indexOf(typedDayPeriodPart) === 0 && newValue.getHours() >= 12 ||
		                                calendar.PM[0].toLowerCase().indexOf(typedDayPeriodPart) === 0 && newValue.getHours() < 12) {
		                                newValue.setHours((newValue.getHours() + 12) % 24);
		                                value = newValue;
		                                return true;
		                            }
		                            typedDayPeriodPart = typedDayPeriodPart.substring(1, typedDayPeriodPart.length);
		                        }
		                        return false;
		                    }
		                    break;
		                default: break;
		            }
		            value = newValue;
		            return true;
		        };
	
		        this.toPair = function (format, culture , messages) {
		            if (!format) {
		                return ["", ""];
		            }
		            culture = kendo.getCulture(culture);
		            calendar = culture.calendars.standard;
		            format = calendar.patterns[format] || format;
		            days = calendar.days;
		            months = calendar.months;
		            placeholders = messages;
		            return [
		                format.replace(dateFormatRegExp, generateMatcher(false)),
		                format.replace(dateFormatRegExp, generateMatcher(true))
		            ];
		        };
	
		        this.getDateObject = function () {
		            return (year && month && date && hours && minutes && seconds && milliseconds) ?
		                new Date(value.getTime()) : null;
		        };
	
		        if (!initDate) {
		            value = new Date();
		            var sampleFormat = this.toPair(initFormat, initCulture, initMessages)[1];
		            for (var i = 0; i < sampleFormat.length; i++) {
		                setExisting(sampleFormat[i], false);
		            }
		        } else {
		            value = new Date(initDate.getTime());
		        }
		    };
	
		    function approximateStringMatching(oldText, oldFormat, newText, caret){
		        var oldTextSeparator = oldText[caret + oldText.length - newText.length];
		        oldText = oldText.substring(0, caret + oldText.length - newText.length);
		        newText = newText.substring(0, caret);
		        var diff = [];
		        var i;
		        //handle typing single character over the same selection
		        if (oldText === newText && caret > 0) {
		            diff.push([oldFormat[caret - 1], newText[caret - 1]]);
		            return diff;
		        }
		        if (oldText.indexOf(newText) === 0 && (newText.length === 0 || oldFormat[newText.length - 1] !== oldFormat[newText.length])) {
		            //handle delete/backspace
		            var deletedSymbol = "";
		            for (i = newText.length; i < oldText.length; i++) {
		                if (oldFormat[i] !== deletedSymbol && knownSymbols.indexOf(oldFormat[i]) >= 0) {
		                    deletedSymbol = oldFormat[i];
		                    diff.push([deletedSymbol, ""]);
		                }
		            }
		            return diff;
		        }
	
		        //handle entering space or separator, for nagivation to next item
		        if (newText[newText.length - 1] === " " || newText[newText.length - 1] === oldTextSeparator) {
		            return [[oldFormat[caret - 1], " "]];
		        }
	
		        //handle inserting text (new text is longer than previous)
		        //handle typing over literal as well
		        if (newText.indexOf(oldText) === 0 || knownSymbols.indexOf(oldFormat[caret - 1]) === -1) {
		            var symbol = oldFormat[0];
		            for (i = Math.max(0, oldText.length - 1); i < oldFormat.length; i++) {
		                if (knownSymbols.indexOf(oldFormat[i]) >= 0) {
		                    symbol = oldFormat[i];
		                    break;
		                }
		            }
		            return [[symbol, newText[caret - 1]]];
		        }
		        //handle typing over correctly selected part
		        return [[oldFormat[caret - 1], newText[caret - 1]]];
		}
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1115);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1115:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1116), __webpack_require__(1036),  __webpack_require__(1117) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "datepicker",
		    name: "DatePicker",
		    category: "web",
		    description: "The DatePicker widget allows the user to select a date from a calendar or by direct input.",
		    depends: [ "calendar", "popup" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		    ui = kendo.ui,
		    Widget = ui.Widget,
		    parse = kendo.parseDate,
		    keys = kendo.keys,
		    support = kendo.support,
		    template = kendo.template,
		    activeElement = kendo._activeElement,
		    DIV = "<div />",
		    SPAN = "<span />",
		    ns = ".kendoDatePicker",
		    CLICK = "click" + ns,
		    UP = support.mouseAndTouchPresent ? kendo.applyEventMap("up", ns.slice(1)) : CLICK,
		    OPEN = "open",
		    CLOSE = "close",
		    CHANGE = "change",
		    DISABLED = "disabled",
		    READONLY = "readonly",
		    DEFAULT = "k-state-default",
		    FOCUSED = "k-state-focused",
		    SELECTED = "k-state-selected",
		    STATEDISABLED = "k-state-disabled",
		    HOVER = "k-state-hover",
		    HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		    MOUSEDOWN = "mousedown" + ns,
		    ID = "id",
		    MIN = "min",
		    MAX = "max",
		    MONTH = "month",
		    ARIA_DISABLED = "aria-disabled",
		    ARIA_EXPANDED = "aria-expanded",
		    ARIA_HIDDEN = "aria-hidden",
		    calendar = kendo.calendar,
		    isInRange = calendar.isInRange,
		    restrictValue = calendar.restrictValue,
		    isEqualDatePart = calendar.isEqualDatePart,
		    extend = $.extend,
		    proxy = $.proxy,
		    DATE = Date;
	
		    function normalize(options) {
		        var parseFormats = options.parseFormats,
		            format = options.format;
	
		        calendar.normalize(options);
	
	
		        parseFormats = $.isArray(parseFormats) ? parseFormats : [parseFormats];
	
		        if (!parseFormats.length) {
		            parseFormats.push("yyyy-MM-dd");
		        }
	
		        if ($.inArray(format, parseFormats) === -1) {
		            parseFormats.splice(0, 0, options.format);
		        }
	
		        options.parseFormats = parseFormats;
		    }
	
		    function preventDefault(e) {
		        e.preventDefault();
		    }
	
		    var DateView = function(options) {
		        var that = this, id,
		            body = document.body,
		            div = $(DIV).attr(ARIA_HIDDEN, "true")
		                        .addClass("k-calendar-container")
		                        .appendTo(body);
	
		        that.options = options = options || {};
		        id = options.id;
	
		        if (id) {
		            id += "_dateview";
	
		            div.attr(ID, id);
		            that._dateViewID = id;
		        }
	
		        that.popup = new ui.Popup(div, extend(options.popup, options, { name: "Popup", isRtl: kendo.support.isRtl(options.anchor) }));
		        that.div = div;
	
		        that.value(options.value);
		    };
	
		    DateView.prototype = {
		        _calendar: function() {
		            var that = this;
		            var calendar = that.calendar;
		            var options = that.options;
		            var div;
	
		            if (!calendar) {
		                div = $(DIV).attr(ID, kendo.guid())
		                            .appendTo(that.popup.element)
		                            .on(MOUSEDOWN, preventDefault)
		                            .on(CLICK, "td:has(.k-link)", proxy(that._click, that));
	
		                that.calendar = calendar = new ui.Calendar(div);
		                that._setOptions(options);
	
		                kendo.calendar.makeUnselectable(calendar.element);
	
		                calendar.navigate(that._value || that._current, options.start);
	
		                that.value(that._value);
		            }
		        },
	
		        _setOptions: function(options) {
		            this.calendar.setOptions({
		                focusOnNav: false,
		                change: options.change,
		                culture: options.culture,
		                dates: options.dates,
		                depth: options.depth,
		                footer: options.footer,
		                format: options.format,
		                max: options.max,
		                min: options.min,
		                month: options.month,
		                weekNumber: options.weekNumber,
		                start: options.start,
		                disableDates: options.disableDates
		            });
		        },
	
		        setOptions: function(options) {
		            var old = this.options;
		            var disableDates = options.disableDates;
	
		            if (disableDates) {
		                options.disableDates = calendar.disabled(disableDates);
		            }
	
		            this.options = extend(old, options, {
		                change: old.change,
		                close: old.close,
		                open: old.open
		            });
	
		            if (this.calendar) {
		                this._setOptions(this.options);
		            }
		        },
	
		        destroy: function() {
		            this.popup.destroy();
		        },
	
		        open: function() {
		            var that = this;
		            var popupHovered;
	
		            that._calendar();
	
		            // In some cases when the popup is opened resize is triggered which will cause it to close
		            // Setting the below flag will prevent this from happening
		            // Reference: https://github.com/telerik/kendo/pull/7553
		            popupHovered = that.popup._hovered;
		            that.popup._hovered = true;
	
		            that.popup.open();
	
		            setTimeout(function() {
		                that.popup._hovered = popupHovered;
		            }, 1);
		        },
	
		        close: function() {
		            this.popup.close();
		        },
	
		        min: function(value) {
		            this._option(MIN, value);
		        },
	
		        max: function(value) {
		            this._option(MAX, value);
		        },
	
		        toggle: function() {
		            var that = this;
	
		            that[that.popup.visible() ? CLOSE : OPEN]();
		        },
	
		        move: function(e) {
		            var that = this,
		                key = e.keyCode,
		                calendar = that.calendar,
		                selectIsClicked = e.ctrlKey && key == keys.DOWN || key == keys.ENTER,
		                handled = false;
	
		            if (e.altKey) {
		                if (key == keys.DOWN) {
		                    that.open();
		                    e.preventDefault();
		                    handled = true;
		                } else if (key == keys.UP) {
		                    that.close();
		                    e.preventDefault();
		                    handled = true;
		                }
	
		            } else if (that.popup.visible()) {
	
		                if (key == keys.ESC || (selectIsClicked && calendar._cell.hasClass(SELECTED))) {
		                    that.close();
		                    e.preventDefault();
		                    return true;
		                }
		                //spacebar selects a date in the calendar
		                if (key != keys.SPACEBAR) {
		                    that._current = calendar._move(e);
		                }
	
		                handled = true;
		            }
	
		            return handled;
		        },
	
		        current: function(date) {
		            this._current = date;
		            this.calendar._focus(date);
		        },
	
		        value: function(value) {
		            var that = this,
		                calendar = that.calendar,
		                options = that.options,
		                disabledDate = options.disableDates;
	
		            if (disabledDate && disabledDate(value)) {
		                value = null;
		            }
	
		            that._value = value;
		            that._current = new DATE(+restrictValue(value, options.min, options.max));
	
		            if (calendar) {
		                calendar.value(value);
		            }
		        },
	
		        _click: function(e) {
	
		            if (e.currentTarget.className.indexOf(SELECTED) !== -1) {
		                this.close();
		            }
		        },
	
		        _option: function(option, value) {
		            var that = this;
		            var calendar = that.calendar;
	
		            that.options[option] = value;
	
		            if (calendar) {
		                calendar[option](value);
		            }
		        }
		    };
	
		    DateView.normalize = normalize;
	
		    kendo.DateView = DateView;
	
		    var DatePicker = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                disabled,
		                div;
	
		            Widget.fn.init.call(that, element, options);
		            element = that.element;
		            options = that.options;
	
		            options.disableDates = kendo.calendar.disabled(options.disableDates);
	
		            options.min = parse(element.attr("min")) || parse(options.min);
		            options.max = parse(element.attr("max")) || parse(options.max);
	
		            normalize(options);
	
		            that._initialOptions = extend({}, options);
	
		            that._wrapper();
	
		            that.dateView = new DateView(extend({}, options, {
		                id: element.attr(ID),
		                anchor: that.wrapper,
		                change: function() {
		                    // calendar is the current scope
		                    that._change(this.value());
		                    that.close();
		                },
		                close: function(e) {
		                    if (that.trigger(CLOSE)) {
		                        e.preventDefault();
		                    } else {
		                        element.attr(ARIA_EXPANDED, false);
		                        div.attr(ARIA_HIDDEN, true);
		                    }
		                },
		                open: function(e) {
		                    var options = that.options,
		                        date;
	
		                    if (that.trigger(OPEN)) {
		                        e.preventDefault();
		                    } else {
		                        if (that.element.val() !== that._oldText) {
		                            date = parse(element.val(), options.parseFormats, options.culture);
	
		                            that.dateView[date ? "current" : "value"](date);
		                        }
	
		                        element.attr(ARIA_EXPANDED, true);
		                        div.attr(ARIA_HIDDEN, false);
	
		                        that._updateARIA(date);
	
		                    }
		                }
		            }));
		            div = that.dateView.div;
	
		            that._icon();
	
		            try {
		                element[0].setAttribute("type", "text");
		            } catch(e) {
		                element[0].type = "text";
		            }
	
		            element
		                .addClass("k-input")
		                .attr({
		                    role: "combobox",
		                    "aria-expanded": false,
		                    "aria-owns": that.dateView._dateViewID,
		                    "autocomplete": "off"
		                });
		            that._reset();
		            that._template();
	
		            disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
		            if (disabled) {
		                that.enable(false);
		            } else {
		                that.readonly(element.is("[readonly]"));
		            }
	
		            that._createDateInput(options);
	
		            that._old = that._update(options.value || that.element.val());
		            that._oldText = element.val();
	
		            kendo.notify(that);
		        },
		        events: [
		        OPEN,
		        CLOSE,
		        CHANGE],
		        options: {
		            name: "DatePicker",
		            value: null,
		            footer: "",
		            format: "",
		            culture: "",
		            parseFormats: [],
		            min: new Date(1900, 0, 1),
		            max: new Date(2099, 11, 31),
		            start: MONTH,
		            depth: MONTH,
		            animation: {},
		            month: {},
		            dates: [],
		            disableDates: null,
		            ARIATemplate: 'Current focused date is #=kendo.toString(data.current, "D")#',
		            dateInput: false,
		            weekNumber: false
		        },
	
		        setOptions: function(options) {
		            var that = this;
		            var value = that._value;
	
		            Widget.fn.setOptions.call(that, options);
	
		            options = that.options;
	
		            options.min = parse(options.min);
		            options.max = parse(options.max);
	
		            normalize(options);
	
		            that.dateView.setOptions(options);
		            that._createDateInput(options);
	
		            if (!that._dateInput) {
		                that.element.val(kendo.toString(value, options.format, options.culture));
		            }
	
		            if (value) {
		                that._updateARIA(value);
		            }
		        },
	
		        _editable: function(options) {
		            var that = this,
		                icon = that._dateIcon.off(ns),
		                element = that.element.off(ns),
		                wrapper = that._inputWrapper.off(ns),
		                readonly = options.readonly,
		                disable = options.disable;
	
		            if (!readonly && !disable) {
		                wrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                element.removeAttr(DISABLED)
		                       .removeAttr(READONLY)
		                       .attr(ARIA_DISABLED, false)
		                       .on("keydown" + ns, proxy(that._keydown, that))
		                       .on("focusout" + ns, proxy(that._blur, that))
		                       .on("focus" + ns, function() {
		                           that._inputWrapper.addClass(FOCUSED);
		                       });
	
		               icon.on(UP, proxy(that._click, that))
		                   .on(MOUSEDOWN, preventDefault);
		            } else {
		                wrapper
		                    .addClass(disable ? STATEDISABLED : DEFAULT)
		                    .removeClass(disable ? DEFAULT : STATEDISABLED);
	
		                element.attr(DISABLED, disable)
		                       .attr(READONLY, readonly)
		                       .attr(ARIA_DISABLED, disable);
		            }
		        },
	
		        readonly: function(readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		        },
	
		        enable: function(enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.dateView.destroy();
	
		            that.element.off(ns);
		            that._dateIcon.off(ns);
		            that._inputWrapper.off(ns);
	
		            if (that._form) {
		                that._form.off("reset", that._resetHandler);
		            }
		        },
	
		        open: function() {
		            this.dateView.open();
		        },
	
		        close: function() {
		            this.dateView.close();
		        },
	
		        min: function(value) {
		            return this._option(MIN, value);
		        },
	
		        max: function(value) {
		            return this._option(MAX, value);
		        },
	
		        value: function(value) {
		            var that = this;
	
		            if (value === undefined) {
		                return that._value;
		            }
	
		            that._old = that._update(value);
	
		            if (that._old === null) {
		                that.element.val("");
		            }
	
		            that._oldText = that.element.val();
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
		        },
	
		        _blur: function() {
		            var that = this,
		                value = that.element.val();
	
		            that.close();
		            if (value !== that._oldText) {
		                that._change(value);
		            }
	
		            that._inputWrapper.removeClass(FOCUSED);
		        },
	
		        _click: function(e) {
		            var that = this;
	
		            that.dateView.toggle();
		            that._focusElement(e.type);
		        },
	
		        _focusElement: function(eventType) {
		            var element = this.element;
	
		            if ((!support.touch || (support.mouseAndTouchPresent && !(eventType || "").match(/touch/i))) && element[0] !== activeElement()) {
		                element.focus();
		            }
		        },
	
		        _change: function(value) {
		            var that = this,
		            oldValue = that.element.val(),
		            dateChanged;
	
		            value = that._update(value);
		            dateChanged = !kendo.calendar.isEqualDate(that._old, value);
	
		            var valueUpdated = dateChanged && !that._typing;
		            var textFormatted = oldValue !== that.element.val();
	
		            if (valueUpdated || textFormatted) {
		                that.element.trigger(CHANGE);
		            }
	
		            if (dateChanged) {
		                that._old = value;
		                that._oldText = that.element.val();
	
		                that.trigger(CHANGE);
		            }
	
		            that._typing = false;
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                dateView = that.dateView,
		                value = that.element.val(),
		                handled = false;
	
		            if (!dateView.popup.visible() && e.keyCode == keys.ENTER && value !== that._oldText) {
		                that._change(value);
		            } else {
		                handled = dateView.move(e);
		                that._updateARIA(dateView._current);
	
		                if (!handled) {
		                    that._typing = true;
		                } else if (that._dateInput && e.stopImmediatePropagation) {
		                    e.stopImmediatePropagation();
		                }
		            }
		        },
	
		        _icon: function() {
		            var that = this,
		                element = that.element,
		                icon;
	
		            icon = element.next("span.k-select");
	
		            if (!icon[0]) {
		                icon = $('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-calendar"></span></span>').insertAfter(element);
		            }
	
		            that._dateIcon = icon.attr({
		                "role": "button",
		                "aria-controls": that.dateView._dateViewID
		            });
		        },
	
		        _option: function(option, value) {
		            var that = this,
		                options = that.options;
	
		            if (value === undefined) {
		                return options[option];
		            }
	
		            value = parse(value, options.parseFormats, options.culture);
	
		            if (!value) {
		                return;
		            }
	
		            options[option] = new DATE(+value);
		            that.dateView[option](value);
		        },
	
		        _update: function(value) {
		            var that = this,
		                options = that.options,
		                min = options.min,
		                max = options.max,
		                current = that._value,
		                date = parse(value, options.parseFormats, options.culture),
		                isSameType = (date === null && current === null) || (date instanceof Date && current instanceof Date),
		                formattedValue;
	
		            if (options.disableDates(date)) {
		                date = null;
		                if (!that._old && !that.element.val()) {
		                    value = null;
		                }
		            }
	
		            if (+date === +current && isSameType) {
		                formattedValue = kendo.toString(date, options.format, options.culture);
	
		                if (formattedValue !== value) {
		                    that.element.val(date === null ? value : formattedValue);
		                }
	
		                return date;
		            }
	
		            if (date !== null && isEqualDatePart(date, min)) {
		                date = restrictValue(date, min, max);
		            } else if (!isInRange(date, min, max)) {
		                date = null;
		            }
	
		            that._value = date;
		            that.dateView.value(date);
		            if (that._dateInput && date) {
		                that._dateInput.value(date || value);
		            } else {
		                that.element.val(kendo.toString(date || value, options.format, options.culture));
		            }
		            that._updateARIA(date);
	
		            return date;
		        },
	
		        _wrapper: function() {
		            var that = this,
		                element = that.element,
		                wrapper;
	
		            wrapper = element.parents(".k-datepicker");
	
		            if (!wrapper[0]) {
		                wrapper = element.wrap(SPAN).parent().addClass("k-picker-wrap k-state-default");
		                wrapper = wrapper.wrap(SPAN).parent();
		            }
	
		            wrapper[0].style.cssText = element[0].style.cssText;
		            element.css({
		                width: "100%",
		                height: element[0].style.height
		            });
	
		            that.wrapper = wrapper.addClass("k-widget k-datepicker")
		                .addClass(element[0].className);
	
		            that._inputWrapper = $(wrapper[0].firstChild);
		        },
	
		        _reset: function() {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    that.value(element[0].defaultValue);
		                    that.max(that._initialOptions.max);
		                    that.min(that._initialOptions.min);
		                };
	
		                that._form = form.on("reset", that._resetHandler);
		            }
		        },
	
		        _template: function() {
		            this._ariaTemplate = template(this.options.ARIATemplate);
		        },
	
		        _createDateInput: function(options) {
		            if (this._dateInput) {
		                this._dateInput.destroy();
		                this._dateInput = null;
		            }
	
		            if (options.dateInput ) {
		                this._dateInput = new ui.DateInput(this.element, {
		                    culture: options.culture,
		                    format: options.format,
		                    min: options.min,
		                    max: options.max
		                });
		            }
		        },
	
		        _updateARIA: function(date) {
		            var cell;
		            var that = this;
		            var calendar = that.dateView.calendar;
	
		            that.element.removeAttr("aria-activedescendant");
	
		            if (calendar) {
		                cell = calendar._cell;
		                cell.attr("aria-label", that._ariaTemplate({ current: date || calendar.current() }));
	
		                that.element.attr("aria-activedescendant", cell.attr("id"));
		            }
		        }
		    });
	
		    ui.plugin(DatePicker);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1116:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(588);
	
	/***/ }),
	
	/***/ 1117:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(589);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1332);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1117:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(589);
	
	/***/ }),
	
	/***/ 1332:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1036), __webpack_require__(1117) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "timepicker",
		    name: "TimePicker",
		    category: "web",
		    description: "The TimePicker widget allows the end user to select a value from a list of predefined values or to type a new value.",
		    depends: [ "popup" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        keys = kendo.keys,
		        parse = kendo.parseDate,
		        activeElement = kendo._activeElement,
		        extractFormat = kendo._extractFormat,
		        support = kendo.support,
		        browser = support.browser,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        OPEN = "open",
		        CLOSE = "close",
		        CHANGE = "change",
		        ns = ".kendoTimePicker",
		        CLICK = "click" + ns,
		        DEFAULT = "k-state-default",
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        LI = "li",
		        SPAN = "<span/>",
		        FOCUSED = "k-state-focused",
		        HOVER = "k-state-hover",
		        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		        MOUSEDOWN = "mousedown" + ns,
		        MS_PER_MINUTE = 60000,
		        MS_PER_DAY = 86400000,
		        SELECTED = "k-state-selected",
		        STATEDISABLED = "k-state-disabled",
		        ARIA_SELECTED = "aria-selected",
		        ARIA_EXPANDED = "aria-expanded",
		        ARIA_HIDDEN = "aria-hidden",
		        ARIA_DISABLED = "aria-disabled",
		        ARIA_ACTIVEDESCENDANT = "aria-activedescendant",
		        ID = "id",
		        isArray = $.isArray,
		        extend = $.extend,
		        proxy = $.proxy,
		        DATE = Date,
		        TODAY = new DATE();
	
		    TODAY = new DATE(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate(), 0, 0, 0);
	
		    var TimeView = function(options) {
		        var that = this,
		            id = options.id;
	
		        that.options = options;
		        that._dates = [];
	
		        that.ul = $('<ul tabindex="-1" role="listbox" aria-hidden="true" unselectable="on" class="k-list k-reset"/>')
		                    .css({ overflow: support.kineticScrollNeeded ? "": "auto" })
		                    .on(CLICK, LI, proxy(that._click, that))
		                    .on("mouseenter" + ns, LI, function() { $(this).addClass(HOVER); })
		                    .on("mouseleave" + ns, LI, function() { $(this).removeClass(HOVER); });
	
		        that.list = $("<div class='k-list-container k-list-scroller' unselectable='on'/>")
		                    .append(that.ul)
		                    .on(MOUSEDOWN, preventDefault);
	
		        if (id) {
		            that._timeViewID = id + "_timeview";
		            that._optionID = id + "_option_selected";
	
		            that.ul.attr(ID, that._timeViewID);
		        }
	
		        that._popup();
		        that._heightHandler = proxy(that._height, that);
	
		        that.template = kendo.template('<li tabindex="-1" role="option" class="k-item" unselectable="on">#=data#</li>', { useWithBlock: false });
		    };
	
		    TimeView.prototype = {
		        current: function(candidate) {
		            var that = this,
		                active = that.options.active;
	
		            if (candidate !== undefined) {
		                if (that._current) {
		                    that._current
		                        .removeClass(SELECTED)
		                        .removeAttr(ARIA_SELECTED)
		                        .removeAttr(ID);
		                }
	
		                if (candidate) {
		                    candidate = $(candidate).addClass(SELECTED)
		                                            .attr(ID, that._optionID)
		                                            .attr(ARIA_SELECTED, true);
	
		                    that.scroll(candidate[0]);
		                }
	
		                that._current = candidate;
	
		                if (active) {
		                    active(candidate);
		                }
		            } else {
		                return that._current;
		            }
		        },
	
		        close: function() {
		            this.popup.close();
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.ul.off(ns);
		            that.list.off(ns);
		            that.popup.destroy();
		        },
	
		        open: function() {
		            var that = this;
		            var popupHovered;
	
		            if (!that.ul[0].firstChild) {
		                that.bind();
		            }
	
		            // In some cases when the popup is opened resize is triggered which will cause it to close
		            // Setting the below flag will prevent this from happening
		            // Reference: https://github.com/telerik/kendo/pull/7553
		            popupHovered = that.popup._hovered;
		            that.popup._hovered = true;
	
		            that.popup.open();
	
		            setTimeout(function() {
		                that.popup._hovered = popupHovered;
		            }, 1);
	
		            if (that._current) {
		                that.scroll(that._current[0]);
		            }
		        },
	
		        dataBind: function(dates) {
		            var that = this,
		                options = that.options,
		                format = options.format,
		                toString = kendo.toString,
		                template = that.template,
		                length = dates.length,
		                idx = 0,
		                date,
		                html = "";
	
		            for (; idx < length; idx++) {
		                date = dates[idx];
	
		                if (isInRange(date, options.min, options.max)) {
		                    html += template(toString(date, format, options.culture));
		                }
		            }
	
		            that._html(html);
		        },
	
		        refresh: function() {
		            var that = this,
		                options = that.options,
		                format = options.format,
		                offset = dst(),
		                ignoreDST = offset < 0,
		                min = options.min,
		                max = options.max,
		                msMin = getMilliseconds(min),
		                msMax = getMilliseconds(max),
		                msLastTime = getMilliseconds(lastTimeOption(options.interval)),
		                msInterval = options.interval * MS_PER_MINUTE,
		                toString = kendo.toString,
		                template = that.template,
		                start = new DATE(+min),
		                startDate = new DATE(start),
		                msStart, lastIdx,
		                idx = 0, length,
		                html = "";
	
		            if (ignoreDST) {
		                length = (MS_PER_DAY + (offset * MS_PER_MINUTE)) / msInterval;
		            } else {
		                length = MS_PER_DAY / msInterval;
		            }
	
		            if (msMin != msMax || msLastTime === msMax) {
		                if (msMin > msMax) {
		                    msMax += MS_PER_DAY;
		                }
	
		                length = ((msMax - msMin) / msInterval) + 1;
		            }
	
		            lastIdx = parseInt(length, 10);
	
		            for (; idx < length; idx++) {
		                if (idx) {
		                    setTime(start, msInterval, ignoreDST);
		                }
	
		                if (msMax && lastIdx == idx) {
		                    msStart = getMilliseconds(start);
		                    if (startDate < start) {
		                        msStart += MS_PER_DAY;
		                    }
	
		                    if (msStart > msMax) {
		                        start = new DATE(+max);
		                    }
		                }
	
		                that._dates.push(getMilliseconds(start));
		                html += template(toString(start, format, options.culture));
		            }
	
		            that._html(html);
		        },
	
		        bind: function() {
		            var that = this,
		                dates = that.options.dates;
	
		            if (dates && dates[0]) {
		                that.dataBind(dates);
		            } else {
		                that.refresh();
		            }
		        },
	
		        _html: function(html) {
		            var that = this;
	
		            that.ul[0].innerHTML = html;
	
		            that.popup.unbind(OPEN, that._heightHandler);
		            that.popup.one(OPEN, that._heightHandler);
	
		            that.current(null);
		            that.select(that._value);
		        },
	
		        scroll: function(item) {
		            if (!item) {
		                return;
		            }
	
		            var content = this.list[0],
		                itemOffsetTop = item.offsetTop,
		                itemOffsetHeight = item.offsetHeight,
		                contentScrollTop = content.scrollTop,
		                contentOffsetHeight = content.clientHeight,
		                bottomDistance = itemOffsetTop + itemOffsetHeight;
	
		                if (contentScrollTop > itemOffsetTop) {
		                    contentScrollTop = itemOffsetTop;
		                } else if (bottomDistance > (contentScrollTop + contentOffsetHeight)) {
		                    contentScrollTop = (bottomDistance - contentOffsetHeight);
		                }
	
		                content.scrollTop = contentScrollTop;
		        },
	
		        select: function(li) {
		            var that = this,
		                options = that.options,
		                current = that._current,
		                selection;
	
		            if (li instanceof Date) {
		                li = kendo.toString(li, options.format, options.culture);
		            }
	
		            if (typeof li === "string") {
		                if (!current || current.text() !== li) {
		                    li = $.grep(that.ul[0].childNodes, function(node) {
		                        return (node.textContent || node.innerText) == li;
		                    });
	
		                    li = li[0] ? li : null;
		                } else {
		                    li = current;
		                }
		            }
		            selection = that._distinctSelection(li);
		            that.current(selection);
		        },
	
		        _distinctSelection: function(selection) {
		            var that = this,
		                currentValue,
		                selectionIndex;
	
		            if (selection && selection.length > 1) {
		                currentValue = getMilliseconds(that._value);
		                selectionIndex = $.inArray(currentValue, that._dates);
		                selection = that.ul.children()[selectionIndex];
		            }
	
		            return selection;
		        },
	
		        setOptions: function(options) {
		            var old = this.options;
	
		            options.min = parse(options.min);
		            options.max = parse(options.max);
	
		            this.options = extend(old, options, {
		                active: old.active,
		                change: old.change,
		                close: old.close,
		                open: old.open
		            });
	
		            this.bind();
		        },
	
		        toggle: function() {
		            var that = this;
	
		            if (that.popup.visible()) {
		                that.close();
		            } else {
		                that.open();
		            }
		        },
	
		        value: function(value) {
		            var that = this;
	
		            that._value = value;
		            if (that.ul[0].firstChild) {
		                that.select(value);
		            }
		        },
	
		        _click: function(e) {
		            var that = this,
		                li = $(e.currentTarget),
		                date = li.text(),
		                dates = that.options.dates;
	
		            if (dates && dates.length > 0) {
		                date = dates[li.index()];
		            }
	
		            if (!e.isDefaultPrevented()) {
		                that.select(li);
		                that.options.change(date, true);
		                that.close();
		            }
		        },
	
		        _height: function() {
		            var that = this;
		            var list = that.list;
		            var parent = list.parent(".k-animation-container");
		            var height = that.options.height;
	
		            if (that.ul[0].children.length) {
		                list.add(parent)
		                    .show()
		                    .height(that.ul[0].scrollHeight > height ? height : "auto")
		                    .hide();
		            }
		        },
	
		        _parse: function(value) {
		            var that = this,
		                options = that.options,
		                min = getMilliseconds(options.min) != getMilliseconds(TODAY) ? options.min : null,
		                max = getMilliseconds(options.max) != getMilliseconds(TODAY) ? options.max : null,
		                current = that._value || min || max || TODAY;
	
		            if (value instanceof DATE) {
		                return value;
		            }
	
		            value = parse(value, options.parseFormats, options.culture);
	
		            if (value) {
		                value = new DATE(current.getFullYear(),
		                                 current.getMonth(),
		                                 current.getDate(),
		                                 value.getHours(),
		                                 value.getMinutes(),
		                                 value.getSeconds(),
		                                 value.getMilliseconds());
		            }
	
		            return value;
		        },
	
		        _adjustListWidth: function() {
		            var list = this.list,
		                width = list[0].style.width,
		                wrapper = this.options.anchor,
		                computedStyle, computedWidth,
		                outerWidth = kendo._outerWidth;
	
		            if (!list.data("width") && width) {
		                return;
		            }
	
		            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
		            computedWidth = computedStyle ? parseFloat(computedStyle.width) : outerWidth(wrapper);
	
		            if (computedStyle && (browser.mozilla || browser.msie)) { // getComputedStyle returns different box in FF and IE.
		                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
		            }
	
		            width = computedWidth - (outerWidth(list) - list.width());
	
		            list.css({
		                fontFamily: wrapper.css("font-family"),
		                width: width
		            })
		            .data("width", width);
		        },
	
		        _popup: function() {
		            var that = this,
		                list = that.list,
		                options = that.options,
		                anchor = options.anchor;
	
		            that.popup = new ui.Popup(list, extend(options.popup, {
		                anchor: anchor,
		                open: options.open,
		                close: options.close,
		                animation: options.animation,
		                isRtl: support.isRtl(options.anchor)
		            }));
		        },
	
		        move: function(e) {
		            var that = this,
		                key = e.keyCode,
		                ul = that.ul[0],
		                current = that._current,
		                down = key === keys.DOWN;
	
		            if (key === keys.UP || down) {
		                if (e.altKey) {
		                    that.toggle(down);
		                    return;
		                } else if (down) {
		                    current = current ? current[0].nextSibling : ul.firstChild;
		                } else {
		                    current = current ? current[0].previousSibling : ul.lastChild;
		                }
	
		                if (current) {
		                    that.select(current);
		                }
	
		                that.options.change(that._current.text());
		                e.preventDefault();
	
		            } else if (key === keys.ENTER || key === keys.TAB || key === keys.ESC) {
		                e.preventDefault();
		                if (current) {
		                    that.options.change(current.text(), true);
		                }
		                that.close();
		            }
		        }
		    };
	
		    function setTime(date, time, ignoreDST) {
		        var offset = date.getTimezoneOffset(),
		            offsetDiff;
	
		        date.setTime(date.getTime() + time);
	
		        if (!ignoreDST) {
		            offsetDiff = date.getTimezoneOffset() - offset;
		            date.setTime(date.getTime() + offsetDiff * MS_PER_MINUTE);
		        }
		    }
	
		    function dst() {
		        var today = new DATE(),
		            midnight = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
		            noon = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 12, 0, 0);
	
		        return -1 * (midnight.getTimezoneOffset() - noon.getTimezoneOffset());
		    }
	
		    function getMilliseconds(date) {
		        return date.getHours() * 60 * MS_PER_MINUTE + date.getMinutes() * MS_PER_MINUTE + date.getSeconds() * 1000 + date.getMilliseconds();
		    }
	
		    function lastTimeOption(interval) {
		        var date = new Date(2100, 0, 1);
		        date.setMinutes(-interval);
		        return date;
		    }
	
		    function isInRange(value, min, max) {
		        var msMin = getMilliseconds(min),
		            msMax = getMilliseconds(max),
		            msValue;
	
		        if (!value || msMin == msMax) {
		            return true;
		        }
	
		        msValue = getMilliseconds(value);
	
		        if (msMin > msValue) {
		            msValue += MS_PER_DAY;
		        }
	
		        if (msMax < msMin) {
		            msMax += MS_PER_DAY;
		        }
	
		        return msValue >= msMin && msValue <= msMax;
		    }
	
		    TimeView.getMilliseconds = getMilliseconds;
	
		    kendo.TimeView = TimeView;
	
		    var TimePicker = Widget.extend({
		        init: function(element, options) {
		            var that = this, ul, timeView, disabled;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element;
		            options = that.options;
	
		            options.min = parse(element.attr("min")) || parse(options.min);
		            options.max = parse(element.attr("max")) || parse(options.max);
	
		            normalize(options);
	
		            that._initialOptions = extend({}, options);
	
		            that._wrapper();
	
		            that.timeView = timeView = new TimeView(extend({}, options, {
		                id: element.attr(ID),
		                anchor: that.wrapper,
		                format: options.format,
		                change: function(value, trigger) {
		                    if (trigger) {
		                        that._change(value);
		                    } else {
		                        element.val(value);
		                    }
		                },
		                open: function(e) {
		                    that.timeView._adjustListWidth();
	
		                    if (that.trigger(OPEN)) {
		                        e.preventDefault();
		                    } else {
		                        element.attr(ARIA_EXPANDED, true);
		                        ul.attr(ARIA_HIDDEN, false);
		                    }
		                },
		                close: function(e) {
		                    if (that.trigger(CLOSE)) {
		                        e.preventDefault();
		                    } else {
		                        element.attr(ARIA_EXPANDED, false);
		                        ul.attr(ARIA_HIDDEN, true);
		                    }
		                },
		                active: function(current) {
		                    element.removeAttr(ARIA_ACTIVEDESCENDANT);
		                    if (current) {
		                        element.attr(ARIA_ACTIVEDESCENDANT, timeView._optionID);
		                    }
		                }
		            }));
		            ul = timeView.ul;
	
		            that._icon();
		            that._reset();
	
		            try {
		                element[0].setAttribute("type", "text");
		            } catch(e) {
		                element[0].type = "text";
		            }
	
		            element.addClass("k-input")
		                   .attr({
		                        "role": "combobox",
		                        "aria-expanded": false,
		                        "aria-owns": timeView._timeViewID,
		                        "autocomplete": "off"
		                   });
	
		            disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
		            if (disabled) {
		                that.enable(false);
		            } else {
		                that.readonly(element.is("[readonly]"));
		            }
		            if (options.dateInput) {
		                var min = options.min;
		                var max = options.max;
		                var today = new DATE();
		                if (getMilliseconds(min) == getMilliseconds(max)) {
		                    min = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
		                    max = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 24, 0, 0);
		                }
	
		                that._dateInput = new ui.DateInput(element, {
		                    culture: options.culture,
		                    format: options.format,
		                    min: min,
		                    max: max,
		                    value: options.value
		                });
		            }
		            that._old = that._update(options.value || that.element.val());
		            that._oldText = element.val();
	
		            kendo.notify(that);
		        },
	
		        options: {
		            name: "TimePicker",
		            min: TODAY,
		            max: TODAY,
		            format: "",
		            dates: [],
		            parseFormats: [],
		            value: null,
		            interval: 30,
		            height: 200,
		            animation: {},
		            dateInput: false
		        },
	
		        events: [
		         OPEN,
		         CLOSE,
		         CHANGE
		        ],
	
		        setOptions: function(options) {
		            var that = this;
		            var value = that._value;
	
		            Widget.fn.setOptions.call(that, options);
		            options = that.options;
	
		            normalize(options);
	
		            that.timeView.setOptions(options);
	
		            if (value) {
		                that.element.val(kendo.toString(value, options.format, options.culture));
		            }
		        },
	
		        dataBind: function(dates) {
		            if (isArray(dates)) {
		                this.timeView.dataBind(dates);
		            }
		        },
	
		        _editable: function(options) {
		            var that = this,
		                disable = options.disable,
		                readonly = options.readonly,
		                arrow = that._arrow.off(ns),
		                element = that.element.off(ns),
		                wrapper = that._inputWrapper.off(ns);
	
		            if (!readonly && !disable) {
		                wrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                element.removeAttr(DISABLED)
		                       .removeAttr(READONLY)
		                       .attr(ARIA_DISABLED, false)
		                       .on("keydown" + ns, proxy(that._keydown, that))
		                       .on("focusout" + ns, proxy(that._blur, that))
		                       .on("focus" + ns, function() {
		                           that._inputWrapper.addClass(FOCUSED);
		                       });
	
		               arrow.on(CLICK, proxy(that._click, that))
		                   .on(MOUSEDOWN, preventDefault);
		            } else {
		                wrapper
		                    .addClass(disable ? STATEDISABLED : DEFAULT)
		                    .removeClass(disable ? DEFAULT : STATEDISABLED);
	
		                element.attr(DISABLED, disable)
		                       .attr(READONLY, readonly)
		                       .attr(ARIA_DISABLED, disable);
		            }
		        },
	
		        readonly: function(readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		        },
	
		        enable: function(enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.timeView.destroy();
	
		            that.element.off(ns);
		            that._arrow.off(ns);
		            that._inputWrapper.off(ns);
	
		            if (that._form) {
		                that._form.off("reset", that._resetHandler);
		            }
		        },
	
		        close: function() {
		            this.timeView.close();
		        },
	
		        open: function() {
		            this.timeView.open();
		        },
	
		        min: function (value) {
		            return this._option("min", value);
		        },
	
		        max: function (value) {
		            return this._option("max", value);
		        },
	
		        value: function(value) {
		            var that = this;
	
		            if (value === undefined) {
		                return that._value;
		            }
	
		            that._old = that._update(value);
	
		            if (that._old === null) {
		                that.element.val("");
		            }
	
		            that._oldText = that.element.val();
		        },
	
		        _blur: function() {
		            var that = this,
		                value = that.element.val();
	
		            that.close();
		            if (value !== that._oldText) {
		                that._change(value);
		            }
		            that._inputWrapper.removeClass(FOCUSED);
		        },
	
		        _click: function() {
		            var that = this,
		                element = that.element;
	
		            that.timeView.toggle();
	
		            if (!support.touch && element[0] !== activeElement()) {
		                element.focus();
		            }
		        },
	
		        _change: function(value) {
		            var that = this;
	
		            value = that._update(value);
	
		            if (+that._old != +value) {
		                that._old = value;
		                that._oldText = that.element.val();
	
		                if (!that._typing) {
		                    // trigger the DOM change event so any subscriber gets notified
		                    that.element.trigger(CHANGE);
		                }
	
		                that.trigger(CHANGE);
		            }
	
		            that._typing = false;
		        },
	
		        _icon: function() {
		            var that = this,
		                element = that.element,
		                arrow;
	
		            arrow = element.next("span.k-select");
	
		            if (!arrow[0]) {
		                arrow = $('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-clock"></span></span>').insertAfter(element);
		            }
	
		            that._arrow = arrow.attr({
		                "role": "button",
		                "aria-controls": that.timeView._timeViewID
		            });
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode,
		                timeView = that.timeView,
		                value = that.element.val();
	
		            if (timeView.popup.visible() || e.altKey) {
		                timeView.move(e);
		                if (that._dateInput && e.stopImmediatePropagation) {
		                    e.stopImmediatePropagation();
		                }
		            } else if (key === keys.ENTER && value !== that._oldText) {
		                that._change(value);
		            } else {
		                that._typing = true;
		            }
		        },
	
		        _option: function(option, value) {
		            var that = this,
		                options = that.options;
	
		            if (value === undefined) {
		                return options[option];
		            }
	
		            value = that.timeView._parse(value);
	
		            if (!value) {
		                return;
		            }
	
		            value = new DATE(+value);
	
		            options[option] = value;
		            that.timeView.options[option] = value;
		            that.timeView.bind();
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
		        },
	
		        _update: function(value) {
		            var that = this,
		                options = that.options,
		                timeView = that.timeView,
		                date = timeView._parse(value);
	
		            if (!isInRange(date, options.min, options.max)) {
		                date = null;
		            }
	
		            that._value = date;
		            if (that._dateInput && date) {
		                that._dateInput.value(date || value);
		            } else {
		                that.element.val(kendo.toString(date || value, options.format, options.culture));
		            }
		            timeView.value(date);
	
		            return date;
		        },
	
		        _wrapper: function() {
		            var that = this,
		                element = that.element,
		                wrapper;
	
		            wrapper = element.parents(".k-timepicker");
	
		            if (!wrapper[0]) {
		                wrapper = element.wrap(SPAN).parent().addClass("k-picker-wrap k-state-default");
		                wrapper = wrapper.wrap(SPAN).parent();
		            }
	
		            wrapper[0].style.cssText = element[0].style.cssText;
		            that.wrapper = wrapper.addClass("k-widget k-timepicker")
		                .addClass(element[0].className);
	
		            element.css({
		                width: "100%",
		                height: element[0].style.height
		            });
	
		            that._inputWrapper = $(wrapper[0].firstChild);
		        },
	
		        _reset: function() {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    that.value(element[0].defaultValue);
		                    that.max(that._initialOptions.max);
		                    that.min(that._initialOptions.min);
		                };
	
		                that._form = form.on("reset", that._resetHandler);
		            }
		        }
		    });
	
		    function normalize(options) {
		        var parseFormats = options.parseFormats;
	
		        options.format = extractFormat(options.format || kendo.getCulture(options.culture).calendars.standard.patterns.t);
	
		        parseFormats = isArray(parseFormats) ? parseFormats : [parseFormats];
		        parseFormats.splice(0, 0, options.format);
		        options.parseFormats = parseFormats;
		    }
	
		    function preventDefault(e) {
		        e.preventDefault();
		    }
	
		    ui.plugin(TimePicker);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1256);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1256:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1038) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "numerictextbox",
		    name: "NumericTextBox",
		    category: "web",
		    description: "The NumericTextBox widget can format and display numeric, percentage or currency textbox.",
		    depends: [ "core", "userevents" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        caret = kendo.caret,
		        keys = kendo.keys,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        activeElement = kendo._activeElement,
		        extractFormat = kendo._extractFormat,
		        parse = kendo.parseFloat,
		        placeholderSupported = kendo.support.placeholder,
		        getCulture = kendo.getCulture,
		        CHANGE = "change",
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        INPUT = "k-input",
		        SPIN = "spin",
		        ns = ".kendoNumericTextBox",
		        TOUCHEND = "touchend",
		        MOUSELEAVE = "mouseleave" + ns,
		        HOVEREVENTS = "mouseenter" + ns + " " + MOUSELEAVE,
		        DEFAULT = "k-state-default",
		        FOCUSED = "k-state-focused",
		        HOVER = "k-state-hover",
		        FOCUS = "focus",
		        POINT = ".",
		        CLASS_ICON = "k-icon",
		        SELECTED = "k-state-selected",
		        STATEDISABLED = "k-state-disabled",
		        STATE_INVALID = "k-state-invalid",
		        ARIA_DISABLED = "aria-disabled",
		        INTEGER_REGEXP = /^(-)?(\d*)$/,
		        NULL = null,
		        proxy = $.proxy,
		        extend = $.extend;
	
		    var NumericTextBox = Widget.extend({
		         init: function(element, options) {
		             var that = this,
		             isStep = options && options.step !== undefined,
		             min, max, step, value, disabled;
		             var inputType;
	
		             Widget.fn.init.call(that, element, options);
	
		             options = that.options;
		             element = that.element
		                           .on("focusout" + ns, proxy(that._focusout, that))
		                           .attr("role", "spinbutton");
	
		             options.placeholder = options.placeholder || element.attr("placeholder");
	
		             min = that.min(element.attr("min"));
		             max = that.max(element.attr("max"));
		             step = that._parse(element.attr("step"));
	
		             if (options.min === NULL && min !== NULL) {
		                 options.min = min;
		             }
	
		             if (options.max === NULL && max !== NULL) {
		                 options.max = max;
		             }
	
		             if (!isStep && step !== NULL) {
		                 options.step = step;
		             }
	
		             that._initialOptions = extend({}, options);
	
		             inputType = element.attr("type");
	
		             that._reset();
		             that._wrapper();
		             that._arrows();
		             that._validation();
		             that._input();
	
		             if (!kendo.support.mobileOS) {
		                 that._text.on(FOCUS + ns, proxy(that._click, that));
		             } else {
		                 that._text.on(TOUCHEND + ns + " " + FOCUS + ns, function() {
		                     if (kendo.support.browser.edge) {
		                         that._text.one(FOCUS + ns, function() {
		                             that._toggleText(false);
		                             element.focus();
		                         });
		                     } else {
		                         that._toggleText(false);
		                         element.focus();
		                     }
		                 });
		             }
	
		             element.attr("aria-valuemin", options.min !== NULL ? options.min*options.factor : options.min)
		                    .attr("aria-valuemax", options.max !== NULL ? options.max*options.factor : options.max);
	
		             options.format = extractFormat(options.format);
	
		             value = options.value;
	
		             if (value == NULL) {
		                 if (inputType == "number") {
		                    value = parseFloat(element.val());
		                 } else {
		                     value = element.val();
		                 }
		             }
	
		             that.value(value);
	
		             disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
	
		             if (disabled) {
		                 that.enable(false);
		             } else {
		                 that.readonly(element.is("[readonly]"));
		             }
	
		             kendo.notify(that);
		         },
	
		        options: {
		            name: "NumericTextBox",
		            decimals: NULL,
		            restrictDecimals: false,
		            min: NULL,
		            max: NULL,
		            value: NULL,
		            step: 1,
		            round: true,
		            culture: "",
		            format: "n",
		            spinners: true,
		            placeholder: "",
		            factor: 1,
		            upArrowText: "Increase value",
		            downArrowText: "Decrease value"
		        },
		        events: [
		            CHANGE,
		            SPIN
		        ],
	
		        _editable: function(options) {
		            var that = this,
		                element = that.element,
		                disable = options.disable,
		                readonly = options.readonly,
		                text = that._text.add(element),
		                wrapper = that._inputWrapper.off(HOVEREVENTS);
	
		            that._toggleText(true);
	
		            that._upArrowEventHandler.unbind("press");
		            that._downArrowEventHandler.unbind("press");
		            element
		                .off("keydown" + ns)
		                .off("keypress" + ns)
		                .off("keyup" + ns)
		                .off("paste" + ns);
	
		            if (!readonly && !disable) {
		                wrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                text.removeAttr(DISABLED)
		                    .removeAttr(READONLY)
		                    .attr(ARIA_DISABLED, false);
	
		                that._upArrowEventHandler.bind("press", function(e) {
		                    e.preventDefault();
		                    that._spin(1);
		                    that._upArrow.addClass(SELECTED);
		                });
	
		                that._downArrowEventHandler.bind("press", function(e) {
		                    e.preventDefault();
		                    that._spin(-1);
		                    that._downArrow.addClass(SELECTED);
		                });
	
		                that.element
		                    .on("keydown" + ns, proxy(that._keydown, that))
		                    .on("keypress" + ns, proxy(that._keypress, that))
		                    .on("keyup" + ns, proxy(that._keyup, that))
		                    .on("paste" + ns, proxy(that._paste, that));
	
		            } else {
		                wrapper
		                    .addClass(disable ? STATEDISABLED : DEFAULT)
		                    .removeClass(disable ? DEFAULT : STATEDISABLED);
	
		                text.attr(DISABLED, disable)
		                    .attr(READONLY, readonly)
		                    .attr(ARIA_DISABLED, disable);
		            }
		        },
	
		        readonly: function(readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		        },
	
		        enable: function(enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		        },
	
		        setOptions: function (options) {
		            var that = this;
		            Widget.fn.setOptions.call(that, options);
	
		            that._arrowsWrap.toggle(that.options.spinners);
		            that._inputWrapper.toggleClass("k-expand-padding", !that.options.spinners);
		            that._text.prop("placeholder", that.options.placeholder);
		            that._placeholder(that.options.placeholder);
		            that.element.attr({
		                "aria-valuemin": that.options.min !== NULL ? that.options.min*that.options.factor : that.options.min,
		                "aria-valuemax": that.options.max !== NULL ? that.options.max*that.options.factor : that.options.max
		            });
	
		            that.options.format = extractFormat(that.options.format);
	
		            if (options.value !== undefined) {
		                that.value(options.value);
		            }
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.element
		                .add(that._text)
		                .add(that._upArrow)
		                .add(that._downArrow)
		                .add(that._inputWrapper)
		                .off(ns);
	
		            that._upArrowEventHandler.destroy();
		            that._downArrowEventHandler.destroy();
	
		            if (that._form) {
		                that._form.off("reset", that._resetHandler);
		            }
	
		            Widget.fn.destroy.call(that);
		        },
	
		        min: function(value) {
		            return this._option("min", value);
		        },
	
		        max: function(value) {
		            return this._option("max", value);
		        },
	
		        step: function(value) {
		            return this._option("step", value);
		        },
	
		        value: function(value) {
		            var that = this, adjusted;
	
		            if (value === undefined) {
		                return that._value;
		            }
	
		            value = that._parse(value);
		            adjusted = that._adjust(value);
	
		            if (value !== adjusted) {
		                return;
		            }
	
		            that._update(value);
		            that._old = that._value;
		        },
	
		        focus: function() {
		            this._focusin();
		        },
	
		        _adjust: function(value) {
		            var that = this,
		            options = that.options,
		            min = options.min,
		            max = options.max;
	
		            if (value === NULL) {
		                return value;
		            }
	
		            if (min !== NULL && value < min) {
		                value = min;
		            } else if (max !== NULL && value > max) {
		                value = max;
		            }
	
		            return value;
		        },
	
		        _arrows: function() {
		            var that = this,
		            arrows,
		            _release = function() {
		                clearTimeout( that._spinning );
		                arrows.removeClass(SELECTED);
		            },
		            options = that.options,
		            spinners = options.spinners,
		            element = that.element;
	
		            arrows = element.siblings("." + CLASS_ICON);
	
		            if (!arrows[0]) {
		                arrows = $(buttonHtml("increase", options.upArrowText) + buttonHtml("decrease", options.downArrowText))
		                        .insertAfter(element);
	
		                that._arrowsWrap = arrows.wrapAll('<span class="k-select"/>').parent();
		            }
	
		            if (!spinners) {
		                arrows.parent().toggle(spinners);
		                that._inputWrapper.addClass("k-expand-padding");
		            }
	
		            that._upArrow = arrows.eq(0);
		            that._upArrowEventHandler = new kendo.UserEvents(that._upArrow, { release: _release });
		            that._downArrow = arrows.eq(1);
		            that._downArrowEventHandler = new kendo.UserEvents(that._downArrow, { release: _release });
		        },
	
		        _validation: function () {
		            var that = this;
		            var element = that.element;
	
		            that._validationIcon = $("<span class='" + CLASS_ICON + " k-i-warning'></span>")
		                .hide()
		                .insertAfter(element);
		        },
	
		        _blur: function() {
		            var that = this;
	
		            that._toggleText(true);
	
		            that._change(that.element.val());
		        },
	
		        _click: function(e) {
		            var that = this;
	
		            clearTimeout(that._focusing);
		            that._focusing = setTimeout(function() {
		                var input = e.target,
		                    idx = caret(input)[0],
		                    value = input.value.substring(0, idx),
		                    format = that._format(that.options.format),
		                    group = format[","],
		                    result, groupRegExp, extractRegExp,
		                    caretPosition = 0;
	
		                if (group) {
		                    groupRegExp = new RegExp("\\" + group, "g");
		                    extractRegExp = new RegExp("([\\d\\" + group + "]+)(\\" + format[POINT] + ")?(\\d+)?");
		                }
	
		                if (extractRegExp) {
		                    result = extractRegExp.exec(value);
		                }
	
		                if (result) {
		                    caretPosition = result[0].replace(groupRegExp, "").length;
	
		                    if (value.indexOf("(") != -1 && that._value < 0) {
		                        caretPosition++;
		                    }
		                }
	
		                that._focusin();
	
		                caret(that.element[0], caretPosition);
		            });
		        },
	
		        _change: function(value) {
		            var that = this,
		                factor = that.options.factor;
	
		            if(factor && factor !== 1){
		                value = kendo.parseFloat(value);
		                if(value !== null) {
		                    value = value/factor;
		                }
		            }
	
		            that._update(value);
		            value = that._value;
	
		            if (that._old != value) {
		                that._old = value;
	
		                if (!that._typing) {
		                    // trigger the DOM change event so any subscriber gets notified
		                    that.element.trigger(CHANGE);
		                }
	
		                that.trigger(CHANGE);
		            }
	
		            that._typing = false;
		        },
	
		        _culture: function(culture) {
		            return culture || getCulture(this.options.culture);
		        },
	
		        _focusin: function() {
		            var that = this;
		            that._inputWrapper.addClass(FOCUSED);
		            that._toggleText(false);
		            that.element[0].focus();
		        },
	
		        _focusout: function() {
		            var that = this;
	
		            clearTimeout(that._focusing);
		            that._inputWrapper.removeClass(FOCUSED).removeClass(HOVER);
		            that._blur();
		            that._removeInvalidState();
		        },
	
		        _format: function(format, culture) {
		            var numberFormat = this._culture(culture).numberFormat;
	
		            format = format.toLowerCase();
	
		            if (format.indexOf("c") > -1) {
		                numberFormat = numberFormat.currency;
		            } else if (format.indexOf("p") > -1) {
		                numberFormat = numberFormat.percent;
		            }
	
		            return numberFormat;
		        },
	
		        _input: function() {
		            var that = this,
		                options = that.options,
		                CLASSNAME = "k-formatted-value",
		                element = that.element.addClass(INPUT).show()[0],
		                accessKey = element.accessKey,
		                wrapper = that.wrapper,
		                text;
	
		            text = wrapper.find(POINT + CLASSNAME);
	
		            if (!text[0]) {
		                text = $('<input type="text"/>').insertBefore(element).addClass(CLASSNAME);
		            }
	
		            try {
		                element.setAttribute("type", "text");
		            } catch(e) {
		                element.type = "text";
		            }
	
		            that._initialTitle = element.title;
		            text[0].title = element.title;
		            text[0].tabIndex = element.tabIndex;
		            text[0].style.cssText = element.style.cssText;
		            text.prop("placeholder", options.placeholder);
	
		            if (accessKey) {
		                text.attr("accesskey", accessKey);
		                element.accessKey = "";
		            }
	
	
		            that._text = text.addClass(element.className)
		                             .attr({
		                                 "role": "spinbutton",
		                                 "aria-valuemin": options.min !== NULL ? options.min*options.factor : options.min,
		                                 "aria-valuemax": options.max !== NULL ? options.max*options.factor : options.max,
		                                 "autocomplete": "off"
		                             });
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode;
	
		            that._key = key;
	
		            if (key == keys.DOWN) {
		                that._step(-1);
		            } else if (key == keys.UP) {
		                that._step(1);
		            } else if (key == keys.ENTER) {
		                that._change(that.element.val());
		            } else if (key != keys.TAB) {
		                that._typing = true;
		            }
	
		        },
	
		        _keypress: function(e) {
		            if (e.which === 0 || e.metaKey || e.ctrlKey || e.keyCode === keys.BACKSPACE || e.keyCode === keys.ENTER) {
		                return;
		            }
	
		            var that = this;
		            var min = that.options.min;
		            var element = that.element;
		            var selection = caret(element);
		            var selectionStart = selection[0];
		            var selectionEnd = selection[1];
		            var character = String.fromCharCode(e.which);
		            var numberFormat = that._format(that.options.format);
		            var isNumPadDecimal = that._key === keys.NUMPAD_DOT;
		            var value = element.val();
		            var isValid;
	
		            if (isNumPadDecimal) {
		                character = numberFormat[POINT];
		            }
	
		            value = value.substring(0, selectionStart) + character + value.substring(selectionEnd);
		            isValid = that._numericRegex(numberFormat).test(value);
	
		            if (isValid && isNumPadDecimal) {
		                element.val(value);
		                caret(element, selectionStart + character.length);
	
		                e.preventDefault();
		            } else if ((min !== null && min >= 0 && value.charAt(0) === "-") || !isValid) {
		                that._addInvalidState();
		                e.preventDefault();
		            }
	
		            that._key = 0;
		        },
	
		        _keyup: function () {
		            this._removeInvalidState();
		        },
	
		        _addInvalidState: function () {
		            var that = this;
		            that._inputWrapper.addClass(STATE_INVALID);
		            that._validationIcon.show();
		        },
	
		        _removeInvalidState: function () {
		            var that = this;
		            that._inputWrapper.removeClass(STATE_INVALID);
		            that._validationIcon.hide();
		        },
	
		        _numericRegex: function(numberFormat) {
		            var that = this;
		            var separator = numberFormat[POINT];
		            var precision = that.options.decimals;
		            var fractionRule = "*";
	
		            if (separator === POINT) {
		                separator = "\\" + separator;
		            }
	
		            if (precision === NULL) {
		                precision = numberFormat.decimals;
		            }
	
		            if (precision === 0 && that.options.restrictDecimals) {
		                return INTEGER_REGEXP;
		            }
	
		            if (that.options.restrictDecimals) {
		                fractionRule = "{0," + precision + "}";
		            }
	
		            if (that._separator !== separator) {
		                that._separator = separator;
		                that._floatRegExp = new RegExp("^(-)?(((\\d+(" + separator + "\\d" + fractionRule + ")?)|(" + separator + "\\d" + fractionRule + ")))?$");
		            }
	
		            return that._floatRegExp;
		        },
	
		        _paste: function(e) {
		            var that = this;
		            var element = e.target;
		            var value = element.value;
		            var numberFormat = that._format(that.options.format);
	
		            setTimeout(function() {
		                var result = that._parse(element.value);
	
		                if (result === NULL) {
		                    that._update(value);
		                } else {
		                    element.value = result.toString().replace(POINT, numberFormat[POINT]);
		                    if (that._adjust(result) !== result || !that._numericRegex(numberFormat).test(element.value)) {
		                        that._update(value);
		                    }
		                }
		            });
		        },
	
		        _option: function(option, value) {
		            var that = this,
		                element = that.element,
		                options = that.options;
	
		            if (value === undefined) {
		                return options[option];
		            }
	
		            value = that._parse(value);
	
		            if (!value && option === "step") {
		                return;
		            }
	
		            options[option] = value;
		            element
		                .add(that._text)
		                .attr("aria-value" + option, value);
	
		            element.attr(option, value);
		        },
	
		        _spin: function(step, timeout) {
		            var that = this;
	
		            timeout = timeout || 500;
	
		            clearTimeout( that._spinning );
		            that._spinning = setTimeout(function() {
		                that._spin(step, 50);
		            }, timeout );
	
		            that._step(step);
		        },
	
		        _step: function(step) {
		            var that = this,
		                element = that.element,
		                originalValue = that._value,
		                value = that._parse(element.val()) || 0,
		                precision = that.options.decimals || 2;
	
		            if (activeElement() != element[0]) {
		                that._focusin();
		            }
	
		            if(that.options.factor && value) {
		                value = value/that.options.factor;
		            }
	
		            value =  +(value + that.options.step * step).toFixed(precision);
		            value = that._adjust(value);
		            that._update(value);
		            that._typing = false;
	
		            if (originalValue !== value) {
		                that.trigger(SPIN);
		            }
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
		        },
	
		        _toggleText: function(toggle) {
		            var that = this;
	
		            that._text.toggle(toggle);
		            that.element.toggle(!toggle);
		        },
	
		        _parse: function(value, culture) {
		            return parse(value, this._culture(culture), this.options.format);
		        },
	
		        _round: function(value, precision) {
		            var rounder = this.options.round ? kendo._round : truncate;
	
		            return rounder(value, precision);
		        },
	
		        _update: function(value) {
		            var that = this,
		                options = that.options,
		                factor = options.factor,
		                format = options.format,
		                decimals = options.decimals,
		                culture = that._culture(),
		                numberFormat = that._format(format, culture),
		                isNotNull;
	
		            if (decimals === NULL) {
		                decimals = numberFormat.decimals;
		            }
	
		            value = that._parse(value, culture);
	
		            isNotNull = value !== NULL;
	
		            if (isNotNull) {
		                value = parseFloat(that._round(value, decimals), 10);
		            }
	
		            that._value = value = that._adjust(value);
		            that._placeholder(kendo.toString(value, format, culture));
	
		            if (isNotNull) {
		                if(factor) {
		                    value =  parseFloat(that._round(value*factor, decimals), 10);
		                }
		                value = value.toString();
		                if (value.indexOf("e") !== -1) {
		                    value = that._round(+value, decimals);
		                }
		                value = value.replace(POINT, numberFormat[POINT]);
		            } else {
		                value = null;
		            }
	
		            that.element.val(value);
		            that.element.add(that._text).attr("aria-valuenow", value);
		        },
	
		        _placeholder: function(value) {
		            var input = this._text;
	
		            input.val(value);
		            if (!placeholderSupported && !value) {
		                input.val(this.options.placeholder);
		            }
	
		            input.attr("title", this._initialTitle || input.val());
		        },
	
		        _wrapper: function() {
		            var that = this,
		                element = that.element,
		                DOMElement = element[0],
		                wrapper;
	
		            wrapper = element.parents(".k-numerictextbox");
	
		            if (!wrapper.is("span.k-numerictextbox")) {
		                wrapper = element.hide().wrap('<span class="k-numeric-wrap k-state-default" />').parent();
		                wrapper = wrapper.wrap("<span/>").parent();
		            }
	
		            wrapper[0].style.cssText = DOMElement.style.cssText;
		            DOMElement.style.width = "";
		            that.wrapper = wrapper.addClass("k-widget k-numerictextbox")
		                                  .addClass(DOMElement.className)
		                                  .css("display", "");
	
		            that._inputWrapper = $(wrapper[0].firstChild);
		        },
	
		        _reset: function() {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    setTimeout(function() {
		                        that.value(element[0].value);
		                        that.max(that._initialOptions.max);
		                        that.min(that._initialOptions.min);
		                    });
		                };
	
		                that._form = form.on("reset", that._resetHandler);
		            }
		        }
		    });
	
		    function buttonHtml(direction, text) {
		        var className = "k-i-arrow-" + (direction === "increase" ? "60-up" : "60-down");
	
		        return (
		            '<span unselectable="on" class="k-link k-link-' + direction + '" aria-label="' + text + '" title="' + text + '">' +
		                '<span unselectable="on" class="' + CLASS_ICON + ' ' + className + '"></span>' +
		            '</span>'
		        );
		    }
	
		    function truncate(value, precision) {
		        var parts = parseFloat(value, 10).toString().split(POINT);
	
		        if (parts[1]) {
		            parts[1] = parts[1].substring(0, precision);
		        }
	
		        return parts.join(POINT);
	
		    }
	
		    ui.plugin(NumericTextBox);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1272);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1272:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "resizable",
		    name: "Resizable",
		    category: "framework",
		    depends: [ "core", "draganddrop" ],
		    advanced: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        proxy = $.proxy,
		        isFunction = kendo.isFunction,
		        extend = $.extend,
		        HORIZONTAL = "horizontal",
		        VERTICAL = "vertical",
		        START = "start",
		        RESIZE = "resize",
		        RESIZEEND = "resizeend";
	
		    var Resizable = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            that.orientation = that.options.orientation.toLowerCase() != VERTICAL ? HORIZONTAL : VERTICAL;
		            that._positionMouse = that.orientation == HORIZONTAL ? "x" : "y";
		            that._position = that.orientation == HORIZONTAL ? "left" : "top";
		            that._sizingDom = that.orientation == HORIZONTAL ? "outerWidth" : "outerHeight";
	
		            that.draggable = new ui.Draggable(options.draggableElement || element, {
		                distance: 1,
		                filter: options.handle,
		                drag: proxy(that._resize, that),
		                dragcancel: proxy(that._cancel, that),
		                dragstart: proxy(that._start, that),
		                dragend: proxy(that._stop, that)
		            });
	
		            that.userEvents = that.draggable.userEvents;
		        },
	
		        events: [
		            RESIZE,
		            RESIZEEND,
		            START
		        ],
	
		        options: {
		            name: "Resizable",
		            orientation: HORIZONTAL
		        },
	
		        resize: function() {
		            // Overrides base widget resize
		        },
	
		        _max: function(e) {
		            var that = this,
		                hintSize = that.hint ? that.hint[that._sizingDom]() : 0,
		                size = that.options.max;
	
		            return isFunction(size) ? size(e) : size !== undefined ? (that._initialElementPosition + size) - hintSize : size;
		        },
	
		        _min: function(e) {
		            var that = this,
		                size = that.options.min;
	
		            return isFunction(size) ? size(e) : size !== undefined ? that._initialElementPosition + size : size;
		        },
	
		        _start: function(e) {
		            var that = this,
		                hint = that.options.hint,
		                el = $(e.currentTarget);
	
		            that._initialElementPosition = el.position()[that._position];
		            that._initialMousePosition = e[that._positionMouse].startLocation;
	
		            if (hint) {
		                that.hint = isFunction(hint) ? $(hint(el)) : hint;
	
		                that.hint.css({
		                    position: "absolute"
		                })
		                .css(that._position, that._initialElementPosition)
		                .appendTo(that.element);
		            }
	
		            that.trigger(START, e);
	
		            that._maxPosition = that._max(e);
		            that._minPosition = that._min(e);
	
		            $(document.body).css("cursor", el.css("cursor"));
		        },
	
		        _resize: function(e) {
		            var that = this,
		                maxPosition = that._maxPosition,
		                minPosition = that._minPosition,
		                currentPosition = that._initialElementPosition + (e[that._positionMouse].location - that._initialMousePosition),
		                position;
	
		            position = minPosition !== undefined ? Math.max(minPosition, currentPosition) : currentPosition;
		            that.position = position =  maxPosition !== undefined ? Math.min(maxPosition, position) : position;
	
		            if(that.hint) {
		                that.hint.toggleClass(that.options.invalidClass || "", position == maxPosition || position == minPosition)
		                         .css(that._position, position);
		            }
	
		            that.resizing = true;
		            that.trigger(RESIZE, extend(e, { position: position }));
		        },
	
		        _stop: function(e) {
		            var that = this;
	
		            if(that.hint) {
		                that.hint.remove();
		            }
	
		            that.resizing = false;
		            that.trigger(RESIZEEND, extend(e, { position: that.position }));
		            $(document.body).css("cursor", "");
		        },
	
		        _cancel: function(e) {
		            var that = this;
	
		            if (that.hint) {
		                that.position = undefined;
		                that.hint.css(that._position, that._initialElementPosition);
		                that._stop(e);
		            }
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            if (that.draggable) {
		                that.draggable.destroy();
		            }
		        },
	
		        press: function(target) {
		            if (!target) {
		                return;
		            }
	
		            var position = target.position(),
		                that = this;
	
		            that.userEvents.press(position.left, position.top, target[0]);
		            that.targetPosition = position;
		            that.target = target;
		        },
	
		        move: function(delta) {
		            var that = this,
		                orientation = that._position,
		                position = that.targetPosition,
		                current = that.position;
	
		            if (current === undefined) {
		                current = position[orientation];
		            }
	
		            position[orientation] = current + delta;
	
		            that.userEvents.move(position.left, position.top);
		        },
	
		        end: function() {
		            this.userEvents.end();
		            this.target = this.position = undefined;
		        }
		    });
	
		    kendo.ui.plugin(Resizable);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1368);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1368:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1036)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    var __meta__ = { // jshint ignore:line
		        id: "window",
		        name: "Window",
		        category: "web",
		        description: "The Window widget displays content in a modal or non-modal HTML window.",
		        depends: [ "draganddrop", "popup" ],
		        features: [ {
		            id: "window-fx",
		            name: "Animation",
		            description: "Support for animation",
		            depends: [ "fx" ]
		        } ]
		    };
	
		    (function($, undefined) {
		        var kendo = window.kendo,
		            Widget = kendo.ui.Widget,
		            TabKeyTrap = kendo.ui.Popup.TabKeyTrap,
		            Draggable = kendo.ui.Draggable,
		            isPlainObject = $.isPlainObject,
		            activeElement = kendo._activeElement,
		            outerWidth = kendo._outerWidth,
		            outerHeight = kendo._outerHeight,
		            proxy = $.proxy,
		            extend = $.extend,
		            each = $.each,
		            template = kendo.template,
		            BODY = "body",
		            templates,
		            NS = ".kendoWindow",
		            MODAL_NS = ".kendoWindowModal",
		            // classNames
		            KWINDOW = ".k-window",
		            KWINDOWTITLE = ".k-window-title",
		            KWINDOWTITLEBAR = KWINDOWTITLE + "bar",
		            KWINDOWCONTENT = ".k-window-content",
		            KDIALOGCONTENT = ".k-dialog-content",
		            KWINDOWRESIZEHANDLES = ".k-resize-handle",
		            KOVERLAY = ".k-overlay",
		            KCONTENTFRAME = "k-content-frame",
		            LOADING = "k-i-loading",
		            KHOVERSTATE = "k-state-hover",
		            KFOCUSEDSTATE = "k-state-focused",
		            MAXIMIZEDSTATE = "k-window-maximized",
		            // constants
		            VISIBLE = ":visible",
		            HIDDEN = "hidden",
		            CURSOR = "cursor",
		            // events
		            OPEN = "open",
		            ACTIVATE = "activate",
		            DEACTIVATE = "deactivate",
		            CLOSE = "close",
		            REFRESH = "refresh",
		            MINIMIZE = "minimize",
		            MAXIMIZE = "maximize",
		            RESIZESTART = "resizeStart",
		            RESIZE = "resize",
		            RESIZEEND = "resizeEnd",
		            DRAGSTART = "dragstart",
		            DRAGEND = "dragend",
		            ERROR = "error",
		            OVERFLOW = "overflow",
		            DATADOCOVERFLOWRULE = "original-overflow-rule",
		            ZINDEX = "zIndex",
		            MINIMIZE_MAXIMIZE = ".k-window-actions .k-i-window-minimize,.k-window-actions .k-i-window-maximize",
		            KPIN = ".k-i-pin",
		            KUNPIN = ".k-i-unpin",
		            PIN_UNPIN = KPIN + "," + KUNPIN,
		            TITLEBAR_BUTTONS = ".k-window-titlebar .k-window-action",
		            REFRESHICON = ".k-window-titlebar .k-i-refresh",
		            WINDOWEVENTSHANDLED = "WindowEventsHandled",
		            zero = /^0[a-z]*$/i,
		            isLocalUrl = kendo.isLocalUrl;
	
		        function defined(x) {
		            return (typeof x != "undefined");
		        }
	
		        function toInt(element, property) {
		            return parseInt(element.css(property), 10) || 0;
		        }
	
		        function constrain(value, low, high) {
		            return Math.max(Math.min(parseInt(value, 10), high === Infinity ? high : parseInt(high, 10)), low === -Infinity ? low : parseInt(low, 10));
		        }
	
		        function executableScript() {
		            return !this.type || this.type.toLowerCase().indexOf("script") >= 0;
		        }
	
	
		        function getPosition(elem) {
		            var result = { top: elem.offsetTop, left: elem.offsetLeft },
		                parent = elem.offsetParent;
	
		            while (parent) {
		                result.top += parent.offsetTop;
		                result.left += parent.offsetLeft;
	
		                var parentOverflowX = $(parent).css("overflowX");
		                var parentOverflowY = $(parent).css("overflowY");
	
		                if (parentOverflowY === "auto" || parentOverflowY === "scroll") {
		                    result.top -= parent.scrollTop;
		                }
	
		                if (parentOverflowX === "auto" || parentOverflowX === "scroll") {
		                    result.left -= parent.scrollLeft;
		                }
	
		                parent = parent.offsetParent;
		            }
	
		            return result;
		        }
	
		        var Window = Widget.extend({
		            init: function(element, options) {
		                var that = this,
		                    wrapper,
		                    offset = {},
		                    visibility, display, position,
		                    isVisible = false,
		                    content,
		                    windowContent,
		                    windowFrame,
		                    globalWindow,
		                    suppressActions = options && options.actions && !options.actions.length,
		                    id;
	
		                Widget.fn.init.call(that, element, options);
		                options = that.options;
		                position = options.position;
		                element = that.element;
		                content = options.content;
		                globalWindow = $(window);
	
		                if (suppressActions) {
		                    options.actions = [];
		                }
	
		                that.appendTo = $(options.appendTo);
	
		                that.containment = options.draggable.containment ? $(options.draggable.containment).first() : null;
	
		                if (content && !isPlainObject(content)) {
		                    content = options.content = { url: content };
		                }
	
		                // remove script blocks to prevent double-execution
		                element.find("script").filter(executableScript).remove();
	
		                if (!element.parent().is(that.appendTo) && !that.containment && (position.top === undefined || position.left === undefined)) {
		                    if (element.is(VISIBLE)) {
		                        offset = element.offset();
		                        isVisible = true;
		                    } else {
		                        visibility = element.css("visibility");
		                        display = element.css("display");
	
		                        element.css({ visibility: HIDDEN, display: "" });
		                        offset = element.offset();
		                        element.css({ visibility: visibility, display: display });
		                    }
	
		                    if (position.top === undefined) {
		                        position.top = offset.top;
		                    }
		                    if (position.left === undefined) {
		                        position.left = offset.left;
		                    }
		                }
	
		                if (!defined(options.visible) || options.visible === null) {
		                    options.visible = element.is(VISIBLE);
		                }
	
		                wrapper = that.wrapper = element.closest(KWINDOW);
	
		                if (!element.is(".k-content") || !wrapper[0]) {
		                    element.addClass("k-window-content k-content");
		                    that._createWindow(element, options);
		                    wrapper = that.wrapper = element.closest(KWINDOW);
	
		                    that.title(that.options.title);
		                    that._dimensions();
		                }
	
		                that.minTop = that.minLeft = -Infinity;
		                that.maxTop = that.maxLeft = Infinity;
		                that._position();
	
		                if (content) {
		                    that.refresh(content);
		                }
	
		                if (options.visible) {
		                    that.toFront();
		                }
	
		                windowContent = wrapper.children(KWINDOWCONTENT);
		                that._tabindex(windowContent);
	
		                if (options.visible && options.modal) {
		                    that._overlay(wrapper.is(VISIBLE)).css({ opacity: 0.5 });
		                }
	
		                wrapper
		                    .on("mouseenter" + NS, TITLEBAR_BUTTONS, proxy(that._buttonEnter, that))
		                    .on("mouseleave" + NS, TITLEBAR_BUTTONS, proxy(that._buttonLeave, that))
		                    .on("click" + NS, "> " + TITLEBAR_BUTTONS, proxy(that._windowActionHandler, that))
		                    .on("keydown" + NS, proxy(that._keydown, that))
		                    .on("focus" + NS, proxy(that._focus, that))
		                    .on("blur" + NS, proxy(that._blur, that));
	
		                windowContent
		                    .on("keydown" + NS, proxy(that._keydown, that))
		                    .on("focus" + NS, proxy(that._focus, that))
		                    .on("blur" + NS, proxy(that._blur, that));
	
		                windowFrame = windowContent.find("." + KCONTENTFRAME)[0];
	
		                if(windowFrame && !globalWindow.data(WINDOWEVENTSHANDLED)){
	
		                    globalWindow.on("blur" + NS, function(){
		                        var element = $(document.activeElement).parent(KWINDOWCONTENT);
		                        if (element.length) {
		                            var windowInstance = kendo.widgetInstance(element);
		                            windowInstance._focus();
		                        }
		                    });
	
		                    globalWindow.on("focus" + NS, function(){
		                        $(KWINDOWCONTENT).not(KDIALOGCONTENT).each(function(i, element){
		                            kendo.widgetInstance($(element))._blur();
		                        });
		                    });
	
		                    globalWindow.data(WINDOWEVENTSHANDLED, true);
		                }
	
		                this._resizable();
	
		                this._draggable();
	
		                if (options.pinned && this.wrapper.is(":visible")) {
		                    that.pin();
		                }
	
		                id = element.attr("id");
		                if (id) {
		                    id = id + "_wnd_title";
		                    wrapper.children(KWINDOWTITLEBAR)
		                        .children(KWINDOWTITLE)
		                        .attr("id", id);
	
		                    windowContent
		                        .attr({
		                            "role": "dialog",
		                            "aria-labelledby": id
		                        });
		                }
	
		                wrapper.add(wrapper.children(".k-resize-handle," + KWINDOWTITLEBAR))
		                    .on("mousedown" + NS, proxy(that.toFront, that));
	
		                that.touchScroller = kendo.touchScroller(element);
	
		                that._resizeHandler = proxy(that._onDocumentResize, that);
	
		                that._marker = kendo.guid().substring(0, 8);
	
		                $(window).on("resize" + NS + that._marker, that._resizeHandler);
	
		                if (options.visible) {
		                    that.trigger(OPEN);
		                    that.trigger(ACTIVATE);
		                }
	
		                kendo.notify(that);
	
		                if(this.options.modal) {
		                    this._tabKeyTrap = new TabKeyTrap(wrapper);
		                    this._tabKeyTrap.trap();
		                    this._tabKeyTrap.shouldTrap = function () {
		                        return windowContent.data("isFront");
		                    };
		                }
		            },
	
		            _buttonEnter: function(e) {
		                $(e.currentTarget).addClass(KHOVERSTATE);
		            },
	
		            _buttonLeave: function(e) {
		                $(e.currentTarget).removeClass(KHOVERSTATE);
		            },
	
		            _focus: function() {
		                this.wrapper.addClass(KFOCUSEDSTATE);
		            },
	
		            _blur: function() {
		                this.wrapper.removeClass(KFOCUSEDSTATE);
		            },
	
		            _dimensions: function() {
		                var wrapper = this.wrapper;
		                var options = this.options;
		                var width = options.width;
		                var height = options.height;
		                var maxHeight = options.maxHeight;
		                var dimensions = ["minWidth","minHeight","maxWidth","maxHeight"];
		                var contentBoxSizing = wrapper.css("box-sizing") == "content-box";
	
		                var lrBorderWidth = contentBoxSizing ? toInt(wrapper, "border-left-width") + toInt(wrapper, "border-right-width") : 0;
		                var tbBorderWidth = contentBoxSizing ? toInt(wrapper, "border-top-width") + toInt(wrapper, "border-bottom-width") : 0;
		                var paddingTop = contentBoxSizing ? toInt(wrapper, "padding-top") : 0;
	
		                if (this.containment && !this._isPinned) {
		                    this._updateBoundaries();
		                    options.maxHeight = Math.min(this.containment.height - (tbBorderWidth + paddingTop), maxHeight);
		                    options.maxWidth = Math.min(this.containment.width - lrBorderWidth, options.maxWidth);
		                }
	
		                for (var i = 0; i < dimensions.length; i++) {
		                    var value = options[dimensions[i]] || "";
		                    if (value != Infinity) {
		                        wrapper.css(dimensions[i], value);
		                    }
		                }
	
		                if (maxHeight != Infinity) {
		                    this.element.css("maxHeight", maxHeight);
		                }
	
		                if (width) {
		                    if (isNaN(width) && width.toString().indexOf("px") < 0) {
		                        wrapper.width(width);
		                    } else {
		                        wrapper.width(constrain(width, options.minWidth, options.maxWidth));
		                    }
		                }
		                else {
		                    wrapper.width("");
		                }
	
		                if (height) {
		                    if (isNaN(height) && height.toString().indexOf("px") < 0) {
		                        wrapper.height(height);
		                    } else {
		                        wrapper.height(constrain(height, options.minHeight, options.maxHeight));
		                    }
		                }
		                else {
		                    wrapper.height("");
		                }
	
		                if (!options.visible) {
		                    wrapper.hide();
		                }
		            },
	
		            _position: function() {
		                var wrapper = this.wrapper,
		                    position = this.options.position;
	
		                this._updateBoundaries();
	
		                if (this.containment) {
		                    position.top = Math.min(this.minTop + (position.top || 0), this.maxTop);
		                    position.left = Math.min(this.minLeft + (position.left || 0), this.maxLeft);
		                }
	
		                if (position.top === 0) {
		                    position.top = position.top.toString();
		                }
	
		                if (position.left === 0) {
		                    position.left = position.left.toString();
		                }
	
		                wrapper.css({
		                    top: position.top || "",
		                    left: position.left || ""
		                });
		            },
	
		            _updateBoundaries: function() {
		                var containment = this.containment;
	
		                if (!containment) {
		                    return null;
		                }
	
		                containment.width = containment.innerWidth();
		                containment.height = containment.innerHeight();
	
		                if (parseInt(containment.width, 10) > containment[0].clientWidth) {
		                    containment.width -= kendo.support.scrollbar();
		                }
	
		                if (parseInt(containment.height, 10) > containment[0].clientHeight) {
		                    containment.height -= kendo.support.scrollbar();
		                }
	
		                containment.position = getPosition(containment[0]);
	
		                if (this._isPinned) {
		                    this.minTop = this.minLeft = -Infinity;
		                    this.maxTop = this.maxLeft = Infinity;
		                } else {
		                    this.minTop = containment.scrollTop();
		                    this.minLeft = containment.scrollLeft();
		                    this.maxLeft = this.minLeft + containment.width - outerWidth(this.wrapper, true);
		                    this.maxTop = this.minTop + containment.height - outerHeight(this.wrapper, true);
		                }
		            },
	
		            _animationOptions: function(id) {
		                var animation = this.options.animation;
		                var basicAnimation = {
		                    open: { effects: {} },
		                    close: { hide: true, effects: {} }
		                };
	
		                return animation && animation[id] || basicAnimation[id];
		            },
	
		            _resize: function() {
		                kendo.resize(this.element.children());
		            },
	
		            _resizable: function() {
		                var resizable = this.options.resizable;
		                var wrapper = this.wrapper;
	
		                if (this.resizing) {
		                    wrapper
		                        .off("dblclick" + NS)
		                        .children(KWINDOWRESIZEHANDLES).remove();
	
		                    this.resizing.destroy();
		                    this.resizing = null;
		                }
	
		                if (resizable) {
		                    wrapper.on("dblclick" + NS, KWINDOWTITLEBAR, proxy(function(e) {
		                        if (!$(e.target).closest(".k-window-action").length) {
		                            this.toggleMaximization();
		                        }
		                    }, this));
	
		                    each("n e s w se sw ne nw".split(" "), function(index, handler) {
		                        wrapper.append(templates.resizeHandle(handler));
		                    });
	
		                    this.resizing = new WindowResizing(this);
		                }
	
		                wrapper = null;
		            },
	
		            _draggable: function() {
		                var draggable = this.options.draggable;
	
		                if (this.dragging) {
		                    this.dragging.destroy();
		                    this.dragging = null;
		                }
		                if (draggable) {
		                    this.dragging = new WindowDragging(this, draggable.dragHandle || KWINDOWTITLEBAR);
		                }
		            },
	
		            _actions: function() {
		                var options = this.options;
		                var actions = options.actions;
		                var pinned = options.pinned;
		                var titlebar = this.wrapper.children(KWINDOWTITLEBAR);
		                var container = titlebar.find(".k-window-actions");
		                var windowSpecificCommands = [ "maximize", "minimize" ];
	
		                actions = $.map(actions, function(action) {
		                    action = pinned && action.toLowerCase() === "pin" ? "unpin" : action;
		                    return { name: (windowSpecificCommands.indexOf(action.toLowerCase()) > - 1) ? "window-" + action : action };
		                });
	
		                container.html(kendo.render(templates.action, actions));
		            },
	
		            setOptions: function(options) {
		                // make a deep extend over options.position telerik/kendo-ui-core#844
		                var cachedOptions = JSON.parse(JSON.stringify(options));
		                extend(options.position, this.options.position);
		                extend(options.position, cachedOptions.position);
	
		                Widget.fn.setOptions.call(this, options);
		                var scrollable = this.options.scrollable !== false;
	
		                this.restore();
	
		                if (typeof options.title !== "undefined") {
		                    this.title(options.title);
		                }
	
		                this._dimensions();
		                this._position();
		                this._resizable();
		                this._draggable();
		                this._actions();
		                if (typeof options.modal !== "undefined") {
		                    var visible = this.options.visible !== false;
	
		                    this._overlay(options.modal && visible);
		                }
	
		                this.element.css(OVERFLOW, scrollable ? "" : "hidden");
		            },
	
		            events:[
		                OPEN,
		                ACTIVATE,
		                DEACTIVATE,
		                CLOSE,
		                MINIMIZE,
		                MAXIMIZE,
		                REFRESH,
		                RESIZESTART,
		                RESIZE,
		                RESIZEEND,
		                DRAGSTART,
		                DRAGEND,
		                ERROR
		            ],
	
		            options: {
		                name: "Window",
		                animation: {
		                    open: {
		                        effects: { zoom: { direction: "in" }, fade: { direction: "in" } },
		                        duration: 350
		                    },
		                    close: {
		                        effects: { zoom: { direction: "out", properties: { scale: 0.7 } }, fade: { direction: "out" } },
		                        duration: 350,
		                        hide: true
		                    }
		                },
		                title: "",
		                actions: ["Close"],
		                autoFocus: true,
		                modal: false,
		                resizable: true,
		                draggable: true,
		                minWidth: 90,
		                minHeight: 50,
		                maxWidth: Infinity,
		                maxHeight: Infinity,
		                pinned: false,
		                scrollable: true,
		                position: {},
		                content: null,
		                visible: null,
		                height: null,
		                width: null,
		                appendTo: "body",
		                isMaximized: false,
		                isMinimized: false
		            },
	
		            _closable: function() {
		                return $.inArray("close", $.map(this.options.actions, function(x) { return x.toLowerCase(); })) > -1;
		            },
	
		            _keydown: function(e) {
		                var that = this,
		                    options = that.options,
		                    keys = kendo.keys,
		                    keyCode = e.keyCode,
		                    wrapper = that.wrapper,
		                    offset, handled,
		                    distance = 10,
		                    isMaximized = options.isMaximized,
		                    isMinimized = options.isMinimized,
		                    newWidth, newHeight, w, h;
	
		                if (keyCode == keys.ESC && that._closable()) {
		                    e.stopPropagation();
		                    that._close(false);
		                }
	
		                if (e.target != e.currentTarget || that._closing) {
		                    return;
		                }
	
		                 // Refresh
		                if (e.altKey && keyCode == 82) {// Alt + R
		                    that.refresh();
		                }
	
		                // Pin/Unpin
		                if (e.altKey && keyCode == 80) {// Alt + P
		                    if(that.options.pinned){
		                        that.unpin();
		                    } else {
		                        that.pin();
		                    }
		                }
	
		                // Maximize/Restore/Miminimize
		                if(e.altKey && keyCode == keys.UP){
		                    if (isMinimized) {
		                        that.restore();
		                        that.element.focus();
		                    } else if (!isMaximized) {
		                        that.maximize();
		                        that.element.focus();
		                    }
		                } else if (e.altKey && keyCode == keys.DOWN){
		                    if (!isMinimized && !isMaximized) {
		                        that.minimize();
		                        that.wrapper.focus();
		                    } else if (isMaximized) {
		                        that.restore();
		                        that.element.focus();
		                    }
		                }
	
		                offset = kendo.getOffset(wrapper);
	
		                if (that.containment && !that._isPinned) {
		                    offset = that.options.position;
		                }
	
		                if (options.draggable && !e.ctrlKey && !e.altKey && !isMaximized) {
		                    that._updateBoundaries();
		                    if (keyCode == keys.UP) {
		                        offset.top = constrain(offset.top - distance, that.minTop, that.maxTop);
		                        handled = wrapper.css("top", offset.top);
		                    } else if (keyCode == keys.DOWN) {
		                        offset.top = constrain(offset.top + distance, that.minTop, that.maxTop);
		                        handled = wrapper.css("top", offset.top);
		                    } else if (keyCode == keys.LEFT) {
		                        offset.left = constrain(offset.left - distance, that.minLeft, that.maxLeft);
		                        handled = wrapper.css("left", offset.left);
		                    } else if (keyCode == keys.RIGHT) {
		                        offset.left = constrain(offset.left + distance, that.minLeft, that.maxLeft);
		                        handled = wrapper.css("left", offset.left);
		                    }
		                }
	
		                if (options.resizable && e.ctrlKey && !isMaximized && !isMinimized) {
		                    if (keyCode == keys.UP) {
		                        handled = true;
		                        newHeight = wrapper.height() - distance;
		                    } else if (keyCode == keys.DOWN) {
		                        handled = true;
		                        if (that.containment && !that._isPinned) {
		                            newHeight = Math.min(wrapper.height() + distance,
		                                that.containment.height - offset.top - toInt(wrapper, "padding-top") -
		                                toInt(wrapper, "borderBottomWidth") - toInt(wrapper, "borderTopWidth"));
		                        } else {
		                            newHeight = wrapper.height() + distance;
		                        }
		                    } if (keyCode == keys.LEFT) {
		                        handled = true;
		                        newWidth = wrapper.width() - distance;
		                    } else if (keyCode == keys.RIGHT) {
		                        handled = true;
		                        if (that.containment && !that._isPinned) {
		                            newWidth = Math.min(wrapper.width() + distance,
		                                                that.containment.width - offset.left -
		                                                toInt(wrapper, "borderLeftWidth") - toInt(wrapper, "borderRightWidth"));
		                        } else {
		                            newWidth = wrapper.width() + distance;
		                        }
		                    }
	
		                    if (handled) {
		                        w = constrain(newWidth, options.minWidth, options.maxWidth);
		                        h = constrain(newHeight, options.minHeight, options.maxHeight);
	
		                        if (!isNaN(w)) {
		                            wrapper.width(w);
		                            that.options.width = w + "px";
		                        }
		                        if (!isNaN(h)) {
		                            wrapper.height(h);
		                            that.options.height = h + "px";
		                        }
	
		                        that.resize();
		                    }
		                }
	
		                if (handled) {
		                    e.preventDefault();
		                }
		            },
	
		            _overlay: function (visible) {
		                var overlay = this.containment ? this.containment.children(KOVERLAY) : this.appendTo.children(KOVERLAY),
		                    wrapper = this.wrapper;
	
		                if (!overlay.length) {
		                    overlay = $("<div class='k-overlay' />");
		                }
	
		                overlay
		                    .insertBefore(wrapper[0])
		                    .toggle(visible)
		                    .css(ZINDEX, parseInt(wrapper.css(ZINDEX), 10) - 1);
	
		                return overlay;
		            },
	
		            _actionForIcon: function(icon) {
		                var iconClass = /\bk-i(-\w+)+\b/.exec(icon[0].className)[0];
		                return {
		                    "k-i-close": "_close",
		                    "k-i-window-maximize": "maximize",
		                    "k-i-window-minimize": "minimize",
		                    "k-i-window-restore": "restore",
		                    "k-i-refresh": "refresh",
		                    "k-i-pin": "pin",
		                    "k-i-unpin": "unpin"
		                }[iconClass];
		            },
	
		            _windowActionHandler: function (e) {
		                if (this._closing) {
		                    return;
		                }
		                var icon = $(e.target).closest(".k-window-action").find(".k-icon");
		                var action = this._actionForIcon(icon);
	
		                if (action) {
		                    e.preventDefault();
		                    this[action]();
		                    return false;
		                }
		            },
	
		            _modals: function() {
		                var that = this;
	
		                var zStack = $(KWINDOW).filter(function() {
		                    var dom = $(this);
		                    var object = that._object(dom);
		                    var options = object && object.options;
	
		                    return options && options.modal && options.visible && options.appendTo === that.options.appendTo && dom.is(VISIBLE);
		                }).sort(function(a, b){
		                    return +$(a).css("zIndex") - +$(b).css("zIndex");
		                });
	
		                that = null;
	
		                return zStack;
		            },
	
		            _object: function(element) {
		                var content = element.children(KWINDOWCONTENT);
		                var widget = kendo.widgetInstance(content);
	
		                if (widget) {
		                    return widget;
		                }
	
		                return undefined;
		            },
	
		            center: function () {
		                var that = this,
		                    position = that.options.position,
		                    wrapper = that.wrapper,
		                    documentWindow = $(window),
		                    scrollTop = 0,
		                    scrollLeft = 0,
		                    newTop, newLeft;
	
		                if (that.options.isMaximized) {
		                    return that;
		                }
	
		                if(that.options.pinned && !that._isPinned) {
		                    that.pin();
		                }
	
		                if (!that.options.pinned) {
		                    scrollTop = documentWindow.scrollTop();
		                    scrollLeft = documentWindow.scrollLeft();
		                }
	
		                if (this.containment && !that.options.pinned) {
		                    newTop = this.minTop + (this.maxTop - this.minTop) / 2;
		                    newLeft = this.minLeft + (this.maxLeft - this.minLeft) / 2;
		                } else {
		                    newLeft = scrollLeft + Math.max(0, (documentWindow.width() - wrapper.width()) / 2);
		                    newTop = scrollTop + Math.max(0, (documentWindow.height() - wrapper.height() - toInt(wrapper, "paddingTop")) / 2);
		                }
	
		                wrapper.css({
		                    left: newLeft,
		                    top: newTop
		                });
	
		                position.top = newTop;
		                position.left = newLeft;
	
		                return that;
		            },
	
		            title: function (title) {
		                var that = this,
		                    value,
		                    encoded = true,
		                    wrapper = that.wrapper,
		                    titleBar = wrapper.children(KWINDOWTITLEBAR),
		                    titleElement = titleBar.children(KWINDOWTITLE),
		                    titleBarHeight,
		                    display, visibility;
	
		                if (!arguments.length) {
		                    return titleElement.html();
		                }
	
		                if ($.isPlainObject(title)) {
		                    value = typeof title.text !== "undefined" ? title.text :  "";
		                    encoded = title.encoded !== false;
		                } else {
		                    value = title;
		                }
	
		                if (value === false) {
		                    wrapper.addClass("k-window-titleless");
		                    titleBar.remove();
		                } else {
		                    if (!titleBar.length) {
		                        wrapper.prepend(templates.titlebar({
		                            title: encoded ? kendo.htmlEncode(value) : value
		                        }));
		                        that._actions();
		                        titleBar = wrapper.children(KWINDOWTITLEBAR);
		                    } else {
		                        titleElement.html(encoded ? kendo.htmlEncode(value) : value);
		                    }
	
		                    visibility = wrapper.css("visibility");
		                    display = wrapper.css("display");
	
		                    if (visibility === HIDDEN) {
		                        wrapper.css({ display: "" });
		                        titleBarHeight = parseInt(outerHeight(titleBar), 10);
		                        wrapper.css({ display: display });
		                    } else {
		                        wrapper.css({ visibility: HIDDEN, display: "" });
		                        titleBarHeight = parseInt(outerHeight(titleBar), 10);
		                        wrapper.css({ visibility: visibility, display: display });
		                    }
	
		                    wrapper.css("padding-top", titleBarHeight);
		                    titleBar.css("margin-top", -titleBarHeight);
		                }
	
		                that.options.title = value;
	
		                return that;
		            },
	
		            content: function (html, data) {
		                var content = this.wrapper.children(KWINDOWCONTENT),
		                    scrollContainer = content.children(".km-scroll-container");
	
		                content = scrollContainer[0] ? scrollContainer : content;
	
		                if (!defined(html)) {
		                    return content.html();
		                }
	
		                this.angular("cleanup", function(){
		                    return { elements: content.children() };
		                });
	
		                kendo.destroy(this.element.children());
	
		                content.empty().html(html);
	
		                this.angular("compile", function(){
		                    var a = [];
		                    for (var i = content.length; --i >= 0;) {
		                        a.push({ dataItem: data });
		                    }
		                    return {
		                        elements: content.children(),
		                        data: a
		                    };
		                });
	
		                return this;
		            },
	
		            open: function () {
		                var that = this,
		                    wrapper = that.wrapper,
		                    options = that.options,
		                    showOptions = this._animationOptions("open"),
		                    contentElement = wrapper.children(KWINDOWCONTENT),
		                    overlay, otherModalsVisible,
		                    containmentContext = this.containment && !that._isPinned,
		                    doc = containmentContext ? this.containment : $(document);
	
		                if (!that.trigger(OPEN)) {
		                    if (that._closing) {
		                        wrapper.kendoStop(true, true);
		                    }
	
		                    that._closing = false;
	
		                    that.toFront();
	
		                    if (options.autoFocus) {
		                        that.element.focus();
		                    }
	
		                    options.visible = true;
	
		                    if (options.modal) {
		                        otherModalsVisible = !!that._modals().length;
		                        overlay = that._overlay(otherModalsVisible);
	
		                        overlay.kendoStop(true, true);
	
		                        if (showOptions.duration && kendo.effects.Fade && !otherModalsVisible) {
		                            var overlayFx = kendo.fx(overlay).fadeIn();
		                            overlayFx.duration(showOptions.duration || 0);
		                            overlayFx.endValue(0.5);
		                            overlayFx.play();
		                        } else {
		                            overlay.css("opacity", 0.5);
		                        }
	
		                        overlay.show();
	
		                        $(window).on("focus" + MODAL_NS, function() {
		                            if (contentElement.data("isFront") && !$(document.activeElement).closest(contentElement).length) {
		                               that.element.focus();
		                            }
		                        });
		                    }
	
		                    if (!wrapper.is(VISIBLE)) {
		                        contentElement.css(OVERFLOW, HIDDEN);
		                        wrapper.show().kendoStop().kendoAnimate({
		                            effects: showOptions.effects,
		                            duration: showOptions.duration,
		                            complete: proxy(this._activate, this)
		                        });
		                    }
		                }
	
		                if (options.isMaximized) {
		                    that._containerScrollTop = doc.scrollTop();
		                    that._containerScrollLeft = doc.scrollLeft();
		                    that._stopDocumentScrolling();
		                }
	
		                if(options.pinned && !that._isPinned){
		                    that.pin();
		                }
	
		                return that;
		            },
	
		            _activate: function() {
		                var scrollable = this.options.scrollable !== false;
	
		                if (this.options.autoFocus) {
		                    this.element.focus();
		                }
	
		                this.element.css(OVERFLOW, scrollable ? "" : "hidden");
		                kendo.resize(this.element.children());
		                this.trigger(ACTIVATE);
		            },
	
		            _removeOverlay: function(suppressAnimation) {
		                var modals = this._modals();
		                var options = this.options;
		                var hideOverlay = options.modal && !modals.length;
		                var overlay = options.modal ? this._overlay(true) : $(undefined);
		                var hideOptions  = this._animationOptions("close");
	
		                if (hideOverlay) {
		                    if (!suppressAnimation && hideOptions.duration && kendo.effects.Fade) {
		                        var overlayFx = kendo.fx(overlay).fadeOut();
		                        overlayFx.duration(hideOptions.duration || 0);
		                        overlayFx.startValue(0.5);
		                        overlayFx.play();
		                    } else {
		                        this._overlay(false).remove();
		                    }
		                } else if (modals.length) {
		                    this._object(modals.last())._overlay(true);
		                }
		            },
	
		            _close: function(systemTriggered) {
		                var that = this,
		                    wrapper = that.wrapper,
		                    options = that.options,
		                    showOptions = this._animationOptions("open"),
		                    hideOptions  = this._animationOptions("close"),
		                    containmentContext = this.containment && !that._isPinned,
		                    doc = containmentContext ? this.containment : $(document),
		                    defaultPrevented;
	
		                if (that._closing) {
		                    return;
		                }
	
		                defaultPrevented = that.trigger(CLOSE, { userTriggered: !systemTriggered });
		                that._closing = !defaultPrevented;
	
		                if (wrapper.is(VISIBLE) && !defaultPrevented) {
		                    options.visible = false;
	
		                    $(KWINDOW).each(function(i, element) {
		                        var contentElement = $(element).children(KWINDOWCONTENT);
	
		                        // Remove overlay set by toFront
		                        if (element != wrapper && contentElement.find("> ." + KCONTENTFRAME).length > 0) {
		                            contentElement.children(KOVERLAY).remove();
		                        }
		                    });
	
		                    this._removeOverlay();
	
		                    wrapper.kendoStop().kendoAnimate({
		                        effects: hideOptions.effects || showOptions.effects,
		                        reverse: hideOptions.reverse === true,
		                        duration: hideOptions.duration,
		                        complete: proxy(this._deactivate, this)
		                    });
	
		                    $(window).off(MODAL_NS);
		                }
	
		                if (that.options.isMaximized) {
		                    that._enableDocumentScrolling();
		                    if (that._containerScrollTop && that._containerScrollTop > 0) {
		                        doc.scrollTop(that._containerScrollTop);
		                    }
		                    if (that._containerScrollLeft && that._containerScrollLeft > 0) {
		                        doc.scrollLeft(that._containerScrollLeft);
		                    }
		                }
		            },
	
		            _deactivate: function () {
		                var that = this;
		                that.wrapper.hide().css("opacity", "");
		                that.trigger(DEACTIVATE);
		                if (that.options.modal) {
		                    var lastModal = that._object(that._modals().last());
		                    if (lastModal) {
		                        lastModal.toFront();
		                    }
		                }
		            },
	
		            close: function () {
		                this._close(true);
		                return this;
		            },
	
		            _actionable: function(element) {
		                return $(element).is(TITLEBAR_BUTTONS + "," + TITLEBAR_BUTTONS + " .k-icon,:input,a");
		            },
	
		            _shouldFocus: function(target) {
		                var active = activeElement(),
		                    element = this.element;
	
		                return this.options.autoFocus &&
		                    !$(active).is(element) &&
		                    !this._actionable(target) &&
		                    (!element.find(active).length || !element.find(target).length);
		            },
	
		            toFront: function (e) {
		                var that = this,
		                    wrapper = that.wrapper,
		                    currentWindow = wrapper[0],
		                    containmentContext = that.containment && !that._isPinned,
		                    zIndex = +wrapper.css(ZINDEX),
		                    originalZIndex = zIndex,
		                    target = (e && e.target) || null;
	
		                $(KWINDOW).each(function(i, element) {
		                    var windowObject = $(element),
		                        zIndexNew = windowObject.css(ZINDEX),
		                        contentElement = windowObject.children(KWINDOWCONTENT);
	
		                    if (!isNaN(zIndexNew)) {
		                        zIndex = Math.max(+zIndexNew, zIndex);
		                    }
	
		                    contentElement.data("isFront", element == currentWindow);
		                    // Add overlay to windows with iframes and lower z-index to prevent
		                    // trapping of events when resizing / dragging
		                    if (element != currentWindow && contentElement.find("> ." + KCONTENTFRAME).length > 0) {
		                        contentElement.append(templates.overlay);
		                    }
		                });
	
		                if (!wrapper[0].style.zIndex || originalZIndex < zIndex) {
		                    wrapper.css(ZINDEX, zIndex + 2);
		                }
		                that.element.find("> .k-overlay").remove();
	
		                if (that._shouldFocus(target)) {
		                    if (that.isMinimized()) {
		                        that.wrapper.focus();
		                    } else if ($(target).is(KOVERLAY)) {
		                        setTimeout(function(){
		                            that.element.focus();
		                        });
		                    } else {
		                        that.element.focus();
		                    }
	
		                    var scrollTop = containmentContext ? that.containment.scrollTop() : $(window).scrollTop(),
		                        windowTop = parseInt(wrapper.position().top, 10);
	
		                    if (!that.options.pinned && windowTop > 0 && windowTop < scrollTop) {
		                        if (scrollTop > 0) {
		                            $(window).scrollTop(windowTop);
		                        } else {
		                            wrapper.css("top", scrollTop);
		                        }
		                    }
		                }
	
		                wrapper = null;
	
		                return that;
		            },
	
		            toggleMaximization: function () {
		                if (this._closing) {
		                    return this;
		                }
	
		                return this[this.options.isMaximized ? "restore" : "maximize"]();
		            },
	
		            restore: function () {
		                var that = this;
		                var options = that.options;
		                var minHeight = options.minHeight;
		                var restoreOptions = that.restoreOptions;
		                var shouldRestrictTop;
		                var container = that.containment && !that._isPinned ? that.containment : $(document);
	
		                if (!options.isMaximized && !options.isMinimized) {
		                    return that;
		                }
	
		                if (minHeight && minHeight != Infinity) {
		                    that.wrapper.css("min-height", minHeight);
		                }
	
		                if (restoreOptions && !options.isMaximized) {
		                    restoreOptions.height = constrain(restoreOptions.height, that.options.minHeight, that.options.maxHeight);
	
		                    shouldRestrictTop = options.position.top + parseInt(restoreOptions.height, 10) > that.maxTop;
	
		                    if (shouldRestrictTop) {
		                        options.position.top = constrain(options.position.top, that.minTop, that.maxTop - parseInt(restoreOptions.height, 10));
	
		                        extend(restoreOptions, {
		                            left: options.position.left,
		                            top: options.position.top
		                        });
		                    }
		                }
	
		                that.wrapper
		                    .css({
		                        position: options.pinned ? "fixed" : "absolute",
		                        left: restoreOptions.left,
		                        top: restoreOptions.top,
		                        width: restoreOptions.width,
		                        height: restoreOptions.height
		                    })
		                    .removeClass(MAXIMIZEDSTATE)
		                    .find(".k-window-content,.k-resize-handle").show().end()
		                    .find(".k-window-titlebar .k-i-window-restore").parent().remove().end().end()
		                    .find(MINIMIZE_MAXIMIZE).parent().show().end().end()
		                    .find(PIN_UNPIN).parent().show();
	
		                if (options.isMaximized) {
		                    that.wrapper.find(".k-i-window-maximize").parent().focus();
		                } else if (options.isMinimized) {
		                    that.wrapper.find(".k-i-window-minimize").parent().focus();
		                }
	
		                that.options.width = restoreOptions.width;
		                that.options.height = restoreOptions.height;
	
		                that._enableDocumentScrolling();
	
		                if (this._containerScrollTop && this._containerScrollTop > 0) {
		                    container.scrollTop(this._containerScrollTop);
		                }
		                if (this._containerScrollLeft && this._containerScrollLeft > 0) {
		                    container.scrollLeft(this._containerScrollLeft);
		                }
	
		                options.isMaximized = options.isMinimized = false;
	
		                this.wrapper.removeAttr("tabindex");
		                this.wrapper.removeAttr("aria-labelled-by");
	
		                that.resize();
	
		                return that;
		            },
	
		            _sizingAction: function(actionId, callback) {
		                var that = this,
		                    wrapper = that.wrapper,
		                    style = wrapper[0].style,
		                    options = that.options;
	
		                if (options.isMaximized || options.isMinimized) {
		                    return that;
		                }
	
		                that.restoreOptions = {
		                    width: style.width,
		                    height: style.height
		                };
	
		                wrapper
		                    .children(KWINDOWRESIZEHANDLES).hide().end()
		                    .children(KWINDOWTITLEBAR).find(MINIMIZE_MAXIMIZE).parent().hide()
		                    .eq(0).before(templates.action({ name: "window-restore" }));
	
		                callback.call(that);
	
		                that.wrapper.children(KWINDOWTITLEBAR).find(PIN_UNPIN).parent().toggle(actionId !== "maximize");
	
		                that.trigger(actionId);
	
		                wrapper.find(".k-i-window-restore").parent().focus();
	
		                return that;
		            },
	
		            maximize: function() {
		                this._sizingAction("maximize", function() {
		                    var that = this,
		                        wrapper = that.wrapper,
		                        containmentContext = this.containment && !that._isPinned,
		                        position = wrapper.position(),
		                        doc = $(document);
	
		                    extend(that.restoreOptions, {
		                        left: position.left + (containmentContext ? this.containment.scrollLeft() : 0),
		                        top: position.top + (containmentContext ? this.containment.scrollTop() : 0)
		                    });
	
		                    this._containerScrollTop = containmentContext ? this.containment.scrollTop() : doc.scrollTop();
		                    this._containerScrollLeft = containmentContext ? this.containment.scrollLeft() : doc.scrollLeft();
	
		                    that._stopDocumentScrolling();
	
		                    wrapper
		                        .css({
		                            top: containmentContext ? this.containment.scrollTop() : 0,
		                            left: containmentContext ? this.containment.scrollLeft() : 0,
		                            position: containmentContext ? "absolute" : "fixed"
		                        })
		                        .addClass(MAXIMIZEDSTATE);
	
		                    that.options.isMaximized = true;
	
		                    that._onDocumentResize();
		                });
	
		                return this;
		            },
	
		            _stopDocumentScrolling: function(){
		                var that = this;
		                var containment = that.containment;
	
		                if (containment && !that._isPinned) {
		                    that._storeOverflowRule(containment);
		                    containment.css(OVERFLOW, HIDDEN);
		                    that.wrapper.css({
		                        maxWidth: containment.innerWidth(),
		                        maxHeight: containment.innerHeight()
		                    });
		                    return;
		                }
	
		                var $body = $("body");
		                that._storeOverflowRule($body);
		                $body.css(OVERFLOW, HIDDEN);
	
		                var $html = $("html");
		                that._storeOverflowRule($html);
		                $html.css(OVERFLOW, HIDDEN);
		            },
	
		            _enableDocumentScrolling: function(){
		                var that = this;
		                var containment = that.containment;
	
		                if (containment && !that._isPinned) {
		                    that._restoreOverflowRule(containment);
		                    that.wrapper.css({
		                        maxWidth: containment.width,
		                        maxHeight: containment.height
		                    });
		                    return;
		                }
	
		                that._restoreOverflowRule($(document.body));
		                that._restoreOverflowRule($("html"));
		            },
	
		            _storeOverflowRule: function($element){
		                if(this._isOverflowStored($element)){
		                    return;
		                }
	
		                var overflowRule = $element.get(0).style.overflow;
	
		                if(typeof overflowRule === "string"){
		                    $element.data(DATADOCOVERFLOWRULE, overflowRule);
		                }
		            },
	
		            _isOverflowStored: function ($element){
		                return typeof $element.data(DATADOCOVERFLOWRULE) === "string";
		            },
	
		            _restoreOverflowRule: function($element){
		                var overflowRule = $element.data(DATADOCOVERFLOWRULE);
	
		                if(overflowRule !== null && overflowRule !== undefined){
		                    $element.css(OVERFLOW, overflowRule);
		                    $element.removeData(DATADOCOVERFLOWRULE);
		                } else {
		                    $element.css(OVERFLOW, "");
		                }
		            },
	
		            isMaximized: function() {
		                return this.options.isMaximized;
		            },
	
		            minimize: function() {
		                this._sizingAction("minimize", function() {
		                    var that = this;
	
		                    that.wrapper.css({
		                        height: "",
		                        minHeight: ""
		                    });
	
		                    that.element.hide();
	
		                    that.options.isMinimized = true;
		                });
	
		                this.wrapper.attr("tabindex", 0);
		                this.wrapper.attr("aria-labelled-by", this.element.attr("aria-labelled-by"));
	
		                this._updateBoundaries();
	
		                return this;
		            },
	
		            isMinimized: function() {
		                return this.options.isMinimized;
		            },
	
		            pin: function() {
		                var that = this,
		                    win = $(window),
		                    wrapper = that.wrapper,
		                    options = that.options,
		                    position = options.position,
		                    top = this.containment ? getPosition(wrapper[0]).top + toInt(this.containment, "borderTopWidth") : toInt(wrapper, "top"),
		                    left = this.containment ? getPosition(wrapper[0]).left + toInt(this.containment, "borderLeftWidth") : toInt(wrapper, "left");
	
		                if (!that.options.isMaximized) {
		                    position.top = top;
		                    position.left = left;
	
		                    if (!this.containment || this.containment.css("position") !== "fixed") {
		                        position.top -= win.scrollTop();
		                        position.left -= win.scrollLeft();
		                    }
	
		                    wrapper.css(extend(position, {position: "fixed"}));
		                    wrapper.children(KWINDOWTITLEBAR).find(KPIN).addClass("k-i-unpin").removeClass("k-i-pin");
	
		                    that._isPinned = true;
		                    that.options.pinned = true;
	
		                    if (this.containment) {
		                        options.maxWidth = options.maxHeight = Infinity;
		                        wrapper.css({
		                            maxWidth: "",
		                            maxHeight: ""
		                        });
		                    }
		                }
		            },
	
		            unpin: function() {
		                var that = this,
		                    win = $(window),
		                    wrapper = that.wrapper,
		                    options = that.options,
		                    position = that.options.position,
		                    containment = that.containment,
		                    top = parseInt(wrapper.css("top"), 10) + win.scrollTop(),
		                    left = parseInt(wrapper.css("left"), 10) + win.scrollLeft();
	
		                if (!that.options.isMaximized) {
		                    that._isPinned = false;
		                    that.options.pinned = false;
	
		                    if (containment) {
		                        that._updateBoundaries();
	
		                        options.maxWidth = Math.min(containment.width, options.maxWidth);
		                        options.maxHeight = Math.min(containment.height - toInt(wrapper, "padding-top"), options.maxHeight);
	
		                        wrapper.css({
		                            maxWidth: options.maxWidth,
		                            maxHeight: options.maxHeight
		                        });
	
		                        if (top < containment.position.top) {
		                            top = that.minTop;
		                        } else if (top > containment.position.top + containment.height) {
		                            top = that.maxTop;
		                        } else {
		                            top = top + containment.scrollTop() - (containment.position.top + toInt(containment, "border-top-width"));
		                        }
	
		                        if (left < containment.position.left) {
		                            left = that.minLeft;
		                        } else if (left > containment.position.left + containment.width) {
		                            left = that.maxLeft;
		                        } else {
		                            left = left + containment.scrollLeft() - (containment.position.left + toInt(containment, "border-left-width"));
		                        }
	
		                    }
	
		                    position.top = constrain(top, that.minTop, that.maxTop);
		                    position.left = constrain(left, that.minLeft, that.maxLeft);
	
		                    wrapper.css(extend(position, {position: ""}));
		                    wrapper.children(KWINDOWTITLEBAR).find(KUNPIN).addClass("k-i-pin").removeClass("k-i-unpin");
		                }
		            },
	
		            _onDocumentResize: function () {
		                var that = this,
		                    wrapper = that.wrapper,
		                    wnd = $(window),
		                    zoomLevel = kendo.support.zoomLevel(),
		                    contentBoxSizing = wrapper.css("box-sizing") == "content-box",
		                    w, h;
	
		                if (!that.options.isMaximized) {
		                    return;
		                }
	
		                var lrBorderWidth = contentBoxSizing ? toInt(wrapper, "border-left-width") + toInt(wrapper, "border-right-width") : 0;
		                var tbBorderWidth = contentBoxSizing ? toInt(wrapper, "border-top-width") + toInt(wrapper, "border-bottom-width") : 0;
		                var paddingTop = contentBoxSizing ? toInt(wrapper, "padding-top") : 0;
	
		                if (that.containment && !that._isPinned) {
		                    w = that.containment.innerWidth() - lrBorderWidth;
		                    h = that.containment.innerHeight() - (tbBorderWidth + paddingTop);
		                } else {
		                    w = wnd.width() / zoomLevel - lrBorderWidth;
		                    h = wnd.height() / zoomLevel - (tbBorderWidth + paddingTop);
		                }
	
		                wrapper.css({
		                    width: w,
		                    height: h
		                });
		                that.options.width = w;
		                that.options.height = h;
	
		                that.resize();
		            },
	
		            refresh: function (options) {
		                var that = this,
		                    initOptions = that.options,
		                    element = $(that.element),
		                    iframe,
		                    showIframe,
		                    url;
	
		                if (!isPlainObject(options)) {
		                    options = { url: options };
		                }
	
		                options = extend({}, initOptions.content, options);
	
		                showIframe = defined(initOptions.iframe) ? initOptions.iframe : options.iframe;
	
		                url = options.url;
	
		                if (url) {
		                    if (!defined(showIframe)) {
		                        showIframe = !isLocalUrl(url);
		                    }
	
		                    if (!showIframe) {
		                        // perform AJAX request
		                        that._ajaxRequest(options);
		                    } else {
		                        iframe = element.find("." + KCONTENTFRAME)[0];
	
		                        if (iframe) {
		                            // refresh existing iframe
		                            iframe.src = url || iframe.src;
		                        } else {
		                            // render new iframe
		                            element.html(templates.contentFrame(extend({}, initOptions, { content: options })));
		                        }
	
		                        element.find("." + KCONTENTFRAME)
		                            .unbind("load" + NS)
		                            .on("load" + NS, proxy(this._triggerRefresh, this));
		                    }
		                } else {
		                    if (options.template) {
		                        // refresh template
		                        that.content(template(options.template)({}));
		                    }
	
		                    that.trigger(REFRESH);
		                }
	
		                element.toggleClass("k-window-iframecontent", !!showIframe);
	
		                return that;
		            },
	
		            _triggerRefresh: function() {
		                this.trigger(REFRESH);
		            },
	
		            _ajaxComplete: function() {
		                clearTimeout(this._loadingIconTimeout);
		                this.wrapper.find(REFRESHICON).removeClass(LOADING);
		            },
	
		            _ajaxError: function (xhr, status) {
		                this.trigger(ERROR, { status: status, xhr: xhr });
		            },
	
		            _ajaxSuccess: function (contentTemplate) {
		                return function (data) {
		                    var html = data;
		                    if (contentTemplate) {
		                        html = template(contentTemplate)(data || {});
		                    }
	
		                    this.content(html, data);
		                    this.element.prop("scrollTop", 0);
	
		                    this.trigger(REFRESH);
		                };
		            },
	
		            _showLoading: function() {
		                this.wrapper.find(REFRESHICON).addClass(LOADING);
		            },
	
		            _ajaxRequest: function (options) {
		                this._loadingIconTimeout = setTimeout(proxy(this._showLoading, this), 100);
	
		                $.ajax(extend({
		                    type: "GET",
		                    dataType: "html",
		                    cache: false,
		                    error: proxy(this._ajaxError, this),
		                    complete: proxy(this._ajaxComplete, this),
		                    success: proxy(this._ajaxSuccess(options.template), this)
		                }, options));
		            },
	
		            _destroy: function() {
		                if (this.resizing) {
		                    this.resizing.destroy();
		                }
	
		                if (this.dragging) {
		                    this.dragging.destroy();
		                }
	
		                this.wrapper.off(NS)
		                    .children(KWINDOWCONTENT).off(NS).end()
		                    .find(".k-resize-handle,.k-window-titlebar").off(NS);
	
		                $(window).off("resize" + NS + this._marker);
		                $(window).off(MODAL_NS);
		                $(window).off(NS);
	
		                clearTimeout(this._loadingIconTimeout);
	
		                Widget.fn.destroy.call(this);
	
		                this.unbind(undefined);
	
		                kendo.destroy(this.wrapper);
	
		                this._removeOverlay(true);
		            },
	
		            destroy: function() {
		                this._destroy();
	
		                this.wrapper.empty().remove();
	
		                this.wrapper = this.appendTo = this.element = $();
		            },
	
		            _createWindow: function() {
		                var contentHtml = this.element,
		                    options = this.options,
		                    iframeSrcAttributes,
		                    wrapper,
		                    isRtl = kendo.support.isRtl(contentHtml);
	
		                if (options.scrollable === false) {
		                    contentHtml.css("overflow", "hidden");
		                }
	
		                wrapper = $(templates.wrapper(options));
	
		                // Collect the src attributes of all iframes and then set them to empty string.
		                // This seems to fix this IE9 "feature": http://msdn.microsoft.com/en-us/library/gg622929%28v=VS.85%29.aspx?ppud=4
		                iframeSrcAttributes = contentHtml.find("iframe:not(.k-content)").map(function() {
		                    var src = this.getAttribute("src");
		                    this.src = "";
		                    return src;
		                });
	
		                // Make sure the wrapper is appended to the body only once. IE9+ will throw exceptions if you move iframes in DOM
		                wrapper
		                    .toggleClass("k-rtl", isRtl)
		                    .append(contentHtml)
		                    .find("iframe:not(.k-content)").each(function(index) {
		                    // Restore the src attribute of the iframes when they are part of the live DOM tree
		                    this.src = iframeSrcAttributes[index];
		                });
	
		                if (this.containment) {
		                    this.containment.prepend(wrapper);
		                } else if (this.appendTo) {
		                    wrapper.appendTo(this.appendTo);
		                }
	
		                wrapper.find(".k-window-title")
		                    .css(isRtl ? "left" : "right", outerWidth(wrapper.find(".k-window-actions")) + 10);
	
		                contentHtml.css("visibility", "").show();
	
		                contentHtml.find("[data-role=editor]").each(function() {
		                    var editor = $(this).data("kendoEditor");
	
		                    if (editor) {
		                        editor.refresh();
		                    }
		                });
	
		                wrapper = contentHtml = null;
		            }
		        });
	
		        templates = {
		            wrapper: template("<div class='k-widget k-window' />"),
		            action: template(
		                "<a role='button' href='\\#' class='k-button k-bare k-button-icon k-window-action' aria-label='#= name #'>" +
		                "<span class='k-icon k-i-#= name.toLowerCase() #'></span>" +
		                "</a>"
		            ),
		            titlebar: template(
		                "<div class='k-window-titlebar k-header'>" +
		                "<span class='k-window-title'>#= title #</span>" +
		                "<div class='k-window-actions' />" +
		                "</div>"
		            ),
		            overlay: "<div class='k-overlay' />",
		            contentFrame: template(
		                "<iframe frameborder='0' title='#= title #' class='" + KCONTENTFRAME + "' " +
		                "src='#= content.url #'>" +
		                "This page requires frames in order to show content" +
		                "</iframe>"
		            ),
		            resizeHandle: template("<div class='k-resize-handle k-resize-#= data #'></div>")
		        };
	
	
		        function WindowResizing(wnd) {
		            var that = this;
		            that.owner = wnd;
		            that._preventDragging = false;
		            that._draggable = new Draggable(wnd.wrapper, {
		                filter: ">" + KWINDOWRESIZEHANDLES,
		                group: wnd.wrapper.id + "-resizing",
		                dragstart: proxy(that.dragstart, that),
		                drag: proxy(that.drag, that),
		                dragend: proxy(that.dragend, that)
		            });
	
		            that._draggable.userEvents.bind("press", proxy(that.addOverlay, that));
		            that._draggable.userEvents.bind("release", proxy(that.removeOverlay, that));
		        }
	
		        WindowResizing.prototype = {
		            addOverlay: function () {
		                this.owner.wrapper.append(templates.overlay);
		            },
		            removeOverlay: function () {
		                this.owner.wrapper.find(KOVERLAY).remove();
		            },
		            dragstart: function (e) {
		                var that = this;
		                var wnd = that.owner;
		                var wrapper = wnd.wrapper;
	
		                that._preventDragging = wnd.trigger(RESIZESTART);
		                if (that._preventDragging) {
		                    return;
		                }
	
		                that.elementPadding = parseInt(wrapper.css("padding-top"), 10);
		                that.initialPosition = kendo.getOffset(wrapper, "position");
	
		                that.resizeDirection = e.currentTarget.prop("className").replace("k-resize-handle k-resize-", "");
	
		                that.initialSize = {
		                    width: wrapper.width(),
		                    height: wrapper.height()
		                };
	
		                wnd._updateBoundaries();
	
		                that.containerOffset = wnd.containment ? wnd.containment.position : kendo.getOffset(wnd.appendTo, "position");
	
		                var offsetParent = wrapper.offsetParent();
	
		                if (offsetParent.is("html")) {
		                    that.containerOffset.top = that.containerOffset.left = 0;
		                } else {
		                    var marginTop = offsetParent.css("margin-top");
		                    var marginLeft = offsetParent.css("margin-left");
		                    var hasMargin = !zero.test(marginTop) || !zero.test(marginLeft);
		                    if (hasMargin) {
		                        var wrapperPosition = getPosition(wrapper[0]);
		                        var relativeElMarginLeft = wrapperPosition.left - that.containerOffset.left - that.initialPosition.left;
		                        var relativeElMarginTop = wrapperPosition.top - that.containerOffset.top - that.initialPosition.top;
	
		                        that._relativeElMarginLeft = relativeElMarginLeft > 1 ? relativeElMarginLeft : 0;
		                        that._relativeElMarginTop = relativeElMarginTop > 1 ? relativeElMarginTop : 0;
	
		                        that.initialPosition.left += that._relativeElMarginLeft;
		                        that.initialPosition.top += that._relativeElMarginTop;
		                    }
		                }
	
		                wrapper
		                    .children(KWINDOWRESIZEHANDLES).not(e.currentTarget).hide();
	
		                $(BODY).css(CURSOR, e.currentTarget.css(CURSOR));
		            },
		            drag: function (e) {
		                if (this._preventDragging) {
		                    return;
		                }
		                var that = this,
		                    wnd = that.owner,
		                    wrapper = wnd.wrapper,
		                    options = wnd.options,
		                    position = options.position,
		                    direction = that.resizeDirection,
		                    containerOffset = that.containerOffset,
		                    initialPosition = that.initialPosition,
		                    initialSize = that.initialSize,
		                    containmentContext = wnd.containment && !wnd._isPinned,
		                    rtl = kendo.support.isRtl(wnd.containment),
		                    leftRtlOffset = containmentContext && rtl && wnd.containment.innerWidth() > wnd.containment.width ? kendo.support.scrollbar() : 0,
		                    scrollOffset = containmentContext ? { top: wnd.containment.scrollTop(), left: wnd.containment.scrollLeft()} : { top: 0, left: 0},
		                    newWidth, newHeight,
		                    windowBottom, windowRight,
		                    x = Math.max(e.x.location, 0),
		                    y = Math.max(e.y.location, 0);
	
		                    if (direction.indexOf("e") >= 0) {
	
		                        if (wnd.containment && x - initialSize.width >= wnd.maxLeft - scrollOffset.left + containerOffset.left + leftRtlOffset) {
		                            newWidth = wnd.maxLeft + leftRtlOffset - initialPosition.left + initialSize.width - scrollOffset.left;
		                        } else {
		                            newWidth = x - initialPosition.left - containerOffset.left;
		                        }
	
		                        wrapper.width(constrain(newWidth, options.minWidth, options.maxWidth));
		                    } else if (direction.indexOf("w") >= 0) {
		                        windowRight = initialPosition.left + initialSize.width + containerOffset.left;
		                        newWidth = constrain(windowRight - x, options.minWidth, options.maxWidth);
		                        position.left = windowRight - newWidth - containerOffset.left - leftRtlOffset - (that._relativeElMarginLeft || 0) + scrollOffset.left;
	
		                        if (wnd.containment && position.left <= wnd.minLeft) {
		                            position.left = wnd.minLeft;
		                            newWidth = constrain(windowRight - leftRtlOffset - position.left - containerOffset.left + scrollOffset.left, options.minWidth, options.maxWidth);
		                        }
	
		                        wrapper.css({
		                            left: position.left,
		                            width: newWidth
		                        });
		                    }
	
		                    var newWindowTop = y;
		                    if (wnd.options.pinned) {
		                        newWindowTop -= $(window).scrollTop();
		                    }
		                    if (direction.indexOf("s") >= 0) {
		                        newHeight = newWindowTop - initialPosition.top - that.elementPadding - containerOffset.top;
	
		                        if (newWindowTop - initialSize.height - that.elementPadding >= wnd.maxTop + containerOffset.top - scrollOffset.top) {
		                            newHeight = wnd.maxTop - initialPosition.top + initialSize.height - scrollOffset.top;
		                        }
	
		                        wrapper.height(constrain(newHeight, options.minHeight, options.maxHeight));
		                    } else if (direction.indexOf("n") >= 0) {
		                        windowBottom = initialPosition.top + initialSize.height + containerOffset.top;
		                        newHeight = constrain(windowBottom - newWindowTop, options.minHeight, options.maxHeight);
		                        position.top = windowBottom - newHeight - containerOffset.top - (that._relativeElMarginTop || 0) + scrollOffset.top;
	
		                        if (position.top <= wnd.minTop && wnd.containment) {
		                            position.top = wnd.minTop;
		                            newHeight = constrain(windowBottom - position.top - containerOffset.top + scrollOffset.top, options.minHeight, options.maxHeight);
		                        }
	
		                        wrapper.css({
		                            top: position.top,
		                            height: newHeight
		                        });
		                    }
	
		                    if (newWidth) {
		                        wnd.options.width = newWidth + "px";
		                    }
		                    if (newHeight) {
		                        wnd.options.height = newHeight + "px";
		                    }
	
		                    wnd.resize();
		            },
		            dragend: function (e) {
		                if (this._preventDragging) {
		                    return;
		                }
		                var that = this,
		                    wnd = that.owner,
		                    wrapper = wnd.wrapper;
	
		                wrapper
		                    .children(KWINDOWRESIZEHANDLES).not(e.currentTarget).show();
	
		                $(BODY).css(CURSOR, "");
	
		                if (wnd.touchScroller) {
		                    wnd.touchScroller.reset();
		                }
	
		                if (e.keyCode == 27) {
		                    wrapper.css(that.initialPosition)
		                        .css(that.initialSize);
		                }
	
		                wnd.trigger(RESIZEEND);
	
		                return false;
		            },
		            destroy: function() {
		                if (this._draggable) {
		                    this._draggable.destroy();
		                }
	
		                this._draggable = this.owner = null;
		            }
		        };
	
		        function WindowDragging(wnd, dragHandle) {
		            var that = this;
		            that.owner = wnd;
		            that._preventDragging = false;
		            that._draggable = new Draggable(wnd.wrapper, {
		                filter: dragHandle,
		                group: wnd.wrapper.id + "-moving",
		                dragstart: proxy(that.dragstart, that),
		                drag: proxy(that.drag, that),
		                dragend: proxy(that.dragend, that),
		                dragcancel: proxy(that.dragcancel, that)
		            });
	
		            that._draggable.userEvents.stopPropagation = false;
		        }
	
		        WindowDragging.prototype = {
		            dragstart: function (e) {
		                var wnd = this.owner,
		                    draggable = wnd.options.draggable,
		                    element = wnd.element,
		                    actions = element.find(".k-window-actions"),
		                    containerOffset = kendo.getOffset(wnd.appendTo);
	
		                this._preventDragging = wnd.trigger(DRAGSTART) || !draggable;
		                if (this._preventDragging || wnd.isMaximized()) {
		                    return;
		                }
	
		                wnd.initialWindowPosition = kendo.getOffset(wnd.wrapper, "position");
	
		                wnd.initialPointerPosition = {
		                    left: wnd.options.position.left,
		                    top: wnd.options.position.top
		                };
	
		                wnd.startPosition = {
		                    left: e.x.client - wnd.initialWindowPosition.left,
		                    top: e.y.client - wnd.initialWindowPosition.top
		                };
	
		                wnd._updateBoundaries();
		                if (!wnd.containment) {
		                    if (actions.length > 0) {
		                        wnd.minLeft = outerWidth(actions) + parseInt(actions.css("right"), 10) - outerWidth(element);
		                    } else {
		                        wnd.minLeft =  20 - outerWidth(element); // at least 20px remain visible
		                    }
	
		                    wnd.minLeft -= containerOffset.left;
		                    wnd.minTop = -containerOffset.top;
		                }
	
		                wnd.wrapper
		                    .append(templates.overlay)
		                    .children(KWINDOWRESIZEHANDLES).hide();
	
		                $(BODY).css(CURSOR, e.currentTarget.css(CURSOR));
		            },
	
		            drag: function (e) {
		                var wnd = this.owner;
		                var position = wnd.options.position;
		                var axis = wnd.options.draggable.axis;
		                var left;
		                var top;
	
		                if (this._preventDragging || wnd.isMaximized()) {
		                    return;
		                }
	
		                if (!axis || axis.toLowerCase() === "x") {
		                    left = e.x.client - wnd.startPosition.left;
	
		                    if (wnd.containment && !wnd._isPinned) {
		                        left += wnd.containment.scrollLeft();
		                    }
	
		                    position.left = constrain(left, wnd.minLeft, wnd.maxLeft);
		                }
	
		                if (!axis || axis.toLowerCase() === "y") {
		                    top = e.y.client - wnd.startPosition.top;
	
		                    if (wnd.containment && !wnd._isPinned) {
		                        top += wnd.containment.scrollTop();
		                    }
	
		                    position.top = constrain(top, wnd.minTop, wnd.maxTop);
		                }
	
		                if (kendo.support.transforms) {
		                    $(wnd.wrapper).css(
		                        "transform", "translate(" +
		                        (position.left - wnd.initialPointerPosition.left) + "px, " +
		                        (position.top - wnd.initialPointerPosition.top) + "px)"
		                    );
		                } else {
		                    $(wnd.wrapper).css(position);
		                }
	
		            },
	
		            _finishDrag: function() {
		                var wnd = this.owner;
	
		                wnd.wrapper
		                    .children(KWINDOWRESIZEHANDLES).toggle(!wnd.options.isMinimized).end()
		                    .find(KOVERLAY).remove();
	
		                $(BODY).css(CURSOR, "");
		            },
	
		            dragcancel: function (e) {
		                if (this._preventDragging) {
		                    return;
		                }
		                this._finishDrag();
	
		                e.currentTarget.closest(KWINDOW).css(this.owner.initialWindowPosition);
		            },
	
		            dragend: function () {
		                var wnd = this.owner;
	
		                if (this._preventDragging || wnd.isMaximized()) {
		                    return;
		                }
	
		                $(wnd.wrapper)
		                    .css(wnd.options.position)
		                    .css("transform", "");
	
		                this._finishDrag();
	
		                wnd.trigger(DRAGEND);
	
		                return false;
		            },
		            destroy: function() {
		                if (this._draggable) {
		                    this._draggable.destroy();
		                }
	
		                this._draggable = this.owner = null;
		            }
		        };
	
		        kendo.ui.plugin(Window);
	
		    })(window.kendo.jQuery);
	
		    return window.kendo;
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1034);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1034:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1035), __webpack_require__(1036), __webpack_require__(1037), __webpack_require__(1038), __webpack_require__(1039) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "colorpicker",
		    name: "Color tools",
		    category: "web",
		    description: "Color selection widgets",
		    depends: [ "core", "color", "popup", "slider", "userevents", "button" ]
		};
	
		(function($, parseInt, undefined){
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /*jshint eqnull:true  */
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        parseColor = kendo.parseColor,
		        Color = kendo.Color,
		        KEYS = kendo.keys,
		        BACKGROUNDCOLOR = "background-color",
		        ITEMSELECTEDCLASS = "k-state-selected",
		        SIMPLEPALETTE = "000000,7f7f7f,880015,ed1c24,ff7f27,fff200,22b14c,00a2e8,3f48cc,a349a4,ffffff,c3c3c3,b97a57,ffaec9,ffc90e,efe4b0,b5e61d,99d9ea,7092be,c8bfe7",
		        WEBPALETTE = "FFFFFF,FFCCFF,FF99FF,FF66FF,FF33FF,FF00FF,CCFFFF,CCCCFF,CC99FF,CC66FF,CC33FF,CC00FF,99FFFF,99CCFF,9999FF,9966FF,9933FF,9900FF,FFFFCC,FFCCCC,FF99CC,FF66CC,FF33CC,FF00CC,CCFFCC,CCCCCC,CC99CC,CC66CC,CC33CC,CC00CC,99FFCC,99CCCC,9999CC,9966CC,9933CC,9900CC,FFFF99,FFCC99,FF9999,FF6699,FF3399,FF0099,CCFF99,CCCC99,CC9999,CC6699,CC3399,CC0099,99FF99,99CC99,999999,996699,993399,990099,FFFF66,FFCC66,FF9966,FF6666,FF3366,FF0066,CCFF66,CCCC66,CC9966,CC6666,CC3366,CC0066,99FF66,99CC66,999966,996666,993366,990066,FFFF33,FFCC33,FF9933,FF6633,FF3333,FF0033,CCFF33,CCCC33,CC9933,CC6633,CC3333,CC0033,99FF33,99CC33,999933,996633,993333,990033,FFFF00,FFCC00,FF9900,FF6600,FF3300,FF0000,CCFF00,CCCC00,CC9900,CC6600,CC3300,CC0000,99FF00,99CC00,999900,996600,993300,990000,66FFFF,66CCFF,6699FF,6666FF,6633FF,6600FF,33FFFF,33CCFF,3399FF,3366FF,3333FF,3300FF,00FFFF,00CCFF,0099FF,0066FF,0033FF,0000FF,66FFCC,66CCCC,6699CC,6666CC,6633CC,6600CC,33FFCC,33CCCC,3399CC,3366CC,3333CC,3300CC,00FFCC,00CCCC,0099CC,0066CC,0033CC,0000CC,66FF99,66CC99,669999,666699,663399,660099,33FF99,33CC99,339999,336699,333399,330099,00FF99,00CC99,009999,006699,003399,000099,66FF66,66CC66,669966,666666,663366,660066,33FF66,33CC66,339966,336666,333366,330066,00FF66,00CC66,009966,006666,003366,000066,66FF33,66CC33,669933,666633,663333,660033,33FF33,33CC33,339933,336633,333333,330033,00FF33,00CC33,009933,006633,003333,000033,66FF00,66CC00,669900,666600,663300,660000,33FF00,33CC00,339900,336600,333300,330000,00FF00,00CC00,009900,006600,003300,000000",
		        WHITE = "#ffffff",
		        MESSAGES = {
		            apply  : "Apply",
		            cancel : "Cancel",
		            noColor: "no color",
		            clearColor: "Clear color",
		            previewInput: "Color Hexadecimal Code"
		        },
		        NS = ".kendoColorTools",
		        CLICK_NS = "click" + NS,
		        KEYDOWN_NS = "keydown" + NS,
	
		        browser = kendo.support.browser,
		        isIE8 = browser.msie && browser.version < 9;
	
		    var ColorSelector = Widget.extend({
		        init: function(element, options) {
		            var that = this, ariaId;
	
		            Widget.fn.init.call(that, element, options);
		            element = that.element;
		            options = that.options;
		            that._value = options.value = parseColor(options.value);
		            that._tabIndex = element.attr("tabIndex") || 0;
	
		            ariaId = that._ariaId = options.ariaId;
		            if (ariaId) {
		                element.attr("aria-labelledby", ariaId);
		            }
	
		            if (options._standalone) {
		                that._triggerSelect = that._triggerChange;
		            }
		        },
		        options: {
		            name: "ColorSelector",
		            value: null,
		            _standalone: true
		        },
		        events: [
		            "change",
		            "select",
		            "cancel"
		        ],
		        color: function(value) {
		            if (value !== undefined) {
		                this._value = parseColor(value);
		                this._updateUI(this._value);
		            }
	
		            return this._value;
		        },
		        value: function(color) {
		            color = this.color(color);
	
		            if (color) {
		                if (this.options.opacity) {
		                    color = color.toCssRgba();
		                } else {
		                    color = color.toCss();
		                }
		            }
	
		            return color || null;
		        },
		        enable: function(enable) {
		            if (arguments.length === 0) {
		                enable = true;
		            }
		            $(".k-disabled-overlay", this.wrapper).remove();
		            if (!enable) {
		                this.wrapper.append("<div class='k-disabled-overlay'></div>");
		            }
		            this._onEnable(enable);
		        },
		        _select: function(color, nohooks) {
		            var prev = this._value;
		            color = this.color(color);
		            if (!nohooks) {
		                this.element.trigger("change");
		                if (!color.equals(prev)) {
		                    this.trigger("change", { value: this.value() });
		                } else if (!this._standalone) {
		                    this.trigger("cancel");
		                }
		            }
		        },
		        _triggerSelect: function(color) {
		            triggerEvent(this, "select", color);
		        },
		        _triggerChange: function(color) {
		            triggerEvent(this, "change", color);
		        },
		        destroy: function() {
		            if (this.element) {
		                this.element.off(NS);
		            }
		            if (this.wrapper) {
		                this.wrapper.off(NS).find("*").off(NS);
		            }
		            this.wrapper = null;
		            Widget.fn.destroy.call(this);
		        },
		        _updateUI: $.noop,
		        _selectOnHide: function() {
		            return null;
		        },
		        _cancel: function() {
		            this.trigger("cancel");
		        }
		    });
	
		    function triggerEvent(self, type, color) {
		        color = parseColor(color);
		        if (color && !color.equals(self.color())) {
		            if (type == "change") {
		                // UI is already updated.  setting _value directly
		                // rather than calling self.color(color) to avoid an
		                // endless loop.
		                self._value = color;
		            }
		            if (color.a != 1) {
		                color = color.toCssRgba();
		            } else {
		                color = color.toCss();
		            }
		            self.trigger(type, { value: color });
		        }
		    }
	
		    var ColorPalette = ColorSelector.extend({
		        init: function(element, options) {
		            var that = this;
		            ColorSelector.fn.init.call(that, element, options);
		            element = that.wrapper = that.element;
		            options = that.options;
		            var colors = options.palette;
	
		            if (colors == "websafe") {
		                colors = WEBPALETTE;
		                options.columns = 18;
		            } else if (colors == "basic") {
		                colors = SIMPLEPALETTE;
		            }
	
		            if (typeof colors == "string") {
		                colors = colors.split(",");
		            }
	
		            if ($.isArray(colors)) {
		                colors = $.map(colors, function(x) { return parseColor(x); });
		            }
	
		            that._selectedID = (options.ariaId || kendo.guid()) + "_selected";
	
		            element.addClass("k-widget k-colorpalette")
		                .attr("role", "grid")
		                .attr("aria-readonly", "true")
		                .append($(that._template({
		                    colors   : colors,
		                    columns  : options.columns,
		                    tileSize : options.tileSize,
		                    value    : that._value,
		                    id       : options.ariaId
		                })))
		                .on(CLICK_NS, ".k-item", function(ev){
		                    that._select($(ev.currentTarget).css(BACKGROUNDCOLOR));
		                })
		                .attr("tabIndex", that._tabIndex)
		                .on(KEYDOWN_NS, bind(that._keydown, that));
	
		            var tileSize = options.tileSize, width, height;
		            if (tileSize) {
		                if (/number|string/.test(typeof tileSize)) {
		                    width = height = parseFloat(tileSize);
		                } else if (typeof tileSize == "object") {
		                    width = parseFloat(tileSize.width);
		                    height = parseFloat(tileSize.height);
		                } else {
		                    throw new Error("Unsupported value for the 'tileSize' argument");
		                }
		                element.find(".k-item").css({ width: width, height: height });
		            }
		        },
		        focus: function(){
		            if (this.wrapper && !this.wrapper.is("[unselectable='on']")) {
		                this.wrapper.focus();
		            }
		        },
		        options: {
		            name: "ColorPalette",
		            columns: 10,
		            tileSize: null,
		            palette: "basic"
		        },
		        _onEnable: function(enable) {
		            if (enable) {
		                this.wrapper.attr("tabIndex", this._tabIndex);
		            } else {
		                this.wrapper.removeAttr("tabIndex");
		            }
		        },
		        _keydown: function(e) {
		            var selected,
		                wrapper = this.wrapper,
		                items = wrapper.find(".k-item"),
		                current = items.filter("." + ITEMSELECTEDCLASS).get(0),
		                keyCode = e.keyCode;
	
		            if (keyCode == KEYS.LEFT) {
		                selected = relative(items, current, -1);
		            } else if (keyCode == KEYS.RIGHT) {
		                selected = relative(items, current, 1);
		            } else if (keyCode == KEYS.DOWN) {
		                selected = relative(items, current, this.options.columns);
		            } else if (keyCode == KEYS.UP) {
		                selected = relative(items, current, -this.options.columns);
		            } else if (keyCode == KEYS.ENTER) {
		                preventDefault(e);
		                if (current) {
		                    this._select($(current).css(BACKGROUNDCOLOR));
		                }
		            } else if (keyCode == KEYS.ESC) {
		                this._cancel();
		            }
	
		            if (selected) {
		                preventDefault(e);
	
		                this._current(selected);
	
		                try {
		                    var color = parseColor(selected.css(BACKGROUNDCOLOR));
		                    this._triggerSelect(color);
		                } catch(ex) {}
		            }
		        },
		        _current: function(item) {
		            this.wrapper.find("." + ITEMSELECTEDCLASS)
		                .removeClass(ITEMSELECTEDCLASS)
		                .attr("aria-selected", false)
		                .removeAttr("id");
	
		            $(item)
		                .addClass(ITEMSELECTEDCLASS)
		                .attr("aria-selected", true)
		                .attr("id", this._selectedID);
	
		            this.element
		                .removeAttr("aria-activedescendant")
		                .attr("aria-activedescendant", this._selectedID);
		        },
		        _updateUI: function(color) {
		            var item = null;
	
		            this.wrapper.find(".k-item").each(function(){
		                var c = parseColor($(this).css(BACKGROUNDCOLOR));
	
		                if (c && c.equals(color)) {
		                    item = this;
	
		                    return false;
		                }
		            });
	
		            this._current(item);
		        },
		        _template: kendo.template(
		            '<table class="k-palette k-reset" role="presentation"><tr role="row">' +
		              '# for (var i = 0; i < colors.length; ++i) { #' +
		                '# var selected = colors[i].equals(value); #' +
		                '# if (i && i % columns == 0) { # </tr><tr role="row"> # } #' +
		                '<td role="gridcell" unselectable="on" style="background-color:#= colors[i].toCss() #"' +
		                    '#= selected ? " aria-selected=true" : "" # ' +
		                    '#=(id && i === 0) ? "id=\\""+id+"\\" " : "" # ' +
		                    'class="k-item#= selected ? " ' + ITEMSELECTEDCLASS + '" : "" #" ' +
		                    'aria-label="#= colors[i].toCss() #"></td>' +
		              '# } #' +
		            '</tr></table>'
		        )
		    });
	
		    var FlatColorPicker = ColorSelector.extend({
		        init: function(element, options) {
		            var that = this;
		            ColorSelector.fn.init.call(that, element, options);
	
		            options = that.options;
		            options.messages = options.options ? $.extend(that.options.messages, options.options.messages) : that.options.messages;
		            element = that.element;
	
		            that.wrapper = element.addClass("k-widget k-flatcolorpicker")
		                .append(that._template(options));
	
		            that._hueElements = $(".k-hsv-rectangle, .k-transparency-slider .k-slider-track", element);
	
		            that._selectedColor = $(".k-selected-color-display", element);
	
		            that._colorAsText = $("input.k-color-value", element);
	
		            that._sliders();
	
		            that._hsvArea();
	
		            that._updateUI(that._value || parseColor("#f00"));
	
		            element
		                .find("input.k-color-value").on(KEYDOWN_NS, function(ev){
		                    var input = this;
		                    if (ev.keyCode == KEYS.ENTER) {
		                        try {
		                            var color = parseColor(input.value);
		                            var val = that.color();
		                            that._select(color, color.equals(val));
		                        } catch(ex) {
		                            $(input).addClass("k-state-error");
		                        }
		                    } else if (that.options.autoupdate) {
		                        setTimeout(function(){
		                            var color = parseColor(input.value, true);
		                            if (color) {
		                                that._updateUI(color, true);
		                            }
		                        }, 10);
		                    }
		                }).end()
	
		                .on(CLICK_NS, ".k-controls button.apply", function(){
		                    // calling select for the currently displayed
		                    // color will trigger the "change" event.
		                    if (that.options._clearedColor) {
		                        that.trigger("change");
		                    } else {
		                        that._select(that._getHSV());
		                    }
		                })
		                .on(CLICK_NS, ".k-controls button.cancel", function(){
		                    // but on cancel, we simply select the previous
		                    // value (again, triggers "change" event).
		                    that._updateUI(that.color());
		                    that._cancel();
		                });
	
		            if (isIE8) {
		                // IE filters require absolute URLs
		                that._applyIEFilter();
		            }
		        },
		        destroy: function() {
		            this._hueSlider.destroy();
		            if (this._opacitySlider) {
		                this._opacitySlider.destroy();
		            }
		            this._hueSlider = this._opacitySlider = this._hsvRect = this._hsvHandle =
		                this._hueElements = this._selectedColor = this._colorAsText = null;
		            ColorSelector.fn.destroy.call(this);
		        },
		        options: {
		            name       : "FlatColorPicker",
		            opacity    : false,
		            buttons    : false,
		            input      : true,
		            preview    : true,
		            clearButton: false,
		            autoupdate : true,
		            messages   : MESSAGES
		        },
		        _applyIEFilter: function() {
		            var track = this.element.find(".k-hue-slider .k-slider-track")[0],
		                url = track.currentStyle.backgroundImage;
	
		            url = url.replace(/^url\([\'\"]?|[\'\"]?\)$/g, "");
		            track.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + url + "', sizingMethod='scale')";
		        },
		        _sliders: function() {
		            var that = this,
		                element = that.element,
		                hueSlider = element.find(".k-hue-slider"),
		                opacitySlider = element.find(".k-transparency-slider");
	
		            function hueChange(e) {
		                that._updateUI(that._getHSV(e.value, null, null, null));
		            }
	
		            hueSlider.attr("aria-label", "hue saturation");
		            that._hueSlider = hueSlider.kendoSlider({
		                min: 0,
		                max: 360,
		                tickPlacement: "none",
		                showButtons: false,
		                slide: hueChange,
		                change: hueChange
		            }).data("kendoSlider");
	
		            function opacityChange(e) {
		                that._updateUI(that._getHSV(null, null, null, e.value / 100));
		            }
	
		            opacitySlider.attr("aria-label", "opacity");
		            that._opacitySlider = opacitySlider.kendoSlider({
		                min: 0,
		                max: 100,
		                tickPlacement: "none",
		                showButtons: false,
		                slide: opacityChange,
		                change: opacityChange
		            }).data("kendoSlider");
		        },
		        _hsvArea: function() {
		            var that = this,
		                element = that.element,
		                hsvRect = element.find(".k-hsv-rectangle"),
		                hsvHandle = hsvRect.find(".k-draghandle").attr("tabIndex", 0).on(KEYDOWN_NS, bind(that._keydown, that));
	
		            function update(x, y) {
		                var offset = this.offset,
		                    dx = x - offset.left, dy = y - offset.top,
		                    rw = this.width, rh = this.height;
	
		                dx = dx < 0 ? 0 : dx > rw ? rw : dx;
		                dy = dy < 0 ? 0 : dy > rh ? rh : dy;
		                that._svChange(dx / rw, 1 - dy / rh);
		            }
	
		            that._hsvEvents = new kendo.UserEvents(hsvRect, {
		                global: true,
		                press: function(e) {
		                    this.offset = kendo.getOffset(hsvRect);
		                    this.width = hsvRect.width();
		                    this.height = hsvRect.height();
		                    hsvHandle.focus();
		                    update.call(this, e.x.location, e.y.location);
		                },
		                start: function() {
		                    hsvRect.addClass("k-dragging");
		                    hsvHandle.focus();
		                },
		                move: function(e) {
		                    e.preventDefault();
		                    update.call(this, e.x.location, e.y.location);
		                },
		                end: function() {
		                    hsvRect.removeClass("k-dragging");
		                }
		            });
	
		            that._hsvRect = hsvRect;
		            that._hsvHandle = hsvHandle;
		        },
		        _onEnable: function(enable) {
		            this._hueSlider.enable(enable);
	
		            if (this._opacitySlider) {
		                this._opacitySlider.enable(enable);
		            }
	
		            this.wrapper.find("input").attr("disabled", !enable);
	
		            var handle = this._hsvRect.find(".k-draghandle");
	
		            if (enable) {
		                handle.attr("tabIndex", this._tabIndex);
		            } else {
		                handle.removeAttr("tabIndex");
		            }
		        },
		        _keydown: function(ev) {
		            var that = this;
		            function move(prop, d) {
		                var c = that._getHSV();
		                c[prop] += d * (ev.shiftKey ? 0.01 : 0.05);
		                if (c[prop] < 0) { c[prop] = 0; }
		                if (c[prop] > 1) { c[prop] = 1; }
		                that._updateUI(c);
		                preventDefault(ev);
		            }
		            function hue(d) {
		                var c = that._getHSV();
		                c.h += d * (ev.shiftKey ? 1 : 5);
		                if (c.h < 0) { c.h = 0; }
		                if (c.h > 359) { c.h = 359; }
		                that._updateUI(c);
		                preventDefault(ev);
		            }
		            switch (ev.keyCode) {
		              case KEYS.LEFT:
		                if (ev.ctrlKey) {
		                    hue(-1);
		                } else {
		                    move("s", -1);
		                }
		                break;
		              case KEYS.RIGHT:
		                if (ev.ctrlKey) {
		                    hue(1);
		                } else {
		                    move("s", 1);
		                }
		                break;
		              case KEYS.UP:
		                move(ev.ctrlKey && that._opacitySlider ? "a" : "v", 1);
		                break;
		              case KEYS.DOWN:
		                move(ev.ctrlKey && that._opacitySlider ? "a" : "v", -1);
		                break;
		              case KEYS.ENTER:
		                that._select(that._getHSV());
		                break;
		              case KEYS.F2:
		                that.wrapper.find("input.k-color-value").focus().select();
		                break;
		              case KEYS.ESC:
		                that._cancel();
		                break;
		            }
		        },
		        focus: function() {
		            this._hsvHandle.focus();
		        },
		        _getHSV: function(h, s, v, a) {
		            var rect = this._hsvRect,
		                width = rect.width(),
		                height = rect.height(),
		                handlePosition = this._hsvHandle.position();
	
		            if (h == null) {
		                h = this._hueSlider.value();
		            }
		            if (s == null) {
		                s = handlePosition.left / width;
		            }
		            if (v == null) {
		                v = 1 - handlePosition.top / height;
		            }
		            if (a == null) {
		                a = this._opacitySlider ? this._opacitySlider.value() / 100 : 1;
		            }
		            return Color.fromHSV(h, s, v, a);
		        },
		        _svChange: function(s, v) {
		            var color = this._getHSV(null, s, v, null);
		            this._updateUI(color);
		        },
		        _updateUI: function(color, dontChangeInput) {
		            var that = this,
		                rect = that._hsvRect;
	
		            if (!color) {
		                return;
		            }
	
		            this._colorAsText.attr("title", that.options.messages.previewInput);
		            this._colorAsText.removeClass("k-state-error");
	
		            that._selectedColor.css(BACKGROUNDCOLOR, color.toDisplay());
		            if (!dontChangeInput) {
		                that._colorAsText.val(that._opacitySlider ? color.toCssRgba() : color.toCss());
		            }
		            that._triggerSelect(color);
	
		            color = color.toHSV();
		            that._hsvHandle.css({
		                // saturation is 0 on the left side, full (1) on the right
		                left: color.s * rect.width() + "px",
		                // value is 0 on the bottom, full on the top.
		                top: (1 - color.v) * rect.height() + "px"
		            });
	
		            that._hueElements.css(BACKGROUNDCOLOR, Color.fromHSV(color.h, 1, 1, 1).toCss());
		            that._hueSlider.value(color.h);
	
		            if (that._opacitySlider) {
		                that._opacitySlider.value(100 * color.a);
		            }
		        },
		        _selectOnHide: function() {
		            return this.options.buttons ? null : this._getHSV();
		        },
		        _template: kendo.template(
		            '# if (preview) { #' +
		                '<div class="k-selected-color"><div class="k-selected-color-display"><div class="k-color-input"><input class="k-color-value" ' +
		                    '# if (clearButton && !_standalone) { #' +
		                        'placeholder="#: messages.noColor #" ' +
		                    '# } #' +
		                    '#= !data.input ? \'style=\"visibility: hidden;\"\' : \"\" #>' +
		                '# if (clearButton && !_standalone) { #' +
		                    '<span class="k-clear-color k-button k-bare" title="#: messages.clearColor #"></span>' +
		                '# } #' +
		                '</div></div></div>' +
		            '# } #' +
		             '# if (clearButton && !_standalone && !preview) { #' +
		                    '<div class="k-clear-color-container"><span class="k-clear-color k-button k-bare">#: messages.clearColor #</span></div>' +
		             '# } #' +
		            '<div class="k-hsv-rectangle"><div class="k-hsv-gradient"></div><div class="k-draghandle"></div></div>' +
		            '<input class="k-hue-slider" />' +
		            '# if (opacity) { #' +
		                '<input class="k-transparency-slider" />' +
		            '# } #' +
		            '# if (buttons) { #' +
		                '<div unselectable="on" class="k-controls"><button class="k-button k-primary apply">#: messages.apply #</button> <button class="k-button cancel">#: messages.cancel #</button></div>' +
		            '# } #'
		        )
		    });
	
		    function relative(array, element, delta) {
		        array = Array.prototype.slice.call(array);
		        var n = array.length;
		        var pos = array.indexOf(element);
		        if (pos < 0) {
		            return delta < 0 ? array[n - 1] : array[0];
		        }
		        pos += delta;
		        if (pos < 0) {
		            pos += n;
		        } else {
		            pos %= n;
		        }
		        return array[pos];
		    }
	
		    /* -----[ The ColorPicker widget ]----- */
	
		    var ColorPicker = Widget.extend({
		        init: function(element, options) {
		            var that = this;
		            Widget.fn.init.call(that, element, options);
		            options = that.options;
		            element = that.element;
	
		            var value = element.attr("value") || element.val();
		            if (value) {
		                value = parseColor(value, true);
		            } else {
		                value = parseColor(options.value, true);
		            }
		            that._value = options.value = value;
	
		            var content = that.wrapper = $(that._template(options));
		            element.hide().after(content);
	
		            if (element.is("input")) {
		                element.appendTo(content);
	
		                // if there exists a <label> associated with this
		                // input field, we must catch clicks on it to prevent
		                // the built-in color picker from showing up.
		                // https://github.com/telerik/kendo-ui-core/issues/292
	
		                var label = element.closest("label");
		                var id = element.attr("id");
		                if (id) {
		                    label = label.add('label[for="' + id + '"]');
		                }
		                label.click(function(ev){
		                    that.open();
		                    ev.preventDefault();
		                });
		            }
	
		            that._tabIndex = element.attr("tabIndex") || 0;
	
		            that.enable(!element.attr("disabled"));
	
		            var accesskey = element.attr("accesskey");
		            if (accesskey) {
		                element.attr("accesskey", null);
		                content.attr("accesskey", accesskey);
		            }
	
		            that.bind("activate", function(ev){
		                if (!ev.isDefaultPrevented()) {
		                    that.toggle();
		                }
		            });
	
		            that._updateUI(value);
		        },
		        destroy: function() {
		            this.wrapper.off(NS).find("*").off(NS);
		            if (this._popup) {
		                this._selector.destroy();
		                this._popup.destroy();
		            }
		            this._selector = this._popup = this.wrapper = null;
		            Widget.fn.destroy.call(this);
		        },
		        enable: function(enable) {
		            var that = this,
		                wrapper = that.wrapper,
		                innerWrapper = wrapper.children(".k-picker-wrap"),
		                arrow = innerWrapper.find(".k-select");
	
		            if (arguments.length === 0) {
		                enable = true;
		            }
	
		            that.element.attr("disabled", !enable);
		            wrapper.attr("aria-disabled", !enable);
	
		            arrow.off(NS).on("mousedown" + NS, preventDefault);
	
		            wrapper.addClass("k-state-disabled")
		                .removeAttr("tabIndex")
		                .add("*", wrapper).off(NS);
	
		            if (enable) {
		                wrapper.removeClass("k-state-disabled")
		                    .attr("tabIndex", that._tabIndex)
		                    .on("mouseenter" + NS, function () { innerWrapper.addClass("k-state-hover"); })
		                    .on("mouseleave" + NS, function () { innerWrapper.removeClass("k-state-hover"); })
		                    .on("focus" + NS, function () { innerWrapper.addClass("k-state-focused"); })
		                    .on("blur" + NS, function () { innerWrapper.removeClass("k-state-focused"); })
		                    .on(KEYDOWN_NS, bind(that._keydown, that))
		                    .on(CLICK_NS, ".k-select", bind(that.toggle, that))
		                    .on(CLICK_NS, that.options.toolIcon ? ".k-tool-icon" : ".k-selected-color", function () {
		                        that.trigger("activate");
		                    });
		            } else {
		                that.close();
		            }
		        },
	
		        _template: kendo.template(
		            '<span role="textbox" aria-haspopup="true" class="k-widget k-colorpicker">' +
		                '<span class="k-picker-wrap k-state-default">' +
		                    '# if (toolIcon) { #' +
		                        '<span class="k-icon k-tool-icon #= toolIcon #">' +
		                            '<span class="k-selected-color"></span>' +
		                        '</span>' +
		                    '# } else { #' +
		                        '<span class="k-selected-color"><span class="k-icon k-i-line" style="display: none;"></span></span>' +
		                    '# } #' +
		                    '<span class="k-select" unselectable="on" aria-label="select">' +
		                        '<span class="k-icon k-i-arrow-60-down"></span>' +
		                    '</span>' +
		                '</span>' +
		            '</span>'
		        ),
	
		        options: {
		            name: "ColorPicker",
		            palette: null,
		            columns: 10,
		            toolIcon: null,
		            value: null,
		            messages: MESSAGES,
		            opacity: false,
		            buttons: true,
		            preview: true,
		            clearButton: false,
		            ARIATemplate: 'Current selected color is #=data || ""#'
		        },
	
		        events: [ "activate", "change", "select", "open", "close" ],
	
		        open: function () {
		            if (!this.element.prop("disabled")) {
		                this._getPopup().open();
		            }
		        },
		        close: function () {
		            var selOptions = (this._selector && this._selector.options) || {};
		            selOptions._closing = true;
	
		            this._getPopup().close();
	
		            delete selOptions._closing;
		        },
		        toggle: function () {
		            if (!this.element.prop("disabled")) {
		                this._getPopup().toggle();
		            }
		        },
		        _noColorIcon: function(){
		            return this.wrapper.find(".k-picker-wrap > .k-selected-color > .k-icon.k-i-line");
		        },
		        color: ColorSelector.fn.color,
		        value: ColorSelector.fn.value,
		        _select: ColorSelector.fn._select,
		        _triggerSelect: ColorSelector.fn._triggerSelect,
		        _isInputTypeColor: function() {
		            var el = this.element[0];
		            return (/^input$/i).test(el.tagName) && (/^color$/i).test(el.type);
		        },
	
		        _updateUI: function(value) {
		            var formattedValue = "";
	
		            if (value) {
		                if (this._isInputTypeColor() || value.a == 1) {
		                    // seems that input type="color" doesn't support opacity
		                    // in colors; the only accepted format is hex #RRGGBB
		                    formattedValue = value.toCss();
		                } else {
		                    formattedValue = value.toCssRgba();
		                }
	
		                this.element.val(formattedValue);
		            }
	
		            if (!this._ariaTemplate) {
		                this._ariaTemplate = kendo.template(this.options.ARIATemplate);
		            }
	
		            this.wrapper.attr("aria-label", this._ariaTemplate(formattedValue));
	
		            this._triggerSelect(value);
		            this.wrapper.find(".k-selected-color").css(
		                BACKGROUNDCOLOR,
		                value ? value.toDisplay() : WHITE
		            );
	
		            this._noColorIcon()[formattedValue ? "hide": "show"]();
		        },
		        _keydown: function(ev) {
		            var key = ev.keyCode;
		            if (this._getPopup().visible()) {
		                if (key == KEYS.ESC) {
		                    this._selector._cancel();
		                } else {
		                    this._selector._keydown(ev);
		                }
		                preventDefault(ev);
		            }
		            else if (key == KEYS.ENTER || key == KEYS.DOWN) {
		                this.open();
		                preventDefault(ev);
		            }
		        },
		        _getPopup: function() {
		            var that = this, popup = that._popup;
	
		            if (!popup) {
		                var options = that.options;
		                var selectorType;
	
		                if (options.palette) {
		                    selectorType = ColorPalette;
		                } else {
		                    selectorType = FlatColorPicker;
		                }
	
		                options._standalone = false;
		                delete options.select;
		                delete options.change;
		                delete options.cancel;
	
		                var id = kendo.guid();
		                var selector = that._selector = new selectorType($('<div id="' + id +'"/>').appendTo(document.body), options);
	
		                that.wrapper.attr("aria-owns", id);
	
		                that._popup = popup = selector.wrapper.kendoPopup({
		                    anchor: that.wrapper,
		                    adjustSize: { width: 5, height: 0 }
		                }).data("kendoPopup");
	
		                selector.element.find(".k-clear-color").kendoButton({
		                    icon: "reset-color",
		                    click: function(e) {
		                        selector.options._clearedColor = true;
		                        that.value(null);
		                        that.element.val(null);
		                        that._updateUI(null);
		                        selector._colorAsText.val("");
		                        selector._hsvHandle.css({
		                            top: "0px",
		                            left: "0px"
		                        });
		                        selector._selectedColor.css(BACKGROUNDCOLOR, WHITE);
	
		                        that.trigger("change", { value: that.value() });
		                        e.preventDefault();
		                    }
		                });
	
		                selector.bind({
		                    select: function(ev){
		                        that._updateUI(parseColor(ev.value));
		                        delete selector.options._clearedColor;
		                    },
		                    change: function(){
		                        if (!selector.options._clearedColor) {
		                            that._select(selector.color());
		                        }
		                        that.close();
		                    },
		                    cancel: function() {
		                        if (selector.options._clearedColor && !that.value() && selector.value()) {
		                            that._select(selector.color(), true);
		                        }
		                        that.close();
		                    }
		                });
		                popup.bind({
		                    close: function(ev){
		                        if (that.trigger("close")) {
		                            ev.preventDefault();
		                            return;
		                        }
		                        that.wrapper.children(".k-picker-wrap").removeClass("k-state-focused");
		                        var color = selector._selectOnHide();
		                        var selectorColor = selector.value();
		                        var value = that.value();
		                        var options = selector.options;
		                        if (!color) {
		                            setTimeout(function(){
		                                if (that.wrapper && !that.wrapper.is("[unselectable='on']")) {
		                                    that.wrapper.focus();
		                                }
		                            });
	
		                            if (!options._closing && options._clearedColor && !value && selectorColor) {
		                                that._select(selectorColor, true);
		                            } else {
		                                that._updateUI(that.color());
		                            }
		                        } else if (!(options._clearedColor && !value)) {
		                            that._select(color);
		                        }
		                    },
		                    open: function(ev) {
		                        if (that.trigger("open")) {
		                            ev.preventDefault();
		                        } else {
		                            that.wrapper.children(".k-picker-wrap").addClass("k-state-focused");
		                        }
		                    },
		                    activate: function(){
		                        selector._select(that.color(), true);
		                        selector.focus();
		                        that.wrapper.children(".k-picker-wrap").addClass("k-state-focused");
		                    }
		                });
		            }
		            return popup;
		        }
		    });
	
		    function preventDefault(ev) { ev.preventDefault(); }
	
		    function bind(callback, obj) {
		        return function() {
		            return callback.apply(obj, arguments);
		        };
		    }
	
		    ui.plugin(ColorPalette);
		    ui.plugin(FlatColorPicker);
		    ui.plugin(ColorPicker);
	
		})(jQuery, parseInt);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ }),
	
	/***/ 1035:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(554);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1037:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(579);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1039:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(580);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1208);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1208:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1209) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "imagebrowser",
		    name: "ImageBrowser",
		    category: "web",
		    description: "",
		    hidden: true,
		    depends: [ "filebrowser" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        FileBrowser = kendo.ui.FileBrowser,
		        isPlainObject = $.isPlainObject,
		        proxy = $.proxy,
		        extend = $.extend,
		        browser = kendo.support.browser,
		        isFunction = kendo.isFunction,
		        trimSlashesRegExp = /(^\/|\/$)/g,
		        ERROR = "error",
		        NS = ".kendoImageBrowser",
		        NAMEFIELD = "name",
		        SIZEFIELD = "size",
		        TYPEFIELD = "type",
		        DEFAULTSORTORDER = { field: TYPEFIELD, dir: "asc" },
		        EMPTYTILE = kendo.template('<li class="k-tile-empty"><strong>${text}</strong></li>');
	
		    extend(true, kendo.data, {
		        schemas: {
		            "imagebrowser": {
		                data: function(data) {
		                    return data.items || data || [];
		                },
		                model: {
		                    id: "name",
		                    fields: {
		                        name: "name",
		                        size: "size",
		                        type: "type"
		                    }
		                }
		            }
		        }
		    });
	
		    extend(true, kendo.data, {
		        transports: {
		            "imagebrowser": kendo.data.RemoteTransport.extend({
		                init: function(options) {
		                    kendo.data.RemoteTransport.fn.init.call(this, $.extend(true, {}, this.options, options));
		                },
		                _call: function(type, options) {
		                    options.data = $.extend({}, options.data, { path: this.options.path() });
	
		                    if (isFunction(this.options[type])) {
		                        this.options[type].call(this, options);
		                    } else {
		                        kendo.data.RemoteTransport.fn[type].call(this, options);
		                    }
		                },
		                read: function(options) {
		                    this._call("read", options);
		                },
		                create: function(options) {
		                    this._call("create", options);
		                },
		                destroy: function(options) {
		                    this._call("destroy", options);
		                },
		                update: function() {
		                    //updates are handled by the upload
		                },
		                options: {
		                    read: {
		                        type: "POST"
		                    },
		                    update: {
		                        type: "POST"
		                    },
		                    create: {
		                        type: "POST"
		                    },
		                    destroy: {
		                        type: "POST"
		                    }
		                }
		            })
		        }
		    });
	
		    var offsetTop;
		    if (browser.msie && browser.version < 8) {
		        offsetTop = function (element) {
		            return element.offsetTop;
		        };
		    } else {
		        offsetTop = function (element) {
		            return element.offsetTop - $(element).height();
		        };
		    }
	
		    function concatPaths(path, name) {
		        if(path === undefined || !path.match(/\/$/)) {
		            path = (path || "") + "/";
		        }
		        return path + name;
		    }
	
		    function sizeFormatter(value) {
		        if(!value) {
		            return "";
		        }
	
		        var suffix = " bytes";
	
		        if (value >= 1073741824) {
		            suffix = " GB";
		            value /= 1073741824;
		        } else if (value >= 1048576) {
		            suffix = " MB";
		            value /= 1048576;
		        } else  if (value >= 1024) {
		            suffix = " KB";
		            value /= 1024;
		        }
	
		        return Math.round(value * 100) / 100 + suffix;
		    }
	
		    var ImageBrowser = FileBrowser.extend({
		        init: function(element, options) {
		            var that = this;
	
		            options = options || {};
	
		            FileBrowser.fn.init.call(that, element, options);
	
		            that.element.addClass("k-imagebrowser");
		        },
	
		        options: {
		            name: "ImageBrowser",
		            fileTypes: "*.png,*.gif,*.jpg,*.jpeg"
		        },
	
		        value: function () {
		            var that = this,
		                selected = that._selectedItem(),
		                path,
		                imageUrl = that.options.transport.imageUrl;
	
		            if (selected && selected.get(TYPEFIELD) === "f") {
		                path = concatPaths(that.path(), selected.get(NAMEFIELD)).replace(trimSlashesRegExp, "");
		                if (imageUrl) {
		                    path = isFunction(imageUrl) ? imageUrl(path) : kendo.format(imageUrl, encodeURIComponent(path));
		                }
		                return path;
		            }
		        },
	
		        _fileUpload: function(e) {
		            var that = this,
		                options = that.options,
		                fileTypes = options.fileTypes,
		                filterRegExp = new RegExp(("(" + fileTypes.split(",").join(")|(") + ")").replace(/\*\./g , ".*."), "i"),
		                fileName = e.files[0].name,
		                fileNameField = NAMEFIELD,
		                sizeField = SIZEFIELD,
		                file;
	
		            if (filterRegExp.test(fileName)) {
		                e.data = { path: that.path() };
	
		                file = that._createFile(fileName);
	
		                if (!file) {
		                    e.preventDefault();
		                } else {
		                    file._uploading = true;
		                    that.upload.one("success", function(e) {
		                        delete file._uploading;
	
		                        var model = that._insertFileToList(file);
		                        model.set(fileNameField, e.response[that._getFieldName(fileNameField)]);
		                        model.set(sizeField, e.response[that._getFieldName(sizeField)]);
	
		                        that._tiles = that.listView.items().filter("[" + kendo.attr("type") + "=f]");
		                        that._scroll();
		                    });
		                }
		            } else {
		                e.preventDefault();
		                that._showMessage(kendo.format(options.messages.invalidFileType, fileName, fileTypes));
		            }
		        },
	
		        _content: function() {
		            var that = this;
	
		            that.list = $('<ul class="k-reset k-floats k-tiles" />')
		                .appendTo(that.element)
		                .on("scroll" + NS, proxy(that._scroll, that))
		                .on("dblclick" + NS, "li", proxy(that._dblClick, that));
	
		            that.listView = new kendo.ui.ListView(that.list, {
		                dataSource: that.dataSource,
		                template: that._itemTmpl(),
		                editTemplate: that._editTmpl(),
		                selectable: true,
		                autoBind: false,
		                dataBinding: function(e) {
	
		                    that.toolbar.find(".k-i-close").parent().addClass("k-state-disabled");
	
		                    if (e.action === "remove" || e.action === "sync") {
		                        e.preventDefault();
		                        kendo.ui.progress(that.listView.element, false);
		                    }
		                },
		                dataBound: function() {
		                    if (that.dataSource.view().length) {
		                        that._tiles = this.items().filter("[" + kendo.attr("type") + "=f]");
		                        that._scroll();
		                    } else {
		                        this.wrapper.append(EMPTYTILE({ text: that.options.messages.emptyFolder }));
		                    }
		                },
		                change: proxy(that._listViewChange, that)
		            });
		        },
	
		        _dataSource: function() {
		            var that = this,
		                options = that.options,
		                transport = options.transport,
		                typeSortOrder = extend({}, DEFAULTSORTORDER),
		                nameSortOrder = { field: NAMEFIELD, dir: "asc" },
		                schema,
		                dataSource = {
		                    type: transport.type || "imagebrowser",
		                    sort: [typeSortOrder, nameSortOrder]
		                };
	
		            if (isPlainObject(transport)) {
		                transport.path = proxy(that.path, that);
		                dataSource.transport = transport;
		            }
	
		            if (isPlainObject(options.schema)) {
		                dataSource.schema = options.schema;
		            } else if (transport.type && isPlainObject(kendo.data.schemas[transport.type])) {
		                schema = kendo.data.schemas[transport.type];
		            }
	
		            if (that.dataSource && that._errorHandler) {
		                that.dataSource.unbind(ERROR, that._errorHandler);
		            } else {
		                that._errorHandler = proxy(that._error, that);
		            }
	
		            that.dataSource = kendo.data.DataSource.create(dataSource)
		                .bind(ERROR, that._errorHandler);
		        },
	
		        _loadImage: function(li) {
		            var that = this,
		                element = $(li),
		                dataItem = that.dataSource.getByUid(element.attr(kendo.attr("uid"))),
		                name = dataItem.get(NAMEFIELD),
		                thumbnailUrl = that.options.transport.thumbnailUrl,
		                img = $("<img />", { alt: name }),
		                urlJoin = "?";
	
		            if (dataItem._uploading) {
		                return;
		            }
	
		            img.hide()
		               .on("load" + NS, function() {
		                   $(this).prev().remove().end().addClass("k-image").fadeIn();
		               });
	
		            element.find(".k-i-loading").after(img);
	
		            if (isFunction(thumbnailUrl)) {
		                thumbnailUrl = thumbnailUrl(that.path(), encodeURIComponent(name));
		            } else {
		                if (thumbnailUrl.indexOf("?") >= 0) {
		                    urlJoin = "&";
		                }
	
		                thumbnailUrl = thumbnailUrl + urlJoin + "path=" + encodeURIComponent(that.path() + name);
		                if (dataItem._override) {
		                    thumbnailUrl += "&_=" + new Date().getTime();
		                    delete dataItem._override;
		                }
		            }
	
		            // IE8 will trigger the load event immediately when the src is assigned
		            // if the image is loaded from the cache
		            img.attr("src", thumbnailUrl);
	
		            li.loaded = true;
		        },
	
		        _scroll: function() {
		            var that = this;
		            if (that.options.transport && that.options.transport.thumbnailUrl) {
		                clearTimeout(that._timeout);
	
		                that._timeout = setTimeout(function() {
		                    var height = kendo._outerHeight(that.list),
		                        viewTop = that.list.scrollTop(),
		                        viewBottom = viewTop + height;
	
		                    that._tiles.each(function() {
		                        var top = offsetTop(this),
		                            bottom = top + this.offsetHeight;
	
		                        if ((top >= viewTop && top < viewBottom) || (bottom >= viewTop && bottom < viewBottom)) {
		                            that._loadImage(this);
		                        }
	
		                        if (top > viewBottom) {
		                            return false;
		                        }
		                    });
	
		                    that._tiles = that._tiles.filter(function() {
		                        return !this.loaded;
		                    });
	
		                }, 250);
		            }
		        },
	
		        _itemTmpl: function() {
		            var that = this,
		                html = '<li class="k-tile" ' + kendo.attr("uid") + '="#=uid#" ';
	
		            html += kendo.attr("type") + '="${' + TYPEFIELD + '}">';
		            html += '#if(' + TYPEFIELD + ' == "d") { #';
		            html += '<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>';
		            html += "#}else{#";
		            if (that.options.transport && that.options.transport.thumbnailUrl) {
		                html += '<div class="k-thumb"><span class="k-icon k-i-loading"></span></div>';
		            } else {
		                html += '<div class="k-thumb"><span class="k-icon k-i-file"></span></div>';
		            }
		            html += "#}#";
		            html += '<strong>${' + NAMEFIELD + '}</strong>';
		            html += '#if(' + TYPEFIELD + ' == "f") { # <span class="k-filesize">${this.sizeFormatter(' + SIZEFIELD + ')}</span> #}#';
		            html += '</li>';
	
		            return proxy(kendo.template(html), { sizeFormatter: sizeFormatter } );
		        }
		    });
	
		    kendo.ui.plugin(ImageBrowser);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1209:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(597);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1178);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1178:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1179), __webpack_require__(1008), __webpack_require__(1180) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "filebrowser",
		    name: "FileBrowser",
		    category: "web",
		    description: "",
		    hidden: true,
		    depends: [ "selectable", "listview", "dropdownlist", "upload" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        isPlainObject = $.isPlainObject,
		        proxy = $.proxy,
		        extend = $.extend,
		        placeholderSupported = kendo.support.placeholder,
		        browser = kendo.support.browser,
		        isFunction = kendo.isFunction,
		        trimSlashesRegExp = /(^\/|\/$)/g,
		        CHANGE = "change",
		        APPLY = "apply",
		        ERROR = "error",
		        CLICK = "click",
		        NS = ".kendoFileBrowser",
		        BREADCRUBMSNS = ".kendoBreadcrumbs",
		        SEARCHBOXNS = ".kendoSearchBox",
		        NAMEFIELD = "name",
		        SIZEFIELD = "size",
		        TYPEFIELD = "type",
		        DEFAULTSORTORDER = { field: TYPEFIELD, dir: "asc" },
		        EMPTYTILE = kendo.template('<li class="k-tile-empty"><strong>${text}</strong></li>'),
		        TOOLBARTMPL = '<div class="k-widget k-filebrowser-toolbar k-header k-floatwrap">' +
		                            '<div class="k-toolbar-wrap">' +
		                                '# if (showUpload) { # ' +
		                                    '<div class="k-widget k-upload"><div class="k-button k-button-icontext k-upload-button">' +
		                                        '<span class="k-icon k-i-plus"></span>#=messages.uploadFile#<input type="file" name="file" /></div></div>' +
		                                '# } #' +
	
		                                '# if (showCreate) { #' +
		                                     '<button type="button" class="k-button k-button-icon"><span class="k-icon k-i-folder-add" /></button>' +
		                                '# } #' +
	
		                                '# if (showDelete) { #' +
		                                    '<button type="button" class="k-button k-button-icon k-state-disabled"><span class="k-icon k-i-close" /></button>&nbsp;' +
		                                '# } #' +
		                            '</div>' +
		                            '<div class="k-tiles-arrange">' +
		                                '<label>#=messages.orderBy#: <select /></label>' +
		                            '</div>' +
		                        '</div>';
	
		    extend(true, kendo.data, {
		        schemas: {
		            "filebrowser": {
		                data: function(data) {
		                    return data.items || data || [];
		                },
		                model: {
		                    id: "name",
		                    fields: {
		                        name: "name",
		                        size: "size",
		                        type: "type"
		                    }
		                }
		            }
		        }
		    });
	
		    extend(true, kendo.data, {
		        transports: {
		            "filebrowser": kendo.data.RemoteTransport.extend({
		                init: function(options) {
		                    kendo.data.RemoteTransport.fn.init.call(this, $.extend(true, {}, this.options, options));
		                },
		                _call: function(type, options) {
		                    options.data = $.extend({}, options.data, { path: this.options.path() });
	
		                    if (isFunction(this.options[type])) {
		                        this.options[type].call(this, options);
		                    } else {
		                        kendo.data.RemoteTransport.fn[type].call(this, options);
		                    }
		                },
		                read: function(options) {
		                    this._call("read", options);
		                },
		                create: function(options) {
		                    this._call("create", options);
		                },
		                destroy: function(options) {
		                    this._call("destroy", options);
		                },
		                update: function() {
		                    //updates are handled by the upload
		                },
		                options: {
		                    read: {
		                        type: "POST"
		                    },
		                    update: {
		                        type: "POST"
		                    },
		                    create: {
		                        type: "POST"
		                    },
		                    destroy: {
		                        type: "POST"
		                    }
		                }
		            })
		        }
		    });
	
		    function bindDragEventWrappers(element, onDragEnter, onDragLeave) {
		        var hideInterval, lastDrag;
	
		        element
		            .on("dragenter" + NS, function() {
		                onDragEnter();
		                lastDrag = new Date();
	
		                if (!hideInterval) {
		                    hideInterval = setInterval(function() {
		                        var sinceLastDrag = new Date() - lastDrag;
		                        if (sinceLastDrag > 100) {
		                            onDragLeave();
	
		                            clearInterval(hideInterval);
		                            hideInterval = null;
		                        }
		                    }, 100);
		                }
		            })
		            .on("dragover" + NS, function() {
		                lastDrag = new Date();
		            });
		    }
	
		    var offsetTop;
		    if (browser.msie && browser.version < 8) {
		        offsetTop = function (element) {
		            return element.offsetTop;
		        };
		    } else {
		        offsetTop = function (element) {
		            return element.offsetTop - $(element).height();
		        };
		    }
	
		    function concatPaths(path, name) {
		        if(path === undefined || !path.match(/\/$/)) {
		            path = (path || "") + "/";
		        }
		        return path + name;
		    }
	
		    function sizeFormatter(value) {
		        if(!value) {
		            return "";
		        }
	
		        var suffix = " bytes";
	
		        if (value >= 1073741824) {
		            suffix = " GB";
		            value /= 1073741824;
		        } else if (value >= 1048576) {
		            suffix = " MB";
		            value /= 1048576;
		        } else  if (value >= 1024) {
		            suffix = " KB";
		            value /= 1024;
		        }
	
		        return Math.round(value * 100) / 100 + suffix;
		    }
	
		    function fieldName(fields, name) {
		        var descriptor = fields[name];
	
		        if (isPlainObject(descriptor)) {
		            return descriptor.from || descriptor.field || name;
		        }
		        return descriptor;
		    }
	
		    var FileBrowser = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            options = options || {};
	
		            Widget.fn.init.call(that, element, options);
	
		            that.element.addClass("k-filebrowser");
	
		            that.element
		                .on(CLICK + NS, ".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-close)", proxy(that._deleteClick, that))
		                .on(CLICK + NS, ".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-folder-add)", proxy(that._addClick, that))
		                .on("keydown" + NS, "li.k-state-selected input", proxy(that._directoryKeyDown, that))
		                .on("blur" + NS, "li.k-state-selected input", proxy(that._directoryBlur, that));
	
		            that._dataSource();
	
		            that.refresh();
	
		            that.path(that.options.path);
		        },
	
		        options: {
		            name: "FileBrowser",
		            messages: {
		                uploadFile: "Upload",
		                orderBy: "Arrange by",
		                orderByName: "Name",
		                orderBySize: "Size",
		                directoryNotFound: "A directory with this name was not found.",
		                emptyFolder: "Empty Folder",
		                deleteFile: 'Are you sure you want to delete "{0}"?',
		                invalidFileType: "The selected file \"{0}\" is not valid. Supported file types are {1}.",
		                overwriteFile: "A file with name \"{0}\" already exists in the current directory. Do you want to overwrite it?",
		                dropFilesHere: "drop file here to upload",
		                search: "Search"
		            },
		            transport: {},
		            path: "/",
		            fileTypes: "*.*"
		        },
	
		        events: [ERROR, CHANGE, APPLY],
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.dataSource
		                .unbind(ERROR, that._errorHandler);
	
		            that.element
		                .add(that.list)
		                .add(that.toolbar)
		                .off(NS);
	
		            kendo.destroy(that.element);
		        },
	
		        value: function() {
		            var that = this,
		                selected = that._selectedItem(),
		                path,
		                fileUrl = that.options.transport.fileUrl;
	
		            if (selected && selected.get(TYPEFIELD) === "f") {
		                path = concatPaths(that.path(), selected.get(NAMEFIELD)).replace(trimSlashesRegExp, "");
		                if (fileUrl) {
		                    path = isFunction(fileUrl) ? fileUrl(path) : kendo.format(fileUrl, encodeURIComponent(path));
		                }
		                return path;
		            }
		        },
	
		        _selectedItem: function() {
		            var listView = this.listView,
		                selected = listView.select();
	
		            if (selected.length) {
		                return this.dataSource.getByUid(selected.attr(kendo.attr("uid")));
		            }
		        },
	
		        _toolbar: function() {
		            var that = this,
		                template = kendo.template(TOOLBARTMPL),
		                messages = that.options.messages,
		                arrangeBy = [
		                    { text: messages.orderByName, value: "name" },
		                    { text: messages.orderBySize, value: "size" }
		                ];
	
		            that.toolbar = $(template({
		                    messages: messages,
		                    showUpload: that.options.transport.uploadUrl,
		                    showCreate: that.options.transport.create,
		                    showDelete: that.options.transport.destroy
		                }))
		                .appendTo(that.element)
		                .find(".k-upload input")
		                .kendoUpload({
		                    multiple: false,
		                    localization: {
		                        dropFilesHere: messages.dropFilesHere
		                    },
		                    async: {
		                        saveUrl: that.options.transport.uploadUrl,
		                        autoUpload: true
		                    },
		                    upload: proxy(that._fileUpload, that),
		                    error: function(e) {
		                        that._error({ xhr: e.XMLHttpRequest, status: "error" });
		                    }
		                }).end();
	
		            that.upload = that.toolbar
		                .find(".k-upload input")
		                .data("kendoUpload");
	
		            that.arrangeBy = that.toolbar.find(".k-tiles-arrange select")
		                .kendoDropDownList({
		                    dataSource: arrangeBy,
		                    dataTextField: "text",
		                    dataValueField: "value",
		                    change: function() {
		                        that.orderBy(this.value());
		                    }
		                })
		                .data("kendoDropDownList");
	
		            that._attachDropzoneEvents();
		        },
	
		        _attachDropzoneEvents: function() {
		            var that = this;
	
		            if (that.options.transport.uploadUrl) {
		                bindDragEventWrappers($(document.documentElement),
		                    $.proxy(that._dropEnter, that),
		                    $.proxy(that._dropLeave, that)
		                );
		                that._scrollHandler = proxy(that._positionDropzone, that);
		            }
		        },
	
		        _dropEnter: function() {
		            this._positionDropzone();
		            $(document).on("scroll" + NS, this._scrollHandler);
		        },
	
		        _dropLeave: function() {
		            this._removeDropzone();
		            $(document).off("scroll" + NS, this._scrollHandler);
		        },
	
		        _positionDropzone: function() {
		            var that = this,
		                element = that.element,
		                offset = element.offset();
	
		            that.toolbar.find(".k-dropzone")
		                .addClass("k-filebrowser-dropzone")
		                .offset(offset)
		                .css({
		                    width: element[0].clientWidth,
		                    height: element[0].clientHeight,
		                    lineHeight: element[0].clientHeight + "px"
		                });
		        },
	
		        _removeDropzone: function() {
		            this.toolbar.find(".k-dropzone")
		                .removeClass("k-filebrowser-dropzone")
		                .css({ width: "", height: "", lineHeight: "", top: "", left: "" });
		        },
	
		        _deleteClick: function() {
		            var that = this,
		                item = that.listView.select(),
		                message = kendo.format(that.options.messages.deleteFile, item.find("strong").text());
	
		            if (item.length && that._showMessage(message, "confirm")) {
		                that.listView.remove(item);
		            }
		        },
	
		        _addClick: function() {
		            this.createDirectory();
		        },
	
		        _getFieldName: function(name) {
		            return fieldName(this.dataSource.reader.model.fields, name);
		        },
	
		        _fileUpload: function(e) {
		            var that = this,
		                options = that.options,
		                fileTypes = options.fileTypes,
		                filterRegExp = new RegExp(("(" + fileTypes.split(",").join(")|(") + ")").replace(/\*\./g , ".*."), "i"),
		                fileName = e.files[0].name,
		                fileNameField = NAMEFIELD,
		                sizeField = SIZEFIELD,
		                file;
	
		            if (filterRegExp.test(fileName)) {
		                e.data = { path: that.path() };
	
		                file = that._createFile(fileName);
	
		                if (!file) {
		                    e.preventDefault();
		                } else {
		                    that.upload.one("success", function(e) {
		                        var model = that._insertFileToList(file);
		                        model.set(fileNameField, e.response[that._getFieldName(fileNameField)]);
		                        model.set(sizeField, e.response[that._getFieldName(sizeField)]);
	
		                        that._tiles = that.listView.items().filter("[" + kendo.attr("type") + "=f]");
		                    });
		                }
		            } else {
		                e.preventDefault();
		                that._showMessage(kendo.format(options.messages.invalidFileType, fileName, fileTypes));
		            }
		        },
	
		        _findFile: function(name) {
		            var data = this.dataSource.data(),
		                idx,
		                result,
		                typeField = TYPEFIELD,
		                nameField = NAMEFIELD,
		                length;
	
		            name = name.toLowerCase();
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if (data[idx].get(typeField) === "f" &&
		                    data[idx].get(nameField).toLowerCase() === name) {
	
		                    result = data[idx];
		                    break;
		                }
		            }
		            return result;
		        },
	
		        _createFile: function(fileName) {
		            var that = this,
		                model = {},
		                typeField = TYPEFIELD,
		                file = that._findFile(fileName);
	
		            if (file) {
		                if (!that._showMessage(kendo.format(that.options.messages.overwriteFile, fileName), "confirm")) {
		                    return null;
		                } else {
		                    file._override = true;
		                    return file;
		                }
		            }
	
		            model[typeField] = "f";
		            model[NAMEFIELD] = fileName;
		            model[SIZEFIELD] = 0;
	
		            return model;
		        },
	
		        _insertFileToList: function(model) {
		            var index;
		            if(model._override) {
		                return model;
		            }
	
		            var dataSource = this.dataSource;
		            var view = dataSource.view();
	
		            for (var i = 0, length = view.length; i < length; i++) {
		                if (view[i].get(TYPEFIELD) === "f") {
		                    index = i;
		                    break;
		                }
		            }
	
		            return dataSource.insert(++index, model);
		        },
	
		        createDirectory: function() {
		            var that = this,
		                idx,
		                length,
		                lastDirectoryIdx = 0,
		                typeField = TYPEFIELD,
		                nameField = NAMEFIELD,
		                view = that.dataSource.data(),
		                name = that._nameDirectory(),
		                model = new that.dataSource.reader.model();
	
		            for (idx = 0, length = view.length; idx < length; idx++) {
		                if (view[idx].get(typeField) === "d") {
		                    lastDirectoryIdx = idx;
		                }
		            }
	
		            model.set(typeField, "d");
		            model.set(nameField, name);
	
		            that.listView.one("dataBound", function() {
		                var selected = that.listView.items()
		                    .filter("[" + kendo.attr("uid") + "=" + model.uid + "]"),
		                    input = selected.find("input");
	
		                if (selected.length) {
		                    this.edit(selected);
		                }
	
		                this.element.scrollTop(selected.attr("offsetTop") - this.element[0].offsetHeight);
	
		                setTimeout(function() {
		                    input.select();
		                });
		            })
		            .one("save", function(e) {
		                var value = e.model.get(nameField);
	
		                if (!value) {
		                    e.model.set(nameField, name);
		                } else {
		                    e.model.set(nameField, that._nameExists(value, model.uid) ? that._nameDirectory() : value);
		                }
		            });
	
		            that.dataSource.insert(++lastDirectoryIdx, model);
		        },
	
		        _directoryKeyDown: function(e) {
		            if (e.keyCode == 13) {
		                e.currentTarget.blur();
		            }
		        },
	
		        _directoryBlur: function() {
		            this.listView.save();
		        },
	
		        _nameExists: function(name, uid) {
		            var data = this.dataSource.data(),
		                typeField = TYPEFIELD,
		                nameField = NAMEFIELD,
		                idx,
		                length;
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if (data[idx].get(typeField) === "d" &&
		                    data[idx].get(nameField).toLowerCase() === name.toLowerCase() &&
		                    data[idx].uid !== uid) {
		                    return true;
		                }
		            }
		            return false;
		        },
	
		        _nameDirectory: function() {
		            var name = "New folder",
		                data = this.dataSource.data(),
		                directoryNames = [],
		                typeField = TYPEFIELD,
		                nameField = NAMEFIELD,
		                candidate,
		                idx,
		                length;
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if (data[idx].get(typeField) === "d" && data[idx].get(nameField).toLowerCase().indexOf(name.toLowerCase()) > -1) {
		                    directoryNames.push(data[idx].get(nameField));
		                }
		            }
	
		            if ($.inArray(name, directoryNames) > -1) {
		                idx = 2;
	
		                do {
		                    candidate = name + " (" + idx + ")";
		                    idx++;
		                } while ($.inArray(candidate, directoryNames) > -1);
	
		                name = candidate;
		            }
	
		            return name;
		        },
	
		        orderBy: function(field) {
		            this.dataSource.sort([
		                { field: TYPEFIELD, dir: "asc" },
		                { field: field, dir: "asc" }
		            ]);
		        },
	
		        search: function(name) {
		            this.dataSource.filter({
		                field: NAMEFIELD,
		                operator: "contains",
		                value: name
		            });
		        },
	
		        _content: function() {
		            var that = this;
	
		            that.list = $('<ul class="k-reset k-floats k-tiles" />')
		                .appendTo(that.element)
		                .on("dblclick" + NS, "li", proxy(that._dblClick, that));
	
		            that.listView = new kendo.ui.ListView(that.list, {
		                dataSource: that.dataSource,
		                template: that._itemTmpl(),
		                editTemplate: that._editTmpl(),
		                selectable: true,
		                autoBind: false,
		                dataBinding: function(e) {
		                    that.toolbar.find(".k-i-close").parent().addClass("k-state-disabled");
	
		                    if (e.action === "remove" || e.action === "sync") {
		                        e.preventDefault();
		                        kendo.ui.progress(that.listView.element, false);
		                    }
		                },
		                dataBound: function() {
		                    if (that.dataSource.view().length) {
		                        that._tiles = this.items().filter("[" + kendo.attr("type") + "=f]");
		                    } else {
		                        this.wrapper.append(EMPTYTILE({ text: that.options.messages.emptyFolder }));
		                    }
		                },
		                change: proxy(that._listViewChange, that)
		            });
		        },
	
		        _dblClick: function(e) {
		            var that = this,
		                li = $(e.currentTarget);
	
		            if (li.hasClass("k-edit-item")) {
		                that._directoryBlur();
		            }
	
		            if (li.filter("[" + kendo.attr("type") + "=d]").length) {
		                var folder = that.dataSource.getByUid(li.attr(kendo.attr("uid")));
		                if (folder) {
		                    that.path(concatPaths(that.path(), folder.get(NAMEFIELD)));
		                    that.breadcrumbs.value(that.path());
		                }
		            } else if (li.filter("[" + kendo.attr("type") + "=f]").length) {
		                that.trigger(APPLY);
		            }
		        },
	
		        _listViewChange: function() {
		            var selected = this._selectedItem();
	
		            if (selected) {
		                this.toolbar.find(".k-i-close").parent().removeClass("k-state-disabled");
		                this.trigger(CHANGE, { selected: selected });
		            }
		        },
	
		        _dataSource: function() {
		            var that = this,
		                options = that.options,
		                transport = options.transport,
		                typeSortOrder = extend({}, DEFAULTSORTORDER),
		                nameSortOrder = { field: NAMEFIELD, dir: "asc" },
		                schema,
		                dataSource = {
		                    type: transport.type || "filebrowser",
		                    sort: [typeSortOrder, nameSortOrder]
		                };
	
		            if (isPlainObject(transport)) {
		                transport.path = proxy(that.path, that);
		                dataSource.transport = transport;
		            }
	
		            if (isPlainObject(options.schema)) {
		                dataSource.schema = options.schema;
		            } else if (transport.type && isPlainObject(kendo.data.schemas[transport.type])) {
		                schema = kendo.data.schemas[transport.type];
		            }
	
		            if (that.dataSource && that._errorHandler) {
		                that.dataSource.unbind(ERROR, that._errorHandler);
		            } else {
		                that._errorHandler = proxy(that._error, that);
		            }
	
		            that.dataSource = kendo.data.DataSource.create(dataSource)
		                .bind(ERROR, that._errorHandler);
		        },
	
		        _navigation: function() {
		            var that = this,
		                navigation = $('<div class="k-floatwrap"><input/><input/></div>')
		                    .appendTo(this.element);
	
		            that.breadcrumbs = navigation.find("input:first")
		                    .kendoBreadcrumbs({
		                        value: that.options.path,
		                        change: function() {
		                            that.path(this.value());
		                        }
		                    }).data("kendoBreadcrumbs");
	
		            that.searchBox = navigation.parent().find("input:last")
		                    .kendoSearchBox({
		                        label: that.options.messages.search,
		                        change: function() {
		                            that.search(this.value());
		                        }
		                    }).data("kendoSearchBox");
		        },
	
		        _error: function(e) {
		            var that = this,
		                status;
	
		            if (!that.trigger(ERROR, e)) {
		                status = e.xhr.status;
	
		                if (e.status == 'error') {
		                    if (status == '404') {
		                        that._showMessage(that.options.messages.directoryNotFound);
		                    } else if (status != '0') {
		                        that._showMessage('Error! The requested URL returned ' + status + ' - ' + e.xhr.statusText);
		                    }
		                } else if (status == 'timeout') {
		                    that._showMessage('Error! Server timeout.');
		                }
	
		                var dataSource = that.dataSource;
		                if (dataSource.hasChanges()) {
		                    dataSource.cancelChanges();
		                }
		            }
		        },
	
		        _showMessage: function(message, type) {
		            return window[type || "alert"](message);
		        },
	
		        refresh: function() {
		            var that = this;
		            that._navigation();
		            that._toolbar();
		            that._content();
		        },
	
		        _editTmpl: function() {
		            var html = '<li class="k-tile k-state-selected" ' + kendo.attr("uid") + '="#=uid#" ';
	
		            html += kendo.attr("type") + '="${' + TYPEFIELD + '}">';
		            html += '#if(' + TYPEFIELD + ' == "d") { #';
		            html += '<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>';
		            html += "#}else{#";
		            html += '<div class="k-thumb"><span class="k-icon k-i-loading"></span></div>';
		            html += "#}#";
		            html += '#if(' + TYPEFIELD + ' == "d") { #';
		            html += '<input class="k-input" ' + kendo.attr("bind") + '="value:' + NAMEFIELD + '"/>';
		            html += "#}#";
		            html += '</li>';
	
		            return proxy(kendo.template(html), { sizeFormatter: sizeFormatter } );
		        },
	
		        _itemTmpl: function() {
		            var html = '<li class="k-tile" ' + kendo.attr("uid") + '="#=uid#" ';
	
		            html += kendo.attr("type") + '="${' + TYPEFIELD + '}">';
		            html += '#if(' + TYPEFIELD + ' == "d") { #';
		            html += '<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>';
		            html += "#}else{#";
		            html += '<div class="k-thumb"><span class="k-icon k-i-file"></span></div>';
		            html += "#}#";
		            html += '<strong>${' + NAMEFIELD + '}</strong>';
		            html += '#if(' + TYPEFIELD + ' == "f") { # <span class="k-filesize">${this.sizeFormatter(' + SIZEFIELD + ')}</span> #}#';
		            html += '</li>';
	
		            return proxy(kendo.template(html), { sizeFormatter: sizeFormatter } );
		        },
	
		        path: function(value) {
		            var that = this,
		                path = that._path || "";
	
		            if (value !== undefined) {
		                that._path = value.replace(trimSlashesRegExp, "") + "/";
		                that.dataSource.read({ path: that._path });
		                return;
		            }
	
		            if (path) {
		                path = path.replace(trimSlashesRegExp, "");
		            }
	
		            return path === "/" || path === "" ? "" : (path + "/");
		        }
		    });
	
		    var SearchBox = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            options = options || {};
	
		            Widget.fn.init.call(that, element, options);
	
		            if (placeholderSupported) {
		                that.element.attr("placeholder", that.options.label);
		            }
	
		            that._wrapper();
	
		            that.element
		                .on("keydown" + SEARCHBOXNS, proxy(that._keydown, that))
		                .on("change" + SEARCHBOXNS, proxy(that._updateValue, that));
	
		            that.wrapper
		                .on(CLICK + SEARCHBOXNS, "a", proxy(that._click, that));
	
		            if (!placeholderSupported) {
		                that.element.on("focus" + SEARCHBOXNS, proxy(that._focus, that))
		                    .on("blur" + SEARCHBOXNS, proxy(that._blur, that));
		            }
		        },
	
		        options: {
		            name: "SearchBox",
		            label: "Search",
		            value: ""
		        },
	
		        events: [ CHANGE ],
	
		        destroy: function() {
		            var that = this;
	
		            that.wrapper
		                .add(that.element)
		                .add(that.label)
		                .off(SEARCHBOXNS);
	
		            Widget.fn.destroy.call(that);
		        },
	
		        _keydown: function(e) {
		            if (e.keyCode === 13) {
		                this._updateValue();
		            }
		        },
	
		        _click: function(e) {
		            e.preventDefault();
		            this._updateValue();
		        },
	
		        _updateValue: function() {
		            var that = this,
		                value = that.element.val();
	
		            if (value !== that.value()) {
		                that.value(value);
	
		                that.trigger(CHANGE);
		            }
		        },
	
		        _blur: function() {
		            this._updateValue();
		            this._toggleLabel();
		        },
	
		        _toggleLabel: function() {
		            if (!placeholderSupported) {
		                this.label.toggle(!this.element.val());
		            }
		        },
	
		        _focus: function() {
		            this.label.hide();
		        },
	
		        _wrapper: function() {
		            var element = this.element,
		                wrapper = element.parents(".k-search-wrap");
	
		            element[0].style.width = "";
		            element.addClass("k-input");
	
		            if (!wrapper.length) {
		                wrapper = element.wrap($('<div class="k-widget k-search-wrap k-textbox"/>')).parent();
		                if (!placeholderSupported) {
		                    $('<label style="display:block">' + this.options.label + '</label>').insertBefore(element);
		                }
		                $('<a href="#" class="k-icon k-i-zoom k-search"/>').appendTo(wrapper);
		            }
	
		            this.wrapper = wrapper;
		            this.label = wrapper.find(">label");
		        },
	
		        value: function(value) {
		            var that = this;
	
		            if (value !== undefined) {
		                that.options.value = value;
		                that.element.val(value);
		                that._toggleLabel();
		                return;
		            }
		            return that.options.value;
		        }
		    });
	
		    var Breadcrumbs = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            options = options || {};
	
		            Widget.fn.init.call(that, element, options);
	
		            that._wrapper();
	
		            that.wrapper
		                .on("focus" + BREADCRUBMSNS, "input", proxy(that._focus, that))
		                .on("blur" + BREADCRUBMSNS, "input", proxy(that._blur, that))
		                .on("keydown" + BREADCRUBMSNS, "input", proxy(that._keydown, that))
		                .on(CLICK + BREADCRUBMSNS, "a.k-i-arrow-60-up:first", proxy(that._rootClick, that))
		                .on(CLICK + BREADCRUBMSNS, "a:not(.k-i-arrow-60-up)", proxy(that._click, that));
		            that.value(that.options.value);
		        },
	
		        options: {
		            name: "Breadcrumbs",
		            gap: 50
		        },
	
		        events: [ CHANGE ],
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.wrapper
		                .add(that.wrapper.find("input"))
		                .add(that.wrapper.find("a"))
		                .off(BREADCRUBMSNS);
		        },
	
		        _update: function(val) {
		            val = (val || "").charAt(0) === "/" ? val : ("/" + (val || ""));
	
		            if (val !== this.value()) {
		                this.value(val);
		                this.trigger(CHANGE);
		            }
		        },
	
		        _click: function(e) {
		            e.preventDefault();
		            this._update(this._path($(e.target).prevAll("a:not(.k-i-arrow-60-up)").addBack()));
		        },
	
		        _rootClick: function(e) {
		            e.preventDefault();
		            this._update("");
		        },
	
		        _focus: function() {
		            var that = this,
		                element = that.element;
	
		            that.overlay.hide();
		            that.element.val(that.value());
	
		            setTimeout(function() {
		               element.select();
		            });
		        },
	
		        _blur: function() {
		            if (this.overlay.is(":visible")) {
		                return;
		            }
	
		            var that = this,
		                element = that.element,
		                val = element.val().replace(/\/{2,}/g, "/");
	
		            that.overlay.show();
		            element.val("");
		            that._update(val);
		        },
	
		        _keydown: function(e) {
		            var that = this;
		            if (e.keyCode === 13) {
		                that._blur();
	
		                setTimeout(function() {
		                    that.overlay.find("a:first").focus();
		                });
		            }
		        },
	
		        _wrapper: function() {
		            var element = this.element,
		                wrapper = element.parents(".k-breadcrumbs"),
		                overlay;
	
		            element[0].style.width = "";
		            element.addClass("k-input");
	
		            if (!wrapper.length) {
		                wrapper = element.wrap($('<div class="k-widget k-breadcrumbs k-textbox"/>')).parent();
		            }
	
		            overlay = wrapper.find(".k-breadcrumbs-wrap");
		            if (!overlay.length) {
		                overlay = $('<div class="k-breadcrumbs-wrap"/>').appendTo(wrapper);
		            }
		            this.wrapper = wrapper;
		            this.overlay = overlay;
		        },
	
		        refresh: function() {
		            var html = "",
		                value = this.value(),
		                segments,
		                segment,
		                idx,
		                length;
	
		            if (value === undefined || !value.match(/^\//)) {
		                value = "/" + (value || "");
		            }
	
		            segments = value.split("/");
	
		            for (idx = 0, length = segments.length; idx < length; idx++) {
		                segment = segments[idx];
		                if (segment) {
		                    if (!html) {
		                        html += '<a href="#" class="k-icon k-i-arrow-60-up" title="Go to parent folder"></a>';
		                    }
		                    html += '<a class="k-link" href="#">' + segments[idx] + '</a>';
		                    html += '<span class="k-icon k-i-arrow-60-right" title="Go to child folder"></span>';
		                }
		            }
		            this.overlay.empty().append($(html));
	
		            this._adjustSectionWidth();
		        },
	
		        _adjustSectionWidth: function() {
		            var that = this,
		                wrapper = that.wrapper,
		                width = wrapper.width() - that.options.gap,
		                links = that.overlay.find("a"),
		                a;
	
		            links.each(function(index) {
		                a = $(this);
	
		                if (a.parent().width() > width) {
		                    if (index == links.length - 1) {
		                        a.width(width);
		                    } else {
		                        a.prev().addBack().hide();
		                    }
		                }
		            });
		        },
	
		        value: function(val) {
		            if (val !== undefined) {
		                this._value = val.replace(/\/{2,}/g, "/");
		                this.refresh();
		                return;
		            }
		            return this._value;
		        },
	
		        _path: function(trail) {
		            return "/" + $.map(trail, function(b) {
		                return $(b).text();
		            }).join("/");
		        }
		    });
	
		    kendo.ui.plugin(FileBrowser);
		    kendo.ui.plugin(Breadcrumbs);
		    kendo.ui.plugin(SearchBox);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1179:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(598);
	
	/***/ }),
	
	/***/ 1180:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(600);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1212);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1028:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(578);
	
	/***/ }),
	
	/***/ 1194:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(599);
	
	/***/ }),
	
	/***/ 1212:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013), __webpack_require__(1194), __webpack_require__(1028) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "listview",
		    name: "ListView",
		    category: "web",
		    description: "The ListView widget offers rich support for interacting with data.",
		    depends: [ "data" ],
		    features: [ {
		        id: "listview-editing",
		        name: "Editing",
		        description: "Support for record editing",
		        depends: [ "editable" ]
		    }, {
		        id: "listview-selection",
		        name: "Selection",
		        description: "Support for selection",
		        depends: [ "selectable" ]
		    } ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        CHANGE = "change",
		        CANCEL = "cancel",
		        DATABOUND = "dataBound",
		        DATABINDING = "dataBinding",
		        Widget = kendo.ui.Widget,
		        keys = kendo.keys,
		        FOCUSSELECTOR =  ">*:not(.k-loading-mask)",
		        PROGRESS = "progress",
		        ERROR = "error",
		        FOCUSED = "k-state-focused",
		        SELECTED = "k-state-selected",
		        KEDITITEM = "k-edit-item",
		        EDIT = "edit",
		        REMOVE = "remove",
		        SAVE = "save",
		        CLICK = "click",
		        NS = ".kendoListView",
		        proxy = $.proxy,
		        activeElement = kendo._activeElement,
		        progress = kendo.ui.progress,
		        DataSource = kendo.data.DataSource;
	
		    var ListView = kendo.ui.DataBoundWidget.extend( {
		        init: function(element, options) {
		            var that = this;
	
		            options = $.isArray(options) ? { dataSource: options } : options;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
	
		            that.wrapper = element = that.element;
	
		            if (element[0].id) {
		                that._itemId = element[0].id + "_lv_active";
		            }
	
		            that._element();
	
		            that._dataSource();
	
		            that._templates();
	
		            that._navigatable();
	
		            that._selectable();
	
		            that._pageable();
	
		            that._crudHandlers();
	
		            if (that.options.autoBind){
		                that.dataSource.fetch();
		            }
	
		            kendo.notify(that);
		        },
	
		        events: [
		            CHANGE,
		            CANCEL,
		            DATABINDING,
		            DATABOUND,
		            EDIT,
		            REMOVE,
		            SAVE
		        ],
	
		        options: {
		            name: "ListView",
		            autoBind: true,
		            selectable: false,
		            navigatable: false,
		            template: "",
		            altTemplate: "",
		            editTemplate: ""
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
	
		            this._templates();
	
		            if (this.selectable) {
		                this.selectable.destroy();
		                this.selectable = null;
		            }
	
		            this._selectable();
		        },
	
		        _templates: function() {
		            var options = this.options;
	
		            this.template = kendo.template(options.template || "");
		            this.altTemplate = kendo.template(options.altTemplate || options.template);
		            this.editTemplate = kendo.template(options.editTemplate || "");
		        },
	
		        _item: function(action) {
		            return this.element.children()[action]();
		        },
	
		        items: function() {
		            return this.element.children();
		        },
	
		        dataItem: function(element) {
		            var attr = kendo.attr("uid");
		            var uid = $(element).closest("[" + attr + "]").attr(attr);
	
		            return this.dataSource.getByUid(uid);
		        },
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
		            this._dataSource();
	
		            if (this.options.autoBind) {
		                dataSource.fetch();
		            }
		        },
	
		        _unbindDataSource: function() {
		            var that = this;
	
		            that.dataSource.unbind(CHANGE, that._refreshHandler)
		                            .unbind(PROGRESS, that._progressHandler)
		                            .unbind(ERROR, that._errorHandler);
		        },
	
		        _dataSource: function() {
		            var that = this;
	
		            if (that.dataSource && that._refreshHandler) {
		                that._unbindDataSource();
		            } else {
		                that._refreshHandler = proxy(that.refresh, that);
		                that._progressHandler = proxy(that._progress, that);
		                that._errorHandler = proxy(that._error, that);
		            }
	
		            that.dataSource = DataSource.create(that.options.dataSource)
		                                .bind(CHANGE, that._refreshHandler)
		                                .bind(PROGRESS, that._progressHandler)
		                                .bind(ERROR, that._errorHandler);
		        },
	
		        _progress: function() {
		            progress(this.element, true);
		        },
	
		        _error: function() {
		            progress(this.element, false);
		        },
	
		        _element: function() {
		            this.element.addClass("k-widget k-listview").attr("role", "listbox");
		        },
	
		        refresh: function(e) {
		            var that = this,
		                view = that.dataSource.view(),
		                data,
		                items,
		                item,
		                html = "",
		                idx,
		                length,
		                template = that.template,
		                altTemplate = that.altTemplate,
		                active = activeElement();
	
		            e = e || {};
	
		            if (e.action === "itemchange") {
		                if (!that._hasBindingTarget() && !that.editable) {
		                    data = e.items[0];
		                    item = that.items().filter("[" + kendo.attr("uid") + "=" + data.uid + "]");
	
		                    if (item.length > 0) {
		                        idx = item.index();
	
		                        that.angular("cleanup", function() {
		                            return { elements: [ item ]};
		                        });
	
		                        item.replaceWith(template(data));
		                        item = that.items().eq(idx);
		                        item.attr(kendo.attr("uid"), data.uid);
	
		                        that.angular("compile", function() {
		                            return { elements: [ item ], data: [ { dataItem: data } ]};
		                        });
	
		                        that.trigger("itemChange", {
		                            item: item,
		                            data: data
		                        });
		                    }
		                }
	
		                return;
		            }
	
		            if (that.trigger(DATABINDING, { action: e.action || "rebind", items: e.items, index: e.index })) {
		                return;
		            }
	
		            that._angularItems("cleanup");
	
		            that._destroyEditable();
	
		            for (idx = 0, length = view.length; idx < length; idx++) {
		                if (idx % 2) {
		                    html += altTemplate(view[idx]);
		                } else {
		                    html += template(view[idx]);
		                }
		            }
	
		            that.element.html(html);
	
		            items = that.items();
		            for (idx = 0, length = view.length; idx < length; idx++) {
		                items.eq(idx).attr(kendo.attr("uid"), view[idx].uid)
		                             .attr("role", "option")
		                             .attr("aria-selected", "false");
		            }
	
		            if (that.element[0] === active && that.options.navigatable) {
		                that.current(items.eq(0));
		            }
	
		            that._angularItems("compile");
	
		            that.trigger(DATABOUND, { action: e.action || "rebind", items: e.items, index: e.index });
		        },
	
		        _pageable: function() {
		            var that = this,
		                pageable = that.options.pageable,
		                settings,
		                pagerId;
	
		            if ($.isPlainObject(pageable)) {
		                pagerId = pageable.pagerId;
		                settings = $.extend({}, pageable, {
		                    dataSource: that.dataSource,
		                    pagerId: null
		                });
	
		                that.pager = new kendo.ui.Pager($("#" + pagerId), settings);
		            }
		        },
	
		        _selectable: function() {
		            var that = this,
		                multi,
		                current,
		                selectable = that.options.selectable,
		                navigatable = that.options.navigatable;
	
		            if (selectable) {
		                multi = kendo.ui.Selectable.parseOptions(selectable).multiple;
	
		                that.selectable = new kendo.ui.Selectable(that.element, {
		                    aria: true,
		                    multiple: multi,
		                    filter: FOCUSSELECTOR,
		                    change: function() {
		                        that.trigger(CHANGE);
		                    }
		                });
	
		                if (navigatable) {
		                    that.element.on("keydown" + NS, function(e) {
		                        if (e.keyCode === keys.SPACEBAR) {
		                            current = that.current();
		                            if (e.target == e.currentTarget) {
		                                e.preventDefault();
		                            }
		                            if(multi) {
		                                if(!e.ctrlKey) {
		                                    that.selectable.clear();
		                                } else {
		                                    if (current && current.hasClass(SELECTED)) {
		                                        current.removeClass(SELECTED);
		                                        return;
		                                    }
		                                }
		                            } else {
		                                that.selectable.clear();
		                            }
	
		                            that.selectable.value(current);
		                        }
		                    });
		                }
		            }
		        },
	
		        current: function(candidate) {
		            var that = this,
		                element = that.element,
		                current = that._current,
		                id = that._itemId;
	
		            if (candidate === undefined) {
		                return current;
		            }
	
		            if (current && current[0]) {
		                if (current[0].id === id) {
		                    current.removeAttr("id");
		                }
	
		                current.removeClass(FOCUSED);
		                element.removeAttr("aria-activedescendant");
		            }
	
		            if (candidate && candidate[0]) {
		                id = candidate[0].id || id;
	
		                that._scrollTo(candidate[0]);
	
		                element.attr("aria-activedescendant", id);
		                candidate.addClass(FOCUSED).attr("id", id);
		            }
	
		            that._current = candidate;
		        },
	
		        _scrollTo: function(element) {
		            var that = this,
		                container,
		                UseJQueryoffset = false,
		                SCROLL = "scroll";
	
		            if (that.wrapper.css("overflow") == "auto" || that.wrapper.css("overflow") == SCROLL) {
		                container = that.wrapper[0];
		            } else {
		                container = window;
		                UseJQueryoffset = true;
		            }
	
		            var scrollDirectionFunc = function(direction, dimension) {
	
		                var elementOffset = UseJQueryoffset ? $(element).offset()[direction.toLowerCase()] : element["offset" + direction],
		                    elementDimension = element["client" + dimension],
		                    containerScrollAmount = $(container)[SCROLL + direction](),
		                    containerDimension = $(container)[dimension.toLowerCase()]();
	
		                if (elementOffset + elementDimension > containerScrollAmount + containerDimension) {
		                    $(container)[SCROLL + direction](elementOffset + elementDimension - containerDimension);
		                } else if (elementOffset < containerScrollAmount) {
		                    $(container)[SCROLL + direction](elementOffset);
		                }
		            };
	
		            scrollDirectionFunc("Top", "Height");
		            scrollDirectionFunc("Left", "Width");
		        },
	
		        _navigatable: function() {
		            var that = this,
		                navigatable = that.options.navigatable,
		                element = that.element,
		                clickCallback = function(e) {
		                    that.current($(e.currentTarget));
		                    if(!$(e.target).is(":button,a,:input,a>.k-icon,textarea")) {
		                        kendo.focusElement(element);
		                    }
		                };
	
		            if (navigatable) {
		                that._tabindex();
		                element.on("focus" + NS, function() {
		                        var current = that._current;
		                        if(!current || !current.is(":visible")) {
		                            current = that._item("first");
		                        }
	
		                        that.current(current);
		                    })
		                    .on("focusout" + NS, function() {
		                        if (that._current) {
		                            that._current.removeClass(FOCUSED);
		                        }
		                    })
		                    .on("keydown" + NS, function(e) {
		                        var key = e.keyCode,
		                            current = that.current(),
		                            target = $(e.target),
		                            canHandle = !target.is(":button,textarea,a,a>.t-icon,input"),
		                            isTextBox = target.is(":text,:password"),
		                            preventDefault = kendo.preventDefault,
		                            editItem = element.find("." + KEDITITEM),
		                            active = activeElement(), idx;
	
		                        if ((!canHandle && !isTextBox && keys.ESC != key) || (isTextBox && keys.ESC != key && keys.ENTER != key)) {
		                            return;
		                        }
	
		                        if (keys.UP === key || keys.LEFT === key) {
		                            if (current) {
		                                current = current.prev();
		                            }
	
		                            that.current(!current || !current[0] ? that._item("last") : current);
		                            preventDefault(e);
		                        } else if (keys.DOWN === key || keys.RIGHT === key) {
		                            if (current) {
		                                current = current.next();
		                            }
		                            that.current(!current || !current[0] ? that._item("first") : current);
		                            preventDefault(e);
		                        } else if (keys.PAGEUP === key) {
		                            that.current(null);
		                            that.dataSource.page(that.dataSource.page() - 1);
		                            preventDefault(e);
		                        } else if (keys.PAGEDOWN === key) {
		                            that.current(null);
		                            that.dataSource.page(that.dataSource.page() + 1);
		                            preventDefault(e);
		                        } else if (keys.HOME === key) {
		                            that.current(that._item("first"));
		                            preventDefault(e);
		                        } else if (keys.END === key) {
		                            that.current(that._item("last"));
		                            preventDefault(e);
		                        } else if (keys.ENTER === key) {
		                            if (editItem.length !== 0 && (canHandle || isTextBox)) {
		                                idx = that.items().index(editItem);
		                                if (active) {
		                                    active.blur();
		                                }
		                                that.save();
		                                var focusAgain = function(){
		                                    that.element.trigger("focus");
		                                    that.current(that.items().eq(idx));
		                                };
		                                that.one("dataBound", focusAgain);
		                            } else if (that.options.editTemplate !== "") {
		                                that.edit(current);
		                            }
		                        } else if (keys.ESC === key) {
		                            editItem = element.find("." + KEDITITEM);
		                            if (editItem.length === 0) {
		                                return;
		                            }
		                            idx = that.items().index(editItem);
		                            that.cancel();
		                            that.element.trigger("focus");
		                            that.current(that.items().eq(idx));
		                        }
		                    });
	
		                element.on("mousedown" + NS + " touchstart" + NS, FOCUSSELECTOR, proxy(clickCallback, that));
		            }
		       },
	
		       clearSelection: function() {
		           var that = this;
		           that.selectable.clear();
		           that.trigger(CHANGE);
		       },
	
		       select: function(items) {
		           var that = this,
		               selectable = that.selectable;
	
		            items = $(items);
		            if(items.length) {
		                if(!selectable.options.multiple) {
		                    selectable.clear();
		                    items = items.first();
		                }
		                selectable.value(items);
		                return;
		            }
	
		           return selectable.value();
		       },
	
		       _destroyEditable: function() {
		           var that = this;
		           if (that.editable) {
		               that.editable.destroy();
		               delete that.editable;
		           }
		       },
	
		       _modelFromElement: function(element) {
		           var uid = element.attr(kendo.attr("uid"));
	
		           return this.dataSource.getByUid(uid);
		       },
	
		       _closeEditable: function() {
		           var that = this,
		               editable = that.editable,
		               data,
		               item,
		               index,
		               template = that.template;
	
		           if (editable) {
		               if (editable.element.index() % 2) {
		                   template = that.altTemplate;
		               }
	
		               that.angular("cleanup", function() {
		                   return { elements: [ editable.element ]};
		               });
	
		               data = that._modelFromElement(editable.element);
		               that._destroyEditable();
	
		               index = editable.element.index();
		               editable.element.replaceWith(template(data));
		               item = that.items().eq(index);
		               item.attr(kendo.attr("uid"), data.uid);
	
		               if (that._hasBindingTarget()) {
		                   kendo.bind(item, data);
		               }
	
		               that.angular("compile", function() {
		                   return { elements: [ item ], data: [ { dataItem: data } ]};
		               });
		           }
		           return true;
		       },
	
		       edit: function(item) {
		           var that = this,
		               data = that._modelFromElement(item),
		               container,
		               uid = data.uid,
		               index;
	
		            that.cancel();
	
		            item = that.items().filter("[" + kendo.attr("uid") + "=" + uid + "]");
		            index = item.index();
		            item.replaceWith(that.editTemplate(data));
		            container = that.items().eq(index).addClass(KEDITITEM).attr(kendo.attr("uid"), data.uid);
		            that.editable = container.kendoEditable({
		                model: data,
		                clearContainer: false,
		                errorTemplate: false,
		                target: that
		            }).data("kendoEditable");
	
		            that.trigger(EDIT, { model: data, item: container });
		       },
	
		       save: function() {
		           var that = this,
		               editable = that.editable,
		               model;
	
		           if (!editable) {
		               return;
		           }
	
		           var container = editable.element;
		           model = that._modelFromElement(container);
	
		           if (editable.end() && !that.trigger(SAVE, { model: model, item: container }))  {
		               that._closeEditable();
		               that.dataSource.sync();
		           }
		       },
	
		       remove: function(item) {
		           var that = this,
		               dataSource = that.dataSource,
		               data = that._modelFromElement(item);
	
		           if (that.editable) {
		               dataSource.cancelChanges(that._modelFromElement(that.editable.element));
		               that._closeEditable();
		           }
	
		           if (!that.trigger(REMOVE, { model: data, item: item })) {
		               item.hide();
		               dataSource.remove(data);
		               dataSource.sync();
		           }
		       },
	
		       add: function() {
		           var that = this,
		               dataItem,
		               dataSource = that.dataSource,
		               index = dataSource.indexOf((dataSource.view() || [])[0]);
	
		           if (index < 0) {
		               index = 0;
		           }
	
		           that.cancel();
		           dataItem = dataSource.insert(index, {});
		           that.edit(that.element.find("[data-uid='" + dataItem.uid + "']"));
		       },
	
		       cancel: function() {
		           var that = this,
		               dataSource = that.dataSource;
	
		           if (that.editable) {
		               var container = that.editable.element;
		               var model = that._modelFromElement(container);
	
		               if (!that.trigger(CANCEL, { model: model, container: container})) {
		                   dataSource.cancelChanges(model);
		                   that._closeEditable();
		               }
		           }
		       },
	
		       _crudHandlers: function() {
		           var that = this,
		               clickNS = CLICK + NS;
	
		           that.element.on(clickNS, ".k-edit-button", function(e) {
		               var item = $(this).closest("[" + kendo.attr("uid") + "]");
		               that.edit(item);
		               e.preventDefault();
		           });
	
		           that.element.on(clickNS, ".k-delete-button", function(e) {
		               var item = $(this).closest("[" + kendo.attr("uid") + "]");
		               that.remove(item);
		               e.preventDefault();
		           });
	
		           that.element.on(clickNS, ".k-update-button", function(e) {
		               that.save();
		               e.preventDefault();
		           });
	
		           that.element.on(clickNS, ".k-cancel-button", function(e) {
		               that.cancel();
		               e.preventDefault();
		           });
		       },
	
		       destroy: function() {
		           var that = this;
	
		           Widget.fn.destroy.call(that);
	
		           that._unbindDataSource();
	
		           that._destroyEditable();
	
		           that.element.off(NS);
	
		           if (that.pager) {
		               that.pager.destroy();
		           }
	
		           kendo.destroy(that.element);
		       }
		    });
	
		    kendo.ui.plugin(ListView);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1133);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1011:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(577);
	
	/***/ }),
	
	/***/ 1058:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1119:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(590);
	
	/***/ }),
	
	/***/ 1133:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1119), __webpack_require__(1134), __webpack_require__(1011), __webpack_require__(1058) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "editable",
		    name: "Editable",
		    category: "framework",
		    depends: [ "datepicker", "numerictextbox", "validator", "binder" ],
		    hidden: true
		};
	
		/* jshint eqnull: true */
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        extend = $.extend,
		        oldIE = kendo.support.browser.msie && kendo.support.browser.version < 9,
		        isFunction = kendo.isFunction,
		        isPlainObject = $.isPlainObject,
		        inArray = $.inArray,
		        POINT = ".",
		        nameSpecialCharRegExp = /("|\%|'|\[|\]|\$|\.|\,|\:|\;|\+|\*|\&|\!|\#|\(|\)|<|>|\=|\?|\@|\^|\{|\}|\~|\/|\||`)/g,
		        ERRORTEMPLATE = '<div class="k-widget k-tooltip k-tooltip-validation" style="margin:0.5em"><span class="k-icon k-i-warning"> </span>' +
		                    '#=message#<div class="k-callout k-callout-n"></div></div>',
		        CHANGE = "change";
		    var EQUAL_SET = "equalSet";
		    var specialRules = ["url", "email", "number", "date", "boolean"];
	
		    function fieldType(field) {
		        field = field != null ? field : "";
		        return field.type || $.type(field) || "string";
		    }
	
		    function convertToValueBinding(container) {
		        container.find(":input:not(:button, .k-combobox .k-input, [" + kendo.attr("role") + "=listbox], [" + kendo.attr("role") + "=upload], [" + kendo.attr("skip") + "], [type=file])").each(function() {
		            var bindAttr = kendo.attr("bind"),
		                binding = this.getAttribute(bindAttr) || "",
		                bindingName = this.type === "checkbox" || this.type === "radio" ? "checked:" : "value:",
		                fieldName = this.name;
	
		            if (binding.indexOf(bindingName) === -1 && fieldName) {
		                binding += (binding.length ? "," : "") + bindingName + fieldName;
	
		                $(this).attr(bindAttr, binding);
		            }
		        });
		    }
	
		    function createAttributes(options) {
		        var field = (options.model.fields || options.model)[options.field],
		            type = fieldType(field),
		            validation = field ? field.validation : {},
		            ruleName,
		            DATATYPE = kendo.attr("type"),
		            BINDING = kendo.attr("bind"),
		            rule,
		            attr = {
		                name: options.field,
		                title: options.title
		            };
	
		        for (ruleName in validation) {
		            rule = validation[ruleName];
	
		            if (inArray(ruleName, specialRules) >= 0) {
		                attr[DATATYPE] = ruleName;
		            } else if (!isFunction(rule)) {
		                var culture = kendo.getCulture();
	
		                if (typeof rule === "number" && culture.name.length) {
		                    var numberFormat = culture.numberFormat;
		                    var stringRule = rule.toString()
		                        .replace(POINT, numberFormat[POINT]);
	
		                    attr[ruleName] = stringRule;
		                } else {
		                    attr[ruleName] = isPlainObject(rule) ? rule.value || ruleName : rule;
		                }
		            }
	
		            attr[kendo.attr(ruleName + "-msg")] = rule.message;
		        }
	
		        if (inArray(type, specialRules) >= 0) {
		            attr[DATATYPE] = type;
		        }
	
		        attr[BINDING] = (type === "boolean" ? "checked:" : "value:") + options.field;
	
		        return attr;
		    }
	
		    function convertItems(items) {
		        var idx,
		            length,
		            item,
		            value,
		            text,
		            result;
	
		        if (items && items.length) {
		            result = [];
		            for (idx = 0, length = items.length; idx < length; idx++) {
		                item = items[idx];
		                text = item.text || item.value || item;
		                value = item.value == null ? (item.text || item) : item.value;
	
		                result[idx] = { text: text, value: value };
		            }
		        }
		        return result;
		    }
	
		    var editors = {
		        "number": function(container, options) {
		            var attr = createAttributes(options);
		            $('<input type="text"/>').attr(attr).appendTo(container).kendoNumericTextBox({ format: options.format });
		            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>').hide().appendTo(container);
		        },
		        "date": function(container, options) {
		            var attr = createAttributes(options),
		                format = options.format;
	
		            if (format) {
		                format = kendo._extractFormat(format);
		            }
	
		            attr[kendo.attr("format")] = format;
	
		            $('<input type="text"/>').attr(attr).appendTo(container).kendoDatePicker({ format: options.format });
		            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>').hide().appendTo(container);
		        },
		        "string": function(container, options) {
		            var attr = createAttributes(options);
	
		            $('<input type="text" class="k-input k-textbox"/>').attr(attr).appendTo(container);
		        },
		        "boolean": function(container, options) {
		            var attr = createAttributes(options);
		            $('<input type="checkbox" />').attr(attr).appendTo(container);
		        },
		        "values": function(container, options) {
		            var attr = createAttributes(options);
		            var items = kendo.stringify(convertItems(options.values));
		            $('<select ' + kendo.attr("text-field") + '="text"' + kendo.attr("value-field") + '="value"' +
		                kendo.attr("source") + "=\'" + (items ? items.replace(/\'/g,"&apos;") : items) +
		                "\'" + kendo.attr("role") + '="dropdownlist"/>') .attr(attr).appendTo(container);
		            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>').hide().appendTo(container);
		        }
		    };
	
		    function addValidationRules(modelField, rules) {
		        var validation = modelField ? (modelField.validation || {}) : {},
		            rule,
		            descriptor;
	
		        for (rule in validation) {
		            descriptor = validation[rule];
	
		            if (isPlainObject(descriptor) && descriptor.value) {
		                descriptor = descriptor.value;
		            }
	
		            if (isFunction(descriptor)) {
		                rules[rule] = descriptor;
		            }
		        }
		    }
	
		    var Editable = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            if (options.target) {
		                options.$angular = options.target.options.$angular;
		            }
		            Widget.fn.init.call(that, element, options);
		            that._validateProxy = $.proxy(that._validate, that);
		            that.refresh();
		        },
	
		        events: [CHANGE],
	
		        options: {
		            name: "Editable",
		            editors: editors,
		            clearContainer: true,
		            errorTemplate: ERRORTEMPLATE,
		            skipFocus: false
		        },
	
		        editor: function(field, modelField) {
		            var that = this,
		                editors = that.options.editors,
		                isObject = isPlainObject(field),
		                fieldName = isObject ? field.field : field,
		                model = that.options.model || {},
		                isValuesEditor = isObject && field.values,
		                type = isValuesEditor ? "values" : fieldType(modelField),
		                isCustomEditor = isObject && field.editor,
		                editor = isCustomEditor ? field.editor : editors[type],
		                container = that.element.find("[" + kendo.attr("container-for") + "=" + fieldName.replace(nameSpecialCharRegExp, "\\$1")+ "]");
	
		            editor = editor ? editor : editors.string;
	
		            if (isCustomEditor && typeof field.editor === "string") {
		                editor = function(container) {
		                    container.append(field.editor);
		                };
		            }
	
		            container = container.length ? container : that.element;
		            editor(container, extend(true, {}, isObject ? field : { field: fieldName }, { model: model }));
		        },
	
		        _validate: function(e) {
		            var that = this,
		                input,
		                value = e.value,
		                preventChangeTrigger = that._validationEventInProgress,
		                values = {},
		                bindAttribute = kendo.attr("bind"),
		                fieldName = e.field.replace(nameSpecialCharRegExp, "\\$1"),
		                bindingRegex = new RegExp("(value|checked)\\s*:\\s*" + fieldName + "\\s*(,|$)");
	
		            values[e.field] = e.value;
	
		            input = $(':input[' + bindAttribute + '*="' + fieldName + '"]', that.element)
		                .filter("[" + kendo.attr("validate") + "!='false']").filter(function() {
		                   return bindingRegex.test($(this).attr(bindAttribute));
		                });
		            if (input.length > 1) {
		                input = input.filter(function () {
		                    var element = $(this);
		                    return !element.is(":radio") || element.val() == value;
		                });
		            }
	
		            try {
		                that._validationEventInProgress = true;
	
		                if (!that.validatable.validateInput(input) || (!preventChangeTrigger && that.trigger(CHANGE, { values: values }))) {
		                    e.preventDefault();
		                }
	
		            } finally {
		                that._validationEventInProgress = false;
		            }
		        },
	
		        end: function() {
		            return this.validatable.validate();
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.angular("cleanup", function(){
		                return { elements: that.element };
		            });
	
		            Widget.fn.destroy.call(that);
	
		            that.options.model.unbind("set", that._validateProxy);
		            that.options.model.unbind(EQUAL_SET, that._validateProxy);
	
		            kendo.unbind(that.element);
	
		            if (that.validatable) {
		                that.validatable.destroy();
		            }
		            kendo.destroy(that.element);
	
		            that.element.removeData("kendoValidator");
	
		            if (that.element.is("[" + kendo.attr("role") + "=editable]")) {
		                that.element.removeAttr(kendo.attr("role"));
		            }
		        },
	
		        refresh: function() {
		            var that = this,
		                idx,
		                length,
		                fields = that.options.fields || [],
		                container = that.options.clearContainer ? that.element.empty() : that.element,
		                model = that.options.model || {},
		                rules = {},
		                field,
		                isObject,
		                fieldName,
		                modelField,
		                modelFields;
	
		            if (!$.isArray(fields)) {
		                fields = [fields];
		            }
	
		            for (idx = 0, length = fields.length; idx < length; idx++) {
		                 field = fields[idx];
		                 isObject = isPlainObject(field);
		                 fieldName = isObject ? field.field : field;
		                 modelField = (model.fields || model)[fieldName];
	
		                 addValidationRules(modelField, rules);
	
		                 that.editor(field, modelField);
		            }
	
		            if (that.options.target) {
		                that.angular("compile", function(){
		                    return {
		                        elements: container,
		                        data: container.map(function() { return { dataItem: model }; })
		                    };
		                });
		            }
	
		            if (!length) {
		                modelFields = model.fields || model;
		                for (fieldName in modelFields) {
		                    addValidationRules(modelFields[fieldName], rules);
		               }
		            }
	
		            convertToValueBinding(container);
	
		            if (that.validatable) {
		                that.validatable.destroy();
		            }
	
		            kendo.bind(container, that.options.model);
	
		            that.options.model.unbind("set", that._validateProxy);
		            that.options.model.bind("set", that._validateProxy);
	
		            that.options.model.unbind(EQUAL_SET, that._validateProxy);
		            that.options.model.bind(EQUAL_SET, that._validateProxy);
	
		            that.validatable = new kendo.ui.Validator(container, {
		                validateOnBlur: false,
		                errorTemplate: that.options.errorTemplate || undefined,
		                rules: rules });
	
		            if (!that.options.skipFocus) {
		                var focusable = container.find(":kendoFocusable").eq(0).focus();
		                if (oldIE) {
		                    focusable.focus();
		                }
		            }
		        }
		   });
	
		   ui.plugin(Editable);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1134:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(592);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1349);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1349:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "upload",
		    name: "Upload",
		    category: "web",
		    description: "The Upload widget uses progressive enhancement to deliver the best possible uploading experience to users.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        antiForgeryTokens = kendo.antiForgeryTokens,
		        logToConsole = kendo.logToConsole,
		        rFileExtension = /\.([^\.]+)$/,
		        NS = ".kendoUpload",
		        SELECT = "select",
		        UPLOAD = "upload",
		        SUCCESS = "success",
		        ERROR = "error",
		        COMPLETE = "complete",
		        CANCEL = "cancel",
		        CLEAR = "clear",
		        PAUSE = "pause",
		        RESUME = "resume",
		        PROGRESS = "progress",
		        REMOVE = "remove",
		        VALIDATIONERRORS = "validationErrors",
		        INVALIDMAXFILESIZE = "invalidMaxFileSize",
		        INVALIDMINFILESIZE = "invalidMinFileSize",
		        INVALIDFILEEXTENSION = "invalidFileExtension",
		        PROGRESSHIDEDELAY = 1000,
		        PROGRESSHIDEDURATION = 2000;
	
		    var headerStatusIcon = {
		        loading: "k-i-loading",
		        warning: "k-i-warning",
		        success: "k-i-check"
		    };
	
		    var Upload = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            that.name = element.name;
		            that.multiple = that.options.multiple;
		            that.directory = that.options.directory;
		            that.localization = that.options.localization;
	
		            var activeInput = that.element;
		            that.wrapper = activeInput.closest(".k-upload");
		            if (that.wrapper.length === 0) {
		                that.wrapper = that._wrapInput(activeInput);
		            }
	
		            that._activeInput(activeInput);
		            that.toggle(that.options.enabled);
	
		            var ns = that._ns = NS + "-" + kendo.guid();
		            activeInput.closest("form")
		                .on("submit" + ns, $.proxy(that._onParentFormSubmit, that))
		                .on("reset" + ns, $.proxy(that._onParentFormReset, that));
	
		            if (that.options.async.saveUrl) {
		                that._module = that._supportsFormData() ?
		                new formDataUploadModule(that) :
		                new iframeUploadModule(that);
		                that._async = true;
	
		                var initialFiles = that.options.files;
		                if (initialFiles.length > 0) {
		                    that._renderInitialFiles(initialFiles);
		                }
	
		            } else {
		                that._module = new syncUploadModule(that);
		            }
	
		            if (that._supportsDrop()) {
		                if(that.options.dropZone !== "") {
		                    that._setupCustomDropZone();
		                } else {
		                    that._setupDropZone();
		                }
		            }
	
		            that.wrapper
		            .on("click", ".k-upload-action", $.proxy(that._onFileAction, that))
		            .on("click", ".k-clear-selected", $.proxy(that._onClearSelected, that))
		            .on("click", ".k-upload-selected", $.proxy(that._onUploadSelected, that));
	
		            if(that.element.val()) {
		                that._onInputChange({ target: that.element });
		            }
		        },
	
		        events: [
		            SELECT,
		            UPLOAD,
		            SUCCESS,
		            ERROR,
		            COMPLETE,
		            CANCEL,
		            CLEAR,
		            PROGRESS,
		            REMOVE,
		            PAUSE,
		            RESUME
		        ],
	
		        options: {
		            name: "Upload",
		            enabled: true,
		            multiple: true,
		            directory: false,
		            showFileList: true,
		            template: "",
		            files: [],
		            async: {
		                autoRetryAfter: 0,
		                bufferChunkSize: 10000000,
		                maxAutoRetries: 1,
		                removeVerb: "POST",
		                autoUpload: true,
		                withCredentials: true,
		                accept: "*/*; q=0.5, application/json",
		                useArrayBuffer: false
		            },
		            localization: {
		                "select": "Select files...",
		                "cancel": "Cancel",
		                "retry": "Retry",
		                "remove": "Remove",
		                "pause": "Pause",
		                "resume": "Resume",
		                "clearSelectedFiles": "Clear",
		                "uploadSelectedFiles": "Upload",
		                "dropFilesHere": "Drop files here to upload",
		                "invalidFiles": "Invalid file(s). Please check file upload requirements.",
		                "statusUploading": "uploading",
		                "statusUploaded": "uploaded",
		                "statusWarning": "warning",
		                "statusFailed": "failed",
		                "headerStatusUploading": "Uploading...",
		                "headerStatusPaused": "Paused",
		                "headerStatusUploaded": "Done",
		                "invalidMaxFileSize": "File size too large.",
		                "invalidMinFileSize": "File size too small.",
		                "invalidFileExtension": "File type not allowed."
		            },
		            validation: {
		                allowedExtensions: [],
		                maxFileSize: 0,
		                minFileSize: 0
		            },
		            dropZone: ""
		        },
	
		        setOptions: function(options) {
		            var that = this,
		                activeInput = that.element;
	
		            Widget.fn.setOptions.call(that, options);
	
		            that.multiple = that.options.multiple;
		            that.directory = that.options.directory;
	
		            activeInput.attr("multiple", that._supportsMultiple() ? that.multiple : false);
		            if(that.directory){
		                activeInput.attr("webkitdirectory", that.directory);
		                activeInput.attr("directory", that.directory);
		            }
		            that.toggle(that.options.enabled);
		        },
	
		        enable: function(enable) {
		            enable = typeof (enable) === "undefined" ? true : enable;
		            this.toggle(enable);
		        },
	
		        disable: function() {
		            this.toggle(false);
		        },
	
		        toggle: function(enable) {
		            enable = typeof (enable) === "undefined" ? enable : !enable;
		            this.wrapper.toggleClass("k-state-disabled", enable);
		            this.element.prop("disabled", enable);
		        },
	
		        focus: function() {
		            this.element.focus();
		        },
	
		        destroy: function() {
		            var that = this;
		            var customDropZone = $(that.options.dropZone);
	
		            $(document)
		                .add($(".k-dropzone", that.wrapper))
		                .add(that.wrapper.closest("form"))
		                .off(that._ns);
	
		            if(customDropZone.length > 0) {
		                customDropZone.off(that._ns);
		            }
	
		            $(that.element).off(NS);
	
		            Widget.fn.destroy.call(that);
		        },
		        pause: function(fileEntry){
		            this._module.onPause({ target: $(fileEntry, this.wrapper) });
	
		            var pauseIcon = fileEntry.find(".k-i-pause-sm");
		            pauseIcon.removeClass("k-i-pause-sm").addClass("k-i-play-sm").attr("title", this.localization.resume);
		            $(pauseIcon).parent().attr("aria-label", this.localization.resume);
		        },
		        resume: function(fileEntry){
		            this._module.onResume({ target: $(fileEntry, this.wrapper) });
	
		            var playIcon = fileEntry.find(".k-i-play-sm");
		            playIcon.removeClass("k-i-play-sm").addClass("k-i-pause-sm").attr("title", this.localization.pause);
		            $(playIcon).parent().attr("aria-label", this.localization.pause);
		        },
		        upload: function() {
		            var that = this;
	
		            that._module.onSaveSelected();
		        },
	
		        getFiles: function() {
		            var that = this;
		            var filesData;
		            var allFiles = [];
		            var listItems = that.wrapper.find(".k-file");
	
		            for(var i = 0; i < listItems.length; i++) {
		                filesData = $(listItems[i]).data("fileNames");
	
		                if(filesData) {
		                    for(var j = 0; j < filesData.length; j++) {
		                        allFiles.push(filesData[j]);
		                    }
		                }
		            }
	
		            return allFiles;
		        },
	
		        clearAllFiles: function() {
		            var that = this;
		            var files = that.wrapper.find(".k-file");
	
		            files.each(function(index, file) {
		                that._removeFileByDomElement(file, false);
		            });
		        },
	
		        removeAllFiles: function() {
		            var that = this;
		            var files = that.wrapper.find(".k-file");
	
		            files.each(function(index, file) {
		                that._removeFileByDomElement(file, true);
		            });
		        },
	
		        removeFileByUid: function(uid) {
		            this._removeFileByUid(uid, true);
		        },
	
		        clearFileByUid: function(uid) {
		            this._removeFileByUid(uid, false);
		        },
	
		        _removeFileByUid: function(uid, shouldSendRemoveRequest) {
		            var that = this;
		            var fileEntry;
	
		            if(typeof uid !== 'string') { return; }
	
		            fileEntry = $('.k-file[' + kendo.attr('uid') + '="' + uid + '"]', that.wrapper);
	
		            if(fileEntry.length > 0) {
		                that._removeFileByDomElement(fileEntry, shouldSendRemoveRequest);
		            }
		        },
	
		        clearFile: function(callback) {
		            this._removeFile(callback, false);
		        },
	
		        removeFile: function(callback) {
		            this._removeFile(callback, true);
		        },
	
		        _removeFile: function(callback, shouldSendRemoveRequest) {
		            var that = this;
		            var files = that.wrapper.find(".k-file");
		            var fileData;
	
		            if(typeof callback === "function") {
		                files.each(function(index, file){
		                    fileData = $(file).data("fileNames");
	
		                    if(callback(fileData)) {
		                        that._removeFileByDomElement(file, shouldSendRemoveRequest);
		                    }
		                });
		            }
		        },
	
		        _removeFileByDomElement: function(fileEntry, shouldSendRemoveRequest) {
		            var that = this;
		            var fileData = {
		                target: $(fileEntry, that.wrapper)
		            };
		            var allFiles;
	
		            if(that.options.async.saveUrl) {
		                if($(fileEntry).hasClass("k-file-progress")) {
		                    that._module.onCancel(fileData);
		                } else {
		                    that._module.onRemove(fileData, {}, shouldSendRemoveRequest);
		                }
	
		                allFiles = $(".k-file", that.wrapper);
	
		                if(allFiles.length === 0) {
		                    that._hideHeaderUploadstatus();
		                } else {
		                    that._updateHeaderUploadStatus();
		                }
		            } else {
		                that._module.onRemove(fileData, {}, shouldSendRemoveRequest);
		            }
		        },
	
		        _addInput: function(sourceInput) {
		            //check if source input is a DOM element. Required for some unit tests
		            if (!sourceInput[0].nodeType) {
		                return;
		            }
	
		            var that = this,
		                input = sourceInput.clone().val("");
	
		            input
		                .insertAfter(that.element)
		                .data("kendo" + that.options.prefix + that.options.name, that);
	
		            $(that.element)
		                .hide()
		                .attr("tabindex", "-1")
		                .removeAttr("id")
		                .off(NS);
	
		            that._activeInput(input);
		            that.element.focus();
		        },
	
		        _activeInput: function(input) {
		            var that = this,
		                wrapper = that.wrapper;
	
		            that.element = input;
	
		            if(that.directory){
		                input.attr("webkitdirectory", that.directory);
		                input.attr("directory", that.directory);
		            }
	
		            input
		                .attr("multiple", that._supportsMultiple() ? that.multiple : false)
		                .attr("autocomplete", "off")
		                .on("click" + NS, function(e) {
		                    if (wrapper.hasClass("k-state-disabled")) {
		                        e.preventDefault();
		                    }
		                })
		                .on("focus" + NS, function() {
		                    $(this).parent().addClass("k-state-focused");
		                })
		                .on("blur" + NS, function() {
		                    $(this).parent().removeClass("k-state-focused");
		                })
		                .on("change" + NS, $.proxy(that._onInputChange, that))
		                .on("keydown" + NS, $.proxy(that._onInputKeyDown, that));
		        },
	
		        _onInputKeyDown: function(e) {
		            var that = this;
		            var firstButton = that.wrapper.find(".k-upload-action:visible:first");
	
		            if (e.keyCode === kendo.keys.TAB && firstButton.length > 0 && !e.shiftKey) {
		                e.preventDefault();
	
		                firstButton.focus();
		            }
		        },
	
		        _onInputChange: function(e) {
		            var that = this;
		            var input = $(e.target);
		            var files = assignGuidToFiles(that._inputFiles(input), that._isAsyncNonBatch());
	
		            validateFiles(files, that.options.validation);
	
		            var prevented = that.trigger(SELECT, { files: files });
		            if (prevented) {
		                that._addInput(input);
		                input.remove();
		            } else {
		                that._module.onSelect({target : input}, files);
		            }
		        },
	
		        _readDirectory: function(item){
		            var deferred = new $.Deferred();
		            var dirReader = item.createReader();
		            var allFolderFiles = [];
	
		            var readEntries = function () {
		                dirReader.readEntries(function(entries) {
		                    if (!entries.length) {
		                        deferred.resolve(allFolderFiles);
		                    } else {
		                        allFolderFiles = allFolderFiles.concat(entries);
		                        readEntries();
		                    }
		                }, deferred.reject);
		            };
	
		            readEntries();
	
		             return deferred.promise();
		        },
	
		        _readFile: function(item){
		            var that = this;
		            var fullpath = item.fullPath;
	
		            item.file(function(file){
		                    file.relativePath = fullpath.slice(1);
		                    that.droppedFolderFiles.push(file);
		                    that.droppedFolderCounter --;
		                    if(that.droppedFolderCounter === 0){
		                        setTimeout(function(){
		                            if(that.droppedFolderCounter === 0){
		                                if(that.droppedFolderFiles.length){
		                                    that._proceedDroppedItems(that.droppedFolderFiles);
		                                    that.droppedFolderFiles = [];
		                                }
		                            }
		                        },0);
		                    }
		            }, function(){
		                logToConsole("File error.");
		            });
		        },
	
		        _traverseFileTree: function (item, skipCounter) {
		            var that = this;
		            if(!skipCounter){
		                that.droppedFolderCounter--;
		            }
	
		            this._readDirectory(item).then(function(items){
		                that.droppedFolderCounter += items.length;
		                for (var i = 0; i < items.length; i++) {
		                    if(items[i].isFile){
		                        that._readFile(items[i]);
		                    } else if (items[i].isDirectory){
		                        that._traverseFileTree(items[i]);
		                    }
		                }
		            });
		        },
	
		        _onDrop: function (e) {
		            var dt = e.originalEvent.dataTransfer;
		            var that = this;
		            var droppedFiles = dt.files;
		            var length;
	
		            stopEvent(e);
		           if(that.options.directoryDrop && dt.items){
		                length = dt.items.length;
		                that.droppedFolderCounter = 0;
		                that.droppedFolderFiles = [];
	
		                for (var i = 0; i < length; i++) {
		                    if(dt.items[i].webkitGetAsEntry){
		                        var entry = dt.items[i].webkitGetAsEntry();
	
		                        if(entry.isDirectory){
		                            that._traverseFileTree(entry, true);
		                        }else if (entry.isFile){
		                            that.droppedFolderFiles.push(dt.files[i]);
		                        }
		                    }else{
		                         that._proceedDroppedItems(droppedFiles);
		                    }
		                }
		           }else{
		               that._proceedDroppedItems(droppedFiles);
		           }
		        },
	
		        _proceedDroppedItems: function(droppedFiles){
		            var that = this;
		            var files = assignGuidToFiles(getAllFileInfo(droppedFiles), that._isAsyncNonBatch());
	
		              if (droppedFiles.length > 0 && !that.wrapper.hasClass("k-state-disabled")) {
		                if (!that.multiple && files.length > 1) {
		                    files.splice(1, files.length - 1);
		                }
	
		                validateFiles(files, that.options.validation);
	
		                var prevented = that.trigger(SELECT, { files: files });
		                if (!prevented) {
		                    that._module.onSelect({target : $(".k-dropzone", that.wrapper) }, files);
		                }
		            }
		        },
	
		        _filesContainValidationErrors: function(files) {
		            var hasErrors = false;
	
		            $(files).each(function(index, file){
		                if(file[VALIDATIONERRORS] && file[VALIDATIONERRORS].length > 0) {
		                    hasErrors = true;
		                    return false;
		                }
		            });
	
		            return hasErrors;
		        },
	
		        _isAsyncNonBatch: function () {
		            return (this._async && !this.options.async.batch) || false;
		        },
	
		        _renderInitialFiles: function(files) {
		            var that = this;
		            var idx = 0;
		            files = assignGuidToFiles(files, true);
	
		            for (idx = 0; idx < files.length; idx++) {
		                var currentFile = files[idx];
	
		                var fileEntry = that._enqueueFile(currentFile.name, { fileNames: [ currentFile ] });
		                fileEntry.addClass("k-file-success").data("files", [ files[idx] ]);
	
		                if (that._supportsRemove()){
		                    that._fileAction(fileEntry, REMOVE);
		                }
		            }
		        },
	
		        _prepareTemplateData: function(name, data) {
		            var filesData = data.fileNames,
		                templateData = {},
		                totalSize = 0,
		                idx = 0;
	
		            for (idx = 0; idx < filesData.length; idx++) {
		                totalSize += filesData[idx].size;
		            }
	
		            templateData.name = name;
		            templateData.size = totalSize;
		            templateData.files = data.fileNames;
	
		            return templateData;
		        },
	
		        _prepareDefaultSingleFileEntryTemplate: function(data) {
		            var that = this;
		            var file = data.fileNames[0];
		            var fileSize = getTotalFilesSizeMessage(data.fileNames);
		            var errors = file[VALIDATIONERRORS];
		            var template = "";
	
		            if(errors && errors.length > 0) {
		                template += "<li class='k-file k-file-invalid'><span class='k-progress'></span>" +
		                "<span class='k-file-invalid-extension-wrapper'>" +
		                    "<span class='k-file-invalid-icon'>!</span>" +
		                    "<span class='k-file-state'></span>" +
		                "</span>" +
		                "<span class='k-file-name-size-wrapper'>" +
		                    "<span class='k-file-name k-file-name-invalid' title='" + file.name + "'>" + file.name + "</span>" +
		                    "<span class='k-file-validation-message'>" + that.localization[errors[0]] + "</span>" +
		                "</span>";
		            } else {
		                template += "<li class='k-file'><span class='k-progress'></span>" +
		                "<span class='k-file-extension-wrapper'>" +
		                    "<span class='k-file-extension'>" + file.extension.substring(1) + "</span>" +
		                    "<span class='k-file-state'></span>" +
		                "</span>" +
		                "<span class='k-file-name-size-wrapper'><span class='k-file-name' title='" + file.name + "'>" + file.name + "</span>" +
		                "<span class='k-file-size'>" + fileSize + "</span></span>";
		            }
	
		            template += "<strong class='k-upload-status'></strong>";
	
		            return $(template);
		        },
	
		        _prepareDefaultMultipleFileEntriesTemplate: function(data) {
		            var that = this;
		            var files = data.fileNames;
		            var filesHaveValidationErrors = that._filesContainValidationErrors(files);
		            var totalFileSize = getTotalFilesSizeMessage(files);
		            var template = "";
		            var i, currentFile;
	
		            if(filesHaveValidationErrors) {
		                template += "<li class='k-file k-file-invalid'><span class='k-progress'></span>" +
		                    "<span class='k-multiple-files-invalid-extension-wrapper'>" +
		                    "<span class='k-file-invalid-icon'>!</span>";
		            } else {
		                template += "<li class='k-file'><span class='k-progress'></span>" +
		                    "<span class='k-multiple-files-extension-wrapper'>";
		            }
	
		            template += "<span class='k-file-state'></span></span>";
	
		            files.sort(function(a, b){
		                if(a[VALIDATIONERRORS]) { return -1; }
	
		                if (b[VALIDATIONERRORS]) { return 1; }
	
		                return 0;
		            });
	
		            template += "<span class='k-file-name-size-wrapper'>";
		            for(i = 0; i < files.length; i++) {
		                currentFile = files[i];
		                if(currentFile[VALIDATIONERRORS] && currentFile[VALIDATIONERRORS].length > 0) {
		                    template += "<span class='k-file-name k-file-name-invalid' title='" + currentFile.name + "'>" + currentFile.name + "</span>";
		                } else {
		                    template += "<span class='k-file-name' title='" + currentFile.name + "'>" + currentFile.name + "</span>";
		                }
		            }
	
		            if(filesHaveValidationErrors) {
		                template += "<span class='k-file-validation-message'>" + that.localization.invalidFiles +"</span>";
		            } else {
		                template += "<span class='k-file-information'>Total: " + files.length + " files, " + totalFileSize + "</span>";
		            }
	
		            template += "</span><strong class='k-upload-status'></strong>";
	
		            return $(template);
		        },
	
		        _enqueueFile: function(name, data) {
		            var that = this;
		            var existingFileEntries;
		            var fileEntry;
		            var fileUid = data.fileNames[0].uid;
		            var fileList =  $(".k-upload-files", that.wrapper);
		            var options = that.options;
		            var template = options.template;
		            var templateData;
		            var removeEventArgs;
	
		            if (fileList.length === 0) {
		                fileList = $("<ul class='k-upload-files k-reset'></ul>").appendTo(that.wrapper);
		                if (!that.options.showFileList) {
		                    fileList.hide();
		                }
	
		                that.wrapper.removeClass("k-upload-empty");
		            }
	
		            existingFileEntries = $(".k-file", fileList);
	
		            if (!template) {
		                if(data.fileNames.length === 1) {
		                    fileEntry = that._prepareDefaultSingleFileEntryTemplate(data);
		                } else {
		                    fileEntry = that._prepareDefaultMultipleFileEntriesTemplate(data);
		                }
		            } else {
		                templateData = that._prepareTemplateData(name, data);
		                template = kendo.template(template);
	
		                fileEntry = $("<li class='k-file'>" + template(templateData) + "</li>");
		                fileEntry.find(".k-upload-action").addClass("k-button");
	
		                that.angular("compile", function(){
		                    return {
		                        elements: fileEntry,
		                        data: [ templateData ]
		                    };
		                });
		            }
	
		            fileEntry
		                .attr(kendo.attr("uid"), fileUid)
		                .appendTo(fileList)
		                .data(data);
	
		            if (!that._async) {
		                $(".k-progress", fileEntry).width('100%');
		            }
	
		            if (!that.multiple && existingFileEntries.length > 0) {
		                removeEventArgs = {
		                    files: existingFileEntries.data("fileNames"),
		                    headers: {}
		                };
		                if (!that.trigger(REMOVE, removeEventArgs)) {
		                    that._module.onRemove({target : $(existingFileEntries, that.wrapper)}, removeEventArgs);
		                }
		            }
	
		            return fileEntry;
		        },
	
		        _removeFileEntry: function(fileEntry) {
		            var that = this;
		            var fileList = fileEntry.closest(".k-upload-files");
		            var allFiles, allCompletedFiles, allInvalidFiles;
	
		            fileEntry.remove();
		            allFiles = $(".k-file", fileList);
		            allCompletedFiles = $(".k-file-success, .k-file-error", fileList);
		            allInvalidFiles = $(".k-file-invalid", fileList);
	
		            if (allCompletedFiles.length === allFiles.length || allInvalidFiles.length === allFiles.length) {
		                this._hideUploadButton();
		            }
	
		            if (allFiles.length === 0) {
		                fileList.remove();
		                that.wrapper.addClass("k-upload-empty");
		                that._hideHeaderUploadstatus();
		            } else {
		                that._updateHeaderUploadStatus();
		            }
		        },
	
		        _fileAction: function(fileElement, actionKey, skipClear) {
		            var classDictionary = { remove: "k-i-x", cancel: "k-i-cancel", retry: "k-i-retry", pause: "k-i-pause-sm"};
		            var iconsClassDictionary = {remove: "k-i-close", cancel: "k-i-close", retry: "k-i-reload-sm", pause: "k-i-pause-sm"};
		            var firstActionButton;
	
		            if (!classDictionary.hasOwnProperty(actionKey)) {
		                return;
		            }
		            if(!skipClear){
		                this._clearFileAction(fileElement);
		            }
		            if (!this.options.template) {
		                if(!skipClear){
		                    fileElement.find(".k-upload-status .k-upload-action").remove();
		                }
		                fileElement.find(".k-upload-status").append(
		                    this._renderAction(classDictionary[actionKey], this.localization[actionKey], iconsClassDictionary[actionKey])
		                );
		            } else {
		                firstActionButton = fileElement.find(".k-upload-action").first();
		                if(!firstActionButton.find(".k-icon").length){
		                firstActionButton
		                        .addClass("k-button")
		                        .append("<span class='k-icon " + iconsClassDictionary[actionKey] + " " + classDictionary[actionKey] +
		                                "' title='" + this.localization[actionKey] + "'" +
		                                "aria-label='" + this.localization[actionKey] + "'></span>")
		                        .show();
		                }else if (firstActionButton.next(".k-upload-action").length){
		                    firstActionButton.next(".k-upload-action")
		                        .addClass("k-button")
		                        .append("<span class='k-icon " + iconsClassDictionary[actionKey] + " " + classDictionary[actionKey] +
		                                "' title='" + this.localization[actionKey] + "'" +
		                                "aria-label='" + this.localization[actionKey] + "'></span>")
		                        .show();
		                }
		            }
		        },
	
		        _fileState: function(fileEntry, stateKey) {
		            var localization = this.localization,
		                states = {
		                    uploading: {
		                        text : localization.statusUploading
		                    },
		                    uploaded: {
		                        text : localization.statusUploaded
		                    },
		                    failed: {
		                        text : localization.statusFailed
		                    }
		                },
		                currentState = states[stateKey];
	
		            if (currentState) {
		                $("span.k-file-state", fileEntry).text(currentState.text);
		            }
		        },
	
		        _renderAction: function (actionClass, actionText, iconClass) {
		            if (actionClass !== "") {
		                return $(
		                "<button type='button' class='k-button k-upload-action' aria-label='" + actionText + "'>" +
		                    "<span class='k-icon "+ iconClass + " " + actionClass + "' title='" + actionText + "'></span>" +
		                "</button>"
		                ).on("focus", function() { $(this).addClass("k-state-focused"); })
		                 .on("blur", function() { $(this).removeClass("k-state-focused"); });
		            }
		            else {
		                return $(
		                "<button type='button' class='k-button'>" +
		                    actionText +
		                "</button>"
		                );
		            }
		        },
	
		        _clearFileAction: function(fileElement) {
		            $(".k-upload-action", fileElement).empty().hide();
		        },
	
		        _onFileAction: function(e) {
		            var that = this;
		            if (!that.wrapper.hasClass("k-state-disabled")) {
		                var button = $(e.target).closest(".k-upload-action");
		                var icon = button.find(".k-icon");
		                var fileEntry = button.closest(".k-file");
		                var files = fileEntry.data("fileNames");
		                var hasValidationErrors = that._filesContainValidationErrors(files);
		                var eventArgs = {
		                    files: files,
		                    headers: {}
		                };
	
		                that._retryClicked = false;
	
		                if (icon.hasClass("k-i-x")) {
		                    if (!that.trigger(REMOVE, eventArgs)) {
		                        that._module.onRemove({target : $(fileEntry, that.wrapper)}, eventArgs, !hasValidationErrors);
		                    }
		                } else if (icon.hasClass("k-i-cancel")) {
		                    that.trigger(CANCEL, eventArgs);
		                    that._module.onCancel({ target: $(fileEntry, that.wrapper) });
		                    that._checkAllComplete();
		                    that._updateHeaderUploadStatus();
		                } else if (icon.hasClass("k-i-pause-sm")) {
		                    that.trigger(PAUSE, eventArgs);
		                    that.pause(fileEntry);
		                    that._updateHeaderUploadStatus();
		                } else if (icon.hasClass("k-i-play-sm")) {
		                    that.trigger(RESUME, eventArgs);
		                    that.resume(fileEntry);
		                }else if (icon.hasClass("k-i-retry")) {
		                    $(".k-i-warning", fileEntry).remove();
		                    $(".k-progress", fileEntry).finish().show();
		                    that._module.onRetry({ target: $(fileEntry, that.wrapper) });
		                    that._retryClicked = true;
		                }
		            }
	
		            return false;
		        },
	
		        _onUploadSelected: function() {
		            var that = this;
		            var wrapper = that.wrapper;
	
		            if (!wrapper.hasClass("k-state-disabled")) {
		                this._module.onSaveSelected();
		            }
	
		            return false;
		        },
	
		        _onClearSelected: function() {
		            var that = this;
		            var wrapper = that.wrapper;
	
		            var clearEventArgs = { };
		            if(!wrapper.hasClass("k-state-disabled") && !that.trigger(CLEAR, clearEventArgs)) {
		                that.clearAllFiles();
		            }
	
		            return false;
		        },
	
		        _onFileProgress: function(e, percentComplete) {
		            var progressPct;
		            var warningPct;
	
		            if (percentComplete > 100) {
		                percentComplete = 100;
		            }
	
		            if (!this.options.template) {
		                progressPct = $(".k-upload-pct", e.target);
		                warningPct = $(".k-i-warning", e.target);
	
		                if(warningPct.length){
		                    warningPct.removeClass("k-i-warning").removeClass("k-icon").addClass("k-upload-pct");
		                }else if (progressPct.length === 0) {
		                    $(".k-upload-status", e.target).prepend("<span class='k-upload-pct'></span>");
		                }
	
		                if(percentComplete !== 100){
		                    $(".k-upload-pct", e.target).text(percentComplete + "%");
		                }else{
		                     $(".k-upload-pct", e.target).remove();
		                }
		                $(".k-progress", e.target).width(percentComplete + "%");
		            } else {
		                $(".k-progress", e.target).width(percentComplete + "%");
		            }
	
		            this.trigger(PROGRESS, {
		                files: getFileEntry(e).data("fileNames"),
		                percentComplete: percentComplete
		            });
		        },
	
		        _onUploadSuccess: function(e, response, xhr) {
		            var that = this;
		            var fileEntry = getFileEntry(e);
	
		            var prevented = that.trigger(SUCCESS, {
		                files: fileEntry.data("fileNames"),
		                response: response,
		                operation: "upload",
		                XMLHttpRequest: xhr
		            });
	
		            if(prevented) {
		                that._setUploadErrorState(fileEntry);
		            } else {
		                that._fileState(fileEntry, "uploaded");
		                fileEntry.removeClass('k-file-progress').addClass('k-file-success');
		                that._updateHeaderUploadStatus();
	
		                if (that._supportsRemove()) {
		                    that._fileAction(fileEntry, REMOVE);
		                } else {
		                    that._clearFileAction(fileEntry);
		                }
		            }
	
		            that._hideUploadProgress(fileEntry);
	
		            that._checkAllComplete();
		        },
	
		        _onUploadError: function(e, xhr) {
		            var that = this;
		            var module = that._module;
		            var fileEntry = getFileEntry(e);
		            var fileUid = fileEntry.data("uid");
	
		            that._setUploadErrorState(fileEntry);
	
		            that.trigger(ERROR, {
		                operation: "upload",
		                files: fileEntry.data("fileNames"),
		                XMLHttpRequest: xhr
		            });
	
		            logToConsole("Server response: " + xhr.responseText);
	
		            if(!that.options.async.chunkSize){
		                that._hideUploadProgress(fileEntry);
		            }else{
		                if(module._decreasePosition){
		                    module._decreasePosition(fileUid);
		                }
		            }
	
		           that._checkAllComplete();
	
		            if(this.options.async.autoRetryAfter){
		               this._autoRetryAfter(fileEntry);
		            }
		        },
		        _autoRetryAfter: function(fileEntry){
		            var that = this;
		            var retries = this._module.retries;
	
		            if(!retries){
		                return;
		            }
	
		            if(!retries[fileEntry.data("uid")]){
		                retries[fileEntry.data("uid")] = 1;
		            }
	
		            if(retries[fileEntry.data("uid")] <= this.options.async.maxAutoRetries){
		                retries[fileEntry.data("uid")]++;
		                setTimeout(function(){
		                    that._module.performUpload(fileEntry);
		                },this.options.async.autoRetryAfter);
		            }
		        },
		        _setUploadErrorState: function(fileEntry) {
		            var that = this;
		            var uploadPercentage;
	
		            that._fileState(fileEntry, "failed");
		            fileEntry.removeClass('k-file-progress').addClass('k-file-error');
	
		            that._updateUploadProgress(fileEntry);
	
		            uploadPercentage = $('.k-upload-pct', fileEntry);
		            if (uploadPercentage.length > 0) {
		                if(!uploadPercentage.parent().find(".k-i-warning").length){
		                    uploadPercentage.removeClass('k-upload-pct').addClass('k-icon k-i-warning');
		                }
		                uploadPercentage.empty();
		            } else {
		                $('.k-upload-status', fileEntry).prepend("<span class='k-icon k-i-warning'></span>");
		            }
	
		            this._updateHeaderUploadStatus();
		            this._fileAction(fileEntry, "retry");
		            this._fileAction(fileEntry, REMOVE, true);
	
		            if (that._retryClicked) {
		                fileEntry.find(".k-i-retry").parent().focus();
		            }
		        },
	
		       _updateUploadProgress: function(fileEntry){
		            var that = this;
	
		            if(!that.options.async.chunkSize){
		                $('.k-progress', fileEntry).width("100%");
		            }else{
		                var fileUid = fileEntry.data("uid");
		                if(that._module.metaData){
		                    var fileMetaData = that._module.metaData[fileUid];
	
		                    if(fileMetaData){
		                        var percentComplete = fileMetaData.totalChunks ? Math.round(((fileMetaData.chunkIndex)/fileMetaData.totalChunks)*100):100;
	
		                        that._onFileProgress({ target : $(fileEntry, that.wrapper) }, percentComplete);
		                    }
		                }
		            }
		        },
	
		        _hideUploadProgress: function(fileEntry) {
		            $(".k-progress", fileEntry)
		                .delay(PROGRESSHIDEDELAY)
		                .fadeOut(PROGRESSHIDEDURATION, function() {
		                    $(this).css("width", "0%");
		                });
		        },
	
		        _showUploadButton: function() {
		            var that = this;
		            var uploadButton = $(".k-upload-selected", that.wrapper);
		            var clearButton = $(".k-clear-selected", that.wrapper);
	
		            if (uploadButton.length === 0) {
		                uploadButton = that._renderAction("", this.localization.uploadSelectedFiles)
		                                   .addClass("k-upload-selected");
	
		                clearButton = that._renderAction("", this.localization.clearSelectedFiles)
		                                  .addClass("k-clear-selected");
		            }
	
		            this.wrapper.append(clearButton, uploadButton);
		        },
	
		        _hideUploadButton: function() {
		            $(".k-upload-selected, .k-clear-selected", this.wrapper).remove();
		        },
	
		        _showHeaderUploadStatus: function(isUploading) {
		            var that = this;
		            var localization = that.localization;
		            var dropZone = $(".k-dropzone", that.wrapper);
		            var headerUploadStatus = $('.k-upload-status-total', that.wrapper);
	
		            if (headerUploadStatus.length !== 0) {
		                headerUploadStatus.remove();
		            }
	
		            headerUploadStatus = '<strong class="k-upload-status k-upload-status-total"><span class="k-icon"></span></strong>';
	
		            if(isUploading) {
		                headerUploadStatus = $(headerUploadStatus).append(localization.headerStatusUploading);
		                headerUploadStatus.find(".k-icon").addClass(headerStatusIcon.loading);
		            } else {
		                headerUploadStatus = $(headerUploadStatus).append(localization.headerStatusUploaded);
		                headerUploadStatus.find(".k-icon").addClass(headerStatusIcon.warning);
		            }
	
		            if (dropZone.length > 0) {
		                dropZone.append(headerUploadStatus);
		            } else {
		                $('.k-upload-button', that.wrapper).after(headerUploadStatus);
		            }
		        },
	
		        _updateHeaderUploadStatus: function() {
		            var that = this;
		            var headerUploadStatus = $('.k-upload-status-total', this.wrapper);
		            var currentlyUploading = $('.k-file', that.wrapper).not('.k-file-success, .k-file-error, .k-file-invalid');
		            var currentlyInvalid = $('.k-file-invalid', that.wrapper);
		            var currentlyFailed = $('.k-file-error', that.wrapper);
		            var currentlyPaused = $('.k-file', that.wrapper).find(".k-i-play-sm");
		            var failedUploads, headerUploadStatusIcon;
	
		            if(currentlyPaused.length &&
		            (currentlyPaused.length === currentlyUploading.length || !that.options.async.concurrent)){
		                headerUploadStatusIcon = $('.k-icon', headerUploadStatus)
		                                .removeClass()
		                                .addClass("k-icon")
		                                .addClass("k-i-pause-sm");
	
		                headerUploadStatus.html(headerUploadStatusIcon)
		                                  .append(that.localization.headerStatusPaused);
		            }else if (currentlyUploading.length === 0 || currentlyInvalid.length > 0 || currentlyFailed.length > 0) {
		                failedUploads = $('.k-file.k-file-error, .k-file.k-file-invalid', that.wrapper);
	
		                headerUploadStatus = $('.k-upload-status-total', that.wrapper);
		                headerUploadStatusIcon = $('.k-icon', headerUploadStatus).removeClass().addClass("k-icon")
		                                              .addClass(failedUploads.length !== 0 ? headerStatusIcon.warning : headerStatusIcon.success);
	
		                headerUploadStatus.html(headerUploadStatusIcon)
		                                  .append(that.localization.headerStatusUploaded);
		            }
		        },
	
		        _hideHeaderUploadstatus: function() {
		            $('.k-upload-status-total', this.wrapper).remove();
		        },
	
		        _onParentFormSubmit: function() {
		            var upload = this,
		                element = upload.element;
	
		            if(typeof this._module.onAbort !== 'undefined'){
		                this._module.onAbort();
		            }
	
		            if (!element.value) {
		                var input = $(element);
	
		                // Prevent submitting an empty input
		                input.attr("disabled", "disabled");
	
		                window.setTimeout(function() {
		                    // Restore the input so the Upload remains functional
		                    // in case the user cancels the form submit
		                    input.removeAttr("disabled");
		                }, 0);
		            }
		        },
	
		        _onParentFormReset: function() {
		            $(".k-upload-files", this.wrapper).remove();
		        },
	
		        _supportsFormData: function() {
		            return typeof(FormData) != "undefined";
		        },
	
		        _supportsMultiple: function() {
		            var windows = this._userAgent().indexOf("Windows") > -1;
	
		            return !kendo.support.browser.opera &&
		                   !(kendo.support.browser.safari && windows);
		        },
	
		        _supportsDrop: function() {
		            var userAgent = this._userAgent().toLowerCase();
		            var isChrome = /chrome/.test(userAgent);
		            var isSafari = !isChrome && /safari/.test(userAgent);
		            var isWindowsSafari = isSafari && /windows/.test(userAgent);
	
		            return !isWindowsSafari && this._supportsFormData() && (this.options.async.saveUrl);
		        },
	
		        _userAgent: function() {
		            return navigator.userAgent;
		        },
	
		        _setupDropZone: function() {
		            var that = this;
	
		            $(".k-upload-button", that.wrapper).wrap("<div class='k-dropzone'></div>");
	
		            var ns = that._ns;
		            var dropZone = $(".k-dropzone", that.wrapper)
		                .append($("<em>" + that.localization.dropFilesHere + "</em>"))
		                .on("dragenter" + ns, stopEvent)
		                .on("dragover" + ns, function(e) { e.preventDefault(); })
		                .on("drop" + ns, $.proxy(that._onDrop, that));
	
		            bindDragEventWrappers(dropZone, ns,
		                function() {
		                    if (!dropZone.closest('.k-upload').hasClass("k-state-disabled")) {
		                        dropZone.addClass("k-dropzone-hovered");
		                    }
		                },
		                function() { dropZone.removeClass("k-dropzone-hovered"); });
	
		            that._bindDocumentDragEventWrappers(dropZone);
		        },
	
		        _setupCustomDropZone: function() {
		            var that = this;
		            var dropZone = $(that.options.dropZone);
	
		            $(".k-upload-button", that.wrapper)
		                .wrap("<div class='k-dropzone'></div>")
		                .after($("<em>" + that.localization.dropFilesHere + "</em>"));
	
		            var ns = that._ns;
		            dropZone.on("dragenter" + ns, stopEvent)
		                    .on("dragover" + ns, function(e) { e.preventDefault(); })
		                    .on("drop" + ns, $.proxy(that._onDrop, that));
	
		            bindDragEventWrappers(dropZone, ns,
		                function(e) {
		                    if (!that.wrapper.hasClass("k-state-disabled")) {
		                        dropZone.removeClass("k-dropzone-hovered");
		                        $(e.target).addClass("k-dropzone-hovered");
		                    }
		                },
		                function() {
		                    dropZone.removeClass("k-dropzone-hovered");
		                    dropZone.find('.k-dropzone-hovered').removeClass("k-dropzone-hovered");
		                }
		            );
	
		            that._bindDocumentDragEventWrappers(dropZone);
		        },
	
		        _bindDocumentDragEventWrappers: function(dropZone) {
		            var that = this;
		            var ns = that._ns;
	
		            bindDragEventWrappers($(document), ns,
		                function() {
		                    if (!that.wrapper.hasClass("k-state-disabled")) {
		                        dropZone.addClass("k-dropzone-active");
		                        dropZone.closest('.k-upload').removeClass('k-upload-empty');
		                    }
		                },
		                function() {
		                    dropZone.removeClass("k-dropzone-active");
		                    if ($('li.k-file', dropZone.closest('.k-upload')).length === 0) {
		                        dropZone.closest('.k-upload').addClass('k-upload-empty');
		                    }
		                }
		            );
		        },
	
		        _supportsRemove: function() {
		            return !!this.options.async.removeUrl;
		        },
	
		        _submitRemove: function(fileNames, eventArgs, onSuccess, onError) {
		            var upload = this,
		                removeField = upload.options.async.removeField || "fileNames",
		                params = $.extend(eventArgs.data, antiForgeryTokens());
	
		            params[removeField] = fileNames;
	
		            jQuery.ajax({
		                  type: this.options.async.removeVerb,
		                  dataType: "json",
		                  dataFilter: normalizeJSON,
		                  url: this.options.async.removeUrl,
		                  traditional: true,
		                  data: params,
		                  headers: eventArgs.headers,
		                  success: onSuccess,
		                  error: onError,
		                  xhrFields:{
		                    withCredentials: this.options.async.withCredentials
		                  }
		            });
		        },
	
		        _wrapInput: function(input) {
		            var that = this;
		            var options = that.options;
		            input.wrap("<div class='k-widget k-upload k-header'><div class='k-button k-upload-button' aria-label='" + this.localization.select + "'></div></div>");
	
		            if(!options.async.saveUrl) {
		                input.closest(".k-upload").addClass("k-upload-sync");
		            }
	
		            input.closest(".k-upload").addClass("k-upload-empty");
	
		            input.closest(".k-button")
		                .append("<span>" + this.localization.select + "</span>");
	
		            return input.closest(".k-upload");
		        },
	
		        _checkAllComplete: function() {
		            if ($(".k-file.k-file-progress", this.wrapper).length === 0) {
		                this.trigger(COMPLETE);
		            }
		        },
	
		        _inputFiles: function(sourceInput) {
		            return inputFiles(sourceInput);
		        }
		    });
	
		    // Synchronous upload module
		    var syncUploadModule = function(upload) {
		        this.name = "syncUploadModule";
		        this.element = upload.wrapper;
		        this.upload = upload;
		        this.element
		            .closest("form")
		                .attr("enctype", "multipart/form-data")
		                .attr("encoding", "multipart/form-data");
		    };
	
		    syncUploadModule.prototype = {
		        onSelect: function(e, files) {
		            var upload = this.upload;
		            var sourceInput = $(e.target);
		            var filesContainErrors = upload._filesContainValidationErrors(files);
	
		            upload._addInput(sourceInput);
	
		            var fileData = { "fileNames": files };
	
		            if(filesContainErrors) {
		                sourceInput.remove();
		            } else {
		                fileData.relatedInput = sourceInput;
		            }
	
		            var file = upload._enqueueFile(getFileName(sourceInput), fileData);
	
		            if(filesContainErrors) {
		                upload._hideUploadProgress(file);
		            }
	
		            upload._fileAction(file, REMOVE);
		        },
	
		        onRemove: function(e) {
		            var fileEntry = getFileEntry(e);
		            var relatedInput = fileEntry.data("relatedInput");
	
		            if(relatedInput) {
		                relatedInput.remove();
		            }
	
		            this.upload._removeFileEntry(fileEntry);
		        }
		    };
	
		    var iframeUploadModule = function(upload) {
		        this.name = "iframeUploadModule";
		        this.element = upload.wrapper;
		        this.upload = upload;
		        this.iframes = [];
		    };
	
		    Upload._frameId = 0;
	
		    iframeUploadModule.prototype = {
		        onSelect: function(e, files) {
		            var upload = this.upload;
		            var sourceInput = $(e.target);
		            var hasValidationErrors = upload._filesContainValidationErrors(files);
	
		            var fileEntry = this.prepareUpload(sourceInput, files, hasValidationErrors);
	
		            if (upload.options.async.autoUpload) {
		                if(!hasValidationErrors) {
		                    this.performUpload(fileEntry);
		                } else {
		                    upload._fileAction(fileEntry, REMOVE);
		                    upload._showHeaderUploadStatus(false);
		                }
		            } else {
		                upload._fileAction(fileEntry, REMOVE);
	
		                if(!hasValidationErrors) {
		                    upload._showUploadButton();
		                } else {
		                    upload._updateHeaderUploadStatus();
		                }
		            }
	
		            if(hasValidationErrors) {
		                upload._hideUploadProgress(fileEntry);
		            }
		        },
	
		        prepareUpload: function(sourceInput, files, hasValidationErrors) {
		            var upload = this.upload;
		            var activeInput = $(upload.element);
		            var name = upload.options.async.saveField || sourceInput.attr("name");
		            var fileEntry, fileData, iframe, form;
	
		            upload._addInput(sourceInput);
		            sourceInput.attr("name", name);
	
		            if(!hasValidationErrors) {
		                iframe = this.createFrame(upload.name + "_" + Upload._frameId++);
		                this.registerFrame(iframe);
	
		                form = this.createForm(upload.options.async.saveUrl, iframe.attr("name"))
		                           .append(activeInput);
	
		                fileData = { "frame": iframe, "relatedInput": activeInput, "fileNames": files };
		            } else {
		                sourceInput.remove();
	
		                fileData = { "fileNames": files };
		            }
	
		            fileEntry = upload._enqueueFile(getFileName(sourceInput), fileData);
	
		            if(iframe) {
		                iframe.data({ "form": form, "file": fileEntry });
		            }
	
		            return fileEntry;
		        },
	
		        performUpload: function(fileEntry) {
		            var e = { files: fileEntry.data("fileNames") };
		            var iframe = fileEntry.data("frame");
		            var upload = this.upload;
	
		            if (!upload.trigger(UPLOAD, e)) {
		                upload._hideUploadButton();
		                upload._showHeaderUploadStatus(true);
	
		                iframe.appendTo(document.body);
	
		                var form = iframe.data("form")
		                    .attr("action", upload.options.async.saveUrl)
		                    .appendTo(document.body);
	
		                e.data = $.extend({ }, e.data, antiForgeryTokens());
		                for (var key in e.data) {
		                    var dataInput = form.find("input[name='" + key + "']");
		                    if (dataInput.length === 0) {
		                        dataInput = $("<input>", { type: "hidden", name: key })
		                            .prependTo(form);
		                    }
		                    dataInput.val(e.data[key]);
		                }
	
		                upload._fileAction(fileEntry, CANCEL);
		                upload._fileState(fileEntry, "uploading");
		                $(fileEntry).removeClass("k-file-error").addClass("k-file-progress");
	
		                iframe
		                    .one("load", $.proxy(this.onIframeLoad, this));
	
		                form[0].submit();
		            } else {
		                upload._removeFileEntry(iframe.data("file"));
		                this.cleanupFrame(iframe);
		                this.unregisterFrame(iframe);
		            }
		        },
	
		        onSaveSelected: function() {
		            var module = this;
		            var upload = module.upload;
	
		            $(".k-file", this.element).each(function() {
		                var fileEntry = $(this);
		                var started = isFileUploadStarted(fileEntry);
		                var hasValidationErrors = upload._filesContainValidationErrors(fileEntry.data("fileNames"));
	
		                if (!started && !hasValidationErrors) {
		                    module.performUpload(fileEntry);
		                }
		            });
		        },
	
		        onIframeLoad: function(e) {
		            var iframe = $(e.target),
		                responseText;
	
		            try {
		                responseText = iframe.contents().text();
		            } catch (ex) {
		                responseText = "Error trying to get server response: " + ex;
		            }
	
		            this.processResponse(iframe, responseText);
		        },
	
		        processResponse: function(iframe, responseText) {
		            var fileEntry = iframe.data("file"),
		                module = this,
		                fakeXHR = {
		                    responseText: responseText
		                };
		            tryParseJSON(responseText,
		                function(jsonResult) {
		                    $.extend(fakeXHR, { statusText: "OK", status: "200" });
		                    module.upload._onFileProgress({ target : $(fileEntry, module.upload.wrapper) }, 100);
		                    module.upload._onUploadSuccess({ target : $(fileEntry, module.upload.wrapper) }, jsonResult, fakeXHR);
	
		                    module.cleanupFrame(iframe);
		                    module.unregisterFrame(iframe);
		                },
		                function() {
		                    $.extend(fakeXHR, { statusText: "error", status: "500" });
		                    module.upload._onUploadError({ target : $(fileEntry, module.upload.wrapper) }, fakeXHR);
		                }
		            );
		        },
	
		        onCancel: function(e) {
		            var iframe = $(e.target).data("frame");
	
		            this.stopFrameSubmit(iframe);
		            this.cleanupFrame(iframe);
		            this.unregisterFrame(iframe);
		            this.upload._removeFileEntry(iframe.data("file"));
		        },
	
		        onRetry: function(e) {
		            var fileEntry = getFileEntry(e);
		            this.performUpload(fileEntry);
		        },
	
		        onRemove: function(e, eventArgs, shouldSendRemoveRequest) {
		            var module = this;
		            var upload = module.upload;
		            var fileEntry = getFileEntry(e);
		            var iframe = fileEntry.data("frame");
	
		            if (iframe) {
		                module.unregisterFrame(iframe);
		                upload._removeFileEntry(fileEntry);
		                module.cleanupFrame(iframe);
		            } else {
		                if (fileEntry.hasClass("k-file-success")) {
		                    removeUploadedFile(fileEntry, upload, eventArgs, shouldSendRemoveRequest);
		                } else {
		                    upload._removeFileEntry(fileEntry);
		                }
		            }
		        },
	
		        onAbort: function() {
		            var element = this.element,
		                module = this;
	
		            $.each(this.iframes, function() {
		                $("input", this.data("form")).appendTo(element);
		                module.stopFrameSubmit(this[0]);
		                this.data("form").remove();
		                this.remove();
		            });
	
		            this.iframes = [];
		        },
	
		        createFrame: function(id) {
		            return $(
		                "<iframe" +
		                " name='" + id + "'" +
		                " id='" + id + "'" +
		                " style='display:none;' />"
		            );
		        },
	
		        createForm: function(action, target) {
		            return $(
		                "<form enctype='multipart/form-data' method='POST'" +
		                " action='" + action + "'" +
		                " target='" + target + "'" +
		                "/>");
		        },
	
		        stopFrameSubmit: function(frame) {
		            if (typeof(frame.stop) != "undefined") {
		                frame.stop();
		            } else if (frame.document) {
		                frame.document.execCommand("Stop");
		            }
		        },
	
		        registerFrame: function(frame) {
		            this.iframes.push(frame);
		        },
	
		        unregisterFrame: function(frame) {
		            this.iframes = $.grep(this.iframes, function(value) {
		                return value.attr("name") != frame.attr("name");
		            });
		        },
	
		        cleanupFrame: function(frame) {
		            var form = frame.data("form");
	
		            frame.data("file").data("frame", null);
	
		            setTimeout(function () {
		                form.remove();
		                frame.remove();
		            }, 1);
		        }
		    };
	
		    // FormData upload module
		    var formDataUploadModule = function(upload) {
		        this.name = "formDataUploadModule";
		        this.element = upload.wrapper;
		        this.upload = upload;
		        this.position = {};
		        this.metaData = {};
		        this.cancelled = {};
		        this.resume = {};
		        this.paused = {};
		        this.retries = {};
		    };
	
		    formDataUploadModule.prototype = {
		        onSelect: function(e, files) {
		            var upload = this.upload;
		            var module = this;
		            var sourceElement = $(e.target);
		            var fileEntries = this.prepareUpload(sourceElement, files);
		            var hasValidationErrors;
		            var prev;
	
		            $.each(fileEntries, function(index) {
		                hasValidationErrors = upload._filesContainValidationErrors($(this.data("fileNames")));
	
		                if (upload.options.async.autoUpload) {
		                    if(!hasValidationErrors) {
		                        if(upload.options.async.chunkSize){
		                            module.prepareChunk(this);
		                            prev = this.prev();
	
		                            if(upload.options.async.concurrent || (index === 0 && !prev.length) ||
		                             (index === 0 && prev.hasClass("k-file-success"))){
		                                module.performUpload(this);
		                            }
		                        }else{
		                            module.performUpload(this);
		                        }
		                    } else {
		                        upload._fileAction(this, REMOVE);
		                        upload._showHeaderUploadStatus(false);
		                    }
		                } else {
		                    upload._fileAction(this, REMOVE);
	
		                    if(!hasValidationErrors) {
		                        upload._showUploadButton();
		                        this.addClass("k-toupload");
		                    } else {
		                        upload._updateHeaderUploadStatus();
		                    }
		                }
	
		                if(hasValidationErrors) {
		                    upload._hideUploadProgress(this);
		                }
		            });
		        },
	
		        prepareUpload: function(sourceElement, files) {
		            var fileEntries = this.enqueueFiles(files);
	
		            if (sourceElement.is("input")) {
		                $.each(fileEntries, function() {
		                    $(this).data("relatedInput", sourceElement);
		                });
		                sourceElement.data("relatedFileEntries", fileEntries);
		                this.upload._addInput(sourceElement);
		            }
	
		            return fileEntries;
		        },
	
		        enqueueFiles: function(files) {
		            var upload = this.upload;
		            var name;
		            var i;
		            var filesLength = files.length;
		            var currentFile;
		            var fileEntry;
		            var fileEntries = [];
	
		            if (upload.options.async.batch === true) {
		                name = $.map(files, function(file) { return file.name; }).join(", ");
	
		                if(upload.directory || upload.options.directoryDrop){
		                    $(files).each(function(){
		                        if(this.rawFile.webkitRelativePath || this.rawFile.relativePath){
		                            this.name = this.rawFile.webkitRelativePath || this.rawFile.relativePath;
		                        }
		                    });
		                }
	
		                fileEntry = upload._enqueueFile(name, { fileNames: files });
		                fileEntry.data("files", files);
	
		                fileEntries.push(fileEntry);
		            } else {
		                for (i = 0; i < filesLength; i++) {
		                    currentFile = files[i];
		                    name = currentFile.name;
		                    if(upload.directory || upload.options.directoryDrop){
		                        if(currentFile.rawFile.webkitRelativePath || currentFile.rawFile.relativePath){
		                            currentFile.name = currentFile.rawFile.webkitRelativePath || currentFile.rawFile.relativePath;
		                        }
		                    }
		                    fileEntry = upload._enqueueFile(name, { fileNames: [ currentFile ] });
		                    fileEntry.data("files", [ currentFile ]);
	
		                    fileEntries.push(fileEntry);
		                }
		            }
	
		            return fileEntries;
		        },
	
		        performUpload: function(fileEntry) {
		            var upload = this.upload,
		                formData = this.createFormData(),
		                xhr = this.createXHR(),
		                e = {
		                    files: fileEntry.data("fileNames"),
		                    XMLHttpRequest: xhr
		                },
		                files;
	
		            if (!upload.trigger(UPLOAD, e)) {
		                if(fileEntry.find(".k-i-cancel").length === 0){
		                    if(upload.options.async.chunkSize){
		                        upload._fileAction(fileEntry, PAUSE);
		                    }
		                    upload._fileAction(fileEntry, CANCEL, upload.options.async.chunkSize);
		                }
	
		                if(!upload.wrapper.find(".k-toupload").length){
		                    upload._hideUploadButton();
		                }
	
		                upload._showHeaderUploadStatus(true);
	
		                if (e.formData) {
		                    formData = e.formData;
		                } else {
		                    e.data = $.extend({ }, e.data, antiForgeryTokens());
		                    for (var key in e.data) {
		                        formData.append(key, e.data[key]);
		                    }
	
		                    files = fileEntry.data("files");
		                    if(files){
		                        this.populateFormData(formData, files);
		                    }
		                }
	
		                upload._fileState(fileEntry, "uploading");
		                $(fileEntry).removeClass("k-file-error").addClass("k-file-progress");
		                if(upload.options.async.useArrayBuffer && window.FileReader){
		                    this._readFile(upload.options.async.saveUrl, formData, fileEntry, xhr);
		                }else{
		                    this.postFormData(upload.options.async.saveUrl, formData, fileEntry, xhr);
		                }
		            } else {
		                this.removeFileEntry(fileEntry);
		            }
		        },
	
		        _readFile: function(saveUrl, formData, fileEntry, xhr){
		            var that = this;
		            var upload = that.upload;
		            var file = fileEntry.data("files")[0];
	
		            var reader = new FileReader();
		            reader.onload = function (e) {
		                try{
		                    if(!that.fileArrayBuffer){
		                        that.fileArrayBuffer = e.target.result;
		                    }else{
		                        that.fileArrayBuffer = that._appendBuffer(that.fileArrayBuffer, e.target.result);
		                    }
		                }catch(err) {
		                    upload._onUploadError({ target : $(fileEntry, upload.wrapper) }, xhr);
		                    return;
		                }
	
		                if(that.position[file.uid] > file.size){
		                    that.postFormData(upload.options.async.saveUrl, that.fileArrayBuffer, fileEntry, xhr);
		                    that.fileArrayBuffer = null;
		                }else{
		                    that._readFile(saveUrl, formData, fileEntry, xhr);
		                }
		            };
		            reader.onerror = function () {
		                upload._onUploadError({ target : $(fileEntry, upload.wrapper) }, xhr);
		            };
		            reader.readAsArrayBuffer(that._getCurrentChunk(file.rawFile, file.uid));
		        },
	
		        _appendBuffer: function(buffer1, buffer2) {
		            var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
	
		            tmp.set(new Uint8Array(buffer1), 0);
		            tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
	
		            return tmp.buffer;
		        },
	
		        onSaveSelected: function() {
		            var module = this;
		            var upload = module.upload;
	
		            $(".k-toupload", this.element).filter(function() {
		                var fileEntry = $(this);
		                var started = isFileUploadStarted(fileEntry);
		                var hasValidationErrors = upload._filesContainValidationErrors(fileEntry.data("fileNames"));
	
		                return !started && !hasValidationErrors;
		            }).each(function(index) {
		                var fileEntry = $(this);
		                var prevEntry = fileEntry.prev();
	
		                fileEntry.removeClass("k-toupload");
		                if(upload.options.async.chunkSize){
		                    module.prepareChunk(fileEntry);
	
		                    if(upload.options.async.concurrent || (index === 0 && !prevEntry.length) ||
		                        (index === 0 && prevEntry.hasClass("k-file-success") || prevEntry.hasClass("k-file-error"))){
		                        module.performUpload(fileEntry);
		                    }
		                }else{
		                    module.performUpload(fileEntry);
		                }
		            });
		        },
	
		        onCancel: function(e) {
		            var fileEntry = getFileEntry(e);
	
		            if(this.upload.options.async.chunkSize){
		                this.cancelled[fileEntry.data("uid")] = true;
		            }
		            this.stopUploadRequest(fileEntry);
		            this.removeFileEntry(fileEntry);
		        },
	
		        onPause: function(e) {
		            var fileEntry = getFileEntry(e);
		            var fileUid = fileEntry.data("uid");
		            var async = this.upload.options.async;
	
		            if(async.chunkSize){
		                this.retries[fileUid] = async.maxAutoRetries + 1;
		                this.paused[fileUid] = true;
		                this.resume[fileUid] = false;
		            }
		        },
	
		        onResume: function(e) {
		            var fileEntry = getFileEntry(e);
		            var fileUid = fileEntry.data("uid");
	
		            if(this.upload.options.async.chunkSize){
		                delete this.paused[fileUid];
		                this.resume[fileUid] = true;
		                this.retries[fileEntry.data("uid")] = 1;
		                this._increaseChunkIndex(fileUid);
		                this.performUpload(fileEntry);
		            }
		        },
	
		        onRetry: function(e) {
		            var fileEntry = getFileEntry(e);
		            var async = this.upload.options.async;
	
		            if(async.chunkSize){
		                this.retries[fileEntry.data("uid")] = async.maxAutoRetries + 1;
		                delete this.paused[fileEntry.data("uid")];
		            }
	
		            this.performUpload(fileEntry);
		        },
	
		        onRemove: function(e, eventArgs, shouldSendRemoveRequest) {
		            var module = this;
		            var upload = module.upload;
		            var fileEntry = getFileEntry(e);
		            var async = this.upload.options.async;
	
		            if(async.chunkSize){
		                this.retries[fileEntry.data("uid")] = async.maxAutoRetries + 1;
		            }
	
		            if (fileEntry.hasClass("k-file-success")) {
		                removeUploadedFile(fileEntry, upload, eventArgs, shouldSendRemoveRequest);
		            } else {
		                module.removeFileEntry(fileEntry);
		            }
		        },
	
		        createXHR: function() {
		            return new XMLHttpRequest();
		        },
	
		        postFormData: function(url, data, fileEntry, xhr) {
		            var module = this;
	
		            fileEntry.data("request", xhr);
	
		            xhr.addEventListener("load", function(e) {
		                module.onRequestSuccess.call(module, e, fileEntry);
		            }, false);
	
		            xhr.addEventListener(ERROR, function(e) {
		                module.onRequestError.call(module, e, fileEntry);
		            }, false);
	
		            xhr.upload.addEventListener("progress", function(e) {
		                module.onRequestProgress.call(module, e, fileEntry);
		            }, false);
	
		            xhr.open("POST", url, true);
		            xhr.withCredentials = this.upload.options.async.withCredentials;
	
		            var accept = this.upload.options.async.accept;
		            if (accept) {
		                xhr.setRequestHeader("Accept", accept);
		            }
	
		            xhr.send(data);
		        },
	
		        createFormData: function() {
		            return new FormData();
		        },
	
		        populateFormData: function(data, files) {
		            var chunk;
		            var i;
		            var length = files.length;
		            var uid;
		            var upload = this.upload;
	
		            if(upload.options.async.chunkSize){
		                 uid = files[0].uid;
		                 chunk = this._getCurrentChunk(files[0].rawFile, uid);
	
		                data.append(
		                    upload.options.async.saveField || upload.name,
		                    chunk
		                );
	
		                var serializedMetaData = JSON.stringify(this.metaData[uid]);
		                data.append("metadata", serializedMetaData);
		            }else{
		                 for (i = 0; i < length; i++) {
		                    data.append(
		                        upload.options.async.saveField || upload.name,
		                        files[i].rawFile
		                    );
		                 }
		            }
	
		            return data;
		        },
	
		        onRequestSuccess: function(e, fileEntry) {
		            var xhr = e.target,
		                module = this;
	
		            function raiseError() {
		                module.upload._onUploadError({ target : $(fileEntry, module.upload.wrapper) }, xhr);
		            }
	
		            function parseSuccess(jsonResult) {
		                var batch = module.upload.options.async.batch;
		                var chunkSize = module.upload.options.async.chunkSize;
		                var concurrent = module.upload.options.async.concurrent;
		                var fileUid = jsonResult.fileUid;
	
		                if(module.paused[fileUid] || module.cancelled[fileUid]){
		                    return;
		                }
	
		                delete module.retries[fileUid];
	
		                if(chunkSize && !batch && !jsonResult.uploaded){
	
		                    module._increaseChunkIndex(fileUid);
		                    module.performUpload(fileEntry);
		                }else if(chunkSize && !batch && !concurrent && fileEntry.next().length && !fileEntry.next().hasClass("k-toupload")) {
		                        module.upload._onFileProgress({ target : $(fileEntry, module.upload.wrapper) }, 100);
		                        module._resetChunkIndex(fileUid);
		                        module.upload._onUploadSuccess({ target : $(fileEntry, module.upload.wrapper) }, jsonResult, xhr);
	
		                        module.performUpload(fileEntry.next());
		                }else{
		                    module.upload._onFileProgress({ target : $(fileEntry, module.upload.wrapper) }, 100);
		                    module.upload._onUploadSuccess({ target : $(fileEntry, module.upload.wrapper) }, jsonResult, xhr);
		                    module.cleanupFileEntry(fileEntry);
		                }
		            }
	
		            if (xhr.status >= 200 && xhr.status <= 299) {
		                tryParseJSON(xhr.responseText,
		                    parseSuccess,
		                    raiseError
		                );
		            } else {
		                raiseError();
		            }
		        },
	
		        onRequestError: function(e, fileEntry) {
		            var xhr = e.target;
	
		            this.upload._onUploadError({ target : $(fileEntry, this.upload.wrapper) }, xhr);
		        },
	
		        cleanupFileEntry: function(fileEntry) {
		            var relatedInput = fileEntry.data("relatedInput"),
		                uploadComplete = true;
	
		            if (relatedInput) {
		                $.each(relatedInput.data("relatedFileEntries") || [], function() {
		                    // Exclude removed file entries and self
		                    if (this.parent().length > 0 && this[0] != fileEntry[0]) {
		                        uploadComplete = uploadComplete && this.hasClass("k-file-success");
		                    }
		                });
	
		                if (uploadComplete) {
		                    relatedInput.remove();
		                }
		            }
		        },
	
		        removeFileEntry: function(fileEntry) {
		            var chunkSize = this.upload.options.async.chunkSize;
		            var concurrent = this.upload.options.async.concurrent;
		            var isUploadButtonVisible = this.upload.wrapper.find(".k-upload-selected").length > 0;
	
		            this.cleanupFileEntry(fileEntry);
		            if(chunkSize && !concurrent && !isUploadButtonVisible){
		                 if(fileEntry.next().length){
		                     this.performUpload(fileEntry.next());
		                 }
		            }
		            this.upload._removeFileEntry(fileEntry);
		        },
	
		        onRequestProgress: function(e, fileEntry) {
		            var percentComplete = Math.round(e.loaded * 100 / e.total);
		            var fileUid = fileEntry.data("uid");
		            var fileMetaData;
	
		            if(this.upload.options.async.chunkSize){
		                fileMetaData = this.metaData[fileUid];
		                percentComplete = fileMetaData && fileMetaData.totalChunks ? Math.round(((fileMetaData.chunkIndex)/fileMetaData.totalChunks)*100):100;
		            }
		            this.upload._onFileProgress({ target : $(fileEntry, this.upload.wrapper) }, percentComplete);
		        },
	
		        stopUploadRequest: function(fileEntry) {
		            fileEntry.data("request").abort();
		        },
	
		        prepareChunk: function (fileEntry) {
		            var file = fileEntry.data("files")[0];
		            var rawFile = file.rawFile;
		            var uid = file.uid;
		            var chunkSize  = this.upload.options.async.chunkSize;
		            this.position[uid] = 0;
	
		            this.metaData[uid] = {
		                chunkIndex: 0,
		                contentType: rawFile.type,
		                fileName: rawFile.name,
		                relativePath: file.name,
		                totalFileSize: rawFile.size,
		                totalChunks: Math.ceil(rawFile.size / chunkSize),
		                uploadUid: uid
		            };
		        },
	
		        _decreaseChunkIndex: function(uid){
		            this.metaData[uid].chunkIndex--;
		        },
	
		        _increaseChunkIndex: function(uid){
		            this.metaData[uid].chunkIndex++;
		        },
	
		        _resetChunkIndex: function(uid){
		            this.metaData[uid].chunkIndex = 0;
		        },
	
		        _decreasePosition: function(uid){
		            this.position[uid] -= this.upload.options.async.chunkSize;
		        },
	
		        _getCurrentChunk: function (file, uid) {
		            var oldPosition = this.position[uid];
		            var methodToInvoke;
		            var async = this.upload.options.async;
		            var chunkSize = async.chunkSize || async.bufferChunkSize;
	
		            if(!this.position[uid]){
		                this.position[uid] = 0;
		            }
		            this.position[uid] += chunkSize;
	
		            if (!!(methodToInvoke = this._getChunker(file))){
		                return file[methodToInvoke](oldPosition, this.position[uid]);
		            }else{
		                return file;
		            }
		        },
	
		        _getChunker: function (file) {
		            if (file.slice) {
		                return "slice";
		            }else if (file.mozSlice) {
		                return "mozSlice";
		            }else if (file.webkitSlice) {
		                    return "webkitSlice";
		            }else {
		                return null;
		            }
		        }
		    };
	
		    // Helper functions
		    function getFileName(input) {
		        return $.map(inputFiles(input), function (file) {
		            return file.name;
		        }).join(", ");
		    }
	
		    function inputFiles($input) {
		        var input = $input[0];
	
		        if (input.files) {
		            return getAllFileInfo(input.files);
		        } else {
		            return [{
		                name: stripPath(input.value),
		                extension: getFileExtension(input.value),
		                size: null
		            }];
		        }
		    }
	
		    function getAllFileInfo(rawFiles) {
		        return $.map(rawFiles, function (file) {
		            return getFileInfo(file);
		        });
		    }
	
		    function getFileInfo(rawFile) {
		        // Older Firefox versions (before 3.6) use fileName and fileSize
		        var fileName = rawFile.name || rawFile.fileName;
		        return {
		            name: kendo.htmlEncode(fileName),
		            extension: getFileExtension(fileName),
		            size: typeof rawFile.size == "number" ? rawFile.size : rawFile.fileSize, //rawFile.size || rawFile.fileSize,
		            rawFile: rawFile
		        };
		    }
	
		    function getFileExtension(fileName) {
		        var matches = fileName.match(rFileExtension);
		        return matches ? matches[0] : "";
		    }
	
		    function stripPath(name) {
		        var slashIndex = name.lastIndexOf("\\");
		        return (slashIndex != -1) ? name.substr(slashIndex + 1) : name;
		    }
	
		    function assignGuidToFiles(files, unique) {
		        var uid = kendo.guid();
	
		        return $.map(files, function(file){
		            file.uid = unique ? kendo.guid() : uid;
	
		            return file;
		        });
		    }
	
		    function validateFiles(files, validationInfo) {
		        var allowedExtensions = parseAllowedExtensions(validationInfo.allowedExtensions);
		        var maxFileSize = validationInfo.maxFileSize;
		        var minFileSize = validationInfo.minFileSize;
	
		        for(var i = 0; i < files.length; i++) {
		            validateFileExtension(files[i], allowedExtensions);
		            validateFileSize(files[i], minFileSize, maxFileSize);
		        }
		    }
	
		    function parseAllowedExtensions(extensions) {
		        var allowedExtensions = $.map(extensions, function(ext){
		            var parsedExt = (ext.substring(0, 1) === ".") ? ext : ("." + ext);
		            return parsedExt.toLowerCase();
		        });
	
		        return allowedExtensions;
		    }
	
		    function validateFileExtension(file, allowedExtensions) {
		        if(allowedExtensions.length > 0) {
		            if(allowedExtensions.indexOf(file.extension.toLowerCase()) < 0) {
		                file.validationErrors = file.validationErrors || [];
		                if($.inArray(INVALIDFILEEXTENSION, file.validationErrors) === -1) {
		                    file.validationErrors.push(INVALIDFILEEXTENSION);
		                }
		            }
		        }
		    }
	
		    function validateFileSize(file, minFileSize, maxFileSize) {
		        if(minFileSize !== 0 && file.size < minFileSize) {
		            file.validationErrors = file.validationErrors || [];
		            if($.inArray(INVALIDMINFILESIZE, file.validationErrors) === -1) {
		                file.validationErrors.push(INVALIDMINFILESIZE);
		            }
		        }
	
		        if(maxFileSize !== 0 && file.size > maxFileSize) {
		            file.validationErrors = file.validationErrors || [];
		            if($.inArray(INVALIDMAXFILESIZE, file.validationErrors) === -1) {
		                file.validationErrors.push(INVALIDMAXFILESIZE);
		            }
		        }
		    }
	
		    function getTotalFilesSizeMessage(files) {
		        var totalSize = 0;
	
		        if(typeof files[0].size == "number") {
		            for(var i = 0; i < files.length; i++) {
		                if(files[i].size) {
		                    totalSize += files[i].size;
		                }
		            }
		        } else {
		            return "";
		        }
	
		        totalSize /= 1024;
	
		        if(totalSize < 1024) {
		            return totalSize.toFixed(2) + " KB";
		        } else {
		            return (totalSize / 1024).toFixed(2) + " MB";
		        }
		    }
	
		    function shouldRemoveFileEntry(upload) {
		        return !upload.multiple && $(".k-file", upload.wrapper).length > 1;
		    }
	
		    function removeUploadedFile(fileEntry, upload, eventArgs, shouldSendRemoveRequest) {
		        if (!upload._supportsRemove()) {
		            if(shouldRemoveFileEntry(upload) || !shouldSendRemoveRequest) {
		                upload._removeFileEntry(fileEntry);
		            }
	
		            return;
		        }
	
		        var files = fileEntry.data("fileNames");
		        var fileNames = $.map(files, function(file) { return file.name; });
	
		        if(shouldSendRemoveRequest === false) {
		            upload._removeFileEntry(fileEntry);
	
		            return;
		        }
	
		        upload._submitRemove(fileNames, eventArgs,
		            function onSuccess(data, textStatus, xhr) {
		                var prevented = upload.trigger(SUCCESS, {
		                    operation: "remove",
		                    files: files,
		                    response: data,
		                    XMLHttpRequest: xhr
		                });
	
		                if(!prevented) {
		                    upload._removeFileEntry(fileEntry);
		                }
		            },
	
		            function onError(xhr) {
		                if(shouldRemoveFileEntry(upload)) {
		                    upload._removeFileEntry(fileEntry);
		                }
	
		                upload.trigger(ERROR, {
		                    operation: "remove",
		                    files: files,
		                    XMLHttpRequest: xhr
		                });
	
		                logToConsole("Server response: " + xhr.responseText);
		            }
		        );
		    }
	
		    function tryParseJSON(input, onSuccess, onError) {
		        var success = false,
		            json = "";
	
		        try {
		            json = $.parseJSON(normalizeJSON(input));
		            success = true;
		        } catch (e) {
		            onError();
		        }
	
		        if (success) {
		            onSuccess(json);
		        }
		    }
	
		    function normalizeJSON(input) {
		        if (typeof input === "undefined" || input === "") {
		            input = "{}";
		        }
	
		        return input;
		    }
	
		    function stopEvent(e) {
		        e.stopPropagation(); e.preventDefault();
		    }
	
		    function bindDragEventWrappers(element, namespace, onDragEnter, onDragLeave) {
		        var hideInterval, lastDrag;
	
		        element
		            .on("dragenter" + namespace, function(e) {
		                onDragEnter(e);
		                lastDrag = new Date();
	
		                if (!hideInterval) {
		                    hideInterval = setInterval(function() {
		                        var sinceLastDrag = new Date() - lastDrag;
		                        if (sinceLastDrag > 100) {
		                            onDragLeave();
	
		                            clearInterval(hideInterval);
		                            hideInterval = null;
		                        }
		                    }, 100);
		                }
		            })
		            .on("dragover" + namespace, function() {
		                lastDrag = new Date();
		            });
		    }
	
		    function isFileUploadStarted(fileEntry) {
		        return fileEntry.is(".k-file-progress, .k-file-success, .k-file-error");
		    }
	
		    function getFileEntry(e) {
		        return $(e.target).closest(".k-file");
		    }
	
		    kendo.ui.plugin(Upload);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1331);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1331:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "tabstrip",
		    name: "TabStrip",
		    category: "web",
		    description: "The TabStrip widget displays a collection of tabs with associated tab content.",
		    depends: [ "data" ],
		    features: [ {
		        id: "tabstrip-fx",
		        name: "Animation",
		        description: "Support for animation",
		        depends: [ "fx" ]
		    } ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        keys = kendo.keys,
		        map = $.map,
		        each = $.each,
		        trim = $.trim,
		        extend = $.extend,
		        isFunction = kendo.isFunction,
		        template = kendo.template,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        Widget = ui.Widget,
		        excludedNodesRegExp = /^(a|div)$/i,
		        NS = ".kendoTabStrip",
		        IMG = "img",
		        HREF = "href",
		        PREV = "prev",
		        NEXT = "next",
		        SHOW = "show",
		        LINK = "k-link",
		        LAST = "k-last",
		        CLICK = "click",
		        ERROR = "error",
		        EMPTY = ":empty",
		        IMAGE = "k-image",
		        FIRST = "k-first",
		        SELECT = "select",
		        ACTIVATE = "activate",
		        CONTENT = "k-content",
		        CONTENTURL = "contentUrl",
		        MOUSEENTER = "mouseenter",
		        MOUSELEAVE = "mouseleave",
		        CONTENTLOAD = "contentLoad",
		        DISABLEDSTATE = "k-state-disabled",
		        DEFAULTSTATE = "k-state-default",
		        ACTIVESTATE = "k-state-active",
		        FOCUSEDSTATE = "k-state-focused",
		        HOVERSTATE = "k-state-hover",
		        TABONTOP = "k-tab-on-top",
		        NAVIGATABLEITEMS = ".k-item:not(." + DISABLEDSTATE + ")",
		        KEYBOARDNAVIGATABLEITEMS = ".k-item",
		        HOVERABLEITEMS = ".k-tabstrip-items > " + NAVIGATABLEITEMS + ":not(." + ACTIVESTATE + ")",
		        DEFAULTDISTANCE = 200,
	
		        templates = {
		            content: template(
		                "<div class='k-content'#= contentAttributes(data) # role='tabpanel'>#= content(item) #</div>"
		            ),
		            itemWrapper: template(
		                "<#= tag(item) # class='k-link'#= contentUrl(item) ##= textAttributes(item) #>" +
		                    "#= image(item) ##= sprite(item) ##= text(item) #" +
		                "</#= tag(item) #>"
		            ),
		            item: template(
		                "<li class='#= wrapperCssClass(group, item) #' role='tab' #=item.active ? \"aria-selected='true'\" : ''#>" +
		                    "#= itemWrapper(data) #" +
		                "</li>"
		            ),
		            image: template("<img class='k-image' alt='' src='#= imageUrl #' />"),
		            sprite: template("<span class='k-sprite #= spriteCssClass #'></span>"),
		            empty: template("")
		        },
	
		        rendering = {
		            wrapperCssClass: function (group, item) {
		                var result = "k-item",
		                    index = item.index;
	
		                if (item.enabled === false) {
		                    result += " k-state-disabled";
		                } else {
		                    result += " k-state-default";
		                }
	
		                if (index === 0) {
		                    result += " k-first";
		                }
	
		                if (index == group.length-1) {
		                    result += " k-last";
		                }
	
		                return result;
		            },
		            textAttributes: function(item) {
		                return item.url ? " href='" + item.url + "'" : "";
		            },
		            text: function(item) {
		                return item.encoded === false ? item.text : kendo.htmlEncode(item.text);
		            },
		            tag: function(item) {
		                return item.url ? "a" : "span";
		            },
		            contentAttributes: function(content) {
		                return content.active !== true ? " style='display:none' aria-hidden='true' aria-expanded='false'" : "";
		            },
		            content: function(item) {
		                return item.content ? item.content : item.contentUrl ? "" : "&nbsp;";
		            },
		            contentUrl: function(item) {
		                return item.contentUrl ? kendo.attr("content-url") + '="' + item.contentUrl + '"' : "";
		            }
		        };
	
		    function updateTabClasses (tabs) {
		        tabs.children(IMG)
		            .addClass(IMAGE);
	
		        tabs.children("a")
		            .addClass(LINK)
		            .children(IMG)
		            .addClass(IMAGE);
	
		        tabs.filter(":not([disabled]):not([class*=k-state-disabled])")
		            .addClass(DEFAULTSTATE);
	
		        tabs.filter("li[disabled]")
		            .addClass(DISABLEDSTATE)
		            .attr("aria-disabled", "true")
		            .removeAttr("disabled");
	
		        tabs.filter(":not([class*=k-state])")
		            .children("a")
		            .filter(":focus")
		            .parent()
		            .addClass(ACTIVESTATE + " " + TABONTOP);
	
		        tabs.attr("role", "tab");
		        tabs.filter("." + ACTIVESTATE)
		            .attr("aria-selected", true);
	
	
		        tabs.each(function() {
		            var item = $(this);
	
		            if (!item.children("." + LINK).length) {
		                item
		                    .contents()      // exclude groups, real links, templates and empty text nodes
		                    .filter(function() { return (!this.nodeName.match(excludedNodesRegExp) && !(this.nodeType == 3 && !trim(this.nodeValue))); })
		                    .wrapAll("<span UNSELECTABLE='on' class='" + LINK + "'/>");
		            }
		        });
	
		    }
	
		    function updateFirstLast (tabGroup) {
		        var tabs = tabGroup.children(".k-item");
	
		        tabs.filter(".k-first:not(:first-child)").removeClass(FIRST);
		        tabs.filter(".k-last:not(:last-child)").removeClass(LAST);
		        tabs.filter(":first-child").addClass(FIRST);
		        tabs.filter(":last-child").addClass(LAST);
		    }
	
		    function scrollButtonHtml(buttonClass, iconClass) {
		        return "<span class='k-button k-button-icon k-bare k-tabstrip-" + buttonClass + "' unselectable='on'><span class='k-icon " + iconClass + "'></span></span>";
		    }
	
		    var TabStrip = Widget.extend({
		        init: function(element, options) {
		            var that = this, value;
	
		            Widget.fn.init.call(that, element, options);
	
		            that._animations(that.options);
	
		            options = that.options;
	
		            that._contentUrls = options.contentUrls || [];
	
		            that._wrapper();
	
		            that._isRtl = kendo.support.isRtl(that.wrapper);
	
		            that._tabindex();
	
		            that._updateClasses();
	
		            that._dataSource();
	
		            if (options.dataSource) {
		                that.dataSource.fetch();
		            }
	
		            that._tabPosition();
	
		            that._scrollable();
	
		            if (that._contentUrls.length) {
		                that.wrapper.find(".k-tabstrip-items > .k-item")
		                    .each(function(index, item) {
		                        var url = that._contentUrls[index];
	
		                        if (typeof url === 'string') {
		                            $(item).find(">." + LINK).data(CONTENTURL, url);
		                        }
		                    });
		            } else {
		                that._contentUrls.length = that.tabGroup.find("li.k-item").length;
		            }
	
		            that.wrapper
		                .on(MOUSEENTER + NS + " " + MOUSELEAVE + NS, HOVERABLEITEMS, that._toggleHover)
		                .on("focus" + NS, $.proxy(that._active, that))
		                .on("blur" + NS, function() { that._current(null); });
	
		            that._keyDownProxy = $.proxy(that._keydown, that);
	
		            if (options.navigatable) {
		                that.wrapper.on("keydown" + NS, that._keyDownProxy);
		            }
	
		            if (that.options.value) {
		                value = that.options.value;
		            }
	
		            that.wrapper.children(".k-tabstrip-items")
		                .on(CLICK + NS, ".k-state-disabled .k-link", false)
		                .on(CLICK + NS, " > " + NAVIGATABLEITEMS, function (e) {
		                    var wr = that.wrapper[0];
		                    if (wr !== document.activeElement) {
		                        var msie = kendo.support.browser.msie;
		                        if (msie) {
		                            try {
		                                // does not scroll to the active element
		                                wr.setActive();
		                            } catch (j) {
		                                wr.focus();
		                            }
		                        } else {
		                            wr.focus();
		                        }
		                    }
	
		                    if (that._click($(e.currentTarget))) {
		                        e.preventDefault();
		                    }
		                });
	
		            var selectedItems = that.tabGroup.children("li." + ACTIVESTATE),
		                content = that.contentHolder(selectedItems.index());
	
		            if (selectedItems[0] && content.length > 0 && content[0].childNodes.length === 0) {
		                that.activateTab(selectedItems.eq(0));
		            }
	
		            that.element.attr("role", "tablist");
	
		            if (that.element[0].id) {
		                that._ariaId = that.element[0].id + "_ts_active";
		            }
		            that.value(value);
		            kendo.notify(that);
		        },
	
		        _active: function () {
		            var item = this.tabGroup.children().filter("." + ACTIVESTATE);
	
		            item = item[0] ? item : this._endItem("first");
		            if (item[0]) {
		                this._current(item);
		            }
		        },
	
		        _endItem: function(action) {
		            return this.tabGroup.children(NAVIGATABLEITEMS)[action]();
		        },
	
		        _getItem: function(action) {
		            return this.tabGroup.children(KEYBOARDNAVIGATABLEITEMS)[action]();
		        },
	
		        _item: function(item, action) {
		            var endItem;
		            if (action === PREV) {
		                endItem = "last";
		            } else {
		                endItem = "first";
		            }
	
		            if (!item) {
		                return this._endItem(endItem);
		            }
	
		            item = item[action]();
	
		            if (!item[0]) {
		                item = this.tabGroup.children(KEYBOARDNAVIGATABLEITEMS)[endItem]();
		            }
	
		            if (item.hasClass(DISABLEDSTATE)) {
		                item.addClass(FOCUSEDSTATE);
		            }
		            if (item.hasClass(DISABLEDSTATE) || item.hasClass(ACTIVESTATE)) {
		                this._focused = item;
		            }
	
		            return item;
		        },
	
		        _current: function (candidate) {
		            var that = this,
		                focused = that._focused,
		                id = that._ariaId;
	
		            if (candidate === undefined) {
		                return focused;
		            }
	
		            if (focused) {
		                that.tabGroup.children("#" + id).removeAttr("id");
		                focused.removeClass(FOCUSEDSTATE);
		            }
	
		            if (candidate) {
		                if (!candidate.hasClass(ACTIVESTATE)) {
		                    candidate.addClass(FOCUSEDSTATE);
		                }
	
		                that.element.removeAttr("aria-activedescendant");
	
		                id = candidate[0].id || id;
	
		                if (id) {
		                    candidate.attr("id", id);
		                    that.element.attr("aria-activedescendant", id);
		                }
		            }
	
		            that._focused = candidate;
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode,
		                current = that._current(),
		                rtl = that._isRtl,
		                isHorizontal = /top|bottom/.test(that.options.tabPosition),
		                action;
	
		            if (e.target != e.currentTarget) {
		                return;
		            }
	
		            if (key === keys.DOWN && !isHorizontal) {
		                action = NEXT;
		            } else if (key === keys.UP && !isHorizontal) {
		                action = PREV;
		            } else if (key === keys.RIGHT && isHorizontal) {
		                action = rtl ? PREV : NEXT;
		            } else if (key === keys.LEFT && isHorizontal) {
		                action = rtl ? NEXT : PREV;
		            } else if (key == keys.ENTER || key == keys.SPACEBAR) {
		                that._click(current);
		                e.preventDefault();
		            } else if (key == keys.HOME) {
		                that._click(that._getItem("first"));
		                e.preventDefault();
		                return;
		            } else if (key == keys.END) {
		                that._click(that._getItem("last"));
		                e.preventDefault();
		                return;
		            }
	
		            if (action) {
		                that._click(that._item(current, action));
		                e.preventDefault();
		            }
		        },
	
		        _dataSource: function() {
		            var that = this;
	
		            if (that.dataSource && that._refreshHandler) {
		                that.dataSource.unbind("change", that._refreshHandler);
		            } else {
		                that._refreshHandler = $.proxy(that.refresh, that);
		            }
	
		            that.dataSource = kendo.data.DataSource.create(that.options.dataSource)
		                                .bind("change", that._refreshHandler);
		        },
	
		        setDataSource: function(dataSource) {
		            var that = this;
	
		            that.options.dataSource = dataSource;
		            that._dataSource();
		            that.dataSource.fetch();
		        },
	
		        _animations: function(options) {
		            if (options && ("animation" in options) && !options.animation) {
		                options.animation = { open: { effects: {} }, close: { effects: {} } }; // No animation
		            }
		        },
	
		        refresh: function(e) {
		            var that = this,
		                options = that.options,
		                encoded = kendo.getter(options.dataEncodedField),
		                text = kendo.getter(options.dataTextField),
		                content = kendo.getter(options.dataContentField),
		                contentUrl = kendo.getter(options.dataContentUrlField),
		                image = kendo.getter(options.dataImageUrlField),
		                url = kendo.getter(options.dataUrlField),
		                sprite = kendo.getter(options.dataSpriteCssClass),
		                idx,
		                tabs = [],
		                tab,
		                action,
		                view = that.dataSource.view(),
		                length;
	
	
		            e = e || {};
		            action = e.action;
	
		            if (action) {
		               view = e.items;
		            }
	
		            for (idx = 0, length = view.length; idx < length; idx ++) {
		                tab = {
		                    text: text(view[idx])
		                };
	
		                if (options.dataEncodedField) {
		                    tab.encoded = encoded(view[idx]);
		                }
	
		                if (options.dataContentField) {
		                    tab.content = content(view[idx]);
		                }
	
		                if (options.dataContentUrlField) {
		                    tab.contentUrl = contentUrl(view[idx]);
		                }
	
		                if (options.dataUrlField) {
		                    tab.url = url(view[idx]);
		                }
	
		                if (options.dataImageUrlField) {
		                    tab.imageUrl = image(view[idx]);
		                }
	
		                if (options.dataSpriteCssClass) {
		                    tab.spriteCssClass = sprite(view[idx]);
		                }
	
		                tabs[idx] = tab;
		            }
	
		            if (e.action == "add") {
		                if (e.index < that.tabGroup.children().length) {
		                    that.insertBefore(tabs, that.tabGroup.children().eq(e.index));
		                } else {
		                    that.append(tabs);
		                }
		            } else if (e.action == "remove") {
		                for (idx = 0; idx < view.length; idx++) {
		                   that.remove(e.index);
		                }
		            } else if (e.action == "itemchange") {
		                idx = that.dataSource.view().indexOf(view[0]);
		                if (e.field === options.dataTextField) {
		                    that.tabGroup.children().eq(idx).find(".k-link").text(view[0].get(e.field));
		                }
	
		                if (e.field === options.dataUrlField) {
		                    that._contentUrls[idx] = view[0].get(e.field);
		                }
		            } else {
		                that.trigger("dataBinding");
		                that.remove("li");
		                that._contentUrls = [];
		                that.append(tabs);
		                that.trigger("dataBound");
		            }
		        },
	
		        value: function(value) {
		            var that = this;
	
		            if (value !== undefined) {
		                if (value != that.value()) {
		                   that.tabGroup.children().each(function() {
		                        if ($.trim($(this).text()) == value) {
		                            that.select(this);
		                        }
		                   });
		                }
		            } else {
		                return that.select().text();
		            }
		        },
	
		        items: function() {
		            return this.tabGroup[0].children;
		        },
	
		        setOptions: function(options) {
		            var that = this,
		                animation = that.options.animation;
	
		            that._animations(options);
	
		            if (options.contentUrls) {
		                that._contentUrls = options.contentUrls;
		            }
	
		            options.animation = extend(true, animation, options.animation);
	
		            if (options.navigatable) {
		                that.wrapper.on("keydown" + NS,  that._keyDownProxy);
		            } else {
		                that.wrapper.off("keydown" + NS,  that._keyDownProxy);
		            }
	
		            Widget.fn.setOptions.call(that, options);
		        },
	
		        events: [
		            SELECT,
		            ACTIVATE,
		            SHOW,
		            ERROR,
		            CONTENTLOAD,
		            "change",
		            "dataBinding",
		            "dataBound"
		        ],
	
		        options: {
		            name: "TabStrip",
		            dataEncodedField: "",
		            dataTextField: "",
		            dataContentField: "",
		            dataImageUrlField: "",
		            dataUrlField: "",
		            dataSpriteCssClass: "",
		            dataContentUrlField: "",
		            tabPosition: "top",
		            animation: {
		                open: {
		                    effects: "expand:vertical fadeIn",
		                    duration: 200
		                },
		                close: { // if close animation effects are defined, they will be used instead of open.reverse
		                    duration: 200
		                }
		            },
		            collapsible: false,
		            navigatable: true,
		            contentUrls: false,
		            scrollable: {
		                distance: DEFAULTDISTANCE
		            }
		        },
	
		        destroy: function() {
		            var that = this,
		            scrollWrap = that.scrollWrap;
	
		            Widget.fn.destroy.call(that);
	
		            if (that._refreshHandler) {
		                that.dataSource.unbind("change", that._refreshHandler);
		            }
	
		            that.wrapper.off(NS);
		            that.wrapper.children(".k-tabstrip-items").off(NS);
	
		            if (that._scrollableModeActive) {
		                that._scrollPrevButton.off().remove();
		                that._scrollNextButton.off().remove();
		            }
	
		            kendo.destroy(that.wrapper);
		            scrollWrap.children(".k-tabstrip").unwrap();
		        },
	
		        select: function (element) {
		            var that = this;
	
		            if (arguments.length === 0) {
		                return that.tabGroup.children("li." + ACTIVESTATE);
		            }
	
		            if (!isNaN(element)) {
		                element = that.tabGroup.children().get(element);
		            }
	
		            element = that.tabGroup.find(element);
		            $(element).each(function (index, item) {
		                item = $(item);
		                if (!item.hasClass(ACTIVESTATE) && !that.trigger(SELECT, { item: item[0], contentElement: that.contentHolder(item.index())[0] })) {
		                    that.activateTab(item);
		                }
		            });
	
		            return that;
		        },
	
		        enable: function (element, state) {
		            this._toggleDisabled(element, state !== false);
	
		            return this;
		        },
	
		        disable: function (element) {
		            this._toggleDisabled(element, false);
	
		            return this;
		        },
	
		          reload: function (element) {
		            element = this.tabGroup.find(element);
		            var that = this;
		            var contentUrls = that._contentUrls;
	
		            element.each(function () {
		                var item = $(this),
		                    contentUrl = item.find("." + LINK).data(CONTENTURL) || contentUrls[item.index()],
		                    content = that.contentHolder(item.index());
	
		                if (contentUrl) {
		                    that.ajaxRequest(item, content, null, contentUrl);
		                }
		            });
	
		            return that;
		        },
	
		        append: function (tab) {
		            var that = this,
		                inserted = that._create(tab);
	
		            each(inserted.tabs, function (idx) {
		                var contents = inserted.contents[idx];
		                that.tabGroup.append(this);
		                if (that.options.tabPosition == "bottom") {
		                    that.tabGroup.before(contents);
		                } else if (that._scrollableModeActive) {
		                    that._scrollPrevButton.before(contents);
		                } else {
		                    that.wrapper.append(contents);
		                }
		                that.angular("compile", function(){ return { elements: [ contents ] }; });
		            });
	
		            updateFirstLast(that.tabGroup);
		            that._updateContentElements();
		            that.resize(true);
	
		            return that;
		        },
	
		        _appendUrlItem: function(url) {
		            this._contentUrls.push(url);
		        },
	
		        _moveUrlItem: function(from, to) {
		            this._contentUrls.splice(to, 0, this._contentUrls.splice(from, 1)[0]);
		        },
	
		        _removeUrlItem: function(index) {
		            this._contentUrls.splice(index, 1);
		        },
	
		        insertBefore: function (tab, referenceTab) {
		            if ($(tab).is($(referenceTab))) {
		                referenceTab = this.tabGroup.find(referenceTab).next();
		            } else {
		                referenceTab = this.tabGroup.find(referenceTab);
		            }
	
		            var that = this,
		                inserted = that._create(tab),
		                referenceContent = that.element.find("[id='" + referenceTab.attr("aria-controls") + "']");
	
		            each(inserted.tabs, function (idx) {
		                var contents = inserted.contents[idx];
		                var fromIndex = inserted.newTabsCreated ? that._contentUrls.length - (inserted.tabs.length - idx) : $(contents).index() - 1;
	
		                referenceTab.before(this);
		                referenceContent.before(contents);
	
		                that._moveUrlItem(fromIndex, $(this).index());
		                that.angular("compile", function(){ return { elements: [ contents ] }; });
		            });
	
		            updateFirstLast(that.tabGroup);
		            that._updateContentElements(inserted.newTabsCreated);
		            that.resize(true);
	
		            return that;
		        },
	
		        insertAfter: function (tab, referenceTab) {
		            if ($(tab).is($(referenceTab))) {
		                referenceTab = this.tabGroup.find(referenceTab).prev();
		            } else {
		                referenceTab = this.tabGroup.find(referenceTab);
		            }
	
		            var that = this,
		                inserted = that._create(tab),
		                referenceContent = that.element.find("[id='" + referenceTab.attr("aria-controls") + "']");
	
		            each(inserted.tabs, function (idx) {
		                var contents = inserted.contents[idx];
		                var fromIndex = inserted.newTabsCreated ? that._contentUrls.length - (inserted.tabs.length - idx) : $(contents).index() - 1;
	
		                referenceTab.after(this);
		                referenceContent.after(contents);
	
		                that._moveUrlItem(fromIndex, $(this).index());
		                that.angular("compile", function(){ return { elements: [ contents ] }; });
		            });
	
		            updateFirstLast(that.tabGroup);
		            that._updateContentElements(inserted.newTabsCreated);
		            that.resize(true);
	
		            return that;
		        },
	
		        remove: function (elements) {
		            var that = this;
		            var type = typeof elements;
		            var contents;
	
		            if (type === "string") {
		                elements = that.tabGroup.find(elements);
		            } else if (type === "number") {
		                elements = that.tabGroup.children().eq(elements);
		            }
	
		            contents = elements.map(function () {
		                var idx = $(this).index();
		                var content = that.contentElement(idx);
	
		                kendo.destroy(content);
		                that._removeUrlItem(idx);
	
		                return content;
		            });
	
		            elements.remove();
		            contents.empty();
		            contents.remove();
	
		            that._updateContentElements();
		            that.resize(true);
	
		            return that;
		        },
	
		        _create: function (tab) {
		            var that = this,
		            tabs,
		            contents,
		            content,
		            newTabsCreated = false;
	
		            tab = tab instanceof kendo.data.ObservableArray ? tab.toJSON() : tab;
	
		            if ($.isPlainObject(tab) || $.isArray(tab)) {
		                tab = $.isArray(tab) ? tab : [tab];
		                newTabsCreated = true;
	
		                tabs = map(tab, function (value, idx) {
		                            that._appendUrlItem(tab[idx].contentUrl || null);
	
		                            return $(TabStrip.renderItem({
		                                group: that.tabGroup,
		                                item: extend(value, { index: idx })
		                            }));
		                        });
	
		                contents = map( tab, function (value, idx) {
		                            if (typeof value.content == "string" || value.contentUrl) {
		                                return $(TabStrip.renderContent({
		                                    item: extend(value, { index: idx })
		                                }));
		                            }
		                        });
		            } else {
		                if (typeof tab == "string" && tab[0] != "<") {
		                    tabs = that.element.find(tab);
		                } else {
		                    tabs = $(tab);
		                }
		                contents = $();
		                tabs.each(function () {
		                    if (/k-tabstrip-items/.test(this.parentNode.className)) {
		                        var element = that.element.find("[id='" + this.getAttribute("aria-controls") + "']");
		                        content = element;
		                    } else {
		                        content = $("<div class='" + CONTENT + "'/>");
		                    }
	
		                    contents = contents.add(content);
		                });
	
		                updateTabClasses(tabs);
		            }
	
		            return { tabs: tabs, contents: contents, newTabsCreated: newTabsCreated };
		        },
	
		        _toggleDisabled: function(element, enable) {
		            element = this.tabGroup.find(element);
		            element.each(function () {
		                $(this)
		                    .toggleClass(DEFAULTSTATE, enable)
		                    .toggleClass(DISABLEDSTATE, !enable)
		                    .attr("aria-disabled", !enable);
		            });
		        },
	
		        _updateClasses: function() {
		            var that = this,
		                tabs, activeItem, activeTab;
	
		            that.wrapper.addClass("k-widget k-header k-tabstrip");
	
		            that.tabGroup = that.wrapper.children("ul").addClass("k-tabstrip-items k-reset");
	
		            if (!that.tabGroup[0]) {
		                that.tabGroup = $("<ul class='k-tabstrip-items k-reset'/>").appendTo(that.wrapper);
		            }
	
		            tabs = that.tabGroup.find("li").addClass("k-item");
	
		            if (tabs.length) {
		                activeItem = tabs.filter("." + ACTIVESTATE).index();
		                activeTab = activeItem >= 0 ? activeItem : undefined;
	
		                that.tabGroup // Remove empty text nodes
		                    .contents()
		                    .filter(function () { return (this.nodeType == 3 && !trim(this.nodeValue)); })
		                    .remove();
		            }
	
		            if (activeItem >= 0) {
		                tabs.eq(activeItem).addClass(TABONTOP);
		            }
	
		            that.contentElements = that.wrapper.children("div");
	
		            that.contentElements
		                .addClass(CONTENT)
		                .eq(activeTab)
		                .addClass(ACTIVESTATE)
		                .css({ display: "block" });
	
		            if (tabs.length) {
		                updateTabClasses(tabs);
	
		                updateFirstLast(that.tabGroup);
		                that._updateContentElements(true);
		            }
		        },
	
		        _elementId: function(element, idx) {
		            var elementId = element.attr("id");
		            var wrapperId = this.element.attr("id");
	
		            if (!elementId || elementId.indexOf(wrapperId + "-") > -1) {
		                var tabStripID = (wrapperId || kendo.guid()) + "-";
	
		                return tabStripID + (idx + 1);
		            }
	
		            return elementId;
		        },
	
		        _updateContentElements: function(isInitialUpdate) {
		            var that = this,
		                contentUrls = that._contentUrls,
		                items = that.tabGroup.children(".k-item"),
		                contentElements = that.wrapper.children("div"),
		                _elementId = that._elementId.bind(that);
	
		            if (contentElements.length && (items.length > contentElements.length)) {
		                contentElements.each(function(idx) {
		                    var id = _elementId($(this), idx);
		                    var item = items.filter("[aria-controls=" + (this.id || 0) + "]")[0];
	
		                    if (!item && isInitialUpdate) {
		                         item = items[idx];
		                    }
	
		                    if (item) {
		                        item.setAttribute("aria-controls", id);
		                    }
	
		                    this.setAttribute("id", id);
		                });
		            } else {
		                items.each(function(idx) {
		                    var currentContent = contentElements.eq(idx);
		                    var id = _elementId(currentContent, idx);
	
		                    this.setAttribute("aria-controls", id);
	
		                    if (!currentContent.length && contentUrls[idx]) {
		                        $("<div class='" + CONTENT + "'/>").appendTo(that.wrapper).attr("id", id);
		                    } else {
		                        currentContent.attr("id", id);
	
		                        if (!$(this).children(".k-loading")[0] && !contentUrls[idx]) {
		                            $("<span class='k-loading k-complete'/>").prependTo(this);
		                        }
		                    }
		                    currentContent.attr("role", "tabpanel");
		                    currentContent.filter(":not(." + ACTIVESTATE + ")").attr("aria-hidden", true).attr("aria-expanded", false);
		                    currentContent.filter("." + ACTIVESTATE).attr("aria-expanded", true);
		                });
		            }
	
		            that.contentElements = that.contentAnimators = that.wrapper.children("div"); // refresh the contents
	
		            that.tabsHeight = outerHeight(that.tabGroup) +
		                              parseInt(that.wrapper.css("border-top-width"), 10) +
		                              parseInt(that.wrapper.css("border-bottom-width"), 10);
	
		            if (kendo.kineticScrollNeeded && kendo.mobile.ui.Scroller) {
		                kendo.touchScroller(that.contentElements);
		                that.contentElements = that.contentElements.children(".km-scroll-container");
		            }
		        },
	
		        _wrapper: function() {
		            var that = this;
	
		            if (that.element.is("ul")) {
		                that.wrapper = that.element.wrapAll("<div />").parent();
		            } else {
		                that.wrapper = that.element;
		            }
	
		            that.scrollWrap = that.wrapper.parent(".k-tabstrip-wrapper");
	
		            if (!that.scrollWrap[0]) {
		                that.scrollWrap = that.wrapper.wrapAll("<div class='k-tabstrip-wrapper' />").parent();
		            }
		        },
	
		        _tabPosition: function() {
		            var that = this,
		                tabPosition = that.options.tabPosition;
	
		            that.wrapper.addClass("k-floatwrap k-tabstrip-" + tabPosition);
	
		            if (tabPosition == "bottom") {
		                that.tabGroup.appendTo(that.wrapper);
		            }
	
		            that.resize(true);
		        },
	
		        _setContentElementsDimensions: function () {
		            var that = this,
		                tabPosition = that.options.tabPosition;
	
		            if (tabPosition == "left" || tabPosition == "right") {
		                var contentDivs = that.wrapper.children(".k-content"),
		                    activeDiv = contentDivs.filter(":visible"),
		                    marginStyleProperty = "margin-" + tabPosition,
		                    tabGroup = that.tabGroup,
		                    margin = outerWidth(tabGroup);
	
		                var minHeight = Math.ceil(tabGroup.height()) -
		                    parseInt(activeDiv.css("padding-top"), 10) -
		                    parseInt(activeDiv.css("padding-bottom"), 10) -
		                    parseInt(activeDiv.css("border-top-width"), 10) -
		                    parseInt(activeDiv.css("border-bottom-width"), 10);
	
		                setTimeout(function () {
		                    contentDivs.css(marginStyleProperty, margin).css("min-height", minHeight);
		                });
		            }
		        },
	
		        _resize: function() {
		            this._setContentElementsDimensions();
		            this._scrollable();
		        },
	
		        _sizeScrollWrap: function (element) {
		            if (element.is(":visible")) {
		                var tabPosition = this.options.tabPosition;
		                var h = Math.floor(outerHeight(element, true)) + (tabPosition === "left" || tabPosition === "right" ? 2 : this.tabsHeight);
	
		                this.scrollWrap.css("height", h).css("height");
		            }
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVERSTATE, e.type == MOUSEENTER);
		        },
	
		        _click: function (item) {
		            var that = this,
		                link = item.find("." + LINK),
		                href = link.attr(HREF),
		                collapse = that.options.collapsible,
		                index = item.index(),
		                contentHolder = that.contentHolder(index),
		                prevent, isAnchor,
		                neighbours = item.parent().children(),
		                oldFocusedTab = neighbours.filter("." + FOCUSEDSTATE);
	
		            if (item.closest(".k-widget")[0] != that.wrapper[0]) {
		                return;
		            }
	
		            if (item.is("." + DISABLEDSTATE + (!collapse ? ",." + ACTIVESTATE : ""))) {
		                oldFocusedTab.removeClass(FOCUSEDSTATE);
		                that._focused = item;
	
		                item.addClass(FOCUSEDSTATE);
		                that._current(item);
	
		                if (that._scrollableModeActive) {
		                    that._scrollTabsToItem(item);
		                }
		                return true;
		            }
	
		            isAnchor = link.data(CONTENTURL) || that._contentUrls[index] || (href && (href.charAt(href.length - 1) == "#" || href.indexOf("#" + that.element[0].id + "-") != -1));
		            prevent = !href || isAnchor;
	
		            if (that.tabGroup.children("[data-animating]").length) {
		                return prevent;
		            }
	
		            if (that.trigger(SELECT, { item: item[0], contentElement: contentHolder[0] })) {
		                return true;
		            }
	
		            if (prevent === false) {
		                return;
		            }
	
		            if (collapse && item.is("." + ACTIVESTATE)) {
		                that.deactivateTab(item);
		                return true;
		            }
	
		            if (that.activateTab(item)) {
		                prevent = true;
		            }
	
		            return prevent;
		        },
	
		        _scrollable: function() {
		            var that = this,
		                options = that.options,
		                wrapperOffsetWidth,
		                tabGroupScrollWidth,
		                scrollPrevButton,
		                scrollNextButton;
	
		            if (that._scrollableAllowed()) {
	
		                that.wrapper.addClass("k-tabstrip-scrollable");
	
		                wrapperOffsetWidth = that.wrapper[0].offsetWidth;
		                tabGroupScrollWidth = that.tabGroup[0].scrollWidth;
	
		                if (tabGroupScrollWidth > wrapperOffsetWidth && !that._scrollableModeActive) {
		                    that._nowScrollingTabs = false;
		                    that._isRtl = kendo.support.isRtl(that.element);
		                    var mouseDown = kendo.support.mobileOS ? "touchstart" : "mousedown";
		                    var mouseUp = kendo.support.mobileOS ? "touchend" : "mouseup";
	
		                    that.wrapper.append(scrollButtonHtml("prev", "k-i-arrow-60-left") + scrollButtonHtml("next", "k-i-arrow-60-right"));
	
		                    scrollPrevButton = that._scrollPrevButton = that.wrapper.children(".k-tabstrip-prev");
		                    scrollNextButton = that._scrollNextButton = that.wrapper.children(".k-tabstrip-next");
	
		                    that.tabGroup.css({ marginLeft: outerWidth(scrollPrevButton) + 9, marginRight: outerWidth(scrollNextButton) + 12 });
	
		                    scrollPrevButton.on(mouseDown + NS, function () {
		                        that._nowScrollingTabs = true;
		                        that._scrollTabsByDelta(options.scrollable.distance * (that._isRtl ? 1 : -1));
		                    });
	
		                    scrollNextButton.on(mouseDown + NS, function () {
		                        that._nowScrollingTabs = true;
		                        that._scrollTabsByDelta(options.scrollable.distance * (that._isRtl ? -1 : 1));
		                    });
	
		                    scrollPrevButton.add(scrollNextButton).on(mouseUp + NS, function () {
		                        that._nowScrollingTabs = false;
		                    });
	
		                    that._scrollableModeActive = true;
	
		                    that._toggleScrollButtons();
		                } else if (that._scrollableModeActive && tabGroupScrollWidth <= wrapperOffsetWidth) {
		                    that._scrollableModeActive = false;
	
		                    that.wrapper.removeClass("k-tabstrip-scrollable");
	
		                    that._scrollPrevButton.off().remove();
		                    that._scrollNextButton.off().remove();
		                    that.tabGroup.css({ marginLeft: "", marginRight: "" });
		                } else if (!that._scrollableModeActive) {
		                    that.wrapper.removeClass("k-tabstrip-scrollable");
		                } else {
		                    that._toggleScrollButtons();
		                }
		            }
		        },
	
		        _scrollableAllowed: function() {
		            var options = this.options;
	
		            if(options.scrollable && !options.scrollable.distance){
		                options.scrollable = {distance: DEFAULTDISTANCE};
		            }
	
		            return options.scrollable && !isNaN(options.scrollable.distance) && (options.tabPosition == "top" || options.tabPosition == "bottom");
		        },
	
		        _scrollTabsToItem: function (item) {
		            var that = this,
		                tabGroup = that.tabGroup,
		                currentScrollOffset = tabGroup.scrollLeft(),
		                itemWidth = outerWidth(item),
		                itemOffset = that._isRtl ? item.position().left : item.position().left - tabGroup.children().first().position().left,
		                tabGroupWidth = tabGroup[0].offsetWidth,
		                tabGroupPadding = Math.ceil(parseFloat(tabGroup.css("padding-left"))),
		                itemPosition;
	
		            if (that._isRtl) {
		                if (itemOffset < 0) {
		                    itemPosition = currentScrollOffset + itemOffset - (tabGroupWidth - currentScrollOffset) - tabGroupPadding;
		                } else if (itemOffset + itemWidth > tabGroupWidth) {
		                    itemPosition = currentScrollOffset + itemOffset - itemWidth + tabGroupPadding * 2;
		                }
		            } else {
		                if (currentScrollOffset + tabGroupWidth < itemOffset + itemWidth) {
		                    itemPosition = itemOffset + itemWidth - tabGroupWidth + tabGroupPadding * 2;
		                } else if (currentScrollOffset > itemOffset) {
		                    itemPosition = itemOffset - tabGroupPadding;
		                }
		            }
	
		            tabGroup.finish().animate({ "scrollLeft": itemPosition }, "fast", "linear", function () {
		                that._toggleScrollButtons();
		            });
		        },
	
		        _scrollTabsByDelta: function (delta) {
		            var that = this;
		            var tabGroup = that.tabGroup;
		            var scrLeft = tabGroup.scrollLeft();
	
		            tabGroup.finish().animate({ "scrollLeft": scrLeft + delta }, "fast", "linear", function () {
		                if (that._nowScrollingTabs && !jQuery.fx.off) {
		                    that._scrollTabsByDelta(delta);
		                } else {
		                    that._toggleScrollButtons();
		                }
		            });
		        },
	
		        _toggleScrollButtons: function () {
		            var that = this,
		                ul = that.tabGroup,
		                scrollLeft = ul.scrollLeft();
	
		            that._scrollPrevButton.toggle(that._isRtl ? scrollLeft < ul[0].scrollWidth - ul[0].offsetWidth - 1 : scrollLeft !== 0);
		            that._scrollNextButton.toggle(that._isRtl ? scrollLeft !== 0 : scrollLeft < ul[0].scrollWidth - ul[0].offsetWidth - 1);
		        },
	
		        deactivateTab: function (item) {
		            var that = this,
		                animationSettings = that.options.animation,
		                animation = animationSettings.open,
		                close = extend({}, animationSettings.close),
		                hasCloseAnimation = close && "effects" in close;
		            item = that.tabGroup.find(item);
	
		            close = extend( hasCloseAnimation ? close : extend({ reverse: true }, animation), { hide: true });
	
		            if (kendo.size(animation.effects)) {
		                item.kendoAddClass(DEFAULTSTATE, { duration: animation.duration });
		                item.kendoRemoveClass(ACTIVESTATE, { duration: animation.duration });
		            } else {
		                item.addClass(DEFAULTSTATE);
		                item.removeClass(ACTIVESTATE);
		            }
	
		            item.removeAttr("aria-selected");
	
		            that.contentAnimators
		                    .filter("." + ACTIVESTATE)
		                    .kendoStop(true, true)
		                    .kendoAnimate( close )
		                    .removeClass(ACTIVESTATE)
		                    .attr("aria-hidden", true);
		        },
	
		        activateTab: function (item) {
		            if (this.tabGroup.children("[data-animating]").length) { return; }
	
		            item = this.tabGroup.find(item);
	
		            var that = this,
		                animationSettings = that.options.animation,
		                animation = animationSettings.open,
		                close = extend({}, animationSettings.close),
		                hasCloseAnimation = close && "effects" in close,
		                neighbours = item.parent().children(),
		                oldTab = neighbours.filter("." + ACTIVESTATE),
		                itemIndex = neighbours.index(item),
		                isAnimationEnabled = animation && "duration" in animation && "effects" in animation;
	
		            close = extend( hasCloseAnimation ? close : extend({ reverse: true }, animation), { hide: true });
		            // deactivate previously active tab
		            if (kendo.size(animation.effects)) {
		                oldTab.kendoRemoveClass(ACTIVESTATE, { duration: close.duration });
		                item.kendoRemoveClass(HOVERSTATE, { duration: close.duration });
		            } else {
		                oldTab.removeClass(ACTIVESTATE);
		                item.removeClass(HOVERSTATE);
		            }
	
		            // handle content elements
		            var contentAnimators = that.contentAnimators;
	
		            if (that.inRequest) {
		                that.xhr.abort();
		                that.inRequest = false;
		            }
	
		            if (contentAnimators.length === 0) {
		                that.tabGroup.find("." + TABONTOP).removeClass(TABONTOP);
		                item.addClass(TABONTOP) // change these directly to bring the tab on top.
		                    .css("z-index");
	
		                item.addClass(ACTIVESTATE);
		                that._current(item);
	
		                that.trigger("change");
	
		                if (that._scrollableModeActive) {
		                    that._scrollTabsToItem(item);
		                }
	
		                return false;
		            }
	
		            var visibleContents = contentAnimators.filter("." + ACTIVESTATE),
		                contentHolder = that.contentHolder(itemIndex),
		                contentElement = contentHolder.closest(".k-content");
	
		            that.tabsHeight = outerHeight(that.tabGroup) +
		                              parseInt(that.wrapper.css("border-top-width"), 10) +
		                              parseInt(that.wrapper.css("border-bottom-width"), 10);
	
		            that._sizeScrollWrap(visibleContents);
	
		            if (contentHolder.length === 0) {
		                visibleContents
		                    .removeClass( ACTIVESTATE )
		                    .attr("aria-hidden", true)
		                    .kendoStop(true, true)
		                    .kendoAnimate( close );
		                return false;
		            }
	
		            item.attr("data-animating", true);
	
		          var isAjaxContent = (item.children("." + LINK).data(CONTENTURL) || that._contentUrls[itemIndex] || false) && contentHolder.is(EMPTY),
		                showContentElement = function () {
		                    oldTab.removeAttr("aria-selected");
		                    item.attr("aria-selected", true);
	
		                    that._current(item);
	
		                    that._sizeScrollWrap(contentElement);
	
		                    contentElement
		                        .addClass(ACTIVESTATE)
		                        .removeAttr("aria-hidden")
		                        .kendoStop(true, true)
		                        .attr("aria-expanded", true)
		                        .kendoAnimate( extend({ init: function () {
		                            that.trigger(SHOW, { item: item[0], contentElement: contentHolder[0] });
		                            kendo.resize(contentHolder);
		                        } }, animation, {
		                            complete: function () {
		                                item.removeAttr("data-animating");
	
		                                that.trigger(ACTIVATE, { item: item[0], contentElement: contentHolder[0] });
		                                kendo.resize(contentHolder);
	
		                                that.scrollWrap.css("height", "").css("height");
	
		                                // Force IE and Edge rendering to fix visual glitches telerik/kendo-ui-core#2777.
		                                if (isAnimationEnabled && (kendo.support.browser.msie || kendo.support.browser.edge)) {
		                                    contentHolder.finish().animate({
		                                        opacity: 0.9
		                                    },"fast", "linear", function(){
		                                        contentHolder.finish().animate({
		                                            opacity: 1
		                                        },"fast", "linear");
		                                    });
		                                }
		                            }
		                        } ) );
		                },
		                showContent = function() {
		                    if (!isAjaxContent) {
		                        showContentElement();
		                        that.trigger("change");
		                    } else {
		                        item.removeAttr("data-animating");
		                        that.ajaxRequest(item, contentHolder, function () {
		                            item.attr("data-animating", true);
		                            showContentElement();
		                            that.trigger("change");
		                        });
		                    }
	
		                    if (that._scrollableModeActive) {
		                        that._scrollTabsToItem(item);
		                    }
	
		                };
	
		            visibleContents
		                    .removeClass(ACTIVESTATE);
	
		            that.tabGroup.find("." + TABONTOP).removeClass(TABONTOP);
		                    item.addClass(TABONTOP) // change these directly to bring the tab on top.
		                        .css("z-index");
	
		            if (kendo.size(animation.effects)) {
		                oldTab.kendoAddClass(DEFAULTSTATE, { duration: animation.duration });
		                item.kendoAddClass(ACTIVESTATE, { duration: animation.duration });
		            } else {
		                oldTab.addClass(DEFAULTSTATE);
		                item.addClass(ACTIVESTATE);
		            }
	
		            visibleContents.attr("aria-hidden", true);
		            visibleContents.attr("aria-expanded", false);
	
		            if (visibleContents.length) {
		                visibleContents
		                    .kendoStop(true, true)
		                    .kendoAnimate(extend( {
		                        complete: showContent
		                   }, close ));
		            } else {
		                showContent();
		            }
	
		            return true;
		        },
	
		        contentElement: function (itemIndex) {
		            if (isNaN(itemIndex - 0)) {
		                return undefined;
		            }
	
		            var contentElements = this.contentElements && this.contentElements[0] && !kendo.kineticScrollNeeded ? this.contentElements : this.contentAnimators;
		            var id = $(this.tabGroup.children()[itemIndex]).attr("aria-controls");
	
		            if (contentElements) {
		                for (var i = 0, len = contentElements.length; i < len; i++) {
		                    if (contentElements.eq(i).closest(".k-content")[0].id == id) {
		                        return contentElements[i];
		                    }
		                }
		            }
	
		            return undefined;
		        },
	
		        contentHolder: function (itemIndex) {
		            var contentElement = $(this.contentElement(itemIndex)),
		                scrollContainer = contentElement.children(".km-scroll-container");
	
		            return kendo.support.touch && scrollContainer[0] ? scrollContainer : contentElement;
		        },
	
		        ajaxRequest: function (element, content, complete, url) {
		            element = this.tabGroup.find(element);
	
		            var that = this,
		                xhr = $.ajaxSettings.xhr,
		                link = element.find("." + LINK),
		                data = {},
		                halfWidth = element.width() / 2,
		                fakeProgress = false,
		                statusIcon = element.find(".k-loading").removeClass("k-complete");
	
		            if (!statusIcon[0]) {
		                statusIcon = $("<span class='k-loading'/>").prependTo(element);
		            }
	
		            var endState = halfWidth * 2 - statusIcon.width();
	
		            var oldProgressAnimation = function() {
		                statusIcon.animate({ marginLeft: (parseInt(statusIcon.css("marginLeft"), 10) || 0) < halfWidth ? endState : 0 }, 500, oldProgressAnimation);
		            };
	
		            if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
		                setTimeout(oldProgressAnimation, 40);
		            }
	
		             url = url || link.data(CONTENTURL) || that._contentUrls[element.index()] || link.attr(HREF);
		            that.inRequest = true;
	
		            var ajaxOptions = {
		                type: "GET",
		                cache: false,
		                url: url,
		                dataType: "html",
		                data: data,
		                xhr: function() {
		                    var current = this,
		                        request = xhr(),
		                        event = current.progressUpload ? "progressUpload" : current.progress ? "progress" : false;
	
		                    if (request) {
		                        $.each([ request, request.upload ], function () {
		                            if (this.addEventListener) {
		                                this.addEventListener("progress", function(evt) {
		                                    if (event) {
		                                        current[event](evt);
		                                    }
		                                }, false);
		                            }
		                        });
		                    }
	
		                    current.noProgress = !(window.XMLHttpRequest && ('upload' in new XMLHttpRequest()));
		                    return request;
		                },
	
		                progress: function(evt) {
		                    if (evt.lengthComputable) {
		                        var percent = parseInt((evt.loaded / evt.total * 100), 10) + "%";
		                        statusIcon
		                            .stop(true)
		                            .addClass("k-progress")
		                            .css({
		                                "width": percent,
		                                "marginLeft": 0
		                            });
		                    }
		                },
	
		                error: function (xhr, status) {
		                    if (that.trigger("error", { xhr: xhr, status: status })) {
		                        this.complete();
		                    }
		                },
	
		                stopProgress: function () {
		                    clearInterval(fakeProgress);
		                    statusIcon
		                        .stop(true)
		                        .addClass("k-progress")
		                        [0].style.cssText = "";
		                },
	
		                complete: function (xhr) {
		                    that.inRequest = false;
		                    if (this.noProgress) {
		                        setTimeout(this.stopProgress, 500);
		                    } else {
		                        this.stopProgress();
		                    }
	
		                    if (xhr.statusText == "abort") {
		                        statusIcon.remove();
		                    }
		                },
	
		                success: function (data) {
		                    statusIcon.addClass("k-complete");
		                    try {
		                        var current = this,
		                            loaded = 10;
	
		                        if (current.noProgress) {
		                            statusIcon.width(loaded+"%");
		                            fakeProgress = setInterval(function () {
		                                current.progress({ lengthComputable: true, loaded: Math.min(loaded, 100), total: 100 });
		                                loaded += 10;
		                            }, 40);
		                        }
	
		                        that.angular("cleanup", function () { return { elements: content.get() }; });
		                        kendo.destroy(content);
		                        content.html(data);
		                    } catch (e) {
		                        var console = window.console;
	
		                        if (console && console.error) {
		                            console.error(e.name + ": " + e.message + " in " + url);
		                        }
		                        this.error(this.xhr, "error");
		                    }
	
		                    if (complete) {
		                        complete.call(that, content);
		                    }
	
		                    that.angular("compile", function(){ return { elements: content.get() }; });
	
		                    that.trigger(CONTENTLOAD, { item: element[0], contentElement: content[0] });
		                }
		            };
	
		            if (typeof url === "object") {
		                ajaxOptions = $.extend(true, {}, ajaxOptions, url);
	
		                if (isFunction(ajaxOptions.url)) {
		                    ajaxOptions.url = ajaxOptions.url();
		                }
		            }
	
		            that.xhr = $.ajax(ajaxOptions);
		        }
		    });
	
		    // client-side rendering
		    extend(TabStrip, {
		        renderItem: function (options) {
		            options = extend({ tabStrip: {}, group: {} }, options);
	
		            var empty = templates.empty,
		                item = options.item;
	
		            return templates.item(extend(options, {
		                image: item.imageUrl ? templates.image : empty,
		                sprite: item.spriteCssClass ? templates.sprite : empty,
		                itemWrapper: templates.itemWrapper
		            }, rendering));
		        },
	
		        renderContent: function (options) {
		            return templates.content(extend(options, rendering));
		        }
		    });
	
		    kendo.ui.plugin(TabStrip);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1020);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1020:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1021), __webpack_require__(1022), __webpack_require__(1023) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "autocomplete",
		    name: "AutoComplete",
		    category: "web",
		    description: "The AutoComplete widget provides suggestions depending on the typed text.It also allows multiple value entries.",
		    depends: [ "list" ],
		    features: [ {
		        id: "mobile-scroller",
		        name: "Mobile scroller",
		        description: "Support for kinetic scrolling in mobile device",
		        depends: [ "mobile.scroller" ]
		    }, {
		        id: "virtualization",
		        name: "VirtualList",
		        description: "Support for virtualization",
		        depends: [ "virtuallist" ]
		    } ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        support = kendo.support,
		        caret = kendo.caret,
		        activeElement = kendo._activeElement,
		        placeholderSupported = support.placeholder,
		        ui = kendo.ui,
		        List = ui.List,
		        keys = kendo.keys,
		        DataSource = kendo.data.DataSource,
		        ARIA_DISABLED = "aria-disabled",
		        ARIA_READONLY = "aria-readonly",
		        CHANGE = "change",
		        DEFAULT = "k-state-default",
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        FOCUSED = "k-state-focused",
		        SELECTED = "k-state-selected",
		        STATEDISABLED = "k-state-disabled",
		        HOVER = "k-state-hover",
		        ns = ".kendoAutoComplete",
		        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		        proxy = $.proxy;
	
		    function indexOfWordAtCaret(caretIdx, text, separator) {
		        return separator ? text.substring(0, caretIdx).split(separator).length - 1 : 0;
		    }
	
		    function wordAtCaret(caretIdx, text, separator) {
		        return text.split(separator)[indexOfWordAtCaret(caretIdx, text, separator)];
		    }
	
		    function replaceWordAtCaret(caretIdx, text, word, separator, defaultSeparator) {
		        var words = text.split(separator);
	
		        words.splice(indexOfWordAtCaret(caretIdx, text, separator), 1, word);
	
		        if (separator && words[words.length - 1] !== "") {
		            words.push("");
		        }
	
		        return words.join(defaultSeparator);
		    }
	
		    var AutoComplete = List.extend({
		        init: function (element, options) {
		            var that = this, wrapper, disabled;
	
		            that.ns = ns;
		            options = $.isArray(options) ? { dataSource: options} : options;
	
		            List.fn.init.call(that, element, options);
	
		            element = that.element;
		            options = that.options;
	
		            options.placeholder = options.placeholder || element.attr("placeholder");
		            if (placeholderSupported) {
		                element.attr("placeholder", options.placeholder);
		            }
	
		            that._wrapper();
		            that._loader();
		            that._clearButton();
	
		            that._dataSource();
		            that._ignoreCase();
	
		            element[0].type = "text";
		            wrapper = that.wrapper;
	
		            that._popup();
	
		            element
		                .addClass("k-input")
		                .on("keydown" + ns, proxy(that._keydown, that))
		                .on("keypress" + ns, proxy(that._keypress, that))
		                .on("input" + ns, proxy(that._search, that))
		                .on("paste" + ns, proxy(that._search, that))
		                .on("focus" + ns, function () {
		                    that._prev = that._accessor();
		                    that._oldText = that._prev;
		                    that._placeholder(false);
		                    wrapper.addClass(FOCUSED);
		                })
		                .on("focusout" + ns, function () {
		                    that._change();
		                    that._placeholder();
		                    that.close();
		                    wrapper.removeClass(FOCUSED);
		                })
		                .attr({
		                    autocomplete: "off",
		                    role: "textbox",
		                    "aria-haspopup": true
		                });
	
		            that._clear.on("click" + ns + " touchend" + ns, proxy(that._clearValue, that));
		            that._enable();
	
		            that._old = that._accessor();
	
		            if (element[0].id) {
		                element.attr("aria-owns", that.ul[0].id);
		            }
	
		            that._aria();
	
		            that._placeholder();
	
		            that._initList();
	
		            disabled = $(that.element).parents("fieldset").is(':disabled');
	
		            if (disabled) {
		                that.enable(false);
		            }
	
		            that.listView.bind("click", function(e) { e.preventDefault(); });
	
		            that._resetFocusItemHandler = $.proxy(that._resetFocusItem, that);
	
		            kendo.notify(that);
		            that._toggleCloseVisibility();
		        },
	
		        options: {
		            name: "AutoComplete",
		            enabled: true,
		            suggest: false,
		            template: "",
		            groupTemplate: "#:data#",
		            fixedGroupTemplate: "#:data#",
		            dataTextField: "",
		            minLength: 1,
		            enforceMinLength: false,
		            delay: 200,
		            height: 200,
		            filter: "startswith",
		            ignoreCase: true,
		            highlightFirst: false,
		            separator: null,
		            placeholder: "",
		            animation: {},
		            virtual: false,
		            value: null,
		            clearButton: true,
		            autoWidth: false
		        },
	
		        _dataSource: function() {
		            var that = this;
	
		            if (that.dataSource && that._refreshHandler) {
		                that._unbindDataSource();
		            } else {
		                that._progressHandler = proxy(that._showBusy, that);
		                that._errorHandler = proxy(that._hideBusy, that);
		            }
	
		            that.dataSource = DataSource.create(that.options.dataSource)
		                .bind("progress", that._progressHandler)
		                .bind("error", that._errorHandler);
		        },
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
		            this._dataSource();
	
		            this.listView.setDataSource(this.dataSource);
		        },
	
		        events: [
		            "open",
		            "close",
		            CHANGE,
		            "select",
		            "filtering",
		            "dataBinding",
		            "dataBound"
		        ],
	
		        setOptions: function(options) {
		            var listOptions = this._listOptions(options);
	
		            List.fn.setOptions.call(this, options);
	
		            this.listView.setOptions(listOptions);
		            this._accessors();
		            this._aria();
		            this._clearButton();
		        },
	
		        _listOptions: function(options) {
		            var listOptions = List.fn._listOptions.call(this, $.extend(options, {
		                skipUpdateOnBind: true
		            }));
	
		            listOptions.dataValueField = listOptions.dataTextField;
		            listOptions.selectedItemChange = null;
	
		            return listOptions;
		        },
	
		        _editable: function(options) {
		            var that = this,
		                element = that.element,
		                wrapper = that.wrapper.off(ns),
		                readonly = options.readonly,
		                disable = options.disable;
	
		            if (!readonly && !disable) {
		                wrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                element.removeAttr(DISABLED)
		                       .removeAttr(READONLY)
		                       .attr(ARIA_DISABLED, false)
		                       .attr(ARIA_READONLY, false);
		            } else {
		                wrapper
		                    .addClass(disable ? STATEDISABLED : DEFAULT)
		                    .removeClass(disable ? DEFAULT : STATEDISABLED);
	
		                element.attr(DISABLED, disable)
		                       .attr(READONLY, readonly)
		                       .attr(ARIA_DISABLED, disable)
		                       .attr(ARIA_READONLY, readonly);
		            }
		        },
	
		        close: function () {
		            var that = this;
		            var current = that.listView.focus();
	
		            if (current) {
		                current.removeClass(SELECTED);
		            }
	
		            that.popup.close();
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.element.off(ns);
		            that._clear.off(ns);
		            that.wrapper.off(ns);
	
		            List.fn.destroy.call(that);
		        },
	
		        refresh: function() {
		            this.listView.refresh();
		        },
	
		        select: function (li) {
		            this._select(li);
		        },
	
		        search: function (word) {
		            var that = this,
		            options = that.options,
		            ignoreCase = options.ignoreCase,
		            separator = that._separator(),
		            length;
	
		            word = word || that._accessor();
	
		            clearTimeout(that._typingTimeout);
	
		            if (separator) {
		                word = wordAtCaret(caret(that.element)[0], word, separator);
		            }
	
		            length = word.length;
	
		            if ((!options.enforceMinLength && !length) || length >= options.minLength) {
		                that._open = true;
	
		                that._mute(function() {
		                    this.listView.value([]);
		                });
	
		                that._filterSource({
		                    value: ignoreCase ? word.toLowerCase() : word,
		                    operator: options.filter,
		                    field: options.dataTextField,
		                    ignoreCase: ignoreCase
		                });
	
		                that.one("close", $.proxy(that._unifySeparators, that));
		            }
		            that._toggleCloseVisibility();
		        },
	
		        suggest: function (word) {
		            var that = this,
		                key = that._last,
		                value = that._accessor(),
		                element = that.element[0],
		                caretIdx = caret(element)[0],
		                separator = that._separator(),
		                words = value.split(separator),
		                wordIndex = indexOfWordAtCaret(caretIdx, value, separator),
		                selectionEnd = caretIdx,
		                idx;
	
		            if (key == keys.BACKSPACE || key == keys.DELETE) {
		                that._last = undefined;
		                return;
		            }
	
		            word = word || "";
	
		            if (typeof word !== "string") {
		                if (word[0]) {
		                    word = that.dataSource.view()[List.inArray(word[0], that.ul[0])];
		                }
	
		                word = word ? that._text(word) : "";
		            }
	
		            if (caretIdx <= 0) {
		                caretIdx = value.toLowerCase().indexOf(word.toLowerCase()) + 1;
		            }
	
		            idx = value.substring(0, caretIdx).lastIndexOf(separator);
		            idx = idx > -1 ? caretIdx - (idx + separator.length) : caretIdx;
		            value = words[wordIndex].substring(0, idx);
	
		            if (word) {
		                word = word.toString();
		                idx = word.toLowerCase().indexOf(value.toLowerCase());
		                if (idx > -1) {
		                    word = word.substring(idx + value.length);
	
		                    selectionEnd = caretIdx + word.length;
	
		                    value += word;
		                }
	
		                if (separator && words[words.length - 1] !== "") {
		                    words.push("");
		                }
	
		            }
	
		            words[wordIndex] = value;
	
		            that._accessor(words.join(separator || ""));
	
		            if (element === activeElement()) {
		                caret(element, caretIdx, selectionEnd);
		            }
		        },
	
		        value: function (value) {
		            if (value !== undefined) {
		                this.listView.value(value);
	
		                this._accessor(value);
		                this._old = this._accessor();
		                this._oldText = this._accessor();
		            } else {
		                return this._accessor();
		            }
		            this._toggleCloseVisibility();
		        },
	
		        _click: function(e) {
		            var item = e.item;
		            var that = this;
		            var element = that.element;
		            var dataItem = that.listView.dataItemByIndex(that.listView.getElementIndex(item));
	
		            e.preventDefault();
	
		            that._active = true;
	
		            if (that.trigger("select", { dataItem: dataItem, item: item })) {
		                that.close();
		                return;
		            }
		            that._oldText = element.val();
		            that._select(item).done(function() {
		                that._blur();
	
		                caret(element, element.val().length);
		            });
		        },
	
		        _clearText: $.noop,
	
		        _resetFocusItem: function() {
		            var index = this.options.highlightFirst ? 0 : -1;
	
		            if (this.options.virtual) {
		                this.listView.scrollTo(0);
		            }
	
		            this.listView.focus(index);
		        },
	
		        _listBound: function() {
		            var that = this;
		            var popup = that.popup;
		            var options = that.options;
		            var data = that.dataSource.flatView();
		            var length = data.length;
		            var groupsLength = that.dataSource._group.length;
		            var isActive = that.element[0] === activeElement();
		            var action;
	
		            that._renderFooter();
		            that._renderNoData();
		            that._toggleNoData(!length);
		            that._toggleHeader(!!groupsLength && !!length);
	
		            that._resizePopup();
	
		            popup.position();
	
		            if (length) {
		                if (options.suggest && isActive) {
		                    that.suggest(data[0]);
		                }
		            }
	
		            if (that._open) {
		                that._open = false;
		                action = that._allowOpening() ? "open" : "close";
	
		                if (that._typingTimeout && !isActive) {
		                    action = "close";
		                }
	
		                if (length) {
		                    that._resetFocusItem();
	
		                    if (options.virtual) {
		                        that.popup
		                            .unbind("activate", that._resetFocusItemHandler)
		                            .one("activate", that._resetFocusItemHandler);
		                    }
		                }
	
		                popup[action]();
		                that._typingTimeout = undefined;
		            }
	
		            if (that._touchScroller) {
		                that._touchScroller.reset();
		            }
	
		            that._hideBusy();
		            that._makeUnselectable();
	
		            that.trigger("dataBound");
		        },
	
		        _mute: function(callback) {
		            this._muted = true;
		            callback.call(this);
		            this._muted = false;
		        },
	
		        _listChange: function() {
		            var isActive = this._active || this.element[0] === activeElement();
	
		            if (isActive && !this._muted) {
		                this._selectValue(this.listView.selectedDataItems()[0]);
		            }
		        },
	
		        _selectValue: function(dataItem) {
		            var separator = this._separator();
		            var text = "";
	
		            if (dataItem) {
		                text = this._text(dataItem);
		            }
	
		            if (text === null) {
		                text = "";
		            }
	
		            if (separator) {
		                text = replaceWordAtCaret(caret(this.element)[0], this._accessor(), text, separator, this._defaultSeparator());
		            }
	
		            this._prev = text;
		            this._accessor(text);
		            this._placeholder();
		        },
	
		        _unifySeparators: function() {
		            this._accessor(this.value().split(this._separator()).join(this._defaultSeparator()));
		            return this;
		        },
	
		        _preselect: function(value, text) {
		            this._inputValue(text);
		            this._accessor(value);
	
		            this._old = this.oldText =  this._accessor();
	
		            this.listView.setValue(value);
		            this._placeholder();
		        },
	
		        _change: function() {
		            var that = this;
		            var value = that._unifySeparators().value();
		            var trigger = value !== List.unifyType(that._old, typeof value);
	
		            var valueUpdated = trigger && !that._typing;
		            var itemSelected = that._oldText !== value;
	
		            that._old = value;
		            that._oldText = value;
	
		            if (valueUpdated || itemSelected) {
		                // trigger the DOM change event so any subscriber gets notified
		                that.element.trigger(CHANGE);
		            }
	
		            if (trigger) {
		                that.trigger(CHANGE);
		            }
	
		            that.typing = false;
		            that._toggleCloseVisibility();
		        },
	
		        _accessor: function (value) {
		            var that = this,
		                element = that.element[0];
	
		            if (value !== undefined) {
		                element.value = value === null ? "" : value;
		                that._placeholder();
		            } else {
		                value = element.value;
	
		                if (element.className.indexOf("k-readonly") > -1) {
		                    if (value === that.options.placeholder) {
		                        return "";
		                    } else {
		                        return value;
		                    }
		                }
	
		                return value;
		            }
		        },
	
		        _keydown: function (e) {
		            var that = this;
		            var key = e.keyCode;
		            var listView = that.listView;
		            var visible = that.popup.visible();
		            var current = listView.focus();
	
		            that._last = key;
	
		            if (key === keys.DOWN) {
		                if (visible) {
		                    this._move(current ? "focusNext" : "focusFirst");
		                } else if (that.value()) {
		                    that._filterSource({
		                        value: that.ignoreCase ? that.value().toLowerCase() : that.value(),
		                        operator: that.options.filter,
		                        field: that.options.dataTextField,
		                        ignoreCase: that.ignoreCase
		                    }).done(function () {
		                        if (that._allowOpening()) {
		                            that._resetFocusItem();
		                            that.popup.open();
		                        }
		                    });
		                }
		                e.preventDefault();
		            } else if (key === keys.UP) {
		                if (visible) {
		                    this._move(current ? "focusPrev" : "focusLast");
		                }
		                e.preventDefault();
		            } else if (key === keys.HOME) {
		                this._move("focusFirst");
		            } else if (key === keys.END) {
		                this._move("focusLast");
		            } else if (key === keys.ENTER || key === keys.TAB) {
	
		                if (key === keys.ENTER && visible) {
		                    e.preventDefault();
		                }
	
		                if (visible && current) {
		                    var dataItem = listView.dataItemByIndex(listView.getElementIndex(current));
		                    if (that.trigger("select", { dataItem: dataItem, item: current })) {
		                        return;
		                    }
	
		                    this._select(current);
		                }
	
		                this._blur();
		            } else if (key === keys.ESC) {
		                if (visible) {
		                    e.preventDefault();
		                } else {
		                    that._clearValue();
		                }
		                that.close();
		            } else if (that.popup.visible() && (key === keys.PAGEDOWN || key === keys.PAGEUP)) {
		                e.preventDefault();
	
		                var direction = key === keys.PAGEDOWN ? 1 : -1;
		                listView.scrollWith(direction * listView.screenHeight());
		            } else {
		                // In some cases when the popup is opened resize is triggered which will cause it to close
		                // Setting the below flag will prevent this from happening
		                that.popup._hovered = true;
		                that._search();
		            }
		        },
	
		        _keypress: function() {
		            this._oldText = this.element.val();
		            this._typing = true;
		        },
	
		        _move: function (action) {
		            this.listView[action]();
	
		            if (this.options.suggest) {
		                this.suggest(this.listView.focus());
		            }
		        },
	
		        _hideBusy: function () {
		            var that = this;
		            clearTimeout(that._busy);
		            that._loading.hide();
		            that.element.attr("aria-busy", false);
		            that._busy = null;
		            that._showClear();
		        },
	
		        _showBusy: function () {
		            var that = this;
	
		            if (that._busy) {
		                return;
		            }
	
		            that._busy = setTimeout(function () {
		                that.element.attr("aria-busy", true);
		                that._loading.show();
		                that._hideClear();
		            }, 100);
		        },
	
		        _placeholder: function(show) {
		            if (placeholderSupported) {
		                return;
		            }
	
		            var that = this,
		                element = that.element,
		                placeholder = that.options.placeholder,
		                value;
	
		            if (placeholder) {
		                value = element.val();
	
		                if (show === undefined) {
		                    show = !value;
		                }
	
		                if (!show) {
		                    if (value !== placeholder) {
		                        placeholder = value;
		                    } else {
		                        placeholder = "";
		                    }
		                }
	
		                if (value === that._old && !show) {
		                    return;
		                }
	
		                element.toggleClass("k-readonly", show)
		                       .val(placeholder);
	
		                if (!placeholder && element[0] === document.activeElement) {
		                    caret(element[0], 0, 0);
		                }
		            }
		        },
	
		        _separator: function() {
		            var separator = this.options.separator;
		            if (separator instanceof Array) {
		               return new RegExp(separator.join("|"), 'gi');
		            }
		            return separator;
		        },
	
		        _defaultSeparator: function() {
		            var separator = this.options.separator;
		            if (separator instanceof Array) {
		                return separator[0];
		            }
		            return separator;
		        },
	
		        _inputValue: function() {
		            return this.element.val();
		        },
	
		        _search: function () {
		            var that = this;
		            clearTimeout(that._typingTimeout);
	
		            that._typingTimeout = setTimeout(function () {
		                if (that._prev !== that._accessor()) {
		                    that._prev = that._accessor();
		                    that.search();
		                }
		            }, that.options.delay);
		        },
	
		        _select: function(candidate) {
		            var that = this;
		            that._active = true;
	
		            return that.listView.select(candidate).done(function() {
		                that._active = false;
		            });
		        },
	
		        _loader: function() {
		            this._loading = $('<span class="k-icon k-i-loading" style="display:none"></span>').insertAfter(this.element);
		        },
	
		        _clearButton: function() {
		            List.fn._clearButton.call(this);
	
		            if (this.options.clearButton) {
		                this._clear.insertAfter(this.element);
		                this.wrapper.addClass("k-autocomplete-clearable");
		            }
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
		        },
	
		        _toggleCloseVisibility: function() {
		            if (this.value()) {
		                this._showClear();
		            } else {
		                this._hideClear();
		            }
		        },
	
		        _wrapper: function () {
		            var that = this,
		                element = that.element,
		                DOMelement = element[0],
		                wrapper;
	
		            wrapper = element.parent();
	
		            if (!wrapper.is("span.k-widget")) {
		                wrapper = element.wrap("<span />").parent();
		            }
	
		            wrapper.attr("tabindex", -1);
		            wrapper.attr("role", "presentation");
	
		            wrapper[0].style.cssText = DOMelement.style.cssText;
		            element.css({
		                width: "",
		                height: DOMelement.style.height
		            });
	
		            that._focused = that.element;
		            that.wrapper = wrapper
		                .addClass("k-widget k-autocomplete")
		                .addClass(DOMelement.className);
		        }
		    });
	
		    ui.plugin(AutoComplete);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1021:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(562);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1023:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(570);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1190);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1001:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1190:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1001), __webpack_require__(1191), __webpack_require__(1059), __webpack_require__(1192), __webpack_require__(1193), __webpack_require__(1194) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		var __meta__ = { // jshint ignore:line
		    id: "gantt.list",
		    name: "Gantt List",
		    category: "web",
		    description: "The Gantt List",
		    depends: [ "dom", "touch", "draganddrop", "columnsorter", "datetimepicker", "editable" ],
		    hidden: true
		};
	
		(function($) {
		    var kendo = window.kendo;
		    var kendoDom = kendo.dom;
		    var kendoDomElement = kendoDom.element;
		    var kendoTextElement = kendoDom.text;
		    var browser = kendo.support.browser;
		    var mobileOS = kendo.support.mobileOS;
		    var ui = kendo.ui;
		    var Widget = ui.Widget;
		    var extend = $.extend;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
		    var map = $.map;
		    var isFunction = $.isFunction;
		    var oldIE = browser.msie && browser.version < 9;
		    var keys = kendo.keys;
		    var titleFromField = {
		        "title": "Title",
		        "start": "Start Time",
		        "end": "End Time",
		        "percentComplete": "% Done",
		        "parentId": "Predecessor ID",
		        "id": "ID",
		        "orderId": "Order ID"
		    };
		    var STRING = "string";
		    var NS = ".kendoGanttList";
		    var CLICK = "click";
		    var DOT = ".";
		    var SIZE_CALCULATION_TEMPLATE = "<table style='visibility: hidden;'>" +
		        "<tbody>" +
		            "<tr style='height:{0}'>" +
		                "<td>&nbsp;</td>" +
		            "</tr>" +
		        "</tbody>" +
		    "</table>";
	
		    var listStyles = {
		        wrapper: "k-treelist k-grid k-widget",
		        header: "k-header",
		        alt: "k-alt",
		        rtl: "k-rtl",
		        editCell: "k-edit-cell",
		        group: "k-treelist-group",
		        gridHeader: "k-grid-header",
		        gridHeaderWrap: "k-grid-header-wrap",
		        gridContent: "k-grid-content",
		        gridContentWrap: "k-grid-content",
		        selected: "k-state-selected",
		        icon: "k-icon",
		        iconCollapse: "k-i-collapse",
		        iconExpand: "k-i-expand",
		        iconHidden: "k-i-none",
		        iconPlaceHolder: "k-icon k-i-none",
		        input: "k-input",
		        link: "k-link",
		        resizeHandle: "k-resize-handle",
		        resizeHandleInner: "k-resize-handle-inner",
		        dropPositions: "k-i-insert-up k-i-insert-down k-i-plus k-i-insert-middle",
		        dropTop: "k-i-insert-up",
		        dropBottom: "k-i-insert-down",
		        dropAdd: "k-i-plus",
		        dropMiddle: "k-i-insert-middle",
		        dropDenied: "k-i-cancel",
		        dragStatus: "k-drag-status",
		        dragClue: "k-drag-clue",
		        dragClueText: "k-clue-text"
		    };
	
		    function createPlaceholders(options) {
		        var spans = [];
		        var className = options.className;
	
		        for (var i = 0, level = options.level; i < level; i++) {
		            spans.push(kendoDomElement("span", { className: className }));
		        }
	
		        return spans;
		    }
	
		    function blurActiveElement() {
		        var activeElement = kendo._activeElement();
	
		        if (activeElement && activeElement.nodeName.toLowerCase() !== "body") {
		            $(activeElement).blur();
		        }
		    }
	
		    var GanttList = ui.GanttList = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            if (this.options.columns.length === 0) {
		                this.options.columns.push("title");
		            }
	
		            this.dataSource = this.options.dataSource;
	
		            this._columns();
		            this._layout();
		            this._domTrees();
		            this._header();
		            this._sortable();
		            this._editable();
		            this._selectable();
		            this._draggable();
		            this._resizable();
		            this._attachEvents();
		            this._adjustHeight();
	
		            this.bind("render", function() {
		                var headerCols;
		                var tableCols;
	
		                if (this.options.resizable) {
		                    headerCols = this.header.find("col");
		                    tableCols = this.content.find("col");
	
		                    this.header.find("th").not(':last').each(function(index) {
		                        var width = outerWidth($(this));
	
		                        headerCols.eq(index).width(width);
		                        tableCols.eq(index).width(width);
		                    });
	
		                    headerCols.last().css("width", "auto");
		                    tableCols.last().css("width", "auto");
		                }
		            }, true);
		        },
	
		        _adjustHeight: function() {
		            if(this.content){
		                this.content.height(this.element.height() - outerHeight(this.header.parent()));
		            }
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            if (this._reorderDraggable) {
		                this._reorderDraggable.destroy();
		            }
	
		            if (this._tableDropArea) {
		                this._tableDropArea.destroy();
		            }
	
		            if (this._contentDropArea) {
		                this._contentDropArea.destroy();
		            }
	
		            if (this._columnResizable) {
		                this._columnResizable.destroy();
		            }
	
		            if (this.touch) {
		                this.touch.destroy();
		            }
	
		            if (this.timer) {
		                clearTimeout(this.timer);
		            }
	
		            this.content.off(NS);
		            this.header.find("thead").off(NS);
		            this.header.find(DOT + GanttList.link).off(NS);
	
		            this.header = null;
		            this.content = null;
		            this.levels = null;
	
		            kendo.destroy(this.element);
		        },
	
		        options: {
		            name: "GanttList",
		            selectable: true,
		            editable: true,
		            resizable: false
		        },
	
		        _attachEvents: function() {
		            var that = this;
		            var listStyles = GanttList.styles;
	
		            that.content
		                .on(CLICK + NS, "td > span." + listStyles.icon + ":not(." + listStyles.iconHidden + ")", function(e) {
		                    var element = $(this);
		                    var model = that._modelFromElement(element);
	
		                    model.set("expanded", !model.get("expanded"));
	
		                    e.stopPropagation();
		                });
		        },
	
		        _domTrees: function() {
		            this.headerTree = new kendoDom.Tree(this.header[0]);
		            this.contentTree = new kendoDom.Tree(this.content[0]);
		        },
	
		        _columns: function() {
		            var columns = this.options.columns;
		            var model = function() {
		                this.field = "";
		                this.title = "";
		                this.editable = false;
		                this.sortable = false;
		            };
	
		            this.columns = map(columns, function(column) {
		                column = typeof column === STRING ? {
		                    field: column, title: titleFromField[column]
		                } : column;
	
		                return extend(new model(), column);
		            });
		        },
	
		        _layout: function () {
		            var that = this;
		            var options = this.options;
		            var element = this.element;
		            var listStyles = GanttList.styles;
		            var calculateRowHeight = function() {
		                var rowHeight = typeof options.rowHeight === STRING ? options.rowHeight :
		                    options.rowHeight + "px";
		                var table = $(kendo.format(SIZE_CALCULATION_TEMPLATE, rowHeight));
		                var height;
	
		                that.content.append(table);
		                height = outerHeight(table.find("tr"));
		                table.remove();
	
		                return height;
		            };
	
		            element
		                .addClass(listStyles.wrapper)
		                .append("<div class='" + listStyles.gridHeader + "'><div class='" + listStyles.gridHeaderWrap + "'></div></div>")
		                .append("<div class='" + listStyles.gridContentWrap + "'></div>");
	
		            this.header = element.find(DOT + listStyles.gridHeaderWrap);
		            this.content = element.find(DOT + listStyles.gridContent);
	
		            if (options.rowHeight) {
		                this._rowHeight = calculateRowHeight();
		            }
		        },
	
		        _header: function() {
		            var domTree = this.headerTree;
		            var colgroup;
		            var thead;
		            var table;
	
		            colgroup = kendoDomElement("colgroup", null, this._cols());
		            thead = kendoDomElement("thead", { "role": "rowgroup" }, [kendoDomElement("tr", { "role": "row" }, this._ths())]);
		            table = kendoDomElement("table", {
		                "style": { "minWidth": this.options.listWidth + "px" },
		                "role": "grid"
		            }, [colgroup, thead]);
	
		            domTree.render([table]);
		        },
	
		        _render: function(tasks) {
		            var colgroup;
		            var tbody;
		            var table;
		            var tableAttr = {
		                "style": { "minWidth": this.options.listWidth + "px" },
		                "tabIndex": 0,
		                "role": "treegrid"
		            };
	
		            if (this._rowHeight) {
		                tableAttr.style.height = (tasks.length * this._rowHeight) + "px";
		            }
	
		            this.levels = [{ field: null, value: 0 }];
	
		            colgroup = kendoDomElement("colgroup", null, this._cols());
		            tbody = kendoDomElement("tbody", { "role": "rowgroup" }, this._trs(tasks));
		            table = kendoDomElement("table", tableAttr, [colgroup, tbody]);
	
		            this.contentTree.render([table]);
		            this.trigger("render");
		        },
	
		        _ths: function() {
		            var columns = this.columns;
		            var column;
		            var attr;
		            var ths = [];
	
		            for (var i = 0, length = columns.length; i < length; i++) {
		                column = columns[i];
		                attr = {
		                    "data-field": column.field,
		                    "data-title": column.title,
		                    className: GanttList.styles.header,
		                    "role": "columnheader"
		                };
	
		                ths.push(kendoDomElement("th", attr, [kendoTextElement(column.title)]));
		            }
	
		            if (this.options.resizable) {
		                ths.push(kendoDomElement("th", {
		                    className: GanttList.styles.header,
		                    "role": "columnheader"
		                }));
		            }
	
		            return ths;
		        },
	
		        _cols: function() {
		            var columns = this.columns;
		            var column;
		            var style;
		            var width;
		            var cols = [];
	
		            for (var i = 0, length = columns.length; i < length; i++) {
		                column = columns[i];
		                width = column.width;
	
		                if (width && parseInt(width, 10) !== 0) {
		                    style = { style: { width: typeof width === STRING ? width : width + "px" } };
		                } else {
		                    style = null;
		                }
	
		                cols.push(kendoDomElement("col", style, []));
		            }
	
		            if (this.options.resizable) {
		                cols.push(kendoDomElement("col", { style: { width: "1px" }}));
		            }
	
		            return cols;
		        },
	
		        _trs: function(tasks) {
		            var task;
		            var rows = [];
		            var attr;
		            var className = [];
		            var level;
		            var listStyles = GanttList.styles;
	
		            for (var i = 0, length = tasks.length; i < length; i++) {
		                task = tasks[i];
		                level = this._levels({
		                    idx: task.parentId,
		                    id: task.id,
		                    summary: task.summary
		                });
	
		                attr = {
		                    "data-uid": task.uid,
		                    "data-level": level,
		                    "role": "row"
		                };
	
		                if (task.summary) {
		                    attr["aria-expanded"] = task.expanded;
		                }
	
		                if (i % 2 !== 0) {
		                    className.push(listStyles.alt);
		                }
	
		                if (task.summary) {
		                    className.push(listStyles.group);
		                }
	
		                if (className.length) {
		                    attr.className = className.join(" ");
		                }
	
		                rows.push(this._tds({
		                    task: task,
		                    attr: attr,
		                    level: level
		                }));
	
		                className = [];
		            }
	
		            return rows;
		        },
	
		        _tds: function(options) {
		            var children = [];
		            var columns = this.columns;
		            var column;
	
		            for (var i = 0, l = columns.length; i < l; i++) {
		                column = columns[i];
	
		                children.push(this._td({ task: options.task, column: column, level: options.level }));
		            }
	
		            if (this.options.resizable) {
		                children.push(kendoDomElement("td", { "role": "gridcell" }));
		            }
	
		            return kendoDomElement("tr", options.attr, children);
		        },
	
		        _td: function(options) {
		            var children = [];
		            var resourcesField = this.options.resourcesField;
		            var listStyles = GanttList.styles;
		            var task = options.task;
		            var column = options.column;
		            var value = task.get(column.field);
		            var formatedValue;
		            var label;
	
		            if (column.field == resourcesField) {
		                value = value || [];
		                formatedValue = [];
		                for (var i = 0; i < value.length; i++) {
		                    formatedValue.push(kendo.format("{0} [{1}]", value[i].get("name"), value[i].get("formatedValue")));
		                }
		                formatedValue = formatedValue.join(", ");
		            } else {
		                formatedValue = column.format ? kendo.format(column.format, value) : value;
		            }
	
		            if (column.field === "title") {
		                children = createPlaceholders({ level: options.level, className: listStyles.iconPlaceHolder });
		                children.push(kendoDomElement("span", {
		                    className: listStyles.icon + " " + (task.summary ? (task.expanded ? listStyles.iconCollapse : listStyles.iconExpand)
		                        : listStyles.iconHidden)
		                }));
	
		                label = kendo.format("{0}, {1:P0}", formatedValue, task.percentComplete);
		            }
	
		            children.push(kendoDomElement("span", { "aria-label": label }, [kendoTextElement(formatedValue)]));
	
		            return kendoDomElement("td", { "role": "gridcell" }, children);
		        },
	
		        _levels: function(options) {
		            var levels = this.levels;
		            var level;
		            var summary = options.summary;
		            var idx = options.idx;
		            var id = options.id;
	
		            for (var i = 0, length = levels.length; i < length; i++) {
		                level = levels[i];
	
		                if (level.field == idx) {
	
		                    if (summary) {
		                        levels.push({ field: id, value: level.value + 1 });
		                    }
	
		                    return level.value;
		                }
		            }
		        },
	
		        _sortable: function() {
		            var that = this;
		            var resourcesField = this.options.resourcesField;
		            var columns = this.columns;
		            var column;
		            var sortableInstance;
		            var cells = this.header.find("th[" + kendo.attr("field") + "]");
		            var cell;
		            var changeHandler = function(e) {
		                if (that.dataSource.total() === 0 || that.editable && that.editable.trigger('validate')) {
		                    e.preventDefault();
		                }
		            };
	
		            for (var idx = 0, length = cells.length; idx < length; idx++) {
		                column = columns[idx];
	
		                if (column.sortable && column.field !== resourcesField) {
		                    cell = cells.eq(idx);
	
		                    sortableInstance = cell.data("kendoColumnSorter");
	
		                    if (sortableInstance) {
		                        sortableInstance.destroy();
		                    }
	
		                    cell.attr("data-" + kendo.ns + "field", column.field)
		                        .kendoColumnSorter({
		                            dataSource: this.dataSource,
		                            change: changeHandler
		                        });
		                }
		            }
		            cells = null;
		        },
	
		        _selectable: function() {
		            var that = this;
		            var selectable = this.options.selectable;
	
		            if (selectable) {
		                this.content
		                   .on(CLICK + NS, "tr", function(e) {
		                       var element = $(this);
	
		                       if (that.editable) {
		                           that.editable.trigger("validate");
		                       }
	
		                       if (!e.ctrlKey) {
		                           that.select(element);
		                       } else {
		                           that.clearSelection();
		                       }
		                   });
		            }
		        },
	
		        select: function(value) {
		            var element = this.content.find(value);
		            var selectedClassName = GanttList.styles.selected;
	
		            if (element.length) {
		                element
		                    .siblings(DOT + selectedClassName)
		                    .removeClass(selectedClassName)
		                    .attr("aria-selected", false)
		                    .end()
		                    .addClass(selectedClassName)
		                    .attr("aria-selected", true);
	
		                this.trigger("change");
	
		                return;
		            }
	
		            return this.content.find(DOT + selectedClassName);
		        },
	
		        clearSelection: function() {
		            var selected = this.select();
	
		            if (selected.length) {
		                selected.removeClass(GanttList.styles.selected);
	
		                this.trigger("change");
		            }
		        },
	
		        _setDataSource: function(dataSource) {
		            this.dataSource = dataSource;
	
		            // Re-initialize sortable columns
		            this._sortable();
		        },
	
		        _editable: function() {
		            var that = this;
		            var editable = this.options.editable;
		            var listStyles = GanttList.styles;
		            var iconSelector = "span." + listStyles.icon + ":not(" + listStyles.iconHidden +")";
		            var finishEdit = function() {
		                var editable = that.editable;
	
		                if (editable) {
		                    if (editable.end()) {
		                        that._closeCell();
		                    } else {
		                        editable.trigger("validate");
		                    }
		                }
		            };
		            var mousedown = function(e) {
		                var currentTarget = $(e.currentTarget);
	
		                if (!currentTarget.hasClass(listStyles.editCell)) {
		                    blurActiveElement();
		                }
		            };
	
		            if (!editable || editable.update === false) {
		                return;
		            }
	
		            this._startEditHandler = function(e) {
		                var td = e.currentTarget ? $(e.currentTarget) : e;
		                var column = that._columnFromElement(td);
	
		                if (that.editable) {
		                    return;
		                }
	
		                if (column && column.editable) {
		                    that._editCell({ cell: td, column: column });
		                }
		            };
	
		            that.content
		                .on("focusin" + NS, function() {
		                    clearTimeout(that.timer);
		                    that.timer = null;
		                })
		                .on("focusout" + NS, function() {
		                    that.timer = setTimeout(finishEdit, 1);
		                })
		                .on("keydown" + NS, function(e) {
		                    if (e.keyCode === keys.ENTER) {
		                        e.preventDefault();
		                    }
		                })
		                .on("keyup" + NS, function(e) {
		                    var key = e.keyCode;
		                    var cell;
		                    var model;
	
		                    switch (key) {
		                        case keys.ENTER:
		                            blurActiveElement();
		                            finishEdit();
		                            break;
		                        case keys.ESC:
		                            if (that.editable) {
		                                cell = that._editableContainer;
		                                model = that._modelFromElement(cell);
		                                if (!that.trigger("cancel", { model: model, cell: cell })) {
		                                    that._closeCell(true);
		                                }
		                            }
		                            break;
		                    }
		                });
	
		            if (!mobileOS) {
		                that.content
		                    .on("mousedown" + NS, "td", function(e) {
		                        mousedown(e);
		                    })
		                    .on("dblclick" + NS, "td", function(e) {
		                        if (!$(e.target).is(iconSelector)) {
		                            that._startEditHandler(e);
		                        }
		                    });
		            } else {
		                that.touch = that.content
		                    .kendoTouch({
		                        filter: "td",
		                        touchstart: function(e) {
		                            mousedown(e.touch);
		                        },
		                        doubletap: function(e) {
		                            if (!$(e.touch.initialTouch).is(iconSelector)) {
		                                that._startEditHandler(e.touch);
		                            }
		                        }
		                    }).data("kendoTouch");
		            }
		        },
	
		        _editCell: function(options) {
		            var resourcesField = this.options.resourcesField;
		            var listStyles = GanttList.styles;
		            var cell = options.cell;
		            var column = options.column;
		            var model = this._modelFromElement(cell);
		            var modelCopy = this.dataSource._createNewModel(model.toJSON());
		            var field = modelCopy.fields[column.field] || modelCopy[column.field];
		            var validation = field.validation;
		            var DATATYPE = kendo.attr("type");
		            var BINDING = kendo.attr("bind");
		            var FORMAT = kendo.attr("format");
		            var attr = {
		                "name": column.field,
		                "required": field.validation ?
		                    field.validation.required === true : false
		            };
		            var editor;
	
		            if (column.field === resourcesField) {
		                column.editor(cell, modelCopy);
		                return;
		            }
	
		            this._editableContent = cell.children().detach();
		            this._editableContainer = cell;
	
		            cell.data("modelCopy", modelCopy);
	
		            if ((field.type === "date" || $.type(field) === "date") &&
		                (!column.format || /H|m|s|F|g|u/.test(column.format))) {
	
		                attr[BINDING] = "value:" + column.field;
		                attr[DATATYPE] = "date";
	
		                if (column.format) {
		                    attr[FORMAT] = kendo._extractFormat(column.format);
		                }
	
		                editor = function(container, options) {
		                    $('<input type="text"/>').attr(attr)
		                        .appendTo(container).kendoDateTimePicker({ format: options.format });
		                };
		            }
	
		            this.editable = cell
		                .addClass(listStyles.editCell)
		                .kendoEditable({
		                    fields: {
		                        field: column.field,
		                        format: column.format,
		                        editor: column.editor || editor
		                    },
		                    model: modelCopy,
		                    clearContainer: false
		                }).data("kendoEditable");
	
		            if (validation && validation.dateCompare &&
		                isFunction(validation.dateCompare) && validation.message) {
		                $('<span ' + kendo.attr("for") + '="' + column.field + '" class="k-invalid-msg"/>')
		                    .hide()
		                    .appendTo(cell);
	
		                cell.find('[name=' + column.field + ']')
		                    .attr(kendo.attr("dateCompare-msg"), validation.message);
		            }
	
		            this.editable.bind("validate", function(e) {
		                var focusable = this.element.find(":kendoFocusable:first").focus();
	
		                if (oldIE) {
		                    focusable.focus();
		                }
	
		                e.preventDefault();
		            });
	
		            if (this.trigger("edit", { model: model, cell: cell })) {
		                this._closeCell(true);
		            }
		        },
	
		        _closeCell: function(cancelUpdate) {
		            var listStyles = GanttList.styles;
		            var cell = this._editableContainer;
		            var model = this._modelFromElement(cell);
		            var column = this._columnFromElement(cell);
		            var field = column.field;
		            var copy = cell.data("modelCopy");
		            var taskInfo = {};
	
		            taskInfo[field] = copy.get(field);
	
		            cell.empty()
		                .removeData("modelCopy")
		                .removeClass(listStyles.editCell)
		                .append(this._editableContent);
	
		            this.editable.unbind();
		            this.editable.destroy();
		            this.editable = null;
	
		            this._editableContainer = null;
		            this._editableContent = null;
	
		            if (!cancelUpdate) {
		                if (field === "start") {
		                    taskInfo.end = new Date(taskInfo.start.getTime() + model.duration());
		                }
	
		                this.trigger("update", { task: model, updateInfo: taskInfo });
		            }
		        },
	
		        _draggable: function() {
		            var that = this;
		            var draggedTask = null;
		            var dropAllowed = true;
		            var dropTarget;
		            var listStyles = GanttList.styles;
		            var isRtl = kendo.support.isRtl(this.element);
		            var selector = 'tr[' + kendo.attr("level") + ' = 0]:last';
		            var action = {};
		            var editable = this.options.editable;
		            var clear = function() {
		                draggedTask = null;
		                dropTarget = null;
		                dropAllowed = true;
		                action = {};
		            };
		            var allowDrop = function(task) {
		                var parent = task;
	
		                while (parent) {
		                    if (draggedTask.get("id") === parent.get("id")) {
		                        dropAllowed = false;
		                        break;
		                    }
		                    parent = that.dataSource.taskParent(parent);
		                }
		            };
		            var defineLimits = function() {
		                var height = $(dropTarget).height();
		                var offsetTop = kendo.getOffset(dropTarget).top;
	
		                extend(dropTarget, {
		                    beforeLimit: offsetTop + height * 0.25,
		                    afterLimit: offsetTop + height * 0.75
		                });
		            };
		            var defineAction = function(coordinate) {
		                if (!dropTarget) {
		                    return;
		                }
	
		                var location = coordinate.location;
		                var className = listStyles.dropAdd;
		                var command = "add";
		                var level = parseInt(dropTarget.attr(kendo.attr("level")), 10);
		                var sibling;
	
		                if (location <= dropTarget.beforeLimit) {
		                    sibling = dropTarget.prev();
		                    className = listStyles.dropTop;
		                    command = "insert-before";
		                } else if (location >= dropTarget.afterLimit) {
		                    sibling = dropTarget.next();
		                    className = listStyles.dropBottom;
		                    command = "insert-after";
		                }
	
		                if (sibling && parseInt(sibling.attr(kendo.attr("level")), 10) === level) {
		                    className = listStyles.dropMiddle;
		                }
	
		                action.className = className;
		                action.command = command;
		            };
		            var status = function() {
		                return that._reorderDraggable
		                            .hint
		                            .children(DOT + listStyles.dragStatus)
		                            .removeClass(listStyles.dropPositions);
		            };
	
		            if (!editable || editable.reorder === false || editable.update === false) {
		                return;
		            }
	
		            this._reorderDraggable = this.content
		                .kendoDraggable({
		                    distance: 10,
		                    holdToDrag: mobileOS,
		                    group: "listGroup",
		                    filter: "tr[data-uid]",
		                    ignore: DOT + listStyles.input,
		                    hint: function(target) {
		                        return $('<div class="' + listStyles.header + " " + listStyles.dragClue + '"/>')
		                                .css({
		                                    width: 300,
		                                    paddingLeft: target.css("paddingLeft"),
		                                    paddingRight: target.css("paddingRight"),
		                                    lineHeight: target.height() + "px",
		                                    paddingTop: target.css("paddingTop"),
		                                    paddingBottom: target.css("paddingBottom")
		                                })
		                                .append('<span class="' + listStyles.icon + " " + listStyles.dragStatus +'" /><span class="' + listStyles.dragClueText + '"/>');
		                    },
		                    cursorOffset: { top: -20, left: 0 },
		                    container: this.content,
		                    "dragstart": function(e) {
		                        var editable = that.editable;
	
		                        if (editable && editable.reorder !== false && editable.trigger("validate")) {
		                            e.preventDefault();
		                            return;
		                        }
		                        draggedTask = that._modelFromElement(e.currentTarget);
		                        this.hint.children(DOT + listStyles.dragClueText)
		                            .text(draggedTask.get("title"));
	
		                        if (isRtl) {
		                            this.hint.addClass(listStyles.rtl);
		                        }
		                    },
		                    "drag": function(e) {
		                        if (dropAllowed) {
		                            defineAction(e.y);
		                            status().addClass(action.className);
		                        }
		                    },
		                    "dragend": function() {
		                        clear();
		                    },
		                    "dragcancel": function() {
		                        clear();
		                    }
		                }).data("kendoDraggable");
	
		            this._tableDropArea = this.content
		                .kendoDropTargetArea({
		                    distance: 0,
		                    group: "listGroup",
		                    filter: "tr[data-uid]",
		                    "dragenter": function(e) {
		                        dropTarget = e.dropTarget;
		                        allowDrop(that._modelFromElement(dropTarget));
		                        defineLimits();
		                        status().toggleClass(listStyles.dropDenied, !dropAllowed);
		                    },
		                    "dragleave": function() {
		                        dropAllowed = true;
		                        status();
		                    },
		                    "drop": function() {
		                        var target = that._modelFromElement(dropTarget);
		                        var orderId = target.orderId;
		                        var taskInfo = {
		                            parentId: target.parentId
		                        };
	
		                        if (dropAllowed) {
		                            switch (action.command) {
		                                case "add":
		                                    taskInfo.parentId = target.id;
		                                    break;
		                                case "insert-before":
		                                    if (target.parentId === draggedTask.parentId &&
		                                        target.orderId > draggedTask.orderId) {
		                                            taskInfo.orderId = orderId - 1;
		                                    } else {
		                                        taskInfo.orderId = orderId;
		                                    }
		                                    break;
		                                case "insert-after":
		                                    if (target.parentId === draggedTask.parentId &&
		                                        target.orderId > draggedTask.orderId) {
		                                            taskInfo.orderId = orderId;
		                                    } else {
		                                        taskInfo.orderId = orderId + 1;
		                                    }
		                                    break;
		                            }
		                            that.trigger("update", {
		                                task: draggedTask,
		                                updateInfo: taskInfo
		                            });
		                        }
		                    }
		                }).data("kendoDropTargetArea");
	
		            this._contentDropArea = this.element
		               .kendoDropTargetArea({
		                   distance: 0,
		                   group: "listGroup",
		                   filter: DOT + listStyles.gridContent,
		                   "drop": function() {
		                       var target = that._modelFromElement(that.content.find(selector));
		                       var orderId = target.orderId;
		                       var taskInfo = {
		                           parentId: null,
		                           orderId: draggedTask.parentId !== null ?
		                                        orderId + 1 : orderId
		                       };
	
		                        that.trigger("update", {
		                            task: draggedTask,
		                            updateInfo: taskInfo
		                        });
		                   }
		               }).data("kendoDropTargetArea");
		        },
	
		        _resizable: function() {
		            var that = this;
		            var listStyles = GanttList.styles;
		            var positionResizeHandle = function(e) {
		                var th = $(e.currentTarget);
		                var resizeHandle = that.resizeHandle;
		                var position = th.position();
		                var left = position.left;
		                var cellWidth = outerWidth(th);
		                var container = th.closest("div");
		                var clientX = e.clientX + $(window).scrollLeft();
		                var indicatorWidth = that.options.columnResizeHandleWidth;
	
		                left += container.scrollLeft();
	
		                if (!resizeHandle) {
		                    resizeHandle = that.resizeHandle = $(
		                        '<div class="' + listStyles.resizeHandle + '"><div class="' + listStyles.resizeHandleInner + '" /></div>'
		                    );
		                }
	
		                var cellOffset = th.offset().left + cellWidth;
		                var show = clientX > cellOffset - indicatorWidth && clientX < cellOffset + indicatorWidth;
	
		                if (!show) {
		                    resizeHandle.hide();
		                    return;
		                }
	
		                container.append(resizeHandle);
	
		                resizeHandle
		                    .show()
		                    .css({
		                        top: position.top,
		                        left: left + cellWidth - indicatorWidth - 1,
		                        height: outerHeight(th),
		                        width: indicatorWidth * 3
		                    })
		                    .data("th", th);
		            };
	
		            if (!this.options.resizable) {
		                return;
		            }
	
		            if (this._columnResizable) {
		                this._columnResizable.destroy();
		            }
	
		            this.header.find("thead")
		               .on("mousemove" + NS, "th", positionResizeHandle);
	
		            this._columnResizable = this.header.kendoResizable({
		                handle: DOT + listStyles.resizeHandle,
		                start: function(e) {
		                    var th = $(e.currentTarget).data("th");
		                    var colSelector = "col:eq(" + th.index() + ")";
		                    var header = that.header.find("table");
		                    var contentTable = that.content.find("table");
	
		                    that.element.addClass("k-grid-column-resizing");
	
		                    this.col = contentTable.children("colgroup").find(colSelector)
		                          .add(header.find(colSelector));
	
		                    this.th = th;
		                    this.startLocation = e.x.location;
		                    this.columnWidth = outerWidth(th);
		                    this.table = header.add(contentTable);
		                    this.totalWidth = (this.table.width() - outerWidth(header.find("th:last")));
		                },
		                resize: function(e) {
		                    var minColumnWidth = 11;
		                    var delta = e.x.location - this.startLocation;
	
		                    if (this.columnWidth + delta < minColumnWidth) {
		                        delta = minColumnWidth - this.columnWidth;
		                    }
	
		                    this.table.css({
		                        "minWidth": (this.totalWidth + delta)
		                    });
		                    this.col.width(this.columnWidth + delta);
		                },
		                resizeend: function() {
		                    that.element.removeClass("k-grid-column-resizing");
	
		                    var oldWidth = Math.floor(this.columnWidth);
		                    var newWidth = Math.floor(outerWidth(this.th));
		                    var column = that.columns[this.th.index()];
	
		                    that.trigger("columnResize", {
		                        column: column,
		                        oldWidth: oldWidth,
		                        newWidth: newWidth
		                    });
	
		                    this.table = this.col = this.th = null;
		                }
		            }).data("kendoResizable");
		        },
	
		        _modelFromElement: function(element) {
		            var row = element.closest("tr");
		            var model = this.dataSource.getByUid(row.attr(kendo.attr("uid")));
	
		            return model;
		        },
	
		        _columnFromElement: function(element) {
		            var td = element.closest("td");
		            var tr = td.parent();
		            var idx = tr.children().index(td);
	
		            return this.columns[idx];
		        }
		    });
	
		    extend(true, ui.GanttList, { styles: listStyles });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1191:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(604);
	
	/***/ }),
	
	/***/ 1192:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(605);
	
	/***/ }),
	
	/***/ 1193:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(606);
	
	/***/ }),
	
	/***/ 1194:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(599);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1336);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1336:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1038) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "touch",
		    name: "Touch",
		    category: "mobile",
		    description: "The kendo Touch widget provides a cross-platform compatible API for handling user-initiated touch events, multi-touch gestures and event sequences (drag, swipe, etc.). ",
		    depends: [ "core", "userevents" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        proxy = $.proxy,
		        abs = Math.abs,
		        MAX_DOUBLE_TAP_DISTANCE = 20;
	
		    var Touch = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
		            options = that.options;
	
		            element = that.element;
		            that.wrapper = element;
	
		            function eventProxy(name) {
		                return function(e) {
		                    that._triggerTouch(name, e);
		                };
		            }
	
		            function gestureEventProxy(name) {
		                return function(e) {
		                    that.trigger(name, { touches: e.touches, distance: e.distance, center: e.center, event: e.event });
		                };
		            }
	
		            that.events = new kendo.UserEvents(element, {
		                filter: options.filter,
		                surface: options.surface,
		                minHold: options.minHold,
		                multiTouch: options.multiTouch,
		                allowSelection: true,
		                fastTap: options.fastTap,
		                press: eventProxy("touchstart"),
		                hold: eventProxy("hold"),
		                tap: proxy(that, "_tap"),
		                gesturestart: gestureEventProxy("gesturestart"),
		                gesturechange: gestureEventProxy("gesturechange"),
		                gestureend: gestureEventProxy("gestureend")
		            });
	
		            if (options.enableSwipe) {
		                that.events.bind("start", proxy(that, "_swipestart"));
		                that.events.bind("move", proxy(that, "_swipemove"));
		            } else {
		                that.events.bind("start", proxy(that, "_dragstart"));
		                that.events.bind("move", eventProxy("drag"));
		                that.events.bind("end", eventProxy("dragend"));
		            }
	
		            kendo.notify(that);
		        },
	
		        events: [
		            "touchstart",
		            "dragstart",
		            "drag",
		            "dragend",
		            "tap",
		            "doubletap",
		            "hold",
		            "swipe",
		            "gesturestart",
		            "gesturechange",
		            "gestureend"
		        ],
	
		        options: {
		            name: "Touch",
		            surface: null,
		            global: false,
		            fastTap: false,
		            filter: null,
		            multiTouch: false,
		            enableSwipe: false,
		            minXDelta: 30,
		            maxYDelta: 20,
		            maxDuration: 1000,
		            minHold: 800,
		            doubleTapTimeout: 800
		        },
	
		        cancel: function() {
		            this.events.cancel();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this.events.destroy();
		        },
	
		        _triggerTouch: function(type, e) {
		            if (this.trigger(type, { touch: e.touch, event: e.event })) {
		                e.preventDefault();
		            }
		        },
	
		        _tap: function(e) {
		            var that = this,
		                lastTap = that.lastTap,
		                touch = e.touch;
	
		            if (lastTap &&
		                (touch.endTime - lastTap.endTime < that.options.doubleTapTimeout) &&
		                kendo.touchDelta(touch, lastTap).distance < MAX_DOUBLE_TAP_DISTANCE
		                ) {
	
		               that._triggerTouch("doubletap", e);
		               that.lastTap = null;
		            } else {
		                that._triggerTouch("tap", e);
		                that.lastTap = touch;
		            }
		        },
	
		        _dragstart: function(e) {
		            this._triggerTouch("dragstart", e);
		        },
	
		        _swipestart: function(e) {
		            if (abs(e.x.velocity) * 2 >= abs(e.y.velocity)) {
		                e.sender.capture();
		            }
		        },
	
		        _swipemove: function(e) {
		            var that = this,
		                options = that.options,
		                touch = e.touch,
		                duration = e.event.timeStamp - touch.startTime,
		                direction = touch.x.initialDelta > 0 ? "right" : "left";
	
		            if (
		                abs(touch.x.initialDelta) >= options.minXDelta &&
		                abs(touch.y.initialDelta) < options.maxYDelta &&
		                duration < options.maxDuration
		                )
		            {
		                that.trigger("swipe", {
		                    direction: direction,
		                    touch: e.touch
		                });
	
		                touch.cancel();
		            }
		        }
		    });
	
		    kendo.ui.plugin(Touch);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1043);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1043:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "columnsorter",
		    name: "Column Sorter",
		    category: "framework",
		    depends: ["core"],
		    advanced: true
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo;
		    var ui = kendo.ui;
		    var Widget = ui.Widget;
		    var DIR = "dir";
		    var ASC = "asc";
		    var SINGLE = "single";
		    var FIELD = "field";
		    var DESC = "desc";
		    var sorterNS = ".kendoColumnSorter";
		    var TLINK = ".k-link";
		    var ARIASORT = "aria-sort";
		    var proxy = $.proxy;
	
		    var ColumnSorter = Widget.extend({
		        init: function (element, options) {
	
		            var that = this, link;
	
		            Widget.fn.init.call(that, element, options);
	
		            that._refreshHandler = proxy(that.refresh, that);
	
		            that.dataSource = that.options.dataSource.bind("change", that._refreshHandler);
	
		            that.directions = that.options.initialDirection === ASC ? [ASC, DESC] : [DESC, ASC];
	
		            link = that.element.find(TLINK);
	
		            if (!link[0]) {
		                link = that.element.wrapInner('<a class="k-link" href="#"/>').find(TLINK);
		            }
	
		            that.link = link;
	
		            that.element.on("click" + sorterNS, proxy(that._click, that));
		        },
	
		        options: {
		            name: "ColumnSorter",
		            mode: SINGLE,
		            allowUnsort: true,
		            compare: null,
		            filter: "",
		            initialDirection: ASC,
		            showIndexes: false
		        },
	
		        events: ["change"],
	
		        destroy: function () {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.element.off(sorterNS);
	
		            that.dataSource.unbind("change", that._refreshHandler);
		            that._refreshHandler = that.element = that.link = that.dataSource = null;
		        },
	
		        refresh: function () {
		            var that = this,
		                sort = that.dataSource.sort() || [],
		                idx,
		                length,
		                descriptor,
		                dir,
		                element = that.element,
		                field = element.attr(kendo.attr(FIELD)),
		                headerIndex,
		                sortOrder,
		                leafCells;
	
		            element.removeAttr(kendo.attr(DIR));
		            element.removeAttr(ARIASORT);
		            for (idx = 0, length = sort.length; idx < length; idx++) {
		                descriptor = sort[idx];
	
		                if (field == descriptor.field) {
		                    element.attr(kendo.attr(DIR), descriptor.dir);
		                    sortOrder = idx + 1;
		                }
		            }
	
		            dir = element.attr(kendo.attr(DIR));
		            if (element.is("th")) {
		                var table = element.closest("table");
		                if (table.parent().hasClass("k-grid-header-wrap")) {
		                    table = table.closest(".k-grid").find(".k-grid-content > table");
		                } else if (table.parent().hasClass("k-grid-header-locked")) {
		                    table = table.closest(".k-grid").find(".k-grid-content-locked > table");
		                } else if (!table.parent().hasClass("k-grid")) {
		                    table = null;
		                }
	
		                if (table) {
		                    if (element.attr(kendo.attr("index"))) {
		                        leafCells = leafDataCells(element.closest("table"));
		                        headerIndex = leafCells.index(element);
		                    } else {
		                        headerIndex = element.parent().children(":visible").index(element);
		                    }
	
		                    element.toggleClass("k-sorted", dir !== undefined);
		                    table.children("colgroup").children().eq(headerIndex).toggleClass("k-sorted", dir !== undefined);
		                }
		            }
		            element.find(".k-i-sort-asc-sm,.k-i-sort-desc-sm,.k-sort-order").remove();
	
		            if (dir === ASC) {
		                $('<span class="k-icon k-i-sort-asc-sm" />').appendTo(that.link);
		                element.attr(ARIASORT, "ascending");
		            } else if (dir === DESC) {
		                $('<span class="k-icon k-i-sort-desc-sm" />').appendTo(that.link);
		                element.attr(ARIASORT, "descending");
		            }
		            if (that.options.showIndexes && sort.length > 1 && sortOrder) {
		                $('<span class="k-sort-order" />').html(sortOrder).appendTo(that.link);
		            }
		        },
	
		        _toggleSortDirection: function(dir) {
		            var directions = this.directions;
		            if (dir === directions[directions.length - 1] && this.options.allowUnsort) {
		                return undefined;
		            }
		            return directions[0] === dir ? directions[1] : directions[0];
		        },
	
		        _click: function (e) {
		            var that = this,
		                element = that.element,
		                field = element.attr(kendo.attr(FIELD)),
		                dir = element.attr(kendo.attr(DIR)),
		                options = that.options,
		                compare = that.options.compare === null ? undefined : that.options.compare,
		                sort = that.dataSource.sort() || [],
		                idx,
		                length;
	
		            e.preventDefault();
	
		            if (options.filter && !element.is(options.filter)) {
		                return;
		            }
	
		            dir = this._toggleSortDirection(dir);
	
		            if (this.trigger("change", { sort: { field: field, dir: dir, compare: compare } })) {
		                return;
		            }
	
		            if (options.mode === SINGLE) {
		                sort = [{ field: field, dir: dir, compare: compare }];
		            } else if (options.mode === "multiple") {
		                for (idx = 0, length = sort.length; idx < length; idx++) {
		                    if (sort[idx].field === field) {
		                        sort.splice(idx, 1);
		                        break;
		                    }
		                }
		                sort.push({ field: field, dir: dir, compare: compare });
		            }
	
		            if (this.dataSource.options.endless) {
		                this.dataSource.options.endless = null;
		                element.closest(".k-grid").getKendoGrid()._endlessPageSize = that.dataSource.options.pageSize;
		                this.dataSource.pageSize(that.dataSource.options.pageSize);
		            }
		            this.dataSource.sort(sort);
		        }
		    });
	
		    function leafDataCells(container) {
		        var rows = container.find("tr:not(.k-filter-row)");
	
		        var filter = function() {
		            var el = $(this);
		            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
		        };
	
		        var cells = $();
		        if (rows.length > 1) {
		            cells = rows.find("th:visible")
		                .filter(filter)
		                .filter(function() { return this.rowSpan > 1; });
		        }
	
		        cells = cells.add(rows.last().find("th:visible").filter(filter));
	
		        var indexAttr = kendo.attr("index");
		        cells.sort(function(a, b) {
		            a = $(a);
		            b = $(b);
	
		            var indexA = a.attr(indexAttr);
		            var indexB = b.attr(indexAttr);
	
		            if (indexA === undefined) {
		                indexA = $(a).index();
		            }
		            if (indexB === undefined) {
		                indexB = $(b).index();
		            }
	
		            indexA = parseInt(indexA, 10);
		            indexB = parseInt(indexB, 10);
		            return indexA > indexB ? 1 : (indexA < indexB ? -1 : 0);
		        });
	
		        return cells;
		    }
	
		    ui.plugin(ColumnSorter);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1118);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1118:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1119), __webpack_require__(1120) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "datetimepicker",
		    name: "DateTimePicker",
		    category: "web",
		    description: "The DateTimePicker allows the end user to select a value from a calendar or a time drop-down list.",
		    depends: [ "datepicker", "timepicker" ]
		};
	
		(function($, undefined) {
	
		    var kendo = window.kendo,
		        TimeView = kendo.TimeView,
		        parse = kendo.parseDate,
		        support = kendo.support,
		        activeElement = kendo._activeElement,
		        extractFormat = kendo._extractFormat,
		        calendar = kendo.calendar,
		        isInRange = calendar.isInRange,
		        restrictValue = calendar.restrictValue,
		        isEqualDatePart = calendar.isEqualDatePart,
		        getMilliseconds = TimeView.getMilliseconds,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        OPEN = "open",
		        CLOSE = "close",
		        CHANGE = "change",
		        ns = ".kendoDateTimePicker",
		        CLICK = "click" + ns,
		        UP = support.mouseAndTouchPresent ? kendo.applyEventMap("up", ns.slice(1)) : CLICK,
		        DISABLED = "disabled",
		        READONLY = "readonly",
		        DEFAULT = "k-state-default",
		        FOCUSED = "k-state-focused",
		        HOVER = "k-state-hover",
		        STATEDISABLED = "k-state-disabled",
		        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		        MOUSEDOWN = "mousedown" + ns,
		        MONTH = "month",
		        SPAN = "<span/>",
		        ARIA_ACTIVEDESCENDANT = "aria-activedescendant",
		        ARIA_EXPANDED = "aria-expanded",
		        ARIA_HIDDEN = "aria-hidden",
		        ARIA_OWNS = "aria-owns",
		        ARIA_DISABLED = "aria-disabled",
		        DATE = Date,
		        MIN = new DATE(1800, 0, 1),
		        MAX = new DATE(2099, 11, 31),
		        dateViewParams = { view: "date" },
		        timeViewParams = { view: "time" },
		        extend = $.extend;
	
		    var DateTimePicker = Widget.extend({
		        init: function(element, options) {
		            var that = this, disabled;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element;
		            options = that.options;
	
		            options.disableDates = kendo.calendar.disabled(options.disableDates);
		            options.min = parse(element.attr("min")) || parse(options.min);
		            options.max = parse(element.attr("max")) || parse(options.max);
	
		            normalize(options);
	
		            that._initialOptions = extend({}, options);
	
		            that._wrapper();
	
		            that._views();
	
		            that._icons();
	
		            that._reset();
		            that._template();
	
		            try {
		                element[0].setAttribute("type", "text");
		            } catch(e) {
		                element[0].type = "text";
		            }
	
		            element.addClass("k-input")
		                   .attr({
		                       "role": "combobox",
		                       "aria-expanded": false,
		                       "autocomplete": "off"
		                   });
	
	
		            that._midnight = that._calculateMidnight(options.min, options.max);
	
		            disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
		            if (disabled) {
		                that.enable(false);
		            } else {
		                that.readonly(element.is("[readonly]"));
		            }
	
		            that._createDateInput(options);
	
		            that._old = that._update(options.value || that.element.val());
		            that._oldText = element.val();
	
		            kendo.notify(that);
		        },
	
		        options: {
		            name: "DateTimePicker",
		            value: null,
		            format: "",
		            timeFormat: "",
		            culture: "",
		            parseFormats: [],
		            dates: [],
		            disableDates: null,
		            min: new DATE(MIN),
		            max: new DATE(MAX),
		            interval: 30,
		            height: 200,
		            footer: "",
		            start: MONTH,
		            depth: MONTH,
		            animation: {},
		            month : {},
		            ARIATemplate: 'Current focused date is #=kendo.toString(data.current, "d")#',
		            dateButtonText: "Open the date view",
		            timeButtonText: "Open the time view",
		            dateInput: false,
		            weekNumber: false
		        },
	
		        events: [
		            OPEN,
		            CLOSE,
		            CHANGE
		        ],
	
		        setOptions: function(options) {
		            var that = this,
		                value = that._value,
		                min, max, currentValue;
	
		            Widget.fn.setOptions.call(that, options);
	
		            options = that.options;
	
		            options.min = min = parse(options.min);
		            options.max = max = parse(options.max);
	
		            normalize(options);
	
		            that._midnight = that._calculateMidnight(options.min, options.max);
	
		            currentValue = options.value || that._value || that.dateView._current;
	
		            if (min && !isEqualDatePart(min, currentValue)) {
		                min = new DATE(MIN);
		            }
	
		            if (max && !isEqualDatePart(max, currentValue)) {
		                max = new DATE(MAX);
		            }
	
		            that.dateView.setOptions(options);
	
		            that.timeView.setOptions(extend({}, options, {
		                format: options.timeFormat,
		                min: min,
		                max: max
		            }));
	
		            that._createDateInput(options);
	
		            if (!that._dateInput) {
		                that.element.val(kendo.toString(value, options.format, options.culture));
		            }
	
		            if (value) {
		                that._updateARIA(value);
		            }
		        },
	
		        _editable: function(options) {
		            var that = this,
		                element = that.element.off(ns),
		                dateIcon = that._dateIcon.off(ns),
		                timeIcon = that._timeIcon.off(ns),
		                wrapper = that._inputWrapper.off(ns),
		                readonly = options.readonly,
		                disable = options.disable;
	
		            if (!readonly && !disable) {
		                wrapper
		                    .addClass(DEFAULT)
		                    .removeClass(STATEDISABLED)
		                    .on(HOVEREVENTS, that._toggleHover);
	
		                element.removeAttr(DISABLED)
		                       .removeAttr(READONLY)
		                       .attr(ARIA_DISABLED, false)
		                       .on("keydown" + ns, $.proxy(that._keydown, that))
		                       .on("focus" + ns, function() {
		                           that._inputWrapper.addClass(FOCUSED);
		                       })
		                       .on("focusout" + ns, function() {
		                           that._inputWrapper.removeClass(FOCUSED);
		                           if (element.val() !== that._oldText) {
		                               that._change(element.val());
		                           }
		                           that.close("date");
		                           that.close("time");
		                       });
	
		               dateIcon.on(MOUSEDOWN, preventDefault)
		                        .on(UP, function(e) {
		                            that.toggle("date");
		                            that._focusElement(e.type);
		                        });
	
		               timeIcon.on(MOUSEDOWN, preventDefault)
		                        .on(UP, function(e) {
		                            that.toggle("time");
		                            that._focusElement(e.type);
		                        });
	
		            } else {
		                wrapper
		                    .addClass(disable ? STATEDISABLED : DEFAULT)
		                    .removeClass(disable ? DEFAULT : STATEDISABLED);
	
		                element.attr(DISABLED, disable)
		                       .attr(READONLY, readonly)
		                       .attr(ARIA_DISABLED, disable);
		            }
		        },
	
		        _focusElement: function(eventType) {
		            var element = this.element;
	
		            if ((!support.touch || (support.mouseAndTouchPresent && !(eventType || "").match(/touch/i))) && element[0] !== activeElement()) {
		                element.focus();
		            }
		        },
	
		        readonly: function(readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		        },
	
		        enable: function(enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
		            that.dateView.destroy();
		            that.timeView.destroy();
	
		            that.element.off(ns);
		            that._dateIcon.off(ns);
		            that._timeIcon.off(ns);
		            that._inputWrapper.off(ns);
	
		            if (that._form) {
		                that._form.off("reset", that._resetHandler);
		            }
		        },
	
		        close: function(view) {
		            if (view !== "time") {
		                view = "date";
		            }
	
		            this[view + "View"].close();
		        },
	
		        open: function(view) {
		            if (view !== "time") {
		                view = "date";
		            }
	
		            this[view + "View"].open();
		        },
	
		        min: function(value) {
		            return this._option("min", value);
		        },
	
		        max: function(value) {
		            return this._option("max", value);
		        },
	
		        toggle: function(view) {
		            var secondView = "timeView";
	
		            if (view !== "time") {
		                view = "date";
		            } else {
		                secondView = "dateView";
		            }
	
		            this[view + "View"].toggle();
		            this[secondView].close();
		        },
	
		        value: function(value) {
		            var that = this;
	
		            if (value === undefined) {
		                return that._value;
		            }
	
		            that._old = that._update(value);
		            if (that._old === null) {
		                that.element.val("");
		            }
	
		            that._oldText = that.element.val();
		        },
	
		        _change: function(value) {
		            var that = this,
		            oldValue = that.element.val(),
		            dateChanged;
	
		            value = that._update(value);
		            dateChanged = +that._old != +value;
	
		            var valueUpdated = dateChanged && !that._typing;
		            var textFormatted = oldValue !== that.element.val();
	
		            if (valueUpdated || textFormatted) {
		                that.element.trigger(CHANGE);
		            }
	
		            if (dateChanged) {
		                that._old = value;
		                that._oldText = that.element.val();
	
		                that.trigger(CHANGE);
		            }
	
		            that._typing = false;
		        },
	
		        _option: function(option, value) {
		            var that = this;
		            var options = that.options;
		            var timeView = that.timeView;
		            var timeViewOptions = timeView.options;
		            var current = that._value || that._old;
		            var minDateEqual;
		            var maxDateEqual;
	
		            if (value === undefined) {
		                return options[option];
		            }
	
		            value = parse(value, options.parseFormats, options.culture);
	
		            if (!value) {
		                return;
		            }
	
		            if (options.min.getTime() === options.max.getTime()) {
		                timeViewOptions.dates = [];
		            }
	
		            options[option] = new DATE(value.getTime());
		            that.dateView[option](value);
	
		            that._midnight = that._calculateMidnight(options.min, options.max);
	
		            if (current) {
		                minDateEqual = isEqualDatePart(options.min, current);
		                maxDateEqual = isEqualDatePart(options.max, current);
		            }
	
		            if (minDateEqual || maxDateEqual) {
		                timeViewOptions[option] = value;
	
		                if (minDateEqual && !maxDateEqual) {
		                    timeViewOptions.max = lastTimeOption(options.interval);
		                }
	
		                if (maxDateEqual) {
		                    if (that._midnight) {
		                        timeView.dataBind([MAX]);
		                        return;
		                    } else if (!minDateEqual) {
		                        timeViewOptions.min = MIN;
		                    }
		                }
		            } else {
		                timeViewOptions.max = MAX;
		                timeViewOptions.min = MIN;
		            }
	
		            timeView.bind();
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
		        },
	
		        _update: function(value) {
		            var that = this,
		                options = that.options,
		                min = options.min,
		                max = options.max,
		                dates = options.dates,
		                timeView = that.timeView,
		                current = that._value,
		                date = parse(value, options.parseFormats, options.culture),
		                isSameType = (date === null && current === null) || (date instanceof Date && current instanceof Date),
		                rebind, timeViewOptions, old, skip, formattedValue;
	
		            if (options.disableDates && options.disableDates(date)) {
		                date = null;
		                if (!that._old && !that.element.val()) {
		                    value = null;
		                }
		            }
	
		            if (+date === +current && isSameType) {
		                formattedValue = kendo.toString(date, options.format, options.culture);
	
		                if (formattedValue !== value ) {
		                    that.element.val(date === null ? value : formattedValue);
		                    if (value instanceof String) {
		                        that.element.trigger(CHANGE);
		                    }
		                }
	
		                return date;
		            }
	
		            if (date !== null && isEqualDatePart(date, min)) {
		                date = restrictValue(date, min, max);
		            } else if (!isInRange(date, min, max)) {
		                date = null;
		            }
	
		            that._value = date;
		            timeView.value(date);
		            that.dateView.value(date);
	
		            if (date) {
		                old = that._old;
		                timeViewOptions = timeView.options;
	
		                if (dates[0]) {
		                    dates = $.grep(dates, function(d) { return isEqualDatePart(date, d); });
	
		                    if (dates[0]) {
		                        timeView.dataBind(dates);
		                        skip = true;
		                    }
		                }
	
		                if (!skip) {
		                    if (isEqualDatePart(date, min)) {
		                        timeViewOptions.min = min;
		                        timeViewOptions.max = lastTimeOption(options.interval);
		                        rebind = true;
		                    }
	
		                    if (isEqualDatePart(date, max)) {
		                        if (that._midnight) {
		                            timeView.dataBind([MAX]);
		                            skip = true;
		                        } else {
		                            timeViewOptions.max = max;
		                            if (!rebind) {
		                                timeViewOptions.min = MIN;
		                            }
		                            rebind = true;
		                        }
		                    }
		                }
	
		                if (!skip && ((!old && rebind) || (old && !isEqualDatePart(old, date)))) {
		                    if (!rebind) {
		                        timeViewOptions.max = MAX;
		                        timeViewOptions.min = MIN;
		                    }
	
		                    timeView.bind();
		                }
		            }
		            if (that._dateInput && date) {
		                that._dateInput.value(date || value);
		            } else {
		                that.element.val(kendo.toString(date || value, options.format, options.culture));
		            }
		            that._updateARIA(date);
	
		            return date;
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                dateView = that.dateView,
		                timeView = that.timeView,
		                value = that.element.val(),
		                isDateViewVisible = dateView.popup.visible();
		            var stopPropagation = that._dateInput && e.stopImmediatePropagation;
		            if (e.altKey && e.keyCode === kendo.keys.DOWN) {
		                that.toggle(isDateViewVisible ? "time" : "date");
		            } else if (isDateViewVisible) {
		                dateView.move(e);
		                that._updateARIA(dateView._current);
		            } else if (timeView.popup.visible()) {
		                timeView.move(e);
		            } else if (e.keyCode === kendo.keys.ENTER && value !== that._oldText) {
		                that._change(value);
		            } else {
		                that._typing = true;
		                stopPropagation = false;
		            }
		            if (stopPropagation) {
		                e.stopImmediatePropagation();
		            }
		        },
	
		        _views: function() {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                id = element.attr("id"),
		                dateView, timeView,
		                div, ul, msMin,
		                date;
	
		            that.dateView = dateView = new kendo.DateView(extend({}, options, {
		                id: id,
		                anchor: that.wrapper,
		                change: function() {
		                    var value = dateView.calendar.value(),
		                        msValue = +value,
		                        msMin = +options.min,
		                        msMax = +options.max,
		                        current, adjustedDate;
	
		                    if (msValue === msMin || msValue === msMax) {
		                        current = msValue === msMin ? msMin : msMax;
		                        current = new DATE(that._value || current);
		                        current.setFullYear(value.getFullYear(), value.getMonth(), value.getDate());
	
		                        if (isInRange(current, msMin, msMax)) {
		                            value = current;
		                        }
		                    }
	
		                    if (that._value) {
	
		                       adjustedDate = kendo.date.setHours(new Date(value), that._value);
	
		                       if (isInRange(adjustedDate, msMin, msMax)) {
		                           value = adjustedDate;
		                       }
		                    }
	
		                    that._change(value);
		                    that.close("date");
		                },
		                close: function(e) {
		                    if (that.trigger(CLOSE, dateViewParams)) {
		                        e.preventDefault();
		                    } else {
		                        element.attr(ARIA_EXPANDED, false);
		                        div.attr(ARIA_HIDDEN, true);
	
		                        if (!timeView.popup.visible()) {
		                            element.removeAttr(ARIA_OWNS);
		                        }
		                    }
		                },
		                open:  function(e) {
		                    if (that.trigger(OPEN, dateViewParams)) {
		                        e.preventDefault();
		                    } else {
	
		                        if (element.val() !== that._oldText) {
		                            date = parse(element.val(), options.parseFormats, options.culture);
	
		                            that.dateView[date ? "current" : "value"](date);
		                        }
	
		                        div.attr(ARIA_HIDDEN, false);
		                        element.attr(ARIA_EXPANDED, true)
		                               .attr(ARIA_OWNS, dateView._dateViewID);
	
		                        that._updateARIA(date);
		                    }
		                }
		            }));
		            div = dateView.div;
	
		            msMin = options.min.getTime();
		            that.timeView = timeView = new TimeView({
		                id: id,
		                value: options.value,
		                anchor: that.wrapper,
		                animation: options.animation,
		                format: options.timeFormat,
		                culture: options.culture,
		                height: options.height,
		                interval: options.interval,
		                min: new DATE(MIN),
		                max: new DATE(MAX),
		                dates: msMin === options.max.getTime() ? [new Date(msMin)] : [],
		                parseFormats: options.parseFormats,
		                change: function(value, trigger) {
		                    value = timeView._parse(value);
	
		                    if (value < options.min) {
		                        value = new DATE(+options.min);
		                        timeView.options.min = value;
		                    } else if (value > options.max) {
		                        value = new DATE(+options.max);
		                        timeView.options.max = value;
		                    }
	
		                    if (trigger) {
		                        that._timeSelected = true;
		                        that._change(value);
		                    } else {
		                        element.val(kendo.toString(value, options.format, options.culture));
		                        dateView.value(value);
		                        that._updateARIA(value);
		                    }
		                },
		                close: function(e) {
		                    if (that.trigger(CLOSE, timeViewParams)) {
		                        e.preventDefault();
		                    } else {
		                        ul.attr(ARIA_HIDDEN, true);
		                        element.attr(ARIA_EXPANDED, false);
	
		                        if (!dateView.popup.visible()) {
		                            element.removeAttr(ARIA_OWNS);
		                        }
		                    }
		                },
		                open:  function(e) {
		                    timeView._adjustListWidth();
		                    if (that.trigger(OPEN, timeViewParams)) {
		                        e.preventDefault();
		                    } else {
		                        if (element.val() !== that._oldText) {
		                            date = parse(element.val(), options.parseFormats, options.culture);
	
		                            that.timeView.value(date);
		                        }
	
		                        ul.attr(ARIA_HIDDEN, false);
		                        element.attr(ARIA_EXPANDED, true)
		                               .attr(ARIA_OWNS, timeView._timeViewID);
	
		                        timeView.options.active(timeView.current());
		                    }
		                },
		                active: function(current) {
		                    element.removeAttr(ARIA_ACTIVEDESCENDANT);
		                    if (current) {
		                        element.attr(ARIA_ACTIVEDESCENDANT, timeView._optionID);
		                    }
		                }
		            });
		            ul = timeView.ul;
		        },
	
		        _icons: function() {
		            var that = this;
		            var element = that.element;
		            var options = that.options;
		            var icons;
	
		            icons = element.next("span.k-select");
	
		            if (!icons[0]) {
		                icons = $('<span unselectable="on" class="k-select">' +
		                            '<span class="k-link k-link-date" aria-label="' + options.dateButtonText + '"><span unselectable="on" class="k-icon k-i-calendar"></span></span>' +
		                            '<span class="k-link k-link-time" aria-label="' + options.timeButtonText + '"><span unselectable="on" class="k-icon k-i-clock"></span></span>' +
		                          '</span>'
		                         ).insertAfter(element);
		            }
	
		            icons = icons.children();
	
		            that._dateIcon = icons.eq(0).attr("aria-controls", that.dateView._dateViewID);
		            that._timeIcon = icons.eq(1).attr("aria-controls", that.timeView._timeViewID);
		        },
	
		        _wrapper: function() {
		            var that = this,
		            element = that.element,
		            wrapper;
	
		            wrapper = element.parents(".k-datetimepicker");
	
		            if (!wrapper[0]) {
		                wrapper = element.wrap(SPAN).parent().addClass("k-picker-wrap k-state-default");
		                wrapper = wrapper.wrap(SPAN).parent();
		            }
	
		            wrapper[0].style.cssText = element[0].style.cssText;
		            element.css({
		                width: "100%",
		                height: element[0].style.height
		            });
	
		            that.wrapper = wrapper.addClass("k-widget k-datetimepicker")
		                .addClass(element[0].className);
	
		            that._inputWrapper = $(wrapper[0].firstChild);
		        },
	
		        _reset: function() {
		            var that = this,
		                element = that.element,
		                formId = element.attr("form"),
		                form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    that.value(element[0].defaultValue);
		                    that.max(that._initialOptions.max);
		                    that.min(that._initialOptions.min);
		                };
	
		                that._form = form.on("reset", that._resetHandler);
		            }
		        },
	
		        _template: function() {
		            this._ariaTemplate = kendo.template(this.options.ARIATemplate);
		        },
	
		        _createDateInput: function(options) {
		            if (this._dateInput) {
		                this._dateInput.destroy();
		                this._dateInput = null;
		            }
	
		            if (options.dateInput ) {
		                this._dateInput = new ui.DateInput(this.element, {
		                    culture: options.culture,
		                    format: options.format,
		                    min: options.min,
		                    max: options.max
		                });
		            }
		        },
	
		        _calculateMidnight: function(min, max) {
		            return getMilliseconds(min) + getMilliseconds(max) === 0;
		        },
	
		        _updateARIA: function(date) {
		            var cell;
		            var that = this;
		            var calendar = that.dateView.calendar;
	
		            that.element.removeAttr(ARIA_ACTIVEDESCENDANT);
	
		            if (calendar) {
		                cell = calendar._cell;
		                cell.attr("aria-label", that._ariaTemplate({ current: date || calendar.current() }));
	
		                that.element.attr(ARIA_ACTIVEDESCENDANT, cell.attr("id"));
		            }
		        }
		    });
	
		    function lastTimeOption(interval) {
		        var date = new Date(2100, 0, 1);
		        date.setMinutes(-interval);
		        return date;
		    }
	
		    function preventDefault(e) {
		        e.preventDefault();
		    }
	
		    function normalize(options) {
		        var patterns = kendo.getCulture(options.culture).calendars.standard.patterns,
		            parseFormats = !options.parseFormats.length,
		            timeFormat;
	
		        options.format = extractFormat(options.format || patterns.g);
		        options.timeFormat = timeFormat = extractFormat(options.timeFormat || patterns.t);
		        kendo.DateView.normalize(options);
	
		        if (parseFormats) {
		           options.parseFormats.unshift("yyyy-MM-ddTHH:mm:ss");
		        }
	
		        if ($.inArray(timeFormat, options.parseFormats) === -1) {
		            options.parseFormats.push(timeFormat);
		        }
		    }
	
		    ui.plugin(DateTimePicker);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1119:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(590);
	
	/***/ }),
	
	/***/ 1120:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(591);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1195);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1001:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1191:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(604);
	
	/***/ }),
	
	/***/ 1195:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1001), __webpack_require__(1191), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "gantt.timeline",
		    name: "Gantt Timeline",
		    category: "web",
		    description: "The Gantt Timeline",
		    depends: [ "dom", "touch", "draganddrop" ],
		    hidden: true
		};
	
		(function($) {
	
		    var Widget = kendo.ui.Widget;
		    var kendoDomElement = kendo.dom.element;
		    var kendoTextElement = kendo.dom.text;
		    var kendoHtmlElement = kendo.dom.html;
		    var isPlainObject = $.isPlainObject;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
		    var extend = $.extend;
		    var proxy = $.proxy;
		    var browser = kendo.support.browser;
		    var isRtl = false;
		    var keys = kendo.keys;
		    var Query = kendo.data.Query;
		    var STRING = "string";
		    var NS = ".kendoGanttTimeline";
		    var CLICK = "click";
		    var DBLCLICK = "dblclick";
		    var MOUSEMOVE = "mousemove";
		    var MOUSEENTER = "mouseenter";
		    var MOUSELEAVE = "mouseleave";
		    var KEYDOWN = "keydown";
		    var DOT = ".";
		    var TIME_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 't')#");
		    var DAY_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'ddd M/dd')#");
		    var WEEK_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'ddd M/dd')# - #=kendo.toString(kendo.date.addDays(end, -1), 'ddd M/dd')#");
		    var MONTH_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'MMM')#");
		    var YEAR_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'yyyy')#");
		    var RESIZE_HINT = kendo.template('<div class="#=styles.marquee#">' +
		                           '<div class="#=styles.marqueeColor#"></div>' +
		                       '</div>');
		    var RESIZE_TOOLTIP_TEMPLATE = kendo.template('<div style="z-index: 100002;" class="#=styles.tooltipWrapper#">' +
		                                   '<div class="#=styles.tooltipContent#">' +
		                                        '<div>#=messages.start#: #=kendo.toString(start, format)#</div>' +
		                                        '<div>#=messages.end#: #=kendo.toString(end, format)#</div>' +
		                                   '</div>' +
		                              '</div>');
		    var PERCENT_RESIZE_TOOLTIP_TEMPLATE = kendo.template('<div style="z-index: 100002;" class="#=styles.tooltipWrapper#" >' +
		                                   '<div class="#=styles.tooltipContent#">#=text#%</div>' +
		                                   '<div class="#=styles.tooltipCallout#" style="left:13px;"></div>' +
		                              '</div>');
		    var TASK_TOOLTIP_TEMPLATE = kendo.template('<div class="#=kendo.htmlEncode(styles.taskDetails)#">' +
		                                    '<strong>#=kendo.htmlEncode(task.title)#</strong>' +
		                                    '<div class="#=styles.taskDetailsPercent#">#=kendo.toString(task.percentComplete, "p0")#</div>' +
		                                    '<ul class="#=styles.reset#">' +
		                                        '<li>#=messages.start#: #=kendo.toString(task.start, "h:mm tt ddd, MMM d")#</li>' +
		                                        '<li>#=messages.end#: #=kendo.toString(task.end, "h:mm tt ddd, MMM d")#</li>' +
		                                    '</ul>' +
		                                '</div>');
		    var SIZE_CALCULATION_TEMPLATE = "<table style='visibility: hidden;'>" +
		        "<tbody>" +
		            "<tr style='height:{0}'>" +
		                "<td>&nbsp;</td>" +
		            "</tr>" +
		        "</tbody>" +
		    "</table>";
	
		    var defaultViews = {
		        day: {
		            type: "kendo.ui.GanttDayView"
		        },
		        week: {
		            type: "kendo.ui.GanttWeekView"
		        },
		        month: {
		            type: "kendo.ui.GanttMonthView"
		        },
		        year: {
		            type: "kendo.ui.GanttYearView"
		        }
		    };
	
		    function trimOptions(options) {
		        delete options.name;
		        delete options.prefix;
		        delete options.views;
	
		        return options;
		    }
	
		    function getWorkDays(options) {
		        var workDays = [];
		        var dayIndex = options.workWeekStart;
	
		        workDays.push(dayIndex);
	
		        while (options.workWeekEnd != dayIndex) {
		            if (dayIndex > 6) {
		                dayIndex -= 7;
		            } else {
		                dayIndex++;
		            }
		            workDays.push(dayIndex);
		        }
		        return workDays;
		    }
	
		    function blurActiveElement() {
		        var activeElement = kendo._activeElement();
	
		        if (activeElement && activeElement.nodeName.toLowerCase() !== "body") {
		            $(activeElement).blur();
		        }
		    }
	
		    var viewStyles = {
		        alt: "k-alt",
		        reset: "k-reset",
		        nonWorking: "k-nonwork-hour",
		        header: "k-header",
		        gridHeader: "k-grid-header",
		        gridHeaderWrap: "k-grid-header-wrap",
		        gridContent: "k-grid-content",
		        tasksWrapper: "k-gantt-tables",
		        rowsTable: "k-gantt-rows",
		        columnsTable: "k-gantt-columns",
		        tasksTable: "k-gantt-tasks",
		        dependenciesWrapper: "k-gantt-dependencies",
		        resource: "k-resource",
		        resourceAlt: "k-resource k-alt",
		        task: "k-task",
		        taskSingle: "k-task-single",
		        taskMilestone: "k-task-milestone",
		        taskSummary: "k-task-summary",
		        taskWrap: "k-task-wrap",
		        taskMilestoneWrap: "k-milestone-wrap",
		        resourcesWrap: "k-resources-wrap",
		        taskDot: "k-task-dot",
		        taskDotStart: "k-task-start",
		        taskDotEnd: "k-task-end",
		        taskDragHandle: "k-task-draghandle",
		        taskContent: "k-task-content",
		        taskTemplate: "k-task-template",
		        taskActions: "k-task-actions",
		        taskDelete: "k-task-delete",
		        taskComplete: "k-task-complete",
		        taskDetails: "k-task-details",
		        taskDetailsPercent: "k-task-pct",
		        link: "k-link",
		        icon: "k-icon",
		        iconDelete: "k-i-close",
		        taskResizeHandle: "k-resize-handle",
		        taskResizeHandleWest: "k-resize-w",
		        taskResizeHandleEast: "k-resize-e",
		        taskSummaryProgress: "k-task-summary-progress",
		        taskSummaryComplete: "k-task-summary-complete",
		        line: "k-line",
		        lineHorizontal: "k-line-h",
		        lineVertical: "k-line-v",
		        arrowWest: "k-arrow-w",
		        arrowEast: "k-arrow-e",
		        dragHint: "k-drag-hint",
		        dependencyHint: "k-dependency-hint",
		        tooltipWrapper: "k-widget k-tooltip k-popup k-group k-reset",
		        tooltipContent: "k-tooltip-content",
		        tooltipCallout: "k-callout k-callout-s",
		        callout: "k-callout",
		        marquee: "k-marquee k-gantt-marquee",
		        marqueeColor: "k-marquee-color"
		    };
	
		    var GanttView = kendo.ui.GanttView = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this.title = this.options.title || this.options.name;
	
		            this.header = this.element.find(DOT + GanttView.styles.gridHeader);
	
		            this.content = this.element.find(DOT + GanttView.styles.gridContent);
	
		            this.contentWidth = this.content.width();
	
		            this._workDays = getWorkDays(this.options);
	
		            this._headerTree = options.headerTree;
	
		            this._taskTree = options.taskTree;
	
		            this._taskTemplate = options.taskTemplate ?
		                kendo.template(options.taskTemplate, extend({}, kendo.Template, options.templateSettings)) :
		                null;
	
		            this._dependencyTree = options.dependencyTree;
	
		            this._taskCoordinates = {};
	
		            this._currentTime();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            clearTimeout(this._tooltipTimeout);
	
		            this.headerRow = null;
		            this.header = null;
		            this.content = null;
	
		            this._dragHint = null;
		            this._resizeHint = null;
		            this._resizeTooltip = null;
		            this._taskTooltip = null;
		            this._percentCompleteResizeTooltip = null;
	
		            this._headerTree = null;
		            this._taskTree = null;
		            this._dependencyTree = null;
		        },
	
		        options: {
		            showWorkHours: false,
		            showWorkDays: false,
		            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
		            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
		            workWeekStart: 1,
		            workWeekEnd: 5,
		            hourSpan: 1,
		            slotSize: 100,
		            currentTimeMarker: {
		                 updateInterval: 10000
		            }
		        },
	
		        renderLayout: function() {
		            this._slots = this._createSlots();
	
		            this._tableWidth = this._calculateTableWidth();
	
		            this.createLayout(this._layout());
	
		            this._slotDimensions();
	
		            this._adjustHeight();
	
		            this.content.find(DOT + GanttView.styles.dependenciesWrapper).width(this._tableWidth);
		        },
	
		        _adjustHeight: function() {
		            if(this.content){
		                this.content.height(this.element.height() - outerHeight(this.header));
		            }
		        },
	
		        createLayout: function(rows) {
		            var headers = this._headers(rows);
		            var colgroup = this._colgroup();
		            var tree = this._headerTree;
		            var header = kendoDomElement("thead", null, headers);
		            var table = kendoDomElement("table", { style: { width: this._tableWidth + "px"} }, [colgroup, header]);
	
		            tree.render([table]);
	
		            this.headerRow = this.header.find("table:first tr").last();
		        },
	
		        _slotDimensions: function() {
		            var headers = this.headerRow[0].children;
		            var slots = this._timeSlots();
		            var slot;
		            var header;
	
		            for (var i = 0, length = headers.length; i < length; i++) {
		                header = headers[i];
		                slot = slots[i];
	
		                slot.offsetLeft = header.offsetLeft;
		                slot.offsetWidth = header.offsetWidth;
		            }
		        },
	
		        render: function(tasks) {
		            var taskCount = tasks.length;
		            var styles = GanttView.styles;
		            var contentTable;
		            var rowsTable = this._rowsTable(taskCount);
		            var columnsTable = this._columnsTable(taskCount);
		            var tasksTable = this._tasksTable(tasks);
		            var currentTimeMarker = this.options.currentTimeMarker;
		            var calculatedSize = this.options.calculatedSize;
		            var totalHeight;
	
		            this._taskTree.render([rowsTable, columnsTable, tasksTable]);
	
		            contentTable = this.content.find(DOT + styles.rowsTable);
	
		            if (calculatedSize) {
		                totalHeight = calculatedSize.row * tasks.length;
		                this.content.find(DOT + styles.tasksTable).height(totalHeight);
		                contentTable.height(totalHeight);
		            }
	
		            this._contentHeight = contentTable.height();
		            this._rowHeight = calculatedSize ? calculatedSize.row : this._contentHeight / contentTable.find("tr").length;
	
		            this.content.find(DOT + styles.columnsTable).height(this._contentHeight);
	
		            if (currentTimeMarker !== false && currentTimeMarker.updateInterval !== undefined) {
		                this._renderCurrentTime();
		            }
		        },
	
		        _rowsTable: function(rowCount) {
		            var rows = [];
		            var row;
		            var styles = GanttView.styles;
		            var attributes = [null, { className: styles.alt }];
	
		            for (var i = 0; i < rowCount; i++) {
		                row = kendoDomElement("tr", attributes[i % 2], [
		                    kendoDomElement("td", null, [
		                        kendoTextElement("\u00a0")
		                    ])
		                ]);
	
		                rows.push(row);
		            }
	
		            return this._createTable(1, rows, { className: styles.rowsTable });
		        },
	
		        _columnsTable: function() {
		            var cells = [];
		            var row;
		            var styles = GanttView.styles;
		            var slots = this._timeSlots();
		            var slotsCount = slots.length;
		            var slot;
		            var slotSpan;
		            var totalSpan = 0;
		            var attributes;
	
		            for (var i = 0; i < slotsCount; i++) {
		                slot = slots[i];
	
		                attributes = {};
	
		                slotSpan = slot.span;
	
		                totalSpan += slotSpan;
	
		                if (slotSpan !== 1) {
		                    attributes.colspan = slotSpan;
		                }
	
		                if (slot.isNonWorking) {
		                    attributes.className = styles.nonWorking;
		                }
	
		                cells.push(kendoDomElement("td", attributes, [
		                    kendoTextElement("\u00a0")
		                ]));
		            }
	
		            row = kendoDomElement("tr", null, cells);
	
		            return this._createTable(totalSpan, [row], { className: styles.columnsTable});
		        },
	
		        _tasksTable: function(tasks) {
		            var rows = [];
		            var row;
		            var cell;
		            var position;
		            var task;
		            var styles = GanttView.styles;
		            var coordinates = this._taskCoordinates = {};
		            var size = this._calculateMilestoneWidth();
		            var milestoneWidth = Math.round(size.width);
		            var resourcesField = this.options.resourcesField;
		            var className = [styles.resource, styles.resourceAlt];
		            var calculatedSize = this.options.calculatedSize;
		            var resourcesPosition;
		            var resourcesMargin = this._calculateResourcesMargin();
		            var taskBorderWidth = this._calculateTaskBorderWidth();
		            var resourceStyle;
	
		            var addCoordinates = function(rowIndex) {
		                var taskLeft;
		                var taskRight;
	
		                taskLeft = position.left;
		                taskRight = taskLeft + position.width;
	
		                if (task.isMilestone()) {
		                    taskLeft -= milestoneWidth / 2;
		                    taskRight = taskLeft + milestoneWidth;
		                }
	
		                coordinates[task.id] = {
		                    start: taskLeft,
		                    end: taskRight,
		                    rowIndex: rowIndex
		                };
		            };
	
		            for (var i = 0, l = tasks.length; i < l; i++) {
		                task = tasks[i];
	
		                position = this._taskPosition(task);
		                position.borderWidth = taskBorderWidth;
	
		                row = kendoDomElement("tr", null);
		                cell = kendoDomElement("td");
	
		                if (task.start <= this.end && task.end >= this.start) {
		                    cell.children.push(this._renderTask(tasks[i], position));
	
		                    if (task[resourcesField] && task[resourcesField].length) {
		                        if (isRtl) {
		                            resourcesPosition = this._tableWidth - position.left;
		                        } else {
		                            resourcesPosition = Math.max((position.width || size.clientWidth), 0) + position.left;
		                        }
	
		                        resourceStyle = {
		                            width: (this._tableWidth - (resourcesPosition + resourcesMargin)) + "px"
		                        };
	
		                        resourceStyle[isRtl ? "right" : "left"] = resourcesPosition + "px";
	
		                        if (calculatedSize) {
		                            resourceStyle.height = calculatedSize.cell + "px";
		                        }
	
		                        cell.children.push(kendoDomElement("div",
		                            {
		                                className: styles.resourcesWrap,
		                                style: resourceStyle
		                            },
		                            this._renderResources(task[resourcesField], className[i % 2]))
		                        );
		                    }
	
		                    addCoordinates(i);
		                }
		                row.children.push(cell);
		                rows.push(row);
		            }
	
		            return this._createTable(1, rows, { className: GanttView.styles.tasksTable });
		        },
	
		        _createTable: function(colspan, rows, styles) {
		            var cols = [];
		            var colgroup;
		            var tbody;
	
		            for (var i = 0; i < colspan; i++) {
		                cols.push(kendoDomElement("col"));
		            }
	
		            colgroup = kendoDomElement("colgroup", null, cols);
	
		            tbody = kendoDomElement("tbody", null, rows);
	
		            if (!styles.style) {
		                styles.style = {};
		            }
	
		            styles.style.width = this._tableWidth + "px";
	
		            return kendoDomElement("table", styles, [colgroup, tbody]);
		        },
	
		        _calculateTableWidth: function() {
		            var slots = this._timeSlots();
		            var maxSpan = 0;
		            var totalSpan = 0;
		            var currentSpan;
		            var tableWidth;
	
		            for (var i = 0, length = slots.length; i < length; i++) {
		                currentSpan = slots[i].span;
	
		                totalSpan += currentSpan;
	
		                if (currentSpan > maxSpan) {
		                    maxSpan = currentSpan;
		                }
		            }
	
		            tableWidth = Math.round((totalSpan * this.options.slotSize) / maxSpan);
	
		            return tableWidth;
		        },
	
		        _calculateMilestoneWidth: function() {
		            var size;
		            var className = GanttView.styles.task + " " + GanttView.styles.taskMilestone;
		            var milestone = $("<div class='" + className + "' style='visibility: hidden; position: absolute'>");
		            var boundingClientRect;
	
		            this.content.append(milestone);
	
		            boundingClientRect = milestone[0].getBoundingClientRect();
	
		            size = {
		                "width": boundingClientRect.right - boundingClientRect.left,
		                "clientWidth": milestone[0].clientWidth
		            };
	
		            milestone.remove();
	
		            return size;
		        },
	
		        _calculateResourcesMargin: function() {
		            var margin;
		            var wrapper = $("<div class='" + GanttView.styles.resourcesWrap + "' style='visibility: hidden; position: absolute'>");
	
		            this.content.append(wrapper);
	
		            margin = parseInt(wrapper.css(isRtl ? "margin-right" : "margin-left"), 10);
	
		            wrapper.remove();
	
		            return margin;
		        },
	
		        _calculateTaskBorderWidth: function() {
		            var width;
		            var className = GanttView.styles.task + " " + GanttView.styles.taskSingle;
		            var task = $("<div class='" + className + "' style='visibility: hidden; position: absolute'>");
		            var computedStyle;
	
		            this.content.append(task);
	
		            computedStyle = kendo.getComputedStyles(task[0], ["border-left-width"]);
	
		            width = parseFloat(computedStyle["border-left-width"], 10);
	
		            task.remove();
	
		            return width;
		        },
	
		        _renderTask: function(task, position) {
		            var taskWrapper;
		            var taskElement;
		            var editable = this.options.editable;
		            var progressHandleOffset;
		            var taskLeft = position.left;
		            var styles = GanttView.styles;
		            var wrapClassName = styles.taskWrap;
		            var calculatedSize = this.options.calculatedSize;
		            var dragHandleStyle = {};
		            var taskWrapAttr = {
		                className: wrapClassName,
		                style: { left: taskLeft + "px" }
		            };
	
		            if (calculatedSize) {
		                taskWrapAttr.style.height = calculatedSize.cell + "px";
		            }
	
		            if (task.summary) {
		                taskElement = this._renderSummary(task, position);
		            } else if (task.isMilestone()) {
		                taskElement = this._renderMilestone(task, position);
		                taskWrapAttr.className += " " + styles.taskMilestoneWrap;
		            } else {
		                taskElement = this._renderSingleTask(task, position);
		            }
	
		            taskWrapper = kendoDomElement("div", taskWrapAttr, [
		                taskElement
		            ]);
	
		            if (editable && editable.dependencyCreate !== false) {
		                taskWrapper.children.push(kendoDomElement("div", { className: styles.taskDot + " " + styles.taskDotStart }));
		                taskWrapper.children.push(kendoDomElement("div", { className: styles.taskDot + " " + styles.taskDotEnd }));
		            }
	
		            if (!task.summary && !task.isMilestone() && editable && editable.dragPercentComplete !== false && editable.update !== false && this._taskTemplate === null) {
		                progressHandleOffset = Math.round(position.width * task.percentComplete);
	
		                dragHandleStyle[isRtl ? "right" : "left"] = progressHandleOffset + "px";
		                taskWrapper.children.push(kendoDomElement("div", { className: styles.taskDragHandle, style: dragHandleStyle }));
		            }
	
		            return taskWrapper;
		        },
	
		        _renderSingleTask: function(task, position) {
		            var styles = GanttView.styles;
		            var progressWidth = Math.round(position.width * task.percentComplete);
		            var taskChildren = [];
		            var taskContent;
		            var editable = this.options.editable;
	
		            if (this._taskTemplate !== null) {
		                taskContent = kendoHtmlElement(this._taskTemplate(task));
		            } else {
		                taskContent = kendoTextElement(task.title);
		                taskChildren.push(kendoDomElement("div", { className: styles.taskComplete, style: { width: progressWidth + "px" } }));
		            }
	
		            var content = kendoDomElement("div", { className: styles.taskContent }, [
		                kendoDomElement("div", { className: styles.taskTemplate }, [
		                    taskContent
		                ])
		            ]);
	
		            taskChildren.push(content);
	
		            if (editable) {
		                if (editable.destroy !== false) {
		                    content.children.push(kendoDomElement("span", { className: styles.taskActions }, [
		                        kendoDomElement("a", { className: styles.link + " " + styles.taskDelete, href: "#", "aria-label": "Delete" }, [
		                            kendoDomElement("span", { className: styles.icon + " " + styles.iconDelete })
		                        ])
		                    ]));
		                }
	
		                if (editable.resize !== false && editable.update !== false) {
		                    content.children.push(kendoDomElement("span", { className: styles.taskResizeHandle + " " + styles.taskResizeHandleWest }));
		                    content.children.push(kendoDomElement("span", { className: styles.taskResizeHandle + " " + styles.taskResizeHandleEast }));
		                }
		            }
	
		            var element = kendoDomElement("div", {
		                className: styles.task + " " + styles.taskSingle, "data-uid": task.uid, style:
		                    { width: Math.max((position.width - position.borderWidth * 2), 0) + "px" }
		            }, taskChildren);
	
		            return element;
		        },
	
		        _renderMilestone: function(task) {
		            var styles = GanttView.styles;
		            var element = kendoDomElement("div", { className: styles.task + " " + styles.taskMilestone, "data-uid": task.uid });
	
		            return element;
		        },
	
		        _renderSummary: function(task, position) {
		            var styles = GanttView.styles;
		            var progressWidth = Math.round(position.width * task.percentComplete);
	
		            var element = kendoDomElement("div", { className: styles.task + " " + styles.taskSummary, "data-uid": task.uid, style: { width: position.width + "px" } }, [
		                kendoDomElement("div", { className: styles.taskSummaryProgress, style: { width: progressWidth + "px" } }, [
		                    kendoDomElement("div", { className: styles.taskSummaryComplete, style: { width: position.width + "px" } })
		                ])
		            ]);
	
		            return element;
		        },
	
		        _renderResources: function(resources, className) {
		            var children = [];
		            var resource;
	
		            for (var i = 0, length = resources.length; i < length; i++) {
		                resource = resources[i];
		                children.push(kendoDomElement("span", {
		                    className: className,
		                    style: {
		                        "color": resource.get("color")
		                    }
		                }, [kendoTextElement(resource.get("name"))]));
		            }
	
		            if (isRtl) {
		                children.reverse();
		            }
	
		            return children;
		        },
	
		        _taskPosition: function(task) {
		            var round = Math.round;
	
		            var startLeft = round(this._offset(isRtl ? task.end : task.start));
		            var endLeft = round(this._offset(isRtl ? task.start : task.end));
	
		            return { left: startLeft, width: endLeft - startLeft };
		        },
	
		        _offset: function(date) {
		            var slots = this._timeSlots();
		            var slot;
		            var startOffset;
		            var slotDuration;
		            var slotOffset = 0;
		            var startIndex;
	
		            if (!slots.length) {
		                return 0;
		            }
	
		            startIndex = this._slotIndex("start", date);
	
		            slot = slots[startIndex];
	
		            if (slot.end < date) {
		                slotOffset = slot.offsetWidth;
		            } else if (slot.start <= date) {
		                startOffset = date - slot.start;
		                slotDuration = slot.end - slot.start;
		                slotOffset = (startOffset / slotDuration) * slot.offsetWidth;
		            }
	
		            if (isRtl) {
		                slotOffset = (slot.offsetWidth + 1) - slotOffset; // Add one pixel for border
		            }
	
		            return slot.offsetLeft + slotOffset;
		        },
	
		        _slotIndex: function(field, value, reverse) {
		            var slots = this._timeSlots();
		            var startIdx = 0;
		            var endIdx = slots.length - 1;
		            var middle;
	
		            if (reverse) {
		                slots = [].slice.call(slots).reverse();
		            }
	
		            do {
		                middle = Math.ceil((endIdx + startIdx) / 2);
	
		                if (slots[middle][field] < value) {
		                    startIdx = middle;
		                } else {
		                    if (middle === endIdx) {
		                        middle--;
		                    }
	
		                    endIdx = middle;
		                }
		            } while (startIdx !== endIdx);
	
		            if (reverse) {
		                startIdx = (slots.length - 1) - startIdx;
		            }
	
		            return startIdx;
		        },
	
		        _timeByPosition: function(x, snap, snapToEnd) {
		            var slot = this._slotByPosition(x);
	
		            if (snap) {
		                return snapToEnd ? slot.end : slot.start;
		            }
	
		            var offsetLeft = x - $(DOT + GanttView.styles.tasksTable).offset().left;
		            var duration = slot.end - slot.start;
		            var slotOffset = offsetLeft - slot.offsetLeft;
	
		            if (isRtl) {
		                slotOffset = slot.offsetWidth - slotOffset;
		            }
	
		            return new Date(slot.start.getTime() + (duration * (slotOffset / slot.offsetWidth)));
		        },
	
		        _slotByPosition: function(x) {
		            var offsetLeft = x - $(DOT + GanttView.styles.tasksTable).offset().left;
		            var slotIndex = this._slotIndex("offsetLeft", offsetLeft, isRtl);
	
		            return this._timeSlots()[slotIndex];
		        },
	
		        _renderDependencies: function(dependencies) {
		            var elements = [];
		            var tree = this._dependencyTree;
	
		            for (var i = 0, l = dependencies.length; i < l; i++) {
		                elements.push.apply(elements, this._renderDependency(dependencies[i]));
	
		            }
	
		            tree.render(elements);
		        },
	
		        _renderDependency: function(dependency) {
		            var predecessor = this._taskCoordinates[dependency.predecessorId];
		            var successor = this._taskCoordinates[dependency.successorId];
		            var elements;
		            var method;
	
		            if (!predecessor || !successor) {
		                return [];
		            }
	
		            method = "_render" + ["FF", "FS", "SF", "SS"][isRtl ? 3 - dependency.type : dependency.type];
	
		            elements = this[method](predecessor, successor);
	
		            for (var i = 0, length = elements.length; i < length; i++) {
		                elements[i].attr["data-uid"] = dependency.uid;
		            }
	
		            return elements;
		        },
	
		        _renderFF: function(from, to) {
		            var lines = this._dependencyFF(from, to, false);
	
		            lines[lines.length - 1].children[0] = this._arrow(true);
	
		            return lines;
		        },
	
		        _renderSS: function(from, to) {
		            var lines = this._dependencyFF(to, from, true);
	
		            lines[0].children[0] = this._arrow(false);
	
		            return lines.reverse();
		        },
	
		        _renderFS: function(from, to) {
		            var lines = this._dependencyFS(from, to, false);
	
		            lines[lines.length - 1].children[0] = this._arrow(false);
	
		            return lines;
		        },
	
		        _renderSF: function(from, to) {
		            var lines = this._dependencyFS(to, from, true);
	
		            lines[0].children[0] = this._arrow(true);
	
		            return lines.reverse();
		        },
	
		        _dependencyFF: function(from, to, reverse) {
		            var that = this;
		            var lines = [];
		            var left = 0;
		            var top = 0;
		            var width = 0;
		            var height = 0;
		            var dir = reverse ? "start" : "end";
		            var delta;
		            var overlap = 2;
		            var arrowOverlap = 1;
		            var rowHeight = this._rowHeight;
		            var minLineWidth = 10;
		            var fromTop = from.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
		            var toTop = to.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
		            var styles = GanttView.styles;
	
		            var addHorizontal = function() {
		                lines.push(that._line(styles.line + " " + styles.lineHorizontal, { left: left + "px", top: top + "px", width: width + "px" }));
		            };
		            var addVertical = function() {
		                lines.push(that._line(styles.line + " " + styles.lineVertical, { left: left + "px", top: top + "px", height: height + "px" }));
		            };
	
		            left = from[dir];
		            top = fromTop;
		            width = minLineWidth;
	
		            delta = to[dir] - from[dir];
	
		            if ((delta) > 0 !== reverse) {
		                width = Math.abs(delta) + minLineWidth;
		            }
	
		            if (reverse) {
		                left -= width;
		                width -= arrowOverlap;
		                addHorizontal();
		            } else {
		                addHorizontal();
		                left += width - overlap;
		            }
	
		            if (toTop < top) {
		                height = top - toTop;
		                height += overlap;
		                top = toTop;
		                addVertical();
		            } else {
		                height = toTop - top;
		                height += overlap;
		                addVertical();
		                top += (height - overlap);
		            }
	
		            width = Math.abs(left - to[dir]);
	
		            if (!reverse) {
		                width -= arrowOverlap;
		                left -= width;
		            }
	
		            addHorizontal();
	
		            return lines;
		        },
	
		        _dependencyFS: function(from, to, reverse) {
		            var that = this;
		            var lines = [];
		            var left = 0;
		            var top = 0;
		            var width = 0;
		            var height = 0;
		            var rowHeight = this._rowHeight;
		            var minLineHeight = Math.floor(rowHeight / 2);
		            var minLineWidth = 10;
		            var minDistance = 2 * minLineWidth;
		            var delta = to.start - from.end;
		            var overlap = 2;
		            var arrowOverlap = 1;
		            var fromTop = from.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
		            var toTop = to.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
		            var styles = GanttView.styles;
	
		            var addHorizontal = function() {
		                lines.push(that._line(styles.line + " " + styles.lineHorizontal, { left: left + "px", top: top + "px", width: width + "px" }));
		            };
		            var addVertical = function() {
		                lines.push(that._line(styles.line + " " + styles.lineVertical, { left: left + "px", top: top + "px", height: height + "px" }));
		            };
	
		            left = from.end;
		            top = fromTop;
		            width = minLineWidth;
	
		            if (reverse) {
		                left += arrowOverlap;
	
		                if (delta > minDistance) {
		                    width = delta - (minLineWidth - overlap);
		                }
	
		                width -= arrowOverlap;
		            }
	
		            addHorizontal();
		            left += width - overlap;
	
		            if ((delta) <= minDistance) {
		                height = reverse ? Math.abs(toTop - fromTop) - minLineHeight : minLineHeight;
	
		                if (toTop < fromTop) {
		                    top -= height;
	
		                    height += overlap;
	
		                    addVertical();
		                } else {
		                    addVertical();
		                    top += height;
		                }
	
		                width = (from.end - to.start) + minDistance;
	
		                if (width < minLineWidth) {
		                    width = minLineWidth;
		                }
	
		                left -= width - overlap;
	
		                addHorizontal();
		            }
	
		            if (toTop < fromTop) {
		                height = top - toTop;
		                top = toTop;
	
		                height += overlap;
	
		                addVertical();
		            } else {
		                height = toTop - top;
		                addVertical();
		                top += height;
		            }
	
		            width = to.start - left;
	
		            if (!reverse) {
		                width -= arrowOverlap;
		            }
	
		            addHorizontal();
	
		            return lines;
		        },
	
		        _line: function(className, styles) {
		            return kendoDomElement("div", { className: className, style: styles });
		        },
	
		        _arrow: function(direction) {
		            return kendoDomElement("span", { className: direction ? GanttView.styles.arrowWest : GanttView.styles.arrowEast });
		        },
	
		        _colgroup: function() {
		            var slots = this._timeSlots();
		            var count = slots.length;
		            var cols = [];
	
		            for (var i = 0; i < count; i++) {
		                for (var j = 0, length = slots[i].span; j < length; j++) {
		                    cols.push(kendoDomElement("col"));
		                }
		            }
	
		            return kendoDomElement("colgroup", null, cols);
		        },
	
		        _createDragHint: function(element) {
		            this._dragHint = element
		                .clone()
		                .addClass(GanttView.styles.dragHint)
		                .css("cursor", "move");
	
		            element
		                .parent()
		                .append(this._dragHint);
		        },
	
		        _updateDragHint: function(start) {
		            var left = this._offset(start);
	
		            this._dragHint
		                .css({
		                    "left": left
		                });
		        },
	
		        _removeDragHint: function() {
		            this._dragHint.remove();
		            this._dragHint = null;
		        },
	
		        _createResizeHint: function(task) {
		            var styles = GanttView.styles;
		            var taskTop = this._taskCoordinates[task.id].rowIndex * this._rowHeight;
		            var tooltipHeight;
		            var tooltipTop;
		            var options = this.options;
		            var messages = options.messages;
	
		            this._resizeHint = $(RESIZE_HINT({ styles: styles })).css({
		                "top": 0,
		                "height": this._contentHeight
		            });
	
		            this.content.append(this._resizeHint);
	
		            this._resizeTooltip = $(RESIZE_TOOLTIP_TEMPLATE({
		                styles: styles,
		                start: task.start,
		                end: task.end,
		                messages: messages.views,
		                format: options.resizeTooltipFormat
		            }))
		            .css({
		                "top": 0,
		                "left": 0
		            });
	
		            this.content.append(this._resizeTooltip);
	
		            this._resizeTooltipWidth = outerWidth(this._resizeTooltip);
		            tooltipHeight = outerHeight(this._resizeTooltip);
	
		            tooltipTop = taskTop - tooltipHeight;
	
		            if (tooltipTop < 0) {
		                tooltipTop = taskTop + this._rowHeight;
		            }
	
		            this._resizeTooltipTop = tooltipTop;
		        },
	
		        _updateResizeHint: function(start, end, resizeStart) {
		            var left = this._offset(isRtl ? end : start);
		            var right = this._offset(isRtl ? start : end);
		            var width = right - left;
		            var tooltipLeft = (resizeStart !== isRtl) ? left : right;
		            var tablesWidth = this._tableWidth - kendo.support.scrollbar();
		            var tooltipWidth = this._resizeTooltipWidth;
		            var options = this.options;
		            var messages = options.messages;
		            var tableOffset = $(DOT + GanttView.styles.tasksTable).offset().left - $(DOT + GanttView.styles.tasksWrapper).offset().left;
	
		            if (isRtl) {
		                left += tableOffset;
		            }
	
		            this._resizeHint
		                .css({
		                    "left": left,
		                    "width": width
		                });
	
		            if (this._resizeTooltip) {
		                this._resizeTooltip.remove();
		            }
	
		            tooltipLeft -= Math.round(tooltipWidth / 2);
	
		            if (tooltipLeft < 0) {
		                tooltipLeft = 0;
		            } else if (tooltipLeft + tooltipWidth > tablesWidth) {
		                tooltipLeft = tablesWidth - tooltipWidth;
		            }
	
		            if (isRtl) {
		                tooltipLeft += tableOffset;
		            }
	
		            this._resizeTooltip = $(RESIZE_TOOLTIP_TEMPLATE({
		                styles: GanttView.styles,
		                start: start,
		                end: end,
		                messages: messages.views,
		                format: options.resizeTooltipFormat
		            }))
		            .css({
		                "top": this._resizeTooltipTop,
		                "left": tooltipLeft,
		                "min-width": tooltipWidth
		            })
		            .appendTo(this.content);
		        },
	
		        _removeResizeHint: function() {
		            this._resizeHint.remove();
		            this._resizeHint = null;
	
		            this._resizeTooltip.remove();
		            this._resizeTooltip = null;
		        },
	
		        _updatePercentCompleteTooltip: function(top, left, text) {
		            this._removePercentCompleteTooltip();
	
		            var tooltip = this._percentCompleteResizeTooltip = $(PERCENT_RESIZE_TOOLTIP_TEMPLATE({ styles: GanttView.styles, text: text }))
		                .appendTo(this.element);
	
		            var tooltipMiddle = Math.round(outerWidth(tooltip) / 2);
		            var arrow = tooltip.find(DOT + GanttView.styles.callout);
		            var arrowHeight = Math.round(outerWidth(arrow) / 2);
	
		            tooltip.css({
		                "top": top - (outerHeight(tooltip) + arrowHeight),
		                "left": left - tooltipMiddle
		            });
	
		            arrow.css("left", tooltipMiddle - arrowHeight);
		        },
	
		        _removePercentCompleteTooltip: function() {
		            if (this._percentCompleteResizeTooltip) {
		                this._percentCompleteResizeTooltip.remove();
		            }
	
		            this._percentCompleteResizeTooltip = null;
		        },
	
		        _updateDependencyDragHint: function(from, to, useVML) {
		            this._removeDependencyDragHint();
	
		            if (useVML) {
		                this._creteVmlDependencyDragHint(from, to);
		            } else {
		                this._creteDependencyDragHint(from, to);
		            }
		        },
	
		        _creteDependencyDragHint: function(from, to) {
		            var styles = GanttView.styles;
	
		            var deltaX = to.x - from.x;
		            var deltaY = to.y - from.y;
	
		            var width = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
		            var angle = Math.atan(deltaY / deltaX);
	
		            if (deltaX < 0) {
		                angle += Math.PI;
		            }
	
		            $("<div class='" + styles.line + " " + styles.lineHorizontal + " " + styles.dependencyHint + "'></div>")
		                .css({
		                    "top": from.y,
		                    "left": from.x,
		                    "width": width,
		                    "transform-origin": "0% 0",
		                    "-ms-transform-origin": "0% 0",
		                    "-webkit-transform-origin": "0% 0",
		                    "transform": "rotate(" + angle + "rad)",
		                    "-ms-transform": "rotate(" + angle + "rad)",
		                    "-webkit-transform": "rotate(" + angle + "rad)"
		                })
		                .appendTo(this.content);
		        },
	
		        _creteVmlDependencyDragHint: function(from, to) {
		            var hint = $("<kvml:line class='" + GanttView.styles.dependencyHint + "' style='position:absolute; top: 0px; left: 0px;' strokecolor='black' strokeweight='2px' from='" +
		                from.x + "px," + from.y + "px' to='" + to.x + "px," + to.y + "px'" + "></kvml:line>")
		                .appendTo(this.content);
	
		            // IE8 Bug
		            hint[0].outerHTML = hint[0].outerHTML;
		        },
	
		        _removeDependencyDragHint: function() {
		            this.content.find(DOT + GanttView.styles.dependencyHint).remove();
		        },
	
		        _createTaskTooltip: function(task, element, mouseLeft) {
		            var styles = GanttView.styles;
		            var options = this.options;
		            var content = this.content;
		            var contentOffset = content.offset();
		            var contentWidth = content.width();
		            var contentScrollLeft = kendo.scrollLeft(content);
		            var row = $(element).parents("tr").first();
		            var rowOffset = row.offset();
		            var template = (options.tooltip && options.tooltip.template) ? kendo.template(options.tooltip.template) : TASK_TOOLTIP_TEMPLATE;
		            var left = isRtl ? mouseLeft - (contentOffset.left + contentScrollLeft + kendo.support.scrollbar())
		                : mouseLeft - (contentOffset.left - contentScrollLeft);
		            var top = (rowOffset.top + outerHeight(row) - contentOffset.top) + content.scrollTop();
		            var tooltip = this._taskTooltip = $('<div style="z-index: 100002;" class="' +styles.tooltipWrapper + '" >' +
		                                   '<div class="' + styles.taskContent + '"></div></div>');
		            var tooltipWidth;
	
		            tooltip
		                .css({
		                    "left": left,
		                    "top": top
		                })
		                .appendTo(content)
		                .find(DOT + styles.taskContent)
		                .append(template({
		                    styles: styles,
		                    task: task,
		                    messages: options.messages.views
		                }));
	
		            if (outerHeight(tooltip) < rowOffset.top - contentOffset.top) {
		                tooltip.css("top", ((rowOffset.top - contentOffset.top) - outerHeight(tooltip)) + content.scrollTop());
		            }
	
		            tooltipWidth = outerWidth(tooltip);
	
		            if ((tooltipWidth + left) - contentScrollLeft > contentWidth) {
		                left -= tooltipWidth;
	
		                if (left < contentScrollLeft) {
		                    left = (contentScrollLeft + contentWidth) - (tooltipWidth + 17);
		                }
	
		                tooltip.css("left", left);
		            }
	
		        },
	
		        _removeTaskTooltip: function() {
		            if (this._taskTooltip) {
		                this._taskTooltip.remove();
		            }
	
		            this._taskTooltip = null;
		        },
	
		        _scrollTo: function(element) {
		            var elementLeft = element.offset().left;
		            var elementWidth = element.width();
		            var elementRight = elementLeft + elementWidth;
	
		            var row = element.closest("tr");
		            var rowTop = row.offset().top;
		            var rowHeight = row.height();
		            var rowBottom = rowTop + rowHeight;
	
		            var content = this.content;
		            var contentOffset = content.offset();
		            var contentTop = contentOffset.top;
		            var contentHeight = content.height();
		            var contentBottom = contentTop + contentHeight;
		            var contentLeft = contentOffset.left;
		            var contentWidth = content.width();
		            var contentRight = contentLeft + contentWidth;
	
		            var scrollbarWidth = kendo.support.scrollbar();
	
		            if (rowTop < contentTop) {
		                content.scrollTop(content.scrollTop() + (rowTop - contentTop));
		            } else if (rowBottom > contentBottom) {
		                content.scrollTop(content.scrollTop() + (rowBottom + scrollbarWidth - contentBottom));
		            }
	
		            if (elementLeft < contentLeft && elementWidth > contentWidth && elementRight < contentRight ||
		                elementRight > contentRight && elementWidth < contentWidth) {
		                content.scrollLeft(content.scrollLeft() + (elementRight + scrollbarWidth - contentRight));
		            } else if (elementRight > contentRight && elementWidth > contentWidth && elementLeft > contentLeft ||
		                elementLeft < contentLeft && elementWidth < contentWidth) {
		                content.scrollLeft(content.scrollLeft() + (elementLeft - contentLeft));
		            }
		        },
	
		        _scrollToDate: function (date) {
		            var viewStart = this.start;
		            var viewEnd = this.end;
		            var offset;
	
		            if (date >= viewStart && date < viewEnd) {
		                offset = this._offset(date);
	
		                if (kendo.support.isRtl(this.element)) {
		                    offset = this._tableWidth - offset;
		                }
	
		                kendo.scrollLeft(this.content, offset);
		            }
		        },
	
		        _timeSlots: function() {
		            if (!this._slots || !this._slots.length) {
		                return [];
		            }
	
		            return this._slots[this._slots.length - 1];
		        },
	
		        _headers: function(columnLevels) {
		            var rows = [];
		            var level;
		            var headers;
		            var column;
		            var headerText;
		            var styles = GanttView.styles;
	
		            for (var levelIndex = 0, levelCount = columnLevels.length; levelIndex < levelCount; levelIndex++) {
		                level = columnLevels[levelIndex];
		                headers = [];
	
		                for (var columnIndex = 0, columnCount = level.length; columnIndex < columnCount; columnIndex++) {
		                    column = level[columnIndex];
	
		                    headerText = kendoHtmlElement(column.text);
		                    headers.push(kendoDomElement("th", { colspan: column.span, className: styles.header + (column.isNonWorking ? (" " + styles.nonWorking) : "") }, [headerText]));
		                }
	
		                rows.push(kendoDomElement("tr", null, headers));
		            }
	
		            return rows;
		        },
	
		        _hours: function(start, end) {
		            var slotEnd;
		            var slots = [];
		            var options = this.options;
		            var workDayStart = options.workDayStart.getHours();
		            var workDayEnd = options.workDayEnd.getHours();
		            var isWorkHour;
		            var hours;
		            var hourSpan = options.hourSpan;
	
		            start = new Date(start);
		            end = new Date(end);
	
		            if (options.showWorkHours) {
		                start.setHours(workDayStart);
		            }
	
		            while (start < end) {
		                slotEnd = new Date(start);
		                hours = slotEnd.getHours();
	
		                isWorkHour = hours >= workDayStart && hours < workDayEnd;
	
		                slotEnd.setHours(slotEnd.getHours() + hourSpan);
	
		                if (hours == slotEnd.getHours()) {
		                    // Chrome DTS Fix
		                    slotEnd.setHours(slotEnd.getHours() + 2 * hourSpan);
		                }
	
		                if (!options.showWorkHours || isWorkHour) {
		                    slots.push({
		                        start: start,
		                        end: slotEnd,
		                        isNonWorking: !isWorkHour,
		                        span: 1
		                    });
		                }
	
		                start = slotEnd;
		            }
	
		            return slots;
		        },
	
		        _days: function(start, end) {
		            var slotEnd;
		            var slots = [];
		            var isWorkDay;
	
		            start = new Date(start);
		            end = new Date(end);
	
		            while (start < end) {
		                slotEnd = end < kendo.date.nextDay(start) ? end : kendo.date.nextDay(start);
	
		                isWorkDay = this._isWorkDay(start);
	
		                if (!this.options.showWorkDays || isWorkDay) {
		                    slots.push({
		                        start: start,
		                        end: slotEnd,
		                        isNonWorking: !isWorkDay,
		                        span: 1
		                    });
		                }
	
		                start = slotEnd;
		            }
	
		            return slots;
		        },
	
		        _weeks: function(start, end) {
		            var slotEnd;
		            var slots = [];
		            var firstDay = this.calendarInfo().firstDay;
		            var daySlots;
		            var span;
	
		            start = new Date(start);
		            end = new Date(end);
	
		            while (start < end) {
		                slotEnd = kendo.date.dayOfWeek(kendo.date.addDays(start, 1), firstDay, 1);
	
		                if (slotEnd > end) {
		                    slotEnd = end;
		                }
	
		                daySlots = this._days(start, slotEnd);
		                span = daySlots.length;
	
		                if (span > 0) {
		                    slots.push({
		                        start: daySlots[0].start,
		                        end: daySlots[span - 1].end,
		                        span: span
		                    });
		                }
	
		                start = slotEnd;
		            }
	
		            return slots;
		        },
	
		        _months: function(start, end) {
		            var slotEnd;
		            var endMonth;
		            var slots = [];
		            var daySlots;
		            var span;
	
		            start = new Date(start);
		            end = new Date(end);
	
		            while (start < end) {
		                slotEnd = new Date(start);
		                endMonth = kendo.date.firstDayOfMonth(new Date(slotEnd.setMonth(slotEnd.getMonth() + 1)));
		                slotEnd = end < endMonth ? end : endMonth;
	
		                daySlots = this._days(start, slotEnd);
		                span = daySlots.length;
	
		                if (span > 0) {
		                    slots.push({
		                        start: daySlots[0].start,
		                        end: daySlots[span - 1].end,
		                        span: span
		                    });
		                }
	
		                start = slotEnd;
		            }
	
		            return slots;
		        },
	
		        _years: function(start, end) {
		            var slotEnd;
		            var monthSpan;
		            var endMonth;
		            var slots = [];
	
		            start = new Date(start);
		            end = new Date(end);
	
		            while (start < end) {
		                slotEnd = new Date(start);
		                slotEnd = kendo.date.firstDayOfMonth(new Date(slotEnd.setMonth(12)));
	
		                if (slotEnd >= end) {
		                    slotEnd = end;
		                }
	
		                endMonth = slotEnd.getMonth() || 12;
		                monthSpan = endMonth - start.getMonth();
	
		                slots.push({
		                    start: start,
		                    end: slotEnd,
		                    span: monthSpan
		                });
	
		                start = slotEnd;
		            }
	
		            return slots;
		        },
	
		        _slotHeaders: function(slots, template) {
		            var columns = [];
		            var slot;
	
		            for (var i = 0, l = slots.length; i < l; i++) {
		                slot = slots[i];
	
		                columns.push({
		                    text: template(slot),
		                    isNonWorking: !!slot.isNonWorking,
		                    span: slot.span
		                });
		            }
	
		            return columns;
		        },
	
		        _isWorkDay: function(date) {
		            var day = date.getDay();
		            var workDays = this._workDays;
	
		            for (var i = 0, l = workDays.length; i < l; i++) {
		                if (workDays[i] === day) {
		                    return true;
		                }
		            }
	
		            return false;
		        },
	
		        calendarInfo: function() {
		            return kendo.getCulture().calendars.standard;
		        },
	
		        _renderCurrentTime: function() {
		            var currentTime = this._getCurrentTime();
		            var timeOffset = this._offset(currentTime);
		            var element = $("<div class='k-current-time'></div>");
		            var viewStyles = GanttView.styles;
		            var tablesWrap = $(DOT + viewStyles.tasksWrapper);
		            var tasksTable = $(DOT + viewStyles.tasksTable);
		            var slot;
	
		            if (!this.content || !this._timeSlots().length) {
		                return;
		            }
	
		            this.content.find(".k-current-time").remove();
	
		            slot = this._timeSlots()[this._slotIndex("start", currentTime)];
	
		            if (currentTime < slot.start || currentTime > slot.end) {
		                return;
		            }
	
		            if (tablesWrap.length && tasksTable.length) {
		                timeOffset += tasksTable.offset().left - tablesWrap.offset().left;
		            }
	
		            element.css({
		                left: timeOffset + "px",
		                top: "0px",
		                width: "1px",
		                height: this._contentHeight + "px"
		            })
		            .appendTo(this.content);
		        },
	
		        _getCurrentTime: function() {
		            // Introduced for testing purposes
		            return new Date();
		        },
	
		        _currentTime: function() {
		            var markerOptions = this.options.currentTimeMarker;
	
		            if (markerOptions !== false && markerOptions.updateInterval !== undefined) {
		                this._renderCurrentTime();
		                this._currentTimeUpdateTimer = setInterval(proxy(this._renderCurrentTime, this), markerOptions.updateInterval);
		            }
		        }
		    });
	
		    extend(true, GanttView, { styles: viewStyles });
	
		    kendo.ui.GanttDayView = GanttView.extend({
		        name: "day",
	
		        options: {
		            timeHeaderTemplate: TIME_HEADER_TEMPLATE,
		            dayHeaderTemplate: DAY_HEADER_TEMPLATE,
		            resizeTooltipFormat: "h:mm tt ddd, MMM d"
		        },
	
		        range: function(range) {
		            var optionsRange = this.options.range;
		            this.start = kendo.date.getDate(range.start);
		            this.end = kendo.date.getDate(range.end);
	
		            if (kendo.date.getMilliseconds(range.end) > 0 || this.end.getTime() === this.start.getTime()) {
		                this.end = kendo.date.addDays(this.end, 1);
		            }
	
		            if (optionsRange && optionsRange.start) {
		                this.start = kendo.date.getDate(optionsRange.start);
		                this.start.setHours(optionsRange.start.getHours());
		            }
	
		            if (optionsRange && optionsRange.end) {
		                this.end = kendo.date.getDate(optionsRange.end);
		                this.end.setHours(optionsRange.end.getHours());
		            }
		        },
	
		        _createSlots: function() {
		            var daySlots;
		            var daySlot;
		            var hourSlots;
		            var hours;
		            var slots = [];
	
		            daySlots = this._days(this.start, this.end);
		            hourSlots = [];
	
		            for (var i = 0, l = daySlots.length; i < l; i++) {
		                daySlot = daySlots[i];
		                hours = this._hours(daySlot.start, daySlot.end);
	
		                daySlot.span = hours.length;
	
		                hourSlots.push.apply(hourSlots, hours);
		            }
	
		            slots.push(daySlots);
		            slots.push(hourSlots);
	
		            return slots;
		        },
	
		        _layout: function() {
		            var rows = [];
		            var options = this.options;
	
		            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.dayHeaderTemplate)));
		            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.timeHeaderTemplate)));
	
		            return rows;
		        }
		    });
	
		    kendo.ui.GanttWeekView = GanttView.extend({
		        name: "week",
	
		        options: {
		            dayHeaderTemplate: DAY_HEADER_TEMPLATE,
		            weekHeaderTemplate: WEEK_HEADER_TEMPLATE,
		            resizeTooltipFormat: "h:mm tt ddd, MMM d"
		        },
	
		        range: function(range) {
		            var optionsRange = this.options.range;
		            var calendarInfo = this.calendarInfo();
		            var firstDay = calendarInfo.firstDay;
		            var rangeEnd = range.end;
		            var endDay;
	
		            if (firstDay === rangeEnd.getDay()) {
		                rangeEnd.setDate(rangeEnd.getDate() + 7);
		            }
	
		            this.start = kendo.date.getDate(kendo.date.dayOfWeek(range.start, firstDay, -1));
		            this.end = kendo.date.getDate(kendo.date.dayOfWeek(rangeEnd, firstDay, 1));
	
		            if (optionsRange && optionsRange.start) {
		                this.start = kendo.date.getDate(optionsRange.start);
		            }
	
		            if (optionsRange && optionsRange.end) {
		                endDay = new Date(optionsRange.end);
	
		                if (kendo.date.getDate(endDay) < optionsRange.end) {
		                    this.end = kendo.date.getDate(new Date(endDay.setDate(endDay.getDate() + 1)));
		                } else {
		                    this.end = kendo.date.getDate(endDay);
		                }
		            }
		        },
	
		        _createSlots: function() {
		            var slots = [];
	
		            slots.push(this._weeks(this.start, this.end));
		            slots.push(this._days(this.start, this.end));
	
		            return slots;
		        },
	
		        _layout: function() {
		            var rows = [];
		            var options = this.options;
	
		            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.weekHeaderTemplate)));
		            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.dayHeaderTemplate)));
	
		            return rows;
		        }
		    });
	
		    kendo.ui.GanttMonthView = GanttView.extend({
		        name: "month",
	
		        options: {
		            weekHeaderTemplate: WEEK_HEADER_TEMPLATE,
		            monthHeaderTemplate: MONTH_HEADER_TEMPLATE,
		            resizeTooltipFormat: "dddd, MMM d, yyyy"
		        },
	
		        range: function(range) {
		            var optionsRange = this.options.range;
		            var endDay;
		            this.start = kendo.date.firstDayOfMonth(range.start);
		            this.end = kendo.date.addDays(kendo.date.getDate(kendo.date.lastDayOfMonth(range.end)), 1);
	
		            if (optionsRange && optionsRange.start) {
		                this.start = kendo.date.getDate(optionsRange.start);
		            }
	
		            if (optionsRange && optionsRange.end) {
		                endDay = new Date(optionsRange.end);
	
		                if (kendo.date.getDate(endDay) < optionsRange.end) {
		                    this.end = kendo.date.getDate(new Date(endDay.setDate(endDay.getDate() + 1)));
		                } else {
		                    this.end = kendo.date.getDate(endDay);
		                }
		            }
		        },
	
		        _createSlots: function() {
		            var slots = [];
	
		            slots.push(this._months(this.start, this.end));
		            slots.push(this._weeks(this.start, this.end));
	
		            return slots;
		        },
	
		        _layout: function() {
		            var rows = [];
		            var options = this.options;
	
		            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.monthHeaderTemplate)));
		            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.weekHeaderTemplate)));
	
		            return rows;
		        }
		    });
	
		    kendo.ui.GanttYearView = GanttView.extend({
		        name: "year",
	
		        options: {
		            yearHeaderTemplate: YEAR_HEADER_TEMPLATE,
		            monthHeaderTemplate: MONTH_HEADER_TEMPLATE,
		            resizeTooltipFormat: "dddd, MMM d, yyyy"
		        },
	
		        range: function(range) {
		            var optionsRange = this.options.range;
		            var firstDayOfMonth;
		            this.start = kendo.date.firstDayOfMonth(new Date(range.start.setMonth(0)));
		            this.end = kendo.date.firstDayOfMonth(new Date(range.end.setMonth(12))); //set month to first month of next year
	
		            if (optionsRange && optionsRange.start) {
		                this.start = kendo.date.firstDayOfMonth(optionsRange.start);
		            }
	
		            if (optionsRange && optionsRange.end) {
		                firstDayOfMonth = kendo.date.firstDayOfMonth(optionsRange.end);
	
		                this.end = kendo.date.getDate(new Date(firstDayOfMonth.setMonth(firstDayOfMonth.getMonth() + 1)));
		            }
		        },
	
		        _createSlots: function() {
		            var slots = [];
		            var monthSlots = this._months(this.start, this.end);
	
		            $(monthSlots).each(function(index, slot) {
		                slot.span = 1;
		            });
	
		            slots.push(this._years(this.start, this.end));
		            slots.push(monthSlots);
	
		            return slots;
		        },
	
		        _layout: function() {
		            var rows = [];
		            var options = this.options;
	
		            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.yearHeaderTemplate)));
		            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.monthHeaderTemplate)));
	
		            return rows;
		        }
		    });
	
		    var timelineStyles = {
		        wrapper: "k-timeline k-grid k-widget",
		        gridHeader: "k-grid-header",
		        gridHeaderWrap: "k-grid-header-wrap",
		        gridContent: "k-grid-content",
		        gridContentWrap: "k-grid-content",
		        tasksWrapper: "k-gantt-tables",
		        dependenciesWrapper: "k-gantt-dependencies",
		        task: "k-task",
		        line: "k-line",
		        taskResizeHandle: "k-resize-handle",
		        taskResizeHandleWest: "k-resize-w",
		        taskDragHandle: "k-task-draghandle",
		        taskComplete: "k-task-complete",
		        taskDelete: "k-task-delete",
		        taskWrapActive: "k-task-wrap-active",
		        taskWrap: "k-task-wrap",
		        taskDot: "k-task-dot",
		        taskDotStart: "k-task-start",
		        taskDotEnd: "k-task-end",
		        hovered: "k-state-hover",
		        selected: "k-state-selected",
		        origin: "k-origin"
		    };
	
		    var GanttTimeline = kendo.ui.GanttTimeline = Widget.extend({
		        init: function(element, options) {
	
		            Widget.fn.init.call(this, element, options);
	
		            if (!this.options.views || !this.options.views.length) {
		                this.options.views = ["day", "week", "month"];
		            }
	
		            isRtl = kendo.support.isRtl(element);
	
		            this._wrapper();
	
		            this._domTrees();
	
		            this._views();
	
		            this._selectable();
	
		            this._draggable();
	
		            this._resizable();
	
		            this._percentResizeDraggable();
	
		            this._createDependencyDraggable();
	
		            this._attachEvents();
	
		            this._tooltip();
		        },
	
		        options: {
		            name: "GanttTimeline",
		            messages: {
		                views: {
		                    day: "Day",
		                    week: "Week",
		                    month: "Month",
		                    year: "Year",
		                    start: "Start",
		                    end: "End"
		                }
		            },
		            snap: true,
		            selectable: true,
		            editable: true
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            clearTimeout(this._tooltipTimeout);
	
		            if (this._currentTimeUpdateTimer) {
		                clearInterval(this._currentTimeUpdateTimer);
		            }
	
		            this._unbindView(this._selectedView);
	
		            if (this._moveDraggable) {
		                this._moveDraggable.destroy();
		            }
	
		            if (this._resizeDraggable) {
		                this._resizeDraggable.destroy();
		            }
	
		            if (this._percentDraggable) {
		                this._percentDraggable.destroy();
		            }
	
		            if (this._dependencyDraggable) {
		                this._dependencyDraggable.destroy();
		            }
	
		            if (this.touch) {
		                this.touch.destroy();
		            }
	
		            this._headerTree = null;
		            this._taskTree = null;
		            this._dependencyTree = null;
	
		            this.wrapper.off(NS);
	
		            kendo.destroy(this.wrapper);
		        },
	
		        _wrapper: function() {
		            var styles = GanttTimeline.styles;
		            var that = this;
		            var options = this.options;
		            var calculateSize = function () {
		                var rowHeight = typeof options.rowHeight === STRING ? options.rowHeight :
		                    options.rowHeight + "px";
		                var table = $(kendo.format(SIZE_CALCULATION_TEMPLATE, rowHeight));
		                var calculatedRowHeight;
		                var calculatedCellHeight;
		                var content = that.wrapper.find(DOT + styles.tasksWrapper);
	
		                content.append(table);
	
		                calculatedRowHeight = outerHeight(table.find("tr"));
		                calculatedCellHeight = table.find("td").height();
	
		                table.remove();
	
		                return {
		                    "row": calculatedRowHeight,
		                    "cell": calculatedCellHeight
		                };
		            };
	
		            this.wrapper = this.element
		                .addClass(styles.wrapper)
		                .append("<div class='" + styles.gridHeader + "'><div class='" + styles.gridHeaderWrap + "'></div></div>")
		                .append("<div class='" + styles.gridContentWrap + "'><div class='" + styles.tasksWrapper + "'></div><div class='" + styles.dependenciesWrapper + "'></div></div>");
	
		            if (options.rowHeight) {
		                this._calculatedSize = calculateSize();
		            }
		        },
	
		        _domTrees: function() {
		            var styles = GanttTimeline.styles;
		            var tree = kendo.dom.Tree;
		            var wrapper = this.wrapper;
	
		            this._headerTree = new tree(wrapper.find(DOT + styles.gridHeaderWrap)[0]);
	
		            this._taskTree = new tree(wrapper.find(DOT + styles.tasksWrapper)[0]);
	
		            this._dependencyTree = new tree(wrapper.find(DOT + styles.dependenciesWrapper)[0]);
		        },
	
		        _views: function() {
		            var views = this.options.views;
		            var view;
		            var isSettings;
		            var name;
		            var defaultView;
		            var selected;
	
		            this.views = {};
	
		            for (var i = 0, l = views.length; i < l; i++) {
		                view = views[i];
	
		                isSettings = isPlainObject(view);
	
		                if (isSettings && view.selectable === false) {
		                    continue;
		                }
	
		                name = isSettings ? ((typeof view.type !== "string") ? view.title : view.type) : view;
	
		                defaultView = defaultViews[name];
	
		                if (defaultView) {
		                    if (isSettings) {
		                        view.type = defaultView.type;
		                    }
	
		                    defaultView.title = this.options.messages.views[name];
		                }
	
		                view = extend({ title: name }, defaultView, isSettings ? view : {});
	
		                if (name) {
		                    this.views[name] = view;
	
		                    if (!selected || view.selected) {
		                        selected = name;
		                    }
		                }
		            }
	
		            if (selected) {
		                this._selectedViewName = selected;
		            }
		        },
	
		        view: function(name) {
		            if (name) {
		                this._selectView(name);
	
		                this.trigger("navigate", { view: name, action: "changeView" });
		            }
	
		            return this._selectedView;
		        },
	
		        _selectView: function(name) {
		            if (name && this.views[name]) {
		                if (this._selectedView) {
		                    this._unbindView(this._selectedView);
		                }
	
		                this._selectedView = this._initializeView(name);
		                this._selectedViewName = name;
		            }
		        },
	
		        _viewByIndex: function(index) {
		            var view;
		            var views = this.views;
	
		            for (view in views) {
		                if (!index) {
		                    return view;
		                }
	
		                index--;
		            }
		        },
	
		        _initializeView: function(name) {
		            var view = this.views[name];
	
		            if (view) {
		                var type = view.type;
	
		                if (typeof type === "string") {
		                    type = kendo.getter(view.type)(window);
		                }
	
		                if (type) {
		                    var newRange = {};
		                    extend(newRange, this.options.range, view.range);
	
		                    var newDate = view.date || this.options.date;
	
		                    view = new type(this.wrapper, trimOptions(extend(true, {
		                        headerTree: this._headerTree,
		                        taskTree: this._taskTree,
		                        dependencyTree: this._dependencyTree,
		                        calculatedSize: this._calculatedSize
		                    }, view, this.options, {
		                        date: newDate,
		                        range: newRange
		                    })));
		                } else {
		                    throw new Error("There is no such view");
		                }
		            }
	
		            return view;
		        },
	
		        _unbindView: function(view) {
		            if (view) {
		                view.destroy();
		            }
		        },
	
		        _range: function (tasks) {
		            var startOrder = {
		                field: "start",
		                dir: "asc"
		            };
		            var endOrder = {
		                field: "end",
		                dir: "desc"
		            };
	
		            if (!tasks || !tasks.length) {
		                return { start: new Date(), end: new Date() };
		            }
	
		            var start = new Query(tasks).sort(startOrder).toArray()[0].start || new Date();
		            var end = new Query(tasks).sort(endOrder).toArray()[0].end || new Date();
	
		            return {
		                start: new Date(start),
		                end: new Date(end)
		            };
		        },
	
		        _render: function(tasks) {
		            var view = this.view();
		            var range = this._range(tasks);
		            var date = view.options.date;
	
		            this._tasks = tasks;
	
		            view.range(range);
	
		            view.renderLayout();
	
		            view.render(tasks);
	
		            if (date) {
		                view._scrollToDate(date);
		            }
		        },
	
		        _renderDependencies: function(dependencies) {
		            this.view()._renderDependencies(dependencies);
		        },
	
		        _taskByUid: function(uid) {
		            var tasks = this._tasks;
		            var length = tasks.length;
		            var task;
	
		            for (var i = 0; i < length; i++) {
		                task = tasks[i];
	
		                if (task.uid === uid) {
		                    return task;
		                }
		            }
		        },
	
		        _draggable: function() {
		            var that = this;
		            var element;
		            var task;
		            var currentStart;
		            var startOffset;
		            var snap = this.options.snap;
		            var styles = GanttTimeline.styles;
		            var editable = this.options.editable;
	
		            var cleanUp = function() {
		                that.view()._removeDragHint();
	
		                if (element) {
		                    element.css("opacity", 1);
		                }
	
		                element = null;
		                task = null;
		                that.dragInProgress = false;
		            };
	
		            if (!editable || editable.move === false || editable.update === false) {
		                return;
		            }
	
		            this._moveDraggable = new kendo.ui.Draggable(this.wrapper, {
		                distance: 0,
		                filter: DOT + styles.task,
		                holdToDrag: kendo.support.mobileOS,
		                ignore: DOT + styles.taskResizeHandle
		            });
	
		            this._moveDraggable
		                .bind("dragstart", function(e) {
		                    var view = that.view();
		                    element = e.currentTarget.parent();
		                    task = that._taskByUid(e.currentTarget.attr("data-uid"));
	
		                    if (that.trigger("moveStart", { task: task })) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    currentStart = task.start;
		                    startOffset = view._timeByPosition(e.x.location, snap) - currentStart;
	
		                    view._createDragHint(element);
	
		                    element.css("opacity", 0.5);
	
		                    clearTimeout(that._tooltipTimeout);
		                    that.dragInProgress = true;
		                })
		                .bind("drag", kendo.throttle(function(e) {
		                    if (!that.dragInProgress) {
		                        return;
		                    }
	
		                    var view = that.view();
		                    var date = new Date(view._timeByPosition(e.x.location, snap) - startOffset);
		                    var updateHintDate = date;
	
		                    if (!that.trigger("move", { task: task, start: date })) {
		                        currentStart = date;
	
		                        if (isRtl) {
		                            updateHintDate = new Date(currentStart.getTime() + task.duration());
		                        }
	
		                        view._updateDragHint(updateHintDate);
		                    }
		                }, 15))
		                .bind("dragend", function() {
		                    that.trigger("moveEnd", { task: task, start: currentStart });
	
		                    cleanUp();
		                })
		                .bind("dragcancel", function() {
		                    cleanUp();
		                })
		                .userEvents.bind("select", function() {
		                    blurActiveElement();
		                });
		        },
	
		        _resizable: function() {
		            var that = this;
		            var element;
		            var task;
		            var currentStart;
		            var currentEnd;
		            var resizeStart;
		            var snap = this.options.snap;
		            var styles = GanttTimeline.styles;
		            var editable = this.options.editable;
	
		            var cleanUp = function() {
		                that.view()._removeResizeHint();
		                element = null;
		                task = null;
		                that.dragInProgress = false;
		            };
	
		            if (!editable || editable.resize === false || editable.update === false) {
		                return;
		            }
	
		            this._resizeDraggable = new kendo.ui.Draggable(this.wrapper, {
		                distance: 0,
		                filter: DOT + styles.taskResizeHandle,
		                holdToDrag: false
		            });
	
		            this._resizeDraggable
		                .bind("dragstart", function(e) {
		                    resizeStart = e.currentTarget.hasClass(styles.taskResizeHandleWest);
	
		                    if (isRtl) {
		                        resizeStart = !resizeStart;
		                    }
	
		                    element = e.currentTarget.closest(DOT + styles.task);
	
		                    task = that._taskByUid(element.attr("data-uid"));
	
		                    if (that.trigger("resizeStart", { task: task })) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    currentStart = task.start;
		                    currentEnd = task.end;
	
		                    that.view()._createResizeHint(task);
	
		                    clearTimeout(that._tooltipTimeout);
		                    that.dragInProgress = true;
		                })
		                .bind("drag", kendo.throttle(function(e) {
		                    if (!that.dragInProgress) {
		                        return;
		                    }
	
		                    var view = that.view();
		                    var date = view._timeByPosition(e.x.location, snap, !resizeStart);
	
		                    if (resizeStart) {
		                        if (date < currentEnd) {
		                            currentStart = date;
		                        } else {
		                            currentStart = currentEnd;
		                        }
		                    } else {
		                        if (date > currentStart) {
		                            currentEnd = date;
		                        } else {
		                            currentEnd = currentStart;
		                        }
		                    }
	
		                    if (!that.trigger("resize", { task: task, start: currentStart, end: currentEnd })) {
		                        view._updateResizeHint(currentStart, currentEnd, resizeStart);
		                    }
		                }, 15))
		                .bind("dragend", function() {
		                    that.trigger("resizeEnd", { task: task, resizeStart: resizeStart, start: currentStart, end: currentEnd });
	
		                    cleanUp();
		                })
		                .bind("dragcancel", function() {
		                    cleanUp();
		                })
		                .userEvents.bind("select", function() {
		                    blurActiveElement();
		                });
		        },
	
		        _percentResizeDraggable: function() {
		            var that = this;
		            var task;
		            var taskElement;
		            var taskElementOffset;
		            var timelineOffset;
		            var originalPercentWidth;
		            var maxPercentWidth;
		            var currentPercentComplete;
		            var tooltipTop;
		            var tooltipLeft;
		            var styles = GanttTimeline.styles;
		            var delta;
		            var editable = this.options.editable;
	
		            var cleanUp = function() {
		                that.view()._removePercentCompleteTooltip();
		                taskElement = null;
		                task = null;
		                that.dragInProgress = false;
		            };
	
		            var updateElement = function(width) {
		                taskElement
		                    .find(DOT + styles.taskComplete)
		                    .width(width)
		                    .end()
		                    .siblings(DOT + styles.taskDragHandle)
		                    .css(isRtl ? "right" : "left", width);
		            };
	
		            if (!editable || editable.dragPercentComplete === false || editable.update === false) {
		                return;
		            }
	
		            this._percentDraggable = new kendo.ui.Draggable(this.wrapper, {
		                distance: 0,
		                filter: DOT + styles.taskDragHandle,
		                holdToDrag: false
		            });
	
		            this._percentDraggable
		                .bind("dragstart", function(e) {
		                    if (that.trigger("percentResizeStart")) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    taskElement = e.currentTarget.siblings(DOT + styles.task);
	
		                    task = that._taskByUid(taskElement.attr("data-uid"));
	
		                    currentPercentComplete = task.percentComplete;
	
		                    taskElementOffset = taskElement.offset();
		                    timelineOffset = this.element.offset();
	
		                    originalPercentWidth = taskElement.find(DOT + styles.taskComplete).width();
		                    maxPercentWidth = outerWidth(taskElement);
	
		                    clearTimeout(that._tooltipTimeout);
		                    that.dragInProgress = true;
		                })
		                .bind("drag", kendo.throttle(function(e) {
		                    if (!that.dragInProgress) {
		                        return;
		                    }
	
		                    delta = isRtl ? -e.x.initialDelta : e.x.initialDelta;
	
		                    var currentWidth = Math.max(0, Math.min(maxPercentWidth, originalPercentWidth + delta));
	
		                    currentPercentComplete = Math.round((currentWidth / maxPercentWidth) * 100);
	
		                    updateElement(currentWidth);
	
		                    tooltipTop = taskElementOffset.top - timelineOffset.top;
		                    tooltipLeft = taskElementOffset.left + currentWidth - timelineOffset.left;
	
		                    if (isRtl) {
		                        tooltipLeft += (maxPercentWidth - 2 * currentWidth);
		                    }
	
		                    that.view()._updatePercentCompleteTooltip(tooltipTop, tooltipLeft, currentPercentComplete);
		                }, 15))
		                .bind("dragend", function() {
		                    that.trigger("percentResizeEnd", { task: task, percentComplete: currentPercentComplete / 100 });
	
		                    cleanUp();
		                })
		                .bind("dragcancel", function() {
		                    updateElement(originalPercentWidth);
	
		                    cleanUp();
		                })
		                .userEvents.bind("select", function() {
		                    blurActiveElement();
		                });
		        },
	
		        _createDependencyDraggable: function() {
		            var that = this;
		            var originalHandle;
		            var hoveredHandle = $();
		            var hoveredTask = $();
		            var startX;
		            var startY;
		            var useVML = browser.msie && browser.version < 9;
		            var styles = GanttTimeline.styles;
		            var editable = this.options.editable;
	
		            var cleanUp = function() {
		                originalHandle
		                    .css("display", "")
		                    .removeClass(styles.hovered);
	
		                originalHandle.parent().removeClass(styles.origin);
		                originalHandle = null;
	
		                toggleHandles(false);
	
		                hoveredTask = $();
		                hoveredHandle = $();
	
		                that.view()._removeDependencyDragHint();
	
		                that.dragInProgress = false;
		            };
	
		            var toggleHandles = function(value) {
		                if (!hoveredTask.hasClass(styles.origin)) {
		                    hoveredTask.find(DOT + styles.taskDot).css("display", value ? "block" : "");
		                    hoveredHandle.toggleClass(styles.hovered, value);
		                }
		            };
	
		            if (!editable || editable.dependencyCreate === false) {
		                return;
		            }
	
		            if (useVML && document.namespaces) {
		                document.namespaces.add("kvml", "urn:schemas-microsoft-com:vml", "#default#VML");
		            }
	
		            this._dependencyDraggable = new kendo.ui.Draggable(this.wrapper, {
		                distance: 0,
		                filter: DOT + styles.taskDot,
		                holdToDrag: false
		            });
	
		            this._dependencyDraggable
		                .bind("dragstart", function(e) {
		                    if (that.trigger("dependencyDragStart")) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    originalHandle = e.currentTarget
		                        .css("display", "block")
		                        .addClass(styles.hovered);
	
		                    originalHandle.parent().addClass(styles.origin);
	
		                    var elementOffset = originalHandle.offset();
		                    var tablesOffset = that.wrapper.find(DOT + styles.tasksWrapper).offset();
	
		                    startX = Math.round(elementOffset.left - tablesOffset.left + (outerHeight(originalHandle) / 2));
		                    startY = Math.round(elementOffset.top - tablesOffset.top + (outerWidth(originalHandle) / 2));
	
		                    clearTimeout(that._tooltipTimeout);
		                    that.dragInProgress = true;
		                })
		                .bind("drag", kendo.throttle(function(e) {
		                    if (!that.dragInProgress) {
		                        return;
		                    }
	
		                    that.view()._removeDependencyDragHint();
	
		                    var target = $(kendo.elementUnderCursor(e));
		                    var tablesOffset = that.wrapper.find(DOT + styles.tasksWrapper).offset();
		                    var currentX = e.x.location - tablesOffset.left;
		                    var currentY = e.y.location - tablesOffset.top;
	
		                    that.view()._updateDependencyDragHint({ x: startX, y: startY }, { x: currentX, y: currentY }, useVML);
	
		                    toggleHandles(false);
	
		                    hoveredHandle = (target.hasClass(styles.taskDot)) ? target : $();
		                    hoveredTask = target.closest(DOT + styles.taskWrap);
	
		                    toggleHandles(true);
		                }, 15))
		                .bind("dragend", function() {
		                    if (hoveredHandle.length) {
		                        var fromStart = originalHandle.hasClass(styles.taskDotStart);
		                        var toStart = hoveredHandle.hasClass(styles.taskDotStart);
	
		                        var type = fromStart ? (toStart ? 3 : 2) : (toStart ? 1 : 0);
	
		                        var predecessor = that._taskByUid(originalHandle.siblings(DOT + styles.task).attr("data-uid"));
		                        var successor = that._taskByUid(hoveredHandle.siblings(DOT + styles.task).attr("data-uid"));
	
		                        if (predecessor !== successor) {
		                            that.trigger("dependencyDragEnd", { type: type, predecessor: predecessor, successor: successor });
		                        }
		                    }
	
		                    cleanUp();
		                })
		                .bind("dragcancel", function() {
		                    cleanUp();
		                })
		                .userEvents.bind("select", function() {
		                    blurActiveElement();
		                });
		        },
	
		        _selectable: function() {
		            var that = this;
		            var styles = GanttTimeline.styles;
	
		            if (this.options.selectable) {
		                this.wrapper
		                    .on(CLICK + NS, DOT + styles.task, function(e) {
		                        e.stopPropagation();
	
		                        if (!e.ctrlKey) {
		                            that.trigger("select", { uid: $(this).attr("data-uid") });
		                        } else {
		                            that.trigger("clear");
		                        }
		                    })
		                    .on(CLICK + NS, DOT + styles.taskWrap, function(e) {
		                        e.stopPropagation();
	
		                        // Decrease z-index of wrap so the we can get to the
		                        // dependency line underneath, if there is any
		                        $(this).css("z-index", "0");
	
		                        var target = $(document.elementFromPoint(e.clientX, e.clientY));
	
		                        if (target.hasClass(styles.line)) {
		                            target.click();
		                        }
	
		                        $(this).css("z-index", "");
		                    })
		                    .on(CLICK + NS, DOT + styles.tasksWrapper, function() {
		                        if (that.selectDependency().length > 0) {
		                            that.clearSelection();
		                        } else {
		                            that.trigger("clear");
		                        }
		                    })
		                    .on(CLICK + NS, DOT + styles.line, function(e) {
		                        e.stopPropagation();
	
		                        that.selectDependency(this);
		                    });
		            }
		        },
	
		        select: function(value) {
		            var element = this.wrapper.find(value);
		            var styles = GanttTimeline.styles;
	
		            if (element.length) {
		                this.clearSelection();
	
		                element.addClass(styles.selected);
	
		                if (kendo.support.mobileOS) {
		                    element.parent().addClass(styles.taskWrapActive);
		                }
	
		                return;
		            }
	
		            return this.wrapper.find(DOT + styles.task + DOT + styles.selected);
		        },
	
		        selectDependency: function(value) {
		            var element = this.wrapper.find(value);
		            var uid;
		            var styles = GanttTimeline.styles;
	
		            if (element.length) {
		                this.clearSelection();
		                this.trigger("clear");
	
		                uid = $(element).attr("data-uid");
	
		                this.wrapper.find(DOT + styles.line + "[data-uid='" + uid + "']").addClass(styles.selected);
	
		                return;
		            }
	
		            return this.wrapper.find(DOT + styles.line + DOT + styles.selected);
		        },
	
		        clearSelection: function() {
		            var styles = GanttTimeline.styles;
	
		            this.wrapper
		                .find(DOT + styles.selected)
		                .removeClass(styles.selected);
	
		            if (kendo.support.mobileOS) {
		                this.wrapper
		                    .find(DOT + styles.taskWrapActive)
		                    .removeClass(styles.taskWrapActive);
		            }
		        },
	
		        _attachEvents: function() {
		            var that = this;
		            var styles = GanttTimeline.styles;
		            var editable = this.options.editable;
	
		            if (editable) {
		                this._tabindex();
	
		                this.wrapper
		                    .on(CLICK + NS, DOT + styles.taskDelete, function(e) {
		                        that.trigger("removeTask", { uid: $(this).closest(DOT + styles.task).attr("data-uid") });
		                        e.stopPropagation();
		                        e.preventDefault();
		                    })
		                    .on(KEYDOWN + NS, function(e) {
		                        var selectedDependency;
		                        var editable = that.options.editable;
	
		                        if (e.keyCode === keys.DELETE && editable && editable.dependencyDestroy !== false) {
		                            selectedDependency = that.selectDependency();
	
		                            if (selectedDependency.length) {
		                                that.trigger("removeDependency", { uid: selectedDependency.attr("data-uid") });
		                                that.clearSelection();
		                            }
		                        }
		                    });
	
		                if (!kendo.support.mobileOS) {
		                    this.wrapper
		                        .on(DBLCLICK + NS, DOT + styles.task, function(e) {
		                            if (that.options.editable.update !== false) {
		                                that.trigger("editTask", { uid: $(this).attr("data-uid") });
	
		                                e.stopPropagation();
		                                e.preventDefault();
		                            }
		                        });
		                } else {
		                    this.touch = this.wrapper
		                        .kendoTouch({
		                            filter: DOT + styles.task,
		                            doubletap: function(e) {
		                                if (that.options.editable.update !== false) {
		                                    that.trigger("editTask", { uid: $(e.touch.currentTarget).attr("data-uid") });
		                                }
		                            }
		                        }).data("kendoTouch");
		                }
		            }
		        },
	
		        _tooltip: function() {
		            var that = this;
		            var tooltipOptions = this.options.tooltip;
		            var styles = GanttTimeline.styles;
		            var currentMousePosition;
		            var mouseMoveHandler = function(e) {
		                currentMousePosition = e.clientX;
		            };
	
		            if (tooltipOptions && tooltipOptions.visible === false) {
		                return;
		            }
	
		            if (!kendo.support.mobileOS) {
		                this.wrapper
		                        .on(MOUSEENTER + NS, DOT + styles.task, function() {
		                            var element = this;
		                            var task = that._taskByUid($(this).attr("data-uid"));
	
		                            if (that.dragInProgress) {
		                                return;
		                            }
	
		                            that._tooltipTimeout = setTimeout(function() {
		                                that.view()._createTaskTooltip(task, element, currentMousePosition);
		                            }, 800);
	
		                            $(this).on(MOUSEMOVE, mouseMoveHandler);
		                        })
		                        .on(MOUSELEAVE + NS, DOT + styles.task, function() {
		                            clearTimeout(that._tooltipTimeout);
	
		                            that.view()._removeTaskTooltip();
	
		                            $(this).off(MOUSEMOVE, mouseMoveHandler);
		                        });
		            } else {
		                this.wrapper
		                    .on(CLICK + NS, DOT + styles.taskDelete, function(e) {
		                        e.stopPropagation();
		                        that.view()._removeTaskTooltip();
		                    })
		                    .on(MOUSELEAVE + NS, DOT + styles.task, function(e) {
		                        var parents = $(e.relatedTarget).parents(DOT + styles.taskWrap, DOT + styles.task);
	
		                        if (parents.length === 0) {
		                            that.view()._removeTaskTooltip();
		                        }
		                    });
	
		                if (this.touch) {
		                    this.touch
		                        .bind("tap", function(e) {
		                            var element = e.touch.target;
		                            var task = that._taskByUid($(element).attr("data-uid"));
		                            var currentPosition = e.touch.x.client;
	
		                            if (that.view()._taskTooltip) {
		                                that.view()._removeTaskTooltip();
		                            }
	
		                            that.view()._createTaskTooltip(task, element, currentPosition);
		                        })
		                        .bind("doubletap", function() {
		                            that.view()._removeTaskTooltip();
		                        });
		                }
		            }
		        }
	
		    });
	
		    extend(true, GanttTimeline, { styles: timelineStyles });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1196);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1028:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(578);
	
	/***/ }),
	
	/***/ 1041:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(609);
	
	/***/ }),
	
	/***/ 1137:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(593);
	
	/***/ }),
	
	/***/ 1138:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1189:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(610);
	
	/***/ }),
	
	/***/ 1192:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(605);
	
	/***/ }),
	
	/***/ 1194:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(599);
	
	/***/ }),
	
	/***/ 1196:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013), __webpack_require__(1192), __webpack_require__(1194), __webpack_require__(1138), __webpack_require__(1041), __webpack_require__(1198), __webpack_require__(1199), __webpack_require__(1200), __webpack_require__(1028), __webpack_require__(1197), __webpack_require__(1201), __webpack_require__(1137), __webpack_require__(1202), __webpack_require__(1203), __webpack_require__(1204), __webpack_require__(1205), __webpack_require__(1206), __webpack_require__(1189) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "grid",
		    name: "Grid",
		    category: "web",
		    description: "The Grid widget displays tabular data and offers rich support for interacting with data,including paging, sorting, grouping, and selection.",
		    depends: [ "data", "columnsorter", "sortable" ],
		    features: [ {
		        id: "grid-editing",
		        name: "Editing",
		        description: "Support for record editing",
		        depends: [ "editable", "window" ]
		    }, {
		        id: "grid-filtering",
		        name: "Filtering",
		        description: "Support for record filtering",
		        depends: [ "filtermenu" ]
		    }, {
		        id: "grid-columnmenu",
		        name: "Column menu",
		        description: "Support for header column menu",
		        depends: [ "columnmenu" ]
		    }, {
		        id: "grid-grouping",
		        name: "Grouping",
		        description: "Support for grid grouping",
		        depends: [ "groupable" ]
		    }, {
		        id: "grid-filtercell",
		        name: "Row filter",
		        description: "Support for grid header filtering",
		        depends: [ "filtercell" ]
		    }, {
		        id: "grid-paging",
		        name: "Paging",
		        description: "Support for grid paging",
		        depends: [ "pager" ]
		    }, {
		        id: "grid-selection",
		        name: "Selection",
		        description: "Support for row selection",
		        depends: [ "selectable" ]
		    }, {
		        id: "grid-column-reorder",
		        name: "Column reordering",
		        description: "Support for column reordering",
		        depends: [ "reorderable" ]
		    }, {
		        id: "grid-column-resize",
		        name: "Column resizing",
		        description: "Support for column resizing",
		        depends: [ "resizable" ]
		    }, {
		        id: "grid-mobile",
		        name: "Grid adaptive rendering",
		        description: "Support for adaptive rendering",
		        depends: [ "mobile.actionsheet", "mobile.pane" ]
		    }, {
		        id: "grid-excel-export",
		        name: "Excel export",
		        description: "Export grid data as Excel spreadsheet",
		        depends: [ "excel" ]
		    }, {
		        id: "grid-pdf-export",
		        name: "PDF export",
		        description: "Export grid data as PDF",
		        depends: [ "pdf", "drawing", "progressbar" ]
		    } ]
		};
	
		/* jshint eqnull: true */
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        DataSource = kendo.data.DataSource,
		        ObservableObject = kendo.data.ObservableObject,
		        tbodySupportsInnerHtml = kendo.support.tbodyInnerHtml,
		        activeElement = kendo._activeElement,
		        Widget = ui.Widget,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        keys = kendo.keys,
	
		        isPlainObject = $.isPlainObject,
		        extend = $.extend,
		        map = $.map,
		        grep = $.grep,
		        isArray = $.isArray,
		        inArray = $.inArray,
		        push = Array.prototype.push,
		        proxy = $.proxy,
		        isFunction = kendo.isFunction,
		        isEmptyObject = $.isEmptyObject,
		        contains = $.contains,
		        math = Math,
	
		        PROGRESS = "progress",
		        ERROR = "error",
		        DATA_CELL = ":not(.k-group-cell):not(.k-hierarchy-cell:not(:has(.k-icon.k-i-collapse,.k-icon.k-i-expand))):visible",
		        SELECTION_CELL_SELECTOR = "tbody>tr:not(.k-grouping-row):not(.k-detail-row):not(.k-group-footer) > td:not(.k-group-cell):not(.k-hierarchy-cell)",
		        NAVROW = "tr:not(.k-footer-template):visible",
		        NAVCELL = ":not(.k-group-cell):not(.k-detail-cell):not(.k-hierarchy-cell):visible",
		        ITEMROW = "tr:not(.k-grouping-row):not(.k-detail-row):not(.k-footer-template):not(.k-group-footer):visible",
		        FIRSTITEMROW = ITEMROW + ":first",
		        LASTITEMROW = ITEMROW + ":last",
		        FIRSTNAVITEM = NAVROW + ":first>" + NAVCELL + ":first",
		        HEADERCELLS = "th.k-header:not(.k-group-cell):not(.k-hierarchy-cell)",
		        NS = ".kendoGrid",
		        CONTENTRLOCKEDCONTAINER = "k-grid-content-locked",
		        GROUPCELLCLASS = "k-group-cell",
	
		        EDIT = "edit",
		        BEFOREEDIT = "beforeEdit",
		        SAVE = "save",
		        REMOVE = "remove",
		        DETAILINIT = "detailInit",
		        FILTERMENUINIT = "filterMenuInit",
		        COLUMNMENUINIT = "columnMenuInit",
		        FILTERMENUOPEN = "filterMenuOpen",
		        COLUMNMENUOPEN = "columnMenuOpen",
		        CELLCLOSE = "cellClose",
		        CHANGE = "change",
		        COLUMNHIDE = "columnHide",
		        COLUMNSHOW = "columnShow",
		        SAVECHANGES = "saveChanges",
		        DATABOUND = "dataBound",
		        DETAILEXPAND = "detailExpand",
		        DETAILCOLLAPSE = "detailCollapse",
		        ITEM_CHANGE = "itemchange",
		        PAGE = "page",
		        PAGING = "paging",
		        SCROLL = "scroll",
		        SYNC = "sync",
	
		        FOCUSED = "k-state-focused",
		        FOCUSABLE = ":kendoFocusable",
		        SELECTED = "k-state-selected",
		        CHECKBOX = "k-checkbox",
		        CHECKBOXINPUT = "input[data-role='checkbox']." + CHECKBOX,
		        NORECORDSCLASS = "k-grid-norecords",
		        RESIZE = "resize",
		        COLUMNRESIZE = "columnResize",
		        COLUMNREORDER = "columnReorder",
		        COLUMNLOCK = "columnLock",
		        COLUMNUNLOCK = "columnUnlock",
		        NAVIGATE = "navigate",
		        CLICK = "click",
		        MOUSEDOWN = "mousedown",
		        HEIGHT = "height",
		        TABINDEX = "tabIndex",
		        FUNCTION = "function",
		        STRING = "string",
		        BOTTOM = "bottom",
		        CONTAINER_FOR = "container-for",
		        FIELD = "field",
		        INPUT = "input",
		        INCELL = "incell",
		        INLINE = "inline",
		        UNIQUE_ID = "uid",
		        MINCOLSPANVALUE = 1,
	
		        DELETECONFIRM = "Are you sure you want to delete this record?",
		        NORECORDS = "No records available.",
		        CONFIRMDELETE = "Delete",
		        CANCELDELETE = "Cancel",
		        COLLAPSE = "Collapse",
		        EXPAND = "Expand",
		        ARIALABEL = "aria-label",
		        formatRegExp = /(\}|\#)/ig,
		        templateHashRegExp = /#/ig,
		        whitespaceRegExp = "[\\x20\\t\\r\\n\\f]",
		        nonDataCellsRegExp = new RegExp("(^|" + whitespaceRegExp + ")" + "(k-group-cell|k-hierarchy-cell)" + "(" + whitespaceRegExp + "|$)"),
		        filterRowRegExp = new RegExp("(^|" + whitespaceRegExp + ")" + "(k-filter-row)" + "(" + whitespaceRegExp + "|$)"),
		        COMMANDBUTTONTMPL = '# if (iconClass) {#' +
		                                '<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#"><span class="#=iconClass#"></span>#=text#</a>' +
		                            '# } else { #' +
		                                '<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#">#=text#</a>' +
		                            '# } #',
		        SELECTCOLUMNTMPL = '# var checkboxGuid = kendo.guid(); #' +
		                            '<input class="' + CHECKBOX + '" data-role="checkbox" id="#= checkboxGuid #" aria-label="Select row" aria-checked="false" type="checkbox">' +
		                            '<label for="#= checkboxGuid #" class="k-checkbox-label k-no-text">&\\#8203;</label>',
		        SELECTCOLUMNHEADERTMPL = '# var checkboxGuid = kendo.guid(); #' +
		                                 '<input class="' + CHECKBOX + '" data-role="checkbox" aria-label="Select all rows" aria-checked="false" type="checkbox" id="#= checkboxGuid #">' +
		                                 '<label for="#= checkboxGuid #" class="k-checkbox-label k-no-text">##&\\#8203;##</label>',
		        isRtl = false,
		        browser = kendo.support.browser,
		        isIE7 = browser.msie && browser.version == 7,
		        isIE8 = browser.msie && browser.version == 8;
		    var isIE11 = browser.msie && browser.version === 11;
		    var isMac = /Mac OS/.test(navigator.userAgent);
	
		    var VirtualScrollable =  Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
		            that._refreshHandler = proxy(that.refresh, that);
		            that.setDataSource(options.dataSource);
		            that.wrap();
		        },
	
		        setDataSource: function(dataSource) {
		            var that = this;
		            if (that.dataSource) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
		            }
		            that.dataSource = dataSource;
		            that.dataSource.bind(CHANGE, that._refreshHandler);
		            that.dataSource.options.useRanges = true;
		        },
	
		        options: {
		            name: "VirtualScrollable",
		            itemHeight: $.noop,
		            prefetch: true,
		            maxScrollHeight: 250000
		        },
	
		        events: [
		            PAGING,
		            PAGE,
		            SCROLL
		        ],
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.dataSource.unbind(CHANGE, that._refreshHandler);
		            that.wrapper.add(that.verticalScrollbar).off(NS);
	
		            clearTimeout(that._timeout);
	
		            if (that.drag) {
		                that.drag.destroy();
		                that.drag = null;
		            }
		            that.wrapper = that.element = that.verticalScrollbar = null;
		            that._refreshHandler = null;
		        },
	
		        wrap: function() {
		            var that = this,
		                // workaround for IE issue where scroll is not raised if container is same width as the scrollbar
		                scrollbar = kendo.support.scrollbar() + 1,
		                element = that.element,
		                wrapper;
	
		            element.css( {
		                width: "auto",
		                overflow: "hidden"
		            }).css((isRtl ? "padding-left" : "padding-right"), scrollbar);
		            that.content = element.children().first();
		            wrapper = that.wrapper = that.content.wrap('<div class="k-virtual-scrollable-wrap"/>')
		                                .parent()
		                                .bind("DOMMouseScroll" + NS + " mousewheel" + NS, proxy(that._wheelScroll, that));
		            that._wrapper();
	
		            if (kendo.support.kineticScrollNeeded) {
		                that.drag = new kendo.UserEvents(that.wrapper, {
		                    global: true,
		                    allowSelection: true,
		                    start: function(e) {
		                        e.sender.capture();
		                    },
		                    move: function(e) {
		                        that.verticalScrollbar.scrollTop(that.verticalScrollbar.scrollTop() - e.y.delta);
		                        wrapper.scrollLeft(wrapper.scrollLeft() - e.x.delta);
		                        e.preventDefault();
		                    }
		                });
		            }
	
		            that.verticalScrollbar = $('<div class="k-scrollbar k-scrollbar-vertical" />')
		                                        .css({
		                                            width: scrollbar
		                                        }).appendTo(element)
		                                        .bind("scroll" + NS, proxy(that._scroll, that));
		        },
	
		        _wrapper: function() {
		            var that = this;
	
		            if (isIE11) {
		                //scrolling the virtual scrollbar to the bottom and then
		                //scrolling the horizontal content scrollbar does not fire the "scroll" event
		                //seems like a problem in IE 11 only (after version 11.0.9600.18860)
		                //https://github.com/telerik/kendo-ui-core/issues/3779
		                that.wrapper.css({
		                    "overflow-y": SCROLL
		                });
	
		                //hide the wrapper behind the virtual scrollbar
		                that.element.css((isRtl ? "padding-left" : "padding-right"), 0);
		            }
		        },
	
		        _wheelScroll: function (e) {
		            if (e.ctrlKey) {
		                return;
		            }
	
		            var scrollbar = this.verticalScrollbar,
		                scrollTop = scrollbar.scrollTop(),
		                delta = kendo.wheelDeltaY(e);
	
		            if (delta && !(delta > 0 && scrollTop === 0) && !(delta < 0 && scrollTop + scrollbar[0].clientHeight == scrollbar[0].scrollHeight)) {
		                e.preventDefault();
		                this.verticalScrollbar.scrollTop(scrollTop + (-delta));
		            }
		        },
	
		        _scroll: function(e) {
		            var that = this,
		                delayLoading = !that.options.prefetch,
		                scrollTop = e.currentTarget.scrollTop,
		                dataSource = that.dataSource,
		                rowHeight = that.itemHeight,
		                skip = dataSource.skip() || 0,
		                start = that._rangeStart || skip,
		                height = that.element.innerHeight(),
		                isScrollingUp = !!(that._scrollbarTop && that._scrollbarTop > scrollTop),
		                firstItemIndex = math.max(math.floor(scrollTop / rowHeight), 0),
		                lastItemOffset = isScrollingUp ? math.ceil(height / rowHeight) : math.floor(height / rowHeight),
		                lastItemIndex = math.max(firstItemIndex + lastItemOffset, 0);
	
		            if (that._preventScroll) {
		                that._preventScroll = false;
		                return;
		            }
	
		            that._scrollTop = scrollTop - (start * rowHeight);
		            that._scrollbarTop = scrollTop;
	
		            that._scrolling = delayLoading;
	
		            if (!that._fetch(firstItemIndex, lastItemIndex, isScrollingUp)) {
		                that.wrapper[0].scrollTop = that._scrollTop;
		            }
	
		            that.trigger(SCROLL);
	
		            if (delayLoading) {
		                if (that._scrollingTimeout) {
		                    clearTimeout(that._scrollingTimeout);
		                }
	
		                that._scrollingTimeout = setTimeout(function() {
		                    that._scrolling = false;
		                    that._page(that._rangeStart, that.dataSource.take());
		                }, 100);
		            }
		        },
	
		        scrollToTop: function() {
		            this._scrollTo(0);
		        },
	
		        scrollToBottom: function() {
		            var scrollbar = this.verticalScrollbar;
		            this._scrollTo(scrollbar[0].scrollHeight - scrollbar.height());
		        },
	
		        _scrollWrapperToTop: function() {
		            this.wrapper.scrollTop(0);
		        },
	
		        _scrollWrapperToBottom: function() {
		            this.wrapper.scrollTop(this.wrapper[0].scrollHeight);
		        },
	
		        _scrollWrapperOnColumnResize: function() {
		            var that = this;
		            var wrapper = this.wrapper;
		            var initialScrollTop = wrapper.scrollTop();
	
		            if (wrapper[0].scrollWidth > wrapper[0].clientWidth) {
		                if (!that._wrapperScrolled || that._isScrolledToBottom()) {
		                    wrapper.scrollTop(initialScrollTop + kendo.support.scrollbar());
		                    that._scrollTop = wrapper.scrollTop();
		                    that._wrapperScrolled = true;
		                }
		            } else if (that._wrapperScrolled) {
		                if (!that._isWrapperScrolledToBottom()) {
		                    wrapper.scrollTop(initialScrollTop - kendo.support.scrollbar());
		                    that._scrollTop = wrapper.scrollTop();
		                }
	
		                that._wrapperScrolled = false;
		            }
		        },
	
		        _scrollTo: function(scrollTop) {
		            var that = this;
		            var scrollbar = that.verticalScrollbar;
	
		            if (scrollbar.scrollTop() !== scrollTop) {
		                that._preventScroll = true;
		            }
	
		            that.wrapper.scrollTop(scrollTop);
		            that._scrollTop = that.wrapper.scrollTop();
	
		            scrollbar.scrollTop(scrollTop);
		            that._scrollbarTop = scrollbar.scrollTop();
		        },
	
		        _isScrolledToTop: function() {
		            return this.verticalScrollbar.scrollTop() === 0;
		        },
	
		        _isScrolledToBottom: function() {
		            var scrollbar = this.verticalScrollbar;
		            var scrollTop = scrollbar.scrollTop();
	
		            return (scrollTop > 0 && scrollTop >= parseInt(scrollbar[0].scrollHeight - scrollbar.height(), 10));
		        },
	
		        _isWrapperScrolledToBottom: function() {
		            var wrapper = this.wrapper;
	
		            return (wrapper.scrollTop() >= parseInt(wrapper[0].scrollHeight - wrapper.height(), 10));
		        },
	
		        itemIndex: function(rowIndex) {
		            var rangeStart = this._rangeStart || this.dataSource.skip() || 0;
	
		            return rangeStart + rowIndex;
		        },
	
		        _isElementVisible: function(element) {
		            return this._isElementVisibleInWrapper(element);
		        },
	
		        _isElementVisibleInWrapper: function(element) {
		            var that = this;
		            var wrapper = that.wrapper;
		            var offsetTop;
		            var halfHeight;
	
		            element = $(element);
	
		            if (element[0] && contains(wrapper[0], element[0])) {
		                offsetTop = element.offset().top - wrapper.offset().top;
		                halfHeight = element.outerHeight() / 2;
	
		                if ((offsetTop >= 0 || math.abs(offsetTop) <= halfHeight) && (math.floor(offsetTop + halfHeight) <= wrapper.height())) {
		                    return true;
		                }
		            }
	
		            return false;
		        },
	
		        position: function(index) {
		            var rangeStart = this._rangeStart || this.dataSource.skip() || 0;
		            var pageSize = this.dataSource.pageSize();
		            var result;
	
		            if (index > rangeStart) {
		                result = index - rangeStart + 1;
		            } else {
		                result = rangeStart - index - 1;
		            }
	
		            return result > pageSize ? pageSize : result;
		        },
	
		        scrollIntoView: function(row) {
		            var container = this.wrapper[0];
		            var containerHeight = container.clientHeight;
		            var containerScroll = !this._isScrolledToBottom() ? (this._scrollTop || container.scrollTop) : container.scrollTop;
		            var elementOffset = row[0].offsetTop;
		            var elementHeight = row[0].offsetHeight;
	
		            if (containerScroll > elementOffset) {
		                this.verticalScrollbar[0].scrollTop -= containerHeight / 2;
		            } else if (elementOffset + elementHeight >=  containerScroll + containerHeight) {
		                this.verticalScrollbar[0].scrollTop += containerHeight / 2;
		            }
		        },
	
		        _fetch: function(firstItemIndex, lastItemIndex, scrollingUp) {
		            var that = this,
		                dataSource = that.dataSource,
		                itemHeight = that.itemHeight,
		                take = dataSource.take(),
		                rangeStart = that._rangeStart || dataSource.skip() || 0,
		                currentSkip = math.floor(firstItemIndex / take) * take,
		                fetching = false,
		                prefetchAt = 0.33;
		            var scrollbar = that.verticalScrollbar;
		            var webkitCorrection = browser.webkit ? 1 : 0;
	
		            if (firstItemIndex < rangeStart) {
	
		                fetching = true;
		                rangeStart = math.max(0, lastItemIndex - take);
		                that._scrollTop = scrollbar.scrollTop() - (rangeStart * itemHeight);
		                that._page(rangeStart, take);
	
		            } else if (lastItemIndex >= rangeStart + take && !scrollingUp) {
	
		                fetching = true;
		                rangeStart = math.min(firstItemIndex, dataSource.total() - take);
	
		                //ensure the scrollbar can be scrolled to bottom with mouse drag
		                if (scrollbar.scrollTop() >= scrollbar[0].scrollHeight - scrollbar.height() - webkitCorrection) {
		                    that._scrollTop = that.wrapper[0].scrollHeight - that.wrapper.height();
		                } else {
		                    that._scrollTop = itemHeight;
		                }
	
		                that._page(rangeStart, take);
	
		            } else if (!that._fetching && that.options.prefetch) {
	
		                if (firstItemIndex < (currentSkip + take) - take * prefetchAt && firstItemIndex > take) {
		                    dataSource.prefetch(currentSkip - take, take, $.noop);
		                }
		                if (lastItemIndex > currentSkip + take * prefetchAt) {
		                    dataSource.prefetch(currentSkip + take, take, $.noop);
		                }
	
		            }
		            return fetching;
		        },
	
		        fetching: function() {
		            return this._fetching;
		        },
	
		        _page: function(skip, take, callback) {
		            var that = this,
		                delayLoading = !that.options.prefetch,
		                dataSource = that.dataSource;
		            callback = isFunction(callback) ? callback : $.noop;
	
		            if (that.trigger(PAGING, { skip: skip, take: take })) {
		                return;
		            }
	
		            clearTimeout(that._timeout);
		            that._fetching = true;
		            that._rangeStart = skip;
	
		            if (dataSource.inRange(skip, take)) {
		                kendo.ui.progress($(that.wrapper).parent(), true);
	
		                dataSource.range(skip, take, function() {
		                    kendo.ui.progress($(that.wrapper).parent(), false);
		                    callback();
		                    that.trigger(PAGE);
		                });
		            } else {
		                if (!delayLoading) {
		                    kendo.ui.progress(that.wrapper.parent(), true);
		                }
	
		                that._timeout = setTimeout(function() {
		                    if (!that._scrolling) {
	
		                        if (delayLoading) {
		                            kendo.ui.progress(that.wrapper.parent(), true);
		                        }
	
		                        dataSource.range(skip, take, function() {
		                            kendo.ui.progress(that.wrapper.parent(), false);
		                            callback();
		                            that.trigger(PAGE);
		                        });
		                    }
		                }, 100);
		            }
		        },
	
		        repaintScrollbar: function(shouldScrollWrapper) {
		            var that = this,
		                html = "",
		                maxHeight = that.options.maxScrollHeight,
		                dataSource = that.dataSource,
		                scrollbar = !kendo.support.kineticScrollNeeded ? kendo.support.scrollbar() : 0,
		                wrapperElement = that.wrapper[0],
		                totalHeight,
		                idx,
		                itemHeight;
		            var wasScrolledToBottom = that._isScrolledToBottom();
	
		            itemHeight = that.itemHeight = that.options.itemHeight() || 0;
	
		            var addScrollBarHeight = (wrapperElement.scrollWidth > wrapperElement.offsetWidth) ? scrollbar : 0;
	
		            totalHeight = dataSource.total() * itemHeight + addScrollBarHeight;
	
		            for (idx = 0; idx < math.floor(totalHeight / maxHeight) ; idx++) {
		                html += '<div style="width:1px;height:' + maxHeight + 'px"></div>';
		            }
	
		            if (totalHeight % maxHeight) {
		                html += '<div style="width:1px;height:' + (totalHeight % maxHeight) + 'px"></div>';
		            }
	
		            that.verticalScrollbar.html(html);
	
		            if (wasScrolledToBottom && !that._isScrolledToBottom()) {
		                that.scrollToBottom();
		            }
	
		            if (typeof(that._scrollTop) !== "undefined" && !!shouldScrollWrapper) {
		                wrapperElement.scrollTop = that._scrollTop;
		                that._scrollWrapperOnColumnResize();
		            }
		        },
	
		        refresh: function(e) {
		            var that = this,
		                dataSource = that.dataSource,
		                rangeStart = that._rangeStart;
		            var action = (e || {}).action;
		            var shouldScrollWrapper = that._isScrolledToBottom() || !action || (action !== ITEM_CHANGE && action !== REMOVE && action !== SYNC);
	
		            kendo.ui.progress(that.wrapper.parent(), false);
		            clearTimeout(that._timeout);
	
		            that.repaintScrollbar(shouldScrollWrapper);
	
		            if (that.drag) {
		                that.drag.cancel();
		            }
	
		            if (typeof(rangeStart) !== "undefined" && !that._fetching) { // we are rebound from outside local range should be reset
		                if (!action || (action !== SYNC && action !== ITEM_CHANGE)) {
		                    that._rangeStart = dataSource.skip();
		                }
	
		                if (dataSource.page() === 1 && (!action || (action !== SYNC && action !== ITEM_CHANGE))) {
		                    // reset the scrollbar position if datasource is filtered
		                    that.verticalScrollbar[0].scrollTop = 0;
		                }
		            }
	
		            that._fetching = false;
		        }
		    });
	
		    function attrEquals(attrName, attrValue) {
		        return "[" + kendo.attr(attrName) + "=" + attrValue + "]";
		    }
	
		    function groupCells(count) {
		        return new Array(count + 1).join('<td class="k-group-cell">&nbsp;</td>');
		    }
	
		    function stringifyAttributes(attributes) {
		        var attr,
		            result = " ";
	
		        if (attributes) {
		            if (typeof attributes === STRING) {
		                return attributes;
		            }
	
		            for (attr in attributes) {
		                if (attributes[attr] !== '') {
		                    result += attr + '="' + attributes[attr] + '"';
		                }
		            }
		        }
		        return result;
		    }
	
		    var defaultCommands = {
		        create: {
		            text: "Add new record",
		            className: "k-grid-add",
		            iconClass: "k-icon k-i-plus"
		        },
		        cancel: {
		            text: "Cancel changes",
		            className: "k-grid-cancel-changes",
		            iconClass: "k-icon k-i-cancel"
		        },
		        save: {
		            text: "Save changes",
		            className: "k-grid-save-changes",
		            iconClass: "k-icon k-i-check"
		        },
		        destroy: {
		            text: "Delete",
		            className: "k-grid-delete",
		            iconClass: "k-icon k-i-close"
		        },
		        edit: {
		            text: "Edit",
		            className: "k-grid-edit",
		            iconClass: "k-icon k-i-edit"
		        },
		        update: {
		            text: "Update",
		            className: "k-primary k-grid-update",
		            iconClass: "k-icon k-i-check"
		        },
		        canceledit: {
		            text: "Cancel",
		            className: "k-grid-cancel",
		            iconClass: "k-icon k-i-cancel"
		        },
		        excel: {
		            text: "Export to Excel",
		            className: "k-grid-excel",
		            iconClass: "k-icon k-i-file-excel"
		        },
		        pdf: {
		            text: "Export to PDF",
		            className: "k-grid-pdf",
		            iconClass: "k-icon k-i-file-pdf"
		        }
		    };
	
		    function cursor(context, value) {
		        $('th, th .k-grid-filter, th .k-link', context)
		            .add(document.body)
		            .css('cursor', value);
		    }
	
		    function reorder(selector, source, dest, before, count) {
		        var sourceIndex = source;
		        source = $();
		        count = count || 1;
		        for (var idx = 0; idx < count; idx++) {
		            source = source.add(selector.eq(sourceIndex + idx));
		        }
	
		        if (typeof dest == "number") {
		            source[before ? "insertBefore" : "insertAfter"](selector.eq(dest));
		        } else {
		            source.appendTo(dest);
		        }
		    }
	
		    function elements(lockedContent, content, filter) {
		        return $(lockedContent).add(content).find(filter);
		    }
	
		    function attachCustomCommandEvent(context, container, commands) {
		        var idx,
		            length,
		            command,
		            commandName;
	
		        commands = !isArray(commands) ? [commands] : commands;
	
		        for (idx = 0, length = commands.length; idx < length; idx++) {
		            command = commands[idx];
	
		            if (isPlainObject(command) && command.click) {
		                commandName = command.name || command.text;
		                container.on(CLICK + NS, "a.k-grid-" + (commandName || "").replace(/\s/g, ""), { commandName: commandName }, proxy(command.click, context));
		            }
		        }
		    }
	
		    function normalizeColumns(columns, encoded, hide) {
		        return map(columns, function(column) {
		            column = typeof column === STRING ? { field: column } : column;
	
		            var hidden;
	
		            if (!isVisible(column) || hide) {
		                column.attributes = addHiddenStyle(column.attributes);
		                column.footerAttributes = addHiddenStyle(column.footerAttributes);
		                column.headerAttributes = addHiddenStyle(column.headerAttributes);
		                hidden = true;
		            }
	
		            if (column.columns) {
		                column.columns = normalizeColumns(column.columns, encoded, hidden);
		            }
		            var uid = kendo.guid();
		            column.headerAttributes = extend({id: uid}, column.headerAttributes);
		            return extend({ encoded: encoded, hidden: hidden }, column);
		        });
		    }
	
		    function columnParent(column, columns) {
		        var parents = [];
		        columnParents(column, columns, parents);
		        return parents[parents.length - 1];
		    }
	
		    function columnParents(column, columns, parents) {
		        parents = parents || [];
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (column === columns[idx]) {
		                return true;
		            } else if (columns[idx].columns) {
		                var inserted = parents.length;
		                parents.push(columns[idx]);
		                if (!columnParents(column, columns[idx].columns, parents)) {
		                    parents.splice(inserted, parents.length - inserted);
		                } else {
		                    return true;
		                }
		            }
		        }
		        return false;
		    }
	
		    function setColumnVisibility(column, visible) {
		        setVisibility(column, visible, visible);
		    }
	
		    function setVisibility(column, visible, show) {
		        var method = show ? removeHiddenStyle : addHiddenStyle;
		        column.hidden = !visible;
		        column.attributes = method(column.attributes);
		        column.footerAttributes = method(column.footerAttributes);
		        column.headerAttributes = method(column.headerAttributes);
		    }
	
	
		    function setColumnMediaVisibility(column, visible) {
		        setColumnMatchesMedia(column);
		        var hideByMedia = column._hideByMedia;
		        setVisibility(column, visible, hideByMedia ? column.matchesMedia : visible);
		    }
	
		    function setColumnMatchesMedia(column) {
		        column.matchesMedia = columnMatchesMedia(column);
		    }
	
		    function columnMatchesMedia(column) {
		        return column && (isUndefined(column.media) || (!isUndefined(column.media) && kendo.matchesMedia(column.media)));
		    }
	
		    function isCellVisible() {
		        return this.style.display !== "none";
		    }
	
		    function isElementVisible(element) {
		        return $(element)[0].style.display !== "none";
		    }
	
		    function isVisible(column) {
		        return visibleColumns([column]).length > 0;
		    }
	
		    function visibleColumns(columns) {
		        return grep(columns, function(column) {
		            var result = !column.hidden && column.matchesMedia !== false;
	
		            if (result && column.columns) {
		                result = visibleColumns(column.columns).length > 0;
		            }
		            return result;
		        });
		    }
	
		    function columnsWithMedia(columns) {
		        var result = [];
		        var column;
	
		        for (var i = 0; i < columns.length; i++) {
		            column = columns[i];
	
		            if (!isUndefined(column.media)) {
		                if (!isUndefined(column.minScreenWidth)) {
		                    throw new Error("Using 'media' and 'minScreenWidth' options at the same time is not supported.");
		                }
	
		                result.push(column);
		            }
	
		            if (column.columns) {
		                result = result.concat(columnsWithMedia(column.columns));
		            }
		        }
	
		        return result;
		    }
	
		    function isUndefined(value) {
		        return typeof value === "undefined";
		    }
	
		    function toJQuery(elements) {
		        return $(elements).map(function() { return this.toArray(); });
		    }
	
		    function updateCellRowSpan(cell, columns, sourceLockedColumnsCount) {
		        var lockedColumnDepth = depth(lockedColumns(columns));
		        var nonLockedColumnDepth = depth(nonLockedColumns(columns));
	
		        var rowSpan = cell.rowSpan;
		        if (sourceLockedColumnsCount) {
		            if (lockedColumnDepth > nonLockedColumnDepth) {
		                cell.rowSpan = (rowSpan - (lockedColumnDepth - nonLockedColumnDepth)) || 1;
		            } else {
		                cell.rowSpan = rowSpan + (nonLockedColumnDepth - lockedColumnDepth);
		            }
		        } else {
		            if (lockedColumnDepth > nonLockedColumnDepth) {
		                cell.rowSpan = rowSpan + (lockedColumnDepth - nonLockedColumnDepth);
		            } else {
		                cell.rowSpan = (rowSpan - (nonLockedColumnDepth - lockedColumnDepth)) || 1;
		            }
		        }
		    }
	
		    function moveCellsBetweenContainers(sources, target, leafs, columns, container, destination, groups) {
		        var sourcesDepth = depth(sources);
		        var targetDepth = depth([target]);
	
		        if (sourcesDepth > targetDepth) {
		            var groupCells = new Array(groups + 1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>');
		            var rows = destination.children(":not(.k-filter-row)");
		            $(new Array((sourcesDepth - targetDepth) + 1).join("<tr>" + groupCells + "</tr>")).insertAfter(rows.last());
		        }
	
		        addRowSpanValue(destination, sourcesDepth - targetDepth);
	
		        moveCells(leafs, columns, container, destination);
		    }
	
		    function updateCellIndex(thead, columns, offset) {
		        offset = offset || 0;
	
		        var position;
		        var cell;
		        var allColumns = columns;
		        columns = leafColumns(columns);
	
		        var cells = {};
		        var rows = thead.find(">tr:not(.k-filter-row)");
	
		        var filter = function() {
		            var el = $(this);
		            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
		        };
	
		        for (var idx = 0, length = columns.length; idx < length; idx++) {
		            position = columnPosition(columns[idx], allColumns);
	
		            if (!cells[position.row]) {
		                cells[position.row] = rows.eq(position.row)
		                    .find(".k-header")
		                    .filter(filter);
		            }
	
		            cell = cells[position.row].eq(position.cell);
		            cell.attr(kendo.attr("index"), offset + idx);
		        }
	
	
		        return columns.length;
		    }
	
		    function depth(columns) {
		        var result = 1;
		        var max = 0;
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (columns[idx].columns) {
		                var temp = depth(columns[idx].columns);
		                if (temp > max) {
		                    max = temp;
		                }
		            }
		        }
		        return result + max;
		    }
	
		    function moveCells(leafs, columns, container, destination) {
		        var sourcePosition = columnVisiblePosition(leafs[0], columns);
	
		        var ths = container.find(">tr:not(.k-filter-row):eq(" + sourcePosition.row + ")>th.k-header");
	
		        var t = $();
		        var sourceIndex = sourcePosition.cell;
		        var idx;
	
		        for (idx = 0; idx < leafs.length; idx++) {
		            t = t.add(ths.eq(sourceIndex + idx));
		        }
	
		        destination.find(">tr:not(.k-filter-row)").eq(sourcePosition.row).append(t);
	
		        var children = [];
		        for (idx = 0; idx < leafs.length; idx++) {
		            if (leafs[idx].columns) {
		                children = children.concat(leafs[idx].columns);
		            }
		        }
	
		        if (children.length) {
		            moveCells(children, columns, container, destination);
		        }
		    }
	
		    function columnPosition(column, columns, row, cellCounts) {
		        var result;
		        var idx;
	
		        row = row || 0;
		        cellCounts = cellCounts || {};
		        cellCounts[row] = cellCounts[row] || 0;
	
		        for (idx = 0; idx < columns.length; idx++) {
		           if (columns[idx] == column) {
		                result = { cell: cellCounts[row], row: row };
		                break;
		           } else if (columns[idx].columns) {
		               result = columnPosition(column, columns[idx].columns, row + 1, cellCounts);
		               if (result) {
		                    break;
		               }
		           }
	
		           cellCounts[row]++;
		        }
		        return result;
		    }
		    function findParentColumnWithChildren(columns, index, source, rtl) {
		        var target;
		        var locked = !!source.locked;
		        var targetLocked;
	
		        do {
		            target = columns[index];
		            index += rtl ? 1 : -1;
		            targetLocked = !!target.locked;
		        } while(target && index > -1 && index < columns.length && target != source && !target.columns && targetLocked === locked);
	
		        return target;
		    }
	
		    function findReorderTarget(columns, target, source, before, masterColumns) {
		        if (target.columns) {
		            target = target.columns;
		            return target[before ? 0 : target.length - 1];
		        } else {
		            var parent = columnParent(target, columns);
		            var parentColumns;
	
		            if (parent) {
		                parentColumns = parent.columns;
		            } else {
		                parentColumns = columns;
		            }
	
		            var index = inArray(target, parentColumns);
		            if (index === 0 && before) {
		                index++;
		            } else if (index == parentColumns.length - 1 && !before) {
		                index--;
		            } else if (index > 0 || (index === 0 && !before)) {
		                index += before ? -1 : 1;
		            }
	
		            var sourceIndex = inArray(source, parentColumns);
		            target = findParentColumnWithChildren(parentColumns, index, source, sourceIndex > index);
		            var targetIndex = inArray(target, masterColumns);
		            if (target.columns && (!targetIndex || targetIndex === parentColumns.length -1)) {
		                return null;
		            }
	
		            if (target && target != source && target.columns) {
		                return findReorderTarget(columns, target, source, before, masterColumns);
		            }
		        }
		        return null;
		    }
	
		    function columnVisiblePosition(column, columns, row, cellCounts) {
		        var result;
		        var idx;
	
		        row = row || 0;
		        cellCounts = cellCounts || {};
		        cellCounts[row] = cellCounts[row] || 0;
	
		        for (idx = 0; idx < columns.length; idx++) {
		           if (columns[idx] == column) {
		                result = { cell: cellCounts[row], row: row };
		                break;
		           } else if (columns[idx].columns) {
		               result = columnVisiblePosition(column, columns[idx].columns, row + 1, cellCounts);
		               if (result) {
		                    break;
		               }
		           }
	
		           if (!columns[idx].hidden) {
		               cellCounts[row]++;
		           }
		        }
		        return result;
		    }
	
		    function flatColumnsInDomOrder(columns) {
		        var result = flatColumns(lockedColumns(columns));
		        return result.concat(flatColumns(nonLockedColumns(columns)));
		    }
	
		    function targetParentContainerIndex(flatColumns, columns, sourceIndex, targetIndex) {
		        var column = flatColumns[sourceIndex];
		        var target = flatColumns[targetIndex];
	
		        var parent = columnParent(column, columns);
		        columns = parent ? parent.columns : columns;
	
		        return inArray(target, columns);
		    }
	
		    function flatColumns(columns) {
		        var result = [];
		        var children = [];
		        for (var idx = 0; idx < columns.length; idx++) {
		            result.push(columns[idx]);
		            if (columns[idx].columns) {
		                children = children.concat(columns[idx].columns);
		            }
	
		        }
		        if (children.length) {
		            result = result.concat(flatColumns(children));
		        }
		        return result;
		    }
	
		    function hiddenLeafColumnsCount(columns) {
		        var counter = 0;
		        var column;
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            column = columns[idx];
	
		            if (column.columns) {
		                counter += hiddenLeafColumnsCount(column.columns);
		            } else if (column.hidden) {
		                counter++;
		            }
		        }
		        return counter;
		    }
	
		    function columnsWidth(cols) {
		        var colWidth, width = 0;
	
		        for (var idx = 0, length = cols.length; idx < length; idx++) {
		            colWidth = cols[idx].style.width;
		            if (colWidth && colWidth.indexOf("%") == -1) {
		                width += parseInt(colWidth, 10);
		            }
		        }
	
		        return width;
		    }
	
		    function removeRowSpanValue(container, count) {
		        var cells = container.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");
	
		        var rowSpan;
		        for (var idx = 0; idx < cells.length; idx++) {
		            rowSpan = cells[idx].rowSpan;
		            if (rowSpan > 1) {
		                cells[idx].rowSpan = (rowSpan - count) || 1;
		            }
		        }
		    }
	
		    function addRowSpanValue(container, count) {
		        var cells = container.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");
	
		        for (var idx = 0; idx < cells.length; idx++) {
		            cells[idx].rowSpan += count;
		        }
		    }
	
		    function removeEmptyRows(container) {
		        var rows = container.find("tr:not(.k-filter-row)");
	
		        var emptyRowsCount = rows.filter(function() {
		            return !$(this).children().length;
		        }).remove().length;
	
		        var cells = rows.find("th:not(.k-group-cell,.k-hierarchy-cell)");
	
		        for (var idx = 0; idx < cells.length; idx++) {
		            if (cells[idx].rowSpan > 1) {
		                cells[idx].rowSpan -= emptyRowsCount;
		            }
		        }
		        return rows.length - emptyRowsCount;
		    }
	
		    function mapColumnToCellRows(columns, cells, rows, rowIndex, offset) {
		        var idx, row, length, children = [];
	
		        for (idx = 0, length = columns.length; idx < length; idx++) {
		            row = rows[rowIndex] || [];
		            row.push(cells.eq(offset + idx));
		            rows[rowIndex] = row;
	
		            if (columns[idx].columns) {
		                children = children.concat(columns[idx].columns);
		            }
		        }
	
		        if (children.length) {
		            mapColumnToCellRows(children, cells, rows, rowIndex + 1, offset + columns.length);
		        }
		    }
	
		    function lockedColumns(columns) {
		        return grep(columns, function(column) {
		            return column.locked;
		        });
		    }
	
		    function nonLockedColumns(columns) {
		        return grep(columns, function(column) {
		            return !column.locked;
		        });
		    }
	
		    function visibleNonLockedColumns(columns) {
		        return grep(columns, function(column) {
		            return !column.locked && isVisible(column);
		        });
		    }
	
		    function visibleLockedColumns(columns) {
		        return grep(columns, function(column) {
		            return column.locked && isVisible(column);
		        });
		    }
	
		    function visibleLeafColumns(columns) {
		        var result = [];
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (columns[idx].hidden) {
		                continue;
		            }
	
		            if (columns[idx].columns) {
		                result = result.concat(visibleLeafColumns(columns[idx].columns));
		            } else {
		                result.push(columns[idx]);
		            }
		        }
	
		        return result;
		    }
	
		    function leafColumns(columns) {
		        var result = [];
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (!columns[idx].columns) {
		                result.push(columns[idx]);
		                continue;
		            }
		            result = result.concat(leafColumns(columns[idx].columns));
		        }
	
		        return result;
		    }
	
		    function leafDataCells(container) {
		        var rows = container.find(">tr:not(.k-filter-row)");
	
		        var filter = function() {
		            var el = $(this);
		            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
		        };
	
		        var cells = $();
		        if (rows.length > 1) {
		            cells = rows.find("th")
		                .filter(filter)
		                .filter(function() { return this.rowSpan > 1; });
		        }
	
		        cells = cells.add(rows.last().find("th").filter(filter));
	
		        var indexAttr = kendo.attr("index");
		        cells.sort(function(a, b) {
		            a = $(a);
		            b = $(b);
	
		            var indexA = a.attr(indexAttr);
		            var indexB = b.attr(indexAttr);
	
		            if (indexA === undefined) {
		                indexA = $(a).index();
		            }
		            if (indexB === undefined) {
		                indexB = $(b).index();
		            }
	
		            indexA = parseInt(indexA, 10);
		            indexB = parseInt(indexB, 10);
		            return indexA > indexB ? 1 : (indexA < indexB ? -1 : 0);
		        });
	
		        return cells;
		    }
	
		    function parentColumnsCells(cell) {
		        var container = cell.closest("table");
		        var result = $().add(cell);
	
		        var row = cell.closest("tr");
		        var headerRows = container.find("tr:not(.k-filter-row)");
		        var level = headerRows.index(row);
		        if (level > 0) {
		            var parent = headerRows.eq(level - 1);
		            var parentCellsWithChildren = parent.find("th:not(.k-group-cell,.k-hierarchy-cell)").filter(function() {
		                return !$(this).attr("rowspan");
		            });
	
		            var offset = 0;
		            var index = row.find("th:not(.k-group-cell,.k-hierarchy-cell)").index(cell);
	
		            var prevCells = cell.prevAll(":not(.k-group-cell,.k-hierarchy-cell)").filter(function() {
		                return this.colSpan > 1;
		            });
	
		            for (var idx = 0; idx < prevCells.length; idx++) {
		                offset += prevCells[idx].colSpan || 1;
		            }
	
		            index += Math.max(offset - 1, 0);
	
		            offset = 0;
		            for (idx = 0; idx < parentCellsWithChildren.length; idx++) {
		                var parentCell = parentCellsWithChildren.eq(idx);
		                if (parentCell.attr("data-colspan")) {
		                    offset += parentCell[0].getAttribute("data-colspan");
		                } else {
		                    offset += 1;
		                }
		                if (index >= idx && index < offset) {
		                    result = parentColumnsCells(parentCell).add(result);
		                    break;
		                }
		            }
		        }
		        return result;
		    }
	
		    function childColumnsCells(cell) {
		        var container = cell.closest("thead");
		        var result = $().add(cell);
	
		        var row = cell.closest("tr");
		        var headerRows = container.find("tr:not(.k-filter-row)");
		        var level = headerRows.index(row) + cell[0].rowSpan;
		        var colSpanAttr = kendo.attr("colspan");
	
		        if (level <= headerRows.length - 1) {
		            var child = row.next();
		            var prevCells = cell.prevAll(":not(.k-group-cell,.k-hierarchy-cell)");
	
		            var idx;
	
		            prevCells = prevCells.filter(function() {
		                return !this.rowSpan || this.rowSpan === 1;
		            });
	
		            var offset = 0;
	
		            for (idx = 0; idx < prevCells.length; idx++) {
		                offset += parseInt(prevCells.eq(idx).attr(colSpanAttr), 10) || 1;
		            }
	
		            var cells = child.find("th:not(.k-group-cell,.k-hierarchy-cell)");
		            var colSpan = parseInt(cell.attr(colSpanAttr), 10) || 1;
	
		            idx = 0;
	
		            while (idx < colSpan) {
		                child = cells.eq(idx + offset);
		                result = result.add(childColumnsCells(child));
		                var value = parseInt(child.attr(colSpanAttr), 10);
		                if (value > 1) {
		                    colSpan -= value - 1;
		                }
		                idx++;
		            }
		        }
	
		        return result;
		    }
	
		    function appendContent(tbody, table, html, empty) {
		        var placeholder,
		            tmp = tbody;
	
		        // necessary for AngularJS to cleanup its guts.
		        if (empty) {
		            tbody.empty();
		        }
	
		        if (tbodySupportsInnerHtml) {
		            tbody[0].innerHTML = html;
		        } else {
		            placeholder = document.createElement("div");
		            placeholder.innerHTML = "<table><tbody>" + html + "</tbody></table>";
		            tbody = placeholder.firstChild.firstChild;
		            table[0].replaceChild(tbody, tmp[0]);
		            tbody = $(tbody);
		        }
		        return tbody;
		    }
	
		    function addHiddenStyle(attr) {
		        attr = attr || {};
		        var style = attr.style;
	
		        if(!style) {
		            style = "display:none";
		        } else {
		            style = style.replace(/((.*)?display)(.*)?:([^;]*)/i, "$1:none");
		            if(style === attr.style) {
		                style = style.replace(/(.*)?/i, "display:none;$1");
		            }
		        }
	
		        return extend({}, attr, { style: style });
		    }
	
		    function removeHiddenStyle(attr) {
		        attr = attr || {};
		        var style = attr.style;
	
		        if(style) {
		            attr.style = style.replace(/(display\s*:\s*none\s*;?)*/ig, "");
		        }
	
		        return attr;
		    }
	
		    function normalizeCols(table, visibleColumns, hasDetails, groups) {
		        var colgroup = table.find(">colgroup"),
		            width,
		            cols = map(visibleColumns, function(column) {
		                    width = column.width;
		                    if (width && parseInt(width, 10) !== 0) {
		                        return kendo.format('<col style="width:{0}"/>', typeof width === STRING? width : width + "px");
		                    }
	
		                    return "<col />";
		                });
	
		        if (hasDetails || colgroup.find(".k-hierarchy-col").length) {
		            cols.splice(0, 0, '<col class="k-hierarchy-col" />');
		        }
	
		        if (colgroup.length) {
		            colgroup.remove();
		        }
	
		        colgroup = $(new Array(groups + 1).join('<col class="k-group-col">') + cols.join(""));
		        if (!colgroup.is("colgroup")) {
		            colgroup = $("<colgroup/>").append(colgroup);
		        }
	
		        table.prepend(colgroup);
	
		        // fill gap after column hiding
		        if (browser.msie && browser.version == 8) {
		            table.css("display", "inline-table");
		            window.setTimeout(function(){table.css("display", "");}, 1);
		        }
		    }
	
		    function normalizeHeaderCells(container, columns) {
		        var lastIndex = 0;
		        var idx , len;
		        var th = container.find("th:not(.k-group-cell)");
	
		        for (idx = 0, len = columns.length; idx < len; idx ++) {
		            if (columns[idx].locked) {
		                th.eq(idx).insertBefore(th.eq(lastIndex));
		                th = container.find("th:not(.k-group-cell)");
		                lastIndex ++;
		            }
		        }
		    }
	
		    function convertToObject(array) {
		        var result = {},
		            item,
		            idx,
		            length;
	
		        for (idx = 0, length = array.length; idx < length; idx++) {
		            item = array[idx];
		            result[item.value] = item.text;
		        }
	
		        return result;
		    }
	
		    function formatGroupValue(value, format, columnValues, encoded) {
		        var isForeignKey = columnValues && columnValues.length && isPlainObject(columnValues[0]) && "value" in columnValues[0],
		            groupValue = isForeignKey ? convertToObject(columnValues)[value] : value;
	
		        groupValue = groupValue != null ? groupValue : "";
	
		        return format ? kendo.format(format, groupValue) : (encoded === false ? groupValue : kendo.htmlEncode(groupValue));
		    }
	
		    function setCellVisibility(cells, index, visible) {
		        var pad = 0,
		            state,
		            cell = cells[pad];
	
		        while (cell) {
		            state = visible ? true : cell.style.display !== "none";
	
		            if (state && !nonDataCellsRegExp.test(cell.className) && --index < 0) {
		                cell.style.display = visible ? "" : "none";
		                break;
		            }
	
		            cell = cells[++pad];
		        }
		    }
	
		    function hideColumnCells(rows, columnIndex) {
		        var idx = 0,
		            length = rows.length,
		            cell, row;
	
		        for ( ; idx < length; idx += 1) {
		            row = rows.eq(idx);
		            if (row.is(".k-grouping-row,.k-detail-row")) {
		                cell = row.children(":not(.k-group-cell):first,.k-detail-cell").last();
		                cell.attr("colspan", parseInt(cell.attr("colspan"), 10) - 1);
		            } else {
		                if (row.hasClass("k-grid-edit-row") && (cell = row.children(".k-edit-container")[0])) {
		                    cell = $(cell);
		                    cell.attr("colspan", parseInt(cell.attr("colspan"), 10) - 1);
		                    cell.find("col").eq(columnIndex).remove();
		                    row = cell.find("tr:first");
		                }
	
		                setCellVisibility(row[0].cells, columnIndex, false);
		            }
		        }
		    }
	
		    function groupRows(data) {
		        var result = [];
		        var item;
	
		        for (var idx = 0; idx < data.length; idx++) {
		            item = data[idx];
		            if (!("field" in item && "value" in item && "items" in item)) {
		                break;
		            }
	
		            result.push(item);
	
		            if (item.hasSubgroups) {
		                result = result.concat(groupRows(item.items));
		            }
		        }
	
		        return result;
		    }
	
		    function groupFooters(data) {
		        var result = [];
		        var item;
	
		        for (var idx = 0; idx < data.length; idx++) {
		            item = data[idx];
		            if (!("field" in item && "value" in item && "items" in item)) {
		                break;
		            }
	
		            if (item.hasSubgroups) {
		                result = result.concat(groupFooters(item.items));
		            }
	
		            result.push(item.aggregates);
		        }
	
		        return result;
		    }
	
		    function showColumnCells(rows, columnIndex) {
		        var idx = 0,
		            length = rows.length,
		            cell, row, columns;
	
		        for ( ; idx < length; idx += 1) {
		            row = rows.eq(idx);
		            if (row.is(".k-grouping-row,.k-detail-row")) {
		                cell = row.children(":not(.k-group-cell):first,.k-detail-cell").last();
		                cell.attr("colspan", parseInt(cell.attr("colspan"), 10) + 1);
		            } else {
		                if (row.hasClass("k-grid-edit-row") && (cell = row.children(".k-edit-container")[0])) {
		                    cell = $(cell);
		                    cell.attr("colspan", parseInt(cell.attr("colspan"), 10) + 1);
		                    normalizeCols(cell.find(">form>table"), visibleColumns(columns), false,  0);
		                    row = cell.find("tr:first");
		                }
	
		                setCellVisibility(row[0].cells, columnIndex, true);
		            }
		        }
		    }
	
		    function updateColspan(toAdd, toRemove, num) {
		        num = num || 1;
	
		        var item, idx, length;
		        for (idx = 0, length = toAdd.length; idx < length; idx++) {
		            item = toAdd.eq(idx).children().last();
		            item.attr("colspan", parseInt(item.attr("colspan"), 10) + num);
	
		            item = toRemove.eq(idx).children().last();
		            item.attr("colspan", parseInt(item.attr("colspan"), 10) - num);
		        }
		    }
	
		    function tableWidth(table) {
		        var idx, length, width = 0;
		        var cols = table.find(">colgroup>col");
	
		        for (idx = 0, length = cols.length; idx < length; idx += 1) {
		            width += parseInt(cols[idx].style.width, 10);
		        }
	
		        return width;
		    }
	
		    var Grid = kendo.ui.DataBoundWidget.extend({
		        init: function(element, options, events) {
		            var that = this;
	
		            options = isArray(options) ? { dataSource: options } : options;
	
		            Widget.fn.init.call(that, element, options);
	
		            if (events) {
		                that._events = events;
		            }
	
		            isRtl = kendo.support.isRtl(element);
	
		            that._element();
	
		            that._aria();
	
		            that._columns($.extend(true, [], that.options.columns));
	
		            that._dataSource();
	
		            that._tbody();
	
		            that._pageable();
	
		            that._thead();
	
		            that._groupable();
	
		            that._toolbar();
	
		            that._setContentHeight();
	
		            that._templates();
	
		            that._navigatable();
	
		            that._selectable();
	
		            that._clipboard();
	
		            that._details();
	
		            that._editable();
	
		            that._attachCustomCommandsEvent();
	
		            that._adaptiveColumns();
	
		            that._minScreenSupport();
	
		            if (that.options.autoBind) {
		                that.dataSource.fetch();
		            } else {
		                that._group = that._groups() > 0;
		                that._footer();
		            }
	
		            if (that.lockedContent) {
		                that.wrapper.addClass("k-grid-lockedcolumns");
		                that._resizeHandler = function()  { that.resize(); };
		                $(window).on("resize" + NS, that._resizeHandler);
		            }
	
		            kendo.notify(that);
		        },
	
		        events: [
		           CHANGE,
		           "dataBinding",
		           "cancel",
		           DATABOUND,
		           DETAILEXPAND,
		           DETAILCOLLAPSE,
		           DETAILINIT,
		           FILTERMENUINIT,
		           FILTERMENUOPEN,
		           COLUMNMENUINIT,
		           COLUMNMENUOPEN,
		           EDIT,
		           BEFOREEDIT,
		           SAVE,
		           REMOVE,
		           SAVECHANGES,
		           CELLCLOSE,
		           COLUMNRESIZE,
		           COLUMNREORDER,
		           COLUMNSHOW,
		           COLUMNHIDE,
		           COLUMNLOCK,
		           COLUMNUNLOCK,
		           NAVIGATE,
		           "page",
		           "sort",
		           "filter",
		           "group",
		           "groupExpand",
		           "groupCollapse"
		        ],
	
		        setDataSource: function(dataSource) {
		            var that = this;
		            var scrollable = that.options.scrollable;
		            var scrollableContent;
	
		            that.options.dataSource = dataSource;
	
		            that._dataSource();
	
		            that._pageable();
	
		            that._thead();
	
		            if (scrollable) {
		                if (scrollable.virtual) {
		                    scrollableContent = that.content.find(">.k-virtual-scrollable-wrap");
		                    scrollableContent.scrollLeft(leftMostPosition(scrollableContent, isRtl));
		                } else {
		                    scrollableContent = that.tbody;
		                    that.content.scrollLeft(leftMostPosition(scrollableContent, isRtl));
		                }
		            }
	
		            if (that.options.groupable) {
		                that._groupable();
		            }
	
		            if (that.virtualScrollable) {
		                that.virtualScrollable.setDataSource(that.options.dataSource);
		            }
	
		            if (that.options.navigatable) {
		                that._navigatable();
		            }
	
		            if (that.options.selectable) {
		                that._selectable();
		            }
	
		            if (that.options.autoBind) {
		                that.dataSource.fetch();
		            }
		        },
	
		        options: {
		            name: "Grid",
		            columns: [],
		            toolbar: null,
		            autoBind: true,
		            filterable: false,
		            scrollable: true,
		            sortable: false,
		            selectable: false,
		            allowCopy: false,
		            navigatable: false,
		            pageable: false,
		            persistSelection: false,
		            editable: false,
		            groupable: false,
		            rowTemplate: "",
		            altRowTemplate: "",
		            noRecords: false,
		            dataSource: {},
		            height: null,
		            resizable: false,
		            reorderable: false,
		            columnMenu: false,
		            detailTemplate: null,
		            columnResizeHandleWidth: 3,
		            mobile: "",
		            messages: {
		                editable: {
		                    cancelDelete: CANCELDELETE,
		                    confirmation: DELETECONFIRM,
		                    confirmDelete: CONFIRMDELETE
		                },
		                commands: {
		                    create: defaultCommands.create.text,
		                    cancel: defaultCommands.cancel.text,
		                    save: defaultCommands.save.text,
		                    destroy: defaultCommands.destroy.text,
		                    edit: defaultCommands.edit.text,
		                    update: defaultCommands.update.text,
		                    canceledit: defaultCommands.canceledit.text,
		                    excel: defaultCommands.excel.text,
		                    pdf: defaultCommands.pdf.text
		                },
		                noRecords: NORECORDS,
		                expandCollapseColumnHeader: "",
		                groupHeader: "Press ctrl + space to group",
		                ungroupHeader: "Press ctrl + space to ungroup"
		            }
		        },
	
		        destroy: function() {
		            var that = this,
		                element;
	
		            that._angularItems("cleanup");
		            that._destroyColumnAttachments();
	
		            Widget.fn.destroy.call(that);
	
		            this._navigatableTables = null;
	
		            if (that._resizeHandler) {
		                $(window).off("resize" + NS, that._resizeHandler);
		            }
	
		            if (that.pager && that.pager.element) {
		                that.pager.destroy();
		            }
	
		            that.pager = null;
	
		            if (that.groupable && that.groupable.element) {
		                that.groupable.element.kendoGroupable("destroy");
		            }
	
		            that.groupable = null;
	
		            if (that.options.reorderable) {
		                that.wrapper.data("kendoReorderable").destroy();
		            }
	
		            if (that.selectable && that.selectable.element) {
		                that.selectable.destroy();
	
		                that.clearArea();
		                that._selectedIds = null;
	
		                if (that.copyHandler) {
		                    that.wrapper.off("keydown", that.copyHandler);
		                    that.unbind(that.copyHandler);
		                }
		                if (that.updateClipBoardState) {
		                    that.unbind(that.updateClipBoardState);
		                    that.updateClipBoardState = null;
		                }
		                if (that.clearAreaHandler) {
		                    that.wrapper.off("keyup", that.clearAreaHandler);
		                }
		            }
	
		            that.selectable = null;
	
		            if (that.resizable) {
		                that.resizable.destroy();
	
		                if (that._resizeUserEvents) {
		                    if (that._resizeHandleDocumentClickHandler) {
		                        $(document).off("click", that._resizeHandleDocumentClickHandler);
		                    }
		                    that._resizeUserEvents.destroy();
		                    that._resizeUserEvents = null;
		                }
		                that.resizable = null;
		            }
	
		            that._destroyVirtualScrollable();
	
		            that._destroyEditable();
	
		            if (that.dataSource) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler)
		                           .unbind(PROGRESS, that._progressHandler)
		                           .unbind(ERROR, that._errorHandler);
	
		                that._refreshHandler = that._progressHandler = that._errorHandler = null;
		            }
	
		            element = that.element
		                .add(that.wrapper)
		                .add(that.table)
		                .add(that.thead)
		                .add(that.wrapper.find(">.k-grid-toolbar"));
	
		            if (that.content) {
		                element = element
		                        .add(that.content)
		                        .add(that.content.find(">.k-virtual-scrollable-wrap"));
		            }
	
		            if (that.lockedHeader) {
		                that._removeLockedContainers();
		            }
	
		            if (that.pane) {
		                that.pane.destroy();
		            }
	
		            if (that.minScreenResizeHandler) {
		                $(window).off("resize", that.minScreenResizeHandler);
		            }
	
		            that._detachColumnMediaResizeHandler();
	
		            if (that._draggableInstance && that._draggableInstance.element) {
		                that._draggableInstance.destroy();
		            }
	
		            that._draggableInstance = null;
	
		            element.off(NS);
	
		            kendo.destroy(that.wrapper);
	
		            that.rowTemplate =
		            that.altRowTemplate =
		            that.lockedRowTemplate =
		            that.lockedAltRowTemplate =
		            that.detailTemplate =
		            that.footerTemplate =
		            that.groupFooterTemplate =
		            that.lockedGroupFooterTemplate =
		            that.noRecordsTemplate = null;
	
		            that.scrollables =
		            that.thead =
		            that.tbody =
		            that.element =
		            that.table =
		            that.content =
		            that.footer =
		            that.wrapper =
		            that.lockedTable =
		            that.lockedContent =
		            that.lockedHeader =
		            that.lockedFooter =
		            that._groupableClickHandler =
		            that._groupRows =
		            that._setContentWidthHandler = null;
		        },
	
		        getOptions: function() {
		            var options = this.options;
		            options.dataSource = null;
	
		            var result = extend(true, {}, this.options);
		            result.columns = kendo.deepExtend([], this.columns);
	
		            var dataSource = this.dataSource;
	
		            var initialData = dataSource.options.data && dataSource._data;
		            dataSource.options.data = null;
	
		            result.dataSource = $.extend(true, {}, dataSource.options);
	
		            dataSource.options.data = initialData;
	
		            result.dataSource.data = initialData;
		            result.dataSource.page = dataSource.page();
		            result.dataSource.filter = dataSource.filter();
		            result.dataSource.pageSize = dataSource.pageSize();
		            result.dataSource.sort = dataSource.sort();
		            result.dataSource.group = dataSource.group();
		            result.dataSource.aggregate = dataSource.aggregate();
	
		            if (result.dataSource.transport) {
		                result.dataSource.transport.dataSource = null;
		            }
	
		            if (result.pageable && result.pageable.pageSize) {
		                result.pageable.pageSize = dataSource.pageSize();
		            }
	
		            result.$angular = undefined;
	
		            return result;
		        },
	
		        setOptions: function(options) {
		            var currentOptions = this.getOptions();
		            kendo.deepExtend(currentOptions, options);
		            if (!options.dataSource) {
		                currentOptions.dataSource = this.dataSource;
		            }
		            var wrapper = this.wrapper;
		            var events = this._events;
		            var element = this.element;
	
		            this.destroy();
		            this.options = null;
		            if (this._isMobile) {
		                var mobileWrapper = wrapper.closest(kendo.roleSelector("pane")).parent();
		                mobileWrapper.after(wrapper);
		                mobileWrapper.remove();
		                wrapper.removeClass("k-grid-mobile");
		            }
		            if (wrapper[0] !== element[0]) {
		                wrapper.before(element);
		                wrapper.remove();
		            }
		            element.empty();
	
		            this.init(element, currentOptions, events);
		            this._setEvents(currentOptions);
		        },
	
		        items: function() {
		            if (this.lockedContent) {
		                return this._items(this.tbody).add(this._items(this.lockedTable.children("tbody")));
		            } else {
		                return this._items(this.tbody);
		            }
		        },
	
		        _items: function(container) {
		            return container.children().filter(function() {
		                var tr = $(this);
		                return !tr.hasClass("k-grouping-row") && !tr.hasClass("k-detail-row") && !tr.hasClass("k-group-footer");
		            });
		        },
	
		        dataItems: function() {
		            var dataItems = kendo.ui.DataBoundWidget.fn.dataItems.call(this);
		            if (this.lockedContent) {
		                var n = dataItems.length, tmp = new Array(2 * n);
		                for (var i = n; --i >= 0;) {
		                    tmp[i] = tmp[i + n] = dataItems[i];
		                }
		                dataItems = tmp;
		            }
	
		            return dataItems;
		        },
	
		        _destroyColumnAttachments: function() {
		            var that = this;
	
		            that.resizeHandle = null;
	
		            if (!that.thead) {
		                return;
		            }
	
		            this.angular("cleanup", function(){
		                return { elements: that.thead.get() };
		            });
	
		            that.thead.add(that.lockedHeader).find("th").each(function(){
		                var th = $(this),
		                    filterMenu = th.data("kendoFilterMenu"),
		                    sortable = th.data("kendoColumnSorter"),
		                    columnMenu = th.data("kendoColumnMenu");
	
		                if (filterMenu) {
		                    filterMenu.destroy();
		                }
	
		                if (sortable) {
		                    sortable.destroy();
		                }
	
		                if (columnMenu) {
		                    columnMenu.destroy();
		                }
		            });
		        },
	
		        _attachCustomCommandsEvent: function() {
		            var that = this,
		                columns = leafColumns(that.columns || []),
		                command,
		                idx,
		                length;
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                command = columns[idx].command;
	
		                if (command) {
		                    attachCustomCommandEvent(that, that.wrapper, command);
		                }
		            }
		        },
	
		        _aria: function() {
		            var id = this.element.attr("id") || "aria";
	
		            if (id) {
		                this._cellId = id + "_active_cell";
		            }
		        },
	
		        _element: function() {
		            var that = this,
		                table = that.element;
	
		            if (!table.is("table")) {
		                if (that.options.scrollable) {
		                    table = that.element.find("> .k-grid-content > table");
		                } else {
		                    table = that.element.children("table");
		                }
	
		                if (!table.length) {
		                    table = $("<table />").appendTo(that.element);
		                }
		            }
	
		            if (isIE7) {
		                table.attr("cellspacing", 0);
		            }
	
		            that.table = table.attr("role", that._hasDetails() ? "treegrid" : "grid");
	
		            that._wrapper();
		        },
	
		        _createResizeHandle: function(container, th) {
		            var that = this;
		            var indicatorWidth = that.options.columnResizeHandleWidth;
		            var scrollable = that.options.scrollable;
		            var resizeHandle = that.resizeHandle;
		            var groups = this._groups();
		            var left;
	
		            if (resizeHandle && that.lockedContent && resizeHandle.data("th")[0] !== th[0]) {
		                resizeHandle.off(NS).remove();
		                resizeHandle = null;
		            }
	
		            if (!resizeHandle) {
		                resizeHandle = that.resizeHandle = $('<div class="k-resize-handle"><div class="k-resize-handle-inner"></div></div>');
		                container.append(resizeHandle);
		            }
	
		            if (!isRtl) {
		                left = th[0].offsetWidth;
	
		                var cells = leafDataCells(th.closest("thead")).filter(":visible");
		                for (var idx = 0; idx < cells.length; idx++) {
		                    if (cells[idx] == th[0]) {
		                        break;
		                    }
		                    left += cells[idx].offsetWidth;
		                }
	
		                if (groups > 0) {
		                    left += outerWidth(container.find(".k-group-cell:first")) * groups;
		                }
	
		                if (that._hasDetails()) {
		                    left += outerWidth(container.find(".k-hierarchy-cell:first"));
		                }
	
		           } else {
		                left = th.position().left;
		                if (scrollable) {
		                    var headerWrap = th.closest(".k-grid-header-wrap, .k-grid-header-locked"),
		                        ieCorrection = browser.msie ? headerWrap.scrollLeft() : 0,
		                        webkitCorrection = browser.webkit ? (headerWrap[0].scrollWidth - headerWrap[0].offsetWidth - headerWrap.scrollLeft()) : 0,
		                        firefoxCorrection = browser.mozilla ? (headerWrap[0].scrollWidth - headerWrap[0].offsetWidth - (headerWrap[0].scrollWidth - headerWrap[0].offsetWidth - headerWrap.scrollLeft())) : 0;
	
		                    left -= webkitCorrection - firefoxCorrection + ieCorrection;
		                }
		            }
	
		            resizeHandle.css({
		                top: th.position().top,//scrollable ? 0 : heightAboveHeader(that.wrapper),
		                left: left - indicatorWidth,
		                height: outerHeight(th),
		                width: indicatorWidth * 3
		            })
		            .data("th", th)
		            .show();
	
		            resizeHandle.off("dblclick" + NS).on("dblclick" + NS, function () {
		                that._autoFitLeafColumn(th.data("index"));
		            });
		        },
	
		        _positionColumnResizeHandle: function() {
		            var that = this,
		                lockedHead = that.lockedHeader ? that.lockedHeader.find("thead:first") : $();
	
		            that.thead.add(lockedHead).on("mousemove" + NS, "th", function (e) {
		                var button = typeof e.buttons !== "undefined" ? e.buttons : (e.which || e.button);
	
		                var th = $(this);
		                if (th.hasClass("k-group-cell") || th.hasClass("k-hierarchy-cell")) {
		                    return;
		                }
	
		                if (typeof button !== "undefined" && button !== 0) {
		                    //do not create a new resize handle if a mouse button is still pressed
		                    //this happens during resizing or before UserEvents trigger "start"
		                    return;
		                }
	
		                that._createResizeHandle(th.closest("div"), th);
		            });
		        },
	
		        _resizeHandleDocumentClick: function(e) {
		            if ($(e.target).closest(".k-column-active").length) {
		                return;
		            }
	
		            $(document).off(e);
	
		            this._hideResizeHandle();
		        },
	
		        _hideResizeHandle: function() {
		            if (this.resizeHandle) {
		                this.resizeHandle.data("th")
		                    .removeClass("k-column-active");
	
		                if (this.lockedContent && !this._isMobile) {
		                    this.resizeHandle.off(NS).remove();
		                    this.resizeHandle = null;
		                } else {
		                    this.resizeHandle.hide();
		                }
		            }
		        },
	
		        _positionColumnResizeHandleTouch: function() {
		            var that = this,
		                lockedHead = that.lockedHeader ? that.lockedHeader.find("thead:first") : $();
	
		            that._resizeUserEvents = new kendo.UserEvents(lockedHead.add(that.thead), {
		                filter: "th:not(.k-group-cell):not(.k-hierarchy-cell)",
		                threshold: 10,
		                hold: function(e) {
		                    var th = $(e.target);
	
		                    e.preventDefault();
	
		                    th.addClass("k-column-active");
		                    that._createResizeHandle(th.closest("div"), th);
	
		                    if (!that._resizeHandleDocumentClickHandler) {
		                        that._resizeHandleDocumentClickHandler = proxy(that._resizeHandleDocumentClick, that);
		                    }
	
		                    $(document).on("click", that._resizeHandleDocumentClickHandler);
		                }
		            });
		        },
	
		        resizeColumn: function(column, columnWidth) {
		            var that = this;
		            var isLocked = !!column.locked;
		            var isHidden = !!column.hidden;
		            var options = this.options;
		            var scrollbar = !kendo.support.mobileOS ? kendo.support.scrollbar() : 0;
		            var index = isLocked ? inArray(column, visibleLockedColumns(that.columns)) : inArray(column, visibleNonLockedColumns(that.columns));
		            var contentTable =  isLocked ? that.lockedTable : that.table;
		            var footer = that.footer || $();
		            var header = isLocked ? that.lockedHeader.find("table") : that.thead.closest("table");
		            var columnMinWidth = column.minResizableWidth || 10;
		            var gridWidth = isLocked ? outerWidth(contentTable.find("tbody")) : outerWidth(that.tbody); // IE returns 0 if grid is empty and scrolling is enabled
		            var col;
	
		            if (isHidden) {
		                column.width = columnWidth > columnMinWidth ? columnWidth : columnMinWidth;
		                return;
		            }
	
		            if (that.footer && that.lockedContent) {
		                footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
		            }
	
		            if (options.scrollable) {
	
		                col = header.find("col:not(.k-group-col,.k-hierarchy-col):eq(" + index + ")")
		                    .add(contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"))
		                    .add(footer.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"));
		            } else {
		                col = contentTable.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")");
		            }
	
		            if (options.scrollable) {
		                var constrain = false;
		                var totalWidth = that.wrapper.width() - scrollbar;
		                var width = columnWidth = columnWidth > columnMinWidth ? columnWidth : columnMinWidth;
	
		                if (isLocked && gridWidth - columnWidth + width > totalWidth) {
		                    width = columnWidth + (totalWidth - gridWidth - scrollbar * 2);
		                    if (width < 0) {
		                        width = columnWidth;
		                    }
		                    constrain = true;
		                }
	
		                if (width > 10 && width >= columnMinWidth) {
		                    col.css('width', width);
	
		                    if (gridWidth) {
		                        if (constrain) {
		                            width = totalWidth - scrollbar * 2;
		                        } else {
		                            width = gridWidth + (columnWidth - column.width);
		                        }
	
		                        contentTable
		                            .add(header)
		                            .add(footer)
		                            .css('width', width);
	
		                        if (!isLocked) {
		                            that._footerWidth = width;
		                        }
		                    }
		                }
	
		            that._scrollVirtualWrapperOnColumnResize();
		            } else if (columnWidth > 10 && columnWidth >= columnMinWidth) {
		                col.css('width', columnWidth);
		            }
	
		            column.width = columnWidth;
	
		            that._applyLockedContainersWidth();
		            that._syncLockedContentHeight();
		            that._syncLockedHeaderHeight();
		        },
	
		        _resizable: function() {
		            var that = this,
		                options = that.options,
		                container,
		                columnStart,
		                columnWidth,
		                columnMinWidth,
		                gridWidth,
		                isMobile = this._isMobile,
		                scrollbar = !kendo.support.mobileOS ? kendo.support.scrollbar() : 0,
		                isLocked,
		                col, th;
	
		            if (options.resizable) {
		                container = options.scrollable ? that.wrapper.find(".k-grid-header-wrap:first") : that.wrapper;
	
		                if (isMobile) {
		                    that._positionColumnResizeHandleTouch(container);
		                } else {
		                    that._positionColumnResizeHandle(container);
		                }
	
		                if (that.resizable) {
		                    that.resizable.destroy();
		                }
	
		                that.resizable = new ui.Resizable(container.add(that.lockedHeader), {
		                    handle: (!!options.scrollable ? "" : ">") + ".k-resize-handle",
		                    hint: function(handle) {
		                        return $('<div class="k-grid-resize-indicator" />').css({
		                            height: outerHeight(handle.data("th")) + that.tbody.attr("clientHeight")
		                        });
		                    },
		                    start: function(e) {
		                        th = $(e.currentTarget).data("th");
	
		                        if (isMobile) {
		                            that._hideResizeHandle();
		                        }
	
		                        var header = th.closest("table"),
		                            index = $.inArray(th[0], leafDataCells(th.closest("thead")).filter(":visible"));
	
		                        isLocked = header.parent().hasClass("k-grid-header-locked");
	
		                        var contentTable =  isLocked ? that.lockedTable : that.table,
		                            footer = that.footer || $();
	
		                        if (that.footer && that.lockedContent) {
		                            footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
		                        }
	
		                        cursor(that.wrapper, 'col-resize');
	
		                        if (options.scrollable) {
		                            col = header.find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")")
		                                .add(contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"))
		                                .add(footer.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"));
		                        } else {
		                            col = contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")");
		                        }
	
		                        var columns = $.map(that.columns, function(a) {
		                            return !a.hidden && ((isLocked && a.locked) || ((!isLocked && !a.locked))) ? a : null;
		                        });
	
		                        columnStart = e.x.location;
		                        columnWidth = outerWidth(th);
		                        columnMinWidth = leafColumns(columns)[index].minResizableWidth || 10;
		                        gridWidth = isLocked ? outerWidth(contentTable.children("tbody")) : outerWidth(that.tbody); // IE returns 0 if grid is empty and scrolling is enabled
	
		                        // fix broken UI in Chrome38+
		                        if (browser.webkit) {
		                            that.wrapper.addClass("k-grid-column-resizing");
		                        }
		                    },
		                    resize: function(e) {
		                        var rtlMultiplier = isRtl ? -1 : 1,
		                            currentWidth = columnWidth + (e.x.location * rtlMultiplier) - (columnStart * rtlMultiplier);
	
		                        if (options.scrollable) {
		                            var footer;
		                            if (isLocked && that.lockedFooter) {
		                                footer = that.lockedFooter.children("table");
		                            } else if (that.footer) {
		                                footer = that.footer.find(">.k-grid-footer-wrap>table");
		                            }
		                            if (!footer || !footer[0]) {
		                                footer = $();
		                            }
		                            var header = th.closest("table");
		                            var contentTable = isLocked ? that.lockedTable : that.table;
		                            var constrain = false;
		                            var totalWidth = that.wrapper.width() - scrollbar;
		                            var width = currentWidth;
	
		                            if (isLocked && gridWidth - columnWidth + width > totalWidth) {
		                                width = columnWidth + (totalWidth - gridWidth - scrollbar * 2);
		                                if (width < 0) {
		                                    width = currentWidth;
		                                }
		                                constrain = true;
		                            }
	
		                            if (width > 10 && width >= columnMinWidth) {
		                                col.css('width', width);
	
		                                if (gridWidth) {
		                                    if (constrain) {
		                                        width = totalWidth - scrollbar * 2;
		                                    } else {
		                                        width = gridWidth + (e.x.location * rtlMultiplier) - (columnStart * rtlMultiplier);
		                                    }
	
		                                    contentTable
		                                        .add(header)
		                                        .add(footer)
		                                        .css('width', width);
	
		                                    if (!isLocked) {
		                                        that._footerWidth = width;
		                                    }
		                                }
		                            }
	
		                            that._scrollVirtualWrapperOnColumnResize();
		                        } else if (currentWidth > 10 && currentWidth >= columnMinWidth) {
		                            col.css('width', currentWidth);
		                        }
		                    },
		                    resizeend: function() {
		                        var newWidth = outerWidth(th),
		                            column,
		                            header;
	
		                        cursor(that.wrapper, "");
	
		                        if (browser.webkit) {
		                            that.wrapper.removeClass("k-grid-column-resizing");
		                        }
	
		                        if (columnWidth != newWidth) {
		                            header = that.lockedHeader ? that.lockedHeader.find("thead:first tr:first").add(that.thead.find("tr:first")) : th.parent();
	
		                            var index = th.attr(kendo.attr("index"));
		                            if (!index) {
		                                index = header.find("th:not(.k-group-cell):not(.k-hierarchy-cell)").index(th);
		                            }
		                            column = leafColumns(that.columns)[index];
	
		                            column.width = newWidth;
	
		                            that.trigger(COLUMNRESIZE, {
		                                column: column,
		                                oldWidth: columnWidth,
		                                newWidth: newWidth
		                            });
	
		                            that._applyLockedContainersWidth();
		                            that._syncLockedContentHeight();
		                            that._syncLockedHeaderHeight();
		                        }
	
		                        that._hideResizeHandle();
		                        th = null;
		                    }
		                });
	
		            }
		        },
	
		        _draggable: function() {
		            var that = this;
		            if (that.options.reorderable) {
	
		                if (that._draggableInstance) {
		                    that._draggableInstance.destroy();
		                }
	
		                var header = that.wrapper.children(".k-grid-header");
	
		                that._draggableInstance = that.wrapper.kendoDraggable({
		                    group: kendo.guid(),
		                    autoScroll: true,
		                    filter: that.content ? ".k-grid-header:first " + HEADERCELLS : "table:first>.k-grid-header " + HEADERCELLS,
		                    dragstart: function() {
		                        header.children(".k-grid-header-wrap").unbind("scroll" + NS + "scrolling").bind("scroll" + NS + "scrolling", function (e) {
		                            if (that.virtualScrollable) {
		                                that.content.find(">.k-virtual-scrollable-wrap").scrollLeft(this.scrollLeft);
		                            } else {
		                                that.scrollables.not(e.currentTarget).scrollLeft(this.scrollLeft);
		                            }
		                        });
		                    },
		                    dragend: function() {
		                        header.children(".k-grid-header-wrap").unbind("scroll" + NS + "scrolling");
		                    },
		                    drag: function() {
		                        that._hideResizeHandle();
		                    },
		                    hint: function(target) {
		                        var title = target.attr(kendo.attr("title"));
		                        if (title) {
		                            title = kendo.htmlEncode(title);
		                        }
		                        return $('<div class="k-header k-drag-clue" />')
		                            .css({
		                                width: target.width(),
		                                paddingLeft: target.css("paddingLeft"),
		                                paddingRight: target.css("paddingRight"),
		                                lineHeight: target.height() + "px",
		                                paddingTop: target.css("paddingTop"),
		                                paddingBottom: target.css("paddingBottom")
		                            })
		                            .html(title || target.attr(kendo.attr("field")) || target.text())
		                            .prepend('<span class="k-icon k-drag-status k-i-cancel" />');
		                    }
		                }).data("kendoDraggable");
		            }
		        },
	
		        _reorderable: function() {
		            var that = this;
		            if (that.options.reorderable) {
		                if (that.wrapper.data("kendoReorderable")) {
		                    that.wrapper.data("kendoReorderable").destroy();
		                }
	
		                that.wrapper.kendoReorderable({
		                    draggable: that._draggableInstance,
		                    dragOverContainers: function(sourceIndex, targetIndex) {
		                        var columns = flatColumnsInDomOrder(that.columns);
		                        return columns[sourceIndex].lockable !== false && targetParentContainerIndex(columns, that.columns, sourceIndex, targetIndex) > -1;
		                    },
		                    inSameContainer: function(e) {
		                        return $(e.source).parent()[0] === $(e.target).parent()[0] && targetParentContainerIndex(flatColumnsInDomOrder(that.columns), that.columns, e.sourceIndex, e.targetIndex) > -1;
		                    },
		                    change: function(e) {
		                        var columns = flatColumnsInDomOrder(that.columns);
		                        var column = columns[e.oldIndex];
		                        var newIndex = targetParentContainerIndex(columns, that.columns, e.oldIndex, e.newIndex);
	
		                        that.trigger(COLUMNREORDER, {
		                            newIndex: newIndex,
		                            oldIndex: inArray(column, columns),
		                            column: column
		                        });
	
		                        that.reorderColumn(newIndex, column, e.position === "before");
		                    }
		                });
		            }
		        },
	
		        _reorderHeader: function(sources, target, before) {
		            var that = this;
		            var sourcePosition = columnPosition(sources[0], that.columns);
		            var destPosition = columnPosition(target, that.columns);
	
		            var leafs = [];
		            for (var idx = 0; idx < sources.length; idx++) {
		                if (sources[idx].columns) {
		                    leafs = leafs.concat(sources[idx].columns);
		                }
		            }
	
		            var ths = elements(that.lockedHeader, that.thead, "tr:eq(" + sourcePosition.row + ")>th.k-header:not(.k-group-cell,.k-hierarchy-cell)");
	
		            var sourceLockedColumns = lockedColumns(sources).length;
		            var targetLockedColumns = lockedColumns([target]).length;
	
		            if (leafs.length) {
		                if (sourceLockedColumns > 0 && targetLockedColumns === 0) {
		                    moveCellsBetweenContainers(sources, target, leafs, that.columns, that.lockedHeader.find("thead"), that.thead, this._groups());
		                } else if (sourceLockedColumns === 0 && targetLockedColumns > 0) {
		                    moveCellsBetweenContainers(sources, target, leafs, nonLockedColumns(that.columns), that.thead, that.lockedHeader.find("thead"), this._groups());
		                }
	
		                if (target.columns || sourcePosition.cell - destPosition.cell > 1 || destPosition.cell - sourcePosition.cell > 1) {
		                    target = findReorderTarget(that.columns, target, sources[0], before, that.columns);
		                    if (target) {
		                        that._reorderHeader(leafs, target, before);
		                    }
		                }
		            } else if (sourceLockedColumns !== targetLockedColumns) { // move between containers
		                updateCellRowSpan(ths[sourcePosition.cell], that.columns, sourceLockedColumns);
		            }
	
		            reorder(ths, sourcePosition.cell, destPosition.cell, before, sources.length);
		        },
	
		        _reorderContent: function(sources, destination, before) {
		            var that = this;
		            var lockedRows = $();
		            var source = sources[0];
		            var visibleSources = visibleColumns(sources);
		            var sourceIndex = inArray(source, leafColumns(that.columns));
		            var destIndex = inArray(destination, leafColumns(that.columns));
	
		            var colSourceIndex = inArray(visibleSources[0], visibleLeafColumns(that.columns));
		            var colDest = inArray(destination, visibleLeafColumns(that.columns));
		            var lockedCount = lockedColumns(that.columns).length;
		            var isLocked = !!destination.locked;
		            var footer = that.footer || that.wrapper.find(".k-grid-footer");
	
		            var headerCol, footerCol, beforeVisibleColumn;
		            headerCol = footerCol = colDest;
	
		            if (destination.hidden) {
		                var columnsArray = isLocked ? lockedColumns(that.columns): nonLockedColumns(that.columns);
	
		                if (visibleColumns(columnsArray).length > 0) {
		                    headerCol = footerCol = colDest = this._findClosestVisibleColumnIndex(columnsArray, destIndex);
		                    beforeVisibleColumn = visibleColumns(columnsArray.slice(destIndex)).length > 0;
		                }
		                else {
		                    if (isLocked) {
		                        colDest = that.lockedTable.find("colgroup");
		                        headerCol = that.lockedHeader.find("colgroup");
		                        footerCol = $(that.lockedFooter).find(">table>colgroup");
		                    } else {
		                        colDest = that.tbody.prev();
		                        headerCol = that.thead.prev();
		                        footerCol = footer.find(".k-grid-footer-wrap").find(">table>colgroup");
		                    }
		                }
		            }
	
		            if (that._hasFilterRow()) {
		                reorder(that.wrapper.find(".k-filter-row th:not(.k-group-cell,.k-hierarchy-cell)"), sourceIndex, destIndex, before, sources.length);
		            }
	
		            if (colSourceIndex >= 0) {
		                reorder(elements(that.lockedHeader, that.thead.prev(), "col:not(.k-group-col,.k-hierarchy-col)"), colSourceIndex, headerCol, beforeVisibleColumn ? beforeVisibleColumn : before, visibleSources.length);
		            }
	
		            if (that.options.scrollable) {
		                if (colSourceIndex >= 0) {
		                    reorder(elements(that.lockedTable, that.tbody.prev(), "col:not(.k-group-col,.k-hierarchy-col)"), colSourceIndex, colDest, beforeVisibleColumn ? beforeVisibleColumn : before, visibleSources.length);
		                }
		            }
	
		            if (footer && footer.length) {
		                if (colSourceIndex >= 0) {
		                    reorder(elements(that.lockedFooter, footer.find(".k-grid-footer-wrap"), ">table>colgroup>col:not(.k-group-col,.k-hierarchy-col)"), colSourceIndex, footerCol, beforeVisibleColumn ? beforeVisibleColumn : before, visibleSources.length);
		                }
		                reorder(footer.find(".k-footer-template>td:not(.k-group-cell,.k-hierarchy-cell)"), sourceIndex, destIndex, before, sources.length);
		            }
	
		            var rows = that.tbody.children(":not(.k-grouping-row,.k-detail-row)");
		            if (that.lockedTable) {
		                if (lockedCount > destIndex) {
		                    if (lockedCount <= sourceIndex) {
		                        updateColspan(
		                            that.lockedTable.find(">tbody>tr.k-grouping-row"),
		                            that.table.find(">tbody>tr.k-grouping-row"),
		                            sources.length
		                        );
		                    }
		                } else if (lockedCount > sourceIndex) {
		                    updateColspan(
		                        that.table.find(">tbody>tr.k-grouping-row"),
		                        that.lockedTable.find(">tbody>tr.k-grouping-row"),
		                        sources.length
		                    );
		                }
	
		                lockedRows = that.lockedTable.find(">tbody>tr:not(.k-grouping-row,.k-detail-row)");
		            }
	
		            for (var idx = 0, length = rows.length; idx < length; idx += 1) {
		                reorder(elements(lockedRows[idx], rows[idx], ">td:not(.k-group-cell,.k-hierarchy-cell)"), sourceIndex, destIndex, before, sources.length);
		            }
		        },
	
		        _findClosestVisibleColumnIndex: function(columns, columnIndex) {
		            var columnsArray = visibleColumns(columns.slice(columnIndex)).length > 0 ? columns.slice(columnIndex) : columns.slice(0, columnIndex + 1).reverse(),
		                closestVisibleColumn = visibleColumns(columnsArray)[0];
	
		            return inArray(closestVisibleColumn, visibleColumns(this.columns));
		        },
	
		        _autoFitLeafColumn: function (leafIndex) {
		            this.autoFitColumn(leafColumns(this.columns)[leafIndex]);
		        },
	
		        autoFitColumn: function (column) {
		            var that = this,
		                options = that.options,
		                columns = that.columns,
		                index,
		                th,
		                headerTable,
		                isLocked,
		                visibleLocked = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).filter(isCellVisible).length : 0,
		                col,
		                minWidth,
		                contentDiv, scrollLeft,
		                notGroupOrHierarchyCol = "col:not(.k-group-col):not(.k-hierarchy-col)",
		                notGroupOrHierarchyVisibleCell = "td:visible:not(.k-group-cell):not(.k-hierarchy-cell)";
	
		            //  retrieve the column object, depending on the method argument
		            if (typeof column == "number") {
		                column = columns[column];
		            } else if (isPlainObject(column)) {
		                column = grep(flatColumns(columns), function (item) {
		                    return item === column;
		                })[0];
		            } else {
		                column = grep(flatColumns(columns), function (item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            if (!column || !isVisible(column)) {
		                return;
		            }
	
		            minWidth = column.minResizableWidth;
		            index = inArray(column, leafColumns(columns));
		            isLocked = column.locked;
	
		            if (isLocked) {
		                headerTable = that.lockedHeader.children("table");
		            } else {
		                headerTable = that.thead.parent();
		            }
	
		            th = headerTable.find("[data-index='" + index + "']");
	
		            var contentTable = isLocked ? that.lockedTable : that.table,
		                footer = that.footer || $();
	
		            if (that.footer && that.lockedContent) {
		                footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
		            }
	
		            var footerTable = footer.find("table").first();
	
		            if (that.lockedHeader && !isLocked) {
		                index -= visibleLocked;
		            }
	
		            // adjust column index, depending on previous hidden columns
		            for (var j = 0; j < columns.length; j++) {
		                if (columns[j] === column) {
		                    break;
		                } else {
		                    if (columns[j].hidden) {
		                        index--;
		                    }
		                }
		            }
	
		            // get col elements
		            if (options.scrollable) {
		                col = headerTable.find(notGroupOrHierarchyCol).eq(index)
		                    .add(contentTable.children("colgroup").find(notGroupOrHierarchyCol).eq(index))
		                    .add(footerTable.find("colgroup").find(notGroupOrHierarchyCol).eq(index));
	
		                if (!isLocked) {
		                    contentDiv = contentTable.parent();
		                    scrollLeft = contentDiv.scrollLeft();
		                }
		            } else {
		                col = contentTable.children("colgroup").find(notGroupOrHierarchyCol).eq(index);
		            }
	
		            var tables = headerTable.add(contentTable).add(footerTable);
	
		            var oldColumnWidth = outerWidth(th);
	
		            // reset the table and autofitted column widths
		            // if scrolling is disabled, we need some additional repainting of the table
		            col.width("");
		            tables.css("table-layout", "fixed");
		            col.width("auto");
		            tables.addClass("k-autofitting");
		            tables.css("table-layout", "");
	
		            // +1 is required by IE, regardless of the border widths, otherwise unexpected wrapping may occur with hyphenated text
		            var newColumnWidth = Math.ceil(Math.max(
		                outerWidth(th),
		                outerWidth(contentTable.find("tr:not(.k-grouping-row)").eq(0).children(notGroupOrHierarchyVisibleCell).eq(index)),
		                outerWidth(footerTable.find("tr").eq(0).children(notGroupOrHierarchyVisibleCell).eq(index))
		            )) + 1;
	
		            if (minWidth && minWidth > newColumnWidth) {
		                newColumnWidth = minWidth;
		            }
	
		            col.width(newColumnWidth);
		            column.width = newColumnWidth;
	
		            // if all visible columns have widths, the table needs a pixel width as well
		            if (options.scrollable) {
		                var cols = headerTable.find("col"),
		                    colWidth,
		                    totalWidth = 0;
		                for (var idx = 0, length = cols.length; idx < length; idx += 1) {
		                    colWidth = cols[idx].style.width;
		                    if (colWidth && colWidth.indexOf("%") == -1) {
		                        totalWidth += parseInt(colWidth, 10);
		                    } else if (cols.eq(idx).hasClass("k-group-col")) {
		                        totalWidth += parseInt(cols.eq(idx).width(), 10);
		                    } else {
		                        totalWidth = 0;
		                        break;
		                    }
		                }
	
		                if (totalWidth) {
		                    tables.each(function () {
		                        this.style.width = totalWidth + "px";
		                    });
		                }
		            }
	
		            if (browser.msie && browser.version == 8) {
		                tables.css("display", "inline-table");
		                setTimeout(function () {
		                    tables.css("display", "table");
		                }, 1);
		            }
	
		            tables.removeClass("k-autofitting");
	
		            if (scrollLeft) {
		                contentDiv.scrollLeft(scrollLeft);
		            }
	
		            that.trigger(COLUMNRESIZE, {
		                column: column,
		                oldWidth: oldColumnWidth,
		                newWidth: newColumnWidth
		            });
	
		            that._applyLockedContainersWidth();
		            that._syncLockedContentHeight();
		            that._syncLockedHeaderHeight();
		        },
	
		        reorderColumn: function(destIndex, column, before) {
		            var that = this,
		                parent = columnParent(column, that.columns),
		                columns = parent ? parent.columns : that.columns,
		                sourceIndex = inArray(column, columns),
		                destColumn = columns[destIndex],
		                lockChanged,
		                isLocked = !!destColumn.locked,
		                lockedCount = lockedColumns(that.columns).length,
		                groupHeaderColumnTemplateColumns = grep(leafColumns(that.columns), function(column) { return column.groupHeaderColumnTemplate; });
	
		            if (sourceIndex === destIndex) {
		                return;
		            }
	
		            if (!column.locked && isLocked && nonLockedColumns(that.columns).length == 1) {
		                return;
		            }
	
		            if (column.locked && !isLocked && lockedCount == 1) {
		                return;
		            }
	
		            that._hideResizeHandle();
	
		            if (before === undefined) {
		                before = destIndex < sourceIndex;
		            }
	
		            var sourceColumns = [column];
	
		            that._reorderHeader(sourceColumns, destColumn, before);
	
		            if (that.lockedHeader) {
		                removeEmptyRows(that.thead);
		                removeEmptyRows(that.lockedHeader);
		            }
	
		            if (destColumn.columns) {
		                destColumn = leafColumns(destColumn.columns);
		                destColumn = destColumn[before ? 0 : destColumn.length - 1];
		            }
	
		            if (column.columns) {
		                sourceColumns = leafColumns(column.columns);
		            }
	
		            that._reorderContent(sourceColumns, destColumn, before);
	
		            lockChanged = !!column.locked;
		            lockChanged = lockChanged != isLocked;
		            column.locked = isLocked;
	
		            columns.splice(before ? destIndex : destIndex + 1, 0, column);
		            columns.splice(sourceIndex < destIndex ? sourceIndex : sourceIndex + 1, 1);
	
		            that._updateLockedCols();
		            that._updateCols();
		            that._templates();
	
		            that._updateColumnCellIndex();
	
		            if (groupHeaderColumnTemplateColumns.length > 0) {
		                that._renderGroupRows();
		            }
		            that._updateTablesWidth();
		            that._applyLockedContainersWidth();
		            that._syncLockedHeaderHeight();
		            that._syncLockedContentHeight();
		            that._updateFirstColumnClass();
	
		            if(!lockChanged) {
		                return;
		            }
	
		            if (isLocked) {
		                that.trigger(COLUMNLOCK, {
		                    column: column
		                });
		            } else {
		                that.trigger(COLUMNUNLOCK, {
		                    column: column
		                });
		            }
		        },
	
		        _updateColumnCellIndex: function() {
		            var header;
		            var offset = 0;
	
		            if (this.lockedHeader) {
		                header = this.lockedHeader.find("thead");
		                offset = updateCellIndex(header, lockedColumns(this.columns));
		            }
		            updateCellIndex(this.thead, nonLockedColumns(this.columns), offset);
		        },
	
		        lockColumn: function(column) {
		            var columns = this.columns;
	
		            if (typeof column == "number") {
		                column = columns[column];
		            } else {
		                column = grep(columns, function(item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            if (!column || column.locked || column.hidden) {
		                return;
		            }
	
		            var index = lockedColumns(columns).length - 1;
		            this.reorderColumn(index, column, false);
		        },
	
		        unlockColumn: function(column) {
		            var columns = this.columns;
	
		            if (typeof column == "number") {
		                column = columns[column];
		            } else {
		                column = grep(columns, function(item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            if (!column || !column.locked || column.hidden) {
		                return;
		            }
	
		            var index = lockedColumns(columns).length;
		            this.reorderColumn(index, column, true);
		        },
	
		        cellIndex: function(td) {
		            var lockedColumnOffset = 0;
	
		            if (this.lockedTable && !$.contains(this.lockedTable[0], td[0])) {
		                lockedColumnOffset = leafColumns(lockedColumns(this.columns)).length;
		            }
	
		            return $(td).parent().children('td:not(.k-group-cell,.k-hierarchy-cell)').index(td) + lockedColumnOffset;
		        },
	
		        _modelForContainer: function(container) {
		            container = $(container);
	
		            if (!container.is("tr") && this._editMode() !== "popup") {
		                container = container.closest("tr");
		            }
	
		            var id = container.attr(kendo.attr("uid"));
	
		            return this.dataSource.getByUid(id);
		        },
	
		        _editable: function() {
		            var that = this,
		                selectable = that.selectable && that.selectable.options.multiple,
		                editable = that.options.editable,
		                handler = function() {
		                    var target = activeElement(),
		                        cell = that._editContainer;
	
		                    if (cell && cell[0] && !$.contains(cell[0], target) && cell[0] !== target && !$(target).closest(".k-animation-container").length) {
		                        if (that.editable.end()) {
		                            that.closeCell();
		                        } else {
		                            that._scrollVirtualWrapper();
		                        }
		                    }
		                };
	
		            if (editable) {
		                this.wrapper.addClass("k-editable");
	
		                var mode = that._editMode();
		                if (mode === "incell") {
		                    that.table.add(that.lockedTable)
		                        .on("mousedown" + NS, NAVROW + ">" + NAVCELL, function (e) {
		                            var target = $(e.target);
		                            if (that._editMode() === "incell" && target.hasClass("k-checkbox-label") && target.prev().attr(kendo.attr("bind"))) {
		                                e.preventDefault();
		                            }
		                        });
	
		                    if (editable.update !== false) {
		                        if (isMac) {
		                            that.wrapper
		                                .on(CLICK + NS, ".k-edit-cell > input[type='checkbox']", function(e) {
		                                    // checking /unchecking a checkbox does not change the document.activeElement to be the checkbox
		                                    // this is necessary for the "focusout" event to be fired
		                                    $(e.target).focus();
		                                })
		                                .on(CLICK + NS, ".k-edit-cell", function(e) {
		                                    if (!$(e.target).is("input")) {
		                                        $(e.currentTarget).find("input[type='checkbox']").focus();
		                                    }
		                                })
		                                .on(MOUSEDOWN + NS, "tr:not(.k-grouping-row) > td", function(e) {
		                                    var editContainer = that._editContainer;
	
		                                    if (editContainer && editContainer[0] && ($.contains(editContainer[0], e.target) || editContainer[0] === e.target)) {
		                                        that._mousedownOnEditCell = true;
		                                    } else {
		                                        that._mousedownOnEditCell = false;
		                                    }
		                                });
		                        }
	
		                        that.wrapper.on(CLICK + NS, "tr:not(.k-grouping-row) > td", function(e) {
		                            var td = $(this),
		                                isLockedCell = that.lockedTable && td.closest("table")[0] === that.lockedTable[0];
	
		                            that._mousedownOnEditCell = false;
	
		                            if (td.hasClass("k-hierarchy-cell") ||
		                                td.hasClass("k-detail-cell") ||
		                                td.hasClass("k-group-cell") ||
		                                td.hasClass("k-edit-cell") ||
		                                td.has("a.k-grid-delete").length ||
		                                td.has("button.k-grid-delete").length ||
		                                (td.closest("tbody")[0] !== that.tbody[0] && !isLockedCell) ||
		                                $(e.target).is(":input")) {
		                                return;
		                            }
	
		                            if (that.editable) {
		                                if (that.editable.end()) {
		                                    if (selectable) {
		                                        $(activeElement()).blur();
		                                    }
		                                    that.closeCell();
		                                    that.editCell(td);
		                                } else {
		                                    that._scrollVirtualWrapper();
		                                }
		                            } else {
		                                that.editCell(td);
		                            }
	
		                        })
		                        .on("focusin" + NS, function() {
		                            // fix focus issue in IE
		                            if (!$.contains(this, activeElement())) {
		                                clearTimeout(that.timer);
		                                that.timer = null;
		                            }
		                        })
		                        .on("focusout" + NS, function(e) {
		                            var shouldCloseCell = true;
	
		                            if (isMac && that._mousedownOnEditCell) {
		                                shouldCloseCell = false;
		                            }
	
		                            that._mousedownOnEditCell = false;
	
		                            if (shouldCloseCell) {
		                                that.timer = setTimeout(function() {
		                                    handler(e);
		                                }, 1);
		                            }
		                        });
		                    }
		                } else {
		                    if (editable.update !== false) {
		                        that.wrapper.on(CLICK + NS, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible a.k-grid-edit", function(e) {
		                            e.preventDefault();
		                            that.editRow($(this).closest("tr"));
		                        });
	
		                        if (that._isVirtualInlineEditable()) {
		                            that.wrapper.on("focusout" + NS, "tr:not(.k-grouping-row) > td", function() {
		                                if (that.editable && !that.editable.end()) {
		                                    that._scrollVirtualWrapper();
		                                }
		                            });
		                        }
		                    }
		                }
	
		                if (editable.destroy !== false) {
		                    that.wrapper.on(CLICK + NS, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible .k-grid-delete", function(e) {
		                        e.preventDefault();
		                        e.stopPropagation();
		                        that.removeRow($(this).closest("tr"));
		                    });
		                } else {
		                    //Required for the MVC server wrapper delete button
		                    that.wrapper.on(CLICK + NS, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible button.k-grid-delete", function(e) {
		                        e.stopPropagation();
	
		                        if (!that._confirmation()) {
		                            e.preventDefault();
		                        }
		                    });
		                }
		            }
		        },
	
		        editCell: function(cell) {
		            cell = $(cell);
	
		            var that = this,
		            column = leafColumns(that.columns)[that.cellIndex(cell)],
		                model = that._modelForContainer(cell);
	
		            that.closeCell();
	
		            if (model && isColumnEditable(column, model) && !column.command) {
		                if (that.trigger(BEFOREEDIT, { model: model })) {
		                    return;
		                }
	
		                that._attachModelChange(model);
	
		                that._editContainer = cell;
	
		                if (that._shouldClearEditableState) {
		                    that._clearEditableState();
		                }
		                that.editable = cell.addClass("k-edit-cell")
		                    .kendoEditable({
		                        fields: { field: column.field, format: column.format, editor: column.editor, values: column.values },
		                        model: model,
		                        target: that,
		                        change: function(e) {
		                            if (that.trigger(SAVE, { values: e.values, container: cell, model: model } )) {
		                                e.preventDefault();
		                            }
		                        },
		                        skipFocus: that._isVirtualIncellEditable() && that._editableState ? true : false
	
		                    }).data("kendoEditable");
	
		                var tr = cell.parent().addClass("k-grid-edit-row");
	
		                if (that.lockedContent) {
		                    adjustRowHeight(tr[0], that._relatedRow(tr).addClass("k-grid-edit-row")[0]);
		                }
	
		                that.trigger(EDIT, { container: cell, model: model });
		            }
		        },
	
		        _adjustLockedHorizontalScrollBar: function() {
		            var table = this.table,
		                content = table.parent();
	
		            var scrollbar = table[0].offsetWidth > content[0].clientWidth ? kendo.support.scrollbar() : 0;
		            this.lockedContent.height(content.height() - scrollbar);
		        },
	
		        _syncLockedContentHeight: function() {
		            if (this.lockedTable) {
		                if (!this.touchScroller) {
		                    this._adjustLockedHorizontalScrollBar();
		                }
		                this._adjustRowsHeight(this.table, this.lockedTable);
		            }
		        },
	
		        _syncLockedHeaderHeight: function() {
		            if (this.lockedHeader) {
		                var lockedTable = this.lockedHeader.children("table");
		                var table = this.thead.parent();
	
		                this._adjustRowsHeight(lockedTable, table);
	
		                syncTableHeight(lockedTable, table);
		            }
		        },
	
		        _syncLockedFooterHeight: function() {
		            if (this.lockedFooter && this.footer && this.footer.length) {
		                this._adjustRowsHeight(this.lockedFooter.children("table"), this.footer.find(".k-grid-footer-wrap > table"));
		            }
		        },
	
		        _destroyEditable: function() {
		            var that = this;
	
		            var destroy = function() {
		                if (that.editable) {
	
		                    var container = that.editView ? that.editView.element : that._editContainer;
	
		                    if (container) {
		                        container.off(CLICK + NS, "a.k-grid-cancel", that._editCancelClickHandler);
		                        container.off(CLICK + NS, "a.k-grid-update", that._editUpdateClickHandler);
		                    }
	
		                    that._detachModelChange();
		                    that.editable.destroy();
		                    that.editable = null;
		                    that._editContainer = null;
		                    that._destroyEditView();
		                    that._editableIsClosing = null;
		                }
		            };
	
		            if (that.editable) {
		                if (that._editMode() === "popup" && !that._isMobile) {
		                    if (that._editableIsClosing) {
		                        that._editContainer.data("kendoWindow").bind("deactivate", destroy);
		                    }
		                    else {
		                        that._editableIsClosing = true;
		                        that._editContainer.data("kendoWindow").bind("deactivate", destroy).close();
		                    }
		                } else {
		                    destroy();
		                }
		            }
		            if (that._actionSheet) {
		                that._actionSheet.destroy();
		                that._actionSheet = null;
		            }
		        },
	
		        _destroyEditView: function() {
		            if (this.editView) {
		                this.editView.purge();
		                this.editView = null;
		                this.pane.navigate("");
		            }
		        },
	
		        _attachModelChange: function(model) {
		            var that = this;
	
		            that._modelChangeHandler = function(e) {
		                that._modelChange({ field: e.field, model: this });
		            };
	
		            model.bind("change", that._modelChangeHandler);
		        },
	
		        _detachModelChange: function() {
		            var that = this,
		                container = that._editContainer,
		                model = that._modelForContainer(container);
	
		            if (model) {
		                model.unbind(CHANGE, that._modelChangeHandler);
		            }
		        },
	
		        closeCell: function(isCancel) {
		            var that = this,
		                cell = that._editContainer,
		                column,
		                tr,
		                model;
	
		            if (!cell) {
		                return;
		            }
	
		            model = that._modelForContainer(cell);
	
		            if (isCancel && that.trigger("cancel", { container: cell, model: model })) {
		                return;
		            }
	
		            that.trigger(CELLCLOSE, { type: isCancel ? "cancel" : "save", model: model, container: cell });
	
		            cell.removeClass("k-edit-cell");
		            column = leafColumns(that.columns)[that.cellIndex(cell)];
	
		            tr = cell.parent().removeClass("k-grid-edit-row");
	
		            if (that.lockedContent) {
		                that._relatedRow(tr).removeClass("k-grid-edit-row");
		            }
	
		            that._destroyEditable(); // editable should be destroyed before content of the container is changed
	
		            that._displayCell(cell, column, model);
	
		            if (that._shouldClearEditableState) {
		                that._clearEditableState();
		            }
	
		            that.trigger("itemChange", { item: tr, data: model, ns: ui });
	
		            if (that.lockedContent) {
		                adjustRowHeight(tr.css("height", "")[0], that._relatedRow(tr).css("height", "")[0]);
		            }
		        },
	
		        _displayCell: function(cell, column, dataItem) {
		            var that = this,
		                state = { storage: {}, count: 0 },
		                settings = extend({}, kendo.Template, that.options.templateSettings),
		                tmpl = kendo.template(that._cellTmpl(column, state), settings);
	
		            if (state.count > 0) {
		                tmpl = proxy(tmpl, state.storage);
		            }
	
		            cell.empty().html(tmpl(dataItem));
	
		            that.angular("compile", function(){
		                return {
		                    elements: cell,
		                    data: [ { dataItem: dataItem } ]
		                };
		            });
		        },
	
		        removeRow: function(row) {
		            if (!this._confirmation(row)) {
		                return;
		            }
	
		            this._removeRow(row);
		        },
	
		        _removeRow: function(row) {
		            var that = this,
		                model,
		                modelId,
		                key,
		                schema,
		                mode = that._editMode();
	
		            if (mode !== "incell") {
		                that.cancelRow();
		            }
	
		            row = $(row);
	
		            if (that.lockedContent) {
		                row = row.add(that._relatedRow(row));
		            }
	
		            row = row.hide();
		            model = that._modelForContainer(row);
	
		            if (model && !that.trigger(REMOVE, { row: row, model: model })) {
		                schema =  that.dataSource.options.schema;
		                if (that._selectedIds && schema && schema.model) {
		                    modelId = isFunction(that.dataSource.options.schema.model) ? that.dataSource.options.schema.model.fn.idField : that.dataSource.options.schema.model.id;
		                    key = model[modelId];
		                    delete that._selectedIds[key];
		                }
	
		                that.dataSource.remove(model);
	
		                if (mode === "inline" || mode === "popup") {
		                    that.dataSource.sync();
		                }
		            } else if (mode === "incell") {
		                that._destroyEditable();
		            }
		        },
	
		        _editMode: function() {
		            var mode = "incell",
		                editable = this.options.editable;
	
		            if (editable !== true) {
		                if (typeof editable == "string") {
		                    mode = editable;
		                } else {
		                    mode = editable.mode || mode;
		                }
		            }
	
		            return mode;
		        },
	
		        editRow: function(row) {
		            var model;
		            var that = this;
	
		            if (row instanceof ObservableObject) {
		                model = row;
		            } else {
		                row = $(row);
		                model = that._modelForContainer(row);
		            }
	
		            var mode = that._editMode();
		            var container;
	
		            that.cancelRow();
	
		            if (model) {
		                row = that.tbody.children("[" + kendo.attr("uid") + "=" + model.uid + "]");
		                that._attachModelChange(model);
	
		                if (mode === "popup") {
		                    that._createPopupEditor(model);
		                } else if (mode === "inline") {
		                    that._createInlineEditor(row, model);
		                } else if (mode === "incell") {
		                    $(row).children(DATA_CELL).each(function() {
		                        var cell = $(this);
		                        var column = leafColumns(that.columns)[that.cellIndex(cell)];
	
		                        model = that._modelForContainer(cell);
	
		                        if (model && (!model.editable || model.editable(column.field)) && column.field && !column.selectable) {
		                            that.editCell(cell);
		                            return false;
		                        }
		                    });
		                }
	
	
		                container = that.editView ? that.editView.element : that._editContainer;
	
		                if (container) {
		                    if (!this._editCancelClickHandler) {
		                        this._editCancelClickHandler = proxy(this._editCancelClick, this);
		                    }
	
		                    container.on(CLICK + NS, "a.k-grid-cancel", this._editCancelClickHandler);
	
		                    if (!this._editUpdateClickHandler) {
		                        this._editUpdateClickHandler = proxy(this._editUpdateClick, this);
		                    }
	
		                    container.on(CLICK + NS, "a.k-grid-update", this._editUpdateClickHandler);
		                }
		            }
		        },
	
		        _editUpdateClick: function(e) {
		            e.preventDefault();
		            e.stopPropagation();
	
		            this.saveRow();
		        },
	
		        _editCancelClick: function(e) {
		            var that = this;
		            var navigatable = that.options.navigatable;
		            var model = that.editable.options.model;
		            var container = that.editView ? that.editView.element : that._editContainer;
	
		            e.preventDefault();
		            e.stopPropagation();
	
		            if (that.trigger("cancel", { container: container, model: model })) {
		                return;
		            }
	
		            var currentIndex = that.items().index($(that.current()).parent());
	
		            that.cancelRow();
	
		            if (navigatable) {
		                that._setCurrent(that.items().eq(currentIndex).children().filter(NAVCELL).first());
		                focusTable(that.table, true);
		            }
		        },
	
		        _createPopupEditor: function(model) {
		            var that = this;
		            var html = '<div ' + kendo.attr("uid") + '="' + model.uid + '" class="k-popup-edit-form' + (that._isMobile ? ' k-mobile-list' : '') + '"><div class="k-edit-form-container">';
		            var column;
		            var command;
		            var fields = [];
		            var idx;
		            var length;
		            var tmpl;
		            var updateText;
		            var cancelText;
		            var updateIconClass;
		            var cancelIconClass;
		            var tempCommand;
		            var columns = leafColumns(that.columns);
		            var attr;
		            var editable = that.options.editable;
		            var template = editable.template;
		            var options = isPlainObject(editable) ? editable.window : {};
		            var settings = extend({}, kendo.Template, that.options.templateSettings);
	
		            if (that.trigger(BEFOREEDIT, { model: model })) {
		                return;
		            }
	
		            options = options || {};
	
		            if (template) {
		                if (typeof template === STRING) {
		                    template = window.unescape(template);
		                }
	
		                html += (kendo.template(template, settings))(model);
	
		                for (idx = 0, length = columns.length; idx < length; idx++) {
		                    column = columns[idx];
		                    if (column.command) {
		                        tempCommand = getCommand(column.command, "edit");
		                        if (tempCommand) {
		                            command = tempCommand;
		                        }
		                    }
		                }
		            } else {
		                for (idx = 0, length = columns.length; idx < length; idx++) {
		                    column = columns[idx];
		                    if (column.selectable) {
		                        continue;
		                    }
		                    if (!column.command) {
		                        html += '<div class="k-edit-label"><label for="' + column.field + '">' + (column.title || column.field || "") + '</label></div>';
	
		                        if (isColumnEditable(column, model)) {
		                            fields.push({ field: column.field, format: column.format, editor: column.editor, values: column.values });
		                            html += '<div ' + kendo.attr("container-for") + '="' + column.field + '" class="k-edit-field"></div>';
		                        } else {
		                            var state = { storage: {}, count: 0 };
	
		                            tmpl = kendo.template(that._cellTmpl(column, state), settings);
	
		                            if (state.count > 0) {
		                                tmpl = proxy(tmpl, state.storage);
		                            }
	
		                            html += '<div class="k-edit-field">' + tmpl(model) + '</div>';
		                        }
		                    } else if (column.command) {
		                        tempCommand = getCommand(column.command, "edit");
		                        if (tempCommand) {
		                            command = tempCommand;
		                        }
		                    }
		                }
		            }
	
		            if (command) {
		                if (isPlainObject(command)) {
		                    if (isPlainObject(command.text)) {
		                        updateText = command.text.update;
		                        cancelText = command.text.cancel;
		                    }
		                    if (isPlainObject(command.iconClass)) {
		                        updateIconClass = command.iconClass.update;
		                        cancelIconClass = command.iconClass.cancel;
		                    }
	
		                   if (command.attr) {
		                       attr = command.attr;
		                   }
		                }
		            }
	
		            var container;
	
		            if (!that._isMobile) {
		                html += '<div class="k-edit-buttons k-state-default">';
		                html += that._createButton({ name: "update", text: updateText, attr: attr, iconClass: updateIconClass }) + that._createButton({ name: "canceledit", text: cancelText, attr: attr, iconClass: cancelIconClass });
		                html += '</div></div></div>';
	
		                container = that._editContainer = $(html)
		                .appendTo(that.wrapper).eq(0)
		                .kendoWindow(extend({
		                    modal: true,
		                    resizable: false,
		                    draggable: true,
		                    title: "Edit",
		                    visible: false,
		                    close: function(e) {
		                        if (e.userTriggered) {
		                            //The bellow line is required due to: draggable window in IE, change event will be triggered while the window is closing
		                            e.sender.element.focus();
		                            if (that.trigger("cancel", { container: container, model: model })) {
		                                e.preventDefault();
		                                return;
		                            }
	
		                            var currentIndex = that.items().index($(that.current()).parent());
	
		                            that._editableIsClosing = true;
		                            that.cancelRow();
		                            if (that.options.navigatable) {
		                                that._setCurrent(that.items().eq(currentIndex).children().filter(NAVCELL).first());
		                                focusTable(that.table, true);
		                            }
		                        }
		                    }
		                }, options));
		            } else {
		                html += "</div></div>";
		                that.editView = that.pane.append(
		                    '<div data-' + kendo.ns + 'role="view" data-' + kendo.ns + 'use-native-scrolling="true" data-' + kendo.ns + 'init-widgets="false" class="k-grid-edit-form">'+
		                        '<div data-' + kendo.ns + 'role="header" class="k-header">'+
		                            that._createButton({ name: "update", text: updateText, attr: attr }) +
		                            (options.title || "Edit") +
		                            that._createButton({ name: "canceledit", text: cancelText, attr: attr }) +
		                        '</div>'+
		                        html +
		                    '</div>');
		                container = that._editContainer = that.editView.element.find(".k-popup-edit-form");
		            }
	
		            that.editable = that._editContainer
		                .kendoEditable({
		                    fields: fields,
		                    model: model,
		                    clearContainer: false,
		                    target: that
		                }).data("kendoEditable");
	
		            // TODO: Replace this code with labels and for="ID"
		            if (that._isMobile) {
		                container.find("input[type=checkbox],input[type=radio]")
		                         .parent(".k-edit-field")
		                         .addClass("k-check")
		                         .prev(".k-edit-label")
		                         .addClass("k-check")
		                         .click(function() {
		                             $(this).next().children("input").click();
		                         });
		            }
	
		            that._openPopUpEditor();
	
		            that.trigger(EDIT, { container: container, model: model });
		        },
	
		        _openPopUpEditor: function() {
		            var that = this;
		            var windowEditor = that._editContainer ? that._editContainer.data("kendoWindow") : null;
		            var windowOptions = (that.options.editable || {}).window || {};
	
		            if (!this._isMobile) {
		                if (windowEditor) {
		                    if (!windowOptions.position) {
		                        windowEditor.center();
		                    }
	
		                    windowEditor.open();
		                }
		            } else {
		                this.pane.navigate(this.editView, this._editAnimation);
		            }
		        },
	
		        _createInlineEditor: function(row, model) {
		            var that = this;
		            var column;
		            var cell;
		            var command;
		            var fields = [];
	
		            if (that.trigger(BEFOREEDIT, { model: model })) {
		                return;
		            }
	
		            if (that.lockedContent) {
		                row = row.add(that._relatedRow(row));
		            }
	
		            row.children(":not(.k-group-cell,.k-hierarchy-cell)").each(function() {
		                cell = $(this);
		                column = leafColumns(that.columns)[that.cellIndex(cell)];
	
		                if (!column.command && isColumnEditable(column, model)) {
		                    fields.push({ field: column.field, format: column.format, editor: column.editor, values: column.values });
		                    cell.attr(kendo.attr("container-for"), column.field);
		                    cell.empty();
		                } else if (column.command) {
		                    command = getCommand(column.command, "edit");
		                    if (command) {
		                        cell.empty();
	
		                        var updateText,
		                            cancelText,
		                            updateIconClass,
		                            cancelIconClass,
		                            attr;
	
		                        if (isPlainObject(command)) {
		                                if (isPlainObject(command.text)) {
		                                    updateText = command.text.update;
		                                    cancelText = command.text.cancel;
		                                }
		                                if (isPlainObject(command.iconClass)) {
		                                    updateIconClass = command.iconClass.update;
		                                    cancelIconClass = command.iconClass.cancel;
		                                }
	
		                            if (command.attr) {
		                                attr = command.attr;
		                            }
		                        }
	
		                        $(that._createButton({ name: "update", text: updateText, attr: attr, iconClass: updateIconClass }) +
		                            that._createButton({ name: "canceledit", text: cancelText, attr: attr, iconClass: cancelIconClass })).appendTo(cell);
		                    }
		                }
		            });
	
		            that._editContainer = row;
		            that._editContainer.addClass("k-grid-edit-row");
	
		            if (that._shouldClearEditableState) {
		                that._clearEditableState();
		            }
	
		            that.editable = new kendo.ui.Editable(that._editContainer, {
		                target: that,
		                fields: fields,
		                model: model,
		                skipFocus: that._isVirtualInlineEditable() && that._editableState && that._editableState.field ? true : false,
		                clearContainer: false
		            });
	
		            if (row.length > 1) {
	
		                adjustRowHeight(row[0], row[1]);
		                that._applyLockedContainersWidth();
		            }
	
		            that.trigger(EDIT, { container: row, model: model });
		        },
	
		        cancelRow: function(notify) {
		            var that = this,
		                container = that._editContainer,
		                model;
	
		            if (container) {
		                model = that._modelForContainer(container);
	
		                if (!model || (notify && that.trigger("cancel", { container: container, model: model }))) {
		                    return;
		                }
	
		                that._destroyEditable();
	
		                that.dataSource.cancelChanges(model);
	
		                that._clearEditableState();
	
		                if (that._editMode() !== "popup") {
		                    that._displayRow(container);
		                } else {
		                    that._displayRow(that.tbody.find("[" + kendo.attr("uid") + "=" + model.uid + "]"));
		                }
		            }
		        },
	
		        saveRow: function() {
		            var that = this;
		            var container = this._editContainer;
		            var model = this._modelForContainer(container);
		            var deferred = $.Deferred();
		            var valid;
	
		            if (!container || !this.editable) {
		                return deferred.resolve().promise();
		            }
	
		            valid = that.editable && that.editable.end();
	
		            if (!valid || this.trigger(SAVE, { container: container, model: model })) {
		                if (!valid) {
		                    that._scrollVirtualWrapper();
		                }
	
		                return deferred.reject().promise();
		            }
	
		            that._clearEditableState();
	
		            return this.dataSource.sync();
		        },
	
		        _displayRow: function(row) {
		            var that = this,
		                model = that._modelForContainer(row),
		                related,
		                newRow,
		                nextRow,
		                isSelected = row.hasClass("k-state-selected"),
		                isAlt = row.hasClass("k-alt");
	
		            if (model) {
	
		                if (that.lockedContent) {
		                    related = $((isAlt ? that.lockedAltRowTemplate : that.lockedRowTemplate)(model));
		                    that._relatedRow(row.last()).replaceWith(related);
		                }
	
		                that.angular("cleanup", function(){ return { elements: row.get() }; });
	
		                newRow = $((isAlt ? that.altRowTemplate : that.rowTemplate)(model));
		                if(!row.is(":visible")) {
		                    newRow.hide();
		                }
		                row.replaceWith(newRow);
	
		                that.trigger("itemChange", { item: newRow, data: model, ns: ui });
	
		                if (related && related.length) {
		                    that.trigger("itemChange", { item: related, data: model, ns: ui });
		                }
	
		                var angularElements = newRow;
		                var angularData = [{ dataItem: model }];
	
		                if (related && related.length) {
		                    angularElements = newRow.add(related);
		                    angularData.push({ dataItem: model });
		                }
	
		                that.angular("compile", function(){
		                    return {
		                        elements: angularElements.get(),
		                        data: angularData
		                    };
		                });
	
	
		                if (isSelected && (that.options.selectable || that._checkBoxSelection)) {
		                    that.select(newRow.add(related));
		                }
	
		                if (related) {
		                    adjustRowHeight(newRow[0], related[0]);
		                }
	
		                nextRow = newRow.next();
		                if (nextRow.hasClass("k-detail-row") && nextRow.is(":visible")) {
		                    newRow.find(".k-hierarchy-cell .k-icon")
		                        .removeClass("k-i-expand")
		                        .addClass("k-i-collapse");
		                }
		            }
		        },
	
		        _showMessage: function(messages, row) {
		            var that = this;
	
		            if (!that._isMobile) {
		                return window.confirm(messages.title);
		            }
	
		            var template = kendo.template('<ul>'+
		                '<li class="km-actionsheet-title">#:title#</li>'+
		                '<li><a href="\\#" class="k-button k-grid-delete">#:confirmDelete#</a></li>'+
		            '</ul>');
	
		            var html = $(template(messages)).appendTo(that.view.element);
	
		            var actionSheet = that._actionSheet = new kendo.mobile.ui.ActionSheet(html, {
		                cancel: messages.cancelDelete,
		                cancelTemplate: '<li class="km-actionsheet-cancel"><a class="k-button" href="\\#">#:cancel#</a></li>',
		                close: function() {
		                    this.destroy();
		                },
		                command: function(e) {
		                    var item = $(e.currentTarget).parent();
		                    if (!item.hasClass("km-actionsheet-cancel")) {
		                        that._removeRow(row);
		                    }
		                },
		                popup: that._actionSheetPopupOptions
		            });
	
		            actionSheet.open(row);
	
		            return false;
		        },
	
		        _confirmation: function(row) {
		            var that = this,
		                editable = that.options.editable,
		                confirmation = (editable === true || typeof editable === STRING) ? that.options.messages.editable.confirmation : editable.confirmation;
	
		            if (isPlainObject(editable) && typeof editable.mode === STRING && typeof confirmation !== FUNCTION && typeof confirmation !== STRING && confirmation !== false) {
		                confirmation = that.options.messages.editable.confirmation;
		            }
	
		            if (confirmation !== false && confirmation != null) {
	
		                if (typeof confirmation === FUNCTION) {
		                    confirmation = confirmation(that._modelForContainer(row));
		                }
	
		                return that._showMessage({
		                        confirmDelete: editable.confirmDelete || that.options.messages.editable.confirmDelete,
		                        cancelDelete: editable.cancelDelete || that.options.messages.editable.cancelDelete,
		                        title: confirmation === true ? that.options.messages.editable.confirmation : confirmation
		                    }, row);
		            }
	
		            return true;
		        },
	
		        cancelChanges: function() {
		            var that = this;
	
		            that.dataSource.cancelChanges();
	
		            if (that._isVirtualEditable()) {
		                that._virtualPageToTop(function() {
		                    that.virtualScrollable.scrollToTop();
		                });
		            }
		        },
	
		        saveChanges: function() {
		            var that = this;
		            var valid = that.editable && that.editable.end();
	
		            if ((valid || !that.editable) && !that.trigger(SAVECHANGES)) {
		                that.dataSource.sync();
		            } else if (!valid) {
		                that._scrollVirtualWrapper();
		            }
		        },
	
		        addRow: function() {
		            var that = this,
		                index,
		                dataSource = that.dataSource,
		                mode = that._editMode(),
		                createAt = that.options.editable.createAt || "",
		                pageSize = dataSource.pageSize(),
		                view = dataSource.view() || [];
		            var createAtBottom = createAt.toLowerCase() === BOTTOM;
		            var model;
		            var virtualEditable = that._isVirtualEditable();
	
		            if ((that.editable && that.editable.end()) || !that.editable) {
		                if (mode != "incell") {
		                    that.cancelRow();
		                }
	
		                index = dataSource.indexOf(view[0]);
	
		                if (createAtBottom) {
		                    index += view.length;
	
		                    if (pageSize && !dataSource.options.serverPaging && pageSize <= view.length) {
		                        index -= 1;
		                    }
		                }
	
		                if (index < 0) {
		                    if (dataSource.page() > dataSource.totalPages()) {
		                        index = (dataSource.page() - 1) * pageSize;
		                    } else {
		                        index = 0;
		                    }
		                }
	
		                if (that.options.navigatable && mode == "incell") {
		                    that._removeCurrent();
		                }
	
		                if (virtualEditable) {
		                    that._virtualAddRow();
		                } else {
		                    model = dataSource.insert(index, {});
		                    that._editModel(model);
		                }
		            } else {
		                that._scrollVirtualWrapper();
		            }
		        },
	
		        _editModel: function(model) {
		            var that = this;
		            var createAt = that.options.editable.createAt || "";
		            var mode = that._editMode();
	
		            if (model) {
		                var id = model.uid,
		                    table = that.lockedContent ? that.lockedTable : that.table,
		                    row = table.find("tr[" + kendo.attr("uid") + "=" + id + "]"),
		                    cell = row.children("td:not(.k-group-cell,.k-hierarchy-cell)").eq(that._firstEditableColumnIndex(row));
	
		                if (mode === "inline" && row.length) {
		                    that.editRow(row);
		                } else if (mode === "popup") {
		                    that.editRow(model);
		                } else if (cell.length) {
		                    that.editCell(cell);
		                }
	
		                if (createAt.toLowerCase() == "bottom" && that.lockedContent) {
		                    //scroll the containers to the bottom
		                    that.lockedContent[0].scrollTop = that.content[0].scrollTop = that.table[0].offsetHeight;
		                }
		            }
		        },
	
		        _virtualAddRow: function() {
		            var that = this;
		            var createAtBottom = (that.options.editable.createAt || "").toLowerCase() === BOTTOM;
	
		            that._clearEditableState();
	
		            if (createAtBottom) {
		                that._virtualAddRowAtBottom();
		            } else {
		                that._virtualAddRowAtTop();
		            }
		        },
	
		        _virtualAddRowAtTop: function() {
		            var that = this;
		            var dataSource = that.dataSource;
		            var virtualScrollable = that.virtualScrollable;
		            var model;
	
		            if (dataSource.page() === 1) {
		                model = dataSource.insert(0, {});
		                that._editModel(model);
		                virtualScrollable.scrollToTop();
		            } else {
		                that._virtualPageToTop(function() {
		                    model = dataSource.insert(0, {});
		                    that._editModel(model);
		                    virtualScrollable.scrollToTop();
		                });
		            }
		        },
	
		        _virtualAddRowAtBottom: function() {
		            var that = this;
		            var dataSource = that.dataSource;
		            var virtualScrollable = that.virtualScrollable;
		            var index = dataSource.total();
		            var model;
	
		            if (dataSource.at(index - 1) instanceof ObservableObject) {
		                model = dataSource.insert(index, {});
	
		                that._virtualPageToBottom(function() {
		                    that._editModel(model);
		                    virtualScrollable.scrollToBottom();
		                });
		            } else {
		                that._virtualPageToBottom(function() {
		                    model = dataSource.insert(index, {});
		                    that._editModel(model);
		                    virtualScrollable.scrollToBottom();
		                });
		            }
		        },
	
		        _virtualPageToTop: function(callback) {
		            var that = this;
	
		            that._virtualPage(0, that.dataSource.take(), function() {
		                callback();
		            });
		        },
	
		        _virtualPageToBottom: function(callback) {
		            var that = this;
		            var dataSource = that.dataSource;
		            var take = dataSource.take();
		            var total = dataSource.total();
		            var skip = total > take ? (total - take) : 0;
	
		            that._virtualPage(skip, take, function() {
		                callback();
		            });
		        },
	
		        _virtualPage: function(skip, take, callback) {
		            var that = this;
	
		            if (that._isVirtualEditable()) {
		                that.virtualScrollable._preventScroll = true;
		                that.virtualScrollable._page(skip, take, callback);
		            }
		        },
	
		        _firstEditableColumnIndex: function(container) {
		            var that = this,
		                column,
		                columns = leafColumns(that.columns),
		                idx,
		                length,
		                model = that._modelForContainer(container);
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                column = columns[idx];
	
		                if (model && (!model.editable || model.editable(column.field)) && !column.command && column.field && column.hidden !== true) {
		                    return idx;
		                }
		            }
		            return -1;
		        },
	
		        _toolbar: function() {
		            var that = this,
		                wrapper = that.wrapper,
		                toolbar = that.options.toolbar,
		                editable = that.options.editable,
		                container;
	
		            if (toolbar) {
		                container = that.wrapper.find(".k-grid-toolbar");
	
		                if (!container.length) {
		                    if (!isFunction(toolbar)) {
		                        toolbar = (typeof toolbar === STRING ? toolbar : that._toolbarTmpl(toolbar).replace(templateHashRegExp, "\\#"));
		                        toolbar = proxy(kendo.template(toolbar), that);
		                    }
	
		                    container = $('<div class="k-header k-grid-toolbar" />')
		                        .html(toolbar({}))
		                        .prependTo(wrapper);
	
		                    that.angular("compile", function(){
		                        return { elements: container.get() };
		                    });
		                }
	
		                if (editable && editable.create !== false) {
		                    container.on(CLICK + NS, ".k-grid-add", function(e) { e.preventDefault(); that.addRow(); })
		                        .on(CLICK + NS, ".k-grid-cancel-changes", function(e) { e.preventDefault(); that.cancelChanges(); })
		                        .on(CLICK + NS, ".k-grid-save-changes", function(e) { e.preventDefault(); that.saveChanges(); });
		                }
	
		                container.on(CLICK + NS, ".k-grid-excel", function(e) {
		                    e.preventDefault();
	
		                    that.saveAsExcel();
		                });
	
		                container.on(CLICK + NS, ".k-grid-pdf", function(e) {
		                    e.preventDefault();
	
		                    that.saveAsPDF();
		                });
		            }
		        },
	
		        _toolbarTmpl: function(commands) {
		            var that = this,
		                idx,
		                length,
		                html = "";
	
		            if (isArray(commands)) {
		                for (idx = 0, length = commands.length; idx < length; idx++) {
		                    html += that._createButton(commands[idx]);
		                }
		            }
		            return html;
		        },
	
		        _createButton: function(command) {
		            var template = command.template || COMMANDBUTTONTMPL,
		                commandName = typeof command === STRING ? command : command.name || command.text,
		                className = defaultCommands[commandName] ? defaultCommands[commandName].className : "k-grid-" + (commandName || "").replace(/\s/g, ""),
		                options = { className: className, text: commandName, attr: "", iconClass: "" },
		                messages = this.options.messages.commands,
		                attributeClassMatch;
	
		            if (!commandName && !(isPlainObject(command) && command.template))  {
		                throw new Error("Custom commands should have name specified");
		            }
	
		            if (isPlainObject(command)) {
		                command = extend(true, {}, command);
	
		                if (command.className && inArray(options.className, command.className.split(" ")) < 0) {
		                    command.className += " " + options.className;
		                } else if (command.className === undefined) {
		                    command.className = options.className;
		                }
	
		                if (commandName === "edit") {
		                    command = extend(true, {}, command);
		                    command.text = isPlainObject(command.text) ? command.text.edit : command.text;
		                    command.iconClass = isPlainObject(command.iconClass) ? command.iconClass.edit : command.iconClass;
		                }
	
		                if (command.attr) {
		                    if (isPlainObject(command.attr)) {
		                        command.attr = stringifyAttributes(command.attr);
		                    }
	
		                    if (typeof command.attr === STRING) {
		                        attributeClassMatch = command.attr.match(/class="(.+?)"/);
	
		                        if (attributeClassMatch && inArray(attributeClassMatch[1], command.className.split(" ")) < 0) {
		                            command.className += " " + attributeClassMatch[1];
		                        }
		                    }
		                }
	
		                options = extend(true, options, defaultCommands[commandName], { text: messages[commandName] }, command);
		            } else {
		                options = extend(true, options, defaultCommands[commandName], { text: messages[commandName] });
		            }
	
		            return kendo.template(template)(options);
		        },
	
		        _hasFooters: function() {
		            return !!this.footerTemplate ||
		                !!this.groupFooterTemplate ||
		                (this.footer && this.footer.length > 0) ||
		                this.wrapper.find(".k-grid-footer").length > 0;
		        },
	
		        _groupable: function() {
		            var that = this;
	
		            if (that._groupableClickHandler) {
		                that.table.add(that.lockedTable).off(CLICK + NS, that._groupableClickHandler);
		            } else {
		                that._groupableClickHandler = function(e) {
		                    var element = $(this),
		                    groupRow = element.closest("tr");
	
		                    var group = that._groupRows ? that._groupRows[that.wrapper.find(".k-grouping-row").index(groupRow)] : { };
	
		                    if(element.hasClass('k-i-collapse')) {
		                        if (!that.trigger("groupCollapse", { group: group, element: groupRow})) {
		                            that.collapseGroup(groupRow);
		                        }
		                    } else {
		                        if (!that.trigger("groupExpand",  { group: group, element: groupRow})) {
		                            that.expandGroup(groupRow);
		                        }
		                    }
		                    e.preventDefault();
		                    e.stopPropagation();
		                };
		            }
	
		            if (that._isLocked()) {
		                that.lockedTable.on(CLICK + NS, ".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse", that._groupableClickHandler);
		            } else {
		                that.table.on(CLICK + NS, ".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse", that._groupableClickHandler);
		            }
	
		            that._attachGroupable();
		        },
	
		        _attachGroupable: function() {
		            var that = this,
		                wrapper = that.wrapper,
		                groupable = that.options.groupable,
		                draggables = HEADERCELLS + "[" + kendo.attr("field") + "]",
		                filter = that.content ? ".k-grid-header:first " + draggables  : "table:first>.k-grid-header " + draggables;
	
		            if (groupable && groupable.enabled !== false) {
	
		                if(!wrapper.has("div.k-grouping-header")[0]) {
		                    $("<div>&nbsp;</div>").addClass("k-grouping-header").prependTo(wrapper);
		                }
	
		                if (that.groupable) {
		                    that.groupable.destroy();
		                }
	
		                that.groupable = new ui.Groupable(wrapper, extend({}, groupable, {
		                    draggable: that._draggableInstance,
		                    groupContainer: ">div.k-grouping-header",
		                    dataSource: that.dataSource,
		                    draggableElements: filter,
		                    filter: filter,
		                    allowDrag: that.options.reorderable,
		                    change: function(e) {
		                        if(that.trigger("group", { groups: e.groups })) {
		                            e.preventDefault();
		                        } else {
		                            that._clearEditableState();
		                            if (that.dataSource.options.endless) {
		                                that.dataSource.options.endless = null;
		                                that._endlessPageSize = that.dataSource.options.pageSize;
		                                that.dataSource._skip = 0;
		                                that.dataSource._pageSize = that.dataSource._take = that._endlessPageSize;
		                                that.dataSource._page = 1;
		                            }
		                        }
		                    }
		                }));
	
		            }
		        },
	
		        _continuousItems: function(filter, cell) {
		            if (!this.lockedContent) {
		                return;
		            }
	
		            var that = this;
	
		            var elements = that.table.add(that.lockedTable);
	
		            var lockedItems = $(filter, elements[0]);
		            var nonLockedItems = $(filter, elements[1]);
		            var columns = cell ? lockedColumns(that.columns).length : 1;
		            var nonLockedColumns = cell ? that.columns.length - columns : 1;
		            var result = [];
	
		            for (var idx = 0; idx < lockedItems.length; idx += columns) {
		                push.apply(result, lockedItems.slice(idx, idx + columns));
		                push.apply(result, nonLockedItems.splice(0, nonLockedColumns));
		            }
	
		            return result;
		        },
	
		        _selectable: function() {
		            var that = this,
		                multi,
		                cell,
		                notString = [],
		                isLocked = that._isLocked(),
		                selectable = that.options.selectable;
	
		            if (selectable) {
	
		                if (that.selectable) {
		                    that.selectable.destroy();
		                }
	
		                that._selectedIds = {};
	
		                selectable = kendo.ui.Selectable.parseOptions(selectable);
	
		                multi = selectable.multiple;
		                cell = selectable.cell;
	
		                if (that._hasDetails()) {
		                    notString[notString.length] = ".k-detail-row";
		                }
		                if (that.options.groupable || that._hasFooters() || that._groups()) {
		                    notString[notString.length] = ".k-grouping-row,.k-group-footer";
		                }
	
		                notString = notString.join(",");
	
		                if (notString !== "") {
		                    notString = ":not(" + notString + ")";
		                }
	
		                var elements = that.table;
		                if (isLocked) {
		                    elements = elements.add(that.lockedTable);
		                }
	
		                var filter = ">" + (cell ? SELECTION_CELL_SELECTOR : "tbody>tr" + notString);
		                that.selectable = new kendo.ui.Selectable(elements, {
		                    filter: filter,
		                    aria: true,
		                    multiple: multi,
		                    change: function() {
		                        if (!cell) {
		                            that._persistSelectedRows();
		                        }
	
		                        that.trigger(CHANGE);
		                    },
		                    useAllItems: isLocked && multi && cell,
		                    relatedTarget: function(items) {
		                        if (cell || !isLocked) {
		                            return;
		                        }
	
		                        var related;
		                        var result = $();
		                        for (var idx = 0, length = items.length; idx < length; idx ++) {
		                            related = that._relatedRow(items[idx]);
	
		                            if (inArray(related[0], items) < 0) {
		                                result = result.add(related);
		                            }
		                        }
	
		                        return result;
		                    },
		                    continuousItems: function() {
		                        return that._continuousItems(filter, cell);
		                    }
		                });
	
		                if (that.options.navigatable) {
		                    elements.on("keydown" + NS, function(e) {
		                        var current = that.current();
		                        var target = e.target;
		                        if (e.keyCode === keys.SPACEBAR && !e.shiftKey && $.inArray(target, elements) > -1 &&
		                            !current.is(".k-edit-cell,.k-header") &&
		                            current.parent().is(":not(.k-grouping-row,.k-detail-row,.k-group-footer)")) {
		                                e.preventDefault();
		                                e.stopPropagation();
		                                current = cell ? current : current.parent();
	
		                                if (isLocked && !cell) {
		                                    current = current.add(that._relatedRow(current));
		                                }
	
		                                if(multi) {
		                                    if(!e.ctrlKey) {
		                                        that.selectable.clear();
		                                    } else {
		                                        if(current.hasClass(SELECTED)) {
		                                            current.removeClass(SELECTED);
		                                            that.trigger(CHANGE);
		                                            return;
		                                        }
		                                    }
		                                } else {
		                                    that.selectable.clear();
		                                }
		                                if (!cell) {
		                                    that.selectable._lastActive = current;
		                                }
		                                that.selectable.value(current);
		                        } else if(!cell &&
		                            ($(target).is("td") || ($(target).is("table") && inArray(target, this._navigatableTables))) &&
		                          ((e.shiftKey && e.keyCode == keys.LEFT)||
		                           (e.shiftKey && e.keyCode == keys.RIGHT)||
		                           (e.shiftKey && e.keyCode == keys.UP)||
		                           (e.shiftKey && e.keyCode == keys.DOWN)||
		                           (e.keyCode === keys.SPACEBAR && e.shiftKey))) {
		                            e.preventDefault();
		                            e.stopPropagation();
		                            current = current.parent();
	
		                            if (isLocked) {
		                                current = current.add(that._relatedRow(current));
		                            }
	
		                            if (multi) {
		                                if(!that.selectable._lastActive) {
		                                    that.selectable._lastActive = current;
		                                }
		                                that.selectable.selectRange(that.selectable._firstSelectee(), current);
		                            } else {
		                                that.selectable.clear();
		                                that.selectable.value(current);
		                            }
		                        }
		                    });
		                }
		            }
		        },
	
		        _clipboard: function() {
		            var options = this.options;
		            var selectable = options.selectable;
		            if (selectable && options.allowCopy) {
		                var grid = this;
		                if (!options.navigatable) {
		                    grid.table.add(grid.lockedTable)
		                        .attr("tabindex", 0)
		                        .on("mousedown" + NS + " keydown" + NS, ".k-detail-cell", function(e) {
		                            if (e.target !== e.currentTarget) {
		                                e.stopImmediatePropagation();
		                            }
		                        })
		                        .on("mousedown" + NS, NAVROW + ">" + NAVCELL, proxy(tableClick, grid));
		                }
		                grid.copyHandler = proxy(grid.copySelection, grid);
		                grid.updateClipBoardState = function () {
		                    if (grid.areaClipBoard) {
		                        grid.areaClipBoard.val(grid.getTSV()).focus().select();
		                    }
		                };
		                grid.bind("change",grid.updateClipBoardState);
		                grid.wrapper.on("keydown", grid.copyHandler);
		                grid.clearAreaHandler = proxy(grid.clearArea, grid);
		                grid.wrapper.on("keyup", grid.clearAreaHandler);
		            }
		        },
	
		        copySelection: function(e) {
		            if ((e instanceof jQuery.Event && !(e.ctrlKey || e.metaKey)) ||
		                $(e.target).is("input:visible,textarea:visible") ||
		                (window.getSelection && window.getSelection().toString()) ||
		                (document.selection && document.selection.createRange().text) ) {
		                return;
		            }
	
	
		            if (!this.areaClipBoard) {
		                this.areaClipBoard =
		                    $("<textarea />")
		                    .css({
		                        position: "fixed",
		                        top: "50%",
		                        left:"50%",
		                        opacity: 0,
		                        width: 0,
		                        height: 0
		                    })
		                    .appendTo(this.wrapper);
		            }
	
		            this.areaClipBoard.val(this.getTSV()).focus().select();
	
		        },
	
		        getTSV: function() {
		            var grid = this;
		            var selected = grid.select();
		            var delimeter = "\t";
		            var allowCopy = grid.options.allowCopy;
		            var onlyVisible = true;
	
		            if ($.isPlainObject(allowCopy) && allowCopy.delimeter) {
		                delimeter = allowCopy.delimeter;
		            }
		            var text = "";
		            if (selected.length) {
		                if (selected.eq(0).is("tr")) {
		                    selected = selected.find("td:not(.k-group-cell)");
		                }
		                if (onlyVisible) {
		                    selected.filter(":visible");
		                }
	
		                var result = [];
		                var cellsOffset = this.columns.length;
		                var lockedCols = grid._isLocked() && lockedColumns(grid.columns).length;
		                var inLockedArea = true;
	
		                $.each(selected, function (idx, cell) {
		                    cell = $(cell);
		                    var tr = cell.closest("tr");
		                    var rowIndex = tr.index();
		                    var cellIndex = cell.index();
		                    if (onlyVisible) {
		                        cellIndex -= cell.prevAll(":hidden").length;
		                    }
		                    if (lockedCols && inLockedArea) {
		                        inLockedArea = $.contains(grid.lockedTable[0], cell[0]);
		                    }
		                    if (grid._groups() && inLockedArea) {
		                        cellIndex -= grid._groups();
		                    }
		                    cellIndex = inLockedArea ? cellIndex : (cellIndex + lockedCols );
		                    if (cellsOffset > cellIndex) {
		                        cellsOffset = cellIndex;
		                    }
		                    var cellText = cell.text();
		                    if (!result[rowIndex]) {
		                        result[rowIndex] = [];
		                    }
		                    result[rowIndex][cellIndex] = cellText;
	
		                });
	
		                var rowsOffset = result.length;
		                result = $.each(result, function (idx, val) {
		                    if (val) {
		                        result[idx] = val.slice(cellsOffset);
		                        if (rowsOffset > idx) {
		                            rowsOffset = idx;
		                        }
		                    }
		                });
	
		                $.each(result.slice(rowsOffset), function (idx, val) {
		                    if (val) {
		                        text += val.join(delimeter) + "\r\n";
		                    } else {
		                        text +=  "\r\n";
		                    }
		                });
		            }
		            return text;
		        },
	
		        clearArea: function (e) {
		            var table;
		            if (this.areaClipBoard && e && e.target === this.areaClipBoard[0]) {
		                if (this.options.navigatable) {
		                    table = $(this.current()).closest("table");
		                } else {
		                    table = this.table;
		                }
		                focusTable(table, true);
		            }
	
		            if (this.areaClipBoard) {
		                this.areaClipBoard.remove();
		                this.areaClipBoard = null;
		            }
		        },
	
		        _adaptiveColumns: function() {
		            var that = this;
	
		            if (that._anyColumnHasMediaQuery()) {
		                that._setColumnsMediaVisibility(that.columns);
		                that._attachColumnMediaResizeHandler();
		            }
		        },
	
		        _anyColumnHasMediaQuery: function() {
		            return this._columnsWithMediaQuery().length;
		        },
	
		        _columnsWithMediaQuery: function() {
		            return columnsWithMedia(this.columns);
		        },
	
		        _attachColumnMediaResizeHandler: function() {
		            var that = this;
	
		            that._detachColumnMediaResizeHandler();
		            that._columnMediaResizeHandler = proxy(that._onColumnMediaResize, that);
		            $(window).on(RESIZE + NS, that._columnMediaResizeHandler);
		        },
	
		        _detachColumnMediaResizeHandler: function() {
		            var that = this;
	
		            if (that._columnMediaResizeHandler) {
		                $(window).off(RESIZE + NS, that._columnMediaResizeHandler);
		            }
		        },
	
		        _onColumnMediaResize: function() {
		            var that = this;
		            that._setColumnsMediaVisibility(that.columns);
		            that._setContentMediaWidth();
		        },
	
		        _setColumnsMediaVisibility: function(columns) {
		            var cols = columns || [];
	
		            for (var i = 0; i < cols.length; i++) {
		                this._setColumnMediaVisibility(cols[i]);
		            }
		        },
	
		        _setColumnMediaVisibility: function(column) {
		            var that = this;
	
		            if (isUndefined(column.media)) {
		                that._setColumnsMediaVisibility(column.columns);
		            } else {
		                if (columnMatchesMedia(column)) {
		                    that._showColumnByMedia(column);
	
		                    if (!column.hidden) {
		                        that._setColumnsMediaVisibility(column.columns);
		                    }
		                } else {
		                    that._hideColumnByMedia(column);
		                }
		            }
		        },
	
		        _showColumnByMedia: function(column) {
		            if (!column.hidden) {
		                // "hidden" has a priority over "matchesMedia"
		                this.showColumn(column);
		            }
	
		            setColumnMatchesMedia(column);
		        },
	
		        _hideColumnByMedia: function(column) {
		            var initiallyHidden = column.hidden;
	
		            if (!initiallyHidden) {
		                column._hideByMedia = true;
		                this.hideColumn(column);
		                column._hideByMedia = false;
	
		                // hiding is tracked in "matchesMedia" instead of "hidden" flag
		                column.hidden = initiallyHidden;
		            }
	
		            setColumnMatchesMedia(column);
		        },
	
		        _setContentMediaWidth: function() {
		            var that = this;
		            var options = that.options;
		            var isLocked = that._isLocked();
		            var footer;
	
		            if (options.scrollable && options.resizable) {
		                if (isLocked && that.lockedFooter) {
		                    footer = that.lockedFooter.children("table");
		                } else if (that.footer) {
		                    footer = that.footer.find(">.k-grid-footer-wrap>table");
		                }
	
		                if (!footer || !footer[0]) {
		                    footer = $();
		                }
	
		                var header = isLocked ? that.wrapper.find(".k-grid-header-locked").find("table") : that.wrapper.find(".k-grid-header").find("table");
		                var contentTable = isLocked ? that.lockedTable : that.table;
	
		                var headerColumns = header.find("th");
		                var headerColgroup = header.find("colgroup");
	
		                var headerColumnsCount = headerColumns.length;
		                var visibleHeaderColumnsCount = headerColumns.filter(isCellVisible).length;
		                var hiddenHeaderColumnsCount = headerColumns.length - visibleHeaderColumnsCount;
	
		                var totalHeaderWidth = 0;
	
		                if (header[0].style.width !== "" && parseFloat(header[0].style.width) !== totalHeaderWidth) {
		                    var currentHeaderWidth = header.css("width");
	
		                    for (var i = 0; i < headerColumnsCount; i++) {
		                        if (isElementVisible(headerColumns[i])) {
		                            var columnWidth;
		                            var cellIndex = Math.max(i, (i - hiddenHeaderColumnsCount));
		                            var colgroupChild = headerColgroup.children()[cellIndex];
		                            var columnStyleWidth = colgroupChild ? colgroupChild.style.width : "";
	
		                            if (columnStyleWidth !== "") {
		                                columnWidth = parseFloat(columnStyleWidth);
		                            } else {
		                                // remove the header width to calculate the height of a column without fixed width
		                                header.css("width", "auto");
		                                columnWidth = outerWidth(headerColumns.eq(i));
		                                header.css("width", currentHeaderWidth);
		                            }
	
		                            totalHeaderWidth += columnWidth;
		                        }
		                    }
	
		                    contentTable.css('width', totalHeaderWidth - 1); // subtract 1 to remove the horizontal scroll
		                    header.css('width', totalHeaderWidth);
		                    footer.css('width', totalHeaderWidth);
		                }
		            }
		        },
	
		        _minScreenSupport: function() {
		            var any = this.hideMinScreenCols();
	
		            if (any) {
		                this.minScreenResizeHandler = proxy(this.hideMinScreenCols, this);
		                $(window).on("resize", this.minScreenResizeHandler);
		            }
		        },
	
		        hideMinScreenCols: function() {
		            var cols = this.columns,
		                screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	
		            return this._iterateMinScreenCols(cols, screenWidth);
		        },
	
		        _iterateMinScreenCols: function (cols, screenWidth) {
		            var any = false;
	
		            for (var i = 0; i < cols.length; i++) {
		                var col = cols[i];
		                var minWidth = col.minScreenWidth;
		                if (minWidth !== undefined && minWidth !== null) {
		                    any = true;
		                    if (minWidth > screenWidth) {
		                        this.hideColumn(col);
		                    } else {
		                        this.showColumn(col);
		                    }
		                }
		                if (!col.hidden && col.columns) {
		                    any = this._iterateMinScreenCols(col.columns, screenWidth) || any;
		                }
		            }
		            return any;
		        },
	
		        _relatedRow: function(row) {
		            var lockedTable = this.lockedTable;
		            row = $(row);
	
		            if (!lockedTable) {
		                return row;
		            }
	
		            var table = row.closest(this.table.add(this.lockedTable));
		            var index = table.find(">tbody>tr").index(row);
	
		            table = table[0] === this.table[0] ? lockedTable : this.table;
	
		            return table.find(">tbody>tr").eq(index);
		        },
	
		        _relatedCell: function(cell) {
		            var lockedTable = this.lockedTable;
	
		            cell = $(cell);
	
		            if (!lockedTable) {
		                return cell;
		            }
	
		            var table = cell.closest(this.table.add(this.lockedTable));
		            var index = table.find(">tbody>tr>td").index(cell);
	
		            table = table[0] === this.table[0] ? lockedTable : this.table;
	
		            return table.find(">tbody>tr>td").index(index);
		        },
	
		        clearSelection: function() {
		            var that = this;
	
		            if (that.selectable) {
		                that.selectable.clear();
		            }
	
		            if (that._checkBoxSelection) {
		                that._deselectCheckRows(that.select());
		                return;
		            }
	
		            if (that.options.persistSelection) {
		                that._persistSelectedRows();
		            } else {
		                that._selectedIds = {};
		            }
	
		            that.trigger(CHANGE);
		        },
	
		        select: function(items) {
		            var that = this,
		                selectable = that.selectable,
		                selectableoptions = kendo.ui.Selectable.parseOptions(this.options.selectable),
		                cell = selectableoptions.cell;
	
		            items = that.table.add(that.lockedTable).find(items);
		            if(items.length) {
		                if(selectable && !selectable.options.multiple) {
		                    selectable.clear();
		                    items = items.first();
		                }
	
		                if (that._isLocked()) {
		                    items = items.add(items.map(function() {
		                        if (cell) {
		                            return that._relatedCell(this);
		                        }
		                        else {
		                            return that._relatedRow(this);
		                        }
		                    }));
		                }
	
		                if(selectable) {
		                   selectable.value(items);
		                } else {
		                    items.each(function() {
		                        $(this).addClass(SELECTED).find(CHECKBOXINPUT).prop("checked", true)
		                            .attr("aria-label", "Deselect row").attr("aria-checked", true);
		                    });
	
		                    if(that.select().length === that.items().length) {
		                        that._toggleHeaderCheckState(true);
		                    }
	
		                    if (!cell) {
		                        that._persistSelectedRows();
		                    }
	
		                    that.trigger(CHANGE);
		                }
	
		                return;
		            }
	
		            return selectable ? selectable.value() : that.items().filter("." + SELECTED);
		        },
	
		        _toggleHeaderCheckState: function(checked) {
		            var that = this;
		            if(checked) {
		                that.thead.add(that.lockedHeader).find("tr " + CHECKBOXINPUT)
		                    .prop("checked", true).attr("aria-checked", true)
		                    .attr("aria-label", "Deselect all rows");
		            } else {
		                that.thead.add(that.lockedHeader).find("tr " + CHECKBOXINPUT)
		                    .prop("checked", false).attr("aria-checked", false)
		                    .attr("aria-label", "Select all rows");
		            }
		        },
	
		        _deselectCheckRows: function(items) {
		            var that = this;
		            items = that.table.add(that.lockedTable).find(items);
	
		            if (that._isLocked()) {
		                items = items.add(items.map(function() {
		                    return that._relatedRow(this);
		                }));
		            }
	
		            items.each(function() {
		                $(this).removeClass(SELECTED).find(CHECKBOXINPUT).attr("aria-checked", false)
		                    .prop("checked", false).attr("aria-label", "Select row");
		            });
		            that._toggleHeaderCheckState(false);
	
		            that._persistSelectedRows();
	
		            that.trigger(CHANGE);
		        },
	
		        _persistSelectedRows: function() {
		            var that = this,
		                key,
		                dataItem,
		                allRows = that.items(),
		                dataSourceOptions = that.dataSource.options,
		                schema = dataSourceOptions.schema,
		                modelId,
		                selectedViewIds = {};
	
		            if (!schema || !schema.model || !that._data) {
		                return;
		            }
	
		            modelId = isFunction(schema.model) ? schema.model.fn.idField : schema.model.id;
	
		            if (!modelId) {
		                return;
		            }
	
		            that.select().each(function() {
		                dataItem = that.dataItem(this);
		                selectedViewIds[dataItem[modelId]] = true;
		            });
	
		            for (var i = 0; i < allRows.length; i ++) {
		                dataItem = that.dataItem(allRows[i]);
		                key = dataItem[modelId];
		                if(selectedViewIds[key]) {
		                    that._selectedIds[key] = true;
		                } else {
		                    delete that._selectedIds[key];
		                }
		            }
		        },
	
		        selectedKeyNames: function() {
		            var that = this,
		                ids = [];
		            for (var property in that._selectedIds) {
		                ids.push(property);
		            }
		            ids.sort();
		            return ids;
		        },
	
		        _updateCurrentAttr: function(current, next) {
		            var headerId = $(current).data("headerId");
	
		            $(current)
		                .removeClass(FOCUSED)
		                .closest("table")
		                .removeAttr("aria-activedescendant");
	
		            if(headerId){
		                headerId = headerId.replace(this._cellId, "");
		                $(current).attr("id", headerId);
		            }else{
		                $(current).removeAttr("id");
		            }
	
		            next
		                .data("headerId", next.attr("id"))
		                .attr("id", this._cellId)
		                .addClass(FOCUSED)
		                .closest("table")
		                .attr("aria-activedescendant", this._cellId);
	
		            this._current = next;
		        },
	
		        _scrollCurrent: function() {
		            var current = this._current;
		            var scrollable = this.options.scrollable;
	
		            if (!current || !scrollable) {
		                return;
		            }
	
		            var row = current.parent();
		            var tableContainer = row.closest("table").parent();
	
		            var isInLockedContainer = tableContainer.is(".k-grid-content-locked,.k-grid-header-locked");
		            var isInContent = tableContainer.is(".k-grid-content-locked,.k-grid-content,.k-virtual-scrollable-wrap");
	
		            var scrollableContainer = $(this.content).find(">.k-virtual-scrollable-wrap").addBack().last()[0];
	
		            //adjust scroll vertically
		            if (isInContent) {
		                if (scrollable.virtual) {
		                    var rowIndex = Math.max(inArray(row[0], this._items(row.parent())), 0);
		                    this._rowVirtualIndex = this.virtualScrollable.itemIndex(rowIndex);
		                    this.virtualScrollable.scrollIntoView(row);
		                } else {
		                    this._scrollTo(this._relatedRow(row)[0], scrollableContainer);
		                }
		            }
	
		            if (this.lockedContent) {
		                //sync locked and non-locked content scrollTop
		                this.lockedContent[0].scrollTop = scrollableContainer.scrollTop;
		            }
	
		            //adjust scroll horizontally, if not inside locked tables
		            if (!isInLockedContainer) {
		                this._scrollTo(current[0], scrollableContainer);
		            }
		        },
	
		        current: function(next) {
		            return this._setCurrent(next, true);
		        },
	
		        _setCurrent: function(next, preventTrigger) {
		            var current = this._current;
		            next = $(next);
	
		            if (next.length) {
		                if (!current || current[0] !== next[0]) {
		                    this._updateCurrentAttr(current, next);
	
		                    this._scrollCurrent();
	
		                    if (!preventTrigger) {
		                        this.trigger(NAVIGATE, {
		                            element: next
		                        });
		                    }
		                }
		            }
	
		            if (next && next.length) {
		                this._lastCellIndex = next.parent().children(DATA_CELL).index(next);
		            }
		            return this._current;
		        },
	
		        _removeCurrent: function() {
		            if (this._current) {
		                this._current.removeClass(FOCUSED);
		                this._current = null;
		            }
		        },
	
		        _scrollTo: function(element, container) {
		            var elementToLowercase = element.tagName.toLowerCase();
		            var isHorizontal =  elementToLowercase === "td" || elementToLowercase === "th";
		            var elementOffset = element[isHorizontal ? "offsetLeft" : "offsetTop"];
		            var elementOffsetDir = element[isHorizontal ? "offsetWidth" : "offsetHeight"];
		            var containerScroll = container[isHorizontal ? "scrollLeft" : "scrollTop"];
		            var containerOffsetDir = container[isHorizontal ? "clientWidth" : "clientHeight"];
		            var bottomDistance = elementOffset + elementOffsetDir;
		            var result = 0;
		            var ieCorrection = 0;
		            var firefoxCorrection = 0;
	
		            if (isRtl && isHorizontal) {
		                var table = $(element).closest("table")[0];
		                if (browser.msie) {
		                    ieCorrection = table.offsetLeft;
		                } else if (browser.mozilla) {
		                    firefoxCorrection = table.offsetLeft - kendo.support.scrollbar();
		                }
		            }
	
		            containerScroll = Math.abs(containerScroll + ieCorrection - firefoxCorrection);
	
		            if (containerScroll > elementOffset) {
		                result = elementOffset;
		            } else if (bottomDistance > (containerScroll + containerOffsetDir)) {
		                if (elementOffsetDir <= containerOffsetDir) {
		                    result = (bottomDistance - containerOffsetDir);
		                } else {
		                    result = elementOffset;
		                }
		            } else {
		                result = containerScroll;
		            }
	
		            result = Math.abs(result + ieCorrection) + firefoxCorrection;
	
		            container[isHorizontal ? "scrollLeft" : "scrollTop"] = result;
		        },
	
		        _navigatable: function() {
		            var that = this;
	
		            if (!that.options.navigatable) {
		                return;
		            }
	
		            //data tables - locked and non-locked
		            var dataTables = that.table.add(that.lockedTable);
		            //header tables - locked and non-locked
		            var headerTables = that.thead.parent().add($(">table", that.lockedHeader));
	
		            //the over wich keys will be handled
		            var tables = dataTables;
	
		            if (that.options.scrollable) {
		                //add the header table when the widget is scrollable
		                tables = tables.add(headerTables);
		                //data tables will recive first focus on TAB
		                headerTables.attr(TABINDEX, -1);
		            }
	
		            this._navigatableTables = tables;
	
		            //dettach all previous events
		            tables.off("mousedown" + NS + " focus" + NS + " focusout" + NS + " keydown" + NS);
	
		            headerTables
		                .on("keydown" + NS, proxy(that._openHeaderMenu, that))
		                .find("a.k-link").attr("tabIndex", -1);
	
		            //prevent propagation when clicked inside detail grid
		            dataTables
		                .attr(TABINDEX, math.max(dataTables.attr(TABINDEX) || 0, 0))
		                .on("keydown" + NS, ".k-detail-cell", function(e) {
		                    if (e.target !== e.currentTarget) {
		                        e.stopImmediatePropagation();
		                    }
		                });
	
		            tables
		                //handle click on tables, will attempt to focus the table
		                .on((kendo.support.touch ? "touchstart" + NS : "mousedown" + NS), NAVROW + ">" + NAVCELL, proxy(tableClick, that))
		                .on("focus" + NS, proxy(that._tableFocus, that))
		                .on("focusout" + NS, proxy(that._tableBlur, that))
		                .on("keydown" + NS, proxy(that._tableKeyDown, that));
		        },
	
		        _openHeaderMenu: function(e) {
		            if (e.altKey && e.keyCode == keys.DOWN) {
		                this.current().find(".k-grid-filter, .k-header-column-menu").click();
		                e.stopImmediatePropagation();
		            }
		        },
	
		        _setTabIndex: function(table) {
		            this._navigatableTables.attr(TABINDEX, -1);
	
		            table.attr(TABINDEX, 0);
		        },
	
		        _tableFocus: function(e) {
		            var current = this.current();
		            var table = $(e.currentTarget);
	
		            //if there is already current, highlighted it
		            //otherwise highlight the first possible cell
		            if (current && current.is(":visible")) {
		                current.addClass(FOCUSED);
		            } else {
		                this._setCurrent(table.find(FIRSTNAVITEM));
		            }
	
		            this._setTabIndex(table);
		        },
	
		        _tableBlur: function() {
		            var current = this.current();
	
		            if (current) {
		                current.removeClass(FOCUSED);
		            }
		        },
	
		        _tableKeyDown: function(e) {
		            var current = this.current();
		            var requestInProgress = this.virtualScrollable && this.virtualScrollable.fetching();
		            var target = $(e.target);
		            var canHandle = !e.isDefaultPrevented() && !target.is(":button,a,:input,a>.k-icon");
	
		            // do not handle key down if request in progress
		            // or there isn't current set
		            if (requestInProgress) {
		                // swallow key events while in progress
		                e.preventDefault();
		                return;
		            }
	
		            current = current ? current : $(this.lockedTable).add(this.options.scrollable ? this.table : this.tbody).find(FIRSTNAVITEM);
		            if (!current.length) {
		                return;
		            }
	
		            var handled = false;
	
		            if (canHandle && e.keyCode == keys.UP) {
		                handled = this._moveUp(current, e.shiftKey);
		            }
	
		            if (canHandle && e.keyCode == keys.DOWN) {
		                handled = this._moveDown(current, e.shiftKey);
		            }
	
		            if (canHandle && e.keyCode == (isRtl ? keys.LEFT : keys.RIGHT)) {
		                handled = this._moveRight(current, e.altKey, e.shiftKey, e.ctrlKey, e.currentTarget);
		            }
	
		            if (canHandle && e.keyCode == (isRtl ? keys.RIGHT : keys.LEFT)) {
		                handled = this._moveLeft(current, e.altKey, e.shiftKey, e.ctrlKey, e.currentTarget);
		            }
	
		            if (canHandle && e.keyCode == keys.PAGEDOWN) {
		                handled = this._handlePageDown();
		            }
	
		            if (canHandle && e.keyCode == keys.PAGEUP) {
		                handled = this._handlePageUp();
		            }
	
		            if (canHandle && e.keyCode == keys.HOME) {
		                handled = this._handleHome(current, e.ctrlKey);
		            }
	
		            if (canHandle && e.keyCode == keys.END) {
		                handled = this._handleEnd(current, e.ctrlKey);
		            }
	
		            if (canHandle && e.keyCode == keys.SPACEBAR) {
		                handled = this._handleSpaceKey(current, e.ctrlKey);
		            }
	
		            if (e.keyCode == keys.ENTER || e.keyCode == keys.F2) {
		                handled = this._handleEnterKey(current, e.currentTarget, target);
		            }
	
		            if (e.keyCode == keys.ESC) {
		                handled = this._handleEscKey(current, e.currentTarget);
		            }
	
		            if (e.keyCode == keys.TAB) {
		                handled = this._handleTabKey(current, e.currentTarget, e.shiftKey);
		            }
	
		            if (handled) {
		                //prevent scrolling while pressing the keys
		                e.preventDefault();
		                //required in hierarchy
		                e.stopPropagation();
		            }
		        },
	
		        _moveLeft: function(current, altKey, shiftKey, ctrlKey, currentTable) {
		            var next, index;
		            var row = current.parent();
		            //thead or tbody
		            var container = row.parent();
	
		            if (altKey) {
		                this.collapseRow(row);
		            } else if (ctrlKey && current.is(".k-header") && this.options.reorderable) {
		               this._moveColumn(current, true);
		            } else {
		                index = container.find(NAVROW).index(row);
		                next = this._prevHorizontalCell(container, current, index);
	
		                if (!next[0]) {
		                    if (shiftKey) {
		                        if (this.lockedTable) {
		                            next = this._relatedRow(row);
		                            if ($.contains(this.lockedTable[0], row[0])) {
		                                next = next.prevAll(ITEMROW + ":first");
		                            }
		                            next = next.children(DATA_CELL + ":last");
		                        } else {
		                            next = this._tabNext(current, currentTable, true);
		                        }
		                    } else {
		                        container = this._horizontalContainer(container);
	
		                        next = this._prevHorizontalCell(container, current, index);
	
		                        if (next[0] !== current[0]) {
		                            focusTable(container.parent(), true);
		                        }
		                    }
		                }
	
		                this._setCurrent(next);
		            }
	
		            return true;
		        },
	
		        _moveRight: function(current, altKey, shiftKey, ctrlKey, currentTable) {
		            var next, index;
		            var row = current.parent();
		            //thead or tbody
		            var container = row.parent();
	
		            if (altKey) {
		                this.expandRow(row);
		             } else if (ctrlKey && current.is(".k-header") && this.options.reorderable) {
		                this._moveColumn(current, false);
		            } else {
		                index = container.find(NAVROW).index(row);
		                next = this._nextHorizontalCell(container, current, index);
	
		                if (!next[0]) {
		                    if (shiftKey) {
		                       if (this.lockedTable) {
		                            next = this._relatedRow(row);
		                            if ($.contains(this.table[0], row[0])) {
		                                next = next.nextAll(ITEMROW + ":first");
		                            }
		                            next = next.children(DATA_CELL + ":first");
		                        } else {
		                            next = this._tabNext(current, currentTable, false);
		                        }
		                    } else {
		                        container = this._horizontalContainer(container, true);
	
		                        next = this._nextHorizontalCell(container, current, index);
	
		                        if (next[0] !== current[0]) {
		                            focusTable(container.parent(), true);
		                        }
		                    }
		                }
	
		                this._setCurrent(next);
		            }
	
		            return true;
		        },
	
		        _moveUp: function(current, shiftKey) {
		            //thead or tbody
		            var container = current.parent().parent();
		            var next;
	
		            if (shiftKey) {
		               next = current.parent();
		               next = next.prevAll(ITEMROW + ":first");
		               next = current.parent().is(ITEMROW) ? next.children().eq(current.index()) : next.children(DATA_CELL + ":last" );
		            } else {
		               next = this._prevVerticalCell(container, current);
		               if (!next[0]) {
		                  this._lastCellIndex = 0;
		                  container = this._verticalContainer(container, true);
	
		                  next = this._prevVerticalCell(container, current);
	
		                  if (next[0]) {
		                      focusTable(container.parent(), true);
		                  }
		               }
		            }
	
		            var tmp = this._lastCellIndex || 0;
		            this._setCurrent(next);
		            this._lastCellIndex = tmp;
	
		            return true;
		        },
	
		        _moveDown: function(current, shiftKey) {
		            //thead or tbody
		            var container = current.parent().parent();
		            var next;
	
		            if (shiftKey) {
		                next = current.parent();
		                next = next.nextAll(ITEMROW + ":first");
		                next = current.parent().is(ITEMROW)? next.children().eq(current.index()) : next.children(DATA_CELL + ":first" );
		            } else {
		                next = this._nextVerticalCell(container, current);
		                if (!next[0]) {
		                    this._lastCellIndex = 0;
		                    container = this._verticalContainer(container);
	
		                    next = this._nextVerticalCell(container, current);
		                    if (next[0]) {
		                        focusTable(container.parent(), true);
		                    }
		                }
		            }
		            var tmp = this._lastCellIndex || 0;
		            this._setCurrent(next);
		            this._lastCellIndex = tmp;
		            return true;
		        },
	
		        _moveColumn: function(current, isLeft) {
		            var elements = this.wrapper.data().kendoReorderable.element.find(this._draggableInstance.options.filter + ":visible");
	
		            var columns = visibleColumns(flatColumnsInDomOrder(this.columns));
		            var oldIndex = elements.index($(current));
		            var offset = isLeft ? - 1: 1;
		            var column = columns[oldIndex];
		            var newIndex = targetParentContainerIndex(columns, this.columns, oldIndex, oldIndex + offset);
		            if (newIndex >= 0) {
		                this.reorderColumn(newIndex, column, isLeft);
		            }
		        },
	
		        _handleHome: function(current, ctrl) {
		            var row = current.parent();
		            var rowContainer = row.parent();
		            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
		            var isInBody = rowContainer[0] === this.tbody[0];
		            var prev;
	
		            if (ctrl) {
		                if (this.lockedTable) {
		                    prev = this.lockedTable.find(FIRSTITEMROW + ">" + NAVCELL + ":first");
		                } else {
		                    prev = this.table.find(FIRSTITEMROW + ">" + NAVCELL + ":first");
		                }
		            } else if (isInBody || isInLockedTable) {
		                if (isInBody && this.lockedTable) {
		                    row = this._relatedRow(row);
		                }
		                prev = row.children(DATA_CELL + ":first");
		            }
	
		            if (prev && prev.length) {
		                this._setCurrent(prev);
		                return true;
		            }
		        },
	
		        _handleEnd: function(current, ctrl) {
		            var row = current.parent();
		            var rowContainer = row.parent();
		            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
		            var isInBody = rowContainer[0] === this.tbody[0];
		            var next;
	
		            if (ctrl) {
		                next = this.table.find(LASTITEMROW + ">" + NAVCELL + ":last");
		            } else if (isInBody || isInLockedTable) {
		                if (!isInBody && this.lockedTable) {
		                    row = this._relatedRow(row);
		                }
		                next = row.children(DATA_CELL + ":last");
		            }
	
		            if (next && next.length) {
		                this._setCurrent(next);
		                return true;
		            }
		        },
	
		        _handlePageDown: function() {
		            if (!this.options.pageable) {
		                return false;
		            }
	
		            this.dataSource.page(this.dataSource.page() + 1);
	
		            return true;
		        },
	
		        _handlePageUp: function() {
		            if (!this.options.pageable) {
		                return false;
		            }
	
		            this.dataSource.page(this.dataSource.page() - 1);
	
		            return true;
		        },
	
		        _handleTabKey: function(current, currentTable, shiftKey) {
		            var isInCell = this.options.editable && this._editMode() == "incell";
		            var cell;
	
		            if (!isInCell || current.is("th")) {
		                return false;
		            }
	
		            cell = $(activeElement()).closest(".k-edit-cell");
	
		            if (cell[0] && cell[0] !== current[0]) {
		                current = cell;
		            }
	
		            cell = this._tabNext(current, currentTable, shiftKey);
	
		            if (cell.length) {
		                this._handleEditing(current, cell, cell.closest("table"));
	
		                return true;
		            }
	
		            return false;
		        },
	
		        _handleEscKey: function(current, currentTable) {
		            var active = activeElement();
		            var isInCell = this._editMode() == "incell";
	
		            if (!isInEdit(current)) {
		                if (current.has(active).length) {
		                    // return focus back to the table
		                    focusTable(currentTable, true);
	
		                    return true;
		                }
		                return false;
		            }
	
		            if (isInCell) {
		                this.closeCell(true);
		            } else {
		                var currentIndex = $(current).parent().index();
		                if (active) {
		                    active.blur();
		                }
		                this.cancelRow(true);
		                if (currentIndex >= 0) {
		                    this._setCurrent(this.items().eq(currentIndex).children(NAVCELL).first());
		                }
		            }
	
		            if (browser.msie && browser.version < 9) {
		                document.body.focus();
		            }
	
		            focusTable(currentTable, true);
	
		            return true;
		        },
	
		        _toggleCurrent: function(current, editable) {
		            var row = current.parent();
	
		            if (row.is(".k-grouping-row")) {
		                row.find(".k-icon:first").click();
	
		                return true;
		            }
	
		            if (!editable && row.is(".k-master-row")) {
		                row.find(".k-icon:first").click();
	
		                return true;
		            }
	
		            return false;
		        },
	
		        _handleSpaceKey: function(current, ctrlKey) {
		            var that = this;
	
		            if (!ctrlKey || !that.groupable || !current.hasClass("k-header")) {
		                return;
		            }
	
		            var descriptors = that.groupable.descriptors();
		            var field = current.attr(kendo.attr("field"));
		            var aggregates = that.groupable.aggregates();
		            var label = current.attr(kendo.attr("title")) || field;
	
		            if (that.groupable._canDrag(current)) {
		                descriptors.push({
		                    field: field,
		                    dir: "asc",
		                    aggregates: aggregates || []
		                });
		                label += " " + that.options.messages.ungroupHeader;
		            } else {
		                descriptors = $.grep(descriptors, function (item)
		                {
		                    return item.field !== field;
		                });
		                label += " " + that.options.messages.groupHeader;
		            }
	
		            current.attr("aria-label", label);
	
		            that.dataSource.group(descriptors);
	
		            return true;
		        },
	
		        _handleEnterKey: function(current, currentTable, target) {
		            var editable = this.options.editable && this.options.editable.update !== false;
		            var container = target.closest("[role=gridcell]");
		            var link;
	
		            if (!target.is("table") && !$.contains(current[0], target[0])) {
		                current = container;
		            }
	
		            if (current.is("th")) {
		                // sort the column, if possible
		                link = current.find(".k-link");
		                if (link.length) {
		                    link.click();
		                } else {
		                    current.find(CHECKBOXINPUT).focus();
		                }
	
		                return true;
		            }
	
		            if (this._toggleCurrent(current, editable)) {
		                return true;
		            }
	
		            var focusable = current.find(":kendoFocusable:first");
		            if (focusable[0] && !current.hasClass("k-edit-cell") && current.hasClass("k-state-focused")) {
		                focusable.focus();
	
		                return true;
		            }
	
		            if (editable && !target.is(":button,.k-button,textarea")) {
		                if (!container[0]) {
		                    container = current;
		                }
	
		                this._handleEditing(container, false, currentTable);
	
		                return true;
		            }
	
		            return false;
		        },
	
		        _nextHorizontalCell: function(table, current, originalIndex) {
		            var cells = current.nextAll(DATA_CELL);
	
		            if (!cells.length) {
		                var rows = table.find(NAVROW);
		                var rowIndex = rows.index(current.parent());
	
		                //no sibling cells are found and we've changed the table
		                if (rowIndex == -1) {
		                    if (current.hasClass("k-header")) {
		                        var headerRows = [];
		                        mapColumnToCellRows([lockedColumns(this.columns)[0]], childColumnsCells(rows.eq(0).children(":visible").first()), headerRows, 0, 0);
	
		                        if (headerRows[originalIndex]) {
		                            return headerRows[originalIndex][0];
		                        }
	
		                        return current;
		                    }
	
		                    //current is in filter row
		                    if (current.parent().hasClass("k-filter-row")) {
		                        return rows.last().children(DATA_CELL).first();
		                    }
	
		                    //get the same row index in the new table
		                    return rows.eq(originalIndex).children(DATA_CELL).first();
		                }
		            }
	
		            return cells.first();
		        },
	
		        _prevHorizontalCell: function(table, current, originalIndex) {
		            var cells = current.prevAll(DATA_CELL);
	
		            if (!cells.length) {
		                var rows = table.find(NAVROW);
		                var rowIndex = rows.index(current.parent());
	
		                //no sibling cells are found and we've changed the table
		                if (rowIndex == -1) {
		                    if (current.hasClass("k-header")) {
		                        var headerRows = [];
		                        var columns = lockedColumns(this.columns);
		                        mapColumnToCellRows([columns[columns.length - 1]], childColumnsCells(rows.eq(0).children().last()), headerRows, 0, 0);
	
		                        if (headerRows[originalIndex]) {
		                            return headerRows[originalIndex][0];
		                        }
	
		                        return current;
		                    }
	
		                    //current is in filter row
		                    if (current.parent().hasClass("k-filter-row")) {
		                        return rows.last().children(DATA_CELL).last();
		                    }
	
		                    //get the same row index in the new table
		                    return rows.eq(originalIndex).children(DATA_CELL).last();
		                }
		            }
	
		            return cells.first();
		        },
	
		        _currentDataIndex: function(table, current) {
		            var index = current.attr("data-index");
	
		            if (!index) {
		                return undefined;
		            }
	
		            var lockedColumnsCount = lockedColumns(this.columns).length;
		            if (lockedColumnsCount && !table.closest("div").hasClass("k-grid-content-locked")[0]) {
		                return index - lockedColumnsCount;
		            }
	
		            return index;
		        },
	
		        _prevVerticalCell: function(container, current) {
		            var cells;
		            var row = current.parent();
		            var rows = container.children(NAVROW);
		            var rowIndex = rows.index(row);
		            //get data-index in case of last level of multi-level columns
		            var index = this._currentDataIndex(container, current);
	
		            //current is in the header, but not at the last level of multi-level columns
		            if (index || current.hasClass("k-header")) {
		                cells = parentColumnsCells(current);
		                return cells.eq(cells.length - 2);
		            }
	
		            index = Math.max(row.children(DATA_CELL).index(current), this._lastCellIndex || 0);
	
		            //if current is inside filter row
		            if (row.hasClass("k-filter-row")) {
		                return leafDataCells(container).filter(isCellVisible).eq(index);
		            }
	
		            //move up to header container
		            if (rowIndex == -1) {
		                //is there filter row in the header container
		                row = container.find("tr.k-filter-row:visible");
		                if (!row[0]) {
		                    // in hierarchical grid we need to correct the index
		                    // since the k-hierarchy cell is navigatable
		                    if ((this._hasDetails() || current.parent().find('.k-hierarchy-cell').length) && index) {
		                        index--;
		                    }
		                    return leafDataCells(container).filter(isCellVisible).eq(index);
		                }
		            } else {
		                row =  rowIndex === 0 ? $() : rows.eq(rowIndex - 1);
		            }
	
		            cells = row.children(DATA_CELL);
		            if (cells.length > index) {
		                return cells.eq(index);
		            }
	
		            return cells.eq(0);
		        },
	
		        _nextVerticalCell: function(container, current) {
		            var cells;
		            var row = current.parent();
		            var rows = container.children(NAVROW);
		            var rowIndex = rows.index(row);
		            //get data-index in case of last level of multi-level columns
		            var index = this._currentDataIndex(container, current);
	
		            //current is in the header, but not at the last level of multi-level columns
		            //and we are not changing the table
		            if (rowIndex != -1 && index === undefined && current.hasClass("k-header")) {
		                return childColumnsCells(current).eq(1);
		            }
	
		            index = index ? parseInt(index, 10) : row.children(DATA_CELL).index(current);
		            index = Math.max(index, this._lastCellIndex || 0);
	
		            //move down to data container
		            if (rowIndex == -1) {
		                row = rows.eq(0);
		                // in hierarchical grid we need to correct the index
		                // since the k-hierarchy cell is navigatable
		                if (this._hasDetails() || row.find('.k-hierarchy-cell').length) {
		                    index++;
		                }
		            } else {
		                row = rows.eq(rowIndex + current[0].rowSpan);
		            }
	
		            var tmpIndex = index;
		            //in case of last level of multi-level columns the index should be updated depending on the hidden columns
		            if (this._currentDataIndex(container, current) !== undefined) {
		                var currentRowCells = row.children(":not(.k-group-cell):not(.k-hierarchy-cell)");
		                var hiddenColumns = currentRowCells.filter(":hidden");
		                for(var idx = 0, length = hiddenColumns.length; idx < length; idx++) {
		                    if (currentRowCells.index(hiddenColumns[idx]) < index) {
		                        tmpIndex--;
		                    }
		                }
		            }
		            index = tmpIndex;
	
		            cells = row.children(DATA_CELL);
		            if (cells.length > index) {
		                return cells.eq(index);
		            }
	
		            return cells.eq(0);
		        },
	
		        _verticalContainer: function(container, up) {
		            var table = container.parent();
		            var length = this._navigatableTables.length;
		            var step = Math.floor(length / 2);
		            var index = inArray(table[0], this._navigatableTables);
	
		            if (up) {
		                step *= -1;
		            }
		            index += step;
	
		            if (index >= 0 || index < length) {
		                table = this._navigatableTables.eq(index);
		            }
	
		            return table.find(up ? ">thead" : ">tbody");
		        },
	
		        _horizontalContainer: function(container, right) {
		            var length = this._navigatableTables.length;
		            if (length <= 2) {
		                return container;
		            }
	
		            var table = container.parent();
		            var index = inArray(table[0], this._navigatableTables);
	
		            index += right ? 1 : -1;
	
		            if (right && (index == 2 || index == length)) {
		                return container;
		            }
	
		            if (!right && (index == 1 || index < 0)) {
		                return container;
		            }
	
		            return this._navigatableTables.eq(index).find("thead, tbody");
		        },
	
		        _tabNext: function (current, currentTable, back) {
		            var switchRow = true;
		            var next = back ? current.prevAll(DATA_CELL + ":first") : current.nextAll(":visible:first");
	
		            if (!next.length) {
		                next = current.parent();
		                if (this.lockedTable) {
		                    switchRow = (back && currentTable == this.lockedTable[0]) || (!back && currentTable == this.table[0]);
		                    next = this._relatedRow(next);
		                }
	
		                if (switchRow) {
		                    next = next[back ? "prevAll" : "nextAll"]("tr:not(.k-grouping-row):not(.k-detail-row):visible:first");
		                }
		                next = next.children(DATA_CELL + (back ? ":last" : ":first"));
		            }
	
		            return next;
		        },
	
		        _handleEditing: function(current, next, table) {
		            var that = this,
		                active = $(activeElement()),
		                mode = that._editMode(),
		                isIE = browser.msie,
		                oldIE = isIE && browser.version < 9,
		                editContainer = that._editContainer,
		                focusable,
		                editable = that.options.editable && that.options.editable.update !== false,
		                isEdited;
	
		            table = $(table);
		            if (mode == "incell") {
		                isEdited = current.hasClass("k-edit-cell");
		            } else {
		                isEdited = current.parent().hasClass("k-grid-edit-row");
		            }
	
		            if (that.editable) {
		                if ($.contains(editContainer[0], active[0])) {
		                    if (browser.opera || oldIE) {
		                        active.blur().change().triggerHandler("blur");
		                    } else {
		                        active.blur();
		                        if (isIE) {
		                            //IE10 with jQuery 1.9.x does not trigger blur handler
		                            //numeric textbox does trigger change
		                            active.blur();
		                        }
		                    }
		                }
	
		                if (!that.editable) {
		                    focusTable(table);
		                    return;
		                }
	
		                if (that.editable.end()) {
		                    if (mode == "incell") {
		                        that.closeCell();
		                    } else {
		                        that.saveRow();
		                        isEdited = true;
		                    }
		                } else {
		                    if (mode == "incell") {
		                        that._setCurrent(editContainer);
		                    } else {
		                        that._setCurrent(editContainer.children().filter(DATA_CELL).first());
		                    }
		                    focusable = editContainer.find(":kendoFocusable:first")[0];
		                    if (focusable) {
		                        focusable.focus();
		                    }
		                    return;
		                }
		            }
	
		            if (next) {
		                that._setCurrent(next);
		            }
	
		            if (oldIE) {
		                document.body.focus();
		            }
	
		            focusTable(table, true);
	
		            if (!editable) {
		                return;
		            }
	
		            if ((!isEdited && !next) || next) {
		                if (mode == "incell") {
		                    that.editCell(that.current());
		                } else {
		                    that.editRow(that.current().parent());
		                }
		            }
		        },
	
		        _wrapper: function() {
		            var that = this,
		                table = that.table,
		                height = that.options.height,
		                wrapper = that.element;
	
		            if (!wrapper.is("div")) {
		               wrapper = wrapper.wrap("<div/>").parent();
		            }
	
		            that.wrapper = wrapper.addClass("k-grid k-widget k-display-block");
	
		            if (height) {
		                that.wrapper.css(HEIGHT, height);
		                table.css(HEIGHT, "auto");
		            }
	
		            that._initMobile();
		        },
	
		        _initMobile: function() {
		            var options = this.options;
		            var that = this;
	
		            this._isMobile = (options.mobile === true && kendo.support.mobileOS) ||
		                                options.mobile === "phone" ||
		                                options.mobile === "tablet";
	
		            if (this._isMobile) {
		                var html = this.wrapper.addClass("k-grid-mobile").wrap(
		                        '<div data-' + kendo.ns + 'stretch="true" data-' + kendo.ns + 'role="view" ' +
		                        'data-' + kendo.ns + 'init-widgets="false"></div>'
		                    )
		                    .parent();
	
		                this.pane = kendo.mobile.ui.Pane.wrap(html);
		                this.view = this.pane.view();
		                this._actionSheetPopupOptions = $(document.documentElement).hasClass("km-root") ? { modal: false } : {
		                    align: "bottom center",
		                    position: "bottom center",
		                    effect: "slideIn:up"
		                };
	
		                if (options.height) {
		                    this.pane.element.parent().css(HEIGHT, options.height);
		                }
	
		                this._editAnimation = "slide";
	
		                this.view.bind("show", function() {
		                    if (that._isLocked()) {
		                        that._updateTablesWidth();
		                        that._applyLockedContainersWidth();
		                        that._syncLockedContentHeight();
		                        that._syncLockedHeaderHeight();
		                        that._syncLockedFooterHeight();
		                    }
		                });
		            }
		        },
	
		        _tbody: function() {
		            var that = this,
		                table = that.table,
		                tbody;
	
		            tbody = table.find(">tbody");
	
		            if (!tbody.length) {
		                tbody = $("<tbody/>").appendTo(table);
		            }
	
		            that.tbody = tbody.attr("role", "rowgroup");
		        },
	
		        _scrollable: function() {
		            var that = this,
		                header,
		                table,
		                options = that.options,
		                scrollable = options.scrollable,
		                hasVirtualScroll = scrollable !== true && scrollable.virtual && !that.virtualScrollable,
		                scrollbar = !kendo.support.kineticScrollNeeded || hasVirtualScroll ? kendo.support.scrollbar() : 0,
		                headerWrap;
	
		            if (scrollable) {
		                header = that.wrapper.children(".k-grid-header");
	
		                if (!header[0]) {
		                    header = $('<div class="k-grid-header" />').insertBefore(that.table);
		                }
	
		                // workaround for IE issue where scroll is not raised if container is same width as the scrollbar
		                header.css((isRtl ? "padding-left" : "padding-right"), scrollable.virtual ? scrollbar + 1 : scrollbar);
		                table = $('<table role="grid" />');
		                if (isIE7) {
		                    table.attr("cellspacing", 0);
		                }
	
		                table.width(that.table[0].style.width);
	
		                table.append(that.thead);
		                header.empty().append($('<div class="k-grid-header-wrap k-auto-scrollable" />').append(table));
	
	
		                that.content = that.table.parent();
	
		                if (that.content.is(".k-virtual-scrollable-wrap, .km-scroll-container")) {
		                    that.content = that.content.parent();
		                }
	
		                if (!that.content.is(".k-grid-content, .k-virtual-scrollable-wrap")) {
		                    that.content = that.table.wrap('<div class="k-grid-content k-auto-scrollable" />').parent();
		                }
		                if (hasVirtualScroll) {
		                    that._createVirtualScrollable();
		                }
		                headerWrap = header.children(".k-grid-header-wrap");
	
		                that.scrollables = headerWrap.add(that.content);
	
		                // the footer may exists if rendered from the server
		                var footer = that.wrapper.find(".k-grid-footer");
	
		                if (footer.length) {
		                    that.scrollables = that.scrollables.add(footer.children(".k-grid-footer-wrap"));
		                }
	
		                headerWrap.unbind("scroll" + NS).bind("scroll" + NS, function (e) {
		                    if (that._scrollLeft !== this.scrollLeft) {
		                        that.scrollables.not(e.currentTarget).scrollLeft(this.scrollLeft);
		                    }
		                });
	
		                if (scrollable.virtual) {
		                    that.content.find(">.k-virtual-scrollable-wrap").unbind("scroll" + NS).bind("scroll" + NS, function () {
		                        that.scrollables.scrollLeft(this.scrollLeft);
		                        if (that.lockedContent) {
		                            that.lockedContent[0].scrollTop = this.scrollTop;
		                        }
		                    });
		                } else {
		                    var endless = scrollable.endless;
		                    var originalPageSize = that.dataSource.options.pageSize;
		                    if (endless) {
		                        that._endlessPageSize = originalPageSize;
		                    }
		                    that.content.unbind("scroll" + NS).bind("scroll" + NS, function (e) {
		                        that._scrollLeft = this.scrollLeft;
		                        that.scrollables.not(e.currentTarget).scrollLeft(that._scrollLeft);
		                        if (that.lockedContent && e.currentTarget == that.content[0]) {
		                            that.lockedContent[0].scrollTop = this.scrollTop;
		                        }
		                        if (endless) {
		                            if ((this.scrollTop + this.clientHeight - this.scrollHeight >= -10) &&
		                                !that._endlessFetchInProgress &&
		                                that._endlessPageSize < that.dataSource.total()) {
		                                that._skipRerenderItemsCount =  that._endlessPageSize;
		                                that._endlessPageSize = that._endlessPageSize + originalPageSize;
		                                that.dataSource.options.endless = true;
		                                that._endlessFetchInProgress = true;
		                                that.dataSource.pageSize(that._endlessPageSize);
		                            }
		                        }
		                    });
	
		                    var touchScroller = that.content.data("kendoTouchScroller");
		                    if (touchScroller) {
		                        touchScroller.destroy();
		                    }
	
		                    touchScroller = kendo.touchScroller(that.content);
		                    if (touchScroller && touchScroller.movable) {
		                        that.touchScroller = touchScroller;
		                        touchScroller.movable.bind("change", function(e) {
		                            that.scrollables.scrollLeft(-e.sender.x);
		                            if (that.lockedContent) {
		                                that.lockedContent.scrollTop(-e.sender.y);
		                            }
		                        });
	
		                        that.one(DATABOUND, function (e) {
		                            e.sender.wrapper.addClass("k-grid-backface");
		                        });
		                    }
		                }
		            }
	
	
		        },
	
		        _createVirtualScrollable: function() {
		            var that = this;
	
		            if (that.virtualScrollable) {
		                that.virtualScrollable.destroy();
		            }
	
		            that.virtualScrollable = new VirtualScrollable(that.content, {
		                dataSource: that.dataSource,
		                itemHeight: function() { return that._averageRowHeight(); },
		                page: function() {
		                    that._restoreEditableState();
		                },
		                scroll: function() {
		                    that._focusEditable();
		                }
		            });
	
		            that.virtualScrollable.bind(PAGING, proxy(that._onVirtualPaging, that));
		        },
	
		        _onVirtualPaging: function() {
		            var that = this;
	
		            that._cacheEditableState();
	
		            if (that._isVirtualIncellEditable()) {
		                that._shouldClearEditableState = false;
		                that.closeCell();
		                that._shouldClearEditableState = true;
		            }
		        },
	
		        _isVirtualEditable: function() {
		            return this._isVirtualIncellEditable() || this._isVirtualInlineEditable() || this._isVirtualPopupEditable();
		        },
	
		        _isVirtualInlineEditable: function() {
		            return this.virtualScrollable && this._editMode() === INLINE;
		        },
	
		        _isVirtualIncellEditable: function() {
		            return this.virtualScrollable && this._editMode() === INCELL;
		        },
	
		        _isVirtualPopupEditable: function() {
		            return this.virtualScrollable && this._editMode() === "popup";
		        },
	
		        _scrollVirtualWrapper: function() {
		            var that = this;
		            var scrollable = that.virtualScrollable;
	
		            if (that._isVirtualInlineEditable() || that._isVirtualIncellEditable()) {
		                if (scrollable._isScrolledToBottom()) {
		                    scrollable._scrollWrapperToBottom();
		                } else if (scrollable._isScrolledToTop()) {
		                    scrollable._scrollWrapperToTop();
		                }
		            }
		        },
	
		        _scrollVirtualWrapperOnColumnResize: function() {
		            var virtualScrollable = this.virtualScrollable;
	
		            if (virtualScrollable) {
		                virtualScrollable._scrollWrapperOnColumnResize();
		            }
		        },
	
		        _restoreEditableState: function() {
		            var that = this;
		            var editableState = that._editableState || {};
		            var editedModel = editableState.model;
		            var dataSource = that.dataSource;
		            var inlineMode = that._isVirtualInlineEditable();
		            var incellMode = that._isVirtualIncellEditable();
		            var row;
		            var cell;
	
		            if ((inlineMode || incellMode) && editedModel && dataSource._getByUid(editedModel.uid, dataSource.view())) {
		                if (inlineMode) {
		                    that._shouldClearEditableState = false;
		                    that.editRow(editedModel);
		                    that._focusEditable();
		                } else if (incellMode) {
		                    row = that.tbody.children(attrEquals(UNIQUE_ID, editedModel.uid));
		                    cell = $(row).children(attrEquals(FIELD, editableState.field));
	
		                    if (cell[0]) {
		                        that._shouldClearEditableState = false;
		                        that.editCell(cell);
		                        that._focusEditable();
		                    }
		                }
		            }
	
		            that._shouldClearEditableState = true;
		        },
	
		        _focusEditable: function() {
		            var that = this;
		            var editedField = (that._editableState || {}).field;
		            var editContainer = that._editContainer;
	
		            if (editContainer && !contains(editContainer[0], activeElement()) && that._canFocusEditable()) {
		                if (that._isVirtualInlineEditable()) {
		                    editContainer.find(attrEquals(CONTAINER_FOR, editedField)).find(FOCUSABLE).eq(0).focus();
		                } else if (that._isVirtualIncellEditable()) {
		                    editContainer.find(FOCUSABLE).eq(0).focus();
		                }
		            }
		        },
	
		        _canFocusEditable: function() {
		            var that = this;
		            return ((that._isVirtualIncellEditable() || that._isVirtualInlineEditable()) &&
		                    that.virtualScrollable._isElementVisible(that._editContainer));
		        },
	
		        _cacheEditableState: function() {
		            var that = this;
		            var editContainer = that._editContainer;
		            var editedModel = editContainer ? that._modelForContainer(editContainer) : null;
		            var inlineMode = that._isVirtualInlineEditable();
		            var incellMode = that._isVirtualIncellEditable();
		            var active;
		            var widget;
	
		            if ((inlineMode || incellMode) && editedModel) {
		                that._clearEditableState();
		                active = $(activeElement());
	
		                if (editContainer && active[0] && contains(editContainer[0], active[0])) {
		                    //change event is not fired if the editable container is scrolled
		                    //out of the virtual view with the mousewheel right after editing
		                    active.change();
	
		                    widget =  kendo.widgetInstance(active, kendo.ui);
	
		                    if (widget && isFunction(widget.value) && active.is(INPUT)) {
		                        widget.value(active.val());
		                        widget.trigger(CHANGE);
		                    }
		                }
	
		                if (inlineMode) {
		                    that._editableState = {
		                        model: editedModel,
		                        field: active.closest("[" + kendo.attr(CONTAINER_FOR) + "]").attr(kendo.attr(CONTAINER_FOR))
		                    };
		                } else if (incellMode) {
		                    that._editableState = {
		                        model: editedModel,
		                        field: editContainer.attr(kendo.attr(FIELD))
		                    };
		                }
		            }
		        },
	
		        _clearEditableState: function() {
		            var that = this;
	
		            if (that.virtualScrollable) {
		                that._editableState = null;
		            }
		        },
	
		        _destroyVirtualScrollable: function() {
		            var that = this;
	
		            that._clearEditableState();
	
		            if (that.virtualScrollable && that.virtualScrollable.element) {
		                that.virtualScrollable.destroy();
		            }
	
		            that.virtualScrollable = null;
		        },
	
		        _renderNoRecordsContent: function() {
		            var that = this;
	
		            if (that.options.noRecords) {
		                var noRecordsElement = that.table.parent().children('.' + NORECORDSCLASS);
	
		                if (noRecordsElement.length) {
		                    that.angular("cleanup", function(){
		                        return { elements: noRecordsElement.get() };
		                    });
	
		                    noRecordsElement.remove();
		                }
	
		                if (!that.dataSource || !that.dataSource.view().length) {
		                    noRecordsElement = $(that.noRecordsTemplate({})).insertAfter(that.table);
	
		                    that.angular("compile", function(){
		                        return {
		                            elements: noRecordsElement.get(),
		                            data: [{}]
		                        };
		                    });
		                }
		            }
		        },
	
		        _setContentWidth: function(scrollLeft) {
		            var that = this,
		                hiddenDivClass = 'k-grid-content-expander',
		                hiddenDiv = '<div class="' + hiddenDivClass + '"></div>',
		                resizable = that.resizable,
		                expander;
	
		            if (that.options.scrollable && that.wrapper.is(":visible")) {
		                expander = that.table.parent().children('.' + hiddenDivClass);
		                that._setContentWidthHandler = proxy(that._setContentWidth, that);
		                if (!that.dataSource || !that.dataSource.view().length) {
		                    if (!expander[0]) {
		                        expander = $(hiddenDiv).appendTo(that.table.parent());
		                        if (resizable) {
		                            resizable.bind("resize", that._setContentWidthHandler);
		                        }
		                    }
		                    if (that.thead) {
		                        expander.width(that.thead.width());
		                        if (!isNaN(parseFloat(scrollLeft, 10))) {
		                            that.content.scrollLeft(scrollLeft);
		                        }
		                    }
		                } else if (expander[0]) {
		                    expander.remove();
		                    if (resizable) {
		                        resizable.unbind("resize", that._setContentWidthHandler);
		                    }
		                }
	
		                that._applyLockedContainersWidth();
		                that._syncLockedContentHeight();
	
		                // workaround IE does not show vertical scrollbar for elements without width
		                if (that.lockedHeader && that.table[0].clientWidth === 0) {
		                    that.table[0].style.width = "1px";
		                }
		            }
		        },
	
		        _applyLockedContainersWidth: function() {
		            if (this.options.scrollable && this.lockedHeader) {
		                var headerTable = this.thead.parent(),
		                    headerWrap = headerTable.parent(),
		                    contentWidth = this.wrapper[0].clientWidth,
		                    groups = this._groups(),
		                    scrollbar = kendo.support.scrollbar(),
		                    cols = this.lockedHeader.find(">table>colgroup>col:not(.k-group-col, .k-hierarchy-col)"),
		                    nonLockedCols = headerTable.find(">colgroup>col:not(.k-group-col, .k-hierarchy-col)"),
		                    width = columnsWidth(cols),
		                    nonLockedColsWidth = columnsWidth(nonLockedCols),
		                    footerWrap;
	
		                if (groups > 0) {
		                    width += outerWidth(this.lockedHeader.find(".k-group-cell:first")) * groups;
		                }
	
		                if (width >= contentWidth) {
		                    width = contentWidth - 3 * scrollbar;
		                }
	
		                this.lockedHeader
		                    .add(this.lockedContent)
		                    .width(width);
	
		                headerWrap[0].style.width = headerWrap.parent().width() - width - 2 + "px";
	
		                headerTable.add(this.table).width(nonLockedColsWidth);
	
		                //https://github.com/telerik/kendo-ui-core/issues/377
		                if (this.virtualScrollable && !isIE11) {
		                    contentWidth -= scrollbar;
		                }
	
		                this.content[0].style.width = contentWidth - width - 2 + "px";
	
		                if (this.lockedFooter && this.lockedFooter.length) {
		                    this.lockedFooter.width(width);
		                    footerWrap = this.footer.find(".k-grid-footer-wrap");
		                    footerWrap[0].style.width = headerWrap[0].clientWidth + "px";
		                    footerWrap.children().first().width(nonLockedColsWidth);
		                }
		            }
		        },
	
		        _setContentHeight: function() {
		            var that = this,
		                options = that.options,
		                height,
		                header = that.wrapper.children(".k-grid-header"),
		                scrollbar = kendo.support.scrollbar();
		            var scrollableHeight = (options.scrollable || {}).height;
	
		            if (options.scrollable && that.wrapper.is(":visible")) {
		                if (scrollableHeight && that.content[0].style.height === "") {
		                    // fallback to client-side setting as ASP.NET MVC Core wrapper does not provide server rendering of the content
		                    that.content[0].style.height = scrollableHeight;
		                }
	
		                height = that.wrapper.innerHeight();
	
		                height -= outerHeight(header);
	
		                if (that.pager && that.pager.element.is(":visible")) {
		                    height -= outerHeight(that.pager.element);
		                }
	
		                if(options.groupable) {
		                    height -= outerHeight(that.wrapper.children(".k-grouping-header"));
		                }
	
		                if(options.toolbar) {
		                    height -= outerHeight(that.wrapper.children(".k-grid-toolbar"));
		                }
	
		                if (that.footerTemplate) {
		                    height -= outerHeight(that.wrapper.children(".k-grid-footer"));
		                }
	
		                var isGridHeightSet = function(el) {
		                    var initialHeight, newHeight;
		                    if (el[0].style.height) {
		                        return true;
		                    } else {
		                        initialHeight = el.height();
		                    }
	
		                    el.height("auto");
		                    newHeight = el.height();
	
		                    if (initialHeight != newHeight) {
		                        el.height("");
		                        return true;
		                    }
		                    el.height("");
		                    return false;
		                };
	
		                if (isGridHeightSet(that.wrapper)) { // set content height only if needed
		                    if (height > scrollbar * 2) { // do not set height if proper scrollbar cannot be displayed
		                        if (that.lockedContent) {
		                            scrollbar = that.table[0].offsetWidth > that.table.parent()[0].clientWidth ? scrollbar : 0;
		                            that.lockedContent.height(height - scrollbar);
		                        }
	
		                        that.content.height(height);
		                    } else {
		                        that.content.height(scrollbar * 2 + 1);
		                    }
		                }
		            }
		        },
	
		        _averageRowHeight: function() {
		            var that = this,
		                itemsCount = that._items(that.tbody).length,
		                rowHeight = that._rowHeight;
	
		            if (itemsCount === 0) {
		                return rowHeight;
		            }
	
		            if (!that._rowHeight) {
		                that._rowHeight = rowHeight = outerHeight(that.table) / itemsCount;
		                that._sum = rowHeight;
		                that._measures = 1;
		            }
	
		            var currentRowHeight = outerHeight(that.table) / itemsCount;
	
		            if (rowHeight !== currentRowHeight) {
		                that._measures ++;
		                that._sum += currentRowHeight;
		                that._rowHeight = that._sum / that._measures;
		            }
		            return rowHeight;
		        },
	
		        _dataSource: function() {
		            var that = this,
		                options = that.options,
		                pageable,
		                dataSource = options.dataSource;
	
		            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;
	
		            if (isPlainObject(dataSource)) {
		                extend(dataSource, { table: that.table, fields: that.columns });
	
		                pageable = options.pageable;
	
		                if (isPlainObject(pageable) && pageable.pageSize !== undefined) {
		                    dataSource.pageSize = pageable.pageSize;
		                }
		            }
	
		            if (that.dataSource && that._refreshHandler) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler)
		                                .unbind(PROGRESS, that._progressHandler)
		                                .unbind(ERROR, that._errorHandler);
		            } else {
		                that._refreshHandler = proxy(that.refresh, that);
		                that._progressHandler = proxy(that._requestStart, that);
		                that._errorHandler = proxy(that._error, that);
		            }
	
		            that.dataSource = DataSource.create(dataSource)
		                                .bind(CHANGE, that._refreshHandler)
		                                .bind(PROGRESS, that._progressHandler)
		                                .bind(ERROR, that._errorHandler);
		        },
	
		        _error: function() {
		            this._progress(false);
		        },
	
		        _requestStart: function() {
		            this._progress(true);
		        },
	
		        _modelChange: function(e) {
		            var that = this,
		                tbody = that.tbody,
		                model = e.model,
		                row = that.tbody.find("tr[" + kendo.attr("uid") + "=" + model.uid +"]"),
		                relatedRow,
		                cell,
		                column,
		                isAlt = row.hasClass("k-alt"),
		                tmp,
		                idx = that._items(tbody).index(row),
		                isLocked = that.lockedContent,
		                selectable,
		                selectableRow,
		                childCells,
		                originalCells,
		                length;
	
		            if (isLocked) {
		                relatedRow = that._relatedRow(row);
		            }
	
		            if (row.add(relatedRow).children(".k-edit-cell").length && !that.options.rowTemplate) {
		                row.add(relatedRow).children(":not(.k-group-cell,.k-hierarchy-cell)").each(function() {
		                    cell = $(this);
		                    column = leafColumns(that.columns)[that.cellIndex(cell)];
	
		                    if (column.field === e.field) {
		                        if (!cell.hasClass("k-edit-cell")) {
		                            that._displayCell(cell, column, model);
		                        } else {
		                            cell.addClass("k-dirty-cell");
		                        }
		                    }
		                });
	
		            } else if (!row.hasClass("k-grid-edit-row")) {
	
		                selectableRow = $().add(row);
	
		                if (isLocked) {
		                    tmp = (isAlt ? that.lockedAltRowTemplate : that.lockedRowTemplate)(model);
	
		                    selectableRow = selectableRow.add(relatedRow);
	
		                    relatedRow.replaceWith(tmp);
		                }
	
		                that.angular("cleanup", function(){ return { elements: selectableRow.get() }; });
	
		                tmp = (isAlt ? that.altRowTemplate : that.rowTemplate)(model);
	
		                row.replaceWith(tmp);
	
		                tmp = that._items(tbody).eq(idx);
	
		                var angularData = [ { dataItem: model } ];
	
		                if (isLocked) {
		                    row = row.add(relatedRow);
	
		                    relatedRow = that._relatedRow(tmp)[0];
		                    adjustRowHeight(tmp[0], relatedRow);
	
		                    tmp = tmp.add(relatedRow);
		                    angularData.push({ dataItem: model });
		                }
	
		                that.angular("compile", function(){
		                    return {
		                        elements: tmp.get(),
		                        data: angularData
		                     };
		                });
	
		                selectable = that.options.selectable;
		                if ((selectable || that._checkBoxSelection) && row.hasClass("k-state-selected")) {
		                   that.select(tmp);
		                }
	
		                originalCells = selectableRow.children(":not(.k-group-cell,.k-hierarchy-cell)");
		                childCells = tmp.children(":not(.k-group-cell,.k-hierarchy-cell)");
	
		                for (idx = 0, length = that.columns.length; idx < length; idx++) {
		                    column = that.columns[idx];
	
		                    cell = childCells.eq(idx);
		                    if (selectable && originalCells.eq(idx).hasClass("k-state-selected")) {
		                        cell.addClass("k-state-selected");
		                    }
		                }
	
		                that.trigger("itemChange", { item: tmp, data: model, ns: ui });
		            }
		        },
	
		        _pageable: function() {
		            var that = this,
		                wrapper,
		                pageable = that.options.pageable;
	
		            if (pageable) {
		                wrapper = that.wrapper.children("div.k-grid-pager");
	
		                if (!wrapper.length) {
		                    wrapper = $('<div class="k-pager-wrap k-grid-pager"/>').appendTo(that.wrapper);
		                }
	
		                if (that.pager) {
		                    that.pager.destroy();
		                }
	
		                if (typeof pageable === "object" && pageable instanceof kendo.ui.Pager) {
		                    that.pager = pageable;
		                } else {
		                    that.pager = new kendo.ui.Pager(wrapper, extend({}, pageable, { dataSource: that.dataSource }));
		                }
	
		                that.pager.bind("pageChange", function(e) {
		                    if (that.trigger("page", { page: e.index })) {
		                        e.preventDefault();
		                    }
		                });
		            }
		        },
	
		        _footer: function() {
		            var that = this,
		                aggregates = that.dataSource.aggregates(),
		                html = "",
		                footerTemplate = that.footerTemplate,
		                options = that.options,
		                footerWrap,
		                footer = that.footer || that.wrapper.find(".k-grid-footer");
	
		            if (footerTemplate) {
		                html = $(that._wrapFooter(footerTemplate(aggregates)));
	
		                if (footer.length) {
		                    var tmp = html;
	
		                    that.angular("cleanup", function(){
		                        return { elements: footer.get() };
		                    });
	
		                    footer.replaceWith(tmp);
		                    footer = that.footer = tmp;
		                } else {
		                    if (options.scrollable) {
		                        footer = that.footer = options.pageable ? html.insertBefore(that.wrapper.children("div.k-grid-pager")) : html.appendTo(that.wrapper);
		                    } else {
		                        footer = that.footer = html.insertBefore(that.tbody);
		                    }
		                }
	
		                that.angular("compile", function(){
		                    return {
		                        elements: footer.find("td:not(.k-group-cell, .k-hierarchy-cell)").get(),
		                        data: map(that.columns, function(col){
		                            return {
		                                column: col,
		                                aggregate: aggregates[col.field]
		                            };
		                        })
		                    };
		                });
	
		            } else if (footer && !that.footer) {
		                that.footer = footer;
		            }
	
		            if (footer.length) {
		                if (options.scrollable) {
		                    footerWrap = footer.attr("tabindex", -1).children(".k-grid-footer-wrap");
	
		                    that.scrollables = $(
		                        that.scrollables
		                            .filter(function() { return !$(this).is(".k-grid-footer-wrap"); })
		                            .toArray()
		                    ).add(footerWrap);
		                }
	
		                if (that._footerWidth) {
		                    footer.find("table").css('width', that._footerWidth);
		                }
	
		                if (footerWrap) {
		                    var offset = that.content.scrollLeft();
	
		                    if (options.scrollable !== true && options.scrollable.virtual) {
		                        offset = that.wrapper.find('.k-virtual-scrollable-wrap').scrollLeft();
		                    }
		                    footerWrap.scrollLeft(offset);
		                }
		            }
	
		            if (that.lockedContent) {
		                that._appendLockedColumnFooter();
		                that._applyLockedContainersWidth();
		                that._syncLockedFooterHeight();
		            }
		        },
	
		        _wrapFooter: function(footerRow) {
		            var that = this,
		                html = "",
		                scrollbar = !kendo.support.mobileOS ? kendo.support.scrollbar() : 0;
	
		            if (that.options.scrollable) {
		                html = $('<div class="k-grid-footer"><div class="k-grid-footer-wrap"><table' + (isIE7 ? ' cellspacing="0"' : '') + '><tbody>' + footerRow + '</tbody></table></div></div>');
		                that._appendCols(html.find("table"));
		                html.css((isRtl ? "padding-left" : "padding-right"), scrollbar); // Update inner fix.
	
		                return html;
		            }
	
		            return '<tfoot class="k-grid-footer">' + footerRow + '</tfoot>';
		        },
	
		        _columnMenu: function() {
		            var that = this,
		                menu,
		                columns = leafColumns(that.columns),
		                column,
		                options = that.options,
		                columnMenu = options.columnMenu,
		                menuOptions,
		                sortable,
		                filterable,
		                cells,
		                hasMultiColumnHeaders = grep(that.columns, function(item) {
		                    return item.columns !== undefined;
		                }).length > 0,
		                isMobile = this._isMobile,
		                initCallback = function(e) {
		                    that.trigger(COLUMNMENUINIT, { field: e.field, container: e.container });
		                },
		                openCallback = function(e) {
		                    that.trigger(COLUMNMENUOPEN, { field: e.field, container: e.container });
		                },
		                closeCallback = function(element) {
		                    focusTable(element.closest("table"), true);
		                },
		                sortHandler = function(e) {
		                    if (that.trigger("sort", { sort: e.sort })) {
		                        e.preventDefault();
		                    } else {
		                        that._clearEditableState();
		                        if (that.dataSource.options.endless) {
		                            that.dataSource.options.endless = null;
		                            that._endlessPageSize = that.dataSource.options.pageSize;
		                            that.dataSource.pageSize(that.dataSource.options.pageSize);
		                        }
		                    }
		                },
		                filterHandler = function(e) {
		                    if (that.trigger("filter", { filter: e.filter, field: e.field })) {
		                        e.preventDefault();
		                    } else {
		                        that._clearEditableState();
		                        if (that.dataSource.options.endless) {
		                            that.dataSource.options.endless = null;
		                            that._endlessPageSize = that.dataSource.options.pageSize;
		                            that.dataSource.pageSize(that.dataSource.options.pageSize);
		                        }
		                    }
		                },
		                $angular = options.$angular;
	
		            if (columnMenu) {
		                if (typeof columnMenu == "boolean") {
		                    columnMenu = {};
		                }
	
		                that._setColumnsMediaVisibility(columns);
	
		                cells = leafDataCells(that.thead);
	
		                for (var idx = 0, length = cells.length; idx < length; idx++) {
		                    column = columns[idx];
		                    var cell = cells.eq(idx);
	
		                    if (!column.command && (column.field || cell.attr("data-" + kendo.ns + "field"))) {
		                        menu = cell.data("kendoColumnMenu");
		                        if (menu) {
		                            menu.destroy();
		                        }
	
		                        sortable = column.sortable !== false && columnMenu.sortable !== false && options.sortable !== false ? extend({}, options.sortable, {
		                            compare: (column.sortable || {}).compare
		                        }) : false;
	
		                        filterable = options.filterable && column.filterable !== false && columnMenu.filterable !== false ? extend({ pane: that.pane }, options.filterable, column.filterable) : false;
	
		                        if (column.filterable && column.filterable.dataSource) {
		                            filterable.forceUnique = false;
		                            filterable.checkSource = column.filterable.dataSource;
		                        }
	
		                        if (filterable) {
		                            filterable.format = column.format;
		                        }
	
		                        menuOptions = {
		                            dataSource: that.dataSource,
		                            values: column.values,
		                            columns: columnMenu.columns,
		                            sortable: sortable,
		                            filterable: filterable,
		                            messages: columnMenu.messages,
		                            owner: that,
		                            closeCallback: closeCallback,
		                            init: initCallback,
		                            open: openCallback,
		                            pane: that.pane,
		                            sort: sortHandler,
		                            filtering: filterHandler,
		                            filter: isMobile ? ":not(.k-column-active)" : "",
		                            lockedColumns: !hasMultiColumnHeaders && column.lockable !== false && lockedColumns(columns).length > 0
		                        };
	
		                        if ($angular) {
		                            menuOptions.$angular = $angular;
		                        }
	
		                        cell.kendoColumnMenu(menuOptions);
		                    }
		                }
		            }
		        },
	
		        _headerCells: function() {
		            return this.thead.find("th").filter(function() {
		                var th = $(this);
		                return !th.hasClass("k-group-cell") && !th.hasClass("k-hierarchy-cell");
		            });
		        },
	
		        _filterable: function() {
		            var that = this,
		                columns = leafColumns(that.columns),
		                filterMenu,
		                cells,
		                cell,
		                filterInit = function(e) {
		                    that.trigger(FILTERMENUINIT, { field: e.field, container: e.container });
		                },
		                closeCallback = function(element) {
		                    focusTable(element.closest("table"), true);
		                },
		                filterHandler = function(e) {
		                    if (that.trigger("filter", { filter: e.filter, field: e.field })) {
		                        e.preventDefault();
		                    } else {
		                        that._clearEditableState();
		                        if (that.dataSource.options.endless) {
		                            that.dataSource.options.endless = null;
		                            that._endlessPageSize = that.dataSource.options.pageSize;
		                            that.dataSource.pageSize(that.dataSource.options.pageSize);
		                        }
		                    }
		                },
		                filterOpen = function(e) {
		                    that.trigger(FILTERMENUOPEN, { field: e.field, container: e.container });
		                },
		                filterable = that.options.filterable;
		                if (filterable && typeof filterable.mode == STRING && filterable.mode.indexOf("menu") == -1) {
		                    filterable = false;
		                }
	
		            if (filterable && !that.options.columnMenu) {
		                cells = leafDataCells(that.thead);//that._headerCells();
	
		                for (var idx = 0, length = cells.length; idx < length; idx++) {
		                    cell = cells.eq(idx);
	
		                    if (columns[idx].filterable !== false && !columns[idx].command && (columns[idx].field || cell.attr("data-" + kendo.ns + "field"))) {
		                        filterMenu = cell.data("kendoFilterMenu");
	
		                        if (filterMenu) {
		                            filterMenu.destroy();
		                        }
	
		                        filterMenu = cell.data("kendoFilterMultiCheck");
		                        if (filterMenu) {
		                           filterMenu.destroy();
		                        }
	
		                        var columnFilterable = columns[idx].filterable;
	
		                        var options = extend({},
		                            filterable,
		                            columnFilterable,
		                            {
		                                dataSource: that.dataSource,
		                                values: columns[idx].values,
		                                format: columns[idx].format,
		                                closeCallback: closeCallback,
		                                title: columns[idx].title || columns[idx].field,
		                                init: filterInit,
		                                open: filterOpen,
		                                pane: that.pane,
		                                change: filterHandler
		                            }
		                        );
	
		                        if (columnFilterable && columnFilterable.messages) {
		                            options.messages = extend(true, {}, filterable.messages, columnFilterable.messages);
		                        }
		                        if (columnFilterable && columnFilterable.dataSource) {
		                            options.forceUnique = false;
		                            options.checkSource = columnFilterable.dataSource;
		                        }
	
		                        if (columnFilterable && columnFilterable.multi) {
		                            cell.kendoFilterMultiCheck(options);
		                        } else {
		                            cell.kendoFilterMenu(options);
		                        }
		                    }
		                }
		            }
		        },
	
		        _filterRow: function() {
		            var that = this;
		            if (!that._hasFilterRow()) {
		               return;
		            }
	
		            var settings;
		            var $angular = that.options.$angular;
		            var columns = leafColumns(that.columns),
		                filterable = that.options.filterable,
		                rowheader = that.thead.find(".k-filter-row"),
		                filterHandler = function(e) {
		                    if (that.trigger("filter", { filter: e.filter, field: e.field })) {
		                        e.preventDefault();
		                    } else {
		                        that._clearEditableState();
		                        if (that.dataSource.options.endless) {
		                            that.dataSource.options.endless = null;
		                            that._endlessPageSize = that.dataSource.options.pageSize;
		                            that.dataSource.pageSize(that.dataSource.options.pageSize);
		                        }
		                    }
		                };
	
	
		            this._updateHeader(this.dataSource.group().length);
	
		            for (var i = 0; i < columns.length; i++) {
		                var suggestDataSource,
		                    col = columns[i],
		                    operators = that.options.filterable.operators,
		                    customDataSource = false,
		                    th = $("<th/>"),
		                    field = col.field;
	
		                if (col.hidden) {
		                    th.hide();
		                }
		                rowheader.append(th);
		                if (field && col.filterable !== false) {
		                    var cellOptions = col.filterable && col.filterable.cell || {};
	
		                    suggestDataSource = that.options.dataSource;
		                    if (suggestDataSource instanceof DataSource) {
		                        suggestDataSource = that.options.dataSource.options;
		                    }
	
		                    var messages = extend(true, {}, filterable.messages);
		                    if (col.filterable) {
		                        extend(true, messages, col.filterable.messages);
		                    }
	
		                    if (cellOptions.enabled === false) {
		                        th.html("&nbsp;");
		                        continue;
		                    }
		                    if (cellOptions.dataSource) {
		                        suggestDataSource = cellOptions.dataSource;
		                        customDataSource = true;
		                    }
		                    if (col.filterable && col.filterable.operators) {
		                        operators =  col.filterable.operators;
		                    }
	
		                    settings = {
		                        column: col,
		                        dataSource: that.dataSource,
		                        suggestDataSource: suggestDataSource,
		                        customDataSource: customDataSource,
		                        field: field,
		                        messages: messages,
		                        values: col.values,
		                        template: cellOptions.template,
		                        delay: cellOptions.delay,
		                        inputWidth: cellOptions.inputWidth,
		                        suggestionOperator: cellOptions.suggestionOperator,
		                        minLength: cellOptions.minLength,
		                        dataTextField: cellOptions.dataTextField,
		                        operator: cellOptions.operator,
		                        operators: operators,
		                        showOperators: cellOptions.showOperators,
		                        change: filterHandler
		                    };
	
		                    if ($angular) {
		                        settings.$angular = $angular;
		                    }
	
		                    $("<span/>").attr(kendo.attr("field"), field)
		                        .appendTo(th)
		                        .kendoFilterCell(settings);
		                } else {
		                    th.html("&nbsp;");
		                }
		            }
		        },
	
		        _sortable: function() {
		            var that = this,
		                columns = leafColumns(that.columns),
		                column,
		                sorterInstance,
		                cell,
		                sortable = that.options.sortable,
		                sortHandler = function(e) {
		                    if (that.trigger("sort", { sort: e.sort })) {
		                        e.preventDefault();
		                    } else {
		                        that._clearEditableState();
		                    }
		                };
	
	
		            if (sortable) {
		                var cells = leafDataCells(that.thead);
	
		                for (var idx = 0, length = cells.length; idx < length; idx++) {
		                    column = columns[idx];
	
		                    if (column.sortable !== false && !column.command && column.field) {
		                        cell = cells.eq(idx);
	
		                        sorterInstance = cell.data("kendoColumnSorter");
	
		                        if (sorterInstance) {
		                            sorterInstance.destroy();
		                        }
	
		                        cell.attr("data-" + kendo.ns +"field", column.field)
		                            .kendoColumnSorter(
		                                extend({}, sortable, column.sortable, {
		                                    dataSource: that.dataSource,
		                                    aria: true,
		                                    filter: ":not(.k-column-active)",
		                                    change: sortHandler
		                                })
		                            );
		                    }
		                }
		                cells = null;
		            }
		        },
	
		        _columns: function(columns) {
		            var that = this,
		                table = that.table,
		                encoded,
		                cols = table.find("col"),
		                lockedCols,
		                headers = that.element.find('thead:first th[data-index]'),
		                columnLeafs,
		                dataSource = that.options.dataSource;
	
		            // using HTML5 data attributes as a configuration option e.g. <th data-field="foo">Foo</foo>
		            columns = columns.length ? columns : map(table.find("th"), function(th, idx) {
		                th = $(th);
		                var sortable = th.attr(kendo.attr("sortable")),
		                    filterable = th.attr(kendo.attr("filterable")),
		                    type = th.attr(kendo.attr("type")),
		                    groupable = th.attr(kendo.attr("groupable")),
		                    field = th.attr(kendo.attr("field")),
		                    title = th.attr(kendo.attr("title")),
		                    menu = th.attr(kendo.attr("menu"));
	
		                if (!field) {
		                   field = th.text().replace(/\s|[^A-z0-9]/g, "");
		                }
	
		                return {
		                    field: field,
		                    type: type,
		                    title: title,
		                    sortable: sortable !== "false",
		                    filterable: filterable !== "false",
		                    groupable: groupable !== "false",
		                    menu: menu,
		                    template: th.attr(kendo.attr("template")),
		                    width: cols.eq(idx).css("width")
		                };
		            });
	
		            encoded = !(that.table.find("tbody tr").length > 0 && (!dataSource || !dataSource.transport));
	
		            if (that.options.scrollable) {
		                var initialColumns = columns;
		                lockedCols = lockedColumns(columns);
		                columns = nonLockedColumns(columns);
	
		                if (lockedCols.length > 0 && columns.length === 0) {
		                    throw new Error("There should be at least one non locked column");
		                }
	
		                normalizeHeaderCells(that.element.find("tr:has(th):first"), initialColumns);
		                columns = lockedCols.concat(columns);
		            }
	
		            that.columns = normalizeColumns(columns, encoded);
	
		            if (headers.length && that.columns.length) {
		                columnLeafs = leafColumns(that.columns);
		                map(headers, function(th) {
		                    th = $(th);
		                    var id = th.attr("id");
		                    var idx = kendo.parseInt(th.attr("data-index"));
		                    if (id) {
		                        columnLeafs[idx].headerAttributes = extend(columnLeafs[idx].headerAttributes, { id: id });
		                    }
		                });
		            }
	
		            if($.grep(leafColumns(that.columns), function (col) { return col.selectable ;}).length) {
		                that._selectedIds = {};
		                that._checkBoxSelection = true;
		                that.wrapper.on(CLICK + NS, "tbody > tr " + CHECKBOXINPUT, proxy(that._checkboxClick, that));
		                that.wrapper.on(CLICK + NS, "thead > tr " + CHECKBOXINPUT, proxy(that._headerCheckboxClick, that));
		            }
		        },
	
		        _headerCheckboxClick: function(e) {
		            var that = this,
		                checkBox = $(e.target),
		                checked = checkBox.prop("checked"),
		                parentGrid = checkBox.closest(".k-grid.k-widget").getKendoGrid();
	
		            if (that !== parentGrid) {
		                return;
		            }
	
		            if (checked) {
		                that.select(parentGrid.items());
		            } else {
		                that.clearSelection();
		            }
		        },
	
		        _checkboxClick: function(e) {
		            var that = this,
		                row =  $(e.target).closest("tr"),
		                isSelecting = !row.hasClass(SELECTED);
	
		            if(that !== row.closest(".k-grid.k-widget").getKendoGrid()) {
		                return;
		            }
	
		            if (isSelecting) {
		                that.select(row);
		            } else {
		                that._deselectCheckRows(row);
		            }
		        },
	
		        _groups: function() {
		            var group = this.dataSource.group();
	
		            return group ? group.length : 0;
		        },
	
		        _tmpl: function(rowTemplate, columns, alt, skipGroupCells) {
		            var that = this,
		                settings = extend({}, kendo.Template, that.options.templateSettings),
		                paramName = settings.paramName,
		                idx,
		                length = columns.length,
		                template,
		                state = { storage: {}, count: 0 },
		                column,
		                type,
		                hasDetails = that._hasDetails(),
		                className = [],
		                groups = that._groups(),
		                navigatable = that.options.navigatable;
		            var fieldAttr = kendo.attr("field");
		            var field;
		            var dirtyCellTemplate = "";
	
		            if (!rowTemplate) {
		                rowTemplate = "<tr";
	
		                if (alt) {
		                    className.push("k-alt");
		                }
	
		                if (hasDetails) {
		                    className.push("k-master-row");
		                }
	
		                if (className.length) {
		                    rowTemplate += ' class="' + className.join(" ") + '"';
		                }
	
		                if (length) { // data item is an object
		                    rowTemplate += ' ' + kendo.attr("uid") + '="#=' + kendo.expr("uid", settings.paramName) + '#"';
		                }
	
		                rowTemplate += " role='row'>";
	
		                if (groups > 0 && !skipGroupCells) {
		                    rowTemplate += groupCells(groups);
		                }
	
		                if (hasDetails) {
		                    rowTemplate += '<td class="k-hierarchy-cell" aria-expanded="false"><a class="k-icon k-i-expand" href="\\#" ' + ARIALABEL + '="' + EXPAND + '" tabindex="-1"></a></td>';
		                }
	
		                for (idx = 0; idx < length; idx++) {
		                    column = columns[idx];
		                    template = column.template;
		                    type = typeof template;
		                    field = column.field;
	
		                    if (that._editMode() === INCELL && field) {
		                        column.attributes = column.attributes || {};
	
		                        if (that.virtualScrollable) {
		                            column.attributes[fieldAttr] = field;
		                        }
	
		                        dirtyCellTemplate = that._dirtyCellTemplate(field, paramName);
		                        column.attributes["class"] = (column.attributes["class"] || "");
	
		                        if (column.attributes["class"].indexOf(dirtyCellTemplate) < 0) {
		                            column.attributes["class"] += dirtyCellTemplate;
		                        }
		                    }
	
		                    if (column.command) {
		                        column.attributes = column.attributes || {};
	
		                        if (typeof column.attributes["class"] !== "undefined") {
		                            column.attributes["class"] += " k-command-cell";
		                        } else {
		                            column.attributes["class"] = "k-command-cell";
		                        }
		                    }
	
		                    rowTemplate += "<td" + stringifyAttributes(column.attributes);
	
		                    if (navigatable) {
		                        rowTemplate += " aria-describedby='" + column.headerAttributes.id + "'";
		                    }
	
		                    rowTemplate += " role='gridcell'>";
		                    rowTemplate += that._cellTmpl(column, state);
	
		                    rowTemplate += "</td>";
		                }
	
		                rowTemplate += "</tr>";
		            }
	
		            rowTemplate = kendo.template(rowTemplate, settings);
	
		            if (state.count > 0) {
		                return proxy(rowTemplate, state.storage);
		            }
	
		            return rowTemplate;
		        },
	
		        _dirtyCellTemplate: function(field, paramName) {
		            var dirtyField;
	
		            if (field && paramName) {
		                dirtyField = field.charAt(0) === "[" ? kendo.expr(field, paramName + ".dirtyFields") : paramName + ".dirtyFields['" + field + "']";
	
		                return "#= " + paramName + " && " + paramName + ".dirty && " + paramName + ".dirtyFields && " + dirtyField + " ? ' k-dirty-cell' : '' #";
		            }
	
		            return "";
		        },
	
		        _headerCellText: function(column) {
		            var that = this,
		                settings = extend({}, kendo.Template, that.options.templateSettings),
		                template = column.headerTemplate,
		                type = typeof(template),
		                text = column.title || column.field || "";
	
		            if (type === FUNCTION) {
		                text = kendo.template(template, settings)({});
		            } else if (type === STRING) {
		                text = template;
		            }
		            return text;
		        },
	
		        _cellTmpl: function(column, state) {
		            var that = this,
		                settings = extend({}, kendo.Template, that.options.templateSettings),
		                template = column.template,
		                paramName = settings.paramName,
		                field = column.field,
		                html = "",
		                idx,
		                length,
		                format = column.format,
		                type = typeof template,
		                columnValues = column.values;
	
		            if (column.command) {
		                if (isArray(column.command)) {
		                    for (idx = 0, length = column.command.length; idx < length; idx++) {
		                        if(column.command[idx].visible) {
		                            html += kendo.format("#= {0}(data)? '{1}':'' #",column.command[idx].visible, that._createButton(column.command[idx]).replace(templateHashRegExp, "\\#").replace(/'/ig,"\\'"));
		                        } else {
		                            html += that._createButton(column.command[idx]).replace(templateHashRegExp, "\\#");
		                        }
		                    }
		                    return html;
		                }
		                return that._createButton(column.command).replace(templateHashRegExp, "\\#");
		            }
	
		            if(column.selectable) {
		                return SELECTCOLUMNTMPL;
		            }
	
		            html += that._dirtyIndicatorTemplate(field, paramName);
	
		            if (type === FUNCTION) {
		                state.storage["tmpl" + state.count] = template;
		                html += "#=this.tmpl" + state.count + "(" + paramName + ")#";
		                state.count ++;
		            } else if (type === STRING) {
		                html += template;
		            } else if (columnValues && columnValues.length && isPlainObject(columnValues[0]) && "value" in columnValues[0] && field) {
		                html += "#var v =" + kendo.stringify(convertToObject(columnValues)).replace(templateHashRegExp, "\\#") + "#";
		                html += "#var f = v[";
	
		                if (!settings.useWithBlock) {
		                    html += paramName + ".";
		                }
	
		                html += field + "]#";
		                html += "${f != null ? f : ''}";
		            } else {
		                html += column.encoded ? "#:" : "#=";
	
		                if (format) {
		                    html += 'kendo.format(\"' + format.replace(formatRegExp,"\\$1") + '\",';
		                }
	
		                if (field) {
		                    field = kendo.expr(field, paramName);
		                    html += field + "==null?'':" + field;
		                } else {
		                    html += "''";
		                }
	
		                if (format) {
		                    html += ")";
		                }
	
		                html += "#";
		            }
		            return html;
		        },
	
		        _dirtyIndicatorTemplate: function(field, paramName) {
		            var dirtyField;
	
		            if (field && paramName) {
		                dirtyField = field.charAt(0) === "[" ? kendo.expr(field, paramName + ".dirtyFields") : paramName + ".dirtyFields['" + field + "']";
	
		                return "#= " + paramName + " && " + paramName + ".dirty && " + paramName + ".dirtyFields && " + dirtyField +
		                    " ? '<span class=\"k-dirty\"></span>' : '' #";
		            }
	
		            return "";
		        },
	
		        _templates: function() {
		            var that = this,
		                options = that.options,
		                dataSource = that.dataSource,
		                groups = dataSource.group(),
		                footer = that.footer || that.wrapper.find(".k-grid-footer"),
		                aggregates = dataSource.aggregate(),
		                columnLeafs = leafColumns(that.columns),
		                columnsLocked = leafColumns(lockedColumns(that.columns)),
		                columns = options.scrollable ? leafColumns(nonLockedColumns(that.columns)) : columnLeafs,
		                groupHeaderColumnTemplateLockedColumns = grep(visibleColumns(columnsLocked), function(column, index) { return column.groupHeaderColumnTemplate && index !== 0; }),
		                groupHeaderColumnTemplateNonLockedColumns = grep(visibleColumns(columns), function(column) { return column.groupHeaderColumnTemplate; });
	
		            if (options.scrollable && columnsLocked.length) {
		                if (options.rowTemplate || options.altRowTemplate) {
		                    throw new Error("Having both row template and locked columns is not supported");
		                }
	
		                that.rowTemplate = that._tmpl(options.rowTemplate, columns, false, true);
		                that.altRowTemplate = that._tmpl(options.altRowTemplate || options.rowTemplate, columns, true, true);
	
		                that.lockedRowTemplate = that._tmpl(options.rowTemplate, columnsLocked);
		                that.lockedAltRowTemplate = that._tmpl(options.altRowTemplate || options.rowTemplate, columnsLocked, true);
		            } else {
		                that.rowTemplate = that._tmpl(options.rowTemplate, columns);
		                that.altRowTemplate = that._tmpl(options.altRowTemplate || options.rowTemplate, columns, true);
		            }
	
		            if (that._hasDetails()) {
		                that.detailTemplate = that._detailTmpl(options.detailTemplate || "");
		            }
	
		            if ((that._group && !isEmptyObject(aggregates)) || (!isEmptyObject(aggregates) && !footer.length) ||
		                grep(columnLeafs, function(column) { return column.footerTemplate; }).length) {
	
		                that.footerTemplate = that._footerTmpl(columnLeafs, aggregates, "footerTemplate", "k-footer-template");
		            }
	
		            if (groups && grep(columnLeafs, function(column) { return column.groupFooterTemplate; }).length) {
		                aggregates = $.map(groups, function(g) { return g.aggregates; });
	
		                that.groupFooterTemplate = that._footerTmpl(columns, aggregates, "groupFooterTemplate", "k-group-footer", columnsLocked.length);
	
		                if (options.scrollable && columnsLocked.length) {
		                    that.lockedGroupFooterTemplate = that._footerTmpl(columnsLocked, aggregates, "groupFooterTemplate", "k-group-footer");
		                }
		            }
	
		            if (groups && (groupHeaderColumnTemplateLockedColumns.length || groupHeaderColumnTemplateNonLockedColumns.length)) {
		                aggregates = $.map(groups, function(g) { return g.aggregates; });
	
		                that.groupHeaderColumnTemplate = that._groupHeaderTmpl(visibleColumns(columns), aggregates, "groupHeaderColumnTemplate", "k-grouping-row", columnsLocked.length, groupHeaderColumnTemplateNonLockedColumns);
	
		                if (options.scrollable && columnsLocked.length) {
		                    that.lockedGroupHeaderColumnTemplate = that._groupHeaderTmpl(visibleColumns(columnsLocked), aggregates, "groupHeaderColumnTemplate", "k-grouping-row", 0, groupHeaderColumnTemplateLockedColumns);
		                }
		            } else {
		                that.groupHeaderColumnTemplate = null;
		                that.lockedGroupHeaderColumnTemplate  = null;
		            }
	
		                if (that.options.noRecords) {
		                that.noRecordsTemplate = that._noRecordsTmpl();
		            }
		        },
	
		        _noRecordsTmpl: function () {
		            var wrapper = '<div class="{0}">{1}</div>';
		            var defaultTemplate = '<div class="k-grid-norecords-template"{1}>{0}</div>';
		            var scrollableNoGridHeightStyles = (this.options.scrollable && !this.wrapper[0].style.height) ? ' style="margin:0 auto;position:static;"' : '';
		            var state = { storage: {}, count: 0 };
		            var settings = $.extend({}, kendo.Template, this.options.templateSettings);
		            var paramName = settings.paramName;
		            var template;
		            var html = "";
		            var type;
		            var tmpl;
	
		            if (this.options.noRecords.template) {
		                template = this.options.noRecords.template;
		            } else {
		                template = kendo.format(defaultTemplate, this.options.messages.noRecords, scrollableNoGridHeightStyles);
		            }
	
		            type = typeof template;
		            if (type === "function") {
		                state.storage["tmpl" + state.count] = template;
		                html += "#=this.tmpl" + state.count + "(" + paramName + ")#";
		                state.count ++;
		            } else if (type === "string") {
		                html += template;
		            }
	
		            tmpl = kendo.template(kendo.format(wrapper, NORECORDSCLASS, html), settings);
	
		            if (state.count > 0) {
		                tmpl = $.proxy(tmpl, state.storage);
		            }
	
		            return tmpl;
		        },
	
		        _footerTmpl: function(columns, aggregates, templateName, rowClass, skipGroupCells) {
		            var that = this,
		                settings = extend({}, kendo.Template, that.options.templateSettings),
		                paramName = settings.paramName,
		                html = "",
		                idx,
		                length,
		                template,
		                type,
		                storage = {},
		                count = 0,
		                scope = {},
		                groups = that._groups(),
		                fieldsMap = that.dataSource._emptyAggregates(aggregates),
		                column;
	
		            html += '<tr class="' + rowClass + '">';
	
		            if (groups > 0 && !skipGroupCells) {
		                html += groupCells(groups);
		            }
	
		            if (that._hasDetails()) {
		                html += '<td class="k-hierarchy-cell">&nbsp;</td>';
		            }
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                column = columns[idx];
		                template = column[templateName];
		                type = typeof template;
	
		                html += "<td" + stringifyAttributes(column.footerAttributes) + ">";
	
		                if (template) {
		                    if (type !== FUNCTION) {
		                        scope = fieldsMap[column.field] ? extend({}, settings, { paramName: paramName + "['" + column.field + "']" }) : {};
		                        template = kendo.template(template, scope);
		                    }
	
		                    storage["tmpl" + count] = template;
		                    html += "#=this.tmpl" + count + "(" + paramName + ")#";
		                    count ++;
		                } else {
		                    html += "&nbsp;";
		                }
	
		                html += "</td>";
		            }
	
		            html += '</tr>';
	
		            html = kendo.template(html, settings);
	
		            if (count > 0) {
		                return proxy(html, storage);
		            }
	
		            return html;
		        },
	
		        _groupHeaderTmpl: function(columns, aggregates, templateName, rowClass, skipGroupCells, groupHeaderColumnTemplateColumns) {
		            var that = this,
		                settings = extend({}, kendo.Template, that.options.templateSettings),
		                paramName = settings.paramName,
		                html = "",
		                idx,
		                length,
		                template,
		                type,
		                storage = {},
		                count = 0,
		                scope = {},
		                fieldsMap = that.dataSource._emptyAggregates(aggregates),
		                column,
		                headerTemplateIndex = groupHeaderColumnTemplateColumns.length ? inArray(groupHeaderColumnTemplateColumns[0], columns) : -1;
	
		            html += '<tr role="row" class="' + rowClass + '">';
	
		            if (!skipGroupCells) {
		                html += '# for (var i = 0; i < data.groupCells; i++) { #' +
		                '<td class="k-group-cell">' +
		                  '&nbsp;' +
		                '</td>' +
		                '# } #';
		            }
	
		            if (that._hasDetails()) {
		                html += '<td class="k-hierarchy-cell">&nbsp;</td>';
		            }
	
		            if (headerTemplateIndex < 0) {
		                html += !skipGroupCells ? groupCellBuilder(columns.length) : '';
		                return;
		            }
	
		            if (headerTemplateIndex < MINCOLSPANVALUE && groupHeaderColumnTemplateColumns.length <= 1 && !skipGroupCells) {
		                html += !skipGroupCells ? groupCellBuilder(columns.length) : '';
		                return kendo.template(html, settings);
		            }
	
		            if (headerTemplateIndex < MINCOLSPANVALUE) {
		                headerTemplateIndex = !skipGroupCells ? 1 : 0;
		                html += !skipGroupCells ? groupCellBuilder(headerTemplateIndex) : '';
		            }
		            else {
		                html += !skipGroupCells ? groupCellBuilder(headerTemplateIndex) : groupCellLockedContentBuilder(headerTemplateIndex);
		            }
	
		            for (idx = headerTemplateIndex, length = columns.length; idx < length; idx++) {
		                column = columns[idx];
		                template = column[templateName];
		                type = typeof template;
	
		                html += "<td>";
	
		                if (template) {
		                    if (type !== FUNCTION) {
		                        scope = fieldsMap[column.field] ? extend({}, settings, { paramName: paramName + "['" + column.field + "']" }) : {};
		                        template = kendo.template(template, scope);
		                    }
	
		                    storage["tmpl" + count] = template;
		                    html += "#=this.tmpl" + count + "(" + paramName + ")#";
		                    count ++;
		                } else {
		                    html += "&nbsp;";
		                }
	
		                html += "</td>";
		            }
	
		            html += '</tr>';
	
		            html = kendo.template(html, settings);
	
		            if (count > 0) {
		                return proxy(html, storage);
		            }
	
		            return html;
		        },
	
		        _detailTmpl: function(template) {
		            var that = this,
		                html = "",
		                settings = extend({}, kendo.Template, that.options.templateSettings),
		                paramName = settings.paramName,
		                templateFunctionStorage = {},
		                templateFunctionCount = 0,
		                groups = that._groups(),
		                colspan = visibleColumns(leafColumns(that.columns)).length,
		                type = typeof template;
	
		            html += '<tr class="k-detail-row">';
		            if (groups > 0) {
		                html += groupCells(groups);
		            }
		            html += '<td class="k-hierarchy-cell"></td><td class="k-detail-cell"' + (colspan? ' colspan="' + colspan + '"' : '') + ">";
	
		            if (type === FUNCTION) {
		                templateFunctionStorage["tmpl" + templateFunctionCount] = template;
		                html += "#=this.tmpl" + templateFunctionCount + "(" + paramName + ")#";
		                templateFunctionCount ++;
		            } else {
		                html += template;
		            }
	
		            html += "</td></tr>";
	
		            html = kendo.template(html, settings);
	
		            if (templateFunctionCount > 0) {
		                return proxy(html, templateFunctionStorage);
		            }
	
		            return html;
		        },
	
		        _hasDetails: function() {
		            var that = this;
	
		            return that.options.detailTemplate !== null  || (that._events[DETAILINIT] || []).length;
		        },
		        _hasFilterRow: function() {
		            var filterable = this.options.filterable;
		            var hasFiltering = filterable &&
		                    typeof filterable.mode == STRING &&
		                    filterable.mode.indexOf("row") != -1;
		            var columns = this.columns;
		            var columnsWithoutFiltering = $.grep(columns, function(col) {
		                return col.filterable === false;
		            });
	
		            if (columns.length && columnsWithoutFiltering.length == columns.length) {
		                hasFiltering = false;
		            }
	
		            return hasFiltering;
		        },
	
		        _details: function() {
		            var that = this;
	
		            if (that.options.scrollable && that._hasDetails() && lockedColumns(that.columns).length) {
		                throw new Error("Having both detail template and locked columns is not supported");
		            }
	
		            that.table.on(CLICK + NS, ".k-hierarchy-cell .k-i-expand, .k-hierarchy-cell .k-i-collapse", function(e) {
		                var button = $(this),
		                    cell = button.closest("td.k-hierarchy-cell"),
		                    expanding = button.hasClass("k-i-expand"),
		                    masterRow = button.closest("tr.k-master-row"),
		                    detailRow,
		                    detailTemplate = that.detailTemplate,
		                    data,
		                    hasDetails = that._hasDetails(),
		                    ariaLabelText = expanding ? COLLAPSE : EXPAND,
		                    ariaExpandText = expanding ? true : false;
	
		                button.toggleClass("k-i-expand", !expanding)
		                    .toggleClass("k-i-collapse", expanding)
		                    .attr(ARIALABEL, ariaLabelText);
	
		                cell.attr("aria-expanded", ariaExpandText);
	
		                detailRow = masterRow.next();
	
		                if (hasDetails && !detailRow.hasClass("k-detail-row")) {
		                    data = that.dataItem(masterRow);
	
		                    detailRow = $(detailTemplate(data))
		                        .addClass(masterRow.hasClass("k-alt") ? "k-alt" : "")
		                        .insertAfter(masterRow);
	
		                    that.angular("compile", function(){
		                        return {
		                            elements: detailRow.get(),
		                            data: [ { dataItem: data } ]
		                        };
		                    });
	
		                    that.trigger(DETAILINIT, { masterRow: masterRow, detailRow: detailRow, data: data, detailCell: detailRow.find(".k-detail-cell") });
		                }
	
		                that.trigger(expanding ? DETAILEXPAND : DETAILCOLLAPSE, { masterRow: masterRow, detailRow: detailRow});
		                detailRow.toggle(expanding);
	
		                e.preventDefault();
		                return false;
		            });
		        },
	
		        dataItem: function(tr) {
		            tr = $(tr)[0];
		            if (!tr) {
		                return null;
		            }
	
		            var rows = this.tbody.children(),
		                classesRegEx = /k-grouping-row|k-detail-row|k-group-footer/,
		                idx = tr.sectionRowIndex,
		                j, correctIdx;
	
		            correctIdx = idx;
	
		            for (j = 0; j < idx; j++) {
		                if (classesRegEx.test(rows[j].className)) {
		                    correctIdx--;
		                }
		            }
	
		            return this._data[correctIdx];
		        },
	
		        expandRow: function(tr) {
		            $(tr).find('> td .k-i-expand').click();
		        },
	
		        collapseRow: function(tr) {
		            $(tr).find('> td .k-i-collapse').click();
		        },
	
		        _createHeaderCells: function(columns, rowSpan) {
		            var that = this,
		                idx,
		                th,
		                text,
		                html = "",
		                length,
		                title,
		                messages = that.options.messages,
		                leafs = leafColumns(that.columns),
		                groups = that.dataSource.group(),
		                field;
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                th = columns[idx].column || columns[idx];
		                text = that._headerCellText(th);
		                field = "";
	
		                var index = inArray(th, leafs);
	
		                if (th.selectable) {
		                    html += "<th scope='col'" + stringifyAttributes(th.headerAttributes);
	
		                    if (rowSpan && !columns[idx].colSpan) {
		                        html += " rowspan='" + rowSpan + "'";
		                    }
	
		                    if (index > -1) {
		                        html += kendo.attr("index") + "='" + index + "'";
		                    }
		                    text = th.headerTemplate ? text: kendo.template(SELECTCOLUMNHEADERTMPL)({});
		                    html += ">" + text + "</th>";
		                } else if(th.command) {
		                    html += "<th scope='col'" + stringifyAttributes(th.headerAttributes);
	
		                    if (rowSpan && !columns[idx].colSpan) {
		                        html += " rowspan='" + rowSpan + "'";
		                    }
	
		                    if (index > -1) {
		                        html += kendo.attr("index") + "='" + index + "'";
		                    }
	
		                    html += ">" + text + "</th>";
		                } else {
		                    if (th.field) {
		                        field = kendo.attr("field") + "='" + th.field + "' ";
		                    }
	
		                    html += "<th scope='col' role='columnheader' " + field;
		                    html += " aria-haspopup='true'";
	
		                    if (rowSpan && !columns[idx].colSpan) {
		                        html += " rowspan='" + rowSpan + "'";
		                    }
	
		                    if (columns[idx].colSpan > 1) {
		                        html += 'colspan="' + (columns[idx].colSpan - hiddenLeafColumnsCount(th.columns)) + '" ';
		                        html += kendo.attr("colspan") + "='" + columns[idx].colSpan + "'";
		                    }
	
		                    if (th.title) {
		                        title = th.title.replace('"', '&quot;').replace(/'/g, "\'");
		                        html += kendo.attr("title") + '="' + title + '" ';
		                    }
	
		                    if (th.groupable !== undefined) {
		                        html += kendo.attr("groupable") + "='" + th.groupable + "' ";
		                    }
	
		                    if (isColumnGroupable(that, th)) {
		                        html += "aria-label='" + (title || th.field) + " ";
		                        html += isGroupedBy(groups, th.field) ? messages.ungroupHeader : messages.groupHeader;
		                        html += "' ";
		                    }
	
		                    if (th.aggregates && th.aggregates.length) {
		                        html += kendo.attr("aggregates") + "='" + th.aggregates + "'";
		                    }
	
		                    if (index > -1) {
		                        html += kendo.attr("index") + "='" + index + "'";
		                    }
	
		                    html += stringifyAttributes(th.headerAttributes);
	
		                    html += ">" + text + "</th>";
		                }
		            }
		            return html;
		        },
	
		        _appendLockedColumnContent: function() {
		            var columns = this.columns,
		                idx,
		                colgroup = this.table.find("colgroup"),
		                cols = colgroup.find("col:not(.k-group-col,.k-hierarchy-col)"),
		                length,
		                lockedCols = $(),
		                skipHiddenCount = 0,
		                container,
		                colSpan,
		                spanIdx,
		                colOffset = 0;
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                if (columns[idx].locked) {
	
		                    if (isVisible(columns[idx])) {
		                        colSpan = 1;
	
		                        if (columns[idx].columns) {
		                            colSpan = leafColumns(columns[idx].columns).length - hiddenLeafColumnsCount(columns[idx].columns);
		                        }
	
		                        colSpan = colSpan || 1;
		                        for (spanIdx = 0; spanIdx < colSpan; spanIdx++) {
		                            lockedCols = lockedCols.add(cols.eq(idx + colOffset + spanIdx - skipHiddenCount));
		                        }
		                        colOffset += colSpan - 1;
		                    } else {
		                        skipHiddenCount ++;
		                    }
		                }
		            }
	
		            container = $('<div class="k-grid-content-locked"><table' + (isIE7 ? ' cellspacing="0"' : '') + '><colgroup/><tbody></tbody></table></div>');
		            // detach is required for IE8, otherwise it switches to compatibility mode
		            colgroup.detach();
		            container.find("colgroup").append(lockedCols);
		            colgroup.insertBefore(this.table.find("tbody"));
	
		            this.lockedContent = container.insertBefore(this.content);
		            this.lockedTable = container.children("table");
		        },
	
		        _appendLockedColumnFooter: function() {
		            var that = this;
		            var footer = that.footer;
		            var cells = footer.find(".k-footer-template>td");
		            var cols = footer.find(".k-grid-footer-wrap>table>colgroup>col");
		            var html = $('<div class="k-grid-footer-locked"><table><colgroup /><tbody><tr class="k-footer-template"></tr></tbody></table></div>');
		            var idx, length;
		            var groups = that._groups();
		            var lockedCells = $(), lockedCols = $();
	
		            lockedCells = lockedCells.add(cells.filter(".k-group-cell"));
		            for (idx = 0, length = leafColumns(lockedColumns(that.columns)).length; idx < length; idx++) {
		                lockedCells = lockedCells.add(cells.eq(idx + groups));
		            }
	
		            lockedCols = lockedCols.add(cols.filter(".k-group-col"));
		            for (idx = 0, length = visibleColumns(leafColumns(visibleLockedColumns(that.columns))).length; idx < length; idx++) {
		                lockedCols = lockedCols.add(cols.eq(idx + groups));
		            }
	
		            lockedCells.appendTo(html.find("tr"));
		            lockedCols.appendTo(html.find("colgroup"));
		            that.lockedFooter = html.prependTo(footer);
		        },
	
		        _appendLockedColumnHeader: function(container) {
		            var that = this,
		                columns = this.columns,
		                idx,
		                html,
		                length,
		                colgroup,
		                tr,
		                trFilter,
		                table,
		                header,
		                filtercellCells,
		                rows = [],
		                skipHiddenCount = 0,
		                cols = $(),
		                hasFilterRow = that._hasFilterRow(),
		                filterCellOffset = 0,
		                filterCells = $(),
		                cell,
		                leafColumnsCount = 0,
		                cells = $();
	
		            colgroup = that.thead.prev().find("col:not(.k-group-col,.k-hierarchy-col)");
		            header = that.thead.find("tr:first .k-header:not(.k-group-cell,.k-hierarchy-cell)");
		            filtercellCells = that.thead.find(".k-filter-row").find("th:not(.k-group-cell,.k-hierarchy-cell)");
	
		            var colOffset = 0;
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                if (columns[idx].locked) {
		                    cell = header.eq(idx);
		                    leafColumnsCount = leafColumns(columns[idx].columns || []).length;
	
		                    if (isVisible(columns[idx])) {
		                        var colSpan = null;
	
		                        if (columns[idx].columns) {
		                            colSpan = leafColumnsCount - hiddenLeafColumnsCount(columns[idx].columns);
		                        }
	
		                        colSpan = colSpan || 1;
		                        for (var spanIdx = 0; spanIdx < colSpan; spanIdx++) {
		                            cols = cols.add(colgroup.eq(idx + colOffset + spanIdx - skipHiddenCount));
		                        }
		                        colOffset += colSpan - 1;
		                    }
	
		                    mapColumnToCellRows([columns[idx]], childColumnsCells(cell), rows, 0, 0);
	
		                    leafColumnsCount = leafColumnsCount || 1;
		                    for (var j = 0; j < leafColumnsCount; j++) {
		                        filterCells = filterCells.add(filtercellCells.eq(filterCellOffset + j));
		                    }
		                    filterCellOffset += leafColumnsCount;
		                }
	
		                if (columns[idx].columns) {
		                    skipHiddenCount += hiddenLeafColumnsCount(columns[idx].columns);
		                }
	
		                if (!isVisible(columns[idx])) {
		                    skipHiddenCount++;
		                }
		            }
	
		            if (rows.length) {
		                html = '<div class="k-grid-header-locked" style="width:1px"><table' + (isIE7 ? ' cellspacing="0"' : '') + '><colgroup/><thead>';
		                html += new Array(rows.length + 1).join("<tr></tr>");
		                html += (hasFilterRow ? '<tr class="k-filter-row" />' : '') + '</thead></table></div>';
	
		                table = $(html);
	
		                colgroup = table.find("colgroup");
		                colgroup.append(that.thead.prev().find("col.k-group-col").add(cols));
	
		                tr = table.find("thead tr:not(.k-filter-row)");
		                for (idx = 0, length = rows.length; idx < length; idx++) {
		                    cells = toJQuery(rows[idx]);
		                    tr.eq(idx).append(that.thead.find("tr:eq(" + idx + ") .k-group-cell").add(cells));
		                }
	
		                var count = removeEmptyRows(this.thead);
		                if (rows.length < count) {
		                    removeRowSpanValue(table, count - rows.length);
		                }
	
		                trFilter = table.find(".k-filter-row");
		                trFilter.append(that.thead.find(".k-filter-row .k-group-cell").add(filterCells));
	
		                this.lockedHeader = table.prependTo(container);
		                this.thead.find(".k-group-cell").remove();
	
		                return true;
		            }
		            return false;
		        },
	
		        _removeLockedContainers: function() {
		            var elements = this.lockedHeader
		                .add(this.lockedContent)
		                .add(this.lockedFooter);
	
		            kendo.destroy(elements);
		            elements.off(NS).remove();
	
		            this.lockedHeader = this.lockedContent = this.lockedFooter = null;
		            this.selectable = null;
		        },
	
		        _thead: function() {
		            var that = this,
		                columns = that.columns,
		                hasDetails = that._hasDetails() && columns.length,
		                hasFilterRow = that._hasFilterRow(),
		                idx,
		                html = "",
		                thead = that.table.find(">thead"),
		                hasTHead = that.element.find("thead:first").length > 0,
		                tr;
	
		            if (!thead.length) {
		                thead = $("<thead/>").insertBefore(that.tbody);
		            }
	
		            if (that.lockedHeader && that.thead) {
		                tr = that.thead.find("tr:has(th):not(.k-filter-row)").html("");
		                tr.remove();
		                tr = $();
	
		                that._removeLockedContainers();
		            } else if (hasTHead) {
		                tr = that.element.find("thead:first tr:has(th):not(.k-filter-row)");
		            } else {
		                tr = that.element.find("tr:has(th):first");
		            }
	
		            if (!tr.length) {
		                tr = thead.children().first();
		                if (!tr.length) {
		                   var rows = [{ rowSpan: 1, cells: [], index: 0 }];
		                   that._prepareColumns(rows, columns);
	
		                   for (idx = 0; idx < rows.length; idx++) {
		                       html += "<tr>";
		                       if (hasDetails) {
		                           html += '<th class="k-hierarchy-cell" scope="col">' + that.options.messages.expandCollapseColumnHeader + '</th>';
		                       }
		                       html += that._createHeaderCells(rows[idx].cells, rows[idx].rowSpan);
		                       html += "</tr>";
		                   }
	
		                   tr = $(html);
		                }
		            } else {
		                for (idx = 0; idx < columns.length; idx++) {
							var columnIndex = inArray(columns[idx], leafColumns(columns));
							var cell = leafDataCells(tr.parent()).filter("th:not(.k-group-cell):not(.k-hierarchy-cell)").eq(columnIndex);
							if (columns[idx].hidden) {
								cell[0].style.display = "none";
							}
		               }
					}
	
		            if (hasFilterRow) {
		                var filterRow = $("<tr/>");
		                filterRow.addClass("k-filter-row");
		                if (hasDetails || tr.find(".k-hierarchy-cell").length) { // handles server side detail template
		                    filterRow.prepend('<th class="k-hierarchy-cell" scope="col">&nbsp;</th>');
		                }
	
		                var existingFilterRow = (that.thead || thead).find(".k-filter-row");
		                if (existingFilterRow.length) {
		                    kendo.destroy(existingFilterRow);
		                    existingFilterRow.remove();
		                }
	
		                thead.append(filterRow);
		            }
	
		            if (!tr.children().length) {
		                html = "";
		                if (hasDetails) {
		                    html += '<th class="k-hierarchy-cell" scope="col">&nbsp;</th>';
		                }
	
		                html += that._createHeaderCells(columns);
	
		                tr.html(html);
		            } else if (hasDetails && !tr.find(".k-hierarchy-cell")[0]) {
		                tr.prepend('<th class="k-hierarchy-cell" scope="col">&nbsp;</th>');
		            }
	
		            tr.attr("role", "row").find("th").addClass("k-header");
	
		            if(!that.options.scrollable) {
		                thead.addClass("k-grid-header");
		            }
	
		            tr.find("script").remove().end().prependTo(thead);
	
		            if (that.thead) {
		                that._destroyColumnAttachments();
		            }
	
		            this.angular("cleanup", function(){
		                return {
		                    elements: thead.find("th" + NAVCELL).get()
		                };
		            });
	
		            this.angular("compile", function(){
		                return {
		                    elements: thead.find("th" + NAVCELL).get(),
		                    data: map(columns, function(col) { return { column: col }; })
		                };
		            });
	
		            that.thead = thead.attr("role", "rowgroup");
	
		            that._sortable();
	
		            that._filterable();
	
		            that._filterRow();
	
		            that._scrollable();
	
		            that._columnMenu();
	
		            var syncHeight;
		            var hasLockedColumns = this.options.scrollable && lockedColumns(this.columns).length;
	
		            if (hasLockedColumns) {
	
		                syncHeight = that._appendLockedColumnHeader(that.thead.closest(".k-grid-header"));
	
		                that._appendLockedColumnContent();
	
		                that.lockedContent.bind("DOMMouseScroll" + NS + " mousewheel" + NS, proxy(that._wheelScroll, that));
	
		                that._updateLockedCols();
		            }
	
		            that._updateCols();
	
		            that._updateColumnCellIndex();
	
		            that._updateFirstColumnClass();
	
		            that._resizable();
	
		            that._draggable();
	
		            that._reorderable();
	
		            that._updateHeader(that._groups());
	
		            if (hasLockedColumns) {
		                if (syncHeight) {
		                    that._syncLockedHeaderHeight();
		                }
	
		                that._applyLockedContainersWidth();
		            }
	
		            if (that.groupable) {
		                that._attachGroupable();
		            }
		        },
	
		        _retrieveFirstColumn: function(columns, rows) {
		            var result = $();
	
		            if (rows.length && columns[0]) {
		                var column = columns[0];
	
		                while(column.columns && column.columns.length) {
		                    column = column.columns[0];
		                    rows = rows.filter(":not(:first())");
		                }
	
		                result = result.add(rows);
		            }
	
		            return result;
		        },
	
		        _updateFirstColumnClass: function() {
		            var that = this,
		                columns = that.columns || [],
		                hasDetails = that._hasDetails() && columns.length;
	
		            if (!hasDetails && !that._groups()) {
		                var tr = that.thead.find(">tr:not(.k-filter-row):not(:first)");
		                columns = nonLockedColumns(columns);
	
		                var rows = that._retrieveFirstColumn(columns, tr);
	
		                if (that._isLocked()) {
		                    tr = that.lockedHeader.find("thead>tr:not(.k-filter-row):not(:first)");
		                    columns = lockedColumns(that.columns);
	
		                    rows = rows.add(that._retrieveFirstColumn(columns, tr));
		                }
	
		                rows.each(function() {
		                    var ths = $(this).find("th");
		                    ths.removeClass("k-first");
		                    ths.eq(0).addClass("k-first");
		                });
		            }
		        },
	
		        _prepareColumns: function(rows, columns, parentCell, parentRow) {
		            var row = parentRow || rows[rows.length - 1];
	
		            var childRow = rows[row.index + 1];
		            var totalColSpan = 0;
	
		            for (var idx = 0; idx < columns.length; idx++) {
		                var cell = { column: columns[idx], colSpan: 0 };
		                row.cells.push(cell);
	
		                if (columns[idx].columns && columns[idx].columns.length) {
		                    if (!childRow) {
		                        childRow = { rowSpan: 0, cells: [], index: rows.length };
		                        rows.push(childRow);
		                    }
		                    cell.colSpan = columns[idx].columns.length;
		                    this._prepareColumns(rows, columns[idx].columns, cell, childRow);
		                    totalColSpan += cell.colSpan - 1;
		                    row.rowSpan = rows.length - row.index;
		                }
		            }
		            if (parentCell) {
		                parentCell.colSpan += totalColSpan;
		            }
		        },
	
		        _wheelScroll: function (e) {
		            if (e.ctrlKey) {
		                return;
		            }
	
		            var content = this.content;
	
		            if (this.options.scrollable.virtual) {
		                content = this.virtualScrollable.verticalScrollbar;
		            }
	
		            var scrollTop = content.scrollTop(),
		                delta = kendo.wheelDeltaY(e);
	
		            if (delta) {
		                if (content[0].scrollHeight > content[0].clientHeight &&
		                    (content[0].scrollTop < content[0].scrollHeight - content[0].clientHeight && delta < 0 ||
		                    content[0].scrollTop > 0 && delta > 0)) {
		                    e.preventDefault();
		                }
	
		                content.scrollTop(scrollTop + (-delta));
		            }
		        },
	
		        _isLocked: function() {
		            return this.lockedHeader != null;
		        },
	
		        _updateHeaderCols: function() {
		            var table = this.thead.parent().add(this.table);
	
		            if (this._isLocked()) {
		                normalizeCols(table, visibleLeafColumns(visibleNonLockedColumns(this.columns)), this._hasDetails(), 0);
		            } else {
		                normalizeCols(table, visibleLeafColumns(visibleColumns(this.columns)), this._hasDetails(), 0);
		            }
		        },
	
		        _updateCols: function(table) {
		            table = table || this.thead.parent().add(this.table);
	
		            this._appendCols(table, this._isLocked());
		        },
	
		        _updateLockedCols: function(table) {
		            if (this._isLocked()) {
		                table = table || this.lockedHeader.find("table").add(this.lockedTable);
	
		                normalizeCols(table, visibleLeafColumns(visibleLockedColumns(this.columns)), this._hasDetails(), this._groups());
		            }
		        },
	
		        _appendCols: function(table, locked) {
		            if (locked) {
		                normalizeCols(table, visibleLeafColumns(visibleNonLockedColumns(this.columns)), this._hasDetails(), 0);
		            } else {
		                normalizeCols(table, visibleLeafColumns(visibleColumns(this.columns)), this._hasDetails(), this._groups());
		            }
		        },
	
		        _autoColumns: function(schema) {
		            if (schema && schema.toJSON) {
		                var that = this,
		                    field,
		                    encoded;
	
		                schema = schema.toJSON();
	
		                encoded = !(that.table.find("tbody tr").length > 0 && (!that.dataSource || !that.dataSource.transport));
	
		                for (field in schema) {
		                    that.columns.push({ field: field, encoded: encoded, headerAttributes: {id: kendo.guid()} });
		                }
	
		                that._thead();
	
		                that._templates();
		            }
		        },
	
		        _rowsHtml: function(data, templates) {
		            var that = this,
		                html = "",
		                idx,
		                rowTemplate = templates.rowTemplate,
		                altRowTemplate = templates.altRowTemplate,
		                length;
	
		            for (idx = 0, length = data.length; idx < length; idx++) {
		                if (that._skipRerenderItemsCount > 0) {
		                    that._skipRerenderItemsCount--;
		                } else {
		                    if (idx % 2) {
		                        html += altRowTemplate(data[idx]);
		                    } else {
		                        html += rowTemplate(data[idx]);
		                    }
		                }
		                that._data.push(data[idx]);
		            }
	
		            return html;
		        },
	
		        _groupData: function(group, skipFooter, firstColumn) {
		            var that = this,
		                footerDefaults = that._groupAggregatesDefaultObject || {},
		                groupItems = group.items,
		                aggregates = extend({}, footerDefaults, group.aggregates),
		                headerData = extend({}, {
		                    field: group.field,
		                    value: group.value,
		                    items: groupItems,
		                    aggregates: aggregates
		                }, group.aggregates[firstColumn ? firstColumn.field : group.field]),
		                footerData = {};
	
		            if (!skipFooter) {
		                for (var aggregate in aggregates) {
		                    footerData[aggregate] = extend({}, aggregates[aggregate],
		                        { group: { field: group.field, value: group.value, items: groupItems } }
		                    );
		                }
		            }
		            return extend({}, footerData, headerData);
		        },
	
		        _groupRowHtml: function(group, colspan, level, groupHeaderBuilder, templates, skipColspan, skipLastGroup) {
		            var that = this,
		                html = "",
		                idx,
		                length,
		                field = group.field,
		                column = grep(leafColumns(that.columns), function(column) { return column.field == field; })[0] || { },
		                template = column.groupHeaderTemplate ? column.groupHeaderTemplate : visibleColumns(that.columns)[0].groupHeaderColumnTemplate,
		                text = (column.title || field) + ': ' + formatGroupValue(group.value, column.format, column.values, column.encoded),
		                groupItems = group.items,
		                groups = that._groups(),
		                groupFooterTemplate = templates.groupFooterTemplate,
		                groupHeaderColumnTemplate = templates.groupHeaderColumnTemplate,
		                groupData;
	
	
	
		            if (templates.groupFooterTemplate || templates.groupHeaderColumnTemplate || column.groupHeaderTemplate) {
		                groupData = that._groupData(group, false, !column.groupHeaderTemplate && visibleColumns(that.columns)[0].groupHeaderColumnTemplate ? visibleColumns(that.columns)[0] : false);
		            }
		            if (template && !skipColspan) {
		                text  = typeof template === FUNCTION ? template(groupData) : kendo.template(template)(groupData);
		            }
		            if (!that._skipRerenderItemsCount) {
		                if (groupHeaderColumnTemplate) {
		                    html += groupHeaderColumnTemplate(extend({}, groupData, {groupCells: level, colspan: groups - level, text: text}));
		                }
		                else {
		                    html += groupHeaderBuilder(colspan, level, text);
		                }
		            } else {
		                groupHeaderBuilder(colspan, level, text);
		            }
	
		            if (group.hasSubgroups) {
		                for (idx = 0, length = groupItems.length; idx < length; idx++) {
		                    html += that._groupRowHtml(groupItems[idx], skipColspan ? colspan : colspan - 1, level + 1, groupHeaderBuilder, templates, skipColspan, skipLastGroup && idx === groupItems.length - 1);
		                }
		            } else {
		                html += that._rowsHtml(groupItems, templates);
		            }
	
		            if (groupFooterTemplate) {
	
		                if (skipLastGroup) {
		                    if (!inArray(group.value, that._skippedGroups)) {
		                        that._skippedGroups.push(group.value);
		                    }
		                } else {
		                    if (that._skippedGroups.length && that._skippedGroups[0] === group.value) {
		                        that._skippedGroups.shift();
		                    }
		                    if (!that._skipRerenderItemsCount) {
		                        html += groupFooterTemplate(groupData);
		                    }
		                }
		            }
		            return html;
		        },
	
		        collapseGroup: function(group) {
	
		            var level,
		                that = this,
		                groupToCollapse = group,
		                groupable = this.options.groupable,
		                showFooter =  groupable.showFooter,
		                footerCount = showFooter ? 0 : 1,
		                offset,
		                relatedGroup = $(),
		                idx,
		                length,
		                tr;
	
		            group = $(group);
	
		            if (this._isLocked()) {
		                if (!group.closest("div").hasClass("k-grid-content-locked")) {
		                    relatedGroup = group.nextAll("tr");
		                    group = this.lockedTable.find(">tbody>tr:eq(" + group.index() + ")");
		                } else {
		                    relatedGroup = this.tbody.children("tr:eq(" + group.index() + ")").nextAll("tr");
		                }
		            }
	
		            level = group.find(".k-group-cell").length;
		            group.find(".k-i-collapse").addClass("k-i-expand").removeClass("k-i-collapse");
		            group.find("td[aria-expanded='true']:first").attr("aria-expanded", false)
		                .find("a").attr(ARIALABEL, EXPAND);
	
		            group = group.nextAll("tr");
	
		            var toHide = [];
	
		            for (idx = 0, length = group.length; idx < length; idx ++ ) {
		                tr = group.eq(idx);
		                offset = tr.find(".k-group-cell").length;
	
		                if (tr.hasClass("k-grouping-row")) {
		                    footerCount++;
		                } else if (tr.hasClass("k-group-footer")) {
		                    footerCount--;
		                }
	
		                if (offset <= level || (tr.hasClass("k-group-footer") && footerCount < 0)) {
		                    break;
		                }
	
		                if (relatedGroup.length) {
		                    toHide.push(relatedGroup[idx]);
		                }
		                toHide.push(tr[0]);
		            }
	
		            $(toHide).hide();
	
		            if (this.options.scrollable.endless && this.content) {
		                setTimeout(function () {
		                    that.content.scroll();
		                    that._groupToCollapse = groupToCollapse;
		                });
		            }
		        },
	
		        expandGroup: function(group) {
		            group = $(group);
	
		            var that = this,
		                showFooter = that.options.groupable.showFooter,
		                level,
		                tr,
		                offset,
		                relatedGroup = $(),
		                idx,
		                length,
		                footersVisibility = [],
		                groupsCount = 1;
	
		            if (this._isLocked()) {
		                if (!group.closest("div").hasClass("k-grid-content-locked")) {
		                    relatedGroup = group.nextAll("tr");
		                    group = this.lockedTable.find(">tbody>tr:eq(" + group.index() + ")");
		                } else {
		                    relatedGroup = this.tbody.children("tr:eq(" + group.index() + ")").nextAll("tr");
		                }
		            }
	
		            level = group.find(".k-group-cell").length;
		            group.find(".k-i-expand").addClass("k-i-collapse").removeClass("k-i-expand");
		            group.find("td[aria-expanded='false']:first").attr("aria-expanded", true)
		                .find("a").attr(ARIALABEL, COLLAPSE);
		            group = group.nextAll("tr");
	
		            for (idx = 0, length = group.length; idx < length; idx ++ ) {
		                tr = group.eq(idx);
		                offset = tr.find(".k-group-cell").length;
		                if (offset <= level) {
		                    break;
		                }
	
		                if (offset == level + 1 && !tr.hasClass("k-detail-row")) {
		                    tr.show();
		                    relatedGroup.eq(idx).show();
	
		                    if (tr.hasClass("k-grouping-row") && tr.find(".k-icon").hasClass("k-i-collapse")) {
		                        that.expandGroup(tr);
		                    }
	
		                    if (tr.hasClass("k-master-row") && tr.find(".k-icon").hasClass("k-i-collapse")) {
		                        tr.next().show();
		                        relatedGroup.eq(idx + 1).show();
		                    }
		                }
	
		                if (tr.hasClass("k-grouping-row")) {
		                    if (showFooter) {
		                        footersVisibility.push(tr.is(":visible"));
		                    }
		                    groupsCount ++;
		                }
	
		                if (tr.hasClass("k-group-footer")) {
		                    if (showFooter) {
		                        tr.toggle(footersVisibility.pop());
		                    }
		                    if (groupsCount == 1) {
		                        tr.show();
		                        relatedGroup.eq(idx).show();
		                    } else {
		                        groupsCount --;
		                    }
		                }
		            }
	
		            if (level === 0 && that.options.scrollable.endless && this._isLocked()) {
		                that._syncLockedContentHeight();
		            }
		        },
	
		        _updateHeader: function(groups) {
		            var that = this,
		                container = that._isLocked() ? that.lockedHeader.find("thead") : that.thead,
		                filterCells = container.find("tr.k-filter-row").find("th.k-group-cell").length,
		                length = container.find("tr:first").find("th.k-group-cell").length,
		                rows = container.children("tr:not(:first)").filter(function() {
		                    return !$(this).children(":visible").length;
		                });
	
		            if(groups > length) {
		                $(new Array(groups - length + 1).join('<th class="k-group-cell k-header" scope="col">' + that.options.messages.expandCollapseColumnHeader + '</th>')).prependTo(container.children("tr:not(.k-filter-row)"));
		                if (that.element.is(":visible")) {
		                    rows.find("th.k-group-cell").hide();
		                }
		            } else if(groups < length) {
		                container.find("tr").each(function() {
		                    $(this).find("th.k-group-cell")
		                        .filter(":eq(" + groups + ")," + ":gt(" + groups + ")").remove();
		                });
		            }
		            if(groups > filterCells) {
		                $(new Array(groups - filterCells + 1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>')).prependTo(container.find(".k-filter-row"));
		            }
		        },
	
		        _firstDataItem: function(data, grouped) {
		            if(data && grouped) {
		                if(data.hasSubgroups) {
		                    data = this._firstDataItem(data.items[0], grouped);
		                } else {
		                    data = data.items[0];
		                }
		            }
		            return data;
		        },
	
		        _updateTablesWidth: function() {
		            var that = this,
		                tables;
	
		            if (!that._isLocked()) {
		                return;
		            }
	
		            tables =
		                $(">.k-grid-footer>.k-grid-footer-wrap>table", that.wrapper)
		                .add(that.thead.parent())
		                .add(that.table);
	
		            that._footerWidth = tableWidth(tables.eq(0));
		            tables.width(that._footerWidth);
	
		            tables =
		                $(">.k-grid-footer>.k-grid-footer-locked>table", that.wrapper)
		                .add(that.lockedHeader.find(">table"))
		                .add(that.lockedTable);
	
		            tables.width(tableWidth(tables.eq(0)));
		        },
	
		        hideColumn: function(column) {
		            var that = this,
		                cell,
		                tables,
		                idx,
		                cols,
		                colWidth,
		                position,
		                width = 0,
		                headerCellIndex,
		                length,
		                footer = that.footer || that.wrapper.find(".k-grid-footer"),
		                columns = that.columns,
		                visibleLocked = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).filter(isCellVisible).length : 0,
		                columnIndex,
		                groupHeaderColumnTemplateColumns = grep(leafColumns(that.columns), function(column) { return column.groupHeaderColumnTemplate; });
	
		            if (typeof column == "number") {
		                column = columns[column];
		            } else if (isPlainObject(column)) {
		                column = grep(flatColumns(columns), function(item) {
		                    return item === column;
		                })[0];
		            } else {
		                column = grep(flatColumns(columns), function(item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            if (!column || !isVisible(column)) {
		                return;
		            }
	
		            var setColumnVisibility = that._columnVisibilitySetter(column);
	
		            if (column.columns && column.columns.length) {
		                position = columnVisiblePosition(column, columns);
	
		                setColumnVisibility(column, false);
	
		                setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr:eq(" + position.row + ")>th"), position.cell, false);
	
		                for (idx = 0; idx < column.columns.length; idx++) {
		                   this.hideColumn(column.columns[idx]);
		                }
	
		                that.trigger(COLUMNHIDE, { column: column });
	
		                return;
		            }
	
		            columnIndex = inArray(column, visibleColumns(leafColumns(columns)));
		            setColumnVisibility(column, false);
	
		            that._setParentsVisibility(column, false);
	
		            that._templates();
	
		            that._updateCols();
		            that._updateLockedCols();
	
		            var container = that.thead;
	
		            headerCellIndex = columnIndex;
		            if (that.lockedHeader && visibleLocked > columnIndex) {
		                container = that.lockedHeader.find(">table>thead");
		            } else {
		                headerCellIndex -= visibleLocked;
		            }
	
		            cell = leafDataCells(container).filter(isCellVisible).eq(headerCellIndex);
		            cell[0].style.display = "none";
	
		            setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr.k-filter-row>th"), columnIndex, false);
		            if (footer[0]) {
		                that._updateCols(footer.find(">.k-grid-footer-wrap>table"));
		                that._updateLockedCols(footer.find(">.k-grid-footer-locked>table"));
		                setCellVisibility(footer.find(".k-footer-template>td"), columnIndex, false);
		            }
	
		            if (that.lockedTable && visibleLocked > columnIndex) {
		                hideColumnCells(that.lockedTable.find(">tbody>tr"), columnIndex);
		            } else {
		                hideColumnCells(that.tbody.children(), columnIndex - visibleLocked);
		            }
	
		            if (that.lockedTable) {
		                that._updateTablesWidth();
		                that._applyLockedContainersWidth();
		                that._syncLockedContentHeight();
		                that._syncLockedHeaderHeight();
		                that._syncLockedFooterHeight();
		            } else {
		                cols = that.thead.prev().find("col");
		                for (idx = 0, length = cols.length; idx < length; idx += 1) {
		                    colWidth = cols[idx].style.width;
		                    if (colWidth && colWidth.indexOf("%") == -1) {
		                        width += parseInt(colWidth, 10);
		                    } else {
		                        width = 0;
		                        break;
		                    }
		                }
	
		                tables = $(">.k-grid-header table:first,>.k-grid-footer table:first",that.wrapper).add(that.table);
		                that._footerWidth = null;
	
		                if (width) {
		                    tables.each(function() {
		                        this.style.width = width + "px";
		                    });
	
		                    that._footerWidth = width;
		                }
		                if(browser.msie && browser.version == 8) {
		                    tables.css("display", "inline-table");
		                    setTimeout(function() {
		                        tables.css("display", "table");
		                    }, 1);
		                }
		            }
	
		            that._updateFirstColumnClass();
		            if (groupHeaderColumnTemplateColumns.length > 0) {
		                that._renderGroupRows();
		            }
		            that.trigger(COLUMNHIDE, { column: column });
		        },
	
		        _setParentsVisibility: function(column, visible) {
		            var that = this;
		            var columns = that.columns;
		            var idx;
		            var parents = [];
		            var parent;
		            var position;
		            var cell;
		            var colSpan;
		            var setColumnVisibility = that._columnVisibilitySetter(column);
	
		            var predicate = visible ?
		                function(p) { return visibleColumns(p.columns).length && p.hidden; } :
		                function(p) { return !visibleColumns(p.columns).length && !p.hidden; };
	
	
		            if (columnParents(column, columns, parents) && parents.length) {
		                for (idx = parents.length - 1; idx >= 0; idx--) {
		                    parent = parents[idx];
		                    position = columnPosition(parent, columns);
		                    cell = elements($(">table>thead", this.lockedHeader), this.thead, ">tr:eq(" + position.row + ")>th:not(.k-group-cell):not(.k-hierarchy-cell)").eq(position.cell);
	
		                    if (predicate(parent)) {
		                        setColumnVisibility(parent, visible);
		                        cell[0].style.display = visible ? "" : "none";
		                    }
	
		                    if (cell.filter("[" + kendo.attr("colspan") + "]").length) {
		                        colSpan = parseInt(cell.attr(kendo.attr("colspan")), 10);
		                        cell[0].colSpan = (colSpan - hiddenLeafColumnsCount(parent.columns)) || 1;
		                    }
		                }
		            }
		        },
	
		        showColumn: function(column) {
		            var that = this,
		                idx,
		                length,
		                cell,
		                tables,
		                width,
		                headerCellIndex,
		                position,
		                colWidth,
		                cols,
		                columns = that.columns,
		                footer = that.footer || that.wrapper.find(".k-grid-footer"),
		                lockedColumnsCount = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).length : 0,
		                columnIndex,
		                originalColumn,
		                columnLeafIndex,
		                groupHeaderColumnTemplateColumns = grep(leafColumns(that.columns), function(column) { return column.groupHeaderColumnTemplate; });
	
		            if (typeof column == "number") {
		                columnIndex = column;
		                column = columns[column];
		            } else if (isPlainObject(column)) {
		                $.each(flatColumns(columns), function (index, item) {
		                    if (item === column) {
		                        column = item;
		                        columnIndex = index;
		                        return false;
		                    }
		                });
		            } else {
		                $.each(flatColumns(columns), function (index, item) {
		                    if (item.field === column) {
		                        column = item;
		                        columnIndex = index;
		                        return false;
		                    }
		                });
		            }
	
		            if (!column || isVisible(column)) {
		                return;
		            }
	
		            var setColumnVisibility = that._columnVisibilitySetter(column);
	
		            if (column.columns && column.columns.length) {
		                position =  columnPosition(column, columns);
		                originalColumn = flatColumns(that.options.columns)[columnIndex];
	
		                setColumnVisibility(column, true);
	
		                setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr:eq(" + position.row + ")>th"), position.cell, true);
	
		                for (idx = 0; idx < column.columns.length; idx++) {
		                    if (!originalColumn.columns[idx].hidden) {
		                        this.showColumn(column.columns[idx]);
		                    }
		                }
	
		                that.trigger(COLUMNSHOW, { column: column });
	
		                return;
		            }
	
		            columnLeafIndex = inArray(column, leafColumns(columns));
	
		            setColumnVisibility(column, true);
	
		            that._setParentsVisibility(column, true);
	
		            that._templates();
		            that._updateCols();
		            that._updateLockedCols();
	
		            var container = that.thead;
	
		            headerCellIndex = columnLeafIndex;
		            if (that.lockedHeader && lockedColumnsCount > columnLeafIndex) {
		                container = that.lockedHeader.find(">table>thead");
		            } else {
		                headerCellIndex -= lockedColumnsCount;
		            }
	
		            cell = leafDataCells(container).eq(headerCellIndex);
		            cell[0].style.display = "";
	
		            setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr.k-filter-row>th"), columnLeafIndex, true);
		            if (footer[0]) {
		                that._updateCols(footer.find(">.k-grid-footer-wrap>table"));
		                that._updateLockedCols(footer.find(">.k-grid-footer-locked>table"));
		                setCellVisibility(footer.find(".k-footer-template>td"), columnLeafIndex, true);
		            }
	
		            if (that.lockedTable && lockedColumnsCount > columnLeafIndex) {
		                showColumnCells(that.lockedTable.find(">tbody>tr"), columnLeafIndex);
		            } else {
		                showColumnCells(that.tbody.children(), columnLeafIndex - lockedColumnsCount);
		            }
	
		            if (that.lockedTable) {
		                that._updateTablesWidth();
		                that._applyLockedContainersWidth();
		                that._syncLockedContentHeight();
		                that._syncLockedHeaderHeight();
		            } else {
		                tables = $(">.k-grid-header table:first,>.k-grid-footer table:first",that.wrapper).add(that.table);
		                if (!column.width) {
		                    tables.width("");
		                } else {
		                    width = 0;
		                    cols = that.thead.prev().find("col");
		                    for (idx = 0, length = cols.length; idx < length; idx += 1) {
		                        colWidth = cols[idx].style.width;
		                        if (colWidth.indexOf("%") > -1) {
		                            width = 0;
		                            break;
		                        }
		                        width += parseInt(colWidth, 10);
		                    }
	
		                    that._footerWidth = null;
		                    if (width) {
		                        tables.each(function() {
		                            this.style.width = width + "px";
		                        });
		                        that._footerWidth = width;
		                    }
		                }
		            }
	
		            that._updateFirstColumnClass();
		            if (groupHeaderColumnTemplateColumns.length > 0) {
		                that._renderGroupRows();
		            }
		            that.trigger(COLUMNSHOW, { column: column });
		        },
	
		        _columnVisibilitySetter: function(column) {
		            var col = column || {};
	
		            if (isUndefined(col.media)) {
		                return setColumnVisibility;
		            } else {
		                return setColumnMediaVisibility;
		            }
		        },
	
		        _progress: function(toggle) {
		            var element = this.element;
		            var endless = this.options.scrollable && this.options.scrollable.endless;
	
		            if (this._editContainer && this._editMode() === "popup") {
		                element = this._editContainer;
		            } else if (this.lockedContent || endless) {
		                element = this.wrapper;
		            } else if (this.element.is("table")) {
		                element = this.element.parent();
		            } else if (this.content && this.content.length) {
		                element = this.content;
		            }
	
		            if (endless && toggle) {
		                kendo.ui.progress(element, toggle, { height: this.content.height(), top: this.content[0].offsetTop, opacity: true });
		            } else {
		                kendo.ui.progress(element, toggle);
		            }
		        },
	
		        _resize: function(size, force) {
	
		            this._syncLockedContentHeight();
		            this._syncLockedHeaderHeight();
	
		            if (this.content) {
		                this._setContentWidth();
		                this._setContentHeight();
		            }
	
		            if (this.lockedTable) {
		                this.lockedContent[0].scrollTop = this.content[0].scrollTop;
		            }
	
		            if (this.virtualScrollable && (force || this._rowHeight)) {
		                if (force) {
		                    this._rowHeight = null;
		                }
		                this.virtualScrollable.repaintScrollbar();
		            }
		        },
	
		        _isActiveInTable: function() {
		            var active = activeElement();
	
		            if (!active) { return false; }
	
		            return this.table[0] === active ||
		                $.contains(this.table[0], active) ||
		                (this._isLocked() &&
		                    (this.lockedTable[0] === active || $.contains(this.lockedTable[0], active))
		                );
		        },
	
		        refresh: function(e) {
		            var that = this,
		                data = that.dataSource.view(),
		                navigatable = that.options.navigatable,
		                currentIndex,
		                current = $(that.current()),
		                isCurrentInHeader = false,
		                groups = (that.dataSource.group() || []).length,
		                colspan = groups + visibleLeafColumns(visibleColumns(that.columns)).length,
		                contentScrollLeft,
		                cachedItemsToSkip;
	
		            if (e && e.action === "itemchange" && (that.editable || that.options.scrollable.endless)) { // skip rebinding if editing is in progress
		                if (this._editMode() != "popup" || this._editMode() === "popup" && !that._editableIsClosing) { // popup editing animation has not finished yet and the editable is not destoyed
		                    return;
		                }
		            }
	
		            //someone remove the edited item
		            if (e && e.action === "remove" && that.editable &&
		                that.editable.options.model && inArray(that.editable.options.model, e.items) > -1) {
		                that.editable.options.model.unbind(CHANGE, that._modelChangeHandler);
		            }
	
		            e = e || {};
	
		            if (that.trigger("dataBinding", { action: e.action || "rebind", index: e.index, items: e.items })) {
		                return;
		            }
	
		            if (e.action === SYNC && that._isVirtualEditable()) {
		                that._destroyEditable();
		                that._clearEditableState();
		            }
	
		            that._angularItems("cleanup");
		            if (!that._endlessFetchInProgress) {
		                if (navigatable && (that._isActiveInTable() || (that._editContainer && that._editContainer.data("kendoWindow")))) {
		                    isCurrentInHeader = current.is("th");
		                    currentIndex = isCurrentInHeader ? current.parent().children(":not(.k-group-cell)").index(current[0]) : Math.max(that.cellIndex(current), 0);
		                }
		                that._destroyEditable();
		            }
	
		            if(that.options.scrollable && that.options.scrollable.endless){
		                clearTimeout(that._progressTimeOut);
		                that._progressTimeOut = setTimeout(function(){
		                    if (!that._endlessFetchInProgress) {
		                        that._progress(false);
		                    }
		                },100);
		            } else {
		                 that._progress(false);
		            }
	
		            that._hideResizeHandle();
	
		            that._data = [];
	
		            if (!that.columns.length) {
		                that._autoColumns(that._firstDataItem(data[0], groups));
		                colspan = groups + that.columns.length;
		            }
	
		            that._group = groups > 0 || that._group;
	
		            if(that._group) {
		                that._templates();
		                that._updateCols();
		                that._updateLockedCols();
		                that._updateHeader(groups);
		                that._group = groups > 0;
		                that._groupRows = groupRows(data);
		            }
	
		            if (that.content) {
		                contentScrollLeft = that.content.scrollLeft();
		            }
		            cachedItemsToSkip = that._skipRerenderItemsCount;
		            that._renderContent(data, colspan, groups);
		            if (that.options.scrollable && that.options.scrollable.endless && this.lockedContent) {
		                that._skipRerenderItemsCount = cachedItemsToSkip;
		            }
		            that._renderLockedContent(data, colspan, groups);
	
		            that._footer();
	
		            that._renderNoRecordsContent();
	
		            that._togglePagerVisibility();
	
		            that._setContentHeight();
	
		            that._setContentWidth(that.content && contentScrollLeft);
	
		            if (that.lockedTable) {
		                //requires manual trigger of scroll to sync both tables
		                if (that.options.scrollable.virtual) {
		                    that.content.find(">.k-virtual-scrollable-wrap").trigger("scroll");
		                } else if (that.touchScroller) {
		                    that.touchScroller.movable.trigger("change");
		                } else {
		                    that.wrapper.one("scroll", function(e) { e.stopPropagation(); });
		                    that.content.trigger("scroll");
		                }
		            }
	
		            if(!that._endlessFetchInProgress) {
		                that._restoreCurrent(currentIndex, isCurrentInHeader);
		            }
	
		            if (that.touchScroller) {
		                that.touchScroller.contentResized();
		            }
	
		            if (that.selectable) {
		                that.selectable.resetTouchEvents();
		            }
	
		            that._muteAngularRebind(function() {
		                that._angularItems("compile");
		            });
	
		            if (that._checkBoxSelection) {
		                that._toggleHeaderCheckState(false);
		            }
	
		            if(that.options.persistSelection &&
		                ((that.selectable && !kendo.ui.Selectable.parseOptions(that.options.selectable).cell) || that._checkBoxSelection)) {
		                that._restoreSelection();
		            } else {
		                that._selectedIds = {};
		            }
	
		            that.trigger(DATABOUND);
		       },
	
		        _restoreCurrent: function(currentIndex, isCurrentInHeader) {
		            if (currentIndex === undefined || currentIndex < 0) {
		                return;
		            }
	
		            this._removeCurrent();
	
		            if (isCurrentInHeader) {
		                this._setCurrent(this.thead.find("th:not(.k-group-cell)").eq(currentIndex));
		            } else {
		                var rowIndex = 0;
		                if (this._rowVirtualIndex) {
		                    rowIndex = this.virtualScrollable.position(this._rowVirtualIndex);
		                } else {
		                    currentIndex = 0;
		                }
	
		                var row = $();
	
		                if (this.lockedTable) {
		                    row = this.lockedTable.find(">tbody>tr").eq(rowIndex);
		                }
		                row = row.add(this.tbody.children().eq(rowIndex));
	
		                var td = row.find(">td:not(.k-group-cell):not(.k-hierarchy-cell)")
		                    .eq(currentIndex);
	
		                this._setCurrent(td);
		            }
	
		            if (this._current) {
		                focusTable(this._current.closest("table")[0], true);
		            }
		        },
	
		        _restoreSelection: function() {
		            var that = this,
		                allRows = that.items(),
		                selectedRows,
		                id = isFunction(that.dataSource.options.schema.model) ? that.dataSource.options.schema.model.fn.idField : that.dataSource.options.schema.model.id;
	
		            selectedRows = grep(allRows, function(row) {
		                 var dataItemKey = that.dataItem(row)[id];
		                 if(that._selectedIds[dataItemKey]) {
		                    return row;
		                 }
		            });
	
		            that.select(selectedRows);
		        },
	
		       _angularItems: function(cmd) {
	
		           kendo.ui.DataBoundWidget.fn._angularItems.call(this, cmd);
	
		           if (cmd === "cleanup" && (!this.dataSource || !this.dataSource.options.endless)) {
		               this._cleanupDetailItems();
		           }
	
		           this._angularGroupItems(cmd);
	
		           this._angularGroupFooterItems(cmd);
		       },
	
		       _cleanupDetailItems: function() {
		           var that = this;
	
		           if (that._hasDetails()) {
		              that.angular("cleanup", function() {
		                   return { elements: that.tbody.children(".k-detail-row") };
		               });
	
		               that.tbody.find(".k-detail-cell").empty();
		           }
		       },
	
		       _angularGroupItems: function(cmd) {
		           var that = this,
		               container = that.tbody;
	
		           if (that.lockedContent) {
		               container = that.lockedTable.find("tbody");
		           }
	
		           if (that._group) {
		              that.angular(cmd, function(){
		                   return {
		                       elements: container.children(".k-grouping-row"),
		                       data: $.map(groupRows(that.dataSource.view()), function(dataItem){
		                           return { dataItem: dataItem };
		                       })
		                   };
		               });
		           }
		       },
	
		       _angularGroupFooterItems: function(cmd) {
		           var that = this,
		               container = that.tbody;
	
		           if (that.lockedContent) {
		                container = that.element;
		           }
	
		           if (that._group && that.groupFooterTemplate) {
	
		               that.angular(cmd, function() {
		                   return {
		                       elements: container.find(".k-group-footer"),
		                       data: $.map(groupFooters(that.dataSource.view()), function(dataItem){
		                           return { dataItem: dataItem };
		                       })
		                   };
		               });
		           }
		       },
	
		       _renderContent: function(data, colspan, groups) {
		            var that = this,
		                idx,
		                length,
		                html = "",
		                isLocked = that.lockedContent != null,
		                endlessAppend = null,
		                skipLastGroup,
		                flatViewLength,
		                scrollable = that.options.scrollable,
		                templates = {
		                        rowTemplate: that.rowTemplate,
		                        altRowTemplate: that.altRowTemplate,
		                        groupFooterTemplate: that.groupFooterTemplate,
		                        groupHeaderColumnTemplate: that.groupHeaderColumnTemplate
		                    };
		            if (scrollable && scrollable.endless && !that.dataSource.options.endless) {
		                that._skipRerenderItemsCount = 0;
		                if (that.content) {
		                    that.content[0].scrollTop = 0;
		                }
		            }
		            endlessAppend = that._skipRerenderItemsCount > 0;
		            colspan = isLocked ? colspan - visibleLeafColumns(visibleLockedColumns(that.columns)).length : colspan;
		            if(groups > 0) {
	
		                colspan = isLocked ? colspan - groups : colspan;
	
		                if (that.detailTemplate) {
		                    colspan++;
		                }
	
		                if (that.groupFooterTemplate) {
		                    that._groupAggregatesDefaultObject = that.dataSource.aggregates();
		                }
		                if (that.options.scrollable.endless) {
		                    flatViewLength = that.dataSource.flatView().length;
		                }
		                for (idx = 0, length = data.length; idx < length; idx++) {
		                    if (!that._skippedGroups) {
		                        that._skippedGroups = [];
		                    }
		                    skipLastGroup = flatViewLength && idx === data.length - 1 && flatViewLength !== that.dataSource.total();
		                    html += that._groupRowHtml(data[idx], colspan, 0, isLocked ? groupRowLockedContentBuilder : groupRowBuilder, templates, isLocked, skipLastGroup);
		                }
		            } else {
		                html += that._rowsHtml(data, templates);
		            }
	
		            if (endlessAppend) {
		                that.tbody.append(html);
		                setTimeout(function () {
		                    if (that._groupToCollapse) {
		                        that.collapseGroup(that._groupToCollapse);
		                        that._groupToCollapse = null;
		                    }
		                });
		                that._endlessFetchInProgress = null;
		            } else {
		                that.tbody = appendContent(that.tbody, that.table, html, this.options.$angular);
		            }
		       },
	
		       _renderGroupRows : function() {
		        var that = this,
		        data = that._groupRows,
		        groupRows = that.wrapper.find(".k-grouping-row"),
		        groups = that._groups(),
		        groupRowBuilderFunc,
		        isLocked = that.lockedContent != null,
		        columns,
		        colspan,
		        group,
		        field,
		        column,
		        template,
		        text,
		        groupHeaderData,
		        tableContainer,
		        isInLockedContainer,
		        prevElement,
		        newGroupRowElement,
		        currentRow,
		        level,
		        groupHeaderColumnTemplate,
		        firstColumnGroupData;
	
		        groupRows.each(function(index, row) {
		            currentRow = $(row);
		            tableContainer = currentRow.closest("table").parent();
		            isInLockedContainer = tableContainer.is("." + CONTENTRLOCKEDCONTAINER);
		            columns = isInLockedContainer ? visibleLeafColumns(visibleColumns(lockedColumns(that.columns))) : visibleLeafColumns(visibleColumns(nonLockedColumns(that.columns)));
		            level = currentRow.find("." + GROUPCELLCLASS).length;
		            if (isLocked) {
		                groupRowBuilderFunc = isInLockedContainer ? groupRowBuilder : groupRowLockedContentBuilder;
		                colspan = isInLockedContainer ? columns.length + groups - level  : columns.length;
		            }
		            else {
		                groupRowBuilderFunc = groupRowBuilder;
		                colspan = columns.length + groups - level;
		            }
	
		            group = index >= data.length ? data[index - data.length] : data[index];
		            field = group.field;
		            column = grep(leafColumns(that.columns), function(column) { return column.field == field; })[0] || { };
		            firstColumnGroupData = !column.groupHeaderTemplate && visibleColumns(that.columns)[0].groupHeaderColumnTemplate ? visibleColumns(that.columns)[0] : false;
		            template = column.groupHeaderTemplate ? column.groupHeaderTemplate : visibleColumns(that.columns)[0].groupHeaderColumnTemplate;
		            text = (column.title || field) + ': ' + formatGroupValue(group.value, column.format, column.values, column.encoded);
		            groups = groups;
		            groupHeaderData = that._groupData(group, false, firstColumnGroupData);
		            groupHeaderColumnTemplate = isInLockedContainer ? that.lockedGroupHeaderColumnTemplate : that.groupHeaderColumnTemplate;
	
		            if (template) {
		                text  = typeof template === FUNCTION ? template(groupHeaderData) : kendo.template(template)(groupHeaderData);
		            }
	
		            prevElement = currentRow.prev().length ? currentRow.prev() : currentRow.parent();
	
		            newGroupRowElement = $(groupHeaderColumnTemplate ?
		                groupHeaderColumnTemplate(extend({}, groupHeaderData, { groupCells: level, colspan: groups - level, text: text})) :
		                groupRowBuilderFunc(colspan, level, text)
		            );
	
		            if (prevElement.is("tbody")) {
		                prevElement.prepend(newGroupRowElement);
		            }
		            else {
		                prevElement.after(newGroupRowElement);
		            }
		                currentRow.remove();
		           });
		       },
	
		       _renderLockedContent: function(data, colspan, groups) {
		           var html = "",
		               idx,
		               length,
		               endlessAppend = null,
		               templates = {
		                   rowTemplate: this.lockedRowTemplate,
		                   altRowTemplate: this.lockedAltRowTemplate,
		                   groupFooterTemplate: this.lockedGroupFooterTemplate,
		                   groupHeaderColumnTemplate: this.lockedGroupHeaderColumnTemplate
		               };
	
		           if (this.lockedContent) {
	
		               var table = this.lockedTable;
		               endlessAppend = this._skipRerenderItemsCount > 0;
	
		               if (groups > 0) {
		                   colspan = colspan - visibleColumns(leafColumns(nonLockedColumns(this.columns))).length;
		                   for (idx = 0, length = data.length; idx < length; idx++) {
		                    html += this._groupRowHtml(data[idx], colspan, 0, groupRowBuilder, templates, false, this.options.scrollable.endless && idx === data.length -1);
		                   }
		               } else {
		                   html = this._rowsHtml(data, templates);
		               }
	
		               if (endlessAppend) {
		                   table.children("tbody").append(html);
		               } else {
		                   appendContent(table.children("tbody"), table, html, this.options.$angular);
		               }
	
		               this._syncLockedContentHeight();
		           }
		       },
	
		       _togglePagerVisibility: function() {
		           if (this.options.pageable.alwaysVisible === false) {
		                this.wrapper.find(".k-grid-pager").toggle(this.dataSource.total() >= this.dataSource.pageSize());
		            }
		       },
	
		       _adjustRowsHeight: function(table1, table2) {
		           var rows = table1[0].rows,
		               length = rows.length,
		               idx,
		               rows2 = table2[0].rows,
		               containers = table1.add(table2),
		               containersLength = containers.length,
		               heights = [];
	
		           for (idx = 0; idx < length; idx++) {
		               if (!rows2[idx]) {
		                   break;
		               }
	
		               if (rows[idx].style.height) {
		                   rows[idx].style.height = rows2[idx].style.height = "";
		               }
		           }
	
		           for (idx = 0; idx < length; idx++) {
		               if (!rows2[idx]) {
		                   break;
		               }
	
		               var offsetHeight1 = rows[idx].offsetHeight;
		               var offsetHeight2 = rows2[idx].offsetHeight;
		               var height = 0;
	
		               if (offsetHeight1 > offsetHeight2) {
		                   height = offsetHeight1;
		               } else if (offsetHeight1 < offsetHeight2) {
		                   height = offsetHeight2;
		               }
	
		               heights.push(height);
		           }
	
		           for (idx = 0; idx < containersLength; idx++) {
		               containers[idx].style.display = "none";
		           }
	
		           for (idx = 0; idx < length; idx++) {
		               if (heights[idx]) {
		                   //add one to resolve row misalignment in IE
		                   rows[idx].style.height = rows2[idx].style.height = (heights[idx] + 1) + "px";
		               }
		           }
	
		           for (idx = 0; idx < containersLength; idx++) {
		               containers[idx].style.display = "";
		           }
		       }
		   });
	
		   if (kendo.ExcelMixin) {
		       kendo.ExcelMixin.extend(Grid.prototype);
		   }
	
		   if (kendo.PDFMixin) {
		       kendo.PDFMixin.extend(Grid.prototype);
	
		       Grid.prototype._drawPDF_autoPageBreak = function(progress) {
		           var grid = this;
		           var result = new $.Deferred();
		           var dataSource = grid.dataSource;
		           var allPages = grid.options.pdf.allPages;
		           var origBody = grid.wrapper.find('table[role$="grid"] > tbody');
		           var cont = $("<div>")
		               .css({ position: "absolute", left: -10000, top: -10000 });
		           var clone = grid.wrapper.clone().css({
		               height: "auto", width: "auto"
		           }).appendTo(cont);
		           clone.find(".k-grid-content").css({ height: "auto", width: "auto", overflow: "visible" });
		           clone.find('table[role$="grid"], .k-grid-footer table').css({ height: "auto", width: "100%", overflow: "visible" });
		           clone.find(".k-grid-pager, .k-grid-toolbar, .k-grouping-header").remove();
		           clone.find(".k-grid-header, .k-grid-footer").css({ paddingRight: 0 });
	
		           this._initPDFProgress(progress);
	
		           var body = clone.find('table[role$="grid"] > tbody').empty();
		           var startingPage = dataSource.page();
	
		           function resolve() {
		               if (allPages && startingPage !== undefined) {
		                   dataSource.one("change", draw);
		                   dataSource.page(startingPage);
		               } else {
		                   grid.refresh();
		                   draw();
		               }
		           }
	
		           function draw() {
		               cont.appendTo(document.body);
		               var options = $.extend({}, grid.options.pdf, {
		                   _destructive: true,
		                   progress: function(p) {
		                       progress.notify({
		                           page: p.page,
		                           pageNumber: p.pageNum,
		                           progress: 0.5 + p.pageNum / p.totalPages / 2,
		                           totalPages: p.totalPages
		                       });
		                   }
		               });
		               kendo.drawing.drawDOM(clone, options)
		                   .always(function(){
		                       cont.remove();
		                   })
		                   .then(function(group){
		                       result.resolve(group);
		                   })
		                   .fail(function(err){
		                       result.reject(err);
		                   });
		           }
	
		           function renderPage() {
		               var pageNum = dataSource.page();
		               var totalPages = allPages ? dataSource.totalPages() : 1;
		               body.append(origBody.find("tr"));
		               if (pageNum < totalPages) {
		                   dataSource.page(pageNum + 1);
		               } else {
		                   dataSource.unbind("change", renderPage);
		                   resolve();
		               }
		           }
	
		           if (allPages) {
		               dataSource.bind("change", renderPage);
		               dataSource.page(1);
		           } else {
		               renderPage();
		           }
	
		           return result.promise();
		       };
	
		       Grid.prototype._drawPDF = function(progress) {
		           var grid = this;
	
		           if (grid.options.pdf.paperSize && grid.options.pdf.paperSize != "auto") {
		               return grid._drawPDF_autoPageBreak(progress);
		           }
	
		           var result = new $.Deferred();
		           var dataSource = grid.dataSource;
		           var allPages = grid.options.pdf.allPages;
	
		           this._initPDFProgress(progress);
	
		           // This group will be our document containing all pages
		           var doc = new kendo.drawing.Group();
		           var startingPage = dataSource.page();
	
		           function resolve() {
		               if (allPages && startingPage !== undefined) {
		                   dataSource.unbind("change", exportPage);
		                   dataSource.one("change", function() {
		                       result.resolve(doc);
		                   });
	
		                   dataSource.page(startingPage);
		               } else {
		                   result.resolve(doc);
		               }
		           }
	
		           function exportPage() {
		                grid._drawPDFShadow({
		                    width: grid.wrapper.width()
		                }, {
		                    avoidLinks: grid.options.pdf.avoidLinks
		                })
		                .done(function(group) {
		                    var pageNum = dataSource.page();
		                    var totalPages = allPages ? dataSource.totalPages() : 1;
	
		                    var args = {
		                        page: group,
		                        pageNumber: pageNum,
		                        progress: pageNum / totalPages,
		                        totalPages: totalPages
		                    };
	
		                    progress.notify(args);
		                    doc.append(args.page);
	
		                    if (pageNum < totalPages) {
		                        dataSource.page(pageNum + 1);
		                    } else {
		                        resolve();
		                    }
		                })
		                .fail(function(err) {
		                    result.reject(err);
		                });
		            }
	
		            if (allPages) {
		                dataSource.bind("change", exportPage);
		                dataSource.page(1);
		            } else {
		                exportPage();
		            }
	
		            return result.promise();
		        };
	
		        Grid.prototype._initPDFProgress = function(deferred) {
		           var loading = $("<div class='k-loading-pdf-mask'><div class='k-loading-color'/></div>");
		           loading.prepend(this.wrapper.clone().css({
		               position: "absolute", top: 0, left: 0
		           }));
	
		           this.wrapper.append(loading);
	
		           var pb = $("<div class='k-loading-pdf-progress'>")
		           .appendTo(loading)
		           .kendoProgressBar({
		               type: "chunk",
		               chunkCount: 10,
		               min: 0,
		               max: 1,
		               value: 0
		           }).data("kendoProgressBar");
	
		           deferred.progress(function(e) {
		               pb.value(e.progress);
		           })
		           .always(function() {
		               kendo.destroy(loading);
		               loading.remove();
		           });
		        };
		   }
	
		   function syncTableHeight(table1, table2) {
		       table1 = table1[0];
		       table2 = table2[0];
	
		       if (table1.rows.length !== table2.rows.length) {
		           var lockedHeigth = table1.offsetHeight;
		           var tableHeigth = table2.offsetHeight;
	
		           var row;
		           var diff;
		           if (lockedHeigth > tableHeigth) {
		               row = table2.rows[table2.rows.length - 1];
	
		               if (filterRowRegExp.test(row.className)) {
		                   row = table2.rows[table2.rows.length - 2];
		               }
	
		               diff = lockedHeigth - tableHeigth;
		           } else {
		               row = table1.rows[table1.rows.length - 1];
	
		               if (filterRowRegExp.test(row.className)) {
		                   row = table1.rows[table1.rows.length - 2];
		               }
	
		               diff = tableHeigth - lockedHeigth;
		           }
		           row.style.height = row.offsetHeight + diff + "px";
		       }
		   }
	
		   function adjustRowHeight(row1, row2) {
		       var height;
		       var offsetHeight1 = row1.offsetHeight;
		       var offsetHeight2 = row2.offsetHeight;
	
		       if (offsetHeight1 > offsetHeight2) {
		           height = offsetHeight1 + "px";
		       } else if (offsetHeight1 < offsetHeight2) {
		           height = offsetHeight2 + "px";
		       }
	
		       if (height) {
		           row1.style.height = row2.style.height = height;
		       }
		   }
	
		   function getCommand(commands, name) {
		       var idx, length, command;
	
		       if (typeof commands === STRING && commands === name) {
		          return commands;
		       }
	
		       if (isPlainObject(commands) && commands.name === name) {
		           return commands;
		       }
	
		       if (isArray(commands)) {
		           for (idx = 0, length = commands.length; idx < length; idx++) {
		               command = commands[idx];
	
		               if ((typeof command === STRING && command === name) || (command.name === name)) {
		                   return command;
		               }
		           }
		       }
		       return null;
		   }
	
		   function focusTable(table, direct) {
		      if (direct === true) {
		         table = $(table);
		         var scrollLeft = table.parent().scrollLeft();
	
		         kendo.focusElement(table);
		         table.parent().scrollLeft(scrollLeft);
		      } else {
		         $(table).one("focusin", function(e) { e.preventDefault(); }).focus();
		      }
		   }
	
		   function isColumnGroupable(grid, column) {
		       return grid.options.groupable && (column.groupable || column.groupable === undefined);
		   }
	
		   function isGroupedBy(groups, field) {
		       return !!$.grep(groups, function (item) {
		           return item.field === field;
		       }).length;
		   }
	
		   function isColumnEditable(column, model) {
		       if(!column.field || column.selectable) {
		           return false;
		       }
		       if(model.editable && !model.editable(column.field)) {
		           return false;
		       }
		       if(column.editable && !column.editable(model)) {
		           return false;
		       }
		       return true;
		   }
	
		   function isInputElement(element) {
		       return $(element).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,label.k-checkbox-label,.k-input,.k-multiselect-wrap,.k-picker-wrap,.k-picker-wrap>.k-selected-color,.k-tool-icon,.k-dropdown");
		   }
	
		   function tableClick(e) {
		       var currentTarget = $(e.currentTarget),
		           isHeader = currentTarget.is("th"),
		           table = this.table.add(this.lockedTable),
		           headerTable = this.thead.parent().add($(">table", this.lockedHeader)),
		           isInput = isInputElement(e.target),
		           target = $(e.target),
		           currentTable = currentTarget.closest("table")[0];
	
		       if (isInput && currentTarget.find(kendo.roleSelector("filtercell")).length) {
		           this._setCurrent(currentTarget);
		           return;
		       }
	
		       if (currentTable !== table[0] && currentTable !== table[1] && currentTable !== headerTable[0] && currentTable !== headerTable[1]) {
		           return;
		       }
	
		       if (target.is("a.k-i-expand, a.k-i-collapse")) {
		           return;
		       }
	
		       if (this.options.navigatable) {
		           this._setCurrent(currentTarget);
		       }
	
		       if (isHeader || !isInput) {
		           setTimeout(function() {
		               //Do not focus if widget, because in IE8 a DDL will be closed
		               if (!(isIE8 && $(kendo._activeElement()).hasClass("k-widget"))) {
		                   //Only if input element is not selected yet and it is not descendant of the grid's table
		                   if (!isInputElement(kendo._activeElement()) || !$.contains(currentTable, kendo._activeElement())) {
		                       //DOMElement.focus() only for header, because IE doesn't really focus the table
		                       focusTable(currentTable, true);
		                   }
		                }
		           });
		       }
	
		       if (isHeader && !kendo.support.touch) {
		           e.preventDefault(); //if any problem occurs, call preventDefault only for the clicked header links
		       }
		   }
	
		   function leftMostPosition(element, rtl) {
		       if (!rtl) {
		           return 0;
		       }
	
		       var result = 0;
	
		       if (kendo.support.browser.webkit) {
		           result = element.width();
		       }
	
		       return result;
		   }
	
		   function isInEdit(cell) {
		       return cell &&
		           (cell.hasClass("k-edit-cell") ||
		            cell.parent().hasClass("k-grid-edit-row"));
		   }
	
		   function groupCellBuilder(headerTemplateIndex) {
		    return '<td colspan="#=data.colspan +'+ headerTemplateIndex + '#">' +
		    '<p class="k-reset">' +
		    '<a class="k-icon k-i-collapse" href="\\#" tabindex="-1" ' +
		    ARIALABEL + '="' + COLLAPSE +
		    '"></a>#=data.text#' +
		    '</p></td>';
		   }
	
		   function groupCellLockedContentBuilder(headerTemplateIndex) {
		    return '<td colspan="'+ headerTemplateIndex + '">' +
		    '<p class="k-reset">&nbsp;</p></td>';
		   }
	
		   function groupRowBuilder(colspan, level, text) {
		    return '<tr role="row" class="k-grouping-row">' + groupCells(level) +
		        '<td colspan="' + colspan + '" aria-expanded="true">' +
		        '<p class="k-reset">' +
		        '<a class="k-icon k-i-collapse" href="#" tabindex="-1" ' + ARIALABEL + '="' + COLLAPSE + '"></a>' + text +
		    '</p></td></tr>';
		   }
	
		   function groupRowLockedContentBuilder(colspan) {
		    return '<tr role="row" class="k-grouping-row">' +
		        '<td colspan="' + colspan + '" aria-expanded="true">' +
		        '<p class="k-reset">&nbsp;</p></td></tr>';
		   }
	
		   ui.plugin(Grid);
		   ui.plugin(VirtualScrollable);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ }),
	
	/***/ 1197:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(614);
	
	/***/ }),
	
	/***/ 1198:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(615);
	
	/***/ }),
	
	/***/ 1199:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(616);
	
	/***/ }),
	
	/***/ 1200:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(617);
	
	/***/ }),
	
	/***/ 1201:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(618);
	
	/***/ }),
	
	/***/ 1202:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(619);
	
	/***/ }),
	
	/***/ 1203:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(622);
	
	/***/ }),
	
	/***/ 1204:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(625);
	
	/***/ }),
	
	/***/ 1205:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(629);
	
	/***/ }),
	
	/***/ 1206:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(633);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1183);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1058:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1119:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(590);
	
	/***/ }),
	
	/***/ 1134:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(592);
	
	/***/ }),
	
	/***/ 1183:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1119), __webpack_require__(1134), __webpack_require__(1008), __webpack_require__(1058) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "filtermenu",
		    name: "Filtering Menu",
		    category: "framework",
		    depends: [ "datepicker", "numerictextbox", "dropdownlist", "binder" ],
		    advanced: true
		};
	
		/* jshint eqnull: true */
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        proxy = $.proxy,
		        POPUP = "kendoPopup",
		        INIT = "init",
		        OPEN = "open",
		        REFRESH = "refresh",
		        CHANGE = "change",
		        NS = ".kendoFilterMenu",
		        EQ = "Is equal to",
		        NEQ = "Is not equal to",
		        roles = {
		            "number": "numerictextbox",
		            "date": "datepicker"
		        },
		        mobileRoles = {
		            "string": "text",
		            "number": "number",
		            "date": "date"
		        },
		        isFunction = kendo.isFunction,
		        Widget = ui.Widget;
	
		    var booleanTemplate =
		            '<div>' +
		                '<div class="k-filter-help-text">#=messages.info#</div>'+
		                '<label>'+
		                    '<input type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value"/>' +
		                    '#=messages.isTrue#' +
		                '</label>' +
		                '<label>'+
		                    '<input type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value"/>' +
		                    '#=messages.isFalse#' +
		                '</label>' +
		                '<div>' +
		                '<button type="submit" class="k-button k-primary">#=messages.filter#</button>' +
		                '<button type="reset" class="k-button">#=messages.clear#</button>'+
		                '</div>' +
		            '</div>';
	
		    var customBooleanTemplate =
		            '<div>' +
		                '<div class="k-filter-help-text">#=messages.info#</div>'+
		                '<label>'+
		                    '<input class="k-textbox" data-#=ns#bind="value: filters[0].value" name="filters[0].value"/>' +
		                '</label>' +
		                '<div>' +
		                '<button type="submit" class="k-button k-primary">#=messages.filter#</button>' +
		                '<button type="reset" class="k-button">#=messages.clear#</button>'+
		                '</div>' +
		            '</div>';
	
		    var defaultTemplate =
		            '<div>' +
		                '<div class="k-filter-help-text">#=messages.info#</div>'+
		                '<select title="#=messages.operator#" data-#=ns#bind="value: filters[0].operator" data-#=ns#role="dropdownlist">'+
		                    '#for(var op in operators){#'+
		                        '<option value="#=op#">#=operators[op]#</option>' +
		                    '#}#'+
		                '</select>'+
		                '#if(values){#' +
		                    '<select title="#=messages.value#" data-#=ns#bind="value:filters[0].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true">' +
		                    '</select>' +
		                '#}else{#' +
		                    '<input title="#=messages.value#" data-#=ns#bind="value:filters[0].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""# />'+
		                '#}#' +
		                '#if(extra){#'+
		                    '<select title="#=messages.logic#" class="k-filter-and" data-#=ns#bind="value: logic" data-#=ns#role="dropdownlist">'+
		                        '<option value="and">#=messages.and#</option>'+
		                        '<option value="or">#=messages.or#</option>'+
		                    '</select>'+
		                    '<select title="#=messages.additionalOperator#" data-#=ns#bind="value: filters[1].operator" data-#=ns#role="dropdownlist">'+
		                        '#for(var op in operators){#'+
		                            '<option value="#=op#">#=operators[op]#</option>'+
		                        '#}#'+
		                    '</select>'+
		                    '#if(values){#' +
		                        '<select title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true">' +
		                        '</select>'+
		                    '#}else{#' +
		                        '<input title="#=messages.additionalValue#" data-#=ns#bind="value: filters[1].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""#/>'+
		                    '#}#' +
		                '#}#'+
		                '<div>'+
		                '<button type="submit" class="k-button k-primary">#=messages.filter#</button>'+
		                '<button type="reset" class="k-button">#=messages.clear#</button>'+
		                '</div>'+
		            '</div>';
	
		        var defaultMobileTemplate =
		            '<div data-#=ns#role="view" data-#=ns#init-widgets="false" data-#=ns#use-native-scrolling="true" class="k-grid-filter-menu">'+
		                '<div data-#=ns#role="header" class="k-header">'+
		                    '<button class="k-button k-i-cancel">#=messages.cancel#</button>'+
		                    '#=title#'+
		                    '<button type="submit" class="k-button k-submit">#=messages.filter#</button>'+
		                '</div>'+
		                '<form title="#=messages.title#" class="k-filter-menu k-mobile-list">'+
		                    '<ul class="k-filter-help-text"><li><span class="k-link">#=messages.info#</span>'+
		                    '<ul>'+
		                        '<li class="k-item"><label class="k-label">#=messages.operator#'+
		                            '<select data-#=ns#bind="value: filters[0].operator">'+
		                                '#for(var op in operators){#'+
		                                    '<option value="#=op#">#=operators[op]#</option>' +
		                                '#}#'+
		                            '</select>'+
		                        '</label></li>' +
		                        '<li class="k-item"><label class="k-label">#=messages.value#'+
		                            '#if(values){#' +
		                                '<select data-#=ns#bind="value:filters[0].value">'+
		                                    '<option value="">#=messages.selectValue#</option>' +
		                                    '#for(var val in values){#'+
		                                        '<option value="#=values[val].value#">#=values[val].text#</option>' +
		                                    '#}#'+
		                                '</select>' +
		                            '#}else{#' +
		                                '<input data-#=ns#bind="value:filters[0].value" class="k-textbox" type="#=inputType#" '+
		                                '#=useRole ? "data-" + ns + "role=\'" + role + "\'" : ""# />'+
		                            '#}#' +
		                        '</label></li>'+
		                        '#if(extra){#'+
		                        '</ul>'+
		                        '<ul class="k-filter-help-text"><li><span class="k-link"></span>'+
		                            '<li class="k-item"><label class="k-label"><input type="radio" name="logic" class="k-check" data-#=ns#bind="checked: logic" value="and" />#=messages.and#</label></li>'+
		                            '<li class="k-item"><label class="k-label"><input type="radio" name="logic" class="k-check" data-#=ns#bind="checked: logic" value="or" />#=messages.or#</label></li>'+
		                        '</ul>'+
		                        '<ul class="k-filter-help-text"><li><span class="k-link"></span>'+
		                            '<li class="k-item"><label class="k-label">#=messages.additionalOperator#'+
		                                '<select data-#=ns#bind="value: filters[1].operator">'+
		                                    '#for(var op in operators){#'+
		                                        '<option value="#=op#">#=operators[op]#</option>' +
		                                    '#}#'+
		                                '</select>'+
		                            '</label></li>'+
		                            '<li class="k-item"><label class="k-label">#=messages.additionalValue#'+
		                                '#if(values){#' +
		                                    '<select data-#=ns#bind="value:filters[1].value">'+
		                                        '<option value="">#=messages.selectValue#</option>' +
		                                        '#for(var val in values){#'+
		                                            '<option value="#=values[val].value#">#=values[val].text#</option>' +
		                                        '#}#'+
		                                    '</select>' +
		                                '#}else{#' +
		                                    '<input data-#=ns#bind="value:filters[1].value" class="k-textbox" type="#=inputType#" '+
		                                    '#=useRole ? "data-" + ns + "role=\'" + role + "\'" : ""# />'+
		                                '#}#' +
		                            '</label></li>'+
		                        '#}#'+
		                        '</ul>'+
		                        '</li><li class="k-button-container">' +
		                            '<button type="reset" class="k-button">#=messages.clear#</button>'+
		                        '</li></ul>' +
		                    '</div>'+
		                '</form>'+
		            '</div>';
	
		    var booleanMobileTemplate =
		            '<div data-#=ns#role="view" data-#=ns#init-widgets="false" data-#=ns#use-native-scrolling="true" class="k-grid-filter-menu">'+
		                '<div data-#=ns#role="header" class="k-header">'+
		                    '<button class="k-button k-i-cancel">#=messages.cancel#</button>'+
		                    '#=title#'+
		                    '<button type="submit" class="k-button k-submit">#=messages.filter#</button>'+
		                '</div>'+
		                '<form title="#=messages.title#" class="k-filter-menu k-mobile-list">'+
		                    '<ul class="k-filter-help-text"><li><span class="k-link">#=messages.info#</span>'+
		                    '<ul>'+
		                        '<li class="k-item"><label class="k-label">'+
		                            '<input class="k-check" type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value"/>' +
		                            '#=messages.isTrue#' +
		                        '</label></li>' +
		                        '<li class="k-item"><label class="k-label">'+
		                            '<input class="k-check" type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value"/>' +
		                            '#=messages.isFalse#' +
		                        '</label></li>' +
		                    '</ul>'+
		                    '</li><li class="k-button-container">' +
		                        '<button type="reset" class="k-button">#=messages.clear#</button>'+
		                    '</li></ul>' +
		                '</form>'+
		            '</div>';
	
		    function removeFiltersForField(expression, field) {
		        if (expression.filters) {
		            expression.filters = $.grep(expression.filters, function(filter) {
		                removeFiltersForField(filter, field);
		                if (filter.filters) {
		                    return filter.filters.length;
		                } else {
		                    return filter.field != field;
		                }
		            });
		        }
		    }
	
		    function convertItems(items) {
		        var idx,
		            length,
		            item,
		            value,
		            text,
		            result;
	
		        if (items && items.length) {
		            result = [];
		            for (idx = 0, length = items.length; idx < length; idx++) {
		                item = items[idx];
		                text = item.text !== "" ? item.text || item.value || item : item.text;
		                value = item.value == null ? (item.text || item) : item.value;
	
		                result[idx] = { text: text, value: value };
		            }
		        }
		        return result;
		    }
	
	
		    function clearFilter(filters, field) {
		        return $.grep(filters, function(expr) {
		            if (expr.filters) {
		                expr.filters = $.grep(expr.filters, function(nested) {
		                    return nested.field != field;
		                });
	
		                return expr.filters.length;
		            }
		            return expr.field != field;
		        });
		    }
	
		    var FilterMenu = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                type = "string",
		                operators,
		                initial,
		                link,
		                field;
	
		            Widget.fn.init.call(that, element, options);
	
		            operators = that.operators = options.operators || {};
	
		            element = that.element;
		            options = that.options;
	
		            if (!options.appendToElement) {
		                link = element.addClass("k-with-icon k-filterable").find(".k-grid-filter");
	
		                if (!link[0]) {
		                    link = element.prepend('<a class="k-grid-filter" href="#" title="' +
		                        options.messages.filter + '" aria-label="' +
		                        options.messages.filter + '"><span class="k-icon k-i-filter"></span></a>').find(".k-grid-filter");
		                }
	
		                link.attr("tabindex", -1).on("click" + NS, proxy(that._click, that));
		            }
	
		            that.link = link || $();
	
		            that.dataSource = DataSource.create(options.dataSource);
	
		            that.field = options.field || element.attr(kendo.attr("field"));
	
		            that.model = that.dataSource.reader.model;
	
		            that._parse = function(value) {
		                 return value != null ? (value + "") : value;
		            };
	
		            if (that.model && that.model.fields) {
		                field = that.model.fields[that.field];
	
		                if (field) {
		                    type = field.type || "string";
		                    if (field.parse) {
		                        that._parse = proxy(field.parse, field);
		                    }
		                }
		            }
	
		            if (options.values) {
		                type = "enums";
		            }
	
		            that.type = type;
	
		            operators = operators[type] || options.operators[type];
	
		            for (initial in operators) { // get the first operator
		                break;
		            }
	
		            that._defaultFilter = function() {
		                return { field: that.field, operator: initial || "eq", value: "" };
		            };
	
		            that._refreshHandler = proxy(that.refresh, that);
	
		            that.dataSource.bind(CHANGE, that._refreshHandler);
	
		            if (options.appendToElement) { // force creation if used in column menu
		                that._init();
		            } else {
		                that.refresh(); //refresh if DataSource is fitered before menu is created
		            }
		        },
	
		        _init: function() {
		            var that = this,
		                ui = that.options.ui,
		                setUI = isFunction(ui),
		                role;
	
		            that.pane = that.options.pane;
		            if (that.pane) {
		                that._isMobile = true;
		            }
	
		            if (!setUI) {
		                role = ui || roles[that.type];
		            }
	
		            if (that._isMobile) {
		                that._createMobileForm(role);
		            } else {
		                that._createForm(role);
		            }
	
		            that.form
		                .on("submit" + NS, proxy(that._submit, that))
		                .on("reset" + NS, proxy(that._reset, that));
	
		            if (setUI) {
		                that.form.find(".k-textbox")
		                    .removeClass("k-textbox")
		                    .each(function() {
		                        ui($(this));
		                    });
		            }
	
		            that.form
		                 .find("[" + kendo.attr("role") + "=numerictextbox]")
		                 .removeClass("k-textbox")
		                 .end()
		                 .find("[" + kendo.attr("role") + "=datetimepicker]")
		                 .removeClass("k-textbox")
		                 .end()
		                 .find("[" + kendo.attr("role") + "=timepicker]")
		                 .removeClass("k-textbox")
		                 .end()
		                 .find("[" + kendo.attr("role") + "=datepicker]")
		                 .removeClass("k-textbox");
	
		            that.refresh();
	
		            that.trigger(INIT, { field: that.field, container: that.form });
	
		            kendo.cycleForm(that.form);
		        },
	
		        _createForm: function(role) {
		            var that = this,
		                options = that.options,
		                operators = that.operators || {},
		                type = that.type,
		                hasCustomTemplate = isFunction(that.options.ui);
	
		            operators = operators[type] || options.operators[type];
	
		            that.form = $('<form title="' + that.options.messages.title + '" class="k-filter-menu"/>')
		                .html(kendo.template(type === "boolean" ? (hasCustomTemplate ? customBooleanTemplate : booleanTemplate) : defaultTemplate)({
		                    field: that.field,
		                    format: options.format,
		                    ns: kendo.ns,
		                    messages: options.messages,
		                    extra: options.extra,
		                    operators: operators,
		                    type: type,
		                    role: role,
		                    values: convertItems(options.values)
		                }));
	
		            if (!options.appendToElement) {
		                that.popup = that.form[POPUP]({
		                    anchor: that.link,
		                    open: proxy(that._open, that),
		                    activate: proxy(that._activate, that),
		                    close: function() {
		                        if (that.options.closeCallback) {
		                            that.options.closeCallback(that.element);
		                        }
		                    }
		                }).data(POPUP);
		            } else {
		                that.element.append(that.form);
		                that.popup = that.element.closest(".k-popup").data(POPUP);
		            }
	
		            that.form
		                .on("keydown" + NS, proxy(that._keydown, that));
		        },
	
		        _createMobileForm: function(role) {
		            var that = this,
		                options = that.options,
		                operators = that.operators || {},
		                type = that.type;
	
		            operators = operators[type] || options.operators[type];
	
		            that.form = $("<div />")
		                .html(kendo.template(type === "boolean" ? booleanMobileTemplate : defaultMobileTemplate)({
		                    field: that.field,
		                    title: options.title || that.field,
		                    format: options.format,
		                    ns: kendo.ns,
		                    messages: options.messages,
		                    extra: options.extra,
		                    operators: operators,
		                    type: type,
		                    role: role,
		                    useRole: (!kendo.support.input.date && type === "date") || type === "number",
		                    inputType: mobileRoles[type],
		                    values: convertItems(options.values)
		                }));
	
		            that.view = that.pane.append(that.form.html());
		            that.form = that.view.element.find("form");
	
		            that.view.element
		                .on("click", ".k-submit", function(e) {
		                    that.form.submit();
		                    e.preventDefault();
		                })
		                .on("click", ".k-i-cancel", function(e) {
		                    that._closeForm();
		                    e.preventDefault();
		                });
		        },
	
		        refresh: function() {
		            var that = this,
		                expression = that.dataSource.filter() || { filters: [], logic: "and" };
	
		            var defaultFilters = [ that._defaultFilter() ];
		            var defaultOperator = that._defaultFilter().operator;
		            if (that.options.extra || (defaultOperator !== "isnull" && defaultOperator !== "isnullorempty" && defaultOperator !== "isnotnullorempty" && defaultOperator !== "isnotnull")) {
		                defaultFilters.push(that._defaultFilter());
		            }
	
		            that.filterModel = kendo.observable({
		                logic: "and",
		                filters: defaultFilters
		            });
	
		            if (that.form) {
		                //NOTE: binding the form element directly causes weird error in IE when grid is bound through MVVM and column is sorted
		                kendo.bind(that.form.children().first(), that.filterModel);
		            }
	
		            if (that._bind(expression)) {
		                that.link.addClass("k-state-active");
		            } else {
		                that.link.removeClass("k-state-active");
		            }
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            if (that.form) {
		                kendo.unbind(that.form);
		                kendo.destroy(that.form);
		                that.form.unbind(NS);
		                if (that.popup) {
		                    that.popup.destroy();
		                    that.popup = null;
		                }
		                that.form = null;
		            }
	
		            if (that.view) {
		                that.view.purge();
		                that.view = null;
		            }
	
		            that.link.unbind(NS);
	
		            if (that._refreshHandler) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
		                that.dataSource = null;
		            }
	
		            that.element = that.link = that._refreshHandler = that.filterModel = null;
		        },
	
		        _bind: function(expression) {
		            var that = this,
		                filters = expression.filters,
		                idx,
		                length,
		                found = false,
		                current = 0,
		                filterModel = that.filterModel,
		                currentFilter,
		                filter;
	
		            for (idx = 0, length = filters.length; idx < length; idx++) {
		                filter = filters[idx];
		                if (filter.field == that.field) {
		                    filterModel.set("logic", expression.logic);
	
		                    currentFilter = filterModel.filters[current];
		                    if (!currentFilter) {
		                        filterModel.filters.push({ field: that.field });
		                        currentFilter = filterModel.filters[current];
		                    }
		                    currentFilter.set("value", that._parse(filter.value));
		                    currentFilter.set("operator", filter.operator);
	
		                    current++;
		                    found = true;
		                } else if (filter.filters) {
		                    found = found || that._bind(filter);
		                }
		            }
	
		            return found;
		        },
	
		        _stripFilters: function(filters) {
		           return $.grep(filters, function(filter) {
		               return (filter.value !== "" && filter.value != null) ||
		               (filter.operator === "isnull" || filter.operator === "isnotnull" ||
		                   filter.operator === "isempty" || filter.operator === "isnotempty" ||
		                   filter.operator == "isnullorempty" || filter.operator == "isnotnullorempty");
		            });
		        },
	
		        _merge: function(expression) {
		            var that = this,
		                logic = expression.logic || "and",
		                filters = this._stripFilters(expression.filters),
		                filter,
		                result = that.dataSource.filter() || { filters:[], logic: "and" },
		                idx,
		                length;
	
		            removeFiltersForField(result, that.field);
	
		            for (idx = 0, length = filters.length; idx < length; idx++) {
		                filter = filters[idx];
		                filter.value = that._parse(filter.value);
		            }
	
		            if (filters.length) {
		                if (result.filters.length) {
		                    expression.filters = filters;
	
		                    if (result.logic !== "and") {
		                        result.filters = [ { logic: result.logic, filters: result.filters }];
		                        result.logic = "and";
		                    }
	
		                    if (filters.length > 1) {
		                        result.filters.push(expression);
		                    } else {
		                        result.filters.push(filters[0]);
		                    }
		                } else {
		                    result.filters = filters;
		                    result.logic = logic;
		                }
		            }
	
		            return result;
		        },
	
		        filter: function(expression) {
		            var filters = this._stripFilters(expression.filters);
		            if (filters.length && this.trigger("change", {
		                    filter: { logic: expression.logic, filters: filters },
		                    field: this.field
		                })) {
	
		                return;
		            }
	
		            expression = this._merge(expression);
	
		            if (expression.filters.length) {
		                this.dataSource.filter(expression);
		            }
		        },
	
		        clear: function() {
		            var that = this,
		                expression = that.dataSource.filter() || { filters:[] };
	
		            if (this.trigger("change", { filter: null, field: that.field })) {
		                return;
		            }
	
		            that._removeFilter(expression);
		        },
	
		        _removeFilter: function(expression) {
		            var that = this;
		            expression.filters = $.grep(expression.filters, function(filter) {
		                if (filter.filters) {
		                    filter.filters = clearFilter(filter.filters, that.field);
	
		                    return filter.filters.length;
		                }
	
		                return filter.field != that.field;
		            });
	
		            if (!expression.filters.length) {
		                expression = null;
		            }
	
		            that.dataSource.filter(expression);
		        },
	
		        _submit: function(e) {
		            e.preventDefault();
		            e.stopPropagation();
		            var expression = this.filterModel.toJSON();
		            var containsFilters = $.grep(expression.filters, function(filter) {
		                return filter.value !== "" && filter.value !== null;
		            });
	
		            if (this._checkForNullOrEmptyFilter(expression) || (containsFilters && containsFilters.length)) {
		                this.filter(expression);
		            } else {
		                var currentExpression = this.dataSource.filter();
	
		                if (currentExpression) {
		                    currentExpression.filters.push(expression);
		                    expression = currentExpression;
		                }
		                this._removeFilter(expression);
		            }
	
		            this._closeForm();
		        },
	
		        _checkForNullOrEmptyFilter: function(expression) {
		            if(!expression || !expression.filters || !expression.filters.length) {
		                return false;
		            }
		            var firstNullOrEmpty = false;
		            var secondNullOrEmpty = false;
		            var operator;
	
		            if (expression.filters[0]) {
		                operator = expression.filters[0].operator;
		                firstNullOrEmpty = operator == "isnull" || operator == "isnotnull" || operator == "isnotempty" ||
		                    operator == "isempty" || operator == "isnullorempty" || operator == "isnotnullorempty";
		            }
		            if (expression.filters[1]) {
		                operator = expression.filters[1].operator;
		                secondNullOrEmpty = operator == "isnull" || operator == "isnotnull" || operator == "isnotempty" ||
		                    operator == "isempty" || operator == "isnullorempty" || operator == "isnotnullorempty";
		            }
	
		            return (!this.options.extra && firstNullOrEmpty) || (this.options.extra && (firstNullOrEmpty || secondNullOrEmpty));
		        },
	
		        _reset: function() {
		            this.clear();
	
		            if (this.options.search && this.container) {
		                this.container.find("label").parent().show();
		            }
		            this._closeForm();
		        },
	
		        _closeForm: function() {
		            if (this._isMobile) {
		                this.pane.navigate("", this.options.animations.right);
		            } else {
		                this.popup.close();
		            }
		        },
	
		        _click: function(e) {
		            e.preventDefault();
		            e.stopPropagation();
	
		            if (!this.popup && !this.pane) {
		                this._init();
		            }
	
		            if (this._isMobile) {
		                this.pane.navigate(this.view, this.options.animations.left);
		            } else {
		                this.popup.toggle();
		            }
		        },
	
		        _open: function() {
		            var popup;
	
		            $(".k-filter-menu").not(this.form).each(function() {
		                popup = $(this).data(POPUP);
		                if (popup) {
		                    popup.close();
		                }
		            });
		        },
	
		        _activate: function() {
		            this.form.find(":kendoFocusable:first").focus();
	
		            this.trigger(OPEN, { field: this.field, container: this.form });
		        },
	
		        _keydown: function(e) {
		            if (e.keyCode == kendo.keys.ESC) {
		                this.popup.close();
		            }
		        },
	
		        events: [ INIT, "change", OPEN ],
	
		        options: {
		            name: "FilterMenu",
		            extra: true,
		            appendToElement: false,
		            type: "string",
		            operators: {
		                string: {
		                    eq: EQ,
		                    neq: NEQ,
		                    startswith: "Starts with",
		                    contains: "Contains",
		                    doesnotcontain: "Does not contain",
		                    endswith: "Ends with",
		                    isnull: "Is null",
		                    isnotnull: "Is not null",
		                    isempty: "Is empty",
		                    isnotempty: "Is not empty",
		                    isnullorempty: "Has no value",
		                    isnotnullorempty: "Has value"
		                },
		                number: {
		                    eq: EQ,
		                    neq: NEQ,
		                    gte: "Is greater than or equal to",
		                    gt: "Is greater than",
		                    lte: "Is less than or equal to",
		                    lt: "Is less than",
		                    isnull: "Is null",
		                    isnotnull: "Is not null"
		                },
		                date: {
		                    eq: EQ,
		                    neq: NEQ,
		                    gte: "Is after or equal to",
		                    gt: "Is after",
		                    lte: "Is before or equal to",
		                    lt: "Is before",
		                    isnull: "Is null",
		                    isnotnull: "Is not null"
		                },
		                enums: {
		                    eq: EQ,
		                    neq: NEQ,
		                    isnull: "Is null",
		                    isnotnull: "Is not null"
		                }
		            },
		            messages: {
		                info: "Show items with value that:",
		                title: "Show items with value that:",
		                isTrue: "is true",
		                isFalse: "is false",
		                filter: "Filter",
		                clear: "Clear",
		                and: "And",
		                or: "Or",
		                selectValue: "-Select value-",
		                operator: "Operator",
		                value: "Value",
		                additionalValue: "Additional value",
		                additionalOperator: "Additional operator",
		                logic: "Filters logic",
		                cancel: "Cancel"
		            },
		            animations: {
		                left: "slide",
		                right: "slide:right"
		            }
		        }
		    });
	
		    var multiCheckNS = ".kendoFilterMultiCheck";
	
		    function filterValuesForField(expression, field) {
	
		        if (expression.filters) {
		            expression.filters = $.grep(expression.filters, function(filter) {
		                filterValuesForField(filter, field);
		                if (filter.filters) {
		                    return filter.filters.length;
		                } else {
		                    return filter.field == field && filter.operator == "eq";
		                }
		            });
		        }
		    }
	
		    function flatFilterValues(expression) {
		        if (expression.logic == "and" && expression.filters.length > 1) {
		            return [];
		        }
		        if (expression.filters) {
		            return $.map(expression.filters, function(filter) {
		                return flatFilterValues(filter);
		            });
		        } else if (expression.value !== undefined) {
		            return [expression.value];
		        } else {
		            return [];
		        }
		    }
	
		    function distinct(items, field) {
		        var getter = kendo.getter(field, true),
		            result = [],
		            index = 0,
		            seen = {};
	
		        while (index < items.length) {
		            var item = items[index++],
		                text = getter(item);
	
		            if(text !== undefined && !seen.hasOwnProperty(text)){
		                result.push(item);
		                seen[text] = true;
		            }
		        }
	
		        return result;
		    }
	
		    function removeDuplicates (dataSelector, dataTextField) {
	
		        return function(e) {
		            var items = dataSelector(e);
	
		            return distinct(items, dataTextField);
		        };
		    }
	
		    var DataSource = kendo.data.DataSource;
	
		    var multiCkeckMobileTemplate =
		        '<div data-#=ns#role="view" data-#=ns#init-widgets="false" class="k-grid-filter-menu">' +
		            '<div data-#=ns#role="header" class="k-header">' +
		                '<button class="k-button k-i-cancel">#=messages.cancel#</button>' +
		                '#=title#' +
		                '<button type="submit" class="k-button k-submit">#=messages.filter#</button>' +
		            '</div>' +
		            '<form class="k-filter-menu k-mobile-list">' +
		                '#if(search){#' +
		                "<div class='k-textbox k-space-right'>" +
		                    "<input placeholder='#=messages.search#'/>" +
		                    "<span class='k-icon k-i-zoom' />" +
		                    "</div>" +
		                '#}#' +
		                '<ul class="k-multicheck-wrap"></ul>' +
		                '</li><li class="k-button-container">' +
		                "#if(messages.selectedItemsFormat){#<div class='k-filter-selected-items'></div>#}#" +
		                    '<button type="reset" class="k-button">#=messages.clear#</button>' +
		                '</li></ul>' +
		            '</form>' +
		        '</div>';
	
		    var FilterMultiCheck = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
		            options = this.options;
		            this.element = $(element);
		            var field = this.field = this.options.field || this.element.attr(kendo.attr("field"));
		            var checkSource = options.checkSource;
		            if (this._foreignKeyValues()) {
		                this.checkSource = DataSource.create(options.values);
		                this.checkSource.fetch();
		            } else if (options.forceUnique) {
		                checkSource = $.extend(true, {}, options.dataSource.options);
		                delete checkSource.pageSize;
	
		                this.checkSource = DataSource.create(checkSource);
		                this.checkSource.reader.data = removeDuplicates(this.checkSource.reader.data, this.field);
		            } else {
		                this.checkSource = DataSource.create(checkSource);
		            }
	
		            this.dataSource = options.dataSource;
		            this.model = this.dataSource.reader.model;
	
		            this._parse = function(value) {
		                 return value + "";
		            };
	
		            if (this.model && this.model.fields) {
		                field = this.model.fields[this.field];
	
		                if (field) {
		                    if (field.type == "number") {
		                        this._parse = function (value) {
		                            if (typeof value === "string" && value.toLowerCase() === "null") {
		                                return null;
		                            }
		                            return parseFloat(value);
		                        };
		                    } else if (field.parse) {
		                        this._parse = proxy(field.parse, field);
		                    }
		                    this.type = field.type || "string";
		                }
		            }
		            if (!options.appendToElement) {
		                this._createLink();
		            } else {
		                this._init();
		            }
	
		            this._refreshHandler = proxy(this.refresh, this);
		            this.dataSource.bind(CHANGE, this._refreshHandler);
	
		        },
		        _createLink: function() {
		            var element = this.element;
		            var link = element.addClass("k-with-icon k-filterable").find(".k-grid-filter");
	
		            if (!link[0]) {
		                link = element.prepend('<a class="k-grid-filter" href="#" title="' +
		                this.options.messages.filter + '" aria-label="' +
		                this.options.messages.filter + '"><span class="k-icon k-i-filter"/></a>').find(".k-grid-filter");
		            }
	
		            this._link = link.attr("tabindex", -1).on("click" + NS, proxy(this._click, this));
		        },
		        _init: function() {
		            var that = this;
		            var forceUnique = this.options.forceUnique;
	
		            var options = this.options;
		            this.pane = options.pane;
	
		            if (this.pane) {
		                this._isMobile = true;
		            }
	
		            this._createForm();
	
		            if (this._foreignKeyValues()) {
		                this.refresh();
		            } else if (forceUnique && !this.checkSource.options.serverPaging && this.dataSource.data().length) {
		                this.checkSource.data(distinct(this.dataSource.data(),this.field));
		                this.refresh();
		            } else {
		                this._attachProgress();
	
		                this.checkSource.fetch(function() {
		                    that.refresh.call(that);
		                });
		            }
	
		            if (!this.options.forceUnique) {
		                this.checkChangeHandler = function() {
		                    that.container.empty();
		                    that.refresh();
		                };
		                this.checkSource.bind(CHANGE, this.checkChangeHandler);
		            }
	
		            this.form.on("keydown" + multiCheckNS, proxy(this._keydown, this))
		                        .on("submit" + multiCheckNS, proxy(this._filter, this))
		                        .on("reset" + multiCheckNS, proxy(this._reset, this));
	
		            this.trigger(INIT, { field: this.field, container: this.form });
		        },
	
		        _attachProgress: function() {
		            var that = this;
	
		            this._progressHandler = function() {
		                ui.progress(that.container, true);
		            };
	
		            this._progressHideHandler = function() {
		                ui.progress(that.container, false);
		            };
	
		            this.checkSource
		                .bind("progress", this._progressHandler)
		                .bind("change", this._progressHideHandler);
		        },
	
		        _input: function () {
		            var that = this;
		            that._clearTypingTimeout();
		            that._typingTimeout = setTimeout(function () { that.search(); }, 100);
		        },
	
		        _clearTypingTimeout: function() {
		            if (this._typingTimeout) {
		                clearTimeout(this._typingTimeout);
		                this._typingTimeout = null;
		            }
		        },
	
		        search: function () {
		            var ignoreCase = this.options.ignoreCase;
		            var searchString = this.searchTextBox[0].value;
		            var labels = this.container.find("label");
	
		            if (ignoreCase) {
		                searchString = searchString.toLowerCase();
		            }
		            var i = 0;
		            if(this.options.checkAll && labels.length)
		            {
		                labels[0].parentNode.style.display = searchString ? "none" : "";
		                i++;
		            }
	
		            while (i < labels.length) {
		                var label = labels[i];
		                var labelText = label.textContent || label.innerText;
		                if (ignoreCase) {
		                    labelText = labelText.toLowerCase();
		                }
		                label.parentNode.style.display = labelText.indexOf(searchString) >= 0 ? "" : "none";
		                i++;
		            }
		        },
		        _activate: function() {
		            this.form.find(":kendoFocusable:first").focus();
	
		            this.trigger(OPEN, { field: this.field, container: this.form });
		        },
		        _createForm: function() {
		            var options = this.options;
		            var html = "";
		            var that = this;
	
		            if (!this._isMobile) {
		                if (options.search) {
		                    html += "<div class='k-textbox k-space-right'>" +
		                    "<input placeholder='" + options.messages.search + "'/>" +
		                    "<span class='k-icon k-i-zoom' />" +
		                    "</div>";
		                }
		                html += "<ul class='k-reset k-multicheck-wrap'></ul>";
		                if (options.messages.selectedItemsFormat) {
		                    html += "<div class='k-filter-selected-items'>" + kendo.format(options.messages.selectedItemsFormat, 0) + "</div>";
		                }
		                html +="<button type='submit' class='k-button k-primary'>" + options.messages.filter + "</button>";
		                html += "<button type='reset' class='k-button'>" + options.messages.clear + "</button>";
	
		                this.form = $('<form class="k-filter-menu"/>').html(html);
		                this.container = this.form.find(".k-multicheck-wrap");
		            }
		            if (this._isMobile) {
		                that.form = $("<div />")
		                    .html(kendo.template(multiCkeckMobileTemplate)({
		                        field: that.field,
		                        title: options.title || that.field,
		                        ns: kendo.ns,
		                        messages: options.messages,
		                        search: options.search
		                    }));
	
		                that.view = that.pane.append(that.form.html());
		                that.form = that.view.element.find("form");
		                var element = this.view.element;
		                this.container = element.find(".k-multicheck-wrap");
	
		                element
		                    .on("click", ".k-submit", function (e) {
		                        that.form.submit();
		                        e.preventDefault();
		                    })
		                    .on("click", ".k-i-cancel", function (e) {
		                        that._closeForm();
		                        e.preventDefault();
		                    });
		            } else {
		                if (!options.appendToElement) {
		                    that.popup = that.form.kendoPopup({
		                        anchor: that._link,
		                        open: proxy(that._open, that),
		                        activate: proxy(that._activate, that),
		                        close: function() {
		                            if (that.options.closeCallback) {
		                                that.options.closeCallback(that.element);
		                            }
		                        }
		                    }).data(POPUP);
		                } else {
		                    this.popup = this.element.closest(".k-popup").data(POPUP);
		                    this.element.append(this.form);
		                }
		            }
	
		            if (options.search) {
		                this.searchTextBox = this.form.find(".k-textbox > input");
		                this.searchTextBox.on("input", proxy(this._input, this));
		            }
		        },
		        createCheckAllItem: function () {
		            var options = this.options;
		            var template = kendo.template(options.itemTemplate({ field: "all", mobile: this._isMobile }));
		            var checkAllContainer = $(template({ all: options.messages.checkAll}));
		            this.container.prepend(checkAllContainer);
	
		            this.checkBoxAll = checkAllContainer.find(":checkbox").eq(0).addClass("k-check-all");
		            this.checkAllHandler = proxy(this.checkAll, this);
		            this.checkBoxAll.on(CHANGE+ multiCheckNS, this.checkAllHandler);
		        },
		        updateCheckAllState: function() {
		            if (this.options.messages.selectedItemsFormat) {
		                this.form.find(".k-filter-selected-items").text(kendo.format(this.options.messages.selectedItemsFormat, this.container.find(":checked:not(.k-check-all)").length));
		            }
		            if (this.checkBoxAll) {
		                var state = this.container.find(":checkbox:not(.k-check-all)").length == this.container.find(":checked:not(.k-check-all)").length;
		                this.checkBoxAll.prop("checked", state);
		            }
		        },
		        refresh: function(e) {
		            var forceUnique = this.options.forceUnique;
		            var dataSource = this.dataSource;
		            var filters = this.getFilterArray();
	
		            if (this._link) {
		                this._link.toggleClass("k-state-active", filters.length !== 0);
		            }
	
		            if (this.form) {
		                if (e && forceUnique && e.sender === dataSource && !dataSource.options.serverPaging &&
		                     (e.action == "itemchange" || e.action == "add" || e.action == "remove" || (dataSource.options.autoSync && e.action === "sync")) &&
		                         !this._foreignKeyValues()) {
		                    this.checkSource.data(distinct(this.dataSource.data(),this.field));
		                    this.container.empty();
		                }
	
		                if (this.container.is(":empty")) {
		                    this.createCheckBoxes();
		                }
		                this.checkValues(filters);
		                this.trigger(REFRESH);
		            }
		        },
		        getFilterArray: function() {
		            var expression = $.extend(true, {}, { filters: [], logic: "and" }, this.dataSource.filter());
		            filterValuesForField(expression, this.field);
		            var flatValues = flatFilterValues(expression);
		            return flatValues;
		        },
		        createCheckBoxes: function() {
		            var options = this.options;
		            var data;
		            var templateOptions = {
		                field: this.field,
		                format: options.format,
		                mobile: this._isMobile,
		                type: this.type
		            };
	
		            if (!this.options.forceUnique) {
		                data = this.checkSource.view();
		            } else if (this._foreignKeyValues()) {
		                data = this.checkSource.data();
		                templateOptions.valueField = "value";
		                templateOptions.field = "text";
		            } else {
		                data = this.checkSource.data();
		            }
	
		            var template = kendo.template(options.itemTemplate(templateOptions));
		            var itemsHtml = kendo.render(template, data);
		            if (options.checkAll) {
		                this.createCheckAllItem();
		            }
		            this.container.on(CHANGE + multiCheckNS, ":checkbox", proxy(this.updateCheckAllState, this));
	
		            this.container.append(itemsHtml);
	
		        },
		        checkAll: function() {
		            var state = this.checkBoxAll.is(":checked");
		            this.container.find(":checkbox").prop("checked", state);
		        },
		        checkValues: function(values) {
		            var that = this;
	
		            $($.grep(this.container.find(":checkbox").prop("checked", false), function(ele) {
		                var found = false;
		                if ($(ele).is(".k-check-all")) {
		                    return;
		                }
		                var checkBoxVal = that._parse($(ele).val());
		                for (var i = 0; i < values.length; i++) {
		                    if (that.type == "date") {
		                        if (values[i] && checkBoxVal) {
		                            found = values[i].getTime() == checkBoxVal.getTime();
		                        } else if (values[i] === null && checkBoxVal === null) {
		                            found = true;
		                        } else {
		                            found = false;
		                        }
		                    } else {
		                        found = values[i] == checkBoxVal;
		                    }
		                    if (found) {
		                        return found;
		                    }
		                }
		            })).prop("checked", true);
		            this.updateCheckAllState();
		        },
	
		        _filter: function(e) {
		            e.preventDefault();
		            e.stopPropagation();
	
		            var expression = { logic: "or" };
	
		            var that = this;
		            expression.filters = $.map(this.form.find(":checkbox:checked:not(.k-check-all)"), function (item) {
		                return { value: $(item).val(), operator: "eq", field: that.field };
		            });
	
		            if (expression.filters.length && this.trigger("change", { filter: expression, field: that.field })) {
		                return;
		            }
	
		            expression = this._merge(expression);
		            if (expression.filters.length) {
		                this.dataSource.filter(expression);
		            } else {
		                this.clear();
		            }
	
		            this._closeForm();
		        },
	
		        _stripFilters: function(filters) {
		           return $.grep(filters, function(filter) {
		                return filter.value != null;
		            });
		        },
	
		        _foreignKeyValues: function() {
		            var options = this.options;
		            return options.values && !options.checkSource;
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            if (that.form) {
		                kendo.unbind(that.form);
		                kendo.destroy(that.form);
		                that.form.unbind(multiCheckNS);
		                if (that.popup) {
		                    that.popup.destroy();
		                    that.popup = null;
		                }
		                that.form = null;
		                if (that.container) {
		                    that.container.unbind(multiCheckNS);
		                    that.container = null;
		                }
	
		                if (that.checkBoxAll) {
		                    that.checkBoxAll.unbind(multiCheckNS);
		                }
		            }
	
		            if (that.view) {
		                that.view.purge();
		                that.view = null;
		            }
	
		            if (that._link) {
		                that._link.unbind(NS);
		            }
	
		            if (that._refreshHandler) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
		                that.dataSource = null;
		            }
	
		            if (that.checkChangeHandler) {
		                that.checkSource.unbind(CHANGE, that.checkChangeHandler);
		            }
	
		            if (that._progressHandler) {
		                that.checkSource.unbind("progress", that._progressHandler);
		            }
	
		            if (that._progressHideHandler) {
		                that.checkSource.unbind("change", that._progressHideHandler);
		            }
	
		            this._clearTypingTimeout();
		            this.searchTextBox = null;
	
		            that.element = that.checkSource = that.container = that.checkBoxAll = that._link = that._refreshHandler = that.checkAllHandler = null;
		        },
		        options: {
		            name: "FilterMultiCheck",
		            itemTemplate: function(options) {
		                var field = options.field;
		                var format = options.format;
		                var valueField = options.valueField;
		                var mobile = options.mobile;
		                var valueFormat = "";
	
		                if (valueField === undefined) {
		                    valueField = field;
		                }
		                if (options.type == "date") {
		                    valueFormat = ":yyyy-MM-ddTHH:mm:sszzz";
		                }
	
		                return "<li class='k-item'>" +
		                          "<label class='k-label'>" +
		                              "<input type='checkbox' class='" + (mobile? "k-check" : "") +"'  value='#:kendo.format('{0"+ valueFormat + "}'," + valueField + ")#'/>" +
		                                 "#:kendo.format('" + ( format ?  format  : "{0}" ) + "', "  + field + ")#" +
		                          "</label>" +
		                        "</li>";
		            },
		            checkAll: true,
		            search: false,
		            ignoreCase: true,
		            appendToElement: false,
		            messages: {
		                checkAll: "Select All",
		                clear: "Clear",
		                filter: "Filter",
		                search: "Search",
		                cancel: "Cancel",
		                selectedItemsFormat: "{0} items selected"
		            },
		            forceUnique: true,
		            animations: {
		                left: "slide",
		                right: "slide:right"
		            }
		        },
		        events: [ INIT, REFRESH, "change", OPEN ]
		    });
	
		    $.extend(FilterMultiCheck.fn, {
		        _click: FilterMenu.fn._click,
		        _keydown: FilterMenu.fn._keydown,
		        _reset: FilterMenu.fn._reset,
		        _closeForm: FilterMenu.fn._closeForm,
		        _removeFilter: FilterMenu.fn._removeFilter,
		        clear: FilterMenu.fn.clear,
	
		        _merge: FilterMenu.fn._merge
		    });
	
		    ui.plugin(FilterMenu);
		    ui.plugin(FilterMultiCheck);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1261);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1000:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1261:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1000), __webpack_require__(1262), __webpack_require__(1263) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
		}) (function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "pdf",
		    name: "PDF export",
		    description: "PDF Generation framework",
		    mixin: true,
		    category: "framework",
		    depends: [ "core", "drawing" ]
		};
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1262:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(611);
	
	/***/ }),
	
	/***/ 1263:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(613);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1443);
		module.exports = __webpack_require__(1443);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 923:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(554);
	
	/***/ }),
	
	/***/ 1443:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1444),
		        __webpack_require__(19),
		        __webpack_require__(923),
		        __webpack_require__(1445)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}) (function(){
	
		(function(kendo){
	
		// WARNING: removing the following jshint declaration and turning
		// == into === to make JSHint happy will break functionality.
		/* jshint eqnull:true */
		/* jshint -W069 */
		/* jshint loopfunc:true */
		/* jshint newcap:false */
		/* jshint latedef: nofunc */
	
		window.kendo.pdf = window.kendo.pdf || {};
		var support = kendo.support;
		var supportBrowser = support.browser;
		var kendoPdf = kendo.pdf;
		var drawing = kendo.drawing;
		var util = drawing.util;
		var kendoGeometry = kendo.geometry;
	
		/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
		/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
		/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
		/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
		// XXX: remove this junk (assume `true`) when we no longer have to support IE < 10
		// IE 9 (at least compatibility) reports having Uint8Array but the request response does not contain ArrayBuffer which results in missing table head error
		var HAS_TYPED_ARRAYS = typeof Uint8Array !== 'undefined' && kendo.support.browser && (!kendo.support.browser.msie || kendo.support.browser.version > 9);
	
		var BASE64 = (function(){
		    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
		    return {
		        decode: function(str) {
		            var input = str.replace(/[^A-Za-z0-9\+\/\=]/g, ""), i = 0, n = input.length, output = [];
	
		            while (i < n) {
		                var enc1 = keyStr.indexOf(input.charAt(i++));
		                var enc2 = keyStr.indexOf(input.charAt(i++));
		                var enc3 = keyStr.indexOf(input.charAt(i++));
		                var enc4 = keyStr.indexOf(input.charAt(i++));
	
		                var chr1 = (enc1 << 2) | (enc2 >>> 4);
		                var chr2 = ((enc2 & 15) << 4) | (enc3 >>> 2);
		                var chr3 = ((enc3 & 3) << 6) | enc4;
	
		                output.push(chr1);
		                if (enc3 != 64) {
		                    output.push(chr2);
		                }
		                if (enc4 != 64) {
		                    output.push(chr3);
		                }
		            }
	
		            return output;
		        },
		        encode: function(bytes) {
		            var i = 0, n = bytes.length;
		            var output = "";
	
		            while (i < n) {
		                var chr1 = bytes[i++];
		                var chr2 = bytes[i++];
		                var chr3 = bytes[i++];
	
		                var enc1 = chr1 >>> 2;
		                var enc2 = ((chr1 & 3) << 4) | (chr2 >>> 4);
		                var enc3 = ((chr2 & 15) << 2) | (chr3 >>> 6);
		                var enc4 = chr3 & 63;
	
		                if (i - n == 2) {
		                    enc3 = enc4 = 64;
		                } else if (i - n == 1) {
		                    enc4 = 64;
		                }
	
		                output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
		            }
		            return output;
		        }
		    };
		}());
	
		function BinaryStream(data) {
		    var offset = 0, length = 0;
		    if (data == null) {
		        data = HAS_TYPED_ARRAYS ? new Uint8Array(256) : [];
		    } else {
		        length = data.length;
		    }
	
		    var ensure = HAS_TYPED_ARRAYS ? function(len) {
		        if (len >= data.length) {
		            var tmp = new Uint8Array(Math.max(len + 256, data.length * 2));
		            tmp.set(data, 0);
		            data = tmp;
		        }
		    } : function() {};
	
		    var get = HAS_TYPED_ARRAYS ? function() {
		        return new Uint8Array(data.buffer, 0, length);
		    } : function() {
		        return data;
		    };
	
		    var write = HAS_TYPED_ARRAYS ? function(bytes) {
		        if (typeof bytes == "string") {
		            return writeString(bytes);
		        }
		        var len = bytes.length;
		        ensure(offset + len);
		        data.set(bytes, offset);
		        offset += len;
		        if (offset > length) {
		            length = offset;
		        }
		    } : function(bytes) {
		        if (typeof bytes == "string") {
		            return writeString(bytes);
		        }
		        for (var i = 0; i < bytes.length; ++i) {
		            writeByte(bytes[i]);
		        }
		    };
	
		    var slice = HAS_TYPED_ARRAYS ? function(start, length) {
		        if (data.buffer.slice) {
		            return new Uint8Array(data.buffer.slice(start, start + length));
		        } else {
		            // IE10
		            var x = new Uint8Array(length);
		            x.set(new Uint8Array(data.buffer, start, length));
		            return x;
		        }
		    } : function(start, length) {
		        return data.slice(start, start + length);
		    };
	
		    function eof() {
		        return offset >= length;
		    }
		    function readByte() {
		        return offset < length ? data[offset++] : 0;
		    }
		    function writeByte(b) {
		        ensure(offset);
		        data[offset++] = b & 0xFF;
		        if (offset > length) {
		            length = offset;
		        }
		    }
		    function readShort() {
		        return (readByte() << 8) | readByte();
		    }
		    function writeShort(w) {
		        writeByte(w >> 8);
		        writeByte(w);
		    }
		    function readShort_() {
		        var w = readShort();
		        return w >= 0x8000 ? w - 0x10000 : w;
		    }
		    function writeShort_(w) {
		        writeShort(w < 0 ? w + 0x10000 : w);
		    }
		    function readLong() {
		        return (readShort() * 0x10000) + readShort();
		    }
		    function writeLong(w) {
		        writeShort((w >>> 16) & 0xFFFF);
		        writeShort(w & 0xFFFF);
		    }
		    function readLong_() {
		        var w = readLong();
		        return w >= 0x80000000 ? w - 0x100000000 : w;
		    }
		    function writeLong_(w) {
		        writeLong(w < 0 ? w + 0x100000000 : w);
		    }
		    function readFixed() {
		        return readLong() / 0x10000;
		    }
		    function writeFixed(f) {
		        writeLong(Math.round(f * 0x10000));
		    }
		    function readFixed_() {
		        return readLong_() / 0x10000;
		    }
		    function writeFixed_(f) {
		        writeLong_(Math.round(f * 0x10000));
		    }
		    function read(len) {
		        return times(len, readByte);
		    }
		    function readString(len) {
		        return String.fromCharCode.apply(String, read(len));
		    }
		    function writeString(str) {
		        for (var i = 0; i < str.length; ++i) {
		            writeByte(str.charCodeAt(i));
		        }
		    }
		    function times(n, reader) {
		        for (var ret = new Array(n), i = 0; i < n; ++i) {
		            ret[i] = reader();
		        }
		        return ret;
		    }
	
		    var stream = {
		        eof         : eof,
		        readByte    : readByte,
		        writeByte   : writeByte,
		        readShort   : readShort,
		        writeShort  : writeShort,
		        readLong    : readLong,
		        writeLong   : writeLong,
		        readFixed   : readFixed,
		        writeFixed  : writeFixed,
	
		        // signed numbers.
		        readShort_  : readShort_,
		        writeShort_ : writeShort_,
		        readLong_   : readLong_,
		        writeLong_  : writeLong_,
		        readFixed_  : readFixed_,
		        writeFixed_ : writeFixed_,
	
		        read        : read,
		        write       : write,
		        readString  : readString,
		        writeString : writeString,
	
		        times       : times,
		        get         : get,
		        slice       : slice,
	
		        offset: function(pos) {
		            if (pos != null) {
		                offset = pos;
		                return stream;
		            }
		            return offset;
		        },
	
		        skip: function(nbytes) {
		            offset += nbytes;
		        },
	
		        toString: function() {
		            throw new Error("FIX CALLER.  BinaryStream is no longer convertible to string!");
		        },
	
		        length: function() { return length; },
	
		        saveExcursion: function(f) {
		            var pos = offset;
		            try {
		                return f();
		            } finally {
		                offset = pos;
		            }
		        },
	
		        writeBase64: function(base64) {
		            if (window.atob) {
		                writeString(window.atob(base64));
		            } else {
		                write(BASE64.decode(base64));
		            }
		        },
		        base64: function() {
		            return BASE64.encode(get());
		        }
		    };
	
		    return stream;
		}
	
		function ucs2decode(string) {
		    var output = [],
		        counter = 0,
		        length = string.length,
		        value,
		        extra;
		    while (counter < length) {
		        value = string.charCodeAt(counter++);
		        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
		            // high surrogate, and there is a next character
		            extra = string.charCodeAt(counter++);
		            if ((extra & 0xFC00) == 0xDC00) { // low surrogate
		                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
		            } else {
		                // unmatched surrogate; only append this code unit, in case the next
		                // code unit is the high surrogate of a surrogate pair
		                output.push(value);
		                counter--;
		            }
		        } else {
		            output.push(value);
		        }
		    }
		    return output;
		}
	
		function ucs2encode(array) {
		    return array.map(function(value){
		        var output = "";
		        if (value > 0xFFFF) {
		            value -= 0x10000;
		            output += String.fromCharCode(value >>> 10 & 0x3FF | 0xD800);
		            value = 0xDC00 | value & 0x3FF;
		        }
		        output += String.fromCharCode(value);
		        return output;
		    }).join("");
		}
	
		function atobUint8Array(base64) {
		    var data = window.atob(base64);
		    var result = new Uint8Array(data.length);
	
		    for (var idx = 0; idx < data.length; idx++) {
		        result[idx] = data.charCodeAt(idx);
		    }
	
		    return result;
		}
	
		function createUint8Array(data) {
		    var result = new Uint8Array(data.length);
	
		    for (var idx = 0; idx < data.length; idx++) {
		        result[idx] = data[idx];
		    }
	
		    return result;
		}
	
		function base64ToUint8Array(base64) {
		    if (window.atob) {
		        return atobUint8Array(base64);
		    }
	
		    return createUint8Array(BASE64.decode(base64));
		}
	
		/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
		/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
		/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
		/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
		/*****************************************************************************\
		 *
		 * The code in this file, although written from scratch, is influenced by the
		 * TrueType parser/encoder in PDFKit -- http://pdfkit.org/ (a CoffeeScript
		 * library for producing PDF files).
		 *
		 * PDFKit is (c) Devon Govett 2014 and released under the MIT License.
		 *
		\*****************************************************************************/
	
		function hasOwnProperty$1(obj, key) {
		    return Object.prototype.hasOwnProperty.call(obj, key);
		}
	
		function sortedKeys(obj) {
		    return Object.keys(obj).sort(function(a, b){ return a - b; }).map(parseFloat);
		}
	
		///
	
		function Directory(data) {
		    this.raw = data;
		    this.scalerType = data.readLong();
		    this.tableCount = data.readShort();
		    this.searchRange = data.readShort();
		    this.entrySelector = data.readShort();
		    this.rangeShift = data.readShort();
	
		    var tables = this.tables = {};
		    for (var i = 0; i < this.tableCount; ++i) {
		        var entry = {
		            tag      : data.readString(4),
		            checksum : data.readLong(),
		            offset   : data.readLong(),
		            length   : data.readLong()
		        };
		        tables[entry.tag] = entry;
		    }
		}
	
		Directory.prototype = {
	
		    readTable: function(name, Ctor) {
		        var def = this.tables[name];
		        if (!def) {
		            throw new Error("Table " + name + " not found in directory");
		        }
		        return (this[name] = def.table = new Ctor(this, def));
		    },
	
		    render: function(tables) {
		        var this$1 = this;
	
		        var tableCount = Object.keys(tables).length;
	
		        var maxpow2 = Math.pow(2, Math.floor(Math.log(tableCount) / Math.LN2));
		        var searchRange = maxpow2 * 16;
		        var entrySelector = Math.floor(Math.log(maxpow2) / Math.LN2);
		        var rangeShift = tableCount * 16 - searchRange;
	
		        var out = BinaryStream();
		        out.writeLong(this.scalerType);
		        out.writeShort(tableCount);
		        out.writeShort(searchRange);
		        out.writeShort(entrySelector);
		        out.writeShort(rangeShift);
	
		        var directoryLength = tableCount * 16;
		        var offset = out.offset() + directoryLength;
		        var headOffset = null;
		        var tableData = BinaryStream();
	
		        for (var tag in tables) {
		            if (hasOwnProperty$1(tables, tag)) {
		                var table = tables[tag];
	
		                out.writeString(tag);
		                out.writeLong(this$1.checksum(table));
		                out.writeLong(offset);
		                out.writeLong(table.length);
	
		                tableData.write(table);
		                if (tag == "head") {
		                    headOffset = offset;
		                }
		                offset += table.length;
	
		                while (offset % 4) {
		                    tableData.writeByte(0);
		                    offset++;
		                }
		            }
		        }
	
		        out.write(tableData.get());
		        var sum = this.checksum(out.get());
		        var adjustment = 0xB1B0AFBA - sum;
	
		        out.offset(headOffset + 8);
		        out.writeLong(adjustment);
		        return out.get();
		    },
	
		    checksum: function(data) {
		        data = BinaryStream(data);
		        var sum = 0;
		        while (!data.eof()) {
		            sum += data.readLong();
		        }
		        return sum & 0xFFFFFFFF;
		    }
		};
	
		function deftable(methods) {
		    function Ctor(file, def) {
		        this.definition = def;
		        this.length = def.length;
		        this.offset = def.offset;
		        this.file = file;
		        this.rawData = file.raw;
		        this.parse(file.raw);
		    }
		    Ctor.prototype.raw = function() {
		        return this.rawData.slice(this.offset, this.length);
		    };
		    for (var i in methods) {
		        if (hasOwnProperty$1(methods, i)) {
		            Ctor[i] = Ctor.prototype[i] = methods[i];
		        }
		    }
		    return Ctor;
		}
	
		var HeadTable = deftable({
		    parse: function(data) {
		        data.offset(this.offset);
		        this.version             = data.readLong();
		        this.revision            = data.readLong();
		        this.checkSumAdjustment  = data.readLong();
		        this.magicNumber         = data.readLong();
		        this.flags               = data.readShort();
		        this.unitsPerEm          = data.readShort();
		        this.created             = data.read(8);
		        this.modified            = data.read(8);
	
		        this.xMin = data.readShort_();
		        this.yMin = data.readShort_();
		        this.xMax = data.readShort_();
		        this.yMax = data.readShort_();
	
		        this.macStyle           = data.readShort();
		        this.lowestRecPPEM      = data.readShort();
		        this.fontDirectionHint  = data.readShort_();
		        this.indexToLocFormat   = data.readShort_();
		        this.glyphDataFormat    = data.readShort_();
		    },
		    render: function(indexToLocFormat) {
		        var out = BinaryStream();
		        out.writeLong(this.version);
		        out.writeLong(this.revision);
		        out.writeLong(0);       // checksum adjustment; shall be computed later
		        out.writeLong(this.magicNumber);
		        out.writeShort(this.flags);
		        out.writeShort(this.unitsPerEm);
		        out.write(this.created);
		        out.write(this.modified);
		        out.writeShort_(this.xMin);
		        out.writeShort_(this.yMin);
		        out.writeShort_(this.xMax);
		        out.writeShort_(this.yMax);
		        out.writeShort(this.macStyle);
		        out.writeShort(this.lowestRecPPEM);
		        out.writeShort_(this.fontDirectionHint);
		        out.writeShort_(indexToLocFormat); // this will depend on the `loca` table
		        out.writeShort_(this.glyphDataFormat);
		        return out.get();
		    }
		});
	
		var LocaTable = deftable({
		    parse: function(data) {
		        data.offset(this.offset);
		        var format = this.file.head.indexToLocFormat;
		        if (format === 0) {
		            this.offsets = data.times(this.length / 2, function(){
		                return 2 * data.readShort();
		            });
		        } else {
		            this.offsets = data.times(this.length / 4, data.readLong);
		        }
		    },
		    offsetOf: function(id) {
		        return this.offsets[id];
		    },
		    lengthOf: function(id) {
		        return this.offsets[id + 1] - this.offsets[id];
		    },
		    render: function(offsets) {
		        var out = BinaryStream();
		        var needsLongFormat = offsets[offsets.length - 1] > 0xFFFF;
		        for (var i = 0; i < offsets.length; ++i) {
		            if (needsLongFormat) {
		                out.writeLong(offsets[i]);
		            } else {
		                out.writeShort(offsets[i] / 2);
		            }
		        }
		        return {
		            format: needsLongFormat ? 1 : 0,
		            table: out.get()
		        };
		    }
		});
	
		var HheaTable = deftable({
		    parse: function(data) {
		        data.offset(this.offset);
	
		        this.version              = data.readLong();
		        this.ascent               = data.readShort_();
		        this.descent              = data.readShort_();
		        this.lineGap              = data.readShort_();
		        this.advanceWidthMax      = data.readShort();
		        this.minLeftSideBearing   = data.readShort_();
		        this.minRightSideBearing  = data.readShort_();
		        this.xMaxExtent           = data.readShort_();
		        this.caretSlopeRise       = data.readShort_();
		        this.caretSlopeRun        = data.readShort_();
		        this.caretOffset          = data.readShort_();
	
		        data.skip(4 * 2);       // reserved
	
		        this.metricDataFormat     = data.readShort_();
		        this.numOfLongHorMetrics  = data.readShort();
		    },
		    render: function(ids) {
		        var out = BinaryStream();
		        out.writeLong(this.version);
		        out.writeShort_(this.ascent);
		        out.writeShort_(this.descent);
		        out.writeShort_(this.lineGap);
		        out.writeShort(this.advanceWidthMax);
		        out.writeShort_(this.minLeftSideBearing);
		        out.writeShort_(this.minRightSideBearing);
		        out.writeShort_(this.xMaxExtent);
		        out.writeShort_(this.caretSlopeRise);
		        out.writeShort_(this.caretSlopeRun);
		        out.writeShort_(this.caretOffset);
	
		        out.write([ 0, 0, 0, 0, 0, 0, 0, 0 ]); // reserved bytes
	
		        out.writeShort_(this.metricDataFormat);
		        out.writeShort(ids.length);
		        return out.get();
		    }
		});
	
		var MaxpTable = deftable({
		    parse: function(data) {
		        data.offset(this.offset);
		        this.version = data.readLong();
		        this.numGlyphs = data.readShort();
		        this.maxPoints = data.readShort();
		        this.maxContours = data.readShort();
		        this.maxComponentPoints = data.readShort();
		        this.maxComponentContours = data.readShort();
		        this.maxZones = data.readShort();
		        this.maxTwilightPoints = data.readShort();
		        this.maxStorage = data.readShort();
		        this.maxFunctionDefs = data.readShort();
		        this.maxInstructionDefs = data.readShort();
		        this.maxStackElements = data.readShort();
		        this.maxSizeOfInstructions = data.readShort();
		        this.maxComponentElements = data.readShort();
		        this.maxComponentDepth = data.readShort();
		    },
		    render: function(glyphIds) {
		        var out = BinaryStream();
		        out.writeLong(this.version);
		        out.writeShort(glyphIds.length);
		        out.writeShort(this.maxPoints);
		        out.writeShort(this.maxContours);
		        out.writeShort(this.maxComponentPoints);
		        out.writeShort(this.maxComponentContours);
		        out.writeShort(this.maxZones);
		        out.writeShort(this.maxTwilightPoints);
		        out.writeShort(this.maxStorage);
		        out.writeShort(this.maxFunctionDefs);
		        out.writeShort(this.maxInstructionDefs);
		        out.writeShort(this.maxStackElements);
		        out.writeShort(this.maxSizeOfInstructions);
		        out.writeShort(this.maxComponentElements);
		        out.writeShort(this.maxComponentDepth);
		        return out.get();
		    }
		});
	
		var HmtxTable = deftable({
		    parse: function(data) {
		        data.offset(this.offset);
		        var dir = this.file, hhea = dir.hhea;
		        this.metrics = data.times(hhea.numOfLongHorMetrics, function(){
		            return {
		                advance: data.readShort(),
		                lsb: data.readShort_()
		            };
		        });
		        var lsbCount = dir.maxp.numGlyphs - dir.hhea.numOfLongHorMetrics;
		        this.leftSideBearings = data.times(lsbCount, data.readShort_);
		    },
		    forGlyph: function(id) {
		        var metrics = this.metrics;
		        var n = metrics.length;
		        if (id < n) {
		            return metrics[id];
		        }
		        return {
		            advance: metrics[n - 1].advance,
		            lsb: this.leftSideBearings[id - n]
		        };
		    },
		    render: function(glyphIds) {
		        var this$1 = this;
	
		        var out = BinaryStream();
		        for (var i = 0; i < glyphIds.length; ++i) {
		            var m = this$1.forGlyph(glyphIds[i]);
		            out.writeShort(m.advance);
		            out.writeShort_(m.lsb);
		        }
		        return out.get();
		    }
		});
	
		var GlyfTable = (function(){
	
		    function SimpleGlyph(raw) {
		        this.raw = raw;
		    }
		    SimpleGlyph.prototype = {
		        compound: false,
		        render: function() {
		            return this.raw.get();
		        }
		    };
	
		    var ARG_1_AND_2_ARE_WORDS     = 0x0001;
		    var WE_HAVE_A_SCALE           = 0x0008;
		    var MORE_COMPONENTS           = 0x0020;
		    var WE_HAVE_AN_X_AND_Y_SCALE  = 0x0040;
		    var WE_HAVE_A_TWO_BY_TWO      = 0x0080;
		    //var WE_HAVE_INSTRUCTIONS      = 0x0100;
	
		    function CompoundGlyph(data) {
		        this.raw = data;
		        var ids = this.glyphIds = [];
		        var offsets = this.idOffsets = [];
		        while (true) {          // eslint-disable-line no-constant-condition
		            var flags = data.readShort();
		            offsets.push(data.offset());
		            ids.push(data.readShort());
	
		            if (!(flags & MORE_COMPONENTS)) {
		                break;
		            }
	
		            data.skip(flags & ARG_1_AND_2_ARE_WORDS ? 4 : 2);
	
		            if (flags & WE_HAVE_A_TWO_BY_TWO) {
		                data.skip(8);
		            } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
		                data.skip(4);
		            } else if (flags & WE_HAVE_A_SCALE) {
		                data.skip(2);
		            }
		        }
		    }
	
		    CompoundGlyph.prototype = {
		        compound: true,
		        render: function(old2new) {
		            var this$1 = this;
	
		            var out = BinaryStream(this.raw.get());
		            for (var i = 0; i < this.glyphIds.length; ++i) {
		                var id = this$1.glyphIds[i];
		                out.offset(this$1.idOffsets[i]);
		                out.writeShort(old2new[id]);
		            }
		            return out.get();
		        }
		    };
	
		    return deftable({
		        parse: function() {
		            this.cache = {};
		        },
		        glyphFor: function(id) {
		            var cache = this.cache;
		            if (hasOwnProperty$1(cache, id)) {
		                return cache[id];
		            }
	
		            var loca = this.file.loca;
		            var length = loca.lengthOf(id);
	
		            if (length === 0) {
		                return (cache[id] = null);
		            }
	
		            var data = this.rawData;
		            var offset = this.offset + loca.offsetOf(id);
		            var raw = BinaryStream(data.slice(offset, length));
	
		            var numberOfContours = raw.readShort_();
		            var xMin = raw.readShort_();
		            var yMin = raw.readShort_();
		            var xMax = raw.readShort_();
		            var yMax = raw.readShort_();
	
		            var glyph = cache[id] = numberOfContours == -1 ? new CompoundGlyph(raw) : new SimpleGlyph(raw);
	
		            glyph.numberOfContours = numberOfContours;
		            glyph.xMin = xMin;
		            glyph.yMin = yMin;
		            glyph.xMax = xMax;
		            glyph.yMax = yMax;
	
		            return glyph;
		        },
		        render: function(glyphs, oldIds, old2new) {
		            var out = BinaryStream(), offsets = [];
		            for (var i = 0; i < oldIds.length; ++i) {
		                var id = oldIds[i];
		                var glyph = glyphs[id];
		                offsets.push(out.offset());
		                if (glyph) {
		                    out.write(glyph.render(old2new));
		                }
		            }
		            offsets.push(out.offset());
		            return {
		                table: out.get(),
		                offsets: offsets
		            };
		        }
		    });
	
		}());
	
		var NameTable = (function(){
	
		    function NameEntry(text, entry) {
		        this.text = text;
		        this.length = text.length;
		        this.platformID = entry.platformID;
		        this.platformSpecificID = entry.platformSpecificID;
		        this.languageID = entry.languageID;
		        this.nameID = entry.nameID;
		    }
	
		    return deftable({
		        parse: function(data) {
		            data.offset(this.offset);
		            data.readShort();   // format
		            var count = data.readShort();
		            var stringOffset = this.offset + data.readShort();
		            var nameRecords = data.times(count, function(){
		                return {
		                    platformID         : data.readShort(),
		                    platformSpecificID : data.readShort(),
		                    languageID         : data.readShort(),
		                    nameID             : data.readShort(),
		                    length             : data.readShort(),
		                    offset             : data.readShort() + stringOffset
		                };
		            });
		            var strings = this.strings = {};
		            for (var i = 0; i < nameRecords.length; ++i) {
		                var rec = nameRecords[i];
		                data.offset(rec.offset);
		                var text = data.readString(rec.length);
		                if (!strings[rec.nameID]) {
		                    strings[rec.nameID] = [];
		                }
		                strings[rec.nameID].push(new NameEntry(text, rec));
		            }
		            this.postscriptEntry = strings[6][0];
		            this.postscriptName = this.postscriptEntry.text.replace(/[^\x20-\x7F]/g, "");
		        },
	
		        render: function(psName) {
		            var this$1 = this;
	
		            var strings = this.strings;
		            var strCount = 0;
		            for (var i in strings) {
		                if (hasOwnProperty$1(strings, i)) {
		                    strCount += strings[i].length;
		                }
		            }
		            var out = BinaryStream();
		            var strTable = BinaryStream();
	
		            out.writeShort(0);  // format
		            out.writeShort(strCount);
		            out.writeShort(6 + 12 * strCount); // stringOffset
	
		            for (i in strings) {
		                if (hasOwnProperty$1(strings, i)) {
		                    var list = i == 6 ? [
		                        new NameEntry(psName, this$1.postscriptEntry)
		                    ] : strings[i];
		                    for (var j = 0; j < list.length; ++j) {
		                        var str = list[j];
		                        out.writeShort(str.platformID);
		                        out.writeShort(str.platformSpecificID);
		                        out.writeShort(str.languageID);
		                        out.writeShort(str.nameID);
		                        out.writeShort(str.length);
		                        out.writeShort(strTable.offset());
	
		                        strTable.writeString(str.text);
		                    }
		                }
		            }
	
		            out.write(strTable.get());
	
		            return out.get();
		        }
		    });
	
		})();
	
		var PostTable = (function(){
	
		    var POSTSCRIPT_GLYPHS = ".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(/\s+/g);
	
		    return deftable({
		        parse: function(data) {
		            var this$1 = this;
	
		            data.offset(this.offset);
	
		            this.format = data.readLong();
		            this.italicAngle = data.readFixed_();
		            this.underlinePosition = data.readShort_();
		            this.underlineThickness = data.readShort_();
		            this.isFixedPitch = data.readLong();
		            this.minMemType42 = data.readLong();
		            this.maxMemType42 = data.readLong();
		            this.minMemType1 = data.readLong();
		            this.maxMemType1 = data.readLong();
	
		            var numberOfGlyphs;
	
		            switch (this.format) {
		              case 0x00010000:
		              case 0x00030000:
		                break;
	
		              case 0x00020000:
		                numberOfGlyphs = data.readShort();
		                this.glyphNameIndex = data.times(numberOfGlyphs, data.readShort);
		                this.names = [];
		                var limit = this.offset + this.length;
		                while (data.offset() < limit) {
		                    this$1.names.push(data.readString(data.readByte()));
		                }
		                break;
	
		              case 0x00025000:
		                numberOfGlyphs = data.readShort();
		                this.offsets = data.read(numberOfGlyphs);
		                break;
	
		              case 0x00040000:
		                this.map = data.times(this.file.maxp.numGlyphs, data.readShort);
		                break;
		            }
		        },
		        glyphFor: function(code) {
		            switch (this.format) {
		              case 0x00010000:
		                return POSTSCRIPT_GLYPHS[code] || ".notdef";
	
		              case 0x00020000:
		                var index = this.glyphNameIndex[code];
		                if (index < POSTSCRIPT_GLYPHS.length) {
		                    return POSTSCRIPT_GLYPHS[index];
		                }
		                return this.names[index - POSTSCRIPT_GLYPHS.length] || ".notdef";
	
		              case 0x00025000:
	
		              case 0x00030000:
		                return ".notdef";
	
		              case 0x00040000:
		                return this.map[code] || 0xFFFF;
		            }
		        },
		        render: function(mapping) {
		            var this$1 = this;
	
		            if (this.format == 0x00030000) {
		                return this.raw();
		            }
	
		            // keep original header, but set format to 2.0
		            var out = BinaryStream(this.rawData.slice(this.offset, 32));
		            out.writeLong(0x00020000);
		            out.offset(32);
	
		            var indexes = [];
		            var strings = [];
	
		            for (var i = 0; i < mapping.length; ++i) {
		                var id = mapping[i];
		                var post = this$1.glyphFor(id);
		                var index = POSTSCRIPT_GLYPHS.indexOf(post);
		                if (index >= 0) {
		                    indexes.push(index);
		                } else {
		                    indexes.push(POSTSCRIPT_GLYPHS.length + strings.length);
		                    strings.push(post);
		                }
		            }
	
		            out.writeShort(mapping.length);
	
		            for (i = 0; i < indexes.length; ++i) {
		                out.writeShort(indexes[i]);
		            }
	
		            for (i = 0; i < strings.length; ++i) {
		                out.writeByte(strings[i].length);
		                out.writeString(strings[i]);
		            }
	
		            return out.get();
		        }
		    });
		})();
	
		var CmapTable = (function(){
	
		    function CmapEntry(data, offset, codeMap) {
		        var self = this;
		        self.platformID = data.readShort();
		        self.platformSpecificID = data.readShort();
		        self.offset = offset + data.readLong();
	
		        data.saveExcursion(function(){
		            var code;
		            data.offset(self.offset);
		            self.format = data.readShort();
	
		            switch (self.format) {
		              case 0:
		                self.length = data.readShort();
		                self.language = data.readShort();
		                for (var i = 0; i < 256; ++i) {
		                    codeMap[i] = data.readByte();
		                }
		                break;
	
		              case 4:
		                self.length = data.readShort();
		                self.language = data.readShort();
		                var segCount = data.readShort() / 2;
	
		                data.skip(6);       // searchRange, entrySelector, rangeShift
		                var endCode = data.times(segCount, data.readShort);
		                data.skip(2);       // reserved pad
		                var startCode = data.times(segCount, data.readShort);
		                var idDelta = data.times(segCount, data.readShort_);
		                var idRangeOffset = data.times(segCount, data.readShort);
	
		                var count = (self.length + self.offset - data.offset()) / 2;
		                var glyphIds = data.times(count, data.readShort);
	
		                for (i = 0; i < segCount; ++i) {
		                    var start = startCode[i], end = endCode[i];
		                    for (code = start; code <= end; ++code) {
		                        var glyphId;
		                        if (idRangeOffset[i] === 0) {
		                            glyphId = code + idDelta[i];
		                        } else {
		                            ///
		                            // When non-zero, idRangeOffset contains for each segment the byte offset of the Glyph ID
		                            // into the glyphIds table, from the *current* `i` cell of idRangeOffset.  In other words,
		                            // this offset spans from the first into the second array.  This works, because the arrays
		                            // are consecutive in the TTF file:
		                            //
		                            //     [ ...idRangeOffset... ][ ...glyphIds... ]
		                            //       ...... 48 ......       .... ID ....
		                            //              ^----- 48 bytes -----^
		                            //
		                            // (but I can't stop wondering why is it not just a plain index, possibly incremented by 1
		                            // so that we can have that special `zero` value.)
		                            //
		                            // The elements of idRangeOffset are even numbers, because both arrays contain 16-bit words,
		                            // yet the offset is in bytes.  That is why we divide it by 2.  Then we subtract the
		                            // remaining segments (segCount-i), and add the code-start offset, to which we need to add
		                            // the corresponding delta to get the actual glyph ID.
		                            ///
		                            var index = idRangeOffset[i] / 2 - (segCount - i) + (code - start);
		                            glyphId = glyphIds[index] || 0;
		                            if (glyphId !== 0) {
		                                glyphId += idDelta[i];
		                            }
		                        }
		                        codeMap[code] = glyphId & 0xFFFF;
		                    }
		                }
		                break;
	
		              case 6:
		                self.length = data.readShort();
		                self.language = data.readShort();
		                code = data.readShort();
		                var length = data.readShort();
		                while (length-- > 0) {
		                    codeMap[code++] = data.readShort();
		                }
		                break;
	
		              case 12:
		                data.readShort(); // reserved
		                self.length = data.readLong();
		                self.language = data.readLong();
		                var ngroups = data.readLong();
		                while (ngroups-- > 0) {
		                    code = data.readLong();
		                    var endCharCode = data.readLong();
		                    var glyphCode = data.readLong();
		                    while (code <= endCharCode) {
		                        codeMap[code++] = glyphCode++;
		                    }
		                }
		                break;
	
		              default:
		                if (window.console) {
		                    window.console.error("Unhandled CMAP format: " + self.format);
		                }
		            }
		        });
		    }
	
		    function renderCharmap(ncid2ogid, ogid2ngid) {
		        var codes = sortedKeys(ncid2ogid);
		        var startCodes = [];
		        var endCodes = [];
		        var last = null;
		        var diff = null;
	
		        function new_gid(charcode) {
		            return ogid2ngid[ncid2ogid[charcode]];
		        }
	
		        for (var i = 0; i < codes.length; ++i) {
		            var code = codes[i];
		            var gid = new_gid(code);
		            var delta = gid - code;
		            if (last == null || delta !== diff) {
		                if (last) {
		                    endCodes.push(last);
		                }
		                startCodes.push(code);
		                diff = delta;
		            }
		            last = code;
		        }
	
		        if (last) {
		            endCodes.push(last);
		        }
		        endCodes.push(0xFFFF);
		        startCodes.push(0xFFFF);
	
		        var segCount = startCodes.length;
		        var segCountX2 = segCount * 2;
		        var searchRange = 2 * Math.pow(2, Math.floor(Math.log(segCount) / Math.LN2));
		        var entrySelector = Math.log(searchRange / 2) / Math.LN2;
		        var rangeShift = segCountX2 - searchRange;
	
		        var deltas = [];
		        var rangeOffsets = [];
		        var glyphIds = [];
	
		        for (i = 0; i < segCount; ++i) {
		            var startCode = startCodes[i];
		            var endCode = endCodes[i];
		            if (startCode == 0xFFFF) {
		                deltas.push(0);
		                rangeOffsets.push(0);
		                break;
		            }
		            var startGlyph = new_gid(startCode);
		            if (startCode - startGlyph >= 0x8000) {
		                deltas.push(0);
		                rangeOffsets.push(2 * (glyphIds.length + segCount - i));
		                for (var j = startCode; j <= endCode; ++j) {
		                    glyphIds.push(new_gid(j));
		                }
		            } else {
		                deltas.push(startGlyph - startCode);
		                rangeOffsets.push(0);
		            }
		        }
	
		        var out = BinaryStream();
	
		        out.writeShort(3);      // platformID
		        out.writeShort(1);      // platformSpecificID
		        out.writeLong(12);      // offset
		        out.writeShort(4);      // format
		        out.writeShort(16 + segCount * 8 + glyphIds.length * 2); // length
		        out.writeShort(0);      // language
		        out.writeShort(segCountX2);
		        out.writeShort(searchRange);
		        out.writeShort(entrySelector);
		        out.writeShort(rangeShift);
	
		        endCodes.forEach(out.writeShort);
		        out.writeShort(0);      // reserved pad
		        startCodes.forEach(out.writeShort);
		        deltas.forEach(out.writeShort_);
		        rangeOffsets.forEach(out.writeShort);
		        glyphIds.forEach(out.writeShort);
	
		        return out.get();
		    }
	
		    return deftable({
		        parse: function(data) {
		            var self = this;
		            var offset = self.offset;
		            data.offset(offset);
		            self.codeMap = {};
		            self.version = data.readShort();
		            var tableCount = data.readShort();
		            self.tables = data.times(tableCount, function(){
		                return new CmapEntry(data, offset, self.codeMap);
		            });
		        },
		        render: function(ncid2ogid, ogid2ngid) {
		            var out = BinaryStream();
		            out.writeShort(0);  // version
		            out.writeShort(1);  // tableCount
		            out.write(renderCharmap(ncid2ogid, ogid2ngid));
		            return out.get();
		        }
		    });
	
		})();
	
		var OS2Table = deftable({
		    parse: function(data) {
		        data.offset(this.offset);
		        this.version = data.readShort();
		        this.averageCharWidth = data.readShort_();
		        this.weightClass = data.readShort();
		        this.widthClass = data.readShort();
		        this.type = data.readShort();
		        this.ySubscriptXSize = data.readShort_();
		        this.ySubscriptYSize = data.readShort_();
		        this.ySubscriptXOffset = data.readShort_();
		        this.ySubscriptYOffset = data.readShort_();
		        this.ySuperscriptXSize = data.readShort_();
		        this.ySuperscriptYSize = data.readShort_();
		        this.ySuperscriptXOffset = data.readShort_();
		        this.ySuperscriptYOffset = data.readShort_();
		        this.yStrikeoutSize = data.readShort_();
		        this.yStrikeoutPosition = data.readShort_();
		        this.familyClass = data.readShort_();
	
		        this.panose = data.times(10, data.readByte);
		        this.charRange = data.times(4, data.readLong);
	
		        this.vendorID = data.readString(4);
		        this.selection = data.readShort();
		        this.firstCharIndex = data.readShort();
		        this.lastCharIndex = data.readShort();
	
		        if (this.version > 0) {
		            this.ascent = data.readShort_();
		            this.descent = data.readShort_();
		            this.lineGap = data.readShort_();
		            this.winAscent = data.readShort();
		            this.winDescent = data.readShort();
		            this.codePageRange = data.times(2, data.readLong);
	
		            if (this.version > 1) {
		                this.xHeight = data.readShort();
		                this.capHeight = data.readShort();
		                this.defaultChar = data.readShort();
		                this.breakChar = data.readShort();
		                this.maxContext = data.readShort();
		            }
		        }
		    },
		    render: function() {
		        return this.raw();
		    }
		});
	
		var subsetTag = 100000;
	
		function nextSubsetTag() {
		    var ret = "", n = String(subsetTag);
		    for (var i = 0; i < n.length; ++i) {
		        ret += String.fromCharCode(n.charCodeAt(i) - 48 + 65);
		    }
		    ++subsetTag;
		    return ret;
		}
	
		function Subfont(font) {
		    this.font = font;
		    this.subset = {};
		    this.unicodes = {};
		    this.ogid2ngid = { 0: 0 };
		    this.ngid2ogid = { 0: 0 };
		    this.ncid2ogid = {};
		    this.next = this.firstChar = 1;
		    this.nextGid = 1;
		    this.psName = nextSubsetTag() + "+" + this.font.psName;
		}
	
		Subfont.prototype = {
		    use: function(ch) {
		        var self = this;
		        if (typeof ch == "string") {
		            return ucs2decode(ch).reduce(function(ret, code){
		                return ret + String.fromCharCode(self.use(code));
		            }, "");
		        }
		        var code = self.unicodes[ch];
		        if (!code) {
		            code = self.next++;
		            self.subset[code] = ch;
		            self.unicodes[ch] = code;
	
		            // generate new GID (glyph ID) and maintain newGID ->
		            // oldGID and back mappings
		            var old_gid = self.font.cmap.codeMap[ch];
		            if (old_gid) {
		                self.ncid2ogid[code] = old_gid;
		                if (self.ogid2ngid[old_gid] == null) {
		                    var new_gid = self.nextGid++;
		                    self.ogid2ngid[old_gid] = new_gid;
		                    self.ngid2ogid[new_gid] = old_gid;
		                }
		            }
		        }
		        return code;
		    },
		    encodeText: function(text) {
		        return this.use(text);
		    },
		    glyphIds: function() {
		        return sortedKeys(this.ogid2ngid);
		    },
		    glyphsFor: function(glyphIds, result) {
		        var this$1 = this;
	
		        if (!result) {
		            result = {};
		        }
		        for (var i = 0; i < glyphIds.length; ++i) {
		            var id = glyphIds[i];
		            if (!result[id]) {
		                var glyph = result[id] = this$1.font.glyf.glyphFor(id);
		                if (glyph && glyph.compound) {
		                    this$1.glyphsFor(glyph.glyphIds, result);
		                }
		            }
		        }
		        return result;
		    },
		    render: function() {
		        var this$1 = this;
	
		        var glyphs = this.glyphsFor(this.glyphIds());
	
		        // add missing sub-glyphs
		        for (var old_gid in glyphs) {
		            if (hasOwnProperty$1(glyphs, old_gid)) {
		                old_gid = parseInt(old_gid, 10);
		                if (this$1.ogid2ngid[old_gid] == null) {
		                    var new_gid = this$1.nextGid++;
		                    this$1.ogid2ngid[old_gid] = new_gid;
		                    this$1.ngid2ogid[new_gid] = old_gid;
		                }
		            }
		        }
	
		        // must obtain old_gid_ids in an order matching sorted
		        // new_gid_ids
		        var new_gid_ids = sortedKeys(this.ngid2ogid);
		        var old_gid_ids = new_gid_ids.map(function(id){
		            return this.ngid2ogid[id];
		        }, this);
	
		        var font = this.font;
		        var glyf = font.glyf.render(glyphs, old_gid_ids, this.ogid2ngid);
		        var loca = font.loca.render(glyf.offsets);
	
		        this.lastChar = this.next - 1;
	
		        var tables = {
		            "cmap" : CmapTable.render(this.ncid2ogid, this.ogid2ngid),
		            "glyf" : glyf.table,
		            "loca" : loca.table,
		            "hmtx" : font.hmtx.render(old_gid_ids),
		            "hhea" : font.hhea.render(old_gid_ids),
		            "maxp" : font.maxp.render(old_gid_ids),
		            "post" : font.post.render(old_gid_ids),
		            "name" : font.name.render(this.psName),
		            "head" : font.head.render(loca.format),
		            "OS/2" : font.os2.render()
		        };
	
		        return this.font.directory.render(tables);
		    },
		    cidToGidMap: function() {
		        var this$1 = this;
	
		        var out = BinaryStream(), len = 0;
		        for (var cid = this.firstChar; cid < this.next; ++cid) {
		            while (len < cid) {
		                out.writeShort(0);
		                len++;
		            }
		            var old_gid = this$1.ncid2ogid[cid];
		            if (old_gid) {
		                var new_gid = this$1.ogid2ngid[old_gid];
		                out.writeShort(new_gid);
		            } else {
		                out.writeShort(0);
		            }
		            len++;
		        }
		        return out.get();
		    }
		};
	
		function TTFFont(rawData, name) {
		    var self = this;
		    var data = self.contents = BinaryStream(rawData);
		    if (data.readString(4) == "ttcf") {
		        var offset;
		        var parse = function() {
		            data.offset(offset);
		            self.parse();
		        };
		        if (!name) {
		            throw new Error("Must specify a name for TTC files");
		        }
		        data.readLong();        // version
		        var numFonts = data.readLong();
		        for (var i = 0; i < numFonts; ++i) {
		            offset = data.readLong();
		            data.saveExcursion(parse);
		            if (self.psName == name) {
		                return;
		            }
		        }
		        throw new Error("Font " + name + " not found in collection");
		    } else {
		        data.offset(0);
		        self.parse();
		    }
		}
	
		TTFFont.prototype = {
		    parse: function() {
		        var dir = this.directory = new Directory(this.contents);
	
		        this.head = dir.readTable("head", HeadTable);
		        this.loca = dir.readTable("loca", LocaTable);
		        this.hhea = dir.readTable("hhea", HheaTable);
		        this.maxp = dir.readTable("maxp", MaxpTable);
		        this.hmtx = dir.readTable("hmtx", HmtxTable);
		        this.glyf = dir.readTable("glyf", GlyfTable);
		        this.name = dir.readTable("name", NameTable);
		        this.post = dir.readTable("post", PostTable);
		        this.cmap = dir.readTable("cmap", CmapTable);
		        this.os2  = dir.readTable("OS/2", OS2Table);
	
		        this.psName = this.name.postscriptName;
		        this.ascent = this.os2.ascent || this.hhea.ascent;
		        this.descent = this.os2.descent || this.hhea.descent;
		        this.lineGap = this.os2.lineGap || this.hhea.lineGap;
		        this.scale = 1000 / this.head.unitsPerEm;
		    },
		    widthOfGlyph: function(glyph) {
		        return this.hmtx.forGlyph(glyph).advance * this.scale;
		    },
		    makeSubset: function() {
		        return new Subfont(this);
		    }
		};
	
		/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
		/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
		/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
		/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
		var browser = kendo.support.browser;
		var NL = "\n";
	
		var RESOURCE_COUNTER = 0;
	
		var PAPER_SIZE = {
		    a0        : [ 2383.94 , 3370.39 ],
		    a1        : [ 1683.78 , 2383.94 ],
		    a2        : [ 1190.55 , 1683.78 ],
		    a3        : [ 841.89  , 1190.55 ],
		    a4        : [ 595.28  , 841.89  ],
		    a5        : [ 419.53  , 595.28  ],
		    a6        : [ 297.64  , 419.53  ],
		    a7        : [ 209.76  , 297.64  ],
		    a8        : [ 147.40  , 209.76  ],
		    a9        : [ 104.88  , 147.40  ],
		    a10       : [ 73.70   , 104.88  ],
		    b0        : [ 2834.65 , 4008.19 ],
		    b1        : [ 2004.09 , 2834.65 ],
		    b2        : [ 1417.32 , 2004.09 ],
		    b3        : [ 1000.63 , 1417.32 ],
		    b4        : [ 708.66  , 1000.63 ],
		    b5        : [ 498.90  , 708.66  ],
		    b6        : [ 354.33  , 498.90  ],
		    b7        : [ 249.45  , 354.33  ],
		    b8        : [ 175.75  , 249.45  ],
		    b9        : [ 124.72  , 175.75  ],
		    b10       : [ 87.87   , 124.72  ],
		    c0        : [ 2599.37 , 3676.54 ],
		    c1        : [ 1836.85 , 2599.37 ],
		    c2        : [ 1298.27 , 1836.85 ],
		    c3        : [ 918.43  , 1298.27 ],
		    c4        : [ 649.13  , 918.43  ],
		    c5        : [ 459.21  , 649.13  ],
		    c6        : [ 323.15  , 459.21  ],
		    c7        : [ 229.61  , 323.15  ],
		    c8        : [ 161.57  , 229.61  ],
		    c9        : [ 113.39  , 161.57  ],
		    c10       : [ 79.37   , 113.39  ],
		    executive : [ 521.86  , 756.00  ],
		    folio     : [ 612.00  , 936.00  ],
		    legal     : [ 612.00  , 1008.00 ],
		    letter    : [ 612.00  , 792.00  ],
		    tabloid   : [ 792.00  , 1224.00 ]
		};
	
		function makeOutput() {
		    var indentLevel = 0, output = BinaryStream();
		    function out() {
		        var arguments$1 = arguments;
	
		        for (var i = 0; i < arguments.length; ++i) {
		            var x = arguments$1[i];
		            if (x === undefined) {
		                throw new Error("Cannot output undefined to PDF");
		            }
		            else if (x instanceof PDFValue) {
		                x.beforeRender(out);
		                x.render(out);
		            }
		            else if (isArray(x)) {
		                renderArray(x, out);
		            }
		            else if (isDate(x)) {
		                renderDate(x, out);
		            }
		            else if (typeof x == "number") {
		                if (isNaN(x)) {
		                    throw new Error("Cannot output NaN to PDF");
		                }
		                // make sure it doesn't end up in exponent notation
		                var num = x.toFixed(7);
		                if (num.indexOf(".") >= 0) {
		                    num = num.replace(/\.?0+$/, "");
		                }
		                if (num == "-0") {
		                    num = "0";
		                }
		                output.writeString(num);
		            }
		            else if (/string|boolean/.test(typeof x)) {
		                output.writeString(String(x));
		            }
		            else if (typeof x.get == "function") {
		                output.write(x.get());
		            }
		            else if (typeof x == "object") {
		                if (!x) {
		                    output.writeString("null");
		                } else {
		                    out(new PDFDictionary(x));
		                }
		            }
		        }
		    }
		    out.writeData = function(data) {
		        output.write(data);
		    };
		    out.withIndent = function(f) {
		        ++indentLevel;
		        f(out);
		        --indentLevel;
		    };
		    out.indent = function() {
		        out(NL, pad("", indentLevel * 2, "  "));
		        out.apply(null, arguments);
		    };
		    out.offset = function() {
		        return output.offset();
		    };
		    out.toString = function() {
		        throw new Error("FIX CALLER");
		    };
		    out.get = function() {
		        return output.get();
		    };
		    out.stream = function() {
		        return output;
		    };
		    return out;
		}
	
		function wrapObject(value, id) {
		    var beforeRender = value.beforeRender;
		    var renderValue = value.render;
	
		    value.beforeRender = function(){};
	
		    value.render = function(out) {
		        out(id, " 0 R");
		    };
	
		    value.renderFull = function(out) {
		        value._offset = out.offset();
		        out(id, " 0 obj ");
		        beforeRender.call(value, out);
		        renderValue.call(value, out);
		        out(" endobj");
		    };
		}
	
		function getPaperOptions(getOption) {
		    if (typeof getOption != "function") {
		        var options = getOption;
		        getOption = function(key, def) {
		            return key in options ? options[key] : def;
		        };
		    }
		    var paperSize = getOption("paperSize", PAPER_SIZE.a4);
		    if (!paperSize) {
		        return {};
		    }
		    if (typeof paperSize == "string") {
		        paperSize = PAPER_SIZE[paperSize.toLowerCase()];
		        if (paperSize == null) {
		            throw new Error("Unknown paper size");
		        }
		    }
	
		    paperSize[0] = unitsToPoints(paperSize[0]);
		    paperSize[1] = unitsToPoints(paperSize[1]);
	
		    if (getOption("landscape", false)) {
		        paperSize = [
		            Math.max(paperSize[0], paperSize[1]),
		            Math.min(paperSize[0], paperSize[1])
		        ];
		    }
	
		    var margin = getOption("margin");
		    if (margin) {
		        if (typeof margin == "string" || typeof margin == "number") {
		            margin = unitsToPoints(margin, 0);
		            margin = { left: margin, top: margin, right: margin, bottom: margin };
		        } else {
		            margin = {
		                left   : unitsToPoints(margin.left, 0),
		                top    : unitsToPoints(margin.top, 0),
		                right  : unitsToPoints(margin.right, 0),
		                bottom : unitsToPoints(margin.bottom, 0)
		            };
		        }
		        if (getOption("addMargin")) {
		            paperSize[0] += margin.left + margin.right;
		            paperSize[1] += margin.top + margin.bottom;
		        }
		    }
		    return { paperSize: paperSize, margin: margin };
		}
	
		function PDFDocument(options) {
		    var self = this;
		    var out = makeOutput();
		    var objcount = 0;
		    var objects = [];
	
		    function getOption(name, defval) {
		        return (options && options[name] != null) ? options[name] : defval;
		    }
	
		    self.getOption = getOption;
	
		    self.attach = function(value) {
		        if (objects.indexOf(value) < 0) {
		            wrapObject(value, ++objcount);
		            objects.push(value);
		        }
		        return value;
		    };
	
		    self.pages = [];
	
		    self.FONTS = {};
		    self.IMAGES = {};
		    self.GRAD_COL_FUNCTIONS = {}; // cache for color gradient functions
		    self.GRAD_OPC_FUNCTIONS = {}; // cache for opacity gradient functions
		    self.GRAD_COL = {};     // cache for whole color gradient objects
		    self.GRAD_OPC = {};     // cache for whole opacity gradient objects
	
		    var catalog = self.attach(new PDFCatalog());
		    var pageTree = self.attach(new PDFPageTree());
	
		    if (getOption("autoPrint")) {
		        var nameTree = {};
		        nameTree.JavaScript = new PDFDictionary({ Names: [
		            new PDFString("JS"), self.attach(new PDFDictionary({
		                S: _("JavaScript"),
		                JS: new PDFString("print(true);")
		            }))
		        ] });
		        catalog.props.Names = new PDFDictionary(nameTree);
		    }
	
		    catalog.setPages(pageTree);
	
		    var info = self.attach(new PDFDictionary({
		        Producer     : new PDFString(getOption("producer", "Kendo UI PDF Generator")), // XXX: kendo.version?
		        Title        : new PDFString(getOption("title", "")),
		        Author       : new PDFString(getOption("author", "")),
		        Subject      : new PDFString(getOption("subject", "")),
		        Keywords     : new PDFString(getOption("keywords", "")),
		        Creator      : new PDFString(getOption("creator", "Kendo UI PDF Generator")),
		        CreationDate : getOption("date", new Date())
		    }));
	
		    self.addPage = function(options) {
		        var paperOptions  = getPaperOptions(function(name, defval){
		            return (options && options[name] != null) ? options[name] : defval;
		        });
		        var paperSize     = paperOptions.paperSize;
		        var margin        = paperOptions.margin;
		        var contentWidth  = paperSize[0];
		        var contentHeight = paperSize[1];
		        if (margin) {
		            contentWidth -= margin.left + margin.right;
		            contentHeight -= margin.top + margin.bottom;
		        }
		        var content = new PDFStream(makeOutput(), null, true);
		        var props = {
		            Contents : self.attach(content),
		            Parent   : pageTree,
		            MediaBox : [ 0, 0, paperSize[0], paperSize[1] ]
		        };
		        var page = new PDFPage(self, props);
		        page._content = content;
		        pageTree.addPage(self.attach(page));
	
		        // canvas-like coord. system.  (0,0) is upper-left.
		        // text must be vertically mirorred before drawing.
		        page.transform(1, 0, 0, -1, 0, paperSize[1]);
	
		        if (margin) {
		            page.translate(margin.left, margin.top);
		            // XXX: clip to right/bottom margin.  Make this optional?
		            page.rect(0, 0, contentWidth, contentHeight);
		            page.clip();
		        }
	
		        self.pages.push(page);
		        return page;
		    };
	
		    self.render = function() {
		        var i;
		        /// file header
		        out("%PDF-1.4", NL, "%\xc2\xc1\xda\xcf\xce", NL, NL);
	
		        /// file body
		        for (i = 0; i < objects.length; ++i) {
		            objects[i].renderFull(out);
		            out(NL, NL);
		        }
	
		        /// cross-reference table
		        var xrefOffset = out.offset();
		        out("xref", NL, 0, " ", objects.length + 1, NL);
		        out("0000000000 65535 f ", NL);
		        for (i = 0; i < objects.length; ++i) {
		            out(zeropad(objects[i]._offset, 10), " 00000 n ", NL);
		        }
		        out(NL);
	
		        /// trailer
		        out("trailer", NL);
		        out(new PDFDictionary({
		            Size: objects.length + 1,
		            Root: catalog,
		            Info: info
		        }), NL, NL);
	
		        /// end
		        out("startxref", NL, xrefOffset, NL);
		        out("%%EOF", NL);
	
		        return out.stream().offset(0);
		    };
		}
	
		var FONT_CACHE = {
		    "Times-Roman"           : true,
		    "Times-Bold"            : true,
		    "Times-Italic"          : true,
		    "Times-BoldItalic"      : true,
		    "Helvetica"             : true,
		    "Helvetica-Bold"        : true,
		    "Helvetica-Oblique"     : true,
		    "Helvetica-BoldOblique" : true,
		    "Courier"               : true,
		    "Courier-Bold"          : true,
		    "Courier-Oblique"       : true,
		    "Courier-BoldOblique"   : true,
		    "Symbol"                : true,
		    "ZapfDingbats"          : true
		};
	
		function loadBinary(url, cont) {
		    // IE throws Accesss denied error for Data URIs
		    var m;
		    if (browser.msie && (m = /^data:.*?;base64,/i.exec(url))) {
		        cont(base64ToUint8Array(url.substr(m[0].length)));
		        return;
		    }
	
		    function error() {
		        if (window.console) {
		            if (window.console.error) {
		                window.console.error("Cannot load URL: %s", url);
		            } else {
		                window.console.log("Cannot load URL: %s", url);
		            }
		        }
		        cont(null);
		    }
		    var req = new XMLHttpRequest();
		    req.open('GET', url, true);
		    if (HAS_TYPED_ARRAYS) {
		        req.responseType = "arraybuffer";
		    }
		    req.onload = function() {
		        if (req.status == 200 || req.status == 304) {
		            if (HAS_TYPED_ARRAYS) {
		                cont(new Uint8Array(req.response));
		            } else {
		                cont(new window.VBArray(req.responseBody).toArray()); // IE9 only
		            }
		        } else {
		            error();
		        }
		    };
		    req.onerror = error;
		    req.send(null);
		}
	
		function loadFont(url, cont) {
		    var font = FONT_CACHE[url];
		    if (font) {
		        cont(font);
		    } else {
		        loadBinary(url, function(data){
		            if (data == null) {
		                throw new Error("Cannot load font from " + url);
		            } else {
		                var font = new TTFFont(data);
		                FONT_CACHE[url] = font;
		                cont(font);
		            }
		        });
		    }
		}
	
		var IMAGE_CACHE = {};
	
		function clearImageCache() {
		    IMAGE_CACHE = {};
		}
	
		function loadImage(url, size, cont) {
		    var img = IMAGE_CACHE[url], bloburl, blob;
		    if (img) {
		        cont(img);
		    } else {
		        img = new Image();
		        if (!(/^data:/i.test(url))) {
		            img.crossOrigin = "Anonymous";
		        }
		        if (HAS_TYPED_ARRAYS && !(/^data:/i.test(url))) {
		            // IE10 fails to load images from another domain even when the server sends the
		            // proper CORS headers.  a XHR, however, will be able to load the data.
		            // http://stackoverflow.com/a/19734516/154985
		            //
		            // On the other hand, it's worth doing it this way for all browsers which support
		            // responseType = "blob" (HAS_TYPED_ARRAYS will be true), because we can inspect the
		            // mime type and if it's a JPEG (very common case) we can save a lot of time in
		            // _load below.
		            var xhr = new XMLHttpRequest();
		            xhr.onload = function() {
		                blob = xhr.response;
		                bloburl = URL.createObjectURL(blob);
		                _load(bloburl);
		            };
		            xhr.onerror = _onerror;
		            xhr.open("GET", url, true);
		            xhr.responseType = "blob";
		            xhr.send();
		        } else {
		            _load(url);
		        }
		    }
	
		    function _load(url) {
		        img.src = url;
		        if (img.complete && !browser.msie) {
		            // IE, bless it's little heart, says img.complete == true even though the image is
		            // not loaded (width=0), therefore we must go the onload route (ticket 929635).
		            _onload();
		        } else {
		            img.onload = _onload;
		            img.onerror = _onerror;
		        }
		    }
	
		    function _trycanvas() {
		        if (!size) {
		            size = { width: img.width, height: img.height };
		        }
	
		        var canvas = document.createElement("canvas");
		        canvas.width = size.width;
		        canvas.height = size.height;
	
		        var ctx = canvas.getContext("2d");
		        ctx.drawImage(img, 0, 0, size.width, size.height);
	
		        var imgdata;
		        try {
		            imgdata = ctx.getImageData(0, 0, size.width, size.height);
		        } catch (ex) {
		            // it tainted the canvas -- can't draw it.
		            _onerror();
		            return;
		        } finally {
		            if (bloburl) {
		                URL.revokeObjectURL(bloburl);
		            }
		        }
	
		        // in case it contains transparency, we must separate rgb data from the alpha
		        // channel and create a PDFRawImage image with opacity.  otherwise we can use a
		        // PDFJpegImage.
		        //
		        // to do this in one step, we create the rgb and alpha streams anyway, even if
		        // we might end up not using them if hasAlpha remains false.
	
		        var hasAlpha = false, rgb = BinaryStream(), alpha = BinaryStream();
		        var rawbytes = imgdata.data;
		        var i = 0;
		        while (i < rawbytes.length) {
		            rgb.writeByte(rawbytes[i++]);
		            rgb.writeByte(rawbytes[i++]);
		            rgb.writeByte(rawbytes[i++]);
		            var a = rawbytes[i++];
		            if (a < 255) {
		                hasAlpha = true;
		            }
		            alpha.writeByte(a);
		        }
	
		        if (hasAlpha) {
		            img = new PDFRawImage(size.width, size.height, rgb, alpha);
		        } else {
		            // no transparency, encode as JPEG.
		            var data = canvas.toDataURL("image/jpeg");
		            data = data.substr(data.indexOf(";base64,") + 8);
	
		            var stream = BinaryStream();
		            stream.writeBase64(data);
		            img = new PDFJpegImage(stream);
		        }
	
		        cont(IMAGE_CACHE[url] = img);
		    }
	
		    function _onerror() {
		        cont(IMAGE_CACHE[url] = "ERROR");
		    }
	
		    function _onload() {
		        if (size) {
		            // but if requested size is bigger than the image, just use the original image.
		            if (size.width >= img.width || size.height >= img.height) {
		                size = null;
		            }
		        }
		        if (!size && blob && /^image\/jpe?g$/i.test(blob.type)) {
		            // If we know we got a JPEG, we can skip the process of rendering it to a
		            // canvas, getting the pixel data, searching for transparency we know we won't
		            // find, getting back a data URI and then decoding the BASE64 to finally get the
		            // binary we already have.  Also, we avoid downgrading the image quality, with
		            // the possible drawback of making a bigger PDF; still, seems legit.
		            //
		            // Besides saving a lot of work, this also reuses the buffer memory
		            // (BinaryStream does not create a copy), potentially saving some GC cycles.
		            var reader = new FileReader();
		            reader.onload = function() {
		                try {
		                    var img = new PDFJpegImage(BinaryStream(new Uint8Array(this.result)));
		                    URL.revokeObjectURL(bloburl);
		                    cont(IMAGE_CACHE[url] = img);
		                } catch (ex) {
		                    // if there's an error parsing the JPEG stream, it could be due to a
		                    // misconfigured server (improper content-type:
		                    // https://github.com/telerik/kendo-ui-core/issues/4184).  If that's the case,
		                    // the canvas will still be able to draw it.
		                    _trycanvas();
		                }
		            };
		            reader.readAsArrayBuffer(blob);
		        } else {
		            _trycanvas();
		        }
		    }
		}
	
		function manyLoader(loadOne) {
		    return function(urls, callback) {
		        var n = urls.length, i = n;
		        if (n === 0) {
		            return callback();
		        }
		        function next() {
		            if (--n === 0) {
		                callback();
		            }
		        }
		        while (i-- > 0) {
		            loadOne(urls[i], next);
		        }
		    };
		}
	
		var loadFonts = manyLoader(loadFont);
		var loadImages = function(images, callback) {
		    var urls = Object.keys(images), n = urls.length;
		    if (n === 0) {
		        return callback();
		    }
		    function next() {
		        if (--n === 0) {
		            callback();
		        }
		    }
		    urls.forEach(function(url){
		        loadImage(url, images[url], next);
		    });
		};
	
		PDFDocument.prototype = {
		    loadFonts: loadFonts,
		    loadImages: loadImages,
	
		    getFont: function(url) {
		        var font = this.FONTS[url];
		        if (!font) {
		            font = FONT_CACHE[url];
		            if (!font) {
		                throw new Error("Font " + url + " has not been loaded");
		            }
		            if (font === true) {
		                font = this.attach(new PDFStandardFont(url));
		            } else {
		                font = this.attach(new PDFFont(this, font));
		            }
		            this.FONTS[url] = font;
		        }
		        return font;
		    },
	
		    getImage: function(url) {
		        var img = this.IMAGES[url];
		        if (!img) {
		            img = IMAGE_CACHE[url];
		            if (!img) {
		                throw new Error("Image " + url + " has not been loaded");
		            }
		            if (img === "ERROR") {
		                return null;
		            }
		            img = this.IMAGES[url] = this.attach(img.asStream(this));
		        }
		        return img;
		    },
	
		    getOpacityGS: function(opacity, forStroke) {
		        var id = parseFloat(opacity).toFixed(3);
		        opacity = parseFloat(id);
		        id += forStroke ? "S" : "F";
		        var cache = this._opacityGSCache || (this._opacityGSCache = {});
		        var gs = cache[id];
		        if (!gs) {
		            var props = {
		                Type: _("ExtGState")
		            };
		            if (forStroke) {
		                props.CA = opacity;
		            } else {
		                props.ca = opacity;
		            }
		            gs = this.attach(new PDFDictionary(props));
		            gs._resourceName = _("GS" + (++RESOURCE_COUNTER));
		            cache[id] = gs;
		        }
		        return gs;
		    },
	
		    dict: function(props) {
		        return new PDFDictionary(props);
		    },
	
		    name: function(str) {
		        return _(str);
		    },
	
		    stream: function(props, content) {
		        return new PDFStream(content, props);
		    }
		};
	
		/* -----[ utils ]----- */
	
		function pad(str, len, ch) {
		    while (str.length < len) {
		        str = ch + str;
		    }
		    return str;
		}
	
		function zeropad(n, len) {
		    return pad(String(n), len, "0");
		}
	
		function hasOwnProperty(obj, key) {
		    return Object.prototype.hasOwnProperty.call(obj, key);
		}
	
		var isArray = Array.isArray || function(obj) {
		    return obj instanceof Array;
		};
	
		function isDate(obj) {
		    return obj instanceof Date;
		}
	
		function renderArray(a, out) {
		    out("[");
		    if (a.length > 0) {
		        out.withIndent(function(){
		            for (var i = 0; i < a.length; ++i) {
		                if (i > 0 && i % 8 === 0) {
		                    out.indent(a[i]);
		                } else {
		                    out(" ", a[i]);
		                }
		            }
		        });
		        //out.indent();
		    }
		    out(" ]");
		}
	
		function renderDate(date, out) {
		    out("(D:",
		        zeropad(date.getUTCFullYear(), 4),
		        zeropad(date.getUTCMonth() + 1, 2),
		        zeropad(date.getUTCDate(), 2),
		        zeropad(date.getUTCHours(), 2),
		        zeropad(date.getUTCMinutes(), 2),
		        zeropad(date.getUTCSeconds(), 2),
		        "Z)");
		}
	
		function mm2pt(mm) {
		    return mm * (72/25.4);
		}
	
		function cm2pt(cm) {
		    return mm2pt(cm * 10);
		}
	
		function in2pt(inch)  {
		    return inch * 72;
		}
	
		function unitsToPoints(x, def) {
		    if (typeof x == "number") {
		        return x;
		    }
		    if (typeof x == "string") {
		        var m;
		        m = /^\s*([0-9.]+)\s*(mm|cm|in|pt)\s*$/.exec(x);
		        if (m) {
		            var num = parseFloat(m[1]);
		            if (!isNaN(num)) {
		                if (m[2] == "pt") {
		                    return num;
		                }
		                return {
		                    "mm": mm2pt,
		                    "cm": cm2pt,
		                    "in": in2pt
		                }[m[2]](num);
		            }
		        }
		    }
		    if (def != null) {
		        return def;
		    }
		    throw new Error("Can't parse unit: " + x);
		}
	
		/* -----[ PDF basic objects ]----- */
	
		function PDFValue(){}
	
		PDFValue.prototype.beforeRender = function(){};
	
		function defclass(Ctor, proto, Base) {
		    if (!Base) {
		        Base = PDFValue;
		    }
		    Ctor.prototype = new Base();
		    for (var i in proto) {
		        if (hasOwnProperty(proto, i)) {
		            Ctor.prototype[i] = proto[i];
		        }
		    }
		    return Ctor;
		}
	
		/// strings
	
		var PDFString = defclass(function PDFString(value){
		    this.value = value;
		}, {
		    render: function(out) {
		        var txt = "", val = this.value;
		        for (var i = 0; i < val.length; ++i) {
		            txt += String.fromCharCode(val.charCodeAt(i) & 0xFF);
		        }
		        out("(", txt.replace(/([\(\)\\])/g, "\\$1"), ")");
		    },
		    toString: function() {
		        return this.value;
		    }
		});
	
		var PDFHexString = defclass(function PDFHexString(value){
		    this.value = value;
		}, {
		    render: function(out) {
		        var this$1 = this;
	
		        out("<");
		        for (var i = 0; i < this.value.length; ++i) {
		            out(zeropad(this$1.value.charCodeAt(i).toString(16), 4));
		        }
		        out(">");
		    }
		}, PDFString);
	
		/// names
	
		var PDFName = defclass(function PDFName(name) {
		    this.name = name;
		}, {
		    render: function(out) {
		        out("/" + this.escape());
		    },
		    escape: function() {
		        return this.name.replace(/[^\x21-\x7E]/g, function(c){
		            return "#" + zeropad(c.charCodeAt(0).toString(16), 2);
		        });
		    },
		    toString: function() {
		        return this.name;
		    }
		});
	
		var PDFName_cache = {};
		PDFName.get = _;
	
		function _(name) {
		    if (hasOwnProperty(PDFName_cache, name)) {
		        return PDFName_cache[name];
		    }
		    return (PDFName_cache[name] = new PDFName(name));
		}
	
		/// dictionary
	
		var PDFDictionary = defclass(function PDFDictionary(props) {
		    this.props = props;
		}, {
		    render: function(out) {
		        var props = this.props, empty = true;
		        out("<<");
		        out.withIndent(function(){
		            for (var i in props) {
		                if (hasOwnProperty(props, i) && !/^_/.test(i)) {
		                    empty = false;
		                    out.indent(_(i), " ", props[i]);
		                }
		            }
		        });
		        if (!empty) {
		            out.indent();
		        }
		        out(">>");
		    }
		});
	
		/// streams
	
		var PDFStream = defclass(function PDFStream(data, props, compress) {
		    if (typeof data == "string") {
		        var tmp = BinaryStream();
		        tmp.write(data);
		        data = tmp;
		    }
		    this.data = data;
		    this.props = props || {};
		    this.compress = compress;
		}, {
		    render: function(out) {
		        var data = this.data.get(), props = this.props;
		        if (this.compress && kendoPdf.supportsDeflate()) {
		            if (!props.Filter) {
		                props.Filter = [];
		            } else if (!(props.Filter instanceof Array)) {
		                props.Filter = [ props.Filter ];
		            }
		            props.Filter.unshift(_("FlateDecode"));
		            data = kendoPdf.deflate(data);
		        }
		        props.Length = data.length;
		        out(new PDFDictionary(props), " stream", NL);
		        out.writeData(data);
		        out(NL, "endstream");
		    }
		});
	
		/// catalog
	
		var PDFCatalog = defclass(function PDFCatalog(){
		    this.props = {
		        Type: _("Catalog")
		    };
		}, {
		    setPages: function(pagesObj) {
		        this.props.Pages = pagesObj;
		    }
		}, PDFDictionary);
	
		/// page tree
	
		var PDFPageTree = defclass(function PDFPageTree(){
		    this.props = {
		        Type  : _("Pages"),
		        Kids  : [],
		        Count : 0
		    };
		}, {
		    addPage: function(pageObj) {
		        this.props.Kids.push(pageObj);
		        this.props.Count++;
		    }
		}, PDFDictionary);
	
		/// images
	
		// JPEG
	
		var SOF_CODES = [0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf];
	
		function PDFJpegImage(data) {
		    // we must determine the correct color space.  we'll parse a bit
		    // of the JPEG stream for this, it's still better than going
		    // through the canvas.
		    // https://github.com/telerik/kendo-ui-core/issues/2845
		    data.offset(0);
		    var width, height, colorSpace, bitsPerComponent;
		    var soi = data.readShort();
		    if (soi != 0xFFD8) {
		        // XXX: do we have some better options here?
		        throw new Error("Invalid JPEG image");
		    }
		    while (!data.eof()) {
		        var ff = data.readByte();
		        if (ff != 0xFF) {
		            throw new Error("Invalid JPEG image");
		        }
		        var marker = data.readByte();
		        var length = data.readShort();
		        if (SOF_CODES.indexOf(marker) >= 0) {
		            // "start of frame" marker
		            bitsPerComponent = data.readByte();
		            height = data.readShort();
		            width = data.readShort();
		            colorSpace = data.readByte();
		            break;
		        }
		        data.skip(length - 2);
		    }
	
		    if (colorSpace == null) {
		        throw new Error("Invalid JPEG image");
		    }
	
		    var props = {
		        Type             : _("XObject"),
		        Subtype          : _("Image"),
		        Width            : width,
		        Height           : height,
		        BitsPerComponent : bitsPerComponent,
		        Filter           : _("DCTDecode")
		    };
	
		    switch (colorSpace) {
		      case 1:
		        props.ColorSpace = _("DeviceGray");
		        break;
		      case 3:
		        props.ColorSpace = _("DeviceRGB");
		        break;
		      case 4:
		        props.ColorSpace = _("DeviceCMYK");
		        props.Decode = [ 1, 0, 1, 0, 1, 0, 1, 0 ]; // invert colors
		        break;
		    }
	
		    this.asStream = function() {
		        data.offset(0);
		        var stream = new PDFStream(data, props);
		        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
		        return stream;
		    };
		}
	
		// PDFRawImage will be used for images with transparency (PNG)
	
		function PDFRawImage(width, height, rgb, alpha) {
		    this.asStream = function(pdf) {
		        var mask = new PDFStream(alpha, {
		            Type             : _("XObject"),
		            Subtype          : _("Image"),
		            Width            : width,
		            Height           : height,
		            BitsPerComponent : 8,
		            ColorSpace       : _("DeviceGray")
		        }, true);
		        var stream = new PDFStream(rgb, {
		            Type             : _("XObject"),
		            Subtype          : _("Image"),
		            Width            : width,
		            Height           : height,
		            BitsPerComponent : 8,
		            ColorSpace       : _("DeviceRGB"),
		            SMask            : pdf.attach(mask)
		        }, true);
		        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
		        return stream;
		    };
		}
	
		/// standard fonts
	
		var PDFStandardFont = defclass(function PDFStandardFont(name){
		    this.props = {
		        Type     : _("Font"),
		        Subtype  : _("Type1"),
		        BaseFont : _(name)
		    };
		    this._resourceName = _("F" + (++RESOURCE_COUNTER));
		}, {
		    encodeText: function(str) {
		        return new PDFString(String(str));
		    }
		}, PDFDictionary);
	
		/// TTF fonts
	
		var PDFFont = defclass(function PDFFont(pdf, font, props){
		    props = this.props = props || {};
		    props.Type = _("Font");
		    props.Subtype = _("Type0");
		    props.Encoding = _("Identity-H");
	
		    this._pdf = pdf;
		    this._font = font;
		    this._sub = font.makeSubset();
		    this._resourceName = _("F" + (++RESOURCE_COUNTER));
	
		    var head = font.head;
	
		    this.name = font.psName;
		    var scale = this.scale = font.scale;
		    this.bbox = [
		        head.xMin * scale,
		        head.yMin * scale,
		        head.xMax * scale,
		        head.yMax * scale
		    ];
	
		    this.italicAngle = font.post.italicAngle;
		    this.ascent = font.ascent * scale;
		    this.descent = font.descent * scale;
		    this.lineGap = font.lineGap * scale;
		    this.capHeight = font.os2.capHeight || this.ascent;
		    this.xHeight = font.os2.xHeight || 0;
		    this.stemV = 0;
	
		    this.familyClass = (font.os2.familyClass || 0) >> 8;
		    this.isSerif = this.familyClass >= 1 && this.familyClass <= 7;
		    this.isScript = this.familyClass == 10;
	
		    this.flags = ((font.post.isFixedPitch ? 1 : 0) |
		                  (this.isSerif ? 1 << 1 : 0) |
		                  (this.isScript ? 1 << 3 : 0) |
		                  (this.italicAngle !== 0 ? 1 << 6 : 0) |
		                  (1 << 5));
		}, {
		    encodeText: function(text) {
		        return new PDFHexString(this._sub.encodeText(String(text)));
		    },
		    getTextWidth: function(fontSize, text) {
		        var this$1 = this;
	
		        var width = 0, codeMap = this._font.cmap.codeMap;
		        for (var i = 0; i < text.length; ++i) {
		            var glyphId = codeMap[text.charCodeAt(i)];
		            width += this$1._font.widthOfGlyph(glyphId || 0);
		        }
		        return width * fontSize / 1000;
		    },
		    beforeRender: function() {
		        var self = this;
		        var sub = self._sub;
	
		        // write the TTF data
		        var data = sub.render();
		        var fontStream = new PDFStream(BinaryStream(data), {
		            Length1: data.length
		        }, true);
	
		        var descriptor = self._pdf.attach(new PDFDictionary({
		            Type         : _("FontDescriptor"),
		            FontName     : _(self._sub.psName),
		            FontBBox     : self.bbox,
		            Flags        : self.flags,
		            StemV        : self.stemV,
		            ItalicAngle  : self.italicAngle,
		            Ascent       : self.ascent,
		            Descent      : self.descent,
		            CapHeight    : self.capHeight,
		            XHeight      : self.xHeight,
		            FontFile2    : self._pdf.attach(fontStream)
		        }));
	
		        var cmap = sub.ncid2ogid;
		        var firstChar = sub.firstChar;
		        var lastChar = sub.lastChar;
		        var charWidths = [];
		        (function loop(i, chunk){
		            if (i <= lastChar) {
		                var gid = cmap[i];
		                if (gid == null) {
		                    loop(i + 1);
		                } else {
		                    if (!chunk) {
		                        charWidths.push(i, chunk = []);
		                    }
		                    chunk.push(self._font.widthOfGlyph(gid));
		                    loop(i + 1, chunk);
		                }
		            }
		        })(firstChar);
	
		        // As if two dictionaries weren't enough, we need another
		        // one, the "descendant font".  Only that one can be of
		        // Subtype CIDFontType2.  PDF is the X11 of document
		        // formats: portable but full of legacy that nobody cares
		        // about anymore.
	
		        var descendant = new PDFDictionary({
		            Type: _("Font"),
		            Subtype: _("CIDFontType2"),
		            BaseFont: _(self._sub.psName),
		            CIDSystemInfo: new PDFDictionary({
		                Registry   : new PDFString("Adobe"),
		                Ordering   : new PDFString("Identity"),
		                Supplement : 0
		            }),
		            FontDescriptor: descriptor,
		            FirstChar: firstChar,
		            LastChar: lastChar,
		            DW: Math.round(self._font.widthOfGlyph(0)),
		            W: charWidths,
		            CIDToGIDMap: self._pdf.attach(self._makeCidToGidMap())
		        });
	
		        var dict = self.props;
		        dict.BaseFont = _(self._sub.psName);
		        dict.DescendantFonts = [ self._pdf.attach(descendant) ];
	
		        // Compute the ToUnicode map so that apps can extract
		        // meaningful text from the PDF.
		        var unimap = new PDFToUnicodeCmap(firstChar, lastChar, sub.subset);
		        var unimapStream = new PDFStream(makeOutput(), null, true);
		        unimapStream.data(unimap);
		        dict.ToUnicode = self._pdf.attach(unimapStream);
		    },
		    _makeCidToGidMap: function() {
		        return new PDFStream(BinaryStream(this._sub.cidToGidMap()), null, true);
		    }
		}, PDFDictionary);
	
		var PDFToUnicodeCmap = defclass(function PDFUnicodeCMap(firstChar, lastChar, map){
		    this.firstChar = firstChar;
		    this.lastChar = lastChar;
		    this.map = map;
		}, {
		    render: function(out) {
		        out.indent("/CIDInit /ProcSet findresource begin");
		        out.indent("12 dict begin");
		        out.indent("begincmap");
		        out.indent("/CIDSystemInfo <<");
		        out.indent("  /Registry (Adobe)");
		        out.indent("  /Ordering (UCS)");
		        out.indent("  /Supplement 0");
		        out.indent(">> def");
		        out.indent("/CMapName /Adobe-Identity-UCS def");
		        out.indent("/CMapType 2 def");
		        out.indent("1 begincodespacerange");
		        out.indent("  <0000><ffff>");
		        out.indent("endcodespacerange");
	
		        var self = this;
		        out.indent(self.lastChar - self.firstChar + 1, " beginbfchar");
		        out.withIndent(function(){
		            for (var code = self.firstChar; code <= self.lastChar; ++code) {
		                var unicode = self.map[code];
		                var str = ucs2encode([ unicode ]);
		                out.indent("<", zeropad(code.toString(16), 4), ">", "<");
		                for (var i = 0; i < str.length; ++i) {
		                    out(zeropad(str.charCodeAt(i).toString(16), 4));
		                }
		                out(">");
		            }
		        });
		        out.indent("endbfchar");
	
		        out.indent("endcmap");
		        out.indent("CMapName currentdict /CMap defineresource pop");
		        out.indent("end");
		        out.indent("end");
		    }
		});
	
		/// gradients
	
		function makeHash(a) {
		    return a.map(function(x){
		        return isArray(x) ? makeHash(x)
		            : typeof x == "number" ? (Math.round(x * 1000) / 1000).toFixed(3)
		            : x;
		    }).join(" ");
		}
	
		function cacheColorGradientFunction(pdf, r1, g1, b1, r2, g2, b2) {
		    var hash = makeHash([ r1, g1, b1, r2, g2, b2 ]);
		    var func = pdf.GRAD_COL_FUNCTIONS[hash];
		    if (!func) {
		        func = pdf.GRAD_COL_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
		            FunctionType: 2,
		            Domain: [ 0, 1 ],
		            Range: [ 0, 1, 0, 1, 0, 1 ],
		            N: 1,
		            C0: [ r1 , g1 , b1 ],
		            C1: [ r2 , g2 , b2 ]
		        }));
		    }
		    return func;
		}
	
		function cacheOpacityGradientFunction(pdf, a1, a2) {
		    var hash = makeHash([ a1, a2 ]);
		    var func = pdf.GRAD_OPC_FUNCTIONS[hash];
		    if (!func) {
		        func = pdf.GRAD_OPC_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
		            FunctionType: 2,
		            Domain: [ 0, 1 ],
		            Range: [ 0, 1 ],
		            N: 1,
		            C0: [ a1 ],
		            C1: [ a2 ]
		        }));
		    }
		    return func;
		}
	
		function makeGradientFunctions(pdf, stops) {
		    var hasAlpha = false;
		    var opacities = [];
		    var colors = [];
		    var offsets = [];
		    var encode = [];
		    var i, prev, cur, prevColor, curColor;
		    for (i = 1; i < stops.length; ++i) {
		        prev = stops[i - 1];
		        cur = stops[i];
		        prevColor = prev.color;
		        curColor = cur.color;
		        colors.push(cacheColorGradientFunction(
		            pdf,
		            prevColor.r, prevColor.g, prevColor.b,
		            curColor.r,  curColor.g,  curColor.b
		        ));
		        if (prevColor.a < 1 || curColor.a < 1) {
		            hasAlpha = true;
		        }
		        offsets.push(cur.offset);
		        encode.push(0, 1);
		    }
		    if (hasAlpha) {
		        for (i = 1; i < stops.length; ++i) {
		            prev = stops[i - 1];
		            cur = stops[i];
		            prevColor = prev.color;
		            curColor = cur.color;
		            opacities.push(cacheOpacityGradientFunction(
		                pdf, prevColor.a, curColor.a
		            ));
		        }
		    }
		    offsets.pop();
		    return {
		        hasAlpha  : hasAlpha,
		        colors    : assemble(colors),
		        opacities : hasAlpha ? assemble(opacities) : null
		    };
		    function assemble(funcs) {
		        if (funcs.length == 1) {
		            return funcs[0];
		        }
		        return {
		            FunctionType: 3,
		            Functions: funcs,
		            Domain: [ 0, 1 ],
		            Bounds: offsets,
		            Encode: encode
		        };
		    }
		}
	
		function cacheColorGradient(pdf, isRadial, stops, coords, funcs, box) {
		    var shading, hash;
		    // if box is given then we have user-space coordinates, which
		    // means the gradient is designed for a certain position/size
		    // on page.  caching won't do any good.
		    if (!box) {
		        var a = [ isRadial ].concat(coords);
		        stops.forEach(function(x){
		            a.push(x.offset, x.color.r, x.color.g, x.color.b);
		        });
		        hash = makeHash(a);
		        shading = pdf.GRAD_COL[hash];
		    }
		    if (!shading) {
		        shading = new PDFDictionary({
		            Type: _("Shading"),
		            ShadingType: isRadial ? 3 : 2,
		            ColorSpace: _("DeviceRGB"),
		            Coords: coords,
		            Domain: [ 0, 1 ],
		            Function: funcs,
		            Extend: [ true, true ]
		        });
		        pdf.attach(shading);
		        shading._resourceName = "S" + (++RESOURCE_COUNTER);
		        if (hash) {
		            pdf.GRAD_COL[hash] = shading;
		        }
		    }
		    return shading;
		}
	
		function cacheOpacityGradient(pdf, isRadial, stops, coords, funcs, box) {
		    var opacity, hash;
		    // if box is given then we have user-space coordinates, which
		    // means the gradient is designed for a certain position/size
		    // on page.  caching won't do any good.
		    if (!box) {
		        var a = [ isRadial ].concat(coords);
		        stops.forEach(function(x){
		            a.push(x.offset, x.color.a);
		        });
		        hash = makeHash(a);
		        opacity = pdf.GRAD_OPC[hash];
		    }
		    if (!opacity) {
		        opacity = new PDFDictionary({
		            Type: _("ExtGState"),
		            AIS: false,
		            CA: 1,
		            ca: 1,
		            SMask: {
		                Type: _("Mask"),
		                S: _("Luminosity"),
		                G: pdf.attach(new PDFStream("/a0 gs /s0 sh", {
		                    Type: _("XObject"),
		                    Subtype: _("Form"),
		                    FormType: 1,
		                    BBox: (box ? [
		                        box.left, box.top + box.height, box.left + box.width, box.top
		                    ] : [ 0, 1, 1, 0 ]),
		                    Group: {
		                        Type: _("Group"),
		                        S: _("Transparency"),
		                        CS: _("DeviceGray"),
		                        I: true
		                    },
		                    Resources: {
		                        ExtGState: {
		                            a0: { CA: 1, ca: 1 }
		                        },
		                        Shading: {
		                            s0: {
		                                ColorSpace: _("DeviceGray"),
		                                Coords: coords,
		                                Domain: [ 0, 1 ],
		                                ShadingType: isRadial ? 3 : 2,
		                                Function: funcs,
		                                Extend: [ true, true ]
		                            }
		                        }
		                    }
		                }))
		            }
		        });
		        pdf.attach(opacity);
		        opacity._resourceName = "O" + (++RESOURCE_COUNTER);
		        if (hash) {
		            pdf.GRAD_OPC[hash] = opacity;
		        }
		    }
		    return opacity;
		}
	
		function cacheGradient(pdf, gradient, box) {
		    var isRadial = gradient.type == "radial";
		    var funcs = makeGradientFunctions(pdf, gradient.stops);
		    var coords = isRadial ? [
		        gradient.start.x , gradient.start.y , gradient.start.r,
		        gradient.end.x   , gradient.end.y   , gradient.end.r
		    ] : [
		        gradient.start.x , gradient.start.y,
		        gradient.end.x   , gradient.end.y
		    ];
		    var shading = cacheColorGradient(
		        pdf, isRadial, gradient.stops, coords, funcs.colors, gradient.userSpace && box
		    );
		    var opacity = funcs.hasAlpha ? cacheOpacityGradient(
		        pdf, isRadial, gradient.stops, coords, funcs.opacities, gradient.userSpace && box
		    ) : null;
		    return {
		        hasAlpha: funcs.hasAlpha,
		        shading: shading,
		        opacity: opacity
		    };
		}
	
		/// page object
	
		var PDFPage = defclass(function PDFPage(pdf, props){
		    this._pdf = pdf;
		    this._rcount = 0;
		    this._textMode = false;
		    this._fontResources = {};
		    this._gsResources = {};
		    this._xResources = {};
		    this._patResources = {};
		    this._shResources = {};
		    this._opacity = 1;
		    this._matrix = [ 1, 0, 0, 1, 0, 0 ];
		    this._annotations = [];
	
		    this._font = null;
		    this._fontSize = null;
	
		    this._contextStack = [];
	
		    props = this.props = props || {};
		    props.Type = _("Page");
		    props.ProcSet = [
		        _("PDF"),
		        _("Text"),
		        _("ImageB"),
		        _("ImageC"),
		        _("ImageI")
		    ];
		    props.Resources = new PDFDictionary({
		        Font      : new PDFDictionary(this._fontResources),
		        ExtGState : new PDFDictionary(this._gsResources),
		        XObject   : new PDFDictionary(this._xResources),
		        Pattern   : new PDFDictionary(this._patResources),
		        Shading   : new PDFDictionary(this._shResources)
		    });
		    props.Annots = this._annotations;
		}, {
		    _out: function() {
		        this._content.data.apply(null, arguments);
		    },
		    transform: function(a, b, c, d, e, f) {
		        if (!isIdentityMatrix(arguments)) {
		            this._matrix = mmul(arguments, this._matrix);
		            this._out(a, " ", b, " ", c, " ", d, " ", e, " ", f, " cm");
		            // XXX: debug
		            // this._out(" % current matrix: ", this._matrix);
		            this._out(NL);
		        }
		    },
		    translate: function(dx, dy) {
		        this.transform(1, 0, 0, 1, dx, dy);
		    },
		    scale: function(sx, sy) {
		        this.transform(sx, 0, 0, sy, 0, 0);
		    },
		    rotate: function(angle) {
		        var cos = Math.cos(angle), sin = Math.sin(angle);
		        this.transform(cos, sin, -sin, cos, 0, 0);
		    },
		    beginText: function() {
		        this._textMode = true;
		        this._out("BT", NL);
		    },
		    endText: function() {
		        this._textMode = false;
		        this._out("ET", NL);
		    },
		    _requireTextMode: function() {
		        if (!this._textMode) {
		            throw new Error("Text mode required; call page.beginText() first");
		        }
		    },
		    _requireFont: function() {
		        if (!this._font) {
		            throw new Error("No font selected; call page.setFont() first");
		        }
		    },
		    setFont: function(font, size) {
		        this._requireTextMode();
		        if (font == null) {
		            font = this._font;
		        } else if (!(font instanceof PDFFont)) {
		            font = this._pdf.getFont(font);
		        }
		        if (size == null) {
		            size = this._fontSize;
		        }
		        this._fontResources[font._resourceName] = font;
		        this._font = font;
		        this._fontSize = size;
		        this._out(font._resourceName, " ", size, " Tf", NL);
		    },
		    setTextLeading: function(size) {
		        this._requireTextMode();
		        this._out(size, " TL", NL);
		    },
		    setTextRenderingMode: function(mode) {
		        this._requireTextMode();
		        this._out(mode, " Tr", NL);
		    },
		    showText: function(text, requestedWidth) {
		        this._requireFont();
		        if (text.length > 1 && requestedWidth && this._font instanceof PDFFont) {
		            var outputWidth = this._font.getTextWidth(this._fontSize, text);
		            var scale = requestedWidth / outputWidth * 100;
		            this._out(scale, " Tz ");
		        }
		        this._out(this._font.encodeText(text), " Tj", NL);
		    },
		    showTextNL: function(text) {
		        this._requireFont();
		        this._out(this._font.encodeText(text), " '", NL);
		    },
		    addLink: function(uri, box) {
		        var ll = this._toPage({ x: box.left, y: box.bottom });
		        var ur = this._toPage({ x: box.right, y: box.top });
		        this._annotations.push(new PDFDictionary({
		            Type    : _("Annot"),
		            Subtype : _("Link"),
		            Rect    : [ ll.x, ll.y, ur.x, ur.y ],
		            Border  : [ 0, 0, 0 ],
		            A       : new PDFDictionary({
		                Type : _("Action"),
		                S    : _("URI"),
		                URI  : new PDFString(uri)
		            })
		        }));
		    },
		    setStrokeColor: function(r, g, b) {
		        this._out(r, " ", g, " ", b, " RG", NL);
		    },
		    setOpacity: function(opacity) {
		        this.setFillOpacity(opacity);
		        this.setStrokeOpacity(opacity);
		        this._opacity *= opacity;
		    },
		    setStrokeOpacity: function(opacity) {
		        if (opacity < 1) {
		            var gs = this._pdf.getOpacityGS(this._opacity * opacity, true);
		            this._gsResources[gs._resourceName] = gs;
		            this._out(gs._resourceName, " gs", NL);
		        }
		    },
		    setFillColor: function(r, g, b) {
		        this._out(r, " ", g, " ", b, " rg", NL);
		    },
		    setFillOpacity: function(opacity) {
		        if (opacity < 1) {
		            var gs = this._pdf.getOpacityGS(this._opacity * opacity, false);
		            this._gsResources[gs._resourceName] = gs;
		            this._out(gs._resourceName, " gs", NL);
		        }
		    },
		    gradient: function(gradient, box) {
		        this.save();
		        this.rect(box.left, box.top, box.width, box.height);
		        this.clip();
		        if (!gradient.userSpace) {
		            this.transform(box.width, 0, 0, box.height, box.left, box.top);
		        }
		        var g = cacheGradient(this._pdf, gradient, box);
		        var sname = g.shading._resourceName, oname;
		        this._shResources[sname] = g.shading;
		        if (g.hasAlpha) {
		            oname = g.opacity._resourceName;
		            this._gsResources[oname] = g.opacity;
		            this._out("/" + oname + " gs ");
		        }
		        this._out("/" + sname + " sh", NL);
		        this.restore();
		    },
		    setDashPattern: function(dashArray, dashPhase) {
		        this._out(dashArray, " ", dashPhase, " d", NL);
		    },
		    setLineWidth: function(width) {
		        this._out(width, " w", NL);
		    },
		    setLineCap: function(lineCap) {
		        this._out(lineCap, " J", NL);
		    },
		    setLineJoin: function(lineJoin) {
		        this._out(lineJoin, " j", NL);
		    },
		    setMitterLimit: function(mitterLimit) {
		        this._out(mitterLimit, " M", NL);
		    },
		    save: function() {
		        this._contextStack.push(this._context());
		        this._out("q", NL);
		    },
		    restore: function() {
		        this._out("Q", NL);
		        this._context(this._contextStack.pop());
		    },
	
		    // paths
		    moveTo: function(x, y) {
		        this._out(x, " ", y, " m", NL);
		    },
		    lineTo: function(x, y) {
		        this._out(x, " ", y, " l", NL);
		    },
		    bezier: function(x1, y1, x2, y2, x3, y3) {
		        this._out(x1, " ", y1, " ", x2, " ", y2, " ", x3, " ", y3, " c", NL);
		    },
		    bezier1: function(x1, y1, x3, y3) {
		        this._out(x1, " ", y1, " ", x3, " ", y3, " y", NL);
		    },
		    bezier2: function(x2, y2, x3, y3) {
		        this._out(x2, " ", y2, " ", x3, " ", y3, " v", NL);
		    },
		    close: function() {
		        this._out("h", NL);
		    },
		    rect: function(x, y, w, h) {
		        this._out(x, " ", y, " ", w, " ", h, " re", NL);
		    },
		    ellipse: function(x, y, rx, ry) {
		        function _X(v) { return x + v; }
		        function _Y(v) { return y + v; }
	
		        // how to get to the "magic number" is explained here:
		        // http://www.whizkidtech.redprince.net/bezier/circle/kappa/
		        var k = 0.5522847498307936;
	
		        this.moveTo(_X(0), _Y(ry));
		        this.bezier(
		            _X(rx * k) , _Y(ry),
		            _X(rx)     , _Y(ry * k),
		            _X(rx)     , _Y(0)
		        );
		        this.bezier(
		            _X(rx)     , _Y(-ry * k),
		            _X(rx * k) , _Y(-ry),
		            _X(0)      , _Y(-ry)
		        );
		        this.bezier(
		            _X(-rx * k) , _Y(-ry),
		            _X(-rx)     , _Y(-ry * k),
		            _X(-rx)     , _Y(0)
		        );
		        this.bezier(
		            _X(-rx)     , _Y(ry * k),
		            _X(-rx * k) , _Y(ry),
		            _X(0)       , _Y(ry)
		        );
		    },
		    circle: function(x, y, r) {
		        this.ellipse(x, y, r, r);
		    },
		    stroke: function() {
		        this._out("S", NL);
		    },
		    nop: function() {
		        this._out("n", NL);
		    },
		    clip: function() {
		        this._out("W n", NL);
		    },
		    clipStroke: function() {
		        this._out("W S", NL);
		    },
		    closeStroke: function() {
		        this._out("s", NL);
		    },
		    fill: function() {
		        this._out("f", NL);
		    },
		    fillStroke: function() {
		        this._out("B", NL);
		    },
		    drawImage: function(url) {
		        var img = this._pdf.getImage(url);
		        if (img) { // the result can be null for a cross-domain image
		            this._xResources[img._resourceName] = img;
		            this._out(img._resourceName, " Do", NL);
		        }
		    },
		    comment: function(txt) {
		        var self = this;
		        txt.split(/\r?\n/g).forEach(function(line){
		            self._out("% ", line, NL);
		        });
		    },
	
		    // internal
		    _context: function(val) {
		        if (val != null) {
		            this._opacity = val.opacity;
		            this._matrix = val.matrix;
		        } else {
		            return {
		                opacity: this._opacity,
		                matrix: this._matrix
		            };
		        }
		    },
	
		    _toPage: function(p) {
		        var m = this._matrix;
		        var a = m[0], b = m[1], c = m[2], d = m[3], e = m[4], f = m[5];
		        return {
		            x: a*p.x + c*p.y + e,
		            y: b*p.x + d*p.y + f
		        };
		    }
		}, PDFDictionary);
	
		function unquote(str) {
		    return str.replace(/^\s*(['"])(.*)\1\s*$/, "$2");
		}
	
		function parseFontDef(fontdef) {
		    // XXX: this is very crude for now and buggy.  Proper parsing is quite involved.
		    var rx = /^\s*((normal|italic)\s+)?((normal|small-caps)\s+)?((normal|bold|\d+)\s+)?(([0-9.]+)(px|pt))(\/(([0-9.]+)(px|pt)|normal))?\s+(.*?)\s*$/i;
		    var m = rx.exec(fontdef);
		    if (!m) {
		        return { fontSize: 12, fontFamily: "sans-serif" };
		    }
		    var fontSize = m[8] ? parseInt(m[8], 10) : 12;
		    return {
		        italic     : m[2] && m[2].toLowerCase() == "italic",
		        variant    : m[4],
		        bold       : m[6] && /bold|700/i.test(m[6]),
		        fontSize   : fontSize,
		        lineHeight : m[12] ? m[12] == "normal" ? fontSize : parseInt(m[12], 10) : null,
		        fontFamily : m[14].split(/\s*,\s*/g).map(unquote)
		    };
		}
	
		function getFontURL(style) {
		    function mkFamily(name) {
		        if (style.bold) {
		            name += "|bold";
		        }
		        if (style.italic) {
		            name += "|italic";
		        }
		        return name.toLowerCase();
		    }
		    var fontFamily = style.fontFamily;
		    var name, url;
		    if (fontFamily instanceof Array) {
		        for (var i = 0; i < fontFamily.length; ++i) {
		            name = mkFamily(fontFamily[i]);
		            url = FONT_MAPPINGS[name];
		            if (url) {
		                break;
		            }
		        }
		    } else {
		        url = FONT_MAPPINGS[fontFamily.toLowerCase()];
		    }
		    while (typeof url == "function") {
		        url = url();
		    }
		    if (!url) {
		        url = "Times-Roman";
		    }
		    return url;
		}
	
		var FONT_MAPPINGS = {
		    "serif"                    : "Times-Roman",
		    "serif|bold"               : "Times-Bold",
		    "serif|italic"             : "Times-Italic",
		    "serif|bold|italic"        : "Times-BoldItalic",
		    "sans-serif"               : "Helvetica",
		    "sans-serif|bold"          : "Helvetica-Bold",
		    "sans-serif|italic"        : "Helvetica-Oblique",
		    "sans-serif|bold|italic"   : "Helvetica-BoldOblique",
		    "monospace"                : "Courier",
		    "monospace|bold"           : "Courier-Bold",
		    "monospace|italic"         : "Courier-Oblique",
		    "monospace|bold|italic"    : "Courier-BoldOblique",
		    "zapfdingbats"             : "ZapfDingbats",
		    "zapfdingbats|bold"        : "ZapfDingbats",
		    "zapfdingbats|italic"      : "ZapfDingbats",
		    "zapfdingbats|bold|italic" : "ZapfDingbats"
		};
	
		function fontAlias(alias, name) {
		    alias = alias.toLowerCase();
		    FONT_MAPPINGS[alias] = function() {
		        return FONT_MAPPINGS[name];
		    };
		    FONT_MAPPINGS[alias + "|bold"] = function() {
		        return FONT_MAPPINGS[name + "|bold"];
		    };
		    FONT_MAPPINGS[alias + "|italic"] = function() {
		        return FONT_MAPPINGS[name + "|italic"];
		    };
		    FONT_MAPPINGS[alias + "|bold|italic"] = function() {
		        return FONT_MAPPINGS[name + "|bold|italic"];
		    };
		}
	
		// Let's define some common names to an appropriate replacement.
		// These are overridable via pdf.defineFont, should the user want to
		// include the proper versions.
	
		fontAlias("Times New Roman" , "serif");
		fontAlias("Courier New"     , "monospace");
		fontAlias("Arial"           , "sans-serif");
		fontAlias("Helvetica"       , "sans-serif");
		fontAlias("Verdana"         , "sans-serif");
		fontAlias("Tahoma"          , "sans-serif");
		fontAlias("Georgia"         , "sans-serif");
		fontAlias("Monaco"          , "monospace");
		fontAlias("Andale Mono"     , "monospace");
	
		function defineFont(name, url) {
		    if (arguments.length == 1) {
		        for (var i in name) {
		            if (hasOwnProperty(name, i)) {
		                defineFont(i, name[i]);
		            }
		        }
		    } else {
		        name = name.toLowerCase();
		        FONT_MAPPINGS[name] = url;
	
		        // special handling for DejaVu fonts: if they get defined,
		        // let them also replace the default families, for good
		        // Unicode support out of the box.
		        switch (name) {
		          case "dejavu sans"               : FONT_MAPPINGS["sans-serif"]              = url; break;
		          case "dejavu sans|bold"          : FONT_MAPPINGS["sans-serif|bold"]         = url; break;
		          case "dejavu sans|italic"        : FONT_MAPPINGS["sans-serif|italic"]       = url; break;
		          case "dejavu sans|bold|italic"   : FONT_MAPPINGS["sans-serif|bold|italic"]  = url; break;
		          case "dejavu serif"              : FONT_MAPPINGS["serif"]                   = url; break;
		          case "dejavu serif|bold"         : FONT_MAPPINGS["serif|bold"]              = url; break;
		          case "dejavu serif|italic"       : FONT_MAPPINGS["serif|italic"]            = url; break;
		          case "dejavu serif|bold|italic"  : FONT_MAPPINGS["serif|bold|italic"]       = url; break;
		          case "dejavu mono"               : FONT_MAPPINGS["monospace"]               = url; break;
		          case "dejavu mono|bold"          : FONT_MAPPINGS["monospace|bold"]          = url; break;
		          case "dejavu mono|italic"        : FONT_MAPPINGS["monospace|italic"]        = url; break;
		          case "dejavu mono|bold|italic"   : FONT_MAPPINGS["monospace|bold|italic"]   = url; break;
		        }
		    }
		}
	
		function mmul(a, b) {
		    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
		    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
		    return [
		        a1*a2 + b1*c2,          a1*b2 + b1*d2,
		        c1*a2 + d1*c2,          c1*b2 + d1*d2,
		        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
		    ];
		}
	
		function isIdentityMatrix(m) {
		    return m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0;
		}
	
		var TEXT_RENDERING_MODE = {
		    fill           : 0,
		    stroke         : 1,
		    fillAndStroke  : 2,
		    invisible      : 3,
		    fillAndClip    : 4,
		    strokeAndClip  : 5,
		    fillStrokeClip : 6,
		    clip           : 7
		};
	
		/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
		/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
		/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
		/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
		var TEXT_RENDERING_MODE$1 = TEXT_RENDERING_MODE;
	
		var DASH_PATTERNS = {
		    dash           : [ 4 ],
		    dashDot        : [ 4, 2, 1, 2 ],
		    dot            : [ 1, 2 ],
		    longDash       : [ 8, 2 ],
		    longDashDot    : [ 8, 2, 1, 2 ],
		    longDashDotDot : [ 8, 2, 1, 2, 1, 2 ],
		    solid          : []
		};
	
		var LINE_CAP = {
		    butt   : 0,
		    round  : 1,
		    square : 2
		};
	
		var LINE_JOIN = {
		    miter : 0,
		    round : 1,
		    bevel : 2
		};
	
		function render(group, callback) {
		    var fonts = [], images = {}, options = group.options;
	
		    function getOption(name, defval, hash) {
		        if (!hash) {
		            hash = options;
		        }
		        if (hash.pdf && hash.pdf[name] != null) {
		            return hash.pdf[name];
		        }
		        return defval;
		    }
	
		    var multiPage = getOption("multiPage");
		    var imgDPI = getOption("imgDPI");
	
		    if (imgDPI) {
		        clearImageCache();
		    }
	
		    group.traverse(function(element){
		        dispatch({
		            Image: function(element) {
		                var url = element.src();
		                if (imgDPI) {
		                    var box = element.bbox().size;
		                    var prev = images[url];
		                    box = {
		                        width: Math.ceil(box.width * imgDPI / 72),
		                        height: Math.ceil(box.height * imgDPI / 72)
		                    };
		                    if (prev) {
		                        box.width = Math.max(prev.width, box.width);
		                        box.height = Math.max(prev.height, box.height);
		                    }
		                    images[url] = box;
		                } else {
		                    images[url] = null;
		                }
		            },
		            Text: function(element) {
		                var style = parseFontDef(element.options.font);
		                var url = getFontURL(style);
		                if (fonts.indexOf(url) < 0) {
		                    fonts.push(url);
		                }
		            }
		        }, element);
		    });
	
		    function doIt() {
		        if (--count > 0) {
		            return;
		        }
	
		        var pdf = new (PDFDocument)({
		            producer  : getOption("producer"),
		            title     : getOption("title"),
		            author    : getOption("author"),
		            subject   : getOption("subject"),
		            keywords  : getOption("keywords"),
		            creator   : getOption("creator"),
		            date      : getOption("date"),
	
		            autoPrint : getOption("autoPrint")
		        });
	
		        function drawPage(group) {
		            var options = group.options;
	
		            var tmp = optimize(group);
		            var bbox = tmp.bbox;
		            group = tmp.root;
		            // var tmp, bbox;
	
		            var paperSize = getOption("paperSize", getOption("paperSize", "auto"), options), addMargin = false;
		            if (paperSize == "auto") {
		                if (bbox) {
		                    var size = bbox.getSize();
		                    paperSize = [ size.width, size.height ];
		                    addMargin = true;
		                    var origin = bbox.getOrigin();
		                    tmp = new drawing.Group();
		                    tmp.transform(new kendoGeometry.Matrix(1, 0, 0, 1, -origin.x, -origin.y));
		                    tmp.append(group);
		                    group = tmp;
		                }
		                else {
		                    paperSize = "A4";
		                }
		            }
	
		            var page;
		            page = pdf.addPage({
		                paperSize : paperSize,
		                margin    : getOption("margin", getOption("margin"), options),
		                addMargin : addMargin,
		                landscape : getOption("landscape", getOption("landscape", false), options)
		            });
		            drawElement(group, page, pdf);
		        }
	
		        if (multiPage) {
		            group.children.forEach(drawPage);
		        } else {
		            drawPage(group);
		        }
	
		        callback(pdf.render(), pdf);
		    }
	
		    var count = 2;
		    loadFonts(fonts, doIt);
		    loadImages(images, doIt);
		}
	
		function toDataURL(group, callback) {
		    render(group, function(data){
		        callback("data:application/pdf;base64," + data.base64());
		    });
		}
	
		function toBlob(group, callback) {
		    render(group, function(data){
		        callback(new window.Blob([ data.get() ], { type: "application/pdf" }));
		    });
		}
	
		function saveAs$1(group, filename, proxy, callback) {
		    // XXX: Safari has Blob, but does not support the download attribute
		    //      so we'd end up converting to dataURL and using the proxy anyway.
		    if (window.Blob && !supportBrowser.safari) {
		        toBlob(group, function(blob){
		            kendo.saveAs({ dataURI: blob, fileName: filename });
		            if (callback) {
		                callback(blob);
		            }
		        });
		    } else {
		        toDataURL(group, function(dataURL){
		            kendo.saveAs({ dataURI: dataURL, fileName: filename, proxyURL: proxy });
		            if (callback) {
		                callback(dataURL);
		            }
		        });
		    }
		}
	
		function dispatch(handlers, element) {
		    var handler = handlers[element.nodeType];
		    if (handler) {
		        return handler.call.apply(handler, arguments);
		    }
		    return element;
		}
	
		function drawElement(element, page, pdf) {
		    if (element.options._pdfDebug) {
		        page.comment("BEGIN: " + element.options._pdfDebug);
		    }
	
		    var transform = element.transform();
		    var opacity = element.opacity();
	
		    page.save();
	
		    if (opacity != null && opacity < 1) {
		        page.setOpacity(opacity);
		    }
	
		    setStrokeOptions(element, page, pdf);
		    setFillOptions(element, page, pdf);
	
		    if (transform) {
		        var m = transform.matrix();
		        page.transform(m.a, m.b, m.c, m.d, m.e, m.f);
		    }
	
		    setClipping(element, page, pdf);
	
		    dispatch({
		        Path      : drawPath,
		        MultiPath : drawMultiPath,
		        Circle    : drawCircle,
		        Arc       : drawArc,
		        Text      : drawText,
		        Image     : drawImage,
		        Group     : drawGroup,
		        Rect      : drawRect
		    }, element, page, pdf);
	
		    page.restore();
	
		    if (element.options._pdfDebug) {
		        page.comment("END: " + element.options._pdfDebug);
		    }
		}
	
		function setStrokeOptions(element, page) {
		    var stroke = element.stroke && element.stroke();
		    if (!stroke) {
		        return;
		    }
	
		    var color = stroke.color;
		    if (color) {
		        color = parseColor$1(color);
		        if (color == null) {
		            return; // no stroke
		        }
		        page.setStrokeColor(color.r, color.g, color.b);
		        if (color.a != 1) {
		            page.setStrokeOpacity(color.a);
		        }
		    }
	
		    var width = stroke.width;
		    if (width != null) {
		        if (width === 0) {
		            return; // no stroke
		        }
		        page.setLineWidth(width);
		    }
	
		    var dashType = stroke.dashType;
		    if (dashType) {
		        page.setDashPattern(DASH_PATTERNS[dashType], 0);
		    }
	
		    var lineCap = stroke.lineCap;
		    if (lineCap) {
		        page.setLineCap(LINE_CAP[lineCap]);
		    }
	
		    var lineJoin = stroke.lineJoin;
		    if (lineJoin) {
		        page.setLineJoin(LINE_JOIN[lineJoin]);
		    }
	
		    var opacity = stroke.opacity;
		    if (opacity != null) {
		        page.setStrokeOpacity(opacity);
		    }
		}
	
		function setFillOptions(element, page) {
		    var fill = element.fill && element.fill();
		    if (!fill) {
		        return;
		    }
	
		    if (fill instanceof drawing.Gradient) {
		        return;
		    }
	
		    var color = fill.color;
		    if (color) {
		        color = parseColor$1(color);
		        if (color == null) {
		            return; // no fill
		        }
		        page.setFillColor(color.r, color.g, color.b);
		        if (color.a != 1) {
		            page.setFillOpacity(color.a);
		        }
		    }
	
		    var opacity = fill.opacity;
		    if (opacity != null) {
		        page.setFillOpacity(opacity);
		    }
		}
	
		function setClipping(element, page, pdf) {
		    // XXX: only Path supported at the moment.
		    var clip = element.clip();
		    if (clip) {
		        _drawPath(clip, page, pdf);
		        page.clip();
		        // page.setStrokeColor(Math.random(), Math.random(), Math.random());
		        // page.setLineWidth(1);
		        // page.stroke();
		    }
		}
	
		function shouldDraw(thing) {
		    return (thing &&
		            (thing instanceof drawing.Gradient ||
		             (thing.color && !/^(none|transparent)$/i.test(thing.color) &&
		              (thing.width == null || thing.width > 0) &&
		              (thing.opacity == null || thing.opacity > 0))));
		}
	
		function maybeGradient(element, page, pdf, stroke) {
		    var fill = element.fill();
		    if (fill instanceof drawing.Gradient) {
		        if (stroke) {
		            page.clipStroke();
		        } else {
		            page.clip();
		        }
		        var isRadial = fill instanceof drawing.RadialGradient;
		        var start, end;
		        if (isRadial) {
		            start = { x: fill.center().x , y: fill.center().y , r: 0 };
		            end   = { x: fill.center().x , y: fill.center().y , r: fill.radius() };
		        } else {
		            start = { x: fill.start().x , y: fill.start().y };
		            end   = { x: fill.end().x   , y: fill.end().y   };
		        }
	
		        var stops = fill.stops.elements().map(function(stop){
		            var offset = stop.offset();
		            if (/%$/.test(offset)) {
		                offset = parseFloat(offset) / 100;
		            } else {
		                offset = parseFloat(offset);
		            }
		            var color = parseColor$1(stop.color());
		            color.a *= stop.opacity();
		            return {
		                offset: offset,
		                color: color
		            };
		        });
	
		        // Duplicats first and last stop to fix
		        // https://github.com/telerik/kendo-ui-core/issues/1782
		        stops.unshift(stops[0]);
		        stops.push(stops[stops.length - 1]);
	
		        var gradient = {
		            userSpace : fill.userSpace(),
		            type      : isRadial ? "radial" : "linear",
		            start     : start,
		            end       : end,
		            stops     : stops
		        };
		        var box = element.rawBBox();
		        var tl = box.topLeft(), size = box.getSize();
		        box = {
		            left   : tl.x,
		            top    : tl.y,
		            width  : size.width,
		            height : size.height
		        };
		        page.gradient(gradient, box);
		        return true;
		    }
		}
	
		function maybeFillStroke(element, page, pdf) {
		    if (shouldDraw(element.fill()) && shouldDraw(element.stroke())) {
		        if (!maybeGradient(element, page, pdf, true)) {
		            page.fillStroke();
		        }
		    } else if (shouldDraw(element.fill())) {
		        if (!maybeGradient(element, page, pdf, false)) {
		            page.fill();
		        }
		    } else if (shouldDraw(element.stroke())) {
		        page.stroke();
		    } else {
		        // we should not get here; the path should have been
		        // optimized away.  but let's be prepared.
		        page.nop();
		    }
		}
	
		function maybeDrawRect(path, page) {
		    var segments = path.segments;
		    if (segments.length == 4 && path.options.closed) {
		        // detect if this path looks like a rectangle parallel to the axis
		        var a = [];
		        for (var i = 0; i < segments.length; ++i) {
		            if (segments[i].controlIn()) { // has curve?
		                return false;
		            }
		            a[i] = segments[i].anchor();
		        }
		        // it's a rectangle if the y/x/y/x or x/y/x/y coords of
		        // consecutive points are the same.
		        var isRect = (
		            a[0].y == a[1].y && a[1].x == a[2].x && a[2].y == a[3].y && a[3].x == a[0].x
		        ) || (
		            a[0].x == a[1].x && a[1].y == a[2].y && a[2].x == a[3].x && a[3].y == a[0].y
		        );
		        if (isRect) {
		            // this saves a bunch of instructions in PDF:
		            // moveTo, lineTo, lineTo, lineTo, close -> rect.
		            page.rect(a[0].x, a[0].y,
		                      a[2].x - a[0].x /*width*/,
		                      a[2].y - a[0].y /*height*/);
		            return true;
		        }
		    }
		}
	
		function _drawPath(element, page, pdf) {
		    var segments = element.segments;
		    if (segments.length === 0) {
		        return;
		    }
		    if (!maybeDrawRect(element, page, pdf)) {
		        for (var prev, i = 0; i < segments.length; ++i) {
		            var seg = segments[i];
		            var anchor = seg.anchor();
		            if (!prev) {
		                page.moveTo(anchor.x, anchor.y);
		            } else {
		                var prevOut = prev.controlOut();
		                var controlIn = seg.controlIn();
		                if (prevOut && controlIn) {
		                    page.bezier(
		                        prevOut.x   , prevOut.y,
		                        controlIn.x , controlIn.y,
		                        anchor.x    , anchor.y
		                    );
		                } else {
		                    page.lineTo(anchor.x, anchor.y);
		                }
		            }
		            prev = seg;
		        }
		        if (element.options.closed) {
		            page.close();
		        }
		    }
		}
	
		function drawPath(element, page, pdf) {
		    _drawPath(element, page, pdf);
		    maybeFillStroke(element, page, pdf);
		}
	
		function drawMultiPath(element, page, pdf) {
		    var paths = element.paths;
		    for (var i = 0; i < paths.length; ++i) {
		        _drawPath(paths[i], page, pdf);
		    }
		    maybeFillStroke(element, page, pdf);
		}
	
		function drawCircle(element, page, pdf) {
		    var g = element.geometry();
		    page.circle(g.center.x, g.center.y, g.radius);
		    maybeFillStroke(element, page, pdf);
		}
	
		function drawArc(element, page, pdf) {
		    var points = element.geometry().curvePoints();
		    page.moveTo(points[0].x, points[0].y);
		    for (var i = 1; i < points.length;) {
		        page.bezier(
		            points[i].x, points[i++].y,
		            points[i].x, points[i++].y,
		            points[i].x, points[i++].y
		        );
		    }
		    maybeFillStroke(element, page, pdf);
		}
	
		function drawText(element, page) {
		    var style = parseFontDef(element.options.font);
		    var pos = element._position;
		    var mode;
		    if (element.fill() && element.stroke()) {
		        mode = TEXT_RENDERING_MODE$1.fillAndStroke;
		    } else if (element.fill()) {
		        mode = TEXT_RENDERING_MODE$1.fill;
		    } else if (element.stroke()) {
		        mode = TEXT_RENDERING_MODE$1.stroke;
		    }
	
		    page.transform(1, 0, 0, -1, pos.x, pos.y + style.fontSize);
		    page.beginText();
		    page.setFont(getFontURL(style), style.fontSize);
		    page.setTextRenderingMode(mode);
		    page.showText(element.content(), element._pdfRect ? element._pdfRect.width() : null);
		    page.endText();
		}
	
		function drawGroup(element, page, pdf) {
		    if (element._pdfLink) {
		        page.addLink(element._pdfLink.url, element._pdfLink);
		    }
		    var children = element.children;
		    for (var i = 0; i < children.length; ++i) {
		        drawElement(children[i], page, pdf);
		    }
		}
	
		function drawImage(element, page) {
		    var url = element.src();
		    if (!url) {
		        return;
		    }
	
		    var rect = element.rect();
		    var tl = rect.getOrigin();
		    var sz = rect.getSize();
		    page.transform(sz.width, 0, 0, -sz.height, tl.x, tl.y + sz.height);
		    page.drawImage(url);
		}
	
		function drawRect(element, page, pdf) {
		    var geometry = element.geometry();
		    page.rect(geometry.origin.x, geometry.origin.y, geometry.size.width, geometry.size.height);
		    maybeFillStroke(element, page, pdf);
		}
	
		function parseColor$1(value) {
		    var color = kendo.parseColor(value, true);
		    return color ? color.toRGB() : null;
		}
	
		function optimize(root) {
		    var clipbox = false;
		    var matrix = kendoGeometry.Matrix.unit();
		    var currentBox = null;
		    var changed;
		    do {
		        changed = false;
		        root = opt(root);
		    } while (root && changed);
		    return { root: root, bbox: currentBox };
	
		    function change(newShape) {
		        changed = true;
		        return newShape;
		    }
	
		    function visible(shape) {
		        return (shape.visible() && shape.opacity() > 0 &&
		                ( shouldDraw(shape.fill()) ||
		                  shouldDraw(shape.stroke()) ));
		    }
	
		    function optArray(a) {
		        var b = [];
		        for (var i = 0; i < a.length; ++i) {
		            var el = opt(a[i]);
		            if (el != null) {
		                b.push(el);
		            }
		        }
		        return b;
		    }
	
		    function withClipping(shape, f) {
		        var saveclipbox = clipbox;
		        var savematrix = matrix;
	
		        if (shape.transform()) {
		            matrix = matrix.multiplyCopy(shape.transform().matrix());
		        }
	
		        var clip = shape.clip();
		        if (clip) {
		            clip = clip.bbox();
		            if (clip) {
		                clip = clip.bbox(matrix);
		                clipbox = clipbox ? kendoGeometry.Rect.intersect(clipbox, clip) : clip;
		            }
		        }
	
		        try {
		            return f();
		        }
		        finally {
		            clipbox = saveclipbox;
		            matrix = savematrix;
		        }
		    }
	
		    function inClipbox(shape) {
		        if (clipbox == null) {
		            return false;
		        }
		        var box = shape.rawBBox().bbox(matrix);
		        if (clipbox && box) {
		            box = kendoGeometry.Rect.intersect(box, clipbox);
		        }
		        return box;
		    }
	
		    function opt(shape) {
		        return withClipping(shape, function(){
		            if (!(shape instanceof drawing.Group || shape instanceof drawing.MultiPath)) {
		                var box = inClipbox(shape);
		                if (!box) {
		                    return change(null);
		                }
		                currentBox = currentBox ? kendoGeometry.Rect.union(currentBox, box) : box;
		            }
		            return dispatch({
		                Path: function(shape) {
		                    if (shape.segments.length === 0 || !visible(shape)) {
		                        return change(null);
		                    }
		                    return shape;
		                },
		                MultiPath: function(shape) {
		                    if (!visible(shape)) {
		                        return change(null);
		                    }
		                    var el = new drawing.MultiPath(shape.options);
		                    el.paths = optArray(shape.paths);
		                    if (el.paths.length === 0) {
		                        return change(null);
		                    }
		                    return el;
		                },
		                Circle: function(shape) {
		                    if (!visible(shape)) {
		                        return change(null);
		                    }
		                    return shape;
		                },
		                Arc: function(shape) {
		                    if (!visible(shape)) {
		                        return change(null);
		                    }
		                    return shape;
		                },
		                Text: function(shape) {
		                    if (!/\S/.test(shape.content()) || !visible(shape)) {
		                        return change(null);
		                    }
		                    return shape;
		                },
		                Image: function(shape) {
		                    if (!(shape.visible() && shape.opacity() > 0)) {
		                        return change(null);
		                    }
		                    return shape;
		                },
		                Group: function(shape) {
		                    var el = new drawing.Group(shape.options);
		                    el.children = optArray(shape.children);
		                    el._pdfLink = shape._pdfLink;
		                    if (shape !== root && el.children.length === 0 && !shape._pdfLink) {
		                        return change(null);
		                    }
		                    return el;
		                },
		                Rect: function(shape) {
		                    if (!visible(shape)) {
		                        return change(null);
		                    }
		                    return shape;
		                }
		            }, shape);
		        });
		    }
		}
	
		function exportPDF(group, options) {
		    var promise = util.createPromise();
	
		    for (var i in options) {
		        if (i == "margin" && group.options.pdf && group.options.pdf._ignoreMargin) {
		            // This hackish option is set by the page breaking code in drawDOM.  The idea is
		            // that margin is already taken into account there (that's required to do proper
		            // page breaking) and we don't want to set it again here, as it would double the
		            // top-left margin, and truncate the content on bottom/right.
		            continue;
		        }
		        group.options.set("pdf." + i, options[i]);
		    }
	
		    toDataURL(group, promise.resolve);
	
		    return promise;
		}
	
		kendo.deepExtend(kendo.pdf, {
		    Document: PDFDocument,
		    BinaryStream: BinaryStream,
		    defineFont: defineFont,
		    parseFontDef: parseFontDef,
		    getFontURL: getFontURL,
		    loadFonts: loadFonts,
		    loadImages: loadImages,
		    getPaperOptions: getPaperOptions,
		    clearImageCache: clearImageCache,
		    TEXT_RENDERING_MODE: TEXT_RENDERING_MODE,
		    exportPDF: exportPDF,
		    saveAs: saveAs$1,
		    toDataURL: toDataURL,
		    toBlob: toBlob,
		    render: render
		});
	
		kendo.drawing.exportPDF = kendo.pdf.exportPDF;
		kendo.drawing.pdf = kendo.pdf;
	
		})(kendo);
	
		return kendo;
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 1444:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(612);
	
	/***/ }),
	
	/***/ 1445:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1448);
		module.exports = __webpack_require__(1448);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1448:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function () {
	
		    kendo.pdf = kendo.pdf || {};
	
		    kendo.pdf.supportsDeflate = function() {
		        return window.pako && typeof window.pako.deflate == "function";
		    };
	
		    kendo.pdf.deflate = function(data) {
		        return window.pako.deflate(data);
		    };
	
		})();
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1446);
		module.exports = __webpack_require__(1446);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1446:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1447)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    
		kendo.PDFMixin = {
		    extend: function(proto) {
		        proto.events.push("pdfExport");
		        proto.options.pdf = this.options;
		        proto.saveAsPDF = this.saveAsPDF;
		        proto._drawPDF = this._drawPDF;
		        proto._drawPDFShadow = this._drawPDFShadow;
		    },
		    options: {
		        fileName  : "Export.pdf",
		        proxyURL  : "",
	
		        // paperSize can be an usual name, i.e. "A4", or an array of two Number-s specifying the
		        // width/height in points (1pt = 1/72in), or strings including unit, i.e. "10mm".  Supported
		        // units are "mm", "cm", "in" and "pt".  The default "auto" means paper size is determined
		        // by content.
		        paperSize : "auto",
	
		        // Export all pages, if applicable
		        allPages: false,
	
		        // True to reverse the paper dimensions if needed such that width is the larger edge.
		        landscape : false,
	
		        // An object containing { left, top, bottom, right } margins with units.
		        margin    : null,
	
		        // Optional information for the PDF Info dictionary; all strings except for the date.
		        title     : null,
		        author    : null,
		        subject   : null,
		        keywords  : null,
		        creator   : "Kendo UI PDF Generator v." + kendo.version,
	
		        // Creation Date; defaults to new Date()
		        date      : null
		    },
	
		    saveAsPDF: function() {
		        var progress = new $.Deferred();
		        var promise = progress.promise();
		        var args = { promise: promise };
	
		        if (this.trigger("pdfExport", args)) {
		            return;
		        }
	
		        var options = this.options.pdf;
		        options.multiPage = options.multiPage || options.allPages;
	
		        this._drawPDF(progress)
		        .then(function(root) {
		            return kendo.drawing.exportPDF(root, options);
		        })
		        .done(function(dataURI) {
		            kendo.saveAs({
		                dataURI: dataURI,
		                fileName: options.fileName,
		                proxyURL: options.proxyURL,
		                forceProxy: options.forceProxy,
		                proxyTarget: options.proxyTarget
		            });
	
		            progress.resolve();
		        })
		        .fail(function(err) {
		            progress.reject(err);
		        });
	
		        return promise;
		    },
	
		    _drawPDF: function(progress) {
		        var promise = new $.Deferred();
	
		        kendo.drawing.drawDOM(this.wrapper)
		        .done(function(group) {
		            var args = {
		                page: group,
		                pageNumber: 1,
		                progress: 1,
		                totalPages: 1
		            };
	
		            progress.notify(args);
		            promise.resolve(args.page);
		        })
		        .fail(function(err) {
		            promise.reject(err);
		        });
	
		        return promise;
		    },
	
		    _drawPDFShadow: function(settings, drawOptions) {
		        settings = settings || {};
		        var wrapper = this.wrapper;
		        var shadow = $("<div class='k-pdf-export-shadow'>");
	
		        // Content will be allowed to take up to 200" if no width is given.
		        if (settings.width) {
		            shadow.css({
		                width: settings.width,
		                overflow: "visible"
		            });
		        }
	
		        wrapper.before(shadow);
		        shadow.append(settings.content || wrapper.clone(true, true));
	
		        var defer = $.Deferred();
	
		        /* https://github.com/telerik/kendo/issues/4790 -- We need to
		         * allow a small timeout so that the browser finalizes the
		         * layout of any images here.  Another option would be to pass
		         * forcePageBreak: "-" to drawDOM, but that would make it
		         * clone the content as well and look for page breaks;
		         * needless work, so better do it here.
		         */
		        setTimeout(function(){
		            var promise = kendo.drawing.drawDOM(shadow, drawOptions);
		            promise.always(function() {
		                shadow.remove();
		            }).then(function(){
		                defer.resolve.apply(defer, arguments);
		            }).fail(function(){
		                defer.reject.apply(defer, arguments);
		            }).progress(function(){
		                defer.progress.apply(defer, arguments);
		            });
		        }, 15);
	
		        return defer.promise();
		    }
		};
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 1447:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(611);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1290);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1290:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {/* jshint eqnull: true */
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "sortable",
		    name: "Sortable",
		    category: "framework",
		    depends: [ "draganddrop" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
	
		        START = "start",
		        BEFORE_MOVE = "beforeMove",
		        MOVE = "move",
		        END = "end",
		        CHANGE = "change",
		        CANCEL = "cancel",
	
		        ACTION_SORT = "sort",
		        ACTION_REMOVE = "remove",
		        ACTION_RECEIVE = "receive",
	
		        DEFAULT_FILTER = ">*",
		        MISSING_INDEX = -1;
	
		    function containsOrEqualTo(parent, child) {
		        try {
		            return $.contains(parent, child) || parent == child;
		        } catch (e) {
		            return false;
		        }
		    }
	
		    function defaultHint(element) {
		        return element.clone();
		    }
	
		    function defaultPlaceholder(element) {
		        return element.clone().removeAttr("id").css("visibility", "hidden");
		    }
	
		    var Sortable = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            if(!that.options.placeholder) {
		                that.options.placeholder = defaultPlaceholder;
		            }
	
		            if(!that.options.hint) {
		                that.options.hint = defaultHint;
		            }
	
		            that.draggable = that._createDraggable();
		        },
	
		        events: [
		            START,
		            BEFORE_MOVE,
		            MOVE,
		            END,
		            CHANGE,
		            CANCEL
		        ],
	
		        options: {
		            name: "Sortable",
		            hint: null,
		            placeholder: null,
		            filter: DEFAULT_FILTER,
		            holdToDrag: false,
		            disabled: null,
		            container: null,
		            connectWith: null,
		            handler: null,
		            cursorOffset: null,
		            axis: null,
		            ignore: null,
		            autoScroll: false,
		            cursor: "auto",
		            moveOnDragEnter: false
		        },
	
		        destroy: function() {
		            this.draggable.destroy();
		            Widget.fn.destroy.call(this);
		        },
	
		        _createDraggable: function() {
		            var that = this,
		                element = that.element,
		                options = that.options;
	
		            return new kendo.ui.Draggable(element, {
		                filter: options.filter,
		                hint: kendo.isFunction(options.hint) ? options.hint : $(options.hint),
		                holdToDrag: options.holdToDrag,
		                container: options.container ? $(options.container) : null,
		                cursorOffset: options.cursorOffset,
		                axis: options.axis,
		                ignore: options.ignore,
		                autoScroll: options.autoScroll,
		                dragstart: $.proxy(that._dragstart, that),
		                dragcancel: $.proxy(that._dragcancel, that),
		                drag: $.proxy(that._drag, that),
		                dragend: $.proxy(that._dragend, that)
		            });
		        },
	
		        _dragstart: function(e) {
		            var draggedElement = this.draggedElement = e.currentTarget,
		                disabled = this.options.disabled,
		                handler = this.options.handler,
		                _placeholder = this.options.placeholder,
		                placeholder = this.placeholder = kendo.isFunction(_placeholder) ? $(_placeholder.call(this, draggedElement)) : $(_placeholder);
	
		            if(disabled && draggedElement.is(disabled)) {
		                e.preventDefault();
		            } else if(handler && !$(e.initialTarget).is(handler)) {
		                e.preventDefault();
		            } else {
	
		                if(this.trigger(START, { item: draggedElement, draggableEvent: e })) {
		                    e.preventDefault();
		                } else {
		                    draggedElement.css("display", "none");
		                    draggedElement.before(placeholder);
	
		                    this._setCursor();
		                }
	
		            }
		        },
	
		        _dragcancel: function() {
		            this._cancel();
		            this.trigger(CANCEL, { item: this.draggedElement });
	
		            this._resetCursor();
		        },
	
		        _drag: function(e) {
		            var draggedElement = this.draggedElement,
		                target = this._findTarget(e),
		                targetCenter,
		                cursorOffset = { left: e.x.location, top: e.y.location },
		                offsetDelta,
		                axisDelta = { x: e.x.delta, y: e.y.delta },
		                direction,
		                sibling,
		                getSibling,
		                axis = this.options.axis,
		                moveOnDragEnter= this.options.moveOnDragEnter,
		                eventData = { item: draggedElement, list: this, draggableEvent: e };
	
		            if(axis === "x" || axis === "y") {
		                this._movementByAxis(axis, cursorOffset, axisDelta[axis], eventData);
		                return;
		            }
	
		            if(target) {
		                targetCenter = this._getElementCenter(target.element);
	
		                offsetDelta = {
		                    left: Math.round(cursorOffset.left - targetCenter.left),
		                    top: Math.round(cursorOffset.top - targetCenter.top)
		                };
	
		                $.extend(eventData, { target: target.element });
	
		                if(target.appendToBottom) {
		                    this._movePlaceholder(target, null, eventData);
		                    return;
		                }
	
		                if(target.appendAfterHidden) {
		                    this._movePlaceholder(target, "next", eventData);
		                }
	
		                if(this._isFloating(target.element)) { //horizontal
		                    if((axisDelta.x < 0 && moveOnDragEnter) || (!moveOnDragEnter && offsetDelta.left < 0)) {
		                        direction = "prev";
		                    } else if((axisDelta.x > 0 && moveOnDragEnter) || (!moveOnDragEnter &&  offsetDelta.left > 0)) {
		                        direction = "next";
		                    }
		                } else { //vertical
		                    if((axisDelta.y < 0  && moveOnDragEnter) || (!moveOnDragEnter &&  offsetDelta.top < 0)) {
		                        direction = "prev";
		                    } else if((axisDelta.y > 0  && moveOnDragEnter) || (!moveOnDragEnter &&  offsetDelta.top > 0)) {
		                        direction = "next";
		                    }
		                }
	
		                if(direction) {
		                    getSibling = (direction === "prev") ? jQuery.fn.prev : jQuery.fn.next;
	
		                    sibling = getSibling.call(target.element);
	
		                    //find the prev/next visible sibling
		                    while(sibling.length && !sibling.is(":visible")) {
		                        sibling = getSibling.call(sibling);
		                    }
	
		                    if(sibling[0] != this.placeholder[0]) {
		                        this._movePlaceholder(target, direction, eventData);
		                    }
		                }
		            }
		        },
	
		        _dragend: function(e) {
		            var placeholder = this.placeholder,
		                draggedElement = this.draggedElement,
		                draggedIndex = this.indexOf(draggedElement),
		                placeholderIndex = this.indexOf(placeholder),
		                connectWith = this.options.connectWith,
		                connectedList,
		                isDefaultPrevented,
		                eventData,
		                connectedListEventData;
	
		            this._resetCursor();
	
		            eventData = {
		                action: ACTION_SORT,
		                item: draggedElement,
		                oldIndex: draggedIndex,
		                newIndex: placeholderIndex,
		                draggableEvent: e
		            };
	
		            if(placeholderIndex >= 0) {
		                isDefaultPrevented = this.trigger(END, eventData);
		            } else {
		                connectedList = placeholder.parents(connectWith).getKendoSortable();
	
		                eventData.action = ACTION_REMOVE;
		                connectedListEventData = $.extend({}, eventData, {
		                    action: ACTION_RECEIVE,
		                    oldIndex: MISSING_INDEX,
		                    newIndex: connectedList.indexOf(placeholder)
		                });
	
		                isDefaultPrevented = !(!this.trigger(END, eventData) && !connectedList.trigger(END, connectedListEventData));
		            }
	
		            if(isDefaultPrevented || placeholderIndex === draggedIndex) {
		                this._cancel();
		                return;
		            }
	
		            placeholder.replaceWith(draggedElement);
	
		            draggedElement.show();
		            this.draggable.dropped = true;
	
		            eventData = {
		                action: this.indexOf(draggedElement) != MISSING_INDEX ? ACTION_SORT : ACTION_REMOVE,
		                item: draggedElement,
		                oldIndex: draggedIndex,
		                newIndex: this.indexOf(draggedElement),
		                draggableEvent: e
		            };
	
		            this.trigger(CHANGE, eventData);
	
		            if(connectedList) {
		                connectedListEventData = $.extend({}, eventData, {
		                    action: ACTION_RECEIVE,
		                    oldIndex: MISSING_INDEX,
		                    newIndex: connectedList.indexOf(draggedElement)
		                });
	
		                connectedList.trigger(CHANGE, connectedListEventData);
		            }
	
		        },
	
		        _findTarget: function(e) {
		            var element = this._findElementUnderCursor(e),
		                items,
		                connectWith = this.options.connectWith,
		                node;
	
		            if($.contains(this.element[0], element)) { //the element is part of the sortable container
		                items = this.items();
		                node = items.filter(element)[0] || items.has(element)[0];
	
		                return node ? { element: $(node), sortable: this } : null;
		            } else if (this.element[0] == element && this._isEmpty()) {
		                return { element: this.element, sortable: this, appendToBottom: true };
		            } else if (this.element[0] == element && this._isLastHidden()) {
		                node = this.items().eq(0);
		                return { element: node , sortable: this, appendAfterHidden: true };
		            } else if (connectWith) { //connected lists are present
		                return this._searchConnectedTargets(element, e);
		            }
		        },
	
		        _findElementUnderCursor: function(e) {
		            var elementUnderCursor = kendo.elementUnderCursor(e),
		                draggable = e.sender;
	
		            if(containsOrEqualTo(draggable.hint[0], elementUnderCursor)) {
		                draggable.hint.hide();
		                elementUnderCursor = kendo.elementUnderCursor(e);
		                // IE8 does not return the element in iframe from first attempt
		                if (!elementUnderCursor) {
		                    elementUnderCursor = kendo.elementUnderCursor(e);
		                }
		                draggable.hint.show();
		            }
	
		            return elementUnderCursor;
		        },
	
		        _searchConnectedTargets: function(element, e) {
		            var connected = $(this.options.connectWith),
		                sortableInstance,
		                items,
		                node;
	
		            for (var i = 0; i < connected.length; i++) {
		                sortableInstance = connected.eq(i).getKendoSortable();
	
		                if($.contains(connected[i], element)) {
		                    if(sortableInstance) {
		                        items = sortableInstance.items();
		                        node = items.filter(element)[0] || items.has(element)[0];
	
		                        if(node) {
		                            sortableInstance.placeholder = this.placeholder;
		                            return { element: $(node), sortable: sortableInstance };
		                        } else {
		                            return null;
		                        }
		                    }
		                } else if(connected[i] == element) {
		                    if(sortableInstance && sortableInstance._isEmpty()) {
		                        return { element: connected.eq(i), sortable: sortableInstance, appendToBottom: true };
		                    } else if (this._isCursorAfterLast(sortableInstance, e)) {
		                        node = sortableInstance.items().last();
		                        return { element: node, sortable: sortableInstance };
		                    }
		                }
		            }
	
		        },
	
		        _isCursorAfterLast: function(sortable, e) {
		            var lastItem = sortable.items().last(),
		                cursorOffset = { left: e.x.location, top: e.y.location },
		                lastItemOffset,
		                delta;
	
		            lastItemOffset = kendo.getOffset(lastItem);
		            lastItemOffset.top += outerHeight(lastItem);
		            lastItemOffset.left += outerWidth(lastItem);
	
		            if(this._isFloating(lastItem)) { //horizontal
		                delta = lastItemOffset.left - cursorOffset.left;
		            } else { //vertical
		                delta = lastItemOffset.top - cursorOffset.top;
		            }
	
		            return delta < 0 ? true : false;
		        },
	
		        _movementByAxis: function(axis, cursorOffset, delta, eventData) {
		            var cursorPosition = (axis === "x") ? cursorOffset.left : cursorOffset.top,
		                target = (delta < 0) ? this.placeholder.prev() : this.placeholder.next(),
		                items = this.items(),
		                targetCenter;
	
		            if (target.length && !target.is(":visible")) {
		                target = (delta <0) ? target.prev() : target.next();
		            }
	
		            if (!items.filter(target).length) {
		                return;
		            }
	
		            $.extend(eventData, { target: target });
		            targetCenter = this._getElementCenter(target);
	
		            if (targetCenter) {
		                targetCenter = (axis === "x") ? targetCenter.left : targetCenter.top;
		            }
	
		            if (target.length && delta < 0 && cursorPosition - targetCenter < 0) { //prev
		                this._movePlaceholder({ element: target, sortable: this }, "prev", eventData);
		            } else if (target.length && delta > 0 && cursorPosition - targetCenter > 0) { //next
		                this._movePlaceholder({ element: target, sortable: this }, "next", eventData);
		            }
		        },
	
		        _movePlaceholder: function(target, direction, eventData) {
		            var placeholder = this.placeholder;
	
		            if (!target.sortable.trigger(BEFORE_MOVE, eventData)) {
	
		                if (!direction) {
		                    target.element.append(placeholder);
		                } else if (direction === "prev") {
		                    target.element.before(placeholder);
		                } else if (direction === "next") {
		                    target.element.after(placeholder);
		                }
	
		                target.sortable.trigger(MOVE, eventData);
		            }
		        },
	
		        _setCursor: function() {
		            var cursor = this.options.cursor,
		                body;
	
		            if(cursor && cursor !== "auto") {
		                body = $(document.body);
	
		                this._originalCursorType = body.css("cursor");
		                body.css({ "cursor": cursor });
	
		                if(!this._cursorStylesheet) {
		                    this._cursorStylesheet = $("<style>* { cursor: " + cursor + " !important; }</style>");
		                }
	
		                this._cursorStylesheet.appendTo(body);
		            }
		        },
	
		        _resetCursor: function() {
		            if(this._originalCursorType) {
		                $(document.body).css("cursor", this._originalCursorType);
		                this._originalCursorType = null;
	
		                this._cursorStylesheet.remove();
		            }
		        },
	
		        _getElementCenter: function(element) {
		            var center = element.length ? kendo.getOffset(element) : null;
		            if(center) {
		                center.top += outerHeight(element) / 2;
		                center.left += outerWidth(element) / 2;
		            }
	
		            return center;
		        },
	
		        _isFloating: function(item) {
		            return (/left|right/).test(item.css("float")) || (/inline|table-cell/).test(item.css("display"));
		        },
	
		        _cancel: function() {
		            this.draggedElement.show();
		            this.placeholder.remove();
		        },
	
		        _items: function() {
		            var filter = this.options.filter,
		                items;
	
		            if(filter) {
		                items = this.element.find(filter);
		            } else {
		                items = this.element.children();
		            }
	
		            return items;
		        },
	
		        indexOf: function(element) {
		            var items = this._items(),
		                placeholder = this.placeholder,
		                draggedElement = this.draggedElement;
	
		            if(placeholder && element[0] == placeholder[0]) {
		                return items.not(draggedElement).index(element);
		            } else {
		                return items.not(placeholder).index(element);
		            }
		        },
	
		        items: function() {
		            var placeholder = this.placeholder,
		                items = this._items();
	
		            if(placeholder) {
		                items = items.not(placeholder);
		            }
	
		            return items;
		        },
	
		        _isEmpty: function() {
		            return !this.items().length;
		        },
	
		        _isLastHidden: function() {
		            return this.items().length === 1 && this.items().is(":hidden");
		        }
	
		    });
	
		    kendo.ui.plugin(Sortable);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1040);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1040:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1036), __webpack_require__(1041), __webpack_require__(1042) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "columnmenu",
		    name: "Column Menu",
		    category: "framework",
		    depends: [ "popup", "filtermenu", "menu" ],
		    advanced: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        proxy = $.proxy,
		        extend = $.extend,
		        grep = $.grep,
		        map = $.map,
		        inArray = $.inArray,
		        ACTIVE = "k-state-selected",
		        ASC = "asc",
		        DESC = "desc",
		        CHANGE = "change",
		        INIT = "init",
		        OPEN = "open",
		        SELECT = "select",
		        POPUP = "kendoPopup",
		        FILTERMENU = "kendoFilterMenu",
		        MENU = "kendoMenu",
		        NS = ".kendoColumnMenu",
		        Widget = ui.Widget;
	
		    function trim(text) {
		        return $.trim(text).replace(/&nbsp;/gi, "");
		    }
	
		    function toHash(arr, key) {
		        var result = {};
		        var idx, len, current;
		        for (idx = 0, len = arr.length; idx < len; idx ++) {
		            current = arr[idx];
		            result[current[key]] = current;
		        }
		        return result;
		    }
	
		    function leafColumns(columns) {
		        var result = [];
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (!columns[idx].columns) {
		                result.push(columns[idx]);
		                continue;
		            }
		            result = result.concat(leafColumns(columns[idx].columns));
		        }
	
		        return result;
		    }
	
		    function attrEquals(attrName, attrValue) {
		        return "[" + kendo.attr(attrName) + "='" + (attrValue || "").replace(/'/g, "\"") + "']";
		    }
	
		    function insertElementAt(index, element, container) {
		        if (index > 0) {
		            element.insertAfter(container.children().eq(index - 1));
		        } else {
		            container.prepend(element);
		        }
		    }
	
		    var ColumnMenu = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                link;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element;
		            options = that.options;
		            that.owner = options.owner;
		            that.dataSource = options.dataSource;
	
		            that.field = element.attr(kendo.attr("field"));
		            that.title = element.attr(kendo.attr("title"));
	
		            link = element.find(".k-header-column-menu");
	
		            if (!link[0]) {
		                link = element.addClass("k-with-icon").prepend('<a class="k-header-column-menu" href="#" title="' +
		                    options.messages.settings + '" aria-label="' +
		                    options.messages.settings + '"><span class="k-icon k-i-more-vertical"></span></a>').find(".k-header-column-menu");
		            }
	
		            that.link = link
		                .attr("tabindex", -1)
		                .on("click" + NS, proxy(that._click, that));
	
		            that.wrapper = $('<div class="k-column-menu"/>');
	
		            that._refreshHandler = proxy(that.refresh, that);
	
		            that.dataSource.bind(CHANGE, that._refreshHandler);
		        },
	
		        _init: function() {
		            var that = this;
	
		            that.pane = that.options.pane;
		            if (that.pane) {
		                that._isMobile = true;
		            }
	
		            if (that._isMobile) {
		                that._createMobileMenu();
		            } else {
		                that._createMenu();
		            }
	
		            that.owner._muteAngularRebind(function() {
		                that._angularItems("compile");
		            });
	
		            that._sort();
	
		            that._columns();
	
		            that._filter();
	
		            that._lockColumns();
	
		            that.trigger(INIT, { field: that.field, container: that.wrapper });
		        },
	
		        events: [ INIT, OPEN, "sort", "filtering" ],
	
		        options: {
		            name: "ColumnMenu",
		            messages: {
		                sortAscending: "Sort Ascending",
		                sortDescending: "Sort Descending",
		                filter: "Filter",
		                columns: "Columns",
		                done: "Done",
		                settings: "Column Settings",
		                lock: "Lock",
		                unlock: "Unlock"
		            },
		            filter: "",
		            columns: true,
		            sortable: true,
		            filterable: true,
		            animations: {
		                left: "slide"
		            }
		        },
	
		        _createMenu: function() {
		            var that = this,
		                options = that.options;
	
		            that.wrapper.html(kendo.template(template)({
		                uid: kendo.guid(),
		                ns: kendo.ns,
		                messages: options.messages,
		                sortable: options.sortable,
		                filterable: options.filterable,
		                columns: that._ownerColumns(),
		                showColumns: options.columns,
		                lockedColumns: options.lockedColumns
		            }));
	
		            that.popup = that.wrapper[POPUP]({
		                anchor: that.link,
		                open: proxy(that._open, that),
		                activate: proxy(that._activate, that),
		                close: function() {
		                    if (that.options.closeCallback) {
		                        that.options.closeCallback(that.element);
		                    }
		                }
		            }).data(POPUP);
	
		            that.menu = that.wrapper.children()[MENU]({
		                orientation: "vertical",
		                closeOnClick: false,
		                open: function() {
		                    that._updateMenuItems();
		                }
		            }).data(MENU);
		        },
	
		        _createMobileMenu: function() {
		            var that = this,
		                options = that.options;
	
		            var html = kendo.template(mobileTemplate)({
		                ns: kendo.ns,
		                field: that.field,
		                title: that.title || that.field,
		                messages: options.messages,
		                sortable: options.sortable,
		                filterable: options.filterable,
		                columns: that._ownerColumns(),
		                showColumns: options.columns,
		                lockedColumns: options.lockedColumns
		            });
	
		            that.view = that.pane.append(html);
	
		            that.wrapper = that.view.element.find(".k-column-menu");
	
		            that.menu = new MobileMenu(that.wrapper.children(), {
		                pane: that.pane
		            });
	
		            that.view.element.on("click", ".k-done", function(e) {
		                that.close();
		                e.preventDefault();
		            });
	
		            if (that.options.lockedColumns) {
		                that.view.bind("show", function() {
		                    that._updateLockedColumns();
		                });
		            }
		        },
	
		        _angularItems: function(action) {
		            var that = this;
		            that.angular(action, function(){
		                var items = that.wrapper.find(".k-columns-item input[" + kendo.attr("field") + "]").map(function(){
		                    return $(this).closest("li");
		                });
		                var data = map(that._ownerColumns(), function(col){
		                    return { column: col._originalObject };
		                });
		                return {
		                    elements: items,
		                    data: data
		                };
		            });
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that._angularItems("cleanup");
	
		            Widget.fn.destroy.call(that);
	
		            if (that.filterMenu) {
		                that.filterMenu.destroy();
		            }
	
		            if (that._refreshHandler) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
		            }
	
		            if (that.options.columns && that.owner) {
		                if (that._updateColumnsMenuHandler) {
		                    that.owner.unbind("columnShow", that._updateColumnsMenuHandler);
		                    that.owner.unbind("columnHide", that._updateColumnsMenuHandler);
		                }
	
		                if (that._updateColumnsLockedStateHandler) {
		                    that.owner.unbind("columnLock", that._updateColumnsLockedStateHandler);
		                    that.owner.unbind("columnUnlock", that._updateColumnsLockedStateHandler);
		                }
		            }
	
		            if (that.menu) {
		                that.menu.element.off(NS);
		                that.menu.destroy();
		            }
	
		            that.wrapper.off(NS);
	
		            if (that.popup) {
		                that.popup.destroy();
		            }
	
		            if (that.view) {
		                that.view.purge();
		            }
	
		            that.link.off(NS);
		            that.owner = null;
		            that.wrapper = null;
		            that.element = null;
		        },
	
		        close: function() {
		            this.menu.close();
		            if (this.popup) {
		                this.popup.close();
		                this.popup.element.off("keydown" + NS);
		            }
		        },
	
		        _click: function(e) {
		            var that = this;
	
		            e.preventDefault();
		            e.stopPropagation();
	
		            var options = this.options;
	
		            if (options.filter && this.element.is(!options.filter)) {
		                return;
		            }
	
		            if (!this.popup && !this.pane) {
		                this._init();
		            } else {
		                that._updateMenuItems();
		            }
	
		            if (this._isMobile) {
		                this.pane.navigate(this.view, this.options.animations.left);
		            } else {
		                this.popup.toggle();
		            }
		        },
	
		        _updateMenuItems: function() {
		            var that = this;
		            that._setMenuItemsVisibility();
		            that._reorderMenuItems();
		        },
	
		        _setMenuItemsVisibility: function() {
		            var that = this;
	
		            that._eachRenderedMenuItem(function(index, column, renderedListElement) {
		                if (column.matchesMedia === false) {
		                    renderedListElement.hide();
		                } else {
		                    renderedListElement.show();
		                }
		            });
		        },
	
		        _reorderMenuItems: function() {
		            var that = this;
	
		            that._eachRenderedMenuItem(function(index, column, renderedListElement, renderedList) {
		                if (renderedListElement[0] && renderedListElement.index() !== index) {
		                    insertElementAt(index, renderedListElement, renderedList);
		                }
		            });
		        },
	
		        _eachRenderedMenuItem: function(callback) {
		            var that = this;
		            var renderedListElement;
		            var columns = that._ownerColumns() || [];
		            var renderedList = that._isMobile && that.view ?
		                $(that.view.element).find(".k-columns-item").children("ul") :
		                $(that.wrapper).find(".k-menu-group").first();
	
		            for (var i = 0; i < columns.length; i++) {
		                renderedListElement = renderedList.find(attrEquals("field", columns[i].originalField)).closest("li");
		                callback(i, columns[i], renderedListElement, renderedList);
		            }
		        },
	
		        _open: function() {
		            var that = this;
		            $(".k-column-menu").not(that.wrapper).each(function() {
		                $(this).data(POPUP).close();
		            });
		            that.popup.element.on("keydown" + NS, function(e) {
		                if (e.keyCode == kendo.keys.ESC) {
		                    that.close();
		                }
		            });
	
		            if (that.options.lockedColumns) {
		                that._updateLockedColumns();
		            }
		        },
	
		        _activate: function() {
		            this.menu.element.focus();
	
		            this.trigger(OPEN, { field: this.field, container: this.wrapper });
		        },
	
		        _ownerColumns: function() {
		            var columns = leafColumns(this.owner.columns),
		                menuColumns = grep(columns, function(col) {
		                    var result = true,
		                        title = trim(col.title || "");
	
		                    if (col.menu === false || (!col.field && !title.length)) {
		                        result = false;
		                    }
	
		                    return result;
		                });
	
		            return map(menuColumns, function(col) {
		                return {
		                    originalField: col.field,
		                    field: col.field || col.title,
		                    title: col.title || col.field,
		                    hidden: col.hidden,
		                    matchesMedia: col.matchesMedia,
		                    index: inArray(col, columns),
		                    locked: !!col.locked,
		                    _originalObject: col
		                };
		            });
		        },
	
		        _sort: function() {
		            var that = this;
	
		            if (that.options.sortable) {
		                that.refresh();
	
		                that.menu.bind(SELECT, function(e) {
		                    var item = $(e.item),
		                        dir;
	
		                    if (item.hasClass("k-sort-asc")) {
		                        dir = ASC;
		                    } else if (item.hasClass("k-sort-desc")) {
		                        dir = DESC;
		                    }
	
		                    if (!dir) {
		                        return;
		                    }
	
		                    item.parent().find(".k-sort-" + (dir == ASC ? DESC : ASC)).removeClass(ACTIVE);
	
		                    that._sortDataSource(item, dir);
	
		                    that.close();
		                });
		            }
		        },
	
		        _sortDataSource: function(item, dir) {
		            var that = this,
		                sortable = that.options.sortable,
		                compare = sortable.compare === null ? undefined : sortable.compare,
		                dataSource = that.dataSource,
		                idx,
		                length,
		                sort = dataSource.sort() || [];
	
		            var removeClass = item.hasClass(ACTIVE) && sortable && sortable.allowUnsort !== false;
	
		            dir = !removeClass ? dir : undefined;
	
		            if (that.trigger("sort", { sort: { field: that.field, dir: dir, compare: compare } })) {
		                return;
		            }
	
		            if (removeClass) {
		                item.removeClass(ACTIVE);
		            } else {
		                item.addClass(ACTIVE);
		            }
	
		            if (sortable.mode === "multiple") {
		                for (idx = 0, length = sort.length; idx < length; idx++) {
		                    if (sort[idx].field === that.field) {
		                        sort.splice(idx, 1);
		                        break;
		                    }
		                }
		                sort.push({ field: that.field, dir: dir, compare: compare });
		            } else {
		                sort = [ { field: that.field, dir: dir, compare: compare} ];
		            }
	
		            dataSource.sort(sort);
		        },
	
		        _columns: function() {
		            var that = this;
	
		            if (that.options.columns) {
	
		                that._updateColumnsMenu();
	
		                that._updateColumnsMenuHandler = proxy(that._updateColumnsMenu, that);
	
		                that.owner.bind(["columnHide", "columnShow"], that._updateColumnsMenuHandler);
	
		                that._updateColumnsLockedStateHandler = proxy(that._updateColumnsLockedState, that);
	
		                that.owner.bind(["columnUnlock", "columnLock" ], that._updateColumnsLockedStateHandler);
	
		                that.menu.bind(SELECT, function(e) {
		                    var item = $(e.item),
		                        input,
		                        column,
		                        columns = leafColumns(that.owner.columns),
		                        field;
	
		                    if (that._isMobile) {
		                        e.preventDefault();
		                    }
	
		                    if (!item.parent().closest("li.k-columns-item")[0]) {
		                        return;
		                    }
	
		                    input = item.find(":checkbox");
		                    if (input.attr("disabled")) {
		                        return;
		                    }
	
		                    field = input.attr(kendo.attr("field"));
	
		                    column = grep(columns, function(column) {
		                        return column.field == field || (!column.field && column.title == field);
		                    })[0];
	
		                    if (column.hidden === true) {
		                        that.owner.showColumn(column);
		                    } else {
		                        that.owner.hideColumn(column);
		                    }
		                });
		            }
		        },
	
		        _updateColumnsMenu: function() {
		            var idx, length, current, checked, locked;
		            var fieldAttr = kendo.attr("field"),
		                lockedAttr = kendo.attr("locked"),
		                visibleFields = grep(this._ownerColumns(), function(field) {
		                    return !field.hidden && field.matchesMedia !== false;
		                }),
		                visibleDataFields = grep(visibleFields, function(field) {
		                    return field.originalField;
		                }),
		                lockedCount = grep(visibleDataFields, function(col) {
		                    return col.locked === true;
		                }).length,
		                nonLockedCount = grep(visibleDataFields, function(col) {
		                    return col.locked !== true;
		                }).length,
		                columnNotInMenuCount = grep(this.owner.columns, function(col) {
		                    return col.menu === false;
		                }).length;
	
		            var visible = map(visibleFields, function(col) {
		                return col.field;
		            });
	
		            this.wrapper.find("[role='menuitemcheckbox']").attr("aria-checked", false);
	
		            var checkboxes = this.wrapper
		                .find(".k-columns-item input[" + fieldAttr + "]")
		                .prop("disabled", false)
		                .prop("checked", false);
	
		            for (idx = 0, length = checkboxes.length; idx < length; idx ++) {
		                current = checkboxes.eq(idx);
		                locked = current.attr(lockedAttr) === "true";
		                checked = false;
		                if (inArray(current.attr(fieldAttr), visible) > -1) {
		                    checked = true;
		                    current.prop("checked", checked);
		                }
	
		                current.closest("[role='menuitemcheckbox']").attr("aria-checked", checked);
	
		                if (checked) {
		                    if (lockedCount == 1 && locked) {
		                        current.prop("disabled", true);
		                    }
	
		                    if (columnNotInMenuCount === 0 && nonLockedCount == 1 && !locked) {
		                        current.prop("disabled", true);
		                    }
		                }
		            }
		        },
	
		        _updateColumnsLockedState: function() {
		            var idx, length, current, column;
		            var fieldAttr = kendo.attr("field");
		            var lockedAttr = kendo.attr("locked");
		            var columns = toHash(this._ownerColumns(), "field");
		            var checkboxes = this.wrapper
		                .find(".k-columns-item input[type=checkbox]");
	
		            for (idx = 0, length = checkboxes.length; idx < length; idx ++ ) {
		                current = checkboxes.eq(idx);
		                column = columns[current.attr(fieldAttr)];
		                if (column) {
		                    current.attr(lockedAttr, column.locked);
		                }
		            }
	
		            this._updateColumnsMenu();
		        },
	
		        _filter: function() {
		            var that = this,
		                widget = FILTERMENU,
		                options = that.options;
	
		            if (options.filterable !== false) {
	
		                if (options.filterable.multi) {
		                    widget = "kendoFilterMultiCheck";
		                    if (options.filterable.dataSource) {
		                        options.filterable.checkSource = options.filterable.dataSource;
		                        delete options.filterable.dataSource;
		                    }
		                }
		                that.filterMenu = that.wrapper.find(".k-filterable")[widget](
		                    extend(true, {}, {
		                        appendToElement: true,
		                        dataSource: options.dataSource,
		                        values: options.values,
		                        field: that.field,
		                        title: that.title,
		                        change: function(e) {
		                            if (that.trigger("filtering", { filter: e.filter, field: e.field })) {
		                                e.preventDefault();
		                            }
		                        }
		                    },
		                    options.filterable)
		                    ).data(widget);
	
		                if (that._isMobile) {
		                    that.menu.bind(SELECT, function(e) {
		                        var item = $(e.item);
	
		                        if (item.hasClass("k-filter-item")) {
		                            that.pane.navigate(that.filterMenu.view, that.options.animations.left);
		                        }
		                    });
		                }
		            }
		        },
	
		        _lockColumns: function() {
		            var that = this;
		            that.menu.bind(SELECT, function(e) {
		                var item = $(e.item);
	
		                if (item.hasClass("k-lock")) {
		                    that.owner.lockColumn(that.field);
		                    that.close();
		                } else if (item.hasClass("k-unlock")) {
		                    that.owner.unlockColumn(that.field);
		                    that.close();
		                }
		            });
		        },
	
		        _updateLockedColumns: function() {
		            var field = this.field;
		            var columns = this.owner.columns;
		            var column = grep(columns, function(column) {
		                return column.field == field || column.title == field;
		            })[0];
	
		            if (!column) {
		                return;
		            }
	
		            var locked = column.locked === true;
		            var length = grep(columns, function(column) {
		                return !column.hidden && ((column.locked && locked) || (!column.locked && !locked));
		            }).length;
	
		            var lockItem = this.wrapper.find(".k-lock").removeClass("k-state-disabled");
		            var unlockItem = this.wrapper.find(".k-unlock").removeClass("k-state-disabled");
	
		            if (locked || length == 1) {
		                lockItem.addClass("k-state-disabled");
		            }
	
		            if (!locked || length == 1) {
		                unlockItem.addClass("k-state-disabled");
		            }
	
		            this._updateColumnsLockedState();
		        },
	
		        refresh: function() {
		            var that = this,
		                sort = that.options.dataSource.sort() || [],
		                descriptor,
		                field = that.field,
		                idx,
		                length;
	
		            that.wrapper.find(".k-sort-asc, .k-sort-desc").removeClass(ACTIVE);
	
		            for (idx = 0, length = sort.length; idx < length; idx++) {
		               descriptor = sort[idx];
	
		               if (field == descriptor.field) {
		                   that.wrapper.find(".k-sort-" + descriptor.dir).addClass(ACTIVE);
		               }
		            }
	
		            that.link[that._filterExist(that.dataSource.filter()) ? "addClass" : "removeClass"]("k-state-active");
		        },
	
		        _filterExist: function(filters) {
		            var found = false;
		            var filter;
	
		            if (!filters) {
		                return;
		            }
	
		            filters = filters.filters;
	
		            for (var idx = 0, length = filters.length; idx < length; idx++) {
		                filter = filters[idx];
	
		                if (filter.field == this.field) {
		                    found = true;
		                } else if (filter.filters) {
		                    found = found || this._filterExist(filter);
		                }
		            }
	
		            return found;
		        }
		    });
	
		    var template = '<ul id="#=uid#">'+
		                    '#if(sortable){#'+
		                        '<li class="k-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span>${messages.sortAscending}</span></li>'+
		                        '<li class="k-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span>${messages.sortDescending}</span></li>'+
		                        '#if(showColumns || filterable){#'+
		                            '<li class="k-separator" role="presentation"></li>'+
		                        '#}#'+
		                    '#}#'+
		                    '#if(showColumns){#'+
		                        '<li class="k-item k-columns-item" aria-haspopup="true"><span class="k-link"><span class="k-icon k-i-columns"></span>${messages.columns}</span><ul>'+
		                        '#for (var idx = 0; idx < columns.length; idx++) {#'+
		                            '<li role="menuitemcheckbox" aria-checked="false" #=columns[idx].matchesMedia === false ? "style=\'display:none;\'" : ""#><input type="checkbox" data-#=ns#field="#=columns[idx].field.replace(/\"/g,"&\\#34;")#" data-#=ns#index="#=columns[idx].index#" data-#=ns#locked="#=columns[idx].locked#"/>#=columns[idx].title#</li>'+
		                        '#}#'+
		                        '</ul></li>'+
		                        '#if(filterable || lockedColumns){#'+
		                            '<li class="k-separator" role="presentation"></li>'+
		                        '#}#'+
		                    '#}#'+
		                    '#if(filterable){#'+
		                        '<li class="k-item k-filter-item" aria-haspopup="true"><span class="k-link"><span class="k-icon k-i-filter"></span>${messages.filter}</span><ul>'+
		                            '<li><div class="k-filterable"></div></li>'+
		                        '</ul></li>'+
		                        '#if(lockedColumns){#'+
		                            '<li class="k-separator" role="presentation"></li>'+
		                        '#}#'+
		                    '#}#'+
		                    '#if(lockedColumns){#'+
		                        '<li class="k-item k-lock"><span class="k-link"><span class="k-icon k-i-lock"></span>${messages.lock}</span></li>'+
		                        '<li class="k-item k-unlock"><span class="k-link"><span class="k-icon k-i-unlock"></span>${messages.unlock}</span></li>'+
		                    '#}#'+
		                    '</ul>';
	
		    var mobileTemplate =
		            '<div data-#=ns#role="view" data-#=ns#init-widgets="false" data-#=ns#use-native-scrolling="true" class="k-grid-column-menu">'+
		                '<div data-#=ns#role="header" class="k-header">'+
		                    '${messages.settings}'+
		                    '<button class="k-button k-done">#=messages.done#</button>'+
		                '</div>'+
		                '<div class="k-column-menu k-mobile-list"><ul><li>'+
		                    '<span class="k-link">${title}</span><ul>'+
		                '#if(sortable){#'+
		                    '<li class="k-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span>${messages.sortAscending}</span></li>'+
		                    '<li class="k-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span>${messages.sortDescending}</span></li>'+
		                '#}#'+
		                '#if(lockedColumns){#'+
		                    '<li class="k-item k-lock"><span class="k-link"><span class="k-icon k-i-lock"></span>${messages.lock}</span></li>'+
		                    '<li class="k-item k-unlock"><span class="k-link"><span class="k-icon k-i-unlock"></span>${messages.unlock}</span></li>'+
		                '#}#'+
		                '#if(filterable){#'+
		                    '<li class="k-item k-filter-item">'+
		                        '<span class="k-link k-filterable">'+
		                            '<span class="k-icon k-i-filter"></span>'+
		                            '${messages.filter}</span>'+
		                    '</li>'+
		                '#}#'+
		                '</ul></li>'+
		                '#if(showColumns){#'+
		                    '<li class="k-columns-item"><span class="k-link">${messages.columns}</span><ul>'+
		                    '#for (var idx = 0; idx < columns.length; idx++) {#'+
		                        '<li class="k-item"><label class="k-label"><input type="checkbox" class="k-check" data-#=ns#field="#=columns[idx].field.replace(/\"/g,"&\\#34;")#" data-#=ns#index="#=columns[idx].index#" data-#=ns#locked="#=columns[idx].locked#"/>#=columns[idx].title#</label></li>'+
		                    '#}#'+
		                    '</ul></li>'+
		                '#}#'+
		                '</ul></div>'+
		            '</div>';
	
		    var MobileMenu = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this.element.on("click" + NS, "li.k-item:not(.k-separator):not(.k-state-disabled)", "_click");
		        },
	
		        events: [ SELECT ],
	
		        _click: function(e) {
		            if (!$(e.target).is("[type=checkbox]")) {
		                e.preventDefault();
		            }
	
		            this.trigger(SELECT, { item: e.currentTarget });
		        },
	
		        close: function() {
		            this.options.pane.navigate("");
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this.element.off(NS);
		        }
		    });
	
		    ui.plugin(ColumnMenu);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1041:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(609);
	
	/***/ }),
	
	/***/ 1042:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(581);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1207);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1207:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "groupable",
		    name: "Groupable",
		    category: "framework",
		    depends: [ "core", "draganddrop" ],
		    advanced: true
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        outerWidth = kendo._outerWidth,
		        proxy = $.proxy,
		        isRtl = false,
		        NS = ".kendoGroupable",
		        CHANGE = "change",
		        indicatorTmpl = kendo.template('<div class="k-group-indicator" data-#=data.ns#field="${data.field}" data-#=data.ns#title="${data.title || ""}" data-#=data.ns#dir="${data.dir || "asc"}">' +
		                '<a href="\\#" class="k-link">' +
		                    '<span class="k-icon k-i-sort-${(data.dir || "asc") == "asc" ? "asc-sm" : "desc-sm"}" title="(sorted ${(data.dir || "asc") == "asc" ? "ascending": "descending"})"></span>' +
		                    '${data.title ? data.title: data.field}' +
		                '</a>' +
		                '<a class="k-button k-button-icon k-bare">' +
		                    '<span class="k-icon k-i-close"></span>' +
		                '</a>' +
		             '</div>',  { useWithBlock:false }),
		        hint = function(target) {
		            var title = target.attr(kendo.attr("title"));
		            if (title) {
		                title = kendo.htmlEncode(title);
		            }
	
		            return $('<div class="k-header k-drag-clue" />')
		                .css({
		                    width: target.width(),
		                    paddingLeft: target.css("paddingLeft"),
		                    paddingRight: target.css("paddingRight"),
		                    lineHeight: target.height() + "px",
		                    paddingTop: target.css("paddingTop"),
		                    paddingBottom: target.css("paddingBottom")
		                })
		                .html(title || target.attr(kendo.attr("field")))
		                .prepend('<span class="k-icon k-drag-status k-i-cancel" />');
		        },
		        dropCue = $('<div class="k-grouping-dropclue"/>');
	
		    function dropCueOffsetTop(element) {
		        return element.position().top + 3;
		    }
	
		    var Groupable = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                group = kendo.guid(),
		                intializePositions = proxy(that._intializePositions, that),
		                draggable,
		                horizontalCuePosition,
		                dropCuePositions = that._dropCuePositions = [];
	
		            Widget.fn.init.call(that, element, options);
	
		            isRtl = kendo.support.isRtl(element);
		            horizontalCuePosition = isRtl ? "right" : "left";
	
		            that.draggable = draggable = that.options.draggable || new kendo.ui.Draggable(that.element, {
		                filter: that.options.draggableElements,
		                hint: hint,
		                group: group
		            });
	
		            that.groupContainer = $(that.options.groupContainer, that.element)
		                .kendoDropTarget({
		                    group: draggable.options.group,
		                    dragenter: function(e) {
		                        if (that._canDrag(e.draggable.currentTarget)) {
		                            e.draggable.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus");
		                            dropCue.css("top", dropCueOffsetTop(that.groupContainer)).css(horizontalCuePosition, 0).appendTo(that.groupContainer);
		                        }
		                    },
		                    dragleave: function(e) {
		                        e.draggable.hint.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel");
		                        dropCue.remove();
		                    },
		                    drop: function(e) {
		                        var targetElement = e.draggable.currentTarget,
		                            field = targetElement.attr(kendo.attr("field")),
		                            title = targetElement.attr(kendo.attr("title")),
		                            sourceIndicator = that.indicator(field),
		                            dropCuePositions = that._dropCuePositions,
		                            lastCuePosition = dropCuePositions[dropCuePositions.length - 1],
		                            position;
	
		                        if (!targetElement.hasClass("k-group-indicator") && !that._canDrag(targetElement)) {
		                            return;
		                        }
		                        if(lastCuePosition) {
		                            position = that._dropCuePosition(kendo.getOffset(dropCue).left + parseInt(lastCuePosition.element.css("marginLeft"), 10) * (isRtl ? -1 : 1) + parseInt(lastCuePosition.element.css("marginRight"), 10));
		                            if(position && that._canDrop($(sourceIndicator), position.element, position.left)) {
		                                if(position.before) {
		                                    position.element.before(sourceIndicator || that.buildIndicator(field, title));
		                                } else {
		                                    position.element.after(sourceIndicator || that.buildIndicator(field, title));
		                                }
	
		                                that._change();
		                            }
		                        } else {
		                            that.groupContainer.append(that.buildIndicator(field, title));
		                            that._change();
		                        }
		                    }
		                })
		                .kendoDraggable({
		                    filter: "div.k-group-indicator",
		                    hint: hint,
		                    group: draggable.options.group,
		                    dragcancel: proxy(that._dragCancel, that),
		                    dragstart: function(e) {
		                        var element = e.currentTarget,
		                            marginLeft = parseInt(element.css("marginLeft"), 10),
		                            elementPosition = element.position(),
		                            left = isRtl ? elementPosition.left - marginLeft : elementPosition.left + outerWidth(element);
	
		                        intializePositions();
		                        dropCue.css({top: dropCueOffsetTop(that.groupContainer), left: left}).appendTo(that.groupContainer);
		                        this.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus");
		                    },
		                    dragend: function() {
		                        that._dragEnd(this);
		                    },
		                    drag: proxy(that._drag, that)
		                })
		                .on("click" + NS, ".k-button", function(e) {
		                    e.preventDefault();
		                    that._removeIndicator($(this).parent());
		                })
		                .on("click" + NS,".k-link", function(e) {
		                    var current = $(this).parent(),
		                        newIndicator = that.buildIndicator(current.attr(kendo.attr("field")), current.attr(kendo.attr("title")), current.attr(kendo.attr("dir")) == "asc" ? "desc" : "asc");
	
		                    current.before(newIndicator).remove();
		                    that._change();
		                    e.preventDefault();
		                });
	
		            draggable.bind([ "dragend", "dragcancel", "dragstart", "drag" ],
		            {
		                dragend: function() {
		                    that._dragEnd(this);
		                },
		                dragcancel: proxy(that._dragCancel, that),
		                dragstart: function(e) {
		                    var element, marginRight, left;
	
		                    if (!that.options.allowDrag && !that._canDrag(e.currentTarget)) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    intializePositions();
		                    if(dropCuePositions.length) {
		                        element = dropCuePositions[dropCuePositions.length - 1].element;
		                        marginRight = parseInt(element.css("marginRight"), 10);
		                        left = element.position().left + outerWidth(element) + marginRight;
		                    } else {
		                        left = 0;
		                    }
		                },
		                drag: proxy(that._drag, that)
		            });
	
		            that.dataSource = that.options.dataSource;
	
		            if (that.dataSource && that._refreshHandler) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
		            } else {
		                that._refreshHandler = proxy(that.refresh, that);
		            }
	
		            if(that.dataSource) {
		                that.dataSource.bind("change", that._refreshHandler);
		                that.refresh();
		            }
		        },
	
		        refresh: function() {
		            var that = this,
		                dataSource = that.dataSource;
	
		            if (that.groupContainer) {
		                that.groupContainer.empty().append(
		                    $.map(dataSource.group() || [], function(item) {
		                        var fieldName = item.field;
		                        var attr = kendo.attr("field");
		                        var element = that.element.find(that.options.filter)
		                            .filter(function() { return $(this).attr(attr) === fieldName; });
	
		                        return that.buildIndicator(item.field, element.attr(kendo.attr("title")), item.dir);
		                    }).join("")
		                );
		            }
		            that._invalidateGroupContainer();
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.groupContainer.off(NS);
	
		            if (that.groupContainer.data("kendoDropTarget")) {
		                that.groupContainer.data("kendoDropTarget").destroy();
		            }
	
		            if (that.groupContainer.data("kendoDraggable")) {
		                that.groupContainer.data("kendoDraggable").destroy();
		            }
	
		            if (!that.options.draggable) {
		                that.draggable.destroy();
		            }
	
		            if (that.dataSource && that._refreshHandler) {
		                that.dataSource.unbind("change", that._refreshHandler);
		                that._refreshHandler = null;
		            }
	
		            that.groupContainer = that.element = that.draggable = null;
		        },
	
		        events: ["change"],
	
		        options: {
		            name: "Groupable",
		            filter: "th",
		            draggableElements: "th",
		            messages: {
		                empty: "Drag a column header and drop it here to group by that column"
		            }
		        },
	
		        indicator: function(field) {
		            var indicators = $(".k-group-indicator", this.groupContainer);
		            return $.grep(indicators, function (item)
		                {
		                    return $(item).attr(kendo.attr("field")) === field;
		                })[0];
		        },
	
		        buildIndicator: function(field, title, dir) {
		            return indicatorTmpl({ field: field.replace(/"/g, "'"), dir: dir, title: title, ns: kendo.ns });
		        },
	
		        aggregates: function() {
		            var that = this;
		            var names;
		            var idx;
		            var length;
	
		            return that.element.find(that.options.filter).map(function() {
		                var cell = $(this),
		                    aggregate = cell.attr(kendo.attr("aggregates")),
		                    member = cell.attr(kendo.attr("field"));
	
		                if (aggregate && aggregate !== "") {
		                    names = aggregate.split(",");
		                    aggregate = [];
		                    for (idx = 0, length = names.length; idx < length; idx++) {
		                        aggregate.push({ field: member, aggregate: names[idx] });
		                    }
		                }
		                return aggregate;
		            }).toArray();
		        },
	
		        descriptors: function() {
		            var that = this,
		                indicators = $(".k-group-indicator", that.groupContainer),
		                field,
		                aggregates = that.aggregates();
	
		            return $.map(indicators, function(item) {
		                item = $(item);
		                field = item.attr(kendo.attr("field"));
	
		                return {
		                    field: field,
		                    dir: item.attr(kendo.attr("dir")),
		                    aggregates: aggregates || []
		                };
		            });
		        },
	
		        _removeIndicator: function(indicator) {
		            var that = this;
		            indicator.remove();
		            that._invalidateGroupContainer();
		            that._change();
		        },
	
		        _change: function() {
		            var that = this;
		            if(that.dataSource) {
		                var descriptors = that.descriptors();
		                if (that.trigger("change", { groups: descriptors })) {
		                    that.refresh();
		                    return;
		                }
		                that.dataSource.group(descriptors);
		            }
		        },
	
		        _dropCuePosition: function(position) {
		            var dropCuePositions = this._dropCuePositions;
		            if(!dropCue.is(":visible") || dropCuePositions.length === 0) {
		                return;
		            }
	
		            position = Math.ceil(position);
	
		            var lastCuePosition = dropCuePositions[dropCuePositions.length - 1],
		                left = lastCuePosition.left,
		                right = lastCuePosition.right,
		                marginLeft = parseInt(lastCuePosition.element.css("marginLeft"), 10),
		                marginRight = parseInt(lastCuePosition.element.css("marginRight"), 10);
	
		            if(position >= right && !isRtl || position < left && isRtl) {
		                position = {
		                    left: lastCuePosition.element.position().left + (!isRtl ? outerWidth(lastCuePosition.element) + marginRight : - marginLeft),
		                    element: lastCuePosition.element,
		                    before: false
		                };
		            } else {
		                position = $.grep(dropCuePositions, function(item) {
		                    return (item.left <= position && position <= item.right) || (isRtl && position > item.right);
		                })[0];
	
		                if(position) {
		                    position = {
		                        left: isRtl ? position.element.position().left + outerWidth(position.element) + marginRight : position.element.position().left - marginLeft,
		                        element: position.element,
		                        before: true
		                    };
		                }
		            }
	
		            return position;
		        },
		        _drag: function(event) {
		            var position = this._dropCuePosition(event.x.location);
	
		            if (position) {
		                dropCue.css({ left: position.left, right: "auto" });
		            }
		        },
		        _canDrag: function(element) {
		            var field = element.attr(kendo.attr("field"));
	
		            return element.attr(kendo.attr("groupable")) != "false" &&
		                field &&
		                (element.hasClass("k-group-indicator") ||
		                    !this.indicator(field));
		        },
		        _canDrop: function(source, target, position) {
		            var next = source.next(),
		                result = source[0] !== target[0] && (!next[0] || target[0] !== next[0] || (!isRtl && position > next.position().left || isRtl && position < next.position().left));
		            return result;
		        },
		        _dragEnd: function(draggable) {
		            var that = this,
		                field = draggable.currentTarget.attr(kendo.attr("field")),
		                sourceIndicator = that.indicator(field);
	
		            if (draggable !== that.options.draggable && !draggable.dropped && sourceIndicator) {
		                that._removeIndicator($(sourceIndicator));
		            }
	
		            that._dragCancel();
		        },
		        _dragCancel: function() {
		            dropCue.remove();
		            this._dropCuePositions = [];
		        },
		        _intializePositions: function() {
		            var that = this,
		                indicators = $(".k-group-indicator", that.groupContainer),
		                left;
	
		            that._dropCuePositions = $.map(indicators, function(item) {
		                item = $(item);
		                left = kendo.getOffset(item).left;
		                return {
		                    left: parseInt(left, 10),
		                    right: parseInt(left + outerWidth(item), 10),
		                    element: item
		                };
		            });
		        },
		        _invalidateGroupContainer: function() {
		            var groupContainer = this.groupContainer;
		            if(groupContainer && groupContainer.is(":empty")) {
		                groupContainer.html(this.options.messages.empty);
		            }
		        }
		    });
	
		    kendo.ui.plugin(Groupable);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1259);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1259:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "pager",
		    name: "Pager",
		    category: "framework",
		    depends: [ "data" ],
		    advanced: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        proxy = $.proxy,
		        FIRST = ".k-i-arrow-end-left",
		        LAST = ".k-i-arrow-end-right",
		        PREV = ".k-i-arrow-60-left",
		        NEXT = ".k-i-arrow-60-right",
		        CHANGE = "change",
		        NS = ".kendoPager",
		        CLICK = "click",
		        KEYDOWN = "keydown",
		        DISABLED = "disabled",
		        MOUSEDOWN = "down",
		        DOCUMENT_ELEMENT = $(document.documentElement),
		        MAX_VALUE = Number.MAX_VALUE,
		        iconTemplate = kendo.template('<a href="\\#" aria-label="#=text#" title="#=text#" class="k-link k-pager-nav #= wrapClassName #"><span class="k-icon #= className #"></span></a>');
	
		    function button(template, idx, text, numeric, title) {
		        return template( {
		            idx: idx,
		            text: text,
		            ns: kendo.ns,
		            numeric: numeric,
		            title: title || ""
		        });
		    }
	
		    function icon(className, text, wrapClassName) {
		        return iconTemplate({
		            className: className.substring(1),
		            text: text,
		            wrapClassName: wrapClassName || ""
		        });
		    }
	
		    function update(element, selector, page, disabled) {
		       element.find(selector)
		              .parent()
		              .attr(kendo.attr("page"), page)
		              .attr("tabindex", -1)
		              .toggleClass("k-state-disabled", disabled);
		    }
	
		    function first(element, page) {
		        update(element, FIRST, 1, page <= 1);
		    }
	
		    function prev(element, page) {
		        update(element, PREV, Math.max(1, page - 1), page <= 1);
		    }
	
		    function next(element, page, totalPages) {
		        update(element, NEXT, Math.min(totalPages, page + 1), page >= totalPages);
		    }
	
		    function last(element, page, totalPages) {
		        update(element, LAST, totalPages, page >= totalPages);
		    }
	
		    var Pager = Widget.extend( {
		        init: function(element, options) {
		            var that = this, page, totalPages;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
		            that._createDataSource(options);
		            that.linkTemplate = kendo.template(that.options.linkTemplate);
		            that.selectTemplate = kendo.template(that.options.selectTemplate);
		            that.currentPageTemplate = kendo.template(that.options.currentPageTemplate);
	
		            page = that.page();
		            totalPages = that.totalPages();
	
		            that._refreshHandler = proxy(that.refresh, that);
	
		            that.dataSource.bind(CHANGE, that._refreshHandler);
		            that.downEvent = kendo.applyEventMap(MOUSEDOWN, kendo.guid());
		            if (options.previousNext) {
		                if (!that.element.find(FIRST).length) {
		                    that.element.append(icon(FIRST, options.messages.first, "k-pager-first"));
	
		                    first(that.element, page, totalPages);
		                }
	
		                if (!that.element.find(PREV).length) {
		                    that.element.append(icon(PREV, options.messages.previous));
	
		                    prev(that.element, page, totalPages);
		                }
		            }
	
		            if (options.numeric) {
		                that.list = that.element.find(".k-pager-numbers");
	
		                if (!that.list.length) {
		                   that.list = $('<ul class="k-pager-numbers k-reset" />').appendTo(that.element);
		                }
		            }
	
		            if (options.input) {
		                if (!that.element.find(".k-pager-input").length) {
		                   that.element.append('<span class="k-pager-input k-label">'+
		                       options.messages.page +
		                       '<input class="k-textbox">' +
		                       kendo.format(options.messages.of, totalPages) +
		                       '</span>');
		                }
	
		                that.element.on(KEYDOWN + NS, ".k-pager-input input", proxy(that._keydown, that));
		            }
	
		            if (options.previousNext) {
		                if (!that.element.find(NEXT).length) {
		                    that.element.append(icon(NEXT, options.messages.next));
	
		                    next(that.element, page, totalPages);
		                }
	
		                if (!that.element.find(LAST).length) {
		                    that.element.append(icon(LAST, options.messages.last, "k-pager-last"));
	
		                    last(that.element, page, totalPages);
		                }
		            }
	
		            if (options.pageSizes){
		                if (!that.element.find(".k-pager-sizes").length){
		                    var pageSizes = options.pageSizes.length ? options.pageSizes : ["all", 5, 10, 20];
		                    var pageItems = $.map(pageSizes, function(size) {
		                        if (size.toLowerCase && size.toLowerCase() === "all") {
		                            return "<option value='all'>" + options.messages.allPages + "</option>";
		                        }
	
		                        return "<option>" + size + "</option>";
		                    });
	
		                    $('<span class="k-pager-sizes k-label"><select/>' + options.messages.itemsPerPage + "</span>")
		                        .appendTo(that.element)
		                        .find("select").html(pageItems.join("")).end()
		                        .appendTo(that.element);
		                }
	
		                that.element.find(".k-pager-sizes select").val(that.pageSize());
	
		                if (kendo.ui.DropDownList) {
		                   that.element.find(".k-pager-sizes select").show().kendoDropDownList();
		                }
	
		                that.element.on(CHANGE + NS, ".k-pager-sizes select", proxy(that._change, that));
		            }
	
		            if (options.refresh) {
		                if (!that.element.find(".k-pager-refresh").length) {
		                    that.element.append('<a href="#" class="k-pager-refresh k-link" title="' + options.messages.refresh +
		                        '" aria-label="' + options.messages.refresh + '"><span class="k-icon k-i-reload"></span></a>');
		                }
	
		                that.element.on(CLICK + NS, ".k-pager-refresh", proxy(that._refreshClick, that));
		            }
	
		            if (options.info) {
		                if (!that.element.find(".k-pager-info").length) {
		                    that.element.append('<span class="k-pager-info k-label" />');
		                }
		            }
	
		            that.element
		                .on(CLICK + NS , "a", proxy(that._click, that))
		                .addClass("k-pager-wrap k-widget k-floatwrap");
	
		            that.element.on(CLICK + NS , ".k-current-page", proxy(that._toggleActive, that));
	
		            if (options.autoBind) {
		                that.refresh();
		            }
	
		            kendo.notify(that);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
	
		            that.element.off(NS);
		            that.dataSource.unbind(CHANGE, that._refreshHandler);
		            that._refreshHandler = null;
	
		            kendo.destroy(that.element);
		            that.element = that.list = null;
		        },
	
		        events: [
		            CHANGE
		        ],
	
		        options: {
		            name: "Pager",
		            selectTemplate: '<li><span class="k-state-selected">#=text#</span></li>',
		            currentPageTemplate: '<li class="k-current-page"><span class="k-link k-pager-nav">#=text#</span></li>',
		            linkTemplate: '<li><a tabindex="-1" href="\\#" class="k-link" data-#=ns#page="#=idx#" #if (title !== "") {# title="#=title#" #}#>#=text#</a></li>',
		            buttonCount: 10,
		            autoBind: true,
		            numeric: true,
		            info: true,
		            input: false,
		            previousNext: true,
		            pageSizes: false,
		            refresh: false,
		            messages: {
		                allPages: "All",
		                display: "{0} - {1} of {2} items",
		                empty: "No items to display",
		                page: "Page",
		                of: "of {0}",
		                itemsPerPage: "items per page",
		                first: "Go to the first page",
		                previous: "Go to the previous page",
		                next: "Go to the next page",
		                last: "Go to the last page",
		                refresh: "Refresh",
		                morePages: "More pages"
		            }
		        },
	
		        setDataSource: function(dataSource) {
		            var that = this;
	
		            that.dataSource.unbind(CHANGE, that._refreshHandler);
		            that.dataSource = that.options.dataSource = dataSource;
		            dataSource.bind(CHANGE, that._refreshHandler);
	
		            if (that.options.autoBind) {
		                dataSource.fetch();
		            }
		        },
	
		        _createDataSource: function(options) {
		            this.dataSource = kendo.data.DataSource.create(options.dataSource);
		        },
	
		        refresh: function(e) {
		            var that = this,
		                idx,
		                end,
		                start = 1,
		                reminder,
		                page = that.page(),
		                html = "",
		                options = that.options,
		                pageSize = that.pageSize(),
		                collapsedTotal = that._collapsedTotal(),
		                total = that.dataSource.total(),
		                totalPages = that.totalPages(),
		                linkTemplate = that.linkTemplate,
		                buttonCount = options.buttonCount;
	
		            DOCUMENT_ELEMENT.unbind(that.downEvent, $.proxy(that._hideList, that));
		            if (e && e.action == "itemchange") {
		                return;
		            }
	
		            if (options.numeric) {
	
		                if (page > buttonCount) {
		                    reminder = (page % buttonCount);
	
		                    start = (reminder === 0) ? (page - buttonCount) + 1 : (page - reminder) + 1;
		                }
	
		                end = Math.min((start + buttonCount) - 1, totalPages);
	
		                if (start > 1) {
		                    html += button(linkTemplate, start - 1, "...", false, options.messages.morePages);
		                }
	
		                for (idx = start; idx <= end; idx++) {
		                    html += button(idx == page ? that.selectTemplate : linkTemplate, idx, idx, true);
		                }
	
		                if (end < totalPages) {
		                    html += button(linkTemplate, idx, "...", false, options.messages.morePages);
		                }
	
		                if (html === "") {
		                    html = that.selectTemplate({ text: 0 });
		                }
	
		                html = this.currentPageTemplate({ text: page }) + html;
	
		                that.list.removeClass("k-state-expanded").html(html);
		            }
	
		            if (options.info) {
		                if (total > 0) {
		                    html = kendo.format(options.messages.display,
		                        that.dataSource.options.endless ? 1 : Math.min((page - 1) * (that.dataSource.pageSize() || 0) + 1, collapsedTotal), // first item in the page
		                        Math.min(page * pageSize, collapsedTotal), // last item in the page
		                    total);
		                } else {
		                    html = options.messages.empty;
		                }
	
		                that.element.find(".k-pager-info").html(html);
		            }
	
		            if (options.input) {
		                that.element
		                    .find(".k-pager-input")
		                    .html(that.options.messages.page +
		                        '<input class="k-textbox" aria-label="' + page + '">' +
		                        kendo.format(options.messages.of, totalPages))
		                    .find("input")
		                    .val(page)
		                    .attr(DISABLED, total < 1)
		                    .toggleClass("k-state-disabled", total < 1);
		            }
	
		            if (options.previousNext) {
		                first(that.element, page, totalPages);
	
		                prev(that.element, page, totalPages);
	
		                next(that.element, page, totalPages);
	
		                last(that.element, page, totalPages);
		            }
	
		            if (options.pageSizes) {
		                var hasAll = that.element.find(".k-pager-sizes option[value='all']").length > 0;
		                var selectAll = hasAll && (pageSize === this.dataSource.total() || pageSize == MAX_VALUE);
		                var text = pageSize;
		                if (selectAll) {
		                    pageSize = "all";
		                    text = options.messages.allPages;
		                }
	
		                that.element
		                    .find(".k-pager-sizes select")
		                    .val(pageSize)
		                    .attr("aria-label", pageSize)
		                    .filter("[" + kendo.attr("role") + "=dropdownlist]")
		                    .kendoDropDownList("value", pageSize)
		                    .kendoDropDownList("text", text); // handles custom values
		            }
		        },
	
		        _collapsedTotal: function() {
		            return this.dataSource.total();
		        },
	
		        _keydown: function(e) {
		            if (e.keyCode === kendo.keys.ENTER) {
		                var input = this.element.find(".k-pager-input").find("input"),
		                    page = parseInt(input.val(), 10);
	
		                if (isNaN(page) || page < 1 || page > this.totalPages()) {
		                    page = this.page();
		                }
	
		                input.val(page);
	
		                this.page(page);
		            }
		        },
	
		        _refreshClick: function(e) {
		            e.preventDefault();
	
		            this.dataSource.read();
		        },
	
		        _change: function(e) {
		            var value = e.currentTarget.value;
		            var pageSize = parseInt(value, 10);
		            var dataSource = this.dataSource;
	
		            if (!isNaN(pageSize)){
		                dataSource.pageSize(pageSize);
		            } else if ((value + "").toLowerCase() == "all") {
		                dataSource._pageSize = undefined;
		                dataSource._take = undefined;
		                dataSource.fetch();
		            }
		        },
	
		        _toggleActive: function() {
		            var that = this;
	
		            if (that.list.hasClass("k-state-expanded")) {
		                DOCUMENT_ELEMENT.unbind(that.downEvent, $.proxy(that._hideList, that));
		            } else {
		                DOCUMENT_ELEMENT.bind(that.downEvent, $.proxy(that._hideList, that));
		            }
		            that.list.toggleClass("k-state-expanded");
		        },
	
		        _hideList: function(e) {
		             var that = this,
		                target = kendo.eventTarget(e);
	
		            if (!$.contains(that.list[0], target)) {
		                DOCUMENT_ELEMENT.unbind(that.downEvent, $.proxy(that._hideList, that));
		                that.list.removeClass("k-state-expanded");
		            }
		        },
	
		        _click: function(e) {
		            var target = $(e.currentTarget);
	
		            e.preventDefault();
	
		            if (!target.is(".k-state-disabled")) {
		                this.page(target.attr(kendo.attr("page")));
		            }
		        },
	
		        totalPages: function() {
		            return Math.ceil((this.dataSource.total() || 0) / (this.pageSize() || 1));
		        },
	
		        pageSize: function() {
		            return this.dataSource.pageSize() || this.dataSource.total();
		        },
	
		        page: function(page) {
		            if (page !== undefined) {
		                if (this.trigger("pageChange", { index: page })) {
		                   return;
		                }
	
		                this.dataSource.page(page);
	
		                this.trigger(CHANGE, { index: page });
		            } else {
		                if (this.dataSource.total() > 0) {
		                    return this.dataSource.page();
		                } else {
		                    return 0;
		                }
		            }
		        }
		    });
	
		    ui.plugin(Pager);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1271);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1271:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "reorderable",
		    name: "Reorderable",
		    category: "framework",
		    depends: [ "core", "draganddrop" ],
		    advanced: true
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        getOffset = kendo.getOffset,
		        Widget = kendo.ui.Widget,
		        CHANGE =  "change",
		        KREORDERABLE = "k-reorderable";
	
		    function toggleHintClass(hint, denied) {
		        hint = $(hint);
	
		        if (denied) {
		            hint.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel");
		        } else {
		            hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus");
		        }
		    }
	
		    var Reorderable = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                draggable,
		                group = kendo.guid() + "-reorderable";
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element.addClass(KREORDERABLE);
		            options = that.options;
	
		            that.draggable = draggable = options.draggable || new kendo.ui.Draggable(element, {
		                group: group,
		                autoScroll: true,
		                filter: options.filter,
		                hint: options.hint
		            });
	
		            that.reorderDropCue = $('<div class="k-reorder-cue"></div></div>');
	
		            element.find(draggable.options.filter).kendoDropTarget({
		                group: draggable.options.group,
		                dragenter: function(e) {
		                    if (!that._draggable) {
		                        return;
		                    }
	
		                    var dropTarget = this.element, offset;
		                    var denied = !that._dropTargetAllowed(dropTarget) || that._isLastDraggable();
	
		                    toggleHintClass(e.draggable.hint, denied);
		                    if (!denied) {
		                        offset = getOffset(dropTarget);
		                        var left = offset.left;
	
		                        if (options.inSameContainer && !options.inSameContainer({
		                            source: dropTarget,
		                            target: that._draggable,
		                            sourceIndex: that._index(dropTarget),
		                            targetIndex: that._index(that._draggable)
		                        })) {
		                            that._dropTarget = dropTarget;
		                        } else {
		                            if (that._index(dropTarget) > that._index(that._draggable)) {
		                                left += outerWidth(dropTarget);
		                            }
		                        }
	
		                        that.reorderDropCue.css({
		                             height: outerHeight(dropTarget),
		                             top: offset.top,
		                             left: left
		                        })
		                        .appendTo(document.body);
		                    }
		                },
		                dragleave: function(e) {
		                    toggleHintClass(e.draggable.hint, true);
		                    that.reorderDropCue.remove();
		                    that._dropTarget = null;
		                },
		                drop: function() {
		                    that._dropTarget = null;
		                    if (!that._draggable) {
		                        return;
		                    }
		                    var dropTarget = this.element;
		                    var draggable = that._draggable;
	
		                    if (that._dropTargetAllowed(dropTarget) && !that._isLastDraggable()) {
		                        that.trigger(CHANGE, {
		                            element: that._draggable,
		                            target: dropTarget,
		                            oldIndex: that._index(draggable),
		                            newIndex: that._index(dropTarget),
		                            position: getOffset(that.reorderDropCue).left > getOffset(dropTarget).left ? "after" : "before"
		                        });
		                    }
		                }
		            });
	
		            draggable.bind([ "dragcancel", "dragend", "dragstart", "drag" ],
		                {
		                    dragcancel: function() {
		                        that.reorderDropCue.remove();
		                        that._draggable = null;
		                        that._elements = null;
		                    },
		                    dragend: function() {
		                        that.reorderDropCue.remove();
		                        that._draggable = null;
		                        that._elements = null;
		                    },
		                    dragstart: function(e) {
		                        that._draggable = e.currentTarget;
		                        that._elements = that.element.find(that.draggable.options.filter);
		                    },
		                    drag: function(e) {
		                        if (!that._dropTarget || this.hint.find(".k-drag-status").hasClass("k-i-cancel")) {
		                            return;
		                        }
	
		                        var dropStartOffset = getOffset(that._dropTarget).left;
		                        var width = outerWidth(that._dropTarget);
	
		                        if (e.pageX > dropStartOffset + width / 2) {
		                            that.reorderDropCue.css({ left: dropStartOffset + width });
		                        } else {
		                            that.reorderDropCue.css({ left: dropStartOffset });
		                        }
		                    }
		                }
		            );
		        },
	
		        options: {
		            name: "Reorderable",
		            filter: "*"
		        },
	
		        events: [
		            CHANGE
		        ],
	
		        _isLastDraggable: function() {
		            var inSameContainer = this.options.inSameContainer,
		                draggable = this._draggable[0],
		                elements = this._elements.get(),
		                found = false,
		                item;
	
		            if (!inSameContainer) {
		                return false;
		            }
	
		            while (!found && elements.length > 0) {
		                item = elements.pop();
		                found = draggable !== item && inSameContainer({
		                    source: draggable,
		                    target: item,
		                    sourceIndex: this._index(draggable),
		                    targetIndex: this._index(item)
		                });
		            }
	
		            return !found;
		        },
	
		        _dropTargetAllowed: function(dropTarget) {
		            var inSameContainer = this.options.inSameContainer,
		                dragOverContainers = this.options.dragOverContainers,
		                draggable = this._draggable;
	
		            if (draggable[0] === dropTarget[0]) {
		                return false;
		            }
	
		            if (!inSameContainer || !dragOverContainers) {
		                return true;
		            }
	
		            if (inSameContainer({ source: draggable,
		                target: dropTarget,
		                sourceIndex: this._index(draggable),
		                targetIndex: this._index(dropTarget)
		            })) {
		                return true;
		            }
	
		            return dragOverContainers(this._index(draggable), this._index(dropTarget));
		        },
	
		        _index: function(element) {
		            return this._elements.index(element);
		        },
	
		        destroy: function() {
		           var that = this;
	
		           Widget.fn.destroy.call(that);
	
		           that.element.find(that.draggable.options.filter).each(function() {
		               var item = $(this);
		               if (item.data("kendoDropTarget")) {
		                   item.data("kendoDropTarget").destroy();
		               }
		           });
	
		           if (that.draggable) {
		               that.draggable.destroy();
	
		               that.draggable.element = that.draggable = null;
		           }
		           that.elements = that.reorderDropCue = that._elements = that._draggable = null;
		       }
		    });
	
		    kendo.ui.plugin(Reorderable);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1234);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1218:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(620);
	
	/***/ }),
	
	/***/ 1219:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(621);
	
	/***/ }),
	
	/***/ 1234:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1219), __webpack_require__(1218) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.actionsheet",
		    name: "ActionSheet",
		    category: "mobile",
		    description: "The mobile ActionSheet widget displays a set of choices related to a task the user initiates.",
		    depends: [ "mobile.popover", "mobile.shim" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        support = kendo.support,
		        ui = kendo.mobile.ui,
		        Shim = ui.Shim,
		        Popup = ui.Popup,
		        Widget = ui.Widget,
		        OPEN = "open",
		        CLOSE = "close",
		        COMMAND = "command",
		        BUTTONS = "li>a",
		        CONTEXT_DATA = "actionsheetContext",
		        WRAP = '<div class="km-actionsheet-wrapper" />',
		        cancelTemplate = kendo.template('<li class="km-actionsheet-cancel"><a href="\\#">#:cancel#</a></li>');
	
		    var ActionSheet = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                ShimClass,
		                tablet,
		                type,
		                os = support.mobileOS;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
		            type = options.type;
		            element = that.element;
	
		            if (type === "auto") {
		                tablet = os && os.tablet;
		            } else {
		                tablet = type === "tablet";
		            }
	
		            ShimClass = tablet ? Popup : Shim;
	
		            if (options.cancelTemplate) {
		                cancelTemplate = kendo.template(options.cancelTemplate);
		            }
	
		            element
		                .addClass("km-actionsheet")
		                .append(cancelTemplate({cancel: that.options.cancel}))
		                .wrap(WRAP)
		                .on("up", BUTTONS, "_click")
		                .on("click", BUTTONS, kendo.preventDefault);
	
		            that.view().bind("destroy", function() {
		                that.destroy();
		            });
	
		            that.wrapper = element.parent().addClass(type ? " km-actionsheet-" + type : "");
	
		            that.shim = new ShimClass(that.wrapper, $.extend({modal: os.ios && os.majorVersion < 7, className: "km-actionsheet-root"}, that.options.popup) );
	
		            that._closeProxy = $.proxy(that, "_close");
		            that._shimHideProxy = $.proxy(that, "_shimHide");
		            that.shim.bind("hide", that._shimHideProxy);
	
		            if (tablet) {
		                kendo.onResize(that._closeProxy);
		            }
	
		            kendo.notify(that, ui);
		        },
	
		        events: [
		            OPEN,
		            CLOSE,
		            COMMAND
		        ],
	
		        options: {
		            name: "ActionSheet",
		            cancel: "Cancel",
		            type: "auto",
		            popup: { height: "auto" }
		        },
	
		        open: function(target, context) {
		            var that = this;
		            that.target = $(target);
		            that.context = context;
		            that.shim.show(target);
		        },
	
		        close: function() {
		            this.context = this.target = null;
		            this.shim.hide();
		        },
	
		        openFor: function(target) {
		            var that = this,
		                context = target.data(CONTEXT_DATA);
	
		            that.open(target, context);
		            that.trigger(OPEN, { target: target, context: context });
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            kendo.unbindResize(this._closeProxy);
		            this.shim.destroy();
		        },
	
		        _click: function(e) {
		            if (e.isDefaultPrevented()) {
		                return;
		            }
	
		            var currentTarget = $(e.currentTarget);
		            var action = currentTarget.data("action");
	
		            if (action) {
		                var actionData = {
		                    target: this.target,
		                    context: this.context
		                },
		                $angular = this.options.$angular;
	
		                if ($angular) {
		                    this.element.injector().get("$parse")(action)($angular[0])(actionData);
		                } else {
		                    kendo.getter(action)(window)(actionData);
		                }
		            }
	
		            this.trigger(COMMAND, { target: this.target, context: this.context, currentTarget: currentTarget });
	
		            e.preventDefault();
		            this._close();
		        },
	
		        _shimHide: function(e) {
		            if (!this.trigger(CLOSE)) {
		                this.context = this.target = null;
		            } else {
		                e.preventDefault();
		            }
		        },
	
		        _close: function(e) {
		            if (!this.trigger(CLOSE)) {
		                this.close();
		            } else {
		                e.preventDefault();
		            }
		        }
		    });
	
		    ui.plugin(ActionSheet);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1248);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1248:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1036) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.shim",
		    name: "Shim",
		    category: "mobile",
		    description: "Mobile Shim",
		    depends: [ "popup" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        Popup = kendo.ui.Popup,
		        SHIM = '<div class="km-shim"/>',
		        HIDE = "hide",
		        Widget = ui.Widget;
	
		    var Shim = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                app = kendo.mobile.application,
		                os = kendo.support.mobileOS,
		                osname = app ? app.os.name : (os ? os.name : "ios"),
		                ioswp = osname === "ios" || osname === "wp" || (app ? app.os.skin : false),
		                bb = osname === "blackberry",
		                align = options.align || (ioswp ?  "bottom center" : bb ? "center right" : "center center"),
		                position = options.position || (ioswp ? "bottom center" : bb ? "center right" : "center center"),
		                effect = options.effect || (ioswp ? "slideIn:up" : bb ? "slideIn:left" : "fade:in"),
		                shim = $(SHIM).handler(that).hide();
	
		            Widget.fn.init.call(that, element, options);
	
		            that.shim = shim;
		            element = that.element;
		            options = that.options;
	
		            if (options.className) {
		                that.shim.addClass(options.className);
		            }
	
		            if (!options.modal) {
		                that.shim.on("down", "_hide");
		            }
	
		            (app ? app.element : $(document.body)).append(shim);
	
		            that.popup = new Popup(that.element, {
		                anchor: shim,
		                modal: true,
		                appendTo: shim,
		                origin: align,
		                position: position,
		                animation: {
		                    open: {
		                        effects: effect,
		                        duration: options.duration
		                    },
		                    close: {
		                        duration: options.duration
		                    }
		                },
	
		                close: function(e) {
		                    var prevented = false;
	
		                    if (!that._apiCall) {
		                        prevented = that.trigger(HIDE);
		                    }
	
		                    if (prevented) {
		                        e.preventDefault();
		                    }
	
		                    that._apiCall = false;
		                },
	
		                deactivate: function() { // Deactivate event can't be prevented.
		                    shim.hide();
		                },
	
		                open: function() {
		                    shim.show();
		                }
		            });
	
		            kendo.notify(that);
		        },
	
		        events: [ HIDE ],
	
		        options: {
		            name: "Shim",
		            modal: false,
		            align: undefined,
		            position: undefined,
		            effect: undefined,
		            duration: 200
		        },
	
		        show: function() {
		            this.popup.open();
		        },
	
		        hide: function() {
		            this._apiCall = true;
		            this.popup.close();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.shim.kendoDestroy();
		            this.popup.destroy();
		            this.shim.remove();
		        },
	
		        _hide: function(e) {
		            if (!e || !$.contains(this.shim.children().children(".k-popup")[0], e.target)) {
		                this.popup.close();
		            }
		        }
		    });
	
		    ui.plugin(Shim);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1245);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1203:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(622);
	
	/***/ }),
	
	/***/ 1245:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1036), __webpack_require__(1203) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.popover",
		    name: "PopOver",
		    category: "mobile",
		    description: "The mobile PopOver widget represents a transient view which is displayed when the user taps on a navigational widget or area on the screen. ",
		    depends: [ "popup", "mobile.pane" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        ui = mobile.ui,
		        HIDE = "hide",
		        OPEN = "open",
		        CLOSE = "close",
		        WRAPPER = '<div class="km-popup-wrapper" />',
		        ARROW = '<div class="km-popup-arrow" />',
		        OVERLAY = '<div class="km-popup-overlay" />',
		        DIRECTION_CLASSES = "km-up km-down km-left km-right",
		        Widget = ui.Widget,
		        DIRECTIONS = {
		            "down": {
		                origin: "bottom center",
		                position: "top center"
		            },
		            "up": {
		                origin: "top center",
		                position: "bottom center"
		            },
		            "left": {
		                origin: "center left",
		                position: "center right",
		                collision: "fit flip"
		            },
		            "right": {
		                origin: "center right",
		                position: "center left",
		                collision: "fit flip"
		            }
		        },
	
		        ANIMATION = {
		            animation: {
		                open: {
		                    effects: "fade:in",
		                    duration: 0
		                },
		                close: {
		                    effects: "fade:out",
		                    duration: 400
		                }
		            }
		        },
		        DIMENSIONS = {
		            "horizontal": { offset: "top", size: "height" },
		            "vertical": { offset: "left", size: "width" }
		        },
	
		        REVERSE = {
		            "up": "down",
		            "down": "up",
		            "left": "right",
		            "right": "left"
		        };
	
		    var Popup = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                containerPopup = element.closest(".km-modalview-wrapper"),
		                viewport = element.closest(".km-root").children('.km-pane').first(),
		                container = containerPopup[0] ? containerPopup : viewport,
		                popupOptions,
		                axis;
	
		            if (options.viewport) {
		                viewport = options.viewport;
		            } else if (!viewport[0]) {
		                viewport = window;
		            }
	
		            if (options.container) {
		                container = options.container;
		            } else if (!container[0]) {
		                container = document.body;
		            }
	
		            popupOptions = {
		                viewport: viewport,
		                copyAnchorStyles: false,
		                autosize: true,
		                open: function() {
		                    that.overlay.show();
		                },
	
		                activate: $.proxy(that._activate, that),
	
		                deactivate: function() {
		                    that.overlay.hide();
		                    if (!that._apiCall) {
		                        that.trigger(HIDE);
		                    }
	
		                    that._apiCall = false;
		                }
		            };
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element;
		            options = that.options;
	
		            element.wrap(WRAPPER).addClass("km-popup").show();
	
		            axis = that.options.direction.match(/left|right/) ? "horizontal" : "vertical";
	
		            that.dimensions = DIMENSIONS[axis];
	
		            that.wrapper = element.parent().css({
		                width: options.width,
		                height: options.height
		            }).addClass("km-popup-wrapper km-" + options.direction).hide();
	
		            that.arrow = $(ARROW).prependTo(that.wrapper).hide();
	
		            that.overlay = $(OVERLAY).appendTo(container).hide();
		            popupOptions.appendTo = that.overlay;
	
		            if (options.className) {
		                that.overlay.addClass(options.className);
		            }
	
		            that.popup = new kendo.ui.Popup(that.wrapper, $.extend(true, popupOptions, ANIMATION, DIRECTIONS[options.direction]));
		        },
	
		        options: {
		            name: "Popup",
		            width: 240,
		            height: "",
		            direction: "down",
		            container: null,
		            viewport: null
		        },
	
		        events: [
		            HIDE
		        ],
	
		        show: function(target) {
		            this.popup.options.anchor = $(target);
		            this.popup.open();
		        },
	
		        hide: function() {
		            this._apiCall = true;
		            this.popup.close();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.popup.destroy();
		            this.overlay.remove();
		        },
	
		        target: function() {
		            return this.popup.options.anchor;
		        },
	
		        _activate: function() {
		            var that = this,
		                direction = that.options.direction,
		                dimensions = that.dimensions,
		                offset = dimensions.offset,
		                popup = that.popup,
		                anchor = popup.options.anchor,
		                anchorOffset = $(anchor).offset(),
		                elementOffset = $(popup.element).offset(),
		                cssClass = popup.flipped ? REVERSE[direction] : direction,
		                min = that.arrow[dimensions.size]() * 2,
		                max = that.element[dimensions.size]() - that.arrow[dimensions.size](),
		                size = $(anchor)[dimensions.size](),
		                offsetAmount = anchorOffset[offset] - elementOffset[offset] + (size / 2);
	
		            if (offsetAmount < min) {
		                offsetAmount = min;
		            }
	
		            if (offsetAmount > max) {
		                offsetAmount = max;
		            }
	
		            that.wrapper.removeClass(DIRECTION_CLASSES).addClass("km-" + cssClass);
		            that.arrow.css(offset, offsetAmount).show();
		        }
		    });
	
		    var PopOver = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                popupOptions;
	
		            that.initialOpen = false;
	
		            Widget.fn.init.call(that, element, options);
	
		            popupOptions = $.extend({
		                className: "km-popover-root",
		                hide: function() { that.trigger(CLOSE); }
		            }, this.options.popup);
	
		            that.popup = new Popup(that.element, popupOptions);
		            that.popup.overlay.on("move", function(e) {
		                if (e.target == that.popup.overlay[0]) {
		                    e.preventDefault();
		                }
		            });
	
		            that.pane = new ui.Pane(that.element, $.extend(this.options.pane, { $angular: this.options.$angular }));
	
		            kendo.notify(that, ui);
		        },
	
		        options: {
		            name: "PopOver",
		            popup: { },
		            pane: { }
		        },
	
		        events: [
		            OPEN,
		            CLOSE
		        ],
	
		        open: function(target) {
		            this.popup.show(target);
	
		            if (!this.initialOpen) {
		                if (!this.pane.navigateToInitial()) {
		                    this.pane.navigate("");
		                }
	
		                this.popup.popup._position();
		                this.initialOpen = true;
		            } else {
		                this.pane.view()._invokeNgController();
		            }
		        },
	
		        openFor: function(target) {
		            this.open(target);
		            this.trigger(OPEN, { target: this.popup.target() });
		        },
	
		        close: function() {
		            this.popup.hide();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.pane.destroy();
		            this.popup.destroy();
	
		            kendo.destroy(this.element);
		        }
		    });
	
		    ui.plugin(Popup);
		    ui.plugin(PopOver);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1244);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1220:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(623);
	
	/***/ }),
	
	/***/ 1221:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(624);
	
	/***/ }),
	
	/***/ 1244:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1221), __webpack_require__(1220) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.pane",
		    name: "Pane",
		    category: "mobile",
		    description: "Mobile Pane",
		    depends: [ "mobile.view", "mobile.loader" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        roleSelector = kendo.roleSelector,
		        ui = mobile.ui,
		        Widget = ui.Widget,
		        ViewEngine = mobile.ViewEngine,
		        View = ui.View,
		        Loader = mobile.ui.Loader,
	
		        EXTERNAL = "external",
		        HREF = "href",
		        DUMMY_HREF = "#!",
	
		        NAVIGATE = "navigate",
		        VIEW_SHOW = "viewShow",
		        SAME_VIEW_REQUESTED = "sameViewRequested",
		        OS = kendo.support.mobileOS,
		        SKIP_TRANSITION_ON_BACK_BUTTON = OS.ios && !OS.appMode && OS.flatVersion >= 700,
		        WIDGET_RELS = /popover|actionsheet|modalview|drawer/,
		        BACK = "#:back",
	
		        attrValue = kendo.attrValue;
	
		    var Pane = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
		            element = that.element;
	
		            element.addClass("km-pane");
	
		            if (that.options.collapsible) {
		                element.addClass("km-collapsible-pane");
		            }
	
		            this.history = [];
	
		            this.historyCallback = function(url, params, backButtonPressed) {
		                var transition = that.transition;
		                that.transition = null;
	
		                // swiping back in iOS leaves the app in a very broken state if we perform a transition
		                if (SKIP_TRANSITION_ON_BACK_BUTTON && backButtonPressed) {
		                    transition = "none";
		                }
	
		                return that.viewEngine.showView(url, transition, params);
		            };
	
		            this._historyNavigate = function(url) {
		                if (url === BACK) {
		                    if (that.history.length === 1) {
		                        return;
		                    }
	
		                    that.history.pop();
		                    url = that.history[that.history.length - 1];
		                } else {
		                    that.history.push(url);
		                }
	
		                that.historyCallback(url, kendo.parseQueryStringParams(url));
		            };
	
		            this._historyReplace = function(url) {
		                var params = kendo.parseQueryStringParams(url);
		                that.history[that.history.length - 1] = url;
		                that.historyCallback(url, params);
		            };
	
		            that.loader = new Loader(element, {
		                loading: that.options.loading
		            });
	
		            that.viewEngine = new ViewEngine({
		                container: element,
		                transition: options.transition,
		                modelScope: options.modelScope,
		                rootNeeded: !options.initial,
		                serverNavigation: options.serverNavigation,
		                remoteViewURLPrefix: options.root || "",
		                layout: options.layout,
		                $angular: options.$angular,
		                loader: that.loader,
	
		                showStart: function() {
		                    that.loader.transition();
		                    that.closeActiveDialogs();
		                },
	
		                after: function() {
		                    that.loader.transitionDone();
		                },
	
		                viewShow: function(e) {
		                    that.trigger(VIEW_SHOW, e);
		                },
	
		                loadStart: function() {
		                    that.loader.show();
		                },
	
		                loadComplete: function() {
		                    that.loader.hide();
		                },
	
		                sameViewRequested: function() {
		                    that.trigger(SAME_VIEW_REQUESTED);
		                },
	
		                viewTypeDetermined: function(e) {
		                    if (!e.remote || !that.options.serverNavigation)  {
		                        that.trigger(NAVIGATE, { url: e.url });
		                    }
		                }
		            });
	
	
		            this._setPortraitWidth();
	
		            kendo.onResize(function() {
		                that._setPortraitWidth();
		            });
	
		            that._setupAppLinks();
		        },
	
		        closeActiveDialogs: function() {
		            var dialogs = this.element.find(roleSelector("actionsheet popover modalview")).filter(":visible");
		            dialogs.each(function() {
		                kendo.widgetInstance($(this), ui).close();
		            });
		        },
	
		        navigateToInitial: function() {
		            var initial = this.options.initial;
	
		            if (initial) {
		                this.navigate(initial);
		            }
	
		            return initial;
		        },
	
		        options: {
		            name: "Pane",
		            portraitWidth: "",
		            transition: "",
		            layout: "",
		            collapsible: false,
		            initial: null,
		            modelScope: window,
		            loading: "<h1>Loading...</h1>"
		        },
	
		        events: [
		            NAVIGATE,
		            VIEW_SHOW,
		            SAME_VIEW_REQUESTED
		        ],
	
		        append: function(html) {
		            return this.viewEngine.append(html);
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.viewEngine.destroy();
		            this.userEvents.destroy();
		        },
	
		        navigate: function(url, transition) {
		            if (url instanceof View) {
		                url = url.id;
		            }
	
		            this.transition = transition;
	
		            this._historyNavigate(url);
		        },
	
		        replace: function(url, transition) {
		            if (url instanceof View) {
		                url = url.id;
		            }
	
		            this.transition = transition;
	
		            this._historyReplace(url);
		        },
	
		        bindToRouter: function(router) {
		            var that = this,
		                history = this.history,
		                viewEngine = this.viewEngine;
	
		            router.bind("init", function(e) {
		                var url = e.url,
		                    attrUrl = router.pushState ? url : "/";
	
		                viewEngine.rootView.attr(kendo.attr("url"), attrUrl);
	
		                // if current is set, then this means that the pane has navigated to a given view - we need to update the router accordingly.
		                var length = history.length;
	
		                if (url === "/" && length) {
		                    router.navigate(history[length - 1], true);
		                    e.preventDefault(); // prevents from executing routeMissing, by default
		                }
		            });
	
		            router.bind("routeMissing", function(e) {
		                if (!that.historyCallback(e.url, e.params, e.backButtonPressed)) {
		                    e.preventDefault();
		                }
		            });
	
		            router.bind("same", function() {
		                that.trigger(SAME_VIEW_REQUESTED);
		            });
	
		            that._historyNavigate = function(url) {
		                router.navigate(url);
		            };
	
		            that._historyReplace = function(url) {
		                router.replace(url);
		            };
		        },
	
		        hideLoading: function() {
		            this.loader.hide();
		        },
	
		        showLoading: function() {
		            this.loader.show();
		        },
	
		        changeLoadingMessage: function(message) {
		            this.loader.changeMessage(message);
		        },
	
		        view: function() {
		            return this.viewEngine.view();
		        },
	
		        _setPortraitWidth: function() {
		            var width,
		                portraitWidth = this.options.portraitWidth;
	
		            if (portraitWidth) {
		                width = kendo.mobile.application.element.is(".km-vertical") ? portraitWidth : "auto";
		                this.element.css("width", width);
		            }
		        },
	
		        _setupAppLinks: function() {
		            var that = this,
		                linkRoles = "tab",
		                pressedButtonSelector = "[data-" + kendo.ns + "navigate-on-press]",
	
		                buttonSelectors = $.map(["button", "backbutton", "detailbutton", "listview-link"] , function(role) {
		                    return roleSelector(role) + ":not(" + pressedButtonSelector + ")";
		                }).join(",");
	
		            this.element.handler(this)
		                .on("down", roleSelector(linkRoles) + "," + pressedButtonSelector, "_mouseup")
		                .on("click", roleSelector(linkRoles) + "," + buttonSelectors + "," + pressedButtonSelector, "_appLinkClick");
	
		            this.userEvents = new kendo.UserEvents(this.element, {
		                fastTap: true,
		                filter: buttonSelectors,
		                tap: function(e) {
		                    e.event.currentTarget = e.touch.currentTarget;
		                    that._mouseup(e.event);
		                }
		            });
	
		            // remove the ms-touch-action added by the user events, breaks native scrolling in WP8
		            this.element.css('-ms-touch-action', '');
		        },
	
		        _appLinkClick: function (e) {
		            var href = $(e.currentTarget).attr("href");
		            var remote = href && href[0] !== "#" && this.options.serverNavigation;
	
		            if(!remote && attrValue($(e.currentTarget), "rel") != EXTERNAL) {
		                e.preventDefault();
		            }
		        },
	
		        _mouseup: function(e) {
		            if (e.which > 1 || e.isDefaultPrevented()) {
		                return;
		            }
	
		            var pane = this,
		                link = $(e.currentTarget),
		                transition = attrValue(link, "transition"),
		                rel = attrValue(link, "rel") || "",
		                target = attrValue(link, "target"),
		                href = link.attr(HREF),
		                delayedTouchEnd = SKIP_TRANSITION_ON_BACK_BUTTON && link[0].offsetHeight === 0,
		                remote = href && href[0] !== "#" && this.options.serverNavigation;
	
		            if (delayedTouchEnd || remote || rel === EXTERNAL || (typeof href === "undefined") || href === DUMMY_HREF) {
		                return;
		            }
	
		            // Prevent iOS address bar progress display for in app navigation
		            link.attr(HREF, DUMMY_HREF);
		            setTimeout(function() { link.attr(HREF, href); });
	
		            if (rel.match(WIDGET_RELS)) {
		                kendo.widgetInstance($(href), ui).openFor(link);
		                // if propagation is not stopped and actionsheet is opened from tabstrip,
		                // the actionsheet is closed immediately.
		                if (rel === "actionsheet" || rel === "drawer") {
		                    e.stopPropagation();
		                }
		            } else {
		                if (target === "_top") {
		                    pane = mobile.application.pane;
		                }
		                else if (target) {
		                    pane = $("#" + target).data("kendoMobilePane");
		                }
	
		                pane.navigate(href, transition);
		            }
	
		            e.preventDefault();
		        }
		    });
	
		    Pane.wrap = function(element) {
		        if (!element.is(roleSelector("view"))) {
		            element = element.wrap('<div data-' + kendo.ns + 'role="view" data-stretch="true"></div>').parent();
		        }
	
		        var paneContainer = element.wrap('<div class="km-pane-wrapper"><div></div></div>').parent(),
		            pane = new Pane(paneContainer);
	
		        pane.navigate("");
	
		        return pane;
		    };
		    ui.plugin(Pane);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1241);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1241:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.loader",
		    name: "Loader",
		    category: "mobile",
		    description: "Mobile Loader",
		    depends: [ "core" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        Widget = ui.Widget,
		        CAPTURE_EVENTS = $.map(kendo.eventMap, function(value) { return value; }).join(" ").split(" ");
	
		    var Loader = Widget.extend({
		        init: function(container, options) {
		            var that = this,
		                element = $('<div class="km-loader"><span class="km-loading km-spin"></span><span class="km-loading-left"></span><span class="km-loading-right"></span></div>');
	
		            Widget.fn.init.call(that, element, options);
	
		            that.container = container;
		            that.captureEvents = false;
	
		            that._attachCapture();
	
		            element.append(that.options.loading).hide().appendTo(container);
		        },
	
		        options: {
		            name: "Loader",
		            loading: "<h1>Loading...</h1>",
		            timeout: 100
		        },
	
		        show: function() {
		            var that = this;
	
		            clearTimeout(that._loading);
	
		            if (that.options.loading === false) {
		                return;
		            }
	
		            that.captureEvents = true;
		            that._loading = setTimeout(function() {
		                that.element.show();
		            }, that.options.timeout);
		        },
	
		        hide: function() {
		            this.captureEvents = false;
		            clearTimeout(this._loading);
		            this.element.hide();
		        },
	
		        changeMessage: function(message) {
		            this.options.loading = message;
		            this.element.find(">h1").html(message);
		        },
	
		        transition: function() {
		            this.captureEvents = true;
		            this.container.css("pointer-events", "none");
		        },
	
		        transitionDone: function() {
		            this.captureEvents = false;
		            this.container.css("pointer-events", "");
		        },
	
		        _attachCapture: function() {
		            var that = this;
		            that.captureEvents = false;
	
		            function capture(e) {
		                if (that.captureEvents) {
		                    e.preventDefault();
		                }
		            }
	
		            for (var i = 0; i < CAPTURE_EVENTS.length; i ++) {
		                that.container[0].addEventListener(CAPTURE_EVENTS[i], capture, true);
		            }
		        }
		    });
	
		    ui.plugin(Loader);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1252);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1056:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(584);
	
	/***/ }),
	
	/***/ 1252:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1054), __webpack_require__(1022), __webpack_require__(1056) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.view",
		    name: "View",
		    category: "mobile",
		    description: "Mobile View",
		    depends: [ "core", "fx", "mobile.scroller", "view" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        ui = mobile.ui,
		        attr = kendo.attr,
		        Widget = ui.Widget,
		        ViewClone = kendo.ViewClone,
		        INIT = "init",
		        UI_OVERLAY = '<div style="height: 100%; width: 100%; position: absolute; top: 0; left: 0; z-index: 20000; display: none" />',
		        BEFORE_SHOW = "beforeShow",
		        SHOW = "show",
		        AFTER_SHOW = "afterShow",
		        BEFORE_HIDE = "beforeHide",
		        TRANSITION_END = "transitionEnd",
		        TRANSITION_START = "transitionStart",
		        HIDE = "hide",
		        DESTROY = "destroy",
		        attrValue = kendo.attrValue,
		        roleSelector = kendo.roleSelector,
		        directiveSelector = kendo.directiveSelector,
		        compileMobileDirective = kendo.compileMobileDirective;
	
		    function initPopOvers(element) {
		        var popovers = element.find(roleSelector("popover")),
		            idx, length,
		            roles = ui.roles;
	
		        for (idx = 0, length = popovers.length; idx < length; idx ++) {
		            kendo.initWidget(popovers[idx], {}, roles);
		        }
		    }
	
		    function preventScrollIfNotInput(e) {
		        if (!kendo.triggeredByInput(e)) {
		            e.preventDefault();
		        }
		    }
	
		    var View = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
		            this.params = {};
	
		            $.extend(this, options);
	
		            this.transition = this.transition || this.defaultTransition;
	
		            this._id();
	
		            if (!this.options.$angular) {
		                this._layout();
		                this._overlay();
		                this._scroller();
		                this._model();
		            } else {
		                this._overlay();
		            }
		        },
	
		        events: [
		            INIT,
		            BEFORE_SHOW,
		            SHOW,
		            AFTER_SHOW,
		            BEFORE_HIDE,
		            HIDE,
		            DESTROY,
		            TRANSITION_START,
		            TRANSITION_END
		        ],
	
		        options: {
		            name: "View",
		            title: "",
		            layout: null,
		            getLayout: $.noop,
		            reload: false,
		            transition: "",
		            defaultTransition: "",
		            useNativeScrolling: false,
		            stretch: false,
		            zoom: false,
		            model: null,
		            modelScope: window,
		            scroller: {},
		            initWidgets: true
		        },
	
		        enable: function(enable) {
		            if(typeof enable == "undefined") {
		                enable = true;
		            }
	
		            if(enable) {
		                this.overlay.hide();
		            } else {
		                this.overlay.show();
		            }
		        },
	
		        destroy: function() {
		            if (this.layout) {
		                this.layout.detach(this);
		            }
	
		            this.trigger(DESTROY);
	
	
		            Widget.fn.destroy.call(this);
	
		            if (this.scroller) {
		                this.scroller.destroy();
		            }
	
		            if (this.options.$angular) {
		                this.element.scope().$destroy();
		            }
	
		            kendo.destroy(this.element);
		        },
	
		        purge: function() {
		            this.destroy();
		            this.element.remove();
		        },
	
		        triggerBeforeShow: function() {
		            if (this.trigger(BEFORE_SHOW, { view: this })) {
		                return false;
		            }
		            return true;
		        },
	
		        triggerBeforeHide: function() {
		            if (this.trigger(BEFORE_HIDE, { view: this })) {
		                return false;
		            }
		            return true;
		        },
	
		        showStart: function() {
		            var element = this.element;
	
		            element.css("display", "");
	
		            if (!this.inited) {
		                this.inited = true;
		                this.trigger(INIT, {view: this});
		            } else { // skip the initial controller update
		                this._invokeNgController();
		            }
	
		            if (this.layout) {
		                this.layout.attach(this);
		            }
	
		            this._padIfNativeScrolling();
		            this.trigger(SHOW, {view: this});
		            kendo.resize(element);
		        },
	
		        showEnd: function() {
		            this.trigger(AFTER_SHOW, {view: this});
		            this._padIfNativeScrolling();
		        },
	
		        hideEnd: function() {
		            var that = this;
		            that.element.hide();
		            that.trigger(HIDE, {view: that});
	
		            if (that.layout) {
		                that.layout.trigger(HIDE, { view : that, layout: that.layout });
		            }
		        },
	
		        beforeTransition: function(type){
		            this.trigger(TRANSITION_START, { type: type });
		        },
	
		        afterTransition: function(type){
		            this.trigger(TRANSITION_END, { type: type });
		        },
	
		        _padIfNativeScrolling: function() {
		            if (mobile.appLevelNativeScrolling()) {
		                var isAndroid = kendo.support.mobileOS && kendo.support.mobileOS.android,
		                    skin = mobile.application.skin() || "",
		                    isAndroidForced = mobile.application.os.android || (skin.indexOf("android") > -1),
		                    hasPlatformIndependentSkin = skin === "flat" || (skin.indexOf("material") > -1),
		                    topContainer = (isAndroid || isAndroidForced) && (!hasPlatformIndependentSkin) ? "footer" : "header",
		                    bottomContainer = (isAndroid || isAndroidForced) && (!hasPlatformIndependentSkin) ? "header" : "footer";
	
		                this.content.css({
		                    paddingTop: this[topContainer].height(),
		                    paddingBottom: this[bottomContainer].height()
		                });
		            }
		        },
	
		        contentElement: function() {
		            var that = this;
	
		            return that.options.stretch ? that.content : that.scrollerContent;
		        },
	
		        clone: function() {
		            return new ViewClone(this);
		        },
	
		        _scroller: function() {
		            var that = this;
	
		            if (mobile.appLevelNativeScrolling()) {
		                return;
		            }
		            if (that.options.stretch) {
		                that.content.addClass("km-stretched-view");
		            } else {
		                that.content.kendoMobileScroller($.extend(that.options.scroller, { zoom: that.options.zoom, useNative: that.options.useNativeScrolling }));
	
		                that.scroller = that.content.data("kendoMobileScroller");
		                that.scrollerContent = that.scroller.scrollElement;
		            }
	
		            // prevent accidental address bar display when pulling the header
		            if (kendo.support.kineticScrollNeeded) {
		                $(that.element).on("touchmove", ".km-header", preventScrollIfNotInput);
		                if (!that.options.useNativeScrolling && !that.options.stretch) {
		                    $(that.element).on("touchmove", ".km-content", preventScrollIfNotInput);
		                }
		            }
		        },
	
		        _model: function() {
		            var that = this,
		                element = that.element,
		                model = that.options.model;
	
		            if (typeof model === "string") {
		                model = kendo.getter(model)(that.options.modelScope);
		            }
	
		            that.model = model;
	
		            initPopOvers(element);
	
		            that.element.css("display", "");
		            if (that.options.initWidgets) {
		                if (model) {
		                    kendo.bind(element, model, ui, kendo.ui, kendo.dataviz.ui);
		                } else {
		                    mobile.init(element.children());
		                }
		            }
		            that.element.css("display", "none");
		        },
	
		        _id: function() {
		            var element = this.element,
		                idAttrValue = element.attr("id") || "";
	
		            this.id = attrValue(element, "url") || "#" + idAttrValue;
	
		            if (this.id == "#") {
		                this.id = kendo.guid();
		                element.attr("id", this.id);
		            }
		        },
	
		        _layout: function() {
		            var contentSelector = roleSelector("content"),
		                element = this.element;
	
		            element.addClass("km-view");
	
		            this.header = element.children(roleSelector("header")).addClass("km-header");
		            this.footer = element.children(roleSelector("footer")).addClass("km-footer");
	
		            if (!element.children(contentSelector)[0]) {
		              element.wrapInner("<div " + attr("role") + '="content"></div>');
		            }
	
		            this.content = element.children(roleSelector("content"))
		                                .addClass("km-content");
	
		            this.element.prepend(this.header).append(this.footer);
	
	
		            this.layout = this.options.getLayout(this.layout);
	
		            if (this.layout) {
		                this.layout.setup(this);
		            }
		        },
	
		        _overlay: function() {
		            this.overlay = $(UI_OVERLAY).appendTo(this.element);
		        },
	
		        _invokeNgController: function() {
		            var controller,
		                scope;
	
		            if (this.options.$angular) {
		                controller = this.element.controller();
		                scope = this.options.$angular[0];
	
		                if (controller) {
		                    var callback = $.proxy(this, '_callController', controller, scope);
	
		                    if (/^\$(digest|apply)$/.test(scope.$$phase)) {
		                        callback();
		                    } else {
		                        scope.$apply(callback);
		                    }
		                }
		            }
		        },
	
		        _callController: function(controller, scope) {
		            this.element.injector().invoke(controller.constructor, controller, { $scope: scope });
		        }
		    });
	
		    function initWidgets(collection) {
		        collection.each(function() {
		            kendo.initWidget($(this), {}, ui.roles);
		        });
		    }
	
		    var Layout = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            element = this.element;
	
		            this.header = element.children(this._locate("header")).addClass("km-header");
		            this.footer = element.children(this._locate("footer")).addClass("km-footer");
		            this.elements = this.header.add(this.footer);
	
		            initPopOvers(element);
	
		            if (!this.options.$angular) {
		                kendo.mobile.init(this.element.children());
		            }
		            this.element.detach();
		            this.trigger(INIT, {layout: this});
		        },
	
		        _locate: function(selectors) {
		            return this.options.$angular ? directiveSelector(selectors) : roleSelector(selectors);
		        },
	
		        options: {
		            name: "Layout",
		            id: null,
		            platform: null
		        },
	
		        events: [
		            INIT,
		            SHOW,
		            HIDE
		        ],
	
		        setup: function(view) {
		            if (!view.header[0]) { view.header = this.header; }
		            if (!view.footer[0]) { view.footer = this.footer; }
		        },
	
		        detach: function(view) {
		            var that = this;
		            if (view.header === that.header && that.header[0]) {
		                view.element.prepend(that.header.detach()[0].cloneNode(true));
		            }
	
		            if (view.footer === that.footer && that.footer.length) {
		                view.element.append(that.footer.detach()[0].cloneNode(true));
		            }
		        },
	
		        attach: function(view) {
		            var that = this,
		                previousView = that.currentView;
	
		            if (previousView) {
		                that.detach(previousView);
		            }
	
		            if (view.header === that.header) {
		                that.header.detach();
		                view.element.children(roleSelector("header")).remove();
		                view.element.prepend(that.header);
		            }
	
		            if (view.footer === that.footer) {
		                that.footer.detach();
		                view.element.children(roleSelector("footer")).remove();
		                view.element.append(that.footer);
		            }
	
		            that.trigger(SHOW, {layout: that, view: view});
		            that.currentView = view;
		        }
		    });
	
		    var Observable = kendo.Observable,
		        bodyRegExp = /<body[^>]*>(([\u000a\u000d\u2028\u2029]|.)*)<\/body>/i,
		        LOAD_START = "loadStart",
		        LOAD_COMPLETE = "loadComplete",
		        SHOW_START = "showStart",
		        SAME_VIEW_REQUESTED = "sameViewRequested",
		        VIEW_SHOW = "viewShow",
		        VIEW_TYPE_DETERMINED = "viewTypeDetermined",
		        AFTER = "after";
	
		    var ViewEngine = Observable.extend({
		        init: function(options) {
		            var that = this,
		                views,
		                errorMessage,
		                container,
		                collection;
	
		            Observable.fn.init.call(that);
	
		            $.extend(that, options);
		            that.sandbox = $("<div />");
		            container = that.container;
	
		            views = that._hideViews(container);
		            that.rootView = views.first();
	
		            if (!that.rootView[0] && options.rootNeeded) {
		                if (container[0] == kendo.mobile.application.element[0]) {
		                    errorMessage = 'Your kendo mobile application element does not contain any direct child elements with data-role="view" attribute set. Make sure that you instantiate the mobile application using the correct container.';
		                } else {
		                    errorMessage = 'Your pane element does not contain any direct child elements with data-role="view" attribute set.';
		                }
		                throw new Error(errorMessage);
		            }
	
		            that.layouts = {};
	
		            that.viewContainer = new kendo.ViewContainer(that.container);
	
		            that.viewContainer.bind("accepted", function(e) {
		                e.view.params = that.params;
		            });
	
		            that.viewContainer.bind("complete", function(e) {
		                that.trigger(VIEW_SHOW, { view: e.view });
		            });
	
		            that.viewContainer.bind(AFTER, function() {
		                that.trigger(AFTER);
		            });
	
		            this.getLayoutProxy = $.proxy(this, "_getLayout");
		            that._setupLayouts(container);
	
		            collection = container.children(that._locate("modalview drawer"));
		            if (that.$angular) {
	
		                that.$angular[0].viewOptions = {
		                    defaultTransition: that.transition,
		                    loader: that.loader,
		                    container: that.container,
		                    getLayout: that.getLayoutProxy
		                };
	
		                collection.each(function(idx, element) {
		                    compileMobileDirective($(element), options.$angular[0]);
		                });
		            } else {
		                initWidgets(collection);
		            }
	
		            this.bind(this.events, options);
		        },
	
		        events: [
		            SHOW_START,
		            AFTER,
		            VIEW_SHOW,
		            LOAD_START,
		            LOAD_COMPLETE,
		            SAME_VIEW_REQUESTED,
		            VIEW_TYPE_DETERMINED
		        ],
	
		        destroy: function() {
		            kendo.destroy(this.container);
	
		            for (var id in this.layouts) {
		                this.layouts[id].destroy();
		            }
		        },
	
		        view: function() {
		            return this.viewContainer.view;
		        },
	
		        showView: function(url, transition, params) {
		            url = url.replace(new RegExp("^" + this.remoteViewURLPrefix), "");
		            if (url === "" && this.remoteViewURLPrefix) {
		                url = "/";
		            }
	
		            if (url.replace(/^#/, "") === this.url) {
		                this.trigger(SAME_VIEW_REQUESTED);
		                return false;
		            }
	
		            this.trigger(SHOW_START);
	
		            var that = this,
		                showClosure = function(view) {
		                    return that.viewContainer.show(view, transition, url);
		                },
		                element = that._findViewElement(url),
		                view = kendo.widgetInstance(element);
	
		            that.url = url.replace(/^#/, "");
	
		            that.params = params;
	
		            if (view && view.reload) {
		                view.purge();
		                element = [];
		            }
	
		            this.trigger(VIEW_TYPE_DETERMINED, { remote: element.length === 0, url: url });
	
		            if (element[0]) {
		                if (!view) {
		                    view = that._createView(element);
		                }
	
		                return showClosure(view);
		            } else {
		                if (this.serverNavigation) {
		                    location.href = url;
		                } else {
		                    that._loadView(url, showClosure);
		                }
		                return true;
		            }
		        },
	
		        append: function(html, url) {
		            var sandbox = this.sandbox,
		                urlPath = (url || "").split("?")[0],
		                container = this.container,
		                views,
		                modalViews,
		                view;
	
		            if (bodyRegExp.test(html)) {
		                html = RegExp.$1;
		            }
	
		            sandbox[0].innerHTML = html;
	
		            container.append(sandbox.children("script, style"));
	
		            views = this._hideViews(sandbox);
		            view = views.first();
	
		            // Generic HTML content found as remote view - no remote view markers
		            if (!view.length) {
		                views = view = sandbox.wrapInner("<div data-role=view />").children(); // one element
		            }
	
		            if (urlPath) {
		                view.hide().attr(attr("url"), urlPath);
		            }
	
		            this._setupLayouts(sandbox);
	
		            modalViews = sandbox.children(this._locate("modalview drawer"));
	
		            container.append(sandbox.children(this._locate("layout modalview drawer")).add(views));
	
		            // Initialize the modalviews after they have been appended to the final container
		            initWidgets(modalViews);
	
		            return this._createView(view);
		        },
	
		        _locate: function(selectors) {
		            return this.$angular ? directiveSelector(selectors) : roleSelector(selectors);
		        },
	
		        _findViewElement: function(url) {
		            var element,
		                urlPath = url.split("?")[0];
	
		            if (!urlPath) {
		                return this.rootView;
		            }
	
		            element = this.container.children("[" + attr("url") + "='" + urlPath + "']");
	
		            // do not try to search for "#/foo/bar" id, jQuery throws error
		            if (!element[0] && urlPath.indexOf("/") === -1) {
		                element = this.container.children(urlPath.charAt(0) === "#" ? urlPath : "#" + urlPath);
		            }
	
		            return element;
		        },
	
		        _createView: function(element) {
		            if (this.$angular) {
		                return compileMobileDirective(element, this.$angular[0]);
		            } else {
		                return kendo.initWidget(element, {
		                    defaultTransition: this.transition,
		                    loader: this.loader,
		                    container: this.container,
		                    getLayout: this.getLayoutProxy,
		                    modelScope: this.modelScope,
		                    reload: attrValue(element, "reload")
		                }, ui.roles);
		            }
		        },
	
		        _getLayout: function(name) {
		            if (name === "") {
		                return null;
		            }
	
		            return name ? this.layouts[name] : this.layouts[this.layout];
		        },
	
		        _loadView: function(url, callback) {
		            if (this._xhr) {
		                this._xhr.abort();
		            }
	
		            this.trigger(LOAD_START);
	
		            this._xhr = $.get(kendo.absoluteURL(url, this.remoteViewURLPrefix), "html")
		                .always($.proxy(this, "_xhrComplete", callback, url));
		        },
	
		        _xhrComplete: function(callback, url, response) {
		            var success = true;
	
		            if (typeof response === "object") {
		                if (response.status === 0) {
		                    if (response.responseText && response.responseText.length > 0) {
		                        success = true;
		                        response = response.responseText;
		                    } else { // request has been aborted for real
		                        return;
		                    }
		                }
		            }
	
		            this.trigger(LOAD_COMPLETE);
	
		            if (success) {
		                callback(this.append(response, url));
		            }
		        },
	
		        _hideViews: function(container) {
		            return container.children(this._locate("view splitview")).hide();
		        },
	
		        _setupLayouts: function(element) {
		            var that = this,
		                layout;
	
		            element.children(that._locate("layout")).each(function() {
		                if (that.$angular) {
		                    layout = compileMobileDirective($(this), that.$angular[0]);
		                } else {
		                    layout = kendo.initWidget($(this), {}, ui.roles);
		                }
	
		                var platform = layout.options.platform;
	
		                if (!platform || platform === mobile.application.os.name) {
		                    that.layouts[layout.options.id] = layout;
		                } else {
		                    layout.destroy();
		                }
		            });
	
		        }
		    });
	
		    kendo.mobile.ViewEngine = ViewEngine;
	
		    ui.plugin(View);
		    ui.plugin(Layout);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1257);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1257:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1258) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "ooxml",
		    name: "XLSX generation",
		    category: "framework",
		    advanced: true,
		    depends: [ "core" ]
		};
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1258:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(626);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1440);
		module.exports = __webpack_require__(1440);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1440:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(19),
		        __webpack_require__(1441)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		var Workbook = kendo.ooxml.Workbook;
	
		kendo.ooxml.IntlService.register({
		    toString: kendo.toString
		});
	
		kendo.ooxml.Workbook = Workbook.extend({
		    toDataURL: function() {
		        var result = Workbook.fn.toDataURL.call(this);
		        if (typeof result !== 'string') {
		            throw new Error('The toDataURL method can be used only with jsZip 2. Either include jsZip 2 or use the toDataURLAsync method.');
		        }
	
		        return result;
		    },
	
		    toDataURLAsync: function() {
		        var deferred = $.Deferred();
		        var result = Workbook.fn.toDataURL.call(this);
		        if (typeof result === 'string') {
		            result = deferred.resolve(result);
		        } else if (result && result.then){
		            result.then(function(dataURI) {
		                deferred.resolve(dataURI);
		            }, function() {
		                deferred.reject();
		            });
		        }
	
		        return deferred.promise();
		    }
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1441:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(627);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1439);
		module.exports = __webpack_require__(1439);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 879:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(628);
	
	/***/ }),
	
	/***/ 1439:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(19),
		        __webpack_require__(879)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
		/* jshint eqnull:true */
		/* jshint laxbreak:true */
	
		window.kendo.ooxml = window.kendo.ooxml || {};
		var ooxml = kendo.ooxml;
	
		var map = $.map;
		var createZip = ooxml.createZip;
	
		var current = {
		    toString: function (value) { return value; }
		};
	
		var IntlService = kendo.Class.extend({
	
		});
	
		IntlService.register = function(userImplementation) {
		    current = userImplementation;
		};
	
		IntlService.toString = function(value, format) {
		    return current.toString(value, format);
		};
	
		// date packing utilities from Kendo Spreadsheet
	
		// Julian days algorithms from http://www.hermetic.ch/cal_stud/jdn.htm#comp
		function dateToJulianDays(y, m, d) {
		    return ((1461 * (y + 4800 + ((m - 13) / 12 | 0))) / 4 | 0) +
		        ((367 * (m - 1 - 12 * ((m - 13) / 12 | 0))) / 12 | 0) -
		        ((3 * (((y + 4900 + ((m - 13) / 12 | 0)) / 100 | 0))) / 4 | 0) +
		        d - 32075;
		}
	
		// This uses the Google Spreadsheet approach: treat 1899-12-31 as day 1, allowing to avoid
		// implementing the "Leap Year Bug" yet still be Excel compatible for dates starting 1900-03-01.
		var BASE_DATE = dateToJulianDays(1900, 0, -1);
	
		function packDate(year, month, date) {
		    return dateToJulianDays(year, month, date) - BASE_DATE;
		}
	
		function packTime(hh, mm, ss, ms) {
		    return (hh + (mm + (ss + ms / 1000) / 60) / 60) / 24;
		}
	
		function dateToSerial(date) {
		    var time = packTime(date.getHours(),
		                          date.getMinutes(),
		                          date.getSeconds(),
		                          date.getMilliseconds());
		    var serial = packDate(date.getFullYear(),
		                            date.getMonth(),
		                            date.getDate());
		    return serial < 0 ? serial - 1 + time : serial + time;
		}
	
		var DATA_URL_PREFIX = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
		var DATA_URL_OPTIONS = { compression: "DEFLATE", type: "base64" };
	
		/* eslint-disable key-spacing, no-arrow-condition, indent, no-nested-ternary, consistent-return */
	
		function toDataURI(content) {
		    return DATA_URL_PREFIX + content;
		}
	
		function indexOf(thing, array) {
		    return array.indexOf(thing);
		}
	
		var parseJSON = JSON.parse.bind(JSON);
	
		function ESC(val) {
		    return String(val)
		        .replace(/&/g, "&amp;")
		        .replace(/</g, "&lt;")
		        .replace(/>/g, "&gt;")
		        .replace(/\"/g, "&quot;")
		        .replace(/\'/g, "&#39;");
		}
	
		function repeat(count, func) {
		    var str = "";
		    for (var i = 0; i < count; ++i) {
		        str += func(i);
		    }
		    return str;
		}
	
		function foreach(arr, func) {
		    var str = "";
		    for (var i = 0; i < arr.length; ++i) {
		        str += func(arr[i], i);
		    }
		    return str;
		}
	
		var XMLHEAD = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r';
	
		var RELS = XMLHEAD + "\n            <Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n               <Relationship Id=\"rId3\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties\" Target=\"docProps/app.xml\"/>\n               <Relationship Id=\"rId2\" Type=\"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties\" Target=\"docProps/core.xml\"/>\n               <Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument\" Target=\"xl/workbook.xml\"/>\n            </Relationships>";
	
		var CORE = function (ref) {
		  var creator = ref.creator;
		  var lastModifiedBy = ref.lastModifiedBy;
		  var created = ref.created;
		  var modified = ref.modified;
	
		  return (XMLHEAD + "\n <cp:coreProperties xmlns:cp=\"http://schemas.openxmlformats.org/package/2006/metadata/core-properties\"\n   xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:dcterms=\"http://purl.org/dc/terms/\"\n   xmlns:dcmitype=\"http://purl.org/dc/dcmitype/\" xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\">\n   <dc:creator>" + (ESC(creator)) + "</dc:creator>\n   <cp:lastModifiedBy>" + (ESC(lastModifiedBy)) + "</cp:lastModifiedBy>\n   <dcterms:created xsi:type=\"dcterms:W3CDTF\">" + (ESC(created)) + "</dcterms:created>\n   <dcterms:modified xsi:type=\"dcterms:W3CDTF\">" + (ESC(modified)) + "</dcterms:modified>\n</cp:coreProperties>");
		};
	
		var APP = function (ref) {
		  var sheets = ref.sheets;
	
		  return (XMLHEAD + "\n<Properties xmlns=\"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties\" xmlns:vt=\"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes\">\n  <Application>Microsoft Excel</Application>\n  <DocSecurity>0</DocSecurity>\n  <ScaleCrop>false</ScaleCrop>\n  <HeadingPairs>\n    <vt:vector size=\"2\" baseType=\"variant\">\n      <vt:variant>\n        <vt:lpstr>Worksheets</vt:lpstr>\n      </vt:variant>\n      <vt:variant>\n        <vt:i4>" + (sheets.length) + "</vt:i4>\n      </vt:variant>\n    </vt:vector>\n  </HeadingPairs>\n  <TitlesOfParts>\n    <vt:vector size=\"" + (sheets.length) + "\" baseType=\"lpstr\">" + (foreach(sheets, function (sheet, i) { return sheet.options.title
		          ? ("<vt:lpstr>" + (ESC(sheet.options.title)) + "</vt:lpstr>")
		          : ("<vt:lpstr>Sheet" + (i + 1) + "</vt:lpstr>"); }
		      )) + "</vt:vector>\n  </TitlesOfParts>\n  <LinksUpToDate>false</LinksUpToDate>\n  <SharedDoc>false</SharedDoc>\n  <HyperlinksChanged>false</HyperlinksChanged>\n  <AppVersion>14.0300</AppVersion>\n</Properties>");
		};
	
		var CONTENT_TYPES = function (ref) {
		  var count = ref.count;
	
		  return (XMLHEAD + "\n<Types xmlns=\"http://schemas.openxmlformats.org/package/2006/content-types\">\n  <Default Extension=\"rels\" ContentType=\"application/vnd.openxmlformats-package.relationships+xml\" />\n  <Default Extension=\"xml\" ContentType=\"application/xml\" />\n  <Override PartName=\"/xl/workbook.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml\" />\n  <Override PartName=\"/xl/styles.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml\"/>\n  <Override PartName=\"/xl/sharedStrings.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml\"/>\n  " + (repeat(count, function (idx) { return ("<Override PartName=\"/xl/worksheets/sheet" + (idx + 1) + ".xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml\" />"); })) + "\n  <Override PartName=\"/docProps/core.xml\" ContentType=\"application/vnd.openxmlformats-package.core-properties+xml\" />\n  <Override PartName=\"/docProps/app.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.extended-properties+xml\" />\n</Types>");
		};
	
		var WORKBOOK = function (ref) {
		  var sheets = ref.sheets;
		  var filterNames = ref.filterNames;
		  var userNames = ref.userNames;
	
		  return (XMLHEAD + "\n<workbook xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\">\n  <fileVersion appName=\"xl\" lastEdited=\"5\" lowestEdited=\"5\" rupBuild=\"9303\" />\n  <workbookPr defaultThemeVersion=\"124226\" />\n  <bookViews>\n    <workbookView xWindow=\"240\" yWindow=\"45\" windowWidth=\"18195\" windowHeight=\"7995\" />\n  </bookViews>\n  <sheets>\n  " + (foreach(sheets, function (ref, i) {
		    var options = ref.options;
	
		    var name = options.name || options.title || ("Sheet" + (i + 1));
		    return ("<sheet name=\"" + (ESC(name)) + "\" sheetId=\"" + (i + 1) + "\" r:id=\"rId" + (i + 1) + "\" />");
		  })) + "\n  </sheets>\n  " + (filterNames.length || userNames.length ? ("\n    <definedNames>\n      " + (foreach(filterNames, function (f) { return ("\n         <definedName name=\"_xlnm._FilterDatabase\" hidden=\"1\" localSheetId=\"" + (f.localSheetId) + "\">" + (ESC(f.name)) + "!" + (ESC(f.from)) + ":" + (ESC(f.to)) + "</definedName>"); })) + "\n      " + (foreach(userNames, function (f) { return ("\n         <definedName name=\"" + (f.name) + "\" hidden=\"" + (f.hidden ? 1 : 0) + "\" " + (f.localSheetId != null ? ("localSheetId=\"" + (f.localSheetId) + "\"") : '') + ">" + (ESC(f.value)) + "</definedName>"); })) + "\n    </definedNames>") : '') + "\n  <calcPr fullCalcOnLoad=\"1\" calcId=\"145621\" />\n</workbook>");
		};
	
		var WORKSHEET = function (ref) {
		  var frozenColumns = ref.frozenColumns;
		  var frozenRows = ref.frozenRows;
		  var columns = ref.columns;
		  var defaults = ref.defaults;
		  var data = ref.data;
		  var index = ref.index;
		  var mergeCells = ref.mergeCells;
		  var autoFilter = ref.autoFilter;
		  var filter = ref.filter;
		  var showGridLines = ref.showGridLines;
		  var hyperlinks = ref.hyperlinks;
		  var validations = ref.validations;
		  var defaultCellStyleId = ref.defaultCellStyleId;
		  var rtl = ref.rtl;
	
		  return (XMLHEAD + "\n<worksheet xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\" xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\" mc:Ignorable=\"x14ac\">\n   <dimension ref=\"A1\" />\n\n   <sheetViews>\n     <sheetView " + (rtl ? 'rightToLeft="1"' : '') + " " + (index === 0 ? 'tabSelected="1"' : '') + " workbookViewId=\"0\" " + (showGridLines === false ? 'showGridLines="0"' : '') + ">\n     " + (frozenRows || frozenColumns ? ("\n       <pane state=\"frozen\"\n         " + (frozenColumns ? ("xSplit=\"" + frozenColumns + "\"") : '') + "\n         " + (frozenRows ? ("ySplit=\"" + frozenRows + "\"") : '') + "\n         topLeftCell=\"" + (String.fromCharCode(65 + (frozenColumns || 0)) + ((frozenRows || 0) + 1)) + "\"\n       />") : '') + "\n     </sheetView>\n   </sheetViews>\n\n   <sheetFormatPr x14ac:dyDescent=\"0.25\" customHeight=\"1\" defaultRowHeight=\"" + (defaults.rowHeight ? defaults.rowHeight * 0.75 : 15) + "\"\n     " + (defaults.columnWidth ? ("defaultColWidth=\"" + (toWidth(defaults.columnWidth)) + "\"") : '') + " />\n\n   " + (defaultCellStyleId != null || (columns && columns.length > 0) ? ("\n     <cols>\n       " + (!columns || !columns.length ? ("\n         <col min=\"1\" max=\"16384\" style=\"" + defaultCellStyleId + "\"\n              " + (defaults.columnWidth ? ("width=\"" + (toWidth(defaults.columnWidth)) + "\"") : '') + " /> ") : '') + "\n       " + (foreach(columns, function (column, ci) {
		         var columnIndex = typeof column.index === "number" ? column.index + 1 : (ci + 1);
		         if (column.width === 0) {
		           return ("<col " + (defaultCellStyleId != null ? ("style=\"" + defaultCellStyleId + "\"") : '') + "\n                        min=\"" + columnIndex + "\" max=\"" + columnIndex + "\" hidden=\"1\" customWidth=\"1\" />");
		         }
		         return ("<col " + (defaultCellStyleId != null ? ("style=\"" + defaultCellStyleId + "\"") : '') + "\n                      min=\"" + columnIndex + "\" max=\"" + columnIndex + "\" customWidth=\"1\"\n                      " + (column.autoWidth
		                          ? ("width=\"" + (((column.width * 7 + 5) / 7 * 256) / 256) + "\" bestFit=\"1\"")
		                          : ("width=\"" + (toWidth(column.width)) + "\"")) + " />");
		       })) + "\n     </cols>") : '') + "\n\n   <sheetData>\n     " + (foreach(data, function (row, ri) {
		       var rowIndex = typeof row.index === "number" ? row.index + 1 : (ri + 1);
		       return ("\n         <row r=\"" + rowIndex + "\" x14ac:dyDescent=\"0.25\"\n              " + (row.height === 0 ? 'hidden="1"'
		                                 : row.height ? ("ht=\"" + (toHeight(row.height)) + "\" customHeight=\"1\"") : "") + ">\n           " + (foreach(row.data, function (cell) { return ("\n             <c r=\"" + (cell.ref) + "\" " + (cell.style ? ("s=\"" + (cell.style) + "\"") : '') + " " + (cell.type ? ("t=\"" + (cell.type) + "\"") : '') + ">\n               " + (cell.formula != null ? writeFormula(cell.formula) : '') + "\n               " + (cell.value != null ? ("<v>" + (ESC(cell.value)) + "</v>") : '') + "\n             </c>"); })) + "\n         </row>\n       ");})) + "\n   </sheetData>\n\n   " + (autoFilter ? ("<autoFilter ref=\"" + (autoFilter.from) + ":" + (autoFilter.to) + "\"/>")
		                : filter ? spreadsheetFilters(filter) : '') + "\n\n   " + (mergeCells.length ? ("\n     <mergeCells count=\"" + (mergeCells.length) + "\">\n       " + (foreach(mergeCells, function (ref) { return ("<mergeCell ref=\"" + ref + "\"/>"); })) + "\n     </mergeCells>") : '') + "\n\n   " + (validations.length ? ("\n     <dataValidations>\n       " + (foreach(validations, function (val) { return ("\n         <dataValidation sqref=\"" + (val.sqref.join(" ")) + "\"\n                         showErrorMessage=\"" + (val.showErrorMessage) + "\"\n                         type=\"" + (ESC(val.type)) + "\"\n                         " + (val.type !== "list" ? ("operator=\"" + (ESC(val.operator)) + "\"") : '') + "\n                         allowBlank=\"" + (val.allowBlank) + "\"\n                         showDropDown=\"" + (val.showDropDown) + "\"\n                         " + (val.error ? ("error=\"" + (ESC(val.error)) + "\"") : '') + "\n                         " + (val.errorTitle ? ("errorTitle=\"" + (ESC(val.errorTitle)) + "\"") : '') + ">\n           " + (val.formula1 ? ("<formula1>" + (ESC(val.formula1)) + "</formula1>") : '') + "\n           " + (val.formula2 ? ("<formula2>" + (ESC(val.formula2)) + "</formula2>") : '') + "\n         </dataValidation>"); })) + "\n     </dataValidations>") : '') + "\n\n   " + (hyperlinks.length ? ("\n     <hyperlinks>\n       " + (foreach(hyperlinks, function (link, hi) { return ("\n         <hyperlink ref=\"" + (link.ref) + "\" r:id=\"rId" + hi + "\"/>"); })) + "\n     </hyperlinks>") : '') + "\n\n   <pageMargins left=\"0.7\" right=\"0.7\" top=\"0.75\" bottom=\"0.75\" header=\"0.3\" footer=\"0.3\" />\n</worksheet>");
		};
	
		var WORKBOOK_RELS = function (ref) {
		  var count = ref.count;
	
		  return (XMLHEAD + "\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n  " + (repeat(count, function (idx) { return ("\n    <Relationship Id=\"rId" + (idx + 1) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet\" Target=\"worksheets/sheet" + (idx + 1) + ".xml\" />"); })) + "\n  <Relationship Id=\"rId" + (count + 1) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles\" Target=\"styles.xml\" />\n  <Relationship Id=\"rId" + (count + 2) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings\" Target=\"sharedStrings.xml\" />\n</Relationships>");
		};
	
		var WORKSHEET_RELS = function (ref) {
		  var hyperlinks = ref.hyperlinks;
	
		  return (XMLHEAD + "\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n  " + (foreach(hyperlinks, function (link, i) { return ("\n    <Relationship Id=\"rId" + i + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink\" Target=\"" + (ESC(link.target)) + "\" TargetMode=\"External\" />"); })) + "\n</Relationships>");
		};
	
		var SHARED_STRINGS = function (ref) {
		  var count = ref.count;
		  var uniqueCount = ref.uniqueCount;
		  var indexes = ref.indexes;
	
		  return (XMLHEAD + "\n<sst xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" count=\"" + count + "\" uniqueCount=\"" + uniqueCount + "\">\n  " + (foreach(Object.keys(indexes), function (index) { return ("\n    <si><t xml:space=\"preserve\">" + (ESC(index.substring(1))) + "</t></si>"); })) + "\n</sst>");
		};
	
		var STYLES = function (ref) {
		  var formats = ref.formats;
		  var fonts = ref.fonts;
		  var fills = ref.fills;
		  var borders = ref.borders;
		  var styles = ref.styles;
	
		  return (XMLHEAD + "\n<styleSheet\n    xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\"\n    xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\"\n    mc:Ignorable=\"x14ac\"\n    xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\">\n  <numFmts count=\"" + (formats.length) + "\">\n  " + (foreach(formats, function (format, fi) { return ("\n    <numFmt formatCode=\"" + (ESC(format.format)) + "\" numFmtId=\"" + (165 + fi) + "\" />"); })) + "\n  </numFmts>\n  <fonts count=\"" + (fonts.length + 1) + "\" x14ac:knownFonts=\"1\">\n    <font>\n       <sz val=\"11\" />\n       <color theme=\"1\" />\n       <name val=\"Calibri\" />\n       <family val=\"2\" />\n       <scheme val=\"minor\" />\n    </font>\n    " + (foreach(fonts, function (font) { return ("\n    <font>\n      <sz val=\"" + (font.fontSize || 11) + "\" />\n      " + (font.bold ? '<b/>' : '') + "\n      " + (font.italic ? '<i/>' : '') + "\n      " + (font.underline ? '<u/>' : '') + "\n      " + (font.color ? ("<color rgb=\"" + (ESC(font.color)) + "\" />") : '<color theme="1" />') + "\n      " + (font.fontFamily ? ("\n        <name val=\"" + (ESC(font.fontFamily)) + "\" />\n        <family val=\"2\" />\n      ") : "\n        <name val=\"Calibri\" />\n        <family val=\"2\" />\n        <scheme val=\"minor\" />\n      ") + "\n    </font>"); })) + "\n  </fonts>\n  <fills count=\"" + (fills.length + 2) + "\">\n      <fill><patternFill patternType=\"none\"/></fill>\n      <fill><patternFill patternType=\"gray125\"/></fill>\n    " + (foreach(fills, function (fill) { return ("\n      " + (fill.background ? ("\n        <fill>\n          <patternFill patternType=\"solid\">\n              <fgColor rgb=\"" + (ESC(fill.background)) + "\"/>\n          </patternFill>\n        </fill>\n      ") : '')); })) + "\n  </fills>\n  <borders count=\"" + (borders.length + 1) + "\">\n    <border><left/><right/><top/><bottom/><diagonal/></border>\n    " + (foreach(borders, borderTemplate)) + "\n  </borders>\n  <cellStyleXfs count=\"1\">\n    <xf borderId=\"0\" fillId=\"0\" fontId=\"0\" />\n  </cellStyleXfs>\n  <cellXfs count=\"" + (styles.length + 1) + "\">\n    <xf numFmtId=\"0\" fontId=\"0\" fillId=\"0\" borderId=\"0\" xfId=\"0\" />\n    " + (foreach(styles, function (style) { return ("\n      <xf xfId=\"0\"\n          " + (style.fontId ? ("fontId=\"" + (style.fontId) + "\" applyFont=\"1\"") : '') + "\n          " + (style.fillId ? ("fillId=\"" + (style.fillId) + "\" applyFill=\"1\"") : '') + "\n          " + (style.numFmtId ? ("numFmtId=\"" + (style.numFmtId) + "\" applyNumberFormat=\"1\"") : '') + "\n          " + (style.textAlign || style.verticalAlign || style.wrap ? 'applyAlignment="1"' : '') + "\n          " + (style.borderId ? ("borderId=\"" + (style.borderId) + "\" applyBorder=\"1\"") : '') + ">\n        " + (style.textAlign || style.verticalAlign || style.wrap ? ("\n        <alignment\n          " + (style.textAlign ? ("horizontal=\"" + (ESC(style.textAlign)) + "\"") : '') + "\n          " + (style.verticalAlign ? ("vertical=\"" + (ESC(style.verticalAlign)) + "\"") : '') + "\n          " + (style.wrap ? 'wrapText="1"' : '') + " />\n        ") : '') + "\n      </xf>\n    "); })) + "\n  </cellXfs>\n  <cellStyles count=\"1\">\n    <cellStyle name=\"Normal\" xfId=\"0\" builtinId=\"0\"/>\n  </cellStyles>\n  <dxfs count=\"0\" />\n  <tableStyles count=\"0\" defaultTableStyle=\"TableStyleMedium2\" defaultPivotStyle=\"PivotStyleMedium9\" />\n</styleSheet>");
		};
	
		function writeFormula(formula) {
		    if (typeof formula == "string") {
		        return ("<f>" + (ESC(formula)) + "</f>");
		    }
		    // array formulas
		    return ("<f t=\"array\" ref=\"" + (formula.ref) + "\">" + (ESC(formula.src)) + "</f>");
		}
	
		function numChar(colIndex) {
		   var letter = Math.floor(colIndex / 26) - 1;
	
		   return (letter >= 0 ? numChar(letter) : "") + String.fromCharCode(65 + (colIndex % 26));
		}
	
		function ref(rowIndex, colIndex) {
		    return numChar(colIndex) + (rowIndex + 1);
		}
	
		function $ref(rowIndex, colIndex) {
		    return "$" + numChar(colIndex) + "$" + (rowIndex + 1);
		}
	
		function filterRowIndex(options) {
		    var frozenRows = options.frozenRows || (options.freezePane || {}).rowSplit || 1;
		    return frozenRows - 1;
		}
	
		function toWidth(px) {
		    var maximumDigitWidth = 7;
	
		    var fraction = (px / maximumDigitWidth) - (Math.floor(128 / maximumDigitWidth) / 256);
		    return fraction;
		}
	
		function toHeight(px) {
		    return px * 0.75;
		}
	
		function stripFunnyChars(value) {
		    return String(value)
		        .replace(/[\x00-\x09\x0B\x0C\x0E-\x1F]/g, "") // leave CRLF in
		        .replace(/\r?\n/g, "\r\n");                   // make sure LF is preceded by CR
		}
	
		var Worksheet = kendo.Class.extend({
		    init: function(options, sharedStrings, styles, borders) {
		        this.options = options;
		        this._strings = sharedStrings;
		        this._styles = styles;
		        this._borders = borders;
		        this._validations = {};
		    },
	
		    relsToXML: function() {
		        var hyperlinks = this.options.hyperlinks || [];
		        if (!hyperlinks.length) {
		            return "";
		        }
	
		        return WORKSHEET_RELS({ hyperlinks: hyperlinks });
		    },
	
		    toXML: function(index) {
		        var this$1 = this;
	
		        var mergeCells = this.options.mergedCells || [];
		        var rows = this.options.rows || [];
		        var data = inflate(rows, mergeCells);
	
		        this._readCells(data);
	
		        var autoFilter = this.options.filter;
		        var filter;
		        if (autoFilter && (typeof autoFilter.from === "number") && (typeof autoFilter.to === "number")) {
		            // Grid enables auto filter
		            autoFilter = {
		                from: ref(filterRowIndex(this.options), autoFilter.from),
		                to: ref(filterRowIndex(this.options), autoFilter.to)
		            };
		        } else if (autoFilter && autoFilter.ref && autoFilter.columns) {
		            // this is probably from the Spreadsheet
		            filter = autoFilter;
		            autoFilter = null;
		        }
	
		        var validations = [];
		        for (var i in this._validations) {
		            if (Object.prototype.hasOwnProperty.call(this$1._validations, i)) {
		                validations.push(this$1._validations[i]);
		            }
		        }
	
		        var defaultCellStyleId = null;
		        if (this.options.defaultCellStyle) {
		            defaultCellStyleId = this._lookupStyle(this.options.defaultCellStyle);
		        }
	
		        var freezePane = this.options.freezePane || {};
		        var defaults = this.options.defaults || {};
		        return WORKSHEET({
		            frozenColumns: this.options.frozenColumns || freezePane.colSplit,
		            frozenRows: this.options.frozenRows || freezePane.rowSplit,
		            columns: this.options.columns,
		            defaults: defaults,
		            data: data,
		            index: index,
		            mergeCells: mergeCells,
		            autoFilter: autoFilter,
		            filter: filter,
		            showGridLines: this.options.showGridLines,
		            hyperlinks: this.options.hyperlinks || [],
		            validations: validations,
		            defaultCellStyleId: defaultCellStyleId,
		            rtl: this.options.rtl !== undefined ? this.options.rtl : defaults.rtl
		        });
		    },
	
		    _lookupString: function(value) {
		        var key = "$" + value;
		        var index = this._strings.indexes[key];
		        var result;
	
		        if (index !== undefined) {
		            result = index;
		        } else {
		            result = this._strings.indexes[key] = this._strings.uniqueCount;
		            this._strings.uniqueCount ++;
		        }
	
		        this._strings.count ++;
	
		        return result;
		    },
	
		    _lookupStyle: function(style) {
		        var json = JSON.stringify(style);
	
		        if (json === "{}") {
		            return 0;
		        }
	
		        var index = indexOf(json, this._styles);
	
		        if (index < 0) {
		            index = this._styles.push(json) - 1;
		        }
	
		        // There is one default style
		        return index + 1;
		    },
	
		    _lookupBorder: function(border) {
		        var json = JSON.stringify(border);
		        if (json === "{}") {
		            return;
		        }
	
		        var index = indexOf(json, this._borders);
		        if (index < 0) {
		            index = this._borders.push(json) - 1;
		        }
	
		        // There is one default border
		        return index + 1;
		    },
	
		    _readCells: function(rowData) {
		        var this$1 = this;
	
		        for (var i = 0; i < rowData.length; i++) {
		            var row = rowData[i];
		            var cells = row.cells;
	
		            row.data = [];
	
		            for (var j = 0; j < cells.length; j++) {
		                var cellData = this$1._cell(cells[j], row.index, j);
		                if (cellData) {
		                    row.data.push(cellData);
		                }
		            }
		        }
		    },
	
		    _cell: function(data, rowIndex, cellIndex) {
		        if (!data || data === EMPTY_CELL) {
		            return null;
		        }
	
		        var value = data.value;
	
		        var border = {};
	
		        if (data.borderLeft) {
		            border.left = data.borderLeft;
		        }
	
		        if (data.borderRight) {
		            border.right = data.borderRight;
		        }
	
		        if (data.borderTop) {
		            border.top = data.borderTop;
		        }
	
		        if (data.borderBottom) {
		            border.bottom = data.borderBottom;
		        }
	
		        border = this._lookupBorder(border);
	
		        var defStyle = this.options.defaultCellStyle || {};
		        var style = { borderId: border };
	
		        (function(add) {
		            add("color");
		            add("background");
		            add("bold");
		            add("italic");
		            add("underline");
		            if (!add("fontFamily")) { add("fontName", "fontFamily"); }
		            add("fontSize");
		            add("format");
		            if (!add("textAlign")) { add("hAlign", "textAlign"); }
		            if (!add("verticalAlign")) { add("vAlign", "verticalAlign"); }
		            add("wrap");
		        })(
		            function(prop, target) {
		                var val = data[prop];
		                if (val === undefined) {
		                    val = defStyle[prop];
		                }
		                if (val !== undefined) {
		                    style[target || prop] = val;
		                    return true;
		                }
		            }
		        );
	
		        var columns = this.options.columns || [];
	
		        var column = columns[cellIndex];
		        var type = typeof value;
	
		        if (column && column.autoWidth) {
		            var displayValue = value;
	
		            // XXX: let's not bring kendo.toString in only for this.
		            //      better wait until the spreadsheet engine is available as a separate
		            //      component, then we can use a real Excel-like formatter.
		            //
		            if (type === "number") {
		                // kendo.toString will not behave exactly like the Excel format
		                // Still, it's the best we have available for estimating the character count.
		                displayValue = IntlService.toString(value, data.format);
		            }
	
		            column.width = Math.max(column.width || 0, String(displayValue).length);
		        }
	
		        if (type === "string") {
		            value = stripFunnyChars(value);
		            value = this._lookupString(value);
		            type = "s";
		        } else if (type === "number") {
		            type = "n";
		        } else if (type === "boolean") {
		            type = "b";
		            value = Number(value);
		        } else if (value && value.getTime) {
		            type = null;
		            value = dateToSerial(value);
		            if (!style.format) {
		                style.format = "mm-dd-yy";
		            }
		        } else {
		            type = null;
		            value = null;
		        }
	
		        style = this._lookupStyle(style);
	
		        var cellName = ref(rowIndex, cellIndex);
	
		        if (data.validation) {
		            this._addValidation(data.validation, cellName);
		        }
	
		        return {
		            value: value,
		            formula: data.formula,
		            type: type,
		            style: style,
		            ref: cellName
		        };
		    },
	
		    _addValidation: function(v, ref) {
		        var tmp = {
		            showErrorMessage : v.type === "reject" ? 1 : 0,
		            formula1         : v.from,
		            formula2         : v.to,
		            type             : MAP_EXCEL_TYPE[v.dataType] || v.dataType,
		            operator         : MAP_EXCEL_OPERATOR[v.comparerType] || v.comparerType,
		            allowBlank       : v.allowNulls ? 1 : 0,
		            showDropDown     : v.showButton ? 0 : 1, // LOL, Excel!
		            error            : v.messageTemplate,
		            errorTitle       : v.titleTemplate
		        };
		        var json = JSON.stringify(tmp);
		        if (!this._validations[json]) {
		            this._validations[json] = tmp;
		            tmp.sqref = [];
		        }
		        this._validations[json].sqref.push(ref);
		    }
		});
	
		var MAP_EXCEL_OPERATOR = {
		    // includes only what differs; key is our operator, value is Excel
		    // operator.
		    greaterThanOrEqualTo : "greaterThanOrEqual",
		    lessThanOrEqualTo    : "lessThanOrEqual"
		};
	
		var MAP_EXCEL_TYPE = {
		    number: "decimal"
		};
	
		var defaultFormats = {
		    "General": 0,
		    "0": 1,
		    "0.00": 2,
		    "#,##0": 3,
		    "#,##0.00": 4,
		    "0%": 9,
		    "0.00%": 10,
		    "0.00E+00": 11,
		    "# ?/?": 12,
		    "# ??/??": 13,
		    "mm-dd-yy": 14,
		    "d-mmm-yy": 15,
		    "d-mmm": 16,
		    "mmm-yy": 17,
		    "h:mm AM/PM": 18,
		    "h:mm:ss AM/PM": 19,
		    "h:mm": 20,
		    "h:mm:ss": 21,
		    "m/d/yy h:mm": 22,
		    "#,##0 ;(#,##0)": 37,
		    "#,##0 ;[Red](#,##0)": 38,
		    "#,##0.00;(#,##0.00)": 39,
		    "#,##0.00;[Red](#,##0.00)": 40,
		    "mm:ss": 45,
		    "[h]:mm:ss": 46,
		    "mmss.0": 47,
		    "##0.0E+0": 48,
		    "@": 49,
		    "[$-404]e/m/d": 27,
		    "m/d/yy": 30,
		    "t0": 59,
		    "t0.00": 60,
		    "t#,##0": 61,
		    "t#,##0.00": 62,
		    "t0%": 67,
		    "t0.00%": 68,
		    "t# ?/?": 69,
		    "t# ??/??": 70
		};
	
		function convertColor(value) {
		    var color = value;
		    if (color.length < 6) {
		        color = color.replace(/(\w)/g, function($0, $1) {
		            return $1 + $1;
		        });
		    }
	
		    color = color.substring(1).toUpperCase();
	
		    if (color.length < 8) {
		        color = "FF" + color;
		    }
	
		    return color;
		}
	
		var Workbook = kendo.Class.extend({
		    init: function(options) {
		        var this$1 = this;
	
		        this.options = options || {};
		        this._strings = {
		            indexes: {},
		            count: 0,
		            uniqueCount: 0
		        };
		        this._styles = [];
		        this._borders = [];
	
		        this._sheets = map(this.options.sheets || [], function (options) {
		            options.defaults = this$1.options;
		            return new Worksheet(options, this$1._strings, this$1._styles, this$1._borders);
		        });
		    },
	
		    toZIP: function() {
		        var this$1 = this;
	
		        var zip = createZip();
	
		        var docProps = zip.folder("docProps");
	
		        docProps.file("core.xml", CORE({
		            creator: this.options.creator || "Kendo UI",
		            lastModifiedBy: this.options.creator || "Kendo UI",
		            created: this.options.date || new Date().toJSON(),
		            modified: this.options.date || new Date().toJSON()
		        }));
	
		        var sheetCount = this._sheets.length;
	
		        docProps.file("app.xml", APP({ sheets: this._sheets }));
	
		        var rels = zip.folder("_rels");
		        rels.file(".rels", RELS);
	
		        var xl = zip.folder("xl");
	
		        var xlRels = xl.folder("_rels");
		        xlRels.file("workbook.xml.rels", WORKBOOK_RELS({ count: sheetCount }));
	
		        var sheetIds = {};
	
		        xl.file("workbook.xml", WORKBOOK({
		            sheets: this._sheets,
		            filterNames: map(this._sheets, function(sheet, index) {
		                var options = sheet.options;
		                var sheetName = (options.name || options.title || "Sheet" + (index + 1));
		                sheetIds[sheetName.toLowerCase()] = index;
		                var filter = options.filter;
		                if (filter) {
		                    if (filter.ref) {
		                        // spreadsheet provides `ref`
		                        var a = filter.ref.split(":");
		                        var from = parseRef(a[0]);
		                        var to = parseRef(a[1]);
		                        return {
		                            localSheetId: index,
		                            name: sheetName,
		                            from: $ref(from.row, from.col),
		                            to: $ref(to.row, to.col)
		                        };
		                    } else if (typeof filter.from !== "undefined" && typeof filter.to !== "undefined") {
		                        // grid does this
		                        return {
		                            localSheetId: index,
		                            name: sheetName,
		                            from: $ref(filterRowIndex(options), filter.from),
		                            to: $ref(filterRowIndex(options), filter.to)
		                        };
		                    }
		                }
		            }),
		            userNames: map(this.options.names || [], function(def) {
		                return {
		                    name: def.localName,
		                    localSheetId: def.sheet ? sheetIds[def.sheet.toLowerCase()] : null,
		                    value: def.value,
		                    hidden: def.hidden
		                };
		            })
		        }));
	
		        var worksheets = xl.folder("worksheets");
	
		        var sheetRels = worksheets.folder("_rels");
	
		        for (var idx = 0; idx < sheetCount; idx++) {
		            var sheet = this$1._sheets[idx];
		            var sheetName = "sheet" + (idx + 1) + ".xml";
		            var relsXml = sheet.relsToXML();
	
		            if (relsXml) {
		                sheetRels.file(sheetName + ".rels", relsXml);
		            }
	
		            worksheets.file(sheetName, sheet.toXML(idx));
		        }
	
		        var borders = map(this._borders, parseJSON);
	
		        var styles = map(this._styles, parseJSON);
	
		        var hasFont = function(style) {
		            return style.underline || style.bold || style.italic || style.color || style.fontFamily || style.fontSize;
		        };
	
		        var fonts = map(styles, function(style) {
		            if (style.color) {
		                style.color = convertColor(style.color);
		            }
	
		            if (hasFont(style)) {
		                return style;
		            }
		        });
	
		        var formats = map(styles, function(style) {
		            if (style.format && defaultFormats[style.format] === undefined) {
		                return style;
		            }
		        });
	
		        var fills = map(styles, function(style) {
		            if (style.background) {
		                style.background = convertColor(style.background);
		                return style;
		            }
		        });
	
		        xl.file("styles.xml", STYLES({
		            fonts: fonts,
		            fills: fills,
		            formats: formats,
		            borders: borders,
		            styles: map(styles, function(style) {
		                var result = {};
	
		                if (hasFont(style)) {
		                    result.fontId = indexOf(style, fonts) + 1;
		                }
	
		                if (style.background) {
		                    result.fillId = indexOf(style, fills) + 2;
		                }
	
		                result.textAlign = style.textAlign;
		                result.verticalAlign = style.verticalAlign;
		                result.wrap = style.wrap;
		                result.borderId = style.borderId;
	
		                if (style.format) {
		                    if (defaultFormats[style.format] !== undefined) {
		                        result.numFmtId = defaultFormats[style.format];
		                    } else {
		                        result.numFmtId = 165 + indexOf(style, formats);
		                    }
		                }
	
		                return result;
		            })
		        }));
	
		        xl.file("sharedStrings.xml", SHARED_STRINGS(this._strings));
	
		        zip.file("[Content_Types].xml", CONTENT_TYPES( { count: sheetCount }));
	
		        return zip;
		    },
	
		    toDataURL: function() {
		        var zip = this.toZIP();
	
		        return zip.generateAsync ? zip.generateAsync(DATA_URL_OPTIONS).then(toDataURI) : toDataURI(zip.generate(DATA_URL_OPTIONS));
		    }
		});
	
		function borderStyle(width) {
		    var alias = "thin";
	
		    if (width === 2) {
		        alias = "medium";
		    } else if (width === 3) {
		        alias = "thick";
		    }
	
		    return alias;
		}
	
		function borderSideTemplate(name, style) {
		    var result = "";
	
		    if (style) {
		        result += "<" + name + " style=\"" + borderStyle(style.size) + "\">";
		        if (style.color) {
		            result += "<color rgb=\"" + convertColor(style.color) + "\"/>";
		        }
		        result += "</" + name + ">";
		    }
	
		    return result;
		}
	
		function borderTemplate(border) {
		    return "<border>" +
		       borderSideTemplate("left", border.left) +
		       borderSideTemplate("right", border.right) +
		       borderSideTemplate("top", border.top) +
		       borderSideTemplate("bottom", border.bottom) +
		   "</border>";
		}
	
		var EMPTY_CELL = {};
		function inflate(rows, mergedCells) {
		    var rowData = [];
		    var rowsByIndex = [];
	
		    indexRows(rows, function(row, index) {
		        var data = {
		            _source: row,
		            index: index,
		            height: row.height,
		            cells: []
		        };
	
		        rowData.push(data);
		        rowsByIndex[index] = data;
		    });
	
		    var sorted = sortByIndex(rowData).slice(0);
		    var ctx = {
		        rowData: rowData,
		        rowsByIndex: rowsByIndex,
		        mergedCells: mergedCells
		    };
	
		    for (var i = 0; i < sorted.length; i++) {
		        fillCells(sorted[i], ctx);
		        delete sorted[i]._source;
		    }
	
		    return sortByIndex(rowData);
		}
	
		function indexRows(rows, callback) {
		    for (var i = 0; i < rows.length; i++) {
		        var row = rows[i];
		        if (!row) {
		            continue;
		        }
	
		        var index = row.index;
		        if (typeof index !== "number") {
		            index = i;
		        }
	
		        callback(row, index);
		    }
		}
	
		function sortByIndex(items) {
		    return items.sort(function(a, b) {
		        return a.index - b.index;
		    });
		}
	
		function pushUnique(array, el) {
		    if (array.indexOf(el) < 0) {
		        array.push(el);
		    }
		}
	
		function getSpan(mergedCells, ref) {
		    for (var i = 0; i < mergedCells.length; ++i) {
		        var range = mergedCells[i];
		        var a = range.split(":");
		        var topLeft = a[0];
		        if (topLeft === ref) {
		            var bottomRight = a[1];
		            topLeft = parseRef(topLeft);
		            bottomRight = parseRef(bottomRight);
		            return {
		                rowSpan: bottomRight.row - topLeft.row + 1,
		                colSpan: bottomRight.col - topLeft.col + 1
		            };
		        }
		    }
		}
	
		function parseRef(ref) {
		    function getcol(str) {
		        var upperStr = str.toUpperCase();
		        var col = 0;
		        for (var i = 0; i < upperStr.length; ++i) {
		            col = col * 26 + upperStr.charCodeAt(i) - 64;
		        }
		        return col - 1;
		    }
	
		    function getrow(str) {
		        return parseInt(str, 10) - 1;
		    }
	
		    var m = /^([a-z]+)(\d+)$/i.exec(ref);
		    return {
		        row: getrow(m[2]),
		        col: getcol(m[1])
		    };
		}
	
		function fillCells(data, ctx) {
		    var row = data._source;
		    var rowIndex = data.index;
		    var cells = row.cells;
		    var cellData = data.cells;
	
		    if (!cells) {
		        return;
		    }
	
		    for (var i = 0; i < cells.length; i++) {
		        var cell = cells[i] || EMPTY_CELL;
	
		        var rowSpan = cell.rowSpan || 1;
		        var colSpan = cell.colSpan || 1;
	
		        var cellIndex = insertCell(cellData, cell);
		        var topLeftRef = ref(rowIndex, cellIndex);
	
		        if (rowSpan === 1 && colSpan === 1) {
		            // could still be merged: the spreadsheet does not send
		            // rowSpan/colSpan, but mergedCells is already populated.
		            // https://github.com/telerik/kendo-ui-core/issues/2401
		            var tmp = getSpan(ctx.mergedCells, topLeftRef);
		            if (tmp) {
		                colSpan = tmp.colSpan;
		                rowSpan = tmp.rowSpan;
		            }
		        }
	
		        spanCell(cell, cellData, cellIndex, colSpan);
	
		        if (rowSpan > 1 || colSpan > 1) {
		            pushUnique(ctx.mergedCells,
		                       topLeftRef + ":" + ref(rowIndex + rowSpan - 1,
		                                              cellIndex + colSpan - 1));
		        }
	
		        if (rowSpan > 1) {
		            for (var ri = rowIndex + 1; ri < rowIndex + rowSpan; ri++) {
		                var nextRow = ctx.rowsByIndex[ri];
		                if (!nextRow) {
		                    nextRow = ctx.rowsByIndex[ri] = { index: ri, cells: [] };
		                    ctx.rowData.push(nextRow);
		                }
	
		                spanCell(cell, nextRow.cells, cellIndex - 1, colSpan + 1);
		            }
		        }
		    }
		}
	
		function insertCell(data, cell) {
		    var index;
	
		    if (typeof cell.index === "number") {
		        index = cell.index;
		        insertCellAt(data, cell, cell.index);
		    } else {
		        index = appendCell(data, cell);
		    }
	
		    return index;
		}
	
		function insertCellAt(data, cell, index) {
		    data[index] = cell;
		}
	
		function appendCell(data, cell) {
		    var index = data.length;
	
		    for (var i = 0; i < data.length + 1; i++) {
		        if (!data[i]) {
		            data[i] = cell;
		            index = i;
		            break;
		        }
		    }
	
		    return index;
		}
	
		function spanCell(cell, row, startIndex, colSpan) {
		    for (var i = 1; i < colSpan; i++) {
		        var tmp = {
		            borderTop    : cell.borderTop,
		            borderRight  : cell.borderRight,
		            borderBottom : cell.borderBottom,
		            borderLeft   : cell.borderLeft
		        };
		        insertCellAt(row, tmp, startIndex + i);
		    }
		}
	
		var SPREADSHEET_FILTERS = function (ref$1) {
		  var ref = ref$1.ref;
		  var columns = ref$1.columns;
		  var generators = ref$1.generators;
	
		  return ("\n<autoFilter ref=\"" + ref + "\">\n  " + (foreach(columns, function (col) { return ("\n    <filterColumn colId=\"" + (col.index) + "\">\n      " + (generators[col.filter](col)) + "\n    </filterColumn>\n  "); })) + "\n</autoFilter>");
		};
	
		var SPREADSHEET_CUSTOM_FILTER = function (ref) {
		  var logic = ref.logic;
		  var criteria = ref.criteria;
	
		  return ("\n<customFilters " + (logic === 'and' ? 'and="1"' : '') + ">\n" + (foreach(criteria, function (f) {
		    var op = spreadsheetFilters.customOperator(f);
		    var val = spreadsheetFilters.customValue(f);
		    return ("<customFilter " + (op ? ("operator=\"" + op + "\"") : '') + " val=\"" + val + "\"/>");
		})) + "\n</customFilters>");
		};
	
		var SPREADSHEET_DYNAMIC_FILTER = function (ref) {
		  var type = ref.type;
	
		  return ("<dynamicFilter type=\"" + (spreadsheetFilters.dynamicFilterType(type)) + "\" />");
		};
	
		var SPREADSHEET_TOP_FILTER = function (ref) {
		  var type = ref.type;
		  var value = ref.value;
	
		  return ("<top10 percent=\"" + (/percent$/i.test(type) ? 1 : 0) + "\"\n       top=\"" + (/^top/i.test(type) ? 1 : 0) + "\"\n       val=\"" + value + "\" />");
		};
	
		var SPREADSHEET_VALUE_FILTER = function (ref) {
		    var blanks = ref.blanks;
		    var values = ref.values;
	
		    return ("<filters " + (blanks ? 'blank="1"' : '') + ">\n    " + (foreach(values, function (value) { return ("\n      <filter val=\"" + value + "\" />"); })) + "\n  </filters>");
		};
	
		function spreadsheetFilters(filter) {
		    return SPREADSHEET_FILTERS({
		        ref: filter.ref,
		        columns: filter.columns,
		        generators: {
		            custom  : SPREADSHEET_CUSTOM_FILTER,
		            dynamic : SPREADSHEET_DYNAMIC_FILTER,
		            top     : SPREADSHEET_TOP_FILTER,
		            value   : SPREADSHEET_VALUE_FILTER
		        }
		    });
		}
	
		spreadsheetFilters.customOperator = function(f) {
		    return {
		        eq  : "equal",
		        gt  : "greaterThan",
		        gte : "greaterThanOrEqual",
		        lt  : "lessThan",
		        lte : "lessThanOrEqual",
		        ne  : "notEqual",
	
		        // These are not in the spec, but seems to be how Excel does
		        // it (see customValue below).  For the non-negated versions,
		        // the operator attribute is missing completely.
		        doesnotstartwith: "notEqual",
		        doesnotendwith: "notEqual",
		        doesnotcontain: "notEqual",
		        doesnotmatch: "notEqual"
		    }[f.operator.toLowerCase()];
		};
	
		spreadsheetFilters.customValue = function(f) {
		    function esc(str) {
		        return str.replace(/([*?])/g, "~$1");
		    }
	
		    switch (f.operator.toLowerCase()) {
		        case "startswith":
		        case "doesnotstartwith":
		            return esc(f.value) + "*";
	
		        case "endswith":
		        case "doesnotendwith":
		            return "*" + esc(f.value);
	
		        case "contains":
		        case "doesnotcontain":
		            return "*" + esc(f.value) + "*";
	
		        default:
		            return f.value;
		    }
		};
	
		spreadsheetFilters.dynamicFilterType = function(type) {
		    return {
		        quarter1  : "Q1",
		        quarter2  : "Q2",
		        quarter3  : "Q3",
		        quarter4  : "Q4",
		        january   : "M1",
		        february  : "M2",
		        march     : "M3",
		        april     : "M4",
		        may       : "M5",
		        june      : "M6",
		        july      : "M7",
		        august    : "M8",
		        september : "M9",
		        october   : "M10",
		        november  : "M11",
		        december  : "M12"
		    }[type.toLowerCase()] || type;
		};
	
		kendo.deepExtend(kendo.ooxml, {
		    IntlService: IntlService,
		    Workbook: Workbook,
		    Worksheet: Worksheet
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1442);
		module.exports = __webpack_require__(1442);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1442:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(19)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function () {
	
		/* global JSZip */
	
		kendo.ooxml = kendo.ooxml || {};
	
		kendo.ooxml.createZip = function() {
		    if (typeof JSZip === "undefined") {
		       throw new Error("JSZip not found. Check http://docs.telerik.com/kendo-ui/framework/excel/introduction#requirements for more details.");
		    }
	
		    return new JSZip();
		};
	
		})();
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1175);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1175:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1176), __webpack_require__(1177) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "excel",
		    name: "Excel export",
		    category: "framework",
		    advanced: true,
		    mixin: true,
		    depends: [ "data", "ooxml" ]
		};
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1176:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(630);
	
	/***/ }),
	
	/***/ 1177:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(632);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(992);
		module.exports = __webpack_require__(992);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 992:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(5), __webpack_require__(993) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, kendo){
	
		    var ExcelExporter = kendo.excel.ExcelExporter;
	
		    var extend = $.extend;
	
		    kendo.excel.TemplateService.register({
		        compile: kendo.template
		    });
	
		    kendo.ExcelExporter = kendo.Class.extend({
		        init: function(options) {
		            this.options = options;
		            var dataSource = options.dataSource;
	
		            if (dataSource instanceof kendo.data.DataSource) {
	
		                if (!dataSource.filter()) {
		                    dataSource.options.filter = undefined;
		                }
	
		                this.dataSource = new dataSource.constructor(extend(
		                    {},
		                    dataSource.options,
		                    {
		                        page: options.allPages ? 0 : dataSource.page(),
		                        filter: dataSource.filter(),
		                        pageSize: options.allPages ? dataSource.total() : dataSource.pageSize() || dataSource.total(),
		                        sort: dataSource.sort(),
		                        group: dataSource.group(),
		                        aggregate: dataSource.aggregate()
		                    }));
	
		                var data = dataSource.data();
	
		                if (data.length > 0) {
		                    // Avoid toJSON() for perf and avoid data() to prevent reparenting.
		                    this.dataSource._data = data;
	
		                    var transport = this.dataSource.transport;
		                    if (dataSource._isServerGrouped() && transport.options && transport.options.data) { // clear the transport data when using aspnet-mvc transport
		                        transport.options.data = null;
		                    }
		                }
	
		            } else {
		                this.dataSource = kendo.data.DataSource.create(dataSource);
		            }
		        },
	
		        _hierarchy: function() {
		            var hierarchy = this.options.hierarchy;
		            var dataSource = this.dataSource;
	
		            if (hierarchy && dataSource.level) {
		                hierarchy = {
		                    itemLevel: function(item) {
		                        return dataSource.level(item);
		                    }
		                };
	
		                var view = dataSource.view();
		                var depth = 0;
		                var level;
	
		                for (var idx = 0; idx < view.length; idx++) {
		                    level = dataSource.level(view[idx]);
	
		                    if (level > depth) {
		                        depth = level;
		                    }
		                }
	
		                hierarchy.depth = depth + 1;
		            } else {
		                hierarchy = false;
		            }
	
		            return {
		                hierarchy: hierarchy
		            };
		        },
	
		        workbook: function() {
		            return $.Deferred($.proxy(function(d) {
		                this.dataSource.fetch()
		                    .then($.proxy(function() {
	
		                        var workbook = new ExcelExporter(extend({}, this.options, this._hierarchy(), {
		                            data: this.dataSource.view(),
		                            groups: this.dataSource.group(),
		                            aggregates: this.dataSource.aggregates()
		                        })).workbook();
	
		                        d.resolve(workbook, this.dataSource.view());
		                    }, this));
		            }, this)).promise();
		        }
		    });
	
	
		})(kendo.jQuery, kendo);
	
		return kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 993:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(631);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(991);
		module.exports = __webpack_require__(991);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 991:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(19)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		window.kendo.excel = window.kendo.excel || {};
	
		var getter = kendo.getter;
		var map = $.map;
	
		var current = {
		    compile: function(template) {
		        return template;
		    }
		};
	
		var TemplateService = kendo.Class.extend({
	
		});
	
		TemplateService.register = function(userImplementation) {
		    current = userImplementation;
		};
	
		TemplateService.compile = function(template) {
		    return current.compile(template);
		};
	
		function defaultGroupHeaderTemplate(data) {
		    return ((data.title) + ": " + (data.value));
		}
	
		function createArray(length, callback) {
		    var result = [];
	
		    for (var idx = 0; idx < length; idx++) {
		        result.push(callback(idx));
		    }
	
		    return result;
		}
	
		var ExcelExporter = kendo.Class.extend({
		    init: function(options) {
		        options.columns = this._trimColumns(options.columns || []);
	
		        this.allColumns = map(this._leafColumns(options.columns || []), this._prepareColumn);
	
		        this.columns = this.allColumns.filter(function(column) { return !column.hidden; });
	
		        this.options = options;
		        this.data = options.data || [];
		        this.aggregates = options.aggregates || {};
		        this.groups = [].concat(options.groups || []);
		        this.hierarchy = options.hierarchy;
		    },
	
		    workbook: function() {
		        var workbook = {
		            sheets: [ {
		                columns: this._columns(),
		                rows: this.hierarchy ? this._hierarchyRows() : this._rows(),
		                freezePane: this._freezePane(),
		                filter: this._filter()
		            } ]
		        };
	
		        return workbook;
		    },
	
		    _trimColumns: function(columns) {
		        var this$1 = this;
	
		        return columns.filter(function (column) {
		            var result = Boolean(column.field);
	
		            if (!result && column.columns) {
		                result = this$1._trimColumns(column.columns).length > 0;
		            }
	
		            return result;
		        });
		    },
	
		    _leafColumns: function(columns) {
		        var this$1 = this;
	
		        var result = [];
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (!columns[idx].columns) {
		                result.push(columns[idx]);
		            } else {
		                result = result.concat(this$1._leafColumns(columns[idx].columns));
		            }
		        }
	
		        return result;
		    },
	
		    _prepareColumn: function(column) {
		        if (!column.field) {
		            return null;
		        }
	
		        var value = function(dataItem) {
		            return getter(column.field, true)(dataItem);
		        };
	
		        var values = null;
	
		        if (column.values) {
		            values = {};
	
		            column.values.forEach(function(item) {
		                values[item.value] = item.text;
		            });
	
		            value = function(dataItem) {
		                return values[getter(column.field, true)(dataItem)];
		            };
		        }
	
		        return $.extend({}, column, {
		            value: value,
		            values: values,
		            groupHeaderTemplate: column.groupHeaderTemplate ? TemplateService.compile(column.groupHeaderTemplate) : defaultGroupHeaderTemplate,
		            groupFooterTemplate: column.groupFooterTemplate ? TemplateService.compile(column.groupFooterTemplate) : null,
		            footerTemplate: column.footerTemplate ? TemplateService.compile(column.footerTemplate) : null
		        });
		    },
	
		    _filter: function() {
		        if (!this.options.filterable) {
		            return null;
		        }
	
		        var depth = this._depth();
	
		        return {
		            from: depth,
		            to: depth + this.columns.length - 1
		        };
		    },
	
		    _createPaddingCells: function(length) {
		        var this$1 = this;
	
		        return createArray(length, function () { return $.extend({
		            background: "#dfdfdf",
		            color: "#333"
		        }, this$1.options.paddingCellOptions); });
		    },
	
		    _dataRow: function(dataItem, level, depth) {
		        var this$1 = this;
	
		        var cells = this._createPaddingCells(level);
	
		        // grouped
		        if (depth && dataItem.items) {
		            var column = this.allColumns.filter(function(column) {
		                return column.field === dataItem.field;
		            })[0];
	
		            var title = column && column.title ? column.title : dataItem.field;
		            var template = column ? column.groupHeaderTemplate : null;
		            var group = $.extend({
		                title: title,
		                field: dataItem.field,
		                value: column && column.values ? column.values[dataItem.value] : dataItem.value,
		                aggregates: dataItem.aggregates,
		                items: dataItem.items
		            }, dataItem.aggregates[dataItem.field]);
	
		            var value = title + ": " + (dataItem.value);
	
		            if (template) {
		                value = template(group);
		            }
	
		            cells.push($.extend({
		                value: value,
		                background: "#dfdfdf",
		                color: "#333",
		                colSpan: this.columns.length + depth - level
		            }, (column || {}).groupHeaderCellOptions));
	
		            var rows = this._dataRows(dataItem.items, level + 1);
	
		            rows.unshift({
		                type: "group-header",
		                cells: cells
		            });
	
		            return rows.concat(this._footer(dataItem));
		        }
	
		        var dataCells = [];
	
		        for (var cellIdx = 0; cellIdx < this.columns.length; cellIdx++) {
		            dataCells[cellIdx] = this$1._cell(dataItem, this$1.columns[cellIdx]);
		        }
	
		        if (this.hierarchy) {
		            dataCells[0].colSpan = depth - level + 1;
		        }
	
		        return [ {
		            type: "data",
		            cells: cells.concat(dataCells)
		        } ];
		    },
	
		    _dataRows: function(dataItems, level) {
		        var this$1 = this;
	
		        var depth = this._depth();
		        var rows = [];
	
		        for (var idx = 0; idx < dataItems.length; idx++) {
		            rows.push.apply(rows, this$1._dataRow(dataItems[idx], level, depth));
		        }
	
		        return rows;
		    },
	
		    _hierarchyRows: function() {
		        var this$1 = this;
	
		        var depth = this._depth();
		        var data = this.data;
		        var itemLevel = this.hierarchy.itemLevel;
		        var hasFooter = this._hasFooterTemplate();
		        var rows = [];
		        var parents = [];
		        var previousLevel = 0;
		        var previousItemId;
	
		        for (var idx = 0; idx < data.length; idx++) {
		            var item = data[idx];
		            var level = itemLevel(item);
	
		            if (hasFooter) {
		                if (level > previousLevel) {
		                    parents.push({ id: previousItemId, level: previousLevel });
		                } else if (level < previousLevel) {
		                    rows.push.apply(rows, this$1._hierarchyFooterRows(parents, level, depth));
		                }
	
		                previousLevel = level;
		                previousItemId = item.id;
		            }
	
		            rows.push.apply(rows, this$1._dataRow(item, level + 1, depth));
		        }
	
		        if (hasFooter) {
		            rows.push.apply(rows, this._hierarchyFooterRows(parents, 0, depth));
	
		            var rootAggregate = data.length ? this.aggregates[data[0].parentId] : {};
		            rows.push(this._hierarchyFooter(rootAggregate, 0, depth));
		        }
	
		        this._prependHeaderRows(rows);
	
		        return rows;
		    },
	
		    _hierarchyFooterRows: function(parents, currentLevel, depth) {
		        var this$1 = this;
	
		        var rows = [];
		        while (parents.length && parents[parents.length - 1].level >= currentLevel) {
		            var parent = parents.pop();
		            rows.push(this$1._hierarchyFooter(this$1.aggregates[parent.id], parent.level + 1, depth));
		        }
	
		        return rows;
		    },
	
		    _hasFooterTemplate: function() {
		        var columns = this.columns;
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (columns[idx].footerTemplate) {
		                return true;
		            }
		        }
		    },
	
		    _hierarchyFooter: function(aggregates, level, depth) {
		        var cells = this.columns.map(function(column, index) {
		            var colSpan = index ? 1 : depth - level + 1;
		            if (column.footerTemplate) {
		                return $.extend({
		                    background: "#dfdfdf",
		                    color: "#333",
		                    colSpan: colSpan,
		                    value: column.footerTemplate($.extend({}, (aggregates || {})[column.field]))
		                }, column.footerCellOptions);
		            }
	
		            return $.extend({
		                background: "#dfdfdf",
		                color: "#333",
		                colSpan: colSpan
		            }, column.footerCellOptions);
		        });
	
		        return {
		            type: "footer",
		            cells: this._createPaddingCells(level).concat(cells)
		        };
		    },
	
		    _footer: function(dataItem) {
		        var rows = [];
		        var footer = this.columns.some(function (column) { return column.groupFooterTemplate; });
	
		        var templateData, group;
		        if (footer) {
		            group = {
		                group: { items: dataItem.items,
		                         field: dataItem.field,
		                         value: dataItem.value }
		            };
		            templateData = {};
		            Object.keys(dataItem.aggregates).forEach(function (key) {
		                templateData[key] = $.extend({}, dataItem.aggregates[key], group);
		            });
		        }
	
		        var cells = this.columns.map(function (column) {
		            if (column.groupFooterTemplate) {
		                var data = $.extend({}, templateData, dataItem.aggregates[column.field], group);
		                return $.extend({
		                    background: "#dfdfdf",
		                    color: "#333",
		                    value: column.groupFooterTemplate(data)
		                }, column.groupFooterCellOptions);
		            }
	
		            return $.extend({
		                background: "#dfdfdf",
		                color: "#333"
		            }, column.groupFooterCellOptions);
		        });
	
		        if (footer) {
		            rows.push({
		                type: "group-footer",
		                cells: this._createPaddingCells(this.groups.length).concat(cells)
		            });
		        }
	
		        return rows;
		    },
	
		    _isColumnVisible: function(column) {
		        return this._visibleColumns([ column ]).length > 0 && (column.field || column.columns);
		    },
	
		    _visibleColumns: function(columns) {
		        var this$1 = this;
	
		        return columns.filter(function (column) {
		            var result = !column.hidden;
		            if (result && column.columns) {
		                result = this$1._visibleColumns(column.columns).length > 0;
		            }
		            return result;
		        });
		    },
	
		    _headerRow: function(row, groups) {
		        var this$1 = this;
	
		        var headers = row.cells.map(function(cell) {
		            return $.extend(cell, {
		                colSpan: cell.colSpan > 1 ? cell.colSpan : 1,
		                rowSpan: row.rowSpan > 1 && !cell.colSpan ? row.rowSpan : 1
		            });
		        });
	
		        if (this.hierarchy) {
		            headers[0].colSpan = this._depth() + 1;
		        }
	
		        return {
		            type: "header",
		            cells: createArray(groups.length, function () { return $.extend({
		                background: "#7a7a7a",
		                color: "#fff"
		            }, this$1.options.headerPaddingCellOptions); }).concat(headers)
		        };
		    },
	
		    _prependHeaderRows: function(rows) {
		        var this$1 = this;
	
		        var groups = this.groups;
	
		        var headerRows = [ { rowSpan: 1, cells: [], index: 0 } ];
	
		        this._prepareHeaderRows(headerRows, this.options.columns);
	
		        for (var idx = headerRows.length - 1; idx >= 0; idx--) {
		            rows.unshift(this$1._headerRow(headerRows[idx], groups));
		        }
		    },
	
		    _prepareHeaderRows: function(rows, columns, parentCell, parentRow) {
		        var this$1 = this;
	
		        var row = parentRow || rows[rows.length - 1];
		        var childRow = rows[row.index + 1];
		        var totalColSpan = 0;
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            var column = columns[idx];
		            if (this$1._isColumnVisible(column)) {
	
		                var cell = $.extend({
		                    background: "#7a7a7a",
		                    color: "#fff",
		                    value: column.title || column.field,
		                    colSpan: 0
		                }, column.headerCellOptions);
		                row.cells.push(cell);
	
		                if (column.columns && column.columns.length) {
		                    if (!childRow) {
		                        childRow = { rowSpan: 0, cells: [], index: rows.length };
		                        rows.push(childRow);
		                    }
		                    cell.colSpan = this$1._trimColumns(this$1._visibleColumns(column.columns)).length;
		                    this$1._prepareHeaderRows(rows, column.columns, cell, childRow);
		                    totalColSpan += cell.colSpan - 1;
		                    row.rowSpan = rows.length - row.index;
		                }
		            }
		        }
	
		        if (parentCell) {
		            parentCell.colSpan += totalColSpan;
		        }
		    },
	
		    _rows: function() {
		        var this$1 = this;
	
		        var rows = this._dataRows(this.data, 0);
	
		        if (this.columns.length) {
		            this._prependHeaderRows(rows);
		            var footer = false;
	
		            var cells = this.columns.map(function (column) {
		                if (column.footerTemplate) {
		                    footer = true;
	
		                    return $.extend({
		                        background: "#dfdfdf",
		                        color: "#333",
		                        value: column.footerTemplate($.extend({}, this$1.aggregates, this$1.aggregates[column.field]))
		                    }, column.footerCellOptions);
		                }
	
		                return $.extend({
		                    background: "#dfdfdf",
		                    color: "#333"
		                }, column.footerCellOptions);
		            });
	
		            if (footer) {
		                rows.push({
		                    type: "footer",
		                    cells: this._createPaddingCells(this.groups.length).concat(cells)
		                });
		            }
		        }
	
		        return rows;
		    },
	
		    _headerDepth: function(columns) {
		        var this$1 = this;
	
		        var result = 1;
		        var max = 0;
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (columns[idx].columns) {
		                var temp = this$1._headerDepth(columns[idx].columns);
		                if (temp > max) {
		                    max = temp;
		                }
		            }
		        }
		        return result + max;
		    },
	
		    _freezePane: function() {
		        var columns = this._visibleColumns(this.options.columns || []);
	
		        var colSplit = this._visibleColumns(this._trimColumns(this._leafColumns(columns.filter(function(column) {
		            return column.locked;
		        })))).length;
	
		        return {
		            rowSplit: this._headerDepth(columns),
		            colSplit: colSplit ? colSplit + this.groups.length : 0
		        };
		    },
	
		    _cell: function(dataItem, column) {
		        return $.extend({
		            value: column.value(dataItem)
		        }, column.cellOptions);
		    },
	
		    _depth: function() {
		        var depth = 0;
	
		        if (this.hierarchy) {
		            depth = this.hierarchy.depth;
		        } else {
		            depth = this.groups.length;
		        }
	
		        return depth;
		    },
	
		    _columns: function() {
		        var depth = this._depth();
		        var columns = createArray(depth, function () { return ({ width: 20 }); });
	
		        return columns.concat(this.columns.map(function(column) {
		            return {
		                width: parseInt(column.width, 10),
		                autoWidth: column.width ? false : true
		            };
		        }));
		    }
		});
	
		kendo.deepExtend(kendo.excel, {
		    ExcelExporter: ExcelExporter,
		    TemplateService: TemplateService
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(994);
		module.exports = __webpack_require__(994);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 937:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(630);
	
	/***/ }),
	
	/***/ 994:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(937), __webpack_require__(995) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, kendo){
	
	
		kendo.ExcelMixin = {
		    extend: function(proto) {
		       proto.events.push("excelExport");
		       proto.options.excel = $.extend(proto.options.excel, this.options);
		       proto.saveAsExcel = this.saveAsExcel;
		    },
		    options: {
		        proxyURL: "",
		        allPages: false,
		        filterable: false,
		        fileName: "Export.xlsx"
		    },
		    saveAsExcel: function() {
		        var excel = this.options.excel || {};
	
		        var exporter = new kendo.ExcelExporter({
		            columns: this.columns,
		            dataSource: this.dataSource,
		            allPages: excel.allPages,
		            filterable: excel.filterable,
		            hierarchy: excel.hierarchy
		        });
	
		        exporter.workbook().then($.proxy(function(book, data) {
		            if (!this.trigger("excelExport", { workbook: book, data: data })) {
		                var workbook = new kendo.ooxml.Workbook(book);
	
		                workbook.toDataURLAsync().then(function(dataURI) {
		                    kendo.saveAs({
		                        dataURI: dataURI,
		                        fileName: book.fileName || excel.fileName,
		                        proxyURL: excel.proxyURL,
		                        forceProxy: excel.forceProxy
		                    });
		                });
	
		            }
		        }, this));
		    }
		};
	
		})(kendo.jQuery, kendo);
	
		return kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 995:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(625);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1270);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1270:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "progressbar",
		    name: "ProgressBar",
		    category: "web",
		    description: "The ProgressBar offers rich functionality for displaying and tracking progress",
		    depends: [ "core" ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        HORIZONTAL = "horizontal",
		        VERTICAL = "vertical",
		        DEFAULTMIN = 0,
		        DEFAULTMAX = 100,
		        DEFAULTVALUE = 0,
		        DEFAULTCHUNKCOUNT = 5,
		        KPROGRESSBAR = "k-progressbar",
		        KPROGRESSBARREVERSE = "k-progressbar-reverse",
		        KPROGRESSBARINDETERMINATE = "k-progressbar-indeterminate",
		        KPROGRESSBARCOMPLETE = "k-complete",
		        KPROGRESSWRAPPER = "k-state-selected",
		        KPROGRESSSTATUS = "k-progress-status",
		        KCOMPLETEDCHUNK = "k-state-selected",
		        KUPCOMINGCHUNK = "k-state-default",
		        KSTATEDISABLED = "k-state-disabled",
		        PROGRESSTYPE = {
		            VALUE: "value",
		            PERCENT: "percent",
		            CHUNK: "chunk"
		        },
		        CHANGE = "change",
		        COMPLETE = "complete",
		        BOOLEAN = "boolean",
		        math = Math,
		        extend = $.extend,
		        proxy = $.proxy,
		        HUNDREDPERCENT = 100,
		        DEFAULTANIMATIONDURATION = 400,
		        PRECISION = 3,
		        templates = {
		            progressStatus: "<span class='k-progress-status-wrap'><span class='k-progress-status'></span></span>"
		        };
	
		    var ProgressBar = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(this, element, options);
	
		            options = that.options;
	
		            that._progressProperty = (options.orientation === HORIZONTAL) ? "width" : "height";
	
		            that._fields();
	
		            options.value = that._validateValue(options.value);
	
		            that._validateType(options.type);
	
		            that._wrapper();
	
		            that._progressAnimation();
	
		            if ((options.value !== options.min) && (options.value !== false)) {
		               that._updateProgress();
		            }
		        },
	
		        setOptions: function(options) {
		            var that = this;
	
		            Widget.fn.setOptions.call(that, options);
	
		            if (options.hasOwnProperty("reverse")) {
		                that.wrapper.toggleClass("k-progressbar-reverse", options.reverse);
		            }
	
		            if (options.hasOwnProperty("enable")) {
		                that.enable(options.enable);
		            }
	
		            that._progressAnimation();
	
		            that._validateValue();
	
		            that._updateProgress();
		        },
	
		        events: [
		            CHANGE,
		            COMPLETE
		        ],
	
		        options: {
		            name: "ProgressBar",
		            orientation: HORIZONTAL,
		            reverse: false,
		            min: DEFAULTMIN,
		            max: DEFAULTMAX,
		            value: DEFAULTVALUE,
		            enable: true,
		            type: PROGRESSTYPE.VALUE,
		            chunkCount: DEFAULTCHUNKCOUNT,
		            showStatus: true,
		            animation: { }
		        },
	
		        _fields: function() {
		            var that = this;
	
		            that._isStarted = false;
	
		            that.progressWrapper = that.progressStatus = $();
		        },
	
		        _validateType: function(currentType) {
		            var isValid = false;
	
		            $.each(PROGRESSTYPE, function(k, type) {
		                if (type === currentType) {
		                    isValid = true;
		                    return false;
		                }
		            });
	
		            if (!isValid) {
		                throw new Error(kendo.format("Invalid ProgressBar type '{0}'", currentType));
		            }
		        },
	
		        _wrapper: function() {
		            var that = this;
		            var container = that.wrapper = that.element;
		            var options = that.options;
		            var orientation = options.orientation;
		            var initialStatusValue;
	
		            container.addClass("k-widget " + KPROGRESSBAR);
	
		            container.addClass(KPROGRESSBAR + "-" + ((orientation === HORIZONTAL) ? HORIZONTAL : VERTICAL));
	
		            if(options.enable === false) {
		                container.addClass(KSTATEDISABLED);
		            }
	
		            if (options.reverse) {
		                container.addClass(KPROGRESSBARREVERSE);
		            }
	
		            if (options.value === false) {
		                container.addClass(KPROGRESSBARINDETERMINATE);
		            }
	
		            if (options.type === PROGRESSTYPE.CHUNK) {
		                that._addChunkProgressWrapper();
		            } else {
		                if (options.showStatus){
		                    that.progressStatus = that.wrapper.prepend(templates.progressStatus)
		                                              .find("." + KPROGRESSSTATUS);
	
		                    initialStatusValue = (options.value !== false) ? options.value : options.min;
	
		                    if (options.type === PROGRESSTYPE.VALUE) {
		                        that.progressStatus.text(initialStatusValue);
		                    } else {
		                        that.progressStatus.text(that._calculatePercentage(initialStatusValue).toFixed() + "%");
		                    }
		                }
		            }
		        },
	
		        value: function(value) {
		            return this._value(value);
		        },
	
		        _value: function(value){
		            var that = this;
		            var options = that.options;
		            var validated;
	
		            if (value === undefined) {
		                return options.value;
		            } else {
		                if (typeof value !== BOOLEAN) {
		                    value = that._roundValue(value);
	
		                    if(!isNaN(value)) {
		                        validated = that._validateValue(value);
	
		                        if (validated !== options.value) {
		                            that.wrapper.removeClass(KPROGRESSBARINDETERMINATE);
	
		                            options.value = validated;
	
		                            that._isStarted = true;
	
		                            that._updateProgress();
		                        }
		                    }
		                } else if (!value) {
		                    that.wrapper.addClass(KPROGRESSBARINDETERMINATE);
		                    options.value = false;
		                }
		            }
		        },
	
		        _roundValue: function(value) {
		            value = parseFloat(value);
	
		            var power = math.pow(10, PRECISION);
	
		            return math.floor(value * power) / power;
		        },
	
		        _validateValue: function(value) {
		            var that = this;
		            var options = that.options;
	
		            if (value !== false) {
		                if (value <= options.min || value === true) {
		                    return options.min;
		                } else if (value >= options.max) {
		                    return options.max;
		                }
		            } else if (value === false) {
		                return false;
		            }
	
		            if(isNaN(that._roundValue(value))) {
		                return options.min;
		            }
	
		            return value;
		        },
	
		        _updateProgress: function() {
		            var that = this;
		            var options = that.options;
		            var percentage = that._calculatePercentage();
	
		            if (options.type === PROGRESSTYPE.CHUNK) {
		                that._updateChunks(percentage);
		                that._onProgressUpdateAlways(options.value);
		            } else {
		                that._updateProgressWrapper(percentage);
		            }
		        },
	
		        _updateChunks: function(percentage) {
		            var that = this;
		            var options = that.options;
		            var chunkCount = options.chunkCount;
		            var percentagesPerChunk =  parseInt((HUNDREDPERCENT / chunkCount) * 100, 10) / 100;
		            var percentageParsed = parseInt(percentage * 100, 10) / 100;
		            var completedChunksCount = math.floor(percentageParsed / percentagesPerChunk);
		            var completedChunks;
	
		            if((options.orientation === HORIZONTAL && !(options.reverse)) ||
		               (options.orientation === VERTICAL && options.reverse)) {
		                completedChunks = that.wrapper.find("li.k-item:lt(" + completedChunksCount + ")");
		            } else {
		                completedChunks = that.wrapper.find("li.k-item:gt(-" + (completedChunksCount + 1) + ")");
		            }
	
		            that.wrapper.find("." + KCOMPLETEDCHUNK)
		                        .removeClass(KCOMPLETEDCHUNK)
		                        .addClass(KUPCOMINGCHUNK);
	
		            completedChunks.removeClass(KUPCOMINGCHUNK)
		                           .addClass(KCOMPLETEDCHUNK);
		        },
	
		        _updateProgressWrapper: function(percentage) {
		            var that = this;
		            var options = that.options;
		            var progressWrapper = that.wrapper.find("." + KPROGRESSWRAPPER);
		            var animationDuration = that._isStarted ? that._animation.duration : 0;
		            var animationCssOptions = { };
	
		            if (progressWrapper.length === 0) {
		                that._addRegularProgressWrapper();
		            }
	
		            animationCssOptions[that._progressProperty] = percentage + "%";
		            that.progressWrapper.animate(animationCssOptions, {
		                duration: animationDuration,
		                start: proxy(that._onProgressAnimateStart, that),
		                progress: proxy(that._onProgressAnimate, that),
		                complete: proxy(that._onProgressAnimateComplete, that, options.value),
		                always: proxy(that._onProgressUpdateAlways, that, options.value)
		            });
		        },
	
		        _onProgressAnimateStart: function() {
		            this.progressWrapper.show();
		        },
	
		        _onProgressAnimate: function(e) {
		            var that = this;
		            var options = that.options;
		            var progressInPercent = parseFloat(e.elem.style[that._progressProperty], 10);
		            var progressStatusWrapSize;
	
		            if (options.showStatus) {
		                progressStatusWrapSize = 10000 / parseFloat(that.progressWrapper[0].style[that._progressProperty]);
	
		                that.progressWrapper.find(".k-progress-status-wrap").css(that._progressProperty, progressStatusWrapSize + "%");
		            }
	
		            if (options.type !== PROGRESSTYPE.CHUNK && progressInPercent <= 98) {
		                that.progressWrapper.removeClass(KPROGRESSBARCOMPLETE);
		            }
		        },
	
		        _onProgressAnimateComplete: function(currentValue) {
		            var that = this;
		            var options = that.options;
		            var progressWrapperSize = parseFloat(that.progressWrapper[0].style[that._progressProperty]);
		            var progressValue;
	
		            if (options.type !== PROGRESSTYPE.CHUNK && progressWrapperSize > 98) {
		                that.progressWrapper.addClass(KPROGRESSBARCOMPLETE);
		            }
	
		            if (options.showStatus) {
		                if (options.type === PROGRESSTYPE.VALUE) {
		                    progressValue = currentValue;
		                } else if (options.type == PROGRESSTYPE.PERCENT) {
		                    progressValue = that._calculatePercentage(currentValue).toFixed() + "%";
		                } else {
		                    progressValue = math.floor(that._calculatePercentage(currentValue)) + "%";
		                }
		                that.progressStatus.text(progressValue);
		            }
	
		            if (currentValue === options.min) {
		                that.progressWrapper.hide();
		            }
		        },
	
		        _onProgressUpdateAlways: function(currentValue) {
		            var that = this;
		            var options = that.options;
	
		            if (that._isStarted) {
		                that.trigger(CHANGE, { value: currentValue });
		            }
	
		            if (currentValue === options.max && that._isStarted) {
		                that.trigger(COMPLETE, { value: options.max });
		            }
		        },
	
		        enable: function(enable) {
		            var that = this;
		            var options = that.options;
	
		            options.enable = typeof(enable) === "undefined" ? true : enable;
		            that.wrapper.toggleClass(KSTATEDISABLED, !options.enable);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(that);
		        },
	
		        _addChunkProgressWrapper: function () {
		            var that = this;
		            var options = that.options;
		            var container = that.wrapper;
		            var chunkSize = HUNDREDPERCENT / options.chunkCount;
		            var html = "";
	
		            if (options.chunkCount <= 1) {
		                options.chunkCount = 1;
		            }
	
		            html += "<ul class='k-reset'>";
		            for (var i = options.chunkCount - 1; i >= 0; i--) {
		                html += "<li class='k-item k-state-default'></li>";
		            }
		            html += "</ul>";
	
		            container.append(html).find(".k-item").css(that._progressProperty, chunkSize + "%")
		                     .first().addClass("k-first")
		                     .end()
		                     .last().addClass("k-last");
	
		            that._normalizeChunkSize();
		        },
	
		        _normalizeChunkSize: function() {
		            var that = this;
		            var options = that.options;
		            var lastChunk = that.wrapper.find(".k-item:last");
		            var currentSize = parseFloat(lastChunk[0].style[that._progressProperty]);
		            var difference = HUNDREDPERCENT - (options.chunkCount * currentSize);
	
		            if (difference > 0) {
		                lastChunk.css(that._progressProperty, (currentSize + difference) + "%");
		            }
		        },
	
		        _addRegularProgressWrapper: function() {
		            var that = this;
	
		            that.progressWrapper = $("<div class='" + KPROGRESSWRAPPER + "'></div>").appendTo(that.wrapper);
	
		            if (that.options.showStatus) {
		                that.progressWrapper.append(templates.progressStatus);
	
		                that.progressStatus = that.wrapper.find("." + KPROGRESSSTATUS);
		            }
		        },
	
		        _calculateChunkSize: function() {
		            var that = this;
		            var chunkCount = that.options.chunkCount;
		            var chunkContainer = that.wrapper.find("ul.k-reset");
	
		            return (parseInt(chunkContainer.css(that._progressProperty), 10) - (chunkCount - 1)) / chunkCount;
		        },
	
		        _calculatePercentage: function(currentValue) {
		            var that = this;
		            var options = that.options;
		            var value = (currentValue !== undefined) ? currentValue : options.value;
		            var min = options.min;
		            var max = options.max;
		            that._onePercent = math.abs((max - min) / 100);
	
		            return math.abs((value - min) / that._onePercent);
		        },
	
		        _progressAnimation: function() {
		            var that = this;
		            var options = that.options;
		            var animation = options.animation;
	
		            if (animation === false) {
		                that._animation = { duration: 0 };
		            } else {
		                that._animation = extend({
		                    duration: DEFAULTANIMATIONDURATION
		                }, options.animation);
		            }
		        }
		    });
	
		    kendo.ui.plugin(ProgressBar);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1334);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1334:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1038), __webpack_require__(1036) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "toolbar",
		    name: "ToolBar",
		    category: "web",
		    description: "The ToolBar widget displays one or more command buttons divided into groups.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Class = kendo.Class,
		        Widget = kendo.ui.Widget,
		        proxy = $.proxy,
		        isFunction = kendo.isFunction,
		        keys = kendo.keys,
		        outerWidth = kendo._outerWidth,
	
		        TOOLBAR = "k-toolbar",
		        BUTTON = "k-button",
		        OVERFLOW_BUTTON = "k-overflow-button",
		        TOGGLE_BUTTON = "k-toggle-button",
		        BUTTON_GROUP = "k-button-group",
		        SPLIT_BUTTON = "k-split-button",
		        SEPARATOR = "k-separator",
		        POPUP = "k-popup",
	
		        RESIZABLE_TOOLBAR = "k-toolbar-resizable",
		        STATE_ACTIVE = "k-state-active",
		        STATE_DISABLED = "k-state-disabled",
		        STATE_HIDDEN = "k-state-hidden",
		        GROUP_START = "k-group-start",
		        GROUP_END = "k-group-end",
		        PRIMARY = "k-primary",
	
		        ICON = "k-icon",
		        ICON_PREFIX = "k-i-",
		        BUTTON_ICON = "k-button-icon",
		        BUTTON_ICON_TEXT = "k-button-icontext",
	
		        LIST_CONTAINER = "k-list-container k-split-container",
		        SPLIT_BUTTON_ARROW = "k-split-button-arrow",
	
		        OVERFLOW_ANCHOR = "k-overflow-anchor",
		        OVERFLOW_CONTAINER = "k-overflow-container",
		        FIRST_TOOLBAR_VISIBLE = "k-toolbar-first-visible",
		        LAST_TOOLBAR_VISIBLE = "k-toolbar-last-visible",
	
		        CLICK = "click",
		        TOGGLE = "toggle",
		        OPEN = "open",
		        CLOSE = "close",
		        OVERFLOW_OPEN = "overflowOpen",
		        OVERFLOW_CLOSE = "overflowClose",
	
		        OVERFLOW_NEVER = "never",
		        OVERFLOW_AUTO = "auto",
		        OVERFLOW_ALWAYS = "always",
		        OVERFLOW_HIDDEN = "k-overflow-hidden",
	
		        OPTION_LIST_SUFFIX = "_optionlist",
	
		        KENDO_UID_ATTR = kendo.attr("uid");
	
		        kendo.toolbar = {};
	
		        var components = {
		            overflowAnchor: '<div tabindex="0" class="k-overflow-anchor"></div>',
		            overflowContainer: '<ul class="k-overflow-container k-list-container"></ul>'
		        };
	
		        kendo.toolbar.registerComponent = function(name, toolbar, overflow) {
		            components[name] = {
		                toolbar: toolbar,
		                overflow: overflow
		            };
		        };
	
		        var Item = kendo.Class.extend({
		            addOverflowAttr: function() {
		                this.element.attr(kendo.attr("overflow"), this.options.overflow || OVERFLOW_AUTO);
		            },
	
		            addUidAttr: function() {
		                this.element.attr(KENDO_UID_ATTR, this.options.uid);
		            },
	
		            addIdAttr: function() {
		                if (this.options.id) {
		                    this.element.attr("id", this.options.id);
		                }
		            },
	
		            addOverflowIdAttr: function() {
		                if (this.options.id) {
		                    this.element.attr("id", this.options.id + "_overflow");
		                }
		            },
	
		            attributes: function() {
		                if (this.options.attributes) {
		                    this.element.attr(this.options.attributes);
		                }
		            },
	
		            show: function() {
		                this.element.removeClass(STATE_HIDDEN).show();
		                this.options.hidden = false;
		            },
	
		            hide: function() {
		                this.element.addClass(STATE_HIDDEN).hide();
		                if(this.overflow && this.overflowHidden){
		                    this.overflowHidden();
		                }
		                this.options.hidden = true;
		            },
	
		            remove: function() {
		                this.element.remove();
		            },
	
		            enable: function(isEnabled) {
		                if (isEnabled === undefined) {
		                    isEnabled = true;
		                }
		                this.element.toggleClass(STATE_DISABLED, !isEnabled);
		                this.options.enable = isEnabled;
		            },
	
		            twin: function() {
		                var uid = this.element.attr(KENDO_UID_ATTR);
		                if (this.overflow && this.options.splitContainerId) {
		                    return $("#" + this.options.splitContainerId)
		                            .find("[" + KENDO_UID_ATTR + "='" + uid + "']")
		                            .data(this.options.type);
		                } else if (this.overflow) {
		                    return this.toolbar
		                            .element
		                            .find("[" + KENDO_UID_ATTR + "='" + uid + "']")
		                            .data(this.options.type);
		                } else if (this.toolbar.options.resizable) {
		                    return this.toolbar
		                            .popup.element
		                            .find("[" + KENDO_UID_ATTR + "='" + uid + "']")
		                            .data(this.options.type);
		                }
		            }
		        });
	
		        kendo.toolbar.Item = Item;
	
		        var Button = Item.extend({
		            init: function(options, toolbar) {
		                var element = options.useButtonTag ? $('<button tabindex="0"></button>') : $('<a href tabindex="0"></a>');
	
		                this.element = element;
		                this.options = options;
		                this.toolbar = toolbar;
	
		                this.attributes();
	
		                if (options.primary) {
		                    element.addClass(PRIMARY);
		                }
	
		                if (options.togglable) {
		                    element.addClass(TOGGLE_BUTTON);
		                    this.toggle(options.selected);
		                }
	
		                if (options.url !== undefined && !options.useButtonTag) {
		                    element.attr("href", options.url);
		                    if (options.mobile) {
		                        element.attr(kendo.attr("role"), "button");
		                    }
		                }
	
		                if (options.group) {
		                    element.attr(kendo.attr("group"), options.group);
		                    this.group = this.toolbar.addToGroup(this, options.group);
		                }
	
		                if (!options.togglable && options.click && isFunction(options.click)) {
		                    this.clickHandler = options.click;
		                }
	
		                if (options.togglable && options.toggle && isFunction(options.toggle)) {
		                    this.toggleHandler = options.toggle;
		                }
		            },
	
		            toggle: function(state, propagate) {
		                state = !!state;
	
		                if (this.group && state) {
		                    this.group.select(this);
		                } else if (!this.group) {
		                    this.select(state);
		                }
	
		                if (propagate && this.twin()) {
		                    this.twin().toggle(state);
		                }
		            },
	
		            getParentGroup: function() {
		                if (this.options.isChild) {
		                    return this.element.closest("." + BUTTON_GROUP).data("buttonGroup");
		                }
		            },
	
		            _addGraphics: function() {
		                var element = this.element,
		                    icon = this.options.icon,
		                    spriteCssClass = this.options.spriteCssClass,
		                    imageUrl = this.options.imageUrl,
		                    isEmpty, span, img;
	
		                if (spriteCssClass || imageUrl || icon) {
		                    isEmpty = true;
	
		                    element.contents().filter(function() {
		                        return (!$(this).hasClass("k-sprite") && !$(this).hasClass(ICON) && !$(this).hasClass("k-image"));
		                    }).each(function(idx, el){
		                        if (el.nodeType == 1 || el.nodeType == 3 && $.trim(el.nodeValue).length > 0) {
		                            isEmpty = false;
		                        }
		                    });
	
		                    if (isEmpty) {
		                        element.addClass(BUTTON_ICON);
		                    } else {
		                        element.addClass(BUTTON_ICON_TEXT);
		                    }
		                }
		                if (icon) {
		                    span = element.children("span." + ICON).first();
		                    if (!span[0]) {
		                        span = $('<span class="' + ICON + '"></span>').prependTo(element);
		                    }
		                    span.addClass(ICON_PREFIX + icon);
		                } else if (spriteCssClass) {
		                    span = element.children("span.k-sprite").first();
		                    if (!span[0]) {
		                        span = $('<span class="k-sprite ' + ICON + '"></span>').prependTo(element);
		                    }
		                    span.addClass(spriteCssClass);
		                } else if (imageUrl) {
		                    img = element.children("img.k-image").first();
		                    if (!img[0]) {
		                        img = $('<img alt="icon" class="k-image" />').prependTo(element);
		                    }
		                    img.attr("src", imageUrl);
		                }
		            }
		        });
	
		        kendo.toolbar.Button = Button;
	
		        var ToolBarButton = Button.extend({
		            init: function(options, toolbar) {
		                Button.fn.init.call(this, options, toolbar);
	
		                var element = this.element;
	
		                element.addClass(BUTTON);
	
		                this.addIdAttr();
	
		                if (options.align) {
		                    element.addClass("k-align-" + options.align);
		                }
	
		                if (options.showText != "overflow" && options.text) {
		                    if (options.mobile) {
		                        element.html('<span class="km-text">' + options.text + "</span>");
		                    } else {
		                        element.html(options.text);
		                    }
		                }
	
		                options.hasIcon = (options.showIcon != "overflow") && (options.icon || options.spriteCssClass || options.imageUrl);
		                if (options.hasIcon) {
		                    this._addGraphics();
		                }
	
		                this.addUidAttr();
		                this.addOverflowAttr();
		                this.enable(options.enable);
	
		                if (options.hidden) {
		                    this.hide();
		                }
	
		                this.element.data({
		                    type: "button",
		                    button: this
		                });
		            },
	
		            select: function(selected) {
		                if (selected === undefined) {
		                    selected = false;
		                }
	
		                this.element.toggleClass(STATE_ACTIVE, selected);
		                this.options.selected = selected;
		            }
		        });
	
		        kendo.toolbar.ToolBarButton = ToolBarButton;
	
		        var OverflowButton = Button.extend({
		            init: function(options, toolbar) {
		                this.overflow = true;
	
		                Button.fn.init.call(this, $.extend({}, options), toolbar);
	
		                var element = this.element;
	
		                if (options.showText != "toolbar" && options.text) {
		                    if (options.mobile) {
		                        element.html('<span class="km-text">' + options.text + "</span>");
		                    } else {
		                        element.html('<span class="k-text">' + options.text + "</span>");
		                    }
		                }
	
		                options.hasIcon = (options.showIcon != "toolbar") && (options.icon || options.spriteCssClass || options.imageUrl);
		                if (options.hasIcon) {
		                    this._addGraphics();
		                }
	
		                if (!options.isChild) {
		                    this._wrap();
		                }
	
		                this.addOverflowIdAttr();
		                this.attributes();
		                this.addUidAttr();
		                this.addOverflowAttr();
		                this.enable(options.enable);
	
		                element.addClass(OVERFLOW_BUTTON + " " + BUTTON);
	
		                if (options.hidden) {
		                    this.hide();
		                }
	
		                if (options.togglable){
		                    this.toggle(options.selected);
		                }
	
		                this.element.data({
		                    type: "button",
		                    button: this
		                });
		            },
	
		            _wrap: function() {
		                this.element = this.element.wrap("<li></li>").parent();
		            },
	
		            overflowHidden: function() {
		                this.element.addClass(OVERFLOW_HIDDEN);
		            },
	
		            select: function(selected) {
		                if (selected === undefined) {
		                    selected = false;
		                }
	
		                if (this.options.isChild) {
		                    this.element.toggleClass(STATE_ACTIVE, selected);
		                } else {
		                    this.element.find(".k-button").toggleClass(STATE_ACTIVE, selected);
		                }
		                this.options.selected = selected;
		            }
		        });
	
		        kendo.toolbar.OverflowButton = OverflowButton;
		        kendo.toolbar.registerComponent("button", ToolBarButton, OverflowButton);
	
		        var ButtonGroup = Item.extend({
		            createButtons: function(buttonConstructor) {
		                var options = this.options;
		                var items = options.buttons || [];
		                var item;
	
		                for (var i = 0; i < items.length; i++) {
		                    if (!items[i].uid) {
		                        items[i].uid = kendo.guid();
		                    }
		                    item = new buttonConstructor($.extend({ mobile: options.mobile, isChild: true, type: "button" }, items[i]), this.toolbar);
		                    item.element.appendTo(this.element);
		                }
		            },
	
		            refresh: function() {
		                this.element.children().filter(":not('." + STATE_HIDDEN + "'):first").addClass(GROUP_START);
		                this.element.children().filter(":not('." + STATE_HIDDEN + "'):last").addClass(GROUP_END);
		            }
		        });
	
		        kendo.toolbar.ButtonGroup = ButtonGroup;
	
		        var ToolBarButtonGroup = ButtonGroup.extend({
		            init: function(options, toolbar) {
		                var element = this.element = $('<div></div>');
		                this.options = options;
		                this.toolbar = toolbar;
	
		                this.addIdAttr();
	
		                if (options.align) {
		                    element.addClass("k-align-" + options.align);
		                }
	
		                this.createButtons(ToolBarButton);
		                this.attributes();
		                this.addUidAttr();
		                this.addOverflowAttr();
		                this.refresh();
	
		                element.addClass(BUTTON_GROUP);
	
		                this.element.data({
		                    type: "buttonGroup",
		                    buttonGroup: this
		                });
		            }
		        });
	
		        kendo.toolbar.ToolBarButtonGroup = ToolBarButtonGroup;
	
		        var OverflowButtonGroup = ButtonGroup.extend({
		            init: function(options, toolbar) {
		                var element = this.element = $('<li></li>');
		                this.options = options;
		                this.toolbar = toolbar;
		                this.overflow = true;
	
		                this.addOverflowIdAttr();
	
		                this.createButtons(OverflowButton);
		                this.attributes();
		                this.addUidAttr();
		                this.addOverflowAttr();
		                this.refresh();
	
		                element.addClass((options.mobile ? "" : BUTTON_GROUP) + " k-overflow-group");
	
		                this.element.data({
		                    type: "buttonGroup",
		                    buttonGroup: this
		                });
		            },
	
		            overflowHidden: function() {
		                this.element.addClass(OVERFLOW_HIDDEN);
		            }
		        });
	
		        kendo.toolbar.OverflowButtonGroup = OverflowButtonGroup;
		        kendo.toolbar.registerComponent("buttonGroup", ToolBarButtonGroup, OverflowButtonGroup);
	
		        var ToolBarSplitButton = Item.extend({
		            init: function(options, toolbar) {
		                var element = this.element = $('<div class="' + SPLIT_BUTTON + '" tabindex="0"></div>');
	
		                this.options = options;
		                this.toolbar = toolbar;
	
		                this.mainButton = new ToolBarButton($.extend({}, options, { hidden: false }), toolbar);
		                this.arrowButton = $('<a class="' + BUTTON + " " + SPLIT_BUTTON_ARROW + '"><span class="' + (options.mobile ? "km-icon km-arrowdown" : "k-icon k-i-arrow-60-down") + '"></span></a>');
		                this.popupElement = $('<ul class="' + LIST_CONTAINER + '"></ul>');
	
		                this.mainButton.element
		                    .removeAttr("href tabindex")
		                    .appendTo(element);
	
		                this.arrowButton.appendTo(element);
		                this.popupElement.appendTo(element);
	
		                if (options.align) {
		                    element.addClass("k-align-" + options.align);
		                }
	
		                if (!options.id) {
		                    options.id = options.uid;
		                }
	
		                element.attr("id", options.id + "_wrapper");
	
		                this.addOverflowAttr();
		                this.addUidAttr();
	
		                this.createMenuButtons();
		                this.createPopup();
		                this._navigatable();
	
		                this.mainButton.main = true;
	
		                this.enable(options.enable);
	
		                if (options.hidden) {
		                    this.hide();
		                }
	
		                element.data({
		                    type: "splitButton",
		                    splitButton: this,
		                    kendoPopup: this.popup
		                });
		            },
	
		            _navigatable: function() {
		                var that = this;
	
		                that.popupElement.on("keydown", "." + BUTTON, function(e) {
		                    var li = $(e.target).parent();
	
		                    e.preventDefault();
	
		                    if (e.keyCode === keys.ESC || e.keyCode === keys.TAB || (e.altKey && e.keyCode === keys.UP)) {
		                        that.toggle();
		                        that.focus();
		                    } else if (e.keyCode === keys.DOWN) {
		                        findFocusableSibling(li, "next").focus();
		                    } else if (e.keyCode === keys.UP) {
		                        findFocusableSibling(li, "prev").focus();
		                    } else if (e.keyCode === keys.SPACEBAR || e.keyCode === keys.ENTER) {
		                        that.toolbar.userEvents.trigger("tap", { target: $(e.target) });
		                    } else if (e.keyCode === keys.HOME) {
		                        li.parent().find(":kendoFocusable").first().focus();
		                    } else if (e.keyCode === keys.END) {
		                        li.parent().find(":kendoFocusable").last().focus();
		                    }
		                });
		            },
	
		            createMenuButtons: function() {
		                var options = this.options;
		                var items = options.menuButtons;
		                var item;
	
		                for (var i = 0; i < items.length; i++) {
		                    item = new ToolBarButton($.extend({ mobile: options.mobile, type: "button", click: options.click }, items[i]), this.toolbar);
		                    item.element.wrap("<li></li>").parent().appendTo(this.popupElement);
		                }
		            },
	
		            createPopup: function() {
		                var that = this;
		                var options = this.options;
		                var element = this.element;
	
		                this.popupElement
		                        .attr("id", options.id + OPTION_LIST_SUFFIX)
		                        .attr(KENDO_UID_ATTR, options.rootUid);
	
		                if (options.mobile) {
		                    this.popupElement = actionSheetWrap(this.popupElement);
		                }
	
		                this.popup = this.popupElement.kendoPopup({
		                    appendTo: options.mobile ? $(options.mobile).children(".km-pane") : null,
		                    anchor: element,
		                    isRtl: this.toolbar._isRtl,
		                    copyAnchorStyles: false,
		                    animation: options.animation,
		                    open: function(e){
		                        var isDefaultPrevented = that.toolbar.trigger(OPEN, { target: element });
	
		                        if(isDefaultPrevented){
		                            e.preventDefault();
		                            return;
		                        }
	
		                        that.adjustPopupWidth(e.sender);
		                    },
		                    activate: function() {
		                        this.element.find(":kendoFocusable").first().focus();
		                    },
		                    close: function(e) {
		                        var isDefaultPrevented = that.toolbar.trigger(CLOSE, { target: element });
		                        if(isDefaultPrevented){
		                            e.preventDefault();
		                        }
		                        element.focus();
		                    }
		                }).data("kendoPopup");
	
		                this.popup.element.on(CLICK, "a.k-button", preventClick);
		            },
	
		            adjustPopupWidth: function (popup) {
		                var anchor = popup.options.anchor,
		                    computedWidth = outerWidth(anchor),
		                    width;
	
		                kendo.wrap(popup.element).addClass("k-split-wrapper");
	
		                if (popup.element.css("box-sizing") !== "border-box") {
		                    width = computedWidth - (outerWidth(popup.element) - popup.element.width());
		                } else {
		                    width = computedWidth;
		                }
	
		                popup.element.css({
		                    fontFamily: anchor.css("font-family"),
		                    "min-width": width
		                });
		            },
	
		            remove: function() {
		                this.popup.element.off(CLICK, "a.k-button");
		                this.popup.destroy();
		                this.element.remove();
		            },
	
		            toggle: function() {
		                if(this.options.enable || this.popup.visible()){
		                    this.popup.toggle();
		                }
		            },
	
		            enable: function(isEnabled) {
		                if (isEnabled === undefined) {
		                    isEnabled = true;
		                }
	
		                this.mainButton.enable(isEnabled);
		                this.element.toggleClass(STATE_DISABLED, !isEnabled);
		                this.options.enable = isEnabled;
		            },
	
		            focus: function() {
		                this.element.focus();
		            },
	
		            hide: function() {
		                if (this.popup) {
		                    this.popup.close();
		                }
	
		                this.element.addClass(STATE_HIDDEN).hide();
		                this.options.hidden = true;
		            },
	
		            show: function() {
		                this.element.removeClass(STATE_HIDDEN).hide();
		                this.options.hidden = false;
		            }
		        });
	
		        kendo.toolbar.ToolBarSplitButton = ToolBarSplitButton;
	
		        var OverflowSplitButton = Item.extend({
		            init: function(options, toolbar) {
		                var element = this.element = $('<li class="' + SPLIT_BUTTON + '"></li>'),
		                    items = options.menuButtons,
		                    item, splitContainerId;
	
		                this.options = options;
		                this.toolbar = toolbar;
		                this.overflow = true;
		                splitContainerId = (options.id || options.uid) + OPTION_LIST_SUFFIX;
	
		                this.mainButton = new OverflowButton($.extend({ }, options));
		                this.mainButton.element.appendTo(element);
	
		                for (var i = 0; i < items.length; i++) {
		                    item = new OverflowButton($.extend({ mobile: options.mobile, type: "button", splitContainerId: splitContainerId }, items[i]), this.toolbar);
		                    item.element.appendTo(element);
		                }
	
		                this.addUidAttr();
		                this.addOverflowAttr();
	
		                this.mainButton.main = true;
	
		                element.data({
		                    type: "splitButton",
		                    splitButton: this
		                });
		            },
	
		            overflowHidden: function() {
		                this.element.addClass(OVERFLOW_HIDDEN);
		            }
		        });
	
		        kendo.toolbar.OverflowSplitButton = OverflowSplitButton;
		        kendo.toolbar.registerComponent("splitButton", ToolBarSplitButton, OverflowSplitButton);
	
		        var ToolBarSeparator = Item.extend({
		            init: function(options, toolbar) {
		                var element = this.element = $('<div>&nbsp;</div>');
	
		                this.element = element;
		                this.options = options;
		                this.toolbar = toolbar;
	
		                this.attributes();
		                this.addIdAttr();
		                this.addUidAttr();
		                this.addOverflowAttr();
	
		                element.addClass(SEPARATOR);
	
		                element.data({
		                    type: "separator",
		                    separator: this
		                });
		            }
		        });
	
		        var OverflowSeparator = Item.extend({
		            init: function(options, toolbar) {
		                var element = this.element = $('<li>&nbsp;</li>');
	
		                this.element = element;
		                this.options = options;
		                this.toolbar = toolbar;
		                this.overflow = true;
	
		                this.attributes();
		                this.addUidAttr();
		                this.addOverflowIdAttr();
	
		                element.addClass(SEPARATOR);
	
		                element.data({
		                    type: "separator",
		                    separator: this
		                });
		            },
	
		            overflowHidden: function() {
		                this.element.addClass(OVERFLOW_HIDDEN);
		            }
		        });
	
		        kendo.toolbar.registerComponent("separator", ToolBarSeparator, OverflowSeparator);
	
		        var TemplateItem = Item.extend({
		            init: function(template, options, toolbar) {
		                var element = isFunction(template) ? template(options) : template;
	
		                if (!(element instanceof jQuery)) {
		                    element = $("<div></div>").html(element);
		                } else {
		                    element = element.wrap("<div></div>").parent();
		                }
	
		                this.element = element;
		                this.options = options;
		                this.options.type = "template";
		                this.toolbar = toolbar;
	
		                this.attributes();
		                this.addUidAttr();
		                this.addIdAttr();
		                this.addOverflowAttr();
	
		                element.data({
		                    type: "template",
		                    template: this
		                });
		            }
		        });
	
		        kendo.toolbar.TemplateItem = TemplateItem;
	
		        var OverflowTemplateItem = Item.extend({
		            init: function(template, options, toolbar) {
		                var element = isFunction(template) ? $(template(options)) : $(template);
	
		                if (!(element instanceof jQuery)) {
		                    element = $("<li></li>").html(element);
		                } else {
		                    element = element.wrap("<li></li>").parent();
		                }
	
		                this.element = element;
		                this.options = options;
		                this.options.type = "template";
		                this.toolbar = toolbar;
		                this.overflow = true;
	
		                this.attributes();
		                this.addUidAttr();
		                this.addOverflowIdAttr();
		                this.addOverflowAttr();
	
		                element.data({
		                    type: "template",
		                    template: this
		                });
		            },
	
		            overflowHidden: function() {
		                this.element.addClass(OVERFLOW_HIDDEN);
		            }
		        });
	
		        kendo.toolbar.OverflowTemplateItem = OverflowTemplateItem;
	
		        function toggleActive(e) {
		            if (!e.target.is(".k-toggle-button")) {
		                e.target.toggleClass(STATE_ACTIVE, e.type == "press");
		            }
		        }
	
		        function actionSheetWrap(element) {
		            element = $(element);
	
		            return element.hasClass("km-actionsheet") ? element.closest(".km-popup-wrapper") : element.addClass("km-widget km-actionsheet")
		                             .wrap('<div class="km-actionsheet-wrapper km-actionsheet-tablet km-widget km-popup"></div>').parent()
		                             .wrap('<div class="km-popup-wrapper k-popup"></div>').parent();
		        }
	
		        function preventClick(e) {
		            if ($(e.target).closest("a.k-button").length) {
		                e.preventDefault();
		            }
		        }
	
		        function findFocusableSibling (element, dir) {
		            var getSibling = dir === "next" ? $.fn.next : $.fn.prev;
		            var getter = dir === "next" ? $.fn.first : $.fn.last;
		            var candidate = getSibling.call(element);
	
		            if(!candidate.length && element.is("." + OVERFLOW_ANCHOR)){
		                return element;
		            }
	
		            if (candidate.is(":kendoFocusable") || !candidate.length) {
		                return candidate;
		            }
	
		            if (candidate.find(":kendoFocusable").length) {
		                return getter.call(candidate.find(":kendoFocusable"));
		            }
	
		            return findFocusableSibling(candidate, dir);
		        }
	
		        var Group = Class.extend({
		            init: function(name) {
		                this.name = name;
		                this.buttons = [];
		            },
	
		            add: function(button) {
		                this.buttons[this.buttons.length] = button;
		            },
	
		            remove: function(button) {
		                var index = $.inArray(button, this.buttons);
		                this.buttons.splice(index, 1);
		            },
	
		            select: function(button) {
		                var tmp;
		                for (var i = 0; i < this.buttons.length; i ++) {
		                    tmp = this.buttons[i];
	
		                    tmp.select(false);
		                }
	
		                button.select(true);
		                if (button.twin()) {
		                    button.twin().select(true);
		                }
		            }
		        });
	
		        var ToolBar = Widget.extend({
		            init: function(element, options) {
		                var that = this;
	
		                Widget.fn.init.call(that, element, options);
	
		                options = that.options;
		                element = that.wrapper = that.element;
	
		                element.addClass(TOOLBAR + " k-widget");
	
		                this.uid = kendo.guid();
		                this._isRtl = kendo.support.isRtl(element);
		                this._groups = {};
		                element.attr(KENDO_UID_ATTR, this.uid);
	
		                that.isMobile = (typeof options.mobile === "boolean") ? options.mobile : that.element.closest(".km-root")[0];
		                that.animation = that.isMobile ? { open: { effects: "fade" } } : {};
	
		                if (that.isMobile) {
		                    element.addClass("km-widget");
		                    ICON = "km-icon";
		                    ICON_PREFIX = "km-";
		                    BUTTON = "km-button";
		                    BUTTON_GROUP = "km-buttongroup km-widget";
		                    STATE_ACTIVE = "km-state-active";
		                    STATE_DISABLED = "km-state-disabled";
		                }
	
		                if(options.resizable) {
		                    that._renderOverflow();
		                    element.addClass(RESIZABLE_TOOLBAR);
	
		                    that.overflowUserEvents = new kendo.UserEvents(that.element, {
		                        threshold: 5,
		                        allowSelection: true,
		                        filter: "." + OVERFLOW_ANCHOR,
		                        tap: proxy(that._toggleOverflow, that)
		                    });
	
		                    that._resizeHandler = kendo.onResize(function() {
		                        that.resize();
		                    });
		                } else {
		                    that.popup = { element: $([]) };
		                }
	
		                if(options.items && options.items.length) {
		                    for (var i = 0; i < options.items.length; i++) {
		                        that.add(options.items[i]);
		                    }
	
		                    if(options.resizable) {
		                        that._shrink(that.element.innerWidth());
		                    }
		                }
	
		                that.userEvents = new kendo.UserEvents(document, {
		                    threshold: 5,
		                    allowSelection: true,
		                    filter:
		                        "[" + KENDO_UID_ATTR + "=" + this.uid + "] a." + BUTTON + ", " +
		                        "[" + KENDO_UID_ATTR + "=" + this.uid + "] ." + OVERFLOW_BUTTON,
		                    tap: proxy(that._buttonClick, that),
		                    press: toggleActive,
		                    release: toggleActive
		                });
	
		                that.element.on(CLICK, "a.k-button", preventClick);
		                that._navigatable();
	
		                if (options.resizable) {
		                    that.popup.element.on(CLICK, + "a.k-button", preventClick);
		                }
	
		                if (options.resizable) {
		                    this._toggleOverflowAnchor();
		                }
	
		                kendo.notify(that);
		            },
	
		            events: [
		                CLICK,
		                TOGGLE,
		                OPEN,
		                CLOSE,
		                OVERFLOW_OPEN,
		                OVERFLOW_CLOSE
		            ],
	
		            options: {
		                name: "ToolBar",
		                items: [],
		                resizable: true,
		                mobile: null
		            },
	
		            addToGroup: function(button, groupName) {
		                var group;
	
		                if (!this._groups[groupName]) {
		                    group = this._groups[groupName] = new Group();
		                } else {
		                    group = this._groups[groupName];
		                }
	
		                group.add(button);
		                return group;
		            },
	
		            destroy: function() {
		                var that = this;
	
		                that.element.find("." + SPLIT_BUTTON).each(function(idx, element) {
		                    $(element).data("kendoPopup").destroy();
		                });
	
		                that.element.off(CLICK, "a.k-button");
	
		                that.userEvents.destroy();
	
		                if (that.options.resizable) {
		                    kendo.unbindResize(that._resizeHandler);
		                    that.overflowUserEvents.destroy();
		                    that.popup.element.off(CLICK, "a.k-button");
		                    that.popup.destroy();
		                }
	
		                Widget.fn.destroy.call(that);
		            },
	
		            add: function(options) {
		                var component = components[options.type],
		                    template = options.template,
		                    tool, that = this,
		                    itemClasses = that.isMobile ? "" : "k-item k-state-default",
		                    overflowTemplate = options.overflowTemplate,
		                    overflowTool;
	
		                $.extend(options, {
		                    uid: kendo.guid(),
		                    animation: that.animation,
		                    mobile: that.isMobile,
		                    rootUid: that.uid
		                });
	
		                if (options.menuButtons) {
		                    for (var i = 0; i < options.menuButtons.length; i++) {
		                        $.extend(options.menuButtons[i], {
		                            uid: kendo.guid()
		                        });
		                    }
		                }
	
		                if (template && !overflowTemplate) {
		                    options.overflow = OVERFLOW_NEVER;
		                } else if (!options.overflow) {
		                    options.overflow = OVERFLOW_AUTO;
		                }
	
		                //add the command in the overflow popup
		                if (options.overflow !== OVERFLOW_NEVER && that.options.resizable) {
		                    if (overflowTemplate) { //template command
		                         overflowTool = new OverflowTemplateItem(overflowTemplate, options, that);
		                    } else if (component) { //build-in command
		                        overflowTool = new component.overflow(options, that);
		                        overflowTool.element.addClass(itemClasses);
		                    }
	
		                    if (overflowTool) {
		                        if (options.overflow === OVERFLOW_AUTO) {
		                            overflowTool.overflowHidden();
		                        }
	
		                        overflowTool.element.appendTo(that.popup.container);
		                        that.angular("compile", function(){
		                            return { elements: overflowTool.element.get() };
		                        });
		                    }
		                }
	
		                //add the command in the toolbar container
		                if (options.overflow !== OVERFLOW_ALWAYS) {
		                    if (template) { //template command
		                        tool = new TemplateItem(template, options, that);
		                    } else if (component) { //build-in command
		                        tool = new component.toolbar(options, that);
		                    }
	
		                    if (tool) {
		                        tool.element.appendTo(that.element);
	
		                        that.angular("compile", function(){
		                            return { elements: tool.element.get() };
		                        });
		                    }
		                }
		            },
	
		            _getItem: function(candidate) {
		                var element,
		                    toolbarItem,
		                    overflowItem,
		                    isResizable = this.options.resizable,
		                    type;
	
		                //find toolbar item
	
		                element = this.element.find(candidate);
		                if (!element.length) {
		                    element = $(".k-split-container[data-uid=" + this.uid + "]").find(candidate);
		                }
	
		                type = element.length ? element.data("type") : "";
		                toolbarItem = element.data(type);
	
		                if (toolbarItem) {
		                    if (toolbarItem.main) {
		                        element = element.parent("." + SPLIT_BUTTON);
		                        type = "splitButton";
		                        toolbarItem = element.data(type);
		                    }
	
		                    if (isResizable) {
		                        overflowItem = toolbarItem.twin();
		                    }
		                } else if (isResizable) { //find overflow item
		                    element = this.popup.element.find(candidate);
		                    type = element.length ? element.data("type") : "";
		                    overflowItem = element.data(type);
	
		                    if (overflowItem && overflowItem.main) {
		                        element = element.parent("." + SPLIT_BUTTON);
		                        type = "splitButton";
		                        overflowItem = element.data(type);
		                    }
		                }
	
		                return {
		                    type: type,
		                    toolbar: toolbarItem,
		                    overflow: overflowItem
		                };
		            },
	
		            remove: function(candidate) {
		                var item = this._getItem(candidate);
	
		                if (item.toolbar) { item.toolbar.remove(); }
		                if (item.overflow) { item.overflow.remove(); }
	
		                this.resize(true);
		            },
	
		            hide: function(candidate) {
		                var item = this._getItem(candidate);
	
		                if (item.toolbar) {
		                    if (item.toolbar.options.type === "button" && item.toolbar.options.isChild) {
		                        item.toolbar.hide();
		                        item.toolbar.getParentGroup().refresh();
		                    } else if(!item.toolbar.options.hidden) {
		                        item.toolbar.hide();
		                    }
		                }
	
		                if (item.overflow) {
		                    if (item.overflow.options.type === "button" && item.overflow.options.isChild) {
		                        item.overflow.hide();
		                        item.overflow.getParentGroup().refresh();
		                    } else if(!item.overflow.options.hidden) {
		                        item.overflow.hide();
		                    }
		                }
	
		                this.resize(true);
		            },
	
		            show: function(candidate) {
		                var item = this._getItem(candidate);
	
		                if (item.toolbar) {
		                    if (item.toolbar.options.type === "button" && item.toolbar.options.isChild) {
		                        item.toolbar.show();
		                        item.toolbar.getParentGroup().refresh();
		                    } else if(item.toolbar.options.hidden) {
		                        item.toolbar.show();
		                    }
		                }
	
		                if (item.overflow) {
		                    if (item.overflow.options.type === "button" && item.overflow.options.isChild) {
		                        item.toolbar.show();
		                        item.overflow.getParentGroup().refresh();
		                    } else if(item.overflow.options.hidden) {
		                        item.overflow.show();
		                    }
		                }
	
		                this.resize(true);
		            },
	
		            enable: function(element, enable) {
		                var item = this._getItem(element);
	
		                if (typeof enable == "undefined") {
		                    enable = true;
		                }
	
		                if (item.toolbar) { item.toolbar.enable(enable); }
		                if (item.overflow) { item.overflow.enable(enable); }
		            },
	
		            getSelectedFromGroup: function(groupName) {
		                return this.element.find("." + TOGGLE_BUTTON + "[data-group='" + groupName + "']").filter("." + STATE_ACTIVE);
		            },
	
		            toggle: function(button, checked) {
		                var element = $(button),
		                    item = element.data("button");
	
		                if (item.options.togglable) {
		                    if (checked === undefined) {
		                        checked = true;
		                    }
		                    item.toggle(checked, true);
		                }
		            },
	
		            _renderOverflow: function() {
		                var that = this,
		                    overflowContainer = components.overflowContainer,
		                    isRtl = that._isRtl,
		                    horizontalDirection = isRtl ? "left" : "right";
	
		                that.overflowAnchor = $(components.overflowAnchor).addClass(BUTTON);
	
		                that.element.append(that.overflowAnchor);
	
		                if (that.isMobile) {
		                    that.overflowAnchor.append('<span class="km-icon km-more"></span>');
		                    overflowContainer = actionSheetWrap(overflowContainer);
		                } else {
		                    that.overflowAnchor.append('<span class="k-icon k-i-more-vertical"></span>');
		                }
	
		                that.popup = new kendo.ui.Popup(overflowContainer, {
		                    origin: "bottom " + horizontalDirection,
		                    position: "top " + horizontalDirection,
		                    anchor: that.overflowAnchor,
		                    isRtl: isRtl,
		                    animation: that.animation,
		                    appendTo: that.isMobile ? $(that.isMobile).children(".km-pane") : null,
		                    copyAnchorStyles: false,
		                    open: function (e) {
		                        var wrapper = kendo.wrap(that.popup.element)
		                            .addClass("k-overflow-wrapper");
	
		                        if (!that.isMobile) {
		                            wrapper.css("margin-left", (isRtl ? -1 : 1) * ((outerWidth(wrapper) - wrapper.width()) / 2 + 1));
		                        } else {
		                            that.popup.container.css("max-height", (parseFloat($(".km-content:visible").innerHeight()) - 15) + "px");
		                        }
	
		                        if (that.trigger(OVERFLOW_OPEN)) {
		                            e.preventDefault();
		                        }
		                    },
		                    activate: function() {
		                        this.element.find(":kendoFocusable").first().focus();
		                    },
		                    close: function (e) {
		                        if (that.trigger(OVERFLOW_CLOSE)) {
		                            e.preventDefault();
		                        }
	
		                        this.element.focus();
		                    }
		                });
	
		                that.popup.element.on("keydown", "." + BUTTON, function(e) {
		                    var target = $(e.target),
		                        li = target.parent(),
		                        isComplexTool = li.is("." + BUTTON_GROUP) || li.is("." + SPLIT_BUTTON),
		                        element;
	
		                    e.preventDefault();
	
		                    if (e.keyCode === keys.ESC || e.keyCode === keys.TAB || (e.altKey && e.keyCode === keys.UP)) {
	
		                        that._toggleOverflow();
		                        that.overflowAnchor.focus();
		                    } else if (e.keyCode === keys.DOWN) {
		                        element = !isComplexTool || (isComplexTool && target.is(":last-child")) ? li : target;
		                        findFocusableSibling(element, "next").focus();
		                    } else if (e.keyCode === keys.UP) {
		                        element = !isComplexTool || (isComplexTool && target.is(":first-child")) ? li : target;
		                        findFocusableSibling(element, "prev").focus();
		                    } else if (e.keyCode === keys.SPACEBAR || e.keyCode === keys.ENTER) {
		                        that.userEvents.trigger("tap", { target: $(e.target) });
		                        that.overflowAnchor.focus();
		                    } else if (e.keyCode === keys.HOME) {
		                        li.parent().find(":kendoFocusable").first().focus();
		                    } else if (e.keyCode === keys.END) {
		                        li.parent().find(":kendoFocusable").last().focus();
		                    }
		                });
	
		                if (that.isMobile) {
		                    that.popup.container = that.popup.element.find("." + OVERFLOW_CONTAINER);
		                } else {
		                    that.popup.container = that.popup.element;
		                }
	
		                that.popup.container.attr(KENDO_UID_ATTR, this.uid);
		            },
	
		            _toggleOverflowAnchor: function() {
		                var hasVisibleChildren = false;
	
		                if (this.options.mobile) {
		                    hasVisibleChildren = this.popup.element.find("." + OVERFLOW_CONTAINER).children(":not(." + OVERFLOW_HIDDEN + ", ." + POPUP + ")").length > 0;
		                } else {
		                    hasVisibleChildren = this.popup.element.children(":not(." + OVERFLOW_HIDDEN + ", ." + POPUP + ")").length > 0;
		                }
	
		                if (hasVisibleChildren) {
		                    this.overflowAnchor.css({
		                        visibility: "visible",
		                        width: ""
		                    });
		                } else {
		                    this.overflowAnchor.css({
		                        visibility: "hidden",
		                        width: "1px"
		                    });
		                }
		            },
	
		            _buttonClick: function(e) {
		                var that = this, popup,
		                    target, item, splitContainer,
		                    isSplitButtonArrow = e.target.closest("." + SPLIT_BUTTON_ARROW).length,
		                    handler, eventData, urlTarget;
	
		                e.preventDefault();
	
		                if (isSplitButtonArrow) {
		                    that._toggle(e);
		                    return;
		                }
	
		                target = $(e.target).closest("." + BUTTON, that.element);
	
		                if (target.hasClass(OVERFLOW_ANCHOR)) {
		                    return;
		                }
	
		                item = target.data("button");
	
		                if (!item && that.popup) {
		                    target = $(e.target).closest("." + OVERFLOW_BUTTON, that.popup.container);
		                    item = target.parent("li").data("button");
		                }
	
		                if (!item || !item.options.enable) {
		                    return;
		                }
	
		                if (item.options.togglable) {
		                    handler = isFunction(item.toggleHandler) ? item.toggleHandler : null;
	
		                    item.toggle(!item.options.selected, true);
		                    eventData = { target: target, group: item.options.group, checked: item.options.selected, id: item.options.id, item: item };
	
		                    if (handler) { handler.call(that, eventData); }
		                    that.trigger(TOGGLE, eventData);
		                } else {
		                    handler = isFunction(item.clickHandler) ? item.clickHandler : null;
		                    eventData = { sender: that, target: target, id: item.options.id, item: item };
	
		                    if (handler) { handler.call(that, eventData); }
		                    that.trigger(CLICK, eventData);
		                }
	
		                if (item.options.url) {
		                    if (item.options.attributes && item.options.attributes.target) {
		                        urlTarget = item.options.attributes.target;
		                    }
		                    window.open(item.options.url, urlTarget || "_self");
		                }
	
		                if (target.hasClass(OVERFLOW_BUTTON)) {
		                    that.popup.close();
		                }
	
		                splitContainer = target.closest(".k-split-container");
		                if (splitContainer[0]) {
		                    popup = splitContainer.data("kendoPopup");
		                    (popup ? popup : splitContainer.parents(".km-popup-wrapper").data("kendoPopup")).close();
		                }
		            },
	
		            _navigatable: function() {
		                var that = this;
	
		                that.element
		                    .attr("tabindex", 0)
		                    .on("focusin", function(ev) {
		                        var target = $(ev.target);
		                        var element = $(this).find(":kendoFocusable:first");
	
		                        if (!target.is("." + TOOLBAR) || element.length === 0) {
		                            return;
		                        }
	
		                        if (element.is("." + OVERFLOW_ANCHOR)) {
		                            element = findFocusableSibling(element, "next");
		                        }
	
		                        if(element.length) {
		                            element[0].focus();
		                        }
		                    })
		                    .on("keydown", proxy(that._keydown, that));
		            },
	
		            _keydown: function(e) {
		                var target = $(e.target),
		                    keyCode = e.keyCode,
		                    items = this.element.children(":not(.k-separator):visible"),
		                    direction = this._isRtl ? -1 : 1;
	
		                if (keyCode === keys.TAB) {
		                    var element = target.parentsUntil(this.element).last(),
		                        lastHasFocus = false,
		                        firstHasFocus = false,
		                        isOnlyOverflowAnchor = false;
	
		                    if(!items.not("." + OVERFLOW_ANCHOR).length){
		                        isOnlyOverflowAnchor = true;
		                    }
	
		                    if (!element.length) {
		                        element = target;
		                    }
	
		                    if (element.is("." + OVERFLOW_ANCHOR) && !isOnlyOverflowAnchor) {
		                        var lastItemNotOverflowAnchor = items.last();
	
		                        if (e.shiftKey) {
		                            e.preventDefault();
		                        }
	
		                        if (lastItemNotOverflowAnchor.is(":kendoFocusable")) {
		                            items.last().focus();
		                        } else {
		                            items.last().find(":kendoFocusable").last().focus();
		                        }
		                    }
	
		                    if (!e.shiftKey && items.index(element) === items.length - 1) {
		                        if (element.is("." + BUTTON_GROUP)) {
		                            lastHasFocus = target.is(":last-child");
		                        } else {
		                            lastHasFocus = true;
		                        }
		                    }
	
		                    var isFirstTool = items.index(element) === items.not(".k-overflow-anchor").first().index();
		                    if (e.shiftKey && isFirstTool) {
		                        if (element.is("." + BUTTON_GROUP)) {
		                            firstHasFocus = target.is(":first-child");
		                        } else {
		                            firstHasFocus = true;
		                        }
		                    }
	
		                    if (lastHasFocus && this.overflowAnchor && this.overflowAnchor.css("visibility") !== "hidden" && !isOnlyOverflowAnchor) {
		                        e.preventDefault();
		                        this.overflowAnchor.focus();
		                    }
	
		                    if (firstHasFocus || (isOnlyOverflowAnchor && e.shiftKey)) {
		                        e.preventDefault();
		                        var prevFocusable = this._getPrevFocusable(this.wrapper);
		                        if (prevFocusable) {
		                            prevFocusable.focus();
		                        }
		                    }
		                    this._preventNextFocus = false;
		                }
	
		                if (e.altKey && keyCode === keys.DOWN) {
		                    var splitButton = $(document.activeElement).data("splitButton");
		                    var isOverflowAnchor = $(document.activeElement).is("." + OVERFLOW_ANCHOR);
	
		                    if (splitButton) {
		                        splitButton.toggle();
		                    } else if (isOverflowAnchor) {
		                        this._toggleOverflow();
		                    }
	
		                    return;
		                }
	
		                if ((keyCode === keys.SPACEBAR || keyCode === keys.ENTER) && !target.is("input, checkbox")) {
	
		                    if(keyCode === keys.SPACEBAR){
		                        e.preventDefault(); //prevent spacebar to scroll the page down
		                    }
	
		                    if (target.is("." + SPLIT_BUTTON)) {
		                        target = target.children().first();
		                        this.userEvents.trigger("tap", { target: target });
		                    } else if (keyCode === keys.SPACEBAR) {
		                        this.userEvents.trigger("tap", { target: target });
		                    }
	
		                    return;
		                }
	
		                if (keyCode === keys.HOME) {
		                    if (target.is(".k-dropdown") || target.is("input")) {
		                        return;
		                    }
	
		                    if (this.overflowAnchor) {
		                        items.eq(1).focus();
		                    } else {
		                        items.first().focus();
		                    }
		                    e.preventDefault();
		                } else if (keyCode === keys.END) {
		                    if (target.is(".k-dropdown") || target.is("input")) {
		                        return;
		                    }
		                    if (this.overflowAnchor && $(this.overflowAnchor).css("visibility") != "hidden") {
		                        this.overflowAnchor.focus();
		                    } else {
		                        items.last().focus();
		                    }
		                    e.preventDefault();
		                } else if (keyCode === keys.RIGHT && !this._preventNextFocus && !target.is("input, select, .k-dropdown, .k-colorpicker") && this._getNextElement(e.target, 1 * direction)) {
		                    this._getNextElement(e.target, 1 * direction).focus();
		                    e.preventDefault();
		                } else if (keyCode === keys.LEFT && !this._preventNextFocus && !target.is("input, select, .k-dropdown, .k-colorpicker") && this._getNextElement(e.target, -1 * direction)) {
		                    this._getNextElement(e.target, -1 * direction).focus();
		                    e.preventDefault();
		                }
		            },
	
		            _getNextElement: function (item, direction) {
		                var items = this.element.children(":not(.k-separator):visible");
		                var itemIndex = items.index(item) === -1 ? items.index(item.parentElement) : items.index(item);
		                var startIndex = this.overflowAnchor ? 1 : 0;
		                var directionNumber = direction;
		                var searchIndex = direction === 1 ? items.length - 1 : startIndex;
		                var index = direction === 1 ? startIndex : items.length - 1;
		                var focusableItem = items[itemIndex + direction];
		                this._preventNextFocus = false;
	
		                if ($(item).closest("." + BUTTON_GROUP).length && !$(item).is(direction === 1 ? ":last-child" : ":first-child")) {
		                    return $(item)
		                        .closest("." + BUTTON_GROUP)
		                        .children()[$(item)
		                        .closest("." + BUTTON_GROUP)
		                        .children()
		                        .index(item) + direction];
		                }
	
		                if (this.overflowAnchor && item === this.overflowAnchor[0] && direction === -1) {
		                    focusableItem = items[items.length - 1];
		                }
	
		                if (itemIndex === searchIndex) {
		                    focusableItem = !this.overflowAnchor ||
		                        (this.overflowAnchor &&
		                        $(this.overflowAnchor).css("visibility") === "hidden") ? items[index] : this.overflowAnchor;
		                }
	
		                while (!$(focusableItem).is(":kendoFocusable")) {
		                    if (direction === -1 && $(focusableItem).closest("." + BUTTON_GROUP).length) {
		                        focusableItem = $(focusableItem).children(":not(label, div)").last();
		                    } else {
		                        focusableItem = $(focusableItem).children(":not(label, div)").first();
		                    }
		                    if (!focusableItem.length) {
		                        directionNumber = directionNumber + direction;
		                        focusableItem = items[itemIndex + directionNumber];
		                        if (!focusableItem) {
		                            return this.overflowAnchor;
		                        }
		                    }
		                    this._preventNextFocus = $(focusableItem).closest("." + BUTTON_GROUP).length ? false : true;
		                }
	
		                return focusableItem;
		            },
	
		            _getPrevFocusable: function(element) {
		                if (element.is("html")) {
		                    return element;
		                }
	
		                var elementToFocus, prevElement,
		                    prevElements = element.prevAll();
		                prevElements.each(function(){
		                    prevElement = $(this);
		                    if (prevElement.is(":kendoFocusable")) {
		                        elementToFocus = prevElement;
		                        return false;
		                    } else if (prevElement.find(":kendoFocusable").length > 0) {
		                        elementToFocus = prevElement.find(":kendoFocusable").last();
		                        return false;
		                    }
		                });
		                if (elementToFocus) {
		                    return elementToFocus;
		                } else {
		                    return this._getPrevFocusable(element.parent());
		                }
		            },
	
		            _toggle: function(e) {
		                var splitButton = $(e.target).closest("." + SPLIT_BUTTON).data("splitButton");
	
		                e.preventDefault();
	
		                if (!splitButton.options.enable) {
		                    return;
		                }
	
		                splitButton.toggle();
		            },
	
		            _toggleOverflow: function() {
		                this.popup.toggle();
		            },
	
		            _resize: function(e) {
		                var containerWidth = e.width;
	
		                if (!this.options.resizable) {
		                    return;
		                }
	
		                this.popup.close();
	
		                this._shrink(containerWidth);
		                this._stretch(containerWidth);
	
		                this._markVisibles();
	
		                this._toggleOverflowAnchor();
		            },
	
		            _childrenWidth: function() {
		                var childrenWidth = 0;
	
		                this.element.children(":visible:not('." + STATE_HIDDEN + "')").each(function() {
		                    childrenWidth += outerWidth($(this), true);
		                });
	
		                return Math.ceil(childrenWidth);
		            },
	
		            _shrink: function(containerWidth) {
		                var commandElement,
		                    visibleCommands;
		                if (containerWidth < this._childrenWidth()) {
		                    visibleCommands = this.element.children(":visible:not([data-overflow='never'], ." + OVERFLOW_ANCHOR + ")");
	
		                    for (var i = visibleCommands.length - 1; i >= 0; i--) {
		                        commandElement = visibleCommands.eq(i);
	
		                        if (containerWidth > this._childrenWidth()) {
		                            break;
		                        } else {
		                            this._hideItem(commandElement);
		                        }
		                    }
		                }
		            },
	
		            _stretch: function(containerWidth) {
		                var commandElement,
		                    hiddenCommands;
	
		                if (containerWidth > this._childrenWidth()) {
		                    hiddenCommands = this.element.children(":hidden:not('." + STATE_HIDDEN + "')");
	
		                    for (var i = 0; i < hiddenCommands.length ; i++) {
		                        commandElement = hiddenCommands.eq(i);
		                        if (containerWidth < this._childrenWidth() || !this._showItem(commandElement, containerWidth)) {
		                            break;
		                        }
		                    }
		                }
		            },
	
		            _hideItem: function(item) {
		                item.hide();
		                if (this.popup) {
		                    this.popup.container
		                        .find(">li[data-uid='" + item.data("uid") + "']")
		                        .removeClass(OVERFLOW_HIDDEN);
		                }
		            },
	
		            _showItem: function(item, containerWidth) {
		                if (item.length && containerWidth > this._childrenWidth() + outerWidth(item, true)) {
		                    item.show();
		                    if (this.popup) {
		                        this.popup.container
		                            .find(">li[data-uid='" + item.data("uid") + "']")
		                            .addClass(OVERFLOW_HIDDEN);
		                    }
	
		                    return true;
		                }
	
		                return false;
		            },
	
		            _markVisibles: function() {
		                var overflowItems = this.popup.container.children(),
		                    toolbarItems = this.element.children(":not(.k-overflow-anchor)"),
		                    visibleOverflowItems = overflowItems.filter(":not(.k-overflow-hidden)"),
		                    visibleToolbarItems = toolbarItems.filter(":visible");
	
		                overflowItems.add(toolbarItems).removeClass(FIRST_TOOLBAR_VISIBLE + " " + LAST_TOOLBAR_VISIBLE);
		                visibleOverflowItems.first().add(visibleToolbarItems.first()).addClass(FIRST_TOOLBAR_VISIBLE);
		                visibleOverflowItems.last().add(visibleToolbarItems.last()).addClass(LAST_TOOLBAR_VISIBLE);
		            }
	
		        });
	
		    kendo.ui.plugin(ToolBar);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1268);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1001:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1268:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1001), __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "pivotgrid",
		    name: "PivotGrid",
		    category: "web",
		    description: "The PivotGrid widget is a data summarization tool.",
		    depends: [ "dom", "data", "data.xml", "sortable" ],
		    features: [{
		        id: "pivotgrid-configurator",
		        name: "Configurator",
		        description: "The PivotConfigurator widget allows the user to select data slices displayed in PivotGrid",
		        depends: [ "pivot.configurator" ]
		    }, {
		        id: "pivotgrid-filtering",
		        name: "Filtering",
		        description: "Support for filtering",
		        depends: [ "pivot.fieldmenu" ]
		    }, {
		        id: "pivotgrid-excel-export",
		        name: "Excel export",
		        description: "Export pivot grid data as Excel spreadsheet",
		        depends: [ "ooxml" ]
		    }, {
		        id: "pivotgrid-pdf-export",
		        name: "PDF export",
		        description: "Export pivot grid data as PDF",
		        depends: [ "pdf", "drawing" ]
		    }, {
		        id: "mobile-scroller",
		        name: "Mobile scroller",
		        description: "Support for kinetic scrolling in mobile device",
		        depends: [ "mobile.scroller" ]
		    }]
		};
	
		/*jshint eqnull: true*/
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Class = kendo.Class,
		        Widget = ui.Widget,
		        DataSource = kendo.data.DataSource,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        toString = {}.toString,
		        identity = function(o) { return o; },
		        map = $.map,
		        extend = $.extend,
		        isFunction = kendo.isFunction,
		        CHANGE = "change",
		        ERROR = "error",
		        MEASURES = "Measures",
		        PROGRESS = "progress",
		        STATERESET = "stateReset",
		        AUTO = "auto",
		        DIV = "<div/>",
		        NS = ".kendoPivotGrid",
		        ROW_TOTAL_KEY = "__row_total__",
		        DATABINDING = "dataBinding",
		        DATABOUND = "dataBound",
		        EXPANDMEMBER = "expandMember",
		        COLLAPSEMEMBER = "collapseMember",
		        STATE_EXPANDED = "k-i-collapse",
		        STATE_COLLAPSED = "k-i-expand",
		        HEADER_TEMPLATE = "<span>#: data.member.caption || data.member.name #</span>",
		        KPISTATUS_TEMPLATE = '<span class="k-icon k-i-kpi-status-#=data.dataItem.value > 0 ? \"open\" : data.dataItem.value < 0 ? \"deny\" : \"hold\"#" title="#:data.dataItem.value#"></span>',
		        KPITREND_TEMPLATE = '<span class="k-icon k-i-kpi-trend-#=data.dataItem.value > 0 ? \"increase\" : data.dataItem.value < 0 ? \"decrease\" : \"equal\"#" title="#:data.dataItem.value#"></span>',
		        DATACELL_TEMPLATE = '#= data.dataItem ? kendo.htmlEncode(data.dataItem.fmtValue || data.dataItem.value) || "&nbsp;" : "&nbsp;" #',
		        LAYOUT_TABLE = '<table class="k-pivot-layout">' +
		                            '<tr>' +
		                                '<td>' +
		                                    '<div class="k-pivot-rowheaders"></div>' +
		                                '</td>' +
		                                '<td>' +
		                                    '<div class="k-pivot-table k-state-default"></div>' +
		                                '</td>' +
		                            '</tr>' +
		                        '</table>';
		        var AXIS_ROWS = "rows";
		        var AXIS_COLUMNS = "columns";
	
		    function normalizeMeasures(measure) {
		        var descriptor = typeof measure === "string" ? [{ name: measure }] : measure;
		        var descriptors = toString.call(descriptor) === "[object Array]" ? descriptor : (descriptor !== undefined ? [descriptor] : []);
	
		        return map(descriptors, function(d) {
		            if (typeof d === "string") {
		                return { name: d };
		            }
		            return { name: d.name, type: d.type };
		        });
		    }
	
		    function normalizeMembers(member) {
		        var descriptor = typeof member === "string" ? [{ name: [member], expand: false }] : member;
		        var descriptors = toString.call(descriptor) === "[object Array]" ? descriptor : (descriptor !== undefined ? [descriptor] : []);
	
		        return map(descriptors, function(d) {
		            if (typeof d === "string") {
		                return { name: [d], expand: false };
		            }
		            return { name: (toString.call(d.name) === "[object Array]" ? d.name.slice() : [d.name]), expand: d.expand };
		        });
		    }
	
		    function normalizeName(name) {
		        if (name.indexOf(" ") !== -1) {
		            name = '["' + name + '"]';
		        }
	
		        return name;
		    }
	
		    function accumulateMembers(accumulator, rootTuple, tuple, level) {
		        var idx, length;
		        var children;
		        var member;
	
		        if (!tuple) {
		            tuple = rootTuple;
		        }
	
		        if (!level) {
		            level = 0;
		        }
	
		        member = tuple.members[level];
	
		        if (!member || member.measure) { //return if no member or measure
		            return;
		        }
	
		        children = member.children;
		        length = children.length;
	
		        if (tuple === rootTuple) {
		            accumulator[kendo.stringify([member.name])] = !!length;
		        } else if (length) {
		            accumulator[kendo.stringify(buildPath(tuple, level))] = true;
		        }
	
		        if (length) {
		            for (idx = 0; idx < length; idx++) {
		                accumulateMembers(accumulator, rootTuple, children[idx], level);
		            }
		        }
	
		        accumulateMembers(accumulator, rootTuple, tuple, level + 1);
		    }
	
		    function descriptorsForAxes(tuples) {
		        var result = {};
	
		        if (tuples.length) {
		            accumulateMembers(result, tuples[0]);
		        }
	
		        var descriptors = [];
		        for (var k in result) {
		            descriptors.push({ name: $.parseJSON(k), expand: result[k] });
		        }
	
		        return descriptors;
		    }
	
		    function addMissingPathMembers(members, axis) {
		        var tuples = axis.tuples || [];
		        var firstTuple = tuples[0];
	
		        if (firstTuple && members.length < firstTuple.members.length) {
		            var tupleMembers = firstTuple.members;
	
		            for (var idx = 0; idx < tupleMembers.length; idx++) {
		                if (tupleMembers[idx].measure) {
		                    continue;
		                }
	
		                var found = false;
		                for (var j = 0; j < members.length; j++) {
		                    if (getName(members[j]).indexOf(tupleMembers[idx].hierarchy) === 0) {
		                        found = true;
		                        break;
		                    }
		                }
	
		                if (!found) {
		                    members.push({ name: [tupleMembers[idx].name], expand: false }); //calling normalize here to make name from string to array
		                }
		            }
		        }
		    }
	
		    function tupleToDescriptors(tuple) {
		        var result = [];
		        var members = tuple.members;
	
		        for (var idx = 0; idx < members.length; idx++) {
		            if (members[idx].measure) {
		                continue;
		            }
	
		            //make tuple name an array
		            result.push({ name: [members[idx].name], expand: members[idx].children.length > 0});
		        }
	
		        return result;
		    }
	
		    function descriptorsForMembers(axis, members, measures) {
		        axis = axis || {};
	
		        addMissingPathMembers(members, axis);
	
		        if (measures.length > 1) {
		            members.push({
		                name: MEASURES,
		                measure: true,
		                children: normalizeMembers(measures)
		            });
		        }
	
		        var tupletoSearch = {
		            members: members
		        };
	
		        if (axis.tuples) {
		            var result = findExistingTuple(axis.tuples, tupletoSearch);
		            if (result.tuple) {
		                members = tupleToDescriptors(result.tuple);
		            }
		        }
	
		        return members;
		    }
	
		    function createAggregateGetter(m) {
		        var measureGetter = kendo.getter(m.field, true);
		        return function(aggregatorContext, state) {
		            return m.aggregate(measureGetter(aggregatorContext.dataItem), state, aggregatorContext);
		        };
		    }
	
		    function isNumber(val) {
		        return typeof val === "number" && !isNaN(val);
		    }
	
		    function isDate(val) {
		        return val && val.getTime;
		    }
	
		    var functions = {
		        sum: function(value, state) {
		            var accumulator = state.accumulator;
	
		            if (!isNumber(accumulator)) {
		                accumulator = value;
		            } else if (isNumber(value)) {
		                accumulator += value;
		            }
	
		            return accumulator;
		        },
		        count: function(value, state) {
		            return (state.accumulator || 0) + 1;
		        },
		        average: {
		            aggregate: function(value, state) {
		                var accumulator = state.accumulator;
	
		                if (state.count === undefined) {
		                    state.count = 0;
		                }
	
		                if (!isNumber(accumulator)) {
		                    accumulator = value;
		                } else if (isNumber(value)) {
		                    accumulator += value;
		                }
	
		                if (isNumber(value)) {
		                    state.count++;
		                }
	
		                return accumulator;
		            },
		            result: function(state) {
		                var accumulator = state.accumulator;
	
		                if (isNumber(accumulator)) {
		                    accumulator = accumulator / state.count;
		                }
	
		                return accumulator;
		            }
		        },
		        max: function(value, state) {
		            var accumulator = state.accumulator;
	
		            if (!isNumber(accumulator) && !isDate(accumulator)) {
		                accumulator = value;
		            }
	
		            if(accumulator < value && (isNumber(value) || isDate(value))) {
		                accumulator = value;
		            }
		            return accumulator;
		        },
		        min: function(value, state) {
		            var accumulator = state.accumulator;
	
		            if (!isNumber(accumulator) && !isDate(accumulator)) {
		                accumulator = value;
		            }
	
		            if(accumulator > value && (isNumber(value) || isDate(value))) {
		                accumulator = value;
		            }
		            return accumulator;
		        }
		    };
	
		    var PivotCubeBuilder = Class.extend({
		        init: function(options) {
		            this.options = extend({}, this.options, options);
		            this.dimensions = this._normalizeDescriptors("field", this.options.dimensions);
		            this.measures = this._normalizeDescriptors("name", this.options.measures);
		        },
	
		        _normalizeDescriptors: function(keyField, descriptors) {
		            descriptors = descriptors || {};
		            var fields = {};
		            var field;
	
		            if (toString.call(descriptors) === "[object Array]") {
		                for (var idx = 0, length = descriptors.length; idx < length; idx++) {
		                    field = descriptors[idx];
		                    if (typeof field === "string") {
		                        fields[field] = {};
		                    } else if (field[keyField]) {
		                        fields[field[keyField]] = field;
		                    }
		                }
		                descriptors = fields;
		            }
	
		            return descriptors;
		        },
	
		        _rootTuples: function(rootNames, measureAggregators) {
		            var aggregatorsLength = measureAggregators.length || 1;
		            var dimensionsSchema = this.dimensions || [];
		            var root, name, parts;
		            var measureIdx = 0;
		            var idx;
	
		            var rootNamesLength = rootNames.length;
		            var result = [];
		            var keys = [];
	
		            if (rootNamesLength || measureAggregators.length) {
		                for (measureIdx = 0; measureIdx < aggregatorsLength; measureIdx++) {
	
		                    root = { members: [] };
	
		                    for (idx = 0; idx < rootNamesLength; idx++) {
		                        name = rootNames[idx];
		                        parts = name.split("&");
	
		                        root.members[root.members.length] = {
		                            children: [],
		                            caption: (dimensionsSchema[name] || {}).caption || "All",
		                            name: name,
		                            levelName: name,
		                            levelNum: "0",
		                            hasChildren: true,
		                            parentName: parts.length > 1 ? parts[0] : undefined,
		                            hierarchy: name
		                        };
		                    }
	
		                    if (aggregatorsLength > 1) {
		                        root.members[root.members.length] = {
		                            children: [],
		                            caption: (measureAggregators[measureIdx]).caption,
		                            name: measureAggregators[measureIdx].descriptor.name,
		                            levelName: "MEASURES",
		                            levelNum: "0",
		                            hasChildren: false,
		                            parentName: undefined,
		                            hierarchy: "MEASURES"
		                        };
		                    }
	
		                    result[result.length] = root;
		                }
	
		                keys.push(ROW_TOTAL_KEY);
		            }
	
		            return {
		                keys: keys,
		                tuples: result
		            };
		        },
	
		        _expandedTuples: function(map, expanded, measureAggregators) {
		            var aggregatorsLength = measureAggregators.length || 1;
		            var dimensionsSchema = this.dimensions || [];
		            var measureIdx;
		            var tuple;
	
		            var key;
		            var mapItem;
		            var current;
		            var currentKeys;
		            var accumulator = [];
		            var accumulatorKeys = [];
		            var memberInfo;
	
		            var expandedNames;
		            var parts;
		            var name;
		            var idx;
	
		            for (key in map) {
		                mapItem = map[key];
		                memberInfo = this._findExpandedMember(expanded, mapItem.uniquePath);
	
		                current = accumulator[memberInfo.index] || [];
		                currentKeys = accumulatorKeys[memberInfo.index] || [];
	
		                expandedNames = memberInfo.member.names;
	
		                for (measureIdx = 0; measureIdx < aggregatorsLength; measureIdx++) {
		                    tuple = { members: [] };
		                    for (idx = 0; idx < expandedNames.length; idx++) {
		                        if (idx === memberInfo.member.expandedIdx) {
		                            tuple.members[tuple.members.length] = {
		                                children: [],
		                                caption: mapItem.value,
		                                name: mapItem.name,
		                                hasChildren: false,
		                                levelNum: 1,
		                                levelName: mapItem.parentName + mapItem.name,
		                                parentName: mapItem.parentName,
		                                hierarchy: mapItem.parentName + mapItem.name
		                            };
	
		                            if (measureIdx === 0) {
		                                currentKeys.push(buildPath(tuple, idx).join(""));
		                            }
		                        } else {
		                            name = expandedNames[idx];
		                            parts = name.split("&");
		                            tuple.members[tuple.members.length] = {
		                                children: [],
		                                caption: (dimensionsSchema[name] || {}).caption || "All",
		                                name: name,
		                                levelName: name,
		                                levelNum: "0",
		                                hasChildren: true,
		                                parentName: parts.length > 1 ? parts[0] : undefined,
		                                hierarchy: name
		                            };
		                        }
		                    }
	
		                    if (aggregatorsLength > 1) {
		                        tuple.members[tuple.members.length] = {
		                            children: [],
		                            caption: measureAggregators[measureIdx].caption,
		                            name: measureAggregators[measureIdx].descriptor.name,
		                            levelName: "MEASURES",
		                            levelNum: "0",
		                            hasChildren: true,
		                            parentName: undefined,
		                            hierarchy: "MEASURES"
		                        };
		                    }
	
		                    current[current.length] = tuple;
		                }
	
		                accumulator[memberInfo.index] = current;
		                accumulatorKeys[memberInfo.index] = currentKeys;
		            }
	
		            return {
		                keys: accumulatorKeys,
		                tuples: accumulator
		            };
		        },
	
		        _findExpandedMember: function(members, parentName) {
		            for (var idx = 0; idx < members.length; idx++) {
		                if (members[idx].uniquePath === parentName) {
		                    return {
		                        member: members[idx],
		                        index: idx
		                    };
		                }
		            }
		        },
	
		        _asTuples: function(map, descriptor, measureAggregators) {
		            measureAggregators = measureAggregators || [];
	
		            var rootInfo = this._rootTuples(descriptor.root, measureAggregators);
		            var expandedInfo = this._expandedTuples(map, descriptor.expanded, measureAggregators);
	
		            return {
		                keys: [].concat.apply(rootInfo.keys, expandedInfo.keys),
		                tuples: [].concat.apply(rootInfo.tuples, expandedInfo.tuples)
		            };
		        },
	
		        _measuresInfo: function(measures, rowAxis) {
		            var idx = 0;
		            var length = measures && measures.length;
	
		            var aggregateNames = [];
		            var resultFuncs= {};
		            var formats = {};
	
		            var descriptors = (this.measures || {});
		            var measure;
		            var name;
	
		            for (; idx < length; idx++) {
		                name = measures[idx].descriptor.name;
		                measure = descriptors[name] || {};
	
		                aggregateNames.push(name);
	
		                if (measure.result) {
		                    resultFuncs[name] = measure.result;
		                }
	
		                if (measure.format) {
		                    formats[name] = measure.format;
		                }
		            }
	
		            return {
		                names: aggregateNames,
		                formats: formats,
		                resultFuncs: resultFuncs,
		                rowAxis: rowAxis
		            };
		        },
	
		        _toDataArray: function(map, measuresInfo, rowKeys, columnKeys) {
		            var result = [];
	
		            var aggregates;
		            var name, i, j, k, n;
		            var row, column, columnKey;
	
		            var rowMeasureNamesLength = 1;
		            var rowMeasureNames = [];
		            var columnMeasureNames;
	
		            var rowLength = rowKeys.length || 1;
		            var columnLength = columnKeys.length || 1;
	
		            if (measuresInfo.rowAxis) {
		                rowMeasureNames = measuresInfo.names;
		                rowMeasureNamesLength = rowMeasureNames.length;
		            } else {
		                columnMeasureNames = measuresInfo.names;
		            }
	
		            for (i = 0; i < rowLength; i++) {
		                row = map[rowKeys[i] || ROW_TOTAL_KEY];
	
		                for (n = 0; n < rowMeasureNamesLength; n++) {
		                    if (measuresInfo.rowAxis) {
		                        columnMeasureNames = [rowMeasureNames[n]];
		                    }
	
		                    for (j = 0; j < columnLength; j++) {
		                        columnKey = columnKeys[j] || ROW_TOTAL_KEY;
		                        column = row.items[columnKey];
	
		                        if (columnKey === ROW_TOTAL_KEY) {
		                            aggregates = row.aggregates;
		                        } else {
		                            aggregates = column ? column.aggregates : {};
		                        }
	
		                        for (k = 0; k < columnMeasureNames.length; k++) {
		                            name = columnMeasureNames[k];
		                            this._addData(result, aggregates[name], measuresInfo.formats[name], measuresInfo.resultFuncs[name]);
		                        }
		                    }
		                }
		            }
	
		            return result;
		        },
	
		        _addData: function(result, value, format, resultFunc) {
		            var fmtValue = "";
		            var ordinal;
	
		            if (value) {
		                value = resultFunc ? resultFunc(value) : value.accumulator;
		                fmtValue = format ? kendo.format(format, value) : value;
		            }
	
		            ordinal = result.length;
	
		            result[ordinal] = {
		                ordinal: ordinal,
		                value: value || "",
		                fmtValue: fmtValue
		            };
		        },
	
		        _matchDescriptors: function(dataItem, descriptor, getters) {
		            var parts;
		            var parentField;
		            var expectedValue;
	
		            var names = descriptor.names;
		            var idx = descriptor.expandedIdx;
		            var value;
	
		            while (idx > 0) {
		                parts = names[--idx].split("&");
		                if (parts.length > 1) {
		                    parentField = parts[0];
		                    expectedValue = parts[1];
	
		                    value = getters[parentField](dataItem);
		                    value = (value !== undefined && value !== null) ? value.toString() : value;
	
		                    if (value != expectedValue) {
		                        return false;
		                    }
		                }
		            }
		            return true;
		        },
	
		        _calculateAggregate: function(measureAggregators, aggregatorContext, totalItem) {
		            var result = {};
		            var state;
		            var name;
	
		            for (var measureIdx = 0; measureIdx < measureAggregators.length; measureIdx++) {
		                name = measureAggregators[measureIdx].descriptor.name;
		                state = totalItem.aggregates[name] || { };
		                state.accumulator = measureAggregators[measureIdx].aggregator(aggregatorContext, state);
		                result[name] = state;
		            }
	
		            return result;
		        },
	
		        _processColumns: function(measureAggregators, descriptors, getters, columns, aggregatorContext, rowTotal, state, updateColumn) {
		            var value;
		            var descriptor;
		            var column;
		            var totalItem;
		            var key, name, parentName, path;
		            var dataItem = aggregatorContext.dataItem;
		            var idx = 0;
	
		            for (; idx < descriptors.length; idx++) {
		                descriptor = descriptors[idx];
	
		                //checks whether the dataItem is relevant to the descriptors
		                if (!this._matchDescriptors(dataItem, descriptor, getters)) {
		                    continue;
		                }
	
		                path = descriptor.names.slice(0, descriptor.expandedIdx).join("");
		                name = descriptor.names[descriptor.expandedIdx];
	
	
		                value = getters[name](dataItem);
		                value = (value !== undefined && value !== null) ? value.toString() : value;
	
		                parentName = name;
		                name = name + "&" + value;
		                key = path + name;
	
		                column = columns[key] || {
		                    index: state.columnIndex,
		                    parentName: parentName,
		                    name: name,
		                    uniquePath: path + parentName,
		                    value: value
		                };
	
		                totalItem = rowTotal.items[key] || {
		                    aggregates: {}
		                };
	
		                rowTotal.items[key] = {
		                    index: column.index,
		                    aggregates: this._calculateAggregate(measureAggregators, aggregatorContext, totalItem)
		                };
	
		                if (updateColumn) {
		                    if (!columns[key]) {
		                        state.columnIndex++;
		                    }
		                    columns[key] = column;
		                }
		            }
		        },
	
		        _measureAggregators: function(options) {
		            var measureDescriptors = options.measures || [];
		            var measures = this.measures || {};
		            var aggregators = [];
		            var descriptor, measure, idx, length;
		            var defaultAggregate, aggregate;
	
		            if (measureDescriptors.length) {
		                for (idx = 0, length = measureDescriptors.length; idx < length; idx++) {
		                    descriptor = measureDescriptors[idx];
		                    measure = measures[descriptor.name];
		                    defaultAggregate = null;
	
		                    if (measure) {
		                        aggregate = measure.aggregate;
		                        if (typeof aggregate === "string") {
		                            defaultAggregate = functions[aggregate.toLowerCase()];
	
		                            if (!defaultAggregate) {
		                                throw new Error("There is no such aggregate function");
		                            }
	
		                            measure.aggregate = defaultAggregate.aggregate || defaultAggregate;
		                            measure.result = defaultAggregate.result;
		                        }
	
	
		                        aggregators.push({
		                            descriptor: descriptor,
		                            caption: measure.caption,
		                            result: measure.result,
		                            aggregator: createAggregateGetter(measure)
		                        });
		                    }
		                }
		            } else {
		                aggregators.push({
		                    descriptor: { name: "default"},
		                    caption: "default",
		                    aggregator: function() { return 1; }
		                });
		            }
	
		            return aggregators;
		        },
	
		        _buildGetters: function(names) {
		            var result = {};
		            var parts;
		            var name;
	
		            for (var idx = 0; idx < names.length; idx++) {
		                name = names[idx];
		                parts = name.split("&");
	
		                if (parts.length > 1) {
		                    result[parts[0]] = kendo.getter(parts[0], true);
		                } else {
		                    result[name] = kendo.getter(normalizeName(name), true);
		                }
		            }
	
		            return result;
		        },
	
		        _parseDescriptors: function (descriptors) {
		            var parsedDescriptors = parseDescriptors(descriptors);
		            var rootNames = getRootNames(parsedDescriptors.root);
		            var expanded = parsedDescriptors.expanded;
		            var result = [];
	
		            for (var idx = 0; idx < expanded.length; idx++) {
		                result.push(mapNames(expanded[idx].name, rootNames));
		            }
	
		            return {
		                root: rootNames,
		                expanded: result
		            };
		        },
	
		        _filter: function(data, filter) {
		            if (!filter) {
		                return data;
		            }
	
		            var expr;
		            var idx = 0;
		            var filters = filter.filters;
	
		            for (; idx < filters.length; idx++) {
		                expr = filters[idx];
	
		                if (expr.operator === "in") {
		                    filters[idx] = this._normalizeFilter(expr);
		                }
		            }
	
		            return new kendo.data.Query(data).filter(filter).data;
		        },
	
		        _normalizeFilter: function(filter) {
		            var value = filter.value.split(",");
		            var result = [];
	
		            if (!value.length) {
		                return value;
		            }
	
		            for (var idx = 0; idx < value.length; idx++) {
		                result.push({
		                    field: filter.field,
		                    operator: "eq",
		                    value: value[idx]
		                });
		            }
	
		            return {
		                logic: "or",
		                filters: result
		            };
		        },
	
		        process: function(data, options) {
		            data = data || [];
		            options = options || {};
	
		            data = this._filter(data, options.filter);
	
		            var measures = options.measures || [];
	
		            var measuresRowAxis = options.measuresAxis === "rows";
	
		            var columnDescriptors = options.columns || [];
		            var rowDescriptors = options.rows || [];
	
		            if (!columnDescriptors.length && rowDescriptors.length && (!measures.length || (measures.length && measuresRowAxis))) {
		                columnDescriptors = rowDescriptors;
		                rowDescriptors = [];
		                measuresRowAxis = false;
		            }
	
		            if (!columnDescriptors.length && !rowDescriptors.length) {
		                measuresRowAxis = false;
		            }
	
		            if (!columnDescriptors.length && measures.length) {
		                columnDescriptors = normalizeMembers(options.measures);
		            }
	
		            columnDescriptors = this._parseDescriptors(columnDescriptors);
		            rowDescriptors = this._parseDescriptors(rowDescriptors);
	
		            var aggregatedData = {};
		            var columns = {};
		            var rows = {};
	
		            var rowValue;
		            var state = { columnIndex: 0 };
	
		            var measureAggregators = this._measureAggregators(options);
	
		            var columnGetters = this._buildGetters(columnDescriptors.root);
		            var rowGetters = this._buildGetters(rowDescriptors.root);
	
		            var processed = false;
	
		            var expandedColumns = columnDescriptors.expanded;
		            var expandedRows = rowDescriptors.expanded;
	
		            var dataItem;
		            var aggregatorContext;
		            var hasExpandedRows = expandedRows.length !== 0;
	
		            var rowIdx, rowDescriptor, rowName, rowTotal;
		            var key, path, parentName, value;
		            var columnsInfo, rowsInfo;
		            var length = data.length;
		            var idx = 0;
	
		            if (columnDescriptors.root.length || rowDescriptors.root.length) {
		                processed = true;
	
		                for (idx = 0; idx < length; idx++) {
		                    dataItem = data[idx];
	
		                    aggregatorContext = {
		                        dataItem: dataItem,
		                        index: idx
		                    };
	
		                    rowTotal = aggregatedData[ROW_TOTAL_KEY] || {
		                        items: {},
		                        aggregates: {}
		                    };
	
		                    this._processColumns(measureAggregators, expandedColumns, columnGetters, columns, aggregatorContext, rowTotal, state, !hasExpandedRows);
	
		                    rowTotal.aggregates = this._calculateAggregate(measureAggregators, aggregatorContext, rowTotal);
		                    aggregatedData[ROW_TOTAL_KEY] = rowTotal;
	
		                    for (rowIdx = 0; rowIdx < expandedRows.length; rowIdx++) {
		                        rowDescriptor = expandedRows[rowIdx];
	
		                        if (!this._matchDescriptors(dataItem, rowDescriptor, rowGetters)) {
		                            this._processColumns(measureAggregators, expandedColumns, columnGetters, columns, aggregatorContext, { items: {}, aggregates: {} }, state, true);
		                            continue;
		                        }
	
		                        path = rowDescriptor.names.slice(0, rowDescriptor.expandedIdx).join("");
		                        rowName = rowDescriptor.names[rowDescriptor.expandedIdx];
	
		                        parentName = rowName;
	
		                        rowValue = rowGetters[rowName](dataItem);
		                        rowValue = rowValue !== undefined ? rowValue.toString() : rowValue;
	
		                        rowName = rowName + "&" + rowValue;
		                        key = path + rowName;
	
		                        rows[key] = {
		                            uniquePath: path + parentName,
		                            parentName: parentName,
		                            name: rowName,
		                            value: rowValue
		                        };
	
		                        value = aggregatedData[key] || {
		                            items: {},
		                            aggregates: {}
		                        };
	
		                        this._processColumns(measureAggregators, expandedColumns, columnGetters, columns, aggregatorContext, value, state, true);
	
		                        value.aggregates = this._calculateAggregate(measureAggregators, aggregatorContext, value);
		                        aggregatedData[key] = value;
		                    }
		                }
		            }
	
		            if (processed && length) {
		                if (measureAggregators.length > 1 && (!options.columns || !options.columns.length)) {
		                    columnDescriptors = {
		                        root: [],
		                        expanded: []
		                    };
		                }
	
		                columnsInfo = this._asTuples(columns, columnDescriptors, measuresRowAxis ? [] : measureAggregators);
		                rowsInfo = this._asTuples(rows, rowDescriptors, measuresRowAxis ? measureAggregators : []);
	
		                columns = columnsInfo.tuples;
		                rows = rowsInfo.tuples;
	
		                aggregatedData = this._toDataArray(aggregatedData, this._measuresInfo(measureAggregators, measuresRowAxis), rowsInfo.keys, columnsInfo.keys);
		            } else {
		                aggregatedData = columns = rows = [];
		            }
	
		            return {
		                axes: {
		                    columns: { tuples: columns },
		                    rows: { tuples: rows }
		                },
		                data: aggregatedData
		            };
		        }
		    });
	
		    var PivotTransport = Class.extend({
		        init: function(options, transport) {
		            this.transport = transport;
		            this.options = transport.options || {};
	
		            if (!this.transport.discover) {
		                if (isFunction(options.discover)) {
		                    this.discover = options.discover;
		                }
		            }
		        },
		        read: function(options) {
		            return this.transport.read(options);
		        },
		        update: function(options) {
		            return this.transport.update(options);
		        },
		        create: function(options) {
		            return this.transport.create(options);
		        },
		        destroy: function(options) {
		            return this.transport.destroy(options);
		        },
		        discover: function(options) {
		            if (this.transport.discover) {
		                return this.transport.discover(options);
		            }
		            options.success({});
		        },
		        catalog: function(val) {
		            var options = this.options || {};
	
		            if (val === undefined) {
		                return (options.connection || {}).catalog;
	
		            }
	
		            var connection = options.connection || {};
		            connection.catalog = val;
	
		            this.options.connection = connection;
		            $.extend(this.transport.options, { connection: connection });
		        },
		        cube: function(val) {
		            var options = this.options || {};
	
		            if (val === undefined) {
		                return (options.connection || {}).cube;
		            }
	
		            var connection = options.connection || {};
		            connection.cube = val;
	
		            this.options.connection = connection;
		            extend(true, this.transport.options, { connection: connection });
		        }
		    });
	
		    var PivotDataSource = DataSource.extend({
		        init: function(options) {
		            var cube = ((options || {}).schema || {}).cube;
		            var measuresAxis = "columns";
		            var measures;
	
		            var schema = {
		                axes: identity,
		                cubes: identity,
		                catalogs: identity,
		                measures: identity,
		                dimensions: identity,
		                hierarchies: identity,
		                levels: identity,
		                members: identity
		            };
	
		            if (cube) {
		                schema = $.extend(schema, this._cubeSchema(cube));
		                this.cubeBuilder = new PivotCubeBuilder(cube);
		            }
	
		            DataSource.fn.init.call(this, extend(true, {}, {
		                schema: schema
		            }, options));
	
		            this.transport = new PivotTransport(this.options.transport || {}, this.transport);
	
		            this._columns = normalizeMembers(this.options.columns);
		            this._rows = normalizeMembers(this.options.rows);
	
		            measures = this.options.measures || [];
	
		            if (toString.call(measures) === "[object Object]") {
		                measuresAxis = measures.axis || "columns";
		                measures = measures.values || [];
		            }
	
		            this._measures = normalizeMeasures(measures);
		            this._measuresAxis = measuresAxis;
	
		            this._skipNormalize = 0;
		            this._axes = {};
		        },
	
		        _cubeSchema: function(cube) {
		            return {
		                dimensions: function() {
		                    var result = [];
		                    var dimensions = cube.dimensions;
	
		                    for (var key in dimensions) {
		                        result.push({
		                            name: key,
		                            caption: dimensions[key].caption || key,
		                            uniqueName: key,
		                            defaultHierarchy: key,
		                            type: 1
		                        });
		                    }
	
		                    if (cube.measures) {
		                        result.push({
		                            name: MEASURES,
		                            caption: MEASURES,
		                            uniqueName: MEASURES,
		                            type: 2
		                        });
		                    }
	
		                    return result;
		                },
		                hierarchies: function(){
		                    return [];
		                },
		                measures: function() {
		                    var result = [];
		                    var measures = cube.measures;
	
		                    for (var key in measures) {
		                        result.push({
		                            name: key,
		                            caption: key,
		                            uniqueName: key,
		                            aggregator: key
		                        });
		                    }
	
		                    return result;
		                },
		                members: $.proxy(function(response, restrictions) {
		                    var name = restrictions.levelUniqueName || restrictions.memberUniqueName;
		                    var schemaData = this.options.schema.data;
		                    var dataGetter = isFunction(schemaData) ? schemaData : kendo.getter(schemaData, true);
		                    var data = (this.options.data && dataGetter(this.options.data)) || this._rawData || [];
		                    var result = [];
		                    var getter;
		                    var value;
		                    var idx = 0;
		                    var distinct = {};
	
		                    if (name) {
		                        name = name.split(".")[0];
		                    }
	
		                    if (!restrictions.treeOp) {
		                        result.push({
		                            caption: cube.dimensions[name].caption || name,
		                            childrenCardinality: "1",
		                            dimensionUniqueName: name,
		                            hierarchyUniqueName: name,
		                            levelUniqueName: name,
		                            name: name,
		                            uniqueName: name
		                        });
	
		                        return result;
		                    }
	
		                    getter = kendo.getter(normalizeName(name), true);
	
		                    for (; idx < data.length; idx++) {
		                        value = getter(data[idx]);
		                        if ((value || value === 0) && !distinct[value]) {
		                            distinct[value] = true;
	
		                            result.push({
		                                caption: value,
		                                childrenCardinality: "0",
		                                dimensionUniqueName: name,
		                                hierarchyUniqueName: name,
		                                levelUniqueName: name,
		                                name: value,
		                                uniqueName: value
		                            });
		                        }
		                    }
	
		                    return result;
		                }, this)
		            };
		        },
	
		        options: {
		            serverSorting: true,
		            serverPaging: true,
		            serverFiltering: true,
		            serverGrouping: true,
		            serverAggregates: true
		        },
	
		        catalog: function(val) {
		            if (val === undefined) {
		                return this.transport.catalog();
		            }
	
		            this.transport.catalog(val);
		            this._mergeState({});// clears current state
		            this._axes = {};
		            this.data([]);
		        },
	
		        cube: function(val) {
		            if (val === undefined) {
		                return this.transport.cube();
		            }
	
		            this.transport.cube(val);
		            this._axes = {};
		            this._mergeState({});// clears current state
		            this.data([]);
		        },
	
		        axes: function() {
		            return this._axes;
		        },
	
		        columns: function(val) {
		            if (val === undefined) {
		                return this._columns;
		            }
	
		            this._skipNormalize += 1;
		            this._clearAxesData = true;
	
		            this._columns = normalizeMembers(val);
		            this.query({
		                columns: val,
		                rows: this.rowsAxisDescriptors(),
		                measures: this.measures(),
		                sort: this.sort(),
		                filter: this.filter()
		            });
		        },
	
		        rows: function(val) {
		            if (val === undefined) {
		                return this._rows;
		            }
	
		            this._skipNormalize += 1;
		            this._clearAxesData = true;
	
		            this._rows = normalizeMembers(val);
	
		            this.query({
		                columns: this.columnsAxisDescriptors(),
		                rows: val,
		                measures: this.measures(),
		                sort: this.sort(),
		                filter: this.filter()
		            });
		        },
	
		        measures: function(val) {
		            if (val === undefined) {
		                return this._measures;
		            }
	
		            this._skipNormalize += 1;
		            this._clearAxesData = true;
	
		            this.query({
		                columns: this.columnsAxisDescriptors(),
		                rows: this.rowsAxisDescriptors(),
		                measures: normalizeMeasures(val),
		                sort: this.sort(),
		                filter: this.filter()
		            });
		        },
	
		        measuresAxis: function() {
		            return this._measuresAxis || "columns";
		        },
	
		        _expandPath: function(path, axis) {
		            var origin = axis === "columns" ? "columns" : "rows";
		            var other = axis === "columns" ? "rows" : "columns";
	
		            var members = normalizeMembers(path);
		            var memberToExpand = getName(members[members.length - 1]);
	
		            this._lastExpanded = origin;
	
		            members = descriptorsForMembers(this.axes()[origin], members, this.measures());
	
		            for (var idx = 0; idx < members.length; idx++) {
		                var memberName = getName(members[idx]);
	
		                if (memberName === memberToExpand) {
		                    if (members[idx].expand) {
		                        return;
		                    }
		                    members[idx].expand = true;
		                } else {
		                    members[idx].expand = false;
		                }
		            }
	
		            var descriptors = {};
		            descriptors[origin] = members;
		            descriptors[other] = this._descriptorsForAxis(other);
	
		            this._query(descriptors);
		        },
	
		        _descriptorsForAxis: function(axis) {
		            var axes = this.axes();
		            var descriptors = this[axis]() || [];
	
		            if (axes && axes[axis] && axes[axis].tuples && axes[axis].tuples[0]) {
		                descriptors = descriptorsForAxes(axes[axis].tuples || []);
		            }
		            return descriptors;
		        },
	
		        columnsAxisDescriptors: function() {
		            return this._descriptorsForAxis("columns");
		        },
	
		        rowsAxisDescriptors: function() {
		            return this._descriptorsForAxis("rows");
		        },
	
		        _process: function (data, e) {
		            this._view = data;
	
		            e = e || {};
		            e.items = e.items || this._view;
	
		            this.trigger(CHANGE, e);
		        },
	
		        _query: function(options) {
		            var that = this;
	
		            if (!options) {
		                this._skipNormalize += 1;
		                this._clearAxesData = true;
		            }
	
		            return that.query(extend({}, {
		                page: that.page(),
		                pageSize: that.pageSize(),
		                sort: that.sort(),
		                filter: that.filter(),
		                group: that.group(),
		                aggregate: that.aggregate(),
		                columns: this.columnsAxisDescriptors(),
		                rows: this.rowsAxisDescriptors(),
		                measures: this.measures()
		            }, options));
		        },
	
		        query: function(options) {
		            var state = this._mergeState(options);
	
		            if (this._data.length && this.cubeBuilder) {
		                this._params(state);
		                this._updateLocalData(this._pristineData);
	
		                return $.Deferred().resolve().promise();
		            }
	
		            return this.read(state);
		        },
	
		        _mergeState: function(options) {
		            options = DataSource.fn._mergeState.call(this, options);
	
		            if (options !== undefined) {
		                this._measures = normalizeMeasures(options.measures);
	
		                if (options.columns) {
		                    options.columns = normalizeMembers(options.columns);
		                } else if (!options.columns) {
		                    this._columns = [];
		                }
	
		                if (options.rows) {
		                    options.rows = normalizeMembers(options.rows);
		                } else if (!options.rows) {
		                    this._rows = [];
		                }
		            }
		            return options;
		        },
	
		        filter: function(val) {
		            if (val === undefined) {
		                return this._filter;
		            }
	
		            this._skipNormalize += 1;
		            this._clearAxesData = true;
		            this._query({ filter: val, page: 1 });
		        },
	
		        expandColumn: function(path) {
		            this._expandPath(path, "columns");
		        },
	
		        expandRow: function(path) {
		            this._expandPath(path, "rows");
		        },
	
		        success: function(data) {
		            var originalData;
		            if (this.cubeBuilder) {
		                originalData = (this.reader.data(data) || []).slice(0);
		            }
		            DataSource.fn.success.call(this, data);
		            if (originalData) {
		                this._pristineData = originalData;
		            }
		        },
	
		        _processResult: function(data, axes) {
		            if (this.cubeBuilder) {
		                var processedData = this.cubeBuilder.process(data, this._requestData);
	
		                data = processedData.data;
		                axes = processedData.axes;
		            }
	
		            var columnIndexes, rowIndexes;
		            var tuples, resultAxis, measures, axisToSkip;
		            var columnDescriptors = this.columns();
		            var rowDescriptors = this.rows();
		            var hasColumnTuples = axes.columns && axes.columns.tuples;
	
		            if (!columnDescriptors.length && rowDescriptors.length && hasColumnTuples && (this._rowMeasures().length || !this.measures().length)) {
		                axes = {
		                    columns: {},
		                    rows: axes.columns
		                };
		            }
	
		            if (!columnDescriptors.length && !rowDescriptors.length && this.measuresAxis() === "rows" && hasColumnTuples) {
		                axes = {
		                    columns: {},
		                    rows: axes.columns
		                };
		            }
	
		            this._axes = {
		                columns: normalizeAxis(this._axes.columns),
		                rows: normalizeAxis(this._axes.rows)
		            };
	
		            axes = {
		                columns: normalizeAxis(axes.columns),
		                rows: normalizeAxis(axes.rows)
		            };
	
		            columnIndexes = this._normalizeTuples(axes.columns.tuples, this._axes.columns.tuples, columnDescriptors, this._columnMeasures());
		            rowIndexes = this._normalizeTuples(axes.rows.tuples, this._axes.rows.tuples, rowDescriptors, this._rowMeasures());
	
		            if (this._skipNormalize > 0) {
		                this._skipNormalize -= 1;
		            }
	
		            if (!this.cubeBuilder) {
		                data = this._normalizeData({
		                    columnsLength: axes.columns.tuples.length,
		                    rowsLength: axes.rows.tuples.length,
		                    columnIndexes: columnIndexes,
		                    rowIndexes: rowIndexes,
		                    data: data
		                });
		            }
	
		            if (this._lastExpanded == "rows") {
		                tuples = axes.columns.tuples;
		                measures = this._columnMeasures();
		                resultAxis = validateAxis(axes.columns, this._axes.columns, measures);
	
		                if (resultAxis) {
		                    axisToSkip = "columns";
		                    axes.columns = resultAxis;
		                    adjustDataByColumn(tuples, resultAxis.tuples, axes.rows.tuples.length, measures, data);
		                    if (!this.cubeBuilder) {
		                        data = this._normalizeData({
		                            columnsLength: membersCount(axes.columns.tuples, measures),
		                            rowsLength: axes.rows.tuples.length,
		                            data: data
		                        });
		                    }
		                }
		            } else if (this._lastExpanded == "columns") {
		                tuples = axes.rows.tuples;
		                measures = this._rowMeasures();
		                resultAxis = validateAxis(axes.rows, this._axes.rows, measures);
	
		                if (resultAxis) {
		                    axisToSkip = "rows";
		                    axes.rows = resultAxis;
		                    adjustDataByRow(tuples, resultAxis.tuples, axes.columns.tuples.length, measures, data);
	
		                    if (!this.cubeBuilder) {
		                        data = this._normalizeData({
		                            columnsLength: membersCount(axes.rows.tuples, measures),
		                            rowsLength: axes.columns.tuples.length,
		                            data: data
		                        });
		                    }
		                }
		            }
	
		            this._lastExpanded = null;
	
		            var result = this._mergeAxes(axes, data, axisToSkip);
		            this._axes = result.axes;
	
		            return result.data;
		        },
	
		        _readData: function(data) {
		            var axes = this.reader.axes(data);
		            var newData = this.reader.data(data);
	
		            if (this.cubeBuilder) {
		                this._rawData = newData;
		            }
	
		            return this._processResult(newData, axes);
		        },
	
		        _createTuple: function(tuple, measure, buildRoot) {
		            var members = tuple.members;
		            var length = members.length;
		            var root = { members: [] };
		            var levelName, levelNum;
		            var name, parentName;
		            var hasChildren;
		            var hierarchy;
		            var caption;
		            var member;
		            var idx = 0;
	
		            if (measure) {
		                length -= 1;
		            }
	
		            for (; idx < length; idx++) {
		                member = members[idx];
		                levelNum = Number(member.levelNum);
	
		                name = member.name;
		                parentName = member.parentName;
		                caption = member.caption || name;
		                hasChildren = member.hasChildren;
		                hierarchy = member.hierarchy;
		                levelName = member.levelName;
	
		                if (buildRoot) {
		                    caption = "All";
		                    if (levelNum === 0) {
		                        parentName = member.name;
		                    } else {
		                        levelNum -= 1;
		                    }
	
		                    hasChildren = true;
		                    name = hierarchy = levelName = parentName;
		                }
	
		                root.members.push({
		                    name: name,
		                    children: [],
		                    caption: caption,
		                    levelName: levelName,
		                    levelNum: levelNum.toString(),
		                    hasChildren: hasChildren,
		                    hierarchy: hierarchy,
		                    parentName: !buildRoot ? parentName: ""
		                });
		            }
	
		            if (measure) {
		                root.members.push({
		                    name: measure.name,
		                    children: []
		                });
		            }
	
		            return root;
		        },
	
		        _hasRoot: function(target, source, descriptors) {
		            if (source.length) {
		                return findExistingTuple(source, target).tuple;
		            }
	
		            var members = target.members;
		            var member;
		            var descriptor;
	
		            var isRoot = true;
		            var levelNum;
	
		            for (var idx = 0, length = members.length; idx < length; idx++) {
		                member = members[idx];
		                levelNum = Number(member.levelNum) || 0;
		                descriptor = descriptors[idx];
	
		                if (!(levelNum === 0 || (descriptor && member.name === getName(descriptor)))) {
		                    isRoot = false;
		                    break;
		                }
		            }
	
		            return isRoot;
		        },
	
		        _mergeAxes: function(sourceAxes, data, axisToSkip) {
		            var columnMeasures = this._columnMeasures();
		            var rowMeasures = this._rowMeasures();
		            var axes = this.axes();
		            var startIndex, tuples;
	
		            var oldRowsLength = membersCount(axes.rows.tuples, rowMeasures);
		            var newRowsLength = sourceAxes.rows.tuples.length;
	
		            var oldColumnsLength = membersCount(axes.columns.tuples, columnMeasures);
		            var newColumnsLength = sourceAxes.columns.tuples.length;
	
		            if (axisToSkip == "columns") {
		                newColumnsLength = oldColumnsLength;
		                tuples = sourceAxes.columns.tuples;
		            } else {
		                tuples = parseSource(sourceAxes.columns.tuples, columnMeasures);
		                data = prepareDataOnColumns(tuples, data);
		            }
	
		            var mergedColumns = mergeTuples(axes.columns.tuples, tuples, columnMeasures);
	
		            if (axisToSkip == "rows") {
		                newRowsLength = membersCount(sourceAxes.rows.tuples, rowMeasures);
		                tuples = sourceAxes.rows.tuples;
		            } else {
		                tuples = parseSource(sourceAxes.rows.tuples, rowMeasures);
		                data = prepareDataOnRows(tuples, data);
		            }
		            var mergedRows = mergeTuples(axes.rows.tuples, tuples, rowMeasures);
	
		            axes.columns.tuples = mergedColumns.tuples;
		            axes.rows.tuples = mergedRows.tuples;
	
		            if (oldColumnsLength !== membersCount(axes.columns.tuples, columnMeasures)) {
		                //columns are expanded
		                startIndex = mergedColumns.index + findDataIndex(mergedColumns.parsedRoot, mergedColumns.memberIndex, columnMeasures);
		                var offset = oldColumnsLength + newColumnsLength;
		                data = this._mergeColumnData(data, startIndex, newRowsLength, newColumnsLength, offset);
		            } else if (oldRowsLength !== membersCount(axes.rows.tuples, rowMeasures)) {
		                //rows are expanded
		                startIndex = mergedRows.index + findDataIndex(mergedRows.parsedRoot, mergedRows.memberIndex, rowMeasures);
		                data = this._mergeRowData(data, startIndex, newRowsLength, newColumnsLength);
		            }
	
		            if (axes.columns.tuples.length === 0 && axes.rows.tuples.length === 0) {
		                data = [];
		            }
	
		            return {
		                axes: axes,
		                data: data
		            };
		        },
	
		        _mergeColumnData: function(newData, columnIndex, rowsLength, columnsLength, offset) {
		            var data = this.data().toJSON();
		            var rowIndex, index, drop = 0, toAdd;
		            var columnMeasures = Math.max(this._columnMeasures().length, 1);
	
		            rowsLength = Math.max(rowsLength, 1);
	
		            if (data.length > 0) {
		                //if there is already data, drop the first new data item
		                drop = columnMeasures;
		                offset -= columnMeasures;
		            }
	
		            for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
		                index = columnIndex + (rowIndex * offset);
		                toAdd = newData.splice(0, columnsLength);
		                toAdd.splice(0, drop);
		                [].splice.apply(data, [index, 0].concat(toAdd));
		            }
	
		            return data;
		        },
	
		        _mergeRowData: function(newData, rowIndex, rowsLength, columnsLength) {
		            var data = this.data().toJSON();
		            var idx, dataIndex, toAdd;
		            var rowMeasures = Math.max(this._rowMeasures().length, 1);
	
		            columnsLength = Math.max(columnsLength, 1);
		            if (data.length > 0) {
		                //if there is already data, drop the first new data item
		                rowsLength -= rowMeasures;
		                newData.splice(0, columnsLength * rowMeasures);
		            }
	
		            for (idx = 0; idx < rowsLength; idx++) {
		                toAdd = newData.splice(0, columnsLength);
		                dataIndex = (rowIndex * columnsLength) + (idx * columnsLength);
		                [].splice.apply(data, [dataIndex, 0].concat(toAdd));
		            }
	
		            return data;
		        },
	
		        _columnMeasures: function() {
		            var measures = this.measures();
		            var columnMeasures = [];
	
		            if (this.measuresAxis() === "columns") {
		                if (this.columns().length === 0) {
		                    columnMeasures = measures;
		                } else if (measures.length > 1) {
		                    columnMeasures = measures;
		                }
		            }
	
		            return columnMeasures;
		        },
	
		        _rowMeasures: function() {
		            var measures = this.measures();
		            var rowMeasures = [];
	
		            if (this.measuresAxis() === "rows") {
		                if (this.rows().length === 0) {
		                    rowMeasures = measures;
		                } else if (measures.length > 1) {
		                    rowMeasures = measures;
		                }
		            }
	
		            return rowMeasures;
		        },
	
		        _updateLocalData: function(data, state) {
		            if (this.cubeBuilder) {
		                if (state) {
		                    this._requestData = state;
		                }
		                data = this._processResult(data);
		            }
	
		            this._data = this._observe(data);
	
		            this._ranges = [];
		            this._addRange(this._data);
	
		            this._total = this._data.length;
		            this._pristineTotal = this._total;
		            this._process(this._data);
		        },
	
		        data: function(value) {
		            var that = this;
		            if (value !== undefined) {
		                this._pristineData = value.slice(0);
		                this._updateLocalData(value, {
		                        columns: this.columns(),
		                        rows: this.rows(),
		                        measures: this.measures()
		                    });
		            } else {
		                return that._data;
		            }
		        },
	
		        _normalizeTuples: function(tuples, source, descriptors, measures) {
		            var length = measures.length || 1;
		            var idx = 0;
	
		            var roots = [];
		            var indexes = {};
		            var measureIdx = 0;
		            var tuple, memberIdx, last;
	
		            if (!tuples.length) {
		                return;
		            }
	
		            if (this._skipNormalize <= 0 && !this._hasRoot(tuples[0], source, descriptors)) {
		                this._skipNormalize = 0;
		                for (; idx < length; idx++) {
		                    roots.push(this._createTuple(tuples[0], measures[idx], true));
		                    indexes[idx] = idx;
		                }
	
		                tuples.splice.apply(tuples, [0, tuples.length].concat(roots).concat(tuples));
		                idx = length;
		            }
	
		            if (measures.length) {
		                last = tuple = tuples[idx];
		                memberIdx = tuple.members.length - 1;
	
		                while (tuple) {
		                    if (measureIdx >= length) {
		                        measureIdx = 0;
		                    }
	
		                    if (tuple.members[memberIdx].name !== measures[measureIdx].name) {
		                        tuples.splice(idx, 0, this._createTuple(tuple, measures[measureIdx]));
		                        indexes[idx] = idx;
		                    }
	
		                    idx += 1;
		                    measureIdx += 1;
		                    tuple = tuples[idx];
	
		                    if (length > measureIdx && (!tuple || tupleName(last, memberIdx - 1) !== tupleName(tuple, memberIdx - 1))) {
		                        for (; measureIdx < length; measureIdx++) {
		                            tuples.splice(idx, 0, this._createTuple(last, measures[measureIdx]));
		                            indexes[idx] = idx;
		                            idx += 1;
		                        }
		                        tuple = tuples[idx];
		                    }
		                    last = tuple;
		                }
		            }
	
		            return indexes;
		        },
	
		        _addMissingDataItems: function(result, metadata) {
		            while (metadata.rowIndexes[parseInt(result.length / metadata.columnsLength, 10)] !== undefined) {
		                for (var idx = 0; idx < metadata.columnsLength; idx++) {
		                    result = addEmptyDataItem(result);
		                }
		            }
	
		            while (metadata.columnIndexes[result.length % metadata.columnsLength] !== undefined) {
		                result = addEmptyDataItem(result);
		            }
	
		            return result;
		        },
	
		        _normalizeOrdinals: function(result, dataItem, metadata) {
		            var lastOrdinal = metadata.lastOrdinal;
	
		            if (!dataItem) {
		                return addEmptyDataItem(result);
		            }
	
		            if ((dataItem.ordinal - lastOrdinal) > 1) {
		                lastOrdinal += 1;
	
		                while (lastOrdinal < dataItem.ordinal && result.length < metadata.length) {
		                    result = this._addMissingDataItems(addEmptyDataItem(result), metadata);
		                    lastOrdinal += 1;
		                }
		            }
	
		            dataItem.ordinal = result.length;
		            result[result.length] = dataItem;
	
		            return result;
		        },
	
		        _normalizeData: function(options) {
		            var data = options.data;
		            var dataIdx = 0;
		            var dataItem;
		            var result = [];
		            var lastOrdinal;
		            var length;
	
		            options.lastOrdinal = 0;
		            options.columnIndexes = options.columnIndexes || {};
		            options.rowIndexes = options.rowIndexes || {};
		            options.columnsLength = options.columnsLength || 1;
		            options.rowsLength = options.rowsLength || 1;
		            options.length = options.columnsLength * options.rowsLength;
		            length = options.length;
	
		            if (data.length === length) {
		                return data;
		            }
	
		            while(result.length < length) {
		                dataItem = data[dataIdx++];
		                if (dataItem) {
		                    lastOrdinal = dataItem.ordinal;
		                }
	
		                result = this._normalizeOrdinals(this._addMissingDataItems(result, options), dataItem, options);
	
		                options.lastOrdinal = lastOrdinal;
		            }
	
		            return result;
		        },
	
		        discover: function(options, converter) {
		            var that = this,
		                transport = that.transport;
	
		            return $.Deferred(function(deferred) {
		                transport.discover(extend({
		                    success: function(response) {
		                       response = that.reader.parse(response);
	
		                        if (that._handleCustomErrors(response)) {
		                            return;
		                        }
	
		                        if (converter) {
		                            response = converter(response);
		                        }
		                        deferred.resolve(response);
		                    },
		                    error: function(response, status, error) {
		                        deferred.reject(response);
		                        that.error(response, status, error);
		                    }
		                }, options));
		            }).promise().done(function() {
		                that.trigger("schemaChange");
		            });
		        },
	
		        schemaMeasures: function() {
		            var that = this;
	
		            return that.discover({
		                data: {
		                    command: "schemaMeasures",
		                    restrictions: {
		                        catalogName: that.transport.catalog(),
		                        cubeName: that.transport.cube()
		                    }
		                }
		            }, function(response) {
		                return that.reader.measures(response);
		            });
		        },
	
		        schemaKPIs: function() {
		            var that = this;
	
		            return that.discover({
		                data: {
		                    command: "schemaKPIs",
		                    restrictions: {
		                        catalogName: that.transport.catalog(),
		                        cubeName: that.transport.cube()
		                    }
		                }
		            }, function(response) {
		                return that.reader.kpis(response);
		            });
		        },
	
		        schemaDimensions: function() {
		            var that = this;
	
		            return that.discover({
		                data: {
		                    command: "schemaDimensions",
		                    restrictions: {
		                        catalogName: that.transport.catalog(),
		                        cubeName: that.transport.cube()
		                    }
		                }
		            }, function(response) {
		                return that.reader.dimensions(response);
		            });
		        },
	
		        schemaHierarchies: function(dimensionName) {
		            var that = this;
	
		            return that.discover({
		                data: {
		                    command: "schemaHierarchies",
		                    restrictions: {
		                        catalogName: that.transport.catalog(),
		                        cubeName: that.transport.cube(),
		                        dimensionUniqueName: dimensionName
		                    }
		                }
		            }, function(response) {
		                return that.reader.hierarchies(response);
		            });
		        },
	
		        schemaLevels: function(hierarchyName) {
		            var that = this;
	
		            return that.discover({
		                data: {
		                    command: "schemaLevels",
		                    restrictions: {
		                        catalogName: that.transport.catalog(),
		                        cubeName: that.transport.cube(),
		                        hierarchyUniqueName: hierarchyName
		                    }
		                }
		            }, function(response) {
		                return that.reader.levels(response);
		            });
		        },
	
		        schemaCubes: function() {
		            var that = this;
	
		            return that.discover({
		                data: {
		                    command: "schemaCubes",
		                    restrictions: {
		                        catalogName: that.transport.catalog()
		                    }
		                }
		            }, function(response) {
		                return that.reader.cubes(response);
		            });
		        },
	
		        schemaCatalogs: function() {
		            var that = this;
	
		            return that.discover({
		                data: {
		                    command: "schemaCatalogs"
		                }
		            }, function(response) {
		                return that.reader.catalogs(response);
		            });
		        },
	
		        schemaMembers: function(restrictions) {
		            var that = this;
		            var success = (function(restrictions) {
		                return function(response) {
		                    return that.reader.members(response, restrictions);
		                };
		            }(restrictions));
	
		            return that.discover({
		                data: {
		                    command: "schemaMembers",
		                    restrictions: extend({
		                       catalogName: that.transport.catalog(),
		                       cubeName: that.transport.cube()
		                   }, restrictions)
		                }
		            }, success);
		        },
	
		        _params: function(data) {
		            if (this._clearAxesData) {
		                this._axes = {};
		                this._data = this._observe([]);
		                this._clearAxesData = false;
		                this.trigger(STATERESET);
		            }
	
		            var options = DataSource.fn._params.call(this, data);
	
		            options = extend({
		                measures: this.measures(),
		                measuresAxis: this.measuresAxis(),
		                columns: this.columns(),
		                rows: this.rows()
		            }, options);
	
		            if (this.cubeBuilder) {
		                this._requestData = options;
		            }
	
		            return options;
		        }
		    });
	
		    function addEmptyDataItem(result) {
		        result[result.length] = { value: "", fmtValue: "", ordinal: result.length };
		        return result;
		    }
	
		    function validateAxis(newAxis, axis, measures) {
		        if (newAxis.tuples.length < membersCount(axis.tuples, measures)) {
	
		            return axis;
		        }
	
		        return;
		    }
	
		    function adjustDataByColumn(sourceTuples, targetTuples, rowsLength, measures, data) {
		        var columnIdx, rowIdx, dataIdx;
		        var columnsLength = sourceTuples.length;
		        var targetColumnsLength = membersCount(targetTuples, measures);
		        var measuresLength = measures.length || 1;
	
		        for (rowIdx = 0; rowIdx < rowsLength; rowIdx++) {
		            for (columnIdx = 0; columnIdx < columnsLength; columnIdx++) {
		                dataIdx = tupleIndex(sourceTuples[columnIdx], targetTuples) * measuresLength;
		                dataIdx += columnIdx % measuresLength;
	
		                data[rowIdx * columnsLength + columnIdx].ordinal = rowIdx * targetColumnsLength + dataIdx;
		            }
		        }
		    }
	
		    function adjustDataByRow(sourceTuples, targetTuples, columnsLength, measures, data) {
		        var columnIdx, rowIdx, dataIdx;
		        var rowsLength = sourceTuples.length;
		        var measuresLength = measures.length || 1;
	
		        for (rowIdx = 0; rowIdx < rowsLength; rowIdx++) {
		            dataIdx = tupleIndex(sourceTuples[rowIdx], targetTuples);
		            dataIdx *= measuresLength;
		            dataIdx += rowIdx % measuresLength;
	
		            for (columnIdx = 0; columnIdx < columnsLength; columnIdx++) {
		                data[rowIdx * columnsLength + columnIdx].ordinal = dataIdx * columnsLength + columnIdx;
		            }
		        }
		    }
	
		    function tupleIndex(tuple, collection) {
		        return findExistingTuple(collection, tuple).index;
		    }
	
		    function membersCount(tuples, measures) {
		        if (!tuples.length) {
		            return 0;
		        }
	
		        var queue = tuples.slice();
		        var current = queue.shift();
		        var result = 1;
	
		        while (current) {
		            if (current.members) {
		                [].push.apply(queue, current.members);
		            } else if (current.children) {
		                if (!current.measure) {
		                    result += current.children.length;
		                }
		                [].push.apply(queue, current.children);
		            }
	
		            current = queue.shift();
		        }
	
		        if (measures.length) {
		            result = result * measures.length;
		        }
	
		        return result;
		    }
	
		    function normalizeAxis(axis) {
		        if (!axis) {
		            axis = {
		                tuples: []
		            };
		        }
	
		        if (!axis.tuples) {
		            axis.tuples = [];
		        }
	
		        return axis;
		    }
	
		    function findDataIndex(tuple, memberIndex, measures) {
		        if (!tuple) {
		            return 0;
		        }
	
		        var measuresLength = Math.max(measures.length, 1);
		        var tuples = tuple.members.slice(0, memberIndex);
		        var current = tuples.shift();
	
		        //the initial value is equal to the total number of measures
		        //as the measures member is not extracted from the members of the starting tuple
		        //but should be calculated in the final result
		        var counter = measuresLength;
	
		        while (current) {
		            if (current.name === MEASURES) {
		                //subtract 1 as the measures member has been already counted as a single standard member
		                //but we are interested in the total number of measures instead
		                counter += (measuresLength - 1);
		            } else if (current.children) {
		                //is member
		                [].push.apply(tuples, current.children);
		            } else {
		                //is tuple
		                counter ++;
		                [].push.apply(tuples, current.members);
		            }
	
		            current = tuples.shift();
		        }
	
		        return counter;
		    }
	
		    function mergeTuples(target, source, measures) {
		        if (!source[0]) {
		            return {
		                parsedRoot: null,
		                tuples: target,
		                memberIndex: 0,
		                index: 0
		            };
		        }
	
		        var result = findExistingTuple(target, source[0]);
	
		        if (!result.tuple) {
		            return {
		                parsedRoot: null,
		                tuples: source,
		                memberIndex: 0,
		                index: 0
		            };
		        }
	
		        var targetMembers = result.tuple.members;
		        var sourceMembers = source[0].members;
		        var memberIndex = -1;
	
		        if (targetMembers.length !== sourceMembers.length) {
		            return {
		                parsedRoot: null,
		                tuples: source,
		                memberIndex: 0,
		                index: 0
		            };
		        }
	
		        for (var idx = 0, length = targetMembers.length; idx < length; idx++) {
		            if (!targetMembers[idx].measure && sourceMembers[idx].children[0]) {
		                if (memberIndex == -1 && sourceMembers[idx].children.length) {
		                    memberIndex = idx;
		                }
	
		                targetMembers[idx].children = sourceMembers[idx].children;
		            }
		        }
	
		        measures = Math.max(measures.length, 1);
	
		        return {
		            parsedRoot: result.tuple,
		            index: result.index * measures,
		            memberIndex: memberIndex,
		            tuples: target
		        };
		    }
	
		    function equalTuples(first, second) {
		        var equal = true;
		        var idx, length;
	
		        first = first.members;
		        second = second.members;
	
		        for (idx = 0, length = first.length; idx < length; idx++) {
		            if (first[idx].measure || second[idx].measure) {
		                continue;
		            }
	
		            equal = equal && (getName(first[idx]) === getName(second[idx]));
		        }
	
		        return equal;
		    }
	
		    function findExistingTuple(tuples, toFind) {
		        var idx, length, tuple, found, counter = 0;
		        var memberIndex, membersLength, member;
	
		        for (idx = 0, length = tuples.length; idx < length; idx++) {
		            tuple = tuples[idx];
		            if (equalTuples(tuple, toFind)) {
		                return {
		                    tuple: tuple,
		                    index: counter
		                };
		            }
	
		            counter ++;
	
		            for (memberIndex = 0, membersLength = tuple.members.length; memberIndex < membersLength; memberIndex++) {
		                member = tuple.members[memberIndex];
		                if (member.measure) {
		                    //counter += member.children.length;
		                    continue;
		                }
		                found = findExistingTuple(member.children, toFind);
		                counter += found.index;
		                if (found.tuple) {
		                    return {
		                        tuple: found.tuple,
		                        index: counter
		                    };
		                }
		            }
		        }
	
		        return {
		            index: counter
		        };
		    }
	
		    function addMembers(members, map) {
		        var member, i, len, path = "";
		        for (i = 0, len = members.length; i < len; i++) {
		            member = members[i];
		            path += member.name;
		            if (!map[path]) {
		                map[path] = member;
		            }
		        }
		    }
	
	
		    function findParentMember(tuple, map) {
		        var members = tuple.members;
		        var i, len, member, path = "";
		        var parentPath = "";
		        var parentMember;
	
		        for (i = 0, len = members.length; i < len; i++) {
		            member = members[i];
		            if (parentMember) {
		                if (map[path + member.name]) {
		                    path += member.name;
		                    parentMember = map[path];
		                    continue;
		                } else if (map[path + member.parentName]) {
		                    return map[path + member.parentName];
		                } else if (map[parentPath + member.parentName]) {
		                    return map[parentPath + member.parentName];
		                } else {
		                    return map[parentPath];
		                }
		            }
	
		            path += member.name;
		            parentMember = map[member.parentName];
	
		            if (!parentMember) {
		                parentMember = map[path];
		                if (!parentMember) {
		                    return null;
		                }
		            }
	
		            if (parentMember) {
		                parentPath += parentMember.name;
		            }
		        }
	
		        return parentMember;
		    }
	
		    function measurePosition(tuple, measures) {
		        if (measures.length === 0) {
		            return -1;
		        }
	
		        var measure = measures[0];
		        var members = tuple.members;
		        for (var idx = 0, len = members.length; idx < len; idx ++) {
		            if (members[idx].name == measure.name) {
		                return idx;
		            }
		        }
		    }
	
		    function normalizeTupleMeasures(tuple, index) {
		        if (index < 0) {
		            return;
		        }
		        var member = {
		            name: MEASURES,
		            measure: true,
		            children: [
		                $.extend({ members: [], dataIndex: tuple.dataIndex }, tuple.members[index])
		            ]
		        };
		        tuple.members.splice(index, 1, member);
		        tuple.dataIndex = undefined;
		    }
	
		    function parseSource(tuples, measures) {
		        if (tuples.length < 1) {
		            return [];
		        }
		        var result = [];
		        var map = { };
		        var measureIndex = measurePosition(tuples[0], measures);
	
		        for (var i = 0; i < tuples.length; i++) {
		            var tuple = tuples[i];
	
		            //keep the old data index of the tuple
		            tuple.dataIndex = i;
	
		            normalizeTupleMeasures(tuple, measureIndex);
		            var parentMember = findParentMember(tuple, map);
	
		            if (parentMember) {
		                if (measureIndex < 0 || !parentMember.measure) {
		                    parentMember.children.push(tuple);
		                } else {
		                    parentMember.children.push(tuple.members[measureIndex].children[0]);
		                }
		            } else {
		                result.push(tuple);
		            }
	
		            addMembers(tuple.members, map);
		        }
	
		        return result;
		    }
	
		    function prepareDataOnRows(tuples, data) {
		        if (!tuples || !tuples.length) {
		            return data;
		        }
	
		        var result = [];
		        var indices = buildDataIndices(tuples);
		        var rowsLength = indices.length;
		        var columnsLength = Math.max(data.length / rowsLength, 1);
		        var rowIndex, columnIndex, targetIndex, sourceIndex;
		        var calcIndex;
	
		        for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
		            targetIndex = columnsLength * rowIndex;
		            sourceIndex = columnsLength * indices[rowIndex];
		            for (columnIndex = 0; columnIndex < columnsLength; columnIndex++) {
		                calcIndex = parseInt(sourceIndex + columnIndex, 10);
		                result[parseInt(targetIndex + columnIndex, 10)] = data[calcIndex] || { value: "", fmtValue: "", ordinal: calcIndex };
		            }
		        }
	
		        return result;
		    }
	
		    function prepareDataOnColumns(tuples, data) {
		        if (!tuples || !tuples.length) {
		            return data;
		        }
	
		        var result = [];
		        var indices = buildDataIndices(tuples);
		        var columnsLength = indices.length;
		        var rowsLength = Math.max(data.length / columnsLength, 1);
		        var columnIndex, rowIndex, dataIndex, calcIndex;
	
		        for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
		            dataIndex = columnsLength * rowIndex;
		            for (columnIndex = 0; columnIndex < columnsLength; columnIndex++) {
		                calcIndex = indices[columnIndex] + dataIndex;
		                result[dataIndex + columnIndex] = data[calcIndex] || { value: "", fmtValue: "", ordinal: calcIndex };
		            }
		        }
	
		        return result;
		    }
	
		    function buildDataIndices(tuples) {
		        tuples = tuples.slice();
		        var result = [];
		        var tuple = tuples.shift();
		        var idx, length, spliceIndex, children, member;
	
		        while (tuple) {
		            //required for multiple measures
		            if (tuple.dataIndex !== undefined) {
		                result.push(tuple.dataIndex);
		            }
	
		            spliceIndex = 0;
		            for (idx = 0, length = tuple.members.length; idx < length; idx++) {
		                member = tuple.members[idx];
		                children = member.children;
		                if (member.measure) {
		                    [].splice.apply(tuples, [0, 0].concat(children));
		                } else {
		                    [].splice.apply(tuples, [spliceIndex, 0].concat(children));
		                }
		                spliceIndex += children.length;
		            }
	
		            tuple = tuples.shift();
		        }
	
		        return result;
		    }
	
		    PivotDataSource.create = function(options) {
		        options = options && options.push ? { data: options } : options;
	
		        var dataSource = options || {},
		            data = dataSource.data;
	
		        dataSource.data = data;
	
		        if (!(dataSource instanceof PivotDataSource) && dataSource instanceof kendo.data.DataSource) {
		            throw new Error("Incorrect DataSource type. Only PivotDataSource instances are supported");
		        }
	
		        return dataSource instanceof PivotDataSource ? dataSource : new PivotDataSource(dataSource);
		    };
	
		    function baseHierarchyPath(memberName) {
		        var parts = memberName.split(".");
		        if (parts.length > 2) {
		            return parts[0] + "." + parts[1];
		        }
		        return memberName;
		    }
	
		    function expandMemberDescriptor(names, sort) {
		        var idx = names.length - 1;
		        var name = names[idx];
		        var sortDescriptor;
	
		        sortDescriptor = sortDescriptorForMember(sort, name);
	
		        if (sortDescriptor && sortDescriptor.dir) {
		            name = "ORDER(" + name + ".Children," + sortDescriptor.field + ".CurrentMember.MEMBER_CAPTION," + sortDescriptor.dir + ")";
		        } else {
		            name += ".Children";
		        }
	
		        names[idx] = name;
	
		        return names;
		    }
	
		    function sortDescriptorForMember(sort, member) {
		        for (var idx = 0, length = sort.length; idx < length; idx++) {
		            if (member.indexOf(sort[idx].field) === 0) {
		                return sort[idx];
		            }
		        }
		        return null;
		    }
	
		    function crossJoin(names) {
		        var result = "CROSSJOIN({";
		        var r;
	
		        if (names.length > 2) {
		            r = names.pop();
		            result += crossJoin(names);
		        } else {
		            result += names.shift();
		            r = names.pop();
		        }
	
		        result += "},{";
		        result += r;
		        result += "})";
		        return result;
		    }
	
		    function crossJoinCommand(members, measures) {
		        var tmp = members.slice(0);
	
		        if (measures.length > 1) {
		            tmp.push("{" + measureNames(measures).join(",") + "}");
		        }
	
		        return crossJoin(tmp);
		    }
	
		    function measureNames(measures) {
		        var idx = 0;
		        var length = measures.length;
		        var result = [];
		        var measure;
	
		        for (; idx < length; idx++) {
		            measure = measures[idx];
		            result.push(measure.name !== undefined ? measure.name :  measure);
		        }
	
		        return result;
		    }
	
		    function getName(name) {
		        name = name.name || name;
	
		        if (toString.call(name) === "[object Array]") {
		            name = name[name.length - 1];
		        }
	
		        return name;
		    }
	
		    function getRootNames(members) {
		        var length = members.length;
		        var names = [];
		        var idx = 0;
	
		        for (; idx < length; idx++) {
		            names.push(members[idx].name[0]);
		        }
	
		        return names;
		    }
	
		    function mapNames(names, rootNames) {
		        var name;
		        var rootName;
	
		        var j;
		        var idx = 0;
		        var length = names.length;
		        var rootLength = rootNames.length;
	
		        rootNames = rootNames.slice(0);
	
		        for (; idx < length; idx++) {
		            name = names[idx];
	
		            for (j = 0; j < rootLength; j++) {
		                rootName = baseHierarchyPath(rootNames[j]);
	
		                if (name.indexOf(rootName) !== -1) {
		                    rootNames[j] = name;
		                    break;
		                }
		            }
		        }
	
		        return {
		            names: rootNames,
		            expandedIdx: j,
		            uniquePath: rootNames.slice(0, j + 1).join("")
		        };
		    }
	
		    function parseDescriptors(members) {
		        var expanded = [];
		        var child = [];
		        var root = [];
		        var member;
	
		        var j, l;
		        var idx = 0;
		        var length = members.length;
	
		        var name;
		        var hierarchyName;
	
		        var found;
	
		        for (; idx < length; idx++) {
		            member = members[idx];
		            name = member.name;
		            found = false;
	
		            if (toString.call(name) !== "[object Array]") {
		                member.name = name = [name];
		            }
	
		            if (name.length > 1) {
		                child.push(member);
		            } else {
		                hierarchyName = baseHierarchyPath(name[0]);
	
		                for (j = 0, l = root.length; j < l; j++) {
		                    if (root[j].name[0].indexOf(hierarchyName) === 0) {
		                        found = true;
		                        break;
		                    }
		                }
	
		                if (!found) {
		                    root.push(member);
		                }
	
		                if (member.expand) {
		                    expanded.push(member);
		                }
		            }
		        }
	
		        expanded = expanded.concat(child);
	
		        return {
		            root: root,
		            expanded: expanded
		        };
		    }
	
		    function serializeMembers(members, measures, sort) {
		        var command = "";
	
		        members = members || [];
	
		        var expanded = parseDescriptors(members);
		        var root = expanded.root;
	
		        var rootNames = getRootNames(root);
		        var crossJoinCommands = [];
	
		        expanded = expanded.expanded;
	
		        var length = expanded.length;
		        var idx = 0;
	
		        var memberName;
		        var names = [];
	
		        if (rootNames.length > 1 || measures.length > 1) {
		            crossJoinCommands.push(crossJoinCommand(rootNames, measures));
	
		            for (; idx < length; idx++) {
		                memberName = expandMemberDescriptor(expanded[idx].name, sort);
		                names = mapNames(memberName, rootNames).names;
	
		                crossJoinCommands.push(crossJoinCommand(names, measures));
		            }
	
		            command += crossJoinCommands.join(",");
		        } else {
		            for (; idx < length; idx++) {
		                memberName = expandMemberDescriptor(expanded[idx].name, sort);
		                names.push(memberName[0]); //check if this is ok
		            }
	
		            command += rootNames.concat(names).join(",");
		        }
	
		        return command;
		    }
	
		    var filterFunctionFormats = {
		        contains: ", InStr({0}.CurrentMember.MEMBER_CAPTION,\"{1}\") > 0",
		        doesnotcontain: ", InStr({0}.CurrentMember.MEMBER_CAPTION,\"{1}\")",
		        startswith: ", Left({0}.CurrentMember.MEMBER_CAPTION,Len(\"{1}\"))=\"{1}\"",
		        endswith: ", Right({0}.CurrentMember.MEMBER_CAPTION,Len(\"{1}\"))=\"{1}\"",
		        eq: ", {0}.CurrentMember.MEMBER_CAPTION = \"{1}\"",
		        neq: ", {0}.CurrentMember.MEMBER_CAPTION = \"{1}\""
		    };
	
		    function serializeExpression(expression) {
		        var command = "";
		        var value = expression.value;
		        var field = expression.field;
		        var operator = expression.operator;
	
		        if (operator == "in") {
		            command += "{";
		            command += value;
		            command += "}";
		        } else {
		            command += operator == "neq" || operator == "doesnotcontain" ? "-" : "";
		            command += "Filter(";
		            command += field + ".MEMBERS";
		            command += kendo.format(filterFunctionFormats[operator], field, value);
		            command += ")";
		        }
	
		        return command;
		    }
	
		    function serializeFilters(filter, cube) {
		        var command = "", current;
		        var filters = filter.filters;
		        var length = filters.length;
		        var idx;
	
		        for (idx = length - 1; idx >= 0; idx--) {
	
		            current = "SELECT (";
		            current += serializeExpression(filters[idx]);
		            current += ") ON 0";
	
		            if (idx == length - 1) {
		                current += " FROM [" + cube + "]";
		                command = current;
		            } else {
		                command = current + " FROM ( " + command + " )";
		            }
		        }
	
		        return command;
		    }
	
		    function serializeOptions(parentTagName, options, capitalize) {
		        var result = "";
	
		        if (options) {
		            result += "<" + parentTagName + ">";
		            var value;
		            for (var key in options) {
		                value = options[key] ;
		                if (capitalize) {
		                    key = key.replace(/([A-Z]+(?=$|[A-Z][a-z])|[A-Z]?[a-z]+)/g, "$1_").toUpperCase().replace(/_$/, "");
		                }
		                result += "<" + key + ">" + value + "</" + key + ">";
		            }
		            result += "</" + parentTagName + ">";
		        } else {
		            result += "<" + parentTagName + "/>";
		        }
		        return result;
		    }
	
		    var xmlaDiscoverCommands = {
		        schemaCubes: "MDSCHEMA_CUBES",
		        schemaCatalogs: "DBSCHEMA_CATALOGS",
		        schemaMeasures: "MDSCHEMA_MEASURES",
		        schemaDimensions: "MDSCHEMA_DIMENSIONS",
		        schemaHierarchies: "MDSCHEMA_HIERARCHIES",
		        schemaLevels: "MDSCHEMA_LEVELS",
		        schemaMembers: "MDSCHEMA_MEMBERS",
		        schemaKPIs: "MDSCHEMA_KPIS"
		    };
	
		    var convertersMap = {
		        read: function(options) {
		            var command = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Execute xmlns="urn:schemas-microsoft-com:xml-analysis"><Command><Statement>';
	
		            command += "SELECT NON EMPTY {";
	
		            var columns = options.columns || [];
		            var rows = options.rows || [];
	
		            var measures = options.measures || [];
		            var measuresRowAxis = options.measuresAxis === "rows";
		            var sort = options.sort || [];
	
		            if (!columns.length && rows.length && (!measures.length || (measures.length && measuresRowAxis))) {
		                columns = rows;
		                rows = [];
		                measuresRowAxis = false;
		            }
	
		            if (!columns.length && !rows.length) {
		                measuresRowAxis = false;
		            }
	
		            if (columns.length) {
		                command += serializeMembers(columns, !measuresRowAxis ? measures : [], sort);
		            } else if (measures.length && !measuresRowAxis) {
		                command += measureNames(measures).join(",");
		            }
	
		            command += "} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON COLUMNS";
	
		            if (rows.length || (measuresRowAxis && measures.length > 1)) {
		                command += ", NON EMPTY {";
	
		                if (rows.length) {
		                    command += serializeMembers(rows, measuresRowAxis ? measures : [], sort);
		                } else {
		                    command += measureNames(measures).join(",");
		                }
	
		                command += "} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON ROWS";
		            }
	
		            if (options.filter) {
		                command += " FROM ";
		                command += "(";
		                command += serializeFilters(options.filter, options.connection.cube);
		                command += ")";
		            } else {
		                command += " FROM [" + options.connection.cube + "]";
		            }
	
		            if (measures.length == 1 && columns.length) {
		                command += " WHERE (" + measureNames(measures).join(",") + ")";
		            }
	
		            command += '</Statement></Command><Properties><PropertyList><Catalog>' + options.connection.catalog + '</Catalog><Format>Multidimensional</Format></PropertyList></Properties></Execute></Body></Envelope>';
		            return command.replace(/\&/g, "&amp;");
		        },
		        discover: function(options) {
		            options = options || {};
	
		            var command = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Discover xmlns="urn:schemas-microsoft-com:xml-analysis">';
		            command += "<RequestType>" + (xmlaDiscoverCommands[options.command] || options.command) + "</RequestType>";
	
		            command += "<Restrictions>" + serializeOptions("RestrictionList", options.restrictions, true) + "</Restrictions>";
	
		            if (options.connection && options.connection.catalog) {
		                options.properties = $.extend({}, {
		                    Catalog: options.connection.catalog
		                }, options.properties);
		            }
	
		            command += "<Properties>" + serializeOptions("PropertyList", options.properties) + "</Properties>";
	
		            command += '</Discover></Body></Envelope>';
		            return command;
		        }
		    };
	
		    var XmlaTransport = kendo.data.RemoteTransport.extend({
		        init: function(options) {
		            var originalOptions = options;
	
		            options = this.options = extend(true, {}, this.options, options);
	
		            kendo.data.RemoteTransport.call(this, options);
	
		            if (isFunction(originalOptions.discover)) {
		                this.discover = originalOptions.discover;
		            } else if (typeof originalOptions.discover === "string") {
		                this.options.discover = {
		                    url: originalOptions.discover
		                };
		            } else if (!originalOptions.discover) {
		                this.options.discover = this.options.read;
		            }
		        },
		        setup: function(options, type) {
		            options.data = options.data || {};
		            $.extend(true, options.data, { connection: this.options.connection });
	
		            return kendo.data.RemoteTransport.fn.setup.call(this, options, type);
		        },
		        options: {
		            read: {
		                dataType: "text",
		                contentType: "text/xml",
		                type: "POST"
		            },
		            discover: {
		                dataType: "text",
		                contentType: "text/xml",
		                type: "POST"
		            },
		            parameterMap: function(options, type) {
		                return convertersMap[type](options,type);
		            }
		        },
	
		        discover: function(options) {
		            return $.ajax(this.setup(options, "discover"));
		        }
		    });
	
		    function asArray(object) {
		        if (object == null) {
		            return [];
		        }
	
		        var type = toString.call(object);
		        if (type !== "[object Array]") {
		            return [object];
		        }
	
		        return object;
		    }
	
		    function translateAxis(axis) {
		        var result = { tuples: [] };
		        var tuples = asArray(kendo.getter("Tuples.Tuple", true)(axis));
		        var captionGetter = kendo.getter("Caption['#text']");
		        var unameGetter = kendo.getter("UName['#text']");
		        var levelNameGetter = kendo.getter("LName['#text']");
		        var levelNumGetter = kendo.getter("LNum['#text']");
		        var childrenGetter = kendo.getter("CHILDREN_CARDINALITY['#text']", true);
		        var hierarchyGetter = kendo.getter("['@Hierarchy']");
		        var parentNameGetter = kendo.getter("PARENT_UNIQUE_NAME['#text']", true);
	
		        for (var idx = 0; idx < tuples.length; idx++) {
		            var members = [];
		            var member = asArray(tuples[idx].Member);
		            for (var memberIdx = 0; memberIdx < member.length; memberIdx++) {
		                members.push({
		                    children: [],
		                    caption: captionGetter(member[memberIdx]),
		                    name: unameGetter(member[memberIdx]),
		                    levelName: levelNameGetter(member[memberIdx]),
		                    levelNum: levelNumGetter(member[memberIdx]),
		                    hasChildren: parseInt(childrenGetter(member[memberIdx]), 10) > 0,
		                    parentName: parentNameGetter(member[memberIdx]),
		                    hierarchy: hierarchyGetter(member[memberIdx])
		                });
		            }
	
		            result.tuples.push({ members: members });
		        }
		        return result;
		    }
	
		    var schemaDataReaderMap = {
		        cubes: {
		            name: kendo.getter("CUBE_NAME['#text']", true),
		            caption: kendo.getter("CUBE_CAPTION['#text']", true),
		            description: kendo.getter("DESCRIPTION['#text']", true),
		            type: kendo.getter("CUBE_TYPE['#text']", true)
		        },
		        catalogs: {
		            name: kendo.getter("CATALOG_NAME['#text']", true),
		            description: kendo.getter("DESCRIPTION['#text']", true)
		        },
		        measures: {
		            name: kendo.getter("MEASURE_NAME['#text']", true),
		            caption: kendo.getter("MEASURE_CAPTION['#text']", true),
		            uniqueName: kendo.getter("MEASURE_UNIQUE_NAME['#text']", true),
		            description: kendo.getter("DESCRIPTION['#text']", true),
		            aggregator: kendo.getter("MEASURE_AGGREGATOR['#text']", true),
		            groupName: kendo.getter("MEASUREGROUP_NAME['#text']", true),
		            displayFolder: kendo.getter("MEASURE_DISPLAY_FOLDER['#text']", true),
		            defaultFormat: kendo.getter("DEFAULT_FORMAT_STRING['#text']", true)
		        },
		        kpis: {
		            name: kendo.getter("KPI_NAME['#text']", true),
		            caption: kendo.getter("KPI_CAPTION['#text']", true),
		            value: kendo.getter("KPI_VALUE['#text']", true),
		            goal: kendo.getter("KPI_GOAL['#text']", true),
		            status: kendo.getter("KPI_STATUS['#text']", true),
		            trend: kendo.getter("KPI_TREND['#text']", true),
		            statusGraphic: kendo.getter("KPI_STATUS_GRAPHIC['#text']", true),
		            trendGraphic: kendo.getter("KPI_TREND_GRAPHIC['#text']", true),
		            description: kendo.getter("KPI_DESCRIPTION['#text']", true),
		            groupName: kendo.getter("MEASUREGROUP_NAME['#text']", true)
		        },
		        dimensions: {
		            name: kendo.getter("DIMENSION_NAME['#text']", true),
		            caption: kendo.getter("DIMENSION_CAPTION['#text']", true),
		            description: kendo.getter("DESCRIPTION['#text']", true),
		            uniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
		            defaultHierarchy: kendo.getter("DEFAULT_HIERARCHY['#text']", true),
		            type: kendo.getter("DIMENSION_TYPE['#text']", true)
		//unknown = 0; time = 1; measure = 2; other = 3; quantitative = 5; accounts = 6; customers = 7; products = 8; scenario = 9; utility = 10; currency = 11; rates = 12; channel = 13; promotion = 14; organization = 15; billOfMaterials = 16; geography = 17;
	
		        },
		        hierarchies: {
		            name: kendo.getter("HIERARCHY_NAME['#text']", true),
		            caption: kendo.getter("HIERARCHY_CAPTION['#text']", true),
		            description: kendo.getter("DESCRIPTION['#text']", true),
		            uniqueName: kendo.getter("HIERARCHY_UNIQUE_NAME['#text']", true),
		            dimensionUniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
		            displayFolder: kendo.getter("HIERARCHY_DISPLAY_FOLDER['#text']", true),
		            origin: kendo.getter("HIERARCHY_ORIGIN['#text']", true),
		            defaultMember: kendo.getter("DEFAULT_MEMBER['#text']", true)
		        },
		        levels: {
		            name: kendo.getter("LEVEL_NAME['#text']", true),
		            caption: kendo.getter("LEVEL_CAPTION['#text']", true),
		            description: kendo.getter("DESCRIPTION['#text']", true),
		            uniqueName: kendo.getter("LEVEL_UNIQUE_NAME['#text']", true),
		            dimensionUniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
		            displayFolder: kendo.getter("LEVEL_DISPLAY_FOLDER['#text']", true),
		            orderingProperty: kendo.getter("LEVEL_ORDERING_PROPERTY['#text']", true),
		            origin: kendo.getter("LEVEL_ORIGIN['#text']", true),
		            hierarchyUniqueName: kendo.getter("HIERARCHY_UNIQUE_NAME['#text']", true)
		        },
		        members: {
		            name: kendo.getter("MEMBER_NAME['#text']", true),
		            caption: kendo.getter("MEMBER_CAPTION['#text']", true),
		            uniqueName: kendo.getter("MEMBER_UNIQUE_NAME['#text']", true),
		            dimensionUniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
		            hierarchyUniqueName: kendo.getter("HIERARCHY_UNIQUE_NAME['#text']", true),
		            levelUniqueName: kendo.getter("LEVEL_UNIQUE_NAME['#text']", true),
		            childrenCardinality: kendo.getter("CHILDREN_CARDINALITY['#text']", true)
		        }
		    };
	
		    var xmlaReaderMethods = ["axes", "catalogs", "cubes", "dimensions", "hierarchies", "levels", "measures"];
	
		    var XmlaDataReader = kendo.data.XmlDataReader.extend({
		        init: function(options) {
		            kendo.data.XmlDataReader.call(this, options);
	
		            this._extend(options);
		        },
		        _extend: function(options) {
		            var idx = 0;
		            var length = xmlaReaderMethods.length;
		            var methodName;
		            var option;
	
		            for (; idx < length; idx++) {
		                methodName = xmlaReaderMethods[idx];
		                option = options[methodName];
	
		                if (option && option !== identity) {
		                    this[methodName] = option;
		                }
		            }
		        },
		        parse: function(xml) {
		            var result = kendo.data.XmlDataReader.fn.parse(xml.replace(/<(\/?)(\w|-)+:/g, "<$1"));
		            return kendo.getter("['Envelope']['Body']", true)(result);
		        },
		        errors: function(root) {
		            var fault = kendo.getter("['Fault']", true)(root);
		            if (fault) {
		                return [{
		                    faultstring: kendo.getter("faultstring['#text']", true)(fault),
		                    faultcode: kendo.getter("faultcode['#text']", true)(fault)
		                }];
		            }
		            return null;
		        },
		        axes: function(root) {
		            root = kendo.getter("ExecuteResponse[\"return\"].root", true)(root);
	
		            var axes = asArray(kendo.getter("Axes.Axis", true)(root));
		            var axis;
	
		            var result = {
		                columns: {},
		                rows: {}
		            };
	
		            for (var idx = 0; idx < axes.length; idx++) {
		                axis = axes[idx];
	
		                if (axis["@name"].toLowerCase() !== "sliceraxis") {
		                    if (!result.columns.tuples) {
		                        result.columns = translateAxis(axis);
		                    } else {
		                        result.rows = translateAxis(axis);
		                    }
		                }
		            }
	
		            return result;
		        },
		        data: function(root) {
		            root = kendo.getter("ExecuteResponse[\"return\"].root", true)(root);
	
		            var cells = asArray(kendo.getter("CellData.Cell", true)(root));
	
		            var result = [];
		            var ordinalGetter = kendo.getter("['@CellOrdinal']");
		            var valueGetter = kendo.getter("Value['#text']");
		            var fmtValueGetter = kendo.getter("FmtValue['#text']");
	
		            for (var idx = 0; idx < cells.length; idx++) {
		                result.push({
		                    value: valueGetter(cells[idx]),
		                    fmtValue: fmtValueGetter(cells[idx]),
		                    ordinal: parseInt(ordinalGetter(cells[idx]), 10)
		                });
		            }
	
		            return result;
		        },
		        _mapSchema: function(root, getters) {
		            root = kendo.getter("DiscoverResponse[\"return\"].root", true)(root);
		            var rows = asArray(kendo.getter("row", true)(root));
	
		            var result = [];
	
		            for (var idx = 0; idx < rows.length; idx++) {
		                var obj = {};
		                for (var key in getters) {
		                    obj[key] = getters[key](rows[idx]);
		                }
		                result.push(obj);
		            }
	
		            return result;
		        },
		        measures: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.measures);
		        },
		        kpis: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.kpis);
		        },
		        hierarchies: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.hierarchies);
		        },
		        levels: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.levels);
		        },
		        dimensions: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.dimensions);
		        },
		        cubes: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.cubes);
		        },
		        catalogs: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.catalogs);
		        },
		        members: function(root) {
		            return this._mapSchema(root, schemaDataReaderMap.members);
		        }
		    });
	
		    extend(true, kendo.data, {
		       PivotDataSource: PivotDataSource,
		       XmlaTransport: XmlaTransport,
		       XmlaDataReader: XmlaDataReader,
		       PivotCubeBuilder: PivotCubeBuilder,
		       transports: {
		           xmla: XmlaTransport
		       },
		       readers: {
		           xmla: XmlaDataReader
		       }
		    });
	
		    var sortExpr = function(expressions, name) {
		        if (!expressions) {
		            return null;
		        }
	
		        for (var idx = 0, length = expressions.length; idx < length; idx++) {
		            if (expressions[idx].field === name) {
		                return expressions[idx];
		            }
		        }
	
		        return null;
		    };
	
		    var removeExpr = function(expressions, name) {
		        var result = [];
	
		        for (var idx = 0, length = expressions.length; idx < length; idx++) {
		            if (expressions[idx].field !== name) {
		                result.push(expressions[idx]);
		            }
		        }
	
		        return result;
		    };
	
		    kendo.ui.PivotSettingTarget = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            that.element.addClass("k-pivot-setting");
	
		            that.dataSource = kendo.data.PivotDataSource.create(options.dataSource);
	
		            that._refreshHandler = $.proxy(that.refresh, that);
		            that.dataSource.first(CHANGE, that._refreshHandler);
	
		            if (!options.template) {
		                that.options.template = "<div data-" + kendo.ns + 'name="${data.name || data}">${data.name || data}' +
		                    (that.options.enabled ?
		                    '<a class="k-button k-button-icon k-bare"><span class="k-icon k-i-close k-setting-delete"></span></a>' : "") + '</div>';
		            }
	
		            that.template = kendo.template(that.options.template);
		            that.emptyTemplate = kendo.template(that.options.emptyTemplate);
	
		            that._sortable();
	
		            that.element.on("click" + NS, ".k-button,.k-item", function(e) {
		                var target = $(e.target);
		                var name = target.closest("[" + kendo.attr("name") + "]")
		                                 .attr(kendo.attr("name"));
	
		                if (!name) {
		                    return;
		                }
	
		                if (target.hasClass("k-i-close")) {
		                    that.remove(name);
		                } else if (that.options.sortable && target[0] === e.currentTarget) {
		                    that.sort({
		                        field: name,
		                        dir: target.find(".k-i-sort-asc-sm")[0] ? "desc" : "asc"
		                    });
		                }
		            });
	
		            if (options.filterable || options.sortable) {
		                that.fieldMenu = new ui.PivotFieldMenu(that.element, {
		                    messages: that.options.messages.fieldMenu,
		                    filter: ".k-setting-fieldmenu",
		                    filterable: options.filterable,
		                    sortable: options.sortable,
		                    dataSource: that.dataSource
		                });
		            }
	
		            that.refresh();
		        },
	
		        options: {
		            name: "PivotSettingTarget",
		            template: null,
		            filterable: false,
		            sortable: false,
		            emptyTemplate: "<div class='k-empty'>${data}</div>",
		            setting: "columns",
		            enabled: true,
		            messages: {
		                empty: "Drop Fields Here"
		            }
		        },
		        setDataSource: function(dataSource) {
		            this.dataSource.unbind(CHANGE, this._refreshHandler);
		            this.dataSource = this.options.dataSource = dataSource;
	
		            if (this.fieldMenu) {
		                this.fieldMenu.setDataSource(dataSource);
		            }
		            dataSource.first(CHANGE, this._refreshHandler);
	
		            this.refresh();
		        },
	
		        _sortable: function() {
		            var that = this;
	
		            if (that.options.enabled) {
		                this.sortable = this.element.kendoSortable({
		                    connectWith: this.options.connectWith,
		                    hint: that.options.hint,
		                    cursor: "move",
		                    start: function(e) {
		                        e.item.focus().blur();
		                    },
		                    change: function(e) {
		                        var name = e.item.attr(kendo.attr("name"));
	
		                        if (e.action == "receive") {
		                            that.add(name);
		                        } else if (e.action == "remove") {
		                            that.remove(name);
		                        } else if (e.action == "sort") {
		                            that.move(name, e.newIndex);
		                        }
		                    }
		                }).data("kendoSortable");
		            }
		        },
	
		        _indexOf: function(name, items) {
		            var idx, length, index = -1;
	
		            for (idx = 0, length = items.length; idx < length; idx++) {
		                if (getName(items[idx]) === name) {
		                    index = idx;
		                    break;
		                }
		            }
		            return index;
		        },
	
		        _isKPI: function(data) {
		            return data.type === "kpi" || data.measure;
		        },
	
		        validate: function(data) {
		            var isMeasure = (data.type == 2 || "aggregator" in data || this._isKPI(data));
	
		            if (isMeasure) {
		                return this.options.setting === "measures";
		            }
	
		            if (this.options.setting === "measures") {
		                return isMeasure;
		            }
	
		            var items = this.dataSource[this.options.setting]();
		            var name = data.defaultHierarchy || data.uniqueName;
		            if (this._indexOf(name, items) > -1) {
		                return false;
		            }
	
		            items = this.dataSource[this.options.setting === "columns" ? "rows" : "columns"]();
		            if (this._indexOf(name, items) > -1) {
		                return false;
		            }
	
		            return true;
		        },
	
		        add: function(name) {
		            var items = this.dataSource[this.options.setting]();
		            var i, l;
	
		            name = $.isArray(name) ? name.slice(0) : [name];
	
		            for (i = 0, l = name.length; i < l; i++) {
		                if (this._indexOf(name[i], items) !== -1) {
		                    name.splice(i, 1);
		                    i -= 1;
		                    l -= 1;
		                }
		            }
	
		            if (name.length) {
		                items = items.concat(name);
		                this.dataSource[this.options.setting](items);
		            }
		        },
	
		        move: function(name, index) {
		            var items = this.dataSource[this.options.setting]();
		            var idx = this._indexOf(name, items);
	
		            if (idx > -1) {
		                name = items.splice(idx, 1)[0];
	
		                items.splice(index, 0, name);
	
		                this.dataSource[this.options.setting](items);
		            }
		        },
	
		        remove: function (name) {
		            var items = this.dataSource[this.options.setting]();
		            var idx = this._indexOf(name, items);
		            var sortExpressions = this.dataSource.sort();
		            var filter = this.dataSource.filter();
	
		            if (idx > -1) {
		                if (filter) {
		                    filter.filters = removeExpr(filter.filters, name);
		                    this.dataSource._filter.filters = filter.filters;
		                    if (!filter.filters.length) {
		                        this.dataSource._filter = null;
		                    }
		                }
		                if (sortExpressions) {
		                    sortExpressions = removeExpr(sortExpressions, name);
		                    this.dataSource._sort = sortExpressions;
		                }
		                items.splice(idx, 1);
		                this.dataSource[this.options.setting](items);
		            }
		        },
	
		        sort: function(expr) {
		            var sortable = this.options.sortable;
		            var allowUnsort = sortable === true || sortable.allowUnsort;
		            var skipExpr = allowUnsort && expr.dir === "asc";
	
		            var expressions = (this.dataSource.sort() || []);
		            var result = removeExpr(expressions, expr.field);
	
		            if (skipExpr && expressions.length !== result.length) {
		                expr = null;
		            }
	
		            if (expr) {
		                result.push(expr);
		            }
	
		            this.dataSource.sort(result);
		        },
	
		        refresh: function() {
		            var html = "";
		            var items = this.dataSource[this.options.setting]();
		            var length = items.length;
		            var idx = 0;
		            var item;
	
		            if (length) {
		                for (; idx < length; idx++) {
		                    item = items[idx];
		                    item = item.name === undefined ? { name: item } : item;
	
		                    html += this.template(extend({ sortIcon: this._sortIcon(item.name) }, item));
		                }
		            } else {
		                html = this.emptyTemplate(this.options.messages.empty);
		            }
	
		            this.element.html(html);
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this.dataSource.unbind(CHANGE, this._refreshHandler);
		            this.element.off(NS);
	
		            if (this.sortable) {
		                this.sortable.destroy();
		            }
	
		            if (this.fieldMenu) {
		                this.fieldMenu.destroy();
		            }
	
		            this.element = null;
		            this._refreshHandler = null;
		        },
	
		        _sortIcon: function(name) {
		            var expressions = this.dataSource.sort();
		            var expr = sortExpr(expressions, getName(name));
		            var icon = "";
	
		            if (expr) {
		                icon = "k-i-sort-" + expr.dir;
		            }
	
		            return icon;
		        }
		    });
	
		    var PivotGrid = Widget.extend({
		        init: function(element, options) {
		            var that = this;
		            var columnBuilder;
		            var rowBuilder;
	
		            Widget.fn.init.call(that, element, options);
	
		            that._dataSource();
	
		            that._bindConfigurator();
	
		            that._wrapper();
		            that._createLayout();
	
		            that._columnBuilder = columnBuilder = new ColumnBuilder();
		            that._rowBuilder = rowBuilder = new RowBuilder();
		            that._contentBuilder = new ContentBuilder();
	
		            that._templates();
	
		            that.columnsHeader
		                .add(that.rowsHeader)
		                .on("click", "span.k-icon", function() {
		                    var button = $(this);
		                    var builder = columnBuilder;
		                    var action = "expandColumn";
		                    var eventName;
		                    var path = button.attr(kendo.attr("path"));
		                    var eventArgs = {
		                        axis: "columns",
		                        path: $.parseJSON(path)
		                    };
	
		                    if (button.parent().is("td")) {
		                        builder = rowBuilder;
		                        action = "expandRow";
		                        eventArgs.axis = "rows";
		                    }
	
		                    var expanded = button.hasClass(STATE_EXPANDED);
		                    var metadata = builder.metadata[path];
		                    var request = metadata.expanded === undefined;
	
		                    eventName = expanded ? COLLAPSEMEMBER : EXPANDMEMBER;
		                    eventArgs.childrenLoaded = metadata.maxChildren > metadata.children;
	
		                    if (that.trigger(eventName, eventArgs)) {
		                        return;
		                    }
	
		                    builder.metadata[path].expanded = !expanded;
	
		                    button.toggleClass(STATE_EXPANDED, !expanded)
		                          .toggleClass(STATE_COLLAPSED, expanded);
	
		                    if (!expanded && request) {
		                        that.dataSource[action](eventArgs.path);
		                    } else {
		                        that.refresh();
		                    }
		                });
	
		            that._scrollable();
	
		            if (that.options.autoBind) {
		                that.dataSource.fetch();
		            }
	
		            kendo.notify(that);
		        },
	
		        events: [
		            DATABINDING,
		            DATABOUND,
		            EXPANDMEMBER,
		            COLLAPSEMEMBER
		        ],
	
		        options: {
		            name: "PivotGrid",
		            autoBind: true,
		            reorderable: true,
		            filterable: false,
		            sortable: false,
		            height: null,
		            columnWidth: 100,
		            configurator: "",
		            columnHeaderTemplate: null,
		            rowHeaderTemplate: null,
		            dataCellTemplate: null,
		            kpiStatusTemplate: null,
		            kpiTrendTemplate: null,
		            messages: {
		                measureFields: "Drop Data Fields Here",
		                columnFields: "Drop Column Fields Here",
		                rowFields: "Drop Rows Fields Here"
		            }
		        },
	
		        _templates: function() {
		            var columnTemplate = this.options.columnHeaderTemplate;
		            var rowTemplate = this.options.rowHeaderTemplate;
		            var dataTemplate = this.options.dataCellTemplate;
		            var kpiStatusTemplate = this.options.kpiStatusTemplate;
		            var kpiTrendTemplate = this.options.kpiTrendTemplate;
	
		            this._columnBuilder.template = kendo.template(columnTemplate || HEADER_TEMPLATE, { useWithBlock: !!columnTemplate });
		            this._contentBuilder.dataTemplate = kendo.template(dataTemplate || DATACELL_TEMPLATE, { useWithBlock: !!dataTemplate });
		            this._contentBuilder.kpiStatusTemplate = kendo.template(kpiStatusTemplate || KPISTATUS_TEMPLATE, { useWithBlock: !!kpiStatusTemplate });
		            this._contentBuilder.kpiTrendTemplate = kendo.template(kpiTrendTemplate || KPITREND_TEMPLATE, { useWithBlock: !!kpiTrendTemplate });
		            this._rowBuilder.template = kendo.template(rowTemplate || HEADER_TEMPLATE, { useWithBlock: !!rowTemplate });
		        },
	
		        _bindConfigurator: function() {
		            var configurator = this.options.configurator;
		            if (configurator) {
		                $(configurator).kendoPivotConfigurator("setDataSource", this.dataSource);
		            }
		        },
	
		        cellInfoByElement: function(element) {
		            element = $(element);
	
		            return this.cellInfo(element.index(), element.parent("tr").index());
		        },
	
		        cellInfo: function(columnIndex, rowIndex) {
		            var contentBuilder = this._contentBuilder;
		            var columnInfo = contentBuilder.columnIndexes[columnIndex || 0];
		            var rowInfo = contentBuilder.rowIndexes[rowIndex || 0];
		            var dataIndex;
	
		            if (!columnInfo || !rowInfo) {
		                return null;
		            }
	
		            dataIndex = (rowInfo.index * contentBuilder.rowLength) + columnInfo.index;
	
		            return {
		                columnTuple: columnInfo.tuple,
		                rowTuple: rowInfo.tuple,
		                measure: columnInfo.measure || rowInfo.measure,
		                dataItem: this.dataSource.view()[dataIndex]
		            };
		        },
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
	
		            this._dataSource();
	
		            if (this.measuresTarget) {
		                this.measuresTarget.setDataSource(dataSource);
		            }
	
		            if (this.rowsTarget) {
		                this.rowsTarget.setDataSource(dataSource);
		            }
	
		            if (this.columnsTarget) {
		                this.columnsTarget.setDataSource(dataSource);
		            }
	
		            this._bindConfigurator();
	
		            if (this.options.autoBind) {
		                dataSource.fetch();
		            }
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
	
		            this._templates();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            clearTimeout(this._headerReflowTimeout);
		        },
	
		        _dataSource: function() {
		            var that = this;
		            var dataSource = that.options.dataSource;
	
		            dataSource = $.isArray(dataSource) ? { data: dataSource } : dataSource;
	
		            if (that.dataSource && this._refreshHandler) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler)
		                               .unbind(STATERESET, that._stateResetHandler)
		                               .unbind(PROGRESS, that._progressHandler)
		                               .unbind(ERROR, that._errorHandler);
		            } else {
		                that._refreshHandler = $.proxy(that.refresh, that);
		                that._progressHandler = $.proxy(that._requestStart, that);
		                that._stateResetHandler = $.proxy(that._stateReset, that);
		                that._errorHandler = $.proxy(that._error, that);
		            }
	
		            that.dataSource = kendo.data.PivotDataSource.create(dataSource)
		                                   .bind(CHANGE, that._refreshHandler)
		                                   .bind(PROGRESS, that._progressHandler)
		                                   .bind(STATERESET, that._stateResetHandler)
		                                   .bind(ERROR, that._errorHandler);
		        },
	
		        _error: function() {
		            this._progress(false);
		        },
	
		        _requestStart: function() {
		            this._progress(true);
		        },
	
		        _stateReset: function() {
		            this._columnBuilder.reset();
		            this._rowBuilder.reset();
		        },
	
		        _wrapper: function() {
		            var height = this.options.height;
	
		            this.wrapper = this.element.addClass("k-widget k-pivot");
	
		            if (height) {
		                this.wrapper.css("height", height);
		            }
		        },
	
		        _measureFields: function() {
		            this.measureFields = $(DIV).addClass("k-pivot-toolbar k-header k-settings-measures");
	
		            this.measuresTarget = this._createSettingTarget(this.measureFields, {
		                setting: "measures",
		                messages: {
		                    empty: this.options.messages.measureFields
		                }
		            });
		        },
	
		        _createSettingTarget: function(element, options) {
		            var template = '<span tabindex="0" class="k-button" data-' + kendo.ns + 'name="${data.name}">${data.name}';
		            var sortable = options.sortable;
		            var icons = "";
	
		            if (sortable) {
		                icons += '#if (data.sortIcon) {#';
		                icons += '<span class="k-icon ${data.sortIcon}-sm"></span>';
		                icons += '#}#';
		            }
	
		            if (options.filterable || sortable) {
		                icons += '<span class="k-icon k-i-more-vertical k-setting-fieldmenu"></span>';
		            }
		            if (this.options.reorderable) {
		                icons += '<span class="k-icon k-i-close k-setting-delete"></span>';
		            }
	
		            if (icons) {
		                template += '<span class="k-field-actions">' + icons + '</span>';
		            }
	
		            template += '</span>';
	
		            return new kendo.ui.PivotSettingTarget(element, $.extend({
		                template: template,
		                emptyTemplate: '<span class="k-empty">${data}</span>',
		                enabled: this.options.reorderable,
		                dataSource: this.dataSource
		            }, options));
		        },
	
		        _initSettingTargets: function() {
		            this.columnsTarget = this._createSettingTarget(this.columnFields, {
		                connectWith: this.rowFields,
		                setting: "columns",
		                filterable: this.options.filterable,
		                sortable: this.options.sortable,
		                messages: {
		                    empty: this.options.messages.columnFields,
		                    fieldMenu: this.options.messages.fieldMenu
		                }
		            });
	
		            this.rowsTarget = this._createSettingTarget(this.rowFields, {
		                connectWith: this.columnFields,
		                setting: "rows",
		                filterable: this.options.filterable,
		                sortable: this.options.sortable,
		                messages: {
		                    empty: this.options.messages.rowFields,
		                    fieldMenu: this.options.messages.fieldMenu
		                }
		            });
		        },
	
		        _createLayout: function() {
		            var that = this;
		            var layoutTable = $(LAYOUT_TABLE);
		            var leftContainer = layoutTable.find(".k-pivot-rowheaders");
		            var rightContainer = layoutTable.find(".k-pivot-table");
		            var gridWrapper = $(DIV).addClass("k-grid k-widget");
	
		            that._measureFields();
		            that.columnFields = $(DIV).addClass("k-pivot-toolbar k-header k-settings-columns");
	
		            that.rowFields = $(DIV).addClass("k-pivot-toolbar k-header k-settings-rows");
		            that.columnsHeader = $('<div class="k-grid-header-wrap" />')
		                                    .wrap('<div class="k-grid-header" />');
	
		            that.columnsHeader.parent().css("padding-right", kendo.support.scrollbar());
	
		            that.rowsHeader = $('<div class="k-grid k-widget k-alt"/>');
		            that.content = $('<div class="k-grid-content" />');
	
		            leftContainer.append(that.measureFields);
		            leftContainer.append(that.rowFields);
		            leftContainer.append(that.rowsHeader);
	
		            gridWrapper.append(that.columnsHeader.parent());
		            gridWrapper.append(that.content);
	
		            rightContainer.append(that.columnFields);
		            rightContainer.append(gridWrapper);
	
		            that.wrapper.append(layoutTable);
	
		            that.columnsHeaderTree = new kendo.dom.Tree(that.columnsHeader[0]);
		            that.rowsHeaderTree = new kendo.dom.Tree(that.rowsHeader[0]);
		            that.contentTree = new kendo.dom.Tree(that.content[0]);
	
		            that._initSettingTargets();
		        },
	
		        _progress: function(toggle) {
		            kendo.ui.progress(this.wrapper, toggle);
		        },
	
		        _resize: function() {
		            if (this.content[0].firstChild) {
		                this._setSectionsWidth();
		                this._setSectionsHeight();
		                this._setContentWidth();
		                this._setContentHeight();
		                this._columnHeaderReflow();
		            }
		        },
	
		        _columnHeaderReflow: function() {
		            var columnTable = this.columnsHeader.children("table");
	
		            if (!kendo.support.browser.mozilla) {
		                return;
		            }
	
		            clearTimeout(this._headerReflowTimeout);
	
		            columnTable.css("table-layout", "auto");
	
		            this._headerReflowTimeout = setTimeout(function() {
		                columnTable.css("table-layout", "");
		            });
		        },
	
		        _setSectionsWidth: function() {
		            var rowsHeader = this.rowsHeader;
		            var leftColumn = rowsHeader.parent(".k-pivot-rowheaders").width(AUTO);
		            var width;
	
		            width = Math.max(outerWidth(this.measureFields), outerWidth(this.rowFields));
		            width = Math.max(rowsHeader.children("table").width(), width);
	
		            leftColumn.width(width);
		        },
	
		        _setSectionsHeight: function() {
		            var measureFieldsHeight = this.measureFields.height(AUTO).height();
		            var columnFieldsHeight = this.columnFields.height(AUTO).height();
		            var rowFieldsHeight = this.rowFields.height(AUTO).innerHeight();
		            var columnsHeight = this.columnsHeader.height(AUTO).innerHeight();
	
		            var padding = rowFieldsHeight - this.rowFields.height();
	
		            var firstRowHeight = columnFieldsHeight > measureFieldsHeight ? columnFieldsHeight : measureFieldsHeight;
		            var secondRowHeight = columnsHeight > rowFieldsHeight ? columnsHeight : rowFieldsHeight;
	
		            this.measureFields.height(firstRowHeight);
		            this.columnFields.height(firstRowHeight);
		            this.rowFields.height(secondRowHeight - padding);
		            this.columnsHeader.height(secondRowHeight);
		        },
	
		        _setContentWidth: function() {
		            var contentTable = this.content.find("table");
		            var columnTable = this.columnsHeader.children("table");
	
		            var rowLength = contentTable.children("colgroup").children().length;
	
		            var calculatedWidth = rowLength * this.options.columnWidth;
		            var minWidth = Math.ceil((calculatedWidth / this.content.width()) * 100);
	
		            if (minWidth < 100) {
		                minWidth = 100;
		            }
	
		            contentTable.add(columnTable).css("width", minWidth + "%");
	
		            this._resetColspan(columnTable);
		        },
	
		        _setContentHeight: function() {
		            var that = this;
		            var content = that.content;
		            var rowsHeader = that.rowsHeader;
		            var innerHeight = that.wrapper.innerHeight();
		            var scrollbar = kendo.support.scrollbar();
		            var skipScrollbar = content[0].offsetHeight === content[0].clientHeight;
		            var height = that.options.height;
	
		            if (that.wrapper.is(":visible")) {
		                if (!innerHeight || !height) {
		                    if (skipScrollbar) {
		                        scrollbar = 0;
		                    }
	
		                    content.height("auto");
		                    rowsHeader.height(content.height() - scrollbar);
		                    return;
		                }
	
		                innerHeight -= outerHeight(that.columnFields);
		                innerHeight -= outerHeight(that.columnsHeader);
	
		                if (innerHeight <= scrollbar * 2) { // do not set height if proper scrollbar cannot be displayed
		                    innerHeight = scrollbar * 2 + 1;
		                    if (!skipScrollbar) {
		                        innerHeight += scrollbar;
		                    }
		                }
	
		                content.height(innerHeight);
	
		                if (skipScrollbar) {
		                    scrollbar = 0;
		                }
	
		                rowsHeader.height(innerHeight - scrollbar);
		            }
		        },
	
		        _resetColspan: function(columnTable) {
		            var that = this;
		            var cell = columnTable.children("tbody").children(":first").children(":first");
	
		            if (that._colspan === undefined) {
		                that._colspan = cell.attr("colspan");
		            }
	
		            cell.attr("colspan", 1);
	
		            clearTimeout(that._layoutTimeout);
	
		            that._layoutTimeout = setTimeout(function() {
		                cell.attr("colspan", that._colspan);
		                that._colspan = undefined;
		            });
		        },
	
		        _axisMeasures: function(axis) {
		            var result = [];
		            var dataSource = this.dataSource;
		            var measures = dataSource.measures();
		            var hasMeasure = measures.length > 1 || (measures[0] && measures[0].type);
	
		            if (dataSource.measuresAxis() === axis) {
		                if (dataSource[axis]().length === 0 || hasMeasure) {
		                    result = measures;
		                }
		            }
	
		            return result;
		        },
	
		        items: function() {
		            return [];
		        },
	
		        refresh: function() {
		            var that = this;
		            var dataSource = that.dataSource;
	
		            var axes = dataSource.axes();
		            var columns = (axes.columns || {}).tuples || [];
		            var rows = (axes.rows || {}).tuples || [];
	
		            var columnBuilder = that._columnBuilder;
		            var rowBuilder = that._rowBuilder;
	
		            var columnAxis = {};
		            var rowAxis = {};
	
		            if (that.trigger(DATABINDING, { action: "rebind" } )) {
		                return;
		            }
	
		            columnBuilder.measures = that._axisMeasures(AXIS_COLUMNS);
		            rowBuilder.measures = that._axisMeasures(AXIS_ROWS);
	
		            that.columnsHeaderTree.render(columnBuilder.build(columns));
		            that.rowsHeaderTree.render(rowBuilder.build(rows));
	
		            columnAxis = {
		                indexes: columnBuilder._indexes,
		                measures: columnBuilder.measures,
		                metadata: columnBuilder.metadata
		            };
	
		            rowAxis = {
		                indexes: rowBuilder._indexes,
		                measures: rowBuilder.measures,
		                metadata: rowBuilder.metadata
		            };
	
		            that.contentTree.render(that._contentBuilder.build(dataSource.view(), columnAxis, rowAxis));
	
		            that._resize();
	
		            if (that.touchScroller) {
		                that.touchScroller.contentResized();
		            } else {
		                var touchScroller = kendo.touchScroller(that.content);
	
		                if (touchScroller && touchScroller.movable) {
		                    that.touchScroller = touchScroller;
	
		                    touchScroller.movable.bind("change", function(e) {
		                        that.columnsHeader.scrollLeft(-e.sender.x);
		                        that.rowsHeader.scrollTop(-e.sender.y);
		                    });
		                }
		            }
	
		            that._progress(false);
	
		            that.trigger(DATABOUND);
		        },
	
		        _scrollable: function() {
		            var that = this;
		            var columnsHeader = that.columnsHeader;
		            var rowsHeader = that.rowsHeader;
	
		            that.content.scroll(function() {
		                columnsHeader.scrollLeft(this.scrollLeft);
		                rowsHeader.scrollTop(this.scrollTop);
		            });
	
		            rowsHeader.bind("DOMMouseScroll" + NS + " mousewheel" + NS, $.proxy(that._wheelScroll, that));
		        },
	
		        _wheelScroll: function (e) {
		            if (e.ctrlKey) {
		                return;
		            }
	
		            var delta = kendo.wheelDeltaY(e);
		            var scrollTop = this.content.scrollTop();
	
		            if (delta) {
		                e.preventDefault();
		                //In Firefox DOMMouseScroll event cannot be canceled
		                $(e.currentTarget).one("wheel" + NS, false);
	
		                this.rowsHeader.scrollTop(scrollTop + (-delta));
		                this.content.scrollTop(scrollTop + (-delta));
		            }
		        }
		    });
	
		    var element = kendo.dom.element;
		    var htmlNode = kendo.dom.html;
	
		    var createMetadata = function(levelNum, memberIdx) {
		       return {
		            maxChildren: 0,
		            children: 0,
		            maxMembers: 0,
		            members: 0,
		            measures: 1,
		            levelNum: levelNum,
		            parentMember: memberIdx !== 0
		        };
		    };
	
		    var buildPath = function(tuple, index) {
		        var path = [];
		        var idx = 0;
	
		        for(; idx <= index; idx++) {
		            path.push(tuple.members[idx].name);
		        }
	
		        return path;
		    };
	
		    var tupleName = function(tuple, index) {
		        var name = "";
		        var idx = 0;
	
		        for(; idx <= index; idx++) {
		            name += tuple.members[idx].name;
		        }
	
		        return name;
		    };
	
		    var ColumnBuilder = Class.extend({
		        init: function() {
		            this.measures = 1;
		            this.metadata = {};
		        },
	
		        build: function(tuples) {
		            var tbody = this._tbody(tuples);
		            var colgroup = this._colGroup();
	
		            return [
		                element("table", null, [colgroup, tbody])
		            ];
		        },
	
		        reset: function() {
		            this.metadata = {};
		        },
	
		        _colGroup: function() {
		            var length = this._rowLength();
		            var children = [];
		            var idx = 0;
	
		            for (; idx < length; idx++) {
		                children.push(element("col", null));
		            }
	
		            return element("colgroup", null, children);
		        },
	
		        _tbody: function(tuples) {
		            var root = tuples[0];
	
		            this.map = {};
		            this.rows = [];
		            this.rootTuple = root;
	
		            this._indexes = [];
	
		            if (root) {
		                this._buildRows(root, 0);
		                this._normalize();
		            } else {
		                this.rows.push(element("tr", null, [ element("th", null, [ htmlNode("&nbsp;") ]) ]));
		            }
	
		            return element("tbody", null, this.rows);
		        },
	
		        _normalize: function() {
		            var rows = this.rows;
		            var rowsLength = rows.length;
		            var rowIdx = 0;
		            var row;
	
		            var cellsLength;
		            var cellIdx;
		            var cells;
		            var cell;
	
		            for (; rowIdx < rowsLength; rowIdx++) {
		                row = rows[rowIdx];
	
		                if (row.rowSpan === 1) {
		                    continue;
		                }
	
		                cells = row.children;
	
		                cellIdx = 0;
		                cellsLength = cells.length;
	
		                for (; cellIdx < cellsLength; cellIdx++) {
		                    cell = cells[cellIdx];
	
		                    if (cell.tupleAll) {
		                        cell.attr.rowSpan = row.rowSpan;
		                    }
		                }
		            }
		        },
	
		        _rowIndex: function(row) {
		            var rows = this.rows;
		            var length = rows.length;
		            var idx = 0;
	
		            for(; idx < length; idx++) {
		                if (rows[idx] === row) {
		                    break;
		                }
		            }
	
		            return idx;
		        },
	
		        _rowLength: function() {
		            var cells = this.rows[0] ? this.rows[0].children : [];
		            var length = cells.length;
		            var rowLength = 0;
		            var idx = 0;
	
		            if (length) {
		                for (; idx < length; idx++) {
		                    rowLength += cells[idx].attr.colSpan || 1;
		                }
		            }
	
		            if (!rowLength) {
		                rowLength = this.measures;
		            }
	
		            return rowLength;
		        },
	
		        _row: function(tuple, memberIdx, parentMember) {
		            var rootName = this.rootTuple.members[memberIdx].name;
		            var levelNum = tuple.members[memberIdx].levelNum;
		            var rowKey = rootName + levelNum;
		            var map = this.map;
		            var parentRow;
		            var children;
	
		            var row = map[rowKey];
	
		            if (!row) {
		                row = element("tr", null, []);
	
		                row.parentMember = parentMember;
		                row.collapsed = 0;
		                row.colSpan = 0;
		                row.rowSpan = 1;
	
		                map[rowKey] = row;
		                parentRow = map[rootName + (Number(levelNum) - 1)];
	
		                if (parentRow) {
		                    children = parentRow.children;
	
		                    if (children[1] && children[1].attr.className.indexOf("k-alt") === -1) {
		                        row.notFirst = true;
		                    } else {
		                        row.notFirst = parentRow.notFirst;
		                    }
		                }
	
		                this.rows.splice(this._rowIndex(parentRow) + 1, 0, row);
		            } else {
		                row.notFirst = false;
	
		                if (!row.parentMember || row.parentMember !== parentMember) {
		                    row.parentMember = parentMember;
		                    row.collapsed = 0;
		                    row.colSpan = 0;
		                }
		            }
	
		            return row;
		        },
	
		        _measures: function(measures, tuple, className) {
		            var map = this.map;
		            var row = map.measureRow;
		            var measure;
	
		            if (!row) {
		                row = element("tr", null, []);
		                map.measureRow = row;
		                this.rows.push(row);
		            }
	
		            for (var idx = 0, length = measures.length; idx < length; idx++) {
		                measure = measures[idx];
		                row.children.push(this._cell((className || ""), [this._content(measure, tuple)], measure));
		            }
	
		            return length;
		        },
	
		        _content: function(member, tuple) {
		            return htmlNode(this.template({
		                member: member,
		                tuple: tuple
		            }));
		        },
	
		        _cell: function(className, children, member) {
		            var cell = element("th", { className: "k-header" + className }, children);
		            cell.value = member.caption || member.name;
		            return cell;
		        },
	
		        _buildRows: function(tuple, memberIdx, parentMember) {
		            var members = tuple.members;
		            var member = members[memberIdx];
		            var nextMember = members[memberIdx + 1];
	
		            var row, childRow, children, childrenLength;
		            var cell, allCell, cellAttr;
		            var cellChildren = [];
		            var path;
	
		            var idx = 0;
		            var metadata;
	
		            var colSpan;
		            var collapsed = 0;
		            var memberCollapsed = 0;
	
		            if (member.measure) {
		                this._measures(member.children, tuple);
		                return;
		            }
	
		            path = kendo.stringify(buildPath(tuple, memberIdx));
		            row = this._row(tuple, memberIdx, parentMember);
	
		            children = member.children;
		            childrenLength = children.length;
	
		            metadata = this.metadata[path];
		            if (!metadata) {
		                this.metadata[path] = metadata = createMetadata(Number(member.levelNum), memberIdx);
		                metadata.rootLevelNum = Number(this.rootTuple.members[memberIdx].levelNum);
		            }
	
		            this._indexes.push({
		                path: path,
		                tuple: tuple
		            });
	
		            if (member.hasChildren) {
		                if (metadata.expanded === false) {
		                    collapsed = metadata.maxChildren;
		                    row.collapsed += collapsed;
	
		                    metadata.children = 0;
		                    childrenLength = 0;
		                }
	
		                cellAttr = { className: "k-icon " + (childrenLength ? STATE_EXPANDED : STATE_COLLAPSED) };
		                cellAttr[kendo.attr("path")] = path;
	
		                cellChildren.push(element("span", cellAttr));
		            }
	
		            cellChildren.push(this._content(member, tuple));
		            cell = this._cell((row.notFirst ? " k-first" : ""), cellChildren, member);
	
		            row.children.push(cell);
		            row.colSpan += 1;
	
		            if (childrenLength) {
		                allCell = this._cell(" k-alt", [this._content(member, tuple)], member);
		                row.children.push(allCell);
	
		                for (; idx < childrenLength; idx++) {
		                    childRow = this._buildRows(children[idx], memberIdx, member);
		                }
	
		                colSpan = childRow.colSpan;
		                collapsed = childRow.collapsed;
	
		                cell.attr.colSpan = colSpan;
	
		                metadata.children = colSpan;
		                metadata.members = 1;
	
		                row.colSpan += colSpan;
		                row.collapsed += collapsed;
		                row.rowSpan = childRow.rowSpan + 1;
	
		                if (nextMember) {
		                    if (nextMember.measure) {
		                        colSpan = this._measures(nextMember.children, tuple, " k-alt");
		                    } else {
		                        childRow = this._buildRows(tuple, memberIdx + 1);
		                        colSpan = childRow.colSpan;
	
		                        row.collapsed += childRow.collapsed;
		                        memberCollapsed = childRow.collapsed;
		                    }
	
		                    allCell.attr.colSpan = colSpan;
		                    colSpan -= 1;
	
		                    metadata.members += colSpan;
		                    row.colSpan += colSpan;
		                }
		            } else if (nextMember) {
		                if (nextMember.measure) {
		                    colSpan = this._measures(nextMember.children, tuple);
		                } else {
		                    childRow = this._buildRows(tuple, memberIdx + 1);
		                    colSpan = childRow.colSpan;
	
		                    row.collapsed += childRow.collapsed;
		                    memberCollapsed = childRow.collapsed;
		                }
	
		                metadata.members = colSpan;
	
		                if (colSpan > 1) {
		                    cell.attr.colSpan = colSpan;
		                    row.colSpan += colSpan - 1;
		                }
		            }
	
		            if (metadata.maxMembers < (metadata.members + memberCollapsed)) {
		                metadata.maxMembers = metadata.members + memberCollapsed;
		            }
	
		            children = metadata.children + collapsed;
	
		            if (metadata.maxChildren < children) {
		                metadata.maxChildren = children;
		            }
	
		            (allCell || cell).tupleAll = true;
	
		            return row;
		        }
		    });
	
		    var RowBuilder = Class.extend({
		        init: function() {
		            this.metadata = {};
		        },
	
		        build: function(tuples) {
		            var tbody = this._tbody(tuples);
		            var colgroup = this._colGroup();
	
		            return [
		                element("table", null, [colgroup, tbody])
		            ];
		        },
	
		        reset: function() {
		            this.metadata = {};
		        },
	
		        _rowLength: function() {
		            var children = this.rows[0].children;
		            var length = 0;
		            var idx = 0;
	
		            var cell = children[idx];
	
		            while(cell) {
		                length += (cell.attr.colSpan || 1);
		                cell = children[++idx];
		            }
	
		            return length;
		        },
	
		        _colGroup: function() {
		            var length = this._rowLength();
		            var children = [];
		            var idx = 0;
	
		            for (; idx < length; idx++) {
		                children.push(element("col", null));
		            }
	
		            return element("colgroup", null, children);
		        },
	
		        _tbody: function(tuples) {
		            var root = tuples[0];
	
		            this.rootTuple = root;
		            this.rows = [];
		            this.map = {};
	
		            this._indexes = [];
	
		            if (root) {
		                this._buildRows(root, 0);
		                this._normalize();
		            } else {
		                this.rows.push(element("tr", null, [ element("td", null, [ htmlNode("&nbsp;") ]) ]));
		            }
	
		            return element("tbody", null, this.rows);
		        },
	
		        _normalize: function() {
		            var rows = this.rows;
		            var rowsLength = rows.length;
		            var rowIdx = 0;
	
		            var members = this.rootTuple.members;
		            var firstMemberName = members[0].name;
		            var membersLength = members.length;
		            var memberIdx = 0;
	
		            var row;
		            var cell;
		            var maxcolSpan;
		            var map = this.map;
		            var allRow;
	
		            for (; rowIdx < rowsLength; rowIdx++) {
		                row = rows[rowIdx];
	
		                for (memberIdx = 0; memberIdx < membersLength; memberIdx++) {
		                    maxcolSpan = this[members[memberIdx].name];
		                    cell = row.colSpan["dim" + memberIdx];
	
		                    if (cell && cell.colSpan < maxcolSpan) {
		                        cell.attr.colSpan = (maxcolSpan - cell.colSpan) + 1;
		                    }
		                }
		            }
	
		            row = map[firstMemberName];
		            allRow = map[firstMemberName + "all"];
	
		            if (row) {
		                row.children[0].attr.className = "k-first";
		            }
	
		            if (allRow) {
		                allRow.children[0].attr.className += " k-first";
		            }
		        },
	
		        _row: function(children) {
		            var row = element("tr", null, children);
		            row.rowSpan = 1;
		            row.colSpan = {};
	
		            this.rows.push(row);
	
		            return row;
		        },
	
		        _content: function(member, tuple) {
		            return htmlNode(this.template({
		                member: member,
		                tuple: tuple
		            }));
		        },
	
		        _cell: function(className, children, member) {
		            var cell = element("td", { className: className }, children);
		            cell.value = member.caption || member.name;
		            return cell;
		        },
	
		        _buildRows: function(tuple, memberIdx) {
		            var map = this.map;
		            var path;
	
		            var members = tuple.members;
		            var member = members[memberIdx];
		            var nextMember = members[memberIdx + 1];
	
		            var children = member.children;
		            var childrenLength = children.length;
	
		            var levelNum = Number(member.levelNum);
		            var rootName = this.rootTuple.members[memberIdx].name;
		            var tuplePath = buildPath(tuple, memberIdx - 1).join("");
		            var rootLevelNum = Number(this.rootTuple.members[memberIdx].levelNum);
		            var parentName = tuplePath + (rootLevelNum === levelNum ? "" : (member.parentName || ""));
		            var row = map[parentName + "all"] || map[parentName];
		            var colSpan = levelNum + 1;
	
		            var cell, allCell;
		            var childRow, allRow;
		            var metadata;
		            var className;
		            var cellChildren = [];
		            var expandIconAttr;
		            var idx;
	
		            if (!row || row.hasChild) {
		                row = this._row();
		            } else {
		                row.hasChild = true;
		            }
	
		            if (member.measure) {
		                className = row.allCell ? "k-grid-footer" : "";
		                row.children.push(this._cell(className, [ this._content(children[0], tuple) ], children[0]));
	
		                row.rowSpan = childrenLength;
	
		                for (idx = 1; idx < childrenLength; idx++) {
		                    this._row([ this._cell(className, [ this._content(children[idx], tuple) ], children[idx]) ]);
		                }
	
		                return row;
		            }
	
		            map[tuplePath + member.name] = row;
	
		            path = kendo.stringify(buildPath(tuple, memberIdx));
	
		            metadata = this.metadata[path];
		            if (!metadata) {
		                this.metadata[path] = metadata = createMetadata(levelNum, memberIdx);
		                metadata.rootLevelNum = rootLevelNum;
		            }
	
		            this._indexes.push({
		                path: path,
		                tuple: tuple
		            });
	
		            if (member.hasChildren) {
		                if (metadata.expanded === false) {
		                    childrenLength = 0;
		                    metadata.children = 0;
		                }
	
		                expandIconAttr = { className: "k-icon " + (childrenLength ? STATE_EXPANDED : STATE_COLLAPSED) };
		                expandIconAttr[kendo.attr("path")] = path;
	
		                cellChildren.push(element("span", expandIconAttr));
		            }
	
		            cellChildren.push(this._content(member, tuple));
	
		            className = row.allCell && !childrenLength ? "k-grid-footer" : "";
		            cell = this._cell(className, cellChildren, member);
		            cell.colSpan = colSpan;
	
		            row.children.push(cell);
		            row.colSpan["dim" + memberIdx] = cell;
	
		            if (!this[rootName] || this[rootName] < colSpan) {
		                this[rootName] = colSpan;
		            }
	
		            if (childrenLength) {
		                row.allCell = false;
		                row.hasChild = false;
	
		                for (idx = 0; idx < childrenLength; idx++) {
		                    childRow = this._buildRows(children[idx], memberIdx);
	
		                    if (row !== childRow) {
		                        row.rowSpan += childRow.rowSpan;
		                    }
		                }
	
		                if (row.rowSpan > 1) {
		                    cell.attr.rowSpan = row.rowSpan;
		                }
	
		                metadata.children = row.rowSpan;
	
		                allCell = this._cell("k-grid-footer", [this._content(member, tuple)], member);
		                allCell.colSpan = colSpan;
	
		                allRow = this._row([ allCell ]);
		                allRow.colSpan["dim" + memberIdx] = allCell;
		                allRow.allCell = true;
	
		                map[tuplePath + member.name + "all"] = allRow;
	
		                if (nextMember) {
		                    childRow = this._buildRows(tuple, memberIdx + 1);
		                    allCell.attr.rowSpan = childRow.rowSpan;
		                }
	
		                row.rowSpan += allRow.rowSpan;
	
		                metadata.members = allRow.rowSpan;
	
		            } else if (nextMember) {
		                row.hasChild = false;
		                this._buildRows(tuple, memberIdx + 1);
	
		                (allCell || cell).attr.rowSpan = row.rowSpan;
	
		                metadata.members = row.rowSpan;
		            }
	
		            if (metadata.maxChildren < metadata.children) {
		                metadata.maxChildren = metadata.children;
		            }
	
		            if (metadata.maxMembers < metadata.members) {
		                metadata.maxMembers = metadata.members;
		            }
	
		            return row;
		        }
		    });
	
		    var ContentBuilder = Class.extend({
		        init: function() {
		            this.columnAxis = {};
		            this.rowAxis = {};
		        },
	
		        build: function(data, columnAxis, rowAxis) {
		            var index = columnAxis.indexes[0];
		            var metadata = columnAxis.metadata[index ? index.path : undefined];
	
		            this.columnAxis = columnAxis;
		            this.rowAxis = rowAxis;
	
		            this.data = data;
	
		            this.rowLength = metadata ? metadata.maxChildren + metadata.maxMembers : columnAxis.measures.length || 1;
	
		            if (!this.rowLength) {
		                this.rowLength = 1;
		            }
	
		            var tbody = this._tbody();
		            var colgroup = this._colGroup();
	
		            return [
		                element("table", null, [colgroup, tbody])
		            ];
		        },
	
		        _colGroup: function() {
		            var length = this.columnAxis.measures.length || 1;
		            var children = [];
		            var idx = 0;
	
		            if (this.rows[0]) {
		                length = this.rows[0].children.length;
		            }
	
		            for (; idx < length; idx++) {
		                children.push(element("col", null));
		            }
	
		            return element("colgroup", null, children);
		        },
	
		        _tbody: function() {
		            this.rows = [];
	
		            if (this.data[0]) {
		                this.columnIndexes = this._indexes(this.columnAxis, this.rowLength);
		                this.rowIndexes = this._indexes(this.rowAxis, Math.ceil(this.data.length / this.rowLength));
	
		                this._buildRows();
		            } else {
		                this.rows.push(element("tr", null, [ element("td", null, [ htmlNode("&nbsp;") ]) ]));
		            }
	
		            return element("tbody", null, this.rows);
		        },
	
		        _indexes: function(axisInfo, total) {
		            var result = [];
		            var axisInfoMember;
		            var indexes = axisInfo.indexes;
		            var metadata = axisInfo.metadata;
		            var measures = axisInfo.measures;
		            var measuresLength = measures.length || 1;
	
		            var current;
		            var dataIdx = 0;
		            var firstEmpty = 0;
	
		            var idx = 0;
		            var length = indexes.length;
		            var measureIdx;
		            var index;
	
		            var children;
		            var skipChildren;
	
		            if (!length) {
		                for (measureIdx = 0; measureIdx < measuresLength; measureIdx++) {
		                    result[measureIdx] = {
		                        index: measureIdx,
		                        measure: measures[measureIdx],
		                        tuple: null
		                    };
		                }
	
		                return result;
		            }
	
		            for (; idx < length; idx++) {
		                axisInfoMember = indexes[idx];
		                current = metadata[axisInfoMember.path];
		                children = current.children + current.members;
		                skipChildren = 0;
	
		                if (children) {
		                    children -= measuresLength;
		                }
	
		                if (current.expanded === false && current.children !== current.maxChildren) {
		                    skipChildren = current.maxChildren;
		                }
	
		                if (current.parentMember && current.levelNum === current.rootLevelNum) {
		                    children = -1;
		                }
	
		                if (children > -1) {
		                    for (measureIdx = 0; measureIdx < measuresLength; measureIdx++) {
		                        index = children + measureIdx;
		                        if (!current.children) {
		                            index += firstEmpty;
		                        }
	
		                        result[children + firstEmpty + measureIdx] = {
		                            children: children,
		                            index: dataIdx,
		                            measure: measures[measureIdx],
		                            tuple: axisInfoMember.tuple
		                        };
		                        dataIdx += 1;
		                    }
	
		                    while(result[firstEmpty] !== undefined) {
		                        firstEmpty += 1;
		                    }
		                }
	
		                if (firstEmpty === total) {
		                    break;
		                }
	
		                dataIdx += skipChildren;
		            }
	
		            return result;
		        },
	
		        _buildRows: function() {
		            var rowIndexes = this.rowIndexes;
		            var length = rowIndexes.length;
		            var idx = 0;
	
		            for (; idx < length; idx++) {
		                var rowIndex = rowIndexes[idx];
		                if (rowIndex) {
		                    this.rows.push(this._buildRow(rowIndex));
		                }
		            }
		        },
	
		        _buildRow: function(rowInfo) {
		            var startIdx = rowInfo.index * this.rowLength;
		            var columnIndexes = this.columnIndexes;
		            var length = columnIndexes.length;
		            var columnInfo;
		            var cells = [];
		            var idx = 0;
	
		            var templateInfo;
		            var cell, cellContent;
		            var attr, dataItem, measure;
	
		            for (; idx < length; idx++) {
		                columnInfo = columnIndexes[idx];
	
		                if (columnInfo === undefined) {
		                    continue;
		                }
	
		                attr = {};
		                if (columnInfo.children) {
		                    attr.className = "k-alt";
		                }
	
		                cellContent = "";
		                dataItem = this.data[startIdx + columnInfo.index];
		                measure = columnInfo.measure || rowInfo.measure;
	
		                templateInfo = {
		                    columnTuple: columnInfo.tuple,
		                    rowTuple: rowInfo.tuple,
		                    measure: measure,
		                    dataItem: dataItem
		                };
	
		                if (dataItem.value !== "" && measure && measure.type) {
		                    if (measure.type === "status") {
		                        cellContent = this.kpiStatusTemplate(templateInfo);
		                    } else if (measure.type === "trend") {
		                        cellContent = this.kpiTrendTemplate(templateInfo);
		                    }
		                }
	
		                if (!cellContent) {
		                    cellContent = this.dataTemplate(templateInfo);
		                }
	
		                cell = element("td", attr, [ htmlNode(cellContent) ]);
		                cell.value = dataItem.value;
		                cells.push(cell);
		            }
	
		            attr = {};
		            if (rowInfo.children) {
		                attr.className = "k-grid-footer";
		            }
	
		            return element("tr", attr, cells);
		        }
		    });
	
		    ui.plugin(PivotGrid);
	
		    kendo.PivotExcelExporter = kendo.Class.extend({
		        init: function(options) {
		            this.options = options;
	
		            this.widget = options.widget;
		            this.dataSource = this.widget.dataSource;
		        },
	
		        _columns: function() {
		            var columnHeaderTable = this.widget.columnsHeaderTree.children[0];
		            var rowHeaderTable = this.widget.rowsHeaderTree.children[0];
	
		            var columnHeaderLength = columnHeaderTable.children[0].children.length;
		            var rowHeaderLength = rowHeaderTable.children[0].children.length;
	
		            var width = this.widget.options.columnWidth;
		            var result = [];
		            var idx;
	
		            if (rowHeaderLength && this.dataSource.data()[0]) {
		                for (idx = 0; idx < rowHeaderLength; idx++) {
		                    result.push({
		                        autoWidth: true
		                    });
		                }
		            }
	
		            for (idx = 0; idx < columnHeaderLength; idx++) {
		                result.push({
		                    autoWidth: false,
		                    width: width
		                });
		            }
	
		            return result;
		        },
	
		        _cells: function(rows, type, callback) {
		            var result = [];
	
		            var i = 0;
		            var length = rows.length;
	
		            var cellsLength;
		            var row, cells;
		            var j, cell;
	
		            for (; i < length; i++) {
		                row = [];
		                cells = rows[i].children;
		                cellsLength = cells.length;
	
		                for (j = 0; j < cellsLength; j++) {
		                    cell = cells[j];
	
		                    row.push({
		                        background: "#7a7a7a",
		                        color: "#fff",
		                        value: cell.value,
		                        colSpan: cell.attr.colSpan || 1,
		                        rowSpan: cell.attr.rowSpan || 1
		                    });
		                }
	
		                if (callback) {
		                    callback(row, i);
		                }
	
		                result.push({
		                    cells: row,
		                    type: type
		                });
		            }
	
		            return result;
		        },
	
		        _rows: function() {
		            var columnHeaderTable = this.widget.columnsHeaderTree.children[0];
		            var rowHeaderTable = this.widget.rowsHeaderTree.children[0];
	
		            var columnHeaderLength = columnHeaderTable.children[0].children.length;
		            var rowHeaderLength = rowHeaderTable.children[0].children.length;
	
		            var columnHeaderRows = columnHeaderTable.children[1].children;
		            var rowHeaderRows = rowHeaderTable.children[1].children;
		            var contentRows = this.widget.contentTree.children[0].children[1].children;
	
		            var columnRows = this._cells(columnHeaderRows, "header");
	
		            if (rowHeaderLength) {
		                columnRows[0].cells.splice(0, 0, {
		                    background: "#7a7a7a",
		                    color: "#fff",
		                    value: "",
		                    colSpan: rowHeaderLength,
		                    rowSpan: columnHeaderRows.length
		                });
		            }
	
		            var dataCallback = function(row, index) {
		                var j = 0;
		                var cell, value;
		                var cells = contentRows[index].children;
	
		                for (; j < columnHeaderLength; j++) {
		                    cell = cells[j];
		                    value = Number(cell.value);
	
		                    if (isNaN(value)) {
		                        value = cell.value;
		                    }
	
		                    row.push({
		                        background: "#dfdfdf",
		                        color: "#333",
		                        value: value,
		                        colSpan: 1,
		                        rowSpan: 1
		                    });
		                }
		            };
	
		            var rowRows = this._cells(rowHeaderRows, "data", dataCallback);
	
		            return columnRows.concat(rowRows);
		        },
	
		        _freezePane: function() {
		            var columnHeaderTable = this.widget.columnsHeaderTree.children[0];
		            var rowHeaderTable = this.widget.rowsHeaderTree.children[0];
	
		            var rowHeaderLength = rowHeaderTable.children[0].children.length;
		            var columnHeaderRows = columnHeaderTable.children[1].children;
	
		            return {
		                colSplit: rowHeaderLength,
		                rowSplit: columnHeaderRows.length
		            };
		        },
	
		        workbook: function() {
		            var promise;
	
		            if (this.dataSource.view()[0]) {
		                promise = $.Deferred();
		                promise.resolve();
		            } else {
		                promise = this.dataSource.fetch();
		            }
	
		            return promise.then($.proxy(function() {
		                return {
		                    sheets: [ {
		                       columns: this._columns(),
		                       rows: this._rows(),
		                       freezePane: this._freezePane(),
		                       filter: null
		                    } ]
		                };
		            }, this));
		        }
		    });
	
		    var PivotExcelMixin = {
		        extend: function(proto) {
		           proto.events.push("excelExport");
		           proto.options.excel = $.extend(proto.options.excel, this.options);
		           proto.saveAsExcel = this.saveAsExcel;
		        },
		        options: {
		            proxyURL: "",
		            filterable: false,
		            fileName: "Export.xlsx"
		        },
		        saveAsExcel: function() {
		            var excel = this.options.excel || {};
	
		            var exporter = new kendo.PivotExcelExporter({
		                widget: this
		            });
	
		            exporter.workbook().then($.proxy(function(book) {
		                if (!this.trigger("excelExport", { workbook: book })) {
		                    var workbook = new kendo.ooxml.Workbook(book);
	
		                    workbook.toDataURLAsync().then(function(dataURI) {
		                        kendo.saveAs({
		                            dataURI: dataURI,
		                            fileName: book.fileName || excel.fileName,
		                            proxyURL: excel.proxyURL,
		                            forceProxy: excel.forceProxy
		                        });
		                    });
		                }
		            }, this));
		        }
		    };
	
		    kendo.PivotExcelMixin = PivotExcelMixin;
	
		    if (kendo.ooxml && kendo.ooxml.Workbook) {
		        PivotExcelMixin.extend(PivotGrid.prototype);
		    }
	
		    if (kendo.PDFMixin) {
		        kendo.PDFMixin.extend(PivotGrid.prototype);
	
		        PivotGrid.fn._drawPDF = function() {
		            return this._drawPDFShadow({
		                width: this.wrapper.width()
		            }, {
		                avoidLinks: this.options.pdf.avoidLinks
		            });
		        };
		    }
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1283);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1278:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(637);
	
	/***/ }),
	
	/***/ 1283:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1278) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "scheduler.dayview",
		    name: "Scheduler Day View",
		    category: "web",
		    description: "The Scheduler Day View",
		    depends: [ "scheduler.view" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        browser = kendo.support.browser,
		        setTime = kendo.date.setTime,
		        SchedulerView = ui.SchedulerView,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        extend = $.extend,
		        proxy = $.proxy,
		        getDate = kendo.date.getDate,
		        MS_PER_MINUTE = kendo.date.MS_PER_MINUTE,
		        MS_PER_DAY = kendo.date.MS_PER_DAY,
		        CURRENT_TIME_MARKER_CLASS = "k-current-time",
		        CURRENT_TIME_MARKER_ARROW_CLASS = "k-current-time-arrow",
		        BORDER_SIZE_COEFF = 0.8666,
		        getMilliseconds = kendo.date.getMilliseconds,
		        NS = ".kendoMultiDayView";
	
		    var DAY_VIEW_EVENT_TEMPLATE = kendo.template('<div title="(#=kendo.format("{0:t} - {1:t}", start, end)#): #=title.replace(/"/g,"&\\#34;")#">' +
		                    '<div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div>' +
		                    '<div class="k-event-template">${title}</div>' +
		                '</div>'),
		        DAY_VIEW_ALL_DAY_EVENT_TEMPLATE = kendo.template('<div title="(#=kendo.format("{0:t}", start)#): #=title.replace(/"/g,"&\\#34;")#">' +
		                    '<div class="k-event-template">${title}</div>' +
		                '</div>'),
		        DATA_HEADER_TEMPLATE = kendo.template("<span class='k-link k-nav-day'>#=kendo.toString(date, 'ddd M/dd')#</span>"),
		        ALLDAY_EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" ' +
		                'data-#=ns#uid="#=uid#"' +
		                '#if (resources[0]) { #' +
		                    'style="background-color:#=resources[0].color#; border-color: #=resources[0].color#"' +
		                    'class="k-event#=inverseColor ? " k-event-inverse" : ""#" ' +
		                '#} else {#' +
		                    'class="k-event"' +
		                '#}#' +
		                '>' +
		                '<span class="k-event-actions">' +
		                    '# if(data.tail || data.middle) {#' +
		                        '<span class="k-icon k-i-arrow-60-left"></span>' +
		                    '#}#' +
		                    '# if(data.isException()) {#' +
		                        '<span class="k-icon k-i-non-recurrence"></span>' +
		                    '# } else if(data.isRecurring()) {#' +
		                        '<span class="k-icon k-i-reload"></span>' +
		                    '# } #' +
		                '</span>' +
		                '{0}' +
		                '<span class="k-event-actions">' +
		                    '#if (showDelete) {#' +
		                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
		                    '#}#' +
		                    '# if(data.head || data.middle) {#' +
		                        '<span class="k-icon k-i-arrow-60-right"></span>' +
		                    '#}#' +
		                '</span>' +
		                '#if(resizable && !singleDay && !data.tail && !data.middle){#' +
		                '<span class="k-resize-handle k-resize-w"></span>' +
		                '#}#' +
		                '#if(resizable && !singleDay && !data.head && !data.middle){#' +
		                '<span class="k-resize-handle k-resize-e"></span>' +
		                '#}#' +
		                '</div>',
		        EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" ' +
		                'data-#=ns#uid="#=uid#" ' +
		                '#if (resources[0]) { #' +
		                    'style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"' +
		                    'class="k-event#=inverseColor ? " k-event-inverse" : ""#"' +
		                '#} else {#' +
		                    'class="k-event"' +
		                '#}#' +
		                '>' +
		                 '<span class="k-event-actions">' +
		                    '# if(data.isException()) {#' +
		                        '<span class="k-icon k-i-non-recurrence"></span>' +
		                    '# } else if(data.isRecurring()) {#' +
		                        '<span class="k-icon k-i-reload"></span>' +
		                    '# } #' +
		                '</span>' +
		                '{0}' +
		                '<span class="k-event-actions">' +
		                    '#if (showDelete) {#' +
		                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
		                    '#}#' +
		                '</span>' +
		                '<span class="k-event-top-actions">' +
		                    '# if(data.tail || data.middle) {#' +
		                    '<span class="k-icon k-i-arrow-60-up"></span>' +
		                    '# } #' +
		                '</span>' +
		                '<span class="k-event-bottom-actions">' +
		                    '# if(data.head || data.middle) {#' +
		                        '<span class="k-icon k-i-arrow-60-down"></span>' +
		                    '# } #' +
		                '</span>' +
		                '# if(resizable && !data.tail && !data.middle) {#' +
		                '<span class="k-resize-handle k-resize-n"></span>' +
		                '# } #' +
		                '# if(resizable && !data.head && !data.middle) {#' +
		                    '<span class="k-resize-handle k-resize-s"></span>' +
		                '# } #' +
		                '</div>';
	
		    function toInvariantTime(date) {
		        var staticDate = new Date(1980, 1, 1, 0, 0, 0);
		        setTime(staticDate, getMilliseconds(date));
		        return staticDate;
		    }
	
		    function isInDateRange(value, min, max) {
		        return value >= min && value <= max;
		    }
	
		    function isInTimeRange(value, min, max, overlaps) {
		        overlaps = overlaps ? value <= max : value < max;
		        return value > min && overlaps;
		    }
	
		    function addContinuousEvent(group, range, element, isAllDay) {
		        var events = group._continuousEvents;
		        var lastEvent = events[events.length - 1];
		        var startDate = getDate(range.start.startDate()).getTime();
	
		        //this handles all day event which is over multiple slots but starts
		        //after one of the time events
		        if (isAllDay && lastEvent &&
		            getDate(lastEvent.start.startDate()).getTime() == startDate) {
	
		                var idx = events.length - 1;
		                for ( ; idx > -1; idx --) {
		                    if (events[idx].isAllDay ||
		                        getDate(events[idx].start.startDate()).getTime() < startDate) {
		                            break;
		                        }
		                }
	
		                events.splice(idx + 1, 0, {
		                    element: element,
		                    isAllDay: true,
		                    uid: element.attr(kendo.attr("uid")),
		                    start: range.start,
		                    end: range.end
		                });
		            } else {
		                events.push({
		                    element: element,
		                    isAllDay: isAllDay,
		                    uid: element.attr(kendo.attr("uid")),
		                    start: range.start,
		                    end: range.end
		                });
		            }
		    }
	
		    function getWorkDays(options) {
		        var workDays = [];
		        var dayIndex = options.workWeekStart % 7;
		        var workWeekEnd = Math.abs(options.workWeekEnd % 7);
	
		        workDays.push(dayIndex);
	
		        while(workWeekEnd != dayIndex) {
		            if(dayIndex > 6 ) {
		                dayIndex -= 7;
		            } else {
		                dayIndex++;
		            }
		            workDays.push(dayIndex);
		        }
		        return workDays;
		    }
	
		    var MultiDayView = SchedulerView.extend({
		        init: function(element, options) {
		            var that = this;
	
		            SchedulerView.fn.init.call(that, element, options);
	
		            that.title = that.options.title || that.options.name;
	
		            that._workDays = getWorkDays(that.options);
	
		            that._templates();
	
		            that._editable();
	
		            that.calculateDateRange();
	
		            that._groups();
	
		            that._currentTime(true);
		        },
	
		        _currentTimeMarkerUpdater: function() {
		            this._updateCurrentTimeMarker(new Date());
		        },
	
		        _updateCurrentTimeMarker: function(currentTime) {
		            var options = this.options;
	
		            if(options.currentTimeMarker.useLocalTimezone === false) {
		                var timezone = options.dataSource.options.schema.timezone;
	
		                if(options.dataSource && timezone) {
		                   var timezoneOffset = kendo.timezone.offset(currentTime, timezone);
		                   currentTime = kendo.timezone.convert(currentTime, currentTime.getTimezoneOffset(), timezoneOffset);
		                }
		            }
	
		            this.times.find("." + CURRENT_TIME_MARKER_CLASS).remove();
		            this.content.find("." + CURRENT_TIME_MARKER_CLASS).remove();
	
		            var groupsCount = !options.group || options.group.orientation == "horizontal" ? 1 : this.groups.length;
		            var firstTimesCell = this.times.find("tr:first th:first");
		            var lastTimesCell = this.times.find("tr:first th:last");
	
		            for(var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
		                var currentGroup = this.groups[groupIndex];
	
		                if (!currentGroup) {
		                    return;
		                }
	
		                var utcCurrentTime = kendo.date.toUtcTime(currentTime);
		                var ranges = currentGroup.timeSlotRanges(utcCurrentTime, utcCurrentTime + 1);
	
		                if(ranges.length === 0) {
		                    return;
		                }
	
		                var collection = ranges[0].collection;
		                var slotElement = collection.slotByStartDate(currentTime);
	
		                if(slotElement) {
		                    var elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";
		                    var timesTableMarker = $(elementHtml).prependTo(this.times);
		                    var markerTopPosition = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).top);
		                    var timesTableMarkerCss = {};
		                    var markerWidth = this.content[0].scrollWidth;
		                    if(browser.msie || browser.edge) {
		                        markerWidth -= 1;
		                    }
	
		                    if (this._isRtl) {
		                        timesTableMarkerCss.right = firstTimesCell.position().left + outerHeight(firstTimesCell) - outerHeight(lastTimesCell);
		                        timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-left");
		                    } else {
		                        timesTableMarkerCss.left = lastTimesCell.position().left;
		                        timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-right");
		                    }
	
		                    timesTableMarkerCss.top = markerTopPosition - (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2);
	
		                    timesTableMarker.css(timesTableMarkerCss);
	
		                    $(elementHtml).prependTo(this.content).css({
		                        top: markerTopPosition,
		                        height: "1px",
		                        right: 0,
		                        width: markerWidth,
		                        left: 0
		                    });
		                }
		            }
		        },
	
		        _currentTime: function(setUpdateTimer) {
		            var that = this;
		            var markerOptions = that.options.currentTimeMarker;
	
		            if (markerOptions !== false && markerOptions.updateInterval !== undefined) {
		                that._currentTimeMarkerUpdater();
	
		                if (setUpdateTimer) {
		                    that._currentTimeUpdateTimer = setInterval(proxy(this._currentTimeMarkerUpdater, that), markerOptions.updateInterval);
		                }
		            }
		        },
	
		        _updateResizeHint: function(event, groupIndex, startTime, endTime) {
		            var multiday = event.isMultiDay();
	
		            var group = this.groups[groupIndex];
	
		            var ranges = group.ranges(startTime, endTime, multiday, event.isAllDay);
		            var width, height, top, hint;
	
		            this._removeResizeHint();
	
		            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
		                var range = ranges[rangeIndex];
		                var start = range.startSlot();
	
		                if (this._isGroupedByDate() && multiday) {
		                    for (var slotIdx = start.index; slotIdx <= range.end.index; slotIdx++) {
		                        var slot = range.collection._slots[slotIdx];
		                        width = slot.offsetWidth;
		                        height = slot.clientHeight;
		                        top = slot.offsetTop;
	
		                        hint = SchedulerView.fn._createResizeHint.call(this,
		                            slot.offsetLeft,
		                            top,
		                            width,
		                            height
		                        );
	
		                        this._resizeHint = this._resizeHint.add(hint);
		                    }
		                } else {
		                    width = start.offsetWidth;
		                    height = start.clientHeight;
		                    top = start.offsetTop;
	
		                    if (multiday) {
		                        width = range.innerWidth();
		                    } else {
		                        var rect = range.outerRect(startTime, endTime, this.options.snap);
		                        top = rect.top;
		                        height = rect.bottom - rect.top;
		                    }
	
		                    hint = SchedulerView.fn._createResizeHint.call(this,
		                        start.offsetLeft,
		                        top,
		                        width,
		                        height
		                    );
	
		 	               this._resizeHint = this._resizeHint.add(hint);
		                }
		            }
	
		            var format = "t";
		            var container = this.content;
	
		            if (multiday) {
		                format = "M/dd";
		                container = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div");
		                if (!container.length) {
		                    container = this.content;
		                }
		            }
	
		            this._resizeHint.appendTo(container);
	
		            this._resizeHint.find(".k-label-top,.k-label-bottom").text("");
	
		            this._resizeHint.first().addClass("k-first").find(".k-label-top").text(kendo.toString(kendo.timezone.toLocalDate(startTime), format));
	
		            this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(kendo.toString(kendo.timezone.toLocalDate(endTime), format));
		        },
	
		        _updateMoveHint: function (event, groupIndex, distance) {
		            var multiday = event.isMultiDay();
	
		            var group = this.groups[groupIndex];
	
		            var start = kendo.date.toUtcTime(event.start) + distance;
	
		            var end = start + event.duration();
	
		            var ranges = group.ranges(start, end, multiday, event.isAllDay);
	
		            start = kendo.timezone.toLocalDate(start);
	
		            end = kendo.timezone.toLocalDate(end);
	
		            this._removeMoveHint(event.uid);
	
		            if (!multiday && (getMilliseconds(end) === 0 || getMilliseconds(end) < getMilliseconds(this.startTime()))) {
		                if (ranges.length > 1) {
		                    ranges.pop();
		                }
		            }
	
		            var eventHint = $();
	
		            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
		                var range = ranges[rangeIndex];
		                var startSlot = range.start;
		                var hint;
		                var css = {
		                    left: startSlot.offsetLeft + 2,
		                    top: startSlot.offsetTop
		                };
	
		                if (this._isGroupedByDate() && multiday) {
		                    for (var slotIdx = startSlot.index; slotIdx <= range.end.index; slotIdx++) {
		                        var slot = range.collection._slots[slotIdx];
	
		                        css.left = this._isRtl ? slot.clientWidth * 0.1 + slot.offsetLeft + 2 : slot.offsetLeft + 2;
		                        css.height = slot.offsetHeight;
		                        css.width = slot.clientWidth * 0.9 - 4;
	
		                        hint = this._createEventElement(event.clone({ start: start, end: end }), !multiday);
	
		                        this._appendMoveHint(hint, css);
		                        eventHint = eventHint.add(hint);
		                    }
		                } else {
		                    if (this._isRtl) {
		                       css.left = startSlot.clientWidth * 0.1 + startSlot.offsetLeft + 2;
		                    }
	
		                    if (multiday) {
		                        css.width = range.innerWidth() - 4;
		                    } else {
		                        var rect = range.outerRect(start, end, this.options.snap);
		                        css.top = rect.top;
		                        css.height = rect.bottom - rect.top;
		                        css.width = startSlot.clientWidth * 0.9 - 4;
		                    }
	
		                      hint = this._createEventElement(event.clone({ start: start, end: end }), !multiday);
	
		                      this._appendMoveHint(hint, css);
		                      eventHint = eventHint.add(hint);
		                }
		            }
	
		            var content = this.content;
	
		            if (multiday) {
		                content = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div");
		                if (!content.length) {
		                    content = this.content;
		                }
		            }
	
		            eventHint.appendTo(content);
		        },
	
		        _appendMoveHint: function(hint, css) {
		            hint.addClass("k-event-drag-hint");
		            hint.css(css);
	
		            this._moveHint = this._moveHint.add(hint);
		       },
	
		       _slotByPosition: function(x, y) {
		           var slot, offset;
	
		           if (this._isVerticallyGrouped()) {
		               offset = this.content.offset();
		               y += this.content[0].scrollTop;
		               x += this.content[0].scrollLeft;
		           } else {
		               offset = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day)").find(">div").offset();
		           }
	
		           if (offset) {
		               x -= offset.left;
		               y -= offset.top;
		           }
	
		           x = Math.ceil(x);
		           y = Math.ceil(y);
	
		           var group;
		           var groupIndex;
	
		           for (groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
		                group = this.groups[groupIndex];
	
		                slot = group.daySlotByPosition(x, y, this._isGroupedByDate());
	
		                if (slot) {
		                    return slot;
		                }
		           }
	
		           if (offset) {
		               x += offset.left;
		               y += offset.top;
		           }
	
		           offset = this.content.offset();
	
		           x -= offset.left;
		           y -= offset.top;
	
		           if (!this._isVerticallyGrouped()) {
		               y += this.content[0].scrollTop;
		               x += this.content[0].scrollLeft;
		           }
	
		           x = Math.ceil(x);
		           y = Math.ceil(y);
	
		           for (groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
		                group = this.groups[groupIndex];
	
		                slot = group.timeSlotByPosition(x, y);
	
		                if (slot) {
		                    return slot;
		                }
		           }
	
		           return null;
		       },
	
		       _groupCount: function() {
		            var resources = this.groupedResources;
		            var byDate = this._isGroupedByDate();
	
		            if (resources.length) {
		                if (this._groupOrientation() === "vertical") {
		                    if (byDate) {
		                        return this._columnCountForLevel(resources.length - 1);
		                    } else {
		                        return this._rowCountForLevel(resources.length - 1);
		                    }
		                } else {
		                    if (byDate) {
		                        return this._columnCountForLevel(resources.length) / this._columnCountForLevel(0);
		                    } else {
		                          return this._columnCountForLevel(resources.length) / this._columnOffsetForResource(resources.length);
		                    }
		                }
		            }
		            return 1;
		        },
	
		        _columnCountInResourceView: function() {
		            var resources = this.groupedResources;
		            var byDate = this._isGroupedByDate();
	
		            if (!resources.length || this._isVerticallyGrouped()) {
		                if (byDate) {
		                     return this._rowCountForLevel(0);
		                } else {
		                     return this._columnCountForLevel(0);
		                }
		            }
	
		            if (byDate) {
		                return this._columnCountForLevel(0);
		            } else {
		                return this._columnOffsetForResource(resources.length);
		            }
		        },
	
		        _timeSlotGroups: function(groupCount, columnCount) {
		            var interval = this._timeSlotInterval();
		            var verticalViews = groupCount;
		            var byDate = this._isGroupedByDate();
		            var tableRows = this.content.find("tr:not(.k-scheduler-header-all-day)");
		            var group, time, rowIndex, cellIndex;
	
		            tableRows.attr("role", "row");
	
		            var rowCount = tableRows.length;
	
		            if (this._isVerticallyGrouped()) {
		                if (byDate) {
		                    verticalViews = columnCount;
		                }
		                rowCount = Math.floor(rowCount / verticalViews);
		            }
	
		            for (var groupIndex = 0; groupIndex < verticalViews; groupIndex++) {
		                var rowMultiplier = 0;
		                var cellMultiplier = 0;
	
		                if (this._isVerticallyGrouped()) {
		                    rowMultiplier = groupIndex;
		                } else{
		                    cellMultiplier = groupIndex;
		                }
	
		                rowIndex = rowMultiplier * rowCount;
	
		              while (rowIndex < (rowMultiplier + 1) * rowCount) {
		                    var cells = tableRows[rowIndex].children;
	
		                    if (rowIndex % rowCount === 0) {
		                        time = getMilliseconds(new Date(+this.startTime()));
		                    }
	
		                    var timeIndex = 0;
		                    if(byDate){
		                        if (this._isVerticallyGrouped()) {
		                            for (cellIndex = 0; cellIndex < groupCount; cellIndex++) {
		                                group = this.groups[cellIndex];
		                                this._addTimeSlotGroup(group, cells, cellIndex, time, interval, groupIndex);
		                            }
		                        } else {
		                            group = this.groups[groupIndex];
		                            for (cellIndex = cellMultiplier; cellIndex < groupCount * columnCount; cellIndex=cellIndex + groupCount) {
		                                this._addTimeSlotGroup(group, cells, cellIndex, time, interval, timeIndex);
		                                timeIndex++;
		                            }
		                        }
		                    } else {
		                        group = this.groups[groupIndex];
		                        for (cellIndex = cellMultiplier * columnCount; cellIndex < (cellMultiplier + 1) * columnCount; cellIndex++) {
	
		                            this._addTimeSlotGroup(group, cells, cellIndex, time, interval,  timeIndex);
		                             timeIndex++;
		                        }
		                    }
	
		                    time += interval;
		                    rowIndex ++;
		                }
		            }
		        },
	
		        _addTimeSlotGroup: function(group, cells, cellIndex, time, interval, timeIndex) {
		              var cell = cells[cellIndex];
		              var collection = group.getTimeSlotCollection(timeIndex);
		              var currentDate = this._dates[timeIndex];
		              if(!currentDate){
		                  return;
		              }
		              var currentTime = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
		              var start = currentTime + time;
		              var end = start + interval;
	
		              cell.setAttribute("role", "gridcell");
		              cell.setAttribute("aria-selected", false);
	
		              collection.addTimeSlot(cell, start, end);
		        },
	
		         _addDaySlotGroup: function(collection, cells, cellIndex, columnCount, cellCount) {
		                var cell = cells[cellIndex];
		                var start = this._dates[cellCount];
		                if(!start){
		                    return;
		                }
		                var currentTime = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
	
		                cell.setAttribute("role", "gridcell");
		                cell.setAttribute("aria-selected", false);
		                collection.addDaySlot(cell, currentTime, currentTime + kendo.date.MS_PER_DAY);
		        },
	
		        _daySlotGroups: function(groupCount, columnCount) {
		            var tableRows, cellIndex;
		            var verticalViews = groupCount;
		            var byDate = this._isGroupedByDate();
	
		            if (this._isVerticallyGrouped()) {
		                if (byDate) {
		                    verticalViews = columnCount;
		                }
		                tableRows = this.element.find(".k-scheduler-header-all-day");
		            } else {
		                tableRows = this.element.find(".k-scheduler-header-all-day tr");
		            }
	
		            tableRows.attr("role", "row");
	
		            for (var groupIndex = 0; groupIndex < verticalViews; groupIndex++) {
		                var rowMultiplier = 0;
		                var group, collection;
	
		                if (this._isVerticallyGrouped()) {
		                    rowMultiplier = groupIndex;
		                }
	
		                var cells = tableRows[rowMultiplier].children;
		                var cellMultiplier = 0;
	
		                if (!this._isVerticallyGrouped()) {
		                    cellMultiplier = groupIndex;
		                }
	
		                var cellCount = 0;
		                if(byDate){
		                    if (this._isVerticallyGrouped()) {
		                        for (cellIndex = 0; cellIndex < groupCount; cellIndex++) {
		                            group = this.groups[cellIndex];
		                            collection = group.getDaySlotCollection(0);
		                            this._addDaySlotGroup(collection, cells, cellIndex, columnCount, groupIndex);
		                        }
		                    } else {
		                        group = this.groups[groupIndex];
		                        collection = group.getDaySlotCollection(0);
		                        for (cellIndex = cellMultiplier; cellIndex < groupCount * columnCount; cellIndex = cellIndex + groupCount) {
		                            this._addDaySlotGroup(collection, cells, cellIndex, columnCount, cellCount);
		                            cellCount++;
		                        }
		                    }
		                } else {
		                    group = this.groups[groupIndex];
		                    collection = group.getDaySlotCollection(0);
		                    for (cellIndex = cellMultiplier * columnCount; cellIndex < (cellMultiplier + 1) * columnCount; cellIndex++) {
	
		                        this._addDaySlotGroup(collection, cells, cellIndex, columnCount, cellCount);
		                        cellCount++;
		                    }
		                }
		            }
		        },
	
		        _groups: function() {
		            var groupCount = this._groupCount();
		            var columnCount = this._columnCountInResourceView();
	
		            this.groups = [];
	
		            for (var idx = 0; idx < groupCount; idx++) {
		                var view = this._addResourceView(idx);
	
		                for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
		                    if(this._dates[columnIndex]){
		                        view.addTimeSlotCollection(this._dates[columnIndex], kendo.date.addDays(this._dates[columnIndex], 1));
		                    }
		                }
	
		                if (this.options.allDaySlot) {
		                    view.addDaySlotCollection(this._dates[0], kendo.date.addDays(this._dates[this._dates.length - 1], 1));
		                }
		            }
	
		            this._timeSlotGroups(groupCount, columnCount);
	
		            if (this.options.allDaySlot) {
		                this._daySlotGroups(groupCount, columnCount);
		            }
		        },
	
		        options: {
		            name: "MultiDayView",
		            selectedDateFormat: "{0:D}",
		            selectedShortDateFormat: "{0:d}",
		            allDaySlot: true,
		            showWorkHours: false,
		            title: "",
		            startTime: kendo.date.today(),
		            endTime: kendo.date.today(),
		            minorTickCount: 2,
		            majorTick: 60,
		            majorTimeHeaderTemplate: "#=kendo.toString(date, 't')#",
		            minorTimeHeaderTemplate: "&\\#8203;",
		            groupHeaderTemplate: "#=text#",
		            slotTemplate: "&nbsp;",
		            allDaySlotTemplate: "&nbsp;",
		            eventTemplate: DAY_VIEW_EVENT_TEMPLATE,
		            allDayEventTemplate: DAY_VIEW_ALL_DAY_EVENT_TEMPLATE,
		            dateHeaderTemplate: DATA_HEADER_TEMPLATE,
		            editable: true,
		            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
		            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
		            workWeekStart: 1,
		            workWeekEnd: 5,
		            footer: {
		                command: "workDay"
		            },
		            messages: {
		                allDay: "all day",
		                showFullDay: "Show full day",
		                showWorkDay: "Show business hours"
		            },
		            currentTimeMarker: {
		                 updateInterval: 10000,
		                 useLocalTimezone: true
		            }
		        },
	
		        events: ["remove", "add", "edit"],
	
		        _templates: function() {
		            var options = this.options,
		                settings = extend({}, kendo.Template, options.templateSettings);
	
		            this.eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_STRING);
		            this.allDayEventTemplate = this._eventTmpl(options.allDayEventTemplate, ALLDAY_EVENT_WRAPPER_STRING);
	
		            this.majorTimeHeaderTemplate = kendo.template(options.majorTimeHeaderTemplate, settings);
		            this.minorTimeHeaderTemplate = kendo.template(options.minorTimeHeaderTemplate, settings);
		            this.dateHeaderTemplate = kendo.template(options.dateHeaderTemplate, settings);
		            this.slotTemplate = kendo.template(options.slotTemplate, settings);
		            this.allDaySlotTemplate = kendo.template(options.allDaySlotTemplate, settings);
		            this.groupHeaderTemplate = kendo.template(options.groupHeaderTemplate, settings);
		        },
	
		        _editable: function() {
		            if (this.options.editable) {
		                if (this._isMobile()) {
		                    this._touchEditable();
		                } else {
		                    this._mouseEditable();
		                }
		            }
		        },
	
		        _mouseEditable: function() {
		            var that = this;
		            that.element.on("click" + NS, ".k-event a:has(.k-i-close)", function(e) {
		                that.trigger("remove", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
		                e.preventDefault();
		            });
	
		            if (that.options.editable.create !== false) {
		                that.element.on("dblclick" + NS, ".k-scheduler-content td", function(e) {
		                    if (!$(this).parent().hasClass("k-scheduler-header-all-day")) {
		                        var slot = that._slotByPosition(e.pageX, e.pageY);
	
		                        if (slot) {
		                            var resourceInfo = that._resourceBySlot(slot);
		                            that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
		                        }
	
		                        e.preventDefault();
		                    }
		                }).on("dblclick" + NS, ".k-scheduler-header-all-day td", function(e) {
		                    var slot = that._slotByPosition(e.pageX, e.pageY);
		                    if (slot) {
		                        var resourceInfo = that._resourceBySlot(slot);
		                        that.trigger("add", { eventInfo: extend({}, { isAllDay: true, start: kendo.date.getDate(slot.startDate()), end: kendo.date.getDate(slot.startDate()) }, resourceInfo) });
		                    }
		                    e.preventDefault();
		                });
		            }
	
		            if (that.options.editable.update !== false) {
		                that.element.on("dblclick" + NS, ".k-event", function(e) {
		                    that.trigger("edit", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
		                    e.preventDefault();
		                });
		            }
		        },
	
		        _touchEditable: function() {
		            var that = this;
		            var threshold = 0;
	
		            if (kendo.support.mobileOS.android) {
		                threshold = 5;
		            }
	
		            if (that.options.editable.create !== false) {
		                that._addUserEvents = new kendo.UserEvents(that.element, {
		                    threshold: threshold,
		                    filter:  ".k-scheduler-content td",
		                    useClickAsTap: !kendo.support.browser.edge,
		                    tap: function(e) {
		                        if (that._scrolling) {
		                            return;
		                        }
		                        if (!$(e.target).parent().hasClass("k-scheduler-header-all-day")) {
		                            var x = e.x.location !== undefined ? e.x.location : e.x;
		                            var y = e.y.location !== undefined ? e.y.location : e.y;
		                            var slot = that._slotByPosition(x, y);
	
		                            if (slot) {
		                                var resourceInfo = that._resourceBySlot(slot);
		                                that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
		                            }
	
		                            e.preventDefault();
		                        }
		                    }
		                });
	
		                that._allDayUserEvents = new kendo.UserEvents(that.element, {
		                    threshold: threshold,
		                    useClickAsTap: !kendo.support.browser.edge,
		                    filter: ".k-scheduler-header-all-day td",
		                    tap: function(e) {
		                        if (that._scrolling) {
		                            return;
		                        }
		                        var x = e.x.location !== undefined ? e.x.location : e.x;
		                        var y = e.y.location !== undefined ? e.y.location : e.y;
		                        var slot = that._slotByPosition(x, y);
	
		                        if (slot) {
		                            var resourceInfo = that._resourceBySlot(slot);
		                            that.trigger("add", { eventInfo: extend({}, { isAllDay: true, start: kendo.date.getDate(slot.startDate()), end: kendo.date.getDate(slot.startDate()) }, resourceInfo) });
		                        }
	
		                        e.preventDefault();
		                    }
		                });
		            }
	
		            if (that.options.editable.update !== false) {
		                that._editUserEvents = new kendo.UserEvents(that.element, {
		                    threshold: threshold,
		                    useClickAsTap: !kendo.support.browser.edge,
		                    filter: ".k-event",
		                    tap: function(e) {
		                        if (that._scrolling) {
		                            return;
		                        }
		                        var eventElement = $(e.target).closest(".k-event");
	
		                        if (!eventElement.hasClass("k-event-active")) {
		                            that.trigger("edit", { uid: eventElement.attr(kendo.attr("uid")) });
		                        }
	
		                        e.preventDefault();
		                    }
		                });
		            }
		        },
	
		        _layout: function(dates) {
		            var columns = [];
		            var rows = [];
		            var options = this.options;
		            var that = this;
		            var byDate = that._isGroupedByDate();
	
		            for (var idx = 0; idx < dates.length; idx++) {
		                var column = {};
	
		                column.text = that.dateHeaderTemplate({ date: dates[idx] });
	
		                if (kendo.date.isToday(dates[idx])) {
		                    column.className = "k-today";
		                }
	
		                columns.push(column);
		            }
	
		            var resources = this.groupedResources;
	
		            if (options.allDaySlot) {
		                rows.push({
		                    text: options.messages.allDay, allDay: true,
		                    cellContent: function(idx) {
		                        var groupIndex = idx;
	
		                        idx = resources.length && that._groupOrientation() !== "vertical" ? idx % dates.length : idx;
	
		                        return that.allDaySlotTemplate({ date: dates[idx], resources: function() {
		                                return that._resourceBySlot({ groupIndex: groupIndex });
		                            }
		                        });
		                    }
		                });
		            }
	
		            this._forTimeRange(this.startTime(), this.endTime(), function(date, majorTick, middleRow, lastSlotRow) {
		                var template = majorTick ? that.majorTimeHeaderTemplate : that.minorTimeHeaderTemplate;
	
		                var row = {
		                    text: template({ date: date }),
		                    className: lastSlotRow ? "k-slot-cell" : ""
		                };
	
		                rows.push(row);
		            });
	
	
		            if (resources.length) {
		                if (this._groupOrientation() === "vertical") {
		                    if (byDate) {
		                        rows = this._createDateLayout(columns, rows);
		                        columns = this._createColumnsLayout(resources, null, this.groupHeaderTemplate);
		                    } else {
		                        rows = this._createRowsLayout(resources, rows, this.groupHeaderTemplate);
		                    }
		                } else {
		                      if (byDate) {
		                         columns = this._createColumnsLayout(resources, columns, this.groupHeaderTemplate, columns);
		                      }else {
		                         columns = this._createColumnsLayout(resources, columns, this.groupHeaderTemplate);
		                      }
		                }
		            }
	
		            return {
		                columns: columns,
		                rows: rows
		            };
		        },
	
		        _footer: function() {
		            var options = this.options;
	
		            if (options.footer !== false) {
		                var html = '<div class="k-header k-scheduler-footer">';
	
		                var command = options.footer.command;
	
		                if (command && command === "workDay") {
		                    html += '<ul class="k-reset k-header">';
	
		                    html += '<li class="k-state-default k-scheduler-fullday"><a href="#" class="k-link"><span class="k-icon k-i-clock"></span>';
		                    html += (options.showWorkHours ? options.messages.showFullDay : options.messages.showWorkDay) + '</a></li>';
	
		                    html += '</ul>';
	
		                } else {
		                    html += "&nbsp;";
		                }
	
		                html += "</div>";
	
		                this.footer = $(html).appendTo(this.element);
	
		                var that = this;
	
		                this.footer.on("click" + NS, ".k-scheduler-fullday", function(e) {
		                    e.preventDefault();
		                    that.trigger("navigate", { view: that.name || options.name, date: options.date, isWorkDay: !options.showWorkHours });
		                });
		            }
		        },
	
		        _forTimeRange: function(min, max, action, after) {
		            min = toInvariantTime(min); //convert the date to 1/2/1980 and sets the time
		            max = toInvariantTime(max);
	
		            var that = this,
		                msMin = getMilliseconds(min),
		                msMax = getMilliseconds(max),
		                minorTickCount = that.options.minorTickCount,
		                msMajorInterval = that.options.majorTick * MS_PER_MINUTE,
		                msInterval = msMajorInterval / minorTickCount || 1,
		                start = new Date(+min),
		                startDay = start.getDate(),
		                msStart,
		                idx = 0, length,
		                html = "";
	
		            length = MS_PER_DAY / msInterval;
	
		            if (msMin != msMax) {
		                if (msMin > msMax) {
		                    msMax += MS_PER_DAY;
		                }
	
		                length = ((msMax - msMin) / msInterval);
		            }
	
		            length = Math.round(length);
	
		            for (; idx < length; idx++) {
		                var majorTickDivider = idx % (msMajorInterval/msInterval),
		                    isMajorTickRow = majorTickDivider === 0,
		                    isMiddleRow = majorTickDivider < minorTickCount - 1,
		                    isLastSlotRow = majorTickDivider === minorTickCount - 1;
	
		                html += action(start, isMajorTickRow, isMiddleRow, isLastSlotRow);
	
		                setTime(start, msInterval, false);
		            }
	
		            if (msMax) {
		                msStart = getMilliseconds(start);
		                if (startDay < start.getDate()) {
		                    msStart += MS_PER_DAY;
		                }
	
		                if (msStart > msMax) {
		                    start = new Date(+max);
		                }
		            }
	
		            if (after) {
		                html += after(start);
		            }
	
		            return html;
		        },
	
		        _content: function(dates) {
		            var that = this;
		            var options = that.options;
		            var start = that.startTime();
		            var end = this.endTime();
		            var groupsCount = 1;
		            var rowCount = 1;
		            var columnCount = dates.length;
		            var html = '';
		            var resources = this.groupedResources;
		            var allDaySlotTemplate = this.allDaySlotTemplate;
		            var isVerticalGroupped = false;
		            var allDayVerticalGroupRow;
		            var byDate = that._isGroupedByDate();
		            var dateID = 0;
	
		            if (resources.length) {
		                isVerticalGroupped = that._groupOrientation() === "vertical";
	
		                if (isVerticalGroupped) {
		                    rowCount = this._rowCountForLevel(this.rowLevels.length - 2);
	
		                    if (byDate) {
		                         groupsCount = this._columnCountForLevel(this.columnLevels.length - 1);
		                    }
	
		                    if (options.allDaySlot) {
		                        allDayVerticalGroupRow = function (groupIndex) {
		                            var result = '<tr class="k-scheduler-header-all-day">';
		                            var dateGroupIndex = byDate ? 0 : groupIndex;
		                            var resources = function() {
		                                return that._resourceBySlot({ groupIndex: dateGroupIndex });
		                            };
	
		                            if (byDate) {
		                                for (; dateGroupIndex < groupsCount; dateGroupIndex++) {
		                                    result += "<td>" + allDaySlotTemplate({ date: dates[dateID], resources: resources }) + "</td>";
		                                }
		                            } else {
		                                for (var idx = 0; idx < dates.length; idx++) {
		                                    result += "<td>" + allDaySlotTemplate({ date: dates[idx], resources: resources }) + "</td>";
		                                }
		                            }
	
		                            return result + "</tr>";
		                        };
		                    }
		                } else {
		                    if (byDate) {
		                         groupsCount = this._columnCountForLevel(this.columnLevels.length - 1) / this._columnCountForLevel(0);
		                    } else {
		                         groupsCount = this._columnCountForLevel(this.columnLevels.length - 2);
		                    }
		                }
		            }
	
		            html += '<tbody>';
	
		            var appendRow = function(date, majorTick, middleRow) {
		                var content = "";
		                var groupIdx = 0;
		                var idx, length;
	
		                content = '<tr' + (middleRow ? ' class="k-middle-row"' : "") + '>';
	
		                if (byDate) {
		                    for (idx = 0, length = columnCount; idx < length; idx++) {
		                        for (groupIdx = 0; groupIdx < groupsCount; groupIdx++) {
		                            var dateIndex = idx;
		                            if (isVerticalGroupped) {
		                                dateIndex = dateID;
		                            }
		                            content = that._addCellsToContent(content, dates, date, dateIndex, groupIdx, rowIdx);
	
		                        }
		                        if (isVerticalGroupped) {
	
		                            break;
		                        }
		                    }
		                } else {
		                     for (; groupIdx < groupsCount; groupIdx++) {
		                        for (idx = 0, length = columnCount; idx < length; idx++) {
		                            content = that._addCellsToContent(content, dates, date, idx, groupIdx, rowIdx);
		                        }
		                     }
		                }
	
		                content += "</tr>";
	
		                return content;
		            };
	
		            for (var rowIdx = 0; rowIdx < rowCount; rowIdx++) {
		                html += allDayVerticalGroupRow ? allDayVerticalGroupRow(rowIdx) : "";
	
		                html += this._forTimeRange(start, end, appendRow);
		                if (isVerticalGroupped) {
		                        dateID++;
		                }
		            }
	
		            html += '</tbody>';
	
		            this.content.find("table").append(html);
		        },
	
		        _addCellsToContent: function(content, dates, date, idx, groupIdx, rowIdx) {
		            var that = this;
		            var classes = "";
		            var tmplDate;
		            var slotTemplate = this.slotTemplate;
		            var isVerticalGroupped = this._groupOrientation() === "vertical";
		            var resources = function(groupIndex) {
		                return function() {
		                    return that._resourceBySlot({ groupIndex: groupIndex });
		                };
		            };
	
		            if (kendo.date.isToday(dates[idx])) {
		                classes += "k-today";
		            }
	
		            if (kendo.date.getMilliseconds(date) < kendo.date.getMilliseconds(this.options.workDayStart) ||
		                kendo.date.getMilliseconds(date) >= kendo.date.getMilliseconds(this.options.workDayEnd) ||
		                !this._isWorkDay(dates[idx])) {
		                classes += " k-nonwork-hour";
		            }
	
		            content += '<td' + (classes !== "" ? ' class="' + classes + '"' : "") + ">";
		            tmplDate = kendo.date.getDate(dates[idx]);
		            kendo.date.setTime(tmplDate, kendo.date.getMilliseconds(date));
	
		            content += slotTemplate({ date: tmplDate, resources: resources(isVerticalGroupped && !that._isGroupedByDate()  ? rowIdx : groupIdx) });
		            content += "</td>";
		            return content;
		        },
	
		        _isWorkDay: function(date) {
		            var day = date.getDay();
		            var workDays =  this._workDays;
	
		            for (var i = 0; i < workDays.length; i++) {
		                if (workDays[i] === day) {
		                    return true;
		                }
		            }
		            return false;
		        },
	
		        _render: function(dates) {
		            var that = this;
	
		            dates = dates || [];
	
		            this._dates = dates;
	
		            this._startDate = dates[0];
	
		            this._endDate = dates[(dates.length - 1) || 0];
	
		            this.createLayout(this._layout(dates));
	
		            this._content(dates);
	
		            this._footer();
	
		            this.refreshLayout();
	
		            var allDayHeader = this.element.find(".k-scheduler-header-all-day td");
	
		            if (allDayHeader.length) {
		                this._allDayHeaderHeight = allDayHeader.first()[0].clientHeight;
		            }
	
		            that.element.on("click" + NS, ".k-nav-day", function(e) {
		                var th = $(e.currentTarget).closest("th");
		                var offset = th.offset();
		                var additioanlWidth = 0;
		                var additionalHeight = outerHeight(th);
	
		                if (that._isGroupedByDate()) {
		                    if (that._isVerticallyGrouped()) {
		                        additioanlWidth = outerWidth(that.times);
		                        additionalHeight = 0;
		                    } else {
		                        additionalHeight = outerHeight(that.datesHeader);
		                    }
		                }
	
		                var slot = that._slotByPosition(offset.left + additioanlWidth, offset.top + additionalHeight);
	
		                that.trigger("navigate", { view: "day", date: slot.startDate() });
		            });
		        },
	
		        startTime: function() {
		            var options = this.options;
		            return options.showWorkHours ? options.workDayStart : options.startTime;
		        },
	
		        endTime: function() {
		            var options = this.options;
		            return options.showWorkHours ? options.workDayEnd : options.endTime;
		        },
	
		        startDate: function() {
		            return this._startDate;
		        },
	
		        endDate: function() {
		            return this._endDate;
		        },
	
		        _end: function(isAllDay) {
		            var time = getMilliseconds(this.endTime()) || MS_PER_DAY;
	
		            if (isAllDay) {
		                time = 0;
		            }
	
		            return new Date(this._endDate.getTime() + time);
		        },
	
		        nextDate: function() {
		            return kendo.date.nextDay(this.endDate());
		        },
	
		        previousDate: function() {
		            return kendo.date.previousDay(this.startDate());
		        },
	
		        calculateDateRange: function() {
		            this._render([this.options.date]);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            if (that._currentTimeUpdateTimer) {
		                clearInterval(that._currentTimeUpdateTimer);
		            }
	
		            if (that.datesHeader) {
		                that.datesHeader.off(NS);
		            }
	
		            if (that.element) {
		                that.element.off(NS);
		            }
	
		            if (that.footer) {
		                that.footer.remove();
		            }
	
		            SchedulerView.fn.destroy.call(this);
	
		            if (this._isMobile() && that.options.editable) {
		                if (that.options.editable.create !== false) {
		                    that._addUserEvents.destroy();
		                    that._allDayUserEvents.destroy();
		                }
	
		                if (that.options.editable.update !== false) {
		                    that._editUserEvents.destroy();
		                }
		            }
		        },
	
		        inRange: function(options) {
		            var inRange = SchedulerView.fn.inRange.call(this, options);
	
		            if (options.isAllDay) {
		                return inRange;
		            }
	
		            var startTime = getMilliseconds(this.startTime());
		            var endTime = getMilliseconds(this.endTime()) || kendo.date.MS_PER_DAY;
	
		            var start = getMilliseconds(options.start);
		            var end = getMilliseconds(options.end) || kendo.date.MS_PER_DAY;
	
		            return inRange && startTime <= start && end <= endTime;
		        },
	
		        selectionByElement: function(cell) {
		            var offset = cell.offset();
		            return this._slotByPosition(offset.left, offset.top);
		        },
	
		        _timeSlotInterval: function() {
		            var options = this.options;
		            return (options.majorTick/options.minorTickCount) * MS_PER_MINUTE;
		        },
	
		        _timeSlotIndex: function(date) {
		            var options = this.options;
		            var eventStartTime = getMilliseconds(date);
		            var startTime = getMilliseconds(this.startTime());
		            var timeSlotInterval = ((options.majorTick/options.minorTickCount) * MS_PER_MINUTE);
	
		            return (eventStartTime - startTime) / (timeSlotInterval);
		        },
	
		        _slotIndex: function(date, multiday) {
		            if (multiday) {
		                return this._dateSlotIndex(date);
		            }
	
		            return this._timeSlotIndex(date);
		        },
	
		        _dateSlotIndex: function(date, overlaps) {
		            var idx;
		            var length;
		            var slots = this._dates || [];
		            var slotStart;
		            var slotEnd;
		            var offset = 1;
	
		            for (idx = 0, length = slots.length; idx < length; idx++) {
		                slotStart = kendo.date.getDate(slots[idx]);
		                slotEnd = new Date(kendo.date.getDate(slots[idx]).getTime() + MS_PER_DAY - (overlaps ? 0 : 1));
	
		                if (isInDateRange(date, slotStart, slotEnd)) {
		                    return idx * offset;
		                }
		            }
		            return -1;
		        },
	
		        _positionAllDayEvent: function(element, slotRange) {
		            var slotWidth = slotRange.innerWidth();
		            var startIndex = slotRange.start.index;
		            var endIndex = slotRange.end.index;
	
		            var allDayEvents = SchedulerView.collidingEvents(slotRange.events(), startIndex, endIndex);
	
		            var currentColumnCount = this._headerColumnCount || 0;
	
		            var leftOffset = 2;
	
		            var rightOffset = startIndex !== endIndex ? 5 : 4;
	
		            var eventHeight = this._allDayHeaderHeight;
	
		            var start = slotRange.startSlot();
	
		            element
		                .css({
		                    left: start.offsetLeft + leftOffset,
		                    width: slotWidth - rightOffset
		                });
	
		            slotRange.addEvent({ slotIndex: startIndex, start: startIndex, end: endIndex, element: element });
	
		            allDayEvents.push({ slotIndex: startIndex, start: startIndex, end: endIndex, element: element });
	
		            var rows = SchedulerView.createRows(allDayEvents);
	
		            if (rows.length && rows.length > currentColumnCount) {
		                this._headerColumnCount = rows.length;
		            }
	
		            var top = slotRange.start.offsetTop;
	
		            for (var idx = 0, length = rows.length; idx < length; idx++) {
		                var rowEvents = rows[idx].events;
	
		                for (var j = 0, eventLength = rowEvents.length; j < eventLength; j++) {
		                    $(rowEvents[j].element).css({
		                        top: top + idx * eventHeight
		                    });
		                }
		            }
		        },
	
		        _arrangeColumns: function(element, top, height, slotRange) {
		            var startSlot = slotRange.start;
	
		            element = { element: element, slotIndex: startSlot.index, start: top, end: top + height };
	
		            var columns,
		                slotWidth = startSlot.clientWidth,
		                eventRightOffset = slotWidth * 0.10,
		                columnEvents,
		                eventElements =  slotRange.events(),
		                slotEvents = SchedulerView.collidingEvents(eventElements, element.start, element.end);
	
		            slotRange.addEvent(element);
	
		            slotEvents.push(element);
	
		            columns = SchedulerView.createColumns(slotEvents);
	
		            var columnWidth = (slotWidth - eventRightOffset) / columns.length;
	
		            for (var idx = 0, length = columns.length; idx < length; idx++) {
		                columnEvents = columns[idx].events;
	
		                for (var j = 0, eventLength = columnEvents.length; j < eventLength; j++) {
		                    columnEvents[j].element[0].style.width = columnWidth - 4 + "px";
		                    columnEvents[j].element[0].style.left = (this._isRtl ? eventRightOffset : 0) + startSlot.offsetLeft + idx * columnWidth + 2 + "px";
		                }
		            }
		        },
	
		        _positionEvent: function(event, element, slotRange) {
		            var start = event._startTime || event.start;
		            var end = event._endTime || event.end;
	
		            var rect = slotRange.innerRect(start, end, false);
	
		            var height = rect.bottom - rect.top - 2; /* two times border width */
	
		            if (height < 0) {
		                height = 0;
		            }
	
		            element.css( {
		                top: rect.top,
		                height: height
		            } );
	
		            this._arrangeColumns(element, rect.top, element[0].clientHeight, slotRange);
		       },
	
		       _createEventElement: function(event, isOneDayEvent, head, tail) {
		            var template = isOneDayEvent ? this.eventTemplate : this.allDayEventTemplate;
		            var options = this.options;
		            var editable = options.editable;
		            var isMobile = this._isMobile();
		            var showDelete = editable && editable.destroy !== false && !isMobile;
		            var resizable = editable && editable.resize !== false;
		            var startDate = getDate(this.startDate());
		            var endDate = getDate(this.endDate());
		            var startTime = getMilliseconds(this.startTime());
		            var endTime = getMilliseconds(this.endTime());
		            var eventStartTime = event._time("start");
		            var eventEndTime = event._time("end");
		            var middle;
	
		            if (startTime >= endTime) {
		                endTime = getMilliseconds(new Date(this.endTime().getTime() + MS_PER_DAY - 1));
		            }
	
		            if (!isOneDayEvent && !event.isAllDay) {
		                endDate = new Date(endDate.getTime() + MS_PER_DAY);
		            }
	
		            var eventStartDate = event.start;
		            var eventEndDate = event.end;
	
		            if (event.isAllDay) {
		                eventEndDate = getDate(event.end);
		            }
	
		            if ((!isInDateRange(getDate(eventStartDate), startDate, endDate) &&
		                !isInDateRange(eventEndDate, startDate, endDate)) ||
		                (isOneDayEvent && eventStartTime < startTime && eventEndTime > endTime)) {
	
		                middle = true;
		            } else if (getDate(eventStartDate) < startDate || (isOneDayEvent && eventStartTime < startTime)) {
		                tail = true;
		            } else if ((eventEndDate > endDate && !isOneDayEvent) || (isOneDayEvent && eventEndTime > endTime)) {
		                head = true;
		            }
	
		            var resources = this.eventResources(event);
	
		           if (event._startTime && eventStartTime !== kendo.date.getMilliseconds(event.start)) {
		                eventStartDate = new Date(eventStartTime);
		                eventStartDate = kendo.timezone.apply(eventStartDate, "Etc/UTC");
		            }
	
		           if (event._endTime && eventEndTime !== kendo.date.getMilliseconds(event.end)) {
		                eventEndDate = new Date(eventEndTime);
		                eventEndDate = kendo.timezone.apply(eventEndDate, "Etc/UTC");
		            }
	
		            var data = extend({}, {
		                ns: kendo.ns,
		                resizable: resizable,
		                showDelete: showDelete,
		                middle: middle,
		                head: head,
		                tail: tail,
		                singleDay: this._dates.length == 1,
		                resources: resources,
		                inverseColor: resources && resources[0] ? this._shouldInverseResourceColor(resources[0]) : false,
		                messages: options.messages
		            }, event, {
		                start: eventStartDate,
		                end: eventEndDate
		            });
	
		            var element = $(template(data));
	
		            this.angular("compile", function(){
		                return {
		                    elements: element,
		                    data: [ { dataItem: data } ]
		                };
		            });
	
		            return element;
		        },
	
		        _isInTimeSlot: function(event) {
		            var slotStartTime = this.startTime(),
		                slotEndTime = this.endTime(),
		                startTime = event._startTime || event.start,
		                endTime = event._endTime || event.end;
	
		            if (getMilliseconds(slotEndTime) === getMilliseconds(kendo.date.getDate(slotEndTime))) {
		                slotEndTime = kendo.date.getDate(slotEndTime);
		                setTime(slotEndTime, MS_PER_DAY - 1);
		            }
	
		            if (event._date("end") > event._date("start")) {
		               endTime = +event._date("end") + (MS_PER_DAY - 1);
		            }
	
		            endTime = event._endTime ? endTime - event._date("end"): getMilliseconds(new Date(endTime));
		            startTime = event._startTime? startTime - event._date("start"): getMilliseconds(new Date(startTime));
	
		            slotEndTime = getMilliseconds(slotEndTime);
		            slotStartTime = getMilliseconds(slotStartTime);
	
		            if(slotStartTime === startTime && startTime === endTime) {
		                return true;
		            }
	
		            var overlaps = startTime !== slotEndTime;
	
		            return isInTimeRange(startTime, slotStartTime, slotEndTime, overlaps) ||
		                isInTimeRange(endTime, slotStartTime, slotEndTime, overlaps) ||
		                isInTimeRange(slotStartTime, startTime, endTime) ||
		                isInTimeRange(slotEndTime, startTime, endTime);
		        },
	
		        _isInDateSlot: function(event) {
		            var groups = this.groups[0];
		            var slotStart = groups.firstSlot().start;
		            var slotEnd = groups.lastSlot().end - 1;
	
		            var startTime = kendo.date.toUtcTime(event.start);
		            var endTime = kendo.date.toUtcTime(event.end);
	
		            return (isInDateRange(startTime, slotStart, slotEnd) ||
		                isInDateRange(endTime, slotStart, slotEnd) ||
		                isInDateRange(slotStart, startTime, endTime) ||
		                isInDateRange(slotEnd, startTime, endTime)) &&
		                (!isInDateRange(endTime, slotStart, slotStart) || isInDateRange(endTime, startTime, startTime) || event.isAllDay );
		        },
	
		        _updateAllDayHeaderHeight: function(height) {
		            if (this._height !== height) {
		                this._height = height;
	
		                var allDaySlots = this.element.find(".k-scheduler-header-all-day td");
	
		                if (allDaySlots.length) {
		                    allDaySlots.parent()
		                        .add(this.element.find(".k-scheduler-times-all-day").parent())
		                        .height(height);
	
		                    for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
		                        this.groups[groupIndex].refresh();
		                    }
		                }
		            }
		        },
	
		        _renderEvents: function(events, groupIndex) {
		            var allDayEventContainer = this.datesHeader.find(".k-scheduler-header-wrap > div");
		            var byDate = this._isGroupedByDate();
		            var event;
	
		            var idx;
		            var length;
	
		            for (idx = 0, length = events.length; idx < length; idx++) {
		                event = events[idx];
	
		                if (this._isInDateSlot(event)) {
		                    var isMultiDayEvent = event.isAllDay || event.duration() >= MS_PER_DAY;
		                    var container = isMultiDayEvent && !this._isVerticallyGrouped() ? allDayEventContainer : this.content;
		                    var element, ranges, range, start, end, group;
	
		                    if (!isMultiDayEvent) {
	
		                        if (this._isInTimeSlot(event)) {
		                            group = this.groups[groupIndex];
	
		                            if (!group._continuousEvents) {
		                                group._continuousEvents = [];
		                            }
	
		                            ranges = group.slotRanges(event);
	
		                            var rangeCount = ranges.length;
	
		                            for (var rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
		                                range = ranges[rangeIndex];
		                                start = event.start;
		                                end = event.end;
	
		                                if (rangeCount > 1) {
		                                    if (rangeIndex === 0) {
		                                        end = range.end.endDate();
		                                    } else if (rangeIndex == rangeCount - 1) {
		                                        start = range.start.startDate();
		                                    } else {
		                                        start = range.start.startDate();
		                                        end = range.end.endDate();
		                                    }
		                                }
	
		                                var occurrence = event.clone({ start: start, end: end, _startTime: event._startTime, _endTime: event.endTime });
	
		                                if (this._isInTimeSlot(occurrence)) {
		                                    var head = range.head;
	
		                                    element = this._createEventElement(event, !isMultiDayEvent, head, range.tail);
	
		                                    element.appendTo(container);
	
		                                    this._positionEvent(occurrence, element, range);
	
		                                    addContinuousEvent(group, range, element, false);
		                                }
		                            }
		                        }
	
		                    } else if (this.options.allDaySlot) {
		                       group = this.groups[groupIndex];
	
		                       if (!group._continuousEvents) {
		                           group._continuousEvents = [];
		                       }
	
		                        ranges = group.slotRanges(event);
	
		                        if (ranges.length) {
		                            range = ranges[0];
		                            var startIndex = range.start.index;
		                            var endIndex = range.end.index;
	
		                            if (byDate && startIndex !== endIndex) {
		                                start = range.start.start;
		                                end = range.end.end;
		                                var newStart = new Date(start);
		                                var newEnd = new Date(start);
	
		                                for (var i = range.start.index; i <= range.end.index; i++) {
		                                    element = this._createEventElement(event, !isMultiDayEvent, i !== endIndex, i !== startIndex);
	
		                                    var dateRange = group.daySlotRanges(newStart, newEnd, true)[0];
		                                    newEnd.setDate(newEnd.getDate() + 1);
		                                    newStart.setDate(newStart.getDate() + 1);
	
		                                    this._positionAllDayEvent(element, dateRange);
	
		                                    addContinuousEvent(group, dateRange, element, true);
	
		                                    element.appendTo(container);
		                                }
		                               } else {
		                                       element = this._createEventElement(event, !isMultiDayEvent);
	
		                                       this._positionAllDayEvent(element, ranges[0]);
	
		                                       addContinuousEvent(group, ranges[0], element, true);
	
		                                       element.appendTo(container);
		                               }
		                       }
		                    }
		                }
		            }
		        },
	
		        render: function(events) {
		            this._headerColumnCount = 0;
	
		            this._groups();
	
		            this.element.find(".k-event").remove();
	
		            events = new kendo.data.Query(events)
		                .sort([{ field: "start", dir: "asc" },{ field: "end", dir: "desc" }])
		                .toArray();
	
		            var eventsByResource = [];
	
		            this._eventsByResource(events, this.groupedResources, eventsByResource);
	
		            var eventsPerDate = $.map(this._dates, function(date) {
		                return Math.max.apply(null,
		                    $.map(eventsByResource, function(events) {
		                        return $.grep(events, function(event) {
		                            return event.isMultiDay() && isInDateRange(date, getDate(event.start), getDate(event.end));
		                        }).length;
		                    })
		                );
		            });
	
		            var height = Math.max.apply(null, eventsPerDate);
	
		            this._updateAllDayHeaderHeight((height + 1) * this._allDayHeaderHeight);
	
		            for (var groupIndex = 0; groupIndex < eventsByResource.length; groupIndex++) {
		                this._renderEvents(eventsByResource[groupIndex], groupIndex);
		            }
	
		            this.refreshLayout();
	
		            this._currentTime(false);
	
		            this.trigger("activate");
		        },
	
		        _eventsByResource: function(events, resources, result) {
		            var resource = resources[0];
	
		            if (resource) {
		                var view = resource.dataSource.view();
	
		                for (var itemIdx = 0; itemIdx < view.length; itemIdx++) {
		                    var value = this._resourceValue(resource, view[itemIdx]);
	
		                    var eventsFilteredByResource = new kendo.data.Query(events).filter({ field: resource.field, operator: SchedulerView.groupEqFilter(value) }).toArray();
	
		                    if (resources.length > 1) {
		                        this._eventsByResource(eventsFilteredByResource, resources.slice(1), result);
		                    } else {
		                        result.push(eventsFilteredByResource);
		                    }
		                }
		            } else {
		                result.push(events);
		            }
		        },
	
		        _columnOffsetForResource: function(index) {
		            return this._columnCountForLevel(index) / this._columnCountForLevel(index - 1);
		        },
	
		        _columnCountForLevel: function(level) {
		            var columnLevel = this.columnLevels[level];
		            return columnLevel ? columnLevel.length : 0;
		        },
	
		        _rowCountForLevel: function(level) {
		            var rowLevel = this.rowLevels[level];
		            return rowLevel ? rowLevel.length : 0;
		        },
	
		        clearSelection: function() {
	
		            this.content.add(this.datesHeader)
		                .find(".k-state-selected")
		                .removeAttr("id")
		                .attr("aria-selected", false)
		                .removeClass("k-state-selected");
		        },
	
		        _updateDirection: function(selection, ranges, multiple, reverse, vertical) {
		            var isDaySlot = selection.isAllDay;
		            var startSlot = ranges[0].start;
		            var endSlot = ranges[ranges.length - 1].end;
	
		            if (multiple) {
		                if (vertical) {
		                    if (!isDaySlot &&
		                        startSlot.index === endSlot.index &&
		                        startSlot.collectionIndex === endSlot.collectionIndex) {
		                            selection.backward = reverse;
		                    }
		                } else {
		                    if ((isDaySlot && startSlot.index === endSlot.index) ||
		                        (!isDaySlot && startSlot.collectionIndex === endSlot.collectionIndex)) {
		                            selection.backward = reverse;
		                    }
		                }
		            }
		        },
	
		        _changeViewPeriod: function(selection, reverse, vertical) {
		            if (!vertical) {
		                var date = reverse ? this.previousDate() : this.nextDate();
		                var start = selection.start;
		                var end = selection.end;
		                var verticalByDate = this._isGroupedByDate()  && this._isVerticallyGrouped();
		                var group = this.groups[selection.groupIndex];
		                var collection = reverse ? group._timeSlotCollections : group._getCollections(group.daySlotCollectionCount());
		                var slots = collection[collection.length - 1]._slots;
		                var slotIndex = (!reverse && !group.daySlotCollectionCount()) ? 0 : slots.length - 1;
		                var endMilliseconds;
		                var newDateStart, newDateEnd;
	
		                newDateStart =  new Date(date);
		                newDateEnd = new Date(date);
	
		                if(this._isInRange(newDateStart, newDateEnd)){
		                    return false;
		                }
	
		                selection.start = newDateStart;
		                selection.end = newDateEnd;
	
		                if (verticalByDate) {
		                    var newStart =new Date(slots[slotIndex].startDate());
		                    var newEnd = new Date(slots[slotIndex].endDate());
		                    endMilliseconds = getMilliseconds(newEnd) ? getMilliseconds(newEnd) : MS_PER_DAY ;
	
		                        setTime(selection.start, getMilliseconds(newStart));
		                        setTime(selection.end, endMilliseconds);
		                        if(group.daySlotCollectionCount()){
		                            selection.isAllDay = !selection.isAllDay;
		                        }
		                } else {
		                    endMilliseconds = (selection.isAllDay || !getMilliseconds(end)) ? MS_PER_DAY : getMilliseconds(end);
	
		                    setTime(selection.start, getMilliseconds(start));
		                    setTime(selection.end, endMilliseconds);
		                }
	
		                if (!this._isVerticallyGrouped()) {
		                    selection.groupIndex = reverse ? this.groups.length - 1 : 0;
		                }
	
		                selection.events = [];
	
		                return true;
		            }
		        }
		    });
	
		    extend(true, ui, {
		        MultiDayView: MultiDayView,
		        DayView: MultiDayView.extend({
		            options: {
		                name: "DayView",
		                title: "Day"
		            },
		            name: "day"
		        }),
		        WeekView: MultiDayView.extend({
		            options: {
		                name: "WeekView",
		                title: "Week",
		                selectedDateFormat: "{0:D} - {1:D}",
		                selectedShortDateFormat: "{0:d} - {1:d}"
		            },
		            name: "week",
		            calculateDateRange: function() {
		                var selectedDate = this.options.date,
		                    start = kendo.date.dayOfWeek(selectedDate, this.calendarInfo().firstDay, -1),
		                    idx, length,
		                    dates = [];
	
		                for (idx = 0, length = 7; idx < length; idx++) {
		                    dates.push(start);
		                    start = kendo.date.nextDay(start);
		                }
		                this._render(dates);
		            }
		        }),
		        WorkWeekView: MultiDayView.extend({
		            options: {
		                name: "WorkWeekView",
		                title: "Work Week",
		                selectedDateFormat: "{0:D} - {1:D}",
		                selectedShortDateFormat: "{0:d} - {1:d}"
		            },
		            name: "workWeek",
		            nextDate: function() {
		                var weekStart = kendo.date.dayOfWeek(kendo.date.nextDay(this.startDate()), this.calendarInfo().firstDay, 1);
		                return kendo.date.addDays(weekStart, this._workDays[0]);
		            },
		            previousDate: function() {
		                var weekStart = kendo.date.dayOfWeek(this.startDate(), this.calendarInfo().firstDay, -1);
		                var workDays = this._workDays;
	
		                return kendo.date.addDays(weekStart, workDays[workDays.length - 1] - 7);
		            },
		            calculateDateRange: function() {
		                var selectedDate = this.options.date,
		                    dayOfWeek = kendo.date.dayOfWeek,
		                    weekStart = dayOfWeek(selectedDate, this.calendarInfo().firstDay, -1),
		                    start = dayOfWeek(weekStart, this.options.workWeekStart, 1),
		                    end = dayOfWeek(start, this.options.workWeekEnd, 1),
		                    dates = [];
	
		                while (start <= end) {
		                    dates.push(start);
		                    start = kendo.date.nextDay(start);
		                }
		                this._render(dates);
		            }
		        })
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1287);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1287:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "scheduler.view",
		    name: "Scheduler View",
		    category: "web",
		    description: "The Scheduler Common View",
		    depends: [ "core" ],
		    hidden: true
		};
		    kendo.ui.scheduler = {};
		/* jshint eqnull: true */
		(function($) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        getDate = kendo.date.getDate,
		        Widget = ui.Widget,
		        outerHeight = kendo._outerHeight,
		        keys = kendo.keys,
		        NS = ".kendoSchedulerView",
		        math = Math;
	
		    function levels(values, key) {
		        var result = [];
	
		        function collect(depth, values) {
		            values = values[key];
	
		            if (values) {
		                var level = result[depth] = result[depth] || [];
	
		                for (var idx = 0; idx < values.length; idx++) {
		                    level.push(values[idx]);
		                    collect(depth + 1, values[idx]);
		                }
		            }
		        }
	
		        collect(0, values);
	
		        return result;
		    }
	
		    function cellspacing() {
		        if (kendo.support.cssBorderSpacing) {
		            return "";
		        }
	
		        return 'cellspacing="0"';
		    }
	
		    function table(tableRows, className) {
		        if (!tableRows.length) {
		            return "";
		        }
	
		        return '<table ' + cellspacing() + ' class="' + $.trim('k-scheduler-table ' + (className || "")) + '">' +
		               '<tr>' +
		                    tableRows.join("</tr><tr>") +
		               '</tr>' +
		               '</table>';
		    }
	
		    function allDayTable(tableRows, className) {
		        if (!tableRows.length) {
		            return "";
		        }
	
		        return "<div style='position:relative'>" + table(tableRows, className) + "</div>";
		    }
	
		    function timesHeader(columnLevelCount, allDaySlot, rowCount) {
		        var tableRows = [];
	
		        if (rowCount > 0) {
		            for (var idx = 0; idx < columnLevelCount; idx++) {
		                tableRows.push("<th>&#8203;</th>");
		            }
		        }
	
		        if (allDaySlot) {
		            tableRows.push('<th class="k-scheduler-times-all-day">' + allDaySlot.text + '</th>');
		        }
	
		        if (rowCount < 1) {
		           return $();
		        }
	
		        return $('<div class="k-scheduler-times">' + table(tableRows) + '</div>');
		    }
	
		    function datesHeader(columnLevels, columnCount, allDaySlot) {
		        var dateTableRows = [];
		        var columnIndex;
	
		        for (var columnLevelIndex = 0; columnLevelIndex < columnLevels.length; columnLevelIndex++) {
		            var level = columnLevels[columnLevelIndex];
		            var th = [];
		            var colspan = columnCount / level.length;
	
		            for (columnIndex = 0; columnIndex < level.length; columnIndex ++) {
		                var column = level[columnIndex];
	
		                th.push('<th colspan="' + (column.colspan || colspan) + '" class="' + (column.className || "")  + '">' + column.text + "</th>");
		            }
	
		            dateTableRows.push(th.join(""));
		        }
	
		        var allDayTableRows = [];
	
		        if (allDaySlot) {
		            var lastLevel = columnLevels[columnLevels.length - 1];
		            var td = [];
		            var cellContent = allDaySlot.cellContent;
	
		            for (columnIndex = 0; columnIndex < lastLevel.length; columnIndex++) {
		                td.push('<td class="' + (lastLevel[columnIndex].className || "")  + '">' + (cellContent ? cellContent(columnIndex) : '&nbsp;') + '</td>');
		            }
	
		            allDayTableRows.push(td.join(""));
		        }
	
		        return $(
		            '<div class="k-scheduler-header k-state-default">' +
		                '<div class="k-scheduler-header-wrap">' +
		                    table(dateTableRows) +
		                    allDayTable(allDayTableRows, "k-scheduler-header-all-day") +
		                '</div>' +
		            '</div>'
		        );
		    }
	
		    function times(rowLevels, rowCount) {
		        var rows = new Array(rowCount).join().split(",");
		        var rowHeaderRows = [];
		        var rowIndex;
	
		        for (var rowLevelIndex = 0; rowLevelIndex < rowLevels.length; rowLevelIndex++) {
		            var level = rowLevels[rowLevelIndex];
		            var rowspan = rowCount / level.length;
		            var className;
	
		            for (rowIndex = 0; rowIndex < level.length; rowIndex++) {
		                className = level[rowIndex].className || "";
	
		                if (level[rowIndex].allDay) {
		                    className = "k-scheduler-times-all-day";
		                }
	
		                rows[rowspan * rowIndex] += '<th class="' + className + '" rowspan="' + rowspan + '">' + level[rowIndex].text + "</th>";
		            }
		        }
	
		        for (rowIndex = 0; rowIndex < rowCount; rowIndex++) {
		            rowHeaderRows.push(rows[rowIndex]);
		        }
	
		        if (rowCount < 1) {
		            return $();
		        }
	
		        return $('<div class="k-scheduler-times">' + table(rowHeaderRows) + '</div>');
		    }
	
		    function content() {
		        return $(
		            '<div class="k-scheduler-content">' +
		                '<table ' + cellspacing() + ' class="k-scheduler-table"/>' +
		            '</div>'
		        );
		    }
		    var HINT = '<div class="k-marquee k-scheduler-marquee">' +
		                    '<div class="k-marquee-color"></div>' +
		                    '<div class="k-marquee-text">' +
		                        '<div class="k-label-top"></div>' +
		                        '<div class="k-label-bottom"></div>' +
		                    '</div>' +
		                '</div>';
	
	
		    var ResourceView = kendo.Class.extend({
		        init: function(index, isRtl) {
		            this._index = index;
		            this._timeSlotCollections = [];
		            this._daySlotCollections = [];
		            this._isRtl = isRtl;
		        },
	
		        addTimeSlotCollection: function(startDate, endDate) {
		            return this._addCollection(startDate, endDate, this._timeSlotCollections);
		        },
	
		        addDaySlotCollection: function(startDate, endDate) {
		            return this._addCollection(startDate, endDate, this._daySlotCollections);
		        },
	
		        _addCollection: function(startDate, endDate, collections) {
		            var collection = new SlotCollection(startDate, endDate, this._index, collections.length);
	
		            collections.push(collection);
	
		            return collection;
		        },
	
		        timeSlotCollectionCount: function() {
		            return this._timeSlotCollections.length;
		        },
	
		        daySlotCollectionCount: function() {
		            return this._daySlotCollections.length;
		        },
	
		        daySlotByPosition: function(x, y, byDate) {
		            return this._slotByPosition(x, y, this._daySlotCollections, byDate);
		        },
	
		        timeSlotByPosition: function(x, y, byDate) {
		            return this._slotByPosition(x, y, this._timeSlotCollections, byDate);
		        },
	
		        _slotByPosition: function(x, y, collections, byDate) {
		           for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex++) {
		               var collection = collections[collectionIndex];
	
		               for (var slotIndex = 0; slotIndex < collection.count(); slotIndex++) {
		                   var slot = collection.at(slotIndex);
		                   var width = slot.offsetWidth;
		                   var height = slot.offsetHeight;
		                   var nextSlot;
	
		                   var horizontalEnd = slot.offsetLeft + width;
		                   var verticalEnd =  slot.offsetTop + height;
	
		                   if (!byDate) {
		                        nextSlot =  collection.at(slotIndex + 1);
		                   }
	
		                   if (nextSlot) {
		                       if (nextSlot.offsetLeft != slot.offsetLeft) {
		                           if (this._isRtl) {
		                               horizontalEnd = slot.offsetLeft + (slot.offsetLeft - nextSlot.offsetLeft);
		                           } else {
		                               horizontalEnd = nextSlot.offsetLeft;
		                           }
		                       } else {
		                           verticalEnd = nextSlot.offsetTop;
		                       }
		                   }
	
		                   if (x >= slot.offsetLeft && x < horizontalEnd &&
		                       y >= slot.offsetTop && y < verticalEnd) {
		                       return slot;
		                   }
		               }
		           }
		        },
	
		        refresh: function() {
		            var collectionIndex;
	
		            for (collectionIndex = 0; collectionIndex < this._daySlotCollections.length; collectionIndex++) {
		                this._daySlotCollections[collectionIndex].refresh();
		            }
	
		            for (collectionIndex = 0; collectionIndex < this._timeSlotCollections.length; collectionIndex++) {
		                this._timeSlotCollections[collectionIndex].refresh();
		            }
		        },
	
		        timeSlotRanges: function(startTime, endTime) {
		            var collections = this._timeSlotCollections;
	
		            var start = this._startSlot(startTime, collections);
	
		            if (!start.inRange && startTime >= start.slot.end) {
		                start = null;
		            }
	
		            var end = start;
	
		            if (startTime < endTime) {
		                end = this._endSlot(endTime, collections);
		            }
	
		            if (end && !end.inRange && endTime <= end.slot.start) {
		                end = null;
		            }
	
		            if (start === null && end === null) {
		                return [];
		            }
	
		            if (start === null) {
		                if (end.slot.end <= startTime) {
		                    return [];
		                }
	
		                start = {
		                    inRange: true,
		                    slot: collections[end.slot.collectionIndex].first()
		                };
		            }
	
		            if (end === null) {
		                if (start.slot.start >= endTime) {
		                    return [];
		                }
	
		                end = {
		                    inRange: true,
		                    slot: collections[start.slot.collectionIndex].last()
		                };
		            }
	
		            return this._continuousRange(TimeSlotRange, collections, start, end);
		        },
	
		        daySlotRanges: function(startTime, endTime, isAllDay) {
		            var collections = this._daySlotCollections;
	
		            var start = this._startSlot(startTime, collections, isAllDay);
	
		            if (!start.inRange && startTime >= start.slot.end) {
		                start = null;
		            }
	
		            var end = start;
	
		            if (startTime < endTime) {
		                end = this._endSlot(endTime, collections, isAllDay);
		            }
	
		            if (end && !end.inRange && endTime <= end.slot.start) {
		                end = null;
		            }
	
		            if (start === null && end === null) {
		                return [];
		            }
	
		            if (start === null) {
		                if (end.slot.end <= startTime) {
		                    return [];
		                }
	
		                do {
		                    startTime += kendo.date.MS_PER_DAY;
		                    start = this._startSlot(startTime, collections, isAllDay);
		                } while (!start.inRange && startTime >= start.slot.end);
		            }
	
		            if (end === null) {
		                if (start.slot.start >= endTime) {
		                    return [];
		                }
	
		                do {
		                    endTime -= kendo.date.MS_PER_DAY;
		                    end = this._endSlot(endTime, collections, isAllDay);
		                } while (!end.inRange && endTime <= end.slot.start);
		            }
	
		            return this._continuousRange(DaySlotRange, collections, start, end);
		        },
	
		        _continuousRange: function(range, collections, start, end) {
		            var startSlot = start.slot;
		            var endSlot = end.slot;
	
		            var startIndex = startSlot.collectionIndex;
		            var endIndex = endSlot.collectionIndex;
	
		            var ranges = [];
	
		            for (var collectionIndex = startIndex; collectionIndex <= endIndex; collectionIndex++) {
		                var collection = collections[collectionIndex];
	
		                var first = collection.first();
		                var last = collection.last();
		                var head = false;
		                var tail = false;
	
		                if (collectionIndex == startIndex) {
		                    tail = !start.inRange;
		                }
	
		                if (collectionIndex == endIndex) {
		                    head = !end.inRange;
		                }
	
		                if (first.start < startSlot.start) {
		                    first = startSlot;
		                }
	
		                if (last.start > endSlot.start) {
		                    last = endSlot;
		                }
	
		                if (startIndex < endIndex) {
		                    if (collectionIndex == startIndex) {
		                        head = true;
		                    } else if (collectionIndex == endIndex) {
		                        tail = true;
		                    } else {
		                        head = tail = true;
		                    }
		                }
	
		                ranges.push(new range({
		                    start: first,
		                    end: last,
		                    collection: collection,
		                    head: head,
		                    tail: tail
		                }));
		            }
	
		            return ranges;
		        },
	
		        slotRanges: function(event, isDay) {
		            var startTime = event._startTime || kendo.date.toUtcTime(event.start);
		            var endTime = event._endTime || kendo.date.toUtcTime(event.end);
	
		            if (isDay === undefined) {
		                isDay = event.isMultiDay();
		            }
	
		            if (isDay) {
		                return this.daySlotRanges(startTime, endTime, event.isAllDay);
		            }
	
		            return this.timeSlotRanges(startTime, endTime);
		        },
	
		        ranges: function(startTime, endTime, isDay, isAllDay) {
		            if (typeof startTime != "number") {
		                startTime = kendo.date.toUtcTime(startTime);
		            }
	
		            if (typeof endTime != "number") {
		                endTime = kendo.date.toUtcTime(endTime);
		            }
	
		            if (isDay) {
		                return this.daySlotRanges(startTime, endTime, isAllDay);
		            }
	
		            return this.timeSlotRanges(startTime, endTime);
		        },
	
		        _startCollection: function(date, collections) {
		            for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex++) {
		                var collection = collections[collectionIndex];
	
		                if (collection.startInRange(date)) {
		                    return collection;
		                }
		            }
	
		            return null;
		        },
	
		        _endCollection: function(date, collections, isAllDay) {
		            for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex++) {
		                var collection = collections[collectionIndex];
	
		                if (collection.endInRange(date, isAllDay)) {
		                    return collection;
		                }
		            }
	
		            return null;
		        },
	
		        _getCollections: function(isDay) {
		            return isDay ? this._daySlotCollections : this._timeSlotCollections;
		        },
	
		        continuousSlot: function(slot, reverse) {
		            var pad = reverse ? -1 : 1;
		            var collections = this._getCollections(slot.isDaySlot);
		            var collection = collections[slot.collectionIndex + pad];
	
		            return collection ? collection[reverse ? "last" : "first"]() : undefined;
		        },
	
		        firstSlot: function() {
		            var collections = this._getCollections(this.daySlotCollectionCount());
	
		            return collections[0].first();
		        },
	
		        lastSlot: function() {
		            var collections = this._getCollections(this.daySlotCollectionCount());
	
		            return collections[collections.length - 1].last();
		        },
	
		        upSlot: function(slot, keepCollection, groupByDateVertically) {
		            var that = this;
		            var moveToDaySlot = function(isDaySlot, collectionIndex, index) {
		                var isFirstCell = index === 0;
	
		                if (!keepCollection && !isDaySlot && isFirstCell && that.daySlotCollectionCount()) {
		                    return that._daySlotCollections[0].at(collectionIndex);
		                }
		            };
	
		            if (!this.timeSlotCollectionCount()) {
		                keepCollection = true;
		            }
	
		            return this._verticalSlot(slot, -1, moveToDaySlot, groupByDateVertically);
		        },
	
		        downSlot: function(slot, keepCollection, groupByDateVertically) {
		            var that = this;
		            var moveToTimeSlot = function(isDaySlot, collectionIndex, index) {
		                if (!keepCollection && isDaySlot && that.timeSlotCollectionCount()) {
		                    return that._timeSlotCollections[index].at(0);
		                }
		            };
	
		            if (!this.timeSlotCollectionCount()) {
		                keepCollection = true;
		            }
	
		            return this._verticalSlot(slot, 1, moveToTimeSlot, groupByDateVertically);
		        },
	
		        leftSlot: function(slot, groupByDateVertically) {
		            return this._horizontalSlot(slot, -1, groupByDateVertically);
		        },
	
		        rightSlot: function(slot, groupByDateVertically) {
		            return this._horizontalSlot(slot, 1, groupByDateVertically);
		        },
	
		        _horizontalSlot: function(slot, step, groupByDateVertically) {
		            var index = slot.index;
		            var isDaySlot = slot.isDaySlot;
		            var collectionIndex = slot.collectionIndex;
		            var collections = this._getCollections(isDaySlot);
	
		            isDaySlot = groupByDateVertically ? false : isDaySlot;
	
		            if (isDaySlot) {
		                index += step;
		            } else {
		                collectionIndex += step;
		            }
	
		            var collection = collections[collectionIndex];
	
		            return collection ? collection.at(index) : undefined;
		        },
	
		        _verticalSlot: function(slot, step, swapCollection, groupByDateVertically) {
		            var index = slot.index;
		            var isDaySlot = slot.isDaySlot;
		            var collectionIndex = slot.collectionIndex;
		            var collections = this._getCollections(isDaySlot);
	
		            slot = swapCollection(isDaySlot, collectionIndex, index);
		            if (slot) {
		                return slot;
		            }
	
		            isDaySlot = groupByDateVertically ? false : isDaySlot;
	
		            if (isDaySlot) {
		                collectionIndex += step;
		            } else {
		                index += step;
		            }
	
		            var collection = collections[collectionIndex];
	
		            return collection ? collection.at(index) : undefined;
		        },
	
		        _collection: function(index, multiday) {
		            var collections = multiday? this._daySlotCollections : this._timeSlotCollections;
	
		            return collections[index];
		        },
	
		        _startSlot: function(time, collections, isAllDay) {
		            var collection = this._startCollection(time, collections);
	
		            var inRange = true;
	
		            if (!collection) {
		                collection = collections[0];
		                inRange = false;
		            }
	
		            var slot = collection.slotByStartDate(time, isAllDay);
	
		            if (!slot) {
		                slot = collection.first();
		                inRange = false;
		            }
	
		            return {
		                slot: slot,
		                inRange: inRange
		            };
		        },
	
		        _endSlot: function(time, collections, isAllDay) {
		            var collection = this._endCollection(time, collections, isAllDay);
	
		            var inRange = true;
	
		            if (!collection) {
		                collection = collections[collections.length - 1];
		                inRange = false;
		            }
	
		            var slot = collection.slotByEndDate(time, isAllDay);
	
		            if (!slot) {
		                slot = collection.last();
		                inRange = false;
		            }
	
		            return {
		                slot: slot,
		                inRange: inRange
		            };
		        },
	
		        getSlotCollection: function(index, isDay) {
		            return this[isDay ? "getDaySlotCollection" : "getTimeSlotCollection"](index);
		        },
	
		        getTimeSlotCollection: function(index) {
		            return this._timeSlotCollections[index];
		        },
	
		        getDaySlotCollection: function(index) {
		            return this._daySlotCollections[index];
		        }
		    });
	
		    var SlotRange = kendo.Class.extend({
		        init: function(options) {
		            $.extend(this, options);
		        },
	
		        innerHeight: function() {
		            var collection = this.collection;
	
		            var startIndex = this.start.index;
	
		            var endIndex = this.end.index;
	
		            var result = 0;
	
		            for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
		               result += collection.at(slotIndex).offsetHeight;
		            }
	
		            return result;
		        },
	
		        events: function () {
		            return this.collection.events();
		        },
	
		        addEvent: function(event) {
		            this.events().push(event);
		        },
	
		        startSlot: function() {
		            if (this.start.offsetLeft > this.end.offsetLeft) {
		                return this.end;
		            }
		            return this.start;
		        },
	
		        endSlot: function() {
		            if (this.start.offsetLeft > this.end.offsetLeft) {
		                return this.start;
		            }
		            return this.end;
		        }
		    });
	
		    var TimeSlotRange = SlotRange.extend({
		        innerHeight: function() {
		            var collection = this.collection;
	
		            var startIndex = this.start.index;
	
		            var endIndex = this.end.index;
	
		            var result = 0;
	
		            for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
		               result += collection.at(slotIndex).offsetHeight;
		            }
	
		            return result;
		        },
	
		        outerRect: function(start, end, snap) {
		            return this._rect("offset", start, end, snap);
		        },
	
		        _rect: function(property, start, end, snap) {
		            var top;
		            var bottom;
		            var left;
		            var right;
		            var startSlot = this.start;
		            var endSlot = this.end;
		            var isRtl = kendo.support.isRtl(startSlot.element);
	
		            if (typeof start != "number") {
		                start = kendo.date.toUtcTime(start);
		            }
	
		            if (typeof end != "number") {
		                end = kendo.date.toUtcTime(end);
		            }
	
		            if (snap) {
		                top = startSlot.offsetTop;
		                bottom = endSlot.offsetTop + endSlot[property + "Height"];
		                if(isRtl) {
		                    left = endSlot.offsetLeft;
		                    right = startSlot.offsetLeft + startSlot[property + "Width"];
		                } else {
		                    left = startSlot.offsetLeft;
		                    right = endSlot.offsetLeft + endSlot[property + "Width"];
		                }
		            } else {
		                var startOffset = start - startSlot.start;
	
		                if (startOffset < 0) {
		                    startOffset = 0;
		                }
	
		                var startSlotDuration = startSlot.end - startSlot.start;
	
		                top = startSlot.offsetTop + startSlot[property + "Height"] * startOffset / startSlotDuration;
	
		                var endOffset = endSlot.end - end;
	
		                if (endOffset < 0) {
		                    endOffset = 0;
		                }
	
		                var endSlotDuration = endSlot.end - endSlot.start;
	
		                bottom = endSlot.offsetTop + endSlot[property + "Height"] - endSlot[property + "Height"] * endOffset / endSlotDuration;
	
		                if(isRtl) {
		                    left = Math.round(endSlot.offsetLeft + endSlot[property + "Width"]* endOffset / endSlotDuration);
		                    right = Math.round(startSlot.offsetLeft + startSlot[property + "Width"] - startSlot[property + "Width"] * startOffset / startSlotDuration);
		                } else {
		                    left = Math.round(startSlot.offsetLeft + startSlot[property + "Width"] * startOffset / startSlotDuration);
		                    right = Math.round(endSlot.offsetLeft + endSlot[property + "Width"] - endSlot[property + "Width"] * endOffset / endSlotDuration);
		                }
		            }
	
		            return {
		                top: top,
		                bottom: bottom,
		                //first column has no left border
		                left: left === 0 ? left : left + 1,
		                right: right
		            };
		        },
	
		        innerRect: function(start, end, snap) {
		            return this._rect("client", start, end, snap);
		        }
		    });
	
		    var DaySlotRange = SlotRange.extend({
		        innerWidth: function() {
		            var collection = this.collection;
	
		            var startIndex = this.start.index;
	
		            var endIndex = this.end.index;
	
		            var result = 0;
	
		            var width = startIndex !== endIndex ? "offsetWidth" : "clientWidth";
	
		            for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
		               result += collection.at(slotIndex)[width];
		            }
	
		            return result;
		        }
		    });
	
		    var SlotCollection = kendo.Class.extend({
		        init: function(startDate, endDate, groupIndex, collectionIndex) {
		            this._slots = [];
	
		            this._events = [];
	
		            this._start = kendo.date.toUtcTime(startDate);
	
		            this._end = kendo.date.toUtcTime(endDate);
	
		            this._groupIndex = groupIndex;
	
		            this._collectionIndex = collectionIndex;
		        },
		        refresh: function() {
		            for (var slotIndex = 0; slotIndex < this._slots.length; slotIndex++) {
		                this._slots[slotIndex].refresh();
		            }
		        },
	
		        startInRange: function(date) {
		            return this._start <= date && date < this._end;
		        },
	
		        endInRange: function(date, isAllDay) {
		            var end = isAllDay ? date < this._end : date <= this._end;
		            return this._start <= date && end;
		        },
	
		        slotByStartDate: function(date) {
		            var time = date;
	
		            if (typeof time != "number") {
		                time = kendo.date.toUtcTime(date);
		            }
	
		            for (var slotIndex = 0; slotIndex < this._slots.length; slotIndex++) {
		                var slot = this._slots[slotIndex];
	
		                if (slot.startInRange(time)) {
		                    return slot;
		                }
		            }
	
		            return null;
		        },
	
		        slotByEndDate: function(date, allday) {
		            var time = date;
	
		            if (typeof time != "number") {
		                time = kendo.date.toUtcTime(date);
		            }
	
		            if (allday) {
		                return this.slotByStartDate(date, false);
		            }
	
		            for (var slotIndex = 0; slotIndex < this._slots.length; slotIndex++) {
		                var slot = this._slots[slotIndex];
	
		                if (slot.endInRange(time)) {
		                    return slot;
		                }
		            }
	
		            return null;
		        },
	
		        count: function() {
		            return this._slots.length;
		        },
		        events: function() {
		            return this._events;
		        },
		        addTimeSlot: function(element, start, end, isHorizontal) {
		            var slot = new TimeSlot(element, start, end, this._groupIndex, this._collectionIndex, this._slots.length, isHorizontal);
	
		            this._slots.push(slot);
		        },
		        addDaySlot: function(element, start, end, eventCount) {
		            var slot = new DaySlot(element, start, end, this._groupIndex, this._collectionIndex, this._slots.length, eventCount);
	
		            this._slots.push(slot);
		        },
		        first: function() {
		            return this._slots[0];
		        },
		        last: function() {
		            return this._slots[this._slots.length - 1];
		        },
		        at: function(index) {
		            return this._slots[index];
		        }
		    });
	
		    var Slot = kendo.Class.extend({
		        init: function(element, start, end, groupIndex, collectionIndex, index) {
		            this.element = element;
		            this.clientWidth = element.clientWidth;
		            this.clientHeight = element.clientHeight;
		            this.offsetWidth = element.offsetWidth;
		            this.offsetHeight = element.offsetHeight;
		            this.offsetTop = element.offsetTop;
		            this.offsetLeft = element.offsetLeft;
	
		            this.start = start;
		            this.end = end;
		            this.element = element;
		            this.groupIndex = groupIndex;
		            this.collectionIndex = collectionIndex;
		            this.index = index;
		            this.isDaySlot = false;
		        },
	
		        refresh: function() {
		            var element = this.element;
	
		            this.clientWidth = element.clientWidth;
		            this.clientHeight = element.clientHeight;
		            this.offsetWidth = element.offsetWidth;
		            this.offsetHeight = element.offsetHeight;
		            this.offsetTop = element.offsetTop;
		            this.offsetLeft = element.offsetLeft;
		        },
	
		        startDate: function() {
		            return kendo.timezone.toLocalDate(this.start);
		        },
	
		        endDate: function() {
		            return kendo.timezone.toLocalDate(this.end);
		        },
	
		        startInRange: function(date) {
		            return this.start <= date && date < this.end;
		        },
	
		        endInRange: function(date) {
		            return this.start < date && date <= this.end;
		        },
	
		        startOffset: function() {
		           return this.start;
		        },
	
		        endOffset: function() {
		            return this.end;
		        }
		    });
	
		    var TimeSlot = Slot.extend({
		        init: function(element, start, end, groupIndex, collectionIndex, index, isHorizontal) {
		            Slot.fn.init.apply(this, arguments);
	
		            this.isHorizontal = isHorizontal ? true : false;
		        },
	
		        offsetX: function(rtl, offset) {
		            if (rtl) {
		                return this.offsetLeft + offset;
		            } else {
		                return this.offsetLeft + offset;
		            }
		        },
	
		        startInRange: function(date) {
		            return this.start <= date && date < this.end;
		        },
	
		        endInRange: function(date) {
		            return this.start < date && date <= this.end;
		        },
	
		        startOffset: function(x, y, snap) {
		            if (snap) {
		                return this.start;
		            }
	
		            var offset = $(this.element).offset();
	
		            var duration = this.end - this.start;
		            var difference;
		            var time;
	
		            if (this.isHorizontal) {
		                //need update
		                var isRtl = kendo.support.isRtl(this.element);
		                difference =  x - offset.left;
		                time = Math.floor(duration * ( difference / this.offsetWidth));
	
		                if (isRtl) {
		                    return this.start + duration - time;
		                }
		            } else {
		                difference = y - offset.top;
		                time = Math.floor(duration * ( difference / this.offsetHeight));
		            }
	
		            return this.start + time;
		        },
	
		        endOffset: function(x, y, snap) {
		            if (snap) {
		                return this.end;
		            }
	
		            var offset = $(this.element).offset();
	
		            var duration = this.end - this.start;
		            var difference;
		            var time;
	
		            if (this.isHorizontal) {
		                //need update
		                var isRtl = kendo.support.isRtl(this.element);
		                difference = x - offset.left;
		                time = Math.floor(duration * ( difference / this.offsetWidth));
	
		                if (isRtl) {
		                    return this.start + duration - time;
		                }
		            } else {
		                difference = y - offset.top;
		                time = Math.floor(duration * ( difference / this.offsetHeight));
		            }
	
		            return this.start + time;
		        }
		    });
	
		    var DaySlot = Slot.extend({
		        init: function(element, start, end, groupIndex, collectionIndex, index, eventCount) {
		            Slot.fn.init.apply(this, arguments);
	
		            this.eventCount = eventCount;
		            this.isDaySlot = true;
	
		            if (this.element.children.length) {
		                var firstChild = this.element.children[0];
	
		                this.firstChildHeight = firstChild.offsetHeight;
		                this.firstChildTop = firstChild.offsetTop;
		            } else {
		                this.firstChildHeight = 3;
		                this.firstChildTop = 0;
		            }
		        },
	
		        startDate: function() {
		            var date = new Date(this.start);
	
		            return kendo.timezone.apply(date, "Etc/UTC");
		        },
	
		        endDate: function() {
		            var date = new Date(this.end);
	
		            return kendo.timezone.apply(date, "Etc/UTC");
		        },
	
		        startInRange: function(date) {
		            return this.start <= date && date < this.end;
		        },
	
		        endInRange: function(date) {
		            return this.start < date && date <= this.end;
		        }
		    });
	
		    var scrollbarWidth;
		    function scrollbar() {
		        scrollbarWidth = scrollbarWidth ? scrollbarWidth : kendo.support.scrollbar();
		        return scrollbarWidth;
		    }
	
		    kendo.ui.SchedulerView = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this._normalizeOptions();
		            this._scrollbar = scrollbar();
		            this._isRtl = kendo.support.isRtl(element);
		            this._resizeHint = $();
		            this._moveHint = $();
		            this._cellId = kendo.guid();
		            this._resourcesForGroups();
		            this._selectedSlots = [];
		        },
	
		        visibleEndDate: function () {
		            return this.endDate();
		        },
	
		        _normalizeOptions: function() {
		            var options = this.options;
	
		            if (options.startTime) {
		                options.startTime.setMilliseconds(0);
		            }
	
		            if (options.endTime) {
		                options.endTime.setMilliseconds(0);
		            }
	
		            if (options.workDayStart) {
		                options.workDayStart.setMilliseconds(0);
		            }
	
		            if (options.workDayEnd) {
		                options.workDayEnd.setMilliseconds(0);
		            }
		        },
	
		        _isMobile: function() {
		            var options = this.options;
		            return (options.mobile === true && kendo.support.mobileOS) || options.mobile === "phone" || options.mobile === "tablet";
		        },
	
		        _isMobilePhoneView: function() {
		            var options = this.options;
		            return (options.mobile === true && kendo.support.mobileOS && !kendo.support.mobileOS.tablet) || options.mobile === "phone";
		        },
	
		        _addResourceView: function() {
		            var resourceView = new ResourceView(this.groups.length, this._isRtl);
	
		            this.groups.push(resourceView);
	
		            return resourceView;
		        },
	
		        dateForTitle: function() {
		            return kendo.format(this.options.selectedDateFormat, this.startDate(), this.endDate());
		        },
	
		        shortDateForTitle: function() {
		            return kendo.format(this.options.selectedShortDateFormat, this.startDate(), this.endDate());
		        },
	
		        _changeGroup: function(selection, previous) {
		            var method = previous ? "prevGroupSlot" : "nextGroupSlot";
		            var slot = this[method](selection.start, selection.groupIndex, selection.isAllDay);
	
		            if (slot) {
		                selection.groupIndex += previous ? -1 : 1;
		            }
	
		            if (this._isGroupedByDate() && !slot) {
		               selection.groupIndex = previous ? this.groups.length - 1 : 0;
		            }
	
		            return slot;
		        },
	
		        _changeDate: function(selection, slot, previous) {
		            var group = this.groups[selection.groupIndex];
		            var collections, index;
	
		            if (previous) {
		                  collections = group._getCollections(false);
		                  index = group.daySlotCollectionCount() ? slot.index - 1 : slot.collectionIndex - 1;
	
		                  if (index >= 0) {
		                      return  collections[index]._slots[collections[index]._slots.length - 1];
		                  }
		              } else {
		                  collections = group._getCollections(group.daySlotCollectionCount());
		                  index = group.daySlotCollectionCount() ? 0 : slot.collectionIndex + 1;
		                  var slotIndex = group.daySlotCollectionCount() ? slot.collectionIndex + 1 : 0;
	
		                  if (collections[index] && collections[index]._slots[slotIndex]) {
		                      return  collections[index]._slots[slotIndex];
		                  }
		               }
		        },
	
		        _changeGroupContinuously: function() {
		            return null;
		        },
	
		        _changeViewPeriod: function() {
		            return false;
		        },
	
		        _isInRange: function(newStart, newEnd) {
		            if(!newStart || !newEnd || !this.options.min || !this.options.max){
		                return false;
		            }
		            return getDate(newStart) <= getDate(this.options.min) || getDate(newEnd) >= getDate(this.options.max);
		        },
	
		        _horizontalSlots: function(selection, ranges, multiple, reverse) {
		            var method = reverse ? "leftSlot" : "rightSlot";
		            var horizontalRange = {
		                 startSlot: ranges[0].start,
		                 endSlot: ranges[ranges.length - 1].end
		             };
		            var group = this.groups[selection.groupIndex];
		            var isVertical = this._isVerticallyGrouped();
	
		            if (!multiple) {
		                var slot = this._normalizeHorizontalSelection(selection, ranges, reverse);
		                if (slot) {
		                    horizontalRange.startSlot = horizontalRange.endSlot = slot;
		                }
		            }
	
		            if (this._isGroupedByDate() && !multiple) {
		                  var tempSlot = this._changeGroup(selection, reverse);
	
		                  if(!tempSlot)
		                  {
		                    horizontalRange = this._getNextHorizontalRange(group, method, horizontalRange);
		                  } else {
		                      horizontalRange.startSlot = horizontalRange.endSlot = tempSlot;
		                  }
		            } else {
		                  horizontalRange.startSlot = group[method](horizontalRange.startSlot);
		                  horizontalRange.endSlot = group[method](horizontalRange.endSlot);
	
		                  if (!multiple && !isVertical && (!horizontalRange.startSlot || !horizontalRange.endSlot)) {
		                        horizontalRange.startSlot = horizontalRange.endSlot = this._changeGroup(selection, reverse);
		                  }
		            }
	
		            var continuousSlot;
	
		            if ((!horizontalRange.startSlot || !horizontalRange.endSlot) && !this._isGroupedByDate()) {
		                continuousSlot = this._continuousSlot(selection, ranges, reverse);
		                continuousSlot = this._changeGroupContinuously(selection, continuousSlot, multiple, reverse);
	
		                if (continuousSlot) {
		                    horizontalRange.startSlot = horizontalRange.endSlot = continuousSlot;
		                }
		            }
	
		            return horizontalRange;
		        },
	
		         _getNextHorizontalRange: function(group, method, horizontalRange){
		            if(!this._isVerticallyGrouped()){
		                horizontalRange.startSlot = group[method](horizontalRange.startSlot);
		                horizontalRange.endSlot = group[method](horizontalRange.endSlot);
		            }
	
		             return horizontalRange;
		        },
	
		        _verticalSlots: function(selection, ranges, multiple, reverse) {
		            var group = this.groups[selection.groupIndex];
		            var slot;
		            var verticalRange = {
		                startSlot: ranges[0].start,
		                endSlot: ranges[ranges.length - 1].end
		            };
	
		            if (!multiple) {
		                slot = this._normalizeVerticalSelection(selection, ranges, reverse);
		                if (slot) {
		                    verticalRange.startSlot = verticalRange.endSlot = slot;
		                }
		            }
	
		            var method = reverse ? "upSlot" : "downSlot";
	
		            verticalRange = this._getNextVerticalRange(group, method, verticalRange, multiple);
	
		            if (!multiple && this._isVerticallyGrouped() && (!verticalRange.startSlot || !verticalRange.endSlot)) {
		                if (this._isGroupedByDate()) {
		                    verticalRange.startSlot = verticalRange.endSlot = this._changeDate(selection, slot, reverse);
	
		               }else{
		                    verticalRange.startSlot = verticalRange.endSlot = this._changeGroup(selection, reverse);
		               }
		            }
	
		            return verticalRange;
		        },
	
		        _getNextVerticalRange: function(group, method, verticalRange, multiple){
		             verticalRange.startSlot = group[method](verticalRange.startSlot, multiple);
		             verticalRange.endSlot = group[method](verticalRange.endSlot, multiple);
	
		             return verticalRange;
		        },
	
		        _normalizeHorizontalSelection: function() {
		            return null;
		        },
	
		        _normalizeVerticalSelection: function(selection, ranges, reverse) {
		            var slot;
	
		            if (reverse) {
		                slot = ranges[0].start;
		            } else {
		                slot = ranges[ranges.length - 1].end;
		            }
	
		            return slot;
		        },
	
		        _continuousSlot: function() {
		            return null;
		        },
	
		        constrainSelection: function(selection) {
		            var group = this.groups[0];
		            var slot;
	
		            if (!this.inRange(selection)) {
		               slot = group.firstSlot();
	
		               selection.isAllDay = slot.isDaySlot;
		               selection.start = slot.startDate();
		               selection.end = slot.endDate();
		            } else {
		                if (!group.daySlotCollectionCount()) {
		                    selection.isAllDay = false;
		                } else if (!group.timeSlotCollectionCount()) {
		                    selection.isAllDay = true;
		                }
		           }
	
		            if (!this.groups[selection.groupIndex]) {
		                selection.groupIndex = 0;
		            }
		        },
	
		        move: function(selection, key, shift) {
		            var handled = false;
		            var group = this.groups[selection.groupIndex];
		            var verticalByDate = this._isGroupedByDate()  && this._isVerticallyGrouped();
	
		            if (!group.timeSlotCollectionCount()) {
		                selection.isAllDay = true;
		            }
	
		            var ranges = group.ranges(selection.start, selection.end, selection.isAllDay, false);
		            var startSlot, endSlot, reverse, slots;
	
		            if (key === keys.DOWN || key === keys.UP) {
		                handled = true;
		                reverse = key === keys.UP;
	
		                this._updateDirection(selection, ranges, shift, reverse, true);
	
		                slots = this._verticalSlots(selection, ranges, shift, reverse);
	
		                if (!slots.startSlot && !shift && this._changeViewPeriod(selection, reverse, !verticalByDate)) {
		                    return handled;
		                }
	
		            } else if (key === keys.LEFT || key === keys.RIGHT) {
		                handled = true;
		                reverse = key === keys.LEFT;
	
		                this._updateDirection(selection, ranges, shift, reverse, false);
	
		                slots = this._horizontalSlots(selection, ranges, shift, reverse);
	
		                if (!slots.startSlot && !shift && this._changeViewPeriod(selection, reverse, verticalByDate)) {
		                    return handled;
		                }
		            }
	
		            if (handled) {
		                startSlot = slots.startSlot;
		                endSlot = slots.endSlot;
	
		                if (shift) {
		                    var backward = selection.backward;
		                    if (backward && startSlot) {
		                        selection.start = startSlot.startDate();
		                    } else if (!backward && endSlot) {
		                        selection.end = endSlot.endDate();
		                    }
		                } else if (startSlot && endSlot) {
		                    selection.isAllDay = startSlot.isDaySlot;
		                    selection.start = startSlot.startDate();
		                    selection.end = endSlot.endDate();
		                }
	
		                selection.events = [];
		            }
	
		            return handled;
		        },
	
		        moveToEventInGroup: function(group, slot, selectedEvents, prev) {
		            var events = group._continuousEvents || [];
	
		            var found, event;
	
		            var pad = prev ? -1 : 1;
	
		            var length = events.length;
		            var idx = prev ? length - 1 : 0;
	
		            if (selectedEvents.length) {
		                var lastSelected = selectedEvents[selectedEvents.length - 1];
	
		                for (var i = 0; i < events.length; i++) {
		                    if (events[i].uid === lastSelected) {
		                        idx = i + pad;
		                    }
		                }
		            }
	
		            while (idx < length && idx > -1) {
		                event = events[idx];
	
		                if ( (!prev && event.start.startDate() >= slot.startDate()) ||
		                    (prev && event.start.startDate() <= slot.startDate()) ) {
	
		                    if (event && $.inArray(event.uid, selectedEvents) === -1) {
		                        found = !!event;
		                        break;
		                    }
		                }
	
		                idx += pad;
		            }
	
		            return event;
		        },
	
		        moveToEvent: function(selection, prev) {
		            var groupIndex = selection.groupIndex;
	
		            var group = this.groups[groupIndex];
		            var slot = group.ranges(selection.start, selection.end, selection.isAllDay, false)[0].start;
	
		            var length = this.groups.length;
		            var pad = prev ? -1 : 1;
		            var events = selection.events;
		            var event;
	
		            if (this._isGroupedByDate()) {
		                var allEvents = this._getAllEvents();
		                var uniqueAllEvents = this._getUniqueEvents(allEvents);
		                var sortedEvents = this._getSortedEvents(uniqueAllEvents);
	
		                if(events.length === 0){
		                    var eventIndex = this._getNextEventIndexBySlot(slot, sortedEvents, groupIndex);
	
		                    if(prev){
		                        eventIndex--;
		                    }
	
		                    event = sortedEvents[eventIndex];
		                } else{
		                     var idx = this._getStartIdx(events, sortedEvents);
	
		                    while (idx < sortedEvents.length && idx > -1) {
		                        if(events.length > 0){
		                            slot = this._getSelectedSlot(slot, sortedEvents, event, idx, pad, prev);
		                        }
	
		                        if(!slot){
		                            break;
		                        }
	
		                        if ( (!prev && sortedEvents[idx].start.startDate() >= slot.startDate()) ||
		                              (prev && sortedEvents[idx].start.startDate() <= slot.startDate())) {
		                             if (events[0] != sortedEvents[idx].uid) {
		                                 event = sortedEvents[idx];
		                                  break;
		                             }
		                        }
		                        idx += pad;
		                    }
		                }
		            } else {
		                  while (groupIndex < length && groupIndex > -1) {
		                    event = this.moveToEventInGroup(group, slot, events, prev);
	
		                    groupIndex += pad;
		                    group = this.groups[groupIndex];
	
		                    if (!group || event) {
		                        break;
		                    }
	
		                    events = [];
		                    if (prev) {
		                        slot = group.lastSlot();
		                    } else {
		                        slot = group.firstSlot(true);
		                    }
		                }
		            }
	
		            if (event) {
		                selection.events = [ event.uid ];
		                selection.start = event.start.startDate();
		                selection.end = event.end.endDate();
		                selection.isAllDay = event.start.isDaySlot;
		                selection.groupIndex = event.start.groupIndex;
		            }
	
		            return !!event;
		        },
	
		        current: function(candidate) {
		            if (candidate !== undefined) {
		                this._current = candidate;
		                if (this.content.has(candidate)) {
		                    this._scrollTo(candidate, this.content[0]);
		                }
		            } else {
		                return this._current;
		            }
		        },
	
		        select: function(selection) {
		            this.clearSelection();
	
		            if (!this._selectEvents(selection)) {
		                this._selectSlots(selection);
		            }
		        },
	
		        _getNextEventIndexBySlot: function(slot, sortedEvents, groupIndex){
		            var tempIndex = 0;
		            var slotStartDate = kendo.date.getDate(slot.startDate());
	
		            for (var i = 0; i < sortedEvents.length; i++) {
		                var eventStartDate = kendo.date.getDate(sortedEvents[i].start.startDate());
		                if (slotStartDate > eventStartDate) {
		                    tempIndex++;
		                    continue;
		                }
	
		                if (slotStartDate.getTime() === eventStartDate.getTime() && groupIndex > sortedEvents[i].start.groupIndex) {
		                      tempIndex++;
		                      continue;
		                }
	
		                if (slotStartDate.getTime() === eventStartDate.getTime() &&
		                    groupIndex >= sortedEvents[i].start.groupIndex &&
		                    slot.startDate() > sortedEvents[i].start.startDate()) {
		                    tempIndex++;
		                    continue;
		                 }
	
		                 break;
		            }
		            return tempIndex;
		        },
	
		        _getSelectedSlot: function(slot, sortedEvents, event, idx, pad, prev) {
		              if (sortedEvents[idx + pad] &&
		               sortedEvents[idx].start.groupIndex !== sortedEvents[idx + pad].start.groupIndex) {
		                    var groupIndex = sortedEvents[idx + pad].start.groupIndex;
		                    var group = this.groups[groupIndex];
	
		                    if (!group || event) {
		                       slot = null;
		                    }
	
		                    if (prev) {
		                        slot = group.lastSlot();
		                    } else {
		                        slot = group.firstSlot(true);
		                    }
		                }
		             return slot;
		        },
	
		        _getStartIdx: function(events, sortedEvents){
		            var selectedEventIndex = 0;
	
		            $.each(sortedEvents, function() {
		                if (this.uid === events[0]){
		                     return false;
		                }
	
		                selectedEventIndex++;
		            });
	
		            return selectedEventIndex;
		        },
	
		        _getAllEvents: function(){
		            var allEvents = [];
		            var groups = this.groups;
	
		            for (var idx = 0; idx < groups.length; idx++) {
		                if (groups[idx]._continuousEvents) {
		                    allEvents= allEvents.concat(groups[idx]._continuousEvents);
		                }
		            }
	
		            return allEvents;
		        },
	
		        _getUniqueEvents: function(allEvents){
		            var uniqueAllEvents = [];
	
		            for (var i = 0; i < allEvents.length; i++) {
		                var exists = false;
		                for (var j = 0; j < uniqueAllEvents.length; j++) {
		                    if (allEvents[i].uid === uniqueAllEvents[j].uid) {
		                        exists = true;
		                        break;
		                    }
		                }
	
		                if (!exists) {
		                    uniqueAllEvents.push(allEvents[i]);
		                }
		            }
	
		            return uniqueAllEvents;
		        },
	
		        _getSortedEvents: function(uniqueAllEvents){
		             return uniqueAllEvents.sort(function(first, second) {
		                var firstStartDate = first.start.startDate();
		                var secondStartDate = second.start.startDate();
		                var result = kendo.date.getDate(firstStartDate) - kendo.date.getDate(secondStartDate);
	
		                if (result === 0) {
		                    result = first.start.groupIndex - second.start.groupIndex;
		                }
	
		                if (result === 0) {
		                    result = firstStartDate.getTime() - secondStartDate.getTime();
		                }
	
		                if (result === 0) {
		                    if (first.start.isDaySlot && !second.start.isDaySlot) {
		                            result = -1;
		                    }
	
		                    if (!first.start.isDaySlot && second.start.isDaySlot) {
		                            result = 1;
		                    }
		                }
	
		                if (result === 0) {
		                    result = $(first.element).index() - $(second.element).index();
		                }
	
		                return result;
		            });
		        },
	
		        _selectSlots: function(selection) {
		            var isAllDay = selection.isAllDay;
		            var group = this.groups[selection.groupIndex];
	
		            if (!group.timeSlotCollectionCount()) {
		                isAllDay = true;
		            }
	
		            this._selectedSlots = [];
	
		            var ranges = group.ranges(selection.start, selection.end, isAllDay, false);
		            var element;
		            var slot;
	
		            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
		                var range = ranges[rangeIndex];
		                var collection = range.collection;
	
		                for (var slotIndex = range.start.index; slotIndex <= range.end.index; slotIndex++) {
		                    slot = collection.at(slotIndex);
	
		                    element = slot.element;
		                    element.setAttribute("aria-selected", true);
		                    addSelectedState(element);
	
		                    this._selectedSlots.push({
		                        start: slot.startDate(),
		                        end: slot.endDate(),
		                        element: element
		                    });
		                }
		            }
	
		            if (selection.backward) {
		                element = ranges[0].start.element;
		            }
	
		            this.current(element);
		        },
	
		        _selectEvents: function(selection) {
		            var found = false;
		            var events = selection.events;
		            var groupEvents = this._getAllEvents();
		            var idx, groupEvent, length = groupEvents.length;
	
		            if (!events[0] || !groupEvents[0]) {
		                return found;
		            }
	
		            var result = $();
		            selection.events = [];
		            for (idx = 0; idx < length; idx ++) {
		                if ($.inArray(groupEvents[idx].uid, events) > -1) {
		                    groupEvent = groupEvents[idx];
		                    result = result.add(groupEvent.element);
		                    if(selection.events.indexOf(groupEvent.uid) === -1){
		                        selection.events.push(groupEvent.uid);
		                    }
		                }
		            }
	
		            if (result[0]) {
		                result.addClass("k-state-selected").attr("aria-selected", true);
		                this.current(result.last()[0]);
		                this._selectedSlots = [];
		                found = true;
		            }
	
		            return found;
		        },
	
		        inRange: function(options) {
		            var startDate = this.startDate();
		            var endDate = kendo.date.addDays(this.endDate(), 1);
		            var start = options.start;
		            var end = options.end;
	
		            return startDate <= start && start < endDate && startDate < end && end <= endDate;
		        },
	
		        _resourceValue: function(resource, item) {
		            if (resource.valuePrimitive) {
		                item = kendo.getter(resource.dataValueField)(item);
		            }
		            return item;
		        },
	
		        _resourceBySlot: function(slot) {
		            var resources = this.groupedResources;
		            var result = {};
	
		            if (resources.length) {
		                var resourceIndex = slot.groupIndex;
	
		                for (var idx = resources.length - 1; idx >=0; idx--) {
		                    var resource = resources[idx];
	
		                    var value = this._resourceValue(resource, resource.dataSource.view()[resourceIndex % resource.dataSource.total()]);
	
		                    if (resource.multiple) {
		                        value = [value];
		                    }
	
		                    var setter = kendo.setter(resource.field);
		                    setter(result, value);
	
		                    resourceIndex = Math.floor(resourceIndex / resource.dataSource.total());
		                }
		            }
	
		            return result;
		        },
	
		        _createResizeHint: function(left, top, width, height) {
		            return $(HINT).css({
		                left: left,
		                top: top,
		                width: width,
		                height: height
		            });
		        },
	
		        _removeResizeHint: function() {
		            this._resizeHint.remove();
		            this._resizeHint = $();
		        },
	
		        _removeMoveHint: function (uid) {
		            if (uid) {
		                this._moveHint.filter("[data-uid='" + uid + "']").remove();
	
		                this._moveHint = this._moveHint.filter("[data-uid!='" + uid + "']");
		            } else {
		                this._moveHint.remove();
		                this._moveHint = $();
		            }
		        },
	
		        _scrollTo: function(element, container) {
		            var elementOffset = element.offsetTop,
		                elementOffsetDir = element.offsetHeight,
		                containerScroll = container.scrollTop,
		                containerOffsetDir = container.clientHeight,
		                bottomDistance = elementOffset + elementOffsetDir,
		                result = 0;
	
		                if (containerScroll > elementOffset) {
		                    result = elementOffset;
		                } else if (bottomDistance > (containerScroll + containerOffsetDir)) {
		                    if (elementOffsetDir <= containerOffsetDir) {
		                        result = (bottomDistance - containerOffsetDir);
		                    } else {
		                        result = elementOffset;
		                    }
		                } else {
		                    result = containerScroll;
		                }
		                container.scrollTop = result;
		        },
	
		        _shouldInverseResourceColor: function(resource) {
		            var resourceColorIsDark = new Color(resource.color).isDark();
		            var currentColor = this.element.css("color");
		            var currentColorIsDark = new Color(currentColor).isDark();
	
		            return (resourceColorIsDark == currentColorIsDark);
		        },
	
		       _eventTmpl: function(template, wrapper) {
		           var options = this.options,
		               settings = $.extend({}, kendo.Template, options.templateSettings),
		               paramName = settings.paramName,
		               html = "",
		               type = typeof template,
		               state = { storage: {}, count: 0 };
	
		            if (type === "function") {
		                state.storage["tmpl" + state.count] = template;
		                html += "#=this.tmpl" + state.count + "(" + paramName + ")#";
		                state.count ++;
		            } else if (type === "string") {
		                html += template;
		            }
	
		            var tmpl = kendo.template(kendo.format(wrapper, html), settings);
	
		            if (state.count > 0) {
		                tmpl = $.proxy(tmpl, state.storage);
		            }
	
		            return tmpl;
		       },
	
		        eventResources: function(event) {
		            var resources = [],
		                options = this.options;
	
		            if (!options.resources) {
		                return resources;
		            }
	
		            for (var idx = 0; idx < options.resources.length; idx++) {
		                var resource = options.resources[idx];
		                var field = resource.field;
		                var eventResources = kendo.getter(field)(event);
	
		                if (eventResources == null) {
		                    continue;
		                }
	
		                if (!resource.multiple) {
		                    eventResources = [eventResources];
		                }
	
		                var data = resource.dataSource.view();
	
		                for (var resourceIndex = 0; resourceIndex < eventResources.length; resourceIndex++) {
		                    var eventResource = null;
	
		                    var value = eventResources[resourceIndex];
	
		                    if (!resource.valuePrimitive) {
		                        value = kendo.getter(resource.dataValueField)(value);
		                    }
	
		                    for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
		                        if (data[dataIndex].get(resource.dataValueField) == value) {
		                            eventResource = data[dataIndex];
		                            break;
		                        }
		                    }
	
		                    if (eventResource !== null) {
		                        var resourceColor = kendo.getter(resource.dataColorField)(eventResource);
		                        resources.push({
		                            field: resource.field,
		                            title: resource.title,
		                            name: resource.name,
		                            text: kendo.getter(resource.dataTextField)(eventResource),
		                            value: value,
		                            color: resourceColor
		                        });
		                    }
		                }
		            }
		            return resources;
		        },
	
		        createLayout: function(layout) {
		            var allDayIndex = -1;
	
		            if (!layout.rows) {
		                layout.rows = [];
		            }
	
		            for (var idx = 0; idx < layout.rows.length; idx++) {
		                if (layout.rows[idx].allDay) {
		                    allDayIndex = idx;
		                    break;
		                }
		            }
	
		            var allDaySlot = layout.rows[allDayIndex];
	
		            if (allDayIndex >= 0) {
		                layout.rows.splice(allDayIndex, 1);
		            }
	
		            var columnLevels = this.columnLevels = levels(layout, "columns");
	
		            var rowLevels = this.rowLevels = levels(layout, "rows");
	
		            this.table = $('<table ' + cellspacing() + ' class="k-scheduler-layout k-scheduler-' + this.name + 'view"><tbody></tbody></table>');
	
		            var rowCount = rowLevels[rowLevels.length - 1].length;
	
		            this.table.find("tbody:first").append(this._topSection(columnLevels, allDaySlot, rowCount));
	
		            this.table.find("tbody:first").append(this._bottomSection(columnLevels, rowLevels, rowCount));
	
		            this.element.append(this.table);
	
		            this._scroller();
		        },
	
		        refreshLayout: function() {
		            var that = this,
		                toolbar = that.element.find(">.k-scheduler-toolbar"),
		                height = that.element.innerHeight(),
		                scrollbar = this._scrollbar,
		                headerHeight = 0,
		                paddingDirection = this._isRtl ? "left" : "right";
	
		            for (var idx = 0; idx < toolbar.length; idx++) {
		                height -= outerHeight(toolbar.eq(idx));
		            }
	
		            if (that.datesHeader) {
		                headerHeight = outerHeight(that.datesHeader);
		            }
	
		            if (that.timesHeader && outerHeight(that.timesHeader) > headerHeight) {
		                headerHeight = outerHeight(that.timesHeader);
		            }
	
		            if (that.datesHeader && that.timesHeader) {
		                var datesHeaderRows = that.datesHeader.find("table:first tr");
	
		                that.timesHeader.find("tr").height(function(index) {
		                    $(this).height(datesHeaderRows.eq(index).height());
		                });
		            }
	
		            if (headerHeight) {
		                height -= headerHeight;
		            }
	
		            if (that.footer) {
		                height -= outerHeight(that.footer);
		            }
	
		            var isSchedulerHeightSet = function(el) {
		                var initialHeight, newHeight;
		                if (el[0].style.height) {
		                    return true;
		                } else {
		                    initialHeight = el.height();
		                }
	
		                el.height("auto");
		                newHeight = el.height();
	
		                if (initialHeight != newHeight) {
		                    el.height("");
		                    return true;
		                }
		                el.height("");
		                return false;
		            };
	
		            var contentDiv = that.content[0],
		                scrollbarWidth = !kendo.support.kineticScrollNeeded ? scrollbar : 0;
	
		            if (isSchedulerHeightSet(that.element)) { // set content height only if needed
		                if (height > scrollbar * 2) { // do not set height if proper scrollbar cannot be displayed
		                    that.content.height(height);
		                } else {
		                    that.content.height(scrollbar * 2 + 1);
		                }
		                that.times.height(contentDiv.clientHeight);
	
		                var timesTable = that.times.find("table");
		                if (timesTable.length) {
		                    timesTable.height(that.content.find("table")[0].clientHeight);
		                }
		            }
	
	
		            if (contentDiv.offsetWidth - contentDiv.clientWidth > 0) {
		                that.table.addClass("k-scrollbar-v");
		                that.datesHeader.css("padding-" + paddingDirection, scrollbarWidth - parseInt(that.datesHeader.children().css("border-" + paddingDirection + "-width"), 10));
		            } else {
		                that.datesHeader.css("padding-" + paddingDirection, "");
		            }
		            if (contentDiv.offsetHeight - contentDiv.clientHeight > 0 || contentDiv.clientHeight > that.content.children(".k-scheduler-table").height()) {
		                that.table.addClass("k-scrollbar-h");
		            } else {
		                that.table.removeClass("k-scrollbar-h");
		            }
		        },
	
		        _topSection: function(columnLevels, allDaySlot, rowCount) {
		            this.timesHeader = timesHeader(columnLevels.length, allDaySlot, rowCount);
	
		            var columnCount = columnLevels[columnLevels.length - 1].length;
	
		            this.datesHeader = datesHeader(columnLevels, columnCount, allDaySlot);
	
		            return $("<tr>").append(this.timesHeader.add(this.datesHeader).wrap("<td>").parent());
		        },
	
		        _bottomSection: function(columnLevels, rowLevels, rowCount) {
		            this.times = times(rowLevels, rowCount);
	
		            this.content = content(columnLevels[columnLevels.length - 1], rowLevels[rowLevels.length - 1]);
	
		            return $("<tr>").append(this.times.add(this.content).wrap("<td>").parent());
		        },
	
		        _scroller: function() {
		            var that = this;
	
		            this.content.bind("scroll" + NS, function () {
		                that.datesHeader.find(">.k-scheduler-header-wrap").scrollLeft(this.scrollLeft);
		                that.times.scrollTop(this.scrollTop);
		            });
	
		            var touchScroller = kendo.touchScroller(this.content, {
		                avoidScrolling: function(e) {
		                    return $(e.event.target).closest(".k-event.k-event-active").length > 0;
		                }
		            });
	
		            if (touchScroller && touchScroller.movable) {
	
		                this._touchScroller = touchScroller;
	
		                this.content = touchScroller.scrollElement;
	
		                touchScroller.movable.bind("change", function(e) {
		                    that.datesHeader.find(">.k-scheduler-header-wrap").scrollLeft(-e.sender.x);
		                    that.times.scrollTop(-e.sender.y);
		                });
		            }
		        },
	
		        _resourcesForGroups: function() {
		            var result = [];
		            var groups = this.options.group;
		            var resources = this.options.resources;
	
		            groups = groups && groups.resources ? groups.resources : [];
	
		            if (resources && groups.length) {
		                for (var idx = 0, length = resources.length; idx < length; idx++) {
		                    for (var groupIdx = 0, groupLength = groups.length; groupIdx < groupLength; groupIdx++) {
		                        if (resources[idx].name === groups[groupIdx]) {
		                            result.push(resources[idx]);
		                        }
		                    }
		                }
		            }
	
		            this.groupedResources = result;
		        },
	
		        _createDateLayout: function(dates, inner, times) {
		            return createDateLayoutConfiguration("rows", dates, inner, times);
		        },
	
		        _createColumnsLayout: function(resources, inner, template, dates, times) {
		            return createLayoutConfiguration("columns", resources, inner, template, dates, times);
		        },
	
		        _groupOrientation: function() {
		            var groups = this.options.group;
		            return groups && groups.resources ? groups.orientation : "horizontal";
		        },
	
		        _isGroupedByDate: function() {
		            return this.options.group && this.options.group.date;
		        },
	
		        _isVerticallyGrouped: function() {
		            return this.groupedResources.length && this._groupOrientation() === "vertical";
		        },
	
		        _createRowsLayout: function(resources, inner, template, dates) {
		            return createLayoutConfiguration("rows", resources, inner, template, dates);
		        },
	
		        selectionByElement: function() {
		            return null;
		        },
	
		        clearSelection: function() {
		            this.content
		                .find(".k-state-selected")
		                .removeAttr("id")
		                .attr("aria-selected", false)
		                .removeClass("k-state-selected");
		        },
	
		        destroy: function() {
		            var that = this;
	
		            Widget.fn.destroy.call(this);
	
		            if (that.table) {
		                kendo.destroy(that.table);
		                that.table.remove();
		            }
	
		            that.groups = null;
		            that.table = null;
		            that.content = null;
		            that.times = null;
		            that.datesHeader = null;
		            that.timesHeader = null;
		            that.footer = null;
		            that._resizeHint = null;
		            that._moveHint = null;
		        },
	
		        calendarInfo: function() {
		            return kendo.getCulture().calendars.standard;
		        },
	
		        prevGroupSlot: function(date, groupIndex, isDay) {
		            var collection;
		            var group = this.groups[groupIndex];
		            var slot = group.ranges(date, date, isDay, false)[0].start;
	
		            if (groupIndex <= 0) {
		                return;
		            }
	
		            if (this._isGroupedByDate()) {
		               return slot;
		            }
	
		            if (this._isVerticallyGrouped()) {
		                if (!group.timeSlotCollectionCount()) {
		                    collection = group._collection(group.daySlotCollectionCount() - 1, true);
		                    return collection.at(slot.index);
		                } else {
		                    collection = group._collection(isDay ? slot.index : slot.collectionIndex, false);
		                    return collection.last();
		                }
		            } else {
		                if (!group.timeSlotCollectionCount()) {
		                    collection = group._collection(slot.collectionIndex, true);
		                    return collection.last();
		                } else {
		                    collection = group._collection(isDay ? 0 : group.timeSlotCollectionCount() - 1, isDay);
		                    return isDay ? collection.last() : collection.at(slot.index);
		                }
		            }
		        },
	
		        nextGroupSlot: function(date, groupIndex, isDay) {
		            var collection;
		            var group = this.groups[groupIndex];
		            var slot = group.ranges(date, date, isDay, false)[0].start;
		            var daySlotCollectionCount;
	
		            if (groupIndex >= this.groups.length - 1) {
		                return;
		            }
	
		            if (this._isGroupedByDate()) {
		               return slot;
		            }
	
		            if (this._isVerticallyGrouped()) {
		                if (!group.timeSlotCollectionCount()) {
		                    collection = group._collection(0, true);
		                    return collection.at(slot.index);
		                } else {
		                    daySlotCollectionCount = group.daySlotCollectionCount();
		                    collection = group._collection(daySlotCollectionCount ? 0 : slot.collectionIndex, daySlotCollectionCount);
	
		                    return isDay ? collection.first() : collection.at(slot.collectionIndex);
		                }
		            } else {
		                if (!group.timeSlotCollectionCount()) {
		                    collection = group._collection(slot.collectionIndex, true);
		                    return collection.first();
		                } else {
		                    collection = group._collection(0, isDay);
		                    return isDay ? collection.first() : collection.at(slot.index);
		                }
		            }
		        },
	
		        _eventOptionsForMove: function () {
		            return {};
		        },
	
		        _updateEventForResize: function () {
		            return;
		        },
	
		        _updateEventForSelection: function (event) {
		            return event;
		        }
		    });
	
		    function collidingEvents(elements, start, end) {
		        var idx,
		            index,
		            startIndex,
		            overlaps,
		            endIndex;
	
		        for (idx = elements.length-1; idx >= 0; idx--) {
		            index = rangeIndex(elements[idx]);
		            startIndex = index.start;
		            endIndex = index.end;
	
		            overlaps = startIndex <= start && endIndex >= start;
	
		            if (overlaps || (startIndex >= start && endIndex <= end) || (start <= startIndex && end >= startIndex)) {
		                if (startIndex < start) {
		                    start = startIndex;
		                }
	
		                if (endIndex > end) {
		                    end = endIndex;
		                }
		            }
		        }
	
		        return eventsForSlot(elements, start, end);
		    }
	
		    function rangeIndex(eventElement) {
		        return {
		            start: eventElement.start,
		            end: eventElement.end
		        };
		    }
	
		    function eventsForSlot(elements, slotStart, slotEnd) {
		        var events = [];
	
		        for (var idx = 0; idx < elements.length; idx++) {
		            var event = rangeIndex(elements[idx]);
	
		            if ((event.start < slotStart && event.end > slotStart) || (event.start >= slotStart && event.end <= slotEnd)) {
		                events.push(elements[idx]);
		            }
		        }
	
		        return events;
		    }
	
		    function createColumns(eventElements) {
		        return _createColumns(eventElements);
		    }
	
		    function createRows(eventElements) {
		        return _createColumns(eventElements);
		    }
	
		    var Color = function(value) {
		        var color = this,
		            formats = Color.formats,
		            re,
		            processor,
		            parts,
		            i,
		            channels;
	
		        if (arguments.length === 1) {
		            value = color.resolveColor(value);
	
		            for (i = 0; i < formats.length; i++) {
		                re = formats[i].re;
		                processor = formats[i].process;
		                parts = re.exec(value);
	
		                if (parts) {
		                    channels = processor(parts);
		                    color.r = channels[0];
		                    color.g = channels[1];
		                    color.b = channels[2];
		                }
		            }
		        } else {
		            color.r = arguments[0];
		            color.g = arguments[1];
		            color.b = arguments[2];
		        }
	
		        color.r = color.normalizeByte(color.r);
		        color.g = color.normalizeByte(color.g);
		        color.b = color.normalizeByte(color.b);
		    };
	
		    Color.prototype = {
		        resolveColor: function(value) {
		            value = value || "#000";
	
		            if (value.charAt(0) == "#") {
		                value = value.substr(1, 6);
		            }
	
		            value = value.replace(/ /g, "");
		            value = value.toLowerCase();
		            value = Color.namedColors[value] || value;
	
		            return value;
		        },
	
		        normalizeByte: function(value) {
		            return (value < 0 || isNaN(value)) ? 0 : ((value > 255) ? 255 : value);
		        },
	
		        percBrightness: function() {
		            var color = this;
		            return math.sqrt(0.241 * color.r * color.r + 0.691 * color.g * color.g + 0.068 * color.b * color.b);
		        },
	
		        isDark: function() {
		            var color = this;
		            var brightnessValue = color.percBrightness();
		            return brightnessValue < 180;
		        }
		    };
	
		    Color.formats = [{
		            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
		            process: function(parts) {
		                return [
		                    parseInt(parts[1], 10), parseInt(parts[2], 10), parseInt(parts[3], 10)
		                ];
		            }
		        }, {
		            re: /^(\w{2})(\w{2})(\w{2})$/,
		            process: function(parts) {
		                return [
		                    parseInt(parts[1], 16), parseInt(parts[2], 16), parseInt(parts[3], 16)
		                ];
		            }
		        }, {
		            re: /^(\w{1})(\w{1})(\w{1})$/,
		            process: function(parts) {
		                return [
		                    parseInt(parts[1] + parts[1], 16),
		                    parseInt(parts[2] + parts[2], 16),
		                    parseInt(parts[3] + parts[3], 16)
		                ];
		            }
		        }
		    ];
	
		    Color.namedColors = {
		        aqua: "00ffff", azure: "f0ffff", beige: "f5f5dc",
		        black: "000000", blue: "0000ff", brown: "a52a2a",
		        coral: "ff7f50", cyan: "00ffff", darkblue: "00008b",
		        darkcyan: "008b8b", darkgray: "a9a9a9", darkgreen: "006400",
		        darkorange: "ff8c00", darkred: "8b0000", dimgray: "696969",
		        fuchsia: "ff00ff", gold: "ffd700", goldenrod: "daa520",
		        gray: "808080", green: "008000", greenyellow: "adff2f",
		        indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c",
		        lightblue: "add8e6", lightgrey: "d3d3d3", lightgreen: "90ee90",
		        lightpink: "ffb6c1", lightyellow: "ffffe0", lime: "00ff00",
		        limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff",
		        maroon: "800000", mediumblue: "0000cd", navy: "000080",
		        olive: "808000", orange: "ffa500", orangered: "ff4500",
		        orchid: "da70d6", pink: "ffc0cb", plum: "dda0dd",
		        purple: "800080", red: "ff0000", royalblue: "4169e1",
		        salmon: "fa8072", silver: "c0c0c0", skyblue: "87ceeb",
		        slateblue: "6a5acd", slategray: "708090", snow: "fffafa",
		        steelblue: "4682b4", tan: "d2b48c", teal: "008080",
		        tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee",
		        wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5",
		        yellow: "ffff00", yellowgreen: "9acd32"
		    };
	
		    function _createColumns(eventElements) {
		        var columns = [];
	
		        for (var idx = 0; idx < eventElements.length; idx++) {
		            var event = eventElements[idx];
		            var eventRange = rangeIndex(event);
		            var column = null;
	
		            for (var j = 0, columnLength = columns.length; j < columnLength; j++) {
		                var endOverlaps = eventRange.start > columns[j].end;
	
		                if (eventRange.start < columns[j].start || endOverlaps) {
	
		                    column = columns[j];
	
		                    if (column.end < eventRange.end) {
		                        column.end = eventRange.end;
		                    }
	
		                    break;
		                }
		            }
	
		            if (!column) {
		                column = { start: eventRange.start, end: eventRange.end, events: [] };
		                columns.push(column);
		            }
	
		            column.events.push(event);
		        }
	
		        return columns;
		    }
	
		    function createDateLayoutConfiguration(name, dates, inner, times) {
		         var configuration = [];
	
		         $.each(dates, function(index, item) {
		            var className = item.className ? "k-slot-cell " + item.className : "k-slot-cell";
	
		            var obj = {
		                text: item.text,
		                className: className
		            };
	
		            if(times && !item.minorTicks){
		                obj[name] = createDateLayoutConfiguration(name, item.columns, inner, times);
		            } else {
		                obj[name] = inner;
		            }
		            configuration.push(obj);
		        });
	
		        return configuration;
		    }
	
		    function createLayoutConfiguration(name, resources, inner, template, dates, times) {
		        var resource = resources[0];
		        var configuration = [];
	
		        if (resource) {
		            if (dates && inner) {
		                $.each(dates, function(index, item) {
	
		                    if (times && !item.minorTicks) {
		                        item[name] = createLayoutConfiguration(name, resources, item.columns, template, item.columns, times);
		                    } else {
		                         item[name] = createLayoutConfiguration(name, resources, null, template);
		                    }
		                });
		                configuration = dates;
		            } else {
		                var data = resource.dataSource.view();
	
		                for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
		                    var obj = {
		                        text: template({
		                            text: kendo.htmlEncode(kendo.getter(resource.dataTextField)(data[dataIndex])),
		                            color: kendo.getter(resource.dataColorField)(data[dataIndex]),
		                            field: resource.field,
		                            title: resource.title,
		                            name: resource.name,
		                            value:kendo.getter(resource.dataValueField)(data[dataIndex])
		                        }),
		                        className: "k-slot-cell"
		                    };
		                    obj[name] = createLayoutConfiguration(name, resources.slice(1), inner, template);
	
		                    configuration.push(obj);
		                }
		            }
		            return configuration;
		        }
		        return inner;
		    }
	
		    function groupEqFilter(value) {
		        return function(item) {
		            if ($.isArray(item) || item instanceof kendo.data.ObservableArray) {
		                for (var idx = 0; idx < item.length; idx++) {
		                    if (item[idx] == value) {
		                        return true;
		                    }
		                }
		                return false;
		            }
		            return item == value;
		        };
		    }
	
		    var selectedStateRegExp = /\s*k-state-selected/;
		    function addSelectedState(cell) {
		        cell.className = cell.className.replace(selectedStateRegExp, "") + " k-state-selected";
		    }
	
		    $.extend(ui.SchedulerView, {
		        createColumns: createColumns,
		        createRows: createRows,
		        rangeIndex: rangeIndex,
		        collidingEvents: collidingEvents,
		        groupEqFilter: groupEqFilter
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1285);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1119:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(590);
	
	/***/ }),
	
	/***/ 1134:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(592);
	
	/***/ }),
	
	/***/ 1285:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1008), __webpack_require__(1119), __webpack_require__(1134) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "scheduler.recurrence",
		    name: "Recurrence",
		    category: "web",
		    depends: [ "dropdownlist", "datepicker", "numerictextbox" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        timezone = kendo.timezone,
		        Class = kendo.Class,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        DropDownList = ui.DropDownList,
		        kendoDate = kendo.date,
		        setTime = kendoDate.setTime,
		        setDayOfWeek = kendoDate.setDayOfWeek,
		        adjustDST = kendoDate.adjustDST,
		        firstDayOfMonth = kendoDate.firstDayOfMonth,
		        getMilliseconds = kendoDate.getMilliseconds,
		        DAYS_IN_LEAPYEAR = [0,31,60,91,121,152,182,213,244,274,305,335,366],
		        DAYS_IN_YEAR = [0,31,59,90,120,151,181,212,243,273,304,334,365],
		        MONTHS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
		        WEEK_DAYS = {
		            0: "SU",
		            1: "MO",
		            2: "TU",
		            3: "WE",
		            4: "TH",
		            5: "FR",
		            6: "SA"
		        },
		        WEEK_DAYS_IDX = {
		            "SU": 0,
		            "MO": 1,
		            "TU": 2,
		            "WE": 3,
		            "TH": 4,
		            "FR": 5,
		            "SA": 6
		        },
		        DATE_FORMATS = [
		            "yyyy-MM-ddTHH:mm:ss.fffzzz",
		            "yyyy-MM-ddTHH:mm:sszzz",
		            "yyyy-MM-ddTHH:mm:ss",
		            "yyyy-MM-ddTHH:mm",
		            "yyyy-MM-ddTHH",
		            "yyyy-MM-dd",
		            "yyyyMMddTHHmmssfffzzz",
		            "yyyyMMddTHHmmsszzz",
		            "yyyyMMddTHHmmss",
		            "yyyyMMddTHHmm",
		            "yyyyMMddTHH",
		            "yyyyMMdd"
		        ],
		        RULE_NAMES = ["months", "weeks", "yearDays", "monthDays", "weekDays", "hours", "minutes", "seconds"],
		        RULE_NAMES_LENGTH = RULE_NAMES.length,
		        RECURRENCE_DATE_FORMAT = "yyyyMMddTHHmmssZ",
		        limitation = {
		            months: function(date, end, rule) {
		                var monthRules = rule.months,
		                    months = ruleValues(monthRules, date.getMonth() + 1),
		                    changed = false;
	
		                if (months !== null) {
		                    if (months.length) {
		                        date.setMonth(months[0] - 1, 1);
		                    } else {
		                        date.setFullYear(date.getFullYear() + 1, monthRules[0] - 1, 1);
		                    }
	
		                    changed = true;
		                }
	
		                return changed;
		            },
	
		            monthDays: function(date, end, rule) {
		                var monthLength, month, days,
		                    changed = false,
		                    hours = date.getHours(),
		                    normalize = function(monthDay) {
		                        if (monthDay < 0) {
		                            monthDay = monthLength + monthDay + 1;
		                        }
		                        return monthDay;
		                    };
	
		                while (date <= end) {
		                    month = date.getMonth();
		                    monthLength = getMonthLength(date);
		                    days = ruleValues(rule.monthDays, date.getDate(), normalize);
	
		                    if (days === null) {
		                        return changed;
		                    }
	
		                    changed = true;
	
		                    if (days.length) {
		                        date.setMonth(month, days.sort(numberSortPredicate)[0]);
		                        adjustDST(date, hours);
	
		                        if (month === date.getMonth()) {
		                            break;
		                        }
		                    } else {
		                        date.setMonth(month + 1, 1);
		                    }
		                }
	
		                return changed;
		            },
	
		            yearDays: function(date, end, rule) {
		                var year, yearDays,
		                    changed = false,
		                    hours = date.getHours(),
		                    normalize = function(yearDay) {
		                        if (yearDay < 0) {
		                            yearDay = year + yearDay;
		                        }
		                        return yearDay;
		                    };
	
		                while (date < end) {
		                    year = leapYear(date) ? 366 : 365;
		                    yearDays = ruleValues(rule.yearDays, dayInYear(date), normalize);
	
		                    if (yearDays === null) {
		                        return changed;
		                    }
	
		                    changed = true;
		                    year = date.getFullYear();
	
		                    if (yearDays.length) {
		                        date.setFullYear(year, 0, yearDays.sort(numberSortPredicate)[0]);
		                        adjustDST(date, hours);
		                        break;
		                    } else {
		                        date.setFullYear(year + 1, 0, 1);
		                    }
		                }
	
		                return changed;
		            },
	
		            weeks: function(date, end, rule) {
		                var weekStart = rule.weekStart,
		                    year, weeks, day,
		                    changed = false,
		                    hours = date.getHours(),
		                    normalize = function(week) {
		                        if (week < 0) {
		                            week = 53 + week;
		                        }
		                        return week;
		                    };
	
		                while (date < end) {
		                    weeks = ruleValues(rule.weeks, weekInYear(date, weekStart), normalize);
	
		                    if (weeks === null) {
		                        return changed;
		                    }
	
		                    changed = true;
		                    year = date.getFullYear();
	
		                    if (weeks.length) {
		                        day = (weeks.sort(numberSortPredicate)[0] * 7) - 1;
	
		                        date.setFullYear(year, 0, day);
		                        setDayOfWeek(date, weekStart, -1);
	
		                        adjustDST(date, hours);
		                        break;
		                    } else {
		                        date.setFullYear(year + 1, 0, 1);
		                    }
		                }
	
		                return changed;
		            },
	
		            weekDays: function(date, end, rule) {
		                var weekDays = rule.weekDays;
		                var weekStart = rule.weekStart;
		                var weekDayRules = ruleWeekValues(weekDays, date, weekStart);
		                var hours = date.getHours();
		                var weekDayRule, day;
	
		                if (weekDayRules === null) {
		                    return false;
		                }
	
		                weekDayRule = weekDayRules[0];
		                if (!weekDayRule) {
		                    weekDayRule = weekDays[0];
		                    setDayOfWeek(date, weekStart);
		                }
	
		                day = weekDayRule.day;
	
		                if (weekDayRule.offset) {
		                    while (date <= end && !isInWeek(date, weekDayRule, weekStart)) {
		                        if (weekInMonth(date, weekStart) === numberOfWeeks(date, weekStart)) {
		                            date.setMonth(date.getMonth() + 1, 1);
		                            adjustDST(date, hours);
		                        } else {
		                            date.setDate(date.getDate() + 7);
		                            adjustDST(date, hours);
	
		                            setDayOfWeek(date, weekStart, -1);
		                        }
		                    }
		                }
	
		                if (date.getDay() !== day) {
		                    setDayOfWeek(date, day);
		                }
	
		                return true;
		            },
	
		            hours: function(date, end, rule) {
		                var hourRules = rule.hours,
		                    startTime = rule._startTime,
		                    startHours = startTime.getHours(),
		                    hours = ruleValues(hourRules, startHours),
		                    changed = false;
	
		                if (hours !== null) {
		                    changed = true;
	
		                    date.setHours(startHours);
		                    adjustDST(date, startHours);
	
		                    if (hours.length) {
		                        hours = hours[0];
		                        date.setHours(hours);
		                    } else {
		                        hours = date.getHours();
		                        date.setDate(date.getDate() + 1);
		                        adjustDST(date, hours);
	
		                        hours = hourRules[0];
		                        date.setHours(hours);
		                        adjustDST(date, hours);
		                    }
	
		                    if (rule.minutes) {
		                        date.setMinutes(0);
		                    }
	
		                    startTime.setHours(hours, date.getMinutes());
		                }
	
		                return changed;
		            },
	
		            minutes: function(date, end, rule) {
		                var minuteRules = rule.minutes,
		                    currentMinutes = date.getMinutes(),
		                    minutes = ruleValues(minuteRules, currentMinutes),
		                    hours = rule._startTime.getHours(),
		                    changed = false;
	
		                if (minutes !== null) {
		                    changed = true;
	
		                    if (minutes.length) {
		                        minutes = minutes[0];
		                    } else {
		                        hours += 1;
		                        minutes = minuteRules[0];
		                    }
	
		                    if (rule.seconds) {
		                        date.setSeconds(0);
		                    }
	
		                    date.setHours(hours, minutes);
	
		                    hours = hours % 24;
		                    adjustDST(date, hours);
		                    rule._startTime.setHours(hours, minutes, date.getSeconds());
		                }
	
		                return changed;
		            },
	
		            seconds: function(date, end, rule) {
		                var secondRules = rule.seconds,
		                    hours = rule._startTime.getHours(),
		                    seconds = ruleValues(secondRules, date.getSeconds()),
		                    minutes = date.getMinutes(),
		                    changed = false;
	
		                if (seconds !== null) {
		                    changed = true;
	
		                    if (seconds.length) {
		                        date.setSeconds(seconds[0]);
		                    } else {
		                        minutes += 1;
		                        date.setMinutes(minutes, secondRules[0]);
	
		                        if (minutes > 59) {
		                            minutes = minutes % 60;
		                            hours = (hours + 1) % 24;
		                        }
		                    }
	
		                    rule._startTime.setHours(hours, minutes, date.getSeconds());
		                }
	
		                return changed;
		            }
		        },
		        BaseFrequency = Class.extend({
		            next: function(date, rule) {
		                var startTime = rule._startTime,
		                    day = startTime.getDate(),
		                    minutes, seconds;
	
		                if (rule.seconds) {
		                    seconds = date.getSeconds() + 1;
	
		                    date.setSeconds(seconds);
		                    startTime.setSeconds(seconds);
		                    startTime.setDate(day);
	
		                } else if (rule.minutes) {
		                    minutes = date.getMinutes() + 1;
	
		                    date.setMinutes(minutes);
		                    startTime.setMinutes(minutes);
		                    startTime.setDate(day);
		                } else {
		                    return false;
		                }
	
		                return true;
		            },
	
		            normalize: function(options) {
		                var rule = options.rule;
	
		                if (options.idx === 4 && rule.hours) {
		                    rule._startTime.setHours(0);
		                    this._hour(options.date, rule);
		                }
		            },
	
		            limit: function(date, end, rule) {
		                var interval = rule.interval,
		                    ruleName, firstRule,
		                    modified,
		                    idx, day;
	
		                while (date <= end) {
		                    modified = firstRule = undefined;
		                    day = date.getDate();
	
		                    for (idx = 0; idx < RULE_NAMES_LENGTH; idx++) {
		                        ruleName = RULE_NAMES[idx];
	
		                        if (rule[ruleName]) {
		                            modified = limitation[ruleName](date, end, rule);
		                            if (firstRule !== undefined && modified) {
		                                break;
		                            } else {
		                                firstRule = modified;
		                            }
		                        }
	
		                        if (modified) {
		                            this.normalize({ date: date, rule: rule, day: day, idx: idx });
		                        }
		                    }
	
		                    if ((interval === 1 || !this.interval(rule, date)) && idx === RULE_NAMES_LENGTH) {
		                        break;
		                    }
		                }
		            },
	
		            interval: function (rule, current) {
		                var start = new Date(rule._startPeriod);
		                var date = new Date(current);
		                var hours = current.getHours();
		                var weekStart = rule.weekStart;
		                var interval = rule.interval;
		                var frequency = rule.freq;
		                var modified = false;
		                var excess = 0;
		                var month = 0;
		                var day = 1;
		                var diff;
	
		                var startTimeHours;
	
		                if (frequency === "hourly") {
		                    diff = date.getTimezoneOffset() - start.getTimezoneOffset();
		                    startTimeHours = rule._startTime.getHours();
	
		                    date = date.getTime();
		                    if (hours !== startTimeHours) {
		                        date += (startTimeHours - hours) * kendoDate.MS_PER_HOUR;
		                    }
		                    date -= start;
	
		                    if (diff) {
		                        date -= diff * kendoDate.MS_PER_MINUTE;
		                    }
	
		                    diff = Math.floor(date / kendoDate.MS_PER_HOUR);
		                    excess = intervalExcess(diff, interval);
	
		                    if (excess !== 0) {
		                        this._hour(current, rule, excess);
		                        modified = true;
		                    }
		                } else if (frequency === "daily") {
		                    kendoDate.setTime(date, -start, true);
	
		                    diff = Math.round(date / kendoDate.MS_PER_DAY);
		                    excess = intervalExcess(diff, interval);
	
		                    if (excess !== 0) {
		                        this._date(current, rule, excess);
		                        modified = true;
		                    }
	
		                } else if (frequency === "weekly") {
		                    excess = this._getNumberOfWeeksBetweenDates(start, current);
	
		                    var normalizedCurrentIndex = normalizeDayIndex(current.getDay(), weekStart);
		                    var normalizedStartIndex = normalizeDayIndex(start.getDay(), weekStart);
	
		                    if (normalizedCurrentIndex < normalizedStartIndex) {
		                        excess += 1;
		                    }
	
		                    excess = intervalExcess(excess, interval);
		                    if (excess !== 0) {
		                        kendoDate.setDayOfWeek(current, rule.weekStart, -1);
	
		                        current.setDate(current.getDate() + (excess * 7));
		                        adjustDST(current, hours);
	
		                        modified = true;
		                    }
		                } else if (frequency === "monthly") {
		                    diff = current.getFullYear() - start.getFullYear();
		                    diff = current.getMonth() - start.getMonth() + (diff * 12);
	
		                    excess = intervalExcess(diff, interval);
	
		                    if (excess !== 0) {
		                        day = rule._hasRuleValue ? 1 : current.getDate();
	
		                        current.setFullYear(current.getFullYear(), current.getMonth() + excess, day);
		                        adjustDST(current, hours);
	
		                        modified = true;
		                    }
		                } else if (frequency === "yearly") {
		                    diff = current.getFullYear() - start.getFullYear();
		                    excess = intervalExcess(diff, interval);
	
		                    if (!rule.months) {
		                        month = current.getMonth();
		                    }
	
		                    if (!rule.yearDays && !rule.monthDays && !rule.weekDays) {
		                        day = current.getDate();
		                    }
	
		                    if (excess !== 0) {
		                        current.setFullYear(current.getFullYear() + excess, month, day);
		                        adjustDST(current, hours);
	
		                        modified = true;
		                    }
		                }
	
		                return modified;
		            },
	
		            _getNumberOfWeeksBetweenDates: function(first, second){
		                 var weeks = (second - first) / 604800000;
		                 var exactWeeks = Math.floor(weeks);
	
		                //this is happening when weeks pass DST change
		                if (weeks - exactWeeks > 0.99) {
		                    exactWeeks = Math.round(weeks);
		                }
		                return exactWeeks;
		            },
	
		            _hour: function(date, rule, interval) {
		                var startTime = rule._startTime,
		                    hours = startTime.getHours();
	
		                if (interval) {
		                    hours += interval;
		                }
	
		                date.setHours(hours);
	
		                hours = hours % 24;
		                startTime.setHours(hours);
		                adjustDST(date, hours);
		            },
	
		            _date: function(date, rule, interval) {
		                var hours = date.getHours();
	
		                date.setDate(date.getDate() + interval);
		                if (!adjustDST(date, hours)) {
		                    this._hour(date, rule);
		                }
		            }
		        }),
		        HourlyFrequency = BaseFrequency.extend({
		            next: function(date, rule) {
		                if (!BaseFrequency.fn.next(date, rule)) {
		                    this._hour(date, rule, 1);
		                }
		            },
	
		            normalize: function(options) {
		                var rule = options.rule;
	
		                if (options.idx === 4) {
		                    rule._startTime.setHours(0);
		                    this._hour(options.date, rule);
		                }
		            }
		        }),
		        DailyFrequency = BaseFrequency.extend({
		            next: function(date, rule) {
		                if (!BaseFrequency.fn.next(date, rule)) {
		                    this[rule.hours ? "_hour" : "_date"](date, rule, 1);
		                }
		            }
		        }),
		        WeeklyFrequency = DailyFrequency.extend({
		            setup: function(rule, eventStartDate) {
		                if (!rule.weekDays) {
		                    rule.weekDays = [{
		                        day: eventStartDate.getDay(),
		                        offset: 0
		                    }];
		                }
		            }
		        }),
		        MonthlyFrequency = BaseFrequency.extend({
		            next: function(date, rule) {
		                var day, hours;
		                if (!BaseFrequency.fn.next(date, rule)) {
		                    if (rule.hours) {
		                        this._hour(date, rule, 1);
		                    } else if (rule.monthDays || rule.weekDays || rule.yearDays || rule.weeks) {
		                        this._date(date, rule, 1);
		                    } else {
		                        day = date.getDate();
		                        hours = date.getHours();
	
		                        date.setMonth(date.getMonth() + 1);
		                        adjustDST(date, hours);
	
		                        while(date.getDate() !== day) {
		                            date.setDate(day);
		                            adjustDST(date, hours);
		                        }
	
		                        this._hour(date, rule);
		                    }
		                }
		            },
		            normalize: function(options) {
		                var rule = options.rule,
		                    date = options.date,
		                    hours = date.getHours();
	
		                if (options.idx === 0 && !rule.monthDays && !rule.weekDays) {
		                    date.setDate(options.day);
		                    adjustDST(date, hours);
		                } else {
		                    BaseFrequency.fn.normalize(options);
		                }
		            },
		            setup: function(rule, eventStartDate, date) {
		                if (!rule.monthDays && !rule.weekDays) {
		                    date.setDate(eventStartDate.getDate());
		                }
		            }
		        }),
		        YearlyFrequency = MonthlyFrequency.extend({
		            next: function(date, rule) {
		                var day,
		                    hours = date.getHours();
	
		                if (!BaseFrequency.fn.next(date, rule)) {
		                    if (rule.hours) {
		                        this._hour(date, rule, 1);
		                    } else if (rule.monthDays || rule.weekDays || rule.yearDays || rule.weeks) {
		                        this._date(date, rule, 1);
		                    } else if (rule.months) {
		                        day = date.getDate();
	
		                        date.setMonth(date.getMonth() + 1);
		                        adjustDST(date, hours);
	
		                        while(date.getDate() !== day) {
		                            date.setDate(day);
		                            adjustDST(date, hours);
		                        }
	
		                        this._hour(date, rule);
		                    } else {
		                        date.setFullYear(date.getFullYear() + 1);
		                        adjustDST(date, hours);
	
		                        this._hour(date, rule);
		                    }
		                }
		            },
		            setup: function() {}
		        }),
		        frequencies = {
		            "hourly" : new HourlyFrequency(),
		            "daily" : new DailyFrequency(),
		            "weekly" : new WeeklyFrequency(),
		            "monthly" : new MonthlyFrequency(),
		            "yearly" : new YearlyFrequency()
		        },
		        CLICK = "click";
	
		    function intervalExcess(diff, interval) {
		        var excess;
		        if (diff !== 0 && diff < interval) {
		            excess = interval - diff;
		        } else {
		            excess = diff % interval;
		            if (excess) {
		                excess = interval - excess;
		            }
		        }
	
		        return excess;
		    }
	
		    function dayInYear(date) {
		        var month = date.getMonth();
		        var days = leapYear(date) ? DAYS_IN_LEAPYEAR[month] : DAYS_IN_YEAR[month];
	
		        return days + date.getDate();
		    }
	
		    function weekInYear(date, weekStart){
		        var year, days;
	
		        date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
		        adjustDST(date, 0);
	
		        year = date.getFullYear();
	
		        if (weekStart !== undefined) {
		            setDayOfWeek(date, weekStart, -1);
		            date.setDate(date.getDate() + 4);
		        } else {
		            date.setDate(date.getDate() + (4 - (date.getDay() || 7)));
		        }
	
		        adjustDST(date, 0);
		        days = Math.floor((date.getTime() - new Date(year, 0, 1, -6)) / 86400000);
	
		        return 1 + Math.floor(days / 7);
		    }
	
		    function weekInMonth(date, weekStart) {
		        var firstWeekDay = firstDayOfMonth(date).getDay();
		        var firstWeekLength = 7 - (firstWeekDay + 7 - (weekStart || 7)) || 7;
	
		        if (firstWeekLength < 0) {
		            firstWeekLength += 7;
		        }
	
		        return Math.ceil((date.getDate() - firstWeekLength) / 7) + 1;
		    }
	
		    function normalizeDayIndex(weekDay, weekStart) {
		        return weekDay + (weekDay < weekStart ? 7 : 0);
		    }
	
		    function normalizeOffset(date, rule, weekStart) {
		        var offset = rule.offset;
	
		        if (!offset) {
		            return weekInMonth(date, weekStart);
		        }
	
		        var lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
		        var weeksInMonth = weekInMonth(lastDate, weekStart);
	
		        var day = normalizeDayIndex(rule.day, weekStart);
	
		        var skipFirst = day < normalizeDayIndex(new Date(date.getFullYear(), date.getMonth(), 1).getDay(), weekStart);
		        var skipLast = day > normalizeDayIndex(lastDate.getDay(), weekStart);
	
		        if (offset < 0) {
		            offset = weeksInMonth + (offset + 1 - (skipLast ? 1 : 0));
		        } else if (skipFirst) {
		            offset += 1;
		        }
	
		        weeksInMonth -= (skipLast ? 1 : 0);
	
		        if (offset < (skipFirst ? 1 : 0) || offset > weeksInMonth) {
		            return null;
		        }
	
		        return offset;
		    }
	
		    function numberOfWeeks(date, weekStart) {
		        return weekInMonth(new Date(date.getFullYear(), date.getMonth() + 1, 0), weekStart);
		    }
	
		    function isInWeek(date, rule, weekStart) {
		        return weekInMonth(date, weekStart) === normalizeOffset(date, rule, weekStart);
		    }
	
		    function ruleWeekValues(weekDays, date, weekStart) {
		        var currentDay = normalizeDayIndex(date.getDay(), weekStart);
		        var length = weekDays.length;
		        var ruleWeekOffset;
		        var weekDay, day;
		        var weekNumber;
		        var result = [];
		        var idx = 0;
	
		        for (;idx < length; idx++) {
		            weekDay = weekDays[idx];
	
		            weekNumber = weekInMonth(date, weekStart);
		            ruleWeekOffset = normalizeOffset(date, weekDay, weekStart);
	
		            if (ruleWeekOffset === null) {
		                continue;
		            }
	
		            if (weekNumber < ruleWeekOffset) {
		                result.push(weekDay);
		            } else if (weekNumber === ruleWeekOffset) {
		                day = normalizeDayIndex(weekDay.day, weekStart);
	
		                if (currentDay < day) {
		                    result.push(weekDay);
		                } else if (currentDay === day) {
		                    return null;
		                }
		            }
		        }
	
		        return result;
		    }
	
		    function ruleValues(rules, value, normalize) {
		        var idx = 0,
		            length = rules.length,
		            availableRules = [],
		            ruleValue;
	
		        for (; idx < length; idx++) {
		            ruleValue = rules[idx];
	
		            if (normalize) {
		                ruleValue = normalize(ruleValue);
		            }
	
		            if (value === ruleValue) {
		                return null;
		            }  else if (value < ruleValue) {
		                availableRules.push(ruleValue);
		            }
		        }
	
		        return availableRules;
		    }
	
		    function parseArray(list, range) {
		        var idx = 0,
		            length = list.length,
		            value;
	
		        for (; idx < length; idx++) {
		            value = parseInt(list[idx], 10);
		            if (isNaN(value) || value < range.start || value > range.end || (value === 0 && range.start < 0)) {
		                return null;
		            }
	
		            list[idx] = value;
		        }
	
		        return list.sort(numberSortPredicate);
		    }
	
		    function parseWeekDayList(list) {
		        var idx = 0, length = list.length,
		            value, valueLength, day;
	
		        for (; idx < length; idx++) {
		            value = list[idx];
		            valueLength = value.length;
		            day = value.substring(valueLength - 2).toUpperCase();
	
		            day = WEEK_DAYS_IDX[day];
		            if (day === undefined) {
		                return null;
		            }
	
		            list[idx] = {
		                offset: parseInt(value.substring(0, valueLength - 2), 10) || 0,
		                day: day
		            };
		        }
		        return list;
		    }
	
		    function serializeWeekDayList(list) {
		        var idx = 0, length = list.length,
		            value, valueString, result = [];
	
		        for (; idx < length; idx++) {
		            value = list[idx];
		            if (typeof value === "string") {
		                valueString = value;
		            } else {
		                valueString = "" + WEEK_DAYS[value.day];
	
		                if (value.offset) {
		                    valueString = value.offset + valueString;
		                }
		            }
	
		            result.push(valueString);
		        }
		        return result.toString();
		    }
	
		    function getMonthLength(date) {
		        var month = date.getMonth();
	
		        if (month === 1) {
		            if (new Date(date.getFullYear(), 1, 29).getMonth() === 1) {
		                return 29;
		            }
		            return 28;
		        }
		        return MONTHS[month];
		    }
	
		    function leapYear(year) {
		        year = year.getFullYear();
		        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
		    }
	
		    function numberSortPredicate(a, b) {
		        return a - b;
		    }
	
		    function parseExceptions(exceptions, zone) {
		        var idx = 0, length, date,
		            dates = [];
	
		        if (exceptions) {
		            exceptions = exceptions.split(exceptions.indexOf(";") !== -1 ? ";" : ",");
		            length = exceptions.length;
	
		            for (; idx < length; idx++) {
		                date = parseUTCDate(exceptions[idx], zone);
	
		                if (date) {
		                    dates.push(date);
		                }
		            }
		        }
	
		        return dates;
		    }
	
		    function isException(exceptions, date, zone) {
		        var dates = $.isArray(exceptions) ? exceptions : parseExceptions(exceptions, zone),
		            dateTime = date.getTime() - date.getMilliseconds(),
		            idx = 0, length = dates.length;
	
		        for (; idx < length; idx++) {
		            if (dates[idx].getTime() === dateTime) {
		                return true;
		            }
		        }
	
		        return false;
		    }
	
		    function toExceptionString(dates, zone) {
		        var idx = 0;
		        var length;
		        var date;
		        var result = [].concat(dates);
	
		        for (length = result.length; idx < length; idx++) {
		            date = result[idx];
		            date = kendo.timezone.convert(date, zone || date.getTimezoneOffset(), "Etc/UTC");
		            result[idx] = kendo.toString(date, RECURRENCE_DATE_FORMAT);
		        }
	
		        return result.join(",");
		    }
	
		    function startPeriodByFreq(start, rule) {
		        var date = new Date(start);
	
		        switch (rule.freq) {
		            case "yearly":
		                date.setFullYear(date.getFullYear(), 0, 1);
		                break;
	
		            case "monthly":
		                date.setFullYear(date.getFullYear(), date.getMonth(), 1);
		                break;
	
		            case "weekly":
		                setDayOfWeek(date, rule.weekStart, -1);
		                break;
	
		            default:
		                break;
		        }
	
		        if (rule.hours) {
		            date.setHours(0);
		        }
	
		        if (rule.minutes) {
		            date.setMinutes(0);
		        }
	
		        if (rule.seconds) {
		            date.setSeconds(0);
		        }
	
		        return date;
		    }
	
		    function endPeriodByFreq(start, rule) {
		        var date = new Date(start);
	
		        switch (rule.freq) {
		            case "yearly":
		                date.setFullYear(date.getFullYear(), 11, 31);
		                break;
	
		            case "monthly":
		                date.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
		                break;
	
		            case "weekly":
		                setDayOfWeek(date, rule.weekStart, -1);
		                date.setDate(date.getDate() + 6);
		                break;
	
		            default:
		                break;
		        }
	
		        if (rule.hours) {
		            date.setHours(23);
		        }
	
		        if (rule.minutes) {
		            date.setMinutes(59);
		        }
	
		        if (rule.seconds) {
		            date.setSeconds(59);
		        }
	
		        return date;
		    }
	
		    function eventsByPosition(periodEvents, start, positions) {
		        var periodEventsLength = periodEvents.length;
		        var events = [];
		        var position;
		        var event;
	
		        for (var idx = 0, length = positions.length; idx < length; idx++) {
		            position = positions[idx];
	
		            if (position < 0) {
		                position = periodEventsLength + position;
		            } else {
		                position -= 1; //convert to zero based index
		            }
	
		            event = periodEvents[position];
	
		            if (event && event.start >= start) {
		                events.push(event);
		            }
		        }
	
		        return events;
		    }
	
		    function removeExceptionDates(periodEvents, exceptionDates, zone) {
		        var events = [];
		        var event;
	
		        for (var idx = 0; idx < periodEvents.length; idx++) {
		            event = periodEvents[idx];
		            if (!isException(exceptionDates, event.start, zone)) {
		                events.push(event);
		            }
		        }
	
		        return events;
		    }
	
		    function expand(event, start, end, zone) {
		        var rule = parseRule(event.recurrenceRule, zone),
		            startTime, endTime, endDate,
		            hours, minutes, seconds,
		            durationMS, startPeriod, inPeriod,
		            ruleStart, ruleEnd,
		            useEventStart, freqName,
		            exceptionDates,
		            eventStartTime,
		            eventStartMS,
		            eventStart,
		            count, freq,
		            positions,
		            currentIdx,
		            periodEvents,
		            events = [],
		            shiftedStart,
		            shiftedEnd,
		            shiftedStartTime, 
		            shifterEndTime;
	
		        if (!rule) {
		            return [event];
		        }
	
		        positions = rule.positions;
		        currentIdx = positions ? 0 : 1;
	
		        ruleStart = rule.start;
		        ruleEnd = rule.end;
	
		        if (ruleStart || ruleEnd) {
		            event = event.clone({
		                start: ruleStart ? new Date(ruleStart.value[0]) : undefined,
		                end: ruleEnd ? new Date(ruleEnd.value[0]) : undefined
		            });
		        }
	
		        eventStart = event.start;
		        eventStartMS = eventStart.getTime();
		        eventStartTime = getMilliseconds(eventStart);
	
		        exceptionDates = parseExceptions(event.recurrenceException, zone);
	
		        if (!exceptionDates[0] && rule.exdates) {
		            exceptionDates = rule.exdates.value;
		            event.set("recurrenceException", toExceptionString(exceptionDates, zone));
		        }
	
		        startPeriod = start = new Date(start);
		        end = new Date(end);
	
		        freqName = rule.freq;
		        freq = frequencies[freqName];
		        count = rule.count;
	
		        if (rule.until && rule.until < end) {
		            end = new Date(rule.until);
		        }
	
		        useEventStart = freqName === "yearly" || freqName === "monthly" || freqName === "weekly";
	
		        if (start < eventStartMS || count || rule.interval > 1 || useEventStart ||
		             ((freqName === "daily" || freqName === "hourly") && !rule.seconds)) {            
		                    start = new Date(eventStartMS);
		        } else {
		            hours = start.getHours();
		            minutes = start.getMinutes();
		            seconds = start.getSeconds();
	
		            if (!rule.hours) {
		                hours = eventStart.getHours();
		            }
	
		            if (!rule.minutes) {
		                minutes = eventStart.getMinutes();
		            }
	
		            if (!rule.seconds) {
		                seconds = eventStart.getSeconds();
		            }
	
		            start.setHours(hours, minutes, seconds, eventStart.getMilliseconds());
		        }
	
		        rule._startPeriod = new Date(start);
	
		        if (positions) {
		            start = startPeriodByFreq(start, rule);
		            end = endPeriodByFreq(end, rule);
	
		            var diff = getMilliseconds(end) - getMilliseconds(start);
		            if (diff < 0) {
		                hours = start.getHours();
		                end.setHours(hours, start.getMinutes(), start.getSeconds(), start.getMilliseconds());
		                kendoDate.adjustDST(end, hours);
		            }
	
		            rule._startPeriod = new Date(start);
		            rule._endPeriod = endPeriodByFreq(start, rule);
		        }
	
		        durationMS = event.duration();
		        rule._startTime = startTime = kendoDate.toInvariantTime(start);
	
		        if (freq.setup) {
		            freq.setup(rule, eventStart, start);
		        }
	
		        freq.limit(start, end, rule);
	
		        while (start <= end) {
		            endDate = new Date(start);
		            setTime(endDate, durationMS);
	
		            inPeriod = start >= startPeriod || endDate > startPeriod;
	
		            if (inPeriod && !isException(exceptionDates, start, zone) || positions) {
		                startTime = kendoDate.toUtcTime(kendoDate.getDate(start)) + getMilliseconds(rule._startTime);
		                endTime = startTime + durationMS;
	
		                if (eventStartMS !== start.getTime() || eventStartTime !== getMilliseconds(rule._startTime)) {
		                    if(!event.isAllDay){
		                        var startZone = event.startTimezone || event.endTimezone;
		                        var endZone = event.endTimezone || event.startTimezone;
		                        if((zone && startZone) || (!zone && !startZone)){
		                            var startOffsetDiff = getZoneOffset(start, zone) - getZoneOffset(event.start, zone);
		                            var endOffsetDiff = getZoneOffset(endDate, zone) - getZoneOffset(event.end, zone);
		                            var startTZOffsetDiff = getZoneOffset(start, startZone) - getZoneOffset(event.start, startZone);
		                            var endTZOffsetDiff = getZoneOffset(endDate, endZone) - getZoneOffset(event.end, endZone);
	
		                            if(startOffsetDiff !== startTZOffsetDiff){
		                                var offsetTicksStart = (startOffsetDiff - startTZOffsetDiff) * 60000;
		                                shiftedStart = new Date(start.getTime() - offsetTicksStart);
		                                shiftedStartTime = startTime - offsetTicksStart;
		                            }
	
		                            if(endOffsetDiff !== endTZOffsetDiff){
		                                var offsetTicksEnd = (endOffsetDiff - endTZOffsetDiff) * 60000;
		                                shiftedEnd = new Date(endDate.getTime() - offsetTicksEnd);
		                                shifterEndTime = endTime - offsetTicksEnd;
		                            }
		                        }
		                    }
	
		                    events.push(event.toOccurrence({
		                        start: shiftedStart || new Date(start),
		                        end: shiftedEnd || endDate,
		                        _startTime: shiftedStartTime || startTime,
		                        _endTime: shifterEndTime || endTime
		                    }));
	
		                    shiftedStart = shiftedEnd = shiftedStartTime = shifterEndTime = null;
		                } else {
		                    event._startTime = startTime;
		                    event._endTime = endTime;
		                    events.push(event);
		                }
		            }
	
		            if (positions) {
		                freq.next(start, rule);
		                freq.limit(start, end, rule);
	
		                if (start > rule._endPeriod) {
		                    periodEvents = eventsByPosition(events.slice(currentIdx), eventStart, positions);
		                    periodEvents = removeExceptionDates(periodEvents, exceptionDates, zone);
		                    events = events.slice(0, currentIdx).concat(periodEvents);
	
		                    rule._endPeriod = endPeriodByFreq(start, rule);
	
		                    currentIdx = events.length;
		                }
	
		                if (count && count === currentIdx) {
		                    break;
		                }
	
		            } else {
		                if (count && count === currentIdx) {
		                    break;
		                }
	
		                currentIdx += 1;
	
		                var isMissingDSTHour = isDSTMissingHour(start);
		                freq.next(start, rule);
		               
		                if(isMissingDSTHour && rule.freq!=="hourly" && kendoDate.toInvariantTime(event.start).getTime() !== kendoDate.toInvariantTime(start).getTime()){
		                    rule._startTime = startTime = new Date(start.getTime() - 3600000);
		                }
	
		                freq.limit(start, end, rule);
		            }
		        }
	
		        return events;
		    }
	
		    function isDSTMissingHour(date){
		        var dateOffset = date.getTimezoneOffset();
		        var dateMinusHour = new Date(date.getTime() - 3600000);
		        var dateMinusHourOffset = dateMinusHour.getTimezoneOffset();
	
		        return dateOffset < dateMinusHourOffset;
		    }
	
		    function getZoneOffset(date, zone) {
		        return zone ? kendo.timezone.offset(date, zone): date.getTimezoneOffset();
		    }
	
		    function parseUTCDate(value, zone) {
		        value = kendo.parseDate(value, DATE_FORMATS); //Parse UTC to local time
	
		        if (value && zone) {
		            value = timezone.apply(value, zone);
		        }
	
		        return value;
		    }
	
		    function parseDateRule(dateRule, zone) {
		        var pairs = dateRule.split(";");
		        var pair;
		        var property;
		        var value;
		        var tzid;
		        var valueIdx, valueLength;
	
		        for (var idx = 0, length = pairs.length; idx < length; idx++) {
		            pair = pairs[idx].split(":");
		            property = pair[0];
		            value = pair[1];
	
		            if (property.indexOf("TZID") !== -1) {
		                tzid = property.substring(property.indexOf("TZID")).split("=")[1];
		            }
	
		            if (value) {
		                value = value.split(",");
	
		                for (valueIdx = 0, valueLength = value.length; valueIdx < valueLength; valueIdx++) {
		                    value[valueIdx] = parseUTCDate(value[valueIdx], tzid || zone);
		                }
		            }
		        }
	
		        if (value) {
		            return {
		                value: value,
		                tzid: tzid
		            };
		        }
		    }
	
		    function parseRule(recur, zone) {
		        var instance = {};
		        var splits, value;
		        var idx = 0, length;
		        var ruleValue = false;
		        var rule, part, parts;
		        var property, weekStart, weekDays;
		        var predicate = function(a, b) {
		            var day1 = a.day,
		                day2 = b.day;
	
		            if (day1 < weekStart) {
		               day1 += 7;
		            }
	
		            if (day2 < weekStart) {
		                day2 += 7;
		            }
	
		            return day1 - day2;
		        };
	
		        if (!recur) {
		            return null;
		        }
	
		        parts = recur.split("\n");
	
		        if (!parts[1] && (recur.indexOf("DTSTART") !== -1 || recur.indexOf("DTEND") !== -1 || recur.indexOf("EXDATE") !== -1)) {
		            parts = recur.split(" ");
		        }
	
		        for (idx = 0, length = parts.length; idx < length; idx++) {
		            part = $.trim(parts[idx]);
	
		            if (part.indexOf("DTSTART") !== -1) {
		                instance.start = parseDateRule(part, zone);
		            } else if (part.indexOf("DTEND") !== -1) {
		                instance.end = parseDateRule(part, zone);
		            } else if (part.indexOf("EXDATE") !== -1) {
		                instance.exdates = parseDateRule(part, zone);
		            } else if (part.indexOf("RRULE") !== -1) {
		                rule = part.substring(6);
		            } else if ($.trim(part)) {
		                rule = part;
		            }
		        }
	
		        rule = rule.split(";");
	
		        for (idx = 0, length = rule.length; idx < length; idx++) {
		            property = rule[idx];
		            splits = property.split("=");
		            value = $.trim(splits[1]).split(",");
	
		            switch ($.trim(splits[0]).toUpperCase()) {
		                case "FREQ":
		                    instance.freq = value[0].toLowerCase();
		                    break;
		                case "UNTIL":
		                    instance.until = parseUTCDate(value[0], zone);
		                    break;
		                case "COUNT":
		                    instance.count = parseInt(value[0], 10);
		                    break;
		                case "INTERVAL":
		                    instance.interval = parseInt(value[0], 10);
		                    break;
		                case "BYSECOND":
		                    instance.seconds = parseArray(value, { start: 0, end: 60 });
		                    ruleValue = true;
		                    break;
		                case "BYMINUTE":
		                    instance.minutes = parseArray(value, { start: 0, end: 59 });
		                    ruleValue = true;
		                    break;
		                case "BYHOUR":
		                    instance.hours = parseArray(value, { start: 0, end: 23 });
		                    ruleValue = true;
		                    break;
		                case "BYMONTHDAY":
		                    instance.monthDays = parseArray(value, { start: -31, end: 31 });
		                    ruleValue = true;
		                    break;
		                case "BYYEARDAY":
		                    instance.yearDays = parseArray(value, { start: -366, end: 366 });
		                    ruleValue = true;
		                    break;
		                case "BYMONTH":
		                    instance.months = parseArray(value, { start: 1, end: 12 });
		                    ruleValue = true;
		                    break;
		                case "BYDAY":
		                    instance.weekDays = weekDays = parseWeekDayList(value);
		                    ruleValue = true;
		                    break;
		                case "BYWEEKNO":
		                    instance.weeks = parseArray(value, { start: -53, end: 53 });
		                    ruleValue = true;
		                    break;
		                case "BYSETPOS":
		                    instance.positions = parseArray(value, { start: -366, end: 366 });
		                    break;
		                case "WKST":
		                    instance.weekStart = weekStart = WEEK_DAYS_IDX[value[0]];
		                    break;
		            }
		        }
	
		        if (instance.freq === undefined || (instance.count !== undefined && instance.until)) {
		            return null;
		        }
	
		        if (!instance.interval) {
		            instance.interval = 1;
		        }
	
		        if (weekStart === undefined) {
		            instance.weekStart = weekStart = kendo.culture().calendar.firstDay;
		        }
	
		        if (weekDays) {
		            instance.weekDays = weekDays.sort(predicate);
		        }
	
		        if (instance.positions && !ruleValue) {
		            instance.positions = null;
		        }
	
		        instance._hasRuleValue = ruleValue;
	
		        return instance;
		    }
	
		    function serializeDateRule(dateRule, zone) {
		        var value = dateRule.value;
		        var tzid = dateRule.tzid || "";
		        var length = value.length;
		        var idx = 0;
		        var val;
	
		        for (; idx < length; idx++) {
		            val = value[idx];
		            val = timezone.convert(val, tzid || zone || val.getTimezoneOffset(), "Etc/UTC");
		            value[idx] = kendo.toString(val, "yyyyMMddTHHmmssZ");
		        }
	
		        if (tzid) {
		            tzid = ";TZID=" + tzid;
		        }
	
		        return tzid + ":" + value.join(",") + " ";
		    }
	
		    function serialize(rule, zone) {
		        var weekStart = rule.weekStart;
		        var ruleString = "FREQ=" + rule.freq.toUpperCase();
		        var exdates = rule.exdates || "";
		        var start = rule.start || "";
		        var end = rule.end || "";
		        var until = rule.until;
	
		        if (rule.interval > 1) {
		            ruleString += ";INTERVAL=" + rule.interval;
		        }
	
		        if (rule.count) {
		            ruleString += ";COUNT=" + rule.count;
		        }
	
		        if (until) {
		            until = timezone.convert(until, zone || until.getTimezoneOffset(), "Etc/UTC");
	
		            ruleString += ";UNTIL=" + kendo.toString(until, "yyyyMMddTHHmmssZ");
		        }
	
		        if (rule.months) {
		            ruleString += ";BYMONTH=" + rule.months;
		        }
	
		        if (rule.weeks) {
		            ruleString += ";BYWEEKNO=" + rule.weeks;
		        }
	
		        if (rule.yearDays) {
		            ruleString += ";BYYEARDAY=" + rule.yearDays;
		        }
	
		        if (rule.monthDays) {
		            ruleString += ";BYMONTHDAY=" + rule.monthDays;
		        }
	
		        if (rule.weekDays) {
		            ruleString += ";BYDAY=" + serializeWeekDayList(rule.weekDays);
		        }
	
		        if (rule.hours) {
		            ruleString += ";BYHOUR=" + rule.hours;
		        }
	
		        if (rule.minutes) {
		            ruleString += ";BYMINUTE=" + rule.minutes;
		        }
	
		        if (rule.seconds) {
		            ruleString += ";BYSECOND=" + rule.seconds;
		        }
	
		        if (rule.positions) {
		            ruleString += ";BYSETPOS=" + rule.positions;
		        }
	
		        if (weekStart !== undefined) {
		            ruleString += ";WKST=" + WEEK_DAYS[weekStart];
		        }
	
		        if (start) {
		            start = "DTSTART" + serializeDateRule(start, zone);
		        }
	
		        if (end) {
		            end = "DTEND" + serializeDateRule(end, zone);
		        }
	
		        if (exdates) {
		            exdates = "EXDATE" + serializeDateRule(exdates, zone);
		        }
	
		        if (start || end || exdates) {
		            ruleString = start + end + exdates + "RRULE:" + ruleString;
		        }
	
		        return ruleString;
		    }
	
		    kendo.recurrence = {
		        rule: {
		            parse: parseRule,
		            serialize: serialize
		        },
		        expand: expand,
		        dayInYear: dayInYear,
		        weekInYear: weekInYear,
		        weekInMonth: weekInMonth,
		        numberOfWeeks: numberOfWeeks,
		        isException: isException,
		        toExceptionString: toExceptionString
		    };
	
		    var weekDayCheckBoxes = function(firstDay) {
		        var shortNames = kendo.culture().calendar.days.namesShort,
		            length = shortNames.length,
		            result = "",
		            idx = 0,
		            values = [];
	
		        for (; idx < length; idx++) {
		            values.push(idx);
		        }
	
		        shortNames = shortNames.slice(firstDay).concat(shortNames.slice(0, firstDay));
		        values = values.slice(firstDay).concat(values.slice(0, firstDay));
	
		        for (idx = 0; idx < length; idx++) {
		            result += '<label class="k-check"><input class="k-recur-weekday-checkbox" type="checkbox" value="' + values[idx] + '" /> ' + shortNames[idx] + "</label>";
		        }
	
		        return result;
		    };
	
		    var RECURRENCE_VIEW_TEMPLATE = kendo.template(
		       '# if (frequency !== "never") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatEvery#</label></div>' +
		           '<div class="k-edit-field"><input class="k-recur-interval" title="#:messages.interval#"/>#:messages.interval#</div>' +
		       '# } #' +
		       '# if (frequency === "weekly") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatOn#</label></div>' +
		           '<div class="k-edit-field">#=weekDayCheckBoxes(firstWeekDay)#</div>' +
		       '# } else if (frequency === "monthly") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatOn#</label></div>' +
		           '<div class="k-edit-field">' +
		               '<ul class="k-reset">' +
		                   '<li>' +
		                       '<label><input class="k-recur-month-radio" type="radio" name="month" value="monthday" title="#:messages.day#" />#:messages.day#</label>' +
		                       '<input class="k-recur-monthday" title="#:messages.day#" />' +
		                   '</li>' +
		                   '<li>' +
		                        '<input class="k-recur-month-radio" type="radio" name="month" value="weekday" title="#:messages.repeatOn#" />' +
		                        '<input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#" />' +
		                   '</li>' +
		               '</ul>' +
		           '</div>' +
		       '# } else if (frequency === "yearly") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatOn#</label></div>' +
		           '<div class="k-edit-field">' +
		               '<ul class="k-reset">' +
		                   '<li>' +
		                       '<input class="k-recur-year-radio" type="radio" name="year" value="monthday" title="#:messages.repeatOn#" />' +
		                       '<input class="k-recur-month" title="#:messages.repeatOn#" /><input class="k-recur-monthday" title="#:messages.day#" />' +
		                   '</li>' +
		                   '<li>' +
		                       '<input class="k-recur-year-radio" type="radio" name="year" value="weekday" title="#:messages.repeatOn#" />' +
		                       '<input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#"  />#:messages.of#<input class="k-recur-month" title="#:messages.of#"/>' +
		                   '</li>' +
		               '</ul>' +
		           '</div>' +
		       '# } #' +
		       '# if (frequency !== "never") { #' +
		           '<div class="k-edit-label"><label>#:end.label#</label></div>' +
		           '<div class="k-edit-field">' +
		               '<ul class="k-reset">' +
		                   '<li>' +
		                       '<label><input class="k-recur-end-never" type="radio" name="end" value="never" />#:end.never#</label>' +
		                   '</li>' +
		                   '<li>' +
		                       '<label><input class="k-recur-end-count" type="radio" name="end" value="count" />#:end.after#</label>' +
		                       '<input class="k-recur-count" title="#:end.occurrence#" />#:end.occurrence#' +
		                   '</li>' +
		                   '<li>' +
		                       '<label><input class="k-recur-end-until" type="radio" name="end" value="until" />#:end.on#</label>' +
		                       '<input class="k-recur-until" title="#:end.on#" />' +
		                   '</li>' +
		               '</ul>' +
		           '</div>' +
		       '# } #'
		    );
	
		    var DAY_RULE = [
		        { day: 0, offset: 0 },
		        { day: 1, offset: 0 },
		        { day: 2, offset: 0 },
		        { day: 3, offset: 0 },
		        { day: 4, offset: 0 },
		        { day: 5, offset: 0 },
		        { day: 6, offset: 0 }
		    ];
	
		    var WEEKDAY_RULE = [
		        { day: 1, offset: 0 },
		        { day: 2, offset: 0 },
		        { day: 3, offset: 0 },
		        { day: 4, offset: 0 },
		        { day: 5, offset: 0 }
		    ];
	
		    var WEEKEND_RULE = [
		        { day: 0, offset: 0 },
		        { day: 6, offset: 0 }
		    ];
	
		    var BaseRecurrenceEditor = Widget.extend({
		        init: function(element, options) {
		            var start;
		            var that = this;
		            var frequencies = options && options.frequencies;
	
		            Widget.fn.init.call(that, element, options);
	
		            that.wrapper = that.element;
	
		            options = that.options;
		            options.start = start = options.start || kendoDate.today();
	
		            if (frequencies) {
		                options.frequencies = frequencies;
		            }
	
		            if (typeof start === "string") {
		                options.start = kendo.parseDate(start, "yyyyMMddTHHmmss");
		            }
	
		            if (options.firstWeekDay === null) {
		                options.firstWeekDay = kendo.culture().calendar.firstDay;
		            }
	
		            that._namespace = "." + options.name;
		        },
	
		        options: {
		            value: "",
		            start: "",
		            timezone: "",
		            spinners: true,
		            firstWeekDay: null,
		            frequencies: [
		                "never",
		                "daily",
		                "weekly",
		                "monthly",
		                "yearly"
		            ],
		            mobile: false,
		            messages: {
		                recurrenceEditorTitle:"Recurrence editor",
		                frequencies: {
		                    never: "Never",
		                    hourly: "Hourly",
		                    daily: "Daily",
		                    weekly: "Weekly",
		                    monthly: "Monthly",
		                    yearly: "Yearly"
		                },
		                hourly: {
		                    repeatEvery: "Repeat every: ",
		                    interval: " hour(s)"
		                },
		                daily: {
		                    repeatEvery: "Repeat every: ",
		                    interval: " day(s)"
		                },
		                weekly: {
		                    interval: " week(s)",
		                    repeatEvery: "Repeat every: ",
		                    repeatOn: "Repeat on: "
		                },
		                monthly: {
		                    repeatEvery: "Repeat every: ",
		                    repeatOn: "Repeat on: ",
		                    interval: " month(s)",
		                    day: "Day "
		                },
		                yearly: {
		                    repeatEvery: "Repeat every: ",
		                    repeatOn: "Repeat on: ",
		                    interval: " year(s)",
		                    of: " of "
		                },
		                end: {
		                    label: "End:",
		                    mobileLabel: "Ends",
		                    never: "Never",
		                    after: "After ",
		                    occurrence: " occurrence(s)",
		                    on: "On "
		                },
		                offsetPositions: {
		                    first: "first",
		                    second: "second",
		                    third: "third",
		                    fourth: "fourth",
		                    last: "last"
		                },
		                weekdays: {
		                    day: "day",
		                    weekday: "weekday",
		                    weekend: "weekend day"
		                }
		            }
		        },
	
		        events: ["change"],
	
		        _initInterval: function() {
		            var that = this;
		            var rule = that._value;
	
		            that._container
		                .find(".k-recur-interval")
		                .kendoNumericTextBox({
		                    spinners: that.options.spinners,
		                    value: rule.interval || 1,
		                    decimals: 0,
		                    format: "#",
		                    min: 1,
		                    change: function() {
		                        rule.interval = this.value();
		                        that._trigger();
		                    }
		                });
		        },
	
		        _weekDayRule: function(clear) {
		            var that = this;
		            var weekday = (that._weekDay.element || that._weekDay).val();
		            var offset = Number((that._weekDayOffset.element || that._weekDayOffset).val());
		            var weekDays = null;
		            var positions = null;
	
		            if (!clear) {
		                if (weekday === "day") {
		                    weekDays = DAY_RULE;
		                    positions = offset;
		                } else if (weekday === "weekday") {
		                    weekDays = WEEKDAY_RULE;
		                    positions = offset;
		                } else if (weekday === "weekend") {
		                    weekDays = WEEKEND_RULE;
		                    positions = offset;
		                } else {
		                    weekDays = [{
		                        offset: offset,
		                        day: Number(weekday)
		                    }];
		                }
		            }
	
		            that._value.weekDays = weekDays;
		            that._value.positions = positions;
		        },
	
		        _weekDayView: function() {
		            var that = this;
		            var weekDays = that._value.weekDays;
		            var positions = that._value.positions;
		            var weekDayOffsetWidget = that._weekDayOffset;
		            var weekDayOffset;
		            var weekDayValue;
		            var length;
		            var method;
	
		            if (weekDays) {
		                length = weekDays.length;
	
		                if (positions) {
		                    if (length === 7) {
		                        weekDayValue = "day";
		                        weekDayOffset = positions;
		                    } else if (length === 5) {
		                        weekDayValue = "weekday";
		                        weekDayOffset = positions;
		                    } else if (length === 2) {
		                        weekDayValue = "weekend";
		                        weekDayOffset = positions;
		                    }
		                }
	
		                if (!weekDayValue) {
		                    weekDays = weekDays[0];
		                    weekDayValue = weekDays.day;
		                    weekDayOffset = weekDays.offset || "";
		                }
	
		                method = weekDayOffsetWidget.value ? "value" : "val";
	
		                weekDayOffsetWidget[method](weekDayOffset);
		                that._weekDay[method](weekDayValue);
		            }
		        },
	
		        _initWeekDay: function() {
		            var that = this, data;
	
		            var weekdayMessage = that.options.messages.weekdays;
		            var offsetMessage = that.options.messages.offsetPositions;
	
		            var weekDayInput = that._container.find(".k-recur-weekday");
	
		            var change = function() {
		                that._weekDayRule();
		                that._trigger();
		            };
	
		            if (weekDayInput[0]) {
		                that._weekDayOffset = new DropDownList(that._container.find(".k-recur-weekday-offset"), {
		                    change: change,
		                    dataTextField: "text",
		                    dataValueField: "value",
		                    dataSource: [
		                        { text: offsetMessage.first, value: "1" },
		                        { text: offsetMessage.second, value: "2" },
		                        { text: offsetMessage.third, value: "3" },
		                        { text: offsetMessage.fourth, value: "4" },
		                        { text: offsetMessage.last, value: "-1" }
		                    ]
		                });
	
		                data = [
		                    { text: weekdayMessage.day, value: "day" },
		                    { text: weekdayMessage.weekday, value: "weekday" },
		                    { text: weekdayMessage.weekend, value: "weekend" }
		                ];
	
		                that._weekDay = new DropDownList(weekDayInput, {
		                    value: that.options.start.getDay(),
		                    change: change,
		                    dataTextField: "text",
		                    dataValueField: "value",
		                    dataSource: data.concat($.map(kendo.culture().calendar.days.names, function(dayName, idx) {
		                        return {
		                            text: dayName,
		                            value: idx
		                        };
		                    }))
		                });
	
		                that._weekDayView();
		            }
		        },
	
		        _initWeekDays: function() {
		            var that = this;
		            var rule = that._value;
		            var weekDays = that._container.find(".k-recur-weekday-checkbox");
	
		            if (weekDays[0]) {
		                weekDays.on(CLICK + that._namespace, function() {
		                    rule.weekDays = $.map(weekDays.filter(":checked"), function(checkbox) {
		                        return {
		                            day: Number(checkbox.value),
		                            offset: 0
		                        };
		                    });
	
		                    if (!that.options.mobile) {
		                        that._trigger();
		                    }
		                });
	
		                if (rule.weekDays) {
		                    var idx, weekDay;
		                    var i = 0, l = weekDays.length;
		                    var length = rule.weekDays.length;
	
		                    for (; i < l; i++) {
		                        weekDay = weekDays[i];
		                        for (idx = 0; idx < length; idx ++) {
		                            if (weekDay.value == rule.weekDays[idx].day) {
		                                weekDay.checked = true;
		                            }
		                        }
		                    }
		                }
		            }
		        },
	
		        _initMonthDay: function() {
		            var that = this;
		            var rule = that._value;
		            var monthDayInput = that._container.find(".k-recur-monthday");
	
		            if (monthDayInput[0]) {
		                that._monthDay = new kendo.ui.NumericTextBox(monthDayInput, {
		                    spinners: that.options.spinners,
		                    min: 1,
		                    max: 31,
		                    decimals: 0,
		                    format: "#",
		                    value: rule.monthDays ? rule.monthDays[0] : that.options.start.getDate(),
		                    change: function() {
		                        var value = this.value();
	
		                        rule.monthDays = value ? [value] : value;
		                        that._trigger();
		                    }
		                });
		            }
		        },
	
		        _initCount: function() {
		            var that = this,
		                input = that._container.find(".k-recur-count"),
		                rule = that._value;
	
		            that._count = input.kendoNumericTextBox({
		                spinners: that.options.spinners,
		                value: rule.count || 1,
		                decimals: 0,
		                format: "#",
		                min: 1,
		                change: function() {
		                    rule.count = this.value();
		                    that._trigger();
		                }
		            }).data("kendoNumericTextBox");
		        },
	
		        _initUntil: function() {
		            var that = this,
		                input = that._container.find(".k-recur-until"),
		                start = that.options.start,
		                rule = that._value,
		                until = rule.until;
	
		            that._until = input.kendoDatePicker({
		                min: until && until < start ? until : start,
		                value: until || new Date(start.getFullYear(), start.getMonth(), start.getDate(), 23, 59, 59),
		                change: function() {
		                    var date  = this.value();
	
		                    rule.until =  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
		                    that._trigger();
		                }
		            }).data("kendoDatePicker");
		        },
	
		        _trigger: function() {
		            if (!this.options.mobile) {
		                this.trigger("change");
		            }
		        }
		    });
	
		    var RecurrenceEditor = BaseRecurrenceEditor.extend({
		        init: function(element, options) {
		            var that = this;
	
		            BaseRecurrenceEditor.fn.init.call(that, element, options);
	
		            that._initFrequency();
	
		            that._initContainer();
	
		            that.value(that.options.value);
		        },
	
		        options: {
		            name: "RecurrenceEditor"
		        },
	
		        events: [ "change" ],
	
		        destroy: function() {
		            var that = this;
	
		            that._frequency.destroy();
		            that._container.find("input[type=radio],input[type=checkbox]").off(CLICK + that._namespace);
	
		            kendo.destroy(that._container);
	
		            BaseRecurrenceEditor.fn.destroy.call(that);
		        },
	
		        value: function(value) {
		            var that = this;
		            var timezone = that.options.timezone;
		            var freq;
	
		            if (value === undefined) {
		                if (!that._value.freq) {
		                    return "";
		                }
	
		                return serialize(that._value, timezone);
		            }
	
		            that._value = parseRule(value, timezone) || {};
	
		            freq = that._value.freq;
	
		            if (freq) {
		                that._frequency.value(freq);
		            } else {
		                that._frequency.select(0);
		            }
	
		            that._initView(that._frequency.value());
		        },
	
		        _initContainer: function() {
		            var element = this.element,
		                container = $('<div class="k-recur-view" />'),
		                editContainer = element.parent(".k-edit-field");
	
		            if (editContainer[0]) {
		                container.insertAfter(editContainer);
		            } else {
		                element.append(container);
		            }
	
		            this._container = container;
		        },
	
		        _initFrequency: function() {
		            var that = this,
		                options = that.options,
		                frequencies = options.frequencies,
		                messages = options.messages.frequencies,
		                ddl = $('<input />').attr({title: options.messages.recurrenceEditorTitle}),
		                frequency;
	
		            frequencies = $.map(frequencies, function(frequency) {
		                return {
		                    text: messages[frequency],
		                    value: frequency
		                };
		            });
	
		            frequency = frequencies[0];
		            if (frequency && frequency.value === "never") {
		                frequency.value = "";
		            }
	
		            that.element.append(ddl);
		            that._frequency = new DropDownList(ddl, {
		                dataTextField: "text",
		                dataValueField: "value",
		                dataSource: frequencies,
		                change: function() {
		                    that._value = {};
		                    that._initView(that._frequency.value());
		                    that.trigger("change");
		                }
		            });
		        },
	
		        _initView: function(frequency) {
		            var that = this;
		            var rule = that._value;
		            var options = that.options;
	
		            var data = {
		                 frequency: frequency || "never",
		                 weekDayCheckBoxes: weekDayCheckBoxes,
		                 firstWeekDay: options.firstWeekDay,
		                 messages: options.messages[frequency],
		                 end: options.messages.end
		            };
	
		            kendo.destroy(that._container);
		            that._container.html(RECURRENCE_VIEW_TEMPLATE(data));
	
		            if (!frequency) {
		                that._value = {};
		                return;
		            }
	
		            rule.freq = frequency;
	
		            if (frequency === "weekly" && !rule.weekDays) {
		                rule.weekDays = [{
		                    day: options.start.getDay(),
		                    offset: 0
		                }];
		            }
	
		            that._initInterval();
		            that._initWeekDays();
		            that._initMonthDay();
		            that._initWeekDay();
		            that._initMonth();
		            that._initCount();
		            that._initUntil();
	
		            that._period();
		            that._end();
		        },
	
		        _initMonth: function() {
		            var that = this;
		            var rule = that._value;
		            var month = rule.months || [that.options.start.getMonth() + 1];
		            var monthInputs = that._container.find(".k-recur-month");
		            var options;
	
		            if (monthInputs[0]) {
		                options = {
		                    change:  function() {
		                        rule.months = [Number(this.value())];
		                        that.trigger("change");
		                    },
		                    dataTextField: "text",
		                    dataValueField: "value",
		                    dataSource: $.map(kendo.culture().calendar.months.names, function(monthName, idx) {
		                        return {
		                            text: monthName,
		                            value: idx + 1
		                        };
		                    })
		                };
	
		                that._month1 = new DropDownList(monthInputs[0], options);
		                that._month2 = new DropDownList(monthInputs[1], options);
	
		                if (month) {
		                    month = month[0];
		                    that._month1.value(month);
		                    that._month2.value(month);
		                }
		            }
	
		        },
	
		        _end: function() {
		            var that = this;
		            var rule = that._value;
		            var container = that._container;
		            var namespace = that._namespace;
		            var click = function(e) {
		                that._toggleEnd(e.currentTarget.value);
		                that.trigger("change");
		            };
		            var endRule;
	
		            that._buttonNever = container.find(".k-recur-end-never").on(CLICK + namespace, click);
		            that._buttonCount = container.find(".k-recur-end-count").on(CLICK + namespace, click);
		            that._buttonUntil = container.find(".k-recur-end-until").on(CLICK + namespace, click);
	
		            if (rule.count) {
		                endRule = "count";
		            } else if (rule.until) {
		                endRule = "until";
		            }
	
		            that._toggleEnd(endRule);
		        },
	
		        _period: function() {
		            var that = this;
		            var rule = that._value;
		            var monthly = rule.freq === "monthly";
	
		            var toggleRule = monthly ? that._toggleMonthDay : that._toggleYear;
	
		            var selector = ".k-recur-" + (monthly ? "month" : "year") + "-radio";
		            var radioButtons = that._container.find(selector);
	
		            if (!monthly && rule.freq !== "yearly") {
		                return;
		            }
	
		            radioButtons.on(CLICK + that._namespace, function(e) {
		                toggleRule.call(that, e.currentTarget.value);
		                that.trigger("change");
		            });
	
		            that._buttonMonthDay = radioButtons.eq(0);
		            that._buttonWeekDay = radioButtons.eq(1);
	
		            toggleRule.call(that, rule.weekDays ? "weekday" : "monthday");
		        },
	
		        _toggleEnd: function(endRule) {
		            var that = this;
		            var count, until;
		            var enableCount, enableUntil;
	
		            if (endRule === "count") {
		                that._buttonCount.prop("checked", true);
	
		                enableCount = true;
		                enableUntil = false;
	
		                count = that._count.value();
		                until = null;
		            } else if (endRule === "until") {
		                that._buttonUntil.prop("checked", true);
	
		                enableCount = false;
		                enableUntil = true;
	
		                count = null;
		                until = that._until.value();
		            } else {
		                that._buttonNever.prop("checked", true);
	
		                enableCount = enableUntil = false;
		                count = until = null;
		            }
	
		            if(that._count){
		                that._count.enable(enableCount);
		            }
	
		            if(that._until){
		                that._until.enable(enableUntil);
		            }
	
		            that._value.count = count;
		            that._value.until = until;
		        },
	
		        _toggleMonthDay: function(monthRule) {
		            var that = this;
		            var enableMonthDay = false;
		            var enableWeekDay = true;
		            var clear = false;
		            var monthDays;
	
		            if (monthRule === "monthday") {
		                that._buttonMonthDay.prop("checked", true);
	
		                monthDays = [that._monthDay.value()];
	
		                enableMonthDay = true;
		                enableWeekDay = false;
		                clear = true;
		            } else {
		                that._buttonWeekDay.prop("checked", true);
		                monthDays = null;
		            }
	
		            that._weekDay.enable(enableWeekDay);
		            that._weekDayOffset.enable(enableWeekDay);
		            that._monthDay.enable(enableMonthDay);
	
		            that._value.monthDays = monthDays;
	
		            that._weekDayRule(clear);
		        },
	
		        _toggleYear: function(yearRule) {
		            var that = this;
		            var enableMonth1 = false;
		            var enableMonth2 = true;
		            var month;
	
		            if (yearRule === "monthday") {
		                enableMonth1 = true;
		                enableMonth2 = false;
	
		                month = that._month1.value();
		            } else {
		                month = that._month2.value();
		            }
	
		            that._month1.enable(enableMonth1);
		            that._month2.enable(enableMonth2);
	
		            that._value.months = [month];
		            that._toggleMonthDay(yearRule);
		        }
		    });
	
		    ui.plugin(RecurrenceEditor);
	
	
		    var RECURRENCE_HEADER_TEMPLATE = kendo.template('<div class="k-edit-label"><label>#:headerTitle#</label></div>' +
		      '<div class="k-edit-field k-recur-pattern k-scheduler-toolbar"></div>' +
		      '<div class="k-recur-view"></div>'
		    );
	
		    var RECURRENCE_REPEAT_PATTERN_TEMPLATE = kendo.template(
		       '# if (frequency !== "never") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatEvery#</label></div>' +
		           '<div class="k-edit-field"><input class="k-recur-interval" pattern="\\\\d*"/>#:messages.interval#</div>' +
		       '# } #' +
		       '# if (frequency === "weekly") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatOn#</label></div>' +
		           '<div class="k-edit-field">#=weekDayCheckBoxes(firstWeekDay)#</div>' +
		       '# } else if (frequency === "monthly") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatBy#</label></div>' +
		           '<div class="k-edit-field k-scheduler-toolbar k-repeat-rule"></div>' +
		           '<div class="k-monthday-view" style="display:none">' +
		               '<div class="k-edit-label"><label>#:messages.day#</label></div>' +
		               '<div class="k-edit-field"><input class="k-recur-monthday" title="#:messages.day#" pattern="\\\\d*"/></div>' +
		           '</div>' +
		           '<div class="k-weekday-view" style="display:none">' +
		               '<div class="k-edit-label"><label>#:messages.every#</label></div>' +
		               '<div class="k-edit-field"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div>' +
		               '<div class="k-edit-label"><label>#:messages.day#</label></div>' +
		               '<div class="k-edit-field"><select class="k-recur-weekday" title="#:messages.day#"></select></div>' +
		           '</div>' +
		       '# } else if (frequency === "yearly") { #' +
		           '<div class="k-edit-label"><label>#:messages.repeatBy#</label></div>' +
		           '<div class="k-edit-field k-scheduler-toolbar k-repeat-rule"></div>' +
		           '<div class="k-monthday-view" style="display:none">' +
		               '<div class="k-edit-label"><label>#:messages.day#</label></div>' +
		               '<div class="k-edit-field"><input class="k-recur-monthday" title="#:messages.day#" pattern="\\\\d*"/></div>' +
		           '</div>' +
		           '<div class="k-weekday-view" style="display:none">' +
		               '<div class="k-edit-label"><label>#:messages.every#</label></div>' +
		               '<div class="k-edit-field"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div>' +
		               '<div class="k-edit-label"><label>#:messages.day#</label></div>' +
		               '<div class="k-edit-field"><select class="k-recur-weekday" title="#:messages.day#"></select></div>' +
		           '</div>' +
		           '<div class="k-edit-label"><label>#:messages.month#</label></div>' +
		           '<div class="k-edit-field"><select class="k-recur-month" title="#:messages.month#"></select></div>' +
		       '# } #'
		    );
	
		    var RECURRENCE_END_PATTERN_TEMPLATE = kendo.template(
		        '# if (endPattern === "count") { #' +
		           '<div class="k-edit-label"><label>#:messages.after#</label></div>' +
		           '<div class="k-edit-field"><input class="k-recur-count" pattern="\\\\d*" /></div>' +
		        '# } else if (endPattern === "until") { #' +
		           '<div class="k-edit-label"><label>#:messages.on#</label></div>' +
		           '<div class="k-edit-field"><input type="date" class="k-recur-until" /></div>' +
		        '# } #'
		    );
	
		    var RECURRENCE_GROUP_BUTTON_TEMPLATE = kendo.template(
		        '<ul class="k-reset k-header k-scheduler-navigation">' +
		            '#for (var i = 0, length = dataSource.length; i < length; i++) {#' +
		                '<li class="k-state-default #= value === dataSource[i].value ? \"k-state-selected\" : \"\" #">' +
		                    '<a role="button" href="\\#" class="k-link" data-#=ns#value="#=dataSource[i].value#">#:dataSource[i].text#</a>' +
		                '</li>' +
		            '#}#'  +
		        '</ul>'
		    );
	
		    var MobileRecurrenceEditor = BaseRecurrenceEditor.extend({
		        init: function(element, options) {
		            var that = this;
	
		            BaseRecurrenceEditor.fn.init.call(that, element, options);
	
		            options = that.options;
	
		            that._optionTemplate = kendo.template('<option value="#:value#">#:text#</option>');
	
		            that.value(options.value);
	
		            that._pane = options.pane;
	
		            that._initRepeatButton();
	
		            that._initRepeatEnd();
	
		            that._defaultValue = that._value;
		        },
	
		        options: {
		            name: "MobileRecurrenceEditor",
		            animations: {
		                left: "slide",
		                right: "slide:right"
		            },
		            mobile: true,
		            messages: {
		                cancel: "Cancel",
		                update: "Save",
		                endTitle: "Repeat ends",
		                repeatTitle: "Repeat pattern",
		                headerTitle: "Repeat event",
		                end: {
		                    patterns: {
		                        never: "Never",
		                        after: "After...",
		                        on: "On..."
		                    },
		                    never: "Never",
		                    after: "End repeat after",
		                    on: "End repeat on"
		                },
		                daily: {
		                    interval: ""
		                },
		                hourly: {
		                    interval: ""
		                },
		                weekly: {
		                    interval: ""
		                },
		                monthly: {
		                    interval: "",
		                    repeatBy: "Repeat by: ",
		                    dayOfMonth: "Day of the month",
		                    dayOfWeek: "Day of the week",
		                    repeatEvery: "Repeat every",
		                    every: "Every",
		                    day: "Day "
		                },
		                yearly: {
		                    interval: "",
		                    repeatBy: "Repeat by: ",
		                    dayOfMonth: "Day of the month",
		                    dayOfWeek: "Day of the week",
		                    repeatEvery: "Repeat every: ",
		                    every: "Every",
		                    month: "Month",
		                    day: "Day"
		                }
		            }
		        },
	
		        events: [ "change" ],
	
		        value: function(value) {
		            var that = this;
		            var timezone = that.options.timezone;
	
		            if (value === undefined) {
		                if (!that._value.freq) {
		                    return "";
		                }
	
		                return serialize(that._value, timezone);
		            }
	
		            that._value = parseRule(value, timezone) || {};
		        },
	
		        destroy: function() {
		            this._destroyView();
	
		            kendo.destroy(this._endFields);
	
		            this._repeatButton.off(CLICK + this._namespace);
	
		            BaseRecurrenceEditor.fn.destroy.call(this);
		        },
	
		        _initRepeatButton: function() {
		            var that = this;
		            var freq = that.options.messages.frequencies[this._value.freq || "never"];
	
		            that._repeatButton = $('<a href="#" class="k-button k-scheduler-recur">' + freq + '</a>')
		                                    .on(CLICK + that._namespace, function(e) {
		                                        e.preventDefault();
		                                        that._createView("repeat");
		                                        that._pane.navigate("recurrence", that.options.animations.left);
		                                    });
	
		            that.element.append(that._repeatButton);
		        },
	
		        _initRepeatEnd: function() {
		            var that = this;
	
		            var endLabelField = $('<div class="k-edit-label"><label>' + that.options.messages.end.mobileLabel + '</label></div>').insertAfter(that.element.parent(".k-edit-field"));
	
		            var endEditField = $('<div class="k-edit-field"><a href="#" class="k-button k-scheduler-recur-end"></a></div>')
		                .on(CLICK + that._namespace, function(e) {
		                    e.preventDefault();
	
		                    if (!that._value.freq) {
		                        return;
		                    }
	
		                    that._createView("end");
		                    that._pane.navigate("recurrence", that.options.animations.left);
		                })
		                .insertAfter(endLabelField);
	
		            that._endFields = endLabelField.add(endEditField).toggleClass("k-state-disabled", !that._value.freq);
		            that._endButton = endEditField.find(".k-scheduler-recur-end").text(that._endText());
		        },
	
		        _endText: function() {
		            var rule = this._value;
		            var messages = this.options.messages.end;
	
		            var text = messages.never;
	
		            if (rule.count) {
		                text = kendo.format("{0} {1}", messages.after, rule.count);
		            } else if (rule.until) {
		                text = kendo.format("{0} {1:d}", messages.on, rule.until);
		            }
	
		            return text;
		        },
	
		        _initFrequency: function() {
		            var that = this;
		            var frequencyMessages = that.options.messages.frequencies;
	
		            var html = RECURRENCE_GROUP_BUTTON_TEMPLATE({
		                dataSource: $.map(this.options.frequencies, function(frequency) {
		                    return {
		                        text: frequencyMessages[frequency],
		                        value: frequency !== "never" ? frequency : ""
		                    };
		                }),
		                value: that._value.freq || "",
		                ns: kendo.ns
		            });
	
		            that._view.element
		                .find(".k-recur-pattern")
		                .append(html)
		                .on(CLICK + that._namespace, ".k-scheduler-navigation li", function(e) {
		                    var li = $(this);
	
		                    e.preventDefault();
	
		                    li.addClass("k-state-selected")
		                      .siblings().removeClass("k-state-selected");
	
		                    that._value = { freq: li.children("a").attr(kendo.attr("value")) };
	
		                    that._initRepeatView();
		                });
		        },
	
		        _initEndNavigation: function() {
		            var that = this;
		            var endMessages = that.options.messages.end.patterns;
		            var rule = that._value;
		            var value = "";
	
		            if (rule.count) {
		                value = "count";
		            } else if (rule.until) {
		                value = "until";
		            }
	
		            var html = RECURRENCE_GROUP_BUTTON_TEMPLATE({
		                dataSource: [
		                    { text: endMessages.never, value: "" },
		                    { text: endMessages.after, value: "count" },
		                    { text: endMessages.on, value: "until" }
		                ],
		                value: value,
		                ns: kendo.ns
		            });
	
		            that._view.element
		                .find(".k-recur-pattern")
		                .append(html)
		                .on(CLICK + that._namespace, ".k-scheduler-navigation li", function(e) {
		                    var li = $(this);
		                    var count = null;
		                    var until = null;
	
		                    e.preventDefault();
	
		                    li.addClass("k-state-selected")
		                      .siblings().removeClass("k-state-selected");
	
		                    that._initEndView(li.children("a").attr(kendo.attr("value")));
	
		                    if (that._count) {
		                        count = that._count.value();
		                        until = null;
		                    } else if (that._until) {
		                        count = null;
		                        until = that._until.val ? kendo.parseDate(that._until.val(), "yyyy-MM-dd") : that._until.value();
		                    }
	
		                    rule.count = count;
		                    rule.until = until;
		                });
		        },
	
		        _createView: function(viewType) {
		            var that = this;
		            var options = that.options;
		            var messages = options.messages;
		            var headerTitle = messages[viewType === "repeat" ? "repeatTitle" : "endTitle"];
	
		            var html = '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form k-mobile-list" id="recurrence">' +
		                       '<div data-role="header" class="k-header">' +
		                           '<a href="#" class="k-button k-scheduler-cancel">' + messages.cancel + '</a>' +
		                               messages.headerTitle +
		                           '<a href="#" class="k-button k-scheduler-update">' + messages.update + '</a>' +
		                       '</div>';
	
		            var returnViewId = that._pane.view().id;
	
		            that._view = that._pane.append(html + RECURRENCE_HEADER_TEMPLATE({ headerTitle: headerTitle }));
	
		            that._view.element.on(CLICK + that._namespace, "a.k-scheduler-cancel, a.k-scheduler-update", function(e) {
		                e.preventDefault();
		                e.stopPropagation();
	
		                if ($(this).hasClass("k-scheduler-update")) {
		                    that.trigger("change");
		                    that._defaultValue = $.extend({}, that._value);
		                } else {
		                    that._value = that._defaultValue;
		                }
	
		                var frequency = that._value.freq;
	
		                that._endButton.text(that._endText());
		                that._endFields.toggleClass("k-state-disabled", !frequency);
		                that._repeatButton.text(messages.frequencies[frequency || "never"]);
	
		                that._pane.one("viewShow", function() {
		                    that._destroyView();
		                });
	
		                that._pane.navigate(returnViewId, that.options.animations.right);
		            });
	
		            that._container = that._view.element.find(".k-recur-view");
	
		            if (viewType === "repeat") {
		                that._initFrequency();
		                that._initRepeatView();
		            } else {
		                that._initEndNavigation();
		                that._initEndView();
		            }
		        },
	
		        _destroyView: function() {
		            if (this._view) {
		                this._view.destroy();
		                this._view.element.remove();
		            }
	
		            this._view = null;
		        },
	
		        _initRepeatView: function() {
		            var that = this;
		            var frequency = that._value.freq || "never";
	
		            var data = {
		                 frequency: frequency,
		                 weekDayCheckBoxes: weekDayCheckBoxes,
		                 firstWeekDay: that.options.firstWeekDay,
		                 messages: that.options.messages[frequency]
		            };
	
		            var html = RECURRENCE_REPEAT_PATTERN_TEMPLATE(data);
		            var container = that._container;
		            var rule = that._value;
	
		            kendo.destroy(container);
		            container.html(html);
	
		            if (!html) {
		                that._value = {};
		                return;
		            }
	
		            if (frequency === "weekly" && !rule.weekDays) {
		                 rule.weekDays = [{
		                    day: that.options.start.getDay(),
		                    offset: 0
		                 }];
		            }
	
		            that._initInterval();
		            that._initMonthDay();
		            that._initWeekDays();
		            that._initWeekDay();
		            that._initMonth();
	
		            that._period();
		        },
	
		        _initEndView: function (endPattern) {
		            var that = this;
		            var rule = that._value;
	
		            if (endPattern === undefined) {
		                if (rule.count) {
		                    endPattern = "count";
		                } else if (rule.until) {
		                    endPattern = "until";
		                }
		            }
	
		            var data = {
		                 endPattern: endPattern,
		                 messages: that.options.messages.end
		            };
	
		            kendo.destroy(that._container);
		            that._container.html(RECURRENCE_END_PATTERN_TEMPLATE(data));
	
		            that._initCount();
		            that._initUntil();
		        },
	
		        _initWeekDay: function() {
		            var that = this, data;
	
		            var weekdayMessage = that.options.messages.weekdays;
		            var offsetMessage = that.options.messages.offsetPositions;
	
		            var weekDaySelect = that._container.find(".k-recur-weekday");
	
		            var change = function() {
		                that._weekDayRule();
		                that.trigger("change");
		            };
	
		            if (weekDaySelect[0]) {
		                that._weekDayOffset = that._container.find(".k-recur-weekday-offset")
		                                          .html(that._options([
		                                            { text: offsetMessage.first, value: "1" },
		                                            { text: offsetMessage.second, value: "2" },
		                                            { text: offsetMessage.third, value: "3" },
		                                            { text: offsetMessage.fourth, value: "4" },
		                                            { text: offsetMessage.last, value: "-1" }
		                                          ]))
		                                          .change(change);
	
		                data = [
		                    { text: weekdayMessage.day, value: "day" },
		                    { text: weekdayMessage.weekday, value: "weekday" },
		                    { text: weekdayMessage.weekend, value: "weekend" }
		                ];
	
		                data = data.concat($.map(kendo.culture().calendar.days.names, function(dayName, idx) {
		                    return {
		                        text: dayName,
		                        value: idx
		                    };
		                }));
	
		                that._weekDay = weekDaySelect.html(that._options(data))
		                                             .change(change)
		                                             .val(that.options.start.getDay());
	
		                that._weekDayView();
		            }
		        },
	
		        _initMonth: function() {
		            var that = this;
		            var rule = that._value;
		            var start = that.options.start;
		            var month = rule.months || [start.getMonth() + 1];
		            var monthSelect = that._container.find(".k-recur-month");
		            var monthNames = kendo.culture().calendar.months.names;
	
		            if (monthSelect[0]) {
		                var data = $.map(monthNames, function(monthName, idx) {
		                    return {
		                        text: monthName,
		                        value: idx + 1
		                    };
		                });
	
		                monthSelect.html(that._options(data))
		                           .change(function() {
		                               rule.months = [Number(this.value)];
		                           });
	
		                that._monthSelect = monthSelect;
	
		                if (month) {
		                    monthSelect.val(month[0]);
		                }
		            }
	
		        },
	
		        _period: function() {
		            var that = this;
		            var rule = that._value;
		            var container = that._container;
		            var messages = that.options.messages[rule.freq];
		            var repeatRuleGroupButton = container.find(".k-repeat-rule");
		            var weekDayView = container.find(".k-weekday-view");
		            var monthDayView = container.find(".k-monthday-view");
	
		            if (repeatRuleGroupButton[0]) {
		                var currentValue = rule.weekDays ? "weekday" : "monthday";
	
		                var html = RECURRENCE_GROUP_BUTTON_TEMPLATE({
		                    value : currentValue,
		                    dataSource: [
		                        { text: messages.dayOfMonth, value: "monthday" },
		                        { text: messages.dayOfWeek, value: "weekday" }
		                    ],
		                    ns: kendo.ns
		                });
	
		                var init = function(val) {
		                    var weekDayName = that._weekDay.val();
		                    var weekDayOffset = that._weekDayOffset.val();
		                    var monthDay = that._monthDay.value();
		                    var month = that._monthSelect ? that._monthSelect.val() : null;
	
		                    if (val === "monthday") {
		                        rule.weekDays = null;
		                        rule.monthDays = monthDay ? [monthDay] : monthDay;
		                        rule.months = month ? [Number(month)] : month;
	
		                        weekDayView.hide();
		                        monthDayView.show();
		                    } else {
		                        rule.monthDays = null;
		                        rule.months = month ? [Number(month)] : month;
	
		                        rule.weekDays = [{
		                            offset: Number(weekDayOffset),
		                            day: Number(weekDayName)
		                        }];
	
		                        weekDayView.show();
		                        monthDayView.hide();
		                    }
		                };
	
		                repeatRuleGroupButton
		                    .append(html)
		                    .on(CLICK + that._namespace, ".k-scheduler-navigation li", function(e) {
		                        var li = $(this).addClass("k-state-selected");
	
		                        e.preventDefault();
	
		                        li.siblings().removeClass("k-state-selected");
	
		                        var value = li.children("a").attr(kendo.attr("value"));
	
		                        init(value);
		                    });
	
		                init(currentValue);
		            }
		        },
	
		        _initUntil: function() {
		            var that = this;
		            var input = that._container.find(".k-recur-until");
		            var start = that.options.start;
		            var rule = that._value;
		            var until = rule.until;
		            var min = until && until < start ? until : start;
	
		            if (kendo.support.input.date) {
		                that._until = input.attr("min", kendo.toString(min, "yyyy-MM-dd"))
		                                   .val(kendo.toString(until || start, "yyyy-MM-dd"))
		                                   .on("change", function() {
		                                       rule.until = kendo.parseDate(this.value, "yyyy-MM-dd");
		                                   });
		            } else {
		                that._until = input.kendoDatePicker({
		                    min: min,
		                    value: until || start,
		                    change: function() {
		                        rule.until = this.value();
		                    }
		                }).data("kendoDatePicker");
		            }
		        },
	
		        _options: function(data, optionLabel) {
		            var idx = 0;
		            var html = "";
		            var length = data.length;
		            var template = this._optionTemplate;
	
		            if (optionLabel) {
		                html += template({ value: "", text: optionLabel });
		            }
	
		            for (; idx < length; idx++) {
		                html += template(data[idx]);
		            }
	
		            return html;
		        }
		    });
	
		    ui.plugin(MobileRecurrenceEditor);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1282);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1278:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(637);
	
	/***/ }),
	
	/***/ 1282:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1278) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    var __meta__ = { // jshint ignore:line
		        id: "scheduler.agendaview",
		        name: "Scheduler Agenda View",
		        category: "web",
		        description: "The Scheduler Agenda View",
		        depends: [ "scheduler.view" ],
		        hidden: true
		    };
	
		    (function($){
		        var kendo = window.kendo,
		            ui = kendo.ui,
		            NS = ".kendoAgendaView";
	
		        var EVENT_WRAPPER_FORMAT = '<div class="k-task" title="#:(data.title || "").replace(/"/g,"\'")#" data-#=kendo.ns#uid="#=uid#">' +
		                                   '# if (resources[0]) {#' +
		                                   '<span class="k-scheduler-mark" style="background-color:#=resources[0].color#"></span>' +
		                                   "# } #" +
		                                   "# if (data.isException()) { #" +
		                                   '<span class="k-icon k-i-non-recurrence"></span>' +
		                                   '# } else if (data.isRecurring()) {#' +
		                                   '<span class="k-icon k-i-reload"></span>' +
		                                   "# } #" +
		                                   '{0}' +
		                                   '#if (showDelete) {#' +
		                                       '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
		                                   '#}#' +
		                               '</div>';
	
		            var AgendaGroupedView = kendo.Class.extend({
		    	        init: function(view) {
		    		        this._view = view;
		    	        },
	
		                _getColumns: function(groupHeaders, columns){
		                    return groupHeaders.concat(columns);
		                },
		                _getGroupsInDay: function(){
		                    return [];
		                },
	
		                _getSumOfItemsForDate: function(){
		                    return 0;
		                },
	
		                _renderTaskGroupsCells: function(headerCells, groups, taskGroupIndex, taskIndex){
		                    var view = this._view;
	
		                    if (taskGroupIndex === 0 && taskIndex === 0 && groups.length) {
		                         view._renderTaskGroupsCells(headerCells, groups);
		                    }
		                },
	
		                _renderDateCell: function(tableRow, groups, tasks, date, taskGroupIndex, tasksGroups){
		                     var view = this._view;
	
		                     tableRow.push(kendo.format(
		                        '<td class="k-scheduler-datecolumn{3}{2}" rowspan="{0}">{1}</td>',
		                        tasks.length,
		                        view._dateTemplate({ date: date }),
		                        taskGroupIndex == tasksGroups.length - 1 && !groups.length ? " k-last" : "",
		                        !groups.length ? " k-first" : ""
		                    ));
		                },
	
		                _renderDates: function (){
		                     return undefined;
		                },
	
		                _getParents: function (parentGroups){
		                    return parentGroups.splice(0);
		                },
	
		                _getGroupsByDate: function(){
		                    return undefined;
		                },
	
		                _renderTaskGroups: function(table, items, parents){
		                    var view = this._view;
	
		                    table.append(view._renderTaskGroups(items, parents));
		                }
	
		            });
	
			        var AgendaGroupedByDateView = kendo.Class.extend({
		                init: function(view) {
		    	            this._view = view;
		                },
	
		                _getColumns: function(groupHeaders, columns){
		                    var view = this._view;
	
		                    if (view._isMobilePhoneView()) {
		                        return groupHeaders.concat(columns);
		                    } else {
		                        var date = columns.slice(0, 1);
		                        var columnsWithoutDate = columns.slice(1);
	
		                        return date.concat(groupHeaders).concat(columnsWithoutDate);
		                    }
		                },
	
		                _compareDateGroups: function(currentGroup, prevGroup, index){
		                    if (currentGroup[index].text == prevGroup[index].text) {
		                        if (index === 0) {
		                            return true;
		                        }else {
		                            return this._compareDateGroups(currentGroup, prevGroup, index - 1);
		                        }
		                    }
	
		                    return false;
		                },
	
		                _getGroupsInDay: function(tasksGroups, groups){
		                      var groupsInDay = [];
		                      var prevGroup = null;
	
		                       for (var tasksGroupIdx = 0; tasksGroupIdx < tasksGroups.length; tasksGroupIdx++) {
		                            for (var itemsIdx = 0; itemsIdx < tasksGroups[tasksGroupIdx].items.length; itemsIdx++) {
		                                var idx = 0;
	
		                                if (groupsInDay.length === 0) {
		                                    for (idx; idx < groups[tasksGroupIdx].length; idx++) {
		                                        groupsInDay.push([1]);
		                                    }
		                                } else {
		                                    for (idx; idx < groups[tasksGroupIdx].length; idx++) {
	
		                                        if (this._compareDateGroups(groups[tasksGroupIdx], prevGroup, idx)) {
		                                            groupsInDay[idx][groupsInDay[idx].length - 1]++;
		                                        } else {
		                                            var lastItemValue = groupsInDay[idx][groupsInDay[idx].length - 1] - 1;
		                                            for (var i = 0; i < lastItemValue; i++) {
		                                                groupsInDay[idx].push(0);
		                                            }
		                                            groupsInDay[idx].push(1);
		                                        }
		                                    }
		                                }
		                                prevGroup = groups[tasksGroupIdx];
		                            }
		                        }
	
		                        return groupsInDay;
		                },
	
		                _getSumOfItemsForDate: function(tasksGroups){
		                    var sumOfItemsForDate = 0;
	
		                    for (var i = 0; i < tasksGroups.length; i++) {
	
		                        sumOfItemsForDate += tasksGroups[i].items.length;
		                    }
		                    return sumOfItemsForDate;
		                },
	
		                _renderTaskGroupsCells: function(headerCells, groups, taskGroupIndex, taskIndex, groupsInDay, sumOfItemsForDate, date, groupsRowSpanIndex){
		                    var view = this._view;
		                    var isPhoneView = view._isMobilePhoneView();
	
		                     if(!isPhoneView){
		                        if (taskGroupIndex === 0 && taskIndex === 0 ) {
		                            headerCells.push(kendo.format(
		                                '<td class="k-scheduler-datecolumn k-first" rowspan="{0}">{1}</td>',
		                                sumOfItemsForDate,
		                                view._dateTemplate({ date: date })
		                            ));
		                        }
	
		                        for (var idx = 0; idx < groups[taskGroupIndex].length; idx++) {
		                            if (groupsInDay[idx][groupsRowSpanIndex]) {
		                                headerCells.push(kendo.format(
		                                    '<td class="k-scheduler-groupcolumn" rowspan="{0}">{1}</td>',
		                                    groupsInDay[idx][groupsRowSpanIndex],
		                                    view._groupTemplate({ value: groups[taskGroupIndex][idx].text }),
		                                    groups[taskGroupIndex][idx].className
		                                ));
		                            }
		                        }
		                    }else{
		                        if (taskGroupIndex === 0 && taskIndex === 0 && groups.length) {
		                            view._renderTaskGroupsCells(headerCells, groups);
		                        }
		                    }
		                },
	
		                _renderDateCell: function(){
		                   return undefined;
		                },
	
		                _renderDates: function(table){
		                    var view = this._view;
		                    var sortedArray = view._groupsByDate.sort(function(a, b) {
		                        return a.array[0].value.getTime() - b.array[0].value.getTime();
		                    });
	
		                    for (var i = 0; i < sortedArray.length; i++) {
		                        table.append(view._renderTaskGroups(sortedArray[i].array, sortedArray[i].groups));
		                    }
		                },
	
		                _getParents: function(parentGroups){
		                    return parentGroups.slice(0);
		                },
	
		                _getGroupsByDate: function(groups, idx, parents){
		                    var view = this._view;
	
		                    if (groups[idx].items) {
		                        for (var taskGroupIndex = 0; taskGroupIndex < groups[idx].items.length; taskGroupIndex++) {
		                            var date = groups[idx].items[taskGroupIndex].value;
		                            var dateExists = false;
	
		                            for (var i = 0; i < view._groupsByDate.length; i++) {
		                                if (view._groupsByDate[i].array[0].value.getTime() === date.getTime()) {
		                                    dateExists = true;
		                                    view._groupsByDate[i].array.push(groups[idx].items[taskGroupIndex]);
		                                    view._groupsByDate[i].groups.push(parents);
		                                }
		                            }
	
		                            if (!dateExists) {
		                                view._groupsByDate.push({
		                                    array: [groups[idx].items[taskGroupIndex]],
		                                    groups: [parents]
		                                });
		                            }
		                        }
		                    }
		                },
	
		                _renderTaskGroups: function(){
		                    return undefined;
		                }
	
			        });
	
			        kendo.ui.scheduler.AgendaGroupedView = AgendaGroupedView;
			        kendo.ui.scheduler.AgendaGroupedByDateView = AgendaGroupedByDateView;
	
	
		        ui.AgendaView = ui.SchedulerView.extend({
		            init: function(element, options) {
		                ui.SchedulerView.fn.init.call(this, element, options);
	
		                this._groupedView = this._getGroupedView();
	
		                options = this.options;
	
		                if (options.editable) {
		                    options.editable = $.extend(
		                        { "delete": true },
		                        options.editable,
		                        { create: false, update: false },
		                        { messages: options.messages }
		                    );
		                }
	
		                this.title = options.title;
	
		                this._eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_FORMAT);
		                this._dateTemplate = kendo.template(options.eventDateTemplate);
		                this._groupTemplate = kendo.template(options.eventGroupTemplate);
		                this._timeTemplate = kendo.template(options.eventTimeTemplate);
	
		                this.element.on("mouseenter" + NS, ".k-scheduler-agenda .k-scheduler-content tr", "_mouseenter")
		                            .on("mouseleave" + NS, ".k-scheduler-agenda .k-scheduler-content tr", "_mouseleave")
		                            .on("click" + NS, ".k-scheduler-agenda .k-scheduler-content .k-link:has(.k-i-close)", "_remove");
	
		                this._renderLayout(options.date);
		            },
	
		            name: "agenda",
	
		             _getGroupedView: function() {
		                if (this._isGroupedByDate()) {
		                       return new kendo.ui.scheduler.AgendaGroupedByDateView(this);
		                } else {
		                       return new kendo.ui.scheduler.AgendaGroupedView(this);
		                }
		            },
	
		            _mouseenter: function(e) {
		                $(e.currentTarget).addClass("k-state-hover");
		            },
	
		            _mouseleave: function(e) {
		                $(e.currentTarget).removeClass("k-state-hover");
		            },
	
		            _remove: function(e) {
		                e.preventDefault();
	
		                this.trigger("remove", {
		                    uid: $(e.currentTarget).closest(".k-task").attr(kendo.attr("uid"))
		                });
		            },
	
		            nextDate: function() {
		                return kendo.date.nextDay(this.startDate());
		            },
	
		            startDate: function() {
		                return this._startDate;
		            },
	
		            endDate: function() {
		                return this._endDate;
		            },
	
		            previousDate: function() {
		                return kendo.date.previousDay(this.startDate());
		            },
	
		            _renderLayout: function(date) {
		                this._startDate = date;
		                this._endDate = kendo.date.addDays(date, 7);
		                this.createLayout(this._layout());
		                this.table.addClass("k-scheduler-agenda");
		            },
	
		            _layout: function() {
		                var columns = [
		                        { text: this.options.messages.time, className: "k-scheduler-timecolumn" },
		                        { text: this.options.messages.event }
		                ];
	
		                if (!this._isMobilePhoneView()) {
		                    columns.splice(0, 0, { text: this.options.messages.date, className: "k-scheduler-datecolumn" });
		                }
	
		                var resources = this.groupedResources;
		                if (resources.length) {
		                    var groupHeaders = [];
		                    for (var idx = 0; idx < resources.length; idx++) {
		                        groupHeaders.push({ text: "", className: "k-scheduler-groupcolumn"});
		                    }
	
		                    columns = this._groupedView._getColumns(groupHeaders, columns);
		                }
	
		                return {
		                    columns: columns
		                };
		            },
	
		            _tasks: function(events) {
		                var tasks = [];
	
		                for (var idx = 0; idx < events.length; idx++) {
		                    var event = events[idx];
		                    var start = event.start;
		                    var end = event.isAllDay ? kendo.date.getDate(event.end) : event.end;
	
		                    var eventDurationInDays = Math.ceil((end - kendo.date.getDate(start)) / kendo.date.MS_PER_DAY);
	
		                    if (event.isAllDay) {
		                        eventDurationInDays += 1;
		                    }
	
		                    var task = event.clone();
		                    task.startDate = kendo.date.getDate(start);
	
		                    if (task.startDate >= this.startDate()) {
		                        tasks.push(task);
		                    }
	
		                    if (eventDurationInDays > 1) {
		                        task.end = kendo.date.nextDay(start);
		                        task.head = true;
		                        for (var day = 1; day < eventDurationInDays; day++) {
		                            start = task.end;
		                            task = event.clone();
		                            task.start = task.startDate = kendo.date.getDate(start);
		                            task.end = kendo.date.nextDay(start);
		                            if (day == eventDurationInDays - 1) {
		                                task.end = new Date(task.start.getFullYear(), task.start.getMonth(), task.start.getDate(), end.getHours(), end.getMinutes(), end.getSeconds(), end.getMilliseconds());
		                                task.tail = true;
		                            } else {
		                                task.isAllDay = true;
		                                task.middle = true;
		                            }
	
		                            if ((kendo.date.getDate(task.end) <= this.endDate() && task.start >= this.startDate()) || kendo.date.getDate(task.start).getTime() == this.endDate().getTime()) {
		                                tasks.push(task);
		                            }
		                        }
		                    }
		                }
	
		                return new kendo.data.Query(tasks).sort([{ field: "start", dir: "asc" },{ field: "end", dir: "asc" }]).groupBy({field: "startDate"}).toArray();
		            },
	
		            _renderTaskGroups: function(tasksGroups, groups) {
		                var tableRows = [];
		                var editable = this.options.editable;
		                var showDelete = editable && editable.destroy !== false && !this._isMobile();
		                var isPhoneView = this._isMobilePhoneView();
		                var sumOfItemsForDate = this._groupedView._getSumOfItemsForDate(tasksGroups);
		                var groupsInDay = this._groupedView._getGroupsInDay(tasksGroups, groups);
		                var groupsRowSpanIndex = 0;
	
		                for (var taskGroupIndex = 0; taskGroupIndex < tasksGroups.length; taskGroupIndex++) {
		                    var date = tasksGroups[taskGroupIndex].value;
	
		                    var tasks = tasksGroups[taskGroupIndex].items;
	
		                    var today = kendo.date.isToday(date);
	
		                    for (var taskIndex = 0; taskIndex < tasks.length; taskIndex++) {
		                        var task = tasks[taskIndex];
	
		                        var tableRow = [];
	
		                        var headerCells = !isPhoneView ? tableRow : [];
	
		                        this._groupedView._renderTaskGroupsCells(headerCells, groups, taskGroupIndex, taskIndex, groupsInDay, sumOfItemsForDate, date, groupsRowSpanIndex);
	
		                        groupsRowSpanIndex++;
		                        if (taskIndex === 0) {
		                            if (isPhoneView) {
		                                headerCells.push(kendo.format(
		                                    '<td class="k-scheduler-datecolumn" colspan="2">{0}</td>',
		                                    this._dateTemplate({ date: date })
		                                ));
	
		                                tableRows.push('<tr role="row" aria-selected="false"' + (today ? ' class="k-today">' : ">") + headerCells.join("")  + "</tr>");
		                            } else {
		                                this._groupedView._renderDateCell(tableRow, groups, tasks, date, taskGroupIndex, tasksGroups);
		                            }
		                        }
	
		                        if (task.head) {
		                            task.format = "{0:t}";
		                        } else if (task.tail) {
		                            task.format = "{1:t}";
		                        } else {
		                            task.format = "{0:t}-{1:t}";
		                        }
	
		                        task.resources = this.eventResources(task);
	
		                        tableRow.push(kendo.format(
		                            '<td class="k-scheduler-timecolumn"><div>{0}{1}{2}</div></td><td>{3}</td>',
		                            task.tail || task.middle ? '<span class="k-icon k-i-arrow-60-left"></span>' : "",
		                            this._timeTemplate(task.clone({ start: task._startTime || task.start, end: task.endTime || task.end })),
		                            task.head || task.middle ? '<span class="k-icon k-i-arrow-60-right"></span>' : "",
		                            this._eventTemplate(task.clone({ showDelete: showDelete, messages: this.options.messages }))
		                        ));
	
		                        tableRows.push('<tr role="row" aria-selected="false"' + (today ? ' class="k-today">' : ">") + tableRow.join("") + "</tr>");
		                    }
		                }
	
		                return tableRows.join("");
		            },
	
		            _renderTaskGroupsCells: function (headerCells, groups){
		                 for (var idx = 0; idx < groups.length; idx++) {
		                    headerCells.push(kendo.format(
		                        '<td class="k-scheduler-groupcolumn{2}" rowspan="{0}">{1}</td>',
		                        groups[idx].rowSpan,
		                        this._groupTemplate({ value: groups[idx].text }),
		                        groups[idx].className
		                    ));
		                }
		            },
	
		            render: function(events) {
		                var table = this.content.find("table").empty();
		                var groups = [];
	
		                if (events.length > 0) {
		                    var resources = this.groupedResources;
	
		                    if (resources.length) {
		                        groups = this._createGroupConfiguration(events, resources, null);
		                        this._groupsByDate = [];
		                        this._renderGroups(groups, table, []);
		                        this._groupedView._renderDates(table);
		                    } else {
		                        groups = this._tasks(events);
		                        table.append(this._renderTaskGroups(groups, []));
		                    }
		                }
	
		                var items = this._eventsList = flattenTaskGroups(groups);
		                this._angularItems(table, items);
	
		                this.refreshLayout();
		                this.trigger("activate");
		            },
	
		            _angularItems: function(table, items) {
		                this.angular("compile", function(){
		                    var data = [], elements = items.map(function(item){
		                        data.push({ dataItem: item });
		                        return table.find(".k-task[" + kendo.attr("uid") + "=" + item.uid + "]");
		                    });
		                    return { elements: elements, data: data };
		                });
		            },
	
		            _renderGroups: function(groups, table, parentGroups) {
		                for (var idx = 0, length = groups.length; idx < length; idx++) {
		                    var parents = this._groupedView._getParents(parentGroups);
	
		                    parents.push(groups[idx]);
		                    this._groupedView._getGroupsByDate(groups, idx, parents);
	
		                    if (groups[idx].groups) {
		                        this._renderGroups(groups[idx].groups, table, parents);
		                    } else {
		                        this._groupedView._renderTaskGroups(table, groups[idx].items, parents);
		                    }
		                }
		            },
	
		            _createGroupConfiguration: function(events, resources, parent) {
		                var resource = resources[0];
		                var configuration = [];
		                var data = resource.dataSource.view();
		                var isPhoneView = this._isMobilePhoneView();
	
		                for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
		                    var value = resourceValue(resource, data[dataIndex]);
	
		                    var tmp = new kendo.data.Query(events).filter({ field: resource.field, operator: ui.SchedulerView.groupEqFilter(value) }).toArray();
	
		                    if (tmp.length) {
		                        var tasks = this._tasks(tmp);
		                        var className = parent ? "" : " k-first";
	
		                        if (dataIndex === data.length - 1 && (!parent || parent.className.indexOf("k-last") > -1)) {
		                            className += " k-last";
		                        }
	
		                        var obj = {
		                            text: kendo.getter(resource.dataTextField)(data[dataIndex]),
		                            value: value,
		                            rowSpan: 0,
		                            className: className
		                        };
	
		                        if (resources.length > 1) {
		                            obj.groups = this._createGroupConfiguration(tmp, resources.slice(1), obj);
		                            if (parent) {
		                                parent.rowSpan += obj.rowSpan;
		                            }
		                        } else {
		                            obj.items = tasks;
		                            var span = rowSpan(obj.items);
	
		                            if (isPhoneView) {
		                                span += obj.items.length;
		                            }
	
		                            obj.rowSpan = span;
		                            if (parent) {
		                                parent.rowSpan += span;
		                            }
		                        }
		                        configuration.push(obj);
		                    }
		                }
	
		                return configuration;
		            },
	
		            selectionByElement: function(cell) {
		                var index, event;
		                cell = $(cell);
		                if (cell.hasClass("k-scheduler-datecolumn") || !this._eventsList.length) {
		                    return;
		                }
	
		                if (cell.is(".k-task")) {
		                    cell = cell.closest("td");
		                }
	
		                if (this._isMobile()) {
		                    var parent = cell.parent();
		                    index = parent.parent().children()
		                        .filter(function() {
		                            return $(this).children(":not(.k-scheduler-datecolumn)").length;
		                        })
		                        .index(parent);
		                } else {
		                    index = cell.parent().index();
		                }
	
		                event = this._eventsList[index];
	
		                return {
		                    index: index,
		                    start: event.start,
		                    end: event.end,
		                    isAllDay: event.isAllDay,
		                    uid: event.uid
		                };
		            },
	
		            select: function(selection) {
		                this.clearSelection();
	
		                var row = this.table
		                    .find(".k-task")
		                    .eq(selection.index)
		                    .closest("tr")
		                    .addClass("k-state-selected")
		                    .attr("aria-selected", true)[0];
	
		                this.current(row);
		            },
	
		            move: function(selection, key) {
		                var handled = false;
		                var index = selection.index;
	
		                if (key == kendo.keys.UP) {
		                    index --;
		                    handled = true;
		                } else  if (key == kendo.keys.DOWN) {
		                    index ++;
		                    handled = true;
		                }
	
		                if (handled) {
		                    var event = this._eventsList[index];
		                    if (event) {
		                        selection.start = event.start;
		                        selection.end = event.end;
		                        selection.isAllDay = event.isAllDay;
		                        selection.events = [ event.uid ];
		                        selection.index = index;
		                    }
		                }
	
		                return handled;
		            },
	
		            moveToEvent: function() {
		                return false;
		            },
	
		            constrainSelection: function(selection) {
		                var event = this._eventsList[0];
		                if (event) {
		                    selection.start = event.start;
		                    selection.end = event.end;
		                    selection.isAllDay = event.isAllDay;
		                    selection.events = [ event.uid ];
		                    selection.index = 0;
		                }
		            },
	
		            isInRange: function() {
		                return true;
		            },
	
		            destroy: function(){
		                if (this.element) {
		                    this.element.off(NS);
		                }
	
		                ui.SchedulerView.fn.destroy.call(this);
		            },
	
		            options: {
		                title: "Agenda",
		                name: "agenda",
		                editable: true,
		                selectedDateFormat: "{0:D}-{1:D}",
		                selectedShortDateFormat: "{0:d} - {1:d}",
		                eventTemplate: "#:title#",
		                eventTimeTemplate: "#if(data.isAllDay) {#" +
		                                '#=this.options.messages.allDay#' +
		                              "#} else { #" +
		                                '#=kendo.format(format, start, end)#' +
		                              "# } #",
		                eventDateTemplate: '<strong class="k-scheduler-agendaday">' +
		                                '#=kendo.toString(date, "dd")#' +
		                              '</strong>' +
		                              '<em class="k-scheduler-agendaweek">' +
		                                  '#=kendo.toString(date,"dddd")#' +
		                              '</em>' +
		                              '<span class="k-scheduler-agendadate">' +
		                                  '#=kendo.toString(date, "y")#' +
		                                  '</span>',
		                eventGroupTemplate: '<strong class="k-scheduler-adgendagroup">' +
		                                '#=value#' +
		                              '</strong>',
		                messages: {
		                    event: "Event",
		                    date: "Date",
		                    time: "Time",
		                    allDay: "all day"
		                }
		            }
		        });
	
		        function rowSpan(tasks) {
		            var result = 0;
	
		            for (var idx = 0, length = tasks.length; idx < length; idx++) {
		                result += tasks[idx].items.length;
		            }
	
		            return result;
		        }
	
		        function resourceValue(resource, item) {
		            if (resource.valuePrimitive) {
		                item = kendo.getter(resource.dataValueField)(item);
		            }
		            return item;
		        }
	
		        function flattenTaskGroups(groups) {
		            var idx = 0,
		                length = groups.length,
		                item,
		                result = [];
	
		            for ( ; idx < length; idx ++) {
		                item = groups[idx];
		                if (item.groups) {
		                    item = flattenGroup(item.groups);
		                    result = result.concat(item);
		                } else {
		                    result = result.concat(flattenGroup(item.items));
		                }
		            }
	
		            return result;
		        }
	
		        function flattenGroup(groups) {
		            var items = [].concat(groups),
		                item = items.shift(),
		                result = [],
		                push = [].push;
		            while (item) {
		                if (item.groups) {
		                    push.apply(items, item.groups);
		                } else if (item.items) {
		                    push.apply(items, item.items);
		                } else {
		                    push.call(result, item);
		                }
	
		                item = items.shift();
		            }
	
		            return result;
		        }
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1284);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1278:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(637);
	
	/***/ }),
	
	/***/ 1284:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1278) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "scheduler.monthview",
		    name: "Scheduler Month View",
		    category: "web",
		    description: "The Scheduler Month View",
		    depends: [ "scheduler.view" ],
		    hidden: true
		};
	
		(function($){
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        SchedulerView = ui.SchedulerView,
		        NS = ".kendoMonthView",
		        extend = $.extend,
		        getDate = kendo.date.getDate,
		        MS_PER_DAY = kendo.date.MS_PER_DAY,
		        NUMBER_OF_ROWS = 6,
		        NUMBER_OF_COLUMNS = 7,
		        DAY_TEMPLATE = kendo.template('<span class="k-link k-nav-day">#:kendo.toString(date, "dd")#</span>'),
		        EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#"' +
		                '#if (resources[0]) { #' +
		                    'style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"' +
		                    'class="k-event#=inverseColor ? " k-event-inverse" : ""#"' +
		                '#} else {#' +
		                    'class="k-event"' +
		                '#}#' +
		                '>' +
		                '<span class="k-event-actions">' +
		                    '# if(data.tail || data.middle) {#' +
		                        '<span class="k-icon k-i-arrow-60-left"></span>' +
		                    '#}#' +
		                    '# if(data.isException()) {#' +
		                        '<span class="k-icon k-i-non-recurrence"></span>' +
		                    '# } else if(data.isRecurring()) {#' +
		                        '<span class="k-icon k-i-reload"></span>' +
		                    '#}#' +
		                '</span>' +
		                '{0}' +
		                '<span class="k-event-actions">' +
		                    '#if (showDelete) {#' +
		                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
		                    '#}#' +
		                    '# if(data.head || data.middle) {#' +
		                        '<span class="k-icon k-i-arrow-60-right"></span>' +
		                    '#}#' +
		                '</span>' +
		                '# if(resizable && !data.tail && !data.middle) {#' +
		                '<span class="k-resize-handle k-resize-w"></span>' +
		                '#}#' +
		                '# if(resizable && !data.head && !data.middle) {#' +
		                '<span class="k-resize-handle k-resize-e"></span>' +
		                '#}#' +
		                '</div>',
		        EVENT_TEMPLATE = kendo.template('<div title="#=title.replace(/"/g,"&\\#34;")#">' +
		                    '<div class="k-event-template">#:title#</div>' +
		                '</div>');
	
		    var MORE_BUTTON_TEMPLATE = kendo.template(
		        '<div style="width:#=width#px;left:#=left#px;top:#=top#px" class="k-more-events k-button"><span>...</span></div>'
		    );
	
		       var MonthGroupedView = kendo.Class.extend({
		            init: function(view) {
		                this._view = view;
		            },
	
		            _verticalRowCountForLevel: function(level) {
		                var view = this._view;
	
		                return view._rowCountForLevel(level);
		            },
	
		            _horizontalGroupCountForLevel: function(level) {
		                var view = this._view;
	
		                return view._columnCountForLevel(level);
		            },
	
		            _getCalendarRowsLength: function(cellsPerRow, cellCount) {
		                return cellCount / cellsPerRow;
		            },
	
		            _createRows: function(start, startIdx, horizontalGroupCount, verticalGroupIndex) {
		                var view = this._view;
		                var cellsPerRow = NUMBER_OF_COLUMNS;
		                var isVerticallyGrouped = view._isVerticallyGrouped();
		                var html = "";
	
		                for (var groupIdx = 0; groupIdx < horizontalGroupCount; groupIdx++) {
		                    html += view._createRow(start, startIdx, cellsPerRow, isVerticallyGrouped ? verticalGroupIndex : groupIdx);
		                }
	
		                return html;
		            },
	
		            _adjustStartDate: function(start) {
		                return kendo.date.addDays(start, NUMBER_OF_COLUMNS);
		            },
	
		            _getContent: function(content, startDate, resources) {
		                return content({ date: startDate, resources: resources });
		            },
	
		            _getTimeSlotByPosition: function(x, y, groupIndex) {
		                var group = this._view.groups[groupIndex];
	
		                return group.daySlotByPosition(x, y);
		            },
	
		            _nextSlotStartDate: function(startDate) {
		                return kendo.date.nextDay(startDate);
		            },
	
		            _createRowsLayout: function(resources, rows, groupHeaderTemplate) {
		                var view = this._view;
	
		                return view._createRowsLayout(resources, rows, groupHeaderTemplate);
		            },
	
		            _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate, columns) {
	
		                return columns;
		            },
	
		            _createColumnsLayout: function(resources, columns, groupHeaderTemplate) {
		                var view = this._view;
	
		                return view._createColumnsLayout(resources, columns, groupHeaderTemplate);
		            },
	
		            _verticalGroupCount: function(level) {
		                var view = this._view;
	
		                return view._rowCountForLevel(level);
		            },
	
		            _horizontalGroupCount: function(level) {
		                var view = this._view;
	
		                return view._columnCountForLevel(level) / view._columnOffsetForResource(level);
		            },
	
		            _positionEvent: function(event, group, range, rangeCount, start, end, rangeIndex){
		                var view = this._view;
		                var isMobilePhoneView = view._isMobilePhoneView();
	
		                if (rangeCount > 1) {
		                    if (rangeIndex === 0) {
		                        end = range.end.endDate();
		                    } else if (rangeIndex == rangeCount - 1) {
		                        start = range.start.startDate();
		                    } else {
		                        start = range.start.startDate();
		                        end = range.end.endDate();
		                    }
		                }
	
		                var occurrence = event.clone({ start: start, end: end, head: range.head, tail: range.tail });
	
		                if (isMobilePhoneView) {
		                    view._positionMobileEvent(range, view._createEventElement(occurrence), group);
		                } else {
		                    view._positionEvent(range, view._createEventElement(occurrence), group);
		                }
		            },
	
		            _addDaySlotCollections: function(groupCount, tableRows, startDate) {
		                var view = this._view;
		                var columnCount = NUMBER_OF_COLUMNS;
		                var rowCount = NUMBER_OF_ROWS;
	
		                for (var groupIndex = 0; groupIndex < groupCount; groupIndex++) {
		                    var cellCount = 0;
		                    var rowMultiplier = 0;
	
		                    if (view._isVerticallyGrouped()) {
		                        rowMultiplier = groupIndex;
		                    }
	
		                    for (var rowIndex = rowMultiplier * rowCount; rowIndex < (rowMultiplier + 1) * rowCount; rowIndex++) {
		                        var group = view.groups[groupIndex];
		                        var collection = group.addDaySlotCollection(kendo.date.addDays(startDate, cellCount), kendo.date.addDays(startDate, cellCount + columnCount));
	
		                        var tableRow = tableRows[rowIndex];
		                        var cells = tableRow.children;
		                        var cellMultiplier = 0;
	
		                        tableRow.setAttribute("role", "row");
	
		                        if (!view._isVerticallyGrouped()) {
		                            cellMultiplier = groupIndex;
		                        }
	
		                        for (var cellIndex = cellMultiplier * columnCount; cellIndex < (cellMultiplier + 1) * columnCount; cellIndex++) {
		                            var cell = cells[cellIndex];
	
		                            view.addDaySlot(collection, cell, startDate, cellCount);
		                            cellCount++;
		                        }
		                    }
		                }
		            },
	
		            _changePeriodGroupIndex: function(reverse){
		                var view = this._view;
	
		                return reverse ? view.groups.length - 1 : 0;
		            },
	
		            _createResizeHint: function(range) {
		                 var view = this._view;
		                 var left = range.startSlot().offsetLeft;
		                 var top = range.start.offsetTop;
		                 var width = range.innerWidth();
		                 var height = range.start.clientHeight - 2;
		                 var hint = SchedulerView.fn._createResizeHint.call(view, left, top, width, height);
	
		                 view._appendResizeHint(hint);
		            },
	
		           _createMoveHint: function(range, event) {
		                var view = this._view;
		                var startSlot = range.startSlot();
		                var endSlot = range.endSlot();
		                var hint = view._createEventElement(event.clone({ head: range.head, tail: range.tail }));
	
		                hint.css({
		                    left: startSlot.offsetLeft + 2,
		                    top: startSlot.offsetTop + startSlot.firstChildHeight,
		                    height: view.options.eventHeight,
		                    width: range.innerWidth() - (startSlot.index !== endSlot.index ? 5 : 4)
		                });
	
		                hint.addClass("k-event-drag-hint");
	
		                view._appendMoveHint(hint);
		            }
		        });
	
		        var MonthGroupedByDateView = kendo.Class.extend({
		            init: function(view) {
		                this._view = view;
		            },
	
		            _verticalRowCountForLevel: function() {
		                return 1;
		            },
	
		            _horizontalGroupCountForLevel: function(level) {
		                var view = this._view;
	
		                return view._columnCountForLevel(level + 1) / NUMBER_OF_COLUMNS;
		            },
	
		            _createRows: function(start, startIdx, horizontalGroupCount) {
		                var view = this._view;
		                var cellsPerRow = NUMBER_OF_COLUMNS;
		                var isVerticallyGrouped = view._isVerticallyGrouped();
		                var html = "";
		                var dateIdx = 0;
	
		                if (isVerticallyGrouped) {
		                    var verticalStart = new Date(start);
		                    var groupCount = view._groupCount();
		                    for (dateIdx; dateIdx < NUMBER_OF_ROWS; dateIdx++) {
		                        html += view._createRow(verticalStart, startIdx, groupCount, dateIdx);
	
		                        verticalStart = kendo.date.addDays(verticalStart, cellsPerRow);
		                    }
		                    start = kendo.date.nextDay(start);
		                } else {
		                    for (dateIdx; dateIdx < cellsPerRow; dateIdx++) {
		                        html += view._createRow(start, startIdx, horizontalGroupCount, dateIdx);
		                        start = kendo.date.nextDay(start);
		                    }
		                    start = kendo.date.addDays(start, cellsPerRow);
		                }
	
		                return html;
		            },
	
		            _adjustStartDate: function(start, isLastRow) {
		                var view = this._view;
		                var isVerticallyGrouped = view._isVerticallyGrouped();
	
		                if (isVerticallyGrouped) {
		                    if (isLastRow) {
		                        return kendo.date.addDays(start, NUMBER_OF_COLUMNS * (NUMBER_OF_ROWS - 1) + 1);
		                    } else {
		                        return kendo.date.nextDay(start);
		                    }
		                }
	
		                return kendo.date.addDays(start, NUMBER_OF_COLUMNS);
		            },
	
		            _getContent: function(content, startDate, resources, cellIdx) {
		                if (cellIdx === 0) {
		                    return content({ date: startDate, resources: resources });
		                }
		                return "";
		            },
	
		            _getTimeSlotByPosition: function(x, y, groupIndex) {
		                var group = this._view.groups[groupIndex];
	
		                return group.daySlotByPosition(x, y, true);
		            },
	
		            _nextSlotStartDate: function(startDate) {
		                return startDate;
		            },
	
		            _getCalendarRowsLength: function() {
		                var view = this._view;
		                var isVerticallyGrouped = view._isVerticallyGrouped();
	
		                return isVerticallyGrouped ? NUMBER_OF_COLUMNS : NUMBER_OF_ROWS;
		            },
	
		            _createRowsLayout: function(resources, rows, groupHeaderTemplate, columns) {
		                var view = this._view;
	
		                return view._createDateLayout(columns, null, false);
		            },
	
		            _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate) {
		                var view = this._view;
		                var resource = resources[0];
		                var configuration = [];
		                var data = resource.dataSource.view();
	
		                for (var dataIndex = 0; dataIndex < data.length * NUMBER_OF_ROWS; dataIndex++) {
		                    var obj = {
		                        text: groupHeaderTemplate({
		                            text: kendo.htmlEncode(kendo.getter(resource.dataTextField)(data[dataIndex % data.length])),
		                            color: kendo.getter(resource.dataColorField)(data[dataIndex % data.length]),
		                            field: resource.field,
		                            title: resource.title,
		                            name: resource.name,
		                            value: kendo.getter(resource.dataValueField)(data[dataIndex % data.length])
		                        }),
		                        className: "k-slot-cell"
		                    };
		                    obj.columns = view._createColumnsLayout(resources.slice(1), null, groupHeaderTemplate);
	
		                    configuration.push(obj);
		                }
	
		                return configuration;
		            },
	
		            _createColumnsLayout: function(resources, columns, groupHeaderTemplate, subColumns) {
		                var view = this._view;
	
		                return view._createColumnsLayout(resources, columns, groupHeaderTemplate, subColumns, true);
		            },
	
		            _verticalGroupCount: function(level) {
		                var view = this._view;
	
		                return view._columnCountForLevel(level) / NUMBER_OF_ROWS;
		            },
	
		            _horizontalGroupCount: function(level) {
		                var view = this._view;
		                return view._columnCountForLevel(level) / NUMBER_OF_COLUMNS;
		            },
	
		            _positionEvent: function(event, group, range, rangeCount, start, end){
		                var view = this._view;
		                var startIndex = range.start.index;
		                var endIndex = range.end.index;
		                var isMobilePhoneView = view._isMobilePhoneView();
	
		                for (var i = range.start.index; i <= range.end.index; i++) {
		                    var currentSlot = range.collection._slots[i];
		                    var dateRange = group.daySlotRanges(currentSlot.start, currentSlot.start, true)[0];
	
		                    var occurrence = event.clone({
		                        start: i === startIndex ? start: currentSlot.startDate(),
		                        end: i === endIndex ? end : currentSlot.endDate(),
		                        head: i !== endIndex || range.head,
		                        tail: i !== startIndex || range.tail });
	
		                    if (isMobilePhoneView) {
		                        view._positionMobileEvent(dateRange, view._createEventElement(occurrence), group);
		                    } else {
		                        view._positionEvent(dateRange, view._createEventElement(occurrence), group);
		                    }
		                }
		            },
	
		            _addDaySlotCollections: function(groupCount, tableRows, startDate) {
		                var view = this._view;
		                var columnCount = NUMBER_OF_COLUMNS;
		                var rowCount = NUMBER_OF_ROWS;
		                var isVerticallyGrouped = view._isVerticallyGrouped();
	
		                for (var dateIndex = 0; dateIndex < columnCount; dateIndex++) {
		                    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
		                        var groupIndex = 0;
		                        var currentTableIndex = isVerticallyGrouped ? dateIndex : rowIndex;
		                        var tableRow = tableRows[currentTableIndex];
		                        var cells = tableRow.children;
		                        var cellMultiplier = 0;
	
		                        tableRow.setAttribute("role", "row");
	
		                        if (!view._isVerticallyGrouped()) {
		                            cellMultiplier = dateIndex;
		                        }
	
		                        for (var cellIndex = cellMultiplier * groupCount; cellIndex < (cellMultiplier + 1) * groupCount; cellIndex++) {
		                            var cellCount = (rowIndex * columnCount) + dateIndex;
		                            var currentCellIndex = isVerticallyGrouped ? cellIndex + (rowIndex * groupCount) : cellIndex;
		                            var cell = cells[currentCellIndex];
		                            var currentGroupIndex = isVerticallyGrouped ? cellIndex : groupIndex;
		                            var group = view.groups[currentGroupIndex];
		                            var collection;
		                            if (dateIndex === 0) {
		                                collection = group.addDaySlotCollection(kendo.date.addDays(startDate, cellCount), kendo.date.addDays(startDate, cellCount + columnCount));
		                            } else {
		                                collection = group._daySlotCollections[rowIndex];
		                            }
	
		                            view.addDaySlot(collection, cell, startDate, cellCount);
		                            groupIndex++;
		                        }
		                    }
		                }
		            },
	
		            _changePeriodGroupIndex: function(reverse, vertical, selectionGroupIndex){
		                var view = this._view;
	
		                if(vertical  &&  view._isVerticallyGrouped()){
		                         return reverse ? view.groups.length - 1 : 0;
		                }
	
		                return selectionGroupIndex;
		            },
	
		             _createResizeHint: function(range) {
		                 var view = this._view;
		                 var left, top, width, height, hint;
	
		                 if (view._isVerticallyGrouped()) {
		                    left = range.startSlot().offsetLeft;
		                    top = range.start.offsetTop;
		                    width = range.startSlot().offsetWidth;
		                    height = range.endSlot().offsetTop + range.startSlot().offsetHeight - range.startSlot().offsetTop - 2;
		                    hint = SchedulerView.fn._createResizeHint.call(view, left, top, width, height);
	
		                    view._appendResizeHint(hint);
		                 } else {
		                    for (var slotIdx = range.startSlot().index; slotIdx <= range.endSlot().index; slotIdx++) {
		                       var slot = range.collection._slots[slotIdx];
		                        left = slot.offsetLeft;
		                        top = slot.offsetTop;
		                        width = slot.offsetWidth;
		                        height = slot.offsetHeight - 2;
		                        hint = SchedulerView.fn._createResizeHint.call(view, left, top, width, height);
	
		                        view._appendResizeHint(hint);
		                    }
		                 }
		             },
	
		             _createMoveHint: function(range, event) {
		                 var view = this._view;
		                 var startSlot = range.startSlot();
		                 var endSlot = range.endSlot();
	
		                for (var slotIdx = startSlot.index; slotIdx <= endSlot.index; slotIdx++) {
		                    var slot = range.collection._slots[slotIdx];
		                    var hint = view._createEventElement(event.clone({ head: range.head, tail: range.tail }));
	
		                    hint.css({
		                        left: slot.offsetLeft,
		                        top: slot.offsetTop + slot.firstChildHeight,
		                        height: view.options.eventHeight,
		                        width: slot.offsetWidth - 2
		                    });
	
		                    hint.addClass("k-event-drag-hint");
	
		                    view._appendMoveHint(hint);
		                }
		             }
		        });
	
		        kendo.ui.scheduler.MonthGroupedView = MonthGroupedView;
		        kendo.ui.scheduler.MonthGroupedByDateView = MonthGroupedByDateView;
	
		    ui.MonthView = SchedulerView.extend({
		        init: function(element, options) {
		            var that = this;
	
		            SchedulerView.fn.init.call(that, element, options);
		            that._groupedView = that._getGroupedView();
	
		            that.title = that.options.title;
	
		            that._templates();
	
		            that._editable();
	
		            that._renderLayout(that.options.date);
	
		            that._groups();
		        },
	
		        name: "month",
	
		        _getGroupedView: function(){
		            if(this._isGroupedByDate()){
		                return new kendo.ui.scheduler.MonthGroupedByDateView(this);
		            } else{
		                return new kendo.ui.scheduler.MonthGroupedView(this);
		            }
		        },
	
		        _updateDirection: function(selection, ranges, multiple, reverse, vertical) {
		            if (multiple) {
		                var startSlot = ranges[0].start;
		                var endSlot = ranges[ranges.length - 1].end;
		                var isSameSlot = startSlot.index === endSlot.index;
		                var isSameCollection = startSlot.collectionIndex === endSlot.collectionIndex;
		                var updateDirection;
	
		                if (vertical) {
		                    updateDirection = (isSameSlot && isSameCollection) || isSameCollection;
		                } else {
		                    updateDirection = isSameSlot && isSameCollection;
		                }
	
		                if (updateDirection) {
		                    selection.backward = reverse;
		                }
		            }
		        },
	
		        _changeDate: function(selection, slot, previous) {
		            var group = this.groups[selection.groupIndex];
		            var collections, index;
	
		            if (previous) {
		                  collections = group._getCollections(group.daySlotCollectionCount());
		                  index = slot.collectionIndex - 1;
	
		                  if (index >= 0) {
		                      return  collections[index]._slots[collections[index]._slots.length - 1];
		                  }
		              } else {
		                  collections = group._getCollections(group.daySlotCollectionCount());
		                  index = slot.collectionIndex + 1;
		                  var slotIndex = 0;
	
		                  if (collections[index] && collections[index]._slots[slotIndex]) {
		                      return  collections[index]._slots[slotIndex];
		                  }
		              }
		        },
	
		         _getNextHorizontalRange: function(group, method, horizontalRange){
		              var isVertical = this._isVerticallyGrouped();
	
		             horizontalRange.startSlot = group[method](horizontalRange.startSlot, isVertical);
		             horizontalRange.endSlot = group[method](horizontalRange.endSlot, isVertical);
	
		             return horizontalRange;
		        },
	
		         _getNextVerticalRange: function(group, method, verticalRange, multiple){
		             var isVertical = this._isVerticallyGrouped() && this._isGroupedByDate();
	
		             verticalRange.startSlot = group[method](verticalRange.startSlot, multiple, isVertical);
		             verticalRange.endSlot = group[method](verticalRange.endSlot, multiple, isVertical);
	
		             return verticalRange;
		        },
	
		        _changeViewPeriod: function(selection, reverse, vertical) {
		            var pad = vertical ? 7 : 1;
		            var newStart, newEnd;
	
		            if (reverse) {
		                pad *= -1;
		            }
	
		            newStart =  kendo.date.addDays(selection.start, pad);
		            newEnd = kendo.date.addDays(selection.end, pad);
	
		            if(this._isInRange(newStart, newEnd)){
		                return false;
		            }
	
		            selection.start = newStart;
		            selection.end = newEnd;
	
		            if (!vertical || (vertical && this._isVerticallyGrouped())) {
		                selection.groupIndex = this._groupedView._changePeriodGroupIndex(reverse, vertical, selection.groupIndex);
		            }
	
		            selection.events = [];
	
		            return true;
		        },
	
		        _continuousSlot: function(selection, ranges, reverse) {
		            var index = selection.backward ? 0 : ranges.length - 1;
		            var group = this.groups[selection.groupIndex];
	
		            return group.continuousSlot(ranges[index].start, reverse);
		        },
	
		        _changeGroupContinuously: function(selection, continuousSlot, multiple, reverse) {
		            if (!multiple) {
		                var groupIndex = selection.groupIndex;
		                var lastGroupIndex = this.groups.length - 1;
		                var vertical = this._isVerticallyGrouped();
		                var group = this.groups[groupIndex];
	
		                if (!continuousSlot && vertical) {
	
		                    continuousSlot = group[reverse ? "lastSlot" : "firstSlot"]();
	
		                    groupIndex += (reverse ? -1 : 1);
	
		                } else if (continuousSlot && !vertical) {
		                    groupIndex = reverse ? lastGroupIndex : 0;
		                }
	
		                if (groupIndex < 0 || groupIndex > lastGroupIndex) {
		                    groupIndex = reverse ? lastGroupIndex : 0;
		                    continuousSlot = null;
		                }
	
		                selection.groupIndex = groupIndex;
		            }
	
		            return continuousSlot;
		        },
	
		        _normalizeHorizontalSelection: function(selection, ranges, reverse) {
		            var slot;
	
		            if (reverse) {
		                slot = ranges[0].start;
		            } else {
		                slot = ranges[ranges.length - 1].end;
		            }
	
		            return slot;
		        },
	
		        _normalizeVerticalSelection: function(selection, ranges) {
		            var slot;
	
		            if (selection.backward) {
		                slot = ranges[0].start;
		            } else {
		                slot = ranges[ranges.length - 1].end;
		            }
	
		            return slot;
		        },
	
		        _templates: function() {
		            var options = this.options,
		                settings = extend({}, kendo.Template, options.templateSettings);
	
		            this.eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_STRING);
		            this.dayTemplate = kendo.template(options.dayTemplate, settings);
		            this.groupHeaderTemplate = kendo.template(options.groupHeaderTemplate, settings);
		        },
	
		        dateForTitle: function() {
		            return kendo.format(this.options.selectedDateFormat, this._firstDayOfMonth, this._lastDayOfMonth);
		        },
	
		        shortDateForTitle: function() {
		            return kendo.format(this.options.selectedShortDateFormat, this._firstDayOfMonth, this._lastDayOfMonth);
		        },
	
		        nextDate: function() {
		            return kendo.date.nextDay(this._lastDayOfMonth);
		        },
	
		        previousDate: function() {
		            return kendo.date.previousDay(this._firstDayOfMonth);
		        },
	
		        startDate: function() {
		            return this._startDate;
		        },
	
		        endDate: function() {
		            return this._endDate;
		        },
	
		        _renderLayout: function(date) {
		            var that = this;
	
		            this._firstDayOfMonth = kendo.date.firstDayOfMonth(date);
	
		            this._lastDayOfMonth = kendo.date.lastDayOfMonth(date);
	
		            this._startDate = firstVisibleMonthDay(date, this.calendarInfo());
	
		            this.createLayout(this._layout());
	
		            this._content();
	
		            this.refreshLayout();
	
		            this.content.on("click" + NS, ".k-nav-day,.k-more-events", function(e) {
		               var offset = $(e.currentTarget).offset();
		               var slot = that._slotByPosition(offset.left, offset.top);
	
		               e.preventDefault();
		               that.trigger("navigate", { view: "day", date: slot.startDate() });
		            });
		        },
	
		        _editable: function() {
		            if (this.options.editable && !this._isMobilePhoneView()) {
		                if (this._isMobile()) {
		                    this._touchEditable();
		                } else {
		                    this._mouseEditable();
		                }
	
		            }
		        },
	
		        _mouseEditable: function() {
		            var that = this;
		            that.element.on("click" + NS, ".k-scheduler-monthview .k-event a:has(.k-i-close)", function(e) {
		                that.trigger("remove", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
		                e.preventDefault();
		            });
	
		            if (that.options.editable.create !== false) {
		                that.element.on("dblclick" + NS, ".k-scheduler-monthview .k-scheduler-content td", function(e) {
		                    var offset = $(e.currentTarget).offset();
		                    var slot = that._slotByPosition(offset.left, offset.top);
	
		                    if (slot) {
		                        var resourceInfo = that._resourceBySlot(slot);
		                        that.trigger("add", { eventInfo: extend({ isAllDay: true, start: slot.startDate(), end: slot.startDate() }, resourceInfo ) });
		                    }
	
		                    e.preventDefault();
		                });
		            }
	
		            if (that.options.editable.update !== false) {
		                that.element.on("dblclick" + NS, ".k-scheduler-monthview .k-event", function(e) {
		                    that.trigger("edit", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
		                    e.preventDefault();
		                });
		            }
		        },
	
		        _touchEditable: function() {
		            var that = this;
		            var threshold = 0;
	
		            if (kendo.support.mobileOS.android) {
		                threshold = 5;
		            }
	
		            if (that.options.editable.create !== false) {
		                that._addUserEvents = new kendo.UserEvents(that.element, {
		                    threshold: threshold,
		                    useClickAsTap: !kendo.support.browser.edge,
		                    filter: ".k-scheduler-monthview .k-scheduler-content td",
		                    tap: function(e) {
		                        if (that._scrolling) {
		                            return;
		                        }
		                        var offset = $(e.target).offset();
		                        var slot = that._slotByPosition(offset.left, offset.top);
	
		                        if (slot) {
		                            var resourceInfo = that._resourceBySlot(slot);
		                            that.trigger("add", { eventInfo: extend({ isAllDay: true, start: slot.startDate(), end: slot.startDate() }, resourceInfo ) });
		                        }
	
		                        e.preventDefault();
		                    }
		                });
		            }
	
		            if (that.options.editable.update !== false) {
		                that._editUserEvents = new kendo.UserEvents(that.element, {
		                    threshold: threshold,
		                    filter:  ".k-scheduler-monthview .k-event",
		                    useClickAsTap: !kendo.support.browser.edge,
		                    tap: function(e) {
		                        if (that._scrolling) {
		                            return;
		                        }
		                        if ($(e.event.target).closest("a:has(.k-i-close)").length === 0) {
		                            that.trigger("edit", { uid: $(e.target).closest(".k-event").attr(kendo.attr("uid")) });
		                            e.preventDefault();
		                        }
		                    }
		                });
		            }
		        },
	
		        selectionByElement: function(cell) {
		            var offset = $(cell).offset();
		            return this._slotByPosition(offset.left, offset.top);
		        },
	
		        _columnCountForLevel: function(level) {
		            var columnLevel = this.columnLevels[level];
		            return columnLevel ? columnLevel.length : 0;
		        },
	
		        _rowCountForLevel: function(level) {
		            var rowLevel = this.rowLevels[level];
		            return rowLevel ? rowLevel.length : 0;
		        },
	
		        _content: function() {
		            var html = '<tbody>';
		            var verticalGroupCount = 1;
		            var groupedView = this._groupedView;
		            var resources = this.groupedResources;
	
		            if (resources.length) {
		                if (this._isVerticallyGrouped()) {
		                    verticalGroupCount = groupedView._verticalRowCountForLevel(resources.length - 1);
		                }
		            }
	
		            for (var verticalGroupIdx = 0; verticalGroupIdx < verticalGroupCount; verticalGroupIdx++) {
		                html += this._createCalendar(verticalGroupIdx);
		            }
	
		            html += "</tbody>";
	
		            this.content.find("table").html(html);
		        },
	
		        _createCalendar: function(verticalGroupIndex) {
		            var start = this.startDate();
		            var cellCount = NUMBER_OF_COLUMNS*NUMBER_OF_ROWS;
		            var cellsPerRow = NUMBER_OF_COLUMNS;
		            var weekStartDates = [start];
		            var html = '';
		            var horizontalGroupCount = 1;
		            var isVerticallyGrouped = this._isVerticallyGrouped();
		            var groupedView = this._groupedView;
	
		            var resources = this.groupedResources;
	
		            if (resources.length) {
		                if (!isVerticallyGrouped) {
		                    horizontalGroupCount = groupedView._horizontalGroupCountForLevel(resources.length - 1);
		                }
		            }
	
		            this._slotIndices = {};
	
		            var calendarRowsLength = groupedView._getCalendarRowsLength(cellsPerRow, cellCount);
	
		            for (var rowIdx = 0; rowIdx < calendarRowsLength; rowIdx++) {
		                html += "<tr>";
	
		                weekStartDates.push(start);
	
		                var startIdx = rowIdx*cellsPerRow;
	
		               html += groupedView._createRows(start, startIdx, horizontalGroupCount, verticalGroupIndex);
		               start = groupedView._adjustStartDate(start, rowIdx === calendarRowsLength - 1);
	
		                html += "</tr>";
		            }
	
		            this._weekStartDates = weekStartDates;
		            this._endDate = kendo.date.previousDay(start);
	
		            return html;
		        },
	
		        _createRow: function(startDate, startIdx, cellsPerRow, groupIndex) {
		            var that = this;
		            var min = that._firstDayOfMonth;
		            var max = that._lastDayOfMonth;
		            var content = that.dayTemplate;
		            var classes = "";
		            var html = "";
		            var groupedView = this._groupedView;
	
		            var resources = function() {
		                return that._resourceBySlot({ groupIndex: groupIndex });
		            };
	
		            for (var cellIdx = 0; cellIdx < cellsPerRow; cellIdx++) {
		                classes = "";
	
		                if (kendo.date.isToday(startDate)) {
		                    classes += "k-today";
		                }
	
		                if (!kendo.date.isInDateRange(startDate, min, max)) {
		                    classes += " k-other-month";
		                }
	
		                html += "<td ";
	
		                if (classes !== "") {
		                    html += 'class="' + classes + '"';
		                }
	
		                html += ">";
		                html += groupedView._getContent(content, startDate, resources, cellIdx);
		                html += "</td>";
	
		                that._slotIndices[getDate(startDate).getTime()] = startIdx + cellIdx;
	
		               startDate = groupedView._nextSlotStartDate(startDate);
		            }
	
		            return html;
		        },
	
		        _layout: function() {
		            var calendarInfo = this.calendarInfo();
		            var weekDayNames = this._isMobile() ? calendarInfo.days.namesShort : calendarInfo.days.names;
		            var names = shiftArray(weekDayNames, calendarInfo.firstDay);
		            var columns = $.map(names, function(value) { return { text: value }; });
		            var resources = this.groupedResources;
		            var rows;
		            var groupedView = this._groupedView;
	
		            if (resources.length) {
		                if (this._isVerticallyGrouped()) {
		                    var inner = []; //add hidden cells in order to sync the content rows
		                    for (var idx = 0; idx < 6; idx++) {
		                        inner.push({ text: "<div>&nbsp;</div>", className: "k-hidden k-slot-cell" });
		                    }
		                    rows =  groupedView._createRowsLayout(resources, inner, this.groupHeaderTemplate, columns);
		                    columns =  groupedView._createVerticalColumnsLayout(resources, inner, this.groupHeaderTemplate, columns);
	
		                } else {
		                    columns =  groupedView._createColumnsLayout(resources, columns, this.groupHeaderTemplate, columns);
		                }
		            }
	
		            return {
		                columns: columns,
		                rows: rows
		            };
		        },
	
		       _createEventElement: function(event) {
		            var options = this.options;
		            var editable = options.editable;
	
		            var isMobile = this._isMobile();
	
		            event.showDelete = editable && editable.destroy !== false && !isMobile;
		            event.resizable = editable && editable.resize !== false && !isMobile;
		            event.ns = kendo.ns;
		            event.resources = this.eventResources(event);
		            event.inverseColor = event.resources && event.resources[0] ? this._shouldInverseResourceColor(event.resources[0]) : false;
		            event.messages = options.messages || { destroy: "Delete" };
	
		            var element = $(this.eventTemplate(event));
	
		            this.angular("compile", function(){
		                return {
		                    elements: element,
		                    data: [ { dataItem: event } ]
		                };
		            });
	
		            return element;
		        },
		       _isInDateSlot: function(event) {
		            var groups = this.groups[0];
		            var slotStart = groups.firstSlot().start;
		            var slotEnd = groups.lastSlot().end - 1;
	
		            var startTime = kendo.date.toUtcTime(event.start);
		            var endTime = kendo.date.toUtcTime(event.end);
	
		            return (isInDateRange(startTime, slotStart, slotEnd) ||
		                isInDateRange(endTime, slotStart, slotEnd) ||
		                isInDateRange(slotStart, startTime, endTime) ||
		                isInDateRange(slotEnd, startTime, endTime)) &&
		                (!isInDateRange(endTime, slotStart, slotStart) || isInDateRange(endTime, startTime, startTime) || event.isAllDay );
		        },
	
		        _slotIndex: function(date) {
		            return this._slotIndices[getDate(date).getTime()];
		        },
	
		        _positionMobileEvent: function(slotRange, element, group) {
		            var startSlot = slotRange.start;
	
		            if (slotRange.start.offsetLeft > slotRange.end.offsetLeft) {
		               startSlot = slotRange.end;
		            }
	
		            var startIndex = slotRange.start.index;
		            var endIndex = startIndex;
	
		            var eventCount = 3;
		            var events = SchedulerView.collidingEvents(slotRange.events(), startIndex, endIndex);
	
		            events.push({element: element, start: startIndex, end: endIndex });
	
		            var rows = SchedulerView.createRows(events);
	
		            var slot = slotRange.collection.at(startIndex);
	
		            var container = slot.container;
	
		            if (!container) {
	
		                 container = $(kendo.format('<div class="k-events-container" style="top:{0};left:{1};width:{2}"/>',
		                    startSlot.offsetTop + startSlot.firstChildTop + startSlot.firstChildHeight + "px",
		                    startSlot.offsetLeft + "px",
		                    startSlot.offsetWidth + "px"
		                ));
	
		                slot.container = container;
	
		                this.content[0].appendChild(container[0]);
		            }
	
		            if (rows.length <= eventCount) {
		                slotRange.addEvent({element: element, start: startIndex, end: endIndex, groupIndex: startSlot.groupIndex });
	
		                group._continuousEvents.push({
		                    element: element,
		                    uid: element.attr(kendo.attr("uid")),
		                    start: slotRange.start,
		                    end: slotRange.end
		                });
	
		                container[0].appendChild(element[0]);
		            }
		        },
	
		        _positionEvent: function(slotRange, element, group) {
		            var eventHeight = this.options.eventHeight;
		            var startSlot = slotRange.start;
	
		            if (slotRange.start.offsetLeft > slotRange.end.offsetLeft) {
		               startSlot = slotRange.end;
		            }
	
		            var startIndex = slotRange.start.index;
		            var endIndex = slotRange.end.index;
		            var eventCount = startSlot.eventCount;
		            var events = SchedulerView.collidingEvents(slotRange.events(), startIndex, endIndex);
		            var rightOffset = startIndex !== endIndex ? 5 : 4;
	
		            events.push({element: element, start: startIndex, end: endIndex });
	
		            var rows = SchedulerView.createRows(events);
	
		            for (var idx = 0, length = Math.min(rows.length, eventCount); idx < length; idx++) {
		                var rowEvents = rows[idx].events;
		                var eventTop = startSlot.offsetTop + startSlot.firstChildTop + startSlot.firstChildHeight + idx * eventHeight + 3 * idx + "px";
	
		                for (var j = 0, eventLength = rowEvents.length; j < eventLength; j++) {
		                    rowEvents[j].element[0].style.top = eventTop;
		                }
		            }
	
		            if (rows.length > eventCount) {
		                for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
		                    var collection = slotRange.collection;
	
		                    var slot = collection.at(slotIndex);
	
		                    if (slot.more) {
		                        continue;
		                    }
	
		                    slot.more = $(MORE_BUTTON_TEMPLATE({
		                        ns: kendo.ns,
		                        start: slotIndex,
		                        end: slotIndex,
		                        width: slot.clientWidth - 2,
		                        left: slot.offsetLeft + 2,
		                        top: slot.offsetTop + slot.firstChildTop + slot.firstChildHeight + eventCount * eventHeight + 3 * eventCount
		                    }));
	
		                    this.content[0].appendChild(slot.more[0]);
		                }
		            } else {
		                slotRange.addEvent({element: element, start: startIndex, end: endIndex, groupIndex: startSlot.groupIndex });
	
		                element[0].style.width = slotRange.innerWidth() - rightOffset + "px";
		                element[0].style.left = startSlot.offsetLeft + 2 + "px";
		                element[0].style.height = eventHeight + "px";
	
		                group._continuousEvents.push({
		                    element: element,
		                    uid: element.attr(kendo.attr("uid")),
		                    start: slotRange.start,
		                    end: slotRange.end
		                });
	
		                element.appendTo(this.content);
		            }
		        },
	
		       _slotByPosition: function(x, y) {
		           var offset = this.content.offset();
	
		           x -= offset.left;
		           y -= offset.top;
		           y += this.content[0].scrollTop;
		           x += this.content[0].scrollLeft;
	
		           x = Math.ceil(x);
		           y = Math.ceil(y);
	
		           for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
		               var slot = this._groupedView._getTimeSlotByPosition(x, y, groupIndex);
	
		               if (slot) {
		                   return slot;
		               }
		           }
	
		           return null;
		       },
	
		       _appendResizeHint: function(hint) {
		            hint.appendTo(this.content);
	
		            this._resizeHint = this._resizeHint.add(hint);
		       },
	
		        _updateResizeHint: function(event, groupIndex, startTime, endTime) {
		            this._removeResizeHint();
	
		            var group = this.groups[groupIndex];
	
		            var ranges = group.ranges(startTime, endTime, true, event.isAllDay);
	
		            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
		                this._groupedView._createResizeHint(ranges[rangeIndex]);
		            }
	
		            this._resizeHint.find(".k-label-top,.k-label-bottom").text("");
	
		            this._resizeHint.first().addClass("k-first").find(".k-label-top").text(kendo.toString(kendo.timezone.toLocalDate(startTime), "M/dd"));
	
		            this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(kendo.toString(kendo.timezone.toLocalDate(endTime), "M/dd"));
		        },
	
		       _updateMoveHint: function(event, groupIndex, distance) {
		            var start = kendo.date.toUtcTime(event.start) + distance;
	
		            var end = start + event.duration();
	
		            var group = this.groups[groupIndex];
	
		            var ranges = group.ranges(start, end, true, event.isAllDay);
	
		            this._removeMoveHint(event.uid);
	
		            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
		                this._groupedView._createMoveHint(ranges[rangeIndex], event);
		            }
		       },
	
		       _appendMoveHint: function(hint) {
		            hint.appendTo(this.content);
		            this._moveHint = this._moveHint.add(hint);
		       },
	
		       _groups: function() {
		            var groupCount = this._groupCount();
		            var tableRows = this.content[0].getElementsByTagName("tr");
		            var startDate = this.startDate();
		            this.groups = [];
	
		            for (var idx = 0; idx < groupCount; idx++) {
		                this._addResourceView(idx);
		            }
	
		            this._groupedView._addDaySlotCollections(groupCount, tableRows, startDate);
		        },
	
	
		       addDaySlot: function(collection, cell, startDate, cellCount){
		            var clientHeight = cell.clientHeight;
		            var firstChildHeight = cell.children.length ? cell.children[0].offsetHeight + 3 : 0;
		            var start = kendo.date.addDays(startDate, cellCount);
		            var end = kendo.date.MS_PER_DAY;
	
		            if (startDate.getHours() !== start.getHours()) {
		                end += (startDate.getHours() - start.getHours()) * kendo.date.MS_PER_HOUR;
		            }
	
		            start = kendo.date.toUtcTime(start);
		            end += start;
		            var eventCount = Math.floor((clientHeight - firstChildHeight - this.options.moreButtonHeight) / (this.options.eventHeight + 3)) ;// add space for the more button
	
		            cell.setAttribute("role", "gridcell");
		            cell.setAttribute("aria-selected", false);
	
		            collection.addDaySlot(cell, start, end, eventCount);
		       },
	
		       render: function(events) {
		            this.content.children(".k-event,.k-more-events,.k-events-container").remove();
	
		            this._groups();
	
		            events = new kendo.data.Query(events).sort([{ field: "start", dir: "asc" },{ field: "end", dir: "desc" }]).toArray();
	
		            var resources = this.groupedResources;
		            if (resources.length) {
		               this._renderGroups(events, resources, 0, 1);
		            } else {
		               this._renderEvents(events, 0);
		            }
	
		            this.refreshLayout();
		            this.trigger("activate");
		       },
	
		       _renderEvents: function(events, groupIndex) {
		            var event;
		            var idx;
		            var length;
		            var range;
		            var start;
		            var end;
	
		            for (idx = 0, length = events.length; idx < length; idx++) {
		                event = events[idx];
	
		                if (this._isInDateSlot(event)) {
		                    var group = this.groups[groupIndex];
		                    var view = this._groupedView._view;
		                    var isMobilePhoneView = view._isMobilePhoneView();
	
		                    if (!group._continuousEvents) {
		                        group._continuousEvents = [];
		                    }
	
		                    var ranges = group.slotRanges(event, true);
	
		                    var rangeCount = ranges.length;
	
		                    if(isMobilePhoneView){
		                        range = ranges[0];
		                        start = range.start.start;
		                        end = range.end.end;
		                        var rangeStart = new Date(range.start.start);
		                        var rangeEnd = ranges[ranges.length - 1].end.end;
		                        var newStart = new Date(rangeStart);
		                        var newEnd = new Date(end);
	
		                        while(rangeStart.getTime() <= rangeEnd &&
		                            event.end >= kendo.timezone.toLocalDate(rangeStart) &&
		                            event.start <= kendo.timezone.toLocalDate(rangeEnd)){
		                            var dateRange = group.daySlotRanges(newStart.getTime(), newEnd.getTime(), true)[0];
		                            newEnd.setDate(newEnd.getDate() + 1);
		                            newStart.setDate(newStart.getDate() + 1);
	
		                            if (dateRange) {
		                                dateRange.head = null;
		                                dateRange.middle = null;
		                                dateRange.tail = null;
		                                this._groupedView._positionEvent(event, group, dateRange, 1, start, end, 0);
		                            }
	
		                            rangeStart = kendo.date.addDays(rangeStart, 1);
		                        }
		                    }else{
		                        for (var rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
		                            range = ranges[rangeIndex];
		                            start = event.start;
		                            end = event.end;
	
		                            this._groupedView._positionEvent(event, group, range, rangeCount, start, end, rangeIndex);
		                        }
		                    }
		                }
		            }
		        },
	
		        _renderGroups: function(events, resources, offset, columnLevel) {
		            var resource = resources[0];
	
		            if (resource) {
		                var view = resource.dataSource.view();
	
		                for (var itemIdx = 0; itemIdx < view.length; itemIdx++) {
		                    var value = this._resourceValue(resource, view[itemIdx]);
	
		                    var tmp = new kendo.data.Query(events).filter({ field: resource.field, operator: SchedulerView.groupEqFilter(value) }).toArray();
	
		                    if (resources.length > 1) {
		                        offset = this._renderGroups(tmp, resources.slice(1), offset++, columnLevel + 1);
		                    } else {
		                        this._renderEvents(tmp, offset++);
		                    }
		                }
		            }
		            return offset;
		        },
	
		        _groupCount: function() {
		            var resources = this.groupedResources;
		            var groupedView = this._groupedView;
	
		            if (resources.length) {
		                if (this._isVerticallyGrouped()) {
		                    return groupedView._verticalGroupCount(resources.length - 1);
		                } else {
		                   return groupedView._horizontalGroupCount(resources.length);
		                }
		            }
		            return 1;
		        },
	
		        _columnOffsetForResource: function(index) {
		            return this._columnCountForLevel(index) / this._columnCountForLevel(index - 1);
		        },
	
		        destroy: function(){
		            if (this.table) {
		                this.table.removeClass("k-scheduler-monthview");
		            }
	
		            if (this.content) {
		                this.content.off(NS);
		            }
	
		            if (this.element) {
		                this.element.off(NS);
		            }
	
		            SchedulerView.fn.destroy.call(this);
	
		            if (this._isMobile() && !this._isMobilePhoneView() && this.options.editable) {
		                if (this.options.editable.create !== false) {
		                    this._addUserEvents.destroy();
		                }
	
		                if (this.options.editable.update !== false) {
		                    this._editUserEvents.destroy();
		                }
		            }
		        },
	
		        events: ["remove", "add", "edit", "navigate"],
	
		        options: {
		            title: "Month",
		            name: "month",
		            eventHeight: 25,
		            moreButtonHeight: 13,
		            editable: true,
		            selectedDateFormat: "{0:y}",
		            selectedShortDateFormat: "{0:y}",
		            groupHeaderTemplate: "#=text#",
		            dayTemplate: DAY_TEMPLATE,
		            eventTemplate: EVENT_TEMPLATE
		        }
		    });
	
	
		    function shiftArray(array, idx) {
		        return array.slice(idx).concat(array.slice(0, idx));
		    }
	
		    function firstVisibleMonthDay(date, calendarInfo) {
		        var firstDay = calendarInfo.firstDay,
		            firstVisibleDay = new Date(date.getFullYear(), date.getMonth(), 0, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
	
		        while (firstVisibleDay.getDay() != firstDay) {
		            kendo.date.setTime(firstVisibleDay, -1 * MS_PER_DAY);
		        }
	
		        return firstVisibleDay;
		    }
	
		    function isInDateRange(value, min, max) {
		        var msMin = min,
		            msMax = max,
		            msValue;
	
		        msValue = value;
	
		        return msValue >= msMin && msValue <= msMax;
		    }
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1255);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1255:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004), __webpack_require__(1036) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "notification",
		    name: "Notification",
		    category: "web",
		    description: "The Notification widget displays user alerts.",
		    depends: [ "core", "popup" ],
		    features: [ {
		        id: "notification-fx",
		        name: "Animation",
		        description: "Support for animation",
		        depends: [ "fx" ]
		    } ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        proxy = $.proxy,
		        extend = $.extend,
		        setTimeout = window.setTimeout,
		        CLICK = "click",
		        SHOW = "show",
		        HIDE = "hide",
		        KNOTIFICATION = "k-notification",
		        KICLOSE = ".k-notification-wrap .k-i-close",
		        KHIDING = "k-hiding",
		        INFO = "info",
		        SUCCESS = "success",
		        WARNING = "warning",
		        ERROR = "error",
		        TOP = "top",
		        LEFT = "left",
		        BOTTOM = "bottom",
		        RIGHT = "right",
		        UP = "up",
		        NS = ".kendoNotification",
		        WRAPPER = '<div class="k-widget k-popup k-notification"></div>',
		        TEMPLATE = '<div class="k-notification-wrap">' +
		                '<span class="k-icon k-i-#=typeIcon#" title="#=typeIcon#"></span>' +
		                '#=content#' +
		                '<span class="k-icon k-i-close" title="Hide"></span>' +
		            '</div>',
		        SAFE_TEMPLATE = TEMPLATE.replace("#=content#", "#:content#");
	
		    var Notification = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
	
		            if (!options.appendTo || !$(options.appendTo).is(element)) {
		                that.element.hide();
		            }
	
		            that._compileTemplates(options.templates);
		            that._guid = "_" + kendo.guid();
		            that._isRtl = kendo.support.isRtl(element);
		            that._compileStacking(options.stacking, options.position.top, options.position.left);
	
		            kendo.notify(that);
		        },
	
		        events: [
		            SHOW,
		            HIDE
		        ],
	
		        options: {
		            name: "Notification",
		            position: {
		                pinned: true,
		                top: null,
		                left: null,
		                bottom: 20,
		                right: 20
		            },
		            stacking: "default",
		            hideOnClick: true,
		            button: false,
		            allowHideAfter: 0,
		            autoHideAfter: 5000,
		            appendTo: null,
		            width: null,
		            height: null,
		            templates: [],
		            animation: {
		                open: {
		                    effects: "fade:in",
		                    duration: 300
		                },
		                close: {
		                    effects: "fade:out",
		                    duration: 600,
		                    hide: true
		                }
		            }
		        },
	
		        _compileTemplates: function(templates) {
		            var that = this;
		            var kendoTemplate = kendo.template;
	
		            that._compiled = {};
	
		            $.each(templates, function(key, value) {
		                that._compiled[value.type] = kendoTemplate(value.template || $("#" + value.templateId).html());
		            });
	
		            that._defaultCompiled = kendoTemplate(TEMPLATE);
		            that._safeCompiled = kendoTemplate(SAFE_TEMPLATE);
		        },
	
		        _getCompiled: function(type, safe) {
		            var defaultCompiled = safe ? this._safeCompiled : this._defaultCompiled;
	
		            return type ? this._compiled[type] || defaultCompiled : defaultCompiled;
		        },
	
		        _compileStacking: function(stacking, top, left) {
		            var that = this,
		                paddings = { paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0 },
		                horizontalAlignment = left !== null ? LEFT : RIGHT,
		                origin, position;
	
		            switch (stacking) {
		                case "down":
		                    origin = BOTTOM + " " + horizontalAlignment;
		                    position = TOP + " " + horizontalAlignment;
		                    delete paddings.paddingBottom;
		                break;
		                case RIGHT:
		                    origin = TOP + " " + RIGHT;
		                    position = TOP + " " + LEFT;
		                    delete paddings.paddingRight;
		                break;
		                case LEFT:
		                    origin = TOP + " " + LEFT;
		                    position = TOP + " " + RIGHT;
		                    delete paddings.paddingLeft;
		                break;
		                case UP:
		                    origin = TOP + " " + horizontalAlignment;
		                    position = BOTTOM + " " + horizontalAlignment;
		                    delete paddings.paddingTop;
		                break;
		                default:
		                    if (top !== null) {
		                        origin = BOTTOM + " " + horizontalAlignment;
		                        position = TOP + " " + horizontalAlignment;
		                        delete paddings.paddingBottom;
		                    } else {
		                        origin = TOP + " " + horizontalAlignment;
		                        position = BOTTOM + " " + horizontalAlignment;
		                        delete paddings.paddingTop;
		                    }
		                break;
		            }
	
		            that._popupOrigin = origin;
		            that._popupPosition = position;
		            that._popupPaddings = paddings;
		        },
	
		        _attachPopupEvents: function(options, popup) {
		            var that = this,
		                allowHideAfter = options.allowHideAfter,
		                attachDelay = !isNaN(allowHideAfter) && allowHideAfter > 0,
		                closeIcon;
	
		            function attachClick(target) {
		                target.on(CLICK + NS, function () {
		                    that._hidePopup(popup);
		                });
		            }
	
		            if (options.hideOnClick) {
		                popup.bind("activate", function() {
		                    if (attachDelay) {
		                        setTimeout(function(){
		                            attachClick(popup.element);
		                        }, allowHideAfter);
		                    } else {
		                        attachClick(popup.element);
		                    }
		                });
		            } else if (options.button) {
		                closeIcon = popup.element.find(KICLOSE);
		                if (attachDelay) {
		                    setTimeout(function(){
		                        attachClick(closeIcon);
		                    }, allowHideAfter);
		                } else {
		                    attachClick(closeIcon);
		                }
		            }
		        },
	
		        _showPopup: function(wrapper, options) {
		            var that = this,
		                autoHideAfter = options.autoHideAfter,
		                x = options.position.left,
		                y = options.position.top,
		                popup, openPopup;
	
		            openPopup = $("." + that._guid + ":not(." + KHIDING + ")").last();
	
		            popup = new kendo.ui.Popup(wrapper, {
		                anchor: openPopup[0] ? openPopup : document.body,
		                origin: that._popupOrigin,
		                position: that._popupPosition,
		                animation: options.animation,
		                modal: true,
		                collision: "",
		                isRtl: that._isRtl,
		                close: function() {
		                    that._triggerHide(this.element);
		                },
		                deactivate: function(e) {
		                    e.sender.element.off(NS);
		                    e.sender.element.find(KICLOSE).off(NS);
		                    e.sender.destroy();
		                }
		            });
	
		            that._attachPopupEvents(options, popup);
	
		            wrapper.removeClass("k-group k-reset");
	
		            if (openPopup[0]) {
		                popup.open();
		            } else {
		                if (x === null) {
		                    x = $(window).width() - wrapper.width() - options.position.right;
		                }
	
		                if (y === null) {
		                    y = $(window).height() - wrapper.height() - options.position.bottom;
		                }
	
		                popup.open(x, y);
		            }
	
		            popup.wrapper.addClass(that._guid).css(extend({margin:0,zIndex:10050}, that._popupPaddings));
	
		            if (options.position.pinned) {
		                popup.wrapper.css("position", "fixed");
		                if (openPopup[0]) {
		                    that._togglePin(popup.wrapper, true);
		                }
		            } else if (!openPopup[0]) {
		                that._togglePin(popup.wrapper, false);
		            }
	
		            if (autoHideAfter > 0) {
		                setTimeout(function () {
		                    that._hidePopup(popup);
		                }, autoHideAfter);
		            }
		        },
	
		        _hidePopup: function (popup) {
		            popup.wrapper.addClass(KHIDING);
		            popup.close();
		        },
	
		        _togglePin: function(wrapper, pin) {
		            var win = $(window),
		                sign = pin ? -1 : 1;
	
		            wrapper.css({
		                top: parseInt(wrapper.css(TOP), 10) + sign * win.scrollTop(),
		                left: parseInt(wrapper.css(LEFT), 10) + sign * win.scrollLeft()
		            });
		        },
	
		        _attachStaticEvents: function(options, wrapper) {
		            var that = this,
		                allowHideAfter = options.allowHideAfter,
		                attachDelay = !isNaN(allowHideAfter) && allowHideAfter > 0;
	
		            function attachClick(target) {
		                target.on(CLICK + NS, proxy(that._hideStatic, that, wrapper));
		            }
	
		            if (options.hideOnClick) {
		                if (attachDelay) {
		                    setTimeout(function(){
		                        attachClick(wrapper);
		                    }, allowHideAfter);
		                } else {
		                    attachClick(wrapper);
		                }
		            } else if (options.button) {
		                if (attachDelay) {
		                    setTimeout(function(){
		                        attachClick(wrapper.find(KICLOSE));
		                    }, allowHideAfter);
		                } else {
		                    attachClick(wrapper.find(KICLOSE));
		                }
		            }
		        },
	
		        _showStatic: function(wrapper, options) {
		            var that = this,
		                autoHideAfter = options.autoHideAfter,
		                animation = options.animation,
		                insertionMethod = options.stacking == UP || options.stacking == LEFT ? "prependTo" : "appendTo",
		                initializedNotifications;
	
		            wrapper
		                .removeClass("k-popup")
		                .addClass(that._guid)
		                [insertionMethod](options.appendTo)
		                .hide()
		                .kendoAnimate(animation.open || false);
	
		            initializedNotifications = that.getNotifications();
		            initializedNotifications.each(function(idx, element) {
		                that._attachStaticEvents(options, $(element));
	
		                if (autoHideAfter > 0) {
		                    setTimeout(function(){
		                        that._hideStatic($(element));
		                    }, autoHideAfter);
		                }
		            });
		        },
	
		        _hideStatic: function(wrapper) {
		            wrapper.kendoAnimate(extend(this.options.animation.close || false, { complete: function() {
		                wrapper.off(NS).find(KICLOSE).off(NS);
		                wrapper.remove();
		            }}));
		            this._triggerHide(wrapper);
		        },
	
		        _triggerHide: function(element) {
		            this.trigger(HIDE, { element: element });
		            this.angular("cleanup", function(){
		                return { elements: element };
		            });
		        },
	
		        show: function(content, type, safe) {
		            var that = this,
		                options = that.options,
		                wrapper = $(WRAPPER),
		                args, defaultArgs;
	
		            if (!type) {
		                type = INFO;
		            }
	
		            if (content !== null && content !== undefined && content !== "") {
	
		                if (kendo.isFunction(content)) {
		                    content = content();
		                }
	
		                defaultArgs = {typeIcon: type, content: ""};
	
		                if ($.isPlainObject(content)) {
		                    args = extend(defaultArgs, content);
		                } else {
		                    args = extend(defaultArgs, {content: content});
		                }
	
		                wrapper
		                    .addClass(KNOTIFICATION + "-" + type)
		                    .toggleClass(KNOTIFICATION + "-button", options.button)
		                    .attr("data-role", "alert")
		                    .css({width: options.width, height: options.height})
		                    .append(that._getCompiled(type, safe)(args));
	
		                that.angular("compile", function(){
		                    return {
		                        elements: wrapper,
		                        data: [{ dataItem: args }]
		                    };
		                });
	
		                if ($(options.appendTo)[0]) {
		                    that._showStatic(wrapper, options);
		                } else {
		                    that._showPopup(wrapper, options);
		                }
	
		                that.trigger(SHOW, {element: wrapper});
		            }
	
		            return that;
		        },
	
		        showText: function(content, type) {
		            this.show(content, type, true);
		        },
	
		        info: function(content) {
		            return this.show(content, INFO);
		        },
	
		        success: function(content) {
		            return this.show(content, SUCCESS);
		        },
	
		        warning: function(content) {
		            return this.show(content, WARNING);
		        },
	
		        error: function(content) {
		            return this.show(content, ERROR);
		        },
	
		        hide: function() {
		            var that = this,
		                openedNotifications = that.getNotifications();
	
		            if (that.options.appendTo) {
		                openedNotifications.each(function(idx, element){
		                    that._hideStatic($(element));
		                });
		            } else {
		                openedNotifications.each(function(idx, element){
		                    var popup = $(element).data("kendoPopup");
		                    if (popup) {
		                        that._hidePopup(popup);
		                    }
		                });
		            }
	
		            return that;
		        },
	
		        getNotifications: function() {
		            var that = this,
		                guidElements = $("." + that._guid + ":not(." + KHIDING + ")");
	
		            if (that.options.appendTo) {
		                return guidElements;
		            } else {
		                return guidElements.children("." + KNOTIFICATION);
		            }
		        },
	
		        setOptions: function(newOptions) {
		            var that = this,
		                options;
	
		            Widget.fn.setOptions.call(that, newOptions);
	
		            options = that.options;
	
		            if (newOptions.templates !== undefined) {
		                that._compileTemplates(options.templates);
		            }
	
		            if (newOptions.stacking !== undefined || newOptions.position !== undefined) {
		                that._compileStacking(options.stacking, options.position.top, options.position.left);
		            }
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.getNotifications().off(NS).find(KICLOSE).off(NS);
		        }
		    });
	
		    kendo.ui.plugin(Notification);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1211);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1028:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(578);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1211:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* jshint eqnull: true */
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1013), __webpack_require__(1028) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "listbox",
		    name: "ListBox",
		    category: "web",
		    depends: ["draganddrop", "data", "selectable"]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo;
		    var kendoAttr = kendo.attr;
		    var data = kendo.data;
		    var keys = kendo.keys;
		    var kendoTemplate = kendo.template;
		    var Widget = kendo.ui.Widget;
		    var DataSource = data.DataSource;
		    var Selectable = kendo.ui.Selectable;
		    var DataBoundWidget = kendo.ui.DataBoundWidget;
		    var Class = kendo.Class;
	
		    var extend = $.extend;
		    var noop = $.noop;
		    var proxy = $.proxy;
	
		    var DASH = "-";
		    var DOT = ".";
		    var SPACE = " ";
		    var HASH = "#";
	
		    var KENDO_LISTBOX = "kendoListBox";
		    var NS = DOT + KENDO_LISTBOX;
		    var DISABLED_STATE_CLASS = "k-state-disabled";
		    var SELECTED_STATE_CLASS = "k-state-selected";
		    var ENABLED_ITEM_SELECTOR = ".k-item:not(.k-state-disabled)";
		    var ENABLED_ITEMS_SELECTOR = ".k-list:not(.k-state-disabled) >" + ENABLED_ITEM_SELECTOR;
		    var TOOLBAR_CLASS = "k-listbox-toolbar";
		    var TOOL_SELECTOR = "li > a.k-button:not(.k-state-disabled)";
		    var FOCUSED_CLASS = "k-state-focused";
		    var DRAG_CLUE_CLASS = "k-drag-clue";
		    var DROP_HINT_CLASS = "k-drop-hint";
		    var LIST_CLASS = "k-reset k-list";
		    var LIST_SELECTOR = ".k-reset.k-list";
		    var RESET = "k-reset";
	
		    var CLICK = "click" + NS;
		    var KEYDOWN = "keydown" + NS;
		    var BLUR = "blur" + NS;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
		    var CHANGE = "change";
		    var DATABOUND = "dataBound";
		    var ADD = "add";
		    var REMOVE = "remove";
		    var REORDER = "reorder";
		    var MOVE_UP = "moveUp";
		    var MOVE_DOWN = "moveDown";
		    var TRANSFER_TO = "transferTo";
		    var TRANSFER_FROM = "transferFrom";
		    var TRANSFER_ALL_TO = "transferAllTo";
		    var TRANSFER_ALL_FROM = "transferAllFrom";
		    var DRAGGEDCLASS = "k-ghost";
		    var UNIQUE_ID = "uid";
		    var TABINDEX = "tabindex";
		    var COMMAND = "command";
	
		    var MOVE_UP_OFFSET = -1;
		    var MOVE_DOWN_OFFSET = 1;
		    var DRAGSTART = "dragstart";
		    var DRAG = "drag";
		    var DROP = "drop";
		    var DRAGEND = "dragend";
		    var DEFAULT_FILTER = "ul.k-reset.k-list>li.k-item";
	
		    var RIGHT = "right";
		    var BOTTOM = "bottom";
	
		    var TOOLBAR_POSITION_CLASS_NAMES = [
		        TOOLBAR_CLASS + DASH + "left",
		        TOOLBAR_CLASS + DASH + RIGHT,
		        TOOLBAR_CLASS + DASH + "top",
		        TOOLBAR_CLASS + DASH + BOTTOM
		    ];
	
		    function getSortedDomIndices(items) {
		        var indices = $.map(items, function(item) {
		            return $(item).index();
		        });
	
		        return indices;
		    }
	
		    function isUndefined(value) {
		        return (typeof value === "undefined");
		    }
	
		    function defaultHint(element) {
		        return element.clone()
		            .removeClass(DRAGGEDCLASS)
		            .removeClass(FOCUSED_CLASS)
		            .addClass(kendo.format("{0} {1} {2}", SELECTED_STATE_CLASS, RESET, DRAG_CLUE_CLASS))
		            .width(element.width());
		    }
	
		    function defaultPlaceholder() {
		        return $('<li>').addClass(DROP_HINT_CLASS);
		    }
	
		    var ListBox = DataBoundWidget.extend({
		        init: function(element, options) {
		            var that = this;
		            Widget.fn.init.call(that, element, options);
	
		            that._wrapper();
		            that._list();
		            element = that.element.attr("multiple", "multiple").hide();
	
		            if (element[0] && !that.options.dataSource) {
		                that.options.dataTextField = that.options.dataTextField || "text";
		                that.options.dataValueField = that.options.dataValueField || "value";
		            }
		            that._templates();
		            that._selectable();
		            that._dataSource();
		            that._createToolbar();
		            that._createDraggable();
		            that._createNavigatable();
		        },
	
		        destroy: function() {
		            var that = this;
	
		            DataBoundWidget.fn.destroy.call(that);
		            if(!isNaN(that._listTabIndex)) {
		                that._getList().off();
		                that._listTabIndex = null;
		            }
		            that._unbindDataSource();
		            that._destroySelectable();
		            that._destroyToolbar();
		            that.wrapper.off(NS);
		            if(that._target){
		                that._target = null;
		            }
		            if(that._draggable) {
		                that._draggable.destroy();
		                that.placeholder = null;
		            }
	
		            kendo.destroy(that.element);
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
		            this._templates();
		            this._dataSource();
		        },
	
		        events: [
		            CHANGE,
		            DATABOUND,
		            ADD,
		            REMOVE,
		            REORDER,
		            DRAGSTART,
		            DRAG,
		            DROP,
		            DRAGEND
		        ],
	
		        options: {
		            name: "ListBox",
		            autoBind: true,
		            template: "",
		            dataTextField: "",
		            dataValueField: "",
		            selectable: "single",
		            draggable: null,
		            dropSources: [],
		            connectWith: "",
		            navigatable: true,
		            toolbar: {
		                position: RIGHT,
		                tools: []
		            },
		            messages: {
		                tools: {
		                    remove: "Delete",
		                    moveUp: "Move Up",
		                    moveDown: "Move Down",
		                    transferTo: "Transfer To",
		                    transferFrom: "Transfer From",
		                    transferAllTo: "Transfer All To",
		                    transferAllFrom: "Transfer All From"
		                }
		            }
		        },
	
		        add: function(dataItems) {
		            var that = this;
		            var items = dataItems && dataItems.length ? dataItems : [dataItems];
		            var itemsLength = items.length;
		            var i;
	
		            that._unbindDataSource();
		            for (i = 0; i < itemsLength; i++) {
		                that._addItem(items[i]);
		            }
		            that._bindDataSource();
		            that._syncElement();
		        },
	
		        _addItem: function (dataItem) {
		            var that = this;
		            var item = that.templates.itemTemplate({ item: dataItem, r: that.templates.itemContent });
	
		            $(item).attr(kendoAttr(UNIQUE_ID), dataItem.uid).appendTo(that._getList());
		            if (typeof dataItem === typeof "") {
		                that.dataSource._data.push(dataItem);
		            } else {
		                that.dataSource.add(dataItem);
		            }
		        },
	
		        _addItemAt: function(dataItem, index) {
		            var that = this;
		            var item = that.templates.itemTemplate({ item: dataItem, r: that.templates.itemContent });
		            that._unbindDataSource();
		            if (typeof dataItem === typeof "") {
		                that._insertElementAt(item, index);
		                that.dataSource._data.push(dataItem);
		            } else {
		                that._insertElementAt($(item).attr(kendoAttr(UNIQUE_ID), dataItem.uid), index);
		                that.dataSource.add(dataItem);
		            }
		            that._bindDataSource();
		            that._syncElement();
		        },
	
		        _insertElementAt: function(item, index) {
		            var that = this;
		            var list = that._getList();
	
		            if (index > 0) {
		                $(item).insertAfter(list.children().eq(index - 1));
		            } else {
		                $(list).prepend(item);
		            }
		        },
	
		        _createNavigatable: function() {
		            var that = this;
		            var options = that.options;
	
		            if(options.navigatable) {
		                that._getList().on(CLICK, ENABLED_ITEM_SELECTOR, proxy(that._click, that))
		                            .on(KEYDOWN, proxy(that._keyDown, that))
		                            .on(BLUR, proxy(that._blur, that));
		            }
		        },
	
		        _getTabIndex: function() {
		            var that = this;
		            var tabindex;
	
		            if(!isNaN(that._listTabIndex))
		            {
		                return that._listTabIndex;
		            }
	
		            tabindex = that.element.attr(TABINDEX);
		            that._listTabIndex = !isNaN(tabindex) ? tabindex : 0;
	
		            that.element.removeAttr(TABINDEX);
	
		            return that._listTabIndex;
		        },
	
		        _blur: function() {
		            if(this._target) {
		                this._target.removeClass(FOCUSED_CLASS);
		                this._getList().removeAttr("aria-activedescendant");
		            }
		            this._target = null;
		        },
	
		        _click: function(e) {
		            var that = this;
		            var target = $(e.currentTarget);
		            var oldTarget = that._target;
	
		            if (oldTarget) {
		                oldTarget.removeClass(FOCUSED_CLASS);
		            }
	
		            that._target = target;
		            target.addClass(FOCUSED_CLASS);
		            that._getList().attr("aria-activedescendant", target.attr("id"));
	
		            if (that._getList()[0] !== kendo._activeElement()) {
		                that.focus();
		            }
		        },
	
		        _getNavigatableItem: function(key) {
		            var that = this;
		            var current;
	
		            if (!that._target) {
		                current = that.items().filter(ENABLED_ITEM_SELECTOR).first();
		            }  else {
		                current = that._target;
		            }
	
		            if (key === keys.UP && that._target) {
		                current = that._target.prevAll(ENABLED_ITEM_SELECTOR).first();
		            }
	
		            if (key === keys.DOWN && that._target) {
		                current = that._target.nextAll(ENABLED_ITEM_SELECTOR).first();
		            }
	
		            return current.length ? current : null;
		        },
	
		        _scrollIntoView: function(item) {
		            if (!item) {
		                return;
		            }
	
		            if (item[0]) {
		                item = item[0];
		            }
	
		            var list = this._getList().parent()[0];
		            var itemOffsetTop = item.offsetTop;
		            var contentScrollTop = list.scrollTop;
		            var contentOffsetHeight = list.clientHeight;
		            var bottomDistance = itemOffsetTop + item.offsetHeight;
	
		            if (contentScrollTop > itemOffsetTop) {
		                contentScrollTop = itemOffsetTop;
		            } else if (bottomDistance > (contentScrollTop + contentOffsetHeight)) {
		                contentScrollTop = (bottomDistance - contentOffsetHeight);
		            }
	
		            list.scrollTop = contentScrollTop;
		        },
	
		        _keyDown: function(e) {
		            var that = this;
		            var key = e.keyCode;
		            var current = that._getNavigatableItem(key);
		            var shouldPreventDefault;
	
		            if(that._target) {
		                that._target.removeClass(FOCUSED_CLASS);
		            }
	
		            if(!(e.shiftKey && !e.ctrlKey && (key === keys.DOWN || key === keys.UP))) {
		                that._shiftSelecting = false;
		            }
	
		            if(key == keys.DELETE) {
		                that._executeCommand(REMOVE);
		                if(that._target) {
		                    that._target.removeClass(FOCUSED_CLASS);
		                    that._getList().removeAttr("aria-activedescendant");
		                    that._target = null;
		                }
		                shouldPreventDefault = true;
		            } else if(key === keys.DOWN || key === keys.UP) {
		                if(!current) {
		                    e.preventDefault();
		                    return;
		                }
		                if (e.shiftKey && !e.ctrlKey) {
		                    if (!that._shiftSelecting) {
		                        that.clearSelection();
		                        that._shiftSelecting = true;
		                    }
		                    if (that._target && current.hasClass("k-state-selected")) {
		                        that._target.removeClass(SELECTED_STATE_CLASS);
		                        that.trigger(CHANGE);
		                    } else if(that.options.selectable == "single") {
		                       that.select(current);
		                    } else {
		                       that.select(current.add(that._target));
		                    }
		                } else if (e.shiftKey && e.ctrlKey) {
		                    that._executeCommand(key === keys.DOWN ? MOVE_DOWN : MOVE_UP);
		                    that._scrollIntoView(that._target);
		                    e.preventDefault();
		                    return;
		                } else if (!e.shiftKey && !e.ctrlKey) {
		                    if(that.options.selectable === "multiple"){
		                        that.clearSelection();
		                    }
		                    that.select(current);
		                }
	
		                that._target = current;
		                if(that._target) {
		                    that._target.addClass(FOCUSED_CLASS);
		                    that._scrollIntoView(that._target);
		                    that._getList().attr("aria-activedescendant", that._target.attr("id"));
		                } else {
		                    that._getList().removeAttr("aria-activedescendant");
		                }
		                shouldPreventDefault = true;
		            } else if(key == keys.SPACEBAR) {
		                if(e.ctrlKey && that._target) {
		                   if(that._target.hasClass(SELECTED_STATE_CLASS)) {
		                       that._target.removeClass(SELECTED_STATE_CLASS);
		                       that.trigger(CHANGE);
		                   } else {
		                       that.select(that._target);
		                   }
		                } else {
		                   that.clearSelection();
		                   that.select(that._target);
		                }
		                shouldPreventDefault = true;
		            } else if(e.ctrlKey && key == keys.RIGHT) {
		                if(e.shiftKey) {
		                   that._executeCommand(TRANSFER_ALL_TO);
		                } else {
		                   that._executeCommand(TRANSFER_TO);
		                }
		                that._target = that.select().length ? that.select(): null;
		                shouldPreventDefault = true;
		            } else if(e.ctrlKey && key == keys.LEFT) {
		                if(e.shiftKey) {
		                   that._executeCommand(TRANSFER_ALL_FROM);
		                } else {
		                   that._executeCommand(TRANSFER_FROM);
		                }
		                shouldPreventDefault = true;
		            }
	
		            if(shouldPreventDefault) {
		                e.preventDefault();
		            }
		        },
	
		        focus: function() {
		            kendo.focusElement(this._getList());
		        },
	
		        _createDraggable: function() {
		            var that = this;
		            var draggable = that.options.draggable;
		            var hint;
	
		            if(draggable) {
		                hint = draggable.hint;
		                if(!that.options.selectable) {
		                    throw new Error("Dragging requires selection to be enabled");
		                }
	
		                if(!hint) {
		                    hint = defaultHint;
		                }
	
		                that._draggable = new kendo.ui.Draggable(that.wrapper, {
		                    filter: draggable.filter ? draggable.filter : DEFAULT_FILTER,
		                    hint: kendo.isFunction(hint) ? hint : $(hint),
		                    dragstart: proxy(that._dragstart, that),
		                    dragcancel: proxy(that._clear, that),
		                    drag: proxy(that._drag, that),
		                    dragend: proxy(that._dragend, that)
		                });
		            }
		        },
	
		        _dragstart: function(e) {
		            var that = this;
		            var draggedElement = that.draggedElement = e.currentTarget;
		            var placeholder = that.options.draggable.placeholder;
		            var dataItem = that.dataItem(draggedElement);
		            var eventData = { dataItems: dataItem, items: $(draggedElement), draggableEvent: e };
	
		            if(that.options.draggable.enabled === false) {
		                e.preventDefault();
		                return;
		            }
	
		            if(!placeholder) {
		                placeholder = defaultPlaceholder;
		            }
	
		            that.placeholder = kendo.isFunction(placeholder) ? $(placeholder.call(that, draggedElement)) : $(placeholder);
	
		            if(draggedElement.is(DOT + DISABLED_STATE_CLASS)) {
		                e.preventDefault();
		            } else {
		                if(that.trigger(DRAGSTART, eventData)) {
		                    e.preventDefault();
		                } else {
		                    that.clearSelection();
		                    that.select(draggedElement);
		                    draggedElement.addClass(DRAGGEDCLASS);
		                }
		            }
		        },
	
		        _clear: function() {
		            this.draggedElement.removeClass(DRAGGEDCLASS);
		            this.placeholder.remove();
		        },
	
		        _findElementUnderCursor: function(e) {
		            var elementUnderCursor = kendo.elementUnderCursor(e);
		            var draggable = e.sender;
	
		            if($.contains(draggable.hint[0], elementUnderCursor) || draggable.hint[0] === elementUnderCursor) {
		                draggable.hint.hide();
		                elementUnderCursor = kendo.elementUnderCursor(e);
		                draggable.hint.show();
		            }
	
		            return elementUnderCursor;
		        },
	
		        _findTarget: function(e) {
		            var that = this;
		            var element = that._findElementUnderCursor(e);
		            var elementNode = $(element);
		            var list = that._getList();
		            var items;
		            var node;
	
		            if($.contains(list[0], element)) {
		                items = that.items();
		                element = elementNode.is("li") ? element: elementNode.closest("li")[0];
		                node = items.filter(element)[0] || items.has(element)[0];
		                if(node) {
		                    node = $(node);
		                    return !node.hasClass(DISABLED_STATE_CLASS) ? { element: node, listBox: that } : null;
		                } else {
		                    return null;
		                }
		            } else if (list[0] == element || list.parent()[0] == element) {
		                return { element: $(list), appendToBottom: true, listBox: that };
		            } else {
		                return that._searchConnectedListBox(elementNode);
		            }
		        },
	
		        _getElementCenter: function(element) {
		            var center = element.length ? kendo.getOffset(element) : null;
		            if(center) {
		                center.top += outerHeight(element) / 2;
		                center.left += outerWidth(element) / 2;
		            }
	
		            return center;
		        },
	
		        _searchConnectedListBox: function(element) {
		            var connectedListBox;
		            var items;
		            var node;
		            var originalElement = element;
		            var closestContainer;
	
		            if(element.hasClass("k-list-scroller k-selectable")) {
		                closestContainer = element;
		            } else {
		                closestContainer = element.closest(".k-list-scroller.k-selectable");
		            }
	
		            if(closestContainer.length) {
		                connectedListBox = closestContainer.parent().find("[data-role='listbox']").getKendoListBox();
		            } else {
		                return null;
		            }
	
		            if(connectedListBox && $.inArray(this.element[0].id, connectedListBox.options.dropSources) !== -1) {
		                items = connectedListBox.items();
		                element = element.is("li") ? element[0] : element.closest("li")[0];
		                node = items.filter(element)[0] || items.has(element)[0];
		                if(node) {
		                    node = $(node);
		                    return !node.hasClass(DISABLED_STATE_CLASS) ? { element: node, listBox: connectedListBox } : null;
		                } else if(!items.length ||
		                            originalElement.hasClass("k-list-scroller k-selectable") ||
		                            originalElement.hasClass("k-reset k-list")) {
		                    return { element: connectedListBox._getList(), listBox: connectedListBox, appendToBottom: true };
		                } else {
		                    return null;
		                }
		            }
		            return null;
		        },
	
		        _drag: function(e) {
		            var that = this;
		            var draggedElement = that.draggedElement;
		            var target = that._findTarget(e);
		            var cursorOffset = { left: e.x.location, top: e.y.location };
		            var dataItem = that.dataItem(draggedElement);
		            var eventData = { dataItems: [dataItem], items: $(draggedElement), draggableEvent: e };
		            var targetCenter;
		            var offsetDelta;
		            var direction;
	
		            if(that.trigger(DRAG, eventData)) {
		                e.preventDefault();
		                return;
		            }
	
		            if(target) {
		                targetCenter = this._getElementCenter(target.element);
	
		                offsetDelta = {
		                    left: Math.round(cursorOffset.left - targetCenter.left),
		                    top: Math.round(cursorOffset.top - targetCenter.top)
		                };
	
		                if(target.appendToBottom) {
		                    that._movePlaceholder(target, null , draggedElement);
		                    return;
		                }
	
		                if(offsetDelta.top < 0) {
		                    direction = "prev";
		                } else if(offsetDelta.top > 0) {
		                    direction = "next";
		                }
	
		                if(direction) {
		                    if(target.element[0] != that.placeholder[0]) {
		                        that._movePlaceholder(target, direction, draggedElement);
		                    }
		                }
		             }
		             else if(that.placeholder.parent().length){
		                that.placeholder.remove();
		             }
		        },
	
		        _movePlaceholder: function(target, direction, draggedElement) {
		            var that = this;
		            var placeholder = that.placeholder;
		            var draggableOptions = target.listBox.options.draggable;
	
		            if(placeholder.parent().length) {
		                that.placeholder.remove();
		                if(draggableOptions && draggableOptions.placeholder){
		                    that.placeholder = kendo.isFunction(draggableOptions.placeholder) ? $(draggableOptions.placeholder.call(that, draggedElement)) : $(draggableOptions.placeholder);
		                } else {
		                    that.placeholder = $(defaultPlaceholder.call(that, draggedElement));
		                }
		            }
	
		            if (!direction) {
		                target.element.append(that.placeholder);
		            } else if (direction === "prev") {
		                target.element.before(that.placeholder);
		            } else if (direction === "next") {
		                target.element.after(that.placeholder);
		            }
		        },
	
		        _dragend: function(e) {
		            var that = this;
		            var draggedItem = that.draggedElement;
		            var items = that.items();
		            var placeholderIndex = items.not(that.draggedElement).index(that.placeholder);
		            var draggedIndex = items.not(that.placeholder).index(that.draggedElement);
		            var dataItem = that.dataItem(draggedItem);
		            var eventData = { dataItems: [dataItem], items: $(draggedItem) };
		            var connectedListBox = that.placeholder.closest(".k-widget.k-listbox").find("[data-role='listbox']").getKendoListBox();
	
		            if(that.trigger(DROP, extend({}, eventData, { draggableEvent: e }))) {
		                e.preventDefault();
		                this._clear();
		                return;
		            }
	
		            if(placeholderIndex >= 0) {
		                if(placeholderIndex !== draggedIndex && !that.trigger(REORDER, extend({}, eventData, { offset: placeholderIndex - draggedIndex }))) {
		                    draggedItem.removeClass(DRAGGEDCLASS);
		                    that.reorder(draggedItem, placeholderIndex);
		                }
		            } else if(connectedListBox) {
		                if(!that.trigger(REMOVE, eventData)) {
		                    that.remove($(draggedItem));
		                }
	
		                if(!connectedListBox.trigger(ADD, eventData)) {
		                    connectedListBox._addItemAt(dataItem, connectedListBox.items().index(that.placeholder));
		                }
		            }
	
		            that._clear();
		            that._draggable.dropped = true;
	
		            that.trigger(DRAGEND, extend({}, eventData, { draggableEvent: e }));
	
		            that._updateToolbar();
		            that._updateAllToolbars();
		        },
	
		        reorder: function(item, index) {
		            var that = this;
		            var dataSource = that.dataSource;
		            var dataItem = that.dataItem(item);
		            var dataItemAtIndex = dataSource.at(index);
		            var itemAtIndex = that.items()[index];
		            var listItem = $(item);
	
		            if (dataItem && itemAtIndex && dataItemAtIndex) {
		                that._removeElement(listItem);
		                that._insertElementAt(listItem, index);
		                that._updateToolbar();
		            }
		        },
	
		        remove: function (items) {
		            var that = this;
		            var listItems = that._getItems(items);
		            var itemsLength = listItems.length;
		            var i;
	
		            that._unbindDataSource();
		            for (i = 0; i < itemsLength; i++) {
		                that._removeItem($(listItems[i]));
		            }
		            that._bindDataSource();
		            that._syncElement();
		            that._updateToolbar();
		            that._updateAllToolbars();
		        },
	
		        _removeItem: function (item) {
		            var that = this;
		            var dataSource = that.dataSource;
		            var dataItem = that.dataItem(item);
		            if (!dataItem || !dataSource) {
		                return;
		            }
		            if (typeof dataItem === typeof "") {
		                var data = dataSource._data;
		                for (var i = 0; i < data.length; i++) {
		                    if (dataItem === data[i]) {
		                        data[i] = data[data.length - 1];
		                        data.pop();
		                        break;
		                    }
		                }
		            } else {
		                dataSource.remove(dataItem);
		            }
		            that._removeElement(item);
		        },
	
		        _removeElement: function(item) {
		            kendo.destroy(item);
		            $(item).off().remove();
		        },
	
		        dataItem: function (element) {
		            var uniqueIdAttr = kendoAttr(UNIQUE_ID);
		            var uid = $(element).attr(uniqueIdAttr) || $(element).closest("[" + uniqueIdAttr + "]").attr(uniqueIdAttr);
		            if (uid) {
		                return this.dataSource.getByUid(uid);
		            }
		            else {
		                return $(element).html();
		            }
		        },
	
		        _dataItems: function (items) {
		            var dataItems = [];
		            var listItems = $(items);
		            var itemsLength = listItems.length;
		            var i;
	
		            for (i = 0; i < itemsLength; i++) {
		                dataItems.push(this.dataItem(listItems.eq(i)));
		            }
	
		            return dataItems;
		        },
	
		        items: function() {
		            var list = this._getList();
		            return list.children();
		        },
	
		        select: function(items) {
		            var that = this;
		            var selectable = that.selectable;
		            var enabledItems;
	
		            if (isUndefined(items)) {
		                return selectable.value();
		            }
	
		            enabledItems = that.items().filter(items).filter(ENABLED_ITEMS_SELECTOR);
	
		            if (!selectable.options.multiple) {
		                selectable.clear();
		                enabledItems = enabledItems.first();
		            }
	
		            return selectable.value(enabledItems);
		        },
	
		        clearSelection: function() {
		            var that = this;
		            var selectable = that.selectable;
	
		            if (selectable) {
		                selectable.clear();
		            }
		        },
	
		        enable: function(items, enable) {
		            var that = this;
		            var enabled = isUndefined(enable) ? true : !!enable;
		            var listItems = that._getItems(items);
		            var itemsLength = listItems.length;
		            var i;
	
		            for (i = 0; i < itemsLength; i++) {
		                that._enableItem($(listItems[i]), enabled);
		            }
	
		            that._updateAllToolbars();
		        },
	
		        _enableItem: function(item, enable) {
		            var that = this;
		            var dataItem = that.dataItem(item);
	
		            if (dataItem) {
		                if (enable) {
		                    $(item).removeClass(DISABLED_STATE_CLASS);
		                } else {
		                    $(item)
		                        .addClass(DISABLED_STATE_CLASS)
		                        .removeClass(SELECTED_STATE_CLASS);
		                }
		            }
		        },
	
		        setDataSource: function(dataSource) {
		            var that = this;
	
		            that.options.dataSource = dataSource;
	
		            that._dataSource();
		        },
	
		        _dataSource: function() {
		            var that = this;
		            var options = that.options;
		            var dataSource = options.dataSource || {};
	
		            dataSource = $.isArray(dataSource) ? { data: dataSource } : dataSource;
		            dataSource.select = that.element;
		            dataSource.fields = [
		                { field: options.dataTextField },
		                { field: options.dataValueField }];
	
		            that._unbindDataSource();
		            that.dataSource = DataSource.create(dataSource);
		            that._bindDataSource();
	
		            if (that.options.autoBind) {
		                that.dataSource.fetch();
		            }
		        },
	
		        _bindDataSource: function() {
		            var that = this;
		            var dataSource = that.dataSource;
	
		            that._dataChangeHandler = proxy(that.refresh, that);
	
		            if (dataSource) {
		                dataSource.bind(CHANGE, that._dataChangeHandler);
		            }
		        },
	
		        _unbindDataSource: function() {
		            var that = this;
		            var dataSource = that.dataSource;
	
		            if (dataSource) {
		                dataSource.unbind(CHANGE, that._dataChangeHandler);
		            }
		        },
	
		        _wrapper: function () {
		            var that = this,
		                element = that.element,
		                wrapper = element.parent("div.k-listbox");
	
		            if (!wrapper[0]) {
		                wrapper = element.wrap('<div class="k-widget k-listbox" unselectable="on" />').parent();
		                wrapper[0].style.cssText = element[0].style.cssText;
		                wrapper[0].title = element[0].title;
		                $('<div class="k-list-scroller" />').insertBefore(element);
		            }
	
		            that.wrapper = wrapper.addClass(element[0].className).css("display", "");
		            that._innerWrapper = $(wrapper[0].firstChild);
		        },
	
		        _list: function () {
		            var that = this;
		            $("<ul class='" + LIST_CLASS + "' role='listbox'></ul>").appendTo(that._innerWrapper);
		            if(that.options.navigatable) {
		                that._getList().attr(TABINDEX, that._getTabIndex());
		            }
		        },
	
		        _templates: function () {
		            var that = this;
		            var options = this.options;
		            var template;
	
		            if (options.template && typeof options.template == "string") {
		                template = kendo.template(options.template);
		            } else if (!options.template) {
		                template = kendo.template('${' + kendo.expr(options.dataTextField, "data") + "}", { useWithBlock: false });
		            } else {
		                template = options.template;
		            }
	
		            that.templates = {
		                itemTemplate: kendo.template("# var item = data.item, r = data.r; # <li class='k-item' role='option' aria-selected='false'>#=r(item)#</li>", { useWithBlock: false }),
		                itemContent: template,
		                toolbar: "<div class='" + TOOLBAR_CLASS + "'></div>"
		            };
		        },
	
		        refresh: function() {
		            var that = this;
		            var view = that.dataSource.view();
		            var template = that.templates.itemTemplate;
		            var html = "";
	
		            for (var idx = 0; idx < view.length; idx++) {
		                html += template({ item: view[idx], r: that.templates.itemContent });
		            }
		            that._getList().html(html);
		            that._setItemIds();
		            that._createToolbar();
		            that._syncElement();
		            that._updateToolbar();
		            that._updateAllToolbars();
		            that.trigger(DATABOUND);
		        },
	
		        _syncElement: function () {
		            var options = "";
		            var view = this.dataSource.view();
		            for (var idx = 0; idx < view.length; idx++) {
		                options += this._option(view[idx][this.options.dataValueField] || view[idx], view[idx][this.options.dataTextField] || view[idx], true);
		            }
		            this.element.html(options);
		        },
	
		        _option: function (dataValue, dataText) {
		            var option = "<option";
	
		            if (dataValue !== undefined) {
		                dataValue += "";
	
		                if (dataValue.indexOf('"') !== -1) {
		                    dataValue = dataValue.replace(/"/g, "&quot;");
		                }
	
		                option += ' value="' + dataValue + '"';
		            }
		            option += " selected>";
	
		            if (dataText !== undefined) {
		                option += kendo.htmlEncode(dataText);
		            }
	
		            return option += "</option>";
		        },
	
		        _setItemIds: function() {
		            var that = this;
		            var items = that.items();
		            var view = that.dataSource.view();
		            var viewLength = view.length;
		            var i;
	
		            for (i = 0; i < viewLength; i++) {
		                items.eq(i).attr(kendoAttr(UNIQUE_ID), view[i].uid).attr("id", view[i].uid);
		            }
		        },
	
		        _selectable: function() {
		            var that = this;
		            var selectable = that.options.selectable;
		            var selectableOptions = Selectable.parseOptions(selectable);
	
		            if (selectableOptions.multiple) {
		                that.element.attr("aria-multiselectable", "true");
		            }
	
		            that.selectable = new Selectable(that._innerWrapper, {
		                aria: true,
		                multiple: selectableOptions.multiple,
		                filter: ENABLED_ITEM_SELECTOR,
		                change: proxy(that._onSelect, that)
		            });
		        },
	
		        _onSelect: function() {
		            var that = this;
	
		            that._updateToolbar();
		            that._updateAllToolbars();
		            that.trigger(CHANGE);
		        },
	
		        _destroySelectable: function() {
		            var that = this;
	
		            if (that.selectable && that.selectable.element) {
		                that.selectable.destroy();
		                that.selectable = null;
		            }
		        },
	
		        _getList: function() {
		            return this.wrapper.find(LIST_SELECTOR);
		        },
	
		        _getItems: function(items) {
		            return this.items().filter(items);
		        },
	
		        _createToolbar: function () {
		            var that = this;
		            var toolbarOptions = that.options.toolbar;
		            var position = toolbarOptions.position || RIGHT;
		            var toolbarInsertion = position === BOTTOM ? "insertAfter" : "insertBefore";
		            var tools = toolbarOptions.tools || [];
		            var messages = that.options.messages;
	
		            that._destroyToolbar();
		            that.wrapper.removeClass(TOOLBAR_POSITION_CLASS_NAMES.join(SPACE));
	
		            if (tools.length && tools.length > 0) {
		                var toolbarElement = $(that.templates.toolbar)[toolbarInsertion](that._innerWrapper);
		                that.toolbar = new ToolBar(toolbarElement, extend({}, toolbarOptions, { listBox: that, messages: messages }));
		                that.wrapper.addClass(TOOLBAR_CLASS + DASH + position);
		            }
		        },
	
		        _destroyToolbar: function() {
		            var that = this;
	
		            if (that.toolbar) {
		                that.toolbar.destroy();
		                that.toolbar = null;
		            }
		        },
	
		        _executeCommand: function(commandName) {
		            var that = this;
		            var command = CommandFactory.current.create(commandName, { listBox: that });
	
		            if (command) {
		                command.execute();
		                that._updateToolbar();
		                that._updateAllToolbars();
		            }
		        },
	
		        _updateToolbar: function() {
		            var toolbar = this.toolbar;
	
		            if (toolbar) {
		                toolbar._updateToolStates();
		            }
		        },
	
		        _updateAllToolbars: function() {
		            var listBoxElements = $("select[data-role='listbox']");
		            var elementsLength = listBoxElements.length;
		            var listBox;
		            var i;
	
		            for (i = 0; i < elementsLength; i++) {
		                listBox = $(listBoxElements[i]).data(KENDO_LISTBOX);
	
		                if (listBox) {
		                    listBox._updateToolbar();
		                }
		            }
		        }
		    });
	
		    kendo.ui.plugin(ListBox);
	
		    var CommandFactory = Class.extend({
		        init: function() {
		            this._commands = [];
		        },
	
		        register: function(commandName, commandType) {
		            this._commands.push({
		                commandName: commandName,
		                commandType: commandType
		            });
		        },
	
		        create: function(commandName, options) {
		            var commands = this._commands;
		            var itemsLength = commands.length;
		            var name = commandName ? commandName.toLowerCase() : "";
		            var match;
		            var command;
		            var i;
	
		            for (i = 0; i < itemsLength; i++) {
		                command = commands[i];
	
		                if (command.commandName.toLowerCase() === name) {
		                    match = command;
		                    break;
		                }
		            }
	
		            if (match) {
		                return new match.commandType(options);
		            }
		        }
		    });
		    CommandFactory.current = new CommandFactory();
	
		    var ListBoxCommand = Class.extend({
		        init: function(options) {
		            var that = this;
	
		            that.options = extend({}, that.options, options);
		            that.listBox = that.options.listBox;
		        },
	
		        options: {
		            listBox: null
		        },
	
		        getItems: function() {
		            return $(this.listBox.select());
		        },
	
		        execute: noop,
		        canExecute: noop
		    });
	
		    var RemoveItemsCommand = ListBoxCommand.extend({
		        execute: function() {
		            var that = this;
		            var listBox = that.listBox;
		            var items = that.getItems();
	
		            if (!listBox.trigger(REMOVE, { dataItems: listBox._dataItems(items), items: items })) {
		                listBox.remove(items);
		            }
		        },
	
		        canExecute: function() {
		            return this.listBox.select().length > 0;
		        }
		    });
		    CommandFactory.current.register(REMOVE, RemoveItemsCommand);
	
		    var MoveItemsCommand = ListBoxCommand.extend({
		        execute: function() {
		            var that = this;
	
		            if (that.canExecute()) {
		                that.moveItems();
		            }
		        },
	
		        canExecute: noop,
	
		        moveItems: function() {
		            var that = this;
		            var listBox = that.listBox;
		            var options = that.options;
		            var items = that.getItems();
		            var offset = options.offset;
		            var indecesInDom = getSortedDomIndices(items);
		            var movedItems = $.makeArray(items.sort(that.itemComparer));
		            var moveAction = options.moveAction;
		            var movedItem;
	
		            if (!listBox.trigger(REORDER, { dataItems: listBox._dataItems(movedItems), items: $(movedItems), offset: offset })) {
		                while (movedItems.length > 0 && indecesInDom.length > 0) {
		                    movedItem = movedItems[moveAction]();
	
		                    listBox.reorder(movedItem, indecesInDom[moveAction]() + offset);
		                }
		            }
		        },
	
		        options: {
		            offset: 0,
		            moveAction: "pop"
		        },
	
		        itemComparer: function(item1, item2) {
		            var indexItem1 = $(item1).index();
		            var indexItem2 = $(item2).index();
	
		            if (indexItem1 === indexItem2) {
		                return 0;
		            } else {
		                return (indexItem1 > indexItem2 ? 1 : (-1));
		            }
		        }
		    });
	
		    var MoveUpItemsCommand = MoveItemsCommand.extend({
		        options: {
		            offset: MOVE_UP_OFFSET,
		            moveAction: "shift"
		        },
	
		        canExecute: function() {
		            var items = this.getItems();
		            var domIndices = getSortedDomIndices(items);
	
		            return (domIndices.length > 0 && domIndices[0] > 0);
		        }
		    });
		    CommandFactory.current.register(MOVE_UP, MoveUpItemsCommand);
	
		    var MoveDownItemsCommand = MoveItemsCommand.extend({
		        options: {
		            offset: MOVE_DOWN_OFFSET,
		            moveAction: "pop"
		        },
	
		        canExecute: function() {
		            var that = this;
		            var items = that.getItems();
		            var domIndices = getSortedDomIndices(items);
	
		            return (domIndices.length > 0 && $(domIndices).last()[0] < (that.listBox.items().length - 1));
		        }
		    });
		    CommandFactory.current.register(MOVE_DOWN, MoveDownItemsCommand);
	
		    var TransferItemsCommand = ListBoxCommand.extend({
		        options: {
		            filter: ENABLED_ITEM_SELECTOR
		        },
	
		        execute: function() {
		            var that = this;
		            var sourceListBox = that.getSourceListBox();
		            var items = that.getItems().filter(that.options.filter);
		            var dataItems = sourceListBox ? sourceListBox._dataItems(items) : [];
		            var destinationListBox = that.getDestinationListBox();
		            var updatedSelection = that.getUpdatedSelection(items);
	
		            if (destinationListBox && items.length > 0) {
		                if (!destinationListBox.trigger(ADD, { dataItems: dataItems, items: items })) {
		                    destinationListBox.add(dataItems);
		                }
	
		                if (!sourceListBox.trigger(REMOVE, { dataItems: dataItems, items: items })) {
		                    sourceListBox.remove(items);
		                    that.updateSelection(updatedSelection);
		                }
		            }
		        },
	
		        getUpdatedSelection: function(items) {
		            var that = this;
		            var itemFilter = that.options.filter;
		            var sourceListBox = that.getSourceListBox();
		            var lastEnabledItem = sourceListBox ? sourceListBox.items().filter(itemFilter).last() : null;
		            var containsLastItem = $(items).filter(lastEnabledItem).length > 0;
		            var itemToSelect = containsLastItem ? $(items).prevAll(itemFilter)[0] : $(items).nextAll(itemFilter)[0];
	
		            if ($(items).length === 1 && itemToSelect) {
		                return itemToSelect;
		            } else {
		                return null;
		            }
		        },
	
		        updateSelection: function(item) {
		            var sourceListBox = this.getSourceListBox();
	
		            if (sourceListBox && item) {
		                $(sourceListBox.select($(item)));
		                sourceListBox._scrollIntoView(item);
		            }
		        },
	
		        getSourceListBox: noop,
		        getDestinationListBox: noop
		    });
	
		    var TransferItemsToCommand = TransferItemsCommand.extend({
		        canExecute: function() {
		            var sourceListBox = this.getSourceListBox();
	
		            return (sourceListBox ? sourceListBox.select().length > 0 : false);
		        },
	
		        getSourceListBox: function() {
		            return this.listBox;
		        },
	
		        getDestinationListBox: function() {
		            var sourceListBox = this.getSourceListBox();
		            return sourceListBox && sourceListBox.options.connectWith ? $(HASH + sourceListBox.options.connectWith).data(KENDO_LISTBOX) : null;
		        },
	
		        getItems: function() {
		            var sourceListBox = this.getSourceListBox();
		            return sourceListBox ? $(sourceListBox.select()) : $();
		        }
		    });
		    CommandFactory.current.register(TRANSFER_TO, TransferItemsToCommand);
	
		    var TransferItemsFromCommand = TransferItemsCommand.extend({
		        canExecute: function() {
		            var sourceListBox = this.getSourceListBox();
	
		            return (sourceListBox ? sourceListBox.select().length > 0 : false);
		        },
	
		        getSourceListBox: function() {
		            var destinationListBox = this.getDestinationListBox();
		            return (destinationListBox && destinationListBox.options.connectWith) ? $(HASH + destinationListBox.options.connectWith).data(KENDO_LISTBOX) : null;
		        },
	
		        getDestinationListBox: function() {
		            return this.listBox;
		        },
	
		        getItems: function() {
		            var sourceListBox = this.getSourceListBox();
		            return sourceListBox ? $(sourceListBox.select()) : $();
		        }
		    });
		    CommandFactory.current.register(TRANSFER_FROM, TransferItemsFromCommand);
	
		    var TransferAllItemsToCommand = TransferItemsToCommand.extend({
		        canExecute: function() {
		            var sourceListBox = this.getSourceListBox();
	
		            return (sourceListBox ? sourceListBox.items().filter(ENABLED_ITEM_SELECTOR).length > 0 : false);
		        },
	
		        getItems: function() {
		            var sourceListBox = this.getSourceListBox();
		            return sourceListBox ? sourceListBox.items() : $();
		        },
	
		        getUpdatedSelection: noop,
		        updateSelection: noop
		    });
		    CommandFactory.current.register(TRANSFER_ALL_TO, TransferAllItemsToCommand);
	
		    var TransferAllItemsFromCommand = TransferItemsFromCommand.extend({
		        canExecute: function() {
		            var sourceListBox = this.getSourceListBox();
	
		            return (sourceListBox ? sourceListBox.items().filter(ENABLED_ITEM_SELECTOR).length > 0 : false);
		        },
	
		        getItems: function() {
		            var sourceListBox = this.getSourceListBox();
		            return sourceListBox ? sourceListBox.items() : $();
		        },
	
		        getUpdatedSelection: noop,
		        updateSelection: noop
		    });
		    CommandFactory.current.register(TRANSFER_ALL_FROM, TransferAllItemsFromCommand);
	
		    var ToolBar = Class.extend({
		        init: function(element, options) {
		            var that = this;
	
		            that.element = $(element).addClass(TOOLBAR_CLASS);
		            that.options = extend({}, that.options, options);
		            that.listBox = that.options.listBox;
	
		            that._initTemplates();
		            that._createTools();
		            that._updateToolStates();
		            that._attachEventHandlers();
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that._detachEventHandlers();
		            kendo.destroy(that.element);
		            that.element.remove();
		            that.element = null;
		        },
	
		        options: {
		            position: RIGHT,
		            tools: []
		        },
	
		        _initTemplates: function() {
		            this.templates = {
		                tool: kendoTemplate(
		                    "<li>" +
		                        "<a href='\\\\#' class='k-button k-button-icon' data-command='#= command #' title='#= text #' aria-label='#= text #' role='button'>" +
		                            "<span class='k-icon #= iconClass #'></span>" +
		                        "</a>" +
		                    "</li>")
		            };
		        },
	
		        _createTools: function() {
		            var that = this;
		            var tools = that.options.tools;
		            var toolsLength = tools.length;
		            var toolsMessages = that.options.messages.tools;
		            var toolList = that._createToolList();
		            var tool;
		            var i;
	
		            for (i = 0; i < toolsLength; i++) {
		                tool = extend({}, ToolBar.defaultTools[tools[i]], { text: toolsMessages[tools[i]] });
	
		                if (tool) {
		                    toolList.append($(that.templates.tool(tool)));
		                }
		            }
	
		            that.element.append(toolList);
		        },
	
		        _createToolList: function() {
		            return $("<ul class='k-reset' />");
		        },
	
		        _attachEventHandlers: function() {
		            var that = this;
	
		            that.element.on(CLICK, TOOL_SELECTOR, proxy(that._onToolClick, that));
		        },
	
		        _detachEventHandlers: function() {
		            this.element.off(NS).find("*").off(NS);
		        },
	
		        _onToolClick: function(e) {
		            e.preventDefault();
	
		            this._executeToolCommand($(e.currentTarget).data(COMMAND));
		        },
	
		        _executeToolCommand: function(command) {
		            var that = this;
		            var listBox = that.listBox;
	
		            if (listBox) {
		                listBox._executeCommand(command);
		            }
		        },
	
		        _updateToolStates: function() {
		            var that = this;
		            var tools = that.options.tools;
		            var toolsLength = tools.length;
		            var i;
	
		            for (i = 0; i < toolsLength; i++) {
		                that._updateToolState(tools[i]);
		            }
		        },
	
		        _updateToolState: function(toolName) {
		            var that = this;
		            var command = CommandFactory.current.create(toolName, { listBox: that.listBox });
		            var toolElement = that.element.find("[data-command='" + toolName + "']")[0];
	
		            if (toolElement && command && command.canExecute) {
		                if (command.canExecute()) {
		                    $(toolElement).removeClass(DISABLED_STATE_CLASS).removeAttr(TABINDEX);
		                } else {
		                    $(toolElement).addClass(DISABLED_STATE_CLASS).attr(TABINDEX, "-1");
		                }
		            }
		        }
		    });
	
		    ToolBar.defaultTools = {
		        remove: {
		            command: REMOVE,
		            iconClass: "k-i-x"
		        },
		        moveUp: {
		            command: MOVE_UP,
		            iconClass: "k-i-arrow-60-up"
		        },
		        moveDown: {
		            command: MOVE_DOWN,
		            iconClass: "k-i-arrow-60-down"
		        },
		        transferTo: {
		            command: TRANSFER_TO,
		            iconClass: "k-i-arrow-60-right"
		        },
		        transferFrom: {
		            command: TRANSFER_FROM,
		            iconClass: "k-i-arrow-60-left"
		        },
		        transferAllTo: {
		            command: TRANSFER_ALL_TO,
		            iconClass: "k-i-arrow-double-60-right"
		        },
		        transferAllFrom: {
		            command: TRANSFER_ALL_FROM,
		            iconClass: "k-i-arrow-double-60-left"
		        }
		    };
	
		    extend(ListBox, {
		        ToolBar: ToolBar
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1213);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1213:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "maskedtextbox",
		    name: "MaskedTextBox",
		    category: "web",
		    description: "The MaskedTextBox widget allows to specify a mask type on an input field.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var global = window;
		    var min = global.Math.min;
		    var kendo = global.kendo;
		    var caret = kendo.caret;
		    var keys = kendo.keys;
		    var ui = kendo.ui;
		    var Widget = ui.Widget;
		    var NS = ".kendoMaskedTextBox";
		    var proxy = $.proxy;
		    var setTimeout = window.setTimeout;
	
		    var STATEDISABLED = "k-state-disabled";
		    var STATEINVALID = "k-state-invalid";
		    var DISABLED = "disabled";
		    var READONLY = "readonly";
		    var CHANGE = "change";
		    var MOUSEUP = "mouseup";
		    var DROP = "drop";
		    var KEYDOWN = "keydown";
		    var PASTE = "paste";
		    var INPUT = "input";
	
		    function ns(name) { return name + NS; }
	
		    var INPUT_EVENT_NAME = ns(kendo.support.propertyChangeEvent ? "propertychange" : INPUT);
	
		    function stringDiffStart(str1, str2) {
		        var i = 0;
		        while (i < str2.length) {
		            if (str1[i] !== str2[i]) {
		                break;
		            }
		            i++;
		        }
	
		        return i;
		    }
		    var MaskedTextBox = Widget.extend({
		        init: function(element, options) {
		            var that = this;
		            var DOMElement;
	
		            Widget.fn.init.call(that, element, options);
	
		            that._rules = $.extend({}, that.rules, that.options.rules);
	
		            element = that.element;
		            DOMElement = element[0];
	
		            that._wrapper();
		            that._tokenize();
		            that._form();
	
		            that.element
		                .addClass("k-textbox")
		                .attr("autocomplete", "off")
		                .on("focus" + NS, function() {
		                    var value = DOMElement.value;
	
		                    if (!value) {
		                        DOMElement.value = that._old = that._emptyMask;
		                    } else {
		                        that._togglePrompt(true);
		                    }
	
		                    that._oldValue = value;
	
		                    that._timeoutId = setTimeout(function() {
		                        caret(element, 0, value ? that._maskLength : 0);
		                    });
		                })
		                .on("focusout" + NS, function() {
		                    var value = element.val();
	
		                    clearTimeout(that._timeoutId);
		                    DOMElement.value = that._old = "";
	
		                    if (value !== that._emptyMask) {
		                        DOMElement.value = that._old = value;
		                    }
	
		                    that._change();
		                    that._togglePrompt();
		                });
	
		             var disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
	
		             if (disabled) {
		                 that.enable(false);
		             } else {
		                 that.readonly(element.is("[readonly]"));
		             }
	
		             that.value(that.options.value || element.val());
	
		             that._validationIcon = $("<span class='k-icon k-i-warning'></span>")
		                .insertAfter(element);
	
		             kendo.notify(that);
		        },
	
		        options: {
		            name: "MaskedTextBox",
		            clearPromptChar: false,
		            unmaskOnPost: false,
		            promptChar: "_",
		            culture: "",
		            rules: {},
		            value: "",
		            mask: ""
		        },
	
		        events: [
		            CHANGE
		        ],
	
		        rules: {
		            "0": /\d/,
		            "9": /\d|\s/,
		            "#": /\d|\s|\+|\-/,
		            "L": /[a-zA-Z]/,
		            "?": /[a-zA-Z]|\s/,
		            "&": /\S/,
		            "C": /./,
		            "A": /[a-zA-Z0-9]/,
		            "a": /[a-zA-Z0-9]|\s/
		        },
	
		        setOptions: function(options) {
		            var that = this;
	
		            Widget.fn.setOptions.call(that, options);
	
		            that._rules = $.extend({}, that.rules, that.options.rules);
	
		            that._tokenize();
	
		            this._unbindInput();
		            this._bindInput();
	
		            that.value(that.element.val());
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.element.off(NS);
	
		            if (that._formElement) {
		                that._formElement.off("reset", that._resetHandler);
		                that._formElement.off("submit", that._submitHandler);
		            }
	
		            Widget.fn.destroy.call(that);
		        },
	
		        raw: function() {
		            var unmasked = this._unmask(this.element.val(), 0);
		            return unmasked.replace(new RegExp(escapeRegExp(this.options.promptChar), "g"), "");
		        },
	
		        value: function(value) {
		            var element = this.element;
		            var emptyMask = this._emptyMask;
	
		            if (value === undefined) {
		                return this.element.val();
		            }
	
		            if (value === null) {
		                value = "";
		            }
	
		            if (!emptyMask) {
		                this._oldValue = value;
		                element.val(value);
		                return;
		            }
	
		            value = this._unmask(value + "");
	
		            element.val(value ? emptyMask : "");
	
		            this._mask(0, this._maskLength, value);
		            this._unmaskedValue = null;
	
		            value = element.val();
		            this._oldValue = value;
	
		            if (kendo._activeElement() !== element) {
		                if (value === emptyMask) {
		                    element.val("");
		                } else {
		                    this._togglePrompt();
		                }
		            }
		        },
	
		        _togglePrompt: function(show) {
		            var DOMElement = this.element[0];
		            var value = DOMElement.value;
	
		            if (this.options.clearPromptChar) {
		                if (!show) {
		                    value = value.replace(new RegExp(escapeRegExp(this.options.promptChar), "g"), " ");
		                } else {
		                    value = this._oldValue;
		                }
	
		                DOMElement.value = this._old = value;
		            }
		        },
	
		        readonly: function(readonly) {
		            this._editable({
		                readonly: readonly === undefined ? true : readonly,
		                disable: false
		            });
		        },
	
		        enable: function(enable) {
		            this._editable({
		                readonly: false,
		                disable: !(enable = enable === undefined ? true : enable)
		            });
		        },
	
		        _bindInput: function() {
		            var that = this;
	
		            if (that._maskLength) {
		                if(that.options.$angular) {//detach "input" event in angular scenario to keep the ng-model consistent and updated only when the change event of the textbox is raised.
		                    that.element.off(INPUT);
		                }
		                that.element
		                    .on(ns(KEYDOWN), proxy(that._keydown, that))
		                    .on(ns(DROP), proxy(that._drop, that))
		                    .on(ns(CHANGE), proxy(that._trackChange, that))
		                    .on(INPUT_EVENT_NAME, proxy(that._inputHandler, that));
	
	
		                if (kendo.support.browser.msie) {
		                    var version = kendo.support.browser.version;
		                    if (version > 8 && version < 11) {
		                        var events = [ns(MOUSEUP), ns(DROP), ns(KEYDOWN), ns(PASTE)].join(" ");
		                        that.element.on(events, proxy(that._legacyIEInputHandler, that));
		                    }
		                }
		            }
		        },
	
		        _unbindInput: function() {
		            var events = [INPUT_EVENT_NAME, ns(KEYDOWN), ns(MOUSEUP), ns(DROP), ns(PASTE)].join(" ");
	
		            this.element.off(events);
		        },
	
		        _editable: function(options) {
		            var that = this;
		            var element = that.element;
		            var wrapper = that.wrapper;
		            var disable = options.disable;
		            var readonly = options.readonly;
	
		            that._unbindInput();
	
		            if (!readonly && !disable) {
		                element.removeAttr(DISABLED)
		                       .removeAttr(READONLY);
	
		                wrapper.removeClass(STATEDISABLED);
	
		                that._bindInput();
		            } else {
		                element.attr(DISABLED, disable)
		                       .attr(READONLY, readonly);
	
		                wrapper.toggleClass(STATEDISABLED, disable);
		            }
		        },
	
		        _change: function() {
		            var that = this;
		            var value = that.value();
	
		            if (value !== that._oldValue) {
		                that._oldValue = value;
	
		                that.trigger(CHANGE);
		                that.element.trigger(CHANGE);
		            }
		            else if (value === "" && that.__changing) {//ensure change is raised when empty value (mask is stripped from input content) for consistent ngjs model update
		                that.element.trigger(CHANGE);
		            }
		        },
	
		        inputChange: function(backward) {
		            var that = this;
		            var old = that._old;
		            var element = that.element[0];
		            var value = element.value;
		            var selection = caret(element);
		            var cursor = selection[1];
		            var lengthDiff = value.length - old.length;
		            var mobile = kendo.support.mobileOS;
	
		            if (that.__dropping && lengthDiff < 0) {//dropping in same input on WebKit is raised once for the removal phase and once for the adding phase
		                return;
		            }
	
		            if (lengthDiff === -1 && mobile.android && mobile.browser === "chrome") {
		                backward = true;
		            }
	
		            var contentStart = min(cursor, stringDiffStart(value, old));
		            var content = value.substring(contentStart, cursor);
	
		            element.value = value.substring(0, contentStart) + that._emptyMask.substring(contentStart);
	
		            var caretPos = that._mask(contentStart, cursor, content);
		            var endContent = that._trimStartPromptChars(value.substring(cursor), min(lengthDiff, caretPos - contentStart));
	
		            var unmasked = that._unmask(endContent, old.length - endContent.length);
		            that._mask(caretPos, caretPos, unmasked);
	
		            if (backward) {
		                caretPos = that._findCaretPosBackwards(contentStart);
		            }
	
		            caret(element, caretPos);
	
		            //clean-up flags
		            that.__dropping = false;
		        },
	
		        _trimStartPromptChars: function(content, count) {
		            var promptChar = this.options.promptChar;
	
		            while (count-- > 0 && content.indexOf(promptChar) === 0) {
		                content = content.substring(1);
		            }
	
		            return content;
		        },
	
		        _findCaretPosBackwards: function(pos) {
		            var caretStart = this._find(pos, true);
		            if (caretStart < pos) {
		                caretStart += 1;
		            }
	
		            return caretStart;
		        },
	
		        _inputHandler: function() {
		            if (kendo._activeElement() !== this.element[0]) {
		                return;
		            }
	
		            this.inputChange(this.__backward);
		        },
	
		        _legacyIEInputHandler: function(e) {
		            var that = this;
		            var input = that.element[0];
		            var value = input.value;
		            var type = e.type;
	
		            that.__pasting = (type === "paste");
	
		            setTimeout(function() {
		                if(type === "mouseup" && that.__pasting) {
		                    return;
		                }
		                if (input.value && input.value !== value) {
		                    that.inputChange(that.__backward);
		                }
		            });
		        },
	
		        _trackChange: function() {
		            var that = this;
	
		            that.__changing = true;
		            setTimeout(function() { that.__changing = false; });
		        },
	
		        _form: function() {
		            var that = this;
		            var element = that.element;
		            var formId = element.attr("form");
		            var form = formId ? $("#" + formId) : element.closest("form");
	
		            if (form[0]) {
		                that._resetHandler = function() {
		                    setTimeout(function() {
		                        that.value(element[0].value);
		                    });
		                };
	
		                that._submitHandler = function() {
		                    that.element[0].value = that._old = that.raw();
		                };
	
		                if (that.options.unmaskOnPost) {
		                    form.on("submit", that._submitHandler);
		                }
	
		                that._formElement = form.on("reset", that._resetHandler);
		            }
		        },
	
		        _keydown: function(e) {
		            var key = e.keyCode;
	
		            this.__backward = key === keys.BACKSPACE;
	
		            if (key === keys.ENTER) {
		                this._change();
		            }
		        },
	
		        _drop: function() {
		            this.__dropping = true;
		        },
	
		        _find: function(idx, backward) {
		            var value = this.element.val() || this._emptyMask;
		            var step = 1;
	
		            if (backward === true) {
		                step = -1;
		            }
	
		            while (idx > -1 || idx <= this._maskLength) {
		                if (value.charAt(idx) !== this.tokens[idx]) {
		                    return idx;
		                }
	
		                idx += step;
		            }
	
		            return -1;
		        },
	
		        _mask: function(start, end, value, backward) {
		            var element = this.element[0];
		            var current = element.value || this._emptyMask;
		            var empty = this.options.promptChar;
		            var valueLength;
		            var chrIdx = 0;
		            var unmasked;
		            var chr;
		            var idx;
	
		            start = this._find(start, backward);
	
		            if (start > end) {
		                end = start;
		            }
	
		            unmasked = this._unmask(current.substring(end), end);
		            value = this._unmask(value, start);
		            valueLength = value.length;
	
		            if (value) {
		                unmasked = unmasked.replace(new RegExp("^_{0," + valueLength + "}"), "");
		            }
	
		            value += unmasked;
		            current = current.split("");
		            chr = value.charAt(chrIdx);
	
		            while (start < this._maskLength) {
		                current[start] = chr || empty;
		                chr = value.charAt(++chrIdx);
	
		                if (idx === undefined && chrIdx > valueLength) {
		                    idx = start;
		                }
	
		                start = this._find(start + 1);
		            }
	
		            element.value = this._old = current.join("");
	
		            if (kendo._activeElement() === element) {
		                if (idx === undefined) {
		                    idx = this._maskLength;
		                }
	
		                caret(element, idx);
		            }
	
		            return idx;
		        },
	
		        _unmask: function(value, idx) {
		            if (!value) {
		                return "";
		            }
	
		            if (this._unmaskedValue === value) {
		                return this._unmaskedValue;
		            }
		            value = (value + "").split("");
	
		            var chr;
		            var token;
		            var chrIdx = 0;
		            var tokenIdx = idx || 0;
	
		            var empty = this.options.promptChar;
	
		            var valueLength = value.length;
		            var tokensLength = this.tokens.length;
	
		            var result = "";
	
		            while (tokenIdx < tokensLength) {
		                chr = value[chrIdx];
		                token = this.tokens[tokenIdx];
	
		                if (chr === token || chr === empty) {
		                    result += chr === empty ? empty : "";
	
		                    chrIdx += 1;
		                    tokenIdx += 1;
		                } else if (typeof token !== "string") {
		                    if ((token && token.test && token.test(chr)) || ($.isFunction(token) && token(chr))) {
		                        result += chr;
		                        tokenIdx += 1;
		                    } else {
		                        if (valueLength === 1) {
		                            this._blinkInvalidState();
		                        }
		                    }
	
		                    chrIdx += 1;
		                } else {
		                    tokenIdx += 1;
		                }
	
		                if (chrIdx >= valueLength) {
		                    break;
		                }
		            }
		            this._unmaskedValue = result;
		            return result;
		        },
	
		        _wrapper: function () {
		            var that = this;
		            var element = that.element;
		            var DOMElement = element[0];
	
		            var wrapper = element.wrap("<span class='k-widget k-maskedtextbox'></span>").parent();
		            wrapper[0].style.cssText = DOMElement.style.cssText;
		            DOMElement.style.width = "100%";
		            that.wrapper = wrapper.addClass(DOMElement.className);
		        },
	
		        _blinkInvalidState: function () {
		            var that = this;
	
		            that.wrapper.addClass(STATEINVALID);
		            clearTimeout(that._invalidStateTimeout);
		            that._invalidStateTimeout = setTimeout(proxy(that._removeInvalidState, that), 100);
		        },
	
		        _removeInvalidState: function () {
		            var that = this;
	
		            that.wrapper.removeClass(STATEINVALID);
		            that._invalidStateTimeout = null;
		        },
	
		        _tokenize: function() {
		            var tokens = [];
		            var tokenIdx = 0;
	
		            var mask = this.options.mask || "";
		            var maskChars = mask.split("");
		            var length = maskChars.length;
		            var idx = 0;
		            var chr;
		            var rule;
	
		            var emptyMask = "";
		            var promptChar = this.options.promptChar;
		            var numberFormat = kendo.getCulture(this.options.culture).numberFormat;
		            var rules = this._rules;
	
		            for (; idx < length; idx++) {
		                chr = maskChars[idx];
		                rule = rules[chr];
	
		                if (rule) {
		                    tokens[tokenIdx] = rule;
		                    emptyMask += promptChar;
		                    tokenIdx += 1;
		                } else {
		                    if (chr === "." || chr === ",") {
		                        chr = numberFormat[chr];
		                    } else if (chr === "$") {
		                        chr = numberFormat.currency.symbol;
		                    } else if (chr === "\\") {
		                        idx += 1;
		                        chr = maskChars[idx];
		                    }
	
		                    chr = chr.split("");
	
		                    for (var i = 0, l = chr.length; i < l; i++) {
		                        tokens[tokenIdx] = chr[i];
		                        emptyMask += chr[i];
		                        tokenIdx += 1;
		                    }
		                }
		            }
	
		            this.tokens = tokens;
	
		            this._emptyMask = emptyMask;
		            this._maskLength = emptyMask.length;
		        }
		    });
	
		    function escapeRegExp(text) {
		        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
		    }
	
		    ui.plugin(MaskedTextBox);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1260);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1260:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "panelbar",
		    name: "PanelBar",
		    category: "web",
		    description: "The PanelBar widget displays hierarchical data as a multi-level expandable panel bar.",
		    depends: [ "core", "data", "data.odata" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        keys = kendo.keys,
		        extend = $.extend,
		        proxy = $.proxy,
		        each = $.each,
		        isArray = $.isArray,
		        template = kendo.template,
		        Widget = ui.Widget,
		        HierarchicalDataSource = kendo.data.HierarchicalDataSource,
		        excludedNodesRegExp = /^(ul|a|div)$/i,
		        NS = ".kendoPanelBar",
		        IMG = "img",
		        HREF = "href",
		        LAST = "k-last",
		        LINK = "k-link",
		        LINKSELECTOR = "." + LINK,
		        ERROR = "error",
		        ITEM = ".k-item",
		        GROUP = ".k-group",
		        VISIBLEGROUP = GROUP + ":visible",
		        IMAGE = "k-image",
		        FIRST = "k-first",
		        CHANGE = "change",
		        EXPAND = "expand",
		        SELECT = "select",
		        CONTENT = "k-content",
		        ACTIVATE = "activate",
		        COLLAPSE = "collapse",
		        DATABOUND = "dataBound",
		        MOUSEENTER = "mouseenter",
		        MOUSELEAVE = "mouseleave",
		        CONTENTLOAD = "contentLoad",
		        UNDEFINED = "undefined",
		        ACTIVECLASS = "k-state-active",
		        GROUPS = "> .k-panel",
		        CONTENTS = "> .k-content",
		        STRING = "string",
		        FOCUSEDCLASS = "k-state-focused",
		        DISABLEDCLASS = "k-state-disabled",
		        SELECTEDCLASS = "k-state-selected",
		        SELECTEDSELECTOR = "." + SELECTEDCLASS,
		        HIGHLIGHTCLASS = "k-state-highlight",
		        ACTIVEITEMSELECTOR = ITEM + ":not(.k-state-disabled)",
		        clickableItems = "> " + ACTIVEITEMSELECTOR + " > " + LINKSELECTOR + ", .k-panel > " + ACTIVEITEMSELECTOR + " > " + LINKSELECTOR,
		        disabledItems = ITEM + ".k-state-disabled > .k-link",
		        selectableItems = "> li > " + SELECTEDSELECTOR + ", .k-panel > li > " + SELECTEDSELECTOR,
		        defaultState = "k-state-default",
		        ARIA_DISABLED = "aria-disabled",
		        ARIA_EXPANDED = "aria-expanded",
		        ARIA_HIDDEN = "aria-hidden",
		        ARIA_SELECTED = "aria-selected",
		        VISIBLE = ":visible",
		        EMPTY = ":empty",
		        SINGLE = "single",
		        bindings = {
		            text: "dataTextField",
		            url: "dataUrlField",
		            spriteCssClass: "dataSpriteCssClassField",
		            imageUrl: "dataImageUrlField"
		        },
		        itemIcon,
		        rendering = {
		        aria: function(item) {
		            var attr = "";
	
		            if (item.items || item.content || item.contentUrl || item.expanded) {
		                attr += ARIA_EXPANDED + "='" + (item.expanded ? "true" : "false") + "' ";
		            }
	
		            if (item.enabled === false) {
		                attr += ARIA_DISABLED + "='true'";
		            }
	
		            return attr;
		        },
	
		    wrapperCssClass: function (group, item) {
		        var result = "k-item",
		            index = item.index;
	
		        if (item.enabled === false) {
		            result += " " + DISABLEDCLASS;
		        } else if (item.expanded === true) {
		            result += " " + ACTIVECLASS;
		        } else {
		            result += " k-state-default";
		        }
	
		        if (index === 0) {
		            result += " k-first";
		        }
	
		        if (index == group.length - 1) {
		            result += " k-last";
		        }
	
		        if (item.cssClass) {
		            result += " " + item.cssClass;
		        }
	
		        return result;
		    },
	
		    textClass: function(item, group) {
		        var result = LINK;
	
		        if (group.firstLevel) {
		            result += " k-header";
		        }
	
		        if (item.selected) {
		            result += " " + SELECTEDCLASS;
		        }
	
		        return result;
		    },
		    textAttributes: function(url) {
		        return url ? " href='" + url + "'" : "";
		    },
		    arrowClass: function(item) {
		        var result = "k-icon";
	
		        result += item.expanded ? " k-panelbar-collapse k-i-arrow-60-up" : " k-panelbar-expand k-i-arrow-60-down";
	
		        return result;
		    },
		    text: function(item) {
		         return item.encoded === false ? item.text : kendo.htmlEncode(item.text);
		    },
		    groupAttributes: function(group) {
		        return group.expanded !== true ? " style='display:none'" : "";
		    },
		    ariaHidden: function(group){
		        return group.expanded !== true;
		    },
		    groupCssClass: function() {
		        return "k-group k-panel";
		    },
		    contentAttributes: function(content) {
		        return content.item.expanded !== true ? " style='display:none'" : "";
		    },
		    content: function(item) {
		        return item.content ? item.content : item.contentUrl ? "" : "&nbsp;";
		    },
		    contentUrl: function(item) {
		        return item.contentUrl ? 'href="' + item.contentUrl + '"' : "";
		    }
		};
	
		    function updateFirstLast (items) {
		        items = $(items);
	
		        items.filter(".k-first:not(:first-child)").removeClass(FIRST);
		        items.filter(".k-last:not(:last-child)").removeClass(LAST);
		        items.filter(":first-child").addClass(FIRST);
		        items.filter(":last-child").addClass(LAST);
		    }
	
		     function updateItemHtml(item) {
		        var wrapper = item,
		            group = item.children("ul"),
		            toggleButton = wrapper.children(".k-link").children(".k-icon");
	
		        if (item.hasClass("k-panelbar")) {
		            return;
		        }
	
		        if (!toggleButton.length && group.length) {
		            toggleButton = $("<span class='k-icon' />").appendTo(wrapper);
		        } else if (!group.length || !group.children().length) {
		            toggleButton.remove();
		            group.remove();
		        }
		     }
	
		    itemIcon = function(item) {
		        return item.children("span").children(".k-icon");
		    };
	
		    var PanelBar = kendo.ui.DataBoundWidget.extend({
		        init: function(element, options) {
		            var that = this,
		                content,
		                hasDataSource;
	
		           if (isArray(options)) {
		                options = { dataSource: options };
		           }
	
		            hasDataSource = options && !!options.dataSource;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.wrapper = that.element.addClass("k-widget k-reset k-header k-panelbar");
		            options = that.options;
	
		            if (element[0].id) {
		                that._itemId = element[0].id + "_pb_active";
		            }
	
		            that._tabindex();
	
		            that._accessors();
	
		            that._dataSource();
	
		            that._templates();
	
		            that._initData(hasDataSource);
	
		            that._updateClasses();
	
		            that._animations(options);
	
		            element
		                .on("click" + NS, clickableItems, function(e) {
		                    if (that._click($(e.currentTarget))) {
		                        e.preventDefault();
		                    }
		                })
		                .on(MOUSEENTER  + NS + " " + MOUSELEAVE + NS, clickableItems, that._toggleHover)
		                .on("click" + NS, disabledItems, false)
		                .on("click" + NS, ".k-request-retry", proxy(that._retryRequest, that))
		                .on("keydown" + NS, $.proxy(that._keydown, that))
		                .on("focus" + NS, function() {
		                    var item = that.select();
		                    that._current(item[0] ? item : that._first());
		                })
		                .on("blur" + NS, function() {
		                    that._current(null);
		                })
		                .attr("role", "menu");
	
		            content = element.find("li." + ACTIVECLASS + " > ." + CONTENT);
	
		            if (content[0]) {
		                that.expand(content.parent(), false);
		            }
	
		            if (!options.dataSource) {
		                that._angularCompile();
		            }
	
		            kendo.notify(that);
		        },
	
		        events: [
		            EXPAND,
		            COLLAPSE,
		            SELECT,
		            ACTIVATE,
		            CHANGE,
		            ERROR,
		            DATABOUND,
		            CONTENTLOAD
		        ],
		        options: {
		            name: "PanelBar",
		            dataSource: {},
		            animation: {
		                expand: {
		                    effects: "expand:vertical",
		                    duration: 200
		                },
		                collapse: { // if collapse animation effects are defined, they will be used instead of expand.reverse
		                    duration: 200
		                }
		            },
		            messages: {
		                loading: "Loading...",
		                requestFailed: "Request failed.",
		                retry: "Retry"
		            },
		            autoBind: true,
		            loadOnDemand: true,
		            expandMode: "multiple",
		            template: "",
		            dataTextField: null
		        },
	
		        _angularCompile: function() {
		            var that = this;
		            that.angular("compile", function(){
		                return {
		                    elements: that.element.children("li"),
		                    data: [{ dataItem: that.options.$angular}]
		                };
		            });
		        },
	
		        _angularCompileElements: function(html, items) {
		            var that = this;
		            that.angular("compile", function(){
		                return {
		                    elements: html,
		                    data: $.map(items, function(item) {
		                        return [{ dataItem: item }];
		                    })
		                };
		            });
		        },
	
		        _angularCleanup: function() {
		            var that = this;
	
		            that.angular("cleanup", function(){
		                return { elements: that.element.children("li") };
		            });
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this.element.off(NS);
	
		            this._angularCleanup();
	
		            kendo.destroy(this.element);
		        },
	
		        _initData: function(hasDataSource) {
		            var that = this;
	
		            if (hasDataSource) {
		                that.element.empty();
		                 if (that.options.autoBind) {
		                    that._progress(true);
	
		                    that.dataSource.fetch();
		                 }
		            }
		        },
	
		        _templates: function() {
		            var that = this,
		                options = that.options,
		                fieldAccessor = proxy(that._fieldAccessor, that);
	
		              if (options.template && typeof options.template == STRING) {
		                    options.template = template(options.template);
		              } else if (!options.template) {
		                     options.template = template(
		                        "# var text = " + fieldAccessor("text") + "(data.item); #" +
		                        "# if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {#" +
		                            "#= text #" +
		                        "# } else { #" +
		                            "#: text #" +
		                        "# } #"
		                    );
		                }
	
		            that.templates = {
		                content: template(
		                    "<div role='region' class='k-content'#= contentAttributes(data) #>#= content(item) #</div>"
		                ),
		                group: template(
		                    "<ul role='group' aria-hidden='#= ariaHidden(group) #' class='#= groupCssClass(group) #'#= groupAttributes(group) #>" +
		                        "#= renderItems(data) #" +
		                    "</ul>"
		                ),
		                itemWrapper: template(
		                     "# var url = " + fieldAccessor("url") + "(item); #" +
		                     "# var imageUrl = " + fieldAccessor("imageUrl") + "(item); #" +
		                     "# var spriteCssClass = " + fieldAccessor("spriteCssClass") + "(item); #" +
		                     "# var contentUrl = contentUrl(item); #" +
		                     "# var tag = url||contentUrl ? 'a' : 'span'; #" +
	
		                    "<#= tag # class='#= textClass(item, group) #' #= contentUrl ##= textAttributes(url) #>" +
		                        "# if (imageUrl) { #" +
		                              "<img class='k-image' alt='' src='#= imageUrl #' />" +
		                        "# } #" +
	
		                        "# if (spriteCssClass) { #" +
		                            "<span class='k-sprite #= spriteCssClass #'></span>" +
		                        "# } #" +
		                      "#= data.panelBar.options.template(data) #" +
		                      "#= arrow(data) #" +
		                    "</#= tag #>"
		                ),
	
		                item: template(
		                    "<li role='menuitem' #=aria(item)#class='#= wrapperCssClass(group, item) #'" +
		                         kendo.attr("uid") + "='#= item.uid #'>" +
		                        "#= itemWrapper(data) #" +
		                        "# if (item.items && item.items.length > 0) { #" +
		                        "#= subGroup({ items: item.items, panelBar: panelBar, group: { expanded: item.expanded } }) #" +
		                        "# } else if (item.content || item.contentUrl) { #" +
		                        "#= renderContent(data) #" +
		                        "# } #" +
		                    "</li>"
		                ),
		                loading: template("<div class='k-item'><span class='k-icon k-i-loading'></span> #: data.messages.loading #</div>"),
		                retry: template(
		                    "#: data.messages.requestFailed # " +
		                    "<button class='k-button k-request-retry'>#: data.messages.retry #</button>"
		                ),
		                arrow: template("<span class='#= arrowClass(item) #'></span>"),
		                empty: template("")
		            };
		        },
	
		        setOptions: function(options) {
		            var animation = this.options.animation;
	
		            this._animations(options);
	
		            options.animation = extend(true, animation, options.animation);
	
		            if ("dataSource" in options) {
		                this.setDataSource(options.dataSource);
		            }
	
		            Widget.fn.setOptions.call(this, options);
		        },
	
		        expand: function (element, useAnimation) {
		            var that = this,
		                animBackup = {};
	
		            element = this.element.find(element);
	
		            if (that._animating && element.find("ul").is(":visible")) {
		                that.one("complete", function() {
		                    setTimeout(function() {
		                        that.expand(element);
		                    });
		                });
		                return;
		            }
		            that._animating = true;
	
		            useAnimation = useAnimation !== false;
	
		            element.each(function (index, item) {
		                item = $(item);
		                var wrapper = element.children(".k-group,.k-content");
	
		                if (!wrapper.length) {
		                    wrapper =  that._addGroupElement(element);
		                }
	
		                 var groups = wrapper.add(item.find(CONTENTS));
	
		                if (!item.hasClass(DISABLEDCLASS) && groups.length > 0) {
	
		                    if (that.options.expandMode == SINGLE && that._collapseAllExpanded(item)) {
		                        return that;
		                    }
	
		                    element.find("." + HIGHLIGHTCLASS).removeClass(HIGHLIGHTCLASS);
		                    item.addClass(HIGHLIGHTCLASS);
	
		                    if (!useAnimation) {
		                        animBackup = that.options.animation;
		                        that.options.animation = { expand: { effects: {} }, collapse: { hide: true, effects: {} } };
		                    }
	
		                    if (!that._triggerEvent(EXPAND, item)) {
		                        that._toggleItem(item, false, false);
		                    }
	
		                    if (!useAnimation) {
		                        that.options.animation = animBackup;
		                    }
		                }
		            });
	
		            return that;
		        },
	
		        collapse: function (element, useAnimation) {
		            var that = this,
		                animBackup = {};
	
		            that._animating = true;
	
		            useAnimation = useAnimation !== false;
		            element = that.element.find(element);
	
		            element.each(function (index, item) {
		                item = $(item);
		                var groups = item.find(GROUPS).add(item.find(CONTENTS));
	
		                if (!item.hasClass(DISABLEDCLASS) && groups.is(VISIBLE)) {
		                    item.removeClass(HIGHLIGHTCLASS);
	
		                    if (!useAnimation) {
		                        animBackup = that.options.animation;
		                        that.options.animation = { expand: { effects: {} }, collapse: { hide: true, effects: {} } };
		                    }
	
		                    if (!that._triggerEvent(COLLAPSE, item)) {
		                        that._toggleItem(item, true);
		                    }
	
		                    if (!useAnimation) {
		                        that.options.animation = animBackup;
		                    }
		                }
	
		            });
		            return that;
		        },
	
		         updateArrow: function(items) {
		                var that = this;
	
		                items = $(items);
		                items.children(LINKSELECTOR).children(".k-panelbar-collapse, .k-panelbar-expand").remove();
	
		                items
		                    .filter(function() {
		                        var dataItem = that.dataItem(this);
	
		                        if (!dataItem) {
		                            return $(this).find(".k-panel").length > 0 ||
		                                $(this).find(".k-content").length > 0;
		                        }
	
		                        return dataItem.hasChildren || dataItem.content || dataItem.contentUrl;
		                    })
		                    .children(".k-link:not(:has([class*=k-i-arrow]))")
		                    .each(function () {
		                        var item = $(this),
		                            parent = item.parent();
	
		                        item.append("<span class='k-icon " + (parent.hasClass(ACTIVECLASS) ? " k-panelbar-collapse k-i-arrow-60-up" : " k-panelbar-expand k-i-arrow-60-down") + "'/>");
		                    });
		         },
	
		        _accessors: function() {
		            var that = this,
		                options = that.options,
		                i, field, textField,
		                element = that.element;
	
		            for (i in bindings) {
		                field = options[bindings[i]];
		                textField = element.attr(kendo.attr(i + "-field"));
	
		                if (!field && textField) {
		                    field = textField;
		                }
	
		                if (!field) {
		                    field = i;
		                }
	
		                if (!isArray(field)) {
		                    field = [field];
		                }
	
		                options[bindings[i]] = field;
		            }
		        },
	
		        _progress: function(item, showProgress) {
		            var element = this.element;
		            var loadingText = this.templates.loading({ messages: this.options.messages });
	
		            if (arguments.length == 1) {
		                showProgress = item;
	
		                if (showProgress) {
		                    element.html(loadingText);
		                } else {
		                    element.empty();
		                }
		            }
		            else {
		                itemIcon(item).toggleClass("k-i-loading", showProgress).removeClass("k-i-refresh");
		            }
		        },
	
		        _refreshRoot: function(items) {
		            var that = this;
		            var parent = that.element;
		            var  groupData = {
		                firstLevel: true,
		                expanded: true,
		                length: parent.children().length
		            };
	
		            this.element.empty();
	
		            var rootItemsHtml = $.map(items, function(value, idx) {
		                    if (typeof value === "string") {
		                        return $(value);
		                    } else {
		                        value.items = [];
		                        return $(that.renderItem({
		                            group: groupData,
		                            item: extend(value, { index: idx })
		                        }));
		                    }
		            });
	
		            this.element.append(rootItemsHtml);
		            this._angularCompileElements(rootItemsHtml, items);
		        },
	
		        _refreshChildren: function(item, parentNode) {
		            var i, children, child;
	
		            parentNode.children(".k-group").empty();
		            var items = item.children.data();
		            if (!items.length) {
		                updateItemHtml(parentNode);
		                children = parentNode.children(".k-group").children("li");
		                this._angularCompileElements(children, items);
		            } else {
		                this.append(item.children, parentNode);
	
		                if(this.options.loadOnDemand){
		                    this._toggleGroup(parentNode.children(".k-group"), false);
		                }
		                children = parentNode.children(".k-group").children("li");
	
		                for (i = 0; i < children.length; i++) {
		                    child = children.eq(i);
		                    this.trigger("itemChange", {
		                        item: child,
		                        data: this.dataItem(child),
		                        ns: ui
		                    });
		                }
		            }
		        },
	
		        findByUid: function(uid) {
		            var items = this.element.find(".k-item");
		            var uidAttr = kendo.attr("uid");
		            var result;
	
		            for (var i = 0; i < items.length; i++) {
		                if (items[i].getAttribute(uidAttr) == uid) {
		                    result = items[i];
		                    break;
		                }
		            }
	
		            return $(result);
		        },
	
		        refresh: function(e) {
		            var options = this.options;
		            var node = e.node;
		            var action = e.action;
		            var items = e.items;
		            var parentNode = this.wrapper;
		            var loadOnDemand = options.loadOnDemand;
	
		            if (e.field) {
		                if (!items[0] || !items[0].level) {
		                    return;
		                }
	
		                return this._updateItems(items, e.field);
		            }
	
		            if (node) {
		                parentNode = this.findByUid(node.uid);
		                this._progress(parentNode, false);
		            }
		            if (action == "add") {
		                this._appendItems(e.index, items, parentNode);
		            } else if (action == "remove") {
		                this.remove(this.findByUid(items[0].uid));
		            } else if (action == "itemchange") {
		                this._updateItems(items);
		            } else if (action == "itemloaded") {
		                this._refreshChildren(node, parentNode);
		            } else {
		                this._refreshRoot(items);
		            }
	
		            if (action != "remove") {
		                for (var k = 0; k < items.length; k++) {
	
		                    if (!loadOnDemand || items[k].expanded) {
		                        var tempItem = items[k];
		                        if (this._hasChildItems(tempItem)) {
		                                tempItem.load();
		                        }
		                    }
		                }
		            }
	
		            this.trigger(DATABOUND, { node: node ? parentNode : undefined });
		        },
	
		        _error: function(e) {
		            var node = e.node && this.findByUid(e.node.uid);
		            var retryHtml = this.templates.retry({ messages: this.options.messages });
	
		            if (node) {
		                this._progress(node, false);
		                this._expanded(node, false);
		                itemIcon(node).addClass("k-i-refresh");
		                e.node.loaded(false);
		            } else {
		                this._progress(false);
		                this.element.html(retryHtml);
		            }
		        },
	
		        _retryRequest: function(e) {
		            e.preventDefault();
	
		            this.dataSource.fetch();
		        },
	
		         items: function() {
		            return this.element.find(".k-item > span:first-child");
		        },
	
		        setDataSource: function(dataSource) {
		            var options = this.options;
	
		            options.dataSource = dataSource;
	
		            this._dataSource();
	
		            if (this.options.autoBind) {
		                this._progress(true);
		                this.dataSource.fetch();
		            }
		        },
	
		        _bindDataSource: function() {
		            this._refreshHandler = proxy(this.refresh, this);
		            this._errorHandler = proxy(this._error, this);
	
		            this.dataSource.bind(CHANGE, this._refreshHandler);
		            this.dataSource.bind(ERROR, this._errorHandler);
		        },
	
		        _unbindDataSource: function() {
		            var dataSource = this.dataSource;
	
		            if (dataSource) {
		                dataSource.unbind(CHANGE, this._refreshHandler);
		                dataSource.unbind(ERROR, this._errorHandler);
		            }
		        },
	
		        // generates accessor function for a given field name, honoring the data*Field arrays
		        _fieldAccessor: function(fieldName) {
		            var fieldBindings = this.options[bindings[fieldName]] || [],
		                count = fieldBindings.length,
		                result = "(function(item) {";
	
		            if (count === 0) {
		                result += "return item['" + fieldName + "'];";
		            } else {
		                result += "var levels = [" +
		                            $.map(fieldBindings, function(x) {
		                                return "function(d){ return " + kendo.expr(x) + "}";
		                            }).join(",") + "];";
		                result += "if(item.level){return levels[Math.min(item.level(), " + count + "-1)](item);}else";
		                result += "{return levels["+ count + "-1](item)}";
		            }
	
		            result += "})";
	
		            return result;
		        },
	
		        _dataSource: function() {
		            var that = this,
		                options = that.options,
		                dataSource = options.dataSource;
	
		            if (!dataSource) {
		                return;
		            }
	
		            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;
	
		            that._unbindDataSource();
	
		            if (!dataSource.fields) {
		                dataSource.fields = [
		                    { field: "text" },
		                    { field: "url" },
		                    { field: "spriteCssClass" },
		                    { field: "imageUrl" }
		                ];
		            }
	
		            that.dataSource = HierarchicalDataSource.create(dataSource);
	
		            that._bindDataSource();
		        },
	
		        _appendItems: function(index, items, parentNode) {
		            var that = this, children, wrapper;
	
		              if (parentNode.hasClass("k-panelbar")) {
		                  children = parentNode.children("li");
		                  wrapper = parentNode;
		              } else {
		                  wrapper = parentNode.children(".k-group");
		                  if (!wrapper.length) {
		                      wrapper =  that._addGroupElement(parentNode);
		                  }
	
		                  children = wrapper.children("li");
		              }
	
		             var  groupData = {
		                firstLevel: parentNode.hasClass("k-panelbar"),
		                expanded: true,
		                length: children.length
		             };
	
		             var itemsHtml = $.map(items, function(value, idx) {
		                    if (typeof value === "string") {
		                        return $(value);
		                    } else {
		                        return $(that.renderItem({
		                            group: groupData,
		                            item: extend(value, { index: idx })
		                        }));
		                    }
		            });
	
		              if (typeof index == UNDEFINED) {
		                   index = children.length;
		              }
	
		              for (var i = 0; i < itemsHtml.length; i++) {
		                  if (children.length === 0 || index === 0) {
		                      wrapper.append(itemsHtml[i]);
		                  } else {
		                       itemsHtml[i].insertAfter(children[index - 1]);
		                  }
		               }
	
		            that._angularCompileElements(itemsHtml, items);
		              if (that.dataItem(parentNode)) {
		                  that.dataItem(parentNode).hasChildren = true;
		                  that.updateArrow(parentNode);
		              }
		        },
	
		        _updateItems: function (items, field) {
		            var that = this;
		            var i, node, nodeWrapper, item;
		            var context = { panelBar: that.options, item: item, group: {} };
		            var render = field != "expanded";
	
		            if (field == "selected") {
		                if(items[0][field]){
		                    var currentNode = that.findByUid(items[0].uid);
	
		                    if (!currentNode.hasClass(DISABLEDCLASS)) {
		                        that.select(currentNode, true);
		                    }
		                }else{
		                    that.clearSelection();
		                }
		            } else {
		                var elements = $.map(items, function(item) {
		                    return that.findByUid(item.uid);
		                });
	
		                if (render) {
		                    that.angular("cleanup", function() { return { elements: elements }; });
		                }
	
		                for (i = 0; i < items.length; i++) {
		                    context.item = item = items[i];
		                    context.panelBar = that;
		                    nodeWrapper = elements[i];
		                    node = nodeWrapper.parent();
		                    if (render) {
		                        context.group = {
		                            firstLevel: node.hasClass("k-panelbar"),
		                            expanded: nodeWrapper.parent().hasClass(ACTIVECLASS),
		                            length: nodeWrapper.children().length
		                        };
	
		                        nodeWrapper.children(".k-link").remove();
		                        nodeWrapper.prepend(that.templates.itemWrapper(extend(context,
		                            {
		                                arrow: item.hasChildren || item.content || item.contentUrl ? that.templates.arrow : that.templates.empty
		                            },
		                            rendering)));
		                    }
	
		                    if (field == "expanded") {
		                        that._toggleItem(nodeWrapper, !item[field], item[field] ? "true": true);
		                    } else if (field == "enabled") {
		                        that.enable(nodeWrapper, item[field]);
		                         if (!item[field]) {
		                            if (item.selected) {
		                                item.set("selected", false);
		                            }
		                         }
		                    }
	
		                    if (nodeWrapper.length) {
		                        this.trigger("itemChange", { item: nodeWrapper, data: item, ns: ui });
		                    }
		                }
	
		                if (render) {
		                    that.angular("compile", function(){
		                        return {
		                            elements: elements,
		                            data: $.map(items, function(item) {
		                                return [{ dataItem: item }];
		                            })
		                        };
		                    });
		                }
		            }
		        },
	
		        _toggleDisabled: function(element, enable) {
		            element = this.element.find(element);
		            element
		                .toggleClass(defaultState, enable)
		                .toggleClass(DISABLEDCLASS, !enable)
		                .attr(ARIA_DISABLED, !enable);
		        },
	
		       dataItem: function(item) {
		            var uid = $(item).closest(ITEM).attr(kendo.attr("uid")),
		                dataSource = this.dataSource;
	
		            return dataSource && dataSource.getByUid(uid);
		       },
	
		       select: function (element, skipChange) {
		           var that = this;
	
		            if (element === undefined) {
		                return that.element.find(selectableItems).parent();
		            }
	
		            element = that.element.find(element);
	
		            if (!element.length) {
		                this._updateSelected(element);
		            } else {
		                element
		                    .each(function () {
		                        var item = $(this),
		                            link = item.children(LINKSELECTOR);
	
		                        if (item.hasClass(DISABLEDCLASS)) {
		                            return that;
		                        }
	
		                        that._updateSelected(link, skipChange);
		                    });
		            }
	
		            return that;
		        },
	
		        clearSelection: function() {
		            this.select($());
		        },
	
		        enable: function (element, state) {
		            this._toggleDisabled(element, state !== false);
	
		            return this;
		        },
	
		        disable: function (element) {
		            this._toggleDisabled(element, false);
	
		            return this;
		        },
	
		        append: function (item, referenceItem) {
		            referenceItem = this.element.find(referenceItem);
	
		            var inserted = this._insert(item, referenceItem, referenceItem.length ? referenceItem.find(GROUPS) : null);
	
		            each(inserted.items, function () {
		                inserted.group.append(this);
		                updateFirstLast(this);
		            });
	
		            this.updateArrow(referenceItem);
		            updateFirstLast(inserted.group.find(".k-first, .k-last"));
		            inserted.group.height("auto");
	
		            return this;
		        },
	
		        insertBefore: function (item, referenceItem) {
		            referenceItem = this.element.find(referenceItem);
	
		            var inserted = this._insert(item, referenceItem, referenceItem.parent());
	
		            each(inserted.items, function () {
		                referenceItem.before(this);
		                updateFirstLast(this);
		            });
	
		            updateFirstLast(referenceItem);
		            inserted.group.height("auto");
	
		            return this;
		        },
	
		        insertAfter: function (item, referenceItem) {
		            referenceItem = this.element.find(referenceItem);
	
		            var inserted = this._insert(item, referenceItem, referenceItem.parent());
	
		            each(inserted.items, function () {
		                referenceItem.after(this);
		                updateFirstLast(this);
		            });
	
		            updateFirstLast(referenceItem);
		            inserted.group.height("auto");
	
		            return this;
		        },
	
		        remove: function (element) {
		            element = this.element.find(element);
	
		            var that = this,
		                parent = element.parentsUntil(that.element, ITEM),
		                group = element.parent("ul");
	
		            element.remove();
	
		            if (group && !group.hasClass("k-panelbar") && !group.children(ITEM).length) {
		                group.remove();
		            }
	
		            if (parent.length) {
		                parent = parent.eq(0);
	
		                that.updateArrow(parent);
		                updateFirstLast(parent);
		            }
	
		            return that;
		        },
	
		        reload: function (element) {
		            var that = this;
		            element = that.element.find(element);
	
		            element.each(function () {
		                var item = $(this);
	
		                that._ajaxRequest(item, item.children("." + CONTENT), !item.is(VISIBLE));
		            });
		        },
	
		        _first: function() {
		            return this.element.children(ACTIVEITEMSELECTOR).first();
		        },
	
		        _last: function() {
		            var item = this.element.children(ACTIVEITEMSELECTOR).last(),
		                group = item.children(VISIBLEGROUP);
	
		            if (group[0]) {
		                return group.children(ACTIVEITEMSELECTOR).last();
		            }
		            return item;
		        },
	
		        _current: function(candidate) {
		            var that = this,
		                focused = that._focused,
		                id = that._itemId;
	
		            if (candidate === undefined) {
		                return focused;
		            }
	
		            that.element.removeAttr("aria-activedescendant");
	
		            if (focused && focused.length) {
		                if (focused[0].id === id) {
		                    focused.removeAttr("id");
		                }
	
		                focused
		                    .children(LINKSELECTOR)
		                    .removeClass(FOCUSEDCLASS);
		            }
	
		            if ($(candidate).length) {
		                id = candidate[0].id || id;
	
		                candidate.attr("id", id)
		                         .children(LINKSELECTOR)
		                         .addClass(FOCUSEDCLASS);
	
		                that.element.attr("aria-activedescendant", id);
		            }
	
		            that._focused = candidate;
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode,
		                current = that._current();
	
		            if (e.target != e.currentTarget) {
		                return;
		            }
	
		            if (key == keys.DOWN || key == keys.RIGHT) {
		                that._current(that._nextItem(current));
		                e.preventDefault();
		            } else if (key == keys.UP || key == keys.LEFT) {
		                that._current(that._prevItem(current));
		                e.preventDefault();
		            } else if (key == keys.ENTER || key == keys.SPACEBAR) {
		                that._click(current.children(LINKSELECTOR));
		                e.preventDefault();
		            } else if (key == keys.HOME) {
		                that._current(that._first());
		                e.preventDefault();
		            } else if (key == keys.END) {
		                that._current(that._last());
		                e.preventDefault();
		            }
		        },
	
		        _nextItem: function(item) {
		            if (!item) {
		                return this._first();
		            }
	
		            var group = item.children(VISIBLEGROUP),
		                next = item.nextAll(":visible").first();
	
		            if (group[0]) {
		                next = group.children("." + FIRST);
		            }
	
		            if (!next[0]) {
		                next = item.parent(VISIBLEGROUP).parent(ITEM).next();
		            }
	
		            if (!next[0]) {
		                next = this._first();
		            }
	
		            if (next.hasClass(DISABLEDCLASS)) {
		                next = this._nextItem(next);
		            }
	
		            return next;
		        },
	
		        _prevItem: function(item) {
		            if (!item) {
		                return this._last();
		            }
	
		            var prev = item.prevAll(":visible").first(),
		                result;
	
		            if (!prev[0]) {
		                prev = item.parent(VISIBLEGROUP).parent(ITEM);
		                if (!prev[0]) {
		                    prev = this._last();
		                }
		            } else {
		                result = prev;
		                while (result[0]) {
		                    result = result.children(VISIBLEGROUP).children("." + LAST);
		                    if (result[0]) {
		                        prev = result;
		                    }
		                }
		            }
	
		            if (prev.hasClass(DISABLEDCLASS)) {
		                prev = this._prevItem(prev);
		            }
	
		            return prev;
		        },
	
		        _insert: function (item, referenceItem, parent) {
		            var that = this,
		                items,
		                plain = $.isPlainObject(item),
		                isReferenceItem = referenceItem && referenceItem[0],
		                groupData;
	
		            if (!isReferenceItem) {
		                parent = that.element;
		            }
	
		            groupData = {
		                firstLevel: parent.hasClass("k-panelbar"),
		                expanded: $(referenceItem).hasClass(ACTIVECLASS),
		                length: parent.children().length
		            };
	
		            if (isReferenceItem && !parent.length) {
		                parent = $(that.renderGroup({ group: groupData, options: that.options })).appendTo(referenceItem);
		            }
	
		            if (plain || $.isArray(item) || item instanceof HierarchicalDataSource) { // is JSON or HierarchicalDataSource
		                if (item instanceof HierarchicalDataSource) {
		                   item = item.data();
		                }
	
		                items = $.map(plain ? [item] : item, function(value, idx) {
		                    if (typeof value === "string") {
		                        return $(value);
		                    } else {
		                        return $(that.renderItem({
		                            group: groupData,
		                            item: extend(value, { index: idx })
		                        }));
		                    }
		                });
		                if (isReferenceItem) {
		                    var dataItem = that.dataItem(referenceItem);
		                    if (dataItem) {
		                        dataItem.hasChildren = true;
		                        referenceItem
		                            .attr(ARIA_EXPANDED, dataItem.expanded)
		                            .not("." + ACTIVECLASS)
		                            .children("ul")
		                            .attr(ARIA_HIDDEN, !dataItem.expanded);
		                    }else{
		                        referenceItem.attr(ARIA_EXPANDED, false);
		                    }
		                }
		            } else {
		                if (typeof item == "string" && item.charAt(0) != "<") {
		                    items = that.element.find(item);
		                } else {
		                    items = $(item);
		                }
		                that._updateItemsClasses(items);
		            }
	
		            if (!item.length){
		                item = [item];
		            }
	
		            that._angularCompileElements(items, item);
		            return { items: items, group: parent };
		        },
	
		        _toggleHover: function(e) {
		            var target = $(e.currentTarget);
	
		            if (!target.parents("li." + DISABLEDCLASS).length) {
		                target.toggleClass("k-state-hover", e.type == MOUSEENTER);
		            }
		        },
	
		        _updateClasses: function() {
		            var that = this,
		                panels, items, expanded, panelsParent, dataItem;
	
		            panels = that.element
		                         .find("li > ul")
		                         .not(function () { return $(this).parentsUntil(".k-panelbar", "div").length; })
		                         .addClass("k-group k-panel")
		                         .attr("role", "group");
	
		            panelsParent = panels.parent();
		            dataItem = that.dataItem(panelsParent);
		            expanded = (dataItem && dataItem.expanded) || false;
	
		            panels.parent()
		                  .attr(ARIA_EXPANDED, expanded)
		                  .not("." + ACTIVECLASS)
		                  .children("ul")
		                  .attr(ARIA_HIDDEN, !expanded)
		                  .hide();
	
		            items = that.element.add(panels).children();
	
		            that._updateItemsClasses(items);
		            that.updateArrow(items);
		            updateFirstLast(items);
		        },
	
		        _updateItemsClasses: function(items) {
		            var length = items.length,
		                idx = 0;
	
		            for(; idx < length; idx++) {
		                this._updateItemClasses(items[idx], idx);
		            }
		        },
	
		        _updateItemClasses: function(item, index) {
		            var selected = this._selected,
		                contentUrls = this.options.contentUrls,
		                url = contentUrls && contentUrls[index],
		                root = this.element[0],
		                wrapElement, link;
	
		            item = $(item).addClass("k-item").attr("role", "menuitem");
	
		            if (kendo.support.browser.msie) {  // IE10 doesn't apply list-style: none on invisible items otherwise.
		                item.css("list-style-position", "inside")
		                    .css("list-style-position", "");
		            }
	
		            item
		                .children(IMG)
		                .addClass(IMAGE);
	
		            link = item
		                    .children("a")
		                    .addClass(LINK);
	
		            if (link[0]) {
		                link.attr("href", url); //url can be undefined
	
		                link.children(IMG)
		                    .addClass(IMAGE);
		            }
	
		            item
		                .filter(":not([disabled]):not([class*=k-state])")
		                .addClass("k-state-default");
	
		            item
		                .filter("li[disabled]")
		                .addClass("k-state-disabled")
		                .attr(ARIA_DISABLED, true)
		                .removeAttr("disabled");
	
		            item
		                .children("div")
		                .addClass(CONTENT)
		                .attr("role", "region")
		                .attr(ARIA_HIDDEN, true)
		                .hide()
		                .parent()
		                .attr(ARIA_EXPANDED, false);
	
		            link = item.children(SELECTEDSELECTOR);
		            if (link[0]) {
		                if (selected) {
		                    selected.removeAttr(ARIA_SELECTED)
		                            .children(SELECTEDSELECTOR)
		                            .removeClass(SELECTEDCLASS);
		                }
	
		                link.addClass(SELECTEDCLASS);
		                this._selected = item.attr(ARIA_SELECTED, true);
		            }
	
		            if (!item.children(LINKSELECTOR)[0]) {
		                wrapElement = "<span class='" + LINK + "'/>";
		                if (contentUrls && contentUrls[index] && item[0].parentNode == root) {
		                    wrapElement = '<a class="k-link k-header" href="' + contentUrls[index] + '"/>';
		                }
	
		                item
		                    .contents()      // exclude groups, real links, templates and empty text nodes
		                    .filter(function() { return (!this.nodeName.match(excludedNodesRegExp) && !(this.nodeType == 3 && !$.trim(this.nodeValue))); })
		                    .wrapAll(wrapElement);
		            }
	
		            if (item.parent(".k-panelbar")[0]) {
		                item
		                    .children(LINKSELECTOR)
		                    .addClass("k-header");
		            }
		        },
	
		        _click: function (target) {
		            var that = this,
		                element = that.element,
		                prevent, contents, href, isAnchor;
	
		            if (target.parents("li." + DISABLEDCLASS).length) {
		                return;
		            }
	
		            if (target.closest(".k-widget")[0] != element[0]) {
		                return;
		            }
	
		            var link = target.closest(LINKSELECTOR),
		                item = link.closest(ITEM);
	
		            that._updateSelected(link);
	
		            var wrapper = item.children(".k-group,.k-content");
		            var dataItem = this.dataItem(item);
	
		            if (!wrapper.length && ((that.options.loadOnDemand && dataItem && dataItem.hasChildren) ||
		             this._hasChildItems(item) || item.content || item.contentUrl)) {
		                wrapper =  that._addGroupElement(item);
		            }
	
		            contents = item.find(GROUPS).add(item.find(CONTENTS));
		            href = link.attr(HREF);
		            isAnchor = href && (href.charAt(href.length - 1) == "#" || href.indexOf("#" + that.element[0].id + "-") != -1);
		            prevent = !!(isAnchor || contents.length);
	
		            if (contents.data("animating")) {
		                return prevent;
		            }
	
		            if (that._triggerEvent(SELECT, item)) {
		                prevent = true;
		            }
	
		            if (prevent === false) {
		                return;
		            }
	
		            if (that.options.expandMode == SINGLE) {
		                if (that._collapseAllExpanded(item)) {
		                    return prevent;
		                }
		            }
	
		            if (contents.length) {
		                var visibility = contents.is(VISIBLE);
	
		                if (!that._triggerEvent(!visibility ? EXPAND : COLLAPSE, item)) {
		                    prevent = that._toggleItem(item, visibility);
		                }
		            }
	
		            return prevent;
		        },
		        _hasChildItems: function (item) {
		            return (item.items && item.items.length > 0) || item.hasChildren;
		        },
	
		        _toggleItem: function (element, isVisible, expanded) {
		            var that = this,
		                childGroup = element.find(GROUPS),
		                link = element.find(LINKSELECTOR),
		                url = link.attr(HREF),
		                prevent, content,
		                dataItem = that.dataItem(element),
		                notVisible = !isVisible;
	
		            var loaded = dataItem && dataItem.loaded();
	
		            if (dataItem && !expanded && dataItem.expanded !== notVisible) {
		                dataItem.set("expanded", notVisible);
		                prevent = dataItem.hasChildren || !!dataItem.content || !!dataItem.contentUrl;
		                return prevent;
		            }
	
		            if (dataItem && (!expanded || expanded === "true") &&  !loaded && !dataItem.content && !dataItem.contentUrl) {
		                 if (that.options.loadOnDemand) {
		                     this._progress(element, true);
		                 }
	
		                 element.children(".k-group,.k-content").remove();
		                 prevent = dataItem.hasChildren;
	
		                 dataItem.load();
		             } else {
		                   if (childGroup.length) {
		                        this._toggleGroup(childGroup, isVisible);
		                        prevent = true;
		                   } else {
		                        content = element.children("."  + CONTENT);
	
		                        if (content.length) {
		                            prevent = true;
	
		                            if (!content.is(EMPTY) || url === undefined) {
		                                that._toggleGroup(content, isVisible);
		                            } else {
		                                that._ajaxRequest(element, content, isVisible);
		                            }
		                        }
		                    }
		             }
	
		            return prevent;
		        },
	
		        _toggleGroup: function (element, visibility) {
		            var that = this,
		                animationSettings = that.options.animation,
		                animation = animationSettings.expand,
		                hasCollapseAnimation = animationSettings.collapse && "effects" in animationSettings.collapse,
		                collapse = extend({}, animationSettings.expand, animationSettings.collapse);
	
		            if (!hasCollapseAnimation) {
		                collapse = extend(collapse, {reverse: true});
		            }
	
		            if (element.is(VISIBLE) != visibility) {
		                that._animating = false;
		                return;
		            }
	
		            element.attr(ARIA_HIDDEN, !!visibility);
	
		            element.parent()
		                .attr(ARIA_EXPANDED, !visibility)
		                .toggleClass(ACTIVECLASS, !visibility)
		                .find("> .k-link > .k-panelbar-collapse,> .k-link > .k-panelbar-expand")
		                    .toggleClass("k-i-arrow-60-up", !visibility)
		                    .toggleClass("k-panelbar-collapse", !visibility)
		                    .toggleClass("k-i-arrow-60-down", visibility)
		                    .toggleClass("k-panelbar-expand", visibility);
		            if (visibility) {
		                animation = extend(collapse, { hide: true });
	
		                animation.complete = function() {
		                    that._animationCallback();
		                };
		            } else {
		                animation = extend( { complete: function (element) {
		                        that._triggerEvent(ACTIVATE, element.closest(ITEM));
		                        that._animationCallback();
		                    } }, animation );
		            }
	
		            element
		                .kendoStop(true, true)
		                .kendoAnimate( animation );
		        },
	
		        _animationCallback: function() {
		            var that = this;
		            that.trigger("complete");
		            that._animating = false;
		        },
	
		        _addGroupElement: function(element) {
		            var group = $('<ul role="group" aria-hidden="true" class="k-group k-panel" style="display:none"></ul>');
	
		            element.append(group);
		            return group;
		        },
	
		        _collapseAllExpanded: function (item) {
		            var that = this, children, stopExpand = false;
	
		            var groups = item.find(GROUPS).add(item.find(CONTENTS));
	
		            if (groups.is(VISIBLE)) {
		                stopExpand = true;
		            }
	
		            if (!(groups.is(VISIBLE) || groups.length === 0)) {
		                children = item.siblings();
		                children.find(GROUPS).add(children.find(CONTENTS))
		                        .filter(function () { return $(this).is(VISIBLE); })
		                        .each(function (index, content) {
		                            content = $(content);
	
		                            stopExpand = that._triggerEvent(COLLAPSE, content.closest(ITEM));
		                            if (!stopExpand) {
		                                that._toggleGroup(content, true);
		                            }
		                        });
	
		                 that.one("complete", function() {
		                    setTimeout(function() {
		                        children.each(function (index, child) {
		                            var dataItem = that.dataItem(child);
	
		                            if(dataItem){
		                                dataItem.set("expanded", false);
		                            }
		                        });
		                    });
		                });
		            }
	
		            return stopExpand;
		        },
	
		        _ajaxRequest: function (element, contentElement, isVisible) {
	
		            var that = this,
		                statusIcon = element.find(".k-panelbar-collapse, .k-panelbar-expand"),
		                link = element.find(LINKSELECTOR),
		                loadingIconTimeout = setTimeout(function () {
		                    statusIcon.addClass("k-i-loading");
		                }, 100),
		                data = {},
		                url = link.attr(HREF);
	
		            $.ajax({
		                type: "GET",
		                cache: false,
		                url: url,
		                dataType: "html",
		                data: data,
	
		                error: function (xhr, status) {
		                    statusIcon.removeClass("k-i-loading");
		                    if (that.trigger(ERROR, { xhr: xhr, status: status })) {
		                        this.complete();
		                    }
		                },
	
		                complete: function () {
		                    clearTimeout(loadingIconTimeout);
		                    statusIcon.removeClass("k-i-loading");
		                },
	
		                success: function (data) {
		                    function getElements(){
		                        return { elements: contentElement.get() };
		                    }
		                    try {
		                        that.angular("cleanup", getElements);
		                        contentElement.html(data);
		                        that.angular("compile", getElements);
		                    } catch (e) {
		                        var console = window.console;
	
		                        if (console && console.error) {
		                            console.error(e.name + ": " + e.message + " in " + url);
		                        }
		                        this.error(this.xhr, "error");
		                    }
	
		                    that._toggleGroup(contentElement, isVisible);
	
		                    that.trigger(CONTENTLOAD, { item: element[0], contentElement: contentElement[0] });
		                }
		            });
		        },
	
		        _triggerEvent: function (eventName, element) {
		            var that = this;
	
		            return that.trigger(eventName, { item: element[0] });
		        },
	
		        _updateSelected: function(link, skipChange) {
		            var that = this,
		                element = that.element,
		                item = link.parent(ITEM),
		                selected = that._selected,
		                dataItem = that.dataItem(item);
	
		            if (selected) {
		                selected.removeAttr(ARIA_SELECTED);
		            }
	
		            that._selected = item.attr(ARIA_SELECTED, true);
	
		            element.find(selectableItems).removeClass(SELECTEDCLASS);
		            element.find("> ." + HIGHLIGHTCLASS + ", .k-panel > ." + HIGHLIGHTCLASS).removeClass(HIGHLIGHTCLASS);
	
		            link.addClass(SELECTEDCLASS);
		            link.parentsUntil(element, ITEM).filter(":has(.k-header)").addClass(HIGHLIGHTCLASS);
		            that._current(item[0] ? item : null);
		            if(dataItem){
		                 dataItem.set("selected", true);
		            }
	
		            if(!skipChange){
		                that.trigger(CHANGE);
		            }
		        },
	
		        _animations: function(options) {
		            if (options && ("animation" in options) && !options.animation) {
		                options.animation = { expand: { effects: {} }, collapse: { hide: true, effects: {} } };
		            }
		        },
	
		        renderItem: function (options) {
		            var that = this;
		                options = extend({ panelBar: that, group: {} }, options);
	
		            var empty = that.templates.empty,
		                item = options.item;
	
		            return that.templates.item(extend(options, {
		                itemWrapper: that.templates.itemWrapper,
		                renderContent: that.renderContent,
		                arrow: that._hasChildItems(item) || item.content || item.contentUrl ? that.templates.arrow : empty,
		                subGroup: !options.loadOnDemand || item.expanded ? that.renderGroup : empty
		            }, rendering));
		        },
	
		        renderGroup: function(options) {
		            var that = this;
		            var templates = that.templates || options.panelBar.templates;
	
		            return templates.group(extend({
		                renderItems: function(options) {
		                    var html = "",
		                        i = 0,
		                        items = options.items,
		                        len = items ? items.length : 0,
		                        group = extend({ length: len }, options.group);
	
		                    for (; i < len; i++) {
		                        html += options.panelBar.renderItem(extend(options, {
		                            group: group,
		                            item: extend({ index: i }, items[i])
		                        }));
		                    }
	
		                    return html;
		                }
		            }, options, rendering));
		        },
	
		        renderContent: function(options) {
		            return options.panelBar.templates.content(extend(options, rendering));
		        }
		    });
	
		kendo.ui.plugin(PanelBar);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1273);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1273:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "responsive-panel",
		    name: "Responsive Panel",
		    category: "web",
		    description: "The Responsive Panel widget allows a panel of content to be hidden on mobile devices, available through a toggle button.",
		    depends: [ "core" ]
		};
	
		(function ($, undefined) {
		    var proxy = $.proxy;
		    var NS = ".kendoResponsivePanel";
		    var OPEN = "open";
		    var CLOSE = "close";
		    var ACTIVATE_EVENTS = "click" + NS +" touchstart" + NS;
		    var Widget = kendo.ui.Widget;
		    var ResponsivePanel = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this._guid = "_" + kendo.guid();
	
		            this._toggleHandler = proxy(this._toggleButtonClick, this);
		            this._closeHandler = proxy(this._close, this);
	
		            $(document.documentElement).on(ACTIVATE_EVENTS, this.options.toggleButton, this._toggleHandler);
	
		            this._registerBreakpoint();
	
		            this.element
		                .addClass("k-rpanel k-rpanel-" + this.options.orientation + " " + this._guid);
	
		            this._resizeHandler = proxy(this.resize, this, true);
		            $(window).on("resize" + NS, this._resizeHandler);
		        },
		        _mediaQuery:
		            "@media (max-width: #= breakpoint-1 #px) {" +
		                ".#= guid #.k-rpanel-animate.k-rpanel-left," +
		                ".#= guid #.k-rpanel-animate.k-rpanel-right {" +
		                    "-webkit-transition: -webkit-transform .2s ease-out;" +
		                    "-ms-transition: -ms-transform .2s ease-out;" +
		                    "transition: transform .2s ease-out;" +
		                "} " +
		                ".#= guid #.k-rpanel-top {" +
		                    "overflow: hidden;" +
		                "}" +
		                ".#= guid #.k-rpanel-animate.k-rpanel-top {" +
		                    "-webkit-transition: max-height .2s linear;" +
		                    "-ms-transition: max-height .2s linear;" +
		                    "transition: max-height .2s linear;" +
		                "}" +
		            "} " +
		            "@media (min-width: #= breakpoint #px) {" +
		                "#= toggleButton # { display: none; } " +
		                ".#= guid #.k-rpanel-left { float: left; } " +
		                ".#= guid #.k-rpanel-right { float: right; } " +
		                ".#= guid #.k-rpanel-left, .#= guid #.k-rpanel-right {" +
		                    "position: relative;" +
		                    "-webkit-transform: translateX(0);" +
		                    "-ms-transform: translateX(0);" +
		                    "transform: translateX(0);" +
		                    "-webkit-transform: translateX(0) translateZ(0);" +
		                    "-ms-transform: translateX(0) translateZ(0);" +
		                    "transform: translateX(0) translateZ(0);" +
		                "} " +
		                ".k-ie9 .#= guid #.k-rpanel-left { left: 0; } " +
		                ".#= guid #.k-rpanel-top { max-height: none; }" +
		            "}",
		        _registerBreakpoint: function() {
		            var options = this.options;
	
		            this._registerStyle(kendo.template(this._mediaQuery)({
		                breakpoint: options.breakpoint,
		                toggleButton: options.toggleButton,
		                guid: this._guid
		            }));
		        },
		        _registerStyle: function(cssText) {
		            var head = $("head,body")[0];
		            var style = document.createElement('style');
	
		            head.appendChild(style);
	
		            if (style.styleSheet){
		                style.styleSheet.cssText = cssText;
		            } else {
		                style.appendChild(document.createTextNode(cssText));
		            }
		        },
		        options: {
		            name: "ResponsivePanel",
		            orientation: "left",
		            toggleButton: ".k-rpanel-toggle",
		            breakpoint: 640,
		            autoClose: true
		        },
		        events: [
		            OPEN,
		            CLOSE
		        ],
		        _resize: function() {
		            this.element.removeClass("k-rpanel-animate k-rpanel-expanded");
	
		            $(document.documentElement).off(ACTIVATE_EVENTS, this._closeHandler);
		        },
		        _toggleButtonClick: function(e) {
		            e.preventDefault();
	
		            if (this.element.hasClass("k-rpanel-expanded")) {
		                this.close();
		            } else {
		                this.open();
		            }
		        },
		        open: function() {
		            if (!this.trigger(OPEN)) {
		                this.element.addClass("k-rpanel-animate k-rpanel-expanded");
	
		                if (this.options.autoClose) {
		                    $(document.documentElement).on(ACTIVATE_EVENTS, this._closeHandler);
		                }
		            }
		        },
		        close: function() {
		            if (!this.trigger(CLOSE)) {
		                this.element.addClass("k-rpanel-animate").removeClass("k-rpanel-expanded");
	
		                $(document.documentElement).off(ACTIVATE_EVENTS, this._closeHandler);
		            }
		        },
		        _close: function(e) {
		            var prevented = e.isDefaultPrevented();
		            var container = $(e.target).closest(this.options.toggleButton + ",.k-rpanel");
	
		            if (!container.length && !prevented) {
		                this.close();
		            }
		        },
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            $(window).off("resize" + NS, this._resizeHandler);
		            $(document.documentElement).off(ACTIVATE_EVENTS, this._closeHandler);
		        }
		    });
	
		    kendo.ui.plugin(ResponsivePanel);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1291);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1003:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(330);
	
	/***/ }),
	
	/***/ 1137:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(593);
	
	/***/ }),
	
	/***/ 1291:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1137) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "splitter",
		    name: "Splitter",
		    category: "web",
		    description: "The Splitter widget provides an easy way to create a dynamic layout of resizable and collapsible panes.",
		    depends: [ "resizable" ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        keys = kendo.keys,
		        extend = $.extend,
		        proxy = $.proxy,
		        Widget = ui.Widget,
		        pxUnitsRegex = /^\d+(\.\d+)?px$/i,
		        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
		        NS = ".kendoSplitter",
		        EXPAND = "expand",
		        COLLAPSE = "collapse",
		        CONTENTLOAD = "contentLoad",
		        ERROR = "error",
		        RESIZE = "resize",
		        LAYOUTCHANGE = "layoutChange",
		        HORIZONTAL = "horizontal",
		        VERTICAL = "vertical",
		        MOUSEENTER = "mouseenter",
		        CLICK = "click",
		        PANE = "pane",
		        MOUSELEAVE = "mouseleave",
		        FOCUSED = "k-state-focused",
		        KPANE = "k-" + PANE,
		        PANECLASS = "." + KPANE;
	
		    function isPercentageSize(size) {
		        return percentageUnitsRegex.test(size);
		    }
	
		    function isPixelSize(size) {
		        return pxUnitsRegex.test(size) || /^\d+$/.test(size);
		    }
	
		    function isFluid(size) {
		        return !isPercentageSize(size) && !isPixelSize(size);
		    }
	
		    function calculateSize(size, total) {
		        var output = parseInt(size, 10);
	
		        if (isPercentageSize(size)) {
		            output = Math.floor(output * total / 100);
		        }
	
		        return output;
		    }
	
		    function panePropertyAccessor(propertyName, triggersResize) {
		        return function(pane, value) {
		            var paneConfig = this.element.find(pane).data(PANE);
	
		            if (arguments.length == 1) {
		                return paneConfig[propertyName];
		            }
	
		            paneConfig[propertyName] = value;
	
		            if (triggersResize) {
		                var splitter = this.element.data("kendo" + this.options.name);
		                splitter.resize(true);
		            }
		        };
		    }
	
		    var Splitter = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                isHorizontal;
	
		            Widget.fn.init.call(that, element, options);
	
		            that.wrapper = that.element;
	
		            if(that.options.orientation){
		                isHorizontal = that.options.orientation.toLowerCase() != VERTICAL;
		            }
	
		            that.orientation = isHorizontal ? HORIZONTAL : VERTICAL;
		            that._dimension = isHorizontal ? "width" : "height";
		            that._keys = {
		                decrease: isHorizontal ? keys.LEFT : keys.UP,
		                increase: isHorizontal ? keys.RIGHT : keys.DOWN
		            };
	
		            that._resizeStep = 10;
	
		            that._marker = kendo.guid().substring(0, 8);
	
		            that._initPanes();
	
		            that.resizing = new PaneResizing(that);
	
		            that.element.triggerHandler("init" + NS);
		        },
		        events: [
		            EXPAND,
		            COLLAPSE,
		            CONTENTLOAD,
		            ERROR,
		            RESIZE,
		            LAYOUTCHANGE
		        ],
	
		        _addOverlays: function() {
		            this._panes().append("<div class='k-splitter-overlay k-overlay' />");
		        },
	
		        _removeOverlays: function() {
		            this._panes().children(".k-splitter-overlay").remove();
		        },
	
		        _attachEvents: function() {
		            var that = this,
		                orientation = that.options.orientation;
	
		            // do not use delegated events to increase performance of nested elements
		            that.element
		                .children(".k-splitbar-draggable-" + orientation)
		                    .on("keydown" + NS, proxy(that._keydown, that))
		                    .on("mousedown" + NS, function(e) { e.currentTarget.focus(); })
		                    .on("focus" + NS, function(e) { $(e.currentTarget).addClass(FOCUSED);  })
		                    .on("blur" + NS, function(e) { $(e.currentTarget).removeClass(FOCUSED);
		                        if (that.resizing) {
		                            that.resizing.end();
		                        }
		                    })
		                    .on(MOUSEENTER + NS, function() { $(this).addClass("k-splitbar-" + that.orientation + "-hover"); })
		                    .on(MOUSELEAVE + NS, function() { $(this).removeClass("k-splitbar-" + that.orientation + "-hover"); })
		                    .on("mousedown" + NS, proxy(that._addOverlays, that))
		                .end()
		                .children(".k-splitbar")
		                    .on("dblclick" + NS, proxy(that._togglePane, that))
		                    .children(".k-collapse-next, .k-collapse-prev").on(CLICK + NS, that._arrowClick(COLLAPSE)).end()
		                    .children(".k-expand-next, .k-expand-prev").on(CLICK + NS, that._arrowClick(EXPAND)).end()
		                .end();
	
		            $(window).on("resize" + NS + that._marker, proxy(that.resize, that, false));
		            $(document).on("mouseup" + NS + that._marker, proxy(that._removeOverlays, that));
		        },
	
		        _detachEvents: function() {
		            var that = this;
	
		            that.element
		                .children(".k-splitbar-draggable-" + that.orientation).off(NS).end()
		                .children(".k-splitbar").off("dblclick" + NS)
		                    .children(".k-collapse-next, .k-collapse-prev, .k-expand-next, .k-expand-prev").off(NS);
	
		            $(window).off(NS + that._marker);
		            $(document).off(NS + that._marker);
		        },
	
		        options: {
		            name: "Splitter",
		            orientation: HORIZONTAL,
		            panes: []
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this._detachEvents();
	
		            if (this.resizing) {
		                this.resizing.destroy();
		            }
	
		            kendo.destroy(this.element);
	
		            this.wrapper = this.element = null;
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode,
		                resizing = that.resizing,
		                target = $(e.currentTarget),
		                navigationKeys = that._keys,
		                increase = key === navigationKeys.increase,
		                decrease = key === navigationKeys.decrease,
		                pane;
	
		            if (increase || decrease) {
		                if (e.ctrlKey) {
		                    pane = target[decrease ? "next" : "prev"]();
	
		                    if (resizing && resizing.isResizing()) {
		                        resizing.end();
		                    }
	
		                    if (!pane[that._dimension]()) {
		                        that._triggerAction(EXPAND, pane);
		                    } else {
		                        that._triggerAction(COLLAPSE, target[decrease ? "prev" : "next"]());
		                    }
		                } else if (resizing) {
		                    resizing.move((decrease ? -1 : 1) * that._resizeStep, target);
		                }
		                e.preventDefault();
		            } else if (key === keys.HOME) {
		                resizing.move(-resizing._maxPosition, target);
		                e.preventDefault();
		            } else if (key === keys.END) {
		                resizing.move(resizing._maxPosition, target);
		                e.preventDefault();
		            } else if (key === keys.ENTER && resizing) {
		                resizing.end();
		                e.preventDefault();
		            }
		        },
	
		        _initPanes: function() {
		            var panesConfig = this.options.panes || [];
		            var that = this;
	
		            this.element
		                .addClass("k-widget").addClass("k-splitter")
		                .children()
		                    .each(function(i, pane) {
		                        if (pane.nodeName.toLowerCase() != "script") {
		                            that._initPane(pane, panesConfig[i]);
		                        }
		                    });
	
		            this.resize();
		        },
	
		        _initPane: function(pane, config) {
		            pane = $(pane)
		                .attr("role", "group")
		                .addClass(KPANE);
	
		            pane.data(PANE, config ? config : {})
		                .toggleClass("k-scrollable", config ? config.scrollable !== false : true);
	
		            this.ajaxRequest(pane);
		        },
	
		        ajaxRequest: function(pane, url, data) {
		            var that = this,
		                paneConfig;
	
		            pane = that.element.find(pane);
		            paneConfig = pane.data(PANE);
	
		            url = url || paneConfig.contentUrl;
	
		            if (url) {
		                pane.append("<span class='k-icon k-i-loading k-pane-loading' />");
	
		                if (kendo.isLocalUrl(url)) {
		                    jQuery.ajax({
		                        url: url,
		                        data: data || {},
		                        type: "GET",
		                        dataType: "html",
		                        success: function (data) {
		                            that.angular("cleanup", function(){ return { elements: pane.get() }; });
		                            pane.html(data);
		                            that.angular("compile", function(){ return { elements: pane.get() }; });
	
		                            that.trigger(CONTENTLOAD, { pane: pane[0] });
		                        },
		                        error: function (xhr, status) {
		                            that.trigger(ERROR, {
		                                pane: pane[0],
		                                status: status,
		                                xhr: xhr
		                            });
		                        }
		                    });
		                } else {
		                    pane.removeClass("k-scrollable")
		                        .html("<iframe src='" + url + "' frameborder='0' class='k-content-frame'>" +
		                                "This page requires frames in order to show content" +
		                              "</iframe>");
		                }
		            }
		        },
	
		        _triggerAction: function(type, pane) {
		            if (!this.trigger(type, { pane: pane[0] })) {
		                this[type](pane[0]);
		            }
		        },
	
		        _togglePane: function(e) {
		            var that = this,
		                target = $(e.target),
		                arrow;
	
		            if (target.closest(".k-splitter")[0] != that.element[0]) {
		                return;
		            }
	
		            arrow = target.children(".k-icon:not(.k-resize-handle)");
	
		            if (arrow.length !== 1) {
		                return;
		            }
	
		            if (arrow.is(".k-collapse-prev")) {
		                that._triggerAction(COLLAPSE, target.prev());
		            } else if (arrow.is(".k-collapse-next")) {
		                that._triggerAction(COLLAPSE, target.next());
		            } else if (arrow.is(".k-expand-prev")) {
		                that._triggerAction(EXPAND, target.prev());
		            } else if (arrow.is(".k-expand-next")) {
		                that._triggerAction(EXPAND, target.next());
		            }
		        },
		        _arrowClick: function (arrowType) {
		            var that = this;
	
		            return function(e) {
		                var target = $(e.target),
		                    pane;
	
		                if (target.closest(".k-splitter")[0] != that.element[0]) {
		                    return;
		                }
	
		                if (target.is(".k-" + arrowType + "-prev")) {
		                    pane = target.parent().prev();
		                } else {
		                    pane = target.parent().next();
		                }
		                that._triggerAction(arrowType, pane);
		            };
		        },
		        _updateSplitBar: function(splitbar, previousPane, nextPane) {
		            var catIconIf = function(iconType, condition) {
		                   return condition ? "<div class='k-icon " + iconType + "' />" : "";
		                },
		                orientation = this.orientation,
		                draggable = (previousPane.resizable !== false) && (nextPane.resizable !== false),
		                prevCollapsible = previousPane.collapsible,
		                prevCollapsed = previousPane.collapsed,
		                nextCollapsible = nextPane.collapsible,
		                nextCollapsed = nextPane.collapsed;
	
		            splitbar.addClass("k-splitbar k-state-default k-splitbar-" + orientation)
		                    .attr("role", "separator")
		                    .attr("aria-expanded", !(prevCollapsed || nextCollapsed))
		                    .removeClass("k-splitbar-" + orientation + "-hover")
		                    .toggleClass("k-splitbar-draggable-" + orientation,
		                        draggable && !prevCollapsed && !nextCollapsed)
		                    .toggleClass("k-splitbar-static-" + orientation,
		                        !draggable && !prevCollapsible && !nextCollapsible)
		                    .html(
		                        catIconIf("k-collapse-prev k-i-arrow-60-up", prevCollapsible && !prevCollapsed && !nextCollapsed && orientation == VERTICAL) +
		                        catIconIf("k-collapse-prev k-i-arrow-60-left", prevCollapsible && !prevCollapsed && !nextCollapsed && orientation == HORIZONTAL) +
		                        catIconIf("k-expand-prev k-i-arrow-60-down", prevCollapsible && prevCollapsed && !nextCollapsed && orientation == VERTICAL) +
		                        catIconIf("k-expand-prev k-i-arrow-60-right", prevCollapsible && prevCollapsed && !nextCollapsed && orientation == HORIZONTAL) +
		                        catIconIf("k-resize-handle k-i-hbar", draggable && orientation == VERTICAL) +
		                        catIconIf("k-resize-handle k-i-vbar", draggable && orientation == HORIZONTAL) +
		                        catIconIf("k-collapse-next k-i-arrow-60-down", nextCollapsible && !nextCollapsed && !prevCollapsed && orientation == VERTICAL) +
		                        catIconIf("k-collapse-next k-i-arrow-60-right", nextCollapsible && !nextCollapsed && !prevCollapsed && orientation == HORIZONTAL) +
		                        catIconIf("k-expand-next k-i-arrow-60-up", nextCollapsible && nextCollapsed && !prevCollapsed && orientation == VERTICAL) +
		                        catIconIf("k-expand-next k-i-arrow-60-left", nextCollapsible && nextCollapsed && !prevCollapsed && orientation == HORIZONTAL)
		                    );
	
		            if (!draggable && !prevCollapsible && !nextCollapsible) {
		                splitbar.removeAttr("tabindex");
		            }
		        },
		        _updateSplitBars: function() {
		            var that = this;
	
		            this.element.children(".k-splitbar").each(function() {
		                var splitbar = $(this),
		                    previousPane = splitbar.prevAll(PANECLASS).first().data(PANE),
		                    nextPane = splitbar.nextAll(PANECLASS).first().data(PANE);
	
		                if (!nextPane) {
		                    return;
		                }
	
		                that._updateSplitBar(splitbar, previousPane, nextPane);
		            });
		        },
		        _removeSplitBars: function() {
		            this.element.children(".k-splitbar").remove();
		        },
		        _panes: function() {
		            if (!this.element) {
		                return $();
		            }
		            return this.element.children(PANECLASS);
		        },
	
		        _resize: function() {
		            var that = this,
		                element = that.element,
		                panes = element.children(PANECLASS),
		                isHorizontal = that.orientation == HORIZONTAL,
		                splitBars = element.children(".k-splitbar"),
		                splitBarsCount = splitBars.length,
		                sizingProperty = isHorizontal ? "width" : "height",
		                totalSize = element[sizingProperty]();
	
		            that.wrapper.addClass("k-splitter-resizing");
	
		            if (splitBarsCount === 0) {
		                splitBarsCount = panes.length - 1;
		                panes.slice(0, splitBarsCount)
		                     .after("<div tabindex='0' class='k-splitbar' data-marker='" + that._marker + "' />");
	
		                that._updateSplitBars();
		                splitBars = element.children(".k-splitbar");
		            } else {
		                that._updateSplitBars();
		            }
	
		            // discard splitbar sizes from total size
		            splitBars.each(function() {
		                totalSize -= this[isHorizontal ? "offsetWidth" : "offsetHeight"];
		            });
	
		            var sizedPanesWidth = 0,
		                sizedPanesCount = 0,
		                freeSizedPanes = $();
	
		            panes.css({ position: "absolute", top: 0 })
		                [sizingProperty](function() {
		                    var element = $(this),
		                        config = element.data(PANE) || {}, size;
	
		                    element.removeClass("k-state-collapsed");
		                    if (config.collapsed) {
		                        size = config.collapsedSize ? calculateSize(config.collapsedSize, totalSize) : 0;
		                        element.css("overflow", "hidden").addClass("k-state-collapsed");
		                    } else if (isFluid(config.size)) {
		                        freeSizedPanes = freeSizedPanes.add(this);
		                        return;
		                    } else { // sized in px/%, not collapsed
		                        size = calculateSize(config.size, totalSize);
		                    }
	
		                    sizedPanesCount++;
		                    sizedPanesWidth += size;
	
		                    return size;
		                });
	
		            totalSize -= sizedPanesWidth;
	
		            var freeSizePanesCount = freeSizedPanes.length,
		                freeSizePaneWidth = Math.floor(totalSize / freeSizePanesCount);
	
		            freeSizedPanes
		                .slice(0, freeSizePanesCount - 1)
		                    .css(sizingProperty, freeSizePaneWidth)
		                .end()
		                .eq(freeSizePanesCount - 1)
		                    .css(sizingProperty, totalSize - (freeSizePanesCount - 1) * freeSizePaneWidth);
	
		            // arrange panes
		            var sum = 0,
		                alternateSizingProperty = isHorizontal ? "height" : "width",
		                positioningProperty = isHorizontal ? "left" : "top",
		                sizingDomProperty = isHorizontal ? "offsetWidth" : "offsetHeight";
	
		            if (freeSizePanesCount === 0) {
		                var lastNonCollapsedPane = panes.filter(function() {
		                    return !(($(this).data(PANE) || {}).collapsed);
		                }).last();
	
		                lastNonCollapsedPane[sizingProperty](totalSize + lastNonCollapsedPane[0][sizingDomProperty]);
		            }
	
		            element.children()
		                .css(alternateSizingProperty, element[alternateSizingProperty]())
		                .each(function (i, child) {
		                    if (child.tagName.toLowerCase() != "script") {
		                        child.style[positioningProperty] = Math.floor(sum) + "px";
		                        sum += child[sizingDomProperty];
		                    }
		                });
	
		            that._detachEvents();
		            that._attachEvents();
	
		            that.wrapper.removeClass("k-splitter-resizing");
	
		            kendo.resize(panes);
		            that.trigger(LAYOUTCHANGE);
		        },
	
		        toggle: function(pane, expand) {
		            var that = this,
		                paneConfig;
	
		            pane = that.element.find(pane);
		            paneConfig = pane.data(PANE);
	
		            if (!expand && !paneConfig.collapsible) {
		                return;
		            }
	
		            if (arguments.length == 1) {
		                expand = paneConfig.collapsed === undefined ? false : paneConfig.collapsed;
		            }
	
		            paneConfig.collapsed = !expand;
	
		            if (paneConfig.collapsed) {
		                pane.css("overflow", "hidden");
		            } else {
		                pane.css("overflow", "");
		            }
	
		            that.resize(true);
		        },
	
		        collapse: function(pane) {
		            this.toggle(pane, false);
		        },
	
		        expand: function(pane) {
		            this.toggle(pane, true);
		        },
	
		        _addPane: function(config, idx, paneElement) {
		            var that = this;
	
		            if (paneElement.length) {
		                that.options.panes.splice(idx, 0, config);
		                that._initPane(paneElement, config);
	
		                that._removeSplitBars();
	
		                that.resize(true);
		            }
	
		            return paneElement;
		        },
	
		        append: function(config) {
		            config = config || {};
	
		            var that = this,
		                paneElement = $("<div />").appendTo(that.element);
	
		            return that._addPane(config, that.options.panes.length, paneElement);
		        },
	
		        insertBefore: function(config, referencePane) {
		            referencePane = $(referencePane);
		            config = config || {};
	
		            var that = this,
		                idx = that.wrapper.children(".k-pane").index(referencePane),
		                paneElement = $("<div />").insertBefore($(referencePane));
	
		            return that._addPane(config, idx, paneElement);
		        },
	
		        insertAfter: function(config, referencePane) {
		            referencePane = $(referencePane);
		            config = config || {};
	
		            var that = this,
		                idx = that.wrapper.children(".k-pane").index(referencePane),
		                paneElement = $("<div />").insertAfter($(referencePane));
	
		            return that._addPane(config, idx + 1, paneElement);
		        },
	
		        remove: function(pane) {
		            var that = this;
		            pane = that.wrapper.find(pane);
	
		            if (pane.length) {
		                kendo.destroy(pane);
		                pane.each(function(idx, element){
		                    that.options.panes.splice(that.wrapper.children(".k-pane").index(element), 1);
		                    $(element).remove();
		                });
	
		                that._removeSplitBars();
	
		                if (that.options.panes.length) {
		                    that.resize(true);
		                }
		            }
	
		            return that;
		        },
	
		        size: panePropertyAccessor("size", true),
	
		        min: panePropertyAccessor("min"),
	
		        max: panePropertyAccessor("max")
		    });
	
		    ui.plugin(Splitter);
	
		    var verticalDefaults = {
		            sizingProperty: "height",
		            sizingDomProperty: "offsetHeight",
		            alternateSizingProperty: "width",
		            positioningProperty: "top",
		            mousePositioningProperty: "pageY"
		        };
	
		    var horizontalDefaults = {
		            sizingProperty: "width",
		            sizingDomProperty: "offsetWidth",
		            alternateSizingProperty: "height",
		            positioningProperty: "left",
		            mousePositioningProperty: "pageX"
		        };
	
		    function PaneResizing(splitter) {
		        var that = this,
		            orientation = splitter.orientation;
	
		        that.owner = splitter;
		        that._element = splitter.element;
		        that.orientation = orientation;
	
		        extend(that, orientation === HORIZONTAL ? horizontalDefaults : verticalDefaults);
	
		        that._resizable = new kendo.ui.Resizable(splitter.element, {
		            orientation: orientation,
		            handle: ".k-splitbar-draggable-" + orientation + "[data-marker=" + splitter._marker + "]",
		            hint: proxy(that._createHint, that),
		            start: proxy(that._start, that),
		            max: proxy(that._max, that),
		            min: proxy(that._min, that),
		            invalidClass:"k-restricted-size-" + orientation,
		            resizeend: proxy(that._stop, that)
		        });
		    }
	
		    PaneResizing.prototype = {
		        press: function(target) {
		            this._resizable.press(target);
		        },
	
		        move: function(delta, target) {
		            if (!this.pressed) {
		                this.press(target);
		                this.pressed = true;
		            }
	
		            if (!this._resizable.target) {
		                this._resizable.press(target);
		            }
	
		            this._resizable.move(delta);
		        },
	
		        end: function() {
		            this._resizable.end();
		            this.pressed = false;
		        },
	
		        destroy: function() {
		            this._resizable.destroy();
		            this._resizable = this._element = this.owner = null;
		        },
	
		        isResizing: function() {
		            return this._resizable.resizing;
		        },
	
		        _createHint: function(handle) {
		            var that = this;
		            return $("<div class='k-ghost-splitbar k-ghost-splitbar-" + that.orientation + " k-state-default' />")
		                        .css(that.alternateSizingProperty, handle[that.alternateSizingProperty]());
		        },
	
		        _start: function(e) {
		            var that = this,
		                splitbar = $(e.currentTarget),
		                previousPane = splitbar.prev(),
		                nextPane = splitbar.next(),
		                previousPaneConfig = previousPane.data(PANE),
		                nextPaneConfig = nextPane.data(PANE),
		                prevBoundary = parseInt(previousPane[0].style[that.positioningProperty], 10),
		                nextBoundary = parseInt(nextPane[0].style[that.positioningProperty], 10) + nextPane[0][that.sizingDomProperty] - splitbar[0][that.sizingDomProperty],
		                totalSize = parseInt(that._element.css(that.sizingProperty), 10),
		                toPx = function (value) {
		                    var val = parseInt(value, 10);
		                    return (isPixelSize(value) ? val : (totalSize * val) / 100) || 0;
		                },
		                prevMinSize = toPx(previousPaneConfig.min),
		                prevMaxSize = toPx(previousPaneConfig.max) || nextBoundary - prevBoundary,
		                nextMinSize = toPx(nextPaneConfig.min),
		                nextMaxSize = toPx(nextPaneConfig.max) || nextBoundary - prevBoundary;
	
		            that.previousPane = previousPane;
		            that.nextPane = nextPane;
		            that._maxPosition = Math.min(nextBoundary - nextMinSize, prevBoundary + prevMaxSize);
		            that._minPosition = Math.max(prevBoundary + prevMinSize, nextBoundary - nextMaxSize);
		        },
		        _max: function() {
		              return this._maxPosition;
		        },
		        _min: function() {
		            return this._minPosition;
		        },
		        _stop: function(e) {
		            var that = this,
		                splitbar = $(e.currentTarget),
		                owner = that.owner;
	
		            owner._panes().children(".k-splitter-overlay").remove();
	
		            if (e.keyCode !== kendo.keys.ESC) {
		                var ghostPosition = e.position,
		                    previousPane = splitbar.prev(),
		                    nextPane = splitbar.next(),
		                    previousPaneConfig = previousPane.data(PANE),
		                    nextPaneConfig = nextPane.data(PANE),
		                    previousPaneNewSize = ghostPosition - parseInt(previousPane[0].style[that.positioningProperty], 10),
		                    nextPaneNewSize = parseInt(nextPane[0].style[that.positioningProperty], 10) + nextPane[0][that.sizingDomProperty] - ghostPosition - splitbar[0][that.sizingDomProperty],
		                    fluidPanesCount = that._element.children(PANECLASS).filter(function() { return isFluid($(this).data(PANE).size); }).length;
	
		                if (!isFluid(previousPaneConfig.size) || fluidPanesCount > 1) {
		                    if (isFluid(previousPaneConfig.size)) {
		                        fluidPanesCount--;
		                    }
	
		                    previousPaneConfig.size = previousPaneNewSize + "px";
		                }
	
		                if (!isFluid(nextPaneConfig.size) || fluidPanesCount > 1) {
		                    nextPaneConfig.size = nextPaneNewSize + "px";
		                }
	
		                owner.resize(true);
		            }
	
		            return false;
		        }
		    };
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)))
	
	/***/ })
	
	/******/ });

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1121);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1121:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1004), __webpack_require__(1036)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		    var __meta__ = { // jshint ignore:line
		        id: "dialog",
		        name: "Dialog",
		        category: "web", // suite
		        description: "The dialog widget is a modal popup that brings information to the user.",
		        depends: ["core", "popup"] // dependencies
		    };
	
		    (function($, undefined) {
		        var kendo = window.kendo,
		            Widget = kendo.ui.Widget,
		            TabKeyTrap = kendo.ui.Popup.TabKeyTrap,
		            proxy = $.proxy,
		            template = kendo.template,
		            keys = kendo.keys,
		            isFunction = $.isFunction,
		            NS = "kendoWindow",
		            KDIALOG = ".k-dialog",
		            KWINDOW = ".k-window",
		            KICONCLOSE = ".k-dialog-close",
		            KCONTENTCLASS = "k-content k-window-content k-dialog-content",
		            KCONTENT = ".k-content",
		            KSCROLL = "k-scroll",
		            KTITLELESS = "k-dialog-titleless",
		            KDIALOGTITLE = ".k-dialog-title",
		            KDIALOGTITLEBAR = KDIALOGTITLE + "bar",
		            KBUTTONGROUP = ".k-dialog-buttongroup",
		            KBUTTON = ".k-button",
		            KALERT = "k-alert",
		            KCONFIRM = "k-confirm",
		            KPROMPT = "k-prompt",
		            KTEXTBOX = ".k-textbox",
		            KOVERLAY = ".k-overlay",
		            VISIBLE = ":visible",
		            ZINDEX = "zIndex",
		            BODY = "body",
		            INITOPEN = "initOpen",
		            OPEN = "open",
		            CLOSE = "close",
		            SHOW = "show",
		            HIDE = "hide",
		            WIDTH = "width",
		            HUNDREDPERCENT = 100,
		            messages = {
		                okText  : "OK",
		                cancel : "Cancel",
		                promptInput: "Input"
		            },
		            ceil = Math.ceil,
		            templates,
		            overlaySelector = ":not(link,meta,script,style)";
	
		        function defined(x) {
		            return (typeof x != "undefined");
		        }
	
		        function constrain(value, low, high) {
		            return Math.max(Math.min(parseInt(value, 10), high === Infinity ? high : parseInt(high, 10)), parseInt(low, 10));
		        }
	
		        function buttonKeyTrigger(e) {
		            return e.keyCode == keys.ENTER || e.keyCode == keys.SPACEBAR;
		        }
	
		        var DialogBase = Widget.extend({
		            init: function(element, options) {
		                var that = this;
		                Widget.fn.init.call(that, element, options);
		                that._init(that.element, that.options);
		                kendo.notify(that);
		            },
	
		            _init: function(element, options) {
		                var that = this,
		                    wrapper;
	
		                that._centerCallback = proxy(that._center, that);
	
		                that.appendTo = $(BODY);
		                if (!defined(options.visible) || options.visible === null) {
		                    options.visible = element.is(VISIBLE);
		                }
	
		                if (that.wrapperTemplate === undefined) {
		                    that.wrapperTemplate = templates.wrapper;
		                }
	
		                that._createDialog();
		                wrapper = that.wrapper = element.closest(KDIALOG);
	
		                if (options._defaultFocus === undefined) {
		                    that._defaultFocus = element[0];
		                }
	
		                that._tabindex(element);
		                that._dimensions();
	
		                this._tabKeyTrap = new TabKeyTrap(wrapper);
	
		                if (!that.options.visible) {
		                    that.wrapper.hide();
		                } else {
		                    that._triggerOpen();
		                }
		            },
	
		            setOptions: function(options) {
		                var that = this;
		                options = $.extend(that.options, options);
	
		                Widget.fn.setOptions.call(that, options);
	
		                if (options.title !== undefined) {
		                    that.title(options.title);
		                }
	
		                if (options.content) {
		                    kendo.destroy(that.element.children());
		                    that.element.html(options.content);
		                }
	
		                if (options.actions) {
		                    that.wrapper.children(KBUTTONGROUP).remove();
		                    that._createActionbar(that.wrapper);
		                }
	
		                that.wrapper.show();
		                that._closable(that.wrapper);
		                that._dimensions();
	
		                if (!options.visible) {
		                    that.wrapper.hide();
		                } else {
		                    that._triggerOpen();
		                }
		            },
	
		            _dimensions: function() {
		                var that = this,
		                    wrapper = that.wrapper,
		                    options = that.options,
		                    width = options.width,
		                    height = options.height,
		                    dimensions = ["minWidth", "minHeight", "maxWidth", "maxHeight"];
	
		                for (var i = 0; i < dimensions.length; i++) {
		                    var value = options[dimensions[i]];
		                    if (value && value != Infinity) {
		                        wrapper.css(dimensions[i], value);
		                    }
		                }
	
		                this._setElementMaxHeight();
	
		                if (width) {
		                    if (width.toString().indexOf("%") > 0) {
		                        wrapper.width(width);
		                    } else {
		                        wrapper.outerWidth(constrain(width, options.minWidth, options.maxWidth));
		                    }
		                }
	
		                if (height) {
		                    if (height.toString().indexOf("%") > 0) {
		                        wrapper.height(height);
		                    } else {
		                        wrapper.outerHeight(constrain(height, options.minHeight, options.maxHeight));
		                    }
	
		                    this._setElementHeight();
		                }
		            },
	
		            _setElementMaxHeight: function() {
		                var that = this,
		                    element = that.element,
		                    maxHeight = that.options.maxHeight,
		                    paddingBox,
		                    elementMaxHeight;
	
		                if (maxHeight != Infinity) {
		                    paddingBox = that._paddingBox(element);
		                    elementMaxHeight = parseFloat(maxHeight, 10) - that._uiHeight() - paddingBox.vertical;
		                    if (elementMaxHeight > 0) {
		                        element.css({
		                            maxHeight: ceil(elementMaxHeight) + "px"
		                        });
		                    }
		                }
	
		            },
	
		            _paddingBox: function(element) {
		                var paddingTop = parseFloat(element.css("padding-top"), 10),
		                    paddingLeft = parseFloat(element.css("padding-left"), 10),
		                    paddingBottom = parseFloat(element.css("padding-bottom"), 10),
		                    paddingRight = parseFloat(element.css("padding-right"), 10);
	
		                return {
		                    vertical: paddingTop + paddingBottom,
		                    horizontal: paddingLeft + paddingRight
		                };
		            },
	
		            _setElementHeight: function() {
		                var that = this,
		                    element = that.element,
		                    height = that.options.height,
		                    paddingBox = that._paddingBox(element),
		                    elementHeight = parseFloat(height, 10) - that._uiHeight() - paddingBox.vertical;
	
		                if (elementHeight < 0) {
		                    elementHeight = 0;
		                }
	
		                element.css({
		                    height: ceil(elementHeight) + "px"
		                });
	
		                this._applyScrollClassName(element);
	
		            },
	
		            _applyScrollClassName: function(element) {
		                    var hasScroll = element.get(0).scrollHeight > element.outerHeight();
	
		                    if (hasScroll){
		                        element.addClass(KSCROLL);
		                    } else {
		                        element.removeClass(KSCROLL);
		                    }
		            },
	
		            _uiHeight: function() {
		                var that = this,
		                    wrapper = that.wrapper,
		                    actionbar = wrapper.children(KBUTTONGROUP),
		                    actionbarHeight = actionbar[0] && actionbar[0].offsetHeight || 0,
		                    titlebar = wrapper.children(KDIALOGTITLEBAR),
		                    titlebarHeight = titlebar[0] && titlebar[0].offsetHeight || 0;
	
		                return actionbarHeight + titlebarHeight;
		            },
	
		            _overlay: function(visible) {
		                var overlay = this.appendTo.children(KOVERLAY),
		                    wrapper = this.wrapper;
	
	
		                if (!overlay.length) {
		                    overlay = $(templates.overlay);
		                }
	
		                overlay
		                    .insertBefore(wrapper[0])
		                    .toggle(visible)
		                    .css(ZINDEX, parseInt(wrapper.css(ZINDEX), 10) - 1);
	
		                if (visible) {
		                    this._waiAriaOverlay();
		                }
		                else {
		                    this._removeWaiAriaOverlay();
		                }
	
		                return overlay;
		            },
	
		            _waiAriaOverlay: function() {
		                var node = this.wrapper;
	
		                this._overlayedNodes = node.prevAll(overlaySelector).add(node.nextAll(overlaySelector))
		                    .each(function() {
		                        var jthis = $(this);
		                        jthis.data("ariaHidden", jthis.attr("aria-hidden"));
		                        jthis.attr("aria-hidden", "true");
		                    });
		            },
	
		            _removeWaiAriaOverlay: function() {
		                return this._overlayedNodes && this._overlayedNodes.each(function() {
		                    var node = $(this);
		                    var hiddenValue = node.data("ariaHidden");
		                    if (hiddenValue) {
		                        node.attr("aria-hidden", hiddenValue);
		                    }
		                    else {
		                        node.removeAttr("aria-hidden");
		                    }
		                });
		            },
	
		            _closeClick: function(e) {
		                e.preventDefault();
		                this.close(false);
		            },
	
		            _closeKeyHandler: function(e) {
		                if (buttonKeyTrigger(e) || e.keyCode == keys.ESC) {
		                    this.close(false);
		                }
		            },
	
		            _keydown: function(e) {
		                var that = this,
		                    options = that.options,
		                    keyCode = e.keyCode;
	
		                if (keyCode == keys.ESC && !that._closing && options.closable) {
		                    that.close(false);
		                }
		            },
	
		            _createDialog: function() {
		                var that = this,
		                    content = that.element,
		                    options = that.options,
		                    isRtl = kendo.support.isRtl(content),
		                    titlebar = $(templates.titlebar(options)),
		                    titleId = (content.id || kendo.guid()) + "_title",
		                    wrapper = $(that.wrapperTemplate(options));
	
		                wrapper.toggleClass("k-rtl", isRtl);
	
		                content.addClass(KCONTENTCLASS);
		                that.appendTo.append(wrapper);
	
		                if (options.title !== false) {
		                    wrapper.append(titlebar);
		                    titlebar.attr("id", titleId);
		                    wrapper.attr("aria-labelledby", titleId);
		                } else {
		                    wrapper.addClass(KTITLELESS);
		                }
	
		                that._closable(wrapper);
	
		                wrapper.append(content);
	
		                if (options.content) {
		                    kendo.destroy(content.children());
		                    content.html(options.content);
		                }
	
		                if (options.actions.length) {
		                    that._createActionbar(wrapper);
		                }
		            },
	
		            _closable: function (wrapper) {
		                var that = this;
		                var options = that.options;
		                var titlebar = wrapper.children(KDIALOGTITLEBAR);
		                var titlebarActions = titlebar.find(".k-window-actions");
		                var closeAction = titlebarActions.length ? titlebarActions.find(".k-dialog-close") : wrapper.find(".k-dialog-close");
	
		                closeAction.remove();
	
		                if (options.closable !== false) {
		                    if (options.title !== false && titlebarActions.length) {
		                        titlebarActions.append(templates.close(options));
		                    }
		                    else {
		                        wrapper.prepend(templates.close(options));
		                    }
	
		                    wrapper.autoApplyNS(NS);
		                    that.element.autoApplyNS(NS);
	
		                    wrapper.find(KICONCLOSE)
		                        .on("click", proxy(that._closeClick, that))
		                        .on("keydown", proxy(that._closeKeyHandler, that));
	
		                    that.element.on("keydown", proxy(that._keydown, that));
		                }
		            },
	
		            _createActionbar: function(wrapper) {
		                var isStretchedLayout = (this.options.buttonLayout === "stretched");
		                var buttonLayout = isStretchedLayout ? "stretched" : "normal";
		                var actionbar = $(templates.actionbar({ buttonLayout: buttonLayout }));
		                this._addButtons(actionbar);
		                if(isStretchedLayout) {
		                    this._normalizeButtonSize(actionbar);
		                }
		                wrapper.append(actionbar);
		            },
	
		            _addButtons: function(actionbar) {
		                var that = this,
		                    o = that.options,
		                    actionClick = proxy(that._actionClick, that),
		                    actionKeyHandler = proxy(that._actionKeyHandler, that),
		                    actions = that.options.actions,
		                    length = actions.length,
		                    buttonSize = Math.round(HUNDREDPERCENT / length),
		                    action,
		                    text;
	
		                for (var i = 0; i < length; i++) {
		                    action = actions[i];
		                    text = that._mergeTextWithOptions(action);
		                    var btn = $(templates.action(action))
		                        .autoApplyNS(NS)
		                        .html(text)
		                        .appendTo(actionbar)
		                        .data("action", action.action)
		                        .on("click", actionClick)
		                        .on("keydown", actionKeyHandler);
		                    if(o.buttonLayout === "stretched") {
		                        if(i == length - 1){
		                             buttonSize = HUNDREDPERCENT - i*buttonSize;
		                        }
		                        btn.css(WIDTH, buttonSize + "%");
		                    }
		                }
		            },
	
		            _mergeTextWithOptions : function(action) {
		                var text = action.text;
		                return text ? template(text)(this.options) : "";
		            },
	
		            _normalizeButtonSize: function(actionbar) {
		                var that = this,
		                    options = that.options,
		                    lastButton = actionbar.children(KBUTTON + ":last"),
		                    currentSize = parseFloat(lastButton[0] ? lastButton[0].style[WIDTH] : 0),
		                    difference = HUNDREDPERCENT - (options.actions.length * currentSize);
	
		                if (difference > 0) {
		                    lastButton.css(WIDTH, (currentSize + difference) + "%");
		                }
		            },
	
		            _tabindex: function(target) {
		                var that = this;
		                var wrapper = that.wrapper;
		                var closeBtn = wrapper.find(KICONCLOSE);
		                var actionButtons = wrapper.find(KBUTTONGROUP + " " + KBUTTON);
	
		                Widget.fn._tabindex.call(this, target);
	
		                var tabIndex = target.attr("tabindex");
	
		                closeBtn.attr("tabIndex", tabIndex);
		                actionButtons.attr("tabIndex", tabIndex);
		            },
	
		            _actionClick: function(e) {
		                if (this.wrapper.is(VISIBLE)) {
		                    this._runActionBtn(e.currentTarget);
		                }
		            },
	
		            _actionKeyHandler: function(e) {
		                if (buttonKeyTrigger(e)) {
		                    this._runActionBtn(e.currentTarget);
		                } else if (e.keyCode == keys.ESC) {
		                    this.close(false);
		                }
		            },
	
		            _runActionBtn: function(target) {
		                var that = this;
		                if (that._closing) {
		                    return;
		                }
	
		                var action = $(target).data("action"),
		                    preventClose = (isFunction(action) && action({ sender: that }) === false);
	
		                if (!preventClose) {
		                    that.close(false);
		                }
		            },
	
		            _triggerOpen: function() {
		                var that = this;
		                var options = that.options;
		                var wrapper = that.wrapper;
	
		                that.toFront();
		                that._triggerInitOpen();
		                that.trigger(OPEN);
		                if (options.modal) {
		                    that._overlay(wrapper.is(VISIBLE)).css({ opacity: 0.5 });
		                    that._focusDialog();
		                }
		            },
	
		            open: function() {
		                var that = this,
		                    wrapper = that.wrapper,
		                    showOptions = this._animationOptions(OPEN),
		                    options = that.options,
		                    overlay, otherModalsVisible;
	
		                this._triggerInitOpen();
	
		                if (!that.trigger(OPEN)) {
		                    if (that._closing) {
		                        wrapper.kendoStop(true, true);
		                    }
	
		                    that._closing = false;
	
		                    that.toFront();
		                    options.visible = true;
		                    if (options.modal) {
		                        otherModalsVisible = !!that._modals().length;
		                        overlay = that._overlay(otherModalsVisible);
	
		                        overlay.kendoStop(true, true);
	
		                        if (showOptions.duration && kendo.effects.Fade && !otherModalsVisible) {
		                            var overlayFx = kendo.fx(overlay).fadeIn();
		                            overlayFx.duration(showOptions.duration || 0);
		                            overlayFx.endValue(0.5);
		                            overlayFx.play();
		                        } else {
		                            overlay.css("opacity", 0.5);
		                        }
	
		                        overlay.show();
		                    }
	
		                    wrapper.show().kendoStop().kendoAnimate({
		                        effects: showOptions.effects,
		                        duration: showOptions.duration,
		                        complete: proxy(that._openAnimationEnd, that)
		                    });
		                    wrapper.show();
	
		                }
	
		                return that;
		            },
	
		            _animationOptions: function(id) {
		                var animation = this.options.animation;
		                var basicAnimation = {
		                    open: { effects: {} },
		                    close: { hide: true, effects: {} }
		                };
	
		                return animation && animation[id] || basicAnimation[id];
		            },
	
		            _openAnimationEnd: function() {
		                if (this.options.modal) {
		                    this._focusDialog();
		                }
		                this.trigger(SHOW);
		            },
	
		            _triggerInitOpen: function() {
		                if (!defined(this._initOpenTriggered)) {
		                    this._initOpenTriggered = true;
		                    this.trigger(INITOPEN);
		                }
		            },
	
		            toFront: function() {
		                var that = this,
		                    wrapper = that.wrapper,
		                    zIndex = +wrapper.css(ZINDEX),
		                    originalZIndex = zIndex;
	
		                that.center();
	
		                $(KWINDOW).each(function(i, element) {
		                    var windowObject = $(element),
		                        zIndexNew = windowObject.css(ZINDEX);
	
		                    if (!isNaN(zIndexNew)) {
		                        zIndex = Math.max(+zIndexNew, zIndex);
		                    }
		                });
	
		                if (!wrapper[0].style.zIndex || originalZIndex < zIndex) {
		                    wrapper.css(ZINDEX, zIndex + 2);
		                }
	
		                that.element.find("> .k-overlay").remove();
		                wrapper = null;
	
		                return that;
		            },
	
		            close: function(systemTriggered) {
		                if(!arguments.length) {
		                    systemTriggered = true;
		                }
	
		                this._close(systemTriggered);
		                this._stopCenterOnResize();
		                return this;
		            },
	
		            _close: function(systemTriggered) {
		                var that = this,
		                    wrapper = that.wrapper,
		                    options = that.options,
		                    showOptions = this._animationOptions("open"),
		                    hideOptions = this._animationOptions("close");
	
		                if (wrapper.is(VISIBLE) && !that.trigger(CLOSE, { userTriggered: !systemTriggered })) {
		                    if (that._closing) {
		                        return;
		                    }
		                    that._closing = true;
	
		                    options.visible = false;
		                    this._removeOverlay();
	
		                    wrapper.kendoStop().kendoAnimate({
		                        effects: hideOptions.effects || showOptions.effects,
		                        reverse: hideOptions.reverse === true,
		                        duration: hideOptions.duration,
		                        complete: proxy(this._closeAnimationEnd, this)
		                    });
		                }
	
		                return that;
		            },
	
		            center: function() {
		                this._center();
		                this._centerOnResize();
		            },
	
		            _center: function() {
		                var that = this,
		                    wrapper = that.wrapper,
		                    documentWindow = $(window),
		                    scrollTop = 0,
		                    scrollLeft = 0,
		                    newLeft = scrollLeft + Math.max(0, (documentWindow.width() - wrapper.width()) / 2),
		                    newTop = scrollTop + Math.max(0, (documentWindow.height() - wrapper.height() - parseInt(wrapper.css("paddingTop"), 10)) / 2);
	
		                wrapper.css({
		                    left: newLeft,
		                    top: newTop
		                });
	
		                return that;
		            },
	
		            _centerOnResize: function() {
		                if (this._trackResize) {
		                    return;
		                }
	
		                kendo.onResize(this._centerCallback);
		                this._trackResize = true;
		            },
	
		            _stopCenterOnResize: function() {
		                kendo.unbindResize(this._centerCallback);
		                this._trackResize = false;
		            },
	
		            _removeOverlay: function() {
		                var modals = this._modals();
		                var options = this.options;
		                var hideOverlay = options.modal && !modals.length;
	
		                if (hideOverlay) {
		                    this._overlay(false).remove();
		                } else if (modals.length) {
		                    this._object(modals.last())._overlay(true);
		                }
		            },
	
		            _closeAnimationEnd: function() {
		                var that = this;
	
		                that._closing = false;
		                that.wrapper.hide().css("opacity", "");
		                that.trigger(HIDE);
	
		                if (that.options.modal) {
		                    var lastModal = that._object(that._modals().last());
		                    if (lastModal) {
		                        lastModal.toFront();
		                    }
		                }
		            },
	
		            _modals: function() {
		                var that = this;
	
		                var zStack = $(KWINDOW).filter(function() {
		                    var dom = $(this);
		                    var object = that._object(dom);
		                    var options = object && object.options;
	
		                    return options && options.modal && that.options.appendTo == options.appendTo && options.visible && dom.is(VISIBLE);
		                }).sort(function(a, b) {
		                    return +$(a).css("zIndex") - +$(b).css("zIndex");
		                });
	
		                that = null;
	
		                return zStack;
		            },
	
		            _object: function(element) {
		                var content = element.children(KCONTENT);
		                var widget = kendo.widgetInstance(content);
	
		                if (widget) {
		                    return widget;
		                }
	
		                return undefined;
		            },
	
		            destroy: function() {
		                var that = this;
		                that._destroy();
	
		                Widget.fn.destroy.call(that);
	
		                that.wrapper.remove();
		                that.wrapper = that.element = $();
		            },
	
		            _destroy: function() {
		                var that = this;
		                var ns = "." + NS;
	
		                that.wrapper.off(ns);
		                that.element.off(ns);
		                that.wrapper.find(KICONCLOSE + "," + KBUTTONGROUP + " > " + KBUTTON).off(ns);
		                that._stopCenterOnResize();
		            },
	
		            title: function(html) {
		                var that = this,
		                    wrapper = that.wrapper,
		                    options = that.options,
		                    titlebar = wrapper.children(KDIALOGTITLEBAR),
		                    title = titlebar.children(KDIALOGTITLE),
		                    encodedHtml = kendo.htmlEncode(html);
	
		                if (!arguments.length) {
		                    return title.html();
		                }
	
		                if (html === false) {
		                    titlebar.remove();
		                    wrapper.addClass(KTITLELESS);
		                } else {
		                    if (!titlebar.length) {
		                        titlebar = $(templates.titlebar(options)).prependTo(wrapper);
		                        title = titlebar.children(KDIALOGTITLE);
		                        wrapper.removeClass(KTITLELESS);
		                    }
		                    title.html(encodedHtml);
		                }
	
		                that.options.title = encodedHtml;
	
		                return that;
		            },
	
		            content: function(html, data) {
		                var that = this,
		                    content = that.wrapper.children(KCONTENT);
	
		                if (!defined(html)) {
		                    return content.html();
		                }
	
		                this.angular("cleanup", function(){
		                    return { elements: content.children() };
		                });
	
		                kendo.destroy(content.children());
		                content.html(html);
	
		                this.angular("compile", function(){
		                    var a = [];
		                    for (var i = content.length; --i >= 0;) {
		                        a.push({ dataItem: data });
		                    }
		                    return {
		                        elements: content.children(),
		                        data: a
		                    };
		                });
	
		                that.options.content = html;
	
		                return that;
		            },
	
		            _focusDialog: function() {
		                if (this._defaultFocus) {
		                    this._focus(this._defaultFocus);
		                }
		                this._tabKeyTrap.trap();
		            },
	
		            _focus: function(node) {
		                if (node) {
		                    node.focus();
		                }
		            },
	
		            events: [
		                INITOPEN,
		                OPEN,
		                CLOSE,
		                SHOW,
		                HIDE
		            ],
	
		            options: {
		                title: "",
		                buttonLayout: "stretched",
		                actions: [],
		                modal: true,
		                width: null,
		                height: null,
		                minWidth: 0,
		                minHeight: 0,
		                maxWidth: Infinity,
		                maxHeight: Infinity,
		                content: null,
		                visible: null,
		                appendTo: BODY,
		                closable: true
		            }
		        });
	
		        var Dialog = DialogBase.extend({
		            options: {
		                name: "Dialog",
		                messages: {
		                    close: "Close"
		                }
		            }
		        });
	
		        kendo.ui.plugin(Dialog);
	
		        var PopupBox = DialogBase.extend({
		            _init: function(element, options) {
		                var that = this;
	
		                that.wrapperTemplate = templates.alertWrapper;
		                options._defaultFocus = null;
		                that._ensureContentId(element);
	
		                DialogBase.fn._init.call(that, element, options);
	
		                that.bind(HIDE, proxy(that.destroy, that));
	
		                that._ariaDescribedBy();
		                that._initFocus();
		            },
	
		            _ensureContentId: function(element) {
		                var node = $(element);
		                if(!node.attr("id")) {
		                    node.attr("id", kendo.guid() + "_k-popup");
		                }
		            },
	
		            _ariaDescribedBy: function() {
		                this.wrapper.attr("aria-describedby", this.element.attr("id"));
		            },
	
		            _initFocus: function() {
		                var o = this.options;
	
		                this._defaultFocus = this._chooseEntryFocus();
		                if (this._defaultFocus && o.visible && o.modal) {
		                    this._focusDialog();
		                }
		            },
	
		            _chooseEntryFocus: function() {
		                return this.wrapper.find(KBUTTONGROUP + " > " + KBUTTON)[0];
		            },
	
		            options: {
		                title: window.location.host,
		                closable: false,
		                messages: messages
		            }
		        });
	
		        var Alert = PopupBox.extend({
		            _init: function(element, options) {
		                var that = this;
		                PopupBox.fn._init.call(that, element, options);
		                that.wrapper.addClass(KALERT);
		            },
	
		            options: {
		                name: "Alert",
		                modal: true,
		                actions: [{
		                    text: "#: messages.okText #"
		                }]
		            }
		        });
	
		        kendo.ui.plugin(Alert);
	
		        var kendoAlert = function(text) {
		            return $(templates.alert).kendoAlert({ content: text }).data("kendoAlert").open();
		        };
	
		        var Confirm = PopupBox.extend({
		            _init: function(element, options) {
		                var that = this;
		                PopupBox.fn._init.call(that, element, options);
		                that.wrapper.addClass(KCONFIRM);
		                that.result = $.Deferred();
		            },
	
		            options: {
		                name: "Confirm",
		                modal: true,
		                actions: [{
		                    text: "#: messages.okText #",
		                    primary: true,
		                    action: function(e) {
		                        e.sender.result.resolve();
		                    }
		                }, {
		                    text: "#: messages.cancel #",
		                    action: function(e) {
		                        e.sender.result.reject();
		                    }
		                }]
		            }
		        });
	
		        kendo.ui.plugin(Confirm);
	
		        var kendoConfirm = function(text) {
		            var confirmDialog = $(templates.confirm).kendoConfirm({ content: text }).data("kendoConfirm").open();
		            return confirmDialog.result;
		        };
	
		        var Prompt = PopupBox.extend({
		            _init: function(element, options) {
		                var that = this;
		                PopupBox.fn._init.call(that, element, options);
		                that.wrapper.addClass(KPROMPT);
		                that._createPrompt();
		                that.result = $.Deferred();
		            },
	
		            _createPrompt: function() {
		                var value = this.options.value,
		                    promptContainer = $(templates.promptInputContainer(this.options)).insertAfter(this.element);
	
		                if (value) {
		                    promptContainer.children(KTEXTBOX).val(value);
		                }
	
		                this._defaultFocus = this._chooseEntryFocus();
		                this._focusDialog();
		            },
	
		            _chooseEntryFocus: function() {
		                return this.wrapper.find(KTEXTBOX)[0];
		            },
	
		            options: {
		                name: "Prompt",
		                modal: true,
		                value: "",
		                actions: [{
		                    text: "#: messages.okText #",
		                    primary: true,
		                    action: function(e) {
		                        var sender = e.sender,
		                            value = sender.wrapper.find(KTEXTBOX).val();
	
		                        sender.result.resolve(value);
		                    }
		                }, {
		                    text: "#: messages.cancel #",
		                    action: function(e) {
		                        var sender = e.sender,
		                            value = sender.wrapper.find(KTEXTBOX).val();
	
		                        e.sender.result.reject(value);
		                    }
		                }]
		            }
		        });
	
		        kendo.ui.plugin(Prompt);
	
		        var kendoPrompt = function(text, value) {
		            var promptDialog = $(templates.prompt).kendoPrompt({
		                content: text,
		                value: value
		            }).data("kendoPrompt").open();
	
		            return promptDialog.result;
		        };
	
		        templates = {
		            wrapper: template("<div class='k-widget k-window k-dialog' role='dialog' />"),
		            action: template("<button type='button' class='k-button# if (data.primary) { # k-primary# } role='button' #'></button>"),
		            titlebar: template(
		                "<div class='k-window-titlebar k-dialog-titlebar k-header'>" +
		                    "<span class='k-window-title k-dialog-title'>#: title #</span>" +
		                    "<div class='k-window-actions k-dialog-actions' />" +
		                "</div>"
		            ),
		            close: template("<a role='button' href='\\#' class='k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close' title='#: messages.close #' aria-label='#: messages.close #' tabindex='-1'><span class='k-icon k-i-close'></span></a>"),
		            actionbar: template("<div class='k-button-group k-dialog-buttongroup k-dialog-button-layout-#: buttonLayout #' role='toolbar' />"),
		            overlay: "<div class='k-overlay' />",
		            alertWrapper: template("<div class='k-widget k-window k-dialog' role='alertdialog' />"),
		            alert: "<div />",
		            confirm: "<div />",
		            prompt: "<div />",
		            promptInputContainer: template("<div class='k-prompt-container'><input type='text' class='k-textbox' title='#: messages.promptInput #' aria-label='#: messages.promptInput #' /></div>")
		        };
	
		        kendo.alert = kendoAlert;
		        kendo.confirm = kendoConfirm;
		        kendo.prompt = kendoPrompt;
	
		    })(window.kendo.jQuery);
	
		    return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1029);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1029:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1030), __webpack_require__(1031), __webpack_require__(1032) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "chat",
		    name: "Chat",
		    category: "web",
		    description: "The Chat component.",
		    depends: [ "core", "draganddrop" ]
		};
	
		(function($, undefined) {
	
		    var kendo = window.kendo;
		    var Widget = kendo.ui.Widget;
		    var extend = $.extend;
		    var DOT = ".";
	
		    var chatStyles = {
		        wrapper: "k-widget k-chat",
		        canvas: "k-chat-canvas",
		        viewWrapper: "k-message-list",
		        messageBoxWrapper: "k-message-box",
		        toolbarBoxWrapper: "k-toolbar-box"
		    };
	
		    var Chat = Widget.extend({
		        init: function(element, options, events) {
		            Widget.fn.init.call(this, element, options);
	
		            if (events) {
		                this._events = events;
		            }
	
		            this._user();
	
		            this._wrapper();
	
		            this._view();
	
		            this._messageBox();
	
		            if(options && options.toolbar && options.toolbar.buttons) {
		                this._toolbar();
		            }
	
		            kendo.notify(this);
		        },
	
		        events: [
		            "typingStart",
		            "typingEnd",
		            "post",
		            "sendMessage",
		            "actionClick",
		            "toolClick"
		        ],
	
		        options: {
		            user: {
		                name: "User",
		                iconUrl: ""
		            },
		            name: "Chat",
		            messages: {
		                placeholder: "Type a message..."
		            },
		            toolbar: false
		        },
	
		        setOptions: function(options) {
		            this._setEvents(options);
		            $.extend(true, this.options, options);
	
		            if (this.toolbar && "toolbar" in options) {
		                this.toolbar.destroy();
		                this.toolbar = null;
		            }
	
		            if (this.messageBox) {
		                this.messageBox.unbind();
		                this.messageBox.destroy();
		                this.messageBox = null;
		            }
	
		            this._messageBox();
	
		            if ("toolbar" in options) {
		                this._resetToolbarButtons(options);
		                this._toolbar();
		            }
		        },
	
		        _resetToolbarButtons: function (options) {
		            var toolbarBoxWrapper = this.wrapper.find(DOT + chatStyles.toolbarBoxWrapper);
	
		            if(!toolbarBoxWrapper.is(":visible")){
		                toolbarBoxWrapper.show();
		            }
	
		            if("buttons" in options.toolbar) {
		                this.options.toolbar.buttons = options.toolbar.buttons;
		            }
		        },
	
		        destroy: function() {
		            if (this.view) {
		                this.view.unbind();
		                this.view.destroy();
		                this.view = null;
		            }
	
		            if (this.messageBox) {
		                this.messageBox.unbind();
		                this.messageBox.destroy();
		                this.messageBox = null;
		            }
	
		            if(this.toolbar) {
		                this.toolbar.destroy();
		                this.toolbar = null;
		            }
	
		            Widget.fn.destroy.call(this);
		        },
	
		        _user: function() {
		            this.options.user.id = kendo.guid();
		        },
	
		        getUser: function() {
		            return extend(true, {}, this.options.user);
		        },
	
		        _wrapper: function() {
		            var chatStyles = Chat.styles;
		            var options = this.options;
		            var height = options.height;
		            var width = options.width;
		            var uiElements = "<div class='" + chatStyles.viewWrapper + "'></div>" +
		                             "<div class='" + chatStyles.messageBoxWrapper + "'></div>" +
		                             "<div class='" + chatStyles.toolbarBoxWrapper + "' role='toolbar' style='display:none;'></div>";
	
		            this.wrapper = this.element
		                .addClass(chatStyles.wrapper)
		                .append(uiElements);
	
		            if (options.toolbar && options.toolbar.buttons && options.toolbar.buttons.length) {
		                this.wrapper.find(DOT + chatStyles.toolbarBoxWrapper).show();
		            }
	
		            if (height) {
		                this.wrapper.height(height);
		            }
	
		            if (width) {
		                this.wrapper.css("max-width", width);
		            }
		        },
	
		        _view: function() {
		            var that = this;
		            var chatStyles = Chat.styles;
		            var options = extend(true, {}, this.options);
		            var element = this.wrapper.find(DOT + chatStyles.viewWrapper + "");
	
		            this.view = new kendo.chat.ChatView(element, options);
	
		            this.view
		                .bind("actionClick", function(args) {
		                    that.trigger("actionClick", args);
	
		                    that.postMessage(args.text);
		                });
		        },
	
		        _messageBox: function() {
		            var that = this;
		            var chatStyles = Chat.styles;
		            var options = extend(true, {}, this.options);
		            var element = this.wrapper.find(DOT + chatStyles.messageBoxWrapper + "");
	
		            this.messageBox = new kendo.chat.ChatMessageBox(element, options);
	
		            this.messageBox
		                .bind("typingStart", function(args) {
		                    that.trigger("typingStart", args);
		                })
		                .bind("typingEnd", function(args) {
		                    that.trigger("typingEnd", args);
		                })
		                .bind("sendMessage", function(args) {
		                    that.trigger("sendMessage", args);
	
		                    that.postMessage(args.text);
		                })
		                .bind("toggleToolbar", function() {
		                    that.toggleToolbar();
		                });
		        },
	
		        _toolbar: function() {
		            var that = this;
		            var chatStyles = Chat.styles;
		            var options = extend(true, {}, that.options);
		            var element = that.wrapper.find(DOT + chatStyles.toolbarBoxWrapper + "");
	
		            if(options.toolbar.scrollable === undefined) {
		                this.options.toolbar.scrollable = options.toolbar.scrollable = true;
		            }
	
		            if(options.toolbar.toggleable === undefined) {
		                this.options.toolbar.toggleable = options.toolbar.toggleable = false;
		            }
	
		            that.toolbar = new kendo.chat.ChatToolBar(element, options);
	
		            that.toolbar.bind("click", function(ev){
		                that.trigger("toolClick", {
		                    sender: that,
		                    name: ev.name,
		                    button: ev.button,
		                    messageBox: that.messageBox.input[0],
		                    originalEvent: ev.originalEvent
		                });
		            });
		        },
	
		        postMessage: function(message) {
		            var postArgs = extend(true, {}, { text: message, type: "message", timestamp: new Date(), from: this.getUser() });
	
		            this.trigger("post", postArgs);
	
		            this.renderMessage(postArgs, postArgs.from);
		        },
	
		        // TEST calling View renderMessage
		        renderMessage: function(message, sender) {
		            this.view.renderMessage(message, sender);
		        },
	
		        // TEST calling View renderSuggestedActions
		        renderSuggestedActions: function(suggestedActions) {
		            this.view.renderSuggestedActions(suggestedActions);
		        },
	
		        // TEST calling View renderCard
		        renderAttachments: function(options, sender) {
		            this.view.renderAttachments(options, sender);
		        },
	
		        toggleToolbar: function (skipAnimation) {
		            this.toolbar.toggle(skipAnimation);
		        }
		    });
	
		    kendo.ui.plugin(Chat);
	
		    extend(true, Chat, { styles: chatStyles });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1030:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(649);
	
	/***/ }),
	
	/***/ 1031:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(650);
	
	/***/ }),
	
	/***/ 1032:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(651);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(21);
		module.exports = __webpack_require__(21);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(22)  ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		    var kendo = window.kendo;
		    var Widget = kendo.ui.Widget;
		    var extend = $.extend;
		    var proxy = $.proxy;
		    var DOT = ".";
		    var SPACE = " ";
		    var NS = ".kendoChat";
	
		    var MESSAGE_GROUP_TEMPLATE = kendo.template(
		        '<div #:text# class="#=styles.messageGroup# #= url ? "" : styles.noAvatar #">' +
		            '<p class="#=styles.author#">#:text#</p>' +
		            '# if (url) { #' +
		                '<img src="#=url#" alt="#:text#" class="#=styles.avatar#">' +
		            '# } #' +
		        '</div>');
		    var SELF_MESSAGE_GROUP_TEMPLATE = kendo.template(
		        '<div me class="#=styles.messageGroup# #=styles.self# #= url ? "" : styles.noAvatar #">' +
		            '# if (url) { #' +
		                '<img src="#=url#" alt="#:text#" class="#=styles.avatar#">' +
		            '# } #' +
		        '</div>');
	
		    var TEXT_MESSAGE_TEMPLATE = kendo.template(
		        '<div class="#=styles.message#">' +
		            '<time class="#=styles.messageTime#">#= kendo.toString(kendo.parseDate(timestamp), "HH:mm:ss") #</time>' +
		            '<div class="#=styles.bubble#">#:text#</div>' +
		        '</div>');
		    var TYPING_INDICATOR_TEMPLATE = kendo.template(
		        '<div class="#=styles.message#">' +
		            '<div class="#=styles.bubble#">' +
		                '<div class="#=styles.typingIndicator#">' +
		                    '<span></span><span></span><span></span>' +
		                '</div>' +
		            '</div>' +
		        '</div>');
	
		    var SUGGESTED_ACTIONS_TEMPLATE = kendo.template(
		        '<div class="#=styles.suggestedActions#">' +
		            '# for (var i = 0; i < suggestedActions.length; i++) { #' +
		                '<span class="#=styles.suggestedAction#" data-value="#:suggestedActions[i].value#">#:suggestedActions[i].title#</span>' +
		            '# } #' +
		        '</div>'
		        );
	
		    var HERO_CARD_TEMPLATE = kendo.template(
		        '<div class="#=styles.card# #=styles.cardRich#">' +
		            '# if (typeof images !== "undefined" && images.length > 0) { #' +
		                '<img src="#:images[0].url#" alt="#:images[0].alt#" class="#=styles.cardImage#" />' +
		            '# } #' +
		            '<div class="#=styles.cardBody#">' +
		                '# if (typeof title !== "undefined") { #' +
		                    '<h5 class="#=styles.cardTitle#">#:title#</h5>' +
		                '# } #' +
		                '# if (typeof subtitle !== "undefined") { #' +
		                    '<h6 class="#=styles.cardSubtitle#">#:subtitle#</h6>' +
		                '# } #' +
		                '# if (typeof text !== "undefined") { #' +
		                    '<p>#:text#</p>' +
		                '# } #' +
		            '</div>' +
		            '# if (typeof buttons !== "undefined" && buttons.length > 0) { #' +
		                '<div class="#=styles.cardActions# #=styles.cardActionsVertical#">' +
		                '# for (var i = 0; i < buttons.length; i++) { #' +
		                    '<span class="#=styles.cardAction#"><span class="#=styles.button# #=styles.buttonPrimary#" data-value="#:buttons[i].value#">#:buttons[i].title#</span></span>' +
		                '# } #' +
		                '</div>' +
		            '# } #' +
		        '</div>'
		        );
	
		    kendo.chat = {
		        Templates: {},
		        Components: {}
		    };
	
		    kendo.chat.registerTemplate = function(templateName, template) {
		        kendo.chat.Templates[templateName] = kendo.template(template);
		    };
	
		    kendo.chat.getTemplate = function(templateName) {
		        return kendo.chat.Templates[templateName] || TEXT_MESSAGE_TEMPLATE;
		    };
	
		    kendo.chat.registerTemplate("text", TEXT_MESSAGE_TEMPLATE);
		    kendo.chat.registerTemplate("message", TEXT_MESSAGE_TEMPLATE);
		    kendo.chat.registerTemplate("typing", TYPING_INDICATOR_TEMPLATE);
		    kendo.chat.registerTemplate("suggestedAction", SUGGESTED_ACTIONS_TEMPLATE);
		    kendo.chat.registerTemplate("heroCard", HERO_CARD_TEMPLATE);
		    kendo.chat.registerTemplate("application/vnd.microsoft.card.hero", HERO_CARD_TEMPLATE);
	
		    kendo.chat.registerComponent = function(componentName, component) {
		        kendo.chat.Components[componentName] = component;
		    };
	
		    kendo.chat.getComponent = function(componentName) {
		        return kendo.chat.Components[componentName] || null;
		    };
	
		    var Component = kendo.chat.Component = kendo.Class.extend({
		        init: function(options, view) {
		            this.element = $('<div></div>');
		            this.options = options;
		            this.view = view;
		        },
	
		        destroy: function() {
		            kendo.destroy(this.element);
		        }
		    });
	
		    var Calendar = Component.extend({
		        init: function(options, view) {
		            Component.fn.init.call(this, options, view);
	
		            this.element.kendoCalendar({
		                change: function() {
		                    view.trigger("suggestedAction", { text: kendo.toString(this.value(), 'd'), type: "message" });
		                }
		            });
		        },
	
		        destroy: function() {
		        }
		    });
		    kendo.chat.registerComponent("calendar", Calendar);
	
		    var viewStyles = {
		        wrapper: "k-widget k-chat",
		        messageList: "k-avatars",
		        messageListContent: "k-message-list-content",
		        messageTime: "k-message-time",
		        messageGroup: "k-message-group",
		        message: "k-message",
		        only: "k-only",
		        first: "k-first",
		        middle: "k-middle",
		        last: "k-last",
		        author: "k-author",
		        avatar: "k-avatar",
		        noAvatar: "k-no-avatar",
		        self: "k-alt",
		        button: "k-button",
		        iconButton: "k-button-icon",
		        buttonPrimary: "k-flat k-primary",
		        scrollButtonIcon: "k-icon",
		        scrollButtonIconLeft: "k-i-arrow-chevron-left",
		        scrollButtonIconRight: "k-i-arrow-chevron-right",
		        typingIndicator: "k-typing-indicator",
		        bubble: "k-bubble",
		        suggestedActions: "k-quick-replies",
		        suggestedAction: "k-quick-reply",
		        cardWrapper: "k-card-container",
		        cardDeckScrollWrap: "k-card-deck-scrollwrap",
		        cardDeck: "k-card-deck",
		        cardList: "k-card-list",
		        card: "k-card",
		        cardRich: "k-card-type-rich",
		        cardBody: "k-card-body",
		        cardImage: "k-card-image",
		        cardTitle: "k-card-title",
		        cardSubtitle: "k-card-subtitle",
		        cardActions: "k-card-actions",
		        cardActionsVertical: "k-card-actions-vertical",
		        cardAction: "k-card-action",
		        selected: "k-state-selected"
		    };
	
		    var ChatView = kendo.chat.ChatView = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this._list();
	
		            this._lastSender = null;
	
		            this._attachEvents();
	
		            this._scrollable();
		        },
	
		        events: [
		        ],
	
		        options: {
	
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            if (this._scrollDraggable) {
		                this._scrollDraggable.destroy();
		            }
	
		            this.element.empty();
		            this.element.off(NS);
	
		            this.list = null;
		            this._lastSender = null;
		        },
	
		        _list: function() {
		            var viewStyles = ChatView.styles;
	
		            this.element
		                .addClass(viewStyles.messageList)
		                .attr("aria-live", "polite");
	
		            this.list = $("<div>")
		                .addClass(viewStyles.messageListContent)
		                .appendTo(this.element);
		        },
	
		        _attachEvents: function() {
		            var styles = ChatView.styles;
	
		            this.element
		                .on("click" + NS, proxy(this._listClick, this))
		                .on("click" + NS, DOT + styles.message, proxy(this._messageClick, this))
		                .on("click" + NS, DOT + styles.suggestedAction, proxy(this._suggestedActionClick, this))
		                .on("click" + NS, DOT + styles.cardAction + SPACE + DOT + styles.button, proxy(this._cardActionClick, this));
		        },
	
		        _scrollable: function() {
		            var viewStyles = ChatView.styles;
	
		            this.element
		                .on("click" + NS, DOT + viewStyles.cardDeckScrollWrap + SPACE + DOT + viewStyles.button, proxy(this._scrollButtonClick, this));
		        },
	
		        _scrollButtonClick: function(e) {
		            var viewStyles = ChatView.styles;
		            var button = $(e.currentTarget);
		            var scrollToLeft = button.find(DOT + viewStyles.scrollButtonIconLeft).length !== 0;
		            var scrollContainer = button.siblings(DOT + viewStyles.cardDeck);
		            var lastCard = scrollContainer.find(DOT + viewStyles.card).last();
		            var cardWidth = lastCard.outerWidth(true);
	
		            if (scrollToLeft) {
		                scrollContainer.scrollLeft(scrollContainer.scrollLeft() - cardWidth);
		            } else {
		                scrollContainer.scrollLeft(scrollContainer.scrollLeft() + cardWidth);
		            }
		        },
	
		        getTemplate: function(templateName) {
		            return kendo.chat.getTemplate(templateName);
		        },
	
		        getComponent: function(type) {
		           return kendo.chat.getComponent(type);
		        },
	
		        renderMessage: function(message, sender) {
		            if (!message.timestamp) {
		                message.timestamp = new Date();
		            }
	
		            var bubbleElement = this._renderTemplate(message.type, message);
	
		            this._renderBubble(bubbleElement, sender);
	
		            if(message.type !== "typing"){
		                this._lastSender = sender.id;
		            }
		        },
	
		        renderSuggestedActions: function(suggestedActions) {
		            this._removeSuggestedActions();
	
		            var element = this._renderTemplate("suggestedAction", { suggestedActions: suggestedActions });
	
		            this.list.append(element);
	
		            this._scrollToBottom();
		        },
	
		        renderAttachments: function(options) {
		            var wrapper = this._renderAttachmentWrapper(options.attachmentLayout);
		            var cardContainer = options.attachmentLayout === "carousel" ? wrapper.find(DOT + ChatView.styles.cardDeck) : wrapper;
		            var attachments = options.attachments;
	
		            if (!attachments.length) {
		                return;
		            }
	
		            for (var i = 0; i < attachments.length; i++) {
		                var cardElement = this._renderTemplate(attachments[i].contentType, attachments[i].content);
	
		                cardContainer.append(cardElement);
		            }
	
		            this._removeSuggestedActions();
		            this._removeTypingIndicator();
	
		            this.list.append(wrapper);
	
		            this._lastSender = null;
		        },
	
		        renderComponent: function(type) {
		            var componentType = this.getComponent(type);
		            var component = new componentType({}, this);
	
		            this.list.append(component.element);
	
		            this._scrollToBottom();
		        },
	
		        _removeTypingIndicator: function() {
		            var viewStyles = ChatView.styles;
	
		            var indicator = this.list.find(DOT + viewStyles.typingIndicator);
	
		            if (indicator.length) {
		                var indicatorMessage = indicator.parents(DOT + viewStyles.message).first();
		                var indicatorGroup = indicator.parents(DOT + viewStyles.messageGroup).first();
	
		                indicatorMessage.remove();
	
		                if (!indicatorGroup.find(DOT + viewStyles.message).length &&
		                    !indicatorGroup.find(DOT + viewStyles.cardDeck).length &&
		                    !indicatorGroup.find(DOT + viewStyles.cardWrapper).length) {
		                    indicatorGroup.remove();
		                }
		            }
		        },
	
		        _renderAttachmentWrapper: function(layout) {
		            var viewStyles = ChatView.styles;
		            var wrapper = $("<div>");
	
		            if (layout === "carousel") {
		                wrapper.addClass(viewStyles.cardDeckScrollWrap);
	
		                var buttonLeft = this._renderScrollButton(viewStyles.scrollButtonIconLeft);
		                wrapper.append(buttonLeft);
	
		                wrapper.append($("<div>").addClass(viewStyles.cardDeck));
	
		                var buttonRight = this._renderScrollButton(viewStyles.scrollButtonIconRight);
		                wrapper.append(buttonRight);
		            } else {
		                wrapper.addClass(viewStyles.cardList);
		            }
	
		            return wrapper;
		        },
	
		        _renderScrollButton: function(directionClass) {
		            var viewStyles = ChatView.styles;
	
		            return $("<button>")
		                .addClass(viewStyles.button)
		                .addClass(viewStyles.iconButton)
		                .append($("<span>")
		                    .addClass(viewStyles.scrollButtonIcon)
		                    .addClass(directionClass)
		                );
		        },
	
		        _removeSuggestedActions: function() {
		            this.list.find(DOT + ChatView.styles.suggestedActions).remove();
		        },
	
		        _listClick: function(e) {
		            var styles = ChatView.styles;
		            var targetElement = $(e.target);
	
		            if (targetElement.hasClass(styles.message) || targetElement.parents(DOT + styles.message).length) {
		                return;
		            }
	
		            this._clearSelection();
		        },
	
		        _messageClick: function(e) {
		            this._clearSelection();
	
		            $(e.currentTarget).addClass(ChatView.styles.selected);
		        },
	
		        _suggestedActionClick: function(e) {
		            var text = $(e.target).data("value") || "";
	
		            this.trigger("actionClick", { text: text });
	
		            this._removeSuggestedActions();
		        },
	
		        _cardActionClick: function(e) {
		            var text = $(e.target).data("value") || "";
	
		            this.trigger("actionClick", { text: text });
		        },
	
		        _renderBubble: function(bubbleElement, sender) {
		            this._removeSuggestedActions();
		            this._removeTypingIndicator();
	
		            var group = this._getMessageGroup(sender);
	
		            this._appendToGroup(group, bubbleElement);
	
		            this._scrollToBottom();
		        },
	
		        _renderTemplate: function(type, options) {
		            var componentType = this.getComponent(type);
		            var element;
	
		            if (componentType) {
		                var component = new componentType(options, this);
	
		                element = component.element;
		            } else {
		                var template = this.getTemplate(type);
		                var templateOptions = extend(true, {}, options, { styles: ChatView.styles });
	
		                element = $(template(templateOptions));
		            }
	
		            return element;
		        },
	
		        _getMessageGroup: function(sender) {
		            var viewStyles = ChatView.styles;
		            var template = this._getMessageGroupTemplate(sender);
		            var group;
	
		            if (sender.id === this._lastSender && this._lastSender !== null) {
		                group = this.list.find(DOT + viewStyles.messageGroup).last();
	
		                if (group.length) {
		                    return group;
		                }
		            }
	
		            return $(template({text: sender.name, url: sender.iconUrl, styles: viewStyles})).appendTo(this.list);
		        },
	
		        _getMessageGroupTemplate: function(sender) {
		            var isOwnMessage = sender.id === this.options.user.id;
		            var template = isOwnMessage ?
		                SELF_MESSAGE_GROUP_TEMPLATE :
		                MESSAGE_GROUP_TEMPLATE;
	
		            return template;
		        },
	
		        _appendToGroup: function(group, messageElement) {
		            var viewStyles = ChatView.styles;
		            var children = group.find(DOT + viewStyles.message);
		            var childrenCount = children.length;
	
		            messageElement.addClass(childrenCount === 0 ? viewStyles.only : viewStyles.last);
	
		            children.filter(DOT + viewStyles.only)
		                .removeClass(viewStyles.only)
		                .addClass(viewStyles.first);
	
		            children.filter(DOT + viewStyles.last)
		                .removeClass(viewStyles.last)
		                .addClass(viewStyles.middle);
	
		            group.append(messageElement);
		        },
	
		        _clearSelection: function() {
		            var selectedClass = ChatView.styles.selected;
	
		            this.element.find(DOT + selectedClass).removeClass(selectedClass);
		        },
	
		        _scrollToBottom: function() {
		            this.element.scrollTop(this.element.prop("scrollHeight"));
		        }
		    });
	
		    extend(true, ChatView, { styles: viewStyles });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(18);
		module.exports = __webpack_require__(18);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 18:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		    var kendo = window.kendo;
		    var Widget = kendo.ui.Widget;
		    var extend = $.extend;
		    var proxy = $.proxy;
		    var DOT = ".";
		    var NS = ".kendoChat";
		    var keys = kendo.keys;
		    var SEND_ICON = '<svg version="1.1" ixmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve"><path d="M0,14.3c-0.1,0.6,0.3,0.8,0.8,0.6l14.8-6.5c0.5-0.2,0.5-0.6,0-0.8L0.8,1.1C0.3,0.9-0.1,1.1,0,1.7l0.7,4.2C0.8,6.5,1.4,7,1.9,7.1l8.8,0.8c0.6,0.1,0.6,0.1,0,0.2L1.9,8.9C1.4,9,0.8,9.5,0.7,10.1L0,14.3z"/></svg>';
		    var TOGGLE_ICON = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g>   <path d="M128,240c0-26.4-21.6-48-48-48s-48,21.6-48,48s21.6,48,48,48S128,266.4,128,240z"/>   <path d="M192,240c0,26.4,21.6,48,48,48c26.4,0,48-21.6,48-48s-21.6-48-48-48C213.6,192,192,213.6,192,240z"/>   <path d="M352,240c0,26.4,21.6,48,48,48c26.4,0,48-21.6,48-48s-21.6-48-48-48C373.6,192,352,213.6,352,240z"/></g></svg>';
	
		    var messageBoxStyles = {
		        input: "k-input",
		        button: "k-button",
		        buttonFlat: "k-flat",
		        buttonIcon: "k-button-icon",
		        buttonSend: "k-button-send",
		        buttonToggle: "k-button-toggle",
		        iconAdd: "k-icon k-i-add",
		        hidden: "k-hidden"
		    };
	
		    var ChatMessageBox = kendo.chat.ChatMessageBox = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this._wrapper();
	
		            this._attachEvents();
	
		            this._typing = false;
		        },
	
		        events: [
		        ],
	
		        options: {
		            messages: {
		                placeholder: "Type a message..."
		            }
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            if (this.input) {
		                this.input.off(NS);
		                this.input.remove();
		                this.input = null;
		            }
	
		            this.element.off(NS);
		            this.element.empty();
		        },
	
		        _wrapper: function() {
		            var styles = ChatMessageBox.styles;
		            var options = this.options;
		            var messages = options.messages;
		            var inputId = "inputId_" + kendo.guid();
	
		            $("<label>")
		                .addClass(styles.hidden)
		                .html(messages.placeholder)
		                .attr("for", inputId)
		                .appendTo(this.element);
	
		            this.input = $("<input type='text'>")
		                .addClass(styles.input)
		                .attr("id", inputId)
		                .attr("placeholder", messages.placeholder)
		                .appendTo(this.element);
	
		            if (options.toolbar && options.toolbar.toggleable && options.toolbar.buttons) {
		                $("<button>")
		                    .addClass(styles.button)
		                    .addClass(styles.buttonFlat)
		                    .addClass(styles.buttonIcon)
		                    .addClass(styles.buttonToggle)
		                    .attr("type", "button")
		                    .append($(TOGGLE_ICON))
		                    .appendTo(this.element);
		            }
	
		            $("<button>")
		                .addClass(styles.button)
		                .addClass(styles.buttonFlat)
		                .addClass(styles.buttonIcon)
		                .addClass(styles.buttonSend)
		                .append($(SEND_ICON))
		                .appendTo(this.element);
		        },
	
		        _attachEvents: function() {
		            var styles = ChatMessageBox.styles;
	
		            this.input
		                .on("keydown" + NS, proxy(this._keydown, this))
		                .on("input" + NS, proxy(this._input, this))
		                .on("focusout" + NS, proxy(this._inputFocusout, this));
	
		            this.element
		                .on("click" + NS, DOT + styles.buttonSend, proxy(this._buttonClick, this));
	
		            this.element
		                .on("click" + NS, DOT + styles.buttonToggle, proxy(this._toggleToolbar, this));
		        },
	
		        _input: function() {
		            var currentValue = this.input.val();
		            var start = currentValue.length > 0;
	
		            this._triggerTyping(start);
		        },
	
		        _keydown: function(e) {
		            var key = e.keyCode;
	
		            switch (key) {
		                case keys.ENTER:
		                    e.preventDefault();
	
		                    this._sendMessage();
		                    break;
		            }
		        },
	
		        _buttonClick: function(e) {
		            e.preventDefault();
	
		            this._sendMessage();
		        },
	
		        _sendMessage: function() {
		            var value = this.input.val();
	
		            if (!value.length) {
		                return;
		            }
	
		            this._triggerTyping(false);
	
		            var args = {
		                text: value
		            };
	
		            this.trigger("sendMessage", args);
	
		            this.input.val("");
		        },
	
		        _inputFocusout: function() {
		            this._triggerTyping(false);
		        },
	
		        _triggerTyping: function(start) {
		            if (start) {
		                if (!this._typing) {
		                    this.trigger("typingStart", {});
		                    this._typing = true;
		                }
		            } else {
		                if (this._typing) {
		                    this.trigger("typingEnd", {});
		                    this._typing = false;
		                }
		            }
		        },
	
		        _toggleToolbar: function (ev) {
		            this.trigger("toggleToolbar", { originalEvent: ev });
		        }
		    });
	
		    extend(true, ChatMessageBox, { styles: messageBoxStyles });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(20);
		module.exports = __webpack_require__(20);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 20:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		    var kendo = window.kendo;
		    var Widget = kendo.ui.Widget;
		    var extend = $.extend;
		    var proxy = $.proxy;
		    var DOT = ".";
		    var NS = ".kendoChat";
	
		    var DATA_K_BUTTON_NAME = "kButtonName";
		    var SCROLL_LEFT_NAME = "chatToolbarScrollLeft";
		    var SCROLL_RIGHT_NAME = "chatToolbarScrollRight";
		    var VISIBLE = ":visible";
		    var DEFAULT_ANIMATION = {
		        effects: "expand:vertical",
		        duration: 200
		    };
		    var NO_ANIMATION = {
		        expand: {
		            show: true
		        },
		        collapse: {
		            hide: true
		        }
		    };
	
		    var toolbarStyles = {
		        button: "k-button",
		        buttonFlat: "k-flat",
		        buttonList: "k-button-list",
		        scrollButton: "k-scroll-button",
		        scrollButtonLeft: "k-scroll-button-left",
		        scrollButtonRight: "k-scroll-button-right",
		        scrollButtonLeftIcon: "k-icon k-i-arrow-chevron-left",
		        scrollButtonRightIcon: "k-icon k-i-arrow-chevron-right",
		        buttonIcon: "k-button-icon"
		    };
	
		    var ChatToolBar = kendo.chat.ChatToolBar = Widget.extend({
		        init: function(element, options) {
		            options = extend({}, options, { name: "ChatToolbar" });
		            var toolbarOptions = options.toolbar;
		            var buttonsDefined = toolbarOptions.buttons && toolbarOptions.buttons.length;
	
		            Widget.fn.init.call(this, element, options);
	
		            if (buttonsDefined) {
		                this._createButtonList();
		            }
	
		            if (buttonsDefined && toolbarOptions.scrollable &&
		                    this.buttonsWidth() > this.element.width()) {
		                this._initScrolling();
		            }
	
		            this._setupAnimation();
	
		            if(toolbarOptions.toggleable) {
		                this.toggle(true);
		            }
	
		            this.element.on("click" + NS, proxy(this._onClick, this));
		        },
	
		        events: [
		            "click"
		        ],
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this.element.off(NS);
		            this.element.empty();
		        },
	
		        _createButtonList: function () {
		            var that = this;
		            var styles = ChatToolBar.styles;
		            var buttons = that.options.toolbar.buttons;
		            var buttonList = $("<div class='" + styles.buttonList + "'></div>");
	
		            for(var i = 0; i < buttons.length; i++) {
		                var button = that._createButton(buttons[i]);
		                buttonList.append(button);
		            }
	
		            buttonList.appendTo(this.element);
	
		            this.buttonList = buttonList;
		        },
	
		        _createButton: function (btnOptions) {
		            var styles = ChatToolBar.styles;
		            var buttonElm = $("<button>");
	
		            if (typeof btnOptions === "string") {
		                btnOptions = {
		                    name: btnOptions
		                };
		            }
	
		            buttonElm
		                .attr(btnOptions.attr || {})
		                .attr("title", btnOptions.text)
		                .attr("type", "button")
		                .addClass(btnOptions.name)
		                .data(DATA_K_BUTTON_NAME, btnOptions.name)
		                .addClass(styles.button);
	
		            if (btnOptions.iconClass) {
		                buttonElm.addClass(styles.buttonIcon);
		                buttonElm.prepend("<span class='" + btnOptions.iconClass + "'></span>");
		            }
	
		            return buttonElm;
		        },
	
		        _onClick: function (ev) {
		            var styles = ChatToolBar.styles;
		            var target = $(ev.target).closest(DOT + styles.button);
	
		            if (target.is(DOT + styles.scrollButton) && !this._scrolling) {
		                this._scroll(target.data(DATA_K_BUTTON_NAME));
		            }
	
		            if(target.data(DATA_K_BUTTON_NAME)) {
		                this.trigger("click", {
		                    button: target[0],
		                    name: target.data(DATA_K_BUTTON_NAME),
		                    originalEvent: ev
		                });
		            }
		        },
	
		        _initScrolling: function () {
		            var styles = ChatToolBar.styles;
	
		            this.scrollButtonLeft = this._createButton({
		                name: SCROLL_LEFT_NAME,
		                iconClass: styles.scrollButtonLeftIcon,
		                attr: {
		                    "class": styles.scrollButton + " " + styles.scrollButtonLeft
		                }
		            });
	
		            this.scrollButtonRight = this._createButton({
		                name: SCROLL_RIGHT_NAME,
		                iconClass: styles.scrollButtonRightIcon,
		                attr: {
		                    "class": styles.scrollButton + " " + styles.scrollButtonRight
		                }
		            });
	
		            this.element.prepend(this.scrollButtonLeft);
		            this.element.append(this.scrollButtonRight);
		            this._refreshScrollButtons();
	
		            this.element.on("keydown" + NS, proxy(this._refreshScrollButtons, this));
		        },
	
		        _scroll: function (commandName) {
		            var that = this;
		            var buttonWidth = that.buttonWidth();
		            var maxScrollSize = this.maxScrollSize();
		            var scrollAmmount = commandName === SCROLL_LEFT_NAME ? buttonWidth * -1 : buttonWidth;
		            var currentScroll = this.currentScrollLeft();
		            var scrollValue = currentScroll + scrollAmmount;
		            scrollValue = Math.min(Math.max(scrollValue, 0), maxScrollSize);
	
		            if(commandName !== SCROLL_LEFT_NAME && commandName !== SCROLL_RIGHT_NAME) {
		                return;
		            }
	
		            that.buttonList.scrollLeft(scrollValue);
		            that._refreshScrollButtons(scrollValue);
		        },
	
		        _refreshScrollButtons: function (value) {
		            var maxScrollSize = this.maxScrollSize();
		            var currentScrollLeft = value === undefined || isNaN(parseInt(value, 10)) ? this.currentScrollLeft() : value;
	
		            if(!this.scrollButtonLeft && !this.scrollButtonRight) {
		                return;
		            }
	
		            this.scrollButtonLeft.toggle(currentScrollLeft !== 0);
		            this.scrollButtonRight.toggle(currentScrollLeft !== maxScrollSize);
		        },
	
		        _setupAnimation: function () {
		            var animation = this.options.toolbar.animation;
		            var defaultExpandAnimation = extend({}, DEFAULT_ANIMATION);
		            var defaultCollapseAnimation = extend({
		                reverse: true,
		                hide: true
		            }, DEFAULT_ANIMATION);
	
		            if (animation === false){
		                animation = extend(true, {}, NO_ANIMATION);
		            }  else {
		                animation = extend(true, {
		                    expand: defaultExpandAnimation,
		                    collapse: defaultCollapseAnimation
		                }, animation);
		            }
	
		            this.options.toolbar.animation = animation;
		        },
	
		        _animationComplete: function () {
		            this._refreshScrollButtons();
		        },
	
		        currentScrollLeft: function () {
		            return Math.round(this.buttonList.scrollLeft());
		        },
	
		        maxScrollSize: function () {
		            return Math.round(this.buttonList[0].scrollWidth - this.buttonList[0].clientWidth);
		        },
	
		        buttons: function () {
		            var styles = ChatToolBar.styles;
		            return this.buttonList ? this.buttonList.children(DOT + styles.button) : null;
		        },
	
		        buttonWidth: function () {
		            return Math.round(this.buttons().last().outerWidth(true));
		        },
	
		        buttonsWidth: function () {
		            var width = 0;
	
		            if(this.buttons()) {
		                width = this.buttonWidth() * this.buttons().length;
		            }
	
		            return width;
		        },
	
		        toggle: function (skipAnimation) {
		            var animation = this.options.toolbar.animation;
	
		            if (skipAnimation) {
		                animation = extend(true, {}, NO_ANIMATION);
		            }
	
		            animation.expand.complete = proxy(this._animationComplete, this);
		            animation.collapse.complete = proxy(this._animationComplete, this);
	
		            if(this.element.is(VISIBLE)) {
		                this.element.kendoStop().kendoAnimate(animation.collapse);
		            } else {
		                this.element.kendoStop().kendoAnimate(animation.expand);
		            }
	
		        }
		    });
	
		    extend(true, ChatToolBar, { styles: toolbarStyles });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1026);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1026:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "buttongroup",
		    name: "ButtonGroup",
		    category: "web",
		    description: "The Kendo ButtonGroup widget is a linear set of grouped buttons.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo;
		    var ui = kendo.ui;
		    var Widget = ui.Widget;
		    var keys = kendo.keys;
		    var proxy = $.proxy;
		    var template = kendo.template;
		    var NS = ".kendoButtonGroup";
		    var KWIDGET = "k-widget";
		    var KBUTTONGROUP = "k-button-group";
		    var KBUTTON = "k-button";
		    var KBUTTONICONTEXT = "k-button-icontext";
		    var KBUTTONICON = "k-button-icon";
		    var ACTIVE = "k-state-active";
		    var FOCUSED = "k-state-focused";
		    var DISABLED = "k-state-disabled";
		    var SELECT = "select";
		    var CLICK = "click";
		    var KEYDOWN = "keydown";
		    var FOCUS = "focus";
		    var BLUR = "blur";
		    var MOUSEDOWN = "mousedown";
		    var templates = {
		        item: template('<span class="#= item.selected ? " ' + ACTIVE + '" : "" #" ' +
		                        '#= item.enabled === false ? \"disabled\" : "" # ' +
		                        '# if (item.badge) { #' +
		                            kendo.attr("badge") + '="#=item.badge#"' +
		                        '# } #' +
		                        '>' +
		                        '#= icon(iconClass) #' +
		                        '#= image(item) #' +
		                        '#= text #' +
		                        '</span>'),
		        image: template('<img alt="icon" src="#=data.imageUrl#" />'),
		        icon: template('<span class="#=data#" />'),
		        empty: template("")
		    };
	
		    function createBadge(value, item) {
		        if (value === undefined) {
		            return;
		        }
		        $('<span class="k-badge">' + kendo.htmlEncode(value) + '</span>').appendTo(item);
		    }
	
		    var ButtonGroup = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            that.wrapper = that.element;
	
		            if (that.options.items) {
		                that._renderItems(that.options.items);
		            }
	
		            that.selectedIndices = [];
	
		            that.element
		                    .addClass(KWIDGET + " " + KBUTTONGROUP)
		                    .attr("role", "group")
		                    .attr("tabindex", that.element.attr("tabindex") || "0")
		                    .children().each(function () {
		                        var item = $(this);
		                        that._updateClasses.bind(that)(item);
		                    });
	
	
		            that._enable = true;
		            if(!that.options.enable) {
		                that._enable = false;
		                that.element
		                        .attr("aria-disabled", true)
		                        .addClass(DISABLED);
		            }
	
		            that.select(that.options.index);
	
		            that.element
		                    .on(CLICK + NS, "." + KBUTTON, proxy(that._click, that))
		                    .on(FOCUS + NS, proxy(that._focus, that))
		                    .on(KEYDOWN + NS, proxy(that._keyDown, that))
		                    .on(BLUR + NS, function () {
		                        that.preventFocus = false;
		                        that.element.find("." + KBUTTON).removeClass(FOCUSED);
		                    })
		                    .on(MOUSEDOWN + NS, function () {
		                        that.preventFocus = true;
		                    });
		        },
	
		        events: [
		            SELECT
		        ],
	
		        options: {
		            name: "ButtonGroup",
		            selection: "single",
		            index: -1,
		            enable: true
		        },
	
		        current: function() {
		            return this.element.find("." + ACTIVE);
		        },
	
		        _renderItems: function (items) {
		            var that = this;
	
		            items.forEach(function (item) {
		                var renderedItem = $(templates.item({
		                    image: item.imageUrl ? templates.image : templates.empty,
		                    icon: !item.imageUrl && (item.iconClass || item.icon) ? templates.icon : templates.empty,
		                    iconClass: item.iconClass || "k-icon k-i-" + item.icon,
		                    item: item,
		                    text: item.text ? item.encoded === false ? item.text : kendo.htmlEncode(item.text) : ""
		                }));
	
		                if (item.attributes) {
		                    renderedItem.attr(item.attributes);
		                }
	
		                if (item.iconClass || item.icon || item.imageUrl) {
		                    renderedItem.addClass(item.text ? "k-button-icontext" : "k-button-icon");
		                }
	
		                renderedItem.appendTo(that.element);
		            });
		        },
	
		        _focus: function () {
		            var element = $(this.element);
	
		            if (this.preventFocus) {
		                return;
		            }
	
		            if (element.find("." + ACTIVE).length) {
		                element.find("." + ACTIVE).first().focus().addClass(FOCUSED);
		            } else {
		                element.children().first().focus().addClass(FOCUSED);
		            }
		        },
	
		        _keyDown: function (e) {
		            var that = this;
		            var buttonGroup = $(that.element);
		            var focusableItems = buttonGroup.find("." + KBUTTON);
		            var focusedElement = buttonGroup.find("." + FOCUSED);
		            var currentIndex = focusableItems.index(focusedElement);
		            var isRtl =  kendo.support.isRtl(that.element);
		            var itemToFocus;
	
		            if ((e.keyCode === keys.LEFT && !isRtl) || (e.keyCode === keys.RIGHT && isRtl)) {
		                focusedElement.removeClass(FOCUSED);
		                itemToFocus = currentIndex === 0 ? focusableItems.eq(focusableItems.length - 1) : $(focusableItems[currentIndex - 1]);
		                itemToFocus.focus().addClass(FOCUSED);
		                e.preventDefault();
		            } else if ((e.keyCode === keys.LEFT && isRtl) || (e.keyCode === keys.RIGHT && !isRtl)) {
		                focusedElement.removeClass(FOCUSED);
		                itemToFocus = currentIndex + 1 === focusableItems.length ? focusableItems.eq(0) : $(focusableItems[currentIndex + 1]);
		                itemToFocus.focus().addClass(FOCUSED);
		                e.preventDefault();
		            } else if (e.keyCode === keys.ENTER || e.keyCode === keys.SPACEBAR) {
		                that._select(focusedElement);
		                e.preventDefault();
		            }
		        },
	
		        select: function (button) {
		            var that = this,
		                ariaPressed,
		                index = -1;
	
		            if (button === undefined || button === -1) {
		                return;
		            }
	
		            that.element.find("." + KBUTTON).removeClass(FOCUSED);
	
		            if (typeof button === "number") {
		                index = button;
		                button = that.element.children().eq(button);
		            } else if (button.nodeType) {
		                button = $(button);
		                index = button.index();
		            }
	
		            if (that.options.selection === "multiple") {
		                ariaPressed = button.attr("aria-pressed") === "true";
		                button
		                    .attr("aria-pressed", !ariaPressed)
		                    .toggleClass(ACTIVE);
	
		                if (that.selectedIndices.indexOf(index) === -1) {
		                    that.selectedIndices.push(index);
		                } else {
		                    that.selectedIndices.splice(that.selectedIndices.indexOf(index), 1);
		                }
	
		            } else {
		                that.selectedIndices = [];
		                that.current()
		                        .attr("aria-pressed", false)
		                        .removeClass(ACTIVE);
	
		                button
		                    .attr("aria-pressed", true)
		                    .addClass(ACTIVE);
	
		                that.selectedIndices.push(index);
		            }
	
		            that.trigger(SELECT, { indices: that.selectedIndices});
		        },
	
		        badge: function(item, value) {
		            var buttongroup = this.element;
		            var button = !isNaN(item) ? buttongroup.children().eq(item) : buttongroup.find(item);
		            var validValue = value || value === 0;
		            var badge;
	
		            if (!button.length) {
		                return;
		            }
	
		            badge = button.children(".k-badge").eq(0);
		            if (!badge.length && validValue) {
		                createBadge(kendo.htmlEncode(value), button);
		                return kendo.htmlEncode(value);
		            }
	
		            if (validValue) {
		                badge.html(kendo.htmlEncode(value));
		            } else if (value === false) {
		                badge.empty().remove();
		                return;
		            }
	
		            return badge.html();
		        },
	
		        enable: function(enable) {
		            if(typeof enable == "undefined") {
		                enable = true;
		            }
	
		            this.element
		                    .attr("aria-disabled", !enable)
		                    .toggleClass(DISABLED, !enable);
	
		            this._enable = this.options.enable = enable;
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.element.off(NS);
	
		            Widget.fn.destroy.call(that);
		        },
	
		        _updateClasses: function(button) {
		            var icon = kendo.attrValue(button, "icon");
		            var badge = kendo.attrValue(button, "badge");
		            var image = button.find("img").addClass("k-image");
		            var isEmpty = true;
	
		            button
		                .attr("aria-pressed", false)
		                .attr("role", "button")
		                .addClass(KBUTTON);
	
		            if (button.is("[disabled]") || button.hasClass(DISABLED)) {
		                button
		                    .addClass(DISABLED)
		                    .attr("aria-disabled", true)
		                    .removeAttr("disabled");
		            }
	
		            if (button.is("." + ACTIVE)) {
		                button.removeClass(ACTIVE);
		                if ((!button.hasClass(DISABLED) && this.options.selection === "single") ||
		                    this.options.selection === "multiple") {
		                    this.select(button[0]);
		                }
		            }
	
		            if (!image[0] && icon) {
		                button.prepend($(templates.icon("k-icon k-i-" + icon)));
		            }
	
		            button
		                .contents()
		                .filter(function() {
		                    return !$(this).hasClass("k-icon") && !$(this).hasClass("k-image");
		                }).each(function(){
		                    if (this.nodeType == 1 || this.nodeType == 3 && $.trim(this.nodeValue).length > 0) {
		                        isEmpty = false;
		                    }
		                });
	
		            if (image[0] || icon) {
		                button.addClass(isEmpty ? KBUTTONICON : KBUTTONICONTEXT);
		            }
	
		            if (badge || badge === 0) {
		                createBadge(badge, button);
		            }
		        },
	
		        _click: function(e) {
		            var target = $(e.target).closest("." + KBUTTON);
	
		            if (e.isDefaultPrevented()) {
		                return;
		            }
	
		            this._select(target);
		        },
	
		        _select: function (target) {
		            var button = target;
	
		            this.element.find("." + KBUTTON).removeClass(FOCUSED);
	
		            if (!this._enable || button.is("." + DISABLED)) {
		                button.addClass(FOCUSED);
		                return;
		            }
	
		            this.select(target[0]);
		            button.addClass(FOCUSED);
		        }
		    });
	
		    ui.plugin(ButtonGroup);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1253);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1007:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(561);
	
	/***/ }),
	
	/***/ 1253:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1007) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "multicolumncombobox",
		    name: "MultiColumnComboBox",
		    category: "web",
		    description: "The MultiColumnComboBox widget allows the selection from pre-defined values or entering a new value where the list popup is rendered in table layout.",
		    depends: [ "combobox" ],
		    features: [ {
		        id: "mobile-scroller",
		        name: "Mobile scroller",
		        description: "Support for kinetic scrolling in mobile device",
		        depends: [ "mobile.scroller" ]
		    }, {
		        id: "virtualization",
		        name: "VirtualList",
		        description: "Support for virtualization",
		        depends: [ "virtuallist" ]
		    } ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        ComboBox = ui.ComboBox,
		        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
		        MCCOMBOBOX = "k-dropdowngrid",
		        POPUPCLASS = "k-dropdowngrid-popup k-popup-flush";
	
		    var MultiColumnComboBox = ComboBox.extend({
		        init: function(element, options) {
		            ComboBox.fn.init.call(this, element, options);
		            this.list.addClass(POPUPCLASS);
	
		            if (this._allColumnsWidthsAreSet(this.options)) {
		                this.list.width(this._calculateDropDownWidth(this.options));
		            } else if (this.options.dropDownWidth) {
		                this.list.width(this.options.dropDownWidth);
		            }
		        },
	
		        options: {
		            name: "MultiColumnComboBox",
		            ns: ".kendoMultiColumnComboBox",
		            columns: [],
		            dropDownWidth: null,
		            filterFields: []
		        },
	
		        setOptions: function(options) {
		            ComboBox.fn.setOptions.call(this, options);
		            if (this._allColumnsWidthsAreSet(options)) {
		                this.list.width(this._calculateDropDownWidth(options));
		            } else if (this.options.dropDownWidth) {
		                this.list.width(this.options.dropDownWidth);
		            }
		        },
	
		        _allColumnsWidthsAreSet: function (options) {
		            var columns = options.columns;
	
		            if (!columns || !columns.length) {
		                return false;
		            }
	
		            for (var i = 0; i < columns.length; i++) {
		                var currentWidth = columns[i].width;
		                if(!currentWidth  || isNaN(parseInt(currentWidth, 10)) || percentageUnitsRegex.test(currentWidth)){
		                    return false;
		                }
		            }
	
		            return true;
		        },
	
		        _calculateDropDownWidth: function (options) {
		            var columns = options.columns;
		            var totalWidth = kendo.support.scrollbar();
	
		            for (var i = 0; i < columns.length; i++) {
		                var currentWidth = columns[i].width;
		                totalWidth = totalWidth + parseInt(currentWidth, 10);
		            }
	
		            return totalWidth;
		        },
	
		        _wrapper: function() {
		            ComboBox.fn._wrapper.call(this);
		            this.wrapper.addClass(MCCOMBOBOX);
		        }
		    });
	
		    ui.plugin(MultiColumnComboBox);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1135);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1007:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(561);
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1134:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(592);
	
	/***/ }),
	
	/***/ 1135:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1007), __webpack_require__(1008), __webpack_require__(1137), __webpack_require__(1138), __webpack_require__(1139), __webpack_require__(1140), __webpack_require__(1141), __webpack_require__(1134),
	
		        __webpack_require__(1142),
		        __webpack_require__(1143),
		        __webpack_require__(1144),
		        __webpack_require__(1145),
		        __webpack_require__(1146),
		        __webpack_require__(1147),
		        __webpack_require__(1148),
		        __webpack_require__(1149),
		        __webpack_require__(1150),
	
		        __webpack_require__(1151),
		        __webpack_require__(1152),
		        __webpack_require__(1153),
		        __webpack_require__(1154),
		        __webpack_require__(1136),
		        __webpack_require__(1155),
		        __webpack_require__(1156),
		        __webpack_require__(1157),
		        __webpack_require__(1158),
		        __webpack_require__(1159),
		        __webpack_require__(1160),
		        __webpack_require__(1161),
		        __webpack_require__(1162),
		        __webpack_require__(1163),
		        __webpack_require__(1164),
		        __webpack_require__(1165),
		        __webpack_require__(1166),
		        __webpack_require__(1167),
		        __webpack_require__(1168),
	
		        __webpack_require__(1169),
		        __webpack_require__(1170),
		        __webpack_require__(1171),
		        __webpack_require__(1172),
		        __webpack_require__(1173),
		        __webpack_require__(1174)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    var __meta__ = { // jshint ignore:line
		        id: "editor",
		        name: "Editor",
		        category: "web",
		        description: "Rich text editor component",
		        depends: [ "combobox", "dropdownlist", "window", "colorpicker" ],
		        features: [ {
		            id: "editor-imagebrowser",
		            name: "Image Browser",
		            description: "Support for uploading and inserting images",
		            depends: [ "imagebrowser" ]
		        }, {
		            id: "editor-resizable",
		            name: "Resize handle",
		            description: "Support for resizing the content area via a resize handle",
		            depends: [ "resizable" ]
		        }, {
		            id: "editor-tablewizard",
		            name: "Table wizard dialog",
		            description: "Support for table properties configuration",
		            depends: [ "tabstrip", "button", "numerictextbox" ]
		        }, {
		            id: "editor-pdf-export",
		            name: "PDF export",
		            description: "Export Editor content as PDF",
		            depends: [ "pdf", "drawing" ]
		        }]
		    };
	
			return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1136:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(655);
	
	/***/ }),
	
	/***/ 1137:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(593);
	
	/***/ }),
	
	/***/ 1138:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1139:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(595);
	
	/***/ }),
	
	/***/ 1140:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(596);
	
	/***/ }),
	
	/***/ 1141:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(601);
	
	/***/ }),
	
	/***/ 1142:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(663);
	
	/***/ }),
	
	/***/ 1143:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 1144:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(661);
	
	/***/ }),
	
	/***/ 1145:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(660);
	
	/***/ }),
	
	/***/ 1146:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(658);
	
	/***/ }),
	
	/***/ 1147:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 1148:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(659);
	
	/***/ }),
	
	/***/ 1149:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(664);
	
	/***/ }),
	
	/***/ 1150:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(657);
	
	/***/ }),
	
	/***/ 1151:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(665);
	
	/***/ }),
	
	/***/ 1152:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(666);
	
	/***/ }),
	
	/***/ 1153:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(669);
	
	/***/ }),
	
	/***/ 1154:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(671);
	
	/***/ }),
	
	/***/ 1155:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(672);
	
	/***/ }),
	
	/***/ 1156:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(673);
	
	/***/ }),
	
	/***/ 1157:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(674);
	
	/***/ }),
	
	/***/ 1158:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(675);
	
	/***/ }),
	
	/***/ 1159:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(676);
	
	/***/ }),
	
	/***/ 1160:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(668);
	
	/***/ }),
	
	/***/ 1161:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(667);
	
	/***/ }),
	
	/***/ 1162:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(670);
	
	/***/ }),
	
	/***/ 1163:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(677);
	
	/***/ }),
	
	/***/ 1164:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(678);
	
	/***/ }),
	
	/***/ 1165:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(679);
	
	/***/ }),
	
	/***/ 1166:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(680);
	
	/***/ }),
	
	/***/ 1167:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(681);
	
	/***/ }),
	
	/***/ 1168:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(682);
	
	/***/ }),
	
	/***/ 1169:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(683);
	
	/***/ }),
	
	/***/ 1170:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(686);
	
	/***/ }),
	
	/***/ 1171:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(687);
	
	/***/ }),
	
	/***/ 1172:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(688);
	
	/***/ }),
	
	/***/ 1173:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(689);
	
	/***/ }),
	
	/***/ 1174:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(690);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(958);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 958:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(959), __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    extend = $.extend,
		    Editor = kendo.ui.editor,
		    EditorUtils = Editor.EditorUtils,
		    dom = Editor.Dom,
		    registerTool = EditorUtils.registerTool,
		    ToolTemplate = Editor.ToolTemplate,
		    RangeUtils = Editor.RangeUtils,
		    Command = Editor.Command,
		    keys = kendo.keys,
		    KEDITORIMAGEURL = "#k-editor-image-url",
		    KEDITORIMAGETITLE = "#k-editor-image-title",
		    KEDITORIMAGEWIDTH = "#k-editor-image-width",
		    KEDITORIMAGEHEIGHT = "#k-editor-image-height";
	
		var ImageCommand = Command.extend({
		    init: function(options) {
		        var that = this;
		        Command.fn.init.call(that, options);
	
		        that.async = true;
		        that.attributes = {};
		    },
	
		    insertImage: function(img, range) {
		        var attributes = this.attributes;
		        var doc = RangeUtils.documentFromRange(range);
	
		        if (attributes.src && attributes.src != "http://") {
	
		            var removeIEAttributes = function() {
		                setTimeout(function(){
		                    if (!attributes.width) {
		                        img.removeAttribute("width");
		                    }
	
		                    if (!attributes.height) {
		                        img.removeAttribute("height");
		                    }
	
		                    img.removeAttribute("complete");
		                });
		            };
	
		            if (!img) {
		                img = dom.create(doc, "img", attributes);
		                img.onload = img.onerror = removeIEAttributes;
	
		                range.deleteContents();
		                range.insertNode(img);
	
		                if (!img.nextSibling) {
		                    dom.insertAfter(doc.createTextNode("\ufeff"), img);
		                }
	
		                removeIEAttributes();
	
		                range.setStartAfter(img);
		                range.setEndAfter(img);
		                RangeUtils.selectRange(range);
		                return true;
		            } else {
		                img.onload = img.onerror = removeIEAttributes;
		                dom.attr(img, attributes);
		                removeIEAttributes();
		            }
		        }
	
		        return false;
		    },
	
		    _dialogTemplate: function(showBrowser) {
		        return kendo.template(
		            '<div class="k-editor-dialog k-popup-edit-form">' +
		                '<div class="k-edit-form-container">' +
		                    '<div class="k-edit-form-content">' +
		                        '# if (showBrowser) { #' +
		                            '<div class="k-filebrowser k-imagebrowser"></div>' +
		                        '# } #' +
		                        "<div class='k-edit-label'>" +
		                            '<label for="k-editor-image-url">#: messages.imageWebAddress #</label>' +
		                        "</div>" +
		                        "<div class='k-edit-field'>" +
		                            '<input type="text" class="k-input k-textbox" id="k-editor-image-url">' +
		                        "</div>" +
		                        "<div class='k-edit-label'>" +
		                            '<label for="k-editor-image-title">#: messages.imageAltText #</label>' +
		                        "</div>" +
		                        "<div class='k-edit-field'>" +
		                            '<input type="text" class="k-input k-textbox" id="k-editor-image-title">' +
		                        "</div>" +
		                        "<div class='k-edit-label'>" +
		                            '<label for="k-editor-image-width">#: messages.imageWidth #</label>' +
		                        "</div>" +
		                        "<div class='k-edit-field'>" +
		                            '<input type="text" class="k-input k-textbox" id="k-editor-image-width">' +
		                        "</div>" +
		                        "<div class='k-edit-label'>" +
		                            '<label for="k-editor-image-height">#: messages.imageHeight #</label>' +
		                        "</div>" +
		                        "<div class='k-edit-field'>" +
		                            '<input type="text" class="k-input k-textbox" id="k-editor-image-height">' +
		                        "</div>" +
		                    '</div>' +
		                    '<div class="k-edit-buttons k-state-default">' +
		                        '<button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button>' +
		                        '<button class="k-dialog-close k-button">#: messages.dialogCancel #</button>' +
		                    '</div>' +
		                '</div>' +
		            '</div>'
		        )({
		            messages: this.editor.options.messages,
		            showBrowser: showBrowser
		        });
		    },
	
		    redo: function () {
		        var that = this,
		            range = that.lockRange();
	
		        if (!that.insertImage(RangeUtils.image(range), range)) {
		            that.releaseRange(range);
		        }
		    },
	
		    exec: function () {
		        var that = this,
		            range = that.lockRange(),
		            applied = false,
		            img = RangeUtils.image(range),
		            imageWidth = img && img.getAttribute("width") || "",
		            imageHeight = img && img.getAttribute("height") || "",
		            dialog,
		            isIE = kendo.support.browser.msie,
		            options = that.editor.options,
		            messages = options.messages,
		            imageBrowser = options.imageBrowser,
		            showBrowser = !!(kendo.ui.ImageBrowser && imageBrowser && imageBrowser.transport && imageBrowser.transport.read !== undefined),
		            dialogOptions = {
		                title: messages.insertImage,
		                visible: false,
		                resizable: showBrowser
		            };
	
		        this.expandImmutablesIn(range);
	
		        function apply(e) {
		            var element = dialog.element,
		                w = parseInt(element.find(KEDITORIMAGEWIDTH).val(), 10),
		                h = parseInt(element.find(KEDITORIMAGEHEIGHT).val(), 10);
	
		            that.attributes = {
		                src: element.find(KEDITORIMAGEURL).val().replace(/ /g, "%20"),
		                alt: element.find(KEDITORIMAGETITLE).val()
		            };
	
		            that.attributes.width = null;
		            that.attributes.height = null;
	
		            if (!isNaN(w) && w > 0) {
		                that.attributes.width = w;
		            }
	
		            if (!isNaN(h) && h > 0) {
		                that.attributes.height = h;
		            }
	
		            applied = that.insertImage(img, range);
	
		            close(e);
	
		            if (that.change) {
		                that.change();
		            }
		        }
	
		        function close(e) {
		            e.preventDefault();
		            dialog.destroy();
	
		            dom.windowFromDocument(RangeUtils.documentFromRange(range)).focus();
		            if (!applied) {
		                that.releaseRange(range);
		            }
		        }
	
		        function keyDown(e) {
		            if (e.keyCode == keys.ENTER) {
		                apply(e);
		            } else if (e.keyCode == keys.ESC) {
		                close(e);
		            }
		        }
	
		        dialogOptions.close = close;
	
		        if (showBrowser) {
		            dialogOptions.width = 750;
		        }
	
		        dialog = this.createDialog(that._dialogTemplate(showBrowser), dialogOptions)
		            .toggleClass("k-filebrowser-dialog", showBrowser)
		            .find(".k-dialog-insert").click(apply).end()
		            .find(".k-dialog-close").click(close).end()
		            .find(".k-edit-field input").keydown(keyDown).end()
		            // IE < 8 returns absolute url if getAttribute is not used
		            .find(KEDITORIMAGEURL).val(img ? img.getAttribute("src", 2) : "http://").end()
		            .find(KEDITORIMAGETITLE).val(img ? img.alt : "").end()
		            .find(KEDITORIMAGEWIDTH).val(imageWidth).end()
		            .find(KEDITORIMAGEHEIGHT).val(imageHeight).end()
		            .data("kendoWindow");
	
		        var element = dialog.element;
		        if (showBrowser) {
		            this._imageBrowser = new kendo.ui.ImageBrowser(
		                element.find(".k-imagebrowser"),
		                extend({}, imageBrowser)
		            );
	
		            this._imageBrowser.bind("change", function (ev) {
		                if (ev.selected.get("type") === "f") {
		                    element.find(KEDITORIMAGEURL).val(this.value());
		                }
		            });
	
		            this._imageBrowser.bind("apply", apply);
		        }
	
		        if(isIE) {
		            var dialogHeight = element.closest(".k-window").height();
		            element.css("max-height", dialogHeight);
		        }
		        dialog.center().open();
		        element.find(KEDITORIMAGEURL).focus().select();
		    }
	
		});
	
		kendo.ui.editor.ImageCommand = ImageCommand;
	
		registerTool("insertImage", new Editor.Tool({ command: ImageCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert Image" }) }));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 959:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(596);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(932);
		module.exports = __webpack_require__(932);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 932:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(933) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        Class = kendo.Class,
		        editorNS = kendo.ui.editor,
		        dom = editorNS.Dom,
		        RestorePoint = editorNS.RestorePoint,
		        Marker = editorNS.Marker,
		        extend = $.extend;
	
		function finishUpdate(editor, startRestorePoint) {
		    var endRestorePoint = editor.selectionRestorePoint = new RestorePoint(editor.getRange(), editor.body);
		    var command = new GenericCommand(startRestorePoint, endRestorePoint);
		    command.editor = editor;
	
		    editor.undoRedoStack.push(command);
	
		    return endRestorePoint;
		}
	
		var Command = Class.extend({
		    init: function(options) {
		        this.options = options;
		        this.restorePoint = new RestorePoint(options.range, options.body, {immutables: options.immutables});
		        this.marker = new Marker();
		        this.formatter = options.formatter;
		    },
	
		    getRange: function () {
		        return this.restorePoint.toRange();
		    },
	
		    lockRange: function (expand) {
		        return this.marker.add(this.getRange(), expand);
		    },
	
		    releaseRange: function (range) {
		        this.marker.remove(range);
		        this.editor.selectRange(range);
		    },
	
		    undo: function () {
		        var point = this.restorePoint;
		        point.restoreHtml();
		        this.editor.selectRange(point.toRange());
		    },
	
		    redo: function () {
		        this.exec();
		    },
	
		    createDialog: function (content, options) {
		        var editor = this.editor;
	
		        return $(content).appendTo(document.body)
		            .kendoWindow(extend({}, editor.options.dialogOptions, options))
		            .closest(".k-window").toggleClass("k-rtl", kendo.support.isRtl(editor.wrapper)).end();
		    },
	
		    exec: function () {
		        var range = this.lockRange(true);
		        this.formatter.editor = this.editor;
		        this.formatter.toggle(range);
		        this.releaseRange(range);
		    },
	
		    immutables: function(){
		        return this.editor && this.editor.options.immutables;
		    },
	
		    expandImmutablesIn: function(range) {
		        if (this.immutables()) {
		            kendo.ui.editor.Immutables.expandImmutablesIn(range);
		            this.restorePoint = new RestorePoint(range, this.editor.body);
		        }
		    }
		});
	
		var GenericCommand = Class.extend({
		    init: function(startRestorePoint, endRestorePoint) {
		        this.body = startRestorePoint.body;
		        this.startRestorePoint = startRestorePoint;
		        this.endRestorePoint = endRestorePoint;
		    },
	
		    redo: function () {
		        dom.removeChildren(this.body);
	
		        this.body.innerHTML = this.endRestorePoint.html;
		        this.editor.selectRange(this.endRestorePoint.toRange());
		    },
	
		    undo: function () {
		        dom.removeChildren(this.body);
	
		        this.body.innerHTML = this.startRestorePoint.html;
		        this.editor.selectRange(this.startRestorePoint.toRange());
		    }
		});
	
		extend(editorNS, {
		    _finishUpdate: finishUpdate,
		    Command: Command,
		    GenericCommand: GenericCommand
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 933:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(657);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(938);
		module.exports = __webpack_require__(938);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 938:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(939) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Class = kendo.Class,
		        Editor = kendo.ui.editor,
		        dom = Editor.Dom,
		        template = kendo.template,
		        RangeUtils = Editor.RangeUtils,
		        complexBlocks = ["ul", "ol", "tbody", "thead", "table"],
		        toolsToBeUpdated = [
		            "bold",
		            "italic",
		            "underline",
		            "strikethrough",
		            "superscript",
		            "subscript",
		            "forecolor",
		            "backcolor",
		            "fontname",
		            "fontsize",
		            "createlink",
		            "unlink",
		            "autolink",
		            "addcolumnleft",
		            "addcolumnright",
		            "addrowabove",
		            "addrowbelow",
		            "deleterow",
		            "deletecolumn",
		            "mergecells",
		            "formatting",
		            "cleanformatting" ],
		        IMMUTABALE = "k-immutable",
		        IMMUTABALE_MARKER_SELECTOR = "[" + IMMUTABALE + "]",
		        IMMUTABLE_SELECTOR = "[contenteditable='false']";
	
		    var rootCondition = function(node) {
		        return $(node).is("body,.k-editor");
		    };
	
		    var immutable = function(node) {
		        return node.getAttribute && node.getAttribute("contenteditable") == "false";
		    };
	
		    var immutableParent = function (node) {
		        return dom.closestBy(node, immutable, rootCondition);
		    };
	
		    var expandImmutablesIn = function(range) {
		        var startImmutableParent = immutableParent(range.startContainer);
		        var endImmutableParent = immutableParent(range.endContainer);
	
		        if (startImmutableParent || endImmutableParent) {
		            if (startImmutableParent){
		                range.setStartBefore(startImmutableParent);
		            }
		            if (endImmutableParent){
		                range.setEndAfter(endImmutableParent);
		            }
		        }
		    };
	
		    var immutablesContext = function(range) {
		        if (immutableParent(range.commonAncestorContainer)) {
		            return true;
		        } else if(immutableParent(range.startContainer) || immutableParent(range.endContainer)){
		            var editableNodes = RangeUtils.editableTextNodes(range);
		            if (editableNodes.length === 0){
		                return true;
		            }
		        }
		        return false;
		    };
	
		    var randomId = function(length) {
		        var result = '';
		        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
		        for (var i = length || 10; i > 0; --i) {
		            result += chars.charAt(Math.round(Math.random() * (chars.length - 1)));
		        }
		        return result;
		    };
	
		    var removeImmutables = function (root) {
		        var serializedImmutables = {empty: true}, nodeName, id, serialized;
		         $(root).find(IMMUTABLE_SELECTOR).each(function(i, node){
		            nodeName = dom.name(node);
		            id = randomId();
		            serialized = "<" + nodeName + " " + IMMUTABALE + "='" + id + "'></" + nodeName + ">";
		            serializedImmutables[id] = {node: node, style: $(node).attr("style")};
		            serializedImmutables.empty = false;
		            $(node).replaceWith(serialized);
		        });
	
		        return serializedImmutables;
		    };
	
		    var restoreImmutables = function(root, serializedImmutables) {
		        var id, immutable;
		        $(root).find(IMMUTABALE_MARKER_SELECTOR).each(function(i, node) {
		            id = node.getAttribute(IMMUTABALE);
		            immutable = serializedImmutables[id];
		            $(node).replaceWith(immutable.node);
		            if (immutable.style != $(immutable.node).attr("style")) {
		                $(immutable.node).removeAttr("style").attr("style", immutable.style);
		            }
		        });
		    };
	
		    var deletingKey = function (keyCode) {
		        var keys = kendo.keys;
		        return keyCode === keys.BACKSPACE || keyCode == keys.DELETE;
		    };
		    var updateToolOptions = function(tool) {
		        var options = tool ? tool.options : undefined;
		        if (options && options.finder) {
		            options.finder._initOptions({immutables: true});
		        }
		    };
	
		    var Immutables = Class.extend({
		        init: function (editor) {
		            this.editor = editor;
		            this.serializedImmutables = {};
		            this.options = $.extend({}, editor && editor.options && editor.options.immutables);
	
		            var tools = editor.toolbar.tools;
		            updateToolOptions(tools.justifyLeft);
		            updateToolOptions(tools.justifyCenter);
		            updateToolOptions(tools.justifyRight);
		            updateToolOptions(tools.justifyFull);
		        },
	
		        serialize: function(node) {
		            var result = this._toHtml(node),
		                id;
	
		            if (result.indexOf(IMMUTABALE) === -1) {
		                id = this.randomId();
		                result = result.replace(/>/, ' ' + IMMUTABALE + '="' + id + '">');
		            } else {
		                id = result.match(/k-immutable\s*=\s*['"](.*)['"]/)[1];
		            }
	
		            this.serializedImmutables[id] = node;
		            return result;
		        },
	
		        _toHtml: function(node){
		            var serialization = this.options.serialization;
		            var serializationType = typeof serialization;
		            var nodeName;
	
		            switch (serializationType) {
		                case "string":
		                    return template(serialization)(node);
		                case "function":
		                    return serialization(node);
		                default:
		                    nodeName = dom.name(node);
		                    return "<" + nodeName + "></" + nodeName + ">";
		            }
		        },
	
		        deserialize: function(node) {
		            var that = this;
		            var deserialization = this.options.deserialization;
	
		            $(IMMUTABALE_MARKER_SELECTOR, node).each(function() {
		                var id = this.getAttribute(IMMUTABALE);
		                var immutable = that.serializedImmutables[id];
		                if (kendo.isFunction(deserialization)) {
		                    deserialization(this, immutable);
		                }
		                $(this).replaceWith(immutable);
		            });
	
		            that.serializedImmutables = {};
		        },
	
		        randomId: function (length) {
		            return randomId(length);
		        },
	
		        keydown: function(e, range) {
		            var isDeleting = deletingKey(e.keyCode);
		            var shouldCancelEvent = (isDeleting && this._cancelDeleting(e, range)) ||
		                (!isDeleting && this._cancelTyping(e, range));
	
		            if (shouldCancelEvent) {
		                e.preventDefault();
		                return true;
		            }
		        },
	
		        _cancelTyping: function(e, range) {
		            var editor = this.editor;
		            var keyboard = editor.keyboard;
	
		            return range.collapsed && !keyboard.typingInProgress &&
		                keyboard.isTypingKey(e) && immutablesContext(range);
		        },
	
		        _cancelDeleting: function(e, range) {
		            var keys = kendo.keys;
		            var backspace = e.keyCode === keys.BACKSPACE;
		            var del = e.keyCode == keys.DELETE;
	
		            if (!backspace && !del) {
		                return false;
		            }
		            var cancelDeleting = false;
		            if (range.collapsed) {
		                if (immutablesContext(range)) {
		                    return true;
		                }
		                var immutable = this.nextImmutable(range, del);
		                if (immutable && backspace) {
		                    var closestSelectionLi = dom.closest(range.commonAncestorContainer, "li");
		                    if (closestSelectionLi) {
		                        var closestImmutableLi = dom.closest(immutable, "li");
		                        if (closestImmutableLi && closestImmutableLi !== closestSelectionLi) {
		                            return cancelDeleting;
		                        }
		                    }
		                }
		                if (immutable && !dom.tableCell(immutable)) {
		                    if (dom.parentOfType(immutable, complexBlocks) === dom.parentOfType(range.commonAncestorContainer, complexBlocks)) {
		                        while (immutable && immutable.parentNode.childNodes.length == 1) {
		                            immutable = immutable.parentNode;
		                        }
		                        if (dom.tableCell(immutable)) {
		                            return cancelDeleting;
		                        }
		                        this._removeImmutable(immutable, range);
		                    }
		                    cancelDeleting = true;
		                }
		            }
		            return cancelDeleting;
		        },
	
		        nextImmutable: function(range, forwards) {
		            var commonContainer = range.commonAncestorContainer;
		            if (dom.isBom(commonContainer) || ((forwards && RangeUtils.isEndOf(range, commonContainer)) || (!forwards && RangeUtils.isStartOf(range, commonContainer)))) {
		                var next = this._nextNode(commonContainer, forwards);
		                if (next && dom.isBlock(next) && !immutableParent(next)) {
		                    while (next && next.children && next.children[forwards ? 0 : next.children.length - 1]) {
		                        next = next.children[forwards ? 0 : next.children.length - 1];
		                    }
		                }
		                return immutableParent(next);
		            }
		        },
	
		        _removeImmutable: function(immutable, range) {
		            var editor = this.editor;
		            var startRestorePoint = new Editor.RestorePoint(range, editor.body);
		            dom.remove(immutable);
		            Editor._finishUpdate(editor, startRestorePoint);
		        },
	
		        _nextNode: function(node, forwards) {
		            var sibling = forwards ? "nextSibling" : "previousSibling";
		            var current = node, next;
		            while(current && !next) {
		                next = current[sibling];
		                if (next && dom.isDataNode(next) && /^\s|[\ufeff]$/.test(next.nodeValue)){
		                    current = next;
		                    next = current[sibling];
		                }
		                if (!next){
		                    current = current.parentNode;
		                }
		            }
		            return next;
		        }
		    });
	
		    Immutables.immutable = immutable;
		    Immutables.immutableParent = immutableParent;
		    Immutables.expandImmutablesIn = expandImmutablesIn;
		    Immutables.immutablesContext = immutablesContext;
		    Immutables.toolsToBeUpdated = toolsToBeUpdated;
		    Immutables.removeImmutables = removeImmutables;
		    Immutables.restoreImmutables = restoreImmutables;
	
		    Editor.Immutables = Immutables;
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 939:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(658);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(972);
		module.exports = __webpack_require__(972);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 972:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint boss: true */
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(973) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        Class = kendo.Class,
		        extend = $.extend,
		        Editor = kendo.ui.editor,
		        browser = kendo.support.browser,
		        dom = Editor.Dom,
		        findNodeIndex = dom.findNodeIndex,
		        isDataNode = dom.isDataNode,
		        findClosestAncestor = dom.findClosestAncestor,
		        getNodeLength = dom.getNodeLength,
		        normalize = dom.normalize;
	
		var SelectionUtils = {
		    selectionFromWindow: function(window) {
		        if (!("getSelection" in window)) {
		            return new W3CSelection(window.document);
		        }
	
		        return window.getSelection();
		    },
	
		    selectionFromRange: function(range) {
		        var rangeDocument = RangeUtils.documentFromRange(range);
		        return SelectionUtils.selectionFromDocument(rangeDocument);
		    },
	
		    selectionFromDocument: function(document) {
		        return SelectionUtils.selectionFromWindow(dom.windowFromDocument(document));
		    }
		};
	
		var W3CRange = Class.extend({
		    init: function(doc) {
		        $.extend(this, {
		            ownerDocument: doc, /* not part of the spec; used when cloning ranges, traversing the dom and creating fragments */
		            startContainer: doc,
		            endContainer: doc,
		            commonAncestorContainer: doc,
		            startOffset: 0,
		            endOffset: 0,
		            collapsed: true
		        });
		    },
	
		    // Positioning Methods
		    setStart: function (node, offset) {
		        this.startContainer = node;
		        this.startOffset = offset;
		        updateRangeProperties(this);
		        fixIvalidRange(this, true);
		    },
	
		    setEnd: function (node, offset) {
		        this.endContainer = node;
		        this.endOffset = offset;
		        updateRangeProperties(this);
		        fixIvalidRange(this, false);
		    },
	
		    setStartBefore: function (node) {
		        this.setStart(node.parentNode, findNodeIndex(node));
		    },
	
		    setStartAfter: function (node) {
		        this.setStart(node.parentNode, findNodeIndex(node) + 1);
		    },
	
		    setEndBefore: function (node) {
		        this.setEnd(node.parentNode, findNodeIndex(node));
		    },
	
		    setEndAfter: function (node) {
		        this.setEnd(node.parentNode, findNodeIndex(node) + 1);
		    },
	
		    selectNode: function (node) {
		        this.setStartBefore(node);
		        this.setEndAfter(node);
		    },
	
		    selectNodeContents: function (node) {
		        this.setStart(node, 0);
		        this.setEnd(node, node[node.nodeType === 1 ? 'childNodes' : 'nodeValue'].length);
		    },
	
		    collapse: function (toStart) {
		        var that = this;
	
		        if (toStart) {
		            that.setEnd(that.startContainer, that.startOffset);
		        } else {
		            that.setStart(that.endContainer, that.endOffset);
		        }
		    },
	
		    // Editing Methods
	
		    deleteContents: function () {
		        var that = this,
		            range = that.cloneRange();
	
		        if (that.startContainer != that.commonAncestorContainer) {
		            that.setStartAfter(findClosestAncestor(that.commonAncestorContainer, that.startContainer));
		        }
	
		        that.collapse(true);
	
		        (function deleteSubtree(iterator) {
		            while (iterator.next()) {
		                if (iterator.hasPartialSubtree()) {
		                    deleteSubtree(iterator.getSubtreeIterator());
		                } else {
		                    iterator.remove();
		                }
		            }
		        })(new RangeIterator(range));
		    },
	
		    cloneContents: function () {
		        // clone subtree
		        var document = RangeUtils.documentFromRange(this);
		        return (function cloneSubtree(iterator) {
		                var node, frag = document.createDocumentFragment();
	
		                while (node = iterator.next()) {
		                    node = node.cloneNode(!iterator.hasPartialSubtree());
	
		                    if (iterator.hasPartialSubtree()) {
		                        node.appendChild(cloneSubtree(iterator.getSubtreeIterator()));
		                    }
	
		                    frag.appendChild(node);
		                }
	
		                return frag;
		        })(new RangeIterator(this));
		    },
	
		    extractContents: function () {
		        var that = this,
		            range = that.cloneRange();
	
		        if (that.startContainer != that.commonAncestorContainer) {
		            that.setStartAfter(findClosestAncestor(that.commonAncestorContainer, that.startContainer));
		        }
	
		        that.collapse(true);
	
		        var document = RangeUtils.documentFromRange(that);
	
		        return (function extractSubtree(iterator) {
		            var node, frag = document.createDocumentFragment();
	
		            while (node = iterator.next()) {
		                if (iterator.hasPartialSubtree()) {
		                    node = node.cloneNode(false);
		                    node.appendChild(extractSubtree(iterator.getSubtreeIterator()));
		                } else {
		                    iterator.remove(that.originalRange);
		                }
	
		                frag.appendChild(node);
		            }
	
		            return frag;
		        })(new RangeIterator(range));
		    },
	
		    insertNode: function (node) {
		        var that = this;
	
		        if (isDataNode(that.startContainer)) {
		            if (that.startOffset != that.startContainer.nodeValue.length) {
		                dom.splitDataNode(that.startContainer, that.startOffset);
		            }
	
		            dom.insertAfter(node, that.startContainer);
		        } else {
		            dom.insertAt(that.startContainer, node, that.startOffset);
		        }
	
		        that.setStart(that.startContainer, that.startOffset);
		    },
	
		    cloneRange: function () {
		        // fast copy
		        return $.extend(new W3CRange(this.ownerDocument), {
		            startContainer: this.startContainer,
		            endContainer: this.endContainer,
		            commonAncestorContainer: this.commonAncestorContainer,
		            startOffset: this.startOffset,
		            endOffset: this.endOffset,
		            collapsed: this.collapsed,
	
		            originalRange: this /* not part of the spec; used to update the original range when calling extractContents() on clones */
		        });
		    },
	
		    // used for debug purposes
		    toString: function () {
		        var startNodeName = this.startContainer.nodeName,
		            endNodeName = this.endContainer.nodeName;
	
		        return [startNodeName == "#text" ? this.startContainer.nodeValue : startNodeName, '(', this.startOffset, ') : ',
		                endNodeName == "#text" ? this.endContainer.nodeValue : endNodeName, '(', this.endOffset, ')'].join('');
		    }
		});
	
		W3CRange.fromNode = function(node) {
		    return new W3CRange(node.ownerDocument);
		};
	
		/* can be used in Range.compareBoundaryPoints if we need it one day */
		function compareBoundaries(start, end, startOffset, endOffset) {
		    if (start == end) {
		        return endOffset - startOffset;
		    }
	
		    // end is child of start
		    var container = end;
		    while (container && container.parentNode != start) {
		        container = container.parentNode;
		    }
	
		    if (container) {
		        return findNodeIndex(container) - startOffset;
		    }
	
		    // start is child of end
		    container = start;
		    while (container && container.parentNode != end) {
		        container = container.parentNode;
		    }
	
		    if (container) {
		        return endOffset - findNodeIndex(container) - 1;
		    }
	
		    // deep traversal
		    var root = dom.commonAncestor(start, end);
		    var startAncestor = start;
	
		    while (startAncestor && startAncestor.parentNode != root) {
		        startAncestor = startAncestor.parentNode;
		    }
	
		    if (!startAncestor) {
		        startAncestor = root;
		    }
	
		    var endAncestor = end;
		    while (endAncestor && endAncestor.parentNode != root) {
		        endAncestor = endAncestor.parentNode;
		    }
	
		    if (!endAncestor) {
		        endAncestor = root;
		    }
	
		    if (startAncestor == endAncestor) {
		        return 0;
		    }
	
		    return findNodeIndex(endAncestor) - findNodeIndex(startAncestor);
		}
	
		function fixIvalidRange(range, toStart) {
		    function isInvalidRange(range) {
		        try {
		            return compareBoundaries(range.startContainer, range.endContainer, range.startOffset, range.endOffset) < 0;
		        } catch (ex) {
		            // range was initially invalid (e.g. when cloned from invalid range) - it must be fixed
		            return true;
		        }
		    }
	
		    if (isInvalidRange(range)) {
		        if (toStart) {
		            range.commonAncestorContainer = range.endContainer = range.startContainer;
		            range.endOffset = range.startOffset;
		        } else {
		            range.commonAncestorContainer = range.startContainer = range.endContainer;
		            range.startOffset = range.endOffset;
		        }
	
		        range.collapsed = true;
		    }
		}
	
		function updateRangeProperties(range) {
		    range.collapsed = range.startContainer == range.endContainer && range.startOffset == range.endOffset;
	
		    var node = range.startContainer;
		    while (node && node != range.endContainer && !dom.isAncestorOf(node, range.endContainer)) {
		        node = node.parentNode;
		    }
	
		    range.commonAncestorContainer = node;
		}
	
		var RangeIterator = Class.extend({
		    init: function(range) {
		        $.extend(this, {
		            range: range,
		            _current: null,
		            _next: null,
		            _end: null
		        });
	
		        if (range.collapsed) {
		            return;
		        }
	
		        var root = range.commonAncestorContainer;
	
		        this._next = range.startContainer == root && !isDataNode(range.startContainer) ?
		        range.startContainer.childNodes[range.startOffset] :
		        findClosestAncestor(root, range.startContainer);
	
		        this._end = range.endContainer == root && !isDataNode(range.endContainer) ?
		        range.endContainer.childNodes[range.endOffset] :
		        findClosestAncestor(root, range.endContainer).nextSibling;
		    },
	
		    hasNext: function () {
		        return !!this._next;
		    },
	
		    next: function () {
		        var that = this,
		            current = that._current = that._next;
		        that._next = that._current && that._current.nextSibling != that._end ?
		        that._current.nextSibling : null;
	
		        if (isDataNode(that._current)) {
		            if (that.range.endContainer == that._current) {
		                current = current.cloneNode(true);
		                current.deleteData(that.range.endOffset, current.length - that.range.endOffset);
		            }
	
		            if (that.range.startContainer == that._current) {
		                current = current.cloneNode(true);
		                current.deleteData(0, that.range.startOffset);
		            }
		        }
	
		        return current;
		    },
	
		    traverse: function (callback) {
		        var that = this,
		            current;
	
		        function next() {
		            that._current = that._next;
		            that._next = that._current && that._current.nextSibling != that._end ? that._current.nextSibling : null;
		            return that._current;
		        }
	
		        while (current = next()) {
		            if (that.hasPartialSubtree()) {
		                that.getSubtreeIterator().traverse(callback);
		            } else {
		                callback(current);
		            }
		        }
	
		        return current;
		    },
	
		    remove: function (originalRange) {
		        var that = this,
		            inStartContainer = that.range.startContainer == that._current,
		            inEndContainer = that.range.endContainer == that._current,
		            start, end, delta;
	
		        if (isDataNode(that._current) && (inStartContainer || inEndContainer)) {
		            start = inStartContainer ? that.range.startOffset : 0;
		            end = inEndContainer ? that.range.endOffset : that._current.length;
		            delta = end - start;
	
		            if (originalRange && (inStartContainer || inEndContainer)) {
		                if (that._current == originalRange.startContainer && start <= originalRange.startOffset) {
		                    originalRange.startOffset -= delta;
		                }
	
		                if (that._current == originalRange.endContainer && end <= originalRange.endOffset) {
		                    originalRange.endOffset -= delta;
		                }
		            }
	
		            that._current.deleteData(start, delta);
		        } else {
		            var parent = that._current.parentNode;
	
		            if (originalRange && (that.range.startContainer == parent || that.range.endContainer == parent)) {
		                var nodeIndex = findNodeIndex(that._current);
	
		                if (parent == originalRange.startContainer && nodeIndex <= originalRange.startOffset) {
		                    originalRange.startOffset -= 1;
		                }
	
		                if (parent == originalRange.endContainer && nodeIndex < originalRange.endOffset) {
		                    originalRange.endOffset -= 1;
		                }
		            }
	
		            dom.remove(that._current);
		        }
		    },
	
		    hasPartialSubtree: function () {
		        return !isDataNode(this._current) &&
		        (dom.isAncestorOrSelf(this._current, this.range.startContainer) ||
		            dom.isAncestorOrSelf(this._current, this.range.endContainer));
		    },
	
		    getSubtreeIterator: function () {
		        return new RangeIterator(this.getSubRange());
		    },
	
		    getSubRange: function(){
		        var that = this,
		            subRange = that.range.cloneRange();
		        subRange.selectNodeContents(that._current);
		        if (dom.isAncestorOrSelf(that._current, that.range.startContainer)) {
		            subRange.setStart(that.range.startContainer, that.range.startOffset);
		        }
		        if (dom.isAncestorOrSelf(that._current, that.range.endContainer)) {
		            subRange.setEnd(that.range.endContainer, that.range.endOffset);
		        }
	
		        return subRange;
		    }
		});
	
		var W3CSelection = Class.extend({
		    init: function(doc) {
		        this.ownerDocument = doc;
		        this.rangeCount = 1;
		    },
	
		    addRange: function (range) {
		        var textRange = this.ownerDocument.body.createTextRange();
	
		        // end container should be adopted first in order to prevent selection with negative length
		        adoptContainer(textRange, range, false);
		        adoptContainer(textRange, range, true);
	
		        textRange.select();
		    },
	
		    removeAllRanges: function () {
		        var selection = this.ownerDocument.selection;
	
		        if (selection.type != "None") {
		            selection.empty();
		        }
		    },
	
		    getRangeAt: function () {
		        var textRange,
		            range = new W3CRange(this.ownerDocument),
		            selection = this.ownerDocument.selection,
		            element, commonAncestor;
	
		        try {
		            textRange = selection.createRange();
		            element = textRange.item ? textRange.item(0) : textRange.parentElement();
		            if (element.ownerDocument != this.ownerDocument) {
		                return range;
		            }
		        } catch (ex) {
		            return range;
		        }
	
		        if (selection.type == "Control") {
		            range.selectNode(textRange.item(0));
		        } else {
		            commonAncestor = textRangeContainer(textRange);
		            adoptEndPoint(textRange, range, commonAncestor, true);
		            adoptEndPoint(textRange, range, commonAncestor, false);
	
		            if (range.startContainer.nodeType == 9) {
		                range.setStart(range.endContainer, range.startOffset);
		            }
	
		            if (range.endContainer.nodeType == 9) {
		                range.setEnd(range.startContainer, range.endOffset);
		            }
	
		            if (textRange.compareEndPoints("StartToEnd", textRange) === 0) {
		                range.collapse(false);
		            }
	
		            var startContainer = range.startContainer,
		                endContainer = range.endContainer,
		                body = this.ownerDocument.body;
	
		            if (!range.collapsed && range.startOffset === 0 && range.endOffset == getNodeLength(range.endContainer) &&  // check for full body selection
		                !(startContainer == endContainer && isDataNode(startContainer) && startContainer.parentNode == body)) { // but not when single textnode is selected
		                var movedStart = false,
		                    movedEnd = false;
	
		                while (findNodeIndex(startContainer) === 0 && startContainer == startContainer.parentNode.firstChild && startContainer != body) {
		                    startContainer = startContainer.parentNode;
		                    movedStart = true;
		                }
	
		                while (findNodeIndex(endContainer) == getNodeLength(endContainer.parentNode) - 1 && endContainer == endContainer.parentNode.lastChild && endContainer != body) {
		                    endContainer = endContainer.parentNode;
		                    movedEnd = true;
		                }
	
		                if (startContainer == body && endContainer == body && movedStart && movedEnd) {
		                    range.setStart(startContainer, 0);
		                    range.setEnd(endContainer, getNodeLength(body));
		                }
		            }
		        }
	
		        return range;
		    }
		});
	
		function textRangeContainer(textRange) {
		    var left = textRange.duplicate(),
		        right = textRange.duplicate();
	
		    left.collapse(true);
		    right.collapse(false);
	
		    return dom.commonAncestor(textRange.parentElement(), left.parentElement(), right.parentElement());
		}
	
		function adoptContainer(textRange, range, start) {
		    // find anchor node and offset
		    var container = range[start ? "startContainer" : "endContainer"],
		        offset = range[start ? "startOffset" : "endOffset"],
		        textOffset = 0,
		        isData = isDataNode(container),
		        anchorNode = isData ? container : container.childNodes[offset] || null,
		        anchorParent = isData ? container.parentNode : container,
		        doc = range.ownerDocument,
		        cursor = doc.body.createTextRange(),
		        cursorNode;
	
		    // visible data nodes need a text offset
		    if (container.nodeType == 3 || container.nodeType == 4) {
		        textOffset = offset;
		    }
	
		    if (!anchorParent) {
		        anchorParent = doc.body;
		    }
	
		    if (anchorParent.nodeName.toLowerCase() == "img") {
		        cursor.moveToElementText(anchorParent);
		        cursor.collapse(false);
		        textRange.setEndPoint(start ? "StartToStart" : "EndToStart", cursor);
		    } else {
		        // create a cursor element node to position range (since we can't select text nodes)
		        cursorNode = anchorParent.insertBefore(dom.create(doc, "a"), anchorNode);
	
		        cursor.moveToElementText(cursorNode);
		        dom.remove(cursorNode);
		        cursor[start ? "moveStart" : "moveEnd"]("character", textOffset);
		        cursor.collapse(false);
		        textRange.setEndPoint(start ? "StartToStart" : "EndToStart", cursor);
		    }
		}
	
		function adoptEndPoint(textRange, range, commonAncestor, start) {
		    var cursorNode = dom.create(range.ownerDocument, "a"),
		        cursor = textRange.duplicate(),
		        comparison = start ? "StartToStart" : "StartToEnd",
		        result, parent, target,
		        previous, next,
		        args, index,
		        appended = false;
	
		    cursorNode.innerHTML = "\ufeff";
		    cursor.collapse(start);
	
		    parent = cursor.parentElement();
	
		    if (!dom.isAncestorOrSelf(commonAncestor, parent)) {
		        parent = commonAncestor;
		    }
	
		    // detect range end points
		    // insert cursorNode within the textRange parent and move the cursor until it gets outside of the textRange
		    do {
		        if (appended) {
		            parent.insertBefore(cursorNode, cursorNode.previousSibling);
		        } else {
		            parent.appendChild(cursorNode);
		            appended = true;
		        }
		        cursor.moveToElementText(cursorNode);
		    } while ((result = cursor.compareEndPoints(comparison, textRange)) > 0 && cursorNode.previousSibling);
	
		    target = cursorNode.nextSibling;
	
		    if (result == -1 && isDataNode(target)) {
		        cursor.setEndPoint(start ? "EndToStart" : "EndToEnd", textRange);
	
		        dom.remove(cursorNode);
	
		        args = [target, cursor.text.length];
		    } else {
		        previous = !start && cursorNode.previousSibling;
		        next = start && cursorNode.nextSibling;
	
		        if (isDataNode(next)) {
		            args = [next, 0];
		        } else if (isDataNode(previous)) {
		            args = [previous, previous.length];
		        } else {
		            index = findNodeIndex(cursorNode);
	
		            if (parent.nextSibling && index == parent.childNodes.length - 1) {
		                args = [parent.nextSibling, 0];
		            } else {
		                args = [parent, index];
		            }
		        }
	
		        dom.remove(cursorNode);
		    }
	
		    range[start ? "setStart" : "setEnd"].apply(range, args);
		}
	
		var RangeEnumerator = Class.extend({
		    init: function(range) {
		        this.enumerate = function () {
		            var nodes = [];
	
		            function visit(node) {
		                if (dom.is(node, "img") || (node.nodeType == 3 && (!dom.isEmptyspace(node) || node.nodeValue == "\ufeff"))) {
		                    nodes.push(node);
		                } else {
		                    node = node.firstChild;
		                    while (node) {
		                        visit(node);
		                        node = node.nextSibling;
		                    }
		                }
		            }
	
		            new RangeIterator(range).traverse(visit);
	
		            return nodes;
		        };
		    }
		});
	
		var ImmutablesRangeIterator = RangeIterator.extend({
		    hasPartialSubtree: function () {
		        var immutable = Editor.Immutables && Editor.Immutables.immutable;
		        return immutable && !immutable(this._current) && RangeIterator.fn.hasPartialSubtree.call(this);
		    },
	
		    getSubtreeIterator: function () {
		        return new ImmutablesRangeIterator(this.getSubRange());
		    }
		});
	
		var ImmutablesRangeEnumerator = Class.extend({
		    init: function(range) {
		        this.enumerate = function () {
		            var nodes = [];
		            var immutable = Editor.Immutables && Editor.Immutables.immutable;
		            function visit(node) {
		                if (immutable && !immutable(node)) {
		                    if (dom.is(node, "img") || (node.nodeType == 3 && (!dom.isEmptyspace(node) || node.nodeValue == "\ufeff"))) {
		                        nodes.push(node);
		                    } else {
		                        node = node.firstChild;
		                        while (node) {
		                            visit(node);
		                            node = node.nextSibling;
		                        }
		                    }
		                }
		            }
	
		            new ImmutablesRangeIterator(range).traverse(visit);
	
		            return nodes;
		        };
		    }
		});
	
		var RestorePoint = Class.extend({
		    init: function(range, body, options) {
		        var that = this;
		        that.range = range;
		        that.rootNode = RangeUtils.documentFromRange(range);
		        that.body = body || that.getEditable(range);
		        if (dom.name(that.body) != "body") {
		            that.rootNode = that.body;
		        }
	
		        that.startContainer = that.nodeToPath(range.startContainer);
		        that.endContainer = that.nodeToPath(range.endContainer);
		        that.startOffset = that.offset(range.startContainer, range.startOffset);
		        that.endOffset = that.offset(range.endContainer, range.endOffset);
	
		        that.immutables = options && options.immutables;
	
		        if (that.immutables) {
		            that.serializedImmutables = Editor.Immutables.removeImmutables(that.body);
		        }
	
		        that.html = that.body.innerHTML;
	
		        if (that.immutables && !that.serializedImmutables.empty) {
		            Editor.Immutables.restoreImmutables(that.body, that.serializedImmutables);
		        }
		    },
	
		    index: function(node) {
		        var result = 0,
		            lastType = node.nodeType;
	
		        while (node = node.previousSibling) {
		            var nodeType = node.nodeType;
	
		            if (nodeType != 3 || lastType != nodeType) {
		                result ++;
		            }
	
		            lastType = nodeType;
		        }
	
		        return result;
		    },
	
		    getEditable: function(range) {
		        var root = range.commonAncestorContainer;
	
		        while (root && (root.nodeType == 3 || root.attributes && (!root.attributes.contentEditable || root.attributes.contentEditable.nodeValue.toLowerCase() == "false"))) {
		            root = root.parentNode;
		        }
	
		        return root;
		    },
	
		    restoreHtml: function() {
		        var that = this;
	
		        dom.removeChildren(that.body);
		        that.body.innerHTML = that.html;
		        if (that.immutables && !that.serializedImmutables.empty) {
		            Editor.Immutables.restoreImmutables(that.body, that.serializedImmutables);
		        }
		    },
	
		    offset: function(node, value) {
		        if (node.nodeType == 3) {
		            while ((node = node.previousSibling) && node.nodeType == 3) {
		                value += node.nodeValue.length;
		            }
		        }
	
		        return value;
		    },
	
		    nodeToPath: function(node) {
		        var path = [];
	
		        while (node != this.rootNode) {
		            path.push(this.index(node));
		            node = node.parentNode;
		        }
	
		        return path;
		    },
	
		    toRangePoint: function(range, start, path, denormalizedOffset) {
		        var node = this.rootNode,
		            length = path.length,
		            offset = denormalizedOffset;
	
		        while (length--) {
		            node = node.childNodes[path[length]];
		        }
	
		        while (node && node.nodeType == 3 && node.nodeValue.length < offset) {
		            offset -= node.nodeValue.length;
		            node = node.nextSibling;
		        }
	
		        if (node && offset >= 0) {
		            range[start ? 'setStart' : 'setEnd'](node, offset);
		        }
		    },
	
		    toRange: function () {
		        var that = this,
		            result = that.range.cloneRange();
	
		        that.toRangePoint(result, true, that.startContainer, that.startOffset);
		        that.toRangePoint(result, false, that.endContainer, that.endOffset);
	
		        return result;
		    }
	
		});
	
		var Marker = Class.extend({
		    init: function() {
		        this.caret = null;
		    },
	
		    addCaret: function (range) {
		        var that = this;
		        var caret = that.caret = dom.create(RangeUtils.documentFromRange(range), 'span', { className: 'k-marker' });
		        range.insertNode(caret);
	
		        dom.stripBomNode(caret.previousSibling);
		        dom.stripBomNode(caret.nextSibling);
	
		        range.selectNode(caret);
		        return caret;
		    },
	
		    removeCaret: function (range) {
		        var that = this,
		            previous = that.caret.previousSibling,
		            startOffset = 0;
	
		        if (previous) {
		            startOffset = isDataNode(previous) ? previous.nodeValue.length : findNodeIndex(previous);
		        }
	
		        var container = that.caret.parentNode;
		        var containerIndex = previous ? findNodeIndex(previous) : 0;
	
		        dom.remove(that.caret);
		        normalize(container);
	
		        var node = container.childNodes[containerIndex];
	
		        if (isDataNode(node)) {
		            range.setStart(node, startOffset);
		        } else if (node) {
		            var textNode = dom.lastTextNode(node);
		            if (textNode) {
		                range.setStart(textNode, textNode.nodeValue.length);
		            } else {
		                range[previous ? 'setStartAfter' : 'setStartBefore'](node);
		            }
		        } else {
		            if (!browser.msie && !container.innerHTML) {
		                container.innerHTML = '<br _moz_dirty="" />';
		            }
	
		            range.selectNodeContents(container);
		        }
		        range.collapse(true);
		    },
	
		    add: function (range, expand) {
		        var that = this;
	
		        var collapsed = range.collapsed && !RangeUtils.isExpandable(range);
		        var doc = RangeUtils.documentFromRange(range);
	
		        if (expand && range.collapsed) {
		            that.addCaret(range);
		            range = RangeUtils.expand(range);
		        }
	
		        var rangeBoundary = range.cloneRange();
	
		        rangeBoundary.collapse(false);
		        that.end = dom.create(doc, 'span', { className: 'k-marker' });
		        rangeBoundary.insertNode(that.end);
	
		        rangeBoundary = range.cloneRange();
		        rangeBoundary.collapse(true);
		        that.start = that.end.cloneNode(true);
		        rangeBoundary.insertNode(that.start);
	
		        that._removeDeadMarkers(that.start, that.end);
	
		        if (collapsed) {
		            var bom = doc.createTextNode("\ufeff");
		            dom.insertAfter(bom.cloneNode(), that.start);
		            dom.insertBefore(bom, that.end);
		        }
	
		        normalize(range.commonAncestorContainer);
	
		        range.setStartBefore(that.start);
		        range.setEndAfter(that.end);
	
		        return range;
		    },
	
		    _removeDeadMarkers: function(start, end) {
		        if (start.previousSibling && start.previousSibling.nodeValue == "\ufeff") {
		            dom.remove(start.previousSibling);
		        }
	
		        if (end.nextSibling && end.nextSibling.nodeValue == "\ufeff") {
		            dom.remove(end.nextSibling);
		        }
		    },
	
		    _normalizedIndex: function(node) {
		        var index = findNodeIndex(node);
		        var pointer = node;
	
		        while (pointer.previousSibling) {
		            if (pointer.nodeType == 3 && pointer.previousSibling.nodeType == 3) {
		                index--;
		            }
	
		            pointer = pointer.previousSibling;
		        }
	
		        return index;
		    },
	
		    remove: function (range) {
		        var that = this,
		            start = that.start,
		            end = that.end,
		            shouldNormalizeStart,
		            shouldNormalizeEnd,
		            shouldNormalize;
	
		        normalize(range.commonAncestorContainer);
	
		        while (!start.nextSibling && start.parentNode) {
		            start = start.parentNode;
		        }
	
		        while (!end.previousSibling && end.parentNode) {
		            end = end.parentNode;
		        }
	
		        // merely accessing the siblings will solve range issues in IE
		        shouldNormalizeStart = (start.previousSibling && start.previousSibling.nodeType == 3) &&
		                               (start.nextSibling && start.nextSibling.nodeType == 3);
	
		        shouldNormalizeEnd = (end.previousSibling && end.previousSibling.nodeType == 3) &&
		                             (end.nextSibling && end.nextSibling.nodeType == 3);
	
		        shouldNormalize = shouldNormalizeStart && shouldNormalizeEnd;
	
		        start = start.nextSibling;
		        end = end.previousSibling;
	
		        var isBomSelected = start === end && dom.isBom(start);
		        if (isBomSelected && start.length > 1) {
		            start.nodeValue = start.nodeValue.charAt(0);
		        }
	
		        var collapsed = isBomSelected;
		        var collapsedToStart = false;
		        // collapsed range
		        if (start == that.end) {
		            collapsedToStart = !!that.start.previousSibling;
		            start = end = that.start.previousSibling || that.end.nextSibling;
		            collapsed = true;
		        }
	
		        dom.remove(that.start);
		        dom.remove(that.end);
	
		        if (!start || !end) {
		            range.selectNodeContents(range.commonAncestorContainer);
		            range.collapse(true);
		            return;
		        }
	
		        var startOffset = collapsed ? isDataNode(start) ? start.nodeValue.length : start.childNodes.length : 0;
		        var endOffset = isDataNode(end) ? end.nodeValue.length : end.childNodes.length;
	
		        if (start.nodeType == 3) {
		            while (start.previousSibling && start.previousSibling.nodeType == 3) {
		                start = start.previousSibling;
		                startOffset += start.nodeValue.length;
		            }
		        }
	
		        if (end.nodeType == 3) {
		            while (end.previousSibling && end.previousSibling.nodeType == 3) {
		                end = end.previousSibling;
		                endOffset += end.nodeValue.length;
		            }
		        }
	
		        var startParent = start.parentNode;
		        var endParent = end.parentNode;
		        var startIndex = this._normalizedIndex(start);
		        var endIndex = this._normalizedIndex(end);
	
		        normalize(startParent);
		        if (start.nodeType == 3) {
		            start = startParent.childNodes[startIndex];
		        }
	
		        normalize(endParent);
		        if (end.nodeType == 3) {
		            end = endParent.childNodes[endIndex];
		        }
	
		        if (collapsed) {
		            if (start.nodeType == 3) {
		                range.setStart(start, startOffset);
		            } else {
		                range[collapsedToStart ? 'setStartAfter' : 'setStartBefore'](start);
		            }
	
		            range.collapse(true);
	
		        } else {
		            if (start.nodeType == 3) {
		                range.setStart(start, startOffset);
		            } else {
		                range.setStartBefore(start);
		            }
	
		            if (end.nodeType == 3) {
		                range.setEnd(end, endOffset);
		            } else {
		                range.setEndAfter(end);
		            }
		        }
	
		        if (that.caret) {
		            that.removeCaret(range);
		        }
		    }
		});
	
		var boundary = /[\u0009-\u000d]|\u0020|\u00a0|\ufeff|\.|,|;|:|!|\(|\)|\?/;
	
		var RangeUtils = {
		    nodes: function(range) {
		        var nodes = RangeUtils.textNodes(range);
		        if (!nodes.length) {
		            range.selectNodeContents(range.commonAncestorContainer);
		            nodes = RangeUtils.textNodes(range);
		            if (!nodes.length) {
		                nodes = dom.significantChildNodes(range.commonAncestorContainer);
		            }
		        }
		        return nodes;
		    },
	
		    textNodes: function(range) {
		        return new RangeEnumerator(range).enumerate();
		    },
	
		    editableTextNodes: function(range) {
		        var nodes = [],
		            immutableParent = Editor.Immutables && Editor.Immutables.immutableParent;
	
		        if (immutableParent && !immutableParent(range.commonAncestorContainer)) {
		            nodes = new ImmutablesRangeEnumerator(range).enumerate();
		        }
	
		        return nodes;
		    },
	
		    documentFromRange: function(range) {
		        var startContainer = range.startContainer;
		        return startContainer.nodeType == 9 ? startContainer : startContainer.ownerDocument;
		    },
	
		    createRange: function(document) {
		        if (browser.msie && browser.version < 9) {
		            return new W3CRange(document);
		        }
	
		        return document.createRange();
		    },
	
		    selectRange: function(range) {
		        var image = RangeUtils.image(range);
		        if (image) {
		            range.setStartAfter(image);
		            range.setEndAfter(image);
		        }
		        var selection = SelectionUtils.selectionFromRange(range);
		        selection.removeAllRanges();
		        selection.addRange(range);
		    },
	
		    stringify: function(range) {
		        return kendo.format(
		            "{0}:{1} - {2}:{3}",
		            dom.name(range.startContainer), range.startOffset,
		            dom.name(range.endContainer), range.endOffset
		        );
		    },
	
		    split: function(range, node, trim) {
		        function partition(start) {
		            var partitionRange = range.cloneRange();
		            partitionRange.collapse(start);
		            partitionRange[start ? 'setStartBefore' : 'setEndAfter'](node);
		            var contents = partitionRange.extractContents();
		            if (trim) {
		                contents = dom.trim(contents);
		            }
		            dom[start ? 'insertBefore' : 'insertAfter'](contents, node);
		        }
		        partition(true);
		        partition(false);
		    },
	
		    mapAll: function(range, map) {
		        var nodes = [];
	
		        new RangeIterator(range).traverse(function(node) {
		            var mapped = map(node);
	
		            if (mapped && $.inArray(mapped, nodes) < 0) {
		                nodes.push(mapped);
		            }
		        });
	
		        return nodes;
		    },
	
		    getAll: function(range, predicate) {
		        var selector = predicate;
	
		        if (typeof predicate == "string") {
		            predicate = function(node) {
		                return dom.is(node, selector);
		            };
		        }
	
		        return RangeUtils.mapAll(range, function (node) {
		            if (predicate(node)) {
		                return node;
		            }
		        });
		    },
	
		    getMarkers: function(range) {
		        return RangeUtils.getAll(range, function(node) {
		            return node.className == 'k-marker';
		        });
		    },
	
		    image: function (range) {
		        var nodes = RangeUtils.getAll(range, "img");
	
		        if (nodes.length == 1) {
		            return nodes[0];
		        }
		    },
	
		    isStartOf: function(originalRange, node) {
		        if (originalRange.startOffset !== 0) {
		            return false;
		        }
	
		        var range = originalRange.cloneRange();
	
		        while (range.startOffset === 0 && range.startContainer != node) {
		            var index = dom.findNodeIndex(range.startContainer);
		            var parent = range.startContainer.parentNode;
	
		            while (index > 0 && parent[index-1] && dom.insignificant(parent[index-1])) {
		                index--;
		            }
	
		            range.setStart(parent, index);
		        }
	
		        return range.startOffset === 0 && range.startContainer == node;
		    },
	
		    isEndOf: function(originalRange, node) {
		        var range = originalRange.cloneRange();
	
		        range.collapse(false);
	
		        var start = range.startContainer;
	
		        if (dom.isDataNode(start) && range.startOffset == dom.getNodeLength(start)) {
		            range.setStart(start.parentNode, dom.findNodeIndex(start) + 1);
		            range.collapse(true);
		        }
	
		        range.setEnd(node, dom.getNodeLength(node));
	
		        var nodes = [];
	
		        function visit(node) {
		            if (!dom.insignificant(node) && !(dom.isDataNode(node) && /^[\ufeff]*$/.test(node.nodeValue))) {
		                nodes.push(node);
		            }
		        }
	
		        new RangeIterator(range).traverse(visit);
	
		        return !nodes.length;
		    },
	
		    wrapSelectedElements: function(range) {
		        var startEditable = dom.editableParent(range.startContainer);
		        var endEditable = dom.editableParent(range.endContainer);
	
		        while (range.startOffset === 0 && range.startContainer != startEditable) {
		            range.setStart(range.startContainer.parentNode, dom.findNodeIndex(range.startContainer));
		        }
	
		        function isEnd(offset, container) {
		            var length = dom.getNodeLength(container);
	
		            if (offset == length) {
		                return true;
		            }
	
		            for (var i = offset; i < length; i++) {
		                if (!dom.insignificant(container.childNodes[i])) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        while (isEnd(range.endOffset, range.endContainer) && range.endContainer != endEditable) {
		            range.setEnd(range.endContainer.parentNode, dom.findNodeIndex(range.endContainer) + 1);
		        }
	
		        return range;
		    },
	
		    expand: function (range) {
		        var result = range.cloneRange();
	
		        var startContainer = result.startContainer.childNodes[result.startOffset === 0 ? 0 : result.startOffset - 1];
		        var endContainer = result.endContainer.childNodes[result.endOffset];
	
		        if (!isDataNode(startContainer) || !isDataNode(endContainer)) {
		            return result;
		        }
	
		        var beforeCaret = startContainer.nodeValue;
		        var afterCaret = endContainer.nodeValue;
	
		        if (!beforeCaret || !afterCaret) {
		            return result;
		        }
	
		        var startOffset = beforeCaret.split('').reverse().join('').search(boundary);
		        var endOffset = afterCaret.search(boundary);
	
		        if (!startOffset || !endOffset) {
		            return result;
		        }
	
		        endOffset = endOffset == -1 ? afterCaret.length : endOffset;
		        startOffset = startOffset == -1 ? 0 : beforeCaret.length - startOffset;
	
		        result.setStart(startContainer, startOffset);
		        result.setEnd(endContainer, endOffset);
	
		        return result;
		    },
	
		    isExpandable: function (range) {
		        var node = range.startContainer;
		        var rangeDocument = RangeUtils.documentFromRange(range);
	
		        if (node == rangeDocument || node == rangeDocument.body) {
		            return false;
		        }
	
		        var result = range.cloneRange();
	
		        var value = node.nodeValue;
		        if (!value) {
		            return false;
		        }
	
		        var beforeCaret = value.substring(0, result.startOffset);
		        var afterCaret = value.substring(result.startOffset);
	
		        var startOffset = 0, endOffset = 0;
	
		        if (beforeCaret) {
		            startOffset = beforeCaret.split('').reverse().join('').search(boundary);
		        }
	
		        if (afterCaret) {
		            endOffset = afterCaret.search(boundary);
		        }
	
		        return startOffset && endOffset;
		    }
		};
	
		extend(Editor, {
		    SelectionUtils: SelectionUtils,
		    W3CRange: W3CRange,
		    RangeIterator: RangeIterator,
		    W3CSelection: W3CSelection,
		    RangeEnumerator: RangeEnumerator,
		    RestorePoint: RestorePoint,
		    Marker: Marker,
		    RangeUtils: RangeUtils
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 973:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(659);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(934);
		module.exports = __webpack_require__(934);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 934:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(935) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    DropDownList = kendo.ui.DropDownList,
		    dom = kendo.ui.editor.Dom;
	
		var SelectBox = DropDownList.extend({
		    init: function(element, options) {
		        var that = this;
	
		        DropDownList.fn.init.call(that, element, options);
	
		        // overlay drop-down with popout for snappier interaction
		        if (kendo.support.mobileOS.ios) {
		            this._initSelectOverlay();
		            this.bind("dataBound", $.proxy(this._initSelectOverlay, this));
		        }
	
		        that.text(that.options.title);
	
		        that.element.attr("title", that.options.title);
		        that.wrapper.attr("title", that.options.title);
	
		        that.bind("open", function() {
		            if (that.options.autoSize) {
		                var list = that.list,
		                    listWidth;
	
		                list.css({
		                        whiteSpace: "nowrap",
		                        width: "auto"
		                    });
	
		                listWidth = list.width();
	
		                if (listWidth > 0) {
		                    listWidth += 20;
		                } else {
		                    listWidth = that._listWidth;
		                }
	
		                list.css("width", listWidth + kendo.support.scrollbar());
	
		                that._listWidth = listWidth;
		            }
		        });
		    },
		    options: {
		        name: "SelectBox",
		        index: -1
		    },
	
		    _initSelectOverlay: function() {
		        var selectBox = this;
		        var value = selectBox.value();
		        var view = this.dataSource.view();
		        var item;
		        var html = "";
		        var encode = kendo.htmlEncode;
	
		        for (var i = 0; i < view.length; i++) {
		            item = view[i];
	
		            html += "<option value='" + encode(item.value) + "'";
	
		            if (item.value == value) {
		                html += " selected";
		            }
	
		            html += ">" + encode(item.text) + "</option>";
		        }
	
		        var select = $("<select class='k-select-overlay'>" + html + "</select>");
		        var wrapper = $(this.element).closest(".k-widget");
	
		        wrapper.next(".k-select-overlay").remove();
	
		        select.insertAfter(wrapper);
	
		        select.on("change", function() {
		            selectBox.value(this.value);
		            selectBox.trigger("change");
		        });
		    },
	
		    value: function(value) {
		        var that = this,
		            result = DropDownList.fn.value.call(that, value);
	
		        if (value === undefined) {
		            return result;
		        }
	
		        if (!DropDownList.fn.value.call(that)) {
		           that.text(that.options.title);
		        }
		    },
	
		    decorate: function(body) {
		        var that = this,
		            dataSource = that.dataSource,
		            items = dataSource.data(),
		            i, tag, className, style;
	
		        if (body) {
		            that.list.css("background-color", dom.getEffectiveBackground($(body)));
		        }
	
		        for (i = 0; i < items.length; i++) {
		            tag = items[i].tag || "span";
		            className = items[i].className;
	
		            style = dom.inlineStyle(body, tag, { className : className });
	
		            style = style.replace(/"/g, "'");
	
		            items[i].style = style + ";display:inline-block";
		        }
	
		        dataSource.trigger("change");
		    }
		});
	
	
		kendo.ui.plugin(SelectBox);
		kendo.ui.editor.SelectBox = SelectBox;
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 935:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(660);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(984);
		module.exports = __webpack_require__(984);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 984:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(985) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		// Imports ================================================================
		var kendo = window.kendo;
		var Editor = kendo.ui.editor;
		var dom = Editor.Dom;
		var extend = $.extend;
	
		var fontSizeMappings = 'xx-small,x-small,small,medium,large,x-large,xx-large'.split(',');
		var quoteRe = /"/g; //"
		var brRe = /<br[^>]*>/i;
		var pixelRe = /^\d+(\.\d*)?(px)?$/i;
		var emptyPRe = /<p>(?:&nbsp;)?<\/p>/i;
		var cssDeclaration = /(\*?[-#\/\*\\\w]+(?:\[[0-9a-z_-]+\])?)\s*:\s*((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/g;
		var sizzleAttr = /^sizzle-\d+/i;
		var scriptAttr = /^k-script-/i;
		var onerrorRe = /\s*onerror\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/i;
		var br = '<br class="k-br">';
	
		var div = document.createElement("div");
		div.innerHTML = " <hr>";
		var supportsLeadingWhitespace = div.firstChild.nodeType === 3;
		div = null;
		var isFunction = $.isFunction;
	
		var TD = "td";
	
		var Serializer = {
		    toEditableHtml: function(html) {
		        return (html || "")
		            .replace(/<!\[CDATA\[(.*)?\]\]>/g, "<!--[CDATA[$1]]-->")
		            .replace(/<(\/?)script([^>]*)>/ig, "<$1k:script$2>")
		            .replace(/<img([^>]*)>/ig, function(match) {
		                return match.replace(onerrorRe, "");
		            })
		            .replace(/(<\/?img[^>]*>)[\r\n\v\f\t ]+/ig, "$1")
		            .replace(/^<(table|blockquote)/i, br + '<$1')
		            .replace(/^[\s]*(&nbsp;|\u00a0)/i, '$1')
		            .replace(/<\/(table|blockquote)>$/i, '</$1>' + br);
		    },
	
		    _toEditableImmutables: function(body) {
		        var immutable = Editor.Immutables.immutable,
		            emptyTextNode = dom.emptyTextNode,
		            first = body.firstChild,
		            last = body.lastChild;
	
		        while (emptyTextNode(first)){
		            first = first.nextSibling;
		        }
	
		        while (emptyTextNode(last)){
		            last = last.previousSibling;
		        }
	
		        if (first && immutable(first)) {
		            $(br).prependTo(body);
		        }
	
		        if (last && immutable(last)) {
		            $(br).appendTo(body);
		        }
		    },
	
		    _fillEmptyElements: function(body) {
		        // fills empty elements to allow them to be focused
		        $(body).find("p,td").each(function() {
		            var p = $(this);
		            if (/^\s*$/g.test(p.text()) && !p.find("img,input").length) {
		                var node = this;
		                while (node.firstChild && node.firstChild.nodeType != 3) {
		                    node = node.firstChild;
		                }
	
		                if (node.nodeType == 1 && !dom.empty[dom.name(node)]) {
		                    if(dom.is(node, "td")) {
		                        node.innerHTML = kendo.ui.editor.emptyTableCellContent;
		                    }
		                    else {
		                        node.innerHTML = kendo.ui.editor.emptyElementContent;
		                    }
		                }
		            }
		        });
		    },
	
		    _removeSystemElements: function(body) {
		        // removes persisted system elements
		        $(".k-paste-container", body).remove();
		    },
	
		    _resetOrderedLists: function(root){
		        // fix for IE9 OL bug -- https://connect.microsoft.com/IE/feedback/details/657695/ordered-list-numbering-changes-from-correct-to-0-0
		        var ols = root.getElementsByTagName("ol"), i, ol, originalStart;
	
		        for (i = 0; i < ols.length; i++) {
		            ol = ols[i];
		            originalStart = ol.getAttribute("start");
	
		            ol.setAttribute("start", 1);
	
		            if (originalStart) {
		                ol.setAttribute("start", originalStart);
		            } else {
		                ol.removeAttribute(originalStart);
		            }
		        }
		    },
	
		    _preventScriptExecution: function(root) {
		        $(root).find("*").each(function() {
		            var attributes = this.attributes;
		            var attribute, i, l, name;
		            var attributesToRemove = [];
	
		            for (i = 0, l = attributes.length; i < l; i++) {
		                attribute = attributes[i];
		                name = attribute.nodeName;
	
		                if (attribute.specified && /^on/i.test(name)) {
		                    this.setAttribute("k-script-" + name, attribute.value);
		                    attributesToRemove.push(name);
		                }
		            }
	
		            for (i = 0, l = attributesToRemove.length; i < l; i++) {
		                this.removeAttribute(attributesToRemove[i]);
		            }
		        });
		    },
	
		    htmlToDom: function(html, root, options) {
		        var browser = kendo.support.browser;
		        var msie = browser.msie;
		        var legacyIE = msie && browser.version < 9;
		        var originalSrc = "originalsrc";
		        var originalHref = "originalhref";
		        var o = options || {};
		        var immutables = o.immutables;
	
		        html = Serializer.toEditableHtml(html);
	
		        if (legacyIE) {
		            // Internet Explorer removes comments from the beginning of the html
		            html = "<br/>" + html;
	
		            // IE < 8 makes href and src attributes absolute
		            html = html.replace(/href\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/, originalHref + '="$1"');
		            html = html.replace(/src\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/, originalSrc + '="$1"');
	
		        }
	
		        if(isFunction(o.custom)) {
		            html = o.custom(html) || html;
		        }
		        root.innerHTML = html;
	
		        if (immutables) {
		            immutables.deserialize(root);
		        }
	
		        if (legacyIE) {
		            dom.remove(root.firstChild);
	
		            $(root).find("k\\:script,script,link,img,a").each(function () {
		                var node = this;
		                if (node[originalHref]) {
		                    node.setAttribute("href", node[originalHref]);
		                    node.removeAttribute(originalHref);
		                }
		                if (node[originalSrc]) {
		                    node.setAttribute("src", node[originalSrc]);
		                    node.removeAttribute(originalSrc);
		                }
		            });
		        } else if (msie) {
		            // unicode characters denormalize the DOM tree in IE9
		            dom.normalize(root);
	
		            Serializer._resetOrderedLists(root);
		        }
	
		        Serializer._preventScriptExecution(root);
	
		        Serializer._fillEmptyElements(root);
	
		        Serializer._removeSystemElements(root);
	
		        Serializer._toEditableImmutables(root);
	
		        // add k-table class to all tables
		        $("table", root).addClass("k-table");
	
		        return root;
		    },
	
		    domToXhtml: function(root, options) {
		        var result = [];
		        var immutables = options && options.immutables;
	
		        function semanticFilter(attributes) {
		            return $.grep(attributes, function(attr) {
		                return attr.name != "style";
		            });
		        }
	
		        function mapStart(node, tag) {
		            result.push('<' + tag);
		            attr(node);
		            result.push('>');
		        }
	
		        var tagMap = {
		            iframe: {
		                start: function (node) { mapStart(node, "iframe"); },
		                end: function () { result.push('</iframe>'); }
		            },
		            'k:script': {
		                start: function (node) { mapStart(node, "script"); },
		                end: function () { result.push('</script>'); },
		                skipEncoding: true
		            },
		            span: {
		                semantic: true,
		                start: function(node) {
		                    var style = node.style;
		                    var attributes = specifiedAttributes(node);
		                    var semanticAttributes = semanticFilter(attributes);
	
		                    if (semanticAttributes.length) {
		                        result.push("<span"); attr(node, semanticAttributes); result.push(">");
		                    }
	
		                    if (style.textDecoration == "underline") {
		                        result.push("<u>");
		                    }
	
		                    var font = [];
		                    if (style.color) {
		                        font.push('color="' + dom.toHex(style.color) + '"');
		                    }
	
		                    if (style.fontFamily) {
		                        font.push('face="' + style.fontFamily + '"');
		                    }
	
		                    if (style.fontSize) {
		                        var size = $.inArray(style.fontSize, fontSizeMappings);
		                        font.push('size="' + size + '"');
		                    }
	
		                    if (font.length) {
		                        result.push("<font " + font.join(" ") + ">");
		                    }
		                },
		                end: function(node) {
		                    var style = node.style;
	
		                    if (style.color || style.fontFamily || style.fontSize) {
		                        result.push("</font>");
		                    }
	
		                    if (style.textDecoration == "underline") {
		                        result.push("</u>");
		                    }
	
		                    if (semanticFilter(specifiedAttributes(node)).length) {
		                        result.push("</span>");
		                    }
		                }
		            },
		            strong: {
		                semantic: true,
		                start: function (node) { mapStart(node, "b"); },
		                end: function () { result.push('</b>'); }
		            },
		            em: {
		                semantic: true,
		                start: function (node) { mapStart(node, "i"); },
		                end: function () { result.push('</i>'); }
		            },
		            b: {
		                semantic: false,
		                start: function (node) { mapStart(node, "strong"); },
		                end: function () { result.push('</strong>'); }
		            },
		            i: {
		                semantic: false,
		                start: function (node) { mapStart(node, "em"); },
		                end: function () { result.push('</em>'); }
		            },
		            u: {
		                semantic: false,
		                start: function (node) {
		                    result.push('<span');
	
		                    var attributes = specifiedAttributes(node);
		                    var style = $(attributes).filter(function(i, item){ return item.name == "style"; })[0];
		                    var styleObj = { nodeName: "style", value: "text-decoration:underline;"};
	
		                    if (style) {
		                        styleObj.value  = style.value;
		                        if (!/text-decoration/i.test(styleObj.value)) {
		                            styleObj.value = "text-decoration:underline;" + styleObj.value;
		                        }
		                        attributes.splice($.inArray(style, attributes), 1);
		                    }
		                    attributes.push(styleObj);
	
		                    attr(node, attributes);
		                    result.push('>');
		                },
		                end: function () { result.push('</span>'); }
		            },
		            font: {
		                semantic: false,
		                start: function (node) {
		                    result.push('<span style="');
	
		                    var color = node.getAttribute('color');
		                    var size = fontSizeMappings[node.getAttribute('size')];
		                    var face = node.getAttribute('face');
	
		                    if (color) {
		                        result.push('color:');
		                        result.push(dom.toHex(color));
		                        result.push(';');
		                    }
	
		                    if (face) {
		                        result.push('font-family:');
		                        result.push(face);
		                        result.push(';');
		                    }
	
		                    if (size) {
		                        result.push('font-size:');
		                        result.push(size);
		                        result.push(';');
		                    }
	
		                    result.push('">');
		                },
		                end: function () {
		                    result.push('</span>');
		                }
		            }
		        };
	
		        tagMap.script = tagMap["k:script"];
	
		        options = options || {};
	
		        if (typeof options.semantic == "undefined") {
		            options.semantic = true;
		        }
	
		        function cssProperties(cssText) {
		            var trim = $.trim;
		            var css = trim(cssText);
		            var match;
		            var property, value;
		            var properties = [];
	
		            cssDeclaration.lastIndex = 0;
	
		            while (true) {
		                match = cssDeclaration.exec(css);
	
		                if (!match) {
		                    break;
		                }
	
		                property = trim(match[1].toLowerCase());
		                value = trim(match[2]);
	
		                if (property == "font-size-adjust" || property == "font-stretch") {
		                    continue;
		                }
	
		                if (property.indexOf('color') >= 0) {
		                    value = dom.toHex(value);
		                } else if (property.indexOf('font') >= 0) {
		                    value = value.replace(quoteRe, "'");
		                } else if (/\burl\(/g.test(value)) {
		                    value = value.replace(quoteRe, "");
		                }
	
		                properties.push({ property: property, value: value });
		            }
	
		            return properties;
		        }
	
		        function styleAttr(cssText) {
		            var properties = cssProperties(cssText);
		            var i;
	
		            for (i = 0; i < properties.length; i++) {
		                result.push(properties[i].property);
		                result.push(':');
		                result.push(properties[i].value);
		                result.push(';');
		            }
		        }
	
		        function specifiedAttributes(node) {
		            var result = [];
		            var attributes = node.attributes;
		            var attribute, i, l;
		            var name, value, specified;
	
		            for (i = 0, l = attributes.length; i < l; i++) {
		                attribute = attributes[i];
	
		                name = attribute.nodeName;
		                value = attribute.value;
		                specified = attribute.specified;
	
		                // In IE < 8 the 'value' attribute is not returned as 'specified'. The same goes for type="text"
		                if (name == 'value' && 'value' in node && node.value) {
		                    specified = true;
		                } else if (name == 'type' && value == 'text') {
		                    specified = true;
		                } else if (name == "class" && !value) {
		                    specified = false;
		                } else if (sizzleAttr.test(name)) {
		                    specified = false;
		                } else if (name == 'complete') {
		                    specified = false;
		                } else if (name == 'altHtml') {
		                    specified = false;
		                } else if (name == 'start' && dom.is(node, "ul")) {
		                    specified = false;
		                } else if (name == 'start' && dom.is(node, "ol") && value == "1") {
		                    specified = false;
		                } else if (name.indexOf('_moz') >= 0) {
		                    specified = false;
		                } else if (scriptAttr.test(name)) {
		                    specified = !!options.scripts;
		                } else if (name == 'data-role' && value == 'resizable' && (dom.is(node, "tr") || dom.is(node, "td"))) {
		                    specified = false;
		                }
	
		                if (specified) {
		                    result.push(attribute);
		                }
		            }
	
		            return result;
		        }
	
		        function attr(node, attributes) {
		            var i, l, attribute, name, value;
	
		            attributes = attributes || specifiedAttributes(node);
	
		            if (dom.is(node, 'img')) {
		                var width = node.style.width,
		                    height = node.style.height,
		                    $node = $(node);
	
		                if (width && pixelRe.test(width)) {
		                    $node.attr('width', parseInt(width, 10));
		                    dom.unstyle(node, { width: undefined });
		                }
	
		                if (height && pixelRe.test(height)) {
		                    $node.attr('height', parseInt(height, 10));
		                    dom.unstyle(node, { height: undefined });
		                }
		            }
	
		            if (!attributes.length) {
		                return;
		            }
	
		            // Remove the following if everything seems to be in order.
		            // https://github.com/telerik/kendo-ui-core/issues/3639
		            // attributes.sort(function (a, b) {
		            //     return a.nodeName > b.nodeName ? 1 : a.nodeName < b.nodeName ? -1 : 0;
		            // });
	
		            for (i = 0, l = attributes.length; i < l; i++) {
		                attribute = attributes[i];
		                name = attribute.nodeName;
		                value = attribute.value;
	
		                if (name == "class" && value == "k-table") {
		                    continue;
		                }
	
		                name = name.replace(scriptAttr, "");
	
		                result.push(' ');
		                result.push(name);
		                result.push('="');
	
		                if (name == 'style') {
		                    styleAttr(value || node.style.cssText);
		                } else if (name == 'src' || name == 'href') {
		                    result.push(kendo.htmlEncode(node.getAttribute(name, 2)));
		                } else {
		                    result.push(dom.fillAttrs[name] ? name : value);
		                }
	
		                result.push('"');
		            }
		        }
	
		        function children(node, skip, skipEncoding) {
		            for (var childNode = node.firstChild; childNode; childNode = childNode.nextSibling) {
		                child(childNode, skip, skipEncoding);
		            }
		        }
	
		        function text(node) {
		            return node.nodeValue.replace(/\ufeff/g, "");
		        }
	
		        function isEmptyBomNode(node) {
		            if (dom.isBom(node)) {
		                do {
		                    node = node.parentNode;
	
		                    if (dom.is(node, TD) && node.childNodes.length === 1) {
		                        return true;
		                    }
	
		                    if (node.childNodes.length !== 1) {
		                        return false;
		                    }
		                } while(!dom.isBlock(node));
	
		                return true;
		            }
	
		            return false;
		        }
	
		        function child(node, skip, skipEncoding) {
		            var nodeType = node.nodeType,
		                tagName, mapper,
		                parent, value, previous, jqNode;
	
		            if (immutables && Editor.Immutables.immutable(node)) {
		                result.push(immutables.serialize(node));
		            } else if (nodeType == 1) {
		                tagName = dom.name(node);
		                jqNode = $(node);
	
		                if (jqNode.hasClass("k-table-resize-handle-wrapper") || jqNode.hasClass("k-column-resize-handle-wrapper") || jqNode.hasClass("k-row-resize-handle-wrapper")) {
		                    return;
		                }
	
		                if (!tagName || dom.insignificant(node)) {
		                    return;
		                }
	
		                if (!options.scripts && (tagName == "script" || tagName == "k:script")) {
		                    return;
		                }
	
		                mapper = tagMap[tagName];
	
		                if (mapper) {
		                    if (typeof mapper.semantic == "undefined" ||
		                        (options.semantic ^ mapper.semantic)) {
		                        mapper.start(node);
		                        children(node, false, mapper.skipEncoding);
		                        mapper.end(node);
		                        return;
		                    }
		                }
	
		                result.push('<');
		                result.push(tagName);
	
		                attr(node);
	
		                if (dom.empty[tagName]) {
		                    result.push(' />');
		                } else {
		                    result.push('>');
		                    children(node, skip || dom.is(node, 'pre'));
		                    result.push('</');
		                    result.push(tagName);
		                    result.push('>');
		                }
		            } else if (nodeType == 3) {
		                if(isEmptyBomNode(node)) {
		                    result.push('&nbsp;');
		                    return;
		                }
	
		                value = text(node);
	
		                if (!skip && supportsLeadingWhitespace) {
		                    parent = node.parentNode;
		                    previous = node.previousSibling;
	
		                    if (!previous) {
		                         previous = (dom.isInline(parent) ? parent : node).previousSibling;
		                    }
	
		                    if (!previous || previous.innerHTML === "" || dom.isBlock(previous)) {
		                        value = value.replace(/^[\r\n\v\f\t ]+/, '');
		                    }
	
		                    value = value.replace(/ +/, ' ');
		                }
	
		                result.push(skipEncoding ? value : dom.encode(value, options));
	
		            } else if (nodeType == 4) {
		                result.push('<![CDATA[');
		                result.push(node.data);
		                result.push(']]>');
		            } else if (nodeType == 8) {
		                if (node.data.indexOf('[CDATA[') < 0) {
		                    result.push('<!--');
		                    result.push(node.data);
		                    result.push('-->');
		                } else {
		                    result.push('<!');
		                    result.push(node.data);
		                    result.push('>');
		                }
		            }
		        }
	
		        function textOnly(root) {
		            var childrenCount = root.childNodes.length;
		            var textChild = childrenCount && root.firstChild.nodeType == 3;
	
		            return textChild && (childrenCount == 1 || (childrenCount == 2 && dom.insignificant(root.lastChild)));
		        }
	
		        function runCustom() {
		            if ($.isFunction(options.custom)) {
		                result = options.custom(result) || result;
		            }
		        }
	
		        if (textOnly(root)) {
		            result = dom.encode(text(root.firstChild).replace(/[\r\n\v\f\t ]+/, ' '), options);
		            runCustom();
	
		            return result;
		        }
	
		        children(root);
		        result = result.join('');
		        runCustom();
	
		        // if serialized dom contains only whitespace elements, consider it empty (required field validation)
		        if (result.replace(brRe, "").replace(emptyPRe, "") === "") {
		            return "";
		        }
	
		        return result;
		    }
	
		};
	
		extend(Editor, {
		    Serializer: Serializer
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	
	
	
	/***/ }),
	
	/***/ 985:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(661);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(936);
		module.exports = __webpack_require__(936);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 936:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(937) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		var kendo = window.kendo,
		    map = $.map,
		    extend = $.extend,
		    browser = kendo.support.browser,
		    STYLE = "style",
		    FLOAT = "float",
		    CSSFLOAT = "cssFloat",
		    STYLEFLOAT = "styleFloat",
		    CLASS = "class",
		    KMARKER = "k-marker";
	
		function makeMap(items) {
		    var obj = {},
		        i, len;
	
		    for (i = 0, len = items.length; i < len; i++) {
		        obj[items[i]] = true;
		    }
		    return obj;
		}
	
		var empty = makeMap("area,base,basefont,br,col,frame,hr,img,input,isindex,link,meta,param,embed".split(",")),
		    nonListBlockElements = "p,div,h1,h2,h3,h4,h5,h6,address,applet,blockquote,button,center,dd,dir,dl,dt,fieldset,form,frameset,hr,iframe,isindex,map,menu,noframes,noscript,object,pre,script,table,tbody,td,tfoot,th,thead,tr,header,article,nav,footer,section,aside,main,figure,figcaption".split(","),
		    blockElements = nonListBlockElements.concat(["ul","ol","li"]),
		    block = makeMap(blockElements),
		    selfClosing = makeMap("area,base,br,col,command,embed,hr,img,input,keygen,link,menuitem,meta,param,source,track,wbr".split(",")),
		    inlineElements = "span,em,a,abbr,acronym,applet,b,basefont,bdo,big,br,button,cite,code,del,dfn,font,i,iframe,img,input,ins,kbd,label,map,object,q,s,samp,script,select,small,strike,strong,sub,sup,textarea,tt,u,var,data,time,mark,ruby".split(","),
		    inline = makeMap(inlineElements),
		    fillAttrs = makeMap("checked,compact,declare,defer,disabled,ismap,multiple,nohref,noresize,noshade,nowrap,readonly,selected".split(","));
	
		var normalize = function (node) {
		    if (node.nodeType == 1) {
		        node.normalize();
		    }
		};
	
		if (browser.msie && browser.version >= 8) {
		    normalize = function(parent) {
		        if (parent.nodeType == 1 && parent.firstChild) {
		            var prev = parent.firstChild,
		                node = prev;
	
		            while (true) {
		                node = node.nextSibling;
	
		                if (!node) {
		                    break;
		                }
	
		                if (node.nodeType == 3 && prev.nodeType == 3) {
		                    node.nodeValue = prev.nodeValue + node.nodeValue;
		                    Dom.remove(prev);
		                }
	
		                prev = node;
		            }
		        }
		    };
		}
	
		var whitespace = /^\s+$/,
		    emptyspace = /^[\n\r\t]+$/,
		    rgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i,
		    bom = /\ufeff/g,
		    whitespaceOrBom = /^(\s+|\ufeff)$/,
		    persistedScrollTop,
		    cssAttributes =
		           ("color,padding-left,padding-right,padding-top,padding-bottom," +
		            "background-color,background-attachment,background-image,background-position,background-repeat," +
		            "border-top-style,border-top-width,border-top-color," +
		            "border-bottom-style,border-bottom-width,border-bottom-color," +
		            "border-left-style,border-left-width,border-left-color," +
		            "border-right-style,border-right-width,border-right-color," +
		            "font-family,font-size,font-style,font-variant,font-weight,line-height"
		           ).split(","),
		    htmlRe = /[<>\&]/g,
		    entityRe = /[\u00A0-\u2666<>\&]/g,
		    entityTable = {
		            34: 'quot', 38: 'amp', 39: 'apos', 60: 'lt', 62: 'gt',
		            160: 'nbsp', 161: 'iexcl', 162: 'cent', 163: 'pound', 164: 'curren',
		            165: 'yen', 166: 'brvbar', 167: 'sect', 168: 'uml', 169: 'copy',
		            170: 'ordf', 171: 'laquo', 172: 'not', 173: 'shy', 174: 'reg',
		            175: 'macr', 176: 'deg', 177: 'plusmn', 178: 'sup2', 179: 'sup3',
		            180: 'acute', 181: 'micro', 182: 'para', 183: 'middot', 184: 'cedil',
		            185: 'sup1', 186: 'ordm', 187: 'raquo', 188: 'frac14', 189: 'frac12',
		            190: 'frac34', 191: 'iquest', 192: 'Agrave', 193: 'Aacute', 194: 'Acirc',
		            195: 'Atilde', 196: 'Auml', 197: 'Aring', 198: 'AElig', 199: 'Ccedil',
		            200: 'Egrave', 201: 'Eacute', 202: 'Ecirc', 203: 'Euml', 204: 'Igrave',
		            205: 'Iacute', 206: 'Icirc', 207: 'Iuml', 208: 'ETH', 209: 'Ntilde',
		            210: 'Ograve', 211: 'Oacute', 212: 'Ocirc', 213: 'Otilde', 214: 'Ouml',
		            215: 'times', 216: 'Oslash', 217: 'Ugrave', 218: 'Uacute', 219: 'Ucirc',
		            220: 'Uuml', 221: 'Yacute', 222: 'THORN', 223: 'szlig', 224: 'agrave',
		            225: 'aacute', 226: 'acirc', 227: 'atilde', 228: 'auml', 229: 'aring',
		            230: 'aelig', 231: 'ccedil', 232: 'egrave', 233: 'eacute', 234: 'ecirc',
		            235: 'euml', 236: 'igrave', 237: 'iacute', 238: 'icirc', 239: 'iuml',
		            240: 'eth', 241: 'ntilde', 242: 'ograve', 243: 'oacute', 244: 'ocirc',
		            245: 'otilde', 246: 'ouml', 247: 'divide', 248: 'oslash', 249: 'ugrave',
		            250: 'uacute', 251: 'ucirc', 252: 'uuml', 253: 'yacute', 254: 'thorn',
		            255: 'yuml', 402: 'fnof', 913: 'Alpha', 914: 'Beta', 915: 'Gamma',
		            916: 'Delta', 917: 'Epsilon', 918: 'Zeta', 919: 'Eta', 920: 'Theta',
		            921: 'Iota', 922: 'Kappa', 923: 'Lambda', 924: 'Mu', 925: 'Nu',
		            926: 'Xi', 927: 'Omicron', 928: 'Pi', 929: 'Rho', 931: 'Sigma',
		            932: 'Tau', 933: 'Upsilon', 934: 'Phi', 935: 'Chi', 936: 'Psi',
		            937: 'Omega', 945: 'alpha', 946: 'beta', 947: 'gamma', 948: 'delta',
		            949: 'epsilon', 950: 'zeta', 951: 'eta', 952: 'theta', 953: 'iota',
		            954: 'kappa', 955: 'lambda', 956: 'mu', 957: 'nu', 958: 'xi',
		            959: 'omicron', 960: 'pi', 961: 'rho', 962: 'sigmaf', 963: 'sigma',
		            964: 'tau', 965: 'upsilon', 966: 'phi', 967: 'chi', 968: 'psi',
		            969: 'omega', 977: 'thetasym', 978: 'upsih', 982: 'piv', 8226: 'bull',
		            8230: 'hellip', 8242: 'prime', 8243: 'Prime', 8254: 'oline', 8260: 'frasl',
		            8472: 'weierp', 8465: 'image', 8476: 'real', 8482: 'trade', 8501: 'alefsym',
		            8592: 'larr', 8593: 'uarr', 8594: 'rarr', 8595: 'darr', 8596: 'harr',
		            8629: 'crarr', 8656: 'lArr', 8657: 'uArr', 8658: 'rArr', 8659: 'dArr',
		            8660: 'hArr', 8704: 'forall', 8706: 'part', 8707: 'exist', 8709: 'empty',
		            8711: 'nabla', 8712: 'isin', 8713: 'notin', 8715: 'ni', 8719: 'prod',
		            8721: 'sum', 8722: 'minus', 8727: 'lowast', 8730: 'radic', 8733: 'prop',
		            8734: 'infin', 8736: 'ang', 8743: 'and', 8744: 'or', 8745: 'cap',
		            8746: 'cup', 8747: 'int', 8756: 'there4', 8764: 'sim', 8773: 'cong',
		            8776: 'asymp', 8800: 'ne', 8801: 'equiv', 8804: 'le', 8805: 'ge',
		            8834: 'sub', 8835: 'sup', 8836: 'nsub', 8838: 'sube', 8839: 'supe',
		            8853: 'oplus', 8855: 'otimes', 8869: 'perp', 8901: 'sdot', 8968: 'lceil',
		            8969: 'rceil', 8970: 'lfloor', 8971: 'rfloor', 9001: 'lang', 9002: 'rang',
		            9674: 'loz', 9824: 'spades', 9827: 'clubs', 9829: 'hearts', 9830: 'diams',
		            338: 'OElig', 339: 'oelig', 352: 'Scaron', 353: 'scaron', 376: 'Yuml',
		            710: 'circ', 732: 'tilde', 8194: 'ensp', 8195: 'emsp', 8201: 'thinsp',
		            8204: 'zwnj', 8205: 'zwj', 8206: 'lrm', 8207: 'rlm', 8211: 'ndash',
		            8212: 'mdash', 8216: 'lsquo', 8217: 'rsquo', 8218: 'sbquo', 8220: 'ldquo',
		            8221: 'rdquo', 8222: 'bdquo', 8224: 'dagger', 8225: 'Dagger', 8240: 'permil',
		            8249: 'lsaquo', 8250: 'rsaquo', 8364: 'euro'
		        };
	
		var Dom = {
		    block: block,
		    inline: inline,
	
		    findNodeIndex: function(node, skipText) {
		        var i = 0;
	
		        if (!node) {
		            return -1;
		        }
	
		        while (true) {
		            node = node.previousSibling;
	
		            if (!node) {
		                break;
		            }
	
		            if (!(skipText && node.nodeType == 3)) {
		                i++;
		            }
		        }
	
		        return i;
		    },
	
		    isDataNode: function(node) {
		        return node && node.nodeValue !== null && node.data !== null;
		    },
	
		    isAncestorOf: function(parent, node) {
		        try {
		            return !Dom.isDataNode(parent) && ($.contains(parent, Dom.isDataNode(node) ? node.parentNode : node) || node.parentNode == parent);
		        } catch (e) {
		            return false;
		        }
		    },
	
		    isAncestorOrSelf: function(root, node) {
		        return Dom.isAncestorOf(root, node) || root == node;
		    },
	
		    findClosestAncestor: function(root, node) {
		        if (Dom.isAncestorOf(root, node)) {
		            while (node && node.parentNode != root) {
		                node = node.parentNode;
		            }
		        }
	
		        return node;
		    },
	
		    getAllComments: function (rootElem) {
		        var comments = [];
		        // Fourth argument, which is actually obsolete according to the DOM4 standard, is required in IE 11
		        var iterator = document.createNodeIterator(rootElem,
		            NodeFilter.SHOW_COMMENT,
		            function () {
		                return NodeFilter.FILTER_ACCEPT;
		            }, false);
	
		        var curNode = iterator.nextNode();
		        while (curNode) {
		            comments.push(curNode.nodeValue);
		            curNode = iterator.nextNode();
		        }
		        return comments;
		    },
	
		    getNodeLength: function(node) {
		        return Dom.isDataNode(node) ? node.length : node.childNodes.length;
		    },
	
		    splitDataNode: function(node, offset) {
		        var newNode = node.cloneNode(false);
		        var denormalizedText = "";
		        var iterator = node.nextSibling;
		        var temp;
	
		        while (iterator && iterator.nodeType == 3 && iterator.nodeValue) {
		            denormalizedText += iterator.nodeValue;
		            temp = iterator;
		            iterator = iterator.nextSibling;
		            Dom.remove(temp);
		        }
	
		        node.deleteData(offset, node.length);
		        newNode.deleteData(0, offset);
		        newNode.nodeValue += denormalizedText;
		        Dom.insertAfter(newNode, node);
		    },
	
		    attrEquals: function(node, attributes) {
		        for (var key in attributes) {
		            var value = node[key];
	
		            if (key == FLOAT) {
		                value = node[kendo.support.cssFloat ? CSSFLOAT : STYLEFLOAT];
		            }
	
		            if (typeof value == "object") {
		                if (!Dom.attrEquals(value, attributes[key])) {
		                    return false;
		                }
		            } else if (value != attributes[key]) {
		                return false;
		            }
		        }
	
		        return true;
		    },
	
		    blockParentOrBody: function(node) {
		        return Dom.parentOfType(node, blockElements) || node.ownerDocument.body;
		    },
	
		    blockParents: function(nodes) {
		        var blocks = [],
		            i, len;
	
		        for (i = 0, len = nodes.length; i < len; i++) {
		            var block = Dom.parentOfType(nodes[i], Dom.blockElements);
		            if (block && $.inArray(block, blocks) < 0) {
		                blocks.push(block);
		            }
		        }
	
		        return blocks;
		    },
	
		    windowFromDocument: function(document) {
		        return document.defaultView || document.parentWindow;
		    },
	
		    normalize: normalize,
		    blockElements: blockElements,
		    nonListBlockElements: nonListBlockElements,
		    inlineElements: inlineElements,
		    empty: empty,
		    fillAttrs: fillAttrs,
		    nodeTypes: {
		        ELEMENT_NODE: 1,
		        ATTRIBUTE_NODE: 2,
		        TEXT_NODE: 3,
		        CDATA_SECTION_NODE: 4,
		        ENTITY_REFERENCE_NODE: 5,
		        ENTITY_NODE: 6,
		        PROCESSING_INSTRUCTION_NODE: 7,
		        COMMENT_NODE: 8,
		        DOCUMENT_NODE: 9,
		        DOCUMENT_TYPE_NODE: 10,
		        DOCUMENT_FRAGMENT_NODE: 11,
		        NOTATION_NODE: 12
		    },
	
		    toHex: function (color) {
		        var matches = rgb.exec(color);
	
		        if (!matches) {
		            return color;
		        }
	
		        return "#" + map(matches.slice(1), function (x) {
		            x = parseInt(x, 10).toString(16);
		            return x.length > 1 ? x : "0" + x;
		        }).join("");
		    },
	
		    encode: function (value, options) {
		        var encodableChars = (!options || options.entities) ? entityRe : htmlRe;
		        return value.replace(encodableChars, function(c) {
		            var charCode = c.charCodeAt(0);
		            var entity = entityTable[charCode];
		            return entity ? '&'+entity+';' : c;
		        });
		    },
		    isBom: function(node) {
		        return node && node.nodeType === 3 && /^[\ufeff]+$/.test(node.nodeValue);
		    },
		    stripBom: function(text) {
		        return (text || "").replace(bom, "");
		    },
	
		    stripBomNode: function(node) {
		        if(Dom.isBom(node)) {
		            node.parentNode.removeChild(node);
		        }
		    },
	
		    insignificant: function(node) {
		        var attr = node.attributes;
	
		        return node.className == "k-marker" || (Dom.is(node, 'br') && (node.className == "k-br" || attr._moz_dirty || attr._moz_editor_bogus_node));
		    },
		    tableCell: function(node) {
		        return Dom.is(node, "td") || Dom.is(node, "th");
		    },
		    significantNodes: function(nodes) {
		        return $.grep(nodes, function(child) {
		            var name = Dom.name(child);
	
		            if (name == 'br') {
		                return false;
		            } else if (Dom.insignificant(child)) {
		                return false;
		            } else if (Dom.emptyTextNode(child)) {
		                return false;
		            } else if (child.nodeType == 1 && !empty[name] && Dom.emptyNode(child)) {
		                return false;
		            }
	
		            return true;
		        });
		    },
	
		    emptyTextNode: function(node) {
		        return node && node.nodeType == 3 && whitespaceOrBom.test(node.nodeValue);
		    },
	
		    emptyNode: function(node) {
		        return node.nodeType == 1 && !Dom.significantNodes(node.childNodes).length;
		    },
	
		    name: function (node) {
		        return node.nodeName.toLowerCase();
		    },
	
		    significantChildNodes: function(node) {
		        return $.grep(node.childNodes, function(child) {
		            return child.nodeType != 3 || !Dom.isWhitespace(child);
		        });
		    },
	
		    lastTextNode: function(node) {
		        var result = null;
	
		        if (node.nodeType == 3) {
		            return node;
		        }
	
		        for (var child = node.lastChild; child; child = child.previousSibling) {
		            result = Dom.lastTextNode(child);
	
		            if (result) {
		                return result;
		            }
		        }
	
		        return result;
		    },
	
		    is: function (node, nodeName) {
		        return node && Dom.name(node) == nodeName;
		    },
	
		    isMarker: function(node) {
		        return node.className == KMARKER;
		    },
	
		    isWhitespace: function(node) {
		        return whitespace.test(node.nodeValue);
		    },
	
		    allWhitespaceContent: function(node) {
		        var child = node.firstChild;
		        while(child && Dom.isWhitespace(child)) {
		            child = child.nextSibling;
		        }
	
		        return !child;
		    },
	
	
		    isEmptyspace: function(node) {
		        return emptyspace.test(node.nodeValue);
		    },
	
		    htmlIndentSpace: function (node){
		        if (!(Dom.isDataNode(node) && Dom.isWhitespace(node))) {
		            return false;
		        }
	
		        if (emptyspace.test(node.nodeValue)) {
		            return true;
		        }
	
		        var sibling = function(el, direction) {
		            while (el[direction]) {
		                el = el[direction];
		                if (Dom.significantNodes([el]).length  > 0) {
		                    return el;
		                }
		            }
		        };
	
		        var parent = node.parentNode;
		        var prev = sibling(node, "previousSibling");
		        var next = sibling(node, "nextSibling");
	
		        if (bom.test(node.nodeValue)) {
		            return !!(prev || next);
		        }
	
		        if ($(parent).is("tr,tbody,thead,tfoot,table,ol,ul")) {
		            return true;
		        }
	
		        if (Dom.isBlock(parent) || Dom.is(parent, "body")) {
		            var isPrevBlock = prev && Dom.isBlock(prev);
		            var isNextBlock = next && Dom.isBlock(next);
		            if ((!next && isPrevBlock) || (!prev && isNextBlock) || (isPrevBlock && isNextBlock)) {
		                return true;
		            }
		        }
	
		        return false;
		    },
	
		    isBlock: function(node) {
		        return block[Dom.name(node)];
		    },
	
		    isSelfClosing: function(node) {
		        return selfClosing[Dom.name(node)];
		    },
	
		    isEmpty: function(node) {
		        return empty[Dom.name(node)];
		    },
	
		    isInline: function(node) {
		        return inline[Dom.name(node)];
		    },
	
		    isBr: function(node) {
		        return Dom.name(node) == "br";
		    },
	
		    list: function(node) {
		        var name = node ? Dom.name(node) : "";
		        return name == "ul" || name == "ol" || name == "dl";
		    },
	
		    scrollContainer: function(doc) {
		        var wnd = Dom.windowFromDocument(doc),
		            scrollContainer = (wnd.contentWindow || wnd).document || wnd.ownerDocument || wnd;
	
		        if (scrollContainer.compatMode == 'BackCompat') {
		            scrollContainer = scrollContainer.body;
		        } else {
		            scrollContainer = scrollContainer.scrollingElement || scrollContainer.documentElement;
		        }
	
		        return scrollContainer;
		    },
	
		    scrollTo: function (node, toStart) {
		        var doc = node.ownerDocument;
		        var wnd = Dom.windowFromDocument(doc);
		        var windowHeight = wnd.innerHeight;
		        var scrollContainer = Dom.scrollContainer(doc);
		        var element, elementTop, elementHeight, marker;
	
		        if (Dom.isDataNode(node)) {
		            if (toStart) {
		                marker = Dom.create(doc, "span", {"innerHTML": "&#xfeff;"});
		                Dom.insertBefore(marker, node);
		                element = $(marker);
		            } else {
		                element = $(node.parentNode);
		            }
		        } else {
		            element = $(node);
		        }
	
		        elementTop = element.offset().top;
		        elementHeight = element[0].offsetHeight;
	
		        if (toStart || !elementHeight) {
		            elementHeight = parseInt(element.css("line-height"), 10) ||
		                            Math.ceil(1.2 * parseInt(element.css("font-size"), 10)) ||
		                            15;
		        }
	
		        if (marker) {
		            Dom.remove(marker);
		        }
	
		        if (elementHeight + elementTop > scrollContainer.scrollTop + windowHeight) {
		            scrollContainer.scrollTop = elementHeight + elementTop - windowHeight;
		        }
		    },
	
		    persistScrollTop: function(doc) {
		        persistedScrollTop = Dom.scrollContainer(doc).scrollTop;
		    },
	
		    offset: function (target, offsetParent) {
		        var result = {top: target.offsetTop, left: target.offsetLeft};
		        var parent = target.offsetParent;
	
		        while (parent && (!offsetParent || Dom.isAncestorOf(offsetParent, parent))) {
		            result.top += parent.offsetTop;
		            result.left += parent.offsetLeft;
		            parent = parent.offsetParent;
		        }
	
		        return result;
		    },
	
		    restoreScrollTop: function(doc) {
		        if (typeof persistedScrollTop == "number") {
		            Dom.scrollContainer(doc).scrollTop = persistedScrollTop;
		        }
		    },
	
		    insertAt: function (parent, newElement, position) {
		        parent.insertBefore(newElement, parent.childNodes[position] || null);
		    },
	
		    insertBefore: function (newElement, referenceElement) {
		        if (referenceElement.parentNode) {
		            return referenceElement.parentNode.insertBefore(newElement, referenceElement);
		        } else {
		            return referenceElement;
		        }
		    },
	
		    insertAfter: function (newElement, referenceElement) {
		        return referenceElement.parentNode.insertBefore(newElement, referenceElement.nextSibling);
		    },
	
		    remove: function (node) {
		        if(node.parentNode) {
		            node.parentNode.removeChild(node);
		        }
		    },
	
		    removeChildren: function(node){
		        while(node.firstChild) {
		            node.removeChild(node.firstChild);
		        }
		    },
	
		    removeTextSiblings: function(node) {
		        var parentNode = node.parentNode;
	
		        while (node.nextSibling && node.nextSibling.nodeType == 3) {
		            parentNode.removeChild(node.nextSibling);
		        }
	
		        while (node.previousSibling && node.previousSibling.nodeType == 3) {
		            parentNode.removeChild(node.previousSibling);
		        }
		    },
	
		    trim: function (parent) {
		        for (var i = parent.childNodes.length - 1; i >= 0; i--) {
		            var node = parent.childNodes[i];
		            if (Dom.isDataNode(node)) {
		                if (!Dom.stripBom(node.nodeValue).length) {
		                    Dom.remove(node);
		                }
		            } else if (node.className != KMARKER) {
		                Dom.trim(node);
	
		                if ((!Dom.isEmpty(node) && node.childNodes.length === 0) ||
		                    (Dom.isBlock(node) && Dom.allWhitespaceContent(node))) {
		                    Dom.remove(node);
		                }
		            }
		        }
	
		        return parent;
		    },
	
		    closest: function(node, tag) {
		        while (node && Dom.name(node) != tag) {
		            node = node.parentNode;
		        }
	
		        return node;
		    },
	
		    closestBy: function(node, condition, rootCondition) {
		        while (node && !condition(node)) {
		            if (rootCondition && rootCondition(node)){
		                return null;
		            }
		            node = node.parentNode;
		        }
		        return node;
		    },
	
		    sibling: function(node, direction) {
		        do {
		            node = node[direction];
		        } while (node && node.nodeType != 1);
	
		        return node;
		    },
	
		    next: function(node) {
		        return Dom.sibling(node, "nextSibling");
		    },
	
		    prev: function(node) {
		        return Dom.sibling(node, "previousSibling");
		    },
	
		    parentOfType: function (node, tags) {
		        do {
		            node = node.parentNode;
		        } while (node && !(Dom.ofType(node, tags)));
	
		        return node;
		    },
	
		    ofType: function (node, tags) {
		        return $.inArray(Dom.name(node), tags) >= 0;
		    },
	
		    changeTag: function (referenceElement, tagName, skipAttributes) {
		        var newElement = Dom.create(referenceElement.ownerDocument, tagName),
		            attributes = referenceElement.attributes,
		            i, len, name, value, attribute;
	
		        if (!skipAttributes) {
		            for (i = 0, len = attributes.length; i < len; i++) {
		                attribute = attributes[i];
		                if (attribute.specified) {
		                    // IE < 8 cannot set class or style via setAttribute
		                    name = attribute.nodeName;
		                    value = attribute.nodeValue;
		                    if (name == CLASS) {
		                        newElement.className = value;
		                    } else if (name == STYLE) {
		                        newElement.style.cssText = referenceElement.style.cssText;
		                    } else {
		                        newElement.setAttribute(name, value);
		                    }
		                }
		            }
		        }
	
		        while (referenceElement.firstChild) {
		            newElement.appendChild(referenceElement.firstChild);
		        }
	
		        Dom.insertBefore(newElement, referenceElement);
		        Dom.remove(referenceElement);
		        return newElement;
		    },
	
		    editableParent: function(node) {
		        while (node && (node.nodeType == 3 || node.contentEditable !== 'true')) {
		            node = node.parentNode;
		        }
	
		        return node;
		    },
	
		    wrap: function (node, wrapper) {
		        Dom.insertBefore(wrapper, node);
		        wrapper.appendChild(node);
		        return wrapper;
		    },
	
		    unwrap: function (node) {
		        var parent = node.parentNode;
		        while (node.firstChild) {
		            parent.insertBefore(node.firstChild, node);
		        }
	
		        parent.removeChild(node);
		    },
	
		    wrapper: function(node) {
		        var wrapper = Dom.closestBy(node, function (el) {
		            return el.parentNode && Dom.significantNodes(el.parentNode.childNodes).length > 1;
		        });
	
		        return $(wrapper).is("body,.k-editor") ? undefined : wrapper;
		    },
	
		    create: function (document, tagName, attributes) {
		        return Dom.attr(document.createElement(tagName), attributes);
		    },
	
		    createEmptyNode: function (document, tagName, attributes) {
		        var node = Dom.attr(document.createElement(tagName), attributes);
		        node.innerHTML = "\ufeff";
		        return node;
		    },
	
		    attr: function (element, attributes) {
		        attributes = extend({}, attributes);
	
		        if (attributes && STYLE in attributes) {
		            Dom.style(element, attributes.style);
		            delete attributes.style;
		        }
	
		        for (var attr in attributes) {
		            if (attributes[attr] === null) {
		                element.removeAttribute(attr);
		                delete attributes[attr];
		            } else if (attr == "className") {
		                element[attr] = attributes[attr];
		            }
		        }
	
		        return extend(element, attributes);
		    },
	
		    style: function (node, value) {
		        $(node).css(value || {});
		    },
	
		    unstyle: function (node, value) {
		        for (var key in value) {
		            if (key == FLOAT) {
		                key = kendo.support.cssFloat ? CSSFLOAT : STYLEFLOAT;
		            }
	
		            node.style[key] = "";
		        }
	
		        if (node.style.cssText === "") {
		            node.removeAttribute(STYLE);
		        }
		    },
	
		    inlineStyle: function(body, name, attributes) {
		        var span = $(Dom.create(body.ownerDocument, name, attributes)),
		            style;
	
		        body.appendChild(span[0]);
	
		        style = map(cssAttributes, function(value) {
		            if (browser.msie && value == "line-height" && span.css(value) == "1px") {
		                return "line-height:1.5";
		            } else {
		                return value + ":" + span.css(value);
		            }
		        }).join(";");
	
		        span.remove();
	
		        return style;
		    },
	
		    getEffectiveBackground: function(element) {
		        var backgroundStyle = element.css("background-color") || "";
	
		        if (backgroundStyle.indexOf("rgba(0, 0, 0, 0") < 0 && backgroundStyle !== "transparent") {
		            return backgroundStyle;
		        } else if (element[0].tagName.toLowerCase() === "html") {
		            return "Window";
		        } else {
		            return Dom.getEffectiveBackground(element.parent());
		        }
		    },
	
		    innerText: function(node) {
		        var text = node.innerHTML;
		        text = text.replace(/<!--(.|\s)*?-->/gi, "");
		        text = text.replace(/<\/?[^>]+?\/?>/gm, "");
	
		        return text;
		    },
	
		    removeClass: function(node, classNames) {
		        var className = " " + node.className + " ",
		            classes = classNames.split(" "),
		            i, len;
	
		        for (i = 0, len = classes.length; i < len; i++) {
		            className = className.replace(" " + classes[i] + " ", " ");
		        }
	
		        className = $.trim(className);
	
		        if (className.length) {
		            node.className = className;
		        } else {
		            node.removeAttribute(CLASS);
		        }
		    },
	
		    commonAncestor: function () {
		        var count = arguments.length,
		            paths = [],
		            minPathLength = Infinity,
		            output = null,
		            i, ancestors, node, first, j;
	
		        if (!count) {
		            return null;
		        }
	
		        if (count == 1) {
		            return arguments[0];
		        }
	
		        for (i = 0; i < count; i++) {
		            ancestors = [];
		            node = arguments[i];
		            while (node) {
		                ancestors.push(node);
		                node = node.parentNode;
		            }
		            paths.push(ancestors.reverse());
		            minPathLength = Math.min(minPathLength, ancestors.length);
		        }
	
		        if (count == 1) {
		            return paths[0][0];
		        }
	
		        for (i = 0; i < minPathLength; i++) {
		            first = paths[0][i];
	
		            for (j = 1; j < count; j++) {
		                if (first != paths[j][i]) {
		                    return output;
		                }
		            }
	
		            output = first;
		        }
		        return output;
		    },
	
		    closestSplittableParent: function(nodes) {
		        var result;
	
		        if (nodes.length == 1) {
		            result = Dom.parentOfType(nodes[0], ["ul","ol"]);
		        } else {
		            result = Dom.commonAncestor.apply(null, nodes);
		        }
	
		        if (!result) {
		            result = Dom.parentOfType(nodes[0], ["p", "td"]) || nodes[0].ownerDocument.body;
		        }
	
		        if (Dom.isInline(result)) {
		            result = Dom.blockParentOrBody(result);
		        }
	
		        var editableParents = map(nodes, Dom.editableParent);
		        var editableAncestor = Dom.commonAncestor(editableParents)[0];
	
		        if ($.contains(result, editableAncestor)) {
		            result = editableAncestor;
		        }
	
		        return result;
		    },
	
		    closestEditable: function(node, types) {
		        var closest;
		        var editable = Dom.editableParent(node);
	
		        if (Dom.ofType(node, types)) {
		            closest = node;
		        } else {
		            closest = Dom.parentOfType(node, types);
		        }
	
		        if (closest && editable && $.contains(closest, editable)) {
		            closest = editable;
		        } else if (!closest && editable) {
		            closest = editable;
		        }
	
		        return closest;
		    },
	
		    closestEditableOfType: function(node, types) {
		        var editable = Dom.closestEditable(node, types);
	
		        if (editable && Dom.ofType(editable, types) && !$(editable).is(".k-editor")) {
		            return editable;
		        }
		    },
	
		    filter: function(tagName, nodes, invert) {
		        var filterFn = function (node) {
		            return Dom.name(node) == tagName;
		        };
	
		        return Dom.filterBy(nodes, filterFn, invert);
		    },
	
		    filterBy: function(nodes, condition, invert) {
		        var i = 0;
		        var len = nodes.length;
		        var result = [];
		        var match;
	
		        for (; i < len; i++) {
		            match = condition(nodes[i]);
		            if ((match && !invert) || (!match && invert)) {
		                result.push(nodes[i]);
		            }
		        }
	
		        return result;
		    },
	
		    ensureTrailingBreaks: function(node) {
		        var elements = $(node).find("p,td,th");
		        var length = elements.length;
		        var i = 0;
	
		        if (length) {
		            for (; i < length; i++) {
		                Dom.ensureTrailingBreak(elements[i]);
		            }
		        } else {
		            Dom.ensureTrailingBreak(node);
		        }
		    },
	
		    removeTrailingBreak: function(node) {
		        $(node).find("br[type=_moz],.k-br").remove();
		    },
	
		    ensureTrailingBreak: function(node) {
		        Dom.removeTrailingBreak(node);
	
		        var lastChild = node.lastChild;
		        var name = lastChild && Dom.name(lastChild);
		        var br;
	
		        if (!name ||
		            (name != "br" && name != "img") ||
		            (name == "br" && lastChild.className != "k-br")) {
		            br = node.ownerDocument.createElement("br");
		            br.className = "k-br";
		            node.appendChild(br);
		        }
		    }
		};
	
		kendo.ui.editor.Dom = Dom;
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	
	
	/***/ }),
	
	/***/ 937:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(940);
		module.exports = __webpack_require__(940);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(561);
	
	/***/ }),
	
	/***/ 940:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint scripturl: true */
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(941),
		        __webpack_require__(6),
		        __webpack_require__(942),
		        __webpack_require__(943),
		        __webpack_require__(944)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($,undefined) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        Class = kendo.Class,
		        Widget = kendo.ui.Widget,
		        os = kendo.support.mobileOS,
		        browser = kendo.support.browser,
		        extend = $.extend,
		        proxy = $.proxy,
		        deepExtend = kendo.deepExtend,
		        keys = kendo.keys;
	
		    var SELECT = "select";
		    var SELECT_OVERLAY_SELECTOR = "select.k-select-overlay";
	
		    // options can be: template (as string), cssClass, title, defaultValue
		    var ToolTemplate = Class.extend({
		        init: function(options) {
		            this.options = options;
		        },
	
		        getHtml: function() {
		            var options = this.options;
		            return kendo.template(options.template, {useWithBlock:false})(options);
		        }
		    });
	
		    var EditorUtils = {
		        editorWrapperTemplate:
		            '<table cellspacing="4" cellpadding="0" class="k-widget k-editor k-header" role="presentation"><tbody>' +
		                '<tr role="presentation"><td class="k-editor-toolbar-wrap" role="presentation"><ul class="k-editor-toolbar" role="toolbar" /></td></tr>' +
		                '<tr><td class="k-editable-area" /></tr>' +
		            '</tbody></table>',
	
		        buttonTemplate:
		            '# var iconCssClass= "k-icon k-i-" + kendo.toHyphens(data.cssClass.replace("k-", ""));#' +
		            '<a tabindex="0" role="button" class="k-tool"' +
		            '#= data.popup ? " data-popup" : "" #' +
		            ' unselectable="on" title="#= data.title #"><span unselectable="on" class="k-tool-icon #= iconCssClass #"></span><span class="k-tool-text">#= data.title #</span></a>',
	
		        colorPickerTemplate:
		            '<div class="k-colorpicker k-icon k-i-#= data.cssClass.replace("k-", "") #" />',
	
		        comboBoxTemplate:
		            '<select title="#= data.title #" class="#= data.cssClass #" />',
	
		        dropDownListTemplate:
		            '<span class="k-editor-dropdown"><select title="#= data.title #" class="#= data.cssClass #" /></span>',
	
		        separatorTemplate:
		            '<span class="k-separator" />',
	
		        overflowAnchorTemplate:
		            '<a tabindex="0" role="button" class="k-tool k-overflow-anchor" data-popup' +
		            ' unselectable="on" title="#= data.title #" aria-haspopup="true" aria-expanded="false">' +
		            '<span unselectable="on" class="k-icon k-i-more-vertical"></span><span class="k-tool-text">#= data.title #</span></a>',
	
		        formatByName: function(name, format) {
		            for (var i = 0; i < format.length; i++) {
		                if ($.inArray(name, format[i].tags) >= 0) {
		                    return format[i];
		                }
		            }
		        },
	
		        getToolCssClass: function (name) {
		            var toolCssClassNames = {
	
		                superscript: "sup-script",
		                subscript: "sub-script",
		                justifyLeft: "align-left",
		                justifyCenter: "align-center",
		                justifyRight: "align-right",
		                justifyFull: "align-justify",
		                insertUnorderedList: "list-unordered",
		                insertOrderedList: "list-ordered",
		                "import": "login",
		                indent: "indent-increase",
		                outdent: "indent-decrease",
		                createLink: "link-horizontal",
		                unlink: "unlink-horizontal",
		                insertImage: "image",
		                insertFile: "file-add",
		                viewHtml: "html",
		                foreColor: "foreground-color",
		                backColor: "paint",
		                createTable: "table-insert",
		                addColumnLeft: "table-column-insert-left",
		                addColumnRight: "table-column-insert-right",
		                addRowAbove: "table-row-insert-above",
		                addRowBelow: "table-row-insert-below",
		                deleteRow: "table-row-delete",
		                deleteColumn: "table-column-delete",
		                tableWizard: "table-properties",
		                tableWizardInsert: "table-wizard",
		                cleanFormatting: "clear-css"
		            };
	
		            var cssClass = toolCssClassNames[name];
		            if(cssClass) {
		                return cssClass;
		            }
		            return name;
		        },
	
		        registerTool: function(toolName, tool) {
		            var toolOptions = tool.options;
		            if (toolOptions && toolOptions.template) {
		                toolOptions.template.options.cssClass = "k-" + EditorUtils.getToolCssClass(toolName);
		            }
	
		            if (!tool.name) {
		                tool.options.name = toolName;
		                tool.name = toolName.toLowerCase();
		            }
	
		            Editor.defaultTools[toolName] = tool;
		        },
	
		        registerFormat: function(formatName, format) {
		            Editor.fn.options.formats[formatName] = format;
		        },
	
		        cacheComments: function (content, comments) {
		            for(var index in comments){
		                content = content.replace(comments[index], "{" + index + "}");
		            }
		            return content;
		        },
	
		        retrieveComments: function (content, comments) {
		            for(var index in comments){
		                content = content.replace("{" + index + "}", comments[index]);
		            }
		            return content;
		        }
		    };
	
		    var messages = {
		        bold: "Bold",
		        italic: "Italic",
		        underline: "Underline",
		        strikethrough: "Strikethrough",
		        superscript: "Superscript",
		        subscript: "Subscript",
		        justifyCenter: "Center text",
		        justifyLeft: "Align text left",
		        justifyRight: "Align text right",
		        justifyFull: "Justify",
		        insertUnorderedList: "Insert unordered list",
		        insertOrderedList: "Insert ordered list",
		        indent: "Indent",
		        outdent: "Outdent",
		        createLink: "Insert hyperlink",
		        unlink: "Remove hyperlink",
		        insertImage: "Insert image",
		        insertFile: "Insert file",
		        insertHtml: "Insert HTML",
		        viewHtml: "View HTML",
		        fontName: "Select font family",
		        fontNameInherit: "(inherited font)",
		        fontSize: "Select font size",
		        fontSizeInherit: "(inherited size)",
		        formatBlock: "Format",
		        formatting: "Format",
		        foreColor: "Color",
		        backColor: "Background color",
		        style: "Styles",
		        emptyFolder: "Empty Folder",
		        editAreaTitle: "Editable area. Press F10 for toolbar.",
		        uploadFile: "Upload",
		        overflowAnchor: "More tools",
		        orderBy: "Arrange by:",
		        orderBySize: "Size",
		        orderByName: "Name",
		        invalidFileType: "The selected file \"{0}\" is not valid. Supported file types are {1}.",
		        deleteFile: 'Are you sure you want to delete "{0}"?',
		        overwriteFile: 'A file with name "{0}" already exists in the current directory. Do you want to overwrite it?',
		        directoryNotFound: "A directory with this name was not found.",
		        imageWebAddress: "Web address",
		        imageAltText: "Alternate text",
		        imageWidth: "Width (px)",
		        imageHeight: "Height (px)",
		        fileWebAddress: "Web address",
		        fileTitle: "Title",
		        fileText: "Text",
		        linkWebAddress: "Web address",
		        linkText: "Text",
		        linkToolTip: "ToolTip",
		        linkOpenInNewWindow: "Open link in new window",
		        dialogUpdate: "Update",
		        dialogInsert: "Insert",
		        dialogOk: "Ok",
		        dialogCancel: "Cancel",
		        cleanFormatting: "Clean formatting",
		        createTable: "Create a table",
		        createTableHint: "Create a {0} x {1} table",
		        addColumnLeft: "Add column on the left",
		        addColumnRight: "Add column on the right",
		        addRowAbove: "Add row above",
		        addRowBelow: "Add row below",
		        deleteRow: "Delete row",
		        deleteColumn: "Delete column",
		        tableWizard: "Table Wizard",
		        tableTab: "Table",
		        cellTab: "Cell",
		        accessibilityTab: "Accessibility",
		        caption: "Caption",
		        summary: "Summary",
		        width: "Width",
		        height: "Height",
		        units: "Units",
		        cellSpacing: "Cell Spacing",
		        cellPadding: "Cell Padding",
		        cellMargin: "Cell Margin",
		        alignment: "Alignment",
		        background: "Background",
		        cssClass: "CSS Class",
		        id: "ID",
		        border: "Border",
		        borderStyle: "Border Style",
		        collapseBorders: "Collapse borders",
		        wrapText: "Wrap text",
		        associateCellsWithHeaders: "Associate cells with headers",
		        alignLeft: "Align Left",
		        alignCenter: "Align Center",
		        alignRight: "Align Right",
		        alignLeftTop: "Align Left Top",
		        alignCenterTop: "Align Center Top",
		        alignRightTop: "Align Right Top",
		        alignLeftMiddle: "Align Left Middle",
		        alignCenterMiddle: "Align Center Middle",
		        alignRightMiddle: "Align Right Middle",
		        alignLeftBottom: "Align Left Bottom",
		        alignCenterBottom: "Align Center Bottom",
		        alignRightBottom: "Align Right Bottom",
		        alignRemove: "Remove Alignment",
		        columns: "Columns",
		        rows: "Rows",
		        selectAllCells: "Select All Cells",
		        exportAs: "Export As",
		        "import": "Import"
		    };
	
		    var supportedBrowser = !os || (os.ios && os.flatVersion >= 500) || (!os.ios && typeof(document.documentElement.contentEditable) != 'undefined');
	
		    var toolGroups = {
		        basic: [ "bold", "italic", "underline" ],
		        alignment: [ "justifyLeft", "justifyCenter", "justifyRight" ],
		        lists: [ "insertUnorderedList", "insertOrderedList" ],
		        indenting: [ "indent", "outdent" ],
		        links: [ "createLink", "unlink" ],
		        tables: [ "tableWizard", "createTable", "addColumnLeft", "addColumnRight", "addRowAbove", "addRowBelow", "deleteRow", "deleteColumn" ]
		    };
	
		    var Editor = Widget.extend({
		        init: function (element, options) {
		            var that = this,
		                value,
		                editorNS = kendo.ui.editor,
		                toolbarContainer,
		                toolbarOptions,
		                type, comments;
		            var domElement;
		            var dom = editorNS.Dom;
	
		            /* suppress initialization in mobile webkit devices (w/o proper contenteditable support) */
		            if (!supportedBrowser) {
		                return;
		            }
	
		            Widget.fn.init.call(that, element, options);
	
		            that.options = deepExtend({}, that.options, options);
		            that.options.tools = that.options.tools.slice();
	
		            element = that.element;
		            domElement = element[0];
	
		            type = dom.name(domElement);
	
		            this._registerHandler(
		                element.closest("form"), "submit", proxy(that.update, that, undefined)
		            );
	
		            toolbarOptions = extend({}, that.options);
		            toolbarOptions.editor = that;
	
		            if (type == "textarea") {
		                that._wrapTextarea();
	
		                toolbarContainer = that.wrapper.find(".k-editor-toolbar");
	
		                if (domElement.id) {
		                    toolbarContainer.attr("aria-controls", domElement.id);
		                }
		            } else {
		                that.element.attr("contenteditable", true).addClass("k-widget k-editor k-editor-inline");
	
		                toolbarOptions.popup = true;
	
		                toolbarContainer = $('<ul class="k-editor-toolbar" role="toolbar" />').insertBefore(element);
		            }
	
		            that.toolbar = new editorNS.Toolbar(toolbarContainer[0], toolbarOptions);
	
		            that.toolbar.bindTo(that);
	
		            if (type == "textarea") {
		                setTimeout(function () {
		                    var heightStyle = that.wrapper[0].style.height;
		                    var expectedHeight = parseInt(heightStyle, 10);
		                    var actualHeight = that.wrapper.height();
		                    if (heightStyle.indexOf("px") > 0 && !isNaN(expectedHeight) && actualHeight > expectedHeight) {
		                        that.wrapper.height(expectedHeight - (actualHeight - expectedHeight));
		                    }
		                });
		            }
	
		            that._resizable();
		            that._initializeContentElement(that);
	
		            that.keyboard = new editorNS.Keyboard([
		                new editorNS.BackspaceHandler(that),
		                new editorNS.TypingHandler(that),
		                new editorNS.SystemHandler(that),
		                new editorNS.SelectAllHandler(that)
		            ]);
	
		            that.clipboard = new editorNS.Clipboard(this);
	
		            that.undoRedoStack = new kendo.util.UndoRedoStack();
	
		            if (options && options.value) {
		                value = options.value;
		            } else if (that.textarea) {
		                // indented HTML introduces problematic ranges in IE
		                value = domElement.value;
	
		                // revert encoding of value when content is fetched from cache
		                if (that.options.encoded && $.trim(domElement.defaultValue).length) {
		                    value = domElement.defaultValue;
		                }
	
		                comments = dom.getAllComments($("<div></div>").html(value)[0]);
		                value = EditorUtils.cacheComments(value, comments);
		                value = value.replace(/[\r\n\v\f\t ]+/ig, " ");
		                value = EditorUtils.retrieveComments(value, comments);
		            } else {
		                value = domElement.innerHTML;
		            }
	
		            that.value(value || '\ufeff');
	
		            // using $.proxy here will break #5337
		            this._registerHandler(document, {
		                "mousedown": function() { that._endTyping(); },
		                "mouseup": function(e) { that._mouseup(e); }
		            });
	
		            that._initializeImmutables();
	
		            that.toolbar.resize();
	
		            kendo.notify(that);
		        },
	
		        setOptions: function(options) {
		            var editor = this;
	
		            Widget.fn.setOptions.call(editor, options);
		            if (options.tools) {
		                editor.toolbar.bindTo(editor);
		            }
		        },
	
		        _endTyping: function() {
		            var keyboard = this.keyboard;
	
		            try {
		                if (keyboard.isTypingInProgress()) {
		                    keyboard.endTyping(true);
	
		                    this.saveSelection();
		                }
		            } catch (e) { }
		        },
	
		        _selectionChange: function() {
		            this._selectionStarted = false;
		            this.saveSelection();
		            this.trigger("select", {});
		        },
	
		        _resizable: function() {
		            var resizable = this.options.resizable;
		            var isResizable = $.isPlainObject(resizable) ? (resizable.content === undefined || resizable.content === true) : resizable;
	
		            if (isResizable && this.textarea) {
		                var draggableElement = $("<div class='k-resize-handle'><span class='k-icon k-i-arrow-45-down-right' /></div>")
		                    .insertAfter(this.textarea);
	
		                this.wrapper.addClass('k-resizable');
	
		                this.wrapper.kendoResizable(extend({}, this.options.resizable, {
		                    draggableElement: draggableElement,
		                    start: function(e) {
		                        var editor = this.editor = $(e.currentTarget).closest(".k-editor");
		                        this.initialSize = editor.height();
		                        editor.find("td:last").append("<div class='k-overlay' />");
		                    },
		                    resize: function(e) {
		                        var delta = e.y.initialDelta;
		                        var newSize = this.initialSize + delta;
		                        var min = this.options.min || 0;
		                        var max = this.options.max || Infinity;
	
		                        newSize = Math.min(max, Math.max(min, newSize));
	
		                        this.editor.height(newSize);
		                    },
		                    resizeend: function() {
		                        this.editor.find(".k-overlay").remove();
		                        this.editor = null;
		                    }
		                }));
	
		                if (kendo.support.mobileOS.ios) {
		                    var resizableWidget = this.wrapper.getKendoResizable();
		                    resizableWidget.draggable.options.ignore = SELECT_OVERLAY_SELECTOR;
		                }
		            }
		        },
	
		        _initializeTableResizing: function() {
		            var editor = this;
	
		            kendo.ui.editor.TableResizing.create(editor);
	
		            editor._showTableResizeHandlesProxy = proxy(editor._showTableResizeHandles, editor);
		            editor.bind(SELECT, editor._showTableResizeHandlesProxy);
		        },
	
		        _destroyTableResizing: function() {
		            var editor = this;
		            var tableResizing = editor.tableResizing;
	
		            if (tableResizing) {
		                tableResizing.destroy();
		                editor.tableResizing = null;
		            }
	
		            if (editor._showTableResizeHandlesProxy) {
		                editor.unbind(SELECT, editor._showTableResizeHandlesProxy);
		            }
		        },
	
		        _showTableResizeHandles: function() {
		            var editor = this;
		            var tableResizing = editor.tableResizing;
	
		            if (tableResizing) {
		                tableResizing.showResizeHandles();
		            }
		        },
	
		        _initializeColumnResizing: function() {
		            kendo.ui.editor.ColumnResizing.create(this);
		        },
	
		        _destroyColumnResizing: function() {
		            var editor = this;
	
		            if (editor.columnResizing) {
		                editor.columnResizing.destroy();
		                editor.columnResizing = null;
		            }
		        },
	
		        _initializeRowResizing: function() {
		            kendo.ui.editor.RowResizing.create(this);
		        },
	
		        _destroyRowResizing: function() {
		            var editor = this;
	
		            if (editor.rowResizing) {
		                editor.rowResizing.destroy();
		                editor.rowResizing = null;
		            }
		        },
	
		        _wrapTextarea: function() {
		            var that = this,
		                textarea = that.element,
		                w = textarea[0].style.width,
		                h = textarea[0].style.height,
		                template = EditorUtils.editorWrapperTemplate,
		                editorWrap = $(template).insertBefore(textarea).width(w).height(h),
		                editArea = editorWrap.find(".k-editable-area");
	
		            textarea.attr("autocomplete", "off")
		                .appendTo(editArea).addClass("k-content k-raw-content").css("display", "none");
	
		            that.textarea = textarea;
		            that.wrapper = editorWrap;
		        },
	
		        _createContentElement: function(stylesheets) {
		            var editor = this;
		            var iframe, wnd, doc;
		            var textarea = editor.textarea;
		            var specifiedDomain = editor.options.domain;
		            var domain = specifiedDomain || document.domain;
		            var domainScript = "";
		            var src = 'javascript:""';
	
		            textarea.hide();
	
		            iframe = $("<iframe />", { title: editor.options.messages.editAreaTitle, frameBorder: "0" })[0];
	
		            $(iframe)
		                .css("display", "")
		                .addClass("k-content")
		                .attr("tabindex", textarea[0].tabIndex)
		                .insertBefore(textarea);
	
		            // automatically relax same-origin policy if document.domain != location.hostname,
		            // or forcefully relax if options.domain is specified (for document.domain = document.domain scenario)
		            if (specifiedDomain || domain != location.hostname) {
		                // relax same-origin policy
		                domainScript = "<script>document.domain=\"" + domain + "\"</script>";
		                src = "javascript:document.write('" + domainScript + "')";
		                iframe.src = src;
		            }
	
		            wnd = iframe.contentWindow || iframe;
		            doc = wnd.document || iframe.contentDocument;
	
		            $(iframe).one("load", function() {
		                editor.toolbar.decorateFrom(doc.body);
		            });
	
		            doc.open();
		            doc.write(
		                "<!DOCTYPE html><html><head>" +
		                "<meta charset='utf-8' />" +
		                "<style>" +
		                    "html,body{padding:0;margin:0;height:100%;min-height:100%;}" +
		                    "body{box-sizing:border-box;font-size:12px;font-family:Verdana,Geneva,sans-serif;margin-top:-1px;padding:5px .4em 0;" +
		                    "word-wrap: break-word;-webkit-nbsp-mode: space;-webkit-line-break: after-white-space;" +
		                    (kendo.support.isRtl(textarea) ? "direction:rtl;" : "") +
		                    (browser.msie || browser.edge || browser.chrome ? "height:auto;" : "") +
		                    (os.ios ? "word-break:break-all;" : "") +
		                    "}" +
		                    "h1{font-size:2em;margin:.67em 0}h2{font-size:1.5em}h3{font-size:1.16em}h4{font-size:1em}h5{font-size:.83em}h6{font-size:.7em}" +
		                    "p{margin:0 0 1em;}.k-marker{display:none;}.k-paste-container,.Apple-style-span{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden}" +
		                    "ul,ol{padding-left:2.5em}" +
		                    "span{-ms-high-contrast-adjust:none;}" +
		                    "a{color:#00a}" +
		                    "code{font-size:1.23em}" +
		                    "telerik\\3Ascript{display: none;}" +
		                    ".k-table{width:100%;border-spacing:0;margin: 0 0 1em;}" +
		                    ".k-table td{min-width:1px;padding:.2em .3em;}" +
		                    ".k-table,.k-table td{outline:0;border: 1px dotted #ccc;}" +
		                    ".k-table p{margin:0;padding:0;}" +
		                    ".k-column-resize-handle-wrapper {position: absolute; height: 10px; width:10px; cursor: col-resize; z-index: 2;}" +
		                    ".k-column-resize-handle {width: 100%; height: 100%;}" +
		                    ".k-column-resize-handle > .k-column-resize-marker {width:2px; height:100%; margin:0 auto; background-color:#00b0ff; display:none; opacity:0.8;}" +
		                    ".k-row-resize-handle-wrapper {position: absolute; cursor: row-resize; z-index:2; width: 10px; height: 10px;}" +
		                    ".k-row-resize-handle {display: table; width: 100%; height: 100%;}" +
		                    ".k-row-resize-marker-wrapper{display: table-cell; height:100%; width:100%; margin:0; padding:0; vertical-align: middle;}" +
		                    ".k-row-resize-marker{margin: 0; padding:0; width:100%; height:2px; background-color: #00b0ff; opacity:0.8; display:none;}" +
		                    ".k-table-resize-handle-wrapper {position: absolute; background-color: #fff; border: 1px solid #000; z-index: 100; width: 5px; height: 5px;}" +
		                    ".k-table-resize-handle {width: 100%; height: 100%;}" +
		                    ".k-table-resize-handle.k-resize-east{cursor:e-resize;}" +
		                    ".k-table-resize-handle.k-resize-north{cursor:n-resize;}" +
		                    ".k-table-resize-handle.k-resize-northeast{cursor:ne-resize;}" +
		                    ".k-table-resize-handle.k-resize-northwest{cursor:nw-resize;}" +
		                    ".k-table-resize-handle.k-resize-south{cursor:s-resize;}" +
		                    ".k-table-resize-handle.k-resize-southeast{cursor:se-resize;}" +
		                    ".k-table-resize-handle.k-resize-southwest{cursor:sw-resize;}" +
		                    ".k-table-resize-handle.k-resize-west{cursor:w-resize;}" +
		                    ".k-table.k-table-resizing{opacity:0.6;}" +
		                    "k\\:script{display:none;}" +
		                "</style>" +
		                domainScript +
		                $.map(stylesheets, function(href){
		                    return "<link rel='stylesheet' href='" + href + "'>";
		                }).join("") +
		                "</head><body autocorrect='off' contenteditable='true'></body></html>"
		            );
	
		            doc.close();
	
		            return wnd;
		        },
	
		        _blur: function() {
		            var textarea = this.textarea;
		            var old = textarea ? textarea.val() : this._oldValue;
		            var value = this.options.encoded ? this.encodedValue() : this.value();
	
		            this.update();
	
		            if (textarea) {
		                textarea.trigger("blur");
		            }
	
		            if (value != old) {
		                this.trigger("change");
		                if(textarea) {
		                    textarea.trigger("change");
		                }
		            }
		        },
	
		        _spellCorrect: function(editor) {
		            var beforeCorrection;
		            var falseTrigger = false;
	
		            this._registerHandler(editor.body, {
		                "contextmenu": function() {
		                    editor.one("select", function() {
		                        beforeCorrection = null;
		                    });
	
		                    editor._spellCorrectTimeout = setTimeout(function() {
		                        beforeCorrection = new kendo.ui.editor.RestorePoint(editor.getRange(), editor.body);
		                        falseTrigger = false;
		                    }, 10);
		                },
		                "input": function() {
		                    if (!beforeCorrection) {
		                        return;
		                    }
	
		                    if (kendo.support.browser.mozilla && !falseTrigger) {
		                        falseTrigger = true;
		                        return;
		                    }
	
		                    kendo.ui.editor._finishUpdate(editor, beforeCorrection);
		                }
		            });
		        },
	
		        _registerHandler: function(element, type, handler) {
		            var editor = this;
		            var NS = ".kendoEditor";
		            var eventNames;
		            var i;
	
		            element = $(element);
	
		            if (!this._handlers) {
		                this._handlers = [];
		            }
	
		            if (element.length) {
		                if ($.isPlainObject(type)) {
		                    for (var t in type) {
		                        if (type.hasOwnProperty(t)) {
		                            this._registerHandler(element, t, type[t]);
		                        }
		                    }
		                } else {
		                    //map the original event to handle interaction on mobile platforms
		                    eventNames = kendo.applyEventMap(type).split(" ");
	
		                    for (i = 0; i < eventNames.length; i++) {
		                        editor._handlers.push({
		                            element: element,
		                            type: eventNames[i] + NS,
		                            handler: handler
		                        });
	
		                        element.on(eventNames[i] + NS, handler);
		                    }
		                }
		            }
		        },
	
		        _deregisterHandlers: function() {
		            var handlers = this._handlers;
	
		            for (var i = 0; i < handlers.length; i++) {
		                var h = handlers[i];
		                h.element.off(h.type, h.handler);
		            }
	
		            this._handlers = [];
		        },
	
		        _initializeContentElement: function() {
		            var editor = this;
		            var doc;
		            var blurTrigger;
		            var mousedownTrigger;
	
		            if (editor.textarea) {
		                editor.window = editor._createContentElement(editor.options.stylesheets);
		                doc = editor.document = editor.window.contentDocument || editor.window.document;
	
		                // Ensure that body exists as various Firefox plugins can cause a delay of the body creation
		                // https://github.com/telerik/kendo-ui-core/issues/3515
		                if (!doc.body) {
		                    var body = doc.createElement("body");
		                    body.setAttribute("contenteditable", "true");
		                    body.setAttribute("autocorrect", "off");
		                    doc.getElementsByTagName("html")[0].appendChild(body);
	
		                    var interval = setInterval(function (){
		                        if ($(editor.document).find("body").length > 1) {
		                            $(editor.document).find("body:last").remove();
		                            window.clearInterval(interval);
		                        }
		                    },10);
		                }
	
		                editor.body = doc.body;
	
		                blurTrigger = editor.window;
		                mousedownTrigger = doc;
	
		                this._registerHandler(doc, "mouseup", proxy(this._mouseup, this));
		            } else {
		                editor.window = window;
		                doc = editor.document = document;
		                editor.body = editor.element[0];
	
		                blurTrigger = editor.body;
		                mousedownTrigger = editor.body;
	
		                editor.toolbar.decorateFrom(editor.body);
		            }
	
		            this._registerHandler(blurTrigger, "blur", proxy(this._blur, this));
		            editor._registerHandler(mousedownTrigger, "down", proxy(editor._mousedown, editor));
	
		            try {
		                doc.execCommand("enableInlineTableEditing", null, false);
		            } catch(e) { }
	
		            if (kendo.support.touch) {
		                this._registerHandler(doc, {
		                    "keydown": function() {
		                        // necessary in iOS when touch events are bound to the page
		                        if (kendo._activeElement() != doc.body) {
		                            editor.window.focus();
		                        }
		                    }
		                });
		            }
	
		            this._spellCorrect(editor);
	
		            this._registerHandler(editor.body, {
		                "keydown": function (e) {
		                    var range;
	
		                    if ((e.keyCode === keys.BACKSPACE || e.keyCode === keys.DELETE) && editor.body.getAttribute("contenteditable") !== "true") {
		                        return false;
		                    }
	
		                    if (e.keyCode === keys.F10) {
		                        // Handling with timeout to avoid the default IE menu
		                        setTimeout(proxy(editor.toolbar.focus, editor.toolbar), 100);
		                        editor.toolbar.preventPopupHide = true;
		                        e.preventDefault();
		                        return;
		                    } else if (e.keyCode == keys.LEFT || e.keyCode == keys.RIGHT) {
		                        // skip bom nodes when navigating with arrows
		                        range = editor.getRange();
		                        var left = e.keyCode == keys.LEFT;
		                        var container = range[left ? "startContainer" : "endContainer"];
		                        var offset = range[left ? "startOffset" : "endOffset"];
		                        var direction = left ? -1 : 1;
	
		                        var next = offset + direction;
		                        var nextChar = left ? next : offset;
	
		                        if (container.nodeType == 3 && container.nodeValue[nextChar] == "\ufeff") {
		                            range.setStart(container, next);
		                            range.collapse(true);
		                            editor.selectRange(range);
		                        }
		                    }
	
		                    var tools = editor.toolbar.tools;
		                    var toolName = editor.keyboard.toolFromShortcut(tools, e);
		                    var toolOptions = toolName ? tools[toolName].options : {};
		                    if (toolName && !toolOptions.keyPressCommand) {
		                        e.preventDefault();
	
		                        if (!/^(undo|redo)$/.test(toolName)) {
		                            editor.keyboard.endTyping(true);
		                        }
	
		                        editor.trigger("keydown", e);
		                        editor.exec(toolName);
		                        editor._runPostContentKeyCommands(e);
	
		                        return false;
		                    }
	
		                    editor.keyboard.clearTimeout();
	
		                    editor.keyboard.keydown(e);
		                },
		                "keypress": function(e) {
		                    setTimeout(function () {
		                        editor._runPostContentKeyCommands(e);
		                        editor._showTableResizeHandles();
		                    }, 0);
		                },
		                "keyup": function (e) {
		                    var selectionCodes = [
		                       keys.BACKSPACE,
		                       keys.TAB,
		                       keys.PAGEUP,
		                       keys.PAGEDOWN,
		                       keys.END,
		                       keys.HOME,
		                       keys.LEFT,
		                       keys.UP,
		                       keys.RIGHT,
		                       keys.DOWN,
		                       keys.INSERT,
		                       keys.DELETE
		                    ];
	
		                    if ($.inArray(e.keyCode, selectionCodes) > -1 || (e.keyCode == 65 && e.ctrlKey && !e.altKey && !e.shiftKey)) {
		                        editor._selectionChange();
		                    }
	
		                    editor.keyboard.keyup(e);
		                },
		                "click": function(e) {
		                    var dom = kendo.ui.editor.Dom, range;
	
		                    if (dom.name(e.target) === "img") {
		                        range = editor.createRange();
		                        range.selectNode(e.target);
		                        editor.selectRange(range);
		                    }
		                },
		                "cut copy paste drop dragover": function (e) {
		                    editor.clipboard["on" + e.type](e);
		                },
		                "focusin": function () {
		                    if (editor.body.hasAttribute("contenteditable")) {
		                        $(this).addClass("k-state-active");
		                        editor.toolbar.show();
		                    }
		                },
		                "focusout": function() {
		                    setTimeout(function() {
		                        var active = kendo._activeElement();
		                        var body = editor.body;
		                        var toolbar = editor.toolbar;
		                        if (toolbar.options.popup) {
		                            var toolbarContainerElement = toolbar.window.element.get(0);
		                            if (toolbarContainerElement && !($.contains(toolbarContainerElement, active) || toolbarContainerElement == active)) {
		                                toolbar.preventPopupHide = false;
		                            }
		                        }
		                        if (active != body && !$.contains(body, active) && !$(active).is(".k-editortoolbar-dragHandle") && !toolbar.focused()) {
		                            $(body).removeClass("k-state-active");
		                            toolbar.hide();
		                        }
		                    }, 10);
		                }
		            });
	
		            editor._initializeColumnResizing();
		            editor._initializeRowResizing();
		            editor._initializeTableResizing();
		        },
	
		        _initializeImmutables: function(){
		            var that = this,
		                editorNS = kendo.ui.editor;
	
		            if (that.options.immutables){
		                that.immutables = new editorNS.Immutables(that);
		            }
		        },
	
		        _mousedown: function (e) {
		            var editor = this;
		            editor._selectionStarted = true;
	
		            if ($(editor.body).parents('.k-window').length) {
		                e.stopPropagation();
		            }
	
		            // handle middle-click and ctrl-click on links
		            if (browser.gecko) {
		                return;
		            }
	
		            var target = $(e.target);
	
		            if ((e.which == 2 || (e.which == 1 && e.ctrlKey)) &&
		                target.is("a[href]")) {
		                window.open(target.attr("href"), "_new");
		            }
		        },
	
		        _mouseup: function(e) {
		            var that = this;
	
		            if (kendo.support.mobileOS.ios && e && $(e.target).is(SELECT_OVERLAY_SELECTOR)) {
		                return;
		            }
	
		            if (that._selectionStarted) {
		                setTimeout(function() {
		                    that._selectionChange();
		                }, 1);
		            }
		        },
	
		        _runPostContentKeyCommands: function (e) {
		            var range = this.getRange();
		            var tools = this.keyboard.toolsFromShortcut(this.toolbar.tools, e);
	
		            for (var i = 0; i < tools.length; i++) {
		                var tool = tools[i];
		                var o = tool.options;
		                if (!o.keyPressCommand) {
		                    continue;
		                }
	
		                var cmd = new o.command({range: range});
		                if (cmd.changesContent()) {
		                    this.keyboard.endTyping(true);
		                    this.exec(tool.name);
		                }
		            }
		        },
	
		        refresh: function() {
		            var that = this;
	
		            if (that.textarea) {
		                that._destroyResizings();
		                // preserve updated value before re-initializing
		                // don't use update() to prevent the editor from encoding the content too early
		                var value = that.value();
		                that.textarea.val(value);
		                that.wrapper.find("iframe").remove();
		                that._initializeContentElement(that);
		                that.value(value);
		            }
		        },
	
		        events: [
		            "select",
		            "change",
		            "execute",
		            "error",
		            "paste",
		            "keydown",
		            "keyup"
		        ],
	
		        options: {
		            name: "Editor",
		            messages: messages,
		            formats: {},
		            encoded: true,
		            domain: null,
		            resizable: false,
		            deserialization: {
		                custom: null
		            },
		            serialization: {
		                entities: true,
		                semantic: true,
		                scripts: false
		            },
		            pasteCleanup: {
		                all: false,
		                css: false,
		                custom: null,
		                keepNewLines: false,
		                msAllFormatting: false,
		                msConvertLists: true,
		                msTags: true,
		                none: false,
		                span: false
		            },
		            stylesheets: [],
		            dialogOptions: {
		                modal: true, resizable: false, draggable: true,
		                animation: false
		            },
		            imageBrowser: null,
		            fileBrowser: null,
		            fontName: [
		                { text: "Arial", value: "Arial, Helvetica, sans-serif" },
		                { text: "Courier New", value: "\"Courier New\", Courier, monospace" },
		                { text: "Georgia", value: "Georgia, serif" },
		                { text: "Impact", value: "Impact, Charcoal, sans-serif" },
		                { text: "Lucida Console", value: "\"Lucida Console\", Monaco, monospace" },
		                { text: "Tahoma", value: "Tahoma, Geneva, sans-serif" },
		                { text: "Times New Roman", value: "\"Times New Roman\", Times,serif" },
		                { text: "Trebuchet MS", value: "\"Trebuchet MS\", Helvetica, sans-serif" },
		                { text: "Verdana", value: "Verdana, Geneva, sans-serif" }
		            ],
		            fontSize: [
		                { text: "1 (8pt)",  value: "xx-small" },
		                { text: "2 (10pt)", value: "x-small" },
		                { text: "3 (12pt)", value: "small" },
		                { text: "4 (14pt)", value: "medium" },
		                { text: "5 (18pt)", value: "large" },
		                { text: "6 (24pt)", value: "x-large" },
		                { text: "7 (36pt)", value: "xx-large" }
		            ],
		            formatBlock: [
		                { text: "Paragraph", value: "p" },
		                { text: "Quotation", value: "blockquote" },
		                { text: "Heading 1", value: "h1" },
		                { text: "Heading 2", value: "h2" },
		                { text: "Heading 3", value: "h3" },
		                { text: "Heading 4", value: "h4" },
		                { text: "Heading 5", value: "h5" },
		                { text: "Heading 6", value: "h6" }
		            ],
		            tools: [].concat.call(
		                ["formatting"],
		                toolGroups.basic,
		                toolGroups.alignment,
		                toolGroups.lists,
		                toolGroups.indenting,
		                toolGroups.links,
		                ["insertImage"],
		                toolGroups.tables
		            )
		        },
	
		        destroy: function() {
		            var editor = this;
	
		            Widget.fn.destroy.call(this);
	
		            this._endTyping(true);
	
		            this._deregisterHandlers();
	
		            clearTimeout(this._spellCorrectTimeout);
	
		            this._focusOutside();
	
		            this.toolbar.destroy();
	
		            editor._destroyUploadWidget();
	
		            editor._destroyResizings();
	
		            kendo.destroy(this.wrapper);
		        },
	
		        _destroyResizings: function() {
		            var editor = this;
	
		            editor._destroyTableResizing();
		            kendo.ui.editor.TableResizing.dispose(editor);
		            editor._destroyRowResizing();
		            kendo.ui.editor.RowResizing.dispose(editor);
		            editor._destroyColumnResizing();
		            kendo.ui.editor.ColumnResizing.dispose(editor);
		        },
	
		        _focusOutside: function () {
		            // move focus outside the Editor, see https://github.com/telerik/kendo/issues/3673
		            if (kendo.support.browser.msie && this.textarea) {
		                var tempInput = $("<input style='position:fixed;left:1px;top:1px;width:1px;height:1px;font-size:0;border:0;opacity:0' />").appendTo(document.body).focus();
		                tempInput.blur().remove();
		            }
		        },
	
		        _destroyUploadWidget: function(){
		            var editor = this;
		            if (editor._uploadWidget) {
		                editor._uploadWidget.destroy();
		                editor._uploadWidget = null;
		            }
		        },
	
		        state: function(toolName) {
		            var tool = Editor.defaultTools[toolName];
		            var finder = tool && (tool.options.finder || tool.finder);
		            var RangeUtils = kendo.ui.editor.RangeUtils;
		            var range, textNodes;
	
		            if (finder) {
		                range = this.getRange();
	
		                textNodes = RangeUtils.textNodes(range);
	
		                if (!textNodes.length && range.collapsed) {
		                    textNodes = [range.startContainer];
		                }
	
		                return finder.getFormat ? finder.getFormat(textNodes) : finder.isFormatted(textNodes);
		            }
	
		            return false;
		        },
	
		        value: function (html) {
		            var body = this.body,
		                editorNS = kendo.ui.editor,
		                options = this.options,
		                currentHtml = editorNS.Serializer.domToXhtml(body, options.serialization);
	
		            if (html === undefined) {
		                return currentHtml;
		            }
	
		            if (html == currentHtml) {
		                return;
		            }
	
		            editorNS.Serializer.htmlToDom(html, body, options.deserialization);
	
		            this.selectionRestorePoint = null;
		            this.update();
	
		            this.toolbar.refreshTools();
		        },
	
		        saveSelection: function(range) {
		            range = range || this.getRange();
		            var container = range.commonAncestorContainer,
		                body = this.body;
	
		            if (container == body || $.contains(body, container)) {
		                this.selectionRestorePoint = new kendo.ui.editor.RestorePoint(range, body);
		            }
		        },
	
		        _focusBody: function() {
		            var body = this.body;
		            var iframe = this.wrapper && this.wrapper.find("iframe")[0];
		            var documentElement = this.document.documentElement;
		            var activeElement = kendo._activeElement();
		            var scrollTop;
	
	
		            if(!iframe && body.scrollHeight > body.clientHeight) {
		                scrollTop = body.scrollTop;
		                body.focus();
		                body.scrollTop = scrollTop;
	
		            } else if(activeElement != body && activeElement != iframe) {
		                scrollTop = documentElement.scrollTop;
		                body.focus();
		                documentElement.scrollTop = scrollTop;
		            }
		        },
	
		        restoreSelection: function() {
		            this._focusBody();
	
		            if (this.selectionRestorePoint) {
		                this.selectRange(this.selectionRestorePoint.toRange());
		            }
		        },
	
		        focus: function () {
		            this.restoreSelection();
		        },
	
		        update: function (value) {
		            value = value || this.options.encoded ? this.encodedValue() : this.value();
	
		            if (this.textarea) {
		                this.textarea.val(value);
		            } else {
		                this._oldValue = value;
		            }
		        },
	
		        encodedValue: function () {
		            return kendo.ui.editor.Dom.encode(this.value());
		        },
	
		        createRange: function (document) {
		            return kendo.ui.editor.RangeUtils.createRange(document || this.document);
		        },
	
		        getSelection: function () {
		            return kendo.ui.editor.SelectionUtils.selectionFromDocument(this.document);
		        },
	
		        selectRange: function(range) {
		            this._focusBody();
		            var selection = this.getSelection();
		            selection.removeAllRanges();
		            selection.addRange(range);
		            this.saveSelection(range);
		        },
	
		        getRange: function () {
		            var selection = this.getSelection(),
		                range = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : this.createRange(),
		                doc = this.document;
	
		            if (range.startContainer == doc && range.endContainer == doc && !range.startOffset && !range.endOffset) {
		                range.setStart(this.body, 0);
		                range.collapse(true);
		            }
	
		            return range;
		        },
	
		        _containsRange: function (range) {
		            var dom = kendo.ui.editor.Dom;
		            var body = this.body;
		            return range && dom.isAncestorOrSelf(body, range.startContainer) &&
		                dom.isAncestorOrSelf(body, range.endContainer);
		        },
	
		        _deleteSavedRange: function () {
		            if ("_range" in this) {
		                delete this._range;
		            }
		        },
	
		        selectedHtml: function() {
		            return kendo.ui.editor.Serializer.domToXhtml(this.getRange().cloneContents());
		        },
	
		        paste: function (html, options) {
		            this.focus();
	
		            var command = new kendo.ui.editor.InsertHtmlCommand($.extend({
		                range: this.getRange(),
		                html: html
		            }, options));
	
		            command.editor = this;
	
		            command.exec();
		        },
	
		        exec: function (name, params) {
		            var that = this;
		            var command = null;
		            var range, tool, prevented;
	
		            if (!name) {
		                throw new Error("kendoEditor.exec(): `name` parameter cannot be empty");
		            }
	
		            if (that.body.getAttribute("contenteditable") !== "true" &&
		                name !== "print" &&
		                name !== "pdf" &&
		                name !== "exportAs") {
		                return false;
		            }
	
		            name = name.toLowerCase();
	
		            if (!that.keyboard.isTypingInProgress()) {
		                that._focusBody();
		                that.selectRange(that._range || that.getRange());
		            }
	
		            tool = that.toolbar.toolById(name);
	
		            if (!tool) {
		                // execute non-toolbar tool
		                for (var id in Editor.defaultTools) {
		                    if (id.toLowerCase() == name) {
		                        tool = Editor.defaultTools[id];
		                        break;
		                    }
		                }
		            }
	
		            if (tool) {
		                range = that.getRange();
	
		                if (tool.command) {
		                    command = tool.command(extend({ range: range, body: that.body, immutables: !!that.immutables }, params));
		                }
	
		                prevented = that.trigger("execute", { name: name, command: command });
	
		                if (prevented) {
		                    return;
		                }
	
		                if (/^(undo|redo)$/i.test(name)) {
		                    that.undoRedoStack[name]();
		                } else if (command) {
		                    that.execCommand(command);
	
		                    if (command.async) {
		                        command.change = proxy(that._selectionChange, that);
		                        return;
		                    }
		                }
	
		                that._selectionChange();
		            }
		        },
	
		        execCommand: function(command) {
		            if (!command.managesUndoRedo) {
		                this.undoRedoStack.push(command);
		            }
	
		            command.editor = this;
		            command.exec();
		        }
		    });
	
		    Editor.defaultTools = {
		        undo: { options: { key: "Z", ctrl: true } },
		        redo: { options: { key: "Y", ctrl: true } }
		    };
	
		    kendo.ui.plugin(Editor);
	
		    var Tool = Class.extend({
		        init: function(options) {
		            this.options = options;
		        },
	
		        initialize: function(ui, options) {
		            ui.attr({ unselectable: "on", title: options.title });
		            ui.children(".k-tool-text").html(options.title);
		        },
	
		        command: function (commandArguments) {
		            return new this.options.command(commandArguments);
		        },
	
		        update: $.noop
		    });
	
		    Tool.exec = function (editor, name, value) {
		        editor.exec(name, { value: value });
		    };
	
		    EditorUtils.registerTool("separator", new Tool({ template: new ToolTemplate({template: EditorUtils.separatorTemplate})}));
	
		    // Exports ================================================================
	
		    var bomFill = browser.msie && browser.version < 9 ? '\ufeff' : '';
		    var emptyElementContent = '\ufeff';
		    var emptyTableCellContent = emptyElementContent;
	
		    if(browser.msie || browser.edge) {
		        emptyTableCellContent = emptyElementContent = "&nbsp;";
		    }
	
		    extend(kendo.ui, {
		        editor: {
		            ToolTemplate: ToolTemplate,
		            EditorUtils: EditorUtils,
		            Tool: Tool,
		            _bomFill: bomFill,
		            emptyElementContent: emptyElementContent,
		            emptyTableCellContent: emptyTableCellContent
		        }
		    });
	
		    if (kendo.PDFMixin) {
		        kendo.PDFMixin.extend(Editor.prototype);
		        Editor.prototype._drawPDF = function() {
		            return kendo.drawing.drawDOM(this.body, this.options.pdf);
		        };
		        Editor.prototype.saveAsPDF = function() {
		            var progress = new $.Deferred();
		            var promise = progress.promise();
		            var args = { promise: promise };
	
		            if (this.trigger("pdfExport", args)) {
		                return;
		            }
	
		            var options = this.options.pdf;
	
		            this._drawPDF(progress)
		            .then(function(root) {
		                return kendo.drawing.exportPDF(root, options);
		            })
		            .done(function(dataURI) {
		                kendo.saveAs({
		                    dataURI: dataURI,
		                    fileName: options.fileName,
		                    proxyURL: options.proxyURL,
		                    proxyTarget: options.proxyTarget,
		                    forceProxy: options.forceProxy
		                });
		                progress.resolve();
		            })
		            .fail(function(err) {
		                progress.reject(err);
		            });
	
		            return promise;
		        };
		    }
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 941:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(663);
	
	/***/ }),
	
	/***/ 942:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 943:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 944:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(595);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1516);
		module.exports = __webpack_require__(1516);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1516:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    var UndoRedoStack = kendo.Observable.extend({
		        init: function(options) {
		            kendo.Observable.fn.init.call(this, options);
		            this.clear();
		        },
		        events: [ "undo", "redo" ],
		        push: function (command) {
		            this.stack = this.stack.slice(0, this.currentCommandIndex + 1);
		            this.currentCommandIndex = this.stack.push(command) - 1;
		        },
		        undo: function () {
		            if (this.canUndo()) {
		                var command = this.stack[this.currentCommandIndex--];
		                command.undo();
		                this.trigger("undo", { command: command });
		            }
		        },
		        redo: function () {
		            if (this.canRedo()) {
		                var command = this.stack[++this.currentCommandIndex];
		                command.redo();
		                this.trigger("redo", { command: command });
		            }
		        },
		        clear: function() {
		            this.stack = [];
		            this.currentCommandIndex = -1;
		        },
		        canUndo: function () {
		            return this.currentCommandIndex >= 0;
		        },
		        canRedo: function () {
		            return this.currentCommandIndex != this.stack.length - 1;
		        }
		    });
	
		    kendo.deepExtend(kendo, {
		        util: {
		            UndoRedoStack: UndoRedoStack
		        }
		    });
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(990);
		module.exports = __webpack_require__(990);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 939:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(658);
	
	/***/ }),
	
	/***/ 990:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(939) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($,undefined) {
		    var kendo = window.kendo;
		    var ui = kendo.ui;
		    var editorNS = ui.editor;
		    var Widget = ui.Widget;
		    var extend = $.extend;
		    var proxy = $.proxy;
		    var keys = kendo.keys;
		    var NS = ".kendoEditor";
		    var EditorUtils = editorNS.EditorUtils;
		    var ToolTemplate = editorNS.ToolTemplate;
		    var Tool = editorNS.Tool;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
		    var OVERFLOWANCHOR = "overflowAnchor";
	
		    var focusable = ".k-tool-group:visible a.k-tool:not(.k-state-disabled)," +
		                    ".k-tool.k-overflow-anchor:visible," +
		                    ".k-tool-group:visible .k-widget.k-colorpicker," +
		                    ".k-tool-group:visible .k-selectbox," +
		                    ".k-tool-group:visible .k-dropdown," +
		                    ".k-tool-group:visible .k-combobox .k-input";
	
		    var toolNamesByCssClass = {
		        "k-i-sup-script": "superscript",
		        "k-i-sub-script": "subscript",
		        "k-i-align-left": "justifyLeft",
		        "k-i-align-center": "justifyCenter",
		        "k-i-align-right": "justifyRight",
		        "k-i-align-justify": "justifyFull",
		        "k-i-list-unordered": "insertUnorderedList",
		        "k-i-list-ordered": "insertOrderedList",
		        "k-i-login": "import",
		        "k-i-indent-increase": "indent",
		        "k-i-indent-decrease": "outdent",
		        "k-i-link-horizontal": "createLink",
		        "k-i-unlink-horizontal": "unlink",
		        "k-i-image": "insertImage",
		        "k-i-file-add": "insertFile",
		        "k-i-html": "viewHtml",
		        "k-i-foreground-color": "foreColor",
		        "k-i-paint": "backColor",
		        "k-i-table-insert": "createTable",
		        "k-i-table-column-insert-left": "addColumnLeft",
		        "k-i-table-column-insert-right": "addColumnRight",
		        "k-i-table-row-insert-above": "addRowAbove",
		        "k-i-table-row-insert-below": "addRowBelow",
		        "k-i-table-row-delete": "deleteRow",
		        "k-i-table-column-delete": "deleteColumn",
		        "k-i-table-properties": "tableWizard",
		        "k-i-table-wizard": "tableWizardInsert",
		        "k-i-clear-css": "cleanFormatting"
		    };
	
		    var OverflowAnchorTool = Tool.extend({
		        initialize: function(ui, options) {
		            ui.attr({ unselectable: "on" });
		            var toolbar = options.editor.toolbar;
		            ui.attr("aria-controls", options.editor.element.attr("id"))
		            .on("click", $.proxy(function() {
		                this.overflowPopup.toggle();
		            }, toolbar));
		        },
	
		        options: {
		            name: OVERFLOWANCHOR
		        },
	
		        command: $.noop,
		        update: $.noop,
		        destroy: $.noop
	
		    });
	
		    EditorUtils.registerTool(OVERFLOWANCHOR, new OverflowAnchorTool({
		        key: "",
		        ctrl: true,
		        template: new ToolTemplate({ template: EditorUtils.overflowAnchorTemplate })
		    }));
	
		    var Toolbar = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            options = extend({}, options, { name: "EditorToolbar" });
	
		            Widget.fn.init.call(that, element, options);
	
		            if (options.popup) {
		                that._initPopup();
		            }
	
		            if (options.resizable && options.resizable.toolbar) {
		                that._resizeHandler = kendo.onResize(function() {
		                    that.resize(true);
		                });
	
		                that.element.addClass("k-toolbar-resizable");
		            }
		        },
	
		        events: [
		            "execute"
		        ],
	
		        groups: {
		            basic: ["bold", "italic", "underline", "strikethrough"],
		            scripts: ["subscript", "superscript" ],
		            alignment: ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull" ],
		            links: ["insertImage", "insertFile", "createLink", "unlink"],
		            lists: ["insertUnorderedList", "insertOrderedList", "indent", "outdent"],
		            tables: [ "createTable", "addColumnLeft", "addColumnRight", "addRowAbove", "addRowBelow", "deleteRow", "deleteColumn" ],
		            advanced: [ "viewHtml", "cleanFormatting", "print", "pdf", "exportAs", "import"],
		            fonts: [ "fontName", "fontSize" ],
		            colors: [ "foreColor", "backColor" ]
		        },
	
		        overflowFlaseTools: [ "formatting", "fontName", "fontSize", "foreColor", "backColor", "insertHtml" ],
	
		        _initPopup: function() {
		            var that = this;
		            this.window = $(this.element)
		                .wrap("<div class='editorToolbarWindow k-header' />")
		                .parent()
		                .prepend("<button class='k-button k-bare k-editortoolbar-dragHandle'><span class='k-icon k-i-handler-drag' /></button>")
		                .kendoWindow({
		                    title: false,
		                    resizable: false,
		                    draggable: {
		                        dragHandle: ".k-editortoolbar-dragHandle"
		                    },
		                    animation: {
		                        open: { effects: "fade:in" },
		                        close: { effects: "fade:out" }
		                    },
		                    minHeight: 42,
		                    visible: false,
		                    autoFocus: false,
		                    actions: [],
		                    dragend: function() {
		                        this._moved = true;
		                    }
		                })
		                .on("mousedown", function(e){
		                    if (!$(e.target).is(".k-icon")) {
		                        that.preventPopupHide = true;
		                    }
		                })
		                .on("focusout", function(){
		                    that.options.editor.element.focusout();
		                })
		                .data("kendoWindow");
		        },
	
		        _toggleOverflowStyles: function(element, show) {
		            element
		                .find("> li").toggleClass("k-item k-state-default", show)
		                .find(".k-tool:not(.k-state-disabled),.k-overflow-button").toggleClass("k-overflow-button k-button", show);
		        },
	
		        _initOverflowPopup: function(ui) {
		            var that = this;
		            var popupTemplate = "<ul class='k-editor-overflow-popup k-overflow-container k-list-container'></ul>";
	
		            that.overflowPopup = $(popupTemplate).appendTo("body").kendoPopup({
		                anchor: ui,
		                origin: "bottom right",
		                position: "top right",
		                copyAnchorStyles: false,
		                open: function(e) {
		                    if (this.element.is(":empty")) {
		                        e.preventDefault();
		                    }
	
		                    that._toggleOverflowStyles(this.element, true);
		                    ui.attr("aria-expanded", true);
		                },
		                close: function() {
		                    ui.attr("aria-expanded", false);
		                },
		                activate: proxy(that.focusOverflowPopup, that)
		            }).data("kendoPopup");
		        },
	
		        items: function() {
		            var isResizable = this.options.resizable && this.options.resizable.toolbar,
		                popup, result;
	
		            result = this.element.children().find("> *, select");
	
		            if (isResizable) {
		                popup = this.overflowPopup;
		                result = result.add(popup.element.children().find("> *"));
		            }
	
		            return result;
		        },
	
		        focused: function() {
		            return this.element.find(".k-state-focused").length > 0 ||
		                    this.preventPopupHide ||
		                    (this.overflowPopup && this.overflowPopup.visible());
		        },
	
		        toolById: function(name) {
		            var id, tools = this.tools;
	
		            for (id in tools) {
		                if (id.toLowerCase() == name) {
		                    return tools[id];
		                }
		            }
		        },
	
		        toolGroupFor: function(toolName) {
		            var i, groups = this.groups;
	
		            if (this.isCustomTool(toolName)) {
		                return "custom";
		            }
	
		            for (i in groups) {
		                if ($.inArray(toolName, groups[i]) >= 0) {
		                    return i;
		                }
		            }
		        },
	
		        bindTo: function(editor) {
		            var that = this,
		                window = that.window;
	
		            // detach from editor that was previously listened to
		            if (that._editor) {
		                that._editor.unbind("select", proxy(that.resize, that));
		            }
	
		            that._editor = editor;
	
		            if (that.options.resizable && that.options.resizable.toolbar) {
		                editor.options.tools.push(OVERFLOWANCHOR);
		            }
	
		            // re-initialize the tools
		            that.tools = that.expandTools(editor.options.tools);
		            that.render();
	
		            that.element.find(".k-combobox .k-input").keydown(function(e) {
		                var combobox = $(this).closest(".k-combobox").data("kendoComboBox"),
		                    key = e.keyCode;
	
		                if (key == keys.RIGHT || key == keys.LEFT) {
		                    combobox.close();
		                } else if (key == keys.DOWN) {
		                    if (!combobox.dropDown.isOpened()) {
		                        e.stopImmediatePropagation();
		                        combobox.open();
		                    }
		                }
		            });
	
		            that._attachEvents();
	
		            that.items().each(function initializeTool() {
	
		                var toolName = that._toolName(this),
		                    tool = toolName !== "moreVertical" ? that.tools[toolName] : that.tools.overflowAnchor,
		                    options = tool && tool.options,
		                    messages = editor.options.messages,
		                    description = options && options.tooltip || messages[toolName],
		                    ui = $(this);
	
		                if (!tool || !tool.initialize) {
		                    return;
		                }
	
		                if (toolName == "fontSize" || toolName == "fontName") {
		                    var inheritText = messages[toolName + "Inherit"];
	
		                    ui.find("input").val(inheritText).end()
		                      .find("span.k-input").text(inheritText).end();
		                }
	
		                tool.initialize(ui, {
		                    title: that._appendShortcutSequence(description, tool),
		                    editor: that._editor
		                });
	
		                ui.closest(".k-widget", that.element).addClass("k-editor-widget");
	
		                ui.closest(".k-colorpicker", that.element).next(".k-colorpicker").addClass("k-editor-widget");
		            });
	
		            editor.bind("select", proxy(that.resize, that));
	
		            that.update();
	
		            if (window) {
		                window.wrapper.css({top: "", left: "", width: ""});
		            }
		        },
	
		        show: function() {
		            var that = this,
		                window = that.window,
		                editorOptions = that.options.editor,
		                wrapper, editorElement, editorOffset,
		                browser = kendo.support.browser;
	
		            if (window) {
		                wrapper = window.wrapper;
		                editorElement = editorOptions.element;
	
		                if (!wrapper.is(":visible") || !that.window.options.visible) {
	
		                    if (!wrapper[0].style.width) {
		                        wrapper.width(this._getWindowWidth());
		                    }
	
		                    // track content position when other parts of page change
		                    if (!window._moved) {
		                        editorOffset = editorElement.offset();
		                        wrapper.css({
		                            top: Math.max(0, parseInt(editorOffset.top, 10) - outerHeight(wrapper) - parseInt(that.window.element.css("padding-bottom"), 10)),
		                            left: Math.max(0, parseInt(editorOffset.left, 10))
		                        });
		                    }
	
		                    if ((browser.msie || browser.edge) && that._overlaps(editorElement)) {
		                        setTimeout(function() {
		                            window.open();
		                        }, 0);
		                    } else {
		                        window.open();
		                    }
		                }
		            }
		        },
	
		        _getWindowWidth: function(){
		            var that = this,
		                wrapper = that.window.wrapper,
		                editorElement = that.options.editor.element;
	
		            return outerWidth(editorElement) - parseInt(wrapper.css("border-left-width"), 10) - parseInt(wrapper.css("border-right-width"), 10);
		        },
	
		        _overlaps: function(box) {
		            var toolbarWrapper = this.window.wrapper,
		                toolbarWrapperOffset = toolbarWrapper.offset(),
		                toolbarWrapperLeft = toolbarWrapperOffset.left,
		                toolbarWrapperTop = toolbarWrapperOffset.top,
		                boxOffset = box.offset(),
		                boxOffsetLeft = boxOffset.left,
		                boxOffsetTop = boxOffset.top;
	
		            return !(boxOffsetLeft + box.width() < toolbarWrapperLeft ||
		                    boxOffsetLeft > toolbarWrapperLeft + toolbarWrapper.width() ||
		                    boxOffsetTop + box.height() < toolbarWrapperTop ||
		                    boxOffsetTop > toolbarWrapperTop + toolbarWrapper.height());
		        },
	
		        hide: function() {
		            if (this.window) {
		                this.window.close();
		            }
		        },
	
		        focus: function() {
		            var TABINDEX = "tabIndex";
		            var element = this.element;
		            var tabIndex = this._editor.element.attr(TABINDEX);
	
		            // Chrome can't focus something which has already been focused
		            element.attr(TABINDEX, tabIndex || 0).focus()
		                .find(focusable).first().focus();
	
		            if (!tabIndex && tabIndex !== 0) {
		                element.removeAttr(TABINDEX);
		            }
		        },
	
		        focusOverflowPopup: function() {
		            var TABINDEX = "tabIndex";
		            var element = this.overflowPopup.element;
		            var tabIndex = this._editor.element.attr(TABINDEX);
	
		            element.closest(".k-animation-container").addClass("k-overflow-wrapper");
	
		            element.attr(TABINDEX, tabIndex || 0)
		                .find(focusable).first().focus();
	
		            if (!tabIndex && tabIndex !== 0) {
		                element.removeAttr(TABINDEX);
		            }
		        },
	
		        _appendShortcutSequence: function(localizedText, tool) {
		            if (!tool.key) {
		                return localizedText;
		            }
	
		            var res = localizedText + " (";
	
		            if (tool.ctrl) {
		                res += "Ctrl + ";
		            }
	
		            if (tool.shift) {
		                res += "Shift + ";
		            }
	
		            if (tool.alt) {
		                res += "Alt + ";
		            }
	
		            res += tool.key + ")";
	
		            return res;
		        },
	
		        _nativeTools: [
		            "insertLineBreak",
		            "insertParagraph",
		            "redo",
		            "undo",
		            "autoLink"
		        ],
	
		        tools: {}, // tools collection is copied from defaultTools during initialization
	
		        isCustomTool: function(toolName) {
		            return !(toolName in kendo.ui.Editor.defaultTools);
		        },
	
		        // expand the tools parameter to contain tool options objects
		        expandTools: function(tools) {
		            var currentTool,
		                i,
		                nativeTools = this._nativeTools,
		                options,
		                defaultTools = kendo.deepExtend({}, kendo.ui.Editor.defaultTools),
		                result = {},
		                name;
	
		            for (i = 0; i < tools.length; i++) {
		                currentTool = tools[i];
		                name = currentTool.name;
	
		                if ($.isPlainObject(currentTool)) {
		                    if (name && defaultTools[name]) {
		                        // configured tool
		                        result[name] = extend({}, defaultTools[name]);
		                        extend(result[name].options, currentTool);
		                    } else {
		                        // custom tool
		                        options = extend({ cssClass: "k-i-gear", type: "button", title: "" }, currentTool);
		                        if (!options.name) {
		                            options.name = "custom";
		                        }
	
		                        options.cssClass = "k-" + options.name;
	
		                        if (!options.template && options.type == "button") {
		                            options.template = editorNS.EditorUtils.buttonTemplate;
		                            options.title = options.title || options.tooltip;
		                        }
	
		                        result[name] = {
		                            options: options
		                        };
		                    }
		                } else if (defaultTools[currentTool]) {
		                    // tool by name
		                    result[currentTool] = defaultTools[currentTool];
		                }
		            }
	
		            for (i = 0; i < nativeTools.length; i++) {
		                if (!result[nativeTools[i]]) {
		                    result[nativeTools[i]] = defaultTools[nativeTools[i]];
		                }
		            }
	
		            return result;
		        },
	
		        render: function() {
		            var that = this,
		                tools = that.tools,
		                options, template, toolElement,
		                toolName,
		                editorElement = that._editor.element,
		                element = that.element.empty(),
		                groupName, newGroupName,
		                toolConfig = that._editor.options.tools,
		                browser = kendo.support.browser,
		                group, i, groupPosition = 0,
		                resizable = that.options.resizable && that.options.resizable.toolbar,
		                overflowFlaseTools = this.overflowFlaseTools;
	
		            function stringify(template) {
		                var result;
	
		                if (template.getHtml) {
		                    result = template.getHtml();
		                } else {
		                    if (!$.isFunction(template)) {
		                        template = kendo.template(template);
		                    }
	
		                    result = template(options);
		                }
	
		                return $.trim(result);
		            }
	
		            function endGroup() {
		                if (group.children().length) {
		                    if (resizable) {
		                        group.data("position", groupPosition);
		                        groupPosition++;
		                    }
	
		                    group.appendTo(element);
		                }
		            }
	
		            function startGroup(toolName) {
		                if (toolName !== OVERFLOWANCHOR) {
		                    group = $("<li class='k-tool-group' role='presentation' />");
		                    group.data("overflow", $.inArray(toolName, overflowFlaseTools) === -1 ? true : false);
		                } else {
		                    group = $("<li class='k-overflow-tools' />");
		                }
		            }
	
		            element.empty();
	
		            if (toolConfig.length) {
		                toolName = toolConfig[0].name || toolConfig[0];
		            }
		            startGroup(toolName, overflowFlaseTools);
	
		            for (i = 0; i < toolConfig.length; i++) {
		                toolName = toolConfig[i].name || toolConfig[i];
		                options = tools[toolName] && tools[toolName].options;
	
		                if (!options && $.isPlainObject(toolName)) {
		                    options = toolName;
		                }
	
		                template = options && options.template;
	
		                if (toolName == "break") {
		                    endGroup();
		                    $("<li class='k-row-break' />").appendTo(that.element);
		                    startGroup(toolName, overflowFlaseTools);
		                }
	
		                if (!template) {
		                    continue;
		                }
	
		                newGroupName = that.toolGroupFor(toolName);
	
		                if (groupName != newGroupName || toolName == OVERFLOWANCHOR) {
		                    endGroup();
		                    startGroup(toolName, overflowFlaseTools);
		                    groupName = newGroupName;
		                }
	
		                if (toolName == OVERFLOWANCHOR) {
		                    template.options.title = that.options.messages.overflowAnchor;
		                }
	
		                template = stringify(template);
	
		                toolElement = $(template).appendTo(group);
	
		                if (newGroupName == "custom") {
		                    endGroup();
		                    startGroup(toolName, overflowFlaseTools);
		                }
	
		                if (options.exec && toolElement.hasClass("k-tool")) {
		                    toolElement.click(proxy(options.exec, editorElement[0]));
		                }
		            }
	
		            endGroup();
	
		            $(that.element).children(":has(> .k-tool)").addClass("k-button-group");
	
		            if (that.options.popup && browser.msie && browser.version < 9) {
		                that.window.wrapper.find("*").attr("unselectable", "on");
		            }
	
		            that.updateGroups();
	
		            if (resizable) {
		                that._initOverflowPopup(that.element.find(".k-overflow-anchor"));
		            }
	
		            that.angular("compile", function(){
		                return { elements: that.element };
		            });
		        },
	
		        updateGroups: function() {
		            $(this.element).children().each(function() {
		                $(this).addClass("k-state-disabled");
	
		                $(this).children().filter(function(){
		                    return !$(this).hasClass("k-state-disabled");
		                })
		                    .removeClass("k-group-end")
		                    .first().addClass("k-group-start").end()
		                    .last().addClass("k-group-end").end()
		                    .parent().removeClass("k-state-disabled")
		                    .css("display", "");
		            });
		        },
	
		        decorateFrom: function(body) {
		            this.items().filter(".k-decorated")
		                .each(function() {
		                    var selectBox = $(this).data("kendoSelectBox");
	
		                    if (selectBox) {
		                        selectBox.decorate(body);
		                    }
		                });
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            var id, tools = this.tools;
	
		            for (id in tools) {
		                if (tools[id].destroy) {
		                    tools[id].destroy();
		                }
		            }
	
		            if (this.window) {
		                this.window.destroy();
		            }
	
		            if (this._resizeHandler) {
		                kendo.unbindResize(this._resizeHandler);
		            }
	
		            if (this.overflowPopup) {
		                this.overflowPopup.destroy();
		            }
		        },
	
		        _attachEvents: function() {
		            var that = this,
		                popupElement = that.overflowPopup ? that.overflowPopup.element : $([]);
	
		            that.attachToolsEvents(that.element.add(popupElement));
		        },
	
		        attachToolsEvents: function(element) {
		            var that = this,
		                buttons = "[role=button].k-tool",
		                enabledButtons = buttons + ":not(.k-state-disabled)",
		                disabledButtons = buttons + ".k-state-disabled",
		                dropdown = ".k-dropdown",
		                colorpicker = ".k-colorpicker",
		                editorTools = [buttons, dropdown, colorpicker].join(",");
	
		                element.off(NS)
		                .on("mouseenter" + NS, enabledButtons, function() { $(this).addClass("k-state-hover"); })
		                .on("mouseleave" + NS, enabledButtons, function() { $(this).removeClass("k-state-hover"); })
		                .on("mousedown" + NS, editorTools, function(e) {
		                    e.preventDefault();
		                })
		                .on("keydown" + NS, focusable, function(e) {
		                    var current = this;
		                    var resizable = that.options.resizable && that.options.resizable.toolbar;
		                    var direction = kendo.support.isRtl(that.element) ? -1 : 1;
		                    var focusableItems;
		                    var focusElement,
		                        currentContainer,
		                        keyCode = e.keyCode;
	
		                    function move(direction, container, constrain) {
		                        var tools = container.find(focusable);
		                        var index = tools.index(current) + direction;
	
		                        if (constrain) {
		                            index = Math.max(0, Math.min(tools.length - 1, index));
		                        }
	
		                        return tools[index];
		                    }
	
		                    if (keyCode == keys.RIGHT || keyCode == keys.LEFT) {
		                        if (!$(current).is(".k-dropdown")) {
		                            focusElement = move(keyCode == keys.RIGHT ? 1 * direction : -1 * direction, that.element, true);
		                        } else {
		                            focusElement = $(current);
		                        }
		                    } else if (resizable && (keyCode == keys.UP || keyCode == keys.DOWN)) {
		                        focusElement = move(keyCode == keys.DOWN ? 1 : -1, that.overflowPopup.element, true);
		                    } else if (keyCode == keys.HOME) {
		                        focusElement = that.element.find(focusable)[0];
		                        e.preventDefault();
		                    } else if (keyCode == keys.END) {
		                        focusableItems = that.element.find(focusable).filter(function () {
		                            return $(this).css('visibility') !== 'hidden';
		                        });
		                        focusElement = focusableItems[focusableItems.length - 1];
		                        e.preventDefault();
		                    } else if (keyCode == keys.ESC) {
		                        if (that.overflowPopup && that.overflowPopup.visible()) {
		                            that.overflowPopup.close();
		                        }
	
		                        focusElement = that._editor;
		                    } else if (keyCode == keys.TAB && !(e.ctrlKey || e.altKey)) {
		                        if (resizable) {
		                            currentContainer = $(current.parentElement).hasClass("k-overflow-tool-group") ? that.overflowPopup.element : that.element;
		                        } else {
		                            currentContainer = that.element;
		                        }
	
		                        // skip tabbing to disabled tools, and focus the editing area when running out of tools
		                        if (e.shiftKey) {
		                            focusElement = move(-1, currentContainer);
		                        } else {
		                            focusElement = move(1, currentContainer);
	
		                            if (!focusElement || $(focusElement).closest(".k-overflow-tools").css("visibility") === "hidden") {
		                                focusElement = that._editor;
		                            }
		                        }
		                    }
	
		                    if (focusElement) {
		                        e.preventDefault();
		                        focusElement.focus();
		                    }
	
		                    if ((keyCode === keys.ENTER || keyCode === keys.SPACEBAR) && $(current).is("a") && !$(current).attr("href")) {
		                        //anchors without href attribute do not respond to Enter key
		                        that._executeToolCommand(current, e);
		                    }
		                })
		                .on("click" + NS, enabledButtons, function(e) {
		                    that._executeToolCommand(this, e);
		                })
		                .on("click" + NS, disabledButtons, function(e) { e.preventDefault(); });
	
		        },
	
		        _executeToolCommand: function(toolElement, e) {
		            var that = this;
		            var button = $(toolElement);
		            e.preventDefault();
		            e.stopPropagation();
		            button.removeClass("k-state-hover");
		            if (!button.is("[data-popup]")) {
		                that._editor.exec(that._toolName(toolElement));
		            }
		        },
	
		        _toolName: function (element) {
		            if (!element) {
		                return;
		            }
	
		            var className = element.className;
	
		            if (/k-tool\b/i.test(className)) {
		                className = element.firstChild.className;
		            }
	
		            var tool = $.grep(className.split(" "), function (x) {
		                return !/^k-(widget|tool|tool-icon|icon|state-hover|header|combobox|dropdown|selectbox|colorpicker)$/i.test(x);
		            });
	
		            if (tool[0]) {
		                var toolname = tool[0];
		                if (toolNamesByCssClass[toolname]) {
		                    toolname = toolNamesByCssClass[toolname];
		                }
		                if (toolname.indexOf("k-i-") >=0) {
		                    return kendo.toCamelCase(toolname.substring(toolname.indexOf("k-i-") + 4));
		                }
		                else {
		                    return toolname.substring(toolname.lastIndexOf("-") + 1);
		                }
		            }
		            return "custom";
		        },
	
		        refreshTools: function() {
		            var that = this,
		                editor = that._editor,
		                range = editor.getRange(),
		                nodes = editorNS.RangeUtils.textNodes(range),
		                immutables = editor.options.immutables,
		                immutablesContext = that._immutablesContext(range);
	
		            nodes = editorNS.Dom.filterBy(nodes, editorNS.Dom.htmlIndentSpace, true);
	
		            if (!nodes.length) {
		                nodes = [range.startContainer];
		            }
	
		            that.items().each(function() {
		                var tool = that.tools[that._toolName(this)];
		                if (tool) {
		                    var ui = $(this);
		                    if (tool.update) {
		                        tool.update(ui, nodes);
		                    }
	
		                    if (immutables) {
		                        that._updateImmutablesState(tool, ui, immutablesContext);
		                    }
		                }
		            });
		            this.update();
		        },
	
		        _immutablesContext: function(range) {
		            if (this._editor.options.immutables) {
		                if (range.collapsed) {
		                    return editorNS.Immutables.immutablesContext(range);
		                } else {
		                    return editorNS.RangeUtils.editableTextNodes(range).length === 0;
		                }
		            }
		        },
	
		        _updateImmutablesState: function(tool, ui, immutablesContext) {
		            var name = tool.name;
		            var uiElement = ui;
	
		            var trackImmutables = tool.options.trackImmutables;
		            if (trackImmutables === undefined) {
		                trackImmutables = $.inArray(name, editorNS.Immutables.toolsToBeUpdated) > -1;
		            }
	
		            if (trackImmutables) {
		                var display = immutablesContext ? "none" : "";
		                if (!ui.is(".k-tool")) {
		                    var uiData = ui.data();
		                    for (var key in uiData) {
		                        if (key.match(/^kendo[A-Z][a-zA-Z]*/)) {
		                            var widget = uiData[key];
		                            uiElement = widget.wrapper;
		                            break;
		                        }
		                    }
		                }
		                uiElement.css("display", display);
		                var groupUi = uiElement.closest("li");
		                if (groupUi.children(":visible").length === 0) {
		                    groupUi.css("display", display);
		                }
		            }
		        },
	
		        update: function() {
		            this.updateGroups();
		        },
	
		        _resize: function(e) {
		            var containerWidth = e.width;
		            var resizable = this.options.resizable && this.options.resizable.toolbar;
		            var popup = this.overflowPopup;
		            var editorElement = this.options.editor.element;
		            var toolbarWindow = this.window;
	
		            this.refreshTools();
	
		            if (!resizable) {
		                return;
		            }
	
		            if(toolbarWindow) {
		                toolbarWindow.wrapper.width(this._getWindowWidth());
	
		                if(!toolbarWindow._moved) {
		                    toolbarWindow.wrapper.css({
		                        left: Math.max(0, parseInt(editorElement.offset().left, 10))
		                    });
		                }
		            }
	
		            if (popup.visible()) {
		                popup.close(true);
		            }
	
		            this._refreshWidths();
	
		            this._shrink(containerWidth);
		            this._stretch(containerWidth);
	
		            this._toggleOverflowStyles(this.element, false);
		            this._toggleOverflowStyles(this.overflowPopup.element, true);
	
		            this.element
		                .children("li.k-overflow-tools")
		                .css("visibility", popup.element.is(":empty") ? "hidden" : "visible");
		        },
	
		        _refreshWidths: function() {
		            this.element.children("li").each(function(idx, element) {
		                var group = $(element);
		                group.data("outerWidth", outerWidth(group, true));
		            });
		        },
	
		        _shrink: function(width) {
		            var group, visibleGroups;
	
		            if (width < this._groupsWidth()) {
		                visibleGroups = this._visibleGroups().filter(":not(.k-overflow-tools)");
	
		                for (var i = visibleGroups.length - 1; i >= 0; i--) {
		                    group = visibleGroups.eq(i);
		                    if (width > this._groupsWidth()) {
		                        break;
		                    } else {
		                        this._hideGroup(group);
		                    }
		                }
		            }
		        },
	
		        _stretch: function(width) {
		            var group, hiddenGroups;
	
		            if (width > this._groupsWidth()) {
		                hiddenGroups = this._hiddenGroups();
	
		                for (var i = 0; i < hiddenGroups.length ; i++) {
		                    group = hiddenGroups.eq(i);
		                    if (width < this._groupsWidth() || !this._showGroup(group, width)) {
		                        break;
		                    }
		                }
		            }
		        },
	
		        _hiddenGroups: function() {
		            var popup = this.overflowPopup;
	
		            var hiddenGroups = this.element.children("li.k-tool-group").filter(":hidden");
	
		            hiddenGroups = hiddenGroups.add(popup.element.children("li"));
	
		            hiddenGroups.sort(function(a, b) {
		                return ($(a).data("position") > $(b).data("position")) ? 1 : -1;
		            });
	
		            return hiddenGroups;
		        },
	
		        _visibleGroups: function() {
		            return this.element.children("li.k-tool-group, li.k-overflow-tools").filter(":visible");
		        },
	
		        _groupsWidth: function() {
		            var width = 0;
	
		            this._visibleGroups().each(function() {
		                width += $(this).data("outerWidth");
		            });
	
		            return Math.ceil(width);
		        },
	
		        _hideGroup: function(group) {
		            if (group.data("overflow")) {
		                var popup = this.overflowPopup;
		                group.detach().prependTo(popup.element).addClass("k-overflow-tool-group");
		            } else {
		                group.hide();
		            }
		        },
	
		        _showGroup: function(group, width) {
		            var position, previous;
	
		            if (group.length && width > this._groupsWidth() + group.data("outerWidth")) {
		                if (group.hasClass("k-overflow-tool-group")) {
		                    position = group.data("position");
	
		                    if (position === 0) {
		                        group.detach().prependTo(this.element);
		                    } else {
		                        previous = this.element.children().filter(function(idx, element) {
		                            return $(element).data("position") === position - 1;
		                        });
	
		                        group.detach().insertAfter(previous);
		                    }
	
		                    group.removeClass("k-overflow-tool-group");
	
		                } else {
		                    group.show();
		                }
	
		                return true;
		            }
	
		            return false;
		        }
	
		    });
	
		$.extend(editorNS, {
		    Toolbar: Toolbar
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(971);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 971:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    extend = $.extend,
		    Editor = kendo.ui.editor,
		    EditorUtils = Editor.EditorUtils,
		    Command = Editor.Command,
		    Tool = Editor.Tool,
		    ToolTemplate = Editor.ToolTemplate,
		    dom = Editor.Dom;
	
		var ViewHtmlCommand = Command.extend({
		    init: function(options) {
		        var cmd = this;
		        cmd.options = options;
		        Command.fn.init.call(cmd, options);
		        cmd.attributes = null;
		        cmd.async = true;
		    },
	
		    exec: function() {
		        var that = this,
		            editor = that.editor,
		            options = editor.options,
		            messages = editor.options.messages,
		            dialog = $(kendo.template(ViewHtmlCommand.template)(messages)).appendTo(document.body),
		            textarea = ".k-editor-textarea",
		            content, comments;
	
		        options.serialization.immutables = editor.immutables;
	
		        comments = dom.getAllComments(editor.body);
	
		        content = EditorUtils.cacheComments(editor.value(), comments);
		        content = ViewHtmlCommand.indent(content);
		        content = EditorUtils.retrieveComments(content, comments);
	
		        options.serialization.immutables = undefined;
	
		        function apply(e) {
		            options.deserialization.immutables = editor.immutables;
		            editor.value(dialog.find(textarea).val());
		            options.deserialization.immutables = undefined;
	
		            close(e);
	
		            if (that.change) {
		                that.change();
		            }
	
		            editor.trigger("change");
		        }
	
		        function close(e) {
		            e.preventDefault();
	
		            dialog.data("kendoWindow").destroy();
	
		            if (editor.immutables) {
		                editor.immutables.serializedImmutables = {};
		            }
	
		            editor.focus();
		        }
	
		        this.createDialog(dialog, {
		            title: messages.viewHtml,
		            close: close,
		            visible: false
		        })
		            .find(textarea).val(content).end()
		            .find(".k-dialog-update").click(apply).end()
		            .find(".k-dialog-close").click(close).end()
		            .data("kendoWindow").center().open();
	
		        dialog.find(textarea).focus();
		    }
		});
	
		extend(ViewHtmlCommand, {
		    template: "<div class='k-editor-dialog k-popup-edit-form k-viewhtml-dialog'>" +
		                "<div class='k-edit-form-container'></div>" +
		                    "<textarea class='k-editor-textarea k-input'></textarea>" +
		                    "<div class='k-edit-buttons k-state-default'>" +
		                        "<button class='k-dialog-update k-button k-primary'>#: dialogUpdate #</button>" +
		                        "<button class='k-dialog-close k-button'>#: dialogCancel #</button>" +
		                    "</div>" +
		                "</div>" +
		            "</div>",
		    indent: function(content) {
		        return content.replace(/<\/(p|li|ul|ol|h[1-6]|table|tr|td|th)>/ig, "</$1>\n")
		                      .replace(/<(ul|ol)([^>]*)><li/ig, "<$1$2>\n<li")
		                      .replace(/<br \/>/ig, "<br />\n")
		                      .replace(/\n$/, "");
		    }
		});
	
		kendo.ui.editor.ViewHtmlCommand = ViewHtmlCommand;
	
		Editor.EditorUtils.registerTool("viewHtml", new Tool({ command: ViewHtmlCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "View HTML"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(967);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 957:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(667);
	
	/***/ }),
	
	/***/ 967:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(957) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    Class = kendo.Class,
		    extend = $.extend,
		    proxy = $.proxy,
		    Editor = kendo.ui.editor,
		    dom = Editor.Dom,
		    RangeUtils = Editor.RangeUtils,
		    EditorUtils = Editor.EditorUtils,
		    Command = Editor.Command,
		    Tool = Editor.Tool,
		    ToolTemplate = Editor.ToolTemplate,
		    InlineFormatter = Editor.InlineFormatter,
		    InlineFormatFinder = Editor.InlineFormatFinder,
		    textNodes = RangeUtils.textNodes,
		    editableTextNodes = RangeUtils.editableTextNodes,
		    registerTool = Editor.EditorUtils.registerTool,
		    keys = kendo.keys;
	
		var HTTP_PROTOCOL = "http://";
		var protocolRegExp = /^\w*:\/\//;
		var endLinkCharsRegExp = /[\w\/\$\-_\*\?]/i;
	
		var LinkFormatFinder = Class.extend({
		    findSuitable: function (sourceNode) {
		        return dom.parentOfType(sourceNode, ["a"]);
		    }
		});
	
		var LinkFormatter = Class.extend({
		    init: function() {
		        this.finder = new LinkFormatFinder();
		    },
	
		    apply: function (range, attributes) {
		        var nodes = this.immutables ? editableTextNodes(range) : textNodes(range);
		        var markers, doc, formatter, a, parent;
	
		        if (attributes.innerText) {
		            doc = RangeUtils.documentFromRange(range);
		            markers = RangeUtils.getMarkers(range);
	
		            range.deleteContents();
		            a = dom.create(doc, "a", attributes);
		            range.insertNode(a);
	
		            parent = a.parentNode;
		            if (dom.name(parent) == "a") {
		                dom.insertAfter(a, parent);
		            }
	
		            if (dom.emptyNode(parent)) {
		                dom.remove(parent);
		            }
	
		            // move range and markers after inserted link
		            var ref = a;
		            for (var i = 0; i < markers.length; i++) {
		                dom.insertAfter(markers[i], ref);
		                ref = markers[i];
		            }
	
		            if (markers.length) {
		                dom.insertBefore(doc.createTextNode("\ufeff"), markers[1] || markers[0]);
		                dom.insertAfter(doc.createTextNode("\ufeff"), markers[1] || markers[0]);
		                range.setStartBefore(markers[0]);
		                range.setEndAfter(markers[markers.length-1]);
		            }
		        } else {
		            formatter = new InlineFormatter([{ tags: ["a"]}], attributes);
		            formatter.finder = this.finder;
		            formatter.apply(nodes);
		        }
		    }
		});
	
		var UnlinkCommand = Command.extend({
		    init: function(options) {
		        var that = this;
		        options.formatter = /** @ignore */ {
		            toggle : function(range) {
		                var nodes = that.immutables() ? editableTextNodes(range) : textNodes(range);
		                new InlineFormatter([{ tags: ["a"]}]).remove(nodes);
		            }
		        };
		        this.options = options;
		        Command.fn.init.call(this, options);
		    }
		});
	
		var LinkCommand = Command.extend({
		    init: function(options) {
		        var that;
		        this.options = options;
		        Command.fn.init.call(this, options);
		        this.formatter = new LinkFormatter();
	
		        if (!options.url) {
		            this.attributes = null;
		            this.async = true;
		        } else {
		            this.exec = function() {
		                this.formatter.immutables = that && that.immutables();
		                this.formatter.apply(options.range, {
		                    href: options.url,
		                    innerText: options.text || options.url,
		                    target: options.target
		                });
		            };
		        }
		    },
	
		    _dialogTemplate: function() {
		        return kendo.template(
		            '<div class="k-editor-dialog k-popup-edit-form">' +
		                '<div class="k-edit-form-container">' +
		                    "<div class='k-edit-label'>" +
		                        "<label for='k-editor-link-url'>#: messages.linkWebAddress #</label>" +
		                    "</div>" +
		                    "<div class='k-edit-field'>" +
		                        "<input type='text' class='k-input k-textbox' id='k-editor-link-url'>" +
		                    "</div>" +
		                    "<div class='k-edit-label k-editor-link-text-row'>" +
		                        "<label for='k-editor-link-text'>#: messages.linkText #</label>" +
		                    "</div>" +
		                    "<div class='k-edit-field k-editor-link-text-row'>" +
		                        "<input type='text' class='k-input k-textbox' id='k-editor-link-text'>" +
		                    "</div>" +
		                    "<div class='k-edit-label'>" +
		                        "<label for='k-editor-link-title'>#: messages.linkToolTip #</label>" +
		                    "</div>" +
		                    "<div class='k-edit-field'>" +
		                        "<input type='text' class='k-input k-textbox' id='k-editor-link-title'>" +
		                    "</div>" +
		                    "<div class='k-edit-label'></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<input type='checkbox' class='k-checkbox' id='k-editor-link-target'>" +
		                        "<label for='k-editor-link-target' class='k-checkbox-label'>#: messages.linkOpenInNewWindow #</label>" +
		                    "</div>" +
		                    "<div class='k-edit-buttons k-state-default'>" +
		                        '<button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button>' +
		                        '<button class="k-dialog-close k-button">#: messages.dialogCancel #</button>' +
		                    "</div>" +
		                "</div>" +
		            "</div>"
		        )({
		            messages: this.editor.options.messages
		        });
		    },
	
		    exec: function () {
		        var messages = this.editor.options.messages;
		        this._initialText = "";
		        this._range = this.lockRange(true);
		        this.formatter.immutables = this.immutables();
	
		        var nodes = textNodes(this._range);
		        var a = nodes.length ? this.formatter.finder.findSuitable(nodes[0]) : null;
		        var img = nodes.length && dom.name(nodes[0]) == "img";
	
		        var dialog = this.createDialog(this._dialogTemplate(), {
		            title: messages.createLink,
		            close: proxy(this._close, this),
		            visible: false
		        });
	
		        if (a) {
		            this._range.selectNodeContents(a);
		            nodes = textNodes(this._range);
		        }
	
		        this._initialText = this.linkText(nodes);
	
		        dialog
		            .find(".k-dialog-insert").click(proxy(this._apply, this)).end()
		            .find(".k-dialog-close").click(proxy(this._close, this)).end()
		            .find(".k-edit-field input").keydown(proxy(this._keydown, this)).end()
		            .find("#k-editor-link-url").val(this.linkUrl(a)).end()
		            .find("#k-editor-link-text").val(this._initialText).end()
		            .find("#k-editor-link-title").val(a ? a.title : "").end()
		            .find("#k-editor-link-target").attr("checked", a ? a.target == "_blank" : false).end()
		            .find(".k-editor-link-text-row").toggle(!img);
	
		        this._dialog = dialog.data("kendoWindow").center().open();
	
		        $("#k-editor-link-url", dialog).focus().select();
		    },
	
		    _keydown: function (e) {
		        var keys = kendo.keys;
	
		        if (e.keyCode == keys.ENTER) {
		            this._apply(e);
		        } else if (e.keyCode == keys.ESC) {
		            this._close(e);
		        }
		    },
	
		    _apply: function (e) {
		        var element = this._dialog.element;
		        var href = $("#k-editor-link-url", element).val();
		        var title, text, target;
		        var textInput = $("#k-editor-link-text", element);
	
		        if (href && href != HTTP_PROTOCOL) {
	
		            if (href.indexOf("@") > 0 && !/^(\w+:)|(\/\/)/i.test(href)) {
		                href = "mailto:" + href;
		            }
	
		            this.attributes = { href: href };
	
		            title = $("#k-editor-link-title", element).val();
		            if (title) {
		                this.attributes.title = title;
		            }
	
		            if (textInput.is(":visible")) {
		                text = textInput.val();
		                if (!text && !this._initialText) {
		                    this.attributes.innerText = href;
		                } else if (text && (text !== this._initialText)) {
		                    this.attributes.innerText = dom.stripBom(text);
		                }
		            }
	
		            target = $("#k-editor-link-target", element).is(":checked");
		            this.attributes.target = target ? "_blank" : null;
	
		            this.formatter.apply(this._range, this.attributes);
		        }
	
		        this._close(e);
	
		        if (this.change) {
		            this.change();
		        }
		    },
	
		    _close: function (e) {
		        e.preventDefault();
		        this._dialog.destroy();
	
		        dom.windowFromDocument(RangeUtils.documentFromRange(this._range)).focus();
	
		        this.releaseRange(this._range);
		    },
	
		    linkUrl: function(anchor) {
		        if (anchor) {
		            // IE < 8 returns absolute url if getAttribute is not used
		            return anchor.getAttribute("href", 2);
		        }
	
		        return HTTP_PROTOCOL;
		    },
	
		    linkText: function (nodes) {
		        var text = "";
		        var i;
	
		        for (i = 0; i < nodes.length; i++) {
		            text += nodes[i].nodeValue;
		        }
	
		        return dom.stripBom(text || "");
		    },
	
		    redo: function () {
		        var range = this.lockRange(true);
	
		        this.formatter.apply(range, this.attributes);
		        this.releaseRange(range);
		    }
	
		});
	
		var AutoLinkCommand = Command.extend({
		    init: function (options) {
		        Command.fn.init.call(this, options);
	
		        this.formatter = new LinkFormatter();
		    },
	
		    exec: function () {
		        var detectedLink = this.detectLink();
		        if (!detectedLink) {
		            return;
		        }
	
		        var range = this.getRange();
		        var linkMarker = new kendo.ui.editor.Marker();
		        var linkRange = range.cloneRange();
	
		        linkRange.setStart(detectedLink.start.node, detectedLink.start.offset);
		        linkRange.setEnd(detectedLink.end.node, detectedLink.end.offset);
	
		        range = this.lockRange();
		        linkMarker.add(linkRange);
	
		        this.formatter.apply(linkRange, {
		            href: this._ensureWebProtocol(detectedLink.text)
		        });
	
		        linkMarker.remove(linkRange);
		        this.releaseRange(range);
		    },
	
		    detectLink: function () {
		        var range = this.getRange();
		        var startNode = range.startContainer;
		        var startOffset = range.startOffset;
		        var prev = startNode.previousSibling;
		        if (!prev && ((dom.isBom(startNode) && !startNode.nextSibling) || (!startOffset && dom.isDataNode(startNode)))) {
		            startNode = startNode.parentNode;
		            startOffset = 0;
		        }
		        var traverser = new LeftDomTextTraverser({
		            node: startNode,
		            offset: startOffset,
		            cancelAtNode: function(node) { return node && dom.name(node) === "a"; }
		        });
	
		        var detection = new DomTextLinkDetection(traverser);
		        return detection.detectLink();
		    },
	
		    changesContent: function() {
		        return !!this.detectLink();
		    },
	
		    _ensureWebProtocol: function (linkText) {
		        var hasProtocol = this._hasProtocolPrefix(linkText);
		        return hasProtocol ? linkText : this._prefixWithWebProtocol(linkText);
		    },
	
		    _hasProtocolPrefix: function(linkText) {
		        return protocolRegExp.test(linkText);
		    },
	
		    _prefixWithWebProtocol: function(linkText) {
		        return HTTP_PROTOCOL + linkText;
		    }
		});
	
		var UnlinkTool = Tool.extend({
		    init: function(options) {
		        this.options = options;
		        this.finder = new InlineFormatFinder([{tags:["a"]}]);
	
		        Tool.fn.init.call(this, $.extend(options, {command:UnlinkCommand}));
		    },
	
		    initialize: function(ui, options) {
		        Tool.fn.initialize.call(this, ui, options);
		        ui.addClass("k-state-disabled");
		    },
	
		    update: function (ui, nodes) {
		        ui.toggleClass("k-state-disabled", !this.finder.isFormatted(nodes))
		          .removeClass("k-state-hover");
		    }
		});
	
		var DomTextLinkDetection = Class.extend({
		    init: function (traverser) {
		        this.traverser = traverser;
		        this.start = DomPos();
		        this.end = DomPos();
		        this.text = "";
		    },
	
		    detectLink: function () {
		        var node = this.traverser.node;
		        var offset = this.traverser.offset;
		        if (dom.isDataNode(node)) {
		            var text = node.data.substring(0, offset);
		            if (/\s{2}$/.test(dom.stripBom(text))) {
		                return;
		            }
		        } else if (offset === 0) {//heuristic for new line
		            var p = dom.closestEditableOfType(node, dom.blockElements);
		            if (p && p.previousSibling) {
		                this.traverser.init({
		                    node: p.previousSibling
		                });
		            }
		        }
	
		        this.traverser.traverse($.proxy(this._detectEnd, this));
		        if (!this.end.blank()) {
		            this.traverser = this.traverser.clone(this.end);
		            this.traverser.traverse($.proxy(this._detectStart, this));
	
		            if (!this._isLinkDetected()) {
		                var puntuationOptions = this.traverser.extendOptions(this.start);
		                var puntuationTraverser = new RightDomTextTraverser(puntuationOptions);
		                puntuationTraverser.traverse($.proxy(this._skipStartPuntuation, this));
		                if (!this._isLinkDetected()) {
		                    this.start = DomPos();
		                }
		            }
		        }
	
		        if (this.start.blank()) {
		            return null;
		        } else {
		            return {
		                start: this.start,
		                end: this.end,
		                text: this.text
		            };
		        }
		    },
	
		    _isLinkDetected: function() {
		        return protocolRegExp.test(this.text) || /^w{3}\./i.test(this.text);
		    },
	
		    _detectEnd: function(text, node) {
		        var i = lastIndexOfRegExp(text, endLinkCharsRegExp);
		        if (i > -1) {
		            this.end.node = node;
		            this.end.offset = i + 1;
	
		            return false;
		        }
		    },
	
		    _detectStart: function(text, node) {
		        var i = lastIndexOfRegExp(text, /\s/);
		        var ii = i + 1;
		        this.text = text.substring(ii) + this.text;
	
		        this.start.node = node;
		        this.start.offset = ii;
	
		        if (i > -1) {
		            return false;
		        }
		    },
	
		    _skipStartPuntuation: function(text, node, offset) {
		        var i = indexOfRegExp(text, /\w/);
		        var ii = i;
		        if (i === -1) {
		            ii = text.length;
		        }
	
		        this.text = this.text.substring(ii);
		        this.start.node = node;
		        this.start.offset = ii + (offset |0);
	
		        if (i > -1) {
		            return false;
		        }
		    }
		});
	
		function lastIndexOfRegExp(str, search) {
		    var i = str.length;
		    while (i-- && !search.test(str[i])) {}
	
		    return i;
		}
		function indexOfRegExp(str, search) {
		    var r = search.exec(str);
	
		    return r ? r.index : -1;
		}
	
		var DomPos = function() {
		    return {
		        node: null,
		        offset: null,
		        blank: function() {
		            return this.node === null && this.offset === null;
		        }
		    };
		};
	
		var DomTextTraverser = Class.extend({
		    init: function (options) {
		        this.node = options.node;
		        this.offset = options.offset === undefined ? (dom.isDataNode(this.node) && this.node.length) || 0 : options.offset;
		        this.cancelAtNode = options.cancelAtNode || this.cancelAtNode || $.noop;
		    },
	
		    traverse: function (callback) {
		        if (!callback) {
		            return;
		        }
		        this.cancel = false;
		        this._traverse(callback, this.node, this.offset);
		    },
	
		    _traverse: function (callback, node, offset) {
		        if (!node || this.cancel) {
		            return;
		        }
		        if (node.nodeType === 3) {
		            var text = node.data;
		            if (offset !== undefined) {
		                text = this.subText(text, offset);
		            }
		            this.cancel = (callback(text, node, offset) === false);
		        }
		        else {
		            var edgeNode = this.edgeNode(node);
		            this.cancel = this.cancel || this.cancelAtNode(edgeNode);
		            return this._traverse(callback, edgeNode);
		        }
	
		        var next = this.next(node);
		        if (!next) {
		            var parent = node.parentNode;
		            while (!next && dom.isInline(parent)) {
		                next = this.next(parent);
		                parent = parent.parentNode;
		            }
		        }
		        this.cancel = this.cancel || this.cancelAtNode(next);
		        this._traverse(callback, next);
		    },
	
		    extendOptions: function(o) {
		        return $.extend({
		            node: this.node,
		            offset: this.offset,
		            cancelAtNode: this.cancelAtNode
		        }, o || {});
		    },
	
		    edgeNode: function(node) {}, //jshint ignore: line
		    next: function(node) {}, //jshint ignore: line
		    subText: function(text, offset) {} //jshint ignore: line
	
		});
	
		var LeftDomTextTraverser = DomTextTraverser.extend({
		    subText: function(text, splitIndex) {
		        return text.substring(0, splitIndex);
		    },
	
		    next: function(node) {
		        return node.previousSibling;
		    },
	
		    edgeNode: function(node) {
		        return node.lastChild;
		    },
	
		    clone: function(options) {
		        var o = this.extendOptions(options);
		        return new LeftDomTextTraverser(o);
		    }
		});
	
		var RightDomTextTraverser = DomTextTraverser.extend({
		    subText: function(text, splitIndex) {
		        return text.substring(splitIndex);
		    },
	
		    next: function(node) {
		        return node.nextSibling;
		    },
	
		    edgeNode: function(node) {
		        return node.firstChild;
		    },
	
		    clone: function(options) {
		        var o = this.extendOptions(options);
		        return new RightDomTextTraverser(o);
		    }
		});
	
		extend(kendo.ui.editor, {
		    LinkFormatFinder: LinkFormatFinder,
		    LinkFormatter: LinkFormatter,
		    UnlinkCommand: UnlinkCommand,
		    LinkCommand: LinkCommand,
		    AutoLinkCommand: AutoLinkCommand,
		    UnlinkTool: UnlinkTool,
		    DomTextLinkDetection: DomTextLinkDetection,
		    LeftDomTextTraverser: LeftDomTextTraverser,
		    RightDomTextTraverser: RightDomTextTraverser
		});
	
		registerTool("createLink", new Tool({ key: "K", ctrl: true, command: LinkCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Create Link"})}));
		registerTool("unlink", new UnlinkTool({ key: "K", ctrl: true, shift: true, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Remove Link"})}));
		registerTool("autoLink", new Tool({ key: [keys.ENTER, keys.SPACEBAR], keyPressCommand: true, command: AutoLinkCommand }));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(963);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 955:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(668);
	
	/***/ }),
	
	/***/ 963:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(955) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		(function($) {
	
		var kendo = window.kendo,
		    Class = kendo.Class,
		    Editor = kendo.ui.editor,
		    formats = kendo.ui.Editor.fn.options.formats,
		    EditorUtils = Editor.EditorUtils,
		    Tool = Editor.Tool,
		    ToolTemplate = Editor.ToolTemplate,
		    FormatTool = Editor.FormatTool,
		    dom = Editor.Dom,
		    RangeUtils = Editor.RangeUtils,
		    extend = $.extend,
		    registerTool = Editor.EditorUtils.registerTool,
		    registerFormat = Editor.EditorUtils.registerFormat,
		    MOUSEDOWN_NS = "mousedown.kendoEditor",
		    KEYDOWN_NS = "keydown.kendoEditor",
		    KMARKER = "k-marker";
	
		var InlineFormatFinder = Class.extend({
		    init: function(format) {
		        this.format = format;
		    },
	
		    numberOfSiblings: function(referenceNode) {
		        var textNodesCount = 0,
		            elementNodesCount = 0,
		            markerCount = 0,
		            parentNode = referenceNode.parentNode,
		            node;
	
		        for (node = parentNode.firstChild; node; node = node.nextSibling) {
		            if (node != referenceNode) {
		                if (node.className == KMARKER) {
		                    markerCount++;
		                } else if (node.nodeType == 3) {
		                    textNodesCount++;
		                } else {
		                    elementNodesCount++;
		                }
		            }
		        }
	
		        if (markerCount > 1 && parentNode.firstChild.className == KMARKER && parentNode.lastChild.className == KMARKER) {
		            // full node selection
		            return 0;
		        } else {
		            return elementNodesCount + textNodesCount;
		        }
		    },
	
		    findSuitable: function (sourceNode, skip) {
		        if (!skip && this.numberOfSiblings(sourceNode) > 0) {
		            return null;
		        }
	
		        var node = sourceNode.parentNode;
		        var tags = this.format[0].tags;
	
		        while (!dom.ofType(node, tags)) {
		            if (this.numberOfSiblings(node) > 0) {
		                return null;
		            }
	
		            node = node.parentNode;
		        }
	
		        return node;
		    },
	
		    findFormat: function (sourceNode) {
		        var format = this.format,
		            attrEquals = dom.attrEquals,
		            i, len, node, tags, attributes;
	
		        for (i = 0, len = format.length; i < len; i++) {
		            node = sourceNode;
		            tags = format[i].tags;
		            attributes = format[i].attr;
	
		            if (node && dom.ofType(node, tags) && attrEquals(node, attributes)) {
		                return node;
		            }
	
		            while (node) {
		                node = dom.parentOfType(node, tags);
		                if (node && attrEquals(node, attributes)) {
		                    return node;
		                }
		            }
		        }
	
		        return null;
		    },
	
		    isFormatted: function (nodes) {
		        var i, len;
	
		        for (i = 0, len = nodes.length; i < len; i++) {
		            if (this.findFormat(nodes[i])) {
		                return true;
		            }
		        }
		        return false;
		    }
		});
	
		var InlineFormatter = Class.extend({
		    init: function(format, values) {
		        this.finder = new InlineFormatFinder(format);
		        this.attributes = extend({}, format[0].attr, values);
		        this.tag = format[0].tags[0];
		    },
	
		    wrap: function(node) {
		        return dom.wrap(node, dom.create(node.ownerDocument, this.tag, this.attributes));
		    },
	
		    activate: function(range, nodes) {
		        if (this.finder.isFormatted(nodes)) {
		            this.split(range);
		            this.remove(nodes);
		        } else {
		            this.apply(nodes);
		        }
		    },
	
		    toggle: function (range) {
		        var textNodes = this.immutables() ? RangeUtils.editableTextNodes : RangeUtils.textNodes;
		        var nodes = textNodes(range);
	
		        if (nodes.length > 0) {
		            this.activate(range, nodes);
		        }
		    },
	
		    immutables: function(){
		        return this.editor && this.editor.options.immutables;
		    },
	
		    apply: function (nodes) {
		        var formatNodes = [];
		        var i, l, node, formatNode;
	
		        if (nodes.length > 1) {
		            for (i = 0, l = nodes.length; i < l; i++) {
		                node = nodes[i];
		                formatNode = this.format(node, true);
		                formatNodes.push(formatNode);
	
		            }
		        } else {
		            node = nodes[0];
		            formatNode = this.format(node, false);
		        }
	
		        this.consolidate(formatNodes);
		    },
	
		    format: function (node, outerMostInline) {
		        var formatNode = this.finder.findSuitable(node);
		        var attributes = this.attributes;
		        var styleAttr = attributes ? attributes.style || {} : {};
	
		        if (formatNode) {
		            if (dom.is(formatNode, "font")) {
		                if (styleAttr.color) {
		                    formatNode.removeAttribute("color");
		                }
		                if (styleAttr.fontName) {
		                    formatNode.removeAttribute("face");
		                }
		                if (styleAttr.fontSize) {
		                    formatNode.removeAttribute("size");
		                }
		            }
		            dom.attr(formatNode, attributes);
		        } else {
		            while (!dom.isBlock(node.parentNode) && node.parentNode.childNodes.length == 1 && node.parentNode.contentEditable !== 'true' && outerMostInline) {
		                node = node.parentNode;
		            }
	
		            formatNode = this.wrap(node);
		        }
	
		        return formatNode;
		    },
	
		    remove: function (nodes) {
		        var i, l, formatNode;
	
		        for (i = 0, l = nodes.length; i < l; i++) {
		            formatNode = this.finder.findFormat(nodes[i]);
		            if (formatNode) {
		                if (this.attributes && this.attributes.style) {
		                    dom.unstyle(formatNode, this.attributes.style);
		                    if (!formatNode.style.cssText && !formatNode.attributes["class"]) {
		                        dom.unwrap(formatNode);
		                    }
		                } else {
		                    dom.unwrap(formatNode);
		                }
		            }
		        }
		    },
	
		    split: function (range) {
		        var nodes = RangeUtils.textNodes(range);
		        var l = nodes.length;
		        var i, formatNode;
	
		        if (l > 0) {
		            for (i = 0; i < l; i++) {
		                formatNode = this.finder.findFormat(nodes[i]);
		                if (formatNode) {
		                    RangeUtils.split(range, formatNode, true);
		                }
		            }
		        }
		    },
	
		    consolidate: function (nodes) {
		        var node, last;
	
		        while (nodes.length > 1) {
		            node = nodes.pop();
		            last = nodes[nodes.length - 1];
	
		            if (node.previousSibling && node.previousSibling.className == KMARKER) {
		                last.appendChild(node.previousSibling);
		            }
	
		            if (node.tagName == last.tagName &&
		                node.previousSibling == last &&
		                node.style.cssText == last.style.cssText &&
		                node.className === last.className) {
	
		                while (node.firstChild) {
		                    last.appendChild(node.firstChild);
		                }
	
		                dom.remove(node);
		            }
		        }
		    }
		});
	
		var GreedyInlineFormatFinder = InlineFormatFinder.extend({
		    init: function(format, greedyProperty) {
		        this.format = format;
		        this.greedyProperty = greedyProperty;
		        InlineFormatFinder.fn.init.call(this, format);
		    },
	
		    getInlineCssValue: function(node) {
		        var attributes = node.attributes;
		        var trim = $.trim;
		        var i, l, attribute, name, attributeValue, css, pair, cssIndex, len;
		        var propertyAndValue, property, value;
	
		        if (!attributes) {
		            return;
		        }
	
		        for (i = 0, l = attributes.length; i < l; i++) {
		            attribute = attributes[i];
		            name = attribute.nodeName;
		            attributeValue = attribute.nodeValue;
	
		            if (attribute.specified && name == "style") {
	
		                css = trim(attributeValue || node.style.cssText).split(";");
	
		                for (cssIndex = 0, len = css.length; cssIndex < len; cssIndex++) {
		                    pair = css[cssIndex];
		                    if (pair.length) {
		                        propertyAndValue = pair.split(":");
		                        property = trim(propertyAndValue[0].toLowerCase());
		                        value = trim(propertyAndValue[1]);
	
		                        if (property != this.greedyProperty) {
		                            continue;
		                        }
	
		                        return property.indexOf("color") >= 0 ? dom.toHex(value) : value;
		                    }
		                }
		            }
		        }
		    },
	
		    getFormatInner: function (node) {
		        var $node = $(dom.isDataNode(node) ? node.parentNode : node);
		        var parents = $node.parentsUntil("[contentEditable]").addBack().toArray().reverse();
		        var i, len, value;
	
		        for (i = 0, len = parents.length; i < len; i++) {
		            value = this.greedyProperty == "className" ? parents[i].className : this.getInlineCssValue(parents[i]);
		            if (value) {
		                return value;
		            }
		        }
	
		        return "inherit";
		    },
	
		    getFormat: function (nodes) {
		        var result = this.getFormatInner(nodes[0]), i, len;
	
		        for (i = 1, len = nodes.length; i < len; i++) {
		            if (result != this.getFormatInner(nodes[i])) {
		                return "";
		            }
		        }
	
		        return result;
		    },
	
		    isFormatted: function (nodes) {
		        return this.getFormat(nodes) !== "";
		    }
		});
	
		var GreedyInlineFormatter = InlineFormatter.extend({
		    init: function(format, values, greedyProperty) {
		        InlineFormatter.fn.init.call(this, format, values);
	
		        this.values = values;
		        this.finder = new GreedyInlineFormatFinder(format, greedyProperty);
	
		        if (greedyProperty) {
		            this.greedyProperty = kendo.toCamelCase(greedyProperty);
		        }
	
		    },
	
		    activate: function(range, nodes) {
		        var greedyProperty = this.greedyProperty;
		        var action = "apply";
	
		        this.split(range);
	
		        if (greedyProperty && this.values.style[greedyProperty] == "inherit") {
		            action = "remove";
		        }
	
		        this[action](nodes);
		    }
		});
	
		var InlineFormatTool = FormatTool.extend({
		    init: function(options) {
		        FormatTool.fn.init.call(this, extend(options, {
		            finder: new InlineFormatFinder(options.format),
		            formatter: function () { return new InlineFormatter(options.format); }
		        }));
		    }
		});
	
		var DelayedExecutionTool = Tool.extend({
		    update: function(ui, nodes) {
		        var list = ui.data(this.type);
	
		        list.close();
		        list.value(this.finder.getFormat(nodes));
		    }
		});
	
		var FontTool = DelayedExecutionTool.extend({
		    init: function(options) {
		        Tool.fn.init.call(this, options);
	
		        // IE has single selection hence we are using select box instead of combobox
		        this.type = (kendo.support.browser.msie || kendo.support.touch) ? "kendoDropDownList" : "kendoComboBox";
		        this.format = [{ tags: ["span", "font"] }];
		        this.finder = new GreedyInlineFormatFinder(this.format, options.cssAttr);
		    },
	
		    command: function (commandArguments) {
		        var options = this.options,
		            format = this.format,
		            style = {};
	
		        return new Editor.FormatCommand(extend(commandArguments, {
		            formatter: function () {
		                style[options.domAttr] = commandArguments.value;
	
		                return new GreedyInlineFormatter(format, { style: style }, options.cssAttr);
		            }
		        }));
		    },
	
		    initialize: function (ui, initOptions) {
		        var editor = initOptions.editor,
		            options = this.options,
		            toolName = options.name,
		            dataSource,
		            range,
		            defaultValue = [];
	
		        if (options.defaultValue) {
		           defaultValue = [{
		                text: editor.options.messages[options.defaultValue[0].text],
		                value: options.defaultValue[0].value
		           }];
		        }
	
		        dataSource = defaultValue.concat(options.items ? options.items : (editor.options[toolName] || [] ));
	
		        ui.attr({ title: initOptions.title});
		        ui[this.type]({
		            dataTextField: "text",
		            dataValueField: "value",
		            dataSource: dataSource,
		            change: function () {
		                editor._range = range;
		                Tool.exec(editor, toolName, this.value());
		            },
		            close: function () {
		                setTimeout(function(){
		                    editor._deleteSavedRange();
		                },0);
		            },
		            highlightFirst: false
		        });
	
		        ui.closest(".k-widget").removeClass("k-" + toolName).find("*").addBack().attr("unselectable", "on");
	
		        var widget = ui.data(this.type);
		        widget.value("inherit");
	
		        widget.wrapper.on(MOUSEDOWN_NS, ".k-select,.k-input", function() {
		            var newRange = editor.getRange();
		            range = editor._containsRange(newRange) ? newRange : range;
		        })
		        .on(KEYDOWN_NS, function(e) {
		            if (e.keyCode === kendo.keys.ENTER) {
		                editor._deleteSavedRange();
		                e.preventDefault();
		            }
		        });
		    }
	
		});
	
		var ColorTool = Tool.extend({
		    init: function(options) {
		        Tool.fn.init.call(this, options);
	
		        this.format = [{ tags: ["span","font"]}];
		        this.finder = new GreedyInlineFormatFinder(this.format, options.cssAttr);
		    },
	
		    options: {
		        palette: "websafe"
		    },
	
		    update: function() {
		        this._widget.close();
		    },
	
		    command: function (commandArguments) {
		        var options = this.options,
		            format = this.format,
		            style = {};
	
		        return new Editor.FormatCommand(extend(commandArguments, {
		            formatter: function () {
		                style[options.domAttr] = commandArguments.value;
	
		                return new GreedyInlineFormatter(format, { style: style }, options.cssAttr);
		            }
		        }));
		    },
	
		    initialize: function(ui, initOptions) {
		        var that = this,
		            editor = initOptions.editor,
		            toolName = this.name,
		            options =  extend({}, ColorTool.fn.options, this.options),
		            palette = options.palette,
		            columns = options.columns;
	
		        ui = this._widget = new kendo.ui.ColorPicker(ui, {
		            toolIcon: "k-icon k-i-" + EditorUtils.getToolCssClass(options.name),
		            palette: palette,
		            columns: columns,
		            change: function() {
		                var color = ui.value();
	
		                if (kendo.support.browser.msie && that.storedRange && that._inputFocused) {
		                    editor.selectRange(that.storedRange);
		                }
	
		                if (color) {
		                    Tool.exec(editor, toolName, color);
		                }
	
		                delete that.storedRange;
		                delete that._inputFocused;
		                editor.focus();
		            },
		            open: function (e) {
		                var picker = e.sender;
		                that.storedRange = editor.getRange();
		                picker.value(null);
		                picker._popup.element.on(MOUSEDOWN_NS, function(e){
		                    if(!$(e.target).is("input.k-color-value")){
		                        e.preventDefault();
		                    }
		                });
	
		                if(!picker._popup.element.is("[unselectable='on']")) {
		                    picker._popup.element
		                        .attr({ unselectable: "on" })
		                        .find("*:not(input)").attr("unselectable", "on")
		                        .end().find("input").on("focus", function(){
		                            that._inputFocused = true;
		                        });
		                }
		            },
		            close: function(e) {
		                e.sender._popup.element.off(MOUSEDOWN_NS);
	
		                if (kendo.support.browser.msie && that.storedRange && that._inputFocused) {
		                    editor.selectRange(that.storedRange);
		                }
		            },
		            activate: function(e) {
		                e.preventDefault();
		                ui.trigger("change");
		            }
		        });
		        ui.wrapper
		            .attr({ title: initOptions.title, unselectable: "on" })
		            .find("*:not(input)").attr("unselectable", "on");
		    }
		});
	
		extend(Editor, {
		    InlineFormatFinder: InlineFormatFinder,
		    InlineFormatter: InlineFormatter,
		    DelayedExecutionTool: DelayedExecutionTool,
		    GreedyInlineFormatFinder: GreedyInlineFormatFinder,
		    GreedyInlineFormatter: GreedyInlineFormatter,
		    InlineFormatTool: InlineFormatTool,
		    FontTool: FontTool,
		    ColorTool: ColorTool
		});
	
		registerFormat("bold", [ { tags: ["strong", "b"] }, { tags: ["span"], attr: { style: { fontWeight: "bold"}} } ]);
		registerTool("bold", new InlineFormatTool({ key: "B", ctrl: true, format: formats.bold, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Bold"}) }));
	
		registerFormat("italic", [ { tags: ["em", "i"] }, { tags: ["span"], attr: { style: { fontStyle: "italic"}} } ]);
		registerTool("italic", new InlineFormatTool({ key: "I", ctrl: true, format: formats.italic, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Italic"})}));
	
		registerFormat("underline", [ { tags: ["span"], attr: { style: { textDecoration: "underline"}} }, { tags: ["u"] } ]);
		registerTool("underline", new InlineFormatTool({ key: "U", ctrl: true, format: formats.underline, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Underline"})}));
	
		registerFormat("strikethrough", [ { tags: ["del", "strike"] }, { tags: ["span"], attr: { style: { textDecoration: "line-through"}} } ]);
		registerTool("strikethrough", new InlineFormatTool({format: formats.strikethrough, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Strikethrough"})}));
	
		registerFormat("superscript", [ { tags: ["sup"] } ]);
		registerTool("superscript", new InlineFormatTool({format: formats.superscript, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Superscript"})}));
	
		registerFormat("subscript", [ { tags: ["sub"] } ]);
		registerTool("subscript", new InlineFormatTool({format: formats.subscript, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Subscript"})}));
	
		registerTool("foreColor", new ColorTool({cssAttr:"color", domAttr:"color", name:"foreColor", template: new ToolTemplate({template: EditorUtils.colorPickerTemplate, title: "Color"})}));
	
		registerTool("backColor", new ColorTool({cssAttr:"background-color", domAttr: "backgroundColor", name:"backColor", template: new ToolTemplate({template: EditorUtils.colorPickerTemplate, title: "Background Color"})}));
	
		registerTool("fontName", new FontTool({cssAttr:"font-family", domAttr: "fontFamily", name:"fontName", defaultValue: [{ text: "fontNameInherit",  value: "inherit" }], template: new ToolTemplate({template: EditorUtils.comboBoxTemplate, title: "Font Name"})}));
	
		registerTool("fontSize", new FontTool({cssAttr:"font-size", domAttr:"fontSize", name:"fontSize", defaultValue: [{ text: "fontSizeInherit",  value: "inherit" }], template: new ToolTemplate({template: EditorUtils.comboBoxTemplate, title: "Font Size"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(953);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 953:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		var kendo = window.kendo,
		    extend = $.extend,
		    Editor = kendo.ui.editor,
		    Tool = Editor.Tool,
		    Command = Editor.Command,
		    EditorUtils = Editor.EditorUtils;
	
		var FormatCommand = Command.extend({
		    init: function (options) {
		        options.formatter = options.formatter();
		        var finder = options.formatter.finder;
		        if (finder && EditorUtils.formatByName("immutable", finder.format)) {
		            finder._initOptions({immutables: options.immutables});
		        }
		        Command.fn.init.call(this, options);
		    }
		});
	
		var FormatTool = Tool.extend({
		    init: function (options) {
		        Tool.fn.init.call(this, options);
		    },
	
		    command: function (commandArguments) {
		        var that = this;
		        return new FormatCommand(extend(commandArguments, {
		                formatter: that.options.formatter
		            }));
		    },
	
		    update: function(ui, nodes) {
		        var isFormatted = this.options.finder.isFormatted(nodes);
	
		        ui.toggleClass("k-state-selected", isFormatted);
		        ui.attr("aria-pressed", isFormatted);
		    }
		});
	
		$.extend(Editor, {
		    FormatCommand: FormatCommand,
		    FormatTool: FormatTool
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(968);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 962:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(670);
	
	/***/ }),
	
	/***/ 968:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(962) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		// Imports ================================================================
		var kendo = window.kendo,
		    Class = kendo.Class,
		    extend = $.extend,
		    Editor = kendo.ui.editor,
		    dom = Editor.Dom,
		    RangeUtils = Editor.RangeUtils,
		    EditorUtils = Editor.EditorUtils,
		    Command = Editor.Command,
		    ToolTemplate = Editor.ToolTemplate,
		    FormatTool = Editor.FormatTool,
		    BlockFormatFinder = Editor.BlockFormatFinder,
		    textNodes = RangeUtils.textNodes,
		    registerTool = Editor.EditorUtils.registerTool;
	
		var ListFormatFinder = BlockFormatFinder.extend({
		    init: function(tag) {
		        this.tag = tag;
		        var tags = this.tags = [tag == 'ul' ? 'ol' : 'ul', tag];
	
		        BlockFormatFinder.fn.init.call(this, [{ tags: tags}]);
		    },
	
		    isFormatted: function (nodes) {
		        var formatNodes = [];
		        var formatNode, i;
	
		        for (i = 0; i < nodes.length; i++) {
		            formatNode = this.findFormat(nodes[i]);
	
		            if (formatNode && dom.name(formatNode) == this.tag) {
		                formatNodes.push(formatNode);
		            }
		        }
	
		        if (formatNodes.length < 1) {
		            return false;
		        }
	
		        if (formatNodes.length != nodes.length) {
		            return false;
		        }
	
		        // check if sequential lists are selected
		        for (i = 0; i < formatNodes.length; i++) {
		            if (formatNodes[i].parentNode != formatNode.parentNode) {
		                break;
		            }
	
		            if (formatNodes[i] != formatNode) {
		                return false;
		            }
		        }
	
		        return true;
		    },
	
		    findSuitable: function (nodes) {
		        var candidate = this.findFormat(nodes[0]);
	
		        if (candidate && dom.name(candidate) == this.tag) {
		            return candidate;
		        }
	
		        return null;
		    }
	
		});
	
		var ListFormatter = Class.extend({
		    init: function(tag, unwrapTag) {
		        var that = this;
		        that.finder = new ListFormatFinder(tag);
		        that.tag = tag;
		        that.unwrapTag = unwrapTag;
		    },
	
		    isList: function(node) {
		        return dom.list(node);
		    },
	
		    immutables: function () {
		        return this.editor && !!this.editor.options.immutables;
		    },
	
		    wrap: function(list, nodes) {
		        var li = dom.create(list.ownerDocument, "li"),
		            i, node,
		            isImmutable = this.immutables() ? Editor.Immutables.immutable : $.noop;
	
		        for (i = 0; i < nodes.length; i++) {
		            node = nodes[i];
	
		            if (dom.is(node, 'li')) {
		                list.appendChild(node);
		                continue;
		            }
	
		            if (this.isList(node)) {
		                while (node.firstChild) {
		                    list.appendChild(node.firstChild);
		                }
		                continue;
		            }
	
		            if (dom.is(node, "td")) {
		                while (node.firstChild) {
		                    li.appendChild(node.firstChild);
		                }
		                list.appendChild(li);
		                node.appendChild(list);
		                list = list.cloneNode(false);
		                li = li.cloneNode(false);
		                continue;
		            }
	
		            li.appendChild(node);
	
		            if (dom.isBlock(node)) {
		                list.appendChild(li);
		                if (!isImmutable(node)) {
		                    dom.unwrap(node);
		                }
		                li = li.cloneNode(false);
		            }
		        }
	
		        if (li.firstChild) {
		            list.appendChild(li);
		        }
		    },
	
		    containsAny: function(parent, nodes) {
		        for (var i = 0; i < nodes.length; i++) {
		            if (dom.isAncestorOrSelf(parent, nodes[i])) {
		                return true;
		            }
		        }
	
		        return false;
		    },
	
		    suitable: function (candidate, nodes) {
		        if (candidate.className == "k-marker") {
		            var sibling = candidate.nextSibling;
	
		            if (sibling && dom.isBlock(sibling)) {
		                return false;
		            }
	
		            sibling = candidate.previousSibling;
	
		            if (sibling && dom.isBlock(sibling)) {
		                return false;
		            }
		        }
	
		        return this.containsAny(candidate, nodes) || dom.isInline(candidate) || candidate.nodeType == 3;
		    },
	
		    _parentLists: function(node) {
		        var editable = dom.closestEditable(node);
	
		        return $(node).parentsUntil(editable, "ul,ol");
		    },
	
		    split: function (range) {
		        var nodes = textNodes(range);
		        var start, end, parents;
	
		        if (nodes.length) {
		            start = dom.parentOfType(nodes[0], ['li']);
		            end = dom.parentOfType(nodes[nodes.length - 1], ['li']);
		            range.setStartBefore(start);
		            range.setEndAfter(end);
	
		            for (var i = 0, l = nodes.length; i < l; i++) {
		                var formatNode = this.finder.findFormat(nodes[i]);
		                if (formatNode) {
		                    parents = this._parentLists(formatNode);
		                    if (parents.length) {
		                        RangeUtils.split(range, parents.last()[0], true);
		                    } else {
		                        RangeUtils.split(range, formatNode, true);
		                    }
		                }
		            }
		        }
		    },
	
		    merge: function(tag, formatNode) {
		        var prev = formatNode.previousSibling, next;
	
		        while (prev && (prev.className == "k-marker" || (prev.nodeType == 3 && dom.isWhitespace(prev)))) {
		            prev = prev.previousSibling;
		        }
	
		        // merge with previous list
		        if (prev && dom.name(prev) == tag) {
		            while(formatNode.firstChild) {
		                prev.appendChild(formatNode.firstChild);
		            }
		            dom.remove(formatNode);
		            formatNode = prev;
		        }
	
		        next = formatNode.nextSibling;
		        while (next && (next.className == "k-marker" || (next.nodeType == 3 && dom.isWhitespace(next)))) {
		            next = next.nextSibling;
		        }
	
		        // merge with next list
		        if (next && dom.name(next) == tag) {
		            while(formatNode.lastChild) {
		                next.insertBefore(formatNode.lastChild, next.firstChild);
		            }
		            dom.remove(formatNode);
		        }
		    },
	
		    breakable: function(node) {
		        return (
		            node != node.ownerDocument.body &&
		            !/table|tbody|tr|td/.test(dom.name(node)) &&
		            !node.attributes.contentEditable
		        );
		    },
	
		    applyOnSection: function (section, nodes) {
		        var tag = this.tag;
		        var commonAncestor = dom.closestSplittableParent(nodes);
	
		        var ancestors = [];
	
		        var formatNode = this.finder.findSuitable(nodes);
	
		        if (!formatNode) {
		            formatNode = new ListFormatFinder(tag == "ul" ? "ol" : "ul").findSuitable(nodes);
		        }
	
		        var childNodes;
	
		        if (/table|tbody/.test(dom.name(commonAncestor))) {
		            childNodes = $.map(nodes, function(node) {
		                return dom.parentOfType(node, ["td"]);
		            });
		        } else {
		            childNodes = dom.significantChildNodes(commonAncestor);
	
		            if ($.grep(childNodes, dom.isBlock).length) {
		                childNodes = $.grep(childNodes, $.proxy(function(node) {
		                    return this.containsAny(node, nodes);
		                }, this));
		            }
	
		            if (!childNodes.length) {
		                childNodes = nodes;
		            }
		        }
	
		        function pushAncestor() {
		            ancestors.push(this);
		        }
	
		        for (var i = 0; i < childNodes.length; i++) {
		            var child = childNodes[i];
		            var suitable = (!formatNode || !dom.isAncestorOrSelf(formatNode, child)) && this.suitable(child, nodes);
	
		            if (!suitable) {
		                continue;
		            }
	
		            if (formatNode && this.isList(child)) {
		                // merging lists
		                $.each(child.children, pushAncestor);
		                dom.remove(child);
		            } else {
		                ancestors.push(child);
		            }
		        }
	
		        if (ancestors.length == childNodes.length && this.breakable(commonAncestor)) {
		            ancestors = [commonAncestor];
		        }
	
		        if (!formatNode) {
		            formatNode = dom.create(commonAncestor.ownerDocument, tag);
		            dom.insertBefore(formatNode, ancestors[0]);
		        }
	
		        this.wrap(formatNode, ancestors);
	
		        while (dom.isBom(formatNode.nextSibling)) {
		            dom.remove(formatNode.nextSibling);
		        }
	
		        if (!dom.is(formatNode, tag)) {
		            dom.changeTag(formatNode, tag);
		        }
	
		        this.merge(tag, formatNode);
		    },
	
		    apply: function (nodes) {
		        var i = 0,
		            sections = [],
		            lastSection,
		            lastNodes,
		            section,
		            node,
		            l = nodes.length,
		            immutableParent = this.immutables() ? Editor.Immutables.immutableParent : $.noop;
	
		        function addLastSection() {
		            if (lastSection) {
		                sections.push({
		                    section: lastSection,
		                    nodes: lastNodes
		                });
		            }
		        }
	
		        // split nodes into sections that need to be different lists
		        for (i = 0; i < l; i++) {
		            node = immutableParent(nodes[i]) || nodes[i];
		            section = dom.closestEditable(node, ["td","body"]);
		            if (!lastSection || section != lastSection) {
		                addLastSection();
		                lastNodes = [node];
		                lastSection = section;
		            } else {
		                lastNodes.push(node);
		            }
		        }
	
		        addLastSection();
	
		        for (i = 0; i < sections.length; i++) {
		            this.applyOnSection(sections[i].section, sections[i].nodes);
		        }
		    },
	
		    unwrap: function(ul) {
		        var fragment = ul.ownerDocument.createDocumentFragment(),
		            unwrapTag = this.unwrapTag,
		            parents,
		            li,
		            p,
		            child;
	
		        for (li = ul.firstChild; li; li = li.nextSibling) {
		            p = dom.create(ul.ownerDocument, unwrapTag || 'p');
	
		            while(li.firstChild) {
		                child = li.firstChild;
	
		                if (dom.isBlock(child)) {
	
		                    if (p.firstChild) {
		                        fragment.appendChild(p);
		                        p = dom.create(ul.ownerDocument, unwrapTag || 'p');
		                    }
	
		                    fragment.appendChild(child);
		                } else {
		                    p.appendChild(child);
		                }
		            }
	
		            if (p.firstChild) {
		                fragment.appendChild(p);
		            }
		        }
	
		        parents = this._parentLists(ul);
	
		        if (parents[0]) {
		            dom.insertAfter(fragment, parents.last()[0]);
		            parents.last().remove();
		        } else {
		            dom.insertAfter(fragment, ul);
		        }
	
		        dom.remove(ul);
		    },
	
		    remove: function (nodes) {
		        var formatNode;
		        for (var i = 0, l = nodes.length; i < l; i++) {
		            formatNode = this.finder.findFormat(nodes[i]);
	
		            if (formatNode) {
		                this.unwrap(formatNode);
		            }
		        }
		    },
	
		    toggle: function (range) {
		        var that = this,
		            nodes = textNodes(range),
		            ancestor = range.commonAncestorContainer;
	
		        if (!nodes.length) {
		            range.selectNodeContents(ancestor);
		            nodes = textNodes(range);
		            if (!nodes.length) {
		                var text = ancestor.ownerDocument.createTextNode("");
		                range.startContainer.appendChild(text);
		                nodes = [text];
		                range.selectNode(text.parentNode);
		            }
		        }
		        nodes = dom.filterBy(nodes, dom.htmlIndentSpace, true);
		        if (that.finder.isFormatted(nodes)) {
		            that.split(range);
		            that.remove(nodes);
		        } else {
		            that.apply(nodes);
		        }
		    }
	
		});
	
		var ListCommand = Command.extend({
		    init: function(options) {
		        options.formatter = new ListFormatter(options.tag);
		        Command.fn.init.call(this, options);
		    }
		});
	
		var ListTool = FormatTool.extend({
		    init: function(options) {
		        this.options = options;
		        FormatTool.fn.init.call(this, extend(options, {
		            finder: new ListFormatFinder(options.tag)
		        }));
		    },
	
		    command: function (commandArguments) {
		        return new ListCommand(extend(commandArguments, { tag: this.options.tag }));
		    }
		});
	
		extend(Editor, {
		    ListFormatFinder: ListFormatFinder,
		    ListFormatter: ListFormatter,
		    ListCommand: ListCommand,
		    ListTool: ListTool
		});
	
		registerTool("insertUnorderedList", new ListTool({tag:'ul', template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert unordered list"})}));
		registerTool("insertOrderedList", new ListTool({tag:'ol', template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert ordered list"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(954);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 954:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(955) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		var kendo = window.kendo,
		    Class = kendo.Class,
		    extend = $.extend,
		    Editor = kendo.ui.editor,
		    formats = kendo.ui.Editor.fn.options.formats,
		    dom = Editor.Dom,
		    ToolTemplate = Editor.ToolTemplate,
		    FormatTool = Editor.FormatTool,
		    EditorUtils = Editor.EditorUtils,
		    registerTool = EditorUtils.registerTool,
		    registerFormat = EditorUtils.registerFormat,
		    RangeUtils = Editor.RangeUtils;
	
		var BlockFormatFinder = Class.extend({
		    init: function(format) {
		        this.format = format;
		    },
	
		    contains: function(node, children) {
		        var i, len, child;
	
		        for (i = 0, len = children.length; i < len; i++) {
		            child = children[i];
		            if (!child || !dom.isAncestorOrSelf(node, child)) {
		                return false;
		            }
		        }
	
		        return true;
		    },
	
		    findSuitable: function (nodes) {
		        var format = this.format,
		            suitable = [],
		            i, len, candidate;
	
		        for (i = 0, len = nodes.length; i < len; i++) {
		            for (var f = format.length - 1; f >= 0; f--) {
		                candidate = dom.ofType(nodes[i], format[f].tags) ? nodes[i] : dom.closestEditableOfType(nodes[i], format[f].tags);
		                if (candidate) {
		                    break;
		                }
		            }
	
		            if (!candidate || candidate.contentEditable === 'true') {
		                return [];
		            }
	
		            if ($.inArray(candidate, suitable) < 0) {
		                suitable.push(candidate);
		            }
		        }
	
		        this._resolveListsItems(suitable);
	
		        for (i = 0, len = suitable.length; i < len; i++) {
		            if (this.contains(suitable[i], suitable)) {
		                return [suitable[i]];
		            }
		        }
	
		        return suitable;
		    },
		    _resolveListsItems: function(nodes){
		        var i, node, wrapper;
		        for (i = 0; i < nodes.length; i++) {
		            node = nodes[i];
		            wrapper = dom.is(node, "li") ? node : dom.wrapper(node);
		            wrapper = wrapper && dom.list(wrapper) ? wrapper.children[0] : wrapper;
		            if (dom.is(wrapper, "li")) {
		                node = nodes[i] = wrapper;
		            }
		        }
		    },
	
		    findFormat: function (sourceNode) {
		        var format = this.format,
		            i, len, node, tags, attributes;
		        var editableParent = dom.editableParent(sourceNode);
		        var immutables = this.options && this.options.immutables;
		        var ImmutablesNS = Editor.Immutables;
	
		        for (i = 0, len = format.length; i < len; i++) {
		            node = sourceNode;
		            tags = format[i].tags;
		            attributes = format[i].attr;
	
		            if (immutables && tags && tags[0] == "immutable") {
		                var immutable = ImmutablesNS.immutableParent(node);
		                if (immutable && dom.attrEquals(immutable, attributes)) {
		                    return node;
		                }
		            }
	
		            while (node && dom.isAncestorOf(editableParent, node)) {
		                if (dom.ofType(node, tags) && dom.attrEquals(node, attributes)) {
		                    return node;
		                }
	
		                node = node.parentNode;
		            }
		        }
		        return null;
		    },
	
		    getFormat: function (nodes) {
		        var that = this,
		            findFormat = function(node) {
		                    return that.findFormat(dom.isDataNode(node) ? node.parentNode : node);
		                },
		            result = findFormat(nodes[0]),
		            i, len;
	
		        if (!result) {
		            return "";
		        }
	
		        for (i = 1, len = nodes.length; i < len; i++) {
		            if (result != findFormat(nodes[i])) {
		                return "";
		            }
		        }
	
		        return result.nodeName.toLowerCase();
		    },
	
		    isFormatted: function (nodes) {
		        for (var i = 0, len = nodes.length; i < len; i++) {
		            if (!this.findFormat(nodes[i])) {
		                return false;
		            }
		        }
	
		        return true;
		    }
		});
	
		var BlockFormatter = Class.extend({
		    init: function (format, values) {
		        this.format = format;
		        this.values = values;
		        this.finder = new BlockFormatFinder(format);
		    },
	
		    wrap: function(tag, attributes, nodes) {
		        var commonAncestor = nodes.length == 1 ? dom.blockParentOrBody(nodes[0]) : dom.commonAncestor.apply(null, nodes);
	
		        if (dom.isInline(commonAncestor)) {
		            commonAncestor = dom.blockParentOrBody(commonAncestor);
		        }
	
		        var ancestors = dom.significantChildNodes(commonAncestor),
		            position = dom.findNodeIndex(ancestors[0]),
		            wrapper = dom.create(commonAncestor.ownerDocument, tag, attributes),
		            i, ancestor;
	
		        for (i = 0; i < ancestors.length; i++) {
		            ancestor = ancestors[i];
		            if (dom.isBlock(ancestor)) {
		                dom.attr(ancestor, attributes);
	
		                if (wrapper.childNodes.length) {
		                    dom.insertBefore(wrapper, ancestor);
		                    wrapper = wrapper.cloneNode(false);
		                }
	
		                position = dom.findNodeIndex(ancestor) + 1;
	
		                continue;
		            }
	
		            wrapper.appendChild(ancestor);
		        }
	
		        if (wrapper.firstChild) {
		            dom.insertAt(commonAncestor, wrapper, position);
		        }
		    },
	
		    apply: function (nodes) {
		        var format, values = this.values;
	
		        function attributes(format) {
		            return extend({}, format && format.attr, values);
		        }
	
		        this._handleImmutables(nodes, true);
	
		        var images = dom.filter("img", nodes);
		        var imageFormat = EditorUtils.formatByName("img", this.format);
		        var imageAttributes = attributes(imageFormat);
		        $.each(images, function() {
		            dom.attr(this, imageAttributes);
		        });
	
		        // only images were selected, no need to wrap
		        if (images.length == nodes.length) {
		            return;
		        }
	
		        var nonImages = dom.filter("img", nodes, true);
		        var formatNodes = this.finder.findSuitable(nonImages);
	
		        if (formatNodes.length) {
		            for (var i = 0, len = formatNodes.length; i < len; i++) {
		                format = EditorUtils.formatByName(dom.name(formatNodes[i]), this.format);
		                dom.attr(formatNodes[i], attributes(format));
		            }
		        } else {
		            format = this.format[0];
		            this.wrap(format.tags[0], attributes(format), nonImages);
		        }
		    },
	
		    _handleImmutables: function (nodes, applyFormatting) {
		        if (!this.immutables()) {
		            return;
		        }
		        var immutableFormat = EditorUtils.formatByName("immutable", this.format);
		        if (!immutableFormat) {
		            return;
		        }
		        var ImmutablesNS = Editor.Immutables;
		        var l = nodes.length - 1;
		        for (var i = l; i >= 0; i--) {
		            var immutableParent = ImmutablesNS.immutableParent(nodes[i]);
		            if (!immutableParent) {
		                continue;
		            }
		            if (immutableParent !== nodes[i + 1]) {
		                if (applyFormatting) {
		                    dom.attr(immutableParent, immutableFormat.attr);
		                } else {
		                    dom.unstyle(immutableParent, immutableFormat.attr.style);
		                }
		            }
		            nodes.splice(i, 1);
		        }
		    },
	
		    immutables: function() {
		        return this.editor && this.editor.options.immutables;
		    },
	
		    remove: function (nodes) {
		        var i, l, formatNode, namedFormat, name;
	
		        this._handleImmutables(nodes, false);
	
		        for (i = 0, l = nodes.length; i < l; i++) {
		            formatNode = this.finder.findFormat(nodes[i]);
		            if (formatNode) {
		                name = dom.name(formatNode);
		                if (name == "div" && !formatNode.getAttribute("class")) {
		                    dom.unwrap(formatNode);
		                } else {
		                    namedFormat = EditorUtils.formatByName(name, this.format);
		                    if (namedFormat.attr.style) {
		                        dom.unstyle(formatNode, namedFormat.attr.style);
		                    }
		                    if (namedFormat.attr.className) {
		                        dom.removeClass(formatNode, namedFormat.attr.className);
		                    }
		                }
		            }
		        }
		    },
	
		    toggle: function (range) {
		        var that = this,
		            nodes = dom.filterBy(RangeUtils.nodes(range), dom.htmlIndentSpace, true);
	
		        if (that.finder.isFormatted(nodes)) {
		            that.remove(nodes);
		        } else {
		            that.apply(nodes);
		        }
		    }
		});
	
		var GreedyBlockFormatter = Class.extend({
		    init: function (format, values) {
		        var that = this;
		        that.format = format;
		        that.values = values;
		        that.finder = new BlockFormatFinder(format);
		    },
	
		    apply: function (nodes) {
		        var format = this.format;
		        var blocks = dom.blockParents(nodes);
		        var formatTag = format[0].tags[0];
		        var i, len, list, formatter, range;
		        var element;
		        var tagName;
		        var block;
		        var immutalbeParent;
	
		        if (blocks.length) {
		            for (i = 0, len = blocks.length; i < len; i++) {
		                block = blocks[i];
		                immutalbeParent = this.immutables() && Editor.Immutables.immutableParent(block);
	
		                if (!immutalbeParent) {
		                    tagName = dom.name(block);
	
		                    if (tagName == "li") {
		                        list = block.parentNode;
		                        formatter = new Editor.ListFormatter(list.nodeName.toLowerCase(), formatTag);
		                        range = this.editor.createRange();
		                        range.selectNode(blocks[i]);
		                        formatter.toggle(range);
		                    } else if (formatTag && (tagName == "td" || block.attributes.contentEditable)) {
		                        new BlockFormatter(format, this.values).apply(block.childNodes);
		                    } else {
		                        element = dom.changeTag(block, formatTag);
		                        dom.attr(element, format[0].attr);
		                    }
		                }
		            }
		        } else {
		            var blockFormatter = new BlockFormatter(format, this.values);
		            blockFormatter.editor = this.editor;
		            blockFormatter.apply(nodes);
		        }
		    },
	
		    toggle: function (range) {
		        var nodes = RangeUtils.textNodes(range);
		        if (!nodes.length) {
		            range.selectNodeContents(range.commonAncestorContainer);
		            nodes = RangeUtils.textNodes(range);
		            if (!nodes.length) {
		                nodes = dom.significantChildNodes(range.commonAncestorContainer);
		            }
		        }
	
		        this.apply(nodes);
		    },
	
		    immutables: function() {
		        return this.editor && this.editor.options.immutables;
		    }
		});
	
		var BlockFormatTool = FormatTool.extend({ init: function (options) {
		        FormatTool.fn.init.call(this, extend(options, {
		            finder: new BlockFormatFinder(options.format),
		            formatter: function () {
		                return new BlockFormatter(options.format);
		            }
		        }));
		    }
		});
	
		extend(Editor, {
		    BlockFormatFinder: BlockFormatFinder,
		    BlockFormatter: BlockFormatter,
		    GreedyBlockFormatter: GreedyBlockFormatter,
		    BlockFormatTool: BlockFormatTool
		});
	
		var listElements = ["ul","ol","li"];
	
		registerFormat("justifyLeft", [
		    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "left" }} },
		    { tags: ["img"], attr: { style: { "float": "left", display: "", marginLeft: "", marginRight: "" }} },
		    { tags: ["immutable"], attr: { style: { "float": "left", display: "", marginLeft: "", marginRight: "" }} },
		    { tags: listElements, attr: { style: { textAlign: "left", listStylePosition: "" }} }
		]);
		registerTool("justifyLeft", new BlockFormatTool({
		    format: formats.justifyLeft,
		    template: new ToolTemplate({
		        template: EditorUtils.buttonTemplate,
		        title: "Justify Left"
		    })
		}));
	
		registerFormat("justifyCenter", [
		    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "center" }} },
		    { tags: ["img"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
		    { tags: ["immutable"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
		    { tags: listElements, attr: { style: { textAlign: "center", listStylePosition: "inside" }} }
		]);
		registerTool("justifyCenter", new BlockFormatTool({
		    format: formats.justifyCenter,
		    template: new ToolTemplate({
		        template: EditorUtils.buttonTemplate,
		        title: "Justify Center"
		    })
		}));
	
		registerFormat("justifyRight", [
		    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "right" }} },
		    { tags: ["img"], attr: { style: { "float": "right", display: "", marginLeft: "", marginRight: "" }} },
		    { tags: ["immutable"], attr: { style: { "float": "right", display: "", marginLeft: "", marginRight: "" }} },
		    { tags: listElements, attr: { style: { textAlign: "right", listStylePosition: "inside" }} }
		]);
		registerTool("justifyRight", new BlockFormatTool({
		    format: formats.justifyRight,
		    template: new ToolTemplate({
		        template: EditorUtils.buttonTemplate,
		        title: "Justify Right"
		    })
		}));
	
		registerFormat("justifyFull", [
		    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "justify" }} },
		    { tags: ["img"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
		    { tags: ["immutable"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
		    { tags: listElements, attr: { style: { textAlign: "justify", listStylePosition: "" }} }
		]);
		registerTool("justifyFull", new BlockFormatTool({
		    format: formats.justifyFull,
		    template: new ToolTemplate({
		        template: EditorUtils.buttonTemplate,
		        title: "Justify Full"
		    })
		}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 955:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(668);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(956);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 956:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(957) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		var kendo = window.kendo,
		    Editor = kendo.ui.editor,
		    Tool = Editor.Tool,
		    ToolTemplate = Editor.ToolTemplate,
		    DelayedExecutionTool = Editor.DelayedExecutionTool,
		    Command = Editor.Command,
		    dom = Editor.Dom,
		    EditorUtils = Editor.EditorUtils,
		    RangeUtils = Editor.RangeUtils,
		    registerTool = EditorUtils.registerTool;
	
	
		var FormattingTool = DelayedExecutionTool.extend({
		    init: function(options) {
		        var that = this;
		        Tool.fn.init.call(that, kendo.deepExtend({}, that.options, options));
	
		        that.type = "kendoSelectBox";
	
		        that.finder = {
		            getFormat: function() { return ""; }
		        };
		    },
	
		    options: {
		        items: [
		            { text: "Paragraph", value: "p" },
		            { text: "Quotation", value: "blockquote" },
		            { text: "Heading 1", value: "h1" },
		            { text: "Heading 2", value: "h2" },
		            { text: "Heading 3", value: "h3" },
		            { text: "Heading 4", value: "h4" },
		            { text: "Heading 5", value: "h5" },
		            { text: "Heading 6", value: "h6" }
		        ],
		        width: 110
		    },
	
		    toFormattingItem: function(item) {
		        var value = item.value;
	
		        if (!value) {
		            return item;
		        }
	
		        if (item.tag || item.className) {
		            return item;
		        }
	
		        var dot = value.indexOf(".");
	
		        if (dot === 0) {
		            item.className = value.substring(1);
		        } else if (dot == -1) {
		            item.tag = value;
		        } else {
		            item.tag = value.substring(0, dot);
		            item.className = value.substring(dot + 1);
		        }
	
		        return item;
		    },
	
		    command: function (args) {
		        var that = this;
		        var item = args.value;
	
		        item = this.toFormattingItem(item);
	
		        return new Editor.FormatCommand({
		            range: args.range,
		            formatter: function () {
		                var formatter,
		                    tags = (item.tag || item.context || "span").split(","),
		                    format = [{
		                        tags: tags,
		                        attr: { className: item.className || "" }
		                    }];
	
		                if ($.inArray(tags[0], dom.inlineElements) >= 0) {
		                    formatter = new Editor.GreedyInlineFormatter(format);
		                } else {
		                    formatter = new Editor.GreedyBlockFormatter(format);
		                }
	
		                formatter.editor = that.editor;
		                return formatter;
		            }
		        });
		    },
	
		    initialize: function(ui, initOptions) {
		        var editor = initOptions.editor;
		        var options = this.options;
		        var toolName = options.name;
		        var that = this;
	
		        that.editor = editor;
	
		        ui.width(options.width);
	
		        ui.kendoSelectBox({
		            dataTextField: "text",
		            dataValueField: "value",
		            dataSource: options.items || editor.options[toolName],
		            title: editor.options.messages[toolName],
		            autoSize: true,
		            change: function () {
		                var dataItem = this.dataItem();
	
		                if (dataItem) {
		                    Tool.exec(editor, toolName, dataItem.toJSON());
		                }
		            },
		            dataBound: function() {
		                var i, items = this.dataSource.data();
	
		                for (i = 0; i < items.length; i++) {
		                    items[i] = that.toFormattingItem(items[i]);
		                }
		            },
		            highlightFirst: false,
		            template: kendo.template(
		                '<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>'
		            )
		        });
	
		        ui.addClass("k-decorated")
		            .closest(".k-widget")
		                .removeClass("k-" + toolName)
		                .find("*").addBack()
		                    .attr("unselectable", "on");
		    },
	
		    getFormattingValue: function(items, nodes) {
		        for (var i = 0; i < items.length; i++) {
		            var item = items[i];
		            var tag = item.tag || item.context || "";
		            var className = item.className ? "."+item.className : "";
		            var selector = tag + className;
	
		            var element = $(nodes[0]).closest(selector)[0];
	
		            if (!element) {
		                continue;
		            }
	
		            if (nodes.length == 1) {
		                return item.value;
		            }
	
		            for (var n = 1; n < nodes.length; n++) {
		                if (!$(nodes[n]).closest(selector)[0]) {
		                    break;
		                } else if (n == nodes.length - 1) {
		                    return item.value;
		                }
		            }
		        }
	
		        return "";
		    },
	
		    update: function(ui, nodes) {
		        var selectBox = $(ui).data(this.type);
	
		        // necessary until formatBlock is deleted
		        if (!selectBox) {
		            return;
		        }
	
		        var dataSource = selectBox.dataSource,
		            items = dataSource.data(),
		            i, context,
		            ancestor = dom.commonAncestor.apply(null, nodes);
	
		        if (ancestor != dom.closestEditable(ancestor) && this._ancestor == ancestor) {
		            return;
		        } else {
		            this._ancestor = ancestor;
		        }
	
		        for (i = 0; i < items.length; i++) {
		            context = items[i].context;
	
		            items[i].visible = !context || !!$(ancestor).closest(context).length;
		        }
	
		        dataSource.filter([{ field: "visible", operator: "eq", value: true }]);
	
		        DelayedExecutionTool.fn.update.call(this, ui, nodes);
	
		        selectBox.value(this.getFormattingValue(dataSource.view(), nodes));
	
		        selectBox.wrapper.toggleClass("k-state-disabled", !dataSource.view().length);
		    },
	
		    destroy: function() {
		        this._ancestor = null;
		    }
		});
	
		var CleanFormatCommand = Command.extend({
		    exec: function() {
		        var range = this.lockRange(true);
		        this.tagsToClean = this.options.remove || "strong,em,span,sup,sub,del,b,i,u,font".split(",");
	
		        RangeUtils.wrapSelectedElements(range);
	
		        var nodes = RangeUtils.mapAll(range, function(node) {
		            return node;
		        });
	
	
		        for(var c = nodes.length - 1; c >= 0; c--) {
		            var node = nodes[c];
		            if (!this.immutableParent(node)) {
		                this.clean(node);
		            }
		        }
	
		        this.releaseRange(range);
		    },
	
		    clean: function(node) {
		        if (!node || dom.isMarker(node)) {
		            return;
		        }
	
		        var name = dom.name(node);
	
		        if (name == "ul" || name == "ol") {
		            var listFormatter = new Editor.ListFormatter(name);
		            var prev = node.previousSibling;
		            var next = node.nextSibling;
	
		            listFormatter.unwrap(node);
	
		            // clean contents
		            for (; prev && prev != next; prev = prev.nextSibling) {
		                this.clean(prev);
		            }
		        } else if (name == "blockquote") {
		            dom.changeTag(node, "p");
		        } else if (node.nodeType == 1 && !dom.insignificant(node)) {
		            for (var i = node.childNodes.length-1; i >= 0; i--) {
		                this.clean(node.childNodes[i]);
		            }
	
		            node.removeAttribute("style");
		            node.removeAttribute("class");
		        } else {
		            unwrapListItem(node);
		        }
	
		        if ($.inArray(name, this.tagsToClean) > -1) {
		            dom.unwrap(node);
		        }
		    },
	
		    immutableParent: function(node) {
		        return this.immutables() && Editor.Immutables.immutableParent(node);
		    }
		});
	
	
		function unwrapListItem(node) {
		    var li = dom.closestEditableOfType(node, ["li"]);
		    if (li) {
		        var listFormatter = new Editor.ListFormatter(dom.name(li.parentNode));
		        var range = kendo.ui.editor.W3CRange.fromNode(node);
		        range.selectNode(li);
		        listFormatter.toggle(range);
		    }
		}
	
		$.extend(Editor, {
		    FormattingTool: FormattingTool,
		    CleanFormatCommand: CleanFormatCommand
		});
	
		registerTool("formatting", new FormattingTool({ template: new ToolTemplate({ template: EditorUtils.dropDownListTemplate, title: "Format" }) }));
		registerTool("cleanFormatting", new Tool({ command: CleanFormatCommand, template: new ToolTemplate({ template: EditorUtils.buttonTemplate, title: "Clean formatting" }) }));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 957:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(667);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(960);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 960:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(948) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		(function($, undefined) {
	
		var kendo = window.kendo,
		    extend = $.extend,
		    proxy = $.proxy,
		    Editor = kendo.ui.editor,
		    EditorUtils = Editor.EditorUtils,
		    Command = Editor.Command,
		    Tool = Editor.Tool,
		    registerTool = EditorUtils.registerTool,
		    ToolTemplate = Editor.ToolTemplate,
		    loadingOverlay = '<div contenteditable="false" class="k-loading-mask" style="width: 100%; height: 100%; position: absolute; top: 0px; left: 0px;"><div class="k-loading-image"></div><div class="k-loading-color"></div></div>';
	
		var ImportCommand = Command.extend({
		    exec: function() {
		        (this.editor._uploadWidget || this._initializeUploadWidget()).element.click();
		    },
	
		    _initializeUploadWidget: function(){
		        var cmd = this;
		        var editor = cmd.editor;
		        var importOptions = editor.options["import"];
		        var upload = $('<input id="editorImport" name="files" type="file" />').kendoUpload({
		            success: proxy(cmd._onUploadSuccess, cmd),
		            progress: proxy(cmd._onUploadProgress, cmd),
		            select: proxy(cmd._onUploadSelect, cmd),
		            error: proxy(cmd._onUploadError, cmd),
		            complete: proxy(cmd._onUploadComplete, cmd),
		            showFileList: false,
		            multiple: false,
		            async: {
		                saveUrl:  importOptions.proxyUrl,
		                autoUpload: true,
		                saveField: "file"
		            },
		            validation: {
		                allowedExtensions: importOptions.allowedExtensions,
		                maxFileSize: importOptions.maxFileSize
		            }
		        }).getKendoUpload();
	
		        editor._uploadWidget = upload;
	
		        return upload;
		    },
		    _onUploadComplete: function(ev){
		        this._trigger("complete", ev);
		        ev.sender.clearAllFiles();
	
		        this._removeLoadingOverlay();
		    },
		    _onUploadSuccess: function(ev){
		        this.editor.value(ev.response.html.replace(/<\/?body>/ig, ""));
		        this._trigger("success", ev);
		    },
		    _onUploadProgress: function(ev){
		        this._trigger("progress", ev);
		    },
		    _onUploadSelect: function(ev){
		        this._trigger("select", ev);
		        if (!ev.files[0].validationErrors) {
		            this._initLoadingOverlay();
		        }
		    },
		    _onUploadError: function(ev){
		        this._trigger("error", ev);
		    },
	
		    _trigger: function(eventType, uploadEvent) {
		        var editor = this.editor;
		        var importOptions = editor.options["import"];
		        if (typeof importOptions[eventType] === "function") {
		            importOptions[eventType].call(editor, uploadEvent);
		        }
		    },
	
		    _initLoadingOverlay: function (){
		        var editable = this.editor.body;
		        if (Editor.Dom.is(editable, "body")) {
		            this._iframeWrapper = this._container =
		                this.editor.wrapper.find("iframe").parent()
		                .css({position: "relative"}).append(loadingOverlay);
		        } else {
		            this._container = $(editable).append(loadingOverlay);
		        }
	
		        kendo.ui.progress(this._container, true);
		    },
	
		    _removeLoadingOverlay: function(){
		        kendo.ui.progress(this._container, false);
		        $(this._iframeWrapper).css({
		            position: ""
		        });
	
		        delete this._container;
		        delete this._iframeWrapper;
		    }
		});
	
		extend(Editor, {
		    ImportCommand: ImportCommand
		});
	
		registerTool("import", new Tool({ command: ImportCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Import"})}));
	
		}(window.kendo.jQuery));
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(964);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 964:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        editorNS = kendo.ui.editor,
		        Command = editorNS.Command,
		        GenericCommand = editorNS.GenericCommand,
		        EditorUtils = editorNS.EditorUtils,
		        registerTool = EditorUtils.registerTool,
		        Tool = editorNS.Tool,
		        ToolTemplate = editorNS.ToolTemplate,
		        RestorePoint = editorNS.RestorePoint,
		        extend = $.extend;
	
		var InsertHtmlCommand = Command.extend({
		    init: function(options) {
		        Command.fn.init.call(this, options);
	
		        this.managesUndoRedo = true;
		    },
	
		    exec: function() {
		        var editor = this.editor;
		        var options = this.options;
		        var range = options.range;
		        var body = editor.body;
		        var startRestorePoint = new RestorePoint(range, body);
		        var html = options.html || options.value || '';
	
		        editor.selectRange(range);
	
		        editor.clipboard.paste(html, options);
	
		        if (options.postProcess) {
		            options.postProcess(editor, editor.getRange());
		        }
	
		        var genericCommand = new GenericCommand(startRestorePoint, new RestorePoint(editor.getRange(), body));
		        genericCommand.editor = editor;
		        editor.undoRedoStack.push(genericCommand);
	
		        editor.focus();
		    }
		});
	
		var InsertHtmlTool = Tool.extend({
		    initialize: function(ui, initOptions) {
		        var editor = initOptions.editor,
		            options = this.options,
		            dataSource = options.items ? options.items : editor.options.insertHtml;
	
		        this._selectBox = new editorNS.SelectBox(ui, {
		            dataSource: dataSource,
		            dataTextField: "text",
		            dataValueField: "value",
		            change: function () {
		                Tool.exec(editor, 'insertHtml', this.value());
		            },
		            title: editor.options.messages.insertHtml,
		            highlightFirst: false
		        });
		    },
	
		    command: function (commandArguments) {
		        return new InsertHtmlCommand(commandArguments);
		    },
	
		    update: function(ui) {
		        var selectbox = ui.data("kendoSelectBox") || ui.find("select").data("kendoSelectBox");
		        selectbox.close();
		        selectbox.value(selectbox.options.title);
		    }
		});
	
		extend(editorNS, {
		    InsertHtmlCommand: InsertHtmlCommand,
		    InsertHtmlTool: InsertHtmlTool
		});
	
		registerTool("insertHtml", new InsertHtmlTool({template: new ToolTemplate({template: EditorUtils.dropDownListTemplate, title: "Insert HTML", initialValue: "Insert HTML"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(947);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 947:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(948) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    extend = $.extend,
		    proxy = $.proxy,
		    Editor = kendo.ui.editor,
		    EditorUtils = Editor.EditorUtils,
		    Command = Editor.Command,
		    Tool = Editor.Tool,
		    registerTool = EditorUtils.registerTool,
		    ToolTemplate = Editor.ToolTemplate,
		    defaultExportAsItems = [
		        { text: 'Docx', value: 'docx' },
		        { text: 'Rtf', value: 'rtf' },
		        { text: 'Pdf', value: 'pdf' },
		        { text: 'Html', value: 'html' },
		        { text: 'Plain Text', value: 'txt' }
		    ];
	
		var ExportAsCommand = Command.extend({
		    init: function(options) {
		        var cmd = this;
		        cmd.options = options;
		        Command.fn.init.call(cmd, options);
		        cmd.attributes = null;
		        cmd.exportType = options.exportType;
		    },
	
		    exec: function() {
		        var cmd = this;
		        var range = this.lockRange(true);
		        cmd.postToProxy();
		        cmd.releaseRange(range);
		    },
	
		    postToProxy: function() {
		        this.generateForm().appendTo('body').submit().remove();
		    },
	
		    generateForm: function() {
		        var cmd = this;
		        var exportAsOptions = cmd.editor.options.exportAs;
		        var form = $('<form>').attr({
		            action: exportAsOptions && exportAsOptions.proxyURL || "",
		            method: 'POST'
		        });
	
		        form.append([
		            cmd.valueInput(),
		            cmd.exportTypeInput(),
		            cmd.fileNameInput()
		        ]);
	
		        return form;
		    },
	
		    valueInput: function() {
		        var editor = this.editor;
		        return $('<input>').attr({
		            value: editor.encodedValue(),
		            name: 'value',
		            type: 'hidden'
		        });
		    },
	
		    exportTypeInput: function() {
		        var cmd = this;
		        return $('<input>').attr({
		            value: cmd.exportType,
		            name: 'exportType',
		            type: 'hidden'
		        });
	
		    },
	
		    fileNameInput: function() {
		        var editor = this.editor;
		        var exportAsOptions = editor.options.exportAs;
		        var fileName = exportAsOptions && exportAsOptions.fileName || editor.element.attr("id") || "editor";
		        return $('<input>').attr({
		            value: fileName,
		            name: 'fileName',
		            type: 'hidden'
		        });
		    }
		});
	
		var ExportAsTool = Tool.extend({
		    init: function(options) {
		        var tool = this;
		        Tool.fn.init.call(tool, kendo.deepExtend({}, tool.options, options));
		        tool.type = 'kendoSelectBox';
		    },
	
		    options: {
		        items: defaultExportAsItems,
		        width: 115
		    },
	
		    command: function(args) {
		        var value = args.value;
		        return new Editor.ExportAsCommand({
		            range: args.range,
		            exportType: value.exportType
		        });
		    },
	
		    initialize: function(ui, initOptions) {
		        var tool = this;
		        var editor = initOptions.editor;
		        var options = tool.options;
		        var toolName = options.name;
		        var changeHandler = proxy(tool.changeHandler, tool);
		        var dataSource = options.items || editor.options[toolName];
	
		        dataSource.unshift({
		            text: editor.options.messages[toolName],
		            value: ""
		        });
		        tool.editor = editor;
		        ui.width(options.width);
		        ui.kendoSelectBox({
		            dataTextField: 'text',
		            dataValueField: 'value',
		            dataSource: dataSource,
		            autoSize: true,
		            change: changeHandler,
		            open: function(e) {
		                var sender = e.sender;
		                sender.items()[0].style.display = "none";
		                sender.unbind("open");
		            },
		            highlightFirst: false,
		            template: kendo.template('<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>')
		        });
		        ui.addClass('k-decorated').closest('.k-widget').removeClass('k-' + toolName).find('*').addBack().attr('unselectable', 'on');
		    },
	
		    changeHandler: function(e) {
		        var sender = e.sender;
		        var dataItem = sender.dataItem();
		        var value = dataItem && dataItem.value;
	
		        this._exec(value);
		        sender.value("");
		    },
	
		    _exec: function(value) {
		        if (value) {
		            Tool.exec(this.editor, this.options.name, { exportType: value } );
		        }
		    },
	
		    destroy: function() {
		        this._ancestor = null;
		    }
		});
	
		extend(Editor, {
		    ExportAsTool: ExportAsTool,
		    ExportAsCommand: ExportAsCommand
		});
	
		registerTool('exportAs', new ExportAsTool({
		    template: new ToolTemplate({
		        template: EditorUtils.dropDownListTemplate,
		        title: 'Export As'
		    })
		}));
	
		}(window.kendo.jQuery));
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(961);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 961:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(962) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		// Imports ================================================================
		var kendo = window.kendo,
		    Class = kendo.Class,
		    extend = $.extend,
		    Editor = kendo.ui.editor,
		    dom = Editor.Dom,
		    EditorUtils = Editor.EditorUtils,
		    registerTool = EditorUtils.registerTool,
		    Command = Editor.Command,
		    Tool = Editor.Tool,
		    ToolTemplate = Editor.ToolTemplate,
		    RangeUtils = Editor.RangeUtils,
		    blockElements = dom.blockElements,
		    BlockFormatFinder = Editor.BlockFormatFinder,
		    BlockFormatter = Editor.BlockFormatter;
	
		function indent(node, value) {
		    var isRtl = $(node).css("direction") == "rtl",
		        indentDirection = isRtl ? "Right" : "Left",
		        property = dom.name(node) != "td" ? "margin" + indentDirection : "padding" + indentDirection;
		    if (value === undefined) {
		        return node.style[property] || 0;
		    } else {
		        if (value > 0) {
		            node.style[property] = value + "px";
		        } else {
		            node.style[property] = "";
	
		            if (!node.style.cssText) {
		                node.removeAttribute("style");
		            }
		        }
		    }
		}
	
		var IndentFormatter = Class.extend({
		    init: function() {
		        this.finder = new BlockFormatFinder([{tags:dom.blockElements}]);
		    },
	
		    apply: function (nodes) {
		        nodes = dom.filterBy(nodes, dom.htmlIndentSpace, true);
		        var formatNodes = this.finder.findSuitable(nodes),
		            targets = [],
		            i, len, formatNode, parentList, sibling;
	
		        formatNodes = this.mapImmutables(formatNodes);
	
		        if (formatNodes.length) {
		            for (i = 0, len = formatNodes.length; i < len; i++) {
		                if (dom.is(formatNodes[i], "li")) {
		                    if (!$(formatNodes[i]).index()) {
		                        targets.push(formatNodes[i].parentNode);
		                    } else if ($.inArray(formatNodes[i].parentNode, targets) < 0) {
		                        targets.push(formatNodes[i]);
		                    }
		                } else {
		                    targets.push(formatNodes[i]);
		                }
		            }
	
		            while (targets.length) {
		                formatNode = targets.shift();
		                if (dom.is(formatNode, "li")) {
		                    parentList = formatNode.parentNode;
		                    sibling = $(formatNode).prev("li");
		                    var siblingList = sibling.find("ul,ol").last();
	
		                    var nestedList = $(formatNode).children("ul,ol")[0];
	
		                    if (nestedList && sibling[0]) {
		                        if (siblingList[0]) {
		                           siblingList.append(formatNode);
		                           siblingList.append($(nestedList).children());
		                           dom.remove(nestedList);
		                        } else {
		                            sibling.append(nestedList);
		                            nestedList.insertBefore(formatNode, nestedList.firstChild);
		                        }
		                    } else {
		                        nestedList = sibling.children("ul,ol")[0];
		                        if (!nestedList) {
		                            nestedList = dom.create(formatNode.ownerDocument, dom.name(parentList));
		                            sibling.append(nestedList);
		                        }
	
		                        while (formatNode && formatNode.parentNode == parentList) {
		                            nestedList.appendChild(formatNode);
		                            formatNode = targets.shift();
		                        }
		                    }
		                } else {
		                    var marginLeft = parseInt(indent(formatNode), 10) + 30;
		                    indent(formatNode, marginLeft);
	
		                    for (var targetIndex = 0; targetIndex < targets.length; targetIndex++) {
		                        if ($.contains(formatNode, targets[targetIndex])) {
		                            targets.splice(targetIndex, 1);
		                        }
		                    }
		                }
		            }
		        } else {
		            var formatter = new BlockFormatter([{tags:["p"]}], {style:{marginLeft:30}});
	
		            formatter.apply(nodes);
		        }
		    },
	
		    mapImmutables: function(nodes){
		        if (!this.immutables) {
		            return nodes;
		        } else {
		            var immutables = [];
		            return $.map(nodes, function (node) {
		                var immutable = Editor.Immutables.immutableParent(node);
		                if (immutable) {
		                    if ($.inArray(immutable, immutables) === -1) {
		                        immutables.push(immutable);
		                    } else {
		                        return null;
		                    }
		                }
		                return immutable || node;
		            });
		        }
		    },
	
		    remove: function(nodes) {
		        nodes = dom.filterBy(nodes, dom.htmlIndentSpace, true);
		        var formatNodes = this.finder.findSuitable(nodes),
		            targetNode, i, len, list, listParent, siblings,
		            formatNode, marginLeft;
	
		        formatNodes = this.mapImmutables(formatNodes);
	
		        for (i = 0, len = formatNodes.length; i < len; i++) {
		            formatNode = $(formatNodes[i]);
	
		            if (formatNode.is("li")) {
		                list = formatNode.parent();
		                listParent = list.parent();
		                // listParent will be ul or ol in case of invalid dom - <ul><li></li><ul><li></li></ul></ul>
		                if (listParent.is("li,ul,ol") && !indent(list[0])) {
		                    // skip already processed nodes
		                    if (targetNode && $.contains(targetNode, listParent[0])) {
		                        continue;
		                    }
	
		                    siblings = formatNode.nextAll("li");
		                    if (siblings.length) {
		                        $(list[0].cloneNode(false)).appendTo(formatNode).append(siblings);
		                    }
	
		                    if (listParent.is("li")) {
		                        formatNode.insertAfter(listParent);
		                    } else {
		                        formatNode.appendTo(listParent);
		                    }
	
		                    if (!list.children("li").length) {
		                        list.remove();
		                    }
	
		                    continue;
		                } else {
		                    if (targetNode == list[0]) {
		                        // removing format on sibling LI elements
		                        continue;
		                    }
		                    targetNode = list[0];
		                }
		            } else {
		                targetNode = formatNodes[i];
		            }
	
		            marginLeft = parseInt(indent(targetNode), 10) - 30;
		            indent(targetNode, marginLeft);
		        }
		    }
	
		});
	
		var IndentCommand = Command.extend({
		    init: function(options) {
		        var that = this;
		        options.formatter = /** @ignore */ {
		            toggle : $.proxy(function(range) {
		                var indentFormatter = new IndentFormatter();
		                indentFormatter.immutables = this.editor && this.editor.options.immutables;
		                indentFormatter.apply(RangeUtils.nodes(range));
		            }, that)
		        };
		        Command.fn.init.call(this, options);
		    }
		});
	
		var OutdentCommand = Command.extend({
		    init: function(options) {
		        var that = this;
		        options.formatter = {
		            toggle : $.proxy(function(range) {
		                var indentFormatter = new IndentFormatter();
		                indentFormatter.immutables = this.editor && this.editor.options.immutables;
		                indentFormatter.remove(RangeUtils.nodes(range));
		            }, that)
		        };
		        Command.fn.init.call(this, options);
		    }
		});
	
		var OutdentTool = Tool.extend({
		    init: function(options) {
		        Tool.fn.init.call(this, options);
	
		        this.finder = new BlockFormatFinder([{tags:blockElements}]);
		    },
	
		    initialize: function(ui, options) {
		        Tool.fn.initialize.call(this, ui, options);
	
		        $.extend(this.options, {
		            immutables: options.editor && options.editor.options.immutables
		        });
	
		        ui.addClass("k-state-disabled");
		    },
	
		    update: function (ui, nodes) {
		        var suitableNodes = this.finder.findSuitable(nodes),
		            isOutdentable, listParentsCount, i, len, suitable, immutableParent;
		        for (i = 0, len = suitableNodes.length; i < len; i++) {
		            suitable = suitableNodes[i];
	
		            if (this.options.immutables) {
		                immutableParent = Editor.Immutables.immutableParent(suitable);
		                if (immutableParent) {
		                    suitable = immutableParent;
		                }
		            }
	
		            isOutdentable = indent(suitable);
	
		            if (!isOutdentable) {
		                listParentsCount = $(suitable).parents("ul,ol").length;
		                isOutdentable = (dom.is(suitable, "li") && (listParentsCount > 1 || indent(suitable.parentNode))) ||
		                                (dom.ofType(suitable, ["ul","ol"]) && listParentsCount > 0);
		            }
	
		            if (isOutdentable) {
		                ui.removeClass("k-state-disabled");
		                return;
		            }
		        }
	
		        ui.addClass("k-state-disabled").removeClass("k-state-hover");
		    }
		});
	
		extend(Editor, {
		    IndentFormatter: IndentFormatter,
		    IndentCommand: IndentCommand,
		    OutdentCommand: OutdentCommand,
		    OutdentTool: OutdentTool
		});
	
		registerTool("indent", new Tool({ command: IndentCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Indent"}) }));
		registerTool("outdent", new OutdentTool({ command: OutdentCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Outdent"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 962:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(670);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(966);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 962:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(670);
	
	/***/ }),
	
	/***/ 966:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(962) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		// Imports ================================================================
		var kendo = window.kendo,
		    extend = $.extend,
		    editorNS = kendo.ui.editor,
		    dom = editorNS.Dom,
		    Command = editorNS.Command,
		    Tool = editorNS.Tool,
		    BlockFormatter = editorNS.BlockFormatter,
		    normalize = dom.normalize,
		    RangeUtils = editorNS.RangeUtils,
		    registerTool = editorNS.EditorUtils.registerTool;
	
		var ParagraphCommand = Command.extend({
		    init: function(options) {
		        this.options = options;
		        Command.fn.init.call(this, options);
		    },
	
		    _insertMarker: function(doc, range) {
		        var marker = dom.create(doc, 'a'), container;
		        marker.className = "k-marker";
	
		        range.insertNode(marker);
	
		        if (!marker.parentNode) {
		            // inserting paragraph in Firefox full body range
		            container = range.commonAncestorContainer;
		            container.innerHTML = "";
		            container.appendChild(marker);
		        }
	
		        normalize(marker.parentNode);
	
		        return marker;
		    },
	
		    _moveFocus: function(range, candidate) {
		        if (dom.isEmpty(candidate)) {
		            range.setStartBefore(candidate);
		        } else {
		            range.selectNodeContents(candidate);
	
		            var focusNode = RangeUtils.textNodes(range)[0];
	
		            if (!focusNode) {
		                while (candidate.childNodes.length && !dom.is(candidate.firstChild, "br")) {
		                    candidate = candidate.firstChild;
		                }
	
		                focusNode = candidate;
		            }
	
		            if (dom.isEmpty(focusNode)) {
		                range.setStartBefore(focusNode);
		            } else {
		                if (dom.emptyNode(focusNode)) {
		                    focusNode.innerHTML = "\ufeff";
		                }
		                var startNode = focusNode.firstChild || focusNode;
		                if (dom.isDataNode(startNode)) {
		                    range.setStart(startNode, 0);
		                } else {
		                    range.setStartBefore(startNode);
		                }
		            }
		        }
		    },
	
		    shouldTrim: function(range) {
		        var blocks = 'p,h1,h2,h3,h4,h5,h6'.split(','),
		            startInBlock = dom.parentOfType(range.startContainer, blocks),
		            endInBlock = dom.parentOfType(range.endContainer, blocks);
		        return (startInBlock && !endInBlock) || (!startInBlock && endInBlock);
		    },
	
		    _blankAfter: function (node) {
		        while (node && (dom.isMarker(node) || dom.stripBom(node.nodeValue) === "")) {
		            node = node.nextSibling;
		        }
	
		        return !node;
		    },
	
		    exec: function () {
		        var range = this.getRange(),
		            doc = RangeUtils.documentFromRange(range),
		            parent, previous, next,
		            emptyParagraphContent = editorNS.emptyElementContent,
		            paragraph, marker, li, heading, tableNode, rng,
		            shouldTrim;
	
		        this.expandImmutablesIn(range);
	
		        shouldTrim = this.shouldTrim(range);
	
		        range.deleteContents();
		        marker = this._insertMarker(doc, range);
	
		        dom.stripBomNode(marker.previousSibling);
		        dom.stripBomNode(marker.nextSibling);
	
		        li = dom.closestEditableOfType(marker, ['li']);
		        heading = dom.closestEditableOfType(marker, 'h1,h2,h3,h4,h5,h6'.split(','));
		        tableNode = dom.is(marker.parentNode, 'table') &&  marker.parentNode;
	
		        if (li) {
		            // hitting 'enter' in empty li
		            if (dom.emptyNode(li)) {
		                paragraph = dom.create(doc, 'p');
	
		                if (dom.next(li)) {
		                    rng = range.cloneRange();
		                    rng.selectNode(li);
	
		                    RangeUtils.split(rng, li.parentNode);
		                }
	
		                var br = $("br", li);
		                if (br.length == 1) {
		                    br.remove();
		                }
	
		                var parentNode = li.parentNode;
		                var parentChildrenLength = li.parentNode.children.length;
		                var firstChild = parentChildrenLength > 1 && li.childNodes.length == 1 && li.children[0];
	
		                dom.insertAfter(paragraph, parentNode);
		                dom.remove(parentChildrenLength == 1 ? li.parentNode : li);
	
		                if (firstChild && firstChild !== marker) {
		                    paragraph.appendChild(firstChild);
		                    paragraph.appendChild(marker);
		                } else {
		                    paragraph.innerHTML = emptyParagraphContent;
		                }
		                next = paragraph;
		            }
		        } else if (heading && this._blankAfter(marker)) {
		            paragraph = this._insertParagraphAfter(heading);
		            dom.remove(marker);
		            next = paragraph;
		        } else if (tableNode) {
		            paragraph = this._insertParagraphAfter(tableNode);
		            dom.remove(marker);
		            next = paragraph;
		        }
	
		        if (!next) {
		            if (!(li || heading)) {
		                new BlockFormatter([{ tags: ['p']}]).apply([marker]);
		            }
	
		            range.selectNode(marker);
	
		            parent = dom.parentOfType(marker, [li ? 'li' : heading ? dom.name(heading) : 'p']);
	
		            RangeUtils.split(range, parent, shouldTrim);
	
		            previous = parent.previousSibling;
	
		            if (dom.is(previous, 'li') && previous.firstChild && !dom.is(previous.firstChild, 'br')) {
		                previous = previous.firstChild;
		            }
	
		            next = parent.nextSibling;
	
		            this.clean(previous, { links: true });
		            this.clean(next, { links: true });
	
		            if (dom.is(next, 'li') && next.firstChild && !dom.is(next.firstChild, 'br')) {
		                next = next.firstChild;
		            }
	
		            dom.remove(parent);
	
		            // normalize updates the caret display in Gecko
		            normalize(previous);
		        }
	
		        normalize(next);
	
		        this._moveFocus(range, next);
	
		        range.collapse(true);
	
		        dom.scrollTo(next, true);
	
		        RangeUtils.selectRange(range);
		    },
	
		    _insertParagraphAfter: function (node) {
		        var range = this.getRange();
		        var doc = RangeUtils.documentFromRange(range);
		        var emptyElementContent = editorNS.emptyElementContent;
		        var paragraph = dom.create(doc, 'p');
	
		        dom.insertAfter(paragraph, node);
		        paragraph.innerHTML = emptyElementContent;
	
		        return paragraph;
		    },
	
		    clean: function(node, options) {
		        var root = node;
	
		        if (node.firstChild && dom.is(node.firstChild, 'br')) {
		            dom.remove(node.firstChild);
		        }
	
		        if (dom.isDataNode(node) && !node.nodeValue) {
		            node = node.parentNode;
		        }
	
		        if (node) {
		            var siblings = false;
		            while (node.firstChild && node.firstChild.nodeType == 1) {
		                siblings = siblings || (dom.significantNodes(node.childNodes).length > 1);
		                node = node.firstChild;
		            }
	
		            if (!dom.isEmpty(node) && /^\s*$/.test(node.innerHTML) && !siblings) {
		                $(root).find(".k-br").remove();
		                node.innerHTML = editorNS.emptyElementContent;
		            }
	
		            if (options && options.links) {
		                while (node != root) {
		                    if (dom.is(node, "a") && dom.emptyNode(node)) {
		                        dom.unwrap(node);
		                        break;
		                    }
		                    node = node.parentNode;
		                }
		            }
		        }
		    }
		});
	
		var NewLineCommand = Command.extend({
		    init: function(options) {
		        this.options = options;
		        Command.fn.init.call(this, options);
		    },
	
		    exec: function () {
		        var range = this.getRange();
		        this.expandImmutablesIn(range);
	
		        var br = dom.create(RangeUtils.documentFromRange(range), 'br');
		        var node = range.startContainer;
		        var filler;
		        var browser = kendo.support.browser;
		        var oldIE = browser.msie && browser.version < 11;
	
		        var tableNode = dom.is(node, 'table') && node;
	
		        range.deleteContents();
		        if (tableNode) {
		            dom.insertAfter(br, tableNode);
		        } else {
		            range.insertNode(br);
		        }
	
		        normalize(br.parentNode);
	
		        if (!oldIE && (!br.nextSibling || dom.isWhitespace(br.nextSibling))) {
		            // Gecko and WebKit cannot put the caret after only one br.
		            filler = br.cloneNode(true);
		            filler.className = 'k-br';
		            dom.insertAfter(filler, br);
		        }
	
		        range.setStartAfter(br);
		        range.collapse(true);
	
		        dom.scrollTo(br.nextSibling || br, true);
	
		        RangeUtils.selectRange(range);
		    }
		});
	
		extend(editorNS, {
		    ParagraphCommand: ParagraphCommand,
		    NewLineCommand: NewLineCommand
		});
	
		registerTool("insertLineBreak", new Tool({ key: 13, shift: true, command: NewLineCommand }));
		registerTool("insertParagraph", new Tool({ key: 13, command: ParagraphCommand }));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(950);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 950:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(951), __webpack_require__(952) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    extend = $.extend,
		    Editor = kendo.ui.editor,
		    EditorUtils = Editor.EditorUtils,
		    dom = Editor.Dom,
		    registerTool = EditorUtils.registerTool,
		    ToolTemplate = Editor.ToolTemplate,
		    RangeUtils = Editor.RangeUtils,
		    Command = Editor.Command,
		    LinkFormatter = Editor.LinkFormatter,
		    textNodes = RangeUtils.textNodes,
		    keys = kendo.keys,
		    KEDITORFILEURL = "#k-editor-file-url",
		    KEDITORFILETEXT = "#k-editor-file-text",
		    KEDITORFILETITLE = "#k-editor-file-title";
	
		var FileCommand = Command.extend({
		    init: function(options) {
		        var that = this;
		        Command.fn.init.call(that, options);
	
		        that.formatter = new LinkFormatter();
	
		        that.async = true;
		        that.attributes = {};
		    },
	
		    insertFile: function(file, range) {
		        var attributes = this.attributes;
		        var doc = RangeUtils.documentFromRange(range);
	
		        if (attributes.href && attributes.href != "http://") {
	
		            if (!file) {
		                file = dom.create(doc, "a", {href: attributes.href});
		                file.innerHTML = attributes.innerHTML;
		                file.title = attributes.title;
	
		                range.deleteContents();
		                range.insertNode(file);
	
		                if (!file.nextSibling) {
		                    dom.insertAfter(doc.createTextNode("\ufeff"), file);
		                }
	
		                range.setStartAfter(file);
		                range.setEndAfter(file);
		                RangeUtils.selectRange(range);
		                return true;
		            } else {
		                dom.attr(file, attributes);
		            }
		        }
	
		        return false;
		    },
	
		    _dialogTemplate: function(showBrowser) {
		        return kendo.template(
		            '<div class="k-editor-dialog k-popup-edit-form">' +
		                '<div class="k-edit-form-container">' +
		                    '<div class="k-edit-form-content">' +
		                        '# if (showBrowser) { #' +
		                            '<div class="k-filebrowser"></div>' +
		                        '# } #' +
		                        "<div class='k-edit-label'>" +
		                            '<label for="k-editor-file-url">#: messages.fileWebAddress #</label>' +
		                        "</div>" +
		                        "<div class='k-edit-field'>" +
		                            '<input type="text" class="k-input k-textbox" id="k-editor-file-url">' +
		                        "</div>" +
		                        "<div class='k-edit-label'>" +
		                            '<label for="k-editor-file-text">#: messages.fileText #</label>' +
		                        "</div>" +
		                        "<div class='k-edit-field'>" +
		                            '<input type="text" class="k-input k-textbox" id="k-editor-file-text">' +
		                        "</div>" +
		                        "<div class='k-edit-label'>" +
		                            '<label for="k-editor-file-title">#: messages.fileTitle #</label>' +
		                        "</div>" +
		                        "<div class='k-edit-field'>" +
		                            '<input type="text" class="k-input k-textbox" id="k-editor-file-title">' +
		                        "</div>" +
		                    '</div>' +
		                    '<div class="k-edit-buttons k-state-default">' +
		                        '<button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button>' +
		                        '<button class="k-dialog-close k-button">#: messages.dialogCancel #</button>' +
		                    '</div>' +
		                '</div>' +
		            '</div>'
		        )({
		            messages: this.editor.options.messages,
		            showBrowser: showBrowser
		        });
		    },
	
		    redo: function () {
		        var that = this,
		            range = that.lockRange();
	
		        this.formatter.apply(range, this.attributes);
		        that.releaseRange(range);
		    },
	
		    exec: function () {
		        var that = this,
		            range = that.lockRange(),
		            nodes = textNodes(range),
		            applied = false,
		            file = nodes.length ? this.formatter.finder.findSuitable(nodes[0]) : null,
		            dialog,
		            isIE = kendo.support.browser.msie,
		            options = that.editor.options,
		            messages = options.messages,
		            fileBrowser = options.fileBrowser,
		            showBrowser = !!(kendo.ui.FileBrowser && fileBrowser && fileBrowser.transport && fileBrowser.transport.read !== undefined),
		            dialogOptions = {
		                title: messages.insertFile,
		                visible: false,
		                resizable: showBrowser
		            };
	
		        this.expandImmutablesIn(range);
	
		        function apply(e) {
		            var element = dialog.element,
		                href = element.find(KEDITORFILEURL).val().replace(/ /g, "%20"),
		                innerHTML = element.find(KEDITORFILETEXT).val(),
		                title = element.find(KEDITORFILETITLE).val();
	
		            that.attributes = {
		                href: href,
		                innerHTML: innerHTML !== "" ? innerHTML : href,
		                title: title
		            };
	
		            applied = that.insertFile(file, range);
	
		            close(e);
	
		            if (that.change) {
		                that.change();
		            }
		        }
	
		        function close(e) {
		            e.preventDefault();
		            dialog.destroy();
	
		            dom.windowFromDocument(RangeUtils.documentFromRange(range)).focus();
		            if (!applied) {
		                that.releaseRange(range);
		            }
		        }
	
		        function keyDown(e) {
		            if (e.keyCode == keys.ENTER) {
		                apply(e);
		            } else if (e.keyCode == keys.ESC) {
		                close(e);
		            }
		        }
	
		        dialogOptions.close = close;
	
		        if (showBrowser) {
		            dialogOptions.width = 750;
		        }
	
		        dialog = this.createDialog(that._dialogTemplate(showBrowser), dialogOptions)
		            .toggleClass("k-filebrowser-dialog", showBrowser)
		            .find(".k-dialog-insert").click(apply).end()
		            .find(".k-dialog-close").click(close).end()
		            .find(".k-edit-field input").keydown(keyDown).end()
		            // IE < 8 returns absolute url if getAttribute is not used
		            .find(KEDITORFILEURL).val(file ? file.getAttribute("href", 2) : "http://").end()
		            .find(KEDITORFILETEXT).val(file ? file.innerText : "").end()
		            .find(KEDITORFILETITLE).val(file ? file.title : "").end()
		            .data("kendoWindow");
	
		        var element = dialog.element;
		        if (showBrowser) {
		            that._fileBrowser = new kendo.ui.FileBrowser(
		                element.find(".k-filebrowser"),
		                extend({}, fileBrowser)
		            );
	
		            that._fileBrowser.bind("change", function (ev) {
		                if (ev.selected.get("type") === "f") {
		                    element.find(KEDITORFILEURL).val(this.value());
		                }
		            } );
	
		            that._fileBrowser.bind("apply", apply);
		        }
	
		        if(isIE) {
		            var dialogHeight = element.closest(".k-window").height();
		            element.css("max-height", dialogHeight);
		        }
		        dialog.center().open();
		        element.find(KEDITORFILEURL).focus().select();
		    }
	
		});
	
		kendo.ui.editor.FileCommand = FileCommand;
	
		registerTool("insertFile", new Editor.Tool({ command: FileCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert File" }) }));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 951:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(597);
	
	/***/ }),
	
	/***/ 952:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(666);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(970);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 962:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(670);
	
	/***/ }),
	
	/***/ 970:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(962) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    extend = $.extend,
		    proxy = $.proxy,
		    Editor = kendo.ui.editor,
		    dom = Editor.Dom,
		    EditorUtils = Editor.EditorUtils,
		    RangeUtils = Editor.RangeUtils,
		    Command = Editor.Command,
		    NS = "kendoEditor",
		    ACTIVESTATE = "k-state-active",
		    SELECTEDSTATE = "k-state-selected",
		    Tool = Editor.Tool,
		    ToolTemplate = Editor.ToolTemplate,
		    InsertHtmlCommand = Editor.InsertHtmlCommand,
		    BlockFormatFinder = Editor.BlockFormatFinder,
		    registerTool = Editor.EditorUtils.registerTool,
		    getTouches = kendo.getTouches;
		var template = kendo.template;
	
		var columnTemplate = "<td style='width:#=width#%;'>#=content#</td>";
	
		var tableFormatFinder = new BlockFormatFinder([{tags:["table"]}]);
	
		var TableCommand = InsertHtmlCommand.extend({
		    init: function(options) {
		        var o = $.extend({
		            postProcess: this.postProcess,
		            skipCleaners: true
		        }, options || {});
	
		        InsertHtmlCommand.fn.init.call(this, o);
		    },
		    _tableHtml: function(rows, columns) {
		        rows = rows || 1;
		        columns = columns || 1;
		        var columnHtml = template(columnTemplate)({ width: 100 / columns, content: Editor.emptyTableCellContent });
		        var rowHeight = 100 / rows;
	
		        return "<table class='k-table' data-last>" +
		                    new Array(rows + 1).join(
		                    "<tr style='height:" + rowHeight + "%;'>" +
		                        new Array(columns + 1).join(columnHtml) +
		                    "</tr>") +
		               "</table>";
		    },
	
		    postProcess: function(editor, range) {
		        var insertedTable = $("table[data-last]", editor.document).removeAttr("data-last");
	
		        range.setStart(insertedTable.find("td")[0], 0);
		        range.collapse(true);
	
		        editor.selectRange(range);
		    },
	
		    exec: function() {
		        var options = this.options;
		        options.html = this._tableHtml(options.rows, options.columns);
	
		        InsertHtmlCommand.fn.exec.call(this);
		    }
		});
	
		var PopupTool = Tool.extend({
		    initialize: function(ui, options) {
		        Tool.fn.initialize.call(this, ui, options);
	
		        var popup = $(this.options.popupTemplate).appendTo("body").kendoPopup({
		            anchor: ui,
		            copyAnchorStyles: false,
		            open: proxy(this._open, this),
		            activate: proxy(this._activate, this),
		            close: proxy(this._close, this)
		        }).data("kendoPopup");
	
		        ui.click(proxy(this._toggle, this))
		          .keydown(proxy(this._keydown, this));
	
		        var editor = this._editor = options.editor;
		        this._popup = popup;
	
		        var tableWizard = new Editor.TableWizardTool({
		            template: new ToolTemplate({ template: EditorUtils.buttonTemplate, title: editor.options.messages.tableWizard }),
		            command: Editor.TableWizardCommand,
		            insertNewTable: true
		        });
	
		        registerTool("tableWizardInsert", tableWizard);
	
		        var twTool = $("<div class='k-editor-toolbar'>" + tableWizard.options.template.getHtml() + "</div>");
		        twTool.appendTo(popup.element);
		        if (editor.toolbar) {
		            editor.toolbar.attachToolsEvents(twTool);
		        }
		    },
	
		    popup: function() {
		        return this._popup;
		    },
	
		    _activate: $.noop,
	
		    _open: function() {
		        this._popup.options.anchor.addClass(ACTIVESTATE);
		    },
	
		    _close: function() {
		        this._popup.options.anchor.removeClass(ACTIVESTATE);
		    },
	
		    _keydown: function(e) {
		        var keys = kendo.keys;
		        var key = e.keyCode;
	
		        if (key == keys.DOWN && e.altKey) {
		            this._popup.open();
		        } else if (key == keys.ESC) {
		            this._popup.close();
		        }
		    },
	
		    _toggle: function(e) {
		        var button = $(e.target).closest(".k-tool");
	
		        if (!button.hasClass("k-state-disabled")) {
		            this.popup().toggle();
		        }
		    },
	
		    update: function(ui) {
		        var popup = this.popup();
	
		        if (popup.wrapper && popup.wrapper.css("display") == "block") {
		            popup.close();
		        }
	
		        ui.removeClass("k-state-hover");
		    },
	
		    destroy: function() {
		        this._popup.destroy();
		    }
		});
	
		var InsertTableTool = PopupTool.extend({
		    init: function(options) {
		        this.cols = 8;
		        this.rows = 6;
	
		        PopupTool.fn.init.call(this, $.extend(options, {
		            command: TableCommand,
		            popupTemplate:
		                "<div class='k-ct-popup'>" +
		                    new Array(this.cols * this.rows + 1).join("<span class='k-ct-cell k-state-disabled' />") +
		                    "<div class='k-status'></div>" +
		                "</div>"
		        }));
		    },
	
		    _activate: function() {
		        var that = this,
		            element = that._popup.element,
		            cells = element.find(".k-ct-cell"),
		            firstCell = cells.eq(0),
		            lastCell = cells.eq(cells.length - 1),
		            start = kendo.getOffset(firstCell),
		            end = kendo.getOffset(lastCell),
		            cols = that.cols,
		            rows = that.rows,
		            cellWidth, cellHeight;
	
		        element.find("*").addBack().attr("unselectable", "on");
	
		        end.left += lastCell[0].offsetWidth;
		        end.top += lastCell[0].offsetHeight;
	
		        cellWidth = (end.left - start.left) / cols;
		        cellHeight = (end.top - start.top) / rows;
	
		        function tableFromLocation(e) {
		            var w = $(window);
		            return {
		                row: Math.floor((e.clientY + w.scrollTop() - start.top) / cellHeight) + 1,
		                col: Math.floor((e.clientX + w.scrollLeft() - start.left) / cellWidth) + 1
		            };
		        }
	
		        element.autoApplyNS(NS)
		            .on("mousemove", ".k-ct-cell", function(e) {
		                that._setTableSize(tableFromLocation(e));
		            })
		            .on("mouseleave", ".k-ct-cell", function() {
		                that._setTableSize();
		            })
		            .on("down", ".k-ct-cell", function(e) {
		                e.preventDefault();
		                var touch = getTouches(e)[0];
		                that._exec(tableFromLocation(touch.location));
		            });
		    },
	
		    _valid: function(size) {
		        return size && size.row > 0 && size.col > 0 && size.row <= this.rows && size.col <= this.cols;
		    },
	
		    _exec: function(size) {
		        if (this._valid(size)) {
		            this._editor.exec("createTable", {
		                rows: size.row,
		                columns: size.col
		            });
		            this._popup.close();
		        }
		    },
	
		    _setTableSize: function(size) {
		        var element = this._popup.element;
		        var status = element.find(".k-status");
		        var cells = element.find(".k-ct-cell");
		        var cols = this.cols;
		        var messages = this._editor.options.messages;
	
		        if (this._valid(size)) {
		            status.text(kendo.format(messages.createTableHint, size.row, size.col));
	
		            cells.each(function(i) {
		                $(this).toggleClass(
		                    SELECTEDSTATE,
		                    i % cols < size.col && i / cols < size.row
		                );
		            });
		        } else {
		            status.text(messages.createTable);
		            cells.removeClass(SELECTEDSTATE);
		        }
		    },
	
		    _keydown: function(e) {
		        PopupTool.fn._keydown.call(this, e);
	
		        if (!this._popup.visible()) {
		            return;
		        }
	
		        var keys = kendo.keys;
		        var key = e.keyCode;
		        var cells = this._popup.element.find(".k-ct-cell");
		        var focus = Math.max(cells.filter(".k-state-selected").last().index(), 0);
		        var selectedRows = Math.floor(focus / this.cols);
		        var selectedColumns = focus % this.cols;
	
		        var changed = false;
	
		        if (key == keys.DOWN && !e.altKey) {
		            changed = true;
		            selectedRows++;
		        } else if (key == keys.UP) {
		            changed = true;
		            selectedRows--;
		        } else if (key == keys.RIGHT) {
		            changed = true;
		            selectedColumns++;
		        } else if (key == keys.LEFT) {
		            changed = true;
		            selectedColumns--;
		        }
	
		        var tableSize = {
		            row: Math.max(1, Math.min(this.rows, selectedRows + 1)),
		            col: Math.max(1, Math.min(this.cols, selectedColumns + 1))
		        };
	
		        if (key == keys.ENTER) {
		            this._exec(tableSize);
		        } else {
		            this._setTableSize(tableSize);
		        }
	
		        if (changed) {
		            e.preventDefault();
		            e.stopImmediatePropagation();
		        }
		    },
	
		    _open: function() {
		        var messages = this._editor.options.messages;
	
		        PopupTool.fn._open.call(this);
	
		        this.popup().element
		            .find(".k-status").text(messages.createTable).end()
		            .find(".k-ct-cell").removeClass(SELECTEDSTATE);
		    },
	
		    _close: function() {
		        PopupTool.fn._close.call(this);
		        this.popup().element.off("." + NS);
		    }
		});
	
		var InsertRowCommand = Command.extend({
		    exec: function () {
		        var range = this.lockRange(true),
		            td = range.endContainer,
		            cellCount, row,
		            newRow;
	
		        while (dom.name(td) != "td") {
		            td = td.parentNode;
		        }
	
		        if (this.immutables() && Editor.Immutables.immutableParent(td)) {
		            return;
		        }
	
		        row = td.parentNode;
	
		        cellCount = row.children.length;
		        newRow = row.cloneNode(true);
	
		        for (var i = 0; i < row.cells.length; i++) {
		            newRow.cells[i].innerHTML = Editor.emptyTableCellContent;
		        }
	
		        if (this.options.position == "before") {
		            dom.insertBefore(newRow, row);
		        } else {
		            dom.insertAfter(newRow, row);
		        }
	
		        this.releaseRange(range);
		    }
		});
	
		var InsertColumnCommand = Command.extend({
		    exec: function () {
		        var range = this.lockRange(true),
		            td = dom.closest(range.endContainer, "td"),
		            table = dom.closest(td, "table"),
		            columnIndex,
		            i,
		            rows = table.rows,
		            cell,
		            newCell,
		            position = this.options.position;
	
		        if (this.immutables() && Editor.Immutables.immutableParent(td)) {
		            return;
		        }
	
		        columnIndex = dom.findNodeIndex(td, true);
	
		        for (i = 0; i < rows.length; i++) {
		            cell = rows[i].cells[columnIndex];
	
		            newCell = cell.cloneNode();
		            newCell.innerHTML = Editor.emptyTableCellContent;
	
		            if (position == "before") {
		                dom.insertBefore(newCell, cell);
		            } else {
		                dom.insertAfter(newCell, cell);
		            }
		        }
	
		        this.releaseRange(range);
		    }
		});
	
		var DeleteRowCommand = Command.extend({
		    exec: function () {
		        var range = this.lockRange();
		        var rows = RangeUtils.mapAll(range, function(node) {
		            return $(node).closest("tr")[0];
		        });
		        var row = rows[0];
	
		        if (this.immutables() && Editor.Immutables.immutableParent(row)) {
		            return;
		        }
	
		        var table = dom.closest(row, "table");
		        var focusElement;
	
		        if (table.rows.length <= rows.length) {
		            focusElement = dom.next(table);
		            if (!focusElement || dom.insignificant(focusElement)) {
		                focusElement = dom.prev(table);
		            }
	
		            dom.remove(table);
		        } else {
		            for (var i = 0; i < rows.length; i++) {
		                row = rows[i];
		                dom.removeTextSiblings(row);
	
		                focusElement = dom.next(row) || dom.prev(row);
		                focusElement = focusElement.cells[0];
	
		                dom.remove(row);
		            }
		        }
	
		        if (focusElement) {
		            range.setStart(focusElement, 0);
		            range.collapse(true);
		            this.editor.selectRange(range);
		        }
		    }
		});
	
		var DeleteColumnCommand = Command.extend({
		    exec: function () {
		        var range = this.lockRange(),
		            td = dom.closest(range.endContainer, "td"),
		            table = dom.closest(td, "table"),
		            rows = table.rows,
		            columnIndex = dom.findNodeIndex(td, true),
		            columnCount = rows[0].cells.length,
		            focusElement, i;
	
		        if (this.immutables() && Editor.Immutables.immutableParent(td)) {
		            return;
		        }
	
		        if (columnCount == 1) {
		            focusElement = dom.next(table);
		            if (!focusElement || dom.insignificant(focusElement)) {
		                focusElement = dom.prev(table);
		            }
	
		            dom.remove(table);
		        } else {
		            dom.removeTextSiblings(td);
	
		            focusElement = dom.next(td) || dom.prev(td);
	
		            for (i = 0; i < rows.length; i++) {
		                dom.remove(rows[i].cells[columnIndex]);
		            }
		        }
	
		        if (focusElement) {
		            range.setStart(focusElement, 0);
		            range.collapse(true);
		            this.editor.selectRange(range);
		        }
		    }
		});
	
		var TableModificationTool = Tool.extend({
		    command: function (options) {
		        options = extend(options, this.options);
	
		        if (options.action == "delete") {
		            if (options.type == "row") {
		                return new DeleteRowCommand(options);
		            } else {
		                return new DeleteColumnCommand(options);
		            }
		        } else {
		            if (options.type == "row") {
		                return new InsertRowCommand(options);
		            } else {
		                return new InsertColumnCommand(options);
		            }
		        }
		    },
	
		    initialize: function(ui, options) {
		        Tool.fn.initialize.call(this, ui, options);
		        ui.addClass("k-state-disabled");
		    },
	
		    update: function(ui, nodes) {
		        var isFormatted = !tableFormatFinder.isFormatted(nodes);
		        ui.toggleClass("k-state-disabled", isFormatted);
		    }
		});
	
		extend(kendo.ui.editor, {
		    PopupTool: PopupTool,
		    TableCommand: TableCommand,
		    InsertTableTool: InsertTableTool,
		    TableModificationTool: TableModificationTool,
		    InsertRowCommand: InsertRowCommand,
		    InsertColumnCommand: InsertColumnCommand,
		    DeleteRowCommand: DeleteRowCommand,
		    DeleteColumnCommand: DeleteColumnCommand
		});
	
		registerTool("createTable", new InsertTableTool({ template: new ToolTemplate({template: EditorUtils.buttonTemplate, popup: true, title: "Create table"})}));
	
		registerTool("addColumnLeft", new TableModificationTool({ type: "column", position: "before", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add column on the left"})}));
		registerTool("addColumnRight", new TableModificationTool({ type: "column", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add column on the right"})}));
		registerTool("addRowAbove", new TableModificationTool({ type: "row", position: "before", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add row above"})}));
		registerTool("addRowBelow", new TableModificationTool({ type: "row", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add row below"})}));
		registerTool("deleteRow", new TableModificationTool({ type: "row", action: "delete", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Delete row"})}));
		registerTool("deleteColumn", new TableModificationTool({ type: "column", action: "delete", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Delete column"})}));
		//registerTool("mergeCells", new Tool({ template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Merge cells"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(945);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 945:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        Class = kendo.Class,
		        editorNS = kendo.ui.editor,
		        RangeUtils = editorNS.RangeUtils,
		        dom = editorNS.Dom,
		        RestorePoint = editorNS.RestorePoint,
		        Marker = editorNS.Marker,
		        browser = kendo.support.browser,
		        extend = $.extend;
	
		var Clipboard = Class.extend({
		    init: function(editor) {
		        this.editor = editor;
		        var pasteCleanup = editor.options.pasteCleanup;
		        this.cleaners = [
		            new ScriptCleaner(pasteCleanup),
		            new TabCleaner(pasteCleanup),
		            new MSWordFormatCleaner(pasteCleanup),
		            new WebkitFormatCleaner(pasteCleanup),
		            new HtmlTagsCleaner(pasteCleanup),
		            new HtmlAttrCleaner(pasteCleanup),
		            new HtmlContentCleaner(pasteCleanup),
		            new CustomCleaner(pasteCleanup) //always keep at end
		        ];
		    },
	
		    htmlToFragment: function(html) {
		        var editor = this.editor,
		            doc = editor.document,
		            container = dom.create(doc, 'div'),
		            fragment = doc.createDocumentFragment();
	
		        container.innerHTML = html;
	
		        while (container.firstChild) {
		            fragment.appendChild(container.firstChild);
		        }
	
		        return fragment;
		    },
	
		    isBlock: function(html) {
		        return (/<(div|p|ul|ol|table|h[1-6])/i).test(html);
		    },
	
		    _startModification: function() {
		        var range;
		        var restorePoint;
		        var editor = this.editor;
	
		        if (this._inProgress) {
		            return;
		        }
	
		        this._inProgress = true;
	
		        range = editor.getRange();
		        restorePoint = new RestorePoint(range, editor.body);
	
		        dom.persistScrollTop(editor.document);
	
		        return { range: range, restorePoint: restorePoint };
		    },
	
		    _endModification: function(modificationInfo) {
		        editorNS._finishUpdate(this.editor, modificationInfo.restorePoint);
	
		        this.editor._selectionChange();
	
		        this._inProgress = false;
		    },
	
		    _contentModification: function(before, after) {
		        var that = this;
		        var editor = that.editor;
		        var modificationInfo = that._startModification();
	
		        if (!modificationInfo) {
		            return;
		        }
	
		        before.call(that, editor, modificationInfo.range);
	
		        setTimeout(function() {
		            after.call(that, editor, modificationInfo.range);
	
		            that._endModification(modificationInfo);
		        });
		    },
	
		    _removeBomNodes: function(range) {
		        var nodes = RangeUtils.textNodes(range);
	
		        for (var i = 0; i < nodes.length; i++) {
		            nodes[i].nodeValue = dom.stripBom(nodes[i].nodeValue) || nodes[i].nodeValue;
		        }
		    },
	
		    _onBeforeCopy: function(range) {
		        var marker = new Marker();
		        marker.add(range);
	
		        this._removeBomNodes(range);
	
		        marker.remove(range);
	
		        this.editor.selectRange(range);
		    },
	
		    oncopy: function() {
		        this._onBeforeCopy(this.editor.getRange());
		    },
	
		    oncut: function() {
		        this._onBeforeCopy(this.editor.getRange());
		        this._contentModification($.noop, $.noop);
		    },
	
		    _fileToDataURL: function(blob) {
		        var deferred = $.Deferred();
	
		        var reader = new FileReader();
	
		        if (!(blob instanceof window.File) && blob.getAsFile) {
		            blob = blob.getAsFile();
		        }
	
		        reader.onload = $.proxy(deferred.resolve, deferred);
	
		        reader.readAsDataURL(blob);
	
		        return deferred.promise();
		    },
	
		    _triggerPaste: function(html, options) {
		        var args = { html: html || "" };
	
		        args.html = args.html.replace(/\ufeff/g, "");
	
		        this.editor.trigger("paste", args);
	
		        this.paste(args.html, options || {});
		    },
	
		    _handleImagePaste: function(e) {
		        if (!('FileReader' in window) || (browser.msie && browser.version > 10)) {
		            return;
		        }
	
		        var clipboardData = e.clipboardData || e.originalEvent.clipboardData ||
		                    window.clipboardData || {};
	
		        var items = clipboardData.items || clipboardData.files;
	
		        return this._insertImages(items);
		    },
	
		    _insertImages: function(items){
		        if (!items) {
		            return;
		        }
	
		        var images = $.grep(items, function(item) { return (/^image\//i).test(item.type); });
		        var html = $.grep(items, function(item) { return (/^text\/html/i).test(item.type); });
	
		        if (html.length || !images.length) {
		            return;
		        }
	
		        var modificationInfo = this._startModification();
	
		        if (!modificationInfo) {
		            return;
		        }
	
		        $.when.apply($, $.map(images, this._fileToDataURL))
		            .done($.proxy(function() {
		                var results = Array.prototype.slice.call(arguments);
		                var html = $.map(results, function(e) {
		                    return '<img src="' + e.target.result + '" />';
		                }).join("");
	
		                this._triggerPaste(html);
	
		                this._endModification(modificationInfo);
		            }, this));
	
		        return true;
		    },
	
		    onpaste: function(e) {
		        if (this.editor.body.contentEditable === "false") {
		            return;
		        }
	
		        if (this._handleImagePaste(e)) {
		            e.preventDefault();
		            return;
		        }
	
		        this.expandImmutablesIn();
	
		        this._contentModification(
		            function beforePaste(editor, range) {
		                var clipboardNode = dom.create(editor.document, 'div', {
		                        className:'k-paste-container',
		                        innerHTML: "\ufeff"
		                    });
		                var browser = kendo.support.browser;
		                var body = editor.body;
	
		                this._decoreateClipboardNode(clipboardNode, body);
	
		                body.appendChild(clipboardNode);
	
		                //Browser scrolls to clipboardNode
		                if (browser.webkit) {
		                    this._moveToCaretPosition(clipboardNode, range);
		                }
	
		                // text ranges are slow in IE10-, DOM ranges are buggy in IE9-10
		                if (browser.msie && browser.version < 11) {
		                    e.preventDefault();
		                    var r = editor.createRange();
		                    r.selectNodeContents(clipboardNode);
		                    editor.selectRange(r);
		                    var textRange = editor.document.body.createTextRange();
		                    textRange.moveToElementText(clipboardNode);
		                    $(body).unbind('paste');
		                    textRange.execCommand('Paste');
		                    $(body).bind('paste', $.proxy(this.onpaste, this));
		                } else {
		                    var clipboardRange = editor.createRange();
		                    clipboardRange.selectNodeContents(clipboardNode);
		                    editor.selectRange(clipboardRange);
		                }
	
		                range.deleteContents();
		            },
		            function afterPaste(editor, range) {
		                var html = "", containers;
	
		                editor.selectRange(range);
	
		                containers = $(editor.body).children(".k-paste-container");
	
		                containers.each(function() {
		                    var lastChild = this.lastChild;
	
		                    if (lastChild && dom.is(lastChild, 'br')) {
		                        dom.remove(lastChild);
		                    }
	
		                    html += this.innerHTML;
		                });
	
		                containers.remove();
	
		                this._triggerPaste(html, { clean: true });
		            }
		        );
		    },
		    ondragover: function(e){
		        if (browser.msie || browser.edge) {
		            e.stopPropagation();
		            e.preventDefault();
		        }
		    },
		    ondrop: function(e){
		        if (!('FileReader' in window)) {
		            return;
		        }
	
		        var dataTransfer = (e.originalEvent || e).dataTransfer || {};
		        var items = dataTransfer.items || dataTransfer.files;
	
		        if (this._insertImages(items)) {
		            e.preventDefault();
		        }
		    },
		    _decoreateClipboardNode: function(node, body) {
		        if (!browser.msie && !browser.webkit) {
		            return;
		        }
	
		        node = $(node);
		        node.css({
		            borderWidth : "0px",
		            width : "0px",
		            height : "0px",
		            overflow: "hidden",
		            margin : "0",
		            padding : "0"
		        });
	
		        if (browser.msie) {
		            //node inherits BODY styles and this causes the browser to add additional
		            var documentElement = $(body.ownerDocument.documentElement);
	
		            node.css({
		                fontVariant : "normal",
		                fontWeight : "normal",
		                lineSpacing : "normal",
		                lineHeight : "normal",
		                textDecoration : "none"
		            });
		            var color = documentElement.css("color");
		            if (color) {
		                node.css("color", color);
		            }
		            var fontFamily = documentElement.css("fontFamily");
		            if (fontFamily) {
		                node.css("fontFamily", fontFamily);
		            }
		            var fontSize = documentElement.css("fontSize");
		            if (fontSize) {
		                node.css("fontSize", fontSize);
		            }
		        }
		    },
		    _moveToCaretPosition: function(node, range) {
		        var that = this;
		        var body = that.editor.body;
		        var nodeOffset = dom.offset(node, body);
		        var caretOffset = that._caretOffset(range, body);
		        var translateX = caretOffset.left - nodeOffset.left;
		        var translateY = caretOffset.top - nodeOffset.top;
		        var translate = "translate(" + translateX + "px," + translateY + "px)";
	
		        $(node).css({
		            "-webkit-transform": translate,
		            "transform" : translate
		        });
		    },
		    _caretOffset: function (range, body) {
		        var editor = this.editor;
		        var caret = dom.create(editor.document, 'span', { innerHTML: "\ufeff" });
		        var startContainer = range.startContainer;
		        var rangeChanged;
	
		        if (range.collapsed) {
		            var isStartTextNode = dom.isDataNode(startContainer);
		            if (isStartTextNode && (dom.isBom(startContainer) || range.startOffset === 0)) {
		                dom.insertBefore(caret, startContainer);
		            } else if(isStartTextNode && range.startOffset === startContainer.length) {
		                dom.insertAfter(caret, startContainer);
		            } else {
		                range.insertNode(caret);
		                rangeChanged = true;
		            }
		        } else {
		            startContainer = startContainer === body ?
		                startContainer.childNodes[range.startOffset] : startContainer;
		            dom.insertBefore(caret, startContainer);
		        }
	
		        var offset = dom.offset(caret, body);
		        var prev = caret.previousSibling;
		        var next = caret.nextSibling;
	
		        dom.remove(caret);
	
		        if(rangeChanged && dom.isDataNode(prev) && dom.isDataNode(next) && !dom.isBom(prev) && !dom.isBom(next)) {
		            var prevLength = prev.length;
		            next.data = prev.data + next.data;
		            range.setStart(next, prevLength);
		            dom.remove(prev);
	
		            range.collapse(true);
		            editor.selectRange(range);
		        }
	
		        return offset;
		    },
	
		    expandImmutablesIn: function(range){
		        var editor = this.editor;
		        if (editor && editor.options.immutables) {
		            var body = editor.body;
		            range = range || editor.getRange();
		            kendo.ui.editor.Immutables.expandImmutablesIn(range);
		            if (range.startContainer === body && range.startOffset === 0) {
		                var doc = body.ownerDocument;
		                var bomNode = doc.createTextNode("\ufeff");
		                body.insertBefore(bomNode, body.childNodes[0]);
		                range.setStartBefore(bomNode);
		            }
		            editor.selectRange(range);
		        }
		    },
	
		    splittableParent: function(block, node) {
		        var parentNode, body;
	
		        if (block) {
		            return dom.closestEditableOfType(node, ['p', 'ul', 'ol']) || node.parentNode;
		        }
	
		        parentNode = node.parentNode;
		        body = node.ownerDocument.body;
	
		        if (dom.isInline(parentNode)) {
		            while (parentNode.parentNode != body && !dom.isBlock(parentNode.parentNode)) {
		                parentNode = parentNode.parentNode;
		            }
		        }
	
		        return parentNode;
		    },
	
		    paste: function (html, options) {
		        var editor = this.editor,
		            i, l, childNodes;
	
		        this.expandImmutablesIn();
	
		        options = extend({ clean: false, split: true }, options);
	
		        if(!options.skipCleaners) {
		            for (i = 0, l = this.cleaners.length; i < l; i++) {
		                if (this.cleaners[i].applicable(html)) {
		                    html = this.cleaners[i].clean(html);
		                }
		            }
		        }
	
		        if (options.clean) {
		            // remove br elements which immediately precede block elements
		            html = html.replace(/(<br>(\s|&nbsp;)*)+(<\/?(div|p|li|col|t))/ig, "$3");
		            // remove empty inline elements
		            html = html.replace(/<(a|span)[^>]*><\/\1>/ig, "");
		        }
	
		        html = html.replace(/<(a|span|font)([^>]*)> <\/\1>/ig, "<$1$2>&nbsp;</$1>");
	
		        // It is possible in IE to copy just <li> tags
		        html = html.replace(/^<li/i, '<ul><li').replace(/li>$/g, 'li></ul>');
	
		        var block = this.isBlock(html);
	
		        editor.focus();
		        var range = editor.getRange();
		        range.deleteContents();
	
		        if (range.startContainer == editor.document) {
		            range.selectNodeContents(editor.body);
		        }
	
		        var marker = new Marker();
		        var caret = marker.addCaret(range);
	
		        var parent = this.splittableParent(block, caret);
		        var unwrap = false;
		        var splittable = parent != editor.body && !dom.is(parent, "td");
	
		        if (options.split && splittable && (block || dom.isInline(parent))) {
		            range.selectNode(caret);
		            RangeUtils.split(range, parent, true);
		            unwrap = true;
		        }
	
		        var fragment = this.htmlToFragment(html);
	
		        if (fragment.firstChild && fragment.firstChild.className === "k-paste-container") {
		            var fragmentsHtml = [];
		            for (i = 0, l = fragment.childNodes.length; i < l; i++) {
		                fragmentsHtml.push(fragment.childNodes[i].innerHTML);
		            }
	
		            fragment = this.htmlToFragment(fragmentsHtml.join('<br />'));
		        }
	
		        childNodes = fragment.childNodes;
	
		        $(childNodes)
		            .filter("table").addClass("k-table").end()
		            .find("table").addClass("k-table");
	
		        $(childNodes).each(function(index, elm){
		           if (dom.isBlock(elm) && !dom.isSelfClosing(elm) && elm.innerHTML === "") {
		                elm.appendChild(editor.document.createTextNode("\ufeff"));
		           }
		        });
	
		        range.insertNode(fragment);
	
		        parent = this.splittableParent(block, caret);
		        if (unwrap) {
		            while (caret.parentNode != parent) {
		                dom.unwrap(caret.parentNode);
		            }
	
		            dom.unwrap(caret.parentNode);
		        }
	
		        dom.normalize(range.commonAncestorContainer);
		        caret.style.display = 'inline';
		        dom.restoreScrollTop(editor.document);
		        dom.scrollTo(caret);
		        marker.removeCaret(range);
	
		        var rangeEnd = range.commonAncestorContainer.parentNode;
		        if (range.collapsed && dom.name(rangeEnd) == "tbody") {
		            range.setStartAfter($(rangeEnd).closest("table")[0]);
		            range.collapse(true);
		        }
	
		        var focusedTable = $(range.commonAncestorContainer.parentNode).closest("table");
	
		        if(focusedTable.get(0)) {
		            var siblingNodes = focusedTable.parent().contents();
		            var lastSiblingIndex = siblingNodes.length - 1;
		            var lastSibling = siblingNodes.get(lastSiblingIndex);
	
		            while(lastSibling.nodeValue !== null && (lastSibling.nodeValue === " " || lastSibling.nodeValue === "")) {
		                lastSiblingIndex -= 1;
		                lastSibling = siblingNodes.get(lastSiblingIndex);
		            }
	
		            if(lastSibling === focusedTable.get(0)) {
		                dom.insertAfter(dom.createEmptyNode(editor.document, "p"), focusedTable[0]);
		            }
		        }
	
		        editor.selectRange(range);
		    }
		});
	
		var Cleaner = Class.extend({
		    init: function(options) {
		        this.options = options || {};
		        this.replacements = [];
		    },
	
		    clean: function(html, customReplacements) {
		        var that = this,
		            replacements = customReplacements || that.replacements,
		            i, l;
	
		        for (i = 0, l = replacements.length; i < l; i += 2) {
		            html = html.replace(replacements[i], replacements[i+1]);
		        }
	
		        return html;
		    }
		});
	
		var ScriptCleaner = Cleaner.extend({
		    init: function(options) {
		        Cleaner.fn.init.call(this, options);
	
		        this.replacements = [
		            /<(\/?)script([^>]*)>/i, "<$1telerik:script$2>"
		        ];
		    },
	
		    applicable: function(html) {
		        return !this.options.none && (/<script[^>]*>/i).test(html);
		    }
		});
	
		var TabCleaner = Cleaner.extend({
		    init: function(options) {
		        Cleaner.fn.init.call(this, options);
	
		        var replacement = ' ';
		        this.replacements = [
		            /<span\s+class="Apple-tab-span"[^>]*>\s*<\/span>/gi, replacement,
		            /\t/gi, replacement,
		            /&nbsp;&nbsp; &nbsp;/gi, replacement
		        ];
		    },
	
		    applicable: function(html) {
		        return (/&nbsp;&nbsp; &nbsp;|class="?Apple-tab-span/i).test(html);
		    }
		});
	
		var MSWordFormatCleaner = Cleaner.extend({
		    init: function(options) {
		        Cleaner.fn.init.call(this, options);
	
		        this.junkReplacements = [
		            /<\?xml[^>]*>/gi, '',
		            /<!--(.|\n)*?-->/g, '', /* comments */
		            /&quot;/g, "'", /* encoded quotes (in attributes) */
		            /<o:p>&nbsp;<\/o:p>/ig, '&nbsp;',
		            /<\/?(meta|link|style|o:|v:|x:)[^>]*>((?:.|\n)*?<\/(meta|link|style|o:|v:|x:)[^>]*>)?/ig, '', /* external references and namespaced tags */
		            /<\/o>/g, ''
		        ];
		        this.replacements = this.junkReplacements.concat([
		            /(?:<br>&nbsp;[\s\r\n]+|<br>)*(<\/?(h[1-6]|hr|p|div|table|tbody|thead|tfoot|th|tr|td|li|ol|ul|caption|address|pre|form|blockquote|dl|dt|dd|dir|fieldset)[^>]*>)(?:<br>&nbsp;[\s\r\n]+|<br>)*/g, '$1',
		            /<br><br>/g, '<BR><BR>',
		            /<br>(?!\n)/g, ' ',
		            /<table([^>]*)>(\s|&nbsp;)+<t/gi, '<table$1><t',
		            /<tr[^>]*>(\s|&nbsp;)*<\/tr>/gi, '',
		            /<tbody[^>]*>(\s|&nbsp;)*<\/tbody>/gi, '',
		            /<table[^>]*>(\s|&nbsp;)*<\/table>/gi, '',
		            /<BR><BR>/g, '<br>',
		            /^\s*(&nbsp;)+/gi, '',
		            /(&nbsp;|<br[^>]*>)+\s*$/gi, '',
		            /mso-[^;"]*;?/ig, '', /* office-related CSS attributes */
		            /<(\/?)b(\s[^>]*)?>/ig, '<$1strong$2>',
		            /<(\/?)font(\s[^>]*)?>/ig, this.convertFontMatch,
		            /<(\/?)i(\s[^>]*)?>/ig, '<$1em$2>',
		            /style=(["|'])\s*\1/g, '', /* empty style attributes */
		            /(<br[^>]*>)?\n/g, function ($0, $1) { return $1 ? $0 : ' '; } /* phantom extra line feeds */
		        ]);
		    },
	
		    convertFontMatch: function(match, closing, args) {
		        var faceRe = /face=['"]([^'"]+)['"]/i;
		        var face = faceRe.exec(args);
		        var family = args && face && face[1];
	
		        if (closing) {
		            return '</span>';
		        } else if (family) {
		            return '<span style="font-family:' + family + '">';
		        } else {
		            return '<span>';
		        }
		    },
	
		    applicable: function(html) {
		        return (/class="?Mso/i).test(html) ||
		               (/style="[^"]*mso-/i).test(html) ||
		               (/urn:schemas-microsoft-com:office/).test(html);
		    },
	
		    stripEmptyAnchors: function(html) {
		        return html.replace(/<a([^>]*)>\s*<\/a>/ig, function(a, attributes) {
		            if (!attributes || attributes.indexOf("href") < 0) {
		                return "";
		            }
	
		            return a;
		        });
		    },
	
		    listType: function(p, listData) {
		        var html = p.innerHTML;
		        var text = dom.innerText(p);
	
		        var startingSymbol;
		        var matchSymbol = html.match(/^(?:<span [^>]*texhtml[^>]*>)?<span [^>]*(?:Symbol|Wingdings)[^>]*>([^<]+)/i);
		        var symbol = matchSymbol && matchSymbol[1];
		        var isNumber = /^[a-z\d]/i.test(symbol);//including alpha-numeric and roman numerals
	
		        var trimStartText = function(text) {
		            return text.replace(/^(?:&nbsp;|[\u00a0\n\r\s])+/, '');
		        };
	
		        if (matchSymbol) {
		            startingSymbol = true;
		        }
	
		        html = html.replace(/<\/?\w+[^>]*>/g, '').replace(/&nbsp;/g, '\u00a0');
	
		        if ((!startingSymbol && /^[\u2022\u00b7\u00a7\u00d8o]\u00a0+/.test(html)) ||
		            (startingSymbol && /^.\u00a0+/.test(html)) ||
		            (symbol && !isNumber && listData)) {
		            return {
		                tag: 'ul',
		                style: this._guessUnorderedListStyle(trimStartText(text))
		            };
		        }
	
		        if (/^\s*\w+[\.\)][\u00a0 ]{2,}/.test(html)) {
		            return {
		                tag: 'ol',
		                style: this._guessOrderedListStyle(trimStartText(text))
		            };
		        }
		    },
	
		    _convertToLi: function(p) {
		        var content,
		            name = dom.name(p);
	
		        if (p.childNodes.length == 1) {
		            content = p.firstChild.innerHTML.replace(/^\w+[\.\)](&nbsp;)+ /, "");
		        } else {
		            dom.remove(p.firstChild);
	
		            // check for roman numerals
		            if (p.firstChild.nodeType == 3) {
		                if (/^[ivxlcdm]+\.$/i.test(p.firstChild.nodeValue)) {
		                    dom.remove(p.firstChild);
		                }
		            }
	
		            if (/^(&nbsp;|\s)+$/i.test(p.firstChild.innerHTML)) {
		                dom.remove(p.firstChild);
		            }
	
		            if (name != "p") {
		                content = "<" + name + ">" + p.innerHTML + "</" + name + ">";
		            } else {
		                content = p.innerHTML;
		            }
		        }
	
		        dom.remove(p);
	
		        return dom.create(document, 'li', { innerHTML: content });
		    },
	
		    _guessUnorderedListStyle: function(symbol) {
		        if (/^[\u2022\u00b7\u00FC\u00D8\u002dv-]/.test(symbol)) {
		            return null;//return "disc"; //default CSS value
		        } else if (/^o/.test(symbol)) {
		            return "circle";
		        } else {
		            return "square";
		        }
		    },
		    _guessOrderedListStyle: function(symbol) {
		        var listType = null;
		        if (!/^\d/.test(symbol)) {
		            listType = (/^[a-z]/.test(symbol) ? 'lower-' : 'upper-') +
		                       (/^[ivxlcdm]/i.test(symbol) ? 'roman' : 'alpha');
		        }
	
		        return listType;
		    },
	
		    extractListLevels: function(html) {
		        var msoListRegExp = /style=['"]?[^'"]*?mso-list:\s?[a-zA-Z]+(\d+)\s[a-zA-Z]+(\d+)\s(\w+)/gi;
	
		        html = html.replace(msoListRegExp, function(match, list, level) {
		            return kendo.format('data-list="{0}" data-level="{1}" {2}', list, level, match);
		        });
	
		        return html;
		    },
	
		    _createList: function(type, styleType) {
		        return dom.create(document, type, {
		            style: { listStyleType: styleType }
		        });
		    },
	
		    lists: function(placeholder) {
		        var blockChildren = $(placeholder).find(dom.blockElements.join(',')),
		            lastMargin = -1,
		            name,
		            levels = {},
		            li,
		            rootMargin,
		            rootIndex,
		            lastRootLi,
		            isLastRootLi,
		            rootList,
		            i, p, type, margin, list, listData,
		            acceptedNameTags = ["p", "h1", "h2", "h3", "h4", "h5", "h6"];
	
		        for (i = 0; i < blockChildren.length; i++) {
		            p = blockChildren[i];
		            listData = $(p).data();
		            var listIndex = listData.list;
		            name = dom.name(p);
	
		            if (name == "td") {
		                continue;
		            }
	
		            var listType = this.listType(p, listData);
		            type = listType && listType.tag;
	
		            if (!type || acceptedNameTags.indexOf(name) < 0) {
		                if (!p.innerHTML) {
		                    dom.remove(p);
		                } else if (li && !isLastRootLi) {
		                    li.appendChild(p);
		                }
		                continue;
		            }
	
		            // not supported list levels in ie
		            if (browser.msie) {
		                continue;
		            }
	
		            margin = listData.level || parseFloat(p.style.marginLeft || 0);
	
		            var levelType = type + listIndex;
		            if (!levels[margin]) {
		                levels[margin] = {};
		            }
	
		            if (!rootMargin || rootMargin < 0) {
		                rootMargin = margin;
		                rootIndex = listIndex;
		                lastRootLi = $(placeholder).find("[data-list='" + rootIndex + "']:last")[0];
		                rootList = this._createList(type, listType.style);
		                dom.insertBefore(rootList, p);
		                lastMargin = margin;
		                levels[margin][levelType] = rootList;
		            }
	
		            isLastRootLi = lastRootLi === p;
	
		            list = levels[margin][levelType];
	
		            if (margin > lastMargin || !list) {
		                list = this._createList(type, listType.style);
		                levels[margin][levelType] = list;
		                li.appendChild(list);
		            }
	
		            li = this._convertToLi(p);
		            list.appendChild(li);
	
		            if (isLastRootLi) {
		                rootMargin = lastMargin = -1;
		            } else {
		                lastMargin = margin;
		            }
		        }
		    },
	
		    removeAttributes: function(element) {
		        var attributes = element.attributes,
		            i = attributes.length;
	
		        while (i--) {
		            if (dom.name(attributes[i]) != "colspan") {
		                element.removeAttributeNode(attributes[i]);
		            }
		        }
		    },
	
		    createColGroup: function(row) {
		        var cells = row.cells;
		        var table = $(row).closest("table");
		        var colgroup = table.children("colgroup");
	
		        if (cells.length < 2) {
		            return;
		        } else if (colgroup.length) {
		            cells = colgroup.children();
		            colgroup[0].parentNode.removeChild(colgroup[0]);
		        }
	
		        colgroup = $($.map(cells, function(cell) {
		                var width = cell.width;
		                if (width && parseInt(width, 10) !== 0) {
		                    return kendo.format('<col style="width:{0}px;"/>', width);
		                }
	
		                return "<col />";
		            }).join(""));
	
		        // jquery 1.9/2.0 discrepancy
		        if (!colgroup.is("colgroup")) {
		            colgroup = $("<colgroup/>").append(colgroup);
		        }
	
		        colgroup.prependTo(table);
		    },
	
		    convertHeaders: function(row) {
		        var cells = row.cells,
		            i,
		            boldedCells = $.map(cells, function(cell) {
		                var child = $(cell).children("p").children("strong")[0];
	
		                if (child && dom.name(child) == "strong") {
		                    return child;
		                }
		            });
	
		        if (boldedCells.length == cells.length) {
		            for (i = 0; i < boldedCells.length; i++) {
		                dom.unwrap(boldedCells[i]);
		            }
	
		            $(row).closest("table")
		                .find("colgroup").after("<thead></thead>").end()
		                .find("thead").append(row);
	
		            for (i = 0; i < cells.length; i++) {
		                dom.changeTag(cells[i], "th");
		            }
		        }
		    },
	
		    removeParagraphs: function(cells) {
		        var i, j, len, cell, paragraphs;
	
		        for (i = 0; i < cells.length; i++) {
		            this.removeAttributes(cells[i]);
	
		            // remove paragraphs and insert line breaks between them
		            cell = $(cells[i]);
		            paragraphs = cell.children("p");
	
		            for (j = 0, len = paragraphs.length; j < len; j++) {
		                if (j < len - 1) {
		                    dom.insertAfter(dom.create(document, "br"), paragraphs[j]);
		                }
	
		                dom.unwrap(paragraphs[j]);
		            }
		        }
		    },
	
		    removeDefaultColors: function(spans) {
		        for (var i = 0; i < spans.length; i++) {
		            if (/^\s*color:\s*[^;]*;?$/i.test(spans[i].style.cssText)) {
		                dom.unwrap(spans[i]);
		            }
		        }
		    },
	
		    tables: function(placeholder) {
		        var tables = $(placeholder).find("table"),
		            that = this,
		            rows,
		            firstRow, longestRow, i, j;
	
		        for (i = 0; i < tables.length; i++) {
		            rows = tables[i].rows;
		            longestRow = firstRow = rows[0];
	
		            for (j = 1; j < rows.length; j++) {
		                if (rows[j].cells.length > longestRow.cells.length) {
		                    longestRow = rows[j];
		                }
		            }
	
		            that.createColGroup(longestRow);
		            that.convertHeaders(firstRow);
	
		            that.removeAttributes(tables[i]);
	
		            that.removeParagraphs(tables.eq(i).find("td,th"));
		            that.removeDefaultColors(tables.eq(i).find("span"));
		        }
		    },
	
		    headers: function(placeholder) {
		        var titles = $(placeholder).find("p.MsoTitle");
	
		        for (var i = 0; i < titles.length; i++) {
		            dom.changeTag(titles[i], "h1");
		        }
		    },
	
		    removeFormatting: function (placeholder) {
		        $(placeholder).find("*").each(function() {
		            $(this).css({
		                fontSize: "",
		                fontFamily: ""
		            });
	
		            if (!this.getAttribute("style") && !this.style.cssText) {
		                this.removeAttribute("style");
		            }
		        });
		    },
	
		    clean: function(html) {
		        var that = this, placeholder;
		        var filters = this.options;
	
		        if (filters.none) {
		            html = Cleaner.fn.clean.call(that, html, this.junkReplacements);
		            html = that.stripEmptyAnchors(html);
		        } else {
		            html = this.extractListLevels(html);
		            html = Cleaner.fn.clean.call(that, html);
		            html = that.stripEmptyAnchors(html);
	
		            placeholder = dom.create(document, 'div', {innerHTML: html});
		            that.headers(placeholder);
	
		            if (filters.msConvertLists) {
		                that.lists(placeholder);
		            }
		            that.tables(placeholder);
	
		            if (filters.msAllFormatting) {
		                that.removeFormatting(placeholder);
		            }
	
		            html = placeholder.innerHTML.replace(/(<[^>]*)\s+class="?[^"\s>]*"?/ig, '$1');
		        }
	
		        return html;
		    }
		});
	
		var WebkitFormatCleaner = Cleaner.extend({
		    init: function(options) {
		        Cleaner.fn.init.call(this, options);
	
		        this.replacements = [
		            /\s+class="Apple-style-span[^"]*"/gi, '',
		            /<(div|p|h[1-6])\s+style="[^"]*"/gi, '<$1',
		            /^<div>(.*)<\/div>$/, '$1'
		        ];
		    },
	
		    applicable: function(html) {
		        return (/class="?Apple-style-span|style="[^"]*-webkit-nbsp-mode/i).test(html);
		    }
		});
	
		var DomCleaner = Cleaner.extend({
		    clean: function(html) {
		        var container = dom.create(document, 'div', {innerHTML: html});
		        container = this.cleanDom(container);
		        return container.innerHTML;
		    },
	
		    cleanDom: function(container) {
		        return container;
		    }
		});
	
		var HtmlTagsCleaner = DomCleaner.extend({
		    cleanDom: function(container) {
		        var tags = this.collectTags();
	
		        $(container).find(tags).each(function() {
		            dom.unwrap(this);
		        });
	
		        return container;
		    },
	
		    collectTags: function() {
		        if (this.options.span) {
		            return "span";
		        }
		    },
	
		    applicable: function() {
		        return this.options.span;
		    }
		});
	
		var HtmlAttrCleaner = DomCleaner.extend({
		    cleanDom: function(container) {
		        var attributes = this.collectAttr();
		        var nodes = $(container).find("[" + attributes.join("],[") + "]");
		        nodes.removeAttr(attributes.join(" "));
	
		        return container;
		    },
	
		    collectAttr: function() {
		        if (this.options.css) {
		            return ["class", "style"];
		        }
	
		        return [];
		    },
	
		    applicable: function() {
		        return this.options.css;
		    }
		});
	
		var TextContainer = function() {
		    this.text = "";
		    this.add = function(text) {
		        this.text += text;
		    };
		};
	
		var HtmlTextLines = Class.extend({
		    init: function(separators) {
		        this.separators = separators || {
		                text: " ",
		                line: "<br/>"
		            };
		        this.lines = [];
		        this.inlineBlockText = [];
		        this.resetLine();
		    },
	
		    appendText: function(text) {
		        if (text.nodeType === 3) {
		            text = text.nodeValue;
		        }
	
		        this.textContainer.add(text);
		    },
	
		    appendInlineBlockText: function(text) {
		        this.inlineBlockText.push(text);
		    },
	
		    flashInlineBlockText: function() {
		        if (this.inlineBlockText.length) {
		            this.appendText(this.inlineBlockText.join(" "));
		            this.inlineBlockText = [];
		        }
		    },
	
		    endLine: function() {
		        this.flashInlineBlockText();
		        this.resetLine();
		    },
	
		    html: function() {
		        var separators = this.separators;
		        var result = "";
		        var lines = this.lines;
	
		        this.flashInlineBlockText();
	
		        for (var i = 0, il = lines.length, il1 = il - 1; i < il; i++) {
		            var line = lines[i];
		            for (var j = 0, jl = line.length, jl1 = jl - 1; j < jl; j++) {
		                var text = line[j].text;
		                result += text;
		                if (j !== jl1) {
		                    result += separators.text;
		                }
		            }
		            if (i !== il1) {
		                result += separators.line;
		            }
		        }
	
		        return result;
		    },
	
		    resetLine: function() {
		        this.textContainer = new TextContainer();
		        this.line = [];
		        this.line.push(this.textContainer);
		        this.lines.push(this.line);
		    }
		});
	
		var DomEnumerator = Class.extend({
		    init: function(callback) {
		        this.callback = callback;
		    },
		    enumerate: function(node) {
		        if (!node) {
		            return;
		        }
	
		        var preventDown = this.callback(node);
	
		        var child = node.firstChild;
		        if (!preventDown && child) {
		            this.enumerate(child);
		        }
	
		        this.enumerate(node.nextSibling);
		    }
		});
	
		var HtmlContentCleaner = Cleaner.extend({
		    init: function(options) {
		        Cleaner.fn.init.call(this, options);
		        this.hasText = false; //unpleasant flag to prevent an empty line at the beginning of the generated content.
		        this.enumerator = new DomEnumerator($.proxy(this.buildText, this));
		    },
	
		    clean: function(html) {
		        var container = dom.create(document, 'div', {innerHTML: html});
	
		        return this.cleanDom(container);
		    },
	
		    cleanDom: function(container) {
		        this.separators = this.getDefaultSeparators();
		        this.htmlLines = new HtmlTextLines(this.separators);
		        this.enumerator.enumerate(container.firstChild);
		        this.hasText = false;
	
		        return this.htmlLines.html();
		    },
	
		    buildText: function(node) {
		        if (dom.isDataNode(node)) {
		            if (dom.isEmptyspace(node)) {
		                return;
		            }
		            this.htmlLines.appendText(node.nodeValue.replace('\n', this.separators.line));
		            this.hasText = true;
		        } else if (dom.isBlock(node) && this.hasText) {
		            var action = this.actions[dom.name(node)] || this.actions.block;
		            return action(this, node);
		        } else if (dom.isBr(node)) {
		            this.htmlLines.appendText(this.separators.line);
		        }
		    },
	
		    applicable: function() {
		        var o = this.options;
		        return o.all || o.keepNewLines;
		    },
	
		    getDefaultSeparators: function() {
		        if (this.options.all) {
		            return {text: " ", line: " "};
		        } else {
		            return {text: " ", line: "<br/>"};
		        }
		    },
	
		    actions: {
		        ul: $.noop,
		        ol: $.noop,
		        table: $.noop,
		        thead: $.noop,
		        tbody: $.noop,
		        td: function(cleaner, node) {
		            var tdCleaner = new HtmlContentCleaner({all: true});
	
		            var cellText = tdCleaner.cleanDom(node);
		            cleaner.htmlLines.appendInlineBlockText(cellText);
	
		            return true;
		        },
	
		        block: function(cleaner) {
		            cleaner.htmlLines.endLine();
		        }
		    }
		});
	
		var CustomCleaner = Cleaner.extend({
		    clean: function(html) {
		        return this.options.custom(html);
		    },
	
		    applicable: function() {
		        return typeof(this.options.custom) === "function";
		    }
		});
	
		extend(editorNS, {
		    Clipboard: Clipboard,
		    Cleaner: Cleaner,
		    ScriptCleaner: ScriptCleaner,
		    TabCleaner: TabCleaner,
		    MSWordFormatCleaner: MSWordFormatCleaner,
		    WebkitFormatCleaner: WebkitFormatCleaner,
		    HtmlTagsCleaner: HtmlTagsCleaner,
		    HtmlAttrCleaner: HtmlAttrCleaner,
		    HtmlContentCleaner: HtmlContentCleaner,
		    HtmlTextLines: HtmlTextLines,
		    CustomCleaner: CustomCleaner
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(965);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 965:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		// Imports ================================================================
		var kendo = window.kendo,
		    Class = kendo.Class,
		    editorNS = kendo.ui.editor,
		    RangeUtils = editorNS.RangeUtils,
		    dom = editorNS.Dom,
		    RestorePoint = editorNS.RestorePoint,
		    Marker = editorNS.Marker,
		    browser = kendo.support.browser,
		    br = '<br class="k-br">',
		    extend = $.extend;
		var nodeTypes = dom.nodeTypes;
		var PREVIOUS_SIBLING = "previousSibling";
	
		function selected(node, range) {
		    return range.startContainer === node && range.endContainer === node &&
		        range.startOffset === 0 && range.endOffset == node.childNodes.length;
		}
	
		function getSibling(node, direction, condition) {
		    var sibling = node ? node[direction] : null;
	
		    while (sibling && !condition(sibling)) {
		        sibling = sibling[direction];
		    }
	
		    return sibling;
		}
	
		var tableCells = "td,th,caption";
		var tableCellsWrappers = "table,tbody,thead,tfoot,tr";
		var tableElements = tableCellsWrappers + "," + tableCells;
		var inTable = function (range) { return !range.collapsed && $(range.commonAncestorContainer).is(tableCellsWrappers); };
	
		var RemoveTableContent = Class.extend({
		    remove: function(range) {
		        var that = this;
		        var marker = new Marker();
		        marker.add(range, false);
	
		        var nodes = RangeUtils.getAll(range, function (node) { return $(node).is(tableElements); });
		        var doc = RangeUtils.documentFromRange(range);
		        var start = marker.start;
		        var end = marker.end;
		        var cellsTypes = tableCells.split(",");
		        var startCell = dom.parentOfType(start, cellsTypes);
		        var endCell = dom.parentOfType(end, cellsTypes);
		        that._removeContent(start, startCell, true);
		        that._removeContent(end, endCell, false);
		        $(nodes).each(function(i, node) {
		            node = $(node);
		            (node.is(tableCells) ? node : node.find(tableCells)).each(function(j, cell) {
		                cell.innerHTML = "&#65279;";
		            });
		        });
		        if (startCell && !start.previousSibling) {
		            dom.insertBefore(doc.createTextNode("\ufeff"), start);
		        }
		        if (endCell && !end.nextSibling) {
		            dom.insertAfter(doc.createTextNode("\ufeff"), end);
		        }
		        if (startCell) {
		            range.setStartBefore(start);
		        } else if (nodes[0]) {
		            startCell = $(nodes[0]);
		            startCell = startCell.is(tableCells) ? startCell : startCell.find(tableCells).first();
		            if (startCell.length) {
		                range.setStart(startCell.get(0), 0);
		            }
		        }
	
		        range.collapse(true);
	
		        dom.remove(start);
		        dom.remove(end);
		    },
		    _removeContent: function (start, top, forwards) {
		        if (top) {
		            var sibling = forwards ? "nextSibling" : "previousSibling",
		                next,
		                getNext = function (node) {
		                    while (node && !node[sibling]) {
		                        node = node.parentNode;
		                    }
		                    return node && $.contains(top, node) ? node[sibling] : null;
		                };
		            start = getNext(start);
		            while (start) {
		                next = getNext(start);
		                dom.remove(start);
		                start = next;
		            }
		        }
		    }
		});
	
		var TypingHandler = Class.extend({
		    init: function(editor) {
		        this.editor = editor;
		    },
	
		    keydown: function (e) {
		        var that = this,
		            editor = that.editor,
		            keyboard = editor.keyboard,
		            isTypingKey = keyboard.isTypingKey(e),
		            evt = extend($.Event(), e);
	
		        that.editor.trigger("keydown", evt);
	
		        if (evt.isDefaultPrevented()) {
		            e.preventDefault();
		            return true;
		        }
	
		        if (!evt.isDefaultPrevented() && isTypingKey && !keyboard.isTypingInProgress()) {
		            var range = editor.getRange();
		            var body = editor.body;
		            that.startRestorePoint = new RestorePoint(range, body);
	
		            if (inTable(range)) {
		                var removeTableContent = new RemoveTableContent(editor);
		                removeTableContent.remove(range);
		                editor.selectRange(range);
		            }
	
		            if (browser.webkit && !range.collapsed && selected(body, range)) {
		                body.innerHTML = "";
		            }
	
		            if (editor.immutables && editorNS.Immutables.immutablesContext(range)) {
		                var backspaceHandler = new editorNS.BackspaceHandler(editor);
		                backspaceHandler.deleteSelection(range);
		            }
	
		            keyboard.startTyping(function () {
		                that.endRestorePoint = editorNS._finishUpdate(editor, that.startRestorePoint);
		            });
	
		            return true;
		        }
	
		        return false;
		    },
	
		    keyup: function (e) {
		        var keyboard = this.editor.keyboard;
	
		        this.editor.trigger("keyup", e);
	
		        if (keyboard.isTypingInProgress()) {
		            keyboard.endTyping();
		            return true;
		        }
	
		        return false;
		    }
		});
	
		var BackspaceHandler = Class.extend({
		    init: function(editor) {
		        this.editor = editor;
		    },
		    _addCaret: function(container) {
		        var caret = dom.create(this.editor.document, "a");
	
		        // Only if not Chrome: Make sure to include cared in the formatted inline node
		        if (!kendo.support.browser.chrome && container.firstChild &&
		            container.firstChild.nodeType === nodeTypes.ELEMENT_NODE) {
	
		            container = container.firstChild;
		        }
	
		        dom.insertAt(container, caret, 0);
		        dom.stripBomNode(caret.previousSibling);
		        dom.stripBomNode(caret.nextSibling);
		        return caret;
		    },
		    _restoreCaret: function(caret) {
		        var range = this.editor.createRange();
	
		        if (!caret.nextSibling && dom.isDataNode(caret.previousSibling)) {
		            range.setStart(caret.previousSibling, caret.previousSibling.length);
		        } else {
		            range.setStartAfter(caret);
		        }
	
		        range.collapse(true);
		        this.editor.selectRange(range);
		        dom.remove(caret);
		    },
		    _handleDelete: function(range) {
		        var node = range.endContainer;
		        var block = dom.closestEditableOfType(node, dom.blockElements);
	
		        if (block && editorNS.RangeUtils.isEndOf(range, block)) {
		            // join with next sibling
		            var next = dom.next(block);
		            if (!next || dom.name(next) != "p") {
		                return false;
		            }
	
		            var caret = this._addCaret(next);
	
		            this._merge(block, next);
	
		            this._restoreCaret(caret);
	
		            return true;
		        }
	
		        return false;
		    },
		    _cleanBomBefore: function(range) {
		        var offset = range.startOffset;
		        var node = range.startContainer;
		        var text = node.nodeValue;
		        var count = 0;
		        while (offset-count >= 0 && text[offset-count-1] == "\ufeff") {
		            count++;
		        }
	
		        if (count > 0) {
		            node.deleteData(offset-count, count);
	
		            range.setStart(node, Math.max(0, offset-count));
		            range.collapse(true);
	
		            this.editor.selectRange(range);
		        }
		    },
		    _handleBackspace: function(range) {
		        var node = range.startContainer;
		        var li = dom.closestEditableOfType(node, ['li']);
		        var block = dom.closestEditableOfType(node, 'p,h1,h2,h3,h4,h5,h6'.split(','));
		        var editor = this.editor;
		        var previousSibling;
	
		        if (dom.isDataNode(node)) {
		            if (range.collapsed && /^\s[\ufeff]+$/.test(node.nodeValue)) {
		                range.setStart(node, 0);
		                range.setEnd(node, node.length);
		                editor.selectRange(range);
		                return false;
		            }
		            this._cleanBomBefore(range);
		        }
	
		        previousSibling = getSibling(block, PREVIOUS_SIBLING, function(sibling) {
		            return !dom.htmlIndentSpace(sibling);
		        });
	
		        //deleting the first list item with empty content in IE results in invalid range
		        if (range.collapsed && range.startOffset !== range.endOffset && range.startOffset < 0) {
		            range.startOffset = 0;
		            range.endOffset = 0;
		            editor.selectRange(range);
		        }
	
		        var startAtLi = li && editorNS.RangeUtils.isStartOf(range, li);
		        var liIndex = li && $(li).index();
		        var startAtNonFirstLi = startAtLi && liIndex > 0;
		        if (startAtNonFirstLi) {
		            block = li;
		            previousSibling = dom.prev(li);
		        }
	
		        if(block && previousSibling && dom.is(previousSibling, 'table') && editorNS.RangeUtils.isStartOf(range, block)) {
		            if(block.innerText === ''){
		                block.innerHTML = '\ufeff';
		            }
		            return true;
		        }
		        // unwrap block
		        if ((block && previousSibling && editorNS.RangeUtils.isStartOf(range, block)) || startAtNonFirstLi) {
		            var caret = this._addCaret(block);
		            this._merge(previousSibling, block);
		            this._restoreCaret(caret);
	
		            return true;
		        }
	
		        // unwrap li element
		        if (startAtLi && liIndex === 0) {
		            var child = li.firstChild;
		            if (!child) {
		                li.innerHTML = editorNS.emptyElementContent;
		                child = li.firstChild;
		            }
	
		            var formatter = new editorNS.ListFormatter(dom.name(li.parentNode), "p");
		            range.selectNodeContents(li);
		            formatter.toggle(range);
	
		            if (dom.insignificant(child)) {
		                range.setStartBefore(child);
		            } else {
		                range.setStart(child, 0);
		            }
	
		            editor.selectRange(range);
	
		            return true;
		        }
	
		        var rangeStartNode = node.childNodes[range.startOffset - 1];
		        var linkRange = range;
		        var anchor = rangeStartNode && dom.closestEditableOfType(rangeStartNode, ['a']);
		        var previousNode = getSibling(rangeStartNode || node, PREVIOUS_SIBLING, function(sibling) {
		            return !dom.isDataNode(sibling) || (!dom.isBom(sibling) && sibling.length > 0);
		        });
		        if (anchor || ((range.startOffset === 0 || rangeStartNode) && dom.is(previousNode, "a"))) {
		            anchor = anchor || previousNode;
		            linkRange = editor.createRange();
		            linkRange.setStart(anchor, anchor.childNodes.length);
		            linkRange.collapse(true);
		        }
	
		        anchor = anchor || dom.closestEditableOfType(rangeStartNode || linkRange.startContainer, ['a']);
		        var isEndOfLink = anchor && editorNS.RangeUtils.isEndOf(linkRange, anchor);
		        if (isEndOfLink) {
		            var command = new editorNS.UnlinkCommand({ range: linkRange, body: editor.body, immutables: !!editor.immutables });
		            editor.execCommand(command);
		            editor._selectionChange();
		        }
		        return false;
		    },
		    _handleSelection: function(range) {
		        var ancestor = range.commonAncestorContainer;
		        var table = dom.closest(ancestor, "table");
		        var emptyParagraphContent = editorNS.emptyElementContent;
		        var editor = this.editor;
	
		        if (inTable(range)) {
		            var removeTableContent = new RemoveTableContent(editor);
		            removeTableContent.remove(range);
		            editor.selectRange(range);
		            return true;
		        }
	
		        var marker = new Marker();
		        marker.add(range, false);
	
		        if(range.commonAncestorContainer === editor.body) {
		            this._surroundFullyContent(marker, range);
		        }
	
		        if (editor.immutables) {
		            this._handleImmutables(marker);
		        }
	
		        this._surroundFullySelectedAnchor(marker, range);
	
		        range.setStartAfter(marker.start);
		        range.setEndBefore(marker.end);
	
		        var start = range.startContainer;
		        var end = range.endContainer;
	
		        range.deleteContents();
	
		        if (table && $(table).text() === "") {
		            range.selectNode(table);
		            range.deleteContents();
		        }
	
		        ancestor = range.commonAncestorContainer;
	
		        if (dom.name(ancestor) === "p" && ancestor.innerHTML === "") {
		            ancestor.innerHTML = emptyParagraphContent;
		            range.setStart(ancestor, 0);
		        }
	
		        this._join(start, end);
	
		        dom.insertAfter(editor.document.createTextNode("\ufeff"), marker.start);
		        marker.remove(range);
	
		        start = range.startContainer;
		        if (dom.name(start) == "tr") {
		            start = start.childNodes[Math.max(0, range.startOffset-1)];
		            range.setStart(start, dom.getNodeLength(start));
		        }
	
		        range.collapse(true);
	
		        editor.selectRange(range);
	
		        return true;
		    },
		    _handleImmutables: function (marker) {
		        var immutableParent = editorNS.Immutables.immutableParent;
		        var startImmutable = immutableParent(marker.start);
		        var endImmutable = immutableParent(marker.start);
		        if (startImmutable) {
		            dom.insertBefore(marker.start, startImmutable);
		        }
		        if (endImmutable) {
		            dom.insertAfter(marker.end, endImmutable);
		        }
		        if (startImmutable) {
		            dom.remove(startImmutable);
		        }
		        if (endImmutable && endImmutable.parentNode) {
		            dom.remove(endImmutable);
		        }
		    },
		    _surroundFullyContent: function(marker, range) {
		        var children = range.commonAncestorContainer.children,
		            startParent = children[0],
		            endParent = children[children.length - 1];
	
		        this._moveMarker(marker, range, startParent, endParent);
		    },
		    _surroundFullySelectedAnchor: function(marker, range) {
		        var start = marker.start,
		            startParent = $(start).closest("a").get(0),
		            end = marker.end,
		            endParent = $(end).closest("a").get(0);
	
		        this._moveMarker(marker, range, startParent, endParent);
		    },
		    _moveMarker: function(marker, range, startParent, endParent) {
		        var start = marker.start,
		            end = marker.end;
	
		        if(startParent && RangeUtils.isStartOf(range, startParent)){
		            dom.insertBefore(start, startParent);
		        }
	
		        if(endParent && RangeUtils.isEndOf(range, endParent)){
		            dom.insertAfter(end, endParent);
		        }
		    },
		    _root: function(node) {
		        while (node && dom.name(node) != "body" && node.parentNode && dom.name(node.parentNode) != "body") {
		            node = node.parentNode;
		        }
	
		        return node;
		    },
		    _join: function(start, end) {
		        start = this._root(start);
		        end = this._root(end);
	
		        if (start != end && dom.is(end, "p")) {
		            this._merge(start, end);
		        }
		    },
		    _merge: function(dest, src) {
		        dom.removeTrailingBreak(dest);
	
		        while (dest && src.firstChild) {
		            if (dest.nodeType == 1) {
		                dest = dom.list(dest) ? dest.children[dest.children.length - 1] : dest;
	
		                if (dest) {
		                    dest.appendChild(src.firstChild);
		                }
		            } else if (dest.nodeType === nodeTypes.TEXT_NODE) {
		                this._mergeWithTextNode(dest, src.firstChild);
		            } else {
		                dest.parentNode.appendChild(src.firstChild);
		            }
		        }
	
		        dom.remove(src);
		    },
	
		    _mergeWithTextNode: function(textNode, appendedNode) {
		        if (textNode && textNode.nodeType === nodeTypes.TEXT_NODE) {
		            if (textNode.nextSibling && this._isCaret(textNode.nextSibling)) {
		                dom.insertAfter(appendedNode, textNode.nextSibling);
		            }
		            else {
		                dom.insertAfter(appendedNode, textNode);
		            }
		        }
		    },
	
		    _isCaret: function(element) {
		        return $(element).is("a");
		    },
	
		    keydown: function(e) {
		        var method, startRestorePoint;
		        var editor = this.editor;
		        var range = editor.getRange();
		        var keyCode = e.keyCode;
		        var keys = kendo.keys;
		        var backspace = keyCode === keys.BACKSPACE;
		        var del = keyCode == keys.DELETE;
	
		        if (editor.immutables && editor.immutables.keydown(e, range)) {
		            return;
		        }
	
		        if ((backspace || del) && !range.collapsed) {
		            method = "_handleSelection";
		        } else if (backspace) {
		            method = "_handleBackspace";
		        } else if (del) {
		            method = "_handleDelete";
		        }
	
		        if (!method) {
		            return;
		        }
	
		        startRestorePoint = new RestorePoint(range, editor.body);
	
		        if (this[method](range)) {
		            e.preventDefault();
	
		            editorNS._finishUpdate(editor, startRestorePoint);
		        }
		    },
		    deleteSelection: function (range) {
		        this._handleSelection(range);
		    },
		    keyup: $.noop
		});
	
		var SystemHandler = Class.extend({
		    init: function(editor) {
		        this.editor = editor;
		        this.systemCommandIsInProgress = false;
		    },
	
		    createUndoCommand: function () {
		        this.startRestorePoint = this.endRestorePoint = editorNS._finishUpdate(this.editor, this.startRestorePoint);
		    },
	
		    changed: function () {
		        if (this.startRestorePoint) {
		            return this.startRestorePoint.html != this.editor.body.innerHTML;
		        }
	
		        return false;
		    },
	
		    keydown: function (e) {
		        var that = this,
		            editor = that.editor,
		            keyboard = editor.keyboard;
	
		        if (keyboard.isModifierKey(e)) {
	
		            if (keyboard.isTypingInProgress()) {
		                keyboard.endTyping(true);
		            }
	
		            that.startRestorePoint = new RestorePoint(editor.getRange(), editor.body);
		            return true;
		        }
	
		        if (keyboard.isSystem(e)) {
		            that.systemCommandIsInProgress = true;
	
		            if (that.changed()) {
		                that.systemCommandIsInProgress = false;
		                that.createUndoCommand();
		            }
	
		            return true;
		        }
	
		        return false;
		    },
	
		    keyup: function () {
		        var that = this;
	
		        if (that.systemCommandIsInProgress && that.changed()) {
		            that.systemCommandIsInProgress = false;
		            that.createUndoCommand();
		            return true;
		        }
	
		        return false;
		    }
		});
	
		var SelectAllHandler = Class.extend({
		    init: function(editor) {
		        this.editor = editor;
		    },
	
		    keydown: function (e) {
		        if (!browser.webkit || e.isDefaultPrevented() ||
		            !(e.ctrlKey && e.keyCode == 65 && !e.altKey && !e.shiftKey)) {
		            return;
		        }
		        if (this.editor.options.immutables) {
		            this._toSelectableImmutables();
		        }
		        this._selectEditorBody();
		    },
	
		    _selectEditorBody: function() {
		        var editor = this.editor;
		        var range = editor.getRange();
		        range.selectNodeContents(editor.body);
		        editor.selectRange(range);
		    },
	
		    _toSelectableImmutables: function() {
		        var editor = this.editor,
		            body = editor.body,
		            immutable = editorNS.Immutables.immutable,
		            emptyTextNode = dom.emptyTextNode,
		            first = body.firstChild,
		            last = body.lastChild;
	
		        while (emptyTextNode(first)){
		            first = first.nextSibling;
		        }
	
		        while (emptyTextNode(last)){
		            last = last.previousSibling;
		        }
	
		        if (first && immutable(first)) {
		            $(br).prependTo(body);
		        }
	
		        if (last && immutable(last)) {
		            $(br).appendTo(body);
		        }
		    },
	
		    keyup: $.noop
		});
	
		var Keyboard = Class.extend({
		    init: function(handlers) {
		        this.handlers = handlers;
		        this.typingInProgress = false;
		    },
	
		    isCharacter: function(keyCode) {
		        return (keyCode >= 48 && keyCode <= 90) || (keyCode >= 96 && keyCode <= 111) ||
		               (keyCode >= 186 && keyCode <= 192) || (keyCode >= 219 && keyCode <= 222) ||
		               keyCode == 229;
		    },
	
		    toolFromShortcut: function (tools, e) {
		        var key = String.fromCharCode(e.keyCode),
		            toolName,
		            toolOptions,
		            modifier = this._getShortcutModifier(e, navigator.platform);
	
		        for (toolName in tools) {
		            toolOptions = $.extend({ ctrl: false, alt: false, shift: false }, tools[toolName].options);
	
		            if ((toolOptions.key == key || toolOptions.key == e.keyCode) &&
		                toolOptions.ctrl == modifier &&
		                toolOptions.alt == e.altKey &&
		                toolOptions.shift == e.shiftKey) {
		                return toolName;
		            }
		        }
		    },
	
		    _getShortcutModifier: function (e, platform) {
		        var mac = platform.toUpperCase().indexOf('MAC') >= 0;
		        return mac ? e.metaKey : e.ctrlKey;
		    },
	
		    toolsFromShortcut: function (tools, e) {
		        var key = String.fromCharCode(e.keyCode),
		            toolName,
		            o,
		            matchesKey,
		            found = [];
		        var matchKey = function (toolKey) { return toolKey == key || toolKey == e.keyCode || toolKey == e.charCode; };
	
		        for (toolName in tools) {
		            o = $.extend({ ctrl: false, alt: false, shift: false }, tools[toolName].options);
	
		            matchesKey = $.isArray(o.key) ? $.grep(o.key, matchKey).length > 0 : matchKey(o.key);
		            if (matchesKey &&
		                o.ctrl == e.ctrlKey &&
		                o.alt == e.altKey &&
		                o.shift == e.shiftKey) {
		                found.push(tools[toolName]);
		            }
		        }
	
		        return found;
		    },
	
		    isTypingKey: function (e) {
		        var keyCode = e.keyCode;
		        return (this.isCharacter(keyCode) && !e.ctrlKey && !e.altKey) ||
		               keyCode == 32 || keyCode == 13 || keyCode == 8 ||
		               (keyCode == 46 && !e.shiftKey && !e.ctrlKey && !e.altKey);
		    },
	
		    isModifierKey: function (e) {
		        var keyCode = e.keyCode;
		        return (keyCode == 17 && !e.shiftKey && !e.altKey) ||
		               (keyCode == 16 && !e.ctrlKey && !e.altKey) ||
		               (keyCode == 18 && !e.ctrlKey && !e.shiftKey);
		    },
	
		    isSystem: function (e) {
		        return e.keyCode == 46 && e.ctrlKey && !e.altKey && !e.shiftKey;
		    },
	
		    startTyping: function (callback) {
		        this.onEndTyping = callback;
		        this.typingInProgress = true;
		    },
	
		    stopTyping: function() {
		        if (this.typingInProgress && this.onEndTyping) {
		            this.onEndTyping();
		        }
		        this.typingInProgress = false;
		    },
	
		    endTyping: function (force) {
		        var that = this;
		        that.clearTimeout();
		        if (force) {
		            that.stopTyping();
		        } else {
		            that.timeout = window.setTimeout($.proxy(that.stopTyping, that), 1000);
		        }
		    },
	
		    isTypingInProgress: function () {
		        return this.typingInProgress;
		    },
	
		    clearTimeout: function () {
		        window.clearTimeout(this.timeout);
		    },
	
		    notify: function(e, what) {
		        var i, handlers = this.handlers;
	
		        for (i = 0; i < handlers.length; i++) {
		            if (handlers[i][what](e)) {
		                break;
		            }
		        }
		    },
	
		    keydown: function (e) {
		        this.notify(e, 'keydown');
		    },
	
		    keyup: function (e) {
		        this.notify(e, 'keyup');
		    }
		});
	
		extend(editorNS, {
		    TypingHandler: TypingHandler,
		    SystemHandler: SystemHandler,
		    BackspaceHandler: BackspaceHandler,
		    SelectAllHandler: SelectAllHandler,
		    Keyboard: Keyboard
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(949);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 949:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        editorNS = kendo.ui.editor,
		        Command = editorNS.Command,
		        EditorUtils = editorNS.EditorUtils,
		        registerTool = EditorUtils.registerTool,
		        Tool = editorNS.Tool,
		        ToolTemplate = editorNS.ToolTemplate,
		        extend = $.extend;
	
		var ExportPdfCommand = Command.extend({
		    init: function(options) {
		        this.async = true;
		        Command.fn.init.call(this, options);
		    },
	
		    exec: function() {
		        var that = this;
		        var range = that.lockRange(true);
		        var editor = that.editor;
	
		        editor._destroyResizings();
	
		        editor.saveAsPDF().then(function() {
		            that.releaseRange(range);
		            editor._initializeColumnResizing();
		            editor._initializeRowResizing();
		            editor._initializeTableResizing();
		        });
		    }
		});
	
		extend(editorNS, {
		    ExportPdfCommand: ExportPdfCommand
		});
	
		registerTool("pdf", new Tool({ command: ExportPdfCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Export PDF"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(969);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 946:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(656);
	
	/***/ }),
	
	/***/ 969:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(946) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        editorNS = kendo.ui.editor,
		        Command = editorNS.Command,
		        EditorUtils = editorNS.EditorUtils,
		        registerTool = EditorUtils.registerTool,
		        Tool = editorNS.Tool,
		        ToolTemplate = editorNS.ToolTemplate,
		        extend = $.extend;
	
		var PrintCommand = Command.extend({
		    init: function(options) {
		        Command.fn.init.call(this, options);
	
		        this.managesUndoRedo = true;
		    },
	
		    exec: function() {
		        var editor = this.editor;
	
		        if (kendo.support.browser.msie) {
		            editor.document.execCommand("print", false, null);
		        } else if (editor.window.print) {
		            editor.window.print();
		        }
		    }
		});
	
		extend(editorNS, {
		    PrintCommand: PrintCommand
		});
	
		registerTool("print", new Tool({ command: PrintCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Print"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(974);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 974:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(948), __webpack_require__(975), __webpack_require__(976)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function(kendo, undefined) {
		    var global = window;
		    var math = global.Math;
		    var abs = math.abs;
	
		    var $ = kendo.jQuery;
		    var extend = $.extend;
	
		    var Editor = kendo.ui.editor;
		    var TableElementResizing = Editor.TableElementResizing;
		    var ResizingUtils = Editor.ResizingUtils;
		    var constrain = ResizingUtils.constrain;
		    var calculatePercentageRatio = ResizingUtils.calculatePercentageRatio;
		    var getScrollBarWidth = ResizingUtils.getScrollBarWidth;
		    var inPercentages = ResizingUtils.inPercentages;
		    var toPercentages = ResizingUtils.toPercentages;
		    var toPixels = ResizingUtils.toPixels;
		    var outerWidth = kendo._outerWidth;
	
		    var NS = ".kendoEditorColumnResizing";
		    var RESIZE_HANDLE_CLASS = "k-column-resize-handle";
		    var RESIZE_MARKER_CLASS = "k-column-resize-marker";
	
		    var BODY = "body";
		    var TBODY = "tbody";
		    var TD = "td";
		    var TH = "th";
		    var TR = "tr";
	
		    var COMMA = ",";
		    var WIDTH = "width";
	
		    var ColumnResizing = TableElementResizing.extend({
		        options: {
		            tags: [TD, TH],
		            min: 20,
		            rootElement: null,
		            eventNamespace: NS,
		            rtl: false,
		            handle: {
		                dataAttribute: "column",
		                width: 10,
		                height: 0,
		                classNames: {
		                    handle: RESIZE_HANDLE_CLASS,
		                    marker: RESIZE_MARKER_CLASS
		                },
		                template:
		                    '<div class="k-column-resize-handle-wrapper" unselectable="on" contenteditable="false">' +
		                        '<div class="' + RESIZE_HANDLE_CLASS + '">' +
		                            '<div class="' + RESIZE_MARKER_CLASS + '"></div>' +
		                        '</div>' +
		                    '</div>'
		            }
		        },
	
		        elementBorderHovered: function(column, e) {
		            var that = this;
		            var options = that.options;
		            var handleWidth = options.handle.width;
		            var borderOffset = column.offset().left + (options.rtl ? 0 : outerWidth(column));
	
	
		            var mousePosition = e.clientX + $(column[0].ownerDocument).scrollLeft();
	
		            if ((mousePosition > (borderOffset - handleWidth)) && (mousePosition < (borderOffset + handleWidth))) {
		                return true;
		            }
		            else {
		                return false;
		            }
		        },
	
		        setResizeHandlePosition: function(column) {
		            var that = this;
		            var tableBody = $(that.element).children(TBODY);
		            var options = that.options;
		            var rtl = options.rtl;
		            var handleWidth = options.handle.width;
		            var rootElement = $(options.rootElement);
		            var scrollTopOffset = rootElement.is(BODY) ? 0 : rootElement.scrollTop();
		            var scrollLeftOffset = rootElement.is(BODY) ? 0 : rootElement.scrollLeft();
		            var columnWidthOffset = rtl ? 0 : outerWidth(column);
		            var scrollBarWidth = rtl ? getScrollBarWidth(rootElement[0]) : 0;
		            var columnOffsetLeft = column.offset().left -
		                                    (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
		                                    parseFloat(column.css("marginLeft"));
		            var tBodyOffsetTop = tableBody.offset().top -
		                                    (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
		                                    parseFloat(tableBody.css("marginTop"));
	
		            that.resizeHandle.css({
		                top: tBodyOffsetTop + scrollTopOffset,
		                left: columnOffsetLeft + columnWidthOffset + (scrollLeftOffset - scrollBarWidth) - (handleWidth / 2),
		                position: "absolute"
		            });
		        },
	
		        setResizeHandleDimensions: function() {
		            var that = this;
		            var tableBody = $(that.element).children(TBODY);
	
		            that.resizeHandle.css({
		                width: that.options.handle.width,
		                height: tableBody.height()
		            });
		        },
	
		        setResizeHandleDragPosition: function(e) {
		            var that = this;
		            var column = $($(e.currentTarget).data(that.options.handle.dataAttribute));
		            var options = that.options;
		            var rootElement = $(options.rootElement);
		            var handleWidth = options.handle ? options.handle.width : 0;
		            var min = options.min;
		            var rtl = options.rtl;
		            var columnWidth = outerWidth(column);
		            var columnLeftOffset = column.offset().left -
		                                    (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
		                                    parseFloat(column.css("marginLeft"));
		            var adjacentColumnWidth = outerWidth(column.next());
		            var resizeHandle = $(that.resizeHandle);
		            var scrollLeftOffset = rootElement.is(BODY) ? 0 : rootElement.scrollLeft();
		            var scrollBarWidth = rtl ? getScrollBarWidth(rootElement[0]) : 0;
		            var resizeHandleOffsetLeft = resizeHandle.offset().left -
		                                            (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
		                                            parseFloat(resizeHandle.css("marginLeft"));
	
		            var handleOffset = constrain({
		                value: resizeHandleOffsetLeft + (scrollLeftOffset - scrollBarWidth) + e.x.delta,
		                min: columnLeftOffset + (scrollLeftOffset - scrollBarWidth) - (rtl ? adjacentColumnWidth : 0) + min,
		                max: columnLeftOffset + columnWidth + (scrollLeftOffset - scrollBarWidth) + (rtl ? 0 : adjacentColumnWidth) - handleWidth - min
		            });
	
		            resizeHandle.css({ left: handleOffset });
		        },
	
		        resize: function(e) {
		            var that = this;
		            var column = $($(e.currentTarget).data(that.options.handle.dataAttribute));
		            var options = that.options;
		            var rtlModifier = options.rtl ? (-1) : 1;
		            var min = options.min;
		            var initialDeltaX = rtlModifier * e.x.initialDelta;
		            var newWidth;
		            var initialAdjacentColumnWidth;
		            var initialColumnWidth;
	
		            that._setTableComputedWidth();
		            that._setColumnsComputedWidth();
	
		            initialColumnWidth = outerWidth(column);
		            initialAdjacentColumnWidth = outerWidth(column.next());
	
		            newWidth = constrain({
		                value: initialColumnWidth + initialDeltaX,
		                min: min,
		                max: initialColumnWidth + initialAdjacentColumnWidth - min
		            });
	
		            that._resizeColumn(column[0], newWidth);
		            that._resizeTopAndBottomColumns(column[0], newWidth);
		            that._resizeAdjacentColumns(column.index(), initialAdjacentColumnWidth, initialColumnWidth, (initialColumnWidth - newWidth));
		        },
	
		        _setTableComputedWidth: function() {
		            var element = this.element;
	
		            if (element.style[WIDTH] === "") {
		                element.style[WIDTH] = toPixels(outerWidth($(element)));
		            }
		        },
	
		        _setColumnsComputedWidth: function() {
		            var that = this;
		            var tableBody = $(that.element).children(TBODY);
		            var tableBodyWidth = outerWidth(tableBody);
		            var columns = tableBody.children(TR).children(TD);
		            var length = columns.length;
		            var currentColumnsWidths = columns.map(function() {
		                return outerWidth($(this));
		            });
		            var i;
	
		            for (i = 0; i < length; i++) {
		                if (inPercentages(columns[i].style[WIDTH])) {
		                    columns[i].style[WIDTH] = toPercentages(calculatePercentageRatio(currentColumnsWidths[i], tableBodyWidth));
		                }
		                else {
		                    columns[i].style[WIDTH] = toPixels(currentColumnsWidths[i]);
		                }
		            }
		        },
	
		        _resizeTopAndBottomColumns: function(column, newWidth) {
		            var that = this;
		            var columnIndex = $(column).index();
		            var topAndBottomColumns = $(that.element).children(TBODY).children(TR).children(that.options.tags.join(COMMA))
		                .filter(function() {
		                    var cell = this;
		                    return ($(cell).index() === columnIndex && cell !== column);
		                });
		            var length = topAndBottomColumns.length;
		            var i;
	
		            for (i = 0; i < length; i++) {
		                that._resizeColumn(topAndBottomColumns[i], newWidth);
		            }
		        },
	
		        _resizeColumn: function(column, newWidth) {
		            if (inPercentages(column.style[WIDTH])) {
		                column.style[WIDTH] = toPercentages(calculatePercentageRatio(newWidth, outerWidth($(this.element).children(TBODY))));
		            }
		            else {
		                column.style[WIDTH] = toPixels(newWidth);
		            }
		        },
	
		        _resizeAdjacentColumns: function(columnIndex, initialAdjacentColumnWidth, initialColumnWidth, deltaWidth) {
		            var that = this;
		            var adjacentColumns = $(that.element).children(TBODY).children(TR).children(that.options.tags.join(COMMA))
		                .filter(function() {
		                    return ($(this).index() === (columnIndex + 1));
		                });
		            var length = adjacentColumns.length;
		            var i;
	
		            for (i = 0; i < length; i++) {
		                that._resizeAdjacentColumn(adjacentColumns[i], initialAdjacentColumnWidth, initialColumnWidth, deltaWidth);
		            }
		        },
	
		        _resizeAdjacentColumn: function(adjacentColumn, initialAdjacentColumnWidth, initialColumnWidth, deltaWidth) {
		            var that = this;
		            var min = that.options.min;
		            var newWidth;
	
		            newWidth = constrain({
		                value: initialAdjacentColumnWidth + deltaWidth,
		                min: min,
		                max: abs(initialColumnWidth + initialAdjacentColumnWidth - min)
		            });
	
		            that._resizeColumn(adjacentColumn, newWidth);
		        }
		    });
	
		    ColumnResizing.create = function(editor) {
		        TableElementResizing.create(editor, {
		            name: "columnResizing",
		            type: ColumnResizing,
		            eventNamespace: NS
		        });
		    };
	
		    ColumnResizing.dispose = function(editor) {
		        TableElementResizing.dispose(editor, {
		            eventNamespace: NS
		        });
		    };
	
		    extend(Editor, {
		        ColumnResizing: ColumnResizing
		    });
	
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 975:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(684);
	
	/***/ }),
	
	/***/ 976:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(685);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(977);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 977:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(948)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function(kendo, undefined) {
		    var global = window;
		    var math = global.Math;
		    var min = math.min;
		    var max = math.max;
		    var parseFloat = global.parseFloat;
	
		    var $ = kendo.jQuery;
		    var extend = $.extend;
	
		    var Editor = kendo.ui.editor;
	
		    var PERCENTAGE = "%";
		    var PIXEL = "px";
		    var REGEX_NUMBER_IN_PERCENTAGES = /(\d+)(\.?)(\d*)%/;
		    var REGEX_NUMBER_IN_PIXELS = /(\d+)(\.?)(\d*)px/;
		    var STRING = "string";
	
		    function constrain(options) {
		        var value = options.value;
		        var lowerBound = options.min;
		        var upperBound = options.max;
	
		        return max(min(parseFloat(value), parseFloat(upperBound)), parseFloat(lowerBound));
		    }
	
		    function getScrollBarWidth(element) {
		        if  (element && !$(element).is("body") && element.scrollHeight > element.clientHeight) {
		            return kendo.support.scrollbar();
		        }
	
		        return 0;
		    }
	
		    function calculatePercentageRatio(value, total) {
		        if (inPercentages(value)) {
		            return parseFloat(value);
		        }
		        else {
		            return ((parseFloat(value) / total) * 100);
		        }
		    }
	
		    function inPercentages(value) {
		        return (typeof(value) === STRING && REGEX_NUMBER_IN_PERCENTAGES.test(value));
		    }
	
		    function inPixels(value) {
		        return (typeof(value) === STRING && REGEX_NUMBER_IN_PIXELS.test(value));
		    }
	
		    function toPercentages(value) {
		        return (parseFloat(value) + PERCENTAGE);
		    }
	
		    function toPixels(value) {
		        return (parseFloat(value) + PIXEL);
		    }
	
		    var ResizingUtils = {
		        constrain: constrain,
		        getScrollBarWidth: getScrollBarWidth,
		        calculatePercentageRatio: calculatePercentageRatio,
		        inPercentages: inPercentages,
		        inPixels: inPixels,
		        toPercentages: toPercentages,
		        toPixels: toPixels
		    };
	
		    extend(Editor, {
		        ResizingUtils: ResizingUtils
		    });
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(979);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 975:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(684);
	
	/***/ }),
	
	/***/ 979:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(948), __webpack_require__(980), __webpack_require__(975)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function(kendo, undefined) {
		    var $ = kendo.jQuery;
		    var extend = $.extend;
		    var noop = $.noop;
		    var proxy = $.proxy;
	
		    var Editor = kendo.ui.editor;
		    var Class = kendo.Class;
	
		    var KEY_DOWN = "keydown";
		    var MOUSE_DOWN = "mousedown";
		    var MOUSE_ENTER = "mouseenter";
		    var MOUSE_LEAVE = "mouseleave";
		    var MOUSE_MOVE = "mousemove";
		    var MOUSE_UP = "mouseup";
	
		    var COMMA = ",";
		    var DOT = ".";
		    var LAST_CHILD = ":last-child";
	
		    var TABLE = "table";
	
		    var TableElementResizing = Class.extend({
		        init: function(element, options) {
		            var that = this;
	
		            that.options = extend({}, that.options, options);
	
		            that.options.tags = $.isArray(that.options.tags) ? that.options.tags : [that.options.tags];
	
		            if ($(element).is(TABLE)) {
		                that.element = element;
		                that._attachEventHandlers();
		            }
		        },
	
		        destroy: function() {
		            var that = this;
		            var eventNamespace = that.options.eventNamespace;
	
		            if (that.element) {
		                $(that.element).off(eventNamespace);
		                that.element = null;
		            }
	
		            $(that.options.rootElement).off(KEY_DOWN + eventNamespace);
	
		            that._destroyResizeHandle();
		        },
	
		        options: {
		            tags: [],
		            min: 0,
		            rootElement: null,
		            eventNamespace: "",
		            rtl: false,
		            handle: {
		                dataAttribute: "",
		                height: 0,
		                width: 0,
		                classNames: {},
		                template: ""
		            }
		        },
	
		        _attachEventHandlers: function() {
		            var that = this;
		            var options = that.options;
	
		            $(that.element).on(MOUSE_MOVE + options.eventNamespace, options.tags.join(COMMA), proxy(that.detectElementBorderHovering, that));
		        },
	
		        resizingInProgress: function() {
		            var that = this;
		            var resizable = that._resizable;
	
		            if (resizable) {
		                return !!resizable.resizing;
		            }
	
		            return false;
		        },
	
		        resize: noop,
	
		        detectElementBorderHovering: function(e) {
		            var that = this;
		            var options = that.options;
		            var handleOptions = options.handle;
		            var tableElement = $(e.currentTarget);
		            var resizeHandle = that.resizeHandle;
		            var dataAttribute = handleOptions.dataAttribute;
	
		            if (!that.resizingInProgress()) {
		                if (!tableElement.is(LAST_CHILD) && that.elementBorderHovered(tableElement, e)) {
		                    if (resizeHandle) {
		                        if (resizeHandle.data(dataAttribute) && resizeHandle.data(dataAttribute) !== tableElement[0]) {
		                            that.showResizeHandle(tableElement, e);
		                        }
		                    }
		                    else {
		                        that.showResizeHandle(tableElement, e);
		                    }
		                }
		                else {
		                    if (resizeHandle) {
		                        that._destroyResizeHandle();
		                    }
		                }
		            }
		        },
	
		        elementBorderHovered: noop,
	
		        showResizeHandle: function(tableElement, e) {
		            var that = this;
	
		            if (e.buttons !== 0) {
		                //prevent showing when a mouse button is still being pressed
		                return;
		            }
	
		            that._initResizeHandle();
		            that.setResizeHandlePosition(tableElement);
		            that.setResizeHandleDimensions();
		            that.setResizeHandleDataAttributes(tableElement[0]);
		            that._attachResizeHandleEventHandlers();
	
		            that._initResizable(tableElement);
	
		            that._hideResizeMarker();
		            that.resizeHandle.show();
		        },
	
		        _initResizeHandle: function() {
		            var that = this;
		            var options = that.options;
	
		            that._destroyResizeHandle();
	
		            that.resizeHandle = $(options.handle.template).appendTo(options.rootElement);
		        },
	
		        setResizeHandlePosition: noop,
	
		        setResizeHandleDimensions: noop,
	
		        setResizeHandleDataAttributes: function(tableElement) {
		            var that = this;
	
		            that.resizeHandle.data(that.options.handle.dataAttribute, tableElement);
		        },
	
		        _attachResizeHandleEventHandlers: function() {
		            var that = this;
		            var options = that.options;
		            var eventNamespace = options.eventNamespace;
		            var markerClass = options.handle.classNames.marker;
		            var resizeHandle = that.resizeHandle;
	
		            that.resizeHandle
		                .on(MOUSE_DOWN + eventNamespace, function() {
		                    resizeHandle.find(DOT + markerClass).show();
		                })
		                .on(MOUSE_UP + eventNamespace, function() {
		                    resizeHandle.find(DOT + markerClass).hide();
		                });
		        },
	
		        _hideResizeMarker: function() {
		            var that = this;
	
		            that.resizeHandle.find(DOT + that.options.handle.classNames.marker).hide();
		        },
	
		        _destroyResizeHandle: function() {
		            var that = this;
	
		            if (that.resizeHandle) {
		                that._destroyResizable();
		                that.resizeHandle.off(that.options.eventNamespace).remove();
		                that.resizeHandle = null;
		            }
		        },
	
		        _initResizable: function(tableElement) {
		            var that = this;
	
		            if (!that.resizeHandle) {
		                return;
		            }
	
		            that._destroyResizable();
	
		            that._resizable = new kendo.ui.Resizable(tableElement, {
		                draggableElement: that.resizeHandle[0],
		                start: proxy(that.onResizeStart, that),
		                resize: proxy(that.onResize, that),
		                resizeend: proxy(that.onResizeEnd, that)
		            });
		        },
	
		        _destroyResizable: function() {
		            var that = this;
	
		            if (that._resizable) {
		                that._resizable.destroy();
		                that._resizable = null;
		            }
		        },
	
		        onResizeStart: function() {
		            this._disableKeyboard();
		        },
	
		        onResize: function(e) {
		            this.setResizeHandleDragPosition(e);
		        },
	
		        setResizeHandleDragPosition: noop,
	
		        onResizeEnd: function(e) {
		            var that = this;
	
		            that.resize(e);
		            that._destroyResizeHandle();
		            that._enableKeyboard();
		        },
	
		        _enableKeyboard: function() {
		            var options = this.options;
	
		            $(options.rootElement).off(KEY_DOWN + options.eventNamespace);
		        },
	
		        _disableKeyboard: function() {
		            var options = this.options;
	
		            $(options.rootElement).on(KEY_DOWN + options.eventNamespace, function(e) {
		                e.preventDefault();
		            });
		        },
	
		        _forceResizing: function(e) {
		            var resizable = this._resizable;
	
		            if (resizable && resizable.userEvents) {
		                resizable.userEvents._end(e);
		            }
		        }
		    });
	
		    var ResizingFactory = Class.extend({
		        create: function(editor, options) {
		            var that = this;
		            var resizingName = options.name;
		            var NS = options.eventNamespace;
	
		            $(editor.body)
		                .on(MOUSE_ENTER + NS, TABLE, function(e) {
		                    var table = e.currentTarget;
		                    var resizing = editor[resizingName];
	
		                    e.stopPropagation();
	
		                    if (resizing) {
		                        if (resizing.element !== table && !resizing.resizingInProgress()) {
		                            that._destroyResizing(editor, options);
		                            that._initResizing(editor, table, options);
		                        }
		                    }
		                    else {
		                        that._initResizing(editor, table, options);
		                    }
		                })
		                .on(MOUSE_LEAVE + NS, TABLE, function(e) {
		                    var parentTable;
		                    var resizing = editor[resizingName];
	
		                    e.stopPropagation();
	
		                    if (resizing && !resizing.resizingInProgress() && !resizing.resizeHandle) {
		                        parentTable = $(resizing.element).parents(TABLE)[0];
	
		                        if (parentTable) {
		                            that._destroyResizing(editor, options);
		                            that._initResizing(editor, parentTable, options);
		                        }
		                    }
		                })
		                .on(MOUSE_LEAVE + NS, function() {
		                    var resizing = editor[resizingName];
	
		                    if (resizing && !resizing.resizingInProgress()) {
		                        that._destroyResizing(editor, options);
		                    }
		                })
		                .on(MOUSE_UP + NS, function(e) {
		                    var resizing = editor[resizingName];
		                    var parentTable;
	
		                    if (resizing && resizing.resizingInProgress()) {
		                        parentTable = $(e.target).parents(TABLE)[0];
	
		                        if (parentTable) {
		                            resizing._forceResizing(e);
		                            that._destroyResizing(editor, options);
		                            that._initResizing(editor, parentTable, options);
		                        }
		                    }
		                });
		        },
	
		        dispose: function(editor, options) {
		            $(editor.body).off(options.eventNamespace);
		        },
	
		        _initResizing: function(editor, tableElement, options) {
		            var resizingName = options.name;
		            var resizingType = options.type;
	
		            editor[resizingName] = new resizingType(tableElement, {
		                rtl: kendo.support.isRtl(editor.element),
		                rootElement: editor.body
		            });
		        },
	
		        _destroyResizing: function(editor, options) {
		            var resizingName = options.name;
	
		            if (editor[resizingName]) {
		                editor[resizingName].destroy();
		                editor[resizingName] = null;
		            }
		        }
		    });
		    ResizingFactory.current = new ResizingFactory();
	
		    TableElementResizing.create = function(editor, options) {
		        ResizingFactory.current.create(editor, options);
		    };
	
		    TableElementResizing.dispose = function(editor, options) {
		        ResizingFactory.current.dispose(editor, options);
		    };
	
		    extend(Editor, {
		        TableElementResizing: TableElementResizing
		    });
	
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 980:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(593);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(978);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 975:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(684);
	
	/***/ }),
	
	/***/ 976:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(685);
	
	/***/ }),
	
	/***/ 978:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(948), __webpack_require__(975), __webpack_require__(976)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function(kendo, undefined) {
		    var math = window.Math;
		    var abs = math.abs;
	
		    var $ = kendo.jQuery;
		    var extend = $.extend;
	
		    var Editor = kendo.ui.editor;
		    var TableElementResizing = Editor.TableElementResizing;
		    var ResizingUtils = Editor.ResizingUtils;
		    var getScrollBarWidth = ResizingUtils.getScrollBarWidth;
		    var constrain = ResizingUtils.constrain;
		    var calculatePercentageRatio = ResizingUtils.calculatePercentageRatio;
		    var inPercentages = ResizingUtils.inPercentages;
		    var toPercentages = ResizingUtils.toPercentages;
		    var toPixels = ResizingUtils.toPixels;
		    var outerHeight = kendo._outerHeight;
	
		    var NS = ".kendoEditorRowResizing";
		    var RESIZE_HANDLE_CLASS = "k-row-resize-handle";
		    var RESIZE_HANDLE_MARKER_WRAPPER_CLASS = "k-row-resize-marker-wrapper";
		    var RESIZE_MARKER_CLASS = "k-row-resize-marker";
	
		    var BODY = "body";
		    var TR = "tr";
		    var TBODY = "tbody";
	
		    var HEIGHT = "height";
	
		    var RowResizing = TableElementResizing.extend({
		        options: {
		            tags: [TR],
		            min: 20,
		            rootElement: null,
		            eventNamespace: NS,
		            rtl: false,
		            handle: {
		                dataAttribute: "row",
		                width: 0,
		                height: 10,
		                classNames: {
		                    handle: RESIZE_HANDLE_CLASS,
		                    marker: RESIZE_MARKER_CLASS
		                },
		                template:
		                    '<div class="k-row-resize-handle-wrapper" unselectable="on" contenteditable="false">' +
		                        '<div class="' + RESIZE_HANDLE_CLASS + '">' +
		                            '<div class="' + RESIZE_HANDLE_MARKER_WRAPPER_CLASS + '">' +
		                                '<div class="' + RESIZE_MARKER_CLASS + '"></div>' +
		                            '</div>'+
		                        '</div>' +
		                    '</div>'
		            }
		        },
	
		        elementBorderHovered: function(tableElement, e) {
		            var that = this;
		            var handleHeight = that.options.handle[HEIGHT];
		            var borderOffset = tableElement.offset().top + outerHeight(tableElement);
		            var mousePosition = e.clientY + $(tableElement[0].ownerDocument).scrollTop();
	
		            if ((mousePosition > (borderOffset - handleHeight)) && (mousePosition < (borderOffset + handleHeight))) {
		                return true;
		            }
		            else {
		                return false;
		            }
		        },
	
		        setResizeHandlePosition: function(row) {
		            var that = this;
		            var options = that.options;
		            var handleHeight = options.handle[HEIGHT];
		            var rootElement = $(options.rootElement);
		            var scrollTopOffset = rootElement.is(BODY) ? 0 : rootElement.scrollTop();
		            var scrollLeftOffset = rootElement.is(BODY) ? 0 : rootElement.scrollLeft();
		            var scrollBarWidth = options.rtl ? getScrollBarWidth(rootElement[0]) : 0;
	
		            var rowOffsetLeft = row.offset().left -
		                                    (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
		                                    parseFloat(row.css("marginLeft"));
		            var rowOffsetTop = row.offset().top -
		                                    (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
		                                    parseFloat(row.css("marginTop"));
	
		            that.resizeHandle.css({
		                top: rowOffsetTop + outerHeight(row) + scrollTopOffset - (handleHeight / 2),
		                left: rowOffsetLeft + (scrollLeftOffset - scrollBarWidth),
		                position: "absolute"
		            });
		        },
	
		        setResizeHandleDimensions: function() {
		            var that = this;
	
		            that.resizeHandle.css({
		                width: $(that.element).children(TBODY).width(),
		                height: that.options.handle[HEIGHT]
		            });
		        },
	
		        setResizeHandleDragPosition: function(e) {
		            var that = this;
		            var options = that.options;
		            var min = options.min;
		            var tableBody =  $(that.element).children(TBODY);
		            var resizeHandle = $(that.resizeHandle);
		            var row = $(e.currentTarget).data(options.handle.dataAttribute);
		            var $row = $(row);
		            var rootElement = $(options.rootElement);
		            var scrollTopOffset = rootElement.is(BODY) ? 0 : rootElement.scrollTop();
		            var tableBodyTopOffset = tableBody.offset().top -
		                                    (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
		                                    parseFloat(tableBody.css("marginTop"));
	
		            var rowOffsetTop = $row.offset().top -
		                                (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
		                                parseFloat($row.css("marginTop"));
	
		            var resizeHandleOffsetTop = resizeHandle.offset().top -
		                                (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
		                                parseFloat(resizeHandle.css("marginTop"));
	
		            var handleOffset = constrain({
		                value: resizeHandleOffsetTop + scrollTopOffset + e.y.delta,
		                min: rowOffsetTop + scrollTopOffset + min,
		                max: tableBodyTopOffset + outerHeight(tableBody) + scrollTopOffset - options.handle[HEIGHT] - min
		            });
	
		            resizeHandle.css({ top: handleOffset });
		        },
	
		        resize: function(e) {
		            var that = this;
		            var options = that.options;
		            var row = $(e.currentTarget).data(options.handle.dataAttribute);
		            var currentRowHeight = outerHeight($(row));
		            var element = $(that.element);
		            var initialTableHeight = outerHeight(element);
		            var tableBody = element.children(TBODY);
		            var tableBodyHeight = tableBody.height();
		            var initialStyleHeight = row.style[HEIGHT];
		            var newRowHeight = constrain({
		                value: currentRowHeight + e.y.initialDelta,
		                min: options.min,
		                max: abs(tableBodyHeight - options.min)
		            });
	
		            that._setRowsHeightInPixels();
		            row.style[HEIGHT] = toPixels(newRowHeight);
		            that._setTableHeight(initialTableHeight + (newRowHeight - currentRowHeight));
	
		            if (inPercentages(initialStyleHeight)) {
		                //resize rows in percentages as late as possible to prevent incorrect precision calculations
		                that._setRowsHeightInPercentages();
		            }
		        },
	
		        _setRowsHeightInPixels: function() {
		            var that = this;
		            var rows = $(that.element).children(TBODY).children(TR);
		            var length = rows.length;
		            var currentRowsHeights = rows.map(function() {
		                return outerHeight($(this));
		            });
		            var i;
	
		            for (i = 0; i < length; i++) {
		                rows[i].style[HEIGHT] = toPixels(currentRowsHeights[i]);
		            }
		        },
	
		        _setRowsHeightInPercentages: function() {
		            var that = this;
		            var tableBody = $(that.element).children(TBODY);
		            var tableBodyHeight = tableBody.height();
		            var rows = tableBody.children(TR);
		            var length = rows.length;
		            var currentRowsHeights = rows.map(function() {
		                return outerHeight($(this));
		            });
		            var i;
	
		            for (i = 0; i < length; i++) {
		                rows[i].style[HEIGHT] = toPercentages(calculatePercentageRatio(currentRowsHeights[i], tableBodyHeight));
		            }
		        },
	
		        _setTableHeight: function(newHeight) {
		            var element = this.element;
	
		            if (inPercentages(element.style[HEIGHT])) {
		                element.style[HEIGHT] = toPercentages(calculatePercentageRatio(newHeight, $(element).parent().height()));
		            }
		            else {
		                element.style[HEIGHT] = toPixels(newHeight);
		            }
		        }
		    });
	
		    RowResizing.create = function(editor) {
		        TableElementResizing.create(editor, {
		            name: "rowResizing",
		            type: RowResizing,
		            eventNamespace: NS
		        });
		    };
	
		    RowResizing.dispose = function(editor) {
		        TableElementResizing.dispose(editor, {
		            eventNamespace: NS
		        });
		    };
	
		    extend(Editor, {
		        RowResizing: RowResizing
		    });
	
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(982);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 975:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(684);
	
	/***/ }),
	
	/***/ 982:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(948), __webpack_require__(983), __webpack_require__(975)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function(kendo, undefined) {
		    var global = window;
		    var math = global.Math;
		    var min = math.min;
		    var max = math.max;
	
		    var $ = kendo.jQuery;
		    var contains = $.contains;
		    var extend = $.extend;
		    var proxy = $.proxy;
	
		    var browser = kendo.support.browser;
		    var Editor = kendo.ui.editor;
		    var Class = kendo.Class;
		    var TableResizeHandle = Editor.TableResizeHandle;
		    var ResizingUtils = Editor.ResizingUtils;
		    var calculatePercentageRatio = ResizingUtils.calculatePercentageRatio;
		    var constrain = ResizingUtils.constrain;
		    var inPercentages = ResizingUtils.inPercentages;
		    var inPixels = ResizingUtils.inPixels;
		    var toPercentages = ResizingUtils.toPercentages;
		    var toPixels = ResizingUtils.toPixels;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
	
		    var NS = ".kendoEditorTableResizing";
		    var RESIZE_HANDLE_WRAPPER_CLASS = "k-table-resize-handle-wrapper";
		    var TABLE_CLASS = "k-table";
		    var TABLE_RESIZING_CLASS = "k-table-resizing";
	
		    var DRAG_START = "dragStart";
		    var DRAG = "drag";
		    var DRAG_END = "dragEnd";
		    var KEY_DOWN = "keydown";
		    var MOUSE_DOWN = "mousedown";
		    var MOUSE_OVER = "mouseover";
		    var MOUSE_OUT = "mouseout";
	
		    var COLUMN = "td";
		    var ROW = "tr";
		    var TBODY = "tbody";
		    var TABLE = "table";
	
		    var WIDTH = "width";
		    var HEIGHT = "height";
	
		    var EAST = "east";
		    var NORTH = "north";
		    var NORTHEAST = "northeast";
		    var NORTHWEST = "northwest";
		    var SOUTH = "south";
		    var SOUTHEAST = "southeast";
		    var SOUTHWEST = "southwest";
		    var WEST = "west";
	
		    var DOT = ".";
	
		    function isUndefined(value) {
		        return typeof(value) === "undefined";
		    }
	
		    var TableResizing = Class.extend({
		        init: function(element, options) {
		            var that = this;
	
		            that.options = extend({}, that.options, options);
		            that.handles = [];
	
		            if ($(element).is(TABLE)) {
		                that.element = element;
		            }
		        },
	
		        destroy: function() {
		            var that = this;
	
		            $(that.element).off(NS);
		            that.element = null;
	
		            $(that.options.rootElement).off(KEY_DOWN + NS);
	
		            that._destroyResizeHandles();
		        },
	
		        options: {
		            appendHandlesTo: null,
		            rtl: false,
		            rootElement: null,
		            minWidth: 10,
		            minHeight: 10,
		            handles: [{
		                direction: NORTHWEST
		            }, {
		                direction: NORTH
		            }, {
		                direction: NORTHEAST
		            }, {
		                direction: EAST
		            }, {
		                direction: SOUTHEAST
		            }, {
		                direction: SOUTH
		            }, {
		                direction: SOUTHWEST
		            }, {
		                direction: WEST
		            }]
		        },
	
		        resize: function(args) {
		            var that = this;
		            var deltas = extend({}, {
		                deltaX: 0,
		                deltaY: 0,
		                initialDeltaX: 0,
		                initialDeltaY: 0
		            }, args);
	
		            that._resizeWidth(deltas.deltaX, deltas.initialDeltaX);
		            that._resizeHeight(deltas.deltaY, deltas.initialDeltaY);
	
		            that.showResizeHandles();
		        },
	
		        _resizeWidth: function(delta, initialDelta) {
		            var that = this;
		            var element = $(that.element);
		            var styleWidth = element[0].style[WIDTH];
		            var currentWidth = outerWidth(element);
		            var parentWidth = element.parent().width();
		            var maxWidth = that._getMaxDimensionValue(WIDTH);
		            var newWidth;
		            var ratioValue;
		            var ratioTotalValue;
		            var constrainedWidth;
	
		            if (delta === 0) {
		                return;
		            }
	
		            if (isUndefined(that._initialElementWidth)) {
		                that._initialElementWidth = currentWidth;
		            }
	
		            //use initial delta instead of delta as changing the width with a small value (e.g. 1px)
		            //on each drag does not work due to browser calculation of computed styles
		            constrainedWidth = constrain({
		                value: that._initialElementWidth + initialDelta,
		                min: that.options.minWidth,
		                max: maxWidth
		            });
	
		            if (inPercentages(styleWidth)) {
		                //detect resizing greater than 100%
		                if (currentWidth + delta > parentWidth) {
		                    ratioValue = max(constrainedWidth, parentWidth);
		                    ratioTotalValue = min(constrainedWidth, parentWidth);
		                }
		                else {
		                    ratioValue = min(constrainedWidth, parentWidth);
		                    ratioTotalValue = max(constrainedWidth, parentWidth);
		                }
	
		                newWidth = toPercentages(calculatePercentageRatio(ratioValue, ratioTotalValue));
		            }
		            else {
		                newWidth = toPixels(constrainedWidth);
		            }
	
		            that._setColumnsWidth();
	
		            element[0].style[WIDTH] = newWidth;
		        },
	
		        _resizeHeight: function(delta, initialDelta) {
		            var that = this;
		            var element = $(that.element);
		            var styleHeight = element[0].style[HEIGHT];
		            var currentHeight = outerHeight(element);
		            var parent = element.parent();
		            var parentHeight = parent.height();
		            var maxHeight = that._getMaxDimensionValue(HEIGHT);
		            var newHeight;
		            var ratioValue;
		            var ratioTotalValue;
		            var constrainedHeight;
		            var minHeight = that.options.minHeight;
		            var hasRowsInPixels = that._hasRowsInPixels();
	
		            if (delta === 0) {
		                return;
		            }
	
		            if (isUndefined(that._initialElementHeight)) {
		                that._initialElementHeight = currentHeight;
		            }
	
		            //use initial delta instead of delta as changing the height with a small value (e.g. 1px)
		            //on each drag does not work due to browser calculation of computed styles
		            constrainedHeight = constrain({
		                value: that._initialElementHeight + initialDelta,
		                min: minHeight,
		                max: maxHeight
		            });
	
		            if (hasRowsInPixels && delta < 0) {
		                //decreasing table height when rows are sized in pixels is not possible
		                that._setRowsHeightInPercentages();
		            }
	
		            if (inPercentages(styleHeight)) {
		                //detect resizing greater than 100%
		                if (currentHeight + delta > parentHeight) {
		                    ratioValue = max(constrainedHeight, parentHeight);
		                    ratioTotalValue = min(constrainedHeight, parentHeight);
		                }
		                else {
		                    ratioValue = min(constrainedHeight, parentHeight);
		                    ratioTotalValue = max(constrainedHeight, parentHeight);
		                }
	
		                newHeight = toPercentages(calculatePercentageRatio(ratioValue, ratioTotalValue));
		            }
		            else {
		                newHeight = toPixels(constrainedHeight);
		            }
	
		            element[0].style[HEIGHT] = newHeight;
	
		            if (hasRowsInPixels && delta < 0) {
		                //restore original rows height unit
		                that._setRowsHeightInPixels();
		            }
		        },
	
		        _getMaxDimensionValue: function(dimension) {
		            var that = this;
		            var element = $(that.element);
		            var dimensionLowercase = dimension.toLowerCase();
		            var rtlModifier = that.options.rtl ? (-1) : 1;
		            var parent = $(that.element).parent();
		            var parentElement = parent[0];
		            var parentDimension = parent[dimensionLowercase]();
		            var parentScrollOffset = rtlModifier * (dimension === WIDTH ? parent.scrollLeft() : parent.scrollTop());
	
		            if (parentElement === element.closest(COLUMN)[0]) {
		                if (parentElement.style[dimensionLowercase] === "" && !inPercentages(that.element.style[dimensionLowercase])) {
		                    return Infinity;
		                }
		                else {
		                    return (parentDimension + parentScrollOffset);
		                }
		            }
		            else {
		                return (parentDimension + parentScrollOffset);
		            }
		        },
	
		        _setColumnsWidth: function() {
		            var that = this;
		            var element = $(that.element);
		            var parentElement = element.parent()[0];
		            var parentColumn = element.closest(COLUMN);
		            var columns = parentColumn.closest(ROW).children();
		            var columnsLength = columns.length;
		            var i;
	
		            function isWidthInPercentages(element) {
		                var styleWidth = element.style.width;
	
		                if (styleWidth !== "") {
		                    return inPercentages(styleWidth) ? true : false;
		                }
		                else {
		                    return $(element).hasClass(TABLE_CLASS) ? true : false;
		                }
		            }
	
		            if (isWidthInPercentages(element[0]) && parentElement === parentColumn[0] && parentElement.style[WIDTH] === "") {
		                for (i = 0; i < columnsLength; i++) {
		                    columns[i].style[WIDTH] = toPixels($(columns[i]).width());
		                }
		            }
		        },
	
		        _hasRowsInPixels: function() {
		            var that = this;
		            var rows = $(that.element).children(TBODY).children(ROW);
	
		            for (var i = 0; i < rows.length; i++) {
		                if (rows[i].style.height === "" || inPixels(rows[i].style.height)) {
		                    return true;
		                }
		            }
	
		            return false;
		        },
	
		        _setRowsHeightInPercentages: function() {
		            var that = this;
		            var tableBody = $(that.element).children(TBODY);
		            var tableBodyHeight = tableBody.height();
		            var rows = tableBody.children(ROW);
		            var length = rows.length;
		            var currentRowsHeights = rows.map(function() {
		                return outerHeight($(this));
		            });
		            var i;
	
		            for (i = 0; i < length; i++) {
		                rows[i].style[HEIGHT] = toPercentages(calculatePercentageRatio(currentRowsHeights[i], tableBodyHeight));
		            }
		        },
	
		        _setRowsHeightInPixels: function() {
		            var that = this;
		            var rows = $(that.element).children(TBODY).children(ROW);
		            var length = rows.length;
		            var currentRowsHeights = rows.map(function() {
		                return outerHeight($(this));
		            });
		            var i;
	
		            for (i = 0; i < length; i++) {
		                rows[i].style[HEIGHT] = toPixels(currentRowsHeights[i]);
		            }
		        },
	
		        showResizeHandles: function() {
		            var that = this;
	
		            that._initResizeHandles();
		            that._showResizeHandles();
		        },
	
		        _initResizeHandles: function() {
		            var that = this;
		            var handles = that.handles;
		            var options = that.options;
		            var handleOptions = that.options.handles;
		            var length = handleOptions.length;
		            var i;
	
		            if (handles && handles.length > 0) {
		                return;
		            }
	
		            for (i = 0; i < length; i++) {
		                that.handles.push(new TableResizeHandle(extend({
		                    appendTo: options.appendHandlesTo,
		                    resizableElement: that.element,
		                    rootElement: options.rootElement,
		                    rtl: options.rtl
		                }, handleOptions[i])));
		            }
	
		            that._bindToResizeHandlesEvents();
		        },
	
		        _destroyResizeHandles: function() {
		            var that = this;
		            var length = that.handles ? that.handles.length : 0;
	
		            for (var i = 0; i < length; i++) {
		                that.handles[i].destroy();
		            }
		        },
	
		        _showResizeHandles: function() {
		            var that = this;
		            var handles = that.handles || [];
		            var length = handles.length;
		            var i;
	
		            for (i = 0; i < length; i++) {
		                that.handles[i].show();
		            }
		        },
	
		        _bindToResizeHandlesEvents: function() {
		            var that = this;
		            var handles = that.handles || [];
		            var length = handles.length;
		            var i;
		            var handle;
	
		            for (i = 0; i < length; i++) {
		                handle = handles[i];
		                handle.bind(DRAG_START, proxy(that._onResizeHandleDragStart, that));
		                handle.bind(DRAG, proxy(that._onResizeHandleDrag, that));
		                handle.bind(DRAG_END, proxy(that._onResizeHandleDragEnd, that));
		                handle.bind(MOUSE_OVER, proxy(that._onResizeHandleMouseOver, that));
		                handle.bind(MOUSE_OUT, proxy(that._onResizeHandleMouseOut, that));
		            }
		        },
	
		        _onResizeHandleDragStart: function() {
		            var that = this;
		            var element = $(that.element);
	
		            element.addClass(TABLE_RESIZING_CLASS);
	
		            that._initialElementHeight = outerHeight(element);
		            that._initialElementWidth = outerWidth(element);
		            that._disableKeyboard();
		        },
	
		        _onResizeHandleDrag: function(e) {
		            this.resize(e);
		        },
	
		        _onResizeHandleDragEnd: function() {
		            var that = this;
		            $(that.element).removeClass(TABLE_RESIZING_CLASS);
		            that._enableKeyboard();
		        },
	
		        _enableKeyboard: function() {
		            $(this.options.rootElement).off(KEY_DOWN + NS);
		        },
	
		        _disableKeyboard: function() {
		            $(this.options.rootElement).on(KEY_DOWN + NS, function(e) {
		                e.preventDefault();
		            });
		        }
		    });
	
		    var TableResizingFactory = Class.extend({
		        create: function(editor) {
		            var factory = this;
	
		            $(editor.body)
		                .on(MOUSE_DOWN + NS, TABLE, function(e) {
		                    var eventTarget = e.target;
		                    var eventCurrentTarget = e.currentTarget;
		                    var tableResizing = editor.tableResizing;
		                    var element = tableResizing ? tableResizing.element : null;
	
		                    if (tableResizing) {
		                        if (element && eventCurrentTarget !== element) {
		                            if (contains(eventCurrentTarget, element) && element !== eventTarget && contains(element, eventTarget)) {
		                                //prevent a parent table resizing init when clicking on a nested table when the event bubbles
		                                //instead of stopping event propagation
		                                return;
		                            }
		                            else {
		                                if (element !== eventTarget) {
		                                    editor._destroyTableResizing();
		                                    factory._initResizing(editor, eventCurrentTarget);
		                                }
		                            }
		                        }
		                    }
		                    else {
		                        factory._initResizing(editor, eventCurrentTarget);
		                    }
	
		                    editor._showTableResizeHandles();
		                })
		                .on(MOUSE_DOWN + NS, function(e) {
		                    var tableResizing = editor.tableResizing;
		                    var element = tableResizing ? tableResizing.element : null;
		                    var target = e.target;
		                    var isResizeHandleOrChild = $(target).hasClass(RESIZE_HANDLE_WRAPPER_CLASS) || $(target).parents(DOT + RESIZE_HANDLE_WRAPPER_CLASS).length > 0;
	
		                    if (tableResizing && element !== target && !contains(element, target) && !isResizeHandleOrChild) {
		                        editor._destroyTableResizing();
		                    }
		                });
		        },
	
		        dispose: function(editor) {
		            $(editor.body).off(NS);
		        },
	
		        _initResizing: function(editor, table) {
		            //table resizing is natively supported in IE and Firefox
		            if (!browser.msie && !browser.mozilla) {
		                editor.tableResizing = new TableResizing(table, {
		                    appendHandlesTo: editor.body,
		                    rtl:  kendo.support.isRtl(editor.element),
		                    rootElement: editor.body
		                });
		            }
		        }
		    });
		    TableResizingFactory.current = new TableResizingFactory();
	
		    TableResizing.create = function(editor) {
		        TableResizingFactory.current.create(editor);
		    };
	
		    TableResizing.dispose = function(editor) {
		        TableResizingFactory.current.dispose(editor);
		    };
	
		    extend(Editor, {
		        TableResizing: TableResizing
		    });
	
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 983:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(688);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(981);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 869:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 948:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(662);
	
	/***/ }),
	
	/***/ 975:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(684);
	
	/***/ }),
	
	/***/ 981:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(948),  __webpack_require__(869), __webpack_require__(975)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function(kendo, undefined) {
		    var $ = kendo.jQuery;
		    var extend = $.extend;
		    var noop = $.noop;
		    var proxy = $.proxy;
	
		    var Editor = kendo.ui.editor;
		    var Class = kendo.Class;
		    var Draggable = kendo.ui.Draggable;
		    var Observable = kendo.Observable;
		    var getScrollBarWidth = Editor.ResizingUtils.getScrollBarWidth;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
	
		    var NS = ".kendoEditorTableResizeHandle";
		    var RESIZE_HANDLE_CLASS = "k-table-resize-handle";
	
		    var DRAG_START = "dragStart";
		    var DRAG = "drag";
		    var DRAG_END = "dragEnd";
		    var HALF_INSIDE = "halfInside";
		    var MOUSE_OVER = "mouseover";
		    var MOUSE_OUT = "mouseout";
	
		    var BODY = "body";
		    var TABLE = "table";
	
		    var EAST = "east";
		    var NORTH = "north";
		    var NORTHEAST = "northeast";
		    var NORTHWEST = "northwest";
		    var SOUTH = "south";
		    var SOUTHEAST = "southeast";
		    var SOUTHWEST = "southwest";
		    var WEST = "west";
	
		    var DOT = ".";
	
		    var TableResizeHandle = Observable.extend({
		        init: function(options) {
		            var that = this;
	
		            Observable.fn.init.call(that);
	
		            that.options = extend({}, that.options, options);
		            that.element = $(that.options.template).appendTo(that.options.appendTo)[0];
	
		            that._attachEventHandlers();
		            that._addStyles();
		            that._initDraggable();
		            that._initPositioningStrategy();
		            that._initDraggingStrategy();
	
		            $(that.element).data(TABLE, that.options.resizableElement);
		        },
	
		        destroy: function() {
		            var that = this;
	
		            $(that.element).off(NS).remove();
		            that.element = null;
		            
		            that._destroyDraggable();
	
		            that.unbind();
		        },
	
		        options: {
		            appendTo: null,
		            direction: SOUTHEAST,
		            resizableElement: null,
		            rtl: false,
		            template:
		                "<div class='k-table-resize-handle-wrapper' unselectable='on' contenteditable='false'>"+
		                    "<div class='" + RESIZE_HANDLE_CLASS + "'></div>" +
		                "</div>"
		        },
	
		        events: [
		            DRAG_START,
		            DRAG,
		            DRAG_END,
		            MOUSE_OVER,
		            MOUSE_OUT
		        ],
	
		        show: function() {
		            this._setPosition();
		        },
	
		        _setPosition: function() {
		            var that = this;
		            var position = that._positioningStrategy.getPosition();
	
		            $(that.element).css({
		                top: position.top,
		                left: position.left,
		                position: "absolute"
		            });
		        },
	
		        _attachEventHandlers: function() {
		            var that = this;
	
		            $(that.element)
		                .on(MOUSE_OVER + NS, proxy(that._onMouseOver, that))
		                .on(MOUSE_OUT + NS, proxy(that._onMouseOut, that));
		        },
	
		        _onMouseOver: function() {
		            this.trigger(MOUSE_OVER);
		        },
	
		        _onMouseOut: function() {
		            this.trigger(MOUSE_OUT);
		        },
	
		        _addStyles: function() {
		            var that = this;
		            $(that.element).children(DOT + RESIZE_HANDLE_CLASS).addClass("k-resize-" + that.options.direction);
		        },
	
		        _initPositioningStrategy: function() {
		            var that = this;
		            var options = that.options;
	
		            that._positioningStrategy = HandlePositioningStrategy.create({
		                name: options.direction,
		                handle: that.element,
		                resizableElement: options.resizableElement,
		                rootElement: options.rootElement,
		                rtl: options.rtl
		            });
		        },
	
		        _initDraggable: function() {
		            var that = this;
		            var element = that.element;
	
		            if (that._draggable || !element) {
		                return;
		            }
	
		            that._draggable = new Draggable(element, {
		                dragstart: proxy(that._onDragStart, that),
		                drag: proxy(that._onDrag, that),
		                dragend: proxy(that._onDragEnd, that)
		            });
		        },
	
		        _onDragStart: function() {
		            this.trigger(DRAG_START);
		        },
	
		        _onDrag: function(e) {
		            var that = this;
	
		            that.trigger(DRAG, that._draggingStrategy.adjustDragDelta({
		                deltaX: e.x.delta,
		                deltaY: e.y.delta,
		                initialDeltaX: e.x.initialDelta,
		                initialDeltaY: e.y.initialDelta
		            }));
		        },
	
		        _onDragEnd: function() {
		            this.trigger(DRAG_END);
		        },
	
		        _destroyDraggable : function() {
		            var that = this;
	
		            if (that._draggable) {
		                that._draggable.destroy();
		                that._draggable = null;
		            }
		        },
	
		        _initDraggingStrategy: function() {
		            var that = this;
	
		            that._draggingStrategy = HandleDraggingStrategy.create({
		                name: that.options.direction
		            });
		        }
		    });
	
		    var StrategyFactory = Class.extend({
		        init: function() {
		            this._items = [];
		        },
	
		        register: function(name, type) {
		            this._items.push({
		                name: name,
		                type: type
		            });
		        },
	
		        create: function(options) {
		            var items = this._items;
		            var itemsLength = items.length;
		            var name = options.name ? options.name.toLowerCase() : "";
		            var match;
		            var item;
		            var i;
	
		            for (i = 0; i < itemsLength; i++) {
		                item = items[i];
	
		                if (item.name.toLowerCase() === name) {
		                    match = item;
		                    break;
		                }
		            }
	
		            if (match) {
		                return new match.type(options);
		            }
		        }
		    });
	
		    var PositioningStrategyFactory = StrategyFactory.extend({});
		    PositioningStrategyFactory.current = new PositioningStrategyFactory();
	
		    var HandlePositioningStrategy = Class.extend({
		        init: function(options) {
		            var that = this;
		            that.options = extend({}, that.options, options);
		        },
	
		        options: {
		            handle: null,
		            offset: HALF_INSIDE,
		            resizableElement: null,
		            rootElement: null,
		            rtl: false
		        },
	
		        getPosition: function() {
		            var that = this;
	
		            var position = that.calculatePosition();
		            var handleOffsetPosition = that.applyHandleOffset(position);
		            var scrollOffsetPosition = that.applyScrollOffset(handleOffsetPosition);
	
		            return scrollOffsetPosition;
		        },
	
		        calculatePosition: noop,
	
		        applyHandleOffset: function(position) {
		            var options = this.options;
		            var handle = $(options.handle);
	
		            if (options.offset === HALF_INSIDE) {
		                return {
		                    top: position.top - (outerHeight(handle) / 2),
		                    left: position.left - (outerWidth(handle) / 2)
		                };
		            }
	
		            return position;
		        },
	
		        applyScrollOffset: function(position) {
		            var options = this.options;
		            var rootElement = $(options.rootElement);
		            var scrollBarWidth = options.rtl ? getScrollBarWidth(rootElement[0]) : 0;
	
		            if (!rootElement.is(BODY)) {
		                return {
		                    top: position.top + (rootElement.scrollTop() || 0),
		                    left: position.left + (rootElement.scrollLeft() || 0) - scrollBarWidth
		                };
		            }
	
		            return position;
		        }
		    });
	
		    HandlePositioningStrategy.create = function(options) {
		        return PositioningStrategyFactory.current.create(options);
		    };
	
		    var EastPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {
		                top: offset.top + (outerHeight(resizableElement) / 2),
		                left: offset.left + outerWidth(resizableElement)
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(EAST, EastPositioningStrategy);
	
		    var NorthPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {
		                top: offset.top,
		                left: offset.left + (outerWidth(resizableElement) / 2)
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(NORTH, NorthPositioningStrategy);
	
		    var NortheastPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {
		                top: offset.top,
		                left: offset.left + outerWidth(resizableElement)
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(NORTHEAST, NortheastPositioningStrategy);
	
		    var NorthwestPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {
		                top: offset.top,
		                left: offset.left
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(NORTHWEST, NorthwestPositioningStrategy);
	
		    var SouthPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {
		                top: offset.top + outerHeight(resizableElement),
		                left: offset.left + (outerWidth(resizableElement) / 2)
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(SOUTH, SouthPositioningStrategy);
	
		    var SoutheastPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {
		                top: offset.top + outerHeight(resizableElement),
		                left: offset.left + outerWidth(resizableElement)
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(SOUTHEAST, SoutheastPositioningStrategy);
	
		    var SouthwestPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {
		                top: offset.top + outerHeight(resizableElement),
		                left: offset.left
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(SOUTHWEST, SouthwestPositioningStrategy);
	
		    var WestPositioningStrategy = HandlePositioningStrategy.extend({
		        calculatePosition: function() {
		            var resizableElement = $(this.options.resizableElement);
		            var offset = resizableElement.position();
	
		            return {                
		                top: offset.top + (outerHeight(resizableElement) / 2),
		                left: offset.left
		            };
		        }
		    });
		    PositioningStrategyFactory.current.register(WEST, WestPositioningStrategy);
	
		    var DraggingStrategyFactory = StrategyFactory.extend({});
		    DraggingStrategyFactory.current = new DraggingStrategyFactory();
	
		    var HandleDraggingStrategy = Class.extend({
		        init: function(options) {
		            var that = this;
		            that.options = extend({}, that.options, options);
		        },
	
		        options: {
		            deltaX: {
		                adjustment: null,
		                modifier: null
		            },
		            deltaY: {
		                adjustment: null,
		                modifier: null
		            }
		        },
	
		        adjustDragDelta: function(deltas) {
		            var options = this.options;
		            var xAxisAdjustment = options.deltaX.adjustment * options.deltaX.modifier;
		            var yAxisAdjustment = options.deltaY.adjustment * options.deltaY.modifier;
	
		            return {
		                deltaX: deltas.deltaX * xAxisAdjustment,
		                deltaY: deltas.deltaY * yAxisAdjustment,
		                initialDeltaX: deltas.initialDeltaX * xAxisAdjustment,
		                initialDeltaY: deltas.initialDeltaY * yAxisAdjustment
		            };
		        }
		    });
	
		    HandleDraggingStrategy.create = function(options) {
		        return DraggingStrategyFactory.current.create(options);
		    };
	
		    var HorizontalDraggingStrategy = HandleDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                adjustment: 1,
		                modifier: 1
		            },
		            deltaY: {
		                adjustment: 0,
		                modifier: 0
		            }
		        }
		    });
	
		    var EastDraggingStrategy = HorizontalDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                modifier: 1
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(EAST, EastDraggingStrategy);
	
		    var WestDraggingStrategy = HorizontalDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                modifier: (-1)
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(WEST, WestDraggingStrategy);
	
		    var VerticalDraggingStrategy = HandleDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                adjustment: 0,
		                modifier: 0
		            },
		            deltaY: {
		                adjustment: 1,
		                modifier: 1
		            }
		        }
		    });
	
		    var NorthDraggingStrategy = VerticalDraggingStrategy.extend({
		        options: {
		            deltaY: {
		                modifier: (-1)
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(NORTH, NorthDraggingStrategy);
	
		    var SouthDraggingStrategy = VerticalDraggingStrategy.extend({
		        options: {
		            deltaY: {
		                modifier: 1
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(SOUTH, SouthDraggingStrategy);
	
		    var HorizontalAndVerticalDraggingStrategy = HandleDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                adjustment: 1,
		                modifier: 1
		            },
		            deltaY: {
		                adjustment: 1,
		                modifier: 1
		            }
		        }
		    });
	
		    var NorthEastDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                modifier: 1
		            },
		            deltaY: {
		                modifier: (-1)
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(NORTHEAST, NorthEastDraggingStrategy);
	
		    var NorthWestDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                modifier: (-1)
		            },
		            deltaY: {
		                modifier: (-1)
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(NORTHWEST, NorthWestDraggingStrategy);
	
		    var SouthEastDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                modifier: 1
		            },
		            deltaY: {
		                modifier: 1
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(SOUTHEAST, SouthEastDraggingStrategy);
	
		    var SouthWestDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
		        options: {
		            deltaX: {
		                modifier: (-1)
		            },
		            deltaY: {
		                modifier: 1
		            }
		        }
		    });
		    DraggingStrategyFactory.current.register(SOUTHWEST, SouthWestDraggingStrategy);
	
		    extend(Editor, {
		        TableResizeHandle: TableResizeHandle
		    });
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(986);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 986:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		   !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(987)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    Editor = kendo.ui.editor,
		    EditorUtils = Editor.EditorUtils,
		    RangeUtils = Editor.RangeUtils,
		    dom = Editor.Dom,
		    registerTool = EditorUtils.registerTool,
		    ToolTemplate = Editor.ToolTemplate,
		    Command = Editor.Command;
	
		var tableFormatFinder = new Editor.BlockFormatFinder([{tags:["table"]}]);
		var cellsFormatFinder = new Editor.BlockFormatFinder([{tags:["td","th"]}]);
		var reUnit = /([a-z]+|%)$/i;
	
		var TableWizardCommand = Command.extend({
		    exec: function() {
		        var cmd = this;
		        var editor = cmd.editor;
		        var range = cmd.range = cmd.lockRange();
		        var selectedTable = cmd._sourceTable = !cmd.options.insertNewTable ? cmd._selectedTable(range) : undefined;
		        var selectedCells = cmd._selectedTableCells = selectedTable ? cmd._selectedCells(range) : undefined;
		        var options = {
		            visible: false,
		            messages: editor.options.messages,
		            closeCallback: $.proxy(cmd.onDialogClose, cmd),
		            table: cmd.parseTable(selectedTable, selectedCells),
		            dialogOptions: editor.options.dialogOptions,
		            isRtl: kendo.support.isRtl(editor.wrapper)
		        };
	
		        var dialog = new Editor.TableWizardDialog(options);
		        dialog.open();
		    },
	
		    onDialogClose: function(data) {
		        var cmd = this;
		        cmd.releaseRange(cmd.range);
	
		        if (data) { //Ok button pressed
		            if (cmd.options.insertNewTable) {
		                cmd.insertTable(cmd.createNewTable(data));
		            } else {
		                cmd.updateTable(data, cmd._sourceTable, cmd._selectedTableCells);
		            }
		        }
		    },
		    releaseRange: function(range) {
		        var cmd = this;
		        var doc = cmd.editor.document;
		        dom.windowFromDocument(doc).focus();
		        Command.fn.releaseRange.call(cmd, range);
		    },
		    insertTable: function(table) {
		        var range = this.range;
	
		        range.insertNode(table);
		        range.collapse(true);
		        this.editor.selectRange(range);
	
		        this._ensureFocusableAfterTable(table);
		    },
		    _ensureFocusableAfterTable: function (table) {
		        var siblingNodes = $(table).parent().contents();
		        var lastSiblingIndex = siblingNodes.length - 1;
		        var lastSibling = siblingNodes.get(lastSiblingIndex);
	
		        while(lastSibling.nodeValue !== null && (lastSibling.nodeValue === " " || lastSibling.nodeValue === "")) {
		            lastSiblingIndex -= 1;
		            lastSibling = siblingNodes.get(lastSiblingIndex);
		        }
	
		        if(lastSibling === table) {
		            dom.insertAfter(dom.createEmptyNode(this.editor.document, "p"), table);
		        }
		    },
		    updateTable: function(data, table, selectedCells) {
		        var cmd = this;
		        var tableRows = $(table.rows).toArray();
		        var tableProp = data.tableProperties;
		        var rows = tableProp.rows;
		        var columns = tableProp.columns;
		        var last = function(collection) {
		            return collection[collection.length - 1];
		        };
	
		        //Leave only first selected cell
		        while (selectedCells.length > 1) {
		            selectedCells.pop();
		        }
	
		        var lastSelectedRow = selectedCells.length ? last(selectedCells).parentNode : last(tableRows);
		        var row, parent;
	
		        cmd._deleteTableRows(tableRows, tableRows.length - rows);
	
		        if (tableRows.length < rows) {
		            var rowIndex = $(lastSelectedRow).index();
		            var cellsLength = lastSelectedRow.cells.length;
		            var newRowsCount = rows - tableRows.length;
		            parent = lastSelectedRow.parentNode;
		            while (newRowsCount) {
		                row = parent.insertRow(rowIndex + 1);
		                cmd._insertCells(cellsLength - row.cells.length, row);
		                newRowsCount--;
		            }
		        }
	
		        if (tableRows[0].cells.length > columns) {
		            $(tableRows).each(function(i, row){
		                while(row.cells.length > columns) {
		                    row.deleteCell(-1);
		                }
		            });
		        }
	
		        if (tableRows[0].cells.length < columns) {
		            var cellIndex = $(last(selectedCells) || last(lastSelectedRow.cells)).index();
		            $(tableRows).each(function(i, row) {
		                cmd._insertCells(columns - row.cells.length, row, cellIndex + 1);
		            });
		        }
	
		        cmd._updateTableProperties(table, tableProp);
	
		        var cellProp = data.cellProperties;
		        if (selectedCells[0]) {
		            dom.attr(selectedCells[0], {id: cellProp.id || null});
		        }
		        (cellProp.selectAllCells ? $(tableRows).children() : $(selectedCells)).each(function(i, cell){
		            cmd._updateCellProperties(cell, cellProp);
		        });
	
		        cmd._updateCaption(table, tableProp);
	
		        tableProp.cellsWithHeaders = tableProp.cellsWithHeaders || false;
		        if (cmd.cellsWithHeadersAssociated(table) != tableProp.cellsWithHeaders) {
		            cmd.associateCellsWithHeader(table, tableProp.cellsWithHeaders);
		        }
		    },
		    _isHeadingRow: function(row) {
		        return dom.is(row.parentNode, "thead") || dom.is(row.cells[0], "th");
		    },
		    associateCellsWithHeader: function(table, associate) {
		        var timestamp = new Date().getTime();
		        var ids = [];
		        var columns = table.rows[0].cells.length;
		        var index, nextRow, isDataRow;
	
		        var generateIds = function() {
		            for (var i = 0; i < columns; i++) {
		                ids[i] = "table" + (++timestamp);
		            }
		        };
		        var modifySellsIds = function(c, cell) {
		            $(cell)[associate ? "attr" : "removeAttr"]("id", ids[c]);
		        };
		        var modifyCellsHeadings = function(c, cell) {
		            $(cell)[associate ? "attr" : "removeAttr"]("headers", ids[c]);
		        };
		        var isHeadingRow = this._isHeadingRow;
	
		        $(table.rows).each(function(r, row) {
		            if (isHeadingRow(row)) {
		                index = r;
		                nextRow = table.rows[++index];
		                isDataRow = nextRow && !isHeadingRow(nextRow);
		                if (isDataRow) {
		                    generateIds();
		                    $(row.cells).each(modifySellsIds);
		                }
		                while(isDataRow) {
		                    $(nextRow.cells).each(modifyCellsHeadings);
		                    nextRow = table.rows[++index];
		                    isDataRow = nextRow && !isHeadingRow(nextRow);
		                }
		            }
		        });
		    },
		    cellsWithHeadersAssociated: function(table) {
		        var cells = $(table.rows).children();
		        var isHeadingRow = this._isHeadingRow;
		        var headingIds = [];
		        cells.each(function(c, cell) {
		            if (cell.id && isHeadingRow(cell.parentNode)) {
		                headingIds.push(cell.id);
		            }
		        });
	
		        var associatedCells = cells.filter(function(c, cell) {
		            var headersAttr = cell.getAttribute("headers");
		            return headersAttr && !isHeadingRow(cell.parentNode) && $.inArray(headersAttr, headingIds) > -1;
		        });
	
		        return !!associatedCells.length;
		    },
		    _insertCells: function(count, row, index) {
		        index = isNaN(index) ? -1 : index;
		        for (var i = 0, cell; i < count; i++) {
		            cell = row.insertCell(index);
		            cell.innerHTML = "&nbsp;";
		        }
		    },
	
		    _deleteTableRows: function(rows, count){
		        for (var i = 0, row, rowParent; i < count; i++) {
		            row = rows.pop();
		            rowParent = row.parentNode;
		            rowParent.removeChild(row);
		            if (!rowParent.rows.length) {
		                dom.remove(rowParent);
		            }
		        }
		    },
		    createNewTable: function(data) {
		        var cmd = this;
		        var doc = cmd.editor.document;
		        var tableProp = data.tableProperties;
		        var cellProp = data.cellProperties;
		        var cellPropToAll = cellProp.selectAllCells;
		        var table = dom.create(doc, "table");
	
		        cmd._updateTableProperties(table, tableProp);
		        cmd._updateCaption(table, tableProp);
	
		        var tbody = table.createTBody();
		        for (var r = 0, row; r < tableProp.rows; r++) {
		            row = tbody.insertRow();
		            for (var c = 0, cell; c < tableProp.columns; c++) {
		                cell = row.insertCell();
		                cell.innerHTML = "&nbsp;";
		                if (r === 0 && c === 0 && cellProp.id) {
		                    cell.id = cellProp.id;
		                }
		                cmd._updateCellProperties(cell, (cellPropToAll || (r === 0 && c === 0)) ? cellProp : {});
		            }
		        }
	
		        if (tableProp.cellsWithHeaders) {
		            cmd.associateCellsWithHeader(table, tableProp.cellsWithHeaders);
		        }
	
		        return table;
		    },
		    _updateTableProperties: function(table, data){
		        var style = this._getStylesData(data);
		        dom.attr(table, {
		            cellSpacing: data.cellSpacing || null,
		            cellPadding: data.cellPadding || null,
		            className: data.className || null,
		            id: data.id || null,
		            summary: data.summary || null,
		            style: style || null
		        });
		        $(table).addClass("k-table");
		    },
		    _updateCellProperties: function(cell, data) {
		        var style = this._getStylesData(data);
		        style.padding = data.cellPadding || null;
		        style.margin = data.cellMargin || null;
		        dom.attr(cell, {
		            style: style || null,
		            className: data.className || null
		        });
		    },
		    _updateCaption: function(table, data){
		        if (table.caption && !data.captionContent) {
		            table.deleteCaption();
		        } else if (data.captionContent) {
		            var caption = table.createCaption();
		            caption.innerHTML = data.captionContent;
		            var alignment = this._getAlignmentData(data.captionAlignment);
		            dom.attr(caption, {
		                style: {
		                    textAlign: alignment.textAlign,
		                    verticalAlign: alignment.verticalAlign
		                }
		            });
		        }
		    },
		    _getStylesData: function(data) {
		        var alignment = this._getAlignmentData(data.alignment);
		        var whiteSpace = "wrapText" in data ? (data.wrapText ? "" : "nowrap") : null;
	
		        return {
		            width: data.width ? data.width + data.widthUnit : null,
		            height: data.height ? data.height + data.heightUnit : null,
		            textAlign: alignment.textAlign,
		            verticalAlign: alignment.verticalAlign,
		            backgroundColor: data.bgColor || "",
		            borderWidth: data.borderWidth,
		            borderStyle: data.borderStyle,
		            borderColor: data.borderColor || "",
		            borderCollapse: data.collapseBorders ? "collapse" : null,
		            whiteSpace: whiteSpace
		        };
		    },
		    _getAlignmentData: function(alignment) {
		        var textAlign = "";
		        var verticalAlign = textAlign;
	
		        if (alignment) {
		            if (alignment.indexOf(" ") != -1) {
		                var align = alignment.split(" ");
		                textAlign = align[0];
		                verticalAlign = align[1];
		            } else {
		                textAlign = alignment;
		            }
		        }
		        return {textAlign: textAlign, verticalAlign: verticalAlign};
		    },
		    parseTable: function(table, selectedCells) {
		        if (!table) {
		            return { tableProperties: {}, selectedCells: [] };
		        }
	
		        var cmd = this;
		        var tStyle = table.style;
		        var rows = table.rows;
		        var caption = table.caption;
		        var captionClone = $(caption ? caption.cloneNode(true) : undefined);
		        captionClone.find(".k-marker").remove();
	
		        var cssClass = table.className;
		        cssClass = cssClass.replace(/^k-table\s|\sk-table$/, "");
		        cssClass = cssClass.replace(/\sk-table\s/, " ");
		        cssClass = cssClass.replace(/^k-table$/, "");
	
		        var tableAlignment = cmd._getAlignment(table, true);
		        var captionAlignment = caption ? cmd._getAlignment(caption) : undefined;
		        var cellsWithHeaders = cmd.cellsWithHeadersAssociated(table);
	
		        var tableJson = {
		            tableProperties: {
		                width: tStyle.width || table.width ? parseFloat(tStyle.width || table.width) : null,
		                height: tStyle.height || table.height ? parseFloat(tStyle.height || table.height) : null,
		                columns: rows[0] ? rows[0].children.length : 0,
		                rows: rows.length,
		                widthUnit: cmd._getUnit(tStyle.width),
		                heightUnit: cmd._getUnit(tStyle.height),
		                cellSpacing: table.cellSpacing,
		                cellPadding: table.cellPadding,
		                alignment: tableAlignment.textAlign,
		                bgColor: tStyle.backgroundColor || table.bgColor,
		                className: cssClass,
		                id: table.id,
		                borderWidth: tStyle.borderWidth || table.border,
		                borderColor: tStyle.borderColor,
		                borderStyle: tStyle.borderStyle || "",
		                collapseBorders: !!tStyle.borderCollapse,
		                summary: table.summary,
		                captionContent: caption ? captionClone.html() : "",
		                captionAlignment: caption && captionAlignment.textAlign ? captionAlignment.textAlign + " " + captionAlignment.verticalAlign : "",
		                cellsWithHeaders: cellsWithHeaders
		            },
		            selectedCells: []
		        };
	
		        tableJson.rows = cmd.parseTableRows(rows, selectedCells, tableJson);
	
		        return tableJson;
		    },
		    parseTableRows: function(rows, selectedCells, tableJson) {
		        var cmd = this;
		        var data = [], row, rowData, cells, cell, cellData;
		        for (var i = 0; i < rows.length; i++) {
		            row = rows[i];
		            rowData = {cells: []};
		            cells = row.cells;
		            data.push(rowData);
		            for (var j = 0; j < cells.length; j++) {
		                cell = cells[j];
		                cellData = cmd.parseCell(cell);
		                if ($.inArray(cell, selectedCells) != -1) {
		                    tableJson.selectedCells.push(cellData);
		                }
		                rowData.cells.push(cellData);
		            }
		        }
		        return data;
		    },
		    parseCell: function(cell) {
		        var cmd = this;
		        var cStyle = cell.style;
		        var alignment = cmd._getAlignment(cell);
		        alignment = alignment.textAlign ? alignment.textAlign + " " + alignment.verticalAlign : "";
	
		        var data = {
		            width: cStyle.width || cell.width ? parseFloat(cStyle.width || cell.width) : null,
		            height: cStyle.height || cell.height ? parseFloat(cStyle.height || cell.height) : null,
		            widthUnit: cmd._getUnit(cStyle.width),
		            heightUnit: cmd._getUnit(cStyle.height),
		            cellMargin: cStyle.margin,
		            cellPadding: cStyle.padding,
		            alignment: alignment,
		            bgColor: cStyle.backgroundColor || cell.bgColor,
		            className: cell.className,
		            id: cell.id,
		            borderWidth: cStyle.borderWidth || cell.border,
		            borderColor: cStyle.borderColor,
		            borderStyle: cStyle.borderStyle,
		            wrapText: cStyle.whiteSpace != "nowrap"
		        };
	
		        return data;
		    },
		    _getAlignment: function(element, horizontalOnly) {
		        var style = element.style;
		        var hAlign = style.textAlign || element.align || "";
		        if (horizontalOnly) {
		            return {textAlign: hAlign};
		        }
		        var vAlign = style.verticalAlign || element.vAlign || "";
		        if(hAlign && vAlign) {
		            return {textAlign: hAlign, verticalAlign: vAlign};
		        }
		        if(!hAlign && vAlign) {
		            return {textAlign: "left", verticalAlign: vAlign};
		        }
		        if(hAlign && !vAlign) {
		            return {textAlign: hAlign, verticalAlign: "top"};
		        }
		        return {textAlign: "", verticalAlign: ""};
		    },
		    _getUnit: function(value) {
		        var unit = (value || "").match(reUnit);
		        return unit ? unit[0] : "px";
		    },
		    _selectedTable: function(range) {
		        var nodes = dom.filterBy(RangeUtils.nodes(range), dom.htmlIndentSpace, true);
		        return tableFormatFinder.findSuitable(nodes)[0];
		    },
		    _selectedCells: function(range) {
		        var nodes = dom.filterBy(RangeUtils.nodes(range), dom.htmlIndentSpace, true);
		        return cellsFormatFinder.findSuitable(nodes);
		    }
		});
	
		var TableWizardTool = Editor.Tool.extend({
		    command: function (options) {
		        options.insertNewTable = this.options.insertNewTable;
		        return new TableWizardCommand(options);
		    }
		});
	
		var TableWizardEditTool = TableWizardTool.extend({
		    update: function(ui, nodes) {
		        var isFormatted = !tableFormatFinder.isFormatted(nodes);
		        ui.toggleClass("k-state-disabled", isFormatted);
		    }
		});
	
		kendo.ui.editor.TableWizardTool = TableWizardTool;
		kendo.ui.editor.TableWizardCommand = TableWizardCommand;
	
		registerTool("tableWizard", new TableWizardEditTool({ command: TableWizardCommand, insertNewTable: false, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Table Wizard"})}));
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 987:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(678);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(988);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 988:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		   !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(989)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function($, undefined) {
	
		var kendo = window.kendo,
		    numericTextBoxSettings = { format: "0", min: 0 },
		    units = ["px", "em"],
		    borderStyles = ["solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "initial", "inherit", "none", "hidden"];
	
		var tableAlignmentDropDownSettings = {
		    dataSource: [{
		        className: "k-icon k-i-table-align-middle-left",
		        value: "left"
		    }, {
		        className: "k-icon k-i-table-align-middle-center",
		        value: "center"
		    }, {
		        className: "k-icon k-i-table-align-middle-right",
		        value: "right"
		    }, {
		        className: "k-icon k-i-align-remove",
		        value: ""
		    }],
		    dataTextField: "className",
		    dataValueField: "value",
		    template: "<span class='#: className #' title='#: tooltip #'></span>",
		    valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
		};
	
		var cellAlignmentDropDownSettings = {
		    dataSource: [{
		        className: "k-icon k-i-table-align-top-left",
		        value: "left top"
		    }, {
		        className: "k-icon k-i-table-align-top-center",
		        value: "center top"
		    }, {
		        className: "k-icon k-i-table-align-top-right",
		        value: "right top"
		    }, {
		        className: "k-icon k-i-table-align-middle-left",
		        value: "left middle"
		    }, {
		        className: "k-icon k-i-table-align-middle-center",
		        value: "center middle"
		    }, {
		        className: "k-icon k-i-table-align-middle-right",
		        value: "right middle"
		    }, {
		        className: "k-icon k-i-table-align-bottom-left",
		        value: "left bottom"
		    }, {
		        className: "k-icon k-i-table-align-bottom-center",
		        value: "center bottom"
		    }, {
		        className: "k-icon k-i-table-align-bottom-right",
		        value: "right bottom"
		    }, {
		        className: "k-icon k-i-align-remove",
		        value: ""
		    }],
		    dataTextField: "className",
		    dataValueField: "value",
		    template: "<span class='#: className #' title='#: tooltip #'></span>",
		    valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
		};
	
		var accessibilityAlignmentDropDownSettings = {
		    dataSource: [{
		        className: "k-icon k-i-table-align-top-left",
		        value: "left top"
		    }, {
		        className: "k-icon k-i-table-align-top-center",
		        value: "center top"
		    }, {
		        className: "k-icon k-i-table-align-top-right",
		        value: "right top"
		    }, {
		        className: "k-icon k-i-table-align-bottom-left",
		        value: "left bottom"
		    }, {
		        className: "k-icon k-i-table-align-bottom-center",
		        value: "center bottom"
		    }, {
		        className: "k-icon k-i-table-align-bottom-right",
		        value: "right bottom"
		    }, {
		        className: "k-icon k-i-align-remove",
		        value: ""
		    }],
		    dataTextField: "className",
		    dataValueField: "value",
		    template: "<span class='#: className #' title='#: tooltip #'></span>",
		    valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
		};
	
		var dialogTemplate =
		    '<div class="k-editor-dialog k-editor-table-wizard-dialog k-action-window k-popup-edit-form">' +
		        '<div class="k-edit-form-container">' +
		            '<div id="k-table-wizard-tabs" class="k-root-tabs">' +
		                '<ul>' +
		                    '<li class="k-state-active">#= messages.tableTab #</li>' +
		                    '<li>#= messages.cellTab #</li>' +
		                    '<li>#= messages.accessibilityTab #</li>' +
		                '</ul>' +
		                '<div id="k-table-properties">' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-width">#= messages.width #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-width" />' +
		                        '<input id="k-editor-table-width-type" aria-label="#= messages.units #" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-height">#= messages.height #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-height" />' +
		                        '<input id="k-editor-table-height-type" aria-label="#= messages.units #" />' +
		                    '</div>' +
	
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-columns">#= messages.columns #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-columns" />' +
		                    '</div>' +
	
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-rows">#= messages.rows #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-rows" />' +
		                    '</div>' +
	
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-cell-spacing">#= messages.cellSpacing #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-cell-spacing" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-cell-padding">#= messages.cellPadding #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-cell-padding" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-alignment">#= messages.alignment #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-table-alignment" class="k-align" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-bg">#= messages.background #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-table-bg" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-css-class">#= messages.cssClass #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-css-class" class="k-input k-textbox" type="text" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-id">#= messages.id #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-id" class="k-input k-textbox" type="text" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-border-width">#= messages.border #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-border-width" />' +
		                        '<input id="k-editor-border-color" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-border-style">#= messages.borderStyle #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-border-style" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">&nbsp;</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-collapse-borders" type="checkbox" class="k-checkbox" />' +
		                        '<label for="k-editor-collapse-borders" class="k-checkbox-label">#= messages.collapseBorders #</label>' +
		                    '</div>' +
		                '</div>' +
	
		                '<div id="k-cell-properties">' +
	
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-selectAllCells" type="checkbox" class="k-checkbox" />' +
		                        '<label for="k-editor-selectAllCells" class="k-checkbox-label">#= messages.selectAllCells #</label>' +
		                    '</div>' +
	
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-width">#= messages.width #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-cell-width" />' +
		                        '<input id="k-editor-cell-width-type" aria-label="#= messages.units #" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-height">#= messages.height #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-cell-height" />' +
		                        '<input id="k-editor-cell-height-type" aria-label="#= messages.units #" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-cell-margin">#= messages.cellMargin #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-cell-margin" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-cells-padding">#= messages.cellPadding #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-table-cells-padding" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-alignment">#= messages.alignment #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-cell-alignment" class="k-align" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-bg">#= messages.background #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-cell-bg" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-css-class">#= messages.cssClass #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-cell-css-class" class="k-input k-textbox" type="text" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-id">#= messages.id #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-cell-id" class="k-input k-textbox" type="text" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-border-width">#= messages.border #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input type="numeric" id="k-editor-cell-border-width" />' +
		                        '<input id="k-editor-cell-border-color" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-cell-border-style">#= messages.borderStyle #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-cell-border-style" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">&nbsp;</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-wrap-text" type="checkbox" class="k-checkbox" />' +
		                        '<label for="k-editor-wrap-text" class="k-checkbox-label">#= messages.wrapText #</label>' +
		                    '</div>' +
		                '</div>' +
	
		                '<div id="k-accessibility-properties">' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-table-caption">#= messages.caption #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-table-caption" class="k-input k-textbox" type="text" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-accessibility-alignment">#= messages.alignment #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-accessibility-alignment" class="k-align" />' +
		                    '</div>' +
		                    '<div class="k-edit-label">' +
		                        '<label for="k-editor-accessibility-summary">#= messages.summary #</label>' +
		                    '</div>' +
		                    '<div class="k-edit-field">' +
		                        '<textarea id="k-editor-accessibility-summary" class="k-input k-textbox"></textarea>' +
		                    '</div>' +
		                    '<div class="k-edit-label">&nbsp;</div>' +
		                    '<div class="k-edit-field">' +
		                        '<input id="k-editor-cells-headers" type="checkbox" class="k-checkbox" />' +
		                        '<label for="k-editor-cells-headers" class="k-checkbox-label">#= messages.associateCellsWithHeaders #</label>' +
		                    '</div>' +
		                '</div>' +
		                '</div>' +
		                '<div class="k-edit-buttons k-state-default">' +
		                '<button class="k-button k-primary k-dialog-ok">#= messages.dialogOk #</button>' +
		                '<button class="k-button k-dialog-close">#= messages.dialogCancel #</button>' +
		            '</div>' +
		        '</div>' +
		    '</div>';
	
		var TableWizardDialog = kendo.Class.extend({
		    init: function(options) {
		        this.options = options;
		    },
		    open: function() {
		        var that = this,
		            options = that.options,
		            dialogOptions = options.dialogOptions,
		            tableData = options.table,
		            dialog,
		            messages = options.messages,
		            isIE = kendo.support.browser.msie;
	
		        function close(e) {
		            e.preventDefault();
		            that.destroy();
		            dialog.destroy();
		        }
	
		        function okHandler(e) {
		            that.collectDialogValues(tableData);
	
		            close(e);
	
		            if (that.change) {
		                that.change();
		            }
	
		            options.closeCallback(tableData);
		        }
	
		        function closeHandler(e) {
		            close(e);
		            options.closeCallback();
		        }
	
		        dialogOptions.close = closeHandler;
		        dialogOptions.title = messages.tableWizard;
		        dialogOptions.visible = options.visible;
	
		        dialog = $(that._dialogTemplate(messages)).appendTo(document.body)
		            .kendoWindow(dialogOptions)
		            .closest(".k-window").toggleClass("k-rtl", options.isRtl).end()
		            .find(".k-dialog-ok").click(okHandler).end()
		            .find(".k-dialog-close").click(closeHandler).end()
		            .data("kendoWindow");
	
		        var element = dialog.element;
		        that._initTabStripComponent(element);
		        that._initTableViewComponents(element, tableData);
		        that._initCellViewComponents(element, tableData);
		        that._initAccessibilityViewComponents(element, tableData);
	
		        dialog.center();
		        dialog.open();
	
		        if(isIE) {
		            var dialogHeight = element.closest(".k-window").height();
		            element.css("max-height", dialogHeight);
		        }
		    },
	
		    _initTabStripComponent: function(element){
		        var components = this.components = {};
		        components.tabStrip = element.find("#k-table-wizard-tabs").kendoTabStrip({
		            animation: false
		        }).data("kendoTabStrip");
		    },
	
		    collectDialogValues: function() {
		        var that = this;
		        var data = that.options.table;
		        that._collectTableViewValues(data);
		        that._collectCellViewValues(data);
		        that._collectAccessibilityViewValues(data);
		    },
	
		    _collectTableViewValues: function(tableData) {
		        var tableView = this.components.tableView;
		        var tableProperties = tableData.tableProperties;
		        tableProperties.width = tableView.width.value();
		        tableProperties.widthUnit = tableView.widthUnit.value();
		        tableProperties.height = tableView.height.value();
		        tableProperties.columns = tableView.columns.value();
		        tableProperties.rows = tableView.rows.value();
		        tableProperties.heightUnit = tableView.heightUnit.value();
		        tableProperties.cellSpacing = tableView.cellSpacing.value();
		        tableProperties.cellPadding = tableView.cellPadding.value();
		        tableProperties.alignment = tableView.alignment.value();
		        tableProperties.bgColor = tableView.bgColor.value();
		        tableProperties.className = tableView.className.value;
		        tableProperties.id = tableView.id.value;
		        tableProperties.borderWidth = tableView.borderWidth.value();
		        tableProperties.borderColor = tableView.borderColor.value();
		        tableProperties.borderStyle = tableView.borderStyle.value();
		        tableProperties.collapseBorders = tableView.collapseBorders.checked;
		    },
	
		    _collectCellViewValues: function(table) {
		        var cellData = table.cellProperties = {};
		        var cellView = this.components.cellView;
	
		        cellData.selectAllCells = cellView.selectAllCells.checked;
		        cellData.width = cellView.width.value();
		        cellData.widthUnit = cellView.widthUnit.value();
		        cellData.height = cellView.height.value();
		        cellData.heightUnit = cellView.heightUnit.value();
		        cellData.cellMargin = cellView.cellMargin.value();
		        cellData.cellPadding = cellView.cellPadding.value();
		        cellData.alignment = cellView.alignment.value();
		        cellData.bgColor = cellView.bgColor.value();
		        cellData.className = cellView.className.value;
		        cellData.id = cellView.id.value;
		        cellData.borderWidth = cellView.borderWidth.value();
		        cellData.borderColor = cellView.borderColor.value();
		        cellData.borderStyle = cellView.borderStyle.value();
		        cellData.wrapText = cellView.wrapText.checked;
	
		        if (!cellData.width) {
		            cellData.selectAllCells = true;
		            cellData.width = 100 / table.tableProperties.columns;
		            cellData.widthUnit = "%";
		        }
		    },
	
		   _collectAccessibilityViewValues: function(table) {
		        var tableProperties = table.tableProperties;
		        var accessibilityView = this.components.accessibilityView;
		        tableProperties.captionContent = accessibilityView.captionContent.value;
		        tableProperties.captionAlignment = accessibilityView.captionAlignment.value();
		        tableProperties.summary = accessibilityView.summary.value;
		        tableProperties.cellsWithHeaders = accessibilityView.cellsWithHeaders.checked;
		    },
		    _addUnit: function(units, value){
		        if (value && $.inArray(value, units) == -1) {
		            units.push(value);
		        }
		    },
		    _initTableViewComponents: function(element, table) {
		        var components = this.components;
		        var tableView = components.tableView = {};
		        var tableProperties = table.tableProperties = table.tableProperties || {};
		        tableProperties.borderStyle = tableProperties.borderStyle || "";
	
		        this._addUnit(units, tableProperties.widthUnit);
		        this._addUnit(units, tableProperties.heightUnit);
	
		        this._initNumericTextbox(element.find("#k-editor-table-width"), "width", tableProperties, tableView);
		        this._initNumericTextbox(element.find("#k-editor-table-height"), "height", tableProperties, tableView);
		        this._initNumericTextbox(element.find("#k-editor-table-columns"), "columns", tableProperties, tableView, {min: 1, value: 4});
		        this._initNumericTextbox(element.find("#k-editor-table-rows"), "rows", tableProperties, tableView, {min: 1, value: 4});
		        this._initDropDownList(element.find("#k-editor-table-width-type"), "widthUnit", tableProperties, tableView, units);
		        this._initDropDownList(element.find("#k-editor-table-height-type"), "heightUnit", tableProperties, tableView, units);
		        this._initNumericTextbox(element.find("#k-editor-table-cell-spacing"), "cellSpacing", tableProperties, tableView);
		        this._initNumericTextbox(element.find("#k-editor-table-cell-padding"), "cellPadding", tableProperties, tableView);
		        this._initTableAlignmentDropDown(element.find("#k-editor-table-alignment"), tableProperties);
		        this._initColorPicker(element.find("#k-editor-table-bg"), "bgColor", tableProperties, tableView);
		        this._initInput(element.find("#k-editor-css-class"), "className", tableProperties, tableView);
		        this._initInput(element.find("#k-editor-id"), "id", tableProperties, tableView);
		        this._initNumericTextbox(element.find("#k-editor-border-width"), "borderWidth", tableProperties, tableView);
		        this._initColorPicker(element.find("#k-editor-border-color"), "borderColor", tableProperties, tableView);
		        this._initDropDownList(element.find("#k-editor-border-style"), "borderStyle", tableProperties, tableView, borderStyles);
		        this._initCheckbox(element.find("#k-editor-collapse-borders"), "collapseBorders", tableProperties, tableView);
		    },
	
		    _initCellViewComponents: function(element, table) {
		        var components = this.components;
		        var cellView = components.cellView = {};
		        table.selectedCells = table.selectedCells = table.selectedCells || [];
		        var cellProperties = table.selectedCells[0] || {borderStyle: "", wrapText: true};
		        this._addUnit(units, cellProperties.widthUnit);
		        this._addUnit(units, cellProperties.heightUnit);
	
		        this._initCheckbox(element.find("#k-editor-selectAllCells"), "selectAllCells", table.tableProperties, cellView);
		        this._initNumericTextbox(element.find("#k-editor-cell-width"), "width", cellProperties, cellView);
		        this._initNumericTextbox(element.find("#k-editor-cell-height"), "height", cellProperties, cellView);
		        this._initDropDownList(element.find("#k-editor-cell-width-type"), "widthUnit", cellProperties, cellView, units);
		        this._initDropDownList(element.find("#k-editor-cell-height-type"), "heightUnit", cellProperties, cellView, units);
		        this._initNumericTextbox(element.find("#k-editor-table-cell-margin"), "cellMargin", cellProperties, cellView);
		        this._initNumericTextbox(element.find("#k-editor-table-cells-padding"), "cellPadding", cellProperties, cellView);
		        this._initCellAlignmentDropDown(element.find("#k-editor-cell-alignment"), cellProperties);
		        this._initColorPicker(element.find("#k-editor-cell-bg"), "bgColor", cellProperties, cellView);
		        this._initInput(element.find("#k-editor-cell-css-class"), "className", cellProperties, cellView);
		        this._initInput(element.find("#k-editor-cell-id"), "id", cellProperties, cellView);
		        this._initNumericTextbox(element.find("#k-editor-cell-border-width"), "borderWidth", cellProperties, cellView);
		        this._initColorPicker(element.find("#k-editor-cell-border-color"), "borderColor", cellProperties, cellView);
		        this._initDropDownList(element.find("#k-editor-cell-border-style"), "borderStyle", cellProperties, cellView, borderStyles);
		        this._initCheckbox(element.find("#k-editor-wrap-text"), "wrapText", cellProperties, cellView);
		    },
	
		    _initAccessibilityViewComponents: function(element, table) {
		        var components = this.components;
		        var accessibilityView = components.accessibilityView = {};
		        var tableProperties = table.tableProperties;
	
		        this._initInput(element.find("#k-editor-table-caption"), "captionContent", tableProperties, accessibilityView);
		        this._initAccessibilityAlignmentDropDown(element.find("#k-editor-accessibility-alignment"), tableProperties);
		        this._initInput(element.find("#k-editor-accessibility-summary"), "summary", tableProperties, accessibilityView);
		        this._initCheckbox(element.find("#k-editor-cells-headers"), "cellsWithHeaders", tableProperties, accessibilityView);
		    },
	
		    _initNumericTextbox: function(element, property, data, storage, settings) {
		        var component = storage[property] = element.kendoNumericTextBox(
		                settings ? $.extend({}, numericTextBoxSettings, settings) : numericTextBoxSettings
		            ).data("kendoNumericTextBox");
		        if (property in data) {
		            component.value(parseInt(data[property], 10));
		        }
		    },
	
		    _initDropDownList: function(element, property, data, storage, dataSource) {
		        var component = storage[property] = element.kendoDropDownList({
		            dataSource: dataSource
		        }).data("kendoDropDownList");
		        this._setComponentValue(component, data, property);
		    },
	
		    _initTableAlignmentDropDown: function (element, data) {
		        var messages = this.options.messages;
		        var tableView =  this.components.tableView;
		        var dataSource = tableAlignmentDropDownSettings.dataSource;
		        dataSource[0].tooltip = messages.alignLeft;
		        dataSource[1].tooltip = messages.alignCenter;
		        dataSource[2].tooltip = messages.alignRight;
		        dataSource[3].tooltip = messages.alignRemove;
	
		        this._initAlignmentDropDown(element, tableAlignmentDropDownSettings, "alignment", data, tableView);
		    },
	
		    _initCellAlignmentDropDown: function (element, data) {
		        var messages = this.options.messages;
		        var cellView =  this.components.cellView;
		        var dataSource = cellAlignmentDropDownSettings.dataSource;
		        dataSource[0].tooltip = messages.alignLeftTop;
		        dataSource[1].tooltip = messages.alignCenterTop;
		        dataSource[2].tooltip = messages.alignRightTop;
		        dataSource[3].tooltip = messages.alignLeftMiddle;
		        dataSource[4].tooltip = messages.alignCenterMiddle;
		        dataSource[5].tooltip = messages.alignRightMiddle;
		        dataSource[6].tooltip = messages.alignLeftBottom;
		        dataSource[7].tooltip = messages.alignCenterBottom;
		        dataSource[8].tooltip = messages.alignRightBottom;
		        dataSource[9].tooltip = messages.alignRemove;
	
		        this._initAlignmentDropDown(element, cellAlignmentDropDownSettings, "alignment", data, cellView);
		    },
	
		    _initAccessibilityAlignmentDropDown: function (element, data) {
		        var messages = this.options.messages;
		        var accessibilityView =  this.components.accessibilityView;
		        var dataSource = accessibilityAlignmentDropDownSettings.dataSource;
		        dataSource[0].tooltip = messages.alignLeftTop;
		        dataSource[1].tooltip = messages.alignCenterTop;
		        dataSource[2].tooltip = messages.alignRightTop;
		        dataSource[3].tooltip = messages.alignLeftBottom;
		        dataSource[4].tooltip = messages.alignCenterBottom;
		        dataSource[5].tooltip = messages.alignRightBottom;
		        dataSource[6].tooltip = messages.alignRemove;
	
		        this._initAlignmentDropDown(element, accessibilityAlignmentDropDownSettings, "captionAlignment", data, accessibilityView);
		    },
		    _initAlignmentDropDown: function(element, settings, name, data, storage) {
		        var component = storage[name] =
		            element.kendoDropDownList(settings).data("kendoDropDownList");
	
		        component.list.addClass('k-align').css('width', '110px');
		        this._setComponentValue(component, data, name);
		    },
		    _setComponentValue: function(component, data, property){
		        if (property in data) {
		            component.value(data[property]);
		        }
		    },
	
		    _initColorPicker: function(element, property, data, storage) {
		        var component = storage[property] =
		            element.kendoColorPicker({buttons: false, clearButton: true}).data("kendoColorPicker");
	
		        if (data[property]) {
		            component.value(data[property]);
		        }
		    },
		    _initInput: function(element, property, data, storage) {
		        var component = storage[property] = element.get(0);
		        if (property in data) {
		            component.value = data[property];
		        }
		    },
	
		    _initCheckbox: function(element, property, data, storage) {
		        var component = storage[property] = element.get(0);
		        if (property in data) {
		            component.checked = data[property];
		        }
		    },
	
		    destroy: function() {
		        this._destroyComponents(this.components.tableView);
		        this._destroyComponents(this.components.cellView);
		        this._destroyComponents(this.components.accessibilityView);
		        this._destroyComponents(this.components);
	
		        delete this.components;
		    },
		    _destroyComponents: function(components) {
		        for (var widget in components) {
		            if (components[widget].destroy) {
		                components[widget].destroy();
		            }
		            delete components[widget];
		        }
		    },
	
		    _dialogTemplate: function(messages) {
		        return kendo.template(dialogTemplate)({ messages: messages });
		    }
		});
	
		kendo.ui.editor.TableWizardDialog = TableWizardDialog;
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 989:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(689);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1214);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1037:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(579);
	
	/***/ }),
	
	/***/ 1053:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(582);
	
	/***/ }),
	
	/***/ 1214:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1037), __webpack_require__(1215), __webpack_require__(1008), __webpack_require__(1053)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function () {
	
		    var __meta__ = { // jshint ignore:line
		        id: "mediaplayer",
		        name: "MediaPlayer",
		        category: "web",
		        description: "",
		        depends: ["slider", "toolbar", "dropdownlist", "tooltip"]
		    };
	
		    (function ($, undefined) {
		        var kendo = window.kendo,
		            END = "end",
		            PAUSE = "pause",
		            PLAY = "play",
		            READY = "ready",
		            TIMECHANGE = "timeChange",
		            VOLUMECHANGE = "volumeChange",
		            FULLSCREEN_ENTER = "k-i-full-screen",
		            FULLSCREEN_EXIT = "k-i-full-screen-exit",
		            MUTE = "k-i-volume-off",
		            LOW_VOLUME = "k-i-volume-down",
		            HIGH_VOLUME = "k-i-volume-up",
		            VIDEO_QUALITY = "k-mediaplayer-quality",
		            STATE_PLAY = "k-i-play",
		            STATE_PAUSE = "k-i-pause",
		            TITLEBAR = "k-mediaplayer-titlebar",
		            TITLE = "k-title",
		            TOOLBARWRAP = "k-mediaplayer-toolbar-wrap",
		            TOOLBAR = "k-mediaplayer-toolbar",
		            SLIDER = "k-mediaplayer-seekbar",
		            VOLUME_SLIDER = "k-mediaplayer-volume",
		            MEDIA = "k-mediaplayer-media",
		            OVERLAY = "k-mediaplayer-overlay",
		            YTPLAYER = "k-mediaplayer-yt",
		            DOT = ".",
		            ui = kendo.ui,
		            ns = ".kendoMediaPlayer",
		            baseTime = new Date(1970, 0, 1),
		            timeZoneSec = baseTime.getTimezoneOffset() * 60,
		            Widget = kendo.ui.Widget,
		            isArray = $.isArray,
		            timeFormats = {
		                shortTime: "mm:ss",
		                longTime: "HH:mm:ss"
		            },
		            template = kendo.template,
		            proxy = $.proxy,
		            keys = kendo.keys,
		            templates = {
		                htmlPlayer: "<video class='" + MEDIA + "'> </video>",
		                titleBar: template("<div class='" + TITLEBAR + "' role='heading'><span class='" + TITLE + "'>Video Title</span></div>"),
		                toolBar: "<div class='" + TOOLBARWRAP + "'><div class='" + TOOLBAR + "'></div></div>",
		                youtubePlayer: "<div class='" + YTPLAYER + "'> </div>",
		                toolBarTime: "<span class='k-mediaplayer-currenttime'>00:00:00</span> / <span class='k-mediaplayer-duration'>00:00:00</span>",
		                slider: "<input class='" + SLIDER + "' value='0' title='seekbar' />",
		                volumeSlider: "<input class='" + VOLUME_SLIDER + "' title='volume'/>",
		                qualityDropDown: "<input class='" + VIDEO_QUALITY + "' title='video quality' />",
		                toolTip: "#= kendo.toString(new Date(value), 'HH:mm:ss') #"
		            };
	
		        var MediaPlayer = Widget.extend({
		            init: function (element, options) {
		                this.wrapper = $(element);
	
		                Widget.fn.init.call(this, element, options);
	
		                this.wrapper.addClass("k-mediaplayer k-widget");
	
		                options = this.options;
	
		                this._currentIndex = 0;
	
		                this._createTitlebar();
	
		                this._createToolbar();
	
		                this._createDropDown();
	
		                this._createSlider();
	
		                this._createVolumeSlider();
	
		                this._timers = {};
	
		                this._aria();
	
		                this._navigatable();
	
		                if (options.fullScreen) {
		                    this.fullScreen(true);
		                }
	
		                if (options.media) {
		                    this.media(this.options.media);
		                }
	
		                kendo.notify(this);
		            },
	
		            events: [
		                END,
		                PAUSE,
		                PLAY,
		                READY,
		                TIMECHANGE,
		                VOLUMECHANGE
		            ],
	
		            options: {
		                name: "MediaPlayer",
		                autoPlay: false,
		                autoRepeat: false,
		                volume: 100,
		                fullScreen: false,
		                mute: false,
		                navigatable: false,
		                forwardSeek: true,
		                media: null,
		                messages: {
		                    "pause": "Pause",
		                    "play": "Play",
		                    "mute": "Mute",
		                    "unmute": "Unmute",
		                    "quality": "Quality",
		                    "fullscreen": "Full Screen"
		                }
		            },
	
		            _msToTime: function (ms) {
		                var time = new Date(baseTime.getTime());
		                time.setSeconds(ms);
		                return time;
		            },
	
		            _timeToSec: function (time) {
		                var curTime = new Date(time).getTime();
		                return curTime / 1000;
		            },
	
		            _createTitlebar: function () {
		                this._titleBar = this.wrapper.find(DOT + TITLEBAR);
		                if (this._titleBar.length === 0) {
		                    this.wrapper.append(templates.titleBar);
		                    this._titleBar = this.wrapper.find(DOT + TITLEBAR);
		                }
		            },
	
		            _createSlider: function () {
		                var sliderElement = this.wrapper.find(DOT + SLIDER);
		                if (!this._slider) {
		                    this._sliderDragChangeHandler = proxy(this._sliderDragChange, this);
		                    this._sliderDraggingHandler = proxy(this._sliderDragging, this);
		                    sliderElement = this.wrapper.find(DOT + SLIDER);
	
		                    this._slider = new ui.Slider(sliderElement[0], {
		                        smallStep: 1000,
		                        tickPlacement: "none",
		                        showButtons: false,
		                        change: this._sliderDragChangeHandler,
		                        slide: this._sliderDraggingHandler,
		                        tooltip: {
		                            template: templates.toolTip
		                        },
		                        dragHandleTitle: ""
		                    });
		                }
		            },
	
		            _createVolumeSlider: function () {
		                var volumeSliderElement = this.wrapper.find(DOT + VOLUME_SLIDER);
		                if (!this._volumeSlider) {
		                    this._volumeDraggingHandler = proxy(this._volumeDragging, this);
		                    this._volumeChangeHandler = proxy(this._volumeChange, this);
		                    volumeSliderElement.width(87);
		                    this._volumeSlider = new ui.Slider(volumeSliderElement[0], {
		                        smallStep: 1,
		                        min: 0,
		                        max: 100,
		                        value: this.options.volume,
		                        slide: this._volumeDraggingHandler,
		                        change: this._volumeChangeHandler,
		                        tickPlacement: "none",
		                        showButtons: false,
		                        tooltip: { enabled: false },
		                        dragHandleTitle: ""
		                    });
		                }
		            },
	
		            _resetTime: function () {
		                if (this._youTubeVideo) {
		                    this._ytmedia.seekTo(0, true);
		                } else {
		                    this._media.currentTime = 0;
		                }
	
		                this._mediaTimeUpdate();
		                $.grep(this._toolBar.options.items, function (e) { return !!e.template; }).template = templates.toolBarTime;
		            },
	
		            _currentUrl: function () {
		                var media = this.media();
		                return isArray(media.source) ? media.source[this._currentIndex].url : media.source;
		            },
	
		            _isYouTubeUrl: function () {
		                return !!this._currentUrl().match("youtube.com/|youtu.be/");
		            },
	
		            _setPlayerUrl: function () {
		                var oldPlayer = this._youTubeVideo;
		                this.stop();
	
		                this._youTubeVideo = this._isYouTubeUrl();
	
		                if (oldPlayer !== this._youTubeVideo) {
		                    this.wrapper.find(DOT + YTPLAYER).toggle();
		                    this.wrapper.find(DOT + MEDIA).toggle();
		                }
	
		                var initialized = this._media || this._ytmedia;
	
		                this._initializePlayer();
	
		                if (initialized) { //mute and volume settings should be persisted when switching between html and youtube players
		                    this.mute(this.mute());
		                    this.volume(this.volume());
		                }
	
		                if (!this._youTubeVideo) {
		                    this._videoOverlay.show();
		                    this.wrapper.find(DOT + MEDIA + " > source").remove();
		                    this.wrapper.find(DOT + MEDIA).attr("src", this._currentUrl());
	
		                    if (this.options.autoPlay) {
		                        this.play();
		                    }
		                }
		                else if (this._ytmedia) {
		                    if (this._videoOverlay) {
		                        this._videoOverlay.hide();
		                    }
		                    if (this.options.autoPlay) {
		                        this._ytmedia.loadVideoById(this._getMediaId());
		                        this._playStateToggle(true);
		                    }
		                    else {
		                        this._ytmedia.cueVideoById(this._getMediaId());
		                        this._playStateToggle(true);
		                    }
		                }
		            },
	
		            _createToolbar: function () {
		                var toolBarElement = this.wrapper.find(DOT + TOOLBAR);
		                if (toolBarElement.length === 0) {
		                    this._toolbarClickHandler = proxy(this._toolbarClick, this);
		                    this.wrapper.append(templates.toolBar);
		                    toolBarElement = this.wrapper.find(DOT + TOOLBAR);
		                    toolBarElement.width(this.wrapper.find(DOT + MEDIA).width());
		                    this._toolBar = new ui.ToolBar(toolBarElement, {
		                        click: this._toolbarClickHandler,
		                        resizable: false,
		                        items: [
		                            {
		                                type: "button",
		                                attributes: { "class": "k-play-button" },
		                                icon: "play"
		                            },
		                            {
		                                template: templates.toolBarTime,
		                                attributes: { "class": "k-mediaplayer-currenttime-wrap" }
		                            },
		                            {
		                                type: "separator",
		                                attributes: { "class": "k-toolbar-spacer" }
		                            },
		                            {
		                                type: "button",
		                                attributes: { "class": "k-volume-button" },
		                                icon: "volume-up"
		                            },
		                            {
		                                template: templates.volumeSlider,
		                                attributes: { "class": "k-mediaplayer-volume-wrap" }
		                            },
		                            {
		                                template: templates.qualityDropDown,
		                                attributes: { "class": "k-mediaplayer-quality-wrap" }
		                            },
		                            {
		                                type: "button",
		                                attributes: { "class": "k-fullscreen-button" },
		                                icon: "full-screen"
		                            }
		                        ]
		                    });
	
		                    this._toolBar.wrapper.off("keydown");
		                    toolBarElement.before(templates.slider);
	
		                    this._volumeButton = toolBarElement.find(".k-volume-button");
		                    this._fullscreenButton = toolBarElement.find(".k-fullscreen-button");
		                    this._volumeButton.attr("title", this.options.mute ? this.options.messages.unmute : this.options.messages.mute);
		                    this._volumeButton.attr("aria-label", this.options.mute ? this.options.messages.unmute : this.options.messages.mute);
		                    this._fullscreenButton.attr("title", this.options.messages.fullscreen);
		                    this._fullscreenButton.attr("aria-label", this.options.messages.fullscreen);
	
		                    toolBarElement.width("auto");
		                    this._currentTimeElement = toolBarElement.find(".k-mediaplayer-currenttime");
		                    this._durationElement = toolBarElement.find(".k-mediaplayer-duration");
		                    this._playButton = toolBarElement.find(".k-play-button");
		                    this._playButtonSpan = this._playButton.find(".k-i-play");
	
		                    if (this.options.autoPlay) {
		                        this._playStateToggle(true);
		                    }
	
		                    $([
		                        this._volumeButton[0],
		                        toolBarElement.find(".k-mediaplayer-volume-wrap")[0],
		                        toolBarElement.find(".k-mediaplayer-quality-wrap")[0],
		                        this._fullscreenButton[0]
		                    ]).wrapAll("<div class='k-align-right' />");
		                    toolBarElement.find(".k-button").addClass("k-bare");
		                }
		            },
	
		            _createDropDown: function () {
		                var dropDownElement = this.wrapper.find(DOT + VIDEO_QUALITY);
		                var media = this.media();
		                if (typeof dropDownElement.data("kendoDropDownList") === "undefined") {
		                    this._dropDownSelectHandler = proxy(this._dropDownSelect, this);
		                    this._dropDown = new ui.DropDownList(dropDownElement, {
		                        dataTextField: "quality",
		                        dataValueField: "url",
		                        popup: {
		                            position: "bottom",
		                            origin: "top",
		                            appendTo: this.wrapper
		                        },
		                        animation: {
		                            open: {
		                                effects: "slideIn:up",
		                                duration: 1
		                            }
		                        },
		                        select: this._dropDownSelectHandler
		                    });
	
		                    if (media && isArray(media.source)) {
		                        this._dropDown.setDataSource(media.source);
		                        this._dropDown.select(0);
		                    }
	
		                    this._dropDown.wrapper.addClass("k-button k-bare");
		                    this._dropDown.wrapper.attr("title", this.options.messages.quality).hide();
		                    this._dropDown.wrapper.find("span.k-i-arrow-60-down")
		                        .removeClass('k-i-arrow-60-down')
		                        .addClass('k-icon k-i-hd');
		                    this._dropDown.list.addClass("k-quality-list");
		                }
		            },
	
		            _dropDownSelect: function (e) {
		                if (this._currentIndex !== e.item.index()) {
		                    this._currentIndex = e.item.index();
		                    this._setPlayerUrl();
		                }
		            },
	
		            _toolbarClick: function (e) {
		                var target = $(e.target).children().first();
		                var isPaused = target.hasClass(STATE_PLAY);
	
		                if (!this.media()) {
		                    return;
		                }
	
		                if (target.hasClass(STATE_PLAY) || target.hasClass(STATE_PAUSE)) {
		                    if (isPaused) {
		                        this.play();
		                    }
		                    else {
		                        this.pause();
		                    }
		                }
	
		                if (target.hasClass(FULLSCREEN_ENTER) || target.hasClass(FULLSCREEN_EXIT)) {
		                    if (this._isInFullScreen) {
		                        target
		                            .removeClass(FULLSCREEN_EXIT)
		                            .addClass(FULLSCREEN_ENTER);
		                        this.fullScreen(false);
		                    } else {
		                        target
		                            .removeClass(FULLSCREEN_ENTER)
		                            .addClass(FULLSCREEN_EXIT);
		                        this.fullScreen(true);
		                    }
		                }
	
		                if (target.hasClass(MUTE) || target.hasClass(LOW_VOLUME) || target.hasClass(HIGH_VOLUME)) {
		                    var muted = this.mute();
		                    this.mute(!muted);
		                }
		            },
	
		            _sliderDragging: function () {
		                if (!this.media()) {
		                    return;
		                }
	
		                this._isDragging = true;
		            },
	
		            _sliderDragChange: function (e) {
		                var that = this;
		                var slider = e.sender;
		                var tzOffset = timeZoneSec * 1000;
	
		                if (!this.media()) {
		                    return;
		                }
	
		                that._sliderChangeFired = true;
		                that._isDragging = false;
	
		                if (!this.options.forwardSeek && slider.value() > this._seekBarLastPosition) {
		                    setTimeout(function () {
		                        slider.value(that._seekBarLastPosition);
		                    }, 1);
		                } else if (this._youTubeVideo) {
		                    that._ytmedia.seekTo(that._timeToSec(e.value - tzOffset));
		                } else {
		                    that._media.currentTime = that._timeToSec(e.value - tzOffset);
		                }
		                that.trigger(TIMECHANGE);
		                that._preventPlay = true;
		            },
	
		            _changeVolumeButtonImage: function (volume) {
		                var volumeButton = this._volumeButton;
		                var volumeElement = volumeButton.find("span");
		                var cssClass = volumeElement.attr("class");
		                cssClass = cssClass.substring(0, cssClass.lastIndexOf(" "));
	
		                if (volume === 0) {
		                    volumeElement.attr("class", cssClass + " " + MUTE);
		                    volumeButton.attr("title", this.options.messages.unmute);
		                    volumeButton.attr("aria-label", this.options.messages.unmute);
		                } else if (volume > 0 && volume < 51) {
		                    volumeElement.attr("class", cssClass + " " + LOW_VOLUME);
		                    volumeButton.attr("title", this.options.messages.mute);
		                    volumeButton.attr("aria-label", this.options.messages.mute);
		                } else {
		                    volumeElement.attr("class", cssClass + " " + HIGH_VOLUME);
		                    volumeButton.attr("title", this.options.messages.mute);
		                    volumeButton.attr("aria-label", this.options.messages.mute);
		                }
		            },
	
		            _volumeDragging: function (e) {
		                if (!this.media()) {
		                    return;
		                }
		                this.volume(e.value);
		                this._changeVolumeButtonImage(e.value);
		                this.trigger(VOLUMECHANGE);
		            },
	
		            _volumeChange: function (e) {
		                if (!this.media()) {
		                    return;
		                }
		                this.volume(e.value);
		                this._changeVolumeButtonImage(e.value);
		                this.trigger(VOLUMECHANGE);
		            },
	
		            _mediaTimeUpdate: function () {
		                var currentTime = (this._youTubeVideo) ? this._ytmedia.getCurrentTime() : this._media.currentTime;
		                currentTime = currentTime ? currentTime : 0;
		                var timeInMs = this._msToTime(currentTime);
		                this._currentTimeElement.text(kendo.toString(timeInMs, this._timeFormat));
		                if (!this._isDragging) {
		                    this._seekBarLastPosition = (currentTime + timeZoneSec) * 1000;
		                    this._slider.value(this._seekBarLastPosition);
		                }
	
		                return this.isPlaying();
		            },
	
		            _playStateToggle: function (play) {
		                if (typeof play === "undefined") {
		                    play = this._playButtonSpan.is(DOT + STATE_PLAY);
		                }
	
		                if (play) {
		                    this._playButtonSpan
		                        .removeClass(STATE_PLAY)
		                        .addClass(STATE_PAUSE);
		                    this._playButton.attr("title", this.options.messages.pause);
		                    this._playButton.attr("aria-label", this.options.messages.pause);
		                }
		                else {
		                    this._playButtonSpan
		                        .removeClass(STATE_PAUSE)
		                        .addClass(STATE_PLAY);
		                    this._playButton.attr("title", this.options.messages.play);
		                    this._playButton.attr("aria-label", this.options.messages.play);
		                }
		            },
	
		            _mediaEnded: function () {
		                this._playStateToggle(false);
		                this._currentTimeElement.text(kendo.toString(this._msToTime(0), this._timeFormat));
		                this._slider.value((0 + timeZoneSec) * 1000);
		                this.trigger(END);
		            },
	
		            _mediaPlay: function () {
		                this.trigger(PLAY);
		            },
	
		            _mediaReady: function () {
		                this.trigger(READY);
		            },
	
		            _mediaDurationChange: function () {
		                var durationTime = this._msToTime((this._youTubeVideo) ? this._ytmedia.getDuration() : this._media.duration);
	
		                this._timeFormat = durationTime.getHours() === 0 ? timeFormats.shortTime : timeFormats.longTime;
	
		                this._durationElement.text(kendo.toString(durationTime, this._timeFormat));
		                this._slider.setOptions({
		                    min: baseTime.getTime(),
		                    max: durationTime.getTime()
		                });
	
		                if (!this._isFirstRun) {
		                    this._resetTime();
		                    this._isFirstRun = true;
		                }
		            },
	
		            _createYoutubePlayer: function () {
		                this._mediaTimeUpdateHandler = proxy(this._mediaTimeUpdate, this);
		                this._mediaDurationChangeHandler = proxy(this._mediaDurationChange, this);
	
		                this.wrapper.prepend(templates.youtubePlayer);
		                this._ytPlayer = this.wrapper.find(DOT + YTPLAYER)[0];
		                $(this._ytPlayer)
		                    .css({
		                        width: this.wrapper.width(),
		                        height: this.wrapper.height()
		                    });
	
		                if (!window.YT || !window.YT.Player) {
		                    if (!window.onYouTubeIframeAPIReadyRegister) {
		                        window.onYouTubeIframeAPIReadyRegister = [];
		                        $.getScript("https://www.youtube.com/iframe_api");
		                        window.onYouTubeIframeAPIReady =
		                            function () {
		                                if (window.onYouTubeIframeAPIReadyRegister) {
		                                    for (var i = 0; i < window.onYouTubeIframeAPIReadyRegister.length; i++) {
		                                        window.onYouTubeIframeAPIReadyRegister[i]._youtubeApiReady();
		                                    }
		                                }
		                                window.onYouTubeIframeAPIReadyRegister.length = 0;
		                                window.onYouTubeIframeAPIReadyRegister = undefined;
		                            };
		                    }
		                    window.onYouTubeIframeAPIReadyRegister[window.onYouTubeIframeAPIReadyRegister.length] = this;
		                }
		                else {
		                    this._configurePlayer();
		                }
		            },
	
		            _poll: function (name, callback, interval, context) {
		                var that = this;
	
		                if (that._timers[name] !== null) {
		                    clearTimeout(that._timers[name]);
		                }
	
		                that._timers[name] = setTimeout((function (context) {
		                    return function callLater() {
		                        if (callback.call(context)) {
		                            that._timers[name] = setTimeout(callLater, interval);
		                        }
		                    };
		                })(context), interval);
	
		                return that._timers[name];
		            },
	
		            _youtubeApiReady: function () {
		                this._configurePlayer();
		            },
	
		            _configurePlayer: function () {
		                var vars = {
		                    'autoplay': +this.options.autoPlay,
		                    'wmode': 'transparent',
		                    'controls': 0,
		                    'rel': 0,
		                    'showinfo': 0
		                };
	
		                this._onYouTubePlayerReady = proxy(this._onYouTubePlayerReady, this);
		                window.onYouTubePlayerReady = this._onYouTubePlayerReady;
		                this._onPlayerStateChangeHandler = proxy(this._onPlayerStateChange, this);
		                window.onPlayerStateChange = this._onPlayerStateChange;
	
		                /*jshint unused:false */
		                var player = new window.YT.Player(this.wrapper.find(DOT + YTPLAYER)[0], {
		                    height: this.wrapper.height(),
		                    width: this.wrapper.width(),
		                    videoId: this._getMediaId(),
		                    playerVars: vars,
		                    events: {
		                        'onReady': this._onYouTubePlayerReady,
		                        'onStateChange': this._onPlayerStateChangeHandler
		                    }
		                });
		            },
	
		            _onYouTubePlayerReady: function (event) {
		                this._ytmedia = event.target;
		                this._ytmedia.getIframe().style.width = "100%";
		                this._ytmedia.getIframe().style.height = "100%";
		                this._youTubeVideo = true;
		                this._mediaDurationChangeHandler();
	
		                if (this.options.autoPlay) {
		                    this._playStateToggle(true);
		                    this._ytmedia.loadVideoById(this._getMediaId());
		                }
		                else {
		                    this._ytmedia.cueVideoById(this._getMediaId());
		                }
	
		                if (this.options.mute) {
		                    this.mute(true);
		                }
	
		                this.trigger(READY);
		            },
	
		            _updateTitle: function () {
		                this.titlebar().text(this.media().title || this.media().source);
		            },
	
		            _onPlayerStateChange: function (event) {
	
		                if (event.data === 0) {
		                    this._slider.value(0);
		                    this._paused = false;
		                    this._playStateToggle(true);
		                    this.trigger(END);
		                    if (this.options.autoRepeat) {
		                        this.play();
		                    }
		                }
		                else if (event.data === 1) {
		                    this._mediaDurationChange();
		                    this._ytmedia.setVolume(this.volume());
		                    if (this._sliderChangeFired) {
		                        this._sliderChangeFired = false;
		                    } else {
		                        this._uiDisplay(false);
		                    }
		                    this.trigger(PLAY);
		                    this._playStateToggle(true);
	
		                    this._poll("progress", this._mediaTimeUpdate, 500, this);
		                    this._paused = false;
		                }
		                else if (event.data === 2) {
		                    if (!this._paused) {
		                        this._uiDisplay(true);
		                        this._playStateToggle(false);
		                        this.trigger(PAUSE);
		                        this._paused = true;
		                    }
		                }
		            },
	
		            _getMediaId: function () {
		                var result = this._currentUrl();
		                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		                var match = result.match(regExp);
	
		                if (match && match[7].length === 11) {
		                    result = match[7];
		                }
	
		                return result;
		            },
	
		            _mouseClick: function () {
		                if (this.isPaused()) {
		                    this.play();
		                } else {
		                    this.pause();
		                }
		            },
	
		            _initializePlayer: function () {
		                if (!this._mouseMoveHandler) {
		                    this._mouseMoveHandler = proxy(this._mouseMove, this);
		                    this._mouseInHandler = proxy(this._mouseIn, this);
		                    this._mouseOutHandler = proxy(this._mouseOut, this);
	
		                    $(this.wrapper)
		                        .on("mouseenter" + ns, this._mouseInHandler)
		                        .on("mouseleave" + ns, this._mouseOutHandler)
		                        .on("mousemove" + ns, this._mouseMoveHandler);
		                }
	
		                if (!this._ytmedia && this._youTubeVideo) {
		                    this._createYoutubePlayer();
		                }
		                else if (!this._media && !this._youTubeVideo) {
		                    this._createHtmlPlayer();
		                }
		            },
	
		            _createHtmlPlayer: function () {
		                if (!this._videoOverlay) {
		                    this._mouseClickHanlder = proxy(this._mouseClick, this);
		                    this.wrapper.append("<div class='" + OVERLAY + "'></div>");
		                    this._videoOverlay = this.wrapper.find(".k-mediaplayer-overlay")
		                        .on("click" + ns, this._mouseClickHanlder);
		                }
	
		                this._mediaTimeUpdateHandler = proxy(this._mediaTimeUpdate, this);
		                this._mediaDurationChangeHandler = proxy(this._mediaDurationChange, this);
		                this._mediaEndedHandler = proxy(this._mediaEnded, this);
		                this._mediaCanPlayHandler = proxy(this._mediaReady, this);
		                this._mediaPlayHandler = proxy(this._mediaPlay, this);
		                this._videoOverlay.after(templates.htmlPlayer);
		                this._media = this.wrapper.find(DOT + MEDIA)[0];
		                $(this._media)
		                    .css({
		                        width: "100%",
		                        height: "100%"
		                    });
	
		                if (this.options.mute) {
		                    this.mute(true);
		                }
	
		                this._media.ontimeupdate = this._mediaTimeUpdateHandler;
		                this._media.ondurationchange = this._mediaDurationChangeHandler;
		                this._media.oncanplay = this._mediaCanPlayHandler;
		                this._media.onplay = this._mediaPlayHandler;
		                this._media.onended = this._mediaEndedHandler;
		                this._media.loop = this.options.autoRepeat;
		            },
	
		            _mouseIn: function () {
		                this._uiDisplay(true);
		            },
	
		            _mouseOut: function () {
		                this._poll("mouseIdle", this._mouseIdle, 3000, this);
		            },
	
		            _mouseIdle: function () {
		                this._uiDisplay(false);
		                return false;
		            },
	
		            _mouseMove: function () {
		                if (!(this._titleBar.is(':animated') || this._toolBar.element.is(':animated') || this._slider.wrapper.is(':animated'))) {
		                    this._uiDisplay(true);
		                }
		                this._poll("mouseIdle", this._mouseIdle, 3000, this);
		            },
	
		            _uiDisplay: function (state) {
		                var animationSpeed = 'slow';
		                var uiElements = this._titleBar
		                    .add(this._toolBar.element.parent());
	
		                if (state) {
		                    uiElements.fadeIn(animationSpeed);
		                }
		                else {
		                    uiElements.fadeOut(animationSpeed);
		                    if (this.options.navigatable) {
		                        this.wrapper.focus();
		                    }
		                }
		            },
	
		            setOptions: function (options) {
		                Widget.fn.setOptions.call(this, options);
		            },
	
		            destroy: function () {
		                Widget.fn.destroy.call(this);
	
		                if (!this.isPaused()) {
		                    this.pause();
		                }
	
		                this.element.off(ns);
		                this.element.find(DOT + OVERLAY).off(ns);
		                this._timers = null;
		                this._mouseMoveHandler = null;
		                this._mouseOutHandler = null;
		                this._mouseInHandler = null;
		                this._mouseClickHanlder = null;
		                this._keyDownHandler = null;
		                this._fullscreenHandler = null;
	
		                this._toolbarClickHandler = null;
		                this._sliderDragChangeHandler = null;
		                this._sliderDraggingHandler = null;
		                this._volumeDraggingHandler = null;
		                this._volumeChangeHandler = null;
		                this._youtubeApiReadyHandler = null;
		                this._onYouTubePlayerReady = null;
		                this._onPlayerStateChangeHandler = null;
		                this._dropDownSelectHandler = null;
	
		                if (this._youTubeVideo) {
		                    this._ytmedia.destroy();
		                }
		                else {
		                    this._media.ontimeupdate = this._mediaTimeUpdateHandler = null;
		                    this._media.ondurationchange = this._mediaDurationChangeHandler = null;
		                    this._media.oncanplay = this._mediaCanPlayHandler = null;
		                    this._media.onplay = this._mediaPlayHandler = null;
		                    this._media.onended = this._mediaEndedHandler = null;
		                    this._media.src = "";
		                    this._media.remove();
		                }
	
		                this._mouseMoveTimer = null;
		                clearTimeout(this._mouseMoveTimer);
	
		                kendo.destroy(this.element);
		            },
	
		            seek: function (ms) {
		                if (typeof ms === 'undefined') {
		                    return 1000 * (this._youTubeVideo) ? this._ytmedia.getCurrentTime() : (this._media ? this._media.currentTime : 0);
		                }
		                var seconds = ms / 1000;
		                if (this._youTubeVideo) {
		                    if (seconds + 3 >= this._ytmedia.getDuration() | 0) {
		                        //avoid infinite bad request loop in youtube player.
		                        this._ytmedia.seekTo(this._ytmedia.getDuration() - 3 | 0, true);
		                    } else {
		                        this._ytmedia.seekTo(seconds, true);
		                    }
		                } else {
		                    this._media.currentTime = seconds;
		                }
	
		                return this;
		            },
	
		            play: function () {
		                if (this._youTubeVideo) {
		                    this._ytmedia.playVideo();
		                } else {
		                    if (kendo.support.mobileOS) {
		                        this._uiDisplay(false);
		                    }
		                    this._media.play();
		                }
		                this._paused = false;
	
		                this._playStateToggle(true);
	
		                return this;
		            },
	
		            stop: function () {
		                if (this._youTubeVideo && this._ytmedia) {
		                    this._ytmedia.stopVideo();
		                } else if (this._media && !this._youTubeVideo) {
		                    if (kendo.support.mobileOS) {
		                        this._uiDisplay(true);
		                    }
		                    this._media.pause();
		                    this._media.currentTime = 0;
		                }
		                this._paused = true;
	
		                this._playStateToggle(false);
		                return this;
		            },
	
		            pause: function () {
		                if (this._youTubeVideo) {
		                    this._ytmedia.pauseVideo();
		                } else {
		                    if (kendo.support.mobileOS) {
		                        this._uiDisplay(true);
		                    }
		                    this._media.pause();
		                }
		                this._paused = true;
		                this._playStateToggle(false);
		                this.trigger(PAUSE);
		                return this;
		            },
	
		            toolbar: function () {
		                return this._toolBar;
		            },
	
		            dropdown: function () {
		                return this._dropDown;
		            },
	
		            titlebar: function () {
		                return this._titleBar;
		            },
	
		            fullScreen: function (enterFullScreen) {
		                if (typeof enterFullScreen === 'undefined') {
		                    return this._isInFullScreen || false;
		                }
		                var element = this.element.get(0);
		                if (enterFullScreen) {
		                    // Handles the case when the action is triggered by code and not by user iteraction
		                    this.element.addClass("k-mediaplayer-fullscreen");
		                    if (element.requestFullscreen) {
		                        element.requestFullscreen();
		                    } else if (element.webkitRequestFullscreen) {
		                        element.webkitRequestFullscreen();
		                    } else if (element.mozRequestFullScreen) {
		                        element.mozRequestFullScreen();
		                    } else if (element.msRequestFullscreen) {
		                        element.msRequestFullscreen();
		                    }
		                    this._isInFullScreen = true;
		                } else {
	
		                    if (document.cancelFullscreen) {
		                        document.cancelFullscreen();
		                    } else if (document.webkitCancelFullScreen) {
		                        document.webkitCancelFullScreen();
		                    } else if (document.mozCancelFullScreen) {
		                        document.mozCancelFullScreen();
		                    } else if (document.msCancelFullscreen) {
		                        document.msCancelFullscreen();
		                    } else if (document.exitFullscreen) {
		                        document.exitFullscreen();
		                    } else if (document.msExitFullscreen) {
		                        document.msExitFullscreen();
		                    }
		                    // Handles the case when the action is triggered by code and not by user iteraction
		                    this.element.removeClass("k-mediaplayer-fullscreen");
		                    this._isInFullScreen = false;
		                }
		                this._slider.resize();
		            },
	
		            volume: function (value) {
		                if (typeof value === 'undefined') {
		                    return (typeof this._volume !== 'undefined') ? this._volume : this._volume = this.options.volume;
		                }
		                this._volume = value;
		                this.mute(value <= 0);
	
		                if (this._youTubeVideo) {
		                    this._ytmedia.setVolume(this._volume);
		                } else {
		                    this._media.volume = this._volume / 100;
		                }
	
		                this._volumeSlider.value(value);
		            },
	
		            mute: function (muted) {
		                var currentState = this._youTubeVideo ? (this._ytmedia && this._ytmedia.isMuted()) : (this._media && this._media.muted);
		                if (typeof muted === 'undefined' || muted === currentState) {
		                    return currentState;
		                }
		                if (this._youTubeVideo) {
		                    if (muted) {
		                        this._ytmedia.mute();
		                    }
		                    else {
		                        this._ytmedia.unMute();
		                    }
		                }
		                else {
		                    this._media.muted = muted;
		                }
	
		                if (muted) {
		                    this._volumeSlider.value(0);
		                }
		                else {
		                    this._volumeSlider.value((this._media && this._media.volume * 100) || (this._ytmedia && this._ytmedia.getVolume()));
		                }
		                this.trigger(VOLUMECHANGE);
		                this._changeVolumeButtonImage(this._volumeSlider.value());
		            },
	
		            isEnded: function () {
		                if (this._youTubeVideo) {
		                    return this._ytmedia.getPlayerState() === 0;
		                } else {
		                    return this._media.ended;
		                }
		            },
	
		            media: function (value) {
		                var dropdown = this.dropdown();
		                if (typeof value === 'undefined') {
		                    return (typeof this._mediaData !== 'undefined') ? this._mediaData : this._mediaData = this.options.media;
		                }
	
		                if (isArray(value.source)) {
		                    dropdown.setDataSource(value.source);
		                    dropdown.wrapper.show();
		                }
		                else {
		                    dropdown.wrapper.hide();
		                }
	
		                this._mediaData = value;
	
		                this._updateTitle();
	
		                this._setPlayerUrl();
		            },
	
		            isPaused: function () {
		                return this._paused;
		            },
	
		            isPlaying: function () {
		                return !this.isEnded() && !this._paused;
		            },
	
		            _aria: function () {
		                this.wrapper.attr("role", "region");
		                //this.wrapper.attr("aria-labelledby", "mediaplayerTitleBar");
		                //add onfocus with aria active descendant
		            },
	
		            _navigatable: function () {
		                this._fullscreenHandler = proxy(this._fullscreen, this);
		                $(document)
		                    .on("webkitfullscreenchange mozfullscreenchange fullscreenchange" + ns, this._fullscreenHandler);
	
		                if (this.options.navigatable) {
		                    this.wrapper.attr("tabIndex", 0);
		                    this._keyDownHandler = proxy(this._keyDown, this);
		                    this.wrapper
		                        .on("keydown" + ns, this._keyDownHandler);
		                }
		            },
	
		            _fullscreen: function () {
		                var isFullScreen = document.fullScreen ||
		                    document.mozFullScreen ||
		                    document.webkitIsFullScreen;
	
		                this._uiDisplay(true);
		                this._slider.resize();
	
		                if (!isFullScreen) {
		                    this.wrapper.find('span[class*="k-i-fullscreen"]')
		                        .removeClass(FULLSCREEN_EXIT)
		                        .addClass(FULLSCREEN_ENTER);
		                    this.fullScreen(false);
		                }
		            },
	
		            _keyDown: function (e) {
		                e.preventDefault();
		                var fsButton = this.wrapper.find('span[class*="k-i-fullscreen"]');
		                if (e.keyCode === keys.SPACEBAR) {
		                    if (this.isPlaying()) {
		                        this.pause();
		                    }
		                    else {
		                        this.play();
		                    }
		                }
		                else if (e.keyCode === keys.ENTER && !this._isInFullScreen) {
		                    fsButton
		                        .removeClass(FULLSCREEN_ENTER)
		                        .addClass(FULLSCREEN_EXIT);
		                    this.fullScreen(true);
		                }
		                else if (e.keyCode === 77) {
		                    var muted = this.mute();
		                    this.mute(!muted);
		                }
		                else if (e.keyCode === keys.ESC && this._isInFullScreen) {
		                    fsButton
		                        .removeClass(FULLSCREEN_EXIT)
		                        .addClass(FULLSCREEN_ENTER);
		                    this.fullScreen(false);
		                }
		            },
	
		            _error: function () {
		            },
	
		            _progress: function () {
		            }
	
		        });
	
		        ui.plugin(MediaPlayer);
	
		    })(window.kendo.jQuery);
	
		    return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1215:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(634);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1265);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1042:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(581);
	
	/***/ }),
	
	/***/ 1138:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1265:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1266), __webpack_require__(1042), __webpack_require__(1138), __webpack_require__(1267), __webpack_require__(1008) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "pivot.fieldmenu",
		    name: "PivotFieldMenu",
		    category: "web",
		    description: "The PivotFieldMenu widget allows the user to filter on fields displayed in PivotGrid",
		    depends: [ "menu", "window", "treeview", "dropdownlist" ],
		    advanced: true
		};
	
		/*jshint eqnull: true*/
		(function($, undefined) {
		    var kendo = window.kendo;
		    var ui = kendo.ui;
		    var MENU = "kendoContextMenu";
		    var proxy = $.proxy;
		    var NS = ".kendoPivotFieldMenu";
		    var Widget = ui.Widget;
		    var FILTER_ITEM = "k-filter-item";
		    var ARIA_LABEL = "aria-label";
	
		    var PivotFieldMenu = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this._dataSource();
	
		            this._layout();
	
		            kendo.notify(this);
		        },
	
		        events: [],
	
		        options: {
		            name: "PivotFieldMenu",
		            filter: null,
		            filterable: true,
		            sortable: true,
		            messages: {
		                info: "Show items with value that:",
		                sortAscending: "Sort Ascending",
		                sortDescending: "Sort Descending",
		                filterFields: "Fields Filter",
		                filter: "Filter",
		                include: "Include Fields...",
		                title: "Fields to include",
		                clear: "Clear",
		                ok: "OK",
		                cancel: "Cancel",
		                operators: {
		                    contains: "Contains",
		                    doesnotcontain: "Does not contain",
		                    startswith: "Starts with",
		                    endswith: "Ends with",
		                    eq: "Is equal to",
		                    neq: "Is not equal to"
		                }
		            }
		        },
	
		        _layout: function() {
		            var options = this.options;
	
		            this.wrapper = $(kendo.template(MENUTEMPLATE)({
		                ns: kendo.ns,
		                filterable: options.filterable,
		                sortable: options.sortable,
		                messages: options.messages
		            }));
	
		            this.menu = this.wrapper[MENU]({
		                filter: options.filter,
		                target: this.element,
		                orientation: "vertical",
		                showOn: "click",
		                closeOnClick: false,
		                open: proxy(this._menuOpen, this),
		                select: proxy(this._select, this),
		                copyAnchorStyles: false
		            }).data(MENU);
	
		            this._createWindow();
	
		            if (options.filterable) {
		                this._initFilterForm();
		            }
		        },
	
		        _initFilterForm: function() {
		            var filterForm = this.menu.element.find("." + FILTER_ITEM);
		            var filterProxy = proxy(this._filter, this);
	
		            this._filterOperator = new kendo.ui.DropDownList(filterForm.find("select"));
		            this._filterValue = filterForm.find(".k-textbox");
		            this._updateFilterAriaLabel();
	
		            filterForm
		                .on("submit" + NS, filterProxy)
		                .on("click" + NS, ".k-button-filter", filterProxy)
		                .on("click" + NS, ".k-button-clear", proxy(this._reset, this));
		        },
	
		        _setFilterForm: function(expression) {
		            var filterOperator = this._filterOperator;
		            var operator = "";
		            var value = "";
	
		            if (expression) {
		                operator = expression.operator;
		                value = expression.value;
		            }
	
		            filterOperator.value(operator);
		            if (!filterOperator.value()) {
		                filterOperator.select(0);
		            }
	
		            this._filterValue.val(value);
		        },
	
		        _clearFilters: function(member) {
		            var filter = this.dataSource.filter() || {};
		            var expressions;
		            var idx = 0;
		            var length;
	
		            filter.filters = filter.filters || [];
		            expressions = findFilters(filter, member);
	
		            for (length = expressions.length; idx < length; idx++) {
		                filter.filters.splice(filter.filters.indexOf(expressions[idx]), 1);
		            }
	
		            return filter;
		        },
	
		        _convert: function(value) {
		            var schema = this.dataSource.options.schema;
		            var field = ((schema.model || {}).fields || {})[this.currentMember];
	
		            if (field) {
		                if (field.type === "number") {
		                    value = parseFloat(value);
		                } else if (field.type === "boolean") {
		                    value = Boolean($.parseJSON(value));
		                }
		            }
	
		            return value;
		        },
	
		        _filter: function(e) {
		            var that = this;
		            var value = that._convert(that._filterValue.val());
	
		            e.preventDefault();
	
		            if (value === "") {
		                that.menu.close();
		                return;
		            }
	
		            var expression = {
		                field: that.currentMember,
		                operator: that._filterOperator.value(),
		                value: value
		            };
		            var filter = that._clearFilters(that.currentMember);
	
		            filter.filters.push(expression);
	
		            that.dataSource.filter(filter);
		            that.menu.close();
		        },
	
		        _updateFilterAriaLabel: function () {
		            var filterForm = this.menu.element.find("." + FILTER_ITEM);
		            var selectedOperator = this._filterOperator.value();
		            var selectedOperatorName = this.options.messages.operators[selectedOperator];
	
		            filterForm.find("select").attr(ARIA_LABEL, selectedOperatorName);
		        },
	
		        _reset: function(e) {
		            var that = this;
		            var filter = that._clearFilters(that.currentMember);
	
		            e.preventDefault();
	
		            if (!filter.filters[0]) {
		                filter = {};
		            }
	
		            that.dataSource.filter(filter);
		            that._setFilterForm(null);
		            that.menu.close();
		        },
	
		        _sort: function(dir) {
		            var field = this.currentMember;
		            var expressions = (this.dataSource.sort() || []);
	
		            expressions = removeExpr(expressions, field);
		            expressions.push({
		                field: field,
		                dir: dir
		            });
	
		            this.dataSource.sort(expressions);
		            this.menu.close();
		        },
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
	
		            this._dataSource();
		        },
	
		        _dataSource: function() {
		            this.dataSource = kendo.data.PivotDataSource.create(this.options.dataSource);
		        },
	
		        _createWindow: function() {
		            var messages = this.options.messages;
	
		            this.includeWindow = $(kendo.template(WINDOWTEMPLATE)({
		                messages: messages
		            }))
		            .on("click" + NS, ".k-button-ok", proxy(this._applyIncludes, this))
		            .on("click" + NS, ".k-button-cancel", proxy(this._closeWindow, this));
	
		            this.includeWindow = new ui.Window(this.includeWindow, {
		                title: messages.title,
		                visible: false,
		                resizable: false,
		                open: proxy(this._windowOpen, this)
		            });
		        },
	
		        _applyIncludes: function(e) {
		            var checkedNodes = [];
		            var resultExpression;
		            var view = this.treeView.dataSource.view();
		            var rootChecked = view[0].checked;
		            var filter = this.dataSource.filter();
		            var existingExpression = findFilters(filter, this.currentMember, "in")[0];
	
		            checkedNodeIds(view, checkedNodes);
	
		            if (existingExpression) {
		                if (rootChecked) {
		                    filter.filters.splice(filter.filters.indexOf(existingExpression), 1);
		                    if (!filter.filters.length) {
		                        filter = {};
		                    }
		                } else {
		                    existingExpression.value = checkedNodes.join(",");
		                }
	
		                resultExpression = filter;
		            }
	
		            if (checkedNodes.length) {
		                if (!resultExpression && !rootChecked) {
		                    resultExpression = {
		                        field: this.currentMember,
		                        operator: "in",
		                        value: checkedNodes.join(",")
		                    };
	
		                    if (filter) {
		                        filter.filters.push(resultExpression);
		                        resultExpression = filter;
		                    }
		                }
		            }
	
		            if (resultExpression) {
		                this.dataSource.filter(resultExpression);
		            }
	
		            this._closeWindow(e);
		        },
	
		        _closeWindow: function(e) {
		            e.preventDefault();
	
		            this.includeWindow.close();
		        },
	
		        _treeViewDataSource: function() {
		            var that = this;
	
		            return kendo.data.HierarchicalDataSource.create({
		                schema: {
		                    model: {
		                        id: "uniqueName",
		                        hasChildren: function(item) {
		                            return parseInt(item.childrenCardinality, 10) > 0;
		                        }
		                    }
		                },
		                transport: {
		                    read: function(options) {
		                        var restrictions = {};
		                        var node = that.treeView.dataSource.get(options.data.uniqueName);
		                        var name = options.data.uniqueName;
	
		                        if (!name) {
		                            restrictions.levelUniqueName = that.currentMember + ".[(ALL)]";
		                        } else {
		                            restrictions.memberUniqueName = node.uniqueName.replace(/\&/g, "&amp;");
		                            restrictions.treeOp = 1;
		                        }
	
		                        that.dataSource
		                            .schemaMembers(restrictions)
		                            .done(function (data) {
		                                checkNodes(that.dataSource.filter(), that.currentMember, data);
	
		                                options.success(data);
		                            })
		                            .fail(options.error);
		                    }
		                }
		            });
		        },
	
		        _createTreeView: function(element) {
		            var that = this;
	
		            that.treeView =  new ui.TreeView(element, {
		                autoBind: false,
		                dataSource: that._treeViewDataSource(),
		                dataTextField: "caption",
		                template: "#: data.item.caption || data.item.name #",
		                checkboxes: {
		                    checkChildren: true
		                },
		                dataBound: function() {
		                    ui.progress(that.includeWindow.element, false);
		                }
		            });
		        },
	
		        _menuOpen: function(e) {
		            if (!e.event) {
		                return;
		            }
	
		            var attr = kendo.attr("name");
	
		            this.currentMember = $(e.event.target).closest("[" + attr + "]").attr(attr);
	
		            if (this.options.filterable) {
		                this._setFilterForm(findFilters(this.dataSource.filter(), this.currentMember)[0]);
		            }
		        },
	
		        _select: function(e) {
		            var item = $(e.item);
	
		            $(".k-pivot-filter-window").not(this.includeWindow.element).kendoWindow("close");
	
		            if (item.hasClass("k-include-item")) {
		                this.includeWindow.center().open();
		            } else if (item.hasClass("k-sort-asc")) {
		                this._sort("asc");
		            } else if (item.hasClass("k-sort-desc")) {
		                this._sort("desc");
		            } else if (item.hasClass(FILTER_ITEM)) {
		                this._updateFilterAriaLabel();
		            }
		        },
	
		        _windowOpen: function() {
		            if (!this.treeView) {
		                this._createTreeView(this.includeWindow.element.find(".k-treeview"));
		            }
	
		            ui.progress(this.includeWindow.element, true);
		            this.treeView.dataSource.read();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            if (this.menu) {
		                this.menu.destroy();
		                this.menu = null;
		            }
	
		            if (this.treeView) {
		                this.treeView.destroy();
		                this.treeView = null;
		            }
	
		            if (this.includeWindow) {
		                this.includeWindow.destroy();
		                this.includeWindow = null;
		            }
	
		            this.wrapper = null;
		            this.element = null;
		        }
		    });
	
		    function removeExpr(expressions, name) {
		        var result = [];
	
		        for (var idx = 0, length = expressions.length; idx < length; idx++) {
		            if (expressions[idx].field !== name) {
		                result.push(expressions[idx]);
		            }
		        }
	
		        return result;
		    }
	
		    function findFilters(filter, member, operator) {
		        if (!filter) {
		            return [];
		        }
	
		        filter = filter.filters;
	
		        var idx = 0;
		        var result = [];
		        var length = filter.length;
		        var filterOperator;
	
		        for ( ; idx < length; idx++) {
		            filterOperator = filter[idx].operator;
	
		            if (((!operator && filterOperator !== "in") || (filterOperator === operator)) && filter[idx].field === member) {
		                result.push(filter[idx]);
		            }
		        }
	
		        return result;
		    }
	
		    function checkNodes(filter, member, nodes) {
		        var values, idx = 0, length = nodes.length;
		        filter = findFilters(filter, member, "in")[0];
	
		        if (!filter) {
		            for (; idx < length; idx++) {
		                nodes[idx].checked = true;
		            }
		        } else {
		            values = filter.value.split(",");
		            for (; idx < length; idx++) {
		                nodes[idx].checked = $.inArray(nodes[idx].uniqueName, values) >= 0;
		            }
		        }
		    }
	
		    function checkedNodeIds(nodes, checkedNodes) {
		        var idx, length = nodes.length;
	
		        for (idx = 0; idx < length; idx++) {
		            if (nodes[idx].checked && nodes[idx].level() !== 0) {
		                checkedNodes.push(nodes[idx].uniqueName);
		            }
	
		            if (nodes[idx].hasChildren) {
		                checkedNodeIds(nodes[idx].children.view(), checkedNodes);
		            }
		        }
		    }
	
		    var LABELMENUTEMPLATE =
		        '<div class="k-filterable k-content" tabindex="-1" data-role="fieldmenu">' +
		            '<form class="k-filter-menu">' +
		                '<div>' +
		                    '<div class="k-filter-help-text">#=messages.info#</div>'+
		                    '<select>'+
		                        '#for(var op in messages.operators){#'+
		                            '<option value="#=op#">#=messages.operators[op]#</option>' +
		                        '#}#'+
		                    '</select>'+
		                    '<input class="k-textbox" type="text" ' + ARIA_LABEL + '="#=messages.filter#" />'+
		                    '<div>'+
		                    '<a class="k-button k-primary k-button-filter" href="\\#">#=messages.filter#</a>'+
		                    '<a class="k-button k-button-clear" href="\\#">#=messages.clear#</a>'+
		                    '</div>'+
		                '</div>' +
		            '</form>' +
		        '</div>';
	
		    var MENUTEMPLATE = '<ul class="k-pivot-fieldmenu">'+
		                        '# if (sortable) {#'+
		                        '<li class="k-item k-sort-asc">'+
		                            '<span class="k-link">'+
		                                '<span class="k-icon k-i-sort-asc-sm"></span>'+
		                                '${messages.sortAscending}'+
		                            '</span>'+
		                        '</li>'+
		                        '<li class="k-item k-sort-desc">'+
		                            '<span class="k-link">'+
		                                '<span class="k-icon k-i-sort-desc-sm"></span>'+
		                                '${messages.sortDescending}'+
		                            '</span>'+
		                        '</li>'+
		                            '# if (filterable) {#'+
		                            '<li class="k-separator"></li>'+
		                            '# } #'+
		                        '# } #'+
		                        '# if (filterable) {#'+
		                        '<li class="k-item k-include-item">'+
		                            '<span class="k-link">'+
		                                '<span class="k-icon k-i-filter"></span>'+
		                                '${messages.include}'+
		                            '</span>'+
		                        '</li>'+
		                        '<li class="k-separator"></li>'+
		                        '<li class="k-item ' + FILTER_ITEM + '">'+
		                            '<span class="k-link">'+
		                                '<span class="k-icon k-i-filter"></span>'+
		                                '${messages.filterFields}'+
		                            '</span>'+
		                            '<ul>'+
		                                '<li>' + LABELMENUTEMPLATE + '</li>'+
		                            '</ul>'+
		                        '</li>'+
		                        '# } #'+
		                    '</ul>';
	
		    var WINDOWTEMPLATE = '<div class="k-popup-edit-form k-pivot-filter-window"><div class="k-edit-form-container">'+
		                            '<div class="k-treeview"></div>'+
		                            '<div class="k-edit-buttons k-state-default">'+
		                            '<a class="k-button k-primary k-button-ok" href="\\#">'+
		                                '${messages.ok}'+
		                            '</a>'+
		                            '<a class="k-button k-button-cancel" href="\\#">'+
		                                '${messages.cancel}'+
		                            '</a>'+
		                        '</div></div>';
	
		    ui.plugin(PivotFieldMenu);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1266:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(635);
	
	/***/ }),
	
	/***/ 1267:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(574);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1181);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1007:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(561);
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1119:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(590);
	
	/***/ }),
	
	/***/ 1134:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(592);
	
	/***/ }),
	
	/***/ 1181:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1182), __webpack_require__(1119), __webpack_require__(1134), __webpack_require__(1007), __webpack_require__(1008) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "filtercell",
		    name: "Row filter",
		    category: "framework",
		    depends: [ "autocomplete" ],
		    advanced: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        DataSource = kendo.data.DataSource,
		        Widget = ui.Widget,
		        CHANGE = "change",
		        BOOL = "boolean",
		        ENUM = "enums",
		        STRING = "string",
		        EQ = "Is equal to",
		        NEQ = "Is not equal to",
		        proxy = $.proxy,
		        nonValueOperators = ["isnull", "isnotnull", "isempty", "isnotempty", "isnullorempty", "isnotnullorempty"];
	
		    function isNonValueFilter(filter) {
		        var operator = typeof filter === "string" ? filter : filter.operator;
		        return $.inArray(operator, nonValueOperators) > -1;
		    }
	
		    function findFilterForField(filter, field) {
		        var filters = [];
		        if ($.isPlainObject(filter)) {
		            if (filter.hasOwnProperty("filters")) {
		                filters = filter.filters;
		            } else if(filter.field == field) {
		                return filter;
		            }
		        }
		        if (($.isArray(filter))) {
		           filters = filter;
		        }
	
		        for (var i = 0; i < filters.length; i++) {
		          var result = findFilterForField(filters[i], field);
		          if (result) {
		             return result;
		          }
		        }
		    }
	
		    function removeFiltersForField(expression, field) {
		        if (expression.filters) {
		            expression.filters = $.grep(expression.filters, function(filter) {
		                removeFiltersForField(filter, field);
		                if (filter.filters) {
		                    return filter.filters.length;
		                } else {
		                    return filter.field != field;
		                }
		            });
		        }
		    }
	
		    function removeDuplicates (dataSelector, dataTextField) {
		        var getter = kendo.getter(dataTextField, true);
	
		        return function(e) {
		            var items = dataSelector(e),
		                result = [],
		                index = 0,
		                seen = {};
	
		            while (index < items.length) {
		                var item = items[index++],
		                    text = getter(item);
	
		                if(!seen.hasOwnProperty(text)){
		                    result.push(item);
		                    seen[text] = true;
		                }
		            }
	
		            return result;
		        };
		    }
	
		    var FilterCell = Widget.extend( {
		        init: function(element, options) {
		            element = $(element).addClass("k-filtercell");
		            var wrapper = this.wrapper = $("<span/>").appendTo(element);
		            var that = this,
		                dataSource,
		                viewModel,
		                passedOptions = options,
		                first,
		                type,
		                operators = that.operators = options.operators || {},
		                input = that.input = $("<input/>")
		                    .attr(kendo.attr("bind"), "value: value")
		                    .appendTo(wrapper);
	
		            var suggestDataSource = options ? options.suggestDataSource : null;
	
		            if (suggestDataSource) {
		                // avoid deep cloning the suggest data source
		                options = $.extend({}, options, { suggestDataSource: {} });
		            }
	
		            Widget.fn.init.call(that, element[0], options);
	
		            if (suggestDataSource) {
		                that.options.suggestDataSource = suggestDataSource;
		            }
	
		            options = that.options;
	
		            dataSource = that.dataSource = options.dataSource;
	
		            //gets the type from the dataSource or sets default to string
		            that.model = dataSource.reader.model;
		            type = options.type = STRING;
		            var fields = kendo.getter("reader.model.fields", true)(dataSource) || {};
		            var target = fields[options.field];
		            if (target && target.type) {
		                type = options.type = target.type;
		            }
		            if (options.values) {
		                options.type = type = ENUM;
		            }
	
		            operators = operators[type] || options.operators[type];
	
		            if (!passedOptions.operator) {
		                for (first in operators) { // get the first operator
		                    options.operator = first;
		                    break;
		                }
		            }
	
		            that._parse = function(value) {
		                /*jshint eqnull: true */
		                return value != null ? (value + "") : value;
		            };
	
		            if (that.model && that.model.fields) {
		                var field = that.model.fields[options.field];
	
		                if (field) {
		                    if (field.parse) {
		                        that._parse = proxy(field.parse, field);
		                    }
		                }
		            }
	
		            that.defaultOperator = options.operator;
	
		            that.viewModel = viewModel = kendo.observable({
		                operator: options.operator,
		                value: null,
		                operatorVisible: function() {
		                    var val = this.get("value");
		                    return  (val !== null && val !== undefined && val != "undefined") || (isNonValueFilter(this.get("operator")) && !that._clearInProgress);
		                }
		            });
		            viewModel.bind(CHANGE, proxy(that.updateDsFilter, that));
	
		            if (type == STRING) {
		                that.initSuggestDataSource(options);
		            }
	
		            if (options.inputWidth !== null) {
		                input.addClass('k-sized-input');
		                input.width(options.inputWidth);
		            }
	
		            input.attr("aria-label", that._getColumnTitle());
	
		            that._setInputType(options, type);
	
		            if (type != BOOL && options.showOperators !== false) {
		                that._createOperatorDropDown(operators);
		            } else {
		                $('<div unselectable="on" />')
		                    .css("display", "none")
		                    .text("eq")
		                    .appendTo(wrapper);
	
		                wrapper.addClass("k-operator-hidden");
		            }
	
		            that._createClearIcon();
	
		            kendo.bind(this.wrapper, viewModel);
	
		            if (type == STRING) {
		                if (!options.template) {
		                    that.setAutoCompleteSource();
		                }
		            }
	
		            if (type == ENUM) {
		                that.setComboBoxSource(that.options.values);
		            }
	
		            that._refreshUI();
	
		            that._refreshHandler = proxy(that._refreshUI, that);
	
		            that.dataSource.bind(CHANGE, that._refreshHandler);
	
		        },
	
		        _setInputType: function(options, type) {
		            var that = this,
		                input = that.input;
	
		            if (typeof (options.template) == "function") {
		                options.template.call(that.viewModel, {
		                    element: that.input,
		                    dataSource: that.suggestDataSource
		                });
	
		                that._angularItems("compile");
	
		            } else if (type == STRING) {
		                input.attr(kendo.attr("role"), "autocomplete")
		                        .attr(kendo.attr("text-field"), options.dataTextField || options.field)
		                        .attr(kendo.attr("filter"), options.suggestionOperator)
		                        .attr(kendo.attr("delay"), options.delay)
		                        .attr(kendo.attr("min-length"), options.minLength)
		                        .attr(kendo.attr("value-primitive"), true);
		            } else if (type == "date") {
		                input.attr(kendo.attr("role"), "datepicker");
		            } else if (type == BOOL) {
		                input.remove();
		                var radioInput = $("<input type='radio'/>");
		                var wrapper = that.wrapper;
		                var inputName = kendo.guid();
	
		                var labelTrue = $("<label/>").text(options.messages.isTrue).append(radioInput);
		                radioInput.attr(kendo.attr("bind"), "checked:value")
		                    .attr("name", inputName)
		                    .val("true");
	
		                var labelFalse = labelTrue.clone().text(options.messages.isFalse);
		                radioInput.clone().val("false").appendTo(labelFalse);
		                wrapper.append([labelTrue, labelFalse]);
	
		            } else if (type == "number") {
		                input.attr(kendo.attr("role"), "numerictextbox")
		                        .attr("title", that._getColumnTitle());
		            } else if (type == ENUM) {
		                input.attr(kendo.attr("role"), "combobox")
		                        .attr(kendo.attr("text-field"), "text")
		                        .attr(kendo.attr("suggest"), true)
		                        .attr(kendo.attr("filter"), "contains")
		                        .attr(kendo.attr("value-field"), "value")
		                        .attr(kendo.attr("value-primitive"), true);
		            }
		        },
	
		        _getColumnTitle: function() {
		            var column = this.options.column;
		            return column ? column.title || column.field : "";
		        },
	
		        _createOperatorDropDown: function(operators) {
		            var items = [],
		                viewModel = this.viewModel;
		            for (var prop in operators) {
		                items.push({
		                    text: operators[prop],
		                    value: prop
		                });
		            }
		            var dropdown = $('<input class="k-dropdown-operator" ' + kendo.attr("bind") + '="value: operator"/>').appendTo(this.wrapper);
		            this.operatorDropDown = dropdown.kendoDropDownList({
		                dataSource: items,
		                dataTextField: "text",
		                dataValueField: "value",
		                open: function() {
		                    //TODO calc this
		                    this.popup.element.width(150);
		                },
		                valuePrimitive: true
		            }).data("kendoDropDownList");
	
		            viewModel.bind("change", function() {
		                var ariaLabel = operators[viewModel.operator];
		                dropdown.attr("aria-label", ariaLabel);
		            });
	
		            this.operatorDropDown.wrapper.find(".k-i-arrow-60-down").removeClass("k-i-arrow-60-down").addClass("k-i-filter");
		        },
	
		        initSuggestDataSource: function(options) {
		            var suggestDataSource = options.suggestDataSource;
	
		            if (!(suggestDataSource instanceof DataSource)) {
		                if (!options.customDataSource && suggestDataSource) {
		                    suggestDataSource.group = undefined;
		                }
		                suggestDataSource =
		                    this.suggestDataSource =
		                        DataSource.create(suggestDataSource);
	
	
		            }
	
		            if (!options.customDataSource) {
		                suggestDataSource._pageSize = undefined;
		                suggestDataSource.reader.data = removeDuplicates(suggestDataSource.reader.data, this.options.field);
		            }
	
		            this.suggestDataSource = suggestDataSource;
		        },
	
		        setAutoCompleteSource: function() {
		            var autoComplete = this.input.data("kendoAutoComplete");
		            if (autoComplete) {
		                autoComplete.setDataSource(this.suggestDataSource);
		            }
		        },
	
		        setComboBoxSource: function(values) {
		            var dataSource = DataSource.create({
		                data: values
		            });
		            var comboBox = this.input.data("kendoComboBox");
		            if (comboBox) {
		                comboBox.setDataSource(dataSource);
		            }
		        },
	
		        _refreshUI: function() {
		            var that = this,
		                filter = findFilterForField(that.dataSource.filter(), this.options.field) || {},
		                viewModel = that.viewModel;
	
		            that.manuallyUpdatingVM = true;
		            filter = $.extend(true, {}, filter);
		            //MVVM check binding does not update the UI when changing the value to null/undefined
		            if (that.options.type == BOOL) {
		                if (viewModel.value !== filter.value) {
		                    that.wrapper.find(":radio").prop("checked", false);
		                }
		            }
	
		            if (filter.operator) {
		                viewModel.set("operator", filter.operator);
		            }
		            viewModel.set("value", filter.value);
		            that.manuallyUpdatingVM = false;
		        },
	
		        updateDsFilter: function(e) {
		            var that = this,
		                model = that.viewModel;
	
		            if (that.manuallyUpdatingVM || (e.field == "operator" && model.value === undefined && !isNonValueFilter(model)) ||
		                (e.field == "operator" && that._clearInProgress && model.value !== null))  {
		                return;
		            }
	
		            var currentFilter = $.extend({}, that.viewModel.toJSON(), { field: that.options.field });
	
		            var expression = {
		                logic: "and",
		                filters: []
		            };
	
		            var prevented = false;
	
		            if ((currentFilter.value !== undefined && currentFilter.value !== null) || (isNonValueFilter(currentFilter) && !this._clearInProgress)) {
		                expression.filters.push(currentFilter);
	
		                prevented = that.trigger(CHANGE, { filter: expression, field: that.options.field });
		            }
	
		            if (that._clearInProgress || currentFilter.value === null) {
		                prevented = that.trigger(CHANGE, { filter: null, field: that.options.field });
		            }
	
		            if (prevented) {
		                return;
		            }
	
		            var mergeResult = that._merge(expression);
		            if (mergeResult.filters.length) {
		                that.dataSource.filter(mergeResult);
		            } else {
		                that.dataSource.filter({});
		            }
		        },
	
		        _merge: function(expression) {
		            var that = this,
		                logic = expression.logic || "and",
		                filters = expression.filters,
		                filter,
		                result = that.dataSource.filter() || { filters:[], logic: "and" },
		                idx,
		                length;
	
		            removeFiltersForField(result, that.options.field);
	
		            for (idx = 0, length = filters.length; idx < length; idx++) {
		                filter = filters[idx];
		                filter.value = that._parse(filter.value);
		            }
	
		            filters = $.grep(filters, function(filter) {
		                return (filter.value !== "" && filter.value !== null) || isNonValueFilter(filter);
		            });
	
		            if (filters.length) {
		                if (result.filters.length) {
		                    expression.filters = filters;
	
		                    if (result.logic !== "and") {
		                        result.filters = [ { logic: result.logic, filters: result.filters }];
		                        result.logic = "and";
		                    }
	
		                    if (filters.length > 1) {
		                        result.filters.push(expression);
		                    } else {
		                        result.filters.push(filters[0]);
		                    }
		                } else {
		                    result.filters = filters;
		                    result.logic = logic;
		                }
		            }
	
		            return result;
		        },
	
		        _createClearIcon: function() {
		            var that = this;
	
		            $("<button type='button' class='k-button k-button-icon' title = " + that.options.messages.clear + "/>")
		                .attr("aria-label", that.options.messages.clear)
		                .attr(kendo.attr("bind"), "visible:operatorVisible")
		                .html("<span class='k-icon k-i-filter-clear'/>")
		                .click(proxy(that.clearFilter, that))
		                .appendTo(that.wrapper);
		        },
	
		        clearFilter: function() {
		            this._clearInProgress = true;
	
		            if (isNonValueFilter(this.viewModel.operator)) {
		                this.viewModel.set("operator", this.defaultOperator);
		            }
	
		            this.viewModel.set("value", null);
		            this._clearInProgress = false;
		        },
	
		        _angularItems: function(action) {
		            var elements = this.wrapper.closest("th").get();
		            var column = this.options.column;
	
		            this.angular(action, function() {
		                return {
		                    elements: elements,
		                    data: [{ column: column }]
		                };
		            });
		        },
	
		        destroy: function() {
		            var that = this;
	
		            that.filterModel = null;
		            that.operatorDropDown = null;
	
		            that._angularItems("cleanup");
	
		            if (that._refreshHandler) {
		                that.dataSource.bind(CHANGE, that._refreshHandler);
		                that._refreshHandler = null;
		            }
	
		            kendo.unbind(that.element);
	
		            Widget.fn.destroy.call(that);
	
		            kendo.destroy(that.element);
		        },
	
		        events: [
		            CHANGE
		        ],
	
		        options: {
		            name: "FilterCell",
		            delay: 200,
		            minLength: 1,
		            inputWidth: null,
		            values: undefined,
		            customDataSource: false,
		            field: "",
		            dataTextField: "",
		            type: "string",
		            suggestDataSource: null,
		            suggestionOperator: "startswith",
		            operator: "eq",
		            showOperators: true,
		            template: null,
		            messages: {
		                isTrue: "is true",
		                isFalse: "is false",
		                filter: "Filter",
		                clear: "Clear",
		                operator: "Operator"
		            },
		            operators: {
		                string: {
		                    eq: EQ,
		                    neq: NEQ,
		                    startswith: "Starts with",
		                    contains: "Contains",
		                    doesnotcontain: "Does not contain",
		                    endswith: "Ends with",
		                    isnull: "Is null",
		                    isnotnull: "Is not null",
		                    isempty: "Is empty",
		                    isnotempty: "Is not empty",
		                    isnullorempty: "Has no value",
		                    isnotnullorempty: "Has value"
		                },
		                number: {
		                    eq: EQ,
		                    neq: NEQ,
		                    gte: "Is greater than or equal to",
		                    gt: "Is greater than",
		                    lte: "Is less than or equal to",
		                    lt: "Is less than",
		                    isnull: "Is null",
		                    isnotnull: "Is not null"
		                },
		                date: {
		                    eq: EQ,
		                    neq: NEQ,
		                    gte: "Is after or equal to",
		                    gt: "Is after",
		                    lte: "Is before or equal to",
		                    lt: "Is before",
		                    isnull: "Is null",
		                    isnotnull: "Is not null"
		                },
		                enums: {
		                    eq: EQ,
		                    neq: NEQ,
		                    isnull: "Is null",
		                    isnotnull: "Is not null"
		                }
		            }
		        }
		    });
	
		    ui.plugin(FilterCell);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1182:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(602);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1275);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1008:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 1010:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(576);
	
	/***/ }),
	
	/***/ 1138:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1189:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(610);
	
	/***/ }),
	
	/***/ 1193:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(606);
	
	/***/ }),
	
	/***/ 1194:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(599);
	
	/***/ }),
	
	/***/ 1202:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(619);
	
	/***/ }),
	
	/***/ 1203:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(622);
	
	/***/ }),
	
	/***/ 1275:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1008), __webpack_require__(1194), __webpack_require__(1010), __webpack_require__(1138), __webpack_require__(1193), __webpack_require__(1277), __webpack_require__(1278), __webpack_require__(1276), __webpack_require__(1279), __webpack_require__(1280), __webpack_require__(1281), __webpack_require__(1202), __webpack_require__(1203), __webpack_require__(1189) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "scheduler",
		    name: "Scheduler",
		    category: "web",
		    description: "The Scheduler is an event calendar.",
		    depends: [ "dropdownlist", "editable", "multiselect", "window", "datepicker", "datetimepicker", "scheduler.recurrence", "scheduler.view" ],
		    features: [ {
		        id: "scheduler-dayview",
		        name: "Scheduler Day View",
		        description: "Scheduler Day View",
		        depends: [ "scheduler.dayview" ]
		    }, {
		        id: "scheduler-agendaview",
		        name: "Scheduler Agenda View",
		        description: "Scheduler Agenda View",
		        depends: [ "scheduler.agendaview" ]
		    }, {
		        id: "scheduler-monthview",
		        name: "Scheduler Month View",
		        description: "Scheduler Month View",
		        depends: [ "scheduler.monthview" ]
		    }, {
		        id: "scheduler-timelineview",
		        name: "Scheduler Timeline View",
		        description: "Scheduler Timeline View",
		        depends: [ "scheduler.timelineview" ]
		    }, {
		        id: "scheduler-mobile",
		        name: "Scheduler adaptive rendering",
		        description: "Support for adaptive rendering",
		        depends: [ "mobile.actionsheet", "mobile.pane" ]
		    }, {
		        id: "scheduler-pdf-export",
		        name: "PDF export",
		        description: "Export the scheduler events as PDF",
		        depends: [ "pdf", "drawing" ]
		    }, {
		        id: "scheduler-timezones",
		        name: "Timezones",
		        description: "Allow selecting timezones different than Etc/UTC",
		        depends: [ "timezones" ]
		    } ]
		};
	
		/*jshint eqnull: true */
		(function($, undefined) {
		    var kendo = window.kendo,
		        date = kendo.date,
		        input_support = kendo.support.input,
		        MS_PER_DAY = date.MS_PER_DAY,
		        getDate = date.getDate,
		        getMilliseconds = kendo.date.getMilliseconds,
		        recurrence = kendo.recurrence,
		        keys = $.extend({F10: 121}, kendo.keys),
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        DataBoundWidget = ui.DataBoundWidget,
		        STRING = "string",
		        Popup = ui.Popup,
		        Calendar = ui.Calendar,
		        DataSource = kendo.data.DataSource,
		        isPlainObject = $.isPlainObject,
		        extend = $.extend,
		        proxy = $.proxy,
		        toString = Object.prototype.toString,
		        isArray = $.isArray,
		        NS = ".kendoScheduler",
		        CLICK = "click",
		        MOUSEDOWN = "mousedown",
		        TOUCHSTART = kendo.support.pointers ? "pointerdown" : "touchstart",
		        TOUCHMOVE = kendo.support.pointers ? "pointermove" : "touchmove",
		        TOUCHEND = kendo.support.pointers ? "pointerup" : "touchend",
		        MOUSEMOVE = kendo.support.mousemove,
		        CHANGE = "change",
		        CANCEL = "cancel",
		        REMOVE = "remove",
		        SAVE = "save",
		        ADD = "add",
		        EDIT = "edit",
		        FOCUSEDSTATE = "k-state-focused",
		        EXPANDEDSTATE = "k-state-expanded",
		        VIEWSSELECTOR = ".k-scheduler-views",
		        valueStartEndBoundRegex = /(?:value:start|value:end)(?:,|$)/,
		        TODAY = getDate(new Date()),
		        EXCEPTION_SEPARATOR = ",",
		        OLD_EXCEPTION_SEPARATOR_REGEXP = /\;/g,
		        RECURRENCE_EXCEPTION = "recurrenceException",
		        DELETECONFIRM = "Are you sure you want to delete this event?",
		        DELETERECURRING = "Do you want to delete only this event occurrence or the whole series?",
		        EDITRECURRING = "Do you want to edit only this event occurrence or the whole series?",
		        DELETERECURRINGCONFIRM = "Are you sure you want to delete this event occurrence?",
		        DELETESERIESCONFIRM = "Are you sure you want to delete the whole series?",
		        COMMANDBUTTONTMPL = '<a class="k-button #=className#" #=attr# href="\\#">#=text#</a>',
		        VIEWBUTTONTEMPLATE = kendo.template('<li class="k-current-view" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>'),
		        TOOLBARTEMPLATE = kendo.template('<div class="k-floatwrap k-header k-scheduler-toolbar">' +
		           '# if (pdf) { #' +
		           '<ul class="k-reset k-scheduler-tools">' +
		               '<li><a role="button" href="\\#" class="k-button k-pdf"><span class="k-icon k-i-file-pdf"></span>${messages.pdf}</a></li>' +
		           '</ul>' +
		           '# } #' +
		            '<ul class="k-reset k-scheduler-navigation">' +
		               '<li class="k-state-default k-header k-nav-today"><a role="button" href="\\#" class="k-link" title="${messages.today}">${messages.today}</a></li>' +
		               '<li class="k-state-default k-header k-nav-prev"><a role="button" href="\\#" class="k-link" title="${messages.previous}" aria-label="${messages.previous}"><span class="k-icon k-i-arrow-60-left" style="pointer-events: none"></span></a></li>' +
		               '<li class="k-state-default k-header k-nav-next"><a role="button" href="\\#" class="k-link" title="${messages.next}" aria-label="${messages.next}"><span class="k-icon k-i-arrow-60-right" style="pointer-events: none"></span></a></li>' +
		               '<li class="k-state-default k-nav-current">' +
		                    '<a role="button" href="\\#" class="k-link">' +
		                        '<span class="k-icon k-i-calendar"></span>' +
		                        '<span class="k-sm-date-format" data-#=ns#bind="text: formattedShortDate"></span>' +
		                        '<span class="k-lg-date-format" data-#=ns#bind="text: formattedDate"></span>' +
		                    '</a>' +
		                '</li>' +
		            '</ul>' +
		            '#if(viewsCount === 1){#' +
		                '<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-link k-scheduler-refresh">' +
		                    '<span class="k-icon k-i-reload"></span>' +
		                '</a>' +
		            '#}else{#' +
		                '<ul class="k-reset k-header k-scheduler-views">' +
		                    '#for(var view in views){#' +
		                        '<li class="k-state-default k-view-#= view.toLowerCase() #" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>' +
		                    '#}#'  +
		                '</ul>' +
		            '#}#' +
		            '</div>'),
		        MOBILETOOLBARTEMPLATE = kendo.template('<div class="k-floatwrap k-header k-scheduler-toolbar">' +
		            '# if (pdf) { #' +
		            '<ul class="k-reset k-scheduler-tools">' +
		                '<li><a role="button" href="\\#" class="k-button k-pdf"><span class="k-icon k-i-file-pdf"></span>${messages.pdf}</a></li>' +
		            '</ul>' +
		            '# } #' +
		            '<ul class="k-reset k-header k-scheduler-navigation">' +
		               '<li class="k-state-default k-nav-today"><a role="button" href="\\#" class="k-link">${messages.today}</a></li>' +
		            '</ul>' +
		            '#if(viewsCount === 1){#' +
		                '<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-link k-scheduler-refresh">' +
		                    '<span class="k-icon k-i-reload"></span>' +
		                '</a>' +
		            '#}else{#' +
		                '<ul class="k-reset k-header k-scheduler-views">' +
		                    '#for(var view in views){#' +
		                        '<li class="k-state-default k-view-#= view.toLowerCase() #" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>' +
		                    '#}#'  +
		                '</ul>' +
		            '#}#' +
		            '</div>'+
		            '<div class="k-floatwrap k-header k-scheduler-toolbar">' +
		                '<ul class="k-reset k-header k-scheduler-navigation">' +
		                   '<li class="k-state-default k-nav-prev"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-arrow-60-left"></span></a></li>' +
		                   '<li class="k-state-default k-nav-current">' +
		                        '<span class="k-sm-date-format" data-#=ns#bind="text: formattedShortDate"></span>' +
		                        '<span class="k-lg-date-format" data-#=ns#bind="text: formattedDate"></span>' +
		                    '</li>' +
		                   '<li class="k-state-default k-nav-next"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-arrow-60-right"></span></a></li>' +
		                '</ul>' +
		            '</div>'),
		        MOBILEDATERANGEEDITOR = function(container, options) {
		            var attr = { name: options.field, title: options.title };
		            var datepicker_role = !input_support.date ? kendo.attr("role") + '="datepicker" ' : "";
		            var datetimepicker_role = kendo.attr("role") + '="datetimepicker" ';
		            var isAllDay = options.model.isAllDay;
		            var dateTimeValidate = kendo.attr("validate") + "='" + (!isAllDay) + "'";
		            var dateValidate = kendo.attr("validate") + "='" + isAllDay + "'";
	
		            appendTimezoneAttr(attr, options);
		            appendDateCompareValidator(attr, options);
	
		            $('<input type="datetime-local" required ' + kendo.attr("type") + '="date" ' + datetimepicker_role + kendo.attr("bind") + '="value:' + options.field +',invisible:isAllDay" ' +
		                dateTimeValidate + '/>')
		                .attr(attr).appendTo(container);
	
		            $('<input type="date" required ' + kendo.attr("type") + '="date" ' + datepicker_role + kendo.attr("bind") + '="value:' + options.field +',visible:isAllDay" ' +
		                dateValidate + '/>')
		                .attr(attr).appendTo(container);
	
		            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>').hide().appendTo(container);
		        },
		        DATERANGEEDITOR = function(container, options) {
		            var attr = { name: options.field, title: options.title },
		                isAllDay = options.model.isAllDay,
		                dateTimeValidate = kendo.attr("validate") + "='" + (!isAllDay) + "' ",
		                dateValidate = kendo.attr("validate") + "='" + isAllDay + "' ";
	
		            appendTimezoneAttr(attr, options);
		            appendDateCompareValidator(attr, options);
	
		            $('<input type="text" required ' + kendo.attr("type") + '="date"' + ' ' + kendo.attr("role") + '="datetimepicker" ' + kendo.attr("bind") + '="value:' + options.field +',invisible:isAllDay" ' +
		                dateTimeValidate + '/>')
		            .attr(attr).appendTo(container);
	
		            $('<input type="text" required ' + kendo.attr("type") + '="date"' + ' '  + kendo.attr("role") + '="datepicker" ' + kendo.attr("bind") + '="value:' + options.field +',visible:isAllDay" ' +
		                dateValidate + '/>')
		            .attr(attr).appendTo(container);
	
		            $('<span ' + kendo.attr("bind") + '="text: ' + options.field + 'Timezone"></span>').appendTo(container);
	
		            if (options.field === "end") {
		                $('<span ' + kendo.attr("bind") + '="text: startTimezone, invisible: endTimezone"></span>').appendTo(container);
		            }
	
		            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>').hide().appendTo(container);
		        },
		        RECURRENCEEDITOR = function(container, options) {
		            $('<div ' + kendo.attr("bind") + '="value:' + options.field +'" />')
		                .attr({
		                    name: options.field
		                })
		                .appendTo(container)
		                .kendoRecurrenceEditor({
		                    start: options.model.start,
		                    timezone: options.timezone,
		                    messages: options.messages
		                });
		        },
		        MOBILERECURRENCEEDITOR = function(container, options) {
		            $('<div ' + kendo.attr("bind") + '="value:' + options.field +'" />')
		                .attr({
		                    name: options.field
		                })
		                .appendTo(container)
		                .kendoMobileRecurrenceEditor({
		                    start: options.model.start,
		                    timezone: options.timezone,
		                    messages: options.messages,
		                    pane: options.pane,
		                    value: options.model[options.field]
		                });
		        },
		        MOBILETIMEZONEPOPUP = function(container, options) {
		            var text = timezoneButtonText(options.model, options.messages.noTimezone);
	
		            $('<a href="#" class="k-button k-timezone-button" data-bind="invisible:isAllDay">' + text + '</a>').click(options.click).appendTo(container);
		        },
		        TIMEZONEPOPUP = function(container, options) {
		            $('<a href="#" class="k-button" data-bind="invisible:isAllDay">' + options.messages.timezoneEditorButton + '</a>').click(options.click).appendTo(container);
		        },
		        MOBILETIMEZONEEDITOR = function(container, options) {
		            $('<div ' + kendo.attr("bind") + '="value:' + options.field +'" />')
		                .attr({
		                    name: options.field
		                })
		                .toggle(options.visible)
		                .appendTo(container)
		                .kendoMobileTimezoneEditor({
		                    optionLabel: options.noTimezone
		                });
		        },
		        TIMEZONEEDITOR = function(container, options) {
		            var visible = options.visible || options.visible === undefined;
		            $('<div ' + kendo.attr("bind") + '="value:' + options.field +'" />')
		                .attr({ name: options.field })
		                .toggle(visible)
		                .appendTo(container)
		                .kendoTimezoneEditor({
		                    optionLabel: options.noTimezone,
		                    title: options.title
		                });
		        };
	
		    function timezoneButtonText(model, message) {
		        message = message || "";
	
		        if (model.startTimezone) {
		            message = model.startTimezone;
	
		            if (model.endTimezone) {
		                message += " | " + model.endTimezone;
		            }
		        }
	
		        return message;
		    }
	
		    function appendTimezoneAttr(attrs, options) {
		        var timezone = options.timezone;
	
		        if (timezone) {
		            attrs[kendo.attr("timezone")] = timezone;
		        }
		    }
	
		    function appendDateCompareValidator(attrs, options) {
		        var validationRules = options.model.fields[options.field].validation;
	
		        if (validationRules) {
		            var dateCompareRule = validationRules.dateCompare;
		            if (dateCompareRule && isPlainObject(dateCompareRule) && dateCompareRule.message) {
		                attrs[kendo.attr("dateCompare-msg")] = dateCompareRule.message;
		            }
		        }
		    }
	
		    function wrapDataAccess(originalFunction, timezone) {
		        return function(data) {
		            data = originalFunction(data);
	
		            convertData(data, "apply",  timezone);
	
		            return data || [];
		        };
		    }
	
		    function wrapDataSerialization(originalFunction, timezone) {
		        return function(data) {
	
		            if (data) {
		                if (toString.call(data) !== "[object Array]" && !(data instanceof kendo.data.ObservableArray)) {
		                    data = [data];
		                }
		            }
	
		            convertData(data, "remove",  timezone, true);
	
		            data = originalFunction(data);
	
		            return data || [];
		        };
		    }
	
		    function convertData(data, method, timezone, removeUid) {
		        var event,
		            idx,
		            length;
	
		        data = data || [];
	
		        for (idx = 0, length = data.length; idx < length; idx++) {
		            event = data[idx];
	
		            if (removeUid) {
		                if (event.startTimezone || event.endTimezone) {
		                    if (timezone) {
		                        event.start = kendo.timezone.convert(event.start, event.startTimezone || event.endTimezone, timezone);
		                        event.end = kendo.timezone.convert(event.end, event.endTimezone || event.startTimezone, timezone);
	
		                        event.start = kendo.timezone[method](event.start, timezone);
		                        event.end = kendo.timezone[method](event.end, timezone);
		                    } else {
		                        event.start = kendo.timezone[method](event.start, event.startTimezone || event.endTimezone);
		                        event.end = kendo.timezone[method](event.end, event.endTimezone || event.startTimezone);
		                    }
	
		                } else if (timezone) {
		                    event.start = kendo.timezone[method](event.start, timezone);
		                    event.end = kendo.timezone[method](event.end, timezone);
		                }
		            } else {
		                if (event.startTimezone || event.endTimezone) {
		                    event.start = kendo.timezone[method](event.start, event.startTimezone || event.endTimezone);
		                    event.end = kendo.timezone[method](event.end, event.endTimezone || event.startTimezone);
	
		                    if (timezone) {
		                        event.start = kendo.timezone.convert(event.start, event.startTimezone || event.endTimezone, timezone);
		                        event.end = kendo.timezone.convert(event.end, event.endTimezone || event.startTimezone, timezone);
		                    }
	
		                } else if (timezone) {
		                    event.start = kendo.timezone[method](event.start, timezone);
		                    event.end = kendo.timezone[method](event.end, timezone);
		                }
		            }
	
		            if (removeUid) {
		                delete event.uid;
		            }
		        }
		        return data;
		    }
	
		    function getOccurrenceByUid(data, uid) {
		        var length = data.length,
		            idx = 0,
		            event;
	
		        for (; idx < length; idx++) {
		            event = data[idx];
	
		            if (event.uid === uid) {
		                return event;
		            }
		        }
		    }
	
		    var SchedulerDataReader = kendo.Class.extend({
		        init: function(schema, reader) {
		            var timezone = schema.timezone;
	
		            this.reader = reader;
	
		            if (reader.model) {
		                this.model = reader.model;
		            }
	
		            this.timezone = timezone;
		            this.data = wrapDataAccess($.proxy(this.data, this), timezone);
		            this.serialize = wrapDataSerialization($.proxy(this.serialize, this), timezone);
		        },
		        errors: function(data) {
		            return this.reader.errors(data);
		        },
		        parse: function(data) {
		            return this.reader.parse(data);
		        },
		        data: function(data) {
		            return this.reader.data(data);
		        },
		        total: function(data) {
		            return this.reader.total(data);
		        },
		        groups: function(data) {
		            return this.reader.groups(data);
		        },
		        aggregates: function(data) {
		            return this.reader.aggregates(data);
		        },
		        serialize: function(data) {
		            return this.reader.serialize(data);
		        }
		    });
	
		    function applyZone(date, fromZone, toZone) {
		        if (toZone) {
		            date = kendo.timezone.convert(date, fromZone, toZone);
		        } else {
		            date = kendo.timezone.remove(date, fromZone);
		        }
	
		        return date;
		    }
	
		    function dateCompareValidator(input) {
		        if (input.filter("[name=end]").length) {
		            var container = input.closest(".k-scheduler-edit-form");
		            var startInput = container.find("[name=start]:visible");
		            var endInput = container.find("[name=end]:visible");
	
		            if (endInput[0] && startInput[0]) {
		                var start, end;
		                var startPicker = kendo.widgetInstance(startInput, kendo.ui);
		                var endPicker = kendo.widgetInstance(endInput, kendo.ui);
	
		                var editable = container.data("kendoEditable");
		                var model = editable ? editable.options.model : null;
	
		                if (startPicker && endPicker) {
		                    start = startPicker.value();
		                    end = endPicker.value();
		                } else {
		                    start = kendo.parseDate(startInput.val());
		                    end = kendo.parseDate(endInput.val());
		                }
	
		                if (start && end) {
		                    if (model) {
		                        var timezone = startInput.attr(kendo.attr("timezone"));
		                        var startTimezone = model.startTimezone;
		                        var endTimezone = model.endTimezone;
	
		                        startTimezone = startTimezone || endTimezone;
		                        endTimezone = endTimezone || startTimezone;
	
		                        if (startTimezone) {
		                            start = applyZone(start, startTimezone, timezone);
		                            end = applyZone(end, endTimezone, timezone);
		                        }
		                    }
	
		                    return start <= end;
		                }
		            }
		        }
	
		        return true;
		    }
	
		    var SchedulerEvent = kendo.data.Model.define({
		        init: function(value) {
		            var that = this;
	
		            kendo.data.Model.fn.init.call(that, value);
	
		            that._defaultId = that.defaults[that.idField];
		        },
	
		        _time: function(field) {
		            var date = this[field];
		            var fieldTime = "_" + field + "Time";
	
		            if (this[fieldTime]) {
		                return this[fieldTime] - kendo.date.toUtcTime(kendo.date.getDate(date));
		            }
	
		            return getMilliseconds(date);
		        },
	
		        _date: function(field) {
		            var fieldTime = "_" + field + "Time";
	
		            if (this[fieldTime]) {
		                return this[fieldTime] - this._time(field);
		            }
	
		            return kendo.date.getDate(this[field]);
		        },
	
		        clone: function(options, updateUid) {
		            var uid = this.uid,
		                event = new this.constructor($.extend({}, this.toJSON(), options));
	
		            if (!updateUid) {
		                event.uid = uid;
		            }
	
		            return event;
		        },
	
		        duration: function() {
		            var end = this.end;
		            var start = this.start;
		            var offset = (end.getTimezoneOffset() - start.getTimezoneOffset()) * kendo.date.MS_PER_MINUTE;
	
		            return end - start - offset;
		        },
	
		        expand: function(start, end, zone) {
		            return recurrence ? recurrence.expand(this, start, end, zone) : [this];
		        },
	
		        update: function(eventInfo) {
		            for (var field in eventInfo) {
		                this.set(field, eventInfo[field]);
		            }
	
		            if (this._startTime) {
		                this.set("_startTime", kendo.date.toUtcTime(this.start));
		            }
	
		            if (this._endTime) {
		                this.set("_endTime", kendo.date.toUtcTime(this.end));
		            }
		        },
	
		        isMultiDay: function() {
		            return this.isAllDay || this.duration() >= kendo.date.MS_PER_DAY;
		        },
	
		        isException: function() {
		            return !this.isNew() && this.recurrenceId;
		        },
	
		        isOccurrence: function() {
		            return this.isNew() && this.recurrenceId;
		        },
	
		        isRecurring: function() {
		            return !!(this.recurrenceRule || this.recurrenceId);
		        },
	
		        isRecurrenceHead: function() {
		            return !!(this.id && this.recurrenceRule);
		        },
	
		        toOccurrence: function(options) {
		            options = $.extend(options, {
		                recurrenceException: null,
		                recurrenceRule: null,
		                recurrenceId: this.id || this.recurrenceId
		            });
	
		            options[this.idField] = this.defaults[this.idField];
	
		            return this.clone(options, true);
		        },
	
		        toJSON: function() {
		            var obj = kendo.data.Model.fn.toJSON.call(this);
		            obj.uid = this.uid;
	
		            delete obj._startTime;
		            delete obj._endTime;
	
		            return obj;
		        },
	
		        shouldSerialize: function(field) {
		            return kendo.data.Model.fn.shouldSerialize.call(this, field) && field !== "_defaultId";
		        },
	
		        set: function(key, value) {
		            var isAllDay = this.isAllDay || false;
	
		            kendo.data.Model.fn.set.call(this, key, value);
	
		            if (key == "isAllDay" && value != isAllDay) {
		                var start = kendo.date.getDate(this.start);
		                var end = new Date(this.end);
		                var milliseconds = kendo.date.getMilliseconds(end);
	
		                if (milliseconds === 0 && value) {
		                    milliseconds = MS_PER_DAY;
		                }
	
		                this.set("start", start);
	
		                if (value === true) {
		                    kendo.date.setTime(end, -milliseconds);
	
		                    if (end < start) {
		                        end = start;
		                    }
		                } else {
		                    kendo.date.setTime(end, MS_PER_DAY - milliseconds);
		                }
	
		                this.set("end", end);
		            }
		        },
		        id: "id",
		        fields: {
		            id: { type: "number" },
		            title: { defaultValue: "", type: "string" },
		            start: { type: "date", validation: { required: true } },
		            startTimezone: { type: "string" },
		            end: { type: "date", validation: { required: true, dateCompare: { value: dateCompareValidator } } },
		            endTimezone: { type: "string" },
		            recurrenceRule: { defaultValue: "", type: "string" },
		            recurrenceException: { defaultValue: "", type: "string" },
		            isAllDay: { type: "boolean", defaultValue: false },
		            description: { type: "string" }
		        }
		    });
	
		    var SchedulerDataSource = DataSource.extend({
		        init: function(options) {
	
		            DataSource.fn.init.call(this, extend(true, {}, {
		                schema: {
		                    modelBase: SchedulerEvent,
		                    model: SchedulerEvent
		                }
		            }, options));
	
		            this.reader = new SchedulerDataReader(this.options.schema, this.reader);
		        },
	
		        expand: function(start, end) {
		            var data = this.view(),
		                filter = {},
		                endOffset;
	
		            if (start && end) {
		                endOffset = end.getTimezoneOffset();
		                end = new Date(end.getTime() + MS_PER_DAY - 1);
	
		                if(end.getTimezoneOffset() !== endOffset){
		                    end = kendo.timezone.apply(end, endOffset);
		                }
	
		                filter = {
		                    logic: "or",
		                    filters: [
		                        {
		                            logic: "and",
		                            filters: [
		                                { field: "start", operator: "gte", value: start },
		                                { field: "end", operator: "gte", value: start },
		                                { field: "start", operator: "lte", value: end }
		                            ]
		                        },
		                        {
		                            logic: "and",
		                            filters: [
		                                { field: "start", operator: "lte", value: new Date(start.getTime() + MS_PER_DAY - 1) },
		                                { field: "end", operator: "gte", value: start }
		                            ]
		                        }
		                    ]
		                };
	
		                data = new kendo.data.Query(expandAll(data, start, end, this.reader.timezone)).filter(filter).toArray();
		            }
	
		            return data;
		        },
	
		        cancelChanges: function(model) {
		            if (model && model.isOccurrence()) {
		                this._removeExceptionDate(model);
		            }
	
		            DataSource.fn.cancelChanges.call(this, model);
		        },
	
		        insert: function(index, model) {
		            if (!model) {
		                return;
		            }
	
		            if (!(model instanceof SchedulerEvent)) {
		                var eventInfo = model;
	
		                model = this._createNewModel();
		                model.accept(eventInfo);
		            }
	
		            if ((!this._pushCreated && model.isRecurrenceHead()) || model.recurrenceId) {
		                model = model.recurrenceId ? model : model.toOccurrence();
		                this._addExceptionDate(model);
		            }
	
		            return DataSource.fn.insert.call(this, index, model);
		        },
	
		        pushCreate: function(items) {
		            this._pushCreated = true;
		            DataSource.fn.pushCreate.call(this, items);
		            this._pushCreated = false;
		        },
	
		        remove: function(model) {
		            if (model.isRecurrenceHead()) {
		                this._removeExceptions(model);
		            } else if (model.isRecurring()) {
		                this._addExceptionDate(model);
		            }
	
		            return DataSource.fn.remove.call(this, model);
		        },
	
		        _removeExceptions: function(model) {
		            var data = this.data().slice(0),
		                item = data.shift(),
		                id = model.id;
	
		            while(item) {
		                if (item.recurrenceId === id) {
		                    DataSource.fn.remove.call(this, item);
		                }
	
		                item = data.shift();
		            }
	
		            model.set(RECURRENCE_EXCEPTION, "");
		        },
	
		        _removeExceptionDate: function(model) {
		            if (model.recurrenceId) {
		                var head = this.get(model.recurrenceId);
	
		                if (head) {
		                    var start = model.defaults.start;
		                    var replaceRegExp = new RegExp("(\\" + EXCEPTION_SEPARATOR + "?)" + recurrence.toExceptionString(start, this.reader.timezone));
		                    var recurrenceException = (head.recurrenceException || "").replace(OLD_EXCEPTION_SEPARATOR_REGEXP, EXCEPTION_SEPARATOR).replace(/\,$/, "");
	
		                    if(replaceRegExp.test(recurrenceException)){
		                        head.set(RECURRENCE_EXCEPTION, recurrenceException.replace(replaceRegExp, ""));
		                    }else{
		                        start = model.start;
		                        replaceRegExp = new RegExp("(\\" + EXCEPTION_SEPARATOR + "?)" + recurrence.toExceptionString(start, this.reader.timezone));
		                        head.set(RECURRENCE_EXCEPTION, recurrenceException.replace(replaceRegExp, ""));
		                    }
		                }
		            }
		        },
	
		        _addExceptionDate: function(model) {
		            var start = model.start;
		            var zone = this.reader.timezone;
		            var head = this.get(model.recurrenceId);
		            var recurrenceException = (head.recurrenceException || "").replace(OLD_EXCEPTION_SEPARATOR_REGEXP, EXCEPTION_SEPARATOR).replace(/\,$/, "");
	
		            if (!recurrence.isException(recurrenceException, start, zone)) {
		                var newException = recurrence.toExceptionString(start, zone);
		                model.defaults.start = start;
		                head.set(RECURRENCE_EXCEPTION, recurrenceException + (recurrenceException && newException ? EXCEPTION_SEPARATOR : "") + newException);
		            }
		        }
		    });
	
		    function expandAll(events, start, end, zone) {
		        var length = events.length,
		            data = [],
		            idx = 0;
	
		        for (; idx < length; idx++) {
		            data = data.concat(events[idx].expand(start, end, zone));
		        }
	
		        return data;
		    }
	
		    SchedulerDataSource.create = function(options) {
		        if (isArray(options) || options instanceof kendo.data.ObservableArray) {
		            options = { data: options };
		        }
	
		        var dataSource = options || {},
		            data = dataSource.data;
	
		        dataSource.data = data;
	
		        if (!(dataSource instanceof SchedulerDataSource) && dataSource instanceof kendo.data.DataSource) {
		            throw new Error("Incorrect DataSource type. Only SchedulerDataSource instances are supported");
		        }
	
		        return dataSource instanceof SchedulerDataSource ? dataSource : new SchedulerDataSource(dataSource);
		    };
	
		    extend(true, kendo.data, {
		       SchedulerDataSource: SchedulerDataSource,
		       SchedulerDataReader: SchedulerDataReader,
		       SchedulerEvent: SchedulerEvent
		    });
	
		    var defaultCommands = {
		        update: {
		            text: "Save",
		            className: "k-primary k-scheduler-update"
		        },
		        canceledit: {
		            text: "Cancel",
		            className: "k-scheduler-cancel"
		        },
		        destroy: {
		            text: "Delete",
		            imageClass: "k-i-close",
		            className: "k-primary k-scheduler-delete",
		            iconClass: "k-icon"
		        }
		    };
	
		    function trimOptions(options) {
		        delete options.name;
		        delete options.prefix;
	
		        delete options.remove;
		        delete options.edit;
		        delete options.add;
		        delete options.navigate;
	
		        return options;
		    }
	
		    /*
		    function fieldType(field) {
		        field = field != null ? field : "";
		        return field.type || $.type(field) || "string";
		    }
		    */
	
		    function createValidationAttributes(model, field) {
		        var modelField = (model.fields || model)[field];
		        var specialRules = ["url", "email", "number", "date", "boolean"];
		        var validation = modelField ? modelField.validation : {};
		        // var type = fieldType(modelField);
		        var datatype = kendo.attr("type");
		        var inArray = $.inArray;
		        var ruleName;
		        var rule;
	
		        var attr = {};
	
		        for (ruleName in validation) {
		            rule = validation[ruleName];
	
		            if (inArray(ruleName, specialRules) >= 0) {
		                attr[datatype] = ruleName;
		            } else if (!kendo.isFunction(rule)) {
		                attr[ruleName] = isPlainObject(rule) ? (rule.value || ruleName) : rule;
		            }
	
		            attr[kendo.attr(ruleName + "-msg")] = rule.message;
		        }
	
		        return attr;
		    }
	
		    function dropDownResourceEditor(resource, model) {
		        var attr = createValidationAttributes(model, resource.field);
	
		        return function(container) {
		           $(kendo.format('<select data-{0}bind="value:{1}" title="' + model.title + '">', kendo.ns, resource.field))
		             .appendTo(container)
		             .attr(attr)
		             .kendoDropDownList({
		                 dataTextField: resource.dataTextField,
		                 dataValueField: resource.dataValueField,
		                 dataSource: resource.dataSource,
		                 valuePrimitive: resource.valuePrimitive,
		                 optionLabel: "None",
		                 template: kendo.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', resource.dataColorField, resource.dataTextField)
		             });
		       };
		    }
	
		    function descriptionEditor(options) {
		        var attr = createValidationAttributes(options.model, options.field);
	
		        return function(container, model) {
		            $('<textarea name="description" class="k-textbox" title="' + model.title + '"/>').attr(attr)
		                .appendTo(container);
		        };
		    }
	
		    function multiSelectResourceEditor(resource, model) {
		        var attr = createValidationAttributes(model, resource.field);
	
		        return function(container) {
		           $(kendo.format('<select data-{0}bind="value:{1}">', kendo.ns, resource.field))
		             .appendTo(container)
		             .attr(attr)
		             .kendoMultiSelect({
		                 dataTextField: resource.dataTextField,
		                 dataValueField: resource.dataValueField,
		                 dataSource: resource.dataSource,
		                 valuePrimitive: resource.valuePrimitive,
		                 itemTemplate: kendo.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', resource.dataColorField, resource.dataTextField),
		                 tagTemplate: kendo.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', resource.dataColorField, resource.dataTextField)
		             });
		       };
		    }
	
		    function multiSelectResourceEditorMobile(resource, model) {
		        var attr = createValidationAttributes(model, resource.field);
	
		        return function(container) {
		            var options = "";
		            var view = resource.dataSource.view();
	
		            for (var idx = 0, length = view.length; idx < length; idx++) {
		                options += kendo.format('<option value="{0}">{1}</option>',
		                    kendo.getter(resource.dataValueField)(view[idx]),
		                    kendo.getter(resource.dataTextField)(view[idx])
		                );
		            }
	
		            $(kendo.format('<select data-{0}bind="value:{1}" multiple="multiple" data-{0}value-primitive="{3}">{2}</select>',
		                kendo.ns,
		                resource.field,
		                options,
		                resource.valuePrimitive
		             ))
		             .appendTo(container)
		             .attr(attr);
		       };
		    }
	
		    function moveEventRange(event, distance) {
		        var duration = event.end.getTime() - event.start.getTime();
	
		        var start = new Date(event.start.getTime());
	
		        kendo.date.setTime(start, distance);
	
		        var end = new Date(start.getTime());
	
		        kendo.date.setTime(end, duration, true);
	
		        return {
		            start: start,
		            end: end
		        };
		    }
	
		    var editors = {
		        mobile: {
		            dateRange: MOBILEDATERANGEEDITOR,
		            timezonePopUp: MOBILETIMEZONEPOPUP,
		            timezone: MOBILETIMEZONEEDITOR,
		            recurrence: MOBILERECURRENCEEDITOR,
		            description: descriptionEditor,
		            multipleResources: multiSelectResourceEditorMobile,
		            resources: dropDownResourceEditor
		        },
		        desktop: {
		            dateRange: DATERANGEEDITOR,
		            timezonePopUp: TIMEZONEPOPUP,
		            timezone: TIMEZONEEDITOR,
		            recurrence: RECURRENCEEDITOR,
		            description: descriptionEditor,
		            multipleResources: multiSelectResourceEditor,
		            resources: dropDownResourceEditor
		        }
		    };
	
		    var Editor = kendo.Observable.extend({
		        init: function(element, options) {
	
		            kendo.Observable.fn.init.call(this);
	
		            this.element = element;
		            this.options = extend(true, {}, this.options, options);
		            this.createButton = this.options.createButton;
	
		            this.toggleDateValidationHandler = proxy(this._toggleDateValidation, this);
		        },
	
		        _toggleDateValidation: function(e) {
		            if (e.field == "isAllDay") {
		                var container = this.container,
		                    isAllDay = this.editable.options.model.isAllDay,
		                    bindAttribute = kendo.attr("bind"),
		                    element, isDateTimeInput, shouldValidate;
		                container.find("[" + bindAttribute+ "*=end],[" + bindAttribute + "*=start]").each(function() {
		                    element = $(this);
		                    if (valueStartEndBoundRegex.test(element.attr(bindAttribute))) {
		                        isDateTimeInput = element.is("[" + kendo.attr("role") + "=datetimepicker],[type*=datetime]");
		                        shouldValidate = isAllDay !== isDateTimeInput;
		                        element.attr(kendo.attr("validate"), shouldValidate);
		                    }
		                });
		            }
		        },
	
		        fields: function(editors, model) {
		            var that = this;
	
		            var messages = that.options.messages;
		            var timezone = that.options.timezone;
	
		            var click = function(e) {
		                e.preventDefault();
		                that._initTimezoneEditor(model, this);
		            };
	
		            var fields = [
		                { field: "title", title: messages.editor.title /*, format: field.format, editor: field.editor, values: field.values*/ },
		                { field: "start", title: messages.editor.start, editor: editors.dateRange, timezone: timezone },
		                { field: "end", title: messages.editor.end, editor: editors.dateRange, timezone: timezone },
		                { field: "isAllDay", title: messages.editor.allDayEvent }
		            ];
	
		            if (kendo.timezone.windows_zones) {
		                fields.push({ field: "timezone", title: messages.editor.timezone, editor: editors.timezonePopUp, click: click, messages: messages.editor, model: model });
		                fields.push({ field: "startTimezone", title: messages.editor.startTimezone, editor: editors.timezone, noTimezone: messages.editor.noTimezone });
		                fields.push({ field: "endTimezone", title: messages.editor.endTimezone, editor: editors.timezone, noTimezone: messages.editor.noTimezone });
		            }
	
		            if (!model.recurrenceId) {
		                fields.push({ field: "recurrenceRule", title: messages.editor.repeat, editor: editors.recurrence, timezone: timezone, messages: messages.recurrenceEditor, pane: this.pane });
		            }
	
		            if ("description" in model) {
		                fields.push({ field: "description", title: messages.editor.description, editor: editors.description({model: model, field: "description"}) });
		            }
	
		            for (var resourceIndex = 0; resourceIndex < this.options.resources.length; resourceIndex++) {
		                var resource = this.options.resources[resourceIndex];
		                fields.push({
		                    field: resource.field,
		                    title: resource.title,
		                    editor: resource.multiple? editors.multipleResources(resource, model) : editors.resources(resource, model)
		                });
		            }
	
		            return fields;
		        },
	
		        end: function() {
		            return this.editable.end();
		        },
	
		        _buildEditTemplate: function(model, fields, editableFields) {
		            var messages = this.options.messages;
		            var settings = extend({}, kendo.Template, this.options.templateSettings);
		            var paramName = settings.paramName;
		            var template = this.options.editable.template;
		            var html = "";
	
		            if (template) {
		                if (typeof template === STRING) {
		                    template = window.unescape(template);
		                }
		                html += (kendo.template(template, settings))(model);
		            } else {
		                for (var idx = 0, length = fields.length; idx < length; idx++) {
		                    var field = fields[idx];
	
		                    if (field.field === "startTimezone") {
		                        html += '<div class="k-popup-edit-form k-scheduler-edit-form k-scheduler-timezones" style="display:none">';
		                        html += '<div class="k-edit-form-container">';
		                        html += '<div class="k-edit-label"></div>';
		                        html += '<div class="k-edit-field"><label class="k-check"><input class="k-timezone-toggle" type="checkbox" />' + messages.editor.separateTimezones +'</label></div>';
		                    }
	
		                    html += '<div class="k-edit-label"><label for="' + field.field + '">' + (field.title || field.field || "") + '</label></div>';
	
		                    if ((!model.editable || model.editable(field.field))) {
		                        editableFields.push(field);
		                        html += '<div ' + kendo.attr("container-for") + '="' + field.field + '" class="k-edit-field"></div>';
		                    } else {
		                        var tmpl = "#:";
	
		                        if (field.field) {
		                            field = kendo.expr(field.field, paramName);
		                            tmpl += field + "==null?'':" + field;
		                        } else {
		                            tmpl += "''";
		                        }
	
		                        tmpl += "#";
	
		                        tmpl = kendo.template(tmpl, settings);
	
		                        html += '<div class="k-edit-field">' + tmpl(model) + '</div>';
		                    }
	
		                    if (field.field === "endTimezone") {
		                        html += this._createEndTimezoneButton();
		                    }
		                }
		            }
	
		            return html;
		        },
	
		        _createEndTimezoneButton: function() {
		            return '</div></div>';
		        },
	
		        _revertTimezones: function(model) {
		            model.set("startTimezone", this._startTimezone);
		            model.set("endTimezone", this._endTimezone);
	
		            delete this._startTimezone;
		            delete this._endTimezone;
		        }
		    });
	
		    var MobileEditor = Editor.extend({
		        init: function() {
		            Editor.fn.init.apply(this, arguments);
	
		            this.pane = kendo.mobile.ui.Pane.wrap(this.element);
		            this.pane.element.parent().css("height", this.options.height);
		            this.view = this.pane.view();
		            this._actionSheetButtonTemplate = kendo.template('<li><a #=attr# class="k-button #=className#" href="\\#">#:text#</a></li>');
	
		            this._actionSheetPopupOptions = $(document.documentElement).hasClass("km-root") ? { modal: false } : {
		                align: "bottom center",
		                position: "bottom center",
		                effect: "slideIn:up"
		            };
		        },
	
		        options: {
		            animations: {
		                left: "slide",
		                right: "slide:right"
		            }
		        },
	
		        destroy: function() {
		            this.close();
		            this.unbind();
		            this.pane.destroy();
		        },
	
		        _initTimezoneEditor: function(model) {
		            var that = this;
		            var pane = that.pane;
		            var messages = that.options.messages;
		            var timezoneView = that.timezoneView;
		            var container = that.container.find(".k-scheduler-timezones");
		            var checkbox = container.find(".k-timezone-toggle");
		            var endTimezoneRow = container.find(".k-edit-label:last").add(container.find(".k-edit-field:last"));
		            var startTimezoneChange = function(e) {
		                if (e.field === "startTimezone") {
		                    var value = model.startTimezone;
	
		                    checkbox.prop("disabled", !value);
	
		                    if (!value) {
		                        endTimezoneRow.hide();
		                        model.set("endTimezone", "");
		                        checkbox.prop("checked", false);
		                    }
		                }
		            };
	
		            that._startTimezone = model.startTimezone || "";
		            that._endTimezone = model.endTimezone || "";
	
		            if (!timezoneView) {
		                var html = '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form k-mobile-list">' +
		                           '<div data-role="header" class="k-header"><a href="#" class="k-button k-scheduler-cancel">' + messages.cancel + '</a>' +
		                           messages.editor.timezoneTitle + '<a href="#" class="k-button k-scheduler-update">' + messages.save + '</a></div></div>';
	
		                this.timezoneView = timezoneView = pane.append(html);
	
		                timezoneView.contentElement().append(container.show());
	
		                timezoneView.element.on(CLICK + NS, ".k-scheduler-cancel, .k-scheduler-update", function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    if ($(this).hasClass("k-scheduler-cancel")) {
		                        that._revertTimezones(model);
		                    }
	
		                    model.unbind("change", startTimezoneChange);
	
		                    var editView = pane.element.find("#edit").data("kendoMobileView");
	
		                    var text = timezoneButtonText(model, messages.editor.noTimezone);
	
		                    editView.contentElement().find(".k-timezone-button").text(text);
	
		                    pane.navigate(editView, that.options.animations.right);
		                });
	
		                checkbox.click(function() {
		                    endTimezoneRow.toggle(checkbox.prop("checked"));
		                    model.set("endTimezone", "");
		                });
	
		                model.bind("change", startTimezoneChange);
		            }
	
		            checkbox.prop("checked", model.endTimezone).prop("disabled", !model.startTimezone);
	
		            if (model.endTimezone) {
		                endTimezoneRow.show();
		            } else {
		                endTimezoneRow.hide();
		            }
	
		            pane.navigate(timezoneView, that.options.animations.left);
		        },
	
		        _createActionSheetButton: function(options) {
		            options.template = this._actionSheetButtonTemplate;
		            return  this.createButton(options);
		        },
	
		        showDialog: function(options) {
		            var type = "";
		            var html = "<ul><li class=\"km-actionsheet-title\">" + options.title + "</li>";
	
		            var target = this.element.find(".k-event[" + kendo.attr("uid") + "='" + options.model.uid + "']");
	
		            if (this.container) {
		                target = this.container.find(".k-scheduler-delete");
	
		                if (target[0]) {
		                    type = 'phone';
		                }
		            }
	
		            for (var buttonIndex = 0; buttonIndex < options.buttons.length; buttonIndex++) {
		                html+= this._createActionSheetButton(options.buttons[buttonIndex]);
		            }
	
		            html += "</ul>";
	
		            var actionSheet = $(html)
		                .appendTo(this.pane.view().element)
		                .kendoMobileActionSheet({
		                    type: type,
		                    cancel: this.options.messages.cancel,
		                    cancelTemplate: '<li class="km-actionsheet-cancel"><a class="k-button" href="\\#">#:cancel#</a></li>',
		                    close: function() {
		                        this.destroy();
		                    },
		                    command: function(e) {
		                        var buttonIndex = actionSheet.element.find("li:not(.km-actionsheet-cancel) > .k-button").index($(e.currentTarget));
		                        if (buttonIndex > -1) {
		                            actionSheet.close();
		                            options.buttons[buttonIndex].click();
		                        }
		                    },
		                    popup: this._actionSheetPopupOptions
		                })
		                .data("kendoMobileActionSheet");
	
		            actionSheet.open(target);
		        },
	
		        editEvent: function(model) {
		            var pane = this.pane;
		            var html = "";
	
		            var messages = this.options.messages;
		            var updateText = messages.save;
		            var removeText = messages.destroy;
		            var cancelText = messages.cancel;
		            var titleText = messages.editor.editorTitle;
	
		            html += '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form k-mobile-list" id="edit" ' + kendo.attr("uid") + '="' + model.uid + '">' +
		                '<div data-role="header" class="k-header"><a href="#" class="k-button k-scheduler-cancel">' + cancelText + '</a>' +
		                titleText + '<a href="#" class="k-button k-scheduler-update">' + updateText + '</a></div>';
	
		            var fields = this.fields(editors.mobile, model);
	
		            var that = this;
	
		            var editableFields = [];
	
		            html += this._buildEditTemplate(model, fields, editableFields);
	
		            if (!model.isNew() && this.options.editable && this.options.editable.destroy !== false) {
		                html += '<div class="k-edit-buttons"><a href="#" class="k-scheduler-delete k-button">' + removeText + '</a></div>';
		            }
	
		            html += "</div>";
	
		            var view = pane.append(html);
	
		            var container = this.container = view.element;
	
		            this.editable = container.kendoEditable({
		                fields: editableFields,
		                model: model,
		                clearContainer: false,
		                target: that.options.target,
	
		                validateOnBlur: true
		            }).data("kendoEditable");
	
		            // TODO: Replace this code with labels and for="ID"
		            container.find("input[type=checkbox],input[type=radio]")
		                     .parent(".k-edit-field")
		                     .addClass("k-check")
		                     .prev(".k-edit-label")
		                     .addClass("k-check")
		                     .click(function() {
		                         $(this).next().children("input").click();
		                     });
	
		            if (!this.trigger("edit", { container: container, model: model })) {
	
		                container.on(CLICK + NS, "a.k-scheduler-edit, a.k-scheduler-cancel, a.k-scheduler-update, a.k-scheduler-delete", function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    var button = $(this);
	
		                    if (!button.hasClass("k-scheduler-edit")) {
	
		                        var name = "cancel";
	
		                        if (button.hasClass("k-scheduler-update")) {
		                            name = "save";
		                        } else if (button.hasClass("k-scheduler-delete")) {
		                            name = "remove";
		                        }
	
		                        that.trigger(name, { container: container, model: model });
		                    } else {
		                        pane.navigate("#edit", that.options.animations.right);
		                    }
		                });
	
		                pane.navigate(view, that.options.animations.left);
	
		                model.bind("change", that.toggleDateValidationHandler);
		            } else {
		                this.trigger("cancel", { container: container, model: model });
		            }
	
		            return this.editable;
		        },
	
		        _views: function() {
		            return this.pane.element
		                    .find(kendo.roleSelector("view"))
		                    .not(this.view.element);
		        },
	
		        close: function() {
		            if (this.container) {
		                this.pane.navigate("", this.options.animations.right);
	
		                var views = this._views();
		                var view;
	
		                for (var idx = 0, length = views.length; idx < length; idx++) {
		                    view = views.eq(idx).data("kendoMobileView");
		                    if (view) {
		                       view.purge();
		                    }
		                }
	
		                views.remove();
	
		                this.container = null;
		                if (this.editable) {
		                    this.editable.options.model.unbind("change", this.toggleDateValidationHandler);
		                    this.editable.destroy();
		                    this.editable = null;
		                }
		                this.timezoneView = null;
		            }
		        }
		    });
	
		    var PopupEditor = Editor.extend({
		        destroy: function() {
		            this.close();
		            this.unbind();
		        },
	
		        editEvent: function(model) {
		            var that = this;
		            var editable = that.options.editable;
		            var html = '<div ' + kendo.attr("uid") + '="' + model.uid + '" class="k-popup-edit-form k-scheduler-edit-form"><div class="k-edit-form-container">';
		            var messages = that.options.messages;
		            var updateText = messages.save;
		            var cancelText = messages.cancel;
		            var deleteText = messages.destroy;
	
		            var fields = this.fields(editors.desktop, model);
	
		            var editableFields = [];
	
		            html += this._buildEditTemplate(model, fields, editableFields);
	
		            var attr;
		            var options = isPlainObject(editable) ? editable.window : {};
	
		            html += '<div class="k-edit-buttons k-state-default">';
		            html += this.createButton({ name: "update", text: updateText, attr: attr }) + this.createButton({ name: "canceledit", text: cancelText, attr: attr });
	
		            if (!model.isNew() && editable.destroy !== false) {
		                html += this.createButton({ name: "delete", text: deleteText, attr: attr });
		            }
	
		            html += '</div></div></div>';
	
		            var container = this.container = $(html)
		                .appendTo(that.element).eq(0)
		                .kendoWindow(extend({
		                    modal: true,
		                    resizable: false,
		                    draggable: true,
		                    title: messages.editor.editorTitle,
		                    visible: false,
		                    close: function(e) {
		                        if (e.userTriggered) {
		                            if (that.trigger(CANCEL, { container: container, model: model })) {
		                                e.preventDefault();
		                            }
		                        }
		                    }
		                }, options));
	
		            that.editable = container.kendoEditable({
		                fields: editableFields,
		                model: model,
		                clearContainer: false,
		                validateOnBlur: true,
		                target: that.options.target
		            }).data("kendoEditable");
	
		            if (!that.trigger(EDIT, { container: container, model: model })) {
	
		                container.data("kendoWindow").center().open();
	
		                container.on(CLICK + NS, "a.k-scheduler-cancel", function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    that.trigger(CANCEL, { container: container, model: model });
		                });
	
		                container.on(CLICK + NS, "a.k-scheduler-update", function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    that.trigger("save", { container: container, model: model });
		                });
	
		                container.on(CLICK + NS, "a.k-scheduler-delete", function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    that.trigger(REMOVE, { container: container, model: model });
		                });
	
		                kendo.cycleForm(container);
	
		                model.bind("change", that.toggleDateValidationHandler);
		            } else {
		                that.trigger(CANCEL, { container: container, model: model });
		            }
	
		            return that.editable;
		        },
	
		        close: function() {
		            var that = this;
	
		            var destroy = function() {
		                if (that.editable) {
		                    that.editable.options.model.unbind("change", that.toggleDateValidationHandler);
		                    that.editable.destroy();
		                    that.editable = null;
		                    that.container = null;
		                }
		                if (that.popup) {
		                    that.popup.destroy();
		                    that.popup = null;
		                }
		            };
	
		            if (that.editable) {
		                if (that._timezonePopup && that._timezonePopup.data("kendoWindow")) {
		                    that._timezonePopup.data("kendoWindow").destroy();
		                    that._timezonePopup = null;
		                }
	
		                if (that.container.is(":visible")) {
		                    that.container.data("kendoWindow").bind("deactivate", destroy).close();
		                } else {
		                    destroy();
		                }
		            } else {
		                destroy();
		            }
		        },
	
		        _createEndTimezoneButton: function() {
		            var messages = this.options.messages;
		            var html = "";
	
		            html += '<div class="k-edit-buttons k-state-default">';
		            html += this.createButton({ name: "savetimezone", text: messages.save }) + this.createButton({ name: "canceltimezone", text: messages.cancel });
		            html += '</div></div></div>';
	
		            return html;
		        },
	
		        showDialog: function(options) {
		            var html = kendo.format("<div class='k-popup-edit-form'><div class='k-edit-form-container'><p class='k-popup-message'>{0}</p>", options.text);
	
		            html += '<div class="k-edit-buttons k-state-default">';
	
		            for (var buttonIndex = 0; buttonIndex < options.buttons.length; buttonIndex++) {
		                html+= this.createButton(options.buttons[buttonIndex]);
		            }
	
		            html += '</div></div></div>';
	
		            var wrapper = this.element;
	
		            if (this.popup) {
		                this.popup.destroy();
		            }
	
		            var popup = this.popup = $(html).appendTo(wrapper)
		                               .eq(0)
		                               .on(CLICK, ".k-button", function(e) {
		                                    e.preventDefault();
	
		                                    popup.close();
	
		                                    var buttonIndex = $(e.currentTarget).index();
	
		                                    options.buttons[buttonIndex].click();
		                               })
		                               .kendoWindow({
		                                   modal: true,
		                                   resizable: false,
		                                   draggable: false,
		                                   title: options.title,
		                                   visible: false,
		                                   close: function() {
		                                       this.destroy();
		                                       wrapper.focus();
		                                   }
		                               })
		                               .getKendoWindow();
	
		            popup.center().open();
		        },
	
		        _initTimezoneEditor: function(model, activator) {
		            var that = this;
		            var container = that.container.find(".k-scheduler-timezones");
		            var checkbox = container.find(".k-timezone-toggle");
		            var endTimezoneRow = container.find(".k-edit-label:last").add(container.find(".k-edit-field:last"));
		            var saveButton = container.find(".k-scheduler-savetimezone");
		            var cancelButton = container.find(".k-scheduler-canceltimezone");
		            var timezonePopup = that._timezonePopup;
		            var startTimezoneChange = function(e) {
		                if (e.field === "startTimezone") {
		                    var value = model.startTimezone;
	
		                    checkbox.prop("disabled", !value);
	
		                    if (!value) {
		                        endTimezoneRow.hide();
		                        model.set("endTimezone", "");
		                        checkbox.prop("checked", false);
		                    }
		                }
		            };
		            var wnd;
	
		            that._startTimezone = model.startTimezone;
		            that._endTimezone = model.endTimezone;
	
		            if (!timezonePopup) {
		                that._timezonePopup = timezonePopup = container.kendoWindow({
		                    modal: true,
		                    resizable: false,
		                    draggable: true,
		                    title: that.options.messages.editor.timezoneEditorTitle,
		                    visible: false,
		                    close: function(e) {
		                        model.unbind("change", startTimezoneChange);
	
		                        if (e.userTriggered) {
		                            that._revertTimezones(model);
		                        }
	
		                        if (activator) {
		                            activator.focus();
		                        }
		                    }
		                });
	
		                checkbox.click(function() {
		                    endTimezoneRow.toggle(checkbox.prop("checked"));
		                    model.set("endTimezone", "");
		                });
	
		                saveButton.click(function(e) {
		                    e.preventDefault();
		                    wnd.close();
		                });
	
		                cancelButton.click(function(e) {
		                    e.preventDefault();
		                    that._revertTimezones(model);
		                    wnd.close();
		                });
	
		                model.bind("change", startTimezoneChange);
		            }
	
		            checkbox.prop("checked", model.endTimezone).prop("disabled", !model.startTimezone);
	
		            if (model.endTimezone) {
		                endTimezoneRow.show();
		            } else {
		                endTimezoneRow.hide();
		            }
	
		            wnd = timezonePopup.data("kendoWindow");
		            wnd.center().open();
		        }
		    });
	
		    var Scheduler = DataBoundWidget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            if (!that.options.views || !that.options.views.length) {
		                that.options.views = ["day", "week"];
		            }
	
		            that.resources = [];
	
		            that._initModel();
	
		            that._wrapper();
	
		            that._views();
	
		            that._toolbar();
	
		            that._dataSource();
	
		            that._resources();
	
		            that._resizeHandler = function() {
		                that.resize();
		            };
	
		            that.wrapper.on(MOUSEDOWN + NS + " selectstart" + NS, function(e) {
		                if (!$(e.target).is(":kendoFocusable")) {
		                    e.preventDefault();
		                }
		            });
	
		            if (that.options.editable && that.options.editable.resize !== false) {
		                that._resizable();
		            }
	
		            that._movable();
	
		            that._bindResize();
	
		            if(that.options.messages && that.options.messages.recurrence) {
		                recurrence.options = that.options.messages.recurrence;
		            }
	
		            that._selectable();
	
		            that._touchHandlers();
	
		            that._ariaId = kendo.guid();
	
		            that._createEditor();
		        },
	
		        _bindResize: function() {
		            $(window).on("resize" + NS, this._resizeHandler);
		        },
	
		        _unbindResize: function() {
		            $(window).off("resize" + NS, this._resizeHandler);
		        },
	
		        dataItems: function() {
		            var that = this;
		            var items = that.items();
		            var events = that._data;
		            var eventsUids = $.map(items, function(item) {
		                return $(item).attr("data-uid");
		            });
		            var i;
		            var key;
	
		            var dict = {};
		            var eventsUidsLength = eventsUids.length;
		            for (i = 0; i < eventsUidsLength; i++) {
		                dict[eventsUids[i]] = null;
		            }
	
		            var eventsCount = events.length;
		            for (i = 0; i < eventsCount; i++) {
		                var event = events[i];
		                if (dict[event.uid] !== undefined) {
		                    dict[event.uid] = event;
		                }
		            }
	
		            var sortedData = [];
		            for (key in dict) {
		                sortedData.push(dict[key]);
		            }
	
		            return sortedData;
		        },
	
		        _isMobile: function() {
		            var options = this.options;
		            return (options.mobile === true && kendo.support.mobileOS) || options.mobile === "phone" || options.mobile === "tablet";
		        },
	
		        _isTouch: function(event) {
		            return /touch/.test(event.type) || (event.originalEvent && /touch/.test(event.originalEvent.pointerType));
		        },
	
		        _isMobilePhoneView: function() {
		            var options = this.options;
		            return (options.mobile === true && kendo.support.mobileOS && !kendo.support.mobileOS.tablet) || options.mobile === "phone";
		        },
	
		        _groupsByResource: function(resources, groupIndex, groupsArray, parentFieldValue, parentField) {
		            if (!groupsArray) {
		                groupsArray = [];
		            }
	
		            var resource = resources[0];
		            if (resource) {
		                var group;
		                var data = resource.dataSource.view();
		                var prevIndex = 0;
	
		                for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
		                    var fieldValue = kendo.getter(resource.dataValueField)(data[dataIndex]);
		                    var currentGroupIndex = groupIndex + prevIndex + dataIndex;
	
		                    group = this._groupsByResource(resources.slice(1), currentGroupIndex, groupsArray, fieldValue, resource.field);
		                    group[resource.field] = fieldValue;
		                    prevIndex = group.groupIndex;
	
		                    if (parentField && parentFieldValue) {
		                        group[parentField] = parentFieldValue;
		                    }
	
		                    if (resources.length === 1) {
		                        group.groupIndex = groupIndex + dataIndex;
		                        groupsArray.push(group);
		                    }
		                }
		                return group;
		            } else {
		                return {};
		            }
		        },
	
		        data: function () {
		            return this._data;
		        },
	
		        select: function (options) {
		            var that = this;
		            var view = that.view();
		            var selection = that._selection;
		            var groups = view.groups;
		            var selectedGroups;
	
		            if (options === undefined) {
		                var selectedEvents;
		                var slots = view._selectedSlots;
	
		                if(!selection) {
		                    return [];
		                }
	
		                if (selection && selection.events) {
		                    selectedEvents = that._selectedEvents();
		                }
	
		                return {
		                    start: selection.start,
		                    end: selection.end,
		                    events: selectedEvents,
		                    slots: slots,
		                    resources: view._resourceBySlot(selection)
		                };
		            }
	
		            if (!options) {
		                that._selection = null;
		                that._old = null;
		                view.clearSelection();
	
		                return;
		            }
	
		            if ($.isArray(options)) {
		                options = {
		                    events: options.splice(0)
		                };
		            }
	
		            if (options.resources) {
		                var fieldName;
		                var filters = [];
		                var groupsByResource = [];
	
		                if (view.groupedResources) {
		                    that._groupsByResource(view.groupedResources, 0, groupsByResource);
		                }
	
		                for (fieldName in options.resources) {
		                    filters.push({ field: fieldName, operator: "eq", value: options.resources[fieldName]});
		                }
	
		                selectedGroups = new kendo.data.Query(groupsByResource)
		                    .filter(filters)
		                    .toArray();
		            }
	
		            if (options.events && options.events.length) {
		                that._selectEvents(options.events, selectedGroups);
		                that._select();
	
		                return;
		            }
	
		            if (groups && (options.start && options.end)) {
		                var rangeStart = getDate(view._startDate);
		                var rangeEnd = kendo.date.addDays(getDate(view._endDate),1);
		                var group;
		                var ranges;
	
		                if (options.start < rangeEnd && rangeStart <= options.end) {
		                    if (selectedGroups && selectedGroups.length) {
		                        group = groups[selectedGroups[0].groupIndex];
		                    } else {
		                        group = groups[0];
		                    }
	
		                    ranges = group.ranges(options.start, options.end, options.isAllDay, false);
	
		                    if (ranges.length) {
		                        that._selection = {
		                            start: kendo.timezone.toLocalDate(ranges[0].start.start),
		                            end: kendo.timezone.toLocalDate(ranges[ranges.length-1].end.end),
		                            groupIndex: ranges[0].start.groupIndex,
		                            index: ranges[0].start.index,
		                            isAllDay: ranges[0].start.isDaySlot,
		                            events: []
		                        };
	
		                        that._select();
		                    }
		                }
		            }
		        },
	
		        _selectEvents: function (eventsUids, selectedGroups) {
		            var that = this;
		            var idx;
		            var view = that.view();
		            var groups = view.groups;
		            var eventsLength = eventsUids.length;
		            var isGrouped = selectedGroups && selectedGroups.length;
	
		            for (idx = 0; idx < eventsLength; idx++) {
		                if (groups && isGrouped) {
		                    var currentGroup = groups[selectedGroups[0].groupIndex];
		                    var events = [];
		                    var timeSlotCollectionCount = currentGroup.timeSlotCollectionCount();
		                    var daySlotCollectionCount = currentGroup.daySlotCollectionCount();
	
		                    for (var collIdx = 0; collIdx < timeSlotCollectionCount; collIdx++) {
		                        events = events.concat(currentGroup.getTimeSlotCollection(collIdx).events());
		                    }
	
		                    for (var dayCollIdx = 0; dayCollIdx < daySlotCollectionCount; dayCollIdx++) {
		                        events = events.concat(currentGroup.getDaySlotCollection(dayCollIdx).events());
		                    }
	
		                    events = new kendo.data.Query(events)
		                        .filter({field: "element[0].getAttribute('data-uid')", operator: "eq", value: eventsUids[idx]})
		                        .toArray();
	
		                    if (events[0]) {
		                        that._createSelection(events[0].element);
		                    }
		                } else {
		                    var element = view.element.find(kendo.format(".k-event[data-uid={0}], .k-task[data-uid={0}]", eventsUids[idx]));
	
		                    if (element.length) {
		                        that._createSelection(element[0]);
		                    }
		                }
		            }
		        },
	
		        _touchHandlers: function() {
		            var that = this;
		            var startX;
		            var startY;
		            var endX;
		            var endY;
		            var timeStamp;
		            var wrapper = that.wrapper;
		            var touchMoveHandler = $.proxy(that._touchMove, that);
	
		            wrapper.on(TOUCHSTART + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function(e) {
		                var content = that.wrapper.find(".k-scheduler-content");
	
		                if (!that._isTouch(e)) {
		                    return;
		                }
	
		                content.stop(true, false);
	
		                that._touchPosX = startX = that._tapPosition(e, 'X');
		                that._touchPosY = startY = that._tapPosition(e, 'Y');
		                that._userTouched = true;
		                that.view()._scrolling = false;
		                timeStamp = Date.now();
	
		                wrapper.on(TOUCHMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", touchMoveHandler);
		            });
	
		            wrapper.on(TOUCHEND + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function(e) {
		                if (!that._isTouch(e)) {
		                    return;
		                }
	
		                var delta = Date.now() - timeStamp;
		                var content = that.wrapper.find(".k-scheduler-content");
		                var amplitude = -that._amplitude * (3000 / delta);
	
		                endX = that._tapPosition(e, 'X');
		                endY = that._tapPosition(e, 'Y');
	
		                if (that._dragging) {
		                    return;
		                }
	
		                if (that.options.selectable && (Math.abs(endX - startX) <= 10 || Math.abs(endY - startY) <= 10)) {
		                    that._mouseDownSelection(e);
		                }
	
		                if (!kendo.support.kineticScrollNeeded && delta < 200 && Math.abs(endX - startX) > 10) {
		                    content.animate({
		                        scrollTop: content[0].scrollTop + amplitude
		                    });
		                }
	
		                wrapper.off(TOUCHMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", touchMoveHandler);
		            });
		        },
	
		        _selectable: function() {
		            var that = this;
		            var wrapper = that.wrapper;
	
		            if (!that.options.selectable) {
		                return;
		            }
	
		            that._tabindex();
	
		            wrapper.on(MOUSEDOWN + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function (e) {
		                if (that._isTouch(e)) {
		                    return;
		                }
		                that._mouseDownSelection(e);
		            });
	
		            var mouseMoveHandler = $.proxy(that._mouseMove, that);
	
		            wrapper.on(MOUSEDOWN + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", function(e) {
		                var which = e.which;
		                var button = e.button;
		                var isRight = which && which === 3 || button && button == 2;
	
		                if (that._isTouch(e)) {
		                    return;
		                }
	
		                if (!isRight) {
		                    wrapper.on(MOUSEMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", mouseMoveHandler);
		                }
		            });
	
		            wrapper.on("mouseup" + NS + " mousecancel" + NS, function() {
		                wrapper.off(MOUSEMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", mouseMoveHandler);
		            });
	
		            wrapper.on("focus" + NS, function() {
		                if (!that._selection && !that._userTouched) {
		                    that._selectFirstSlot();
		                }
	
		                that._select();
		            });
	
		            wrapper.on("focusout" + NS, function(e) {
		                that._ctrlKey = that._shiftKey = false;
		                that.toolbar.find("ul > li").removeClass(FOCUSEDSTATE);
		                if (!$(e.relatedTarget).closest(VIEWSSELECTOR).length) {
		                    that.toolbar.find(VIEWSSELECTOR).removeClass(EXPANDEDSTATE);
		                }
		            });
	
		            wrapper.on("keydown" + NS, proxy(that._keydown, that));
	
		            wrapper.on("keyup" + NS, function(e) {
		                that._ctrlKey = e.ctrlKey;
		                that._shiftKey = e.shiftKey;
		            });
		        },
	
		        _mouseDownSelection: function(e) {
		            var which = e.which;
		            var button = e.button;
		            var browser = kendo.support.browser;
		            var isRight = which && which === 3 || button && button == 2;
	
		            if (!isRight) {
		                if( e.ctrlKey){
		                    this._ctrlKey = e.ctrlKey;
		                }
	
		                if(e.shiftKey){
		                    this._shiftKey = e.shiftKey;
		                }
		                this._createSelection(e.currentTarget);
		            }
	
		            this.wrapper.focus();
	
		            if (browser.msie && browser.version < 9) {
		                setTimeout(function() {
		                    this.wrapper.focus();
		                });
		            }
	
		            this.toolbar.find("ul > li").removeClass(FOCUSEDSTATE);
		        },
	
		        _selectFirstSlot: function() {
		            this._createSelection(this.wrapper.find(".k-scheduler-content").find("td:first"));
		        },
	
		        _select: function() {
		            var that = this;
		            var view = that.view();
		            var wrapper = that.wrapper;
		            var current = view.current();
		            var selection = that._selection;
		            var oldSelection = that._old ? that._old.selection : null;
		            var oldEventsLength = that._old ? that._old.eventsLength : null;
		            if (!selection) {
		                return;
		            }
	
		            if (current) {
		                current.removeAttribute("id");
		                current.removeAttribute("aria-label");
		                wrapper.removeAttr("aria-activedescendant");
		            }
	
		            view.select(selection);
	
		            current = view.current();
		            if (current && (oldSelection !== current || (selection.events && (oldEventsLength !== selection.events.length )))) {
		                var currentUid = $(current).data("uid");
	
		                if (that._old && currentUid &&
		                    currentUid === $(that._old.selection).data("uid") &&
		                    (selection.events && that._old.eventsLength === selection.events.length)) {
		                    return;
		                }
	
		                var labelFormat;
		                var data = selection;
		                var events = that._selectedEvents();
		                var slots = view._selectedSlots;
	
		                if (events[0]) {
		                    data = events[0] || selection;
		                    labelFormat = kendo.format(that.options.messages.ariaEventLabel, data.title, data.start, data.start);
		                } else {
		                    labelFormat = kendo.format(that.options.messages.ariaSlotLabel, data.start, data.end);
		                }
	
		                current.setAttribute("id", that._ariaId);
		                current.setAttribute("aria-label", labelFormat);
		                wrapper.attr("aria-activedescendant", that._ariaId);
	
		                that._old ={
		                    selection:current,
		                    eventsLength: events.length
		                };
	
		                that.trigger("change", {
		                    start: selection.start,
		                    end: selection.end,
		                    events: events,
		                    slots: slots,
		                    resources: view._resourceBySlot(selection)
		                });
		            }
		        },
	
		        _selectedEvents: function() {
		            var uids = this._selection.events;
		            var length = uids.length;
		            var idx = 0;
		            var event;
	
		            var events = [];
	
		            for (; idx < length; idx++) {
		                event = this.occurrenceByUid(uids[idx]);
		                if (event) {
		                    events.push(event);
		                }
		            }
	
		            return events;
		        },
	
		        _tapPosition: function (event, coordinate) {
		            return /touch/.test(event.type) ? (event.originalEvent || event).changedTouches[0]['page' + coordinate] : event['page' + coordinate];
		        },
	
		        _touchMove: function (e) {
		            var that = this;
		            var content = that.wrapper.find(".k-scheduler-content");
		            var verticalScroll = content[0].scrollHeight > content[0].clientHeight;
		            var horizontalScroll = content[0].scrollWidth > content[0].clientWidth;
		            var endY = that._tapPosition(e, 'Y');
		            var endX = that._tapPosition(e, 'X');
		            var scrollTop = content[0].scrollTop - Math.round(endY - that._touchPosY);
		            var scrollLeft = content[0].scrollLeft - Math.round(endX - that._touchPosX);
		            var applyVerticalScroll = verticalScroll && Math.abs(endY - that._touchPosY) > 10;
		            var applyhorizontalScroll = horizontalScroll && Math.abs(endY - that._touchPosY) > 10;
	
	
		            if (that._dragging || kendo.support.kineticScrollNeeded || !that._isTouch(e)) {
		                return;
		            }
	
		            if (applyVerticalScroll || applyhorizontalScroll) {
		                that._amplitude = Math.round(endY - that._touchPosY);
		                that._touchPosY = endY;
		                that._touchPosX = endX;
		                content.animate({
		                    scrollTop: scrollTop,
		                    scrollLeft: scrollLeft
		                }, 0);
		                that.view()._scrolling = true;
		            }
		        },
	
		        _mouseMove: function(e) {
		            var that = this;
		            clearTimeout(that._moveTimer);
	
		            if (that._isTouch(e)) {
		                return;
		            }
	
		            that._moveTimer = setTimeout(function() {
		                var view = that.view();
		                var selection = that._selection;
	
		                if (selection) {
		                    var slot = view.selectionByElement($(e.currentTarget));
	
		                    if (slot && selection.groupIndex === slot.groupIndex) {
		                        var startDate = slot.startDate();
		                        var endDate = slot.endDate();
	
		                        if (startDate >= selection.end) {
		                            selection.backward = false;
		                        } else if (endDate <= selection.start) {
		                            selection.backward = true;
		                        }
	
		                        if (selection.backward) {
		                            selection.start = startDate;
		                        } else {
		                            selection.end = endDate;
		                        }
	
		                        that._select();
		                    }
		                }
		            }, 5);
		        },
	
		        _viewByIndex: function(index) {
		            var view, views = this.views;
	
		            for (view in views) {
		                if (!index) {
		                    return view;
		                }
	
		                index--;
		            }
		        },
	
		        _keydown: function(e) {
		            var that = this,
		                key = e.keyCode,
		                view = that.view(),
		                editable = view.options.editable,
		                selection = that._selection,
		                prevSelection = $.extend(selection),
		                isModifier = key === 16 || key === 18 || key === 17 || key === 91 || key === 92,
		                focusableToolBarSelector = ".k-scheduler-tools > li," +
		                                    ".k-scheduler-navigation > li," +
		                                    ".k-scheduler-views > li.k-state-selected:visible, " +
		                                    ".k-scheduler-views > li.k-current-view:visible",
		                focusableItems = that.toolbar.find(focusableToolBarSelector),
		                viewsWrapper = that.toolbar.find(VIEWSSELECTOR),
		                shouldNavigate = $(e.target).closest(VIEWSSELECTOR).length || that.toolbar.find('.k-scheduler-views .k-state-focused').length,
		                focusedViewIndex = viewsWrapper.children().index(that.toolbar.find("." + FOCUSEDSTATE)),
		                selectedIndex,
		                isRtl =  kendo.support.isRtl(that.element),
		                direction = isRtl ? -1 : 1;
	
		            if (focusedViewIndex == -1) {
		                focusedViewIndex = viewsWrapper.children().index(that.toolbar.find(".k-state-selected"));
		            }
	
		            that._ctrlKey = e.ctrlKey;
		            that._shiftKey = e.shiftKey;
	
		            if (key === keys.F10) {
		                that.toolbar.find("ul > li:first")
		                                    .focus()
		                                    .addClass(FOCUSEDSTATE);
		                e.preventDefault();
		                return;
		            } else if (key === keys.TAB) {
		                if (that.toolbar.find("." + FOCUSEDSTATE).length) {
		                    var idx = focusableItems.index(that.toolbar.find("." + FOCUSEDSTATE));
		                    if (idx === -1 && that._focusedView) {
		                        idx = focusableItems.index(that.toolbar.find(".k-scheduler-views > .k-state-selected"));
		                    }
		                    var itemToFocus = e.shiftKey ? focusableItems[idx -  1] : focusableItems[idx +  1];
		                    that.toolbar.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
		                    if (itemToFocus) {
		                        $(itemToFocus).addClass(FOCUSEDSTATE).focus();
		                        that._focusedView = null;
		                        e.preventDefault();
		                        return;
		                    } else {
		                        that.element.focus();
		                        e.preventDefault();
		                        return;
		                    }
		                }
		            } else if (key === keys.ENTER || key === keys.SPACEBAR) {
		                if (shouldNavigate && that._focusedView && !that._focusedView.hasClass("k-state-selected")) {
		                    var focusedViewName = that._focusedView.data().name;
		                    if (!that.trigger("navigate", { view: focusedViewName, action: "changeView", date: that.date() })) {
		                        that.view(focusedViewName);
		                        viewsWrapper.removeClass(EXPANDEDSTATE);
		                        if (that.toolbar.find(".k-current-view:visible").length) {
		                            $(document.activeElement).blur();
		                            that.toolbar.find(".k-current-view:visible").addClass(FOCUSEDSTATE).find('.k-link').focus();
		                        }
		                    }
		                    e.preventDefault();
		                    return;
		                }
	
	
		                if (that.toolbar.find("." + FOCUSEDSTATE + ':visible').length) {
		                    that.toolbar.find("." + FOCUSEDSTATE + ':visible').click();
		                    e.preventDefault();
		                    return;
		                }
		            } else if (e.altKey && key === keys.DOWN) {
		                if (that.toolbar.find("." + FOCUSEDSTATE + ':visible').length) {
		                    that.toolbar.find("." + FOCUSEDSTATE + ':visible').click();
		                    e.preventDefault();
		                    return;
		                }
		            } else if (key === keys.RIGHT && shouldNavigate) {
		                $(that.toolbar.find("." + FOCUSEDSTATE)).removeClass(FOCUSEDSTATE);
		                if (isRtl) {
		                    that._focusedView = focusedViewIndex - 1 === 0 ? $(viewsWrapper.children(":not(.k-current-view):last")) : $(viewsWrapper.children()[focusedViewIndex + (1 * direction)]);
		                } else {
		                    that._focusedView = focusedViewIndex + 1 === viewsWrapper.children().length ? $(viewsWrapper.children(":not(.k-current-view):first")) : $(viewsWrapper.children()[focusedViewIndex + (1 * direction)]);
		                }
		                that._focusedView.focus().addClass(FOCUSEDSTATE);
		                e.preventDefault();
		                return;
		            } else if (key === keys.LEFT && shouldNavigate) {
		                $(that.toolbar.find("." + FOCUSEDSTATE)).removeClass(FOCUSEDSTATE);
		                if (isRtl) {
		                    that._focusedView = focusedViewIndex + 1 === viewsWrapper.children().length ? $(viewsWrapper.children(":not(.k-current-view):first")) : $(viewsWrapper.children()[focusedViewIndex - (1 * direction)]);
		                } else {
		                    that._focusedView = focusedViewIndex - 1 === 0 ? $(viewsWrapper.children(":not(.k-current-view):last")) : $(viewsWrapper.children()[focusedViewIndex - (1 * direction)]);
		                }
		                that._focusedView.focus().addClass(FOCUSEDSTATE);
		                e.preventDefault();
		                return;
		            } else if (key === keys.DOWN && that.toolbar.find(VIEWSSELECTOR).hasClass(EXPANDEDSTATE)) {
		                that.toolbar.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
		                if (that._focusedView) {
		                    selectedIndex = viewsWrapper.find(that._focusedView).index();
		                } else {
		                    selectedIndex = viewsWrapper.children(".k-scheduler-views > .k-state-selected").index();
		                }
		                that._focusedView = selectedIndex + 1 === viewsWrapper.children().length ? $(viewsWrapper.children(":not(.k-current-view):first")) : $(viewsWrapper.children()[selectedIndex + (1 * direction)]);
		                that._focusedView.focus().addClass(FOCUSEDSTATE);
		                e.preventDefault();
		                return;
		            } else if (key === keys.UP && that.toolbar.find(VIEWSSELECTOR).hasClass(EXPANDEDSTATE)) {
		                that.toolbar.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
		                if (that._focusedView) {
		                    selectedIndex = viewsWrapper.find(that._focusedView).index();
		                } else {
		                    selectedIndex = viewsWrapper.children(".k-scheduler-views > .k-state-selected").index();
		                }
		                that._focusedView = selectedIndex - 1 === 0 ? $(viewsWrapper.children(":not(.k-current-view):last")) : $(viewsWrapper.children()[selectedIndex - (1 * direction)]);
		                that._focusedView.focus().addClass(FOCUSEDSTATE);
		                e.preventDefault();
		                return;
		            } else if (e.altKey && key === keys.DOWN && that.toolbar.find(".k-nav-current").hasClass(FOCUSEDSTATE)) {
		                that._showCalendar();
		                e.preventDefault();
		                return;
		            } else if (key === keys.ESC && that.popup && that.popup.visible()) {
		                that.popup.close();
		                e.preventDefault();
		                return;
		            } else if (key === keys.ESC && that.toolbar.find(VIEWSSELECTOR).hasClass(EXPANDEDSTATE)) {
		                that.toolbar.find(VIEWSSELECTOR).removeClass(EXPANDEDSTATE);
		                that.toolbar.find(VIEWSSELECTOR).children().removeClass(FOCUSEDSTATE);
	
		                that._focusedView = null;
	
		                that.toolbar.find(".k-current-view").focus().addClass(FOCUSEDSTATE);
		                e.preventDefault();
		                return;
		            }
	
		            if (isModifier) {
		                return;
		            }
	
		            if (!selection) {
		                that._selectFirstSlot();
		                that._select();
		                that.element.focus();
	
		                return;
		            }
	
		            if (key === keys.TAB) {
		                if (view.moveToEvent(selection, e.shiftKey)) {
		                    that._select();
		                    that.element.focus();
	
		                    e.preventDefault();
		                }
		            } else if (key === keys.ENTER || key === keys.SPACEBAR) {
		                if (selection.events.length && editable) {
		                    if (editable.update !== false) {
		                        that.editEvent(selection.events[0]);
		                    }
		                } else if (editable && editable.create !== false) {
		                    if (selection.isAllDay) {
		                        selection = $.extend({}, selection, {
		                            end: kendo.date.addDays(selection.end, -1)
		                        });
		                    }
	
		                    e.preventDefault();
		                    that.addEvent(extend({}, selection, view._resourceBySlot(selection)));
		                }
		            } else if (key === keys.DELETE && editable !== false && editable.destroy !== false) {
		                that.removeEvent(selection.events[0]);
		            } else if (key >= 49 && key <= 57) {
		                // switch to view 1-9
		                var viewByIndex = that._viewByIndex(key - 49);
		                if (viewByIndex && !that.trigger("navigate", { view: viewByIndex, action: "changeView", date: that.date() })) {
		                    that.view(viewByIndex);
		                }
		            } else if (view.move(selection, key, e.shiftKey)) {
		                if (view.inRange(selection)) {
		                    that._select();
		                } else {
		                    var action  = that.date().getTime() > selection.start.getTime() ? "previous": "next";
		                    if (!that.trigger("navigate", { view: that._selectedViewName, action: action, date: selection.start })) {
		                        that.date(selection.start);
		                    } else {
		                        selection.start = prevSelection.start;
		                        selection.end = prevSelection.end;
		                    }
		                }
	
		                that.toolbar.find("ul > li").removeClass(FOCUSEDSTATE);
		                e.preventDefault();
		            }
	
		            that._adjustSelectedDate();
		        },
	
		        _createSelection: function (item) {
		            var selection = this._selection;
		            var uid;
		            var slot;
	
		            item = $(item);
	
		            if (item.is(".k-event")) {
		                uid = item.attr(kendo.attr("uid"));
	
		                if (selection && selection.events.indexOf(uid) !== -1 && !this._ctrlKey) {
		                    return;
		                }
		            }
	
		            if (!selection || (!this._ctrlKey && !this._shiftKey)) {
		                selection = this._selection = {
		                    events: [],
		                    groupIndex: 0
		                };
		            }
	
		            slot = this.view().selectionByElement(item);
	
		            if (slot) {
		                selection.groupIndex = slot.groupIndex || 0;
		            }
	
		            if (uid) {
		                slot = getOccurrenceByUid(this._data, uid);
		            }
	
		            if (slot && slot.uid) {
		                uid = [slot.uid];
		            }
	
		            this._updateSelection(slot, uid);
		            this._adjustSelectedDate();
		        },
	
		        _updateSelection: function(dataItem, events, groupIndex) {
		            var selection = this._selection;
	
		            if (dataItem && selection) {
		                var view =  this.view();
	
		                if (dataItem.uid) {
		                    dataItem = view._updateEventForSelection(dataItem);
		                }
	
		                if (this._shiftKey && selection.start && selection.end) {
		                    var backward = dataItem.end < selection.end;
	
		                    selection.end = dataItem.endDate ? dataItem.endDate() : dataItem.end;
	
		                    if (backward && view._timeSlotInterval) {
		                        kendo.date.setTime(selection.end, -view._timeSlotInterval());
		                    }
		                } else {
		                    selection.start = dataItem.startDate ? dataItem.startDate() : dataItem.start;
		                    selection.end = dataItem.endDate ? dataItem.endDate() : dataItem.end;
		                }
	
		                if ("isDaySlot" in dataItem) {
		                    selection.isAllDay = dataItem.isDaySlot;
		                } else {
		                    selection.isAllDay = dataItem.isAllDay;
		                }
	
		                if (groupIndex !== null && groupIndex !== undefined) {
		                    selection.groupIndex = groupIndex;
		                }
	
		                selection.index = dataItem.index;
		                if (this._ctrlKey) {
		                    var indexOfEvent = (events && events.length) ? selection.events.indexOf(events[0]): -1;
	
		                    if(indexOfEvent > -1){
		                        selection.events.splice(indexOfEvent, 1);
		                    }else{
		                        selection.events = selection.events.concat(events || []);
		                    }
		                } else {
		                        selection.events = events || [];
		                }
		            }
		        },
	
		        options: {
		            name: "Scheduler",
		            date: TODAY,
		            editable: true,
		            autoBind: true,
		            snap: true,
		            mobile: false,
		            timezone: "",
		            allDaySlot: true,
		            min: new Date(1900, 0, 1),
		            max: new Date(2099, 11, 31),
		            toolbar: null,
		            footer: {},
		            messages: {
		                today: "Today",
		                pdf: "Export to PDF",
		                save: "Save",
		                cancel: "Cancel",
		                destroy: "Delete",
		                deleteWindowTitle: "Delete event",
		                next: "Next",
		                previous: "Previous",
		                ariaSlotLabel: "Selected from {0:t} to {1:t}",
		                ariaEventLabel: "{0} on {1:D} at {2:t}",
		                views: {
		                    day: "Day",
		                    week: "Week",
		                    workWeek: "Work Week",
		                    agenda: "Agenda",
		                    month: "Month",
		                    timeline: "Timeline",
		                    timelineWeek: "Timeline Week",
		                    timelineWorkWeek: "Timeline Work Week",
		                    timelineMonth: "Timeline Month"
		                },
		                recurrenceMessages: {
		                    deleteWindowTitle: "Delete Recurring Item",
		                    deleteWindowOccurrence: "Delete current occurrence",
		                    deleteWindowSeries: "Delete the series",
		                    editWindowTitle: "Edit Recurring Item",
		                    editWindowOccurrence: "Edit current occurrence",
		                    editWindowSeries: "Edit the series"
		                },
		                editable: {
		                    confirmation: DELETECONFIRM
		                },
		                editor: {
		                    title: "Title",
		                    start: "Start",
		                    end: "End",
		                    allDayEvent: "All day event",
		                    description: "Description",
		                    repeat: "Repeat",
		                    timezone: "Timezone",
		                    startTimezone: "Start timezone",
		                    endTimezone: "End timezone",
		                    separateTimezones: "Use separate start and end time zones",
		                    timezoneEditorTitle: "Timezones",
		                    timezoneEditorButton: "Time zone",
		                    timezoneTitle: "Time zones",
		                    noTimezone: "No timezone",
		                    editorTitle: "Event"
		                }
		            },
		            height: null,
		            width: null,
		            resources: [],
		            group: {
		                resources: [],
		                orientation: "horizontal"
		            },
		            views: [],
		            selectable: false
		        },
	
		        events: [
		            REMOVE,
		            EDIT,
		            CANCEL,
		            SAVE,
		            "add",
		            "dataBinding",
		            "dataBound",
		            "moveStart",
		            "move",
		            "moveEnd",
		            "resizeStart",
		            "resize",
		            "resizeEnd",
		            "navigate",
		            "change"
		        ],
	
		        destroy: function() {
		            var that = this,
		                element;
	
		            Widget.fn.destroy.call(that);
	
		            if (that.dataSource) {
		                that.dataSource.unbind(CHANGE, that._refreshHandler);
		                that.dataSource.unbind("progress", that._progressHandler);
		                that.dataSource.unbind("error", that._errorHandler);
		            }
	
		            if (that.calendar) {
		                that.calendar.destroy();
		                that.popup.destroy();
		            }
	
		            if (that.view()) {
		                that.view().destroy();
		            }
	
		            if (that._editor) {
		                that._editor.destroy();
		            }
	
		            if (this._moveDraggable) {
		                this._moveDraggable.destroy();
		            }
	
		            if (this._resizeDraggable) {
		                this._resizeDraggable.destroy();
		            }
	
		            element = that.element
		                .add(that.wrapper)
		                .add(that.toolbar)
		                .add(that.popup);
	
		            element.off(NS);
	
		            clearTimeout(that._moveTimer);
	
		            that._model = null;
		            that.toolbar = null;
		            that.element = null;
	
		            $(window).off("resize" + NS, that._resizeHandler);
	
		            kendo.destroy(that.wrapper);
		        },
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
	
		            this._dataSource();
	
		            if (this.options.autoBind && dataSource.fetch) {
		                dataSource.fetch();
		            } else if (isArray(dataSource)) {
		                this.view(this._selectedView);
		            }
		        },
	
		        items: function() {
		            var content = this.wrapper.find(".k-scheduler-content");
		            var view = this.view();
	
		            if (view && view.options.name === "agenda") {
		                return content.find(".k-task");
		            } else {
		                return content.find(".k-event")
		                              .add(this.wrapper.find(".k-scheduler-header-wrap")
		                                       .find(".k-scheduler-header-all-day").siblings());
		            }
		        },
	
		        _movable: function() {
		            var startSlot;
		            var endSlot;
		            var startResources;
		            var startTime;
		            var endTime;
		            var event;
		            var clonedEvent;
		            var that = this;
		            var originSlot;
		            var originStartTime;
		            var originalEvent;
		            var distance = 0;
		            var clonedEvents = [];
		            var cachedEvents = [];
	
		            var isMobile = that._isMobile();
		            var movable = that.options.editable && that.options.editable.move !== false;
		            var resizable = that.options.editable && that.options.editable.resize !== false;
	
		            if (movable || (resizable && isMobile)) {
		                that._dragging = false;
		                if (isMobile && kendo.support.mobileOS.android) {
		                    distance = 5;
		                }
	
		                that._moveDraggable = new kendo.ui.Draggable(that.element, {
		                    distance: distance,
		                    filter: ".k-event",
		                    ignore: ".k-resize-handle",
		                    holdToDrag: isMobile,
		                    autoScroll: true
		                });
	
		                if (movable) {
		                    that._moveDraggable.bind("dragstart", function(e) {
		                        var view = that.view();
		                        var eventElement = e.currentTarget;
		                        var isTouch = that._isTouch(e);
		                        that._dragging = true;
	
		                        if (!view.options.editable || view.options.editable.move === false) {
		                            that._dragging = false;
		                            e.preventDefault();
		                            return;
		                        }
	
		                        if (isTouch && !eventElement.hasClass("k-event-active")) {
		                            that._dragging = false;
		                            that.element.find(".k-event-active").removeClass("k-event-active");
		                            e.preventDefault();
		                            return;
		                        }
	
		                        event = that.occurrenceByUid(eventElement.attr(kendo.attr("uid")));
	
		                        clonedEvent = event.clone();
		                        originalEvent = event.clone();
	
		                        clonedEvent.update(view._eventOptionsForMove(clonedEvent));
	
		                        clonedEvents = [];
		                        if (that._selection) {
		                            var events = that._selection.events;
	
		                            for (var i = 0; i < events.length; i++) {
		                                var evtClone = that.occurrenceByUid(events[i]).clone();
	
		                                evtClone.update(view._eventOptionsForMove(evtClone));
	
		                                clonedEvents.push(evtClone);
		                            }
		                        } else {
		                            clonedEvents.push(clonedEvent);
		                        }
	
		                        startSlot = view._slotByPosition(e.x.startLocation, e.y.startLocation);
		                        startResources = view._resourceBySlot(startSlot);
	
		                        originStartTime = startTime = startSlot.startOffset(e.x.startLocation, e.y.startLocation, that.options.snap);
	
		                        endSlot = startSlot;
	
		                        originSlot = startSlot;
	
		                        if (!startSlot || that.trigger("moveStart", { event: event })) {
		                            e.preventDefault();
		                        }
		                    })
		                    .bind("drag", function(e) {
		                        var view = that.view();
		                        var slot = view._slotByPosition(e.x.location, e.y.location);
		                        var distance;
		                        var range;
		                        var i;
	
		                        if (!slot) {
		                            return;
		                        }
	
		                        endTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
	
		                        if (slot.isDaySlot !== startSlot.isDaySlot) {
	
		                            if (slot.isDaySlot !== originSlot.isDaySlot) {
		                                var slotIndex = $(startSlot.element).index();
	
		                                var targetSlotElement = $(slot.element).parent().children().eq(slotIndex);
	
		                                startSlot = view._slotByPosition(targetSlotElement.offset().left, targetSlotElement.offset().top);
	
		                                startTime = startSlot.startOffset(e.x.location, e.y.location, true);
	
		                                cachedEvents = clonedEvents.map(function(event) { return event.clone(); });
	
		                                for (i = 0; i < clonedEvents.length; i++) {
		                                    if (clonedEvents[i].isAllDay != slot.isDaySlot) {
		                                        clonedEvents[i].isAllDay = slot.isDaySlot;
	
		                                        clonedEvents[i].end = kendo.date.getDate(clonedEvents[i].start);
		                                        clonedEvents[i].start = kendo.date.getDate(clonedEvents[i].start);
	
		                                        if (!slot.isDaySlot) {
		                                            kendo.date.setTime(clonedEvents[i].start, kendo.date.getMilliseconds(view.startTime()));
		                                            kendo.date.setTime(clonedEvents[i].end, kendo.date.getMilliseconds(view.startTime()) + view._timeSlotInterval());
		                                        }
		                                    }
		                                }
		                            } else {
		                                startSlot = $.extend(true, { }, originSlot);
		                                startTime = originStartTime;
	
		                                clonedEvents = cachedEvents;
		                            }
		                        }
	
		                        distance = endTime - startTime;
	
		                        for (i = 0; i < clonedEvents.length; i++) {
		                            view._updateMoveHint(clonedEvents[i], slot.groupIndex, distance);
		                        }
	
		                        range = moveEventRange(clonedEvent, distance);
	
		                        if (!that.trigger("move", {
		                            event: event,
		                            slot: { element: slot.element, start: slot.startDate(), end: slot.endDate(), isDaySlot: slot.isDaySlot },
		                            resources: view._resourceBySlot(slot),
		                            start: range.start,
		                            end: range.end
		                        })) {
		                            endSlot = slot;
		                        } else {
		                            for (i = 0; i < clonedEvents.length; i++) {
		                                view._updateMoveHint(clonedEvents[i], slot.groupIndex, distance);
		                            }
		                        }
		                    })
		                    .bind("dragend", function(e) {
		                        that.view()._removeMoveHint();
		                        var distance = endTime - startTime;
		                        var range = moveEventRange(clonedEvent, distance);
		                        var start = range.start;
		                        var end = range.end;
		                        that._dragging = false;
	
		                        var endResources = that.view()._resourceBySlot(endSlot);
	
		                        var prevented = that.trigger("moveEnd", {
		                            event: event,
		                            slot: { element: endSlot.element, start: endSlot.startDate(), end: endSlot.endDate() },
		                            start: start,
		                            end: end,
		                            resources: endResources
		                        });
	
		                        if (!prevented && (event.start.getTime() !== start.getTime() ||
		                            event.end.getTime() !== end.getTime() ||
		                            originSlot.isDaySlot !== endSlot.isDaySlot ||
		                            kendo.stringify(endResources) !== kendo.stringify(startResources))) {
	
		                            that._isMultiDrag = clonedEvents.length > 1;
	
		                            for (var i = 0; i < clonedEvents.length; i++) {
		                                var evt = clonedEvents[i];
	
		                                range = moveEventRange(evt, distance);
	
		                                var updatedEventOptions = that.view()._eventOptionsForMove(evt);
		                                var eventOptions = $.extend(
		                                    {
		                                        isAllDay: evt.isAllDay,
		                                        start: range.start,
		                                        end: range.end
		                                    },
		                                    updatedEventOptions,
		                                    endResources
		                                );
	
		                                that._updateEvent(null, evt, eventOptions);
		                            }
	
		                            if (that._isMultiDrag) {
		                                that.dataSource.sync();
		                                that._isMultiDrag = false;
		                            }
		                        }
	
		                        e.currentTarget.removeClass("k-event-active");
		                        this.cancelHold();
		                        clonedEvents = [];
		                        cachedEvents = [];
		                    })
		                    .bind("dragcancel", function() {
		                        that.view()._removeMoveHint();
		                        this.cancelHold();
		                        clonedEvents = [];
		                        cachedEvents = [];
		                    });
		                }
	
		                that._moveDraggable.bind("hold", function(e) {
		                    if (that._isTouch(e)) {
		                        that.element.find(".k-event-active").removeClass("k-event-active");
		                        if (that.options.selectable) {
		                            that._createSelection(e.currentTarget);
		                        }
		                        e.currentTarget.addClass("k-event-active");
		                    }
		                });
		            }
		        },
	
		        _resizable: function() {
		            var startTime;
		            var endTime;
		            var event;
		            var clonedEvent;
		            var slot;
		            var that = this;
		            var distance = 0;
	
		            function direction(handle) {
		                var directions = {
		                    "k-resize-e": "east",
		                    "k-resize-w": "west",
		                    "k-resize-n": "north",
		                    "k-resize-s": "south"
		                };
	
		                for (var key in directions) {
		                    if (handle.hasClass(key)) {
		                        return directions[key];
		                    }
		                }
		            }
	
		            if (that._isMobile() && kendo.support.mobileOS.android) {
		                distance = 5;
		            }
	
		            that._resizeDraggable = new kendo.ui.Draggable(that.element, {
		                distance: distance,
		                filter: ".k-resize-handle",
		                autoScroll: true,
		                dragstart: function(e) {
		                    var dragHandle = $(e.currentTarget);
	
		                    var eventElement = dragHandle.closest(".k-event");
	
		                    var uid = eventElement.attr(kendo.attr("uid"));
	
		                    var view = that.view();
	
		                    that._dragging = true;
		                    event = that.occurrenceByUid(uid);
	
		                    clonedEvent = event.clone();
	
		                    view._updateEventForResize(clonedEvent);
	
		                    slot = view._slotByPosition(e.x.startLocation, e.y.startLocation);
	
		                    if (that.trigger("resizeStart", { event: event })) {
		                        e.preventDefault();
		                    }
	
		                    startTime = kendo.date.toUtcTime(clonedEvent.start);
	
		                    endTime = kendo.date.toUtcTime(clonedEvent.end);
		                },
		                drag: function(e) {
		                    if (!slot) {
		                        return;
		                    }
	
		                    var dragHandle = $(e.currentTarget);
	
		                    var dir = direction(dragHandle);
	
		                    var view = that.view();
	
		                    var currentSlot = view._slotByPosition(e.x.location, e.y.location);
	
		                    if (!currentSlot || slot.groupIndex != currentSlot.groupIndex) {
		                        return;
		                    }
	
		                    slot = currentSlot;
	
		                    var originalStart = startTime;
	
		                    var originalEnd = endTime;
	
		                    if (dir == "south") {
		                        if (!slot.isDaySlot && slot.end - kendo.date.toUtcTime(clonedEvent.start) >= view._timeSlotInterval()) {
		                            if (clonedEvent.isAllDay) {
		                                endTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
		                            } else {
		                                endTime = slot.endOffset(e.x.location, e.y.location, that.options.snap);
		                            }
		                        }
		                    } else if (dir == "north") {
		                        if (!slot.isDaySlot && kendo.date.toUtcTime(clonedEvent.end) - slot.start >= view._timeSlotInterval()) {
		                            startTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
		                        }
		                    } else if (dir == "east") {
		                        if (slot.isDaySlot && kendo.date.toUtcTime(kendo.date.getDate(slot.endDate())) >= kendo.date.toUtcTime(kendo.date.getDate(clonedEvent.start))) {
		                            if (clonedEvent.isAllDay) {
		                                endTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
		                            } else {
		                                endTime = slot.endOffset(e.x.location, e.y.location, that.options.snap);
		                            }
		                        } else if (!slot.isDaySlot && slot.end - kendo.date.toUtcTime(clonedEvent.start) >= view._timeSlotInterval()) {
		                            endTime = slot.endOffset(e.x.location, e.y.location, that.options.snap);
		                        }
		                    } else if (dir == "west") {
		                        if (slot.isDaySlot && kendo.date.toUtcTime(kendo.date.getDate(clonedEvent.end)) >= kendo.date.toUtcTime(kendo.date.getDate(slot.startDate()))) {
		                            startTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
		                        } else if (!slot.isDaySlot && kendo.date.toUtcTime(clonedEvent.end) - slot.start >= view._timeSlotInterval()) {
		                            startTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
		                        }
		                    }
	
		                    if (!that.trigger("resize", {
		                        event: event,
		                        slot: { element: slot.element, start: slot.startDate(), end: slot.endDate() },
		                        start: kendo.timezone.toLocalDate(startTime),
		                        end: kendo.timezone.toLocalDate(endTime),
		                        resources: view._resourceBySlot(slot)
		                    })) {
		                        view._updateResizeHint(clonedEvent, slot.groupIndex, startTime, endTime);
		                    } else {
		                        startTime = originalStart;
		                        endTime = originalEnd;
		                    }
		                },
		                dragend: function(e) {
		                    var dragHandle = $(e.currentTarget);
		                    var start = new Date(clonedEvent.start.getTime());
		                    var end = new Date(clonedEvent.end.getTime());
		                    var dir = direction(dragHandle);
	
		                    that._dragging = false;
		                    that.view()._removeResizeHint();
	
		                    if (dir == "south") {
		                        end = kendo.timezone.toLocalDate(endTime);
		                    } else if (dir == "north") {
		                        start = kendo.timezone.toLocalDate(startTime);
		                    } else if (dir == "east") {
		                        if (slot.isDaySlot) {
		                            end = kendo.date.getDate(kendo.timezone.toLocalDate(endTime));
		                        } else {
		                            end = kendo.timezone.toLocalDate(endTime);
		                        }
		                    } else if (dir == "west") {
		                        if (slot.isDaySlot) {
		                            start = new Date(kendo.timezone.toLocalDate(startTime));
		                            start.setHours(0);
		                            start.setMinutes(0);
		                        } else {
		                            start = kendo.timezone.toLocalDate(startTime);
		                        }
		                    }
	
		                    var prevented = that.trigger("resizeEnd", {
		                        event: event,
		                        slot: { element: slot.element, start: slot.startDate(), end: slot.endDate() },
		                        start: start,
		                        end: end,
		                        resources: that.view()._resourceBySlot(slot)
		                    });
	
		                    if (!prevented && end.getTime() >= start.getTime()) {
		                        if (clonedEvent.start.getTime() != start.getTime() || clonedEvent.end.getTime() != end.getTime()) {
		                            that.view()._updateEventForResize(event);
		                            that._updateEvent(dir, event, { start: start, end: end });
		                        }
		                    }
	
		                    slot = null;
		                    event = null;
		                },
		                dragcancel: function() {
		                    that._dragging = false;
		                    that.view()._removeResizeHint();
	
		                    slot = null;
		                    event = null;
		                }
		            });
		        },
	
		        _updateEvent: function(dir, event, eventInfo) {
		            var that = this;
	
		            var updateEvent = function(event, callback) {
		                try {
		                    that._preventRefresh = true;
		                    event.update(eventInfo);
		                    that._convertDates(event);
		                } finally {
		                    that._preventRefresh = false;
		                }
	
		                if (!that.trigger(SAVE, { event: event })) {
		                    if (callback) {
		                        callback();
		                    }
	
		                    if (!that._isMultiDrag) {
		                        that.dataSource.sync();
		                    }
		                }
		            };
	
		            var recurrenceHead = function(event) {
		                if (event.recurrenceRule) {
		                    return that.dataSource.getByUid(event.uid);
		                } else {
		                    return that.dataSource.get(event.recurrenceId);
		                }
		            };
	
		            var updateSeries = function() {
		                var head = recurrenceHead(event);
	
		                if (dir == "south" || dir == "north") {
		                    if (eventInfo.start) {
		                        var start = kendo.date.getDate(head.start);
		                        kendo.date.setTime(start, getMilliseconds(eventInfo.start));
		                        eventInfo.start = start;
		                    }
		                    if (eventInfo.end) {
		                        var end = kendo.date.getDate(head.end);
		                        kendo.date.setTime(end, getMilliseconds(eventInfo.end));
		                        eventInfo.end = end;
		                    }
		                }
	
		                that.dataSource._removeExceptions(head);
	
		                updateEvent(head);
		            };
	
		            var updateOccurrence = function() {
		                var head = recurrenceHead(event);
		                var eventUid;
	
		                var callback = function() {
		                    that._convertDates(head);
	
		                    if (that._selection) {
		                        that._selection.events.push(eventUid);
		                    }
		                };
	
		                var exception = head.toOccurrence({ start: event.start, end: event.end });
	
		                eventUid = exception.uid;
	
		                updateEvent(that.dataSource.add(exception), callback);
		            };
	
		            if (event.recurrenceRule || event.isOccurrence()) {
		                var recurrenceMessages = that.options.messages.recurrenceMessages;
	
		                that._showRecurringDialog(event, updateOccurrence, updateSeries,{
		                    title: recurrenceMessages.editWindowTitle,
		                    text: recurrenceMessages.editRecurring ? recurrenceMessages.editRecurring : EDITRECURRING,
		                    occurrenceText: recurrenceMessages.editWindowOccurrence,
		                    seriesText: recurrenceMessages.editWindowSeries
		                });
		            } else {
		                updateEvent(that.dataSource.getByUid(event.uid));
		            }
		        },
	
		        _modelForContainer: function(container) {
		            container = $(container).closest("[" + kendo.attr("uid") + "]");
	
		            return this.dataSource.getByUid(container.attr(kendo.attr("uid")));
		        },
	
		        showDialog: function(options) {
		            this._editor.showDialog(options);
		        },
	
		        focus: function() {
		            this.wrapper.focus();
		        },
	
		        _confirmation: function(callback, model) {
		            var editable = this.options.editable;
	
		            if (editable === true || editable.confirmation !== false) {
		                var messages = this.options.messages;
		                var title = messages.deleteWindowTitle;
		                var text = typeof editable.confirmation === STRING ? editable.confirmation : messages.editable.confirmation;
	
		                if (this._isEditorOpened() && model.isRecurring()) {
		                    var recurrenceMessages = this.options.messages.recurrenceMessages;
		                    title = recurrenceMessages.deleteWindowTitle;
	
		                    if (model.isException()) {
		                        text = recurrenceMessages.deleteRecurringConfirmation ? recurrenceMessages.deleteRecurringConfirmation : DELETERECURRINGCONFIRM;
		                    } else {
		                        text = recurrenceMessages.deleteSeriesConfirmation ? recurrenceMessages.deleteSeriesConfirmation : DELETESERIESCONFIRM;
		                    }
		                }
	
		                var buttons = [
		                    { name: "destroy", text: messages.destroy, click: function() { callback(); } }
		                ];
	
		                if (!(this._isMobile() && kendo.mobile.ui.Pane)) {
		                    buttons.push({ name: "canceledit", text: messages.cancel, click: function() { callback(true); } });
		                }
	
		                this._unbindResize();
	
		                this.showDialog({
		                    model: model,
		                    text: text,
		                    title: title,
		                    buttons: buttons
		                });
	
		                this._bindResize();
		            } else {
		                callback();
		            }
		        },
	
		        addEvent: function(eventInfo) {
		            var editable = this._editor.editable;
		            var dataSource = this.dataSource;
		            var event;
	
		            eventInfo = eventInfo || {};
	
		            var prevented = this.trigger("add", { event:  eventInfo });
	
		            if (!prevented && ((editable && editable.end()) || !editable)) {
	
		                this.cancelEvent();
	
		                if (eventInfo && eventInfo.toJSON) {
		                    eventInfo = eventInfo.toJSON();
		                }
	
		                event = dataSource.add(eventInfo);
	
		                if (event) {
		                    this.cancelEvent();
		                    this._editEvent(event);
		                }
		            }
		       },
	
		       saveEvent: function() {
		            var editor = this._editor;
	
		            if (!editor) {
		                return;
		            }
	
		            var editable = editor.editable;
		            var container = editor.container;
		            var model = this._modelForContainer(container);
	
		            if (container && editable && editable.end() &&
		                !this.trigger(SAVE, { container: container, event: model } )) {
	
		                if (model.isRecurrenceHead()) {
		                    this.dataSource._removeExceptions(model);
		                }
	
		                if (!model.dirty && !model.isOccurrence()) {
		                    this._convertDates(model, "remove");
		                }
	
		                this.dataSource.sync();
		            }
		        },
	
		        cancelEvent: function() {
		            var editor = this._editor;
		            var container = editor.container;
		            var model;
	
		            if (container) {
		                model = this._modelForContainer(container);
	
		                if (model && model.isOccurrence()) {
		                    this._convertDates(model, "remove");
		                    this._convertDates(this.dataSource.get(model.recurrenceId), "remove");
		                }
	
		                this.dataSource.cancelChanges(model);
	
		                //TODO: handle the cancel in UI
	
		                editor.close();
		            }
		        },
	
		        editEvent: function(uid) {
		            var model = typeof uid == "string" ? this.occurrenceByUid(uid) : uid;
	
		            if (!model) {
		                return;
		            }
	
		            this.cancelEvent();
	
		            if (model.isRecurring()) {
		                this._editRecurringDialog(model);
		            } else {
		                this._editEvent(model);
		            }
		        },
	
		        _editEvent: function(model) {
		            this._unbindResize();
	
		            this._createPopupEditor(model);
	
		            this._bindResize();
		        },
	
		        _editRecurringDialog: function(model) {
		            var that = this;
	
		            var editOccurrence = function() {
		                if (model.isException()) {
		                    that._editEvent(model);
		                } else {
		                    that.addEvent(model);
		                }
		            };
	
		            var editSeries = function() {
		                if (model.recurrenceId) {
		                    model = that.dataSource.get(model.recurrenceId);
		                }
	
		                that._editEvent(model);
		            };
	
		            var recurrenceMessages = that.options.messages.recurrenceMessages;
		            that._showRecurringDialog(model, editOccurrence, editSeries, {
		                title: recurrenceMessages.editWindowTitle,
		                text: recurrenceMessages.editRecurring ? recurrenceMessages.editRecurring : EDITRECURRING,
		                occurrenceText: recurrenceMessages.editWindowOccurrence,
		                seriesText: recurrenceMessages.editWindowSeries
		            });
		         },
	
		         _showRecurringDialog: function(model, editOccurrence, editSeries, messages) {
		             var editable = this.options.editable;
		             var editRecurringMode = isPlainObject(editable) ? editable.editRecurringMode : "dialog";
	
		             if (editRecurringMode ===  "occurrence" || this._isMultiDrag) {
		                 editOccurrence();
		             } else if (editRecurringMode === "series") {
		                 editSeries();
		             } else {
		                 this._unbindResize();
	
		                 this.showDialog({
		                     model: model,
		                     title: messages.title,
		                     text: messages.text,
		                     buttons: [
		                         { text: messages.occurrenceText, click: editOccurrence },
		                         { text: messages.seriesText, click: editSeries }
		                     ]
		                 });
	
		                 this._bindResize();
		             }
		        },
	
		        _createButton: function(command) {
		            var template = command.template || COMMANDBUTTONTMPL,
		                commandName = typeof command === STRING ? command : command.name || command.text,
		                options = { className: "k-scheduler-" + (commandName || "").replace(/\s/g, ""), text: commandName, attr: "" };
	
		            if (!commandName && !(isPlainObject(command) && command.template))  {
		                throw new Error("Custom commands should have name specified");
		            }
	
		            if (isPlainObject(command)) {
		                if (command.className) {
		                    command.className += " " + options.className;
		                }
	
		                if (commandName === "edit" && isPlainObject(command.text)) {
		                    command = extend(true, {}, command);
		                    command.text = command.text.edit;
		                }
	
		                options = extend(true, options, defaultCommands[commandName], command);
		            } else {
		                options = extend(true, options, defaultCommands[commandName]);
		            }
	
		            return kendo.template(template)(options);
		        },
	
		        _convertDates: function(model, method) {
		            var timezone = this.dataSource.reader.timezone;
		            var startTimezone = model.startTimezone;
		            var endTimezone = model.endTimezone;
		            var start = model.start;
		            var end = model.start;
	
		            method = method || "apply";
		            startTimezone = startTimezone || endTimezone;
		            endTimezone = endTimezone || startTimezone;
	
		            if (startTimezone) {
		                if (timezone) {
		                    if (method === "apply") {
		                        start = kendo.timezone.convert(model.start, timezone, startTimezone);
		                        end = kendo.timezone.convert(model.end, timezone, endTimezone);
		                    } else {
		                        start = kendo.timezone.convert(model.start, startTimezone, timezone);
		                        end = kendo.timezone.convert(model.end, endTimezone, timezone);
		                    }
		                } else {
		                    start = kendo.timezone[method](model.start, startTimezone);
		                    end = kendo.timezone[method](model.end, endTimezone);
		                }
	
		                model._set("start", start);
		                model._set("end", end);
		            }
		        },
	
		        _createEditor: function() {
		            var that = this;
	
		            var editor;
	
		            if (this._isMobile() && kendo.mobile.ui.Pane) {
		                editor = that._editor = new MobileEditor(this.wrapper, extend({}, this.options, {
		                    target: this,
		                    timezone: that.dataSource.reader.timezone,
		                    resources: that.resources,
		                    createButton: proxy(this._createButton, this)
		                }));
		            } else {
		                editor = that._editor = new PopupEditor(this.wrapper, extend({}, this.options, {
		                    target: this,
		                    createButton: proxy(this._createButton, this),
		                    timezone: that.dataSource.reader.timezone,
		                    resources: that.resources
		                }));
		            }
	
		            editor.bind("cancel", function(e) {
		                if (that.trigger("cancel", { container: e.container, event: e.model })) {
		                    e.preventDefault();
		                    return;
		                }
		                that.cancelEvent();
	
		                that.focus();
		            });
	
		            editor.bind("edit", function(e) {
		                if (that.trigger(EDIT, { container: e.container, event: e.model })) {
		                    e.preventDefault();
		                }
		            });
	
		            editor.bind("save", function() {
		                that.saveEvent();
		            });
	
		            editor.bind("remove", function(e) {
		                that.removeEvent(e.model);
		            });
		        },
	
		        _createPopupEditor: function(model) {
		            var editor = this._editor;
	
		            if (!model.isNew() || model.isOccurrence()) {
		                if (model.isOccurrence()) {
		                    this._convertDates(model.recurrenceId ? this.dataSource.get(model.recurrenceId) : model);
		                }
		                this._convertDates(model);
		            }
	
		            this.editable = editor.editEvent(model);
		        },
	
		        removeEvent: function(uid) {
		            var that = this,
		                model = typeof uid == "string" ? that.occurrenceByUid(uid) : uid;
	
		            if (!model) {
		                return;
		            }
	
		            if (model.isRecurring()) {
		                that._deleteRecurringDialog(model);
		            } else {
		                that._confirmation(function(cancel) {
		                    if (!cancel) {
		                        that._removeEvent(model);
		                    }
		                }, model);
		            }
		        },
	
		        occurrenceByUid: function(uid) {
		            var occurrence = this.dataSource.getByUid(uid);
		            if (!occurrence) {
		                occurrence = getOccurrenceByUid(this._data, uid);
		            }
	
		            return occurrence;
		        },
	
		        occurrencesInRange: function(start, end) {
		            return new kendo.data.Query(this._data).filter({
		                logic: "or",
		                filters: [
		                    {
		                        logic: "and",
		                        filters: [
		                            { field: "start", operator: "gte", value: start },
		                            { field: "end", operator: "gte", value: start },
		                            { field: "start", operator: "lt", value: end }
		                        ]
		                    },
		                    {
		                        logic: "and",
		                        filters: [
		                            { field: "start", operator: "lte", value: start },
		                            { field: "end", operator: "gt", value: start }
		                        ]
		                    }
		                ]
		            }).toArray();
		        },
	
		        _removeEvent: function(model) {
		            if (!this.trigger(REMOVE, { event: model })) {
		                if (this.dataSource.remove(model)) {
		                    this.dataSource.sync();
		                }
		            }
		        },
	
		        _deleteRecurringDialog: function(model) {
		            var that = this;
		            var currentModel = model;
		            var editable = that.options.editable;
		            var deleteOccurrence;
		            var deleteSeries;
		            var deleteOccurrenceConfirmation;
		            var deleteSeriesConfirmation;
		            var editRecurringMode = isPlainObject(editable) ? editable.editRecurringMode : "dialog";
	
		            deleteOccurrence = function() {
		                var occurrence = currentModel.recurrenceId ? currentModel : currentModel.toOccurrence();
		                var head = that.dataSource.get(occurrence.recurrenceId);
	
		                that._convertDates(head);
		                that._removeEvent(occurrence);
		            };
	
		            deleteSeries = function() {
		                if (currentModel.recurrenceId) {
		                    currentModel = that.dataSource.get(currentModel.recurrenceId);
		                }
	
		                that._removeEvent(currentModel);
		            };
	
		            if (editRecurringMode != "dialog" || that._isEditorOpened()) {
		                deleteOccurrenceConfirmation = function() {
		                    that._confirmation(function(cancel) {
		                        if (!cancel) {
		                            deleteOccurrence();
		                        }
		                    }, currentModel);
		                };
	
		                deleteSeriesConfirmation = function() {
		                    that._confirmation(function(cancel) {
		                        if (!cancel) {
		                            deleteSeries();
		                        }
		                    }, currentModel);
		                };
		            }
	
		            var seriesCallback = deleteSeriesConfirmation || deleteSeries;
		            var occurrenceCallback = deleteOccurrenceConfirmation || deleteOccurrence;
	
		            if (that._isEditorOpened()) {
		                if (model.isException()) {
		                    occurrenceCallback();
		                } else {
		                    seriesCallback();
		                }
		            } else {
		                var recurrenceMessages = that.options.messages.recurrenceMessages;
		                that._showRecurringDialog(model, occurrenceCallback, seriesCallback, {
		                    title: recurrenceMessages.deleteWindowTitle,
		                    text: recurrenceMessages.deleteRecurring ? recurrenceMessages.deleteRecurring : DELETERECURRING,
		                    occurrenceText: recurrenceMessages.deleteWindowOccurrence,
		                    seriesText: recurrenceMessages.deleteWindowSeries
		                });
		            }
		        },
	
		        _isEditorOpened: function() {
		            return !!this._editor.container;
		        },
	
		        _unbindView: function(view) {
		            var that = this;
		            that.angular("cleanup", function(){
		                return { elements: that.items() };
		            });
	
		            view.destroy();
		        },
	
		        _bindView: function(view) {
		            var that = this;
	
		            if (that.options.editable) {
		                if (that._viewRemoveHandler) {
		                    view.unbind(REMOVE, that._viewRemoveHandler);
		                }
	
		                that._viewRemoveHandler = function(e) {
		                    that.removeEvent(e.uid);
		                };
	
		                view.bind(REMOVE, that._viewRemoveHandler);
	
		                if (that._viewAddHandler) {
		                    view.unbind(ADD, that._viewAddHandler);
		                }
	
		                that._viewAddHandler = function(e) {
		                    that.addEvent(e.eventInfo);
		                };
	
		                view.bind(ADD, this._viewAddHandler);
	
		                if (that._viewEditHandler) {
		                    view.unbind(EDIT, that._viewEditHandler);
		                }
	
		                that._viewEditHandler = function(e) {
		                    that.editEvent(e.uid);
		                };
	
		                view.bind(EDIT, this._viewEditHandler);
		            }
	
		            if (that._viewNavigateHandler) {
		                view.unbind("navigate", that._viewNavigateHandler);
		            }
	
		            that._viewNavigateHandler = function(e) {
		                if (e.view) {
		                    var switchWorkDay = "isWorkDay" in e;
		                    var action = switchWorkDay ? "changeWorkDay" : "changeView";
	
		                    if (!that.trigger("navigate", { view: e.view, isWorkDay: e.isWorkDay, action: action, date: e.date })) {
		                        if (switchWorkDay) {
		                            that._workDayMode = e.isWorkDay;
		                        }
	
		                        that._selectView(e.view);
		                        that.date(e.date);
		                    }
		                }
		            };
	
		            view.bind("navigate", that._viewNavigateHandler);
	
		            if (that._viewActivateHandler) {
		                view.unbind("activate", that._viewActivateHandler);
		            }
	
		            that._viewActivateHandler = function() {
		                var view = this;
		                if (that._selection) {
		                    view.constrainSelection(that._selection);
	
		                    that._select();
	
		                    that._adjustSelectedDate();
		                }
		            };
	
		            view.bind("activate", that._viewActivateHandler);
		        },
	
		        _selectView: function(name) {
		            var that = this;
	
		            if (name && that.views[name]) {
	
		                if (that._selectedView) {
		                    that._unbindView(that._selectedView);
		                }
	
		                that._selectedView = that._renderView(name);
		                that._selectedViewName = name;
	
		                if (that._viewsCount > 1) {
		                    var viewButton = VIEWBUTTONTEMPLATE({views: that.views, view: name, ns: kendo.ns});
		                    var firstButton = that.toolbar.find(".k-scheduler-views li:first-child");
	
		                    if (firstButton.is(".k-current-view")) {
		                        firstButton.replaceWith(viewButton);
		                    } else {
		                        that.toolbar.find(".k-scheduler-views").prepend(viewButton);
		                    }
	
		                    var viewButtons =  that.toolbar.find(".k-scheduler-views li")
		                        .removeClass("k-state-selected");
	
	
		                    viewButtons.end().find(".k-view-" + name.replace(/\./g, "\\.").toLowerCase())
		                        .addClass("k-state-selected");
		                }
		            }
		        },
	
		        view: function(name) {
		            var that = this;
	
		            if (name) {
	
		                that._selectView(name);
	
		                that.rebind();
	
		                return;
	
		            }
	
		            return that._selectedView;
		        },
	
		        viewName: function() {
		            return this.view().name;
		        },
	
		        _renderView: function(name) {
		            var view = this._initializeView(name);
	
		            this._bindView(view);
	
		            if (kendo.support.mouseAndTouchPresent || kendo.support.pointers) {
		                view.content.css("-ms-touch-action", "pinch-zoom");
		                view.content.css("touch-action", "pinch-zoom");
		            }
	
		            this._model.set("formattedDate", view.dateForTitle());
		            this._model.set("formattedShortDate", view.shortDateForTitle());
	
		            return view;
		        },
	
		        resize: function(force) {
		            var size = this.getSize();
		            var currentSize = this._size;
		            var view = this.view();
	
		            if (!view || !view.groups) {
		                return;
		            }
	
		            if (force || !currentSize || size.width !== currentSize.width || size.height !== currentSize.height) {
		                this.refresh({ action: "resize" });
		                this._size = size;
		            }
		        },
	
		        _adjustSelectedDate: function() {
		            var date = this._model.selectedDate,
		                selection = this._selection,
		                start = selection.start;
	
		            if (start && !kendo.date.isInDateRange(date, getDate(start), getDate(selection.end))) {
		                date.setFullYear(start.getFullYear(), start.getMonth(), start.getDate());
		            }
		        },
	
		        _initializeView: function(name) {
		            var view = this.views[name];
	
		            if (view) {
		                var isSettings = isPlainObject(view),
		                    type = view.type;
	
		                if (typeof type === STRING) {
		                    type = kendo.getter(view.type)(window);
		                }
	
		                if (type) {
		                    view = new type(this.wrapper, trimOptions(extend(true, {}, this.options, isSettings ? view : {}, { resources: this.resources, date: this.date(), showWorkHours: this._workDayMode })));
		                } else {
		                    throw new Error("There is no such view");
		                }
		            }
	
		            return view;
		        },
	
		        _views: function() {
		            var views = this.options.views;
		            var view;
		            var defaultView;
		            var selected;
		            var isSettings;
		            var name;
		            var type;
		            var idx;
		            var length;
	
		            this.views = {};
		            this._viewsCount = 0;
	
		            for (idx = 0, length = views.length; idx < length; idx++) {
		                var hasType = false;
	
		                view = views[idx];
	
		                isSettings = isPlainObject(view);
	
		                if (isSettings) {
		                    type = name = view.type ? view.type : view;
		                    if (typeof type !== STRING) {
		                        name = view.name || view.title;
		                        hasType = true;
		                    }
		                } else {
		                    type = name = view;
		                }
	
		                defaultView = defaultViews[name];
	
		                if (defaultView && !hasType) {
	
		                    view.type = defaultView.type;
		                    defaultView.title = this.options.messages.views[name];
		                    if (defaultView.type === "day") {
		                        defaultView.messages = { allDay: this.options.messages.allDay };
		                    } else if (defaultView.type === "agenda") {
		                        defaultView.messages = {
		                            event: this.options.messages.event,
		                            date: this.options.messages.date,
		                            time: this.options.messages.time
		                        };
		                    }
		                }
	
		                view = extend({ title: name }, defaultView, isSettings ? view : {});
	
		                if (name) {
		                    this.views[name] = view;
		                    this._viewsCount++;
	
		                    if (!selected || view.selected) {
		                        selected = name;
		                    }
		                }
		            }
	
		            if (selected) {
		                this._selectedViewName = selected; // toolbar is not rendered yet
		            }
		        },
	
		        rebind: function() {
		            this.dataSource.fetch();
		        },
	
		        _dataSource: function() {
		            var that = this,
		                options = that.options,
		                dataSource = options.dataSource;
	
		            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;
	
		            if (options.timezone && !(dataSource instanceof SchedulerDataSource)) {
		                dataSource = extend(true, dataSource, { schema: { timezone: options.timezone } });
		            } else if(dataSource instanceof SchedulerDataSource) {
		                options.timezone = dataSource.options.schema ? dataSource.options.schema.timezone : "";
		            }
	
		            if (that.dataSource && that._refreshHandler) {
		                that.dataSource
		                    .unbind(CHANGE, that._refreshHandler)
		                    .unbind("progress", that._progressHandler)
		                    .unbind("error", that._errorHandler);
		            } else {
		                that._refreshHandler = proxy(that.refresh, that);
		                that._progressHandler = proxy(that._requestStart, that);
		                that._errorHandler = proxy(that._error, that);
		            }
	
		            that.dataSource = kendo.data.SchedulerDataSource.create(dataSource)
		                .bind(CHANGE, that._refreshHandler)
		                .bind("progress", that._progressHandler)
		                .bind("error", that._errorHandler);
	
		            that.options.dataSource = that.dataSource;
		        },
	
		        _error: function() {
		            this._progress(false);
		        },
	
		        _requestStart: function() {
		            this._progress(true);
		        },
	
		        _progress: function(toggle) {
		            var element = this.element.find(".k-scheduler-content");
		            kendo.ui.progress(element, toggle);
		        },
	
		        _resources: function() {
		            var that = this;
		            var resources = that.options.resources;
	
		            for (var idx = 0; idx < resources.length; idx++) {
		                var resource = resources[idx];
		                var field = resource.field;
		                var dataSource = resource.dataSource;
	
		                if (!field || !dataSource) {
		                    throw new Error('The "field" and "dataSource" options of the scheduler resource are mandatory.');
		                }
	
		                that.resources.push({
		                    field: field,
		                    name: resource.name || field,
		                    title: resource.title || field,
		                    dataTextField: resource.dataTextField || "text",
		                    dataValueField: resource.dataValueField || "value",
		                    dataColorField: resource.dataColorField || "color",
		                    valuePrimitive: resource.valuePrimitive != null ? resource.valuePrimitive : true,
		                    multiple: resource.multiple || false,
		                    dataSource: kendo.data.DataSource.create(dataSource)
		                });
		            }
	
		            var promises = $.map(that.resources, function(resource) {
		                return resource.dataSource.fetch();
		            });
	
		            if (!that.options.autoBind) {
		                that._selectView(that._selectedViewName);
		            } else {
		                $.when.apply(null, promises)
		                      .then(function () {
		                            that.view(that._selectedViewName);
		                        });
		            }
		        },
	
		        _initModel: function() {
		            var that = this;
		            that._model = kendo.observable({
		               selectedDate: new Date(this.options.date),
		               formattedDate: "",
		               formattedShortDate: ""
		           });
	
		           that._model.bind("change", function(e) {
		                if (e.field === "selectedDate") {
		                    that.view(that._selectedViewName);
		                }
		           });
		        },
	
		        _wrapper: function() {
		            var that = this;
		            var options = that.options;
		            var height = options.height;
		            var width = options.width;
	
		            that.wrapper = that.element
		                               .addClass("k-widget k-scheduler k-floatwrap")
		                               .attr("role", "grid")
		                               .attr("aria-multiselectable", true);
	
		            if (that._isMobile()) {
		               that.wrapper.addClass("k-scheduler-mobile");
		            }
	
		            if (that._isMobilePhoneView()) {
		               that.wrapper.addClass("k-scheduler-phone");
		            }
	
		            if (height) {
		                that.wrapper.height(height);
		            }
	
		            if (width) {
		                that.wrapper.width(width);
		            }
		        },
	
		        date: function(value) {
		            if (value != null && getDate(value) >= getDate(this.options.min) && getDate(value) <= getDate(this.options.max)) {
		                this._model.set("selectedDate", value);
		            }
		            return getDate(this._model.get("selectedDate"));
		        },
	
		        _toolbar: function() {
		            var that = this;
		            var options = that.options;
		            var commands = [];
	
		            if (options.toolbar) {
		                commands = $.isArray(options.toolbar) ? options.toolbar : [options.toolbar];
		            }
	
		            var template = this._isMobilePhoneView() ? MOBILETOOLBARTEMPLATE : TOOLBARTEMPLATE;
	
		            var toolbar = $(template({
		                    messages: options.messages,
		                    pdf: $.grep(commands, function(item) {
		                            return item == "pdf" || item.name == "pdf";
		                        }).length > 0,
		                    ns: kendo.ns,
		                    view: that._selectedViewName,
		                    views: that.views,
		                    viewsCount: that._viewsCount
		                }));
	
		            that.wrapper.append(toolbar);
		            that.toolbar = toolbar;
	
		            kendo.bind(that.toolbar, that._model);
	
		            toolbar.on(CLICK + NS, ".k-pdf", function(e) {
		                e.preventDefault();
		                that.saveAsPDF();
		            });
	
		            toolbar.on(CLICK + NS, ".k-scheduler-navigation li", function(e) {
		                var li = $(this);
		                var date = new Date(that.date());
		                var action = "";
		                var currentDate = new Date();
		                var timezone = that.options.timezone;
	
		                e.preventDefault();
	
		                if (li.hasClass("k-nav-today")) {
		                    action = "today";
		                    if(timezone){
		                        var timezoneOffset = kendo.timezone.offset(currentDate, timezone);
		                        date = kendo.timezone.convert(currentDate, currentDate.getTimezoneOffset(), timezoneOffset);
		                    }else{
		                        date = currentDate;
		                    }
	
		                } else if (li.hasClass("k-nav-next")) {
		                    action = "next";
		                    date = that.view().nextDate();
		                } else if (li.hasClass("k-nav-prev")) {
		                    action = "previous";
		                    date = that.view().previousDate();
		                } else if (li.hasClass("k-nav-current") && !that._isMobilePhoneView()) {
		                    that._showCalendar();
		                    return; // TODO: Not good - refactor
		                }
	
		                if (!that.trigger("navigate", { view: that._selectedViewName, action: action, date: date })) {
		                    that.date(date);
		                }
		            });
	
		            toolbar.on(CLICK + NS, ".k-scheduler-views li:not(.k-current-view), .k-scheduler-refresh", function(e) {
		                e.preventDefault();
	
		                var name = $(this).attr(kendo.attr("name"));
	
		                if (!that.trigger("navigate", { view: name, action: "changeView", date: that.date() })) {
		                    that.view(name);
		                    that.element.find("." + EXPANDEDSTATE).removeClass(EXPANDEDSTATE);
		                }
		            });
	
		            toolbar.on(CLICK + NS, ".k-scheduler-views li.k-current-view", function(e) {
		                e.preventDefault();
	
		                that.element.find(".k-scheduler-views").toggleClass(EXPANDEDSTATE);
		                $(document).on(MOUSEDOWN + NS, function(e) {
		                    if($(e.target).closest(".k-scheduler-views").length === 0)
		                    {
		                        that.element.find("." + EXPANDEDSTATE).removeClass(EXPANDEDSTATE);
		                        $(document).off(CLICK + NS);
		                    }
		                });
		            });
	
		            toolbar.find("li").hover(function(){
		                    $(this).addClass("k-state-hover");
		                }, function(){
		                    $(this).removeClass("k-state-hover");
		                });
		        },
	
		        _showCalendar: function() {
		            var that = this,
		                target = that.toolbar.find(".k-nav-current"),
		                html = $('<div class="k-calendar-container"><div class="k-scheduler-calendar"/></div>');
	
		            if (!that.popup) {
		                that.popup = new Popup(html, {
		                    anchor: target,
		                    open: function() {
		                        if (!that.calendar) {
		                            that.calendar = new Calendar(this.element.find(".k-scheduler-calendar"),
		                            {
		                                change: function() {
		                                    var date = this.value();
		                                    if (!that.trigger("navigate", { view: that._selectedViewName, action: "changeDate", date: date })) {
		                                        that.date(date);
		                                        that.popup.close();
		                                    }
		                                    that._selectedView.element.focus();
		                                    that.toolbar.find(".k-nav-current").focus().addClass(FOCUSEDSTATE);
		                                },
		                                min: that.options.min,
		                                max: that.options.max
		                            });
		                        }
		                        that.calendar.element.on("keydown" + NS, function (e) {
		                            if (e.keyCode === keys.ESC || e.keyCode === keys.TAB) {
		                                that.popup.close();
		                                that._selectedView.element.focus();
		                                that.toolbar.find(".k-nav-current").focus().addClass(FOCUSEDSTATE);
		                            }
		                        });
		                        that.calendar.value(that.date());
		                    },
		                    copyAnchorStyles: false
		                });
		            }
	
		            that.popup.open();
		            that.calendar.element.find("table").focus();
		        },
	
		        refresh: function(e) {
		            var that = this;
		            var view = this.view();
	
		            this._progress(false);
	
		            this.angular("cleanup", function(){
		                return { elements: that.items() };
		            });
	
		            e = e || {};
	
		            if (!view) {
		                return;
		            }
	
		            if (e && e.action === "itemchange" && (this._editor.editable || this._preventRefresh)) { // skip rebinding if editing is in progress
		                return;
		            }
	
		            if (this.trigger("dataBinding", { action: e.action || "rebind", index: e.index, items: e.items })) {
		                return;
		            }
	
		            if (!(e && e.action === "resize") && this._editor) {
		                this._editor.close();
		            }
	
		            this._data = this.dataSource.expand(view.startDate(), view.visibleEndDate());
	
		            view.refreshLayout();
	
		            view.render(this._data);
	
		            this.trigger("dataBound");
		        },
	
		        slotByPosition: function(x, y) {
		            var view = this.view();
	
		            if(!view._slotByPosition) {
		                return null;
		            }
	
		            var slot = view._slotByPosition(x, y);
	
		            if(!slot) {
		                return null;
		            }
	
		            return {
		                startDate: slot.startDate(),
		                endDate: slot.endDate(),
		                groupIndex: slot.groupIndex,
		                element: slot.element,
		                isDaySlot: slot.isDaySlot
		            };
		        },
	
		        slotByElement: function(element) {
		            var offset = $(element).offset();
		            return this.slotByPosition(offset.left, offset.top);
		        },
	
		        resourcesBySlot: function(slot) {
		            return this.view()._resourceBySlot(slot);
		        }
		    });
	
		    var defaultViews = {
		        day: {
		            type: "kendo.ui.DayView"
		        },
		        week: {
		            type: "kendo.ui.WeekView"
		        },
		        workWeek: {
		            type: "kendo.ui.WorkWeekView"
		        },
		        agenda: {
		            type: "kendo.ui.AgendaView"
		        },
		        month: {
		            type: "kendo.ui.MonthView"
		        },
		        timeline: {
		            type: "kendo.ui.TimelineView"
		        },
		        timelineWeek: {
		            type: "kendo.ui.TimelineWeekView"
		        },
		        timelineWorkWeek: {
		            type: "kendo.ui.TimelineWorkWeekView"
		        },
		        timelineMonth: {
		            type: "kendo.ui.TimelineMonthView"
		        }
		    };
	
		    ui.plugin(Scheduler);
	
		    if (kendo.PDFMixin) {
		        kendo.PDFMixin.extend(Scheduler.prototype);
	
		        var SCHEDULER_EXPORT = "k-scheduler-pdf-export";
		        Scheduler.fn._drawPDF = function(progress) {
		            var wrapper = this.wrapper;
		            var styles = wrapper[0].style.cssText;
	
		            wrapper.css({
		                width: wrapper.width(),
		                height: wrapper.height()
		            });
	
		            wrapper.addClass(SCHEDULER_EXPORT);
	
		            var scheduler = this;
		            var promise = new $.Deferred();
		            var table = wrapper.find(".k-scheduler-content").find("table").css("table-layout", "auto");
	
		            setTimeout(function() {
		                table.css("table-layout", "fixed");
		                scheduler.resize(true);
	
		                scheduler._drawPDFShadow({}, {
		                    avoidLinks: scheduler.options.pdf.avoidLinks
		                })
		                .done(function(group) {
		                    var args = {
		                        page: group,
		                        pageNumber: 1,
		                        progress: 1,
		                        totalPages: 1
		                    };
	
		                    progress.notify(args);
		                    promise.resolve(args.page);
		                })
		                .fail(function(err) {
		                    promise.reject(err);
		                })
		                .always(function() {
		                    wrapper[0].style.cssText = styles;
		                    wrapper.removeClass(SCHEDULER_EXPORT);
		                    scheduler.resize(true);
	
		                    //Required because slot.offsetLeft is incorrect after first resize
		                    scheduler.resize(true);
		                });
		            });
	
		            return promise;
		        };
		    }
	
		    var TimezoneEditor = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                zones = kendo.timezone.windows_zones;
	
		            if (!zones || !kendo.timezone.zones_titles) {
		                throw new Error('kendo.timezones.min.js is not included.');
		            }
	
		            Widget.fn.init.call(that, element, options);
	
		            that.wrapper = that.element;
	
		            that._zonesQuery = new kendo.data.Query(zones);
		            that._zoneTitleId = kendo.guid();
		            that._zoneTitlePicker();
		            that._zonePicker();
	
		            that._zoneTitle.bind("cascade", function() {
		                if (!this.value()) {
		                    that._zone.wrapper.hide();
		                }
		            });
	
		            that._zone.bind("cascade", function() {
		                that._value = this.value();
		                that.trigger("change");
		            });
	
		            that.value(that.options.value);
		        },
		        options: {
		            name: "TimezoneEditor",
		            value: "",
		            optionLabel: "No timezone"
		        },
		        events: [ "change" ],
	
		        _zoneTitlePicker: function() {
		            var that = this,
		                zoneTitle = $('<input id="' + that._zoneTitleId + '" aria-label="' + that.options.title + '"/>').appendTo(that.wrapper);
	
		            that._zoneTitle = new kendo.ui.DropDownList(zoneTitle, {
		                dataSource: kendo.timezone.zones_titles,
		                dataValueField: "other_zone",
		                dataTextField: "name",
		                optionLabel: that.options.optionLabel
		            });
		        },
	
		        _zonePicker: function() {
		            var that = this,
		                zone = $('<input aria-label="' + that.options.title + '"/>').appendTo(this.wrapper);
	
		            that._zone = new kendo.ui.DropDownList(zone, {
		                dataValueField: "zone",
		                dataTextField: "territory",
		                dataSource: that._zonesQuery.data,
		                cascadeFrom: that._zoneTitleId,
		                dataBound: function() {
		                    that._value = this.value();
		                    this.wrapper.toggle(this.dataSource.view().length > 1);
		                }
		            });
	
		            that._zone.wrapper.hide();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            kendo.destroy(this.wrapper);
		        },
	
		        value: function(value) {
		            var that = this,
		                zone;
	
		            if (value === undefined) {
		                return that._value;
		            }
	
		            zone = that._zonesQuery.filter({ field: "zone", operator: "eq", value: value }).data[0];
	
		            if (zone) {
		                that._zoneTitle.value(zone.other_zone);
		                that._zone.value(zone.zone);
		            } else {
		                that._zoneTitle.select(0);
		            }
	
		        }
		    });
	
		    ui.plugin(TimezoneEditor);
	
		    var ZONETITLEOPTIONTEMPLATE = kendo.template('<option value="#=other_zone#">#=name#</option>');
		    var ZONEOPTIONTEMPLATE = kendo.template('<option value="#=zone#">#=territory#</option>');
	
		    var MobileTimezoneEditor = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                zones = kendo.timezone.windows_zones;
	
		            if (!zones || !kendo.timezone.zones_titles) {
		                throw new Error('kendo.timezones.min.js is not included.');
		            }
	
		            Widget.fn.init.call(that, element, options);
	
		            that.wrapper = that.element;
	
		            that._zonesQuery = new kendo.data.Query(zones);
		            that._zoneTitlePicker();
		            that._zonePicker();
	
		            that.value(that.options.value);
		        },
	
		        options: {
		            name: "MobileTimezoneEditor",
		            optionLabel: "No timezone",
		            value: ""
		        },
	
		        events: [ "change" ],
	
		        _bindZones: function(value) {
		            var data = value ? this._filter(value) : [];
	
		            this._zone.html(this._options(data, ZONEOPTIONTEMPLATE));
		        },
	
		        _filter: function(value) {
		            return this._zonesQuery.filter({ field: "other_zone", operator: "eq", value: value }).data;
		        },
	
		        _options: function(data, template, optionLabel) {
		            var idx = 0;
		            var html = "";
		            var length = data.length;
	
		            if (optionLabel) {
		                html += template({ other_zone: "", name: optionLabel });
		            }
	
		            for (; idx < length; idx++) {
		                html += template(data[idx]);
		            }
	
		            return html;
		        },
	
		        _zoneTitlePicker: function() {
		            var that = this;
		            var options = that._options(kendo.timezone.zones_titles, ZONETITLEOPTIONTEMPLATE, that.options.optionLabel);
	
		            that._zoneTitle = $('<select>' + options + '</select>')
		                                .appendTo(that.wrapper)
		                                .change(function() {
		                                    var value = this.value;
		                                    var zone = that._zone;
	
		                                    that._bindZones(value);
	
		                                    if (value && zone[0].children.length > 1) {
		                                        zone.show();
		                                    } else {
		                                        zone.hide();
		                                    }
	
		                                    that._value = zone[0].value;
	
		                                    that.trigger("change");
		                                });
		        },
	
		        _zonePicker: function() {
		            var that = this;
	
		            that._zone = $('<select style="display:none"></select>')
		                            .appendTo(this.wrapper)
		                            .change(function() {
		                                that._value = this.value;
	
		                                that.trigger("change");
		                            });
	
		            that._bindZones(that._zoneTitle.val());
		            that._value = that._zone[0].value;
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            kendo.destroy(this.wrapper);
		        },
	
		        value: function(value) {
		            var that = this;
		            var zonePicker = that._zone;
		            var other_zone = "";
		            var zone_value = "";
		            var zone;
	
		            if (value === undefined) {
		                return that._value;
		            }
	
		            zone = that._zonesQuery.filter({ field: "zone", operator: "eq", value: value }).data[0];
	
		            if (zone) {
		                zone_value = zone.zone;
		                other_zone = zone.other_zone;
		            }
	
		            that._zoneTitle.val(other_zone);
		            that._bindZones(other_zone);
	
		            zonePicker.val(zone_value);
		            zone_value = zonePicker[0].value;
	
		            if (zone_value && zonePicker[0].children.length > 1) {
		                zonePicker.show();
		            } else {
		                zonePicker.hide();
		            }
	
		            that._value = zone_value;
		        }
		    });
	
		    ui.plugin(MobileTimezoneEditor);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1276:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(636);
	
	/***/ }),
	
	/***/ 1277:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(638);
	
	/***/ }),
	
	/***/ 1278:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(637);
	
	/***/ }),
	
	/***/ 1279:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(639);
	
	/***/ }),
	
	/***/ 1280:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(640);
	
	/***/ }),
	
	/***/ 1281:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(695);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1286);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1278:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(637);
	
	/***/ }),
	
	/***/ 1286:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1278) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "scheduler.timelineview",
		    name: "Scheduler Timeline View",
		    category: "web",
		    description: "The Scheduler Timeline View",
		    depends: [ "scheduler.view" ],
		    hidden: true
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        setTime = kendo.date.setTime,
		        SchedulerView = ui.SchedulerView,
		        outerWidth = kendo._outerWidth,
		        outerHeight = kendo._outerHeight,
		        extend = $.extend,
		        proxy = $.proxy,
		        getDate = kendo.date.getDate,
		        getMilliseconds = kendo.date.getMilliseconds,
		        MS_PER_DAY = kendo.date.MS_PER_DAY,
		        MS_PER_MINUTE = kendo.date.MS_PER_MINUTE,
		        CURRENT_TIME_MARKER_CLASS = "k-current-time",
		        CURRENT_TIME_MARKER_ARROW_CLASS = "k-current-time-arrow",
		        SCHEDULER_HEADER_WRAP_CLASS = "k-scheduler-header-wrap",
		        BORDER_SIZE_COEFF = 0.8666,
		        NS = ".kendoTimelineView";
	
		    var EVENT_TEMPLATE = kendo.template('<div>' +
		        '<div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div>' +
		        '<div class="k-event-template">${title}</div></div>'),
		        DATA_HEADER_TEMPLATE = kendo.template("<span class='k-link k-nav-day'>#=kendo.format('{0:m}', date)#</span>"),
		        EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" ' +
		                'data-#=ns#uid="#=uid#"' +
		                '#if (resources[0]) { #' +
		                    'style="background-color:#=resources[0].color#; border-color: #=resources[0].color#"' +
		                    'class="k-event#=inverseColor ? " k-event-inverse" : ""#" ' +
		                '#} else {#' +
		                    'class="k-event"' +
		                '#}#' +
		                '>' +
		                '<span class="k-event-actions">' +
		                    '# if(data.tail) {#' +
		                        '<span class="k-icon k-i-arrow-60-left"></span>' +
		                    '#}#' +
		                    '# if(data.isException()) {#' +
		                        '<span class="k-icon k-i-non-recurrence"></span>' +
		                    '# } else if(data.isRecurring()) {#' +
		                        '<span class="k-icon k-i-reload"></span>' +
		                    '# } #' +
		                '</span>' +
		                '{0}' +
		                '<span class="k-event-actions">' +
		                    '#if (showDelete) {#' +
		                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
		                    '#}#' +
		                    '# if(data.head) {#' +
		                        '<span class="k-icon k-i-arrow-60-right"></span>' +
		                    '#}#' +
		                '</span>' +
		                '#if(resizable && !data.tail){#' +
		                '<span class="k-resize-handle k-resize-w"></span>' +
		                '#}#' +
		                '#if(resizable && !data.head){#' +
		                '<span class="k-resize-handle k-resize-e"></span>' +
		                '#}#' +
		                '</div>';
	
		    function toInvariantTime(date) {
		        var staticDate = new Date(1980, 1, 1, 0, 0, 0);
		        setTime(staticDate, getMilliseconds(date));
		        return staticDate;
		    }
	
		    function getWorkDays(options) {
		        var workDays = [];
		        var dayIndex = options.workWeekStart % 7;
		        var workWeekEnd = Math.abs(options.workWeekEnd % 7);
	
		        workDays.push(dayIndex);
	
		        while(workWeekEnd != dayIndex) {
		            if(dayIndex > 6 ) {
		                dayIndex -= 7;
		            } else {
		                dayIndex++;
		            }
		            workDays.push(dayIndex);
		        }
		        return workDays;
		    }
	
		    function setColspan(columnLevel) {
		        var count = 0;
		        if (columnLevel.columns) {
		            for (var i = 0; i < columnLevel.columns.length; i++) {
		                count += setColspan(columnLevel.columns[i]);
		            }
		            columnLevel.colspan = count;
		            return count;
		        } else {
		            columnLevel.colspan = 1;
		            return 1;
		        }
		    }
	
		    function collidingEvents(elements, left, right) {
		        var idx,
		            startPosition,
		            overlaps,
		            endPosition;
	
		        for (idx = elements.length-1; idx >= 0; idx--) {
		            startPosition = elements[idx].rectLeft;
		            endPosition = elements[idx].rectRight;
	
		            overlaps = startPosition <= left && endPosition >= left;
	
		            if (overlaps || (startPosition >= left && endPosition <= right) || (left <= startPosition && right >= startPosition)) {
		                if (startPosition < left) {
		                    left = startPosition;
		                }
	
		                if (endPosition > right) {
		                    right = endPosition;
		                }
		            }
		        }
	
		        return eventsForSlot(elements, left, right);
		    }
	
		    function eventsForSlot(elements, left, right) {
		        var events = [];
	
		        for (var idx = 0; idx < elements.length; idx++) {
		            var event = {
		                rectLeft: elements[idx].rectLeft,
		                rectRight: elements[idx].rectRight
		            };
	
		            if ((event.rectLeft < left && event.rectRight > left) || (event.rectLeft >= left && event.rectRight <= right)) {
		                events.push(elements[idx]);
		            }
		        }
	
		        return events;
		    }
	
		    var TimelineGroupedView = kendo.Class.extend({
		        init: function(view) {
		            this._view = view;
		        },
	
		        _getTimeSlotByPosition: function(x, y, groupIndex) {
		            var group = this._view.groups[groupIndex];
	
		            return group.timeSlotByPosition(x, y);
		        },
	
		        _hideHeaders: function() {
		            var view = this._view;
	
		            view.timesHeader.find("table tr:last").hide(); /*Chrome fix, use CSS selector*/
		            view.datesHeader.find("table tr:last").hide();
		        },
	
		        _setColspan: function(timeColumn) {
		            setColspan(timeColumn);
		        },
	
		        _createRowsLayout: function(resources, rows, groupHeaderTemplate) {
		            var view = this._view;
	
		            return view._createRowsLayout(resources, rows, groupHeaderTemplate);
		        },
	
		        _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate, columns) {
	
		            return columns;
		        },
	
		        _createColumnsLayout: function(resources, columns, groupHeaderTemplate) {
		            var view = this._view;
	
		            return view._createColumnsLayout(resources, columns, groupHeaderTemplate);
		        },
	
		        _getRowCount: function() {
		            var view = this._view;
	
		            return view._groupCount();
		        },
	
		        _getGroupsCount: function() {
		            return 1;
		        },
	
		        _addContent: function(dates, columnCount, groupsCount, rowCount, start, end, slotTemplate, isVerticalGrouped) {
		            var view = this._view;
		            var html = '';
		            var options = view.options;
	
		            var appendRow = function(date) {
		                var content = "";
		                var classes = "";
		                var tmplDate;
	
		                var resources = function(groupIndex) {
		                    return function() {
		                        return view._resourceBySlot({ groupIndex: groupIndex });
		                    };
		                };
	
		                if (kendo.date.isToday(dates[idx])) {
		                    classes += "k-today";
		                }
	
		                if (kendo.date.getMilliseconds(date) < kendo.date.getMilliseconds(options.workDayStart) ||
		                    kendo.date.getMilliseconds(date) >= kendo.date.getMilliseconds(options.workDayEnd) ||
		                    !view._isWorkDay(dates[idx])) {
		                    classes += " k-nonwork-hour";
		                }
	
		                content += '<td' + (classes !== "" ? ' class="' + classes + '"' : "") + ">";
		                tmplDate = kendo.date.getDate(dates[idx]);
		                kendo.date.setTime(tmplDate, kendo.date.getMilliseconds(date));
	
		                content += slotTemplate({ date: tmplDate, resources: resources(isVerticalGrouped ? rowIdx : groupIdx) });
		                content += "</td>";
	
		                return content;
		            };
	
		            for (var rowIdx = 0; rowIdx < rowCount; rowIdx++) {
		                html += '<tr>';
		                for (var groupIdx = 0 ; groupIdx < groupsCount; groupIdx++) {
		                    for (var idx = 0, length = columnCount; idx < length; idx++) {
		                        html += view._forTimeRange(start, end, appendRow);
		                    }
		                }
		                html += "</tr>";
		            }
		            return html;
		        },
	
		        _addTimeSlotsCollections: function(groupCount, datesCount, tableRows, interval, isVerticallyGrouped) {
		            var view = this._view;
		            var rowCount = tableRows.length;
	
		            if (isVerticallyGrouped) {
		                rowCount = Math.floor(rowCount / groupCount);
		            }
	
		            for (var groupIndex = 0; groupIndex < groupCount; groupIndex++) {
		                var rowMultiplier = 0;
		                var group = view.groups[groupIndex];
		                var time;
	
		                if (isVerticallyGrouped) {
		                    rowMultiplier = groupIndex;
		                }
	
		                var rowIndex = rowMultiplier * rowCount;
		                var cellMultiplier = 0;
	
		                if (!isVerticallyGrouped) {
		                    cellMultiplier = groupIndex;
		                }
	
		                var cells = tableRows[rowIndex].children;
		                var cellsPerGroup = cells.length / (!isVerticallyGrouped ? groupCount : 1);
		                var cellsPerDay = cellsPerGroup / datesCount;
	
		                for (var dateIndex = 0; dateIndex < datesCount; dateIndex++) {
		                    var cellOffset = dateIndex * cellsPerDay + (cellsPerGroup * cellMultiplier);
		                    time = getMilliseconds(new Date(+view.startTime()));
	
		                    for (var cellIndex = 0; cellIndex < cellsPerDay ; cellIndex++) {
	
		                        view._addTimeSlotToCollection(group, cells, cellIndex, cellOffset, dateIndex, time, interval);
		                        time += interval;
		                    }
		                }
		            }
		        },
	
		        _getVerticalGroupCount: function(groupsCount) {
	
		            return groupsCount;
		        },
	
		        _getVerticalRowCount: function(eventGroups, groupIndex, maxRowCount) {
		            var view = this._view;
	
		            return view._isVerticallyGrouped() ? eventGroups[groupIndex].maxRowCount : maxRowCount;
		        },
	
		        _renderEvent: function(eventGroup, event, adjustedEvent, group, range, container) {
		            var view = this._view;
		            var element;
	
		            element = view._createEventElement(adjustedEvent.occurrence, event, range.head || adjustedEvent.head, range.tail || adjustedEvent.tail);
		            element.appendTo(container).css({top: 0, height: view.options.eventHeight});
	
		            var eventObject = {
		                start: adjustedEvent.occurrence._startTime || adjustedEvent.occurrence.start,
		                end: adjustedEvent.occurrence._endTime || adjustedEvent.occurrence.end,
		                element: element,
		                uid: event.uid,
		                slotRange: range,
		                rowIndex: 0,
		                offsetTop: 0
		            };
	
		            eventGroup.events[event.uid] = eventObject;
	
		            view.addContinuousEvent(group, range, element, event.isAllDay);
		            view._arrangeRows(eventObject, range, eventGroup);
		        },
	
		        _verticalCountForLevel: function(level) {
		            var view = this._view;
	
		            return view._rowCountForLevel(level);
		        },
	
		        _horizontalCountForLevel: function(level) {
		            var view = this._view;
	
		            return view._columnCountForLevel(level);
		        },
	
		        _updateCurrentVerticalTimeMarker: function(ranges, currentTime) {
		            var view = this._view;
		            var elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";
		            var headerWrap = view.datesHeader.find("." + SCHEDULER_HEADER_WRAP_CLASS);
		            var left = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).left);
		            var timesTableMarker = $(elementHtml)
		                    .prependTo(headerWrap)
		                    .addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-down");
	
		            timesTableMarker.css({
		                left: view._adjustLeftPosition(left - (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2)),
		                top: headerWrap.find("tr:last").prev().position().top
		            });
	
		            $(elementHtml).prependTo(view.content).css({
		                left: view._adjustLeftPosition(left),
		                width: "1px",
		                height: view.content[0].scrollHeight - 1,
		                top: 0
		            });
		        },
	
		        _changeGroup: function() {
		            return undefined;
		        },
	
		        _prevGroupSlot: function(slot, group, isDay) {
		            var view = this._view;
	
		            if (view._isVerticallyGrouped()) {
		                return slot;
		            } else {
		                var collection = group._collection(0, isDay);
		                return collection.last();
		            }
		        },
	
		        _nextGroupSlot: function(slot, group, isDay) {
		            var view = this._view;
	
		            if (view._isVerticallyGrouped()) {
		                return slot;
		            } else {
		                var collection = group._collection(0, isDay);
		                return collection.first();
		            }
		        },
	
		        _verticalSlots: function(selection, reverse) {
		             var view = this._view;
	
		             return view._changeGroup(selection, reverse);
		        },
	
		         _verticalMethod: function(reverse) {
	
		              return  reverse ? "leftSlot" : "rightSlot";
		         },
	
		         _normalizeVerticalSelection: function() {
		             return undefined;
		         },
	
		         _horizontalSlots: function(selection, group, method, startSlot, endSlot, multiple, reverse) {
		            var view = this._view;
		            var result = {};
	
		            result.startSlot = group[method](startSlot);
		            result.endSlot = group[method](endSlot);
	
		            if (!multiple && view._isHorizontallyGrouped() && (!result.startSlot || !result.endSlot)) {
		                result.startSlot = result.endSlot = view._changeGroup(selection, reverse);
		            }
	
		            return result;
		        },
	
		        _changeVerticalViewPeriod: function() {
		            return false;
		        },
	
		        _changeHorizontalViewPeriod: function(slots, shift, selection, reverse) {
		            var view = this._view;
	
		            if ((!slots.startSlot ||!slots.endSlot ) && !shift && view._changeViewPeriod(selection, reverse, false)) {
		                return true;
		            }
		            return false;
		        },
	
		        _updateDirection: function(selection, ranges, shift, reverse) {
		            var view = this._view;
	
		            view._updateDirection(selection, ranges, shift, reverse, true);
		        },
	
		         _createMoveHint: function(range, adjustedEvent) {
		                var view = this._view;
		                var startSlot = range.start;
	
		                var hint = view._createEventElement(adjustedEvent.occurrence ,adjustedEvent.occurrence, false, false);
	
		                hint.addClass("k-event-drag-hint");
	
		                var rect = range.innerRect(adjustedEvent.occurrence.start, adjustedEvent.occurrence.end, view.options.snap);
		                var width = rect.right - rect.left - 2;
	
		                if (width < 0) {
		                   width = 0;
		                }
	
		                var left = view._adjustLeftPosition(rect.left);
	
		                var css = {
		                    left: left,
		                    top: startSlot.offsetTop,
		                    height: startSlot.offsetHeight - 2,
		                    width: width
		                };
	
		                hint.css(css);
	
		                view._appendMoveHint(hint);
		         },
	
		         _adjustLeftPosition: function(left) {
		            var view = this._view;
	
		            if (view._isRtl) {
		                left -= (view.content[0].scrollWidth - view.content[0].offsetWidth);
		            }
	
		            return left;
		         }
		    });
	
		    var TimelineGroupedByDateView = kendo.Class.extend({
		        init: function(view) {
		            this._view = view;
		        },
	
		        _getTimeSlotByPosition: function(x, y, groupIndex) {
		            var group = this._view.groups[groupIndex];
	
		            return group.timeSlotByPosition(x, y, true);
		        },
	
		        _hideHeaders: function() {
		            var view = this._view;
	
		            if (!view._isVerticallyGrouped()) {
		                view.timesHeader.find("table tr").eq(2).hide();
		                view.datesHeader.find("table tr").eq(2).hide();
		            } else {
		                        view.times.find(".k-last").hide();
		            }
		        },
		        _setColspan: function() {},
	
		        _createRowsLayout: function(resources, rows, groupHeaderTemplate, columns) {
		            var view = this._view;
	
		            return view._createDateLayout(columns, null, true);
		        },
	
		        _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate) {
		            var view = this._view;
	
		            return view._createColumnsLayout(resources, null, groupHeaderTemplate);
		        },
	
		        _createColumnsLayout: function(resources, columns, groupHeaderTemplate, subColumns) {
		            var view = this._view;
	
		            return view._createColumnsLayout(resources, columns, groupHeaderTemplate, subColumns, true);
		        },
	
		        _getRowCount: function(level) {
		            var view = this._view;
	
		            return view._rowCountForLevel(level);
		        },
	
		        _getGroupsCount: function() {
		            var view = this._view;
	
		            return view._groupCount();
		        },
	
		        _addContent: function(dates, columnCount, groupsCount, rowCount, start, end, slotTemplate, isVerticalGrouped) {
		            var view = this._view;
		            var html = '';
		            var options = view.options;
	
		            var appendRow = function(date, isMajorTickColumn, isMiddleColumn, isLastSlotColumn, minorTickColumns, groupIdx) {
		                var content = "";
		                var classes = "";
		                var tmplDate;
		                var workDateIndex = view._isVerticallyGrouped() ? dateIndex : idx;
	
		                var resources = function(groupIndex) {
		                    return function() {
		                        return view._resourceBySlot({ groupIndex: groupIndex });
		                    };
		                };
	
		                if (kendo.date.isToday(dates[idx])) {
		                    classes += "k-today";
		                }
	
		                if (kendo.date.getMilliseconds(date) < kendo.date.getMilliseconds(options.workDayStart) ||
		                    kendo.date.getMilliseconds(date) >= kendo.date.getMilliseconds(options.workDayEnd) ||
		                    !view._isWorkDay(dates[workDateIndex])) {
		                    classes += " k-nonwork-hour";
		                }
	
		                content += '<td' + (classes !== "" ? ' class="' + classes + '"' : "") + ">";
		                tmplDate = kendo.date.getDate(dates[idx]);
		                kendo.date.setTime(tmplDate, kendo.date.getMilliseconds(date));
	
		                content += slotTemplate({ date: tmplDate, resources: resources(groupIdx)});
		                content += "</td>";
	
		                return content;
		            };
	
		            var tempStart = new Date(start),
		                minorTickCount = view.options.minorTickCount,
		                msMajorInterval = view.options.majorTick * MS_PER_MINUTE,
		                msInterval = msMajorInterval / minorTickCount || 1,
		                dateIndex;
	
		            for (var rowIdx = 0; rowIdx < rowCount; rowIdx++) {
		                html += '<tr>';
	
		                 if((rowIdx % (rowCount / view._dates.length)) === 0){
		                   dateIndex = (rowIdx / (rowCount / view._dates.length));
		                   tempStart = new Date(view._dates[dateIndex]);
		                   kendo.date.setTime(tempStart, kendo.date.getMilliseconds(start));
		                  }
	
		                for (var idx = 0, length = columnCount; idx < length; idx++) {
	
		                    html += view._forTimeRange(tempStart, end, appendRow, isVerticalGrouped, groupsCount);
	
		                    if (isVerticalGrouped){
		                    setTime(tempStart, msInterval, false);
		                        break;
		                    }
		                }
		               html += "</tr>";
		            }
	
		            return html;
		        },
	
		        _addTimeSlotsCollections: function(groupCount, datesCount, tableRows, interval, isVerticallyGrouped) {
		            var view = this._view;
		            var rowCount = tableRows.length;
	
		             if (isVerticallyGrouped) {
		                rowCount = rowCount/datesCount;
		             }
	
		            for (var dateIndex = 0; dateIndex < datesCount; dateIndex++) {
		                var rowMultiplier = 0;
		                var time;
	
		                if (isVerticallyGrouped) {
		                    rowMultiplier = dateIndex;
		                }
	
		                var rowIndex = rowMultiplier * rowCount;
		                var cellMultiplier = 0;
		                var cells = tableRows[rowIndex].children;
		                var cellsPerGroup = isVerticallyGrouped ? rowCount : cells.length / (datesCount * groupCount);
		                var cellsPerDay = cells.length / datesCount;
		                var cellOffset;
	
		                time = getMilliseconds(new Date(+view.startTime()));
	
		                for (var cellIndex = 0; cellIndex < cellsPerGroup; cellIndex++) {
		                    if (!isVerticallyGrouped) {
		                        cellOffset = (dateIndex * cellsPerDay) + (groupCount * cellIndex);
		                        cellMultiplier++;
		                    } else{
		                        cellOffset = 0;
		                        cells = tableRows[cellIndex + (cellsPerGroup*dateIndex)].children;
		                    }
	
		                    for (var groupIndex = 0; groupIndex < groupCount ; groupIndex++) {
		                        var group = view.groups[groupIndex];
	
		                        view._addTimeSlotToCollection(group, cells, groupIndex, cellOffset, dateIndex, time, interval);
		                    }
		                    time += interval;
		                }
		             }
		        },
	
		        _getVerticalGroupCount: function() {
		            var view = this._view;
	
		            return view.content.find("tr").length;
		        },
	
		        _getVerticalRowCount: function(eventGroups, groupIndex, maxRowCount) {
	
		            return maxRowCount;
		        },
	
		        _renderEvent: function(eventGroup, event, adjustedEvent, group, range, container, startIndex, endIndex) {
		            var view = this._view;
		            var element;
		            var eventObjects = [];
	
		            for (var i = range.start.index; i <= range.end.index; i++) {
		                element = view._createEventElement(adjustedEvent.occurrence, event, i !== endIndex, i !== startIndex);
		                element.appendTo(container).css({top: 0, height: view.options.eventHeight});
		                var currentSlot = group._timeSlotCollections[0]._slots[i];
		                var dateRange = group.timeSlotRanges(currentSlot.start, currentSlot.end, false)[0];
	
		                    var eventObject = {
		                    start: i === startIndex ? adjustedEvent.occurrence._startTime || adjustedEvent.occurrence.start : currentSlot.start,
		                    end: i === endIndex ? adjustedEvent.occurrence._endTime || adjustedEvent.occurrence.end : currentSlot.end,
		                    element: element,
		                    uid: event.uid,
		                    slotRange: dateRange,
		                    rowIndex: 0,
		                    offsetTop: 0
		                };
	
		                eventGroup.events[event.uid] = eventObject;
		                eventObjects.push(eventObject);
	
		                view.addContinuousEvent(group, dateRange, element, event.isAllDay);
		                view._arrangeRows(eventObject, dateRange, eventGroup);
		            }
		            eventGroup.events[event.uid] = eventObjects;
		        },
	
		        _verticalCountForLevel: function(level) {
		            var view = this._view;
	
		            return view._columnCountForLevel(level);
		        },
	
		        _horizontalCountForLevel: function(level, columnLevel) {
		            var view = this._view;
	
		            return view._columnCountForLevel(columnLevel) / view._columnCountForLevel(2);
		        },
	
		        _updateCurrentVerticalTimeMarker: function(ranges,currentTime) {
		            var view = this._view;
		            var firstTimesCell = view.times.find("tr:first th:first");
		            var lastTimesCell = view.times.find("tr:first th:last");
		            var elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";
		            var timesTableMarker = $(elementHtml).prependTo(view.times);
		            var markerTopPosition = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).top);
		            var timesTableMarkerCss = {};
	
		            if (this._isRtl) {
		                timesTableMarkerCss.right = firstTimesCell.position().left + outerHeight(firstTimesCell) - outerHeight(lastTimesCell);
		                timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-left");
		            } else {
		                timesTableMarkerCss.left = lastTimesCell.position().left;
		                timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-right");
		            }
	
		            timesTableMarkerCss.top = markerTopPosition - (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2);
	
		            timesTableMarker.css(timesTableMarkerCss);
	
		            $(elementHtml).prependTo(view.content).css({
		                top: markerTopPosition,
		                height: "1px",
		                right: "1px",
		                width: view.content[0].scrollWidth,
		                left: 0
		            });
		        },
	
		        _changeGroup: function(selection, previous, slot) {
		             var view = this._view;
	
		             if (!slot) {
		                selection.groupIndex = previous ? view.groups.length - 1 : 0;
		             }
		        },
	
		         _prevGroupSlot: function(slot) {
		              return slot;
		        },
	
		        _nextGroupSlot: function(slot) {
		              return slot;
		        },
	
		        _changeDate: function(selection, reverse, slot) {
		            var view = this._view;
		            var group = view.groups[selection.groupIndex];
		            var collections, index;
	
		            if (reverse) {
		                  collections = group._getCollections(false);
		                  index = slot.index - 1;
	
		                  if (index >= 0) {
		                      return  collections[0]._slots[index];
		                  }
		              } else {
		                  collections = group._getCollections(false);
		                  index = slot.index + 1;
	
		                  if (collections[0] && collections[0]._slots[index]) {
		                      return  collections[0]._slots[index];
		                  }
		               }
		        },
	
		        _verticalSlots: function (selection, reverse, slot) {
		            return this._changeDate(selection, reverse, slot);
		        },
	
		        _verticalMethod: function(reverse, multiple) {
		            if (multiple) {
		               return reverse ? "upSlot" : "downSlot";
		            } else {
		               return  reverse ? "leftSlot" : "rightSlot";
		            }
		        },
	
		        _normalizeVerticalSelection: function(selection, ranges, reverse, multiple) {
		            var view = this._view;
	
		            if (!multiple) {
		                return view._normalizeVerticalSelection(selection, ranges, reverse);
		            }
	
		            return undefined;
		        },
	
		        _horizontalSlots: function(selection, group, method, startSlot, endSlot, multiple, reverse) {
		             var view = this._view;
		             var tempSlot = view._changeGroup(selection, reverse);
		             var result = {};
	
		            if (!tempSlot) {
		                if (!view._isVerticallyGrouped()) {
		                    result.startSlot = group[method](startSlot);
		                    result.endSlot = group[method](endSlot);
		                }
	
		            } else {
		                result.startSlot = result.endSlot = tempSlot;
		            }
	
		            return result;
		        },
	
		        _changeVerticalViewPeriod: function(slots, shift, selection, reverse) {
		            var view = this._view;
	
		            if ((!slots.startSlot || !slots.endSlot) && !shift &&
		                view._changeViewPeriod(selection, reverse, view._isVerticallyGrouped())) {
		                return true;
		            }
		            return false;
		        },
	
		        _changeHorizontalViewPeriod: function(slots, shift, selection, reverse) {
		           var view = this._view;
	
		           if ( view._isVerticallyGrouped()) {
		               return false;
		           }
	
		           if ((!slots.startSlot ||!slots.endSlot ) && !shift && view._changeViewPeriod(selection, reverse, false)) {
		                return true;
		            }
		            return false;
		        },
	
		        _updateDirection: function(selection, ranges, shift, reverse) {
		            var view = this._view;
	
		            view._updateDirection(selection, ranges, shift, reverse, !view._isVerticallyGrouped());
		        },
	
		         _createMoveHint: function(range, adjustedEvent) {
		                var view = this._view;
		                var startSlot = range.start;
		                var startEnd = range.end;
	
		                for (var slotIdx = startSlot.index; slotIdx <= startEnd.index; slotIdx++) {
		                    var slot = range.collection._slots[slotIdx];
		                    var hint = view._createEventElement(adjustedEvent.occurrence ,adjustedEvent.occurrence, false, false);
	
		                    hint.addClass("k-event-drag-hint");
	
		                    var css = {
		                        left: slot.offsetLeft + 2,
		                        top: slot.offsetTop,
		                        height: view.options.eventHeight,
		                        width: slot.offsetWidth
		                    };
	
		                    hint.css(css);
	
		                    view._appendMoveHint(hint);
		                }
		         },
	
		         _adjustLeftPosition: function(left) {
		             var view = this._view;
	
		            if (view._isRtl && !view._isVerticallyGrouped()) {
		                left -= (view.content[0].scrollWidth - view.content[0].offsetWidth);
		            }
	
		            return left;
		         }
		 });
	
		    kendo.ui.scheduler.TimelineGroupedView = TimelineGroupedView;
		    kendo.ui.scheduler.TimelineGroupedByDateView = TimelineGroupedByDateView;
	
		    var TimelineView = SchedulerView.extend({
		        init: function(element, options) {
		            var that = this;
	
		            SchedulerView.fn.init.call(that, element, options);
	
		            that._groupedView = that._getGroupedView();
	
		            that.title = that.options.title || that.options.name;
	
		            that._workDays = getWorkDays(that.options);
	
		            that._templates();
	
		            that._editable();
	
		            that.calculateDateRange();
	
		            that._groups();
	
		            that._currentTime(true);
		        },
		        name: "timeline",
	
		        _getGroupedView: function() {
	
		            if (this._isGroupedByDate()) {
		                   return new kendo.ui.scheduler.TimelineGroupedByDateView(this);
		            } else {
		                   return new kendo.ui.scheduler.TimelineGroupedView(this);
		            }
		        },
	
		        _getNextEventIndexBySlot: function(slot, sortedEvents, groupIndex){
		           if(this._isVerticallyGrouped()){
		               return kendo.ui.SchedulerView.fn._getNextEventIndexBySlot.call(this, slot, sortedEvents, groupIndex);
		           }
	
		            var tempIndex = 0;
	
		            for (var i = 0; i < sortedEvents.length; i++) {
		                if (slot.startDate()> sortedEvents[i].start.startDate()) {
		                    tempIndex++;
		                    continue;
		                }
	
		                if (slot.startDate().getTime() === sortedEvents[i].start.startDate().getTime() &&
		                 groupIndex > sortedEvents[i].start.groupIndex) {
		                      tempIndex++;
		                      continue;
		                }
	
		                 break;
	
		            }
		            return tempIndex;
		        },
	
		        _getSelectedSlot: function (slot, sortedEvents, event, idx, pad, prev) {
		            if(this._isVerticallyGrouped()){
		               return kendo.ui.SchedulerView.fn._getSelectedSlot.call(this, slot, sortedEvents, event, idx, pad, prev);
		            }
	
		            return slot;
		        },
	
		        _getSortedEvents: function (uniqueAllEvents) {
		            if(this._isVerticallyGrouped()){
		               return kendo.ui.SchedulerView.fn._getSortedEvents.call(this, uniqueAllEvents);
		            }
	
		            return uniqueAllEvents.sort(function(first, second) {
		                var result = first.start.startDate().getTime() - second.start.startDate().getTime();
	
		                if (result === 0) {
		                    if (first.start.isDaySlot && !second.start.isDaySlot) {
		                            result = -1;
		                    }
	
		                    if (!first.start.isDaySlot && second.start.isDaySlot) {
		                            result = 1;
		                    }
		                }
	
		                if (result === 0) {
		                    result = first.start.groupIndex - second.start.groupIndex;
		                }
	
		                if (result === 0) {
		                    result = $(first.element).index() - $(second.element).index();
		                }
	
		                return result;
		            });
		        },
	
		        _currentTimeMarkerUpdater: function() {
		            this._updateCurrentTimeMarker(new Date());
		        },
	
		        _updateCurrentTimeMarker: function(currentTime) {
		            var options = this.options;
	
		            this.datesHeader.find("." + CURRENT_TIME_MARKER_CLASS).remove();
		            this.times.find("." + CURRENT_TIME_MARKER_CLASS).remove();
		            this.content.find("." + CURRENT_TIME_MARKER_CLASS).remove();
	
		            if (!this._isInDateSlot({start: currentTime, end:currentTime })) {
		                return;
		            }
	
		            if(options.currentTimeMarker.useLocalTimezone === false) {
		                var timezone = options.dataSource.options.schema.timezone;
	
		                if(options.dataSource && timezone) {
		                    var timezoneOffset = kendo.timezone.offset(currentTime, timezone);
		                    currentTime = kendo.timezone.convert(currentTime, currentTime.getTimezoneOffset(), timezoneOffset);
		                }
		            }
	
		            var groupsCount = !options.group || options.group.orientation == "vertical" ? 1 : this.groups.length;
	
		            for(var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
		                var currentGroup = this.groups[groupIndex];
	
		                if (!currentGroup) {
		                    return;
		                }
	
		                var utcCurrentTime = kendo.date.toUtcTime(currentTime);
		                var ranges = currentGroup.timeSlotRanges(utcCurrentTime, utcCurrentTime + 1);
	
		                if(ranges.length === 0) {
		                    return;
		                }
	
		                var collection = ranges[0].collection;
		                var slotElement = collection.slotByStartDate(currentTime);
	
		                if(slotElement) {
	
		                    if(this._isVerticallyGrouped()){
		                        this._groupedView._updateCurrentVerticalTimeMarker(ranges,currentTime);
		                    } else{
		                        var elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";
		                        var headerWrap = this.datesHeader.find("." + SCHEDULER_HEADER_WRAP_CLASS);
		                        var left = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).left);
		                        var timesTableMarker = $(elementHtml)
		                                .prependTo(headerWrap)
		                                .addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-down");
	
		                        timesTableMarker.css({
		                            left: this._adjustLeftPosition(left - (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2)),
		                            top: headerWrap.find("tr:last").prev().position().top
		                        });
	
		                        $(elementHtml).prependTo(this.content).css({
		                            left: this._adjustLeftPosition(left),
		                            width: "1px",
		                            height: this.content[0].scrollHeight - 1,
		                            top: 0
		                        });
		                    }
		                }
		            }
		        },
	
		        _adjustLeftPosition: function(left) {
		            return this._groupedView._adjustLeftPosition(left);
		        },
	
		        _currentTime: function(setUpdateTimer) {
		            var that = this;
		            var markerOptions = that.options.currentTimeMarker;
	
		            if (markerOptions !== false && markerOptions.updateInterval !== undefined) {
		                that._currentTimeMarkerUpdater();
	
		                if (setUpdateTimer) {
		                    that._currentTimeUpdateTimer = setInterval(proxy(this._currentTimeMarkerUpdater, that), markerOptions.updateInterval);
		                }
		            }
		        },
	
		        _editable: function() {
		            if (this.options.editable) {
		                if (this._isMobile()) {
		                    this._touchEditable();
		                } else {
		                    this._mouseEditable();
		                }
		            }
		        },
	
		        _mouseEditable: function() {
		            var that = this;
		            that.element.on("click" + NS, ".k-event a:has(.k-i-close)", function(e) {
		                that.trigger("remove", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
		                e.preventDefault();
		            });
	
		            if (that.options.editable.create !== false) {
		                that.element.on("dblclick" + NS, ".k-scheduler-content td", function(e) {
		                    var slot = that._slotByPosition(e.pageX, e.pageY);
	
		                    if (slot) {
		                        var resourceInfo = that._resourceBySlot(slot);
		                        that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
		                    }
	
		                    e.preventDefault();
		                });
		            }
	
		            if (that.options.editable.update !== false) {
		                that.element.on("dblclick" + NS, ".k-event", function(e) {
		                    that.trigger("edit", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
		                    e.preventDefault();
		                });
		            }
		        },
	
		        _touchEditable: function() {
		            var that = this;
		            var threshold = 0;
	
		            if (kendo.support.mobileOS.android) {
		                threshold = 5;
		            }
	
		            if (that.options.editable.create !== false) {
		                that._addUserEvents = new kendo.UserEvents(that.element, {
		                    threshold: threshold,
		                    useClickAsTap: !kendo.support.browser.edge,
		                    filter:  ".k-scheduler-content td",
		                    tap: function(e) {
		                        if (that._scrolling) {
		                            return;
		                        }
		                        var x = e.x.location !== undefined ? e.x.location : e.x;
		                        var y = e.y.location !== undefined ? e.y.location : e.y;
		                        var slot = that._slotByPosition(x, y);
	
		                        if (slot) {
		                            var resourceInfo = that._resourceBySlot(slot);
		                            that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
		                        }
	
		                        e.preventDefault();
		                    }
		                });
		            }
	
		            if (that.options.editable.update !== false) {
		                that._editUserEvents = new kendo.UserEvents(that.element, {
		                    threshold: threshold,
		                    useClickAsTap: !kendo.support.browser.edge,
		                    filter: ".k-event",
		                    tap: function(e) {
		                        if (that._scrolling) {
		                            return;
		                        }
		                        var eventElement = $(e.target).closest(".k-event");
	
		                        if (!eventElement.hasClass("k-event-active")) {
		                            that.trigger("edit", { uid: eventElement.attr(kendo.attr("uid")) });
		                        }
	
		                        e.preventDefault();
		                    }
		                });
		            }
		        },
	
		        _slotByPosition: function(x, y) {
		            var slot;
		            var content = this.content;
		            var offset = content.offset();
		            var groupIndex;
	
		            x -= offset.left;
		            y -= offset.top;
	
		            if (this._isRtl) {
		                var browser = kendo.support.browser;
	
		                if (browser.mozilla) {
		                     x += (content[0].scrollWidth - content[0].offsetWidth);
		                     x += content[0].scrollLeft;
		                } else if (browser.msie) {
		                     x -= content.scrollLeft();
		                     x += content[0].scrollWidth - content[0].offsetWidth;
		                } else if (browser.webkit) {
		                     x += content[0].scrollLeft;
		                }
		            } else {
		                x += content[0].scrollLeft;
		            }
	
		            y += content[0].scrollTop;
	
		            x = Math.ceil(x);
		            y = Math.ceil(y);
	
		            for (groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
	
		                 slot = this._groupedView._getTimeSlotByPosition(x, y, groupIndex);
	
		                 if (slot) {
		                     return slot;
		                 }
		            }
	
		            return null;
		        },
	
		        options: {
		            name: "TimelineView",
		            title: "Timeline",
		            selectedDateFormat: "{0:D}",
		            selectedShortDateFormat: "{0:d}",
		            date: kendo.date.today(),
		            startTime: kendo.date.today(),
		            endTime: kendo.date.today(),
		            showWorkHours: false,
		            minorTickCount: 2,
		            editable: true,
		            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
		            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
		            workWeekStart: 1,
		            workWeekEnd: 5,
		            majorTick: 60,
		            eventHeight: 25,
		            eventMinWidth: 0,
		            columnWidth: 100,
		            groupHeaderTemplate: "#=text#",
		            majorTimeHeaderTemplate: "#=kendo.toString(date, 't')#",
		            slotTemplate: "&nbsp;",
		            eventTemplate: EVENT_TEMPLATE,
		            dateHeaderTemplate: DATA_HEADER_TEMPLATE,
		            footer: {
		                command: "workDay"
		            },
		            currentTimeMarker: {
		                updateInterval: 10000,
		                useLocalTimezone: true
		            },
		            messages: {
		                defaultRowText: "All events",
		                showFullDay: "Show full day",
		                showWorkDay: "Show business hours"
		            }
		        },
	
		        events: ["remove", "add", "edit"],
	
		        _templates: function() {
		            var options = this.options,
		                settings = extend({}, kendo.Template, options.templateSettings);
	
		            this.eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_STRING);
		            this.majorTimeHeaderTemplate = kendo.template(options.majorTimeHeaderTemplate, settings);
		            this.dateHeaderTemplate = kendo.template(options.dateHeaderTemplate, settings);
		            this.slotTemplate = kendo.template(options.slotTemplate, settings);
		            this.groupHeaderTemplate = kendo.template(options.groupHeaderTemplate, settings);
		        },
	
		        _render: function(dates) {
		            var that = this;
	
		            dates = dates || [];
	
		            that._dates = dates;
	
		            that._startDate = dates[0];
	
		            that._endDate = dates[(dates.length - 1) || 0];
	
		            that._calculateSlotRanges();
	
		            that.createLayout(that._layout(dates));
	
		            that._content(dates);
	
		            that._footer();
	
		            that._setContentWidth();
	
		            that.refreshLayout();
	
		            that.datesHeader.on("click" + NS, ".k-nav-day", function(e) {
		                var th = $(e.currentTarget).closest("th");
	
		                var slot = that._slotByPosition(th.offset().left, that.content.offset().top);
	
		                that.trigger("navigate", { view: "timeline", date: slot.startDate() });
		            });
	
		            that._groupedView._hideHeaders();
		        },
	
		        _setContentWidth: function() {
		            var content = this.content;
		            var contentWidth = content.width();
		            var contentTable = this.content.find("table");
		            var columnCount = contentTable.find("tr:first").children().length;
	
		            var minWidth = 100;
		            var calculatedWidth = columnCount * this.options.columnWidth;
	
		            if (contentWidth < calculatedWidth) {
		                minWidth = Math.ceil((calculatedWidth / contentWidth) * 100);
		            }
	
		            contentTable.add(this.datesHeader.find("table"))
		                .css("width", minWidth + "%");
		        },
	
		        _calculateSlotRanges: function () {
		            var dates = this._dates;
		            var slotStartTime = this.startTime();
		            var slotEndTime = this.endTime();
	
		            slotEndTime = getMilliseconds(slotEndTime);
		            slotStartTime = getMilliseconds(slotStartTime);
	
		            if (slotEndTime === slotStartTime) {
		                slotEndTime += MS_PER_DAY - 1;
		            } else if (slotEndTime < slotStartTime) {
		                slotEndTime += MS_PER_DAY;
		            }
	
		            var slotRanges = [];
		            for (var i = 0; i < dates.length; i++) {
		                var rangeStart = getDate(dates[i]);
		                setTime(rangeStart, slotStartTime);
	
		                var rangeEnd = getDate(dates[i]);
		                setTime(rangeEnd, slotEndTime);
	
		                slotRanges.push({
		                    start: kendo.date.toUtcTime(rangeStart),
		                    end: kendo.date.toUtcTime(rangeEnd)
		                });
		            }
	
		            this._slotRanges = slotRanges;
		        },
	
		        _forTimeRange: function(min, max, action, verticalByDate, groupsCount) {
		            min = toInvariantTime(min); //convert the date to 1/2/1980 and sets the time
		            max = toInvariantTime(max);
	
		            var that = this,
		                msMin = getMilliseconds(min),
		                msMax = getMilliseconds(max),
		                minorTickCount = that.options.minorTickCount,
		                msMajorInterval = that.options.majorTick * MS_PER_MINUTE,
		                msInterval = msMajorInterval / minorTickCount || 1,
		                start = new Date(+min),
		                idx = 0, length,
		                html = "";
	
		            length = MS_PER_DAY / msInterval;
	
		            if (msMin != msMax) {
		                if (msMin > msMax) {
		                    msMax += MS_PER_DAY;
		                }
	
		                length = ((msMax - msMin) / msInterval);
		            }
	
		            length = verticalByDate ? 1 : Math.round(length);
	
		            if (groupsCount) {
		                length = length * groupsCount;
		            }
	
		            for (; idx < length; idx++) {
		                var majorTickDivider = idx % (msMajorInterval/msInterval);
		                var isMajorTickColumn = majorTickDivider === 0;
		                var isMiddleColumn = majorTickDivider < minorTickCount - 1;
		                var isLastSlotColumn = majorTickDivider === minorTickCount - 1;
		                var minorTickColumns = minorTickCount;
	
		                if (length % minorTickCount !== 0) {
		                    var isLastMajorSlot = (length - (idx + 1)) < minorTickCount;
		                    if (isMajorTickColumn && isLastMajorSlot) {
		                        minorTickColumns = length % minorTickCount;
		                    }
		                }
	
		                html += action(start, isMajorTickColumn, isMiddleColumn, isLastSlotColumn, minorTickColumns, idx % groupsCount);
	
		                if (!verticalByDate) {
		                    if (groupsCount) {
		                        if ((idx % groupsCount) === groupsCount - 1) {
		                            setTime(start, msInterval, false);
		                        }
		                    } else {
		                        setTime(start, msInterval, false);
		                    }
		                }
		            }
	
		            return html;
		        },
	
		        _layout: function(dates) {
		            var timeColumns = [];
		            var columns = [];
		            var that = this;
		            var rows = [{ text: that.options.messages.defaultRowText }];
		            var groupedView = that._groupedView;
	
		            var minorTickSlots = [];
		            for (var minorTickIndex = 0; minorTickIndex < that.options.minorTickCount; minorTickIndex++) {
		                minorTickSlots.push({
		                    text: "&#8203;",
		                    className: "k-last",
		                    minorTicks: true
		                });
		            }
	
		            this._forTimeRange(that.startTime(), that.endTime(), function(date, majorTick, middleColumn, lastSlotColumn, minorSlotsCount) {
		                var template = that.majorTimeHeaderTemplate;
	
		                if (majorTick) {
		                    var timeColumn = {
		                        text: template({ date: date }),
		                        className: lastSlotColumn ? "k-slot-cell" : "",
		                        columns: minorTickSlots.slice(0, minorSlotsCount)
		                    };
	
		                    groupedView._setColspan(timeColumn);
	
		                    timeColumns.push(timeColumn);
		                }
		            });
	
		            for (var idx = 0; idx < dates.length; idx++) {
		                columns.push({
		                    text: that.dateHeaderTemplate({ date: dates[idx] }),
		                    className:  "k-slot-cell",
		                    columns: timeColumns.slice(0)
		                });
		            }
	
		            var resources = this.groupedResources;
		            if (resources.length) {
		                if (this._groupOrientation() === "vertical") {
		                    rows =  groupedView._createRowsLayout(resources, null, this.groupHeaderTemplate, columns);
		                    columns =  groupedView._createVerticalColumnsLayout(resources, null, this.groupHeaderTemplate, columns);
	
		                } else {
		                    columns =  groupedView._createColumnsLayout(resources, columns, this.groupHeaderTemplate, columns);
		                }
		            }
	
		            return {
		                columns: columns,
		                rows: rows
		            };
		        },
	
		        _footer: function() {
		            var options = this.options;
	
		            if (options.footer !== false) {
		                var html = '<div class="k-header k-scheduler-footer">';
	
		                var command = options.footer.command;
	
		                if (command && command === "workDay") {
		                    html += '<ul class="k-reset k-header">';
	
		                    html += '<li class="k-state-default k-scheduler-fullday"><a href="#" class="k-link"><span class="k-icon k-i-clock"></span>';
		                    html += (options.showWorkHours ? options.messages.showFullDay : options.messages.showWorkDay) + '</a></li>';
	
		                    html += '</ul>';
	
		                } else {
		                    html += "&nbsp;";
		                }
	
		                html += "</div>";
	
		                this.footer = $(html).appendTo(this.element);
	
		                var that = this;
	
		                this.footer.on("click" + NS, ".k-scheduler-fullday", function(e) {
		                    e.preventDefault();
		                    that.trigger("navigate", { view: that.name || options.name, date: that.startDate(), isWorkDay: !options.showWorkHours });
		                });
		            }
		        },
	
		        _columnCountForLevel: function(level) {
		            var columnLevel = this.columnLevels[level];
		            return columnLevel ? columnLevel.length : 0;
		        },
	
		        _rowCountForLevel: function(level) {
		            var rowLevel = this.rowLevels[level];
		            return rowLevel ? rowLevel.length : 0;
		        },
	
		        _isWorkDay: function(date) {
		            var day = date.getDay();
		            var workDays =  this._workDays;
	
		            for (var i = 0; i < workDays.length; i++) {
		                if (workDays[i] === day) {
		                    return true;
		                }
		            }
		            return false;
		        },
	
		        _content: function(dates) {
		            var that = this;
		            var start = that.startTime();
		            var end = this.endTime();
		            var groupsCount = 1;
		            var rowCount = 1;
		            var columnCount = dates.length;
		            var html = '';
		            var resources = this.groupedResources;
		            var slotTemplate = this.slotTemplate;
		            var isVerticalGrouped = false;
	
		            if (resources.length) {
		                isVerticalGrouped = that._groupOrientation() === "vertical";
	
		                if (isVerticalGrouped) {
		                    rowCount = that._groupedView._getRowCount(this.rowLevels.length - 1);
		                    groupsCount = that._groupedView._getGroupsCount();
		                } else {
		                    groupsCount = that._groupCount();
		                }
		            }
	
		            html += '<tbody>';
		            html += that._groupedView._addContent(dates, columnCount, groupsCount, rowCount, start, end, slotTemplate, isVerticalGrouped);
		            html += '</tbody>';
	
		            this.content.find("table").append(html);
		        },
	
		        _groups: function() {
		            var groupCount = this._groupCount();
		            var dates = this._dates;
		            var columnCount = dates.length;
	
		            this.groups = [];
	
		            for (var idx = 0; idx < groupCount; idx++) {
		                var view = this._addResourceView(idx);
	
		                var start = dates[0];
		                var end = dates[(dates.length - 1) || 0];
	
		                var startTime = getMilliseconds(this.startTime());
		                var endTime = getMilliseconds(this.endTime());
	
		                if (startTime !== 0 && endTime <= startTime) {
		                    start = getDate(start);
		                    setTime(start, startTime);
	
		                    end = getDate(end);
		                    setTime(end, endTime);
		                }
	
		                view.addTimeSlotCollection(start, kendo.date.addDays(end, 1));
		            }
	
		            this._timeSlotGroups(groupCount, columnCount);
		        },
	
		        _isHorizontallyGrouped: function() {
		            return this.groupedResources.length && this._groupOrientation() === "horizontal";
		        },
	
		        _timeSlotGroups: function (groupCount, datesCount) {
		            var interval = this._timeSlotInterval();
		            var isVerticallyGrouped = this._isVerticallyGrouped();
		            var tableRows = this.content.find("tr");
	
		            tableRows.attr("role", "row");
	
		            this._groupedView._addTimeSlotsCollections(groupCount, datesCount, tableRows, interval, isVerticallyGrouped);
	
		        },
	
		        _addTimeSlotToCollection: function(group, cells, cellIndex, cellOffset, dateIndex, time, interval){
		              var cell = cells[cellIndex+cellOffset];
		              var collection = group.getTimeSlotCollection(0);
		              var currentDate = this._dates[dateIndex];
		              var currentTime = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
		              var start = currentTime + time;
		              var end = start + interval;
		              cell.setAttribute("role", "gridcell");
		              cell.setAttribute("aria-selected", false);
	
		              collection.addTimeSlot(cell, start, end, true);
		        },
	
		        startDate: function() {
		            return this._startDate;
		        },
	
		        endDate: function() {
		            return this._endDate;
		        },
	
		        visibleEndDate: function () {
		            var startTime = getMilliseconds(this.startTime());
		            var endTime = getMilliseconds(this.endTime());
		            var endDate = this.endDate();
	
		            if (startTime !== 0 && endTime <= startTime) {
		                endDate = kendo.date.addDays(endDate, 1);
		            }
	
		            return endDate;
		        },
	
		        startTime: function() {
		            var options = this.options;
		            return options.showWorkHours ? options.workDayStart : options.startTime;
		        },
	
		        endTime: function() {
		            var options = this.options;
		            return options.showWorkHours ? options.workDayEnd : options.endTime;
		        },
	
		        _timeSlotInterval: function() {
		            var options = this.options;
		            return (options.majorTick/options.minorTickCount) * MS_PER_MINUTE;
		        },
	
		        nextDate: function () {
		            return kendo.date.nextDay(this.endDate());
		        },
	
		        previousDate: function () {
		            return kendo.date.previousDay(this.startDate());
		        },
	
		        calculateDateRange: function() {
		            this._render([this.options.date]);
		        },
	
		        render: function(events) {
		            this._headerColumnCount = 0;
	
		            this._groups();
	
		            this.element.find(".k-event").remove();
	
		            events = new kendo.data.Query(events)
		                .sort([{ field: "start", dir: "asc" },{ field: "end", dir: "desc" }])
		                .toArray();
	
		            var eventsByResource = [];
	
		            this._eventsByResource(events, this.groupedResources, eventsByResource);
	
		            var eventGroups = [];
		            var maxRowCount = 0;
	
		            for (var groupIndex = 0; groupIndex < eventsByResource.length; groupIndex++) {
		                var eventGroup = {
		                    groupIndex: groupIndex,
		                    maxRowCount: 0,
		                    events: {}
		                };
	
		                eventGroups.push(eventGroup);
	
		                this._renderEvents(eventsByResource[groupIndex], groupIndex, eventGroup);
	
		                if (maxRowCount < eventGroup.maxRowCount) {
		                    maxRowCount = eventGroup.maxRowCount;
		                }
		            }
	
		            this._setRowsHeight(eventGroups, eventsByResource.length, maxRowCount);
	
		            this._positionEvents(eventGroups, eventsByResource.length);
	
		            this._currentTime(false);
	
		            this.trigger("activate");
		        },
	
		        _positionEvents: function(eventGroups, groupsCount) {
		            for (var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
		                var eventsForGroup = eventGroups[groupIndex].events;
		                for (var eventUid in eventsForGroup) {
		                    var eventObject = eventsForGroup[eventUid];
		                    if($.isArray(eventObject)){
		                        for(var eventIndex = 0; eventIndex<eventObject.length; eventIndex++){
		                            this._positionEvent(eventObject[eventIndex]);
		                        }
		                    } else{
		                        this._positionEvent(eventObject);
		                    }
		                }
		            }
		        },
	
		        _setRowsHeight: function(eventGroups, groupsCount, maxRowCount) {
		            var eventHeight = this.options.eventHeight + 2;/* two times border width */
		            var eventBottomOffset = this._getBottomRowOffset();
		            var groupedView = this._groupedView;
		            var verticalGroupCount = groupedView._getVerticalGroupCount(groupsCount);
	
		            groupsCount = this._isVerticallyGrouped() ? verticalGroupCount : 1;
	
		            for (var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
		                var rowsCount = groupedView._getVerticalRowCount(eventGroups, groupIndex, maxRowCount);
	
		                rowsCount = rowsCount ? rowsCount : 1;
	
		                var rowHeight = ((eventHeight + 2) * rowsCount) + eventBottomOffset;
		                var timesRow = $(this.times.find("tr")[groupIndex]);
		                var row = $(this.content.find("tr")[groupIndex]);
	
		                timesRow.height(rowHeight);
		                row.height(rowHeight);
		            }
	
		            this._setContentWidth();
		            this.refreshLayout();
		            this._refreshSlots();
		        },
	
		        _getBottomRowOffset: function() {
		            var eventBottomOffset = this.options.eventHeight * 0.50;
		            var isMobile = this._isMobile();
		            var minOffset;
		            var maxOffset;
	
		            if (isMobile) {
		                minOffset = 30;
		                maxOffset = 60;
		            } else {
		                minOffset = 15;
		                maxOffset = 30;
		            }
	
		            if (eventBottomOffset > maxOffset) {
		                eventBottomOffset = maxOffset;
		            } else if (eventBottomOffset < minOffset) {
		                eventBottomOffset = minOffset;
		            }
	
		            return eventBottomOffset;
		        },
	
		        _positionEvent: function(eventObject) {
		            var eventHeight = this.options.eventHeight + 2;
	
		            var rect = eventObject.slotRange.innerRect(eventObject.start, eventObject.end, false);
	
		            var left = this._adjustLeftPosition(rect.left);
	
		            var width = rect.right - rect.left - 2;
	
		            if (width < 0) {
		                width = 0;
		            }
	
		            if (width < this.options.eventMinWidth) {
		                var slotsCollection = eventObject.slotRange.collection;
		                var lastSlot = slotsCollection._slots[slotsCollection._slots.length-1];
		                var offsetRight = lastSlot.offsetLeft + lastSlot.offsetWidth;
	
		                width = this.options.eventMinWidth;
	
		                if (offsetRight < left + width) {
		                    width = offsetRight - rect.left - 2;
		                }
		            }
	
		            eventObject.element.css({
		                top:  eventObject.slotRange.start.offsetTop + eventObject.rowIndex * (eventHeight + 2) + "px",
		                left: left,
		                width: width
		            });
		        },
	
		        _refreshSlots: function() {
		            for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
		                this.groups[groupIndex].refresh();
		            }
		        },
	
		        _eventsByResource: function(events, resources, result) {
		            var resource = resources[0];
	
		            if (resource) {
		                var view = resource.dataSource.view();
	
		                for (var itemIdx = 0; itemIdx < view.length; itemIdx++) {
		                    var value = this._resourceValue(resource, view[itemIdx]);
	
		                    var eventsFilteredByResource = new kendo.data.Query(events).filter({ field: resource.field, operator: SchedulerView.groupEqFilter(value) }).toArray();
	
		                    if (resources.length > 1) {
		                        this._eventsByResource(eventsFilteredByResource, resources.slice(1), result);
		                    } else {
		                        result.push(eventsFilteredByResource);
		                    }
		                }
		            } else {
		                result.push(events);
		            }
		        },
	
		        _isInDateSlot: function(event) {
		            var startTime = event.start;
		            var endTime = event.end;
		            var rangeStart = getDate(this._startDate);
		            var rangeEnd = kendo.date.addDays(getDate(this.visibleEndDate()), 1);
	
		            if (startTime < rangeEnd && rangeStart <= endTime) {
		                return true;
		            }
		            return false;
		        },
	
		        _isInTimeSlot: function(event) {
		            var startTime = event._startTime || kendo.date.toUtcTime(event.start);
		            var endTime = event._endTime || kendo.date.toUtcTime(event.end);
	
		            var slotRanges = this._slotRanges;
	
		            if (startTime === endTime) {
		                endTime = endTime+1;
		            }
	
		            for (var slotIndex = 0; slotIndex < slotRanges.length; slotIndex++) {
		                if (startTime < slotRanges[slotIndex].end && slotRanges[slotIndex].start < endTime) {
		                    return true;
		                }
		            }
		            return false;
		        },
	
		        _adjustEvent: function(event) {
		            var start = event.start;
		            var end = event.end;
		            var eventStartTime = event._time("start");
		            var eventEndTime = event._time("end");
		            var startTime = getMilliseconds(this.startTime());
		            var endTime = getMilliseconds(this.endTime());
		            var adjustedStartDate = null;
		            var adjustedEndDate = null;
		            var occurrence;
		            var head = false;
		            var tail = false;
	
		            if (event.isAllDay) {
		                start = getDate(start);
		                eventStartTime = 0;
	
		                end = getDate(end);
		                eventEndTime = MS_PER_DAY;
		                adjustedEndDate = kendo.date.addDays(end, 1);
		            }
	
		            if (endTime === 0) {
		                endTime = MS_PER_DAY;
		            }
	
		            if (endTime <= startTime) {
		                if (eventStartTime < startTime && eventStartTime >= endTime) {
		                    adjustedStartDate = getDate(start);
		                    setTime(adjustedStartDate, startTime);
		                    tail = true;
		                }
	
		                if (eventEndTime > endTime && eventEndTime <= startTime) {
		                    adjustedEndDate = getDate(end);
		                    setTime(adjustedEndDate, endTime);
		                    head = true;
		                }
		            } else {
		                if (startTime > eventStartTime) {
		                    adjustedStartDate = getDate(start);
		                    setTime(adjustedStartDate, startTime);
		                    tail = true;
		                } else if (endTime <= eventStartTime) {
		                    adjustedStartDate = getDate(start);
		                    adjustedStartDate = kendo.date.addDays(adjustedStartDate, 1);
		                    setTime(adjustedStartDate, startTime);
		                    tail = true;
		                }
	
		                if (endTime < eventEndTime) {
		                    adjustedEndDate = getDate(end);
		                    setTime(adjustedEndDate, endTime);
		                    head = true;
		                } else if (startTime > eventEndTime) {
		                    adjustedEndDate = getDate(end);
		                    adjustedEndDate = kendo.date.addDays(adjustedEndDate,-1);
		                    setTime(adjustedEndDate, endTime);
		                    head = true;
		                }
		            }
	
		            occurrence = event.clone({
		                start: adjustedStartDate ? adjustedStartDate : start,
		                end: adjustedEndDate ? adjustedEndDate : end,
		                _startTime: adjustedStartDate ? kendo.date.toUtcTime(adjustedStartDate) : event._startTime,
		                _endTime:  adjustedEndDate ? kendo.date.toUtcTime(adjustedEndDate) : event._endTime,
		                isAllDay: false
		            });
	
		            return {
		                occurrence: occurrence,
		                head: head,
		                tail: tail
		            };
		        },
	
		        _renderEvents: function(events, groupIndex, eventGroup) {
		            var event;
		            var idx;
		            var length;
	
		            for (idx = 0, length = events.length; idx < length; idx++) {
		                event = events[idx];
	
		                if (this._isInDateSlot(event)) {
		                    var isMultiDayEvent = event.isAllDay || event.duration() >= MS_PER_DAY;
		                    var container = this.content;
	
		                    if (isMultiDayEvent || this._isInTimeSlot(event)) {
		                        var adjustedEvent = this._adjustEvent(event);
		                        var group = this.groups[groupIndex];
	
		                        if (!group._continuousEvents) {
		                            group._continuousEvents = [];
		                        }
	
		                        if (this._isInTimeSlot(adjustedEvent.occurrence)) {
		                            var ranges = group.slotRanges(adjustedEvent.occurrence, false);
		                            var range = ranges[0];
		                            var startIndex = range.start.index;
		                            var endIndex = range.end.index;
	
		                            this._groupedView._renderEvent(eventGroup, event, adjustedEvent, group, range, container, startIndex, endIndex);
		                        }
		                    }
		                }
		            }
		        },
	
		        addContinuousEvent: function(group, range, element, isAllDay) {
		            var events = group._continuousEvents;
	
		            events.push({
		                element: element,
		                isAllDay: isAllDay,
		                uid: element.attr(kendo.attr("uid")),
		                start: range.start,
		                end: range.end
		            });
		        },
	
		        _createEventElement: function(occurrence, event, head, tail) {
		            var template = this.eventTemplate;
		            var editable = this.options.editable;
		            var isMobile = this._isMobile();
		            var showDelete = editable && editable.destroy !== false && !isMobile;
		            var resizable = editable && editable.resize !== false;
		            var eventStartTime = event._time("start");
		            var eventEndTime = event._time("end");
		            var eventStartDate = event.start;
		            var eventEndDate = event.end;
	
		            var resources = this.eventResources(event);
	
		            if (event._startTime && eventStartTime !== kendo.date.getMilliseconds(event.start)) {
		                eventStartDate = new Date(eventStartTime);
		                eventStartDate = kendo.timezone.apply(eventStartDate, "Etc/UTC");
		            }
	
		            if (event._endTime && eventEndTime !== kendo.date.getMilliseconds(event.end)) {
		                eventEndDate = new Date(eventEndTime);
		                eventEndDate = kendo.timezone.apply(eventEndDate, "Etc/UTC");
		            }
	
		            var data = extend({}, {
		                ns: kendo.ns,
		                resizable: resizable,
		                showDelete: showDelete,
		                head: head,
		                tail: tail,
		                singleDay: this._dates.length == 1,
		                resources: resources,
		                inverseColor: resources && resources[0] ? this._shouldInverseResourceColor(resources[0]) : false,
		                messages: this.options.messages
		            }, event, {
		                start: eventStartDate,
		                end: eventEndDate
		            });
	
		            var element = $(template(data));
	
		            this.angular("compile", function(){
		                return {
		                    elements: element,
		                    data: [ { dataItem: data } ]
		                };
		            });
	
		            return element;
		        },
	
		        _arrangeRows: function (eventObject, slotRange, eventGroup) {
		            var startIndex = slotRange.start.index;
		            var endIndex = slotRange.end.index;
	
		            var rect = eventObject.slotRange.innerRect(eventObject.start, eventObject.end, false);
		            var rectRight = rect.right + this.options.eventMinWidth;
	
		            var events = collidingEvents(slotRange.events(), rect.left, rectRight);
	
		            slotRange.addEvent({
		                slotIndex: startIndex,
		                start: startIndex,
		                end: endIndex,
		                rectLeft: rect.left,
		                rectRight: rectRight,
		                element: eventObject.element,
		                uid: eventObject.uid
		            });
	
		            events.push({
		                start: startIndex,
		                end: endIndex,
		                uid: eventObject.uid
		            });
	
		            var rows = SchedulerView.createRows(events);
	
		            if (eventGroup.maxRowCount < rows.length) {
		                eventGroup.maxRowCount = rows.length;
		            }
	
		            for (var idx = 0, length = rows.length; idx < length; idx++) {
		                var rowEvents = rows[idx].events;
		                for (var j = 0, eventLength = rowEvents.length; j < eventLength; j++) {
		                    eventGroup.events[rowEvents[j].uid].rowIndex = idx;
		                }
		            }
		        },
	
		        _groupCount: function() {
		            var resources = this.groupedResources;
		            var groupedView = this._groupedView;
	
		            if (resources.length) {
		                if (this._groupOrientation() === "vertical") {
		                    return groupedView._verticalCountForLevel(resources.length - 1);
		                } else {
		                    return groupedView._horizontalCountForLevel(resources.length - 1, this.columnLevels.length - 1);
		                }
		            }
		            return 1;
		        },
	
		        _updateEventForSelection: function(event) {
		            var adjustedEvent = this._adjustEvent(event.clone());
		            return adjustedEvent.occurrence;
		        },
	
		        _eventOptionsForMove: function(event) {
		           if (event.isAllDay) {
		               return { isAllDay: false };
		           }
	
		            return {};
		        },
	
		        _updateEventForResize: function(event) {
		            if (event.isAllDay) {
		                event.set("isAllDay", false);
		            }
		        },
	
		        _updateMoveHint: function(event, groupIndex, distance) {
		            var group = this.groups[groupIndex];
	
		            var clonedEvent = event.clone({ start: event.start, end: event.end});
	
		            var eventDuraton =  clonedEvent.duration();
		            clonedEvent.start = new Date(clonedEvent.start.getTime() + distance);
		            clonedEvent.end = new Date(+clonedEvent.start + eventDuraton);
	
		            this._removeMoveHint(event.uid);
	
		            if (this._isInDateSlot(clonedEvent)) {
		                if (clonedEvent.isAllDay || clonedEvent.duration() >= MS_PER_DAY || this._isInTimeSlot(clonedEvent)) {
		                    var adjustedEvent = this._adjustEvent(clonedEvent);
		                    var ranges = group.slotRanges(adjustedEvent.occurrence, false);
	
		                    for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
		                        this._groupedView._createMoveHint(ranges[rangeIndex], adjustedEvent);
		                    }
		                }
		            }
		        },
	
		       _appendMoveHint: function(hint) {
		            hint.appendTo(this.content);
		            this._moveHint = this._moveHint.add(hint);
		       },
	
		        _updateResizeHint: function(event, groupIndex, startTime, endTime) {
		            var group = this.groups[groupIndex];
		            var ranges = group.ranges(startTime, endTime, false, false);
	
		            this._removeResizeHint();
	
		            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
		                var range = ranges[rangeIndex];
		                var start = range.startSlot();
	
		                var startRect = range.innerRect(startTime, endTime, false);
		                startRect.top = start.offsetTop;
	
		                var width = startRect.right - startRect.left;
	
		                if (width < 0) {
		                    for (var i = 0; i < range.events().length; i++) {
		                        if (range.events()[i].uid === event.uid) {
		                            width = range.events()[i].rectRight - startRect.left;
		                            break;
		                        }
		                    }
		                }
	
		                var height = range.endSlot().offsetTop + start.offsetHeight - startRect.top;
	
		                var left = this._adjustLeftPosition(startRect.left);
	
		                var hint = SchedulerView.fn._createResizeHint.call(this,
		                    left,
		                    startRect.top,
		                    width,
		                    height
		                );
	
		                this._resizeHint = this._resizeHint.add(hint);
		            }
	
		            var format = "t";
		            var container = this.content;
	
		            this._resizeHint.appendTo(container);
	
		            this._resizeHint.find(".k-label-top,.k-label-bottom").text("");
	
		            this._resizeHint.first().addClass("k-first").find(".k-label-top").text(kendo.toString(kendo.timezone.toLocalDate(startTime), format));
	
		            this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(kendo.toString(kendo.timezone.toLocalDate(endTime), format));
		        },
	
		        selectionByElement: function(cell) {
		            var offset = cell.offset();
		            return this._slotByPosition(offset.left, offset.top);
		        },
	
		        _updateDirection: function(selection, ranges, multiple, reverse, vertical) {
	
		            var startSlot = ranges[0].start;
		            var endSlot = ranges[ranges.length - 1].end;
		            if (multiple && !vertical) {
		                if (startSlot.index === endSlot.index &&
		                    startSlot.collectionIndex === endSlot.collectionIndex) {
		                    selection.backward = reverse;
		                }
		            }
		        },
	
		        _changeGroup: function(selection, previous) {
		            var method = previous ? "prevGroupSlot" : "nextGroupSlot";
	
		            var slot = this[method](selection.start, selection.groupIndex, false);
	
		            if (slot) {
		                selection.groupIndex += previous ? -1 : 1;
		            }
	
		            this._groupedView._changeGroup(selection, previous, slot);
		            return slot;
		        },
	
		        prevGroupSlot: function(date, groupIndex, isDay) {
		            var group = this.groups[groupIndex];
		            var slot = group.ranges(date, date, isDay, false)[0].start;
	
		            if (groupIndex <= 0) {
		                return;
		            }
	
		            return this._groupedView._prevGroupSlot(slot, group, isDay);
		        },
	
		        nextGroupSlot: function(date, groupIndex, isDay) {
		            var group = this.groups[groupIndex];
		            var slot = group.ranges(date, date, isDay, false)[0].start;
	
		            if (groupIndex >= this.groups.length - 1) {
		                return;
		            }
	
		            return this._groupedView._nextGroupSlot(slot, group, isDay);
		        },
	
		        _verticalSlots: function (selection, ranges, multiple, reverse) {
		            var groupedView = this._groupedView;
		            var method = groupedView._verticalMethod(reverse, multiple);
		            var startSlot = ranges[0].start;
		            var endSlot = ranges[ranges.length - 1].end;
		            var group = this.groups[selection.groupIndex];
		            var slot = groupedView._normalizeVerticalSelection(selection, ranges, reverse, multiple);
	
		            if (slot) {
		                startSlot = endSlot = slot;
		            }
	
		            startSlot = group[method](startSlot);
		            endSlot = group[method](endSlot);
	
		            if (!multiple && this._isVerticallyGrouped() && (!startSlot || !endSlot)) {
		                startSlot = endSlot = groupedView._verticalSlots(selection, reverse, slot);
		            }
	
		            return {
		                startSlot: startSlot,
		                endSlot: endSlot
		            };
		        },
	
		        _horizontalSlots: function (selection, ranges, multiple, reverse) {
		            var method = reverse ? "upSlot" : "downSlot";
		            var startSlot = ranges[0].start;
		            var endSlot = ranges[ranges.length - 1].end;
		            var group = this.groups[selection.groupIndex];
		            var result = {};
	
		            if (!multiple) {
		                result = this._groupedView._horizontalSlots(selection, group, method, startSlot, endSlot, multiple, reverse);
		            } else {
		                result.startSlot = group[method](startSlot);
		                result.endSlot = group[method](endSlot);
	
		                if (!multiple && this._isHorizontallyGrouped() && (!startSlot || !endSlot)) {
		                    result.startSlot = result.endSlot = this._changeGroup(selection, reverse);
		                }
		            }
	
		            return result;
		        },
	
		        _changeViewPeriod: function(selection, reverse) {
		            var date = reverse ? this.previousDate() : this.nextDate();
		            var start = selection.start;
		            var end = selection.end;
		            var newStart, newEnd;
	
		            newStart = new Date(date);
		            newEnd = new Date(date);
	
		            if(this._isInRange(newStart, newEnd)){
		                return false;
		            }
		            selection.start = newStart;
		            selection.end = newEnd;
	
		            if (this._isHorizontallyGrouped()) {
		               selection.groupIndex = reverse ? this.groups.length - 1 : 0;
		            }
	
		            var duration = end - start;
	
		            if (reverse) {
		                end = getMilliseconds(this.endTime());
		                end = end === 0 ? MS_PER_DAY : end;
	
		                setTime(selection.start, end-duration);
		                setTime(selection.end,  end);
		            } else {
		                start = getMilliseconds(this.startTime());
	
		                setTime(selection.start, start);
		                setTime(selection.end, start + duration);
		            }
	
		            selection.events = [];
	
		            return true;
		        },
	
		        move: function(selection, key, shift) {
		            var handled = false;
		            var group = this.groups[selection.groupIndex];
		            var keys = kendo.keys;
		            var groupedView = this._groupedView;
		            var ranges = group.ranges(selection.start, selection.end, false, false);
		            var startSlot, endSlot, reverse, slots;
	
		            if (key === keys.DOWN || key === keys.UP) {
		                handled = true;
		                reverse = key === keys.UP;
	
		                groupedView._updateDirection(selection, ranges, shift, reverse);
	
		                slots = this._verticalSlots(selection, ranges, shift, reverse);
	
		                if(groupedView._changeVerticalViewPeriod(slots, shift, selection, reverse)){
		                    return handled;
		                }
		            } else if (key === keys.LEFT || key === keys.RIGHT) {
		                handled = true;
		                reverse = key === keys.LEFT;
	
		                this._updateDirection(selection, ranges, shift, reverse, false);
	
		                slots = this._horizontalSlots(selection, ranges, shift, reverse);
	
		                if(groupedView._changeHorizontalViewPeriod(slots, shift, selection, reverse)){
		                     return handled;
		                }
		            }
	
		           if (handled) {
		               startSlot = slots.startSlot;
		               endSlot = slots.endSlot;
	
		               if (shift) {
		                   var backward = selection.backward;
	
		                   if (backward && startSlot) {
		                       selection.start = startSlot.startDate();
		                   } else if (!backward && endSlot) {
		                       selection.end = endSlot.endDate();
		                   }
		               } else if (startSlot && endSlot) {
		                   selection.start = startSlot.startDate();
		                   selection.end = endSlot.endDate();
		               }
	
		               selection.events = [];
		           }
	
		            return handled;
		        },
	
		        destroy: function() {
		            var that = this;
	
		            if (that.element) {
		                that.element.off(NS);
		            }
	
		            if (that.footer) {
		                that.footer.remove();
		            }
	
		            if (that._currentTimeUpdateTimer) {
		                clearInterval(that._currentTimeUpdateTimer);
		            }
	
		            SchedulerView.fn.destroy.call(this);
	
		            if (this._isMobile() && that.options.editable) {
		                if (that.options.editable.create !== false) {
		                    that._addUserEvents.destroy();
		                }
	
		                if (that.options.editable.update !== false) {
		                    that._editUserEvents.destroy();
		                }
		            }
		        }
		    });
	
		    extend(true, ui, {
		        TimelineView: TimelineView,
		        TimelineWeekView: TimelineView.extend({
		            options: {
		                name: "TimelineWeekView",
		                title: "Timeline Week",
		                selectedDateFormat: "{0:D} - {1:D}",
		                selectedShortDateFormat: "{0:d} - {1:d}",
		                majorTick: 120
		            },
		            name: "timelineWeek",
		            calculateDateRange: function() {
		                var selectedDate = this.options.date,
		                    start = kendo.date.dayOfWeek(selectedDate, this.calendarInfo().firstDay, -1),
		                    idx, length,
		                    dates = [];
	
		                for (idx = 0, length = 7; idx < length; idx++) {
		                    dates.push(start);
		                    start = kendo.date.nextDay(start);
		                }
		                this._render(dates);
		            }
		        }),
		        TimelineWorkWeekView: TimelineView.extend({
		            options: {
		                name: "TimelineWorkWeekView",
		                title: "Timeline Work Week",
		                selectedDateFormat: "{0:D} - {1:D}",
		                selectedShortDateFormat: "{0:d} - {1:d}",
		                majorTick: 120
		            },
		            name: "timelineWorkWeek",
		            nextDate: function() {
		                var weekStart = kendo.date.dayOfWeek(kendo.date.nextDay(this.endDate()), this.calendarInfo().firstDay, 1);
	
		                return kendo.date.addDays(weekStart, this._workDays[0]);
		            },
		            previousDate: function() {
		                var weekStart = kendo.date.dayOfWeek(this.startDate(), this.calendarInfo().firstDay, -1);
		                var workDays = this._workDays;
	
		                return kendo.date.addDays(weekStart, workDays[workDays.length - 1] - 7);
		            },
		            calculateDateRange: function() {
		                var selectedDate = this.options.date,
		                    start = kendo.date.dayOfWeek(selectedDate, this.options.workWeekStart, -1),
		                    end = kendo.date.dayOfWeek(start, this.options.workWeekEnd, 1),
		                    dates = [];
	
		                while (start <= end) {
		                    dates.push(start);
		                    start = kendo.date.nextDay(start);
		                }
		                this._render(dates);
		            }
		        }),
		        TimelineMonthView: TimelineView.extend({
		            options: {
		                name: "TimelineMonthView",
		                title: "Timeline Month",
		                selectedDateFormat: "{0:D} - {1:D}",
		                selectedShortDateFormat: "{0:d} - {1:d}",
		                workDayStart: new Date(1980, 1, 1, 0, 0, 0),
		                workDayEnd: new Date(1980, 1, 1, 23, 59, 59),
		                footer: false,
		                majorTick: 1440,
		                minorTickCount: 1
		            },
		            name: "timelineMonth",
		            calculateDateRange: function() {
		                var selectedDate = this.options.date,
		                    start = kendo.date.firstDayOfMonth(selectedDate),
		                    end = kendo.date.lastDayOfMonth(selectedDate),
		                    idx, length,
		                    dates = [];
	
		                for (idx = 0, length = end.getDate(); idx < length; idx++) {
		                    dates.push(start);
		                    start = kendo.date.nextDay(start);
		                }
		                this._render(dates);
		            }
		        })
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1185);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1137:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(593);
	
	/***/ }),
	
	/***/ 1138:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1185:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1013), __webpack_require__(1036), __webpack_require__(1138), __webpack_require__(1137), __webpack_require__(1186), __webpack_require__(1187), __webpack_require__(1188), __webpack_require__(1189)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "gantt",
		    name: "Gantt",
		    category: "web",
		    description: "The Gantt component.",
		    depends: [ "data", "popup", "resizable", "window", "gantt.list", "gantt.timeline", "grid" ]
		};
	
		(function($, undefined) {
	
		    var kendo = window.kendo;
		    var keys = $.extend({F10: 121}, kendo.keys);
		    var supportsMedia = "matchMedia" in window;
		    var browser = kendo.support.browser;
		    var mobileOS = kendo.support.mobileOS;
		    var Observable = kendo.Observable;
		    var Widget = kendo.ui.Widget;
		    var DataSource = kendo.data.DataSource;
		    var ObservableObject = kendo.data.ObservableObject;
		    var ObservableArray = kendo.data.ObservableArray;
		    var Query = kendo.data.Query;
		    var isArray = $.isArray;
		    var inArray = $.inArray;
		    var isFunction = kendo.isFunction;
		    var proxy = $.proxy;
		    var extend = $.extend;
		    var isPlainObject = $.isPlainObject;
		    var map = $.map;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
		    var defaultIndicatorWidth = 3;
		    var NS = ".kendoGantt";
		    var PERCENTAGE_FORMAT = "p0";
		    var TABINDEX = "tabIndex";
		    var CLICK = "click";
		    var WIDTH = "width";
		    var STRING = "string";
		    var DIRECTIONS = {
		        "down": {
		            origin: "bottom left",
		            position: "top left"
		        },
		        "up": {
		            origin: "top left",
		            position: "bottom left"
		        }
		    };
		    var ARIA_DESCENDANT = "aria-activedescendant";
		    var ARIA_LABEL = "aria-label";
		    var ACTIVE_CELL = "gantt_active_cell";
		    var ACTIVE_OPTION = "action-option-focused";
		    var DOT = ".";
		    var TASK_DELETE_CONFIRM = "Are you sure you want to delete this task?";
		    var DEPENDENCY_DELETE_CONFIRM = "Are you sure you want to delete this dependency?";
		    var TOGGLE_BUTTON_TEMPLATE = kendo.template('<button class="#=styles.buttonToggle#" type="button" '+ ARIA_LABEL + '="Toggle"><span class="#=styles.iconToggle#"></span></button>');
		    var BUTTON_TEMPLATE = '<button class="#=styles.button# #=className#" type="button" '+
		            '#if (action) {#' +
		                'data-action="#=action#"' +
		            '#}#' +
		        '><span class="#=iconClass#"></span><span>#=text#</span></button>';
		    var COMMAND_BUTTON_TEMPLATE = '<a class="#=className#" #=attr# href="\\#">#=text#</a>';
		    var VIEWBUTTONTEMPLATE = kendo.template('<li class="#=styles.currentView# #=styles.viewButtonDefault#"><a href="\\#" class="#=styles.link#">&nbps;</a></li>');
		    var HEADER_VIEWS_TEMPLATE = kendo.template('<ul class="#=styles.viewsWrapper#">' +
		            '#for(var view in views){#' +
		                '<li class="#=styles.viewButtonDefault# #=styles.viewButton#-#= view.toLowerCase() #" data-#=ns#name="#=view#"><a href="\\#" class="#=styles.link#">#=views[view].title#</a></li>' +
		            '#}#' +
		        '</ul>');
		    var TASK_DROPDOWN_TEMPLATE = kendo.template('<div class="#=styles.popupWrapper#">' +
		            '<ul class="#=styles.popupList#" role="listbox">' +
		                '#for(var i = 0, l = actions.length; i < l; i++){#' +
		                    '<li class="#=styles.item#" data-action="#=actions[i].data#" role="option">#=actions[i].text#</span>' +
		                '#}#' +
		            '</ul>' +
		        '</div>');
	
		    var DATERANGEEDITOR = function(container, options) {
		        var attr = { name: options.field, title: options.title };
		        var validationRules = options.model.fields[options.field].validation;
	
		        if (validationRules && isPlainObject(validationRules) && validationRules.message) {
		            attr[kendo.attr("dateCompare-msg")] = validationRules.message;
		        }
	
		        $('<input type="text" required ' +
		                kendo.attr("type") + '="date" ' +
		                kendo.attr("role") + '="datetimepicker" ' +
		                kendo.attr("bind") + '="value:' +
		                options.field +'" ' +
		                kendo.attr("validate") + "='true' />")
		            .attr(attr)
		            .appendTo(container);
	
		        $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>')
		            .hide()
		            .appendTo(container);
		    };
	
		    var RESOURCESEDITOR = function(container, options) {
		        $('<a href="#" class="' + options.styles.button + '">' + options.messages.assignButton + '</a>').click(options.click).appendTo(container);
		    };
	
		    var ganttStyles = {
		        wrapper: "k-widget k-gantt",
		        rowHeight: "k-gantt-rowheight",
		        listWrapper: "k-gantt-layout k-gantt-treelist",
		        list: "k-gantt-treelist",
		        timelineWrapper: "k-gantt-layout k-gantt-timeline",
		        timeline: "k-gantt-timeline",
		        splitBarWrapper: "k-splitbar k-state-default k-splitbar-horizontal k-splitbar-draggable-horizontal k-gantt-layout",
		        splitBar: "k-splitbar",
		        splitBarHover: "k-splitbar-horizontal-hover",
		        popupWrapper: "k-list-container",
		        popupList: "k-list k-reset",
		        resizeHandle: "k-resize-handle",
		        icon: "k-icon",
		        item: "k-item",
		        line: "k-line",
		        buttonDelete: "k-gantt-delete",
		        buttonCancel: "k-gantt-cancel",
		        buttonSave: "k-gantt-update",
		        buttonToggle: "k-gantt-toggle",
		        primary: "k-primary",
		        hovered: "k-state-hover",
		        selected: "k-state-selected",
		        focused: "k-state-focused",
		        gridHeader: "k-grid-header",
		        gridHeaderWrap: "k-grid-header-wrap",
		        gridContent: "k-grid-content",
		        tasks: "k-gantt-tasks",
		        popup: {
		            form: "k-popup-edit-form",
		            editForm: "k-gantt-edit-form",
		            formContainer: "k-edit-form-container",
		            resourcesFormContainer: "k-resources-form-container",
		            message: "k-popup-message",
		            buttonsContainer: "k-edit-buttons k-state-default",
		            button: "k-button",
		            editField: "k-edit-field",
		            editLabel: "k-edit-label",
		            resourcesField: "k-gantt-resources"
		        },
		        toolbar: {
		            headerWrapper: "k-floatwrap k-header k-gantt-toolbar",
		            footerWrapper: "k-floatwrap k-header k-gantt-toolbar",
		            toolbar: "k-gantt-toolbar",
		            expanded: "k-state-expanded",
		            views: "k-gantt-views",
		            viewsWrapper: "k-reset k-header k-gantt-views",
		            actions: "k-gantt-actions",
		            button: "k-button k-button-icontext",
		            buttonToggle: "k-button k-button-icon k-gantt-toggle",
		            iconPlus: "k-icon k-i-plus",
		            iconPdf: "k-icon k-i-file-pdf",
		            iconToggle: "k-icon k-i-layout-1-by-4",
		            viewButtonDefault: "k-state-default",
		            viewButton: "k-view",
		            currentView: "k-current-view",
		            link: "k-link",
		            pdfButton: "k-gantt-pdf",
		            appendButton: "k-gantt-create"
		        }
		    };
	
		    function selector(uid) {
		        return "[" + kendo.attr("uid") + (uid ? "='" + uid + "']" : "]");
		    }
	
		    function trimOptions(options) {
		        delete options.name;
		        delete options.prefix;
	
		        delete options.remove;
		        delete options.edit;
		        delete options.add;
		        delete options.navigate;
	
		        return options;
		    }
	
		    function dateCompareValidator(input) {
		        if (input.filter("[name=end], [name=start]").length) {
		            var field = input.attr("name");
		            var picker = kendo.widgetInstance(input, kendo.ui);
		            var dates = {};
		            var container = input;
		            var editable;
		            var model;
	
		            while (container !== window && !editable) {
		                container = container.parent();
	
		                editable = container.data("kendoEditable");
		            }
	
		            model = editable ? editable.options.model : null;
	
		            if (!model) {
		                return true;
		            }
	
		            dates.start = model.start;
		            dates.end = model.end;
		            dates[field] = picker ? picker.value() : kendo.parseDate(input.value());
	
		            return dates.start <= dates.end;
		        }
	
		        return true;
		    }
	
		    function focusTable(table, direct) {
		        var wrapper = table.parents('[' + kendo.attr("role") + '="gantt"]');
		        var scrollPositions = [];
		        var parents = scrollableParents(wrapper);
	
		        table.attr(TABINDEX, 0);
	
		        if (direct) {
		            parents.each(function(index, parent) {
		                scrollPositions[index] = $(parent).scrollTop();
		            });
		        }
	
		        try {
		            //The setActive method does not cause the document to scroll to the active object in the current page
		            table[0].setActive();
		        } catch (e) {
		            table[0].focus();
		        }
	
		        if (direct) {
		            parents.each(function(index, parent) {
		                $(parent).scrollTop(scrollPositions[index]);
		            });
		        }
		    }
	
		    function scrollableParents(element) {
		        return $(element).parentsUntil("body")
		                .filter(function(index, element) {
		                    var computedStyle = kendo.getComputedStyles(element, ["overflow"]);
		                    return computedStyle.overflow != "visible";
		                })
		                .add(window);
		    }
	
		    var defaultCommands;
	
		    var TaskDropDown = Observable.extend({
		        init: function(element, options) {
	
		            Observable.fn.init.call(this);
	
		            this.element = element;
		            this.options = extend(true, {}, this.options, options);
	
		            this._popup();
		        },
	
		        options: {
		            direction: "down",
		            navigatable: false
		        },
	
		        _current: function(method) {
		            var ganttStyles = Gantt.styles;
		            var current = this.list
		                .find(DOT + ganttStyles.focused);
		            var sibling = current[method]();
	
		            if (sibling.length) {
		                current
		                    .removeClass(ganttStyles.focused)
		                    .removeAttr("id");
		                sibling
		                    .addClass(ganttStyles.focused)
		                    .attr("id", ACTIVE_OPTION);
	
		                this.list.find("ul")
		                    .removeAttr(ARIA_DESCENDANT)
		                    .attr(ARIA_DESCENDANT, ACTIVE_OPTION);
		            }
		        },
	
		        _popup: function() {
		            var that = this;
		            var ganttStyles = Gantt.styles;
		            var itemSelector = "li" + DOT + ganttStyles.item;
		            var appendButtonSelector = DOT + ganttStyles.toolbar.appendButton;
		            var actions = this.options.messages.actions;
		            var navigatable = this.options.navigatable;
	
		            this.list = $(TASK_DROPDOWN_TEMPLATE({
		                styles: ganttStyles,
		                actions: [
		                    {
		                        data: "add",
		                        text: actions.addChild
		                    },
		                    {
		                        data: "insert-before",
		                        text: actions.insertBefore
		                    },
		                    {
		                        data: "insert-after",
		                        text: actions.insertAfter
		                    }
		                ]
		            }));
	
		            this.element.append(this.list);
	
		            this.popup = new kendo.ui.Popup(this.list,
		                extend({
		                    anchor: this.element.find(appendButtonSelector),
		                    open: function() {
		                        that._adjustListWidth();
		                    },
		                    animation: this.options.animation
		                }, DIRECTIONS[this.options.direction])
		            );
	
		            this.element
		                .on(CLICK + NS, appendButtonSelector, function(e) {
		                    var target = $(this);
		                    var action = target.attr(kendo.attr("action"));
	
		                    e.preventDefault();
	
		                    if (action) {
		                        that.trigger("command", { type: action });
		                    } else {
		                        that.popup.open();
	
		                        if (navigatable) {
		                            that.list
		                                .find("li:first")
		                                .addClass(ganttStyles.focused)
		                                .attr("id", ACTIVE_OPTION)
		                                .end()
		                                .find("ul")
		                                .attr({
		                                    TABINDEX: 0,
		                                    "aria-activedescendant": ACTIVE_OPTION
		                                })
		                                .focus();
		                        }
		                    }
		                });
	
		            this.list
		                .find(itemSelector)
		                .hover(function() {
		                    $(this).addClass(ganttStyles.hovered);
		                }, function() {
		                    $(this).removeClass(ganttStyles.hovered);
		                })
		                .end()
		                .on(CLICK + NS, itemSelector, function() {
		                    that.trigger("command", { type: $(this).attr(kendo.attr("action")) });
		                    that.popup.close();
		                });
	
		            if (navigatable) {
		                this.popup
		                    .bind("close", function() {
		                        that.list
		                            .find(itemSelector)
		                            .removeClass(ganttStyles.focused)
		                            .end()
		                            .find("ul")
		                            .attr(TABINDEX, 0);
	
		                        that.element
		                            .parents('[' + kendo.attr("role") + '="gantt"]')
		                            .find(DOT + ganttStyles.gridContent + " > table:first")
		                            .focus();
		                    });
	
		                this.list
		                    .find("ul")
		                    .on("keydown" + NS, function(e) {
		                        var key = e.keyCode;
	
		                        switch (key) {
		                            case keys.UP:
		                                e.preventDefault();
		                                that._current("prev");
		                                break;
		                            case keys.DOWN:
		                                e.preventDefault();
		                                that._current("next");
		                                break;
		                            case keys.ENTER:
		                                that.list
		                                    .find(DOT + ganttStyles.focused)
		                                    .click();
		                                break;
		                            case keys.ESC:
		                                e.preventDefault();
		                                that.popup.close();
		                                break;
		                        }
		                    });
		            }
		        },
	
		        _adjustListWidth: function() {
		            var list = this.list;
		            var ganttStyles = Gantt.styles;
		            var width = list[0].style.width;
		            var wrapper = this.element.find(DOT + ganttStyles.toolbar.appendButton);
		            var listOuterWidth = outerWidth(list);
		            var computedStyle;
		            var computedWidth;
	
		            if (!list.data(WIDTH) && width) {
		                return;
		            }
	
		            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
		            computedWidth = computedStyle ? parseFloat(computedStyle.width) : outerWidth(wrapper);
	
		            if (computedStyle && (browser.mozilla || browser.msie)) { // getComputedStyle returns different box in FF and IE.
		                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
		            }
	
		            if (list.css("box-sizing") !== "border-box") {
		                width = computedWidth - (outerWidth(list) - list.width());
		            } else {
		                width = computedWidth;
		            }
	
		            if (listOuterWidth > width) {
		                width = listOuterWidth;
		            }
	
		            list.css({
		                fontFamily: wrapper.css("font-family"),
		                width: width
		            })
		            .data(WIDTH, width);
		        },
	
		        destroy: function() {
		            clearTimeout(this._focusTimeout);
		            this.popup.destroy();
		            this.element.off(NS);
		            this.list.off(NS);
		            this.unbind();
		        }
		    });
	
		    var createDataSource = function(type, name) {
		        return function(options) {
		            options = isArray(options) ? { data: options } : options;
	
		            var dataSource = options || {};
		            var data = dataSource.data;
	
		            dataSource.data = data;
	
		            if (!(dataSource instanceof type) && dataSource instanceof DataSource) {
		                throw new Error("Incorrect DataSource type. Only " + name + " instances are supported");
		            }
	
		            return dataSource instanceof type ? dataSource : new type(dataSource);
		        };
		    };
	
		    var GanttDependency = kendo.data.Model.define({
		        id: "id",
		        fields: {
		            id: { type: "number" },
		            predecessorId: { type: "number" },
		            successorId: { type: "number" },
		            type: { type: "number" }
		        }
		    });
	
		    var GanttDependencyDataSource = DataSource.extend({
		        init: function(options) {
		            DataSource.fn.init.call(this, extend(true, {}, {
		                schema: {
		                    modelBase: GanttDependency,
		                    model: GanttDependency
		                }
		            }, options));
		        },
	
		        successors: function(id) {
		            return this._dependencies("predecessorId", id);
		        },
	
		        predecessors: function(id) {
		            return this._dependencies("successorId", id);
		        },
	
		        dependencies: function(id) {
		            var predecessors = this.predecessors(id);
		            var successors = this.successors(id);
	
		            predecessors.push.apply(predecessors, successors);
	
		            return predecessors;
		        },
	
		        _dependencies: function(field, id) {
		            var data = this.view();
		            var filter = {
		                field: field,
		                operator: "eq",
		                value: id
		            };
	
		            data = new Query(data).filter(filter).toArray();
	
		            return data;
		        }
		    });
	
		    GanttDependencyDataSource.create = createDataSource(GanttDependencyDataSource, "GanttDependencyDataSource");
	
		    var GanttTask = kendo.data.Model.define({
	
		        duration: function() {
		            var end = this.end;
		            var start = this.start;
	
		            return end - start;
		        },
	
		        isMilestone: function() {
		            return this.duration() === 0;
		        },
	
		        _offset: function(value) {
		            var field = ["start", "end"];
		            var newValue;
	
		            for (var i = 0; i < field.length; i++) {
		                newValue = new Date(this.get(field[i]).getTime() + value);
		                this.set(field[i], newValue);
		            }
		        },
	
		        id: "id",
		        fields: {
		            id: { type: "number" },
		            parentId: { type: "number", defaultValue: null, validation: { required: true } },
		            orderId: { type: "number", validation: { required: true } },
		            title: { type: "string", defaultValue: "New task" },
		            start: { type: "date", validation: { required: true } },
		            end: {
		                type: "date", validation: {
		                    required: true,
		                    dateCompare: dateCompareValidator,
		                    message: "End date should be after or equal to the start date"
		                }
		            },
		            percentComplete: { type: "number", validation: { required: true, min:0, max: 1, step: 0.01 } },
		            summary: { type: "boolean" },
		            expanded: { type: "boolean", defaultValue: true }
		        }
		    });
	
		    var GanttDataSource = DataSource.extend({
		        init: function(options) {
		            DataSource.fn.init.call(this, extend(true, {}, {
		                schema: {
		                    modelBase: GanttTask,
		                    model: GanttTask
		                }
		            }, options));
		        },
	
		        remove: function(task) {
		            var parentId = task.get("parentId");
		            var children = this.taskAllChildren(task);
	
		            this._removeItems(children);
	
		            task = DataSource.fn.remove.call(this, task);
	
		            this._childRemoved(parentId, task.get("orderId"));
	
		            return task;
		        },
	
		        add: function(task) {
		            if (!task) {
		                return;
		            }
	
		            task = this._toGanttTask(task);
	
		            return this.insert(this.taskSiblings(task).length, task);
		        },
	
		        insert: function(index, task) {
		            if (!task) {
		                return;
		            }
	
		            task = this._toGanttTask(task);
	
		            task.set("orderId", index);
	
		            task = DataSource.fn.insert.call(this, index, task);
	
		            this._reorderSiblings(task, this.taskSiblings(task).length - 1);
		            this._resolveSummaryFields(this.taskParent(task));
	
		            return task;
		        },
	
		        taskChildren: function(task) {
		            var data = this.view();
		            var filter = {
		                field: "parentId",
		                operator: "eq",
		                value: null
		            };
	
		            var order = (this._sort && this._sort.length) ? this._sort : {
		                field: "orderId",
		                dir: "asc"
		            };
		            var taskId;
	
		            if (!!task) {
		                taskId = task.get("id");
	
		                if (taskId === undefined || taskId === null || taskId === "") {
		                    return [];
		                }
	
		                filter.value = taskId;
		            }
	
		            data = new Query(data).filter(filter).sort(order).toArray();
	
		            return data;
		        },
	
		        taskAllChildren: function(task) {
		            var data = [];
		            var that = this;
		            var callback = function(task) {
		                var tasks = that.taskChildren(task);
	
		                data.push.apply(data, tasks);
		                map(tasks, callback);
		            };
	
		            if (!!task) {
		                callback(task);
		            } else {
		                data = this.view();
		            }
	
		            return data;
		        },
	
		        taskSiblings: function(task) {
		            if (!task) {
		                return null;
		            }
	
		            var parent = this.taskParent(task);
	
		            return this.taskChildren(parent);
		        },
	
		        taskParent: function(task) {
		            if (!task || task.get("parentId") === null) {
		                return null;
		            }
		            return this.get(task.parentId);
		        },
	
		        taskLevel: function(task) {
		            var level = 0;
		            var parent = this.taskParent(task);
	
		            while (parent !== null) {
		                level += 1;
		                parent = this.taskParent(parent);
		            }
	
		            return level;
		        },
	
		        taskTree: function(task) {
		            var data = [];
		            var current;
		            var tasks = this.taskChildren(task);
	
		            for (var i = 0, l = tasks.length; i < l; i++) {
		                current = tasks[i];
		                data.push(current);
	
		                if (current.get("expanded")) {
		                    var children = this.taskTree(current);
	
		                    data.push.apply(data, children);
		                }
		            }
	
		            return data;
		        },
	
		        update: function(task, taskInfo) {
		            var that = this;
		            var oldValue;
	
		            var offsetChildren = function(parentTask, offset) {
		                var children = that.taskAllChildren(parentTask);
	
		                for (var i = 0, l = children.length; i < l; i++) {
		                    children[i]._offset(offset);
		                }
		            };
	
		            var modelChangeHandler = function(e) {
		                var field = e.field;
		                var model = e.sender;
	
		                switch (field) {
		                    case "start":
		                        that._resolveSummaryStart(that.taskParent(model));
	
		                        offsetChildren(model, model.get(field).getTime() - oldValue.getTime());
		                        break;
		                    case "end":
		                        that._resolveSummaryEnd(that.taskParent(model));
		                        break;
		                    case "percentComplete":
		                        that._resolveSummaryPercentComplete(that.taskParent(model));
		                        break;
		                    case "orderId":
		                        that._reorderSiblings(model, oldValue);
		                        break;
		                }
		            };
	
		            if (taskInfo.parentId !== undefined) {
	
		                oldValue = task.get("parentId");
	
		                if (oldValue !== taskInfo.parentId) {
		                    task.set("parentId", taskInfo.parentId);
	
		                    that._childRemoved(oldValue, task.get("orderId"));
	
		                    task.set("orderId", that.taskSiblings(task).length - 1);
		                    that._resolveSummaryFields(that.taskParent(task));
		                }
	
		                delete taskInfo.parentId;
		            }
	
		            task.bind("change", modelChangeHandler);
	
		            for (var field in taskInfo) {
		                oldValue = task.get(field);
		                task.set(field, taskInfo[field]);
		            }
	
		            task.unbind("change", modelChangeHandler);
		        },
	
		        _resolveSummaryFields: function(summary) {
		            if (!summary) {
		                return;
		            }
	
		            this._updateSummary(summary);
	
		            if (!this.taskChildren(summary).length) {
		                return;
		            }
	
		            this._resolveSummaryStart(summary);
		            this._resolveSummaryEnd(summary);
		            this._resolveSummaryPercentComplete(summary);
		        },
	
		        _resolveSummaryStart: function(summary) {
		            var that = this;
		            var getSummaryStart = function(parentTask) {
		                var children = that.taskChildren(parentTask);
		                var min = children[0].start.getTime();
		                var currentMin;
	
		                for (var i = 1, l = children.length; i < l; i++) {
		                    currentMin = children[i].start.getTime();
		                    if (currentMin < min) {
		                        min = currentMin;
		                    }
		                }
	
		                return new Date(min);
		            };
	
		            this._updateSummaryRecursive(summary, "start", getSummaryStart);
		        },
	
		        _resolveSummaryEnd: function(summary) {
		            var that = this;
		            var getSummaryEnd = function(parentTask) {
		                var children = that.taskChildren(parentTask);
		                var max = children[0].end.getTime();
		                var currentMax;
	
		                for (var i = 1, l = children.length; i < l; i++) {
		                    currentMax = children[i].end.getTime();
		                    if (currentMax > max) {
		                        max = currentMax;
		                    }
		                }
	
		                return new Date(max);
		            };
	
		            this._updateSummaryRecursive(summary, "end", getSummaryEnd);
		        },
	
		        _resolveSummaryPercentComplete: function(summary) {
		            var that = this;
		            var getSummaryPercentComplete = function(parentTask) {
		                var children = that.taskChildren(parentTask);
		                var percentComplete = new Query(children).aggregate([{
		                    field: "percentComplete",
		                    aggregate: "average"
		                }]);
	
		                return percentComplete.percentComplete.average;
		            };
	
		            this._updateSummaryRecursive(summary, "percentComplete", getSummaryPercentComplete);
		        },
	
		        _updateSummaryRecursive: function(summary, field, callback) {
		            if (!summary) {
		                return;
		            }
	
		            var value = callback(summary);
	
		            summary.set(field, value);
	
		            var parent = this.taskParent(summary);
	
		            if (parent) {
		                this._updateSummaryRecursive(parent, field, callback);
		            }
		        },
	
		        _childRemoved: function(parentId, index) {
		            var parent = parentId === null ? null : this.get(parentId);
		            var children = this.taskChildren(parent);
	
		            for (var i = index, l = children.length; i < l; i++) {
		                children[i].set("orderId", i);
		            }
	
		            this._resolveSummaryFields(parent);
		        },
	
		        _reorderSiblings: function(task, oldOrderId) {
		            var orderId = task.get("orderId");
		            var direction = orderId > oldOrderId;
		            var startIndex = direction ? oldOrderId : orderId;
		            var endIndex = direction ? orderId : oldOrderId;
		            var newIndex = direction ? startIndex : startIndex + 1;
		            var siblings = this.taskSiblings(task);
	
		            endIndex = Math.min(endIndex, siblings.length - 1);
	
		            for (var i = startIndex; i <= endIndex; i++) {
		                if (siblings[i] === task) {
		                    continue;
		                }
	
		                siblings[i].set("orderId", newIndex);
	
		                newIndex += 1;
		            }
		        },
	
		        _updateSummary: function(task) {
		            if (task !== null) {
		                var childCount = this.taskChildren(task).length;
	
		                task.set("summary", childCount > 0);
		            }
		        },
	
		        _toGanttTask: function(task) {
		            if (!(task instanceof GanttTask)) {
		                var taskInfo = task;
	
		                task = this._createNewModel();
		                task.accept(taskInfo);
		            }
	
		            return task;
		        }
		    });
	
		    GanttDataSource.create = createDataSource(GanttDataSource, "GanttDataSource");
	
		    extend(true, kendo.data, {
		        GanttDataSource: GanttDataSource,
		        GanttTask: GanttTask,
		        GanttDependencyDataSource: GanttDependencyDataSource,
		        GanttDependency: GanttDependency
		    });
	
		    var editors = {
		        desktop: {
		            dateRange: DATERANGEEDITOR,
		            resources: RESOURCESEDITOR
		        }
		    };
	
		    var Editor = kendo.Observable.extend({
		        init: function(element, options) {
		            kendo.Observable.fn.init.call(this);
	
		            this.element = element;
		            this.options = extend(true, {}, this.options, options);
		            this.createButton = this.options.createButton;
		        },
	
		        fields: function(editors, model) {
		            var that = this;
		            var options = this.options;
		            var messages = options.messages.editor;
		            var resources = options.resources;
		            var fields;
	
		            var click = function(e) {
		                e.preventDefault();
		                resources.editor(that.container.find(DOT + Gantt.styles.popup.resourcesField), model);
		            };
	
		            if (options.editable.template) {
		                fields = $.map(model.fields, function(value, key) {
		                            return { field: key };
		                        });
		            } else {
		                fields = [
		                    { field: "title", title: messages.title },
		                    { field: "start", title: messages.start, editor: editors.dateRange },
		                    { field: "end", title: messages.end, editor: editors.dateRange },
		                    { field: "percentComplete", title: messages.percentComplete, format: PERCENTAGE_FORMAT }
		                ];
	
		                if (model.get(resources.field)) {
		                    fields.push({ field: resources.field, title: messages.resources, messages: messages, editor: editors.resources, click: click, styles: Gantt.styles.popup });
		                }
		            }
	
		            return fields;
		        },
	
		        _buildEditTemplate: function(model, fields, editableFields) {
		            var resources = this.options.resources;
		            var template = this.options.editable.template;
		            var settings = extend({}, kendo.Template, this.options.templateSettings);
		            var paramName = settings.paramName;
		            var popupStyles = Gantt.styles.popup;
		            var html = "";
	
		            if (template) {
		                if (typeof template === STRING) {
		                    template = window.unescape(template);
		                }
	
		                html += (kendo.template(template, settings))(model);
		            } else {
		                for (var i = 0, length = fields.length; i < length; i++) {
		                    var field = fields[i];
	
		                    html += '<div class="' + popupStyles.editLabel + '"><label for="' + field.field + '">' + (field.title || field.field || "") + '</label></div>';
	
		                    if (field.field === resources.field) {
		                        html += '<div class="' + popupStyles.resourcesField + '" style="display:none"></div>';
		                    }
	
		                    if ((!model.editable || model.editable(field.field))) {
		                        editableFields.push(field);
		                        html += '<div ' + kendo.attr("container-for") + '="' + field.field + '" class="' + popupStyles.editField + '"></div>';
		                    } else {
		                        var tmpl = "#:";
	
		                        if (field.field) {
		                            field = kendo.expr(field.field, paramName);
		                            tmpl += field + "==null?'':" + field;
		                        } else {
		                            tmpl += "''";
		                        }
	
		                        tmpl += "#";
	
		                        tmpl = kendo.template(tmpl, settings);
	
		                        html += '<div class="' + popupStyles.editField + '">' + tmpl(model) + '</div>';
		                    }
		                }
		            }
	
		            return html;
		        }
		    });
	
		    var PopupEditor = Editor.extend({
		        destroy: function() {
		            this.close();
		            this.unbind();
		        },
	
		        editTask: function(task) {
		            this.editable = this._createPopupEditor(task);
		        },
	
		        close: function() {
		            var that = this;
	
		            var destroy = function() {
		                if (that.editable) {
		                    that.editable.destroy();
		                    that.editable = null;
		                    that.container = null;
		                }
	
		                if (that.popup) {
		                    that.popup.destroy();
		                    that.popup = null;
		                }
		            };
	
		            if (this.editable && this.container.is(":visible")) {
		                that.trigger("close", { window: that.container });
		                this.container.data("kendoWindow").bind("deactivate", destroy).close();
		            } else {
		                destroy();
		            }
		        },
	
		        showDialog: function(options) {
		            var buttons = options.buttons;
		            var popupStyles = Gantt.styles.popup;
	
		            var html = kendo.format('<div class="{0}"><div class="{1}"><p class="{2}">{3}</p><div class="{4}">',
		                popupStyles.form, popupStyles.formContainer, popupStyles.message, options.text, popupStyles.buttonsContainer);
	
		            for (var i = 0, length = buttons.length; i < length; i++) {
		                html += this.createButton(buttons[i]);
		            }
	
		            html += '</div></div></div>';
	
		            var wrapper = this.element;
	
		            if (this.popup) {
		                this.popup.destroy();
		            }
	
		            var popup = this.popup = $(html).appendTo(wrapper)
		                .eq(0)
		                .on("click", DOT + popupStyles.button, function(e) {
		                    e.preventDefault();
	
		                    popup.close();
	
		                    var buttonIndex = $(e.currentTarget).index();
	
		                    buttons[buttonIndex].click();
		                })
		                .kendoWindow({
		                    modal: true,
		                    autoFocus: false,
		                    resizable: false,
		                    draggable: false,
		                    title: options.title,
		                    visible: false,
		                    deactivate: function() {
		                        this.destroy();
		                        wrapper.focus();
		                    }
		                })
		                .getKendoWindow();
	
		            popup.center().open();
	
		            popup.element.find(".k-primary").focus();
		        },
	
		        _createPopupEditor: function(task) {
		            var that = this;
		            var options = {};
		            var messages = this.options.messages;
		            var ganttStyles = Gantt.styles;
		            var popupStyles = ganttStyles.popup;
	
		            var html = kendo.format('<div {0}="{1}" class="{2} {3}"><div class="{4}">',
		                kendo.attr("uid"), task.uid, popupStyles.form, popupStyles.editForm, popupStyles.formContainer);
	
		            var fields = this.fields(editors.desktop, task);
		            var editableFields = [];
	
		            html += this._buildEditTemplate(task, fields, editableFields);
	
		            html += '<div class="' + popupStyles.buttonsContainer + '">';
		            html += this.createButton({ name: "update", text: messages.save, className: Gantt.styles.primary });
		            html += this.createButton({ name: "cancel", text: messages.cancel });
		            if (that.options.editable.destroy !== false) {
		                html += this.createButton({ name: "delete", text: messages.destroy });
		            }
	
		            html += '</div></div></div>';
	
		            var container = this.container = $(html).appendTo(this.element)
		                .eq(0)
		                .kendoWindow(extend({
		                    modal: true,
		                    resizable: false,
		                    draggable: true,
		                    title: messages.editor.editorTitle,
		                    visible: false,
		                    close: function(e) {
		                        if (e.userTriggered) {
		                            if (that.trigger("cancel", { container: container, model: task })) {
		                                e.preventDefault();
		                            }
		                        }
		                    }
		                }, options));
	
		            var editableWidget = container
		                .kendoEditable({
		                    fields: editableFields,
		                    model: task,
		                    clearContainer: false,
		                    validateOnBlur: true,
		                    target: that.options.target
		                })
		                .data("kendoEditable");
	
		            kendo.cycleForm(container);
	
		            if (!this.trigger("edit", { container: container, model: task })) {
		                container.data("kendoWindow").center().open();
	
		                container.on(CLICK + NS, DOT + ganttStyles.buttonCancel, function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    that.trigger("cancel", { container: container, model: task });
		                });
	
		                container.on(CLICK + NS, DOT + ganttStyles.buttonSave, function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    var fields = that.fields(editors.desktop, task);
		                    var updateInfo = {};
		                    var field;
	
		                    for (var i = 0, length = fields.length; i < length; i++) {
		                        field = fields[i].field;
		                        updateInfo[field] = task.get(field);
		                    }
	
		                    that.trigger("save", { container: container, model: task, updateInfo: updateInfo });
		                });
	
		                container.on(CLICK + NS, DOT + ganttStyles.buttonDelete, function(e) {
		                    e.preventDefault();
		                    e.stopPropagation();
	
		                    that.trigger("remove", { container: container, model: task });
		                });
		            } else {
		                that.trigger("cancel", { container: container, model: task });
		            }
	
		            return editableWidget;
		        }
		    });
	
		    var ResourceEditor = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this.wrapper = this.element;
		            this.model = this.options.model;
		            this.resourcesField = this.options.resourcesField;
		            this.createButton = this.options.createButton;
	
		            this._initContainer();
		            this._attachHandlers();
		        },
	
		        events: [
		            "save"
		        ],
	
		        open: function() {
		            this.window.center().open();
		        },
	
		        close: function() {
		            this.window.bind("deactivate", proxy(this.destroy, this)).close();
		        },
	
		        destroy: function() {
		            this._dettachHandlers();
	
		            this.grid.destroy();
		            this.grid = null;
	
		            this.window.destroy();
		            this.window = null;
	
		            Widget.fn.destroy.call(this);
	
		            kendo.destroy(this.wrapper);
	
		            this.element = this.wrapper = null;
		        },
	
		        _attachHandlers: function() {
		            var ganttStyles = Gantt.styles;
		            var grid = this.grid;
	
		            var closeHandler = this._cancelProxy = proxy(this._cancel, this);
		            this.container.on(CLICK + NS, DOT + ganttStyles.buttonCancel, this._cancelProxy);
	
		            this._saveProxy = proxy(this._save, this);
		            this.container.on(CLICK + NS, DOT + ganttStyles.buttonSave, this._saveProxy);
	
		            this.window.bind("close", function(e) {
		                if (e.userTriggered) {
		                    closeHandler(e);
		                }
		            });
	
		            grid.wrapper.on(CLICK + NS, "input[type='checkbox']", function() {
		                var element = $(this);
		                var row = $(element).closest("tr");
		                var model = grid.dataSource.getByUid(row.attr(kendo.attr("uid")));
		                var value = $(element).is(":checked") ? 1 : "";
	
		                model.set("value", value);
		            });
		        },
	
		        _dettachHandlers: function() {
		            this._cancelProxy = null;
		            this._saveProxy = null;
		            this.container.off(NS);
		            this.grid.wrapper.off();
		        },
	
		        _cancel: function(e) {
		            e.preventDefault();
		            this.close();
		        },
	
		        _save: function(e) {
		            e.preventDefault();
	
		            this._updateModel();
	
		            if (!this.wrapper.is(DOT + Gantt.styles.popup.resourcesField)) {
		                this.trigger("save", { container: this.wrapper, model: this.model });
		            }
	
		            this.close();
		        },
	
		        _initContainer: function() {
		            var that = this;
		            var popupStyles = Gantt.styles.popup;
		            var dom = kendo.format('<div class="{0} {1}"><div class="{2} {3}"/></div>"',
		                popupStyles.form, popupStyles.editForm, popupStyles.formContainer, popupStyles.resourcesFormContainer);
	
		            dom = $(dom);
	
		            this.container = dom.find(DOT + popupStyles.resourcesFormContainer);
	
		            this.window = dom.kendoWindow({
		                modal: true,
		                resizable: false,
		                draggable: true,
		                visible: false,
		                title: this.options.messages.resourcesEditorTitle,
		                open: function() {
		                      that.grid.resize(true);
		                }
		            }).data("kendoWindow");
	
		            this._resourceGrid();
		            this._createButtons();
		        },
	
		        _resourceGrid: function() {
		            var that = this;
		            var messages = this.options.messages;
		            var element = $('<div id="resources-grid"/>').appendTo(this.container);
	
		            this.grid = new kendo.ui.Grid(element, {
		                columns: [
		                    {
		                        field: "name",
		                        title: messages.resourcesHeader,
		                        template:
		                            "<label><input type='checkbox' value='#=name#'" +
		                                "# if (value > 0 && value !== null) {#" +
		                                       "checked='checked'" +
		                                "# } #" +
		                            "/>#=name#</labe>"
		                    },
		                    {
		                        field: "value",
		                        title: messages.unitsHeader,
		                        template: function(dataItem) {
		                            var valueFormat = dataItem.format;
		                            var value = dataItem.value !== null ? dataItem.value : "";
	
		                            return valueFormat ? kendo.toString(value, valueFormat) : value;
		                        }
		                    }
		                ],
		                height: 280,
		                sortable: true,
		                editable: true,
		                filterable: true,
		                dataSource: {
		                    data: that.options.data,
		                    schema: {
		                        model: {
		                            id: "id",
		                            fields: {
		                                id: { from: "id" },
		                                name: { from: "name", type: "string", editable: false},
		                                value: { from: "value", type: "number", validation: this.options.unitsValidation },
		                                format: { from: "format", type: "string" }
		                            }
		                        }
		                    }
		                },
		                save: function(e) {
		                    var value = !!e.values.value;
		                    e.container.parent().find("input[type='checkbox']").prop("checked", value);
		                }
		            });
		        },
	
		        _createButtons: function() {
		            var buttons = this.options.buttons;
		            var html = '<div class="' + Gantt.styles.popup.buttonsContainer + '">';
	
		            for (var i = 0, length = buttons.length; i < length; i++) {
		                html += this.createButton(buttons[i]);
		            }
	
		            html += "</div>";
	
		            this.container.append(html);
		        },
	
		        _updateModel: function() {
		            var resources = [];
		            var value;
		            var data = this.grid.dataSource.data();
	
		            for (var i = 0, length = data.length; i < length; i++) {
		                value = data[i].get("value");
		                if (value !== null && value > 0) {
		                    resources.push(data[i]);
		                }
		            }
	
		            this.model[this.resourcesField] = resources;
		        }
		    });
	
		    var Gantt = Widget.extend({
		        init: function(element, options, events) {
		            if (isArray(options)) {
		                options = { dataSource: options };
		            }
	
		            defaultCommands = {
		                append: {
		                    text: "Add Task",
		                    action: "add",
		                    className: Gantt.styles.toolbar.appendButton,
		                    iconClass: Gantt.styles.toolbar.iconPlus
		                },
		                pdf: {
		                    text: "Export to PDF",
		                    className: Gantt.styles.toolbar.pdfButton,
		                    iconClass: Gantt.styles.toolbar.iconPdf
		                }
		            };
	
		            Widget.fn.init.call(this, element, options);
	
		            if (events) {
		                this._events = events;
		            }
	
		            this._wrapper();
	
		            this._resources();
	
		            if (!this.options.views || !this.options.views.length) {
		                this.options.views = ["day", "week", "month"];
		            }
	
		            this._timeline();
	
		            this._toolbar();
	
		            this._footer();
	
		            this._adjustDimensions();
	
		            // Prevent extra refresh from setting the view
		            this._preventRefresh = true;
	
		            this.view(this.timeline._selectedViewName);
	
		            this._preventRefresh = false;
	
		            this._dataSource();
	
		            this._assignments();
	
		            this._dropDowns();
	
		            this._list();
	
		            this._dependencies();
	
		            this._resizable();
	
		            this._scrollable();
	
		            this._dataBind();
	
		            this._attachEvents();
	
		            this._createEditor();
	
		            kendo.notify(this);
		        },
	
		        events: [
		            "dataBinding",
		            "dataBound",
		            "add",
		            "edit",
		            "remove",
		            "cancel",
		            "save",
		            "change",
		            "navigate",
		            "moveStart",
		            "move",
		            "moveEnd",
		            "resizeStart",
		            "resize",
		            "resizeEnd",
		            "columnResize"
		        ],
	
		        options: {
		            name: "Gantt",
		            autoBind: true,
		            navigatable: false,
		            selectable: true,
		            editable: true,
		            resizable: false,
		            columnResizeHandleWidth: defaultIndicatorWidth,
		            columns: [],
		            views: [],
		            dataSource: {},
		            dependencies: {},
		            resources: {},
		            assignments: {},
		            taskTemplate: null,
		            messages: {
		                save: "Save",
		                cancel: "Cancel",
		                destroy: "Delete",
		                deleteTaskConfirmation: TASK_DELETE_CONFIRM,
		                deleteDependencyConfirmation: DEPENDENCY_DELETE_CONFIRM,
		                deleteTaskWindowTitle: "Delete task",
		                deleteDependencyWindowTitle: "Delete dependency",
		                views: {
		                    day: "Day",
		                    week: "Week",
		                    month: "Month",
		                    year: "Year",
		                    start: "Start",
		                    end: "End"
		                },
		                actions: {
		                    append: "Add Task",
		                    addChild: "Add Child",
		                    insertBefore: "Add Above",
		                    insertAfter: "Add Below",
		                    pdf: "Export to PDF"
		                },
		                editor: {
		                    editorTitle: "Task",
		                    resourcesEditorTitle: "Resources",
		                    title: "Title",
		                    start: "Start",
		                    end: "End",
		                    percentComplete: "Complete",
		                    resources: "Resources",
		                    assignButton: "Assign",
		                    resourcesHeader: "Resources",
		                    unitsHeader: "Units"
		                }
		            },
		            showWorkHours: true,
		            showWorkDays: true,
		            toolbar: null,
		            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
		            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
		            workWeekStart: 1,
		            workWeekEnd: 5,
		            hourSpan: 1,
		            snap: true,
		            height: 600,
		            listWidth: "30%",
		            rowHeight: null
		        },
	
		        select: function(value) {
		            var list = this.list;
	
		            if (!value) {
		                return list.select();
		            }
	
		            list.select(value);
	
		            this.list.element.find("table[role=treegrid]").focus();
		            return;
		        },
	
		        clearSelection: function() {
		            this.list.clearSelection();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            if (this.dataSource) {
		                this.dataSource.unbind("change", this._refreshHandler);
		                this.dataSource.unbind("progress", this._progressHandler);
		                this.dataSource.unbind("error", this._errorHandler);
		            }
	
		            if (this.dependencies) {
		                this.dependencies.unbind("change", this._dependencyRefreshHandler);
		                this.dependencies.unbind("error", this._dependencyErrorHandler);
		            }
	
		            if (this.timeline) {
		                this.timeline.unbind();
		                this.timeline.destroy();
		            }
	
		            if (this.list) {
		                this.list.unbind();
		                this.list.destroy();
		            }
	
		            if (this.footerDropDown) {
		                this.footerDropDown.destroy();
		            }
	
		            if (this.headerDropDown) {
		                this.headerDropDown.destroy();
		            }
	
		            if (this._editor) {
		                this._editor.destroy();
		            }
	
		            if (this._resizeDraggable) {
		                this._resizeDraggable.destroy();
		            }
	
		            this.toolbar.off(NS);
	
		            if (supportsMedia) {
		                this._mediaQuery.removeListener(this._mediaQueryHandler);
		                this._mediaQuery = null;
		            }
	
		            $(window).off("resize" + NS, this._resizeHandler);
		            $(this.wrapper).off(NS);
	
		            this.toolbar = null;
		            this.footer = null;
		        },
	
		        setOptions: function(options) {
		            var newOptions = kendo.deepExtend({}, this.options, options);
	
		            var events = this._events;
	
		            if (!options.views) {
		                var selectedView = this.view().name;
	
		                newOptions.views = $.map(this.options.views, function(view) {
		                    var isSettings = isPlainObject(view);
		                    var name = isSettings ? ((typeof view.type !== "string") ? view.title : view.type) : view;
	
		                    if (selectedView === name) {
		                        if (isSettings) {
		                            view.selected = true;
		                        } else {
		                            view = { type: name, selected: true };
		                        }
		                    } else if (isSettings) {
		                        view.selected = false;
		                    }
	
		                    return view;
		                });
		            }
	
		            if (!options.dataSource) { newOptions.dataSource = this.dataSource; }
		            if (!options.dependencies) { newOptions.dependencies = this.dependencies; }
		            if (!options.resources) { newOptions.resources = this.resources; }
		            if (!options.assignments) { newOptions.assignments = this.assignments; }
	
		            this.destroy();
		            this.element.empty();
		            this.options = null;
	
		            this.init(this.element, newOptions, events);
	
		            Widget.fn._setEvents.call(this, newOptions);
		        },
	
		        _attachEvents: function() {
		            this._resizeHandler = proxy(this.resize, this, false);
		            $(window).on("resize" + NS, this._resizeHandler);
		        },
	
		        _wrapper: function() {
		            var ganttStyles = Gantt.styles;
		            var splitBarHandleClassName = [ganttStyles.icon, ganttStyles.resizeHandle].join(" ");
		            var options = this.options;
		            var height = options.height;
		            var width = options.width;
	
		            this.wrapper = this.element
		                            .addClass(ganttStyles.wrapper)
		                            .append("<div class='" + ganttStyles.listWrapper + "'><div></div></div>")
		                            .append("<div class='" + ganttStyles.splitBarWrapper + "'><div class='" + splitBarHandleClassName + "'></div></div>")
		                            .append("<div class='" + ganttStyles.timelineWrapper + "'><div></div></div>");
	
		            this.wrapper.find(DOT + ganttStyles.list).width(options.listWidth);
	
		            if (height) {
		                this.wrapper.height(height);
		            }
	
		            if (width) {
		                this.wrapper.width(width);
		            }
	
		            if (options.rowHeight) {
		                this.wrapper.addClass(ganttStyles.rowHeight);
		            }
		        },
	
		        _toolbar: function() {
		            var that = this;
		            var ganttStyles = Gantt.styles;
		            var viewsSelector = DOT + ganttStyles.toolbar.views + " > li";
		            var pdfSelector = DOT + ganttStyles.toolbar.pdfButton;
		            var toggleSelector = DOT + ganttStyles.buttonToggle;
		            var contentSelector = DOT + ganttStyles.gridContent;
		            var treelist = $(DOT + ganttStyles.list);
		            var timeline = $(DOT + ganttStyles.timeline);
		            var hoveredClassName = ganttStyles.hovered;
		            var actions = this.options.toolbar;
		            var actionsWrap = $("<div class='" + ganttStyles.toolbar.actions + "'>");
		            var toolbar;
		            var views;
		            var toggleButton;
		            var handler = function(e) {
		                if (e.matches) {
		                    treelist.css({
		                        "display": "none",
		                        "max-width": 0
		                    });
		                } else {
		                    treelist.css({
		                        "display": "inline-block",
		                        "width": "30%",
		                        "max-width": "none"
		                    });
	
		                    timeline.css("display", "inline-block");
	
		                    that.refresh();
	
		                    timeline
		                        .find(contentSelector)
		                        .scrollTop(that.scrollTop);
		                }
	
		                that._resize();
		            };
	
		            if (!isFunction(actions)) {
		                actions = (typeof actions === STRING ? actions : this._actions(actions));
		                actions = proxy(kendo.template(actions), this);
		            }
	
		            toggleButton = $(TOGGLE_BUTTON_TEMPLATE({ styles: ganttStyles.toolbar }));
	
		            views = $(HEADER_VIEWS_TEMPLATE({
		                ns: kendo.ns,
		                views: this.timeline.views,
		                styles: ganttStyles.toolbar
		            }));
	
		            actionsWrap.append(actions({}));
	
		            toolbar = $("<div class='" + ganttStyles.toolbar.headerWrapper + "'>")
		                .append(toggleButton)
		                .append(views)
		                .append(actionsWrap);
	
		            if (views.find("li").length > 1) {
		                views.prepend(VIEWBUTTONTEMPLATE({ styles: ganttStyles.toolbar }));
		            }
	
		            this.wrapper.prepend(toolbar);
		            this.toolbar = toolbar;
	
		            if (supportsMedia) {
		                this._mediaQueryHandler = proxy(handler, this);
		                this._mediaQuery = window.matchMedia("(max-width: 480px)");
		                this._mediaQuery.addListener(this._mediaQueryHandler);
		            }
	
		            toolbar
		                .on(CLICK + NS, viewsSelector, function(e) {
		                    e.preventDefault();
	
		                    var list = that.list;
		                    var name = $(this).attr(kendo.attr("name"));
		                    var currentView = views.find(DOT + ganttStyles.toolbar.currentView);
	
		                    if (currentView.is(":visible")) {
		                        currentView.parent().toggleClass(ganttStyles.toolbar.expanded);
		                    }
	
		                    if (list.editable && list.editable.trigger("validate")) {
		                        return;
		                    }
	
		                    if (!that.trigger("navigate", { view: name })) {
		                        that.view(name);
		                    }
	
		                    that.toolbar.find(DOT + ganttStyles.focused).removeClass(ganttStyles.focused);
		                })
		                .on("keydown" + NS, viewsSelector, function(e) {
		                    var views = $(DOT + ganttStyles.toolbar.views).children(":not(.k-current-view)");
		                    var focusedViewIndex = views.index((that._focusedView && that._focusedView[0]) || views.closest(DOT + ganttStyles.selected)[0]);
	
		                    if (e.keyCode === keys.RIGHT) {
		                        $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
		                        that._focusedView = focusedViewIndex + 1 === views.length ? $(views[0]) : $(views[focusedViewIndex + 1]);
		                        that._focusedView.focus().addClass(ganttStyles.focused);
		                        e.preventDefault();
		                    } else if (e.keyCode === keys.LEFT) {
		                        $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
		                        that._focusedView = focusedViewIndex === 0 ? $(views[views.length - 1]) : $(views[focusedViewIndex - 1]);
		                        that._focusedView.focus().addClass(ganttStyles.focused);
		                        e.preventDefault();
		                    } else if (e.keyCode === keys.DOWN && that.toolbar.find(DOT + ganttStyles.toolbar.currentView).parent().hasClass(ganttStyles.toolbar.expanded)) {
		                        $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
		                        that._focusedView = focusedViewIndex + 1 === views.length ? $(views[0]) : $(views[focusedViewIndex + 1]);
		                        that._focusedView.focus().addClass(ganttStyles.focused);
		                        e.preventDefault();
		                    } else if (e.keyCode === keys.UP && that.toolbar.find(DOT + ganttStyles.toolbar.currentView).parent().hasClass(ganttStyles.toolbar.expanded)) {
		                        $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
		                        that._focusedView = focusedViewIndex === 0 ? $(views[views.length - 1]) : $(views[focusedViewIndex - 1]);
		                        that._focusedView.focus().addClass(ganttStyles.focused);
		                        e.preventDefault();
		                    } else if ((e.keyCode === keys.ENTER || e.keyCode === keys.SPACEBAR) && that._focusedView) {
		                        that.view(that._focusedView.text().toLowerCase());
		                        e.preventDefault();
		                    } else if ((e.keyCode === keys.SPACEBAR || e.keyCode === keys.ENTER || (e.keyCode === keys.DOWN && e.altKey)) && that.toolbar.find(DOT + ganttStyles.toolbar.currentView + " > a").hasClass(ganttStyles.focused)) {
		                        that.toolbar.find(DOT + ganttStyles.toolbar.currentView).parent().toggleClass(ganttStyles.toolbar.expanded);
		                        e.preventDefault();
		                    } else if (e.keyCode === keys.ESC && that.toolbar.find(DOT + ganttStyles.toolbar.currentView).parent().hasClass(ganttStyles.toolbar.expanded)) {
		                        that.toolbar.find(DOT + ganttStyles.toolbar.currentView).parent().toggleClass(ganttStyles.toolbar.expanded).blur();
		                        that._focusedView = null;
		                        that.toolbar.find(DOT + ganttStyles.toolbar.currentView + " > a").addClass(ganttStyles.focused).focus();
		                        e.preventDefault();
		                    } else if (e.keyCode >= 49 && e.keyCode <= 57) {
		                        that.view(that.timeline._viewByIndex(e.keyCode - 49));
		                    }
		                })
		                .on(CLICK + NS, pdfSelector, function(e) {
		                    e.preventDefault();
	
		                    that.saveAsPDF();
		                })
		                .on(CLICK + NS, toggleSelector, function(e) {
		                    e.preventDefault();
	
		                    if (treelist.is(":visible")) {
		                        treelist.css({
		                            "display": "none",
		                            "width": "0"
		                        });
		                        timeline.css({
		                            "display": "inline-block",
		                            "width": "100%"
		                        });
	
		                        that.refresh();
	
		                        timeline
		                            .find(contentSelector)
		                            .scrollTop(that.scrollTop);
		                    } else {
		                        timeline.css({
		                            "display": "none",
		                            "width": 0
		                        });
		                        treelist
		                            .css({
		                                "display": "inline-block",
		                                "width": "100%",
		                                "max-width": "none"
		                            })
		                            .find(contentSelector)
		                            .scrollTop(that.scrollTop);
		                    }
	
		                    that._resize();
		                });
	
		            this.wrapper
		                .on("focusout" + NS, function(e) {
		                    if (!$(e.relatedTarget).closest(DOT + ganttStyles.toolbar.toolbar).length) {
		                        that.toolbar.find(DOT + ganttStyles.focused).removeClass(ganttStyles.focused);
		                    }
		                    if (!$(e.relatedTarget).closest(DOT + ganttStyles.toolbar.views).length) {
		                        that.toolbar.find(DOT + ganttStyles.toolbar.views).removeClass(ganttStyles.toolbar.expanded);
		                    }
		                })
		                .find(DOT + ganttStyles.toolbar.toolbar + " li")
		                .hover(function() {
		                    $(this).addClass(hoveredClassName);
		                }, function() {
		                    $(this).removeClass(hoveredClassName);
		                });
	
		        },
	
		        _actions: function() {
		            var options = this.options;
		            var editable = options.editable;
		            var actions = options.toolbar;
		            var html = "";
	
		            if (!isArray(actions)) {
		                if (editable && editable.create !== false) {
		                    actions = ["append"];
		                } else {
		                    return html;
		                }
		            }
	
		            for (var i = 0, length = actions.length; i < length; i++) {
		                html += this._createButton(actions[i]);
		            }
	
		            return html;
		        },
	
		        _footer: function() {
		            var editable = this.options.editable;
	
		            if (!editable || editable.create === false) {
		                return;
		            }
	
		            var ganttStyles = Gantt.styles.toolbar;
		            var messages = this.options.messages.actions;
		            var button = $(kendo.template(BUTTON_TEMPLATE)(extend(true, { styles: ganttStyles }, defaultCommands.append, { text: messages.append })));
		            var actionsWrap = $("<div class='" + ganttStyles.actions + "'>").append(button);
		            var footer = $("<div class='" + ganttStyles.footerWrapper + "'>").append(actionsWrap);
	
		            this.wrapper.append(footer);
		            this.footer = footer;
		        },
	
		        _createButton: function(command) {
		            var template = command.template || BUTTON_TEMPLATE;
		            var messages = this.options.messages.actions;
		            var commandName = typeof command === STRING ? command : command.name || command.text;
		            var className = defaultCommands[commandName] ? defaultCommands[commandName].className : "k-gantt-" + (commandName || "").replace(/\s/g, "");
		            var options = {
		                iconClass: "",
		                action: "",
		                text: commandName,
		                className: className,
		                styles: Gantt.styles.toolbar
		            };
	
		            if (!commandName && !(isPlainObject(command) && command.template))  {
		                throw new Error("Custom commands should have name specified");
		            }
	
		            options = extend(true, options, defaultCommands[commandName], { text: messages[commandName] });
	
		            if (isPlainObject(command)) {
		                if (command.className && inArray(options.className, command.className.split(" ")) < 0) {
		                    command.className += " " + options.className;
		                }
	
		                options = extend(true, options, command);
		            }
	
		            return kendo.template(template)(options);
		        },
	
		        _adjustDimensions: function() {
		            var element = this.element;
		            var ganttStyles = Gantt.styles;
		            var listSelector = DOT + ganttStyles.list;
		            var timelineSelector = DOT + ganttStyles.timeline;
		            var splitBarSelector = DOT + ganttStyles.splitBar;
		            var toolbarHeight = outerHeight(this.toolbar);
		            var footerHeight = this.footer ? outerHeight(this.footer) : 0;
		            var totalHeight = element.height();
		            var totalWidth = element.width();
		            var splitBarWidth = outerWidth(element.find(splitBarSelector));
		            var treeListWidth = outerWidth(element.find(listSelector));
	
		            element
		                .children([listSelector, timelineSelector, splitBarSelector].join(","))
		                .height(totalHeight - (toolbarHeight + footerHeight))
		                .end()
		                .children(timelineSelector)
		                .width(totalWidth - (splitBarWidth + treeListWidth));
	
		            if (totalWidth < (treeListWidth + splitBarWidth)) {
		                element.find(listSelector).width(totalWidth - splitBarWidth);
		            }
		        },
	
		        _scrollTo: function(value) {
		            var view = this.timeline.view();
		            var list = this.list;
		            var attr = kendo.attr("uid");
		            var id = typeof value === "string" ? value :
		                value.closest("tr" + selector()).attr(attr);
		            var action;
		            var scrollTarget;
		            var scrollIntoView = function() {
		                if (scrollTarget.length !== 0) {
		                    action();
		                }
		            };
	
		            if (view.content.is(":visible")) {
		                scrollTarget = view.content.find(selector(id));
		                action = function() {
		                    view._scrollTo(scrollTarget);
		                };
		            } else {
		                scrollTarget = list.content.find(selector(id));
		                action = function() {
		                    scrollTarget.get(0).scrollIntoView();
		                };
		            }
	
		            scrollIntoView();
		        },
	
		        _dropDowns: function() {
		            var that = this;
		            var actionsSelector = DOT + Gantt.styles.toolbar.actions;
		            var actionMessages = this.options.messages.actions;
		            var timeline = this.timeline;
		            var editable = this.options.editable;
	
		            var handler = function(e) {
		                var type = e.type;
		                var orderId;
		                var dataSource = that.dataSource;
		                var task = dataSource._createNewModel();
		                var selected = that.dataItem(that.select());
		                var parent = dataSource.taskParent(selected);
		                var firstSlot = timeline.view()._timeSlots()[0];
		                var target = type === "add" ? selected : parent;
		                var editable = that.list.editable;
	
		                if (editable && editable.trigger("validate")) {
		                    return;
		                }
	
		                task.set("title", "New task");
	
		                if (target) {
		                    task.set("parentId", target.get("id"));
		                    task.set("start", target.get("start"));
		                    task.set("end", target.get("end"));
		                } else {
		                    task.set("start", firstSlot.start);
		                    task.set("end", firstSlot.end);
		                }
	
		                if (type !== "add") {
		                    orderId = selected.get("orderId");
		                    orderId = type === "insert-before" ? orderId : orderId + 1;
		                }
	
		                that._createTask(task, orderId);
		            };
	
		            if (!editable || editable.create === false) {
		                return;
		            }
	
		            this.footerDropDown = new TaskDropDown(this.footer.children(actionsSelector).eq(0), {
		                messages: {
		                    actions: actionMessages
		                },
		                direction: "up",
		                animation: {
		                    open: {
		                        effects: "slideIn:up"
		                    }
		                },
		                navigatable: that.options.navigatable
		            });
	
		            this.headerDropDown = new TaskDropDown(this.toolbar.children(actionsSelector).eq(0), {
		                messages: {
		                    actions: actionMessages
		                },
		                navigatable: that.options.navigatable
		            });
	
		            this.footerDropDown.bind("command", handler);
		            this.headerDropDown.bind("command", handler);
		        },
	
		        _list: function() {
		            var that = this;
		            var navigatable = that.options.navigatable;
		            var ganttStyles = Gantt.styles;
		            var listWrapper = this.wrapper.find(DOT + ganttStyles.list);
		            var element = listWrapper.find("> div");
		            var toggleButtons = this.wrapper.find(DOT + ganttStyles.toolbar.actions + " > button");
		            var options = {
		                columns: this.options.columns || [],
		                dataSource: this.dataSource,
		                selectable: this.options.selectable,
		                editable: this.options.editable,
		                resizable: this.options.resizable,
		                columnResizeHandleWidth: this.options.columnResizeHandleWidth,
		                listWidth: outerWidth(listWrapper),
		                resourcesField: this.resources.field,
		                rowHeight: this.options.rowHeight
		            };
		            var columns = options.columns;
		            var column;
		            var restoreFocus = function() {
		                if (navigatable) {
		                    that._current(that._cachedCurrent);
	
		                    focusTable(that.list.content.find("table"), true);
		                }
	
		                delete that._cachedCurrent;
		            };
	
		            for (var i = 0; i < columns.length; i++) {
		                column = columns[i];
	
		                if (column.field === this.resources.field && typeof column.editor !== "function") {
		                    column.editor = proxy(this._createResourceEditor, this);
		                }
		            }
	
		            this.list = new kendo.ui.GanttList(element, options);
	
		            this.list
		                .bind("render", function() {
		                    that._navigatable();
		                 }, true)
		                .bind("edit", function(e) {
		                    that._cachedCurrent = e.cell;
	
		                    if (that.trigger("edit", { task: e.model, container: e.cell })) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("cancel", function(e) {
		                    if (that.trigger("cancel", { task: e.model, container: e.cell })) {
		                        e.preventDefault();
		                    }
		                    restoreFocus();
		                })
		                .bind("update", function(e) {
		                    that._updateTask(e.task, e.updateInfo);
		                    restoreFocus();
		                })
		                .bind("change", function() {
		                    that.trigger("change");
	
		                    var selection = that.list.select();
	
		                    if (selection.length) {
		                        toggleButtons.removeAttr("data-action", "add");
		                        that.timeline.select("[data-uid='" + selection.attr("data-uid") + "']");
		                    } else {
		                        toggleButtons.attr("data-action", "add");
		                        that.timeline.clearSelection();
		                    }
		                })
		                .bind("columnResize", function(e) {
		                    that.trigger("columnResize", { column: e.column, oldWidth: e.oldWidth, newWidth: e.newWidth });
		                });
		        },
	
		        _timeline: function() {
		            var that = this;
		            var ganttStyles = Gantt.styles;
		            var options = trimOptions(extend(true, { resourcesField: this.resources.field }, this.options));
		            var element = this.wrapper.find(DOT + ganttStyles.timeline + " > div");
		            var currentViewSelector = DOT + ganttStyles.toolbar.currentView + " > " + DOT + ganttStyles.toolbar.link;
	
		            this.timeline = new kendo.ui.GanttTimeline(element, options);
	
		            this.timeline
		                .bind("navigate", function(e) {
		                    var viewName = e.view.replace(/\./g, "\\.").toLowerCase();
	
		                    var text = that.toolbar
		                        .find(DOT + ganttStyles.toolbar.views +" > li")
		                        .removeClass(ganttStyles.selected)
		                        .end()
		                        .find(DOT + ganttStyles.toolbar.viewButton + "-" + viewName)
		                        .addClass(ganttStyles.selected)
		                        .find(DOT + ganttStyles.toolbar.link)
		                        .text();
	
		                    that.toolbar
		                        .find(currentViewSelector)
		                        .text(text);
	
		                    that.refresh();
		                })
		                .bind("moveStart", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable && editable.trigger("validate")) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    if (that.trigger("moveStart", { task: e.task })) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("move", function(e) {
		                    var task = e.task;
		                    var start = e.start;
		                    var end = new Date(start.getTime() + task.duration());
	
		                    if (that.trigger("move", { task: task, start: start, end: end })) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("moveEnd", function(e) {
		                    var task = e.task;
		                    var start = e.start;
		                    var end = new Date(start.getTime() + task.duration());
	
		                    if (!that.trigger("moveEnd", { task: task, start: start, end: end })) {
		                        that._updateTask(that.dataSource.getByUid(task.uid), {
		                            start: start,
		                            end: end
		                        });
		                    }
		                })
		                .bind("resizeStart", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable && editable.trigger("validate")) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    if (that.trigger("resizeStart", { task: e.task })) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("resize", function(e) {
		                    if (that.trigger("resize", { task: e.task, start: e.start, end: e.end })) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("resizeEnd", function(e) {
		                    var task = e.task;
		                    var updateInfo = {};
	
		                    if (e.resizeStart) {
		                        updateInfo.start = e.start;
		                    } else {
		                        updateInfo.end = e.end;
		                    }
	
		                    if (!that.trigger("resizeEnd", { task: task, start: e.start, end: e.end })) {
		                        that._updateTask(that.dataSource.getByUid(task.uid), updateInfo);
		                    }
		                })
		                .bind("percentResizeStart", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable && editable.trigger("validate")) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("percentResizeEnd", function(e) {
		                    that._updateTask(that.dataSource.getByUid(e.task.uid), { percentComplete: e.percentComplete });
		                })
		                .bind("dependencyDragStart", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable && editable.trigger("validate")) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("dependencyDragEnd", function(e) {
		                    var dependency = that.dependencies._createNewModel({
		                        type: e.type,
		                        predecessorId: e.predecessor.id,
		                        successorId: e.successor.id
		                    });
	
		                    that._createDependency(dependency);
		                })
		                .bind("select", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable) {
		                        editable.trigger("validate");
		                    }
	
		                    that.select("[data-uid='" + e.uid + "']");
		                })
		                .bind("editTask", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable && editable.trigger("validate")) {
		                        return;
		                    }
	
		                    that.editTask(e.uid);
		                })
		                .bind("clear", function() {
		                    that.clearSelection();
		                })
		                .bind("removeTask", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable && editable.trigger("validate")) {
		                        return;
		                    }
	
		                    that.removeTask(that.dataSource.getByUid(e.uid));
		                })
		                .bind("removeDependency", function(e) {
		                    var editable = that.list.editable;
	
		                    if (editable && editable.trigger("validate")) {
		                        return;
		                    }
	
		                    that.removeDependency(that.dependencies.getByUid(e.uid));
		                });
		        },
	
		        _dataSource: function() {
		            var options = this.options;
		            var dataSource = options.dataSource;
	
		            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;
	
		            if (this.dataSource && this._refreshHandler) {
		                this.dataSource
		                    .unbind("change", this._refreshHandler)
		                    .unbind("progress", this._progressHandler)
		                    .unbind("error", this._errorHandler);
		            } else {
		                this._refreshHandler = proxy(this.refresh, this);
		                this._progressHandler = proxy(this._requestStart, this);
		                this._errorHandler = proxy(this._error, this);
		            }
	
		            this.dataSource = kendo.data.GanttDataSource.create(dataSource)
		                .bind("change", this._refreshHandler)
		                .bind("progress", this._progressHandler)
		                .bind("error", this._errorHandler);
		        },
	
		        _dependencies: function() {
		            var dependencies = this.options.dependencies || {};
		            var dataSource = isArray(dependencies) ? { data: dependencies } : dependencies;
	
		            if (this.dependencies && this._dependencyRefreshHandler) {
		                this.dependencies
		                    .unbind("change", this._dependencyRefreshHandler)
		                    .unbind("error", this._dependencyErrorHandler);
		            } else {
		                this._dependencyRefreshHandler = proxy(this.refreshDependencies, this);
		                this._dependencyErrorHandler = proxy(this._error, this);
		            }
	
		            this.dependencies = kendo.data.GanttDependencyDataSource.create(dataSource)
		                .bind("change", this._dependencyRefreshHandler)
		                .bind("error", this._dependencyErrorHandler);
		        },
	
		        _resources: function() {
		            var resources = this.options.resources;
		            var dataSource = resources.dataSource || {};
	
		            this.resources = {
		                field: "resources",
		                dataTextField: "name",
		                dataColorField: "color",
		                dataFormatField: "format"
		            };
	
		            extend(this.resources, resources);
	
		            this.resources.dataSource = kendo.data.DataSource.create(dataSource);
		        },
	
		        _assignments: function() {
		            var assignments = this.options.assignments;
		            var dataSource = assignments.dataSource || { };
	
		            if (this.assignments) {
		                this.assignments.dataSource
		                    .unbind("change", this._assignmentsRefreshHandler);
		            } else {
		                this._assignmentsRefreshHandler = proxy(this.refresh, this);
		            }
	
		            this.assignments = {
		                dataTaskIdField: "taskId",
		                dataResourceIdField: "resourceId",
		                dataValueField: "value"
		            };
	
		            extend(this.assignments, assignments);
	
		            this.assignments.dataSource = kendo.data.DataSource.create(dataSource);
	
		            this.assignments.dataSource.
		                bind("change", this._assignmentsRefreshHandler);
		        },
	
		        _createEditor: function() {
		            var that = this;
	
		            var editor = this._editor = new PopupEditor(this.wrapper, extend({}, this.options, {
		                target: this,
		                resources: {
		                    field: this.resources.field,
		                    editor: proxy(this._createResourceEditor, this)
		                },
		                createButton: proxy(this._createPopupButton, this)
		            }));
	
		            editor
		                .bind("cancel", function(e) {
		                    var task = that.dataSource.getByUid(e.model.uid);
	
		                    if (that.trigger("cancel", { container: e.container, task: task })) {
		                        e.preventDefault();
		                        return;
		                    }
	
		                    that.cancelTask();
		                })
		                .bind("edit", function(e) {
		                    var task = that.dataSource.getByUid(e.model.uid);
	
		                    if (that.trigger("edit", { container: e.container, task: task })) {
		                        e.preventDefault();
		                    }
		                })
		                .bind("save", function(e) {
		                    var task = that.dataSource.getByUid(e.model.uid);
	
		                    that.saveTask(task, e.updateInfo);
		                })
		                .bind("remove", function(e) {
		                    that.removeTask(e.model.uid);
		                })
		                .bind("close", that._onDialogClose);
		        },
	
		        _onDialogClose: function() {},
	
		        _createResourceEditor: function(container, options) {
		            var that = this;
		            var model = options instanceof ObservableObject ? options : options.model;
		            var id = model.get("id");
		            var messages = this.options.messages;
		            var resourcesField = this.resources.field;
		            var unitsValidation = { step: 0.01 };
		            var assignmentsModel = this.assignments.dataSource.options.schema.model;
	
		            if (assignmentsModel && assignmentsModel.fields.Units && assignmentsModel.fields.Units.validation) {
		                extend(true, unitsValidation, assignmentsModel.fields.Units.validation);
		            }
	
		            var editor = this._resourceEditor = new ResourceEditor(container, {
		                resourcesField: resourcesField,
		                unitsValidation: unitsValidation,
		                data: this._wrapResourceData(id),
		                model: model,
		                messages: extend({}, messages.editor),
		                buttons: [
		                    { name: "update", text: messages.save, className: Gantt.styles.primary },
		                    { name: "cancel", text: messages.cancel }
		                ],
		                createButton: proxy(this._createPopupButton, this),
		                save: function(e) {
		                    that._updateAssignments(e.model.get("id"), e.model.get(resourcesField));
		                }
		            });
	
		            editor.open();
		        },
	
		        _createPopupButton: function(command) {
		            var commandName = command.name || command.text;
		            var options = {
		                className: Gantt.styles.popup.button + " k-gantt-" + (commandName || "").replace(/\s/g, ""),
		                text: commandName,
		                attr: ""
		            };
	
		            if (!commandName && !(isPlainObject(command) && command.template))  {
		                throw new Error("Custom commands should have name specified");
		            }
	
		            if (isPlainObject(command)) {
		                if (command.className) {
		                    command.className += " " + options.className;
		                }
	
		                options = extend(true, options, command);
		            }
	
		            return kendo.template(COMMAND_BUTTON_TEMPLATE)(options);
		        },
	
		        view: function(type) {
		            return this.timeline.view(type);
		        },
	
		        range: function (range) {
		            var dataSource = this.dataSource;
		            var view = this.view();
		            var timeline = this.timeline;
	
		            if (range) {
		                view.options.range = {
		                    start: range.start,
		                    end: range.end
		                };
	
		                timeline._render(dataSource.taskTree());
		                timeline._renderDependencies(this.dependencies.view());
		            }
	
		            return {
		                start: view.start,
		                end: view.end
		            };
		        },
	
		        date: function (date) {
		            var view = this.view();
	
		            if (date) {
		                view.options.date = date;
		                view._scrollToDate(date);
		            }
	
		            return view.options.date;
		        },
	
		        dataItem: function(value) {
		            if (!value) {
		                return null;
		            }
	
		            var list = this.list;
		            var element = list.content.find(value);
	
		            return list._modelFromElement(element);
		        },
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
	
		            this._dataSource();
	
		            this.list._setDataSource(this.dataSource);
	
		            if (this.options.autoBind) {
		                dataSource.fetch();
		            }
		        },
	
		        setDependenciesDataSource: function(dependencies) {
		            this.options.dependencies = dependencies;
	
		            this._dependencies();
	
		            if (this.options.autoBind) {
		                dependencies.fetch();
		            }
		        },
	
		        items: function() {
		            return this.wrapper.children(".k-task");
		        },
	
		        _updateAssignments: function(id, resources) {
		            var dataSource = this.assignments.dataSource;
		            var taskId = this.assignments.dataTaskIdField;
		            var resourceId = this.assignments.dataResourceIdField;
		            var hasMatch = false;
		            var assignments = new Query(dataSource.view())
		                .filter({
		                    field: taskId,
		                    operator: "eq",
		                    value: id
		                }).toArray();
		            var assignment;
		            var resource;
		            var value;
	
		            while (assignments.length) {
		                assignment = assignments[0];
	
		                for (var i = 0, length = resources.length; i < length; i++) {
		                    resource = resources[i];
	
		                    if (assignment.get(resourceId) === resource.get("id")) {
		                        value = resources[i].get("value");
		                        this._updateAssignment(assignment, value);
		                        resources.splice(i, 1);
		                        hasMatch = true;
		                        break;
		                    }
		                }
	
		                if (!hasMatch) {
		                    this._removeAssignment(assignment);
		                }
	
		                hasMatch = false;
	
		                assignments.shift();
		            }
	
		            for (var j = 0, newLength = resources.length; j < newLength; j++) {
		                resource = resources[j];
		                this._createAssignment(resource, id);
		            }
	
		            dataSource.sync();
		        },
	
		        cancelTask: function() {
		            var editor = this._editor;
		            var container = editor.container;
	
		            if (container) {
		                editor.close();
		            }
		        },
	
		        editTask: function(uid) {
		            var task = typeof uid === "string" ? this.dataSource.getByUid(uid) : uid;
	
		            if (!task) {
		                return;
		            }
	
		            var taskCopy = this.dataSource._createNewModel(task.toJSON());
		            taskCopy.uid = task.uid;
	
		            this.cancelTask();
	
		            this._editTask(taskCopy);
		        },
	
		        _editTask: function(task) {
		            this._editor.editTask(task);
		        },
	
		        saveTask: function(task, updateInfo) {
		            var editor = this._editor;
		            var container = editor.container;
		            var editable = editor.editable;
	
		            if (container && editable && editable.end()) {
		                this._updateTask(task, updateInfo);
		            }
		        },
	
		        _updateTask: function(task, updateInfo) {
		            var resourcesField = this.resources.field;
	
		            if (!this.trigger("save", { task: task, values: updateInfo })) {
		                this._preventRefresh = true;
	
		                this.dataSource.update(task, updateInfo);
	
		                if (updateInfo[resourcesField]) {
		                    this._updateAssignments(task.get("id"), updateInfo[resourcesField]);
		                }
	
		                this._syncDataSource();
		            }
		        },
	
		        _updateAssignment: function(assignment, value) {
		            var resourceValueField = this.assignments.dataValueField;
	
		            assignment.set(resourceValueField, value);
		        },
	
		        removeTask: function(uid) {
		            var that = this;
		            var task = typeof uid === "string" ? this.dataSource.getByUid(uid) : uid;
	
		            if (!task) {
		                return;
		            }
	
		            this._taskConfirm(function(cancel) {
		                if (!cancel) {
		                    that._removeTask(task);
		                }
		            }, task);
		        },
	
		        _createTask: function(task, index) {
		            if (!this.trigger("add", {
		                task: task,
		                dependency: null
		            })) {
		                var dataSource = this.dataSource;
	
		                this._preventRefresh = true;
	
		                if (index === undefined) {
		                    dataSource.add(task);
		                } else {
		                    dataSource.insert(index, task);
		                }
	
		                this._scrollToUid = task.uid;
		                this._syncDataSource();
		            }
		        },
	
		        _createDependency: function(dependency) {
		            if (!this.trigger("add", {
		                task: null,
		                dependency: dependency
		            })) {
		                this._preventDependencyRefresh = true;
	
		                this.dependencies.add(dependency);
	
		                this._preventDependencyRefresh = false;
	
		                this.dependencies.sync();
		            }
		        },
	
		        _createAssignment: function(resource, id) {
		            var assignments = this.assignments;
		            var dataSource = assignments.dataSource;
		            var taskId = assignments.dataTaskIdField;
		            var resourceId = assignments.dataResourceIdField;
		            var resourceValue = assignments.dataValueField;
		            var assignment = dataSource._createNewModel();
	
		            assignment[taskId] = id;
		            assignment[resourceId] = resource.get("id");
		            assignment[resourceValue] = resource.get("value");
	
		            dataSource.add(assignment);
		        },
	
		        removeDependency: function(uid) {
		            var that = this;
		            var dependency = typeof uid === "string" ? this.dependencies.getByUid(uid) : uid;
	
		            if (!dependency) {
		                return;
		            }
	
		            this._dependencyConfirm(function(cancel) {
		                if (!cancel) {
		                    that._removeDependency(dependency);
		                }
		            }, dependency);
		        },
	
		        _removeTaskDependencies: function(task, dependencies) {
		            this._preventDependencyRefresh = true;
	
		            for (var i = 0, length = dependencies.length; i < length; i++) {
		                this.dependencies.remove(dependencies[i]);
		            }
	
		            this._preventDependencyRefresh = false;
	
		            this.dependencies.sync();
		        },
	
		        _removeTaskAssignments: function(task) {
		            var dataSource = this.assignments.dataSource;
		            var assignments = dataSource.view();
		            var filter = {
		                field: this.assignments.dataTaskIdField,
		                operator: "eq",
		                value: task.get("id")
		            };
	
		            assignments = new Query(assignments).filter(filter).toArray();
	
		            this._preventRefresh = true;
	
		            for (var i = 0, length = assignments.length; i < length; i++) {
		                dataSource.remove(assignments[i]);
		            }
	
		            this._preventRefresh = false;
	
		            dataSource.sync();
		        },
	
		        _removeTask: function(task) {
		            var dependencies = this.dependencies.dependencies(task.id);
	
		            if (!this.trigger("remove", {
		                task: task,
		                dependencies: dependencies
		            })) {
		                this._removeTaskDependencies(task, dependencies);
		                this._removeTaskAssignments(task);
	
		                this._preventRefresh = true;
	
		                if (this.dataSource.remove(task)) {
		                    this._syncDataSource();
		                }
	
		                this._preventRefresh = false;
		            }
		        },
	
		        _removeDependency: function(dependency) {
		            if (!this.trigger("remove", {
		                task: null,
		                dependencies: [dependency]
		            })) {
		                if (this.dependencies.remove(dependency)) {
		                    this.dependencies.sync();
		                }
		            }
		        },
	
		        _removeAssignment: function(assignment) {
		            this.assignments.dataSource.remove(assignment);
		        },
	
		        _taskConfirm: function(callback, task) {
		            var messages = this.options.messages;
	
		            this._confirm(callback, {
		                model: task,
		                text: messages.deleteTaskConfirmation,
		                title: messages.deleteTaskWindowTitle
		            });
		        },
	
		        _dependencyConfirm: function(callback, dependency) {
		            var messages = this.options.messages;
	
		            this._confirm(callback, {
		                model: dependency,
		                text: messages.deleteDependencyConfirmation,
		                title: messages.deleteDependencyWindowTitle
		            });
		        },
	
		        _confirm: function(callback, options) {
		            var editable = this.options.editable;
		            var messages;
		            var buttons;
	
		            if (editable === true || editable.confirmation !== false) {
		                messages = this.options.messages;
		                buttons = [
		                    { name: "delete", text: messages.destroy, className: Gantt.styles.primary, click: function() { callback(); } },
		                    { name: "cancel", text: messages.cancel, click: function() { callback(true); } }
		                ];
	
		                this.showDialog(extend(true, {}, options, { buttons: buttons }));
		            } else {
		                callback();
		            }
		        },
	
		        showDialog: function(options) {
		            this._editor.showDialog(options);
		        },
	
		        refresh: function() {
		            if (this._preventRefresh || this.list.editable) {
		                return;
		            }
	
		            this._progress(false);
	
		            var dataSource = this.dataSource;
		            var taskTree = dataSource.taskTree();
		            var scrollToUid = this._scrollToUid;
		            var current;
		            var cachedUid;
		            var cachedIndex = -1;
	
		            if (this.current) {
		                cachedUid = this.current.closest("tr").attr(kendo.attr("uid"));
		                cachedIndex = this.current.index();
		            }
	
		            if (this.trigger("dataBinding")) {
		                return;
		            }
	
		            if (this.resources.dataSource.data().length !== 0) {
		                this._assignResources(taskTree);
		            }
	
		            if (this._editor) {
		                this._editor.close();
		            }
	
		            this.clearSelection();
		            this.list._render(taskTree);
		            this.timeline._render(taskTree);
		            this.timeline._renderDependencies(this.dependencies.view());
	
		            if (scrollToUid) {
		                this._scrollTo(scrollToUid);
		                this.select(selector(scrollToUid));
		            }
	
		            if ((scrollToUid || cachedUid) && cachedIndex >= 0) {
		                current = this.list.content
		                    .find("tr" + selector((scrollToUid || cachedUid)) + " > td:eq(" + cachedIndex + ")");
	
		                this._current(current);
		            }
	
		            this._scrollToUid = null;
	
		            this.trigger("dataBound");
		        },
	
		        refreshDependencies: function() {
		            if (this._preventDependencyRefresh) {
		                return;
		            }
	
		            if (this.trigger("dataBinding")) {
		                return;
		            }
	
		            this.timeline._renderDependencies(this.dependencies.view());
	
		            this.trigger("dataBound");
		        },
	
		        _assignResources: function(taskTree) {
		            var resources = this.resources;
		            var assignments = this.assignments;
		            var groupAssigments = function() {
		                var data = assignments.dataSource.view();
		                var group = {
		                    field: assignments.dataTaskIdField
		                };
	
		                data = new Query(data).group(group).toArray();
	
		                return data;
		            };
		            var assigments = groupAssigments();
		            var applyTaskResource = function(task, action) {
		                var taskId = task.get("id");
	
		                kendo.setter(resources.field)(task, new ObservableArray([]));
	
		                for (var i = 0, length = assigments.length; i < length; i++) {
		                    if (assigments[i].value === taskId) {
		                        action(task, assigments[i].items);
		                    }
		                }
		            };
		            var wrapTask = function(task, items) {
		                for (var j = 0, length = items.length; j < length; j++) {
		                    var item = items[j];
		                    var resource = resources.dataSource.get(item.get(assignments.dataResourceIdField));
		                    var resourceValue = item.get(assignments.dataValueField);
		                    var resourcedId = item.get(assignments.dataResourceIdField);
		                    var valueFormat = resource.get(resources.dataFormatField) || PERCENTAGE_FORMAT;
		                    var formatedValue = kendo.toString(resourceValue, valueFormat);
	
		                    task[resources.field].push(new ObservableObject({
		                        id: resourcedId,
		                        name: resource.get(resources.dataTextField),
		                        color: resource.get(resources.dataColorField),
		                        value: resourceValue,
		                        formatedValue: formatedValue
		                    }));
		                }
		            };
	
		            for (var i = 0, length = taskTree.length; i < length; i++) {
		                applyTaskResource(taskTree[i], wrapTask);
		            }
		        },
	
		        _wrapResourceData: function(id) {
		            var that = this;
		            var result = [];
		            var resource;
		            var resources = this.resources.dataSource.view();
		            var assignments = this.assignments.dataSource.view();
		            var taskAssignments = new Query(assignments).filter({
		                field: that.assignments.dataTaskIdField,
		                operator: "eq",
		                value: id
		            }).toArray();
		            var valuePerResource = function(id) {
		                var resourceValue = null;
	
		                new Query(taskAssignments).filter({
		                    field: that.assignments.dataResourceIdField,
		                    operator: "eq",
		                    value: id
		                }).select(function(assignment) {
		                    resourceValue += assignment.get(that.assignments.dataValueField);
		                });
	
		                return resourceValue;
		            };
	
		            for (var i = 0, length = resources.length; i < length; i++) {
		                resource = resources[i];
		                result.push({
		                    id: resource.get("id"),
		                    name: resource.get(that.resources.dataTextField),
		                    format: resource.get(that.resources.dataFormatField) || PERCENTAGE_FORMAT,
		                    value: valuePerResource(resource.id)
		                });
		            }
	
		            return result;
		        },
	
		        _syncDataSource: function() {
		            this._preventRefresh = false;
		            this._requestStart();
		            this.dataSource.sync();
		        },
	
		        _requestStart: function() {
		            this._progress(true);
		        },
	
		        _error: function() {
		            this._progress(false);
		        },
	
		        _progress: function(toggle) {
		            kendo.ui.progress(this.element, toggle);
		        },
	
		        _resizable: function() {
		            var that = this;
		            var wrapper = this.wrapper;
		            var ganttStyles = Gantt.styles;
		            var contentSelector = DOT + ganttStyles.gridContent;
		            var treeListWrapper = wrapper.find(DOT + ganttStyles.list);
		            var timelineWrapper = wrapper.find(DOT + ganttStyles.timeline);
		            var treeListWidth;
		            var timelineWidth;
		            var timelineScroll;
	
		            this._resizeDraggable = wrapper
		                .find(DOT + ganttStyles.splitBar)
		                .height(treeListWrapper.height())
		                .hover(function () {
		                    $(this).addClass(ganttStyles.splitBarHover);
		                }, function () {
		                    $(this).removeClass(ganttStyles.splitBarHover);
		                })
		                .end()
		                .kendoResizable({
		                    orientation: "horizontal",
		                    handle: DOT + ganttStyles.splitBar,
		                    "start": function () {
		                        treeListWidth = treeListWrapper.width();
		                        timelineWidth = timelineWrapper.width();
		                        timelineScroll = timelineWrapper.find(contentSelector).scrollLeft();
		                    },
		                    "resize": function(e) {
		                        var delta = e.x.initialDelta;
	
		                        if (kendo.support.isRtl(wrapper)) {
		                            delta *= -1;
		                        }
	
		                        if (treeListWidth + delta < 0 || timelineWidth - delta < 0) {
		                            return;
		                        }
	
		                        treeListWrapper.width(treeListWidth + delta);
		                        timelineWrapper.width(timelineWidth - delta);
		                        timelineWrapper.find(contentSelector).scrollLeft(timelineScroll + delta);
	
		                        that.timeline.view()._renderCurrentTime();
		                    }
		                }).data("kendoResizable");
		        },
	
		        _scrollable: function() {
		            var that = this;
		            var ganttStyles = Gantt.styles;
		            var contentSelector = DOT + ganttStyles.gridContent;
		            var headerSelector = DOT + ganttStyles.gridHeaderWrap;
		            var timelineHeader = this.timeline.element.find(headerSelector);
		            var timelineContent = this.timeline.element.find(contentSelector);
		            var treeListHeader = this.list.element.find(headerSelector);
		            var treeListContent = this.list.element.find(contentSelector);
	
		            if (mobileOS) {
		                treeListContent.css("overflow-y", "auto");
		            }
	
		            timelineContent.on("scroll", function() {
		                that.scrollTop = this.scrollTop;
		                timelineHeader.scrollLeft(this.scrollLeft);
		                treeListContent.scrollTop(this.scrollTop);
		            });
	
		            treeListContent
		                .on("scroll", function() {
		                    treeListHeader.scrollLeft(this.scrollLeft);
		                })
		                .on("DOMMouseScroll" + NS + " mousewheel" + NS, function(e) {
		                    var scrollTop = timelineContent.scrollTop();
		                    var delta = kendo.wheelDeltaY(e);
	
		                    if (delta) {
		                        e.preventDefault();
		                        //In Firefox DOMMouseScroll event cannot be canceled
		                        $(e.currentTarget).one("wheel" + NS, false);
	
		                        timelineContent.scrollTop(scrollTop + (-delta));
		                    }
		                });
		        },
	
		        _navigatable: function() {
		            var that = this;
		            var navigatable = this.options.navigatable;
		            var editable = this.options.editable;
		            var headerTable = this.list.header.find("table");
		            var contentTable = this.list.content.find("table");
		            var ganttStyles = Gantt.styles;
		            var isRtl = kendo.support.isRtl(this.wrapper);
		            var timelineContent = this.timeline.element.find(DOT + ganttStyles.gridContent);
		            var tables = headerTable.add(contentTable);
		            var attr = selector();
		            var cellIndex;
		            var expandState = {
		                collapse: false,
		                expand: true
		            };
	
		            var scroll = function(reverse) {
		                var width = that.timeline.view()._timeSlots()[0].offsetWidth;
		                timelineContent.scrollLeft(timelineContent.scrollLeft() + (reverse ? -width : width));
		            };
	
		            var scrollVertical = function(reverse) {
		                var height = that.timeline.view()._rowHeight;
		                timelineContent.scrollTop(timelineContent.scrollTop() + (reverse ? -height : height));
		            };
	
		            var moveVertical = function(method) {
		                var parent = that.current.parent("tr" + selector());
		                var index = that.current.index();
		                var subling = parent[method]();
	
		                if (that.select().length !== 0) {
		                    that.clearSelection();
		                }
	
		                if (subling.length !== 0) {
		                    that._current(subling.children("td:eq(" + index + ")"));
		                    that._scrollTo(that.current);
		                } else {
		                    if (that.current.is("td") && method == "prev") {
		                        focusTable(headerTable);
		                    } else if (that.current.is("th") && method == "next") {
		                        focusTable(contentTable);
		                    }
		                }
		            };
		            var moveHorizontal = function(method) {
		                var subling = that.current[method]();
	
		                if (subling.length !== 0) {
		                    that._current(subling);
		                    cellIndex = that.current.index();
		                }
		            };
		            var toggleExpandedState = function(value) {
		                var model = that.dataItem(that.current);
	
		                if (model.summary && model.expanded !== value) {
		                    model.set("expanded", value);
		                }
		            };
		            var deleteAction = function() {
		                var editable = that.options.editable;
	
		                if (!editable || editable.destroy === false || that.list.editable) {
		                    return;
		                }
	
		                var selectedTask = that.select();
		                var uid = kendo.attr("uid");
	
		                if (selectedTask.length) {
		                    that.removeTask(selectedTask.attr(uid));
		                }
		            };
	
		            $(this.wrapper)
		                .on("mousedown" + NS, "tr" + attr + ", div" + attr + ":not(" + DOT + ganttStyles.line + ")", function(e) {
		                    var currentTarget = $(e.currentTarget);
		                    var isInput = $(e.target).is(":button,a,:input,a>.k-icon,textarea,span.k-icon,span.k-link,.k-input,.k-multiselect-wrap");
		                    var current;
	
		                    if (e.ctrlKey) {
		                        return;
		                    }
	
		                    if (navigatable) {
		                        if (currentTarget.is("tr")) {
		                            current = $(e.target).closest("td");
		                        } else {
		                            current = that.list
		                                .content.find("tr" + selector(currentTarget.attr(kendo.attr("uid"))) + " > td:first");
		                        }
	
		                        that._current(current);
		                    }
	
		                    if ((navigatable || editable) && !isInput) {
		                        that._focusTimeout = setTimeout(function() {
		                            focusTable(that.list.content.find("table"), true);
		                        }, 2);
		                    }
		                })
	
		                .on("keydown" + NS, function (e) {
		                    var key = e.keyCode;
		                    var that = this;
		                    var focusableItems = $(that._getToolbarItems());
		                    var idx = focusableItems.index(that.toolbar.find(DOT + ganttStyles.focused)[0]);
		                    if (idx === -1 && $(e.target).closest(DOT + ganttStyles.toolbar.views).length) {
		                        idx = focusableItems.index(that.toolbar.find(".k-gantt-views > .k-state-selected:visible > a, .k-current-view:visible > a")[0]);
		                    }
		                    var itemToFocus = e.shiftKey ? focusableItems[idx -  1] : focusableItems[idx +  1];
	
		                    if (key === keys.F10) {
		                        that.toolbar.find(".k-button:visible:first").addClass(ganttStyles.focused).focus();
		                        e.preventDefault();
		                    } else if (key == keys.TAB && $(e.target).closest(DOT + ganttStyles.toolbar.toolbar).length) {
		                        that.toolbar.find(DOT + ganttStyles.focused).removeClass(ganttStyles.focused).blur();
		                        if (itemToFocus) {
		                            $(itemToFocus).addClass(ganttStyles.focused).focus();
		                            e.preventDefault();
		                            return;
		                        }
		                        if (this.list.element.is(":visible")) {
		                            this.list.element.find("table[role=treegrid]").focus();
		                        } else {
		                            this.element.find(DOT + ganttStyles.tasks)[0].focus();
		                        }
		                        e.preventDefault();
		                    }
	
		                }.bind(this));
	
		            if (navigatable !== true) {
		                contentTable
		                    .on("keydown" + NS, function(e) {
		                        if (e.keyCode == keys.DELETE) {
		                            deleteAction();
		                        }
		                    });
	
		                return;
		            }
	
		            tables
		                .on("focus" + NS, function() {
		                    var selector = this === contentTable.get(0) ? "td" : "th";
		                    var selection = that.select();
		                    var current = that.current || $((selection.length ? selection : this))
		                        .find(selector + ":eq(" + (cellIndex || 0) + ")");
	
		                    that._current(current);
		                    $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
		                    $(that.toolbar.find(DOT + ganttStyles.toolbar.currentView)).parent().removeClass(ganttStyles.toolbar.expanded);
		                })
		                .on("blur" + NS, function() {
		                    that._current();
	
		                    if (this == headerTable) {
		                        $(this).attr(TABINDEX, -1);
		                    }
		                })
		                .on("keydown" + NS, function(e) {
		                    var key = e.keyCode;
		                    var isCell;
	
		                    if (!that.current) {
		                        return;
		                    }
	
		                    isCell = that.current.is("td");
	
		                    switch (key) {
		                        case keys.RIGHT:
		                            e.preventDefault();
		                            if (e.altKey) {
		                                scroll();
		                            } else if (e.ctrlKey) {
		                                toggleExpandedState(isRtl ? expandState.collapse : expandState.expand);
		                            } else {
		                                moveHorizontal(isRtl ? "prev" : "next");
		                            }
		                            break;
		                        case keys.LEFT:
		                            e.preventDefault();
		                            if (e.altKey) {
		                                scroll(true);
		                            } else if (e.ctrlKey) {
		                                toggleExpandedState(isRtl ? expandState.expand : expandState.collapse);
		                            } else {
		                                moveHorizontal(isRtl ? "next" : "prev");
		                            }
		                            break;
		                        case keys.UP:
		                            e.preventDefault();
		                            if (e.altKey) {
		                                scrollVertical(true);
		                            } else {
		                                moveVertical("prev");
		                            }
		                            break;
		                        case keys.DOWN:
		                            e.preventDefault();
		                            if (e.altKey) {
		                                scrollVertical();
		                            } else {
		                                moveVertical("next");
		                            }
		                            break;
		                        case keys.SPACEBAR:
		                            e.preventDefault();
		                            if (isCell) {
		                                that.select(that.current.closest("tr"));
		                            }
		                            break;
		                        case keys.ENTER:
		                            e.preventDefault();
		                            if (isCell) {
		                                if (that.options.editable && that.options.editable.update !== false) {
		                                    that._cachedCurrent = that.current;
		                                    that.list._startEditHandler(that.current);
		                                    $(this).one("keyup", function(e) {
		                                        /* Stop the event propagation so that the list widget won't close its editor immediately */
		                                        e.stopPropagation();
		                                    });
		                                }
		                            } else {
		                                /* Sort */
		                                that.current
		                                    .children("a.k-link")
		                                    .click();
		                            }
		                            break;
		                        case keys.ESC:
		                            // e.stopPropagation();
		                            break;
		                        case keys.DELETE:
		                            if (isCell) {
		                                deleteAction();
		                            }
		                            break;
		                        default:
		                            if (key >= 49 && key <= 57 && e.target.tagName.toLowerCase() !== "input") {
		                               that.view(that.timeline._viewByIndex(key - 49));
		                            }
		                            break;
		                    }
		                });
		        },
	
		        _getToolbarItems: function () {
		            return this.toolbar.find(".k-gantt-toggle:visible").toArray().concat(
		                        this.toolbar.find(".k-gantt-actions > .k-button:visible").toArray(),
		                        this.toolbar.find(".k-gantt-views > .k-state-selected:visible > a, .k-current-view:visible > a").toArray()
		                    );
		        },
	
		        _current: function(element) {
		            var ganttStyles = Gantt.styles;
		            var activeElement;
	
		            if (this.current && this.current.length) {
		                this.current
		                    .removeClass(ganttStyles.focused)
		                    .removeAttr("id");
		            }
	
		            if (element && element.length) {
		                this.current = element
		                    .addClass(ganttStyles.focused)
		                    .attr("id", ACTIVE_CELL);
	
		                activeElement = $(kendo._activeElement());
	
		                if (activeElement.is("table") && this.wrapper.find(activeElement).length > 0) {
		                    activeElement
		                        .removeAttr(ARIA_DESCENDANT)
		                        .attr(ARIA_DESCENDANT, ACTIVE_CELL);
		                }
		            } else {
		                this.current = null;
		            }
		        },
	
		        _dataBind: function() {
		            var that = this;
	
		            if (that.options.autoBind) {
		                this._preventRefresh = true;
		                this._preventDependencyRefresh = true;
	
		                var promises = $.map([
		                    this.dataSource,
		                    this.dependencies,
		                    this.resources.dataSource,
		                    this.assignments.dataSource
		                ],
		                function(dataSource) {
		                    return dataSource.fetch();
		                });
	
		                $.when.apply(null, promises)
		                    .done(function() {
		                        that._preventRefresh = false;
		                        that._preventDependencyRefresh = false;
		                        that.refresh();
		                    });
		            }
		        },
	
		        _resize: function() {
		            this._adjustDimensions();
		            this.timeline.view()._adjustHeight();
		            this.timeline.view()._renderCurrentTime();
		            this.list._adjustHeight();
		        }
		    });
	
		    if (kendo.PDFMixin) {
		        kendo.PDFMixin.extend(Gantt.fn);
	
		        Gantt.fn._drawPDF = function() {
		            var ganttStyles = Gantt.styles;
		            var listClass = "." + ganttStyles.list;
		            var listWidth = this.wrapper.find(listClass).width();
	
		            var content = this.wrapper.clone();
		            content.find(listClass).css("width", listWidth);
	
		            return this._drawPDFShadow({
		                content: content
		            }, {
		                avoidLinks: this.options.pdf.avoidLinks
		            });
		        };
		    }
	
		    kendo.ui.plugin(Gantt);
	
		    extend(true, Gantt, { styles: ganttStyles });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1186:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(603);
	
	/***/ }),
	
	/***/ 1187:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(607);
	
	/***/ }),
	
	/***/ 1188:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(608);
	
	/***/ }),
	
	/***/ 1189:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(610);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1337);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1001:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1028:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(578);
	
	/***/ }),
	
	/***/ 1041:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(609);
	
	/***/ }),
	
	/***/ 1137:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(593);
	
	/***/ }),
	
	/***/ 1138:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1192:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(605);
	
	/***/ }),
	
	/***/ 1194:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(599);
	
	/***/ }),
	
	/***/ 1200:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(617);
	
	/***/ }),
	
	/***/ 1337:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1001),
		        __webpack_require__(1013),
		        __webpack_require__(1192),
		        __webpack_require__(1194),
		        __webpack_require__(1138),
		        __webpack_require__(1041),
		        __webpack_require__(1028),
		        __webpack_require__(1137),
		        __webpack_require__(1338),
		        __webpack_require__(1200)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "treelist",
		    name: "TreeList",
		    category: "web",
		    description: "The TreeList widget displays self-referencing data and offers rich support for interacting with data, sorting, filtering, and selection.",
		    depends: [ "dom", "data", "pager" ],
		    features: [ {
		        id: "treelist-sorting",
		        name: "Sorting",
		        description: "Support for column sorting",
		        depends: [ "columnsorter" ]
		    }, {
		        id: "treelist-filtering",
		        name: "Filtering",
		        description: "Support for record filtering",
		        depends: [ "filtermenu" ]
		    }, {
		        id: "treelist-editing",
		        name: "Editing",
		        description: "Support for record editing",
		        depends: [ "editable", "window" ]
		    }, {
		        id: "treelist-selection",
		        name: "Selection",
		        description: "Support for row selection",
		        depends: [ "selectable" ]
		    }, {
		        id: "treelist-column-resize",
		        name: "Column resizing",
		        description: "Support for column resizing",
		        depends: [ "resizable" ]
		    }, {
		        id: "treelist-dragging",
		        name: "Drag & Drop",
		        description: "Support for drag & drop of rows",
		        depends: [ "treeview.draganddrop" ]
		    }, {
		        id: "treelist-excel-export",
		        name: "Excel export",
		        description: "Export data as Excel spreadsheet",
		        depends: [ "excel" ]
		    }, {
		        id: "treelist-pdf-export",
		        name: "PDF export",
		        description: "Export data as PDF",
		        depends: [ "pdf", "drawing" ]
		    }, {
		        id: "treelist-paging",
		        name: "Paging",
		        description: "Support for treelist paging",
		        depends: [ "pager" ]
		    } ]
		};
	
		(function($, undefined) {
		    var data = kendo.data;
		    var kendoDom = kendo.dom;
		    var kendoDomElement = kendoDom.element;
		    var kendoTextElement = kendoDom.text;
		    var kendoHtmlElement = kendoDom.html;
		    var outerWidth = kendo._outerWidth;
		    var keys = kendo.keys;
		    var outerHeight = kendo._outerHeight;
		    var ui = kendo.ui;
		    var DataBoundWidget = ui.DataBoundWidget;
		    var DataSource = data.DataSource;
		    var ObservableArray = data.ObservableArray;
		    var Query = data.Query;
		    var Model = data.Model;
		    var browser = kendo.support.browser;
		    var kendoTemplate = kendo.template;
		    var activeElement = kendo._activeElement;
	
		    var isArray = $.isArray;
		    var extend = $.extend;
		    var proxy = $.proxy;
		    var map = $.map;
		    var grep = $.grep;
		    var inArray = $.inArray;
		    var isPlainObject = $.isPlainObject;
	
		    var push = Array.prototype.push;
	
		    var STRING = "string";
		    var CHANGE = "change";
		    var ITEM_CHANGE = "itemChange";
		    var ERROR = "error";
		    var PROGRESS = "progress";
		    var DOT = ".";
		    var NS = ".kendoTreeList";
		    var CLICK = "click";
		    var MOUSEDOWN = "mousedown";
		    var BEFORE_EDIT = "beforeEdit";
		    var EDIT = "edit";
		    var PAGE = "page";
		    var PAGE_CHANGE = "pageChange";
		    var SAVE = "save";
		    var SAVE_CHANGES = "saveChanges";
		    var EXPAND = "expand";
		    var COLLAPSE = "collapse";
		    var CELL_CLOSE = "cellClose";
		    var REMOVE = "remove";
		    var DATA_CELL = "td:not(.k-group-cell):not(.k-hierarchy-cell):visible";
		    var DATABINDING = "dataBinding";
		    var DATABOUND = "dataBound";
		    var CANCEL = "cancel";
		    var TABINDEX = "tabIndex";
		    var FILTERMENUINIT = "filterMenuInit";
		    var FILTERMENUOPEN = "filterMenuOpen";
		    var COLUMNHIDE = "columnHide";
		    var COLUMNSHOW = "columnShow";
		    var HEADERCELLS = "th.k-header";
		    var COLUMNREORDER = "columnReorder";
		    var COLUMNRESIZE = "columnResize";
		    var COLUMNMENUINIT = "columnMenuInit";
		    var COLUMNMENUOPEN = "columnMenuOpen";
		    var COLUMNLOCK = "columnLock";
		    var COLUMNUNLOCK = "columnUnlock";
		    var PARENTIDFIELD = "parentId";
		    var DRAGSTART = "dragstart";
		    var DRAG = "drag";
		    var DROP = "drop";
		    var DRAGEND = "dragend";
		    var NAVROW = "tr:visible";
		    var NAVCELL = "td:visible";
		    var NAVHEADER = "th:visible";
		    var ITEMROW = "tr:not(.k-footer-template):visible";
		    var FIRSTNAVITEM = NAVROW + " > td:first:visible";
		    var LASTITEMROW = ITEMROW + ":last";
		    var isRtl = false;
		    var HEIGHT = "height";
		    var INCELL = "incell";
		    var INLINE = "inline";
		    var POPUP = "popup";
		    var TABLE = "table";
	
		    var classNames = {
		        wrapper: "k-treelist k-grid k-widget k-display-block",
		        header: "k-header",
		        button: "k-button",
		        alt: "k-alt",
		        editCell: "k-edit-cell",
		        editRow: "k-grid-edit-row",
		        dirtyCell: "k-dirty-cell",
		        group: "k-treelist-group",
		        gridToolbar: "k-grid-toolbar",
		        gridHeader: "k-grid-header",
		        gridHeaderWrap: "k-grid-header-wrap",
		        gridContent: "k-grid-content",
		        gridContentWrap: "k-grid-content",
		        gridFilter: "k-grid-filter",
		        footerTemplate: "k-footer-template",
		        focused: "k-state-focused",
		        loading: "k-i-loading",
		        refresh: "k-i-reload",
		        retry: "k-request-retry",
		        selected: "k-state-selected",
		        status: "k-status",
		        link: "k-link",
		        withIcon: "k-with-icon",
		        filterable: "k-filterable",
		        icon: "k-icon",
		        iconFilter: "k-i-filter",
		        iconCollapse: "k-i-collapse",
		        iconExpand: "k-i-expand",
		        iconHidden: "k-i-none",
		        iconPlaceHolder: "k-icon k-i-none",
		        input: "k-input",
		        dropPositions: "k-i-insert-up k-i-insert-down k-i-plus k-i-insert-middle",
		        dropTop: "k-i-insert-up",
		        dropBottom: "k-i-insert-down",
		        dropAdd: "k-i-plus",
		        dropMiddle: "k-i-insert-middle",
		        dropDenied: "k-i-cancel",
		        dragStatus: "k-drag-status",
		        dragClue: "k-drag-clue",
		        dragClueText: "k-clue-text"
		    };
	
		    var defaultCommands = {
		        create: {
		            imageClass: "k-i-plus",
		            className: "k-grid-add",
		            methodName: "addRow"
		        },
		        createchild: {
		            imageClass: "k-i-plus",
		            className: "k-grid-add",
		            methodName: "addRow"
		        },
		        destroy: {
		            imageClass: "k-i-close",
		            className: "k-grid-delete",
		            methodName: "removeRow"
		        },
		        edit: {
		            imageClass: "k-i-edit",
		            className: "k-grid-edit",
		            methodName: "editRow"
		        },
		        update: {
		            imageClass: "k-i-check",
		            className: "k-primary k-grid-update",
		            methodName: "saveRow"
		        },
		        canceledit: {
		            imageClass: "k-i-cancel",
		            className: "k-grid-cancel",
		            methodName: "_cancelEdit"
		        },
		        cancel: {
		            imageClass: "k-icon k-i-cancel",
		            text: "Cancel changes",
		            className: "k-grid-cancel-changes",
		            methodName: "cancelChanges"
		        },
		        save: {
		            imageClass: "k-icon k-i-check",
		            text: "Save changes",
		            className: "k-grid-save-changes",
		            methodName: "saveChanges"
		        },
		        excel: {
		            imageClass: "k-i-file-excel",
		            className: "k-grid-excel",
		            methodName: "saveAsExcel"
		        },
		        pdf: {
		            imageClass: "k-i-file-pdf",
		            className: "k-grid-pdf",
		            methodName: "saveAsPDF"
		        }
		    };
	
		    var TreeView = kendo.Class.extend({
		        init: function(data, options) {
		            var that = this;
	
		            that.data = data || [];
		            that.options = extend(that.options, options);
		        },
	
		        options: {
		            defaultParentId: null,
		            idField: "id",
		            parentIdField: PARENTIDFIELD
		        },
	
		        childrenMap: function() {
		            var that = this;
		            var childrenMap = {};
		            var dataLength = that.data.length;
		            var dataItem;
		            var dataItemId;
		            var dataItemParentId;
		            var idField = that.options.idField;
		            var parentIdField = that.options.parentIdField;
	
		            if (that._childrenMap) {
		                return that._childrenMap;
		            }
	
		            for (var i = 0; i < dataLength; i++) {
		                dataItem = this.data[i];
		                dataItemId = dataItem[idField];
		                dataItemParentId = dataItem[parentIdField];
	
		                childrenMap[dataItemId] = childrenMap[dataItemId] || [];
		                childrenMap[dataItemParentId] = childrenMap[dataItemParentId] || [];
	
		                childrenMap[dataItemParentId].push(dataItem);
		            }
	
		            that._childrenMap = childrenMap;
	
		            return childrenMap;
		        },
	
		        idsMap: function() {
		            var that = this;
		            var idsMap = {};
		            var data = that.data;
		            var dataLength = data.length;
		            var dataItem;
		            var idField = that.options.idField;
	
		            if (that._idMap) {
		                return that._idMap;
		            }
	
		            for (var i = 0; i < dataLength; i++) {
		                dataItem = data[i];
		                idsMap[dataItem[idField]] = dataItem;
		            }
	
		            that.idsMap = idsMap;
		            return idsMap;
		        },
	
		        dataMaps: function() {
		            var that = this;
		            var childrenMap = {};
		            var data = that.data;
		            var dataLength = data.length;
		            var idsMap = {};
		            var dataItem;
		            var dataItemId;
		            var dataItemParentId;
		            var idField = that.options.idField;
		            var parentIdField = that.options.parentIdField;
	
		            if (that._dataMaps) {
		                return that._dataMaps;
		            }
	
		            for (var i = 0; i < dataLength; i++) {
		                dataItem = data[i];
		                dataItemId = dataItem[idField];
		                dataItemParentId = dataItem[parentIdField];
	
		                idsMap[dataItemId] = dataItem;
	
		                childrenMap[dataItemId] = childrenMap[dataItemId] || [];
		                childrenMap[dataItemParentId] = childrenMap[dataItemParentId] || [];
		                childrenMap[dataItemParentId].push(dataItem);
		            }
	
		            that._dataMaps = {
		                children: childrenMap,
		                ids: idsMap
		            };
	
		            return that._dataMaps;
		        },
	
		        rootNodes: function() {
		            var that = this;
		            var data = that.data;
		            var defaultParentId = that.options.defaultParentId;
		            var dataLength = data.length;
		            var rootNodes = [];
		            var dataItem;
		            var parentIdField = that.options.parentIdField;
	
		            for (var i = 0; i < dataLength; i++) {
		                dataItem = data[i];
	
		                if (dataItem[parentIdField] === defaultParentId) {
		                    rootNodes.push(dataItem);
		                }
		            }
	
		            return rootNodes;
		        },
	
		        removeCollapsedSubtreesFromRootNodes: function(options) {
		            options = options || {};
		            var that = this;
		            var rootNodes = that.rootNodes();
		            var result = [];
		            var prunedTree;
	
		            that._childrenMap = options.childrenMap = options.childrenMap || that.childrenMap();
		            options.maxDepth = options.maxDepth || Infinity;
	
		            for (var i = 0; i < rootNodes.length; i++) {
		                prunedTree = that.removeCollapsedSubtrees(rootNodes[i], options);
		                result = result.concat(prunedTree);
		            }
	
		            return result;
		        },
	
		        removeCollapsedSubtrees: function(rootNode, options) {
		            options = options || {};
		            var that = this;
		            var result = [];
		            var childIdx;
		            var prunedTree;
		            var childrenMap = options.childrenMap || {};
		            var maxDepth = options.maxDepth || Infinity;
		            var idField = that.options.idField;
		            var children = childrenMap[rootNode[idField]] || [];
		            var expanded = isUndefined(rootNode.expanded) ? options.expanded : rootNode.expanded;
	
		            result.push(rootNode);
	
		            if (children && expanded) {
		                for (childIdx = 0; childIdx < children.length; childIdx++) {
		                    if (result.length >= maxDepth) {
		                        break;
		                    }
	
		                    prunedTree = that.removeCollapsedSubtrees(children[childIdx], options);
		                    result = result.concat(prunedTree);
		                }
		            }
	
		            return result;
		        }
		    });
	
		    var TreeQuery = function(data) {
		        this.data = data || [];
		    };
	
		    TreeQuery.prototype = new Query();
		    TreeQuery.prototype.constructor = TreeQuery;
	
		    TreeQuery.process = function(data, options, inPlace) {
		        options = options || {};
		        var query = new TreeQuery(data);
		        var group = options.group;
		        var sort = Query.normalizeGroup(group || []).concat(Query.normalizeSort(options.sort || []));
		        var filterCallback = options.filterCallback;
		        var filter = options.filter;
		        var skip = options.skip;
		        var take = options.take;
		        var total;
		        var childrenMap;
		        var filteredChildrenMap;
		        var view;
		        var prunedData;
	
		        if (sort && inPlace) {
		            query = query.sort(sort, undefined, undefined, inPlace);
		        }
	
		        if (filter) {
		            query = query.filter(filter);
	
		            if (filterCallback) {
		                query = filterCallback(query);
		            }
	
		            total = query.toArray().length;
		        }
	
		        if (sort && !inPlace) {
		            query = query.sort(sort);
	
		            if (group) {
		                data = query.toArray();
		            }
		        }
	
		        if (options.processFromRootNodes) {
		            view = new TreeView(query.toArray(), options);
	
		            if (filter) {
		                filteredChildrenMap = view.childrenMap();
		            }
	
		            prunedData = view.removeCollapsedSubtreesFromRootNodes({
		                // filtering or sorting requires changes to childrenMap
		                childrenMap: filter || (sort && sort.length) ? undefined : options.childrenMap,
		                expanded: options.expanded,
		                maxDepth: (skip + take) || Infinity
		            });
	
		            childrenMap = view.childrenMap();
	
		            query = new TreeQuery(prunedData);
		        }
	
		        if (skip !== undefined && take !== undefined) {
		            query = query.range(skip, take);
		        }
	
		        if (group) {
		            query = query.group(group, data);
		        }
	
		        return {
		            total: total,
		            data: query.toArray(),
		            childrenMap: childrenMap,
		            filteredChildrenMap: filteredChildrenMap
		        };
		    };
	
		    var TreeListModel = Model.define({
		        id: "id",
	
		        parentId: PARENTIDFIELD,
	
		        fields: {
		            id: { type: "number" },
		            parentId: { type: "number", nullable: true }
		        },
	
		        init: function(value) {
		            Model.fn.init.call(this, value);
	
		            this._loaded = false;
	
		            if (!this.parentIdField) {
		                this.parentIdField = PARENTIDFIELD;
		            }
	
		            this.parentId = this.get(this.parentIdField);
		        },
	
		        accept: function(data) {
		            Model.fn.accept.call(this, data);
	
		            this.parentId = this.get(this.parentIdField);
		        },
	
		        set: function(field, value, initiator) {
		            if (field == PARENTIDFIELD && this.parentIdField != PARENTIDFIELD) {
		                this[this.parentIdField] = value;
		            }
	
		            Model.fn.set.call(this, field, value, initiator);
	
		            if (field == this.parentIdField) {
		                this.parentId = this.get(this.parentIdField);
		            }
		        },
	
		        loaded: function(value) {
		            if (value !== undefined) {
		                this._loaded = value;
		            } else {
		                return this._loaded;
		            }
		        },
	
		        shouldSerialize: function(field) {
		            return Model.fn.shouldSerialize.call(this, field) && field !== "_loaded" && field != "_error" && field != "_edit" && !(this.parentIdField !== "parentId" && field === "parentId");
		        }
		    });
	
		    TreeListModel.parentIdField = PARENTIDFIELD;
	
		    TreeListModel.define = function(base, options) {
		        if (options === undefined) {
		            options = base;
		            base = TreeListModel;
		        }
	
		        var parentId = options.parentId || PARENTIDFIELD;
	
		        options.parentIdField = parentId;
	
		        var model = Model.define(base, options);
	
		        if (parentId) {
		            model.parentIdField = parentId;
		        }
	
		        return model;
		    };
	
		    function is(field) {
		        return function(object) {
		            return object[field];
		        };
		    }
	
		    function not(func) {
		        return function(object) {
		            return !func(object);
		        };
		    }
	
		    var TreeListDataSource = DataSource.extend({
		        init: function(options) {
		            options = options || {};
		            var that = this;
		            that._dataMaps = that._getDataMaps();
	
		            options.schema = extend(true, {}, {
		                modelBase: TreeListModel,
		                model: TreeListModel
		            }, options.schema);
	
		            DataSource.fn.init.call(this, options);
		        },
	
		        _addRange: function() {
		            // empty override for performance - the treelist does not support virtualization
		        },
	
		        _createNewModel: function(data) {
		            var that = this;
		            var model = {};
		            var fromModel = data instanceof Model;
		            var parentIdField = this._modelParentIdField();
	
		            if (fromModel) {
		                model = data;
		            }
	
		            model = DataSource.fn._createNewModel.call(this, model);
	
		            if (!fromModel) {
		                if (data.parentId) {
		                    data[model.parentIdField] = data.parentId;
		                } else if (that._isPageable() && data[parentIdField]) {
		                    data[model.parentIdField] = data[parentIdField];
		                }
	
		                model.accept(data);
		            }
	
		            return model;
		        },
	
		        _shouldWrap: function() {
		            return true;
		        },
	
		        _push: function(result, operation) {
		            var data = DataSource.fn._readData.call(this, result);
	
		            if (!data) {
		                data = result;
		            }
	
		            this[operation](data);
		        },
	
		        _getData: function() {
		            // do not use .data(), which wraps the data items
		            return this._data || [];
		        },
	
		        _readData: function(newData) {
		            var that = this;
		            var data = that._isPageable() ? that._getData().toJSON() : that.data();
	
		            newData = DataSource.fn._readData.call(this, newData);
	
		            this._replaceData(((data.toJSON ? data.toJSON() : data)).concat(newData), data);
	
		            if (newData instanceof ObservableArray) {
		                return newData;
		            }
	
		            return data;
		        },
	
		        _replaceData: function(source, target) {
		            var sourceLength = source.length;
	
		            for (var i = 0; i < sourceLength; i++) {
		                target[i] = source[i];
		            }
	
		            target.length = sourceLength;
		        },
	
		        _readAggregates: function(data) {
		            var result = extend(this._aggregateResult, this.reader.aggregates(data));
		            if ("" in result) {
		                result[this._defaultParentId()] = result[""];
		                delete result[""];
		            }
	
		            return result;
		        },
	
		        read: function(data) {
		            var that = this;
	
		            if (that._isPageable()) {
		                that._dataMaps = {};
		            }
	
		            return DataSource.fn.read.call(that, data);
		        },
	
		        remove: function(root) {
		            this._removeChildData(root);
	
		            this._removeFromDataMaps(root);
	
		            DataSource.fn.remove.call(this, root);
		        },
	
		        _removeChildData: function(model, removePristine) {
		            var that = this;
		            var pageable = that._isPageable();
		            var data = pageable ? this._getData() : this.data();
		            var childrenMap = pageable ? that._getChildrenMap() || that.childrenMap(data) : that._childrenMap(data);
		            var items = this._subtree(childrenMap, model.id);
		            var shouldRemovePristine = isUndefined(removePristine) ? false : removePristine;
	
		            var removedItems = this._removeItems(items, shouldRemovePristine);
	
		            that._removeFromDataMaps(removedItems);
		        },
	
		        pushDestroy: function(items) {
		            var that = this;
	
		            if (!isArray(items)) {
		                items = [items];
		            }
	
		            for (var i = 0; i < items.length; i++) {
		                that._removeChildData(items[i], true);
		                that._removeFromDataMaps(items[i]);
		            }
	
		            DataSource.fn.pushDestroy.call(that, items);
		        },
	
		        insert: function(index, model) {
		            var that = this;
		            var newModel = that._createNewModel(model);
	
		            that._insertInDataMaps(newModel);
	
		            return DataSource.fn.insert.call(that, index, newModel);
		        },
	
		        _filterCallback: function(query) {
		            var that = this;
		            var i, item;
		            var map = {};
		            var result = [];
		            var data = query.toArray();
		            var idField = that._modelIdField();
		            var parentIdField = that._modelParentIdField();
		            var pageable = that._isPageable();
		            var parentSubtree = [];
		            var parent;
	
		            for (i = 0; i < data.length; i++) {
		                item = data[i];
	
		                if (pageable) {
		                    // return view from root nodes to child nodes
		                    parentSubtree = [];
	
		                    if (!map[item[idField]]) {
		                        map[item[idField]] = true;
		                        parentSubtree.push(item);
		                    }
	
		                    parent = that._parentNode(item);
	
		                    while (parent) {
		                        if (!map[parent[idField]]) {
		                            map[parent[idField]] = true;
		                            parentSubtree.unshift(parent);
		                            parent = that._parentNode(parent);
		                        } else {
		                            // the parent chain is already processed
		                            break;
		                        }
		                    }
	
		                    if (parentSubtree.length) {
		                        result = result.concat(parentSubtree);
		                    }
		                } else {
		                    while (item) {
		                        if (!map[item[idField]]) {
		                            map[item[idField]] = true;
		                            result.push(item);
		                        }
	
		                        if (!map[item[parentIdField]]) {
		                            map[item[parentIdField]] = true;
		                            item = this.parentNode(item);
	
		                            if (item) {
		                                result.push(item);
		                            }
		                        } else {
		                            break;
		                        }
		                    }
		                }
		            }
	
		            return new Query(result);
		        },
	
		        _subtree: function(map, id) {
		            var that = this;
		            var result = map[id] || [];
		            var defaultParentId = that._defaultParentId();
		            var idField = that._modelIdField();
	
		            for (var i = 0, len = result.length; i < len; i++) {
		                if (result[i][idField] !== defaultParentId) {
		                    result = result.concat(that._subtree(map, result[i][idField]));
		                }
		            }
	
		            return result;
		        },
	
		        // builds hash id -> children
		        _childrenMap: function(data) {
		            var map = {};
		            var i, item, id, parentId;
	
		            data = this._observeView(data);
	
		            for (i = 0; i < data.length; i++) {
		                item = data[i];
		                id = item.id;
		                parentId = item.parentId;
	
		                map[id] = map[id] || [];
		                map[parentId] = map[parentId] || [];
		                map[parentId].push(item);
		            }
	
		            return map;
		        },
	
		        childrenMap: function(data) {
		            var view = this._createTreeView(data);
		            var map =  view.childrenMap();
		            return map;
		        },
	
		        _getChildrenMap: function() {
		            var that = this;
		            var dataMaps = that._getDataMaps();
		            return dataMaps.children;
		        },
	
		        _initIdsMap: function(data) {
		            var that = this;
		            var dataMaps = that._getDataMaps();
	
		            if (isUndefined(dataMaps.ids)) {
		                dataMaps.ids = that._idsMap(data);
		            }
	
		            return dataMaps.ids;
		        },
	
		        _idsMap: function(data) {
		            var view = this._createTreeView(data);
		            var map =  view.idsMap();
		            return map;
		        },
	
		        _getIdsMap: function() {
		            var that = this;
		            var dataMaps = that._getDataMaps();
		            return dataMaps.ids || {};
		        },
	
		        _getFilteredChildrenMap: function() {
		            var that = this;
		            var dataMaps = that._getDataMaps();
		            return dataMaps.filteredChildren;
		        },
	
		        _setFilteredChildrenMap: function(map) {
		            var that = this;
		            var dataMaps = that._getDataMaps();
		            dataMaps.filteredChildren = map;
		        },
	
		        _initDataMaps: function(data) {
		            var that = this;
		            var view = that._createTreeView(data);
	
		            that._dataMaps = view.dataMaps();
	
		            return that._dataMaps;
		        },
	
		        _initChildrenMapForParent: function(parent) {
		            var that = this;
		            var data = that._getData();
		            var childrenMap = that._getChildrenMap();
		            var idField = that._modelIdField();
		            var parentIdField = that._modelParentIdField();
		            var parentId = (parent || {})[idField];
	
		            if (childrenMap && parent) {
		                childrenMap[parentId] = [];
	
		                for (var i = 0; i < data.length; i++) {
		                    if (data[i][parentIdField] === parentId) {
		                        childrenMap[parentId].push(data[i]);
		                    }
		                }
		            }
		        },
	
		        _getDataMaps: function() {
		            var that = this;
		            that._dataMaps = that._dataMaps || {};
		            return that._dataMaps;
		        },
	
		        _createTreeView: function(data, options) {
		            var view = new TreeView(data, extend(options, this._defaultTreeModelOptions()));
		            return view;
		        },
	
		        _defaultTreeModelOptions: function() {
		            var that = this;
		            var modelOptions = that._modelOptions();
	
		            return {
		                defaultParentId: that._defaultParentId(),
		                idField: that._modelIdField(),
		                parentIdField: that._modelParentIdField(),
		                expanded: modelOptions.expanded
		            };
		        },
	
		        _defaultDataItemType: function() {
		            return this.reader.model || kendo.data.ObservableObject;
		        },
	
		        _calculateAggregates: function(data, options) {
		            options = options || {};
		            var that = this;
		            var result = {};
		            var item, subtree, i;
		            var filter = options.filter;
		            var skip = options.skip;
		            var take = options.take;
		            var maxDepth = !isUndefined(skip) && !isUndefined(take) ? (skip + take) : Infinity;
		            var pageable = that._isPageable();
		            var filteredChildrenMap = options.filteredChildrenMap;
		            var childrenMap = options.childrenMap;
		            var pageableChildrenMap;
	
		            if (pageable) {
		                if (isUndefined(options.aggregate)) {
		                    return result;
		                }
	
		                if (filteredChildrenMap) {
		                    pageableChildrenMap = filteredChildrenMap;
		                } else if (childrenMap) {
		                    pageableChildrenMap = childrenMap;
		                } else {
		                    pageableChildrenMap = that.childrenMap(that._getData());
		                }
		            }
	
		            if (!pageable && filter) {
		                data = Query.process(data, {
		                    filter: filter,
		                    filterCallback: proxy(this._filterCallback, this)
		                }).data;
		            }
	
		            var map = pageable ? pageableChildrenMap : that._childrenMap(data);
	
		            // calculate aggregates for each subtree
		            result[this._defaultParentId()] = new Query(this._subtree(map, this._defaultParentId())).aggregate(options.aggregate);
	
		            for (i = 0; i < data.length; i++) {
		                if (i >= maxDepth) {
		                    break;
		                }
	
		                item = data[i];
		                subtree = this._subtree(map, item.id);
	
		                result[item.id] = new Query(subtree).aggregate(options.aggregate);
		            }
	
		            return result;
		        },
	
		        _queryProcess: function(data, options) {
		            var that = this;
		            var result = {};
		            options = options || {};
		            options.filterCallback = proxy(this._filterCallback, this);
	
		            if (that._isPageable()) {
		                return that._processPageableQuery(data, options);
		            } else {
		                var defaultParentId = this._defaultParentId();
		                result = Query.process(data, options);
		                var map = this._childrenMap(result.data);
		                var hasLoadedChildren, i, item, children;
	
		                data = map[defaultParentId] || [];
	
		                for (i = 0; i < data.length; i++) {
		                    item = data[i];
	
		                    if (item.id === defaultParentId) {
		                        continue;
		                    }
	
		                    children = map[item.id];
		                    hasLoadedChildren = !!(children && children.length);
	
		                    if (!item.loaded()) {
		                        item.loaded(hasLoadedChildren || !item.hasChildren);
		                    }
	
		                    if (item.loaded() || item.hasChildren !== true) {
		                        item.hasChildren = hasLoadedChildren;
		                    }
	
		                    if (hasLoadedChildren) {
		                        //cannot use splice due to IE8 bug
		                        data = data.slice(0, i + 1).concat(children, data.slice(i + 1));
		                    }
		                }
	
		                result.data = data;
		            }
	
		            return result;
		        },
	
		        _processPageableQuery: function(data, options) {
		            var that = this;
		            var dataMaps = that._getDataMaps();
		            var result;
		            var filteredChildrenMap;
	
		            if (that._getData() !== data || !dataMaps.children || !dataMaps.ids) {
		                dataMaps = that._initDataMaps(that._getData());
		            }
	
		            options.childrenMap = dataMaps.children || {};
		            options.idsMap = dataMaps.ids || {};
	
		            result = that._processTreeQuery(data, options);
	
		            that._replaceWithObservedData(result.data, data);
	
		            that._processDataItemsState(result.data, result.childrenMap);
	
		            that._replaceItemsInDataMaps(result.data);
	
		            result.dataToAggregate = that._dataToAggregate(result.data, options);
	
		            if (options.filter) {
		                filteredChildrenMap = result.filteredChildrenMap;
		                that._replaceInMapWithObservedData(filteredChildrenMap, data);
		                that._setFilteredChildrenMap(filteredChildrenMap);
		                options.filteredChildrenMap = filteredChildrenMap;
		            }
	
		            return result;
		        },
	
		        _dataToAggregate: function(data) {
		            var that = this;
		            var firstDataItem = data[0] || {};
		            var firstItemParents = that._parentNodes(firstDataItem);
		            var dataToAggregate = firstItemParents.concat(data);
	
		            return dataToAggregate;
		        },
	
		        _replaceItemsInDataMaps: function(observableArray) {
		            var that = this;
		            var view = isArray(observableArray) ? observableArray : [observableArray];
		            var itemType = that._defaultDataItemType();
		            var defaultParentId = that._defaultParentId();
		            var idField = that._modelIdField();
		            var parentIdField = that._modelParentIdField();
		            var dataMaps = that._getDataMaps();
		            var item;
		            var parents;
		            var directParent;
	
		            for (var viewIndex = 0; viewIndex < view.length; viewIndex++) {
		                item = view[viewIndex];
	
		                if (!(item instanceof itemType)) {
		                    continue;
		                }
	
		                that._insertInIdsMap(item);
	
		                parents = that._parentNodes(item);
		                directParent = parents && parents.length ? parents[parents.length - 1] : undefined;
	
		                if (item[parentIdField] === defaultParentId) {
		                    that._replaceInMap(dataMaps.children, defaultParentId, item, itemType);
		                } else if (directParent) {
		                    that._replaceInMap(dataMaps.children, directParent[idField], item, itemType);
		                }
		            }
		        },
	
		        _replaceInMap: function(map, id, replacement, itemType) {
		            var idField = this._modelIdField();
		            map[id] = map[id] || [];
		            itemType = itemType || this._defaultDataItemType();
	
		            var itemInArray = map[id].filter(function(element) {
		                return replacement[idField] === element[idField];
		            })[0];
	
		            var itemIndex = itemInArray ? map[id].indexOf(itemInArray) : -1;
	
		            if (itemIndex !== -1 && !(itemInArray instanceof itemType)) {
		                map[id][itemIndex] = replacement;
		            }
		        },
	
		        _replaceWithObservedData: function(dataToReplace, replacementArray) {
		            var that = this;
		            var idsMap = that._getDataMaps().ids || {};
		            var idField = that._modelIdField();
		            var itemType = that._defaultDataItemType();
		            var itemToReplace;
		            var itemToReplaceId;
		            var dataItem;
		            var dataItemIndex;
		            var observableItem;
	
		            for (var i = 0; i < dataToReplace.length; i++) {
		                itemToReplace = dataToReplace[i];
		                itemToReplaceId = itemToReplace[idField];
	
		                if (!(itemToReplace instanceof itemType)) {
		                    if (!(idsMap[itemToReplaceId] instanceof itemType)) {
		                        dataItem = that._getById(itemToReplaceId);
		                        dataItemIndex = replacementArray.indexOf(dataItem);
	
		                        if (dataItem && dataItemIndex !== -1) {
		                            observableItem = replacementArray.at(dataItemIndex);
		                            dataToReplace[i] = observableItem;
		                        }
		                    } else {
		                        dataToReplace[i] = idsMap[itemToReplaceId];
		                    }
		                }
		            }
		        },
	
		        _replaceInMapWithObservedData: function(map, replacementArray) {
		            var that = this;
	
		            for (var key in map) {
		                that._replaceWithObservedData(map[key], replacementArray);
		            }
		        },
	
		        _insertInDataMaps: function(item) {
		            var that = this;
	
		            if (that._isPageable()) {
		                that._insertInIdsMap(item);
		                that._insertInChildrenMap(item);
		            }
		        },
	
		        _insertInIdsMap: function(item) {
		            var that = this;
		            var idsMap = that._getIdsMap();
		            var idField = that._modelIdField();
	
		            if (!isUndefined(item[idField])) {
		                idsMap[item[idField]] = item;
		            }
		        },
	
		        _insertInChildrenMap: function(item, index) {
		            var that = this;
		            var childrenMap = that._getChildrenMap() || {};
		            var idField = that._modelIdField();
		            var parentIdField = that._modelParentIdField();
		            var itemId = item[idField];
		            var parentId = item[parentIdField];
		            index = index || 0;
	
		            childrenMap[itemId] = childrenMap[itemId] || [];
		            childrenMap[parentId] = childrenMap[parentId] || [];
		            childrenMap[parentId].splice(index, 0, item);
		        },
	
		        _removeFromDataMaps: function(items) {
		            var that = this;
		            items = isArray(items) ? items : [items];
	
		            if (that._isPageable()) {
		                for (var i = 0; i < items.length; i++) {
		                    that._removeFromIdsMap(items[i]);
		                    that._removeFromChildrenMap(items[i]);
		                }
		            }
		        },
	
		        _removeFromIdsMap: function(item) {
		            var that = this;
		            var idsMap = that._getIdsMap();
		            var idField = that._modelIdField();
	
		            if (!isUndefined(item[idField])) {
		                idsMap[item[idField]] = undefined;
		            }
		        },
	
		        _removeFromChildrenMap: function(item) {
		            var that = this;
		            var childrenMap = that._getChildrenMap() || {};
		            var parentIdField = that._modelParentIdField();
		            var parentId = item[parentIdField];
	
		            childrenMap[parentId] = childrenMap[parentId] || [];
	
		            var itemIndex = that._indexInChildrenMap(item);
	
		            if (itemIndex !== -1) {
		                childrenMap[parentId].splice(itemIndex, 1);
		            }
		        },
	
		        _indexInChildrenMap: function(item) {
		            var that = this;
		            return that._itemIndexInMap(item, that._getChildrenMap());
		        },
	
		        _itemIndexInMap: function(item, dataMap) {
		            var that = this;
		            var map = dataMap || {};
		            var parentIdField = that._modelParentIdField();
		            var parentId = item[parentIdField];
	
		            map[parentId] = map[parentId] || [];
	
		            var itemInArray = map[parentId].filter(function(element) {
		                return item.uid === element.uid;
		            })[0];
	
		            var itemIndex = itemInArray ? map[parentId].indexOf(itemInArray) : -1;
	
		            return itemIndex;
		        },
	
		        _getById: function(id) {
		            var that = this;
		            var idField = that._modelIdField();
		            var data = that._getData();
	
		            for (var i = 0; i < data.length; i++) {
		                if (data[i][idField] === id) {
		                    return data[i];
		                }
		            }
		        },
	
		        _isLastItemInView: function(dataItem) {
		            var view = this.view();
		            return view.length && view[view.length - 1] === dataItem;
		        },
	
		        _defaultPageableQueryOptions: function() {
		            var that = this;
		            var dataMaps = that._getDataMaps();
		            var options = {
		                skip: that.skip(),
		                take: that.take(),
		                page: that.page(),
		                pageSize: that.pageSize(),
		                sort: that.sort(),
		                filter: that.filter(),
		                group: that.group(),
		                aggregate: that.aggregate(),
		                filterCallback: proxy(that._filterCallback, that),
		                childrenMap: dataMaps.children,
		                idsMap: dataMaps.ids
		            };
	
		            return options;
		        },
	
		        _isPageable: function() {
		            var pageSize = this.pageSize();
		            return (!isUndefined(pageSize) && pageSize > 0 && !this.options.serverPaging);
		        },
	
		        _updateTotalForAction: function(action, items) {
		            var that = this;
	
		            DataSource.fn._updateTotalForAction.call(that, action, items);
	
		            if (that._isPageable()) {
		                that._updateCollapsedTotalForAction(action, items);
		            }
		        },
	
		        _updateCollapsedTotalForAction: function(action, items) {
		            var that = this;
		            var total = parseInt(that._collapsedTotal, 10);
	
		            if (!isNumber(that._collapsedTotal)) {
		                that._calculateCollapsedTotal();
		                return;
		            }
	
		            if (action === "add") {
		                total += items.length;
		            } else if (action === "remove") {
		                total -= items.length;
		            } else if (action !== "itemchange" && action !== "sync" && !that.options.serverPaging) {
		                total = that._calculateCollapsedTotal();
		            } else if (action === "sync") {
		                total = that._calculateCollapsedTotal();
		            }
	
		            that._collapsedTotal = total;
		        },
	
		        _setFilterTotal: function(filterTotal, setDefaultValue) {
		            var that = this;
	
		            DataSource.fn._setFilterTotal.call(that, filterTotal, setDefaultValue);
	
		            that._setFilterCollapsedTotal(filterTotal);
		        },
	
		        _setFilterCollapsedTotal: function(filterTotal) {
		            var that = this;
	
		            if (!that.options.serverFiltering) {
		                if (filterTotal !== undefined) {
		                    that._collapsedTotal = filterTotal;
		                } else {
		                    if (that._getFilteredChildrenMap()) {
		                        that._calculateCollapsedTotal();
		                    }
	
		                    that._setFilteredChildrenMap(undefined);
		                }
		            }
		        },
	
		        collapsedTotal: function() {
		            var that = this;
	
		            if (!isUndefined(that._collapsedTotal)) {
		                return that._collapsedTotal;
		            }
	
		            return that._calculateCollapsedTotal();
		        },
	
		        _calculateCollapsedTotal: function() {
		            var that = this;
		            var data = that._dataWithoutCollapsedSubtrees();
	
		            if (data.length) {
		                that._collapsedTotal = data.length;
		            }
	
		            return that._collapsedTotal;
		        },
	
		        _dataWithoutCollapsedSubtrees: function() {
		            return this._removeCollapsedSubtrees(this._getData());
		        },
	
		        _removeCollapsedSubtrees: function(data) {
		            var that = this;
		            var view = that._createTreeView(data);
		            var result = view.removeCollapsedSubtreesFromRootNodes({
		                expanded: that._modelOptions().expanded,
		                childrenMap: that._getChildrenMap()
		            });
	
		            return result;
		        },
	
		        _processTreeQuery: function(data, options) {
		            var result = TreeQuery.process(data, extend(options, this._defaultTreeModelOptions(), {
		                processFromRootNodes: true
		            }));
	
		            return result;
		        },
	
		        _processDataItemsState: function(data, childrenMap) {
		            var dataLength = data.length;
		            var i;
	
		            for (i = 0; i < dataLength; i++) {
		                this._processDataItemState(data[i], childrenMap);
		            }
		        },
	
		        _processDataItemState: function(dataItem, childrenMap) {
		            var defaultParentId = this._defaultParentId();
	
		            if (dataItem.id === defaultParentId) {
		                return;
		            }
	
		            var children = childrenMap[dataItem.id] || [];
		            var hasLoadedChildren = !!(children && children.length);
	
		            if (!dataItem.loaded) {
		                return;
		            }
	
		            if (!dataItem.loaded()) {
		                dataItem.loaded(hasLoadedChildren || !dataItem.hasChildren);
		            }
	
		            if (dataItem.loaded() || dataItem.hasChildren !== true) {
		                dataItem.hasChildren = hasLoadedChildren;
		            }
		        },
	
		        _queueRequest: function(options, callback) {
		            // allow simultaneous requests (loading multiple items at the same time)
		            callback.call(this);
		        },
	
		        _modelLoaded: function(id) {
		            var model = this.get(id);
		            model.loaded(true);
		            model.hasChildren = this.childNodes(model).length > 0;
		        },
	
		        _modelError: function(id, e) {
		            this.get(id)._error = e;
		        },
	
		        success: function(data, requestParams) {
		            if (!requestParams || typeof requestParams.id == "undefined") {
		                this._data = this._observe([]);
		            }
	
		            DataSource.fn.success.call(this, data, requestParams);
					this._total = this._data.length;
		        },
	
		        load: function(model) {
		            var method = "_query";
		            var remote = this.options.serverSorting || this.options.serverPaging || this.options.serverFiltering || this.options.serverGrouping || this.options.serverAggregates;
		            var defaultPromise = $.Deferred().resolve().promise();
	
		            if (model.loaded()) {
		                if (remote) {
		                    return defaultPromise;
		                }
		            } else if (model.hasChildren) {
		                method = "read";
		                this._removeChildData(model);
		            }
	
		            return this[method]({ id: model.id })
		                .done(proxy(this._modelLoaded, this, model.id))
		                .fail(proxy(this._modelError, this, model.id));
		        },
	
		        contains: function(root, child) {
		            var that = this;
		            var idField = that._modelIdField();
		            var parentIdField = that._modelParentIdField();
		            var rootId = root[idField];
		            var pageable = that._isPageable();
	
		            while (child) {
		                if (child[parentIdField] === rootId) {
		                    return true;
		                }
	
		                child = pageable ? that._parentNode(child) : that.parentNode(child);
		            }
	
		            return false;
		        },
	
		        _byParentId: function(id, defaultId) {
		            var result = [];
		            var view = this.view();
		            var current;
	
		            if (id === defaultId) {
		                return [];
		            }
	
		            for (var i = 0; i < view.length; i++) {
		                current = view.at(i);
	
		                if (current.parentId == id) {
		                    result.push(current);
		                }
		            }
	
		            return result;
		        },
	
		        _defaultParentId: function() {
		            return this.reader.model.fn.defaults[this.reader.model.parentIdField];
		        },
	
		        _modelOptions: function() {
		            var modelOptions = ((this.options.schema || {}).model || {});
		            return modelOptions;
		        },
	
		        _modelIdField: function() {
		            var modelOptions = this._modelOptions();
		            return modelOptions.id || "id";
		        },
	
		        _modelParentIdField: function() {
		            var modelOptions = this._modelOptions();
		            return modelOptions.parentId || PARENTIDFIELD;
		        },
	
		        childNodes: function(model) {
		            return this._byParentId(model.id, this._defaultParentId());
		        },
	
		        rootNodes: function() {
		            return this._byParentId(this._defaultParentId());
		        },
	
		        _rootNode: function(child) {
		            return this._parentNodes(child)[0];
		        },
	
		        _pageableRootNodes: function(options) {
		            options = options || {};
		            var that = this;
		            var defaultParentId = that._defaultParentId();
		            var parentIdField = that._modelParentIdField();
		            var result = [];
		            var nodesWithoutParentInView = that._nodesWithoutParentInView(options);
		            var node;
		            var root;
	
		            for (var i = 0; i < nodesWithoutParentInView.length; i++) {
		                node = nodesWithoutParentInView[i];
	
		                if (node[parentIdField] === defaultParentId) {
		                    result.push(node);
		                } else {
		                    root = that._rootNode(node);
	
		                    if (root && result.indexOf(root) === -1) {
		                        result.push(root);
		                    }
		                }
		            }
	
		            return result;
		        },
	
		        parentNode: function(model) {
		            return this.get(model.parentId);
		        },
	
		        _parentNode: function(child) {
		            var that = this;
		            var parentIdField = that._modelParentIdField();
		            var idsMap = that._initIdsMap(that._getData());
		            var parentId = child[parentIdField];
		            var parent = idsMap[parentId] || that._getById(parentId);
	
		            return parent;
		        },
	
		        _parentNodes: function(child) {
		            var that = this;
		            var parent = that._parentNode(child);
		            var parents = [];
	
		            while (parent) {
		                parents.unshift(parent);
		                parent = that._parentNode(parent);
		            }
	
		            return parents;
		        },
	
		        _parentNodesNotInView: function() {
		            var that = this;
		            var view = that.view();
		            var result = [];
		            var defaultParentId = that._defaultParentId();
		            var idField = that._modelIdField();
		            var parentIdField = that._modelParentIdField();
		            var parentInView;
		            var parents = [];
		            var directParent;
		            var dataItem;
		            var dataItemId;
		            var dataItemParentId;
	
		            for (var i = 0; i < view.length; i++) {
		                dataItem = view[i];
		                dataItemId = dataItem[idField];
		                dataItemParentId = dataItem[parentIdField];
		                parentInView = that._parentInView(dataItemParentId);
	
		                if (!parentInView && dataItemParentId !== defaultParentId) {
		                    parents = that._parentNodes(dataItem);
	
		                    directParent = parents && parents.length ? parents[parents.length - 1] : that._getById(dataItemParentId);
	
		                    if (directParent && result.indexOf(directParent) === -1) {
		                        result.push(directParent);
		                    }
		                }
		            }
	
		            return result;
		        },
	
		        _nodesWithoutParentInView: function(options) {
		            options = options || {};
		            var that = this;
		            var view = that.view();
		            var childrenMap = options.childrenMap || that.childrenMap(that._getData());
		            var idField = that._modelIdField();
		            var parentIdField = that._modelParentIdField();
		            var dataItem;
		            var parentInView;
		            var children = [];
		            var result = [];
	
		            for (var i = 0; i < view.length; i++) {
		                dataItem = view[i];
		                children = childrenMap[dataItem[idField]];
		                parentInView = that._parentInView(dataItem[parentIdField]);
	
		                if (!parentInView) {
		                    result.push(dataItem);
		                }
		            }
	
		            return result;
		        },
	
		        _parentInView: function(parentId) {
		            var view = this.view();
	
		            for (var i = 0; i < view.length; i++) {
		                if (view[i].id === parentId) {
		                    return view[i];
		                }
		            }
		        },
	
		        level: function(model) {
		            var result = -1;
	
		            if (!(model instanceof TreeListModel)) {
		                model = this.get(model);
		            }
	
		            do {
		                model = this.parentNode(model);
		                result++;
		            } while (model);
	
		            return result;
		        },
	
		        _pageableModelLevel: function(model) {
		            var that = this;
	
		            if (!model || !that._isPageable()) {
		                return 0;
		            }
	
		            var parents = that._parentNodes(model);
	
		            return parents.length;
		        },
	
		        filter: function(value) {
		            var baseFilter = DataSource.fn.filter;
	
		            if (value === undefined) {
		                return baseFilter.call(this, value);
		            }
	
		            baseFilter.call(this, value);
		        },
	
		        _pageableQueryOptions: function(options) {
		            var dataMaps = this._getDataMaps();
	
		            options.childrenMap = dataMaps.children;
		            options.idsMap = dataMaps.ids;
	
		            return options;
		        },
	
		        _flatData: function(data, skip) {
		            skip = this._isPageable() ? true : skip;
		            return DataSource.fn._flatData.call(this, data, skip);
		        },
	
		        data: function(data) {
		            var that = this;
		            var result = DataSource.fn.data.call(that, data);
	
		            if (that._isPageable()) {
		                that._initDataMaps(that._getData());
		                that._calculateCollapsedTotal();
		            }
	
		            return result;
		        },
	
		        cancelChanges: function(model) {
		            var that = this;
	
		            DataSource.fn.cancelChanges.call(that, model);
	
		            that._restorePageSizeAfterAddChild();
		        },
	
		        _modelCanceled: function(model) {
		            var that = this;
	
		            if (that._isPageable()) {
		                that._removeFromDataMaps(model);
		            }
		        },
	
		        _changesCanceled: function() {
		            var that = this;
	
		            if (that._isPageable()) {
		                that._initDataMaps(that._getData());
		            }
		        },
	
		        _setAddChildPageSize: function() {
		            var that = this;
		            var queryOptions = {};
	
		            if (that._isPageable()) {
		                // increase the page size to make the new item visible in view
		                that._addChildPageSize = that.pageSize() + 1;
	
		                queryOptions = that._defaultPageableQueryOptions();
		                queryOptions.take = that._addChildPageSize;
		                queryOptions.pageSize = that._addChildPageSize;
		                that._query(queryOptions);
		            }
		        },
	
		        _restorePageSizeAfterAddChild: function() {
		            var that = this;
		            var queryOptions = {};
	
		            if (that._isPageable()) {
		                if (!isUndefined(that._addChildPageSize)) {
		                    queryOptions = that._defaultPageableQueryOptions();
		                    queryOptions.take = that._addChildPageSize - 1;
		                    queryOptions.pageSize = that._addChildPageSize - 1;
		                    that._query(queryOptions);
		                }
		            }
	
		            that._addChildPageSize = undefined;
		        },
	
		        sync: function() {
		            var that = this;
	
		            return DataSource.fn.sync.call(that)
		                .then(function() {
		                    that._restorePageSizeAfterAddChild();
		                });
		        },
	
		        _syncEnd: function() {
		            var that = this;
	
		            if (that._isPageable()) {
		                that._initDataMaps(that._getData());
		            }
		        }
		    });
	
		    TreeListDataSource.create = function(options) {
		        if ($.isArray(options)) {
		            options = { data: options };
		        } else if (options instanceof ObservableArray) {
		            options = { data: options.toJSON() };
		        }
	
		        return options instanceof TreeListDataSource ? options : new TreeListDataSource(options);
		    };
	
		    function isCellVisible() {
		        return this.style.display !== "none";
		    }
	
		    function sortCells(cells) {
		        var indexAttr = kendo.attr("index");
		        return cells.sort(function(a, b) {
		            a = $(a);
		            b = $(b);
	
		            var indexA = a.attr(indexAttr);
		            var indexB = b.attr(indexAttr);
	
		            if (indexA === undefined) {
		                indexA = $(a).index();
		            }
		            if (indexB === undefined) {
		                indexB = $(b).index();
		            }
	
		            indexA = parseInt(indexA, 10);
		            indexB = parseInt(indexB, 10);
		            return indexA > indexB ? 1 : (indexA < indexB ? -1 : 0);
		        });
		    }
	
		    function leafDataCells(container) {
		        var rows = container.find(">tr:not(.k-filter-row)");
	
		        var filter = function() {
		            var el = $(this);
		            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
		        };
	
		        var cells = $();
		        if (rows.length > 1) {
		            cells = rows.find("th")
		                .filter(filter)
		                .filter(function() { return this.rowSpan > 1; });
		        }
	
		        cells = cells.add(rows.last().find("th").filter(filter));
	
		        return sortCells(cells);
		    }
	
		    function createPlaceholders(options) {
		        var spans = [];
		        var className = options.className;
	
		        for (var i = 0, level = options.level; i < level; i++) {
		            spans.push(kendoDomElement("span", { className: className }));
		        }
	
		        return spans;
		    }
	
		    function columnsWidth(cols) {
		        var colWidth, width = 0;
	
		        for (var idx = 0, length = cols.length; idx < length; idx++) {
		            colWidth = cols[idx].style.width;
		            if (colWidth && colWidth.indexOf("%") == -1) {
		                width += parseInt(colWidth, 10);
		            }
		        }
	
		        return width;
		    }
	
		    function syncTableHeight(table1, table2) {
		       table1 = table1[0];
		       table2 = table2[0];
	
		       if (table1.rows.length && table2.rows.length && table1.rows.length !== table2.rows.length) {
		           var lockedHeigth = table1.offsetHeight;
		           var tableHeigth = table2.offsetHeight;
	
		           var row;
		           var diff;
		           if (lockedHeigth > tableHeigth) {
		               row = table2.rows[table2.rows.length - 1];
	
		               diff = lockedHeigth - tableHeigth;
		           } else {
		               row = table1.rows[table1.rows.length - 1];
	
		               diff = tableHeigth - lockedHeigth;
		           }
		           row.style.height = row.offsetHeight + diff + "px";
		       }
		    }
	
		    var TreeListPager = ui.Pager.extend({
		        options: {
		            name: "TreeListPager"
		        },
	
		        totalPages: function() {
		            var that = this;
		            var dataSource = that.dataSource;
	
		            if (dataSource && dataSource._filter) {
		                return ui.Pager.fn.totalPages.call(that);
		            }
	
		            return Math.ceil((that._collapsedTotal() || 0) / (that.pageSize() || 1));
		        },
	
		        _createDataSource: function(options) {
		            this.dataSource = kendo.data.TreeListDataSource.create(options.dataSource);
		        },
	
		        _collapsedTotal: function() {
		            var dataSource = this.dataSource;
		            return dataSource ? (dataSource.collapsedTotal() || 0) : 0;
		        }
		    });
	
		    var Editor = kendo.Observable.extend({
		        init: function(element, options) {
		            kendo.Observable.fn.init.call(this);
	
		            options = this.options = extend(true, {}, this.options, options);
	
		            this.element = element;
	
		            this.bind(this.events, options);
	
		            this.model = this.options.model;
	
		            this.fields = this._fields(this.options.columns);
	
		            this._initContainer();
	
		            this.createEditable();
		        },
	
		        events: [],
	
		        _initContainer: function() {
		            this.wrapper = this.element;
		        },
	
		        createEditable: function() {
		            var options = this.options;
	
		            this.editable = new ui.Editable(this.wrapper, {
		                fields: this.fields,
		                target: options.target,
		                clearContainer: options.clearContainer,
		                model: this.model,
		                change: options.change
		            });
		        },
	
		        _isEditable: function(column) {
		            return isColumnEditable(column, this.model);
		        },
	
		        _fields: function(columns) {
		            var fields = [];
		            var idx, length, column;
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                column = columns[idx];
	
		                if (this._isEditable(column)) {
		                    fields.push({
		                        field: column.field,
		                        format: column.format,
		                        editor: column.editor
		                    });
		                }
		            }
	
		            return fields;
		        },
	
		        end: function() {
		            return this.editable.end();
		        },
	
		        close: function() {
		            this.destroy();
		        },
	
		        destroy: function() {
		            this.editable.destroy();
		            this.editable.element
		                .find("[" + kendo.attr("container-for") + "]")
		                .empty()
		                .end()
		                .removeAttr(kendo.attr("role"));
	
		            this.model = this.wrapper = this.element = this.columns = this.editable = null;
		        }
		    });
	
		    var PopupEditor = Editor.extend({
		        init: function(element, options) {
		            Editor.fn.init.call(this, element, options);
	
		            this._attachHandlers();
		            kendo.cycleForm(this.wrapper);
	
		            this.open();
		        },
	
		        events: [
		            CANCEL,
		            SAVE
		        ],
	
		        options: {
		            window: {
		                modal: true,
		                resizable: false,
		                draggable: true,
		                title: "Edit",
		                visible: false
		            }
		        },
	
		        _initContainer: function() {
		            var options = this.options;
		            var formContent = [];
	
		            this.wrapper = $('<div class="k-popup-edit-form"/>')
		                .attr(kendo.attr("uid"), this.model.uid)
		                .append('<div class="k-edit-form-container"/>');
	
		            if (options.template) {
		                this._appendTemplate(formContent);
		                this.fields = [];
		            } else {
		                this._appendFields(formContent);
		            }
		            this._appendButtons(formContent);
	
		            new kendoDom.Tree(this.wrapper.children()[0]).render(formContent);
	
		            this.wrapper.appendTo(options.appendTo);
	
		            this.window = new ui.Window(this.wrapper, options.window);
		        },
	
		        _appendTemplate: function(form) {
		            var template = this.options.template;
	
		            if (typeof template === STRING) {
		                template = window.unescape(template);
		            }
	
		            template = kendo.template(template)(this.model);
	
		            form.push(kendoHtmlElement(template));
		        },
	
		        _appendFields: function(form) {
		            var idx, length, column;
		            var columns = this.options.columns;
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                column = columns[idx];
	
		                if (column.command) {
		                    continue;
		                }
	
		                form.push(kendoHtmlElement('<div class="k-edit-label"><label for="' + column.field + '">' + (column.title || column.field || "") + '</label></div>'));
	
		                if (this._isEditable(column)) {
		                    form.push(kendoHtmlElement('<div ' + kendo.attr("container-for") + '="' + column.field +
		                                '" class="k-edit-field"></div>'));
		                } else {
		                    form.push(kendoDomElement("div", {
		                            "class": "k-edit-field"
		                        },
		                        [ this.options.fieldRenderer(column, this.model) ]));
		                }
		            }
		        },
	
		        _appendButtons: function(form) {
		            form.push(kendoDomElement("div", {
		                "class": "k-edit-buttons k-state-default"
		            }, this.options.commandRenderer()));
		        },
	
		        _attachHandlers: function() {
		            var closeHandler = this._cancelProxy = proxy(this._cancel, this);
		            this.wrapper.on(CLICK + NS, ".k-grid-cancel", this._cancelProxy);
	
		            this._saveProxy = proxy(this._save, this);
		            this.wrapper.on(CLICK + NS, ".k-grid-update", this._saveProxy);
	
		            this.window.bind("close", function(e) {
		                if (e.userTriggered) {
		                    closeHandler(e);
		                }
		            });
		        },
	
		        _detachHandlers: function() {
		            this._cancelProxy = null;
		            this._saveProxy = null;
		            this.wrapper.off(NS);
		        },
	
		        _cancel: function(e) {
		            this.trigger(CANCEL, e);
		        },
	
		        _save: function() {
		            this.trigger(SAVE);
		        },
	
		        open: function() {
		            this.window.center().open();
		        },
	
		        close: function() {
		            this.window.bind("deactivate", proxy(this.destroy, this)).close();
		        },
	
		        destroy: function() {
		            this.window.destroy();
		            this.window = null;
		            this._detachHandlers();
	
		            Editor.fn.destroy.call(this);
		        }
		    });
	
		    var IncellEditor = Editor.extend({
		        destroy: function() {
		            var that = this;
	
		            that.editable.destroy();
	
		            that.editable.element
		                .off()
		                .empty()
		                .removeAttr(kendo.attr("role"));
	
		            that.model = that.wrapper = that.element = that.columns = that.editable = null;
		        }
		    });
	
		    var TreeList = DataBoundWidget.extend({
		        init: function(element, options) {
		            DataBoundWidget.fn.init.call(this, element, options);
	
		            isRtl = kendo.support.isRtl(element);
		            this._dataSource(this.options.dataSource);
		            this._aria();
		            this._columns();
		            this._layout();
		            this._navigatable();
		            this._selectable();
		            this._sortable();
		            this._resizable();
		            this._filterable();
		            this._attachEvents();
		            this._toolbar();
		            this._scrollable();
		            this._reorderable();
		            this._columnMenu();
		            this._minScreenSupport();
		            this._draggable();
		            this._pageable();
	
		            if (this.options.autoBind) {
		                this.dataSource.fetch();
		            }
	
		            if (this._hasLockedColumns) {
		                var widget = this;
		                this.wrapper.addClass("k-grid-lockedcolumns");
		                this._resizeHandler = function()  { widget.resize(); };
		                $(window).on("resize" + NS, this._resizeHandler);
		            }
	
		            kendo.notify(this);
		        },
	
		        _draggable: function() {
		            var that = this;
		            var editable = this.options.editable;
		            var dataSource = that.dataSource;
		            var idField = dataSource._modelIdField();
		            var parentIdField = dataSource._modelParentIdField();
		            var pageable = that._isPageable();
	
		            if (!editable || !editable.move) {
		                return;
		            }
	
		            this._dragging = new kendo.ui.HierarchicalDragAndDrop(this.wrapper, {
		                $angular: this.$angular,
		                autoScroll: true,
		                filter: "tbody>tr",
		                itemSelector: "tr",
		                allowedContainers: this.wrapper,
		                hintText: function(row) {
		                    var text = function() { return $(this).text(); };
		                    var separator = "<span class='k-header k-drag-separator' />";
		                    return row.children("td").map(text).toArray().join(separator);
		                },
		                contains: proxy(function(source, destination) {
		                    var dest = this.dataItem(destination);
		                    var src = this.dataItem(source);
	
		                    return src == dest || this.dataSource.contains(src, dest);
		                }, this),
		                itemFromTarget: function(target) {
		                    var tr = target.closest("tr");
		                    return { item: tr, content: tr };
		                },
		                dragstart: proxy(function(source) {
		                    this.wrapper.addClass("k-treelist-dragging");
	
		                    var model = this.dataItem(source);
	
		                    return this.trigger(DRAGSTART, { source: model });
		                }, this),
		                drag: proxy(function(e) {
		                    e.source = this.dataItem(e.source);
	
		                    this.trigger(DRAG, e);
		                }, this),
		                drop: proxy(function(e) {
		                    e.source = this.dataItem(e.source);
		                    e.destination = this.dataItem(e.destination);
	
		                    this.wrapper.removeClass("k-treelist-dragging");
	
		                    return this.trigger(DROP, e);
		                }, this),
		                dragend: proxy(function(e) {
		                    var dest = this.dataItem(e.destination);
		                    var src = this.dataItem(e.source);
		                    var originalSrcParentId = src[parentIdField];
		                    var originalSrcIndex = dataSource._indexInChildrenMap(src);
	
		                    if (pageable) {
		                        dataSource._removeFromChildrenMap(src);
		                        src[parentIdField] = dest ? dest[idField] : null;
	
		                        dataSource._initChildrenMapForParent(dest);
	
		                        // src.set() below will not work as the parent id is already set
		                        src[parentIdField] = originalSrcParentId;
		                    }
	
		                    var isPrevented = src.set("parentId", dest ? dest.id : null);
	
		                    if (pageable && isPrevented) {
		                        dataSource._removeFromChildrenMap(src);
		                        src[parentIdField] = originalSrcParentId;
		                        dataSource._removeFromChildrenMap(src);
		                        dataSource._insertInChildrenMap(src, originalSrcIndex);
		                    }
	
		                    e.source = src;
		                    e.destination = dest;
	
		                    this.trigger(DRAGEND, e);
		                }, this),
		                reorderable: false,
		                dropHintContainer: function(item) {
		                    return item.children("td:eq(1)"); // expandable column
		                },
		                dropPositionFrom: function(dropHint) {
		                    return dropHint.prevAll(".k-i-none").length > 0 ? "after" : "before";
		                }
		            });
		        },
	
		        itemFor: function(model) {
		            if (typeof model == "number") {
		                model = this.dataSource.get(model);
		            }
	
		            return this.tbody.find("[" + kendo.attr("uid") + "=" + model.uid + "]");
		        },
	
		        _itemFor: function(model) {
		            var that = this;
		            var table = that.lockedContent ? that.lockedTable : that.table;
	
		            if (typeof model == "number") {
		                model = this.dataSource.get(model);
		            }
	
		            return table.find("[" + kendo.attr("uid") + "=" + model.uid + "]");
		        },
	
		        _scrollable: function() {
		            if (this.options.scrollable) {
		                var scrollables = this.thead.closest(".k-grid-header-wrap");
		                var lockedContent = $(this.lockedContent)
		                    .bind("DOMMouseScroll" + NS + " mousewheel" + NS, proxy(this._wheelScroll, this));
	
		                this.content.bind("scroll" + NS, function() {
		                    scrollables.scrollLeft(this.scrollLeft);
		                    lockedContent.scrollTop(this.scrollTop);
		                });
	
	
		                var touchScroller = kendo.touchScroller(this.content);
	
		                if (touchScroller && touchScroller.movable) {
		                    this._touchScroller = touchScroller;
	
		                    touchScroller.movable.bind("change", function(e) {
		                        scrollables.scrollLeft(-e.sender.x);
		                        if (lockedContent) {
		                            lockedContent.scrollTop(-e.sender.y);
		                        }
		                    });
		                }
		            }
		        },
	
		        _wheelScroll: function (e) {
		            if (e.ctrlKey) {
		                return;
		            }
	
		            var delta = kendo.wheelDeltaY(e);
		            var lockedDiv = $(e.currentTarget);
	
		            if (delta) {
		                if (lockedDiv[0].scrollHeight > lockedDiv[0].clientHeight &&
		                    (lockedDiv[0].scrollTop < lockedDiv[0].scrollHeight - lockedDiv[0].clientHeight && delta < 0 ||
		                    lockedDiv[0].scrollTop > 0 && delta > 0)) {
		                    e.preventDefault();
		                }
		                //In Firefox DOMMouseScroll event cannot be canceled
		                lockedDiv.one("wheel" + NS, false);
	
		                this.content.scrollTop(this.content.scrollTop() + (-delta));
		            }
		        },
	
		        _progress: function() {
		            var messages = this.options.messages;
	
		            if (!this.tbody.find("tr").length) {
		                this._showStatus(
		                    kendo.template(
		                        "<span class='#= className #' /> #: messages.loading #"
		                    )({
		                        className: classNames.icon + " " + classNames.loading,
		                        messages: messages
		                    })
		                );
		            }
		        },
	
		        _error: function(e) {
		            if (!this.dataSource.rootNodes().length) {
		                this._render({ error: e });
		            }
		        },
	
		        refresh: function(e) {
		            e = e || {};
	
		            if (e.action == "itemchange" && this.editor) {
		                return;
		            }
	
		            if (this.trigger(DATABINDING)) {
		                return;
		            }
		            var current = $(this.current());
		            var isCurrentInHeader = false;
		            var currentIndex;
	
		            this._cancelEditor();
	
		            this._render();
	
		            this._adjustHeight();
	
		            if (this.options.navigatable) {
		                if (this._isActiveInTable() || this.editor) {
		                    isCurrentInHeader = current.is("th");
		                    currentIndex = Math.max(this.cellIndex(current), 0);
		                }
		                this._restoreCurrent(currentIndex, isCurrentInHeader);
		            }
	
		            this.trigger(DATABOUND);
		        },
	
		        _angularFooters: function(command) {
		            var i, footer, aggregates;
		            var allAggregates = this.dataSource.aggregates();
		            var footerRows = this._footerItems();
	
		            for (i = 0; i < footerRows.length; i++) {
		                footer = footerRows.eq(i);
		                aggregates = allAggregates[footer.attr("data-parentId")];
	
		                this._angularFooter(command, footer.find("td").get(), aggregates);
		            }
		        },
	
		        _angularFooter: function(command, cells, aggregates) {
		            var columns = this.columns;
		            this.angular(command, function() {
		                return {
		                    elements: cells,
		                    data: map(columns, function(col){
		                        return {
		                            column: col,
		                            aggregate: aggregates && aggregates[col.field]
		                        };
		                    })
		                };
		            });
		        },
	
		        items: function() {
		            if (this._hasLockedColumns) {
		                return this._items(this.tbody).add(this._items(this.lockedTable));
		            } else {
		                return this._items(this.tbody);
		            }
		        },
	
		        _items: function(container) {
		            return container.find("tr").filter(function() {
		                return !$(this).hasClass(classNames.footerTemplate);
		            });
		        },
	
		        _footerItems: function() {
		            var container = this.tbody;
		            if (this._hasLockedColumns) {
		                container = container.add(this.lockedTable);
		            }
	
		            return container.find("tr").filter(function() {
		                return $(this).hasClass(classNames.footerTemplate);
		            });
		        },
	
		        dataItems: function() {
		            var dataItems = kendo.ui.DataBoundWidget.fn.dataItems.call(this);
		            if (this._hasLockedColumns) {
		                var n = dataItems.length, tmp = new Array(2 * n);
		                for (var i = n; --i >= 0;) {
		                    tmp[i] = tmp[i + n] = dataItems[i];
		                }
		                dataItems = tmp;
		            }
	
		            return dataItems;
		        },
	
		        _showStatus: function(message) {
		            var status = this.element.find(".k-status");
		            var content = $(this.content).add(this.lockedContent);
	
		            if (!status.length) {
		                status = $("<div class='k-status' />").appendTo(this.element);
		            }
	
		            this._contentTree.render([]);
		            if (this._hasLockedColumns) {
		                this._lockedContentTree.render([]);
		            }
	
		            content.hide();
	
		            status.html(message);
		        },
	
		        _hideStatus: function() {
		            this.element.find(".k-status").remove();
	
		            $(this.content).add(this.lockedContent).show();
		        },
	
		        _adjustHeight: function() {
		            var that = this;
		            var element = this.element;
		            var contentWrap = element.find(DOT + classNames.gridContentWrap);
		            var header = element.find(DOT + classNames.gridHeader);
		            var toolbar = element.find(DOT + classNames.gridToolbar);
		            var pagerHeight = that._isPageable() && that.pager && that.pager.element.is(":visible") ? outerHeight(that.pager.element) : 0;
		            var height;
		            var scrollbar = kendo.support.scrollbar();
	
		            element.css(HEIGHT, this.options.height);
	
		            // identical code found in grid & scheduler :(
		            var isHeightSet = function(el) {
		                var initialHeight, newHeight;
		                if (el[0].style.height) {
		                    return true;
		                } else {
		                    initialHeight = el.height();
		                }
	
		                el.height("auto");
		                newHeight = el.height();
		                el.height("");
	
		                return (initialHeight != newHeight);
		            };
	
		            if (isHeightSet(element)) {
		                height = element.height() - outerHeight(header) - outerHeight(toolbar) - pagerHeight;
	
		                contentWrap.height(height);
	
		                if (this._hasLockedColumns) {
		                    scrollbar = this.table[0].offsetWidth > this.table.parent()[0].clientWidth ? scrollbar : 0;
		                    this.lockedContent.height(height - scrollbar);
		                }
		            }
		        },
	
		        _resize: function() {
		            this._applyLockedContainersWidth();
		            this._adjustHeight();
		        },
	
		        _minScreenSupport: function() {
		            var any = this.hideMinScreenCols();
	
		            if (any) {
		                this.minScreenResizeHandler = proxy(this.hideMinScreenCols, this);
		                $(window).on("resize", this.minScreenResizeHandler);
		            }
		        },
		        hideMinScreenCols: function() {
		            var cols = this.columns,
		                any = false,
		                screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	
		            for (var i = 0; i < cols.length; i++) {
		                var col = cols[i];
		                var minWidth = col.minScreenWidth;
		                if (minWidth !== undefined && minWidth !== null) {
		                    any = true;
		                    if (minWidth > screenWidth) {
		                        this.hideColumn(col);
		                    } else {
		                        this.showColumn(col);
		                    }
		                }
		            }
		            return any;
		        },
	
		        destroy: function() {
		            DataBoundWidget.fn.destroy.call(this);
	
		            var dataSource = this.dataSource;
	
		            dataSource.unbind(CHANGE, this._refreshHandler);
		            dataSource.unbind(ERROR, this._errorHandler);
		            dataSource.unbind(PROGRESS, this._progressHandler);
	
		            this._navigatableTables = null;
		            this._current = null;
	
		            if (this._resizeHandler) {
		                $(window).off("resize" + NS, this._resizeHandler);
		            }
	
		            if (this._dragging) {
		                this._dragging.destroy();
		                this._dragging = null;
		            }
	
		            if (this.resizable) {
		                this.resizable.destroy();
		                this.resizable = null;
		            }
	
		            if (this.reorderable) {
		                this.reorderable.destroy();
		                this.reorderable = null;
		            }
	
		            if (this._draggableInstance && this._draggableInstance.element) {
		                this._draggableInstance.destroy();
		                this._draggableInstance = null;
		            }
	
		            if (this.minScreenResizeHandler) {
		                $(window).off("resize", this.minScreenResizeHandler);
		            }
	
		            this._destroyEditor();
	
		            this.element.off(NS);
		            this.wrapper.off(NS);
	
		            if (this._touchScroller) {
		                this._touchScroller.destroy();
		            }
	
		            this._destroyPager();
	
		            if (dataSource) {
		                dataSource._dataMaps = null;
		            }
	
		            this._autoExpandable = null;
	
		            this._refreshHandler = this._errorHandler = this._progressHandler = this._dataSourceFetchProxy = null;
	
		            this.thead =
		                this.content =
		                this.tbody =
		                this.table =
		                this.element =
		                this.lockedHeader =
		                this.lockedContent = null;
	
		            this._statusTree =
		                this._headerTree =
		                this._contentTree =
		                this._lockedHeaderColsTree =
		                this._lockedContentColsTree =
		                this._lockedHeaderTree =
		                this._lockedContentTree = null;
		        },
	
		        options: {
		            name: "TreeList",
		            columns: [],
		            autoBind: true,
		            scrollable: true,
		            selectable: false,
		            sortable: false,
		            toolbar: null,
		            height: null,
		            columnMenu: false,
		            messages: {
		                noRows: "No records to display",
		                loading: "Loading...",
		                requestFailed: "Request failed.",
		                retry: "Retry",
		                commands: {
		                    edit: "Edit",
		                    update: "Update",
		                    canceledit: "Cancel",
		                    create: "Add new record",
		                    createchild: "Add child record",
		                    destroy: "Delete",
		                    excel: "Export to Excel",
		                    pdf: "Export to PDF"
		                }
		            },
		            excel: {
		                hierarchy: true
		            },
		            resizable: false,
		            filterable: false,
		            editable: false,
		            reorderable: false,
		            pageable: false
		        },
	
		        events: [
		            CHANGE,
		            BEFORE_EDIT,
		            EDIT,
		            PAGE,
		            SAVE,
		            SAVE_CHANGES,
		            REMOVE,
		            EXPAND,
		            COLLAPSE,
		            DATABINDING,
		            DATABOUND,
		            CANCEL,
		            DRAGSTART,
		            DRAG,
		            DROP,
		            DRAGEND,
		            FILTERMENUINIT,
		            ITEM_CHANGE,
		            CELL_CLOSE,
		            FILTERMENUOPEN,
		            COLUMNHIDE,
		            COLUMNSHOW,
		            COLUMNREORDER,
		            COLUMNRESIZE,
		            COLUMNMENUINIT,
		            COLUMNMENUOPEN,
		            COLUMNLOCK,
		            COLUMNUNLOCK
		        ],
	
		        _toggle: function(model, expand) {
		            var that = this;
		            var defaultPromise = $.Deferred().resolve().promise();
		            var loaded = model.loaded();
	
		             if (that._isIncellEditable() && that.editor) {
		                // manually trigger change as the expand/collapse icons are not focusable
		                $(activeElement()).change();
		                that.closeCell();
		            }
	
		            // reset error state
		            if (model._error) {
		                model.expanded = false;
		                model._error = undefined;
		            }
	
		            // do not load items that are currently loading
		            if (!loaded && model.expanded) {
		                return defaultPromise;
		            }
	
		            // toggle expanded state
		            if (typeof expand == "undefined") {
		                expand = !model.expanded;
		            }
	
		            model.expanded = expand;
	
		            function afterModelLoaded() {
		                that._toggleData();
		                that._render();
		                that._syncLockedContentHeight();
		            }
	
		            if (!loaded) {
		                defaultPromise = this.dataSource.load(model)
		                    .always(proxy(function() {
		                        afterModelLoaded();
		                    }, this));
		            }
	
		            afterModelLoaded();
	
		            return defaultPromise;
		        },
	
		        _toggleData: function() {
		            var that = this;
	
		            if (that._isPageable()) {
		                that._togglePageableData();
		            }
		        },
	
		        _togglePageableData: function() {
		            var that = this;
		            var dataSource = that.dataSource;
		            var data = dataSource._getData();
		            var result;
		            var queryOptions = dataSource._defaultPageableQueryOptions();
	
		            that._renderProgress(true);
	
		            var childrenMap = dataSource._getChildrenMap() || dataSource.childrenMap(dataSource._getData());
	
		            dataSource._processDataItemsState(data, childrenMap);
	
		            result = dataSource._processPageableQuery(data, queryOptions);
	
		            queryOptions.childrenMap = result.childrenMap;
		            queryOptions.filteredChildrenMap = result.filteredChildrenMap;
	
		            dataSource._aggregateResult = dataSource._calculateAggregates(result.dataToAggregate, queryOptions);
	
		            dataSource.view(result.data);
	
		            dataSource._calculateCollapsedTotal();
	
		            that._refreshPager();
	
		            that._renderProgress(false);
		        },
	
		        _refreshPager: function() {
		            var pager = this.pager;
	
		            if (pager) {
		                pager.refresh();
		            }
		        },
	
		        expand: function(row) {
		            return this._toggle(this.dataItem(row), true);
		        },
	
		        collapse: function(row) {
		            return this._toggle(this.dataItem(row), false);
		        },
	
		        _toggleChildren: function(e) {
		            var icon = $(e.currentTarget);
		            var model = this.dataItem(icon);
	
		            if (!model) {
		                return;
		            }
	
		            var event = !model.expanded ? EXPAND : COLLAPSE;
	
		            if (!this.trigger(event, { model: model })) {
		                this._toggle(model);
		            }
	
		            e.preventDefault();
		        },
	
		        _navigatable: function() {
		            var that = this;
	
		            if (!that.options.navigatable) {
		                return;
		            }
		            var tables = that.table.add(that.lockedTable);
	
		            var headerTables = that.thead.parent().add($(">table", that.lockedHeader));
		            if (that.options.scrollable) {
		                //add the header table when the widget is scrollable
		                tables = tables.add(headerTables);
		                //data tables will recive first focus on TAB
		                headerTables.attr(TABINDEX, -1);
		            }
	
		            this._navigatableTables = tables;
	
		            tables
		                //handle click on tables, will attempt to focus the table
		                .on((kendo.support.touch ? "touchstart" + NS : "mousedown" + NS), NAVROW + ">:visible", proxy(that._tableClick, that))
		                .on("focus" + NS, proxy(that._tableFocus, that))
		                .on("focusout" + NS, proxy(that._tableBlur, that))
		                .on("keydown" + NS, proxy(that._tableKeyDown, that));
		        },
	
		        cellIndex: function(td) {
		            var lockedColumnOffset = 0;
	
		            if (this.lockedTable && !$.contains(this.lockedTable[0], td[0])) {
		                lockedColumnOffset = leafColumns(lockedColumns(this.columns)).length;
		            }
	
		            return $(td).parent().children().index(td) + lockedColumnOffset;
		        },
	
		        _isActiveInTable: function() {
		            var active = kendo._activeElement();
	
		            if (!active) { return false; }
	
		            return this.table[0] === active ||
		                $.contains(this.table[0], active) ||
		                (this.lockedTable &&
		                    (this.lockedTable[0] === active || $.contains(this.lockedTable[0], active))
		                );
		        },
	
		        _restoreCurrent: function(currentIndex, isCurrentInHeader) {
		            var rowIndex;
		            var row;
		            var td;
	
		            if (currentIndex === undefined || currentIndex < 0) {
		                return;
		            }
	
		            if (this._current) {
		                this._current.removeClass("k-state-focused");
		            }
	
		            if (isCurrentInHeader) {
		                this.current(this.thead.find("th").eq(currentIndex));
		            } else {
		                rowIndex = 0;
		                currentIndex = 0;
	
		                row = $();
	
		                if (this.lockedTable) {
		                    row = this.lockedTable.find(">tbody>tr:visible").eq(rowIndex);
		                }
		                row = row.add(this.tbody.children().eq(rowIndex));
	
		                td = row.find(">td:visible")
		                    .eq(currentIndex);
	
		                this.current(td);
		            }
	
		            if (this._current) {
		                focusTable(this._current.closest("table")[0], true);
		            }
		        },
	
		        current: function (newCurrent) {
		            var current = this._current;
		            newCurrent = $(newCurrent);
	
		            if(newCurrent.length && (!current || current[0] !== newCurrent[0])) {
		                this._updateCurrentAttr(current, newCurrent);
	
		                this._scrollCurrent();
		            }
	
		            if (newCurrent && newCurrent.length) {
		                this._lastCellIndex = newCurrent.parent().children(DATA_CELL).index(newCurrent);
		            }
	
		            return this._current;
		        },
	
		        _setCurrent: function(newCurrent) {
		            var that = this;
		            newCurrent = $(newCurrent);
	
		            if (newCurrent[0]) {
		                that._current = newCurrent;
		                that._updateCurrentAttr(that._current, newCurrent);
		                that._scrollCurrent();
		            }
	
		            return that._current;
		        },
	
		        _scrollCurrent: function() {
		            var current = this._current;
		            var scrollable = this.options.scrollable;
	
		            if (!current || !scrollable) {
		                return;
		            }
	
		            var row = current.parent();
		            var tableContainer = row.closest("table").parent();
	
		            var isInLockedContainer = tableContainer.is(".k-grid-content-locked,.k-grid-header-locked");
		            var isInContent = tableContainer.is(".k-grid-content-locked,.k-grid-content");
	
		            var scrollableContainer = $(this.content)[0];
	
		            //adjust scroll vertically
		            if (isInContent) {
		                this._scrollTo(this._relatedRow(row)[0], scrollableContainer);
		            }
	
		            if (this.lockedContent) {
		                //sync locked and non-locked content scrollTop
		                this.lockedContent[0].scrollTop = scrollableContainer.scrollTop;
		            }
	
		            //adjust scroll horizontally, if not inside locked tables
		            if (!isInLockedContainer) {
		                this._scrollTo(current[0], scrollableContainer);
		            }
		        },
	
		        _scrollTo: function(element, container) {
		            var elementToLowercase = element.tagName.toLowerCase();
		            var isHorizontal =  elementToLowercase === "td" || elementToLowercase === "th";
		            var elementOffset = element[isHorizontal ? "offsetLeft" : "offsetTop"];
		            var elementOffsetDir = element[isHorizontal ? "offsetWidth" : "offsetHeight"];
		            var containerScroll = container[isHorizontal ? "scrollLeft" : "scrollTop"];
		            var containerOffsetDir = container[isHorizontal ? "clientWidth" : "clientHeight"];
		            var bottomDistance = elementOffset + elementOffsetDir;
		            var result = 0;
		            var ieCorrection = 0;
		            var firefoxCorrection = 0;
	
		            if (isRtl && isHorizontal) {
		                var table = $(element).closest("table")[0];
		                if (browser.msie) {
		                    ieCorrection = table.offsetLeft;
		                } else if (browser.mozilla) {
		                    firefoxCorrection = table.offsetLeft - kendo.support.scrollbar();
		                }
		            }
	
		            containerScroll = Math.abs(containerScroll + ieCorrection - firefoxCorrection);
	
		            if (containerScroll > elementOffset) {
		                result = elementOffset;
		            } else if (bottomDistance > (containerScroll + containerOffsetDir)) {
		                if (elementOffsetDir <= containerOffsetDir) {
		                    result = (bottomDistance - containerOffsetDir);
		                } else {
		                    result = elementOffset;
		                }
		            } else {
		                result = containerScroll;
		            }
	
		            result = Math.abs(result + ieCorrection) + firefoxCorrection;
	
		            container[isHorizontal ? "scrollLeft" : "scrollTop"] = result;
		        },
	
		        _aria: function() {
		            var id = this.element.attr("id") || "aria";
	
		            if (id) {
		                this._elementId = id + "_active_element";
		            }
		        },
	
		        _currentDataIndex: function(table, current) {
		            var index = current.attr("data-index");
	
		            if (!index) {
		                return undefined;
		            }
	
		            var lockedColumnsCount = lockedColumns(this.columns).length;
		            if (lockedColumnsCount && !table.closest("div").hasClass("k-grid-content-locked")[0]) {
		                return index - lockedColumnsCount;
		            }
	
		            return index;
		        },
	
		        _prevVerticalCell: function(container, current) {
		            var cells;
		            var row = current.parent();
		            var rows = container.children(NAVROW);
		            var rowIndex = rows.index(row);
		            //get data-index in case of last level of multi-level columns
		            var index = this._currentDataIndex(container, current);
	
		            //current is in the header, but not at the last level of multi-level columns
		            if (index || current.hasClass("k-header")) {
		                cells = parentColumnsCells(current);
		                return cells.eq(cells.length - 2);
		            }
	
		            index = Math.max(row.children(DATA_CELL).index(current), this._lastCellIndex || 0);
	
		            //if current is inside filter row
		            if (row.hasClass("k-filter-row")) {
		                return leafDataCells(container).filter(isCellVisible).eq(index);
		            }
	
		            //move up to header container
		            if (rowIndex == -1) {
		                //is there filter row in the header container
		                row = container.find("tr.k-filter-row:visible");
		                if (!row[0]) {
		                    return leafDataCells(container).filter(isCellVisible).eq(index);
		                }
		            } else {
		                row =  rowIndex === 0 ? $() : rows.eq(rowIndex - 1);
		            }
	
		            cells = row.children(DATA_CELL);
		            if (cells.length > index) {
		                return cells.eq(index);
		            }
	
		            return cells.eq(0);
		        },
	
		        _nextVerticalCell: function(container, current) {
		            var cells;
		            var row = current.parent();
		            var rows = container.children(NAVROW);
		            var rowIndex = rows.index(row);
		            //get data-index in case of last level of multi-level columns
		            var index = this._currentDataIndex(container, current);
	
		            //current is in the header, but not at the last level of multi-level columns
		            //and we are not changing the table
		            if (rowIndex != -1 && index === undefined && current.hasClass("k-header")) {
		                return childColumnsCells(current).eq(1);
		            }
	
		            index = index ? parseInt(index, 10) : row.children(DATA_CELL).index(current);
		            index = Math.max(index, this._lastCellIndex || 0);
	
		            //move down to data container
		            if (rowIndex == -1) {
		                row = rows.eq(0);
		            } else {
		                row = rows.eq(rowIndex + current[0].rowSpan);
		            }
	
		            var tmpIndex = index;
		            //in case of last level of multi-level columns the index should be updated depending on the hidden columns
		            if (this._currentDataIndex(container, current) !== undefined) {
		                var currentRowCells = row.children(":not(.k-group-cell):not(.k-hierarchy-cell)");
		                var hiddenColumns = currentRowCells.filter(":hidden");
		                for(var idx = 0, length = hiddenColumns.length; idx < length; idx++) {
		                    if (currentRowCells.index(hiddenColumns[idx]) < index) {
		                        tmpIndex--;
		                    }
		                }
		            }
		            index = tmpIndex;
	
		            cells = row.children(DATA_CELL);
		            if (cells.length > index) {
		                return cells.eq(index);
		            }
	
		            return cells.eq(0);
		        },
	
		        _verticalContainer: function(container, up) {
		            var table = container.parent();
		            var length = this._navigatableTables.length;
		            var step = Math.floor(length / 2);
		            var index = inArray(table[0], this._navigatableTables);
	
		            if (up) {
		                step *= -1;
		            }
		            index += step;
	
		            if (index >= 0 || index < length) {
		                table = this._navigatableTables.eq(index);
		            }
	
		            return table.find(up ? "thead" : "tbody");
		        },
	
		        _updateCurrentAttr: function(current, next) {
		            var headerId = $(current).data("headerId");
	
		            $(current)
		                .removeClass(classNames.focused)
		                .closest("table")
		                .removeAttr("aria-activedescendant");
	
		            if(headerId){
		                headerId = headerId.replace(this._elementId, "");
		                $(current).attr("id", headerId);
		            }else{
		                $(current).removeAttr("id");
		            }
	
		            next
		                .data("headerId", next.attr("id"))
		                .attr("id", this._elementId)
		                .addClass(classNames.focused)
		                .closest("table")
		                .attr("aria-activedescendant", this._elementId);
	
		            this._current = next;
		        },
	
		        _tableKeyDown: function(e) {
		            var handled = false;
		            var current = this.current();
		            var target = $(e.target);
		            var canHandle = !e.isDefaultPrevented() && !target.is(":button,a,:input,a>.k-icon");
	
		            current = current ? current : $(this.lockedTable).add(this.table).find(FIRSTNAVITEM);
	
		            if (canHandle && e.keyCode == keys.UP) {
		                handled = this._moveUp(current, e.shiftKey);
		            }
	
		            if (canHandle && e.keyCode == keys.DOWN) {
		                handled = this._moveDown(current, e.shiftKey);
		            }
	
		            if (canHandle && e.keyCode == (isRtl ? keys.LEFT : keys.RIGHT)) {
		                if (e.altKey) {
		                    handled = this._handleExpand(current);
		                } else {
		                    handled = this._moveRight(current);
		                }
		            }
	
		            if (canHandle && e.keyCode == (isRtl ? keys.RIGHT : keys.LEFT)) {
		                if (e.altKey) {
		                    handled = this._handleCollapse(current);
		                } else {
		                    handled = this._moveLeft(current);
		                }
		            }
	
		            if (canHandle && e.keyCode == keys.PAGEDOWN) {
		                handled = this._handlePageDown();
		            }
	
		            if (canHandle && e.keyCode == keys.PAGEUP) {
		                handled = this._handlePageUp();
		            }
	
		            if (e.keyCode == keys.ENTER || e.keyCode == keys.F2) {
		                handled = this._handleEnterKey(current, e.currentTarget, target);
		            }
	
		            if (e.keyCode == keys.ESC) {
		                handled = this._handleEscKey(current, e.currentTarget);
		            }
	
		            if (canHandle && e.keyCode == keys.HOME) {
		                handled = this._handleHome(current, e.ctrlKey);
		            }
	
		            if (canHandle && e.keyCode == keys.END) {
		                handled = this._handleEnd(current, e.ctrlKey);
		            }
	
		            if (e.keyCode == keys.TAB) {
		                handled = this._handleTabKey(current, e.currentTarget, e.shiftKey);
		            }
	
		            if (handled) {
		                //prevent scrolling while pressing the keys
		                e.preventDefault();
		                //required in hierarchy
		                e.stopPropagation();
		            }
		        },
	
		        _handleExpand: function(current) {
		            var that = this;
		            var row = current.parent();
		            var model = that.dataItem(row);
	
		            if (current.hasClass("k-header")) {
		                return false;
		            }
	
		            if (model && model.hasChildren && !model.expanded && !that.trigger(EXPAND, { model: model })) {
		                this.expand(row);
		                return true;
		            }
	
		            return false;
		        },
	
		        _handleCollapse: function(current) {
		            var that = this;
		            var row = current.parent();
		            var model = that.dataItem(row);
	
		            if (current.hasClass("k-header")) {
		                return false;
		            }
	
		            if (model && model.hasChildren && model.expanded && !that.trigger(COLLAPSE, { model: model })) {
		                that.collapse(row);
		                return true;
		            }
	
		            return false;
		        },
	
		        _handleHome: function(current, ctrl) {
		            var row = current.parent();
		            var rowContainer = row.parent();
		            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
		            var isInBody = rowContainer[0] === this.tbody[0];
		            var prev;
	
		            if (ctrl) {
		                if (this.lockedTable) {
		                    prev = this.lockedTable.find(FIRSTNAVITEM);
		                } else {
		                    prev = this.table.find(FIRSTNAVITEM);
		                }
		            } else if (isInBody || isInLockedTable) {
		                if (isInBody && this.lockedTable) {
		                    row = this._relatedRow(row);
		                }
		                prev = row.children(NAVCELL + ":first");
		            }
	
		            if (prev && prev.length) {
		                this.current(prev);
		                return true;
		            }
		        },
	
		        _handleEnd: function(current, ctrl) {
		            var row = current.parent();
		            var rowContainer = row.parent();
		            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
		            var isInBody = rowContainer[0] === this.tbody[0];
		            var next;
	
		            if (ctrl) {
		                next = this.table.find(LASTITEMROW + ">" + NAVCELL + ":last");
		            } else if (isInBody || isInLockedTable) {
		                if (!isInBody && this.lockedTable) {
		                    row = this._relatedRow(row);
		                }
		                next = row.children(NAVCELL + ":last");
		            }
	
		            if (next && next.length) {
		                this.current(next);
		                return true;
		            }
		        },
	
		        _handlePageDown: function() {
		            var that = this;
	
		            if (!that._isPageable()) {
		                return false;
		            }
	
		            that.dataSource._restorePageSizeAfterAddChild();
		            that.dataSource.page(that.dataSource.page() + 1);
	
		            return true;
		        },
	
		        _handlePageUp: function() {
		            var that = this;
	
		            if (!that._isPageable()) {
		                return false;
		            }
	
		            that.dataSource._restorePageSizeAfterAddChild();
		            that.dataSource.page(that.dataSource.page() - 1);
	
		            return true;
		        },
	
		        _handleEscKey: function(current, currentTable) {
		            var active = kendo._activeElement();
		            var currentIndex;
		            var that = this;
		            var row;
		            var cellIndex;
	
		            if (!current || !current.parent().hasClass("k-grid-edit-row")) {
		                if (current.has(active).length) {
		                    // return focus back to the table
		                    focusTable(currentTable, true);
	
		                    return true;
		                }
		                return false;
		            }
	
		            if (that._isIncellEditable()) {
		                row = current.parent();
		                cellIndex = current.index();
	
		                that.closeCell(true);
	
		                // refresh the current element as the DOM element reference can be changed after render()
		                // moving this to closeCell() causes flickering when clicking on a cell and then on another
		                // as 'k-state-focused' is shown for the closing cell and then added to the newly edited cell
		                that._setCurrent(row.children().eq(cellIndex));
		            } else {
		                currentIndex = $(current).parent().index();
		                if (active) {
		                    active.blur();
		                }
		                this.cancelRow();
		                if (currentIndex >= 0) {
		                    this.current(this.items().eq(currentIndex).children(NAVCELL).first());
		                }
		            }
	
		            if (browser.msie && browser.version < 9) {
		                document.body.focus();
		            }
	
		            focusTable(currentTable, true);
	
		            return true;
		        },
	
		        _handleEnterKey: function(current, currentTable, target) {
		            var editable = this.options.editable;
		            var container = target.closest("[role=gridcell]");
		            var focusable;
	
		            if (!target.is("table") && !$.contains(current[0], target[0])) {
		                current = container;
		            }
	
		            if (current.is("th")) {
		                // sort the column, if possible
		                current.find(".k-link").click();
		                return true;
		            }
	
		            focusable = current.find(":kendoFocusable:first");
		            if (focusable[0] && current.hasClass("k-state-focused")) {
		                focusable.focus();
	
		                return true;
		            }
	
		            if (editable && !target.is(":button,.k-button,textarea")) {
		                if (!container[0]) {
		                    container = current;
		                }
	
		                this._handleEditing(container, false, currentTable);
	
		                return true;
		            }
	
		            return false;
		        },
	
		        _handleTabKey: function(current, currentTable, shiftKey) {
		            var that = this;
		            var incellEditing = that.options.editable && that._isIncellEditable();
		            var cell;
	
		            if (!incellEditing || current.is("th")) {
		                return false;
		            }
	
		            cell = $(activeElement()).closest(DOT + classNames.editCell);
	
		            if (cell[0] && cell[0] !== current[0]) {
		                current = cell;
		            }
	
		            cell = that._tabNext(current, currentTable, shiftKey);
	
		            if (cell.length) {
		                that._handleEditing(current, cell, cell.closest(TABLE));
		                return true;
		            } else {
		                that._preventPageSizeRestore = false;
		            }
	
		            return false;
		        },
	
		        _tabNext: function (current, currentTable, back) {
		            var that = this;
		            var switchRow = true;
		            var next = back ? current.prevAll(DATA_CELL + ":first") : current.nextAll(":visible:first");
	
		            if (!next.length) {
		                next = current.parent();
		                if (that.lockedTable) {
		                    switchRow = (back && currentTable == that.lockedTable[0]) || (!back && currentTable == that.table[0]);
		                    next = that._relatedRow(next);
		                }
	
		                if (switchRow) {
		                    next = next[back ? "prevAll" : "nextAll"]("tr:not(.k-grouping-row):not(.k-detail-row):visible:first");
		                }
		                next = next.children(DATA_CELL + (back ? ":last" : ":first"));
	
		                that.dataSource._restorePageSizeAfterAddChild();
		            }
	
		            return next;
		        },
	
		        _handleEditing: function(current, next, table) {
		            var that = this,
		                active = $(kendo._activeElement()),
		                isIE = browser.msie,
		                editContainer,
		                focusable,
		                isEdited;
		            var editable = that.options.editable && that.options.editable.update !== false;
		            var incellEditing = that._isIncellEditable();
		            var nextFocusableCellRowIndex = $(next).parents("tr").index();
		            var nextFocusableCellIndex = $(next).index();
	
		            table = $(table);
	
		            if (incellEditing) {
		                isEdited = current.hasClass(classNames.editCell);
		            } else {
		                isEdited = current.parent().hasClass("k-grid-edit-row");
		            }
	
		            if (that.editor) {
		                editContainer = that.editor.wrapper;
		                if (editContainer && $.contains(editContainer[0], active[0])) {
		                    if (browser.opera) {
		                        active.blur().change().triggerHandler("blur");
		                    } else {
		                        active.blur();
		                        if (isIE) {
		                            //IE10 with jQuery 1.9.x does not trigger blur handler
		                            //numeric textbox does trigger change
		                            active.blur();
		                        }
		                    }
		                }
	
		                if (!that.editor) {
		                    focusTable(table);
		                    return;
		                }
	
		                if (that.editor.end()) {
		                    if (incellEditing) {
		                        that._preventPageSizeRestore = true;
		                        that.closeCell();
		                        that._preventPageSizeRestore = false;
		                    } else {
		                        that.saveRow();
		                        isEdited = true;
		                    }
		                } else {
		                    if (incellEditing) {
		                        that.current(editContainer);
		                    } else {
		                        that.current(editContainer.children().filter(NAVCELL).first());
		                    }
	
		                    focusable = editContainer.find(":kendoFocusable:first")[0];
		                    if (focusable) {
		                        focusable.focus();
		                    }
		                    return;
		                }
		            }
	
		            // the next cell to focus might be re-rendered, so update the reference to it if it is an element
		            next = $(next).length ? $(table.find("tbody")).children().eq(nextFocusableCellRowIndex).children().eq(nextFocusableCellIndex) : next;
	
		            if (next) {
		                that.current(next);
		            }
	
		            focusTable(table, true);
	
		            if (!editable) {
		                return;
		            }
	
		            if ((!isEdited && !next) || next) {
		                var currentIndex = that.current().index();
	
		                if (incellEditing) {
		                    that.editCell(that.current());
		                } else {
		                    that.editRow(that.current().parent());
		                    that.current(that.editor.wrapper.children().eq(currentIndex));
		                    that.current().removeClass("k-state-focused");
		                }
		            } else {
		                that.dataSource._restorePageSizeAfterAddChild();
		            }
		        },
	
		        _moveRight: function(current) {
		            var next = current.nextAll(NAVCELL).first();
		            var row = current.parent();
	
		            if (current.hasClass("k-header")) {
		                next = current.nextAll(NAVHEADER).first();
		                if(!next[0] && this.lockedTable && current.closest("table")[0] === this.lockedHeader.find("table")[0]) {
		                    next = this.thead.find(NAVHEADER + ":first");
		                }
		            }
	
		            if (!next[0] && this.lockedTable && current.closest("table")[0] === this.lockedTable[0]) {
		               next = this._relatedRow(row).children(NAVCELL).first();
		            }
	
		            if (next[0] && next[0] !== current[0]) {
		                focusTable(next.closest("table"), true);
		            }
	
		            this.current(next);
	
		            return true;
		        },
	
		        _moveLeft: function(current) {
		            var prev = current.prevAll(NAVCELL).first();
		            var row = current.parent();
	
		            if (current.hasClass("k-header")) {
		                prev = current.prevAll(NAVHEADER).first();
		                if(!prev[0] && this.lockedTable && current.closest("table")[0] === this.thead.parent()[0]) {
		                    prev = this.lockedHeader.find(">table>thead>tr>"+ NAVHEADER + ":last");
		                }
		            }
	
		            if (!prev[0] && this.lockedTable && current.closest("table")[0] === this.table[0]) {
		               prev = this._relatedRow(row).children(NAVCELL).last();
		            }
	
		            if (prev[0] && prev[0] !== current[0]) {
		                focusTable(prev.closest("table"), true);
		            }
	
		            this.current(prev);
	
		            return true;
		        },
	
		        _moveUp: function(current, shiftKey) {
		            var container = current.parent().parent();
		            var prev;
	
		            if (shiftKey) {
		               prev = current.parent();
		               prev = prev.prevAll(ITEMROW + ":first");
		               prev = current.parent().is(ITEMROW) ? prev.children().eq(current.index()) : prev.children(DATA_CELL + ":last" );
		            } else {
		               prev = this._prevVerticalCell(container, current);
		               if (!prev[0]) {
		                  this._lastCellIndex = 0;
		                  container = this._verticalContainer(container, true);
	
		                  prev = this._prevVerticalCell(container, current);
	
		                  if (prev[0]) {
		                      focusTable(container.parent(), true);
		                  }
		               }
		            }
	
		            var tmp = this._lastCellIndex || 0;
		            this.current(prev);
		            this._lastCellIndex = tmp;
	
		            return true;
		        },
	
		        _moveDown: function(current, shiftKey) {
		            var container = current.parent().parent();
		            var next;
	
		            if (shiftKey) {
		                next = current.parent();
		                next = next.nextAll(ITEMROW + ":first");
		                next = current.parent().is(ITEMROW)? next.children().eq(current.index()) : next.children(DATA_CELL + ":first" );
		            } else {
		                next = this._nextVerticalCell(container, current);
		                if (!next[0]) {
		                    this._lastCellIndex = 0;
		                    container = this._verticalContainer(container);
	
		                    next = this._nextVerticalCell(container, current);
		                    if (next[0]) {
		                        focusTable(container.parent(), true);
		                    }
		                }
		            }
		            var tmp = this._lastCellIndex || 0;
		            this.current(next);
		            this._lastCellIndex = tmp;
		            return true;
		        },
	
		        _tableClick: function(e) {
		            var currentTarget = $(e.currentTarget),
		                isHeader = currentTarget.is("th"),
		                table = this.table.add(this.lockedTable),
		                headerTable = this.thead.parent().add($(">table", this.lockedHeader)),
		                isInput = isInputElement(e.target),
		                currentTable = currentTarget.closest("table")[0];
	
		            if (kendo.support.touch) {
		                return;
		            }
	
		            if (currentTable !== table[0] && currentTable !== table[1] && currentTable !== headerTable[0] && currentTable !== headerTable[1]) {
		                return;
		            }
	
		            if (this.options.navigatable) {
		                this.current(currentTarget);
		            }
	
		            if (isHeader || !isInput) {
		                setTimeout(function() {
		                   if (!isInputElement(kendo._activeElement()) || !$.contains(currentTable, kendo._activeElement())) {
		                       focusTable(currentTable, true);
		                   }
		                });
		            }
	
		            if (isHeader) {
		                e.preventDefault(); //if any problem occurs, call preventDefault only for the clicked header links
		            }
		        },
	
		        _setTabIndex: function(table) {
		            this._navigatableTables.attr(TABINDEX, -1);
	
		            table.attr(TABINDEX, 0);
		        },
	
		        _tableFocus: function(e) {
		            var current = this.current();
		            var table = $(e.currentTarget);
	
		            if (current && current.is(":visible")) {
		                current.addClass(classNames.focused);
		            } else {
		                this.current(table.find(FIRSTNAVITEM));
		            }
	
		            this._setTabIndex(table);
		        },
	
		        _tableBlur: function() {
		            var current = this.current();
	
		            if (current) {
		                current.removeClass(classNames.focused);
		            }
		        },
	
		        _attachEvents: function() {
		            var icons = DOT + classNames.iconCollapse +
		                ", ." + classNames.iconExpand +
		                ", ." + classNames.refresh;
		            var retryButton = DOT + classNames.retry;
	
		            this.element
		                .on(MOUSEDOWN+ NS, icons, proxy(this._toggleChildren, this))
		                .on(CLICK + NS, retryButton, this._dataSourceFetchProxy)
		                .on(CLICK + NS, ".k-button[data-command]", proxy(this._commandClick, this));
	
		            this._attachCellEditingEventHandlers();
		        },
	
		        _attachCellEditingEventHandlers: function() {
		            var that = this;
		            var editable = that.options.editable;
		            var selectable = that.selectable && that.selectable.options.multiple;
		            var closeCell = function(e) {
		                var target = activeElement();
		                var editor = that.editor || {};
		                var cell = editor.element;
	
		                if (cell && !$.contains(cell[0], target) && cell[0] !== target && !$(target).closest(".k-animation-container").length) {
		                    if (editor.end()) {
		                        if (!e.relatedTarget && that._isPageable() && !isUndefined(that.dataSource._addChildPageSize)) {
		                            that._preventPageSizeRestore = false;
		                        }
	
		                        that.closeCell();
		                    }
		                }
	
		                that._preventPageSizeRestore = false;
		            };
	
		            if (that._isIncellEditable() && editable.update !== false) {
		                that.wrapper
		                    .on(CLICK + NS, "tr:not(.k-grouping-row) > td", function(e) {
		                        var td = $(this),
		                            isLockedCell = that.lockedTable && td.closest("table")[0] === that.lockedTable[0];
	
		                        if (td.hasClass(classNames.editCell) ||
		                            td.has("a.k-grid-delete").length ||
		                            td.has("button.k-grid-delete").length ||
		                            (td.closest("tbody")[0] !== that.tbody[0] && !isLockedCell) ||
		                            $(e.target).is(":input") ||
		                            $(e.target).hasClass(classNames.iconExpand) ||
		                            $(e.target).hasClass(classNames.iconCollapse)) {
	
		                            if (!that.editor) {
		                                that.dataSource._restorePageSizeAfterAddChild();
		                            }
	
		                            that._preventPageSizeRestore = false;
	
		                            return;
		                        }
	
		                        if (that.editor) {
		                            if (that.editor.end()) {
		                                if (selectable) {
		                                    $(activeElement()).blur();
		                                }
		                                that.closeCell();
		                                that.editCell(td);
		                            }
		                        } else {
		                            that.editCell(td);
		                        }
		                    })
		                    .on("mousedown" + NS, "tr:not(.k-grouping-row) > td", function(e) {
		                        // cache the result on "mousedown", which is fired before "focusout" and "click"
		                        if (that.editor && that._isPageable() && !isUndefined(that.dataSource._addChildPageSize)) {
		                            that._preventPageSizeRestore = $(e.target).parents(DOT + classNames.editRow).length > 0;
		                        } else {
		                            that._preventPageSizeRestore = false;
		                        }
		                    })
		                    .on("focusin" + NS, function() {
		                        // fix focus issue in IE
		                        if (!$.contains(this, activeElement())) {
		                            clearTimeout(that._closeCellTimeout);
		                            that._closeCellTimeout = null;
		                        }
		                    })
		                    .on("focusout" + NS, function(e) {
		                        that._closeCellTimeout = setTimeout(function() {
		                            closeCell(e);
		                        }, 1);
		                    });
		            }
		        },
	
		        _commandByName: function(name) {
		            var columns = this.columns;
		            var toolbar = $.isArray(this.options.toolbar) ? this.options.toolbar : [];
		            var i, j, commands, currentName;
	
		            name = name.toLowerCase();
	
		            if (defaultCommands[name]) {
		                return defaultCommands[name];
		            }
	
		            // command not found in defaultCommands, must be custom
		            for (i = 0; i < columns.length; i++) {
		                commands = columns[i].command;
		                if (commands) {
		                    for (j = 0; j < commands.length; j++) {
		                        currentName = commands[j].name;
	
		                        if (!currentName) {
		                            continue;
		                        }
	
		                        if (currentName.toLowerCase() == name) {
		                            return commands[j];
		                        }
		                    }
		                }
		            }
	
		            // custom command in toolbar
		            for (i = 0; i < toolbar.length; i++) {
		                currentName = toolbar[i].name;
	
		                if (!currentName) {
		                    continue;
		                }
	
		                if (currentName.toLowerCase() == name) {
		                    return toolbar[i];
		                }
		            }
		        },
	
		        _commandClick: function(e) {
		            var button = $(e.currentTarget);
		            var commandName = button.attr("data-command");
		            var command = this._commandByName(commandName);
		            var row = button.parentsUntil(this.wrapper, "tr");
	
		            row = row.length ? row : undefined;
	
		            if (command) {
		                if (command.methodName) {
		                    this[command.methodName](row);
		                } else if (command.click) {
		                    command.click.call(this, e);
		                }
	
		                e.preventDefault();
		            }
		        },
	
		        _ensureExpandableColumn: function() {
		            if (this._autoExpandable) {
		                delete this._autoExpandable.expandable;
		            }
	
		            var visibleColumns = grep(this.columns, not(is("hidden")));
		            var expandableColumns = grep(visibleColumns, is("expandable"));
	
		            if (this.columns.length && !expandableColumns.length) {
		                this._autoExpandable = visibleColumns[0];
		                visibleColumns[0].expandable = true;
		            }
		        },
	
		        _columns: function() {
		            var columns = this.options.columns || [];
	
		            this.columns = map(columns, function(column) {
		                column = (typeof column === "string") ? { field: column } : column;
	
		                return extend({ encoded: true }, column);
		            });
	
		            var lockedCols = lockedColumns(columns);
		            if (lockedCols.length > 0) {
		                this._hasLockedColumns = true;
		                this.columns = lockedCols.concat(nonLockedColumns(this.columns));
		            }
	
		            this.columns = normalizeColumns(this.columns);
	
		            this._ensureExpandableColumn();
	
		            this._columnTemplates();
		            this._columnAttributes();
		        },
	
		        _columnTemplates: function() {
		            var idx, length, column;
		            var columns = leafColumns(this.columns);
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                column = columns[idx];
		                if (column.template) {
		                    column.template = kendo.template(column.template);
		                }
	
		                if (column.headerTemplate) {
		                    column.headerTemplate = kendo.template(column.headerTemplate);
		                }
	
		                if (column.footerTemplate) {
		                    column.footerTemplate = kendo.template(column.footerTemplate);
		                }
		            }
		        },
	
		        _columnAttributes: function() {
		            // column style attribute is string, kendo.dom expects object
		            var idx, length;
		            var columns = this.columns;
	
		            function convertStyle(attr) {
		                var properties, i, declaration;
	
		                if (attr && attr.style) {
		                    properties = attr.style.split(";");
		                    attr.style = {};
	
		                    for (i = 0; i < properties.length; i++) {
		                        declaration = properties[i].split(":");
	
		                        var name = $.trim(declaration[0]);
	
		                        if (name) {
		                            attr.style[$.camelCase(name)] = $.trim(declaration[1]);
		                        }
		                    }
		                }
		            }
	
		            for (idx = 0, length = columns.length; idx < length; idx++) {
		                convertStyle(columns[idx].attributes);
		                convertStyle(columns[idx].headerAttributes);
		            }
		        },
	
		        _layout: function () {
		            var columns = this.columns;
		            var element = this.element;
		            var layout = "";
	
		            this.wrapper = element.addClass(classNames.wrapper);
	
		            layout = "<div class='#= gridHeader #'>";
	
		            if (this._hasLockedColumns) {
		                layout += "<div class='k-grid-header-locked'>" +
		                                "<table role='grid'>" +
		                                    "<colgroup></colgroup>"+
		                                    "<thead role='rowgroup' />" +
		                                "</table>" +
		                            "</div>";
		            }
	
		            layout += "<div class='#= gridHeaderWrap #'>" +
		                            "<table role='grid'>" +
		                                "<colgroup></colgroup>"+
		                                "<thead role='rowgroup' />" +
		                            "</table>" +
		                        "</div>"+
		                        "</div>";
	
		            if (this._hasLockedColumns) {
		                layout += "<div class='k-grid-content-locked'>" +
		                                "<table role='treegrid' tabindex='0'>" +
		                                    "<colgroup></colgroup>"+
		                                    "<tbody />" +
		                                "</table>" +
		                            "</div>";
		            }
	
		            layout += "<div class='#= gridContentWrap # k-auto-scrollable'>" +
		                            "<table role='treegrid' tabindex='0'>" +
		                                "<colgroup></colgroup>"+
		                                "<tbody />" +
		                            "</table>" +
		                        "</div>";
	
		            if (!this.options.scrollable) {
		                layout =
		                    "<table role='treegrid' tabindex='0'>" +
		                        "<colgroup></colgroup>"+
		                        "<thead class='#= gridHeader #' role='rowgroup' />" +
		                        "<tbody />" +
		                    "</table>";
		            }
	
		            if (this.options.toolbar) {
		                layout = "<div class='#= header # #= gridToolbar #' />" + layout;
		            }
	
		            element.append(
		                kendo.template(layout)(classNames) +
		                "<div class='k-status' />"
		            );
	
		            this.toolbar = element.find(DOT + classNames.gridToolbar);
	
		            var header = element.find(DOT + classNames.gridHeader).find("thead").addBack().filter("thead");
		            this.thead = header.last();
	
		            if (this.options.scrollable) {
		                var rtl = kendo.support.isRtl(element);
	
		                element.find("div." + classNames.gridHeader)
		                    .css(rtl ? "padding-left" : "padding-right", kendo.support.scrollbar());
		            }
	
	
		            var content = element.find(DOT + classNames.gridContentWrap);
		            if (!content.length) {
		                content = element;
		            } else {
		                this.content = content;
		            }
	
		            this.table = content.find(">table");
		            this.tbody = this.table.find(">tbody");
	
		            if (this._hasLockedColumns) {
		                this.lockedHeader = header.first().closest(".k-grid-header-locked");
		                this.lockedContent = element.find(".k-grid-content-locked");
		                this.lockedTable = this.lockedContent.children();
		            }
	
		            this._initVirtualTrees();
	
		            this._renderCols();
		            this._renderHeader();
	
		            this.angular("compile", function() {
		                return {
		                    elements: header.find("th.k-header").get(),
		                    data: map(columns, function(col) { return { column: col }; })
		                };
		            });
		        },
	
		        _initVirtualTrees: function() {
		            this._headerColsTree = new kendoDom.Tree(this.thead.prev()[0]);
		            this._contentColsTree = new kendoDom.Tree(this.tbody.prev()[0]);
		            this._headerTree = new kendoDom.Tree(this.thead[0]);
		            this._contentTree = new kendoDom.Tree(this.tbody[0]);
		            this._statusTree = new kendoDom.Tree(this.element.children(".k-status")[0]);
	
		            if (this.lockedHeader){
		                this._lockedHeaderColsTree = new kendoDom.Tree(this.lockedHeader.find("colgroup")[0]);
		                this._lockedContentColsTree = new kendoDom.Tree(this.lockedTable.find(">colgroup")[0]);
		                this._lockedHeaderTree = new kendoDom.Tree(this.lockedHeader.find("thead")[0]);
		                this._lockedContentTree = new kendoDom.Tree(this.lockedTable.find(">tbody")[0]);
		            }
		        },
	
		        _toolbar: function() {
		            var options = this.options.toolbar;
		            var toolbar = this.toolbar;
	
		            if (!options) {
		                return;
		            }
	
		            if ($.isArray(options)) {
		                var buttons = this._buildCommands(options);
		                new kendoDom.Tree(toolbar[0]).render(buttons);
		            } else {
		                toolbar.append(kendo.template(options)({}));
		            }
	
		            this.angular("compile", function() {
		                return { elements: toolbar.get() };
		            });
		        },
	
		        _lockedColumns: function() {
		            return grep(this.columns, is("locked"));
		        },
	
		        _nonLockedColumns: function() {
		            return grep(this.columns, not(is("locked")));
		        },
	
		        _templateColumns: function() {
		            return grep(this.columns, is("template"));
		        },
	
		        _flushCache: function() {
		            if (this.options.$angular && this._templateColumns().length) {
		                this._contentTree.render([]);
		                if (this._hasLockedColumns) {
		                    this._lockedContentTree.render([]);
		                }
		            }
		        },
	
		        _render: function(options) {
		            var that = this;
		            options = options || {};
		            options = that._renderOptions(options);
		            var messages = this.options.messages;
		            var pageable = that._isPageable();
		            var dataSource = that.dataSource;
	
		            var maps = { children: (options.filteredChildrenMap || options.childrenMap), ids: options.idsMap };
		            var dataMaps = pageable ? (maps && maps.children && maps.ids ? maps : dataSource._initDataMaps(dataSource._getData())) : {};
		            var childrenMap = dataMaps.children;
		            var idsMap = dataMaps.ids;
		            options.childrenMap = childrenMap;
		            options.idsMap = idsMap;
	
		            var data = that._dataToRender(options);
		            var level = that._renderedModelLevel(data[0], options);
		            var uidAttr = kendo.attr("uid");
		            var selected = this.select().removeClass("k-state-selected").map(function(_, row) {
		                return $(row).attr(uidAttr);
		            });
		            var viewChildrenMap;
	
		            this._absoluteIndex = 0;
	
		            this._angularItems("cleanup");
		            this._angularFooters("cleanup");
		            this._flushCache();
	
		            that._clearRenderMap();
	
		            if (options.error) {
		                // root-level error message
		                this._showStatus(kendo.template(
		                    "#: messages.requestFailed # " +
		                    "<button class='#= buttonClass #'>#: messages.retry #</button>"
		                )({
		                    buttonClass: [classNames.button, classNames.retry].join(" "),
		                    messages: messages
		                }));
		            } else if (!data.length) {
		                // no rows message
		                this._showStatus(kendo.htmlEncode(messages.noRows));
		            } else {
		                if (pageable) {
		                    viewChildrenMap = that._viewChildrenMap(options);
		                }
	
		                // render rows
		                this._hideStatus();
	
		                this._contentTree.render(this._trs({
		                    columns: leafColumns(nonLockedColumns(this.columns)),
		                    editedColumn: options.editedColumn,
		                    editedColumnIndex: options.editedColumnIndex,
		                    aggregates: options.aggregates,
		                    selected: selected,
		                    data: data,
		                    childrenMap: childrenMap,
		                    viewChildrenMap: viewChildrenMap,
		                    visible: true,
		                    level: 0
		                }));
	
		                if (this._hasLockedColumns) {
		                    this._absoluteIndex = 0;
		                    this._lockedContentTree.render(this._trs({
		                        columns: leafColumns(lockedColumns(this.columns)),
		                        editedColumn: options.editedColumn,
		                        editedColumnIndex: options.editedColumnIndex,
		                        aggregates: options.aggregates,
		                        selected: selected,
		                        data: data,
		                        childrenMap: childrenMap,
		                        viewChildrenMap: viewChildrenMap,
		                        visible: true,
		                        level: level
		                    }));
		                }
		            }
	
		            if (this._touchScroller) {
		                this._touchScroller.contentResized();
		            }
	
		            this._muteAngularRebind(function() {
		                this._angularItems("compile");
		                this._angularFooters("compile");
		            });
	
		            this.items().filter(function() {
		                return $.inArray($(this).attr(uidAttr), selected) >= 0;
		            })
		            .addClass("k-state-selected");
	
		            this._syncLockedContentHeight();
	
		            that._togglePagerVisibility();
		        },
	
		        _renderProgress: function(toggle) {
		            kendo.ui.progress(this.wrapper, toggle);
		        },
	
		        _renderOptions: function(options) {
		            options = options || {};
		            var that = this;
		            var dataMaps = that.dataSource._getDataMaps();
		            var filter = that.dataSource.filter();
	
		            if (that._isPageable()) {
		                options.childrenMap = dataMaps.children;
		                options.idsMap = dataMaps.ids;
	
		                if (filter) {
		                    options.filteredChildrenMap = dataMaps.filteredChildren;
		                }
		            }
	
		            return options;
		        },
	
		        _renderedModelLevel: function(model, options) {
		            return !this._isPageable() ? 0 : this.dataSource._pageableModelLevel(model, options);
		        },
	
		        _viewChildrenMap: function(options) {
		            options = options || {};
		            var that = this;
		            var dataSource = that.dataSource;
		            var viewChildrenMap = dataSource.childrenMap(dataSource.view());
		            var idField = dataSource._modelIdField();
		            var parentsNotInView = dataSource._parentNodesNotInView();
		            var parentNotInView;
		            var parentNotInViewId;
		            var parents;
		            var parent;
		            var parentId;
		            var child;
		            var childId;
		            var parentsCopy;
	
		            that._clearRenderMap();
	
		            for (var i = 0; i < parentsNotInView.length; i++) {
		                parentNotInView = parentsNotInView[i];
		                parentNotInViewId = parentNotInView[idField];
	
		                that._markNodeAsNonRenderable(parentNotInViewId);
	
		                viewChildrenMap[parentNotInViewId] = viewChildrenMap[parentNotInViewId] || [];
	
		                parents = dataSource._parentNodes(parentNotInView);
	
		                // copy the items to avoid mutating the original collection
		                parentsCopy = parents.slice();
		                parentsCopy.push(parentNotInView);
	
		                for (var parentIndex = 0; parentIndex < parentsCopy.length - 1; parentIndex++) {
		                    parent = parentsCopy[parentIndex];
		                    parentId = parent[idField];
		                    that._markNodeAsNonRenderable(parentId);
		                    viewChildrenMap[parentId] = viewChildrenMap[parentId] || [];
	
		                    child = parentsCopy[parentIndex + 1];
		                    childId = child[idField];
		                    that._markNodeAsNonRenderable(childId);
		                    viewChildrenMap[childId] = viewChildrenMap[childId] || [];
	
		                    if (viewChildrenMap[parentId].indexOf(child) === -1) {
		                        viewChildrenMap[parentId].unshift(child);
		                    }
		                }
		            }
	
		            return viewChildrenMap;
		        },
	
		        _clearRenderMap: function() {
		            this._skipRenderingMap = {};
		        },
	
		        _dataToRender: function(options) {
		            var that = this;
	
		            if (that._isPageable()) {
		                return that.dataSource._pageableRootNodes(options);
		            }
	
		            return that.dataSource.rootNodes();
		        },
	
		        _markNodeAsNonRenderable: function(nodeId) {
		            this._skipRenderingMap[nodeId] = true;
		        },
	
		        _adjustRowsHeight: function(table1, table2) {
		            if (!this._hasLockedColumns) {
		                return;
		            }
	
		            var rows = table1[0].rows;
		            var length = rows.length;
		            var idx;
		            var rows2 = table2[0].rows;
		            var containers = table1.add(table2);
		            var containersLength = containers.length;
		            var heights = [];
	
		            for (idx = 0; idx < length; idx++) {
		                if (!rows2[idx]) {
		                    break;
		                }
	
		                if (rows[idx].style.height) {
		                    rows[idx].style.height = rows2[idx].style.height = "";
		                }
		            }
	
		            for (idx = 0; idx < length; idx++) {
		                if (!rows2[idx]) {
		                    break;
		                }
	
		                var offsetHeight1 = rows[idx].offsetHeight;
		                var offsetHeight2 = rows2[idx].offsetHeight;
		                var height = 0;
	
		                if (offsetHeight1 > offsetHeight2) {
		                    height = offsetHeight1;
		                } else if (offsetHeight1 < offsetHeight2) {
		                    height = offsetHeight2;
		                }
	
		                heights.push(height);
		            }
	
		            for (idx = 0; idx < containersLength; idx++) {
		                containers[idx].style.display = "none";
		            }
	
		            for (idx = 0; idx < length; idx++) {
		                if (heights[idx]) {
		                    //add one to resolve row misalignment in IE
		                    rows[idx].style.height = rows2[idx].style.height = (heights[idx] + 1) + "px";
		                }
		            }
	
		            for (idx = 0; idx < containersLength; idx++) {
		                containers[idx].style.display = "";
		            }
		        },
	
		        _ths: function(columns, rowSpan) {
		            var ths = [];
		            var column, title, children, cellClasses, attr, headerContent;
	
		            for (var i = 0, length = columns.length; i < length; i++) {
		                column = columns[i];
		                children = [];
		                cellClasses = [classNames.header];
	
		                if (column.headerTemplate) {
		                    title = column.headerTemplate({});
		                } else {
		                    title = column.title || column.field || "";
		                }
	
		                if (column.headerTemplate) {
		                    headerContent = kendoHtmlElement(title);
		                } else {
		                    headerContent = kendoTextElement(title);
		                }
	
		                if (column.sortable) {
		                    children.push(kendoDomElement("a", { href: "#", className: classNames.link }, [
		                        headerContent
		                    ]));
		                } else {
		                    children.push(headerContent);
		                }
	
		                attr = {
		                    "data-field": column.field,
		                    "data-title": column.title,
		                    "style": column.hidden === true ? { "display": "none" } : {},
		                    className: cellClasses.join(" "),
		                    "role": "columnheader"
		                };
	
		                if (!column.columns) {
		                    attr.rowSpan = rowSpan ? rowSpan : 1;
		                }
	
		                if (column.headerAttributes) {
		                    if (column.headerAttributes.colSpan === 1) {
		                        delete column.headerAttributes.colSpan;
		                    }
		                    if (column.headerAttributes["class"]) {
		                        attr.className += " " + column.headerAttributes["class"];
		                        delete column.headerAttributes["class"];
		                    }
		                }
	
		                if (column["data-index"] > -1) {
		                    attr["data-index"] = column["data-index"];
		                }
	
		                attr = extend(true, {}, attr, column.headerAttributes);
	
		                ths.push(kendoDomElement("th", attr, children));
		            }
	
		            return ths;
		        },
	
		        _cols: function(columns) {
		            var cols = [];
		            var width, attr;
	
		            for (var i = 0; i < columns.length; i++) {
		                if (columns[i].hidden === true) {
		                    continue;
		                }
	
		                width = columns[i].width;
		                attr = {};
	
		                if (width && parseInt(width, 10) !== 0) {
		                    attr.style = {
		                        width: typeof width === "string" ? width : width + "px"
		                    };
		                }
	
		                cols.push(kendoDomElement("col", attr));
		            }
	
		            return cols;
		        },
	
		        _clearColsCache: function () {
		            this._headerColsTree.render([]);
		            if (this.options.scrollable) {
		                this._contentColsTree.render([]);
		            }
		            if (this._hasLockedColumns) {
		                this._lockedHeaderColsTree.render([]);
		                this._lockedContentColsTree.render([]);
		            }
		        },
	
		        _renderCols: function() {
		            var columns = nonLockedColumns(this.columns);
		            this._headerColsTree.render(this._cols(leafColumns(columns)));
	
		            if (this.options.scrollable) {
		                this._contentColsTree.render(this._cols(leafColumns(columns)));
		            }
	
		            if (this._hasLockedColumns) {
		                columns = lockedColumns(this.columns);
		                this._lockedHeaderColsTree.render(this._cols(leafColumns(columns)));
		                this._lockedContentColsTree.render(this._cols(leafColumns(columns)));
		            }
		        },
	
		        _retrieveFirstColumn: function(columns, rows) {
		            var result = $();
	
		            if (rows.length && columns[0]) {
		                var column = columns[0];
	
		                while(column.columns && column.columns.length) {
		                    column = column.columns[0];
		                    rows = rows.filter(":not(:first())");
		                }
	
		                result = result.add(rows);
		            }
	
		            return result;
		        },
	
		        _updateFirstColumnClass: function() {
		            var that = this;
		            var columns = that.columns || [];
		            var tr = that.thead.find(">tr:not(:first)");
		            var rows;
	
		            columns = nonLockedColumns(columns);
	
		            rows = that._retrieveFirstColumn(columns, tr);
	
		            if (that.lockedHeader) {
		                tr = that.lockedHeader.find("thead>tr:not(.k-filter-row):not(:first)");
		                columns = lockedColumns(that.columns);
	
		                rows = rows.add(that._retrieveFirstColumn(columns, tr));
		            }
	
		            rows.each(function() {
		                var ths = $(this).find("th");
		                ths.removeClass("k-first");
		                ths.eq(0).addClass("k-first");
		            });
		        },
	
		        _updateRowSpans: function(rows) {
		            for (var i = rows.length - 1; i >= 0; i--) {
		                var included = visibleChildColumns(rows[i].cells).length > 0;
	
		                if (included) {
		                    rows[i].rowSpan = rows.length - i;
		                }
		            }
		        },
	
		        _setColumnDataIndexes: function(columns) {
		            for (var i = 0; i < columns.length; i++) {
		               columns[i]["data-index"] = i;
		            }
		        },
	
		        _updateColumnCellIndex: function() {
		            var header;
		            var offset = 0;
	
		            if (this.lockedHeader) {
		                header = this.lockedHeader.find("thead");
		                offset = updateCellIndex(header, lockedColumns(this.columns));
		            }
		            updateCellIndex(this.thead, nonLockedColumns(this.columns), offset);
		        },
	
		        _setParentsVisibility: function(column, visible) {
		            var columns = this.columns;
		            var idx;
		            var parents = [];
		            var parent;
	
		            var predicate = visible ?
		                function(p) { return visibleColumns(p.columns).length && p.hidden; } :
		                function(p) { return !visibleColumns(p.columns).length && !p.hidden; };
	
	
		            if (columnParents(column, columns, parents) && parents.length) {
		                for (idx = parents.length - 1; idx >= 0; idx--) {
		                    parent = parents[idx];
	
		                    if (predicate(parent)) {
		                        parent.hidden = !visible;
		                    }
		                }
		            }
		        },
	
		        _prepareColumns: function(rows, columns, parentCell, parentRow, parentColumn) {
		            var row = parentRow || rows[rows.length - 1];
	
		            var childRow = rows[row.index + 1];
		            var totalColSpan = 0;
	
		            for (var idx = 0; idx < columns.length; idx++) {
		                var cell = $.extend({}, columns[idx],  { headerAttributes: columns[idx].headerAttributes || {} } );
		                row.cells.push(cell);
	
		                if (columns[idx].columns && columns[idx].columns.length) {
		                    if (!childRow) {
		                        childRow = { rowSpan: 0, cells: [], index: rows.length };
		                        rows.push(childRow);
		                    }
		                    if (columns[idx].columns.length) {
		                        cell.headerAttributes.colSpan = visibleChildColumns(columns[idx].columns).length || 1;
		                        cell.headerAttributes["data-colspan"] = leafColumns(columns[idx].columns).length;
		                    }
		                    this._prepareColumns(rows, columns[idx].columns, cell, childRow, columns[idx]);
		                    if (!cell.hidden) {
		                        totalColSpan += cell.headerAttributes.colSpan - 1;
		                    }
		                    row.rowSpan = rows.length - row.index;
		                }
		                columns[idx].rowIndex = row.index;
		                if (parentColumn) {
		                    columns[idx].parentColumn = parentColumn;
		                }
		                columns[idx].cellIndex = row.cells.length - 1;
		            }
		            if (parentCell) {
		                parentCell.headerAttributes.colSpan += totalColSpan;
		            }
		        },
	
		        _renderHeaderTree: function(tree, columns, hasMultiColumnHeaders) {
		            var idx;
		            var rows = [];
		            var rowsToRender = [];
	
		            if (hasMultiColumnHeaders) {
		                rows = [{ rowSpan: 1, cells: [], index: 0 }];
		                this._prepareColumns(rows, columns);
		                this._updateRowSpans(rows);
		                for (idx = 0; idx< rows.length; idx++) {
		                    rowsToRender.push(kendoDomElement("tr", { "role": "row" }, this._ths(rows[idx].cells, rows[idx].rowSpan)));
		                }
		                tree.render(rowsToRender);
		            } else {
		                tree.render([kendoDomElement("tr", { "role": "row" }, this._ths(columns))]);
		            }
		        },
	
		        _renderHeader: function() {
		            var columns = nonLockedColumns(this.columns);
		            var hasMultiColumnHeaders = grep(this.columns, function(item) {
		                return item.columns !== undefined;
		            }).length > 0;
		            this._setColumnDataIndexes(leafColumns(this.columns));
		            this._renderHeaderTree(this._headerTree, columns, hasMultiColumnHeaders);
	
		            if (this._hasLockedColumns) {
		                columns = lockedColumns(this.columns);
		                this._renderHeaderTree(this._lockedHeaderTree, columns, hasMultiColumnHeaders);
	
		                this._applyLockedContainersWidth();
		                this._syncLockedHeaderHeight();
		            }
		            this._updateFirstColumnClass();
		        },
	
		        _applyLockedContainersWidth: function() {
		            if (!this._hasLockedColumns) {
		                return;
		            }
	
		            var lockedWidth = columnsWidth(this.lockedHeader.find(">table>colgroup>col"));
	
		            var headerTable = this.thead.parent();
		            var nonLockedWidth = columnsWidth(headerTable.find(">colgroup>col"));
	
		            var wrapperWidth = this.wrapper[0].clientWidth;
		            var scrollbar = kendo.support.scrollbar();
	
		            if (lockedWidth >= wrapperWidth) {
		                lockedWidth = wrapperWidth - 3 * scrollbar;
		            }
	
		            this.lockedHeader
		                .add(this.lockedContent)
		                .width(lockedWidth);
	
		            headerTable.add(this.table).width(nonLockedWidth);
	
		            var width = wrapperWidth - lockedWidth - 2;
		            this.content.width(width);
		            headerTable.parent().width(width - scrollbar);
		        },
	
		        _trs: function(options) {
		            var that = this;
		            var model, attr, className, hasChildren, childNodes, i, length;
		            var modelId;
		            var rows = [];
		            var level = options.level;
		            var data = options.data;
		            var dataSource = this.dataSource;
		            var aggregates = dataSource.aggregates() || {};
		            var idField = dataSource._modelIdField();
		            var parentIdField = dataSource._modelParentIdField();
		            var columns = options.columns;
		            var pageable = that._isPageable();
		            var childrenMap = options.childrenMap || dataSource.childrenMap(dataSource._getData());
	
		            for (i = 0, length = data.length; i < length; i++) {
		                className = [];
	
		                model = data[i];
		                modelId = model[idField];
	
		                childNodes = pageable ? childrenMap[modelId] : (model.loaded() ? dataSource.childNodes(model) : []);
		                hasChildren = childNodes && childNodes.length;
	
		                attr = { "role": "row" };
	
		                attr[kendo.attr("uid")] = model.uid;
	
		                if (hasChildren) {
		                    attr["aria-expanded"] = !!model.expanded;
		                }
	
		                if (options.visible) {
		                    if (!pageable || (pageable && !that._skipRenderingMap[modelId])) {
		                        if (this._absoluteIndex % 2 !== 0) {
		                            className.push(classNames.alt);
		                        }
	
		                        this._absoluteIndex++;
		                    }
		                } else {
		                    attr.style = { display: "none" };
		                }
	
		                if ($.inArray(model.uid, options.selected) >= 0) {
		                    className.push(classNames.selected);
		                }
	
		                if (hasChildren) {
		                    className.push(classNames.group);
		                }
	
		                if (model._edit) {
		                    className.push("k-grid-edit-row");
		                }
	
		                attr.className = className.join(" ");
	
		                if (!that._skipRenderingMap[modelId]) {
		                    var row = this._tds({
		                        model: model,
		                        attr: attr,
		                        level: pageable ? that._renderedModelLevel(model, options) : level,
		                        editedColumn: options.editedColumn,
		                        editedColumnIndex: options.editedColumnIndex
		                    }, columns, proxy(this._td, this));
	
		                    rows.push(row);
		                }
	
	
		                if (hasChildren) {
		                    if (pageable) {
		                        // render the child nodes in the paged view only
		                        childNodes = (options.viewChildrenMap || {})[modelId] || [];
		                    }
	
		                    if (childNodes.length === 0) {
		                        continue;
		                    }
	
		                    rows = rows.concat(this._trs({
		                        columns: columns,
		                        editedColumn: options.editedColumn,
		                        editedColumnIndex: options.editedColumnIndex,
		                        aggregates: aggregates,
		                        selected: options.selected,
		                        visible: pageable ? options.visible : (options.visible && !!model.expanded),
		                        data: childNodes,
		                        childrenMap: options.childrenMap || childrenMap,
		                        viewChildrenMap: options.viewChildrenMap,
		                        level: level + 1
		                    }));
		                }
		            }
	
		            if (this._hasFooterTemplate() && model) {
		                attr = {
		                    className: classNames.footerTemplate,
		                    "data-parentId": model[parentIdField]
		                };
	
		                if (!options.visible) {
		                    attr.style = { display: "none" };
		                }
	
		                rows.push(this._tds({
		                    model: aggregates[model[parentIdField]],
		                    attr: attr,
		                    level: level,
		                    editedColumn: options.editedColumn,
		                    editedColumnIndex: options.editedColumnIndex
		                }, columns, this._footerId));
		            }
	
		            return rows;
		        },
	
		        _footerId: function(options) {
		            var content = [];
		            var column = options.column;
		            var template = options.column.footerTemplate || $.noop;
		            var aggregates = options.model[column.field] || {};
		            var attr = {
		                "role": "gridcell",
		                "style": column.hidden === true ? { "display": "none" } : {}
		            };
	
		            if (column.expandable) {
		                content = content.concat(createPlaceholders({
	
		                    level: options.level + 1,
		                    className: classNames.iconPlaceHolder
		                }));
		            }
	
		            if (column.attributes) {
		                extend(attr, column.attributes);
		            }
	
		            content.push(kendoHtmlElement(template(aggregates) || ""));
	
		            return kendoDomElement("td", attr, content);
		        },
	
		        _hasFooterTemplate: function() {
		            return !!grep(this.columns, function(c) {
		                return c.footerTemplate;
		            }).length;
		        },
	
		        _tds: function(options, columns, renderer) {
		            var children = [];
		            var column;
		            var editedColumnField = (options.editedColumn || {}).field;
		            var incellEditing = this._isIncellEditable();
		            var length = columns.length;
	
		            for (var i = 0; i < length; i++) {
		                column = columns[i];
	
		                var col = renderer({
		                    model: options.model,
		                    column: column,
		                    editColumn: !incellEditing || (incellEditing && column.field === editedColumnField && options.editedColumnIndex === i),
		                    level: options.level
		                });
	
		                children.push(col);
		            }
	
		            return kendoDomElement("tr", options.attr, children);
		        },
	
		        _td: function(options) {
		            var children = [];
		            var model = options.model;
		            var column = options.column;
		            var iconClass;
		            var attr = {
		                "role": "gridcell",
		                "style": column.hidden === true ? { "display": "none" } : {}
		            };
		            var incellEditing = this._isIncellEditable();
		            var columnHasEditCommand = false;
	
		            if (column.attributes) {
		                extend(true, attr, column.attributes);
		            }
	
		            if (model._edit && column.field && options.editColumn && (incellEditing || (!incellEditing && isColumnEditable(column, model)))) {
		                attr[kendo.attr("container-for")] = column.field;
	
		                if (incellEditing) {
		                    if (attr.className && attr.className.indexOf(classNames.editCell) !== -1) {
		                        attr.className += " " + classNames.editCell;
		                    } else if (!attr.className) {
		                        attr.className = classNames.editCell;
		                    }
		                }
		            } else {
		                if (column.expandable) {
		                    children = createPlaceholders({ level: options.level, className: classNames.iconPlaceHolder });
		                    iconClass = [classNames.icon];
	
		                    if (model.hasChildren) {
		                        iconClass.push(model.expanded ? classNames.iconCollapse : classNames.iconExpand);
		                    } else {
		                        iconClass.push(classNames.iconHidden);
		                    }
	
		                    if (model._error) {
		                        iconClass.push(classNames.refresh);
		                    } else if (!model.loaded() && model.expanded) {
		                        iconClass.push(classNames.loading);
		                    }
	
		                    children.push(kendoDomElement("span", { className: iconClass.join(" ") }));
	
		                    attr.style["white-space"] = "nowrap";
		                }
	
		                if (isDirtyColumn(column, model)) {
		                    if (attr.className) {
		                        attr.className += classNames.dirtyCell;
		                    } else if (!attr.className) {
		                        attr.className = classNames.dirtyCell;
		                    }
		                }
	
		                if (column.command) {
		                    if (attr.className && attr.className.indexOf("k-command-cell") !== -1 ) {
		                        attr.className += " k-command-cell";
		                    } else if (!attr.className) {
		                        attr.className = "k-command-cell";
		                    }
	
		                    columnHasEditCommand = grep(column.command, function(command) {
		                        return command === EDIT || command.name === EDIT;
		                    }).length > 0;
	
		                    if (model._edit && !this._isIncellEditable() && columnHasEditCommand) {
		                        children = this._buildCommands(["update", "canceledit"]);
		                    } else {
		                        children = this._buildCommands(column.command);
		                    }
		                } else  {
		                    children.push(this._cellContent(column, model));
		                }
	
		                if (attr["class"]) {
		                    attr.className = attr["class"] + " " + attr.className;
		                }
		            }
	
		            return kendoDomElement("td", attr, children);
		        },
	
		        _cellContent: function(column, model) {
		            var that = this;
		            var value;
		            var incellEditing = that._isIncellEditable();
		            var dirtyIndicator = incellEditing ? that._evalDirtyIndicatorTemplate(column, model) : "";
	
		            if (column.template) {
		                value = that._evalColumnTemplate(column, model);
		            } else if (column.field) {
		                value = model.get(column.field);
		                if (value !== null && !isUndefined(value)) {
		                    if (column.format) {
		                        value = kendo.format(column.format, value);
		                    }
	
		                    value = dirtyIndicator + value;
		                } else {
		                    value = dirtyIndicator;
		                }
		            } else if (value === null || isUndefined(value)) {
		                value = "";
		            }
	
		            if (column.template || !column.encoded) {
		                return kendoHtmlElement(value);
		            } else {
		                if (incellEditing) {
		                    return kendoHtmlElement(value);
		                } else {
		                    return kendoTextElement(value);
		                }
		            }
		        },
	
		        _evalColumnTemplate: function(column, model) {
		            if (this._isIncellEditable()) {
		                return this._evalCustomColumnTemplate(column, model);
		            } else {
		                return column.template(model);
		            }
		        },
	
		        _evalCustomColumnTemplate: function(column, model) {
		            var that = this;
		            var templateSettings = that._customTemplateSettings();
		            var columnTemplateAlias = "#=this.columnTemplate(" + templateSettings.paramName + ")#";
	
		            var templateString = that._dirtyIndicatorTemplate(column.field) + columnTemplateAlias;
		            var templateFunction = proxy(kendoTemplate(templateString, templateSettings), { columnTemplate: column.template });
	
		            return templateFunction(model);
		        },
	
		        _evalDirtyIndicatorTemplate: function(column, model) {
		            var dirtyIndicatorTemplate = this._dirtyIndicatorTemplate(column.field);
	
		            return kendoTemplate(dirtyIndicatorTemplate)(model);
		        },
	
		        _dirtyIndicatorTemplate: function(field) {
		            var that = this;
		            var dirtyField;
		            var templateSettings = that._customTemplateSettings();
		            var paramName = templateSettings.paramName;
	
		            if (field && paramName) {
		                dirtyField = field.charAt(0) === "[" ? kendo.expr(field, paramName + ".dirtyFields") : paramName + ".dirtyFields['" + field + "']";
	
		                return "#= " + paramName + " && " + paramName + ".dirty && " + paramName + ".dirtyFields && " + dirtyField +
		                        " ? '<span class=\"k-dirty\"></span>' : '' #";
		            }
	
		            return "";
		        },
	
		        _customTemplateSettings: function() {
		            return extend({}, kendo.Template, this.options.templateSettings);
		        },
	
		        _buildCommands: function(commands) {
		            var i, result = [];
	
		            for (i = 0; i < commands.length; i++) {
		                result.push(this._button(commands[i]));
		            }
	
		            return result;
		        },
	
		        _button: function(command) {
		            var name = (command.name || command).toLowerCase();
		            var text = this.options.messages.commands[name];
		            var icon = [];
	
		            command = extend({}, defaultCommands[name], { text: text }, command);
	
		            if (command.imageClass) {
		                icon.push(kendoDomElement("span", {
		                    className: [ "k-icon", command.imageClass ].join(" ")
		                }));
		            }
	
		            return kendoDomElement(
		                "button", {
		                    "type": "button",
		                    "data-command": name,
		                    className: [ "k-button", "k-button-icontext", command.className ].join(" ")
		                }, icon.concat([ kendoTextElement(command.text || command.name) ])
		            );
		        },
	
		        _positionResizeHandle: function(e) {
		            var th = $(e.currentTarget);
		            var resizeHandle = this.resizeHandle;
		            var position = th.position();
		            var left;
		            var cellWidth = outerWidth(th);
		            var container = th.closest("div");
		            var indicatorWidth = this.options.columnResizeHandleWidth || 3;
	
		            left = cellWidth;
	
		            if (!resizeHandle) {
		                resizeHandle = this.resizeHandle = $(
		                    '<div class="k-resize-handle"><div class="k-resize-handle-inner" /></div>'
		                );
		            }
	
		            var cells = leafDataCells(th.closest("thead")).filter(":visible");
		            if (isRtl) {
		                left = th.position().left;
		            } else {
		                for (var idx = 0; idx < cells.length; idx++) {
		                    if (cells[idx] == th[0]) {
		                        break;
		                    }
		                    left += cells[idx].offsetWidth;
		                }
		            }
	
		            container.append(resizeHandle);
	
		            resizeHandle
		                .show()
		                .css({
		                    top: position.top,
		                    left: left - indicatorWidth - 1,
		                    height: outerHeight(th),
		                    width: indicatorWidth * 3
		                })
		                .data("th", th);
	
		            var that = this;
		            resizeHandle.off("dblclick" + NS).on("dblclick" + NS, function () {
		                //TODO handle frozen columns index
		                var index= th.index();
		                if ($.contains(that.thead[0], th[0])) {
		                    index += grep(that.columns, function (val) { return val.locked && !val.hidden; }).length;
		                }
		                that.autoFitColumn(index);
		            });
		        },
	
		        autoFitColumn: function (column) {
		            var that = this,
		                options = that.options,
		                columns = that.columns,
		                index,
		                browser = kendo.support.browser,
		                th,
		                headerTable,
		                isLocked,
		                visibleLocked = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).filter(isCellVisible).length : 0,
		                col;
	
		            //  retrieve the column object, depending on the method argument
		            if (typeof column == "number") {
		                column = columns[column];
		            } else if (isPlainObject(column)) {
		                column = grep(columns, function (item) {
		                    return item === column;
		                })[0];
		            } else {
		                column = grep(columns, function (item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            if (!column || column.hidden) {
		                return;
		            }
	
		            index = inArray(column, columns);
		            isLocked = column.locked;
	
		            if (isLocked) {
		                headerTable = that.lockedHeader.children("table");
		            } else {
		                headerTable = that.thead.parent();
		            }
	
		            th = headerTable.find("[data-index='" + index + "']");
	
		            var contentTable = isLocked ? that.lockedTable : that.table,
		                footer = that.footer || $();
	
		            if (that.footer && that.lockedContent) {
		                footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
		            }
	
		            var footerTable = footer.find("table").first();
	
		            if (that.lockedHeader && visibleLocked >= index && !isLocked) {
		                index -= visibleLocked;
		            }
	
		            // adjust column index, depending on previous hidden columns
		            for (var j = 0; j < columns.length; j++) {
		                if (columns[j] === column) {
		                    break;
		                } else {
		                    if (columns[j].hidden) {
		                        index--;
		                    }
		                }
		            }
	
		            // get col elements
		            if (options.scrollable) {
		                col = headerTable.find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")")
		                    .add(contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"))
		                    .add(footerTable.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"));
		            } else {
		                col = contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")");
		            }
	
		            var tables = headerTable.add(contentTable).add(footerTable);
	
		            var oldColumnWidth = outerWidth(th);
	
		            // reset the table and autofitted column widths
		            // if scrolling is disabled, we need some additional repainting of the table
		            col.width("");
		            tables.css("table-layout", "fixed");
		            col.width("auto");
		            tables.addClass("k-autofitting");
		            tables.css("table-layout", "");
	
		            var newColumnWidth = Math.ceil(
		                    Math.max(
		                        outerWidth(th),
		                        outerWidth(contentTable.find("tr").eq(0).children("td:visible").eq(index)),
		                        outerWidth(footerTable.find("tr").eq(0).children("td:visible").eq(index))
		            ));
	
		            col.width(newColumnWidth);
		            column.width = newColumnWidth;
	
		            // if all visible columns have widths, the table needs a pixel width as well
		            if (options.scrollable) {
		                var cols = headerTable.find("col"),
		                    colWidth,
		                    totalWidth = 0;
		                for (var idx = 0, length = cols.length; idx < length; idx += 1) {
		                    colWidth = cols[idx].style.width;
		                    if (colWidth && colWidth.indexOf("%") == -1) {
		                        totalWidth += parseInt(colWidth, 10);
		                    } else {
		                        totalWidth = 0;
		                        break;
		                    }
		                }
	
		                if (totalWidth) {
		                    tables.each(function () {
		                        this.style.width = totalWidth + "px";
		                    });
		                }
		            }
	
		            if (browser.msie && browser.version == 8) {
		                tables.css("display", "inline-table");
		                setTimeout(function () {
		                    tables.css("display", "table");
		                }, 1);
		            }
	
		            tables.removeClass("k-autofitting");
	
		            that.trigger(COLUMNRESIZE, {
		                column: column,
		                oldWidth: oldColumnWidth,
		                newWidth: newColumnWidth
		            });
	
		            that._applyLockedContainersWidth();
		            that._syncLockedContentHeight();
		            that._syncLockedHeaderHeight();
		        },
	
		        _adjustLockedHorizontalScrollBar: function() {
		            var table = this.table,
		                content = table.parent();
	
		            var scrollbar = table[0].offsetWidth > content[0].clientWidth ? kendo.support.scrollbar() : 0;
		            this.lockedContent.height(content.height() - scrollbar);
		        },
	
		        _syncLockedContentHeight: function() {
		            if (this.lockedTable) {
		                if (!this._touchScroller) {
		                    this._adjustLockedHorizontalScrollBar();
		                }
		                this._adjustRowsHeight(this.table, this.lockedTable);
		            }
		        },
	
		        _syncLockedHeaderHeight: function() {
		            if (this.lockedHeader) {
		                var lockedTable = this.lockedHeader.children("table");
		                var table = this.thead.parent();
	
		                this._adjustRowsHeight(lockedTable, table);
	
		                syncTableHeight(lockedTable, table);
		            }
		        },
	
		        _resizable: function() {
		            if (!this.options.resizable) {
		                return;
		            }
	
		            if (this.resizable) {
		                this.resizable.destroy();
		            }
	
		            var treelist = this;
	
		            $(this.lockedHeader).find("thead").add(this.thead)
		                .on("mousemove" + NS, "th", $.proxy(this._positionResizeHandle, this));
	
		            this.resizable = new kendo.ui.Resizable(this.wrapper, {
		                handle: ".k-resize-handle",
		                start: function(e) {
		                    var th = $(e.currentTarget).data("th");
		                    var index = $.inArray(th[0], leafDataCells(th.closest("thead")).filter(":visible"));
		                    var colSelector = "col:eq(" + index + ")";
		                    var header, contentTable;
	
		                    treelist.wrapper.addClass("k-grid-column-resizing");
	
		                    if (treelist.lockedHeader && $.contains(treelist.lockedHeader[0], th[0])) {
		                        header = treelist.lockedHeader;
		                        contentTable = treelist.lockedTable;
		                    } else {
		                        header = treelist.thead.parent();
		                        contentTable = treelist.table;
		                    }
	
		                    this.col = contentTable.children("colgroup").find(colSelector)
		                          .add(header.find(colSelector));
		                    this.th = th;
		                    this.startLocation = e.x.location;
		                    this.columnWidth = outerWidth(th);
		                    this.table = this.col.closest("table");
		                    this.totalWidth = this.table.width();
		                },
		                resize: function(e) {
		                    var rtlModifier = isRtl ? -1 : 1;
		                    var minColumnWidth = 11;
		                    var delta = (e.x.location * rtlModifier) - (this.startLocation * rtlModifier);
	
		                    if (this.columnWidth + delta < minColumnWidth) {
		                        delta = minColumnWidth - this.columnWidth;
		                    }
	
		                    this.table.width(this.totalWidth + delta);
		                    this.col.width(this.columnWidth + delta);
		                },
		                resizeend: function() {
		                    treelist.wrapper.removeClass("k-grid-column-resizing");
	
		                    var field = this.th.attr("data-field");
		                    var column = grep(leafColumns(treelist.columns), function(c) {
		                        return c.field == field;
		                    });
		                    var newWidth = Math.floor(outerWidth(this.th));
	
		                    column[0].width = newWidth;
		                    treelist._resize();
		                    treelist._syncLockedContentHeight();
		                    treelist._syncLockedHeaderHeight();
		                    treelist.trigger(COLUMNRESIZE, {
		                        column: column,
		                        oldWidth: this.columnWidth,
		                        newWidth: newWidth
		                    });
	
		                    this.table = this.col = this.th = null;
		                }
		            });
		        },
	
		        _sortable: function() {
		            var columns;
		            var column;
		            var sortableInstance;
		            var cells;
		            var cell, idx, length;
		            var sortable = this.options.sortable;
		            var hasMultiColumnHeaders = grep(this.columns, function(item) {
		                return item.columns !== undefined;
		            }).length > 0;
	
		            if (!sortable) {
		                return;
		            }
	
		            if (hasMultiColumnHeaders) {
		                if (this.lockedHeader) {
		                    cells = sortCells(leafDataCells(this.lockedHeader.find(">table>thead")).add(leafDataCells(this.thead)));
		                } else {
		                    cells = leafDataCells(this.thead);
		                }
		            } else {
		                cells = $(this.lockedHeader).add(this.thead).find("th");
		            }
		            columns = leafColumns(this.columns);
	
		            for (idx = 0, length = cells.length; idx < length; idx++) {
		                column = columns[idx];
	
		                if (column.sortable !== false && !column.command && column.field) {
		                    cell = cells.eq(idx);
	
		                    sortableInstance = cell.data("kendoColumnSorter");
		                    if (sortableInstance) {
		                        sortableInstance.destroy();
		                    }
	
		                    cell.kendoColumnSorter(
		                            extend({}, sortable, column.sortable, {
		                                dataSource: this.dataSource
		                            })
		                        );
		                }
		            }
		        },
	
		        _filterable: function() {
		            var cells;
		            var filterable = this.options.filterable;
		            var idx;
		            var length;
		            var columns;
		            var column;
		            var cell;
		            var filterMenuInstance;
		            var hasMultiColumnHeaders = grep(this.columns, function(item) {
		                return item.columns !== undefined;
		            }).length > 0;
	
		            if (!filterable || this.options.columnMenu) {
		                return;
		            }
	
		            var filterInit = proxy(function(e) {
		                this.trigger(FILTERMENUINIT, { field: e.field, container: e.container });
		            }, this);
	
		            var filterOpen = proxy(function(e) {
		                this.trigger(FILTERMENUOPEN, { field: e.field, container: e.container });
		            }, this);
	
		            if (hasMultiColumnHeaders) {
		                if (this.lockedHeader) {
		                    cells = leafDataCells(this.lockedHeader.find(">table>thead")).add(leafDataCells(this.thead));
		                } else {
		                    cells = leafDataCells(this.thead);
		                }
		            } else {
		                cells = $(this.lockedHeader).add(this.thead).find("th");
		            }
		            columns = leafColumns(this.columns);
	
		            for (idx = 0, length = cells.length; idx < length; idx++) {
		                column = columns[idx];
		                cell = cells.eq(idx);
	
		                filterMenuInstance = cell.data("kendoFilterMenu");
		                if (filterMenuInstance) {
		                    filterMenuInstance.destroy();
		                }
	
		                if (column.command || column.filterable === false) {
		                    continue;
		                }
	
		                cell.kendoFilterMenu(extend(true, {}, filterable, column.filterable, {
		                    dataSource: this.dataSource,
		                    init: filterInit,
		                    open: filterOpen
		                }));
		            }
		        },
	
		        _change: function() {
		            this.trigger(CHANGE);
		        },
	
		        _isLocked: function() {
		            return this.lockedHeader !== null;
		        },
	
		        _selectable: function() {
		            var that = this;
		            var selectable = this.options.selectable;
		            var filter;
		            var element = this.table;
		            var useAllItems;
		            var isLocked = that._isLocked();
		            var multi;
		            var cell;
	
		            if (selectable) {
		                selectable = kendo.ui.Selectable.parseOptions(selectable);
	
		                if (this._hasLockedColumns) {
		                    element = element.add(this.lockedTable);
		                    useAllItems = selectable.multiple && selectable.cell;
		                }
	
		                filter = ">tbody>tr:not(.k-footer-template)";
	
		                if (selectable.cell) {
		                    filter = filter + ">td";
		                }
	
		                this.selectable = new kendo.ui.Selectable(element, {
		                    filter: filter,
		                    aria: true,
		                    multiple: selectable.multiple,
		                    inputSelectors: ".k-icon.k-i-collapse,.k-icon.k-i-expand",
		                    change: proxy(this._change, this),
		                    useAllItems: useAllItems,
		                    continuousItems: proxy(this._continuousItems, this, filter, selectable.cell),
		                    relatedTarget: !selectable.cell && this._hasLockedColumns ? proxy(this._selectableTarget, this) : undefined
		                });
	
		                if (that.options.navigatable) {
		                    multi = selectable.multiple;
		                    cell = selectable.cell;
	
		                    element.on("keydown" + NS, function(e) {
		                        var current = that.current();
		                        var target = e.target;
		                        if (e.keyCode === keys.SPACEBAR && !e.shiftKey && $.inArray(target, element) > -1 &&
		                            !current.is(".k-header")) {
	
		                                e.preventDefault();
		                                e.stopPropagation();
		                                current = cell ? current : current.parent();
	
		                                if (isLocked && !cell) {
		                                    current = current.add(that._relatedRow(current));
		                                }
	
		                                if (multi) {
		                                    if(!e.ctrlKey) {
		                                        that.selectable.clear();
		                                    } else {
		                                        if (current.hasClass(classNames.selected)) {
		                                            current.removeClass(classNames.selected);
		                                            that.trigger(CHANGE);
		                                            return;
		                                        }
		                                    }
		                                } else {
		                                    that.selectable.clear();
		                                }
		                                if (!cell) {
		                                    that.selectable._lastActive = current;
		                                }
	
		                                that.selectable.value(current);
		                        } else if (!cell && ((e.shiftKey && e.keyCode == keys.LEFT)||
		                                    (e.shiftKey && e.keyCode == keys.RIGHT)||
		                                    (e.shiftKey && e.keyCode == keys.UP)||
		                                    (e.shiftKey && e.keyCode == keys.DOWN)||
		                                    (e.keyCode === keys.SPACEBAR && e.shiftKey))) {
	
		                            e.preventDefault();
		                            e.stopPropagation();
		                            current = current.parent();
	
		                            if (isLocked) {
		                                current = current.add(that._relatedRow(current));
		                            }
	
		                            if (multi) {
		                                if(!that.selectable._lastActive) {
		                                    that.selectable._lastActive = current;
		                                }
		                                that.selectable.selectRange(that.selectable._firstSelectee(), current);
		                            } else {
		                                that.selectable.clear();
		                                that.selectable.value(current);
		                            }
		                        }
		                    });
		                }
		            }
		        },
	
		        _continuousItems: function(filter, cell) {
		            if (!this.lockedContent) {
		                return;
		            }
	
		            var lockedItems = $(filter, this.lockedTable);
		            var nonLockedItems = $(filter, this.table);
		            var columns = cell ? lockedColumns(this.columns).length : 1;
		            var nonLockedColumns = cell ? this.columns.length - columns : 1;
		            var result = [];
	
		            for (var idx = 0; idx < lockedItems.length; idx += columns) {
		                push.apply(result, lockedItems.slice(idx, idx + columns));
		                push.apply(result, nonLockedItems.splice(0, nonLockedColumns));
		            }
	
		            return result;
		        },
	
		        _selectableTarget: function(items) {
		            var related;
		            var result = $();
		            for (var idx = 0, length = items.length; idx < length; idx ++) {
		                related = this._relatedRow(items[idx]);
	
		                if (inArray(related[0], items) < 0) {
		                    result = result.add(related);
		                }
		            }
	
		            return result;
		        },
	
		        _relatedRow: function(row) {
		            var lockedTable = this.lockedTable;
		            row = $(row);
	
		            if (!lockedTable) {
		                return row;
		            }
	
		            var table = row.closest(this.table.add(this.lockedTable));
		            var index = table.find(">tbody>tr").index(row);
	
		            table = table[0] === this.table[0] ? lockedTable : this.table;
	
		            return table.find(">tbody>tr").eq(index);
		        },
	
		        select: function(value) {
		            var selectable = this.selectable;
	
		            if (!selectable) {
		                return $();
		            }
	
		            if (typeof value !== "undefined") {
		                if (!selectable.options.multiple) {
		                    selectable.clear();
	
		                    value = value.first();
		                }
	
		                if (this._hasLockedColumns) {
		                    value = value.add($.map(value, proxy(this._relatedRow, this)));
		                }
		            }
	
		            return selectable.value(value);
		        },
	
		        clearSelection: function() {
		            var selected = this.select();
	
		            if (selected.length) {
		                this.selectable.clear();
	
		                this.trigger(CHANGE);
		            }
		        },
	
		        _dataSource: function(dataSource) {
		            var that = this;
		            var ds = this.dataSource;
		            var pageable = that.options.pageable;
	
		            if (ds) {
		                ds.unbind(CHANGE, this._refreshHandler);
		                ds.unbind(ERROR, this._errorHandler);
		                ds.unbind(PROGRESS, this._progressHandler);
		            }
	
		            this._refreshHandler = proxy(this.refresh, this);
		            this._errorHandler = proxy(this._error, this);
		            this._progressHandler = proxy(this._progress, this);
	
	
		            if (isPlainObject(dataSource)) {
		                extend(dataSource, { table: that.table, fields: that.columns });
	
		                if (isPlainObject(pageable) && pageable.pageSize !== undefined) {
		                    dataSource.pageSize = pageable.pageSize;
		                }
		            }
	
		            ds = this.dataSource = TreeListDataSource.create(dataSource);
	
		            if (pageable) {
		                ds._collapsedTotal = undefined;
		            }
	
		            ds.bind(CHANGE, this._refreshHandler);
		            ds.bind(ERROR, this._errorHandler);
		            ds.bind(PROGRESS, this._progressHandler);
	
		            this._dataSourceFetchProxy = proxy(function() {
		                this.dataSource.fetch();
		            }, this);
		        },
	
		        setDataSource: function(dataSource) {
		            this._dataSource(dataSource);
		            this._sortable();
		            this._filterable();
		            this._columnMenu();
		            this._pageable();
	
		            this._contentTree.render([]);
	
		            if (this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        },
	
		        dataItem: function(element) {
		            if (element instanceof TreeListModel) {
		                return element;
		            }
	
		            var row = $(element).closest("tr");
		            var uid = row.attr(kendo.attr("uid"));
		            var model = isUndefined(uid) ? null : this.dataSource.getByUid(uid);
	
		            return model;
		        },
	
		        editRow: function(row) {
		            var that = this;
		            var model;
	
		            if (this._isIncellEditable() || !this.options.editable) {
		                return;
		            }
	
		            if (typeof row === STRING) {
		                row = this.tbody.find(row);
		            }
	
		            if (that._isPageable() && that._isPopupEditable() && row instanceof TreeListModel) {
		                // popup editor can be created without a rendered row
		                model = row;
		            } else {
		                model = this.dataItem(row);
		            }
	
		            if (!model) {
		                return;
		            }
	
		            if (this._editMode() != "popup") {
		                model._edit = true;
		            }
	
		            this._cancelEditor();
	
		            if (this.trigger(BEFORE_EDIT, { model: model })) {
		                that.dataSource._restorePageSizeAfterAddChild();
		                return;
		            }
	
		            this._render();
	
		            this._createEditor(model);
	
		            this.trigger(EDIT, {
		                container: this.editor.wrapper,
		                model: model
		            });
		        },
	
		        _cancelEdit: function(e) {
		            if (!this.editor) {
		                return;
		            }
		            var currentIndex;
	
		            e = extend(e, {
		                container: this.editor.wrapper,
		                model: this.editor.model
		            });
	
		            if (this.trigger(CANCEL, e)) {
		                return;
		            }
	
		            if (this.options.navigatable) {
		                currentIndex = this.items().index($(this.current()).parent());
		            }
	
		            this.cancelRow();
	
		            if (this.options.navigatable) {
		                this.current(this.items().eq(currentIndex).children().filter(NAVCELL).first());
		                focusTable(this.table, true);
		            }
		        },
	
		        cancelRow: function() {
		            if (this._isIncellEditable()) {
		                return;
		            }
	
		            this._cancelEditor();
	
		            this._render();
		        },
	
		        saveRow: function() {
		            var editor = this.editor;
		            var args;
	
		            if (this._isIncellEditable()) {
		                return;
		            }
	
		            if (!editor) {
		                return ;
		            }
	
		            args = {
		                model: editor.model,
		                container: editor.wrapper
		            };
	
		            if (editor.end() && !this.trigger(SAVE, args)) {
		                this.dataSource.sync();
		            }
		        },
	
		        addRow: function(parent) {
		            var that = this;
		            var dataSource = that.dataSource;
		            var pageable = that._isPageable();
		            var incellEditing = that._isIncellEditable();
		            var inlineEditing = that._isInlineEditable();
		            var editor = this.editor;
		            var index = 0;
		            var model = {};
	
		            if ((editor && !editor.end()) || !this.options.editable) {
		                return;
		            }
	
		            if (parent) {
		                if (!(parent instanceof TreeListModel)) {
		                    parent = this.dataItem(parent);
		                }
	
		                model[parent.parentIdField] = parent.id;
		                index = this.dataSource.indexOf(parent) + 1;
	
		                this.expand(parent)
		                    .then(function() {
		                        var showNewModelInView = pageable && dataSource._isLastItemInView(parent) && (incellEditing || inlineEditing);
		                        that._insertAt(model, index, showNewModelInView);
		                    });
	
		                return;
		            }
	
		            this._insertAt(model, index);
		        },
	
		        _insertAt: function(model, index, showNewModelInView) {
		            var that = this;
		            var dataSource = that.dataSource;
		            model = that.dataSource.insert(index, model);
	
		            if (showNewModelInView) {
		                dataSource._setAddChildPageSize();
		            }
	
		            var row = this._itemFor(model);
		            var cell;
	
		            if (that._isIncellEditable()) {
		                cell = row.children("td").eq(that._firstEditableColumnIndex(row));
		                that.editCell(cell);
		            } else if (row && row[0]) {
		                that.editRow(row);
		            } else if (that._isPageable() && that._isPopupEditable()) {
		                that.editRow(model);
		            }
		        },
	
		        _firstEditableColumnIndex: function(container) {
		            var that = this;
		            var model = that.dataItem(container);
		            var columns = leafColumns(that.columns);
		            var length = columns.length;
		            var column;
		            var idx;
	
		            for (idx = 0; idx < length; idx++) {
		                column = columns[idx];
	
		                if (model && (!model.editable || model.editable(column.field)) && !column.command && column.field && column.hidden !== true) {
		                    return idx;
		                }
		            }
	
		            return -1;
		        },
	
		        removeRow: function(row) {
		            var model = this.dataItem(row);
		            var args = {
		                model: model,
		                row: row
		            };
	
		            if (model && !this.trigger(REMOVE, args)) {
		                this.dataSource.remove(model);
	
		                if (!this._isIncellEditable()) {
		                    this.dataSource.sync();
		                }
		            }
		        },
	
		        _cancelEditor: function() {
		            var that = this;
		            var model;
		            var editor = that.editor;
	
		            if (editor) {
		                model = editor.model;
	
		                that._destroyEditor();
	
		                if (!that._isIncellEditable()) {
		                    that.dataSource.cancelChanges(model);
		                } else if (that._shouldRestorePageSize()) {
		                    that.dataSource._restorePageSizeAfterAddChild();
		                }
	
		                model._edit = false;
		            }
	
		            that._preventPageSizeRestore = false;
		        },
	
		        _shouldRestorePageSize: function() {
		            var that = this;
		            return that._isPageable() && that._isIncellEditable() && !that._preventPageSizeRestore;
		        },
	
		        _destroyEditor: function() {
		            if (!this.editor) {
		                return;
		            }
	
		            this.editor.close();
		            this.editor = null;
		        },
	
		        _createEditor: function(model) {
		            var row = this.itemFor(model);
		            var columns = leafColumns(this.columns);
		            var leafCols = [];
	
		            for (var idx = 0; idx < columns.length; idx++) {
		                leafCols.push(extend({}, columns[idx]));
		                delete leafCols[idx].parentColumn;
		            }
	
		            row = row.add(this._relatedRow(row));
	
		            var mode = this._editMode();
	
		            var options = {
		                columns: leafCols,
		                model: model,
		                target: this,
		                clearContainer: false,
		                template: this.options.editable.template
		            };
	
		            if (mode == "inline") {
		                this.editor = new Editor(row, options);
		            } else {
		                extend(options, {
		                    window: this.options.editable.window,
		                    commandRenderer: proxy(function() {
		                        return this._buildCommands(["update", "canceledit"]);
		                    }, this),
		                    fieldRenderer: proxy(this._cellContent, this),
		                    save: proxy(this.saveRow, this),
		                    cancel: proxy(this._cancelEdit, this),
		                    appendTo: this.wrapper
		                });
	
		                this.editor = new PopupEditor(row, options);
		            }
		        },
	
		        _createIncellEditor: function(cell, options) {
		            var that = this;
		            var column = extend({}, options.columns[0]);
	
		            delete column.parentColumn;
	
		            return new IncellEditor(cell, extend({}, {
		                fieldRenderer: proxy(that._cellContent, that),
		                appendTo: that.wrapper,
		                clearContainer: false,
		                target: that,
		                columns: [column],
		                model: options.model,
		                change: options.change
		            }));
		        },
	
		        editCell: function(cell) {
		            var that = this;
		            cell = $(cell);
		            var column = leafColumns(that.columns)[that.cellIndex(cell)];
		            var model = that.dataItem(cell);
	
		            if (that._isIncellEditable() && model && isColumnEditable(column, model)) {
		                that._editCell(cell, column, model);
		            }
		        },
	
		        _editCell: function(cell, column, model) {
		            var that = this;
		            var editedCell;
	
		            if (that.trigger(BEFORE_EDIT, { model: model })) {
		                that.dataSource._restorePageSizeAfterAddChild();
		                return;
		            }
	
		            that.closeCell();
	
		            model._edit = true;
	
		            that._cancelEditor();
	
		            that._render({
		                editedColumn: column,
		                editedColumnIndex: cell.index()
		            });
	
		            editedCell = that.table.add(that.lockedTable).find(DOT + classNames.editCell).first();
	
		            that.editor = that._createIncellEditor(editedCell, {
		                columns: [column],
		                model: model,
		                change: function(e) {
		                    if (that.trigger(SAVE, { values: e.values, container: cell, model: model } )) {
		                        e.preventDefault();
		                    }
	
		                }
		            });
	
		            // refresh the current element as the DOM element reference can be changed after render()
		            that._current = editedCell;
	
		            that.trigger(EDIT, { container: cell, model: model });
		        },
	
		        closeCell: function(isCancel) {
		            var that = this;
		            var cell = (that.editor || {}).element;
		            var tr;
		            var model;
	
		            if (!cell || !cell[0] || !that._isIncellEditable()) {
		                return;
		            }
	
		            model = that.dataItem(cell);
	
		            if (isCancel && that.trigger(CANCEL, { container: cell, model: model })) {
		                return;
		            }
	
		            that.trigger(CELL_CLOSE, { type: isCancel ? CANCEL: SAVE, model: model, container: cell });
	
		            that._cancelEditor();
	
		            cell.removeClass(classNames.editCell);
	
		            tr = cell.parent().removeClass(classNames.editRow);
	
		            if (that.lockedContent) {
		                that._relatedRow(tr).removeClass(classNames.editRow);
		            }
	
		            that._render();
	
		            that.trigger(ITEM_CHANGE, { item: tr, data: model, ns: ui });
	
		            if (that.lockedContent) {
		                adjustRowHeight(tr.css("height", "")[0], that._relatedRow(tr).css("height", "")[0]);
		            }
		        },
	
		        cancelChanges: function() {
		            this.dataSource.cancelChanges();
		        },
	
		        saveChanges: function() {
		            var that = this;
		            var editable = (that.editor || {}).editable;
		            var valid = editable && editable.end();
	
		            if ((valid || !editable) && !that.trigger(SAVE_CHANGES)) {
		                that.dataSource.sync();
		            }
		        },
	
		        _editMode: function() {
		            var mode = "inline",
		                editable = this.options.editable;
	
		            if (editable !== true) {
		                if (typeof editable == "string") {
		                    mode = editable;
		                } else {
		                    mode = editable.mode || mode;
		                }
		            }
	
		            return mode.toLowerCase();
		        },
	
		        _isIncellEditable: function() {
		            return this._editMode() === INCELL;
		        },
	
		        _isInlineEditable: function() {
		            return this._editMode() === INLINE;
		        },
	
		        _isPopupEditable: function() {
		            return this._editMode() === POPUP;
		        },
	
		        hideColumn: function(column) {
		            this._toggleColumnVisibility(column, true);
		        },
	
		        showColumn: function(column) {
		            this._toggleColumnVisibility(column, false);
		        },
	
		        _toggleColumnVisibility: function(column, hidden) {
		            column = this._findColumn(column);
	
		            if (!column || column.hidden === hidden) {
		                return;
		            }
	
		            column.hidden = hidden;
		            this._setParentsVisibility(column, !hidden);
	
		            this._ensureExpandableColumn();
	
		            this._renderCols();
		            this._renderHeader();
		            this._render();
	
		            this._adjustTablesWidth();
	
		            this.trigger(hidden ? COLUMNHIDE : COLUMNSHOW, { column: column });
	
		            if (!hidden && !column.width) {
		                this.table
		                    .add(this.thead.closest("table"))
		                    .width("");
		            }
		            this._updateFirstColumnClass();
		        },
	
		        _findColumn: function(column) {
		            if (typeof column == "number") {
		                column = this.columns[column];
		            } else if (isPlainObject(column)) {
		                column = grep(leafColumns(this.columns), function(item) {
		                    return item === column;
		                })[0];
		            } else {
		                column = grep(leafColumns(this.columns), function(item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            return column;
		        },
	
		        _adjustTablesWidth: function() {
		            var idx, length;
		            var cols = this.thead.prev().children();
		            var colWidth, width = 0;
	
		            for (idx = 0, length = cols.length; idx < length; idx++ ) {
		                colWidth = cols[idx].style.width;
		                if (colWidth && colWidth.indexOf("%") == -1) {
		                    width += parseInt(colWidth, 10);
		                } else {
		                    width = 0;
		                    break;
		                }
		            }
	
	
		            if (width) {
		                this.table
		                    .add(this.thead.closest("table"))
		                    .width(width);
		            }
		        },
	
		        _reorderable: function() {
		            if (!this.options.reorderable) {
		                return;
		            }
	
		            var scrollable = this.options.scrollable === true;
		            var selector = (scrollable ? ".k-grid-header:first " : "table:first>.k-grid-header ") + HEADERCELLS;
		            var that = this;
	
		            this._draggableInstance = new ui.Draggable(this.wrapper, {
		                group: kendo.guid(),
		                filter: selector,
		                hint: function(target) {
		                    return $('<div class="k-header k-drag-clue" />')
		                    .css({
		                        width: target.width(),
		                        paddingLeft: target.css("paddingLeft"),
		                        paddingRight: target.css("paddingRight"),
		                        lineHeight: target.height() + "px",
		                        paddingTop: target.css("paddingTop"),
		                        paddingBottom: target.css("paddingBottom")
		                    })
		                    .html(target.attr(kendo.attr("title")) || target.attr(kendo.attr("field")) || target.text())
		                    .prepend('<span class="k-icon k-drag-status k-i-cancel" />');
		                }
		            });
	
		            this.reorderable = new ui.Reorderable(this.wrapper, {
		                draggable: this._draggableInstance,
		                dragOverContainers: proxy(this._allowDragOverContainers, this),
		                inSameContainer: function(e) {
		                    return $(e.source).parent()[0] === $(e.target).parent()[0] && targetParentContainerIndex(flatColumnsInDomOrder(that.columns), that.columns, e.sourceIndex, e.targetIndex) > -1;
		                },
		                change: function(e) {
		                    var columns = flatColumnsInDomOrder(that.columns);
		                    var column = columns[e.oldIndex];
		                    var newIndex = targetParentContainerIndex(columns, that.columns, e.oldIndex, e.newIndex);
	
		                    that.trigger(COLUMNREORDER, {
		                        newIndex: newIndex,
		                        oldIndex: inArray(column, columns),
		                        column: column
		                    });
	
		                    that.reorderColumn(newIndex, column, e.position === "before");
		                }
		            });
		        },
	
		        _allowDragOverContainers: function(sourceIndex, targetIndex) {
		            var columns = flatColumnsInDomOrder(this.columns);
		            return columns[sourceIndex].lockable !== false && targetParentContainerIndex(columns, this.columns, sourceIndex, targetIndex) > -1;
		        },
	
		        _reorderTrees: function(destSources, destContainer, destDomTree, sources, sourcesContainer, sourcesDomTree, before, depth) {
		            var ths = $();
		            var source = sourcesContainer.find("tr:eq(" + sources[0].rowIndex + ")");
		            var sourceDOM = sourcesDomTree.children[sources[0].rowIndex];
		            var sourceChildren = source.children();
		            var destDomChildren;
		            var currentIndex;
		            var destColumn = before? destSources[0] : destSources[destSources.length -1];
		            var destRow;
		            var sourcesLeafs;
		            var destLeafs;
		            var reorderTaget;
		            var destThs;
	
		            for (var idx = 0; idx < sources.length; idx++) {
		                currentIndex = sources[idx].cellIndex;
		                ths = ths.add(sourceChildren.eq(currentIndex));
		                destDomChildren = destDomTree.children[destColumn.rowIndex].children;
		                if (destDomTree === sourcesDomTree && before) {
		                    currentIndex += idx;
		                }
	
		                destDomChildren.splice(before ? destColumn.cellIndex + idx : destColumn.cellIndex + 1+ idx, 0, sourceDOM.children[currentIndex]);
		            }
	
		            if (destDomTree === sourcesDomTree && before) {
		                sourceDOM.children.splice(sources[0].cellIndex + sources.length, sources.length);
		            } else {
		                sourceDOM.children.splice(sources[0].cellIndex, sources.length);
		            }
		            destRow = destContainer.find("tr:eq(" + destColumn.rowIndex + ")");
		            destThs = destRow.find(">th.k-header:eq(" + destColumn.cellIndex + ")");
	
		            if (destThs.length && ths[0] !== destThs[0]) {
		                ths[before ? "insertBefore" : "insertAfter"](destThs);
		            }
	
		            if (depth >= sources[0].rowIndex + 1 && depth != 1) {
		                sourcesLeafs = [];
		                for (idx = 0; idx < sources.length; idx++) {
		                    if (sources[idx].columns) {
		                        sourcesLeafs = sourcesLeafs.concat(sources[idx].columns);
		                    }
		                }
		                if (!sourcesLeafs.length) {
		                    return;
		                }
	
		                destLeafs = [];
	
		                for (idx = 0; idx < destSources.length; idx++) {
		                    if (destSources[idx].columns) {
		                        destLeafs = destLeafs.concat(destSources[idx].columns);
		                    }
		                }
	
		                if (!destLeafs.length && (destContainer !== sourcesContainer || (destColumn.cellIndex - sources[0].cellIndex > 1 || sources[0].cellIndex - destColumn.cellIndex > 1))) {
		                    reorderTaget = findReorderTarget(this.columns, destColumn, sources[0], before, this.columns);
	
		                    destLeafs = [reorderTaget];
		                    if (!reorderTaget && sourcesLeafs.length && destContainer.find("tr").length > sources[0].rowIndex + 1) {
		                        this._insertTree(sourcesLeafs, sourcesContainer, sourcesDomTree, destContainer, destDomTree);
		                        return;
		                    }
		                }
	
		                if (!destLeafs.length) {
		                    return;
		                }
	
		                this._reorderTrees(destLeafs, destContainer, destDomTree, sourcesLeafs, sourcesContainer, sourcesDomTree, before, depth);
		            }
		        },
	
		        _insertTree: function(columns, sourcesContainer, sourcesDomTree, destContainer, destDomTree) {
		            var leafs = [];
		            var row;
		            var ths = $();
		            var domTr;
	
		            row = sourcesContainer.find("tr:eq(" + columns[0].rowIndex + ")");
		            domTr = sourcesDomTree.children[columns[0].rowIndex];
	
		            for (var idx = 0; idx < columns.length; idx++) {
		                if (columns[idx].columns) {
		                    leafs = leafs.concat(columns[idx].columns);
		                }
		                destDomTree.children[columns[0].rowIndex].children.splice(idx, 0, domTr.children[columns[idx].rowIndex]);
		                ths = ths.add(row.find(">th.k-header:eq(" + columns[idx].cellIndex + ")"));
		            }
	
		            sourcesDomTree.children[columns[0].rowIndex].children.splice(columns[0].cellIndex, columns.length);
		            destContainer.find("tr:eq(" + columns[0].rowIndex + ")").append(ths);
	
		            if (leafs.length) {
		                this._insertTree(leafs, sourcesContainer, sourcesDomTree, destContainer, destDomTree);
		            }
		        },
	
		        _reorderHeader: function(destColumn, column, before) {
		            var sourcesDepth = column.columns ? depth([column]) : 1;
		            var targetDepth = destColumn.columns ? depth([destColumn]) : 1;
		            var sourceLocked = isLocked(column);
		            var destLocked = isLocked(destColumn);
		            var destContainer = destLocked ? this.lockedHeader : this.thead;
		            var sourcesContainer = sourceLocked ? this.lockedHeader : this.thead;
		            var destDomTree = destLocked ? this._lockedHeaderTree : this._headerTree;
		            var sourcesDomTree = sourceLocked ? this._lockedHeaderTree : this._headerTree;
		            var rowsToAdd;
		            var destRows = destContainer.find("tr");
	
	
		            if (sourcesDepth === targetDepth || sourcesDepth < destRows.length ) {
		                this._reorderTrees([destColumn], destContainer, destDomTree , [column], sourcesContainer ,sourcesDomTree, before, sourcesDepth);
		                updateRowSpans(destContainer, destDomTree);
		                removeEmptyRows(sourcesContainer, sourcesDomTree);
		            } else {
		                if (destContainer !== sourcesContainer) {
		                    rowsToAdd = sourcesDepth - destRows.length;
	
		                    destRows.each(function (idx) {
		                        var cells = this.cells;
		                        for (var i = 0; i < cells.length; i++) {
		                            if (cells[i].colSpan <= 1 && cells[i].attributes.rowspan) {
		                                destDomTree.children[idx].children[i].attr.rowSpan += rowsToAdd;
		                                cells[i].rowSpan += rowsToAdd;
		                            }
		                        }
		                    });
	
		                    for (var j = 0; j < rowsToAdd ; j++) {
		                       destDomTree.children.push(kendoDomElement("tr", { "role": "row" }));
		                       if (destContainer.is("thead")) {
		                           destContainer.append("<tr role='row'></tr>");
		                       } else {
		                           destContainer.find("thead").append("<tr role='row'></tr>");
		                       }
		                    }
		                }
	
		                this._reorderTrees([destColumn], destContainer, destDomTree , [column], sourcesContainer ,sourcesDomTree, before, sourcesDepth);
		                removeEmptyRows(sourcesContainer, sourcesDomTree);
		             }
		        },
	
		        reorderColumn: function(destIndex, column, before) {
		            var lockChanged;
		            var parent = column.parentColumn;
		            var columns = parent ? parent.columns : this.columns;
		            var sourceIndex = inArray(column, columns);
		            var destColumn = columns[destIndex];
		            var isLocked = !!destColumn.locked;
		            var hasMultiColumnHeaders = grep(this.columns, function(item) {
		                return item.columns !== undefined;
		            }).length > 0;
		            var nonLockedColumnsLength = nonLockedColumns(columns).length;
	
		            if (sourceIndex === destIndex) {
		                return;
		            }
	
		            if (isLocked && !column.locked && nonLockedColumnsLength == 1) {
		                return;
		            }
	
		            if (!isLocked && column.locked && (columns.length - nonLockedColumnsLength == 1)) {
		                return;
		            }
	
		            if (before === undefined) {
		                before = destIndex < sourceIndex;
		            }
	
		            if (hasMultiColumnHeaders) {
		                this._reorderHeader(destColumn, column, before);
		            }
	
		            lockChanged = !!column.locked;
		            lockChanged = lockChanged != isLocked;
	
		            column.locked = isLocked;
		            columns.splice(before ? destIndex : destIndex + 1, 0, column);
		            columns.splice(sourceIndex < destIndex ? sourceIndex : sourceIndex + 1, 1);
		            this._setColumnDataIndexes(leafColumns(this.columns));
		            this._clearColsCache();
		            this._renderCols();
	
		            //reorder column header manually
		            if (!hasMultiColumnHeaders) {
		                var ths = $(this.lockedHeader).add(this.thead).find("th");
		                ths.eq(sourceIndex)[before ? "insertBefore" : "insertAfter"](ths.eq(destIndex));
	
		                var dom = this._headerTree.children[0].children;
		                if (this._hasLockedColumns) {
		                    dom = this._lockedHeaderTree.children[0].children.concat(dom);
		                }
		                dom.splice(before ? destIndex : destIndex + 1, 0, dom[sourceIndex]);
		                dom.splice(sourceIndex < destIndex ? sourceIndex : sourceIndex + 1, 1);
		                if (this._hasLockedColumns) {
		                    this._lockedHeaderTree.children[0].children = dom.splice(0, lockedColumns(columns).length);
		                    this._headerTree.children[0].children = dom;
		                }
		            } else {
		                if (this.lockedHeader) {
		                    columns = nonLockedColumns(this.columns);
		                    this._prepareColumns([{ rowSpan: 1, cells: [], index: 0 }], columns);
		                    columns = lockedColumns(this.columns);
		                    this._prepareColumns([{ rowSpan: 1, cells: [], index: 0 }], columns);
		                } else {
		                    this._prepareColumns([{ rowSpan: 1, cells: [], index: 0 }], this.columns);
		                }
		            }
		            this._updateColumnCellIndex();
		            this._applyLockedContainersWidth();
		            this._syncLockedHeaderHeight();
		            this._updateFirstColumnClass();
	
		            this.refresh();
	
		            if(!lockChanged) {
		                return;
		            }
	
		            if (isLocked) {
		                this.trigger(COLUMNLOCK, {
		                    column: column
		                });
		            } else {
		                this.trigger(COLUMNUNLOCK, {
		                    column: column
		                });
		            }
		        },
	
		        lockColumn: function(column) {
		            var columns = this.columns;
	
		            if (typeof column == "number") {
		                column = columns[column];
		            } else {
		                column = grep(columns, function(item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            if (!column || column.hidden) {
		                return;
		            }
	
		            var index = lockedColumns(columns).length - 1;
		            this.reorderColumn(index, column, false);
		        },
	
		        unlockColumn: function(column) {
		            var columns = this.columns;
	
		            if (typeof column == "number") {
		                column = columns[column];
		            } else {
		                column = grep(columns, function(item) {
		                    return item.field === column;
		                })[0];
		            }
	
		            if (!column || column.hidden) {
		                return;
		            }
	
		            var index = lockedColumns(columns).length;
		            this.reorderColumn(index, column, true);
		        },
	
		        _columnMenu: function() {
		            var ths = $(this.lockedHeader).add(this.thead).find("th");
		            var columns = this.columns;
		            var options = this.options;
		            var columnMenu = options.columnMenu;
		            var column, menu, menuOptions, sortable, filterable;
		            var initHandler = proxy(this._columnMenuInit, this);
		            var openHandler = proxy(this._columnMenuOpen, this);
		            var lockedColumnsLength = lockedColumns(columns).length;
		            var hasMultiColumnHeaders = grep(this.columns, function(item) {
		                return item.columns !== undefined;
		            }).length > 0;
	
		            if (hasMultiColumnHeaders) {
		                columns = leafColumns(columns);
		                if (this.lockedHeader) {
		                    ths = sortCells(leafDataCells(this.lockedHeader.find(">table>thead")).add(leafDataCells(this.thead)));
		                } else {
		                    ths = leafDataCells(this.thead);
		                }
		            } else {
		                ths = $(this.lockedHeader).add(this.thead).find("th");
		            }
	
		            if (!columnMenu) {
		                return;
		            }
	
		            if (typeof columnMenu == "boolean") {
		                columnMenu = {};
		            }
	
		            for (var i = 0; i < ths.length; i++) {
		                column = columns[i];
		                if (!column.field) {
		                    continue;
		                }
	
		                menu = ths.eq(i).data("kendoColumnMenu");
		                if (menu) {
		                    menu.destroy();
		                }
	
		                sortable = false;
		                if (column.sortable !== false && columnMenu.sortable !== false && options.sortable !== false) {
		                    sortable = extend({}, options.sortable, { compare: (column.sortable || {}).compare });
		                }
	
		                filterable = false;
		                if (options.filterable && column.filterable !== false && columnMenu.filterable !== false) {
		                    filterable = extend({ pane: this.pane }, column.filterable, options.filterable);
		                }
	
		                menuOptions = {
		                    dataSource: this.dataSource,
		                    values: column.values,
		                    columns: columnMenu.columns,
		                    sortable: sortable,
		                    filterable: filterable,
		                    messages: columnMenu.messages,
		                    owner: this,
		                    closeCallback: $.noop,
		                    init: initHandler,
		                    open: openHandler,
		                    pane: this.pane,
		                    lockedColumns: !hasMultiColumnHeaders && column.lockable !== false && lockedColumnsLength > 0
		                };
	
		                if (options.$angular) {
		                    menuOptions.$angular = options.$angular;
		                }
	
		                ths.eq(i).kendoColumnMenu(menuOptions);
		            }
		        },
	
		        _columnMenuInit: function(e) {
		            this.trigger(COLUMNMENUINIT, { field: e.field, container: e.container });
		        },
	
		        _pageable: function() {
		            var that = this,
		                wrapper,
		                pageable = that.options.pageable;
	
		            if (pageable) {
		                wrapper = that.wrapper.children("div.k-grid-pager");
	
		                if (!wrapper.length) {
		                    wrapper = $('<div class="k-pager-wrap k-grid-pager"/>').appendTo(that.wrapper);
		                }
	
		                that._destroyPager();
	
		                if (typeof pageable === "object" && pageable instanceof kendo.ui.TreeListPager) {
		                    that.pager = pageable;
		                } else if (that.dataSource && !that.dataSource.options.serverPaging) {
		                    that._createPager(wrapper);
		                }
	
		                if (that.pager) {
		                    that.pager.bind(PAGE_CHANGE, function(e) {
		                        if (that.trigger(PAGE, { page: e.index })) {
		                            e.preventDefault();
		                        }
		                    });
		                }
		            }
		        },
	
		        _createPager: function(element, options) {
		            var that = this;
	
		            that.pager = new TreeListPager(element, extend({}, that.options.pageable, { dataSource: that.dataSource }, options));
		        },
	
		        _destroyPager: function() {
		            if (this.pager) {
		                this.pager.destroy();
		            }
		        },
	
		        _isPageable: function() {
		            var that = this;
		            return that.options.pageable && (!that.dataSource || (that.dataSource && that.dataSource._isPageable()));
		        },
	
		        _togglePagerVisibility: function() {
		            var that = this;
		            var pageable = that.options.pageable;
	
		            if (pageable && (isPlainObject(pageable) || pageable instanceof TreeListPager) && pageable.alwaysVisible === false) {
		                that.wrapper.find(".k-grid-pager").toggle((that.dataSource.collapsedTotal() || 0) >= that.dataSource.pageSize());
		            }
		        }
		    });
	
		    function isInputElement(element) {
		       return $(element).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,.k-input,.k-multiselect-wrap,.k-tool-icon");
		    }
	
		    function isLocked(column) {
		        if (!column.parentColumn) {
		            return !!column.locked;
		        }
		        return !!isLocked(column.parentColumn);
		    }
	
		    function findParentColumnWithChildren(columns, index, source, rtl) {
		        var target;
		        var locked = !!source.locked;
		        var targetLocked;
	
		        do {
		            target = columns[index];
		            index += rtl ? 1 : -1;
		            targetLocked = !!target.locked;
		        } while(target && index > -1 && index < columns.length && target != source && !target.columns && targetLocked === locked);
	
		        return target;
		    }
	
		    function findReorderTarget(columns, target, source, before, masterColumns) {
		        if (target.columns) {
		            target = target.columns;
		            return target[before ? 0 : target.length - 1];
		        } else {
		            var parent = columnParent(target, columns);
		            var parentColumns;
	
		            if (parent) {
		                parentColumns = parent.columns;
		            } else {
		                parentColumns = columns;
		            }
	
		            var index = inArray(target, parentColumns);
		            if (index === 0 && before && parentColumns.length !== 1) {
		                index++;
		            } else if (index == parentColumns.length - 1 && !before && index !== 0) {
		                index--;
		            } else if (index > 0 || (index === 0 && !before && index !== 0)) {
		                index += before ? -1 : 1;
		            }
	
		            var sourceIndex = inArray(source, parentColumns);
		            target = findParentColumnWithChildren(parentColumns, index, source, sourceIndex > index);
		            var targetIndex = inArray(target, masterColumns);
		            if (target.columns && (!targetIndex || targetIndex === parentColumns.length -1)) {
		                return null;
		            }
	
		            if (target && target != source && target.columns) {
		                return findReorderTarget(columns, target, source, before, masterColumns);
		            }
		        }
		        return null;
		    }
	
		    function leafColumns(columns) {
		        var result = [];
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (!columns[idx].columns) {
		                result.push(columns[idx]);
		                continue;
		            }
		            result = result.concat(leafColumns(columns[idx].columns));
		        }
	
		        return result;
		    }
	
		    function visibleChildColumns(columns) {
		        return grep(columns, function(column) {
		            return !column.hidden;
		        });
		    }
	
		    function isVisible(column) {
		        return visibleColumns([column]).length > 0;
		    }
	
		    function visibleColumns(columns) {
		        return grep(columns, function(column) {
		            var result = !column.hidden;
		            if (result && column.columns) {
		                result = visibleColumns(column.columns).length > 0;
		            }
		            return result;
		        });
		    }
	
		    function normalizeColumns(columns, hide) {
		        return map(columns, function(column) {
		            var hidden;
	
		            if (!isVisible(column) || hide) {
		                hidden = true;
		            }
	
		            if (column.columns) {
		                column.columns = normalizeColumns(column.columns, hidden);
		            }
		            return extend({ hidden: hidden }, column);
		        });
		    }
	
		    function flatColumnsInDomOrder(columns) {
		        var result = flatColumns(lockedColumns(columns));
		        return result.concat(flatColumns(nonLockedColumns(columns)));
		    }
	
		    function targetParentContainerIndex(flatColumns, columns, sourceIndex, targetIndex) {
		        var column = flatColumns[sourceIndex];
		        var target = flatColumns[targetIndex];
	
		        var parent = columnParent(column, columns);
		        columns = parent ? parent.columns : columns;
	
		        return inArray(target, columns);
		    }
	
		    function parentColumnsCells(cell) {
		        var container = cell.closest("table");
		        var result = $().add(cell);
	
		        var row = cell.closest("tr");
		        var headerRows = container.find("tr");
		        var level = headerRows.index(row);
		        if (level > 0) {
		            var parent = headerRows.eq(level - 1);
		            var parentCellsWithChildren = parent.find("th").filter(function() {
		                return !$(this).attr("rowspan");
		            });
	
		            var offset = 0;
		            var index = row.find("th").index(cell);
	
		            var prevCells = cell.prevAll().filter(function() {
		                return this.colSpan > 1;
		            });
	
		            for (var idx = 0; idx < prevCells.length; idx++) {
		                offset += prevCells[idx].colSpan || 1;
		            }
	
		            index += Math.max(offset - 1, 0);
	
		            offset = 0;
		            for (idx = 0; idx < parentCellsWithChildren.length; idx++) {
		                var parentCell = parentCellsWithChildren.eq(idx);
		                if (parentCell.attr("data-colspan")) {
		                    offset += parentCell[0].getAttribute("data-colspan");
		                } else {
		                    offset += 1;
		                }
		                if (index >= idx && index < offset) {
		                    result = parentColumnsCells(parentCell).add(result);
		                    break;
		                }
		            }
		        }
		        return result;
		    }
	
		    function childColumnsCells(cell) {
		        var container = cell.closest("thead");
		        var result = $().add(cell);
	
		        var row = cell.closest("tr");
		        var headerRows = container.find("tr");
		        var level = headerRows.index(row) + cell[0].rowSpan;
		        var colSpanAttr = kendo.attr("colspan");
	
		        if (level <= headerRows.length - 1) {
		            var child = row.next();
		            var prevCells = cell.prevAll();
	
		            var idx;
	
		            prevCells = prevCells.filter(function() {
		                return !this.rowSpan || this.rowSpan === 1;
		            });
	
		            var offset = 0;
	
		            for (idx = 0; idx < prevCells.length; idx++) {
		                offset += parseInt(prevCells.eq(idx).attr(colSpanAttr), 10) || 1;
		            }
	
		            var cells = child.find("th");
		            var colSpan = parseInt(cell.attr(colSpanAttr), 10) || 1;
	
		            idx = 0;
	
		            while (idx < colSpan) {
		                child = cells.eq(idx + offset);
		                result = result.add(childColumnsCells(child));
		                var value = parseInt(child.attr(colSpanAttr), 10);
		                if (value > 1) {
		                    colSpan -= value - 1;
		                }
		                idx++;
		            }
		        }
	
		        return result;
		    }
	
		    function columnParent(column, columns) {
		        var parents = [];
		        columnParents(column, columns, parents);
		        return parents[parents.length - 1];
		    }
	
		    function columnParents(column, columns, parents) {
		        parents = parents || [];
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (column === columns[idx]) {
		                return true;
		            } else if (columns[idx].columns) {
		                var inserted = parents.length;
		                parents.push(columns[idx]);
		                if (!columnParents(column, columns[idx].columns, parents)) {
		                    parents.splice(inserted, parents.length - inserted);
		                } else {
		                    return true;
		                }
		            }
		        }
		        return false;
		    }
	
		    function flatColumns(columns) {
		        var result = [];
		        var children = [];
		        for (var idx = 0; idx < columns.length; idx++) {
		            result.push(columns[idx]);
		            if (columns[idx].columns) {
		                children = children.concat(columns[idx].columns);
		            }
	
		        }
		        if (children.length) {
		            result = result.concat(flatColumns(children));
		        }
		        return result;
		    }
	
		    function columnPosition(column, columns, row, cellCounts) {
		        var result;
		        var idx;
	
		        row = row || 0;
		        cellCounts = cellCounts || {};
		        cellCounts[row] = cellCounts[row] || 0;
	
		        for (idx = 0; idx < columns.length; idx++) {
		           if (columns[idx] == column) {
		                result = { cell: cellCounts[row], row: row };
		                break;
		           } else if (columns[idx].columns) {
		               result = columnPosition(column, columns[idx].columns, row + 1, cellCounts);
		               if (result) {
		                    break;
		               }
		           }
	
		           cellCounts[row]++;
		        }
		        return result;
		    }
	
		    function updateCellIndex(thead, columns, offset) {
		        offset = offset || 0;
	
		        var position;
		        var cell;
		        var allColumns = columns;
		        columns = leafColumns(columns);
	
		        var cells = {};
		        var rows = thead.find(">tr:not(.k-filter-row)");
	
		        var filter = function() {
		            var el = $(this);
		            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
		        };
	
		        for (var idx = 0, length = columns.length; idx < length; idx++) {
		            position = columnPosition(columns[idx], allColumns);
	
		            if (!cells[position.row]) {
		                cells[position.row] = rows.eq(position.row)
		                    .find(".k-header")
		                    .filter(filter);
		            }
	
		            cell = cells[position.row].eq(position.cell);
		            cell.attr(kendo.attr("index"), offset + idx);
		        }
	
		        return columns.length;
		    }
	
		    function depth(columns) {
		        var result = 1;
		        var max = 0;
	
		        for (var idx = 0; idx < columns.length; idx++) {
		            if (columns[idx].columns) {
		                var temp = depth(columns[idx].columns);
		                if (temp > max) {
		                    max = temp;
		                }
		            }
		        }
		        return result + max;
		    }
	
		    function lockedColumns(columns) {
		        return grep(columns, is("locked"));
		    }
	
		    function nonLockedColumns(columns) {
		        return grep(columns, not(is("locked")));
		    }
	
		    function updateRowSpans(container, containerDOMtree) {
		        var rows = container.find("tr");
		        var length = rows.length;
	
		        rows.each(function (idx) {
		            var cells = this.cells;
		            for (var i = 0; i < cells.length; i++) {
		                if (cells[i].colSpan <= 1 && cells[i].attributes.rowspan) {
		                    containerDOMtree.children[idx].children[i].attr.rowSpan = length - idx;
		                    cells[i].rowSpan = length - idx;
		                }
		            }
		        });
		    }
	
		    function removeEmptyRows(container, containerDOMtree) {
		        var rows = container.find("tr");
		        var emptyRows = [];
	
		        rows.filter(function(idx) {
		            var shouldRemove = !$(this).children().length;
		            if (shouldRemove) {
		                emptyRows.push(idx);
	
		            }
		            return shouldRemove;
		        }).remove();
	
		        for (var i = emptyRows.length - 1; i >= 0; i--) {
		            containerDOMtree.children.splice(emptyRows[i], 1);
		        }
	
		        updateRowSpans(container, containerDOMtree);
		    }
	
		    function focusTable(table, direct) {
		      var msie = browser.msie || browser.edge;
		      if (direct === true) {
		         table = $(table);
		         var scrollTop, scrollLeft;
		         scrollTop = table.parent().scrollTop();
		         scrollLeft = table.parent().scrollLeft();
	
		         if (msie) {
		            try {
		               //The setActive method does not cause the document to scroll to the active object in the current page
		               table[0].setActive();
		            } catch(e) {
		               table[0].focus();
		            }
		         } else {
		            table[0].focus(); //because preventDefault bellow, IE cannot focus the table alternative is unselectable=on
		         }
	
		         table.parent().scrollTop(scrollTop).scrollLeft(scrollLeft);
	
		      } else {
		         $(table).one("focusin", function(e) { e.preventDefault(); }).focus();
		      }
		    }
	
		    function adjustRowHeight(row1, row2) {
		       var height;
		       var offsetHeight1 = row1.offsetHeight;
		       var offsetHeight2 = row2.offsetHeight;
	
		       if (offsetHeight1 > offsetHeight2) {
		           height = offsetHeight1 + "px";
		       } else if (offsetHeight1 < offsetHeight2) {
		           height = offsetHeight2 + "px";
		       }
	
		       if (height) {
		           row1.style.height = row2.style.height = height;
		       }
		    }
	
		    function isColumnEditable(column, model) {
		        if (!column || !model || !column.field || column.selectable || column.command || (column.editable && !column.editable(model))) {
		            return false;
		        }
	
		        return (column.field && model.editable && model.editable(column.field));
		    }
	
		    function isDirtyColumn(column, model) {
		        var field = (column || {}).field || "";
		        return (model.dirty && model.dirtyFields && model.dirtyFields[field] && isColumnEditable(column, model));
		    }
	
		    function isUndefined(value) {
		        return typeof(value) === "undefined";
		    }
	
		    function isNumber(value) {
		        return typeof value === "number" && !isNaN(value);
		    }
	
		    if (kendo.ExcelMixin) {
		        kendo.ExcelMixin.extend(TreeList.prototype);
		    }
	
		    if (kendo.PDFMixin) {
		        kendo.PDFMixin.extend(TreeList.prototype);
	
		       TreeList.prototype._drawPDF = function(progress) {
		           var treeList = this;
	
		           if (treeList.options.pdf.paperSize && treeList.options.pdf.paperSize != "auto") {
		               return treeList._drawPDF_autoPageBreak(progress);
		           }
	
		           var result = new $.Deferred();
		           var dataSource = treeList.dataSource;
		           var allPages = treeList.options.pdf.allPages;
	
		           this._initPDFProgress(progress);
	
		           // This group will be our document containing all pages
		           var doc = new kendo.drawing.Group();
		           var startingPage = dataSource.page();
	
		           function resolve() {
		               if (allPages && startingPage !== undefined) {
		                   dataSource.unbind("change", exportPage);
		                   dataSource.one("change", function() {
		                       result.resolve(doc);
		                   });
	
		                   dataSource.page(startingPage);
		               } else {
		                   result.resolve(doc);
		               }
		           }
	
		           function exportPage() {
		                treeList._drawPDFShadow({
		                    width: treeList.wrapper.width()
		                }, {
		                    avoidLinks: treeList.options.pdf.avoidLinks
		                })
		                .done(function(group) {
		                    var pageNum = dataSource.page();
		                    var totalPages = allPages ? dataSource.totalPages() : 1;
	
		                    var args = {
		                        page: group,
		                        pageNumber: pageNum,
		                        progress: pageNum / totalPages,
		                        totalPages: totalPages
		                    };
	
		                    progress.notify(args);
		                    doc.append(args.page);
	
		                    if (pageNum < totalPages) {
		                        dataSource.page(pageNum + 1);
		                    } else {
		                        resolve();
		                    }
		                })
		                .fail(function(err) {
		                    result.reject(err);
		                });
		            }
	
		            if (allPages) {
		                dataSource.bind("change", exportPage);
		                dataSource.page(1);
		            } else {
		                exportPage();
		            }
	
		            return result.promise();
		        };
	
		        TreeList.prototype._initPDFProgress = function(deferred) {
		            var loading = $("<div class='k-loading-pdf-mask'><div class='k-loading-color'/></div>");
		            loading.prepend(this.wrapper.clone().css({
		                position: "absolute", top: 0, left: 0
		            }));
	
		            this.wrapper.append(loading);
	
		            var progressBar = $("<div class='k-loading-pdf-progress'>")
		                .appendTo(loading)
		                .kendoProgressBar({
		                    type: "chunk",
		                    chunkCount: 10,
		                    min: 0,
		                    max: 1,
		                    value: 0
		                }).data("kendoProgressBar");
	
		            deferred.progress(function(e) {
		                progressBar.value(e.progress);
		            })
		            .always(function() {
		                kendo.destroy(loading);
		                loading.remove();
		            });
		        };
	
		        TreeList.prototype._drawPDF_autoPageBreak = function(progress) {
		            var treeList = this;
		            var result = new $.Deferred();
		            var dataSource = treeList.dataSource;
		            var allPages = treeList.options.pdf.allPages;
		            var origBody = treeList.wrapper.find('table[role="treeList"] > tbody');
		            var cont = $("<div>")
		                .css({ position: "absolute", left: -10000, top: -10000 });
		            var clone = treeList.wrapper.clone().css({
		                height: "auto", width: "auto"
		            }).appendTo(cont);
		            clone.find(".k-grid-content").css({ height: "auto", width: "auto", overflow: "visible" });
		            clone.find('table[role="treeList"], .k-grid-footer table').css({ height: "auto", width: "100%", overflow: "visible" });
		            clone.find(".k-grid-pager, .k-grid-toolbar, .k-grouping-header").remove();
		            clone.find(".k-grid-header, .k-grid-footer").css({ paddingRight: 0 });
	
		            this._initPDFProgress(progress);
	
		            var body = clone.find('table[role="treeList"] > tbody').empty();
		            var startingPage = dataSource.page();
	
		            function resolve() {
		                if (allPages && startingPage !== undefined) {
		                    dataSource.one("change", draw);
		                    dataSource.page(startingPage);
		                } else {
		                    treeList.refresh();
		                    draw();
		                }
		            }
	
		            function draw() {
		                cont.appendTo(document.body);
		                var options = $.extend({}, treeList.options.pdf, {
		                    _destructive: true,
		                    progress: function(p) {
		                        progress.notify({
		                            page: p.page,
		                            pageNumber: p.pageNum,
		                            progress: 0.5 + p.pageNum / p.totalPages / 2,
		                            totalPages: p.totalPages
		                        });
		                    }
		                });
		                kendo.drawing.drawDOM(clone, options)
		                    .always(function(){
		                        cont.remove();
		                    })
		                    .then(function(group){
		                        result.resolve(group);
		                    })
		                    .fail(function(err){
		                        result.reject(err);
		                    });
		            }
	
		            function renderPage() {
		                var pageNum = dataSource.page();
		                var totalPages = allPages ? dataSource.totalPages() : 1;
		                body.append(origBody.find("tr"));
		                if (pageNum < totalPages) {
		                    dataSource.page(pageNum + 1);
		                } else {
		                    dataSource.unbind("change", renderPage);
		                    resolve();
		                }
		            }
	
		            if (allPages) {
		                dataSource.bind("change", renderPage);
		                dataSource.page(1);
		            } else {
		                renderPage();
		            }
	
		            return result.promise();
		        };
		    }
	
		    extend(true, kendo.data, {
		        TreeListDataSource: TreeListDataSource,
		        TreeListModel: TreeListModel
		    });
	
		    ui.plugin(TreeList);
		    ui.plugin(TreeListPager);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1338:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(575);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1292);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1142:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(663);
	
	/***/ }),
	
	/***/ 1189:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(610);
	
	/***/ }),
	
	/***/ 1205:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(629);
	
	/***/ }),
	
	/***/ 1206:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(633);
	
	/***/ }),
	
	/***/ 1292:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1142),
		        __webpack_require__(1294),
		        __webpack_require__(1295),
		        __webpack_require__(1205),
		        __webpack_require__(1206),
		        __webpack_require__(1189),
		        __webpack_require__(1296),
		        __webpack_require__(1297),
		        __webpack_require__(1298),
		        __webpack_require__(1299),
		        __webpack_require__(1300),
		        __webpack_require__(1301),
		        __webpack_require__(1302),
		        __webpack_require__(1303),
		        __webpack_require__(1304),
		        __webpack_require__(1305),
		        __webpack_require__(1306),
		        __webpack_require__(1307),
		        __webpack_require__(1308),
		        __webpack_require__(1309),
		        __webpack_require__(1310),
		        __webpack_require__(1293),
		        __webpack_require__(1311),
		        __webpack_require__(1312),
		        __webpack_require__(1313),
		        __webpack_require__(1314),
		        __webpack_require__(1315),
		        __webpack_require__(1316),
		        __webpack_require__(1317),
		        __webpack_require__(1318),
		        __webpack_require__(1319),
		        __webpack_require__(1320),
		        __webpack_require__(1321),
		        __webpack_require__(1322),
		        __webpack_require__(1323),
		        __webpack_require__(1324),
		        __webpack_require__(1325),
		        __webpack_require__(1326),
		        __webpack_require__(1327),
		        __webpack_require__(1328),
		        __webpack_require__(1329),
		        __webpack_require__(1330)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    var __meta__ = { // jshint ignore:line
		        id: "spreadsheet",
		        name: "Spreadsheet",
		        category: "web",
		        description: "Spreadsheet component",
		        depends: [
		            "core", "binder", "colorpicker", "combobox", "data", "dom", "dropdownlist",
		            "menu", "ooxml", "popup", "sortable", "tabstrip", "toolbar", "treeview",
		            "window", "validator", "excel", "pdf", "drawing" ]
		    };
	
		    (function(kendo, undefined) {
		        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		            return;
		        }
	
		        var $ = kendo.jQuery;
		        var keys = $.extend({F10: 121, F11: 122, B: 66, I: 73, U: 85, N: 78, H: 72, A: 65, PAGEDOWN: 34, PAGEUP: 33, DELETE: 46, R: 82}, kendo.keys);
		        var Widget = kendo.ui.Widget;
		        var Workbook = kendo.spreadsheet.Workbook;
		        var Controller = kendo.spreadsheet.Controller;
		        var View = kendo.spreadsheet.View;
		        var NS = ".kendoSpreadsheet";
	
		        var ALL_REASONS = {
		            recalc: true,
		            selection: true,
		            activeCell: true,
		            layout: true,
		            sheetSelection: true,
		            resize: true,
		            editorChange: false,
		            editorClose: false
		        };
	
		        var classNames = {
		            wrapper: "k-widget k-spreadsheet"
		        };
	
		        var Spreadsheet = kendo.ui.Widget.extend({
		            init: function(element, options) {
		                Widget.fn.init.call(this, element, options);
	
		                this.element.addClass(Spreadsheet.classNames.wrapper);
	
		                this._view = new View(this.element, {
		                    messages: this.options.messages.view,
		                    toolbar: this.options.toolbar,
		                    sheetsbar:this.options.sheetsbar
		                });
	
		                this._workbook = new Workbook(this.options, this._view);
	
		                this._controller = new Controller(this._view, this._workbook);
	
		                this._autoRefresh = true;
	
		                this._bindWorkbookEvents();
	
		                this._view.workbook(this._workbook);
	
		                this._view.enableClipboard(false);
		                this.refresh();
		                this._view.enableClipboard(true);
	
		                this._resizeHandler = function() { this.resize(); }.bind(this);
		                $(window).on("resize" + NS, this._resizeHandler);
	
		                this.element.on("keydown" + NS, this._keyDown.bind(this));
		            },
	
		            _keyDown: function(e) {
		                var key = e.keyCode;
		                var redoTool = $(".k-spreadsheet-quick-access-toolbar [title=Redo]");
		                if (key === keys.F11 && e.shiftKey) {
		                    this._view.sheetsbar._onAddSelect();
		                    e.preventDefault();
		                    return;
		                } else if (e.altKey && key === keys.PAGEDOWN) {
		                    this._view.sheetsbar.trigger("select", {
		                                    name: this._view.sheetsbar._sheets[this._view.sheetsbar._selectedIndex + 1].name(),
		                                    isAddButton: false
		                    });
		                } else if (e.altKey && key === keys.PAGEUP) {
		                    this._view.sheetsbar.trigger("select", {
		                                    name: this._view.sheetsbar._sheets[this._view.sheetsbar._selectedIndex - 1].name(),
		                                    isAddButton: false
		                    });
		                } else if (e.altKey && key === keys.DELETE) {
		                    var closeCallback = function(e) {
		                        var dlg = e.sender;
	
		                        if (dlg.isConfirmed()) {
		                            this._view.sheetsbar.trigger("remove", { name: this.activeSheet()._name(), confirmation: true });
		                        }
		                    }.bind(this);
	
		                    this._view.sheetsbar._openDialog("confirmation", {
		                        close: closeCallback
		                    });
		                    e.preventDefault();
		                    return;
		                } else if (e.altKey && key === keys.R) {
		                    this._view.sheetsbar._createEditor();
		                    e.preventDefault();
		                    return;
		                } else if (key === keys.F10 && this._view.tabstrip || (key === keys.TAB && !e.shiftKey && $(document.activeElement).is(redoTool))) {
		                    this._view.tabstrip.toolbars[this._view.tabstrip.element.find("li.k-state-active").text().toLowerCase()].element.find(":not(.k-overflow-anchor):kendoFocusable:first").focus();
		                    this._view.tabstrip.toolbars[this._view.tabstrip.element.find("li.k-state-active").text().toLowerCase()].element.find(".k-toolbar-first-visible").addClass("k-state-focused");
		                    e.preventDefault();
		                    return;
		                } else if (e.ctrlKey && key === keys.B) {
		                    $("[data-tool=bold]")[0].click();
		                } else if (e.ctrlKey && key === keys.I) {
		                    $("[data-tool=italic]")[0].click();
		                } else if (e.ctrlKey && key === keys.U) {
		                    $("[data-tool=underline]")[0].click();
		                } else if (e.altKey && key === keys.H) {
		                    this._view.tabstrip.select(0);
		                    e.preventDefault();
		                    return;
		                } else if (e.altKey && key === keys.N) {
		                    this._view.tabstrip.select(1);
		                    e.preventDefault();
		                    return;
	
		                } else if (e.altKey && key === keys.A) {
		                    this._view.tabstrip.select(2);
		                    e.preventDefault();
		                    return;
	
		                }
		            },
	
		            _resize: function() {
		                this.refresh({ layout: true });
		            },
	
		            _workbookChange: function(e) {
		                if (this._autoRefresh) {
		                    this.refresh(e);
		                }
	
		                if (e.recalc && e.ref) {
		                    var range = e.range || new kendo.spreadsheet.Range(e.ref, this.activeSheet());
		                    this.trigger("change", { range: range });
		                }
		            },
	
		            _workbookCut: function(e) {
		                this.trigger("cut", e);
		            },
	
		            _workbookCopy: function(e) {
		                this.trigger("copy", e);
		            },
	
		            _workbookPaste: function(e) {
		                this.trigger("paste", e);
		            },
	
		            activeSheet: function(sheet) {
		                return this._workbook.activeSheet(sheet);
		            },
	
		            moveSheetToIndex: function (sheet, index) {
		                return this._workbook.moveSheetToIndex(sheet, index);
		            },
	
		            insertSheet: function(options) {
		                return this._workbook.insertSheet(options);
		            },
	
		            sheets: function() {
		                return this._workbook.sheets();
		            },
	
		            removeSheet: function(sheet) {
		                return this._workbook.removeSheet(sheet);
		            },
	
		            sheetByName: function(sheetName) {
		                return this._workbook.sheetByName(sheetName);
		            },
	
		            sheetIndex: function(sheet) {
		                return this._workbook.sheetIndex(sheet);
		            },
	
		            sheetByIndex: function(index) {
		                return this._workbook.sheetByIndex(index);
		            },
	
		            renameSheet: function(sheet, newSheetName) {
		                return this._workbook.renameSheet(sheet, newSheetName);
		            },
	
		            refresh: function(reason) {
		                if (!reason) {
		                    reason = ALL_REASONS;
		                }
	
		                if (!reason.editorClose) {
		                    this._view.sheet(this._workbook.activeSheet());
		                    this._controller.sheet(this._workbook.activeSheet());
	
		                    this._workbook.refresh(reason);
		                }
	
		                if (!reason.editorChange) {
		                    this._view.refresh(reason);
		                    this._controller.refresh();
	
		                    this._view.render();
		                    this.trigger("render");
		                }
	
		                return this;
		            },
	
		            openDialog: function(name, options) {
		                return this._view.openDialog(name, options);
		            },
	
		            autoRefresh: function(value) {
		                if (value !== undefined) {
		                    this._autoRefresh = value;
	
		                    if (value === true) {
		                        this.refresh();
		                    }
	
		                    return this;
		                }
	
		                return this._autoRefresh;
		            },
	
		            toJSON: function() {
		                return this._workbook.toJSON();
		            },
	
		            fromJSON: function(json) {
		                if (json.sheets) {
		                    this._workbook.destroy();
	
		                    this._workbook = new Workbook($.extend({}, this.options, json));
	
		                    this._bindWorkbookEvents();
	
		                    this._view.workbook(this._workbook);
		                    this._controller.workbook(this._workbook);
	
		                    this.activeSheet(this.activeSheet());
		                } else {
		                    this.refresh();
		                }
		            },
	
		            fromFile: function(blob, name) {
		                return this._workbook.fromFile(blob, name);
		            },
	
		            saveAsPDF: function(options) {
		                this._workbook.saveAsPDF(
		                    $.extend({}, this.options.pdf, options, { workbook: this._workbook })
		                );
		            },
	
		            saveAsExcel: function(options) {
		                this._workbook.saveAsExcel(options);
		            },
	
		            draw: function(options, callback) {
		                this._workbook.draw(options, callback);
		            },
	
		            _workbookExcelExport: function(e) {
		                if (this.trigger("excelExport", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookExcelImport: function(e) {
		                if (this.trigger("excelImport", e)) {
		                    e.preventDefault();
		                } else {
		                    this._initProgress(e.promise);
		                }
		            },
	
		            _initProgress: function(deferred) {
		                var loading =
		                    $("<div class='k-loading-mask' " +
		                           "style='width: 100%; height: 100%; top: 0;'>" +
		                        "<div class='k-loading-color'/>" +
		                    "</div>")
		                    .appendTo(this.element);
	
		                var pb = $("<div class='k-loading-progress'>")
		                .appendTo(loading)
		                .kendoProgressBar({
		                    type: "chunk", chunkCount: 10,
		                    min: 0, max: 1, value: 0
		                }).data("kendoProgressBar");
	
		                deferred.progress(function(e) {
		                    pb.value(e.progress);
		                })
		                .always(function() {
		                    kendo.destroy(loading);
		                    loading.remove();
		                });
		            },
	
		            _workbookPdfExport: function(e) {
		                if (this.trigger("pdfExport", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookInsertSheet: function(e) {
		                if (this.trigger("insertSheet", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookRemoveSheet: function(e) {
		                if (this.trigger("removeSheet", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookSelectSheet: function(e) {
		                if (this.trigger("selectSheet", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookRenameSheet: function(e) {
		                if (this.trigger("renameSheet", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookInsertRow: function(e) {
		                if (this.trigger("insertRow", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookInsertColumn: function(e) {
		                if (this.trigger("insertColumn", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookDeleteRow: function(e) {
		                if (this.trigger("deleteRow", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookDeleteColumn: function(e) {
		                if (this.trigger("deleteColumn", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookHideRow: function(e) {
		                if (this.trigger("hideRow", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookHideColumn: function(e) {
		                if (this.trigger("hideColumn", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookUnhideRow: function(e) {
		                if (this.trigger("unhideRow", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookUnhideColumn: function(e) {
		                if (this.trigger("unhideColumn", e)) {
		                    e.preventDefault();
		                }
		            },
	
		            _workbookSelect: function(e) {
		                this.trigger("select", e);
		            },
	
		            _workbookChangeFormat: function(e) {
		               this.trigger("changeFormat", e);
		            },
	
		            _bindWorkbookEvents: function() {
		                this._workbook.bind("cut", this._workbookCut.bind(this));
		                this._workbook.bind("copy", this._workbookCopy.bind(this));
		                this._workbook.bind("paste", this._workbookPaste.bind(this));
		                this._workbook.bind("change", this._workbookChange.bind(this));
		                this._workbook.bind("excelExport", this._workbookExcelExport.bind(this));
		                this._workbook.bind("excelImport", this._workbookExcelImport.bind(this));
		                this._workbook.bind("pdfExport", this._workbookPdfExport.bind(this));
		                this._workbook.bind("insertSheet", this._workbookInsertSheet.bind(this));
		                this._workbook.bind("removeSheet", this._workbookRemoveSheet.bind(this));
		                this._workbook.bind("selectSheet", this._workbookSelectSheet.bind(this));
		                this._workbook.bind("renameSheet", this._workbookRenameSheet.bind(this));
		                this._workbook.bind("insertRow", this._workbookInsertRow.bind(this));
		                this._workbook.bind("insertColumn", this._workbookInsertColumn.bind(this));
		                this._workbook.bind("deleteRow", this._workbookDeleteRow.bind(this));
		                this._workbook.bind("deleteColumn", this._workbookDeleteColumn.bind(this));
		                this._workbook.bind("hideRow", this._workbookHideRow.bind(this));
		                this._workbook.bind("hideColumn", this._workbookHideColumn.bind(this));
		                this._workbook.bind("unhideRow", this._workbookUnhideRow.bind(this));
		                this._workbook.bind("unhideColumn", this._workbookUnhideColumn.bind(this));
		                this._workbook.bind("select", this._workbookSelect.bind(this));
		                this._workbook.bind("changeFormat", this._workbookChangeFormat.bind(this));
		            },
	
		            destroy: function() {
		                kendo.ui.Widget.fn.destroy.call(this);
	
		                this._workbook.destroy();
		                this._controller.destroy();
		                this._view.destroy();
	
		                if (this._resizeHandler) {
		                    $(window).off("resize" + NS, this._resizeHandler);
		                }
		            },
	
		            options: {
		                name: "Spreadsheet",
		                toolbar: true,
		                sheetsbar: true,
		                rows: 200,
		                columns: 50,
		                rowHeight: 20,
		                columnWidth: 64,
		                headerHeight: 20,
		                headerWidth: 32,
		                excel: {
		                    proxyURL: "",
		                    fileName: "Workbook.xlsx"
		                },
		                messages: {},
		                pdf: {
		                    // which part of the workbook to be exported
		                    area      : "workbook",
		                    fileName  : "Workbook.pdf",
		                    proxyURL  : "",
		                    // paperSize can be an usual name, i.e. "A4", or an array of two Number-s specifying the
		                    // width/height in points (1pt = 1/72in), or strings including unit, i.e. "10mm".  Supported
		                    // units are "mm", "cm", "in" and "pt".  The default "auto" means paper size is determined
		                    // by content.
		                    paperSize : "a4",
		                    // True to reverse the paper dimensions if needed such that width is the larger edge.
		                    landscape : true,
		                    // An object containing { left, top, bottom, right } margins with units.
		                    margin    : null,
		                    // Optional information for the PDF Info dictionary; all strings except for the date.
		                    title     : null,
		                    author    : null,
		                    subject   : null,
		                    keywords  : null,
		                    creator   : "Kendo UI PDF Generator v." + kendo.version,
		                    // Creation Date; defaults to new Date()
		                    date      : null
		                },
		                defaultCellStyle: {
		                    fontFamily: "Arial",
		                    fontSize: "12"
		                }
		            },
	
		            defineName: function(name, value, hidden) {
		                return this._workbook.defineName(name, value, hidden);
		            },
	
		            undefineName: function(name) {
		                return this._workbook.undefineName(name);
		            },
	
		            nameValue: function(name) {
		                return this._workbook.nameValue(name);
		            },
	
		            forEachName: function(func) {
		                return this._workbook.forEachName(func);
		            },
	
		            cellContextMenu: function() {
		                return this._view.cellContextMenu;
		            },
	
		            rowHeaderContextMenu: function() {
		                return this._view.rowHeaderContextMenu;
		            },
	
		            colHeaderContextMenu: function() {
		                return this._view.colHeaderContextMenu;
		            },
	
		            events: [
		                "cut",
		                "copy",
		                "paste",
		                "pdfExport",
		                "excelExport",
		                "excelImport",
		                "change",
		                "render",
		                "removeSheet",
		                "selectSheet",
		                "renameSheet",
		                "insertRow",
		                "insertColumn",
		                "deleteRow",
		                "insertSheet",
		                "deleteColumn",
		                "hideRow",
		                "hideColumn",
		                "unhideRow",
		                "unhideColumn",
		                "select",
		                "changeFormat"
		            ]
		        });
	
		        kendo.spreadsheet.ALL_REASONS = ALL_REASONS;
		        kendo.ui.plugin(Spreadsheet);
		        $.extend(true, Spreadsheet, { classNames: classNames });
		    })(window.kendo);
	
		    return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1293:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(699);
	
	/***/ }),
	
	/***/ 1294:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(555);
	
	/***/ }),
	
	/***/ 1295:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(700);
	
	/***/ }),
	
	/***/ 1296:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(702);
	
	/***/ }),
	
	/***/ 1297:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(703);
	
	/***/ }),
	
	/***/ 1298:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(704);
	
	/***/ }),
	
	/***/ 1299:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(705);
	
	/***/ }),
	
	/***/ 1300:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(706);
	
	/***/ }),
	
	/***/ 1301:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(707);
	
	/***/ }),
	
	/***/ 1302:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(708);
	
	/***/ }),
	
	/***/ 1303:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(709);
	
	/***/ }),
	
	/***/ 1304:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(711);
	
	/***/ }),
	
	/***/ 1305:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(712);
	
	/***/ }),
	
	/***/ 1306:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(713);
	
	/***/ }),
	
	/***/ 1307:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(714);
	
	/***/ }),
	
	/***/ 1308:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(717);
	
	/***/ }),
	
	/***/ 1309:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(718);
	
	/***/ }),
	
	/***/ 1310:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(720);
	
	/***/ }),
	
	/***/ 1311:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(721);
	
	/***/ }),
	
	/***/ 1312:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(722);
	
	/***/ }),
	
	/***/ 1313:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(723);
	
	/***/ }),
	
	/***/ 1314:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(724);
	
	/***/ }),
	
	/***/ 1315:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(725);
	
	/***/ }),
	
	/***/ 1316:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(726);
	
	/***/ }),
	
	/***/ 1317:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(727);
	
	/***/ }),
	
	/***/ 1318:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ }),
	
	/***/ 1319:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(719);
	
	/***/ }),
	
	/***/ 1320:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(728);
	
	/***/ }),
	
	/***/ 1321:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(729);
	
	/***/ }),
	
	/***/ 1322:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(730);
	
	/***/ }),
	
	/***/ 1323:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(731);
	
	/***/ }),
	
	/***/ 1324:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(733);
	
	/***/ }),
	
	/***/ 1325:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(734);
	
	/***/ }),
	
	/***/ 1326:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(735);
	
	/***/ }),
	
	/***/ 1327:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(736);
	
	/***/ }),
	
	/***/ 1328:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(737);
	
	/***/ }),
	
	/***/ 1329:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(738);
	
	/***/ }),
	
	/***/ 1330:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(739);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1478);
		module.exports = __webpack_require__(1478);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1478:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    /* jshint eqnull:true */
	
		    var spreadsheet = kendo.spreadsheet;
		    var CellRef = spreadsheet.CellRef;
		    var RangeRef = spreadsheet.RangeRef;
		    var UnionRef = spreadsheet.UnionRef;
		    var NameRef = spreadsheet.NameRef;
		    var Ref = spreadsheet.Ref;
	
		    var FormulaContext = kendo.Class.extend({
		        init: function (workbook) {
		            this.workbook = workbook;
		        },
	
		        getRefCells: function(ref, hiddenInfo, fsheet, frow, fcol, wantNulls) {
		            var sheet, formula, value, i;
		            if (ref instanceof CellRef) {
		                sheet = this.workbook.sheetByName(ref.sheet);
		                if (!sheet || !ref.valid()) {
		                    return [{
		                        value: new kendo.spreadsheet.calc.runtime.CalcError("REF")
		                    }];
		                }
		                formula = sheet.formula(ref);
		                value = sheet.range(ref.row, ref.col).value();
	
		                if (wantNulls || formula != null || value != null) {
		                    return [{
		                        formula: formula,
		                        value: value,
		                        row: ref.row,
		                        col: ref.col,
		                        sheet: ref.sheet,
		                        hidden: hiddenInfo ? (sheet.columnWidth(ref.col) === 0 || sheet.rowHeight(ref.row) === 0) : false
		                    }];
		                } else {
		                    return [];
		                }
		            }
		            if (ref instanceof RangeRef) {
		                i = this.workbook.sheetIndex(ref.sheet);
		                var states = [], n = i;
		                if (ref.endSheet) {
		                    // "3D" reference.
		                    n = this.workbook.sheetIndex(ref.endSheet);
		                    if (i > n) {
		                        var tmp = i;
		                        i = n;
		                        n = tmp;
		                    }
		                }
	
		                if (i < 0 || n < 0 || !ref.valid()) {
		                    return [{
		                        value: new kendo.spreadsheet.calc.runtime.CalcError("REF")
		                    }];
		                }
	
		                // XXX: This is nicer, but significantly slower.
		                // Should investigate why, or add some options to make
		                // it faster (i.e. probably because it adds all cell
		                // properties, while we only need value and formula).
		                //
		                //     var add = function(row, col, data){
		                //         data.row = row;
		                //         data.col = col;
		                //         data.sheet = sheet.name();
		                //         states.push(data);
		                //     };
		                //     while (i <= n) {
		                //         sheet = this.workbook.sheetByIndex(i++);
		                //         sheet.forEach(ref, add);
		                //     }
		                //
		                // For now keep doing it "manually".
	
		                while (i <= n) {
		                    sheet = this.workbook.sheetByIndex(i++);
		                    var tl = sheet._grid.normalize(ref.topLeft);
		                    var br = sheet._grid.normalize(ref.bottomRight);
	
		                    var startCellIndex = sheet._grid.cellRefIndex(tl);
		                    var endCellIndex = sheet._grid.cellRefIndex(br);
	
		                    var values = sheet._properties.iterator("value", startCellIndex, endCellIndex);
	
		                    for (var col = tl.col; col <= br.col; ++col) {
		                        for (var row = tl.row; row <= br.row; ++row) {
		                            var index = sheet._grid.index(row, col);
		                            formula = sheet._properties.get("formula", index);
		                            value = values.at(index);
		                            if (wantNulls || formula != null || value != null) {
		                                states.push({
		                                    formula : formula,
		                                    value   : value,
		                                    row     : row,
		                                    col     : col,
		                                    sheet   : sheet.name(),
		                                    hidden  : hiddenInfo ? (sheet.columnWidth(col) === 0 || sheet.rowHeight(row) === 0) : false
		                                });
		                            }
		                        }
		                    }
		                }
	
		                return states;
		            }
		            if (ref instanceof UnionRef) {
		                var a = [];
		                for (i = 0; i < ref.refs.length; ++i) {
		                    a = a.concat(this.getRefCells(ref.refs[i], hiddenInfo, fsheet, frow, fcol));
		                }
		                return a;
		            }
		            if (ref instanceof NameRef) {
		                var val = this.nameValue(ref, fsheet, frow, fcol);
		                // XXX: revise this
		                if (val instanceof Ref) {
		                    return this.getRefCells(val, hiddenInfo, fsheet, frow, fcol);
		                }
		                return [{
		                    value: val == null ? new kendo.spreadsheet.calc.runtime.CalcError("NAME") : val
		                }];
		            }
		            return [];
		        },
	
		        nameValue: function(ref, fsheet, frow, fcol) {
		            var val;
		            if (ref.hasSheet()) {
		                // qualified name
		                val = this.workbook.nameValue(ref.print());
		            } else {
		                // try local name
		                ref = ref.clone().setSheet(fsheet, true);
		                val = this.workbook.nameValue(ref.print());
		                if (val == null) {
		                    // try global name
		                    val = this.workbook.nameValue(ref.name);
		                }
		            }
		            if (val instanceof Ref) {
		                val = val.absolute(frow, fcol);
		            }
		            return val;
		        },
	
		        getData: function(ref, fsheet, frow, fcol, wantNulls) {
		            var single = ref instanceof CellRef;
		            if (ref instanceof NameRef) {
		                single = this.workbook.nameValue(ref.name) instanceof CellRef;
		            }
		            var data = this.getRefCells(ref, false, fsheet, frow, fcol, wantNulls).map(function(cell){
		                var val = cell.value;
		                if (val instanceof kendo.spreadsheet.calc.runtime.Formula) {
		                    val = val.value;
		                }
		                return val;
		            });
		            return single ? data[0] : data;
		        },
	
		        onFormula: function(f) {
		            var sheet = this.workbook.sheetByName(f.sheet);
		            var row = f.row, col = f.col, value = f.value;
		            var currentFormula = sheet.formula({ row: row, col: col });
		            if (currentFormula !== f) {
		                // could have been deleted or modified in the mean time,
		                // if the formula was asynchronous.  ignore this result.
		                return false;
		            }
	
		            var arrayRange = f.arrayFormulaRange;
		            if (arrayRange) {
		                // `value` will always be a Matrix in this case;
		                // enforced in runtime.js (Context::_resolve).  We
		                // must fill only cells in arrayRange.
		                var tlRow, tlCol;
		                var width = value.width;
		                var height = value.height;
		                sheet.forEach(arrayRange, function(row, col){
		                    if (tlRow === undefined) {
		                        tlRow = row;
		                        tlCol = col;
		                    }
		                    var vrow = row - tlRow;
		                    var vcol = col - tlCol;
		                    var val;
		                    if (vrow < height && vcol < width) {
		                        val = value.get(vrow, vcol);
		                    } else {
		                        val = new kendo.spreadsheet.calc.runtime.CalcError("N/A");
		                    }
		                    sheet._value(row, col, val);
		                });
		            }
		            else {
		                // formulas may return references.  if a range or union,
		                // we'll just save the first cell.
		                if (value instanceof Ref) {
		                    value = this.getData(value, f.sheet, row, col);
		                    if (Array.isArray(value)) {
		                        value = value[0];
		                    }
		                    if (value === undefined) {
		                        value = null; // clear contents
		                    }
		                }
	
		                // when not saved as an array formula, a formula
		                // returning a Matrix will just save the first value.
		                if (value instanceof kendo.spreadsheet.calc.runtime.Matrix) {
		                    value = value.get(0, 0);
		                }
	
		                sheet._value(row, col, value);
		            }
	
		            clearTimeout(sheet._formulaContextRefresh);
		            sheet._formulaContextRefresh = setTimeout(function(){
		                sheet.batch(function(){}, { layout: true });
		            }, 50);
	
		            return true;
		        }
		    });
	
		    var ValidationFormulaContext = FormulaContext.extend({
		        onFormula: function() {
		            return true;
		        }
		    });
	
		    spreadsheet.FormulaContext = FormulaContext;
		    spreadsheet.ValidationFormulaContext = ValidationFormulaContext;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1514);
		module.exports = __webpack_require__(1514);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 937:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(701);
	
	/***/ }),
	
	/***/ 1514:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(937) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    // SAX-style XML parser ====================================================
		    var STRING = String.fromCharCode;
	
		    // XXX: add more here?
		    var ENTITIES = {
		        "amp"  : 38,
		        "lt"   : 60,
		        "gt"   : 62,
		        "quot" : 34,
		        "apos" : 39,
		        "nbsp" : 160
		    };
	
		    function CODE(str) {
		        var out = [];
		        for (var i = 0; i < str.length; ++i) {
		            out.push(str.charCodeAt(i));
		        }
		        return out;
		    }
	
		    function UCS2(out, code) {
		        if (code > 0xFFFF) {
		            code -= 0x10000;
		            out.push(code >>> 10 & 0x3FF | 0xD800,
		                     0xDC00 | code & 0x3FF);
		        } else {
		            out.push(code);
		        }
		    }
	
		    var START_CDATA     = CODE("<![CDATA[");
		    var END_CDATA       = CODE("]]>");
		    var END_COMMENT     = CODE("-->");
		    var START_COMMENT   = CODE("!--");
		    var END_SHORT_TAG   = CODE("/>");
		    var END_TAG         = CODE("</");
		    var END_DECLARATION = CODE("?>");
		    var QUESTION_MARK   = CODE("?");
		    var LESS_THAN       = CODE("<");
		    var GREATER_THAN    = CODE(">");
		    var SEMICOLON       = CODE(";");
		    var EQUAL           = CODE("=");
		    var AMPERSAND       = CODE("&");
		    var QUOTE           = CODE('"');
		    var APOSTROPHE      = CODE("'");
		    var SHARP           = CODE("#");
		    var LOWERCASE_X     = CODE("x");
		    var UPPERCASE_X     = CODE("X");
	
		    var EXIT = {};
	
		    function parse(data, callbacks) {
		        var index = 0;
		        var stack = [];
		        var object = {
		            is: function(selector) {
		                var i = stack.length, j = selector.length;
		                while (--i >= 0 && --j >= 0) {
		                    if (stack[i].$tag != selector[j] && selector[j] != "*") {
		                        return false;
		                    }
		                }
		                return j < 0 ? stack[stack.length - 1] : null;
		            },
		            exit: function() {
		                throw EXIT;
		            },
		            stack: stack
		        };
	
		        function readChar(body) {
		            var code = data[index++];
		            if (!(code & 0xF0 ^ 0xF0)) {// 4 bytes
		                UCS2(body,
		                     ((code & 0x03) << 18) |
		                     ((data[index++] & 0x3F) << 12) |
		                     ((data[index++] & 0x3F) << 6) |
		                     (data[index++] & 0x3F));
		            } else if (!(code & 0xE0 ^ 0xE0)) {// 3 bytes
		                UCS2(body,
		                     ((code & 0x0F) << 12) |
		                     ((data[index++] & 0x3F) << 6) |
		                     (data[index++] & 0x3F));
		            } else if (!(code & 0xC0 ^ 0xC0)) {// 2 bytes
		                UCS2(body,
		                     ((code & 0x1F) << 6) |
		                     (data[index++] & 0x3F));
		            } else {
		                body.push(code);
		            }
		        }
	
		        function croak(msg) {
		            throw new Error(msg + ", at " + index);
		        }
	
		        function readWhile(pred) {
		            var a = [];
		            while (index < data.length && pred(data[index])) {
		                a.push(data[index++]);
		            }
		            return a;
		        }
	
		        function readAsciiWhile(pred) {
		            return STRING.apply(0, readWhile(pred));
		        }
	
		        function skipWhitespace() {
		            readWhile(isWhitespace);
		        }
	
		        function eat(a) {
		            var save = index;
		            for (var i = 0; i < a.length; ++i) {
		                if (data[index++] != a[i]) {
		                    index = save;
		                    return false;
		                }
		            }
		            return a;
		        }
	
		        function skip(code) {
		            if (!eat(code)) {
		                croak("Expecting " + code.join(", "));
		            }
		        }
	
		        function isWhitespace(code) {
		            return code == 9 || code == 10 || code == 13 || code == 32;
		        }
	
		        function isDigit(code) {
		            return code >= 48 && code <= 57;
		        }
	
		        function isHexDigit(code) {
		            return (code >= 48 && code <= 57) ||
		                   ((code|=32) >= 97 && code <= 102); // a..f or A..F
		        }
	
		        function isNameStart(code) {
		            return code == 58 ||                      // :
		                   code == 95 ||                      // _
		                   ((code|=32) >= 97 && code <= 122); // a..z or A..Z
		        }
	
		        function isName(code) {
		            return code == 45 ||                      // -
		                   isDigit(code) ||
		                   isNameStart(code);
		        }
	
		        function xmlComment() {
		            var body = [];
		            while (index < data.length) {
		                if (eat(END_COMMENT)) {
		                    return call("comment", STRING.apply(0, body));
		                }
		                readChar(body);
		            }
		        }
	
		        function xmlTag() {
		            var name, attrs;
		            if (eat(QUESTION_MARK)) {
		                xmlDecl();
		            } else if (eat(START_COMMENT)) {
		                xmlComment();
		            } else {
		                name = xmlName();
		                attrs = xmlAttrs(name);
		                stack.push(attrs);
		                if (eat(END_SHORT_TAG)) {
		                    call("enter", name, attrs, true);
		                } else {
		                    skip(GREATER_THAN);
		                    call("enter", name, attrs);
		                    xmlContent(name);
		                    if (name != xmlName()) {
		                        croak("Bad closing tag");
		                    }
		                    call("leave", name, attrs);
		                    skipWhitespace();
		                    skip(GREATER_THAN);
		                }
		                stack.pop();
		            }
		        }
	
		        function xmlContent(name) {
		            var body = [];
		            while (index < data.length) {
		                if (eat(END_TAG)) {
		                    return body.length && call("text", STRING.apply(0, body));
		                } else if (eat(START_CDATA)) {
		                    while (index < data.length && !eat(END_CDATA)) {
		                        readChar(body);
		                    }
		                } else if (eat(LESS_THAN)) {
		                    if (body.length) {
		                        call("text", STRING.apply(0, body));
		                    }
		                    xmlTag();
		                    body = [];
		                } else if (eat(AMPERSAND)) {
		                    xmlEntity(body);
		                } else {
		                    readChar(body);
		                }
		            }
		            croak("Unclosed tag " + name);
		        }
	
		        function xmlName() {
		            if (!isNameStart(data[index])) {
		                croak("Expecting XML name");
		            }
		            return readAsciiWhile(isName);
		        }
	
		        function xmlString() {
		            var quote = eat(QUOTE) || eat(APOSTROPHE);
		            if (!quote) {
		                croak("Expecting string");
		            }
		            var body = [];
		            while (index < data.length) {
		                if (eat(quote)) {
		                    return STRING.apply(0, body);
		                } else if (eat(AMPERSAND)) {
		                    xmlEntity(body);
		                } else {
		                    readChar(body);
		                }
		            }
		            croak("Unfinished string");
		        }
	
		        function xmlEntity(body) {
		            var code;
		            if (eat(SHARP)) {
		                if (eat(LOWERCASE_X) || eat(UPPERCASE_X)) {
		                    code = parseInt(readAsciiWhile(isHexDigit), 16);
		                } else {
		                    code = parseInt(readAsciiWhile(isDigit), 10);
		                }
		                if (isNaN(code)) {
		                    croak("Bad numeric entity");
		                }
		            } else {
		                var name = xmlName();
		                code = ENTITIES[name];
		                if (code === undefined) {
		                    croak("Unknown entity " + name);
		                }
		            }
		            UCS2(body, code);
		            skip(SEMICOLON);
		        }
	
		        function xmlDecl() {
		            call("decl", xmlName(), xmlAttrs());
		            skip(END_DECLARATION);
		        }
	
		        function xmlAttrs(name) {
		            var map = { $tag: name };
		            while (index < data.length) {
		                skipWhitespace();
		                var code = data[index];
		                if (code == 63 || code == 62 || code == 47) { // ?, > or /
		                    break;
		                }
		                map[xmlName()] = ( skip(EQUAL), xmlString() );
		            }
		            return map;
		        }
	
		        function call(what, thing, arg1, arg2) {
		            var f = callbacks && callbacks[what];
		            if (f) {
		                f.call(object, thing, arg1, arg2);
		            }
		        }
	
		        // skip BOM
		        var tmp = [];
		        readChar(tmp);
		        if (tmp[0] != 65279) {
		            index = 0;
		        }
	
		        while (index < data.length) {
		            skipWhitespace();
		            skip(LESS_THAN);
		            xmlTag();
		            skipWhitespace();
		        }
		    }
	
		    // Exports ================================================================
		    kendo.util.parseXML = function parseXML() {
		        try {
		            return parse.apply(this, arguments);
		        } catch(ex) {
		            if (ex !== EXIT) {
		                throw ex;
		            }
		        }
		    };
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1513);
		module.exports = __webpack_require__(1513);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1513:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(19)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function () {
		    // Imports ================================================================
		    var kendo = window.kendo,
		        deepExtend = kendo.deepExtend;
	
		    function sqr(value) {
		        return value * value;
		    }
	
		    var now = Date.now;
		    if (!now) {
		        now = function() {
		            return new Date().getTime();
		        };
		    }
	
		    // Template helpers =======================================================
	
		    function renderSize(size) {
		        if (typeof size !== "string") {
		            size += "px";
		        }
	
		        return size;
		    }
	
		    function renderPos(pos) {
		        var result = [];
	
		        if (pos) {
		            var parts = kendo.toHyphens(pos).split("-");
	
		            for (var i = 0; i < parts.length; i++) {
		                result.push("k-pos-" + parts[i]);
		            }
		        }
	
		        return result.join(" ");
		    }
	
		    function arabicToRoman(n) {
		        var literals = {
		            1    : "i",       10   : "x",       100  : "c",
		            2    : "ii",      20   : "xx",      200  : "cc",
		            3    : "iii",     30   : "xxx",     300  : "ccc",
		            4    : "iv",      40   : "xl",      400  : "cd",
		            5    : "v",       50   : "l",       500  : "d",
		            6    : "vi",      60   : "lx",      600  : "dc",
		            7    : "vii",     70   : "lxx",     700  : "dcc",
		            8    : "viii",    80   : "lxxx",    800  : "dccc",
		            9    : "ix",      90   : "xc",      900  : "cm",
		            1000 : "m"
		        };
		        var values = [ 1000,
		                       900 , 800, 700, 600, 500, 400, 300, 200, 100,
		                       90  , 80 , 70 , 60 , 50 , 40 , 30 , 20 , 10 ,
		                       9   , 8  , 7  , 6  , 5  , 4  , 3  , 2  , 1 ];
		        var roman = "";
		        while (n > 0) {
		            if (n < values[0]) {
		                values.shift();
		            } else {
		                roman += literals[values[0]];
		                n -= values[0];
		            }
		        }
		        return roman;
		    }
	
		    function romanToArabic(r) {
		        r = r.toLowerCase();
		        var digits = {
		            i: 1,
		            v: 5,
		            x: 10,
		            l: 50,
		            c: 100,
		            d: 500,
		            m: 1000
		        };
		        var value = 0, prev = 0;
		        for (var i = 0; i < r.length; ++i) {
		            var v = digits[r.charAt(i)];
		            if (!v) {
		                return null;
		            }
		            value += v;
		            if (v > prev) {
		                value -= 2 * prev;
		            }
		            prev = v;
		        }
		        return value;
		    }
	
		    function memoize(f) {
		        var cache = Object.create(null);
		        return function() {
		            var id = "";
		            for (var i = arguments.length; --i >= 0;) {
		                id += ":" + arguments[i];
		            }
		            return id in cache ? cache[id] : (cache[id] = f.apply(this, arguments));
		        };
		    }
	
		    function isUnicodeLetter(ch) {
		        return RX_UNICODE_LETTER.test(ch);
		    }
	
		    function withExit(f, obj) {
		        try {
		            return f.call(obj, function(value){
		                throw new Return(value);
		            });
		        } catch(ex) {
		            if (ex instanceof Return) {
		                return ex.value;
		            }
		            throw ex;
		        }
		        function Return(value) {
		            this.value = value;
		        }
		    }
	
		    // Exports ================================================================
		    deepExtend(kendo, {
		        util: {
		            now: now,
		            renderPos: renderPos,
		            renderSize: renderSize,
		            sqr: sqr,
		            romanToArabic: romanToArabic,
		            arabicToRoman: arabicToRoman,
		            memoize: memoize,
		            isUnicodeLetter: isUnicodeLetter,
		            withExit: withExit
		        }
		    });
	
		    var RX_UNICODE_LETTER = new RegExp("[\\u0041-\\u005A\\u0061-\\u007A\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]");
	
		})();
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1457);
		module.exports = __webpack_require__(1457);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 943:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 1457:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(19),
		        __webpack_require__(1458),
		        __webpack_require__(943),
		        __webpack_require__(1459),
		        __webpack_require__(1460)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
	
		    var Command = kendo.spreadsheet.Command = kendo.Class.extend({
		        init: function(options) {
		            this.options = options;
		            this._workbook = options.workbook;
		            this._property = options && options.property;
		            this._state = {};
		        },
		        range: function(range) {
		            if (range !== undefined) {
		                this._setRange(range);
		            }
	
		            return this._range;
		        },
		        _setRange: function(range) {
		            this._range = range;
		        },
		        redo: function() {
		            this.range().select();
		            this.exec();
		        },
		        undo: function() {
		            this.setState(this._state);
		        },
		        getState: function() {
		            this._state = this.range().getState(this._property);
		        },
		        setState: function(state) {
		            this.range().setState(state);
		        },
		        _forEachCell: function(callback) {
		            var range = this.range();
		            var ref = range._ref;
	
		            ref.forEach(function(ref) {
		                range.sheet().forEach(ref.toRangeRef(), callback.bind(this));
		            }.bind(this));
		        }
		    });
	
		    var TargetValueCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._target = options.target;
		            this._value = options.value;
		        },
		        exec: function() {
		            this.getState();
		            this.setState(this._value);
		        }
		    });
	
		    kendo.spreadsheet.ColumnWidthCommand = TargetValueCommand.extend({
		        getState: function() {
		            this._state = this.range().sheet().columnWidth(this._target);
		        },
		        setState: function(state) {
		            this.range().sheet().columnWidth(this._target, state);
		        }
		    });
	
		    kendo.spreadsheet.RowHeightCommand = TargetValueCommand.extend({
		        getState: function() {
		            this._state = this.range().sheet().rowHeight(this._target);
		        },
		        setState: function(state) {
		            this.range().sheet().rowHeight(this._target, state);
		        }
		    });
	
		    kendo.spreadsheet.HyperlinkCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._link = options.link;
		        },
		        exec: function() {
		            var range = this.range();
		            this._prevLink = range.link();
		            this._prevUnderline = range.underline();
		            range.link(this._link);
		            range.underline(true);
		            if (range.value() == null) { // jshint ignore:line
		                this._hasSetValue = true;
		                range.value(this._link);
		            }
		        },
		        undo: function() {
		            var range = this.range();
		            range.link(this._prevLink);
		            range.underline(this._prevUnderline);
		            if (this._hasSetValue) {
		                range.value(null);
		            }
		        }
		    });
	
		    kendo.spreadsheet.GridLinesChangeCommand = TargetValueCommand.extend({
		        getState: function() {
		            this._state = this._range.sheet().showGridLines();
		        },
		        setState: function(v) {
		            this._range.sheet().showGridLines(v);
		        }
		    });
	
		    var PropertyChangeCommand = kendo.spreadsheet.PropertyChangeCommand = Command.extend({
		        _setRange: function(range) {
		            Command.prototype._setRange.call(this, range.skipHiddenCells());
		        },
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._value = options.value;
		        },
		        exec: function() {
		            var range = this.range();
		            if (range.enable()) {
		                this.getState();
	
		                if (this.options.property === "format") {
		                    this._workbook.trigger("changeFormat", { range: range });
		                }
	
		                range[this._property](this._value);
		            }
		        }
		    });
	
		    kendo.spreadsheet.ClearContentCommand = Command.extend({
		        exec: function() {
		            if (!this.range().enable()) {
		                return { reason: "error", type: "cannotModifyDisabled" };
		            }
		            if (!this.range().canEditArrayFormula()) {
		                return { reason: "error", type: "intersectsArray" };
		            }
		            this.getState();
		            this.range().skipHiddenCells().clearContent();
		        }
		    });
	
		    kendo.spreadsheet.EditCommand = PropertyChangeCommand.extend({
		        init: function(options) {
		            options.property = options.property || "input";
		            PropertyChangeCommand.fn.init.call(this, options);
		        },
		        rejectState: function(validationState) {
		            this.undo();
	
		            return {
		                title: validationState.title,
		                body: validationState.message,
		                reason: "error",
		                type: "validationError"
		            };
		        },
		        _setRange: function(range) {
		            PropertyChangeCommand.prototype._setRange.apply(this, arguments);
		            this._editRange = this.options.arrayFormula ? range : range.sheet().activeCellSelection();
		        },
		        getState: function() {
		            this._state = this.range().getState();
		        },
		        exec: function() {
		            var arrayFormula = this.options.arrayFormula;
		            var editRange = this._editRange;
	
		            if (!editRange.enable()) {
		                return { reason: "error", type: "rangeDisabled" };
		            }
	
		            if (!editRange.canEditArrayFormula()) {
		                return { reason: "error", type: "intersectsArray" };
		            }
	
		            var value = this._value;
		            this.getState();
	
		            if (this._property == "value") {
		                editRange.value(value);
		                return;
		            }
	
		            try {
		                editRange.link(null);
		                if (value === "") {
		                    editRange.value(null);
		                } else {
		                    editRange.input(value, { arrayFormula: arrayFormula });
		                    if (/\n/.test(editRange.value())) {
		                        editRange.wrap(true);
		                    }
		                }
		                editRange._adjustRowHeight();
	
		                var validationState = editRange._getValidationState();
		                if (validationState) {
		                    return this.rejectState(validationState);
		                }
		            } catch(ex) {
		                if (ex instanceof kendo.spreadsheet.calc.ParseError) {
		                    return {
		                        title : "Error in formula",
		                        body  : ex+"",
		                        reason: "error"
		                    };
		                } else {
		                    throw ex;
		                }
		            }
		        }
		    });
	
		    kendo.spreadsheet.TextWrapCommand = PropertyChangeCommand.extend({
		        init: function(options) {
		            options.property = "wrap";
		            PropertyChangeCommand.fn.init.call(this, options);
	
		            this._value = options.value;
		        },
		        getState: function() {
		            var rowHeight = {};
		            this.range().forEachRow(function(range) {
		                var index = range.topLeft().row;
	
		                rowHeight[index] = range.sheet().rowHeight(index);
		            });
	
		            this._state = this.range().getState(this._property);
		            this._rowHeight = rowHeight;
		        },
		        undo: function() {
		            var sheet = this.range().sheet();
		            var rowHeight = this._rowHeight;
	
		            this.range().setState(this._state);
	
		            for (var row in rowHeight) {
		                sheet.rowHeight(row, rowHeight[row]);
		            }
		        }
		    });
	
		    kendo.spreadsheet.AdjustDecimalsCommand = Command.extend({
		        init: function(options) {
		            this._delta = options.value;
		            options.property = "format";
		            Command.fn.init.call(this, options);
		        },
		        exec: function() {
		            var sheet = this.range().sheet();
		            var delta = this._delta;
		            var formatting = kendo.spreadsheet.formatting;
	
		            this.getState();
	
		            sheet.batch(function() {
		                this.range().forEachCell(function(row, col, cell) {
		                    var format = cell.format;
	
		                    if (!format) {
		                        var value = cell.value;
		                        if (typeof value == "number" && /\./.test(value)) {
		                            format = "0." + String(value).split(".")[1].replace(/\d/g, "0");
		                        }
		                    }
	
		                    if (format || delta > 0) {
		                        format = formatting.adjustDecimals(format || "0", delta);
		                        sheet.range(row, col).format(format);
		                    }
		                });
		            }.bind(this));
		        }
		    });
	
		    kendo.spreadsheet.BorderChangeCommand = Command.extend({
		        init: function(options) {
		            options.property = "border";
		            Command.fn.init.call(this, options);
		            this._type = options.border;
		            this._style = options.style;
		        },
		        _batch: function(f) {
		            return this.range().sheet().batch(f, {});
		        },
		        exec: function() {
		            var self = this;
		            self.getState();
		            self._batch(function(){
		                self[self._type](self._style);
		            });
		        },
		        noBorders: function() {
		            this.range().insideBorders(null);
		            this.outsideBorders(null);
		        },
		        allBorders: function(style) {
		            this.range().insideBorders(style);
		            this.outsideBorders(style);
		        },
		        leftBorder: function(style) {
		            this.range().leftColumn().borderLeft(style);
		        },
		        rightBorder: function(style) {
		            this.range().rightColumn().borderRight(style);
		        },
		        topBorder: function(style) {
		            this.range().topRow().borderTop(style);
		        },
		        bottomBorder: function(style) {
		            this.range().bottomRow().borderBottom(style);
		        },
		        outsideBorders: function(style) {
		            var range = this.range();
		            range.leftColumn().borderLeft(style);
		            range.topRow().borderTop(style);
		            range.rightColumn().borderRight(style);
		            range.bottomRow().borderBottom(style);
		        },
		        insideBorders: function(style) {
		            this.range().insideBorders(style);
		            this.outsideBorders(null);
		        },
		        insideHorizontalBorders: function(style) {
		            this.range().insideHorizontalBorders(style);
		        },
		        insideVerticalBorders: function(style) {
		            this.range().insideVerticalBorders(style);
		        }
		    });
	
		    kendo.spreadsheet.MergeCellCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._type = options.value;
		        },
		        exec: function() {
		            this.getState();
		            this[this._type]();
		        },
		        activate: function(ref) {
		            this.range().sheet().activeCell(ref);
		        },
		        getState: function() {
		            this._state = this.range().getState();
		        },
		        undo: function() {
		            if (this._type !== "unmerge") {
		                this.range().unmerge();
		                this.activate(this.range().topLeft());
		            }
		            this.range().setState(this._state);
		        },
		        cells: function() {
		            var range = this.range();
		            var ref = range._ref;
	
		            range.merge();
		            this.activate(ref);
		        },
		        horizontally: function() {
		            var ref = this.range().topRow()._ref;
	
		            this.range().forEachRow(function(range) {
		                range.merge();
		            });
	
		            this.activate(ref);
		        },
		        vertically: function() {
		            var ref = this.range().leftColumn()._ref;
	
		            this.range().forEachColumn(function(range) {
		                range.merge();
		            });
	
		            this.activate(ref);
		        },
		        unmerge: function() {
		            var range = this.range();
		            var ref = range._ref.topLeft;
	
		            range.unmerge();
		            this.activate(ref);
		        }
		    });
	
		    kendo.spreadsheet.FreezePanesCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._type = options.value;
		        },
		        exec: function() {
		            this.getState();
		            this._topLeft = this.range().topLeft();
		            this[this._type]();
		        },
		        getState: function() {
		            this._state = this.range().sheet().getState();
		        },
		        undo: function() {
		            this.range().sheet().setState(this._state);
		        },
		        panes: function() {
		            var topLeft = this._topLeft;
		            var sheet = this.range().sheet();
	
		            sheet.frozenColumns(topLeft.col).frozenRows(topLeft.row);
		        },
		        rows: function() {
		            var topLeft = this._topLeft;
		            var sheet = this.range().sheet();
	
		            sheet.frozenRows(topLeft.row);
		        },
		        columns: function() {
		            var topLeft = this._topLeft;
		            var sheet = this.range().sheet();
	
		            sheet.frozenColumns(topLeft.col);
		        },
		        unfreeze: function() {
		            var sheet = this.range().sheet();
		            sheet.frozenRows(0).frozenColumns(0);
		        }
		    });
	
		    kendo.spreadsheet.PasteCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._clipboard = options.workbook.clipboard();
		            this._clipboard.parse();
		            this._event = options.event;
		            this._clipboardContent = this._clipboard._content;
		            this._clipboardPasteRef = this._clipboard.pasteRef();
		            this._sheet = this._workbook.activeSheet();
		            this._range = this._sheet.range(this._clipboard.pasteRef());
		            this._state = this._range.getState();
		        },
		        exec: function() {
		            var status = this._clipboard.canPaste();
		            if (!status.canPaste) {
		                if (status.menuInvoked) {
		                    return { reason: "error", type: "useKeyboard" };
		                }
		                if (status.pasteOnMerged) {
		                    return { reason: "error", type: "modifyMerged" };
		                }
		                if (status.overflow) {
		                    return { reason: "error", type: "overflow" };
		                }
		                if (status.pasteOnDisabled) {
		                    this._event.preventDefault();
		                    return { reason: "error", type: "cannotModifyDisabled" };
		                }
		                return { reason: "error" };
		            }
		            var range = this._workbook.activeSheet().selection();
		            var preventDefault = this._workbook.trigger("paste", {range: range});
		            if (preventDefault) {
		                this._event.preventDefault();
		            } else {
		                this._sheet.range(this._clipboardPasteRef).setState(this._clipboardContent, this._clipboard);
		                this._sheet.triggerChange({ recalc: true, ref: this._clipboardPasteRef });
		                range._adjustRowHeight();
		            }
		        }
		    });
	
		    kendo.spreadsheet.AdjustRowHeightCommand = Command.extend({
		        exec: function() {
		            var options = this.options;
		            var sheet = this._workbook.activeSheet();
		            var range = options.range || sheet.range(options.rowIndex);
	
		            range._adjustRowHeight();
		        }
		    });
	
		    kendo.spreadsheet.ToolbarPasteCommand = Command.extend({
		        exec: function() {
		            if (kendo.support.clipboard.paste) {
		                this._workbook._view.clipboard.focus().select();
		                //reason : focusclipbord
		                document.execCommand('paste');
		            } else {
		                return { reason: "error", type: "useKeyboard" };
		            }
		        }
		    });
	
		    kendo.spreadsheet.CutCommand = Command.extend({
		        _eventType: "cut",
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._clipboard = options.workbook.clipboard();
		            this._event = options.event;
		        },
		        exec: function() {
		            var status = this._clipboard.canCopy();
		            if (!status.canCopy) {
		                if (status.menuInvoked) {
		                    return { reason: "error", type: "useKeyboard" };
		                } else if (status.multiSelection) {
		                    return { reason: "error", type: "unsupportedSelection" };
		                }
		                return;
		            }
		            var range = this._workbook.activeSheet().selection();
		            if (this._eventType == "cut") {
		                if (!range.enable()) {
		                    this._event.preventDefault();
		                    return { reason: "error", type: "cannotModifyDisabled" };
		                }
		                this.getState();
		            }
		            var preventDefault = this._workbook.trigger(this._eventType, { range: range });
		            if (preventDefault) {
		                this._event.preventDefault();
		            } else if (this._eventType == "cut") {
		                this._clipboard.cut();
		            } else {
		                this._clipboard.copy();
		            }
		        }
		    });
	
		    kendo.spreadsheet.CopyCommand = kendo.spreadsheet.CutCommand.extend({
		        _eventType: "copy",
		        undo: $.noop
		    });
	
		    function copyToClipboard(html) {
		        var textarea = document.createElement('textarea');
		        $(textarea).addClass("k-spreadsheet-clipboard")
		            .val(html)
		            .appendTo(document.body)
		            .focus()
		            .select();
	
		        document.execCommand('copy');
	
		        $(textarea).remove();
		    }
	
		    kendo.spreadsheet.ToolbarCopyCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._clipboard = options.workbook.clipboard();
		        },
		        undo: $.noop,
		        exec: function() {
		            if (kendo.support.clipboard.copy) {
		                var clipboard = this._workbook._view.clipboard;
		                copyToClipboard(clipboard.html());
		                clipboard.trigger("copy");
		            } else {
		                return { reason: "error", type: "useKeyboard" };
		            }
		        }
		    });
	
		    kendo.spreadsheet.AutoFillCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		        },
		        origin: function(origin) {
		            this._origin = origin;
		        },
		        exec: function() {
		            var range = this.range();
		            if (!range.enable()) {
		                return { reason: "error", type: "rangeDisabled" };
		            }
		            if (range.intersectingArrayFormula()) {
		                return { reason: "error", type: "intersectsArray" };
		            }
		            this.getState();
		            try {
		                range.fillFrom(this._origin);
		            } catch(ex) {
		                if (ex instanceof kendo.spreadsheet.Range.FillError) {
		                    return { reason: "error", type: ex.code };
		                }
		                throw ex;
		            }
		        }
		    });
	
		    kendo.spreadsheet.ToolbarCutCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._clipboard = options.workbook.clipboard();
		        },
		        exec: function() {
		            if (kendo.support.clipboard.copy) {
		                var clipboard = this._workbook._view.clipboard;
		                copyToClipboard(clipboard.html());
		                clipboard.trigger("cut");
		            } else {
		                return { reason: "error", type: "useKeyboard" };
		            }
		        }
		    });
	
		    kendo.spreadsheet.FilterCommand = Command.extend({
		        undo: function() {
		            this.range().filter(this._state);
		        },
		        exec: function() {
		            var range = this.range();
		            this._state = range.hasFilter();
		            range.filter(!this._state);
		        }
		    });
	
		    kendo.spreadsheet.SortCommand = Command.extend({
		        undo: function() {
		            var sheet = this.range().sheet();
		            sheet.setState(this._state);
		        },
		        exec: function() {
		            var range = this.range();
		            var sheet = range.sheet();
		            var activeCell = sheet.activeCell();
		            var col = this.options.sheet ? activeCell.topLeft.col : (this.options.column || 0);
		            var ascending = this.options.value === "asc" ? true : false;
	
		            this._state = sheet.getState();
	
		            if (this.options.sheet) {
		                range = this.expandRange();
		            }
	
		            var reason = range.cantSort();
		            if (reason) {
		                return { reason: "error", type: reason.code };
		            }
	
		            range.sort({ column: col, ascending: ascending });
		        },
		        expandRange: function() {
		            var sheet = this.range().sheet();
		            return new kendo.spreadsheet.Range(sheet._sheetRef, sheet);
		        }
		    });
	
		    var ApplyFilterCommand = kendo.spreadsheet.ApplyFilterCommand = Command.extend({
		        column: function() {
		            return this.options.column || 0;
		        },
		        undo: function() {
		            var sheet = this.range().sheet();
	
		            sheet.clearFilter(this.column());
	
		            if (this._state.length) {
		                this.range().filter(this._state);
		            }
		        },
		        getState: function() {
		            var sheet = this.range().sheet();
		            var current = sheet.filter();
	
		            if (current) {
		                this._state = current.columns.filter(function(c) {
		                    return c.index == this.column();
		                }.bind(this));
		            }
		        },
		        exec: function() {
		            var range = this.range();
		            var column = this.column();
		            var current = range.sheet().filter();
		            var options;
		            var filterRule;
		            var exists = false;
	
		            if (this.options.valueFilter) {
		                filterRule = { column: column, filter: new kendo.spreadsheet.ValueFilter(this.options.valueFilter) };
		            } else if (this.options.customFilter) {
		                filterRule = { column: column, filter: new kendo.spreadsheet.CustomFilter(this.options.customFilter) };
		            }
	
		            this.getState();
	
		            if (current && current.ref.eq(range._ref) && current.columns.length) {
		                current.columns.forEach(function(element) {
		                    if (element.index === column) {
		                        exists = true;
		                    }
		                });
	
		                options = current.columns.map(function(element) {
		                    return element.index === column ? filterRule : { column: element.index, filter: element.filter };
		                });
	
		                if (!exists) {
		                    options.push(filterRule);
		                }
		            } else {
		                options = filterRule;
		            }
	
		            range.filter(options);
		        }
		    });
	
		    kendo.spreadsheet.ClearFilterCommand = ApplyFilterCommand.extend({
		        exec: function() {
		            var range = this.range();
		            var column = this.column();
	
		            this.getState();
		            range.clearFilter(column);
		        }
		    });
	
		    kendo.spreadsheet.HideLineCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this.axis = options.axis;
		        },
	
		        undo: function() {
		            var sheet = this.range().sheet();
		            sheet.setAxisState(this._state);
		        },
	
		        exec: function() {
		            var sheet = this.range().sheet();
		            this._state = sheet.getAxisState();
	
		            if (this.axis == "row") {
		                sheet.axisManager().hideSelectedRows();
		            } else {
		                sheet.axisManager().hideSelectedColumns();
		            }
		        }
		    });
	
		    kendo.spreadsheet.UnHideLineCommand = kendo.spreadsheet.HideLineCommand.extend({
		        exec: function() {
		            var sheet = this.range().sheet();
		            this._state = sheet.getAxisState();
	
		            if (this.axis == "row") {
		                sheet.axisManager().unhideSelectedRows();
		            } else {
		                sheet.axisManager().unhideSelectedColumns();
		            }
		        }
		    });
	
		    var DeleteCommand = Command.extend({
		        exec: function() {
		            this._expandedRange = this._expand(this.range());
		            this._state = this._expandedRange.getState();
		            this._indexes = this._exec(this._expandedRange.sheet());
		        },
		        undo: function() {
		            var self = this;
		            var range = self._expandedRange;
		            var sheet = range.sheet();
		            sheet.batch(function(){
		                self._indexes.forEach(function(x){
		                    self._undoOne(sheet, x);
		                    sheet._restoreModifiedFormulas(x.formulas);
		                });
		                range.setState(self._state);
		            }, { layout: true, recalc: true, ref: range._ref });
		        }
		    });
	
		    kendo.spreadsheet.DeleteRowCommand = DeleteCommand.extend({
		        _expand: function(range) {
		            return range.resize({ left: -Infinity, right: +Infinity });
		        },
		        _exec: function(sheet) {
		            return sheet.axisManager().deleteSelectedRows();
		        },
		        _undoOne: function(sheet, x) {
		            sheet.insertRow(x.index);
		            sheet.rowHeight(x.index, x.height);
		        }
		    });
	
		    kendo.spreadsheet.DeleteColumnCommand = DeleteCommand.extend({
		        _expand: function(range) {
		            return range.resize({ top: -Infinity, bottom: +Infinity });
		        },
		        _exec: function(sheet) {
		            return sheet.axisManager().deleteSelectedColumns();
		        },
		        _undoOne: function(sheet, x) {
		            sheet.insertColumn(x.index);
		            sheet.columnWidth(x.index, x.width);
		        }
		    });
	
		    var AddCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._value = options.value;
		        },
		        undo: function() {
		            var self = this;
		            var sheet = self.range().sheet();
		            sheet.batch(function(){
		                for (var i = self._pos.count; --i >= 0;) {
		                    self._undoOne(sheet, self._pos.base);
		                }
		            }, { layout: true, recalc: true });
		        }
		    });
	
		    kendo.spreadsheet.AddColumnCommand = AddCommand.extend({
		        exec: function() {
		            var sheet = this.range().sheet();
		            var result = sheet.axisManager().preventAddColumn();
	
		            if (result) {
		                return result;
		            }
	
		            if (this._value === "left") {
		                this._pos = sheet.axisManager().addColumnLeft();
		            } else {
		                this._pos = sheet.axisManager().addColumnRight();
		            }
		        },
		        _undoOne: function(sheet, index) {
		            sheet.deleteColumn(index);
		        }
		    });
	
		    kendo.spreadsheet.AddRowCommand = AddCommand.extend({
		        exec: function() {
		            var sheet = this.range().sheet();
		            var result = sheet.axisManager().preventAddRow();
	
		            if (result) {
		                return result;
		            }
	
		            if (this._value === "above") {
		                this._pos = sheet.axisManager().addRowAbove();
		            } else {
		                this._pos = sheet.axisManager().addRowBelow();
		            }
		        },
		        _undoOne: function(sheet, index) {
		            sheet.deleteRow(index);
		        }
		    });
	
		    kendo.spreadsheet.EditValidationCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._value = options.value;
		        },
		        exec: function() {
		            this.range().validation(this._value);
		        }
		    });
	
		    kendo.spreadsheet.OpenCommand = Command.extend({
		        cannotUndo: true,
		        exec: function() {
		            var file = this.options.file;
		            if (file.name.match(/.xlsx$/i) === null) {
		                return { reason: "error", type: "openUnsupported" };
		            }
	
		            var workbook = this.options.workbook;
		            workbook.fromFile(this.options.file).then(function(){
		                var errors = workbook.excelImportErrors;
		                if (errors && errors.length) {
		                    workbook._view.openDialog("importError", {
		                        errors: errors
		                    });
		                }
		            });
		        }
		    });
	
		    kendo.spreadsheet.SaveAsCommand = Command.extend({
		        exec: function() {
		            var fileName = this.options.name + this.options.extension;
		            if (this.options.extension === ".xlsx") {
		                this.options.workbook.saveAsExcel({
		                    fileName: fileName
		                });
		            } else if (this.options.extension === ".pdf") {
		                this.options.workbook.saveAsPDF($.extend(this.options.pdf, {workbook: this.options.workbook, fileName: fileName}));
		            }
		        }
		    });
	
		    var NameCommand = Command.extend({
		        init: function(options) {
		            Command.fn.init.call(this, options);
		            this._name = options.name;
		            this._value = options.value;
		        },
		        getState: function() {
		            this._state = this._workbook.nameDefinition(this._name);
		        },
		        setState: function() {
		            this._workbook.nameDefinition(this._name, this._state);
		            this._workbook.trigger("change", { recalc: true });
		        }
		    });
	
		    kendo.spreadsheet.DefineNameCommand = NameCommand.extend({
		        exec: function() {
		            this.getState();
		            try {
		                this._workbook.defineName(this._name, this._value);
		                this._workbook.trigger("change", { recalc: true });
		            } catch(ex) {
		                return {
		                    title: "Error",
		                    body: ex+"",
		                    reason: "error"
		                };
		            }
		        }
		    });
	
		    kendo.spreadsheet.DeleteNameCommand = NameCommand.extend({
		        exec: function() {
		            this.getState();
		            this._workbook.undefineName(this._name);
		            this._workbook.trigger("change", { recalc: true });
		        }
		    });
	
		})(kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1458:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1459:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(562);
	
	/***/ }),
	
	/***/ 1460:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(601);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1477);
		module.exports = __webpack_require__(1477);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1477:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
	
		    var classNames = {
		        wrapper: "k-spreadsheet-formula-bar"
		    };
	
		    var FormulaBar = kendo.ui.Widget.extend({
		        init: function(element, options) {
		            kendo.ui.Widget.call(this, element, options);
	
		            element = this.element.addClass(FormulaBar.classNames.wrapper);
	
		            this.formulaInput = new kendo.spreadsheet.FormulaInput($("<div/>").appendTo(element));
		        },
	
		        destroy: function() {
		            if (this.formulaInput) {
		                this.formulaInput.destroy();
		            }
		            this.formulaInput = null;
		        }
		    });
	
		    kendo.spreadsheet.FormulaBar = FormulaBar;
		    $.extend(true, FormulaBar, { classNames: classNames });
		})(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1479);
		module.exports = __webpack_require__(1479);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1479:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo, window) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    /* jshint eqnull:true */
		    /* jshint latedef: nofunc */
	
		    var $ = kendo.jQuery;
		    var Widget = kendo.ui.Widget;
		    var ns = ".kendoFormulaInput";
		    var keys = kendo.keys;
		    var classNames = {
		        wrapper: "k-spreadsheet-formula-input",
		        listWrapper: "k-spreadsheet-formula-list"
		    };
		    var styles = [
		        "font-family",
		        "font-size",
		        "font-stretch",
		        "font-style",
		        "font-weight",
		        "letter-spacing",
		        "text-transform",
		        "line-height"
		    ];
	
		    //move to core
		    var KEY_NAMES = {
		        27: 'esc',
		        37: 'left',
		        39: 'right',
		        35: 'end',
		        36: 'home',
		        32: 'spacebar'
		    };
	
		    var PRIVATE_FORMULA_CHECK = /(^_|[^a-z0-9]$)/i;
	
		    var FormulaInput = Widget.extend({
		        init: function(element, options) {
		            Widget.call(this, element, options);
	
		            element = this.element;
	
		            element.addClass(FormulaInput.classNames.wrapper)
		                .attr("contenteditable", true)
		                .attr("spellcheck", false)
		                .css("white-space", "pre");
	
		            if (this.options.autoScale) {
		                element.on("input", this.scale.bind(this));
		            }
	
		            this._highlightedRefs = [];
		            this._staticTokens = [];
	
		            this._formulaSource();
	
		            this._formulaList();
	
		            this._popup();
	
		            this._tooltip();
	
		            element
		                .on("keydown", this._keydown.bind(this))
		                .on("keyup", this._keyup.bind(this))
		                .on("blur", this._blur.bind(this))
		                .on("input click", this._input.bind(this))
		                .on("focus", this._focus.bind(this))
		                .on("paste", this._paste.bind(this));
		        },
	
		        options: {
		            name: "FormulaInput",
		            autoScale: false,
		            filterOperator: "startswith",
		            scalePadding: 30,
		            minLength: 1
		        },
	
		        events: [
		            "keyup",
		            "focus"
		        ],
	
		        enable: function(enable) {
		            if (enable === undefined) {
		                return this.element.attr("contenteditable") === "true";
		            }
	
		            if (enable) {
		                this.element.attr("contenteditable", enable);
		            } else {
		                this.element.removeAttr("contenteditable");
		            }
	
		            this.element.toggleClass("k-state-disabled", !enable);
		        },
	
		        getPos: function() {
		            var div = this.element[0];
		            var sel = window.getSelection();
		            var a = lookup(sel.focusNode, sel.focusOffset);
		            var b = lookup(sel.anchorNode, sel.anchorOffset);
		            if (a != null && b != null) {
		                if (a > b) {
		                    var tmp = a;
		                    a = b;
		                    b = tmp;
		                }
		                return { begin: a, end: b, collapsed: a == b };
		            }
		            function lookup(lookupNode, pos) {
		                try {
		                    (function loop(node){
		                        if (node === lookupNode) {
		                            throw pos;
		                        } else if (node.nodeType == 1 /* Element */) {
		                            for (var i = node.firstChild; i; i = i.nextSibling) {
		                                loop(i);
		                            }
		                        } else if (node.nodeType == 3 /* Text */) {
		                            pos += node.nodeValue.length;
		                        }
		                    })(div);
		                } catch(index) {
		                    return index;
		                }
		            }
		        },
	
		        setPos: function(begin, end) {
		            var eiv = this.element[0];
		            begin = lookup(eiv, begin);
		            if (end != null) {
		                end = lookup(eiv, end);
		            } else {
		                end = begin;
		            }
		            if (begin && end) {
		                var range = document.createRange();
		                range.setStart(begin.node, begin.pos);
		                range.setEnd(end.node, end.pos);
		                var sel = window.getSelection();
		                var currentRange = sel.getRangeAt(0);
		                if (differ(range, currentRange))  {
		                    sel.removeAllRanges();
		                    sel.addRange(range);
		                }
		            }
		            function differ(a, b) {
		                return (
		                    a.startOffset != b.startOffset ||
		                    a.endOffset != b.endOffset ||
		                    a.startContainer != b.endContainer ||
		                    a.endContainer != b.endContainer
		                );
		            }
		            function lookup(node, pos) {
		                try {
		                    (function loop(node){
		                        if (node.nodeType == 3 /* Text */) {
		                            var len = node.nodeValue.length;
		                            if (len >= pos) {
		                                throw node;
		                            }
		                            pos -= len;
		                        } else if (node.nodeType == 1 /* Element */) {
		                            for (var i = node.firstChild; i; i = i.nextSibling) {
		                                loop(i);
		                            }
		                        }
		                    })(node);
		                } catch(el) {
		                    return { node: el, pos: pos };
		                }
		            }
		        },
	
		        end: function() {
		            this.setPos(this.length());
		        },
	
		        home: function() {
		            this.setPos(0);
		        },
	
		        select: function() {
		            this.setPos(0, this.length());
		        },
	
		        length: function() {
		            return this.value().length;
		        },
	
		        _formulaSource: function() {
		            var result = [];
		            var value;
	
		            for (var key in kendo.spreadsheet.calc.runtime.FUNCS) {
		                if (!PRIVATE_FORMULA_CHECK.test(key)) {
		                    value = key.toUpperCase();
		                    result.push({ value: value, text: value });
		                }
		            }
	
		            this.formulaSource = new kendo.data.DataSource({ data: result });
		        },
	
		        _formulaList: function() {
		            this.list = new kendo.ui.StaticList($('<ul />')
		                .addClass(FormulaInput.classNames.listWrapper)
		                .insertAfter(this.element), {
		                    autoBind: false,
		                    selectable: true,
		                    change: this._formulaListChange.bind(this),
		                    dataSource: this.formulaSource,
		                    dataValueField: "value",
		                    template: "#:data.value#"
		                });
	
		            this.list.element.on("mousedown", function(e) {
		                e.preventDefault();
		            });
		        },
	
		        _formulaListChange: function() {
		            var tokenCtx = this._tokenContext();
	
		            if (!tokenCtx || this._mute) {
		                return;
		            }
	
		            var activeToken = tokenCtx.token;
		            var completion = this.list.value()[0];
		            var ctx = {
		                replace: true,
		                token: activeToken,
		                end: activeToken.end
		            };
	
		            if (!tokenCtx.nextToken || tokenCtx.nextToken.value != "(") {
		                completion += "(";
		            }
	
		            this._replaceAt(ctx, completion);
		            this.popup.close();
		        },
	
		        _popup: function() {
		            this.popup = new kendo.ui.Popup(this.list.element, {
		                anchor: this.element
		            });
		        },
	
		        _blur: function() {
		            this.popup.close();
		            clearTimeout(this._focusId);
		            this.trigger("blur");
		        },
	
		        _isFormula: function() {
		            return /^=/.test(this.value());
		        },
	
		        _keydown: function(e) {
		            var key = e.keyCode;
	
		            if (KEY_NAMES[key]) {
		                this.popup.close();
		                this._navigated = true;
		            } else  if (this._move(key)) {
		                this._navigated = true;
		                e.preventDefault();
		            }
	
		            this._keyDownTimeout = setTimeout(this._syntaxHighlight.bind(this));
		        },
	
		        _keyup: function() {
		            var popup = this.popup;
		            var value;
	
		            if (this._isFormula() && !this._navigated) {
		                value = ((this._tokenContext() || {}).token || {}).value;
	
		                this.filter(value);
	
		                if (!value || !this.formulaSource.view().length) {
		                    popup.close();
		                } else {
		                    popup[popup.visible() ? "position" : "open"]();
		                    this.list.focusFirst();
		                }
		            }
	
		            this._navigated = false;
		            this._syntaxHighlight();
	
		            this.trigger("keyup");
		        },
	
		        _input: function() {
		            this._syntaxHighlight();
		        },
	
		        _focus: function() {
		            setTimeout(this._sync.bind(this));
		            this._focusTimeout = setTimeout(this._syntaxHighlight.bind(this));
		            this.trigger("focus");
		        },
	
		        _paste: function(ev) {
		            ev.preventDefault();
		            var pos = this.getPos();
		            var text;
		            if (kendo.support.browser.msie) {
		                text = window.clipboardData.getData("Text");
		            } else {
		                text = ev.originalEvent.clipboardData.getData("text/plain");
		            }
		            var val = this.value();
		            val = val.substr(0, pos.begin) + text + val.substr(pos.end);
		            this.value(val);
		            this.setPos(pos.begin + text.length);
		            this.scale();
		        },
	
		        _move: function(key) {
		            var list = this.list;
		            var popup = this.popup;
		            if (popup.visible()) {
		                if (key === keys.DOWN) {
		                    list.focusNext();
		                    if (!list.focus()) {
		                        list.focusFirst();
		                    }
		                    return true;
		                }
		                if (key === keys.UP) {
		                    list.focusPrev();
		                    if (!list.focus()) {
		                        list.focusLast();
		                    }
		                    return true;
		                }
		                if (key === keys.ENTER) {
		                    list.select(list.focus());
		                    popup.close();
		                    return true;
		                }
		                if (key === keys.TAB) {
		                    list.select(list.focus());
		                    popup.close();
		                    return true;
		                }
		                if (key === keys.PAGEUP) {
		                    list.focusFirst();
		                    return true;
		                }
		                if (key === keys.PAGEDOWN) {
		                    list.focusLast();
		                    return true;
		                }
		            }
		            return key === keys.ENTER || key === keys.TAB;
		        },
	
		        _tokenContext: function() {
		            var point = this.getPos();
		            var value = this.value();
	
		            if (!value || !point || !point.collapsed) {
		                return null;
		            }
	
		            var tokens = kendo.spreadsheet.calc.tokenize(value, this.row(), this.col());
		            var tok;
	
		            for (var i = 0; i < tokens.length; ++i) {
		                tok = tokens[i];
		                if (touches(tok, point) && /^(?:str|sym|func)$/.test(tok.type)) {
		                    return { token: tok, nextToken: tokens[i + 1] };
		                }
		            }
	
		            return null;
		        },
	
		        _sync: function() {
		            if (this._editorToSync && this.isActive()) {
		                this._editorToSync.value(this.value());
		            }
		        },
	
		        _textContainer: function() {
		            var computedStyles = kendo.getComputedStyles(this.element[0], styles);
	
		            computedStyles.position = "absolute";
		            computedStyles.visibility = "hidden";
		            computedStyles.whiteSpace = "pre";
		            computedStyles.top = -3333;
		            computedStyles.left = -3333;
	
		            this._span = $("<span style='white-space: pre'/>").css(computedStyles).insertAfter(this.element);
		        },
	
		        _tooltip: function() {
		            this._cellTooltip = $('<div class="k-widget k-tooltip" style="position:absolute; display:none">A1</div>').insertAfter(this.element);
		        },
	
		        tooltip: function(value) {
		            this._cellTooltip.text(value);
		        },
	
		        toggleTooltip: function(show) {
		            this._cellTooltip.toggle(show);
		        },
	
		        isActive: function() {
		            return this.element[0] === kendo._activeElement();
		        },
	
		        filter: function(value) {
		            if (!value || value.length < this.options.minLength) {
		                return;
		            }
	
		            this._mute = true;
		            this.list.select(-1);
		            this._mute = false;
	
		            this.formulaSource.filter({
		                field: this.list.options.dataValueField,
		                operator: this.options.filterOperator,
		                value: value
		            });
		        },
	
		        hide: function() {
		            this.enable(false);
		            this.element.hide();
		            this._cellTooltip.hide();
		        },
	
		        show: function() {
		            this.enable(true);
		            this.element.show();
		        },
	
		        row: function() {
		            if (this.activeCell) {
		                return this.activeCell.row;
		            }
		        },
	
		        col: function() {
		            if (this.activeCell) {
		                return this.activeCell.col;
		            }
		        },
	
		        position: function(rectangle) {
		            if (!rectangle) {
		                return;
		            }
	
		            this.show();
	
		            this.element
		                .css({
		                    "top": rectangle.top + 1 + "px",
		                    "left": rectangle.left + 1 + "px"
		                });
	
		            this._cellTooltip.css({
		                "top": (rectangle.top - this._cellTooltip.height() - 10) + "px",
		                "left": rectangle.left
		            });
		        },
	
		        resize: function(rectangle) {
		            if (!rectangle) {
		                return;
		            }
	
		            this.element.css({
		                width: rectangle.width - 1,
		                height: rectangle.height - 1
		            });
		        },
	
		        canInsertRef: function(isKeyboardAction) {
		            var result = this._canInsertRef(isKeyboardAction);
		            var token = result && result.token;
		            var idx;
	
		            if (token) {
		                for (idx = 0; idx < this._staticTokens.length; idx++) {
		                    if (isEqualToken(token, this._staticTokens[idx])) {
		                        return null;
		                    }
		                }
		            }
	
		            return result;
		        },
	
		        _canInsertRef: function(isKeyboardAction) {
		            if (this.popup.visible()) {
		                return null;
		            }
		            var strictMode = isKeyboardAction;
		            var point = this.getPos();
		            var tokens, tok;
	
		            if (point && this._isFormula()) {
		                if (point.begin === 0) {
		                    return null;
		                }
	
		                tokens = kendo.spreadsheet.calc.tokenize(this.value(), this.row(), this.col());
	
		                for (var i = 0; i < tokens.length; ++i) {
		                    tok = tokens[i];
		                    if (touches(tok, point)) {
		                        return canReplace(tok);
		                    }
		                    if (afterPoint(tok)) {
		                        return canInsertBetween(tokens[i-1], tok);
		                    }
		                }
		                return canInsertBetween(tok, null);
		            }
	
		            return null;
	
		            function afterPoint(tok) {
		                return tok.begin > point.begin;
		            }
		            function canReplace(tok) {
		                if (tok) {
		                    if (/^(?:num|str|bool|sym|ref)$/.test(tok.type)) {
		                        return { replace: true, token: tok, end: tok.end };
		                    }
		                    if (/^(?:op|punc|startexp)$/.test(tok.type)) {
		                        if (tok.end == point.end) {
		                            return canInsertBetween(tok, tokens[i+1]);
		                        }
		                        return canInsertBetween(tokens[i-1], tok);
		                    }
		                }
		            }
		            function canInsertBetween(left, right) {
		                if (left == null) {
		                    return null;
		                }
		                if (right == null) {
		                    if (/^(?:op|startexp)$/.test(left.type) || isOpenParen(left.value)) {
		                        return { token: left, end: point.end };
		                    }
		                    return null;
		                }
		                if (strictMode) {
		                    if (left.type == "op" && /^(?:punc|op)$/.test(right.type)) {
		                        return { token: left, end: point.end };
		                    }
		                } else {
		                    if (left.type == "startexp") {
		                        return { token: left, end: point.end };
		                    }
		                    if (/^(?:op|punc)$/.test(left.type) && /^[,;({]$/.test(left.value)) {
		                        return { token: left, end: point.end };
		                    }
		                    if (/^(?:ref|sym)/.test(left.type)) {
		                        return { token: left, replace: true, end: left.end };
		                    }
		                    if (/^(?:ref|sym)/.test(right.type)) {
		                        return { token: right, replace: true, end: right.end };
		                    }
		                }
		                return false;
		            }
		        },
	
		        refAtPoint: function(sheet) {
		            var x = this._canInsertRef();
		            if (x) {
		                var ref = sheet.selection()._ref.simplify().clone().relative(0, 0, 3);
		                if (sheet !== this.activeSheet) {
		                    ref = ref.setSheet(sheet.name(), true);
		                }
		                this._replaceAt(x, ref.print(0, 0));
		            }
		        },
	
		        _replaceAt: function(ctx, newValue) {
		            var value = this.value();
		            var tok = ctx.token;
		            var rest = value.substr(ctx.end);
		            value = value.substr(0, ctx.replace ? tok.begin : ctx.end) + newValue;
		            var point = value.length;
		            value += rest;
		            this._value(value);
		            this.setPos(point);
		            this.scale();
		            this._syntaxHighlight();
		        },
	
		        syncWith: function(formulaInput) {
		            var self = this;
	
		            // IE does not support "input" event on elements with contenteditable
		            // https://developer.mozilla.org/en-US/docs/Web/Events/input#Browser_compatibility
		            var eventName = "input" + ns;
		            var handler = self._sync.bind(self), iehandler;
		            if (kendo.support.browser.msie) {
		                eventName = "keydown" + ns;
		                iehandler = function() {
		                    setTimeout(handler);
		                };
		            }
	
		            self._editorToSync = formulaInput;
		            self.element.off(eventName).on(eventName, iehandler || handler);
		        },
	
		        scale: function() {
		            var element = this.element;
		            var width, height;
	
		            if (!this._span) {
		                this._textContainer();
		            }
	
		            this._span.html(element.html());
	
		            width = this._span.width() + this.options.scalePadding;
		            height = this._span.height();
	
		            if (width > element.width()) {
		                element.width(width);
		            }
		            if (height > element.height()) {
		                element.height(height);
		            }
	
		            this._sync();
		        },
	
		        _value: function(value) {
		            this.element.text(value);
		        },
	
		        value: function(value) {
		            if (value === undefined) {
		                // jQuery's .text() discards the newlines for some reason
		                var txt = this.element[0].innerText;
		                return txt.replace(/\n$/, "");
		            }
	
		            this._value(value);
		            this._syntaxHighlight();
		        },
	
		        highlightedRefs: function() {
		            return this._highlightedRefs.slice();
		        },
	
		        _syntaxHighlight: function() {
		            var pos = this.getPos();
		            var value = this.value();
		            var refClasses = kendo.spreadsheet.Pane.classNames.series;
		            var highlightedRefs = [];
		            var refIndex = 0;
		            var parens = [];
		            var tokens = [];
		            var activeToken;
	
		            if (pos && !pos.collapsed) {
		                // Backward selection (hold shift, move right to left)
		                // will not work properly if we continuously re-set
		                // the HTML.  If the selection is on, presumably the
		                // text has already been highlighted, so stop here.
		                return;
		            }
	
		            if (!(/^=/.test(value))) {
		                // if an user deleted the initial =, reset the text to
		                // discard any highlighting.  Only do that once
		                // (detect via _staticTokens or _highlightedRefs).
		                if (this._staticTokens.length || this._highlightedRefs.length) {
		                    this._staticTokens = [];
		                    this._highlightedRefs = [];
		                    this.element.text(value);
		                }
	
		                // also make sure the completion popup goes away
		                if (this.popup) {
		                    this.popup.close();
		                }
	
		                return; // avoid messing with the cursor position below
		            } else {
		                tokens = kendo.spreadsheet.calc.tokenize(value, this.row(), this.col());
		                tokens.forEach(function(tok){
		                    tok.active = false;
		                    tok.cls = [ "k-syntax-" + tok.type ];
	
		                    if (tok.type == "ref") {
		                        tok.colorClass = refClasses[(refIndex++) % refClasses.length];
		                        tok.cls.push(tok.colorClass);
		                        highlightedRefs.push(tok);
		                    }
		                    if (pos && tok.type == "punc") {
		                        if (isOpenParen(tok.value)) {
		                            parens.unshift(tok);
		                        } else if (isCloseParen(tok.value)) {
		                            var open = parens.shift();
		                            if (open) {
		                                if (isMatchingParen(tok.value, open.value)) {
		                                    if (touches(tok, pos) || touches(open, pos)) {
		                                        tok.cls.push("k-syntax-paren-match");
		                                        open.cls.push("k-syntax-paren-match");
		                                    }
		                                } else {
		                                    tok.cls.push("k-syntax-error");
		                                    open.cls.push("k-syntax-error");
		                                }
		                            } else {
		                                tok.cls.push("k-syntax-error");
		                            }
		                        }
		                    }
		                    if (pos && touches(tok, pos)) {
		                        tok.cls.push("k-syntax-at-point");
		                        tok.active = true;
		                        activeToken = tok;
		                    }
		                    if (tok.type == "func" && !knownFunction(tok.value) && (!pos || !touches(tok, pos))) {
		                        tok.cls.push("k-syntax-error");
		                    }
		                });
		                tokens.reverse().forEach(function(tok){
		                    var begin = tok.begin, end = tok.end;
		                    var text = kendo.htmlEncode(value.substring(begin, end));
		                    value = value.substr(0, begin) +
		                        "<span class='" + tok.cls.join(" ") + "'>" + text + "</span>" +
		                        value.substr(end);
		                });
		                this.element.html(value);
		            }
		            if (pos) {
		                this.setPos(pos.begin, pos.end);
		            }
	
		            if (activeToken && /^(?:startexp|op|punc)$/.test(activeToken.type)) {
		                this._setStaticTokens(tokens);
		            }
	
		            this._highlightedRefs = highlightedRefs;
		        },
	
		        _setStaticTokens: function(tokens) {
		            var idx, tok;
	
		            this._staticTokens = [];
	
		            for (idx = 0; idx < tokens.length; idx++) {
		                tok = tokens[idx];
		                if (/^(?:num|str|bool|sym|ref)$/.test(tok.type)) {
		                    this._staticTokens.push(tok);
		                }
		            }
		        },
	
		        destroy: function() {
		            this._editorToSync = null;
	
		            this.element.off(ns);
	
		            clearTimeout(this._focusTimeout);
		            clearTimeout(this._keyDownTimeout);
	
		            this._cellTooltip = null;
		            this._span = null;
	
		            this.popup.destroy();
		            this.popup = null;
	
		            Widget.fn.destroy.call(this);
		        },
	
		        insertNewline: function() {
		            var val = this.value();
		            var pos = this.getPos();
		            var eof = pos.end == val.length;
		            val = val.substr(0, pos.begin) + (eof ? "\n\n" : "\n" + val.substr(pos.end));
		            this.value(val);
		            this.setPos(pos.begin + 1);
		        }
		    });
	
		    function isOpenParen(ch) {
		        return ch == "(" || ch == "[" || ch == "{";
		    }
	
		    function isCloseParen(ch) {
		        return ch == ")" || ch == "]" || ch == "}";
		    }
	
		    function isMatchingParen(close, open) {
		        return open == "(" ? close == ")"
		            :  open == "[" ? close == "]"
		            :  open == "{" ? close == "}"
		            :  false;
		    }
	
		    function touches(pos, target) {
		        return pos.begin <= target.begin && pos.end >= target.end;
		    }
	
		    function knownFunction(name) {
		        return kendo.spreadsheet.calc.runtime.FUNCS[name.toLowerCase()];
		    }
	
		    function isEqualToken(tok1, tok2) {
		        if (!tok1 || !tok2) {
		            return false;
		        }
	
		        if (tok1.type == "ref" && tok2.type == "ref") {
		            return tok1.ref.eq(tok2.ref);
		        } else {
		            return tok1.value === tok2.value;
		        }
		    }
	
		    kendo.spreadsheet.FormulaInput = FormulaInput;
		    $.extend(true, FormulaInput, { classNames: classNames });
		})(kendo, window);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1468);
		module.exports = __webpack_require__(1468);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1468:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
	
		    var KEY_NAMES = {
		        8: 'backspace',
		        9: 'tab',
		        13: 'enter',
		        27: 'esc',
		        37: 'left',
		        38: 'up',
		        39: 'right',
		        40: 'down',
		        35: 'end',
		        36: 'home',
		        32: 'spacebar',
		        33: 'pageup',
		        34: 'pagedown',
		        46: 'delete',
		        113: ':edit'
		    };
	
		    var Mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	
		    var isAlphaNum = function(keyCode) {
		        if ((keyCode > 47 && keyCode < 58)   || // number keys
		            (keyCode > 64 && keyCode < 91)   || // letter keys
		            (keyCode > 95 && keyCode < 112)  || // numpad keys
		            (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
		            (keyCode > 218 && keyCode < 223) || // [\]' (in order)
		            (keyCode === 229)                   // combined key event?
		           ) {
		            return true;
		        }
	
		        return false;
		    };
	
		    var keyName = function(event) {
		        var keyCode = event.keyCode;
		        var name = KEY_NAMES[keyCode];
	
		        if (!name && isAlphaNum(keyCode)) {
		            name = ":alphanum";
		        }
	
		        // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
		        //
		        // Fix for https://github.com/telerik/kendo-ui-core/issues/2284
		        // (starting editor with `=` on Firefox)
		        if (!name && event.key && event.key.length == 1) {
		            name = ":alphanum";
		        }
	
		        return name;
		    };
	
		    var EventListener = kendo.Class.extend({
		        init: function(target, observer, handlers) {
		            this._handlers = {};
		            this.target = target;
		            this._observer = observer || window;
	
		            this.keyDownProxy = this.keyDown.bind(this);
		            this.mouseProxy = this.mouse.bind(this);
		            this.threshold = 5;
		            this._pressLocation = null;
	
		            target.on("keydown", this.keyDownProxy);
		            target.on("contextmenu mousedown cut copy paste scroll wheel click dblclick focus", this.mouseProxy);
	
		            $(document.documentElement).on("mousemove mouseup", this.mouseProxy);
	
		            if (handlers) {
		                for (var key in handlers) {
		                    this.on(key, handlers[key]);
		                }
		            }
		        },
	
		        keyDown: function(e) {
		            this.handleEvent(e, keyName(e.originalEvent));
		        },
	
		        mouse: function(e) {
	
		            var rightClick;
	
		            if (e.which) {
		                rightClick = (e.which == 3);
		            } else if (e.button) {
		                rightClick = (e.button == 2);
		            }
	
		            var type = e.type;
	
		            if (type === "mousedown") {
		                if (rightClick) {
		                   type = "rightmousedown";
		                } else {
		                    this._pressLocation = { x: e.pageX, y: e.pageY };
		                }
		            }
	
		            if (type === "mouseup") {
		                if (!rightClick) {
		                    this._pressLocation = null;
		                }
		            }
	
		            if (type === "mousemove" && this._pressLocation) {
		                var dx = this._pressLocation.x - e.pageX;
		                var dy = this._pressLocation.y - e.pageY;
		                var distance = Math.sqrt(dx*dx + dy*dy);
	
		                if (distance > this.threshold) {
		                    type = "mousedrag";
		                }
		            }
	
		            this.handleEvent(e, type);
		        },
	
		        handleEvent: function(e, name) {
		            var eventKey = "";
	
		            e.mod = Mac ? e.metaKey : (e.ctrlKey && !e.altKey);
	
		            if (e.altKey) {
		                eventKey += "alt+";
		            }
	
		            if (e.shiftKey) {
		                eventKey += "shift+";
		            }
	
		            if (e.ctrlKey) {
		                eventKey += "ctrl+";
		            }
	
		            eventKey += name;
	
		            var catchAllHandler = this._handlers['*+' + name];
	
		            if (catchAllHandler) {
		                catchAllHandler.call(this._observer, e, eventKey);
		            }
	
		            var handler = this._handlers[eventKey];
	
		            if (handler) {
		                handler.call(this._observer, e, eventKey);
		            }
		        },
	
		        on: function(event, callback) {
		            var handlers = this._handlers;
	
		            if (typeof callback === "string") {
		                callback = this._observer[callback];
		            }
	
		            if (typeof event === "string") {
		                event = event.split(",");
		            }
	
		            event.forEach(function(e) {
		                handlers[e] = callback;
		            });
		        },
	
		        destroy: function() {
		            this.target.off("keydown", this.keyDownProxy);
		            this.target.off("keydown", this.mouseProxy);
		            $(document.documentElement).off("mousemove mouseup", this.mouseProxy);
		        }
		    });
	
		    kendo.spreadsheet.EventListener = EventListener;
		})(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1493);
		module.exports = __webpack_require__(1493);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1493:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var RangeTreeNode = kendo.Class.extend({
		        init: function Node(level, value, left, right) {
		            this.level = level;
		            this.value = value;
		            this.left = left;
		            this.right = right;
		        }
		    });
	
		    var NilNode = new (function NIL() { // jshint ignore:line
		        this.left = this;
		        this.right = this;
		        this.level = 0;
		    })();
	
		    function skew(node) {
		        if (node.left.level === node.level) {
		            var temp = node;
		            node = node.left;
		            temp.left = node.right;
		            node.right = temp;
		        }
	
		        return node;
		    }
	
		    function split(node) {
		        if (node.right.right.level === node.level) {
		            var temp = node;
		            node = node.right;
		            temp.right = node.left;
		            node.left = temp;
		            node.level += 1;
		        }
	
		        return node;
		    }
	
		    function insert(node, value) {
		        if (node === NilNode) {
		            return new RangeTreeNode(1, value, NilNode, NilNode);
		        } else if (node.value.start > value.start) {
		            node.left = insert(node.left, value);
		        } else {
		            node.right = insert(node.right, value);
		        }
	
		        return split(skew(node));
		    }
	
		    function remove(node, value) {
		        if (node === NilNode) {
		            return node;
		        }
	
		        var diff = node.value.start - value.start;
		        if (diff === 0) {
		            if (node.left !== NilNode && node.right !== NilNode) {
		                var heir = node.left;
	
		                while (heir.right !== NilNode) {
		                    heir = heir.right;
		                }
	
		                node.value = heir.value;
		                node.left = remove(node.left, node.value);
		            } else if (node.left === NilNode) {
		                node = node.right;
		            } else {
		                node = node.left;
		            }
		        } else if (diff > 0) {
		            node.left = remove(node.left, value);
		        } else {
		            node.right = remove(node.right, value);
		        }
	
		        if (node.left.level < (node.level - 1) || node.right.level < (node.level - 1)) {
		            node.level -= 1;
		            if (node.right.level > node.level) {
		                node.right.level = node.level;
		            }
	
		            node = skew(node);
		            node.right = skew(node.right);
		            node.right.right = skew(node.right.right);
		            node = split(node);
		            node.right = split(node.right);
		        }
	
		        return node;
		    }
	
		    var Range = kendo.Class.extend({
		        init: function ValueRange(start, end, value) {
		            this.start = start;
		            this.end = end;
		            this.value = value;
		        },
	
		        intersects: function(range) {
		            return range.start <= this.end && range.end >= this.start;
		        },
	
		        clone: function() {
		            return new Range(this.start, this.end, this.value);
		        }
		    });
	
		    var RangeTree = kendo.Class.extend({
		        init: function() {
		            this.root = NilNode;
		        },
	
		        insert: function(value) {
		            this.root = insert(this.root, value);
		        },
	
		        remove: function(value) {
		            this.root = remove(this.root, value);
		        },
	
		        findrange: function(value) {
		            var node = this.root;
	
		            while (node != NilNode) {
		                if (value < node.value.start) {
		                    node = node.left;
		                } else if (value > node.value.end) {
		                    node = node.right;
		                } else {
		                    return node.value;
		                }
		            }
	
		            return null;
		        },
	
		        values: function() {
		            var result = [];
		            values(this.root, result);
		            return result;
		        },
	
		        intersecting: function(start, end) {
		            var ranges = [];
		            intersecting(this.root, new Range(start, end), ranges);
		            return ranges;
		        },
	
		        map: function(callback) {
		            var tree = new RangeTree();
		            map(tree, this.root, callback);
		            return tree;
		        },
	
		        clone: function() {
		            return this.map(function(value) {
		                return value.clone();
		            });
		        },
	
		        first: function() {
		            var first = this.root;
		            while(first.left != NilNode) {
		                first = first.left;
		            }
	
		            return first;
		        },
	
		        last: function() {
		            var last = this.root;
		            while(last.right != NilNode) {
		                last = last.right;
		            }
	
		            return last;
		        }
		    });
	
		    function values(node, result) {
		        if (node === NilNode) {
		            return;
		        }
	
		        values(node.left, result);
		        result.push(node.value);
		        values(node.right, result);
		    }
	
		    function intersecting(node, range, ranges) {
		        if (node === NilNode) {
		            return;
		        }
	
		        var value = node.value;
	
		        if (range.start < value.start) {
		            intersecting(node.left, range, ranges);
		        }
	
		        if (value.intersects(range)) {
		            ranges.push(value);
		        }
	
		        if (range.end > value.end) {
		            intersecting(node.right, range, ranges);
		        }
		    }
	
		    function map(tree, root, callback) {
		        if (root === NilNode) {
		            return;
		        }
	
		        map(tree, root.left, callback);
		        tree.insert(callback(root.value));
		        map(tree, root.right, callback);
		    }
	
		    var RangeList = kendo.Class.extend({
		        init: function(start, end, value) {
		            if (end === undefined) {
		                this.tree = start;
		            } else {
		                this.tree = new RangeTree();
		                this.tree.insert(new Range(start, end, value));
		            }
		        },
	
		        values: function() {
		            return this.tree.values();
		        },
	
		        map: function(callback) {
		            return new RangeList(this.tree.map(callback));
		        },
	
		        intersecting: function(start, end) {
		            return this.tree.intersecting(start, end);
		        },
	
		        first: function() {
		            return this.tree.first().value;
		        },
	
		        last: function() {
		            return this.tree.last().value;
		        },
	
		        insert: function(start, end, value) {
		            return this.tree.insert(new Range(start, end, value));
		        },
	
		        value: function(start, end, value) {
		            if (value === undefined) {
		                if (end === undefined) {
		                    end = start;
		                }
		                return this.intersecting(start, end)[0].value;
		            }
	
		            var ranges = this.tree.intersecting(start - 1, end + 1);
	
		            if (ranges.length) {
		                var firstRange = ranges[0], lastRange = ranges[ranges.length - 1];
	
		                if (firstRange.end < start) {
		                    if (firstRange.value === value) {
		                        start = firstRange.start;
		                    } else {
		                        ranges.shift();
		                    }
		                }
	
		                if (lastRange.start > end) {
		                    if (lastRange.value === value) {
		                        end = lastRange.end;
		                    } else {
		                        ranges.pop();
		                    }
		                }
	
		                for (var i = 0, length = ranges.length; i < length; i++) {
		                    var range = ranges[i];
		                    var rangeValue = range.value;
		                    var rangeStart = range.start;
		                    var rangeEnd = range.end;
	
		                    this.tree.remove(range);
	
		                    if (rangeStart < start) {
		                        if (rangeValue !== value) {
		                            this.insert(rangeStart, start - 1, rangeValue);
		                        } else {
		                            start = rangeStart;
		                        }
		                    }
	
		                    if (rangeEnd > end) {
		                        if (rangeValue !== value) {
		                            this.insert(end + 1, rangeEnd, rangeValue);
		                        } else {
		                            end = rangeEnd;
		                        }
		                    }
		                }
		            }
	
		            this.insert(start, end, value);
		        },
	
		        expandedValues: function(start, end) {
		            var ranges = this.intersecting(start, end);
		            var result = [];
	
		            var rangeIndex = 0;
	
		            for (var i = start; i <= end; i++) {
		                if (ranges[rangeIndex].end < i) {
		                    rangeIndex ++;
		                }
	
		                result.push({ index: i - start, value: ranges[rangeIndex].value });
		            }
	
		            return result;
		        },
	
		        sortedIndices: function(start, end, valueComparer, indices) {
		            var result = this.expandedValues(start, end);
	
		            var comparer = function(a, b) {
		                if (a.value === b.value) {
		                    return a.index - b.index;
		                }
	
		                return valueComparer(a.value, b.value);
		            };
	
		            if (indices) {
		                comparer = function(a, b) {
		                    var x = indices[a.index];
		                    var y = indices[b.index];
	
		                    if (x.value === y.value) {
		                        return valueComparer(a.value, b.value);
		                    }
	
		                    return a.index - b.index;
		                };
		            }
	
		            result.sort(comparer);
	
		            return result;
		        },
	
		        sort: function(start, end, indices) {
		            if (this.intersecting(start, end).length === 1) {
		                return;
		            }
	
		            var values = this.expandedValues(start, end);
	
		            for (var i = 0, len = indices.length; i < len; i++) {
		                this.value(i + start, i + start, values[indices[i].index].value);
		            }
		        },
	
		        copy: function(sourceStart, sourceEnd, targetStart) {
		            var values = this.intersecting(sourceStart, sourceEnd);
	
		            var start = targetStart;
		            var end;
	
		            for (var i = 0, len = values.length; i < len; i++) {
		                var rangeStart = values[i].start;
	
		                if (rangeStart < sourceStart) {
		                    rangeStart = sourceStart;
		                }
	
		                var rangeEnd = values[i].end;
	
		                if (rangeEnd > sourceEnd) {
		                    rangeEnd = sourceEnd;
		                }
	
		                end = start + (rangeEnd - rangeStart);
	
		                this.value(start, end, values[i].value);
	
		                start = ++end;
		            }
		        },
	
		        iterator: function(start, end) {
		            return new Iterator(start, end, this.intersecting(start, end));
		        },
	
		        getState: function() {
		            return this.tree.clone();
		        },
	
		        setState: function(state) {
		            this.tree = state.clone();
		        }
		    });
	
		    var Iterator = kendo.Class.extend({
		        init: function(start, end, ranges) {
		            this.start = start;
		            this.end = end;
		            this.index = 0;
		            this.ranges = ranges;
		        },
	
		        unique: function() {
		            return this.ranges.map(function(range) {
		                return range.value;
		            });
		        },
	
		        at: function(index) {
		            while (this.ranges[this.index] && this.ranges[this.index].end < index) {
		                this.index ++;
		            }
	
		            return this.ranges[this.index] && this.ranges[this.index].value;
		        },
	
		        forEach: function(callback) {
		            for (var i = this.start; i <= this.end; i++) {
		                callback(this.at(i), i);
		            }
	
		            this.index = 0;
		        }
		    });
	
		    var SparseRangeList = RangeList.extend({
		        init: function(start, end, value) {
		            this.tree = new RangeTree();
		            this.range = new Range(start, end, value);
		        },
	
		        intersecting: function(start, end) {
		            var ranges = this.tree.intersecting(start, end);
		            var result = [];
		            var range;
	
		            if (!ranges.length) {
		                return [this.range];
		            }
	
		            for (var i = 0, len = ranges.length; i < len; i++) {
		                range = ranges[i];
		                if (range.start > start) {
		                    result.push(new Range(start, range.start - 1, this.range.value));
		                }
	
		                result.push(range);
		                start = range.end + 1;
		            }
	
		            if (range.end < end) {
		                result.push(new Range(range.end + 1, end, this.range.value));
		            }
	
		            return result;
		        },
	
		        insert: function(start, end, value) {
		            if (value !== this.range.value) {
		                this.tree.insert(new Range(start, end, value));
		            }
		        },
	
		        lastRangeStart: function() {
		            var node = this.tree.root;
	
		            if (node === NilNode) {
		                return this.range.start;
		            }
	
		            while(node.right !== NilNode) {
		                node = node.right;
		            }
	
		            return node.value.end + 1;
		        }
		    });
	
	
		    kendo.spreadsheet.RangeTree = RangeTree;
		    kendo.spreadsheet.RangeList = RangeList;
		    kendo.spreadsheet.SparseRangeList = SparseRangeList;
		    kendo.spreadsheet.ValueRange = Range;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1491);
		module.exports = __webpack_require__(1491);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1491:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var Property = kendo.Class.extend({
		        init: function(list) {
		            this.list = list;
		        },
	
		        get: function(index) {
		            return this.parse(this.list.value(index, index));
		        },
	
		        set: function(start, end, value) {
		            if (value === undefined) {
		                value = end;
		                end = start;
		            }
	
		            this.list.value(start, end, value);
		        },
	
		        parse: function(value) {
		            return value;
		        },
	
		        copy: function(start, end, dst) {
		            this.list.copy(start, end, dst);
		        },
	
		        iterator: function(start, end) {
		            return this.list.iterator(start, end);
		        }
		    });
	
		    var JsonProperty = Property.extend({
		        set: function(start, end, value) {
		            this.list.value(start, end, JSON.stringify(value));
		        },
	
		        parse: function(value) {
		            return JSON.parse(value);
		        }
		    });
	
		    var ValueProperty = Property.extend({
		        init: function(values, formats) {
		            Property.prototype.init.call(this, values);
		            this.formats = formats;
		        },
	
		        set: function(start, end, value) {
		            if (value instanceof Date) {
		                value = kendo.spreadsheet.dateToNumber(value);
		                if (!this.formats.value(start,end)) {
		                    this.formats.value(start, end, toExcelFormat(kendo.culture().calendar.patterns.d));
		                }
		            } else if (typeof value == "number") {
		                value = kendo.spreadsheet.calc.runtime.limitPrecision(value);
		            }
	
		            this.list.value(start, end, value);
		        }
		    });
	
		    function toExcelFormat(format) {
		        return format.replace(/M/g, "m").replace(/'/g, '"').replace(/tt/, "am/pm");
		    }
	
		    kendo.spreadsheet.PropertyBag = kendo.Class.extend({
		        specs: [
		            { property: Property, name: "format", value: null, sortable: true, serializable: true },
		            { property: ValueProperty, name: "value", value: null, sortable: true, serializable: true, depends: "format" },
		            { property: Property, name: "formula", value: null, sortable: true, serializable: true },
		            { property: Property, name: "background", value: null, sortable: true, serializable: true },
		            { property: JsonProperty, name: "vBorders", value: null, sortable: false, serializable: false },
		            { property: JsonProperty, name: "hBorders", value: null, sortable: false, serializable: false },
		            { property: Property, name: "color", value: null, sortable: true, serializable: true },
		            { property: Property, name: "fontFamily", value: null, sortable: true, serializable: true },
		            { property: Property, name: "underline", value: null, sortable: true, serializable: true },
		            { property: Property, name: "fontSize", value: null, sortable: true, serializable: true },
		            { property: Property, name: "italic", value: null, sortable: true, serializable: true },
		            { property: Property, name: "bold", value: null, sortable: true, serializable: true },
		            { property: Property, name: "textAlign", value: null, sortable: true, serializable: true },
		            { property: Property, name: "verticalAlign", value: null, sortable: true, serializable: true },
		            { property: Property, name: "wrap", value: null, sortable: true, serializable: true },
		            { property: Property, name: "validation", value: null, sortable: false, serializable: true },
		            { property: Property, name: "enable", value: null, sortable: false, serializable: true },
		            { property: Property, name: "link", value: null, sortable: true, serializable: true },
		            { property: Property, name: "editor", value: null, sortable: true, serializable: true }
		        ],
	
		        init: function(rowCount, columnCount, defaultValues) {
		            defaultValues = defaultValues || {};
		            var cellCount = rowCount * columnCount - 1;
	
		            this.rowCount = rowCount;
		            this.columnCount = columnCount;
		            this.cellCount = cellCount;
		            this.properties = {};
		            this.lists = {};
	
		            this.specs.forEach(function(spec) {
		                var name = spec.name;
		                var value = defaultValues[name];
		                if (value === undefined) {
		                    value = spec.value;
		                }
		                this.lists[name] = new kendo.spreadsheet.SparseRangeList(0, cellCount, value);
		                var prop = this.properties[name] = new spec.property(this.lists[name], this.lists[spec.depends]);
		                prop.spec = spec;
		            }, this);
	
		            // XXX: this is a hack but I have no better ideas at this
		            // point.  The getState() method in a SparseRangeList
		            // clones the tree (which just copies values over), but
		            // formulas are objects maintaining complex state.
		            // https://github.com/telerik/kendo-ui-core/issues/2816
		            this.lists.formula.tree.clone = cloneFormulaTree;
		            this.lists.validation.tree.clone = cloneFormulaTree;
		        },
	
		        getState: function() {
		            var state = {};
	
		            this.specs.forEach(function(spec) {
		               state[spec.name] = this.lists[spec.name].getState();
		            }, this);
	
		            return state;
		        },
	
		        setState: function(state) {
		            this.specs.forEach(function(spec) {
		                this.lists[spec.name].setState(state[spec.name]);
		            }, this);
		        },
	
		        get: function(name, index) {
		            if (index === undefined) {
		                return this.lists[name];
		            }
	
		            switch (name) {
		              case "borderRight":
		                index += this.rowCount;
		                /* falls through */
		              case "borderLeft":
		                name = "vBorders";
		                break;
	
		              case "borderBottom":
		                index++;
		                /* falls through */
		              case "borderTop":
		                name = "hBorders";
		                break;
		            }
		            return index > this.cellCount ? null : this.properties[name].get(index);
		        },
	
		        set: function(name, start, end, value) {
		            switch (name) {
		              case "borderRight":
		                start += this.rowCount;
		                end += this.rowCount;
		                /* falls through */
		              case "borderLeft":
		                name = "vBorders";
		                break;
	
		              case "borderBottom":
		                start++;
		                end++;
		                /* falls through */
		              case "borderTop":
		                name = "hBorders";
		                break;
		            }
		            if (start <= end && end <= this.cellCount) {
		                this.properties[name].set(start, end, value);
		            }
		        },
	
		        fromJSON: function(index, value) {
		            for (var si = 0; si < this.specs.length; si++) {
		                var spec = this.specs[si];
	
		                if (spec.serializable) {
		                    if (value[spec.name] !== undefined) {
		                        this.set(spec.name, index, index, value[spec.name], false);
		                    }
		                }
		            }
	
		            [ "borderLeft", "borderRight", "borderTop", "borderBottom" ].forEach(function(b){
		                if (value[b] !== undefined) {
		                    this.set(b, index, index, value[b]);
		                }
		            }, this);
		        },
	
		        copy: function(sourceStart, sourceEnd, targetStart) {
		            this.specs.forEach(function(spec) {
		                this.properties[spec.name].copy(sourceStart, sourceEnd, targetStart);
		            }, this);
		        },
	
		        iterator: function(name, start, end) {
		            var prop = this.properties[name];
		            var iter = prop.iterator(start, end), at = iter.at;
		            var cellCount = this.cellCount;
		            iter.at = function(index) {
		                return index > cellCount ? null : prop.parse(at.call(iter, index));
		            };
		            iter.name = name;
		            iter.value = prop.spec.value;
		            return iter;
		        },
	
		        sortable: function() {
		            return this.specs.filter(function(spec) { return spec.sortable; })
		                .map(function(spec) {
		                    return this.lists[spec.name];
		                }, this);
		        },
	
		        iterators: function(start, end) {
		            return this.specs.reduce(function(ret, spec) {
		                if (spec.serializable) {
		                    ret.push(this.iterator(spec.name, start, end));
		                }
		                return ret;
		            }.bind(this), []);
		        },
	
		        forEach: function(start, end, callback) {
		            var iterators = this.iterators(start, end);
		            var hBorders = this.iterator("hBorders", start, end + 1);
		            var leftBorders = this.iterator("vBorders", start, end);
		            var rightBorders = this.iterator("vBorders", start + this.rowCount, end + this.rowCount);
		            var values, index;
	
		            function addBorder(name, iterator, index) {
		                var val = iterator.at(index);
		                if (val !== iterator.value) {
		                    values[name] = val;
		                }
		            }
	
		            for (index = start; index <= end; index++) {
		                values = {};
	
		                for (var i = 0; i < iterators.length; i++) {
		                    var iterator = iterators[i];
		                    var value = iterator.at(index);
	
		                    if (value !== iterator.value) {
		                        values[iterator.name] = value;
		                    }
		                }
	
		                addBorder("borderLeft", leftBorders, index);
		                addBorder("borderRight", rightBorders, index + this.rowCount);
		                addBorder("borderTop", hBorders, index);
		                if ((index + 1) % this.rowCount) {
		                    addBorder("borderBottom", hBorders, index + 1);
		                }
	
		                callback(values);
		            }
		        },
	
		        forEachProperty: function(callback) {
		            for (var name in this.properties) {
		                callback(this.properties[name]);
		            }
		        }
		    });
	
		    function cloneFormulaValue(x) {
		        x = x.clone();
		        x.value = x.value.deepClone(); // x.value is Formula or Validation
		        return x;
		    }
	
		    function cloneFormulaTree() {
		        var tree = this.map(cloneFormulaValue);
		        tree.clone = cloneFormulaTree; // because it's a new RangeTree now
		        return tree;
		    }
	
		    kendo.spreadsheet.ALL_PROPERTIES = kendo.spreadsheet.PropertyBag.prototype.specs.reduce(function(a, spec) {
		        if (spec.serializable) {
		            a.push(spec.name);
		        }
		        return a;
		    }, [ "borderTop", "borderRight", "borderBottom", "borderLeft" ]);
	
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1494);
		module.exports = __webpack_require__(1494);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1494:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /* jshint eqnull:true, laxbreak:true */
	
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var spreadsheet = kendo.spreadsheet;
		    var Class = kendo.Class;
	
		    function columnName(colIndex) {
		        var letter = Math.floor(colIndex / 26) - 1;
		        return (letter >= 0 ? columnName(letter) : "") + String.fromCharCode(65 + (colIndex % 26));
		    }
	
		    function displaySheet(sheet) {
		        if (/^[a-z_][a-z0-9_]*$/i.test(sheet)) {
		            return sheet;
		        }
		        return "'" + sheet.replace(/\x27/g, "\\'") + "'";
		    }
	
		    function displayRef(sheet, row, col, rel) {
		        var aa = "";
	
		        ++row;
	
		        if (!isFinite(row)) {
		            row = "";
		        }
		        else if (rel != null && !(rel & 2)) {
		            row = "$" + row;
		        }
	
		        if (!isFinite(col)) {
		            col = "";
		        }
		        else {
		            aa = columnName(col);
		            if (rel != null && !(rel & 1)) {
		                aa = "$" + aa;
		            }
		        }
	
		        if (sheet) {
		            return displaySheet(sheet) + "!" + aa + row;
		        } else {
		            return aa + row;
		        }
		    }
	
		    /* -----[ References ]----- */
	
		    var Ref = Class.extend({
		        type: "ref",
		        sheet: "",
		        clone: function() {
		            return this;
		        },
		        hasSheet: function() {
		            return this._hasSheet;
		        },
		        simplify: function() {
		            return this;
		        },
		        setSheet: function(sheet, hasSheet) {
		            this.sheet = sheet;
		            if (hasSheet != null) {
		                this._hasSheet = hasSheet;
		            }
		            return this;
		        },
		        absolute: function(){
		            return this;
		        },
		        relative: function(){
		            return this;
		        },
		        adjust: function(){
		            return this;
		        },
		        toString: function() {
		            return this.relative(0, 0, 3, 3).print(0, 0);
		        },
		        forEach: function(callback, obj) {
		            callback.call(obj, this);
		        },
		        map: function(callback, obj) {
		            return callback.call(obj, this);
		        },
		        intersects: function(ref) {
		            return this.intersect(ref) !== NULL;
		        },
		        isCell: function() {
		            return false;
		        },
		        toRow: function() {
		            return this;
		        },
		        toColumn: function() {
		            return this;
		        },
	
		        // UnionRef overrides these, to access its subranges.
		        first: function() {
		            return this;
		        },
		        lastRange: function() {
		            return this;
		        },
		        size: function() {
		            return 1;
		        },
		        rangeAt: function() {
		            return this;
		        },
		        nextRangeIndex: function() {
		            return 0;
		        },
		        previousRangeIndex: function() {
		            return 0;
		        },
		        eq: function(reference) {
		            var r1 = this;
		            var r2 = reference;
	
		            if (r1 === NULL || r2 === NULL) {
		                return r1 === r2;
		            }
	
		            // make positions consistent
		            if ((r2 instanceof CellRef) || (r2 instanceof RangeRef && !(r1 instanceof CellRef))) {
		               r1 = reference;
		               r2 = this;
		            }
	
		            if (r1 instanceof CellRef) { // cell eq *
		                r2 = r2.simplify();
		                return r2 instanceof CellRef && r1.row == r2.row && r1.col == r2.col && r1.sheet == r2.sheet;
		            }
		            else if (r1 instanceof RangeRef) { // range eq range/union
		                if (r2 instanceof RangeRef) {
		                    return r2.topLeft.eq(r1.topLeft) && r2.bottomRight.eq(r1.bottomRight);
		                }
		                if (r2 instanceof UnionRef) {
		                    return r2.single() && r1.eq(r2.refs[0]);
		                }
		            }
		            else if (r1 instanceof UnionRef && r2 instanceof UnionRef) { // union eq union
		                var refs1 = r1.refs;
		                var refs2 = r2.refs;
		                if (refs1.length != refs2.length) {
		                   return false;
		                }
	
		                for (var i = 0, len = refs1.length; i < len; i++) {
		                    if (!refs1[i].eq(refs2[i])) {
		                        return false;
		                    }
		                }
	
		                return true;
		            }
	
		            return r1 === r2;   // XXX: possibly NameRef when we'll support it.
		        },
	
		        concat: function(ref) {
		            return new UnionRef([this, ref]);
		        },
	
		        replaceAt: function(index, ref) {
		            return ref;
		        },
	
		        forEachColumnIndex: function(callback) {
		            this.forEachAxisIndex('col', callback);
		        },
	
		        forEachRowIndex: function(callback) {
		            this.forEachAxisIndex('row', callback);
		        },
	
		        forEachAxisIndex: function(axis, callback) {
		            var sorted = [];
	
		            var method = axis === 'row' ? 'forEachRow' : 'forEachColumn';
	
		            this[method](function(ref) {
		                var index = ref.first()[axis];
		                if (sorted.indexOf(index) === -1) {
		                    sorted.push(index);
		                }
		            });
	
		            sorted.sort(function(a,b) {
		                return a > b ? 1 : (a < b ? -1 : 0);
		            }).forEach(callback);
		        },
	
		        valid: function() {
		            return false;
		        },
	
		        renameSheet: function(oldSheetName, newSheetName) {
		            if (this.sheet && this.sheet.toLowerCase() == oldSheetName.toLowerCase()) {
		                this.sheet = newSheetName;
		                return true;
		            }
		        }
		    });
	
		    Ref.display = displayRef;
	
		    /* -----[ Null reference ]----- */
	
		    var NULL = new (Ref.extend({
		        init: function NullRef(){},
		        print: function() {
		            return "#NULL!";
		        },
		        eq: function(ref) {
		            return ref === this;
		        },
		        forEach: function() {}
		    }))();
	
		    /* -----[ Name reference ]----- */
	
		    var NameRef = Ref.extend({
		        ref: "name",
		        init: function NameRef(name){
		            this.name = name;
		        },
		        clone: function() {
		            return new NameRef(this.name)
		                .setSheet(this.sheet, this.hasSheet());
		        },
		        print: function() {
		            var ret = displaySheet(this.name);
		            if (this.hasSheet()) {
		                ret = displaySheet(this.sheet) + "!" + ret;
		            }
		            return ret;
		        }
		    });
	
		    /* -----[ Cell reference ]----- */
	
		    var CellRef = Ref.extend({
		        ref: "cell",
		        init: function CellRef(row, col, rel) {
		            this.row = row;
		            this.col = col;
		            this.rel = rel || 0;
		        },
		        clone: function() {
		            return new CellRef(this.row, this.col, this.rel)
		                .setSheet(this.sheet, this.hasSheet());
		        },
		        intersect: function(ref) {
		            if (ref instanceof CellRef) {
		                if (this.eq(ref)) {
		                    return this;
		                } else {
		                    return NULL;
		                }
		            }
		            return ref.intersect(this);
		        },
		        print: function(trow, tcol, mod) {
		            var col = this.col, row = this.row, rel = this.rel, abs;
		            if (trow == null && rel) {
		                var sheet = this.hasSheet() ? displaySheet(this.sheet) + "!" : "";
		                if (isFinite(col)) {
		                    col = rel & 1 ? ("C[" + col + "]") : ("C" + (col + 1));
		                } else {
		                    col = "";
		                }
		                if (isFinite(row)) {
		                    row = rel & 2 ? ("R[" + row + "]") : ("R" + (row + 1));
		                } else {
		                    row = "";
		                }
		                return sheet + row + col;
		            } else {
		                abs = this.absolute(trow, tcol);
		                if (mod) {
		                    // Hacks: see the big comment below in `absolute()`
		                    row = abs.row % 0x100000;
		                    col = abs.col % 0x4000;
		                    if (row < 0) {
		                        row += 0x100000;
		                    }
		                    if (col < 0) {
		                        col += 0x4000;
		                    }
		                    return displayRef(this._hasSheet && this.sheet, row, col, rel);
		                }
		                return abs.valid() ? displayRef(this._hasSheet && this.sheet, abs.row, abs.col, rel) : "#REF!";
		            }
		        },
		        absolute: function(arow, acol) {
		            var ret = this.clone();
		            if (ret.rel & 3 === 0) {
		                return ret;    // already absolute
		            }
	
		            // Hacks: we make coordinates modulo 0x4000 (max col) and 0x100000 (max row).  This
		            // fixes importing relative references in definedName-s from Excel.  Example in
		            // Excel: select cell E3, open the Name Manager (in Formula tab) and define name
		            // TEST with value Sheet1!A1:C3.  The serialization of this name in XLSX is:
		            //
		            //     <definedName name="TEST">Sheet1!XFA1048575:XFC1</definedName>
		            //
		            // This is insane, of course, but oh well.  Excel.  If you type in E3 =SUM(TEST) it
		            // works (it actually sums the cells), but if you type =SUM(Sheet1!XFA1048575:XFC1)
		            // you get back zero.  Let's see why SUM(TEST) works:
		            //
		            //     XFA1048575:XFC1                   E3
		            //     (zero-based indexes below)
		            //
		            //     R[1048574]C[16380]:R[0]C[16382] + R2C4 = R1048576C16384:R2C16386
		            //                                            % (0x100000, 0x4000)
		            //                                            = R0C0:R2C2 (== A1:C3)
		            //
		            // So XFA1048575:XFC1 is relocated to E3 at evaluation time, and because we take
		            // rows modulo 0x100000 and cols modulo 0x4000, we get back the correct range.
		            //
		            // IMO Excel should disallow A1-style relative references in name definitions
		            // (simply because the meaning of the A1:C3 you type in Name Manager depends on the
		            // active cell) and only allow R1C1 notation — that's unambiguous.  But it doesn't.
		            // Moreover, R1C1-style refs in XLSX are explicitly forbidden by the spec, and the
		            // hacks above are not documented — how else could we have fun implementing a XLSX
		            // reader?
		            if (ret.rel & 1) {
		                // relative col, add anchor
		                ret.col = (ret.col + acol) % 0x4000;
		            }
		            if (ret.rel & 2) {
		                // relative row, add anchor
		                ret.row = (ret.row + arow) % 0x100000;
		            }
	
		            ret.rel = 0;
		            return ret;
		        },
		        toRangeRef: function() {
		            return new RangeRef(this, this);
		        },
		        relative: function(arow, acol, rel) {
		            if (rel == null) {
		                rel = this.rel;
		            }
		            var row = rel & 2 ? this.row - arow : this.row;
		            var col = rel & 1 ? this.col - acol : this.col;
		            return new CellRef(row, col, rel)
		                .setSheet(this.sheet, this.hasSheet());
		        },
		        height: function() {
		            return 1;
		        },
		        width: function() {
		            return 1;
		        },
		        toString: function() {
		            return displayRef(null, this.row, this.col, 3);
		        },
		        isCell: function() {
		            return true;
		        },
		        leftColumn: function() {
		            return this;
		        },
		        rightColumn: function() {
		            return this;
		        },
		        topRow: function() {
		            return this;
		        },
		        bottomRow: function() {
		            return this;
		        },
		        forEachRow: function(callback) {
		            callback(this.toRangeRef());
		        },
		        forEachColumn: function(callback) {
		            callback(this.toRangeRef());
		        },
		        adjust: function(row, col, trow, tcol, forRow, start, delta) {
		            var ref = this.absolute(row, col);
		            if (forRow) {
		                if (ref.row >= start) {
		                    if (delta < 0 && ref.row < start - delta) {
		                        return NULL;
		                    }
		                    ref.row += delta;
		                }
		            } else {
		                if (ref.col >= start) {
		                    if (delta < 0 && ref.col < start - delta) {
		                        return NULL;
		                    }
		                    ref.col += delta;
		                }
		            }
		            if (trow != null && tcol != null) {
		                ref = ref.relative(trow, tcol, this.rel);
		            }
		            return ref;
		        },
		        valid: function() {
		            if (this.rel) {
		                throw new Error("valid() called on relative reference");
		            }
		            var col = this.col, row = this.row;
		            return !((isFinite(col) && col < 0) || (isFinite(row) && row < 0));
		        }
		    });
	
		    /* -----[ Range reference ]----- */
	
		    var RangeRef = Ref.extend({
		        ref: "range",
		        init: function RangeRef(tl, br) {
		            if (tl._hasSheet && br._hasSheet && tl.sheet.toLowerCase() != br.sheet.toLowerCase()) {
		                // "3D" reference
		                this.endSheet = br.sheet;
		            }
		            // we want to drop any sheet information from the cells here.
		            this.topLeft = new CellRef(tl.row, tl.col, tl.rel);
		            this.bottomRight = new CellRef(br.row, br.col, br.rel);
		            this.normalize();
		        },
		        clone: function() {
		            return new RangeRef(this.topLeft.clone(), this.bottomRight.clone()).setSheet(this.sheet, this.hasSheet());
		        },
		        _containsRange: function(range) {
		            return this._containsCell(range.topLeft)
		                && this._containsCell(range.bottomRight);
		        },
		        _containsCell: function(cell) {
		            return cell.sheet == this.sheet
		                && cell.row >= this.topLeft.row
		                && cell.col >= this.topLeft.col
		                && cell.row <= this.bottomRight.row
		                && cell.col <= this.bottomRight.col;
		        },
		        contains: function(ref) {
		            if (ref instanceof Array) {
		                var that = this;
	
		                return ref.some(function(_ref) { return that.contains(_ref); });
		            }
		            if (ref instanceof CellRef) {
		                return this._containsCell(ref);
		            }
		            if (ref instanceof RangeRef) {
		                return this._containsRange(ref);
		            }
		            return false;
		        },
		        _intersectRange: function(ref) {
		            if (this.sheet != ref.sheet) {
		                return NULL;
		            }
		            var a_left    = this.topLeft.col;
		            var a_top     = this.topLeft.row;
		            var a_right   = this.bottomRight.col;
		            var a_bottom  = this.bottomRight.row;
		            var b_left    = ref.topLeft.col;
		            var b_top     = ref.topLeft.row;
		            var b_right   = ref.bottomRight.col;
		            var b_bottom  = ref.bottomRight.row;
		            if (a_left <= b_right &&
		                b_left <= a_right &&
		                a_top <= b_bottom &&
		                b_top <= a_bottom)
		            {
		                return new RangeRef(
		                    // topLeft
		                    new CellRef(Math.max(a_top, b_top),
		                                Math.max(a_left, b_left)),
		                    // bottomRight
		                    new CellRef(Math.min(a_bottom, b_bottom),
		                                Math.min(a_right, b_right))
		                ).setSheet(this.sheet, this.hasSheet());
		            } else {
		                return NULL;
		            }
		        },
		        intersect: function(ref) {
		            if (ref instanceof CellRef) {
		                return this._containsCell(ref) ? ref : NULL;
		            }
		            if (ref instanceof RangeRef) {
		                return this._intersectRange(ref).simplify();
		            }
		            if (ref instanceof UnionRef) {
		                return ref.intersect(this);
		            }
		            return NULL;        // can't handle NameRef-s here.
		        },
		        simplify: function() {
		            if (this.isCell()) {
		                return new CellRef(
		                    this.topLeft.row,
		                    this.topLeft.col,
		                    this.topLeft.rel
		                ).setSheet(this.sheet, this.hasSheet());
		            }
		            return this;
		        },
		        normalize: function() {
		            var a = this.topLeft, b = this.bottomRight;
		            var r1 = a.row, c1 = a.col, r2 = b.row, c2 = b.col;
		            var rr1 = a.rel & 2, rc1 = a.rel & 1;
		            var rr2 = b.rel & 2, rc2 = b.rel & 1;
		            var tmp, changes = false;
		            // do not attempt to normalize unless relativeness of rows and cols are the same.
		            // https://github.com/telerik/kendo-ui-core/issues/4278
		            if (rr1 === rr2 && rc1 === rc2) {
		                if (r1 > r2) {
		                    changes = true;
		                    tmp = r1; r1 = r2; r2 = tmp;
		                    tmp = rr1; rr1 = rr2; rr2 = tmp;
		                }
		                if (c1 > c2) {
		                    changes = true;
		                    tmp = c1; c1 = c2; c2 = tmp;
		                    tmp = rc1; rc1 = rc2; rc2 = tmp;
		                }
		                if (changes) {
		                    this.topLeft = new CellRef(r1, c1, rc1 | rr1);
		                    this.bottomRight = new CellRef(r2, c2, rc2 | rr2);
		                }
		            }
		            return this;
		        },
		        print: function(trow, tcol, mod) {
		            if (mod || this.absolute(trow, tcol).valid()) {
		                var ret = this.topLeft.print(trow, tcol, mod)
		                    + ":"
		                    + this.bottomRight.print(trow, tcol, mod);
		                if (this.hasSheet()) {
		                    ret = displaySheet(this.sheet)
		                        + (this.endSheet ? ":" + displaySheet(this.endSheet) : "")
		                        + "!" + ret;
		                }
		                return ret;
		            }
		            return "#REF!";
		        },
		        absolute: function(arow, acol) {
		            return new RangeRef(
		                this.topLeft.absolute(arow, acol),
		                this.bottomRight.absolute(arow, acol)
		            ).setSheet(this.sheet, this.hasSheet());
		        },
		        relative: function(arow, acol, relTL, relBR) {
		            if (relBR == null) {
		                relBR = relTL;
		            }
		            return new RangeRef(
		                this.topLeft.relative(arow, acol, relTL),
		                this.bottomRight.relative(arow, acol, relBR)
		            ).setSheet(this.sheet, this.hasSheet());
		        },
		        height: function() {
		            if (this.topLeft.rel != this.bottomRight.rel) {
		                throw new Error("Mixed relative/absolute references");
		            }
		            return this.bottomRight.row - this.topLeft.row + 1;
		        },
		        width: function() {
		            if (this.topLeft.rel != this.bottomRight.rel) {
		                throw new Error("Mixed relative/absolute references");
		            }
		            return this.bottomRight.col - this.topLeft.col + 1;
		        },
		        collapse: function() {
		            return this.topLeft.toRangeRef();
		        },
		        leftColumn: function() {
		            return new RangeRef(this.topLeft, new CellRef(this.bottomRight.row, this.topLeft.col));
		        },
		        rightColumn: function() {
		            return new RangeRef(new CellRef(this.topLeft.row, this.bottomRight.col), this.bottomRight);
		        },
		        topRow: function() {
		            return new RangeRef(this.topLeft, new CellRef(this.topLeft.row, this.bottomRight.col));
		        },
		        bottomRow: function() {
		            return new RangeRef(new CellRef(this.bottomRight.row, this.topLeft.col), this.bottomRight);
		        },
		        toRangeRef: function() {
		            return this;
		        },
		        toRow: function(row) {
		            row += Math.max(0, this.topLeft.row);
		            return new RangeRef(
		                new CellRef(row, this.topLeft.col),
		                new CellRef(row, this.bottomRight.col)
		            ).setSheet(this.sheet, this.hasSheet());
		        },
		        toColumn: function(col) {
		            col += Math.max(0, this.topLeft.col);
		            return new RangeRef(
		                new CellRef(this.topLeft.row, col),
		                new CellRef(this.bottomRight.row, col)
		            ).setSheet(this.sheet, this.hasSheet());
		        },
		        toCell: function(row, col) {
		            row += Math.max(0, this.topLeft.row);
		            col += Math.max(0, this.topLeft.col);
		            return new CellRef(row, col, 0)
		                .setSheet(this.sheet, this.hasSheet());
		        },
		        forEachRow: function(callback) {
		            var startRow = this.topLeft.row;
		            var endRow = this.bottomRight.row;
		            var startCol = this.topLeft.col;
		            var endCol = this.bottomRight.col;
	
		            for (var i = startRow; i <= endRow; i++) {
		                callback(new RangeRef(
		                    new CellRef(i, startCol),
		                    new CellRef(i, endCol)
		                ));
		            }
		        },
		        forEachColumn: function(callback) {
		            var startRow = this.topLeft.row;
		            var endRow = this.bottomRight.row;
		            var startCol = this.topLeft.col;
		            var endCol = this.bottomRight.col;
	
		            for (var i = startCol; i <= endCol; i++) {
		                callback(new RangeRef(
		                    new CellRef(startRow, i),
		                    new CellRef(endRow, i)
		                ));
		            }
		        },
		        intersecting: function(refs) {
		            return refs.filter(function(ref) {
		                return ref.toRangeRef().intersects(this);
		            }, this);
		        },
	
		        union: function(refs, callback) {
		            var intersecting = this.intersecting(refs);
	
		            var topLeftRow = this.topLeft.row;
		            var topLeftCol = this.topLeft.col;
		            var bottomRightRow = this.bottomRight.row;
		            var bottomRightCol = this.bottomRight.col;
	
		            var modified = false;
	
		            intersecting.forEach(function(ref) {
		                ref = ref.toRangeRef();
		                if (ref.topLeft.row < topLeftRow) {
		                    modified = true;
		                    topLeftRow = ref.topLeft.row;
		                }
	
		                if (ref.topLeft.col < topLeftCol) {
		                    modified = true;
		                    topLeftCol = ref.topLeft.col;
		                }
	
		                if (ref.bottomRight.row > bottomRightRow) {
		                    modified = true;
		                    bottomRightRow = ref.bottomRight.row;
		                }
	
		                if (ref.bottomRight.col > bottomRightCol) {
		                    modified = true;
		                    bottomRightCol = ref.bottomRight.col;
		                }
	
		                if (callback) {
		                    callback(ref);
		                }
		            });
	
		            var result = new RangeRef(
		                new CellRef(topLeftRow, topLeftCol),
		                new CellRef(bottomRightRow, bottomRightCol)
		            );
	
		            if (modified) {
		                return result.union(refs, callback);
		            } else {
		                return result;
		            }
		        },
		        resize: function(options) {
		            var limit = Math.max.bind(Math, 0);
		            function num(value) { return value || 0; }
	
		            var top = this.topLeft.row + num(options.top);
		            var left = this.topLeft.col + num(options.left);
		            var bottom = this.bottomRight.row + num(options.bottom);
		            var right = this.bottomRight.col + num(options.right);
	
		            if (left < 0 && right < 0 || top < 0 && bottom < 0) {
		                return NULL;
		            } else if (top <= bottom && left <= right) {
		                return new RangeRef(new CellRef(limit(top), limit(left)),
		                                    new CellRef(limit(bottom), limit(right)));
		            } else {
		                return NULL;
		            }
		        },
		        move: function(rows, cols) {
		            return new RangeRef(
		                new CellRef(this.topLeft.row + rows,
		                            this.topLeft.col + cols),
		                new CellRef(this.bottomRight.row + rows,
		                            this.bottomRight.col + cols)
		            );
		        },
		        first: function() {
		            return this.topLeft.clone().setSheet(this.sheet, this.hasSheet());
		        },
		        isCell: function() {
		            return !this.endSheet && this.topLeft.eq(this.bottomRight);
		        },
		        toString: function() {
		            return this.topLeft + ":" + this.bottomRight;
		        },
		        adjust: function(row, col, trow, tcol, forRow, start, delta) {
		            var tl = this.topLeft.adjust(row, col, trow, tcol, forRow, start, delta);
		            var tr = this.bottomRight.adjust(row, col, trow, tcol, forRow, start, delta);
		            if (tl === NULL && tr === NULL) {
		                return NULL;
		            }
		            if (tl === NULL) {
		                tl = this.topLeft.absolute(row, col);
		                if (forRow) {
		                    tl.row = start;
		                } else {
		                    tl.col = start;
		                }
		                if (trow != null && tcol != null) {
		                    tl = tl.relative(trow, tcol, this.topLeft.rel);
		                }
		            }
		            else if (tr === NULL) {
		                tr = this.bottomRight.absolute(row, col);
		                if (forRow) {
		                    tr.row = start - 1;
		                } else {
		                    tr.col = start - 1;
		                }
		                if (trow != null && tcol != null) {
		                    tr = tr.relative(trow, tcol, this.bottomRight.rel);
		                }
		            }
		            return new RangeRef(tl, tr)
		                .setSheet(this.sheet, this.hasSheet())
		                .simplify();
		        },
		        valid: function() {
		            return this.topLeft.valid() && this.bottomRight.valid();
		        }
		    });
	
		    /* -----[ Union reference ]----- */
	
		    var UnionRef = Ref.extend({
		        init: function UnionRef(refs){
		            this.refs = refs;
		            this.length = refs.length;
		        },
		        clone: function() {
		            return new UnionRef(this.refs.slice());
		        },
		        intersect: function(ref) {
		            var a = [];
		            for (var i = 0; i < this.length; ++i) {
		                var x = ref.intersect(this.refs[i]);
		                if (x !== NULL) {
		                    a.push(x);
		                }
		            }
		            if (a.length > 0) {
		                return new UnionRef(a).simplify();
		            }
		            return NULL;
		        },
		        simplify: function() {
		            var u = new UnionRef(this.refs.reduce(function(a, ref){
		                ref = ref.simplify();
		                if (ref !== NULL) {
		                    a.push(ref);
		                }
		                return a;
		            }, []));
		            if (u.empty()) {
		                return NULL;
		            }
		            if (u.single()) {
		                return u.refs[0];
		            }
		            return u;
		        },
		        absolute: function(arow, acol) {
		            return new UnionRef(this.refs.map(function(ref){
		                return ref.absolute(arow, acol);
		            }));
		        },
		        forEach: function(callback, obj) {
		            this.refs.forEach(function(ref){
		                if (ref instanceof UnionRef) {
		                    ref.forEach(callback, obj);
		                } else {
		                    callback.call(obj, ref);
		                }
		            }, obj);
		        },
		        toRangeRef: function() {
		            return this.refs[0].toRangeRef();
		        },
		        contains: function(theRef) {
		            return this.refs.some(function(ref) { return ref.contains(theRef); });
		        },
		        map: function(callback, obj) {
		            var refs = [];
		            this.forEach(function(ref){
		                refs.push(callback.call(obj, ref));
		            });
		            return new UnionRef(refs);
		        },
		        first: function() {
		            return this.refs[0].first();
		        },
		        lastRange: function() {
		            return this.refs[this.length - 1];
		        },
		        size: function() {
		            return this.length;
		        },
		        single: function() {
		            return this.length == 1;
		        },
		        empty: function() {
		            return this.length === 0;
		        },
		        isCell: function() {
		            return this.single() && this.refs[0].isCell();
		        },
		        rangeAt: function(index) {
		            return this.refs[index];
		        },
		        nextRangeIndex: function(index) {
		            if (index === this.length - 1) {
		                return 0;
		            } else {
		                return index + 1;
		            }
		        },
		        previousRangeIndex: function(index) {
		            if (index === 0) {
		                return this.length - 1;
		            } else {
		                return index - 1;
		            }
		        },
		        concat: function(ref) {
		            return new UnionRef(this.refs.concat([ref]));
		        },
		        print: function(row, col, mod) {
		            return this.refs.map(function(ref) { return ref.print(row, col, mod); }).join(",");
		        },
	
		        replaceAt: function(index, ref) {
		            var newRefs = this.refs.slice();
		            newRefs.splice(index, 1, ref);
		            return new UnionRef(newRefs);
		        },
	
		        leftColumn: function() {
		            return this.map(function(ref) {
		                return ref.leftColumn();
		            });
		        },
		        rightColumn: function() {
		            return this.map(function(ref) {
		                return ref.rightColumn();
		            });
		        },
		        topRow: function() {
		            return this.map(function(ref) {
		                return ref.topRow();
		            });
		        },
		        bottomRow: function() {
		            return this.map(function(ref) {
		                return ref.bottomRow();
		            });
		        },
		        forEachRow: function(callback) {
		            this.forEach(function(ref) {
		                ref.forEachRow(callback);
		            });
		        },
		        forEachColumn: function(callback) {
		            this.forEach(function(ref) {
		                ref.forEachColumn(callback);
		            });
		        },
		        adjust: function(row, col, trow, tcol, forRow, start, delta) {
		            return this.map(function(ref){
		                return ref.adjust(row, col, trow, tcol, forRow, start, delta);
		            }).simplify();
		        },
		        toString: function() {
		            return this.refs.map(function(ref){
		                return ref.toString();
		            }).join(", ");
		        },
		        valid: function() {
		            for (var i = this.refs.length; --i >= 0;) {
		                if (this.refs[i].valid()) {
		                    return false;
		                }
		            }
		            return true;
		        },
		        renameSheet: function(oldSheetName, newSheetName) {
		            this.refs.forEach(function(ref){
		                ref.renameSheet(oldSheetName, newSheetName);
		            });
		        }
		    });
	
		    /* -----[ exports ]----- */
	
		    spreadsheet.NULLREF = NULL;
		    spreadsheet.SHEETREF = new RangeRef(new CellRef(0, 0), new CellRef(Infinity, Infinity));
		    spreadsheet.FIRSTREF = new CellRef(0, 0);
		    spreadsheet.Ref = Ref;
		    spreadsheet.NameRef = NameRef;
		    spreadsheet.CellRef = CellRef;
		    spreadsheet.RangeRef = RangeRef;
		    spreadsheet.UnionRef = UnionRef;
	
		    spreadsheet.SHEETREF.print = function() {
		        return "#SHEET";
		    };
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1483);
		module.exports = __webpack_require__(1483);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1483:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19),  __webpack_require__(1484) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var RangeRef = kendo.spreadsheet.RangeRef;
		    var CellRef = kendo.spreadsheet.CellRef;
	
		    var EdgeNavigator = kendo.Class.extend({
		        init: function(field, axis, rangeGetter, union) {
		            this.rangeGetter = rangeGetter;
	
		            this.prevLeft = function(index) {
		                var current = union(this.range(index));
		                var range = this.range(axis.prevVisible(current.topLeft[field]));
		                return union(range).topLeft[field];
		            };
	
		            this.nextRight = function(index) {
		                var current = union(this.range(index));
		                var range = this.range(axis.nextVisible(current.bottomRight[field]));
		                return union(range).bottomRight[field];
		            };
	
		            // these two don't look like the other ones, as they "shrink"
		            this.nextLeft = function(index) {
		                var range = union(this.range(index));
		                return axis.nextVisible(range.bottomRight[field]);
		            };
	
		            this.prevRight = function(index) {
		                var range = union(this.range(index));
		                return axis.prevVisible(range.topLeft[field]);
		            };
		        },
	
		        boundary: function(top, bottom) {
		            this.top = top;
		            this.bottom = bottom;
		        },
	
		        range: function(index) {
		            return this.rangeGetter(index, this.top, this.bottom);
		        }
		    });
	
		    var SheetNavigator = kendo.Class.extend({
		        init: function(sheet) {
		            this._sheet = sheet;
		            this.columns = this._sheet._grid._columns;
		            this.autoFillCalculator = new kendo.spreadsheet.AutoFillCalculator(sheet._grid);
	
		            this.colEdge = new EdgeNavigator("col", this._sheet._grid._columns, this.columnRange.bind(this), this.union.bind(this));
		            this.rowEdge = new EdgeNavigator("row", this._sheet._grid._rows, this.rowRange.bind(this), this.union.bind(this));
		        },
	
		        height: function(height) {
		            this._viewPortHeight = height;
		        },
	
		        union: function(ref) {
		            return this._sheet.unionWithMerged(ref);
		        },
	
		        columnRange: function(col, topRow, bottomRow) {
		            return this._sheet._ref(topRow, col, bottomRow - topRow, 1);
		        },
	
		        rowRange: function(row, leftCol, rightCol) {
		            return this._sheet._ref(row, leftCol, 1, rightCol - leftCol);
		        },
	
		        selectionIncludesMergedCells: function() {
		            return this._sheet.select().contains(this._sheet._mergedCells);
		        },
	
		        setSelectionValue: function(value) {
		            var selection = this._sheet.selection();
	
		            setTimeout(function() {
		                selection.value(value());
		            });
		        },
	
		        selectAll: function() {
		            this._sheet.select(this._sheet._sheetRef);
		        },
	
		        select: function(ref, mode, addToExisting) {
		            ref = this.refForMode(ref, mode);
	
		            if (addToExisting) {
		                ref = this._sheet.select().concat(ref);
		            }
	
		            this._sheet.select(ref);
		        },
	
		        refForMode: function(ref, mode) {
		            var grid = this._sheet._grid;
	
		            switch(mode) {
		                case "range":
		                    ref = grid.normalize(ref);
		                    break;
		                case "row":
		                    ref = grid.rowRef(ref.row);
		                    break;
		                case "column":
		                    ref = grid.colRef(ref.col);
		                    break;
		                case "sheet":
		                    ref = this._sheet._sheetRef;
		                    break;
		            }
	
		            return ref;
		        },
	
		        startSelection: function(ref, mode, addToExisting, shiftKey) {
		            if (mode == "autofill") {
		                this._sheet.startAutoFill();
		            } else if (shiftKey && mode == "range") {
		                var range = new RangeRef(this._sheet.activeCell().first(), ref);
		                this._sheet.select(range, false, false);
		                this._sheet.startSelection();
		            } else {
		                this._sheet.startSelection();
		                this.select(ref, mode, addToExisting);
		            }
		        },
	
		        completeSelection: function() {
		            this._sheet.completeSelection();
		        },
	
		        selectForContextMenu: function(ref, mode) {
		            var sheet = this._sheet;
	
		            if (!sheet.select().contains(this.refForMode(ref, mode))) {
		                this.select(ref, mode);
		            }
		        },
	
		        modifySelection: function(action) {
		            var direction = this.determineDirection(action);
	
		            var sheet = this._sheet;
		            var viewPortHeight = this._viewPortHeight;
		            var rows = sheet._grid._rows;
		            var columns = sheet._grid._columns;
	
		            var originalSelection = sheet.currentOriginalSelectionRange();
		            var selection = sheet.select().toRangeRef();
		            var activeCell = sheet.activeCell();
	
		            var topLeft = originalSelection.topLeft.clone();
		            var bottomRight = originalSelection.bottomRight.clone();
	
		            var scrollInto;
	
		            this.colEdge.boundary(selection.topLeft.row, selection.bottomRight.row);
		            this.rowEdge.boundary(selection.topLeft.col, selection.bottomRight.col);
	
		            switch (direction) {
		                case "expand-left": // <| |
		                    topLeft.col = this.colEdge.prevLeft(topLeft.col);
		                    scrollInto = topLeft;
		                    break;
		                case "shrink-right": // |>|
		                    topLeft.col = this.colEdge.nextLeft(topLeft.col);
		                    scrollInto = topLeft;
		                    break;
		                case "expand-right": // | |>
		                    bottomRight.col = this.colEdge.nextRight(bottomRight.col);
		                    scrollInto = bottomRight;
		                    break;
		                case "shrink-left": // |<|
		                    bottomRight.col = this.colEdge.prevRight(bottomRight.col);
		                    scrollInto = bottomRight;
		                    break;
	
		                // four actions below mirror the upper ones, on the vertical axis
		                case "expand-up":
		                    topLeft.row = this.rowEdge.prevLeft(topLeft.row);
		                    scrollInto = topLeft;
		                    break;
		                case "shrink-down":
		                    topLeft.row = this.rowEdge.nextLeft(topLeft.row);
		                    scrollInto = topLeft;
		                    break;
		                case "expand-down":
		                    bottomRight.row = this.rowEdge.nextRight(bottomRight.row);
		                    scrollInto = bottomRight;
		                    break;
		                case "shrink-up":
		                    bottomRight.row = this.rowEdge.prevRight(bottomRight.row);
		                    scrollInto = bottomRight;
		                    break;
	
		                // pageup/down - may need improvement
		                case "expand-page-up":
		                    topLeft.row = rows.prevPage(topLeft.row, viewPortHeight);
		                    break;
		                case "shrink-page-up":
		                    bottomRight.row = rows.prevPage(bottomRight.row, viewPortHeight);
		                    break;
		                case "expand-page-down":
		                    bottomRight.row = rows.nextPage(bottomRight.row, viewPortHeight);
		                    break;
		                case "shrink-page-down":
		                    topLeft.row = rows.nextPage(topLeft.row, viewPortHeight);
		                    break;
	
		                case "first-col":
		                    topLeft.col = columns.firstVisible();
		                    bottomRight.col = activeCell.bottomRight.col;
		                    scrollInto = topLeft;
		                    break;
		                case "last-col":
		                    bottomRight.col = columns.lastVisible();
		                    topLeft.col = activeCell.topLeft.col;
		                    scrollInto = bottomRight;
		                    break;
		                case "first-row":
		                    topLeft.row = rows.firstVisible();
		                    bottomRight.row = activeCell.bottomRight.row;
		                    scrollInto = topLeft;
		                    break;
		                case "last-row":
		                    bottomRight.row = rows.lastVisible();
		                    topLeft.row = activeCell.topLeft.row;
		                    scrollInto = bottomRight;
		                    break;
		                case "last":
		                    bottomRight.row = rows.lastVisible();
		                    bottomRight.col = columns.lastVisible();
		                    topLeft = activeCell.topLeft;
		                    scrollInto = bottomRight;
		                    break;
		                case "first":
		                    topLeft.row = rows.firstVisible();
		                    topLeft.col = columns.firstVisible();
		                    bottomRight = activeCell.bottomRight;
		                    scrollInto = topLeft;
		                    break;
		            }
	
		            var newSelection = new RangeRef(topLeft, bottomRight);
	
		            if (!this.union(newSelection).intersects(activeCell)) {
		                // throw new Error(newSelection.print() + " does not contain " + activeCell.print());
		                this.modifySelection(direction.replace("shrink", "expand"));
		                return;
		            }
	
		            if (scrollInto) {
		                sheet.focus(scrollInto);
		            }
	
		            this.updateCurrentSelectionRange(newSelection);
		        },
	
		        moveActiveCell: function(direction) {
		            var sheet = this._sheet;
		            var activeCell = sheet.activeCell();
		            var topLeft = activeCell.topLeft;
		            var bottomRight = activeCell.bottomRight;
	
		            var cell = sheet.originalActiveCell();
		            var rows = sheet._grid._rows;
		            var columns = sheet._grid._columns;
	
		            var row = cell.row;
		            var column = cell.col;
	
		            switch (direction) {
		                case "left":
		                    column = columns.prevVisible(topLeft.col);
		                    break;
		                case "up":
		                    row = rows.prevVisible(topLeft.row);
		                    break;
		                case "right":
		                    column = columns.nextVisible(bottomRight.col);
		                    break;
		                case "down":
		                    row = rows.nextVisible(bottomRight.row);
		                    break;
		                case "first-col":
		                    column = columns.firstVisible();
		                    break;
		                case "last-col":
		                    column = columns.lastVisible();
		                    break;
		                case "first-row":
		                    row = rows.firstVisible();
		                    break;
		                case "last-row":
		                    row = rows.lastVisible();
		                    break;
		                case "last":
		                    row = rows.lastVisible();
		                    column = columns.lastVisible();
		                    break;
		                case "first":
		                    row = rows.firstVisible();
		                    column = columns.firstVisible();
		                    break;
		                case "next-page":
		                    row = rows.nextPage(bottomRight.row, this._viewPortHeight);
		                    break;
		                case "prev-page":
		                    row = rows.prevPage(bottomRight.row, this._viewPortHeight);
		                    break;
	
		            }
	
		            sheet.select(new CellRef(row, column));
		        },
	
		        navigateInSelection: function(direction) {
		            var sheet = this._sheet;
		            var activeCell = sheet.activeCell();
		            var topLeft = activeCell.topLeft;
	
		            var cell = sheet.originalActiveCell();
		            var rows = sheet._grid._rows;
		            var columns = sheet._grid._columns;
	
		            var row = cell.row;
		            var column = cell.col;
	
		            var selTopLeft, selBottomRight;
	
		            var topLeftCol = topLeft.col;
		            var topLeftRow = topLeft.row;
		            var tmp;
	
		            function setSelection(sel) {
		                selTopLeft = sel.topLeft;
		                selBottomRight = sel.bottomRight;
		            }
	
		            setSelection(sheet.currentNavigationRange());
	
		            var done = false;
		            while (!done) {
		                var current = new CellRef(row, column);
	
		                switch (direction) {
		                    case "next":
		                        if (selBottomRight.eq(current)) {
		                            setSelection(sheet.nextNavigationRange());
		                            row = selTopLeft.row;
		                            column = selTopLeft.col;
		                        } else {
		                            column = columns.nextVisible(topLeftCol);
		                            if (column == topLeftCol || column > selBottomRight.col) {
		                                column = selTopLeft.col;
		                                tmp = rows.nextVisible(row);
		                                if (tmp == row || tmp > selBottomRight.row) {
		                                    row = selTopLeft.row;
		                                } else {
		                                    row = tmp;
		                                }
		                            }
		                        }
		                        break;
		                    case "previous":
		                        if (selTopLeft.eq(current)) {
		                            setSelection(sheet.previousNavigationRange());
		                            row = selBottomRight.row;
		                            column = selBottomRight.col;
		                        } else {
		                            column = columns.prevVisible(topLeftCol);
		                            if (column == topLeftCol || column < selTopLeft.col) {
		                                column = selBottomRight.col;
		                                tmp = rows.prevVisible(row);
		                                if (tmp == row || tmp < selTopLeft.row) {
		                                    row = selBottomRight.row;
		                                } else {
		                                    row = tmp;
		                                }
		                            }
		                        }
		                        break;
		                    case "lower":
		                        if (selBottomRight.eq(current)) {
		                            setSelection(sheet.nextNavigationRange());
		                            row = selTopLeft.row;
		                            column = selTopLeft.col;
		                        } else {
		                            row = rows.nextVisible(topLeftRow);
		                            if (row == topLeftRow || row > selBottomRight.row) {
		                                row = selTopLeft.row;
		                                tmp = columns.nextVisible(column);
		                                if (tmp == column || tmp > selBottomRight.col) {
		                                    column = selTopLeft.col;
		                                } else {
		                                    column = tmp;
		                                }
		                            }
		                        }
		                        break;
		                    case "upper":
		                        if (selTopLeft.eq(current)) {
		                            setSelection(sheet.previousNavigationRange());
		                            row = selBottomRight.row;
		                            column = selBottomRight.col;
		                        } else {
		                            row = rows.prevVisible(topLeftRow);
		                            if (row == topLeftRow || row < selTopLeft.row) {
		                                row = selBottomRight.row;
		                                tmp = columns.prevVisible(column);
		                                if (tmp == column || tmp < selTopLeft.col) {
		                                    column = selBottomRight.col;
		                                } else {
		                                    column = tmp;
		                                }
		                            }
		                        }
		                        break;
		                    default:
		                        throw new Error("Unknown entry navigation: " + direction);
		                }
	
		                done = !this.shouldSkip(row, column);
		                // if (!done) { console.log("skipping", row, column); }
		                topLeftCol = column;
		                topLeftRow = row;
		            }
	
		            if (sheet.singleCellSelection()) {
		                sheet.select(new CellRef(row, column));
		            } else {
		                sheet.activeCell(new CellRef(row, column));
		            }
		        },
	
		        extendSelection: function(ref, mode) {
		            var sheet = this._sheet;
		            var grid = sheet._grid;
	
		            if (mode === "autofill") {
		               this.resizeAutoFill(ref);
		               return;
		            }
		            if (mode === "range") {
		                ref = grid.normalize(ref);
		            }
		            else if (mode === "row") {
		                ref = grid.rowRef(ref.row).bottomRight;
		            } else if (mode === "column") {
		                ref = grid.colRef(ref.col).bottomRight;
		            }
	
		            var activeCell = sheet.originalActiveCell().toRangeRef();
	
		            this.updateCurrentSelectionRange(new RangeRef(activeCell.topLeft, ref));
		        },
	
		        shouldSkip: function(row, col) {
		            if (this._sheet.isHiddenRow(row) || this._sheet.isHiddenColumn(col)) {
		                return true;
		            }
		            var ref = new CellRef(row, col);
		            var isMerged = false;
		            this._sheet.forEachMergedCell(function(merged) {
		                if (merged.intersects(ref) && !merged.collapse().eq(ref)) {
		                    isMerged = true;
		                }
		            });
	
		            return isMerged;
		        },
	
		        resizeAutoFill: function(ref) {
		            var sheet = this._sheet;
		            var selection = sheet.select();
		            var origin = sheet._autoFillOrigin;
		            var dest = this.autoFillCalculator.autoFillDest(selection, ref);
	
		            var punch = this.punch(selection, dest);
		            var hint, direction, row;
	
		            if (!punch) {
		                var preview = sheet.range(dest)._previewFillFrom(sheet.range(origin));
	
		                if (preview) {
		                    direction = preview.direction;
		                    var props = preview.props;
	
		                    if (direction === 0 || direction == 1) {
		                        row = props[props.length - 1];
		                        hint = row[row.length - 1].value;
		                    } else if (direction === 2) {
		                        row = props[0];
		                        hint = row[row.length - 1].value;
		                    } else if (direction === 3) {
		                        row = props[props.length - 1];
		                        hint = row[0].value;
		                    }
		                }
		            }
	
		            sheet.updateAutoFill(dest, punch, hint, direction);
		        },
	
		        determineDirection: function(action) {
		            var selection = this._sheet.currentSelectionRange();
		            var activeCell = this._sheet.activeCell();
	
		            // There may be a third, indeterminate state, caused by a merged cell.
		            // In this state, all key movements are treated as shrinks.
		            // The navigator will reverse them if it detects this it will cause the selection to exclude the active cell.
		            var leftMode = activeCell.topLeft.col == selection.topLeft.col;
		            var rightMode = activeCell.bottomRight.col == selection.bottomRight.col;
		            var topMode = activeCell.topLeft.row == selection.topLeft.row;
		            var bottomMode = activeCell.bottomRight.row == selection.bottomRight.row;
	
		            switch(action) {
		                case "left":
		                    action = rightMode ? "expand-left" : "shrink-left";
		                    break;
		                case "right":
		                    action = leftMode ? "expand-right" : "shrink-right";
		                    break;
		                case "up":
		                    action = bottomMode ? "expand-up" : "shrink-up";
		                    break;
		                case "down":
		                    action = topMode ? "expand-down" : "shrink-down";
		                    break;
		                case "prev-page":
		                    action = bottomMode ? "expand-page-up" : "shrink-page-up";
		                    break;
		                case "next-page":
		                    action = topMode ? "expand-page-down" : "shrink-page-down";
		                    break;
		            }
	
		            return action;
		        },
	
		        updateCurrentSelectionRange: function(ref) {
		            var sheet = this._sheet;
		            sheet.select(sheet.originalSelect().replaceAt(sheet.selectionRangeIndex(), ref), false);
		        },
	
		        punch: function(selection, subset) {
		            var punch;
		            if (subset.topLeft.eq(selection.topLeft)) {
		                if (subset.bottomRight.row < selection.bottomRight.row) {
		                    var bottomRow = this.rowEdge.nextRight(subset.bottomRight.row);
	
		                    punch = new RangeRef(
		                        new CellRef(bottomRow, selection.topLeft.col),
		                        selection.bottomRight
		                    );
		                } else if (subset.bottomRight.col < selection.bottomRight.col) {
		                    var bottomCol = this.colEdge.nextRight(subset.bottomRight.col);
	
		                    punch = new RangeRef(
		                        new CellRef(selection.topLeft.row, bottomCol),
		                        selection.bottomRight
		                    );
		                }
		            }
	
		            return punch;
		        }
		    });
	
		    kendo.spreadsheet.SheetNavigator = SheetNavigator;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1484:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(710);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1451);
		module.exports = __webpack_require__(1451);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1451:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var RangeRef = kendo.spreadsheet.RangeRef;
		    var CellRef = kendo.spreadsheet.CellRef;
	
		    var AutoFillCalculator = kendo.Class.extend({
		        init: function(grid) {
		            this._grid = grid;
		        },
	
		        rectIsVertical: function(start, end, x, y) {
		            var startRect = this._grid.rectangle(start.toRangeRef());
		            var endRect = this._grid.rectangle(end.toRangeRef());
		            return Math.abs(endRect[y] - startRect[y]) > Math.abs(startRect[x] - endRect[x]);
		        },
	
		        autoFillDest: function(selection, cursor) {
		            var topLeft = selection.topLeft;
		            var bottomRight = selection.bottomRight;
	
		            var quadrant;
		            var lower = cursor.row >= topLeft.row;
		            var further = cursor.col >= topLeft.col;
	
		            if (lower) {
		                quadrant = further ? 4 : 3;
		            } else {
		                quadrant = further ? 2 : 1;
		            }
	
		            var pivot, opposite, cornerResult, expanding;
	
		            if (quadrant === 4) {
		                pivot = topLeft;
		                opposite = bottomRight;
	
		                expanding = cursor.row > opposite.row || cursor.col > opposite.col;
	
		                if (expanding) {
		                    cursor = new CellRef(Math.max(cursor.row, opposite.row), Math.max(cursor.col, opposite.col));
		                }
	
		                if (this.rectIsVertical(opposite, cursor, 'right', 'bottom')) { // vertical
		                    cornerResult = new CellRef(cursor.row, opposite.col);
		                } else {
		                    cornerResult = new CellRef(opposite.row, cursor.col);
		                }
		            } else if (quadrant === 3) {
		                var bottomLeft = new CellRef(topLeft.col, bottomRight.row);
	
		                if (cursor.row > bottomRight.row && this.rectIsVertical(bottomLeft, cursor, 'left', 'bottom')) { // vertical
		                    pivot = topLeft;
		                    cornerResult = new CellRef(cursor.row, bottomRight.col);
		                } else {
		                    pivot = bottomRight;
		                    cornerResult = new CellRef(topLeft.row, cursor.col);
		                }
		            } else if (quadrant === 2){
		                var topRight = new CellRef(topLeft.row, bottomRight.col);
	
		                if (cursor.col > bottomRight.col && !this.rectIsVertical(topRight, cursor, 'right', 'top')) { // horizontal
		                    pivot = topLeft;
		                    cornerResult = new CellRef(bottomRight.row, cursor.col);
		                } else {
		                    pivot = bottomRight;
		                    cornerResult = new CellRef(cursor.row, topLeft.col);
		                }
		            } else {
		                pivot = bottomRight;
		                if (this.rectIsVertical(topLeft, cursor, 'left', 'top')) { // horizontal
		                    cornerResult = new CellRef(cursor.row, topLeft.col);
		                } else {
		                    cornerResult = new CellRef(topLeft.row, cursor.col);
		                }
		            }
	
		            return this._grid.normalize(new RangeRef(pivot, cornerResult));
		        }
		    });
	
		    kendo.spreadsheet.AutoFillCalculator = AutoFillCalculator;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1453);
		module.exports = __webpack_require__(1453);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1453:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var AxisManager = kendo.Class.extend({
		        init: function(sheet) {
		            this._sheet = sheet;
		        },
	
		        forEachSelectedColumn: function(callback) {
		            var sheet = this._sheet;
	
		            sheet.batch(function() {
		                sheet.select().forEachColumnIndex(function(index, i) {
		                    callback(sheet, index, i);
		                });
		            }, { layout: true, recalc: true });
		        },
	
		        forEachSelectedRow: function(callback) {
		            var sheet = this._sheet;
	
		            sheet.batch(function() {
		                sheet.select().forEachRowIndex(function(index, i) {
		                    callback(sheet, index, i);
		                });
		            }, { layout: true, recalc: true });
		        },
	
		        includesHiddenColumns: function(ref) {
		            return this._sheet._grid._columns.includesHidden(ref.topLeft.col, ref.bottomRight.col);
		        },
	
		        includesHiddenRows: function(ref) {
		            return this._sheet._grid._rows.includesHidden(ref.topLeft.row, ref.bottomRight.row);
		        },
	
		        selectionIncludesHiddenColumns: function() {
		            return this.includesHiddenColumns(this._sheet.select());
		        },
	
		        selectionIncludesHiddenRows: function() {
		            return this.includesHiddenRows(this._sheet.select());
		        },
	
		        deleteSelectedColumns: function() {
		            var indexes = [], delta = 0;
		            this.forEachSelectedColumn(function(sheet, index) {
		                index -= delta;
		                if (sheet.isHiddenColumn(index)) {
		                    return;
		                }
		                delta++;
		                var formulas = [];
		                indexes.unshift({
		                    index    : index,
		                    formulas : formulas,
		                    width    : sheet.columnWidth(index)
		                });
		                sheet._saveModifiedFormulas(formulas, function(){
		                    sheet.deleteColumn(index);
		                });
		            });
		            return indexes;
		        },
	
		        deleteSelectedRows: function() {
		            var indexes = [], delta = 0;
		            this.forEachSelectedRow(function(sheet, index) {
		                index -= delta;
		                if (sheet.isHiddenRow(index)) {
		                    return;
		                }
		                delta++;
		                var formulas = [];
		                indexes.unshift({
		                    index    : index,
		                    formulas : formulas,
		                    height   : sheet.rowHeight(index)
		                });
		                sheet._saveModifiedFormulas(formulas, function(){
		                    sheet.deleteRow(index);
		                });
		            });
		            return indexes;
		        },
	
		        hideSelectedColumns: function() {
		            this.forEachSelectedColumn(function(sheet, index) {
		                sheet.hideColumn(index);
		            });
		            var sheet = this._sheet;
		            var ref = sheet.select().toRangeRef();
		            var left = ref.topLeft.col;
		            var right = ref.bottomRight.col;
		            var sel = null;
		            while (true) {
		                var hasRight = right < sheet._columns._count;
		                var hasLeft = left >= 0;
		                if (!hasLeft && !hasRight) {
		                    break;
		                }
		                if (hasRight && !sheet.isHiddenColumn(right)) {
		                    sel = right;
		                    break;
		                }
		                if (hasLeft && !sheet.isHiddenColumn(left)) {
		                    sel = left;
		                    break;
		                }
		                left--;
		                right++;
		            }
		            if (sel !== null) {
		                ref = new kendo.spreadsheet.RangeRef(
		                    new kendo.spreadsheet.CellRef(0, sel),
		                    new kendo.spreadsheet.CellRef(sheet._rows._count - 1, sel)
		                );
		                sheet.range(ref).select();
		            }
		        },
	
		        hideSelectedRows: function() {
		            this.forEachSelectedRow(function(sheet, index) {
		                sheet.hideRow(index);
		            });
		            var sheet = this._sheet;
		            var ref = sheet.select().toRangeRef();
		            var top = ref.topLeft.row;
		            var bottom = ref.bottomRight.row;
		            var sel = null;
		            while (true) {
		                var hasBottom = bottom < sheet._rows._count;
		                var hasTop = top >= 0;
		                if (!hasTop && !hasBottom) {
		                    break;
		                }
		                if (hasBottom && !sheet.isHiddenRow(bottom)) {
		                    sel = bottom;
		                    break;
		                }
		                if (hasTop && !sheet.isHiddenRow(top)) {
		                    sel = top;
		                    break;
		                }
		                top--;
		                bottom++;
		            }
		            if (sel !== null) {
		                ref = new kendo.spreadsheet.RangeRef(
		                    new kendo.spreadsheet.CellRef(sel, 0),
		                    new kendo.spreadsheet.CellRef(sel, sheet._columns._count - 1)
		                );
		                sheet.range(ref).select();
		            }
		        },
	
		        unhideSelectedColumns: function() {
		            this.forEachSelectedColumn(function(sheet, index) {
		                sheet.unhideColumn(index);
		            });
		        },
	
		        unhideSelectedRows: function() {
		            this.forEachSelectedRow(function(sheet, index) {
		                sheet.unhideRow(index);
		            });
		        },
	
		        preventAddRow: function() {
		            var range = this._sheet.select().toRangeRef();
		            var rowCount = range.height();
		            return this._sheet.preventInsertRow(0, rowCount);
		        },
	
		        preventAddColumn: function() {
		            var range = this._sheet.select().toRangeRef();
		            var columnCount = range.width();
		            return this._sheet.preventInsertColumn(0, columnCount);
		        },
	
		        addColumnLeft: function() {
		            var sheet = this._sheet;
		            var base, count = 0;
		            sheet.batch(function(){
		                sheet.select().forEachColumnIndex(function(index) {
		                    if (!base) {
		                        base = index;
		                    }
		                    sheet.insertColumn(base);
		                    ++count;
		                });
		            }, { recalc: true, layout: true });
		            return { base: base, count: count };
		        },
	
		        addColumnRight: function() {
		            var sheet = this._sheet;
		            var base, count = 0;
		            sheet.batch(function(){
		                sheet.select().forEachColumnIndex(function(index) {
		                    base = index + 1;
		                    ++count;
		                });
		                for (var i = 0; i < count; ++i) {
		                    sheet.insertColumn(base);
		                }
		            }, { recalc: true, layout: true });
		            return { base: base, count: count };
		        },
	
		        addRowAbove: function() {
		            var sheet = this._sheet;
		            var base, count = 0;
		            sheet.batch(function(){
		                sheet.select().forEachRowIndex(function(index) {
		                    if (!base) {
		                        base = index;
		                    }
		                    sheet.insertRow(base);
		                    ++count;
		                });
		            }, { recalc: true, layout: true });
		            return { base: base, count: count };
		        },
	
		        addRowBelow: function() {
		            var sheet = this._sheet;
		            var base, count = 0;
		            sheet.batch(function(){
		                sheet.select().forEachRowIndex(function(index) {
		                    base = index + 1;
		                    ++count;
		                });
		                for (var i = 0; i < count; ++i) {
		                    sheet.insertRow(base);
		                }
		            }, { recalc: true, layout: true });
		            return { base: base, count: count };
		        }
		    });
	
		    kendo.spreadsheet.AxisManager = AxisManager;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1456);
		module.exports = __webpack_require__(1456);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1456:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
		    var CellRef = kendo.spreadsheet.CellRef;
	
		    var Clipboard = kendo.Class.extend({
		        init: function(workbook) {
		            this._content = {};
		            this._externalContent = {};
		            this._internalContent = {};
		            this.workbook = workbook;
		            this.origin = kendo.spreadsheet.NULLREF;
		            this.iframe = document.createElement("iframe");
		            this.iframe.className = "k-spreadsheet-clipboard-paste";
		            this.menuInvoked = false;
		            this._uid = kendo.guid();
		            document.body.appendChild(this.iframe);
		        },
	
		        destroy: function() {
		            document.body.removeChild(this.iframe);
		        },
	
		        canCopy: function() {
		            var status = {canCopy: true};
		            var selection = this.workbook.activeSheet().select();
		            if (selection === kendo.spreadsheet.NULLREF) {
		                status.canCopy = false;
		            }
		            if (selection instanceof kendo.spreadsheet.UnionRef) {
		                status.canCopy = false;
		                status.multiSelection = true;
		            }
		            if (this.menuInvoked) {
		                status.canCopy = false;
		                status.menuInvoked = true;
		            }
		            return status;
		        },
	
		        canPaste: function() {
		            var sheet = this.workbook.activeSheet();
		            var ref = this.pasteRef();
		            var range = sheet.range(ref);
		            var status = { canPaste: true, pasteOnMerged: false, pasteOnDisabled: false };
	
		            if (!range.enable()) {
		                status.canPaste =  false;
		                status.pasteOnDisabled = true;
		            }
		            if (!ref.eq(sheet.unionWithMerged(ref))) {
		                status.canPaste = false;
		                status.pasteOnMerged = true;
		            }
		            if (this.menuInvoked) {
		                status.canPaste = false;
		                status.menuInvoked = true;
		            }
		            if (ref.bottomRight.row >= sheet._rows._count || ref.bottomRight.col >= sheet._columns._count) {
		                status.canPaste = false;
		                status.overflow = true;
		            }
		            return status;
		        },
	
		        intersectsMerged: function() {
		            var sheet = this.workbook.activeSheet();
		            this.parse();
		            this.origin = this._content.origRef;
		            var ref = this.pasteRef();
		            return !ref.eq(sheet.unionWithMerged(ref));
		        },
	
		        copy: function() {
		            var sheet = this.workbook.activeSheet();
		            this.origin = sheet.select();
		            this._internalContent = sheet.selection().getState();
		            delete this._externalContent.html;
		            delete this._externalContent.plain;
		        },
	
		        cut: function() {
		            var sheet = this.workbook.activeSheet();
		            this.copy();
		            sheet.range(sheet.select()).clear();
		        },
	
		        pasteRef: function() {
		            var sheet = this.workbook.activeSheet();
	
		            // When pasting from an external source, origin will be
		            // NULLREF.  Just return the destination range.
		            // https://github.com/telerik/kendo-ui-core/issues/3486
		            if (this.origin === kendo.spreadsheet.NULLREF) {
		                return sheet.select();
		            }
	
		            var destination = sheet.activeCell().first();
		            var originActiveCell = this.origin.first();
		            var rowDelta = originActiveCell.row - destination.row;
		            var colDelta = originActiveCell.col - destination.col;
	
		            return this.origin.relative(rowDelta, colDelta, 3);
		        },
	
		        paste: function() {
		            var sheet = this.workbook.activeSheet();
		            var pasteRef = this.pasteRef();
		            sheet.range(pasteRef).setState(this._content, this);
		            sheet.triggerChange({ recalc: true, ref: pasteRef });
		        },
	
		        external: function(data) {
		            if (data && (data.html || data.plain)) {
		                this._externalContent = data;
		            } else {
		                return this._externalContent;
		            }
		        },
	
		        isExternal: function() {
		            return !this._isInternal();
		        },
	
		        parse: function() {
		            var state = newState();
	
		            if (this._isInternal()) {
		                state = this._internalContent;
		            } else {
		                var data = this._externalContent;
		                if (data.html) {
		                    var doc = this.iframe.contentWindow.document;
		                    doc.open();
		                    doc.write(data.html);
		                    doc.close();
		                    var table = doc.querySelector("table");
		                    if (table) {
		                        state = parseHTML(table);
		                    } else {
		                        state = parseTSV(data.plain);
		                    }
		                } else {
		                    state = parseTSV(data.plain);
		                }
		                this.origin = state.origRef;
		            }
	
		            this._content = state;
		        },
	
		        _isInternal: function() {
		            if (this._externalContent.html === undefined) {
		                return true;
		            }
		            var internalHTML = $("<div/>").html(this._externalContent.html).find("table.kendo-clipboard-"+ this._uid).length ? true : false;
		            var internalPlain = $("<div/>").html(this._externalContent.plain).find("table.kendo-clipboard-"+ this._uid).length ? true : false;
		            return (internalHTML || internalPlain);
		        }
		    });
		    kendo.spreadsheet.Clipboard = Clipboard;
	
		    function newState() {
		        var ref = new CellRef(0, 0, 0);
		        return {
		            ref         : ref,
		            mergedCells : [],
		            data        : [],
		            foreign     : true,
		            origRef     : ref.toRangeRef()
		        };
		    }
	
		    function setStateData(state, row, col, value) {
		        var data = state.data || (state.data = []);
		        if (!data[row]) {
		            data[row] = [];
		        }
		        data[row][col] = value;
		        var br = state.origRef.bottomRight;
		        br.row = Math.max(br.row, row);
		        br.col = Math.max(br.col, col);
		    }
	
		    function stripStyle(style) {
		        return style.replace(/^-(?:ms|moz|webkit)-/, "");
		    }
	
		    function borderObject(styles) {
		        var obj = {};
		        [
		            "borderBottom",
		            "borderRight",
		            "borderLeft",
		            "borderTop"
		        ].forEach(function(key) {
		            obj[key] = styles[key + "Style"] == "none" ? null : {
		                size: 1,
		                color: styles[key + "Color"]
		            };
		        });
		        return obj;
		    }
	
		    function cellState(row, col, element, hBorders, vBorders) {
		        var styles = window.getComputedStyle(element);
		        var text = element.innerText;
		        var borders = borderObject(styles);
		        var state = {
		            value: text === "" ? null : text,
	
		            borderTop    : borders.borderTop    || hBorders.get(row, col)     || null,
		            borderBottom : borders.borderBottom || hBorders.get(row + 1, col) || null,
		            borderLeft   : borders.borderLeft   || vBorders.get(row, col)     || null,
		            borderRight  : borders.borderRight  || vBorders.get(row, col + 1) || null,
	
		            fontSize : parseInt(styles["font-size"], 10)
		        };
	
		        hBorders.set(row, col, state.borderTop);
		        hBorders.set(row + 1, col, state.borderBottom);
		        vBorders.set(row, col, state.borderLeft);
		        vBorders.set(row, col + 1, state.borderRight);
	
		        if (styles["background-color"] !== "rgb(0, 0, 0)" && styles["background-color"] !== "rgba(0, 0, 0, 0)") {
		            state.background = styles["background-color"];
		        }
		        if (styles.color !== "rgb(0, 0, 0)" && styles.color !== "rgba(0, 0, 0, 0)") {
		            state.color = styles.color;
		        }
		        if (styles["text-decoration"] == "underline") {
		            state.underline = true;
		        }
		        if (styles["font-style"] == "italic") {
		            state.italic = true;
		        }
		        if (styles["font-weight"] == "bold") {
		            state.bold = true;
		        }
		        if (stripStyle(styles["text-align"]) !== "right") {
		            state.textAlign = stripStyle(styles["text-align"]);
		        }
		        if (styles["vertical-align"] !== "middle") {
		            state.verticalAlign = styles["vertical-align"];
		        }
		        if (styles["word-wrap"] !== "normal" ) {
		            state.wrap = true;
		        }
	
		        return state;
		    }
	
		    function parseHTML(table) {
		        var state = newState();
	
		        var done = [], row = 0, col = 0;
		        for (var i = 0; i < table.rows.length; ++i) {
		            done.push([]);
		        }
		        var hBorders = new kendo.spreadsheet.calc.runtime.Matrix();
		        var vBorders = new kendo.spreadsheet.calc.runtime.Matrix();
	
		        for (var ri = 0; ri < table.rows.length; ++ri, ++row) {
		            var tr = table.rows[ri];
		            col = 0;
		            for (var ci = 0; ci < tr.cells.length; ++ci) {
		                var td = tr.cells[ci];
		                var rowSpan = td.rowSpan;
		                var colSpan = td.colSpan;
		                while (done[row][col]) {
		                    col++;
		                }
	
		                // A cell containing a long text overflowing the next (empty) cell will weirdly be
		                // reported as merged by Excel (has colspan=2).  Then, Excel informatively suggests
		                // us to ignore the colSpan by passing mso-ignore:colspan in the style.  Much thanks!
		                // https://github.com/telerik/kendo-ui-core/issues/3760
		                var style = td.getAttribute("style");
		                var ignoreColspan = /mso-ignore:colspan/.test(style);
	
		                setStateData(state, row, col, cellState(row, col, td, hBorders, vBorders));
		                if (rowSpan > 1 || (colSpan > 1 && !ignoreColspan)) {
		                    state.mergedCells.push(
		                        new kendo.spreadsheet.RangeRef(
		                            new CellRef(row, col),
		                            new CellRef(row + rowSpan - 1, col + colSpan - 1)
		                        ).toString());
		                }
		                for (var dr = row + rowSpan; --dr >= row;) {
		                    for (var dc = col + colSpan; --dc >= col;) {
		                        if (dr < done.length) {
		                            done[dr][dc] = true;
		                            if (!(dr == row && dc == col)) {
		                                setStateData(state, dr, dc, {});
		                            }
		                        }
		                    }
		                }
		            }
		        }
	
		        return state;
		    }
	
		    function parseTSV(data) {
		        var state = newState();
		        if (data.indexOf("\t") === -1 && data.indexOf("\n") == -1) {
		            setStateData(state, 0, 0, { value: data });
		        } else {
		            var rows = data.split("\n");
		            for (var ri = 0; ri < rows.length; ri++) {
		                var cols = rows[ri].split("\t");
		                for (var ci = 0; ci < cols.length; ci++) {
		                    setStateData(state, ri, ci, { value: cols[ci] });
		                }
		            }
		        }
		        return state;
		    }
	
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1492);
		module.exports = __webpack_require__(1492);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 924:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(555);
	
	/***/ }),
	
	/***/ 1487:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(701);
	
	/***/ }),
	
	/***/ 1492:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(924), __webpack_require__(1487) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
	
		    var UnionRef = kendo.spreadsheet.UnionRef;
		    var CellRef = kendo.spreadsheet.CellRef;
		    var RangeRef = kendo.spreadsheet.RangeRef;
	
		    var PROPERTIES = [
		        "color", "fontFamily", "underline",
		        "italic", "bold", "textAlign",
		        "verticalAlign", "background", "format", "link", "editor",
		        "borderTop", "borderRight", "borderBottom", "borderLeft"
		    ];
	
		    var Range = kendo.Class.extend({
		        init: function(ref, sheet) {
		            this._sheet = sheet;
		            this._ref = ref;
		        },
	
		        clone: function() {
		            return new Range(this._ref.clone(), this._sheet);
		        },
	
		        skipHiddenCells: function() {
		            var refs = [];
		            var self = this, sheet = self._sheet;
		            var skipHiddenRows = sheet.isHiddenRow.bind(sheet);
		            var skipHiddenCols = sheet.isHiddenColumn.bind(sheet);
		            self._ref.forEach(function(ref){
		                ref = self._normalize(ref.toRangeRef());
		                var tl = ref.topLeft, br = ref.bottomRight;
		                var rows = partition(tl.row, br.row, skipHiddenRows);
		                var cols = partition(tl.col, br.col, skipHiddenCols);
		                for (var i = 0; i < rows.length; ++i) {
		                    for (var j = 0; j < cols.length; ++j) {
		                        refs.push(new RangeRef(
		                            new CellRef(rows[i].begin, cols[j].begin),
		                            new CellRef(rows[i].end, cols[j].end)
		                        ));
		                    }
		                }
		            });
		            return sheet.range(refs.length > 1 ? new UnionRef(refs) : refs[0]);
		        },
	
		        _normalize: function(ref) {
		            return this._sheet._grid.normalize(ref);
		        },
	
		        _set: function(name, value, noTrigger) {
		            var self = this;
		            var sheet = self._sheet;
		            self._ref.forEach(function(ref) {
		                sheet._set(ref.toRangeRef(), name, value);
		            });
		            if (!noTrigger) {
		                sheet.triggerChange({
		                    recalc : name == "formula" || name == "value" || name == "validation",
		                    value  : value,
		                    range  : self,
		                    ref    : self._ref
		                });
		            }
		            return self;
		        },
	
		        _get: function(name) {
		            return this._sheet._get(this._ref.toRangeRef(), name);
		        },
	
		        _property: function(name, value) {
		            if (value === undefined) {
		                return this._get(name);
		            } else {
		                return this._set(name, value);
		            }
		        },
	
		        value: function(value) {
		            if (value !== undefined) {
		                // When value is set through the public API we must clear the
		                // formula.  Don't trigger change (third parameter), it'll be
		                // done when setting the value below
		                this._set("formula", null, true);
		            }
		            return this._property("value", value);
		        },
	
		        resize: function(direction) {
		            var ref = this._resizedRef(direction);
		            return new Range(ref, this._sheet);
		        },
	
		        _resizedRef: function(direction) {
		            return this._ref.map(function(ref) {
		                return ref.toRangeRef().resize(direction);
		            });
		        },
	
		        input: function(value, options) {
		            options = $.extend({
		                arrayFormula: false
		            }, options);
		            var existingFormat = this._get("format"), x;
		            if (value !== undefined) {
		                var tl = this._ref.toRangeRef().topLeft;
		                x = kendo.spreadsheet.calc.parse(this._sheet.name(), tl.row, tl.col, value, existingFormat);
		                this._sheet.batch(function() {
		                    var formula = null;
		                    if (x.type == "exp") {
		                        formula = kendo.spreadsheet.calc.compile(x);
		                    } else if (existingFormat != "@") {
		                        var existingFormatType = existingFormat &&
		                            kendo.spreadsheet.formatting.type(x.value, existingFormat);
		                        if (x.type == "date" && existingFormatType != "date") {
		                            this.format(x.format || toExcelFormat(kendo.culture().calendar.patterns.d));
		                        } else if (x.type == "percent" && existingFormatType != "percent") {
		                            this.format(x.value*100 == (x.value*100|0) ? "0%" : "0.00%");
		                        } else if (x.format) {
		                            if (!existingFormat || x.currency ||
		                                (existingFormatType == "number" && x.type == "number" &&
		                                 x.format.length > existingFormat.length)) {
		                                this.format(x.format);
		                            }
		                        }
		                    } else if (x.type != "string") {
		                        x.value = value;
		                    }
		                    this.formula(formula, options.arrayFormula);
		                    if (!formula) {
		                        // value() will clear the formula.  Lucky for us,
		                        // x.value is undefined so it actually won't, but let's
		                        // be explicit and only set value if formula is not
		                        // present.
		                        this.value(x.value);
		                    }
		                }.bind(this), { recalc: true, value: value, ref: this._ref, editorChange: this._sheet.isInEditMode() });
	
		                return this;
		            } else {
		                value = this._get("value");
		                var formula = this._get("formula");
		                var type = existingFormat && !formula && kendo.spreadsheet.formatting.type(value, existingFormat);
	
		                if (formula) {
		                    // it's a Formula object which stringifies to the
		                    // formula as text (without the starting `=`).
		                    value = "=" + formula;
		                } else OUT: { // jshint ignore:line
		                    if (existingFormat && type == "date") {
		                        // check if we could parse back the displayed value.
		                        // https://github.com/telerik/kendo/issues/5335
		                        var t1 = kendo.spreadsheet.formatting.text(value, existingFormat);
		                        x = kendo.spreadsheet.calc.parse(null, null, null, t1, existingFormat); // it's not a formula so we don't need sheet/row/col
		                        var t2 = kendo.spreadsheet.formatting.text(x.value, existingFormat);
		                        if (t1 == t2) {
		                            value = t1;
		                            break OUT; // jshint ignore:line
		                        }
		                    }
		                    if (type === "date") {
		                        value = kendo.toString(kendo.spreadsheet.numberToDate(value), kendo.culture().calendar.patterns.d);
		                    } else if (type === "percent") {
		                        value = kendo.spreadsheet.calc.runtime.limitPrecision(value * 100) + "%";
		                    } else if (typeof value == "string" &&
		                               (/^[=']/.test(value) ||
		                                (/^(?:true|false)$/i).test(value) ||
		                                looksLikeANumber(value))) {
		                        value = "'" + value;
		                    }
		                }
	
		                return value;
		            }
		        },
	
		        enable: function(value) {
		            if (value === undefined) {
		                return !kendo.util.withExit(function(exit){
		                    this._sheet.forEach(this._ref, function(_, __, data) {
		                        if (data.enable === false) {
		                            exit(true);
		                        }
		                    });
		                }, this);
		            }
	
		            return this._property("enable", value);
		        },
	
		        formula: function(value, arrayFormula) {
		            var self = this;
		            if (value === undefined) {
		                var f = self._get("formula");
		                return f ? "" + f : null; // stringify if present
		            }
		            if (arrayFormula) {
		                // when setting an array formula, we want to set it on
		                // the first cell only, as it will fill the whole
		                // range.
		                var ref = this._ref.toRangeRef();
		                value = self._sheet.range(ref.topLeft)
		                    ._set("formula", value)
		                    ._get("formula"); // make sure we get the compiled Formula, not a string
	
		                if (value) {    // could be null.
		                    // this will be used in FormulaContext -- it's the
		                    // range that the formula must populate.
		                    value.setArrayFormulaRange(ref);
		                }
		            } else {
		                self._set("formula", value);
		            }
		            return self;
		        },
	
		        intersectingArrayFormula: function() {
		            var ref = this._ref.clone().simplify().setSheet(this._sheet.name());
		            return kendo.util.withExit(function(exit){
		                this._sheet._forFormulas(function(f){
		                    var r = f.arrayFormulaRange;
		                    if (r && (r = ref.intersect(r)) !== kendo.spreadsheet.NULLREF) {
		                        exit({ formula: f, intersection: r });
		                    }
		                });
		            }, this);
		        },
	
		        canEditArrayFormula: function() {
		            var x = this.intersectingArrayFormula();
		            if (x) {
		                // we want to allow editing only when the new range is
		                // at least as big as the original range (i.e. no
		                // cells removed)
		                return x.formula.arrayFormulaRange.eq(x.intersection);
		            }
		            return true;
		        },
	
		        validation: function(value) {
		            //TODO: Accept objects only?
	
		            if (value === undefined) {
		                var f = this._get("validation");
	
		                return f ? f.toJSON() : null; // stringify if present
		            }
		            return this._property("validation", value);
		        },
	
		        _getValidationState: function() {
		            var ref = this._ref.toRangeRef();
		            var topLeftRow = ref.topLeft.row;
		            var topLeftCol = ref.topLeft.col;
		            var bottomRightRow = ref.bottomRight.row;
		            var bottomRightCol = ref.bottomRight.col;
		            var ci, ri;
	
		            for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
		                for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
		                    var validation = this._sheet._validation(ri, ci);
	
		                    if (validation && validation.type === "reject" && validation.value === false) {
		                        return validation;
		                    }
		                }
		            }
	
		            return false;
		        },
	
		        merge: function() {
		            this._ref = this._sheet._merge(this._ref);
		            return this;
		        },
	
		        unmerge: function() {
		            var mergedCells = this._sheet._mergedCells;
	
		            this._ref.forEach(function(ref) {
		                ref.toRangeRef().intersecting(mergedCells).forEach(function(mergedRef) {
		                    mergedCells.splice(mergedCells.indexOf(mergedRef), 1);
		                });
		            });
	
		            this._sheet.triggerChange({});
	
		            return this;
		        },
	
		        select: function() {
		            this._sheet.select(this._ref);
	
		            return this;
		        },
	
		        values: function(values) {
		            if (this._ref instanceof UnionRef) {
		                throw new Error("Unsupported for multiple ranges.");
		            }
	
		            if (this._ref === kendo.spreadsheet.NULLREF) {
		                if (values !== undefined) {
		                    throw new Error("Unsupported for NULLREF.");
		                } else {
		                    return [];
		                }
		            }
	
		            var ref = this._ref.toRangeRef();
		            var topLeftRow = ref.topLeft.row;
		            var topLeftCol = ref.topLeft.col;
		            var bottomRightRow = ref.bottomRight.row;
		            var bottomRightCol = ref.bottomRight.col;
		            var ci, ri;
	
		            if (values === undefined) {
		                values = new Array(ref.height());
	
		                for (var vi = 0; vi < values.length; vi++) {
		                    values[vi] = new Array(ref.width());
		                }
	
		                for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
		                    for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
		                        values[ri - topLeftRow][ci - topLeftCol] = this._sheet._value(ri, ci);
		                    }
		                }
	
		                return values;
		            } else {
		                this._sheet._set(ref, "formula", null);
	
		                for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
		                    for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
		                        var row = values[ri - topLeftRow];
	
		                        if (row) {
		                            var value = row[ci - topLeftCol];
	
		                            if (value !== undefined) {
		                                this._sheet._value(ri, ci, value);
		                            }
		                        }
		                    }
		                }
	
		                this._sheet.triggerChange({ recalc: true, ref: ref });
	
		                return this;
		            }
		        },
	
		        _properties: function(props) {
		            if (this._ref instanceof UnionRef) {
		                throw new Error("Unsupported for multiple ranges.");
		            }
	
		            if (this._ref === kendo.spreadsheet.NULLREF) {
		                if (props !== undefined) {
		                    throw new Error("Unsupported for NULLREF.");
		                } else {
		                    return [];
		                }
		            }
	
		            var ref = this._ref.toRangeRef();
		            var topLeftRow = ref.topLeft.row;
		            var topLeftCol = ref.topLeft.col;
		            var bottomRightRow = ref.bottomRight.row;
		            var bottomRightCol = ref.bottomRight.col;
		            var ci, ri;
		            var sheet = this._sheet;
	
		            if (props === undefined) {
		                props = new Array(ref.height());
		                sheet.forEach(ref, function(row, col, data){
		                    row -= topLeftRow;
		                    col -= topLeftCol;
		                    var line = props[row] || (props[row] = []);
		                    line[col] = data;
		                });
		                return props;
		            }
		            else {
		                var data;
		                ref = ref.clone();
		                var setProp = function(propName) {
		                    var propValue = data[propName];
		                    ref.topLeft.row = ref.bottomRight.row = ri;
		                    ref.topLeft.col = ref.bottomRight.col = ci;
	
		                    if (propName == "value") {
		                        sheet._set(ref, "formula", null);
		                    }
	
		                    sheet._set(ref, propName, propValue);
		                };
	
		                for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
		                    if (sheet.isHiddenColumn(ci)) {
		                        continue;
		                    }
		                    for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
		                        var row = props[ri - topLeftRow];
		                        if (row && !sheet.isHiddenRow(ri)) {
		                            data = row[ci - topLeftCol];
		                            if (data) {
		                                Object.keys(data).forEach(setProp);
		                            }
		                        }
		                    }
		                }
		                sheet.triggerChange({ recalc: true, ref: this._ref });
		                return this;
		            }
		        },
	
		        clear: function(options) {
		            options = options || {};
		            var clearAll = options.clearAll || !Object.keys(options).length;
	
		            var sheet = this._sheet;
	
		            var reason = {
		                recalc: clearAll || options.contentsOnly,
		                ref: this._ref
		            };
	
		            sheet.batch(function() {
	
		                if (reason.recalc) {
		                    this.formula(null);
		                }
	
		                if (clearAll) {
		                    this.validation(null);
		                }
	
		                if (clearAll || options.formatOnly) {
		                    PROPERTIES.forEach(function(x) {
		                        if (!(options.keepBorders && /^border/i.test(x))) {
		                            this[x](null);
		                        }
		                    }.bind(this));
		                    this.fontSize(null);
		                    this.wrap(null);
		                    this.unmerge();
		                }
	
		            }.bind(this), reason);
	
		            return this;
		        },
	
		        clearContent: function() {
		            return this.clear({ contentsOnly: true });
		        },
	
		        clearFormat: function() {
		            return this.clear({ formatOnly: true });
		        },
	
		        isSortable: function() {
		            return !this.cantSort();
		        },
	
		        cantSort: function() {
		            if (this._ref instanceof UnionRef) {
		                return { code: "cantSortMultipleSelection",
		                         message: "Unsupported for multiple ranges." };
		            }
		            if (this._ref === kendo.spreadsheet.NULLREF) {
		                return { code: "cantSortNullRef",
		                         message: "Unsupported for NULLREF." };
		            }
		            var mc = this._sheet._getMergedCells(this._ref.toRangeRef());
		            var primary = mc.primary;
		            var secondary = mc.secondary;
		            var width = null, height = null;
		            var cant = {};
		            try {
		                this._sheet.forEach(this, function(row, col){
		                    var id = new CellRef(row, col).print();
		                    var merged = primary[id];
		                    if (merged) {
		                        if (width === null) {
		                            width = merged.width();
		                            height = merged.height();
		                        } else if (!(width == merged.width() && height == merged.height())) {
		                            throw cant;
		                        }
		                    }
		                    else if (!secondary[id] && mc.hasMerged) {
		                        throw cant;
		                    }
		                });
		            } catch(ex) {
		                if (ex !== cant) {
		                    throw ex;
		                }
		                return {
		                    code: "cantSortMixedCells",
		                    message: "Unsupported for range containing cells of different shapes."
		                };
		            }
		            return false;
		        },
	
		        sort: function(spec) {
		            var reason = this.cantSort();
		            if (reason) {
		                throw new Error(reason.message);
		            }
	
		            if (spec === undefined) {
		                spec = { column: 0 };
		            }
	
		            spec = spec instanceof Array ? spec : [spec];
	
		            this._sheet._sortBy(this._ref.toRangeRef(), spec.map(function(spec, index) {
		                if (typeof spec === "number") {
		                    spec = { column: spec };
		                }
	
		                return {
		                    index: spec.column === undefined ? index : spec.column,
		                    ascending: spec.ascending === undefined ? true : spec.ascending
		                };
		            }));
	
		            return this;
		        },
	
		        isFilterable: function() {
		            return !(this._ref instanceof UnionRef);
		        },
	
		        filter: function(spec) {
		            if (this._ref instanceof UnionRef) {
		                throw new Error("Unsupported for multiple ranges.");
		            }
	
		            if (spec === false) {
		                this.clearFilters();
		            } else {
		                spec = spec === true ? [] : spec instanceof Array ? spec : [spec];
	
		                this._sheet._filterBy(this._ref.toRangeRef(), spec.map(function(spec, index) {
		                    return {
		                        index: spec.column === undefined ? index : spec.column,
		                        filter: spec.filter
		                    };
		                }));
		            }
	
		            return this;
		        },
	
		        clearFilter: function(spec) {
		            this._sheet.clearFilter(spec);
		        },
	
		        clearFilters: function() {
		            var filter = this._sheet.filter();
		            var spec = [];
	
		            if (filter) {
		                for (var i = 0; i < filter.columns.length; i++) {
		                    spec.push(filter.columns[i].index);
		                }
	
		                this._sheet.batch(function() {
		                    this.clearFilter(spec);
		                    this._filter = null;
		                }, { layout: true, filter: true });
		            }
		        },
	
		        hasFilter: function() {
		            var filter = this._sheet.filter();
		            return !!filter;
		        },
	
		        leftColumn: function() {
		            return new Range(this._ref.leftColumn(), this._sheet);
		        },
	
		        rightColumn: function() {
		            return new Range(this._ref.rightColumn(), this._sheet);
		        },
	
		        topRow: function() {
		            return new Range(this._ref.topRow(), this._sheet);
		        },
	
		        bottomRow: function() {
		            return new Range(this._ref.bottomRow(), this._sheet);
		        },
	
		        column: function(column) {
		            return new Range(this._ref.toColumn(column), this._sheet);
		        },
	
		        row: function(row) {
		            return new Range(this._ref.toRow(row), this._sheet);
		        },
	
		        forEachRow: function(callback) {
		            this._ref.forEachRow(function(ref) {
		                callback(new Range(ref, this._sheet));
		            }.bind(this));
		        },
	
		        forEachColumn: function(callback) {
		            this._ref.forEachColumn(function(ref) {
		                callback(new Range(ref, this._sheet));
		            }.bind(this));
		        },
	
		        sheet: function() {
		            return this._sheet;
		        },
	
		        topLeft: function() {
		            return this._ref.toRangeRef().topLeft;
		        },
	
		        intersectingMerged: function() {
		            var sheet = this._sheet;
		            var mergedCells = [];
	
		            sheet._mergedCells.forEach(function(ref) {
		                if (ref.intersects(this._ref)) {
		                    mergedCells.push(ref.toString());
		                }
		            }.bind(this));
	
		            return mergedCells;
		        },
	
		        getState: function(propertyName) {
		            var topLeft = this._ref.first();
		            var state = {
		                ref     : topLeft,
		                data    : [],
		                origRef : this._ref,
	
		                // save row heights
		                rows    : this._sheet._rows.getState()
		            };
		            var properties;
		            if (!propertyName) {
		                properties = kendo.spreadsheet.ALL_PROPERTIES;
		                state.mergedCells = this.intersectingMerged();
		            } else if (propertyName === "input") {
		                properties = ["value", "formula"];
		            } else if (propertyName === "border") {
		                properties = ["borderLeft", "borderTop", "borderRight", "borderBottom"];
		            } else {
		                properties = [propertyName];
		            }
	
		            var data = state.data;
		            this.forEachCell(function(row, col, cell) {
		                var cellState = {};
		                var dr = row - topLeft.row;
		                var dc = col - topLeft.col;
		                if (!data[dr]) {
		                    data[dr] = [];
		                }
		                data[dr][dc] = cellState;
	
		                properties.forEach(function(property) {
		                    var value = typeof cell[property] == "undefined" ? null : cell[property];
		                    if (value instanceof kendo.spreadsheet.calc.runtime.Formula ||
		                        value instanceof kendo.spreadsheet.validation.Validation)
		                    {
		                        value = value.deepClone();
		                    }
		                    cellState[property] = value;
		                });
		            });
	
		            return state;
		        },
	
		        setState: function(state, clipboard) {
		            var sheet = this._sheet;
		            var origin = this._ref.first();
		            var rowDelta = state.ref.row - origin.row;
		            var colDelta = state.ref.col - origin.col;
		            var internalClipboard = clipboard && !clipboard.isExternal();
		            var externalClipboard = clipboard && !internalClipboard;
	
		            sheet.batch(function() {
		                if (state.mergedCells) {
		                    this.unmerge();
		                }
	
		                if (!clipboard) {
		                    // restore row heights.  they won't be available
		                    // when this function is called from the clipboard
		                    // code.
		                    this._sheet._rows.setState(state.rows);
		                }
	
		                var row = origin.row;
		                var hasFilter = this.hasFilter();
		                state.data.forEach(function(data, dr){
		                    if (hasFilter && internalClipboard && sheet.isHiddenRow(state.ref.row + dr)) {
		                        return;
		                    }
		                    var col = origin.col;
		                    data.forEach(function(cellState, dc){
		                        if (hasFilter && internalClipboard && sheet.isHiddenColumn(state.ref.col + dc)) {
		                            return;
		                        }
		                        var range = clipboard ? sheet.range(row, col)
		                            : sheet.range(origin.row + dr, origin.col + dc);
		                        if (range.enable()) {
		                            for (var property in cellState) {
		                                if (property != "value") {
		                                    // make sure value comes last (after the loop),
		                                    // because if we set value here and get get to
		                                    // formula later and cellState.formula is null,
		                                    // it'll clear the value.
	
		                                    // when pasting, do not copy "disabled" state
		                                    if (!(clipboard && property == "enable")) {
		                                        range._set(property, cellState[property]);
		                                    }
		                                }
		                            }
		                            if (!cellState.formula) {
		                                // only need to set the value if we don't have a
		                                // formula.  Go through the lower level setter rather
		                                // than range.value(...), because range.value will clear
		                                // the formula!  chicken and egg issues.
		                                if (externalClipboard) {
		                                    // https://github.com/telerik/kendo-ui-core/issues/1688
		                                    // if we have a paste from external source, we should parse the
		                                    // value as if it were inputted.  This allows to treat numbers
		                                    // as numbers, or `=sum(a1:b2)` as formula (Google Sheets does
		                                    // the same).  A difference though is that we can't store an
		                                    // invalid Formula and display #ERROR, like G.S. does, so in
		                                    // case of a parse error we'll just set the value as string.
		                                    try {
		                                        if (cellState.value == null) { // jshint ignore:line
		                                            range._set("value", null);
		                                        } else {
		                                            range.input(cellState.value);
		                                        }
		                                    } catch(ex) {
		                                        range._set("value", cellState.value);
		                                    }
		                                } else {
		                                    range._set("value", cellState.value);
		                                }
		                            }
		                        }
		                        col++;
		                    });
		                    row++;
		                });
	
		                if (state.mergedCells) {
		                    state.mergedCells.forEach(function(merged) {
		                        merged = sheet._ref(merged).relative(rowDelta, colDelta, 3);
		                        sheet.range(merged).merge();
		                    }, this);
		                }
		            }.bind(this), { recalc: true, ref: this._ref });
		        },
	
		        _adjustRowHeight: function() {
		            var sheet = this._sheet;
		            var mc = sheet._getMergedCells(this._ref.toRangeRef());
		            var primary = mc.primary;
		            var secondary = mc.secondary;
		            this.forEachRow(function(rowRange){
		                var row = rowRange._ref.topLeft.row;
		                var height = sheet.rowHeight(row);
		                rowRange.forEachCell(function(row, col, cell){
		                    var id = new CellRef(row, col).print();
		                    if (secondary[id]) {
		                        return;
		                    }
		                    var merged = primary[id];
		                    var width;
		                    if (merged) {
		                        width = sheet._columns.sum(merged.topLeft.col,
		                                                   merged.bottomRight.col);
		                    } else {
		                        width = sheet.columnWidth(col);
		                    }
		                    var data = cell.value;
		                    if (cell.format && data != null) { // jshint ignore:line
		                        data = kendo.spreadsheet.formatting.format(data, cell.format);
		                    }
		                    var textHeight = kendo.spreadsheet.util.getTextHeight(
		                        data, width, cell.fontFamily, cell.fontSize, cell.wrap);
		                    height = Math.max(height, textHeight);
		                });
		                sheet.rowHeight(row, height);
		            });
		        },
	
		        forEachCell: function(callback) {
		            this._ref.forEach(function(ref) {
		                this._sheet.forEach(ref.toRangeRef(), callback.bind(this));
		            }.bind(this));
		        },
	
		        hasValue: function() {
		            var defStyle = this._sheet._defaultCellStyle;
		            return kendo.util.withExit(function(exit){
		                this.forEachCell(function(row, col, cell) {
		                    // we must not consider cells that only have same values
		                    // as defaultCellStyle, or otherwise we will forbid
		                    // inserting rows/cols in an empty sheet.
		                    for (var key in cell) {
		                        var val = cell[key];
		                        if (val !== undefined && val !== null && val !== defStyle[key]) {
		                            exit(true);
		                        }
		                    }
		                });
		            }, this);
		        },
	
		        wrap: function(flag) {
		            if (flag === undefined) {
		                return !!this._property("wrap");
		            }
		            this._property("wrap", flag);
		            if (flag !== null) {
		                this._adjustRowHeight();
		            }
		            return this;
		        },
	
		        fontSize: function(size) {
		            if (size === undefined) {
		                return this._property("fontSize");
		            }
		            this._property("fontSize", size);
		            if (size !== null) {
		                this._adjustRowHeight();
		            }
		            return this;
		        },
	
		        draw: function(options, callback) {
		            this._sheet.draw(this, options, callback);
		        },
	
		        insideBorders: function(value) {
		            return this.insideVerticalBorders(value).insideHorizontalBorders(value);
		        },
	
		        insideVerticalBorders: function(value) {
		            this._ref.forEach(function(ref){
		                if (ref instanceof RangeRef && ref.width() > 1) {
		                    ref = ref.clone();
		                    ref.topLeft.col++;
		                    this._sheet.range(ref)._set("vBorders", value);
		                }
		            }, this);
		            return this;
		        },
	
		        insideHorizontalBorders: function(value) {
		            this._ref.forEach(function(ref){
		                if (ref instanceof RangeRef && ref.height() > 1) {
		                    ref = ref.clone();
		                    ref.topLeft.row++;
		                    this._sheet.range(ref)._set("hBorders", value);
		                }
		            }, this);
		            return this;
		        }
		    });
	
		    function partition(begin, end, predicate) {
		        while (begin <= end && predicate(begin)) {
		            begin++;
		        }
		        if (begin > end) {
		            return [];
		        }
		        for (var i = begin + 1; i <= end; ++i) {
		            if (predicate(i)) {
		                return [
		                    { begin: begin, end: i - 1 }
		                ].concat(partition(i + 1, end, predicate));
		            }
		        }
		        return [{ begin: begin, end: end }];
		    }
	
		    // use $.each instead of forEach to work in oldIE
		    $.each(PROPERTIES, function(i, property) {
		        Range.prototype[property] = function(value) {
		            return this._property(property, value);
		        };
		    });
	
		    function toExcelFormat(format) {
		        return format.replace(/M/g, "m").replace(/'/g, '"').replace(/tt/, "am/pm");
		    }
	
		    function looksLikeANumber(str) {
		        // XXX: could do with just a regexp instead of calling parse.
		        return !(/^=/.test(str)) && (/number|percent/).test(kendo.spreadsheet.calc.parse(null, 0, 0, str).type);
		    }
	
		    var measureBox = $('<div style="position: absolute !important; top: -4000px !important; height: auto !important;' +
		                        'padding: 1px 3px !important; box-sizing: border-box; margin: 0 !important; border: 1px solid black !important;' +
		                        'line-height: normal !important; visibility: hidden !important;' +
		                        'white-space: pre-wrap;" />'
		                      )[0];
	
		    function getTextHeight(text, width, fontFamily, fontSize, wrap) {
		        var styles = {
		            "baselineMarkerSize" : 0,
		            "width" : (wrap === true) ? width + "px" : "auto",
		            "font-size" : (fontSize || 12) + "px",
		            "font-family" : fontFamily || "Arial",
		            "white-space" : (wrap === true) ? "pre-wrap" : "pre",
		            "overflow-wrap" : (wrap === true) ? "break-word" : "normal",
		            "word-wrap" : (wrap === true) ? "break-word" : "normal"
		        };
	
		        return kendo.util.measureText(text, styles, { box: measureBox, normalizeText: false }).height;
		    }
	
		    kendo.spreadsheet.util = { getTextHeight: getTextHeight };
		    kendo.spreadsheet.Range = Range;
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1498);
		module.exports = __webpack_require__(1498);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 923:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(554);
	
	/***/ }),
	
	/***/ 1450:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ }),
	
	/***/ 1481:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(708);
	
	/***/ }),
	
	/***/ 1498:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(923), __webpack_require__(1450), __webpack_require__(1499), __webpack_require__(1481) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var RangeRef = kendo.spreadsheet.RangeRef;
		    var UnionRef = kendo.spreadsheet.UnionRef;
		    var CellRef = kendo.spreadsheet.CellRef;
		    var Range = kendo.spreadsheet.Range;
	
		    // This is a “dynamic variable” (see Greenspun's 10th rule).  It's
		    // bound to an array via sheet._saveModifiedFormulas (which see)
		    // while the callback runs.  The goal is to enable external code
		    // to get a list of formulas or validations that have been
		    // adjusted as an effect of an insert/delete row/column operation,
		    // to be able to undo it.
		    //
		    // The reason why simply saving the state via sheet.getState() or
		    // range.getState() won't suffice is that an insert or delete
		    // operation can have far-reaching effects, like adjusting
		    // formulas from another sheet.
		    var MODIFIED_FORMULAS;
	
		    var Selection = kendo.Class.extend({
		        init: function(sheet) {
		            this._sheet = sheet;
		            this.selection = kendo.spreadsheet.FIRSTREF.toRangeRef();
		            this.originalSelection = kendo.spreadsheet.FIRSTREF.toRangeRef();
		            this._activeCell = kendo.spreadsheet.FIRSTREF.toRangeRef();
		            this.originalActiveCell = kendo.spreadsheet.FIRSTREF;
		        },
	
		        currentSelectionRange: function() {
		            return this.selection.rangeAt(this.selectionRangeIndex).toRangeRef();
		        },
	
		        currentOriginalNavigationRange: function() {
		            return this.originalSelection.rangeAt(this.selectionRangeIndex).toRangeRef();
		        },
	
		        currentNavigationRange: function() {
		            if (this.singleCellSelection()) {
		                return this._sheet._sheetRef;
		            } else {
		                return this.selection.rangeAt(this.selectionRangeIndex).toRangeRef();
		            }
		        },
	
		        nextNavigationRange: function() {
		            if (!this.singleCellSelection()) {
		                this.selectionRangeIndex = this.selection.nextRangeIndex(this.selectionRangeIndex);
		            }
	
		            return this.currentNavigationRange();
		        },
	
		        previousNavigationRange: function() {
		            if (!this.singleCellSelection()) {
		                this.selectionRangeIndex = this.selection.previousRangeIndex(this.selectionRangeIndex);
		            }
	
		            return this.currentNavigationRange();
		        },
	
		        activeCell: function(ref) {
		            if (ref) {
		                this.originalActiveCell = ref.first();
		                this._activeCell = this._sheet.unionWithMerged(ref.toRangeRef());
		                this._sheet.focus(ref);
		                this._sheet.triggerChange({ activeCell: true, selection: true });
		            }
	
		            return this._activeCell;
		        },
	
		        select: function(ref, expanded, changeActiveCell) {
		            if (ref) {
		                if (ref.eq(this.originalSelection)) {
		                    return;
		                }
	
		                this._sheet.triggerSelect(new Range(ref, this._sheet));
	
		                this.originalSelection = ref;
	
		                this.selection = expanded;
	
		                if (changeActiveCell !== false) {
	
		                    if (ref.isCell()) {
		                        // when selecting part of a merged cell, i.e. A1:B2 is merged and select(B2)
		                        // is requested, mark A1 as the actually active cell.
		                        // https://github.com/telerik/kendo/issues/7698
		                        this._sheet.forEachMergedCell(ref, function(merged){
		                            ref = merged.topLeft;
		                        });
		                        this.activeCell(ref);
		                    } else {
		                        this.activeCell(this.selection.lastRange().first());
		                    }
	
		                    this.selectionRangeIndex = this.selection.size() - 1;
		                } else {
		                    this._sheet.triggerChange({ selection: true });
		                }
		            }
	
		            return this.selection;
		        },
	
		        singleCellSelection: function() {
		            return this._activeCell.eq(this.selection);
		        }
		    });
	
		    var Sheet = kendo.Observable.extend({
		        init: function() {
		            kendo.Observable.prototype.init.call(this);
		            this._reinit.apply(this, arguments);
		        },
	
	
		        events: [
		            "commandRequest",
		            "afterInsertRow",
		            "afterDeleteRow",
		            "insertRow",
		            "insertColumn",
		            "deleteRow",
		            "deleteColumn",
		            "hideRow",
		            "hideColumn",
		            "unhideRow",
		            "unhideColumn",
		            "select"
		        ],
	
		        _reinit: function(rowCount, columnCount, rowHeight, columnWidth, headerHeight, headerWidth, defaultCellStyle) {
		            defaultCellStyle = defaultCellStyle || {};
	
		            this._defaultCellStyle = {
		                background: defaultCellStyle.background,
		                color: defaultCellStyle.color,
		                fontFamily: defaultCellStyle.fontFamily,
		                fontSize: defaultCellStyle.fontSize,
		                italic: defaultCellStyle.italic,
		                bold: defaultCellStyle.bold,
		                underline: defaultCellStyle.underline,
		                wrap: defaultCellStyle.wrap,
		                verticalAlign: defaultCellStyle.verticalAlign,
		                textAlign: defaultCellStyle.textAlign
		            };
	
		            this._rows = new kendo.spreadsheet.Axis(rowCount, rowHeight);
		            this._columns = new kendo.spreadsheet.Axis(columnCount, columnWidth);
		            this._mergedCells = [];
		            this._frozenRows = 0;
		            this._frozenColumns = 0;
		            this._suspendChanges = false;
		            this._filter = null;
		            this._showGridLines = true;
		            this._gridLinesColor = null;
		            this._grid = new kendo.spreadsheet.Grid(this._rows, this._columns, rowCount, columnCount, headerHeight, headerWidth);
		            this._sheetRef = this._grid.normalize(kendo.spreadsheet.SHEETREF);
		            this._properties = new kendo.spreadsheet.PropertyBag(rowCount, columnCount, this._defaultCellStyle);
		            this._sorter = new kendo.spreadsheet.Sorter(this._grid, this._properties.sortable());
	
		            this._viewSelection = new Selection(this);
	
		            this._editSelection = new Selection(this);
	
		            this._formulaSelections = [];
		       },
	
		        _selectionState: function() {
		            return this._inEdit ? this._editSelection : this._viewSelection;
		        },
	
		        navigator: function() {
		            if(!this._navigator) {
		                 this._navigator = new kendo.spreadsheet.SheetNavigator(this);
		            }
		            return this._navigator;
		        },
	
		        axisManager: function() {
		            if(!this._axisManager) {
		                 this._axisManager = new kendo.spreadsheet.AxisManager(this);
		            }
	
		            return this._axisManager;
		        },
	
		        _name: function(value) {
		            if (!value) {
		                return this._sheetName;
		            }
	
		            this._sheetName = value;
	
		            return this;
		        },
	
		        name: function() {
		            return this._name();
		        },
	
		        _property: function(accessor, value, reason) {
		            if (value === undefined) {
		                return accessor();
		            } else {
		                accessor(value);
	
		                return this.triggerChange(reason);
		            }
		        },
	
		        _field: function(name, value, reason) {
		            if (value === undefined) {
		                return this[name];
		            } else {
		                this[name] = value;
	
		                return this.triggerChange(reason);
		            }
		        },
	
		        suspendChanges: function(value) {
		            if (value === undefined) {
		                return this._suspendChanges;
		            }
	
		            this._suspendChanges = value;
	
		            return this;
		        },
	
		        triggerChange: function(reason) {
		            if (!this._suspendChanges) {
		                this.trigger("change", reason);
		            }
		            return this;
		        },
	
		        triggerSelect: function(range) {
		            this.trigger("select", { range: range });
		        },
	
		        setDataSource: function(dataSource, columns) {
		            if (this.dataSourceBinder) {
		                this.dataSourceBinder.destroy();
		            }
	
		            this.dataSourceBinder = new kendo.spreadsheet.SheetDataSourceBinder({
		                dataSource: dataSource,
		                sheet: this,
		                columns: columns
		            });
	
		            this.dataSource = this.dataSourceBinder.dataSource;
		        },
	
		        hideColumn: function(columnIndex) {
		            if (this.trigger("hideColumn", { index: columnIndex })) {
		                return;
		            }
	
		            return this._property(this._columns.hide.bind(this._columns), columnIndex, { layout: true });
		        },
	
		        unhideColumn: function(columnIndex) {
		            if (this.trigger("unhideColumn", { index: columnIndex })) {
		                return;
		            }
	
		            return this._property(this._columns.unhide.bind(this._columns), columnIndex, { layout: true });
		        },
	
		        isHiddenColumn: function(columnIndex) {
		            return this._grid._columns.hidden(columnIndex);
		        },
	
		        _copyRange: function(sourceRangeRef, targetRef) {
		            var grid = this._grid;
		            var rowCount = grid.rowCount;
	
		            var nextRefTopLeft = grid.normalize(sourceRangeRef.topLeft);
		            var nextRefBottomRight = grid.normalize(sourceRangeRef.bottomRight);
	
		            var nextIndex = nextRefTopLeft.col * rowCount + nextRefTopLeft.row;
		            var nextBottomIndex = nextRefBottomRight.col * rowCount + nextRefBottomRight.row;
	
		            var targetIndex = targetRef.col * rowCount + targetRef.row;
	
		            this._properties.copy(nextIndex, nextBottomIndex, targetIndex);
		        },
	
		        _saveModifiedFormulas: function(array, callback) {
		            var save = MODIFIED_FORMULAS;
		            MODIFIED_FORMULAS = array;
		            var ret = callback();
		            MODIFIED_FORMULAS = save;
		            return ret;
		        },
	
		        _restoreModifiedFormulas: function(array) {
		            var wb = this._workbook;
		            array.forEach(function(f){
		                var sheet = wb.sheetByName(f.sheet), index;
		                if (f instanceof kendo.spreadsheet.calc.runtime.Formula) {
		                    index = sheet._grid.cellRefIndex(f); // f has row, col
		                    sheet._properties.set("formula", index, index, f);
		                }
		                if (f instanceof kendo.spreadsheet.validation.Validation) {
		                    index = sheet._grid.cellRefIndex(f); // f has row, col
		                    sheet._properties.set("validation", index, index, f);
		                }
		            });
		        },
	
		        _adjustReferences: function(operation, start, delta, mergedCells) {
		            this._mergedCells = mergedCells.reduce(function(a, ref){
		                ref = ref.adjust(null, null, null, null, operation == "row", start, delta);
		                if (ref instanceof RangeRef) {
		                    a.push(ref);
		                }
		                return a;
		            }, []);
		            if (this._workbook) {
		                var affectedSheet = this._name();
		                this._workbook._sheets.forEach(function(sheet){
		                    sheet._forFormulas(function(formula){
		                        var prev = formula.adjust(affectedSheet, operation, start, delta);
		                        if (prev && MODIFIED_FORMULAS) {
		                            // if formula.adjust returns non-null,
		                            // that means the formula was indeed
		                            // modified and the returned value is a
		                            // copy of the previous Formula, which we
		                            // can use for undoing the operation.
		                            MODIFIED_FORMULAS.push(prev);
		                        }
		                    });
	
		                    sheet._forValidations(function(validation){
		                        var prev = validation.adjust(affectedSheet, operation, start, delta);
		                        if (prev && MODIFIED_FORMULAS) {
		                            MODIFIED_FORMULAS.push(prev);
		                        }
		                    });
		                });
		                this._workbook.adjustNames(affectedSheet, operation == "row", start, delta);
		            }
		            var selection = this.select();
		            selection = selection.adjust(null, null, null, null, operation == "row", start, delta);
		            if (selection !== kendo.spreadsheet.NULLREF) {
		                this.select(selection);
		            }
		            // adjust column widths or row heights and hidden attribute
		            var axis = operation == "col" ? this._columns : this._rows;
		            axis.adjust(start, delta);
		        },
	
		        _forFormulas: function(callback) {
		            var props = this._properties;
		            var formulas = props.get("formula").values();
		            var n = formulas.length;
		            formulas.forEach(function(f, i){
		                callback.call(this, f.value, i, n);
		            }, this);
		        },
	
		        _forValidations: function(callback) {
		            var props = this._properties;
		            props.get("validation").values().forEach(function(v){
		                callback.call(this, v.value);
		            }, this);
		        },
	
		        preventInsertRow: function(rowIndex, count) {
		            if (this.selectedHeaders().allRows) {
		                return { reason: "error", type: "insertRowWhenColumnIsSelected" };
		            }
	
		            count = count || 1;
		            var grid = this._grid;
		            var range = this.range(grid.rowCount - count, 0, count, grid.columnCount);
	
		            //TODO: Improve has value to return true only if real value is available?
		            if (range.hasValue()) {
		                return { reason: "error", type: "shiftingNonblankCells" };
		            }
	
		            return false;
		        },
	
		        preventInsertColumn: function(colIndex, count) {
		            if (this.selectedHeaders().allCols) {
		                return { reason: "error", type: "insertColumnWhenRowIsSelected" };
		            }
	
		            count = count || 1;
		            var grid = this._grid;
		            var range = this.range(0, grid.columnCount - count, grid.rowCount, count);
	
		            //TODO: Improve has value to return true only if real value is available?
		            if (range.hasValue()) {
		                return { reason: "error", type: "shiftingNonblankCells" };
		            }
	
		            return false;
		        },
	
		        insertRow: function(rowIndex) {
		            var result = this.preventInsertRow(rowIndex);
	
		            if (result) {
		                throw new Error("Shifting nonblank cells off the worksheet is not supported!");
		            }
	
		            if (this.trigger("insertRow", { index: rowIndex })) {
		                return;
		            }
	
		            this.batch(function() {
	
		                var grid = this._grid;
		                var columnCount = grid.columnCount;
		                var rowCount = grid.rowCount;
	
		                var frozenRows = this.frozenRows();
	
		                if (rowIndex < frozenRows) {
		                    this.frozenRows(frozenRows + 1);
		                }
	
		                var mergedCells = this._mergedCells.slice();
	
		                for (var ci = 0; ci < columnCount; ci++) {
		                    var ref = new RangeRef(new CellRef(rowIndex, ci), new CellRef(rowIndex, ci));
	
		                    var topLeft = grid.normalize(ref.topLeft);
		                    var bottomRight = grid.normalize(ref.bottomRight);
	
		                    var nextRef = new RangeRef(
		                        new CellRef(topLeft.row, topLeft.col),
		                        new CellRef(rowCount - 2, bottomRight.col)
		                    );
	
		                    this._copyRange(nextRef, new CellRef(topLeft.row + 1, topLeft.col));
	
		                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });
		                }
	
		                this._adjustReferences("row", rowIndex, 1, mergedCells);
		            }, {
		                recalc: true,
		                layout: true,
		                insertRow: { index: rowIndex },
		                ref: new RangeRef(new CellRef(rowIndex, 0), new CellRef(Infinity, Infinity))
		            });
	
		            this.trigger("afterInsertRow", { index: rowIndex });
	
		            return this;
		        },
	
		        isEnabledRow: function(rowIndex) {
		            var ref = new RangeRef(new CellRef(rowIndex, 0), new CellRef(rowIndex, this._grid.columnCount));
		            return new Range(ref, this).enable();
		        },
	
		        deleteRow: function(rowIndex) {
		            if (!this.isEnabledRow(rowIndex)) {
		                return this;
		            }
	
		            if (this.trigger("deleteRow", { index: rowIndex })) {
		                return;
		            }
	
		            this.batch(function() {
		                var grid = this._grid;
		                var columnCount = grid.columnCount;
	
		                var frozenRows = this.frozenRows();
		                if (rowIndex < frozenRows) {
		                    this.frozenRows(frozenRows - 1);
		                }
	
		                var mergedCells = this._mergedCells.slice();
	
		                for (var ci = 0; ci < columnCount; ci++) {
		                    var ref = new RangeRef(new CellRef(rowIndex, ci), new CellRef(rowIndex, ci));
	
		                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });
	
		                    var topLeft = grid.normalize(ref.topLeft);
		                    var bottomRight = grid.normalize(ref.bottomRight);
	
		                    var nextRef = new RangeRef(
		                        new CellRef(topLeft.row + 1, topLeft.col),
		                        new CellRef(Infinity, bottomRight.col)
		                    );
	
		                    this._copyRange(nextRef, topLeft);
	
		                    var nextRefBottomRight = grid.normalize(nextRef.bottomRight);
	
		                    new Range(new RangeRef(nextRefBottomRight, nextRefBottomRight), this).clear();
		                }
	
		                this._adjustReferences("row", rowIndex, -1, mergedCells);
		            }, {
		                recalc: true,
		                layout: true,
		                deleteRow: { index: rowIndex },
		                ref: new RangeRef(new CellRef(rowIndex, 0), new CellRef(Infinity, Infinity))
		            });
	
		            this.trigger("afterDeleteRow", { index: rowIndex });
	
		            return this;
		        },
	
		        insertColumn: function(columnIndex) {
		            if (this.trigger("insertColumn", { index: columnIndex })) {
		                return;
		            }
	
		            this.batch(function() {
		                var grid = this._grid;
		                var columnCount = grid.columnCount;
	
		                var frozenColumns = this.frozenColumns();
	
		                if (columnIndex < frozenColumns) {
		                    this.frozenColumns(frozenColumns + 1);
		                }
	
		                var mergedCells = this._mergedCells.slice();
	
		                for (var ci = columnCount; ci >= columnIndex; ci--) {
		                    var ref = new RangeRef(new CellRef(0, ci), new CellRef(Infinity, ci));
	
		                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });
	
		                    if (ci == columnIndex) {
		                        break;
		                    }
	
		                    var topLeft = grid.normalize(ref.topLeft);
		                    var bottomRight = grid.normalize(ref.bottomRight);
	
		                    var nextRef = new RangeRef(
		                        new CellRef(topLeft.row, topLeft.col - 1),
		                        new CellRef(bottomRight.row, bottomRight.col - 1)
		                    );
	
		                    this._copyRange(nextRef, topLeft);
		                }
	
		                this._adjustReferences("col", columnIndex, 1, mergedCells);
		            }, {
		                recalc: true,
		                layout: true,
		                insertColumn: { index: columnIndex },
		                ref: new RangeRef(new CellRef(0, columnIndex), new CellRef(Infinity, Infinity))
		            });
	
		            return this;
		        },
	
		        isEnabledColumn: function(columnIndex) {
		            var ref = new RangeRef(new CellRef(0, columnIndex), new CellRef(Infinity, columnIndex));
		            return new Range(ref, this).enable();
		        },
	
		        deleteColumn: function(columnIndex) {
		            if (!this.isEnabledColumn(columnIndex)) {
		                return this;
		            }
	
		            if (this.trigger("deleteColumn", { index: columnIndex })) {
		                return;
		            }
	
		            this.batch(function() {
		                var grid = this._grid;
		                var columnCount = grid.columnCount;
	
		                var frozenColumns = this.frozenColumns();
	
		                if (columnIndex < frozenColumns) {
		                    this.frozenColumns(frozenColumns - 1);
		                }
	
		                var mergedCells = this._mergedCells.slice();
	
		                for (var ci = columnIndex; ci < columnCount; ci++) {
		                    var ref = new RangeRef(new CellRef(0, ci), new CellRef(Infinity, ci));
	
		                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });
	
		                    if (ci == columnCount - 1) {
		                        break;
		                    }
	
		                    var topLeft = grid.normalize(ref.topLeft);
		                    var bottomRight = grid.normalize(ref.bottomRight);
	
		                    var nextRef = new RangeRef(
		                        new CellRef(topLeft.row, topLeft.col + 1),
		                        new CellRef(bottomRight.row, bottomRight.col + 1)
		                    );
	
		                    this._copyRange(nextRef, topLeft);
		                }
	
		                this._adjustReferences("col", columnIndex, -1, mergedCells);
		            }, {
		                recalc: true,
		                layout: true,
		                deleteColumn: { index: columnIndex },
		                ref: new RangeRef(new CellRef(0, columnIndex), new CellRef(Infinity, Infinity))
		            });
	
		            return this;
		        },
	
		        hideRow: function(rowIndex) {
		            if (this.trigger("hideRow", { index: rowIndex })) {
		                return;
		            }
	
		            return this._property(this._rows.hide.bind(this._rows), rowIndex, { layout: true });
		        },
	
		        unhideRow: function(rowIndex) {
		            if (this.trigger("unhideRow", { index: rowIndex })) {
		                return;
		            }
	
		            return this._property(this._rows.unhide.bind(this._rows), rowIndex, { layout: true });
		        },
	
		        isHiddenRow: function(rowIndex) {
		            return this._grid._rows.hidden(rowIndex);
		        },
	
		        columnWidth: function(columnIndex, width) {
		            return this._property(this._columns.value.bind(this._columns, columnIndex, columnIndex), width, { layout: true });
		        },
	
		        rowHeight: function(rowIndex, height) {
		            return this._property(this._rows.value.bind(this._rows, rowIndex, rowIndex), height, { layout: true });
		        },
	
		        frozenRows: function(value) {
		            return this._field("_frozenRows", value, { layout: true });
		        },
	
		        frozenColumns: function(value) {
		            return this._field("_frozenColumns", value, { layout: true });
		        },
	
		        showGridLines: function(value) {
		            return this._field("_showGridLines", value, { layout: true });
		        },
	
		        gridLinesColor: function(value) {
		            return this._field("_gridLinesColor", value, { layout: true });
		        },
	
		        _ref: function(row, column, numRows, numColumns) {
		            var ref = null;
	
		            if (row instanceof kendo.spreadsheet.Ref) {
		                return row;
		            }
	
		            if (row instanceof kendo.spreadsheet.Range) {
		                return row._ref.toRangeRef();
		            }
	
		            if (typeof row === "string") {
		                ref = kendo.spreadsheet.calc.parseReference(row);
		            } else {
		                if (!numRows) {
		                    numRows = 1;
		                }
	
		                if (!numColumns) {
		                    numColumns = 1;
		                }
		                ref = new RangeRef(new CellRef(row, column), new CellRef(row + numRows - 1, column + numColumns - 1));
		            }
	
		            return ref;
		        },
	
		        range: function(row, column, numRows, numColumns) {
		            return new Range(this._ref(row, column, numRows, numColumns), this);
		        },
	
		        _getMergedCells: function(range) {
		            var grid = this._grid;
		            var primary = {};
		            var secondary = {};
		            var hasMerged = false;
	
		            this.forEachMergedCell(range, function(ref) {
		                var topLeft = ref.topLeft;
		                grid.forEach(ref, function(cellRef) {
		                    if (topLeft.eq(cellRef)) {
		                        primary[cellRef.print()] = ref;
		                        hasMerged = true;
		                    } else if (range.contains(cellRef)) {
		                        secondary[cellRef.print()] = topLeft;
		                        hasMerged = true;
		                    }
		                });
		            });
	
		            return { primary: primary, secondary: secondary, hasMerged: hasMerged };
		        },
	
		        forEachMergedCell: function(ref, callback) {
		            var selectAll = false;
	
		            if (typeof callback === "undefined") {
		                callback = ref;
		                selectAll = true;
		            }
	
		            this._mergedCells.forEach(function(merged) {
		                if (selectAll || merged.intersects(ref)) {
		                    callback(merged);
		                }
		            });
		        },
	
		        forEachFilterHeader: function(ref, callback) {
		            var selectAll = false;
	
		            if (typeof callback === "undefined") {
		                callback = ref;
		                selectAll = true;
		            }
	
		            if (this._filter) {
		                var refs = [];
	
		                // get refs of all columns
		                this._filter.ref.forEachColumn(function(columnRef) {
		                    if (selectAll || columnRef.intersects(ref)) {
		                        refs.push(columnRef.topLeft);
		                    }
		                });
	
		                // filter out merged references
		                this._mergedCells.forEach(function(merged) {
		                    refs = refs.map(function(ref) {
		                        if (merged.intersects(ref)) {
		                            return merged;
		                        }
	
		                        return ref;
		                    });
		                });
	
		                // use only unique refs
		                refs.reduce(function unique(result, element) {
		                    if (result.indexOf(element) < 0) {
		                        result.push(element);
		                    }
	
		                    return result;
		                }, []).forEach(callback);
		            }
		        },
	
		        forEach: function(ref, callback) {
		            function forEachRange(ref) {
		                if (!(ref instanceof RangeRef)) {
		                    ref = ref.toRangeRef();
		                }
		                var topLeft = self._grid.normalize(ref.topLeft);
		                var bottomRight = self._grid.normalize(ref.bottomRight);
	
		                function doIt(value) {
		                    callback(ri++, ci, value);
		                }
	
		                for (var ci = topLeft.col; ci <= bottomRight.col; ci++) {
		                    var ri = topLeft.row;
		                    var startCellIndex = self._grid.index(ri, ci);
		                    var endCellIndex = self._grid.index(bottomRight.row, ci);
		                    self._properties.forEach(startCellIndex, endCellIndex, doIt);
		                }
		            }
	
		            var self = this;
		            if (!(ref instanceof RangeRef)) {
		                ref = self._ref(ref);
		            }
	
		            if (ref instanceof UnionRef) {
		                // _ref() might still return a UnionRef, for instance, if
		                // `ref` happens to be one.  Probably an oversight, but it
		                // turns out to be useful.
		                ref.forEach(forEachRange);
		            } else {
		                forEachRange(ref);
		            }
		        },
	
		        startResizing: function(initialPosition) {
		            this._initialPosition = initialPosition;
		            this._resizeInProgress = true;
		        },
	
		        startAutoFill: function() {
		            this._autoFillInProgress = true;
		            var selection = this.select();
		            this._autoFillOrigin = selection;
		            this._autoFillDest = selection;
		            this.triggerChange({ selection: true });
		        },
	
		        updateAutoFill: function(dest, punch, hint, direction) {
		            this._autoFillDest = dest;
		            this._autoFillPunch = punch;
		            this._autoFillHint = hint;
		            this._autoFillDirection = direction;
		            this.triggerChange({ selection: true });
		        },
	
		        autoFillRef: function() {
		            return this._autoFillDest;
		        },
	
		        autoFillPunch: function() {
		            return this._autoFillPunch;
		        },
	
		        autoFillInProgress: function() {
		            return this._autoFillInProgress;
		        },
	
		        resizingInProgress: function() {
		            return this._resizeInProgress;
		        },
	
		        completeResizing: function() {
		            if (this._resizeInProgress) {
		                this._resizeInProgress = false;
		                var hintPosition = this.resizeHintPosition();
	
		                if (this._initialPosition && hintPosition) {
		                    var handlePosition = this.resizeHandlePosition();
		                    if (handlePosition.col !== -Infinity) {
		                        this.trigger("commandRequest", {
		                            command: "ColumnWidthCommand",
		                            options: {
		                                target: handlePosition.col,
		                                value: this.columnWidth(handlePosition.col) - (this._initialPosition.x - hintPosition.x)
		                            }
		                        });
		                    } else {
		                        this.trigger("commandRequest", {
		                            command: "RowHeightCommand",
		                            options: {
		                                target: handlePosition.row,
		                                value: this.rowHeight(handlePosition.row) - (this._initialPosition.y - hintPosition.y)
		                            }
		                        });
		                    }
		                } else {
		                    this.trigger("change", { resize: true });
		                }
		            }
		        },
	
		        resizeHandlePosition: function() {
		            return this._resizeHandlePosition;
		        },
	
		        resizeHintPosition: function(location) {
		            if (location !== undefined) {
		                this._resizeHintPosition = location;
		                this.trigger("change", { resize: true });
		            }
		            return this._resizeHintPosition;
		        },
	
		        removeResizeHandle: function() {
		            if (this._resizeHandlePosition) {
		                this._resizeHintPosition = undefined;
		                this._resizeHandlePosition = undefined;
		                this._initialPosition = undefined;
		                this.trigger("change", { resize: true });
		            }
		        },
	
		        positionResizeHandle: function(ref) {
		            this._resizeHandlePosition = ref;
		            this.trigger("change", { resize: true });
		        },
	
		        startSelection: function() {
		            this._selectionInProgress = true;
		        },
	
		        completeSelection: function() {
		            if (this._selectionInProgress) {
		                this._selectionInProgress = false;
		                this._resizeHintPosition = undefined;
		                this.trigger("change", { selection: true });
		            }
		            if (this._autoFillInProgress) {
		                this._autoFillInProgress = false;
		                var dest = this._autoFillDest;
		                var origin = this._autoFillOrigin;
	
		                if (this._autoFillPunch) { // we just clear data here
		                    this.trigger("commandRequest", {
		                        command: "ClearContentCommand", options: { operatingRange: this.range(this._autoFillPunch) }
		                    });
		                } else {
		                    if (!dest.eq(origin)) {
		                        this.trigger("commandRequest", {
		                            command: "AutoFillCommand", options: { operatingRange: this.range(dest), origin: this.range(origin) }
		                        });
		                    } else {
		                        this.triggerChange({ selection: true });
		                    }
		                }
	
		                this._autoFillDest = null;
		                this._autoFillPunch = null;
		                this._autoFillOrigin = null;
	
		                this.select(dest);
		            }
		        },
	
		        selectionInProgress: function() {
		            return this._selectionInProgress;
		        },
	
		        select: function(ref, changeActiveCell) {
		            var selectionState = this._selectionState();
	
		            var expandedRef;
	
		            if (ref) {
		                ref = this._ref(ref);
		                ref = this._grid.normalize(ref);
		                expandedRef = this._grid.isAxis(ref) ? ref : this.unionWithMerged(ref);
		            }
	
		            return selectionState.select(ref, expandedRef, changeActiveCell);
		        },
	
		        originalSelect: function() {
		            return this._selectionState().originalSelection;
		        },
	
		        currentSelectionRange: function() {
		            return this._selectionState().currentSelectionRange();
		        },
	
		        currentOriginalSelectionRange: function() {
		            return this._selectionState().currentOriginalNavigationRange();
		        },
	
		        currentNavigationRange: function() {
		            return this._selectionState().currentNavigationRange();
		        },
	
		        nextNavigationRange: function() {
		            return this._selectionState().nextNavigationRange();
		        },
	
		        previousNavigationRange: function() {
		            return this._selectionState().previousNavigationRange();
		        },
	
		        selectionRangeIndex: function() {
		            return this._selectionState().selectionRangeIndex;
		        },
	
		        activeCell: function(ref) {
		            return this._selectionState().activeCell(ref);
		        },
	
		        originalActiveCell: function() {
		            return this._selectionState().originalActiveCell;
		        },
	
		        singleCellSelection: function() {
		            return this._selectionState().singleCellSelection();
		        },
	
		        unionWithMerged: function(ref) {
		            var mergedCells = this._mergedCells;
	
		            return ref.map(function(ref) {
		                return ref.toRangeRef().union(mergedCells);
		            });
		        },
	
		        trim: function(ref) {
		            var trims = [];
		            var grid = this._grid;
		            this._properties.forEachProperty(function(property) {
		                trims.push(grid.trim(ref, property.list));
		            });
		            return this.unionWithMerged(ref.topLeft.toRangeRef().union(trims));
		        },
	
		        focus: function(ref) {
		            if (ref) {
		                this._focus = ref.toRangeRef();
		            } else {
		                var focus = this._focus;
		                this._focus = null;
		                return focus;
		            }
		        },
	
		        activeCellSelection: function() {
		            return new Range(this._grid.normalize(this.activeCell()), this);
		        },
	
		        selection: function() {
		            return new Range(this._grid.normalize(this._selectionState().selection), this);
		        },
	
		        selectedHeaders: function() {
		            var selection = this.select();
	
		            var rows = {};
		            var cols = {};
		            var allCols = false;
		            var allRows = false;
		            var maxRow = this._grid.rowCount - 1;
		            var maxCol = this._grid.columnCount - 1;
	
		            selection.forEach(function(ref) {
		                var i;
		                var rowState = "partial";
		                var colState = "partial";
		                ref = ref.toRangeRef();
	
		                var bottomRight = ref.bottomRight;
		                var topLeft = ref.topLeft;
	
		                var rowSelection = topLeft.col <= 0 && bottomRight.col >= maxCol;
		                var colSelection = topLeft.row <= 0 && bottomRight.row >= maxRow;
	
		                if (colSelection) { //column selection
		                    allRows = true;
		                    colState = "full";
		                }
	
		                if (rowSelection) { //row selection
		                    allCols = true;
		                    rowState = "full";
		                }
	
		                if (!colSelection) { //column selection
		                    for (i = topLeft.row; i <= bottomRight.row; i++) {
		                        if (rows[i] !== "full") {
		                            rows[i] = rowState;
		                        }
		                    }
		                }
	
		                if (!rowSelection) {
		                    for (i = topLeft.col; i <= bottomRight.col; i++) {
		                        if (cols[i] !== "full") {
		                            cols[i] = colState;
		                        }
		                    }
		                }
		            });
	
		            return {
		                rows: rows,
		                cols: cols,
		                allRows: allRows,
		                allCols: allCols,
		                all: allRows && allCols
		            };
		        },
	
		        isInEditMode: function(isInEdit) {
		            if (isInEdit === undefined) {
		                return this._inEdit;
		            }
	
		            this._inEdit = isInEdit;
	
		            if (isInEdit) {
		                this._editSelection.selection = this._viewSelection.selection.clone();
		                this._editSelection.originalSelection = this._viewSelection.originalSelection.clone();
		                this._editSelection._activeCell = this._viewSelection._activeCell.clone();
		                this._editSelection.originalActiveCell = this._viewSelection.originalActiveCell.clone();
		            }
		        },
	
		        _setFormulaSelections: function(selection) {
		            this._formulaSelections = (selection || []).slice();
		            this.triggerChange({ selection: true });
		        },
	
		        _viewActiveCell: function() {
		            return this._viewSelection._activeCell.toRangeRef();
		        },
	
		        toJSON: function() {
		            var positions = {};
	
		            var rows = this._rows.toJSON("height", positions);
		            var columns = this._columns.toJSON("width", {});
		            var viewSelection = this._viewSelection;
		            var hyperlinks = [];
		            var defaultCellStyle = this._defaultCellStyle || {};
	
		            function clearDefaultStyle(cell) {
		                Object.keys(defaultCellStyle).forEach(function(key){
		                    if (cell[key] === defaultCellStyle[key]) {
		                        delete cell[key];
		                    }
		                });
		            }
	
		            this.forEach(kendo.spreadsheet.SHEETREF, function(row, col, cell) {
		                clearDefaultStyle(cell);
	
		                if (Object.keys(cell).length === 0) {
		                    return;
		                }
	
		                if (cell.link) {
		                    hyperlinks.push({
		                        ref    : kendo.spreadsheet.Ref.display(null, row, col),
		                        target : cell.link
		                    });
		                }
	
		                var position = positions[row];
	
		                if (position === undefined) {
		                    position = rows.length;
		                    rows.push({ index: row });
		                    positions[row] = position;
		                }
	
		                row = rows[position];
	
		                cell.index = col;
	
		                if (row.cells === undefined) {
		                    row.cells = [];
		                }
	
		                if (cell.formula) {
		                    // stringify Formula object.
		                    if (cell.formula.arrayFormulaRange) {
		                        cell.formula = {
		                            src: cell.formula.toString(),
		                            ref: cell.formula.arrayFormulaRange.toString()
		                        };
		                    } else {
		                        cell.formula = cell.formula.toString();
		                    }
		                }
	
		                if (cell.validation) {
		                    cell.validation = cell.validation.toJSON();
		                }
	
		                if (cell.color) {
		                    cell.color = kendo.parseColor(cell.color).toCss();
		                }
	
		                if (cell.background) {
		                    cell.background = kendo.parseColor(cell.background).toCss();
		                }
	
		                if (cell.borderTop && cell.borderTop.color) {
		                    cell.borderTop.color = kendo.parseColor(cell.borderTop.color).toCss();
		                }
	
		                if (cell.borderBottom && cell.borderBottom.color) {
		                    cell.borderBottom.color = kendo.parseColor(cell.borderBottom.color).toCss();
		                }
	
		                if (cell.borderRight && cell.borderRight.color) {
		                    cell.borderRight.color = kendo.parseColor(cell.borderRight.color).toCss();
		                }
	
		                if (cell.borderLeft && cell.borderLeft.color) {
		                    cell.borderLeft.color = kendo.parseColor(cell.borderLeft.color).toCss();
		                }
	
		                row.cells.push(cell);
		            });
	
		            var json = {
		                name: this._name(),
		                rows: rows,
		                columns: columns,
		                selection: viewSelection.selection.toString(),
		                activeCell: viewSelection.activeCell().toString(),
		                frozenRows: this.frozenRows(),
		                frozenColumns: this.frozenColumns(),
		                showGridLines: this.showGridLines(),
		                gridLinesColor: this.gridLinesColor(),
		                mergedCells: this._mergedCells.map(function(ref) {
		                    return ref.toString();
		                }),
		                hyperlinks: hyperlinks,
		                defaultCellStyle: defaultCellStyle
		            };
	
		            if (this._sort) {
		               json.sort = {
		                   ref: this._sort.ref.toString(),
		                   columns: this._sort.columns.map(function(column) {
		                       return {
		                           index: column.index,
		                           ascending: column.ascending
		                       };
		                   })
		               };
		            }
	
		            if (this._filter) {
		               json.filter = {
		                   ref: this._filter.ref.toString(),
		                   columns: this._filter.columns.map(function(column) {
		                        var filter = column.filter.toJSON();
		                        filter.index = column.index;
		                        return filter;
		                   })
		               };
		            }
	
		            return json;
		        },
	
		        fromJSON: function(json) {
		            this.batch(function() {
		                if (json.name !== undefined) {
		                    this._name(json.name);
		                }
	
		                if (json.frozenColumns !== undefined) {
		                    this.frozenColumns(json.frozenColumns);
		                }
	
		                if (json.frozenRows !== undefined) {
		                    this.frozenRows(json.frozenRows);
		                }
	
		                if (json.columns !== undefined) {
		                    this._columns.fromJSON("width", json.columns);
		                }
	
		                if (json.rows !== undefined) {
		                    this._rows.fromJSON("height", json.rows);
	
		                    for (var ri = 0; ri < json.rows.length; ri++) {
		                        var row = json.rows[ri];
		                        var rowIndex = row.index;
	
		                        if (rowIndex === undefined) {
		                            rowIndex = ri;
		                        }
	
		                        if (row.cells) {
		                            for (var ci = 0; ci < row.cells.length; ci++) {
		                                var cell = row.cells[ci];
		                                var columnIndex = cell.index;
	
		                                if (columnIndex === undefined) {
		                                    columnIndex = ci;
		                                }
	
		                                if (cell.formula) {
		                                    var isArray = typeof cell.formula != "string";
		                                    var src = isArray ? cell.formula.src : cell.formula;
		                                    var formula = this._compileFormula(rowIndex, columnIndex, src);
		                                    if (isArray) {
		                                        formula.setArrayFormulaRange(
		                                            kendo.spreadsheet.calc.parseReference(cell.formula.ref));
		                                    }
		                                    cell.formula = formula;
		                                }
	
		                                if (cell.validation) {
		                                    cell.validation = this._compileValidation(rowIndex, columnIndex, cell.validation);
		                                }
	
		                                this._properties.fromJSON(this._grid.index(rowIndex, columnIndex), cell);
		                            }
		                        }
		                    }
		                }
	
	
		                if (json.selection) {
		                    this._viewSelection.selection =
		                        this._viewSelection.originalSelection = this._ref(json.selection);
		                }
	
		                if (json.activeCell) {
		                    var activeCellRef = this._ref(json.activeCell);
	
		                    this._viewSelection._activeCell = activeCellRef.toRangeRef();
		                    this._viewSelection.originalActiveCell = activeCellRef.first();
		                }
	
	
		                if (json.mergedCells) {
		                    json.mergedCells.forEach(function(ref) {
		                       this.range(ref).merge();
		                    }, this);
		                }
	
		                if (json.sort) {
		                    this._sort = {
		                        ref: this._ref(json.sort.ref),
		                        columns: json.sort.columns.slice(0)
		                    };
		                }
	
		                if (json.filter) {
		                    var ref = json.filter.ref;
		                    var columns = json.filter.columns  === undefined ? [] : json.filter.columns;
	
		                    if (!ref) {
		                        kendo.logToConsole("Dropping filter for sheet '" + json.name + "' due to missing ref");
		                    } else {
		                        this._filter = {
		                            ref: this._ref(ref),
		                            columns: columns.map(function(column) {
		                                return {
		                                    index: column.index,
		                                    filter: kendo.spreadsheet.Filter.create(column)
		                                };
		                            })
		                        };
	
		                        this._refreshFilter();
		                    }
		                }
	
		                if (json.showGridLines !== undefined) {
		                    this._showGridLines = json.showGridLines;
		                }
	
		                this._gridLinesColor = json.gridLinesColor;
		            });
	
		            this._rows._refresh();
		            this._columns._refresh();
		        },
	
		        formula: function(ref) {
		            return this._properties.get("formula", this._grid.cellRefIndex(ref));
		        },
	
		        validation: function(ref) {
		            return this._properties.get("validation", this._grid.cellRefIndex(ref));
		        },
	
		        // NOTE: resetFormulas should be called first.  We don't do it in this
		        // function because it should be done from the Workbook object for all
		        // sheets.
		        resetFormulas: function() {
		            this._forFormulas(function(formula){
		                formula.reset();
		            });
		        },
	
		        resetValidations: function() {
		            this._forValidations(function(validation){
		                validation.reset();
		            });
		        },
	
		        recalc: function(context, callback) {
		            var formulas = this._properties.get("formula").values();
		            var count = formulas.length, pending = 0, i = 0;
		            if (!count && callback) {
		                return callback();
		            }
		            function next() {
		                pending--;
		                if (i == count && !pending) {
		                    callback();
		                }
		            }
		            while (i < count) {
		                pending++;
		                formulas[i++].value.exec(context, callback ? next : null);
		            }
		        },
	
		        revalidate: function(context) {
		            var self = this;
		            this._forValidations(function(validation){
		                var cellRef = new CellRef(validation.row, validation.col);
		                var ref =  new RangeRef(cellRef, cellRef);
		                validation.exec(context, self._get(ref, "value"), self._get(ref, "format"));
		            });
		        },
	
		        _value: function(row, col, value) {
		            var index = this._grid.index(row, col);
	
		            if (value !== undefined) {
		                this._properties.set("value", index, index, value);
		            } else {
		                return this._properties.get("value", index);
		            }
		        },
	
		        _validation: function(row, col) {
		            var index = this._grid.index(row, col);
	
		            return this._properties.get("validation", index);
		        },
	
		        _compileValidation: function(row, col, validation) {
		            if (validation instanceof kendo.spreadsheet.validation.Validation) {
		                // do not alter an existing object.
		                return validation.clone(this._name(), row, col);
		            }
	
		            if (validation.from != null) { // jshint ignore: line
		                validation.from = (validation.from + "").replace(/^=/, "");
		            }
	
		            if (validation.to != null) { // jshint ignore: line
		                validation.to = (validation.to + "").replace(/^=/, "");
		            }
	
		            return kendo.spreadsheet.validation.compile(this._name(), row, col, validation);
		        },
	
		        _compileFormula: function(row, col, f) {
		            f = f.replace(/^=/, "");
		            f = kendo.spreadsheet.calc.parseFormula(this._name(), row, col, f);
		            return kendo.spreadsheet.calc.compile(f);
		        },
	
		        _copyValuesInRange: function (topLeft, bottomRight, value, property) {
		            var ci, start, end;
	
		            for (ci = topLeft.col; ci <= bottomRight.col; ci++) {
		                start = this._grid.index(topLeft.row, ci);
		                end = this._grid.index(bottomRight.row, ci);
		                for (var index = start, row = topLeft.row; index <= end; ++index, ++row) {
		                    // Even if it's the same formula in multiple cells, we
		                    // need to have different Formula objects, hence cloning
		                    // it.  Don't worry, clone() is fast.
		                    value = value.clone(this._name(), row, ci);
		                    this._properties.set(property, index, index, value);
		                }
		            }
		            return value;
		        },
	
		        _set: function(ref, name, value) {
		            var topLeft = this._grid.normalize(ref.topLeft);
		            var bottomRight = this._grid.normalize(ref.bottomRight);
		            var ci, start, end;
	
		            if (typeof value == "number") {
		                // Apparently, Excel (and LibreOffice and Google
		                // Sheets) will limit precision to 14 digits; type:
		                // -4.2524999999999995 and you get -4.2525.  The
		                // formula engine already does something similar for
		                // intermediate formula results, but we must do it
		                // here as well for original input values.
		                value = kendo.spreadsheet.calc.runtime.limitPrecision(value);
		            }
	
		            if (value && name == "formula") {
		                if (typeof value == "string") {
		                    // get Formula object.  we don't care about handling errors
		                    // here since it won't be called interactively.
		                    value = this._compileFormula(topLeft.row, topLeft.col, value);
		                }
	
		                value = this._copyValuesInRange(topLeft, bottomRight, value, "formula");
	
		            } else if (value && name == "validation") {
		                value = this._compileValidation(topLeft.row, topLeft.col, value);
		                value = this._copyValuesInRange(topLeft, bottomRight, value, "validation");
	
		            } else {
		                for (ci = topLeft.col; ci <= bottomRight.col; ci++) {
		                    start = this._grid.index(topLeft.row, ci);
		                    end = this._grid.index(bottomRight.row, ci);
		                    this._properties.set(name, start, end, value);
		                    if (name == "formula") {
		                        // removing a formula, must clear value.
		                        this._properties.set("value", start, end, null);
		                    }
		                }
		            }
		        },
	
		        _get: function(ref, name) {
		            var topLeft = this._grid.normalize(ref.topLeft);
	
		            var index = this._grid.index(topLeft.row, topLeft.col);
	
		            return this._properties.get(name, index);
		        },
	
		        batch: function(callback, reason) {
		            var suspended = this.suspendChanges();
	
		            this.suspendChanges(true);
	
		            callback.call(this);
	
		            return this.suspendChanges(suspended).triggerChange(reason || { recalc: true });
		        },
	
		        _sortBy: function(ref, columns) {
		            var indices = null;
	
		            columns.forEach(function(column) {
		                indices = this._sorter.sortBy(ref, column.index, this._properties.get("value"), column.ascending, indices);
		            }, this);
	
		            this._sort = {
		                ref: ref,
		                columns: columns
		            };
	
		            this._refreshFilter();
	
		            this.forEach(ref, function(row, col, props) {
		                var formula = props.formula;
		                if (formula) {
		                    var diff = row - formula.row;
		                    if (diff !== 0) {
		                        var start = diff > 0 ? formula.row : formula.row + diff;
		                        formula.adjust(this.name(), "row", start, diff);
		                    }
		                }
		            }.bind(this));
	
		            this.triggerChange({ recalc: true });
		        },
	
		        _refreshFilter: function() {
		            if (this._filter) {
		                this._filterBy(this._filter.ref, this._filter.columns);
		            }
		        },
	
		        _filterBy: function(ref, columns) {
		            this.batch(function() {
		                for (var ri = ref.topLeft.row; ri <= ref.bottomRight.row; ri++) {
		                    if (this._rows.hidden(ri)) {
		                        this._rows.unhide(ri);
		                    }
		                }
	
		                columns.forEach(function(column) {
		                    // do not filter header row
		                    var columnRef = ref.resize({ top: 1 }).toColumn(column.index);
	
		                    var cells = [];
	
		                    if (columnRef === kendo.spreadsheet.NULLREF) {
		                        return;
		                    }
	
		                    this.forEach(columnRef, function(row, col, cell) {
		                        cell.row = row;
		                        cells.push(cell);
		                    });
	
		                    column.filter.prepare(cells);
	
		                    for (var ci = 0; ci < cells.length; ci++) {
		                        var cell = cells[ci];
		                        var value = column.filter.value(cell);
	
		                        if (column.filter.matches(value) === false) {
		                            this.hideRow(cell.row);
		                        }
		                    }
		                }, this);
	
		                this._filter = {
		                    ref: ref,
		                    columns: columns
		                };
		            }, { recalc: true, layout: true, filter: true });
		        },
	
		        filterColumn: function(ref) {
		            var filterRef = this.filter().ref;
		            return ref.toRangeRef().topLeft.col - filterRef.topLeft.col;
		        },
	
		        filter: function() {
		            return this._filter;
		        },
	
		        clearFilter: function(spec) {
		            this._clearFilter(spec instanceof Array ? spec : [spec]);
		        },
	
		        _clearFilter: function(indices) {
		            if (this._filter) {
		                this.batch(function() {
		                    this._filter.columns = this._filter.columns.filter(function(column) {
		                        return indices.indexOf(column.index) < 0;
		                    });
	
		                    this._refreshFilter();
		                }, { recalc: true, layout: true, filter: true });
		            }
		        },
	
		        getAxisState: function() {
		            return {
		                rows: this._rows.getState(),
		                columns: this._columns.getState()
		            };
		        },
	
		        setAxisState: function(state) {
		            this._rows.setState(state.rows);
		            this._columns.setState(state.columns);
		            this.triggerChange({ layout: true });
		        },
	
		        getState: function() {
		            return {
		                rows: this._rows.getState(),
		                columns: this._columns.getState(),
		                mergedCells: this._mergedCells.map(function(cell) { return cell.clone(); }),
		                properties: this._properties.getState()
		            };
		        },
	
		        setState: function(state) {
		            this._rows.setState(state.rows);
		            this._columns.setState(state.columns);
		            this._mergedCells = state.mergedCells;
		            this._properties.setState(state.properties);
		            this.triggerChange(kendo.spreadsheet.ALL_REASONS);
		        },
	
		        _merge: function(ref) {
		            var mergedCells = this._mergedCells;
	
		            var sheet = this;
		            var mergedRef;
		            this.batch(function() {
		                mergedRef = ref.map(function(ref) {
		                    if (ref instanceof kendo.spreadsheet.CellRef) {
		                        return ref;
		                    }
	
		                    var currentRef = ref.toRangeRef().union(mergedCells, function(ref) {
		                        mergedCells.splice(mergedCells.indexOf(ref), 1);
		                    });
	
		                    var range = new Range(currentRef, sheet);
		                    var formula = range._get("formula");
		                    var value = range.value();
		                    var format = range.format();
		                    var background = range.background();
	
		                    range.value(null);
		                    range.format(null);
		                    range.background(null);
	
		                    var topLeft = new Range(currentRef.collapse(), sheet);
	
		                    if (formula) {
		                        topLeft._set("formula", formula);
		                    } else {
		                        topLeft.value(value);
		                    }
		                    topLeft.format(format);
		                    topLeft.background(background);
	
		                    mergedCells.push(currentRef);
		                    return currentRef;
		                });
	
		                var viewSelection = sheet._viewSelection;
	
		                viewSelection.selection = sheet.unionWithMerged(viewSelection.originalSelection);
		                viewSelection._activeCell = sheet.unionWithMerged(viewSelection.originalActiveCell);
		            }, { activeCell: true, selection: true });
	
		            return mergedRef;
		        }
		    });
	
		    kendo.spreadsheet.Sheet = Sheet;
		})(kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1499:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(716);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1495);
		module.exports = __webpack_require__(1495);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1481:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(708);
	
	/***/ }),
	
	/***/ 1495:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1481) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /* jshint eqnull:true, newcap:false, laxbreak:true, shadow:true, validthis:true, -W054, loopfunc: true */
		    /* global console */
		    /* jshint latedef: nofunc */
	
		    var calc = {};
		    var spreadsheet = kendo.spreadsheet;
		    spreadsheet.calc = calc;
		    var exports = calc.runtime = {};
		    var Class = kendo.Class;
	
		    var Ref = spreadsheet.Ref;
		    var CellRef = spreadsheet.CellRef;
		    var RangeRef = spreadsheet.RangeRef;
		    var UnionRef = spreadsheet.UnionRef;
		    var NULL = spreadsheet.NULLREF;
	
		    /* -----[ Errors ]----- */
	
		    function CalcError(code) {
		        if (code instanceof CalcError) {
		            return code;
		        }
		        this.code = code;
		    }
	
		    CalcError.prototype.toString = function() {
		        return "#" + this.code + (this.code == "NAME" ? "?" : "!");
		    };
	
		    /* -----[ Context ]----- */
	
		    var Context = Class.extend({
		        init: function Context(callback, formula, ss, parent) {
		            this.callback = callback;
		            this.formula = formula;
		            this.ss = ss;
		            this.parent = parent;
		        },
	
		        resolve: function(val) {
		            var self = this;
		            if (val instanceof Ref) {
		                self.resolveCells([ val ], function(){
		                    self._resolve(val);
		                });
		            } else {
		                self._resolve(val);
		            }
		        },
	
		        error: function(val) {
		            return new CalcError(val);
		        },
	
		        _resolve: function(val) {
		            if (val === undefined) {
		                val = null;
		            } else if (Array.isArray(val)) {
		                val = this.asMatrix(val);
		            } else {
		                val = maybeRoundFloatErrors(val);
		            }
		            var f = this.formula;
		            if (f.arrayFormulaRange) {
		                // when this is an array formula, make sure we return a Matrix.  The value already
		                // *should* be a Matrix, so this won't incur speed penalty in normal cases.
		                val = this.asMatrix(val) || this.asMatrix([[ val ]]);
		            } else if (val instanceof RangeRef) {
		                val = this._arrayArg(val);
		            }
		            f.value = val;
		            if (this.ss.onFormula(f) && this.callback) {
		                this.callback.call(f, val);
		            }
		        },
	
		        resolveCells: function(a, f) {
		            var context = this, formulas = [];
	
		            (function loop(a){
		                for (var i = 0; i < a.length; ++i) {
		                    var x = a[i];
		                    if (x instanceof Ref) {
		                        add(context.getRefCells(x));
		                    }
		                    if (Array.isArray(x)) {
		                        // make sure we resolve cells in literal matrices
		                        loop(x);
		                    }
		                }
		            })(a);
	
		            if (!formulas.length) {
		                return f.call(context);
		            }
	
		            for (var pending = formulas.length, i = 0; i < formulas.length; ++i) {
		                fetch(formulas[i]);
		            }
		            function fetch(formula) { // jshint ignore:line, because you are stupid.
		                formula.exec(context.ss, function(){
		                    if (!--pending) {
		                        f.call(context);
		                    }
		                }, context);
		            }
		            function add(a) {
		                for (var i = 0; i < a.length; ++i) {
		                    var cell = a[i];
		                    if (cell.formula) {
		                        formulas.push(cell.formula);
		                    }
		                }
		                return true;
		            }
		        },
	
		        cellValues: function(a, wantNulls) {
		            var ret = [];
		            for (var i = 0; i < a.length; ++i) {
		                var val = a[i];
		                if (val instanceof Ref) {
		                    val = this.getRefData(val, wantNulls);
		                    ret = ret.concat(val);
		                } else if (Array.isArray(val)) {
		                    ret = ret.concat(this.cellValues(val, wantNulls));
		                } else if (val instanceof Matrix) {
		                    ret = ret.concat(this.cellValues(val.data, wantNulls));
		                } else {
		                    ret.push(val);
		                }
		            }
		            return ret;
		        },
	
		        fetchName: function(ref, callback) {
		            var f = this.formula;
		            var val = this.ss.nameValue(ref, f.sheet, f.row, f.col);
		            if (val instanceof Formula) {
		                // clone and relocate to calling formula, so that relative references in a named
		                // formula would work as expected.
		                val = val.clone(f.sheet, f.row, f.col, true);
	
		                // XXX: I don't like this dependency here; basically we only need ss.onFormula to
		                // return true and do nothing else.
		                var ss = new spreadsheet.ValidationFormulaContext(this.ss.workbook);
	
		                val.exec(ss, callback, this);
		            } else {
		                if (val instanceof Ref) {
		                    // relocate for relative refs
		                    val = val.absolute(f.row, f.col);
		                    if (!val.sheet) {
		                        val.sheet = f.sheet;
		                    }
		                }
		                callback(val == null ? new CalcError("NAME") : val);
		            }
		        },
	
		        force: function(val) {
		            if (val instanceof Ref) {
		                return this.getRefData(val);
		            }
		            return val;
		        },
	
		        func: function(fname, callback, args) {
		            fname = fname.toLowerCase();
		            var f = FUNCS[fname];
		            if (f) {
		                return f.call(this, callback, args);
		            }
		            callback(new CalcError("NAME"));
		        },
	
		        bool: function(val) {
		            if (val instanceof Ref) {
		                val = this.getRefData(val);
		            }
		            if (typeof val == "string") {
		                return val.toLowerCase() == "true";
		            }
		            if (typeof val == "number") {
		                return val !== 0;
		            }
		            if (typeof val == "boolean") {
		                return val;
		            }
		            return val != null;
		        },
	
		        _arrayArg: function(ref) { // not necessarily a reference though
		            var f = this.formula;
		            if (!f.arrayFormulaRange && ref instanceof RangeRef) {
		                // if formula wasn't saved with Ctrl-Shift-Enter but a range is passed, Excel does
		                // something special:
		                //
		                // - if range is Wx1 (horizontal array) and current formula resides within the
		                //   horizontal bounds of the range, the appropriate cell is selected.  Example:
		                //   A1..D1 contain 1, 2, 3, 4 and we have in B2: =A1:D1, then B2 will get 2 (the
		                //   value in A2).  If the same formula is typed outside the horizontal span of the
		                //   range, say in E2: =A1:D1, then #VALUE! is returned.
		                //
		                // - similarly, if the range is 1xH (vertical array), the formula must reside within
		                //   the vertical bounds of the range and it gets the corresponding cell; otherwise,
		                //   #VALUE!.
		                if (ref.height() == 1 && f.col >= ref.topLeft.col && f.col <= ref.bottomRight.col) {
		                    return this.getRefData(new CellRef(ref.topLeft.row, f.col).setSheet(ref.sheet));
		                }
		                if (ref.width() == 1 && f.row >= ref.topLeft.row && f.row <= ref.bottomRight.row) {
		                    return this.getRefData(new CellRef(f.row, ref.topLeft.col).setSheet(ref.sheet));
		                }
		                return new CalcError("VALUE");
		            } else {
		                return this.asMatrix(ref);
		            }
		        },
	
		        asMatrix: function(range) {
		            if (range instanceof Matrix) {
		                return range;
		            }
		            var self = this;
		            if (range instanceof RangeRef) {
		                var tl = range.topLeft;
		                var top = tl.row, left = tl.col;
		                var cells = self.getRefCells(range);
		                var m = new Matrix(self);
		                if (isFinite(range.width())) {
		                    m.width = range.width();
		                }
		                if (isFinite(range.height())) {
		                    m.height = range.height();
		                }
		                if (!isFinite(top)) {
		                    top = 0;
		                }
		                if (!isFinite(left)) {
		                    left = 0;
		                }
		                cells.forEach(function(cell){
		                    m.set(cell.row - top,
		                          cell.col - left,
		                          cell.value);
		                });
		                return m;
		            }
		            if (Array.isArray(range) && range.length > 0) {
		                var m = new Matrix(self), row = 0;
		                range.forEach(function(line){
		                    var col = 0;
		                    var h = 1;
		                    line.forEach(function(el){
		                        var isRange = el instanceof RangeRef;
		                        if (el instanceof Ref && !isRange) {
		                            el = self.getRefData(el);
		                        }
		                        if (isRange || Array.isArray(el)) {
		                            el = self.asMatrix(el);
		                        }
		                        if (el instanceof Matrix) {
		                            el.each(function(el, r, c){
		                                m.set(row + r, col + c, el);
		                            });
		                            h = Math.max(h, el.height);
		                            col += el.width;
		                        } else {
		                            m.set(row, col++, el);
		                        }
		                    });
		                    row += h;
		                });
		                return m;
		            }
		        },
	
		        getRefCells: function(refs, hiddenInfo, wantNulls) {
		            var f = this.formula;
		            return this.ss.getRefCells(refs, hiddenInfo, f.sheet, f.row, f.col, wantNulls);
		        },
	
		        getRefData: function(ref, wantNulls) {
		            var f = this.formula;
		            return this.ss.getData(ref, f.sheet, f.row, f.col, wantNulls);
		        },
	
		        workbook: function() {
		            return this.ss.workbook;
		        }
		    });
	
		    var Matrix = Class.extend({
		        init: function Matrix(context) {
		            this.context = context;
		            this.height = 0;
		            this.width = 0;
		            this.data = [];
		        },
		        clone: function() {
		            var m = new Matrix(this.context);
		            m.height = this.height;
		            m.width = this.width;
		            m.data = this.data.map(function(row){ return row.slice(); });
		            return m;
		        },
		        get: function(row, col) {
		            var line = this.data[row];
		            var val = line ? line[col] : null;
		            return val instanceof Ref ? this.context.getRefData(val) : val;
		        },
		        getNA: function(row, col) {
		            if (row < this.height && col < this.width) {
		                return this.get(row, col);
		            }
		            return new CalcError("N/A");
		        },
		        set: function(row, col, data) {
		            var line = this.data[row];
		            if (line == null) {
		                line = this.data[row] = [];
		            }
		            line[col] = data;
		            if (row >= this.height) {
		                this.height = row + 1;
		            }
		            if (col >= this.width) {
		                this.width = col + 1;
		            }
		        },
		        each: function(f, includeEmpty) {
		            for (var row = 0; row < this.height; ++row) {
		                for (var col = 0; col < this.width; ++col) {
		                    var val = this.get(row, col);
		                    if (includeEmpty || val != null) {
		                        val = f.call(this.context, val, row, col);
		                        if (val !== undefined) {
		                            return val;
		                        }
		                    }
		                }
		            }
		        },
		        map: function(f, includeEmpty) {
		            var m = new Matrix(this.context);
		            this.each(function(el, row, col){
		                // here `this` is actually the context
		                m.set(row, col, f.call(this, el, row, col));
		            }, includeEmpty);
		            return m;
		        },
		        eachRow: function(f) {
		            for (var row = 0; row < this.height; ++row) {
		                var val = f.call(this.context, row);
		                if (val !== undefined) {
		                    return val;
		                }
		            }
		        },
		        eachCol: function(f) {
		            for (var col = 0; col < this.width; ++col) {
		                var val = f.call(this.context, col);
		                if (val !== undefined) {
		                    return val;
		                }
		            }
		        },
		        mapRow: function(f) {
		            var m = new Matrix(this.context);
		            this.eachRow(function(row){
		                m.set(row, 0, f.call(this.context, row));
		            });
		            return m;
		        },
		        mapCol: function(f) {
		            var m = new Matrix(this.context);
		            this.eachCol(function(col){
		                m.set(0, col, f.call(this.context, col));
		            });
		            return m;
		        },
		        toString: function() {
		            return JSON.stringify(this.data);
		        },
		        transpose: function() {
		            var m = new Matrix(this.context);
		            this.each(function(el, row, col){
		                m.set(col, row, el);
		            });
		            return m;
		        },
		        unit: function(n) {
		            this.width = this.height = n;
		            var a = this.data = new Array(n);
		            for (var i = n; --i >= 0;) {
		                var row = a[i] = new Array(n);
		                for (var j = n; --j >= 0;) {
		                    row[j] = i == j ? 1 : 0;
		                }
		            }
		            return this;
		        },
		        multiply: function(b) {
		            var a = this, m = new Matrix(a.context);
		            for (var row = 0; row < a.height; ++row) {
		                for (var col = 0; col < b.width; ++col) {
		                    var s = 0;
		                    for (var i = 0; i < a.width; ++i) {
		                        var va = a.get(row, i);
		                        var vb = b.get(i, col);
		                        if (typeof va != "number" || typeof vb != "number") {
		                            throw new CalcError("VALUE");
		                        }
		                        s += va * vb;
		                    }
		                    m.set(row, col, s);
		                }
		            }
		            return m;
		        },
		        adds: function(b, s) {
		            var a = this, m = new Matrix(a.context);
		            var sign = s ? -1 : 1;
		            for (var row = 0; row < a.height; ++row) {
		                for (var col = 0; col < a.width; ++col) {
		                    var x = a.get(row, col),
		                        y = b.get(row, col);
		                    m.set(row, col, x + sign * y);
		                }
		            }
		            return m;
		        },
		        determinant: function() {
		            var a = this.clone().data;
		            var n = a.length;
		            var d = 1, C, L, i, k;
		            for (C = 0; C < n; C++) {
		                for (L = C; (L < n) && (!a[L][C]); L++) {}
		                if (L == n) {
		                    return 0;
		                }
		                if (L != C) {
		                    d = -d;
		                    for (k = C; k < n; k++) {
		                        var t = a[C][k];
		                        a[C][k] = a[L][k];
		                        a[L][k] = t;
		                    }
		                }
		                for (i = C+1; i < n; i++) {
		                    for (k = C+1; k < n; k++) {
		                        a[i][k] -= a[C][k] * a[i][C] / a[C][C];
		                    }
		                }
		                d *= a[C][C];
		            }
		            return d;
		        },
		        inverse: function() {
		            var n = this.width;
		            var m = this.augment(new Matrix(this.context).unit(n));
		            var a = m.data;
		            var tmp;
	
		            // Gaussian elimination
		            // https://en.wikipedia.org/wiki/Gaussian_elimination#Finding_the_inverse_of_a_matrix
	
		            // 1. Get zeros below main diagonal
		            for (var k = 0; k < n; ++k) {
		                var imax = argmax(k, n, function(i){ return a[i][k]; });
		                if (!a[imax][k]) {
		                    return null; // singular matrix
		                }
		                if (k != imax) {
		                    tmp = a[k];
		                    a[k] = a[imax];
		                    a[imax] = tmp;
		                }
		                for (var i = k+1; i < n; ++i) {
		                    for (var j = k+1; j < 2*n; ++j) {
		                        a[i][j] -= a[k][j] * a[i][k] / a[k][k];
		                    }
		                    a[i][k] = 0;
		                }
		            }
	
		            // 2. Get 1-s on main diagonal, dividing by pivot
		            for (var i = 0; i < n; ++i) {
		                for (var f = a[i][i], j = 0; j < 2*n; ++j) {
		                    a[i][j] /= f;
		                }
		            }
	
		            // 3. Get zeros above main diagonal.  Actually, we only care to compute the right side
		            // here (that will be the inverse), so in the inner loop below we go while j >= n,
		            // instead of j >= k.
		            for (var k = n; --k >= 0;) {
		                for (var i = k; --i >= 0;) {
		                    if (a[i][k]) {
		                        for (var j = 2*n; --j >= n;) {
		                            a[i][j] -= a[k][j] * a[i][k];
		                        }
		                    }
		                }
		            }
	
		            return m.slice(0, n, n, n);
		        },
		        augment: function(m) {
		            var ret = this.clone(), n = ret.width;
		            m.each(function(val, row, col){
		                ret.set(row, col + n, val);
		            });
		            return ret;
		        },
		        slice: function(row, col, height, width) {
		            var m = new Matrix(this.context);
		            for (var i = 0; i < height; ++i) {
		                for (var j = 0; j < width; ++j) {
		                    m.set(i, j, this.get(row + i, col + j));
		                }
		            }
		            return m;
		        }
	
		        // XXX: debug
		        // dump: function() {
		        //     this.data.forEach(function(row){
		        //         console.log(row.map(function(val){
		        //             var str = val.toFixed(3).replace(/\.?0*$/, function(s){
		        //                 return [ "", " ", "  ", "   ", "    " ][s.length];
		        //             });
		        //             if (val >= 0) { str = " " + str; }
		        //             return str;
		        //         }).join("  "));
		        //     });
		        // }
		    });
	
		    function argmax(i, end, f) {
		        var max = f(i), pos = i;
		        while (++i < end) {
		            var v = f(i);
		            if (v > max) {
		                max = v;
		                pos = i;
		            }
		        }
		        return pos;
		    }
	
		    /* -----[ Formula ]----- */
	
		    var Formula = Class.extend({
		        init: function Formula(refs, handler, printer, sheet, row, col, arrayFormulaRange){
		            this.refs = refs;
		            this.handler = handler;
		            this.print = printer;
		            this.absrefs = null;
		            this.sheet = sheet;
		            this.row = row;
		            this.col = col;
		            this.onReady = [];
		            this.pending = false;
		            this.arrayFormulaRange = arrayFormulaRange;
		        },
		        setArrayFormulaRange: function(ref) {
		            this.arrayFormulaRange = ref.clone().setSheet(this.sheet);
		        },
		        clone: function(sheet, row, col, forceRefs) {
		            var lcsheet = sheet.toLowerCase();
		            var refs = this.refs;
		            var range = this.arrayFormulaRange;
		            if (forceRefs || lcsheet != this.sheet.toLowerCase()) {
		                refs = refs.map(function(ref){
		                    if (!ref.hasSheet() && (!ref.sheet || ref.sheet.toLowerCase() != lcsheet)) {
		                        ref = ref.clone().setSheet(sheet);
		                    }
		                    return ref;
		                });
		                if (range) {
		                    range = range.clone().setSheet(sheet);
		                }
		            }
		            return new Formula(refs, this.handler, this.print, sheet, row, col, range);
		        },
		        deepClone: function() {
		            var refs = this.refs.map(function(ref){ return ref.clone(); });
		            return new Formula(refs, this.handler, this.print, this.sheet, this.row, this.col, this.arrayFormulaRange);
		        },
		        resolve: function(val) {
		            this.pending = false;
		            this.onReady.forEach(function(callback){
		                callback(val);
		            });
		        },
		        exec: function(ss, callback, parentContext) {
		            if ("value" in this) {
		                if (callback) {
		                    callback(this.value);
		                }
		            } else {
		                if (callback) {
		                    this.onReady.push(callback);
		                }
	
		                var ctx = new Context(this.resolve, this, ss, parentContext);
		                var level = 0;
		                // if the call chain leads back to this same formula, we have a circular dependency.
		                while (parentContext) {
		                    if (parentContext.formula === this) {
		                        this.pending = false;
		                        ctx.resolve(new CalcError("CIRCULAR"));
		                        return;
		                    }
		                    parentContext = parentContext.parent;
		                    ++level;
		                }
	
		                // pending is still useful for ASYNC formulas
		                if (this.pending) {
		                    return;
		                }
		                this.pending = true;
	
		                var next = function() {
		                    // compute and cache the absolute references
		                    if (!this.absrefs) {
		                        this.absrefs = this.refs.map(function(ref){
		                            return ref.absolute(this.row, this.col);
		                        }, this);
		                    }
	
		                    // finally invoke the handler given to us by the compiler in calc.js
		                    this.handler.call(ctx);
		                }.bind(this);
	
		                if (level < 20) {
		                    next();
		                } else {
		                    setTimeout(next, 0);
		                }
		            }
		        },
		        reset: function() {
		            this.onReady = [];
		            this.pending = false;
		            delete this.value;
		        },
		        renameSheet: function(oldSheetName, newSheetName) {
		            oldSheetName = oldSheetName.toLowerCase();
		            this.absrefs = null;
		            if (this.sheet.toLowerCase() == oldSheetName) {
		                this.sheet = newSheetName;
		            }
		            this.refs.forEach(function(ref){
		                ref.renameSheet(oldSheetName, newSheetName);
		            });
		        },
		        adjust: function(affectedSheet, operation, start, delta) {
		            affectedSheet = affectedSheet.toLowerCase();
		            var formulaRow = this.row;
		            var formulaCol = this.col;
		            var formulaSheet = this.sheet.toLowerCase();
		            var formulaMoves = false;
		            if (formulaSheet == affectedSheet) {
		                // move formula if it's after the change point
		                if (operation == "row" && formulaRow >= start) {
		                    this.row += delta;
		                    formulaMoves = true;
		                }
		                if (operation == "col" && formulaCol >= start) {
		                    this.col += delta;
		                    formulaMoves = true;
		                }
		            }
		            var newFormulaRow = this.row;
		            var newFormulaCol = this.col;
		            this.absrefs = null;
		            var prevRefs = this.refs;
		            var modified = formulaMoves;
		            this.refs = prevRefs.map(function(ref){
		                var newRef = adjust(ref);
		                if (!modified && !sameRef(newRef, ref)) {
		                    modified = true;
		                }
		                return newRef;
		            });
	
		            var prevRange = this.arrayFormulaRange;
		            if (prevRange) {
		                this.arrayFormulaRange = adjust(prevRange);
		                if (!modified && !sameRef(prevRange, this.arrayFormulaRange)) {
		                    modified = true;
		                }
		            }
	
		            if (modified) {
		                // return a clone of the original formula.  needed to undo operations like
		                // deleteRow, which can transform a reference into NULL.
		                return new Formula(prevRefs, this.handler, this.print, this.sheet, formulaRow, formulaCol, prevRange);
		            }
	
		            function adjust(ref){
		                if (ref === NULL) {
		                    return ref;
		                }
		                if (ref.sheet.toLowerCase() != affectedSheet) {
		                    if (formulaMoves) {
		                        // a reference to another sheet should still point to the same location
		                        // after adjustment; thus if row/col was removed before formula, relative
		                        // references must be adjusted by delta.
		                        if (operation == "row" && formulaRow >= start) {
		                            ref = ref.relative(delta, 0);
		                        }
		                        if (operation == "col" && formulaCol >= start) {
		                            ref = ref.relative(0, delta);
		                        }
		                    }
		                    return ref;
		                }
		                return ref.adjust(
		                    formulaRow, formulaCol,
		                    newFormulaRow, newFormulaCol,
		                    operation == "row",
		                    start, delta
		                );
		            }
		        },
		        toString: function() {
		            return this.print(this.row, this.col);
		        }
		    });
	
		    function sameRef(r1, r2) {
		        // note: r1.eq(r2) will not do, because it returns true for A1 and A1:A1 (CellRef
		        // vs. RangeRef).  To properly undo we need to assert that the references are exactly the
		        // same (including type).
		        if (r1.constructor !== r2.constructor) {
		            return false;
		        }
		        if (r1 instanceof CellRef) {
		            return r1.sheet == r2.sheet
		                && r1.row == r2.row
		                && r1.col == r2.col
		                && r1.rel == r2.rel;
		        }
		        if (r1 instanceof RangeRef) {
		            return sameRef(r1.topLeft     , r2.topLeft)
		                && sameRef(r1.bottomRight , r2.bottomRight)
		                && r1.endSheet == r2.endSheet;
		        }
		        if (r1 instanceof UnionRef) {
		            var i = r1.refs.length;
		            if (i != r2.refs.length) {
		                return false;
		            }
		            while (--i >= 0) {
		                if (!sameRef(r1.refs[i], r2.refs[i])) {
		                    return false;
		                }
		            }
		        }
		        return true;
		    }
	
		    // spreadsheet functions --------
		    var FUNCS = Object.create(null);
	
		    FUNCS["if"] = function(callback, args) {
		        var self = this;
		        var co = args[0], th = args[1], el = args[2];
		        // XXX: I don't like this resolveCells here.  We should try to declare IF with
		        // defineFunction.
		        this.resolveCells([ co ], function(){
		            var comatrix = self.asMatrix(co);
		            if (comatrix) {
		                // XXX: calling both branches in this case, since we'll typically need values from
		                // both.  We could optimize and call them only when first needed, but oh well.
		                th(function(th){
		                    el(function(el){
		                        var thmatrix = self.asMatrix(th);
		                        var elmatrix = self.asMatrix(el);
		                        callback(comatrix.map(function(val, row, col){
		                            if (val instanceof CalcError) {
		                                return val;
		                            } else if (self.bool(val)) {
		                                return thmatrix ? thmatrix.get(row, col) : th;
		                            } else {
		                                return elmatrix ? elmatrix.get(row, col) : el;
		                            }
		                        }));
		                    });
		                });
		            } else {
		                co = this.force(co);
		                if (co instanceof CalcError) {
		                    callback(co);
		                } else if (self.bool(co)) {
		                    th(callback);
		                } else {
		                    el(callback);
		                }
		            }
		        });
		    };
	
		    FUNCS["φ"] = function(callback) {
		        callback((1+Math.sqrt(5))/2);
		    };
	
		    // Lasciate ogni speranza, voi ch'entrate.
		    //
		    // XXX: document this function.
		    function compileArgumentChecks(functionName, args) {
		        var arrayArgs = "function arrayArgs(args) { var xargs = [], width = 0, height = 0, arrays = [], i = 0; ";
		        var resolve = "function resolve(args, callback) { var toResolve = [], i = 0; ";
		        var name, forced, main = "'use strict'; function check(args) { var stack = [], tmp, xargs = [], i = 0, m, err = 'VALUE'; ", haveForced = false;
		        var canBeArrayArg = false, hasArrayArgs = false;
		        main += args.map(comp).join("");
		        main += "if (i < args.length) return new CalcError('N/A'); ";
		        main += "return xargs; } ";
		        arrayArgs += "return { args: xargs, width: width, height: height, arrays: arrays }; } ";
	
		        var f;
		        if (haveForced) {
		            resolve += "this.resolveCells(toResolve, callback); } ";
		            f = new Function("CalcError", "round", main + resolve + arrayArgs + " return { resolve: resolve, check: check, arrayArgs: arrayArgs };");
		        } else {
		            f = new Function("CalcError", "round", main + " return { check: check };");
		        }
		        f = f(CalcError, limitPrecision);
		        if (!hasArrayArgs) {
		            delete f.arrayArgs;
		        }
		        return f;
	
		        function comp(x) {
		            name = x[0];
		            var code = "{ ";
		            if (Array.isArray(name)) {
		                arrayArgs += "while (i < args.length) { ";
		                resolve += "while (i < args.length) { ";
		                code += "xargs.push(tmp = []); stack.push(xargs); xargs = tmp; ";
		                code += "while (i < args.length) { ";
		                code += x.map(comp).join("");
		                code += "} ";
		                code += "xargs = stack.pop(); ";
		                resolve += "} ";
		                arrayArgs += "} ";
		            } else if (name == "+") {
		                arrayArgs += "while (i < args.length) { ";
		                resolve += "while (i < args.length) { ";
		                code += "if (i >= args.length) return new CalcError('N/A'); ";
		                code += "xargs.push(tmp = []); stack.push(xargs); xargs = tmp; ";
		                code += "do { ";
		                code += x.slice(1).map(comp).join("");
		                code += "} while (i < args.length); ";
		                code += "xargs = stack.pop(); ";
		                resolve += "} ";
		                arrayArgs += "} ";
		            } else if (name == "?") {
		                // standalone assertion without a new argument
		                code += "if (!(" + cond(x[1]) + ")) return new CalcError(err); ";
		            } else {
		                var type = x[1];
		                if (Array.isArray(type) && /^#?collect/.test(type[0])) {
		                    var wantNulls = /!$/.test(type[0]);
		                    var n = type[2];
		                    force();
		                    code += "try {"
		                        + "var $" + name + " = this.cellValues(args.slice(i";
		                    if (n) {
		                        code += ", i + " + n;
		                    }
		                    code += ")" + (wantNulls ? ",true" : "") + ").reduce(function(ret, $"+name+"){ ";
		                    if (type[0].charAt(0) != "#") {
		                        code += "if ($"+name+" instanceof CalcError) throw $"+name+"; ";
		                    }
		                    code += "if (" + cond(type[1]) + ") ret.push($"+name+"); ";
		                    code += "return ret; ";
		                    code += "}.bind(this), []); ";
		                    if (n) {
		                        code += "i += " + n + "; ";
		                    } else {
		                        code += "i = args.length; ";
		                    }
		                    code += "xargs.push($"+name+")"
		                        + "} catch(ex) { if (ex instanceof CalcError) return ex; throw ex; } ";
		                    resolve += "toResolve.push(args.slice(i)); ";
		                } else if (type == "rest") {
		                    code += "xargs.push(args.slice(i)); i = args.length; ";
		                } else {
		                    if ((canBeArrayArg = /^\*/.test(name))) {
		                        hasArrayArgs = true;
		                        name = name.substr(1);
		                    }
		                    code += "var $" + name + " = args[i++]; ";
		                    var allowError = false;
		                    if (/!$/.test(type)) {
		                        type = type.substr(0, type.length - 1);
		                        allowError = true;
		                    } else {
		                        code += "if ($"+name+" instanceof CalcError) return $"+name+"; ";
		                    }
		                    code += typeCheck(type, allowError) + "xargs.push($"+name+"); ";
		                }
		            }
		            code += "} ";
		            return code;
		        }
	
		        function force() {
		            if (forced) {
		                return "$"+name+"";
		            }
		            haveForced = true;
		            forced = true;
		            resolve += "toResolve.push(args[i++]); ";
		            return "($"+name+" = this.force($"+name+"))";
		        }
	
		        function forceNum(round) {
		            return "("
		                +     (round
		                       ? ("(typeof " + force() + " == 'number' ? ($"+name+" = round($"+name+"), true) : false) || ")
		                       : ("(typeof " + force() + " == 'number') || "))
		                +     "(typeof $"+name+" == 'boolean' ? ($"+name+" = +$" + name + ", true) : false) || "
		                +     "(typeof $"+name+" == 'string' && !/^(?:=|true|false)/i.test($"+name+") ? ("
		                +       "tmp = kendo.spreadsheet.calc.parse(0, 0, 0, $"+name+"), "
		                +       "/^date|number|percent$/.test(tmp.type) ? ($"+name+" = +tmp.value, true) : false"
		                +     ") : false)"
		                +  ")";
		        }
	
		        function typeCheck(type, allowError) {
		            forced = false;
		            var ret = "if (!(" + cond(type) + ")) { ";
		            if (forced && !allowError) {
		                ret += " if ($" + name + " instanceof CalcError) return $" + name + "; ";
		            }
		            ret += "return new CalcError(err); } ";
		            if (!forced) {
		                resolve += "i++; ";
		            }
		            if (canBeArrayArg) {
		                arrayArgs += "var $" + name + " = this._arrayArg(args[i]); "
		                    + "if ($" + name + ") { "
		                    + "xargs.push($" + name + "); "
		                    + "width = Math.max(width, $" + name + ".width); "
		                    + "height = Math.max(height, $" + name + ".height); "
		                    + "arrays.push(true) } else { "
		                    + "xargs.push(args[i]); "
		                    + "arrays.push(false); } i++; ";
		            } else {
		                arrayArgs += "xargs.push(args[i++]); arrays.push(false); ";
		            }
		            return ret;
		        }
	
		        function cond(type) {
		            if (Array.isArray(type)) {
		                if (type[0] == "or") {
		                    return "(" + type.slice(1).map(cond).join(") || (") + ")";
		                }
		                if (type[0] == "and") {
		                    return "(" + type.slice(1).map(cond).join(") && (") + ")";
		                }
		                if (type[0] == "values") {
		                    return "(" + type.slice(1).map(function(val){
		                        return force() + " === " + val;
		                    }).join(") || (") + ")";
		                }
		                if (type[0] == "null") {
		                    return "(" + cond("null") + " ? (($"+name+" = " + type[1] + "), true) : false)";
		                }
		                if (type[0] == "between" || type[0] == "[between]") {
		                    return "(" + force() + " >= " + type[1] + " && " + "$"+name+" <= " + type[2] + " ? true : ((err = 'NUM'), false))";
		                }
		                if (type[0] == "(between)") {
		                    return "(" + force() + " > " + type[1] + " && " + "$"+name+" < " + type[2] + " ? true : ((err = 'NUM'), false))";
		                }
		                if (type[0] == "(between]") {
		                    return "(" + force() + " > " + type[1] + " && " + "$"+name+" <= " + type[2] + " ? true : ((err = 'NUM'), false))";
		                }
		                if (type[0] == "[between)") {
		                    return "(" + force() + " >= " + type[1] + " && " + "$"+name+" < " + type[2] + " ? true : ((err = 'NUM'), false))";
		                }
		                if (type[0] == "assert") {
		                    var err = type[2] || "N/A";
		                    return "((" + type[1] + ") ? true : (err = " + JSON.stringify(err) + ", false))";
		                }
		                if (type[0] == "not") {
		                    return "!(" + cond(type[1]) + ")";
		                }
		                throw new Error("Unknown array type condition: " + type[0]);
		            }
		            if (type == "number" || type == "datetime") {
		                return forceNum(true);
		            }
		            if (type == "number!") {
		                return "(typeof " + force() + " == 'number' ? ($"+name+" = round($"+name+"), true) : false)";
		            }
		            if (type == "integer" || type == "date") {
		                return "(" + forceNum() + " && (($"+name+" |= 0), true))";
		            }
		            if (type == "divisor") {
		                return "(" + forceNum(true) + " && ($"+name+" == 0 ? ((err = 'DIV/0'), false) : true))";
		            }
		            if (type == "number+") {
		                return "(" + forceNum(true) + " && ($"+name+" >= 0 ? true : ((err = 'NUM'), false)))";
		            }
		            if (type == "integer+") {
		                return "(" + forceNum() + " && (($"+name+" |= 0) >= 0 ? true : ((err = 'NUM'), false)))";
		            }
		            if (type == "number++") {
		                return "(" + forceNum(true) + " && ($"+name+" > 0 ? true : ((err = 'NUM'), false)))";
		            }
		            if (type == "integer++") {
		                return "(" + forceNum() + " && (($"+name+" |= 0) > 0 ? true : ((err = 'NUM'), false)))";
		            }
		            if (type == "string") {
		                return "((typeof " + force() + " == 'string' || typeof $"+name+" == 'boolean' || typeof $"+name+" == 'number') ? ($"+name+" += '', true) : ($"+name+" === undefined ? (($"+name+" = ''), true) : false))";
		            }
		            if (type == "boolean") {
		                return "(typeof " + force() + " == 'boolean')";
		            }
		            if (type == "logical") {
		                return "(typeof " + force() + " == 'boolean' || (typeof $"+name+" == 'number' ? ($"+name+" = !!$"+name+", true) : false))";
		            }
		            if (type == "matrix") {
		                force();
		                return "((m = this.asMatrix($"+name+")) ? ($"+name+" = m) : false)";
		            }
		            if (type == "#matrix") {
		                return "((m = this.asMatrix($"+name+")) ? ($"+name+" = m) : false)";
		            }
		            if (type == "ref") {
		                return "($"+name+" instanceof kendo.spreadsheet.Ref)";
		            }
		            if (type == "area") {
		                return "($"+name+" instanceof kendo.spreadsheet.CellRef || $"+name+" instanceof kendo.spreadsheet.RangeRef)";
		            }
		            if (type == "cell") {
		                return "($"+name+" instanceof kendo.spreadsheet.CellRef)";
		            }
		            if (type == "null") {
		                return "(" + force() + " == null)";
		            }
		            if (type == "anyvalue") {
		                return "(" + force() + " != null && i <= args.length)";
		            }
		            if (type == "forced") {
		                return "(" + force() + ", i <= args.length)";
		            }
		            if (type == "anything") {
		                return "(i <= args.length)";
		            }
		            if (type == "blank") {
		                return "(" + force() + " == null || $"+name+" === '')";
		            }
		            throw new Error("Can't check for type: " + type);
		        }
		    }
	
		    function limitPrecision(num) {
		        return num === parseInt(num, 10) ? num : +num.toPrecision(14);
		    }
	
		    function maybeRoundFloatErrors(num) {
		        if (typeof num == "number") {
		            return limitPrecision(num);
		        } else {
		            return num;
		        }
		    }
	
		    function withErrorHandling(obj, f, args) {
		        if (args instanceof CalcError) {
		            return args;
		        }
		        try {
		            return f.apply(obj, args);
		        } catch(ex) {
		            if (ex instanceof CalcError) {
		                return ex;
		            } else {
		                throw ex;
		            }
		        }
		    }
	
		    function makeSyncFunction(handler, resolve, check, arrayArgs) {
		        return function(callback, args) {
		            function doit() {
		                if (arrayArgs) {
		                    var x = arrayArgs.call(this, args);
		                    args = x.args;
		                    if (x.width > 0 && x.height > 0) {
		                        var result = new Matrix(this);
		                        for (var row = 0; row < x.height; ++row) {
		                            for (var col = 0; col < x.width; ++col) {
		                                var xargs = [];
		                                for (var i = 0; i < args.length; ++i) {
		                                    if (x.arrays[i]) {
		                                        xargs[i] = args[i].getNA(row, col);
		                                    } else {
		                                        xargs[i] = args[i];
		                                    }
		                                }
		                                xargs = check.call(this, xargs);
		                                result.set(row, col, withErrorHandling(this, handler, xargs));
		                            }
		                        }
		                        return callback(result);
		                    }
		                }
		                var xargs = check.call(this, args);
		                callback(withErrorHandling(this, handler, xargs));
		            }
		            if (resolve) {
		                resolve.call(this, args, doit);
		            } else {
		                doit.call(this);
		            }
		        };
		    }
	
		    function makeAsyncFunction(handler, resolve, check, arrayArgs) {
		        return function(callback, args) {
		            function doit() {
		                if (arrayArgs) {
		                    var x = arrayArgs.call(this, args);
		                    args = x.args;
		                    if (x.width > 0 && x.height > 0) {
		                        var result = new Matrix(this);
		                        var count = x.width * x.height;
		                        var makeCallback = function(row, col) {
		                            return function(value) {
		                                result.set(row, col, value);
		                                --count;
		                                if (count === 0) {
		                                    return callback(result);
		                                }
		                            };
		                        };
		                        for (var row = 0; row < x.height && count > 0; ++row) {
		                            for (var col = 0; col < x.width && count > 0; ++col) {
		                                var xargs = [];
		                                for (var i = 0; i < args.length; ++i) {
		                                    if (x.arrays[i]) {
		                                        xargs[i] = args[i].getNA(row, col);
		                                    } else {
		                                        xargs[i] = args[i];
		                                    }
		                                }
		                                xargs = check.call(this, xargs);
		                                if (xargs instanceof CalcError) {
		                                    result.set(row, col, xargs);
		                                    --count;
		                                    if (count === 0) {
		                                        return callback(result);
		                                    }
		                                } else {
		                                    xargs.unshift(makeCallback(row, col));
		                                    handler.apply(this, xargs);
		                                }
		                            }
		                        }
		                        return;
		                    }
		                }
		                var x = check.call(this, args);
		                if (x instanceof CalcError) {
		                    callback(x);
		                } else {
		                    x.unshift(callback);
		                    handler.apply(this, x);
		                }
		            }
		            if (resolve) {
		                resolve.call(this, args, doit);
		            } else {
		                doit.call(this);
		            }
		        };
		    }
	
		    function defineFunction(name, func) {
		        name = name.toLowerCase();
		        FUNCS[name] = func;
		        return {
		            args: function(args, log) {
		                var code = compileArgumentChecks(name, args);
		                // XXX: DEBUG
		                if (log) {
		                    if (code.arrayArgs) {console.log(code.arrayArgs.toString());}
		                    if (code.resolve) {console.log(code.resolve.toString());}
		                    if (code.check) {console.log(code.check.toString());}
		                }
		                var f = FUNCS[name] = makeSyncFunction(func, code.resolve, code.check, code.arrayArgs);
		                f.kendoSpreadsheetArgs = args;
		                return this;
		            },
		            argsAsync: function(args, log) {
		                var code = compileArgumentChecks(name, args);
		                // XXX: DEBUG
		                if (log) {
		                    if (code.arrayArgs) {console.log(code.arrayArgs.toString());}
		                    if (code.resolve) {console.log(code.resolve.toString());}
		                    if (code.check) {console.log(code.check.toString());}
		                }
		                var f = FUNCS[name] = makeAsyncFunction(func, code.resolve, code.check, code.arrayArgs);
		                f.kendoSpreadsheetArgs = args;
		                return this;
		            }
		        };
		    }
	
		    /* -----[ date calculations ]----- */
	
		    // Julian days algorithms from http://www.hermetic.ch/cal_stud/jdn.htm#comp
	
		    function dateToJulianDays(y, m, d) {
		        m++;
		        return ((1461 * (y + 4800 + ((m - 14) / 12 | 0))) / 4 | 0) +
		            ((367 * (m - 2 - 12 * ((m - 14) / 12 | 0))) / 12 | 0) -
		            ((3 * (((y + 4900 + ((m - 14) / 12 | 0)) / 100 | 0))) / 4 | 0) +
		            d - 32075;
		    }
	
		    function julianDaysToDate(jd) {
		        var l, n, j, i, m, d, y;
		        l = jd + 68569;
		        n = (4 * l) / 146097 | 0;
		        l = l - ((146097 * n + 3) / 4 | 0);
		        i = (4000 * (l + 1) / 1461001) | 0;
		        l = l - ((1461 * i) / 4 | 0) + 31;
		        j = (80 * l) / 2447 | 0;
		        d = l - ((2447 * j) / 80 | 0);
		        l = j / 11 | 0;
		        m = j + 2 - (12 * l);
		        y = 100 * (n - 49) + i + l;
		        m--;
		        return {
		            year  : y,
		            month : m,
		            date  : d,
		            day   : (jd + 1) % 7,
		            ord   : ORDINAL_ADD_DAYS[isLeapYear(y)][m] + d
		        };
		    }
	
		    // This uses the Google Spreadsheet approach: treat 1899-12-31 as day 1, allowing to avoid
		    // implementing the "Leap Year Bug" yet still be Excel compatible for dates starting 1900-03-01.
		    var BASE_DATE = dateToJulianDays(1900, 0, -1);
	
		    var DAYS_IN_MONTH = [ 31, 28, 31,
		                          30, 31, 30,
		                          31, 31, 30,
		                          31, 30, 31 ];
	
		    var ORDINAL_ADD_DAYS = [
		        [ 0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334 ], // non-leap year
		        [ 0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335 ]  // leap year
		    ];
	
		    function isLeapYear(yr) {
		        if (yr % 4) {
		            return 0;
		        }
		        if (yr % 100) {
		            return 1;
		        }
		        if (yr % 400) {
		            return 0;
		        }
		        return 1;
		    }
	
		    function daysInYear(yr) {
		        return isLeapYear(yr) ? 366 : 365;
		    }
	
		    function daysInMonth(yr, mo) {
		        return (isLeapYear(yr) && mo == 1) ? 29 : DAYS_IN_MONTH[mo];
		    }
	
		    function validDate(yr, mo, da) {
		        return mo >= 1 && mo <= 12 && da >= 1 && da <= daysInMonth(yr, mo - 1);
		    }
	
		    function unpackDate(serial) {
		        return julianDaysToDate((serial | 0) + BASE_DATE);
		    }
	
		    function packDate(year, month, date) {
		        return dateToJulianDays(year, month, date) - BASE_DATE;
		    }
	
		    var MS_IN_MIN = 60 * 1000;
		    var MS_IN_HOUR = 60 * MS_IN_MIN;
		    var MS_IN_DAY = 24 * MS_IN_HOUR;
	
		    function unpackTime(serial) {
		        var frac = serial - (serial|0);
		        if (frac < 0) {
		            frac++;
		        }
		        var ms = Math.round(MS_IN_DAY * frac);
		        var hours = Math.floor(ms / MS_IN_HOUR);
		        ms -= hours * MS_IN_HOUR;
		        var minutes = Math.floor(ms / MS_IN_MIN);
		        ms -= minutes * MS_IN_MIN;
		        var seconds = Math.floor(ms / 1000);
		        ms -= seconds * 1000;
		        return {
		            hours: hours,
		            minutes: minutes,
		            seconds: seconds,
		            milliseconds: ms
		        };
		    }
	
		    function serialToDate(serial) {
		        var d = unpackDate(serial), t = unpackTime(serial);
		        return new Date(d.year, d.month, d.date,
		                        t.hours, t.minutes, t.seconds, t.milliseconds);
		    }
	
		    function packTime(hh, mm, ss, ms) {
		        return (hh+(mm+(ss+ms/1000)/60)/60)/24;
		    }
	
		    function dateToSerial(date) {
		        var time = packTime(date.getHours(),
		                            date.getMinutes(),
		                            date.getSeconds(),
		                            date.getMilliseconds());
		        date = packDate(date.getFullYear(),
		                        date.getMonth(),
		                        date.getDate());
		        if (date < 0) {
		            return date - 1 + time;
		        } else {
		            return date + time;
		        }
		    }
	
		    function parseDate(str, format) {
		        if (format) {
		            format = kendo.spreadsheet.formatting.makeDateFormat(format);
		        }
		        return kendo.parseExactDate(str, format)
		            || kendo.parseExactDate(str)
		            || kendo.parseExactDate(str, [
		                "MMMM dd yyyy",
		                "MMMM dd yy",
		                "MMM dd yyyy",
		                "MMM dd yy",
		                "dd MMMM yyyy",
		                "dd MMMM yy",
		                "dd MMM yyyy",
		                "dd MMM yy",
		                "MMMM dd, yyyy",
		                "MMMM dd, yy",
		                "MMM dd, yyyy",
		                "MMM dd, yy",
		                "MMMM dd",
		                "MMM dd",
		                "MMMM yyyy",
		                "MMM yyyy",
		                "dd MMMM",
		                "dd MMM"
		            ]);
		    }
	
		    /* -----[ exports ]----- */
	
		    exports.CalcError = CalcError;
		    exports.Formula = Formula;
		    exports.Matrix = Matrix;
	
		    exports.packDate = packDate;
		    exports.unpackDate = unpackDate;
		    exports.packTime = packTime;
		    exports.unpackTime = unpackTime;
		    exports.serialToDate = serialToDate;
		    exports.dateToSerial = dateToSerial;
		    exports.daysInMonth = daysInMonth;
		    exports.validDate = validDate;
		    exports.isLeapYear = isLeapYear;
		    exports.daysInYear = daysInYear;
		    exports.parseDate = parseDate;
		    exports.limitPrecision = limitPrecision;
	
		    spreadsheet.dateToNumber = dateToSerial;
		    spreadsheet.numberToDate = serialToDate;
		    spreadsheet.defineFunction = defineFunction;
		    spreadsheet.CalcError = CalcError;
	
		    exports.defineFunction = defineFunction;
		    exports.defineAlias = function(alias, name) {
		        var orig = FUNCS[name];
		        if (!orig) {
		            throw new Error("Function " + name + " is not yet defined");
		        }
		        if (!orig.kendoSpreadsheetAliases) {
		            orig.kendoSpreadsheetAliases = [ name ];
		        }
		        orig.kendoSpreadsheetAliases.push(alias);
		        FUNCS[alias] = orig;
		    };
		    exports.FUNCS = FUNCS;
	
		    /* -----[ Excel operators ]----- */
	
		    var NUMBER_OR_ZERO = [ "or", "number", [ "null", 0 ] ];
	
		    var ARGS_NUMERIC = [
		        [ "*a", NUMBER_OR_ZERO ],
		        [ "*b", NUMBER_OR_ZERO ]
		    ];
	
		    var ARGS_ANYVALUE = [
		        [ "*a", [ "or", "anyvalue", [ "null", 0 ] ] ],
		        [ "*b", [ "or", "anyvalue", [ "null", 0 ] ] ]
		    ];
	
		    defineFunction("binary+", function(a, b){
		        return a + b;
		    }).args(ARGS_NUMERIC);
	
		    defineFunction("binary-", function(a, b){
		        return a - b;
		    }).args(ARGS_NUMERIC);
	
		    defineFunction("binary*", function(a, b){
		        return a * b;
		    }).args(ARGS_NUMERIC);
	
		    defineFunction("binary/", function(a, b){
		        return a / b;
		    }).args([
		        [ "*a", NUMBER_OR_ZERO ],
		        [ "*b", "divisor" ]
		    ]);
	
		    defineFunction("binary^", function(a, b){
		        return Math.pow(a, b);
		    }).args(ARGS_NUMERIC);
	
		    defineFunction("binary&", function(a, b){
		        if (a == null) { a = ""; }
		        if (b == null) { b = ""; }
		        return "" + a + b;
		    }).args([
		        [ "*a", [ "or", "number", "string", "boolean", "null" ] ],
		        [ "*b", [ "or", "number", "string", "boolean", "null" ] ]
		    ]);
	
		    defineFunction("binary=", function(a, b){
		        a = typeof(a) === "string" ? a.toLowerCase() : a;
		        b = typeof(b) === "string" ? b.toLowerCase() : b;
	
		        return a === b;
		    }).args(ARGS_ANYVALUE);
	
		    defineFunction("binary<>", function(a, b){
		        return a !== b;
		    }).args(ARGS_ANYVALUE);
	
		    defineFunction("binary<", binaryCompare(function(a, b){
		        return a < b;
		    })).args(ARGS_ANYVALUE);
	
		    defineFunction("binary<=", binaryCompare(function(a, b){
		        return a <= b;
		    })).args(ARGS_ANYVALUE);
	
		    defineFunction("binary>", binaryCompare(function(a, b){
		        return a > b;
		    })).args(ARGS_ANYVALUE);
	
		    defineFunction("binary>=", binaryCompare(function(a, b){
		        return a >= b;
		    })).args(ARGS_ANYVALUE);
	
		    defineFunction("unary+", function(a){
		        return a;
		    }).args([
		        [ "*a", NUMBER_OR_ZERO ]
		    ]);
	
		    defineFunction("unary-", function(a){
		        return -a;
		    }).args([
		        [ "*a", NUMBER_OR_ZERO ]
		    ]);
	
		    defineFunction("unary%", function(a){
		        return a / 100;
		    }).args([
		        [ "*a", NUMBER_OR_ZERO ]
		    ]);
	
		    // range operator
		    defineFunction("binary:", function(a, b){
		        return new RangeRef(a, b)
		            .setSheet(a.sheet || this.formula.sheet, a.hasSheet());
		    }).args([
		        [ "a", "cell" ],
		        [ "b", "cell" ]
		    ]);
	
		    // union operator
		    defineFunction("binary,", function(a, b){
		        return new UnionRef([ a, b ]);
		    }).args([
		        [ "a", "ref" ],
		        [ "b", "ref" ]
		    ]);
	
		    // intersection operator
		    defineFunction("binary ", function(a, b){
		        return a.intersect(b);
		    }).args([
		        [ "a", "ref" ],
		        [ "b", "ref" ]
		    ]);
	
		    /* -----[ conditionals ]----- */
	
		    defineFunction("not", function(a){
		        return !this.bool(a);
		    }).args([
		        [ "*a", [ "or", "anyvalue", [ "null", 0 ] ] ]
		    ]);
	
		    /* -----[ the IS* functions ]----- */
	
		    defineFunction("isblank", function(val){
		        if (val instanceof CellRef) {
		            val = this.getRefData(val);
		            return val == null;
		        }
		        return false;
		    }).args([
		        [ "*value", "anything!" ]
		    ]);
	
		    defineFunction("iserror", function(val){
		        return val instanceof CalcError;
		    }).args([
		        [ "*value", "forced!" ]
		    ]);
	
		    defineFunction("iserr", function(val){
		        return val instanceof CalcError && val.code != "N/A";
		    }).args([
		        [ "*value", "forced!" ]
		    ]);
	
		    defineFunction("isna", function(val){
		        return val instanceof CalcError && val.code == "N/A";
		    }).args([
		        [ "*value", "forced!" ]
		    ]);
	
		    defineFunction("islogical", function(val){
		        return typeof val == "boolean";
		    }).args([
		        [ "*value", "forced!" ]
		    ]);
	
		    defineFunction("isnontext", function(val){
		        return typeof val != "string";
		    }).args([
		        [ "*value", "forced!" ]
		    ]);
	
		    defineFunction("istext", function(val){
		        return typeof val == "string";
		    }).args([
		        [ "*value", "forced!" ]
		    ]);
	
		    defineFunction("isnumber", function(val){
		        return typeof val == "number";
		    }).args([
		        [ "*value", "forced!" ]
		    ]);
	
		    defineFunction("isref", function(val){
		        // apparently should return true only for cell and range
		        return val instanceof CellRef || val instanceof RangeRef;
		    }).args([
		        [ "*value", "anything!" ]
		    ]);
	
		    /* -----[ resolve NameRef-s ]----- */
	
		    FUNCS[",getname"] = function(callback, args) {
		        this.fetchName(args[0], callback);
		    };
	
		    /// utils
	
		    function binaryCompare(func) {
		        return function(left, right){
		            if (typeof left == "string" && typeof right != "string") {
		                right = right == null ? "" : right + "";
		            }
		            if (typeof left != "string" && typeof right == "string") {
		                left = left == null ? "" : left + "";
		            }
		            if (typeof left == "number" && right == null) {
		                right = 0;
		            }
		            if (typeof right == "number" && left == null) {
		                left = 0;
		            }
		            if (typeof left == "string" && typeof right == "string") {
		                // string comparison is case insensitive
		                left = left.toLowerCase();
		                right = right.toLowerCase();
		            }
		            if (typeof right == typeof left) {
		                return func(left, right);
		            } else {
		                return new CalcError("VALUE");
		            }
		        };
		    }
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1507);
		module.exports = __webpack_require__(1507);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1450:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ }),
	
	/***/ 1507:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1450) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    var $ = kendo.jQuery;
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var spreadsheet = kendo.spreadsheet;
	
		    var exports = {};
		    spreadsheet.validation = exports;
		    var calc = spreadsheet.calc;
		    var Class = kendo.Class;
		    var TRANSPOSE_FORMAT = "_matrix({0})";
		    var DATE_FORMAT = 'DATEVALUE("{0}")';
	
		    calc.runtime.defineFunction("_matrix", function(m){
		        if (typeof m == "string") {
		            // for constant list validation, Excel includes a string
		            // with comma-separated values — make a Matrix from it.
		            m = this.asMatrix([ m.split(/\s*,\s*/) ]);
		        }
		        return m;
		    }).args([
		        [ "m", [ "or", "matrix", "string" ] ]
		    ]);
	
		    function compileValidation(sheet, row, col, validation) {
		        var validationHandler;
		        var comparer;
		        var parsedFromDate;
		        var parsedToDate;
	
		        if (typeof validation === "string") {
		            validation = JSON.parse(validation);
		        }
	
		        if (validation.from) {
		            if (validation.dataType === "list" && !validation.fromIsListValue) {
		                validation.from = kendo.format(TRANSPOSE_FORMAT, validation.from);
		                validation.fromIsListValue = true;
		            }
	
		            if (validation.dataType === "date") {
		                parsedFromDate = calc.runtime.parseDate(validation.from);
		                if (parsedFromDate) {
		                    validation.from = kendo.format(DATE_FORMAT, validation.from);
		                    validation.fromIsDateValue = true;
		                }
		            }
	
		            validation.from = calc.compile(calc.parseFormula(sheet, row, col, validation.from));
		        }
	
		        if (validation.to) {
		            if (validation.dataType === "date") {
		                parsedToDate = calc.runtime.parseDate(validation.to);
		                if (parsedToDate) {
		                    validation.to = kendo.format(DATE_FORMAT, validation.to);
		                    validation.toIsDateValue = true;
		                }
		            }
	
		            validation.to = calc.compile(calc.parseFormula(sheet, row, col, validation.to));
		        }
	
		        if (validation.dataType == "custom") {
		            comparer = exports.validationComparers.custom;
		        } else if (validation.dataType == "list") {
		            comparer = exports.validationComparers.list;
		        } else {
		            comparer = exports.validationComparers[validation.comparerType];
		        }
	
		        if (!comparer) {
		            throw kendo.format("'{0}' comparer is not implemented.", validation.comparerType);
		        }
	
		        validationHandler = function (valueToCompare) { //add 'valueFormat' arg when add isDate comparer
		            var toValue = this.to && this.to_value ? this.to_value : undefined;
	
		            if (valueToCompare === null || valueToCompare === "") {
		                if (this.allowNulls) {
		                    this.value = true;
		                } else {
		                    this.value = false;
		                }
		            } else if (this.dataType == "custom") {
		                this.value = comparer(valueToCompare, this.from_value,  toValue);
		            } else if (this.dataType == "list") {
		                var data = this._getListData();
	
		                this.value = comparer(valueToCompare, data, toValue);
		            } else {
		                //TODO: TYPE CHECK IS REQUIRED ONLY FOR DATE TYPE WHEN SPECIAL COMPARER (ISDATE) IS USED
		                this.value = comparer(valueToCompare, this.from_value,  toValue);
		            }
	
		            return this.value;
		        };
	
		        return new kendo.spreadsheet.validation.Validation($.extend(validation, {
		            handler: validationHandler,
		            sheet: sheet,
		            row: row,
		            col: col
		        }));
		    }
	
		    var Validation = Class.extend({
		        init: function Validation(options){
		            this.handler = options.handler;
		            this.from = options.from;
		            this.to = options.to;
		            this.dataType = options.dataType; //date, time etc
		            this.comparerType =  options.comparerType; //greaterThan, EqaulTo etc
		            this.type = options.type ? options.type : "warning"; //info, warning, reject
		            this.allowNulls = options.allowNulls ? true : false;
		            this.fromIsDateValue = options.fromIsDateValue ? true : false;
		            this.toIsDateValue = options.toIsDateValue ? true : false;
		            this.showButton = options.showButton;
		            this.fromIsListValue = options.fromIsListValue ? true : false;
	
		            //TODO: address to be range / cell ref, and adjust it based on it
		            this.sheet = options.sheet;
		            this.row = options.row;
		            this.col = options.col;
	
		            if (options.tooltipMessageTemplate) {
		                this.tooltipMessageTemplate = options.tooltipMessageTemplate;
		            }
	
		            if (options.tooltipTitleTemplate) {
		                this.tooltipTitleTemplate = options.tooltipTitleTemplate;
		            }
	
		            if (options.messageTemplate) {
		                this.messageTemplate = options.messageTemplate;
		            }
	
		            if (options.titleTemplate) {
		                this.titleTemplate = options.titleTemplate;
		            }
		        },
	
		        _formatMessages: function(format) {
		            var from = this.from ? this.from_value : "";
		            var to = this.to ? this.to_value : "";
	
		            var fromFormula = this.from ? this.from.toString() : "";
		            var toFormula = this.to ? this.to.toString() : "";
		            var dataType = this.dataType;
		            var type = this.type;
		            var comparerType = this.comparerType;
	
		            return kendo.format(format, from, to, fromFormula, toFormula, dataType, type, comparerType);
		        },
	
		        _setMessages: function() {
		            this.title = "";
		            this.message = "";
	
		            if (this.tooltipTitleTemplate) {
		                this.tooltipTitle = this._formatMessages(this.tooltipTitleTemplate);
		            }
	
		            if (this.tooltipMessageTemplate) {
		                this.tooltipMessage = this._formatMessages(this.tooltipMessageTemplate);
		            }
	
		            if (this.titleTemplate) {
		                this.title = this._formatMessages(this.titleTemplate);
		            }
	
		            if (this.messageTemplate) {
		                this.message = this._formatMessages(this.messageTemplate);
		            }
		        },
	
		        _getListData: function() {
		            if (!this.from_value || !this.from_value.data) {
		                return [];
		            }
	
		            var cube = this.from_value.data;
		            var i;
		            var y;
		            var data = [];
	
		            for (i = 0; i < cube.length; i++ ) {
		                var array = cube[i];
	
		                if (array) {
		                    for (y = 0; y < array.length; y++ ) {
		                        data.push(array[y]);
		                    }
		                }
		            }
	
		            return data;
		        },
	
		        clone: function(sheet, row, col) {
		            var options = this._getOptions();
	
		            if (options.from) {
		                options.from = options.from.clone(sheet, row, col);
		            }
	
		            if (options.to) {
		                options.to = options.to.clone(sheet, row, col);
		            }
	
		            return new Validation($.extend(options,
		                { handler: this.handler },
		                { sheet: sheet, row: row, col: col }
		            ));
		        },
	
		        deepClone: function() {
		            var v = new Validation(this);
		            v.from = v.from.deepClone();
		            if (v.to) {
		                v.to = v.to.deepClone();
		            }
		            return v;
		        },
	
		        exec: function(ss, compareValue, compareFormat, callback) {
		            var self = this;
	
		            function getValue(val) {
		                if (val instanceof kendo.spreadsheet.Ref) {
		                    val = ss.getData(val);
		                    if (Array.isArray(val)) {
		                        val = val[0];
		                    }
		                }
		                return val;
		            }
	
		            var calculateFromCallBack = function(val) {
		                self.from_value = getValue(val);
		                self.value = self.handler.call(self, compareValue, compareFormat);
		                self._setMessages();
		                if (callback) {
		                    callback(self.value);
		                }
		            };
	
		            if (self.to) {
		                self.to.exec(ss, function(val) {
		                    self.to_value = getValue(val);
		                    self.from.exec(ss, calculateFromCallBack);
		                });
		            } else {
		                self.from.exec(ss, calculateFromCallBack);
		            }
		        },
	
		        reset: function() {
		            if (this.from) {
		                this.from.reset();
		            }
		            if (this.to) {
		                this.to.reset();
		            }
		            delete this.value;
		        },
	
		        adjust: function(affectedSheet, operation, start, delta) {
		            var prevFrom, prevTo, modified;
		            var formulaRow = this.row;
		            var formulaCol = this.col;
		            if (this.from) {
		                prevFrom = this.from.adjust(affectedSheet, operation, start, delta);
		            }
		            if (this.to) {
		                prevTo = this.to.adjust(affectedSheet, operation, start, delta);
		            }
		            if (this.sheet.toLowerCase() == affectedSheet.toLowerCase()) {
		                switch (operation) {
		                  case "row":
		                    if (formulaRow >= start) {
		                        modified = true;
		                        this.row += delta;
		                    }
		                    break;
		                  case "col":
		                    if (formulaCol >= start) {
		                        modified = true;
		                        this.col += delta;
		                    }
		                    break;
		                }
		            }
		            if (modified || prevFrom || prevTo) {
		                var v = new Validation(this);
		                v.from = prevFrom;
		                v.to = prevTo;
		                v.row = formulaRow;
		                v.col = formulaCol;
		                return v;
		            }
		        },
	
		        toJSON: function() {
		            var options = this._getOptions();
	
		            if (options.from) {
		                options.from = options.from.toString();
	
		                if (options.dataType === "list") {
		                    options.from = options.from.replace(/^_matrix\((.*)\)$/i, "$1");
		                    delete options.fromIsListValue;
		                }
	
		                if (options.dataType === "date") {
		                    if (this.fromIsDateValue) {
		                        options.from = options.from.replace(/^DATEVALUE\("(.*)"\)$/i, "$1");
		                        delete options.fromIsDateValue;
		                    }
		                }
		            }
	
		            if (options.to) {
		                options.to = options.to.toString();
	
		                if (options.dataType === "date") {
		                    if (this.toIsDateValue) {
		                        options.to = options.to.replace(/^DATEVALUE\("(.*)"\)$/i, "$1");
		                        delete options.toIsDateValue;
		                    }
		                }
		            }
	
		            return options;
		        },
	
		        _getOptions: function () {
		            return {
		                from: this.from,
		                to: this.to,
		                dataType: this.dataType,
		                type: this.type,
		                comparerType: this.comparerType,
		                row: this.row,
		                col: this.col,
		                sheet: this.sheet,
		                allowNulls: this.allowNulls,
		                fromIsListValue: this.fromIsListValue,
		                fromIsDateValue: this.fromIsDateValue,
		                toIsDateValue: this.toIsDateValue,
		                tooltipMessageTemplate: this.tooltipMessageTemplate,
		                tooltipTitleTemplate: this.tooltipTitleTemplate,
		                //TODO: export generated messages instead?
		                messageTemplate: this.messageTemplate,
		                titleTemplate: this.titleTemplate,
		                showButton: this.showButton
		            };
		        }
		    });
		    exports.compile = compileValidation;
		    exports.validationComparers = {
		        greaterThan: function (valueToCompare, from) {
		            return valueToCompare > from;
		        },
	
		        lessThan: function (valueToCompare, from) {
		            return valueToCompare < from;
		        },
	
		        between: function (valueToCompare, from, to) {
		            return valueToCompare >= from && valueToCompare <= to;
		        },
	
		        equalTo: function (valueToCompare, from) {
		            return valueToCompare == from;
		        },
	
		        notEqualTo: function (valueToCompare, from) {
		            return valueToCompare != from;
		        },
	
		        greaterThanOrEqualTo: function (valueToCompare, from) {
		            return valueToCompare >= from;
		        },
	
		        lessThanOrEqualTo: function (valueToCompare, from) {
		            return valueToCompare <= from;
		        },
	
		        notBetween: function (valueToCompare, from, to) {
		            return valueToCompare < from || valueToCompare > to;
		        },
	
		        custom: function (valueToCompare, from) {
		            return from;
		        },
	
		        list: function (valueToCompare, data) {
		            return data.indexOf(valueToCompare) > -1;
		        }
		    };
	
		    exports.Validation = Validation;
	
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1501);
		module.exports = __webpack_require__(1501);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1501:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(1502) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    (function(kendo) {
		        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		            return;
		        }
	
		        var $ = kendo.jQuery;
		        var outerWidth = kendo._outerWidth;
		        var DOT = ".";
		        var EMPTYCHAR = " ";
		        var sheetsBarClassNames = {
		            sheetsBarWrapper: "k-widget k-header",
		            sheetsBarSheetsWrapper: "k-tabstrip k-floatwrap k-tabstrip-bottom",
		            sheetsBarActive: "k-spreadsheet-sheets-bar-active",
		            sheetsBarInactive: "k-spreadsheet-sheets-bar-inactive",
		            sheetsBarAdd: "k-spreadsheet-sheets-bar-add",
		            sheetsBarRemove: "k-spreadsheet-sheets-remove",
		            sheetsBarItems: "k-spreadsheet-sheets-items",
		            sheetsBarEditor: "k-spreadsheet-sheets-editor",
		            sheetsBarScrollable: "k-tabstrip-scrollable",
		            sheetsBarNext: "k-tabstrip-next",
		            sheetsBarPrev: "k-tabstrip-prev",
		            sheetsBarKItem: "k-item k-state-default",
		            sheetsBarKActive: "k-state-active k-state-tab-on-top",
		            sheetsBarKTextbox: "k-textbox",
		            sheetsBarKLink: "k-link",
		            sheetsBarKIcon: "k-icon",
		            sheetsBarKFontIcon: "k-icon",
		            sheetsBarKButton: "k-button k-button-icon",
		            sheetsBarKButtonBare: "k-bare",
		            sheetsBarKArrowW: "k-i-arrow-60-left",
		            sheetsBarKArrowE: "k-i-arrow-60-right",
		            sheetsBarKReset: "k-reset k-tabstrip-items",
		            sheetsBarKIconX: "k-i-close",
		            sheetsBarKSprite: "k-sprite",
		            sheetsBarKIconPlus: "k-i-plus",
		            sheetsBarHintWrapper: "k-widget k-tabstrip k-tabstrip-bottom k-spreadsheet-sheets-items-hint",
		            sheetsBarKResetItems: "k-reset k-tabstrip-items"
		        };
	
		        var SheetsBar = kendo.ui.Widget.extend({
		            init: function(element, options) {
		                var classNames = SheetsBar.classNames;
	
		                kendo.ui.Widget.call(this, element, options);
	
		                element = this.element;
	
		                element.addClass(classNames.sheetsBarWrapper);
	
		                this._openDialog = options.openDialog;
	
		                this._tree = new kendo.dom.Tree(element[0]);
	
		                this._tree.render([this._addButton(), this._createSheetsWrapper([])]);
	
		                this._toggleScrollEvents(true);
	
		                this._createSortable();
	
		                this._sortable.bind("start", this._onSheetReorderStart.bind(this));
	
		                this._sortable.bind("end", this._onSheetReorderEnd.bind(this));
	
		                element.on("click", DOT + classNames.sheetsBarRemove, this._onSheetRemove.bind(this));
	
		                element.on("click", "li", this._onSheetSelect.bind(this));
	
		                element.on("dblclick", "li" + DOT + classNames.sheetsBarActive, this._createEditor.bind(this));
	
		                element.on("click", DOT + classNames.sheetsBarAdd, this._onAddSelect.bind(this));
		            },
	
		            options: {
		                name: "SheetsBar",
		                scrollable: {
		                    distance: 200
		                }
		            },
	
		            events: [
		                "select",
		                "reorder",
		                "rename"
		            ],
	
		            _createEditor: function () {
		                if (this._editor) {
		                    return;
		                }
	
		                this._renderSheets(this._sheets, this._selectedIndex, true);
		                this._editor = this.element
		                    .find(kendo.format("input{0}{1}",DOT,SheetsBar.classNames.sheetsBarEditor))
		                    .focus()
		                    .on("keydown", this._onEditorKeydown.bind(this))
		                    .on("blur", this._onEditorBlur.bind(this));
		            },
	
		            _destroyEditor: function(canceled) {
		                var newSheetName = canceled ? null : this._editor.val();
		                this._editor.off();
		                this._editor = null;
		                this._renderSheets(this._sheets, this._selectedIndex, false);
		                this._onSheetRename(newSheetName);
		            },
	
		            renderSheets: function(sheets, selectedIndex) {
		                if (!sheets || selectedIndex < 0) {
		                    return;
		                }
	
		                this._renderSheets(sheets, selectedIndex, false);
		            },
	
		            _renderSheets: function(sheets, selectedIndex, isInEditMode) {
		                var that = this;
		                var wrapperOffsetWidth;
		                var sheetsGroupScrollWidth;
		                var classNames = SheetsBar.classNames;
	
		                that._isRtl = kendo.support.isRtl(that.element);
		                that._sheets = sheets;
		                that._selectedIndex = selectedIndex;
	
		                that._renderHtml(isInEditMode, true);
	
		                if (!that._scrollableAllowed()) {
		                    return;
		                }
	
		                var sheetsWrapper = that._sheetsWrapper();
		                var scrollPrevButton = sheetsWrapper.children(DOT + classNames.sheetsBarPrev);
		                var scrollNextButton = sheetsWrapper.children(DOT + classNames.sheetsBarNext);
		                var gapWidth = 2;
		                var addButton = that.element.find(DOT + classNames.sheetsBarAdd);
		                var addButtonWidth = outerWidth(addButton) + addButton.position().left + gapWidth;
		                var scrollPrevButtonWidth = outerWidth(scrollPrevButton) + gapWidth;
		                var sheetsGroup = that._sheetsGroup();
	
		                scrollPrevButton.css({ left: addButtonWidth });
	
		                sheetsWrapper.addClass(classNames.sheetsBarScrollable + EMPTYCHAR + classNames.sheetsBarSheetsWrapper);
	
		                sheetsGroup.css({ marginLeft: addButtonWidth });
	
		                wrapperOffsetWidth = sheetsWrapper[0].offsetWidth;
		                sheetsGroupScrollWidth = sheetsGroup[0].scrollWidth;
	
		                if (sheetsGroupScrollWidth + addButtonWidth > wrapperOffsetWidth) {
		                    var scrollNextButtonRight = Math.ceil(kendo.parseFloat(scrollNextButton.css("right")));
	
		                    if (!that._scrollableModeActive) {
		                        that._nowScrollingSheets = false;
		                        that._scrollableModeActive = true;
		                    }
	
		                    sheetsGroup.css({
		                        marginLeft: scrollPrevButtonWidth + addButtonWidth,
		                        marginRight: outerWidth(scrollNextButton) + scrollNextButtonRight + gapWidth
		                    });
		                } else {
		                    if (that._scrollableModeActive && sheetsGroupScrollWidth <= wrapperOffsetWidth) {
		                        that._scrollableModeActive = false;
		                        sheetsGroup.css({ marginLeft: addButtonWidth, marginRight: "" });
		                    } else {
		                        sheetsGroup.css({ marginLeft: addButtonWidth });
		                    }
		                }
	
		                that._toggleScrollButtons();
		            },
	
		            _toggleScrollButtons: function (toggle) {
		                var that = this;
		                var ul = that._sheetsGroup();
		                var wrapper = that._sheetsWrapper();
		                var scrollLeft = ul.scrollLeft();
		                var prev = wrapper.find(DOT + SheetsBar.classNames.sheetsBarPrev);
		                var next = wrapper.find(DOT + SheetsBar.classNames.sheetsBarNext);
	
		                if (toggle === false) {
		                    prev.toggle(false);
		                    next.toggle(false);
		                } else {
		                    prev.toggle(that._isRtl ? scrollLeft < ul[0].scrollWidth - ul[0].offsetWidth - 1 : scrollLeft !== 0);
		                    next.toggle(that._isRtl ? scrollLeft !== 0 : scrollLeft < ul[0].scrollWidth - ul[0].offsetWidth - 1);
		                }
	
		            },
	
		            _toggleScrollEvents: function(toggle) {
		                var that = this;
		                var classNames = SheetsBar.classNames;
		                var options = that.options;
		                var scrollPrevButton;
		                var scrollNextButton;
		                var sheetsWrapper = that._sheetsWrapper();
		                scrollPrevButton = sheetsWrapper.children(DOT + classNames.sheetsBarPrev);
		                scrollNextButton = sheetsWrapper.children(DOT + classNames.sheetsBarNext);
	
		                if (toggle) {
		                    scrollPrevButton.on("mousedown", function () {
		                        that._nowScrollingSheets = true;
		                        that._scrollSheetsByDelta(options.scrollable.distance * (that._isRtl ? 1 : -1));
		                    });
	
		                    scrollNextButton.on("mousedown", function () {
		                        that._nowScrollingSheets = true;
		                        that._scrollSheetsByDelta(options.scrollable.distance * (that._isRtl ? -1 : 1));
		                    });
	
		                    scrollPrevButton.add(scrollNextButton).on("mouseup", function () {
		                        that._nowScrollingSheets = false;
		                    });
		                } else {
		                    scrollPrevButton.off();
		                    scrollNextButton.off();
		                }
		            },
	
		            _renderHtml: function(isInEditMode, renderScrollButtons) {
		                var idx;
		                var sheetElements = [];
		                var dom = kendo.dom;
		                var element = dom.element;
		                var sheets = this._sheets;
		                var selectedIndex = this._selectedIndex;
		                var classNames = SheetsBar.classNames;
	
		                for (idx = 0; idx < sheets.length; idx++) {
		                    var sheet = sheets[idx];
		                    var isSelectedSheet = (idx === selectedIndex);
		                    var attr = { className: classNames.sheetsBarKItem + EMPTYCHAR };
		                    var elementContent = [];
	
		                    if (isSelectedSheet) {
		                        attr.className += classNames.sheetsBarKActive + EMPTYCHAR + classNames.sheetsBarActive;
		                    } else {
		                        attr.className += classNames.sheetsBarInactive;
		                    }
	
		                    if (isSelectedSheet && isInEditMode) {
		                        elementContent.push(element("input", {
		                            type: "text",
		                            value: sheet.name(),
		                            className: classNames.sheetsBarKTextbox + EMPTYCHAR + classNames.sheetsBarEditor,
		                            maxlength: 50
		                        }, []));
		                    } else {
		                        elementContent.push(element("span", {
		                            className: classNames.sheetsBarKLink,
		                            title: sheet.name()
		                        }, [dom.text(sheet.name())]));
	
		                        if (sheets.length > 1) {
		                            var deleteIcon = element("span", {
		                                className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKFontIcon + EMPTYCHAR + classNames.sheetsBarKIconX
		                            }, []);
	
		                            elementContent.push(element("span", {
		                                className: classNames.sheetsBarKLink + EMPTYCHAR + classNames.sheetsBarRemove
		                            }, [deleteIcon]));
		                        }
		                    }
	
		                    sheetElements.push(element("li", attr, elementContent));
		                }
	
		                this._tree.render([this._addButton(),  this._createSheetsWrapper(sheetElements, renderScrollButtons)]);
		            },
	
		            _createSheetsWrapper: function(sheetElements, renderScrollButtons) {
		                var element = kendo.dom.element;
		                var classNames = SheetsBar.classNames;
		                var childrenElements = [element("ul", {
		                    className: classNames.sheetsBarKReset
		                }, sheetElements)];
		                renderScrollButtons = true;
	
		                if (renderScrollButtons) {
		                    var baseButtonClass = classNames.sheetsBarKButton + EMPTYCHAR + classNames.sheetsBarKButtonBare + EMPTYCHAR;
	
		                    childrenElements.push(element("span", {className: baseButtonClass + classNames.sheetsBarPrev }, [
		                        element("span", {className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKArrowW}, [])
		                    ]));
	
		                    childrenElements.push(element("span", {className: baseButtonClass + classNames.sheetsBarNext }, [
		                        element("span", {className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKArrowE}, [])
		                    ]));
		                }
	
		                return element("div", { className: classNames.sheetsBarItems }, childrenElements);
		            },
	
		            _createSortable: function() {
		                var classNames = SheetsBar.classNames;
		                this._sortable = new kendo.ui.Sortable(this.element, {
		                    filter: kendo.format("ul li.{0},ul li.{1}", classNames.sheetsBarActive, classNames.sheetsBarInactive),
		                    container: DOT + classNames.sheetsBarItems,
		                    axis: "x",
		                    animation: false,
		                    ignore: "input",
		                    end: function () {
		                        if (this.draggable.hint) {
		                            this.draggable.hint.remove();
		                        }
		                    },
		                    hint: function (element) {
		                        var hint = $(element).clone();
		                        return hint.wrap("<div class='" + classNames.sheetsBarHintWrapper + "'><ul class='" + classNames.sheetsBarKResetItems + "'></ul></div>").closest("div");
		                    }
		                });
		            },
	
		            _onEditorKeydown: function(e) {
		                if (this._editor) {
		                    if (e.which === 13) {
		                        this._destroyEditor();
		                    }
	
		                    if (e.which === 27) {
		                        this._destroyEditor(true);
		                    }
		                }
		            },
	
		            _onEditorBlur: function() {
		                if (this._editor) {
		                    this._destroyEditor();
		                }
		            },
	
		            _onSheetReorderEnd: function(e) {
		                e.preventDefault();
		                this.trigger("reorder", {oldIndex: e.oldIndex, newIndex: e.newIndex});
		            },
	
		            _onSheetReorderStart: function(e) {
		                if (this._editor) {
		                    e.preventDefault();
		                }
		            },
	
		            _onSheetRemove: function(e) {
		                var removedSheetName = $(e.target).closest("li").text();
	
		                if (this._editor) {
		                    this._destroyEditor();
		                }
	
		                var closeCallback = function(e) {
		                    var dlg = e.sender;
	
		                    if (dlg.isConfirmed()) {
		                        this.trigger("remove", { name: removedSheetName, confirmation: true });
		                    }
		                }.bind(this);
	
		                this._openDialog("confirmation", {
		                    close: closeCallback
		                });
		            },
	
		            _onSheetSelect: function(e) {
		                var selectedSheetText = $(e.target).text();
	
		                if ($(e.target).is(DOT + SheetsBar.classNames.sheetsBarEditor) || !selectedSheetText) {
		                    e.preventDefault();
		                    return;
		                }
	
		                if (this._editor) {
		                    this._destroyEditor();
		                }
	
		                this._scrollSheetsToItem($(e.target).closest("li"));
	
		                this.trigger("select", {name: selectedSheetText, isAddButton: false});
		            },
	
		            _onSheetRename: function(newSheetName) {
		                if (this._sheets[this._selectedIndex].name() === newSheetName || newSheetName === null) {
		                    return;
		                }
	
		                this.trigger("rename", {name: newSheetName, sheetIndex: this._selectedIndex });
		            },
	
		            _onAddSelect: function() {
		                this.trigger("select", {isAddButton: true});
		            },
	
		            _addButton: function() {
		                var element = kendo.dom.element;
		                var classNames = SheetsBar.classNames;
		                return element("a", {
		                    className: classNames.sheetsBarAdd + EMPTYCHAR + classNames.sheetsBarKButton
		                }, [element("span", {className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKFontIcon + EMPTYCHAR + classNames.sheetsBarKIconPlus}, [])]);
		            },
	
		            destroy: function() {
		                this._sortable.destroy();
		            },
	
		            _scrollableAllowed: function() {
		                var options = this.options;
		                return options.scrollable && !isNaN(options.scrollable.distance);
		            },
	
		            _scrollSheetsToItem: function (item) {
		                var that = this;
	
		                if (!that._scrollableModeActive) {
		                    return;
		                }
	
		                var sheetsGroup = that._sheetsGroup();
	
		                var currentScrollOffset = sheetsGroup.scrollLeft();
		                var itemWidth = outerWidth(item);
		                var itemOffset = that._isRtl ? item.position().left : item.position().left - sheetsGroup.children().first().position().left;
		                var sheetsGroupWidth = sheetsGroup[0].offsetWidth;
		                var sheetsGroupPadding = Math.ceil(parseFloat(sheetsGroup.css("padding-left")));
		                var itemPosition;
	
		                if (that._isRtl) {
		                    if (itemOffset < 0) {
		                        itemPosition = currentScrollOffset + itemOffset - (sheetsGroupWidth - currentScrollOffset) - sheetsGroupPadding;
		                    } else if (itemOffset + itemWidth > sheetsGroupWidth) {
		                        itemPosition = currentScrollOffset + itemOffset - itemWidth + sheetsGroupPadding * 2;
		                    }
		                } else {
		                    if (currentScrollOffset + sheetsGroupWidth < itemOffset + itemWidth) {
		                        itemPosition = itemOffset + itemWidth - sheetsGroupWidth + sheetsGroupPadding * 2;
		                    } else if (currentScrollOffset > itemOffset) {
		                        itemPosition = itemOffset - sheetsGroupPadding;
		                    }
		                }
	
		                sheetsGroup.finish().animate({ "scrollLeft": itemPosition }, "fast", "linear", function () {
		                    that._toggleScrollButtons();
		                });
		            },
	
		            _sheetsGroup: function() {
		                return this._sheetsWrapper().children("ul");
		            },
	
		            _sheetsWrapper: function() {
		                return this.element.find(DOT + SheetsBar.classNames.sheetsBarItems);
		            },
	
		            _scrollSheetsByDelta: function (delta) {
		                var that = this;
		                var sheetsGroup = that._sheetsGroup();
		                var scrLeft = sheetsGroup.scrollLeft();
	
		                sheetsGroup.finish().animate({ "scrollLeft": scrLeft + delta }, "fast", "linear", function () {
		                    if (that._nowScrollingSheets) {
		                        that._scrollSheetsByDelta(delta);
		                    } else {
		                        that._toggleScrollButtons();
		                    }
		                });
		            }
		        });
	
		        kendo.spreadsheet.SheetsBar = SheetsBar;
		        $.extend(true, SheetsBar, { classNames: sheetsBarClassNames });
		    })(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1502:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(614);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1469);
		module.exports = __webpack_require__(1469);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 923:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(554);
	
	/***/ }),
	
	/***/ 1469:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(923), __webpack_require__(1470), __webpack_require__(1471) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    /* global JSZip */
	
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /* jshint eqnull:true */
		    /* jshint latedef: nofunc */
	
		    var $ = kendo.jQuery;
		    var parseXML = kendo.util.parseXML;
		    var parseReference = kendo.spreadsheet.calc.parseReference;
	
		    var MAP_EXCEL_OPERATOR = {
		        // includes only what differs; key is Excel's operator, value
		        // is our operator.
		        greaterThanOrEqual : "greaterThanOrEqualTo",
		        lessThanOrEqual    : "lessThanOrEqualTo"
		    };
	
		    var ERROR_LOG = null;
	
		    function readExcel(file, workbook, deferred) {
		        var reader = new FileReader();
		        reader.onload = function(e) {
		            var zip = new JSZip(e.target.result);
		            readWorkbook(zip, workbook, deferred);
		        };
	
		        reader.readAsArrayBuffer(file);
		    }
	
		    var SEL_CELL = ["sheetData", "row", "c"];
		    var SEL_COL = ["cols", "col"];
		    var SEL_DEFINED_NAME = ["definedNames", "definedName"];
		    var SEL_FORMULA = ["sheetData", "row", "c", "f"];
		    var SEL_MERGE = ["mergeCells", "mergeCell"];
		    var SEL_PANE = ["sheetViews", "sheetView", "pane"];
		    var SEL_ROW = ["sheetData", "row"];
		    var SEL_SELECTION = ["sheetViews", "sheetView", "selection"];
		    var SEL_SHEET = ["sheets", "sheet"];
		    var SEL_STRING = ["sheetData", "row", "c", "is"];
		    var SEL_TEXT = ["t"];
		    var SEL_SHARED_STRING = ["si"];
		    var SEL_VALUE = ["sheetData", "row", "c", "v"];
		    var SEL_VIEW = ["bookViews", "workbookView"];
		    var SEL_SHEET_VIEW = ["sheetViews", "sheetView"];
		    var SEL_HYPERLINK = ["hyperlinks", "hyperlink"];
	
		    /* A validation section looks like this:
		     *
		     * <dataValidations count="1">
		     *   <dataValidation type="list" allowBlank="1" showInputMessage="1" showErrorMessage="1" sqref="B2">
		     *     <formula1>$E$2:$E$5</formula1>
		     *   </dataValidation>
		     * </dataValidations>
		     */
		    var SEL_VALIDATION = ["dataValidations", "dataValidation"];
		    var SEL_VALIDATION_FORMULA1 = ["dataValidations", "dataValidation", "formula1"];
		    var SEL_VALIDATION_FORMULA2 = ["dataValidations", "dataValidation", "formula2"];
	
		    /* However, when a validation formula in one sheet references
		     * cells from another sheet, Excel produces this version instead:
		     *
		     * <extLst>
		     *   <ext xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" uri="{CCE6A557-97BC-4b89-ADB6-D9C93CAAB3DF}">
		     *     <x14:dataValidations xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main" count="1">
		     *       <x14:dataValidation type="list" allowBlank="1" showInputMessage="1" showErrorMessage="1">
		     *         <x14:formula1>
		     *           <xm:f>Sheet2!$B$3:$B$6</xm:f>
		     *         </x14:formula1>
		     *         <xm:sqref>B1</xm:sqref>
		     *       </x14:dataValidation>
		     *     </x14:dataValidations>
		     *   </ext>
		     * </extLst>
		     *
		     * I call it the "insane version", because that's what it is.
		     * Barring the case that the engineers who produced this horror
		     * were on LSD, the only plausible reason for it is that Microsoft
		     * does not want third party software to be compatible with Excel
		     * (sentiment I've had over and over while working on the
		     * Spreadsheet widget).
		     */
		    // XXX: technically, the aliases `x14` and `xm` below could be
		    // different, but Excel seems to be hard-coded on these; our
		    // parser does not support proper namespaces for now anyway, so
		    // hard-coded they are.
		    var SEL_VALIDATION_INSANE = ["x14:dataValidations", "x14:dataValidation"];
		    var SEL_VALIDATION_SQREF_INSANE = ["x14:dataValidations", "x14:dataValidation", "xm:sqref"];
		    var SEL_VALIDATION_FORMULA1_INSANE = ["x14:dataValidations", "x14:dataValidation", "x14:formula1", "xm:f"];
		    var SEL_VALIDATION_FORMULA2_INSANE = ["x14:dataValidations", "x14:dataValidation", "x14:formula2", "xm:f"];
	
		    function xl(file) {
		        if (!/^\//.test(file)) {
		            file = "xl/" + file;
		        } else {
		            file = file.substr(1);
		        }
		        return file;
		    }
	
		    function readWorkbook(zip, workbook, progress) {
		        ERROR_LOG = workbook.excelImportErrors = [];
	
		        var strings = readStrings(zip);
		        var relationships = readRelationships(zip, "_rels/workbook.xml");
		        var theme = readTheme(zip, relationships.byType.theme[0]);
		        var styles = readStyles(zip, theme);
		        var items = [];
		        var activeSheet = 0;
	
		        parse(zip, "xl/workbook.xml", {
		            enter: function(tag, attrs) {
		                if (this.is(SEL_SHEET)) {
		                    var relId = attrs["r:id"];
		                    var file = relationships.byId[relId];
		                    var name = attrs.name;
		                    var dim = sheetDimensions(zip, file);
	
		                    workbook.options.columnWidth = dim.columnWidth || workbook.options.columnWidth;
		                    workbook.options.rowHeight = dim.rowHeight || workbook.options.rowHeight;
	
		                    items.push({
		                        workbook: workbook,
		                        zip: zip,
		                        strings: strings,
		                        styles: styles,
		                        file: file,
		                        options: {
		                            name: name,
		                            rows: Math.max(workbook.options.rows || 0, dim.rows),
		                            columns: Math.max(workbook.options.columns || 0, dim.cols),
		                            columnWidth: dim.columnWidth,
		                            rowHeight: dim.rowHeight
		                        }
		                    });
		                } else if (this.is(SEL_VIEW)) {
		                    if (attrs.activeTab) {
		                        activeSheet = integer(attrs.activeTab);
		                    }
		                }
		            },
		            text: function(text) {
		                var attrs = this.is(SEL_DEFINED_NAME);
		                if (attrs && !(bool(attrs["function"]) || bool(attrs.vbProcedure))) {
		                    var localSheetId = attrs.localSheetId;
		                    var sheet = null;
		                    if (localSheetId != null) {
		                        sheet = items[localSheetId].options.name;
		                    }
		                    var name = attrs.name;
		                    if (name != "_xlnm._FilterDatabase") {
		                        if (sheet) {
		                            name = "'" + sheet.replace(/\'/g, "\\'") + "'!" + name;
		                        }
		                        withErrorLog(sheet, null, function(){
		                            workbook.defineName(name, text, bool(attrs.hidden));
		                        }, "reading user-defined name: " + name);
		                    }
		                }
		            }
		        });
	
		        var loading = new $.Deferred();
		        loading.progress(function(args) {
		            if (progress) {
		                progress.notify(args);
		            }
		        })
		        .then(function() {
		            var sheets = workbook.sheets();
		            recalcSheets(sheets);
	
		            workbook.activeSheet(sheets[activeSheet]);
	
		            if (progress) {
		                progress.resolve();
		            }
		        });
	
		        loadSheets(items, workbook, loading);
		    }
	
		    function loadSheets(items, workbook, progress) {
		        var ready = (new $.Deferred()).resolve();
		        for (var i = 0; i < items.length; i++) {
		            /*jshint -W083 */
		            (function(entry, i) {
		                ready = ready.then(function() {
		                    var sheet = workbook.insertSheet(entry.options);
		                    sheet.suspendChanges(true);
	
		                    var promise = queueSheet(sheet, entry);
		                    var args = {
		                        sheet: sheet,
		                        progress: i / (items.length - 1)
		                    };
	
		                    promise.then(function() {
		                        progress.notify(args);
		                    });
	
		                    return promise;
		                });
		            })(items[i], i);
		        }
	
		        ready.then(function() {
		            progress.resolve();
		        });
		    }
	
		    function queueSheet(sheet, ctx) {
		        var deferred = new $.Deferred();
	
		        setTimeout(function() {
		            readSheet(ctx.zip, ctx.file, sheet, ctx.strings, ctx.styles);
		            deferred.resolve();
		        }, 0);
	
		        return deferred;
		    }
	
		    function recalcSheets(sheets) {
		        for (var i = 0; i < sheets.length; i++) {
		            sheets[i]
		                .suspendChanges(false)
		                .triggerChange({ recalc: true });
		        }
		    }
	
		    function sheetDimensions(zip, file) {
		        var dim = {
		            rows: 0,
		            cols: 0
		        };
	
		        parse(zip, xl(file), {
		            enter: function(tag, attrs) {
		                if (tag == "dimension") {
		                    var ref = parseReference(attrs.ref);
		                    if (ref.bottomRight) {
		                        dim.cols = ref.bottomRight.col + 1;
		                        dim.rows = ref.bottomRight.row + 1;
		                    }
		                } else if (tag === "sheetFormatPr") {
		                    if (attrs.defaultColWidth) {
		                        dim.columnWidth = toColWidth(parseFloat(attrs.defaultColWidth));
		                    }
	
		                    if (attrs.defaultRowHeight) {
		                        dim.rowHeight = toRowHeight(parseFloat(attrs.defaultRowHeight));
		                    }
		                } else if (this.is(SEL_ROW)) {
		                    // Don't process actual rows
		                    this.exit();
		                }
		            }
		        });
	
		        return dim;
		    }
	
		    function toColWidth(size) {
		        // No font to compute agains, hence the magic number
		        var maximumDigitWidth = 7;
	
		        // The formula below is taken from the OOXML spec
		        var fraction = (256 * size + Math.floor(128 / maximumDigitWidth)) / 256;
		        return fraction * maximumDigitWidth;
		    }
	
		    function toRowHeight(pts) {
		        return pts * (4 / 3);
		    }
	
		    function readSheet(zip, file, sheet, strings, styles) {
		        var sharedFormulas = {};
		        var ref, type, value, formula, formulaRange, isArrayFormula;
		        var nCols = sheet._columns._count;
		        var prevCellRef = null;
		        var relsFile = file.replace(/worksheets\//, "worksheets/_rels/");
		        var relationships = readRelationships(zip, relsFile);
		        var formula1, formula2;
	
		        var filterRef;
		        var filterColumn;
		        var customFilterLogic;
		        var customFilterCriteria;
		        var valueFilterBlanks;
		        var valueFilterValues;
		        var filters = [];
	
		        ERROR_LOG = sheet._workbook.excelImportErrors;
	
		        parse(zip, xl(file), {
		            enter: function(tag, attrs, closed) {
		                var tmp;
		                if (this.is(SEL_FORMULA)) {
		                    if (closed) {
		                        if (attrs.t == "shared" && attrs.si != null) {
		                            formula = sheet.range(sharedFormulas[attrs.si])._get("formula");
		                        }
		                    }
		                }
		                else if (this.is(SEL_CELL)) {
		                    value = null;
		                    formula = null;
		                    ref = attrs.r;
		                    formulaRange = null;
	
		                    if (ref == null) {
		                        // apparently some tools omit the `r` for
		                        // consecutive cells in a row, so we'll figure
		                        // it out from the previous cell's reference.
		                        // XXX: this could be slightly optimized by
		                        // keeping it parsed instead of stringifying
		                        // it to parse it again later.
		                        ref = parseReference(prevCellRef);
		                        ref.col++;
		                        ref = ref.toString();
		                    }
		                    prevCellRef = ref;
	
		                    // XXX: can't find no type actually, so everything is
		                    // interpreted as string.  Additionally, cells having
		                    // a formula will contain both <f> and <v> nodes,
		                    // which makes the value take precedence because it's
		                    // the second node; hence, the hack is to keep note of
		                    // them in the `text` handler, and apply the
		                    // appropriate one in the `leave` handler below.
		                    type = attrs.t;
	
		                    var styleIndex = attrs.s;
		                    if (styleIndex != null) {
		                        applyStyle(sheet, ref, styles, styleIndex);
		                    }
		                }
		                else if (this.is(SEL_MERGE)) {
		                    sheet.range(attrs.ref).merge();
		                }
		                else if (this.is(SEL_COL)) {
		                    var start = integer(attrs.min) - 1;
		                    var stop = Math.min(nCols, integer(attrs.max)) - 1;
		                    var width;
		                    if (attrs.width) {
		                        width = toColWidth(parseFloat(attrs.width));
		                        if (width !== 0) {
		                            sheet._columns.values.value(start, stop, width);
		                        }
		                    }
		                    if (attrs.hidden === "1" || width === 0) {
		                        for (var ci = start; ci <= stop; ci++) {
		                            sheet.hideColumn(ci);
		                        }
		                    }
		                    if (attrs.style != null) {
		                        // apply style on a whole range of columns
		                        applyStyle(sheet, new kendo.spreadsheet.RangeRef(
		                            new kendo.spreadsheet.CellRef(-Infinity, start),
		                            new kendo.spreadsheet.CellRef(+Infinity, stop)
		                        ), styles, attrs.style);
		                    }
		                }
		                else if (this.is(SEL_ROW)) {
		                    var row = integer(attrs.r) - 1;
		                    var height;
		                    if (attrs.ht) {
		                        height = toRowHeight(parseFloat(attrs.ht));
		                        if (height !== 0) {
		                            sheet._rows.values.value(row, row, height);
		                        }
		                    }
		                    if (attrs.hidden === "1" || height === 0) {
		                        sheet.hideRow(row);
		                    }
		                }
		                else if (this.is(SEL_SELECTION)) {
		                    if (attrs.activeCell) {
		                        var acRef = parseReference(attrs.activeCell);
		                        sheet.select(acRef, true);
		                    }
		                }
		                else if (this.is(SEL_PANE)) {
		                    if (attrs.state == "frozen") {
		                        if (attrs.xSplit) {
		                            sheet.frozenColumns(integer(attrs.xSplit));
		                        }
	
		                        if (attrs.ySplit) {
		                            sheet.frozenRows(integer(attrs.ySplit));
		                        }
		                    }
		                }
		                else if (this.is(SEL_SHEET_VIEW)) {
		                    sheet.showGridLines(bool(attrs.showGridLines, true));
		                }
		                else if (this.is(SEL_HYPERLINK)) {
		                    var relId = attrs["r:id"];
		                    var target = relationships.byId[relId];
		                    if (target) {
		                        sheet.range(attrs.ref).link(target);
		                    }
		                }
		                else if (this.is(["autoFilter"])) {
		                    filterRef = attrs.ref;
		                    if (closed) {
		                        addAutoFilter();
		                    }
		                }
		                else if (filterRef) {
		                    if (this.is(["filterColumn"])) {
		                        filterColumn = parseInt(attrs.colId, 10);
		                    }
		                    else if (this.is(["customFilters"])) {
		                        customFilterLogic = bool(attrs.and) ? "and" : "or";
		                        customFilterCriteria = [];
		                    }
		                    else if (this.is(["customFilter"])) {
		                        tmp = getCustomFilter(attrs.operator, attrs.val);
		                        if (tmp) {
		                            customFilterCriteria.push({
		                                operator: tmp.operator,
		                                value: tmp.value
		                            });
		                        }
		                    }
		                    else if (this.is(["dynamicFilter"])) {
		                        filters.push({
		                            column: filterColumn,
		                            filter: new kendo.spreadsheet.DynamicFilter({
		                                type: dynamicFilterType(attrs.type)
		                            })
		                        });
		                    }
		                    else if (this.is(["top10"])) {
		                        filters.push({
		                            column: filterColumn,
		                            filter: new kendo.spreadsheet.TopFilter({
		                                value: getFilterVal(attrs.val),
		                                type: (function(percent, top){
		                                    return percent && top ? "topPercent"
		                                        :  top ? "topNumber"
		                                        :  percent ? "bottomPercent"
		                                        :  "bottomNumber";
		                                })(bool(attrs.percent), bool(attrs.top))
		                            })
		                        });
		                    }
		                    else if (this.is(["filters"])) {
		                        valueFilterBlanks = bool(attrs.blank);
		                        valueFilterValues = [];
		                    }
		                    else if (this.is(["filter"])) {
		                        valueFilterValues.push(getFilterVal(attrs.val));
		                    }
		                }
		            },
		            leave: function(tag, attrs) {
		                if (this.is(SEL_FORMULA)) {
		                    if (!formula && attrs.t == "shared" && attrs.si != null) {
		                        formula = sheet.range(sharedFormulas[attrs.si])._get("formula");
		                    }
		                }
		                else if (this.is(SEL_CELL)) {
		                    if (formula != null) {
		                        var failed = withErrorLog(sheet, formulaRange || ref, function(){
		                            sheet.range(formulaRange || ref).formula(formula, isArrayFormula);
		                        }, "parsing formula");
		                        if (failed) {
		                            sheet.range(formulaRange || ref).value(formula)
		                                .background("#ffaaaa");
		                        }
		                    } else if (value != null) {
		                        var range = sheet.range(ref);
	
		                        if (!range._get("formula")) {
		                            // Check for "shared" formulas before applying a value.
		                            if (!type || type == "n") {
		                                value = parseFloat(value);
		                            } else if (type == "s") {
		                                value = strings[integer(value)];
		                            } else if (type == "b") {
		                                value = value === "1";
		                            } else if (type == "d") {
		                                value = kendo.parseDate(value);
		                            }
	
		                            if (value != null) {
		                                range.value(value);
		                            }
		                        }
		                    }
		                } else if (this.is(SEL_VALIDATION) ||
		                           this.is(SEL_VALIDATION_INSANE)) {
		                    (function(){
		                        var refs = kendo.spreadsheet.calc.parseSqref(attrs.sqref);
		                        var type = attrs.type.toLowerCase();
		                        var operator = attrs.operator;
		                        if (/^(?:whole|decimal)$/.test(type)) {
		                            // we only support "number"
		                            type = "number";
		                        } else if (type == "list") {
		                            // there'll be no operator from Excel for lists
		                            operator = "list";
		                        }
		                        if (!operator && /^(?:number|date)$/.test(type)) {
		                            // Excel skips setting the operator for
		                            // "between", because why not.
		                            operator = "between";
		                        }
		                        refs.forEach(function(ref){
		                            withErrorLog(sheet, ref, function(){
		                                sheet.range(ref).validation({
		                                    type             : bool(attrs.showErrorMessage, true) ? "reject" : "warning",
		                                    from             : formula1,
		                                    to               : formula2,
		                                    dataType         : type,
		                                    comparerType     : MAP_EXCEL_OPERATOR[operator] || operator,
		                                    allowNulls       : bool(attrs.allowBlank),
		                                    showButton       : bool(attrs.showDropDown) || type == "date" || type == "list",
		                                    messageTemplate  : attrs.error,
		                                    titleTemplate    : attrs.errorTitle
		                                });
		                            }, "parsing validation");
		                        });
		                    })();
		                } else if (tag == "cols") {
		                    sheet._columns._refresh();
		                } else if (tag == "sheetData") {
		                    sheet._rows._refresh();
		                } else if (tag == "autoFilter") {
		                    addAutoFilter();
		                } else if (filterRef) {
		                    if (tag == "customFilters") {
		                        filters.push({
		                            column: filterColumn,
		                            filter: new kendo.spreadsheet.CustomFilter({
		                                logic: customFilterLogic,
		                                criteria: customFilterCriteria
		                            })
		                        });
		                    } else if (tag == "filters") {
		                        filters.push({
		                            column: filterColumn,
		                            filter: new kendo.spreadsheet.ValueFilter({
		                                values: valueFilterValues,
		                                blanks: valueFilterBlanks
		                            })
		                        });
		                    }
		                }
		            },
		            text: function(text) {
		                var attrs;
		                if (this.is(SEL_VALUE) || this.is(SEL_STRING)) {
		                    value = text;
		                } else if ((attrs = this.is(SEL_FORMULA))) {
		                    formula = text;
		                    isArrayFormula = attrs.t == "array";
		                    if (isArrayFormula) {
		                        formulaRange = attrs.ref;
		                    } else if (attrs.t == "shared") {
		                        sharedFormulas[attrs.si] = ref;
		                    }
		                } else if (this.is(SEL_VALIDATION_FORMULA1) ||
		                           this.is(SEL_VALIDATION_FORMULA1_INSANE)) {
		                    formula1 = text;
		                } else if (this.is(SEL_VALIDATION_FORMULA2) ||
		                           this.is(SEL_VALIDATION_FORMULA2_INSANE)) {
		                    formula2 = text;
		                } else if (this.is(SEL_VALIDATION_SQREF_INSANE)) {
		                    // put it in <dataValidation>'s attributes where it should be
		                    this.stack[this.stack.length - 2].sqref = text;
		                }
		            }
		        });
	
		        function addAutoFilter() {
		            sheet.range(filterRef).filter(filters);
		            filterRef = null;
		        }
		    }
	
		    function getCustomFilter(op, value) {
		        var ourOp = {
		            equal               : "eq",
		            notEqual            : "ne",
		            greaterThan         : "gt",
		            greaterThanOrEqual  : "gte",
		            lessThan            : "lt",
		            lessThanOrEqual     : "lte"
		        }[op];
	
		        value = getFilterVal(value);
	
		        if (ourOp && typeof value == "number") {
		            return { operator: ourOp, value: value };
		        }
	
		        if ((op == "notEqual" || !op) && typeof value == "string") {
		            // Excel text operators support * and ? wildcards.  Since
		            // our startswith/endswith/contains filters do not, we
		            // can't really use them here, so we'll apply the more
		            // generic "matches" and "doesnotmatch" filters.
		            return {
		                operator: op ? "doesnotmatch" : "matches",
		                value: value
		            };
		        }
		    }
	
		    function dynamicFilterType(type) {
		        return {
		            Q1  : "quarter1",
		            Q2  : "quarter2",
		            Q3  : "quarter3",
		            Q4  : "quarter4",
		            M1  : "january",
		            M2  : "february",
		            M3  : "march",
		            M4  : "april",
		            M5  : "may",
		            M6  : "june",
		            M7  : "july",
		            M8  : "august",
		            M9  : "september",
		            M10 : "october",
		            M11 : "november",
		            M12 : "december"
		        }[type.toUpperCase()] || type;
		    }
	
		    function getFilterVal(val) {
		        var tmp = parseFloat(val);
		        if (!isNaN(tmp) && tmp == val) {
		            return tmp;
		        }
		        return val;
		    }
	
		    function withErrorLog(sheet, ref, func, context) {
		        try {
		            func();
		            return false;
		        } catch(ex) {
		            var err = { context: context, error: String(ex) };
		            if (sheet) {
		                err.sheet = sheet.name();
		            }
		            if (ref) {
		                err.location = String(ref);
		            }
		            ERROR_LOG.push(err);
		            return true;
		        }
		    }
	
		    var BORDER_WIDTHS = {
		        "none"            : 0,
		        "thin"            : 1,
		        "medium"          : 2,
		        "dashed"          : 1,
		        "dotted"          : 1,
		        "thick"           : 3,
		        "double"          : 3,
		        "hair"            : 1,
		        "mediumDashed"    : 2,
		        "dashDot"         : 1,
		        "mediumDashDot"   : 2,
		        "dashDotDot"      : 1,
		        "mediumDashDotDot": 2,
		        "slantDashDot"    : 1
		    };
	
		    var DEFAULT_FORMATS = {
		        0  : "General",
		        1  : "0",
		        2  : "0.00",
		        3  : "#,##0",
		        4  : "#,##0.00",
		        9  : "0%",
		        10 : "0.00%",
		        11 : "0.00E+00",
		        12 : "# ?/?",
		        13 : "# ??/??",
		        14 : "mm-dd-yy",
		        15 : "d-mmm-yy",
		        16 : "d-mmm",
		        17 : "mmm-yy",
		        18 : "h:mm AM/PM",
		        19 : "h:mm:ss AM/PM",
		        20 : "h:mm",
		        21 : "h:mm:ss",
		        22 : "m/d/yy h:mm",
		        37 : "#,##0 ;(#,##0)",
		        38 : "#,##0 ;[Red](#,##0)",
		        39 : "#,##0.00;(#,##0.00)",
		        40 : "#,##0.00;[Red](#,##0.00)",
		        45 : "mm:ss",
		        46 : "[h]:mm:ss",
		        47 : "mmss.0",
		        48 : "##0.0E+0",
		        49 : "@"
		    };
	
		    function applyStyle(sheet, ref, styles, styleIndex) {
		        var range = sheet.range(ref);
		        var xf = styles.inlineStyles[styleIndex], base, value;
		        if (xf.xfId) {
		            base = styles.namedStyles[xf.xfId];
		        }
		        if (shouldSet("applyBorder", "borderId")) {
		            setBorder(styles.borders[value]);
		        }
		        if (shouldSet("applyFont", "fontId")) {
		            setFont(styles.fonts[value]);
		        }
		        if (shouldSet("applyAlignment", "textAlign")) {
		            range.textAlign(value);
		        }
		        if (shouldSet("applyAlignment", "verticalAlign")) {
		            range.verticalAlign(value);
		        }
		        if (shouldSet("applyAlignment", "wrapText")) {
		            // don't use range.wrap to avoid recomputing row height
		            range._property("wrap", value);
		        }
		        if (shouldSet("applyFill", "fillId")) {
		            setFill(styles.fills[value]);
		        }
		        if (shouldSet("applyNumberFormat", "numFmtId")) {
		            setFormat(styles.numFmts[value] || DEFAULT_FORMATS[value]);
		        }
	
		        function setFormat(f) {
		            var format = typeof f == "string" ? f : f.formatCode;
		            if (format != null && !/^general$/i.test(format)) {
		                // XXX: drop locale info.
		                // http://stackoverflow.com/questions/894805/excel-number-format-what-is-409
		                // not supported by the formatting library.
		                format = format.replace(/^\[\$-[0-9]+\]/, "");
		                range.format(format);
		            }
		        }
	
		        function setFill(f) {
		            if (f.type == "solid") {
		                range.background(f.color);
		            }
		        }
	
		        function setFont(f) {
		            range.fontFamily(f.name);
		            //range.fontSize(f.size); //XXX: will recalc row height.
		            range._property("fontSize", f.size);
		            if (f.bold) {
		                range.bold(true);
		            }
		            if (f.italic) {
		                range.italic(true);
		            }
		            if (f.underline) {
		                range.underline(true);
		            }
		            if (f.color) {
		                range.color(f.color);
		            }
		        }
	
		        function setBorder(b) {
		            function set(side, prop) {
		                var border = b[side];
		                if (!border) {
		                    return;
		                }
	
		                var width = BORDER_WIDTHS[border.style];
		                if (width === 0) {
		                    return;
		                }
	
		                var color = border.color;
		                if (color == null) {
		                    color = "#000";
		                }
	
		                range._property(prop, { size: width, color: color });
		            }
	
		            set("left", "borderLeft");
		            set("top", "borderTop");
		            set("right", "borderRight");
		            set("bottom", "borderBottom");
		        }
	
		        function shouldSet(applyName, propName) {
		            var t = xf[applyName];
		            if (t != null && !t) {
		                return false;
		            }
		            value = xf[propName];
		            if (base && value == null) {
		                t = base[applyName];
		                if (t != null && !t) {
		                    return false;
		                }
		                value = base[propName];
		            }
		            return value != null;
		        }
		    }
	
		    function parse(zip, file, callbacks) {
		        var part = zip.files[file];
		        if (part) {
		            parseXML(part.asUint8Array(), callbacks);
		        }
		    }
	
		    function readStrings(zip) {
		        var strings = [];
		        var current = null;
		        parse(zip, "xl/sharedStrings.xml", {
		            leave: function() {
		                if (this.is(SEL_SHARED_STRING)) {
		                    strings.push(current);
		                    current = null;
		                }
		            },
		            text: function(text) {
		                if (this.is(SEL_TEXT)) {
		                    if (current == null) {
		                        current = "";
		                    }
		                    current += text;
		                }
		            }
		        });
		        return strings;
		    }
	
		    function readRelationships(zip, file) {
		        var map = { byId: {}, byType: { theme: [] } };
		        parse(zip, xl(file) + ".rels", {
		            enter: function(tag, attrs) {
		                if (tag == "Relationship") {
		                    map.byId[attrs.Id] = attrs.Target;
	
		                    var type = attrs.Type.match(/\w+$/)[0];
		                    var entries = map.byType[type] || [];
		                    entries.push(attrs.Target);
		                    map.byType[type] = entries;
		                }
		            }
		        });
		        return map;
		    }
	
		    var SEL_BORDER = ["borders", "border"];
		    var SEL_FILL = ["fills", "fill"];
		    var SEL_FONT = ["fonts", "font"];
		    var SEL_INLINE_STYLE = ["cellXfs", "xf"];
		    var SEL_NAMED_STYLE = ["cellStyleXfs", "xf"];
		    var SEL_NUM_FMT = ["numFmts", "numFmt"];
	
		    var INDEXED_COLORS = [
		        toCSSColor("FF000000"), toCSSColor("FFFFFFFF"), toCSSColor("FFFF0000"),
		        toCSSColor("FF00FF00"), toCSSColor("FF0000FF"), toCSSColor("FFFFFF00"),
		        toCSSColor("FFFF00FF"), toCSSColor("FF00FFFF"), toCSSColor("FF000000"),
		        toCSSColor("FFFFFFFF"), toCSSColor("FFFF0000"), toCSSColor("FF00FF00"),
		        toCSSColor("FF0000FF"), toCSSColor("FFFFFF00"), toCSSColor("FFFF00FF"),
		        toCSSColor("FF00FFFF"), toCSSColor("FF800000"), toCSSColor("FF008000"),
		        toCSSColor("FF000080"), toCSSColor("FF808000"), toCSSColor("FF800080"),
		        toCSSColor("FF008080"), toCSSColor("FFC0C0C0"), toCSSColor("FF808080"),
		        toCSSColor("FF9999FF"), toCSSColor("FF993366"), toCSSColor("FFFFFFCC"),
		        toCSSColor("FFCCFFFF"), toCSSColor("FF660066"), toCSSColor("FFFF8080"),
		        toCSSColor("FF0066CC"), toCSSColor("FFCCCCFF"), toCSSColor("FF000080"),
		        toCSSColor("FFFF00FF"), toCSSColor("FFFFFF00"), toCSSColor("FF00FFFF"),
		        toCSSColor("FF800080"), toCSSColor("FF800000"), toCSSColor("FF008080"),
		        toCSSColor("FF0000FF"), toCSSColor("FF00CCFF"), toCSSColor("FFCCFFFF"),
		        toCSSColor("FFCCFFCC"), toCSSColor("FFFFFF99"), toCSSColor("FF99CCFF"),
		        toCSSColor("FFFF99CC"), toCSSColor("FFCC99FF"), toCSSColor("FFFFCC99"),
		        toCSSColor("FF3366FF"), toCSSColor("FF33CCCC"), toCSSColor("FF99CC00"),
		        toCSSColor("FFFFCC00"), toCSSColor("FFFF9900"), toCSSColor("FFFF6600"),
		        toCSSColor("FF666699"), toCSSColor("FF969696"), toCSSColor("FF003366"),
		        toCSSColor("FF339966"), toCSSColor("FF003300"), toCSSColor("FF333300"),
		        toCSSColor("FF993300"), toCSSColor("FF993366"), toCSSColor("FF333399"),
		        toCSSColor("FF333333"),
		        toCSSColor("FF000000"), // System Foreground
		        toCSSColor("FFFFFFFF")  // System Background
		    ];
	
		    function readStyles(zip, theme) {
		        var styles = {
		            fonts        : [],
		            numFmts      : {},
		            fills        : [],
		            borders      : [],
		            namedStyles  : [],
		            inlineStyles : []
		        };
		        var font = null;
		        var fill = null;
		        var border = null;
		        var xf = null;
		        parse(zip, "xl/styles.xml", {
		            enter: function(tag, attrs, closed) {
		                if (this.is(SEL_NUM_FMT)) {
		                    styles.numFmts[attrs.numFmtId] = attrs;
		                }
		                else if (this.is(SEL_FONT)) {
		                    styles.fonts.push(font = {});
		                } else if (font) {
		                    if (tag == "sz") {
		                        font.size = parseFloat(attrs.val);
		                    } else if (tag == "name") {
		                        font.name = attrs.val;
		                    } else if (tag == "b") {
		                        font.bold = bool(attrs.val, true);
		                    } else if (tag == "i") {
		                        font.italic = bool(attrs.val, true);
		                    } else if (tag == "u") {
		                        font.underline = (attrs.val == null || attrs.val == "single");
		                    } else if (tag == "color") {
		                        font.color = getColor(attrs);
		                    }
		                }
		                else if (this.is(SEL_FILL)) {
		                    styles.fills.push(fill = {});
		                } else if (fill) {
		                    if (tag == "patternFill") {
		                        fill.type = attrs.patternType;
		                    } else if (tag == "fgColor" && fill.type === "solid") {
		                        fill.color = getColor(attrs);
		                    } else if (tag == "bgColor" && fill.type !== "solid") {
		                        fill.color = getColor(attrs);
		                    }
		                }
		                else if (this.is(SEL_BORDER)) {
		                    styles.borders.push(border = {});
		                } else if (border) {
		                    if (/^(?:left|top|right|bottom)$/.test(tag)) {
		                        border[tag] = { style: attrs.style || "none" };
		                    }
		                    if (tag == "color") {
		                        var side = this.stack[this.stack.length - 2].$tag;
		                        border[side].color = getColor(attrs);
		                    }
		                }
		                else if (this.is(SEL_NAMED_STYLE)) {
		                    xf = getXf(attrs);
		                    styles.namedStyles.push(xf);
		                    if (closed) {
		                        xf = null;
		                    }
		                } else if (this.is(SEL_INLINE_STYLE)) {
		                    xf = getXf(attrs);
		                    styles.inlineStyles.push(xf);
		                    if (closed) {
		                        xf = null;
		                    }
		                } else if (xf) {
		                    if (tag == "alignment") {
		                        if (/^(?:left|center|right|justify)$/.test(attrs.horizontal)) {
		                            xf.textAlign = attrs.horizontal;
		                        }
		                        if (/^(?:top|center|bottom)$/.test(attrs.vertical)) {
		                            xf.verticalAlign = attrs.vertical;
		                        }
		                        if (attrs.wrapText != null) {
		                            xf.wrapText = bool(attrs.wrapText);
		                        }
		                    }
		                }
		            },
		            leave: function(tag) {
		                if (this.is(SEL_FONT)) {
		                    font = null;
		                } else if (this.is(SEL_FILL)) {
		                    fill = null;
		                } else if (this.is(SEL_BORDER)) {
		                    border = null;
		                } else if (tag == "xf") {
		                    xf = null;
		                }
		            }
		        });
	
		        function getXf(attrs) {
		            var xf = {
		                borderId          : integer(attrs.borderId),
		                fillId            : integer(attrs.fillId),
		                fontId            : integer(attrs.fontId),
		                numFmtId          : integer(attrs.numFmtId),
		                pivotButton       : bool(attrs.pivotButton),
		                quotePrefix       : bool(attrs.quotePrefix),
		                xfId              : integer(attrs.xfId)
		            };
		            addBool("applyAlignment");
		            addBool("applyBorder");
		            addBool("applyFill");
		            addBool("applyFont");
		            addBool("applyNumberFormat");
		            addBool("applyProtection");
		            function addBool(name) {
		                if (attrs[name] != null) {
		                    xf[name] = bool(attrs[name]);
		                }
		            }
		            return xf;
		        }
	
		        function getColor(attrs) {
		            if (attrs.rgb) {
		                return toCSSColor(attrs.rgb);
		            } else if (attrs.indexed) {
		                return INDEXED_COLORS[integer(attrs.indexed)];
		            } else if (attrs.theme) {
		                var themeColor = theme.colorScheme[integer(attrs.theme)];
		                if (!themeColor) {
		                    return INDEXED_COLORS[0];
		                }
	
		                var color = kendo.parseColor(themeColor);
	
		                if (attrs.tint) {
		                    color = color.toHSL();
	
		                    var tint = parseFloat(attrs.tint);
		                    if (tint < 0) {
		                        color.l = color.l * (1 + tint);
		                    } else {
		                        color.l = color.l * (1 - tint) + (100 - 100 * (1 - tint));
		                    }
		                }
	
		                return color.toCssRgba();
		            }
		        }
	
		        return styles;
		    }
	
		    var SEL_SCHEME_RGBCLR = ["a:clrScheme", "*", "a:srgbClr"];
		    var SEL_SCHEME_SYSCLR = ["a:clrScheme", "*", "a:sysClr"];
		    function readTheme(zip, rel) {
		        var scheme = [];
		        var theme = {
		            colorScheme: scheme
		        };
	
		        var file = xl(rel);
		        if (zip.files[file]) {
		            parse(zip, file, {
		                enter: function(tag, attrs) {
		                    if (this.is(SEL_SCHEME_SYSCLR)) {
		                        scheme.push(toCSSColor(
		                            attrs.val == "window" ? "FFFFFFFF" : "FF000000"
		                        ));
		                    } else if (this.is(SEL_SCHEME_RGBCLR)) {
		                        scheme.push(toCSSColor("FF" + attrs.val));
		                    }
		                }
		            });
	
		            if (scheme.length > 3) {
		                // lt1 <-> dk1
		                swap(scheme, 0, 1);
		                // lt2 <-> dk2
		                swap(scheme, 2, 3);
		            }
		        }
	
		        function swap(arr, a, b) {
		            var tmp = arr[a];
		            arr[a] = arr[b];
		            arr[b] = tmp;
		        }
	
		        return theme;
		    }
	
		    function integer(val) {
		        return val == null ? null : parseInt(val, 10);
		    }
	
		    function bool(val, def) {
		        if (val == null) {
		            return def;
		        }
		        return val == "true" || val === true || val == 1;
		    }
	
		    function toCSSColor(rgb) {
		        var m = /^([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(rgb);
		        return "rgba(" +
		            parseInt(m[2], 16) + ", " +
		            parseInt(m[3], 16) + ", " +
		            parseInt(m[4], 16) + ", " +
		            parseInt(m[1], 16) / 255 + ")";
		    }
	
		    kendo.spreadsheet.readExcel = readExcel;
		    kendo.spreadsheet._readSheet = readSheet;
		    kendo.spreadsheet._readStrings = readStrings;
		    kendo.spreadsheet._readStyles = readStyles;
		    kendo.spreadsheet._readTheme = readTheme;
		    kendo.spreadsheet._readWorkbook = readWorkbook;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1470:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(700);
	
	/***/ }),
	
	/***/ 1471:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(719);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1455);
		module.exports = __webpack_require__(1455);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1450:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ }),
	
	/***/ 1455:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1450) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /* jshint eqnull:true, newcap:false, laxbreak:true, shadow:true, -W054 */
		    /* jshint latedef: nofunc */
	
		    var util = kendo.util;
		    var spreadsheet = kendo.spreadsheet;
		    var Ref = spreadsheet.Ref;
		    var RangeRef = spreadsheet.RangeRef;
		    var CellRef = spreadsheet.CellRef;
		    var NameRef = spreadsheet.NameRef;
		    var exports = spreadsheet.calc;
		    var runtime = exports.runtime;
	
		    // Excel formula parser and compiler to JS.
		    // some code adapted from http://lisperator.net/pltut/
	
		    var OPERATORS = Object.create(null);
	
		    var ParseError = kendo.Class.extend({
		        init: function ParseError(message, pos) {
		            this.message = message;
		            this.pos = pos;
		        },
		        toString: function() {
		            return this.message;
		        }
		    });
	
		    (function(ops){
		        ops.forEach(function(cls, i){
		            cls.forEach(function(op){
		                OPERATORS[op] = ops.length - i;
		            });
		        });
		    })([
		        [ ":" ],
		        [ " " ],
		        [ "," ],
		        [ "%" ],
		        [ "^" ],
		        [ "*", "/" ],
		        [ "+", "-" ],
		        [ "&" ],
		        [ "=", "<", ">", "<=", ">=", "<>" ]
		    ]);
	
		    var TRUE = { type: "bool", value: true };
		    var FALSE = { type: "bool", value: false };
	
		    function getcol(str) {
		        str = str.toUpperCase();
		        for (var col = 0, i = 0; i < str.length; ++i) {
		            col = col * 26 + str.charCodeAt(i) - 64;
		        }
		        return col - 1;
		    }
	
		    function getrow(str) {
		        return parseInt(str, 10) - 1;
		    }
	
		    function parseReference(name, noThrow) {
		        if (name.toLowerCase() == "#sheet") {
		            return spreadsheet.SHEETREF;
		        }
		        OUT: {
		            // this is redundant, but let's keep it fast for the most
		            // common case — A1.  If this fails, we'll try to employ the
		            // whole tokenizer.
		            var m;
		            if ((m = /^(\$)?([a-z]+)(\$)?(\d+)$/i.exec(name))) {
		                var row = getrow(m[4]), col = getcol(m[2]);
		                if (row < 0x100000 && col < 0x4000) {
		                    return new CellRef(getrow(m[4]), getcol(m[2]));
		                }
		                // no NameRef-s from this function
		                break OUT;      // jshint ignore:line
		            }
		            var stream = TokenStream(name, {});
		            var a = [];
		            while (true) {
		                var ref = stream.next();
		                if (ref instanceof CellRef) {
		                    // this function always makes absolute references
		                    ref.rel = 0;
		                } else if (ref instanceof RangeRef) {
		                    ref.topLeft.rel = 0;
		                    ref.bottomRight.rel = 0;
		                } else {
		                    break OUT;  // jshint ignore:line
		                }
		                a.push(ref);
		                if (stream.eof()) {
		                    break;
		                }
		                if (!stream.is("op", ",")) {
		                    break OUT;  // jshint ignore:line
		                }
		                stream.next();
		            }
		            return a.length == 1 ? a[0] : new spreadsheet.UnionRef(a);
		        }
		        if (!noThrow) {
		            throw new Error("Cannot parse reference: " + name);
		        }
		    }
	
		    function parseFormula(sheet, row, col, input) {
		        var refs = [];
		        input = TokenStream(input, { row: row, col: col });
		        var is = input.is;
	
		        return {
		            type: "exp",
		            ast: parseExpression(true),
		            refs: refs,
		            sheet: sheet,
		            row: row,
		            col: col
		        };
	
		        function addReference(ref) {
		            ref.index = refs.length;
		            refs.push(ref);
		            return ref;
		        }
	
		        function skip(type, value, allowEOF) {
		            if (is(type, value)) {
		                return input.next();
		            } else {
		                var tok = input.peek();
		                if (tok) {
		                    input.croak("Expected " + type + " «" + value + "» but found " + tok.type + " «" + tok.value + "»");
		                } else if (!allowEOF) {
		                    input.croak("Expected " + type + " «" + value + "»");
		                }
		            }
		        }
	
		        function parseExpression(commas) {
		            return maybeBinary(maybeIntersect(parseAtom(commas)), 0, commas);
		        }
	
		        function parseSymbol(tok) {
		            if (tok.upper == "TRUE" || tok.upper == "FALSE") {
		                return tok.upper == "TRUE" ? TRUE : FALSE;
		            }
		            return addReference(new NameRef(tok.value));
		        }
	
		        function parseFuncall() {
		            var fname = input.next();
		            fname = fname.value;
		            skip("punc", "(");
		            var args = [];
		            while (1) {
		                if (is("punc", ")")) {
		                    break;
		                }
		                if (is("op", ",")) {
		                    args.push({ type: "null" });
		                    input.next();
		                    continue;
		                }
		                args.push(parseExpression(false));
		                if (input.eof() || is("punc", ")")) {
		                    break;
		                }
		                skip("op", ",");
		            }
		            skip("punc", ")", true);
		            return {
		                type: "func",
		                func: fname,
		                args: args
		            };
		        }
	
		        function fixReference(ref) {
		            if (!ref.hasSheet()) {
		                ref.setSheet(sheet);
		            }
		            return addReference(ref);
		        }
	
		        function parseAtom(commas) {
		            var exp;
		            if (is("ref")) {
		                exp = fixReference(input.next());
		            }
		            else if (is("func")) {
		                exp = parseFuncall();
		            }
		            else if (is("punc", "(")) {
		                input.next();
		                exp = parseExpression(true);
		                skip("punc", ")", true);
		            }
		            else if (is("punc", "{")) {
		                input.next();
		                exp = parseArray();
		                skip("punc", "}", true);
		            }
		            else if (is("num") || is("str") || is("error")) {
		                exp = input.next();
		            }
		            else if (is("sym")) {
		                exp = parseSymbol(input.next());
		            }
		            else if (is("op", "+") || is("op", "-")) {
		                exp = {
		                    type: "prefix",
		                    op: input.next().value,
		                    exp: parseAtom(commas)
		                };
		            }
		            else if (!input.peek()) {
		                input.croak("Incomplete expression");
		            }
		            else if (is("punc", "[")) {
		                input.croak("External reference not supported");
		            }
		            else {
		                input.croak("Parse error");
		            }
		            return maybePercent(exp);
		        }
	
		        function parseArray() {
		            var row = [], value = [ row ], first = true;
		            while (!input.eof() && !is("punc", "}")) {
		                if (first) {
		                    first = false;
		                } else if (is("punc", ";")) {
		                    value.push(row = []);
		                    input.next();
		                } else {
		                    skip("op", ",");
		                }
		                row.push(parseExpression(false));
		            }
		            return {
		                type: "matrix",
		                value: value
		            };
		        }
	
		        function maybeIntersect(exp) {
		            if (is("punc", "(") || is("ref") || is("num") || is("func")) {
		                return {
		                    type: "binary",
		                    op: " ",
		                    left: exp,
		                    right: parseExpression(false)
		                };
		            } else {
		                return exp;
		            }
		        }
	
		        function maybePercent(exp) {
		            if (is("op", "%")) {
		                input.next();
		                return maybePercent({
		                    type: "postfix",
		                    op: "%",
		                    exp: exp
		                });
		            } else {
		                return exp;
		            }
		        }
	
		        function maybeBinary(left, my_prec, commas) {
		            var tok = is("op");
		            if (tok && (commas || tok.value != ",")) {
		                var his_prec = OPERATORS[tok.value];
		                if (his_prec > my_prec) {
		                    input.next();
		                    var right = maybeBinary(parseAtom(commas), his_prec, commas);
		                    return maybeBinary({
		                        type: "binary",
		                        op: tok.value,
		                        left: left,
		                        right: right
		                    }, my_prec, commas);
		                }
		            }
		            return left;
		        }
		    }
	
		    function parseNameDefinition(name, def) {
		        var nameRef = parseFormula(null, 0, 0, name);
		        if (!(nameRef.ast instanceof NameRef)) {
		            throw new ParseError("Invalid name: " + name);
		        }
		        nameRef = nameRef.ast;
	
		        if (!(def instanceof Ref)) {
		            var defAST = parseFormula(nameRef.sheet, 0, 0, def);
		            if (defAST.ast instanceof Ref) {
		                def = defAST.ast;   // single reference
		            } else if (/^(?:str|num|bool|error)$/.test(defAST.ast.type)) {
		                def = defAST.ast.value; // constant
		            } else {
		                def = makeFormula(defAST); // formula
		            }
		        }
	
		        return {
		            name: nameRef,
		            value: def
		        };
		    }
	
		    function makePrinter(exp) {
		        return makeClosure("function(row, col, mod){return(" + print(exp.ast, exp, 0) + ")}");
		        function print(node, parent, prec) { // jshint ignore:line, because you are stupid.
		            switch (node.type) {
		              case "num":
		              case "bool":
		                return JSON.stringify(node.value);
		              case "error":
		                return JSON.stringify("#" + node.value);
		              case "str":
		                return JSON.stringify(JSON.stringify(node.value));
		              case "ref":
		                return "this.refs[" + node.index + "].print(row, col, mod)";
		              case "prefix":
		                return withParens(function(){
		                    return JSON.stringify(node.op) + " + " + print(node.exp, node, OPERATORS[node.op]);
		                });
		              case "postfix":
		                return withParens(function(){
		                    return print(node.exp, node, OPERATORS[node.op]) + " + " + JSON.stringify(node.op);
		                });
		              case "binary":
		                return withParens(function(){
		                    var left = parenthesize(
		                        print(node.left, node, OPERATORS[node.op]),
		                        node.left instanceof NameRef && node.op == ":"
		                    );
		                    var right = parenthesize(
		                        print(node.right, node, OPERATORS[node.op]),
		                        node.right instanceof NameRef && node.op == ":"
		                    );
		                    return left + " + " + JSON.stringify(node.op) + " + " + right;
		                });
		              case "func":
		                return JSON.stringify(node.func + "(") + " + "
		                    + (node.args.length > 0
		                       ? node.args.map(function(arg){
		                           return print(arg, node, 0);
		                       }).join(" + ', ' + ")
		                       : "''")
		                    + " + ')'";
		              case "matrix":
		                return "'{ ' + " + node.value.map(function(el){
		                    return el.map(function(el){
		                        return print(el, node, 0);
		                    }).join(" + ', ' + ");
		                }).join(" + '; ' + ") + "+ ' }'";
		              case "null":
		                return "''";
		            }
		            throw new Error("Cannot make printer for node " + node.type);
	
		            function withParens(f) {
		                var op = node.op;
		                var needParens = (OPERATORS[op] < prec
		                                  || (!prec && op == ",")
		                                  || (parent.type == "prefix" && prec == OPERATORS[op] && parent.op == "-")
		                                  || (parent.type == "binary" && prec == OPERATORS[op] && node === parent.right));
		                return parenthesize(f(), needParens);
		            }
		        }
		        function parenthesize(code, cond) {
		            return cond ? "'(' + " + code + " + ')'" : code;
		        }
		    }
	
		    function toCPS(ast, k) {
		        var GENSYM = 0;
		        return cps(ast, k);
	
		        function cps(node, k){
		            switch (node.type) {
		              case "ref"     : return cpsRef(node, k);
		              case "num"     :
		              case "str"     :
		              case "null"    :
		              case "error"   :
		              case "bool"    : return cpsAtom(node, k);
		              case "prefix"  :
		              case "postfix" : return cpsUnary(node, k);
		              case "binary"  : return cpsBinary(node, k);
		              case "func"    : return cpsFunc(node, k);
		              case "lambda"  : return cpsLambda(node, k);
		              case "matrix"  : return cpsMatrix(node.value, k, true);
		            }
		            throw new Error("Cannot CPS " + node.type);
		        }
	
		        function cpsRef(node, k) {
		            return node.ref == "name" ? cpsNameRef(node, k) : cpsAtom(node, k);
		        }
	
		        function cpsAtom(node, k) {
		            return k(node);
		        }
	
		        function cpsNameRef(node, k) {
		            return {
		                type: "func",
		                func: ",getname",
		                args: [ makeContinuation(k), node ]
		            };
		        }
	
		        function cpsUnary(node, k) {
		            return cps({
		                type: "func",
		                func: "unary" + node.op,
		                args: [ node.exp ]
		            }, k);
		        }
	
		        function cpsBinary(node, k) {
		            return cps({
		                type: "func",
		                func: "binary" + node.op,
		                args: [ node.left, node.right ]
		            }, k);
		        }
	
		        function cpsIf(co, th, el, k) {
		            return cps(co, function(co){
		                // compile THEN and ELSE into a lambda which takes a callback to invoke with the
		                // result of the branches, and the IF itself will become a call the internal "if"
		                // function.
		                var rest = makeContinuation(k);
		                var thenK = gensym("T");
		                var elseK = gensym("E");
		                return {
		                    type: "func",
		                    func: "if",
		                    args: [
		                        rest,
		                        co, // condition
		                        { // then
		                            type: "lambda",
		                            vars: [ thenK ],
		                            body: cps(th || TRUE, function(th){
		                                return {
		                                    type: "call",
		                                    func: { type: "var", name: thenK },
		                                    args: [ th ]
		                                };
		                            })
		                        },
		                        { // else
		                            type: "lambda",
		                            vars: [ elseK ],
		                            body: cps(el || FALSE, function(el){
		                                return {
		                                    type: "call",
		                                    func: { type: "var", name: elseK },
		                                    args: [ el ]
		                                };
		                            })
		                        }
		                    ]
		                };
		            });
		        }
	
		        function cpsAnd(args, k) {
		            if (args.length === 0) {
		                return cpsAtom(TRUE, k);
		            }
		            return cps({
		                type: "func",
		                func: "IF",
		                args: [
		                    // first item
		                    args[0],
		                    // if true, apply AND for the rest
		                    {
		                        type: "func",
		                        func: "AND",
		                        args: args.slice(1)
		                    },
		                    // otherwise return false
		                    FALSE
		                ]
		            }, k);
		        }
	
		        function cpsOr(args, k) {
		            if (args.length === 0) {
		                return cpsAtom(FALSE, k);
		            }
		            return cps({
		                type: "func",
		                func: "IF",
		                args: [
		                    // first item
		                    args[0],
		                    // if true, return true
		                    TRUE,
		                    // otherwise apply OR for the rest
		                    {
		                        type: "func",
		                        func: "OR",
		                        args: args.slice(1)
		                    }
		                ]
		            }, k);
		        }
	
		        function cpsFunc(node, k) {
		            switch (node.func.toLowerCase()) {
		              case "if":
		                return cpsIf(node.args[0], node.args[1], node.args[2], k);
		              case "and":
		                return cpsAnd(node.args, k);
		              case "or":
		                return cpsOr(node.args, k);
		              case "true":
		                return k(TRUE);
		              case "false":
		                return k(FALSE);
		            }
		            // actual function
		            return (function loop(args, i){
		                if (i == node.args.length) {
		                    return {
		                        type : "func",
		                        func : node.func,
		                        args : args
		                    };
		                }
		                else {
		                    return cps(node.args[i], function(value){
		                        return loop(args.concat([ value ]), i + 1);
		                    });
		                }
		            })([ makeContinuation(k) ], 0);
		        }
	
		        function cpsLambda(node, k) {
		            var cont = gensym("K");
		            var body = cps(node.body, function(body){
		                return { type: "call",
		                         func: { type: "var", value: cont },
		                         args: [ body ] };
		            });
		            return k({ type: "lambda",
		                       vars: [ cont ].concat(node.vars),
		                       body: body });
		        }
	
		        function cpsMatrix(elements, k, isMatrix) {
		            var a = [];
		            return (function loop(i){
		                if (i == elements.length) {
		                    return k({
		                        type: "matrix",
		                        value: a
		                    });
		                } else {
		                    return (isMatrix ? cpsMatrix : cps)(elements[i], function(val){
		                        a[i] = val;
		                        return loop(i + 1);
		                    });
		                }
		            })(0);
		        }
	
		        function makeContinuation(k) {
		            var cont = gensym("R");
		            return {
		                type : "lambda",
		                vars : [ cont ],
		                body : k({ type: "var", name: cont })
		            };
		        }
	
		        function gensym(name) {
		            if (!name) {
		                name = "";
		            }
		            name = "_" + name;
		            return name + (++GENSYM);
		        }
		    }
	
		    var makeClosure = (function(cache){
		        return function(code) {
		            var f = cache[code];
		            if (!f) {
		                f = cache[code] = new Function("'use strict';return(" + code + ")")();
		            }
		            return f;
		        };
		    })(Object.create(null));
	
		    var FORMULA_CACHE = Object.create(null);
	
		    function makeFormula(exp) {
		        var printer = makePrinter(exp);
		        var hash = printer.call(exp); // needs .refs
		        var formula = FORMULA_CACHE[hash];
		        if (formula) {
		            // we need to clone because formulas cache the result; even if the formula is the same,
		            // its value will depend on its location, hence we need different objects.  Still, using
		            // this cache is a good idea because we'll reuse the same refs array, handler and
		            // printer instead of allocating new ones (and we skip compiling it).
		            return formula.clone(exp.sheet, exp.row, exp.col);
		        }
		        var code = js(toCPS(exp.ast, function(ret){
		            return {
		                type: "return",
		                value: ret
		            };
		        }));
	
		        code = [
		            "function(){",
		            "var context = this, refs = context.formula.absrefs",
		            code,
		            "}"
		        ].join(";\n");
	
		        formula = new runtime.Formula(exp.refs, makeClosure(code), printer, exp.sheet, exp.row, exp.col);
		        FORMULA_CACHE[hash] = formula.clone(exp.sheet, exp.row, exp.col);
		        return formula;
	
		        function js(node){
		            var type = node.type;
		            if (type == "num") {
		                return node.value + "";
		            }
		            else if (type == "str") {
		                return JSON.stringify(node.value);
		            }
		            else if (type == "error") {
		                return "context.error(" + JSON.stringify(node.value) + ")";
		            }
		            else if (type == "return") {
		                return "context.resolve(" + js(node.value) + ")";
		            }
		            else if (type == "func") {
		                return "context.func(" + JSON.stringify(node.func) + ", "
		                    + js(node.args[0]) + ", " // the callback
		                    + jsArray(node.args.slice(1)) // the arguments
		                    + ")";
		            }
		            else if (type == "call") {
		                return js(node.func) + "(" + node.args.map(js).join(", ") + ")";
		            }
		            else if (type == "ref") {
		                return "refs[" + node.index + "]";
		            }
		            else if (type == "bool") {
		                return "" + node.value;
		            }
		            else if (type == "if") {
		                return "(context.bool(" + js(node.co) + ") ? " + js(node.th) + " : " + js(node.el) + ")";
		            }
		            else if (type == "lambda") {
		                return "(function("
		                    + node.vars.join(", ")
		                    + "){ return(" + js(node.body) + ") })";
		            }
		            else if (type == "var") {
		                return node.name;
		            }
		            else if (type == "matrix") {
		                return jsArray(node.value);
		            }
		            else if (type == "null") {
		                return "null";
		            }
		            else {
		                throw new Error("Cannot compile expression " + type);
		            }
		        }
	
		        function jsArray(a) {
		            return "[ " + a.map(js).join(", ") + " ]";
		        }
		    }
	
		    function identity(x) {
		        return x;
		    }
	
		    function TokenStream(input, options) {
		        input = RawTokenStream(InputStream(input), options);
		        var ahead = input.ahead;
		        var skip = input.skip;
		        var token = null;
		        var fixCell = options.row != null && options.col != null
		            ? function(cell) {
		                if (cell.rel & 1) {
		                    cell.col -= options.col;
		                }
		                if (cell.rel & 2) {
		                    cell.row -= options.row;
		                }
		                return cell;
		            }
		            : identity;
	
		        var addPos = options.forEditor
		            ? function(thing, startToken, endToken) {
		                thing.begin = startToken.begin;
		                thing.end = endToken.end;
		                return thing;
		            }
		            : identity;
	
		        return {
		            peek  : peek,
		            next  : next,
		            croak : input.croak,
		            eof   : input.eof,
		            is    : is
		        };
	
		        function is(type, value) {
		            var tok = peek();
		            return tok != null
		                && (type == null || tok.type === type)
		                && (value == null || tok.value === value)
		                ? tok : null;
		        }
	
		        function peek() {
		            if (token == null) {
		                token = readNext();
		            }
		            return token;
		        }
	
		        function next() {
		            if (token != null) {
		                var tmp = token;
		                token = null;
		                return tmp;
		            }
		            return readNext();
		        }
	
		        function readNext() {
		            var ret;
		            var t = input.peek();
		            if (t) {
		                if (t.type == "sym" || t.type == "rc" || t.type == "num") {
		                    ret =  ahead(8, refRange3D)
		                        || ahead(6, refCell3D)
		                        || ahead(6, refSheetRange)
		                        || ahead(4, refSheetCell)
		                        || ahead(4, refRange)
		                        || ahead(2, refCell)
		                        || ahead(2, funcall);
		                }
		                if (!ret) {
		                    ret = input.next();
		                }
		            }
		            return ret;
		        }
	
		        function toCell(tok, isFirst) {
		            if (tok.type == "rc") {
		                // RC notation is read properly without knowing where
		                // we are, so no need to fixCell on this one.
		                // However, if only absolute refs were asked for (from
		                // i.e. parseReference) I feel it's alright to yell
		                // about it here.
		                if (tok.rel && !options.forEditor && (options.row == null || options.col == null)) {
		                    input.croak("Cannot read relative cell in RC notation");
		                }
		                return new CellRef(tok.row, tok.col, tok.rel);
		            }
		            if (tok.type == "num") {
		                if (tok.value <= 1048577) {
		                    // whole row
		                    return fixCell(new CellRef(
		                        getrow(tok.value),
		                        isFirst ? -Infinity : +Infinity,
		                        2
		                    ));
		                } else {
		                    return null;
		                }
		            }
		            // otherwise it's "sym".  The OOXML spec (SpreadsheetML
		            // 18.2.5) defines the maximum value to be interpreted as
		            // a cell reference to be XFD1048576.
		            var name = tok.value;
		            var m = /^(\$)?([a-z]+)(\$)?(\d+)$/i.exec(name);
		            if (m) {
		                var row = getrow(m[4]), col = getcol(m[2]);
		                if (row <= 1048576 && col <= 16383) {
		                    return fixCell(new CellRef(
		                        getrow(m[4]),
		                        getcol(m[2]),
		                        (m[1] ? 0 : 1) | (m[3] ? 0 : 2)
		                    ));
		                } else {
		                    return null;
		                }
		            }
		            var abs = name.charAt(0) == "$";
		            if (abs) {
		                name = name.substr(1);
		            }
		            if (/^\d+$/.test(name)) {
		                var row = getrow(name);
		                if (row <= 1048576) {
		                    return fixCell(new CellRef(
		                        getrow(name),
		                        isFirst ? -Infinity : +Infinity,
		                        (abs ? 0 : 2)
		                    ));
		                }
		            } else {
		                var col = getcol(name);
		                if (col <= 16383) {
		                    return fixCell(new CellRef(
		                        isFirst ? -Infinity : +Infinity,
		                        getcol(name),
		                        (abs ? 0 : 1)
		                    ));
		                }
		            }
		        }
	
		        // Sheet1(a) :(b) Sheet2(c) !(d) A1(e) :(f) C3(g) not followed by paren (h)
		        function refRange3D(a, b, c, d, e, f, g, h) {
		            if (a.type == "sym" &&
		                b.type == "op" && b.value == ":" &&
		                c.type == "sym" &&
		                d.type == "punc" && d.value == "!" &&
		                (e.type == "sym" || e.type == "rc" || (e.type == "num" && e.value == e.value|0)) &&
		                f.type == "op" && f.value == ":" &&
		                (g.type == "sym" || g.type == "rc" || (g.type == "num" && g.value == g.value|0)) &&
		                g.type == e.type &&
		                !(h.type == "punc" && h.value == "(" && !g.space))
		            {
		                var tl = toCell(e, true), br = toCell(g, false);
		                if (tl && br) {
		                    // skip them except the last one, we only wanted to
		                    // ensure it's not paren.
		                    skip(7);
		                    return addPos(new RangeRef(
		                        tl.setSheet(a.value, true),
		                        br.setSheet(c.value, true)
		                    ).setSheet(a.value, true), a, g);
		                }
		            }
		        }
	
		        // Sheet1(a) :(b) Sheet2(c) !(d) A1(e) not followed by paren (f)
		        function refCell3D(a, b, c, d, e, f) {
		            if (a.type == "sym" &&
		                b.type == "op" && b.value == ":" &&
		                c.type == "sym" &&
		                d.type == "punc" && d.value == "!" &&
		                (e.type == "sym" || e.type == "rc" || (e.type == "num" && e.value == e.value|0)) &&
		                !(f.type == "punc" && f.value == "(" && !e.space))
		            {
		                var tl = toCell(e);
		                if (tl) {
		                    skip(5);
		                    var br = tl.clone();
		                    return addPos(new RangeRef(
		                        tl.setSheet(a.value, true),
		                        br.setSheet(c.value, true)
		                    ).setSheet(a.value, true), a, e);
		                }
		            }
		        }
	
		        // Sheet1(a) !(b) A1(c) :(d) C3(e) not followed by paren (f)
		        function refSheetRange(a, b, c, d, e, f) {
		            if (a.type == "sym" &&
		                b.type == "punc" && b.value == "!" &&
		                (c.type == "sym" || c.type == "rc" || (c.type == "num" && c.value == c.value|0)) &&
		                d.type == "op" && d.value == ":" &&
		                (e.type == "sym" || e.type == "rc" || (e.type == "num" && e.value == e.value|0)) &&
		                !(f.type == "punc" && f.value == "(" && !e.space))
		            {
		                var tl = toCell(c, true), br = toCell(e, false);
		                if (tl && br) {
		                    skip(5);
		                    return addPos(new RangeRef(tl, br).setSheet(a.value, true), a, e);
		                }
		            }
		        }
	
		        // Sheet1(a) !(b) A1(c) not followed by paren (d)
		        function refSheetCell(a, b, c, d) {
		            if (a.type == "sym" &&
		                b.type == "punc" && b.value == "!" &&
		                (c.type == "sym" || c.type == "rc" || (c.type == "num" && c.value == c.value|0)) &&
		                !(d.type == "punc" && d.value == "(" && !c.space))
		            {
		                skip(3);
		                var x = toCell(c);
		                if (!x || !isFinite(x.row)) {
		                    x = new NameRef(c.value);
		                }
		                return addPos(x.setSheet(a.value, true), a, c);
		            }
		        }
	
		        // A1(a) :(b) C3(c) not followed by paren (d)
		        function refRange(a, b, c, d) {
		            if ((a.type == "sym" || a.type == "rc" || (a.type == "num" && a.value == a.value|0)) &&
		                (b.type == "op" && b.value == ":") &&
		                (c.type == "sym" || c.type == "rc" || (c.type == "num" && c.value == c.value|0)) &&
		                !(d.type == "punc" && d.value == "(" && !c.space))
		            {
		                var tl = toCell(a, true), br = toCell(c, false);
		                if (tl && br) {
		                    skip(3);
		                    return addPos(new RangeRef(tl, br), a, c);
		                }
		            }
		        }
	
		        // A1(a) not followed by paren (b)
		        function refCell(a, b) {
		            if ((a.type == "sym" || a.type == "rc") && !(b.type == "punc" && b.value == "(" && !a.space)) {
		                var x = toCell(a);
		                if (x && isFinite(x.row) && isFinite(x.col)) {
		                    skip(1);
		                    return addPos(x, a, a);
		                }
		            }
		        }
	
		        function funcall(a, b) {
		            if (a.type == "sym" && b.type == "punc" && b.value == "(" && !a.space) {
		                a.type = "func";
		                skip(1);
		                return a;       // already has position
		            }
		        }
		    }
	
		    function isWhitespace(ch) {
		        return " \t\n\xa0\u200b".indexOf(ch) >= 0;
		    }
	
		    function RawTokenStream(input, options) {
		        var tokens = [], index = 0;
		        var readWhile = input.readWhile;
	
		        return {
		            next  : next,
		            peek  : peek,
		            eof   : eof,
		            croak : input.croak,
		            ahead : ahead,
		            skip  : skip
		        };
	
		        function isDigit(ch) {
		            return (/[0-9]/i.test(ch));
		        }
	
		        function isIdStart(ch) {
		            return (/[a-z$_]/i.test(ch) || util.isUnicodeLetter(ch));
		        }
	
		        function isId(ch) {
		            return isIdStart(ch) || isDigit(ch) || ch == ".";
		        }
	
		        function isOpChar(ch) {
		            return ch in OPERATORS;
		        }
	
		        function isPunc(ch) {
		            return "!;(){}[]".indexOf(ch) >= 0;
		        }
	
		        function readNumber() {
		            // XXX: TODO: exponential notation
		            var has_dot = false;
		            var number = readWhile(function(ch){
		                if (ch == ".") {
		                    if (has_dot) {
		                        return false;
		                    }
		                    has_dot = true;
		                    return true;
		                }
		                return isDigit(ch);
		            });
		            return { type: "num", value: parseFloat(number) };
		        }
	
		        function symbol(id, quote) {
		            return {
		                type  : "sym",
		                value : id,
		                upper : id.toUpperCase(),
		                space : isWhitespace(input.peek()),
		                quote : quote
		            };
		        }
	
		        function getRC(a, b, c) {
		            if (!a && !b && !c) {
		                return null;
		            }
		            if ((!a && !c) || (a && c)) {
		                var num = b ? parseInt(b, 10) : 0;
		                return a ? num : num - 1;
		            }
		        }
	
		        function readSymbol() {
		            var m = input.lookingAt(/^R(\[)?(-?[0-9]+)?(\])?C(\[)?(-?[0-9]+)?(\])?/i);
		            if (m) {
		                var row = getRC(m[1], m[2], m[3]);
		                var col = getRC(m[4], m[5], m[6]);
		                if (row != null && col != null) {
		                    input.skip(m);
		                    return {
		                        type: "rc",
		                        row: row,
		                        col: col,
		                        rel: ((m[4] || !(m[4] || m[5] || m[6]) ? 1 : 0) // col
		                              |
		                              (m[1] || !(m[1] || m[2] || m[3]) ? 2 : 0) // row
		                             )
		                    };
		                }
		            }
		            return symbol(readWhile(isId));
		        }
	
		        function readString() {
		            input.next();
		            return { type: "str", value: input.readEscaped('"') };
		        }
	
		        function readSheetName() {
		            input.next();
		            return symbol(input.readEscaped("'"), true);
		        }
	
		        function readOperator() {
		            return {
		                type  : "op",
		                value : readWhile(function(ch, op){
		                    return (op + ch) in OPERATORS;
		                })
		            };
		        }
	
		        function readPunc() {
		            return {
		                type  : "punc",
		                value : input.next()
		            };
		        }
	
		        function readNext() {
		            if (input.eof()) {
		                return null;
		            }
		            var ch = input.peek(), m;
		            if (ch == '"') {
		                return readString();
		            }
		            if (ch == "'") {
		                return readSheetName();
		            }
		            if (isDigit(ch) || ch == ".") {
		                return readNumber();
		            }
		            if (isIdStart(ch)) {
		                return readSymbol();
		            }
		            if (isOpChar(ch)) {
		                return readOperator();
		            }
		            if (isPunc(ch)) {
		                return readPunc();
		            }
		            if ((m = input.lookingAt(/^#([a-z\/]+)[?!]?/i))) {
		                input.skip(m);
		                return { type: "error", value: m[1] };
		            }
		            if (!options.forEditor) {
		                input.croak("Can't handle character: " + ch);
		            }
		            return { type: "error", value: input.next() };
		        }
	
		        function peek() {
		            while (tokens.length <= index) {
		                readWhile(isWhitespace);
		                var begin = input.pos();
		                var tok = readNext();
		                if (options.forEditor && tok) {
		                    tok.begin = begin;
		                    tok.end = input.pos();
		                }
		                tokens.push(tok);
		            }
		            return tokens[index];
		        }
	
		        function next() {
		            var tok = peek();
		            if (tok) {
		                index++;
		            }
		            return tok;
		        }
	
		        function ahead(n, f) {
		            var pos = index, a = [];
		            while (n-- > 0) {
		                a.push(next() || EOF);
		            }
		            index = pos;
		            return f.apply(a, a);
		        }
	
		        function skip(n) {
		            index += n;
		        }
	
		        function eof() {
		            return peek() == null;
		        }
		    }
	
		    var EOF = { type: "eof" };
	
		    function InputStream(input) {
		        var pos = 0, line = 1, col = 0;
		        return {
		            next        : next,
		            peek        : peek,
		            eof         : eof,
		            croak       : croak,
		            readWhile   : readWhile,
		            readEscaped : readEscaped,
		            lookingAt   : lookingAt,
		            skip        : skip,
		            forward     : forward,
		            pos         : location
		        };
		        function location() { // jshint ignore:line, :-(
		            return pos;
		        }
		        function next() {
		            var ch = input.charAt(pos++);
		            if (ch == "\n") {
		                line++;
		                col = 0;
		            } else {
		                col++;
		            }
		            return ch;
		        }
		        function peek() {
		            return input.charAt(pos);
		        }
		        function eof() {
		            return peek() === "";
		        }
		        function croak(msg) {
		            throw new ParseError(msg + " (input: " + input + ")", pos);
		        }
		        function skip(ch) {
		            if (typeof ch == "string") {
		                if (input.substr(pos, ch.length) != ch) {
		                    croak("Expected " + ch);
		                }
		                forward(ch.length);
		            } else if (ch instanceof RegExp) {
		                var m = ch.exec(input.substr(pos));
		                if (m) {
		                    forward(m[0].length);
		                    return m;
		                }
		            } else {
		                // assuming RegExp match data
		                forward(ch[0].length);
		            }
		        }
		        function forward(n) {
		            while (n-- > 0) {
		                next();
		            }
		        }
		        function readEscaped(end) {
		            var escaped = false, str = "";
		            while (!eof()) {
		                var ch = next();
		                if (escaped) {
		                    str += ch;
		                    escaped = false;
		                } else if (ch == "\\") {
		                    escaped = true;
		                } else if (ch == end) {
		                    break;
		                } else {
		                    str += ch;
		                }
		            }
		            return str;
		        }
		        function readWhile(predicate) {
		            var str = "";
		            while (!eof() && predicate(peek(), str)) {
		                str += next();
		            }
		            return str;
		        }
		        function lookingAt(rx) {
		            return rx.exec(input.substr(pos));
		        }
		    }
	
		    //// exports
	
		    var FORMAT_PARSERS = [];
	
		    var registerFormatParser = exports.registerFormatParser = function(p) {
		        FORMAT_PARSERS.push(p);
		    };
	
		    exports.parse = function(sheet, row, col, input, format) {
		        if (input instanceof Date) {
		            return { type: "date", value: runtime.dateToSerial(input) };
		        }
		        if (typeof input == "number") {
		            return { type: "number", value: input };
		        }
		        if (typeof input == "boolean") {
		            return { type: "boolean", value: input };
		        }
		        input += "";
		        if (/^'/.test(input)) {
		            return {
		                type: "string",
		                value: input.substr(1)
		            };
		        }
		        if (/^[0-9]+%$/.test(input)) {
		            var str = input.substr(0, input.length - 1);
		            var num = parseFloat(str);
		            if (!isNaN(num) && num == str) {
		                return {
		                    type: "percent",
		                    value: num / 100
		                };
		            }
		        }
		        if (/^=/.test(input)) {
		            input = input.substr(1);
		            if (/\S/.test(input)) {
		                return parseFormula(sheet, row, col, input);
		            } else {
		                return {
		                    type: "string",
		                    value: "=" + input
		                };
		            }
		        }
		        for (var i = 0; i < FORMAT_PARSERS.length; ++i) {
		            var result = FORMAT_PARSERS[i](input);
		            if (result) {
		                return result;
		            }
		        }
		        if (input.toLowerCase() == "true") {
		            return { type: "boolean", value: true };
		        }
		        if (input.toLowerCase() == "false") {
		            return { type: "boolean", value: false };
		        }
		        var date = runtime.parseDate(input, format);
		        if (date) {
		            return { type: "date", value: runtime.dateToSerial(date) };
		        }
		        var num = parseFloat(input);
		        if (!isNaN(num) && input.length > 0 && num == input) {
		            return {
		                type: "number",
		                value: num
		            };
		        }
		        return {
		            type: "string",
		            value: input
		        };
		    };
	
		    function tokenize(input, row, col) {
		        var tokens = [];
		        input = TokenStream(input, { forEditor: true, row: row, col: col });
		        while (!input.eof()) {
		            tokens.push(next());
		        }
		        var tok = tokens[0];
		        if (tok.type == "op" && tok.value == "=") {
		            tok.type = "startexp";
		        }
		        return tokens;
	
		        function next() {
		            var tok = input.next();
		            if (tok.type == "sym") {
		                if (tok.upper == "TRUE") {
		                    tok.type = "bool";
		                    tok.value = true;
		                } else if (tok.upper == "FALSE") {
		                    tok.type = "bool";
		                    tok.value = false;
		                }
		            } else if (tok.type == "ref") {
		                tok = {
		                    type  : "ref",
		                    ref   : (row != null && col != null ? tok.absolute(row, col) : tok),
		                    begin : tok.begin,
		                    end   : tok.end
		                };
		            }
		            return tok;
		        }
		    }
	
		    // The `sqref` attribute in dataValidation (XLSX) will contain a space-separated list of
		    // references.  This helper is called from excel-reader.js to parse them.
		    function parseSqref(input, row, col) {
		        row = row || 0;
		        col = col || 0;
		        input = TokenStream(input, { row: row, col: col });
		        var refs = [];
		        while (!input.eof()) {
		            var ref = input.next();
		            if (ref.type != "ref") {
		                throw new ParseError("Expecting a reference but got: " + JSON.stringify(ref));
		            }
		            refs.push(ref.absolute(row, col));
		        }
		        return refs;
		    }
	
		    exports.parseNameDefinition = parseNameDefinition;
		    exports.parseFormula = parseFormula;
		    exports.parseReference = parseReference;
		    exports.compile = makeFormula;
		    exports.parseSqref = parseSqref;
	
		    exports.InputStream = InputStream;
		    exports.ParseError = ParseError;
		    exports.tokenize = tokenize;
	
		    /* -----[ a few special formats ]----- */
	
		    // various time formats
		    registerFormatParser(function(input){
		        var m, date = 0, format = "";
		        // have date part?
		        if ((m = /^(\d+)([-/.])(\d+)\2(\d{2}(?:\d{2})?)(\s*)/.exec(input))) {
		            var mo = parseInt(m[1], 10);
		            var sep = m[2];
		            var da = parseInt(m[3], 10);
		            var yr = parseInt(m[4], 10);
		            if (yr < 30) {
		                yr += 2000;
		            } else if (yr < 100) {
		                yr += 1900;
		            }
		            var monthFirst = true;
		            if (mo > 12) {
		                var tmp = mo;
		                mo = da;
		                da = tmp;
		                monthFirst = false;
		            }
		            if (!runtime.validDate(yr, mo, da)) {
		                return null;
		            }
		            date = runtime.packDate(yr, mo - 1, da);
		            if (date < 0) { date--; }
		            if (monthFirst) {
		                format = ["mm", "dd", "yyyy"].join(sep);
		            } else {
		                format = ["dd", "mm", "yyyy"].join(sep);
		            }
		            format += m[5];
		            input = input.substr(m[0].length); // skip the date
		        }
		        // hh:mm
		        if ((m = /^(\d+):(\d+)$/.exec(input))) {
		            var hh = parseInt(m[1], 10);
		            var mm = parseInt(m[2], 10);
		            return {
		                type   : "date",
		                format : format + "hh:mm",
		                value  : date + runtime.packTime(hh, mm, 0, 0)
		            };
		        }
		        // mm:ss.ms
		        if ((m = /^(\d+):(\d+)(\.\d+)$/.exec(input))) {
		            var mm = parseInt(m[1], 10);
		            var ss = parseInt(m[2], 10);
		            var ms = parseFloat(m[3]) * 1000;
		            return {
		                type   : "date",
		                format : format + "mm:ss.00",
		                value  : date + runtime.packTime(0, mm, ss, ms)
		            };
		        }
		        // hh:mm:ss
		        if ((m = /^(\d+):(\d+):(\d+)$/.exec(input))) {
		            var hh = parseInt(m[1], 10);
		            var mm = parseInt(m[2], 10);
		            var ss = parseInt(m[3], 10);
		            return {
		                type   : "date",
		                format : format + "hh:mm:ss",
		                value  : date + runtime.packTime(hh, mm, ss, 0)
		            };
		        }
		        // hh:mm:ss.ms
		        if ((m = /^(\d+):(\d+):(\d+)(\.\d+)$/.exec(input))) {
		            var hh = parseInt(m[1], 10);
		            var mm = parseInt(m[2], 10);
		            var ss = parseInt(m[3], 10);
		            var ms = parseFloat(m[4]) * 1000;
		            return {
		                type   : "date",
		                format : format + "hh:mm:ss.00",
		                value  : date + runtime.packTime(hh, mm, ss, ms)
		            };
		        }
		    });
	
		    // Support numeric formats with thousands separator and/or currency symbol, like `1,234,567.00`,
		    // `$1234`, `123,456.78 $` etc.  I apologize for this code.
		    registerFormatParser(function(input){
		        var m, n;
		        var culture = kendo.culture();
		        var comma = culture.numberFormat[","];
		        var dot = culture.numberFormat["."];
		        var currency = culture.numberFormat.currency.symbol;
		        var rxnum = getNumberRegexp(comma, dot);
		        var rxcur = new RegExp("^\\s*\\" + currency + "\\s*");
		        var sign = 1;
		        var format = "";
		        var suffix = "";
		        var has_currency = false;
	
		        input = InputStream(input.replace(/^\s+|\s+$/g, ""));
	
		        // has minus before currency?
		        if (input.skip(/^-\s*/)) {
		            sign = -1;
		        }
	
		        // has currency before number?
		        if ((m = input.skip(rxcur))) {
		            has_currency = true;
		            format += '"' + m[0] + '"';
		        }
	
		        // has minus after currency?
		        if (input.skip(/^-\s*/)) {
		            if (sign < 0) {
		                return null;    // not a number
		            }
		            sign = -1;
		        }
	
		        // read the number itself
		        if (!(n = input.skip(rxnum))) {
		            return null;        // not a number
		        }
		        format += "#";
	
		        // has currency after number?
		        if ((m = input.skip(rxcur))) {
		            if (has_currency) {
		                return null;    // either before or after, not both.
		            }
		            has_currency = true;
		            suffix = '"' + m[0] + '"';
		        }
	
		        if (!input.eof()) {
		            return null;        // should anything else follow, not a number
		        }
	
		        if (n[2] || has_currency) {
		            format += ",#";
		        }
		        if (n[3]) {
		            format += "." + repeat("0", n[3].length - 1);
		        }
		        var value = n[0]
		            .replace(new RegExp("\\" + comma, "g"), "")
		            .replace(new RegExp("\\" + dot, "g"), ".");
	
		        format += suffix;
		        if (has_currency) {
		            format += ';-' + format;
		        }
	
		        return {
		            type: "number",
		            currency: has_currency,
		            format: format,
		            value: sign * parseFloat(value)
		        };
		    });
	
		    registerFormatParser(function(input){
		        var m;
		        if ((m = /^([0-9]*)\.([0-9]+)(\s*%)$/.exec(input))) {
		            return {
		                type: "number",
		                value: parseFloat(input) / 100,
		                format: "0." + repeat("0", m[2].length) + m[3]
		            };
		        }
		    });
	
		    var NUMBER_FORMAT_RX = {};
		    function getNumberRegexp(comma, dot) {
		        var id = comma + dot;
		        var rx = NUMBER_FORMAT_RX[id];
		        if (!rx) {
		            rx = "^(\\d+(COM\\d{3})*(DOT\\d+)?)";
		            rx = rx.replace(/DOT/g, "\\" + dot).replace(/COM/g, "\\" + comma);
		            rx = new RegExp(rx);
		            NUMBER_FORMAT_RX[id] = rx;
		        }
		        return rx;
		    }
	
		    function repeat(str, len) {
		        var out = "";
		        while (len-- > 0) {
		            out += str;
		        }
		        return out;
		    }
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1511);
		module.exports = __webpack_require__(1511);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1450:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ }),
	
	/***/ 1481:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(708);
	
	/***/ }),
	
	/***/ 1511:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(1450), __webpack_require__(1481), __webpack_require__(1512) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
		    var Formula = kendo.spreadsheet.calc.runtime.Formula;
		    var Ref = kendo.spreadsheet.Ref;
		    var CalcError = kendo.spreadsheet.CalcError;
	
		    var Workbook = kendo.Observable.extend({
		        init: function(options, view) {
		            kendo.Observable.fn.init.call(this);
	
		            this.options = options;
	
		            this._view = view;
		            this._sheets = [];
	
		            this._sheetsSearchCache = {};
	
		            this._sheet = this.insertSheet({
		                rows: this.options.rows,
		                columns: this.options.columns,
		                rowHeight: this.options.rowHeight,
		                columnWidth: this.options.columnWidth,
		                headerHeight: this.options.headerHeight,
		                headerWidth: this.options.headerWidth,
		                dataSource: this.options.dataSource
		            });
	
		            this.undoRedoStack = new kendo.util.UndoRedoStack();
		            this.undoRedoStack.bind(["undo", "redo"], this._onUndoRedo.bind(this));
	
		            this._context = new kendo.spreadsheet.FormulaContext(this);
		            this._validationContext = new kendo.spreadsheet.ValidationFormulaContext(this);
		            this._names = Object.create(null);
	
		            this.fromJSON(this.options);
		        },
	
		        clipboard: function() {
		            if(!this._clipboard) {
		                 this._clipboard = new kendo.spreadsheet.Clipboard(this);
		            }
		            return this._clipboard;
		        },
	
		        destroy: function() {
		            this.unbind();
	
		            if (this._clipboard) {
		                this._clipboard.destroy();
		            }
		        },
	
		        events: [
		            "cut",
		            "copy",
		            "paste",
		            "change",
		            "excelImport",
		            "excelExport",
		            "insertSheet",
		            "removeSheet",
		            "selectSheet",
		            "renameSheet",
		            "insertRow",
		            "insertColumn",
		            "deleteRow",
		            "deleteColumn",
		            "hideRow",
		            "hideColumn",
		            "unhideRow",
		            "unhideColumn",
		            "select",
		            "changeFormat"
		        ],
	
		        _sheetChange: function(e) {
		            this.trigger("change", e);
		        },
	
		        _sheetInsertRow: function(e) {
		            if (this.trigger("insertRow", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetInsertColumn: function(e) {
		            if (this.trigger("insertColumn", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetDeleteRow: function(e) {
		            if (this.trigger("deleteRow", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetDeleteColumn: function(e) {
		            if (this.trigger("deleteColumn", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetHideRow: function(e) {
		            if (this.trigger("hideRow", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetHideColumn: function(e) {
		            if (this.trigger("hideColumn", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetUnhideRow: function(e) {
		            if (this.trigger("unhideRow", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetUnhideColumn: function(e) {
		            if (this.trigger("unhideColumn", {
		                sheet: e.sender,
		                index: e.index
		            })) {
		                e.preventDefault();
		            }
		        },
	
		        _sheetSelect: function(e) {
		            this.trigger("select", e);
		        },
	
		        _sheetCommandRequest: function(e) {
		            this.trigger("commandRequest", e);
		        },
	
		        _inputForRef: function(ref) {
		            return new kendo.spreadsheet.Range(ref, this._sheet).input();
		        },
	
		        _onUndoRedo: function(e) {
		            e.command.range().select();
		        },
	
		        execute: function(options) {
		            var commandOptions = $.extend({ workbook: this }, options.options);
		            var command = new kendo.spreadsheet[options.command](commandOptions);
		            var sheet = this.activeSheet();
	
		            if (commandOptions.origin) {
		                command.origin(commandOptions.origin);
		            }
	
		            if (commandOptions.operatingRange) {
		                command.range(commandOptions.operatingRange);
		            } else {
		                command.range(sheet.selection());
		            }
	
		            var result = command.exec();
	
		            if (!result || result.reason !== "error") {
		                if (command.cannotUndo) {
		                    this.undoRedoStack.clear();
		                } else {
		                    this.undoRedoStack.push(command);
		                }
		            }
	
		            return result;
		        },
	
		        resetFormulas: function() {
		            this._sheets.forEach(function(sheet){
		                sheet.resetFormulas();
		            });
		        },
	
		        resetValidations: function() {
		            this._sheets.forEach(function(sheet){
		                sheet.resetValidations();
		            });
		        },
	
		        refresh: function(reason) {
		            if (reason.recalc) {
		                this.resetFormulas();
		                this.resetValidations();
		                this._sheet.recalc(this._context);
		                this._sheet.revalidate(this._validationContext);
		            }
		        },
	
		        activeSheet: function(sheet) {
		            if (sheet === undefined) {
		                return this._sheet;
		            }
	
		            if (!this.sheetByName(sheet.name())) {
		                return;
		            }
	
		            this._sheet = sheet;
	
		            //TODO: better way to get all reasons?
		            sheet.triggerChange(kendo.spreadsheet.ALL_REASONS);
		        },
	
		        moveSheetToIndex: function(sheet, toIndex) {
		            var fromIndex = this.sheetIndex(sheet);
		            var sheets = this._sheets;
	
		            if (fromIndex === -1) {
		                return;
		            }
	
		            this._sheetsSearchCache = {};
	
		            sheets.splice(toIndex, 0, sheets.splice(fromIndex, 1)[0]);
	
		            this.trigger("change", { sheetSelection: true });
		        },
	
		        insertSheet: function(options) {
		            options = options || {};
		            var that = this;
		            var insertIndex = typeof options.index === "number" ? options.index : that._sheets.length;
		            var sheetName;
		            var sheets = that._sheets;
	
		            var getUniqueSheetName = function(sheetNameSuffix) {
		                sheetNameSuffix = sheetNameSuffix ? sheetNameSuffix : 1;
	
		                var name = "Sheet" + sheetNameSuffix;
	
		                if (!that.sheetByName(name)) {
		                    return name;
		                }
	
		                return getUniqueSheetName(sheetNameSuffix + 1);
		            };
	
		            if (options.name && that.sheetByName(options.name)) {
		                return;
		            }
	
		            this._sheetsSearchCache = {};
	
		            sheetName = options.name || getUniqueSheetName();
	
		            var sheet = new kendo.spreadsheet.Sheet(
		                options.rows || this.options.rows,
		                options.columns || this.options.columns,
		                options.rowHeight || this.options.rowHeight,
		                options.columnWidth || this.options.columnWidth,
		                options.headerHeight || this.options.headerHeight,
		                options.headerWidth || this.options.headerWidth,
		                options.defaultCellStyle || this.options.defaultCellStyle
		            );
	
		            sheet._workbook = this;
	
		            sheet._name(sheetName);
	
		            this._bindSheetEvents(sheet);
	
		            sheets.splice(insertIndex, 0, sheet);
	
		            if (options.data) {
		                sheet.fromJSON(options.data);
		            }
	
		            if (options.dataSource) {
		                sheet.setDataSource(options.dataSource);
		            }
	
		            this.trigger("change", { sheetSelection: true });
	
		            return sheet;
		        },
	
		        _bindSheetEvents: function(sheet) {
		            sheet.bind("change", this._sheetChange.bind(this));
		            sheet.bind("insertRow", this._sheetInsertRow.bind(this));
		            sheet.bind("insertColumn", this._sheetInsertColumn.bind(this));
		            sheet.bind("deleteRow", this._sheetDeleteRow.bind(this));
		            sheet.bind("deleteColumn", this._sheetDeleteColumn.bind(this));
		            sheet.bind("hideRow", this._sheetHideRow.bind(this));
		            sheet.bind("hideColumn", this._sheetHideColumn.bind(this));
		            sheet.bind("unhideRow", this._sheetUnhideRow.bind(this));
		            sheet.bind("unhideColumn", this._sheetUnhideColumn.bind(this));
		            sheet.bind("select", this._sheetSelect.bind(this));
		            sheet.bind("commandRequest", this._sheetCommandRequest.bind(this));
		        },
	
		        sheets: function() {
		            return this._sheets.slice();
		        },
	
		        sheetByName: function (sheetName) {
		            return this._sheets[this.sheetIndex(sheetName)];
		        },
	
		        sheetByIndex: function(index) {
		            return this._sheets[index];
		        },
	
		        sheetIndex: function(sheet) {
		            var sheets = this._sheets;
		            var sheetName = (typeof sheet == "string" ? sheet : sheet.name()).toLowerCase();
		            var idx = this._sheetsSearchCache[sheetName];
	
		            if (idx >= 0) {
		                return idx;
		            }
	
		            for(idx = 0; idx < sheets.length; idx++) {
		                var name = sheets[idx].name().toLowerCase();
		                this._sheetsSearchCache[name] = idx;
	
		                if (name === sheetName) {
		                    return idx;
		                }
		            }
	
		            return -1;
		        },
	
		        renameSheet: function(sheet, newSheetName) {
		            var oldSheetName = sheet.name().toLowerCase();
	
		            if (!newSheetName ||
		                oldSheetName === newSheetName.toLowerCase() ||
		                this.sheetByName(newSheetName)) {
		                return;
		            }
	
		            sheet = this.sheetByName(oldSheetName);
	
		            if (!sheet) {
		                return;
		            }
	
		            this._sheetsSearchCache = {};
	
		            if (this.trigger("renameSheet", {
		                sheet: sheet,
		                newSheetName: newSheetName
		            })) {
		                return;
		            }
	
		            // update references
		            this._sheets.forEach(function(sheet){
		                sheet._forFormulas(function(formula){
		                    formula.renameSheet(oldSheetName, newSheetName);
		                });
		            });
	
		            this.forEachName(function(def, name){
		                // 1. redefine sheet-local names
		                if (def.nameref.renameSheet(oldSheetName, newSheetName)) {
		                    this.undefineName(name);
		                    def.name = def.nameref.print();
		                    this.nameDefinition(def.name, def);
		                }
		                // 2. if the value is reference or formula, update it
		                if (def.value instanceof Ref || def.value instanceof Formula) {
		                    def.value.renameSheet(oldSheetName, newSheetName);
		                }
		            }.bind(this));
	
		            sheet._name(newSheetName);
	
		            this.trigger("change", { sheetSelection: true });
	
		            return sheet;
		        },
	
		        removeSheet: function(sheet) {
		            var that = this;
		            var sheets = that._sheets;
		            var name = sheet.name();
		            var index = that.sheetIndex(sheet);
	
		            if (sheets.length === 1) {
		                return;
		            }
	
		            if (this.trigger("removeSheet", { sheet: sheet })) {
		                return;
		            }
	
		            this._sheetsSearchCache = {};
	
		            if (index > -1) {
		                sheet.unbind();
	
		                sheets.splice(index, 1);
	
		                if (that.activeSheet().name() === name) {
		                    var newSheet = sheets[index === sheets.length ? index-1 : index];
		                    that.activeSheet(newSheet);
		                } else {
		                    this.trigger("change", { recalc: true,  sheetSelection: true });
		                }
		            }
		        },
	
		        _clearSheets: function() {
		            for (var i = 0; i < this._sheets.length; i++) {
		                this._sheets[i].unbind();
		            }
		            this._sheets = [];
		            this._sheetsSearchCache = {};
		            this._names = {};
		        },
	
		        fromJSON: function(json) {
		            if (json.sheets) {
		                this._clearSheets();
	
		                for (var idx = 0; idx < json.sheets.length; idx++) {
		                    var data = json.sheets[idx];
		                    var args = sheetParamsFromJSON(data, this.options);
		                    var sheet = this.insertSheet({
		                        rows         : args.rowCount,
		                        columns      : args.columnCount,
		                        rowHeight    : args.rowHeight,
		                        columnWidth  : args.columnWidth,
		                        headerHeight : args.headerHeight,
		                        headerWidth  : args.headerWidth,
		                        data         : data
		                    });
	
		                    if (data.dataSource) {
		                        sheet.setDataSource(data.dataSource);
		                    }
		                }
		            }
	
		            if (json.activeSheet) {
		                this.activeSheet(this.sheetByName(json.activeSheet));
		            } else {
		                this.activeSheet(this._sheets[0]);
		            }
	
		            if (json.names) {
		                json.names.forEach(function(def){
		                    this.defineName(def.name, def.value, def.hidden);
		                }, this);
		            }
		        },
	
		        toJSON: function() {
		            this.resetFormulas();
		            this.resetValidations();
		            var names = Object.keys(this._names).map(function(name){
		                var def = this._names[name];
		                var val = def.value;
		                if (val instanceof Ref || val instanceof Formula) {
		                    val = val.print(0, 0, true);
		                } else if (val instanceof CalcError) {
		                    val = val + "";
		                } else {
		                    val = JSON.stringify(val);
		                }
		                return {
		                    value     : val,
		                    hidden    : def.hidden,
		                    name      : def.name,
	
		                    // these two are not really useful in
		                    // deserialization, but are handy in OOXML export.
		                    sheet     : def.nameref.sheet,
		                    localName : def.nameref.name
		                };
		            }, this);
		            return {
		                activeSheet: this.activeSheet().name(),
		                sheets: this._sheets.map(function(sheet) {
		                    sheet.recalc(this._context);
		                    sheet.revalidate(this._validationContext);
		                    return sheet.toJSON();
		                }, this),
		                names: names,
		                columnWidth: this.options.columnWidth,
		                rowHeight: this.options.rowHeight
		            };
		        },
	
		        fromFile: function(file) {
		            var deferred = new $.Deferred();
		            var promise = deferred.promise();
		            var args = { file: file, promise: promise };
	
		            if (file && !this.trigger("excelImport", args)) {
		                this._clearSheets();
		                kendo.spreadsheet.readExcel(file, this, deferred);
		            } else {
		                deferred.reject();
		            }
	
		            return promise;
		        },
	
		        saveAsExcel: function(options) {
		            options = $.extend({}, this.options.excel, options);
		            var data = this.toJSON();
	
		            if (!this.trigger("excelExport", { workbook: data })) {
		                var workbook = new kendo.ooxml.Workbook(data);
	
		                kendo.saveAs({
		                    dataURI: workbook.toDataURL(),
		                    fileName: data.fileName || options.fileName,
		                    proxyURL: options.proxyURL,
		                    forceProxy: options.forceProxy
		                });
		            }
		        },
	
		        draw: function(options, callback) {
		            if (typeof options == "function" && !callback) {
		                callback = options;
		                options = {};
		            }
		            var parts = [], sheets = this._sheets;
		            (function loop(i){
		                if (i < sheets.length) {
		                    sheets[i].draw(kendo.spreadsheet.SHEETREF, options, function(group){
		                        parts.push(group);
		                        loop(i + 1);
		                    });
		                } else {
		                    var group = parts[0];
		                    for (i = 1; i < parts.length; ++i) {
		                        group.children = group.children.concat(parts[i].children);
		                    }
		                    callback(group);
		                }
		            })(0);
		        },
	
		        nameForRef: function(ref, sheet) {
		            if (sheet === undefined) {
		                sheet = ref.sheet;
		            }
		            sheet = sheet.toLowerCase();
		            var str = ref + "";
		            for (var name in this._names) {
		                var def = this._names[name];
		                var val = def.value;
		                if (val instanceof Ref) {
		                    if (!val.sheet || (val.sheet && sheet == val.sheet.toLowerCase())) {
		                        if (val + "" == str) {
		                            return def;
		                        }
		                    }
		                }
		            }
		            return { name: str };
		        },
	
		        defineName: function(name, value, hidden) {
		            var x = kendo.spreadsheet.calc.parseNameDefinition(name, value);
		            name = x.name.print();
		            this._names[name.toLowerCase()] = {
		                value   : x.value,
		                hidden  : hidden,
		                name    : name,
		                nameref : x.name
		            };
		        },
	
		        undefineName: function(name) {
		            delete this._names[name.toLowerCase()];
		        },
	
		        nameValue: function(name) {
		            name = name.toLowerCase();
		            if (name in this._names) {
		                return this._names[name].value;
		            }
		            return null;
		        },
	
		        nameDefinition: function(name, def) {
		            name = name.toLowerCase();
		            if (arguments.length > 1) {
		                if (def === undefined) {
		                    delete this._names[name];
		                } else {
		                    this._names[name] = def;
		                }
		            }
		            return this._names[name];
		        },
	
		        forEachName: function(func) {
		            Object.keys(this._names).forEach(function(name){
		                func(this._names[name], name);
		            }, this);
		        },
	
		        adjustNames: function(affectedSheet, forRow, start, delta) {
		            affectedSheet = affectedSheet.toLowerCase();
		            Object.keys(this._names).forEach(function(name){
		                var def = this._names[name];
		                var x = def.value;
		                if (x instanceof Ref &&
		                    x.sheet.toLowerCase() == affectedSheet) {
		                    def.value = x.adjust(null, null, null, null, forRow, start, delta);
		                }
		                else if (x instanceof Formula) {
		                    x.adjust(affectedSheet, forRow ? "row" : "col", start, delta);
		                }
		            }, this);
		        },
		        options: {}
		    });
	
		    function sheetParamsFromJSON(data, options) {
		        function or(a, b, c) {
		            return a !== undefined ? a : b !== undefined ? b : c;
		        }
	
		        var rowCount     = or(data.rowCount, options.rows, 200),
		            columnCount  = or(data.columnCount, options.columns, 50),
		            rowHeight    = or(data.rowHeight, options.rowHeight, 20),
		            columnWidth  = or(data.columnWidth, options.columnWidth, 64),
		            headerHeight = or(data.headerHeight, options.headerHeight, 20),
		            headerWidth  = or(data.headerWidth, options.headerWidth, 32);
	
		        if (data.rows !== undefined) {
		            for (var i = 0; i < data.rows.length; ++i) {
		                var row = data.rows[i];
		                var ri = or(row.index, i);
		                if (ri >= rowCount) { rowCount = ri + 1; }
		                if (row.cells) {
		                    for (var j = 0; j < row.cells.length; ++j) {
		                        var cell = row.cells[j];
		                        var ci = or(cell.index, j);
		                        if (ci >= columnCount) { columnCount = ci + 1; }
		                    }
		                }
		            }
		        }
	
		        return {
		            rowCount     : rowCount,
		            columnCount  : columnCount,
		            rowHeight    : rowHeight,
		            columnWidth  : columnWidth,
		            headerHeight : headerHeight,
		            headerWidth  : headerWidth
		        };
		    }
	
		    kendo.spreadsheet.Workbook = Workbook;
		    if (kendo.PDFMixin) {
		        kendo.PDFMixin.extend(Workbook.prototype);
	
		        Workbook.prototype.saveAsPDF = function(options) {
		            var progress = new $.Deferred();
		            var promise = progress.promise();
		            var args = { promise: promise };
		            if (this.trigger("pdfExport", args)) {
		                return;
		            }
	
		            this._drawPDF(options, progress)
		            .then(function(root) {
		                return kendo.drawing.exportPDF(root);
		            })
		            .done(function(dataURI) {
		                kendo.saveAs({
		                    dataURI: dataURI,
		                    fileName: options.fileName,
		                    proxyURL: options.proxyURL,
		                    forceProxy: options.forceProxy,
		                    proxyTarget: options.proxyTarget
		                });
	
		                progress.resolve();
		            })
		            .fail(function(err) {
		                progress.reject(err);
		            });
	
		            return promise;
		        };
	
		        Workbook.prototype._drawPDF = function(options) {
		            var result = new $.Deferred();
		            var callback = function(group) {
		                result.resolve(group);
		            };
		            switch(options.area) {
		            case "workbook":
		                options.workbook.draw(options, callback);
		                break;
		            case "sheet":
		                options.workbook.activeSheet().draw(options, callback);
		                break;
		            case "selection":
		                options.workbook.activeSheet().selection().draw(options, callback);
		                break;
		            }
	
		            return result.promise();
		        };
		    }
		})(kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1512:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(718);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1461);
		module.exports = __webpack_require__(1461);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1461:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    'use strict';
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
		    var alphaNumRegExp = /:alphanum$/;
	
		    var ACTIONS = {
		       "up": "up",
		       "down": "down",
		       "left": "left",
		       "right": "right",
		       "home": "first-col",
		       "ctrl+left": "first-col",
		       "end": "last-col",
		       "ctrl+right": "last-col",
		       "ctrl+up": "first-row",
		       "ctrl+down": "last-row",
		       "ctrl+home": "first",
		       "ctrl+end": "last",
		       "pageup": "prev-page",
		       "pagedown": "next-page"
		    };
	
		    var ENTRY_ACTIONS = {
		        "tab": "next",
		        "shift+tab": "previous",
		        "enter": "lower",
		        "shift+enter": "upper",
		        "delete": "clearContents",
		        "backspace": "clearContents",
		        "shift+:alphanum": "edit",
		        "alt+:alphanum": "edit",
		        ":alphanum": "edit",
		        "ctrl+:alphanum": "ctrl",
		        "alt+ctrl+:alphanum": "edit",
		        ":edit": "edit"
		    };
	
		    var CONTAINER_EVENTS = {
		        "wheel": "onWheel",
		        "*+mousedown": "onMouseDown",
		        "contextmenu": "onContextMenu",
		        "*+mousedrag": "onMouseDrag",
		        "*+mouseup": "onMouseUp",
		        "*+dblclick": "onDblClick",
		        "mousemove": "onMouseMove"
		    };
	
		    var CLIPBOARD_EVENTS = {
		        "pageup": "onPageUp",
		        "pagedown": "onPageDown",
		        "mouseup": "onMouseUp",
		        "*+cut": "onCut",
		        "*+paste": "onPaste",
		        "*+copy": "onCopy"
		    };
	
		    var EDITOR_EVENTS = {
		        "esc": "onEditorEsc",
		        "enter": "onEditorBlur",
		        "alt+enter": "insertNewline",
		        "shift+enter": "onEditorBlur",
		        "tab": "onEditorBlur",
		        "shift+tab": "onEditorBlur",
		        "shift+ctrl+enter": "onEditorArrayFormula"
		    };
	
		    var FORMULABAR_EVENTS = $.extend({ focus: "onEditorBarFocus" }, EDITOR_EVENTS);
		    var FORMULAINPUT_EVENTS = $.extend({ focus: "onEditorCellFocus" }, EDITOR_EVENTS);
	
		    var SELECTION_MODES = {
		       cell: "range",
		       rowheader: "row",
		       columnheader: "column",
		       topcorner: "sheet",
		       autofill: "autofill"
		    };
	
		    function toActionSelector(selectors) {
		        return selectors.map(function(action) {
		            return '[data-action="' + action + '"]';
		        }).join(",");
		    }
	
		    var COMPOSITE_UNAVAILABLE_ACTION_SELECTORS = toActionSelector([ 'cut', 'copy', 'paste', 'insert-left', 'insert-right', 'insert-above', 'insert-below' ]);
		    var UNHIDE_ACTION_SELECTORS = toActionSelector([ 'unhide-row', 'unhide-column' ]);
	
		    var ACTION_KEYS = [];
		    var SHIFT_ACTION_KEYS = [];
		    var ENTRY_ACTION_KEYS = [];
	
		    for (var key in ACTIONS) {
		        ACTION_KEYS.push(key);
		        SHIFT_ACTION_KEYS.push("shift+" + key);
		    }
	
		    for (key in ENTRY_ACTIONS) {
		        ENTRY_ACTION_KEYS.push(key);
		    }
	
		    CLIPBOARD_EVENTS[ACTION_KEYS] = "onAction";
		    CLIPBOARD_EVENTS[SHIFT_ACTION_KEYS] = "onShiftAction";
		    CLIPBOARD_EVENTS[ENTRY_ACTION_KEYS] = "onEntryAction";
	
		    FORMULAINPUT_EVENTS[ACTION_KEYS] = "onEditorAction";
		    FORMULAINPUT_EVENTS[SHIFT_ACTION_KEYS] = "onEditorShiftAction";
	
		    var Controller = kendo.Class.extend({
		        init: function(view, workbook) {
		            this.view = view;
		            this.workbook(workbook);
		            this.container = $(view.container);
		            this.clipboardElement = $(view.clipboard);
		            this.cellContextMenu = view.cellContextMenu;
		            this.rowHeaderContextMenu = view.rowHeaderContextMenu;
		            this.colHeaderContextMenu = view.colHeaderContextMenu;
		            this.scroller = view.scroller;
		            this.tabstrip = view.tabstrip;
		            this.sheetsbar = view.sheetsbar;
	
		            view.nameEditor.bind("enter", this.onNameEditorEnter.bind(this));
		            view.nameEditor.bind("cancel", this.onNameEditorCancel.bind(this));
		            view.nameEditor.bind("select", this.onNameEditorSelect.bind(this));
		            view.nameEditor.bind("delete", this.onNameEditorDelete.bind(this));
	
		            this.editor = view.editor;
		            this.editor.bind("change", this.onEditorChange.bind(this));
		            this.editor.bind("activate", this.onEditorActivate.bind(this));
		            this.editor.bind("deactivate", this.onEditorDeactivate.bind(this));
		            this.editor.bind("update", this.onEditorUpdate.bind(this));
	
		            $(view.scroller).on("scroll", this.onScroll.bind(this));
		            this.listener = new kendo.spreadsheet.EventListener(this.container, this, CONTAINER_EVENTS);
	
		            this._enableEditorEvents();
	
		            if (this.sheetsbar) {
		                this.sheetsbar.bind("select", this.onSheetBarSelect.bind(this));
		                this.sheetsbar.bind("reorder", this.onSheetBarReorder.bind(this));
		                this.sheetsbar.bind("rename", this.onSheetBarRename.bind(this));
		                this.sheetsbar.bind("remove", this.onSheetBarRemove.bind(this));
		            }
	
		            this.cellContextMenu.bind("select", this.onContextMenuSelect.bind(this));
		            this.rowHeaderContextMenu.bind("select", this.onContextMenuSelect.bind(this));
		            this.colHeaderContextMenu.bind("select", this.onContextMenuSelect.bind(this));
	
		            // this is necessary for Windows to catch prevent context menu correctly
		            this.cellContextMenu.element.add(this.rowHeaderContextMenu.element).add(this.colHeaderContextMenu.element).on("contextmenu", false);
	
		            if (this.tabstrip) {
		                this.tabstrip.bind("action", this.onCommandRequest.bind(this));
		                this.tabstrip.bind("dialog", this.onDialogRequest.bind(this));
		            }
		        },
	
		        _enableEditorEvents: function (enable) {
		            if (enable === undefined || enable) {
		                this.keyListener = new kendo.spreadsheet.EventListener(this.clipboardElement, this, CLIPBOARD_EVENTS);
		                this.barKeyListener = new kendo.spreadsheet.EventListener(this.editor.barElement(), this, FORMULABAR_EVENTS);
		                this.inputKeyListener = new kendo.spreadsheet.EventListener(this.editor.cellElement(), this, FORMULAINPUT_EVENTS);
		            } else {
		                this.keyListener.destroy();
		                this.barKeyListener.destroy();
		                this.inputKeyListener.destroy();
		            }
		        },
	
		        _execute: function(options) {
		            var result = this._workbook.execute(options);
	
		            if (options.command === "EditCommand" && !result) {
		                this._workbook.trigger("change", { editorClose: true });
		            }
	
		            if (result) {
		                this._preventNavigation = true;
		                if (result.reason === "error") {
		                    this.editor.deactivate(true); // make sure we don't call any change hooks
		                    this.view.showError(result, function(){
		                        // we only get here in case of a validation error when the user decided to retry.
		                        this.activateEditor(false);
		                        // reset to last input from user
		                        this.editor.value(this._lastEditorValue);
		                        // however, set _value manually such that it'll detect change properly.  ugly :-\
		                        this.editor._value = this._workbook._inputForRef(this._workbook.activeSheet()._viewActiveCell());
		                        // seems like a nice UX to have the whole input selected
		                        this.editor.select();
		                    }.bind(this));
		                } else {
		                    this.view.openDialog(result.reason);
		                }
		            }
	
		            return result;
		        },
	
		        _activeTooltip: function() {
		            return this._workbook.activeSheet().activeCell().simplify().toString();
		        },
	
		        onContextMenuSelect: function(e) {
		                var action = $(e.item).data("action");
		                var command;
		                switch(action) {
		                    case "cut":
		                        command = { command: "ToolbarCutCommand", options: { workbook: this._workbook } };
		                        break;
		                    case "copy":
		                        command = { command: "ToolbarCopyCommand", options: { workbook: this._workbook } };
		                        break;
		                    case "paste":
		                        command = { command: "ToolbarPasteCommand", options: { workbook: this._workbook } };
		                        break;
		                    case "unmerge":
		                        command = { command: "MergeCellCommand", options: { value: "unmerge" } };
		                        break;
		                    case "merge":
		                        this.view.openDialog("merge");
		                        break;
		                    case "hide-row":
		                        command = { command: "HideLineCommand", options: { axis: "row" } };
		                        break;
		                    case "hide-column":
		                        command = { command: "HideLineCommand", options: { axis: "column" } };
		                        break;
		                    case "unhide-row":
		                        command = { command: "UnHideLineCommand", options: { axis: "row" } };
		                        break;
		                    case "unhide-column":
		                        command = { command: "UnHideLineCommand", options: { axis: "column" } };
		                        break;
		                    case "delete-row":
		                        command = { command: "DeleteRowCommand" };
		                        break;
		                    case "delete-column":
		                        command = { command: "DeleteColumnCommand" };
		                        break;
		                }
	
		                if (command) {
		                    this._execute(command);
		                }
		        },
	
		        onSheetBarRemove: function(e) {
		            var sheet = this._workbook.sheetByName(e.name);
	
		            //TODO: move to model!
		            if (!sheet) {
		                return;
		            }
	
		            this._workbook.removeSheet(sheet);
		        },
	
		        destroy: function() {
		            this.listener.destroy();
		            this._enableEditorEvents(false);
		            this.keyListener.destroy();
		            this.inputKeyListener.destroy();
		        },
	
		        onSheetBarSelect: function(e) {
		            var sheet;
		            var workbook = this._workbook;
	
		            if (e.isAddButton) {
		                if (this._workbook.trigger("insertSheet")) {
		                    return;
		                }
	
		                sheet = workbook.insertSheet();
		            } else {
		                sheet = workbook.sheetByName(e.name);
		            }
	
		            //TODO: move to model
		            if (workbook.activeSheet().name() !== sheet.name()) {
		                if (this._workbook.trigger("selectSheet", { sheet: sheet })) {
		                    return;
		                }
	
		                if (!this.editor.canInsertRef(false)) {
		                    this.editor.deactivate();
		                }
	
		                workbook.activeSheet(sheet);
		            }
		        },
	
		        onSheetBarReorder: function(e) {
		            var sheet = this._workbook.sheetByIndex(e.oldIndex);
	
		            this._workbook.moveSheetToIndex(sheet, e.newIndex);
	
		            this._workbook.activeSheet(sheet);
		        },
	
		        onSheetBarRename: function(e) {
		            var sheet = this._workbook.sheetByIndex(e.sheetIndex);
	
		            if (this._workbook.sheetByName(e.name)) {
		                this.view.showError({ reason: "error", type: "duplicateSheetName" });
		                return;
		            }
	
		            this._workbook.renameSheet(sheet, e.name);
	
		            this.clipboardElement.focus();
		        },
	
		        sheet: function(sheet) {
		            this.navigator = sheet.navigator();
		            this.axisManager = sheet.axisManager();
		        },
	
		        workbook: function(workbook) {
		            this._workbook = workbook;
		            this.clipboard = workbook.clipboard();
		            workbook.bind("commandRequest", this.onCommandRequest.bind(this));
		        },
	
		        refresh: function() {
		            var editor = this.editor;
		            var workbook = this._workbook;
		            var sheet = workbook.activeSheet();
	
		            this._viewPortHeight = this.view.scroller.clientHeight;
		            this.navigator.height(this._viewPortHeight);
	
		            if (!editor.isActive() && !this.isEditorDisabled) {
		                editor.enable(sheet.selection().enable() !== false);
		                this.resetEditorValue();
		            }
	
		            var ref = sheet.selection()._ref.simplify();
		            var def = this._workbook.nameForRef(ref, sheet.name());
		            this.view.nameEditor.value(def.name);
		        },
	
		        onScroll: function() {
		            this.view.render();
		        },
	
		        onWheel: function(event) {
		            var deltaX = event.originalEvent.deltaX;
		            var deltaY = event.originalEvent.deltaY;
	
		            if (event.originalEvent.deltaMode === 1) {
		                deltaX *= 10;
		                deltaY *= 10;
		            }
	
		            this.scrollWith(deltaX, deltaY);
	
		            event.preventDefault();
		        },
	
		        onAction: function(event, action) {
		            this.navigator.moveActiveCell(ACTIONS[action]);
		            event.preventDefault();
		        },
	
		        onPageUp: function() {
		            this.scrollDown(-this._viewPortHeight);
		        },
	
		        onPageDown: function() {
		            this.scrollDown(this._viewPortHeight);
		        },
	
		        onEntryAction: function(event, action) {
		            if (event.mod) {
		                var shouldPrevent = true;
		                var key = String.fromCharCode(event.keyCode);
	
		                switch(key) {
		                    case "A":
		                        this.navigator.selectAll();
		                        break;
		                    case "Y":
		                        this._workbook.undoRedoStack.redo();
		                        break;
		                    case "Z":
		                        this._workbook.undoRedoStack.undo();
		                        break;
		                    default:
		                        shouldPrevent = false;
		                        break;
		                }
		                if (shouldPrevent) {
		                    event.preventDefault();
		                }
		            } else {
		                var disabled = this._workbook.activeSheet().selection().enable() === false;
		                var casual = action !== ":edit";
	
		                if (action == "delete" || action == "backspace") {
		                    if (!disabled) {
		                        this._execute({ command: "ClearContentCommand" });
		                    }
		                    event.preventDefault();
		                } else if (alphaNumRegExp.test(action) || !casual) {
		                    if (disabled) {
		                        event.preventDefault();
		                        return;
		                    }
		                    if (casual) {
		                        this.editor.value("");
		                    }
		                    this.activateEditor(casual);
		                } else {
		                    this.navigator.navigateInSelection(ENTRY_ACTIONS[action]);
		                    event.preventDefault();
		                }
		            }
		        },
	
		        onShiftAction: function(event, action) {
		            this.navigator.modifySelection(ACTIONS[action.replace("shift+", "")], this.appendSelection);
		            event.preventDefault();
		        },
	
		        onMouseMove: function(event) {
		            var sheet = this._workbook.activeSheet();
	
		            if (sheet.resizingInProgress() || sheet.selectionInProgress()) {
		                return;
		            }
	
		            var object = this.objectAt(event);
		            if (object.type === "columnresizehandle" || object.type === "rowresizehandle") {
		                sheet.positionResizeHandle(object.ref);
		            } else {
		                sheet.removeResizeHandle();
		            }
		        },
	
		        onMouseDown: function(event) {
		            var object = this.objectAt(event);
	
		            if (object.pane) {
		                this.originFrame = object.pane;
		            }
	
		            if (object.type === "editor") {
		                // XXX: canceling the edits, because they might not
		                // validate.  Not sure it's the Right Thing.
		                this.onEditorEsc();
		                this.openCustomEditor();
		                event.preventDefault();
		                return;
		            }
	
		            if (this.editor.canInsertRef(false) && object.ref) {
		                this._workbook.activeSheet()._setFormulaSelections(this.editor.highlightedRefs());
		                this.navigator.startSelection(object.ref, this._selectionMode, this.appendSelection, event.shiftKey);
		                event.preventDefault();
		                return;
		            } else {
		                this._preventNavigation = false;
		                this.editor.deactivate();
		                if (this._preventNavigation) {
		                    return;     // validation error
		                }
		            }
	
		            var sheet = this._workbook.activeSheet();
		            if (object.type === "columnresizehandle" || object.type === "rowresizehandle") {
		                sheet.startResizing({ x: object.x, y: object.y });
		                event.preventDefault();
		                return;
		            }
	
		            if (object.type === "filtericon") {
		                this.openFilterMenu(event);
		                event.preventDefault();
		                return;
		            }
	
		            this._selectionMode = SELECTION_MODES[object.type];
		            this.appendSelection = event.mod;
		            this.navigator.startSelection(object.ref, this._selectionMode, this.appendSelection, event.shiftKey);
		        },
	
		        onContextMenu: function(event) {
		            var sheet = this._workbook.activeSheet();
	
		            if (sheet.resizingInProgress()) {
		                return;
		            }
	
		            event.preventDefault();
	
		            this.cellContextMenu.close();
		            this.colHeaderContextMenu.close();
		            this.rowHeaderContextMenu.close();
	
		            var menu;
	
		            var object = this.objectAt(event);
	
		            if (object.type === "columnresizehandle" || object.type === "rowresizehandle") {
		                return;
		            }
	
		            this.navigator.selectForContextMenu(object.ref, SELECTION_MODES[object.type]);
	
		            var isComposite = this.navigator._sheet.select() instanceof kendo.spreadsheet.UnionRef;
		            var showUnhide = false;
		            var showUnmerge = false;
	
		            if (object.type == "columnheader") {
		                menu = this.colHeaderContextMenu;
		                showUnhide = !isComposite && this.axisManager.selectionIncludesHiddenColumns();
		            } else if (object.type == "rowheader") {
		                menu = this.rowHeaderContextMenu;
		                showUnhide = !isComposite && this.axisManager.selectionIncludesHiddenRows();
		            } else {
		                menu = this.cellContextMenu;
		                showUnmerge = this.navigator.selectionIncludesMergedCells();
		            }
	
		            menu.element.find(COMPOSITE_UNAVAILABLE_ACTION_SELECTORS).toggle(!isComposite);
		            menu.element.find(UNHIDE_ACTION_SELECTORS).toggle(showUnhide);
		            menu.element.find('[data-action=unmerge]').toggle(showUnmerge);
	
		            // avoid the immediate close
		            setTimeout(function() {
		                menu.open(event.pageX, event.pageY);
		            });
		        },
	
		        prevent: function(event) {
		            event.preventDefault();
		        },
	
		        constrainResize: function(type, ref) {
		            var sheet = this._workbook.activeSheet();
		            var resizeHandle = sheet.resizeHandlePosition();
	
		            return !resizeHandle || type === "outside" || type === "topcorner" || ref.col < resizeHandle.col || ref.row < resizeHandle.row;
		        },
	
		        onMouseDrag: function(event) {
		            if (this._selectionMode === "sheet") {
		                return;
		            }
	
		            var location = { clientX: event.clientX, clientY: event.clientY };
		            var object = this.objectAt(location);
	
		            var sheet = this._workbook.activeSheet();
		            if (sheet.resizingInProgress()) {
	
		                if (!this.constrainResize(object.type, object.ref)) {
		                    sheet.resizeHintPosition({ x: object.x, y: object.y });
		                }
	
		                return;
		            }
	
		            if (object.type === "outside") {
		                this.startAutoScroll(object);
		                return;
		            }
	
		            if (this.originFrame === object.pane) {
		                this.selectToLocation(location);
		            } else { // cross frame selection
		                var frame = this.originFrame._grid;
	
		                if (object.x > frame.right) {
		                    this.scrollLeft();
		                }
	
		                if (object.y > frame.bottom) {
		                    this.scrollTop();
		                }
	
		                if (object.y < frame.top || object.x < frame.left) {
		                    this.startAutoScroll(object, location);
		                } else {
		                    this.selectToLocation(location);
		                }
		            }
	
		            event.preventDefault();
		        },
	
		        onMouseUp: function(event) {
		            var sheet = this._workbook.activeSheet();
		            sheet.completeResizing();
	
		            this.navigator.completeSelection();
		            this.stopAutoScroll();
	
		            var editor = this.editor.activeEditor();
		            if (!editor) {
		                return;
		            }
		            var el = event.target;
		            while (el) {
		                if (el === editor.element[0]) {
		                    return;
		                }
		                el = el.parentNode;
		            }
	
		            var object = this.objectAt(event);
		            if (object && object.ref && editor.canInsertRef(false)) {
		                editor.refAtPoint(sheet);
		                sheet._setFormulaSelections(editor.highlightedRefs());
		            }
		        },
	
		        onDblClick: function(event) {
		            var object = this.objectAt(event);
		            var disabled = this._workbook.activeSheet().selection().enable() === false;
	
		            if (object.type !== "cell" || disabled) {
		                return;
		            }
	
		            var sel = this._workbook.activeSheet().selection();
		            this.activateEditor(!sel.value() && !sel.formula());
		            this.onEditorUpdate();
		        },
	
		        onCut: function(e) {
		            if(e){
		                var table = this.clipboardElement.find("table.kendo-clipboard-"+ this.clipboard._uid).detach();
		                this.clipboardElement.append(table.clone(false));
		                setTimeout(function() {
		                    this.clipboardElement.empty().append(table);
		                }.bind(this));
		            }
	
		            this._execute({
		                command: "CutCommand",
		                options: { workbook: this.view._workbook, event: e.originalEvent || e }
		            });
		        },
	
		        clipBoardValue: function() {
		            return this.clipboardElement.html();
		        },
	
		        onPaste: function(e) {
		            var html = "";
		            var plain = "";
		            this.clipboard.menuInvoked = (e === undefined);
		            if(e) {
		                if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) {
		                    e.preventDefault();
		                    var hasHTML = false;
		                    var hasPlainText = false;
		                    //Firefox uses DOMStringList, needs special handling
		                    if(window.DOMStringList && e.originalEvent.clipboardData.types instanceof window.DOMStringList) {
		                        hasHTML = e.originalEvent.clipboardData.types.contains("text/html");
		                        hasPlainText = e.originalEvent.clipboardData.types.contains("text/plain");
		                    } else {
		                        hasHTML = (/text\/html/.test(e.originalEvent.clipboardData.types));
		                        hasPlainText = (/text\/plain/.test(e.originalEvent.clipboardData.types));
		                    }
		                    if (hasHTML) {
		                        html = e.originalEvent.clipboardData.getData('text/html');
		                    }
		                    if (hasPlainText) {
		                        plain = e.originalEvent.clipboardData.getData('text/plain').trim();
		                    }
		                } else {
		                    //workaround for IE's lack of access to the HTML clipboard data
		                    var table = this.clipboardElement.find("table.kendo-clipboard-"+ this.clipboard._uid).detach();
		                    this.clipboardElement.empty();
		                    setTimeout(function() {
		                        var html = this.clipboardElement.html();
		                        var plain = window.clipboardData.getData("Text").trim();
		                        if(!html && !plain) {
		                            return;
		                        }
		                        this.clipboard.external({html: html, plain: plain});
		                        this.clipboardElement.empty().append(table);
		                        this._execute({
		                            command: "PasteCommand",
		                            options: { workbook: this.view._workbook, event: e.originalEvent || e }
		                        });
		                        this.clipboard.menuInvoked = true;
		                    }.bind(this));
		                    return;
		                }
		            } else {
		                if(kendo.support.browser.msie) {
		                    this.clipboardElement.focus().select();
		                    document.execCommand('paste');
		                    return;
		                } else {
		                    this.clipboard.menuInvoked = true;
		                }
		            }
	
		            if(!html && !plain) {
		                return;
		            }
		            this.clipboard.external({html: html, plain:plain});
		            this._execute({
		                command: "PasteCommand",
		                options: { workbook: this.view._workbook, event: e.originalEvent || e }
		            });
	
		        },
	
		        onCopy: function(e) {
		            this.clipboard.menuInvoked = (e === undefined);
		            this._execute({
		                command: "CopyCommand",
		                options: { workbook: this.view._workbook, event: e.originalEvent || e }
		            });
		        },
	
		////////////////////////////////////////////////////////////////////
	
		        scrollTop: function() {
		            this.scroller.scrollTop = 0;
		        },
	
		        scrollLeft: function() {
		            this.scroller.scrollLeft = 0;
		        },
	
		        scrollDown: function(value) {
		            this.scroller.scrollTop += value;
		        },
	
		        scrollRight: function(value) {
		            this.scroller.scrollLeft += value;
		        },
	
		        scrollWith: function(right, down) {
		            this.scroller.scrollTop += down;
		            this.scroller.scrollLeft += right;
		        },
	
		        objectAt: function(location) {
		            if (!location) {
		                return;
		            }
		            var box = this.container[0].getBoundingClientRect();
		            return this.view.objectAt(location.clientX - box.left,
		                                      location.clientY - box.top);
		        },
	
		        selectToLocation: function(cellLocation) {
		            var object = this.objectAt(cellLocation);
	
		            if (object.pane) { // cell, rowheader or columnheader
		                this.extendSelection(object);
		                this.lastKnownCellLocation = cellLocation;
		                this.originFrame = object.pane;
		            }
	
		            this.stopAutoScroll();
		        },
	
		        extendSelection: function(object) {
		            this.navigator.extendSelection(object.ref, this._selectionMode, this.appendSelection);
		        },
	
		        autoScroll: function() {
		            var x = this._autoScrollTarget.x;
		            var y = this._autoScrollTarget.y;
		            var boundaries = this.originFrame._grid;
		            var scroller = this.view.scroller;
		            var scrollStep = 8;
	
		            var scrollLeft = scroller.scrollLeft;
		            var scrollTop = scroller.scrollTop;
	
		            if (x < boundaries.left) {
		                this.scrollRight(-scrollStep);
		            }
		            if (x > boundaries.right) {
		                this.scrollRight(scrollStep);
		            }
		            if (y < boundaries.top) {
		                this.scrollDown(-scrollStep);
		            }
		            if (y > boundaries.bottom) {
		                this.scrollDown(scrollStep);
		            }
	
		            if (scrollTop === scroller.scrollTop && scrollLeft === scroller.scrollLeft) {
		                this.selectToLocation(this.finalLocation);
		            } else {
		                this.extendSelection(this.objectAt(this.lastKnownCellLocation));
		            }
		        },
	
		        startAutoScroll: function(viewObject, location) {
		            if (!this._scrollInterval) {
		                this._scrollInterval = setInterval(this.autoScroll.bind(this), 50);
		            }
	
		            this.finalLocation = location || this.lastKnownCellLocation;
	
		            this._autoScrollTarget = viewObject;
		        },
	
		        stopAutoScroll: function() {
		            clearInterval(this._scrollInterval);
		            this._scrollInterval = null;
		        },
	
		        openCustomEditor: function() {
		            this.view.openCustomEditor();
		        },
	
		        openFilterMenu: function(event) {
		            var object = this.objectAt(event);
		            var sheet = this._workbook.activeSheet();
		            var column = sheet.filterColumn(object.ref);
		            var filterMenu = this.view.createFilterMenu(column);
	
		            filterMenu.bind("action", this.onCommandRequest.bind(this));
		            filterMenu.bind("action", filterMenu.close.bind(filterMenu));
	
		            filterMenu.openFor(event.target);
		        },
	
		////////////////////////////////////////////////////////////////////
	
		        _saveEditorValue: function(arrayFormula) {
		            var sheet = this.editor._range.sheet();
		            var value = this.editor.value();
		            if (this._workbook.activeSheet() !== sheet) {
		                // remove highlighted refs (XXX: which are mostly wrong, BTW)
		                this._workbook.activeSheet()._setFormulaSelections();
		                // go back to the original sheet
		                this._workbook.activeSheet(sheet);
		            }
		            sheet.isInEditMode(false);
		            this._lastEditorValue = value;
		            this._execute({
		                command: "EditCommand",
		                options: {
		                    value: value,
		                    arrayFormula: arrayFormula
		                }
		            });
		        },
	
		        onEditorChange: function() {
		            this._saveEditorValue(false);
		        },
	
		        onEditorArrayFormula: function() {
		            this._saveEditorValue(true);
		            this.editor.deactivate(true);
		        },
	
		        onEditorActivate: function() {
		            var workbook = this._workbook;
		            var sheet = workbook.activeSheet();
	
		            sheet._setFormulaSelections(this.editor.highlightedRefs());
		            sheet.isInEditMode(true);
		        },
	
		        onEditorDeactivate: function() {
		            var sheet = this._workbook.activeSheet();
	
		            sheet.isInEditMode(false);
		            sheet._setFormulaSelections([]);
		        },
	
		        onEditorUpdate: function() {
		            this._workbook.activeSheet()._setFormulaSelections(this.editor.highlightedRefs());
		        },
	
		        onEditorBarFocus: function() {
		            var disabled = this._workbook.activeSheet().selection().enable() === false;
		            if (disabled) {
		                return;
		            }
		            this.editor
		                .activate({
		                    range: this._workbook.activeSheet().selection(),
		                    rect: this.view.activeCellRectangle(),
		                    tooltip: this._activeTooltip()
		                });
		        },
	
		        onEditorCellFocus: function() {
		            this.editor.scale();
		        },
	
		        onEditorEsc: function() {
		            this.resetEditorValue();
		            this.editor.deactivate();
	
		            this.clipboardElement.focus();
		        },
	
		        insertNewline: function(e) {
		            e.preventDefault();
		            this.editor.insertNewline();
		        },
	
		        onEditorBlur: function(_, action) {
		            if (this.editor.isFiltered()) {
		                return;
		            }
	
		            this._preventNavigation = false;
		            this.editor.deactivate();
	
		            if (!this._preventNavigation) {
		                this.clipboardElement.focus();
		                this.navigator.navigateInSelection(ENTRY_ACTIONS[action]);
		            }
		        },
	
		        onEditorAction: function(event, action) {
		            var editor = this.editor;
		            var sheet = this._workbook.activeSheet();
	
		            if (this._casualEditing && /^(?:up|right|down|left)$/.test(action)) {
		                this.deactivateEditor();
		                this.navigator.moveActiveCell(ACTIONS[action]);
		                event.preventDefault();
		            }
		            else if (editor.canInsertRef(true)) {
		                this.navigator.moveActiveCell(ACTIONS[action]);
		                editor.activeEditor().refAtPoint(sheet);
		                sheet._setFormulaSelections(editor.highlightedRefs());
		                event.preventDefault();
		            }
		        },
	
		        onEditorShiftAction: function(event, action) {
		            var editor = this.editor;
		            var sheet = this._workbook.activeSheet();
	
		            if (editor.canInsertRef(true)) {
		                this.navigator.modifySelection(ACTIONS[action.replace("shift+", "")], this.appendSelection);
	
		                editor.activeEditor().refAtPoint(sheet);
		                sheet._setFormulaSelections(editor.highlightedRefs());
	
		                event.preventDefault();
		            }
		        },
	
		////////////////////////////////////////////////////////////////////
		        resetEditorValue: function() {
		            var sheet = this._workbook.activeSheet();
		            var ref = sheet.activeCell();
		            var input = this._workbook._inputForRef(ref);
		            var x = sheet.range(ref).intersectingArrayFormula();
		            if (x) {
		                input = "=" + x.formula;
		            }
		            this.editor.value(input, !!x);
		        },
	
		        activateEditor: function(casual) {
		            // This flag will be false when F2 has been pressed, and
		            // true when editing is "casual", i.e., user just started
		            // typing.  In this case we want arrow keys to do cell
		            // navigation rather than move the cursor.
		            // https://github.com/telerik/kendo-ui-core/issues/3644
		            this._casualEditing = casual;
	
		            this.editor.activate({
		                range: this._workbook.activeSheet().selection(),
		                rect: this.view.activeCellRectangle(),
		                tooltip: this._activeTooltip()
		            }).focus();
		        },
	
		        deactivateEditor: function() {
		            this.view.editor.deactivate();
		        },
	
		        onCommandRequest: function(e) {
		            if (e.command) {
		                this._execute(e);
		            } else {
		                this._workbook.undoRedoStack[e.action]();
		            }
		        },
	
		        onDialogRequest: function(e) {
		            var additionalOptions = {
		                pdfExport: this._workbook.options.pdf,
		                excelExport: this._workbook.options.excel
		            };
	
		            if (e.options) {
		                $.extend(true, e.options, additionalOptions);
		            } else {
		                e.options = additionalOptions;
		            }
	
		            this.view.openDialog(e.name, e.options);
		        },
	
		        onNameEditorEnter: function() {
		            var ref;
		            var workbook = this._workbook;
		            var sheet = workbook.activeSheet();
		            var name = this.view.nameEditor.value();
	
		            // 1. does it look like a reference, or already defined
		            // name?  If so, just select it (don't define/modify any
		            // names)
		            ref = kendo.spreadsheet.calc.parseReference(name, true) || workbook.nameValue(name);
		            if (ref instanceof kendo.spreadsheet.Ref) {
		                if (ref.sheet && ref.sheet.toLowerCase() != sheet.name().toLowerCase()) {
		                    // reference points to another sheet, select it if found
		                    var tmp = workbook.sheetByName(ref.sheet);
		                    if (tmp) {
		                        workbook.activeSheet(tmp);
		                        sheet = tmp;
		                    }
		                }
		                sheet.range(ref).select();
		                return;
		            }
	
		            ref = sheet.selection()._ref.clone().simplify().setSheet(sheet.name(), true);
	
		            // XXX: should we check if a name is already defined for this range, and update it instead?
		            // Excel just adds a new one, and provides a more complete Name Manager dialog.
		            //var def = workbook.nameForRef(ref, sheet.name());
	
		            // just define new name
		            this._execute({
		                command: "DefineNameCommand",
		                options: { name: name, value: ref }
		            });
	
		            this.clipboardElement.focus();
		        },
		        onNameEditorCancel: function() {
		            this.clipboardElement.focus();
		        },
		        onNameEditorSelect: function(ev) {
		            var name = ev.name;
		            var workbook = this._workbook;
		            var sheet = workbook.activeSheet();
		            var ref = workbook.nameValue(name);
		            if (ref instanceof kendo.spreadsheet.Ref) {
		                if (ref.sheet && ref.sheet.toLowerCase() != sheet.name().toLowerCase()) {
		                    // reference points to another sheet, select it if found
		                    var tmp = workbook.sheetByName(ref.sheet);
		                    if (tmp) {
		                        workbook.activeSheet(tmp);
		                        sheet = tmp;
		                    }
		                }
		                sheet.range(ref).select();
		                return;
		            }
		            this.clipboardElement.focus();
		        },
		        onNameEditorDelete: function(ev) {
		            this._execute({
		                command: "DeleteNameCommand",
		                options: { name: ev.name }
		            });
		            this.clipboardElement.focus();
		        }
		    });
	
		    kendo.spreadsheet.Controller = Controller;
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1508);
		module.exports = __webpack_require__(1508);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1487:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(701);
	
	/***/ }),
	
	/***/ 1508:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(1509), __webpack_require__(1510), __webpack_require__(1487) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
		    var CellRef = kendo.spreadsheet.CellRef;
		    var DOT = ".";
		    var RESIZE_HANDLE_WIDTH = 7;
		    var viewClassNames = {
		        view: "k-spreadsheet-view",
		        fixedContainer: "k-spreadsheet-fixed-container",
		        editContainer: "k-spreadsheet-edit-container",
		        scroller: "k-spreadsheet-scroller",
		        viewSize: "k-spreadsheet-view-size",
		        clipboard: "k-spreadsheet-clipboard",
		        cellEditor: "k-spreadsheet-cell-editor",
		        barEditor: "k-spreadsheet-editor",
		        topCorner: "k-spreadsheet-top-corner",
		        filterHeadersWrapper: "k-filter-wrapper",
		        filterRange: "k-filter-range",
		        filterButton: "k-spreadsheet-filter",
		        filterButtonActive: "k-state-active",
		        horizontalResize: "k-horizontal-resize",
		        verticalResize: "k-vertical-resize",
		        icon: "k-icon",
		        iconFilterDefault: "k-i-arrow-60-down",
		        sheetsBar: "k-spreadsheet-sheets-bar",
		        sheetsBarActive: "k-spreadsheet-sheets-bar-active",
		        sheetsBarInactive: "k-spreadsheet-sheets-bar-inactive",
		        cellContextMenu: "k-spreadsheet-cell-context-menu",
		        rowHeaderContextMenu: "k-spreadsheet-row-header-context-menu",
		        colHeaderContextMenu: "k-spreadsheet-col-header-context-menu"
		    };
	
		    kendo.spreadsheet.messages.view = {
		        nameBox: "Name Box",
		        errors: {
		            openUnsupported: "Unsupported format. Please select an .xlsx file.",
		            shiftingNonblankCells: "Cannot insert cells due to data loss possibility. Select another insert location or delete the data from the end of your worksheet.",
		            insertColumnWhenRowIsSelected: "Cannot insert column when all columns are selected.",
		            insertRowWhenColumnIsSelected: "Cannot insert row when all rows are selected.",
		            filterRangeContainingMerges: "Cannot create a filter within a range containing merges",
		            sortRangeContainingMerges: "Cannot sort a range containing merges",
		            cantSortMultipleSelection: "Cannot sort multiple selection",
		            cantSortNullRef: "Cannot sort empty selection",
		            cantSortMixedCells: "Cannot sort range containing cells of mixed shapes",
		            validationError: "The value that you entered violates the validation rules set on the cell.",
		            cannotModifyDisabled: "Cannot modify disabled cells."
		        },
		        tabs: {
		            home: "Home",
		            insert: "Insert",
		            data: "Data"
		        }
		    };
	
		    function selectElementContents(el) {
		        var sel = window.getSelection();
		        sel.removeAllRanges();
	
		        var range = document.createRange();
		        range.selectNodeContents(el);
	
		        sel.addRange(range);
		    }
	
		    function cellBefore(table, row) {
		        var cells = table.trs[row].children;
		        return cells[cells.length - 2];
		    }
	
		    function cellAbove(table, row) {
		        var prevRow = table.trs[row-1];
		        var index = table.trs[row].children.length-1;
	
		        if (prevRow && index >= 0) {
		            return prevRow.children[index];
		        }
		    }
	
		    function cellBorder(value) {
		        return (value.size || 1) + "px solid " + (value.color || "#000");
		    }
	
		    function asURL(link) {
		        if (!/:\/\//.test(link)) {
		            link = "http://" + link;
		        }
		        return link;
		    }
	
		    function drawCell(collection, cell, cls, showGrid) {
		        function maybeLink(el) {
		            var link = cell.link;
		            if (!link) {
		                if (typeof cell.value == "object") {
		                    link = cell.value.link;
		                }
		            }
		            if (link) {
		                var style = {
		                    textDecoration: "none"
		                };
		                if (cell.color) {
		                    style.color = cell.color;
		                }
		                if (cell.underline) {
		                    style.textDecoration = "underline";
		                }
		                return kendo.dom.element("a", {
		                    href   : asURL(link),
		                    style  : style,
		                    target : "_blank" // XXX: customizable?
		                }, el ? [ el ] : []);
		            }
		            return el;
		        }
	
		        var shouldDraw = (cell.value != null || (cell.validation != null && !cell.validation.value) || // jshint ignore:line
		                          cell.background || cell.merged);
		        if (!cls && !shouldDraw) {
		            return;
		        }
	
		        var style = {};
		        var background = cell.background;
		        if (background) {
		            var defaultBorder = background;
		            if (showGrid) {
		                // darken
		                defaultBorder = kendo.parseColor(defaultBorder).toHSV();
		                defaultBorder.v *= 0.9;
		                defaultBorder = defaultBorder.toCssRgba();
		            }
		            defaultBorder = cellBorder({ color: defaultBorder });
		            style.outline = defaultBorder;
		        }
	
		        if (background) {
		            style.backgroundColor = background;
		        }
	
		        if (cell.color) {
		            style.color = cell.color;
		        }
	
		        if (cell.fontFamily) {
		            style.fontFamily = cell.fontFamily;
		        }
	
		        if (cell.underline) {
		            style.textDecoration = "underline";
		        }
	
		        if (cell.italic) {
		            style.fontStyle = "italic";
		        }
	
		        if (cell.textAlign) {
		            style.textAlign = cell.textAlign;
		        }
	
		        if (cell.bold) {
		            style.fontWeight = "bold";
		        }
	
		        if (cell.fontSize) {
		            style.fontSize = cell.fontSize + "px";
		        }
	
		        if (cell.wrap === true) {
		            style.whiteSpace = "pre-wrap";
		            style.overflowWrap = "break-word";
		            style.wordWrap = "break-word";
		        } else {
		            style.whiteSpace = "pre";
		            style.overflowWrap = "normal";
		            style.wordWrap = "normal";
		        }
	
		        style.left = (cell.left + 1) + "px";
		        style.top = (cell.top + 1) + "px";
		        style.width = (cell.width - 1) + "px";
		        style.height = (cell.height - 1) + "px";
	
		        var data = cell.value, type = typeof data;
		        if (cell.format && data != null) { // jshint ignore:line
		            data = kendo.spreadsheet.formatting.format(data, cell.format);
		            if (data.__dataType) {
		                type = data.__dataType;
		            }
		        } else if (data !== null && data !== undefined) {
		            data = kendo.dom.text(data);
		        }
	
		        if (!style.textAlign) {
		            switch (type) {
		              case "number":
		              case "date":
		              case "percent":
		              case "currency":
		                style.textAlign = "right";
		                break;
		              case "boolean":
		                style.textAlign = "center";
		                break;
		            }
		        }
	
		        var classNames = [ paneClassNames.cell ];
	
		        if (cls) {
		            classNames.push(cls);
		        }
		        if (cell.enable === false) {
		            classNames.push("k-state-disabled");
		        }
		        if (cell.merged) {
		            classNames.push("k-spreadsheet-merged-cell");
		        }
	
		        var verticalAlign = cell.verticalAlign || "bottom";
	
		        if (verticalAlign && data) {
		            data = kendo.dom.element("div", { className: "k-vertical-align-" + verticalAlign }, [ maybeLink(data) ]);
		        } else {
		            data = maybeLink(data);
		        }
	
		        var children = data ? [ data ] : [];
		        var properties = {
		            style: style
		        };
		        var validation = cell.validation;
		        if (validation && !validation.value) {
		            children.push(kendo.dom.element("span", { className: "k-dirty" }));
		            classNames.push("k-dirty-cell");
	
		            properties.title = validation.message;
		        }
		        properties.className = classNames.join(" ");
	
		        var div = kendo.dom.element("div", properties, children);
		        collection.push(div);
		        return div;
		    }
	
		    function addCell(table, row, cell) {
		        var style = {};
	
		        if (cell.background) {
		            style.backgroundColor = cell.background;
		        }
	
		        if (cell.color) {
		            style.color = cell.color;
		        }
	
		        if (cell.fontFamily) {
		            style.fontFamily = cell.fontFamily;
		        }
	
		        if (cell.underline) {
		            style.textDecoration = "underline";
		        }
	
		        if (cell.italic) {
		            style.fontStyle = "italic";
		        }
	
		        if (cell.textAlign) {
		            style.textAlign = cell.textAlign;
		        }
	
		        if (cell.verticalAlign) {
		            style.verticalAlign = (cell.verticalAlign === "center") ? "middle" : cell.verticalAlign;
		        }
	
		        if (cell.bold) {
		            style.fontWeight = "bold";
		        }
	
		        if (cell.fontSize) {
		            style.fontSize = cell.fontSize + "px";
		        }
	
		        if (cell.wrap === true) {
		            style.whiteSpace = "pre-wrap";
		        }
	
		        if (cell.borderRight) {
		            style.borderRight = cellBorder(cell.borderRight);
		        } else if (cell.background) {
		            style.borderRightColor = cell.background;
		        }
	
		        if (cell.borderBottom) {
		            style.borderBottom = cellBorder(cell.borderBottom);
		        } else if (cell.background) {
		            style.borderBottomColor = cell.background;
		        }
	
		        var data = cell.value, type = typeof data;
		        if (cell.format && data != null) { // jshint ignore:line
		            data = kendo.spreadsheet.formatting.format(data, cell.format);
		            if (data.__dataType) {
		                type = data.__dataType;
		            }
		        }
	
		        if (!style.textAlign) {
		            switch (type) {
		              case "number":
		              case "date":
		              case "percent":
		              case "currency":
		                style.textAlign = "right";
		                break;
		              case "boolean":
		                style.textAlign = "center";
		                break;
		            }
		        }
	
		        var className = null;
	
		        if (cell.enable === false) {
		            className = "k-state-disabled";
		        }
	
		        var td = table.addCell(row, data, style, className, cell.validation);
	
		        var border, sibling;
	
		        if (cell.borderLeft) {
		            sibling = cellBefore(table, row);
		            border = cellBorder(cell.borderLeft);
		            if (sibling && border) {
		                sibling.attr.style.borderRight = border;
		            }
		        } else if (cell.background) {
		            style.borderLeftColor = cell.background;
		        }
	
		        if (cell.borderTop) {
		            sibling = cellAbove(table, row);
		            border = cellBorder(cell.borderTop);
		            if (sibling && border) {
		                sibling.attr.style.borderBottom = border;
		            }
		        } else if (cell.background) {
		            style.borderTopColor = cell.background;
		        }
	
		        return td;
		    }
	
		    var HtmlTable = kendo.Class.extend({
		        init: function() {
		            this.cols = [];
		            this.trs = [];
		            this._height = 0;
		            this._width = 0;
		        },
	
		        addColumn: function(width) {
		            this._width += width;
	
		            var col = kendo.dom.element("col", { style: { width: width + "px" } });
	
		            col.visible = width > 0;
	
		            this.cols.push(col);
		        },
	
		        addRow: function(height) {
		            var attr = null;
	
		            attr = { style: { height: height + "px" } };
	
		            this._height += height;
	
		            var tr = kendo.dom.element("tr", attr);
	
		            tr.visible = height > 0;
	
		            this.trs.push(tr);
		        },
	
		        addCell: function(rowIndex, text, style, className, validation) {
		            if (text === null || text === undefined) {
		                text = "";
		            }
		            if (!(text instanceof kendo.dom.Node)) {
		                text = kendo.dom.text(text);
		            }
	
		            var children = [ text ];
		            var properties = { style: style };
	
		            if (validation && !validation.value) {
		                children.push(kendo.dom.element("span", { className: "k-dirty" }));
	
		                className = (className || "") + (className ? " " : "") + "k-dirty-cell";
		                properties.title = validation.message;
		            }
	
		            if (className) {
		                properties.className = className;
		            }
		            var td = kendo.dom.element("td", properties, children);
	
		            this.trs[rowIndex].children.push(td);
		            return td;
		        },
	
		        toDomTree: function(x, y, className) {
		            this.trs = this.trs.filter(function(tr) {
		                return tr.visible;
		            });
	
		            var offset = 0;
		            this.cols = this.cols.filter(function(col, ci) {
		                if (!col.visible) {
		                    this.trs.forEach(function(tr) {
		                        tr.children.splice(ci - offset, 1);
		                    });
		                    offset++;
		                }
	
		                return col.visible;
		            }, this);
	
		            return kendo.dom.element("table", { style: { left: x + "px", top: y + "px", height: this._height + "px", width: this._width + "px" }, className: className },
		                [
		                    kendo.dom.element("colgroup", null, this.cols),
		                    kendo.dom.element("tbody", null, this.trs)
		                ]);
		        }
		    });
	
		    var CELL_CONTEXT_MENU = '<ul class="#=classNames.cellContextMenu#">' +
		        '<li data-action=cut>Cut</li>' +
		        '<li data-action=copy>Copy</li>' +
		        '<li data-action=paste>Paste</li>' +
		        '<li class="k-separator"></li>' +
		        '<li data-action=merge>Merge</li>' +
		        '<li data-action=unmerge>Unmerge</li>' +
		    '</ul>';
	
		    var ROW_HEADER_CONTEXT_MENU = '<ul class="#=classNames.rowHeaderContextMenu#">' +
		        '<li data-action=cut>Cut</li>' +
		        '<li data-action=copy>Copy</li>' +
		        '<li data-action=paste>Paste</li>' +
		        '<li class="k-separator"></li>' +
		        '<li data-action="delete-row">Delete</li>'+
		        '<li data-action="hide-row">Hide</li>'+
		        '<li data-action="unhide-row">Unhide</li>'+
		    '</ul>';
	
		    var COL_HEADER_CONTEXT_MENU = '<ul class="#=classNames.colHeaderContextMenu#">' +
		        '<li data-action=cut>Cut</li>' +
		        '<li data-action=copy>Copy</li>' +
		        '<li data-action=paste>Paste</li>' +
		        '<li class="k-separator"></li>' +
		        '<li data-action="delete-column">Delete</li>'+
		        '<li data-action="hide-column">Hide</li>'+
		        '<li data-action="unhide-column">Unhide</li>'+
		    '</ul>';
	
	
		    kendo.spreadsheet.ContextMenu = kendo.ui.ContextMenu;
	
		    var VIEW_CONTENTS = kendo.template('<div class="#=classNames.view#"><div class="#=classNames.fixedContainer#"></div><div class="#=classNames.scroller#"><div class="#=classNames.viewSize#"></div></div>' +
		        '<div tabindex="0" class="#=classNames.clipboard#" contenteditable=true></div><div class="#=classNames.cellEditor#"></div></div><div class="#=classNames.sheetsBar#"></div>' +
		        CELL_CONTEXT_MENU + ROW_HEADER_CONTEXT_MENU + COL_HEADER_CONTEXT_MENU
		    );
	
		    function within(value, min, max) {
		        return value >= min && value <= max;
		    }
	
		    var View = kendo.Class.extend({
		        init: function(element, options) {
		            var classNames = View.classNames;
	
		            this.element = element;
	
		            this.options = $.extend(true, {
		                messages: kendo.spreadsheet.messages.view
		            }, this.options, options);
	
		            this._chrome();
	
		            this._dialogs = [];
	
		            element.append(VIEW_CONTENTS({ classNames: classNames }));
	
		            this._formulaInput();
	
		            this.wrapper =      element.find(DOT + classNames.view);
		            this.container =    element.find(DOT + classNames.fixedContainer)[0];
		            this.scroller =     element.find(DOT + classNames.scroller)[0];
		            this.clipboard =    element.find(DOT + classNames.clipboard);
	
		            this.viewSize = $(this.scroller.firstChild);
	
		            this.tree = new kendo.dom.Tree(this.container);
		            this.clipboardContents = new kendo.dom.Tree(this.clipboard[0]);
	
		            this.editor = new kendo.spreadsheet.SheetEditor(this);
	
		            this._sheetsbar();
	
		            var contextMenuConfig = {
		                target: element,
		                animation: false,
		                showOn: "never" // this is just an invalid event name to prevent the show
		            };
	
		            this.cellContextMenu = new kendo.spreadsheet.ContextMenu(element.find(DOT + classNames.cellContextMenu), contextMenuConfig);
	
		            this.colHeaderContextMenu = new kendo.spreadsheet.ContextMenu(element.find(DOT + classNames.colHeaderContextMenu), contextMenuConfig);
	
		            this.rowHeaderContextMenu = new kendo.spreadsheet.ContextMenu(element.find(DOT + classNames.rowHeaderContextMenu), contextMenuConfig);
		        },
	
		        enableClipboard: function(enable) {
		            this.isClipboardDeactivated = !enable;
	
		            if (enable) {
		                this.clipboard.attr("contenteditable", enable);
		            } else {
		                this.clipboard.removeAttr("contenteditable");
		            }
		        },
	
		        _resize: function() {
		            var actionBar = $(this.formulaBar.element).parents(".k-spreadsheet-action-bar");
		            var outerHeight = kendo._outerHeight;
		            var tabstripHeight = this.tabstrip ? outerHeight(this.tabstrip.element) : 0;
		            var formulaBarHeight = actionBar ? outerHeight(actionBar) : 0;
		            var sheetsBarHeight = this.sheetsbar ? outerHeight(this.sheetsbar.element) : 0;
	
		            this.wrapper.height(
		                this.element.height() -
		                    (tabstripHeight + formulaBarHeight + sheetsBarHeight)
		            );
	
		            if (this.tabstrip) {
		                this.tabstrip.quickAccessAdjust();
		            }
		        },
	
		        _chrome: function() {
		            var wrapper = $("<div class='k-spreadsheet-action-bar' />").prependTo(this.element);
	
		            var nameEditor = $("<div class='k-spreadsheet-name-editor' />").appendTo(wrapper);
		            this.nameEditor = new kendo.spreadsheet.NameEditor(nameEditor, this.options);
	
		            var formulaBar = $("<div />").appendTo(wrapper);
		            this.formulaBar = new kendo.spreadsheet.FormulaBar(formulaBar);
	
		            if (this.options.toolbar) {
		                this._tabstrip();
		            }
		        },
	
		        _formulaInput: function() {
		            var editor = this.element.find(DOT + View.classNames.cellEditor);
	
		            this.formulaInput = new kendo.spreadsheet.FormulaInput(editor, {
		                autoScale: true
		            });
		        },
	
		        _sheetsbar: function() {
		            if (this.options.sheetsbar) {
		                var options = $.extend(true, {
		                    openDialog: this.openDialog.bind(this)
		                }, this.options.sheetsbar);
	
		                this.sheetsbar = new kendo.spreadsheet.SheetsBar(this.element.find(DOT + View.classNames.sheetsBar), options);
		            }
		        },
	
		        _tabstrip: function() {
		            var messages = this.options.messages.tabs;
		            var options = $.extend(true, { home: true, insert: true, data: true }, this.options.toolbar);
		            var tabs = [];
	
		            if (this.tabstrip) {
		                this.tabstrip.destroy();
		                this.element.children(".k-tabstrip").remove();
		            }
	
		            for (var name in options) {
		                if (options[name] === true || options[name] instanceof Array) {
		                    tabs.push({ id: name, text: messages[name], content: "" });
		                }
		            }
	
		            this.tabstrip = new kendo.spreadsheet.TabStrip($("<div />").prependTo(this.element), {
		                animation: false,
		                dataTextField: "text",
		                dataContentField: "content",
		                dataSource: tabs,
		                toolbarOptions: options,
		                view: this
		            });
	
		            this.tabstrip.select(0);
		        },
	
		        _executeCommand: function(e) {
		            this._sheet.trigger("commandRequest", e);
		        },
	
		        workbook: function(workbook) {
		            this._workbook = workbook;
		            workbook._view = this;
		            this.nameEditor._workbook = workbook;
		        },
	
		        sheet: function(sheet) {
		            this._sheet = sheet;
		        },
	
		        activeCellRectangle: function() {
		            return this.cellRectangle(this._sheet._viewActiveCell());
		        },
	
		        _rectangle: function(pane, ref) {
		            return pane._grid.boundingRectangle(ref.toRangeRef());
		        },
	
		        isColumnResizer: function(x, pane, col) {
		            // relative to content
		            x -= this._sheet._grid._headerWidth;
	
		            // add scroll if pane is not frozen
		            if (!pane._grid.columns.frozen) {
		                x += this.scroller.scrollLeft;
		            }
	
		            col = this._sheet._grid._columns.locate(0, col, function(w){
		                return Math.abs(x - w) <= RESIZE_HANDLE_WIDTH/2;
		            });
	
		            return col !== null && !this._sheet.isHiddenColumn(col) ? col : null;
		        },
	
		        isRowResizer: function(y, pane, row) {
		            // relative to content
		            y -= this._sheet._grid._headerHeight;
	
		            // add scroll if pane is not frozen
		            if (!pane._grid.rows.frozen) {
		                y += this.scroller.scrollTop;
		            }
	
		            row = this._sheet._grid._rows.locate(0, row, function(h){
		                return Math.abs(y - h) <= RESIZE_HANDLE_WIDTH/2;
		            });
	
		            return row !== null && !this._sheet.isHiddenRow(row) ? row : null;
		        },
	
		        isFilterIcon: function(x, y, pane, ref) {
		            var self = this;
		            var theGrid = pane._grid;
		            var scrollTop = theGrid.rows.frozen ? 0 : self.scroller.scrollTop;
		            var scrollLeft = theGrid.columns.frozen ? 0 : self.scroller.scrollLeft;
	
		            x -= self._sheet._grid._headerWidth - scrollLeft;
		            y -= self._sheet._grid._headerHeight - scrollTop;
	
		            return kendo.util.withExit(function(exit){
		                self._sheet.forEachFilterHeader(ref, function(ref) {
		                    var rect = self._rectangle(pane, ref);
		                    if (pane.filterIconRect(rect).intersects(x, y)) {
		                        exit(true);
		                    }
		                });
		            });
		        },
	
		        isAutoFill: function(x, y, pane) {
		            var selection = this._sheet.select();
	
		            if (selection.size > 1) {
		                return false;
		            }
	
		            x -= this._sheet._grid._headerWidth;
		            y -= this._sheet._grid._headerHeight;
	
		            if (!pane._grid.columns.frozen) {
		                x += this.scroller.scrollLeft;
		            }
	
		            if (!pane._grid.rows.frozen) {
		                y += this.scroller.scrollTop;
		            }
	
		            var rectangle = this._rectangle(pane, selection);
	
		            return Math.abs(rectangle.right - x) < 8 && Math.abs(rectangle.bottom - y) < 8;
		        },
	
		        isEditButton: function(x, y, pane) {
		            var ed = this._sheet.activeCellCustomEditor();
		            if (ed) {
		                var r = this.activeCellRectangle();
		                // XXX: hard-coded button width (20)
		                if (y >= r.top && y <= r.bottom) {
		                    return pane._editorInLastColumn ? x < r.left && x >= r.left - 20
		                        : x > r.right && x <= r.right + 20;
		                }
		            }
		        },
	
		        objectAt: function(x, y) {
		            var grid = this._sheet._grid;
		            var object, pane;
	
		            if (x < 0 || y < 0 || x > this.scroller.clientWidth || y > this.scroller.clientHeight) {
		                object = { type: "outside" };
		            } else if (x < grid._headerWidth && y < grid._headerHeight) {
		                object = { type: "topcorner" };
		            } else {
		                pane = this.paneAt(x, y);
	
		                if (!pane) {
		                    object = { type: "outside" };
		                } else {
		                    var row = pane._grid.rows.indexVisible(y, this.scroller.scrollTop);
		                    var column = pane._grid.columns.indexVisible(x, this.scroller.scrollLeft);
	
		                    var type = "cell";
		                    var ref = new CellRef(row, column);
		                    var selecting = this._sheet.selectionInProgress();
	
		                    if (this.isAutoFill(x, y, pane)) {
		                        type = "autofill";
		                    } else if (this.isFilterIcon(x, y, pane, ref)) {
		                        type = "filtericon";
		                    } else if (!selecting && x < grid._headerWidth) {
		                        type = "rowheader";
		                        if ((row = this.isRowResizer(y, pane, row)) !== null) {
		                            ref = new CellRef(row, -Infinity);
		                            type = "rowresizehandle";
		                        }
		                    } else if (!selecting && y < grid._headerHeight) {
		                        type = "columnheader";
		                        if ((column = this.isColumnResizer(x, pane, column)) !== null) {
		                            ref = new CellRef(-Infinity, column);
		                            type = "columnresizehandle";
		                        }
		                    } else if (this.isEditButton(x, y, pane)) {
		                        type = "editor";
		                    }
	
		                    if (type == "cell") {
		                        // when clicking on a merged cell, return the top-left one
		                        // https://github.com/telerik/kendo/issues/7698
		                        this._sheet.forEachMergedCell(ref, function(merged){
		                            ref = merged.topLeft;
		                        });
		                    }
	
		                    object = { type: type, ref: ref };
		                }
		            }
	
		            object.pane = pane;
		            object.x = x;
		            object.y = y;
		            return object;
		        },
	
		        paneAt: function(x, y) {
		            return this.panes.filter(function paneLocationWithin(pane) {
		                var grid = pane._grid;
		                return within(y, grid.top, grid.bottom) && within(x, grid.left, grid.right);
		            })[0];
		        },
	
		        containingPane: function(cell) {
		            return this.panes.filter(function(pane) {
		                if (pane._grid.contains(cell)) {
		                    return true;
		                }
		                return false;
		            })[0];
		        },
	
		        cellRectangle: function(cell) {
		            var theGrid = this.containingPane(cell)._grid;
		            var rectangle = this._sheet._grid.rectangle(cell);
	
		            return rectangle.offset(
		                theGrid.headerWidth - (theGrid.columns.frozen ? 0 : this.scroller.scrollLeft),
		                theGrid.headerHeight - (theGrid.rows.frozen ? 0 : this.scroller.scrollTop)
		            );
		        },
	
		        refresh: function(reason) {
		            var sheet = this._sheet;
	
		            if (this.tabstrip) {
		                this.tabstrip.refreshTools(sheet.range(sheet.activeCell()));
		            }
	
		            if (reason.sheetSelection && this.sheetsbar) {
		                this.sheetsbar.renderSheets(this._workbook.sheets(), this._workbook.sheetIndex(this._sheet));
		            }
	
		            this._resize();
	
		            //TODO: refresh sheets list on sheetSelection
		            this.viewSize[0].style.height = sheet._grid.totalHeight() + "px";
		            this.viewSize[0].style.width = sheet._grid.totalWidth() + "px";
	
		            if (reason.layout) {
		                var frozenColumns = sheet.frozenColumns();
		                var frozenRows = sheet.frozenRows();
	
		                // main or bottom or right pane
		                this.panes = [ this._pane(frozenRows, frozenColumns) ];
	
		                // left pane
		                if (frozenColumns > 0) {
		                    this.panes.push(this._pane(frozenRows, 0, null, frozenColumns));
		                }
	
		                // top pane
		                if (frozenRows > 0) {
		                    this.panes.push(this._pane(0, frozenColumns, frozenRows, null));
		                }
	
		                // left-top "fixed" pane
		                if (frozenRows > 0 && frozenColumns > 0) {
		                    this.panes.push(this._pane(0, 0, frozenRows, frozenColumns));
		                }
		            }
	
		            if (reason.filter) {
		                this._destroyFilterMenu();
		            }
	
		            if (reason.activeCell) {
		                this._focus = sheet.activeCell().toRangeRef();
		            }
		        },
	
		        createFilterMenu: function(column) {
		            if (this._filterMenu && this._filterMenu.options.column == column) {
		                return this._filterMenu;
		            }
	
		            this._destroyFilterMenu();
	
		            var sheet = this._sheet;
		            var ref = sheet.filter().ref;
		            var range = new kendo.spreadsheet.Range(ref, sheet);
		            var element = $("<div />").appendTo(this.element);
		            var options = { column: column, range: range };
		            var filterMenu = new kendo.spreadsheet.FilterMenu(element, options);
	
		            this._filterMenu = filterMenu;
	
		            return filterMenu;
		        },
	
		        selectClipBoardContents: function() {
		            if (!this.isClipboardDeactivated) {
		                this.clipboard.focus();
		                selectElementContents(this.clipboard[0]);
		            }
		        },
	
		        scrollIntoView: function(cell) {
		            var willScroll = false;
		            var theGrid = this.containingPane(cell)._grid;
	
		            var boundaries = theGrid.scrollBoundaries(cell);
	
		            var scroller = this.scroller;
		            var scrollTop = theGrid.rows.frozen ? 0 : scroller.scrollTop;
		            var scrollLeft = theGrid.columns.frozen ? 0 : scroller.scrollLeft;
	
		            if (boundaries.top < scrollTop) {
		                willScroll = true;
		                scroller.scrollTop = boundaries.scrollTop;
		            }
	
		            if (boundaries.bottom > scrollTop) {
		                willScroll = true;
		                scroller.scrollTop = boundaries.scrollBottom;
		            }
	
		            if (boundaries.left < scrollLeft) {
		                willScroll = true;
		                scroller.scrollLeft = boundaries.scrollLeft;
		            }
	
		            if (boundaries.right > scrollLeft) {
		                willScroll = true;
		                scroller.scrollLeft = boundaries.scrollRight;
		            }
	
		            return willScroll;
		        },
	
		        _destroyDialog: function() {
		            this._dialogs.pop();
		        },
	
		        openCustomEditor: function() {
		            var self = this;
		            var cell = self._sheet.activeCell().first();
		            var editor = self._sheet.activeCellCustomEditor();
		            var range = self._sheet.range(cell);
		            editor.edit({
		                range      : range,
		                rect       : self.activeCellRectangle(),
		                view       : this,
		                validation : this._sheet.validation(cell),
		                callback   : function(value, parse){
		                    self._executeCommand({
		                        command: "EditCommand",
		                        options: {
		                            operatingRange: range,
		                            property: parse ? "input" : "value",
		                            value: value
		                        }
		                    });
		                }
		            });
		        },
	
		        openDialog: function(name, options) {
		            var dialog = kendo.spreadsheet.dialogs.create(name, options);
	
		            if (dialog) {
		                dialog.bind("action", this._executeCommand.bind(this));
		                dialog.bind("deactivate", this._destroyDialog.bind(this));
		                this._dialogs.push(dialog);
	
		                var sheet = this._sheet;
		                var ref = sheet.activeCell();
		                var range = new kendo.spreadsheet.Range(ref, sheet);
	
		                dialog.open(range);
		                return dialog;
		            }
		        },
	
		        showError: function(options, reopenEditor) {
		            var errorMessages = this.options.messages.errors;
	
		            var focusButton = function(e) {
		                var cont = e.sender.dialog().element;
		                cont.find(".k-button:first").focus();
		                cont.find(".k-button, input").on("keydown", function(ev){
		                    if (ev.keyCode == kendo.keys.ESC) {
		                        e.sender.close();
		                    }
		                });
		            };
	
		            var onClose = function(e) {
		                var dlg = e.sender;
		                this.selectClipBoardContents();
		                if (dlg._retry && reopenEditor) {
		                    reopenEditor();
		                }
		            }.bind(this);
	
		            if (kendo.spreadsheet.dialogs.registered(options.type)) {
		                var dialogOptions = {
		                    close: onClose
		                };
	
		                if (options.type === "validationError") {
		                    dialogOptions = $.extend(dialogOptions, {
		                        title: options.title || "Error",
		                        text: options.body ? options.body : errorMessages[options.type],
		                        activate: focusButton
		                    });
		                }
	
		                this.openDialog(options.type, dialogOptions);
		            } else {
		                this.openDialog("message", {
		                    title : options.title || "Error",
		                    text  : options.body ? options.body : errorMessages[options.type],
		                    activate: focusButton,
		                    close: onClose
		                });
		            }
		        },
	
		        destroy: function() {
		            this._dialogs.forEach(function(dialog) {
		                dialog.destroy();
		            });
		            this.cellContextMenu.destroy();
		            this.rowHeaderContextMenu.destroy();
		            this.colHeaderContextMenu.destroy();
	
		            if (this.tabstrip) {
		                this.tabstrip.destroy();
		            }
	
		            this._destroyFilterMenu();
		        },
	
		        _destroyFilterMenu: function() {
		            if (this._filterMenu) {
		                this._filterMenu.destroy();
		                this._filterMenu = undefined;
		                this._filterMenuColumn = undefined;
		            }
		        },
	
		        render: function() {
		            if (!this.element.is(":visible")) {
		                return;
		            }
		            var sheet = this._sheet;
		            var focus = sheet.focus();
	
		            if (focus && this.scrollIntoView(focus)) {
		                return;
		            }
	
		            var resizeDirection =
		                !sheet.resizingInProgress() ? "none" :
		                sheet.resizeHandlePosition().col === -Infinity ? "column" :
		                "row";
	
		            this.wrapper
		                .toggleClass(viewClassNames.editContainer, this.editor.isActive())
		                .toggleClass(viewClassNames.horizontalResize, resizeDirection == "row")
		                .toggleClass(viewClassNames.verticalResize, resizeDirection == "column");
	
		            var grid = sheet._grid;
	
		            var scrollTop = this.scroller.scrollTop;
		            var scrollLeft = this.scroller.scrollLeft;
	
		            if (scrollTop < 0) {
		                scrollTop = 0;
		            }
	
		            if (scrollLeft < 0) {
		                scrollLeft = 0;
		            }
	
		            var result = this.panes.map(function(pane) {
		                return pane.render(scrollLeft, scrollTop);
		            });
	
		            var topCorner = kendo.dom.element("div", {
		                style: { width: grid._headerWidth + "px", height: grid._headerHeight + "px" },
		                className: View.classNames.topCorner
		            });
	
		            result.push(topCorner);
	
		            if (sheet.resizeHandlePosition() && sheet.resizeHintPosition()) {
		                result.push(this.renderResizeHint());
		            }
	
		            this.tree.render(result);
	
		            var scrollbar = kendo.support.scrollbar();
	
		            $(this.container).css({
		                width: this.wrapper[0].clientWidth - scrollbar,
		                height: this.wrapper[0].clientHeight - scrollbar
		            });
	
		            if (this.editor.isActive()) {
		                this.editor.toggleTooltip(this.activeCellRectangle());
		            } else if (!sheet.selectionInProgress() && !sheet.resizingInProgress() && !sheet.isInEditMode()) {
		                this.renderClipboardContents();
		            }
		        },
	
		        // this renders the big blue line during resizing
		        renderResizeHint: function() {
		            var sheet = this._sheet;
		            var ref = sheet.resizeHandlePosition();
	
		            var horizontal = ref.col !== -Infinity;
	
		            var style;
		            if (horizontal) {
		                style = {
		                    height: this.scroller.clientHeight + "px",
		                    width: RESIZE_HANDLE_WIDTH + "px",
		                    left: sheet.resizeHintPosition().x + "px",
		                    top: "0px"
		                };
		            } else {
		                style = {
		                    height: RESIZE_HANDLE_WIDTH + "px",
		                    width: this.scroller.clientWidth + "px",
		                    top: sheet.resizeHintPosition().y + "px",
		                    left: "0px"
		                };
		            }
	
		            var classNames = Pane.classNames;
	
		            return kendo.dom.element("div", {
		                className: classNames.resizeHint + (!horizontal ? " " + classNames.resizeHintVertical : ""),
		                style: style
		            },[
		                kendo.dom.element("div", { className: classNames.resizeHintHandle }),
		                kendo.dom.element("div", { className: classNames.resizeHintMarker })
		            ]);
		        },
	
		        renderClipboardContents: function() {
		            var sheet = this._sheet;
		            var grid = sheet._grid;
	
		            var selection = grid.normalize(sheet.select().toRangeRef());
		            var status = this._workbook.clipboard().canCopy();
		            if(status.canCopy === false && status.multiSelection) {
		                this.clipboardContents.render([]);
		                this.selectClipBoardContents();
		                return;
		            }
	
		            selection = sheet.trim(selection);
	
		            var table = new HtmlTable();
	
		            var selectionView = grid.rangeDimensions(selection);
	
		            selectionView.rows.forEach(function(height) {
		                table.addRow(height);
		            });
	
		            selectionView.columns.forEach(function(width) {
		                table.addColumn(width);
		            });
	
		            var tmp = sheet._getMergedCells(selection);
		            var primaryMergedCells = tmp.primary;
		            var secondaryMergedCells = tmp.secondary;
	
		            sheet.forEach(selection, function(row, col, cell) {
		                var location = new CellRef(row, col).print();
	
		                if (!secondaryMergedCells[location]) {
		                    var td = addCell(table, row - selection.topLeft.row, cell);
	
		                    var mergedCell = primaryMergedCells[location];
	
		                    if (mergedCell) {
		                        td.attr.colspan = mergedCell.width();
		                        td.attr.rowspan = mergedCell.height();
		                    }
		                }
		            });
		            this.clipboardContents.render([ table.toDomTree(0, 0, "kendo-clipboard-" + this._workbook.clipboard()._uid) ]);
	
		            this.selectClipBoardContents();
		        },
	
		        _pane: function(row, column, rowCount, columnCount) {
		            var pane = new Pane(this._sheet, this._sheet._grid.pane({ row: row, column: column, rowCount: rowCount, columnCount: columnCount }));
		            pane.refresh(this.scroller.clientWidth, this.scroller.clientHeight);
		            return pane;
		        }
		    });
	
		    var paneClassNames = {
		        cell: "k-spreadsheet-cell",
		        vaxis: "k-spreadsheet-vaxis",
		        haxis: "k-spreadsheet-haxis",
		        vborder: "k-spreadsheet-vborder",
		        hborder: "k-spreadsheet-hborder",
		        rowHeader: "k-spreadsheet-row-header",
		        columnHeader: "k-spreadsheet-column-header",
		        pane: "k-spreadsheet-pane",
		        data: "k-spreadsheet-data",
		        mergedCell: "k-spreadsheet-merged-cell",
		        mergedCellsWrapper: "k-merged-cells-wrapper",
		        activeCell: "k-spreadsheet-active-cell",
		        selection: "k-spreadsheet-selection",
		        selectionWrapper: "k-selection-wrapper",
		        autoFillWrapper: "k-auto-fill-wrapper",
		        single: "k-single",
		        top: "k-top",
		        right: "k-right",
		        bottom: "k-bottom",
		        left: "k-left",
		        resizeHandle: "k-resize-handle",
		        columnResizeHandle: "k-column-resize-handle",
		        rowResizeHandle: "k-row-resize-handle",
		        resizeHint: "k-resize-hint",
		        resizeHintHandle: "k-resize-hint-handle",
		        resizeHintMarker: "k-resize-hint-marker",
		        resizeHintVertical: "k-resize-hint-vertical",
		        selectionHighlight: "k-spreadsheet-selection-highlight",
		        series: [
		            "k-series-a",
		            "k-series-b",
		            "k-series-c",
		            "k-series-d",
		            "k-series-e",
		            "k-series-f"
		        ]
		    };
	
		    var Pane = kendo.Class.extend({
		        init: function(sheet, grid) {
		            this._sheet = sheet;
		            this._grid = grid;
		        },
	
		        refresh: function(width, height) {
		            this._grid.refresh(width, height);
		        },
	
		        isVisible: function(scrollLeft, scrollTop, ref) {
		            return this._grid.view(scrollLeft, scrollTop).ref.intersects(ref);
		        },
	
		        render: function(scrollLeft, scrollTop) {
		            var classNames = Pane.classNames;
		            var sheet = this._sheet;
		            var grid = this._grid;
	
		            var view = grid.view(scrollLeft, scrollTop);
		            this._currentView = view;
		            this._currentRect = this._rectangle(view.ref);
		            this._selectedHeaders = sheet.selectedHeaders();
	
		            var children = [];
	
		            children.push(this.renderData());
	
		            children.push(this.renderSelection());
	
		            children.push(this.renderAutoFill());
	
		            children.push(this.renderEditorSelection());
	
		            children.push(this.renderFilterHeaders());
	
		            if (grid.hasRowHeader) {
		                var rowHeader = kendo.dom.element("div", {
		                    className: classNames.rowHeader,
		                    style: {
		                        width: grid.headerWidth + "px",
		                        top: view.rowOffset + "px"
		                    }
		                });
		                children.push(rowHeader);
		                sheet.forEach(view.ref.leftColumn(), function(row){
		                    if (!sheet.isHiddenRow(row)) {
		                        var text = row + 1, height = sheet.rowHeight(row);
		                        rowHeader.children.push(kendo.dom.element("div", {
		                            className: this.headerClassName(row, "row"),
		                            style: {
		                                width: grid.headerWidth + "px",
		                                height: height + "px"
		                            }
		                        }, [ kendo.dom.element("div", {
		                            className: "k-vertical-align-center"
		                        }, [ kendo.dom.text(text+"") ])]));
		                    }
		                }.bind(this));
		            }
	
		            if (grid.hasColumnHeader) {
		                var columnHeader = kendo.dom.element("div", {
		                    className: classNames.columnHeader,
		                    style: {
		                        top: "0px",
		                        left: view.columnOffset + "px",
		                        width: this._currentRect.width + "px",
		                        height: grid.headerHeight + "px"
		                    }
		                });
		                children.push(columnHeader);
		                var left = 0;
		                sheet.forEach(view.ref.topRow(), function(row, col){
		                    if (!sheet.isHiddenColumn(col)) {
		                        var text = kendo.spreadsheet.Ref.display(null, Infinity, col),
		                            width = sheet.columnWidth(col);
		                        columnHeader.children.push(kendo.dom.element("div", {
		                            className: this.headerClassName(col, "col"),
		                            style: {
		                                position: "absolute",
		                                left: left + "px",
		                                width: width + "px",
		                                height: grid.headerHeight + "px"
		                            }
		                        }, [ kendo.dom.element("div", {
		                            className: "k-vertical-align-center"
		                        }, [ kendo.dom.text(text+"") ])]));
		                        left += width;
		                    }
		                }.bind(this));
		            }
	
		            if (sheet.resizeHandlePosition() && (grid.hasColumnHeader || grid.hasRowHeader)) {
		                if (!sheet.resizeHintPosition()) {
		                    this.renderResizeHandle(children);
		                }
		            }
	
		            var paneClasses = [classNames.pane];
	
		            if (grid.hasColumnHeader) {
		                paneClasses.push(classNames.top);
		            }
	
		            if (grid.hasRowHeader) {
		                paneClasses.push(classNames.left);
		            }
	
		            return kendo.dom.element("div", {
		                style: grid.style,
		                className: paneClasses.join(" ")
		            }, children);
		        },
	
		        headerClassName: function(index, type) {
		            var selectedHeaders = this._selectedHeaders;
	
		            var itemSelection;
		            var allHeaders;
	
		            if (type === "row") {
		                itemSelection = selectedHeaders.rows[index];
		                allHeaders = selectedHeaders.allRows;
		            } else {
		                itemSelection = selectedHeaders.cols[index];
		                allHeaders = selectedHeaders.allCols;
		            }
	
		            var className = itemSelection || (selectedHeaders.all ? "full" : (allHeaders ? "partial" : "none"));
	
		            if (className) {
		                className = "k-selection-" + className;
		            }
	
		            return className;
		        },
	
		        renderData: function() {
		            var sheet = this._sheet;
		            var view = this._currentView;
		            var cont = kendo.dom.element("div", {
		                className: Pane.classNames.data,
		                style: {
		                    position: "relative",
		                    left: view.columnOffset + "px",
		                    top: view.rowOffset + "px"
		                }
		            });
		            var rect = this._currentRect;
		            var layout = kendo.spreadsheet.draw.doLayout(sheet, view.ref, { forScreen: true }), prev;
		            var showGridLines = sheet._showGridLines;
		            if (showGridLines) {
		                // draw axis first
		                prev = null;
		                layout.xCoords.forEach(function(x){
		                    if (x !== prev) {
		                        prev = x;
		                        cont.children.push(kendo.dom.element("div", {
		                            className: paneClassNames.vaxis,
		                            style: {
		                                left: x + "px",
		                                height: rect.height + "px",
		                                borderColor: sheet.gridLinesColor()
		                            }
		                        }));
		                    }
		                });
		                prev = null;
		                layout.yCoords.forEach(function(y){
		                    if (y !== prev) {
		                        prev = y;
		                        cont.children.push(kendo.dom.element("div", {
		                            className: paneClassNames.haxis,
		                            style: {
		                                top: y + "px",
		                                width: rect.width + "px",
		                                borderColor: sheet.gridLinesColor()
		                            }
		                        }));
		                    }
		                });
		            }
		            var borders = kendo.spreadsheet.draw.Borders();
		            var activeCellRange = sheet.activeCell().toRangeRef();
		            var activeCell = activeCellRange.topLeft;
	
		            layout.cells.forEach(function(cell){
		                var cls = null;
		                if (cell.row + view.ref.topLeft.row == activeCell.row &&
		                    cell.col + view.ref.topLeft.col == activeCell.col)
		                {
		                    // active cell.  normally we enter here only once.
		                    cls = [
		                        Pane.classNames.activeCell
		                    ].concat(this._activeFormulaColor(),
		                             this._directionClasses(activeCellRange));
		                    if (sheet.singleCellSelection()) {
		                        cls.push(Pane.classNames.single);
		                    }
		                    cls = cls.join(" ");
		                }
		                borders.add(cell);
		                drawCell(cont.children, cell, cls, showGridLines);
		            }, this);
		            borders.vert.forEach(function(a){
		                a.forEach(function(b){
		                    if (!b.rendered) {
		                        b.rendered = true;
		                        var style = {
		                            left        : b.x + "px",
		                            top         : b.top + "px",
		                            height      : (b.bottom - b.top + 1) + "px",
		                            borderWidth : b.size + "px",
		                            borderColor : b.color
		                        };
		                        if (b.size != 1) {
		                            style.transform = "translateX(-" + (b.size-1)/2 + "px)";
		                        }
		                        cont.children.push(kendo.dom.element("div", {
		                            className: paneClassNames.vborder,
		                            style: style
		                        }));
		                    }
		                });
		            });
		            borders.horiz.forEach(function(a){
		                a.forEach(function(b){
		                    if (!b.rendered) {
		                        b.rendered = true;
		                        var style = {
		                            top         : b.y + "px",
		                            left        : b.left + "px",
		                            width       : (b.right - b.left) + "px",
		                            borderWidth : b.size + "px",
		                            borderColor : b.color
		                        };
		                        if (b.size != 1) {
		                            style.transform = "translateY(-" + (b.size-1)/2 + "px)";
		                        }
		                        cont.children.push(kendo.dom.element("div", {
		                            className: paneClassNames.hborder,
		                            style: style
		                        }));
		                    }
		                });
		            });
		            return cont;
		        },
	
		        renderResizeHandle: function(container) {
		            var sheet = this._sheet;
		            var ref = sheet.resizeHandlePosition();
		            var rectangle = this._rectangle(ref);
		            var classNames = [ Pane.classNames.resizeHandle ];
	
		            var style;
		            if (ref.col !== -Infinity) {
		                if (this._grid.rows._start > 0) {
		                    return;
		                }
		                style = {
		                    height: this._grid.headerHeight + "px",
		                    width: RESIZE_HANDLE_WIDTH + "px",
		                    left: rectangle.right - RESIZE_HANDLE_WIDTH/2  + "px",
		                    top: "0px"
		                };
		                classNames.push(viewClassNames.horizontalResize);
		            } else {
		                if (this._grid.columns._start > 0) {
		                    return;
		                }
		                style = {
		                    height: RESIZE_HANDLE_WIDTH + "px",
		                    width:  this._grid.headerWidth + "px",
		                    top: rectangle.bottom - RESIZE_HANDLE_WIDTH/2  + "px",
		                    left: "0px"
		                };
		                classNames.push(viewClassNames.verticalResize);
		            }
	
		            container.push(kendo.dom.element("div", {
		                className: classNames.join(" "),
		                style: style
		            }));
		        },
	
		        filterIconRect: function(rect) {
		            var BUTTON_SIZE = 16;
		            var BUTTON_OFFSET = 3;
	
		            return new kendo.spreadsheet.Rectangle(
		                rect.right - BUTTON_SIZE - BUTTON_OFFSET,
		                rect.top + BUTTON_OFFSET,
		                BUTTON_SIZE,
		                BUTTON_SIZE
		            );
		        },
	
		        renderFilterHeaders: function() {
		            var sheet = this._sheet;
		            var children = [];
		            var classNames = View.classNames;
		            var filter = sheet.filter();
	
		            function icon(className) {
		                return kendo.dom.element("span", {
		                    className: classNames.icon + " " + className
		                });
		            }
	
		            function filterButton(classNames, position, index) {
		                var style = {
		                    left: position.left + "px",
		                    top: position.top + "px"
		                };
		                var filtered = filter && filter.columns.some(function(c) {
		                    return c.index === index;
		                });
		                var classes = classNames.filterButton;
	
		                if (filtered) {
		                    classes += " " + classNames.filterButtonActive;
		                }
	
		                var button = kendo.dom.element(
		                    "span",
		                    { className: classes, style: style },
		                    [ icon(classNames.iconFilterDefault) ]
		                );
	
		                return button;
		            }
	
		            if (filter) {
		                this._addDiv(children, filter.ref, classNames.filterRange);
		            }
	
		            sheet.forEachFilterHeader(this._currentView.ref, function(ref) {
		                var rect = this._rectangle(ref);
		                var position = this.filterIconRect(rect);
		                var column = this._sheet.filterColumn(ref);
		                var button = filterButton(classNames, position, column);
	
		                children.push(button);
		            }.bind(this));
	
		            return kendo.dom.element("div", {
		                className: classNames.filterHeadersWrapper
		            }, children);
	
		        },
	
		        renderEditorSelection: function() {
		            var classNames = Pane.classNames;
		            var sheet = this._sheet;
		            var selections = [];
	
		            sheet._formulaSelections.forEach(function(range) {
		                var ref = range.ref;
	
		                if (ref === kendo.spreadsheet.NULLREF) {
		                    return;
		                }
	
		                this._addDiv(selections, ref, classNames.selectionHighlight + " " + range.colorClass);
		            }.bind(this));
	
		            return kendo.dom.element("div", { className: classNames.selectionWrapper }, selections);
	
		        },
	
		        renderSelection: function() {
		            var classNames = Pane.classNames;
		            var selections = [];
		            var selectionClasses = [classNames.selection];
		            var sheet = this._sheet;
		            var activeCell = sheet.activeCell().toRangeRef();
		            var selection = sheet.select();
	
		            selectionClasses = selectionClasses.concat(this._activeFormulaColor());
	
		            if (selection.size() === 1) {
		                selectionClasses.push("k-single-selection");
		            }
	
		            if (this._sheet.autoFillPunch()) {
		                selectionClasses.push("k-dim-auto-fill-handle");
		            }
	
		            selection.forEach(function(ref) {
		                if (ref !== kendo.spreadsheet.NULLREF) {
		                    this._addDiv(selections, ref, selectionClasses.join(" "));
		                }
		            }.bind(this));
	
		            this._renderCustomEditorButton(selections, activeCell);
	
		            return kendo.dom.element("div", { className: classNames.selectionWrapper }, selections);
		        },
	
		        renderAutoFill: function() {
		            var autoFillRectangle = [];
	
		            if (this._sheet.autoFillInProgress()) {
		                var autoFillRef = this._sheet.autoFillRef();
		                var punch = this._sheet.autoFillPunch();
		                var direction = this._sheet._autoFillDirection;
	
		                this._addDiv(autoFillRectangle, autoFillRef, "k-auto-fill");
	
		                if (punch) { // collapsing, add overlay
		                    this._addDiv(autoFillRectangle, punch, "k-auto-fill-punch");
		                } else if (direction !== undefined) { // expanding - add hint
		                    var ref, cssClass;
	
		                    switch(direction) {
		                        case 0:
		                            ref = autoFillRef.bottomRight;
		                            cssClass = "k-auto-fill-br-hint";
		                            break;
		                        case 1:
		                            ref = autoFillRef.bottomRight;
		                            cssClass = "k-auto-fill-br-hint";
		                            break;
		                        case 2:
		                            ref = new CellRef(autoFillRef.topLeft.row, autoFillRef.bottomRight.col);
		                            cssClass = "k-auto-fill-tr-hint";
		                            break;
		                        case 3:
		                            ref = new CellRef(autoFillRef.bottomRight.row, autoFillRef.topLeft.col);
		                            cssClass = "k-auto-fill-bl-hint";
		                            break;
		                    }
	
		                    var hint = kendo.dom.element("span", { className: "k-tooltip" }, [ kendo.dom.text(this._sheet._autoFillHint) ]);
	
		                    var rectangle = this._addDiv(autoFillRectangle, ref, cssClass);
		                    if (rectangle) {
		                        rectangle.children.push(hint);
		                    }
		                }
		            }
	
		            return kendo.dom.element("div", { className: Pane.classNames.autoFillWrapper }, autoFillRectangle);
		        },
	
		        _addDiv: function(collection, ref, className) {
		            var view = this._currentView, div;
	
		            if (view.ref.intersects(ref)) {
		                div = this._rectangle(ref).resize(1, 1).toDiv(className);
		                collection.push(div);
		            }
		            return div;
		        },
	
		        _renderCustomEditorButton: function(collection, ref) {
		            var self = this;
		            var sheet = self._sheet;
		            var view = self._currentView;
		            var columnCount = self._grid.columns._axis._count;
		            var ed = sheet.activeCellCustomEditor();
	
		            if (ed && view.ref.intersects(ref)) {
		                var rectangle = self._rectangle(ref);
		                sheet.forEach(ref.collapse(), function(row, col, cell) {
		                    cell.left = rectangle.left;
		                    cell.top = rectangle.top;
		                    cell.width = rectangle.width;
		                    cell.height = rectangle.height;
	
		                    var btnClass = "k-button k-spreadsheet-editor-button";
		                    var isLastColumn = col == columnCount - 1;
		                    if (isLastColumn) {
		                        btnClass += " k-spreadsheet-last-column";
		                    }
		                    self._editorInLastColumn = isLastColumn;
		                    var btn = kendo.dom.element("div", {
		                        className: btnClass,
		                        style: {
		                            left   : (cell.left + (isLastColumn ? 0 : cell.width)) + "px",
		                            top    : cell.top + "px",
		                            height : cell.height + "px"
		                        }
		                    });
		                    if (ed.icon) {
		                        btn.children.push(kendo.dom.element("span", {
		                            className: "k-icon " + ed.icon
		                        }));
		                    }
		                    collection.push(btn);
		                });
		            }
		        },
	
		        _activeFormulaColor: function() {
		            var activeFormulaSelection;
		            var colorClasses = [];
	
		            if (this._sheet.isInEditMode()) {
		                activeFormulaSelection = this._sheet._formulaSelections.filter(function(sel) { return sel.active && sel.type == "ref"; })[0];
	
		                if (activeFormulaSelection) {
		                    colorClasses.push(activeFormulaSelection.colorClass);
		                }
		            }
	
		            return colorClasses;
		        },
	
		        _directionClasses: function(cell) {
		            var cellClasses = [];
		            var classNames = Pane.classNames;
		            var view = this._currentView.ref;
	
		            if (!cell.move(0, -1).intersects(view)) {
		                cellClasses.push(classNames.left);
		            }
	
		            if (!cell.move(-1, 0).intersects(view)) {
		                cellClasses.push(classNames.top);
		            }
	
		            if (!cell.move(0, 1).intersects(view)) {
		                cellClasses.push(classNames.right);
		            }
	
		            if (!cell.move(1, 0).intersects(view)) {
		                cellClasses.push(classNames.bottom);
		            }
	
		            return cellClasses;
		        },
	
		        _rectangle: function(ref) {
		            return this._grid.boundingRectangle(ref.toRangeRef()).offset(-this._currentView.mergedCellLeft, -this._currentView.mergedCellTop);
		        }
		    });
	
		    kendo.spreadsheet.View = View;
		    kendo.spreadsheet.Pane = Pane;
		    kendo.spreadsheet.drawCell = drawCell;
	
		    $.extend(true, View, { classNames: viewClassNames });
		    $.extend(true, Pane, { classNames: paneClassNames });
	
		})(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1509:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(581);
	
	/***/ }),
	
	/***/ 1510:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(717);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1462);
		module.exports = __webpack_require__(1462);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 928:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1462:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(928), __webpack_require__(1463), __webpack_require__(1464), __webpack_require__(1465) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
	
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    // jshint eqnull:true
	
		    var EDITORS = {};
	
		    var registerEditor = kendo.spreadsheet.registerEditor = function(name, editor) {
		        EDITORS[name] = editor;
		    };
	
		    kendo.spreadsheet.Sheet.prototype.activeCellCustomEditor = function() {
		        var cell = this.activeCell().first();
	
		        if (this.range(cell).enable()) {
		            var val = this.validation(cell);
		            var key = this._properties.get("editor", this._grid.cellRefIndex(cell));
		            var editor;
	
		            if (key != null) {
		                editor = EDITORS[key];
		            }
		            else if (val && val.showButton) {
		                key = "_validation_" + val.dataType;
		                editor = EDITORS[key];
		            }
	
		            if (typeof editor == "function") {
		                editor = EDITORS[key] = editor();
		            }
	
		            return editor;
		        }
		    };
	
		    registerEditor("_validation_date", function(){
		        var context, calendar, popup;
	
		        function create() {
		            if (!calendar) {
		                calendar = $("<div>").kendoCalendar();
		                popup = $("<div>").kendoPopup();
		                calendar.appendTo(popup);
		                calendar = calendar.getKendoCalendar();
		                popup = popup.getKendoPopup();
	
		                calendar.bind("change", function(){
		                    popup.close();
		                    var date = calendar.value();
		                    if (!context.range.format()) {
		                        context.range.format("yyyy-mm-dd");
		                    }
		                    context.callback(kendo.spreadsheet.dateToNumber(date));
		                });
		            }
		            popup.setOptions({
		                anchor: context.view.element.find(".k-spreadsheet-editor-button")
		            });
		        }
	
		        function open() {
		            create();
		            var date = context.range.value();
		            if (date != null) {
		                calendar.value(kendo.spreadsheet.numberToDate(date));
		            } else {
		                calendar.value(null);
		            }
		            var val = context.validation;
		            if (val) {
		                var min = kendo.ui.Calendar.fn.options.min;
		                var max = kendo.ui.Calendar.fn.options.max;
		                if (/^(?:greaterThan|between)/.test(val.comparerType)) {
		                    min = kendo.spreadsheet.numberToDate(val.from.value);
		                }
		                if (val.comparerType == "between") {
		                    max = kendo.spreadsheet.numberToDate(val.to.value);
		                }
		                if (val.comparerType == "lessThan") {
		                    max = kendo.spreadsheet.numberToDate(val.from.value);
		                }
		                calendar.setOptions({
		                    disableDates: function(date) {
		                        var from = val.from ? val.from.value|0 : 0;
		                        var to = val.to ? val.to.value|0 : 0;
		                        date = kendo.spreadsheet.dateToNumber(date) | 0;
		                        return !kendo.spreadsheet.validation
		                            .validationComparers[val.comparerType](date, from, to);
		                    },
		                    min: min,
		                    max: max
		                });
		            } else {
		                calendar.setOptions({ disableDates: null, min: null, max: null });
		            }
		            popup.open();
		        }
	
		        return {
		            edit: function(options) {
		                context = options;
		                open();
		            },
		            icon: "k-i-calendar"
		        };
		    });
	
		    registerEditor("_validation_list", function(){
		        var context, list, popup;
		        function create() {
		            if (!list) {
		                list = $("<ul class='k-list k-reset'/>").kendoStaticList({
		                    template   : "#:value#",
		                    selectable : true,
		                    autoBind   : false
		                });
		                popup = $("<div>").kendoPopup();
		                list.appendTo(popup);
		                popup = popup.getKendoPopup();
		                list = list.getKendoStaticList();
	
		                list.bind("change", function(){
		                    popup.close();
		                    var item = list.value()[0];
		                    if (item) {
		                        context.callback(item.value);
		                    }
		                });
		            }
		            popup.setOptions({
		                anchor: context.view.element.find(".k-spreadsheet-editor-button")
		            });
		        }
		        function open() {
		            create();
		            var items = context.validation.from.value;
		            var data = [], add = function(el){ data.push({ value: el }); };
		            if (items instanceof kendo.spreadsheet.calc.runtime.Matrix) {
		                items.each(add);
		            } else {
		                // actually Excel expects a simple string for list
		                // validation (comma-separated labels).
		                (items+"").split(/\s*,\s*/).forEach(add);
		            }
		            var dataSource = new kendo.data.DataSource({ data: data });
		            list.setDataSource(dataSource);
		            dataSource.read();
		            popup.open();
		        }
		        return {
		            edit: function(options) {
		                context = options;
		                open();
		            },
		            icon: "k-i-arrow-60-down"
		        };
		    });
	
		})(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1463:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(588);
	
	/***/ }),
	
	/***/ 1464:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(598);
	
	/***/ }),
	
	/***/ 1465:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(714);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1480);
		module.exports = __webpack_require__(1480);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1480:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(1481) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var CellRef = kendo.spreadsheet.CellRef;
		    var RangeRef = kendo.spreadsheet.RangeRef;
		    var UnionRef = kendo.spreadsheet.UnionRef;
	
		    var Rectangle = kendo.Class.extend({
		        init: function(left, top, width, height) {
		            this.left = left;
		            this.width = width;
		            this.right = left + width;
	
		            this.top = top;
		            this.height = height;
		            this.bottom = top + height;
		        },
	
		        offset: function(left, top) {
		            return new Rectangle(this.left + left, this.top + top, this.width, this.height);
		        },
	
		        resize: function(width, height) {
		            return new Rectangle(this.left, this.top, this.width + width, this.height + height);
		        },
	
		        intersects: function(x, y) {
		            return this.left < x && x < this.left + this.width &&
		                   this.top < y && y < this.top + this.height;
		        },
	
		        toDiv: function(className) {
		            return kendo.dom.element("div", {
		                className: className,
		                style: {
		                    width:  this.width + "px",
		                    height: this.height + "px",
		                    top:    this.top + "px",
		                    left:   this.left + "px"
		                }
		            });
		        }
		    });
	
		    var Grid = kendo.Class.extend({
		        init: function(rows, columns, rowCount, columnCount, headerHeight, headerWidth) {
		            this.rowCount = rowCount;
		            this.columnCount = columnCount;
		            this._columns = columns;
		            this._rows = rows;
		            this._headerHeight = headerHeight;
		            this._headerWidth = headerWidth;
		        },
	
		        isAxis: function(ref) {
		            ref = ref.toRangeRef();
		            var topLeft = ref.topLeft;
		            var bottomRight = ref.bottomRight;
		            return (topLeft.row === 0 && bottomRight.row === this.rowCount - 1) || (topLeft.col === 0 && bottomRight.col === this.columnCount - 1);
		        },
	
		        width: function(start, end) {
		            return this._columns.sum(start, end);
		        },
	
		        height: function(start, end) {
		            return this._rows.sum(start, end);
		        },
	
		        totalHeight: function() {
		            return this._rows.total + this._headerHeight;
		        },
	
		        totalWidth: function() {
		            return this._columns.total + this._headerWidth;
		        },
	
		        index: function(row, column) {
		            return column * this.rowCount + row;
		        },
	
		        cellRef: function(index) {
		            return new CellRef(index % this.rowCount, (index / this.rowCount) >> 0);
		        },
	
		        rowRef: function(row) {
		            return new RangeRef(new CellRef(row, 0), new CellRef(row, this.columnCount - 1));
		        },
	
		        colRef: function(col) {
		            return new RangeRef(new CellRef(0, col), new CellRef(this.rowCount - 1, col));
		        },
	
		        cellRefIndex: function(ref) {
		            return this.index(ref.row, ref.col);
		        },
	
		        normalize: function(ref) {
		            if (ref instanceof RangeRef) {
		                return new RangeRef(
		                    this.normalize(ref.topLeft),
		                    this.normalize(ref.bottomRight)
		                ).setSheet(ref.sheet, ref.hasSheet());
		            }
	
		            if (ref instanceof UnionRef) {
		                return ref.map(function(ref) {
		                    return this.normalize(ref);
		                }, this);
		            }
	
		            if (ref instanceof CellRef) {
		                ref = ref.clone();
		                ref.col = Math.max(0, Math.min(this.columnCount - 1, ref.col));
		                ref.row = Math.max(0, Math.min(this.rowCount - 1, ref.row));
		            }
	
		            return ref;
		        },
	
		        rectangle: function(ref) {
		            var topLeft = this.normalize(ref.topLeft);
		            var bottomRight = this.normalize(ref.bottomRight);
		            return new Rectangle(
		                this.width(0, topLeft.col - 1),
		                this.height(0, topLeft.row - 1),
		                this.width(topLeft.col, bottomRight.col),
		                this.height(topLeft.row, bottomRight.row)
		            );
		        },
	
		        pane: function(options) {
		            return new PaneGrid(
		                new kendo.spreadsheet.PaneAxis(this._rows, options.row, options.rowCount, this._headerHeight),
		                new kendo.spreadsheet.PaneAxis(this._columns, options.column, options.columnCount, this._headerWidth),
		                this
		            );
		        },
	
		        rangeDimensions: function(rangeRef) {
		            return {
		                rows: this._rows.values.iterator(rangeRef.topLeft.row, rangeRef.bottomRight.row),
		                columns: this._columns.values.iterator(rangeRef.topLeft.col, rangeRef.bottomRight.col)
		            };
		        },
	
		        forEach: function(ref, callback) {
		            var topLeft = this.normalize(ref.topLeft);
		            var bottomRight = this.normalize(ref.bottomRight);
	
		            for (var ci = topLeft.col; ci <= bottomRight.col; ci ++) {
		                for (var ri = topLeft.row; ri <= bottomRight.row; ri ++) {
		                    callback(new CellRef(ri, ci));
		                }
		            }
		        },
	
		        trim: function(ref, property) {
		            var topLeft = this.normalize(ref.topLeft);
		            var bottomRight = this.normalize(ref.bottomRight);
		            var bottomRightRow = topLeft.row;
		            var bottomRightCol = topLeft.col;
	
		            for (var ci = topLeft.col; ci <= bottomRight.col; ci ++) {
		                var start = this.index(topLeft.row, ci);
		                var end = this.index(bottomRight.row, ci);
		                var values = property.tree.intersecting(start, end);
		                if(values.length) {
		                    var cell = this.cellRef(values[values.length - 1].end);
		                    bottomRightRow = Math.max(bottomRightRow, cell.row);
		                    bottomRightCol = ci;
		                }
		            }
		            return new RangeRef(ref.topLeft, new CellRef(Math.min(bottomRightRow, ref.bottomRight.row), bottomRightCol));
		        }
		    });
	
		    var PaneGrid = kendo.Class.extend({
		        init: function(rows, columns, grid) {
		            this.rows = rows;
		            this.columns = columns;
		            this._grid = grid;
	
		            this.headerHeight = rows.headerSize;
		            this.headerWidth = columns.headerSize;
		            this.hasRowHeader = columns.hasHeader;
		            this.hasColumnHeader = rows.hasHeader;
		        },
	
		        refresh: function(width, height) {
		            this.columns.viewSize(width);
		            this.rows.viewSize(height);
	
		            var x = this.columns.paneSegment();
		            var y = this.rows.paneSegment();
	
		            this.left = x.offset;
		            this.top = y.offset;
		            this.right = x.offset + x.length;
		            this.bottom = y.offset + y.length;
	
		            this.style = {
		                top: y.offset  + "px",
		                left: x.offset + "px",
		                height: y.length + "px",
		                width: x.length + "px"
		            };
		        },
	
		        view: function(left, top) {
		            var rows = this.rows.visible(top);
		            var columns = this.columns.visible(left);
	
		            return {
		                rows: rows,
		                columns: columns,
	
		                rowOffset: rows.offset,
		                columnOffset: columns.offset,
	
		                mergedCellLeft: columns.start,
		                mergedCellTop: rows.start,
	
		                ref: new RangeRef(
		                    new CellRef(rows.values.start, columns.values.start),
		                    new CellRef(rows.values.end, columns.values.end)
		                )
		            };
		        },
	
		        contains: function(ref) {
		            return this.rows.contains(ref.topLeft.row, ref.bottomRight.row) &&
		                this.columns.contains(ref.topLeft.col, ref.bottomRight.col);
		        },
	
		        index: function(row, column) {
		            return this._grid.index(row, column);
		        },
	
		        boundingRectangle: function(ref) {
		            return this._grid.rectangle(ref);
		        },
	
		        cellRefIndex: function(ref) {
		            return this._grid.cellRefIndex(ref);
		        },
	
		        scrollBoundaries: function(cell) {
		            var position = this.boundingRectangle(cell);
	
		            var boundaries = {
		                top: Math.max(0, position.top - this.top + (this.hasColumnHeader ? 0 : this.headerHeight)),
		                left: Math.max(0, position.left - this.left + (this.hasRowHeader ? 0 : this.headerWidth)),
		                right: position.right - this.columns._viewSize + this.headerWidth,
		                bottom: position.bottom - this.rows._viewSize + this.headerHeight
		            };
	
		            var widthCompensation = this.columns.defaultValue / 2;
		            var heightCompensation = this.rows.defaultValue / 2;
	
		            boundaries.scrollTop = boundaries.top - heightCompensation;
		            boundaries.scrollBottom = boundaries.bottom + heightCompensation;
	
		            boundaries.scrollLeft = boundaries.left - widthCompensation;
		            boundaries.scrollRight = boundaries.right + widthCompensation;
		            return boundaries;
		        }
		    });
	
		    kendo.spreadsheet.Grid = Grid;
		    kendo.spreadsheet.PaneGrid = PaneGrid;
		    kendo.spreadsheet.Rectangle = Rectangle;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1481:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(708);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1452);
		module.exports = __webpack_require__(1452);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1452:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var Axis = kendo.Class.extend({
		        init: function(count, value) {
		            this._value = value;
		            this._count = count;
		            this.values = new kendo.spreadsheet.RangeList(0, count - 1, value);
		            this._hidden = new kendo.spreadsheet.RangeList(0, count - 1, 0);
	
		            this.scrollBarSize = kendo.support.scrollbar();
		            this._refresh();
		        },
	
		        adjust: function(start, delta) {
		            // adjust this axis for insert/remove rows/cols operation
		            if (delta < 0) {
		                // removing -- copy from start+|delta| to start
		                this.values.copy(start - delta, this._count - 1, start);
		                this._hidden.copy(start - delta, this._count - 1, start);
		            } else {
		                // adding -- copy from start to start+delta, and set
		                // values for inserted things to default.
		                this.values.copy(start, this._count, start + delta);
		                this._hidden.copy(start, this._count, start + delta);
		                this.values.value(start, start + delta - 1, this._value);
		                this._hidden.value(start, start + delta - 1, 0);
		            }
		            this._refresh();
		        },
	
		        toJSON: function(field, positions) {
		            var values = [];
	
		            var iterator = this.values.iterator(0, this._count - 1);
	
		            for (var idx = 0; idx < this._count; idx++) {
		                var value = iterator.at(idx);
		                var hidden = this._hidden.value(idx, idx);
	
		                if (value === this._value && !hidden) {
		                    continue;
		                }
	
		                var position = positions[idx];
	
		                if (position === undefined) {
		                    position = values.length;
	
		                    var item = { index: idx };
	
		                    item[field] = value;
		                    if (hidden) {
		                        item.hidden = hidden;
		                    }
	
		                    values.push(item);
	
		                    positions[idx] = position;
		                }
		            }
	
		            return values;
		        },
	
		        fromJSON: function(field, values) {
		            for (var idx = 0; idx < values.length; idx++) {
		                var el = values[idx];
	
		                var index = el.index;
		                if (index === undefined) {
		                    index = idx;
		                }
	
		                // when this particular axis is hidden, the value for
		                // the field ("height" or "width") will be zero, and
		                // in the "hidden" field we'll have the actual value
		                // before it was hidden.
		                // https://github.com/telerik/kendo-ui-core/issues/3523
		                var value = el[field];
	
		                if (value === 0) {
		                    if (el.hidden) {
		                        this.value(index, index, el.hidden);
		                    }
		                    this.hide(index);
		                } else {
		                    this.value(index, index, value);
		                }
		            }
		        },
	
		        hide: function(index) {
		            if (!this.hidden(index)) {
		                var value = this.value(index, index);
		                this._hidden.value(index, index, value);
		                this.value(index, index, 0);
		            }
		        },
	
		        hidden: function(index) {
		            return this._hidden.value(index, index) !== 0;
		        },
	
		        includesHidden: function(start, end) {
		             return this._hidden.intersecting(start, end).length > 1;
		        },
	
		        nextVisible: function(index) {
		            var end = this._count - 1, i = index;
		            while (++i <= end) {
		                if (!this.hidden(i)) {
		                    return i;
		                }
		            }
		            return index;
		        },
	
		        nextPage: function(index, pageSize) {
		            return this.index(this.sum(0, index - 1) + pageSize);
		        },
	
		        prevPage: function(index, pageSize) {
		            return this.index(this.sum(0, index) - pageSize);
		        },
	
		        firstVisible: function() {
		            var firstHidden = this._hidden.first();
		            if (firstHidden.value === 0) {
		                return 0;
		            } else {
		                return firstHidden.end + 1;
		            }
		        },
	
		        lastVisible: function() {
		            var lastHidden = this._hidden.last();
		            if (lastHidden.value === 0) {
		                return this._count - 1;
		            } else {
		                return lastHidden.start - 1;
		            }
		        },
	
		        prevVisible: function(index) {
		            var i = index;
		            while (--i >= 0) {
		                if (!this.hidden(i)) {
		                    return i;
		                }
		            }
		            return index;
		        },
	
		        unhide: function(index) {
		            if (this.hidden(index)) {
		                var value = this._hidden.value(index, index);
		                this._hidden.value(index, index, 0);
		                this.value(index, index, value);
		            }
		        },
	
		        value: function(start, end, value) {
		            if (value !== undefined) {
		                this.values.value(start, end, value);
		                this._refresh();
		            } else {
		                return this.values.iterator(start, end).at(0);
		            }
		        },
	
		        sum: function(start, end) {
		            var values = this.values.iterator(start, end);
	
		            var sum = 0;
	
		            for (var idx = start; idx <= end; idx ++) {
		                sum += values.at(idx);
		            }
	
		            return sum;
		        },
	
		        locate: function(start, end, predicate) {
		            var values = this.values.iterator(start, end);
		            var sum = 0;
		            for (var idx = start; idx <= end; idx++) {
		                sum += values.at(idx);
		                var val = predicate(sum);
		                if (val) {
		                    return idx;
		                }
		            }
		            return null;
		        },
	
		        visible: function(start, end) {
		            var startSegment = null;
		            var endSegment = null;
		            var lastPage = false;
	
		            if (end >= this.total + this.scrollBarSize) {
		                lastPage = true;
		            }
	
		            var ranges = this._pixelValues.intersecting(start, end);
	
		            startSegment = ranges[0];
		            endSegment = ranges[ranges.length - 1];
	
		            if (!startSegment) {
		                return { values: this.values.iterator(0, 0), offset: 0 };
		            }
	
		            var startOffset = start - startSegment.start;
	
		            var startIndex = ((startOffset / startSegment.value.value) >> 0) + startSegment.value.start;
	
		            var offset = startOffset - (startIndex - startSegment.value.start) * startSegment.value.value;
	
		            var endOffset = end - endSegment.start;
		            var endIndex = ((endOffset / endSegment.value.value) >> 0) + endSegment.value.start;
	
		            if (endIndex > endSegment.value.end) {
		                endIndex = endSegment.value.end;
		            }
	
		            if (lastPage) {
		                offset += endSegment.value.value - (endOffset - (endIndex - endSegment.value.start) * endSegment.value.value);
		            }
	
		            offset = Math.min(-offset, 0);
	
		            return {
		                values: this.values.iterator(startIndex, endIndex),
		                offset: offset
		            };
		        },
	
		        index: function(value) {
		            var index = 0;
		            var iterator = this.values.iterator(0, this._count - 1);
		            var current = iterator.at(0);
	
		            while (current < value && index < this._count - 1) {
		                current += iterator.at(++index);
		            }
	
		            return index;
		        },
	
		        indexVisible: function(value) {
		            var index = this.index(value);
		            if (this.hidden(index)) {
		                index = this.prevVisible(index);
		            }
		            return index;
		        },
	
		        _refresh: function() {
		            var current = 0;
		            this._pixelValues = this.values.map(function(range) {
		                var start = current;
	
		                current += (range.end - range.start + 1) * range.value;
	
		                var end = current - 1;
	
		                return new kendo.spreadsheet.ValueRange(start, end, range);
		            });
	
		            this.total = current;
		        },
	
		        getState: function() {
		            return {
		                values: this.values.getState(),
		                hidden: this._hidden.getState()
		            };
		        },
	
		        setState: function(state) {
		            this.values.setState(state.values);
		            this._hidden.setState(state.hidden);
		            this._refresh();
		        }
		    });
	
		    var PaneAxis = kendo.Class.extend({
		        init: function(axis, start, count, headerSize) {
		           this._axis = axis;
		           this._start = start;
		           this._count = count;
		           this.hasHeader = start === 0;
		           this.headerSize = headerSize;
		           this.defaultValue = axis._value;
		           this.frozen = count > 0;
		        },
	
		        viewSize: function(viewSize) {
		            this._viewSize = viewSize;
		        },
	
		        sum: function(start, end) {
		            return this._axis.sum(start, end - 1);
		        },
	
		        start: function() {
		            return this.sum(0, this._start);
		        },
	
		        size: function() {
		            return this.sum(this._start, this._start + this._count);
		        },
	
		        index: function(value, offset) {
		            return this._axis.index(value + (this.frozen ? 0 : offset) - this.headerSize);
		        },
	
		        indexVisible: function(value, offset) {
		            return this._axis.indexVisible(value + (this.frozen ? 0 : offset) - this.headerSize);
		        },
	
		        //XXX: rename this method
		        paneSegment: function() {
		            var offset = this.start();
		            var length;
	
		            if (!this.hasHeader) {
		                offset += this.headerSize;
		            }
	
		            if (this.frozen) {
		                length = this.size();
		                if (this.hasHeader) {
		                    length += this.headerSize;
		                } else {
		                    length -= this.headerSize;
		                }
		            } else {
		                length = this._viewSize - offset;
		            }
	
		            return {
		                offset: offset,
		                length: length
		            };
		        },
	
		        visible: function(offset) {
		            var start = this.start();
		            var size;
	
		            if (this.frozen) {
		                size = this.size();
		                if (!this.hasHeader) {
		                    size -= this.headerSize;
		                }
		            } else {
		                size = this._viewSize - start - this.headerSize;
		                start += offset;
		            }
	
		            var result = this._axis.visible(start, start + size - 1);
	
		            if (this.frozen) {
		                result.offset = 0;
		            }
	
		            result.start = start;
	
		            if (this.hasHeader) {
		                result.offset += this.headerSize;
		                result.start -= this.headerSize;
		            }
	
		            return result;
		        },
	
		        contains: function(start, end) {
		            if (this.frozen) {
		                if (start > this._start + this._count) {
		                    return false;
		                }
		                if (end < this._start) {
		                    return false;
		                }
		                return true;
		            } else {
		                return end >= this._start;
		            }
		        }
		    });
	
		    kendo.spreadsheet.Axis = Axis;
		    kendo.spreadsheet.PaneAxis = PaneAxis;
	
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1472);
		module.exports = __webpack_require__(1472);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1472:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(5) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    /*jshint evil: true */
		    var Filter = kendo.spreadsheet.Filter = kendo.Class.extend({
		        prepare: function() {
		        },
		        value: function(cell) {
		            return cell.value;
		        },
		        matches: function() {
		            throw new Error("The 'matches' method is not implemented.");
		        },
		        toJSON: function() {
		            throw new Error("The 'toJSON' method is not implemented.");
		        }
		    });
	
		    Filter.create = function(options) {
		        var filter = options.filter;
	
		        if (!filter) {
		            throw new Error("Filter type not specified.");
		        }
	
		        var constructor = kendo.spreadsheet[filter.charAt(0).toUpperCase() + filter.substring(1) + "Filter"];
	
		        if (!constructor) {
		            throw new Error("Filter type not recognized.");
		        }
	
		        return new constructor(options);
		    };
	
		    kendo.spreadsheet.ValueFilter = Filter.extend({
		        _values: [],
	
		        _dates: [],
	
		        _blanks: false,
	
		        init: function ValueFilter(options) {
		            if (options.values !== undefined) {
		                this._values = options.values;
		            }
	
		            if (options.blanks !== undefined) {
		                this._blanks = options.blanks;
		            }
	
		            if (options.dates !== undefined) {
		                this._dates = options.dates;
		            }
		        },
	
		        value: function(cell) {
		            var value = cell.value;
	
		            if (this._dates.length > 0 && cell.format && typeof value === "number") {
		                var type = kendo.spreadsheet.formatting.type(value, cell.format);
	
		                if (type === "date") {
		                    value = kendo.spreadsheet.numberToDate(value);
		                }
		            }
	
		            return value;
		        },
	
		        matches: function(value) {
		            if (value === null || value === undefined) {
		                return this._blanks;
		            }
	
		            if (value instanceof Date) {
		                return this._dates.some(function(date) {
		                    return date.year === value.getFullYear() &&
		                        (date.month === undefined || date.month === value.getMonth()) &&
		                        (date.day === undefined || date.day === value.getDate()) &&
		                        (date.hours === undefined || date.hours === value.getHours()) &&
		                        (date.minutes === undefined || date.minutes === value.getMinutes()) &&
		                        (date.seconds === undefined || date.seconds === value.getSeconds());
		                });
		            }
	
		            return this._values.indexOf(value) >= 0;
		        },
		        toJSON: function() {
		            return {
		                filter: "value",
		                blanks: this._blanks,
		                values: this._values.slice(0)
		            };
		        }
		    });
	
		    kendo.spreadsheet.CustomFilter = Filter.extend({
		        _logic: "and",
		        init: function CustomFilter(options) {
		            if (options.logic !== undefined) {
		                this._logic = options.logic;
		            }
	
		            if (options.criteria === undefined) {
		                throw new Error("Must specify criteria.");
		            }
	
		            this._criteria = options.criteria;
	
		            var expression = kendo.data.Query.filterExpr({
		                logic: this._logic,
		                filters: this._criteria
		            }).expression;
	
		            this._matches = new Function("d", "return " + expression);
		        },
		        matches: function(value) {
		            if (value === null) {
		                return false;
		            }
	
		            return this._matches(value);
		        },
		        value: function(cell) {
		            var value = cell.value;
		            var criterionValue = this._criteria[0].value;
		            var criterionType = criterionValue instanceof Date ? "date" : typeof criterionValue;
		            var valueType = typeof value;
	
		            if (cell.format) {
		                valueType = kendo.spreadsheet.formatting.type(value, cell.format);
		            }
	
		            if (valueType != criterionType) {
		                if (criterionType == "string") {
		                    if (cell.format) {
		                        value = kendo.spreadsheet.formatting.text(value, cell.format);
		                    }
		                    value = value + "";
		                }
		            } else if (valueType == "date") {
		                value = kendo.spreadsheet.numberToDate(value);
		            }
	
		            return value;
		        },
		        toJSON: function() {
		            return {
		                filter: "custom",
		                logic: this._logic,
		                criteria: this._criteria
		            };
		        }
		    });
	
		    kendo.spreadsheet.TopFilter = Filter.extend({
		        init: function TopFilter(options) {
		            this._type = options.type;
		            this._value = options.value;
		            this._values = [];
		        },
	
		        prepare: function(cells) {
		            var values = cells.map(this.value)
		            .sort()
		            .filter(function(value, index, array) {
		                return index === 0 || value !== array[index - 1];
		            });
	
		            if (this._type === "topNumber" || this._type == "topPercent") {
		                values.sort(function(x, y) {
		                    return y - x;
		                });
		            } else {
		                values.sort(function(x, y) {
		                    return x - y;
		                });
		            }
	
		            var count = this._value;
	
		            if (this._type === "topPercent" || this._type === "bottomPercent") {
		                count = (values.length * count / 100) >> 0;
		            }
	
		            this._values = values.slice(0, count);
		        },
		        matches: function(value) {
		            return this._values.indexOf(value) >= 0;
		        },
		        toJSON: function() {
		            return {
		                filter: "top",
		                type: this._type,
		                value: this._value
		            };
		        }
		    });
	
		    kendo.spreadsheet.DynamicFilter = Filter.extend({
		        init: function DynamicFilter(options) {
		            this._type = options.type;
	
		            this._predicate = this[options.type];
	
		            if (typeof this._predicate !== "function") {
		                throw new Error("DynamicFilter type '" + options.type + "' not recognized.");
		            }
		        },
		        value: function(cell) {
		            var value = cell.value;
	
		            if (cell.format) {
		                var type = kendo.spreadsheet.formatting.type(value, cell.format);
	
		                if (type === "date") {
		                    value = kendo.spreadsheet.numberToDate(value);
		                }
		            }
	
		            return value;
		        },
		        prepare: function(cells) {
		            var sum = 0;
		            var count = 0;
	
		            for (var ci = 0; ci < cells.length; ci++) {
		                var value = this.value(cells[ci]);
	
		                if (typeof value === "number") {
		                    sum += value;
		                    count ++;
		                }
		            }
	
		            if (count > 0) {
		                this._average = sum / count;
		            } else {
		                this._average = 0;
		            }
		        },
		        matches: function(value) {
		            return this._predicate(value);
		        },
		        aboveAverage: function(value) {
		            if (value instanceof Date) {
		                value = kendo.spreadsheet.dateToNumber(value);
		            }
	
		            if (typeof value !== "number") {
		                return false;
		            }
	
		            return value > this._average;
		        },
		        belowAverage: function(value) {
		            if (value instanceof Date) {
		                value = kendo.spreadsheet.dateToNumber(value);
		            }
	
		            if (typeof value !== "number") {
		                return false;
		            }
	
		            return value < this._average;
		        },
		        tomorrow: function(value) {
		            if (value instanceof Date) {
		                var tomorrow = kendo.date.addDays(kendo.date.today(), 1);
	
		                return kendo.date.getDate(value).getTime() === tomorrow.getTime();
		            }
	
		            return false;
		        },
		        today: function(value) {
		            if (value instanceof Date) {
		                return kendo.date.isToday(value);
		            }
	
		            return false;
		        },
		        yesterday: function(value) {
		            if (value instanceof Date) {
		                var yesterday = kendo.date.addDays(kendo.date.today(), -1);
	
		                return kendo.date.getDate(value).getTime() === yesterday.getTime();
		            }
	
		            return false;
		        },
		        nextWeek: function(value) {
		            return sameWeek(kendo.date.addDays(kendo.date.today(), 7), value);
		        },
		        thisWeek: function(value) {
		            return sameWeek(kendo.date.today(), value);
		        },
		        lastWeek: function(value) {
		            return sameWeek(kendo.date.addDays(kendo.date.today(), -7), value);
		        },
		        nextMonth: function(value) {
		            return sameMonth(value, 1);
		        },
		        thisMonth: function(value) {
		            return sameMonth(value, 0);
		        },
		        lastMonth: function(value) {
		            return sameMonth(value, -1);
		        },
		        nextQuarter: function(value) {
		            if (value instanceof Date) {
		                var today = kendo.date.today();
	
		                var diff = quarter(value) - quarter(today);
	
		                return (diff === 1 && today.getFullYear() === value.getFullYear()) ||
		                       (diff == -3 && today.getFullYear() + 1 === value.getFullYear());
		            }
	
		            return false;
		        },
		        thisQuarter: function(value) {
		            if (value instanceof Date) {
		                var today = kendo.date.today();
	
		                var diff = quarter(value) - quarter(today);
	
		                return diff === 0 && today.getFullYear() === value.getFullYear();
		            }
	
		            return false;
		        },
		        lastQuarter: function(value) {
		            if (value instanceof Date) {
		                var today = kendo.date.today();
	
		                var diff = quarter(today) - quarter(value);
	
		                return (diff === 1 && today.getFullYear() === value.getFullYear()) ||
		                       (diff == -3 && today.getFullYear() - 1 === value.getFullYear());
		            }
	
		            return false;
		        },
		        nextYear: function(value) {
		            return sameYear(value, 1);
		        },
		        thisYear: function(value) {
		            return sameYear(value, 0);
		        },
		        lastYear: function(value) {
		            return sameYear(value, -1);
		        },
		        yearToDate: function(value) {
		            if (value instanceof Date) {
		                var today = kendo.date.today();
	
		                return value.getFullYear() === today.getFullYear() && value <= today;
		            }
	
		            return false;
		        },
		        toJSON: function() {
		            return {
		                filter: "dynamic",
		                type: this._type
		            };
		        }
		    });
	
		    [1, 2, 3, 4].forEach(function(target) {
		        kendo.spreadsheet.DynamicFilter.prototype["quarter" + target] = function(value) {
		           if (value instanceof Date) {
		              return quarter(value) === target;
		           }
	
		           return false;
		        };
		    });
	
		    kendo.cultures["en-US"].calendar.months.names.forEach(function(month, index) {
		        kendo.spreadsheet.DynamicFilter.prototype[month.toLowerCase()] = function(value) {
		           if (value instanceof Date) {
		               return value.getMonth() === index;
		           }
	
		           return false;
		        };
		    });
	
		    function quarter(value) {
		        var month = value.getMonth() + 1;
	
		        if (month >= 1 && month <= 3) {
		            return 1;
		        } else if(month >= 4 && month <= 6) {
		            return 2;
		        } else if (month >= 7 && month <= 9) {
		            return 3;
		        } else {
		            return 4;
		        }
		    }
	
		    function sameYear(value, offset) {
		        if (value instanceof Date) {
		            var today = kendo.date.today();
	
		            today.setFullYear(today.getFullYear() + offset);
	
		            return today.getFullYear() === value.getFullYear();
		        }
	
		        return false;
		    }
	
		    function sameMonth(value, offset) {
		        if (value instanceof Date) {
		            var today = kendo.date.firstDayOfMonth(kendo.date.today());
	
		            today.setMonth(today.getMonth() + offset, 1);
	
		            return today.getTime() === kendo.date.firstDayOfMonth(value).getTime();
		        }
	
		        return false;
		    }
	
		    function sameWeek(a, b) {
		        if (b instanceof Date) {
		            var firstWeek = kendo.date.dayOfWeek(kendo.date.getDate(a), 1);
	
		            var secondWeek = kendo.date.dayOfWeek(kendo.date.getDate(b), 1);
	
		            return firstWeek.getTime() === secondWeek.getTime();
		        }
	
		        return false;
		    }
	
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1503);
		module.exports = __webpack_require__(1503);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1503:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var Sorter = kendo.Class.extend({
		        init: function(grid, lists) {
		            this._grid = grid;
		            this._lists = lists;
		        },
	
		        indices: function(rangeRef, list, ascending, indices) {
		            var comparer = Sorter.ascendingComparer;
	
		            if (ascending === false) {
		                comparer = Sorter.descendingComparer;
		            }
	
		            return list.sortedIndices(this._grid.cellRefIndex(rangeRef.topLeft),
		                this._grid.cellRefIndex(rangeRef.bottomRight), comparer, indices);
		        },
	
		        sortBy: function(ref, column, list, ascending, indices) {
		            var sortedIndices = this.indices(ref.toColumn(column), list, ascending, indices);
	
		            for (var ci = ref.topLeft.col; ci <= ref.bottomRight.col; ci++) {
		                var start = this._grid.index(ref.topLeft.row, ci);
		                var end = this._grid.index(ref.bottomRight.row, ci);
	
		                for (var li = 0; li < this._lists.length; li++) {
		                    if (start < this._lists[li].lastRangeStart()) {
		                        this._lists[li].sort(start, end, sortedIndices);
		                    }
		                }
		            }
	
		            return sortedIndices;
		        }
		    });
	
		    Sorter.ascendingComparer = function(a, b) {
		        if (a === null && b === null) {
		            return 0;
		        }
	
		        if (a === null) {
		            return 1;
		        }
	
		        if (b === null) {
		            return -1;
		        }
	
		        var typeA = typeof a;
		        var typeB = typeof b;
	
		        if (typeA === "number") {
		            if (typeB === "number") {
		                return a - b;
		            } else {
		               return -1;
		            }
		        }
	
		        if (typeA === "string") {
		            switch (typeB) {
		                case "number":
		                    return 1;
		                case "string":
		                    return a.localeCompare(b);
		                default:
		                    return -1;
		            }
		        }
	
		        if (typeA === "boolean") {
		            switch (typeB) {
		                case "number":
		                    return 1;
		                case "string":
		                    return 1;
		                case "boolean":
		                    return a - b;
		                default:
		                    return -1;
		            }
		        }
	
		        if (a instanceof kendo.spreadsheet.calc.runtime.CalcError) {
		            if (b instanceof kendo.spreadsheet.calc.runtime.CalcError) {
		                return 0;
		            } else {
		                return 1;
		            }
		        }
	
		        throw new Error("Cannot compare " + a + " and " + b);
		    };
	
		    Sorter.descendingComparer = function(a, b) {
		        if (a === null && b === null) {
		            return 0;
		        }
	
		        if (a === null) {
		            return 1;
		        }
	
		        if (b === null) {
		            return -1;
		        }
	
		        return Sorter.ascendingComparer(b, a);
		    };
	
		    kendo.spreadsheet.Sorter = Sorter;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1485);
		module.exports = __webpack_require__(1485);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1471:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(719);
	
	/***/ }),
	
	/***/ 1485:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1471), __webpack_require__(1486), __webpack_require__(1487) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /* jshint eqnull:true, newcap:false, laxbreak:true, shadow:true, -W054 */
		    /* jshint latedef: nofunc */
	
		    var util = kendo.util;
		    var calc = kendo.spreadsheet.calc;
		    var dom = kendo.dom;
	
		    var RX_COLORS = /^\[(black|green|white|blue|magenta|yellow|cyan|red)\]/i;
		    var RX_CONDITION = /^\[(<=|>=|<>|<|>|=)(-?[0-9.]+)\]/;
	
		    /* The proper amount of suffering for whoever designed the Excel
		       Custom Number Format would be to have him implement the
		       formatter himself. */
	
		    function parse(input) {
		        input = calc.InputStream(input);
		        var sections = [], haveConditional = false, decimalPart;
	
		        while (!input.eof()) {
		            var sec = readSection();
		            sections.push(sec);
		            if (sec.cond) {
		                haveConditional = true;
		            }
		        }
	
		        // From https://support.office.com/en-us/article/Create-or-delete-a-custom-number-format-78f2a361-936b-4c03-8772-09fab54be7f4:
		        //
		        //    A number format can have up to four sections of code, separated by semicolons. These
		        //    code sections define the format for positive numbers, negative numbers, zero values,
		        //    and text, in that order.
		        //
		        //    You do not have to include all code sections in your custom number format. If you
		        //    specify only two code sections for your custom number format, the first section is
		        //    used for positive numbers and zeros, and the second section is used for negative
		        //    numbers. If you specify only one code section, it is used for all numbers. If you want
		        //    to skip a code section and include a code section that follows it, you must include
		        //    the ending semicolon for the section that you skip.
		        //
		        // However, if sections have conditionals, it is not clear if:
		        //
		        //    - still at most four are allowed
		        //    - is the last section still for text
		        //
		        // We will assume that if no sections have conditionals, then there must be at most 4, and
		        // they will be interpreted in the order above.  If the first section contains a
		        // conditional, then there can be any number of them; if the last one is not conditional
		        // then it will be interpreted as text format.
	
		        if (!haveConditional) {
		            if (sections.length == 1) {
		                sections[0].cond = "num";
		            }
		            else if (sections.length == 2) {
		                sections[0].cond = { op: ">=", value: 0 };
		                sections[1].cond = { op: "<", value: 0 };
		            }
		            else if (sections.length >= 3) {
		                sections[0].cond = { op: ">", value: 0 };
		                sections[1].cond = { op: "<", value: 0 };
		                sections[2].cond = { op: "=", value: 0 };
		                if (sections.length > 3) {
		                    sections[3].cond = "text";
		                    sections = sections.slice(0, 4);
		                }
		            }
		        }
	
		        return sections;
	
		        function maybeColor() {
		            var m = input.skip(RX_COLORS);
		            if (m) {
		                return m[1].toLowerCase();
		            }
		        }
	
		        function maybeCondition() {
		            var m = input.skip(RX_CONDITION);
		            if (m) {
		                var val = parseFloat(m[2]);
		                if (!isNaN(val)) {
		                    return { op: m[1], value: val };
		                }
		            }
		        }
	
		        function readFormat() {
		            var format = [], tok, prev = null;
		            while (!input.eof() && (tok = readNext())) {
		                // disambiguate: m/mm might mean month or minutes depending on surrounding context.
		                if (tok.type == "date") {
		                    if (prev && /^(el)?time$/.test(prev.type) && prev.part == "h"
		                        && tok.part == "m" && tok.format < 3) {
		                        // m or mm that follows hours should display minutes
		                        tok.type = "time";
		                    }
		                } else if (/^(el)?time$/.test(tok.type) && tok.part == "s") {
		                    if (prev && prev.type == "date" && prev.part == "m"
		                        && prev.format < 3) {
		                        // m or mm followed by seconds should display minutes
		                        prev.type = "time";
		                    }
		                }
		                if (!(/^(?:str|space|fill)$/.test(tok.type))) {
		                    prev = tok;
		                }
		                format.push(tok);
		            }
		            return format;
		        }
	
		        function maybeFraction(tok) {
		            if (tok.type != "date" || (tok.part == "m" && tok.format < 3)) {
		                var m = input.skip(/^\.(0+)/);
		                if (m) {
		                    tok.fraction = m[1].length;
		                    if (tok.type == "date") {
		                        tok.type = "time";
		                    }
		                }
		            }
		            return tok;
		        }
	
		        function readNext() {
		            var ch, m;
		            // numbers
		            if ((m = input.skip(/^([#0?]+)(?:,([#0?]+))+/))) {
		                // thousands separator.  seems convenient to treat
		                // this as a single token.
		                return { type: "digit", sep: true, format: m[1] + m[2], decimal: decimalPart };
		            }
		            if ((m = input.skip(/^[#0?]+/))) {
		                return { type: "digit", sep: false, format: m[0], decimal: decimalPart };
		            }
		            // XXX: handle this one!
		            if ((m = input.skip(/^(e)([+-])/i))) {
		                return { type: "exp", ch: m[1], sign: m[2] };
		            }
		            // dates
		            if ((m = input.skip(/^(d{1,4}|m{1,5}|yyyy|yy)/i))) {
		                m = m[1].toLowerCase();
		                return maybeFraction({ type: "date", part: m.charAt(0), format: m.length });
		            }
		            // time (interpret as a date)
		            if ((m = input.skip(/^(hh?|ss?)/i))) { // m and mm are handled above
		                m = m[1].toLowerCase();
		                return maybeFraction({ type: "time", part: m.charAt(0), format: m.length });
		            }
		            // elapsed time (interpret as interval of days)
		            if ((m = input.skip(/^\[(hh?|mm?|ss?)\]/i))) {
		                m = m[1].toLowerCase();
		                return maybeFraction({ type: "eltime", part: m.charAt(0), format: m.length });
		            }
		            if ((m = input.skip(/^(a[.]?m[.]?\/p[.]?m[.]?|a\/p)/i))) {
		                m = m[1].split("/");
		                return { type: "ampm", am: m[0], pm: m[1] };
		            }
		            switch ((ch = input.next())) { // JSHint sadness
		              case ";":
		                return null;
		              case "\\":
		                // quotes next character
		                return { type: "str", value: input.next() };
		              case '"':
		                return { type: "str", value: input.readEscaped(ch) };
		              case "@":
		                return { type: "text" };
		              case "_":
		                // whitespace of the width of following character
		                return { type: "space", value: input.next() };
		              case "*":
		                // fills cell width with the following character
		                return { type: "fill", value: input.next() };
		              case ".":
		                if (input.lookingAt(/^\s*[#0?]/)) {
		                    decimalPart = true;
		                    return { type: "dec" };
		                }
		                return { type: "str", value: "." };
		              case "%":
		                return { type: "percent" };
		              case ",":
		                return { type: "comma" };
		            }
	
		            // whatever we can't make sense of, output literally.
		            return { type: "str", value: ch };
		        }
	
		        function readSection() {
		            decimalPart = false;
		            var color = maybeColor(), cond = maybeCondition();
		            if (!color && cond) {
		                color = maybeColor();
		            }
		            return {
		                color : color,
		                cond  : cond,
		                body  : readFormat()
		            };
		        }
		    }
	
		    function print(sections) {
		        return sections.map(printSection).join(";");
	
		        function printSection(sec) {
		            var out = "";
		            if (sec.color) {
		                out += "[" + sec.color + "]";
		            }
		            if (sec.cond) {
		                if (!(sec.cond == "text" || sec.cond == "num")) {
		                    out += "[" + sec.cond.op + sec.cond.value + "]";
		                }
		            }
		            out += sec.body.map(printToken).join("");
		            return out;
		        }
	
		        function maybeFraction(fmt, tok) {
		            if (tok.fraction) {
		                fmt += "." + padLeft("", tok.fraction, "0");
		            }
		            return fmt;
		        }
	
		        function printToken(tok) {
		            if (tok.type == "digit") {
		                if (tok.sep) {
		                    return tok.format.charAt(0) + "," + tok.format.substr(1);
		                } else {
		                    return tok.format;
		                }
		            }
		            else if (tok.type == "exp") {
		                return tok.ch + tok.sign;
		            }
		            else if (tok.type == "date" || tok.type == "time") {
		                return maybeFraction(padLeft("", tok.format, tok.part), tok);
		            }
		            else if (tok.type == "eltime") {
		                return maybeFraction("[" + padLeft("", tok.format, tok.part) + "]", tok);
		            }
		            else if (tok.type == "ampm") {
		                return tok.am + "/" + tok.pm;
		            }
		            else if (tok.type == "str") {
		                return JSON.stringify(tok.value);
		            }
		            else if (tok.type == "text") {
		                return "@";
		            }
		            else if (tok.type == "space") {
		                return "_" + tok.value;
		            }
		            else if (tok.type == "fill") {
		                return "*" + tok.value;
		            }
		            else if (tok.type == "dec") {
		                return ".";
		            }
		            else if (tok.type == "percent") {
		                return "%";
		            }
		            else if (tok.type == "comma") {
		                return ",";
		            }
		        }
		    }
	
		    function adjustDecimals(sections, x) {
		        sections.forEach(function(sec) {
		            var diff = x;
		            if (sec.cond == "text") {
		                return;
		            }
		            var body = sec.body, adjusted = false, i = body.length;
		            while (diff !== 0 && --i >= 0) {
		                var tok = body[i];
		                if (tok.type == "digit") {
		                    if (tok.decimal) {
		                        adjusted = true;
		                        if (diff > 0) {
		                            tok.format += padLeft("", diff, "0");
		                        } else if (diff < 0) {
		                            var tmp = tok.format.length;
		                            tok.format = tok.format.substr(0, tmp + diff);
		                            diff += tmp - tok.format.length;
		                        }
		                        if (tok.format.length === 0) {
		                            body.splice(i, 1);
		                            while (--i >= 0) {
		                                tok = body[i];
		                                if (tok.type == "digit" && tok.decimal) {
		                                    ++i;
		                                    break;
		                                }
		                                if (tok.type == "dec") {
		                                    body.splice(i, 1);
		                                    break;
		                                }
		                            }
		                        }
		                    }
		                    if (diff > 0) {
		                        break;
		                    }
		                }
		            }
		            if (!adjusted && diff > 0) {
		                // no decimal part was found, insert one after the last digit token.
		                body.splice(
		                    i + 1, 0, {
		                        type    : "dec"
		                    }, {
		                        type    : "digit",
		                        sep     : false,
		                        decimal : true,
		                        format  : padLeft("", diff, "0")
		                    }
		                );
		            }
		        });
		    }
	
		    function TokenStream(parts) {
		        var index = 0;
		        return {
		            next: function() {
		                return parts[index++];
		            },
		            eof: function() {
		                return index >= parts.length;
		            },
		            ahead: function(n, f) {
		                if (index + n <= parts.length) {
		                    var val = f.apply(null, parts.slice(index, index + n));
		                    if (val) {
		                        index += n;
		                    }
		                    return val;
		                }
		            },
		            restart: function() {
		                index = 0;
		            }
		        };
		    }
	
		    function compileFormatPart(format) {
		        var input = TokenStream(format.body);
		        var hasDate = false;
		        var hasTime = false;
		        var hasAmpm = false;
		        var percentCount = 0;
		        var currency = /[\$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/;
		        var scaleCount = 0;
		        var code = "";
		        var separeThousands = false;
		        var declen = 0;
		        var intFormat = [], decFormat = [];
		        var condition = format.cond;
		        var preamble = "";
	
		        if (condition == "text") {
		            preamble = "if (typeof value == 'string' || value instanceof kendo.spreadsheet.CalcError) { ";
		        }
		        else if (condition == "num") {
		            preamble = "if (typeof value == 'number') { ";
		        }
		        else if (condition) {
		            var op = condition.op == "=" ? "==" : condition.op;
		            preamble = "if (typeof value == 'number' && value "
		                + op + " " + condition.value + ") { ";
		            code += "value = Math.abs(value); ";
		        }
	
		        if (format.color) {
		            code += "result.color = " + JSON.stringify(format.color) + "; ";
		        }
	
		        function checkComma(a, b) {
		            if ((a.type == "digit" && b.type == "comma") ||
		                (a.type == "comma" && a.hidden && b.type == "comma"))
		            {
		                b.hidden = true;
		                scaleCount++;
		            }
		        }
	
		        while (!input.eof()) {
		            input.ahead(2, checkComma);
		            var tok = input.next();
		            if (tok.type == "percent") {
		                percentCount++;
		            }
		            else if (tok.type == "digit") {
		                if (tok.decimal) {
		                    declen += tok.format.length;
		                    decFormat.push(tok.format);
		                } else {
		                    intFormat.push(tok.format);
		                    if (tok.sep) {
		                        separeThousands = true;
		                    }
		                }
		            }
		            else if (tok.type == "time") {
		                hasTime = true;
		            }
		            else if (tok.type == "date") {
		                hasDate = true;
		            }
		            else if (tok.type == "ampm") {
		                hasAmpm = hasTime = true;
		            }
		        }
	
		        if (percentCount > 0) {
		            code += "value *= " + Math.pow(100, percentCount) + "; ";
		        }
		        if (scaleCount > 0) {
		            code += "value /= " + Math.pow(1000, scaleCount) + "; ";
		        }
		        if (intFormat.length) {
		            code += "var intPart = runtime.formatInt(culture, value, " + JSON.stringify(intFormat) + ", " + declen + ", " + separeThousands + "); ";
		            code += "var isNegative = parseInt(intPart[0]) < 0;";
		        }
		        if (decFormat.length) {
		            code += "var decPart = runtime.formatDec(value, " + JSON.stringify(decFormat) + ", " + declen + "); ";
		        }
		        if (intFormat.length || decFormat.length) {
		            code += "type = 'number'; ";
		        }
		        if (hasDate) {
		            code += "var date = runtime.unpackDate(value); ";
		        }
		        if (hasTime) {
		            code += "var time = runtime.unpackTime(value); ";
		        }
		        if (hasDate || hasTime) {
		            code += "type = 'date'; ";
		        }
	
		        if (percentCount > 0 || scaleCount > 0 || intFormat.length || decFormat.length || hasDate || hasTime) {
		            if (!preamble) {
		                preamble = "if (typeof value == 'number') { ";
		            }
		        }
	
		        input.restart();
		        code += "var matchedCurrency = false;";
		        while (!input.eof()) {
		            var tok = input.next();
		            if (tok.type == "dec") {
		                code += "output += culture.numberFormat['.']; ";
		            }
		            else if (tok.type == "comma" && !tok.hidden) {
		                code += "output += ','; ";
		            }
		            else if (tok.type == "percent") {
		                code += "type = 'percent'; ";
		                code += "output += culture.numberFormat.percent.symbol; ";
		            }
		            else if (tok.type == "str") {
		                if (currency.test(tok.value)) {
		                    code += "type = 'currency'; ";
		                    code += "if (isNegative) { output += '-'; matchedCurrency = true; }";
		                }
		                code += "output += " + JSON.stringify(tok.value) + "; ";
		            }
		            else if (tok.type == "text") {
		                code += "type = 'text'; ";
		                code += "output += value; ";
		            }
		            else if (tok.type == "space") {
		                code += "if (output) result.body.push(output); ";
		                code += "output = ''; ";
		                code += "result.body.push({ type: 'space', value: " + JSON.stringify(tok.value) + " }); ";
		            }
		            else if (tok.type == "fill") {
		                code += "output += runtime.fill(" + JSON.stringify(tok.value) + "); ";
		            }
		            else if (tok.type == "digit") {
		                code += "if (isNegative && intPart[0] && matchedCurrency) {intPart[0] = intPart[0].replace('-', '');}";
		                code += "output += " + (tok.decimal ? "decPart" : "intPart") + ".shift(); ";
		            }
		            else if (tok.type == "date") {
		                code += "output += runtime.date(culture, date, "
		                    + JSON.stringify(tok.part) + ", " + tok.format + "); ";
		            }
		            else if (tok.type == "time") {
		                code += "output += runtime.time(time, "
		                    + JSON.stringify(tok.part) + ", " + tok.format + ", " + hasAmpm + ", " + tok.fraction + "); ";
		            }
		            else if (tok.type == "eltime") {
		                code += "output += runtime.eltime(value, "
		                    + JSON.stringify(tok.part) + ", " + tok.format + ", " + tok.fraction + "); ";
		            }
		            else if (tok.type == "ampm") {
		                // XXX: should use culture?  As per the "spec", Excel
		                // displays whatever the token was (AM/PM, a/p etc.)
		                code += "output += time.hours < 12 ? " + JSON.stringify(tok.am) + " : " + JSON.stringify(tok.pm) + "; ";
		            }
		        }
	
		        code += "if (output) result.body.push(output); ";
		        code += "result.type = type; ";
		        code += "return result; ";
	
		        if (preamble) {
		            code = preamble + code + "}";
		        }
	
		        return code;
		    }
	
		    var TEXT = compileFormatPart({ cond: "text", body: [ { type: "text" } ] });
	
		    var compile = util.memoize(function(format) {
		        var tree = parse(format);
		        var code = tree.map(compileFormatPart);
		        code.push(TEXT);
		        code = code.join("\n");
		        code = "'use strict'; return function(value, culture){ "
		            + "if (!culture) culture = kendo.culture(); "
		            + "var output = '', type = null, result = { body: [] }; " + code + "; return result; };";
		        return new Function("runtime", code)(runtime);
		    });
	
		    // Attempts to produce a format compatible with kendo.parseDate from our Excel format.  Needed
		    // in runtime.parseDate (passing Excel format to kendo.parseDate will mess up the month or
		    // minutes).  https://github.com/telerik/kendo-ui-core/issues/3797
		    var makeDateFormat = util.memoize(function(format){
		        var tree = parse(format);
		        var section, found = false, hasAmpm = false;
	
		        // locate a section that contains date/time formatting.  only the first will be converted.
		        for (var i = 0; i < tree.length; ++i) {
		            section = tree[i];
		            for (var j = 0; j < section.body.length; ++j) {
		                if (/^(?:date|time|ampm)$/.test(section.body[j].type)) {
		                    found = true;
		                    if (section.body[j].type == "ampm") {
		                        hasAmpm = true;
		                    }
		                }
		            }
		            if (found) {
		                break;
		            }
		        }
		        if (!found) {
		            return null;
		        }
	
		        return section.body.map(printToken).join("");
	
		        // a little copy/paste goes a long way
	
		        function maybeFraction(fmt, tok) {
		            if (tok.fraction) {
		                fmt += padLeft("", Math.max(tok.fraction, 3), "f");
		            }
		            return fmt;
		        }
	
		        function printToken(tok) {
		            if (tok.type == "digit") {
		                if (tok.sep) {
		                    return tok.format.charAt(0) + "," + tok.format.substr(1);
		                } else {
		                    return tok.format;
		                }
		            }
		            else if (tok.type == "exp") {
		                return tok.ch + tok.sign;
		            }
		            else if (tok.type == "date" || tok.type == "time") {
		                var part = tok.part;
		                if (tok.type == "date" && /^m/.test(part)) {
		                    part = "M"; // month, not minutes
		                }
		                else if (tok.type == "time" && /^h/.test(part)) {
		                    if (!hasAmpm) {
		                        // 24-hours clock is H or HH
		                        part = part.toUpperCase();
		                    }
		                }
		                return maybeFraction(padLeft("", tok.format, part), tok);
		            }
		            else if (tok.type == "ampm") {
		                return "tt";
		            }
		            else if (tok.type == "str") {
		                // XXX: this is a bit wrong.  it doesn't look like kendo.toString / kendo.parseDate
		                // support arbitrary text (in Excel formats that's quoted), for example:
		                //    kendo.toString(new Date(), "here's the day dude: dd")
		                //  → "3ere'8 t3e 19ay 19u19e: 19"   (it's 19th June, 3 o'clock, probably 8 seconds)
		                return tok.value;
		            }
		            else if (tok.type == "space") {
		                return " ";
		            }
		            else if (tok.type == "dec") {
		                return ".";
		            }
		            else if (tok.type == "percent") {
		                return "%";
		            }
		            else if (tok.type == "comma") {
		                return ",";
		            }
		            else {
		                return "";
		            }
		        }
		    });
	
		    var runtime = {
	
		        unpackDate: calc.runtime.unpackDate,
		        unpackTime: calc.runtime.unpackTime,
	
		        date: function(culture, d, part, length) {
		            switch (part) {
		              case "d":
		                switch (length) {
		                  case 1: return d.date;
		                  case 2: return padLeft(d.date, 2, "0");
		                  case 3: return culture.calendars.standard.days.namesAbbr[d.day];
		                  case 4: return culture.calendars.standard.days.names[d.day];
		                }
		                break;
		              case "m":
		                switch (length) {
		                  case 1: return d.month + 1;
		                  case 2: return padLeft(d.month + 1, 2, "0");
		                  case 3: return culture.calendars.standard.months.namesAbbr[d.month];
		                  case 4: return culture.calendars.standard.months.names[d.month];
		                  case 5: return culture.calendars.standard.months.names[d.month].charAt(0);
		                }
		                break;
		              case "y":
		                switch (length) {
		                  case 2: return d.year % 100;
		                  case 4: return d.year;
		                }
		                break;
		            }
		            return "##";
		        },
	
		        time: function(t, part, length, ampm, fraclen) {
		            var ret, fraction;
		            switch (part) {
		              case "h":
		                ret = padLeft(ampm ? t.hours % 12 || 12 : t.hours, length, "0");
		                if (fraclen) {
		                    fraction = (t.minutes + (t.seconds + t.milliseconds / 1000) / 60) / 60;
		                }
		                break;
		              case "m":
		                ret = padLeft(t.minutes, length, "0");
		                if (fraclen) {
		                    fraction = (t.seconds + t.milliseconds / 1000) / 60;
		                }
		                break;
		              case "s":
		                ret = padLeft(t.seconds, length, "0");
		                if (fraclen) {
		                    fraction = t.milliseconds / 1000;
		                }
		                break;
		            }
		            if (fraction) {
		                ret += runtime.toFixed(fraction, fraclen).replace(/^0+/, "");
		            }
		            return ret;
		        },
	
		        eltime: function(value, part, length, fraclen) {
		            var ret, fraction;
		            switch (part) {
		              case "h":
		                ret = value * 24;
		                break;
		              case "m":
		                ret = value * 24 * 60;
		                break;
		              case "s":
		                ret = value * 24 * 60 * 60;
		                break;
		            }
		            if (fraclen) {
		                fraction = ret - (ret | 0);
		            }
		            ret = padLeft(ret | 0, length, "0");
		            if (fraction) {
		                ret += runtime.toFixed(fraction, fraclen).replace(/^0+/, "");
		            }
		            return ret;
		        },
	
		        fill: function(ch) {
		            // XXX: how to implement this?
		            return ch;
		        },
	
		        // formatting integer part is slightly different than decimal
		        // part, so they're implemented in two functions.  For the
		        // integer part we need to walk the value and the format
		        // backwards (right-to-left).
	
		        formatInt: function(culture, value, parts, declen, sep) {
		            // toFixed is perfect for rounding our value; if there is
		            // no format for decimals, for example, we want the number
		            // rounded up.
		            value = runtime.toFixed(value, declen).replace(/\..*$/, "");
	
		            if (declen > 0) {
		                // if the rounded number is zero and we have decimal
		                // format, consider it a non-significant digit (Excel
		                // won't display the leading zero for 0.2 in format
		                // #.#).
		                if (value === "0") { value = ""; }
		                else if (value === "-0") { value = "-"; }
		            }
	
		            var iv = value.length - 1;
		            var result = [];
		            var len = 0, str;
	
		            function add(ch) {
		                if (sep && len && len % 3 === 0 && /^[0-9]$/.test(ch)) {
		                    str = culture.numberFormat[","] + str;
		                }
		                str = ch + str;
		                len++;
		            }
	
		            for (var j = parts.length; --j >= 0;) {
		                var format = parts[j];
		                str = "";
		                for (var k = format.length; --k >= 0;) {
		                    var chf = format.charAt(k);
		                    if (iv < 0) {
		                        if (chf == "0") {
		                            add("0");
		                        } else if (chf == "?") {
		                            add(" ");
		                        }
		                    } else {
		                        if (value == "0" && chf == "?") {
		                            add(" ");
		                        } else {
		                            add(value.charAt(iv));
		                        }
		                        iv--;
		                    }
		                }
		                if (j === 0) {
		                    while (iv >= 0) {
		                        add(value.charAt(iv--));
		                    }
		                }
		                result.unshift(str);
		            }
	
		            return result;
		        },
	
		        // for decimal part we walk in normal direction and pad on the
		        // right if required (for '0' or '?' chars).
	
		        formatDec: function(value, parts, declen) {
		            value = runtime.toFixed(value, declen);
		            var pos = value.indexOf(".");
		            if (pos >= 0) {
		                value = value.substr(pos + 1).replace(/0+$/, "");
		            } else {
		                value = "";
		            }
	
		            var iv = 0;
		            var result = [];
	
		            for (var j = 0; j < parts.length; ++j) {
		                var format = parts[j];
		                var str = "";
		                for (var k = 0; k < format.length; ++k) {
		                    var chf = format.charAt(k);
		                    if (iv < value.length) {
		                        str += value.charAt(iv++);
		                    } else if (chf == "0") {
		                        str += "0";
		                    } else if (chf == "?") {
		                        str += " ";
		                    }
		                }
		                result.push(str);
		            }
	
		            return result;
		        },
	
		        // JS's toFixed is broken, it's only OK to use it on integers.
		        toFixed: function(value, decimals) {
		            //var CNT = 0;
		            return (function toFixed(value) {
		                // if (++CNT > 2) {
		                //     debugger;
		                // }
	
		                // deal early with the trivial cases
		                if (value < 0) {    // JS's Math.round is broken with negative numbers
		                    return "-" + toFixed(-value);
		                }
	
		                if (decimals === 0) { // no decimals
		                    return String(Math.round(value));
		                }
	
		                if (value === parseInt(value, 10)) { // value is integer
		                    return value.toFixed(decimals);
		                }
	
		                // this handles cases like 0.3.toFixed(20) == "0.29999999999999998890", or
		                // 2.1825.toFixed(20) = "2.18250000000000010658".
		                // https://github.com/telerik/kendo-ui-core/issues/3520#issuecomment-333768221
		                // https://twitter.com/mcbazon/status/1035828655652593665
		                var str = String(value);
		                var pos = str.indexOf(".");
		                var intpart = str.substr(0, pos);
		                var decpart = str.substr(pos + 1);
		                if (decpart.length <= decimals) {
		                    while (decpart.length < decimals) {
		                        decpart += "0";
		                    }
		                    return intpart + "." + decpart;
		                }
	
		                // if there are more decimals than wanted, round and try again.
		                // it should not recurse more than once.
		                var f = Math.pow(10, decimals);
		                return toFixed(Math.round(value * f) / f);
	
		            })(Math.round(value * 1e14) / 1e14); /* restrict to 14 decimals, because 0.1 + 0.2 ===
		                                                 * 0.30000000000000004 */
		        }
	
		    };
	
		    function padLeft(val, width, ch) {
		        val += "";
		        while (val.length < width) {
		            val = ch + val;
		        }
		        return val;
		    }
	
		    /* -----[ exports ]----- */
	
		    function text(f) {
		        var a = f.body;
		        var text = "";
		        for (var i = 0; i < a.length; ++i) {
		            var el = a[i];
		            if (typeof el == "string") {
		                text += el;
		            } else if (el.type == "space") {
		                text += " ";
		            }
		        }
		        return text;
		    }
	
		    kendo.spreadsheet.formatting = {
		        compile : compile,
		        parse: parse,
		        format: function(value, format, culture) {
		            var f = compile(format)(value, culture);
		            var span = dom.element("span");
		            span.__dataType = f.type;
		            var a = f.body;
		            if (f.color) {
		                span.attr.style = { color: f.color };
		            }
		            for (var i = 0; i < a.length; ++i) {
		                var el = a[i];
		                if (typeof el == "string") {
		                    span.children.push(dom.text(el));
		                } else if (el.type == "space") {
		                    span.children.push(dom.element("span", {
		                        style: { visibility: "hidden" }
		                    }, [ dom.text(el.value) ]));
		                }
		            }
		            return span;
		        },
		        text: function(value, format, culture) {
		            var f = compile(format)(value, culture);
		            return text(f);
		        },
		        textAndColor: function(value, format, culture) {
		            var f = compile(format)(value, culture);
		            return { text: text(f), color: f.color, type: f.type };
		        },
		        type: function(value, format) {
		            return compile(format)(value).type;
		        },
		        adjustDecimals: function(format, diff) {
		            var ast = parse(format);
		            adjustDecimals(ast, diff);
		            return print(ast);
		        },
		        makeDateFormat: makeDateFormat
		    };
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1486:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ }),
	
	/***/ 1487:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(701);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1496);
		module.exports = __webpack_require__(1496);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1450:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ }),
	
	/***/ 1487:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(701);
	
	/***/ }),
	
	/***/ 1496:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1450), __webpack_require__(1487) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /* jshint eqnull:true, newcap:false, laxbreak:true, validthis:true */
		    /* jshint latedef:false */
	
		    var util = kendo.util;
		    var spreadsheet = kendo.spreadsheet;
		    var calc = spreadsheet.calc;
		    var runtime = calc.runtime;
		    var defineFunction = runtime.defineFunction;
		    var defineAlias = runtime.defineAlias;
		    var CalcError = runtime.CalcError;
		    var RangeRef = spreadsheet.RangeRef;
		    var CellRef = spreadsheet.CellRef;
		    var UnionRef = spreadsheet.UnionRef;
		    var Matrix = runtime.Matrix;
		    var Ref = spreadsheet.Ref;
		    var daysInMonth = runtime.daysInMonth;
		    var packDate = runtime.packDate;
		    var unpackDate = runtime.unpackDate;
		    var daysInYear = runtime.daysInYear;
	
		    /* -----[ Math functions ]----- */
	
		    [ "abs", "cos", "sin", "acos", "asin", "tan", "atan", "exp", "sqrt" ].forEach(function(name){
		        defineFunction(name, Math[name]).args([
		            [ "*n", "number" ]
		        ]);
		    });
	
		    defineFunction("ln", Math.log).args([
		        [ "*n", "number" ]
		    ]);
	
		    defineFunction("log", function(num, base){
		        return Math.log(num) / Math.log(base);
		    }).args([
		        [ "*num", "number++" ],
		        [ "*base", [ "or", "number++", [ "null", 10 ] ] ],
		        [ "?", [ "assert", "$base != 1", "DIV/0" ] ]
		    ]);
	
		    defineFunction("log10", function(num){
		        return Math.log(num) / Math.log(10);
		    }).args([
		        [ "*num", "number++" ]
		    ]);
	
		    defineFunction("pi", function(){
		        return Math.PI;
		    }).args([]);
	
		    defineFunction("sqrtpi", function(n){
		        return Math.sqrt(n * Math.PI);
		    }).args([
		        [ "*num", "number+" ]
		    ]);
	
		    defineFunction("degrees", function(rad){
		        return ((180 * rad) / Math.PI) % 360;
		    }).args([
		        [ "*radians", "number" ]
		    ]);
	
		    defineFunction("radians", function(deg){
		        return Math.PI * deg / 180;
		    }).args([
		        [ "*degrees", "number" ]
		    ]);
	
		    function _cosh(n){
		        return (Math.exp(n) + Math.exp(-n)) / 2;
		    }
	
		    defineFunction("cosh", _cosh).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("acosh", function(n){
		        return Math.log(n + Math.sqrt(n - 1) * Math.sqrt(n + 1));
		    }).args([
		        [ "*num", "number" ],
		        [ "?", [ "assert", "$num >= 1" ] ]
		    ]);
	
		    function _sinh(n){
		        return (Math.exp(n) - Math.exp(-n)) / 2;
		    }
	
		    defineFunction("sinh", _sinh).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("asinh", function(n){
		        return Math.log(n + Math.sqrt(n * n + 1));
		    }).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("sec", function(n){
		        return 1 / Math.cos(n);
		    }).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("sech", function(n){
		        return 1 / _cosh(n);
		    }).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("csc", function(n){
		        return 1 / Math.sin(n);
		    }).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("csch", function(n){
		        return 1 / _sinh(n);
		    }).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("atan2", function(x, y){
		        return Math.atan(y / x);
		    }).args([
		        [ "*x", "divisor" ],
		        [ "*y", "number" ]
		    ]);
	
		    function _tanh(n) {
		        return _sinh(n) / _cosh(n);
		    }
	
		    defineFunction("tanh", _tanh).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("atanh", function(n){
		        return Math.log(Math.sqrt(1 - n*n) / (1 - n));
		    }).args([
		        [ "*num", [ "and", "number", [ "(between)", -1, 1 ] ] ]
		    ]);
	
		    defineFunction("cot", function(n){
		        return 1 / Math.tan(n);
		    }).args([
		        [ "*num", "divisor" ]
		    ]);
	
		    defineFunction("coth", function(n){
		        return 1 / _tanh(n);
		    }).args([
		        [ "*num", "divisor" ]
		    ]);
	
		    defineFunction("acot", function(n){
		        return Math.PI / 2 - Math.atan(n);
		    }).args([
		        [ "*num", "number" ]
		    ]);
	
		    defineFunction("acoth", function(n){
		        return Math.log((n + 1) / (n - 1)) / 2;
		    }).args([
		        [ "*num", "number" ],
		        [ "?", [ "or",
		                 [ "assert", "$num < -1"],
		                 [ "assert", "$num > 1" ] ] ]
		    ]);
	
		    defineFunction("power", function(a, b){
		        return Math.pow(a, b);
		    }).args([
		        [ "*a", "number" ],
		        [ "*b", "number" ]
		    ]);
	
		    defineFunction("mod", function(a, b){
		        return a % b;
		    }).args([
		        [ "*a", "number" ],
		        [ "*b", "divisor" ]
		    ]);
	
		    defineFunction("quotient", function(a, b){
		        return Math.floor(a / b);
		    }).args([
		        [ "*a", "number" ],
		        [ "*b", "divisor" ]
		    ]);
	
		    defineFunction("ceiling", function(num, s){
		        return s ? s * Math.ceil(num / s) : 0;
		    }).args([
		        [ "*number", "number" ],
		        [ "*significance", "number" ],
		        [ "?", [ "assert", "$significance >= 0 || $number < 0" ] ]
		    ]);
	
		    defineFunction("ceiling.precise", function(num, s){
		        s = Math.abs(s);
		        return s ? s * Math.ceil(num / s) : 0;
		    }).args([
		        [ "*number", "number" ],
		        [ "*significance", [ "or", "number", [ "null", 1 ] ] ]
		    ]);
	
		    defineAlias("iso.ceiling", "ceiling.precise");
	
		    // XXX: how do we know if this function is correct?
		    //
		    // https://support.office.com/en-gb/article/CEILING-MATH-function-80f95d2f-b499-4eee-9f16-f795a8e306c8
		    //
		    // “There are many combinations of Significance and Mode values that affect rounding of negative
		    // numbers in different ways.” — right, thanks for the info. :-\
		    defineFunction("ceiling.math", function(num, s, mode){
		        if (!s || !num) {
		            return 0;
		        }
		        if (num < 0 && ((!mode && s < 0) || (mode && s > 0))) {
		            s = -s;
		        }
		        return s ? s * Math.ceil(num / s) : 0;
		    }).args([
		        [ "*number", "number" ],
		        [ "*significance", [ "or", "number", [ "null", "$number < 0 ? -1 : 1" ] ] ],
		        [ "*mode", [ "or", "logical", [ "null", 0 ] ] ]
		    ]);
	
		    defineFunction("floor", function(num, s){
		        return s ? s * Math.floor(num / s) : 0;
		    }).args([
		        [ "*number", "number" ],
		        [ "*significance", "number" ],
		        [ "?", [ "assert", "$significance >= 0 || $number < 0" ] ]
		    ]);
	
		    defineFunction("floor.precise", function(num, s){
		        s = Math.abs(s);
		        return s ? s * Math.floor(num / s) : 0;
		    }).args([
		        [ "*number", "number" ],
		        [ "*significance", [ "or", "number", [ "null", 1 ] ] ]
		    ]);
	
		    // XXX: check this
		    defineFunction("floor.math", function(num, s, mode){
		        if (!s || !num) {
		            return 0;
		        }
		        if (num < 0 && ((!mode && s < 0) || (mode && s > 0))) {
		            s = -s;
		        }
		        return s ? s * Math.floor(num / s) : 0;
		    }).args([
		        [ "*number", "number" ],
		        [ "*significance", [ "or", "number", [ "null", "$number < 0 ? -1 : 1" ] ] ],
		        [ "*mode", [ "or", "logical", [ "null", 0 ] ] ]
		    ]);
	
		    defineFunction("int", Math.floor).args([
		        [ "*number", "number" ]
		    ]);
	
		    defineFunction("mround", function(num, mult){
		        return mult ? mult * Math.round(num / mult) : 0;
		    }).args([
		        [ "*number", "number" ],
		        [ "*multiple", "number" ]
		    ]);
	
		    defineFunction("round", function(num, digits){
		        var sign = num < 0 ? -1 : 1;
		        if (sign < 0) { num = -num; }
		        digits = Math.pow(10, digits);
		        num *= digits;
		        num = Math.round(num);
		        return sign * num / digits;
		    }).args([
		        [ "*number", "number" ],
		        [ "*digits", "number" ]
		    ]);
	
		    defineFunction("roundup", function(num, digits){
		        digits = Math.pow(10, digits);
		        num *= digits;
		        num = num < 0 ? Math.floor(num) : Math.ceil(num);
		        return num / digits;
		    }).args([
		        [ "*number", "number" ],
		        [ "*digits", "number" ]
		    ]);
	
		    defineFunction("rounddown", function(num, digits){
		        digits = Math.pow(10, digits);
		        num *= digits;
		        num = num < 0 ? Math.ceil(num) : Math.floor(num);
		        return num / digits;
		    }).args([
		        [ "*number", "number" ],
		        [ "*digits", "number" ]
		    ]);
	
		    defineFunction("even", function(num){
		        var n = num < 0 ? Math.floor(num) : Math.ceil(num);
		        return n % 2 ? n + (n < 0 ? -1 : 1) : n;
		    }).args([
		        [ "*number", "number" ]
		    ]);
	
		    defineFunction("odd", function(num){
		        var n = num < 0 ? Math.floor(num) : Math.ceil(num);
		        return n % 2 ? n : n + (n < 0 ? -1 : 1);
		    }).args([
		        [ "*number", "number" ]
		    ]);
	
		    defineFunction("sign", function(num){
		        return num < 0 ? -1 : num > 0 ? 1 : 0;
		    }).args([
		        [ "*number", "number" ]
		    ]);
	
		    function _gcd(a, b) {
		        while (b) {
		            var r = a % b;
		            a = b;
		            b = r;
		        }
		        return a;
		    }
	
		    function _lcm(a, b) {
		        return Math.abs(a * b) / _gcd(a, b);
		    }
	
		    defineFunction("gcd", function(args){
		        var a = args[0];
		        for (var i = 1; i < args.length; ++i) {
		            a = _gcd(a, args[i]);
		        }
		        return a;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("lcm", function(args){
		        var a = args[0];
		        for (var i = 1; i < args.length; ++i) {
		            a = _lcm(a, args[i]);
		        }
		        return a;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("sum", function(numbers){
		        return numbers.reduce(function(sum, num){
		            return sum + num;
		        }, 0);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("product", function(numbers){
		        return numbers.reduce(function(prod, num){
		            return prod * num;
		        }, 1);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("sumproduct", function(first, rest) {
		        var sum = 0;
		        first.each(function(p, row, col){
		            if (typeof p == "number") {
		                for (var i = 0; i < rest.length; ++i) {
		                    var v = rest[i].get(row, col);
		                    if (typeof v != "number") {
		                        return;
		                    }
		                    p *= v;
		                }
		                sum += p;
		            }
		        });
		        return sum;
		    }).args([
		        [ "a1", "matrix" ],
		        [ "+",
		          [ "a2", [ "and", "matrix",
		                    [ "assert", "$a2.width == $a1.width" ],
		                    [ "assert", "$a2.height == $a1.height" ] ] ] ]
		    ]);
	
		    defineFunction("sumsq", function(numbers){
		        return numbers.reduce(function(sum, num){
		            return sum + num * num;
		        }, 0);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("sumx2my2", function(a, b){
		        var sum = 0;
		        a.each(function(x, row, col){
		            var y = b.get(row, col);
		            if (typeof x == "number" && typeof y == "number") {
		                sum += x*x - y*y;
		            }
		        });
		        return sum;
		    }).args([
		        [ "a", "matrix" ],
		        [ "b", [ "and", "matrix",
		                 [ "assert", "$b.width == $a.width" ],
		                 [ "assert", "$b.height == $a.height" ] ] ]
		    ]);
	
		    defineFunction("sumx2py2", function(a, b){
		        var sum = 0;
		        a.each(function(x, row, col){
		            var y = b.get(row, col);
		            if (typeof x == "number" && typeof y == "number") {
		                sum += x*x + y*y;
		            }
		        });
		        return sum;
		    }).args([
		        [ "a", "matrix" ],
		        [ "b", [ "and", "matrix",
		                 [ "assert", "$b.width == $a.width" ],
		                 [ "assert", "$b.height == $a.height" ] ] ]
		    ]);
	
		    defineFunction("sumxmy2", function(a, b){
		        var sum = 0;
		        a.each(function(x, row, col){
		            var y = b.get(row, col);
		            if (typeof x == "number" && typeof y == "number") {
		                sum += (x - y) * (x - y);
		            }
		        });
		        return sum;
		    }).args([
		        [ "a", "matrix" ],
		        [ "b", [ "and", "matrix",
		                 [ "assert", "$b.width == $a.width" ],
		                 [ "assert", "$b.height == $a.height" ] ] ]
		    ]);
	
		    defineFunction("seriessum", function(x, n, m, a){
		        var sum = 0;
		        a.each(function(coef){
		            if (typeof coef != "number") {
		                throw new CalcError("VALUE");
		            }
		            sum += coef * Math.pow(x, n);
		            n += m;
		        });
		        return sum;
		    }).args([
		        [ "x", "number" ],
		        [ "y", "number" ],
		        [ "m", "number" ],
		        [ "a", "matrix" ]
		    ]);
	
		    defineFunction("min", function(numbers){
		        return numbers.length ? Math.min.apply(Math, numbers) : 0;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("max", function(numbers){
		        return numbers.length ? Math.max.apply(Math, numbers) : 0;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("counta", function(values){
		        return values.length;
		    }).args([
		        [ "values", [ "#collect", "anyvalue" ] ]
		    ]);
	
		    defineFunction("count", function(numbers){
		        return numbers.length;
		    }).args([
		        [ "numbers", [ "#collect", "number" ] ]
		    ]);
	
		    defineFunction("countunique", function(values){
		        var count = 0, seen = [];
		        values.forEach(function(val){
		            if (seen.indexOf(val) < 0) {
		                count++;
		                seen.push(val);
		            }
		        });
		        return count;
		    }).args([
		        [ "values", [ "#collect", "anyvalue" ] ]
		    ]);
	
		    defineFunction("countblank", function(a){
		        var count = 0;
		        function add(val) {
		            if (val == null || val === "") {
		                count++;
		            }
		        }
		        function loop(args){
		            for (var i = 0; i < args.length; ++i) {
		                var x = args[i];
		                if (x instanceof Matrix) {
		                    x.each(add, true);
		                } else {
		                    add(x);
		                }
		            }
		        }
		        loop(a);
		        return count;
		    }).args([
		        [ "+", [ "args", [ "or", "matrix", "anyvalue" ] ] ]
		    ]);
	
		    defineFunction("iseven", function(num){
		        return num % 2 === 0;
		    }).args([
		        [ "*number", "number" ]
		    ]);
	
		    defineFunction("isodd", function(num){
		        return num % 2 !== 0;
		    }).args([
		        [ "*number", "number" ]
		    ]);
	
		    defineFunction("n", function(val){
		        if (typeof val == "boolean") {
		            return val ? 1 : 0;
		        }
		        if (typeof val == "number") {
		            return val;
		        }
		        return 0;
		    }).args([
		        [ "*value", "anyvalue" ]
		    ]);
	
		    defineFunction("na", function(){
		        return new CalcError("N/A");
		    }).args([]);
	
		    /* -----[ the "*IFS" functions ]----- */
	
		    // helper function: take `args` like COUNTIFS (see Excel docs) and
		    // calls `f` for each cell matching all criteria.  `f` receives
		    // `chunks` (parsed args containing matrix and predicate) and
		    // row,col of matching cells.
		    function forIFS(args, f) {
		        var chunks = [], i = 0, matrix = args[0];
		        while (i < args.length) {
		            chunks.push({
		                matrix: args[i++],
		                pred: parseCriteria(args[i++])
		            });
		        }
		        ROW: for (var row = 0; row < matrix.height; ++row) {
		            COL: for (var col = 0; col < matrix.width; ++col) {
		                for (i = 0; i < chunks.length; ++i) {
		                    var val = chunks[i].matrix.get(row, col);
		                    if (!chunks[i].pred(val == null || val === "" ? 0 : val)) {
		                        continue COL;
		                    }
		                }
		                f(row, col);
		            }
		        }
		    }
	
		    var ARGS_COUNTIFS = [
		        [ "m1", "matrix" ],
		        [ "c1", "anyvalue" ],
		        [ [ "m2", "matrix" ],
		          [ "c2", "anyvalue" ] ]
		    ];
	
		    defineFunction("countifs", function(m1, c1, rest){
		        var count = 0;
		        rest.unshift(m1, c1);
		        forIFS(rest, function(){ count++; });
		        return count;
		    }).args(ARGS_COUNTIFS);
	
		    var ARGS_SUMIFS = [
		        [ "range", "matrix" ]
		    ].concat(ARGS_COUNTIFS);
	
		    defineFunction("sumifs", function(range, m1, c1, args){
		        // hack: insert a predicate that filters out non-numeric
		        // values; should also accept blank cells.  it's safe to
		        // modify args.
		        args.unshift(range, numericPredicate, m1, c1);
		        var sum = 0;
		        forIFS(args, function(row, col){
		            var val = range.get(row, col);
		            if (val) {
		                sum += val;
		            }
		        });
		        return sum;
		    }).args(ARGS_SUMIFS);
	
		    // similar to sumifs, but compute average of matching cells
		    defineFunction("averageifs", function(range, m1, c1, args){
		        args.unshift(range, numericPredicate, m1, c1);
		        var sum = 0, count = 0;
		        forIFS(args, function(row, col){
		            var val = range.get(row, col);
		            if (val == null || val === "") {
		                val = 0;
		            }
		            sum += val;
		            count++;
		        });
		        return count ? sum / count : new CalcError("DIV/0");
		    }).args(ARGS_SUMIFS);
	
		    defineFunction("countif", function(matrix, criteria){
		        criteria = parseCriteria(criteria);
		        var count = 0;
		        matrix.each(function(val){
		            if (criteria(val)) {
		                count++;
		            }
		        });
		        return count;
		    }).args([
		        [ "range", "matrix" ],
		        [ "*criteria", "anyvalue" ]
		    ]);
	
		    var ARGS_SUMIF = [
		        [ "range", "matrix" ],
		        [ "*criteria", "anyvalue" ],
		        [ "sumRange", [ "or",
		                        [ "and", "matrix",
		                          [ "assert", "$sumRange.width == $range.width" ],
		                          [ "assert", "$sumRange.height == $range.height" ] ],
		                        [ "null", "$range" ] ] ]
		    ];
	
		    defineFunction("sumif", function(range, criteria, sumRange){
		        var sum = 0;
		        criteria = parseCriteria(criteria);
		        range.each(function(val, row, col){
		            if (criteria(val)) {
		                var v = sumRange.get(row, col);
		                if (numericPredicate(v)) {
		                    sum += v || 0;
		                }
		            }
		        });
		        return sum;
		    }).args(ARGS_SUMIF);
	
		    defineFunction("averageif", function(range, criteria, sumRange){
		        var sum = 0, count = 0;
		        criteria = parseCriteria(criteria);
		        range.each(function(val, row, col){
		            if (criteria(val)) {
		                var v = sumRange.get(row, col);
		                if (numericPredicate(v)) {
		                    sum += v || 0;
		                    count++;
		                }
		            }
		        });
		        return count ? sum / count : new CalcError("DIV/0");
		    }).args(ARGS_SUMIF);
	
		    (function(def){
		        def("large", function(numbers, nth){
		            return numbers.sort(descending)[nth];
		        });
		        def("small", function(numbers, nth){
		            return numbers.sort(ascending)[nth];
		        });
		    })(function(name, handler){
		        defineFunction(name, function(matrix, nth){
		            var numbers = [];
		            var error = matrix.each(function(val){
		                if (val instanceof CalcError) {
		                    return val;
		                }
		                if (typeof val == "number") {
		                    numbers.push(val);
		                }
		            });
		            if (error) {
		                return error;
		            }
		            if (nth > numbers.length) {
		                return new CalcError("NUM");
		            }
		            return handler(numbers, nth - 1);
		        }).args([
		            [ "array", "matrix" ],
		            [ "*nth", "number++" ]
		        ]);
		    });
	
		    function _avg(numbers) {
		        return numbers.reduce(function(sum, num){
		            return sum + num;
		        }, 0) / numbers.length;
		    }
	
		    function _var_sp(numbers, divisor, avg) {
		        if (avg == null) {
		            avg = _avg(numbers);
		        }
		        return numbers.reduce(function(sum, num){
		            return sum + Math.pow(num - avg, 2);
		        }, 0) / divisor;
		    }
	
		    function _stdev_sp(numbers, divisor) {
		        return Math.sqrt(_var_sp(numbers, divisor));
		    }
	
		    // https://support.office.com/en-sg/article/STDEV-S-function-7d69cf97-0c1f-4acf-be27-f3e83904cc23
		    defineFunction("stdev.s", function(numbers){
		        return _stdev_sp(numbers, numbers.length - 1);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
		    ]);
	
		    // https://support.office.com/en-sg/article/STDEV-P-function-6e917c05-31a0-496f-ade7-4f4e7462f285
		    defineFunction("stdev.p", function(numbers){
		        return _stdev_sp(numbers, numbers.length);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
		    ]);
	
		    defineFunction("var.s", function(numbers){
		        return _var_sp(numbers, numbers.length - 1);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
		    ]);
	
		    defineFunction("var.p", function(numbers){
		        return _var_sp(numbers, numbers.length);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
		    ]);
	
		    defineFunction("median", function(numbers){
		        var n = numbers.length;
		        numbers.sort(ascending);
		        if (n % 2) {
		            // when length is odd, the median is the number in the middle
		            return numbers[n >> 1];
		        }
		        // that's the average of the two middle numbers, written in in a fancy way
		        return (numbers[n >>= 1] + numbers[n - 1]) / 2;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length > 0", "N/A" ] ]
		    ]);
	
		    defineFunction("mode.sngl", function(numbers){
		        numbers.sort(ascending);
		        var prev = null, count = 0, max = 1, mode = null;
		        for (var i = 0; i < numbers.length; ++i) {
		            var n = numbers[i];
		            if (n != prev) {
		                count = 1;
		                prev = n;
		            } else {
		                count++;
		            }
		            if (count > max) {
		                max = count;
		                mode = n;
		            }
		        }
		        return mode == null ? new CalcError("N/A") : mode;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("mode.mult", function(numbers){
		        var seen = Object.create(null), max = 2, res = [];
		        numbers.forEach(function(num){
		            var s = seen[num] || 0;
		            seen[num] = ++s;
		            if (s == max) {
		                res.push(num);
		            } else if (s > max) {
		                max = s;
		                res = [ num ];
		            }
		        });
		        var m = new Matrix(this);
		        res.forEach(function(num, i){
		            m.set(i, 0, num);
		        });
		        return m;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    defineFunction("geomean", function(numbers){
		        var n = numbers.length;
		        var p = numbers.reduce(function(p, num){
		            if (num < 0) {
		                throw new CalcError("NUM");
		            }
		            return p * num;
		        }, 1);
		        return Math.pow(p, 1/n);
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length > 0", "NUM" ] ]
		    ]);
	
		    defineFunction("harmean", function(numbers){
		        var n = numbers.length;
		        var s = numbers.reduce(function(s, num){
		            if (!num) {
		                throw new CalcError("DIV/0");
		            }
		            return s + 1 / num;
		        }, 0);
		        return n / s;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length > 0", "NUM" ] ]
		    ]);
	
		    defineFunction("trimmean", function(numbers, p){
		        var n = numbers.length;
		        numbers.sort(ascending);
		        var discard = Math.floor(n * p);
		        if (discard % 2) {
		            --discard;
		        }
		        discard /= 2;
		        var sum = 0;
		        for (var i = discard; i < n-discard; ++i) {
		            sum += numbers[i];
		        }
		        return sum / (n - discard * 2);
		    }).args([
		        [ "numbers", [ "collect", "number", 1 ] ],
		        [ "percent", [ "and", "number", [ "[between)", 0, 1 ] ] ],
		        [ "?", [ "assert", "$numbers.length > 0", "NUM" ] ]
		    ]);
	
		    defineFunction("frequency", function(data, bins){
		        // apparently this always returns a vertical matrix in Excel, so we collect all numbers in
		        // bins instead of receiving it as a Matrix and try to mimic its shape.
		        data.sort(ascending);
		        bins.sort(ascending);
		        var prev = -Infinity;
		        var i = 0;
		        function count(max) {
		            var n = 0;
		            while (i < data.length && data[i] > prev && data[i] <= max) {
		                ++n; ++i;
		            }
		            return n;
		        }
		        var m = new Matrix(this);
		        bins.forEach(function(val, i){
		            var n = count(val);
		            prev = val;
		            m.set(i, 0, n);
		        });
		        m.set(m.height, 0, data.length - i);
		        return m;
		    }).args([
		        [ "data", [ "collect", "number", 1 ] ],
		        [ "bins", [ "collect", "number", 1 ] ]
		    ]);
	
		    defineFunction("rank.eq", function(val, numbers, asc) {
		        numbers.sort(asc ? ascending : descending);
		        var pos = numbers.indexOf(val);
		        return pos < 0 ? new CalcError("N/A") : pos + 1;
		    }).args([
		        [ "value", "number" ],
		        [ "numbers", [ "collect", "number" ] ],
		        [ "order", [ "or", "logical", [ "null", false ] ] ]
		    ]);
	
		    defineAlias("rank", "rank.eq");
	
		    defineFunction("rank.avg", function(val, numbers, asc) {
		        numbers.sort(asc ? ascending : descending);
		        var pos = numbers.indexOf(val);
		        if (pos < 0) {
		            return new CalcError("N/A");
		        }
		        for (var i = pos; numbers[i] == val; ++i){}
		        return (pos + i + 1) / 2;
		    }).args([
		        [ "value", "number" ],
		        [ "numbers", [ "collect", "number" ] ],
		        [ "order", [ "or", "logical", [ "null", false ] ] ]
		    ]);
	
		    // formula available at https://support.office.microsoft.com/en-us/article/KURT-function-cbbc2312-dfa6-4cc4-b5c0-1b3c59cc9377
		    defineFunction("kurt", function(numbers){
		        var n = numbers.length;
		        var avg = _avg(numbers);
		        var variance = _var_sp(numbers, n-1, avg);
		        var stddev = Math.sqrt(variance);
		        var sum = numbers.reduce(function(sum, num){
		            return sum + Math.pow((num - avg) / stddev, 4);
		        }, 0);
		        return n*(n+1)/((n-1)*(n-2)*(n-3)) * sum
		            - 3*Math.pow(n-1, 2)/((n-2)*(n-3));
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length >= 4", "NUM" ] ]
		    ]);
	
		    function _percentrank(numbers, x, exc) {
		        var nlt = 0, ngt = 0, left = null, right = null, found = false;
		        numbers.forEach(function(num){
		            if (num < x) {
		                nlt++;
		                left = left == null ? num : Math.max(left, num);
		            } else if (num > x) {
		                ngt++;
		                right = right == null ? num : Math.min(right, num);
		            } else {
		                found = true;
		            }
		        });
		        if (!nlt && !ngt) {
		            return new CalcError("N/A");
		        }
		        if (found) {
		            if (exc) {
		                return (nlt + 1) / (numbers.length + 1);
		            }
		            return nlt / (nlt + ngt);
		        }
		        return ((right - x) * _percentrank(numbers, left, exc) +
		                (x - left) * _percentrank(numbers, right, exc)) / (right - left);
		    }
	
		    var ARGS_PERCENTRANK = [
		        [ "array", [ "collect", "number", 1 ] ],
		        [ "x", "number" ],
		        [ "significance", [ "or", [ "null", 3 ], "integer++" ] ],
		        [ "?", [ "assert", "$array.length > 0", "NUM" ] ]
		    ];
	
		    defineFunction("percentrank.inc", function(numbers, x, significance) {
		        var p = _percentrank(numbers, x, 0);
		        p = p.toFixed(significance + 1);
		        return parseFloat(p.substr(0, p.length - 1));
		    }).args(ARGS_PERCENTRANK);
	
		    defineFunction("percentrank.exc", function(numbers, x, significance) {
		        var p = _percentrank(numbers, x, 1);
		        p = p.toFixed(significance + 1);
		        return parseFloat(p.substr(0, p.length - 1));
		    }).args(ARGS_PERCENTRANK);
	
		    defineAlias("percentrank", "percentrank.inc");
	
		    function _covariance(x, y, divisor) {
		        var sum = 0;
		        var ax = _avg(x);
		        var ay = _avg(y);
		        var n = x.length;
		        for (var i = 0; i < n; ++i) {
		            sum += (x[i] - ax) * (y[i] - ay);
		        }
		        return sum / divisor;
		    }
	
		    defineFunction("covariance.p", function(x, y){
		        return _covariance(x, y, x.length);
		    }).args([
		        [ "array1", [ "collect", "number", 1 ] ],
		        [ "array2", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$array1.length == $array2.length", "N/A" ] ],
		        [ "?", [ "assert", "$array1.length > 0", "DIV/0" ] ]
		    ]);
	
		    defineFunction("covariance.s", function(x, y){
		        return _covariance(x, y, x.length - 1);
		    }).args([
		        [ "array1", [ "collect", "number", 1 ] ],
		        [ "array2", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$array1.length == $array2.length", "N/A" ] ],
		        [ "?", [ "assert", "$array1.length > 1", "DIV/0" ] ]
		    ]);
	
		    defineAlias("covar", "covariance.p");
	
		    /* -----[ Factorials ]----- */
	
		    var _fact = util.memoize(function(n){
		        for (var i = 2, fact = 1; i <= n; ++i) {
		            fact *= i;
		        }
		        return fact;
		    });
	
		    defineFunction("fact", _fact).args([
		        [ "*n", "integer+" ]
		    ]);
	
		    defineFunction("factdouble", function(n){
		        for (var i = 2 + (n&1), fact = 1; i <= n; i += 2) {
		            fact *= i;
		        }
		        return fact;
		    }).args([
		        [ "*n", "integer+" ]
		    ]);
	
		    defineFunction("multinomial", function(numbers){
		        var div = 1, sum = 0;
		        numbers.forEach(function(n){
		            if (n < 0) {
		                throw new CalcError("NUM");
		            }
		            sum += n;
		            div *= _fact(n);
		        });
		        return _fact(sum) / div;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ]
		    ]);
	
		    var _combinations = util.memoize(function (n, k){
		        for (var f1 = k + 1, f2 = 1, p1 = 1, p2 = 1; f2 <= n - k; ++f1, ++f2) {
		            p1 *= f1;
		            p2 *= f2;
		        }
		        return p1/p2;
		    });
	
		    defineFunction("combin", _combinations).args([
		        [ "*n", "integer++" ],
		        [ "*k", [ "and", "integer", [ "[between]", 0, "$n" ] ] ]
		    ]);
	
		    defineFunction("combina", function(n, k){
		        return _combinations(n + k - 1, n - 1);
		    }).args([
		        [ "*n", "integer++" ],
		        [ "*k", [ "and", "integer", [ "[between]", 1, "$n" ] ] ]
		    ]);
	
		    /* -----[ Statistical functions ]----- */
	
		    defineFunction("average", function(numbers){
		        var sum = numbers.reduce(function(sum, num){
		            return sum + num;
		        }, 0);
		        return sum / numbers.length;
		    }).args([
		        // most numeric functions must treat booleans as numbers (1 for TRUE
		        // and 0 for FALSE), but AVERAGE shouldn't.
		        [ "numbers", [ "collect", "number!" ] ],
		        [ "?", [ "assert", "$numbers.length > 0", "DIV/0" ] ]
		    ]);
	
		    defineFunction("averagea", function(values){
		        var sum = 0, count = 0;
		        values.forEach(function(num){
		            if (typeof num != "string") {
		                sum += num;
		            }
		            ++count;
		        });
		        return count ? sum / count : new CalcError("DIV/0");
		    }).args([
		        [ "values", [ "collect", "anyvalue" ] ]
		    ]);
	
		    function _percentile(numbers, rank) {
		        numbers.sort(ascending);
		        var n = numbers.length;
		        var k = rank | 0, d = rank - k;
		        if (k === 0) {
		            return numbers[0];
		        }
		        if (k >= n) {
		            return numbers[n - 1];
		        }
		        --k;
		        return numbers[k] + d * (numbers[k + 1] - numbers[k]);
		    }
	
		    function _percentile_inc(numbers, p){
		        // algorithm from https://en.wikipedia.org/wiki/Percentile#Microsoft_Excel_method
		        var rank = p * (numbers.length - 1) + 1;
		        return _percentile(numbers, rank);
		    }
	
		    function _percentile_exc(numbers, p){
		        // https://en.wikipedia.org/wiki/Percentile#NIST_method
		        var rank = p * (numbers.length + 1);
		        return _percentile(numbers, rank);
		    }
	
		    defineFunction("percentile.inc", _percentile_inc).args([
		        [ "numbers", [ "collect", "number", 1 ] ],
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ]
		    ]);
	
		    defineFunction("percentile.exc", _percentile_exc).args([
		        [ "numbers", [ "collect", "number", 1 ] ],
		        [ "p", [ "and", "number", [ "(between)", 0, 1 ] ] ]
		    ]);
	
		    defineFunction("quartile.inc", function(numbers, quarter){
		        return _percentile_inc(numbers, quarter / 4);
		    }).args([
		        [ "numbers", [ "collect", "number", 1 ] ],
		        [ "quarter", [ "values", 0, 1, 2, 3, 4 ] ]
		    ]);
	
		    defineFunction("quartile.exc", function(numbers, quarter){
		        return _percentile_exc(numbers, quarter / 4);
		    }).args([
		        [ "numbers", [ "collect", "number", 1 ] ],
		        [ "quarter", [ "values", 0, 1, 2, 3, 4 ] ]
		    ]);
	
		    defineAlias("quartile", "quartile.inc");
		    defineAlias("percentile", "percentile.inc");
	
		    var AGGREGATE_FUNCS = [
		        "AVERAGE", "COUNT", "COUNTA", "MAX", "MIN", "PRODUCT",
		        "STDEV.S", "STDEV.P", "SUM", "VAR.S", "VAR.P", "MEDIAN",
		        "MODE.SNGL", "LARGE", "SMALL", "PERCENTILE.INC",
		        "QUARTILE.INC", "PERCENTILE.EXC", "QUARTILE.EXC"
		    ];
	
		    function fetchValuesForAggregate(self, args, options) {
		        var values = [];
		        var opt_ignore_hidden_rows = 1;
		        var opt_ignore_errors = 2;
		        var opt_use_aggregates = 4;
		        (function fetchValues(args) {
		            if (args instanceof Ref) {
		                self.getRefCells(args, true).forEach(function(cell){
		                    var value = cell.value;
		                    if ((options & opt_ignore_hidden_rows) && cell.hidden) {
		                        return;
		                    }
		                    if (cell.formula) {
		                        // XXX: formula.print is fast, but still, can't we do any better here?
		                        //      perhaps access the input string directly somehow?
		                        var str = cell.formula.print(cell.row, cell.col);
		                        if (/^\s*(?:aggregate|subtotal)\s*\(/i.test(str)) {
		                            if (!(options & opt_use_aggregates)) {
		                                return;
		                            }
		                        }
		                        if ("value" in cell.formula) {
		                            value = cell.formula.value;
		                        }
		                    }
		                    if ((options & opt_ignore_errors) && value instanceof CalcError) {
		                        return;
		                    }
		                    if (typeof value == "number" || value instanceof CalcError) {
		                        values.push(value);
		                    }
		                });
		            } else if (Array.isArray(args)) {
		                for (var i = 0; i < args.length; ++i) {
		                    fetchValues(args[i]);
		                }
		            } else if (args instanceof Matrix) {
		                args.each(fetchValues);
		            } else if (typeof args == "number") {
		                values.push(args);
		            } else if (args instanceof CalcError && !(options & opt_ignore_errors)) {
		                values.push(args);
		            }
		        })(args);
		        return values;
		    }
	
		    // AGGREGATE function
		    //
		    // https://support.office.com/en-SG/article/aggregate-function-c8caed56-07df-4aeb-9741-23693ffbe525
		    //
		    // we can only partially type-check this function.  also, we need to use the async version in
		    // order to resolve references and delegate values to the function to aggregate.
		    defineFunction("aggregate", function(callback, funcId, options, args){
		        // options is a bit field.  that makes sense; it's the documentation which doesn't.
		        var self = this;
		        self.resolveCells(args, function(){
		            var values;
		            if (funcId > 12) {
		                // "array form"
		                values = fetchValuesForAggregate(self, args[0], options);
		                var k = args[1];
		                if (k instanceof CellRef) {
		                    k = self.getRefData(k);
		                }
		                if (typeof k != "number") {
		                    return callback(new CalcError("VALUE"));
		                }
		            } else {
		                values = fetchValuesForAggregate(self, args, options);
		            }
		            self.func(AGGREGATE_FUNCS[funcId - 1], callback, values);
		        });
		    }).argsAsync([
		        [ "funcId", [ "values", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
		                      11, 12, 13, 14, 15, 16, 17, 18, 19 ] ],
		        [ "options", [ "or",
		                       [ "null", 0 ],
		                       [ "values", 0, 1, 2, 3, 4, 5, 6, 7  ] ] ],
		        [ "args", "rest" ]
		    ]);
	
		    defineFunction("subtotal", function(callback, funcId){
		        var self = this;
		        var ignoreHidden = funcId > 100;
		        if (ignoreHidden) {
		            funcId -= 100;
		        }
		        var args = [];
		        for (var i = 2; i < arguments.length; ++i) {
		            args.push(arguments[i]);
		        }
		        self.resolveCells(args, function(){
		            var values = fetchValuesForAggregate(self, args, ignoreHidden ? 1 : 0);
		            self.func(AGGREGATE_FUNCS[funcId - 1], callback, values);
		        });
		    }).argsAsync([
		        [ "funcId", [ "values", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
		                      101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111 ] ],
		        [ "+", [ "ref", [ "or", "ref", "#matrix" ] ] ]
		    ]);
	
		    // https://support.office.com/en-sg/article/AVEDEV-function-ec78fa01-4755-466c-9a2b-0c4f9eacaf6d
		    defineFunction("avedev", function(numbers){
		        var avg = numbers.reduce(function(sum, num){
		            return sum + num;
		        }, 0) / numbers.length;
		        return numbers.reduce(function(sum, num){
		            return sum + Math.abs(num - avg);
		        }, 0) / numbers.length;
		    }).args([
		        [ "numbers", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
		    ]);
	
		    function _binom_dist(x, n, p, cumulative) {
		        if (!cumulative) {
		            return _combinations(n, x) * Math.pow(p, x) * Math.pow(1-p, n-x);
		        } else {
		            var sum = 0;
		            for (var j = 0; j <= x; ++j) {
		                sum += _combinations(n, j) * Math.pow(p, j) * Math.pow(1-p, n-j);
		            }
		            return sum;
		        }
		    }
	
		    defineFunction("binom.dist", _binom_dist).args([
		        [ "successes", "integer+" ],
		        [ "trials", [ "and", "integer", [ "assert", "$trials >= $successes" ] ] ],
		        [ "probability", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineAlias("binomdist", "binom.dist");
	
		    defineFunction("binom.inv", function(n, p, alpha){
		        // XXX: could a binary search be faster?
		        for (var x = 0; x <= n; ++x) {
		            if (_binom_dist(x, n, p, true) >= alpha) {
		                return x;
		            }
		        }
		        return new CalcError("N/A"); // XXX: is this right?
		    }).args([
		        [ "trials", "integer+" ],
		        [ "probability", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "alpha", [ "and", "number", [ "[between]", 0, 1 ] ] ]
		    ]);
	
		    defineAlias("critbinom", "binom.inv");
	
		    defineFunction("binom.dist.range", function(n, p, s, s2){
		        var sum = 0;
		        for (var k = s; k <= s2; ++k) {
		            sum += _combinations(n, k) * Math.pow(p, k) * Math.pow(1-p, n-k);
		        }
		        return sum;
		    }).args([
		        [ "trials", "integer+" ],
		        [ "probability", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "successes_min", [ "and", "integer", [ "[between]", 0, "$trials" ] ] ],
		        [ "successes_max", [ "or",
		                             [ "and", "integer",
		                               [ "[between]", "$successes_min", "$trials" ] ],
		                             [ "null", "$successes_min" ] ] ]
		    ]);
	
		    defineFunction("negbinom.dist", function(x, k, p, cumulative){
		        if (cumulative) {
		            var sum = 0;
		            while (x >= 0) {
		                sum += _combinations(x+k-1, x) * Math.pow(p, k) * Math.pow(1-p, x);
		                x--;
		            }
		            return sum;
		        }
		        return _combinations(x+k-1, x) * Math.pow(p, k) * Math.pow(1-p, x);
		    }).args([
		        [ "number_f", "integer+" ],
		        [ "number_s", "integer+" ],
		        [ "probability_s", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineAlias("negbinomdist", "negbinom.dist");
	
		    /* -----[ lookup functions ]----- */
	
		    defineFunction("address", function(row, col, abs, a1, sheet){
		        // by some lucky coincidence, we get the corret `rel` value by just subtracting 1 from the
		        // abs argument
		        var cell = new CellRef(row - 1, col - 1, abs - 1);
		        if (sheet) {
		            cell.setSheet(sheet, true);
		        }
		        return a1 ? cell.print(0, 0) : cell.print();
		    }).args([
		        [ "row", "integer++" ],
		        [ "col", "integer++" ],
		        [ "abs", [ "or", [ "null", 1 ], [ "values", 1, 2, 3, 4 ]]],
		        [ "a1", [ "or", [ "null", true ], "logical" ]],
		        [ "sheet", [ "or", "null", "string" ]]
		    ]);
	
		    defineFunction("areas", function(ref){
		        var count = 0;
		        (function loop(x){
		            if (x instanceof CellRef || x instanceof RangeRef) {
		                count++;
		            } else if (x instanceof UnionRef) {
		                x.refs.forEach(loop);
		            }
		            // XXX: NameRef if we add support
		        })(ref);
		        return count;
		    }).args([
		        [ "ref", "ref" ]
		    ]);
	
		    defineFunction("choose", function(index, args){
		        if (index > args.length) {
		            return new CalcError("N/A");
		        } else {
		            return args[index - 1];
		        }
		    }).args([
		        [ "*index", "integer" ],
		        [ "+", [ "value", "anything" ] ]
		    ]);
	
		    defineFunction("column", function(ref){
		        if (!ref) {
		            return this.formula.col + 1;
		        }
		        if (ref instanceof CellRef) {
		            return ref.col + 1;
		        }
		        return this.asMatrix(ref).mapCol(function(col){
		            return col + ref.topLeft.col + 1;
		        });
		    }).args([
		        [ "ref", [ "or", "area", "null" ]]
		    ]);
	
		    defineFunction("columns", function(m){
		        return m instanceof Ref ? m.width() : m.width;
		    }).args([
		        [ "ref", [ "or", "area", "#matrix" ] ]
		    ]);
	
		    defineFunction("formulatext", function(ref){
		        var cell = this.getRefCells(ref)[0]; // XXX: overkill, but oh well.
		        if (!cell.formula) {
		            return new CalcError("N/A");
		        }
		        return cell.formula.print(cell.row, cell.col);
		    }).args([
		        [ "ref", "ref" ]
		    ]);
	
		    defineFunction("hlookup", function(value, m, row, approx){
		        var resultCol = null;
		        m.eachCol(function(col){
		            var data = m.get(0, col);
		            if (approx) {
		                if (data > value) {
		                    return true;
		                }
		                resultCol = col;
		            } else if (data === value) {
		                resultCol = col;
		                return true;
		            }
		        });
		        if (resultCol == null) {
		            return new CalcError("N/A");
		        }
		        return m.get(row - 1, resultCol);
		    }).args([
		        [ "value", "anyvalue" ],
		        [ "range", "matrix" ],
		        [ "row", "integer++" ],
		        [ "approx", [ "or", "logical", [ "null", true ]]]
		    ]);
	
		    defineFunction("index", function(callback, ref, row, col, areanum){
		        var self = this;
		        if (ref instanceof UnionRef) {
		            ref = ref.refs[areanum - 1];
		        }
		        if ((!row && !col) || !ref) {
		            return callback(new CalcError("N/A"));
		        }
		        if (ref instanceof CellRef) {
		            ref = ref.toRangeRef();
		        }
		        if (ref instanceof RangeRef) {
		            if (row && col) {
		                if (col > ref.width() || row > ref.height()) {
		                    return callback(new CalcError("REF"));
		                }
		                // fetching a single cell
		                var cell = ref.toCell(row - 1, col - 1);
		                self.resolveCells([ cell ], function(){
		                    callback(self.getRefData(cell));
		                });
		                return;
		            }
		            if (!row) {
		                // fetch a full column
		                var colRange = ref.toColumn(col - 1);
		                self.resolveCells([ colRange ], function(){
		                    callback(self.asMatrix(colRange));
		                });
		                return;
		            }
		            if (!col) {
		                // fetch a full row
		                var rowRange = ref.toRow(row - 1);
		                self.resolveCells([ rowRange ], function(){
		                    callback(self.asMatrix(rowRange));
		                });
		                return;
		            }
		        }
		        else if (ref instanceof Matrix) {
		            if (ref.width > 1 && ref.height > 1) {
		                if (row && col) {
		                    return callback(ref.get(row - 1, col - 1));
		                }
		                if (!row) {
		                    return callback(ref.mapRow(function(row){
		                        return ref.get(row, col - 1);
		                    }));
		                }
		                if (!col) {
		                    return callback(ref.mapCol(function(col){
		                        return ref.get(row - 1, col);
		                    }));
		                }
		            }
		            if (ref.width == 1) {
		                return callback(ref.get(row - 1, 0));
		            }
		            if (ref.height == 1) {
		                return callback(ref.get(0, col - 1));
		            }
		        }
		        else {
		            callback(new CalcError("REF"));
		        }
		    }).argsAsync([
		        [ "range", [ "or", "ref", "matrix" ] ],
		        [ "row", [ "or", "integer+", "null" ] ],
		        [ "col", [ "or", "integer+", "null" ] ],
		        [ "areanum", [ "or", "integer++", [ "null", 1 ] ] ]
		    ]);
	
		    defineFunction("indirect", function(thing){
		        try {
		            // XXX: does more work than needed.  we could go for parseReference, but that one
		            // doesn't (yet?) support "SheetName!" prefix.
		            var f = this.formula;
		            var exp = calc.parseFormula(f.sheet, f.row, f.col, thing);
		            if (!(exp.ast instanceof Ref)) {
		                throw 1;
		            }
		            return exp.ast.absolute(f.row, f.col);
		        } catch(ex) {
		            return new CalcError("REF");
		        }
		    }).args([
		        [ "thing", "string" ]
		    ]);
	
		    // XXX: LOOKUP.  seems to be deprecated in favor of HLOOKUP/VLOOKUP
	
		    // XXX: double-check this one.
		    defineFunction("match", function(val, m, type){
		        var index = 1, cmp;
		        if (type === 0) {
		            cmp = parseCriteria(val);
		        } else if (type === -1) {
		            cmp = parseCriteria("<=" + val);
		        } else if (type === 1) {
		            cmp = parseCriteria(">=" + val);
		        }
		        if (m.each(function(el){
		            if (el != null && cmp(el)) {
		                if (type !== 0 && val != el) {
		                    --index;
		                }
		                return true;
		            }
		            index++;
		        }, true) && index > 0) {
		            return index;
		        } else {
		            return new CalcError("N/A");
		        }
		    }).args([
		        [ "value", "anyvalue" ],
		        [ "range", "matrix" ],
		        [ "type", [ "or",
		                    [ "values", -1, 0, 1 ],
		                    [ "null", 1 ]]]
		    ]);
	
		    defineFunction("offset", function(ref, rows, cols, height, width){
		        var topLeft = (ref instanceof CellRef ? ref : ref.topLeft).clone();
		        topLeft.row += rows;
		        topLeft.col += cols;
		        if (topLeft.row < 0 || topLeft.col < 0) {
		            return new CalcError("VALUE");
		        }
		        if (height > 1 || width > 1) {
		            return new RangeRef(topLeft, new CellRef(topLeft.row + height - 1,
		                                                     topLeft.col + width - 1))
		                .setSheet(ref.sheet, ref.hasSheet());
		        }
		        return topLeft;
		    }).args([
		        [ "ref", "area" ],
		        [ "*rows", "integer" ],
		        [ "*cols", "integer" ],
		        [ "*height", [ "or", "integer++", [ "null", "$ref.height()" ]]],
		        [ "*width", [ "or", "integer++", [ "null", "$ref.width()" ]]]
		    ]);
	
		    defineFunction("row", function(ref){
		        if (!ref) {
		            return this.formula.row + 1;
		        }
		        if (ref instanceof CellRef) {
		            return ref.row + 1;
		        }
		        return this.asMatrix(ref).mapRow(function(row){
		            return row + ref.topLeft.row + 1;
		        });
		    }).args([
		        [ "ref", [ "or", "area", "null" ]]
		    ]);
	
		    defineFunction("rows", function(m){
		        return m instanceof Ref ? m.height() : m.height;
		    }).args([
		        [ "ref", [ "or", "area", "#matrix" ] ]
		    ]);
	
		    defineFunction("vlookup", function(value, m, col, approx){
		        var resultRow = null;
		        if (typeof value != "number") {
		            approx = false;
		        }
		        if (typeof value == "string") {
		            value = value.toLowerCase();
		        }
		        m.eachRow(function(row){
		            var data = m.get(row, 0);
		            if (approx) {
		                if (data > value) {
		                    return true;
		                }
		                resultRow = row;
		            } else {
		                if (typeof data == "string") {
		                    data = data.toLowerCase();
		                }
		                if (data === value) {
		                    resultRow = row;
		                    return true;
		                }
		            }
		        });
		        if (resultRow == null) {
		            return new CalcError("N/A");
		        }
		        return m.get(resultRow, col - 1);
		    }).args([
		        [ "value", "anyvalue" ],
		        [ "range", "matrix" ],
		        [ "col", "integer++" ],
		        [ "approx", [ "or", "logical", [ "null", true ]]]
		    ]);
	
		    /* -----[ Date and time functions ]----- */
	
		    defineFunction("date", function(year, month, date){
		        return packDate(year, month-1, date);
		    }).args([
		        [ "*year", "integer" ],
		        [ "*month", "integer" ],
		        [ "*date", "integer" ]
		    ]);
	
		    defineFunction("day", function(date){
		        return unpackDate(date).date;
		    }).args([
		        [ "*date", "date" ]
		    ]);
	
		    defineFunction("month", function(date){
		        return unpackDate(date).month + 1;
		    }).args([
		        [ "*date", "date" ]
		    ]);
	
		    defineFunction("year", function(date){
		        return unpackDate(date).year;
		    }).args([
		        [ "*date", "date" ]
		    ]);
	
		    defineFunction("weekday", function(date){
		        // XXX: TODO type
		        return unpackDate(date).day + 1;
		    }).args([
		        [ "*date", "date" ]
		    ]);
	
		    // https://support.office.com/en-GB/article/WEEKNUM-function-e5c43a03-b4ab-426c-b411-b18c13c75340
		    // XXX: this is a mess.
		    defineFunction("weeknum", function(date, type){
		        var fw = packDate(unpackDate(date).year, 0, 1);
		        var sy = unpackDate(fw);
		        var diff;
		        if (type == 21) {
		            // Monday-based weeks, first week is the one containing the first Thursday of the year
		            // we want to place in fw and sy the first Thursday
		            diff = 3 - (sy.day + 6) % 7;
		            if (diff < 0) {
		                diff += 7;
		            }
		            fw += diff;
		            sy.date += diff;
		            sy.day = 4;         // Thursday.
		            type = 1;
		        } else {
		            if (type == 1) {
		                type = 0;
		            } else if (type == 2) {
		                type = 1;
		            } else {
		                type = (type - 10) % 7;
		            }
		            // finally compatible with what we got:
		            // type == 0 means week starts on Sunday
		            //         1                      Monday
		            //         2                      Tuesday
		            // ...
		        }
		        diff = sy.day - type;
		        if (diff < 0) {
		            diff += 7;
		        }
		        fw -= diff;
		        return Math.ceil((date + 1 - fw) / 7);
		    }).args([
		        [ "*date", "date" ],
		        [ "*type", [ "or", [ "null", 1 ],
		                     [ "values", 1, 2, 11, 12, 13, 14, 15, 16, 17, 21 ] ] ]
		    ]);
	
		    function weeksInYear(year) {
		        var d = unpackDate(packDate(year, 0, 1));
		        if ((d.day == 4) || (d.day == 3 && runtime.isLeapYear(year))) {
		            // long year
		            return 53;
		        }
		        return 52;
		    }
	
		    defineFunction("isoweeknum", function isoweeknum(date){
		        // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_the_week_number_of_a_given_date
		        var d = unpackDate(date);
		        var dow = d.day || 7;
		        var wk = Math.floor((d.ord - dow + 10) / 7);
		        if (wk < 1) {
		            return weeksInYear(d.year - 1);
		        } else if (wk == 53 && wk > weeksInYear(d.year)) {
		            return 1;
		        }
		        return wk;
		    }).args([
		        [ "*date", "date" ]
		    ]);
	
		    defineFunction("now", function(){
		        return runtime.dateToSerial(new Date());
		    }).args([]);
	
		    defineFunction("today", function(){
		        return runtime.dateToSerial(new Date()) | 0;
		    }).args([]);
	
		    defineFunction("time", function(hh, mm, ss){
		        return runtime.packTime(hh, mm, ss, 0);
		    }).args([
		        [ "*hours", "integer" ],
		        [ "*minutes", "integer" ],
		        [ "*seconds", "integer" ]
		    ]);
	
		    defineFunction("hour", function(time){
		        return runtime.unpackTime(time).hours;
		    }).args([
		        [ "*time", "datetime" ]
		    ]);
	
		    defineFunction("minute", function(time){
		        return runtime.unpackTime(time).minutes;
		    }).args([
		        [ "*time", "datetime" ]
		    ]);
	
		    defineFunction("second", function(time){
		        return runtime.unpackTime(time).seconds;
		    }).args([
		        [ "*time", "datetime" ]
		    ]);
	
		    defineFunction("edate", function(base, months){
		        var d = unpackDate(base);
		        var m = d.month + months;
		        var y = d.year + Math.floor(m/12);
		        m %= 12;
		        if (m < 0) {
		            m += 12;
		        }
		        d = Math.min(d.date, daysInMonth(y, m));
		        return packDate(y, m, d);
		    }).args([
		        [ "*start_date", "date" ],
		        [ "*months", "integer" ]
		    ]);
	
		    defineFunction("eomonth", function(base, months){
		        var d = unpackDate(base);
		        var m = d.month + months;
		        var y = d.year + Math.floor(m/12);
		        m %= 12;
		        if (m < 0) {
		            m += 12;
		        }
		        d = daysInMonth(y, m);
		        return packDate(y, m, d);
		    }).args([
		        [ "*start_date", "date" ],
		        [ "*months", "integer" ]
		    ]);
	
		    defineFunction("workday", function(date, n, holidays){
		        // XXX: the algorithm here is pretty dumb, can we do better?
		        var inc = n > 0 ? 1 : -1;
		        n = Math.abs(n);
		        var dow = unpackDate(date).day;
		        while (n > 0) {
		            date += inc;
		            dow = (dow + inc) % 7;
		            if (dow > 0 && dow < 6 && holidays.indexOf(date) < 0) {
		                --n;
		            }
		        }
		        return date;
		    }).args([
		        [ "start_date", "date" ],
		        [ "days", "integer" ],
		        [ "holidays", [ "collect", "date" ] ]
		    ]);
	
		    defineFunction("networkdays", function(date, end, holidays){
		        // XXX: the algorithm here is pretty dumb, can we do better?
		        if (date > end) {
		            var tmp = date;
		            date = end;
		            end = tmp;
		        }
		        var count = 0;
		        var dow = unpackDate(date).day;
		        while (date <= end) {
		            if (dow > 0 && dow < 6 && holidays.indexOf(date) < 0) {
		                count++;
		            }
		            date++;
		            dow = (dow + 1) % 7;
		        }
		        return count;
		    }).args([
		        [ "start_date", "date" ],
		        [ "end_date", "date" ],
		        [ "holidays", [ "collect", "date" ] ]
		    ]);
	
		    defineFunction("days", function(start, end){
		        return end - start;
		    }).args([
		        [ "*start_date", "date" ],
		        [ "*end_date", "date" ]
		    ]);
	
		    function _days_360(start, end, method) {
		        var d1 = unpackDate(start);
		        var d2 = unpackDate(end);
	
		        // https://en.wikipedia.org/wiki/360-day_calendar
		        // humanity is a mess.
		        if (method) {
		            // EU method
		            if (d1.date == 31) {
		                d1.date = 30;
		            }
		            if (d2.date == 31) {
		                d2.date = 30;
		            }
		        } else {
		            // US method
		            if (d1.month == 1 && d2.month == 1
		                && d1.date == daysInMonth(d1.year, 1)
		                && d2.date == daysInMonth(d2.year, 1)) {
		                d2.date = 30;
		            }
		            if (d1.date == daysInMonth(d1.year, d1.month)) {
		                d1.date = 30;
		                if (d2.date == 31) {
		                    d2.date = 30;
		                }
		            } else {
		                if (d1.date == 30 && d2.date == 31) {
		                    d2.date = 30;
		                }
		            }
		        }
	
		        return (360 * (d2.year - d1.year)
		                + 30 * (d2.month - d1.month)
		                + (d2.date - d1.date));
		    }
	
		    runtime._days_360 = _days_360;
	
		    defineFunction("days360", _days_360).args([
		        [ "*start_date", "date" ],
		        [ "*end_date", "date" ],
		        [ "*method", [ "or", "logical", [ "null", false ] ] ]
		    ]);
	
		    defineFunction("yearfrac", function(start, end, method){
		        switch (method) {
		          case 0:
		            return _days_360(start, end, false) / 360;
		          case 1:
		            return (end - start) / daysInYear(unpackDate(start).year);
		          case 2:
		            return (end - start) / 360;
		          case 3:
		            return (end - start) / 365;
		          case 4:
		            return _days_360(start, end, true) / 360;
		        }
		    }).args([
		        [ "*start_date", "date" ],
		        [ "*end_date", "date" ],
		        [ "*method", [ "or", [ "null", 0 ], [ "values", 0, 1, 2, 3, 4 ] ] ]
		    ]);
	
		    defineFunction("datevalue", function(text){
		        var date = runtime.parseDate(text);
		        if (date) {
		            return runtime.dateToSerial(date);
		        }
		        return new CalcError("VALUE");
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("timevalue", function(text){
		        var m = text.toLowerCase().match(/(\d+):(\d+)(:(\d+)(\.(\d+))?)?\s*(am?|pm?)?/);
		        if (m) {
		            var hh = parseFloat(m[1]);
		            var mm = parseFloat(m[2]);
		            var ss = m[3] ? parseFloat(m[4]) : 0;
		            //var ms = m[5] ? parseFloat(m[6]) : 0;
		            var ampm = m[7];
		            if (ampm && (hh > 12 || hh < 1)) {
		                return new CalcError("VALUE");
		            }
		            if (/^p/.test(ampm)) {
		                hh += 12;
		            }
		            return runtime.packTime(hh, mm, ss, 0);
		        }
		        return new CalcError("VALUE");
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    /* -----[ Matrix functions ]----- */
	
		    defineFunction("mdeterm", function(m){
		        var error = m.each(function(val){
		            if (typeof val != "number") {
		                return new CalcError("VALUE");
		            }
		        }, true);
		        return error || m.determinant();
		    }).args([
		        [ "m", [ "and", "matrix",
		                 [ "assert", "$m.width == $m.height" ] ] ]
		    ]);
	
		    defineFunction("transpose", function(m){
		        return m.transpose();
		    }).args([
		        [ "range", "matrix" ]
		    ]);
	
		    defineFunction("mmult", function(a, b){
		        return a.multiply(b);
		    }).args([
		        [ "a", "matrix" ],
		        [ "b", [ "and", "matrix",
		                 [ "assert", "$b.height == $a.width" ] ] ]
		    ]);
	
		    defineFunction("munit", function(n){
		        return new Matrix(this).unit(n);
		    }).args([
		        [ "n", "integer+" ]
		    ]);
	
		    defineFunction("minverse", function(m){
		        var error = m.each(function(val){
		            if (typeof val != "number") {
		                return new CalcError("VALUE");
		            }
		        }, true);
		        return error || m.inverse() || new CalcError("VALUE");
		    }).args([
		        [ "m", [ "and", "matrix",
		                 [ "assert", "$m.width == $m.height" ] ] ]
		    ]);
	
		    /* -----[ Other ]----- */
	
		    defineFunction("rand", function() {
		        return Math.random();
		    }).args([]);
	
		    defineFunction("randbetween", function(min, max){
		        return min + Math.floor((max - min + 1) * Math.random());
		    }).args([
		        [ "min", "integer" ],
		        [ "max", [ "and", "integer", [ "assert", "$max >= $min" ] ] ]
		    ]);
	
		    defineFunction("true", function(){
		        return true;
		    }).args([]);
	
		    defineFunction("false", function(){
		        return true;
		    }).args([]);
	
		    defineFunction("roman", function(num){
		        return util.arabicToRoman(num).toUpperCase();
		    }).args([
		        [ "*number", "integer" ]
		    ]);
	
		    defineFunction("arabic", function(rom){
		        var num = util.romanToArabic(rom);
		        return num == null ? new CalcError("VALUE") : num;
		    }).args([
		        [ "*roman", "string" ]
		    ]);
	
		    defineFunction("base", function(number, radix, minLen){
		        var str = number.toString(radix).toUpperCase();
		        while (str.length < minLen) {
		            str = "0" + str;
		        }
		        return str;
		    }).args([
		        [ "*number", "integer" ],
		        [ "*radix", [ "and", "integer", [ "[between]", 2, 36 ] ] ],
		        [ "*minLen", [ "or", "integer+", [ "null", 0 ] ] ]
		    ]);
	
		    defineFunction("decimal", function(text, radix){
		        text = text.toUpperCase();
		        var val = 0;
		        for (var i = 0; i < text.length; ++i) {
		            var d = text.charCodeAt(i);
		            if (d >= 48 && d <= 57) {
		                d -= 48;
		            } else if (d >= 65 && d < (55 + radix)) {
		                d -= 55;
		            } else {
		                return new CalcError("VALUE");
		            }
		            val = val * radix + d;
		        }
		        return val;
		    }).args([
		        [ "*text", "string" ],
		        [ "*radix", [ "and", "integer", [ "[between]", 2, 36 ] ] ]
		    ]);
	
		    /* -----[ String functions ]----- */
	
		    defineFunction("char", function(code){
		        return String.fromCharCode(code);
		    }).args([
		        [ "*code", "integer+" ]
		    ]);
	
		    // From XRegExp
		    var RX_NON_PRINTABLE = /[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g;
	
		    defineFunction("clean", function(text){
		        return text.replace(RX_NON_PRINTABLE, "");
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("code", function(text){
		        return text.charAt(0);
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineAlias("unichar", "char");
		    defineAlias("unicode", "code");
	
		    defineFunction("concatenate", function(args){
		        var out = "";
		        for (var i = 0; i < args.length; ++i) {
		            out += args[i];
		        }
		        return out;
		    }).args([
		        [ "+",
		          [ "*text", "string" ] ]
		    ]);
	
		    defineFunction("dollar", function(number, decimals){
		        var format = "$#,##0DECIMALS;($#,##0DECIMALS)";
		        var dec = "";
		        var denomitator = 1;
	
		        while (decimals-- > 0) {
		          dec += "0";
		        }
	
		        while (++decimals < 0) {
		          denomitator *= 10;
		        }
	
		        if (dec !== "") {
		          dec = "." + dec;
		        } else if (denomitator !== 1) {
		            number = Math.round(number / denomitator) * denomitator;
		        }
	
		        format = format.replace(/DECIMALS/g, dec);
	
		        return spreadsheet.formatting.text(number, format);
		    }).args([
		        [ "*number", "number" ],
		        [ "*decimals", [ "or", "integer", [ "null", 2 ] ] ]
		    ]);
	
		    defineFunction("exact", function(a, b){
		        return a === b;
		    }).args([
		        [ "*text1", "string" ],
		        [ "*text2", "string" ]
		    ]);
	
		    defineFunction("find", function(substring, string, start){
		        var pos = string.indexOf(substring, start - 1);
		        return pos < 0 ? new CalcError("VALUE") : pos + 1;
		    }).args([
		        [ "*substring", "string" ],
		        [ "*string", "string" ],
		        [ "*start", [ "or", "integer++", [ "null", 1 ] ] ]
		    ]);
	
		    defineFunction("fixed", function(number, decimals, noCommas){
		        var scale = Math.pow(10, decimals);
		        number = Math.round(number * scale) / scale;
		        var format = noCommas ? "0" : "#,##0";
		        if (decimals > 0) {
		            format += ".";
		            while (decimals-- > 0) { format += "0"; }
		        }
		        return spreadsheet.formatting.text(number, format);
		    }).args([
		        [ "*number", "number" ],
		        [ "*decimals", [ "or", "integer", [ "null", 2 ] ] ],
		        [ "*noCommas", [ "or", "boolean", [ "null", false ] ] ]
		    ]);
	
		    defineFunction("left", function(text, length){
		        return text.substr(0, length);
		    }).args([
		        [ "*text", "string" ],
		        [ "*length", [ "or", "integer+", [ "null", 1 ] ] ]
		    ]);
	
		    defineFunction("right", function(text, length){
		        return text.substr(-length);
		    }).args([
		        [ "*text", "string" ],
		        [ "*length", [ "or", "integer+", [ "null", 1 ] ] ]
		    ]);
	
		    defineFunction("len", function(text){
		        return text.length;
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("lower", function(text){
		        return text.toLowerCase();
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("upper", function(text){
		        return text.toUpperCase();
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("ltrim", function(text){
		        return text.replace(/^\s+/, "");
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("rtrim", function(text){
		        return text.replace(/\s+$/, "");
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("trim", function(text){
		        return text.replace(/^\s+|\s+$/, "");
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("mid", function(text, start, length){
		        return text.substr(start - 1, length);
		    }).args([
		        [ "*text", "string" ],
		        [ "*start", "integer++" ],
		        [ "*length", "integer+" ]
		    ]);
	
		    defineFunction("proper", function(text){
		        return text.toLowerCase().replace(/\b./g, function(s){
		            return s.toUpperCase();
		        });
		    }).args([
		        [ "*text", "string" ]
		    ]);
	
		    defineFunction("replace", function(text, start, length, newText){
		        return text.substr(0, --start) + newText + text.substr(start + length);
		    }).args([
		        [ "*text", "string" ],
		        [ "*start", "integer++" ],
		        [ "*length", "integer+" ],
		        [ "*newText", "string" ]
		    ]);
	
		    defineFunction("rept", function(text, number){
		        var out = "";
		        while (number-- > 0) { out += text; }
		        return out;
		    }).args([
		        [ "*text", "string" ],
		        [ "*number", "integer+" ]
		    ]);
	
		    defineFunction("search", function(substring, string, start){
		        var pos = string.toLowerCase().indexOf(substring.toLowerCase(), start - 1);
		        return pos < 0 ? new CalcError("VALUE") : pos + 1;
		    }).args([
		        [ "*substring", "string" ],
		        [ "*string", "string" ],
		        [ "*start", [ "or", "integer++", [ "null", 1 ] ] ]
		    ]);
	
		    defineFunction("substitute", function(text, oldText, newText, nth){
		        if (oldText === newText) {
		            return text;
		        }
		        var pos = -1;
		        function replace() {
		            text = text.substring(0, pos) + newText + text.substring(pos + oldText.length);
		        }
		        while ((pos = text.indexOf(oldText, pos + 1)) >= 0) {
		            if (nth == null) {
		                replace();
		            } else if (--nth === 0) {
		                replace();
		                break;
		            }
		        }
		        return text;
		    }).args([
		        [ "*text", "string" ],
		        [ "*oldText", "string" ],
		        [ "*newText", "string" ],
		        [ "*nth", [ "or", "integer++", "null" ] ]
		    ]);
	
		    defineFunction("t", function(value){
		        return typeof value == "string" ? value : "";
		    }).args([
		        [ "*value", "anyvalue" ]
		    ]);
	
		    defineFunction("text", function(value, format){
		        return spreadsheet.formatting.text(value, format);
		    }).args([
		        [ "*value", "anyvalue" ],
		        [ "*format", "string" ]
		    ]);
	
		    defineFunction("value", function(value){
		        if (typeof value == "number") {
		            return value;
		        }
		        if (typeof value == "boolean") {
		            return +value;
		        }
		        // XXX: this is dirty.  we need it so we can parse i.e. "$12,345.50"
		        value = (value+"").replace(/[$€,]/g, "");
		        value = parseFloat(value);
		        return isNaN(value) ? new CalcError("VALUE") : value;
		    }).args([
		        [ "*value", "anyvalue" ]
		    ]);
	
		    function Hyperlink(link, text) {
		        this.link = link;
		        this.text = text;
		    }
		    Hyperlink.prototype.toString = function() {
		        return this.text;
		    };
	
		    defineFunction("hyperlink", function(link, text){
		        return new Hyperlink(link, text);
		    }).args([
		        [ "*link", "string" ],
		        [ "*text", [ "or", "string", [ "null", "$link" ] ] ]
		    ]);
	
		    //// other misc functions
	
		    defineFunction("iferror", function(value, valueIfError){
		        return value instanceof CalcError ? valueIfError : value;
		    }).args([
		        [ "*value", "forced!" ],
		        [ "*value_if_error", "anyvalue!" ]
		    ]);
	
		    //// utils
	
		    var parseCriteria = (function(){
		        var RXCACHE = Object.create(null);
	
		        function makeComparator(cmp, x) {
		            if (typeof x == "string") {
		                var num = parseFloat(x);
		                if (!isNaN(num) && num == x) {
		                    x = num;
		                }
		            }
		            return function(a) {
		                var b = x;
		                if (typeof a == "string" && typeof b == "string") {
		                    a = a.toLowerCase();
		                    b = b.toLowerCase();
		                }
		                return cmp(a, b);
		            };
		        }
	
		        function lc(a) {
		            var num, str;
		            if (typeof a == "string") {
		                a = a.toLowerCase();
		            }
		            if (/^[0-9.]+%$/.test(a)) {
		                str = a.substr(0, a.length - 1);
		                num = parseFloat(str);
		                if (!isNaN(num) && num == str) {
		                    a = num / 100;
		                }
		            } else if (/^[0-9.]+$/.test(a)) {
		                num = parseFloat(a);
		                if (!isNaN(num) && num == a) {
		                    a = num;
		                }
		            }
		            return a;
		        }
	
		        function compLT(a, b) { return lc(a) < lc(b); }
		        function compLTE(a, b) { return lc(a) <= lc(b); }
		        function compGT(a, b) { return lc(a) > lc(b); }
		        function compGTE(a, b) { return lc(a) >= lc(b); }
		        function compNE(a, b) { return !compEQ(a, b); }
		        function compEQ(a, b) {
		            if (b instanceof RegExp) {
		                return b.test(a);
		            }
		            if (typeof a == "string" || typeof b == "string") {
		                // if either one is string, make sure both are strings
		                a = String(a);
		                b = String(b);
		            }
		            return lc(a) == lc(b);
		        }
	
		        return function(cmp) {
		            if (typeof cmp == "function") {
		                return cmp;
		            }
		            var m;
		            if ((m = /^=(.*)$/.exec(cmp))) {
		                return makeComparator(compEQ, m[1]);
		            }
		            if ((m = /^<>(.*)$/.exec(cmp))) {
		                return makeComparator(compNE, m[1]);
		            }
		            if ((m = /^<=(.*)$/.exec(cmp))) {
		                return makeComparator(compLTE, m[1]);
		            }
		            if ((m = /^<(.*)$/.exec(cmp))) {
		                return makeComparator(compLT, m[1]);
		            }
		            if ((m = /^>=(.*)$/.exec(cmp))) {
		                return makeComparator(compGTE, m[1]);
		            }
		            if ((m = /^>(.*)$/.exec(cmp))) {
		                return makeComparator(compGT, m[1]);
		            }
		            if (/[?*]/.exec(cmp)) {
		                // has wildchars
		                var rx = RXCACHE[cmp];
		                if (!rx) {
		                    rx = cmp.replace(/(~\?|~\*|[\]({\+\.\|\^\$\\})\[]|[?*])/g, function(s){
		                        switch (s) {
		                          case "~?" : return "\\?";
		                          case "~*" : return "\\*";
		                          case "?"  : return ".";
		                          case "*"  : return ".*";
		                          default   : return "\\" + s;
		                        }
		                    });
		                    rx = RXCACHE[cmp] = new RegExp("^" + rx + "$", "i");
		                }
		                return makeComparator(compEQ, rx);
		            }
		            return makeComparator(compEQ, cmp);
		        };
		    })();
	
		    function numericPredicate(val) {
		        return typeof val == "number"
		            || typeof val == "boolean"
		            || val == null
		            || val === "";
		    }
	
		    function ascending(a, b) {
		        return a === b ? 0 : a < b ? -1 : 1;
		    }
	
		    function descending(a, b) {
		        return a === b ? 0 : a < b ? 1 : -1;
		    }
	
		    // var m = new Matrix();
		    // m.data = [[1, 2, 3], [4, 1, 6], [7, 8, 9]];
		    // //m.data = [[0, 2, 1], [2, 6, 1], [1, 1, 4]];
		    // //m.data = [[1,4,1,1], [1,4,0,1], [2,3,1,2], [3,2,6,4]];
		    // m.width = m.height = 3;
		    // var x = m.inverse();
		    // x.dump();
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1497);
		module.exports = __webpack_require__(1497);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1450:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ }),
	
	/***/ 1497:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1450) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    // WARNING: removing the following jshint declaration and turning
		    // == into === to make JSHint happy will break functionality.
		    /* jshint eqnull:true, newcap:false, laxbreak:true, validthis:true */
		    /* jshint latedef: nofunc */
	
		    var spreadsheet = kendo.spreadsheet;
		    var calc = spreadsheet.calc;
		    var runtime = calc.runtime;
		    var defineFunction = runtime.defineFunction;
		    var CalcError = runtime.CalcError;
		    var packDate = runtime.packDate;
		    var unpackDate = runtime.unpackDate;
		    var isLeapYear = runtime.isLeapYear;
		    var daysInMonth = runtime.daysInMonth;
		    var _days_360 = runtime._days_360;
	
		    /* -----[ Spreadsheet API ]----- */
	
		    defineFunction("ERF", function(ll, ul) {
		        if (ul == null) {
		            return ERF(ll);
		        }
		        return ERF(ul) - ERF(ll);
		    }).args([
		        [ "lower_limit", "number" ],
		        [ "upper_limit", [ "or", "number", "null" ] ]
		    ]);
	
		    defineFunction("ERFC", ERFC).args([
		        [ "x", "number" ]
		    ]);
	
		    defineFunction("GAMMALN", GAMMALN).args([
		        [ "x", "number++" ]
		    ]);
	
		    defineFunction("GAMMA", GAMMA).args([
		        [ "x", "number" ]
		    ]);
	
		    defineFunction("GAMMA.DIST", GAMMA_DIST).args([
		        [ "x", "number+" ],
		        [ "alpha", "number++" ],
		        [ "beta", "number++" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("GAMMA.INV", GAMMA_INV).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "alpha", "number++" ],
		        [ "beta", "number++" ]
		    ]);
	
		    defineFunction("NORM.S.DIST", NORM_S_DIST).args([
		        [ "z", "number" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("NORM.S.INV", NORM_S_INV).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ]
		    ]);
	
		    defineFunction("NORM.DIST", NORM_DIST).args([
		        [ "x", "number" ],
		        [ "mean", "number" ],
		        [ "stddev", "number++" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("NORM.INV", NORM_INV).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "mean", "number" ],
		        [ "stddev", "number++" ]
		    ]);
	
		    defineFunction("BETADIST", BETADIST).args([
		        [ "x", "number" ],
		        [ "alpha", "number++" ],
		        [ "beta", "number++" ],
		        [ "A", [ "or", "number", [ "null", 0 ] ] ],
		        [ "B", [ "or", "number", [ "null", 1 ] ] ],
		        [ "?", [ "assert", "$x >= $A", "NUM" ] ],
		        [ "?", [ "assert", "$x <= $B", "NUM" ] ],
		        [ "?", [ "assert", "$A < $B", "NUM" ] ]
		    ]);
	
		    defineFunction("BETA.DIST", BETA_DIST).args([
		        [ "x", "number" ],
		        [ "alpha", "number++" ],
		        [ "beta", "number++" ],
		        [ "cumulative", "logical" ],
		        [ "A", [ "or", "number", [ "null", 0 ] ] ],
		        [ "B", [ "or", "number", [ "null", 1 ] ] ],
		        [ "?", [ "assert", "$x >= $A", "NUM" ] ],
		        [ "?", [ "assert", "$x <= $B", "NUM" ] ],
		        [ "?", [ "assert", "$A < $B", "NUM" ] ]
		    ]);
	
		    defineFunction("BETA.INV", BETA_INV).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "alpha", "number++" ],
		        [ "beta", "number++" ],
		        [ "A", [ "or", "number", [ "null", 0 ] ] ],
		        [ "B", [ "or", "number", [ "null", 1 ] ] ]
		    ]);
	
		    defineFunction("CHISQ.DIST", chisq_left).args([
		        [ "x", "number+" ],
		        [ "deg_freedom", "integer++" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("CHISQ.DIST.RT", chisq_right).args([
		        [ "x", "number+" ],
		        [ "deg_freedom", "integer++" ]
		    ]);
	
		    defineFunction("CHISQ.INV", chisq_left_inv).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "deg_freedom", "integer++" ]
		    ]);
	
		    defineFunction("CHISQ.INV.RT", chisq_right_inv).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "deg_freedom", "integer++" ]
		    ]);
	
		    defineFunction("CHISQ.TEST", function(ac, ex){
		        return chisq_test(ac.data, ex.data);
		    }).args([
		        [ "actual_range", "matrix" ],
		        [ "expected_range", "matrix" ],
		        [ "?", [ "assert", "$actual_range.width == $expected_range.width" ] ],
		        [ "?", [ "assert", "$actual_range.height == $expected_range.height" ] ]
		    ]);
	
		    defineFunction("EXPON.DIST", expon).args([
		        [ "x", "number+" ],
		        [ "lambda", "number++" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("POISSON.DIST", poisson).args([
		        [ "x", "integer+" ],
		        [ "mean", "number+" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("F.DIST", Fdist).args([
		        [ "x", "number+" ],
		        [ "deg_freedom1", "integer++" ],
		        [ "deg_freedom2", "integer++" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("F.DIST.RT", Fdist_right).args([
		        [ "x", "number+" ],
		        [ "deg_freedom1", "integer++" ],
		        [ "deg_freedom2", "integer++" ]
		    ]);
	
		    defineFunction("F.INV", Finv).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "deg_freedom1", "integer++" ],
		        [ "deg_freedom2", "integer++" ]
		    ]);
	
		    defineFunction("F.INV.RT", Finv_right).args([
		        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
		        [ "deg_freedom1", "integer++" ],
		        [ "deg_freedom2", "integer++" ]
		    ]);
	
		    defineFunction("F.TEST", Ftest).args([
		        [ "array1", [ "collect", "number", 1 ] ],
		        [ "array2", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$array1.length >= 2", "DIV/0" ] ],
		        [ "?", [ "assert", "$array2.length >= 2", "DIV/0" ] ]
		    ]);
	
		    defineFunction("FISHER", fisher).args([
		        [ "x", [ "and", "number", [ "(between)", -1, 1 ] ] ]
		    ]);
	
		    defineFunction("FISHERINV", fisherinv).args([
		        [ "y", "number" ]
		    ]);
	
		    defineFunction("T.DIST", Tdist).args([
		        [ "x", "number" ],
		        [ "deg_freedom", "integer++" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("T.DIST.RT", Tdist_right).args([
		        [ "x", "number" ],
		        [ "deg_freedom", "integer++" ]
		    ]);
	
		    defineFunction("T.DIST.2T", Tdist_2tail).args([
		        [ "x", "number+" ],
		        [ "deg_freedom", "integer++" ]
		    ]);
	
		    defineFunction("T.INV", Tdist_inv).args([
		        [ "p", [ "and", "number", [ "(between]", 0, 1 ] ] ],
		        [ "deg_freedom", "integer++" ]
		    ]);
	
		    defineFunction("T.INV.2T", Tdist_2tail_inv).args([
		        [ "p", [ "and", "number", [ "(between]", 0, 1 ] ] ],
		        [ "deg_freedom", "integer++" ]
		    ]);
	
		    defineFunction("T.TEST", Tdist_test).args([
		        [ "array1", [ "collect", "number", 1 ] ],
		        [ "array2", [ "collect", "number", 1 ] ],
		        [ "tails", [ "and", "integer", [ "values", 1, 2 ] ] ],
		        [ "type", [ "and", "integer", [ "values", 1, 2, 3 ] ] ],
		        [ "?", [ "assert", "$type != 1 || $array1.length == $array2.length", "N/A" ] ],
		        [ "?", [ "assert", "$array1.length >= 2", "DIV/0" ] ],
		        [ "?", [ "assert", "$array2.length >= 2", "DIV/0" ] ]
		    ]);
	
		    defineFunction("CONFIDENCE.T", confidence_t).args([
		        [ "alpha", [ "and", "number", [ "(between)", 0, 1 ] ] ],
		        [ "standard_dev", "number++" ],
		        [ "size", [ "and", "integer++",
		                    [ "assert", "$size != 1", "DIV/0" ] ] ]
		    ]);
	
		    defineFunction("CONFIDENCE.NORM", confidence_norm).args([
		        [ "alpha", [ "and", "number", [ "(between)", 0, 1 ] ] ],
		        [ "standard_dev", "number++" ],
		        [ "size", [ "and", "integer++" ] ]
		    ]);
	
		    defineFunction("GAUSS", gauss).args([
		        [ "z", "number" ]
		    ]);
	
		    defineFunction("PHI", phi).args([
		        [ "x", "number" ]
		    ]);
	
		    defineFunction("LOGNORM.DIST", lognorm_dist).args([
		        [ "x", "number++" ],
		        [ "mean", "number" ],
		        [ "standard_dev", "number++" ],
		        [ "cumulative", "logical" ]
		    ]);
	
		    defineFunction("LOGNORM.INV", lognorm_inv).args([
		        [ "probability", [ "and", "number", [ "(between)", 0, 1 ] ] ],
		        [ "mean", "number" ],
		        [ "standard_dev", "number++" ]
		    ]);
	
		    defineFunction("PROB", prob).args([
		        [ "x_range", [ "collect", "number", 1 ] ],
		        [ "prob_range", [ "collect", "number", 1 ] ],
		        [ "lower_limit", "number" ],
		        [ "upper_limit", [ "or", "number", [ "null", "$lower_limit" ] ] ],
		        [ "?", [ "assert", "$prob_range.length == $x_range.length", "N/A" ] ]
		    ]);
	
		    defineFunction("SLOPE", slope).args([
		        [ "known_y", [ "collect", "number", 1 ] ],
		        [ "known_x", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
		        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ]
		    ]);
	
		    defineFunction("INTERCEPT", intercept).args([
		        [ "known_y", [ "collect", "number", 1 ] ],
		        [ "known_x", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
		        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ]
		    ]);
	
		    defineFunction("PEARSON", pearson).args([
		        [ "array1", [ "collect!", "anything", 1 ] ],
		        [ "array2", [ "collect!", "anything", 1 ] ],
		        [ "?", [ "assert", "$array2.length == $array1.length", "N/A" ] ],
		        [ "?", [ "assert", "$array2.length > 0 && $array1.length > 0", "N/A" ] ]
		    ]);
	
		    defineFunction("RSQ", rsq).args([
		        [ "known_y", [ "collect", "number", 1 ] ],
		        [ "known_x", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
		        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ],
		        [ "?", [ "assert", "$known_x.length != 1 && $known_y.length != 1", "N/A" ] ]
		    ]);
	
		    defineFunction("STEYX", steyx).args([
		        [ "known_y", [ "collect", "number", 1 ] ],
		        [ "known_x", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
		        [ "?", [ "assert", "$known_x.length >= 3 && $known_y.length >= 3", "DIV/0" ] ]
		    ]);
	
		    defineFunction("FORECAST", forecast).args([
		        [ "x", "number" ],
		        [ "known_y", [ "collect", "number", 1 ] ],
		        [ "known_x", [ "collect", "number", 1 ] ],
		        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
		        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ]
		    ]);
	
		    defineFunction("LINEST", linest).args([
		        [ "known_y", "matrix" ],
		        [ "known_x", [ "or", "matrix", "null" ] ],
		        [ "const", [ "or", "logical", [ "null", true ] ] ],
		        [ "stats", [ "or", "logical", [ "null", false ] ] ]
		    ]);
	
		    defineFunction("LOGEST", logest).args([
		        [ "known_y", "matrix" ],
		        [ "known_x", [ "or", "matrix", "null" ] ],
		        [ "const", [ "or", "logical", [ "null", true ] ] ],
		        [ "stats", [ "or", "logical", [ "null", false ] ] ]
		    ]);
	
		    defineFunction("TREND", trend).args([
		        [ "known_y", "matrix" ],
		        [ "known_x", [ "or", "matrix", "null" ] ],
		        [ "new_x", [ "or", "matrix", "null" ] ],
		        [ "const", [ "or", "logical", [ "null", true ] ] ]
		    ]);
	
		    defineFunction("GROWTH", growth).args([
		        [ "known_y", "matrix" ],
		        [ "known_x", [ "or", "matrix", "null" ] ],
		        [ "new_x", [ "or", "matrix", "null" ] ],
		        [ "const", [ "or", "logical", [ "null", true ] ] ]
		    ]);
	
		    defineFunction("FV", FV).args([
		        [ "rate", "number" ],
		        [ "nper", "number" ],
		        [ "pmt", [ "or", "number", [ "null", 0 ] ] ],
		        [ "pv", [ "or", "number", [ "null", 0 ] ] ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
		        [ "?", [ "assert", "$pmt || $pv" ] ]
		    ]);
	
		    defineFunction("PV", PV).args([
		        [ "rate", "number" ],
		        [ "nper", "number" ],
		        [ "pmt", [ "or", "number", [ "null", 0 ] ] ],
		        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ]
		    ]);
	
		    defineFunction("PMT", PMT).args([
		        [ "rate", "number" ],
		        [ "nper", "number" ],
		        [ "pmt", "number" ],
		        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ]
		    ]);
	
		    defineFunction("NPER", NPER).args([
		        [ "rate", "number" ],
		        [ "pmt", "number" ],
		        [ "pv", "number" ],
		        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ]
		    ]);
	
		    defineFunction("RATE", RATE).args([
		        [ "nper", "number" ],
		        [ "pmt", [ "or", "number", [ "null", 0 ] ] ],
		        [ "pv", "number" ],
		        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
		        [ "guess", [ "or", "number++", [ "null", 0.01 ] ] ],
		        [ "?", [ "assert", "$pmt || $fv" ] ]
		    ]);
	
		    defineFunction("IPMT", IPMT).args([
		        [ "rate", "number" ],
		        [ "per", "number++" ],
		        [ "nper", "number++" ],
		        [ "pv", "number" ],
		        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
		        [ "?", [ "assert", "$per >= 1 && $per <= $nper" ] ]
		    ]);
	
		    defineFunction("PPMT", PPMT).args([
		        [ "rate", "number" ],
		        [ "per", "number++" ],
		        [ "nper", "number++" ],
		        [ "pv", "number" ],
		        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
		        [ "?", [ "assert", "$per >= 1 && $per <= $nper" ] ]
		    ]);
	
		    defineFunction("CUMPRINC", CUMPRINC).args([
		        [ "rate", "number++" ],
		        [ "nper", "number++" ],
		        [ "pv", "number++" ],
		        [ "start_period", "number++" ],
		        [ "end_period", "number++" ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
		        [ "?", [ "assert", "$end_period >= $start_period", "NUM" ] ]
		    ]);
	
		    defineFunction("CUMIPMT", CUMIPMT).args([
		        [ "rate", "number++" ],
		        [ "nper", "number++" ],
		        [ "pv", "number++" ],
		        [ "start_period", "number++" ],
		        [ "end_period", "number++" ],
		        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
		        [ "?", [ "assert", "$end_period >= $start_period", "NUM" ] ]
		    ]);
	
		    defineFunction("NPV", NPV).args([
		        [ "rate", "number" ],
		        [ "values", [ "collect", "number" ] ],
		        [ "?", [ "assert", "$values.length > 0", "N/A" ] ]
		    ]);
	
		    defineFunction("IRR", IRR).args([
		        [ "values", [ "collect", "number", 1 ] ],
		        [ "guess", [ "or", "number", [ "null", 0.1 ] ] ]
		    ]);
	
		    defineFunction("EFFECT", EFFECT).args([
		        [ "nominal_rate", "number++" ],
		        [ "npery", "integer++" ]
		    ]);
	
		    defineFunction("NOMINAL", NOMINAL).args([
		        [ "effect_rate", "number++" ],
		        [ "npery", "integer++" ]
		    ]);
	
		    defineFunction("XNPV", XNPV).args([
		        [ "rate", "number" ],
		        [ "values", [ "collect", "number", 1 ] ],
		        [ "dates", [ "collect", "date", 1 ] ],
		        [ "?", [ "assert", "$values.length == $dates.length", "NUM" ] ]
		    ]);
	
		    defineFunction("XIRR", XIRR).args([
		        [ "values", [ "collect", "number", 1 ] ],
		        [ "dates", [ "collect", "date", 1 ] ],
		        [ "guess", [ "or", "number", [ "null", 0.1 ] ] ],
		        [ "?", [ "assert", "$values.length == $dates.length", "NUM" ] ]
		    ]);
	
		    defineFunction("ISPMT", ISPMT).args([
		        [ "rate", "number" ],
		        [ "per", "number++" ],
		        [ "nper", "number++" ],
		        [ "pv", "number" ],
		        [ "?", [ "assert", "$per >= 1 && $per <= $nper" ] ]
		    ]);
	
		    defineFunction("DB", DB).args([
		        [ "cost", "number" ],
		        [ "salvage", "number" ],
		        [ "life", "number++" ],
		        [ "period", "number++" ],
		        [ "month", [ "or", "number", [ "null", 12 ] ] ]
		    ]);
	
		    defineFunction("DDB", DDB).args([
		        [ "cost", "number" ],
		        [ "salvage", "number" ],
		        [ "life", "number++" ],
		        [ "period", "number++" ],
		        [ "factor", [ "or", "number", [ "null", 2 ] ] ]
		    ]);
	
		    defineFunction("SLN", SLN).args([
		        [ "cost", "number" ],
		        [ "salvage", "number" ],
		        [ "life", "number++" ]
		    ]);
	
		    defineFunction("SYD", SYD).args([
		        [ "cost", "number" ],
		        [ "salvage", "number" ],
		        [ "life", "number++" ],
		        [ "per", "number++" ]
		    ]);
	
		    defineFunction("VDB", VDB).args([
		        [ "cost", "number+" ],
		        [ "salvage", "number+" ],
		        [ "life", "number++" ],
		        [ "start_period", "number+" ],
		        [ "end_period", "number+" ],
		        [ "factor", [ "or", "number+", [ "null", 2 ] ] ],
		        [ "no_switch", [ "or", "logical", [ "null", false ] ] ],
		        [ "?", [ "assert", "$end_period >= $start_period", "NUM" ] ]
		    ]);
	
		    var COUPS_ARGS = [
		        [ "settlement", "date" ],
		        [ "maturity", "date" ],
		        [ "frequency", [ "and", "integer", [ "values", 1, 2, 4 ] ] ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
		    ];
	
		    defineFunction("COUPDAYBS", COUPDAYBS).args(COUPS_ARGS);
	
		    defineFunction("COUPDAYS", COUPDAYS).args(COUPS_ARGS);
	
		    defineFunction("COUPDAYSNC", COUPDAYSNC).args(COUPS_ARGS);
	
		    defineFunction("COUPPCD", COUPPCD).args(COUPS_ARGS);
	
		    defineFunction("COUPNCD", COUPNCD).args(COUPS_ARGS);
	
		    defineFunction("COUPNUM", COUPNUM).args(COUPS_ARGS);
	
		    defineFunction("ACCRINTM", ACCRINTM).args([
		        [ "issue", "date" ],
		        [ "settlement", "date" ],
		        [ "rate", "number++" ],
		        [ "par", [ "or", [ "null", 1000 ], "number++" ] ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "?", [ "assert", "$issue < $settlement", "NUM" ] ]
		    ]);
	
		    defineFunction("ACCRINT", ACCRINT).args([
		        [ "issue", "date" ],
		        [ "first_interest", "date" ],
		        [ "settlement", "date" ],
		        [ "rate", "number++" ],
		        [ "par", [ "or", [ "null", 1000 ], "number++" ] ],
		        [ "frequency", [ "and", "integer", [ "values", 1, 2, 4 ] ] ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "calc_method", [ "or", "logical", [ "null", true ] ] ],
		        [ "?", [ "assert", "$issue < $settlement", "NUM" ] ]
		    ]);
	
		    defineFunction("DISC", DISC).args([
		        [ "settlement", "date" ],
		        [ "maturity", "date" ],
		        [ "pr", "number++" ],
		        [ "redemption", "number++" ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
		    ]);
	
		    defineFunction("INTRATE", INTRATE).args([
		        [ "settlement", "date" ],
		        [ "maturity", "date" ],
		        [ "investment", "number++" ],
		        [ "redemption", "number++" ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
		    ]);
	
		    defineFunction("RECEIVED", RECEIVED).args([
		        [ "settlement", "date" ],
		        [ "maturity", "date" ],
		        [ "investment", "number++" ],
		        [ "discount", "number++" ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
		    ]);
	
		    defineFunction("PRICE", PRICE).args([
		        [ "settlement", "date" ],
		        [ "maturity", "date" ],
		        [ "rate", "number++" ],
		        [ "yld", "number++" ],
		        [ "redemption", "number++" ],
		        [ "frequency", [ "and", "integer", [ "values", 1, 2, 4 ] ] ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
		    ]);
	
		    defineFunction("PRICEDISC", PRICEDISC).args([
		        [ "settlement", "date" ],
		        [ "maturity", "date" ],
		        [ "discount", "number++" ],
		        [ "redemption", "number++" ],
		        [ "basis", [ "or", [ "null", 0 ],
		                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
		        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
		    ]);
	
		    /* -----[ utils ]----- */
	
		    // function resultAsMatrix(f) {
		    //     return function() {
		    //         var a = f.apply(this, arguments);
		    //         return this.asMatrix(a);
		    //     };
		    // }
	
		    /* -----[ definitions: statistical functions ]----- */
	
		    var MAX_IT = 300,     // Maximum allowed number of iterations
		        EPS = 2.2204e-16, // Relative accuracy; 1-3*(4/3-1) = 2.220446049250313e-16
		        FP_MIN = 1.0e-30, // Near the smallest representable as floating-point, number.
		        f_abs = Math.abs;
	
		    function ERF(x) {
		        if (f_abs(x) >= 3.3) {
		            return 1 - ERFC(x);
		        }
		        var S = x > 0 ? 1 : -1;
		        if (S == -1) {
		            x = -x;
		        }
		        var m = 0, an = 1;
		        for (var n = 1; n < 100; n++) {
		            m += an;
		            an *= 2*x*x/(2*n+1);
		        }
		        return S*2/Math.sqrt(Math.PI)*x*Math.exp(-x*x)*m;
		    }
	
		    function ERFC(x) {
		        if (f_abs(x) < 3.3) {
		            return 1 - ERF(x);
		        }
		        var s = 1;
		        if (x < 0) {
		            s = -1;
		            x = -x;
		        }
		        var frac = x;
		        for (var n = 8; n >= 1; n -= 0.5) {
		            frac = x + n/frac;
		        }
		        frac = 1 / (x + frac);
		        return s == 1
		            ? Math.exp(-x*x)/Math.sqrt(Math.PI)*frac
		            : 2 - Math.exp(-x*x)/Math.sqrt(Math.PI)*frac;
		    }
	
		    function GAMMALN(x) { // Returns the value ln[Γ(x)] for x > 0.
		        var cof = [
		            1.000000000190015, 76.18009172947146, -86.50532032941677,
		            24.01409824083091, -1.231739572450155, 0.1208650973866179e-2, -0.5395239384953e-5
		        ];
		        var y = x, tmp = x + 5.5, ser = cof[0];
		        tmp -= (x + 0.5) * Math.log(tmp);
		        for (var j = 1; j <= 6; j++) {
		            y += 1;
		            ser += cof[j] / y;
		        }
		        return -tmp + Math.log(Math.sqrt(2*Math.PI) * ser / x); // log(Γ(x)) = log(Γ(x+1)) - log(x)
		    }
	
		    function GAMMA(x) { // returns Infinity for 0 or negative _integer argument.
		        if (x > 0) {
		            return Math.exp(GAMMALN(x));
		        }
		        var pi = Math.PI, y = -x; // For x<0 we use the reflection formula: Γ(x)Γ(1-x) = PI / sin(PI*x)
		        return -pi / (y*GAMMA(y)*Math.sin(pi*y));
		    }
	
		    function BETALN(a, b) {
		        return GAMMALN(a) + GAMMALN(b) - GAMMALN(a+b);
		    }
	
		    function BETA(a, b) {
		        return Math.exp(BETALN(a, b));
		    }
	
		    function gamma_inc(a, x) { // returns the normalized incomplete gamma function P(a, x); x > 0.
		        return x < a+1.0 ? g_series(a, x) : 1 - g_contfrac(a, x);
		    }
	
		    function g_series(a, x) { // evaluate P(a, x) by its series representation (converges quickly for x < a+1).
		        var sum = 1/a,
		            frac = sum,
		            ap = a;
		        var gln = GAMMALN(a), n;
		        for (n = 1; n <= MAX_IT; n++) {
		            ap++;
		            frac *= x/ap;
		            sum += frac;
		            if (f_abs(frac) < f_abs(sum)*EPS) {
		                break; // already the last frac is too small versus the current sum value
		            }
		        }
		        return sum * Math.exp(-x + a*Math.log(x) - gln); // e^{-x} * x^a * Γ(a) * sum
		    }
	
		    function g_contfrac(a, x) { // Q(a, x) by its continued fraction representation (converges quickly for x > a + 1); modified Lentz’s method (Numerical Recipes (The Art of Scientific Computing), 2rd Edition $5.2)
		        var f = FP_MIN, c = f, d = 0, aj = 1, bj = x + 1 - a;
		        var gln = GAMMALN(a);
		        for (var i = 1; i <= MAX_IT; i++) {
		            d = bj + aj * d;
			    if (f_abs(d) < FP_MIN) {
		                d = FP_MIN;
		            }
			    c = bj + aj / c;
			    if (f_abs(c) < FP_MIN) {
		                c = FP_MIN;
		            }
			    d = 1 / d;
			    var delta = c * d;
			    f *= delta;
		    	    if (f_abs(delta - 1) < EPS) {
		                break;
		            }
			    bj += 2;
			    aj = -i * (i - a);
			}
			return f * Math.exp(-x - gln + a * Math.log(x));
		    }
	
		    function GAMMA_DIST(x, a, b, cumulative) { // a > 0, b > 0; x >= 0
		        if (!cumulative) {
		            return Math.pow(x/b, a-1)*Math.exp(-x/b)/(b*GAMMA(a)); // the PDF of the Gamma distribution
		        }
		        return gamma_inc(a, x/b); // (else) compute the CDF (using the incomplete Gamma function)
		    }
	
		    function GAMMA_INV(p, a, b) { // the quantile function of the Gamma distribution
			if (p === 0) {
		            return 0;
		        }
			if (p == 1) {
		            return Infinity;
		        }
			var m = 0, M = 10, x = 0, ab = a*b;
			if (ab > 1) {
		            M *= ab;
		        }
			for (var i = 0; i < MAX_IT; i++) {
			    x = 0.5*(m + M); // console.log(x);
			    var q = GAMMA_DIST(x, a, b, true);
			    if (f_abs(p - q) < 1e-16) {
		                break;
		            }
			    if (q > p) {
		                M = x;
		            } else {
		                m = x;
		            }
			}
			return x;
		    }
	
		    function NORM_S_DIST(x, cumulative) {
		        if (!cumulative) {
		            return Math.exp(-x*x/2)/Math.sqrt(2*Math.PI);
		        }
		        return 0.5 + 0.5*ERF(x/Math.sqrt(2));
		    }
	
		    function NORM_S_INV(p) { // see [1] $26.2.3 and http://home.online.no/~pjacklam/notes/invnorm/#References
		        // Coefficients in rational approximations.
		        var a = [-3.969683028665376e+01,  2.209460984245205e+02,
		                 -2.759285104469687e+02,  1.383577518672690e+02,
		                 -3.066479806614716e+01,  2.506628277459239e+00],
		            b = [-5.447609879822406e+01,  1.615858368580409e+02,
		                 -1.556989798598866e+02,  6.680131188771972e+01,
		                 -1.328068155288572e+01],
		            c = [-7.784894002430293e-03, -3.223964580411365e-01,
		                 -2.400758277161838e+00, -2.549732539343734e+00,
		                 4.374664141464968e+00,  2.938163982698783e+00],
		            d = [ 7.784695709041462e-03,  3.224671290700398e-01,
		                  2.445134137142996e+00,  3.754408661907416e+00];
		        // Define break-points.
		        var plow  = 0.02425,
		            phigh = 1 - plow;
		        var q, r;
		        // Rational approximation for lower region:
		        if (p < plow) {
		            q = Math.sqrt(-2*Math.log(p));
		            return (((((c[0]*q+c[1])*q+c[2])*q+c[3])*q+c[4])*q+c[5]) / ((((d[0]*q+d[1])*q+d[2])*q+d[3])*q+1);
		        }
		        // Rational approximation for upper region:
		        if (phigh < p) {
		            q = Math.sqrt(-2*Math.log(1-p));
		            return -(((((c[0]*q+c[1])*q+c[2])*q+c[3])*q+c[4])*q+c[5]) / ((((d[0]*q+d[1])*q+d[2])*q+d[3])*q+1);
		        }
		        // Rational approximation for central region:
		        q = p - 0.5;
		        r = q*q;
		        return (((((a[0]*r+a[1])*r+a[2])*r+a[3])*r+a[4])*r+a[5])*q / (((((b[0]*r+b[1])*r+b[2])*r+b[3])*r+b[4])*r+1);
		    }
	
		    function NORM_DIST(x, m, s, cumulative) {
		        if (!cumulative) {
		            return Math.exp(-(x-m)*(x-m)/(2*s*s))/(s*Math.sqrt(2*Math.PI)); // NORM_S_DIST((x-m)/s)/s;
		        }
		        return NORM_S_DIST((x-m)/s, true);
		    }
	
		    function NORM_INV(p, m, s) {
		        return m + s*NORM_S_INV(p);
		    }
	
		    function betastd_pdf(x, a, b) {
		        return Math.exp((a-1)*Math.log(x) + (b-1)*Math.log(1-x) - BETALN(a, b));
		    }
	
		    function betastd_cdf(x, a, b) {
		        var k = Math.exp(a*Math.log(x) + b*Math.log(1-x) - BETALN(a, b));
		        return x < (a+1)/(a+b+2) ? k*beta_lentz(a, b, x)/a : 1 - k*beta_lentz(b, a, 1-x)/b;
		    }
	
		    function beta_lentz(a, b, x) { // estimates continued fraction by modified Lentz’s method ([2] $8.17.22)
		        var m, m2;
		        var aa, c, d, del, h, qab, qam, qap;
		        qab = a + b; // These q’s will be used in factors that occur in the coefficients d_n
		        qap = a + 1;
		        qam = a - 1;
		        c = 1; // First step of Lentz’s method.
		        d = 1 - qab * x / qap;
		        if (f_abs(d) < FP_MIN) {
		            d = FP_MIN;
		        }
		        d = 1/d;
		        h = d;
		        for (m = 1; m <= MAX_IT; m++) {
		            m2 = 2*m;
		            aa = m*(b - m)*x / ((qam + m2)*(a + m2));
		            d = 1 + aa*d; // One step (the even one) of the recurrence.
		            if (f_abs(d) < FP_MIN) {
		                d = FP_MIN;
		            }
		            c = 1 + aa/c;
		            if (f_abs(c) < FP_MIN) {
		                c = FP_MIN;
		            }
		            d = 1/d;
		            h *= d*c;
		            aa = -(a + m)*(qab + m)*x / ((a + m2)*(qap + m2));
		            d = 1 + aa*d; // Next step of the recurrence (the odd one).
		            if (f_abs(d) < FP_MIN) {
		                d = FP_MIN;
		            }
		            c = 1 + aa/c;
		            if (f_abs(c) < FP_MIN) {
		                c = FP_MIN;
		            }
		            d = 1/d;
		            del = d*c;
		            h *= del;
		            if (f_abs(del - 1) < EPS) {
		                break;
		            }
		        }
		        return h; // if(m > MAX_IT) throw new Error("a or b too big, or MAX_IT too small");
		    }
	
		    function betastd_inv(p, a, b) { // the quantile function of the standard Beta distribution
			var m = 0, M = 1, x = 0;
			for (var i = 0; i < MAX_IT; i++) {
			    x = 0.5*(m + M);
			    var q = betastd_cdf(x, a, b);
			    if (f_abs(p - q) < EPS) {
		                break;
		            }
			    if (q > p) {
		                M = x;
		            } else {
		                m = x;
		            }
			}
			return x;
		    }
	
		    function BETADIST(x, a, b, m, M) {
		        return betastd_cdf((x-m)/(M-m), a, b);
		    }
	
		    function BETA_DIST(x, a, b, cdf, m, M) {
		        if (cdf) {
		            return betastd_cdf((x-m)/(M-m), a, b);
		        }
		        return betastd_pdf((x-m)/(M-m), a, b) / (M-m);
		    }
	
		    function BETA_INV(p, a, b, m, M) {
		        return m + (M-m)*betastd_inv(p, a, b);
		    }
	
		    function chisq_left(x, n, cds) {  // CHISQ.DIST(x,deg_freedom,cumulative)
		        return GAMMA_DIST(x, n/2, 2, cds);
		    }
	
		    function chisq_right(x, n) { // CHISQ.DIST.RT(x,deg_freedom)
		        return 1 - chisq_left(x, n, true);
		    }
	
		    function chisq_left_inv(p, n) { // CHISQ.INV( probability, degrees_freedom )
		        return GAMMA_INV(p, n/2, 2);
		    }
	
		    function chisq_right_inv(p, n) { // CHISQ.INV.RT(probability,deg_freedom)
		        return chisq_left_inv(1-p, n);
		    }
	
		    function chisq_test(obsv, expect) {
		        var rows = obsv.length, cols = obsv[0].length;
		        var x = 0, i, j;
		        for (i = 0; i < rows; i++) {
		            for (j = 0; j < cols; j++) {
		                var eij = expect[i][j];
		                var delta = obsv[i][j] - eij;
		                delta *= delta;
		                x += delta/eij;
		            }
		        }
		        var n = (rows - 1)*(cols - 1);
		        return chisq_right(x, n);
		    }
	
		    function expon(x, r, cdf) { // EXPON.DIST(x, lambda, cumulative)
		        if (cdf) {
		            return 1 - Math.exp(-r*x);
		        }
		        return r * Math.exp(-r*x);
		    }
	
		    function poisson(k, m, cdf) { // POISSON.DIST(x, mean, cumulative)
		        if (cdf) {
		            return 1 - chisq_left(2*m, 2*(k+1), true);
		        }
		        //return chisq_left(2*m, 2*k, true) - chisq_left(2*m, 2*(k+1), true);
		        var lnf = 0;
		        for (var i = 2; i <= k; i++) {
		            lnf += Math.log(i); // compute log(k!)
		        }
		        return Math.exp(k*Math.log(m) - m - lnf);
		    }
	
		    function Fdist(x, n, d, cdf) { //F.DIST(x,deg_freedom1,deg_freedom2,cumulative)
		        if (cdf) {
		            return betastd_cdf(n*x/(d+n*x), n/2, d/2);
		        }
		        var u = n/d;
		        n /= 2; d /= 2;
		        return u/BETA(n, d) * Math.pow(u*x, n-1) / Math.pow(1+u*x, n+d);
		    }
	
		    function Fdist_right(x, n, d) { // F.DIST.RT(x,deg_freedom1,deg_freedom2)
		        return 1 - Fdist(x, n, d, true);
		    }
	
		    function Finv_right(p, n, d) { // F.INV.RT(probability,deg_freedom1,deg_freedom2
		        return d/n*(1/BETA_INV(p, d/2, n/2, 0, 1) - 1);
		    }
	
		    function Finv(p, n, d) { // F.INV(probability,deg_freedom1,deg_freedom2
		        return d/n*(1/BETA_INV(1-p, d/2, n/2, 0, 1) - 1);
		    }
	
		    function _mean(arr) {
		        var me = 0, n = arr.length;
		        for (var i = 0; i < n; i++) {
		            me += arr[i];
		        }
		        return me / n;
		    }
	
		    function _var_sq(arr, m) { // returns the (n-1)-part of the sum of the squares of deviations from m (= VAR)
		        var v = 0, n = arr.length;
		        for (var i = 0; i < n; i++) {
		            var delta = arr[i] - m;
		            v += delta*delta;
		        }
		        return v / (n-1);
		    }
	
		    function Ftest(arr1, arr2) { // F.TEST(array1,array2)
		        var n1 = arr1.length - 1, n2 = arr2.length - 1;
		        var va1 = _var_sq(arr1, _mean(arr1)),
		            va2 = _var_sq(arr2, _mean(arr2));
		        if (!va1 || !va2) {
		            throw new CalcError("DIV/0");
		        }
		        return 2*Fdist(va1 / va2, n1, n2, true);
		    }
	
		    function fisher(x) { // FISHER(x)
		        return 0.5*Math.log((1+x)/(1-x));
		    }
	
		    function fisherinv(x) { // FISHERINV(x)
		        var e2 = Math.exp(2*x);
		        return (e2 - 1)/(e2 + 1);
		    }
	
		    function Tdist(x, n, cdf) { // T.DIST(x,deg_freedom, cumulative)
		        if (cdf) {
		            return 1 - 0.5*betastd_cdf(n/(x*x+n), n/2, 0.5);
		        }
		        return 1/(Math.sqrt(n)*BETA(0.5, n/2)) * Math.pow(1 + x*x/n, -(n+1)/2);
		    }
	
		    function Tdist_right(x, n) { // T.DIST.RT(x,deg_freedom)
		        return 1 - Tdist(x, n, true);
		    }
	
		    function Tdist_2tail(x, n) { // T.DIST.2T(x,deg_freedom)
		        if (x < 0) {
		            x = -x;
		        }
		        return 2*Tdist_right(x, n);
		    }
	
		    function Tdist_inv(p, n) { // T.INV(probability,deg_freedom)
		        var x = betastd_inv(2*Math.min(p, 1-p), n/2, 0.5); // ibetainv();
		        x = Math.sqrt(n * (1 - x) / x);
		        return (p > 0.5) ? x : -x;
		    }
	
		    function Tdist_2tail_inv(p, n) { // T.INV.2T(probability,deg_freedom)
		        // T2 = 2T_r = p => T_r(x,n) = p/2 => 1 - T(x,n,true) = p/2 => x = T^-1(1-p/2, n)
		        return Tdist_inv(1-p/2, n);
		    }
	
		    function Tdist_test(gr1, gr2, tail, type) { // T.TEST(array1,array2,tails,type)
		        var n1 = gr1.length, n2 = gr2.length;
		        var t_st, df; // the t-statistic and the "degree of freedom"
		        if (type == 1) { // paired (dependent) samples
		            var d = 0, d2 = 0;
		            for (var i = 0; i < n1; i++) {
		                var delta = gr1[i] - gr2[i];
		                d += delta;
		                d2 += delta*delta;
		            }
		            var md = d/n1; //, md2 = d2 / n1;
		            t_st = md / Math.sqrt((d2 - d*md)/(n1*(n1-1))); // has a "Student T" distribution
		            return tail == 1 ? Tdist_right(t_st, n1-1) : Tdist_2tail(t_st, n1-1);
		        }
		        // unpaired (independent) samples
		        var m1 = _mean(gr1), m2 = _mean(gr2),
		            v1 = _var_sq(gr1, m1), v2 = _var_sq(gr2, m2);
		        if (type == 3) { // unpaired, unequal variances
		            var u1 = v1/n1, u2 = v2/n2, u = u1 + u2;
		            var q1 = u1/u, q2 = u2/u; // u==0 must be invalidated
		            df = 1/(q1*q1/(n1-1) + q2*q2/(n2-1));
		            t_st =  f_abs(m1-m2)/Math.sqrt(u);
		            return tail == 1 ? Tdist_right(t_st, df) : Tdist_2tail(t_st, df);
		        }
		        else { // (type == 2) unpaired, equal variances ("equal" in the sense that there is no significant difference in variance in both groups - a prealable F-test could revealed that)
		            df = n1 + n2 - 2;
		            t_st = f_abs(m1-m2)*Math.sqrt(df*n1*n2/((n1+n2)*((n1-1)*v1+(n2-1)*v2)));
		            return tail == 1 ? Tdist_right(t_st, df) : Tdist_2tail(t_st, df);
		        }
		    }
	
		    function confidence_t(alpha, stddev, size) { // CONFIDENCE.T(alpha,standard_dev,size)
		        return -Tdist_inv(alpha/2, size-1)*stddev/Math.sqrt(size);
		    }
	
		    function confidence_norm(alpha, stddev, size) { // CONFIDENCE.NORM(alpha,standard_dev,size)
		        return -NORM_S_INV(alpha/2)*stddev/Math.sqrt(size);
		    }
	
		    function gauss(z) { // GAUSS(z)
		        return NORM_S_DIST(z, true) - 0.5;
		    }
	
		    function phi(x) { // PHI(x)
		        return NORM_S_DIST(x);
		    }
	
		    function lognorm_dist(x, m, s, cumulative) { // LOGNORM.DIST(x,mean,standard_dev,cumulative)
		        if (cumulative) {
		            return 0.5 + 0.5*ERF((Math.log(x)-m)/(s*Math.sqrt(2)));
		        }
		        var t = Math.log(x)-m;
		        return Math.exp(-t*t/(2*s*s))/(x*s*Math.sqrt(2*Math.PI));
		    }
	
		    function lognorm_inv(p, m, s) { //LOGNORM.INV(probability, mean, standard_dev)
		        return Math.exp(NORM_INV(p, m, s));
		    }
	
		    function prob(x_, p_, lw, up) { //PROB(x_range, prob_range, [lower_limit], [upper_limit])
		        var n = x_.length;
		        var s = 0, i;
		        for (i = 0; i < n; i++) {
		            if (p_[i] <= 0 || p_[i] > 1) {
		                throw new CalcError("NUM");
		            }
		            s += p_[i];
		        }
		        if (s != 1) {
		            throw new CalcError("NUM");
		        }
		        var res = 0;
		        for (i = 0; i < n; i++) {
		            var x = x_[i];
		            if (x >= lw && x <= up) {
		                res += p_[i];
		            }
		        }
		        return res;
		    }
	
		    function slope(y_, x_) { // SLOPE(known_y's, known_x's)
		        var mx = _mean(x_), my = _mean(y_), b1 = 0, b2 = 0;
		        for (var i = 0, n = y_.length; i < n; i++) {
		            var t = x_[i] - mx;
		            b1 += t*(y_[i] - my);
		            b2 += t*t;
		        }
		        return b1/b2;
		    }
	
		    function intercept(y_, x_) { // INTERCEPT(known_y's, known_x's)
		        var mx = _mean(x_), my = _mean(y_);
		        // return my - mx*slope(y_, x_);  //but repeating the calls for _mean()
		        var b1 = 0, b2 = 0;
		        for (var i = 0, n = y_.length; i < n; i++) {
		            var t = x_[i] - mx;
		            b1 += t*(y_[i] - my);
		            b2 += t*t;
		        }
		        return my - b1*mx/b2;
		    }
	
		    function pearson(x_, y_) { // PEARSON(array1, array2)
		        whipNumberArrays(x_, y_);
		        var mx = _mean(x_), my = _mean(y_);
		        var s1 = 0, s2 = 0, s3 = 0;
		        for(var i = 0, n = x_.length; i < n; i++) {
		            var t1 = x_[i] - mx, t2 = y_[i] - my;
		            s1 += t1*t2;
		            s2 += t1*t1;
		            s3 += t2*t2;
		        }
		        return s1/Math.sqrt(s2*s3);
		    }
	
		    function rsq(x_, y_) { // RSQ(known_y's,known_x's)
		        var r = pearson(x_, y_);
		        return r*r;
		    }
	
		    function steyx(y_, x_) { //STEYX(known_y's, known_x's)
		        var n = x_.length;
		        var mx = _mean(x_), my = _mean(y_);
		        var s1 = 0, s2 = 0, s3 = 0;
		        for (var i = 0; i < n; i++) {
		            var t1 = x_[i] - mx, t2 = y_[i] - my;
		            s1 += t2*t2;
		            s2 += t1*t2;
		            s3 += t1*t1;
		        }
		        return Math.sqrt((s1 - s2*s2/s3)/(n-2));
		    }
	
		    function forecast(x, y_, x_) { //FORECAST(x, known_y's, known_x's)
		        var mx = _mean(x_), my = _mean(y_);
		        var s1 = 0, s2 = 0;
		        for (var i = 0, n = x_.length; i < n; i++) {
		            var t1 = x_[i] - mx, t2 = y_[i] - my;
		            s1 += t1*t2;
		            s2 += t1*t1;
		        }
		        if (s2 === 0) {
		            throw new CalcError("N/A");
		        }
		        var b = s1/s2, a = my - b*mx;
		        return a + b*x;
		    }
	
		    function _mat_mean(Mat) { // returns the mean value of a Matrix(n, 1)
		        var n = Mat.height, sum = 0;
		        for (var i=0; i < n; i++) {
		            sum += Mat.data[i][0];
		        }
		        return sum/n;
		    }
	
		    function _mat_devsq(Mat, mean) { // returns the sum of squares of deviations for a Matrix(n, 1)
		        var n = Mat.height, sq = 0;
		        for (var i=0; i < n; i++) {
		            var x = Mat.data[i][0] - mean;
		            sq += x*x;
		        }
		        return sq;
		    }
	
		    function linest(Y, X, konst, stats) { // LINEST(known_y's, [known_x's], [const], [stats])
		        var i = 0;
	
		        if (!X) {
		            // if not passed, X should default to array {1, 2, 3, ...} (same size as Y)
		            X = Y.map(function(){ return ++i; });
		        }
	
		        if (konst) { // adding 1's column is unnecessary when const==false (meaning that y_intercept==0)
		            X = X.clone();
		            X.eachRow(function(row){
		                X.data[row].unshift(1);
		            });
		            ++X.width;
		        }
	
		        var Xt = X.transpose();
		        var B = Xt.multiply(X).inverse().multiply(Xt).multiply(Y); // the last square estimate of the coefficients
		        var line_1 = [];
		        for (i = B.height-1; i >= 0; i--) {
		            line_1.push(B.data[i][0]); // regression coefficients ('slopes') and the y_intercept
		        }
		        if (!konst) {
		            line_1.push(0); // display 0 for y_intercept, when const==false
		        }
		        if (!stats) {
		            return this.asMatrix([ line_1 ]); // don't display statistics about the regression, when stats==false
		        }
	
		        var Y1 = X.multiply(B); // the predicted Y values
		        var y_y1 = Y.adds(Y1, true); // the errors of the predictions (= Y - Y1)
		        var mp = !konst? 0 : _mat_mean(Y1);
		        var SSreg = _mat_devsq(Y1, mp); // The regression sum of squares
		        var me = !konst? 0 : _mat_mean(y_y1);
		        var SSresid = _mat_devsq(y_y1, me); // The residual sum of squares
		        var line_5 = [];
		        line_5.push(SSreg, SSresid);
		        var R2 = SSreg / (SSreg + SSresid); // The coefficient of determination
		        var degfre = Y.height - X.width; // The degrees of freedom
		        var err_est = Math.sqrt(SSresid / degfre); // The standard error for the y estimate
		        var line_3 = [];
		        line_3.push(R2, err_est);
		        var F_sta = !konst ? (R2/X.width)/((1-R2)/(degfre)) : (SSreg/(X.width-1))/(SSresid/degfre); // The F statistic
		        var line_4 = [];
		        line_4.push(F_sta, degfre);
		        var SCP = Xt.multiply(X).inverse();
		        var line_2 = [];
		        for (i=SCP.height-1; i >= 0; i--) { // The standard errors (of coefficients an y-intercept)
		            line_2.push(Math.sqrt(SCP.data[i][i]*SSresid/degfre));
		        }
		        return this.asMatrix([line_1, line_2, line_3, line_4, line_5]);
		    }
	
		    function logest(Y, X, konst, stats) { // LOGEST(known_y's, [known_x's], [const], [stats])
		        return linest.call(this, Y.map(Math.log), X, konst, stats).map(Math.exp);
		    }
	
		    function trend(Y, X, W, konst) { // TREND(known_y's, [known_x's], [new_x's], [const])
		        var i = 0;
	
		        if (!X) {
		            // if not passed, X should default to array {1, 2, 3, ...} (same size as Y)
		            X = Y.map(function(){ return ++i; });
		        }
	
		        if (konst) { // adding 1's column is unnecessary when const==false (meaning that y_intercept==0)
		            X = X.clone();
		            X.eachRow(function(row){
		                X.data[row].unshift(1);
		            });
		            ++X.width;
		        }
	
		        var Xt = X.transpose();
		        var B = Xt.multiply(X).inverse().multiply(Xt).multiply(Y); // the last square estimate of the coefficients
	
		        if (!W) {
		            W = X;
		        } else {
		            if (konst) { // for non-zero y_intercept
		                W = W.clone();
		                W.eachRow(function(row){
		                    W.data[row].unshift(1);
		                });
		                ++W.width;
		            }
		        }
		        return W.multiply(B); // the predicted Y values for the W values
		    }
	
		    function growth(Y, X, new_X, konst) { // GROWTH(known_y's, [known_x's], [new_x's], [const])
		        // = EXP(TREND(LN(Y_), X_, new_X, const))
		        return trend.call(this, Y.map(Math.log), X, new_X, konst).map(Math.exp);
		    }
	
		    /*
		      [1] Handbook of Mathematical Functions (NIST, 1964-2010):
		      https://en.wikipedia.org/wiki/Abramowitz_and_Stegun
		      http://dlmf.nist.gov/
		      http://www.aip.de/groups/soe/local/numres/
	
		      [2] https://en.wikibooks.org/wiki/Statistics/Numerical_Methods/Numerics_in_Excel
		    */
	
		    /* -----[ financial functions ]----- */
	
		    //// find the root of a function known an initial guess (Newton's method) ////
		    function root_newton(func, guess, max_it, eps) { // func(x) must return [value_F(x), value_F'(x)]
		        var MAX_IT = max_it || 20, // maximum number of iterations
		            EPS = eps || 1E-7; // accuracy
		        var root = guess;
		        for (var j = 1; j <= MAX_IT; j++) {
		            var f_d = func(root),
		                f = f_d[0], // the value of the function
		                df = f_d[1]; // the value of the derivative
		            var dx = f / df;
		            root -= dx;
		            if (Math.abs(dx) < EPS) {
		                return root;
		            }
		        }
		        return new CalcError("NUM");
		    }
	
	
		    /* https://support.office.com/en-us/article/PV-function-23879d31-0e02-4321-be01-da16e8168cbd
		       if(rate==0):
		       PMT * nper + PV + FV = 0
		       else: //the basic equation (with six variables) implied in financial problems
		       PV * (1+rate)^nper + PMT * (1+rate*type) * ((1+rate)^nper-1) / rate + FV = 0         [1]
		    */
	
	
	
		    //// FV (final or future value) ////
		    /* I initially invest £1000 in a saving scheme and then at the end of each month I invest an
		       extra £50. If the interest rate is 0.5% per month and I continue this process for two year,
		       how much will my saving be worth: =FV(0.005, 24, -50, -1000, 0) */
		    function FV(rate, nper, pmt, pv, type) { // FV(rate,nper,pmt,[pv],[type])
		        var h1 = Math.pow(1+rate, nper);
		        var h2 = rate ? (h1 - 1)/rate : nper;
		        return -(pv * h1 + pmt * h2 * (1 + rate*type));
		    }
	
		    //// PV (present value of investment) ////
		    /* If I wish to accumulate £5000 in four years time by depositing £75 per month in a fixed
		       rate account with interest rate of 0.4% per month, what initial investment must I also
		       make: =PV(0.004, 4*12, -75, 5000, 0) */
		    function PV(rate, nper, pmt, fv, type) { // PV(rate, nper, pmt, [fv], [type])
		        if (!rate) {
		            return -fv - pmt*nper;
		        }
		        var h1 = Math.pow(1+rate, nper);
		        return -(fv + pmt * (h1 - 1)/rate * (1 + rate*type)) / h1;
		    }
	
		    //// PMT monthly payments (= principal part PPMT + interest part IPMT) ////
		    /* How much will the monthly repayments be if I borrow £100,000 over 20 years with an
		       effective monthly interest rate is 0.5%: =PMT(0.005, 12*20, 100000, 0, 0) */
		    function PMT(rate, nper, pv, fv, type) { // PMT(rate, nper, pv, [fv], [type])
		        if (!rate) {
		            return -(fv + pv)/nper;
		        }
		        var h1 = Math.pow(1+rate, nper);
		        return -rate*(fv + pv*h1)/((1 + rate*type)*(h1 - 1));
		    }
	
		    //// NPER (number of periods for an investment) ////
		    /* How long would it take me to pay off a loan of £10,000 at a rate of 0.5% per month if I
		       can afford to pay £100 per month: =NPER(0.5%, -100, 10000, 0, 0) */
		    function NPER(rate, pmt, pv, fv, type) { // NPER(rate,pmt,pv,[fv],[type])
		        if (!rate) {
		            return -(fv + pv) / pmt;
		        }
		        var h1 = pmt*(1 + rate*type);
		        return Math.log((h1 - fv*rate)/(h1 + pv*rate)) / Math.log(1 + rate);
		    }
	
		    //// RATE (the interest rate per period) ////
		    /* I borrow £1000 over 1 year making payments of £100 per month at the end of each
		       month. What is the monthly interest rate: =RATE(12, −100, 1000, 0, 0, 0) */
	
		    function RATE (nper, pmt, pv, fv, type, guess) { // RATE(nper, pmt, pv, [fv], [type], [guess])
		        function xfd(x) { // returns F(x) and F'(x), where F is given by the equation [1]
		            var h2 = Math.pow(1+x, nper-1), h1 = h2*(1+x);
		            return [ pv*h1 + pmt*(1/x + type)*(h1 - 1) + fv,
		                     nper*pv*h2 + pmt*(-(h1 - 1)/(x*x) + (1/x + type)*nper*h2) ];
		        }
		        return root_newton(xfd, guess); // a root of the equation F(x)=0
		    }
	
		    //// IPMT (interest part of a loan or investment) ////
		    //// PPMT (principal part of a loan) ////
	
		    function IPMT(rate, per, nper, pv, fv, type) { // IPMT(rate, per, nper, pv, [fv], [type])
		        if(type==1 && per==1) { // interest before beginnig of the payments... = ZERO
		            return 0;
		        }
		        var pmt = PMT(rate, nper, pv, fv, type);
		        var ipmt = FV(rate, per - 1, pmt, pv, type) * rate;
		        return type ? ipmt/(1 + rate) : ipmt;
		    }
	
		    function PPMT(rate, per, nper, pv, fv, type) { // PPMT(rate, per, nper, pv, [fv], [type])
		        var pmt = PMT(rate, nper, pv, fv, type);
		        return pmt - IPMT(rate, per, nper, pv, fv, type);
		    }
	
		    //// CUMPRINC (cumulative principal paid) ////
		    /* The amount financed is $200,000 at an interest rate of 7.25% for 30 years. How much is the amount of principal
		       and the amount of interest paid in the first year: CUMPRINC(0.0725/12, 12*30, 200000, 1, 12, 0)
		       and CUMIPMT(0.0725/12, 12*30, 200000, 1, 12, 0) */
		    function CUMPRINC(rate, nper, pv, start, end, type) { // CUMPRINC(rate, nper, pv, start_period, end_period, type)
		        if(type == 1) { // start >= 1 (as in Excel), but if pay at beginning of the period (type==1),
		            start --;    // then periods must be counted from Zero (decreasing given start and end parameters)
		            end --;
		        }
		        var tn = Math.pow(1 + rate, nper),
		            ts = Math.pow(1 + rate, start-1),
		            te = Math.pow(1 + rate, end);
		        var monthlyPayment = rate * pv * tn / (tn - 1);
		        var remainingBalanceAtStart = ts * pv - ((ts - 1) / rate) * monthlyPayment;
		        var remainingBalanceAtEnd = te * pv - ((te - 1) / rate) * monthlyPayment;
		        return remainingBalanceAtEnd - remainingBalanceAtStart;
		    }
	
		    //// CUMIPMT (cumulative  interest paid) ////
		    function CUMIPMT(rate, nper, pv, start, end, type) { // CUMIPMT(rate, nper, pv, start_period, end_period, type)
		        var cip = 0;
		        for(var i=start; i<=end; i++) {
		            cip += IPMT(rate, i, nper, pv, 0, type);
		        }
		        return cip;
		    }
	
		    //// NPV (Net Present Value of an investment based on a series of periodic cash flows and a discount rate) ////
		    function NPV(rate, flows) { // NPV(rate,value1,[value2],...)
		        var npv = 0;
		        for(var i=0, n=flows.length; i < n; i++) {
		            npv += flows[i]*Math.pow(1 + rate, -i-1);
		        }
		        return npv;
		    }
	
		    //// IRR (Internal Rate of Return on an investment based on a series of periodic cash flows) ////
		    function IRR(flows, guess) { // IRR(values, [guess])
		        function xfd(x) {
		            var npv = 0, npv1 = 0;
		            for(var j=0, n=flows.length; j < n; j++) {
		                npv += flows[j]*Math.pow(1 + x, -j-1); // construct the NPV(x) value,
		                npv1 += -j*flows[j]*Math.pow(1+x, -j-2); // the value in x of the NPV()-derivative
		            }
		            return [npv, npv1];
		        }
		        return root_newton(xfd, guess);
		    }
	
		    //// EFFECT (effective annual interest rate) ////
		    /* which investment option is better - one that pays 5 percent after one year, or a
		       savings account that pays a monthly interest of 4.75 percent:
		       = (5% - EFFECT(4.75%, 12)) * 10000 */
		    function EFFECT(nominal_rate, npery) { // EFFECT(nominal_rate, npery)
		        return Math.pow(1 + nominal_rate/npery, npery) - 1;
		    }
	
		    //// NOMINAL (nominal annual interest rate) ////
		    function NOMINAL(effect_rate, npery) { // NOMINAL(effect_rate, npery)
		        return npery*(Math.pow(effect_rate + 1, 1/npery) - 1);
		    }
	
		    //// XNPV (Net Present Value of a series of cashflows at irregular intervals) ////
		    function XNPV(rate, values, dates) { // XNPV(rate, values, dates)
		        var npv = 0;
		        for(var i=0, n=values.length; i < n; i++) {
		            npv += values[i]*Math.pow(1 + rate, (dates[0]-dates[i])/365);
		        }
		        return npv;
		    }
	
		    //// XIRR (Internal Rate of Return of a series of cashflows at irregular intervals) ////
		    function XIRR(values, dates, guess) { // XIRR(values, dates, [guess])
		        function xfd(x) {
		            var npv = values[0], npv1 = 0;
		            for(var j=1, n=values.length; j < n; j++) {
		                var delta = (dates[0] - dates[j]) / 365;
		                npv += values[j]*Math.pow(1 + x, delta); // construct the XNPV(x) value,
		                npv1 += delta*values[j]*Math.pow(1+x, delta - 1); // the value in x of the XNPV()-derivative
		            }
		            return [npv, npv1];
		        }
		        return root_newton(xfd, guess); // , 100, 0.1);
		    }
	
		    //// ISPMT (Interest paid during a Specific Period of an investment) ////
		    function ISPMT(rate, per, nper, pv) { // ISPMT(rate, per, nper, pv)
		        var tmp = -pv*rate;
		        return tmp*(1 - per/nper);
		    }
	
		    //// DB (Declining Balance depreciation) ////
		    function DB(cost, salvage, life, period, month) { // DB(cost, salvage, life, period, [month])
		        var rate = 1 - Math.pow(salvage/cost, 1/life);
		        rate = Math.floor(rate*1000 + 0.5) / 1000; // rounded to three decimals
		        var db = cost * rate * month / 12;
		        if(period == 1) {
		            return db;
		        }
		        for(var i=1; i < life; i++) {
		            if(i == period - 1) {
		                return (cost - db) * rate;
		            }
		            db += (cost - db) * rate;
		        }
		        return (cost - db) * rate * (12 - month) / 12;
		    }
	
		    //// DDB (Double Declining Balance depreciation) ////
		    function DDB(cost, salvage, life, period, factor) { // DDB(cost, salvage, life, period, [factor])
		        var f = factor / life;
		        var prior = -cost * (Math.pow(1-f, period-1) - 1);
		        var dep = (cost - prior) * f;
		        /* Depreciation cannot exceed book value.  */
		        dep = Math.min(dep, Math.max(0, cost - prior - salvage));
		        return dep;
		    }
	
		    //// SLN (straight-line depreciation) ////
		    function SLN(cost, salvage, life) { // SLN(cost, salvage, life)
		        return (cost - salvage) / life;
		    }
	
		    //// SYD (Sum-of-Years' digits Depreciation) ////
		    function SYD(cost, salvage, life, per) { // SYD(cost, salvage, life, per)
		        return (cost - salvage) * (life - per + 1) * 2 / (life * (life + 1));
		    }
	
		    //// VDB (Variable Declining Balance) ////
		    //
		    // Code adapted from Gnumeric, which in turn took it from OpenOffice.  The original code is
		    // available under GNU Lesser General Public License (LGPL).
		    // https://github.com/GNOME/gnumeric/blob/master/plugins/fn-financial/sc-fin.c
		    function VDB (cost, salvage, life, start, end, factor, no_switch) {
		        var interest = factor >= life ? 1 : factor / life;
	
		        function _getGDA(value, period) {
		            var gda, oldValue, newValue;
		            if (interest == 1) {
		                oldValue = period == 1 ? value : 0;
		            } else {
		                oldValue = value * Math.pow(1 - interest, period - 1);
		            }
		            newValue = value * Math.pow(1 - interest, period);
		            gda = newValue < salvage ? oldValue - salvage : oldValue - newValue;
		            return gda < 0 ? 0 : gda;
		        }
	
		        function _interVDB(cost, life1, period) {
		            var remValue = cost - salvage;
		            var intEnd = Math.ceil(period);
		            var term, lia = 0, vdb = 0, nowLia = false;
		            for (var i = 1; i <= intEnd; i++) {
		                if (!nowLia) {
		                    var gda = _getGDA(cost, i);
		                    lia = remValue / (life1 - i + 1);
		                    if (lia > gda) {
		                        term = lia;
		                        nowLia = true;
		                    } else {
		                        term = gda;
		                        remValue -= gda;
		                    }
		                } else {
		                    term = lia;
		                }
		                if (i == intEnd) {
		                    term *= period + 1 - intEnd;
		                }
		                vdb += term;
		            }
		            return vdb;
		        }
	
		        var intStart = Math.floor(start), intEnd = Math.ceil(end);
		        var vdb = 0;
		        if (no_switch) {
		            for (var i = intStart + 1; i <= intEnd; i++) {
		                var term = _getGDA(cost, i);
		                if (i == intStart + 1) {
		                    term *= Math.min(end, intStart + 1) - start;
		                } else {
		                    if (i == intEnd) {
		                        term *= end + 1 - intEnd;
		                    }
		                }
		                vdb += term;
		            }
		        } else {
		            var life1 = life;
		            if (start != Math.floor(start)) {
		                if (factor > 1) {
		                    if (start >= life / 2) {
		                        var part = start - life / 2;
		                        start = life / 2;
		                        end -= part;
		                        life1 += 1;
		                    }
		                }
		            }
		            cost -= _interVDB(cost, life1, start);
		            vdb = _interVDB(cost, life - start, end - start);
		        }
		        return vdb;
		    }
	
		    /*************************************************************************************/
	
		    /*   (from  http://beginnersinvest.about.com)
		         an investor agrees to loan money to a company or government in exchange for a predetermined interest rate for a pre-determined length of time.
	
		         If an investor wanted to buy a $25,000 Coca-Cola bond with a 30 year maturity and an 10% coupon, it would work like this: He would send in the $25,000 from his savings account and get a $25,000 engraved bond certificate in exchange. After 30 years, he would be able to get his whole $25,000 back from the Coca-Cola company (of course, he can always sell it before then if he needs the money).
	
		         Every year, he’s entitled to receive 10% interest on the money he lent, or $2,500. Since most companies in the United States pay interest semi-annually, he would likely have 60 coupons attached to his bond for $1,250 each.
		         Every June 30th and December 31st, the investor would go down, clip the proper coupon, send it in, and get their money.
	
		         Although the practice is now defunct, the terminology stuck and interest payments on bonds will forever be known as coupons.
		    */
	
	
		    // "Use EDATE to calculate maturity dates or due dates that fall on the same day of the month as the date of issue."
		    // See also: DATEDIF, DAY, DAYS, DAY360, EOMONTH (wich can be useful to determine limits of coupon periods)
		    function _edate(base, months) { // EDATE(start_date, months)
		        var d = unpackDate(base);
		        var m = d.month + months;
		        var y = d.year + Math.floor(m/12);
		        m %= 12;
		        if (m < 0) {
		            m += 12;
		        }
		        d = Math.min(d.date, daysInMonth(y, m));
		        return packDate(y, m, d);
		    }
	
		    function _daysBetween(from, to, basis) {
		        if (basis == 1 || basis == 2 || basis == 3) { // Actual/Actual || Actual/360 || Actual/365
		            return to - from;
		        }
		        return _days_360(from, to, basis);
		    }
	
		    // Find coupon dates that enclose the settlement date, counting backward from the maturity date.
		    /* independent of the 'basis' convention to count days - here we have no need to count days */
		    function _borderCoupons(settlement, maturity, freq) {
		        var sett = unpackDate(settlement), base = unpackDate(maturity);
		        var periods = base.year - sett.year;
		        if (periods > 0) {
		            periods = (periods - 1) * freq;
		        }
		        var prev, next, months = 12/freq;
		        do {
		            periods++;
		            prev = _edate(maturity, - periods*months);
		        } while (settlement < prev);
		        periods--;
		        next = _edate(maturity, - periods*months);
		        return [ prev, next ];
		    }
	
		    // Find coupon dates that enclose the settlement date, counting forward from the first-coupon payment.
		    /* independent of the 'basis' convention to count days - here we have no need to count days */
		    function _borderCoupons_fw(first, settlement, freq) {
		        var sett = unpackDate(settlement), base = unpackDate(first);
		        var periods = sett.year - base.year;
		        if (periods > 0) {
		            periods = (periods - 1) * freq;
		        }
		        var prev = first, next, months = 12/freq;
		        while (settlement > prev) {
		            next = prev;
		            periods++;
		            prev = _edate(first, periods*months);
		        }
		        return [ next, prev ];
		    }
	
		    //// COUPDAYBS (COUPon DAYs Beginning to Settlement) ////
		    /* returns the number of days from the beginning of the coupon period to the settlement date */
		    function COUPDAYBS(settlement, maturity, frequency, basis) { // COUPDAYBS(settlement, maturity, frequency, [basis])
		        var prev = _borderCoupons(settlement, maturity, frequency)[0];
		        return _daysBetween(prev, settlement, basis);
		    }
	
		    //// COUPDAYS (COUPon DAYs containing Settlement) ////
		    /* Returns the number of days in the coupon period that contains the settlement date */
		    function COUPDAYS(settl, matur, freq, basis) { // COUPDAYS(settlement, maturity, frequency, [basis])
		        if (basis == 1) {
		            var borders = _borderCoupons(settl, matur, freq);
		            return _daysBetween(borders[0], borders[1], 1);
		        }
		        if (basis == 3) {
		            return 365/freq;
		        }
		        return 360/freq;
		    }
	
		    //// COUPDAYSNC (COUPon DAYs Settlement to Next Coupon) ////
		    /* Returns the number of days from the settlement date to the next coupon date */
		    function COUPDAYSNC(settl, matur, freq, basis) { // COUPDAYSNC(settlement, maturity, frequency, [basis])
		        var next = _borderCoupons(settl, matur, freq)[1];
		        return _daysBetween(settl, next, basis);
		    }
	
		    //// COUPPCD (COUPon, Previous Coupon Date) ////
		    /* Returns the previous coupon date before the settlement date */
		    function COUPPCD(settl, matur, freq/*, basis*/) { // COUPPCD(settlement, maturity, frequency, [basis])
		        // It is no need to count days, so 'basis' becomes a inutil parameter.
		        return _borderCoupons(settl, matur, freq)[0];
		    }
	
		    //// COUPNCD (COUPon, Next Coupon Date) ////
		    /* Returns the next coupon date after the settlement date */
		    function COUPNCD(settl, matur, freq/*, basis*/) { // COUPNCD(settlement, maturity, frequency, [basis])
		        // It is no need to count days, so 'basis' becomes a inutil parameter.
		        return _borderCoupons(settl, matur, freq)[1];
		    }
	
		    function COUPNUM(settl, matur, freq/*, basis*/) { // COUPNUM(settlement, maturity, frequency, [basis])
		        var sett = unpackDate(settl),
		            mat = unpackDate(matur);
		        var months = 12*(mat.year - sett.year) + mat.month - sett.month;
		        //// Discount the last month if there are not enough days? Finally - we decide to not discount.
		        //// (if this "last month" have 2 days, Excel.COUPNUM returns 6 but GoogleSpreads give only 5)
		        //    var res = _edate(matur, -months);
		        //    if (sett.date >= unpackDate(res).date) {
		        //        months--; // an incomplete last month correspond to a qvasi-coupon period
		        //    }
		        return 1 + (months * freq / 12 | 0);
		    }
	
		    function daysInYear(yr, basis) {
		        if (basis == 3) { return 365; }
		        if (basis == 1) { return isLeapYear(yr) ? 366 : 365; }
		        return 360;
		    }
	
		    //// ACCRINTM  the accrued interest for a security that pays interest at maturity ////
		    function ACCRINTM(issue, maturity, rate, par, basis) { // ACCRINTM(issue, settlement, rate, par, [basis])
		        var year_days = daysInYear(unpackDate(maturity).year, basis); // 360;
		        return rate*par * _daysBetween(issue, maturity, basis) / year_days;
		    }
	
		    function ACCRINT(issue, first, settl, rate, par, freq, basis, calc) {
		        var accr = 0, cost = par * rate / freq;
		        var brace, prev, next, prev1, next1, nrc;
	
		        var annual = basis % 2 === 0 ? 360 : 365; // only if to >> from, we eventually need to count leap years
		        function _numCoupons(from, to) { // better than COUPNUM(from, to, freq, basis)-1
		            return (to - from)*freq/annual | 0;
		        }
	
		        if (settl <= first) {
		            brace = _borderCoupons(settl, first, freq);
		            prev = brace[0];
		            next = brace[1];
		            if (prev <= issue) {
		                return cost * _daysBetween(issue, settl, basis) / _daysBetween(prev, next, basis);
		            }
		            brace = _borderCoupons(issue, prev, freq);
		            prev1 = brace[0];
		            next1 = brace[1];
		            nrc = _numCoupons(next1, settl); // when settl==next, days are counted implicitly by nrc
		            return cost *
		                (nrc +
		                 _daysBetween(issue, next1, basis) / _daysBetween(prev1, next1, basis) +
		                 (settl < next? _daysBetween(prev, settl, basis) / _daysBetween(prev, next, basis) : 0));
		        } else {
		            brace = _borderCoupons_fw(first, settl, freq);
		            prev = brace[0];
		            next = brace[1];
		            nrc = _numCoupons(first, settl); // COUPNUM(first, settl, freq, basis) - 1;
		            if (next == settl) {
		                accr = cost * nrc;
		            } else {
		                accr = cost * (nrc + _daysBetween(prev, settl, basis) / _daysBetween(prev, next, basis));
		            }
		            if (!calc) { return accr; } // Only the accrued interest between first and settlement dates.
		            brace = _borderCoupons(issue, first, freq); // Add the accrued interest between issue and first dates.
		            prev = brace[0];
		            next = brace[1];
		            nrc = _numCoupons(issue, first);
		            accr += cost * (nrc + _daysBetween(issue, next, basis) / _daysBetween(prev, next, basis));
		            return accr; // accrued interest between issue and settlement dates
		        }
		    }
	
		    //// DISC  the discount rate for a security (given price and redemption values per 100$ face value) ////
		    function DISC(settl, matur, pr, redemption, basis) { // DISC(settlement, maturity, pr, redemption, [basis])
		        var annual = basis % 2 === 0 ? 360 : (isLeapYear(unpackDate(settl).year) ? 366 : 365);
		        return (redemption - pr)/redemption*annual/_daysBetween(settl, matur, basis);
		    }
	
		    //// INTRATE  the interest rate for a fully invested security ////
		    function INTRATE(settl, matur, investment, redemption, basis) { // INTRATE(settlement, maturity, investment, redemption, [basis])
		        var annual = basis % 2 === 0 ? 360 : (isLeapYear(unpackDate(settl).year) ? 366 : 365);
		        return (redemption - investment)/investment*annual/_daysBetween(settl, matur, basis);
		    }
	
		    //// RECEIVED  the amount received at maturity for a fully invested security ////
		    function RECEIVED(settl, matur, investment, discount, basis) { // RECEIVED(settlement, maturity, investment, discount, [basis])
		        var annual = basis % 2 === 0 ? 360 : (isLeapYear(unpackDate(settl).year) ? 366 : 365);
		        return investment/(1 - discount*_daysBetween(settl, matur, basis)/annual);
		    }
	
		    //// PRICE  the price per $100 face value of a security that pays periodic interest ////
		    function PRICE(settl, matur, rate, yld, redemption, freq, basis) { // PRICE(settlement, maturity, rate, yld, redemption, frequency, [basis])
		        var N = 1 + ((matur - settl)*freq/(basis % 2 === 0 ? 360 : 365) | 0); // coupons playable between settlement and maturity dates
		        var brace = _borderCoupons(settl, matur, freq),
		            prev = brace[0], next = brace[1];
		        var beg_settl = _daysBetween(prev, settl, basis),
		            settl_end = _daysBetween(settl, next, basis),
		            beg_end = _daysBetween(prev, next, basis);
		        var den = 100*rate/freq,
		            yf = yld/freq,
		            frac = settl_end / beg_end;
		        if (N == 1) {
		            return (redemption + den)/(1 + frac*yf) - beg_settl / beg_end * den;
		        }
		        return redemption / Math.pow(1 + yf, N-1+frac)
		            + den * Math.pow(1 + yf, 1-N-frac) * (Math.pow(1+yf, N) - 1) / yf
		            - beg_settl / beg_end * den;
		    }
	
		    //// PRICEDISC  the price per $100 face value of a discounted security ////
		    function PRICEDISC(settl, matur, discount, redemption, basis) { // PRICEDISC(settlement, maturity, discount, redemption, [basis])
		        var dsm = _daysBetween(settl, matur, basis),
		            dy = daysInYear(unpackDate(matur).year, basis);
		        return redemption - discount*redemption*dsm/dy;
		    }
	
		    // Used in PEARSON, more could follow.  In some situations Excel appears to silently ignore
		    // missing or non-numeric values, for example if some value in a is missing a corresponding
		    // value in b, then the one in a is going to be ignored as if not present.  Arrays must have the
		    // same number of elements.  I couldn't come up with a good name for this function.
		    function whipNumberArrays(a, b) {
		        for (var i = a.length; --i >= 0;) {
		            if (typeof a[i] != "number" || typeof b[i] != "number") {
		                a.splice(i, 1);
		                b.splice(i, 1);
		            }
		        }
		    }
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1504);
		module.exports = __webpack_require__(1504);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(561);
	
	/***/ }),
	
	/***/ 928:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 942:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 944:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(595);
	
	/***/ }),
	
	/***/ 1504:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1505), __webpack_require__(944), __webpack_require__(6), __webpack_require__(942), __webpack_require__(928), __webpack_require__(1506) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
	
		    var ToolBar = kendo.ui.ToolBar;
	
		    var MESSAGES = kendo.spreadsheet.messages.toolbar = {
		        addColumnLeft: "Add column left",
		        addColumnRight: "Add column right",
		        addRowAbove: "Add row above",
		        addRowBelow: "Add row below",
		        alignment: "Alignment",
		        alignmentButtons: {
		            justtifyLeft: "Align left",
		            justifyCenter: "Center",
		            justifyRight: "Align right",
		            justifyFull: "Justify",
		            alignTop: "Align top",
		            alignMiddle: "Align middle",
		            alignBottom: "Align bottom"
		        },
		        backgroundColor: "Background",
		        bold: "Bold",
		        borders: "Borders",
		        copy: "Copy",
		        cut: "Cut",
		        deleteColumn: "Delete column",
		        deleteRow: "Delete row",
		        filter: "Filter",
		        fontFamily: "Font",
		        fontSize: "Font size",
		        format: "Custom format...",
		        formatTypes: {
		            automatic: "Automatic",
		            text: "Text",
		            number: "Number",
		            percent: "Percent",
		            financial: "Financial",
		            currency: "Currency",
		            date: "Date",
		            time: "Time",
		            dateTime: "Date time",
		            duration: "Duration",
		            moreFormats: "More formats..."
		        },
		        formatDecreaseDecimal: "Decrease decimal",
		        formatIncreaseDecimal: "Increase decimal",
		        freeze: "Freeze panes",
		        freezeButtons: {
		            freezePanes: "Freeze panes",
		            freezeRows: "Freeze rows",
		            freezeColumns: "Freeze columns",
		            unfreeze: "Unfreeze panes"
		        },
		        italic: "Italic",
		        merge: "Merge cells",
		        mergeButtons: {
		            mergeCells: "Merge all",
		            mergeHorizontally: "Merge horizontally",
		            mergeVertically: "Merge vertically",
		            unmerge: "Unmerge"
		        },
		        open: "Open...",
		        paste: "Paste",
		        quickAccess: {
		            redo: "Redo",
		            undo: "Undo"
		        },
		        exportAs: "Export...",
		        toggleGridlines: "Toggle gridlines",
		        sort: "Sort",
		        sortButtons: {
		            // sortSheetAsc: "Sort sheet A to Z",
		            // sortSheetDesc: "Sort sheet Z to A",
		            sortRangeAsc: "Sort range A to Z",
		            sortRangeDesc: "Sort range Z to A"
		        },
		        textColor: "Text Color",
		        textWrap: "Wrap text",
		        underline: "Underline",
		        validation: "Data validation...",
		        hyperlink: "Link"
		    };
	
		    var defaultTools = {
		        home: [
		            "open",
		            "exportAs",
		            [ "cut", "copy", "paste" ],
		            [ "bold", "italic", "underline" ], "hyperlink",
		            "backgroundColor", "textColor",
		            "borders",
		            "fontSize", "fontFamily",
		            "alignment",
		            "textWrap",
		            [ "formatDecreaseDecimal", "formatIncreaseDecimal" ],
		            "format",
		            "merge",
		            "freeze",
		            "filter",
		            "toggleGridlines"
		        ],
		        insert: [
		            [ "addColumnLeft", "addColumnRight", "addRowBelow", "addRowAbove" ],
		            [ "deleteColumn", "deleteRow" ]
		        ],
		        data: [
		            "sort",
		            "filter",
		            "validation"
		        ]
		    };
	
		    var toolDefaults = {
		        //home tab
		        open:                  { type: "open",                                     overflow: "never",                          iconClass: "file-excel" },
		        exportAs:              { type: "exportAsDialog", dialogName: "exportAs",   overflow: "never",       text: "",        iconClass: "file-excel" },
		        bold:                  { type: "button", command: "PropertyChangeCommand", property: "bold",          value: true,     iconClass: "bold", togglable: true },
		        italic:                { type: "button", command: "PropertyChangeCommand", property: "italic",        value: true,     iconClass: "italic", togglable: true },
		        underline:             { type: "button", command: "PropertyChangeCommand", property: "underline",     value: true,     iconClass: "underline", togglable: true },
		        formatDecreaseDecimal: { type: "button", command: "AdjustDecimalsCommand",                            value: -1,       iconClass: "decimal-decrease" },
		        formatIncreaseDecimal: { type: "button", command: "AdjustDecimalsCommand",                            value: +1,       iconClass: "decimal-increase" },
		        textWrap:              { type: "button", command: "TextWrapCommand",       property: "wrap",          value: true,     iconClass: "text-wrap", togglable: true },
		        cut:                   { type: "button", command: "ToolbarCutCommand",                                                 iconClass: "cut" },
		        copy:                  { type: "button", command: "ToolbarCopyCommand",                                                iconClass: "copy" },
		        paste:                 { type: "button", command: "ToolbarPasteCommand",                                               iconClass: "paste" },
		        separator:             { type: "separator" },
		        alignment:             { type: "alignment",                           iconClass: "align-left" },
		        backgroundColor:       { type: "colorPicker", property: "background", iconClass: "paint" },
		        textColor:             { type: "colorPicker", property: "color",      iconClass: "foreground-color" },
		        fontFamily:            { type: "fontFamily",  property: "fontFamily", iconClass: "font-family" },
		        fontSize:              { type: "fontSize",    property: "fontSize",   iconClass: "font-size" },
		        format:                { type: "format",      property: "format",     iconClass: "custom-format" },
		        filter:                { type: "filter",      property: "hasFilter",  iconClass: "filter" },
		        merge:                 { type: "merge",                               iconClass: "cells-merge" },
		        freeze:                { type: "freeze",                              iconClass: "pane-freeze" },
		        borders:               { type: "borders",                             iconClass: "borders-all" },
		        formatCells:           { type: "dialog", dialogName: "formatCells", overflow: "never" },
		        hyperlink:             { type: "dialog", dialogName: "hyperlink", iconClass: "link-horizontal", overflow: "never", text: "" },
		        toggleGridlines:       { type: "button", command: "GridLinesChangeCommand", property: "gridLines", value: true, iconClass: "border-no", togglable: true },
	
		        //insert tab
		        addColumnLeft:         { type: "button", command: "AddColumnCommand",    value: "left",  iconClass: "table-column-insert-left"  },
		        addColumnRight:        { type: "button", command: "AddColumnCommand",    value: "right", iconClass: "table-column-insert-right" },
		        addRowBelow:           { type: "button", command: "AddRowCommand",       value: "below", iconClass: "table-row-insert-below"    },
		        addRowAbove:           { type: "button", command: "AddRowCommand",       value: "above", iconClass: "table-row-insert-above"    },
		        deleteColumn:          { type: "button", command: "DeleteColumnCommand",                 iconClass: "table-column-delete"    },
		        deleteRow:             { type: "button", command: "DeleteRowCommand",                    iconClass: "table-row-delete"       },
	
		        //data tab
		        sort:                  { type: "sort", iconClass: "sort-desc" },
		        validation:            { type: "dialog", dialogName: "validation", iconClass: "exception", overflow: "never" }
		    };
	
		    var SpreadsheetToolBar = ToolBar.extend({
		        init: function(element, options) {
		            options.items = this._expandTools(options.tools || SpreadsheetToolBar.prototype.options.tools[options.toolbarName]);
	
		            ToolBar.fn.init.call(this, element, options);
		            var handleClick = this._click.bind(this);
	
		            this.element.addClass("k-spreadsheet-toolbar");
	
		            this._addSeparators(this.element);
		            var that = this;
		            this.element.on("keydown", function (e) {
		                var tool;
		                if (e.keyCode === 9) {
		                    tool = that._nextTool(e.shiftKey ? -1 : 1);
		                    if (tool) {
		                        document.activeElement.blur();
		                        if ($(tool).is(".k-upload-button")) {
		                            $(tool).addClass("k-state-focused");
		                        }
		                        if($(tool).find("input").length) {
		                            $(tool).find("input").focus();
		                        } else {
		                            tool.focus();
		                        }
		                        e.preventDefault();
		                    }
		                }
		            });
	
		            this.element.on("focusout", function () {
		                $(this).find(".k-toolbar-first-visible").removeClass("k-state-focused");
		            });
	
		            this.bind({
		                click: handleClick,
		                toggle: handleClick
		            });
		        },
		        _nextTool: function (direction) {
		            var that = this;
		            var tools = that.element.find(".k-widget, .k-button, .k-button-group > a");
		            var activeIndex = tools.index($(document.activeElement).closest(".k-widget, .k-button, .k-button-group > a"));
		            if (activeIndex > 0) {
		                return tools[activeIndex + direction];
		            }
		        },
		        _addSeparators: function(element) {
		            var groups = element.children(".k-widget, a.k-button, .k-button-group");
	
		            groups.before("<span class='k-separator' />");
		        },
		        _expandTools: function(tools) {
		            function expandTool(toolName) {
		                // expand string to object, add missing tool properties
		                var options = $.isPlainObject(toolName) ? toolName : toolDefaults[toolName] || {};
		                var spriteCssClass = "k-icon k-i-" + options.iconClass;
		                var type = options.type;
		                var typeDefaults = {
		                    button: {
		                        showText: "overflow"
		                    },
		                    colorPicker: {
		                        toolIcon: spriteCssClass,
		                        spriteCssClass: spriteCssClass
		                    },
		                    borders: { spriteCssClass: spriteCssClass },
		                    alignment:  { spriteCssClass: spriteCssClass },
		                    merge:  { spriteCssClass: spriteCssClass },
		                    freeze:  { spriteCssClass: spriteCssClass }
		                };
	
		                var tool = $.extend({
		                    name: options.name || toolName,
		                    text: MESSAGES[options.name || toolName],
		                    icon: options.iconClass,
		                    attributes: {
		                        title: MESSAGES[options.name || toolName],
		                        "aria-label":   MESSAGES[options.name || toolName]
		                    }
		                }, typeDefaults[type], options);
	
		                if (type == "splitButton") {
		                    tool.menuButtons = tool.menuButtons.map(expandTool);
		                }
	
		                tool.attributes["data-tool"] = toolName;
	
		                if (options.property) {
		                    tool.attributes["data-property"] = options.property;
		                }
	
		                return tool;
		            }
	
		            return tools.reduce(function(tools, tool) {
		                if ($.isArray(tool)) {
		                    tools.push({ type: "buttonGroup", buttons: tool.map(expandTool) });
		                } else {
		                    tools.push(expandTool.call(this, tool));
		                }
	
		                return tools;
		            }, []);
		        },
		        _click: function(e) {
		            var toolName = e.target.attr("data-tool");
		            var tool = toolDefaults[toolName] || {};
		            var commandType = tool.command;
	
		            if (!commandType) {
		                return;
		            }
	
		            var args = {
		                command: commandType,
		                options: {
		                    property: tool.property || null,
		                    value: tool.value || null
		                }
		            };
	
		            if (typeof args.options.value === "boolean") {
		                args.options.value = e.checked ? true : null;
		            }
	
		            this.action(args);
		        },
		        events: [
		            "click",
		            "toggle",
		            "open",
		            "close",
		            "overflowOpen",
		            "overflowClose",
	
		            "action",
		            "dialog"
		        ],
		        options: {
		            name: "SpreadsheetToolBar",
		            resizable: true,
		            tools: defaultTools
		        },
		        action: function(args) {
		            this.trigger("action", args);
		        },
		        dialog: function(args) {
		            this.trigger("dialog", args);
		        },
		        refresh: function(activeCell) {
		            var range = activeCell;
		            var tools = this._tools();
	
		            function setToggle(tool, value) {
		                var toolbar = tool.toolbar;
		                var overflow = tool.overflow;
		                var togglable = (toolbar && toolbar.options.togglable) ||
		                                 (overflow && overflow.options.togglable);
	
		                if (!togglable) {
		                    return;
		                }
	
		                var toggle = false;
	
		                if (typeof value === "boolean") {
		                    toggle = value;
		                } else if (typeof value === "string") {
		                    toggle = toolbar.options.value === value;
		                }
	
		                toolbar.toggle(toggle);
	
		                if (overflow) {
		                    overflow.toggle(toggle);
		                }
		            }
	
		            function update(tool, value) {
		                var toolbar = tool.toolbar;
		                var overflow = tool.overflow;
	
		                if (toolbar && toolbar.update) {
		                    toolbar.update(value);
		                }
	
		                if (overflow && overflow.update) {
		                    overflow.update(value);
		                }
		            }
	
		            for (var i = 0; i < tools.length; i++) {
		                var property = tools[i].property;
		                var tool = tools[i].tool;
		                var value = kendo.isFunction(range[property]) ? range[property]() : range;
	
		                if (property == "gridLines") {
		                    // the law of leaky abstractions kicks in.  this
		                    // isn't really a property of the range, it's
		                    // per-sheet.
		                    value = range.sheet().showGridLines();
		                }
	
		                if (tool.type === "button") {
		                    setToggle(tool, value);
		                } else {
		                    update(tool, value);
		                }
		            }
		            this.resize();
		        },
		        _tools: function() {
		            return this.element.find("[data-property]").toArray().map(function(element) {
		                element = $(element);
		                return {
		                    property: element.attr("data-property"),
		                    tool: this._getItem(element)
		                };
		            }.bind(this));
		        },
		        destroy: function() {
		            // TODO: move to ToolBar.destroy to take care of these
		            this.element.find("[data-command],.k-button").each(function() {
		                var element = $(this);
		                var instance = element.data("instance");
		                if (instance && instance.destroy) {
		                    instance.destroy();
		                }
		            });
	
		            ToolBar.fn.destroy.call(this);
		        }
		    });
		    kendo.spreadsheet.ToolBar = SpreadsheetToolBar;
	
		    var DropDownTool = kendo.toolbar.Item.extend({
		        init: function(options, toolbar) {
		            var dropDownList = $("<select />")
		                .attr("title", options.attributes.title)
		                .attr("aria-label", options.attributes.title)
		                .kendoDropDownList({
		                    height: "auto"
		                }).data("kendoDropDownList");
	
		            this.dropDownList = dropDownList;
		            this.element = dropDownList.wrapper;
		            this.options = options;
		            this.toolbar = toolbar;
	
		            this.attributes();
		            this.addUidAttr();
		            this.addOverflowAttr();
	
		            dropDownList.bind("open", this._open.bind(this));
		            dropDownList.bind("change", this._change.bind(this));
	
		            this.element.width(options.width).attr({
		                "data-command": "PropertyChangeCommand",
		                "data-property": options.property
		            });
		        },
		        _open: function() {
		            var ddl = this.dropDownList;
		            var list = ddl.list;
		            var listWidth;
	
		            list.css({
		                whiteSpace: "nowrap",
		                width: "auto"
		            });
	
		            listWidth = list.width();
	
		            if (listWidth > 0) {
		                listWidth += 20;
		            } else {
		                listWidth = ddl._listWidth;
		            }
	
		            list.css("width", listWidth + kendo.support.scrollbar());
	
		            ddl._listWidth = listWidth;
		        },
		        _change: function(e) {
		            var that = this;
		            var instance = e.sender;
		            var value = instance.value();
		            var dataItem = instance.dataItem();
		            var popupName = dataItem ? dataItem.popup : undefined;
	
		            if (popupName) {
		                setTimeout(function () {
		                    that.toolbar.dialog({ name: popupName });
		                });
		            } else {
		                that.toolbar.action({
		                    command: "PropertyChangeCommand",
		                    options: {
		                        property: this.options.property,
		                        value: value == "null" ? null : value
		                    }
		                });
		            }
		        },
		        value: function(value) {
		            if (value !== undefined) {
		                this.dropDownList.value(value);
		            } else {
		                return this.dropDownList.value();
		            }
		        }
		    });
	
		    var PopupTool = kendo.toolbar.Item.extend({
		        init: function(options, toolbar) {
		            this.element = $("<a href='#' class='k-button k-button-icon'>" +
		                                "<span class='" + options.spriteCssClass + "'>" +
		                                "</span><span class='k-icon k-i-arrow-60-down'></span>" +
		                            "</a>");
	
		            this.element
		                .on("click touchend", this.open.bind(this))
		                .attr("data-command", options.command);
	
		            this.options = options;
		            this.toolbar = toolbar;
	
		            this.attributes();
		            this.addUidAttr();
		            this.addOverflowAttr();
	
		            this._popup();
		        },
		        destroy: function() {
		            this.popup.destroy();
		        },
		        open: function(ev) {
		            ev.preventDefault();
		            this.popup.toggle();
		        },
		        _popup: function() {
		            var element = this.element;
	
		            this.popup = $("<div class='k-spreadsheet-popup' />").appendTo(element).kendoPopup({
		                anchor: element
		            }).data("kendoPopup");
		        }
		    });
	
		    kendo.toolbar.registerComponent("dialog", kendo.toolbar.ToolBarButton.extend({
		        init: function(options, toolbar) {
		            kendo.toolbar.ToolBarButton.fn.init.call(this, options, toolbar);
	
		            this._dialogName = options.dialogName;
	
		            this.element.bind("click touchend", this.open.bind(this))
		                        .data("instance", this);
		        },
		        open: function() {
		            this.toolbar.dialog({ name: this._dialogName });
		        }
		    }));
	
		    kendo.toolbar.registerComponent("exportAsDialog", kendo.toolbar.Item.extend({
		        init: function(options, toolbar) {
		            this._dialogName = options.dialogName;
	
		            this.toolbar = toolbar;
		            this._title = options.attributes.title;
		            this.element = $("<button type='button' class='k-button k-button-icon'>" +
		                                 "<span class='k-icon k-i-download' />" +
		                             "</button>")
		                             .attr("title", this._title)
		                             .attr("aria-label", this._title)
		                             .data("instance", this);
	
		            this.element.bind("click", this.open.bind(this))
		                        .data("instance", this);
		        },
		        open: function() {
		            this.toolbar.dialog({ name: this._dialogName });
		        }
		    }));
	
		    var OverflowDialogButton = kendo.toolbar.OverflowButton.extend({
		        init: function(options, toolbar) {
		            kendo.toolbar.OverflowButton.fn.init.call(this, options, toolbar);
	
		            this.element.on("click touchend", this._click.bind(this));
	
		            this.message = this.options.text;
	
		            var instance = this.element.data("button");
		            this.element.data(this.options.type, instance);
		        },
		        _click: $.noop
		    });
	
		    var ColorPicker = PopupTool.extend({
		        init: function(options, toolbar) {
		            PopupTool.fn.init.call(this, options, toolbar);
		            this.popup.element.addClass("k-spreadsheet-colorpicker");
	
		            this.colorChooser = new kendo.spreadsheet.ColorChooser(this.popup.element, {
		                change: this._colorChange.bind(this)
		            });
	
		            this.element.attr({
		                "data-property": options.property
		            });
	
		            this.element.data({
		                type: "colorPicker",
		                colorPicker: this,
		                instance: this
		            });
		        },
		        destroy: function() {
		            this.colorChooser.destroy();
		            PopupTool.fn.destroy.call(this);
		        },
		        update: function(value) {
		            this.value(value);
		        },
		        value: function(value) {
		            this.colorChooser.value(value);
		        },
		        _colorChange: function(e) {
		            this.toolbar.action({
		                command: "PropertyChangeCommand",
		                options: {
		                    property: this.options.property,
		                    value: e.sender.value()
		                }
		            });
		            this.popup.close();
		        }
		    });
	
		    var ColorPickerButton = OverflowDialogButton.extend({
		        init: function(options, toolbar) {
		            options.iconName = "text";
		            OverflowDialogButton.fn.init.call(this, options, toolbar);
		        },
		        _click: function() {
		            this.toolbar.dialog({
		                name: "colorPicker",
		                options: {
		                    title: this.options.property, property: this.options.property
		                }
		            });
		        }
		    });
	
		    kendo.toolbar.registerComponent("colorPicker", ColorPicker, ColorPickerButton);
	
		    var FONT_SIZES = [8, 9, 10, 11, 12, 13, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
		    var DEFAULT_FONT_SIZE = 12;
	
		    var FontSize = kendo.toolbar.Item.extend({
		        init: function(options, toolbar) {
		            var comboBox = $("<input />")
		                .attr("aria-label", options.attributes.title)
		                .kendoComboBox({
		                    change: this._valueChange.bind(this),
		                    clearButton: false,
		                    dataSource: options.fontSizes || FONT_SIZES,
		                    value: DEFAULT_FONT_SIZE
		                }).data("kendoComboBox");
	
		            this.comboBox = comboBox;
		            this.element = comboBox.wrapper;
		            this.options = options;
		            this.toolbar = toolbar;
	
		            this.attributes();
		            this.addUidAttr();
		            this.addOverflowAttr();
	
		            this.element.width(options.width).attr({
		                "data-command": "PropertyChangeCommand",
		                "data-property": options.property
		            });
	
		            this.element.data({
		                type: "fontSize",
		                fontSize: this
		            });
		        },
	
		        _valueChange: function(e) {
		            this.toolbar.action({
		                command: "PropertyChangeCommand",
		                options: {
		                    property: this.options.property,
		                    value: kendo.parseInt(e.sender.value())
		                }
		            });
		        },
	
		        update: function(value) {
		            this.value(kendo.parseInt(value) || DEFAULT_FONT_SIZE);
		        },
	
		        value: function(value) {
		            if (value !== undefined) {
		                this.comboBox.value(value);
		            } else {
		                return this.comboBox.value();
		            }
		        }
		    });
	
		    var FontSizeButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({
		                name: "fontSize",
		                options: {
		                    sizes: FONT_SIZES,
		                    defaultSize: DEFAULT_FONT_SIZE
		                }
		            });
		        },
		        update: function(value) {
		            this._value = value || DEFAULT_FONT_SIZE;
		            this.element.find(".k-text").text(this.message + " (" + this._value + ") ...");
		        }
		    });
	
		    kendo.toolbar.registerComponent("fontSize", FontSize, FontSizeButton);
	
		    var FONT_FAMILIES = ["Arial", "Courier New", "Georgia", "Times New Roman", "Trebuchet MS", "Verdana"];
		    var DEFAULT_FONT_FAMILY = "Arial";
	
		    var FontFamily = DropDownTool.extend({
		        init: function(options, toolbar) {
		            DropDownTool.fn.init.call(this, options, toolbar);
	
		            var ddl = this.dropDownList;
		            ddl.setDataSource(options.fontFamilies || FONT_FAMILIES);
		            ddl.value(DEFAULT_FONT_FAMILY);
	
		            this.element.data({
		                type: "fontFamily",
		                fontFamily: this
		            });
		        },
		        update: function(value) {
		            this.value(value || DEFAULT_FONT_FAMILY);
		        }
		    });
	
		    var FontFamilyButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({
		                name: "fontFamily",
		                options: {
		                    fonts: FONT_FAMILIES,
		                    defaultFont: DEFAULT_FONT_FAMILY
		                }
		            });
		        },
		        update: function(value) {
		            this._value = value || DEFAULT_FONT_FAMILY;
		            this.element.find(".k-text").text(this.message + " (" + this._value + ") ...");
		        }
		    });
	
		    kendo.toolbar.registerComponent("fontFamily", FontFamily, FontFamilyButton);
	
		    var defaultFormats = kendo.spreadsheet.formats = {
		        automatic: null,
		        text: "@",
		        number: "#,0.00",
		        percent: "0.00%",
		        financial: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
		        currency: "$#,##0.00;[Red]$#,##0.00",
		        date: "m/d/yyyy",
		        time: "h:mm:ss AM/PM",
		        dateTime: "m/d/yyyy h:mm",
		        duration: "[h]:mm:ss"
		    };
	
		    var Format = DropDownTool.extend({
		        _revertTitle: function(e) {
		            e.sender.value("");
		            e.sender.wrapper.width("auto");
		        },
		        init: function(options, toolbar) {
		            DropDownTool.fn.init.call(this, options, toolbar);
	
		            var ddl = this.dropDownList;
		            var icon = "<span class='k-icon k-i-" + options.iconClass + "' style='line-height: 1em; width: 1.35em;'></span>";
		            ddl.bind("change", this._revertTitle.bind(this));
		            ddl.bind("dataBound", this._revertTitle.bind(this));
		            ddl.setOptions({
		                dataValueField: "format",
		                dataTextField: "name",
		                dataValuePrimitive: true,
		                valueTemplate: icon,
		                template:
		                    "# if (data.sample) { #" +
		                        "<span class='k-spreadsheet-sample'>#: data.sample #</span>" +
		                    "# } #" +
		                    "#: data.name #"
		            });
		            ddl.text(icon);
		            ddl.setDataSource([
		                { format: defaultFormats.automatic, name: MESSAGES.formatTypes.automatic },
		                { format: defaultFormats.text, name: MESSAGES.formatTypes.text },
		                { format: defaultFormats.number, name: MESSAGES.formatTypes.number , sample: "1,499.99" },
		                { format: defaultFormats.percent, name: MESSAGES.formatTypes.percent , sample: "14.50%" },
		                { format: defaultFormats.financial, name: MESSAGES.formatTypes.financial , sample: "(1,000.12)" },
		                { format: defaultFormats.currency, name: MESSAGES.formatTypes.currency , sample: "$1,499.99" },
		                { format: defaultFormats.date, name: MESSAGES.formatTypes.date , sample: "4/21/2012" },
		                { format: defaultFormats.time, name: MESSAGES.formatTypes.time , sample: "5:49:00 PM" },
		                { format: defaultFormats.dateTime, name: MESSAGES.formatTypes.dateTime , sample: "4/21/2012 5:49:00" },
		                { format: defaultFormats.duration, name: MESSAGES.formatTypes.duration , sample: "168:05:00" },
		                { popup: "formatCells", name: MESSAGES.formatTypes.moreFormats }
		            ]);
	
		            this.element.data({
		                type: "format",
		                format: this
		            });
		        }
		    });
	
		    var FormatButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({ name: "formatCells" });
		        }
		    });
	
		    kendo.toolbar.registerComponent("format", Format, FormatButton);
	
		    var BorderChangeTool = PopupTool.extend({
		        init: function(options, toolbar) {
		            PopupTool.fn.init.call(this, options, toolbar);
		            this._borderPalette();
	
		            this.element.data({
		                type: "borders",
		                instance: this
		            });
		        },
		        destroy: function() {
		            this.borderPalette.destroy();
		            PopupTool.fn.destroy.call(this);
		        },
		        _borderPalette: function() {
		            var element = $("<div />").appendTo(this.popup.element);
		            this.borderPalette = new kendo.spreadsheet.BorderPalette(element, {
		                change: this._action.bind(this)
		            });
		        },
		        _action: function(e) {
		            this.toolbar.action({
		                command: "BorderChangeCommand",
		                options: {
		                    border: e.type,
		                    style: { size: 1, color: e.color }
		                }
		            });
		        }
		    });
	
		    var BorderChangeButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({ name: "borders" });
		        }
		    });
	
		    kendo.toolbar.registerComponent("borders", BorderChangeTool, BorderChangeButton);
	
		    var AlignmentTool = PopupTool.extend({
		        init: function(options, toolbar) {
		            PopupTool.fn.init.call(this, options, toolbar);
	
		            this.element.attr({ "data-property": "alignment" });
		            this._defineButtons();
		            this._commandPalette();
		            this.popup.element.on("click", ".k-button", function(e) {
		                this._action($(e.currentTarget));
		            }.bind(this));
	
		            this.element.data({
		                type: "alignment",
		                alignment: this,
		                instance: this
		            });
		        },
		        _defineButtons: function() {
		            this.buttons = [
		                { property: "textAlign",     value: "left",    iconClass: "align-left",   text: MESSAGES.alignmentButtons.justtifyLeft },
		                { property: "textAlign",     value: "center",  iconClass: "align-center", text: MESSAGES.alignmentButtons.justifyCenter },
		                { property: "textAlign",     value: "right",   iconClass: "align-right",  text: MESSAGES.alignmentButtons.justifyRight },
		                { property: "textAlign",     value: "justify", iconClass: "align-justify",   text: MESSAGES.alignmentButtons.justifyFull },
		                { property: "verticalAlign", value: "top",     iconClass: "align-top",      text: MESSAGES.alignmentButtons.alignTop },
		                { property: "verticalAlign", value: "center",  iconClass: "align-middle",   text: MESSAGES.alignmentButtons.alignMiddle },
		                { property: "verticalAlign", value: "bottom",  iconClass: "align-bottom",   text: MESSAGES.alignmentButtons.alignBottom }
		            ];
		        },
		        destroy: function() {
		            this.popup.element.off();
		            PopupTool.fn.destroy.call(this);
		        },
		        update: function(range) {
		            var textAlign = range.textAlign();
		            var verticalAlign = range.verticalAlign();
		            var element = this.popup.element;
	
		            element.find(".k-button").removeClass("k-state-active");
	
		            if (textAlign) {
		                element.find("[data-property=textAlign][data-value=" + textAlign + "]").addClass("k-state-active");
		            }
	
		            if (verticalAlign) {
		                element.find("[data-property=verticalAlign][data-value=" + verticalAlign + "]").addClass("k-state-active");
		            }
		        },
		        _commandPalette: function() {
		            var buttons = this.buttons;
		            var element = $("<div />").appendTo(this.popup.element);
		            buttons.forEach(function(options, index) {
		                var button = "<a title='" + options.text + "' data-property='" + options.property + "' data-value='" + options.value + "' class='k-button k-button-icon'>" +
		                                "<span class='k-icon k-i-" + options.iconClass + "'></span>" +
		                             "</a>";
		                if (index !== 0 && buttons[index - 1].property !== options.property) {
		                    element.append($("<span class='k-separator' />"));
		                }
		                element.append(button);
		            });
		        },
		        _action: function(button) {
		            var property = button.attr("data-property");
		            var value = button.attr("data-value");
	
		            this.toolbar.action({
		                command: "PropertyChangeCommand",
		                options: {
		                    property: property,
		                    value: value
		                }
		            });
		        }
		    });
	
		    var AlignmentButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({ name: "alignment" });
		        }
		    });
	
		    kendo.toolbar.registerComponent("alignment", AlignmentTool, AlignmentButton);
	
		    var MergeTool = PopupTool.extend({
		        init: function(options, toolbar) {
		            PopupTool.fn.init.call(this, options, toolbar);
	
		            this._defineButtons();
		            this._commandPalette();
		            this.popup.element.on("click", ".k-button", function(e) {
		                this._action($(e.currentTarget));
		            }.bind(this));
	
		            this.element.data({
		                type: "merge",
		                merge: this,
		                instance: this
		            });
		        },
		        _defineButtons: function() {
		            this.buttons = [
		                { value: "cells",        iconClass: "cells-merge",        text: MESSAGES.mergeButtons.mergeCells },
		                { value: "horizontally", iconClass: "cells-merge-horizontally", text: MESSAGES.mergeButtons.mergeHorizontally },
		                { value: "vertically",   iconClass: "cells-merge-vertically",   text: MESSAGES.mergeButtons.mergeVertically },
		                { value: "unmerge",      iconClass: "table-unmerge",      text: MESSAGES.mergeButtons.unmerge }
		            ];
		        },
		        destroy: function() {
		            this.popup.element.off();
		            PopupTool.fn.destroy.call(this);
		        },
		        _commandPalette: function() {
		            var element = $("<div />").appendTo(this.popup.element);
		            this.buttons.forEach(function(options) {
		                var button = "<a title='" + options.text + "' data-value='" + options.value + "' class='k-button k-button-icontext'>" +
		                                "<span class='k-icon k-i-" + options.iconClass + "'></span>" + options.text +
		                             "</a>";
		                element.append(button);
		            });
		        },
		        _action: function(button) {
		            var value = button.attr("data-value");
	
		            this.toolbar.action({
		                command: "MergeCellCommand",
		                options: {
		                    value: value
		                }
		            });
		        }
		    });
	
		    var MergeButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({ name: "merge" });
		        }
		    });
	
		    kendo.toolbar.registerComponent("merge", MergeTool, MergeButton);
	
		    var FreezeTool = PopupTool.extend({
		        init: function(options, toolbar) {
		            PopupTool.fn.init.call(this, options, toolbar);
	
		            this._defineButtons();
		            this._commandPalette();
		            this.popup.element.on("click", ".k-button", function(e) {
		                this._action($(e.currentTarget));
		            }.bind(this));
	
		            this.element.data({
		                type: "freeze",
		                freeze: this,
		                instance: this
		            });
		        },
		        _defineButtons: function() {
		            this.buttons = [
		                { value: "panes",    iconClass: "pane-freeze",  text: MESSAGES.freezeButtons.freezePanes },
		                { value: "rows",     iconClass: "row-freeze",    text: MESSAGES.freezeButtons.freezeRows },
		                { value: "columns",  iconClass: "column-freeze",    text: MESSAGES.freezeButtons.freezeColumns },
		                { value: "unfreeze", iconClass: "table-unmerge", text: MESSAGES.freezeButtons.unfreeze }
		            ];
		        },
		        destroy: function() {
		            this.popup.element.off();
		            PopupTool.fn.destroy.call(this);
		        },
		        _commandPalette: function() {
		            var element = $("<div />").appendTo(this.popup.element);
		            this.buttons.forEach(function(options) {
		                var button = "<a title='" + options.text + "' data-value='" + options.value + "' class='k-button k-button-icontext'>" +
		                                "<span class='k-icon k-i-" + options.iconClass + "'></span>" + options.text +
		                             "</a>";
		                element.append(button);
		            });
		        },
		        _action: function(button) {
		            var value = button.attr("data-value");
	
		            this.toolbar.action({
		                command: "FreezePanesCommand",
		                options: {
		                    value: value
		                }
		            });
		        }
		    });
	
		    var FreezeButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({ name: "freeze" });
		        }
		    });
	
		    kendo.toolbar.registerComponent("freeze", FreezeTool, FreezeButton);
	
		    var Sort = DropDownTool.extend({
		        _revertTitle: function(e) {
		            e.sender.value("");
		            e.sender.wrapper.width("auto");
		        },
		        init: function(options, toolbar) {
		            DropDownTool.fn.init.call(this, options, toolbar);
	
		            var ddl = this.dropDownList;
		            ddl.bind("change", this._revertTitle.bind(this));
		            ddl.bind("dataBound", this._revertTitle.bind(this));
		            ddl.setOptions({
		                valueTemplate: "<span class='k-icon k-i-" + options.iconClass + "' style='line-height: 1em; width: 1.35em;'></span>",
		                template: "<span class='k-icon k-i-#= iconClass #' style='line-height: 1em; width: 1.35em;'></span>#=text#",
		                dataTextField: "text",
		                dataValueField: "value"
		            });
		            ddl.setDataSource([
		                // { value: "asc", sheet: true, asc: true,  text: MESSAGES.sortButtons.sortSheetAsc,  iconClass: "sort-asc" },
		                // { value: "desc", sheet: true, asc: false, text: MESSAGES.sortButtons.sortSheetDesc,  , iconClass: "sort-desc" },
		                { value: "asc", sheet: false, text: MESSAGES.sortButtons.sortRangeAsc, iconClass: "sort-asc" },
		                { value: "desc", sheet: false, text: MESSAGES.sortButtons.sortRangeDesc, iconClass: "sort-desc" }
		            ]);
		            ddl.select(0);
	
		            this.element.data({
		                type: "sort",
		                sort: this
		            });
		        },
		        _change: function(e) {
		            var instance = e.sender;
		            var dataItem = instance.dataItem();
	
		            if (dataItem) {
		                this.toolbar.action({
		                    command: "SortCommand",
		                    options: {
		                        value: dataItem.value,
		                        sheet: dataItem.sheet
		                    }
		                });
		            }
		        },
		        value: $.noop
		    });
	
		    var SortButton = OverflowDialogButton.extend({
		        _click: function() {
		            this.toolbar.dialog({ name: "sort" });
		        }
		    });
	
		    kendo.toolbar.registerComponent("sort", Sort, SortButton);
	
		    var Filter = kendo.toolbar.ToolBarButton.extend({
		        init: function(options, toolbar) {
		            options.showText = "overflow";
		            kendo.toolbar.ToolBarButton.fn.init.call(this, options, toolbar);
	
		            this.element.on("click", this._click.bind(this));
	
		            this.element.data({
		                type: "filter",
		                filter: this
		            });
		        },
		        _click: function() {
		            this.toolbar.action({ command: "FilterCommand" });
		        },
		        update: function(value) {
		            this.toggle(value);
		        }
		    });
	
		    var FilterButton = OverflowDialogButton.extend({
		        init: function(options, toolbar) {
		            OverflowDialogButton.fn.init.call(this, options, toolbar);
	
		            this.element.data({
		                type: "filter",
		                filter: this
		            });
		        },
		        _click: function() {
		            this.toolbar.action({ command: "FilterCommand" });
		        },
		        update: function(value) {
		            this.toggle(value);
		        }
		    });
	
		    kendo.toolbar.registerComponent("filter", Filter, FilterButton);
	
		    var Open = kendo.toolbar.Item.extend({
		        init: function(options, toolbar) {
		            this.toolbar = toolbar;
		            this.element = $("<div class='k-button k-upload-button k-button-icon'>" +
		                                 "<span class='k-icon k-i-folder-open' />" +
		                             "</div>").data("instance", this);
	
		            this._title = options.attributes.title;
		            this._reset();
		        },
		        _reset: function() {
		            this.element.find("input").remove();
	
		            $("<input type='file' autocomplete='off' accept='.xlsx'/>")
		                .attr("title", this._title)
		                .attr("aria-label", this._title)
		                .one("change", this._change.bind(this))
		                .appendTo(this.element);
		        },
		        _change: function(e) {
		            this.toolbar.action({
		                command: "OpenCommand",
		                options: {
		                    file: e.target.files[0]
		                }
		            });
	
		            this._reset();
		        }
		    });
		    kendo.toolbar.registerComponent("open", Open);
	
		    kendo.spreadsheet.TabStrip = kendo.ui.TabStrip.extend({
		        init: function(element, options) {
		            kendo.ui.TabStrip.fn.init.call(this, element, options);
		            element.addClass("k-spreadsheet-tabstrip");
		            this._quickAccessButtons();
	
		            this.toolbars = {};
	
		            var tabs = options.dataSource;
	
		            this.contentElements.each(function(idx, element) {
		                this._toolbar($(element), tabs[idx].id, options.toolbarOptions[tabs[idx].id]);
		            }.bind(this));
	
		            this.one("activate", function() { //force resize of the tabstrip after TabStrip tab is opened
		                this.toolbars[this.options.dataSource[0].id].resize();
		            });
		        },
	
		        events: kendo.ui.TabStrip.fn.events.concat([ "action", "dialog" ]),
	
		        destroy: function() {
		            this.quickAccessToolBar.off("click");
		            kendo.ui.TabStrip.fn.destroy.call(this);
		            for (var name in this.toolbars) {
		                this.toolbars[name].destroy();
		            }
		        },
	
		        action: function(args) {
		            this.trigger("action", args);
		        },
	
		        dialog: function(args) {
		            this.trigger("dialog", args);
		        },
	
		        refreshTools: function(range) {
		            var toolbars = this.toolbars;
		            for (var name in toolbars) {
		                if (toolbars.hasOwnProperty(name)) {
		                    toolbars[name].refresh(range);
		                }
		            }
		        },
	
		        _quickAccessButtons: function() {
		            var buttons = [
		                { title: MESSAGES.quickAccess.undo, iconClass: "undo", action: "undo" },
		                { title: MESSAGES.quickAccess.redo, iconClass: "redo", action: "redo" }
		            ];
		            var buttonTemplate = kendo.template("<a href='\\#' title='#= title #' data-action='#= action #' class='k-button k-button-icon' aria-label='#= title #'><span class='k-icon k-i-#=iconClass#'></span></a>");
	
		            this.quickAccessToolBar = $("<div />", {
		                "class": "k-spreadsheet-quick-access-toolbar",
		                "html": kendo.render(buttonTemplate, buttons)
		            }).insertBefore(this.wrapper);
	
		            this.quickAccessToolBar.on("click", ".k-button", function(e) {
		                e.preventDefault();
	
		                var action = $(e.currentTarget).attr("data-action");
		                this.action({ action: action });
		            }.bind(this));
	
		            this.quickAccessAdjust();
		        },
	
		        quickAccessAdjust: function() {
		            this.tabGroup.css("padding-left", kendo._outerWidth(this.quickAccessToolBar));
		        },
	
		        _toolbar: function(container, name, tools) {
		            var element;
		            var options;
	
		            if (this.toolbars[name]) {
		                this.toolbars[name].destroy();
		                container.children(".k-toolbar").remove();
		            }
	
		            if (tools) {
		                element = container.html("<div />").children("div");
	
		                options = {
		                    tools: typeof tools === "boolean" ? undefined : tools,
		                    toolbarName: name,
		                    action: this.action.bind(this),
		                    dialog: this.dialog.bind(this)
		                };
	
		                this.toolbars[name] = new kendo.spreadsheet.ToolBar(element, options);
		            }
		        }
	
		    });
	
		})(window.kendo);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1505:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(634);
	
	/***/ }),
	
	/***/ 1506:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(732);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1454);
		module.exports = __webpack_require__(1454);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 928:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 944:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(595);
	
	/***/ }),
	
	/***/ 1454:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(944), __webpack_require__(928) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    (function(kendo) {
		        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		            return;
		        }
	
		        var $ = kendo.jQuery;
		        var BORDER_TYPES = [
		            "allBorders",
		            "insideBorders",
		            "insideHorizontalBorders",
		            "insideVerticalBorders",
		            "outsideBorders",
		            "leftBorder",
		            "topBorder",
		            "rightBorder",
		            "bottomBorder",
		            "noBorders"
		        ];
	
		        var BORDER_PALETTE_MESSAGES = kendo.spreadsheet.messages.borderPalette = {
		            allBorders: "All borders",
		            insideBorders: "Inside borders",
		            insideHorizontalBorders: "Inside horizontal borders",
		            insideVerticalBorders: "Inside vertical borders",
		            outsideBorders: "Outside borders",
		            leftBorder: "Left border",
		            topBorder: "Top border",
		            rightBorder: "Right border",
		            bottomBorder: "Bottom border",
		            noBorders: "No border"
		        };
	
		        var COLOR_PICKER_MESSAGES = kendo.spreadsheet.messages.colorPicker = {
		            reset: "Reset color",
		            customColor: "Custom color...",
		            apply: "Apply",
		            cancel: "Cancel"
		        };
	
		        function withPreventDefault(f) {
		            return function(e) {
		                e.preventDefault();
		                return f.apply(this, arguments);
		            };
		        }
	
		        var ColorChooser = kendo.ui.Widget.extend({
		            init: function(element, options) {
		                kendo.ui.Widget.call(this, element, options);
	
		                this.element = element;
		                this.color = options.color;
	
		                this._resetButton();
		                this._colorPalette();
		                this._customColorPalette();
		                this._customColorButton();
	
		                this.resetButton.on("click", withPreventDefault(this.resetColor.bind(this)));
		                this.customColorButton.on("click", withPreventDefault(this.customColor.bind(this)));
		            },
	
		            options: {
		                name: "ColorChooser"
		            },
	
		            events: [
		                "change"
		            ],
	
		            destroy: function() {
		                kendo.unbind(this.dialog.element.find(".k-action-buttons"));
		                this.dialog.destroy();
		                this.colorPalette.destroy();
		                this.resetButton.off("click");
		                this.customColorButton.off("click");
		            },
	
		            value: function(value) {
		                if (value !== undefined) {
		                    this.color = value;
		                    this.customColorButton.find(".k-icon").css("background-color", this.color);
		                    this.colorPalette.value(null);
		                    this.flatColorPicker.value(this.color);
		                } else {
		                    return this.color;
		                }
		            },
	
		            _change: function(value) {
		                this.color = value;
		                this.trigger("change", { value: value });
		            },
	
		            _colorPalette: function() {
		                var element = $("<div />", {
		                    "class": "k-spreadsheet-color-palette"
		                });
	
		                var colorPalette = this.colorPalette = $("<div />").kendoColorPalette({
		                    palette: [ //metro palette
		                        "#ffffff", "#000000", "#d6ecff", "#4e5b6f", "#7fd13b", "#ea157a", "#feb80a", "#00addc", "#738ac8", "#1ab39f",
		                        "#f2f2f2", "#7f7f7f", "#a7d6ff", "#d9dde4", "#e5f5d7", "#fad0e4", "#fef0cd", "#c5f2ff", "#e2e7f4", "#c9f7f1",
		                        "#d8d8d8", "#595959", "#60b5ff", "#b3bcca", "#cbecb0", "#f6a1c9", "#fee29c", "#8be6ff", "#c7d0e9", "#94efe3",
		                        "#bfbfbf", "#3f3f3f", "#007dea", "#8d9baf", "#b2e389", "#f272af", "#fed46b", "#51d9ff", "#aab8de", "#5fe7d5",
		                        "#a5a5a5", "#262626", "#003e75", "#3a4453", "#5ea226", "#af0f5b", "#c58c00", "#0081a5", "#425ea9", "#138677",
		                        "#7f7f7f", "#0c0c0c", "#00192e", "#272d37", "#3f6c19", "#750a3d", "#835d00", "#00566e", "#2c3f71", "#0c594f"
		                    ],
		                    value: this.color,
		                    change: function(e) {
		                        this.customColorButton.find(".k-icon").css("background-color", "transparent");
		                        this.flatColorPicker.value(null);
		                        this._change(e.value);
		                    }.bind(this)
		                }).data("kendoColorPalette");
	
		                element
		                    .append(colorPalette.wrapper)
		                    .appendTo(this.element);
		            },
	
		            _customColorPalette: function() {
		                var element = $("<div />", {
		                    "class": "k-spreadsheet-window",
		                    "html": "<div></div>" +
		                            "<div class='k-action-buttons'>" +
		                                "<button class='k-button k-primary' data-bind='click: apply'>" + COLOR_PICKER_MESSAGES.apply + "</button>" +
		                                "<button class='k-button' data-bind='click: close'>" + COLOR_PICKER_MESSAGES.cancel + "</button>" +
		                            "</div>"
		                });
	
		                var dialog = this.dialog = element.appendTo(document.body).kendoWindow({
		                    animation: false,
		                    scrollable: false,
		                    resizable: false,
		                    maximizable: false,
		                    modal: true,
		                    visible: false,
		                    width: 268,
		                    open: function() {
		                        this.center();
		                    }
		                }).data("kendoWindow");
	
		                dialog.one("activate", function() {
		                    this.element.find("[data-role=flatcolorpicker]").data("kendoFlatColorPicker")._hueSlider.resize();
		                });
	
		                var flatColorPicker = this.flatColorPicker = dialog.element.children().first().kendoFlatColorPicker().data("kendoFlatColorPicker");
	
		                var viewModel = kendo.observable({
		                    apply: function() {
		                        this.customColorButton.find(".k-icon").css("background-color", flatColorPicker.value());
		                        this.colorPalette.value(null);
		                        this._change(flatColorPicker.value());
		                        dialog.close();
		                    }.bind(this),
		                    close: function() {
		                        flatColorPicker.value(null);
		                        dialog.close();
		                    }
		                });
	
		                kendo.bind(dialog.element.find(".k-action-buttons"), viewModel);
		            },
	
		            _resetButton: function() {
		                this.resetButton = $("<a class='k-button k-reset-color' href='#'>" +
		                                    "<span class='k-icon k-i-reset-color'></span>" + COLOR_PICKER_MESSAGES.reset +
		                                   "</a>").appendTo(this.element);
		            },
	
		            _customColorButton: function() {
		                this.customColorButton = $("<a class='k-button k-custom-color' href='#'>" +
		                                            "<span class='k-icon'></span>" + COLOR_PICKER_MESSAGES.customColor +
		                                           "</a>").appendTo(this.element);
		            },
	
		            resetColor: function() {
		                this.colorPalette.value(null);
		                this.flatColorPicker.value(null);
		                this._change(null);
		            },
	
		            customColor: function() {
		                this.dialog.open();
		            }
	
		        });
	
		        var BorderPalette = kendo.ui.Widget.extend({
		            init: function(element, options) {
		                kendo.ui.Widget.call(this, element, options);
	
		                this.element = element;
		                this.color = "#000";
	
		                this.element.addClass("k-spreadsheet-border-palette");
	
		                this._borderTypePalette();
		                this._borderColorPalette();
	
		                this.element.on("click", ".k-spreadsheet-border-type-palette .k-button", withPreventDefault(this._click.bind(this)));
		            },
	
		            options: {
		                name: "BorderPalette"
		            },
	
		            events: [
		                "change"
		            ],
	
		            destroy: function() {
		                this.colorChooser.destroy();
		                this.element.off("click");
		            },
	
		            _borderTypePalette: function() {
		                var messages = BORDER_PALETTE_MESSAGES;
		                var buttons = BORDER_TYPES.map(function(type) {
		                    return '<a title="' + messages[type] + '" aria-label="' + messages[type] + '" href="#" data-border-type="' + type + '" class="k-button k-button-icon">' +
		                                '<span class="k-icon k-i-' + kendo.toHyphens(type) + '"></span>' +
		                           '</a>';
		                }).join("");
	
		                var element = $("<div />", {
		                    "class": "k-spreadsheet-border-type-palette",
		                    "html": buttons
		                });
	
		                element.appendTo(this.element);
		            },
	
		            _borderColorPalette: function() {
		                var element = $("<div />", {
		                    "class": "k-spreadsheet-border-color-palette"
		                });
	
		                element.appendTo(this.element);
	
		                this.colorChooser = new ColorChooser(element, {
		                    color: this.color,
		                    change: this._colorChange.bind(this)
		                });
		            },
	
		            _click: function(e) {
		                this.type = $(e.currentTarget).data("borderType");
		                this.trigger("change", { type: this.type, color: this.color });
		            },
	
		            _colorChange: function(e) {
		                this.color = e.value;
		                if (this.type) {
		                    this.trigger("change", { type: this.type, color: this.color });
		                }
		            }
		        });
	
		        kendo.spreadsheet.ColorChooser = ColorChooser;
		        kendo.spreadsheet.BorderPalette = BorderPalette;
	
		    })(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1466);
		module.exports = __webpack_require__(1466);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 8:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(577);
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1458:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1466:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(1458), __webpack_require__(8) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
		    var ObservableObject = kendo.data.ObservableObject;
	
		    var MESSAGES = kendo.spreadsheet.messages.dialogs = {
		        apply: "Apply",
		        save: "Save",
		        cancel: "Cancel",
		        remove: "Remove",
		        retry: "Retry",
		        revert: "Revert",
		        okText: "OK",
		        formatCellsDialog: {
		            title: "Format",
		            categories: {
		                number: "Number",
		                currency: "Currency",
		                date: "Date"
		            }
		        },
		        fontFamilyDialog: {
		            title: "Font"
		        },
		        fontSizeDialog: {
		            title: "Font size"
		        },
		        bordersDialog: {
		            title: "Borders"
		        },
		        alignmentDialog: {
		            title: "Alignment",
		            buttons: {
		                justtifyLeft: "Align left",
		                justifyCenter: "Center",
		                justifyRight: "Align right",
		                justifyFull: "Justify",
		                alignTop: "Align top",
		                alignMiddle: "Align middle",
		                alignBottom: "Align bottom"
		            }
		        },
		        mergeDialog: {
		            title: "Merge cells",
		            buttons: {
		                mergeCells: "Merge all",
		                mergeHorizontally: "Merge horizontally",
		                mergeVertically: "Merge vertically",
		                unmerge: "Unmerge"
		            }
		        },
		        freezeDialog: {
		            title: "Freeze panes",
		            buttons: {
		                freezePanes: "Freeze panes",
		                freezeRows: "Freeze rows",
		                freezeColumns: "Freeze columns",
		                unfreeze: "Unfreeze panes"
		            }
		        },
		        confirmationDialog: {
		            text: "Are you sure you want to remove this sheet?",
		            title: "Sheet remove"
		        },
		        validationDialog: {
		            title: "Data Validation",
		            hintMessage: "Please enter a valid {0} value {1}.",
		            hintTitle: "Validation {0}",
		            criteria: {
		                any: "Any value",
		                number: "Number",
		                text: "Text",
		                date: "Date",
		                custom: "Custom Formula",
		                list: "List"
		            },
		            comparers: {
		                greaterThan: "greater than",
		                lessThan: "less than",
		                between: "between",
		                notBetween: "not between",
		                equalTo: "equal to",
		                notEqualTo: "not equal to",
		                greaterThanOrEqualTo: "greater than or equal to",
		                lessThanOrEqualTo: "less than or equal to"
		            },
		            comparerMessages: {
		                greaterThan: "greater than {0}",
		                lessThan: "less than {0}",
		                between: "between {0} and {1}",
		                notBetween: "not between {0} and {1}",
		                equalTo: "equal to {0}",
		                notEqualTo: "not equal to {0}",
		                greaterThanOrEqualTo: "greater than or equal to {0}",
		                lessThanOrEqualTo: "less than or equal to {0}",
		                custom: "that satisfies the formula: {0}"
		            },
		            labels: {
		                criteria: "Criteria",
		                comparer: "Comparer",
		                min: "Min",
		                max: "Max",
		                value: "Value",
		                start: "Start",
		                end: "End",
		                onInvalidData: "On invalid data",
		                rejectInput: "Reject input",
		                showWarning: "Show warning",
		                showHint: "Show hint",
		                hintTitle: "Hint title",
		                hintMessage: "Hint message",
		                ignoreBlank: "Ignore blank",
		                showListButton: "Display button to show list",
		                showCalendarButton: "Display button to show calendar"
		            },
		            placeholders: {
		                typeTitle: "Type title",
		                typeMessage: "Type message"
		            }
		        },
		        exportAsDialog: {
		            title: "Export...",
		            labels: {
		                scale: "Scale",
		                fit: "Fit to page",
		                fileName: "File name",
		                saveAsType: "Save as type",
		                exportArea: "Export",
		                paperSize: "Paper size",
		                margins: "Margins",
		                orientation: "Orientation",
		                print: "Print",
		                guidelines: "Guidelines",
		                center: "Center",
		                horizontally: "Horizontally",
		                vertically: "Vertically"
		            }
		        },
		        modifyMergedDialog: {
		            errorMessage: "Cannot change part of a merged cell."
		        },
		        rangeDisabledDialog: {
		            errorMessage: "Destination range contains disabled cells."
		        },
		        intersectsArrayDialog: {
		            errorMessage: "You cannot alter part of an array"
		        },
		        incompatibleRangesDialog: {
		            errorMessage: "Incompatible ranges"
		        },
		        noFillDirectionDialog: {
		            errorMessage: "Cannot determine fill direction"
		        },
		        duplicateSheetNameDialog: {
		            errorMessage: "Duplicate sheet name"
		        },
		        overflowDialog: {
		            errorMessage: "Cannot paste, because the copy area and the paste area are not the same size and shape."
		        },
		        useKeyboardDialog: {
		            title: "Copying and pasting",
		            errorMessage: "These actions cannot be invoked through the menu. Please use the keyboard shortcuts instead:",
		            labels: {
		                forCopy: "for copy",
		                forCut: "for cut",
		                forPaste: "for paste"
		            }
		        },
		        unsupportedSelectionDialog: {
		            errorMessage: "That action cannot be performed on multiple selection."
		        },
		        linkDialog: {
		            title: "Hyperlink",
		            labels: {
		                text: "Text",
		                url: "Address",
		                removeLink: "Remove link"
		            }
		        }
		    };
	
		    var registry = {};
		    kendo.spreadsheet.dialogs = {
		        register: function(name, dialogClass) {
		            registry[name] = dialogClass;
		        },
		        registered: function(name) {
		            return !!registry[name];
		        },
		        create: function(name, options) {
		            var dialogClass = registry[name];
	
		            if (dialogClass) {
		                return new dialogClass(options);
		            }
		        }
		    };
	
		    var SpreadsheetDialog = kendo.spreadsheet.SpreadsheetDialog = kendo.Observable.extend({
		        init: function(options) {
		            kendo.Observable.fn.init.call(this, options);
	
		            this.options = $.extend(true, {}, this.options, options);
	
		            this.bind(this.events, options);
		        },
		        events: [
		            "close",
		            "activate"
		        ],
		        options: {
		            autoFocus: true
		        },
		        dialog: function() {
		            if (!this._dialog) {
		                this._dialog = $("<div class='k-spreadsheet-window k-action-window k-popup-edit-form' />")
		                    .addClass(this.options.className || "")
		                    .append(kendo.template(this.options.template)({
		                        messages: kendo.spreadsheet.messages.dialogs || MESSAGES,
	
		                        // this is for ImportErrorDialog.  ugly that
		                        // we need this line here, but I couldn't
		                        // figure out a better way
		                        errors: this.options.errors
		                    }))
		                    .appendTo(document.body)
		                    .kendoWindow({
		                        autoFocus: false,
		                        scrollable: false,
		                        resizable: false,
		                        modal: true,
		                        visible: false,
		                        width: this.options.width || 320,
		                        title: this.options.title,
		                        open: function() {
		                            this.center();
		                        },
		                        close: this._onDialogClose.bind(this),
		                        activate: this._onDialogActivate.bind(this),
		                        deactivate: this._onDialogDeactivate.bind(this)
		                    })
		                    .data("kendoWindow");
		            }
	
		            return this._dialog;
		        },
		        _onDialogClose: function() {
		            this.trigger("close", {
		                action: this._action
		            });
		        },
		        _onDialogActivate: function() {
		            this.trigger("activate");
		        },
		        _onDialogDeactivate: function() {
		            this.trigger("deactivate");
		            this.destroy();
		        },
		        destroy: function() {
		            if (this._dialog) {
		                this._dialog.destroy();
		                this._dialog = null;
		            }
		        },
		        open: function() {
		            this.dialog().open();
		            this.dialog().element.find(".k-primary").focus();
		        },
		        apply: function() {
		            this.close();
		        },
		        close: function() {
		            this._action = "close";
	
		            this.dialog().close();
		        }
		    });
	
		    function formattedValue(value, format) {
		        return kendo.spreadsheet.formatting.text(value, format);
		    }
	
		    var FormatCellsViewModel = kendo.spreadsheet.FormatCellsViewModel = ObservableObject.extend({
		        init: function(options) {
		            ObservableObject.fn.init.call(this, options);
	
		            this.useCategory(this.category);
		        },
		        useCategory: function(category) {
		            var type = category && category.type || "number";
		            var formatCurrency = type == "currency";
	
		            this.category = category;
	
		            this.set("showCurrencyFilter", formatCurrency && this.currencies.length > 1);
	
		            if (!formatCurrency) {
		                this.set("formats", this.allFormats[type + "Formats"]);
		            } else {
		                this.currency(this.currencies[0]);
		            }
	
		            this.useFirstFormat();
		        },
		        useFirstFormat: function() {
		            if (this.formats.length) {
		                this.set("format", this.formats[0].value);
		            }
		        },
		        currency: function(currency) {
		            if (currency !== undefined) {
		                this._currency = currency;
	
		                var info = currency.value;
		                var formats = [
		                    { currency: info, decimals: true },
		                    { currency: info, decimals: true, iso: true },
		                    { currency: info, decimals: false }
		                ];
	
		                formats = formats.map(function(format) {
		                    format = FormatCellsViewModel.convert.currency(format);
	
		                    return { value: format, name: formattedValue(1000, format) };
		                });
	
		                this.set("formats", formats);
	
		                this.useFirstFormat();
		            }
	
		            return this._currency || this.currencies[0];
		        },
		        categoryFilter: function(category) {
		            if (category !== undefined) {
		                this.useCategory(category);
		            }
	
		            return this.category;
		        },
		        preview: function() {
		            var format = this.get("format");
		            var value = this.value || 0;
	
		            if (format && format.length) {
		                return formattedValue(value, format);
		            } else {
		                return value;
		            }
		        }
		    });
	
		    FormatCellsViewModel.convert = {
		        currency: function(options) {
		            function repeat(token, n) {
		                return new Array(n+1).join(token);
		            }
	
		            // convert culture info to spreadsheet format
		            var info = options.currency;
		            var format = info.pattern[1];
	
		            if (options.decimals) {
		                format = format.replace(/n/g, "n" + info["."] + repeat("0", info.decimals));
		            }
	
		            if (options.iso) {
		                format = '"' + info.abbr + '" ' + format.replace(/\s*\$\s*/g, "");
		            } else {
		                format = format.replace(/\$/g, info.symbol);
		            }
	
		            format = format.replace(/n/g, "?");
	
		            return format;
		        },
		        date: function(format) {
		            if ((/T|Z/).test(format)) {
		                return "";
		            }
	
		            return format.toLowerCase().replace(/tt/g, "AM/PM").replace(/'/g, '"');
		        }
		    };
	
		    function uniqueBy(field, array) {
		        var result = [];
		        var values = [];
	
		        for (var i = 0; i < array.length; i++) {
		            if ($.inArray(array[i][field], values) == -1) {
		                result.push(array[i]);
		                values.push(array[i][field]);
		            }
		        }
	
		        return result;
		    }
	
		    var FormatCellsDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.formatCellsDialog || MESSAGES;
		            var defaultOptions = {
		                title: messages.title,
		                categories: [
		                    { type: "number", name: messages.categories.number },
		                    { type: "currency", name: messages.categories.currency },
		                    { type: "date", name: messages.categories.date }
		                ]
		            };
	
		            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
	
		            this._generateFormats();
		        },
		        options: {
		            className: "k-spreadsheet-format-cells",
		            template:
		                "<div class='k-edit-form-container'>" +
	
		                    "<div class='k-root-tabs' data-role='tabstrip' " +
		                        "data-text-field='name' " +
		                        "data-bind='source: categories, value: categoryFilter' " +
		                        "data-animation='false' />" +
	
		                    "<div class='k-spreadsheet-preview' data-bind='text: preview' />" +
	
		                    "<script type='text/x-kendo-template' id='format-item-template'>" +
		                        "\\#: data.name \\#" +
		                    "</script>" +
	
		                    "<select data-role='dropdownlist' class='k-format-filter' " +
		                        "data-text-field='description' " +
		                        "data-value-field='value.name' " +
		                        "data-bind='visible: showCurrencyFilter, value: currency, source: currencies' />" +
	
		                    "<ul data-role='staticlist' tabindex='0' " +
		                        "class='k-list k-reset' " +
		                        "data-template='format-item-template' " +
		                        "data-value-primitive='true' " +
		                        "data-value-field='value' " +
		                        "data-bind='source: formats, value: format' />" +
	
		                    "<div class='k-action-buttons'>" +
		                        "<button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button>" +
		                        "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
		                    "</div>"+
	
		                "</div>"
		        },
		        _generateFormats: function() {
		            var options = this.options;
	
		            if (!options.currencies) {
		                options.currencies = FormatCellsDialog.currenciesFrom(kendo.cultures);
		            }
	
		            if (!options.numberFormats) {
		                options.numberFormats = [
		                    { value: "#.00%", name: "100.00%" },
		                    { value: "#%", name: "100%" },
		                    { value: "#.00", name: "1024.00" },
		                    { value: "#,###.00", name: "1,024.00" }
		                ];
		            }
	
		            if (!options.dateFormats) {
		                var calendarPatterns = kendo.cultures.current.calendars.standard.patterns;
	
		                options.dateFormats = uniqueBy("value", $.map(calendarPatterns, function(format) {
		                    format = FormatCellsViewModel.convert.date(format);
	
		                    if (!format) {
		                        return;
		                    }
	
		                    return { value: format, name: formattedValue(34567.7678, format) };
		                }));
		            }
		        },
		        open: function(range) {
		            var options = this.options;
		            var value = range.value();
		            var categories = options.categories.slice(0);
		            var element;
	
		            this.viewModel = new FormatCellsViewModel({
		                currencies: options.currencies.slice(0),
		                allFormats: {
		                    numberFormats: options.numberFormats.slice(0),
		                    dateFormats: options.dateFormats.slice(0)
		                },
		                categories: categories,
		                format: range.format(),
		                category: value instanceof Date ? categories[2] : categories[0],
		                apply: this.apply.bind(this),
		                close: this.close.bind(this),
		                value: value
		            });
	
		            SpreadsheetDialog.fn.open.call(this);
	
		            element = this.dialog().element;
	
		            kendo.bind(element, this.viewModel);
	
		            var currencyFilter = element.find("select.k-format-filter").data("kendoDropDownList");
	
		            if (options.currencies.length > 10) {
		                currencyFilter.setOptions({ filter: "contains" });
		            }
	
		            element.find(kendo.roleSelector("staticlist")).parent().addClass("k-list-wrapper");
		        },
		        apply: function() {
		            var format = this.viewModel.format;
	
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "PropertyChangeCommand",
		                options: {
		                    property: "format",
		                    value: format
		                }
		            });
		        }
		    });
	
		    FormatCellsDialog.currenciesFrom = function (cultures) {
		        return uniqueBy("description", $.map(cultures, function(culture, name) {
		            if (!(/-/).test(name)) {
		                return;
		            }
	
		            var currency = culture.numberFormat.currency;
		            var description = kendo.format(
		                "{0} ({1}, {2})",
		                currency.name,
		                currency.abbr,
		                currency.symbol
		            );
	
		            return { description: description, value: currency };
		        }));
		    };
	
		    kendo.spreadsheet.dialogs.register("formatCells", FormatCellsDialog);
	
		    kendo.spreadsheet.dialogs.FormatCellsDialog = FormatCellsDialog;
	
		    var MessageDialog = SpreadsheetDialog.extend({
		        options: {
		            className: "k-spreadsheet-message",
		            title: "",
		            messageId: "",
		            text: "",
		            template:
		                "<div class='k-spreadsheet-message-content' data-bind='text: text' />" +
		                "<div class='k-action-buttons'>" +
		                    "<button class='k-button k-primary' data-bind='click: close'>" +
		                        "#= messages.okText #" +
		                    "</button>" +
		                "</div>"
		        },
		        open: function() {
		            SpreadsheetDialog.fn.open.call(this);
	
		            var options = this.options;
		            var text = options.text;
	
		            if (options.messageId) {
		                text = kendo.getter(options.messageId, true)(kendo.spreadsheet.messages.dialogs);
		            }
	
		            kendo.bind(this.dialog().element, {
		                text: text,
		                close: this.close.bind(this)
		            });
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("message", MessageDialog);
	
		    var ConfirmationDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.confirmationDialog || MESSAGES;
		            var defaultOptions = {
		                title: messages.title,
		                text: messages.text
		            };
	
		            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
		        },
		        options: {
		            className: "k-spreadsheet-message",
		            messageId: "",
		            template:
		                "<div class='k-spreadsheet-message-content' data-bind='text: text' />" +
		                "<div class='k-action-buttons'>" +
		                    "<button class='k-button k-primary' data-bind='click: confirm'>" +
		                        "#= messages.okText #" +
		                    "</button>" +
		                    "<button class='k-button' data-bind='click: cancel'>" +
		                        "#= messages.cancel #" +
		                    "</button>" +
		                "</div>"
		        },
		        open: function() {
		            SpreadsheetDialog.fn.open.call(this);
	
		            var options = this.options;
		            var text = options.text;
	
		            if (options.messageId) {
		                text = kendo.getter(options.messageId, true)(kendo.spreadsheet.messages.dialogs);
		            }
	
		            kendo.bind(this.dialog().element, {
		                text: text,
		                confirm: this.confirm.bind(this),
		                cancel: this.close.bind(this)
		            });
		        },
		        isConfirmed: function() {
		            return this._confirmed;
		        },
		        confirm: function() {
		            this._confirmed = true;
		            this.close();
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("confirmation", ConfirmationDialog);
	
		    var ValidationErrorDialog = SpreadsheetDialog.extend({
		        options: {
		            className: "k-spreadsheet-message",
		            title: "",
		            messageId: "",
		            text: "",
		            template:
		            "<div class='k-spreadsheet-message-content' data-bind='text: text' />" +
		            "<div class='k-action-buttons'>" +
		            "<button class='k-button k-primary' data-bind='click: retry'>" +
		                "#= messages.retry #" +
		            "</button>" +
		            "<button class='k-button' data-bind='click: cancel'>" +
		                "#= messages.cancel #" +
		            "</button>" +
		            "</div>"
		        },
		        open: function() {
		            SpreadsheetDialog.fn.open.call(this);
	
		            var options = this.options;
		            var text = options.text;
	
		            if (options.messageId) {
		                text = kendo.getter(options.messageId, true)(kendo.spreadsheet.messages.dialogs);
		            }
	
		            kendo.bind(this.dialog().element, {
		                text: text,
		                retry: this.retry.bind(this),
		                cancel: this.close.bind(this)
		            });
		        },
		        retry: function() {
		            this._retry = true;
		            this.close();
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("validationError", ValidationErrorDialog);
	
		    var FontFamilyDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.fontFamilyDialog || MESSAGES;
	
		            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));
	
		            this._list();
		        },
		        options: {
		            template: "<ul class='k-list k-reset'></ul>"
		        },
		        _list: function() {
		            var ul = this.dialog().element.find("ul");
		            var fonts = this.options.fonts;
		            var defaultFont = this.options.defaultFont;
	
		            this.list = new kendo.ui.StaticList(ul, {
		                dataSource: new kendo.data.DataSource({ data: fonts }),
		                template: "#: data #",
		                value: defaultFont,
		                change: this.apply.bind(this)
		            });
	
		            this.list.dataSource.fetch();
		        },
		        apply: function(e) {
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "PropertyChangeCommand",
		                options: {
		                    property: "fontFamily",
		                    value: e.sender.value()[0]
		                }
		            });
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("fontFamily", FontFamilyDialog);
	
		    var FontSizeDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.fontSizeDialog || MESSAGES;
	
		            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));
	
		            this._list();
		        },
		        options: {
		            template: "<ul class='k-list k-reset'></ul>"
		        },
		        _list: function() {
		            var ul = this.dialog().element.find("ul");
		            var sizes = this.options.sizes;
		            var defaultSize = this.options.defaultSize;
	
		            this.list = new kendo.ui.StaticList(ul, {
		                dataSource: new kendo.data.DataSource({ data: sizes }),
		                template: "#: data #",
		                value: defaultSize,
		                change: this.apply.bind(this)
		            });
	
		            this.list.dataSource.fetch();
		        },
		        apply: function(e) {
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "PropertyChangeCommand",
		                options: {
		                    property: "fontSize",
		                    value: kendo.parseInt(e.sender.value()[0])
		                }
		            });
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("fontSize", FontSizeDialog);
	
		    var BordersDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.bordersDialog || MESSAGES;
	
		            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));
	
		            this.element = this.dialog().element;
		            this._borderPalette();
	
		            this.viewModel = kendo.observable({
		                apply: this.apply.bind(this),
		                close: this.close.bind(this)
		            });
	
		            kendo.bind(this.element.find(".k-action-buttons"), this.viewModel);
		        },
		        options: {
		            width: 177,
		            template:   "<div></div>" +
		                        "<div class='k-action-buttons'>" +
		                            "<button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button>" +
		                            "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
		                        "</div>"
		        },
		        apply: function() {
		            SpreadsheetDialog.fn.apply.call(this);
	
		            var state = this.value();
	
		            this.trigger("action", {
		                command: "BorderChangeCommand",
		                options: {
		                    border: state.type,
		                    style: { size: 1, color: state.color }
		                }
		            });
		        },
		        _borderPalette: function() {
		            var element = this.dialog().element.find("div:first");
	
		            this.borderPalette = new kendo.spreadsheet.BorderPalette(element, {
		                change: this.value.bind(this)
		            });
		        },
		        value: function(state) {
		            if (state === undefined) {
		                return this._state;
		            } else {
		                this._state = state;
		            }
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("borders", BordersDialog);
	
		    var ColorChooser = SpreadsheetDialog.extend({
		        init: function(options) {
		            SpreadsheetDialog.fn.init.call(this, options);
	
		            this.element = this.dialog().element;
		            this.property = options.property;
		            this.options.title = options.title;
	
		            this.viewModel = kendo.observable({
		                apply: this.apply.bind(this),
		                close: this.close.bind(this)
		            });
	
		            kendo.bind(this.element.find(".k-action-buttons"), this.viewModel);
		        },
		        options: {
		            template:   "<div></div>" +
		                        "<div class='k-action-buttons'>" +
		                            "<button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button>" +
		                            "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
		                        "</div>"
		        },
		        apply: function() {
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "PropertyChangeCommand",
		                options: {
		                    property: this.property,
		                    value: this.value()
		                }
		            });
		        },
		        value: function(e) {
		            if (e === undefined) {
		                return this._value;
		            } else {
		                this._value = e.value;
		            }
		        }
		    });
	
		    var ColorPickerDialog = ColorChooser.extend({
		        init: function(options) {
		            options.width = 177;
		            ColorChooser.fn.init.call(this, options);
		            this._colorPalette();
		        },
		        _colorPalette: function() {
		            var element = this.dialog().element.find("div:first");
		            this.colorPalette = element.kendoColorPalette({
		                palette: [ //metro palette
		                    "#ffffff", "#000000", "#d6ecff", "#4e5b6f", "#7fd13b", "#ea157a", "#feb80a", "#00addc", "#738ac8", "#1ab39f",
		                    "#f2f2f2", "#7f7f7f", "#a7d6ff", "#d9dde4", "#e5f5d7", "#fad0e4", "#fef0cd", "#c5f2ff", "#e2e7f4", "#c9f7f1",
		                    "#d8d8d8", "#595959", "#60b5ff", "#b3bcca", "#cbecb0", "#f6a1c9", "#fee29c", "#8be6ff", "#c7d0e9", "#94efe3",
		                    "#bfbfbf", "#3f3f3f", "#007dea", "#8d9baf", "#b2e389", "#f272af", "#fed46b", "#51d9ff", "#aab8de", "#5fe7d5",
		                    "#a5a5a5", "#262626", "#003e75", "#3a4453", "#5ea226", "#af0f5b", "#c58c00", "#0081a5", "#425ea9", "#138677",
		                    "#7f7f7f", "#0c0c0c", "#00192e", "#272d37", "#3f6c19", "#750a3d", "#835d00", "#00566e", "#2c3f71", "#0c594f"
		                ],
		                change: this.value.bind(this)
		            }).data("kendoColorPalette");
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("colorPicker", ColorPickerDialog);
	
		    var CustomColorDialog = ColorChooser.extend({
		        init: function(options) {
		            options.width = 268;
		            ColorChooser.fn.init.call(this, options);
		            this.dialog().setOptions({ animation: false });
		            this.dialog().one("activate", this._colorPicker.bind(this));
		        },
		        _colorPicker: function() {
		            var element = this.dialog().element.find("div:first");
		            this.colorPicker = element.kendoFlatColorPicker({
		                change: this.value.bind(this)
		            }).data("kendoFlatColorPicker");
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("customColor", CustomColorDialog);
	
		    var AlignmentDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.alignmentDialog || MESSAGES;
		            var defaultOptions = {
		                title: messages.title,
		                buttons: [
		                    { property: "textAlign",     value: "left",    iconClass: "align-left",   text: messages.buttons.justtifyLeft },
		                    { property: "textAlign",     value: "center",  iconClass: "align-center", text: messages.buttons.justifyCenter },
		                    { property: "textAlign",     value: "right",   iconClass: "align-right",  text: messages.buttons.justifyRight },
		                    { property: "textAlign",     value: "justify", iconClass: "align-justify",   text: messages.buttons.justifyFull },
		                    { property: "verticalAlign", value: "top",     iconClass: "align-top",      text: messages.buttons.alignTop },
		                    { property: "verticalAlign", value: "center",  iconClass: "align-middle",   text: messages.buttons.alignMiddle },
		                    { property: "verticalAlign", value: "bottom",  iconClass: "align-bottom",   text: messages.buttons.alignBottom }
		                ]
		            };
	
		            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
	
		            this._list();
		        },
		        options: {
		            template: "<ul class='k-list k-reset'></ul>"
		        },
		        _list: function() {
		            var ul = this.dialog().element.find("ul");
	
		            this.list = new kendo.ui.StaticList(ul, {
		                dataSource: new kendo.data.DataSource({ data: this.options.buttons }),
		                template: "<a title='#=text#' data-property='#=property#' data-value='#=value#'>" +
		                                "<span class='k-icon k-i-#=iconClass#'></span>" +
		                                "#=text#" +
		                           "</a>",
		                change: this.apply.bind(this)
		            });
	
		            this.list.dataSource.fetch();
		        },
		        apply: function(e) {
		            var dataItem = e.sender.value()[0];
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "PropertyChangeCommand",
		                options: {
		                    property: dataItem.property,
		                    value: dataItem.value
		                }
		            });
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("alignment", AlignmentDialog);
	
		    var MergeDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.mergeDialog || MESSAGES;
		            var defaultOptions = {
		                title: messages.title,
		                buttons: [
		                    { value: "cells",        iconClass: "cells-merge",        text: messages.buttons.mergeCells },
		                    { value: "horizontally", iconClass: "cells-merge-horizontally", text: messages.buttons.mergeHorizontally },
		                    { value: "vertically",   iconClass: "cells-merge-vertically",   text: messages.buttons.mergeVertically },
		                    { value: "unmerge",      iconClass: "table-unmerge",      text: messages.buttons.unmerge }
		                ]
		            };
	
		            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
	
		            this._list();
		        },
		        options: {
		            template: "<ul class='k-list k-reset'></ul>"
		        },
		        _list: function() {
		            var ul = this.dialog().element.find("ul");
	
		            this.list = new kendo.ui.StaticList(ul, {
		                dataSource: new kendo.data.DataSource({ data: this.options.buttons }),
		                template: "<a title='#=text#' data-value='#=value#'>" +
		                            "<span class='k-icon k-icon k-i-#=iconClass#'></span>#=text#" +
		                          "</a>",
		                change: this.apply.bind(this)
		            });
	
		            this.list.dataSource.fetch();
		        },
		        apply: function(e) {
		            var dataItem = e.sender.value()[0];
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "MergeCellCommand",
		                options: {
		                    value: dataItem.value
		                }
		            });
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("merge", MergeDialog);
	
		    var FreezeDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.freezeDialog || MESSAGES;
		            var defaultOptions = {
		                title: messages.title,
		                buttons: [
		                    { value: "panes",    iconClass: "pane-freeze",  text: messages.buttons.freezePanes },
		                    { value: "rows",     iconClass: "row-freeze",    text: messages.buttons.freezeRows },
		                    { value: "columns",  iconClass: "column-freeze",    text: messages.buttons.freezeColumns },
		                    { value: "unfreeze", iconClass: "table-unmerge", text: messages.buttons.unfreeze }
		                ]
		            };
	
		            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
	
		            this._list();
		        },
		        options: {
		            template: "<ul class='k-list k-reset'></ul>"
		        },
		        _list: function() {
		            var ul = this.dialog().element.find("ul");
	
		            this.list = new kendo.ui.StaticList(ul, {
		                dataSource: new kendo.data.DataSource({ data: this.options.buttons }),
		                template: "<a title='#=text#' data-value='#=value#'>" +
		                            "<span class='k-icon k-icon k-i-#=iconClass#'></span>#=text#" +
		                          "</a>",
		                change: this.apply.bind(this)
		            });
	
		            this.list.dataSource.fetch();
		        },
		        apply: function(e) {
		            var dataItem = e.sender.value()[0];
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "FreezePanesCommand",
		                options: {
		                    value: dataItem.value
		                }
		            });
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("freeze", FreezeDialog);
	
		    var ValidationViewModel = kendo.spreadsheet.ValidationCellsViewModel = ObservableObject.extend({
		        init: function(options) {
		            ObservableObject.fn.init.call(this, options);
	
		            this.bind("change", (function(e) {
	
		                if (e.field === "criterion") {
		                    this.reset();
	
		                    if (this.criterion === "custom" || this.criterion === "list") {
		                        this.setHintMessageTemplate();
		                    }
		                }
	
		                if (e.field === "comparer") {
		                    this.setHintMessageTemplate();
		                }
	
		                if ((e.field == "hintMessage" || e.field == "hintTitle") && !this._mute) {
		                    this.shouldBuild = false;
		                }
	
		                if ((e.field == "from" || e.field == "to" || e.field == "hintMessageTemplate" || e.field == "type") && this.shouldBuild) {
		                    this.buildMessages();
		                }
		            }).bind(this));
	
		            this.reset();
		        },
		        buildMessages: function() {
		            this._mute = true;
		            this.set("hintTitle", this.hintTitleTemplate ? kendo.format(this.hintTitleTemplate, this.type) : "");
		            this.set("hintMessage", this.hintMessageTemplate ? kendo.format(this.hintMessageTemplate, this.from, this.to) : "");
		            this._mute = false;
		        },
		        reset: function() {
		            this.setComparers();
		            this.set("comparer", this.comparers[0].type);
		            this.set("from", null);
		            this.set("to", null);
	
		            this.set("useCustomMessages", false);
	
		            this.shouldBuild = true;
	
		            this.hintTitleTemplate = this.defaultHintTitle;
		            this.buildMessages();
		        },
		        //TODO: refactor
		        setComparers: function() {
		            var all = this.defaultComparers;
		            var comparers = [];
	
		            if (this.criterion === "text") {
		                var text_comparers = ["equalTo", "notEqualTo"];
		                for (var idx = 0; idx < all.length; idx++) {
		                    if (text_comparers[0] == all[idx].type) {
		                        comparers.push(all[idx]);
		                        text_comparers.shift();
		                    }
		                }
		            } else {
		                comparers = all.slice();
		            }
	
		            this.set("comparers", comparers);
		        },
		        setHintMessageTemplate: function() {
		           if (this.criterion !== "custom" && this.criterion !== "list") {
		               this.set("hintMessageTemplate", kendo.format(this.defaultHintMessage, this.criterion, this.comparerMessages[this.comparer]));
		           } else {
		               this.set("hintMessageTemplate", "");
		               this.set("hintMessage", "");
		           }
		        },
		        isAny: function() {
		            return this.get("criterion") === "any";
		        },
		        isNumber: function() {
		            return this.get("criterion") === "number";
		        },
		        showToForNumber: function() {
		            return this.showTo() && this.isNumber();
		        },
		        showToForDate: function() {
		            return this.showTo() && this.isDate();
		        },
		        isText: function() {
		            return this.get("criterion") === "text";
		        },
		        isDate: function() {
		            return this.get("criterion") === "date";
		        },
		        isList: function() {
		            return this.get("criterion") === "list";
		        },
		        isCustom: function() {
		            return this.get("criterion") === "custom";
		        },
		        showRemove: function() {
		            return this.get("hasValidation");
		        },
		        showTo: function() {
		            return this.get("comparer") == "between" || this.get("comparer") == "notBetween";
		        },
		        update: function(validation) {
		            this.set("hasValidation", !!validation);
	
		            if (validation) {
		                this.fromValidationObject(validation);
		            }
		        },
		        fromValidationObject: function(validation) {
		            this.set("criterion", validation.dataType);
		            this.set("comparer", validation.comparerType);
		            this.set("from", validation.from);
		            this.set("to", validation.to);
		            this.set("type", validation.type);
		            this.set("ignoreBlank", validation.allowNulls);
		            this.set("showButton", validation.showButton);
	
		            if (validation.messageTemplate || validation.titleTemplate) {
		                this.hintMessageTemplate = validation.messageTemplate;
		                this.hintMessage = validation.messageTemplate;
		                this.hintTitleTemplate = validation.titleTemplate;
		                this.hintTitle = validation.titleTemplate;
		                this.useCustomMessages = true;
		                this.buildMessages();
		            } else {
		                this.useCustomMessages = false;
		            }
		        },
		        toValidationObject: function() {
		            if (this.criterion === "any") {
		                return null;
		            }
	
		            var options = {
		                type: this.type,
		                dataType: this.criterion,
		                comparerType: this.comparer,
		                from: this.from,
		                to: this.to,
		                allowNulls: this.ignoreBlank,
		                showButton: this.showButton
		            };
	
		            if (this.useCustomMessages) {
		                options.messageTemplate = this.shouldBuild ? this.hintMessageTemplate : this.hintMessage;
		                options.titleTemplate = this.hintTitle;
		            }
	
		            return options;
		        }
		    });
	
		    var ValidationDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.validationDialog || MESSAGES;
		            var defaultOptions = {
		                title: messages.title,
		                hintMessage: messages.hintMessage,
		                hintTitle: messages.hintTitle,
		                criteria: [
		                    { type: "any", name: messages.criteria.any },
		                    { type: "number", name: messages.criteria.number },
		                    { type: "text", name: messages.criteria.text },
		                    { type: "date", name: messages.criteria.date },
		                    { type: "custom", name: messages.criteria.custom },
		                    { type: "list", name: messages.criteria.list }
		                ],
		                comparers: [
		                    { type: "greaterThan", name: messages.comparers.greaterThan },
		                    { type: "lessThan",    name: messages.comparers.lessThan },
		                    { type: "between",     name: messages.comparers.between },
		                    { type: "notBetween",  name: messages.comparers.notBetween },
		                    { type: "equalTo",     name: messages.comparers.equalTo },
		                    { type: "notEqualTo",  name: messages.comparers.notEqualTo },
		                    { type: "greaterThanOrEqualTo", name: messages.comparers.greaterThanOrEqualTo },
		                    { type: "lessThanOrEqualTo",    name: messages.comparers.lessThanOrEqualTo }
		                ],
		                comparerMessages: messages.comparerMessages
		            };
	
		            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
		        },
		        options: {
		            width: 450,
		            criterion: "any",
		            type: "reject",
		            ignoreBlank: true,
		            showButton: true,
		            useCustomMessages: false,
		            errorTemplate:
		                '<div class="k-widget k-tooltip k-tooltip-validation" style="margin:0.5em"><span class="k-icon k-i-warning"> </span>' +
		                '#= message #<div class="k-callout k-callout-n"></div></div>',
		            template:
		                '<div class="k-edit-form-container">' +
		                    '<div class="k-edit-label"><label>#: messages.validationDialog.labels.criteria #:</label></div>' +
		                    '<div class="k-edit-field">' +
		                        '<select data-role="dropdownlist" ' +
		                            'title="#: messages.validationDialog.labels.criteria #"' +
		                            'data-text-field="name" ' +
		                            'data-value-field="type" ' +
		                            'data-bind="value: criterion, source: criteria" />' +
		                    '</div>' +
	
		                    '<div data-bind="visible: isNumber">' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<select data-role="dropdownlist" ' +
		                                'title="#: messages.validationDialog.labels.comparer #"' +
		                                'data-text-field="name" ' +
		                                'data-value-field="type" ' +
		                                'data-bind="value: comparer, source: comparers" />' +
		                        '</div>' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.min #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<input name="#: messages.validationDialog.labels.min #" title="#: messages.validationDialog.labels.min #" placeholder="e.g. 10" class="k-textbox" data-bind="value: from, enabled: isNumber" required="required" />' +
		                        '</div>' +
		                        '<div data-bind="visible: showTo">' +
		                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.max #:</label></div>' +
		                            '<div class="k-edit-field">' +
		                                '<input name="#: messages.validationDialog.labels.max #" title="#: messages.validationDialog.labels.max #" placeholder="e.g. 100" class="k-textbox" data-bind="value: to, enabled: showToForNumber" required="required" />' +
		                            '</div>' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div data-bind="visible: isText">' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<select data-role="dropdownlist" ' +
		                                'title="#: messages.validationDialog.labels.comparer #"' +
		                                'data-text-field="name" ' +
		                                'data-value-field="type" ' +
		                                'data-bind="value: comparer, source: comparers" />' +
		                        '</div>' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isText" required="required" />' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div data-bind="visible: isDate">' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<select data-role="dropdownlist" ' +
		                                'title="#: messages.validationDialog.labels.comparer #"' +
		                                'data-text-field="name" ' +
		                                'data-value-field="type" ' +
		                                'data-bind="value: comparer, source: comparers" />' +
		                        '</div>' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.start #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<input name="#: messages.validationDialog.labels.start #" title="#: messages.validationDialog.labels.start #" class="k-textbox" data-bind="value: from, enabled: isDate" required="required" />' +
		                        '</div>' +
		                        '<div data-bind="visible: showTo">' +
		                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.end #:</label></div>' +
		                            '<div class="k-edit-field">' +
		                                '<input name="#: messages.validationDialog.labels.end #" title="#: messages.validationDialog.labels.end #" class="k-textbox" data-bind="value: to, enabled: showToForDate" required="required" />' +
		                            '</div>' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div data-bind="visible: isCustom">' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isCustom" required="required" />' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div data-bind="visible: isList">' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isList" required="required" />' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div data-bind="visible: isList">' +
		                        '<div class="k-edit-field">' +
		                            '<input type="checkbox" name="showButton" id="listShowButton" class="k-checkbox" data-bind="checked: showButton"/>' +
		                            '<label for="listShowButton" class="k-checkbox-label">' +
		                                ' #: messages.validationDialog.labels.showListButton #' +
		                            '</label>' +
		                        '</div>' +
		                    "</div>" +
	
		                    '<div data-bind="visible: isDate">' +
		                        '<div class="k-edit-field">' +
		                            '<input type="checkbox" name="showButton" id="dateShowButton" class="k-checkbox" data-bind="checked: showButton"/>' +
		                            '<label for="dateShowButton" class="k-checkbox-label">' +
		                                ' #: messages.validationDialog.labels.showCalendarButton #' +
		                            '</label>' +
		                        '</div>' +
		                    "</div>" +
	
		                    '<div data-bind="invisible: isAny">' +
		                        '<div class="k-edit-field">' +
		                            '<input type="checkbox" title="#: messages.validationDialog.labels.ignoreBlank #" name="ignoreBlank" id="ignoreBlank" class="k-checkbox" data-bind="checked: ignoreBlank"/>' +
		                            '<label for="ignoreBlank" class="k-checkbox-label">' +
		                                ' #: messages.validationDialog.labels.ignoreBlank #' +
		                            '</label>' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div data-bind="invisible: isAny">' +
		                        '<div class="k-hr"></div>' +
		                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.onInvalidData #:</label></div>' +
		                        '<div class="k-edit-field">' +
		                            '<input type="radio" title="#: messages.validationDialog.labels.rejectInput #" id="validationTypeReject" name="validationType" value="reject" data-bind="checked: type" class="k-radio" />' +
		                            '<label for="validationTypeReject" class="k-radio-label">' +
		                                 "#: messages.validationDialog.labels.rejectInput #" +
		                            '</label> ' +
		                            '<input type="radio" title="#: messages.validationDialog.labels.showWarning #" id="validationTypeWarning"  name="validationType" value="warning" data-bind="checked: type" class="k-radio" />' +
		                            '<label for="validationTypeWarning" class="k-radio-label">' +
		                                 "#: messages.validationDialog.labels.showWarning #" +
		                            '</label>' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div data-bind="invisible: isAny" class="hint-wrapper">' +
		                        '<div class="k-edit-field">' +
		                            '<input type="checkbox" title="#: messages.validationDialog.labels.showHint #" name="useCustomMessages" id="useCustomMessages" class="k-checkbox" data-bind="checked: useCustomMessages" />' +
		                            '<label class="k-checkbox-label" for="useCustomMessages">'+
		                                ' #: messages.validationDialog.labels.showHint #' +
		                            '</label>' +
		                        '</div>' +
		                        '<div data-bind="visible: useCustomMessages">' +
		                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.hintTitle #:</label></div>' +
		                            '<div class="k-edit-field">' +
		                                '<input class="k-textbox" title="#: messages.validationDialog.labels.hintTitle #" placeholder="#: messages.validationDialog.placeholders.typeTitle #" data-bind="value: hintTitle" />' +
		                            '</div>' +
		                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.hintMessage #:</label></div>' +
		                            '<div class="k-edit-field">' +
		                                '<input class="k-textbox" title="#: messages.validationDialog.labels.hintMessage #" placeholder="#: messages.validationDialog.placeholders.typeMessage #" data-bind="value: hintMessage" />' +
		                            '</div>' +
		                        '</div>' +
		                    '</div>' +
	
		                    '<div class="k-action-buttons">' +
		                        '<button class="k-button" data-bind="visible: showRemove, click: remove">#: messages.remove #</button>' +
		                        '<button class="k-button k-primary" data-bind="click: apply">#: messages.apply #</button>' +
		                        '<button class="k-button" data-bind="click: close">#: messages.cancel #</button>' +
		                    "</div>" +
		                "</div>"
		        },
		        open: function(range) {
		            var options = this.options;
		            var element;
	
		            this.viewModel = new ValidationViewModel({
		                type: options.type,
		                defaultHintMessage: options.hintMessage,
		                defaultHintTitle: options.hintTitle,
		                defaultComparers: options.comparers.slice(0),
		                comparerMessages: options.comparerMessages,
		                criteria: options.criteria.slice(0),
		                criterion: options.criterion,
		                ignoreBlank: options.ignoreBlank,
		                showButton: options.showButton,
		                apply: this.apply.bind(this),
		                close: this.close.bind(this),
		                remove: this.remove.bind(this)
		            });
	
		            this.viewModel.update(range.validation());
	
		            SpreadsheetDialog.fn.open.call(this);
	
		            element = this.dialog().element;
	
		            if (this.validatable) {
		                this.validatable.destroy();
		            }
	
		            kendo.bind(element, this.viewModel);
	
		            this.validatable = new kendo.ui.Validator(element.find(".k-edit-form-container"), {
		                validateOnBlur: false,
		                errorTemplate: this.options.errorTemplate || undefined
		            });
		        },
		        apply: function() {
	
		            if (this.validatable.validate()) {
		                SpreadsheetDialog.fn.apply.call(this);
	
		                this.trigger("action", {
		                    command: "EditValidationCommand",
		                    options: {
		                        value: this.viewModel.toValidationObject()
		                    }
		                });
		            }
		        },
		        remove: function() {
		            this.viewModel.set("criterion", "any");
		            this.apply();
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("validation", ValidationDialog);
		    kendo.spreadsheet.dialogs.ValidationDialog = ValidationDialog;
	
		    var ExportAsDialog = SpreadsheetDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.exportAsDialog || MESSAGES;
	
		            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));
	
		            this.viewModel = kendo.observable({
		                title: this.options.title,
		                name: this.options.name,
		                extension: this.options.extension,
		                fileFormats:this.options.fileFormats,
		                excel: options.excelExport,
		                pdf: {
		                    proxyURL: options.pdfExport.proxyURL,
		                    forceProxy: options.pdfExport.forceProxy,
		                    title: options.pdfExport.title,
		                    author: options.pdfExport.author,
		                    subject: options.pdfExport.subject,
		                    keywords: options.pdfExport.keywords,
		                    creator: options.pdfExport.creator,
		                    date: options.pdfExport.date,
	
		                    fitWidth: this.options.pdf.fitWidth,
		                    area: this.options.pdf.area,
		                    areas: this.options.pdf.areas,
		                    paperSize: this.options.pdf.paperSize,
		                    paperSizes: this.options.pdf.paperSizes,
		                    margin: this.options.pdf.margin,
		                    margins: this.options.pdf.margins,
		                    landscape: this.options.pdf.landscape,
		                    guidelines: this.options.pdf.guidelines,
		                    hCenter: this.options.pdf.hCenter,
		                    vCenter: this.options.pdf.vCenter
		                },
		                apply: this.apply.bind(this),
		                close: this.close.bind(this)
		            });
	
		            var dialog = this.dialog();
		            this.viewModel.bind("change", function(e) {
		                if (e.field === "extension") {
		                    this.set("showPdfOptions", this.extension === ".pdf" ? true : false);
		                    dialog.center();
		                }
		            });
	
		            kendo.bind(dialog.element, this.viewModel);
		        },
		        options: {
		            name: "Workbook",
		            extension: ".xlsx",
		            fileFormats: [{
		                description: "Excel Workbook (.xlsx)",
		                extension: ".xlsx"
		            }, {
		                description: "Portable Document Format(.pdf)",
		                extension: ".pdf"
		            }],
		            pdf: {
		                fitWidth: true,
		                area: "workbook",
		                areas: [{
		                    area: "workbook",
		                    text: "Entire Workbook"
		                },{
		                    area: "sheet",
		                    text: "Active Sheet"
		                },{
		                    area: "selection",
		                    text: "Selection"
		                }],
		                paperSize: "a4",
		                paperSizes: [
		                    {value: "a2"       , text: 'A2 (420 mm × 594 mm)     '},
		                    {value: "a3"       , text: 'A3 (297 mm x 420 mm)     '},
		                    {value: "a4"       , text: 'A4 (210 mm x 297 mm)     '},
		                    {value: "a5"       , text: 'A5 (148 mm x 210 mm)     '},
		                    {value: "b3"       , text: 'B3 (353 mm × 500 mm)     '},
		                    {value: "b4"       , text: 'B4 (250 mm x 353 mm)     '},
		                    {value: "b5"       , text: 'B5 (176 mm x 250 mm)     '},
		                    {value: "folio"    , text: 'Folio (8.5" x 13")       '},
		                    {value: "legal"    , text: 'Legal (8.5" x 14")       '},
		                    {value: "letter"   , text: 'Letter (8.5" x 11")      '},
		                    {value: "tabloid"  , text: 'Tabloid (11" x 17")      '},
		                    {value: "executive", text: 'Executive (7.25" x 10.5")'}
		                ],
		                margin: {bottom: "0.75in", left: "0.7in", right: "0.7in", top: "0.75in"},
		                margins: [
		                    {value: {bottom: "0.75in", left: "0.7in", right: "0.7in", top: "0.75in"}, text: "Normal"},
		                    {value: {bottom: "0.75in", left: "0.25in", right: "0.25in", top: "0.75in"}, text: "Narrow"},
		                    {value: {bottom: "1in", left: "1in", right: "1in", top: "1in"}, text: "Wide"}
		                ],
		                landscape: true,
		                guidelines: true,
		                hCenter: true,
		                vCenter: true
		            },
		            width: 520,
		            template:
		                "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.fileName #:</label></div>" +
		                "<div class='k-edit-field'>" +
		                    "<input class='k-textbox' data-bind='value: name' />" +
		                "</div>" +
		                "<div >" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.saveAsType #:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                    "<select data-role='dropdownlist' class='k-file-format' " +
		                        "data-text-field='description' " +
		                        "data-value-field='extension' " +
		                        "data-bind='value: extension, source: fileFormats' />" +
		                    "</div>" +
		                "</div>" +
		                "<div class='k-export-config' data-bind='visible: showPdfOptions'>" +
		                    "<hr class='k-hr' />" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.exportArea #:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<select data-role='dropdownlist' class='k-file-format' " +
		                            "data-text-field='text' " +
		                            "data-value-field='area' " +
		                            "data-bind='value: pdf.area, source: pdf.areas' />" +
		                    "</div>" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.paperSize#:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<select data-role='dropdownlist' class='k-file-format' " +
		                            "data-text-field='text' " +
		                            "data-value-field='value' " +
		                            "data-bind='value: pdf.paperSize, source: pdf.paperSizes' />" +
		                    "</div>" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.margins #:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<select data-role='dropdownlist' class='k-file-format' " +
		                            "data-value-primitive='true'" +
		                            "data-text-field='text' " +
		                            "data-value-field='value' " +
		                            "data-bind='value: pdf.margin, source: pdf.margins' />" +
		                    "</div>" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.orientation #:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<div class='k-button-group'>" +
		                            "<input type='radio' id='k-orientation-portrait' name='orientation' data-type='boolean' data-bind='checked: pdf.landscape' value='false' />" +
		                            "<label class='k-button k-button-icon k-group-start k-orientation-button' for='k-orientation-portrait'><span class='k-icon k-i-page-portrait'></span></label>" +
		                            "<input type='radio' id='k-orientation-landscape' name='orientation' data-type='boolean' data-bind='checked: pdf.landscape' value='true' />" +
		                            "<label class='k-button k-button-icon k-group-end k-orientation-button' for='k-orientation-landscape'><span class='k-icon k-i-page-landscape'></span></label>" +
		                        "</div>" +
		                    "</div>" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.print #:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<input class='k-checkbox' id='guidelines' type='checkbox' data-bind='checked: pdf.guidelines'/><label class='k-checkbox-label' for='guidelines'>#: messages.exportAsDialog.labels.guidelines#</label>" +
		                    "</div>" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.scale #:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<input class='k-checkbox' id='fitWidth' type='checkbox' data-bind='checked: pdf.fitWidth'/><label class='k-checkbox-label' for='fitWidth'>#: messages.exportAsDialog.labels.fit #</label>" +
		                    "</div>" +
		                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.center #:</label></div>" +
		                    "<div class='k-edit-field'>" +
		                        "<input class='k-checkbox' id='hCenter' type='checkbox' data-bind='checked: pdf.hCenter'/><label class='k-checkbox-label' for='hCenter'>#: messages.exportAsDialog.labels.horizontally #</label>" +
		                        "<input class='k-checkbox' id='vCenter' type='checkbox' data-bind='checked: pdf.vCenter'/><label class='k-checkbox-label' for='vCenter'>#: messages.exportAsDialog.labels.vertically #</label>" +
		                    "</div>" +
		                    "<div class='k-page-orientation'>" +
		                        "<span class='k-icon k-i-page-portrait' data-bind='invisible: pdf.landscape'></span>" +
		                        "<span class='k-icon k-i-page-landscape' data-bind='visible: pdf.landscape'></span>" +
		                    "</div>" +
		                "</div>" +
		                "<div class='k-action-buttons'>" +
		                    "<button class='k-button k-primary' data-bind='click: apply'>#: messages.save #</button>" +
		                    "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
		                "</div>"
		        },
		        apply: function() {
		            SpreadsheetDialog.fn.apply.call(this);
	
		            this.trigger("action", {
		                command: "SaveAsCommand",
		                options: this.viewModel
		            });
		        }
		    });
		    kendo.spreadsheet.dialogs.register("exportAs", ExportAsDialog);
	
		    function basicErrorDialog(id, msg) {
		        kendo.spreadsheet.dialogs.register(
		            id,
		            MessageDialog.extend({
		                options: { messageId: msg }
		            })
		        );
		    }
	
		    basicErrorDialog("modifyMerged", "modifyMergedDialog.errorMessage");
		    basicErrorDialog("rangeDisabled", "rangeDisabledDialog.errorMessage");
		    basicErrorDialog("intersectsArray", "intersectsArrayDialog.errorMessage");
		    basicErrorDialog("overflow", "overflowDialog.errorMessage");
		    basicErrorDialog("unsupportedSelection", "unsupportedSelectionDialog.errorMessage");
		    basicErrorDialog("incompatibleRanges", "incompatibleRangesDialog.errorMessage");
		    basicErrorDialog("noFillDirection", "noFillDirectionDialog.errorMessage");
		    basicErrorDialog("duplicateSheetName", "duplicateSheetNameDialog.errorMessage");
	
		    var ImportErrorDialog = MessageDialog.extend({
		        options: {
		            width: 640,
		            title: "Errors in import",
		            template:
		                "<div class='k-spreadsheet-message-content k-spreadsheet-import-errors'>" +
		                  "<div class='k--header-message'>We encountered #= errors.length # errors while reading this file.  Please be aware that some formulas might be missing, or contain invalid results.</div>" +
		                  "<div class='k--errors'>" +
		                    "<table>" +
		                      "<thead>" +
		                        "<tr><th>Context</th><th>Error message</th></tr>" +
		                      "</thead>" +
		                      "# for (var i = 0; i < errors.length; ++i) { #" +
		                        "# var err = errors[i]; #" +
		                        "<tr><td>#: err.context #</td><td>#: err.error #</td></tr>" +
		                      "# } #" +
		                    "</table>" +
		                  "</div>" +
		                "</div>" +
		                "<div class='k-action-buttons'>" +
		                  "<button class='k-button k-primary' data-bind='click: close'>" +
		                    "#: messages.okText #" +
		                  "</button>" +
		                "</div>"
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("importError", ImportErrorDialog);
	
		    var UseKeyboardDialog = MessageDialog.extend({
		        init: function(options) {
		            var messages = kendo.spreadsheet.messages.dialogs.useKeyboardDialog || MESSAGES;
	
		            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));
		        },
		        options: {
		            template:
		                "#: messages.useKeyboardDialog.errorMessage #" +
		                "<div>Ctrl+C #: messages.useKeyboardDialog.labels.forCopy #</div>" +
		                "<div>Ctrl+X #: messages.useKeyboardDialog.labels.forCut #</div>" +
		                "<div>Ctrl+V #: messages.useKeyboardDialog.labels.forPaste #</div>" +
		                '<div class="k-action-buttons">' +
		                    "<button class='k-button k-primary' data-bind='click: close'>" +
		                        "#= messages.okText #" +
		                    "</button>" +
		                "</div>"
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("useKeyboard", UseKeyboardDialog);
	
		    var HyperlinkDialog = SpreadsheetDialog.extend({
		        options: {
		            template:
		            ("<div class='k-edit-label'><label>#: messages.linkDialog.labels.url #:</label></div>" +
		             "<div class='k-edit-field'><input class='k-textbox' data-bind='value: url' title='#: messages.linkDialog.labels.url #' /></div>" +
		             "<div class='k-action-buttons'>" + (
		                 ("<button class='k-button k-left' data-bind='click: remove'>#= messages.linkDialog.labels.removeLink #</button>" +
		                  "<button class='k-button k-primary' data-bind='click: apply'>#= messages.okText #</button>" +
		                  "<button class='k-button' data-bind='click: cancel'>#= messages.cancel #</button>")
		             ) + "</div>"
		            ),
		            title: MESSAGES.linkDialog.title,
		            autoFocus: false
		        },
		        open: function(range) {
		            var self = this;
		            SpreadsheetDialog.fn.open.apply(self, arguments);
		            var element = self.dialog().element;
		            var model = kendo.observable({
		                url: range.link(),
		                apply: function() {
		                    if (!/\S/.test(model.url)) {
		                        model.url = null;
		                    }
		                    self.trigger("action", {
		                        command: "HyperlinkCommand",
		                        options: {
		                            link: model.url
		                        }
		                    });
		                    self.close();
		                },
		                remove: function() {
		                    model.url = null;
		                    model.apply();
		                },
		                cancel: self.close.bind(self)
		            });
		            kendo.bind(element, model);
	
		            // it would be nice if we could easily handle that in one
		            // place for all dialogs, but it doesn't seem easily
		            // doable.
		            element.find("input")
		                .focus()
		                .on("keydown", function(ev){
		                    if (ev.keyCode == 13 /*ENTER*/) {
		                        model.url = $(this).val(); // there won't be a "change" event and the model wouldn't update :-\
		                        ev.stopPropagation();
		                        ev.preventDefault();
		                        model.apply();
		                    } else if (ev.keyCode == 27 /*ESC*/) {
		                        ev.stopPropagation();
		                        ev.preventDefault();
		                        model.cancel();
		                    }
		                });
		        }
		    });
	
		    kendo.spreadsheet.dialogs.register("hyperlink", HyperlinkDialog);
	
		})(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1500);
		module.exports = __webpack_require__(1500);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1465:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(714);
	
	/***/ }),
	
	/***/ 1500:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(5), __webpack_require__(1465) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var identity = function(o) { return o; };
	
		    var SheetDataSourceBinder = kendo.Class.extend({
		        init: function(options) {
	
		            this.options = kendo.jQuery.extend({}, this.options, options);
	
		            this.columns = this._normalizeColumns(this.options.columns);
	
		            this._sheet();
		            this._dataSource();
	
		            this._header();
	
		            this._boundRowsCount = 0;
	
		            this.dataSource.fetch();
		        },
	
		        _sheet: function() {
		            this.sheet = this.options.sheet;
	
		            this._sheetChangeHandler = this._sheetChange.bind(this);
		            this._sheetDeleteRowHandler = this._sheetDeleteRow.bind(this);
		            this._sheetInsertRowHandler = this._sheetInsertRow.bind(this);
	
		            this.sheet.bind("change", this._sheetChangeHandler)
		                .bind("afterDeleteRow", this._sheetDeleteRowHandler)
		                .bind("afterInsertRow", this._sheetInsertRowHandler);
		        },
	
		        _sheetInsertRow: function(e) {
		            if (e.index !== undefined) {
		                this.dataSource.insert(Math.max(e.index - 1, 0), {});
		            }
		        },
	
		        _sheetDeleteRow: function(e) {
		            if (e.index !== undefined) {
		                var dataSource = this.dataSource;
		                var model = dataSource.view()[e.index - 1];
	
		                if (model) {
		                    dataSource.remove(model);
		                }
		            }
		        },
	
		        _header: function() {
		            this.sheet.batch(function() {
		                this.columns.forEach(function(column, index) {
		                    this.sheet.range(0,index).value(column.title);
		                }.bind(this));
		            }.bind(this));
		        },
	
		        _sheetChange: function(e) {
		            if (e.insertRow || e.deleteRow) {
		                // these actions are handled via custom events
		                return;
		            }
	
		            if (e.recalc && e.ref) {
		                var dataSource = this.dataSource;
		                var data = dataSource.view();
		                var columns = this.columns;
		                var fields;
	
		                if (dataSource.reader.model) {
		                    fields = dataSource.reader.model.fields;
		                }
	
		                if (!columns.length && data.length) {
		                    columns = Object.keys(data[0].toJSON());
		                }
	
		                var getters = columns.map(function(column) {
		                    var field = column.field;
		                    if (field && fields && fields[field] && fields[field].type == "date") {
		                        return kendo.spreadsheet.numberToDate;
		                    }
		                    return identity;
		                });
	
		                this._skipRebind = true;
		                var normalizedRef = this.sheet._grid.normalize(e.ref);
		                var values = this.sheet.range(normalizedRef).values();
	
		                normalizedRef.forEach(function(ref) {
		                    ref = ref.toRangeRef();
		                    var record;
		                    var valueIndex = 0;
		                    for (var ri = ref.topLeft.row; ri <= ref.bottomRight.row; ri++) {
		                        record = data[ri - 1]; // skip header row
	
		                        if (!record) {
		                            record = dataSource.insert(ri - 1, {});
		                            data = dataSource.view();
		                        }
	
		                        var colValueIndex = 0;
		                        for (var ci = ref.topLeft.col; ci <= ref.bottomRight.col && ci < columns.length; ci++) {
		                            record.set(columns[ci].field, getters[ci](values[valueIndex][colValueIndex++]));
		                        }
		                        valueIndex++;
		                    }
		                });
	
		                this._boundRowsCount = dataSource.view().length;
	
		                this._skipRebind = false;
		            }
		        },
	
		        _normalizeColumns: function(columns) {
		            return columns.map(function(column) {
		                var field = column.field || column;
		                return {
		                    field: field,
		                    title: column.title || field
		                };
		            });
		        },
	
		        _dataSource: function() {
		            var options = this.options;
		            var dataSource = options.dataSource;
	
		            dataSource = Array.isArray(dataSource) ? { data: dataSource } : dataSource;
	
		            if (this.dataSource && this._changeHandler) {
		                this.dataSource.unbind("change", this._changeHandler);
		            } else {
		                this._changeHandler = this._change.bind(this);
		            }
	
		            this.dataSource = kendo.data.DataSource.create(dataSource)
		                .bind("change", this._changeHandler);
		        },
	
		        _change: function() {
		            if (this._skipRebind) {
		                return;
		            }
	
		            var data = this.dataSource.view();
		            var columns = this.columns;
	
		            if (!columns.length && data.length) {
		                this.columns = columns = this._normalizeColumns(Object.keys(data[0].toJSON()));
		                this._header();
		            }
	
		            var getters = columns.map(function(column) {
		                return kendo.getter(column.field);
		            });
	
		            this.sheet.batch(function() {
		                var length = Math.max(data.length, this._boundRowsCount);
	
		                for (var idx = 0; idx < length; idx++) {
		                    for (var getterIdx = 0; getterIdx < getters.length; getterIdx++) {
		                        var value = data[idx] ? getters[getterIdx](data[idx]) : null;
	
		                        //skip header row
		                        this.sheet.range(idx + 1, getterIdx).value(value);
		                    }
		                }
		            }.bind(this));
	
		            this._boundRowsCount = data.length;
		        },
	
		        destroy: function() {
		            this.dataSource.unbind("change", this._changeHandler);
	
		            this.sheet.unbind("change", this._sheetChangeHandler)
		                .unbind("deleteRow", this._sheetDeleteRowHandler)
		                .unbind("insertRow", this._sheetInsertRowHandler);
		        },
	
		        options: {
		            columns: []
		        }
		    });
	
		    kendo.spreadsheet.SheetDataSourceBinder = SheetDataSourceBinder;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1473);
		module.exports = __webpack_require__(1473);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 928:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 931:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(574);
	
	/***/ }),
	
	/***/ 1473:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19), __webpack_require__(928), __webpack_require__(931), __webpack_require__(1474), __webpack_require__(1475), __webpack_require__(1476) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    (function(kendo) {
		        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		            return;
		        }
	
		        var $ = kendo.jQuery;
		        var Widget = kendo.ui.Widget;
		        var classNames = {
		            details: "k-details",
		            button: "k-button",
		            detailsSummary: "k-details-summary",
		            detailsContent: "k-details-content",
		            icon: "k-icon",
		            iconCollapse: "k-i-arrow-45-down-right",
		            iconExpand: "k-i-arrow-60-right",
		            iconSearch: "k-i-zoom",
		            textbox: "k-textbox",
		            wrapper: "k-spreadsheet-filter-menu",
		            filterByCondition: "k-spreadsheet-condition-filter",
		            filterByValue: "k-spreadsheet-value-filter",
		            valuesTreeViewWrapper: "k-spreadsheet-value-treeview-wrapper",
		            actionButtons: "k-action-buttons"
		        };
	
		        var Details = Widget.extend({
		            init: function(element, options) {
		                Widget.fn.init.call(this, element, options);
	
		                this.element.addClass(FilterMenu.classNames.details);
	
		                this._summary = this.element.find("." + FilterMenu.classNames.detailsSummary)
		                    .on("click", this._toggle.bind(this));
	
		                var iconClass = options.expanded ? FilterMenu.classNames.iconCollapse : FilterMenu.classNames.iconExpand;
		                this._icon = $("<span />", { "class": FilterMenu.classNames.icon + " " + iconClass })
		                    .prependTo(this._summary);
	
		                this._container = kendo.wrap(this._summary.next(), true);
	
		                if (!options.expanded) {
		                    this._container.hide();
		                }
		            },
		            options: {
		                name: "Details"
		            },
		            events: [ "toggle" ],
		            visible: function() {
		                return this.options.expanded;
		            },
		            toggle: function(show) {
		                var animation = kendo.fx(this._container).expand("vertical");
	
		                animation.stop()[show ? "reverse" : "play"]();
	
		                this._icon.toggleClass(FilterMenu.classNames.iconExpand, show)
		                          .toggleClass(FilterMenu.classNames.iconCollapse, !show);
	
		                this.options.expanded = !show;
		            },
		            _toggle: function() {
		                var show = this.visible();
		                this.toggle(show);
		                this.trigger("toggle", { show: show });
		            }
		        });
	
		        var FILTERMENU_MESSAGES = kendo.spreadsheet.messages.filterMenu = {
		            sortAscending: "Sort range A to Z",
		            sortDescending: "Sort range Z to A",
		            filterByValue: "Filter by value",
		            filterByCondition: "Filter by condition",
		            apply: "Apply",
		            search: "Search",
		            addToCurrent: "Add to current selection",
		            clear: "Clear",
		            blanks: "(Blanks)",
		            operatorNone: "None",
		            and: "AND",
		            or: "OR",
		            operators: {
		                string: {
		                    contains: "Text contains",
		                    doesnotcontain: "Text does not contain",
		                    startswith: "Text starts with",
		                    endswith: "Text ends with",
		                    matches: "Text matches",
		                    doesnotmatch: "Text does not match"
		                },
		                date: {
		                    eq:  "Date is",
		                    neq: "Date is not",
		                    lt:  "Date is before",
		                    gt:  "Date is after"
		                },
		                number: {
		                    eq: "Is equal to",
		                    neq: "Is not equal to",
		                    gte: "Is greater than or equal to",
		                    gt: "Is greater than",
		                    lte: "Is less than or equal to",
		                    lt: "Is less than"
		                }
		            }
		        };
	
		        kendo.data.binders.spreadsheetFilterValue = kendo.data.Binder.extend({
		            init: function(element, bindings, options) {
		                kendo.data.Binder.fn.init.call(this, element, bindings, options);
	
		                this._change = $.proxy(this.change, this);
		                $(this.element).on("change", this._change);
		            },
		            refresh: function() {
		                var that = this,
		                    value = that.bindings.spreadsheetFilterValue.get(); //get the value from the View-Model
	
		                $(that.element).val(value instanceof Date ? "" : value);
		            },
		            change: function() {
		                var value = this.element.value;
		                this.bindings.spreadsheetFilterValue.set(value); //update the View-Model
		            }
		        });
	
		        kendo.data.binders.widget.spreadsheetFilterValue = kendo.data.Binder.extend({
		            init: function(widget, bindings, options) {
		                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
	
		                this.widget = widget;
		                this._change = $.proxy(this.change, this);
		                this.widget.first("change", this._change);
		            },
		            refresh: function() {
		                var binding = this.bindings.spreadsheetFilterValue,
		                    value = binding.get(),
		                    type = $(this.widget.element).data("filterType");
	
		                if ((type === "date" && value instanceof Date) || (type === "number" && !isNaN(value))) {
		                    this.widget.value(value);
		                } else {
		                    this.widget.value(null);
		                }
		            },
		            change: function() {
		                var value = this.widget.value(),
		                    binding = this.bindings.spreadsheetFilterValue;
	
		                binding.set(value);
		            }
		        });
	
		        var templates = {
		            filterByValue:
		                "<div class='" + classNames.detailsSummary + "'>#= messages.filterByValue #</div>" +
		                "<div class='" + classNames.detailsContent + "'>" +
		                    "<div class='k-textbox k-space-right'>" +
		                        "<input placeholder='#= messages.search #' data-#=ns#bind='events: { input: filterValues }' />" +
		                        "<span class='k-icon k-i-zoom' />" +
		                    "</div>" +
		                    "<div data-#=ns#bind='visible: hasActiveSearch'><input class='k-checkbox' type='checkbox' data-#=ns#bind='checked: appendToSearch' id='_#=guid#' /><label class='k-checkbox-label' for='_#=guid#'>#= messages.addToCurrent #</label></div>" +
		                    "<div class='" + classNames.valuesTreeViewWrapper + "'>" +
		                        "<div data-#=ns#role='treeview' " +
		                            "data-#=ns#checkboxes='{ checkChildren: true }' "+
		                            "data-#=ns#bind='source: valuesDataSource, events: { check: valuesChange, select: valueSelect }' "+
		                            "/>" +
		                    "</div>" +
		                "</div>",
		            filterByCondition:
		                "<div class='" + classNames.detailsSummary + "'>#= messages.filterByCondition #</div>" +
		                "<div class='" + classNames.detailsContent + "'>" +
		                    '<div>' +
		                        '<select ' +
		                            'data-#=ns#role="dropdownlist"' +
		                            'data-#=ns#bind="value: operator, source: operators, events: { change: operatorChange } "' +
		                            'data-value-primitive="false"' +
		                            'data-option-label="#=messages.operatorNone#"' +
		                            'data-height="auto"' +
		                            'data-text-field="text"' +
		                            'data-value-field="unique">'+
		                        '</select>'+
		                    '</div>' +
	
		                    '<div data-#=ns#bind="visible: isString">' +
		                        '<input data-filter-type="string" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" class="k-textbox" />'+
		                    '</div>' +
	
		                    '<div data-#=ns#bind="visible: isNumber">' +
		                        '<input data-filter-type="number" data-#=ns#role="numerictextbox" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" />'+
		                    '</div>' +
	
		                    '<div data-#=ns#bind="visible: isDate">' +
		                        '<input data-filter-type="date" data-#=ns#role="datepicker" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" />'+
		                    '</div>' +
		                "</div>",
		            menuItem:
		                "<li data-command='#=command#' data-dir='#=dir#'>" +
		                    "<span class='k-icon k-i-#=iconClass#'></span>#=text#" +
		                "</li>",
		            actionButtons:
		                "<button data-#=ns#bind='click: apply' class='k-button k-primary'>#=messages.apply#</button>" +
		                "<button data-#=ns#bind='click: clear' class='k-button'>#=messages.clear#</button>"
		        };
	
		        function distinctValues(values) {
		            var hash = {};
		            var result = [];
	
		            for (var i = 0; i < values.length; i++) {
		                if (!hash[values[i].value]) {
		                    hash[values[i].value] = values[i];
		                    result.push(values[i]);
		                } else if (!hash[values[i].value].checked && values[i].checked) {
		                    hash[values[i].value].checked = true;
		                }
		            }
	
		            return result;
		        }
	
		        function filter(dataSource, query) {
		            var hasVisibleChildren = false;
		            var data = dataSource instanceof kendo.data.HierarchicalDataSource && dataSource.data();
		            var valuesFilter = this;
		            var values = this.values;
		            for (var i = 0; i < data.length; i++) {
		                var item = data[i];
		                var text = item.text.toString().toLowerCase();
		                var itemVisible = query === true || query === "" || text.indexOf(query) >= 0;
		                var filterSpread = filter.bind(valuesFilter);
		                var anyVisibleChildren = filterSpread(item.children, query); // pass true if parent matches
	
		                hasVisibleChildren = hasVisibleChildren || anyVisibleChildren || itemVisible;
		                item.hidden = !itemVisible && !anyVisibleChildren;
	
		                if (query.length || (values && !values.length)) {
		                    item.checked = !item.hidden;
		                } else if (values && values.indexOf(item.text) != -1){
		                    item.checked = true;
		                }
		            }
	
		            if (data) {
		                // re-apply filter on children
		                dataSource.filter({ field: "hidden", operator: "neq", value: true });
		            }
	
		            return hasVisibleChildren;
		        }
	
		        function uncheckAll(dataSource) {
		            var data = dataSource instanceof kendo.data.HierarchicalDataSource && dataSource.data();
	
		            for (var i = 0; i < data.length; i++) {
		                var item = data[i];
		                item.checked = false;
	
		                if (item.hasChildren) {
		                    uncheckAll(item.children);
		                }
		            }
		        }
	
		        var FilterMenuViewModel = kendo.spreadsheet.FilterMenuViewModel = kendo.data.ObservableObject.extend({
		            valuesChange: function(e) {
		                var dataSource = e ? e.sender.dataSource : this.valuesDataSource;
		                var checked = function(item) {
		                    return item.checked;
		                };
		                var value = function(item) {
		                    return item.dataType === "date" ? kendo.spreadsheet.dateToNumber(item.value) : item.value;
		                };
		                var unique = function(value, index, array) {
		                    return array.lastIndexOf(value) === index;
		                };
		                var data = dataSource.data();
		                var values = data[0].children.data().toJSON();
		                var blanks = values.filter(function(item) {
		                    return item.dataType === "blank";
		                });
	
		                blanks = blanks.length ? blanks[0].checked : false;
		                values = values.filter(checked).map(value);
	
		                if (this.appendToSearch && this.valueFilter && this.valueFilter.values.length) {
		                    values = values.concat(this.valueFilter.values.toJSON()).sort().filter(unique);
		                }
	
		                this.set("valueFilter", {
		                    values: values,
		                    blanks: blanks
		                });
		            },
		            valueSelect: function(e) {
		                e.preventDefault();
	
		                var node = e.sender.dataItem(e.node);
		                node.set("checked", !node.checked);
		            },
		            hasActiveSearch: false,
		            appendToSearch: false,
		            filterValues: function(e) {
		                var query = typeof e == "string" ? e : $(e.target).val().toLowerCase();
		                var dataSource = this.valuesDataSource;
	
		                this.set("hasActiveSearch", !!query);
	
		                var filterSpread = filter.bind(this.valueFilter);
		                uncheckAll(dataSource);
		                filterSpread(dataSource, query);
		            },
		            reset: function() {
		                this.set("customFilter", { logic: "and", criteria: [ { operator: null, value: null } ] });
		                this.set("valueFilter", { values: [] });
		            },
		            operatorChange: function(e) {
		                var dataItem = e.sender.dataItem();
		                this.set("operatorType", dataItem.type);
	
		                // https://github.com/telerik/kendo-ui-core/issues/3317 - when switching from Value
		                // filter to “filter by condition”, the customFilter property is lost.
		                if (!this.get("customFilter")) {
		                    this.reset();
		                }
	
		                this.set("customFilter.criteria[0].operator", dataItem.value);
		            },
		            isNone: function() {
		                return this.get("operatorType") === undefined;
		            },
		            isString: function() {
		                return this.get("operatorType") === "string";
		            },
		            isNumber: function() {
		                return this.get("operatorType") === "number";
		            },
		            isDate: function() {
		                return this.get("operatorType") === "date";
		            }
		        });
	
		        function flattenOperators(operators) {
		            var messages = FILTERMENU_MESSAGES.operators;
		            var result = [];
		            for (var type in operators) {
		                if (!operators.hasOwnProperty(type)) {
		                    continue;
		                }
	
		                for (var operator in operators[type]) {
		                    if (!operators[type].hasOwnProperty(operator)) {
		                        continue;
		                    }
	
		                    result.push({
		                        text: messages[type][operator],
		                        value: operator,
		                        unique: type + "_" + operator,
		                        type: type
		                    });
		                }
		            }
		            return result;
		        }
	
		        var FilterMenuController = kendo.spreadsheet.FilterMenuController = {
		            valuesTree: function(range, column) {
		                return [{
		                    text: "All",
		                    expanded: true,
		                    checked: false,
		                    items: this.values(range.resize({ top: 1 }), column)
		                }];
		            },
		            values: function(range, column) {
		                var values = [];
		                var messages = FILTERMENU_MESSAGES;
		                var columnRange = range.column(column);
		                var sheet = range.sheet();
	
		                columnRange.forEachCell(function(row, col, cell) {
		                    var checked = true;
		                    if (sheet.isHiddenRow(row)) {
		                        checked = false;
		                    }
	
		                    var value = cell.value;
		                    var dataType = cell.dataType;
		                    var text = cell.text;
	
		                    if (value === undefined) {
		                        dataType = "blank";
		                    } else if (cell.format) {
		                        dataType = kendo.spreadsheet.formatting.type(value, cell.format);
		                    } else {
		                        dataType = typeof value;
		                    }
	
		                    if (value !== null && cell.format) {
		                        text = kendo.spreadsheet.formatting.text(value, cell.format);
		                    } else {
		                        text = dataType == "blank" ? messages.blanks : value;
		                    }
	
		                    if (dataType === "percent" || dataType === "currency") { //treat percent as number
		                        dataType = "number";
		                    }
	
		                    if (dataType === "date") {
		                        value = kendo.spreadsheet.numberToDate(value);
		                    }
	
		                    values.push({
		                        dataType: dataType,
		                        value: value,
		                        text: text,
		                        checked: checked
		                    });
		                });
	
		                values = distinctValues(values);
	
		                values.sort(function(a, b) {
		                    if (a.dataType === b.dataType) {
		                        return 0;
		                    }
	
		                    if (a.dataType === "blank" || b.dataType === "blank") {
		                        return a.dataType === "blank" ? -1 : 1;
		                    }
	
		                    if (a.dataType === "number" || b.dataType === "number") {
		                        return a.dataType === "number" ? -1 : 1;
		                    }
	
		                    if (a.dataType === "date" || b.dataType === "date") {
		                        return a.dataType === "date" ? -1 : 1;
		                    }
	
		                    return 0;
		                });
	
		                return values;
		            },
	
		            filterType: function(range, column) {
		                // 1. try to infer type from current filter
		                var sheet = range.sheet();
		                var filter = this.filterForColumn(column, sheet);
		                var type;
	
		                filter = filter && filter.filter.toJSON();
	
		                if (filter && filter.filter == "custom") {
		                    var value = filter.criteria[0].value;
	
		                    if (value instanceof Date) {
		                        type = "date";
		                    } else if (typeof value == "string") {
		                        type = "string";
		                    } else if (typeof value == "number") {
		                        type = "number";
		                    }
		                }
	
		                if (!type) {
		                    // 2. try to infer type from column data
		                    var topValue = this.values(range.row(1), column)[0];
		                    type = topValue && topValue.dataType;
	
		                    if (type == "blank") {
		                        type = null;
		                    }
		                }
	
		                return type;
		            },
	
		            filterForColumn: function(column, sheet) {
		                var allFilters = sheet.filter();
		                var filters;
	
		                if (allFilters) {
		                    filters =  allFilters.columns.filter(function(item) {
		                        return item.index === column;
		                    })[0];
		                }
	
		                return filters;
		            },
	
		            filter: function(column, sheet) {
		                var columnFilters = this.filterForColumn(column, sheet);
	
		                if (!columnFilters) {
		                    return;
		                }
	
		                var options = columnFilters.filter.toJSON();
		                var type = options.filter;
	
		                delete options.filter;
	
		                var result = {
		                    type: type,
		                    options: options
		                };
	
		                var criteria = options.criteria;
		                if (criteria && criteria.length) {
		                    result.operator = criteria[0].operator;
		                }
	
		                return result;
		            }
		        };
	
		        var FilterMenu = Widget.extend({
		            init: function(element, options) {
		                Widget.call(this, element, options);
	
		                this.element.addClass(FilterMenu.classNames.wrapper);
	
		                this.viewModel = new FilterMenuViewModel({
		                    active: "value",
		                    operator: null,
		                    operators: flattenOperators(this.options.operators),
		                    clear: this.clear.bind(this),
		                    apply: this.apply.bind(this)
		                });
	
		                this._filterInit();
		                this._popup();
		                this._sort();
		                this._filterByCondition();
		                this._filterByValue();
		                this._actionButtons();
		            },
	
		            options: {
		                name: "FilterMenu",
		                column: 0,
		                range: null,
		                operators: {
		                    string: {
		                        contains: "Text contains",
		                        doesnotcontain: "Text does not contain",
		                        startswith: "Text starts with",
		                        endswith: "Text ends with",
		                        matches: "Text matches",
		                        doesnotmatch: "Text does not match"
		                    },
		                    date: {
		                        eq:  "Date is",
		                        neq: "Date is not",
		                        lt:  "Date is before",
		                        gt:  "Date is after"
		                    },
		                    number: {
		                        eq: "Is equal to",
		                        neq: "Is not equal to",
		                        gte: "Is greater than or equal to",
		                        gt: "Is greater than",
		                        lte: "Is less than or equal to",
		                        lt: "Is less than"
		                    }
		                }
		            },
	
		            events: [
		                "action"
		            ],
	
		            destroy: function() {
		                Widget.fn.destroy.call(this);
	
		                this.menu.destroy();
		                this.valuesTreeView.destroy();
		                this.popup.destroy();
		            },
	
		            openFor: function(anchor) {
		                this.popup.setOptions({ anchor: anchor });
		                this.popup.open();
		            },
	
		            close: function() {
		                this.popup.close();
		            },
	
		            clear: function() {
		                this.action({
		                    command: "ClearFilterCommand",
		                    options: {
		                        column: this.options.column
		                    }
		                });
		                this.viewModel.reset();
		                this.close();
		            },
	
		            apply: function() {
		                this._active();
	
		                var options = {
		                    operatingRange: this.options.range,
		                    column: this.options.column
		                };
	
		                var valueFilter;
		                var customFilter;
	
		                if (this.viewModel.active === "value") {
		                    this.viewModel.valuesChange({ sender: this.valuesTreeView });
		                    valueFilter = this.viewModel.valueFilter.toJSON();
	
		                    if (valueFilter.blanks || (valueFilter.values && valueFilter.values.length)) {
		                        options.valueFilter = valueFilter;
		                    }
		                } else if (this.viewModel.active === "custom") {
		                    customFilter = this.viewModel.customFilter.toJSON();
	
		                    if (customFilter.criteria.length && customFilter.criteria[0].value !== null) {
		                        options.customFilter = customFilter;
		                    }
		                }
	
		                if (options.valueFilter || options.customFilter) {
		                    this.action({ command: "ApplyFilterCommand", options: options });
		                }
		            },
	
		            action: function(options) {
		                this.trigger("action", $.extend({ }, options));
		            },
	
		            _filterInit: function() {
		                var column = this.options.column;
		                var range = this.options.range;
		                var sheet = range.sheet();
		                var activeFilter = FilterMenuController.filter(column, sheet);
	
		                if (activeFilter) {
		                    var filterType = FilterMenuController.filterType(range, column);
	
		                    this.viewModel.set("active", activeFilter.type);
		                    this.viewModel.set(activeFilter.type + "Filter", activeFilter.options);
	
		                    if (activeFilter.type == "custom") {
		                        this.viewModel.set("operator", filterType + "_" + activeFilter.operator);
		                        this.viewModel.set("operatorType", filterType);
		                    }
		                } else {
		                    this.viewModel.reset();
		                }
		            },
	
		            _popup: function() {
		                this.popup = this.element.kendoPopup({
		                    copyAnchorStyles: false
		                }).data("kendoPopup");
		            },
	
		            _sort: function() {
		                var template = kendo.template(FilterMenu.templates.menuItem);
		                var messages = FILTERMENU_MESSAGES;
		                var items = [
		                    { command: "sort", dir: "asc", text: messages.sortAscending, iconClass: "sort-asc" },
		                    { command: "sort", dir: "desc", text: messages.sortDescending, iconClass: "sort-desc" }
		                ];
	
		                var ul = $("<ul />", {
		                    "html": kendo.render(template, items)
		                }).appendTo(this.element);
	
		                this.menu = ul.kendoMenu({
		                    orientation: "vertical",
		                    select: function(e) {
		                        var dir = $(e.item).data("dir");
		                        var range = this.options.range.resize({ top: 1 });
		                        var options = {
		                            value: dir,
		                            sheet: false,
		                            operatingRange: range,
		                            column: this.options.column
		                        };
	
		                        if (range.isSortable()) {
		                            this.action({ command: "SortCommand", options: options });
		                        } else {
		                            this.close();
		                        }
		                    }.bind(this)
		                }).data("kendoMenu");
		            },
	
		            _appendTemplate: function(template, className, details, expanded) {
		                var compiledTemplate = kendo.template(template);
		                var wrapper = $("<div class='" + className + "'/>").html(compiledTemplate({
		                    messages: FILTERMENU_MESSAGES,
		                    guid: kendo.guid(),
		                    ns: kendo.ns
		                }));
	
		                this.element.append(wrapper);
	
		                if (details) {
		                    details = new Details(wrapper, { expanded: expanded, toggle: this._detailToggle.bind(this) }); // jshint ignore:line
		                }
	
		                kendo.bind(wrapper, this.viewModel);
	
		                return wrapper;
		            },
	
		            _detailToggle: function(e) {
		                this.element
		                    .find("[data-role=details]")
		                    .not(e.sender.element)
		                    .data("kendoDetails")
		                    .toggle(!e.show);
		            },
	
		            _filterByCondition: function() {
		                var isExpanded = this.viewModel.active === "custom";
		                this._appendTemplate(FilterMenu.templates.filterByCondition, FilterMenu.classNames.filterByCondition, true, isExpanded);
		            },
	
		            _filterByValue: function() {
		                var isExpanded = this.viewModel.active === "value";
		                var wrapper = this._appendTemplate(FilterMenu.templates.filterByValue, FilterMenu.classNames.filterByValue, true, isExpanded);
	
		                this.valuesTreeView = wrapper.find("[data-role=treeview]").data("kendoTreeView");
	
		                var values = FilterMenuController.valuesTree(this.options.range, this.options.column);
	
		                this.viewModel.set("valuesDataSource", new kendo.data.HierarchicalDataSource({ data: values }));
		            },
	
		            _actionButtons: function() {
		                this._appendTemplate(FilterMenu.templates.actionButtons, FilterMenu.classNames.actionButtons, false);
		            },
	
		            _active: function() {
		                var activeContainer = this.element.find("[data-role=details]").filter(function(index, element) {
		                    return $(element).data("kendoDetails").visible();
		                });
	
		                if (activeContainer.hasClass(FilterMenu.classNames.filterByValue)) {
		                    this.viewModel.set("active", "value");
		                } else if (activeContainer.hasClass(FilterMenu.classNames.filterByCondition)) {
		                    this.viewModel.set("active", "custom");
		                }
		            }
		        });
	
		        kendo.spreadsheet.FilterMenu = FilterMenu;
		        $.extend(true, FilterMenu, { classNames: classNames, templates: templates });
	
		    })(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1474:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(592);
	
	/***/ }),
	
	/***/ 1475:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(590);
	
	/***/ }),
	
	/***/ 1476:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(606);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1467);
		module.exports = __webpack_require__(1467);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1467:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var SheetEditor = kendo.Observable.extend({
		        init: function(view) {
		            kendo.Observable.fn.init.call(this);
	
		            this.view = view;
		            this.formulaBar = view.formulaBar;
		            this._active = false;
	
		            this.barInput = view.formulaBar.formulaInput;
		            this.cellInput = view.formulaInput;
	
		            this.barInput.syncWith(this.cellInput);
		            this.cellInput.syncWith(this.barInput);
	
		            this.barInput.bind("keyup", this._triggerUpdate.bind(this));
		            this.cellInput.bind("keyup", this._triggerUpdate.bind(this));
	
		            this.barInput.bind("blur", this._blur.bind(this));
		            this.cellInput.bind("blur", this._blur.bind(this));
		        },
	
		        events: [
		            "activate",
		            "deactivate",
		            "change",
		            "update"
		        ],
	
		        _blur: function() {
		            this.deactivate();
		        },
	
		        _triggerUpdate: function() {
		            this.trigger("update", { value: this.value() });
		        },
	
		        activeEditor: function() {
		            var editor = null;
		            var activeElement = kendo._activeElement();
	
		            if (this.barElement()[0] === activeElement) {
		                editor = this.barInput;
		            } else if (this.cellElement()[0] === activeElement) {
		                editor = this.cellInput;
		            }
	
		            return editor;
		        },
	
		        activate: function(options) {
		            this._active = true;
		            this._rect = options.rect;
		            this._range = options.range;
	
		            this.cellInput.position(options.rect);
		            this.cellInput.resize(options.rect);
		            this.cellInput.tooltip(options.tooltip);
		            this.cellInput.activeCell = this.barInput.activeCell = this._range.topLeft();
		            this.cellInput.activeSheet = this.barInput.activeSheet = this._range._sheet;
	
		            this.trigger("activate");
	
		            return this;
		        },
	
		        deactivate: function(noChange) {
		            var cellInput = this.cellInput;
	
		            if (!this._active) {
		                return;
		            }
	
		            this._active = false;
	
		            if (!noChange && cellInput.value() != this._value) {
		                this.trigger("change", {
		                    value: cellInput.value(),
		                    range: this._range
		                });
		            }
	
		            this._rect = null;
		            cellInput.hide();
		            this.trigger("deactivate");
		        },
	
		        enable: function(enable) {
		            this.barInput.enable(enable);
		            this.cellInput.enable(enable);
		        },
	
		        barElement: function() {
		            return this.barInput.element;
		        },
	
		        cellElement: function() {
		            return this.cellInput.element;
		        },
	
		        focus: function(inputType) {
		            inputType = inputType || "cell";
	
		            if (inputType === "cell") {
		                this.cellInput.element.focus();
		                this.cellInput.end();
		            } else {
		                this.barInput.element.focus();
		            }
		        },
	
		        isActive: function() {
		            return this._active;
		        },
	
		        isFiltered: function() {
		            return this.barInput.popup.visible() || this.cellInput.popup.visible();
		        },
	
		        canInsertRef: function(isKeyboardAction) {
		            var editor = this.activeEditor();
		            return editor && editor.canInsertRef(isKeyboardAction);
		        },
	
		        highlightedRefs: function() {
		            var editor = this.activeEditor();
		            var refs = [];
	
		            if (editor) {
		                refs = editor.highlightedRefs();
		            }
	
		            return refs;
		        },
	
		        scale: function() {
		            this.cellInput.scale();
		        },
	
		        toggleTooltip: function(rect) {
		            this.cellInput.toggleTooltip(notEqual(this._rect, rect));
		        },
	
		        value: function(value, isArrayFormula) {
		            if (value === undefined) {
		                return this.barInput.value();
		            }
	
		            if (value === null) {
		                value = "";
		            }
	
		            this._value = value;
	
		            this.barInput.value(value);
		            this.cellInput.value(value);
	
		            this.barInput.element.toggleClass("k-spreadsheet-array-formula", !!isArrayFormula);
		        },
	
		        insertNewline: function() {
		            this.activeEditor().insertNewline();
		            this.scale();
		        },
	
		        select: function() {
		            this.activeEditor().select();
		        }
		    });
	
		    function notEqual(oldRect, newRect) {
		        return oldRect && (oldRect.top !== newRect.top || oldRect.left !== newRect.left);
		    }
	
		    kendo.spreadsheet.SheetEditor = SheetEditor;
		})(kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1449);
		module.exports = __webpack_require__(1449);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 939:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(713);
	
	/***/ }),
	
	/***/ 1449:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-
	
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1450), __webpack_require__(939) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    // jshint eqnull:true
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var spreadsheet = kendo.spreadsheet;
		    var Range = spreadsheet.Range;
		    var runtime = spreadsheet.calc.runtime;
		    var Formula = runtime.Formula;
	
		    var ERR_INCOMPATIBLE = "incompatibleRanges";
		    var ERR_NO_DIRECTION = "noFillDirection";
	
		    var FillError = Range.FillError = function(msg) {
		        this.code = msg;
		    };
	
		    // `srcRange`: the range containing data that we wish to fill.  `direction`: 0↓, 1→, 2↑, 3←.  So
		    // when bit 0 is set we're doing horizontal filling, and when bit 1 is set we're doing it in
		    // reverse order.
		    Range.prototype._previewFillFrom = function(srcRange, direction) {
		        var destRange = this, sheet = destRange._sheet;
		        if (typeof srcRange == "string") {
		            srcRange = sheet.range(srcRange);
		        }
		        var src = srcRange._ref.toRangeRef().clone().setSheet(sheet.name());
		        var dest = destRange._ref.toRangeRef().clone().setSheet(sheet.name());
	
		        if (src.intersects(dest)) {
		            // the UI will send e.g. C2:C8.fillFrom(C7:D8) (intersecting ranges).  this figures out
		            // the actual destination range.
		            if (src.eq(dest)) {
		                return null; // nothing to do
		            }
		            dest = dest.clone();
		            if (src.topLeft.eq(dest.topLeft)) {
		                if (src.width() == dest.width()) {
		                    dest.topLeft.row += src.height();
		                    direction = 0;
		                } else if (src.height() == dest.height()) {
		                    dest.topLeft.col += src.width();
		                    direction = 1;
		                } else {
		                    throw new FillError(ERR_INCOMPATIBLE);
		                }
		            } else if (src.bottomRight.eq(dest.bottomRight)) {
		                if (src.width() == dest.width()) {
		                    dest.bottomRight.row -= src.height();
		                    direction = 2;
		                } else if (src.height() == dest.height()) {
		                    dest.bottomRight.col -= src.width();
		                    direction = 3;
		                } else {
		                    throw new FillError(ERR_INCOMPATIBLE);
		                }
		            } else {
		                throw new FillError(ERR_INCOMPATIBLE);
		            }
		            return sheet.range(dest)._previewFillFrom(srcRange, direction);
		        }
	
		        if (direction == null) {
		            // try to determine based on ranges location/geometry
		            if (src.topLeft.col == dest.topLeft.col) {
		                // assume vertical filling
		                direction = src.topLeft.row < dest.topLeft.row ? 0 : 2;
		            } else if (src.topLeft.row == dest.topLeft.row) {
		                direction = src.topLeft.col < dest.topLeft.col ? 1 : 3;
		            } else {
		                throw new FillError(ERR_NO_DIRECTION);
		            }
		        }
		        var horizontal = direction & 1;
		        var descending = direction & 2;
		        if ((horizontal && src.height() != dest.height()) ||
		            (!horizontal && src.width() != dest.width())) {
		            throw new FillError(ERR_INCOMPATIBLE);
		        }
		        var data = srcRange._properties(), n;
		        if (!horizontal) {
		            data = transpose(data);
		            n = dest.height();
		        } else {
		            n = dest.width();
		        }
		        var fill = new Array(data.length);
		        for (var i = 0; i < data.length; ++i) {
		            var s = data[i];
		            var f = findSeries(s);
		            var a = fill[i] = new Array(n);
		            for (var j = 0; j < n; ++j) {
		                var idx = descending ? -j - 1 : s.length + j;
		                var srcIdx = descending ? s.length - (j % s.length) - 1 : (j % s.length);
		                a[descending ? n - j - 1 : j] = f(idx, srcIdx);
		            }
		        }
		        if (!horizontal) {
		            fill = transpose(fill);
		        }
		        return { props: fill, direction: direction, dest: destRange };
		    };
	
		    Range.prototype.fillFrom = function(srcRange, direction) {
		        var x = this._previewFillFrom(srcRange, direction);
		        x.dest._properties(x.props);
		        return x.dest;
		    };
	
		    // This is essentially the FORECAST function, see ./runtime.functions.2.js.
		    // It receives an array of values, and returns a function that "predicts"
		    // the value in cell N.
		    function linearRegression(data) {
		        var N = data.length;
		        var mx = (N + 1) / 2, my = data.reduce(function(a, b){
		            return a + b;
		        }, 0) / N;
		        var s1 = 0, s2 = 0;
		        for (var i = 0; i < N; i++) {
		            var t1 = (i + 1) - mx, t2 = data[i] - my;
		            s1 += t1 * t2;
		            s2 += t1 * t1;
		        }
		        if (!s2) {
		            return function(N){
		                return data[N % data.length];
		            };
		        }
		        var b = s1 / s2, a = my - b * mx;
		        return function(N) {
		            return a + b * (N + 1);
		        };
		    }
	
		    function findSeries(properties) {
		        function findStep(a) {
		            var diff = a[1] - a[0];
		            for (var i = 2; i < a.length; ++i) {
		                if (a[i] - a[i-1] != diff) {
		                    return null;
		                }
		            }
		            return diff;
		        }
		        function getData(a) {
		            return a.map(function(v){
		                return v.number;
		            });
		        }
		        var series = [];
		        var data = properties.map(function(x){
		            return x.formula || x.value;
		        });
		        forEachSeries(data, function(begin, end, type, a){
		            var f, values;
		            if (type == "number") {
		                values = getData(a);
	
		                // This code would increase a date even if a single cell was selected.  Seems it's
		                // not desirable so I commented it out.
		                // https://github.com/telerik/kendo-ui-core/issues/3565
		                //
		                // if (values.length == 1 && (begin > 0 || end < data.length ||
		                //                            formatType(values[0], properties[begin].format) == "date")) {
		                //     values.push(values[0] + 1);
		                // }
	
		                f = linearRegression(values);
		            } else if (type == "string" || type == "formula" || type == "boolean") {
		                // formulas are simply copied over; the sheet will internally clone the objects
		                f = function(N, i) {
		                    return data[i];
		                };
		            } else if (Array.isArray(type)) {
		                if (a.length == 1) {
		                    f = function(N) {
		                        return type[(a[0].number + N) % type.length];
		                    };
		                } else {
		                    // figure out the step
		                    var diff = findStep(getData(a));
		                    if (diff == null) {
		                        // seemingly no pattern, just repeat those strings
		                        f = function(N) {
		                            return a[(N) % a.length].value;
		                        };
		                    } else {
		                        f = function(N) {
		                            var idx = a[0].number + diff * N;
		                            return type[idx % type.length];
		                        };
		                    }
		                }
		            } else if (type != "null") {
		                values = getData(a);
		                if (values.length == 1) {
		                    values.push(values[0] + 1);
		                }
		                values = linearRegression(values);
		                f = function(N, i) {
		                    return data[i].replace(/^(.*\D)\d+/, "$1" + values(N, i));
		                };
		            } else {
		                f = function() { return null; };
		            }
		            var s = { f: f, begin: begin, end: end, len: end - begin };
		            for (var i = begin; i < end; ++i) {
		                series[i] = s;
		            }
		        });
		        return function(N, i) {
		            var s = series[i];
		            var q = N / data.length | 0;
		            var r = N % data.length;
		            var n = q * s.len + r - s.begin;
		            var value = s.f(n, i);
		            var props = clone(properties[i]);
		            delete props.enable;
		            if (value instanceof Formula) {
		                props.formula = value;
		            } else {
		                props.value = value;
		            }
		            return props;
		        };
		    }
	
		    // function formatType(value, format) {
		    //     if (format != null) {
		    //         return spreadsheet.formatting.type(value, format);
		    //     }
		    // }
	
		    function clone(obj) {
		        var copy = {};
		        Object.keys(obj || {}).forEach(function(key){
		            copy[key] = obj[key];
		        });
		        return copy;
		    }
	
		    function forEachSeries(data, f) {
		        var prev = null, start = 0, a = [], type;
		        for (var i = 0; i < data.length; ++i) {
		            type = getType(data[i]);
		            a.push(type);
		            if (prev != null && type.type !== prev.type) {
		                f(start, i, prev.type, a.slice(start, i));
		                start = i;
		            }
		            prev = type;
		        }
		        f(start, i, prev.type, a.slice(start, i));
		    }
	
		    function getType(el) {
		        if (typeof el == "number") {
		            return { type: "number", number: el };
		        }
		        if (typeof el == "string") {
		            var lst = findStringList(el);
		            if (lst) {
		                return lst;
		            }
		            var m = /^(.*\D)(\d+)/.exec(el);
		            if (m) {
		                el = el.replace(/^(.*\D)\d+/, "$1-######");
		                return { type: el, match: m, number: parseFloat(m[2]) };
		            }
		            return { type: "string" };
		        }
		        if (typeof el == "boolean") {
		            return { type: "boolean" };
		        }
		        if (el == null) {
		            return { type: "null" };
		        }
		        if (el instanceof Formula) {
		            return { type: "formula" };
		        }
		        window.console.error(el);
		        throw new Error("Cannot fill data");
		    }
	
		    function stringLists() {
		        var culture = kendo.culture();
		        return [
		            culture.calendars.standard.days.namesAbbr,
		            culture.calendars.standard.days.names,
		            culture.calendars.standard.months.namesAbbr,
		            culture.calendars.standard.months.names
		        ];
		    }
	
		    function findStringList(str) {
		        var strl = str.toLowerCase();
		        var lists = stringLists();
		        for (var i = 0; i < lists.length; ++i) {
		            var a = lists[i];
		            for (var j = a.length; --j >= 0;) {
		                var el = a[j].toLowerCase();
		                if (el == strl) {
		                    return { type: a, number: j, value: str };
		                }
		            }
		        }
		    }
	
		    function transpose(a) {
		        var height = a.length, width = a[0].length;
		        var t = [];
		        for (var i = 0; i < width; ++i) {
		            t[i] = [];
		            for (var j = 0; j < height; ++j) {
		                t[i][j] = a[j][i];
		            }
		        }
		        return t;
		    }
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1450:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(715);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1482);
		module.exports = __webpack_require__(1482);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1482:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(19) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function(kendo) {
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var $ = kendo.jQuery;
	
		    var CLASS_NAMES = {
		        input: "k-spreadsheet-name-editor",
		        list: "k-spreadsheet-name-list"
		    };
	
		    var NameEditor = kendo.ui.Widget.extend({
		        init: function(element, options) {
		            kendo.ui.Widget.call(this, element, options);
		            element.addClass(CLASS_NAMES.input);
	
		            var comboBoxTitle = options.messages.nameBox || "Name Box";
		            var dataSource = new kendo.data.DataSource({
		                transport: {
		                    read: function(options) {
		                        var data = [];
		                        this._workbook.forEachName(function(def){
		                            if (!def.hidden && def.value instanceof kendo.spreadsheet.Ref) {
		                                data.push({ name: def.name });
		                            }
		                        });
		                        options.success(data);
		                    }.bind(this),
		                    cache: false
		                }
		            });
	
		            var comboElement = $("<input />")
		                .attr("title", comboBoxTitle)
		                .attr("aria-label", comboBoxTitle);
	
		            this.combo = comboElement.appendTo(element)
		                .kendoComboBox({
		                    clearButton: false,
		                    dataTextField: "name",
		                    dataValueField: "name",
		                    template: "#:data.name#<a class='k-button-delete' href='\\#'><span class='k-icon k-i-close'></span></a>",
		                    dataSource: dataSource,
		                    autoBind: false,
		                    ignoreCase: true,
		                    change: this._on_listChange.bind(this),
		                    noDataTemplate: "<div></div>",
		                    open: function() {
		                        dataSource.read();
		                    }
		                }).getKendoComboBox();
	
		            this.combo.input
		                .on("keydown", this._on_keyDown.bind(this))
		                .on("focus", this._on_focus.bind(this));
	
		            this.combo.popup.element
		                .addClass("k-spreadsheet-names-popup")
	
		                .on("mousemove", function(ev){
		                    // XXX: should remove this when we find a better
		                    // solution for the popup closing as we hover the
		                    // resize handles.
		                    ev.stopPropagation();
		                })
	
		                .on("click", ".k-button-delete", function(ev){
		                    ev.preventDefault();
		                    ev.stopPropagation();
		                    var item = $(ev.target).closest(".k-item");
		                    item = this.combo.dataItem(item);
		                    this._deleteItem(item.name);
		                }.bind(this));
		        },
		        value: function(val) {
		            if (val === undefined) {
		                return this.combo.value();
		            } else {
		                this.combo.value(val);
		            }
		        },
		        _deleteItem: function(name) {
		            this.trigger("delete", { name: name });
		        },
		        _on_keyDown: function(ev) {
		            switch (ev.keyCode) {
		              case 27:
		                this.combo.value(this._prevValue);
		                this.trigger("cancel");
		                break;
		              case 13:
		                this.trigger("enter");
		                break;
		            }
		        },
		        _on_focus: function() {
		            this._prevValue = this.combo.value();
		        },
		        _on_listChange: function() {
		            var name = this.combo.value();
		            if (name) {
		                this.trigger("select", { name: name });
		            }
		        }
		    });
	
		    kendo.spreadsheet.NameEditor = NameEditor;
		})(window.kendo);
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		__webpack_require__(1488);
		module.exports = __webpack_require__(1488);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 924:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(555);
	
	/***/ }),
	
	/***/ 939:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(713);
	
	/***/ }),
	
	/***/ 1465:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(714);
	
	/***/ }),
	
	/***/ 1481:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(708);
	
	/***/ }),
	
	/***/ 1488:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1489), __webpack_require__(1465), __webpack_require__(939), __webpack_require__(1481), __webpack_require__(1490), __webpack_require__(924) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "use strict";
	
		    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
		        return;
		    }
	
		    var spreadsheet = kendo.spreadsheet;
		    var CellRef = spreadsheet.CellRef;
		    var drawing = kendo.drawing;
		    var formatting = spreadsheet.formatting;
		    var geo = kendo.geometry;
	
		    var GUIDELINE_WIDTH = 0.8;
	
		    /* jshint eqnull:true, laxbreak:true, shadow:true, -W054 */
		    /* jshint latedef: nofunc */
	
		    // This takes a list of row heights and the page height, and
		    // produces a list of Y coordinates for each row, such that rows
		    // are not truncated across pages.  However, the algorithm will
		    // decide to truncate a row in the event that more than
		    // `maxEmpty` (default 0.2) of the available space would
		    // otherwise be left blank.
		    //
		    // It will be used for horizontal splitting too (will receive
		    // column widths and page width, and produce a list of X coords).
		    //
		    // If the third argument (headerRows) is not null, it specifies a
		    // number of rows to repeat on each page.  On pages other than the
		    // first, the necessary space will be skipped at the top.  Header
		    // coordinates (except for the first page) are pushed in
		    // headerCoords.
		    function distributeCoords(heights, pageHeight, maxEmpty, headerRows, headerCoords) {
		        var curr = 0;
		        var out = [];
		        var bottom = pageHeight;
		        var header = 0;
		        if (pageHeight && maxEmpty) {
		            maxEmpty *= pageHeight;
		        }
		        heights.forEach(function(h, i){
		            if (headerRows != null && i < headerRows) {
		                header += h;
		            }
		            if (pageHeight && curr + h > bottom) {
		                if (bottom - curr < maxEmpty) {
		                    // align to next page
		                    curr = pageHeight * Math.ceil(curr / pageHeight) + header;
		                    if (header > 0) {
		                        headerCoords.push(curr - header);
		                    }
		                }
		                // update bottom anyway; don't just add pageHeight, as
		                // we might need multiple pages for the pathological
		                // case of one row higher than the page.
		                bottom += pageHeight * Math.ceil(h / pageHeight);
		            }
		            out.push(curr);
		            curr += h;
		        });
		        out.push(curr);
		        return out;
		    }
	
		    function doLayout(sheet, range, options) {
		        // normalize reference so we don't have to deal with Infinity here.
		        var grid = sheet._grid;
		        range = grid.normalize(range);
	
		        // 1. obtain the list of cells that need to be printed, the
		        //    row heights and column widths.  Place in each cell row,
		        //    col (relative to range, i.e. first is 0,0), rowspan,
		        //    colspan and merged.
		        var cells = [];
		        var rowHeights = [];
		        var colWidths = [];
		        var mergedCells = sheet._getMergedCells(range);
	
		        var maxRow = -1, maxCol = -1;
		        sheet.forEach(range, function(row, col, cell){
		            var relrow = row - range.topLeft.row;
		            var relcol = col - range.topLeft.col;
		            var rh = sheet.rowHeight(row);
		            var cw = sheet.columnWidth(col);
		            if (!relcol) {
		                rowHeights.push(rh);
		            }
		            if (!relrow) {
		                colWidths.push(cw);
		            }
		            if (sheet.isHiddenColumn(col) || sheet.isHiddenRow(row) || !rh || !cw) {
		                return;
		            }
		            var nonEmpty = options.forScreen || shouldDrawCell(cell);
		            if (!(options.emptyCells || nonEmpty)) {
		                return;
		            }
		            var id = new CellRef(row, col).print();
		            if (mergedCells.secondary[id]) {
		                return;
		            }
		            if (nonEmpty) {
		                maxRow = Math.max(maxRow, relrow);
		                maxCol = Math.max(maxCol, relcol);
		            } else {
		                cell.empty = true;
		            }
		            cell.row = relrow;
		            cell.col = relcol;
		            var m = mergedCells.primary[id];
		            if (m) {
		                delete mergedCells.primary[id];
		                cell.merged = true;
		                cell.rowspan = m.height();
		                cell.colspan = m.width();
		                if (options.forScreen) {
		                    cell.width = sheet._columns.sum(m.topLeft.col, m.bottomRight.col);
		                    cell.height = sheet._rows.sum(m.topLeft.row, m.bottomRight.row);
		                }
		            } else {
		                cell.rowspan = 1;
		                cell.colspan = 1;
		            }
		            cells.push(cell);
		        });
	
		        // keep only the drawable area
		        rowHeights = rowHeights.slice(0, maxRow + 1);
		        colWidths = colWidths.slice(0, maxCol + 1);
	
		        var pageWidth = options.pageWidth;
		        var pageHeight = options.pageHeight;
		        var scaleFactor = options.scale || 1;
	
		        // when fitWidth is requested, we must update the page size
		        // with the corresponding scale factor; the algorithm below
		        // (2) will continue to work, just drawing on a bigger page.
		        if (options.fitWidth) {
		            var width = colWidths.reduce(sum, 0);
		            if (width > pageWidth) {
		                scaleFactor = pageWidth / width;
		            }
		        }
		        pageWidth = Math.ceil(pageWidth / scaleFactor);
		        pageHeight = Math.ceil(pageHeight / scaleFactor);
	
		        // 2. calculate top, left, bottom, right, width and height for
		        //    printable cells.  Merged cells will be split across
		        //    pages, unless the first row/col is shifted to next page.
		        //    boxWidth and boxHeight get the complete drawing size.
		        //    Note that cell coordinates keep increasing, i.e. they
		        //    are not reset to zero for a new page.  The print
		        //    function translates the view to current page.
		        var hyCoords = []; // will receive header Y coordinates, if needed
		        var yCoords = distributeCoords(rowHeights, pageHeight || 0, options.maxEmpty,
		                                       options.headerRows, hyCoords);
		        var xCoords = distributeCoords(colWidths, pageWidth || 0, options.maxEmpty);
		        var boxWidth = 0;
		        var boxHeight = 0;
		        var headerCells = [];
		        cells = cells.filter(function(cell){
		            if (cell.empty && (cell.row > maxRow || cell.col > maxCol)) {
		                return false;
		            }
		            if (options.headerRows && cell.row < options.headerRows) {
		                headerCells.push(cell);
		            }
		            cell.left = xCoords[cell.col];
		            cell.top = yCoords[cell.row];
		            if (cell.merged) {
		                if (!options.forScreen) {
		                    cell.right = orlast(xCoords, cell.col + cell.colspan);
		                    cell.bottom = orlast(yCoords, cell.row + cell.rowspan);
		                    cell.width = cell.right - cell.left;
		                    cell.height = cell.bottom - cell.top;
		                } else {
		                    cell.right = cell.left + cell.width;
		                    cell.bottom = cell.top + cell.height;
		                }
		            } else {
		                cell.width = colWidths[cell.col];
		                cell.height = rowHeights[cell.row];
		                cell.bottom = cell.top + cell.height;
		                cell.right = cell.left + cell.width;
		            }
		            boxWidth = Math.max(boxWidth, cell.right);
		            boxHeight = Math.max(boxHeight, cell.bottom);
		            return true;
		        });
	
		        // 3. if any merged cells remain in "primary", they start
		        //    outside the printed range and we should still display
		        //    them partially.
		        Object.keys(mergedCells.primary).forEach(function(id){
		            var ref = mergedCells.primary[id];
		            sheet.forEach(ref.topLeft.toRangeRef(), function(row, col, cell){
		                var relrow = row - range.topLeft.row;
		                var relcol = col - range.topLeft.col;
		                cell.merged = true;
		                cell.colspan = ref.width();
		                cell.rowspan = ref.height();
		                if (relrow < 0) {
		                    cell.top = -sheet._rows.sum(row, row - relrow - 1);
		                } else {
		                    cell.top = yCoords[relrow];
		                }
		                if (relcol < 0) {
		                    cell.left = -sheet._columns.sum(col, col - relcol - 1);
		                } else {
		                    cell.left = xCoords[relcol];
		                }
		                cell.height = sheet._rows.sum(ref.topLeft.row, ref.bottomRight.row);
		                cell.width = sheet._columns.sum(ref.topLeft.col, ref.bottomRight.col);
		                if (cell.height > 0 && cell.width > 0) {
		                    // zero means a fully hidden merged cell (all rows/columns are hidden)
		                    // https://github.com/telerik/kendo-ui-core/issues/1794
		                    cell.right = cell.left + cell.width;
		                    cell.bottom = cell.top + cell.height;
		                    cell.row = relrow;
		                    cell.col = relcol;
		                    cells.push(cell);
		                }
		            });
		        });
	
		        // 4. replicate header rows on all pages
		        if (options.headerRows) {
		            hyCoords.forEach(function(y){
		                headerCells.forEach(function(cell){
		                    cell = clone(cell);
		                    cell.top += y;
		                    cell.bottom = cell.top + cell.height;
		                    cells.push(cell);
		                });
		                yCoords.push(y);
		            });
		            yCoords.sort(orderCoords);
		        }
	
		        return {
		            width    : boxWidth,
		            height   : boxHeight,
		            cells    : cells.sort(orderCells),
		            scale    : scaleFactor,
		            xCoords  : xCoords,
		            yCoords  : yCoords
		        };
		    }
	
		    function clone(hash, target) {
		        if (!target) {
		            target = {};
		        }
		        if (Object.assign) {
		            return Object.assign(target, hash);
		        }
		        return Object.keys(hash).reduce(function(copy, key){
		            copy[key] = hash[key];
		            return copy;
		        }, target);
		    }
	
		    function sameBorder(a, b) {
		        return a.size === b.size && a.color === b.color;
		    }
	
		    function sum(a, b) {
		        return a + b;
		    }
	
		    function orlast(a, i) {
		        return i < a.length ? a[i] : a[a.length - 1];
		    }
	
		    function shouldDrawCell(cell) {
		        return cell.value != null
		            || cell.merged
		            || cell.background != null
		            || cell.borderRight != null
		            || cell.borderBottom != null
		            || (cell.validation != null && !cell.validation.value);
		    }
	
		    function orderCells(a, b) {
		        if (a.top < b.top) {
		            return -1;
		        } else if (a.top == b.top) {
		            if (a.left < b.left) {
		                return -1;
		            } else if (a.left == b.left) {
		                return 0;
		            } else {
		                return 1;
		            }
		        } else {
		            return 1;
		        }
		    }
	
		    function orderCoords(a, b) {
		        return a < b ? -1 : a > b ? 1 : 0;
		    }
	
		    function drawLayout(sheet, layout, group, options) {
		        // options:
		        // - pageWidth
		        // - pageHeight
		        // - fitWidth
		        // - hCenter
		        // - vCenter
		        var ncols = Math.ceil(layout.width / options.pageWidth);
		        var nrows = Math.ceil(layout.height / options.pageHeight);
		        var pageWidth = Math.ceil(options.pageWidth / layout.scale);
		        var pageHeight = Math.ceil(options.pageHeight / layout.scale);
	
		        for (var j = 0; j < nrows; ++j) {
		            for (var i = 0; i < ncols; ++i) {
		                addPage(j, i);
		            }
		        }
	
		        function addPage(row, col) {
		            var left = col * pageWidth;
		            var right = left + pageWidth;
		            var top = row * pageHeight;
		            var bottom = top + pageHeight;
		            var endbottom = 0, endright = 0;
	
		            // XXX: this can be optimized - discard cells that won't
		            // be used again, and don't walk cells that stand no
		            // chance to fit.
		            var cells = layout.cells.filter(function(cell){
		                if (cell.right <= left || cell.left >= right ||
		                    cell.bottom <= top || cell.top >= bottom) {
		                    return false;
		                }
		                endbottom = Math.max(cell.bottom, endbottom);
		                endright = Math.max(cell.right, endright);
		                return true;
		            });
	
		            // merged cells might stretch beyond page; limit to that
		            endbottom = Math.min(endbottom, bottom);
		            endright = Math.min(endright, right);
	
		            if (cells.length > 0) {
		                var page = new drawing.Group();
		                group.append(page);
		                // page.clip(drawing.Path.fromRect(
		                //     new geo.Rect([ 0, 0 ],
		                //                  [ options.pageWidth, options.pageHeight ])));
	
		                var content = new drawing.Group();
		                page.append(content);
	
		                content.clip(drawing.Path.fromRect(
		                    new geo.Rect([ left - 1, top - 1 ], [ endright + 1, endbottom + 1 ])
		                ));
	
		                var matrix = geo.Matrix.scale(layout.scale, layout.scale)
		                    .multiplyCopy(geo.Matrix.translate(-left, -top));
	
		                if (options.hCenter || options.vCenter) {
		                    matrix = matrix.multiplyCopy(
		                        geo.Matrix.translate(
		                            options.hCenter ? (right - endright) / 2 : 0,
		                            options.vCenter ? (bottom - endbottom) / 2 : 0)
		                    );
		                }
	
		                content.transform(matrix);
	
		                if (options.guidelines) {
		                    var prev = null;
		                    layout.xCoords.forEach(function(x){
		                        x = Math.min(x, endright);
		                        if (x !== prev && x >= left && x <= right) {
		                            prev = x;
		                            content.append(
		                                new drawing.Path()
		                                    .moveTo(x, top)
		                                    .lineTo(x, endbottom)
		                                    .close()
		                                    .stroke(options.guideColor, GUIDELINE_WIDTH)
		                            );
		                        }
		                    });
		                    var prev = null;
		                    layout.yCoords.forEach(function(y){
		                        y = Math.min(y, endbottom);
		                        if (y !== prev && y >= top && y <= bottom) {
		                            prev = y;
		                            content.append(
		                                new drawing.Path()
		                                    .moveTo(left, y)
		                                    .lineTo(endright, y)
		                                    .close()
		                                    .stroke(options.guideColor, GUIDELINE_WIDTH)
		                            );
		                        }
		                    });
		                }
	
		                var borders = Borders(); // jshint ignore: line
		                cells.forEach(function(cell){
		                    drawCell(cell, content, options);
		                    borders.add(cell, sheet);
		                });
	
		                var bordersGroup = new drawing.Group();
		                borders.vert.forEach(function(a){
		                    a.forEach(function(b){
		                        if (!b.rendered) {
		                            b.rendered = true;
		                            bordersGroup.append(
		                                new drawing.Path()
		                                    .moveTo(b.x, b.top)
		                                    .lineTo(b.x, b.bottom)
		                                    .close()
		                                    .stroke(b.color, b.size)
		                            );
		                        }
		                    });
		                });
		                borders.horiz.forEach(function(a){
		                    a.forEach(function(b){
		                        if (!b.rendered) {
		                            b.rendered = true;
		                            bordersGroup.append(
		                                new drawing.Path()
		                                    .moveTo(b.left, b.y)
		                                    .lineTo(b.right, b.y)
		                                    .close()
		                                    .stroke(b.color, b.size)
		                            );
		                        }
		                    });
		                });
		                content.append(bordersGroup);
		            }
		        }
		    }
	
		    function drawCell(cell, content, options) {
		        var g = new drawing.Group();
		        content.append(g);
		        var rect = new geo.Rect([ cell.left, cell.top ],
		                                [ cell.width, cell.height ]);
		        if (cell.background || cell.merged) {
		            var r2d2 = rect;
		            if (options.guidelines) {
		                r2d2 = rect.clone();
		                r2d2.origin.x += GUIDELINE_WIDTH/2 + 0.1;
		                r2d2.origin.y += GUIDELINE_WIDTH/2 + 0.1;
		                r2d2.size.width -= GUIDELINE_WIDTH + 0.2;
		                r2d2.size.height -= GUIDELINE_WIDTH + 0.2;
		            }
		            g.append(
		                new drawing.Rect(r2d2)
		                    .fill(cell.background || "#fff")
		                    .stroke(null)
		            );
		        }
		        var val = cell.value;
		        if (val != null) {
		            var type = typeof val == "number" ? "number" : null;
		            var clip = new drawing.Group();
		            clip.clip(drawing.Path.fromRect(rect));
		            g.append(clip);
		            var f;
		            if (cell.format) {
		                f = formatting.textAndColor(val, cell.format);
		                val = f.text;
		                if (f.type) {
		                    type = f.type;
		                }
		            } else {
		                val += "";
		            }
		            if (!cell.textAlign) {
		                switch (type) {
		                  case "number":
		                  case "date":
		                  case "percent":
		                  case "currency":
		                    cell.textAlign = "right";
		                    break;
		                  case "boolean":
		                    cell.textAlign = "center";
		                    break;
		                }
		            }
		            drawText(val, (f && f.color) || cell.color || "#000", cell, clip);
		        }
		    }
	
		    var CONT;
		    function drawText(text, color, cell, group) {
		        if (!CONT) {
		            CONT = document.createElement("div");
		            CONT.style.position = "absolute";
		            CONT.style.left = "0px";
		            CONT.style.top = "0px";
		            CONT.style.visibility = "hidden";
		            CONT.style.overflow = "hidden";
		            CONT.style.boxSizing = "border-box";
		            CONT.style.padding = "2px 4px";
		            CONT.style.lineHeight = "normal";
		            document.body.appendChild(CONT);
		        }
	
		        if (CONT.firstChild) {
		            CONT.removeChild(CONT.firstChild);
		        }
	
		        CONT.style.color = color;
		        CONT.style.font = makeFontDef(cell);
		        CONT.style.width = cell.width + "px";
		        CONT.style.textAlign = cell.textAlign || "left";
		        CONT.style.textDecoration = cell.underline ? "underline" : "none";
	
		        if (cell.wrap) {
		            CONT.style.whiteSpace = "pre-wrap";
		            CONT.style.overflowWrap = CONT.style.wordWrap = "break-word";
		        } else {
		            CONT.style.whiteSpace = "pre";
		            CONT.style.overflowWrap = CONT.style.wordWrap = "normal";
		        }
	
		        CONT.appendChild(document.createTextNode(text));
	
		        var vtrans = 0;
		        switch (cell.verticalAlign) {
		          case "center":
		            vtrans = (cell.height - CONT.offsetHeight) >> 1;
		            break;
	
		          case undefined:
		          case null:
		          case "bottom":
		            vtrans = (cell.height - CONT.offsetHeight);
		            break;
		        }
		        if (vtrans < 0) { vtrans = 0; }
	
		        var text_group  = kendo.drawing.drawDOM.drawText(CONT);
		        text_group.transform(geo.Matrix.translate(cell.left, cell.top + vtrans));
		        group.append(text_group);
		    }
	
		    function makeFontDef(cell) {
		        var font = [];
		        if (cell.italic) {
		            font.push("italic");
		        }
		        if (cell.bold) {
		            font.push("bold");
		        }
		        font.push((cell.fontSize || 12) + "px");
		        font.push((cell.fontFamily || "Arial"));
		        return font.join(" ");
		    }
	
		    function draw(sheet, range, options, callback) {
		        if (options == null && callback == null) {
		            callback = range;
		            options = {};
		            range = spreadsheet.SHEETREF;
		        }
		        if (callback == null) {
		            callback = options;
		            if (range instanceof spreadsheet.Range
		                || range instanceof spreadsheet.Ref
		                || typeof range == "string") {
		                options = {};
		            } else {
		                options = range;
		                range = spreadsheet.SHEETREF;
		            }
		        }
		        options = kendo.jQuery.extend({
		            paperSize  : "A4",
		            landscape  : true,
		            margin     : "1cm",
		            guidelines : true,
		            guideColor : "#aaa",
		            emptyCells : true,
		            fitWidth   : false,
		            center     : false,
		            headerRows : null,
		            maxEmpty   : 0.2,
		            scale      : 1
		        }, options);
		        var group = new drawing.Group();
		        var paper = kendo.pdf.getPaperOptions(options);
		        group.options.set("pdf", {
		            author    : options.author,
		            creator   : options.creator,
		            date      : options.date,
		            keywords  : options.keywords,
		            margin    : paper.margin,
		            multiPage : true,
		            paperSize : paper.paperSize,
		            subject   : options.subject,
		            title     : options.title
		        });
		        var pageWidth = paper.paperSize[0];
		        var pageHeight = paper.paperSize[1];
		        if (paper.margin) {
		            pageWidth -= paper.margin.left + paper.margin.right + 1;
		            pageHeight -= paper.margin.top + paper.margin.bottom + 1;
		        }
		        options.pageWidth = pageWidth;
		        options.pageHeight = pageHeight;
		        var layout = doLayout(sheet, sheet._ref(range), options);
		        drawLayout(sheet, layout, group, options);
		        callback(group);
		    }
	
		    spreadsheet.Sheet.prototype.draw = function(range, options, callback) {
		        var sheet = this;
		        if (sheet._workbook) {
		            sheet.recalc(sheet._workbook._context, function(){
		                draw(sheet, range, options, callback);
		            });
		        } else {
		            draw(sheet, range, options, callback);
		        }
		    };
	
		    // Hack: since we index the border arrays by relative row/col we
		    // could end up with negative indexes, i.e. horiz[-2] = border.
		    // Array forEach will ignore these, so we provide a simple
		    // container here (outside code only needs forEach at this time).
		    function Container() {}
		    Container.prototype = {
		        forEach: function(f) {
		            Object.keys(this).forEach(function(key){
		                f(this[key], key, this);
		            }, this);
		        }
		    };
	
		    function Borders() {
		        var horiz = new Container();
		        var vert = new Container();
		        function add(cell, sheet) {
		            if (sheet) {
		                // reset borders here; the propertybag doesn't keep track of merged cells :-/ this
		                // is ugly, but the inner details of data storage have leaked everywhere anyway.
		                var pb = sheet._properties;
		                var grid = sheet._grid;
		                cell.borderLeft    = pb.get("vBorders", grid.index(cell.row, cell.col));
		                cell.borderRight   = pb.get("vBorders", grid.index(cell.row, cell.col + cell.colspan));
		                cell.borderTop     = pb.get("hBorders", grid.index(cell.row, cell.col));
		                cell.borderBottom  = pb.get("hBorders", grid.index(cell.row + cell.rowspan, cell.col));
		            }
		            if (cell.borderLeft) {
		                addVert(cell.row, cell.col, cell.borderLeft,
		                        cell.left, cell.top, cell.bottom);
		            }
		            if (cell.borderRight) {
		                addVert(cell.row, cell.col + cell.colspan, cell.borderRight,
		                        cell.right, cell.top, cell.bottom);
		            }
		            if (cell.borderTop) {
		                addHoriz(cell.row, cell.col, cell.borderTop,
		                         cell.top, cell.left, cell.right);
		            }
		            if (cell.borderBottom) {
		                addHoriz(cell.row + cell.rowspan, cell.col, cell.borderBottom,
		                         cell.bottom, cell.left, cell.right);
		            }
		        }
		        function addVert(row, col, border, x, top, bottom) {
		            var a = vert[col] || (vert[col] = new Container());
		            var prev = row > 0 && a[row - 1];
		            if (prev && sameBorder(prev, border)) {
		                a[row] = prev;
		                prev.bottom = bottom;
		            } else {
		                a[row] = {
		                    size: border.size,
		                    color: border.color,
		                    x: x,
		                    top: top,
		                    bottom: bottom
		                };
		            }
		        }
		        function addHoriz(row, col, border, y, left, right) {
		            var a = horiz[row] || (horiz[row] = new Container());
		            var prev = col > 0 && a[col - 1];
		            if (prev && sameBorder(prev, border)) {
		                a[col] = prev;
		                prev.right = right;
		            } else {
		                a[col] = {
		                    size: border.size,
		                    color: border.color,
		                    y: y,
		                    left: left,
		                    right: right
		                };
		            }
		        }
		        return { add: add, horiz: horiz, vert: vert };
		    }
	
		    function drawTabularData(options) {
		        var progress = new $.Deferred();
		        var promise = progress.promise();
	
		        options = clone(options, {
		            dataSource       : null,
		            guidelines       : true,
		            guideColor       : "#000",
		            columns          : null,
		            headerBackground : "#999",
		            headerColor      : "#000",
		            oddBackground    : null,
		            evenBackground   : null,
		            fontFamily       : "Arial",
		            fontSize         : 12,
		            paperSize        : "A4",
		            margin           : "1cm",
		            landscape        : true,
		            fitWidth         : false,
		            scale            : 1,
		            rowHeight        : 20,
		            maxEmpty         : 1,
		            useGridFormat    : true
		        });
	
		        // retrieve fonts; custom fonts should be already loaded
		        kendo.drawing.pdf.defineFont(
		            kendo.drawing.drawDOM.getFontFaces(document)
		        );
	
		        var charWidth = charWidthFunction(options.fontFamily, options.fontSize);
	
		        function textWidth(value) {
		            if (value != null) {
		                var width = 12;         // magic numbers :-/
		                for (var i = value.length; --i >= 0;) {
		                    width += charWidth(value.charAt(i));
		                }
		                return width;
		            }
		            return 0;
		        }
	
		        var border = options.guidelines ? { size: 1, color: options.guideColor } : null;
	
		        function mkCell(data) {
		            if (!border) {
		                return data;
		            }
		            return clone(data, {
		                borderLeft: border,
		                borderTop: border,
		                borderRight: border,
		                borderBottom: border
		            });
		        }
	
		        options.dataSource.fetch(function(){
		            var data = options.dataSource.data();
		            if (!data.length) {
		                return progress.reject("Empty dataset");
		            }
	
		            // this really must be present
		            var columns = options.columns.map(function(col){
		                if (typeof col == "string") {
		                    return { title: col, field: col };
		                } else {
		                    return col;
		                }
		            });
		            var columnTitles = columns.map(function(col){
		                return col.title || col.field;
		            });
		            var columnWidths = columnTitles.map(textWidth);
	
		            // prepare data for a Sheet object's fromJSON method
		            var rows = data.map(function(row, rowIndex){
		                return {
		                    cells: columns.map(function(col, colIndex){
		                        var value = row[col.field];
	
		                        // NOTE: value might not be string.  I added option useGridFormat (default
		                        // true), which will use a column's format, if present, to convert the value
		                        // to a string, so that we can measure the width right now.
		                        if (options.useGridFormat) {
		                            if (value != null) {
		                                if (col.format) {
		                                    value = kendo.format(col.format, value);
		                                } else {
		                                    value += "";
		                                }
		                            }
		                            // adjust the column widths while we're at it
		                            columnWidths[colIndex] = Math.max(
		                                textWidth(value),
		                                columnWidths[colIndex]
		                            );
		                        }
	
		                        // if options.useGridFormat is false and col.format is present, pass it over
		                        // to the spreadsheet.  In that case we should calculate the widths after
		                        // the spreadsheet is created (XXX to be implemented when someone needs it).
		                        return mkCell({
		                            value: value,
		                            format: options.useGridFormat ? null : col.format,
		                            background: rowIndex % 2 ? options.evenBackground : options.oddBackground
		                        });
		                    })
		                };
		            });
	
		            // insert header line
		            rows.unshift({
		                cells: columnTitles.map(function(label){
		                    return mkCell({
		                        value: label,
		                        background: options.headerBackground,
		                        color: options.headerColor
		                    });
		                })
		            });
	
		            // init a Sheet object.  Note that we have to add one
		            // extra-row and column, because the very last ones can't
		            // have right/bottom borders (known limitation).
		            var sheet = new kendo.spreadsheet.Sheet(
		                rows.length + 1,        // rows
		                columns.length + 1,     // columns
		                options.rowHeight,      // row height
		                50,                     // column width
		                20,                     // header height
		                20,                     // header width,
		                {                       // default cell style
		                    fontFamily: options.fontFamily,
		                    fontSize: options.fontSize,
		                    verticalAlign: "center"
		                }
		            );
	
		            // load data
		            sheet.fromJSON({
		                name: "Sheet1",
		                rows: rows,
		                columns: columnWidths.map(function(w, i){
		                    return { index: i, width: w };
		                })
		            });
	
		            sheet.draw({
		                paperSize  : options.paperSize,
		                landscape  : options.landscape,
		                margin     : options.margin,
		                guidelines : false, // using borders instead (better contrast)
		                scale      : options.scale,
		                fitWidth   : options.fitWidth,
		                maxEmpty   : options.maxEmpty,
		                headerRows : 1
		            }, progress.resolve.bind(progress));
		        });
	
		        return promise;
		    }
	
		    var CACHE_CHAR_WIDTH = {};
	
		    var charWidthFunction = function(fontFamily, fontSize) {
		        var id = fontSize + ":" + fontFamily;
		        var func = CACHE_CHAR_WIDTH[id];
		        if (!func) {
		            var span, div = document.createElement("div");
		            div.style.position = "fixed";
		            div.style.left = "-10000px";
		            div.style.top = "-10000px";
		            div.style.fontFamily = fontFamily;
		            div.style.fontSize = fontSize + "px";
		            div.style.whiteSpace = "pre";
		            for (var i = 32; i < 128; ++i) {
		                span = document.createElement("span");
		                span.appendChild(document.createTextNode(String.fromCharCode(i)));
		                div.appendChild(span);
		            }
		            document.body.appendChild(div);
		            var widths = {};
		            for (i = 32, span = div.firstChild; i < 128 && span; ++i, span = span.nextSibling) {
		                widths[i] = span.offsetWidth;
		            }
		            while ((span = div.firstChild)) {
		                div.removeChild(span);
		            }
		            func = CACHE_CHAR_WIDTH[id] = function(ch) {
		                var code = ch.charCodeAt(0);
		                var width = widths[code];
		                if (width == null) {
		                    // probably not an ASCII character, let's cache its width as well
		                    span = document.createElement("span");
		                    span.appendChild(document.createTextNode(String.fromCharCode(code)));
		                    div.appendChild(span);
		                    width = widths[code] = span.offsetWidth;
		                    div.removeChild(span);
		                }
		                return width;
		            };
		        }
		        return func;
		    };
	
		    spreadsheet.draw = {
		        Borders         : Borders,
		        doLayout        : doLayout
		    };
	
		    spreadsheet.drawTabularData = drawTabularData;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1489:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(610);
	
	/***/ }),
	
	/***/ 1490:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(728);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1264);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1001:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(560);
	
	/***/ }),
	
	/***/ 1264:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1001) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "pivot.configurator",
		    name: "PivotConfigurator",
		    category: "web",
		    depends: [ "dropdownlist", "treeview", "pivot.fieldmenu" ],
		    hidden: true
		};
	
		/*jshint eqnull: true*/
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.ui,
		        Widget = ui.Widget,
		        ns = ".kendoPivotConfigurator",
		        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
		        SETTING_CONTAINER_TEMPLATE = kendo.template('<p class="k-reset"><span class="k-icon #=icon#"></span>${name}</p>' +
		                '<div class="k-list-container k-reset"/>');
	
		    function addKPI(data) {
		        var found;
		        var idx = 0;
		        var length = data.length;
	
		        for (; idx < length; idx++) {
		            if (data[idx].type == 2) {
		                found = true;
		                break;
		            }
		        }
	
		        if (found) {
		            data.splice(idx + 1, 0, {
		                caption: "KPIs",
		                defaultHierarchy: "[KPIs]",
		                name: "KPIs",
		                uniqueName: "[KPIs]"
		            });
		        }
		    }
	
		    function kpiNode(node) {
		        return {
		            name: node.uniqueName,
		            type: node.type
		        };
		    }
	
		    function normalizeKPIs(data) {
		        for (var idx = 0, length = data.length; idx < length; idx++) {
		            data[idx].uniqueName = data[idx].name;
		            data[idx].type = "kpi";
		        }
	
		        return data;
		    }
	
		    function settingTargetFromNode(node) {
		        var target = $(node).closest(".k-pivot-setting");
	
		        if (target.length) {
		            return target.data("kendoPivotSettingTarget");
		        }
		        return null;
		    }
	
		    var PivotConfigurator = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
	
		            this.element.addClass("k-widget k-fieldselector k-alt k-edit-form-container");
	
		            this._dataSource();
	
		            this._layout();
	
		            this.refresh();
	
		            kendo.notify(this);
		        },
	
		        events: [],
	
		        options: {
		            name: "PivotConfigurator",
		            filterable: false,
		            sortable: false,
		            messages: {
		                measures: "Drop Data Fields Here",
		                columns: "Drop Column Fields Here",
		                rows: "Drop Rows Fields Here",
		                measuresLabel: "Measures",
		                columnsLabel: "Columns",
		                rowsLabel: "Rows",
		                fieldsLabel: "Fields"
		            }
		        },
	
		        _dataSource: function() {
		            var that = this;
	
		            if (that.dataSource && that._refreshHandler) {
		                that.dataSource.unbind("change", that._refreshHandler)
		                               .unbind("error", that._errorHandler)
		                               .unbind("progress", that._progressHandler);
		            } else {
		                that._errorHandler = $.proxy(that._error, that);
		                that._refreshHandler = $.proxy(that.refresh, that);
		                that._progressHandler = $.proxy(that._requestStart, that);
		            }
	
		            that.dataSource = kendo.data.PivotDataSource.create(that.options.dataSource);
		            that.dataSource.bind("change", that._refreshHandler)
		                           .bind("error", that._errorHandler)
		                           .bind("progress", that._progressHandler);
		        },
	
		        setDataSource: function(dataSource) {
		            this.options.dataSource = dataSource;
	
		            this._dataSource();
	
		            if (this.measures) {
		                this.measures.setDataSource(dataSource);
		            }
	
		            if (this.rows) {
		                this.rows.setDataSource(dataSource);
		            }
	
		            if (this.columns) {
		                this.columns.setDataSource(dataSource);
		            }
	
		            this.refresh();
		        },
	
		        _treeViewDataSource: function() {
		            var that = this;
	
		            return kendo.data.HierarchicalDataSource.create({
		                schema: {
		                    model: {
		                        id: "uniqueName",
		                        hasChildren: function(item) {
		                            return !("hierarchyUniqueName" in item) && !("aggregator" in item);
		                        }
		                    }
		                },
		                transport: {
		                    read: function(options) {
		                        var promise;
		                        var node;
		                        var kpi;
	
		                        if ($.isEmptyObject(options.data)) {
		                            promise = that.dataSource.schemaDimensions();
	
		                            promise.done(function(data) {
		                                        if (!that.dataSource.cubeBuilder) {
		                                            addKPI(data);
		                                        }
		                                        options.success(data);
		                                    })
		                                    .fail(options.error);
		                        } else {
		                            //Hack to get the actual node as the HierarchicalDataSource does not support passing it
		                            node = that.treeView.dataSource.get(options.data.uniqueName);
	
		                            if (node.uniqueName === "[KPIs]") {
		                                kpi = true;
		                                promise = that.dataSource.schemaKPIs();
		                                promise.done(function (data) {
		                                            options.success(normalizeKPIs(data));
		                                       })
		                                       .fail(options.error);
		                            } else if (node.type == "kpi") {
		                                kpi = true;
		                                options.success(buildKPImeasures(node));
		                            }
	
		                            if (!kpi) {
		                                if (node.type == 2) { //measure
		                                    promise = that.dataSource.schemaMeasures();
		                                } else if (node.dimensionUniqueName) { // hierarchy
		                                    promise = that.dataSource.schemaLevels(options.data.uniqueName);
		                                } else { // dimension
		                                    promise = that.dataSource.schemaHierarchies(options.data.uniqueName);
		                                }
	
		                                promise.done(options.success)
		                                        .fail(options.error);
		                            }
		                        }
		                    }
		                }
		            });
		        },
	
		        _progress: function(toggle) {
		            kendo.ui.progress(this.element, toggle);
		        },
	
		        _error: function() {
		            this._progress(false);
		        },
	
		        _requestStart: function() {
		            this._progress(true);
		        },
	
		        _layout: function() {
		            this.form = $('<div class="k-columns k-state-default k-floatwrap"/>').appendTo(this.element);
		            this._fields();
		            this._targets();
		        },
	
		        _fields: function() {
		            var container = $('<div class="k-state-default"><p class="k-reset"><span class="k-icon k-i-group"></span>' + this.options.messages.fieldsLabel + '</p></div>').appendTo(this.form);
	
		            var template = '# if (item.type == 2 || item.uniqueName == "[KPIs]") { #' +
		                           '<span class="k-icon k-i-#= (item.type == 2 ? \"sum\" : \"kpi\") #"></span>' +
		                           '# } else if (item.type && item.type !== "kpi") { #' +
		                           '<span class="k-icon k-i-arrows-dimensions"></span>' +
		                           '# } #' +
		                           '#: item.caption || item.name #';
	
		            this.treeView = $("<div/>").appendTo(container)
		                .kendoTreeView({
		                    template: template,
		                    dataTextField: "caption",
		                    dragAndDrop: true,
		                    autoBind: false,
		                    dataSource: this._treeViewDataSource(),
		                    dragstart: function(e) {
		                        var dataItem = this.dataItem(e.sourceNode);
		                        if ((!dataItem.hasChildren && !dataItem.aggregator && !dataItem.measure) || (dataItem.type == 2) || dataItem.uniqueName === "[KPIs]") {
		                            e.preventDefault();
		                        }
		                    },
		                    drag: function(e) {
		                        var status = "k-i-cancel";
	
		                        var setting = settingTargetFromNode(e.dropTarget);
		                        if (setting && setting.validate(this.dataItem(e.sourceNode))) {
		                            status = "k-i-plus";
		                        }
	
		                        e.setStatusClass(status);
		                    },
		                    drop: function(e) {
		                        e.preventDefault();
	
		                        var setting = settingTargetFromNode(e.dropTarget);
		                        var node = this.dataItem(e.sourceNode);
		                        var idx, length, measures;
		                        var name;
	
		                        if (setting && setting.validate(node)) {
		                            name = node.defaultHierarchy || node.uniqueName;
	
		                            if (node.type === "kpi") {
		                                measures = buildKPImeasures(node);
		                                length = measures.length;
		                                name = [];
	
		                                for (idx = 0; idx < length; idx++) {
		                                    name.push(kpiNode(measures[idx]));
		                                }
		                            } else if (node.kpi) {
		                                name = [kpiNode(node)];
		                            }
	
		                            setting.add(name);
		                        }
		                    }
		                 })
		                .data("kendoTreeView");
		        },
	
		        _createTarget: function(element, options) {
		            var template = '<li class="k-item k-header" data-' + kendo.ns + 'name="${data.name}">${data.name}';
		            var sortable = options.sortable;
		            var icons = "";
	
		            if (sortable) {
		                icons += '#if (data.sortIcon) {#';
		                icons += '<span class="k-icon ${data.sortIcon}-sm"></span>';
		                icons += '#}#';
		            }
	
		            if (options.filterable || sortable) {
		                icons += '<span class="k-icon k-i-more-vertical k-setting-fieldmenu"></span>';
		            }
	
		            icons += '<span class="k-icon k-i-close k-setting-delete"></span>';
		            template += '<span class="k-field-actions">' + icons + '</span></li>';
	
		            return new kendo.ui.PivotSettingTarget(element, $.extend({
		                dataSource: this.dataSource,
		                hint: function(element) {
		                    var wrapper = $('<div class="k-fieldselector"><ul class="k-list k-reset"></ul></div>');
	
		                    wrapper.find(".k-list").append(element.clone());
	
		                    return wrapper;
		                },
		                template: template,
		                emptyTemplate: '<li class="k-item k-empty">${data}</li>'
		            }, options));
		        },
	
		        _targets: function() {
		            var container = $('<div class="k-state-default"/>').appendTo(this.form);
	
		            var columnsContainer = $(SETTING_CONTAINER_TEMPLATE({ name: this.options.messages.columnsLabel, icon: "k-i-columns" })).appendTo(container);
		            var columns = $('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(columnsContainer.last());
	
		            var rowsContainer = $(SETTING_CONTAINER_TEMPLATE({ name: this.options.messages.rowsLabel, icon: "k-i-rows" })).appendTo(container);
		            var rows = $('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(rowsContainer.last());
	
		            var measuresContainer = $(SETTING_CONTAINER_TEMPLATE({ name: this.options.messages.measuresLabel, icon: "k-i-sum"})).appendTo(container);
		            var measures = $('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(measuresContainer.last());
	
		            var options = this.options;
	
		            this.columns = this._createTarget(columns, {
		                filterable: options.filterable,
		                sortable: options.sortable,
		                connectWith: rows,
		                messages: {
		                    empty: options.messages.columns,
		                    fieldMenu: options.messages.fieldMenu
		                }
		            });
	
		            this.rows = this._createTarget(rows, {
		                filterable: options.filterable,
		                sortable: options.sortable,
		                setting: "rows",
		                connectWith: columns,
		                messages: {
		                    empty: this.options.messages.rows,
		                    fieldMenu: this.options.messages.fieldMenu
		                }
		            });
	
		            this.measures = this._createTarget(measures, {
		                setting: "measures",
		                messages: {
		                    empty: options.messages.measures
		                }
		            });
	
		            columns
		                .add(rows)
		                .add(measures)
		                .on(HOVEREVENTS, ".k-item:not(.k-empty)", this._toggleHover);
		        },
	
		        _toggleHover: function(e) {
		            $(e.currentTarget).toggleClass("k-state-hover", e.type === "mouseenter");
		        },
	
		        _resize: function() {
		            var element = this.element;
		            var height = this.options.height;
		            var border, fields;
		            var outerHeight = kendo._outerHeight;
	
		            if (!height) {
		                return;
		            }
	
		            element.height(height);
	
		            if (element.is(":visible")) {
		                fields = element.children(".k-columns")
		                                .children("div.k-state-default");
	
		                height = element.innerHeight();
	
		                border = (outerHeight(element) - height) / 2;
		                height = height - (outerHeight(fields, true) - fields.height()) - border;
	
		                fields.height(height);
		            }
		        },
	
		        refresh: function() {
		            var dataSource = this.dataSource;
	
		            if (dataSource.cubeBuilder || this._cube !== dataSource.cube() || this._catalog !== dataSource.catalog()) {
		                this.treeView.dataSource.fetch();
		            }
	
		            this._catalog = this.dataSource.catalog();
		            this._cube = this.dataSource.cube();
	
		            this._resize();
	
		            this._progress(false);
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
	
		            this.dataSource.unbind("change", this._refreshHandler);
	
		            this.form.find(".k-list").off(ns);
	
		            this.rows.destroy();
		            this.columns.destroy();
		            this.measures.destroy();
		            this.treeView.destroy();
	
		            this.element = null;
		            this._refreshHandler = null;
		        }
		    });
	
		    function kpiMeasure(name, measure, type) {
		        return {
		            hierarchyUniqueName: name,
		            uniqueName: measure,
		            caption: measure,
		            measure: measure,
		            name: measure,
		            type: type,
		            kpi: true
		        };
		    }
	
		    function buildKPImeasures(node) {
		        var name = node.name;
		        return [
		            kpiMeasure(name, node.value, "value"),
		            kpiMeasure(name, node.goal, "goal"),
		            kpiMeasure(name, node.status, "status"),
		            kpiMeasure(name, node.trend, "trend")
		        ];
		    }
	
		    ui.plugin(PivotConfigurator);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1052);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1000:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1047:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(564);
	
	/***/ }),
	
	/***/ 1048:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(565);
	
	/***/ }),
	
	/***/ 1052:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1004),
		        __webpack_require__(1054),
		        __webpack_require__(1055),
		        __webpack_require__(1056),
		        __webpack_require__(1047),
		        __webpack_require__(1048),
		        __webpack_require__(1013),
		        __webpack_require__(1057),
		        __webpack_require__(1058),
		        __webpack_require__(1038),
		        __webpack_require__(1059),
		        __webpack_require__(1022),
		        __webpack_require__(1036),
		        __webpack_require__(1053),
		        __webpack_require__(1000),
		        __webpack_require__(1060),
		        __webpack_require__(1061),
		        __webpack_require__(1062),
		        __webpack_require__(1063),
		        __webpack_require__(1064),
		        __webpack_require__(1065),
		        __webpack_require__(1066),
		        __webpack_require__(1067),
		        __webpack_require__(1068),
		        __webpack_require__(1069),
		        __webpack_require__(1070),
		        __webpack_require__(1071)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "bundle all";
		    return window.kendo;
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1053:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(582);
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1055:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(583);
	
	/***/ }),
	
	/***/ 1056:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(584);
	
	/***/ }),
	
	/***/ 1057:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(586);
	
	/***/ }),
	
	/***/ 1058:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1060:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 1061:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(745);
	
	/***/ }),
	
	/***/ 1062:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(749);
	
	/***/ }),
	
	/***/ 1063:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(752);
	
	/***/ }),
	
	/***/ 1064:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(755);
	
	/***/ }),
	
	/***/ 1065:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(756);
	
	/***/ }),
	
	/***/ 1066:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(757);
	
	/***/ }),
	
	/***/ 1067:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(760);
	
	/***/ }),
	
	/***/ 1068:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(763);
	
	/***/ }),
	
	/***/ 1069:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(776);
	
	/***/ }),
	
	/***/ 1070:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(783);
	
	/***/ }),
	
	/***/ 1071:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(587);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1076);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1076:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1077),
		        __webpack_require__(1078)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.core",
		    name: "Core",
		    description: "The DataViz core functions",
		    category: "dataviz",
		    depends: [ "core", "drawing" ],
		    hidden: true
		};
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 1077:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(743);
	
	/***/ }),
	
	/***/ 1078:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(744);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(866);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 862:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 866:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(862),
		        __webpack_require__(859)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
		/* jshint curly:false */
	
		window.kendo.dataviz = window.kendo.dataviz || {};
		var drawing = kendo.drawing;
		var util = drawing.util;
		var Path = drawing.Path;
		var Group = drawing.Group;
		var Class = kendo.Class;
		var geometry = kendo.geometry;
		var Rect = geometry.Rect;
		var Circle = geometry.Circle;
		var geometryTransform = geometry.transform;
		var Segment = geometry.Segment;
		var dataviz = kendo.dataviz;
	
		var deepExtend = kendo.deepExtend;
		var isFunction = kendo.isFunction;
		var __common_getter_js = kendo.getter;
	
		var ARC = "arc";
		var AXIS_LABEL_CLICK = "axisLabelClick";
		var BLACK = "#000";
		var BOTTOM = "bottom";
		var CENTER = "center";
		var CIRCLE = "circle";
		var COORD_PRECISION = 3;
		var CROSS = "cross";
		var DATE = "date";
		var DEFAULT_FONT = "12px sans-serif";
		var DEFAULT_HEIGHT = 400;
		var DEFAULT_PRECISION = 10;
		var DEFAULT_WIDTH = 600;
		var END = "end";
		var FORMAT_REGEX = /\{\d+:?/;
		var HEIGHT = "height";
		var HIGHLIGHT_ZINDEX = 100;
		var INSIDE = "inside";
		var LEFT = "left";
		var MAX_VALUE = Number.MAX_VALUE;
		var MIN_VALUE = -Number.MAX_VALUE;
		var NONE = "none";
		var NOTE_CLICK = "noteClick";
		var NOTE_HOVER = "noteHover";
		var NOTE_LEAVE = "noteLeave";
		var OBJECT = "object";
		var OUTSIDE = "outside";
		var RIGHT = "right";
		var START = "start";
		var STRING = "string";
		var TOP = "top";
		var TRIANGLE = "triangle";
		var VALUE = "value";
		var WHITE = "#fff";
		var WIDTH = "width";
		var X = "x";
		var Y = "y";
	
		var constants = {
			ARC: ARC,
			AXIS_LABEL_CLICK: AXIS_LABEL_CLICK,
			BLACK: BLACK,
			BOTTOM: BOTTOM,
			CENTER: CENTER,
			CIRCLE: CIRCLE,
			COORD_PRECISION: COORD_PRECISION,
			CROSS: CROSS,
			DATE: DATE,
			DEFAULT_FONT: DEFAULT_FONT,
			DEFAULT_HEIGHT: DEFAULT_HEIGHT,
			DEFAULT_PRECISION: DEFAULT_PRECISION,
			DEFAULT_WIDTH: DEFAULT_WIDTH,
			END: END,
			FORMAT_REGEX: FORMAT_REGEX,
			HEIGHT: HEIGHT,
			HIGHLIGHT_ZINDEX: HIGHLIGHT_ZINDEX,
			INSIDE: INSIDE,
			LEFT: LEFT,
			MAX_VALUE: MAX_VALUE,
			MIN_VALUE: MIN_VALUE,
			NONE: NONE,
			NOTE_CLICK: NOTE_CLICK,
			NOTE_HOVER: NOTE_HOVER,
			NOTE_LEAVE: NOTE_LEAVE,
			OBJECT: OBJECT,
			OUTSIDE: OUTSIDE,
			RIGHT: RIGHT,
			START: START,
			STRING: STRING,
			TOP: TOP,
			TRIANGLE: TRIANGLE,
			VALUE: VALUE,
			WHITE: WHITE,
			WIDTH: WIDTH,
			X: X,
			Y: Y
		};
	
		function isArray(value) {
		    return Array.isArray(value);
		}
	
		function addClass(element, classes) {
		    var classArray = isArray(classes) ? classes : [ classes ];
	
		    for (var idx = 0; idx < classArray.length; idx++) {
		        var className = classArray[idx];
		        if (element.className.indexOf(className) === -1) {
		            element.className += " " + className;
		        }
		    }
		}
	
		var SPACE_REGEX = /\s+/g;
	
		function removeClass(element, className) {
		    if (element && element.className) {
		        element.className = element.className.replace(className, "").replace(SPACE_REGEX, " ");
		    }
		}
	
		function alignPathToPixel(path) {
		    var offset = 0.5;
		    if (path.options.stroke && kendo.drawing.util.defined(path.options.stroke.width)) {
		        if (path.options.stroke.width % 2 === 0) {
		            offset = 0;
		        }
		    }
	
		    for (var i = 0; i < path.segments.length; i++) {
		        path.segments[i].anchor().round(0).translate(offset, offset);
		    }
	
		    return path;
		}
	
		function clockwise(angle1, angle2) {
		    // True if angle2 is clockwise of angle1
		    // assuming angles grow in clock-wise direction
		    // (as in the pie and radar charts)
		    return -angle1.x * angle2.y + angle1.y * angle2.x < 0;
		}
	
		function isNumber(value) {
		    return typeof value === "number" && !isNaN(value);
		}
	
		function isString(value) {
		    return typeof value === STRING;
		}
	
		function convertableToNumber(value) {
		    return isNumber(value) || (isString(value) && isFinite(value));
		}
	
		function isObject(value) {
		    return typeof value === "object";
		}
	
		function styleValue(value) {
		    if (isNumber(value)) {
		        return value + "px";
		    }
		    return value;
		}
	
		var SIZE_STYLES_REGEX = /width|height|top|left|bottom|right/i;
	
		function isSizeField(field) {
		    return SIZE_STYLES_REGEX.test(field);
		}
	
		function elementStyles(element, styles) {
		    var stylesArray = isString(styles) ? [ styles ] : styles;
	
		    if (isArray(stylesArray)) {
		        var result = {};
		        var style = window.getComputedStyle(element);
	
		        for (var idx = 0; idx < stylesArray.length; idx++) {
		            var field = stylesArray[idx];
		            result[field] = isSizeField(field) ? parseFloat(style[field]) : style[field];
		        }
	
		        return result;
		    } else if (isObject(styles)) {
		        for (var field$1 in styles) {
		            element.style[field$1] = styleValue(styles[field$1]);
		        }
		    }
		}
	
		function getSpacing(value, defaultSpacing) {
		    if (defaultSpacing === void 0) { defaultSpacing = 0; }
	
		    var spacing = { top: 0, right: 0, bottom: 0, left: 0 };
	
		    if (typeof(value) === "number") {
		        spacing[TOP] = spacing[RIGHT] = spacing[BOTTOM] = spacing[LEFT] = value;
		    } else {
		        spacing[TOP] = value[TOP] || defaultSpacing;
		        spacing[RIGHT] = value[RIGHT] || defaultSpacing;
		        spacing[BOTTOM] = value[BOTTOM] || defaultSpacing;
		        spacing[LEFT] = value[LEFT] || defaultSpacing;
		    }
	
		    return spacing;
		}
	
		var defaultImplementation = {
		    format: function (format, value) { return value; },
	
		    toString: function (value) { return value; },
	
		    parseDate: function (value) { return new Date(value); }
		};
	
		var current = defaultImplementation;
	
		var IntlService = Class.extend({
	
		});
	
		IntlService.register = function(userImplementation) {
		    current = userImplementation;
		};
	
		if (Object.defineProperties) {
		    Object.defineProperties(IntlService, {
		        implementation: {
		            get: function() {
		                return current;
		            }
		        }
		    });
		}
	
		var FORMAT_REPLACE_REGEX = /\{(\d+)(:[^\}]+)?\}/g;
	
		var FormatService = Class.extend({
		    init: function(intlService) {
		        this._intlService = intlService;
		    },
	
		    auto: function(formatString) {
		        var values = [], len = arguments.length - 1;
		        while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
	
		        var intl = this.intl;
	
		        if (isString(formatString) && formatString.match(FORMAT_REGEX)) {
		            return intl.format.apply(intl, [ formatString ].concat( values ));
		        }
	
		        return intl.toString(values[0], formatString);
		    },
	
		    localeAuto: function(formatString, values, locale) {
		        var intl = this.intl;
		        var result;
	
		        if (isString(formatString) && formatString.match(FORMAT_REGEX)) {
		            result = formatString.replace(FORMAT_REPLACE_REGEX, function(match, index, placeholderFormat) {
		                var value = values[parseInt(index, 10)];
	
		                return intl.toString(value, placeholderFormat ? placeholderFormat.substring(1) : "", locale);
		            });
		        } else {
		            result = intl.toString(values[0], formatString, locale);
		        }
	
		        return result;
		    }
		});
	
		if (Object.defineProperties) {
		    Object.defineProperties(FormatService.fn, {
		        intl: {
		            get: function() {
		                return this._intlService || IntlService.implementation;
		            },
		            set: function(value) {
		                this._intlService = value;
		            }
		        }
		    });
		}
	
		var ChartService = Class.extend({
		    init: function(chart, context) {
		        if (context === void 0) { context = {}; }
	
		        this._intlService = context.intlService;
		        this.sender = context.sender || chart;
		        this.format = new FormatService(context.intlService);
		        this.chart = chart;
		        this.rtl = Boolean(context.rtl);
		    },
	
		    notify: function(name, args) {
		        if (this.chart) {
		            this.chart.trigger(name, args);
		        }
		    },
	
		    isPannable: function(axis) {
		        var pannable = ((this.chart || {}).options || {}).pannable;
		        return pannable && pannable.lock !== axis;
		    }
		});
	
		if (Object.defineProperties) {
		    Object.defineProperties(ChartService.fn, {
		        intl: {
		            get: function() {
		                return this._intlService || IntlService.implementation;
		            },
		            set: function(value) {
		                this._intlService = value;
		                this.format.intl = value;
		            }
		        }
		    });
		}
	
		var current$1;
	
		var DomEventsBuilder = Class.extend({
	
		});
	
		DomEventsBuilder.register = function(userImplementation) {
		    current$1 = userImplementation;
		};
	
		DomEventsBuilder.create = function(element, events) {
		    if (current$1) {
		        return current$1.create(element, events);
		    }
		};
	
		var current$2 = {
		    compile: function(template) {
		        return template;
		    }
		};
	
		var TemplateService = Class.extend({
	
		});
	
		TemplateService.register = function(userImplementation) {
		    current$2 = userImplementation;
		};
	
		TemplateService.compile = function(template) {
		    return current$2.compile(template);
		};
	
		var services = {
			ChartService: ChartService,
			DomEventsBuilder: DomEventsBuilder,
			FormatService: FormatService,
			IntlService: IntlService,
			TemplateService: TemplateService
		};
	
		function getTemplate(options) {
		    if (options === void 0) { options = {}; }
	
		    var template;
		    if (options.template) {
		        options.template = template = TemplateService.compile(options.template);
		    } else if (isFunction(options.content)) {
		        template = options.content;
		    }
	
		    return template;
		}
	
		function grep(array, callback) {
		    var length = array.length;
		    var result = [];
		    for (var idx = 0; idx < length; idx++) {
		        if (callback(array[idx])) {
		            result .push(array[idx]);
		        }
		    }
	
		    return result;
		}
	
		function hasClasses(element, classNames) {
		    if (element.className) {
		        var names = classNames.split(" ");
		        for (var idx = 0; idx < names.length; idx++) {
		            if (element.className.indexOf(names[idx]) !== -1) {
		                return true;
		            }
		        }
		    }
		}
	
		var HashMap = function HashMap() {
		    this._map = {};
		};
	
		HashMap.prototype.get = function get (name) {
		    return this._map[this._key(name)];
		};
	
		HashMap.prototype.set = function set (name, value) {
		    this._map[this._key(name)] = value;
		};
	
		HashMap.prototype._key = function _key (name) {
		    return name instanceof Date ? name.getTime() : name;
		};
	
		function inArray(value, array) {
		    if (array) {
		        return array.indexOf(value) !== -1;
		    }
		}
	
		function interpolateValue(start, end, progress) {
		    return kendo.drawing.util.round(start + (end - start) * progress, COORD_PRECISION);
		}
	
		var TRIGGER = 'trigger';
	
		var InstanceObserver = Class.extend({
		    init: function(observer, handlers) {
		        this.observer = observer;
		        this.handlerMap = deepExtend({}, this.handlerMap, handlers);
		    },
	
		    trigger: function(name, args) {
		        var ref = this;
		        var observer = ref.observer;
		        var handlerMap = ref.handlerMap;
		        var isDefaultPrevented;
		        if (handlerMap[name]) {
		            isDefaultPrevented = this.callObserver(handlerMap[name], args);
		        } else if (observer[TRIGGER]) {
		            isDefaultPrevented = this.callObserver(TRIGGER, name, args);
		        }
	
		        return isDefaultPrevented;
		    },
	
		    callObserver: function(fnName) {
		        var args = [], len = arguments.length - 1;
		        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
		        return this.observer[fnName].apply(this.observer, args);
		    },
	
		    requiresHandlers: function(names) {
		        var this$1 = this;
	
		        if (this.observer.requiresHandlers) {
		            return this.observer.requiresHandlers(names);
		        }
	
		        for (var idx = 0; idx < names.length; idx++) {
		            if (this$1.handlerMap[names[idx]]) {
		                return true;
		            }
		        }
		    }
		});
	
		function map(array, callback) {
		    var length = array.length;
		    var result = [];
		    for (var idx = 0; idx < length; idx++) {
		        var value = callback(array[idx]);
		        if (kendo.drawing.util.defined(value)) {
		            result.push(value);
		        }
		    }
		    return result;
		}
	
		function mousewheelDelta(e) {
		    var delta = 0;
	
		    if (e.wheelDelta) {
		        delta = -e.wheelDelta / 120;
		        delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
		    }
	
		    if (e.detail) {
		        delta = kendo.drawing.util.round(e.detail / 3);
		    }
	
		    return delta;
		}
	
		var ref = kendo.drawing.util;
		var append = ref.append;
		var bindEvents = ref.bindEvents;
		var defined = ref.defined;
		var deg = ref.deg;
		var elementOffset = ref.elementOffset;
		var elementSize = ref.elementSize;
		var eventElement = ref.eventElement;
		var eventCoordinates = ref.eventCoordinates;
		var last = ref.last;
		var limitValue = ref.limitValue;
		var objectKey = ref.objectKey;
		var rad = ref.rad;
		var round = ref.round;
		var unbindEvents = ref.unbindEvents;
		var valueOrDefault = ref.valueOrDefault;
	
		var FontLoader = Class.extend({
	
		});
	
		FontLoader.fetchFonts = function(options, fonts, state) {
		    if (state === void 0) { state = { depth: 0 }; }
	
		    var MAX_DEPTH = 5;
	
		    if (!options || state.depth > MAX_DEPTH || !document.fonts) {
		        return;
		    }
	
		    Object.keys(options).forEach(function(key) {
		        var value = options[key];
		        if (key === "dataSource" || key[0] === "$" || !value) {
		            return;
		        }
	
		        if (key === "font") {
		            fonts.push(value);
		        } else if (typeof value === "object") {
		            state.depth++;
		            FontLoader.fetchFonts(value, fonts, state);
		            state.depth--;
		        }
		    });
		};
	
		FontLoader.loadFonts = function(fonts, callback) {
		    var promises = [];
	
		    if (fonts.length > 0 && document.fonts) {
		        try {
		            promises = fonts.map(function(font) {
		                return document.fonts.load(font);
		            });
		        } catch (e) {
		            // Silence font-loading errors
		            kendo.logToConsole(e);
		        }
	
		        Promise.all(promises).then(callback, callback);
		    } else {
		        callback();
		    }
		};
	
		FontLoader.preloadFonts = function(options, callback) {
		    var fonts = [];
		    FontLoader.fetchFonts(options, fonts);
	
		    FontLoader.loadFonts(fonts, callback);
		};
	
		function setDefaultOptions(type, options) {
		    var proto = type.prototype;
		    if (proto.options) {
		        proto.options = deepExtend({}, proto.options, options);
		    } else {
		        proto.options = options;
		    }
		}
	
		function sparseArrayLimits(arr) {
		    var min = MAX_VALUE;
		    var max = MIN_VALUE;
	
		    for (var idx = 0, length = arr.length; idx < length; idx++) {
		        var value = arr[idx];
		        if (value !== null && isFinite(value)) {
		            min = Math.min(min, value);
		            max = Math.max(max, value);
		        }
		    }
	
		    return {
		        min: min === MAX_VALUE ? undefined : min,
		        max: max === MIN_VALUE ? undefined : max
		    };
		}
	
		function autoMajorUnit(min, max) {
		    var diff = round(max - min, DEFAULT_PRECISION - 1);
	
		    if (diff === 0) {
		        if (max === 0) {
		            return 0.1;
		        }
	
		        diff = Math.abs(max);
		    }
	
		    var scale = Math.pow(10, Math.floor(Math.log(diff) / Math.log(10)));
		    var relativeValue = round((diff / scale), DEFAULT_PRECISION);
		    var scaleMultiplier = 1;
	
		    if (relativeValue < 1.904762) {
		        scaleMultiplier = 0.2;
		    } else if (relativeValue < 4.761904) {
		        scaleMultiplier = 0.5;
		    } else if (relativeValue < 9.523809) {
		        scaleMultiplier = 1;
		    } else {
		        scaleMultiplier = 2;
		    }
	
		    return round(scale * scaleMultiplier, DEFAULT_PRECISION);
		}
	
		var Point = Class.extend({
		    init: function(x, y) {
	
		        this.x = x || 0;
		        this.y = y || 0;
		    },
	
		    clone: function() {
		        return new Point(this.x, this.y);
		    },
	
		    equals: function(point) {
		        return point && this.x === point.x && this.y === point.y;
		    },
	
		    rotate: function(center, degrees) {
		        var theta = rad(degrees);
		        var cosT = Math.cos(theta);
		        var sinT = Math.sin(theta);
		        var cx = center.x;
		        var cy = center.y;
		        var ref = this;
		        var x = ref.x;
		        var y = ref.y;
	
		        this.x = round(
		            cx + (x - cx) * cosT + (y - cy) * sinT,
		            COORD_PRECISION
		        );
	
		        this.y = round(
		            cy + (y - cy) * cosT - (x - cx) * sinT,
		            COORD_PRECISION
		        );
	
		        return this;
		    },
	
		    multiply: function(a) {
	
		        this.x *= a;
		        this.y *= a;
	
		        return this;
		    },
	
		    distanceTo: function(point) {
		        var dx = this.x - point.x;
		        var dy = this.y - point.y;
	
		        return Math.sqrt(dx * dx + dy * dy);
		    }
		});
	
		Point.onCircle = function(center, angle, radius) {
		    var radians = rad(angle);
	
		    return new Point(
		        center.x - radius * Math.cos(radians),
		        center.y - radius * Math.sin(radians)
		    );
		};
	
		var Box = Class.extend({
		    init: function(x1, y1, x2, y2) {
	
		        this.x1 = x1 || 0;
		        this.y1 = y1 || 0;
		        this.x2 = x2 || 0;
		        this.y2 = y2 || 0;
		    },
	
		    equals: function(box) {
		        return this.x1 === box.x1 && this.x2 === box.x2 &&
		            this.y1 === box.y1 && this.y2 === box.y2;
		    },
	
		    width: function() {
		        return this.x2 - this.x1;
		    },
	
		    height: function() {
		        return this.y2 - this.y1;
		    },
	
		    translate: function(dx, dy) {
		        this.x1 += dx;
		        this.x2 += dx;
		        this.y1 += dy;
		        this.y2 += dy;
	
		        return this;
		    },
	
		    move: function(x, y) {
		        var height = this.height();
		        var width = this.width();
	
		        if (defined(x)) {
		            this.x1 = x;
		            this.x2 = this.x1 + width;
		        }
	
		        if (defined(y)) {
		            this.y1 = y;
		            this.y2 = this.y1 + height;
		        }
	
		        return this;
		    },
	
		    wrap: function(targetBox) {
		        this.x1 = Math.min(this.x1, targetBox.x1);
		        this.y1 = Math.min(this.y1, targetBox.y1);
		        this.x2 = Math.max(this.x2, targetBox.x2);
		        this.y2 = Math.max(this.y2, targetBox.y2);
	
		        return this;
		    },
	
		    wrapPoint: function(point) {
		        var arrayPoint = isArray(point);
		        var x = arrayPoint ? point[0] : point.x;
		        var y = arrayPoint ? point[1] : point.y;
		        this.wrap(new Box(x, y, x, y));
	
		        return this;
		    },
	
		    snapTo: function(targetBox, axis) {
	
		        if (axis === X || !axis) {
		            this.x1 = targetBox.x1;
		            this.x2 = targetBox.x2;
		        }
	
		        if (axis === Y || !axis) {
		            this.y1 = targetBox.y1;
		            this.y2 = targetBox.y2;
		        }
	
		        return this;
		    },
	
		    alignTo: function(targetBox, anchor) {
		        var height = this.height();
		        var width = this.width();
		        var axis = anchor === TOP || anchor === BOTTOM ? Y : X;
		        var offset = axis === Y ? height : width;
	
		        if (anchor === CENTER) {
		            var targetCenter = targetBox.center();
		            var center = this.center();
	
		            this.x1 += targetCenter.x - center.x;
		            this.y1 += targetCenter.y - center.y;
		        } else if (anchor === TOP || anchor === LEFT) {
		            this[axis + 1] = targetBox[axis + 1] - offset;
		        } else {
		            this[axis + 1] = targetBox[axis + 2];
		        }
	
		        this.x2 = this.x1 + width;
		        this.y2 = this.y1 + height;
	
		        return this;
		    },
	
		    shrink: function(dw, dh) {
	
		        this.x2 -= dw;
		        this.y2 -= dh;
	
		        return this;
		    },
	
		    expand: function(dw, dh) {
		        this.shrink(-dw, -dh);
		        return this;
		    },
	
		    pad: function(padding) {
		        var spacing = getSpacing(padding);
	
		        this.x1 -= spacing.left;
		        this.x2 += spacing.right;
		        this.y1 -= spacing.top;
		        this.y2 += spacing.bottom;
	
		        return this;
		    },
	
		    unpad: function(padding) {
		        var spacing = getSpacing(padding);
	
		        spacing.left = -spacing.left;
		        spacing.top = -spacing.top;
		        spacing.right = -spacing.right;
		        spacing.bottom = -spacing.bottom;
	
		        return this.pad(spacing);
		    },
	
		    clone: function() {
		        return new Box(this.x1, this.y1, this.x2, this.y2);
		    },
	
		    center: function() {
		        return new Point(
		            this.x1 + this.width() / 2,
		            this.y1 + this.height() / 2
		        );
		    },
	
		    containsPoint: function(point) {
	
		        return point.x >= this.x1 && point.x <= this.x2 &&
		               point.y >= this.y1 && point.y <= this.y2;
		    },
	
		    points: function() {
		        return [
		            new Point(this.x1, this.y1),
		            new Point(this.x2, this.y1),
		            new Point(this.x2, this.y2),
		            new Point(this.x1, this.y2)
		        ];
		    },
	
		    getHash: function() {
		        return [ this.x1, this.y1, this.x2, this.y2 ].join(",");
		    },
	
		    overlaps: function(box) {
		        return !(box.y2 < this.y1 || this.y2 < box.y1 || box.x2 < this.x1 || this.x2 < box.x1);
		    },
	
		    rotate: function(rotation) {
		        var width = this.width();
		        var height = this.height();
		        var ref = this.center();
		        var cx = ref.x;
		        var cy = ref.y;
	
		        var r1 = rotatePoint(0, 0, cx, cy, rotation);
		        var r2 = rotatePoint(width, 0, cx, cy, rotation);
		        var r3 = rotatePoint(width, height, cx, cy, rotation);
		        var r4 = rotatePoint(0, height, cx, cy, rotation);
	
		        width = Math.max(r1.x, r2.x, r3.x, r4.x) - Math.min(r1.x, r2.x, r3.x, r4.x);
		        height = Math.max(r1.y, r2.y, r3.y, r4.y) - Math.min(r1.y, r2.y, r3.y, r4.y);
	
		        this.x2 = this.x1 + width;
		        this.y2 = this.y1 + height;
	
		        return this;
		    },
	
		    toRect: function() {
		        return new Rect([ this.x1, this.y1 ], [ this.width(), this.height() ]);
		    },
	
		    hasSize: function() {
		        return this.width() !== 0 && this.height() !== 0;
		    },
	
		    align: function(targetBox, axis, alignment) {
		        var c1 = axis + 1;
		        var c2 = axis + 2;
		        var sizeFunc = axis === X ? WIDTH : HEIGHT;
		        var size = this[sizeFunc]();
	
		        if (inArray(alignment, [ LEFT, TOP ])) {
		            this[c1] = targetBox[c1];
		            this[c2] = this[c1] + size;
		        } else if (inArray(alignment, [ RIGHT, BOTTOM ])) {
		            this[c2] = targetBox[c2];
		            this[c1] = this[c2] - size;
		        } else if (alignment === CENTER) {
		            this[c1] = targetBox[c1] + (targetBox[sizeFunc]() - size) / 2;
		            this[c2] = this[c1] + size;
		        }
		    }
		});
	
		function rotatePoint(x, y, cx, cy, angle) {
		    var theta = rad(angle);
	
		    return new Point(
		        cx + (x - cx) * Math.cos(theta) + (y - cy) * Math.sin(theta),
		        cy - (x - cx) * Math.sin(theta) + (y - cy) * Math.cos(theta)
		    );
		}
	
		var Ring = Class.extend({
		    init: function(center, innerRadius, radius, startAngle, angle) {
	
		        this.center = center;
		        this.innerRadius = innerRadius;
		        this.radius = radius;
		        this.startAngle = startAngle;
		        this.angle = angle;
		    },
	
		    clone: function() {
		        return new Ring(this.center, this.innerRadius, this.radius, this.startAngle, this.angle);
		    },
	
		    middle: function() {
		        return this.startAngle + this.angle / 2;
		    },
	
		    setRadius: function(newRadius, innerRadius) {
		        if (innerRadius) {
		            this.innerRadius = newRadius;
		        } else {
		            this.radius = newRadius;
		        }
	
		        return this;
		    },
	
		    point: function(angle, innerRadius) {
		        var radianAngle = rad(angle);
		        var ax = Math.cos(radianAngle);
		        var ay = Math.sin(radianAngle);
		        var radius = innerRadius ? this.innerRadius : this.radius;
		        var x = round(this.center.x - (ax * radius), COORD_PRECISION);
		        var y = round(this.center.y - (ay * radius), COORD_PRECISION);
	
		        return new Point(x, y);
		    },
	
		    adjacentBox: function(distance, width, height) {
		        var sector = this.clone().expand(distance);
		        var midAndle = sector.middle();
		        var midPoint = sector.point(midAndle);
		        var hw = width / 2;
		        var hh = height / 2;
		        var sa = Math.sin(rad(midAndle));
		        var ca = Math.cos(rad(midAndle));
		        var x = midPoint.x - hw;
		        var y = midPoint.y - hh;
	
		        if (Math.abs(sa) < 0.9) {
		            x += hw * -ca / Math.abs(ca);
		        }
	
		        if (Math.abs(ca) < 0.9) {
		            y += hh * -sa / Math.abs(sa);
		        }
	
		        return new Box(x, y, x + width, y + height);
		    },
	
		    containsPoint: function(p) {
		        var center = this.center;
		        var innerRadius = this.innerRadius;
		        var radius = this.radius;
		        var startAngle = this.startAngle;
		        var endAngle = this.startAngle + this.angle;
		        var dx = p.x - center.x;
		        var dy = p.y - center.y;
		        var vector = new Point(dx, dy);
		        var startPoint = this.point(startAngle);
		        var startVector = new Point(startPoint.x - center.x, startPoint.y - center.y);
		        var endPoint = this.point(endAngle);
		        var endVector = new Point(endPoint.x - center.x, endPoint.y - center.y);
		        var dist = round(dx * dx + dy * dy, COORD_PRECISION);
	
		        return (startVector.equals(vector) || clockwise(startVector, vector)) &&
		               !clockwise(endVector, vector) &&
		               dist >= innerRadius * innerRadius && dist <= radius * radius;
		    },
	
		    getBBox: function() {
		        var this$1 = this;
	
		        var box = new Box(MAX_VALUE, MAX_VALUE, MIN_VALUE, MIN_VALUE);
		        var startAngle = round(this.startAngle % 360);
		        var endAngle = round((startAngle + this.angle) % 360);
		        var innerRadius = this.innerRadius;
		        var allAngles = [ 0, 90, 180, 270, startAngle, endAngle ].sort(numericComparer);
		        var startAngleIndex = allAngles.indexOf(startAngle);
		        var endAngleIndex = allAngles.indexOf(endAngle);
		        var angles;
	
		        if (startAngle === endAngle) {
		            angles = allAngles;
		        } else {
		            if (startAngleIndex < endAngleIndex) {
		                angles = allAngles.slice(startAngleIndex, endAngleIndex + 1);
		            } else {
		                angles = [].concat(
		                    allAngles.slice(0, endAngleIndex + 1),
		                    allAngles.slice(startAngleIndex, allAngles.length)
		                );
		            }
		        }
	
		        for (var i = 0; i < angles.length; i++) {
		            var point = this$1.point(angles[i]);
		            box.wrapPoint(point);
		            box.wrapPoint(point, innerRadius);
		        }
	
		        if (!innerRadius) {
		            box.wrapPoint(this.center);
		        }
	
		        return box;
		    },
	
		    expand: function(value) {
		        this.radius += value;
		        return this;
		    }
		});
	
		function numericComparer(a, b) {
		    return a - b;
		}
	
		var Sector = Ring.extend({
		    init: function(center, radius, startAngle, angle) {
		        Ring.fn.init.call(this, center, 0, radius, startAngle, angle);
		    },
	
		    expand: function(value) {
		        return Ring.fn.expand.call(this, value);
		    },
	
		    clone: function() {
		        return new Sector(this.center, this.radius, this.startAngle, this.angle);
		    },
	
		    setRadius: function(newRadius) {
		        this.radius = newRadius;
	
		        return this;
		    }
		});
	
		var DIRECTION_ANGLE = 0.001; //any value that will make the endAngle bigger than the start angle will work here.
	
		var ShapeBuilder = Class.extend({
		    createRing: function(sector, options) {
		        var startAngle = sector.startAngle + 180;
		        var endAngle = sector.angle + startAngle;
	
		        //required in order to avoid reversing the arc direction in cases like 0.000000000000001 + 100 === 100
		        if (sector.angle > 0 && startAngle === endAngle) {
		            endAngle += DIRECTION_ANGLE;
		        }
	
		        var center = new geometry.Point(sector.center.x, sector.center.y);
		        var radius = Math.max(sector.radius, 0);
		        var innerRadius = Math.max(sector.innerRadius, 0);
		        var arc = new geometry.Arc(center, {
		            startAngle: startAngle,
		            endAngle: endAngle,
		            radiusX: radius,
		            radiusY: radius
		        });
		        var path = Path.fromArc(arc, options).close();
	
		        if (innerRadius) {
		            arc.radiusX = arc.radiusY = innerRadius;
		            var innerEnd = arc.pointAt(endAngle);
		            path.lineTo(innerEnd.x, innerEnd.y);
		            path.arc(endAngle, startAngle, innerRadius, innerRadius, true);
		        } else {
		            path.lineTo(center.x, center.y);
		        }
	
		        return path;
		    }
		});
	
		ShapeBuilder.current = new ShapeBuilder();
	
		var ChartElement = Class.extend({
		    init: function(options) {
	
		        this.children = [];
	
		        this.options = deepExtend({}, this.options, this.initUserOptions(options));
		    },
	
		    initUserOptions: function(options) {
		        return options;
		    },
	
		    reflow: function(targetBox) {
		        var children = this.children;
		        var box;
	
		        for (var i = 0; i < children.length; i++) {
		            var currentChild = children[i];
		            currentChild.reflow(targetBox);
	
		            box = box ? box.wrap(currentChild.box) : currentChild.box.clone();
		        }
	
		        this.box = box || targetBox;
		    },
	
		    destroy: function() {
		        var children = this.children;
	
		        if (this.animation) {
		            this.animation.destroy();
		        }
	
		        for (var i = 0; i < children.length; i++) {
		            children[i].destroy();
		        }
		    },
	
		    getRoot: function() {
		        var parent = this.parent;
	
		        return parent ? parent.getRoot() : null;
		    },
	
		    getSender: function() {
		        var service = this.getService();
		        if (service) {
		            return service.sender;
		        }
		    },
	
		    getService: function() {
		        var element = this;
		        while (element) {
		            if (element.chartService) {
		                return element.chartService;
		            }
		            element = element.parent;
		        }
		    },
	
		    translateChildren: function(dx, dy) {
		        var children = this.children;
		        var childrenCount = children.length;
	
		        for (var i = 0; i < childrenCount; i++) {
		            children[i].box.translate(dx, dy);
		        }
		    },
	
		    append: function() {
		        var arguments$1 = arguments;
		        var this$1 = this;
	
		        for (var i = 0; i < arguments.length; i++) {
		            var item = arguments$1[i];
		            this$1.children.push(item);
		            item.parent = this$1;
		        }
		    },
	
		    renderVisual: function() {
		        if (this.options.visible === false) {
		            return;
		        }
	
		        this.createVisual();
	
		        this.addVisual();
	
		        this.renderChildren();
	
		        this.createAnimation();
		        this.renderComplete();
		    },
	
		    addVisual: function() {
		        if (this.visual) {
		            this.visual.chartElement = this;
	
		            if (this.parent) {
		                this.parent.appendVisual(this.visual);
		            }
		        }
		    },
	
		    renderChildren: function() {
		        var children = this.children;
		        var length = children.length;
		        for (var i = 0; i < length; i++) {
		            children[i].renderVisual();
		        }
		    },
	
		    createVisual: function() {
		        this.visual = new Group({
		            zIndex: this.options.zIndex,
		            visible: valueOrDefault(this.options.visible, true)
		        });
		    },
	
		    createAnimation: function() {
		        if (this.visual && this.options.animation) {
		            this.animation = drawing.Animation.create(
		                this.visual, this.options.animation
		            );
		        }
		    },
	
		    appendVisual: function(childVisual) {
		        if (!childVisual.chartElement) {
		            childVisual.chartElement = this;
		        }
	
		        if (childVisual.options.noclip) {
		            this.clipRoot().visual.append(childVisual);
		        } else if (defined(childVisual.options.zIndex)) {
		            this.stackRoot().stackVisual(childVisual);
		        } else if (this.isStackRoot) {
		            this.stackVisual(childVisual);
		        } else if (this.visual) {
		            this.visual.append(childVisual);
		        } else {
		            // Allow chart elements without visuals to
		            // pass through child visuals
		            this.parent.appendVisual(childVisual);
		        }
		    },
	
		    clipRoot: function() {
		        if (this.parent) {
		            return this.parent.clipRoot();
		        }
	
		        return this;
		    },
	
		    stackRoot: function() {
		        if (this.parent) {
		            return this.parent.stackRoot();
		        }
	
		        return this;
		    },
	
		    stackVisual: function(childVisual) {
		        var zIndex = childVisual.options.zIndex || 0;
		        var visuals = this.visual.children;
		        var length = visuals.length;
		        var pos;
	
		        for (pos = 0; pos < length; pos++) {
		            var sibling = visuals[pos];
		            var here = valueOrDefault(sibling.options.zIndex, 0);
		            if (here > zIndex) {
		                break;
		            }
		        }
	
		        this.visual.insert(pos, childVisual);
		    },
	
		    traverse: function(callback) {
		        var children = this.children;
		        var length = children.length;
	
		        for (var i = 0; i < length; i++) {
		            var child = children[i];
	
		            callback(child);
		            if (child.traverse) {
		                child.traverse(callback);
		            }
		        }
		    },
	
		    closest: function(match) {
		        var element = this;
		        var matched = false;
	
		        while (element && !matched) {
		            matched = match(element);
	
		            if (!matched) {
		                element = element.parent;
		            }
		        }
	
		        if (matched) {
		            return element;
		        }
		    },
	
		    renderComplete: function() {},
	
		    hasHighlight: function() {
		        var options = (this.options || {}).highlight;
		        return !(!this.createHighlight || (options && options.visible === false));
		    },
	
		    toggleHighlight: function(show) {
		        var this$1 = this;
	
		        var options = (this.options || {}).highlight || {};
		        var customVisual = options.visual;
		        var highlight = this._highlight;
	
		        if (!highlight) {
		            var highlightOptions = {
		                fill: {
		                    color: WHITE,
		                    opacity: 0.2
		                },
		                stroke: {
		                    color: WHITE,
		                    width: 1,
		                    opacity: 0.2
		                }
		            };
	
		            if (customVisual) {
		                highlight = this._highlight = customVisual(
		                    $.extend(this.highlightVisualArgs(), {
		                        createVisual: function () { return this$1.createHighlight(highlightOptions); },
		                        sender: this.getSender(),
		                        series: this.series,
		                        dataItem: this.dataItem,
		                        category: this.category,
		                        value: this.value,
		                        percentage: this.percentage,
		                        runningTotal: this.runningTotal,
		                        total: this.total
		                    }
		                ));
	
		                if (!highlight) {
		                    return;
		                }
		            } else {
		                highlight = this._highlight = this.createHighlight(highlightOptions);
		            }
	
		            if (!defined(highlight.options.zIndex)) {
		                highlight.options.zIndex = valueOrDefault(options.zIndex, this.options.zIndex);
		            }
	
		            this.appendVisual(highlight);
		        }
	
		        highlight.visible(show);
		    },
	
		    createGradientOverlay: function(element, options, gradientOptions) {
		        var overlay = new Path($.extend({
		            stroke: {
		                color: "none"
		            },
		            fill: this.createGradient(gradientOptions),
		            closed: element.options.closed
		        }, options));
	
		        overlay.segments.elements(element.segments.elements());
	
		        return overlay;
		    },
	
		    createGradient: function(options) {
		        if (this.parent) {
		            return this.parent.createGradient(options);
		        }
		    }
		});
	
		ChartElement.prototype.options = { };
	
		var BoxElement = ChartElement.extend({
		    init: function(options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.options.margin = getSpacing(this.options.margin);
		        this.options.padding = getSpacing(this.options.padding);
		    },
	
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        var options = this.options;
		        var width = options.width;
		        var height = options.height;
		        var shrinkToFit = options.shrinkToFit;
		        var hasSetSize = width && height;
		        var margin = options.margin;
		        var padding = options.padding;
		        var borderWidth = options.border.width;
		        var box;
	
		        var reflowPaddingBox = function () {
		            this$1.align(targetBox, X, options.align);
		            this$1.align(targetBox, Y, options.vAlign);
		            this$1.paddingBox = box.clone().unpad(margin).unpad(borderWidth);
		        };
	
		        var contentBox = targetBox.clone();
		        if (hasSetSize) {
		            contentBox.x2 = contentBox.x1 + width;
		            contentBox.y2 = contentBox.y1 + height;
		        }
	
		        if (shrinkToFit) {
		            contentBox.unpad(margin).unpad(borderWidth).unpad(padding);
		        }
	
		        ChartElement.fn.reflow.call(this, contentBox);
	
		        if (hasSetSize) {
		            box = this.box = new Box(0, 0, width, height);
		        } else {
		            box = this.box;
		        }
	
		        if (shrinkToFit && hasSetSize) {
		            reflowPaddingBox();
		            contentBox = this.contentBox = this.paddingBox.clone().unpad(padding);
		        } else {
		            contentBox = this.contentBox = box.clone();
		            box.pad(padding).pad(borderWidth).pad(margin);
		            reflowPaddingBox();
		        }
	
		        this.translateChildren(
		            box.x1 - contentBox.x1 + margin.left + borderWidth + padding.left,
		            box.y1 - contentBox.y1 + margin.top + borderWidth + padding.top
		        );
	
		        var children = this.children;
		        for (var i = 0; i < children.length; i++) {
		            var item = children[i];
		            item.reflow(item.box);
		        }
		    },
	
		    align: function(targetBox, axis, alignment) {
		        this.box.align(targetBox, axis, alignment);
		    },
	
		    hasBox: function() {
		        var options = this.options;
		        return options.border.width || options.background;
		    },
	
		    createVisual: function() {
		        ChartElement.fn.createVisual.call(this);
	
		        var options = this.options;
		        if (options.visible && this.hasBox()) {
		            this.visual.append(Path.fromRect(
		                this.paddingBox.toRect(),
		                this.visualStyle()
		            ));
		        }
		    },
	
		    visualStyle: function() {
		        var options = this.options;
		        var border = options.border || {};
	
		        return {
		            stroke: {
		                width: border.width,
		                color: border.color,
		                opacity: valueOrDefault(border.opacity, options.opacity),
		                dashType: border.dashType
		            },
		            fill: {
		                color: options.background,
		                opacity: options.opacity
		            },
		            cursor: options.cursor
		        };
		    }
		});
	
		setDefaultOptions(BoxElement, {
		    align: LEFT,
		    vAlign: TOP,
		    margin: {},
		    padding: {},
		    border: {
		        color: BLACK,
		        width: 0
		    },
		    background: "",
		    shrinkToFit: false,
		    width: 0,
		    height: 0,
		    visible: true
		});
	
		var ShapeElement = BoxElement.extend({
		    init: function(options, pointData) {
		        BoxElement.fn.init.call(this, options);
	
		        this.pointData = pointData;
		    },
	
		    getElement: function() {
		        var ref = this;
		        var options = ref.options;
		        var box = ref.paddingBox;
		        var type = options.type;
		        var rotation = options.rotation;
		        var center = box.center();
		        var halfWidth = box.width() / 2;
	
		        if (!options.visible || !this.hasBox()) {
		            return null;
		        }
	
		        var style = this.visualStyle();
		        var element;
	
		        if (type === CIRCLE) {
		            element = new drawing.Circle(
		                new Circle([
		                    round(box.x1 + halfWidth, COORD_PRECISION),
		                    round(box.y1 + box.height() / 2, COORD_PRECISION)
		                ], halfWidth),
		                style
		            );
		        } else if (type === TRIANGLE) {
		            element = Path.fromPoints([
		                [ box.x1 + halfWidth, box.y1 ],
		                [ box.x1, box.y2 ],
		                [ box.x2, box.y2 ]
		            ], style).close();
		        } else if (type === CROSS) {
		            element = new drawing.MultiPath(style);
	
		            element.moveTo(box.x1, box.y1).lineTo(box.x2, box.y2);
		            element.moveTo(box.x1, box.y2).lineTo(box.x2, box.y1);
		        } else {
		            element = Path.fromRect(box.toRect(), style);
		        }
	
		        if (rotation) {
		            element.transform(geometryTransform()
		                .rotate(-rotation, [ center.x, center.y ])
		            );
		        }
	
		        element.options.zIndex = options.zIndex;
		        return element;
		    },
	
		    createElement: function() {
		        var this$1 = this;
	
		        var customVisual = this.options.visual;
		        var pointData = this.pointData || {};
		        var visual;
	
		        if (customVisual) {
		            visual = customVisual({
		                value: pointData.value,
		                dataItem: pointData.dataItem,
		                sender: this.getSender(),
		                series: pointData.series,
		                category: pointData.category,
		                rect: this.paddingBox.toRect(),
		                options: this.visualOptions(),
		                createVisual: function () { return this$1.getElement(); }
		            });
		        } else {
		            visual = this.getElement();
		        }
	
		        return visual;
		    },
	
		    visualOptions: function() {
		        var options = this.options;
		        return {
		            background: options.background,
		            border: options.border,
		            margin: options.margin,
		            padding: options.padding,
		            type: options.type,
		            size: options.width,
		            visible: options.visible
		        };
		    },
	
		    createVisual: function() {
		        this.visual = this.createElement();
		    }
		});
	
		setDefaultOptions(ShapeElement, {
		    type: CIRCLE,
		    align: CENTER,
		    vAlign: CENTER
		});
	
		var LINEAR = "linear";
		var RADIAL = "radial";
	
		var GRADIENTS = {
		    glass: {
		        type: LINEAR,
		        rotation: 0,
		        stops: [ {
		            offset: 0,
		            color: WHITE,
		            opacity: 0
		        }, {
		            offset: 0.25,
		            color: WHITE,
		            opacity: 0.3
		        }, {
		            offset: 1,
		            color: WHITE,
		            opacity: 0
		        } ]
		    },
		    sharpBevel: {
		        type: RADIAL,
		        stops: [ {
		            offset: 0,
		            color: WHITE,
		            opacity: 0.55
		        }, {
		            offset: 0.65,
		            color: WHITE,
		            opacity: 0
		        }, {
		            offset: 0.95,
		            color: WHITE,
		            opacity: 0.25
		        } ]
		    },
		    roundedBevel: {
		        type: RADIAL,
		        stops: [ {
		            offset: 0.33,
		            color: WHITE,
		            opacity: 0.06
		        }, {
		            offset: 0.83,
		            color: WHITE,
		            opacity: 0.2
		        }, {
		            offset: 0.95,
		            color: WHITE,
		            opacity: 0
		        } ]
		    },
		    roundedGlass: {
		        type: RADIAL,
		        supportVML: false,
		        stops: [ {
		            offset: 0,
		            color: WHITE,
		            opacity: 0
		        }, {
		            offset: 0.5,
		            color: WHITE,
		            opacity: 0.3
		        }, {
		            offset: 0.99,
		            color: WHITE,
		            opacity: 0
		        } ]
		    },
		    sharpGlass: {
		        type: RADIAL,
		        supportVML: false,
		        stops: [ {
		            offset: 0,
		            color: WHITE,
		            opacity: 0.2
		        }, {
		            offset: 0.15,
		            color: WHITE,
		            opacity: 0.15
		        }, {
		            offset: 0.17,
		            color: WHITE,
		            opacity: 0.35
		        }, {
		            offset: 0.85,
		            color: WHITE,
		            opacity: 0.05
		        }, {
		            offset: 0.87,
		            color: WHITE,
		            opacity: 0.15
		        }, {
		            offset: 0.99,
		            color: WHITE,
		            opacity: 0
		        } ]
		    },
		    bubbleShadow: {
		        type: RADIAL,
		        center: [ 0.5, 0.5 ],
		        radius: 0.5
		    }
		};
	
		function boxDiff(r, s) {
		    if (r.x1 === s.x1 && r.y1 === s.y1 && r.x2 === s.x2 && r.y2 === s.y2) {
		        return s;
		    }
	
		    var a = Math.min(r.x1, s.x1);
		    var b = Math.max(r.x1, s.x1);
		    var c = Math.min(r.x2, s.x2);
		    var d = Math.max(r.x2, s.x2);
		    var e = Math.min(r.y1, s.y1);
		    var f = Math.max(r.y1, s.y1);
		    var g = Math.min(r.y2, s.y2);
		    var h = Math.max(r.y2, s.y2);
		    var boxes = [];
	
		    // X = intersection, 0-7 = possible difference areas
		    // h +-+-+-+
		    // . |5|6|7|
		    // g +-+-+-+
		    // . |3|X|4|
		    // f +-+-+-+
		    // . |0|1|2|
		    // e +-+-+-+
		    // . a b c d
	
		    // we'll always have rectangles 1, 3, 4 and 6
		    boxes[0] = new Box(b, e, c, f);
		    boxes[1] = new Box(a, f, b, g);
		    boxes[2] = new Box(c, f, d, g);
		    boxes[3] = new Box(b, g, c, h);
	
		    // decide which corners
		    if (r.x1 === a && r.y1 === e || s.x1 === a && s.y1 === e) { // corners 0 and 7
		        boxes[4] = new Box(a, e, b, f);
		        boxes[5] = new Box(c, g, d, h);
		    } else { // corners 2 and 5
		        boxes[4] = new Box(c, e, d, f);
		        boxes[5] = new Box(a, g, b, h);
		    }
	
		    return grep(boxes, function(box) {
		        return box.height() > 0 && box.width() > 0;
		    })[0];
		}
	
		var RootElement = ChartElement.extend({
		    init: function(options) {
		        ChartElement.fn.init.call(this, options);
	
		        var rootOptions = this.options;
		        rootOptions.width = parseInt(rootOptions.width, 10);
		        rootOptions.height = parseInt(rootOptions.height, 10);
	
		        this.gradients = {};
		    },
	
		    reflow: function() {
		        var ref = this;
		        var options = ref.options;
		        var children = ref.children;
		        var currentBox = new Box(0, 0, options.width, options.height);
	
		        this.box = currentBox.unpad(options.margin);
	
		        for (var i = 0; i < children.length; i++) {
		            children[i].reflow(currentBox);
		            currentBox = boxDiff(currentBox, children[i].box) || new Box();
		        }
		    },
	
		    createVisual: function() {
		        this.visual = new Group();
		        this.createBackground();
		    },
	
		    createBackground: function() {
		        var options = this.options;
		        var border = options.border || {};
		        var box = this.box.clone().pad(options.margin).unpad(border.width);
	
		        var background = Path.fromRect(box.toRect(), {
		            stroke: {
		                color: border.width ? border.color : "",
		                width: border.width,
		                dashType: border.dashType
		            },
		            fill: {
		                color: options.background,
		                opacity: options.opacity
		            },
		            zIndex: -10
		        });
	
		        this.visual.append(background);
		    },
	
		    getRoot: function() {
		        return this;
		    },
	
		    createGradient: function(options) {
		        var gradients = this.gradients;
		        var hashCode = objectKey(options);
		        var gradient = GRADIENTS[options.gradient];
		        var drawingGradient;
	
		        if (gradients[hashCode]) {
		            drawingGradient = gradients[hashCode];
		        } else {
		            var gradientOptions = $.extend({}, gradient, options);
		            if (gradient.type === "linear") {
		                drawingGradient = new drawing.LinearGradient(gradientOptions);
		            } else {
		                if (options.innerRadius) {
		                    gradientOptions.stops = innerRadialStops(gradientOptions);
		                }
		                drawingGradient = new drawing.RadialGradient(gradientOptions);
		                drawingGradient.supportVML = gradient.supportVML !== false;
		            }
		            gradients[hashCode] = drawingGradient;
		        }
	
		        return drawingGradient;
		    },
	
		    cleanGradients: function() {
		        var gradients = this.gradients;
		        for (var hashCode in gradients) {
		            gradients[hashCode]._observers = [];//add clear observers method in drawing ObserversMixin
		        }
		    },
	
		    size: function() {
		        var options = this.options;
		        return new Box(0, 0, options.width, options.height);
		    }
		});
	
		setDefaultOptions(RootElement, {
		    width: DEFAULT_WIDTH,
		    height: DEFAULT_HEIGHT,
		    background: WHITE,
		    border: {
		        color: BLACK,
		        width: 0
		    },
		    margin: getSpacing(5),
		    zIndex: -2
		});
	
		function innerRadialStops(options) {
		    var stops = options.stops;
		    var usedSpace = ((options.innerRadius / options.radius) * 100);
		    var length = stops.length;
		    var currentStops = [];
	
		    for (var i = 0; i < length; i++) {
		        var currentStop = $.extend({}, stops[i]);
		        currentStop.offset = (currentStop.offset * (100 - usedSpace) + usedSpace) / 100;
		        currentStops.push(currentStop);
		    }
	
		    return currentStops;
		}
	
		var FloatElement = ChartElement.extend({
		    init: function(options) {
		        ChartElement.fn.init.call(this, options);
		        this._initDirection();
		    },
	
		    _initDirection: function() {
		        var options = this.options;
		        if (options.vertical) {
		            this.groupAxis = X;
		            this.elementAxis = Y;
		            this.groupSizeField = WIDTH;
		            this.elementSizeField = HEIGHT;
		            this.groupSpacing = options.spacing;
		            this.elementSpacing = options.vSpacing;
		        } else {
		            this.groupAxis = Y;
		            this.elementAxis = X;
		            this.groupSizeField = HEIGHT;
		            this.elementSizeField = WIDTH;
		            this.groupSpacing = options.vSpacing;
		            this.elementSpacing = options.spacing;
		        }
		    },
	
		    reflow: function(targetBox) {
		        this.box = targetBox.clone();
		        this.reflowChildren();
		    },
	
		    reflowChildren: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var box = ref.box;
		        var elementAxis = ref.elementAxis;
		        var groupAxis = ref.groupAxis;
		        var elementSizeField = ref.elementSizeField;
		        var groupSizeField = ref.groupSizeField;
		        var ref$1 = this.groupOptions();
		        var groups = ref$1.groups;
		        var groupsSize = ref$1.groupsSize;
		        var maxGroupElementsSize = ref$1.maxGroupElementsSize;
		        var groupsCount = groups.length;
		        var groupsStart = box[groupAxis + 1] + this.alignStart(groupsSize, box[groupSizeField]());
	
		        if (groupsCount) {
		            var groupStart = groupsStart;
	
		            for (var groupIdx = 0; groupIdx < groupsCount; groupIdx++) {
		                var group = groups[groupIdx];
		                var groupElements = group.groupElements;
		                var elementStart = box[elementAxis + 1];
		                var groupElementsCount = groupElements.length;
	
		                for (var idx = 0; idx < groupElementsCount; idx++) {
		                    var element = groupElements[idx];
		                    var elementSize$$1 = this$1.elementSize(element);
		                    var groupElementStart = groupStart + this$1.alignStart(elementSize$$1[groupSizeField], group.groupSize);
	
		                    var elementBox = new Box();
		                    elementBox[groupAxis + 1] = groupElementStart;
		                    elementBox[groupAxis + 2] = groupElementStart + elementSize$$1[groupSizeField];
		                    elementBox[elementAxis + 1] = elementStart;
		                    elementBox[elementAxis + 2] = elementStart + elementSize$$1[elementSizeField];
	
		                    element.reflow(elementBox);
	
		                    elementStart += elementSize$$1[elementSizeField] + this$1.elementSpacing;
		                }
		                groupStart += group.groupSize + this$1.groupSpacing;
		            }
		            box[groupAxis + 1] = groupsStart;
		            box[groupAxis + 2] = groupsStart + groupsSize;
		            box[elementAxis + 2] = box[elementAxis + 1] + maxGroupElementsSize;
		        }
		    },
	
		    alignStart: function(size, maxSize) {
		        var start = 0;
		        var align = this.options.align;
		        if (align === RIGHT || align === BOTTOM) {
		            start = maxSize - size;
		        } else if (align === CENTER) {
		            start = (maxSize - size) / 2;
		        }
		        return start;
		    },
	
		    groupOptions: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var box = ref.box;
		        var children = ref.children;
		        var elementSizeField = ref.elementSizeField;
		        var groupSizeField = ref.groupSizeField;
		        var elementSpacing = ref.elementSpacing;
		        var groupSpacing = ref.groupSpacing;
		        var maxSize = round(box[elementSizeField]());
		        var childrenCount = children.length;
		        var groups = [];
	
		        var groupSize = 0;
		        var groupElementsSize = 0;
		        var groupsSize = 0;
		        var maxGroupElementsSize = 0;
		        var groupElements = [];
	
		        for (var idx = 0; idx < childrenCount; idx++) {
		            var element = children[idx];
		            if (!element.box) {
		                element.reflow(box);
		            }
	
		            var elementSize$$1 = this$1.elementSize(element);
		            if (this$1.options.wrap && round(groupElementsSize + elementSpacing + elementSize$$1[elementSizeField]) > maxSize) {
		                groups.push({
		                    groupElements: groupElements,
		                    groupSize: groupSize,
		                    groupElementsSize: groupElementsSize
		                });
		                maxGroupElementsSize = Math.max(maxGroupElementsSize, groupElementsSize);
		                groupsSize += groupSpacing + groupSize;
		                groupSize = 0;
		                groupElementsSize = 0;
		                groupElements = [];
		            }
		            groupSize = Math.max(groupSize, elementSize$$1[groupSizeField]);
		            if (groupElementsSize > 0) {
		                groupElementsSize += elementSpacing;
		            }
		            groupElementsSize += elementSize$$1[elementSizeField];
		            groupElements.push(element);
		        }
	
		        groups.push({
		            groupElements: groupElements,
		            groupSize: groupSize,
		            groupElementsSize: groupElementsSize
		        });
		        maxGroupElementsSize = Math.max(maxGroupElementsSize, groupElementsSize);
		        groupsSize += groupSize;
	
		        return {
		            groups: groups,
		            groupsSize: groupsSize,
		            maxGroupElementsSize: maxGroupElementsSize
		        };
		    },
	
		    elementSize: function(element) {
		        return {
		            width: element.box.width(),
		            height: element.box.height()
		        };
		    },
	
		    createVisual: function() {}
		});
	
		setDefaultOptions(FloatElement, {
		    vertical: true,
		    wrap: true,
		    vSpacing: 0,
		    spacing: 0
		});
	
		var DrawingText = drawing.Text;
	
		var Text = ChartElement.extend({
		    init: function(content, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.content = content;
	
		        // Calculate size
		        this.reflow(new Box());
		    },
	
		    reflow: function(targetBox) {
		        var options = this.options;
		        var size = options.size = util.measureText(this.content, { font: options.font });
	
		        this.baseline = size.baseline;
	
		        this.box = new Box(targetBox.x1, targetBox.y1,
		                targetBox.x1 + size.width, targetBox.y1 + size.height);
		    },
	
		    createVisual: function() {
		        var ref = this.options;
		        var font = ref.font;
		        var color = ref.color;
		        var opacity = ref.opacity;
		        var cursor = ref.cursor;
	
		        this.visual = new DrawingText(this.content, this.box.toRect().topLeft(), {
		            font: font,
		            fill: { color: color, opacity: opacity },
		            cursor: cursor
		        });
		    }
		});
	
		setDefaultOptions(Text, {
		    font: DEFAULT_FONT,
		    color: BLACK
		});
	
		function rectToBox(rect) {
		    var origin = rect.origin;
		    var bottomRight = rect.bottomRight();
	
		    return new Box(origin.x, origin.y, bottomRight.x, bottomRight.y);
		}
	
		var ROWS_SPLIT_REGEX = /\n/m;
	
		var TextBox = BoxElement.extend({
		    init: function(content, options, data) {
		        BoxElement.fn.init.call(this, options);
		        this.content = content;
		        this.data = data;
	
		        this._initContainer();
		        if (this.options._autoReflow !== false) {
		            this.reflow(new Box());
		        }
		    },
	
		    _initContainer: function() {
		        var options = this.options;
		        var rows = String(this.content).split(ROWS_SPLIT_REGEX);
		        var floatElement = new FloatElement({ vertical: true, align: options.align, wrap: false });
		        var textOptions = deepExtend({ }, options, { opacity: 1, animation: null });
	
		        this.container = floatElement;
		        this.append(floatElement);
	
		        for (var rowIdx = 0; rowIdx < rows.length; rowIdx++) {
		            var text = new Text(rows[rowIdx].trim(), textOptions);
		            floatElement.append(text);
		        }
		    },
	
		    reflow: function(targetBox) {
		        var options = this.options;
		        var visualFn = options.visual;
		        this.container.options.align = options.align;
	
		        if (visualFn && !this._boxReflow) {
		            var visualBox = targetBox;
		            if (!visualBox.hasSize()) {
		                this._boxReflow = true;
		                this.reflow(visualBox);
		                this._boxReflow = false;
		                visualBox = this.box;
		            }
		            var visual = this.visual = visualFn(this.visualContext(visualBox));
	
		            if (visual) {
		                visualBox = rectToBox(visual.clippedBBox() || new Rect());
	
		                visual.options.zIndex = options.zIndex;
		            }
	
		            this.box = this.contentBox = this.paddingBox = visualBox;
		        } else {
		            BoxElement.fn.reflow.call(this, targetBox);
	
		            if (options.rotation) {
		                var margin = getSpacing(options.margin);
		                var box = this.box.unpad(margin);
	
		                this.targetBox = targetBox;
		                this.normalBox = box.clone();
	
		                box = this.rotate();
		                box.translate(margin.left - margin.right, margin.top - margin.bottom);
	
		                this.rotatedBox = box.clone();
	
		                box.pad(margin);
		            }
		        }
		    },
	
		    createVisual: function() {
		        var options = this.options;
	
		        this.visual = new Group({
		            transform: this.rotationTransform(),
		            zIndex: options.zIndex,
		            noclip: options.noclip
		        });
	
		        if (this.hasBox()) {
		            var box = Path.fromRect(this.paddingBox.toRect(), this.visualStyle());
		            this.visual.append(box);
		        }
		    },
	
		    renderVisual: function() {
		        if (!this.options.visible) {
		            return;
		        }
	
		        if (this.options.visual) {
		            var visual = this.visual;
		            if (visual && !defined(visual.options.noclip)) {
		                visual.options.noclip = this.options.noclip;
		            }
		            this.addVisual();
		            this.createAnimation();
		        } else {
		            BoxElement.fn.renderVisual.call(this);
		        }
		    },
	
		    visualContext: function(targetBox) {
		        var this$1 = this;
	
		        var context = {
		            text: this.content,
		            rect: targetBox.toRect(),
		            sender: this.getSender(),
		            options: this.options,
		            createVisual: function () {
		                this$1._boxReflow = true;
		                this$1.reflow(targetBox);
		                this$1._boxReflow = false;
		                return this$1.getDefaultVisual();
		            }
		        };
		        if (this.data) {
		            $.extend(context, this.data);
		        }
	
		        return context;
		    },
	
		    getDefaultVisual: function() {
		        this.createVisual();
		        this.renderChildren();
		        var visual = this.visual;
		        delete this.visual;
		        return visual;
		    },
	
		    rotate: function() {
		        var options = this.options;
		        this.box.rotate(options.rotation);
		        this.align(this.targetBox, X, options.align);
		        this.align(this.targetBox, Y, options.vAlign);
		        return this.box;
		    },
	
		    rotationTransform: function() {
		        var rotation = this.options.rotation;
		        if (!rotation) {
		            return null;
		        }
	
		        var ref = this.normalBox.center();
		        var cx = ref.x;
		        var cy = ref.y;
		        var boxCenter = this.rotatedBox.center();
	
		        return geometryTransform()
		                   .translate(boxCenter.x - cx, boxCenter.y - cy)
		                   .rotate(rotation, [ cx, cy ]);
		    }
		});
	
		var Title = ChartElement.extend({
		    init: function(options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.append(
		            new TextBox(this.options.text, $.extend({}, this.options, {
		                vAlign: this.options.position
		            }))
		        );
		    },
	
		    reflow: function(targetBox) {
		        ChartElement.fn.reflow.call(this, targetBox);
		        this.box.snapTo(targetBox, X);
		    }
		});
	
		Title.buildTitle = function(options, parent, defaultOptions) {
		    var titleOptions = options;
	
		    if (typeof options === "string") {
		        titleOptions = { text: options };
		    }
	
		    titleOptions = $.extend({ visible: true }, defaultOptions, titleOptions);
	
		    var title;
		    if (titleOptions && titleOptions.visible && titleOptions.text) {
		        title = new Title(titleOptions);
		        parent.append(title);
		    }
	
		    return title;
		};
	
		setDefaultOptions(Title, {
		    color: BLACK,
		    position: TOP,
		    align: CENTER,
		    margin: getSpacing(5),
		    padding: getSpacing(5)
		});
	
		var AxisLabel = TextBox.extend({
		    init: function(value, text, index, dataItem, options) {
		        TextBox.fn.init.call(this, text, options);
	
		        this.text = text;
		        this.value = value;
		        this.index = index;
		        this.dataItem = dataItem;
		        this.reflow(new Box());
		    },
	
		    visualContext: function(targetBox) {
		        var context = TextBox.fn.visualContext.call(this, targetBox);
	
		        context.value = this.value;
		        context.dataItem = this.dataItem;
		        context.format = this.options.format;
		        context.culture = this.options.culture;
	
		        return context;
		    },
	
		    click: function(widget, e) {
	
		        widget.trigger(AXIS_LABEL_CLICK, {
		            element: eventElement(e),
		            value: this.value,
		            text: this.text,
		            index: this.index,
		            dataItem: this.dataItem,
		            axis: this.parent.options
		        });
		    },
	
		    rotate: function() {
		        if (this.options.alignRotation !== CENTER) {
		            var box = this.normalBox.toRect();
		            var transform = this.rotationTransform();
	
		            this.box = rectToBox(box.bbox(transform.matrix()));
		        } else {
		            TextBox.fn.rotate.call(this);
		        }
	
		        return this.box;
		    },
	
		    rotationTransform: function() {
		        var options = this.options;
		        var rotation = options.rotation;
		        if (!rotation) {
		            return null;
		        }
	
		        if (options.alignRotation === CENTER) {
		            return TextBox.fn.rotationTransform.call(this);
		        }
	
		        var rotationMatrix = geometryTransform().rotate(rotation).matrix();
		        var box = this.normalBox.toRect();
		        var rect = this.targetBox.toRect();
	
		        var rotationOrigin = options.rotationOrigin || TOP;
		        var alignAxis = rotationOrigin === TOP || rotationOrigin === BOTTOM ? X : Y;
		        var distanceAxis = rotationOrigin === TOP || rotationOrigin === BOTTOM ? Y : X;
		        var axisAnchor = rotationOrigin === TOP || rotationOrigin === LEFT ? rect.origin : rect.bottomRight();
	
		        var topLeft = box.topLeft().transformCopy(rotationMatrix);
		        var topRight = box.topRight().transformCopy(rotationMatrix);
		        var bottomRight = box.bottomRight().transformCopy(rotationMatrix);
		        var bottomLeft = box.bottomLeft().transformCopy(rotationMatrix);
		        var rotatedBox = Rect.fromPoints(topLeft, topRight, bottomRight, bottomLeft);
	
		        var translate = {};
		        translate[distanceAxis] = rect.origin[distanceAxis] - rotatedBox.origin[distanceAxis];
	
		        var distanceLeft = Math.abs(topLeft[distanceAxis] + translate[distanceAxis] - axisAnchor[distanceAxis]);
		        var distanceRight = Math.abs(topRight[distanceAxis] + translate[distanceAxis] - axisAnchor[distanceAxis]);
	
		        var alignStart, alignEnd;
	
		        if (round(distanceLeft, DEFAULT_PRECISION) === round(distanceRight, DEFAULT_PRECISION)) {
		            alignStart = topLeft;
		            alignEnd = topRight;
		        } else if (distanceRight < distanceLeft) {
		            alignStart = topRight;
		            alignEnd = bottomRight;
		        } else {
		            alignStart = topLeft;
		            alignEnd = bottomLeft;
		        }
	
		        var alignCenter = alignStart[alignAxis] + (alignEnd[alignAxis] - alignStart[alignAxis]) / 2;
		        translate[alignAxis] = rect.center()[alignAxis] - alignCenter;
	
		        return geometryTransform()
		            .translate(translate.x, translate.y)
		            .rotate(rotation);
		    }
		});
	
		setDefaultOptions(AxisLabel, {
		    _autoReflow: false
		});
	
		var DEFAULT_ICON_SIZE = 7;
		var DEFAULT_LABEL_COLOR = "#fff";
	
		var Note = BoxElement.extend({
		    init: function(fields, options, chartService) {
		        BoxElement.fn.init.call(this, options);
	
		        this.fields = fields;
		        this.chartService = chartService;
	
		        this.render();
		    },
	
		    hide: function() {
		        this.options.visible = false;
		    },
	
		    show: function() {
		        this.options.visible = true;
		    },
	
		    render: function() {
		        var this$1 = this;
	
		        var options = this.options;
	
		        if (options.visible) {
		            var label = options.label;
		            var icon = options.icon;
		            var box = new Box();
		            var childAlias = function () { return this$1; };
		            var size = icon.size;
		            var text = this.fields.text;
		            var width, height;
	
		            if (defined(label) && label.visible) {
		                var noteTemplate = getTemplate(label);
		                if (noteTemplate) {
		                    text = noteTemplate(this.fields);
		                } else if (label.format) {
		                    text = this.chartService.format.auto(label.format, text);
		                }
	
		                if (!label.color) {
		                    label.color = label.position === INSIDE ? DEFAULT_LABEL_COLOR : icon.background;
		                }
	
		                this.label = new TextBox(text, deepExtend({}, label));
		                this.label.aliasFor = childAlias;
	
		                if (label.position === INSIDE && !defined(size)) {
		                    if (icon.type === CIRCLE) {
		                        size = Math.max(this.label.box.width(), this.label.box.height());
		                    } else {
		                        width = this.label.box.width();
		                        height = this.label.box.height();
		                    }
		                    box.wrap(this.label.box);
		                }
		            }
	
		            icon.width = width || size || DEFAULT_ICON_SIZE;
		            icon.height = height || size || DEFAULT_ICON_SIZE;
	
		            var marker = new ShapeElement(deepExtend({}, icon));
		            marker.aliasFor = childAlias;
	
		            this.marker = marker;
		            this.append(marker);
	
		            if (this.label) {
		                this.append(this.label);
		            }
	
		            marker.reflow(new Box());
		            this.wrapperBox = box.wrap(marker.box);
		        }
		    },
	
		    reflow: function(targetBox) {
		        var ref = this;
		        var options = ref.options;
		        var label = ref.label;
		        var marker = ref.marker;
		        var wrapperBox = ref.wrapperBox;
		        var center = targetBox.center();
		        var length = options.line.length;
		        var position = options.position;
	
		        // TODO: Review
		        if (options.visible) {
		            var lineStart, box, contentBox;
	
		            if (inArray(position, [ LEFT, RIGHT ])) {
		                if (position === LEFT) {
		                    contentBox = wrapperBox.alignTo(targetBox, position).translate(-length, targetBox.center().y - wrapperBox.center().y);
	
		                    if (options.line.visible) {
		                        lineStart = [ targetBox.x1, center.y ];
		                        this.linePoints = [
		                            lineStart,
		                            [ contentBox.x2, center.y ]
		                        ];
		                        box = contentBox.clone().wrapPoint(lineStart);
		                    }
		                } else {
		                    contentBox = wrapperBox.alignTo(targetBox, position).translate(length, targetBox.center().y - wrapperBox.center().y);
	
		                    if (options.line.visible) {
		                        lineStart = [ targetBox.x2, center.y ];
		                        this.linePoints = [
		                            lineStart,
		                            [ contentBox.x1, center.y ]
		                        ];
		                        box = contentBox.clone().wrapPoint(lineStart);
		                    }
		                }
		            } else {
		                if (position === BOTTOM) {
		                    contentBox = wrapperBox.alignTo(targetBox, position).translate(targetBox.center().x - wrapperBox.center().x, length);
	
		                    if (options.line.visible) {
		                        lineStart = [ center.x, targetBox.y2 ];
		                        this.linePoints = [
		                            lineStart,
		                            [ center.x, contentBox.y1 ]
		                        ];
		                        box = contentBox.clone().wrapPoint(lineStart);
		                    }
		                } else {
		                    contentBox = wrapperBox.alignTo(targetBox, position).translate(targetBox.center().x - wrapperBox.center().x, -length);
	
		                    if (options.line.visible) {
		                        lineStart = [ center.x, targetBox.y1 ];
		                        this.linePoints = [
		                            lineStart,
		                            [ center.x, contentBox.y2 ]
		                        ];
		                        box = contentBox.clone().wrapPoint(lineStart);
		                    }
		                }
		            }
	
		            if (marker) {
		                marker.reflow(contentBox);
		            }
	
		            if (label) {
		                label.reflow(contentBox);
		                if (marker) {
		                    if (options.label.position === OUTSIDE) {
		                        label.box.alignTo(marker.box, position);
		                    }
		                    label.reflow(label.box);
		                }
		            }
	
		            this.contentBox = contentBox;
		            this.targetBox = targetBox;
		            this.box = box || contentBox;
		        }
		    },
	
		    createVisual: function() {
		        BoxElement.fn.createVisual.call(this);
		        this.visual.options.noclip = this.options.noclip;
	
		        if (this.options.visible) {
		            this.createLine();
		        }
		    },
	
		    renderVisual: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var customVisual = options.visual;
		        if (options.visible && customVisual) {
		            this.visual = customVisual($.extend(this.fields, {
		                sender: this.getSender(),
		                rect: this.targetBox.toRect(),
		                options: {
		                    background: options.background,
		                    border: options.background,
		                    icon: options.icon,
		                    label: options.label,
		                    line: options.line,
		                    position: options.position,
		                    visible: options.visible
		                },
		                createVisual: function () {
		                    this$1.createVisual();
		                    this$1.renderChildren();
		                    var defaultVisual = this$1.visual;
		                    delete this$1.visual;
		                    return defaultVisual;
		                }
		            }));
		            this.addVisual();
		        } else {
		            BoxElement.fn.renderVisual.call(this);
		        }
		    },
	
		    createLine: function() {
		        var options = this.options.line;
	
		        if (this.linePoints) {
		            var path = Path.fromPoints(this.linePoints, {
		                stroke: {
		                    color: options.color,
		                    width: options.width,
		                    dashType: options.dashType
		                }
		            });
	
		            alignPathToPixel(path);
		            this.visual.append(path);
		        }
		    },
	
		    click: function(widget, e) {
		        var args = this.eventArgs(e);
	
		        if (!widget.trigger(NOTE_CLICK, args)) {
		            e.preventDefault();
		        }
		    },
	
		    over: function(widget, e) {
		        var args = this.eventArgs(e);
	
		        if (!widget.trigger(NOTE_HOVER, args)) {
		            e.preventDefault();
		        }
		    },
	
		    out: function(widget, e) {
		        var args = this.eventArgs(e);
	
		        widget.trigger(NOTE_LEAVE, args);
		    },
	
		    eventArgs: function(e) {
		        var options = this.options;
	
		        return $.extend(this.fields, {
		            element: eventElement(e),
		            text: defined(options.label) ? options.label.text : "",
		            visual: this.visual
		        });
		    }
		});
	
		setDefaultOptions(Note, {
		    icon: {
		        visible: true,
		        type: CIRCLE
		    },
		    label: {
		        position: INSIDE,
		        visible: true,
		        align: CENTER,
		        vAlign: CENTER
		    },
		    line: {
		        visible: true
		    },
		    visible: true,
		    position: TOP,
		    zIndex: 2
		});
	
		function createAxisTick(options, tickOptions) {
		    var tickX = options.tickX;
		    var tickY = options.tickY;
		    var position = options.position;
	
		    var tick = new Path({
		        stroke: {
		            width: tickOptions.width,
		            color: tickOptions.color
		        }
		    });
	
		    if (options.vertical) {
		        tick.moveTo(tickX, position)
		            .lineTo(tickX + tickOptions.size, position);
		    } else {
		        tick.moveTo(position, tickY)
		            .lineTo(position, tickY + tickOptions.size);
		    }
	
		    alignPathToPixel(tick);
	
		    return tick;
		}
	
		function createAxisGridLine(options, gridLine) {
		    var lineStart = options.lineStart;
		    var lineEnd = options.lineEnd;
		    var position = options.position;
	
		    var line = new Path({
		        stroke: {
		            width: gridLine.width,
		            color: gridLine.color,
		            dashType: gridLine.dashType
		        }
		    });
	
		    if (options.vertical) {
		        line.moveTo(lineStart, position)
		            .lineTo(lineEnd, position);
		    } else {
		        line.moveTo(position, lineStart)
		            .lineTo(position, lineEnd);
		    }
	
		    alignPathToPixel(line);
	
		    return line;
		}
	
		var Axis = ChartElement.extend({
		    init: function(options, chartService) {
		        if (chartService === void 0) { chartService = new ChartService(); }
	
		        ChartElement.fn.init.call(this, options);
	
		        this.chartService = chartService;
	
		        if (!this.options.visible) {
		            this.options = deepExtend({}, this.options, {
		                labels: {
		                    visible: false
		                },
		                line: {
		                    visible: false
		                },
		                margin: 0,
		                majorTickSize: 0,
		                minorTickSize: 0
		            });
		        }
	
		        this.options.minorTicks = deepExtend({}, {
		            color: this.options.line.color,
		            width: this.options.line.width,
		            visible: this.options.minorTickType !== NONE
		        }, this.options.minorTicks, {
		            size: this.options.minorTickSize,
		            align: this.options.minorTickType
		        });
	
		        this.options.majorTicks = deepExtend({}, {
		            color: this.options.line.color,
		            width: this.options.line.width,
		            visible: this.options.majorTickType !== NONE
		        }, this.options.majorTicks, {
		            size: this.options.majorTickSize,
		            align: this.options.majorTickType
		        });
	
		        this.initFields();
	
		        if (!this.options._deferLabels) {
		            this.createLabels();
		        }
	
		        this.createTitle();
		        this.createNotes();
		    },
	
		    initFields: function() {
		    },
	
		    labelsRange: function() {
		        return {
		            min: this.options.labels.skip,
		            max: this.labelsCount()
		        };
		    },
	
		    createLabels: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var align = options.vertical ? RIGHT : CENTER;
		        var labelOptions = deepExtend({ }, options.labels, {
		            align: align,
		            zIndex: options.zIndex
		        });
		        var step = Math.max(1, labelOptions.step);
	
		        this.clearLabels();
	
		        if (labelOptions.visible) {
		            var range = this.labelsRange();
		            var rotation = labelOptions.rotation;
	
		            if (isObject(rotation)) {
		                labelOptions.alignRotation = rotation.align;
		                labelOptions.rotation = rotation.angle;
		            }
	
		            if (labelOptions.rotation === "auto") {
		                labelOptions.rotation = 0;
		                options.autoRotateLabels = true;
		            }
	
		            for (var idx = range.min; idx < range.max; idx += step) {
		                var label = this$1.createAxisLabel(idx, labelOptions);
		                if (label) {
		                    this$1.append(label);
		                    this$1.labels.push(label);
		                }
		            }
		        }
		    },
	
		    clearLabels: function() {
		        this.children = grep(this.children, function (child) { return !(child instanceof AxisLabel); });
		        this.labels = [];
		    },
	
		    clearTitle: function() {
		        var this$1 = this;
	
		        if (this.title) {
		            this.children = grep(this.children, function (child) { return child !== this$1.title; });
		            this.title = undefined;
		        }
		    },
	
		    clear: function() {
		        this.clearLabels();
		        this.clearTitle();
		    },
	
		    lineBox: function() {
		        var ref = this;
		        var options = ref.options;
		        var box = ref.box;
		        var vertical = options.vertical;
		        var mirror = options.labels.mirror;
		        var axisX = mirror ? box.x1 : box.x2;
		        var axisY = mirror ? box.y2 : box.y1;
		        var lineWidth = options.line.width || 0;
	
		        return vertical ?
		            new Box(axisX, box.y1, axisX, box.y2 - lineWidth) :
		            new Box(box.x1, axisY, box.x2 - lineWidth, axisY);
		    },
	
		    createTitle: function() {
		        var options = this.options;
		        var titleOptions = deepExtend({
		            rotation: options.vertical ? -90 : 0,
		            text: "",
		            zIndex: 1,
		            visualSize: true
		        }, options.title);
	
		        if (titleOptions.visible && titleOptions.text) {
		            var title = new TextBox(titleOptions.text, titleOptions);
		            this.append(title);
		            this.title = title;
		        }
		    },
	
		    createNotes: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var notes = options.notes;
		        var items = notes.data || [];
	
		        this.notes = [];
	
		        for (var i = 0; i < items.length; i++) {
		            var item = deepExtend({}, notes, items[i]);
		            item.value = this$1.parseNoteValue(item.value);
	
		            var note = new Note({
		                value: item.value,
		                text: item.label.text,
		                dataItem: item
		            }, item, this$1.chartService);
	
		            if (note.options.visible) {
		                if (defined(note.options.position)) {
		                    if (options.vertical && !inArray(note.options.position, [ LEFT, RIGHT ])) {
		                        note.options.position = options.reverse ? LEFT : RIGHT;
		                    } else if (!options.vertical && !inArray(note.options.position, [ TOP, BOTTOM ])) {
		                        note.options.position = options.reverse ? BOTTOM : TOP;
		                    }
		                } else {
		                    if (options.vertical) {
		                        note.options.position = options.reverse ? LEFT : RIGHT;
		                    } else {
		                        note.options.position = options.reverse ? BOTTOM : TOP;
		                    }
		                }
		                this$1.append(note);
		                this$1.notes.push(note);
		            }
		        }
		    },
	
		    parseNoteValue: function(value) {
		        return value;
		    },
	
		    renderVisual: function() {
		        ChartElement.fn.renderVisual.call(this);
	
		        this.createPlotBands();
		    },
	
		    createVisual: function() {
		        ChartElement.fn.createVisual.call(this);
	
		        this.createBackground();
		        this.createLine();
		    },
	
		    gridLinesVisual: function() {
		        var gridLines = this._gridLines;
		        if (!gridLines) {
		            gridLines = this._gridLines = new Group({
		                zIndex: -2
		            });
		            this.appendVisual(this._gridLines);
		        }
	
		        return gridLines;
		    },
	
		    createTicks: function(lineGroup) {
		        var options = this.options;
		        var lineBox = this.lineBox();
		        var mirror = options.labels.mirror;
		        var majorUnit = options.majorTicks.visible ? options.majorUnit : 0;
		        var tickLineOptions = {
		            // TODO
		            // _alignLines: options._alignLines,
		            vertical: options.vertical
		        };
	
		        function render(tickPositions, tickOptions, skipUnit) {
		            var count = tickPositions.length;
		            var step = Math.max(1, tickOptions.step);
	
		            if (tickOptions.visible) {
		                for (var i = tickOptions.skip; i < count; i += step) {
		                    if (defined(skipUnit) && (i % skipUnit === 0)) {
		                        continue;
		                    }
	
		                    tickLineOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
		                    tickLineOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
		                    tickLineOptions.position = tickPositions[i];
	
		                    lineGroup.append(createAxisTick(tickLineOptions, tickOptions));
		                }
		            }
		        }
	
		        render(this.getMajorTickPositions(), options.majorTicks);
		        render(this.getMinorTickPositions(), options.minorTicks, majorUnit / options.minorUnit);
		    },
	
		    createLine: function() {
		        var options = this.options;
		        var line = options.line;
		        var lineBox = this.lineBox();
	
		        if (line.width > 0 && line.visible) {
		            var path = new Path({
		                stroke: {
		                    width: line.width,
		                    color: line.color,
		                    dashType: line.dashType
		                }
	
		                /* TODO
		                zIndex: line.zIndex,
		                */
		            });
	
		            path.moveTo(lineBox.x1, lineBox.y1)
		                .lineTo(lineBox.x2, lineBox.y2);
	
		            if (options._alignLines) {
		                alignPathToPixel(path);
		            }
	
		            var group = this._lineGroup = new Group();
		            group.append(path);
	
		            this.visual.append(group);
		            this.createTicks(group);
		        }
		    },
	
		    getActualTickSize: function() {
		        var options = this.options;
		        var tickSize = 0;
	
		        if (options.majorTicks.visible && options.minorTicks.visible) {
		            tickSize = Math.max(options.majorTicks.size, options.minorTicks.size);
		        } else if (options.majorTicks.visible) {
		            tickSize = options.majorTicks.size;
		        } else if (options.minorTicks.visible) {
		            tickSize = options.minorTicks.size;
		        }
	
		        return tickSize;
		    },
	
		    createBackground: function() {
		        var ref = this;
		        var options = ref.options;
		        var box = ref.box;
		        var background = options.background;
	
		        if (background) {
		            this._backgroundPath = Path.fromRect(box.toRect(), {
		                fill: {
		                    color: background
		                },
		                stroke: null
		            });
	
		            this.visual.append(this._backgroundPath);
		        }
		    },
	
		    createPlotBands: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var plotBands = options.plotBands || [];
		        var vertical = options.vertical;
		        var plotArea = this.plotArea;
	
		        if (plotBands.length === 0) {
		            return;
		        }
	
		        var group = this._plotbandGroup = new Group({
		            zIndex: -1
		        });
	
		        var altAxis = grep(this.pane.axes, function (axis) { return axis.options.vertical !== this$1.options.vertical; })[0];
	
		        for (var idx = 0; idx < plotBands.length; idx++) {
		            var item = plotBands[idx];
		            var slotX = (void 0), slotY = (void 0);
	
		            if (vertical) {
		                slotX = (altAxis || plotArea.axisX).lineBox();
		                slotY = this$1.getSlot(item.from, item.to, true);
		            } else {
		                slotX = this$1.getSlot(item.from, item.to, true);
		                slotY = (altAxis || plotArea.axisY).lineBox();
		            }
	
		            if (slotX.width() !== 0 && slotY.height() !== 0) {
		                var bandRect = new Rect(
		                    [ slotX.x1, slotY.y1 ],
		                    [ slotX.width(), slotY.height() ]
		                );
	
		                var path = Path.fromRect(bandRect, {
		                    fill: {
		                        color: item.color,
		                        opacity: item.opacity
		                    },
		                    stroke: null
		                });
	
		                group.append(path);
		            }
		        }
	
		        this.appendVisual(group);
		    },
	
		    createGridLines: function(altAxis) {
		        var options = this.options;
		        var minorGridLines = options.minorGridLines;
		        var majorGridLines = options.majorGridLines;
		        var minorUnit = options.minorUnit;
		        var vertical = options.vertical;
		        var axisLineVisible = altAxis.options.line.visible;
		        var majorUnit = majorGridLines.visible ? options.majorUnit : 0;
		        var lineBox = altAxis.lineBox();
		        var linePos = lineBox[vertical ? "y1" : "x1"];
		        var lineOptions = {
		            lineStart: lineBox[vertical ? "x1" : "y1"],
		            lineEnd: lineBox[vertical ? "x2" : "y2"],
		            vertical: vertical
		        };
		        var majorTicks = [];
	
		        var container = this.gridLinesVisual();
	
		        function render(tickPositions, gridLine, skipUnit) {
		            var count = tickPositions.length;
		            var step = Math.max(1, gridLine.step);
	
		            if (gridLine.visible) {
		                for (var i = gridLine.skip; i < count; i += step) {
		                    var pos = round(tickPositions[i]);
		                    if (!inArray(pos, majorTicks)) {
		                        if (i % skipUnit !== 0 && (!axisLineVisible || linePos !== pos)) {
		                            lineOptions.position = pos;
		                            container.append(createAxisGridLine(lineOptions, gridLine));
	
		                            majorTicks.push(pos);
		                        }
		                    }
		                }
		            }
		        }
	
		        render(this.getMajorTickPositions(), majorGridLines);
		        render(this.getMinorTickPositions(), minorGridLines, majorUnit / minorUnit);
	
		        return container.children;
		    },
	
		    reflow: function(box) {
		        var ref = this;
		        var options = ref.options;
		        var labels = ref.labels;
		        var title = ref.title;
		        var vertical = options.vertical;
		        var count = labels.length;
		        var sizeFn = vertical ? WIDTH : HEIGHT;
		        var titleSize = title ? title.box[sizeFn]() : 0;
		        var space = this.getActualTickSize() + options.margin + titleSize;
		        var rootBox = (this.getRoot() || {}).box || box;
		        var boxSize = rootBox[sizeFn]();
		        var maxLabelSize = 0;
	
		        for (var i = 0; i < count; i++) {
		            var labelSize = labels[i].box[sizeFn]();
		            if (labelSize + space <= boxSize) {
		                maxLabelSize = Math.max(maxLabelSize, labelSize);
		            }
		        }
	
		        if (vertical) {
		            this.box = new Box(
		                box.x1, box.y1,
		                box.x1 + maxLabelSize + space, box.y2
		            );
		        } else {
		            this.box = new Box(
		                box.x1, box.y1,
		                box.x2, box.y1 + maxLabelSize + space
		            );
		        }
	
		        this.arrangeTitle();
		        this.arrangeLabels();
		        this.arrangeNotes();
		    },
	
		    getLabelsTickPositions: function() {
		        return this.getMajorTickPositions();
		    },
	
		    labelTickIndex: function(label) {
		        return label.index;
		    },
	
		    arrangeLabels: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var labels = ref.labels;
		        var labelsBetweenTicks = this.labelsBetweenTicks();
		        var vertical = options.vertical;
		        var lineBox = this.lineBox();
		        var mirror = options.labels.mirror;
		        var tickPositions = this.getLabelsTickPositions();
		        var labelOffset = this.getActualTickSize() + options.margin;
	
		        for (var idx = 0; idx < labels.length; idx++) {
		            var label = labels[idx];
		            var tickIx = this$1.labelTickIndex(label);
		            var labelSize = vertical ? label.box.height() : label.box.width();
		            var labelPos = tickPositions[tickIx] - (labelSize / 2);
		            var labelBox = (void 0), firstTickPosition = (void 0), nextTickPosition = (void 0);
	
		            if (vertical) {
		                if (labelsBetweenTicks) {
		                    firstTickPosition = tickPositions[tickIx];
		                    nextTickPosition = tickPositions[tickIx + 1];
	
		                    var middle = firstTickPosition + (nextTickPosition - firstTickPosition) / 2;
		                    labelPos = middle - (labelSize / 2);
		                }
	
		                var labelX = lineBox.x2;
	
		                if (mirror) {
		                    labelX += labelOffset;
		                    label.options.rotationOrigin = LEFT;
		                } else {
		                    labelX -= labelOffset + label.box.width();
		                    label.options.rotationOrigin = RIGHT;
		                }
	
		                labelBox = label.box.move(labelX, labelPos);
		            } else {
		                if (labelsBetweenTicks) {
		                    firstTickPosition = tickPositions[tickIx];
		                    nextTickPosition = tickPositions[tickIx + 1];
		                } else {
		                    firstTickPosition = labelPos;
		                    nextTickPosition = labelPos + labelSize;
		                }
	
		                var labelY = lineBox.y1;
	
		                if (mirror) {
		                    labelY -= labelOffset + label.box.height();
		                    label.options.rotationOrigin = BOTTOM;
		                } else {
		                    labelY += labelOffset;
		                    label.options.rotationOrigin = TOP;
		                }
	
		                labelBox = new Box(firstTickPosition, labelY,
		                                nextTickPosition, labelY + label.box.height());
		            }
	
		            label.reflow(labelBox);
		        }
		    },
	
		    autoRotateLabels: function() {
		        if (this.options.autoRotateLabels && !this.options.vertical) {
		            var tickPositions = this.getMajorTickPositions();
		            var labels = this.labels;
		            var angle;
	
		            for (var idx = 0; idx < labels.length; idx++) {
		                var width = Math.abs(tickPositions[idx + 1] - tickPositions[idx]);
		                var labelBox = labels[idx].box;
	
		                if (labelBox.width() > width) {
		                    if (labelBox.height() > width) {
		                        angle = -90;
		                        break;
		                    }
		                    angle = -45;
		                }
		            }
	
		            if (angle) {
		                for (var idx$1 = 0; idx$1 < labels.length; idx$1++) {
		                    labels[idx$1].options.rotation = angle;
		                    labels[idx$1].reflow(new Box());
		                }
		                return true;
		            }
		        }
		    },
	
		    arrangeTitle: function() {
		        var ref = this;
		        var options = ref.options;
		        var title = ref.title;
		        var mirror = options.labels.mirror;
		        var vertical = options.vertical;
	
		        if (title) {
		            if (vertical) {
		                title.options.align = mirror ? RIGHT : LEFT;
		                title.options.vAlign = title.options.position;
		            } else {
		                title.options.align = title.options.position;
		                title.options.vAlign = mirror ? TOP : BOTTOM;
		            }
	
		            title.reflow(this.box);
		        }
		    },
	
		    arrangeNotes: function() {
		        var this$1 = this;
	
		        for (var idx = 0; idx < this.notes.length; idx++) {
		            var item = this$1.notes[idx];
		            var value = item.options.value;
		            var slot = (void 0);
	
		            if (defined(value)) {
		                if (this$1.shouldRenderNote(value)) {
		                    item.show();
		                } else {
		                    item.hide();
		                }
	
		                slot = this$1.noteSlot(value);
		            } else {
		                item.hide();
		            }
	
		            item.reflow(slot || this$1.lineBox());
		        }
		    },
	
		    noteSlot: function(value) {
		        return this.getSlot(value);
		    },
	
		    alignTo: function(secondAxis) {
		        var lineBox = secondAxis.lineBox();
		        var vertical = this.options.vertical;
		        var pos = vertical ? Y : X;
	
		        this.box.snapTo(lineBox, pos);
		        if (vertical) {
		            this.box.shrink(0, this.lineBox().height() - lineBox.height());
		        } else {
		            this.box.shrink(this.lineBox().width() - lineBox.width(), 0);
		        }
		        this.box[pos + 1] -= this.lineBox()[pos + 1] - lineBox[pos + 1];
		        this.box[pos + 2] -= this.lineBox()[pos + 2] - lineBox[pos + 2];
		    },
	
		    axisLabelText: function(value, dataItem, options) {
		        var tmpl = getTemplate(options);
		        var text = value;
	
		        if (tmpl) {
		            text = tmpl({ value: value, dataItem: dataItem, format: options.format, culture: options.culture });
		        } else if (options.format) {
		            text = this.chartService.format.localeAuto(options.format, [ value ], options.culture);
		        }
	
		        return text;
		    },
	
		    slot: function(from , to, limit) {
		        var slot = this.getSlot(from, to, limit);
		        if (slot) {
		            return slot.toRect();
		        }
		    },
	
		    contentBox: function() {
		        var box = this.box.clone();
		        var labels = this.labels;
		        if (labels.length) {
		            var axis = this.options.vertical ? Y : X;
		            if (this.chartService.isPannable(axis)) {
		                var offset = this.maxLabelOffset();
		                box[axis + 1] -= offset.start;
		                box[axis + 2] += offset.end;
		            } else {
		                if (labels[0].options.visible) {
		                    box.wrap(labels[0].box);
		                }
		                var lastLabel = labels[labels.length - 1];
		                if (lastLabel.options.visible) {
		                    box.wrap(lastLabel.box);
		                }
		            }
		        }
	
		        return box;
		    },
	
		    maxLabelOffset: function() {
		        var this$1 = this;
	
		        var ref = this.options;
		        var vertical = ref.vertical;
		        var reverse = ref.reverse;
		        var labelsBetweenTicks = this.labelsBetweenTicks();
		        var tickPositions = this.getLabelsTickPositions();
		        var offsetField = vertical ? Y : X;
		        var labels = this.labels;
		        var startPosition = reverse ? 1 : 0;
		        var endPosition = reverse ? 0 : 1;
		        var maxStartOffset = 0;
		        var maxEndOffset = 0;
	
		        for (var idx = 0; idx < labels.length; idx++) {
		            var label = labels[idx];
		            var tickIx = this$1.labelTickIndex(label);
		            var startTick = (void 0), endTick = (void 0);
	
		            if (labelsBetweenTicks) {
		                startTick = tickPositions[tickIx + startPosition];
		                endTick = tickPositions[tickIx + endPosition];
		            } else {
		                startTick = endTick = tickPositions[tickIx];
		            }
	
		            maxStartOffset = Math.max(maxStartOffset, startTick - label.box[offsetField + 1]);
		            maxEndOffset = Math.max(maxEndOffset, label.box[offsetField + 2] - endTick);
		        }
	
		        return {
		            start: maxStartOffset,
		            end: maxEndOffset
		        };
		    },
	
		    limitRange: function(from, to, min, max, offset) {
		        var options = this.options;
	
		        if ((from < min && offset < 0 && (!defined(options.min) || options.min <= min)) || (max < to && offset > 0 && (!defined(options.max) || max <= options.max))) {
		            return null;
		        }
	
		        if ((to < min && offset > 0) || (max < from && offset < 0)) {
		            return {
		                min: from,
		                max: to
		            };
		        }
	
		        var rangeSize = to - from;
		        var minValue = from;
		        var maxValue = to;
	
		        if (from < min && offset < 0) {
		            minValue = limitValue(from, min, max);
		            maxValue = limitValue(from + rangeSize, min + rangeSize, max);
		        } else if (to > max && offset > 0) {
		            maxValue = limitValue(to, min, max);
		            minValue = limitValue(to - rangeSize, min, max - rangeSize);
		        }
	
		        return {
		            min: minValue,
		            max: maxValue
		        };
		    },
	
		    valueRange: function() {
		        return {
		            min: this.seriesMin,
		            max: this.seriesMax
		        };
		    },
	
		    labelsBetweenTicks: function() {
		        return !this.options.justified;
		    },
	
		    prepareUserOptions: function() {
		    }
		});
	
		setDefaultOptions(Axis, {
		    labels: {
		        visible: true,
		        rotation: 0,
		        mirror: false,
		        step: 1,
		        skip: 0
		    },
		    line: {
		        width: 1,
		        color: BLACK,
		        visible: true
		    },
		    title: {
		        visible: true,
		        position: CENTER
		    },
		    majorTicks: {
		        align: OUTSIDE,
		        size: 4,
		        skip: 0,
		        step: 1
		    },
		    minorTicks: {
		        align: OUTSIDE,
		        size: 3,
		        skip: 0,
		        step: 1
		    },
		    axisCrossingValue: 0,
		    majorTickType: OUTSIDE,
		    minorTickType: NONE,
		    majorGridLines: {
		        skip: 0,
		        step: 1
		    },
		    minorGridLines: {
		        visible: false,
		        width: 1,
		        color: BLACK,
		        skip: 0,
		        step: 1
		    },
		    // TODO: Move to line or labels options
		    margin: 5,
		    visible: true,
		    reverse: false,
		    justified: true,
		    notes: {
		        label: {
		            text: ""
		        }
		    },
	
		    _alignLines: true,
		    _deferLabels: false
		});
	
		var MILLISECONDS = "milliseconds";
		var SECONDS = "seconds";
		var MINUTES = "minutes";
		var HOURS = "hours";
		var DAYS = "days";
		var WEEKS = "weeks";
		var MONTHS = "months";
		var YEARS = "years";
	
		var TIME_PER_MILLISECOND = 1;
		var TIME_PER_SECOND = 1000;
		var TIME_PER_MINUTE = 60 * TIME_PER_SECOND;
		var TIME_PER_HOUR = 60 * TIME_PER_MINUTE;
		var TIME_PER_DAY = 24 * TIME_PER_HOUR;
		var TIME_PER_WEEK = 7 * TIME_PER_DAY;
		var TIME_PER_MONTH = 31 * TIME_PER_DAY;
		var TIME_PER_YEAR = 365 * TIME_PER_DAY;
		var TIME_PER_UNIT = {
		    "years": TIME_PER_YEAR,
		    "months": TIME_PER_MONTH,
		    "weeks": TIME_PER_WEEK,
		    "days": TIME_PER_DAY,
		    "hours": TIME_PER_HOUR,
		    "minutes": TIME_PER_MINUTE,
		    "seconds": TIME_PER_SECOND,
		    "milliseconds": TIME_PER_MILLISECOND
		};
	
		function absoluteDateDiff(a, b) {
		    var diff = a.getTime() - b;
		    var offsetDiff = a.getTimezoneOffset() - b.getTimezoneOffset();
	
		    return diff - (offsetDiff * TIME_PER_MINUTE);
		}
	
		function addTicks(date, ticks) {
		    return new Date(date.getTime() + ticks);
		}
	
		function toDate(value) {
		    var result;
	
		    if (value instanceof Date) {
		        result = value;
		    } else if (value) {
		        result = new Date(value);
		    }
	
		    return result;
		}
	
		function startOfWeek(date, weekStartDay) {
		    if (weekStartDay === void 0) { weekStartDay = 0; }
	
		    var daysToSubtract = 0;
		    var day = date.getDay();
	
		    if (!isNaN(day)) {
		        while (day !== weekStartDay) {
		            if (day === 0) {
		                day = 6;
		            } else {
		                day--;
		            }
	
		            daysToSubtract++;
		        }
		    }
	
		    return addTicks(date, -daysToSubtract * TIME_PER_DAY);
		}
	
		function adjustDST(date, hours) {
		    if (hours === 0 && date.getHours() === 23) {
		        date.setHours(date.getHours() + 2);
		        return true;
		    }
	
		    return false;
		}
	
		function addHours(date, hours) {
		    var roundedDate = new Date(date);
	
		    roundedDate.setMinutes(0, 0, 0);
	
		    var tzDiff = (date.getTimezoneOffset() - roundedDate.getTimezoneOffset()) * TIME_PER_MINUTE;
	
		    return addTicks(roundedDate, tzDiff + hours * TIME_PER_HOUR);
		}
	
		function addDuration(dateValue, value, unit, weekStartDay) {
		    var result = dateValue;
	
		    if (dateValue) {
		        var date = toDate(dateValue);
		        var hours = date.getHours();
	
		        if (unit === YEARS) {
		            result = new Date(date.getFullYear() + value, 0, 1);
		            adjustDST(result, 0);
		        } else if (unit === MONTHS) {
		            result = new Date(date.getFullYear(), date.getMonth() + value, 1);
		            adjustDST(result, hours);
		        } else if (unit === WEEKS) {
		            result = addDuration(startOfWeek(date, weekStartDay), value * 7, DAYS);
		            adjustDST(result, hours);
		        } else if (unit === DAYS) {
		            result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + value);
		            adjustDST(result, hours);
		        } else if (unit === HOURS) {
		            result = addHours(date, value);
		        } else if (unit === MINUTES) {
		            result = addTicks(date, value * TIME_PER_MINUTE);
	
		            if (result.getSeconds() > 0) {
		                result.setSeconds(0);
		            }
		        } else if (unit === SECONDS) {
		            result = addTicks(date, value * TIME_PER_SECOND);
		        } else if (unit === MILLISECONDS) {
		            result = addTicks(date, value);
		        }
	
		        if (unit !== MILLISECONDS && result.getMilliseconds() > 0) {
		            result.setMilliseconds(0);
		        }
		    }
	
		    return result;
		}
	
		function floorDate(date, unit, weekStartDay) {
		    return addDuration(toDate(date), 0, unit, weekStartDay);
		}
	
		function ceilDate(dateValue, unit, weekStartDay) {
		    var date = toDate(dateValue);
	
		    if (date && floorDate(date, unit, weekStartDay).getTime() === date.getTime()) {
		        return date;
		    }
	
		    return addDuration(date, 1, unit, weekStartDay);
		}
	
		function dateComparer(a, b) {
		    if (a && b) {
		        return a.getTime() - b.getTime();
		    }
	
		    return -1;
		}
	
		function dateDiff(a, b) {
		    return a.getTime() - b;
		}
	
		function toTime(value) {
		    if (isArray(value)) {
		        var result = [];
		        for (var idx = 0; idx < value.length; idx++) {
		            result.push(toTime(value[idx]));
		        }
	
		        return result;
		    } else if (value) {
		        return toDate(value).getTime();
		    }
		}
	
		function dateEquals(a, b) {
		    if (a && b) {
		        return toTime(a) === toTime(b);
		    }
	
		    return a === b;
		}
	
		function timeIndex(date, start, baseUnit) {
		    return absoluteDateDiff(date, start) / TIME_PER_UNIT[baseUnit];
		}
	
		function dateIndex(value, start, baseUnit, baseUnitStep) {
		    var date = toDate(value);
		    var startDate = toDate(start);
		    var index;
	
		    if (baseUnit === MONTHS) {
		        index = (date.getMonth() - startDate.getMonth() + (date.getFullYear() - startDate.getFullYear()) * 12) +
		            timeIndex(date, new Date(date.getFullYear(), date.getMonth()), DAYS) / new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
		    } else if (baseUnit === YEARS) {
		        index = date.getFullYear() - startDate.getFullYear() + dateIndex(date, new Date(date.getFullYear(), 0), MONTHS, 1) / 12;
		    } else if (baseUnit === DAYS || baseUnit === WEEKS) {
		        index = timeIndex(date, startDate, baseUnit);
		    } else {
		        index = dateDiff(date, start) / TIME_PER_UNIT[baseUnit];
		    }
	
		    return index / baseUnitStep;
		}
	
		function duration(a, b, unit) {
		    var diff;
	
		    if (unit === YEARS) {
		        diff = b.getFullYear() - a.getFullYear();
		    } else if (unit === MONTHS) {
		        diff = duration(a, b, YEARS) * 12 + b.getMonth() - a.getMonth();
		    } else if (unit === DAYS) {
		        diff = Math.floor(dateDiff(b, a) / TIME_PER_DAY);
		    } else {
		        diff = Math.floor(dateDiff(b, a) / TIME_PER_UNIT[unit]);
		    }
	
		    return diff;
		}
	
		function lteDateIndex(date, sortedDates) {
		    var low = 0;
		    var high = sortedDates.length - 1;
		    var index;
	
		    while (low <= high) {
		        index = Math.floor((low + high) / 2);
		        var currentDate = sortedDates[index];
	
		        if (currentDate < date) {
		            low = index + 1;
		            continue;
		        }
	
		        if (currentDate > date) {
		            high = index - 1;
		            continue;
		        }
	
		        while (dateEquals(sortedDates[index - 1], date)) {
		            index--;
		        }
	
		        return index;
		    }
	
		    if (sortedDates[index] <= date) {
		        return index;
		    }
	
		    return index - 1;
		}
	
		function parseDate(intlService, date) {
		    var result;
		    if (isString(date)) {
		        result = intlService.parseDate(date) || toDate(date);
		    } else {
		        result = toDate(date);
		    }
		    return result;
		}
	
		function parseDates(intlService, dates) {
		    if (isArray(dates)) {
		        var result = [];
		        for (var idx = 0; idx < dates.length; idx++) {
		            result.push(parseDate(intlService, dates[idx]));
		        }
	
		        return result;
		    }
	
		    return parseDate(intlService, dates);
		}
	
		var MIN_CATEGORY_POINTS_RANGE = 0.01;
	
		function indexOf(value, arr) {
		    if (value instanceof Date) {
		        var length = arr.length;
		        for (var idx = 0; idx < length; idx++) {
		            if (dateEquals(arr[idx], value)) {
		                return idx;
		            }
		        }
	
		        return -1;
		    }
	
		    return arr.indexOf(value);
		}
	
		var CategoryAxis = Axis.extend({
		    initFields: function() {
		        this._ticks = {};
		    },
	
		    categoriesHash: function() {
		        return "";
		    },
	
		    clone: function() {
		        var copy = new CategoryAxis($.extend({}, this.options), this.chartService);
		        copy.createLabels();
	
		        return copy;
		    },
	
		    initUserOptions: function(options) {
		        var categories = options.categories || [];
		        var definedMin = defined(options.min);
		        var definedMax = defined(options.max);
		        options.srcCategories = options.categories = categories;
	
		        if ((definedMin || definedMax) && categories.length) {
		            var min = definedMin ? Math.floor(options.min) : 0;
		            var max;
	
		            if (definedMax) {
		                max = options.justified ? Math.floor(options.max) + 1 : Math.ceil(options.max);
		            } else {
		                max = categories.length;
		            }
	
		            options.categories = options.categories.slice(min, max);
		        }
	
		        return options;
		    },
	
		    rangeIndices: function() {
		        var options = this.options;
		        var length = options.categories.length || 1;
		        var min = isNumber(options.min) ? options.min % 1 : 0;
		        var max;
	
		        if (isNumber(options.max) && options.max % 1 !== 0 && options.max < this.totalRange().max) {
		            max = length - (1 - options.max % 1);
		        } else {
		            max = length - (options.justified ? 1 : 0);
		        }
	
		        return {
		            min: min,
		            max: max
		        };
		    },
	
		    totalRangeIndices: function(limit) {
		        var options = this.options;
		        var min = isNumber(options.min) ? options.min : 0;
		        var max;
	
		        if (isNumber(options.max)) {
		            max = options.max;
		        } else if (isNumber(options.min)) {
		            max = min + options.categories.length;
		        } else {
		            max = this.totalRange().max || 1;
		        }
	
		        if (limit) {
		            var totalRange = this.totalRange();
		            min = limitValue(min, 0, totalRange.max);
		            max = limitValue(max, 0, totalRange.max);
		        }
	
		        return {
		            min: min,
		            max: max
		        };
		    },
	
		    range: function() {
		        var options = this.options;
		        var min = isNumber(options.min) ? options.min : 0;
		        var max = isNumber(options.max) ? options.max : this.totalRange().max;
	
		        return {
		            min: min,
		            max: max
		        };
		    },
	
		    totalRange: function() {
		        var options = this.options;
		        return { min: 0, max: Math.max(this._seriesMax || 0, options.srcCategories.length) - (options.justified ? 1 : 0) };
		    },
	
		    scaleOptions: function() {
		        var ref = this.rangeIndices();
		        var min = ref.min;
		        var max = ref.max;
		        var lineBox = this.lineBox();
		        var size = this.options.vertical ? lineBox.height() : lineBox.width();
		        var scale = size / ((max - min) || 1);
	
		        return {
		            scale: scale * (this.options.reverse ? -1 : 1),
		            box: lineBox,
		            min: min,
		            max: max
		        };
		    },
	
		    arrangeLabels: function() {
		        Axis.fn.arrangeLabels.call(this);
		        this.hideOutOfRangeLabels();
		    },
	
		    hideOutOfRangeLabels: function() {
		        var ref = this;
		        var box = ref.box;
		        var labels = ref.labels;
	
		        if (labels.length) {
		            var valueAxis = this.options.vertical ? Y : X;
		            var start = box[valueAxis + 1];
		            var end = box[valueAxis + 2];
		            var firstLabel = labels[0];
		            var lastLabel = last(labels);
	
		            if (firstLabel.box[valueAxis + 1] > end || firstLabel.box[valueAxis + 2] < start) {
		                firstLabel.options.visible = false;
		            }
		            if (lastLabel.box[valueAxis + 1] > end || lastLabel.box[valueAxis + 2] < start) {
		                lastLabel.options.visible = false;
		            }
		        }
		    },
	
		    getMajorTickPositions: function() {
		        return this.getTicks().majorTicks;
		    },
	
		    getMinorTickPositions: function() {
		        return this.getTicks().minorTicks;
		    },
	
		    getLabelsTickPositions: function() {
		        return this.getTicks().labelTicks;
		    },
	
		    tickIndices: function(stepSize) {
		        var ref = this.rangeIndices();
		        var min = ref.min;
		        var max = ref.max;
		        var limit = Math.ceil(max);
		        var current = Math.floor(min);
		        var indices = [];
	
		        while (current <= limit) {
		            indices.push(current);
		            current += stepSize;
		        }
	
		        return indices;
		    },
	
		    getTickPositions: function(stepSize) {
		        var ref = this.options;
		        var vertical = ref.vertical;
		        var reverse = ref.reverse;
		        var ref$1 = this.scaleOptions();
		        var scale = ref$1.scale;
		        var box = ref$1.box;
		        var min = ref$1.min;
		        var pos = box[(vertical ? Y : X) + (reverse ? 2 : 1)];
		        var indices = this.tickIndices(stepSize);
		        var positions = [];
	
		        for (var idx = 0; idx < indices.length; idx++) {
		            positions.push(pos + round(scale * (indices[idx] - min), COORD_PRECISION));
		        }
	
		        return positions;
		    },
	
		    getTicks: function() {
		        var options = this.options;
		        var cache = this._ticks;
		        var range = this.rangeIndices();
		        var lineBox = this.lineBox();
		        var hash = lineBox.getHash() + range.min + "," + range.max + options.reverse + options.justified;
	
		        if (cache._hash !== hash) {
		            var hasMinor = options.minorTicks.visible || options.minorGridLines.visible;
		            cache._hash = hash;
		            cache.labelTicks = this.getTickPositions(1);
		            cache.majorTicks = this.filterOutOfRangePositions(cache.labelTicks, lineBox);
		            cache.minorTicks = hasMinor ? this.filterOutOfRangePositions(this.getTickPositions(0.5), lineBox) : [];
		        }
	
		        return cache;
		    },
	
		    filterOutOfRangePositions: function(positions, lineBox) {
		        if (!positions.length) {
		            return positions;
		        }
	
		        var axis = this.options.vertical ? Y : X;
		        var inRange = function (position) { return lineBox[axis + 1] <= position && position <= lineBox[axis + 2]; };
	
		        var end = positions.length - 1;
		        var startIndex = 0;
		        while (!inRange(positions[startIndex]) && startIndex <= end) {
		            startIndex++;
		        }
	
		        var endIndex = end;
	
		        while (!inRange(positions[endIndex]) && endIndex >= 0) {
		            endIndex--;
		        }
	
		        return positions.slice(startIndex, endIndex + 1);
		    },
	
		    getSlot: function(from, to, limit) {
		        var options = this.options;
		        var reverse = options.reverse;
		        var justified = options.justified;
		        var vertical = options.vertical;
		        var ref = this.scaleOptions();
		        var scale = ref.scale;
		        var box = ref.box;
		        var min = ref.min;
		        var valueAxis = vertical ? Y : X;
		        var lineStart = box[valueAxis + (reverse ? 2 : 1)];
		        var slotBox = box.clone();
		        var singleSlot = !defined(to);
	
		        var start = valueOrDefault(from, 0);
		        var end = valueOrDefault(to, start);
		        end = Math.max(end - 1, start);
	
		        // Fixes transient bug caused by iOS 6.0 JIT
		        // (one can never be too sure)
		        end = Math.max(start, end);
	
		        var p1 = lineStart + (start - min) * scale;
		        var p2 = lineStart + (end + 1 - min) * scale;
	
		        if (singleSlot && justified) {
		            p2 = p1;
		        }
	
		        if (limit) {
		            p1 = limitValue(p1, box[valueAxis + 1], box[valueAxis + 2]);
		            p2 = limitValue(p2, box[valueAxis + 1], box[valueAxis + 2]);
		        }
	
		        slotBox[valueAxis + 1] = reverse ? p2 : p1;
		        slotBox[valueAxis + 2] = reverse ? p1 : p2;
	
		        return slotBox;
		    },
	
		    limitSlot: function(slot) {
		        var vertical = this.options.vertical;
		        var valueAxis = vertical ? Y : X;
		        var lineBox = this.lineBox();
		        var limittedSlot = slot.clone();
	
		        limittedSlot[valueAxis + 1] = limitValue(slot[valueAxis + 1], lineBox[valueAxis + 1], lineBox[valueAxis + 2]);
		        limittedSlot[valueAxis + 2] = limitValue(slot[valueAxis + 2], lineBox[valueAxis + 1], lineBox[valueAxis + 2]);
	
		        return limittedSlot;
		    },
	
		    slot: function(from, to, limit) {
		        var min = Math.floor(this.options.min || 0);
		        var start = from;
		        var end = to;
	
		        if (typeof start === "string") {
		            start = this.categoryIndex(start);
		        } else if (isNumber(start)) {
		            start -= min;
		        }
	
		        if (typeof end === "string") {
		            end = this.categoryIndex(end);
		        } else if (isNumber(end)) {
		            end -= min;
		        }
	
		        return Axis.fn.slot.call(this, start, end, limit);
		    },
	
		    pointCategoryIndex: function(point) {
		        var ref = this.options;
		        var reverse = ref.reverse;
		        var justified = ref.justified;
		        var vertical = ref.vertical;
		        var valueAxis = vertical ? Y : X;
		        var ref$1 = this.scaleOptions();
		        var scale = ref$1.scale;
		        var box = ref$1.box;
		        var min = ref$1.min;
		        var max = ref$1.max;
		        var startValue = reverse ? max : min;
		        var lineStart = box[valueAxis + 1];
		        var lineEnd = box[valueAxis + 2];
		        var pos = point[valueAxis];
	
		        if (pos < lineStart || pos > lineEnd) {
		            return null;
		        }
	
		        var value = startValue + (pos - lineStart) / scale;
		        var diff = value % 1;
	
		        if (justified) {
		            value = Math.round(value);
		        } else if (diff === 0 && value > 0) {
		            value--;
		        }
	
		        return Math.floor(value);
		    },
	
		    getCategory: function(point) {
		        var index = this.pointCategoryIndex(point);
	
		        if (index === null) {
		            return null;
		        }
	
		        return this.options.categories[index];
		    },
	
		    categoryIndex: function(value) {
		        return this.totalIndex(value) - Math.floor(this.options.min || 0);
		    },
	
		    categoryAt: function(index, total) {
		        var options = this.options;
	
		        return (total ? options.srcCategories : options.categories)[index];
		    },
	
		    categoriesCount: function() {
		        return (this.options.categories || []).length;
		    },
	
		    translateRange: function(delta) {
		        var options = this.options;
		        var lineBox = this.lineBox();
		        var size = options.vertical ? lineBox.height() : lineBox.width();
		        var range = options.categories.length;
		        var scale = size / range;
		        var offset = round(delta / scale, DEFAULT_PRECISION);
	
		        return {
		            min: offset,
		            max: range + offset
		        };
		    },
	
		    zoomRange: function(rate) {
		        var rangeIndices = this.totalRangeIndices();
		        var ref = this.totalRange();
		        var totalMin = ref.min;
		        var totalMax = ref.max;
		        var min = limitValue(rangeIndices.min + rate, totalMin, totalMax);
		        var max = limitValue(rangeIndices.max - rate, totalMin, totalMax);
	
		        if (max - min > 0) {
		            return {
		                min: min,
		                max: max
		            };
		        }
		    },
	
		    scaleRange: function(scale) {
		        var range = this.options.categories.length;
		        var delta = scale * range;
	
		        return {
		            min: -delta,
		            max: range + delta
		        };
		    },
	
		    labelsCount: function() {
		        var labelsRange = this.labelsRange();
	
		        return labelsRange.max - labelsRange.min;
		    },
	
		    labelsRange: function() {
		        var options = this.options;
		        var justified = options.justified;
		        var labelOptions = options.labels;
		        var ref = this.totalRangeIndices(true);
		        var min = ref.min;
		        var max = ref.max;
		        var start = Math.floor(min);
	
		        if (!justified) {
		            min = Math.floor(min);
		            max = Math.ceil(max);
		        } else {
		            min = Math.ceil(min);
		            max = Math.floor(max);
		        }
	
		        var skip;
	
		        if (min > labelOptions.skip) {
		            skip = labelOptions.skip + labelOptions.step * Math.ceil((min - labelOptions.skip) / labelOptions.step);
		        } else {
		            skip = labelOptions.skip;
		        }
	
		        return {
		            min: skip - start,
		            max: (options.categories.length ? max + (justified ? 1 : 0) : 0) - start
		        };
		    },
	
		    createAxisLabel: function(index, labelOptions) {
		        var options = this.options;
		        var dataItem = options.dataItems ? options.dataItems[index] : null;
		        var category = valueOrDefault(options.categories[index], "");
		        var text = this.axisLabelText(category, dataItem, labelOptions);
	
		        return new AxisLabel(category, text, index, dataItem, labelOptions);
		    },
	
		    shouldRenderNote: function(value) {
		        var range = this.totalRangeIndices();
	
		        return Math.floor(range.min) <= value && value <= Math.ceil(range.max);
		    },
	
		    noteSlot: function(value) {
		        var options = this.options;
		        var index = value - Math.floor(options.min || 0);
		        return this.getSlot(index);
		    },
	
		    arrangeNotes: function() {
		        Axis.fn.arrangeNotes.call(this);
		        this.hideOutOfRangeNotes();
		    },
	
		    hideOutOfRangeNotes: function() {
		        var ref = this;
		        var notes = ref.notes;
		        var box = ref.box;
		        if (notes && notes.length) {
		            var valueAxis = this.options.vertical ? Y : X;
		            var start = box[valueAxis + 1];
		            var end = box[valueAxis + 2];
	
		            for (var idx = 0; idx < notes.length; idx++) {
		                var note = notes[idx];
		                if (note.box && (end < note.box[valueAxis + 1] || note.box[valueAxis + 2] < start)) {
		                    note.hide();
		                }
		            }
		        }
		    },
	
		    pan: function(delta) {
		        var range = this.totalRangeIndices(true);
		        var ref = this.scaleOptions();
		        var scale = ref.scale;
		        var offset = round(delta / scale, DEFAULT_PRECISION);
		        var totalRange = this.totalRange();
		        var min = range.min + offset;
		        var max = range.max + offset;
	
		        return this.limitRange(min, max, 0, totalRange.max, offset);
		    },
	
		    pointsRange: function(start, end) {
		        var ref = this.options;
		        var reverse = ref.reverse;
		        var vertical = ref.vertical;
		        var valueAxis = vertical ? Y : X;
		        var range = this.totalRangeIndices(true);
		        var ref$1 = this.scaleOptions();
		        var scale = ref$1.scale;
		        var box = ref$1.box;
		        var lineStart = box[valueAxis + (reverse ? 2 : 1)];
	
		        var diffStart = start[valueAxis] - lineStart;
		        var diffEnd = end[valueAxis] - lineStart;
	
		        var min = range.min + diffStart / scale;
		        var max = range.min + diffEnd / scale;
		        var rangeMin = Math.min(min, max);
		        var rangeMax = Math.max(min, max);
	
		        if (rangeMax - rangeMin >= MIN_CATEGORY_POINTS_RANGE) {
		            return {
		                min: rangeMin,
		                max: rangeMax
		            };
		        }
		    },
	
		    valueRange: function() {
		        return this.range();
		    },
	
		    totalIndex: function(value) {
		        var options = this.options;
		        var index = this._categoriesMap ?
		            this._categoriesMap.get(value) : indexOf(value, options.srcCategories);
	
		        return index;
		    },
	
		    currentRangeIndices: function() {
		        var options = this.options;
		        var min = 0;
	
		        if (isNumber(options.min)) {
		            min = Math.floor(options.min);
		        }
	
		        var max;
		        if (isNumber(options.max)) {
		            max = options.justified ? Math.floor(options.max) : Math.ceil(options.max) - 1;
		        } else {
		            max = this.totalCount() - 1;
		        }
	
		        return {
		            min: min,
		            max: max
		        };
		    },
	
		    mapCategories: function() {
		        if (!this._categoriesMap) {
		            var map$$1 = this._categoriesMap = new HashMap();
		            var srcCategories = this.options.srcCategories;
		            for (var idx = 0; idx < srcCategories.length; idx++) {
		                map$$1.set(srcCategories[idx], idx);
		            }
		        }
		    },
	
		    totalCount: function() {
		        return Math.max(this.options.srcCategories.length, this._seriesMax || 0);
		    }
		});
	
		setDefaultOptions(CategoryAxis, {
		    type: "category",
		    vertical: false,
		    majorGridLines: {
		        visible: false,
		        width: 1,
		        color: BLACK
		    },
		    labels: {
		        zIndex: 1
		    },
		    justified: false,
		    _deferLabels: true
		});
	
		var COORDINATE_LIMIT = 300000;
	
		var DateLabelFormats = {
		    milliseconds: "HH:mm:ss.fff",
		    seconds: "HH:mm:ss",
		    minutes: "HH:mm",
		    hours: "HH:mm",
		    days: "M/d",
		    weeks: "M/d",
		    months: "MMM 'yy",
		    years: "yyyy"
		};
	
		var ZERO_THRESHOLD = 0.2;
	
		var AUTO = "auto";
		var BASE_UNITS = [
		    MILLISECONDS, SECONDS, MINUTES, HOURS, DAYS, WEEKS, MONTHS, YEARS
		];
		var FIT = "fit";
	
		function categoryRange(categories) {
		    var range = categories._range;
		    if (!range) {
		        range = categories._range = sparseArrayLimits(categories);
		        range.min = toDate(range.min);
		        range.max = toDate(range.max);
		    }
	
		    return range;
		}
	
		var EmptyDateRange = Class.extend({
		    init: function(options) {
		        this.options = options;
		    },
	
		    displayIndices: function() {
		        return {
		            min: 0,
		            max: 1
		        };
		    },
	
		    displayRange: function() {
		        return {};
		    },
	
		    total: function() {
		        return {};
		    },
	
		    valueRange: function() {
		        return {};
		    },
	
		    valueIndex: function() {
		        return -1;
		    },
	
		    values: function() {
		        return [];
		    },
	
		    totalIndex: function() {
		        return -1;
		    },
	
		    valuesCount: function() {
		        return 0;
		    },
	
		    totalCount: function() {
		        return 0;
		    },
	
		    dateAt: function() {
		        return null;
		    }
		});
	
		var DateRange = Class.extend({
		    init: function(start, end, options) {
		        this.options = options;
		        options.baseUnitStep = options.baseUnitStep || 1;
	
		        var roundToBaseUnit = options.roundToBaseUnit;
		        var justified = options.justified;
	
		        this.start = addDuration(start, 0, options.baseUnit, options.weekStartDay);
		        var lowerEnd = this.roundToTotalStep(end);
		        var expandEnd = !justified && dateEquals(end, lowerEnd) && !options.justifyEnd;
	
		        this.end = this.roundToTotalStep(end, !justified, expandEnd ? 1 : 0);
	
		        var min = options.min || start;
		        this.valueStart = this.roundToTotalStep(min);
		        this.displayStart = roundToBaseUnit ? this.valueStart : min;
	
		        var max = options.max;
		        if (!max) {
		            this.valueEnd = lowerEnd;
		            this.displayEnd = roundToBaseUnit || expandEnd ? this.end : end;
		        } else {
		            this.valueEnd = this.roundToTotalStep(max, false, !justified && dateEquals(max, this.roundToTotalStep(max)) ? -1 : 0);
		            this.displayEnd = roundToBaseUnit ? this.roundToTotalStep(max, !justified) : options.max;
		        }
	
		        if (this.valueEnd < this.valueStart) {
		            this.valueEnd = this.valueStart;
		        }
		        if (this.displayEnd <= this.displayStart) {
		            this.displayEnd = this.roundToTotalStep(this.displayStart, false, 1);
		        }
		    },
	
		    displayRange: function() {
		        return {
		            min: this.displayStart,
		            max: this.displayEnd
		        };
		    },
	
		    displayIndices: function() {
		        if (!this._indices) {
		            var options = this.options;
	
		            var baseUnit = options.baseUnit;
		            var baseUnitStep = options.baseUnitStep;
	
		            var minIdx = dateIndex(this.displayStart, this.valueStart, baseUnit, baseUnitStep);
		            var maxIdx = dateIndex(this.displayEnd, this.valueStart, baseUnit, baseUnitStep);
	
		            this._indices = { min: minIdx, max: maxIdx };
		        }
	
		        return this._indices;
		    },
	
		    total: function() {
		        return {
		            min: this.start,
		            max: this.end
		        };
		    },
	
		    totalCount: function() {
		        var last$$1 = this.totalIndex(this.end);
	
		        return last$$1 + (this.options.justified ? 1 : 0);
		    },
	
		    valueRange: function() {
		        return {
		            min: this.valueStart,
		            max: this.valueEnd
		        };
		    },
	
		    valueIndex: function(value) {
		        var options = this.options;
		        return Math.floor(dateIndex(value, this.valueStart, options.baseUnit, options.baseUnitStep));
		    },
	
		    totalIndex: function(value) {
		        var options = this.options;
		        return Math.floor(dateIndex(value, this.start, options.baseUnit, options.baseUnitStep));
		    },
	
		    dateIndex: function(value) {
		        var options = this.options;
		        return dateIndex(value, this.valueStart, options.baseUnit, options.baseUnitStep);
		    },
	
		    valuesCount: function() {
		        var maxIdx = this.valueIndex(this.valueEnd);
	
		        return maxIdx + 1;
		    },
	
		    values: function() {
		        var values = this._values;
		        if (!values) {
		            var options = this.options;
		            var range = this.valueRange();
		            this._values = values = [];
	
		            for (var date = range.min; date <= range.max;) {
		                values.push(date);
		                date = addDuration(date, options.baseUnitStep, options.baseUnit, options.weekStartDay);
		            }
		        }
	
		        return values;
		    },
	
		    dateAt: function(index, total) {
		        var options = this.options;
	
		        return addDuration(total ? this.start : this.valueStart, options.baseUnitStep * index, options.baseUnit, options.weekStartDay);
		    },
	
		    roundToTotalStep: function(value, upper, next) {
		        var ref = this.options;
		        var baseUnit = ref.baseUnit;
		        var baseUnitStep = ref.baseUnitStep;
		        var weekStartDay = ref.weekStartDay;
		        var start = this.start;
	
		        var step = dateIndex(value, start, baseUnit, baseUnitStep);
		        var roundedStep = upper ? Math.ceil(step) : Math.floor(step);
	
		        if (next) {
		            roundedStep += next;
		        }
	
		        return addDuration(start, roundedStep * baseUnitStep, baseUnit, weekStartDay);
		    }
		});
	
		function autoBaseUnit(options, startUnit, startStep) {
		    var categoryLimits = categoryRange(options.categories);
		    var span = (options.max || categoryLimits.max) - (options.min || categoryLimits.min);
		    var autoBaseUnitSteps = options.autoBaseUnitSteps;
		    var maxDateGroups = options.maxDateGroups;
		    var autoUnit = options.baseUnit === FIT;
		    var autoUnitIx = startUnit ? BASE_UNITS.indexOf(startUnit) : 0;
		    var baseUnit = autoUnit ? BASE_UNITS[autoUnitIx++] : options.baseUnit;
		    var units = span / TIME_PER_UNIT[baseUnit];
		    var totalUnits = units;
		    var unitSteps, step, nextStep;
	
		    while (!step || units >= maxDateGroups) {
		        unitSteps = unitSteps || autoBaseUnitSteps[baseUnit].slice(0);
	
		        do {
		            nextStep = unitSteps.shift();
		        } while (nextStep && startUnit === baseUnit && nextStep < startStep);
	
		        if (nextStep) {
		            step = nextStep;
		            units = totalUnits / step;
		        } else if (baseUnit === last(BASE_UNITS)) {
		            step = Math.ceil(totalUnits / maxDateGroups);
		            break;
		        } else if (autoUnit) {
		            baseUnit = BASE_UNITS[autoUnitIx++] || last(BASE_UNITS);
		            totalUnits = span / TIME_PER_UNIT[baseUnit];
		            unitSteps = null;
		        } else {
		            if (units > maxDateGroups) {
		                step = Math.ceil(totalUnits / maxDateGroups);
		            }
		            break;
		        }
		    }
	
		    options.baseUnitStep = step;
		    options.baseUnit = baseUnit;
		}
	
		function defaultBaseUnit(options) {
		    var categories = options.categories;
		    var count = defined(categories) ? categories.length : 0;
		    var minDiff = MAX_VALUE;
		    var lastCategory, unit;
	
		    for (var categoryIx = 0; categoryIx < count; categoryIx++) {
		        var category = categories[categoryIx];
	
		        if (category && lastCategory) {
		            var diff = absoluteDateDiff(category, lastCategory);
		            if (diff > 0) {
		                minDiff = Math.min(minDiff, diff);
	
		                if (minDiff >= TIME_PER_YEAR) {
		                    unit = YEARS;
		                } else if (minDiff >= TIME_PER_MONTH - TIME_PER_DAY * 3) {
		                    unit = MONTHS;
		                } else if (minDiff >= TIME_PER_WEEK) {
		                    unit = WEEKS;
		                } else if (minDiff >= TIME_PER_DAY) {
		                    unit = DAYS;
		                } else if (minDiff >= TIME_PER_HOUR) {
		                    unit = HOURS;
		                } else if (minDiff >= TIME_PER_MINUTE) {
		                    unit = MINUTES;
		                } else {
		                    unit = SECONDS;
		                }
		            }
		        }
	
		        lastCategory = category;
		    }
	
		    options.baseUnit = unit || DAYS;
		}
	
		function initUnit(options) {
		    var baseUnit = (options.baseUnit || "").toLowerCase();
		    var useDefault = baseUnit !== FIT && !inArray(baseUnit, BASE_UNITS);
	
		    if (useDefault) {
		        defaultBaseUnit(options);
		    }
	
		    if (baseUnit === FIT || options.baseUnitStep === AUTO) {
		        autoBaseUnit(options);
		    }
	
		    return options;
		}
	
		var DateCategoryAxis = CategoryAxis.extend({
		    clone: function() {
		        var copy = new DateCategoryAxis($.extend({}, this.options), this.chartService);
		        copy.createLabels();
	
		        return copy;
		    },
	
		    categoriesHash: function() {
		        var start = this.dataRange.total().min;
		        return this.options.baseUnit + this.options.baseUnitStep + start;
		    },
	
		    initUserOptions: function(options) {
		        return options;
		    },
	
		    initFields: function() {
		        CategoryAxis.fn.initFields.call(this);
	
		        var chartService = this.chartService;
		        var intlService = chartService.intl;
		        var options = this.options;
	
		        var categories = options.categories || [];
		        if (!categories._parsed) {
		            categories = parseDates(intlService, categories);
		            categories._parsed = true;
		        }
	
		        options = deepExtend({
		            roundToBaseUnit: true
		        }, options, {
		            categories: categories,
		            min: parseDate(intlService, options.min),
		            max: parseDate(intlService, options.max)
		        });
	
		        if (chartService.panning && chartService.isPannable(options.vertical ? Y : X)) {
		            options.roundToBaseUnit = false;
		        }
	
		        options.userSetBaseUnit = options.userSetBaseUnit || options.baseUnit;
		        options.userSetBaseUnitStep = options.userSetBaseUnitStep || options.baseUnitStep;
	
		        this.options = options;
		        options.srcCategories = categories;
	
		        if (categories.length > 0) {
		            var range = categoryRange(categories);
		            var maxDivisions = options.maxDivisions;
	
		            this.dataRange = new DateRange(range.min, range.max, initUnit(options));
	
		            if (maxDivisions) {
		                var dataRange = this.dataRange.displayRange();
	
		                var divisionOptions = $.extend({}, options, {
		                    justified: true,
		                    roundToBaseUnit: false,
		                    baseUnit: 'fit',
		                    min: dataRange.min,
		                    max: dataRange.max,
		                    maxDateGroups: maxDivisions
		                });
	
		                var dataRangeOptions = this.dataRange.options;
	
		                autoBaseUnit(divisionOptions, dataRangeOptions.baseUnit, dataRangeOptions.baseUnitStep);
	
		                this.divisionRange = new DateRange(range.min, range.max, divisionOptions);
		            } else {
		                this.divisionRange = this.dataRange;
		            }
	
		        } else {
		            options.baseUnit = options.baseUnit || DAYS;
		            this.dataRange = this.divisionRange = new EmptyDateRange(options);
		        }
		    },
	
		    tickIndices: function(stepSize) {
		        var ref = this;
		        var dataRange = ref.dataRange;
		        var divisionRange = ref.divisionRange;
		        var valuesCount = divisionRange.valuesCount();
	
		        if (!this.options.maxDivisions || !valuesCount) {
		            return CategoryAxis.fn.tickIndices.call(this, stepSize);
		        }
	
		        var indices = [];
		        var values = divisionRange.values();
		        var offset = 0;
	
		        if (!this.options.justified) {
		            values = values.concat(divisionRange.dateAt(valuesCount));
		            offset = 0.5;//align ticks to the center of not justified categories
		        }
	
		        for (var idx = 0; idx < values.length; idx++) {
		            indices.push(dataRange.dateIndex(values[idx]) + offset);
		            if (stepSize !== 1 && idx >= 1) {
		                var last$$1 = indices.length - 1;
		                indices.splice(idx, 0, indices[last$$1 - 1] + (indices[last$$1] - indices[last$$1 - 1]) * stepSize);
		            }
		        }
	
		        return indices;
		    },
	
		    shouldRenderNote: function(value) {
		        var range = this.range();
		        var categories = this.options.categories || [];
	
		        return dateComparer(value, range.min) >= 0 && dateComparer(value, range.max) <= 0 && categories.length;
		    },
	
		    parseNoteValue: function(value) {
		        return parseDate(this.chartService.intl, value);
		    },
	
		    noteSlot: function(value) {
		        return this.getSlot(value);
		    },
	
		    translateRange: function(delta) {
		        var options = this.options;
		        var baseUnit = options.baseUnit;
		        var weekStartDay = options.weekStartDay;
		        var vertical = options.vertical;
		        var lineBox = this.lineBox();
		        var size = vertical ? lineBox.height() : lineBox.width();
		        var range = this.range();
		        var scale = size / (range.max - range.min);
		        var offset = round(delta / scale, DEFAULT_PRECISION);
	
		        if (range.min && range.max) {
		            var from = addTicks(options.min || range.min, offset);
		            var to = addTicks(options.max || range.max, offset);
	
		            range = {
		                min: addDuration(from, 0, baseUnit, weekStartDay),
		                max: addDuration(to, 0, baseUnit, weekStartDay)
		            };
		        }
	
		        return range;
		    },
	
		    scaleRange: function(delta) {
		        var rounds = Math.abs(delta);
		        var result = this.range();
		        var from = result.min;
		        var to = result.max;
	
		        if (from && to) {
		            while (rounds--) {
		                var range = dateDiff(from, to);
		                var step = Math.round(range * 0.1);
		                if (delta < 0) {
		                    from = addTicks(from, step);
		                    to = addTicks(to, -step);
		                } else {
		                    from = addTicks(from, -step);
		                    to = addTicks(to, step);
		                }
		            }
	
		            result = { min: from, max: to };
		        }
	
		        return result;
		    },
	
		    labelsRange: function() {
		        return {
		            min: this.options.labels.skip,
		            max: this.divisionRange.valuesCount()
		        };
		    },
	
		    pan: function(delta) {
		        if (this.isEmpty()) {
		            return null;
		        }
	
		        var options = this.options;
		        var lineBox = this.lineBox();
		        var size = options.vertical ? lineBox.height() : lineBox.width();
		        var ref = this.dataRange.displayRange();
		        var min = ref.min;
		        var max = ref.max;
		        var totalLimits = this.dataRange.total();
		        var scale = size / (max - min);
		        var offset = round(delta / scale, DEFAULT_PRECISION) * (options.reverse ? -1 : 1);
		        var from = addTicks(min, offset);
		        var to = addTicks(max, offset);
	
		        var panRange = this.limitRange(toTime(from), toTime(to), toTime(totalLimits.min), toTime(totalLimits.max), offset);
	
		        if (panRange) {
		            panRange.min = toDate(panRange.min);
		            panRange.max = toDate(panRange.max);
		            panRange.baseUnit = options.baseUnit;
		            panRange.baseUnitStep = options.baseUnitStep || 1;
		            panRange.userSetBaseUnit = options.userSetBaseUnit;
		            panRange.userSetBaseUnitStep = options.userSetBaseUnitStep;
	
		            return panRange;
		        }
		    },
	
		    pointsRange: function(start, end) {
		        if (this.isEmpty()) {
		            return null;
		        }
	
		        var pointsRange = CategoryAxis.fn.pointsRange.call(this, start, end);
		        var datesRange = this.dataRange.displayRange();
		        var indicesRange = this.dataRange.displayIndices();
		        var scale = dateDiff(datesRange.max, datesRange.min) / (indicesRange.max - indicesRange.min);
		        var options = this.options;
	
		        var min = addTicks(datesRange.min, pointsRange.min * scale);
		        var max = addTicks(datesRange.min, pointsRange.max * scale);
	
		        return {
		            min: min,
		            max: max,
		            baseUnit: options.userSetBaseUnit || options.baseUnit,
		            baseUnitStep: options.userSetBaseUnitStep || options.baseUnitStep
		        };
		    },
	
		    zoomRange: function(delta) {
		        if (this.isEmpty()) {
		            return null;
		        }
	
		        var options = this.options;
		        var fit = options.userSetBaseUnit === FIT;
		        var totalLimits = this.dataRange.total();
		        var ref = this.dataRange.displayRange();
		        var rangeMin = ref.min;
		        var rangeMax = ref.max;
		        var ref$1 = this.dataRange.options;
		        var weekStartDay = ref$1.weekStartDay;
		        var baseUnit = ref$1.baseUnit;
		        var baseUnitStep = ref$1.baseUnitStep;
		        var min = addDuration(rangeMin, delta * baseUnitStep, baseUnit, weekStartDay);
		        var max = addDuration(rangeMax, -delta * baseUnitStep, baseUnit, weekStartDay);
	
		        if (fit) {
		            var autoBaseUnitSteps = options.autoBaseUnitSteps;
		            var maxDateGroups = options.maxDateGroups;
	
		            var maxDiff = last(autoBaseUnitSteps[baseUnit]) * maxDateGroups * TIME_PER_UNIT[baseUnit];
		            var rangeDiff = dateDiff(rangeMax, rangeMin);
		            var diff = dateDiff(max, min);
		            var baseUnitIndex = BASE_UNITS.indexOf(baseUnit);
		            var autoBaseUnitStep, ticks;
	
		            if (diff < TIME_PER_UNIT[baseUnit] && baseUnit !== MILLISECONDS) {
		                baseUnit = BASE_UNITS[baseUnitIndex - 1];
		                autoBaseUnitStep = last(autoBaseUnitSteps[baseUnit]);
		                ticks = (rangeDiff - (maxDateGroups - 1) * autoBaseUnitStep * TIME_PER_UNIT[baseUnit]) / 2;
		                min = addTicks(rangeMin, ticks);
		                max = addTicks(rangeMax, -ticks);
	
		            } else if (diff > maxDiff && baseUnit !== YEARS) {
		                var stepIndex = 0;
	
		                do {
		                    baseUnitIndex++;
		                    baseUnit = BASE_UNITS[baseUnitIndex];
		                    stepIndex = 0;
		                    ticks = 2 * TIME_PER_UNIT[baseUnit];
		                    do {
		                        autoBaseUnitStep = autoBaseUnitSteps[baseUnit][stepIndex];
		                        stepIndex++;
		                    } while (stepIndex < autoBaseUnitSteps[baseUnit].length && ticks * autoBaseUnitStep < rangeDiff);
		                } while (baseUnit !== YEARS && ticks * autoBaseUnitStep < rangeDiff);
	
		                ticks = (ticks * autoBaseUnitStep - rangeDiff) / 2;
		                if (ticks > 0) {
		                    min = addTicks(rangeMin, -ticks);
		                    max = addTicks(rangeMax, ticks);
		                    min = addTicks(min, limitValue(max, totalLimits.min, totalLimits.max) - max);
		                    max = addTicks(max, limitValue(min, totalLimits.min, totalLimits.max) - min);
		                }
		            }
		        }
	
		        if (min < totalLimits.min) {
		            min = totalLimits.min;
		        }
		        if (max > totalLimits.max) {
		            max = totalLimits.max;
		        }
	
		        if (min && max && dateDiff(max, min) > 0) {
		            return {
		                min: min,
		                max: max,
		                baseUnit: options.userSetBaseUnit || options.baseUnit,
		                baseUnitStep: options.userSetBaseUnitStep || options.baseUnitStep
		            };
		        }
		    },
	
		    range: function() {
		        return this.dataRange.displayRange();
		    },
	
		    createAxisLabel: function(index, labelOptions) {
		        var options = this.options;
		        var dataItem = options.dataItems && !options.maxDivisions ? options.dataItems[index] : null;
		        var date = this.divisionRange.dateAt(index);
		        var unitFormat = labelOptions.dateFormats[this.divisionRange.options.baseUnit];
	
		        labelOptions.format = labelOptions.format || unitFormat;
		        var text = this.axisLabelText(date, dataItem, labelOptions);
		        if (text) {
		            return new AxisLabel(date, text, index, dataItem, labelOptions);
		        }
		    },
	
		    categoryIndex: function(value) {
		        return this.dataRange.valueIndex(value);
		    },
	
		    slot: function(from, to, limit) {
		        var dateRange = this.dataRange;
		        var start = from;
		        var end = to;
	
		        if (start instanceof Date) {
		            start = dateRange.dateIndex(start);
		        }
	
		        if (end instanceof Date) {
		            end = dateRange.dateIndex(end);
		        }
	
		        var slot = this.getSlot(start, end, limit);
		        if (slot) {
		            return slot.toRect();
		        }
		    },
	
		    getSlot: function(a, b, limit) {
		        var start = a;
		        var end = b;
	
		        if (typeof start === OBJECT) {
		            start = this.categoryIndex(start);
		        }
	
		        if (typeof end === OBJECT) {
		            end = this.categoryIndex(end);
		        }
	
		        return CategoryAxis.fn.getSlot.call(this, start, end, limit);
		    },
	
		    valueRange: function() {
		        var options = this.options;
		        var range = categoryRange(options.srcCategories);
	
		        return {
		            min: toDate(range.min),
		            max: toDate(range.max)
		        };
		    },
	
		    categoryAt: function(index, total) {
		        return this.dataRange.dateAt(index, total);
		    },
	
		    categoriesCount: function() {
		        return this.dataRange.valuesCount();
		    },
	
		    rangeIndices: function() {
		        return this.dataRange.displayIndices();
		    },
	
		    labelsBetweenTicks: function() {
		        return !this.divisionRange.options.justified;
		    },
	
		    prepareUserOptions: function() {
		        if (this.isEmpty()) {
		            return;
		        }
	
		        this.options.categories = this.dataRange.values();
		    },
	
		    getCategory: function(point) {
		        var index = this.pointCategoryIndex(point);
	
		        if (index === null) {
		            return null;
		        }
	
		        return this.dataRange.dateAt(index);
		    },
	
		    totalIndex: function(value) {
		        return this.dataRange.totalIndex(value);
		    },
	
		    currentRangeIndices: function() {
		        var range = this.dataRange.valueRange();
		        return {
		            min: this.dataRange.totalIndex(range.min),
		            max: this.dataRange.totalIndex(range.max)
		        };
		    },
	
		    totalRange: function() {
		        return this.dataRange.total();
		    },
	
		    totalCount: function() {
		        return this.dataRange.totalCount();
		    },
	
		    isEmpty: function() {
		        return !this.options.srcCategories.length;
		    },
	
		    roundedRange: function() {
		        if (this.options.roundToBaseUnit !== false || this.isEmpty()) {
		            return this.range();
		        }
	
		        var options = this.options;
		        var datesRange = categoryRange(options.srcCategories);
	
		        var dateRange = new DateRange(datesRange.min, datesRange.max, $.extend({}, options, {
		            justified: false,
		            roundToBaseUnit: true,
		            justifyEnd: options.justified
		        }));
	
		        return dateRange.displayRange();
		    }
		});
	
		setDefaultOptions(DateCategoryAxis, {
		    type: DATE,
		    labels: {
		        dateFormats: DateLabelFormats
		    },
		    autoBaseUnitSteps: {
		        milliseconds: [ 1, 10, 100 ],
		        seconds: [ 1, 2, 5, 15, 30 ],
		        minutes: [ 1, 2, 5, 15, 30 ],
		        hours: [ 1, 2, 3 ],
		        days: [ 1, 2, 3 ],
		        weeks: [ 1, 2 ],
		        months: [ 1, 2, 3, 6 ],
		        years: [ 1, 2, 3, 5, 10, 25, 50 ]
		    },
		    maxDateGroups: 10
		});
	
		function autoAxisMin(min, max, narrow) {
		    if (!min && !max) {
		        return 0;
		    }
	
		    var axisMin;
	
		    if (min >= 0 && max >= 0) {
		        var minValue = min === max ? 0 : min;
	
		        var diff = (max - minValue) / max;
		        if (narrow === false || (!narrow && diff > ZERO_THRESHOLD)) {
		            return 0;
		        }
	
		        axisMin = Math.max(0, minValue - ((max - minValue) / 2));
		    } else {
		        axisMin = min;
		    }
	
		    return axisMin;
		}
	
		function autoAxisMax(min, max, narrow) {
		    if (!min && !max) {
		        return 1;
		    }
	
		    var axisMax;
	
		    if (min <= 0 && max <= 0) {
		        var maxValue = min === max ? 0 : max;
	
		        var diff = Math.abs((maxValue - min) / maxValue);
		        if (narrow === false || (!narrow && diff > ZERO_THRESHOLD)) {
		            return 0;
		        }
	
		        axisMax = Math.min(0, maxValue - ((min - maxValue) / 2));
		    } else {
		        axisMax = max;
		    }
	
		    return axisMax;
		}
	
		function floor(value, step) {
		    return round(Math.floor(value / step) * step, DEFAULT_PRECISION);
		}
	
		function ceil(value, step) {
		    return round(Math.ceil(value / step) * step, DEFAULT_PRECISION);
		}
	
		function limitCoordinate(value) {
		    return Math.max(Math.min(value, COORDINATE_LIMIT), -COORDINATE_LIMIT);
		}
	
		var MIN_VALUE_RANGE = Math.pow(10, -DEFAULT_PRECISION + 1);
	
		var NumericAxis = Axis.extend({
		    init: function(seriesMin, seriesMax, options, chartService) {
		        Axis.fn.init.call(this, $.extend({}, options, {
		            seriesMin: seriesMin,
		            seriesMax: seriesMax
		        }), chartService);
		    },
	
		    initUserOptions: function(options) {
		        var autoOptions = autoAxisOptions(options.seriesMin, options.seriesMax, options);
		        this.totalOptions = totalAxisOptions(autoOptions, options);
	
		        return axisOptions(autoOptions, options);
		    },
	
		    initFields: function() {
		        this.totalMin = this.totalOptions.min;
		        this.totalMax = this.totalOptions.max;
		        this.totalMajorUnit = this.totalOptions.majorUnit;
		        this.seriesMin = this.options.seriesMin;
		        this.seriesMax = this.options.seriesMax;
		    },
	
		    clone: function() {
		        return new NumericAxis(
		            this.seriesMin,
		            this.seriesMax,
		            $.extend({}, this.options),
		            this.chartService
		        );
		    },
	
		    startValue: function() {
		        return 0;
		    },
	
		    range: function() {
		        var options = this.options;
		        return { min: options.min, max: options.max };
		    },
	
		    getDivisions: function(stepValue) {
		        if (stepValue === 0) {
		            return 1;
		        }
	
		        var options = this.options;
		        var range = options.max - options.min;
	
		        return Math.floor(round(range / stepValue, COORD_PRECISION)) + 1;
		    },
	
		    getTickPositions: function(unit, skipUnit) {
		        var options = this.options;
		        var vertical = options.vertical;
		        var reverse = options.reverse;
		        var lineBox = this.lineBox();
		        var lineSize = vertical ? lineBox.height() : lineBox.width();
		        var range = options.max - options.min;
		        var scale = lineSize / range;
		        var step = unit * scale;
		        var divisions = this.getDivisions(unit);
		        var dir = (vertical ? -1 : 1) * (reverse ? -1 : 1);
		        var startEdge = dir === 1 ? 1 : 2;
		        var positions = [];
		        var pos = lineBox[(vertical ? Y : X) + startEdge];
		        var skipStep = 0;
	
		        if (skipUnit) {
		            skipStep = skipUnit / unit;
		        }
	
		        for (var idx = 0; idx < divisions; idx++) {
		            if (idx % skipStep !== 0) {
		                positions.push(round(pos, COORD_PRECISION));
		            }
	
		            pos = pos + step * dir;
		        }
	
		        return positions;
		    },
	
		    getMajorTickPositions: function() {
		        return this.getTickPositions(this.options.majorUnit);
		    },
	
		    getMinorTickPositions: function() {
		        return this.getTickPositions(this.options.minorUnit);
		    },
	
		    getSlot: function(a, b, limit) {
		        if (limit === void 0) { limit = false; }
	
		        var options = this.options;
		        var vertical = options.vertical;
		        var reverse = options.reverse;
		        var valueAxis = vertical ? Y : X;
		        var lineBox = this.lineBox();
		        var lineStart = lineBox[valueAxis + (reverse ? 2 : 1)];
		        var lineSize = vertical ? lineBox.height() : lineBox.width();
		        var dir = reverse ? -1 : 1;
		        var step = dir * (lineSize / (options.max - options.min));
		        var slotBox = new Box(lineBox.x1, lineBox.y1, lineBox.x1, lineBox.y1);
	
		        var start = a;
		        var end = b;
	
		        if (!defined(start)) {
		            start = end || 0;
		        }
	
		        if (!defined(end)) {
		            end = start || 0;
		        }
	
		        if (limit) {
		            start = Math.max(Math.min(start, options.max), options.min);
		            end = Math.max(Math.min(end, options.max), options.min);
		        }
	
		        var p1, p2;
	
		        if (vertical) {
		            p1 = options.max - Math.max(start, end);
		            p2 = options.max - Math.min(start, end);
		        } else {
		            p1 = Math.min(start, end) - options.min;
		            p2 = Math.max(start, end) - options.min;
		        }
	
		        slotBox[valueAxis + 1] = limitCoordinate(lineStart + step * (reverse ? p2 : p1));
		        slotBox[valueAxis + 2] = limitCoordinate(lineStart + step * (reverse ? p1 : p2));
	
		        return slotBox;
		    },
	
		    getValue: function(point) {
		        var options = this.options;
		        var vertical = options.vertical;
		        var reverse = options.reverse;
		        var max = Number(options.max);
		        var min = Number(options.min);
		        var valueAxis = vertical ? Y : X;
		        var lineBox = this.lineBox();
		        var lineStart = lineBox[valueAxis + (reverse ? 2 : 1)];
		        var lineSize = vertical ? lineBox.height() : lineBox.width();
		        var dir = reverse ? -1 : 1;
		        var offset = dir * (point[valueAxis] - lineStart);
		        var step = (max - min) / lineSize;
		        var valueOffset = offset * step;
	
		        if (offset < 0 || offset > lineSize) {
		            return null;
		        }
	
		        var value = vertical ?
		                max - valueOffset :
		                min + valueOffset;
	
		        return round(value, DEFAULT_PRECISION);
		    },
	
		    translateRange: function(delta) {
		        var options = this.options;
		        var vertical = options.vertical;
		        var reverse = options.reverse;
		        var max = options.max;
		        var min = options.min;
		        var lineBox = this.lineBox();
		        var size = vertical ? lineBox.height() : lineBox.width();
		        var range = max - min;
		        var scale = size / range;
		        var offset = round(delta / scale, DEFAULT_PRECISION);
	
		        if ((vertical || reverse) && !(vertical && reverse )) {
		            offset = -offset;
		        }
	
		        return {
		            min: min + offset,
		            max: max + offset,
		            offset: offset
		        };
		    },
	
		    scaleRange: function(delta) {
		        var options = this.options;
		        var offset = -delta * options.majorUnit;
	
		        return {
		            min: options.min - offset,
		            max: options.max + offset
		        };
		    },
	
		    labelsCount: function() {
		        return this.getDivisions(this.options.majorUnit);
		    },
	
		    createAxisLabel: function(index, labelOptions) {
		        var options = this.options;
		        var value = round(options.min + (index * options.majorUnit), DEFAULT_PRECISION);
		        var text = this.axisLabelText(value, null, labelOptions);
	
		        return new AxisLabel(value, text, index, null, labelOptions);
		    },
	
		    shouldRenderNote: function(value) {
		        var range = this.range();
		        return range.min <= value && value <= range.max;
		    },
	
		    pan: function(delta) {
		        var range = this.translateRange(delta);
		        return this.limitRange(range.min, range.max, this.totalMin, this.totalMax, range.offset);
		    },
	
		    pointsRange: function(start, end) {
		        var startValue = this.getValue(start);
		        var endValue = this.getValue(end);
		        var min = Math.min(startValue, endValue);
		        var max = Math.max(startValue, endValue);
	
		        if (this.isValidRange(min, max)) {
		            return {
		                min: min,
		                max: max
		            };
		        }
		    },
	
		    zoomRange: function(delta) {
		        var ref = this;
		        var totalMin = ref.totalMin;
		        var totalMax = ref.totalMax;
		        var newRange = this.scaleRange(delta);
		        var min = limitValue(newRange.min, totalMin, totalMax);
		        var max = limitValue(newRange.max, totalMin, totalMax);
	
		        if (this.isValidRange(min, max)) {
		            return {
		                min: min,
		                max: max
		            };
		        }
		    },
	
		    isValidRange: function(min, max) {
		        return max - min > MIN_VALUE_RANGE;
		    }
		});
	
		function autoAxisOptions(seriesMin, seriesMax, options) {
		    var narrowRange = options.narrowRange;
	
		    var autoMin = autoAxisMin(seriesMin, seriesMax, narrowRange);
		    var autoMax = autoAxisMax(seriesMin, seriesMax, narrowRange);
	
		    var majorUnit = autoMajorUnit(autoMin, autoMax);
		    var autoOptions = {
		        majorUnit: majorUnit
		    };
	
		    if (options.roundToMajorUnit !== false) {
		        if (autoMin < 0 && remainderClose(autoMin, majorUnit, 1 / 3)) {
		            autoMin -= majorUnit;
		        }
	
		        if (autoMax > 0 && remainderClose(autoMax, majorUnit, 1 / 3)) {
		            autoMax += majorUnit;
		        }
		    }
	
		    autoOptions.min = floor(autoMin, majorUnit);
		    autoOptions.max = ceil(autoMax, majorUnit);
	
		    return autoOptions;
		}
	
		function totalAxisOptions(autoOptions, options) {
		    return {
		        min: defined(options.min) ? Math.min(autoOptions.min, options.min) : autoOptions.min,
		        max: defined(options.max) ? Math.max(autoOptions.max, options.max) : autoOptions.max,
		        majorUnit: autoOptions.majorUnit
		    };
		}
	
		function clearNullValues(options, fields) {
		    for (var idx = 0; idx < fields.length; idx++) {
		        var field = fields[idx];
		        if (options[field] === null) {
		            options[field] = undefined;
		        }
		    }
		}
	
		function axisOptions(autoOptions, userOptions) {
		    var options = userOptions;
		    var userSetMin, userSetMax;
	
		    if (userOptions) {
		        clearNullValues(userOptions, [ 'min', 'max' ]);
	
		        userSetMin = defined(userOptions.min);
		        userSetMax = defined(userOptions.max);
	
		        var userSetLimits = userSetMin || userSetMax;
	
		        if (userSetLimits) {
		            if (userOptions.min === userOptions.max) {
		                if (userOptions.min > 0) {
		                    userOptions.min = 0;
		                } else {
		                    userOptions.max = 1;
		                }
		            }
		        }
	
		        if (userOptions.majorUnit) {
		            autoOptions.min = floor(autoOptions.min, userOptions.majorUnit);
		            autoOptions.max = ceil(autoOptions.max, userOptions.majorUnit);
		        } else if (userSetLimits) {
		            options = deepExtend(autoOptions, userOptions);
	
		            // Determine an auto major unit after min/max have been set
		            autoOptions.majorUnit = autoMajorUnit(options.min, options.max);
		        }
		    }
	
		    autoOptions.minorUnit = (options.majorUnit || autoOptions.majorUnit) / 5;
	
		    var result = deepExtend(autoOptions, options);
		    if (result.min >= result.max) {
		        if (userSetMin && !userSetMax) {
		            result.max = result.min + result.majorUnit;
		        } else if (!userSetMin && userSetMax) {
		            result.min = result.max - result.majorUnit;
		        }
		    }
	
		    return result;
		}
	
		function remainderClose(value, divisor, ratio) {
		    var remainder = round(Math.abs(value % divisor), DEFAULT_PRECISION);
		    var threshold = divisor * (1 - ratio);
	
		    return remainder === 0 || remainder > threshold;
		}
	
		setDefaultOptions(NumericAxis, {
		    type: "numeric",
		    min: 0,
		    max: 1,
		    vertical: true,
		    majorGridLines: {
		        visible: true,
		        width: 1,
		        color: BLACK
		    },
		    labels: {
		        format: "#.####################"
		    },
		    zIndex: 1
		});
	
		var DateValueAxis = Axis.extend({
		    init: function(seriesMin, seriesMax, axisOptions, chartService) {
		        var min = toDate(seriesMin);
		        var max = toDate(seriesMax);
	
		        var intlService = chartService.intl;
		        var options = axisOptions || {};
		        options = deepExtend(options || {}, {
		            min: parseDate(intlService, options.min),
		            max: parseDate(intlService, options.max),
		            axisCrossingValue: parseDates(intlService, options.axisCrossingValues || options.axisCrossingValue)
		        });
		        options = applyDefaults(min, max, options);
	
		        Axis.fn.init.call(this, options, chartService);
	
		        this.intlService = intlService;
		        this.seriesMin = min;
		        this.seriesMax = max;
		        this.totalMin = toTime(floorDate(toTime(min) - 1, options.baseUnit));
		        this.totalMax = toTime(ceilDate(toTime(max) + 1, options.baseUnit));
		    },
	
		    clone: function() {
		        return new DateValueAxis(this.seriesMin, this.seriesMax, $.extend({}, this.options), this.chartService);
		    },
	
		    range: function() {
		        var options = this.options;
		        return { min: options.min, max: options.max };
		    },
	
		    getDivisions: function(stepValue) {
		        var options = this.options;
	
		        return Math.floor(
		            duration(options.min, options.max, options.baseUnit) / stepValue + 1
		        );
		    },
	
		    getTickPositions: function(step) {
		        var options = this.options;
		        var vertical = options.vertical;
		        var lineBox = this.lineBox();
		        var dir = (vertical ? -1 : 1) * (options.reverse ? -1 : 1);
		        var startEdge = dir === 1 ? 1 : 2;
		        var start = lineBox[(vertical ? Y : X) + startEdge];
		        var divisions = this.getDivisions(step);
		        var timeRange = dateDiff(options.max, options.min);
		        var lineSize = vertical ? lineBox.height() : lineBox.width();
		        var scale = lineSize / timeRange;
	
		        var positions = [ start ];
		        for (var i = 1; i < divisions; i++) {
		            var date = addDuration(options.min, i * step, options.baseUnit);
		            var pos = start + dateDiff(date, options.min) * scale * dir;
	
		            positions.push(round(pos, COORD_PRECISION));
		        }
	
		        return positions;
		    },
	
		    getMajorTickPositions: function() {
		        return this.getTickPositions(this.options.majorUnit);
		    },
	
		    getMinorTickPositions: function() {
		        return this.getTickPositions(this.options.minorUnit);
		    },
	
		    getSlot: function(a, b, limit) {
		        return NumericAxis.prototype.getSlot.call(
		            this, parseDate(this.intlService, a), parseDate(this.intlService, b), limit
		        );
		    },
	
		    getValue: function(point) {
		        var value = NumericAxis.prototype.getValue.call(this, point);
	
		        return value !== null ? toDate(value) : null;
		    },
	
		    labelsCount: function() {
		        return this.getDivisions(this.options.majorUnit);
		    },
	
		    createAxisLabel: function(index, labelOptions) {
		        var options = this.options;
		        var offset = index * options.majorUnit;
		        var date = options.min;
	
		        if (offset > 0) {
		            date = addDuration(date, offset, options.baseUnit);
		        }
	
		        var unitFormat = labelOptions.dateFormats[options.baseUnit];
		        labelOptions.format = labelOptions.format || unitFormat;
	
		        var text = this.axisLabelText(date, null, labelOptions);
		        return new AxisLabel(date, text, index, null, labelOptions);
		    },
	
		    translateRange: function(delta, exact) {
		        var options = this.options;
		        var baseUnit = options.baseUnit;
		        var weekStartDay = options.weekStartDay;
		        var lineBox = this.lineBox();
		        var size = options.vertical ? lineBox.height() : lineBox.width();
		        var range = this.range();
		        var scale = size / dateDiff(range.max, range.min);
		        var offset = round(delta / scale, DEFAULT_PRECISION) * (options.reverse ? -1 : 1);
		        var from = addTicks(options.min, offset);
		        var to = addTicks(options.max, offset);
	
		        if (!exact) {
		            from = addDuration(from, 0, baseUnit, weekStartDay);
		            to = addDuration(to, 0, baseUnit, weekStartDay);
		        }
	
		        return {
		            min: from,
		            max: to,
		            offset: offset
		        };
		    },
	
		    scaleRange: function(delta) {
		        var ref = this.options;
		        var from = ref.min;
		        var to = ref.max;
		        var rounds = Math.abs(delta);
	
		        while (rounds--) {
		            var range = dateDiff(from, to);
		            var step = Math.round(range * 0.1);
		            if (delta < 0) {
		                from = addTicks(from, step);
		                to = addTicks(to, -step);
		            } else {
		                from = addTicks(from, -step);
		                to = addTicks(to, step);
		            }
		        }
	
		        return { min: from, max: to };
		    },
	
		    shouldRenderNote: function(value) {
		        var range = this.range();
	
		        return dateComparer(value, range.min) >= 0 && dateComparer(value, range.max) <= 0;
		    },
	
		    pan: function(delta) {
		        var range = this.translateRange(delta, true);
		        var limittedRange = this.limitRange(toTime(range.min), toTime(range.max), this.totalMin, this.totalMax, range.offset);
	
		        if (limittedRange) {
		            return {
		                min: toDate(limittedRange.min),
		                max: toDate(limittedRange.max)
		            };
		        }
		    },
	
		    pointsRange: function(start, end) {
		        var startValue = this.getValue(start);
		        var endValue = this.getValue(end);
		        var min = Math.min(startValue, endValue);
		        var max = Math.max(startValue, endValue);
	
		        return {
		            min: toDate(min),
		            max: toDate(max)
		        };
		    },
	
		    zoomRange: function(delta) {
		        var range = this.scaleRange(delta);
		        var min = toDate(limitValue(toTime(range.min), this.totalMin, this.totalMax));
		        var max = toDate(limitValue(toTime(range.max), this.totalMin, this.totalMax));
	
		        return {
		            min: min,
		            max: max
		        };
		    }
		});
	
		function timeUnits(delta) {
		    var unit = HOURS;
	
		    if (delta >= TIME_PER_YEAR) {
		        unit = YEARS;
		    } else if (delta >= TIME_PER_MONTH) {
		        unit = MONTHS;
		    } else if (delta >= TIME_PER_WEEK) {
		        unit = WEEKS;
		    } else if (delta >= TIME_PER_DAY) {
		        unit = DAYS;
		    }
	
		    return unit;
		}
	
		function applyDefaults(seriesMin, seriesMax, options) {
		    var min = options.min || seriesMin;
		    var max = options.max || seriesMax;
		    var baseUnit = options.baseUnit || (max && min ? timeUnits(absoluteDateDiff(max, min)) : HOURS);
		    var baseUnitTime = TIME_PER_UNIT[baseUnit];
		    var autoMin = floorDate(toTime(min) - 1, baseUnit) || toDate(max);
		    var autoMax = ceilDate(toTime(max) + 1, baseUnit);
		    var userMajorUnit = options.majorUnit ? options.majorUnit : undefined;
		    var majorUnit = userMajorUnit || ceil(
		                        autoMajorUnit(autoMin.getTime(), autoMax.getTime()),
		                        baseUnitTime
		                    ) / baseUnitTime;
		    var actualUnits = duration(autoMin, autoMax, baseUnit);
		    var totalUnits = ceil(actualUnits, majorUnit);
		    var unitsToAdd = totalUnits - actualUnits;
		    var head = Math.floor(unitsToAdd / 2);
		    var tail = unitsToAdd - head;
	
		    if (!options.baseUnit) {
		        delete options.baseUnit;
		    }
	
		    options.baseUnit = options.baseUnit || baseUnit;
		    options.min = options.min || addDuration(autoMin, -head, baseUnit);
		    options.max = options.max || addDuration(autoMax, tail, baseUnit);
		    options.minorUnit = options.minorUnit || majorUnit / 5;
		    options.majorUnit = majorUnit;
	
		    return options;
		}
	
		setDefaultOptions(DateValueAxis, {
		    type: DATE,
		    majorGridLines: {
		        visible: true,
		        width: 1,
		        color: BLACK
		    },
		    labels: {
		        dateFormats: DateLabelFormats
		    }
		});
	
		var DEFAULT_MAJOR_UNIT = 10;
	
		var LogarithmicAxis = Axis.extend({
		    init: function(seriesMin, seriesMax, options, chartService) {
	
		        var axisOptions = deepExtend({ majorUnit: DEFAULT_MAJOR_UNIT, min: seriesMin, max: seriesMax }, options);
		        var base = axisOptions.majorUnit;
		        var autoMax = autoAxisMax$1(seriesMax, base);
		        var autoMin = autoAxisMin$1(seriesMin, seriesMax, axisOptions);
		        var range = initRange(autoMin, autoMax, axisOptions, options);
	
		        axisOptions.max = range.max;
		        axisOptions.min = range.min;
		        axisOptions.minorUnit = options.minorUnit || round(base - 1, DEFAULT_PRECISION);
	
		        Axis.fn.init.call(this, axisOptions, chartService);
	
		        this.totalMin = defined(options.min) ? Math.min(autoMin, options.min) : autoMin;
		        this.totalMax = defined(options.max) ? Math.max(autoMax, options.max) : autoMax;
		        this.logMin = round(log(range.min, base), DEFAULT_PRECISION);
		        this.logMax = round(log(range.max, base), DEFAULT_PRECISION);
		        this.seriesMin = seriesMin;
		        this.seriesMax = seriesMax;
	
		        this.createLabels();
		    },
	
		    clone: function() {
		        return new LogarithmicAxis(
		            this.seriesMin,
		            this.seriesMax,
		            $.extend({}, this.options),
		            this.chartService
		        );
		    },
	
		    startValue: function() {
		        return this.options.min;
		    },
	
		    getSlot: function(a, b, limit) {
		        var ref = this;
		        var options = ref.options;
		        var logMin = ref.logMin;
		        var logMax = ref.logMax;
		        var reverse = options.reverse;
		        var vertical = options.vertical;
		        var base = options.majorUnit;
		        var valueAxis = vertical ? Y : X;
		        var lineBox = this.lineBox();
		        var lineStart = lineBox[valueAxis + (reverse ? 2 : 1)];
		        var lineSize = vertical ? lineBox.height() : lineBox.width();
		        var dir = reverse ? -1 : 1;
		        var step = dir * (lineSize / (logMax - logMin));
		        var slotBox = new Box(lineBox.x1, lineBox.y1, lineBox.x1, lineBox.y1);
		        var start = a;
		        var end = b;
	
		        if (!defined(start)) {
		            start = end || 1;
		        }
	
		        if (!defined(end)) {
		            end = start || 1;
		        }
	
		        if (start <= 0 || end <= 0) {
		            return null;
		        }
	
		        if (limit) {
		            start = Math.max(Math.min(start, options.max), options.min);
		            end = Math.max(Math.min(end, options.max), options.min);
		        }
	
		        start = log(start, base);
		        end = log(end, base);
	
		        var p1, p2;
	
		        if (vertical) {
		            p1 = logMax - Math.max(start, end);
		            p2 = logMax - Math.min(start, end);
		        } else {
		            p1 = Math.min(start, end) - logMin;
		            p2 = Math.max(start, end) - logMin;
		        }
	
		        slotBox[valueAxis + 1] = limitCoordinate(lineStart + step * (reverse ? p2 : p1));
		        slotBox[valueAxis + 2] = limitCoordinate(lineStart + step * (reverse ? p1 : p2));
	
		        return slotBox;
		    },
	
		    getValue: function(point) {
		        var ref = this;
		        var options = ref.options;
		        var logMin = ref.logMin;
		        var logMax = ref.logMax;
		        var reverse = options.reverse;
		        var vertical = options.vertical;
		        var base = options.majorUnit;
		        var lineBox = this.lineBox();
		        var dir = vertical === reverse ? 1 : -1;
		        var startEdge = dir === 1 ? 1 : 2;
		        var lineSize = vertical ? lineBox.height() : lineBox.width();
		        var step = ((logMax - logMin) / lineSize);
		        var valueAxis = vertical ? Y : X;
		        var lineStart = lineBox[valueAxis + startEdge];
		        var offset = dir * (point[valueAxis] - lineStart);
		        var valueOffset = offset * step;
	
		        if (offset < 0 || offset > lineSize) {
		            return null;
		        }
	
		        var value = logMin + valueOffset;
	
		        return round(Math.pow(base, value), DEFAULT_PRECISION);
		    },
	
		    range: function() {
		        var options = this.options;
		        return { min: options.min, max: options.max };
		    },
	
		    scaleRange: function(delta) {
		        var base = this.options.majorUnit;
		        var offset = -delta;
	
		        return {
		            min: Math.pow(base, this.logMin - offset),
		            max: Math.pow(base, this.logMax + offset)
		        };
		    },
	
		    translateRange: function(delta) {
		        var ref = this;
		        var options = ref.options;
		        var logMin = ref.logMin;
		        var logMax = ref.logMax;
		        var reverse = options.reverse;
		        var vertical = options.vertical;
		        var base = options.majorUnit;
		        var lineBox = this.lineBox();
		        var size = vertical ? lineBox.height() : lineBox.width();
		        var scale = size / (logMax - logMin);
		        var offset = round(delta / scale, DEFAULT_PRECISION);
	
		        if ((vertical || reverse) && !(vertical && reverse )) {
		            offset = -offset;
		        }
	
		        return {
		            min: Math.pow(base, logMin + offset),
		            max: Math.pow(base, logMax + offset),
		            offset: offset
		        };
		    },
	
		    labelsCount: function() {
		        var floorMax = Math.floor(this.logMax);
		        var count = Math.floor(floorMax - this.logMin) + 1;
	
		        return count;
		    },
	
		    getMajorTickPositions: function() {
		        var ticks = [];
	
		        this.traverseMajorTicksPositions(function (position) {
		            ticks.push(position);
		        }, { step: 1, skip: 0 });
	
		        return ticks;
		    },
	
		    createTicks: function(lineGroup) {
		        var options = this.options;
		        var majorTicks = options.majorTicks;
		        var minorTicks = options.minorTicks;
		        var vertical = options.vertical;
		        var mirror = options.labels.mirror;
		        var lineBox = this.lineBox();
		        var ticks = [];
		        var tickLineOptions = {
		            // TODO
		            // _alignLines: options._alignLines,
		            vertical: vertical
		        };
	
		        function render(tickPosition, tickOptions) {
		            tickLineOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
		            tickLineOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
		            tickLineOptions.position = tickPosition;
	
		            lineGroup.append(createAxisTick(tickLineOptions, tickOptions));
		        }
	
		        if (majorTicks.visible) {
		            this.traverseMajorTicksPositions(render, majorTicks);
		        }
	
		        if (minorTicks.visible) {
		            this.traverseMinorTicksPositions(render, minorTicks);
		        }
	
		        return ticks;
		    },
	
		    createGridLines: function(altAxis) {
		        var options = this.options;
		        var minorGridLines = options.minorGridLines;
		        var majorGridLines = options.majorGridLines;
		        var vertical = options.vertical;
		        var lineBox = altAxis.lineBox();
		        var lineOptions = {
		            lineStart: lineBox[vertical ? "x1" : "y1"],
		            lineEnd: lineBox[vertical ? "x2" : "y2"],
		            vertical: vertical
		        };
		        var majorTicks = [];
	
		        var container = this.gridLinesVisual();
		        function render(tickPosition, gridLine) {
		            if (!inArray(tickPosition, majorTicks)) {
		                lineOptions.position = tickPosition;
		                container.append(createAxisGridLine(lineOptions, gridLine));
	
		                majorTicks.push(tickPosition);
		            }
		        }
	
		        if (majorGridLines.visible) {
		            this.traverseMajorTicksPositions(render, majorGridLines);
		        }
	
		        if (minorGridLines.visible) {
		            this.traverseMinorTicksPositions(render, minorGridLines);
		        }
	
		        return container.children;
		    },
	
		    traverseMajorTicksPositions: function(callback, tickOptions) {
		        var ref = this._lineOptions();
		        var lineStart = ref.lineStart;
		        var step = ref.step;
		        var ref$1 = this;
		        var logMin = ref$1.logMin;
		        var logMax = ref$1.logMax;
	
		        for (var power = Math.ceil(logMin) + tickOptions.skip; power <= logMax; power += tickOptions.step) {
		            var position = round(lineStart + step * (power - logMin), DEFAULT_PRECISION);
		            callback(position, tickOptions);
		        }
		    },
	
		    traverseMinorTicksPositions: function(callback, tickOptions) {
		        var this$1 = this;
	
		        var ref = this.options;
		        var min = ref.min;
		        var max = ref.max;
		        var minorUnit = ref.minorUnit;
		        var base = ref.majorUnit;
		        var ref$1 = this._lineOptions();
		        var lineStart = ref$1.lineStart;
		        var step = ref$1.step;
		        var ref$2 = this;
		        var logMin = ref$2.logMin;
		        var logMax = ref$2.logMax;
		        var start = Math.floor(logMin);
	
		        for (var power = start; power < logMax; power++) {
		            var minorOptions = this$1._minorIntervalOptions(power);
		            for (var idx = tickOptions.skip; idx < minorUnit; idx += tickOptions.step) {
		                var value = minorOptions.value + idx * minorOptions.minorStep;
		                if (value > max) {
		                    break;
		                }
		                if (value >= min) {
		                    var position = round(lineStart + step * (log(value, base) - logMin), DEFAULT_PRECISION);
		                    callback(position, tickOptions);
		                }
		            }
		        }
		    },
	
		    createAxisLabel: function(index, labelOptions) {
		        var power = Math.ceil(this.logMin + index);
		        var value = Math.pow(this.options.majorUnit, power);
		        var text = this.axisLabelText(value, null, labelOptions);
	
		        return new AxisLabel(value, text, index, null, labelOptions);
		    },
	
		    shouldRenderNote: function(value) {
		        var range = this.range();
		        return range.min <= value && value <= range.max;
		    },
	
		    pan: function(delta) {
		        var range = this.translateRange(delta);
		        return this.limitRange(range.min, range.max, this.totalMin, this.totalMax, range.offset);
		    },
	
		    pointsRange: function(start, end) {
		        var startValue = this.getValue(start);
		        var endValue = this.getValue(end);
		        var min = Math.min(startValue, endValue);
		        var max = Math.max(startValue, endValue);
	
		        return {
		            min: min,
		            max: max
		        };
		    },
	
		    zoomRange: function(delta) {
		        var ref = this;
		        var options = ref.options;
		        var totalMin = ref.totalMin;
		        var totalMax = ref.totalMax;
		        var newRange = this.scaleRange(delta);
		        var min = limitValue(newRange.min, totalMin, totalMax);
		        var max = limitValue(newRange.max, totalMin, totalMax);
		        var base = options.majorUnit;
		        var acceptOptionsRange = max > min && options.min && options.max && (round(log(options.max, base) - log(options.min, base), DEFAULT_PRECISION) < 1);
		        var acceptNewRange = !(options.min === totalMin && options.max === totalMax) && round(log(max, base) - log(min, base), DEFAULT_PRECISION) >= 1;
	
		        if (acceptOptionsRange || acceptNewRange) {
		            return {
		                min: min,
		                max: max
		            };
		        }
		    },
	
		    _minorIntervalOptions: function(power) {
		        var ref = this.options;
		        var minorUnit = ref.minorUnit;
		        var base = ref.majorUnit;
		        var value = Math.pow(base, power);
		        var nextValue = Math.pow(base, power + 1);
		        var difference = nextValue - value;
		        var minorStep = difference / minorUnit;
	
		        return {
		            value: value,
		            minorStep: minorStep
		        };
		    },
	
		    _lineOptions: function() {
		        var ref = this.options;
		        var reverse = ref.reverse;
		        var vertical = ref.vertical;
		        var valueAxis = vertical ? Y : X;
		        var lineBox = this.lineBox();
		        var dir = vertical === reverse ? 1 : -1;
		        var startEdge = dir === 1 ? 1 : 2;
		        var lineSize = vertical ? lineBox.height() : lineBox.width();
		        var step = dir * (lineSize / (this.logMax - this.logMin));
		        var lineStart = lineBox[valueAxis + startEdge];
	
		        return {
		            step: step,
		            lineStart: lineStart,
		            lineBox: lineBox
		        };
		    }
		});
	
		function initRange(autoMin, autoMax, axisOptions, options) {
		    var min = axisOptions.min;
		    var max = axisOptions.max;
	
		    if (defined(axisOptions.axisCrossingValue) && axisOptions.axisCrossingValue <= 0) {
		        throwNegativeValuesError();
		    }
	
		    if (!defined(options.max)) {
		        max = autoMax;
		    } else if (options.max <= 0) {
		        throwNegativeValuesError();
		    }
	
		    if (!defined(options.min)) {
		        min = autoMin;
		    } else if (options.min <= 0) {
		        throwNegativeValuesError();
		    }
	
		    return {
		        min: min,
		        max: max
		    };
		}
	
		function autoAxisMin$1(min, max, options) {
		    var base = options.majorUnit;
		    var autoMin = min;
		    if (min <= 0) {
		        autoMin = max <= 1 ? Math.pow(base, -2) : 1;
		    } else if (!options.narrowRange) {
		        autoMin = Math.pow(base, Math.floor(log(min, base)));
		    }
		    return autoMin;
		}
	
		function autoAxisMax$1(max, base) {
		    var logMaxRemainder = round(log(max, base), DEFAULT_PRECISION) % 1;
		    var autoMax;
		    if (max <= 0) {
		        autoMax = base;
		    } else if (logMaxRemainder !== 0 && (logMaxRemainder < 0.3 || logMaxRemainder > 0.9)) {
		        autoMax = Math.pow(base, log(max, base) + 0.2);
		    } else {
		        autoMax = Math.pow(base, Math.ceil(log(max, base)));
		    }
	
		    return autoMax;
		}
	
		function throwNegativeValuesError() {
		    throw new Error("Non positive values cannot be used for a logarithmic axis");
		}
	
		function log(y, x) {
		    return Math.log(y) / Math.log(x);
		}
	
		setDefaultOptions(LogarithmicAxis, {
		    type: "log",
		    majorUnit: DEFAULT_MAJOR_UNIT,
		    minorUnit: 1,
		    axisCrossingValue: 1,
		    vertical: true,
		    majorGridLines: {
		        visible: true,
		        width: 1,
		        color: BLACK
		    },
		    zIndex: 1,
		    _deferLabels: true
		});
	
		var GridLinesMixin = {
		    createGridLines: function(altAxis) {
		        var options = this.options;
		        var radius = Math.abs(this.box.center().y - altAxis.lineBox().y1);
		        var gridLines = [];
		        var skipMajor = false;
		        var majorAngles, minorAngles;
	
		        if (options.majorGridLines.visible) {
		            majorAngles = this.majorGridLineAngles(altAxis);
		            skipMajor = true;
	
		            gridLines = this.renderMajorGridLines(
		                majorAngles, radius, options.majorGridLines
		            );
		        }
	
		        if (options.minorGridLines.visible) {
		            minorAngles = this.minorGridLineAngles(altAxis, skipMajor);
	
		            append(gridLines, this.renderMinorGridLines(
		                minorAngles, radius, options.minorGridLines, altAxis, skipMajor
		            ));
		        }
	
		        return gridLines;
		    },
	
		    renderMajorGridLines: function(angles, radius, options) {
		        return this.renderGridLines(angles, radius, options);
		    },
	
		    renderMinorGridLines: function(angles, radius, options, altAxis, skipMajor) {
		        var radiusCallback = this.radiusCallback && this.radiusCallback(radius, altAxis, skipMajor);
		        return this.renderGridLines(angles, radius, options, radiusCallback);
		    },
	
		    renderGridLines: function(angles, radius, options, radiusCallback) {
		        var style = {
		            stroke: {
		                width: options.width,
		                color: options.color,
		                dashType: options.dashType
		            }
		        };
	
		        var center = this.box.center();
		        var circle = new Circle([ center.x, center.y ], radius);
		        var container = this.gridLinesVisual();
	
		        for (var i = 0; i < angles.length; i++) {
		            var line = new Path(style);
		            if (radiusCallback) {
		                circle.radius = radiusCallback(angles[i]);
		            }
	
		            line.moveTo(circle.center)
		                .lineTo(circle.pointAt(angles[i] + 180));
	
		            container.append(line);
		        }
	
		        return container.children;
		    },
	
		    gridLineAngles: function(altAxis, size, skip, step, skipAngles) {
		        var this$1 = this;
	
		        var divs = this.intervals(size, skip, step, skipAngles);
		        var options = altAxis.options;
		        var altAxisVisible = options.visible && (options.line || {}).visible !== false;
	
		        return map(divs, function (d) {
		            var alpha = this$1.intervalAngle(d);
	
		            if (!altAxisVisible || alpha !== 90) {
		                return alpha;
		            }
		        });
		    }
		};
	
		var RadarCategoryAxis = CategoryAxis.extend({
		    range: function() {
		        return { min: 0, max: this.options.categories.length };
		    },
	
		    reflow: function(box) {
		        this.box = box;
		        this.reflowLabels();
		    },
	
		    lineBox: function() {
		        return this.box;
		    },
	
		    reflowLabels: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var labels = ref.labels;
		        var labelOptions = ref.options.labels;
		        var skip = labelOptions.skip || 0;
		        var step = labelOptions.step || 1;
		        var measureBox = new Box();
	
		        for (var i = 0; i < labels.length; i++) {
		            labels[i].reflow(measureBox);
		            var labelBox = labels[i].box;
	
		            labels[i].reflow(this$1.getSlot(skip + i * step).adjacentBox(
		                0, labelBox.width(), labelBox.height()
		            ));
		        }
		    },
	
		    intervals: function(size, skipOption, stepOption, skipAngles) {
		        if (skipAngles === void 0) { skipAngles = false; }
	
		        var options = this.options;
		        var categories = options.categories.length;
		        var divCount = categories / size || 1;
		        var divAngle = 360 / divCount;
		        var skip = skipOption || 0;
		        var step = stepOption || 1;
		        var divs = [];
		        var angle = 0;
	
		        for (var i = skip; i < divCount; i += step) {
		            if (options.reverse) {
		                angle = 360 - i * divAngle;
		            } else {
		                angle = i * divAngle;
		            }
	
		            angle = round(angle, COORD_PRECISION) % 360;
	
		            if (!(skipAngles && inArray(angle, skipAngles))) {
		                divs.push(angle);
		            }
		        }
	
		        return divs;
		    },
	
		    majorIntervals: function() {
		        return this.intervals(1);
		    },
	
		    minorIntervals: function() {
		        return this.intervals(0.5);
		    },
	
		    intervalAngle: function(interval) {
		        return (360 + interval + this.options.startAngle) % 360;
		    },
	
		    majorAngles: function() {
		        var this$1 = this;
	
		        return map(this.majorIntervals(), function (interval) { return this$1.intervalAngle(interval); });
		    },
	
		    createLine: function() {
		        return [];
		    },
	
		    majorGridLineAngles: function(altAxis) {
		        var majorGridLines = this.options.majorGridLines;
		        return this.gridLineAngles(altAxis, 1, majorGridLines.skip, majorGridLines.step);
		    },
	
		    minorGridLineAngles: function(altAxis, skipMajor) {
		        var ref = this.options;
		        var minorGridLines = ref.minorGridLines;
		        var majorGridLines = ref.majorGridLines;
		        var majorGridLineAngles = skipMajor ? this.intervals(1, majorGridLines.skip, majorGridLines.step) : null;
	
		        return this.gridLineAngles(altAxis, 0.5, minorGridLines.skip, minorGridLines.step, majorGridLineAngles);
		    },
	
		    radiusCallback: function(radius, altAxis, skipMajor) {
		        if (altAxis.options.type !== ARC) {
		            var minorAngle = rad(360 / (this.options.categories.length * 2));
		            var minorRadius = Math.cos(minorAngle) * radius;
		            var majorAngles = this.majorAngles();
	
		            var radiusCallback = function(angle) {
		                if (!skipMajor && inArray(angle, majorAngles)) {
		                    return radius;
		                }
	
		                return minorRadius;
		            };
		            return radiusCallback;
		        }
		    },
	
		    createPlotBands: function() {
		        var this$1 = this;
	
		        var plotBands = this.options.plotBands || [];
	
		        var group = this._plotbandGroup = new Group({
		            zIndex: -1
		        });
	
		        for (var i = 0; i < plotBands.length; i++) {
		            var band = plotBands[i];
		            var slot = this$1.plotBandSlot(band);
		            var singleSlot = this$1.getSlot(band.from);
	
		            var head = band.from - Math.floor(band.from);
		            slot.startAngle += head * singleSlot.angle;
	
		            var tail = Math.ceil(band.to) - band.to;
		            slot.angle -= (tail + head) * singleSlot.angle;
	
		            var ring = ShapeBuilder.current.createRing(slot, {
		                fill: {
		                    color: band.color,
		                    opacity: band.opacity
		                },
		                stroke: {
		                    opacity: band.opacity
		                }
		            });
		            group.append(ring);
		        }
	
		        this.appendVisual(group);
		    },
	
		    plotBandSlot: function(band) {
		        return this.getSlot(band.from, band.to - 1);
		    },
	
		    getSlot: function(from, to) {
		        var options = this.options;
		        var justified = options.justified;
		        var box = this.box;
		        var divs = this.majorAngles();
		        var totalDivs = divs.length;
		        var slotAngle = 360 / totalDivs;
		        var fromValue = from;
	
		        if (options.reverse && !justified) {
		            fromValue = (fromValue + 1) % totalDivs;
		        }
	
		        fromValue = limitValue(Math.floor(fromValue), 0, totalDivs - 1);
		        var slotStart = divs[fromValue];
	
		        if (justified) {
		            slotStart = slotStart - slotAngle / 2;
	
		            if (slotStart < 0) {
		                slotStart += 360;
		            }
		        }
	
		        var toValue = limitValue(Math.ceil(to || fromValue), fromValue, totalDivs - 1);
		        var slots = toValue - fromValue + 1;
		        var angle = slotAngle * slots;
	
		        return new Ring(box.center(), 0, box.height() / 2, slotStart, angle);
		    },
	
		    slot: function(from, to) {
		        var slot = this.getSlot(from, to);
		        var startAngle = slot.startAngle + 180;
		        var endAngle = startAngle + slot.angle;
	
		        return new geometry.Arc([ slot.center.x, slot.center.y ], {
		            startAngle: startAngle,
		            endAngle: endAngle,
		            radiusX: slot.radius,
		            radiusY: slot.radius
		        });
		    },
	
		    pointCategoryIndex: function(point) {
		        var this$1 = this;
	
		        var length = this.options.categories.length;
		        var index = null;
	
		        for (var i = 0; i < length; i++) {
		            var slot = this$1.getSlot(i);
		            if (slot.containsPoint(point)) {
		                index = i;
		                break;
		            }
		        }
	
		        return index;
		    }
		});
	
		setDefaultOptions(RadarCategoryAxis, {
		    startAngle: 90,
		    labels: {
		        margin: getSpacing(10)
		    },
		    majorGridLines: {
		        visible: true
		    },
		    justified: true
		});
		deepExtend(RadarCategoryAxis.prototype, GridLinesMixin);
	
		var PolarAxis = Axis.extend({
		    init: function(options, chartService) {
		        Axis.fn.init.call(this, options, chartService);
	
		        var instanceOptions = this.options;
	
		        instanceOptions.minorUnit = instanceOptions.minorUnit || instanceOptions.majorUnit / 2;
		    },
	
		    getDivisions: function(stepValue) {
		        return NumericAxis.prototype.getDivisions.call(this, stepValue) - 1;
		    },
	
		    reflow: function(box) {
		        this.box = box;
		        this.reflowLabels();
		    },
	
		    reflowLabels: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var labels = ref.labels;
		        var labelOptions = ref.options.labels;
		        var skip = labelOptions.skip || 0;
		        var step = labelOptions.step || 1;
	
		        var measureBox = new Box();
		        var divs = this.intervals(options.majorUnit, skip, step);
	
		        for (var i = 0; i < labels.length; i++) {
		            labels[i].reflow(measureBox);
		            var labelBox = labels[i].box;
	
		            labels[i].reflow(this$1.getSlot(divs[i]).adjacentBox(0, labelBox.width(), labelBox.height()));
		        }
		    },
	
		    lineBox: function() {
		        return this.box;
		    },
	
		    intervals: function(size, skipOption, stepOption, skipAngles) {
		        if (skipAngles === void 0) { skipAngles = false; }
	
		        var min = this.options.min;
		        var divisions = this.getDivisions(size);
		        var divs = [];
		        var skip = skipOption || 0;
		        var step = stepOption || 1;
	
		        for (var i = skip; i < divisions; i += step) {
		            var current = (360 + min + i * size) % 360;
		            if (!(skipAngles && inArray(current, skipAngles))) {
		                divs.push(current);
		            }
		        }
	
		        return divs;
		    },
	
		    majorIntervals: function() {
		        return this.intervals(this.options.majorUnit);
		    },
	
		    minorIntervals: function() {
		        return this.intervals(this.options.minorUnit);
		    },
	
		    intervalAngle: function(i) {
		        return (540 - i - this.options.startAngle) % 360;
		    },
	
		    createLine: function() {
		        return [];
		    },
	
		    majorGridLineAngles: function(altAxis) {
		        var majorGridLines = this.options.majorGridLines;
		        return this.gridLineAngles(altAxis, this.options.majorUnit, majorGridLines.skip, majorGridLines.step);
		    },
	
		    minorGridLineAngles: function(altAxis, skipMajor) {
		        var options = this.options;
		        var minorGridLines = options.minorGridLines;
		        var majorGridLines = options.majorGridLines;
		        var majorGridLineAngles = skipMajor ? this.intervals(options.majorUnit, majorGridLines.skip, majorGridLines.step) : null;
	
		        return this.gridLineAngles(altAxis, options.minorUnit, minorGridLines.skip, minorGridLines.step, majorGridLineAngles);
		    },
	
		    plotBandSlot: function(band) {
		        return this.getSlot(band.from, band.to);
		    },
	
		    getSlot: function(a, b) {
		        var ref = this;
		        var options = ref.options;
		        var box = ref.box;
		        var startAngle = options.startAngle;
		        var start = limitValue(a, options.min, options.max);
		        var end = limitValue(b || start, start, options.max);
	
		        if (options.reverse) {
		            start *= -1;
		            end *= -1;
		        }
	
		        start = (540 - start - startAngle) % 360;
		        end = (540 - end - startAngle) % 360;
	
		        if (end < start) {
		            var tmp = start;
		            start = end;
		            end = tmp;
		        }
	
		        return new Ring(box.center(), 0, box.height() / 2, start, end - start);
		    },
	
		    slot: function(from, to) {
		        if (to === void 0) { to = from; }
	
		        var options = this.options;
		        var start = 360 - options.startAngle;
		        var slot = this.getSlot(from, to);
		        var min = Math.min(from, to);
		        var max = Math.max(from, to);
		        var startAngle, endAngle;
	
		        if (options.reverse) {
		            startAngle = min;
		            endAngle = max;
		        } else {
		            startAngle = 360 - max;
		            endAngle = 360 - min;
		        }
	
		        startAngle = (startAngle + start) % 360;
		        endAngle = (endAngle + start) % 360;
	
		        return new geometry.Arc([ slot.center.x, slot.center.y ], {
		            startAngle: startAngle,
		            endAngle: endAngle,
		            radiusX: slot.radius,
		            radiusY: slot.radius
		        });
		    },
	
		    getValue: function(point) {
		        var options = this.options;
		        var center = this.box.center();
		        var dx = point.x - center.x;
		        var dy = point.y - center.y;
		        var theta = Math.round(deg(Math.atan2(dy, dx)));
		        var start = options.startAngle;
	
		        if (!options.reverse) {
		            theta *= -1;
		            start *= -1;
		        }
	
		        return (theta + start + 360) % 360;
		    },
	
		    valueRange: function() {
		        return {
		            min: 0,
		            max: Math.PI * 2
		        };
		    }
		});
	
		setDefaultOptions(PolarAxis, {
		    type: "polar",
		    startAngle: 0,
		    reverse: false,
		    majorUnit: 60,
		    min: 0,
		    max: 360,
		    labels: {
		        margin: getSpacing(10)
		    },
		    majorGridLines: {
		        color: BLACK,
		        visible: true,
		        width: 1
		    },
		    minorGridLines: {
		        color: "#aaa"
		    }
		});
	
		deepExtend(PolarAxis.prototype, GridLinesMixin, {
		    createPlotBands: RadarCategoryAxis.prototype.createPlotBands,
		    majorAngles: RadarCategoryAxis.prototype.majorAngles,
		    range: NumericAxis.prototype.range,
		    labelsCount: NumericAxis.prototype.labelsCount,
		    createAxisLabel: NumericAxis.prototype.createAxisLabel
		});
	
		var RadarNumericAxisMixin = {
		    options: {
		        majorGridLines: {
		            visible: true
		        }
		    },
	
		    createPlotBands: function() {
		        var this$1 = this;
	
		        var ref = this.options;
		        var type = ref.majorGridLines.type;
		        var plotBands = ref.plotBands; if (plotBands === void 0) { plotBands = []; }
		        var altAxis = this.plotArea.polarAxis;
		        var majorAngles = altAxis.majorAngles();
		        var center = altAxis.box.center();
		        var group = this._plotbandGroup = new Group({
		            zIndex: -1
		        });
	
		        for (var i = 0; i < plotBands.length; i++) {
		            var band = plotBands[i];
		            var bandStyle = {
		                fill: {
		                    color: band.color,
		                    opacity: band.opacity
		                },
		                stroke: {
		                    opacity: band.opacity
		                }
		            };
	
		            var slot = this$1.getSlot(band.from, band.to, true);
		            var ring = new Ring(center, center.y - slot.y2, center.y - slot.y1, 0, 360);
	
		            var shape = (void 0);
		            if (type === ARC) {
		                shape = ShapeBuilder.current.createRing(ring, bandStyle);
		            } else {
		                shape = Path.fromPoints(this$1.plotBandPoints(ring, majorAngles), bandStyle).close();
		            }
	
		            group.append(shape);
		        }
	
		        this.appendVisual(group);
		    },
	
		    plotBandPoints: function(ring, angles) {
		        var innerPoints = [];
		        var outerPoints = [];
		        var center = [ ring.center.x, ring.center.y ];
		        var innerCircle = new Circle(center, ring.innerRadius);
		        var outerCircle = new Circle(center, ring.radius);
	
		        for (var i = 0; i < angles.length; i++) {
		            innerPoints.push(innerCircle.pointAt(angles[i] + 180));
		            outerPoints.push(outerCircle.pointAt(angles[i] + 180));
		        }
	
		        innerPoints.reverse();
		        innerPoints.push(innerPoints[0]);
		        outerPoints.push(outerPoints[0]);
	
		        return outerPoints.concat(innerPoints);
		    },
	
		    createGridLines: function(altAxis) {
		        var options = this.options;
		        var majorTicks = this.radarMajorGridLinePositions();
		        var majorAngles = altAxis.majorAngles();
		        var center = altAxis.box.center();
		        var gridLines = [];
	
		        if (options.majorGridLines.visible) {
		            gridLines = this.renderGridLines(
		                center, majorTicks, majorAngles, options.majorGridLines
		            );
		        }
	
		        if (options.minorGridLines.visible) {
		            var minorTicks = this.radarMinorGridLinePositions();
		            append(gridLines, this.renderGridLines(
		                center, minorTicks, majorAngles, options.minorGridLines
		            ));
		        }
	
		        return gridLines;
		    },
	
		    renderGridLines: function(center, ticks, angles, options) {
		        var style = {
		            stroke: {
		                width: options.width,
		                color: options.color,
		                dashType: options.dashType
		            }
		        };
		        var skip = options.skip; if (skip === void 0) { skip = 0; }
		        var step = options.step; if (step === void 0) { step = 0; }
		        var container = this.gridLinesVisual();
	
		        for (var tickIx = skip; tickIx < ticks.length; tickIx += step) {
		            var tickRadius = center.y - ticks[tickIx];
		            if (tickRadius > 0) {
		                var circle = new Circle([ center.x, center.y ], tickRadius);
		                if (options.type === ARC) {
		                    container.append(new drawing.Circle(circle, style));
		                } else {
		                    var line = new Path(style);
		                    for (var angleIx = 0; angleIx < angles.length; angleIx++) {
		                        line.lineTo(circle.pointAt(angles[angleIx] + 180));
		                    }
	
		                    line.close();
		                    container.append(line);
		                }
		            }
		        }
	
		        return container.children;
		    },
	
		    getValue: function(point) {
		        var lineBox = this.lineBox();
		        var altAxis = this.plotArea.polarAxis;
		        var majorAngles = altAxis.majorAngles();
		        var center = altAxis.box.center();
		        var radius = point.distanceTo(center);
		        var distance = radius;
	
		        if (this.options.majorGridLines.type !== ARC && majorAngles.length > 1) {
		            var dx = point.x - center.x;
		            var dy = point.y - center.y;
		            var theta = (deg(Math.atan2(dy, dx)) + 540) % 360;
	
		            majorAngles.sort(function(a, b) {
		                return angularDistance(a, theta) - angularDistance(b, theta);
		            });
	
		            // Solve triangle (center, point, axis X) using one side (radius) and two angles.
		            // Angles are derived from triangle (center, point, gridline X)
		            var midAngle = angularDistance(majorAngles[0], majorAngles[1]) / 2;
		            var alpha = angularDistance(theta, majorAngles[0]);
		            var gamma = 90 - midAngle;
		            var beta = 180 - alpha - gamma;
	
		            distance = radius * (Math.sin(rad(beta)) / Math.sin(rad(gamma)));
		        }
	
		        return this.axisType().prototype.getValue.call(
		            this, new Point(lineBox.x1, lineBox.y2 - distance)
		        );
		    }
		};
	
		function angularDistance(a, b) {
		    return 180 - Math.abs(Math.abs(a - b) - 180);
		}
	
		var RadarNumericAxis = NumericAxis.extend({
		    radarMajorGridLinePositions: function() {
		        return this.getTickPositions(this.options.majorUnit);
		    },
	
		    radarMinorGridLinePositions: function() {
		        var options = this.options;
		        var minorSkipStep = 0;
	
		        if (options.majorGridLines.visible) {
		            minorSkipStep = options.majorUnit;
		        }
		        return this.getTickPositions(options.minorUnit, minorSkipStep);
		    },
	
		    axisType: function() {
		        return NumericAxis;
		    }
		});
	
		deepExtend(RadarNumericAxis.prototype, RadarNumericAxisMixin);
	
		var RadarLogarithmicAxis = LogarithmicAxis.extend({
		    radarMajorGridLinePositions: function() {
		        var positions = [];
	
		        this.traverseMajorTicksPositions(function(position) {
		            positions.push(position);
		        }, this.options.majorGridLines);
	
		        return positions;
		    },
	
		    radarMinorGridLinePositions: function() {
		        var positions = [];
	
		        this.traverseMinorTicksPositions(function(position) {
		            positions.push(position);
		        }, this.options.minorGridLines);
	
		        return positions;
		    },
	
		    axisType: function() {
		        return LogarithmicAxis;
		    }
		});
	
		deepExtend(RadarLogarithmicAxis.prototype, RadarNumericAxisMixin);
	
		var WEIGHT = 0.333;
		var EXTREMUM_ALLOWED_DEVIATION = 0.01;
	
		var CurveProcessor = Class.extend({
		    init: function(closed) {
	
		        this.closed = closed;
		    },
	
		    process: function(dataPoints) {
		        var this$1 = this;
	
		        var points = dataPoints.slice(0);
		        var segments = [];
		        var closed = this.closed;
		        var length = points.length;
	
		        if (length > 2) {
		            this.removeDuplicates(0, points);
		            length = points.length;
		        }
	
		        if (length < 2 || (length === 2 && points[0].equals(points[1]))) {
		            return segments;
		        }
	
		        var p0 = points[0];
		        var p1 = points[1];
		        var p2 = points[2];
	
		        segments.push(new Segment(p0));
	
		        while (p0.equals(points[length - 1])) {
		            closed = true;
		            points.pop();
		            length--;
		        }
	
		        if (length === 2) {
		            var tangent = this.tangent(p0,p1, X, Y);
	
		            last(segments).controlOut(
		                this.firstControlPoint(tangent, p0, p1, X, Y)
		            );
	
		            segments.push(new Segment(
		                p1,
		                this.secondControlPoint(tangent, p0, p1, X, Y)
		            ));
	
		            return segments;
		        }
	
		        var initialControlPoint, lastControlPoint;
	
		        if (closed) {
		            p0 = points[length - 1]; p1 = points[0]; p2 = points[1];
		            var controlPoints = this.controlPoints(p0, p1, p2);
		            initialControlPoint = controlPoints[1];
		            lastControlPoint = controlPoints[0];
		        } else {
		            var tangent$1 = this.tangent(p0, p1, X,Y);
		            initialControlPoint = this.firstControlPoint(tangent$1, p0, p1, X, Y);
		        }
	
		        var cp0 = initialControlPoint;
		        for (var idx = 0; idx <= length - 3; idx++) {
		            this$1.removeDuplicates(idx, points);
		            length = points.length;
		            if (idx + 3 <= length) {
		                p0 = points[idx]; p1 = points[idx + 1]; p2 = points[idx + 2];
		                var controlPoints$1 = this$1.controlPoints(p0,p1,p2);
	
		                last(segments).controlOut(cp0);
		                cp0 = controlPoints$1[1];
	
		                var cp1 = controlPoints$1[0];
		                segments.push(new Segment(p1, cp1));
		            }
		        }
	
		        if (closed) {
		            p0 = points[length - 2]; p1 = points[length - 1]; p2 = points[0];
		            var controlPoints$2 = this.controlPoints(p0, p1, p2);
	
		            last(segments).controlOut(cp0);
		            segments.push(new Segment(
		                p1,
		                controlPoints$2[0]
		            ));
	
		            last(segments).controlOut(controlPoints$2[1]);
		            segments.push(new Segment(
		                p2,
		                lastControlPoint
		            ));
		        } else {
		            var tangent$2 = this.tangent(p1, p2, X, Y);
	
		            last(segments).controlOut(cp0);
		            segments.push(new Segment(
		                p2,
		                this.secondControlPoint(tangent$2, p1, p2, X, Y)
		            ));
		        }
	
		        return segments;
		    },
	
		    removeDuplicates: function(idx, points) {
		        while (points[idx + 1] && (points[idx].equals(points[idx + 1]) || points[idx + 1].equals(points[idx + 2]))) {
		            points.splice(idx + 1, 1);
		        }
		    },
	
		    invertAxis: function(p0, p1, p2) {
		        var invertAxis = false;
	
		        if (p0.x === p1.x) {
		            invertAxis = true;
		        } else if (p1.x === p2.x) {
		            if ((p1.y < p2.y && p0.y <= p1.y) || (p2.y < p1.y && p1.y <= p0.y)) {
		                invertAxis = true;
		            }
		        } else {
		            var fn = this.lineFunction(p0,p1);
		            var y2 = this.calculateFunction(fn, p2.x);
		            if (!(p0.y <= p1.y && p2.y <= y2) &&
		                !(p1.y <= p0.y && p2.y >= y2)) {
		                invertAxis = true;
		            }
		        }
	
		        return invertAxis;
		    },
	
		    isLine: function(p0, p1, p2) {
		        var fn = this.lineFunction(p0, p1);
		        var y2 = this.calculateFunction(fn, p2.x);
	
		        return (p0.x === p1.x && p1.x === p2.x) || round(y2, 1) === round(p2.y, 1);
		    },
	
		    lineFunction: function(p1, p2) {
		        var a = (p2.y - p1.y) / (p2.x - p1.x);
		        var b = p1.y - a * p1.x;
	
		        return [ b, a ];
		    },
	
		    controlPoints: function(p0, p1, p2) {
		        var xField = X;
		        var yField = Y;
		        var restrict = false;
		        var switchOrientation = false;
		        var tangent;
	
		        if (this.isLine(p0, p1, p2)) {
		            tangent = this.tangent(p0, p1, X, Y);
		        } else {
		            var monotonic = {
		                x: this.isMonotonicByField(p0, p1, p2, X),
		                y: this.isMonotonicByField(p0, p1, p2, Y)
		            };
	
		            if (monotonic.x && monotonic.y) {
		                tangent = this.tangent(p0, p2, X, Y);
		                restrict = true;
		            } else {
		                if (this.invertAxis(p0, p1, p2)) {
		                    xField = Y;
		                    yField = X;
		                }
	
		                if (monotonic[xField]) {
		                    tangent = 0;
		                } else {
		                    var sign;
		                    if ((p2[yField] < p0[yField] && p0[yField] <= p1[yField]) ||
		                        (p0[yField] < p2[yField] && p1[yField] <= p0[yField])) {
		                        sign = numberSign((p2[yField] - p0[yField]) * (p1[xField] - p0[xField]));
		                    } else {
		                        sign = -numberSign((p2[xField] - p0[xField]) * (p1[yField] - p0[yField]));
		                    }
	
		                    tangent = EXTREMUM_ALLOWED_DEVIATION * sign;
		                    switchOrientation = true;
		                }
		            }
		        }
	
		        var secondControlPoint = this.secondControlPoint(tangent, p0, p1, xField, yField);
	
		        if (switchOrientation) {
		            var oldXField = xField;
		            xField = yField;
		            yField = oldXField;
		        }
	
		        var firstControlPoint = this.firstControlPoint(tangent, p1, p2, xField, yField);
	
		        if (restrict) {
		            this.restrictControlPoint(p0, p1, secondControlPoint, tangent);
		            this.restrictControlPoint(p1, p2, firstControlPoint, tangent);
		        }
	
		        return [ secondControlPoint, firstControlPoint ];
		    },
	
		    restrictControlPoint: function(p1, p2, cp, tangent) {
		        if (p1.y < p2.y) {
		            if (p2.y < cp.y) {
		                cp.x = p1.x + (p2.y - p1.y) / tangent;
		                cp.y = p2.y;
		            } else if (cp.y < p1.y) {
		                cp.x = p2.x - (p2.y - p1.y) / tangent;
		                cp.y = p1.y;
		            }
		        } else {
		            if (cp.y < p2.y) {
		                cp.x = p1.x - (p1.y - p2.y) / tangent;
		                cp.y = p2.y;
		            } else if (p1.y < cp.y) {
		                cp.x = p2.x + (p1.y - p2.y) / tangent;
		                cp.y = p1.y;
		            }
		        }
		    },
	
		    tangent: function(p0, p1, xField, yField) {
		        var x = p1[xField] - p0[xField];
		        var y = p1[yField] - p0[yField];
		        var tangent;
	
		        if (x === 0) {
		            tangent = 0;
		        } else {
		            tangent = y / x;
		        }
	
		        return tangent;
		    },
	
		    isMonotonicByField: function(p0, p1, p2, field) {
		        return (p2[field] > p1[field] && p1[field] > p0[field]) ||
		                    (p2[field] < p1[field] && p1[field] < p0[field]);
		    },
	
		    firstControlPoint: function(tangent, p0, p3, xField, yField) {
		        var t1 = p0[xField];
		        var t2 = p3[xField];
		        var distance = (t2 - t1) * WEIGHT;
	
		        return this.point(t1 + distance, p0[yField] + distance * tangent, xField, yField);
		    },
	
		    secondControlPoint: function(tangent, p0, p3, xField, yField) {
		        var t1 = p0[xField];
		        var t2 = p3[xField];
		        var distance = (t2 - t1) * WEIGHT;
	
		        return this.point(t2 - distance, p3[yField] - distance * tangent, xField, yField);
		    },
	
		    point: function(xValue, yValue, xField, yField) {
		        var controlPoint = new geometry.Point();
		        controlPoint[xField] = xValue;
		        controlPoint[yField] = yValue;
	
		        return controlPoint;
		    },
	
		    calculateFunction: function(fn, x) {
		        var length = fn.length;
		        var result = 0;
	
		        for (var i = 0; i < length; i++) {
		            result += Math.pow(x,i) * fn[i];
		        }
		        return result;
		    }
		});
	
		function numberSign(value) {
		    return value <= 0 ? -1 : 1;
		}
	
		dataviz.Gradients = GRADIENTS;
	
		kendo.deepExtend(kendo.dataviz, {
		    constants: constants,
		    services: services,
		    autoMajorUnit: autoMajorUnit,
		    Point: Point,
		    Box: Box,
		    Ring: Ring,
		    Sector: Sector,
		    ShapeBuilder: ShapeBuilder,
		    ShapeElement: ShapeElement,
		    ChartElement: ChartElement,
		    BoxElement: BoxElement,
		    RootElement: RootElement,
		    FloatElement: FloatElement,
		    Text: Text,
		    TextBox: TextBox,
		    Title: Title,
		    AxisLabel: AxisLabel,
		    Axis: Axis,
		    Note: Note,
		    CategoryAxis: CategoryAxis,
		    DateCategoryAxis: DateCategoryAxis,
		    DateValueAxis: DateValueAxis,
		    NumericAxis: NumericAxis,
		    LogarithmicAxis: LogarithmicAxis,
		    PolarAxis: PolarAxis,
		    RadarCategoryAxis: RadarCategoryAxis,
		    RadarNumericAxis: RadarNumericAxis,
		    RadarLogarithmicAxis: RadarLogarithmicAxis,
		    CurveProcessor: CurveProcessor,
		    rectToBox: rectToBox,
		    addClass: addClass,
		    removeClass: removeClass,
		    alignPathToPixel: alignPathToPixel,
		    clockwise: clockwise,
		    convertableToNumber: convertableToNumber,
		    deepExtend: deepExtend,
		    elementStyles: elementStyles,
		    getSpacing: getSpacing,
		    getTemplate: getTemplate,
		    getter: __common_getter_js,
		    grep: grep,
		    hasClasses: hasClasses,
		    HashMap: HashMap,
		    inArray: inArray,
		    interpolateValue: interpolateValue,
		    InstanceObserver: InstanceObserver,
		    isArray: isArray,
		    isFunction: isFunction,
		    isNumber: isNumber,
		    isObject: isObject,
		    isString: isString,
		    map: map,
		    mousewheelDelta: mousewheelDelta,
		    FontLoader: FontLoader,
		    setDefaultOptions: setDefaultOptions,
		    sparseArrayLimits: sparseArrayLimits,
		    styleValue: styleValue,
		    append: append,
		    bindEvents: bindEvents,
		    Class: Class,
		    defined: defined,
		    deg: deg,
		    elementOffset: elementOffset,
		    elementSize: elementSize,
		    eventElement: eventElement,
		    eventCoordinates: eventCoordinates,
		    last: last,
		    limitValue: limitValue,
		    logToConsole: kendo.logToConsole,
		    objectKey: objectKey,
		    rad: rad,
		    round: round,
		    unbindEvents: unbindEvents,
		    valueOrDefault: valueOrDefault,
		    absoluteDateDiff: absoluteDateDiff,
		    addDuration: addDuration,
		    addTicks: addTicks,
		    ceilDate: ceilDate,
		    dateComparer: dateComparer,
		    dateDiff: dateDiff,
		    dateEquals: dateEquals,
		    dateIndex: dateIndex,
		    duration: duration,
		    floorDate: floorDate,
		    lteDateIndex: lteDateIndex,
		    startOfWeek: startOfWeek,
		    toDate: toDate,
		    parseDate: parseDate,
		    parseDates: parseDates,
		    toTime: toTime
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(864);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 864:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(865)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		    var dataviz = kendo.dataviz;
		    var services = dataviz.services;
		    var draw = kendo.drawing;
	
		    dataviz.ExportMixin = {
		        extend: function(proto, skipLegacy) {
		            if (!proto.exportVisual) {
		                throw new Error("Mixin target has no exportVisual method defined.");
		            }
	
		            proto.exportSVG = this.exportSVG;
		            proto.exportImage = this.exportImage;
		            proto.exportPDF = this.exportPDF;
	
		            if (!skipLegacy) {
		                proto.svg = this.svg;
		                proto.imageDataURL = this.imageDataURL;
		            }
		        },
	
		        exportSVG: function(options) {
		            return draw.exportSVG(this.exportVisual(), options);
		        },
	
		        exportImage: function(options) {
		            return draw.exportImage(this.exportVisual(options), options);
		        },
	
		        exportPDF: function(options) {
		            return draw.exportPDF(this.exportVisual(), options);
		        },
	
		        svg: function() {
		            if (draw.svg.Surface) {
		                return draw.svg.exportGroup(this.exportVisual());
		            } else {
		                throw new Error("SVG Export failed. Unable to export instantiate kendo.drawing.svg.Surface");
		            }
		        },
	
		        imageDataURL: function() {
		            if (!kendo.support.canvas) {
		                return null;
		            }
	
		            if (draw.canvas.Surface) {
		                var container = $("<div />").css({
		                    display: "none",
		                    width: this.element.width(),
		                    height: this.element.height()
		                }).appendTo(document.body);
	
		                var surface = new draw.canvas.Surface(container[0]);
		                surface.draw(this.exportVisual());
		                var image = surface._rootElement.toDataURL();
	
		                surface.destroy();
		                container.remove();
	
		                return image;
		            } else {
		                throw new Error("Image Export failed. Unable to export instantiate kendo.drawing.canvas.Surface");
		            }
		        }
		    };
	
		    services.IntlService.register({
		       format: function(format) {
		           return kendo.format.apply(null, [format].concat(Array.prototype.slice.call(arguments, 1)));
		       },
		       toString: kendo.toString,
		       parseDate: kendo.parseDate
		    });
	
		    services.TemplateService.register({
		       compile: kendo.template
		    });
	
		    dataviz.Point2D = dataviz.Point;
		    dataviz.Box2D = dataviz.Box;
		    dataviz.mwDelta = function(e) {
		        return dataviz.mousewheelDelta(e.originalEvent);
		    };
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 865:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(743);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1109);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1060:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 1109:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1060),
		        __webpack_require__(1110),
		        __webpack_require__(1111),
		        __webpack_require__(1112)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.themes",
		    name: "Themes",
		    description: "Built-in themes for the DataViz widgets",
		    category: "dataviz",
		    depends: [ "dataviz.core" ],
		    hidden: true
		};
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1110:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(746);
	
	/***/ }),
	
	/***/ 1111:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(747);
	
	/***/ }),
	
	/***/ 1112:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(748);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(916);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 857:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 916:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		     !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(857) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function () {
	
		window.kendo.dataviz = window.kendo.dataviz || {};
	
		var BAR_GAP = 1.5;
		var BAR_SPACING = 0.4;
		var BLACK = '#000';
		var SANS = 'Arial, Helvetica, sans-serif';
		var SANS11 = "11px " + SANS;
		var SANS12 = '12px ' + SANS;
		var SANS16 = '16px ' + SANS;
		var TRANSPARENT = 'transparent';
		var WHITE = '#fff';
	
		var notes = function () { return ({
		    icon: {
		        border: {
		            width: 1
		        }
		    },
		    label: {
		        font: SANS12,
		        padding: 3
		    },
		    line: {
		        length: 10,
		        width: 2
		    },
		    visible: true
		}); };
	
		var axisDefaults = function () { return ({
		    labels: {
		        font: SANS12
		    },
		    notes: notes(),
		    title: {
		        font: SANS16,
		        margin: 5
		    }
		}); };
	
		var areaSeries = function () { return ({
		    highlight: {
		        markers: {
		            border: {}
		        }
		    },
		    line: {
		        opacity: 1,
		        width: 0
		    },
		    markers: {
		        size: 6,
		        visible: false
		    },
		    opacity: 0.4
		}); };
	
		var rangeAreaSeries = function () { return ({
		    highlight: {
		        markers: {
		            border: {}
		        }
		    },
		    line: {
		        opacity: 1,
		        width: 0
		    },
		    markers: {
		        size: 6,
		        visible: false
		    },
		    opacity: 0.4
		}); };
	
		var barSeries = function () { return ({
		    gap: BAR_GAP,
		    spacing: BAR_SPACING
		}); };
	
		var boxPlotSeries = function () { return ({
		    outliersField: "",
		    meanField: "",
		    border: {
		        _brightness: 0.8,
		        width: 1
		    },
		    downColor: WHITE,
		    gap: 1,
		    highlight: {
		        border: {
		            opacity: 1,
		            width: 2
		        },
		        whiskers: {
		            width: 3
		        },
		        mean: {
		            width: 2
		        },
		        median: {
		            width: 2
		        }
		    },
		    mean: {
		        width: 2
		    },
		    median: {
		        width: 2
		    },
		    spacing: 0.3,
		    whiskers: {
		        width: 2
		    }
		}); };
	
		var bubbleSeries = function () { return ({
		    border: {
		        width: 0
		    },
		    labels: {
		        background: TRANSPARENT
		    },
		    opacity: 0.6
		}); };
	
		var bulletSeries = function () { return ({
		    gap: BAR_GAP,
		    spacing: BAR_SPACING,
		    target: {
		        color: "#ff0000"
		    }
		}); };
	
		var candlestickSeries = function () { return ({
		    border: {
		        _brightness: 0.8,
		        width: 1
		    },
		    downColor: WHITE,
		    gap: 1,
		    highlight: {
		        border: {
		            opacity: 1,
		            width: 2
		        },
		        line: {
		            width: 2
		        }
		    },
		    line: {
		        color: BLACK,
		        width: 1
		    },
		    spacing: 0.3
		}); };
	
		var columnSeries = function () { return ({
		    gap: BAR_GAP,
		    spacing: BAR_SPACING
		}); };
	
		var donutSeries = function () { return ({
		    margin: 1
		}); };
	
		var lineSeries = function () { return ({
		    width: 2
		}); };
	
		var ohlcSeries = function () { return ({
		    gap: 1,
		    highlight: {
		        line: {
		            opacity: 1,
		            width: 3
		        }
		    },
		    line: {
		        width: 1
		    },
		    spacing: 0.3
		}); };
	
		var radarAreaSeries = function () { return ({
		    line: {
		        opacity: 1,
		        width: 0
		    },
		    markers: {
		        size: 6,
		        visible: false
		    },
		    opacity: 0.5
		}); };
	
		var radarLineSeries = function () { return ({
		    markers: {
		        visible: false
		    },
		    width: 2
		}); };
	
		var rangeBarSeries = function () { return ({
		    gap: BAR_GAP,
		    spacing: BAR_SPACING
		}); };
	
		var rangeColumnSeries = function () { return ({
		    gap: BAR_GAP,
		    spacing: BAR_SPACING
		}); };
	
		var scatterLineSeries = function () { return ({
		    width: 1
		}); };
	
		var waterfallSeries = function () { return ({
		    gap: 0.5,
		    line: {
		        color: BLACK,
		        width: 1
		    },
		    spacing: BAR_SPACING
		}); };
	
		var pieSeries = function () { return ({
		    labels: {
		        background: '',
		        color: '',
		        padding: {
		            top: 5,
		            bottom: 5,
		            left: 7,
		            right: 7
		        }
		    }
		}); };
	
		var funnelSeries = function () { return ({
		    labels: {
		        background: '',
		        color: '',
		        padding: {
		            top: 5,
		            bottom: 5,
		            left: 7,
		            right: 7
		        }
		    }
		}); };
	
		var seriesDefaults = function (options) { return ({
		    visible: true,
		    labels: {
		        font: SANS11
		    },
		    overlay: options.gradients ? {} : {
		        gradient: "none"
		    },
		    area: areaSeries(),
		    rangeArea: rangeAreaSeries(),
		    verticalRangeArea: rangeAreaSeries(),
		    bar: barSeries(),
		    boxPlot: boxPlotSeries(),
		    bubble: bubbleSeries(),
		    bullet: bulletSeries(),
		    candlestick: candlestickSeries(),
		    column: columnSeries(),
		    pie: pieSeries(),
		    donut: donutSeries(),
		    funnel: funnelSeries(),
		    horizontalWaterfall: waterfallSeries(),
		    line: lineSeries(),
		    notes: notes(),
		    ohlc: ohlcSeries(),
		    radarArea: radarAreaSeries(),
		    radarLine: radarLineSeries(),
		    polarArea: radarAreaSeries(),
		    polarLine: radarLineSeries(),
		    rangeBar: rangeBarSeries(),
		    rangeColumn: rangeColumnSeries(),
		    scatterLine: scatterLineSeries(),
		    verticalArea: areaSeries(),
		    verticalBoxPlot: boxPlotSeries(),
		    verticalBullet: bulletSeries(),
		    verticalLine: lineSeries(),
		    waterfall: waterfallSeries()
		}); };
	
		var title = function () { return ({
		    font: SANS16
		}); };
	
		var legend = function () { return ({
		    labels: {
		        font: SANS12
		    }
		}); };
	
		var baseTheme = function (options) {
		    if (options === void 0) { options = {}; }
	
		    return ({
		    axisDefaults: axisDefaults(),
		    categoryAxis: {
		        majorGridLines: {
		            visible: true
		        }
		    },
		    navigator: {
		        pane: {
		            height: 90,
		            margin: {
		                top: 10
		            }
		        }
		    },
		    seriesDefaults: seriesDefaults(options),
		    title: title(),
		    legend: legend()
		});
		};
	
		kendo.deepExtend(kendo.dataviz, {
		    chartBaseTheme: baseTheme
		});
	
		})();
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(915);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 857:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 915:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		     !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(857) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function($) {
		    var cache;
	
		    function autoTheme(force) {
		        if (!force && cache) {
		            return cache;
		        }
	
		        var theme = { chart: kendo.dataviz.chartBaseTheme() };
		        var hook = $(
		            '<div style="display: none">' +
		            '  <div class="k-var--accent"></div>' +
		            '  <div class="k-var--accent-contrast"></div>' +
		            '  <div class="k-var--base"></div>' +
		            '  <div class="k-var--background"></div>' +
		            '  <div class="k-var--normal-background"></div>' +
		            '  <div class="k-var--normal-text-color"></div>' +
		            '  <div class="k-var--hover-background"></div>' +
		            '  <div class="k-var--hover-text-color"></div>' +
		            '  <div class="k-var--selected-background"></div>' +
		            '  <div class="k-var--selected-text-color"></div>' +
		            '  <div class="k-var--chart-error-bars-background"></div>' +
		            '  <div class="k-var--chart-notes-background"></div>' +
		            '  <div class="k-var--chart-notes-border"></div>' +
		            '  <div class="k-var--chart-notes-lines"></div>' +
		            '  <div class="k-var--chart-crosshair-background"></div>' +
		            '  <div class="k-var--chart-inactive"></div>' +
		            '  <div class="k-var--chart-major-lines"></div>' +
		            '  <div class="k-var--chart-minor-lines"></div>' +
		            '  <div class="k-var--chart-area-opacity"></div>' +
		            '  <div class="k-widget">' +
		            '      <div class="k-var--chart-font"></div>' +
		            '      <div class="k-var--chart-title-font"></div>' +
		            '      <div class="k-var--chart-label-font"></div>' +
		            '  </div>' +
		            '  <div class="k-var--series">' +
		            '    <div class="k-var--series-a"></div>' +
		            '    <div class="k-var--series-b"></div>' +
		            '    <div class="k-var--series-c"></div>' +
		            '    <div class="k-var--series-d"></div>' +
		            '    <div class="k-var--series-e"></div>' +
		            '    <div class="k-var--series-f"></div>' +
		            '  </div>' +
		            '  <div class="k-var--gauge-pointer"></div>' +
		            '  <div class="k-var--gauge-track"></div>' +
		            '</div>').appendTo(document.body);
	
		        function mapColor(key, varName) {
		            set(key, queryStyle(varName, "backgroundColor"));
		        }
	
		        function queryStyle(varName, prop) {
		            return hook.find(".k-var--" + varName).css(prop);
		        }
	
		        function set(path, value) {
		            var store = theme;
		            var parts = path.split('.');
		            var key = parts.shift();
	
		            while (parts.length > 0) {
		                store = store[key] = store[key] || {};
		                key = parts.shift();
		            }
	
		            store[key] = value;
		        }
	
		        (function setColors() {
		            mapColor("chart.axisDefaults.crosshair.color", "chart-crosshair-background");
		            mapColor("chart.axisDefaults.labels.color", "normal-text-color");
		            mapColor("chart.axisDefaults.line.color", "chart-major-lines");
		            mapColor("chart.axisDefaults.majorGridLines.color", "chart-major-lines");
		            mapColor("chart.axisDefaults.minorGridLines.color", "chart-minor-lines");
		            mapColor("chart.axisDefaults.notes.icon.background", "chart-notes-background");
		            mapColor("chart.axisDefaults.notes.icon.border.color", "chart-notes-border");
		            mapColor("chart.axisDefaults.notes.line.color", "chart-notes-lines");
		            mapColor("chart.axisDefaults.title.color", "normal-text-color");
		            mapColor('chart.chartArea.background', 'background');
		            mapColor("chart.legend.inactiveItems.labels.color", "chart-inactive");
		            mapColor("chart.legend.inactiveItems.markers.color", "chart-inactive");
		            mapColor("chart.legend.labels.color", "normal-text-color");
		            mapColor("chart.seriesDefaults.boxPlot.downColor", "chart-major-lines");
		            mapColor("chart.seriesDefaults.boxPlot.mean.color", "base");
		            mapColor("chart.seriesDefaults.boxPlot.median.color", "base");
		            mapColor("chart.seriesDefaults.boxPlot.whiskers.color", "accent");
		            mapColor("chart.seriesDefaults.bullet.target.color", "accent");
		            mapColor("chart.seriesDefaults.candlestick.downColor", "normal-text-color");
		            mapColor("chart.seriesDefaults.candlestick.line.color", "normal-text-color");
		            mapColor("chart.seriesDefaults.errorBars.color", "chart-error-bars-background");
		            mapColor("chart.seriesDefaults.horizontalWaterfall.line.color", "chart-major-lines");
		            mapColor("chart.seriesDefaults.icon.border.color", "chart-major-lines");
		            mapColor("chart.seriesDefaults.labels.background", "background");
		            mapColor("chart.seriesDefaults.labels.color", "normal-text-color");
		            mapColor("chart.seriesDefaults.notes.icon.background", "chart-notes-background");
		            mapColor("chart.seriesDefaults.notes.icon.border.color", "chart-notes-border");
		            mapColor("chart.seriesDefaults.notes.line.color", "chart-notes-lines");
		            mapColor("chart.seriesDefaults.verticalBoxPlot.downColor", "chart-major-lines");
		            mapColor("chart.seriesDefaults.verticalBoxPlot.mean.color", "base");
		            mapColor("chart.seriesDefaults.verticalBoxPlot.median.color", "base");
		            mapColor("chart.seriesDefaults.verticalBoxPlot.whiskers.color", "accent");
		            mapColor("chart.seriesDefaults.verticalBullet.target.color", "accent");
		            mapColor("chart.seriesDefaults.waterfall.line.color", "chart-major-lines");
		            mapColor("chart.title.color", "normal-text-color");
	
		            set("chart.seriesDefaults.labels.opacity", queryStyle("chart-area-opacity", "opacity"));
	
		            mapColor("diagram.shapeDefaults.fill.color", "accent");
		            mapColor("diagram.shapeDefaults.content.color", "accent-contrast");
		            mapColor("diagram.shapeDefaults.connectorDefaults.fill.color", "normal-text-color");
		            mapColor("diagram.shapeDefaults.connectorDefaults.stroke.color", "accent-contrast");
		            mapColor("diagram.shapeDefaults.connectorDefaults.hover.fill.color", "accent-contrast");
		            mapColor("diagram.shapeDefaults.connectorDefaults.hover.stroke.color", "normal-text-color");
		            mapColor("diagram.editable.resize.handles.stroke.color", "normal-text-color");
		            mapColor("diagram.editable.resize.handles.fill.color", "normal-background");
		            mapColor("diagram.editable.resize.handles.hover.stroke.color", "normal-text-color");
		            mapColor("diagram.editable.resize.handles.hover.fill.color", "normal-text-color");
		            mapColor("diagram.selectable.stroke.color", "normal-text-color");
		            mapColor("diagram.connectionDefaults.stroke.color", "normal-text-color");
		            mapColor("diagram.connectionDefaults.content.color", "normal-text-color");
		            mapColor("diagram.connectionDefaults.selection.handles.fill.color", "accent-contrast");
		            mapColor("diagram.connectionDefaults.selection.handles.stroke.color", "normal-text-color");
		            mapColor("diagram.connectionDefaults.selection.stroke.color", "normal-text-color");
	
		            mapColor("gauge.pointer.color", "gauge-pointer");
		            mapColor("gauge.scale.labels.color", "normal-text-color");
		            mapColor("gauge.scale.minorTicks.color", "normal-text-color");
		            mapColor("gauge.scale.majorTicks.color", "normal-text-color");
		            mapColor("gauge.scale.line.color", "normal-text-color");
		            mapColor("gauge.scale.rangePlaceholderColor", "gauge-track");
		        })();
	
		        (function setFonts() {
		            function font(varName) {
		                return queryStyle(varName, "fontSize") + " " +
		                       queryStyle(varName, "fontFamily");
		            }
	
		            var defaultFont = font("chart-font");
		            var titleFont = font("chart-title-font");
		            var labelFont = font("chart-label-font");
	
		            set("chart.axisDefaults.labels.font", labelFont);
		            set("chart.axisDefaults.notes.label.font", defaultFont);
		            set("chart.axisDefaults.title.font", defaultFont);
		            set("chart.legend.labels.font", defaultFont);
		            set("chart.seriesDefaults.labels.font", labelFont);
		            set("chart.seriesDefaults.notes.label.font", defaultFont);
		            set("chart.title.font", titleFont);
		        })();
	
		        (function setSeriesColors() {
		            function letterPos(letter) {
		                return letter.toLowerCase().charCodeAt(0) - "a".charCodeAt(0);
		            }
	
		            function seriesPos(name) {
		                return letterPos(name.match(/series-([a-z])$/)[1]);
		            }
	
		            var series = $(".k-var--series div").toArray();
		            var seriesColors = series.reduce(
		              function(arr, el) {
		                var pos = seriesPos(el.className);
		                arr[pos] = $(el).css("backgroundColor");
	
		                return arr;
		              },
		              [] // Will populate the series colors in this array
		            );
	
		            set("chart.seriesColors", seriesColors);
		        })();
	
		        hook.remove();
	
		        cache = theme;
	
		        return theme;
		    }
	
		    kendo.dataviz.autoTheme = autoTheme;
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(917);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 917:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(918) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		    // Imports ================================================================
		    var kendo = window.kendo,
		        ui = kendo.dataviz.ui,
		        deepExtend = kendo.deepExtend;
	
		    // Constants ==============================================================
		    var BLACK = "#000",
		        SANS = "Arial,Helvetica,sans-serif",
		        SANS12 = "12px " + SANS,
		        WHITE = "#fff";
	
		    var chartBaseTheme = kendo.dataviz.chartBaseTheme({
		        gradients: true
		    });
	
		    var gaugeBaseTheme = {
		        scale: {
		            labels: {
		                font: SANS12
		            }
		        }
		    };
	
		    var diagramBaseTheme = {
		        shapeDefaults: {
		            hover: {
		                opacity: 0.2
		            },
		            stroke: {
		                width: 0
		            }
		        },
		        editable: {
		            resize: {
		                handles: {
		                    width: 7,
		                    height: 7
		                }
		            }
		        },
		        selectable: {
		            stroke: {
		                width: 1,
		                dashType: "dot"
		            }
		        },
		        connectionDefaults: {
		            stroke: {
		                width: 2
		            },
		            selection: {
		                handles: {
		                    width: 8,
		                    height: 8
		                }
		            },
		            editable: {
		                tools: ["edit", "delete"]
		            }
		        }
		    };
	
		    var themes = ui.themes,
		        registerTheme = ui.registerTheme = function(themeName, options) {
		            var result = {};
		            // Apply base theme
		            result.chart = deepExtend({}, chartBaseTheme, options.chart);
		            result.gauge = deepExtend({}, gaugeBaseTheme, options.gauge);
		            result.diagram = deepExtend({}, diagramBaseTheme, options.diagram);
		            result.treeMap = deepExtend({}, options.treeMap);
	
		            // Copy the line/area chart settings for their vertical counterparts
		            var defaults = result.chart.seriesDefaults;
		            defaults.verticalLine = deepExtend({}, defaults.line);
		            defaults.verticalArea = deepExtend({}, defaults.area);
		            defaults.rangeArea = deepExtend({}, defaults.area);
		            defaults.verticalRangeArea = deepExtend({}, defaults.rangeArea);
		            defaults.verticalBoxPlot = deepExtend({}, defaults.boxPlot);
		            defaults.polarArea = deepExtend({}, defaults.radarArea);
		            defaults.polarLine = deepExtend({}, defaults.radarLine);
	
		            themes[themeName] = result;
		        };
	
		    registerTheme("black", {
		        chart: {
		            title: {
		                color: WHITE
		            },
		            legend: {
		                labels: {
		                    color: WHITE
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#919191"
		                    },
		                    markers: {
		                        color: "#919191"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: WHITE
		                },
		                errorBars: {
		                    color: WHITE
		                },
		                notes: {
		                    icon: {
		                        background: "#3b3b3b",
		                        border: {
		                            color: "#8e8e8e"
		                        }
		                    },
		                    label: {
		                        color: WHITE
		                    },
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                },
		                pie: {
		                    overlay: {
		                        gradient: "sharpBevel"
		                    }
		                },
		                donut: {
		                    overlay: {
		                        gradient: "sharpGlass"
		                    }
		                },
		                line: {
		                    markers: {
		                        background: "#3d3d3d"
		                    }
		                },
		                scatter: {
		                    markers: {
		                        background: "#3d3d3d"
		                    }
		                },
		                scatterLine: {
		                    markers: {
		                        background: "#3d3d3d"
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                },
		                candlestick: {
		                    downColor: "#555",
		                    line: {
		                        color: WHITE
		                    },
		                    border: {
		                        _brightness: 1.5,
		                        opacity: 1
		                    },
		                    highlight: {
		                        border: {
		                            color: WHITE,
		                            opacity: 0.2
		                        }
		                    }
		                },
		                ohlc: {
		                    line: {
		                        color: WHITE
		                    }
		                }
		            },
		            chartArea: {
		                background: "#3d3d3d"
		            },
		            seriesColors: ["#0081da", "#3aafff", "#99c900", "#ffeb3d", "#b20753", "#ff4195"],
		            axisDefaults: {
		                line: {
		                    color: "#8e8e8e"
		                },
		                labels: {
		                    color: WHITE
		                },
		                majorGridLines: {
		                    color: "#545454"
		                },
		                minorGridLines: {
		                    color: "#454545"
		                },
		                title: {
		                    color: WHITE
		                },
		                crosshair: {
		                    color: "#8e8e8e"
		                },
		                notes: {
		                    icon: {
		                        background: "#3b3b3b",
		                        border: {
		                            color: "#8e8e8e"
		                        }
		                    },
		                    label: {
		                        color: WHITE
		                    },
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#0070e4"
		            },
		            scale: {
		                rangePlaceholderColor: "#1d1d1d",
		                labels: {
		                    color: WHITE
		                },
		                minorTicks: {
		                    color: WHITE
		                },
		                majorTicks: {
		                    color: WHITE
		                },
		                line: {
		                    color: WHITE
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#0066cc"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: WHITE
		                    },
		                    stroke: {
		                        color: "#384049"
		                    },
		                    hover: {
		                        fill: {
		                            color: "#3d3d3d"
		                        },
		                        stroke: {
		                            color: "#efefef"
		                        }
		                    }
		                },
		                content: {
		                    color: WHITE
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: "#3d3d3d"
		                        },
		                        stroke: {
		                            color: WHITE
		                        },
		                        hover: {
		                            fill: {
		                                color: WHITE
		                            },
		                            stroke: {
		                                color: WHITE
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: WHITE
		                        },
		                        fill: {
		                            color: WHITE
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: WHITE
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: WHITE
		                },
		                content: {
		                    color: WHITE
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: "#3d3d3d"
		                        },
		                        stroke: {
		                            color: "#efefef"
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#0081da", "#314b5c"],
		                ["#3aafff", "#3c5464"],
		                ["#99c900", "#4f5931"],
		                ["#ffeb3d", "#64603d"],
		                ["#b20753", "#543241"],
		                ["#ff4195", "#643e4f"]]
		        }
		    });
	
		    registerTheme("blueopal", {
		        chart: {
		            title: {
		                color: "#293135"
		            },
		            legend: {
		                labels: {
		                    color: "#293135"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#27A5BA"
		                    },
		                    markers: {
		                        color: "#27A5BA"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: BLACK,
		                    background: WHITE,
		                    opacity: 0.5
		                },
		                errorBars: {
		                    color: "#293135"
		                },
		                candlestick: {
		                    downColor: "#c4d0d5",
		                    line: {
		                        color: "#9aabb2"
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#9aabb2"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#9aabb2"
		                    }
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#9aabb2"
		                        }
		                    },
		                    label: {
		                        color: "#293135"
		                    },
		                    line: {
		                        color: "#9aabb2"
		                    }
		                }
		            },
		            seriesColors: ["#0069a5", "#0098ee", "#7bd2f6", "#ffb800", "#ff8517", "#e34a00"],
		            axisDefaults: {
		                line: {
		                    color: "#9aabb2"
		                },
		                labels: {
		                    color: "#293135"
		                },
		                majorGridLines: {
		                    color: "#c4d0d5"
		                },
		                minorGridLines: {
		                    color: "#edf1f2"
		                },
		                title: {
		                    color: "#293135"
		                },
		                crosshair: {
		                    color: "#9aabb2"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#9aabb2"
		                        }
		                    },
		                    label: {
		                        color: "#293135"
		                    },
		                    line: {
		                        color: "#9aabb2"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#005c83"
		            },
		            scale: {
		                rangePlaceholderColor: "#daecf4",
	
		                labels: {
		                    color: "#293135"
		                },
		                minorTicks: {
		                    color: "#293135"
		                },
		                majorTicks: {
		                    color: "#293135"
		                },
		                line: {
		                    color: "#293135"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#7ec6e3"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#003f59"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#003f59"
		                        }
		                    }
		                },
		                content: {
		                    color: "#293135"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#003f59"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#003f59"
		                            },
		                            stroke: {
		                                color: "#003f59"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#003f59"
		                        },
		                        fill: {
		                            color: "#003f59"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#003f59"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#003f59"
		                },
		                content: {
		                    color: "#293135"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: "#3d3d3d"
		                        },
		                        stroke: {
		                            color: "#efefef"
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#0069a5", "#bad7e7"],
		                ["#0098ee", "#b9e0f5"],
		                ["#7bd2f6", "#ceeaf6"],
		                ["#ffb800", "#e6e3c4"],
		                ["#ff8517", "#e4d8c8"],
		                ["#e34a00", "#ddccc2"]
		            ]
		        }
		    });
	
		    registerTheme("highcontrast", {
		        chart: {
		            title: {
		                color: "#ffffff"
		            },
		            legend: {
		                labels: {
		                    color: "#ffffff"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#66465B"
		                    },
		                    markers: {
		                        color: "#66465B"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#ffffff"
		                },
		                errorBars: {
		                    color: "#ffffff"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#ffffff"
		                        }
		                    },
		                    label: {
		                        color: "#ffffff"
		                    },
		                    line: {
		                        color: "#ffffff"
		                    }
		                },
		                pie: {
		                    overlay: {
		                        gradient: "sharpGlass"
		                    }
		                },
		                donut: {
		                    overlay: {
		                        gradient: "sharpGlass"
		                    }
		                },
		                line: {
		                    markers: {
		                        background: "#2c232b"
		                    }
		                },
		                scatter: {
		                    markers: {
		                        background: "#2c232b"
		                    }
		                },
		                scatterLine: {
		                    markers: {
		                        background: "#2c232b"
		                    }
		                },
		                area: {
		                    opacity: 0.5
		                },
		                waterfall: {
		                    line: {
		                        color: "#ffffff"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#ffffff"
		                    }
		                },
		                candlestick: {
		                    downColor: "#664e62",
		                    line: {
		                        color: "#ffffff"
		                    },
		                    border: {
		                        _brightness: 1.5,
		                        opacity: 1
		                    },
		                    highlight: {
		                        border: {
		                            color: "#ffffff",
		                            opacity: 1
		                        }
		                    }
		                },
		                ohlc: {
		                    line: {
		                        color: "#ffffff"
		                    }
		                }
		            },
		            chartArea: {
		                background: "#2c232b"
		            },
		            seriesColors: ["#a7008f", "#ffb800", "#3aafff", "#99c900", "#b20753", "#ff4195"],
		            axisDefaults: {
		                line: {
		                    color: "#ffffff"
		                },
		                labels: {
		                    color: "#ffffff"
		                },
		                majorGridLines: {
		                    color: "#664e62"
		                },
		                minorGridLines: {
		                    color: "#4f394b"
		                },
		                title: {
		                    color: "#ffffff"
		                },
		                crosshair: {
		                    color: "#ffffff"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#ffffff"
		                        }
		                    },
		                    label: {
		                        color: "#ffffff"
		                    },
		                    line: {
		                        color: "#ffffff"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#a7008f"
		            },
		            scale: {
		                rangePlaceholderColor: "#2c232b",
	
		                labels: {
		                    color: "#ffffff"
		                },
		                minorTicks: {
		                    color: "#2c232b"
		                },
		                majorTicks: {
		                    color: "#664e62"
		                },
		                line: {
		                    color: "#ffffff"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#a7018f"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: WHITE
		                    },
		                    stroke: {
		                        color: "#2c232b"
		                    },
		                    hover: {
		                        fill: {
		                            color: "#2c232b"
		                        },
		                        stroke: {
		                            color: WHITE
		                        }
		                    }
		                },
		                content: {
		                    color: WHITE
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: "#2c232b"
		                        },
		                        stroke: {
		                            color: WHITE
		                        },
		                        hover: {
		                            fill: {
		                                color: WHITE
		                            },
		                            stroke: {
		                                color: WHITE
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: WHITE
		                        },
		                        fill: {
		                            color: WHITE
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: WHITE
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: WHITE
		                },
		                content: {
		                    color: WHITE
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: "#2c232b"
		                        },
		                        stroke: {
		                            color: WHITE
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#a7008f", "#451c3f"],
		                ["#ffb800", "#564122"],
		                ["#3aafff", "#2f3f55"],
		                ["#99c900", "#424422"],
		                ["#b20753", "#471d33"],
		                ["#ff4195", "#562940"]
		            ]
		        }
		    });
	
		    registerTheme("default", {
		        chart: {
		            title: {
		                color: "#8e8e8e"
		            },
		            legend: {
		                labels: {
		                    color: "#232323"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#919191"
		                    },
		                    markers: {
		                        color: "#919191"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: BLACK,
		                    background: WHITE,
		                    opacity: 0.5
		                },
		                errorBars: {
		                    color: "#232323"
		                },
		                candlestick: {
		                    downColor: "#dedede",
		                    line: {
		                        color: "#8d8d8d"
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#8e8e8e"
		                        }
		                    },
		                    label: {
		                        color: "#232323"
		                    },
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                }
		            },
		            seriesColors: ["#ff6800", "#a0a700", "#ff8d00", "#678900", "#ffb53c", "#396000"],
		            axisDefaults: {
		                line: {
		                    color: "#8e8e8e"
		                },
		                labels: {
		                    color: "#232323"
		                },
		                minorGridLines: {
		                    color: "#f0f0f0"
		                },
		                majorGridLines: {
		                    color: "#dfdfdf"
		                },
		                title: {
		                    color: "#232323"
		                },
		                crosshair: {
		                    color: "#8e8e8e"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#8e8e8e"
		                        }
		                    },
		                    label: {
		                        color: "#232323"
		                    },
		                    line: {
		                        color: "#8e8e8e"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#ea7001"
		            },
		            scale: {
		                rangePlaceholderColor: "#dedede",
	
		                labels: {
		                    color: "#2e2e2e"
		                },
		                minorTicks: {
		                    color: "#2e2e2e"
		                },
		                majorTicks: {
		                    color: "#2e2e2e"
		                },
		                line: {
		                    color: "#2e2e2e"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#e15613"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#282828"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#282828"
		                        }
		                    }
		                },
		                content: {
		                    color: "#2e2e2e"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#282828"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#282828"
		                            },
		                            stroke: {
		                                color: "#282828"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#282828"
		                        },
		                        fill: {
		                            color: "#282828"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#a7018f"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#282828"
		                },
		                content: {
		                    color: "#2e2e2e"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#282828"
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#ff6800", "#edcfba"],
		                ["#a0a700", "#dadcba"],
		                ["#ff8d00", "#edd7ba"],
		                ["#678900", "#cfd6ba"],
		                ["#ffb53c", "#eddfc6"],
		                ["#396000", "#c6ceba"]
		            ]
		        }
		    });
	
		    registerTheme("silver", {
		        chart: {
		            title: {
		                color: "#4e5968"
		            },
		            legend: {
		                labels: {
		                    color: "#4e5968"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#B1BCC8"
		                    },
		                    markers: {
		                        color: "#B1BCC8"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#293135",
		                    background: "#eaeaec",
		                    opacity: 0.5
		                },
		                errorBars: {
		                    color: "#4e5968"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#4e5968"
		                        }
		                    },
		                    label: {
		                        color: "#4e5968"
		                    },
		                    line: {
		                        color: "#4e5968"
		                    }
		                },
		                line: {
		                    markers: {
		                        background: "#eaeaec"
		                    }
		                },
		                scatter: {
		                    markers: {
		                        background: "#eaeaec"
		                    }
		                },
		                scatterLine: {
		                    markers: {
		                        background: "#eaeaec"
		                    }
		                },
		                pie: {
		                    connectors: {
		                        color: "#A6B1C0"
		                    }
		                },
		                donut: {
		                    connectors: {
		                        color: "#A6B1C0"
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#a6b1c0"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#a6b1c0"
		                    }
		                },
		                candlestick: {
		                    downColor: "#a6afbe"
		                }
		            },
		            chartArea: {
		                background: "#eaeaec"
		            },
		            seriesColors: ["#007bc3", "#76b800", "#ffae00", "#ef4c00", "#a419b7", "#430B62"],
		            axisDefaults: {
		                line: {
		                    color: "#a6b1c0"
		                },
		                labels: {
		                    color: "#4e5968"
		                },
		                majorGridLines: {
		                    color: "#dcdcdf"
		                },
		                minorGridLines: {
		                    color: "#eeeeef"
		                },
		                title: {
		                    color: "#4e5968"
		                },
		                crosshair: {
		                    color: "#a6b1c0"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#4e5968"
		                        }
		                    },
		                    label: {
		                        color: "#4e5968"
		                    },
		                    line: {
		                        color: "#4e5968"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#0879c0"
		            },
		            scale: {
		                rangePlaceholderColor: "#f3f3f4",
	
		                labels: {
		                    color: "#515967"
		                },
		                minorTicks: {
		                    color: "#515967"
		                },
		                majorTicks: {
		                    color: "#515967"
		                },
		                line: {
		                    color: "#515967"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#1c82c2"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#515967"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#282828"
		                        }
		                    }
		                },
		                content: {
		                    color: "#515967"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#515967"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#515967"
		                            },
		                            stroke: {
		                                color: "#515967"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#515967"
		                        },
		                        fill: {
		                            color: "#515967"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#515967"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#515967"
		                },
		                content: {
		                    color: "#515967"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#515967"
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#007bc3", "#c2dbea"],
		                ["#76b800", "#dae7c3"],
		                ["#ffae00", "#f5e5c3"],
		                ["#ef4c00", "#f2d2c3"],
		                ["#a419b7", "#e3c7e8"],
		                ["#430b62", "#d0c5d7"]
		            ]
		        }
		    });
	
		    registerTheme("metro", {
		        chart: {
		            title: {
		                color: "#777777"
		            },
		            legend: {
		                labels: {
		                    color: "#777777"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#CBCBCB"
		                    },
		                    markers: {
		                        color: "#CBCBCB"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: BLACK
		                },
		                errorBars: {
		                    color: "#777777"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#777777"
		                        }
		                    },
		                    label: {
		                        color: "#777777"
		                    },
		                    line: {
		                        color: "#777777"
		                    }
		                },
		                candlestick: {
		                    downColor: "#c7c7c7",
		                    line: {
		                        color: "#787878"
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#c7c7c7"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#c7c7c7"
		                    }
		                },
		                overlay: {
		                    gradient: "none"
		                },
		                border: {
		                    _brightness: 1
		                }
		            },
		            seriesColors: ["#8ebc00", "#309b46", "#25a0da", "#ff6900", "#e61e26", "#d8e404", "#16aba9", "#7e51a1", "#313131", "#ed1691"],
		            axisDefaults: {
		                line: {
		                    color: "#c7c7c7"
		                },
		                labels: {
		                    color: "#777777"
		                },
		                minorGridLines: {
		                    color: "#c7c7c7"
		                },
		                majorGridLines: {
		                    color: "#c7c7c7"
		                },
		                title: {
		                    color: "#777777"
		                },
		                crosshair: {
		                    color: "#c7c7c7"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#777777"
		                        }
		                    },
		                    label: {
		                        color: "#777777"
		                    },
		                    line: {
		                        color: "#777777"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#8ebc00"
		            },
		            scale: {
		                rangePlaceholderColor: "#e6e6e6",
	
		                labels: {
		                    color: "#777"
		                },
		                minorTicks: {
		                    color: "#777"
		                },
		                majorTicks: {
		                    color: "#777"
		                },
		                line: {
		                    color: "#777"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#8ebc00"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: BLACK
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: BLACK
		                        }
		                    }
		                },
		                content: {
		                    color: "#777"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#787878"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#787878"
		                            },
		                            stroke: {
		                                color: "#787878"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#787878"
		                        },
		                        fill: {
		                            color: "#787878"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#515967"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#787878"
		                },
		                content: {
		                    color: "#777"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#787878"
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#8ebc00", "#e8f2cc"],
		                ["#309b46", "#d6ebda"],
		                ["#25a0da", "#d3ecf8"],
		                ["#ff6900", "#ffe1cc"],
		                ["#e61e26", "#fad2d4"],
		                ["#d8e404", "#f7facd"],
		                ["#16aba9", "#d0eeee"],
		                ["#7e51a1", "#e5dcec"],
		                ["#313131", "#d6d6d6"],
		                ["#ed1691", "#fbd0e9"]
		            ]
		        }
		    });
	
		    registerTheme("metroblack", {
		        chart: {
		            title: {
		                color: "#ffffff"
		            },
		            legend: {
		                labels: {
		                    color: "#ffffff"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#797979"
		                    },
		                    markers: {
		                        color: "#797979"
		                    }
		                }
		            },
		            seriesDefaults: {
		                border: {
		                    _brightness: 1
		                },
		                labels: {
		                    color: "#ffffff"
		                },
		                errorBars: {
		                    color: "#ffffff"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#cecece"
		                        }
		                    },
		                    label: {
		                        color: "#ffffff"
		                    },
		                    line: {
		                        color: "#cecece"
		                    }
		                },
		                line: {
		                    markers: {
		                        background: "#0e0e0e"
		                    }
		                },
		                bubble: {
		                    opacity: 0.6
		                },
		                scatter: {
		                    markers: {
		                        background: "#0e0e0e"
		                    }
		                },
		                scatterLine: {
		                    markers: {
		                        background: "#0e0e0e"
		                    }
		                },
		                candlestick: {
		                    downColor: "#828282",
		                    line: {
		                        color: "#ffffff"
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#cecece"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#cecece"
		                    }
		                },
		                overlay: {
		                    gradient: "none"
		                }
		            },
		            chartArea: {
		                background: "#0e0e0e"
		            },
		            seriesColors: ["#00aba9", "#309b46", "#8ebc00", "#ff6900", "#e61e26", "#d8e404", "#25a0da", "#7e51a1", "#313131", "#ed1691"],
		            axisDefaults: {
		                line: {
		                    color: "#cecece"
		                },
		                labels: {
		                    color: "#ffffff"
		                },
		                minorGridLines: {
		                    color: "#2d2d2d"
		                },
		                majorGridLines: {
		                    color: "#333333"
		                },
		                title: {
		                    color: "#ffffff"
		                },
		                crosshair: {
		                    color: "#cecece"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#cecece"
		                        }
		                    },
		                    label: {
		                        color: "#ffffff"
		                    },
		                    line: {
		                        color: "#cecece"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#00aba9"
		            },
		            scale: {
		                rangePlaceholderColor: "#2d2d2d",
	
		                labels: {
		                    color: "#ffffff"
		                },
		                minorTicks: {
		                    color: "#333333"
		                },
		                majorTicks: {
		                    color: "#cecece"
		                },
		                line: {
		                    color: "#cecece"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#00aba9"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: WHITE
		                    },
		                    stroke: {
		                        color: "#0e0e0e"
		                    },
		                    hover: {
		                        fill: {
		                            color: "#0e0e0e"
		                        },
		                        stroke: {
		                            color: WHITE
		                        }
		                    }
		                },
		                content: {
		                    color: WHITE
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: "#0e0e0e"
		                        },
		                        stroke: {
		                            color: "#787878"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#787878"
		                            },
		                            stroke: {
		                                color: "#787878"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: WHITE
		                        },
		                        fill: {
		                            color: WHITE
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#787878"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: WHITE
		                },
		                content: {
		                    color: WHITE
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: "#0e0e0e"
		                        },
		                        stroke: {
		                            color: WHITE
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#00aba9", "#0b2d2d"],
		                ["#309b46", "#152a19"],
		                ["#8ebc00", "#28310b"],
		                ["#ff6900", "#3e200b"],
		                ["#e61e26", "#391113"],
		                ["#d8e404", "#36390c"],
		                ["#25a0da", "#132b37"],
		                ["#7e51a1", "#241b2b"],
		                ["#313131", "#151515"],
		                ["#ed1691", "#3b1028"]
		            ]
		        }
		    });
	
		    registerTheme("moonlight", {
		        chart: {
		            title: {
		                color: "#ffffff"
		            },
		            legend: {
		                labels: {
		                    color: "#ffffff"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#A1A7AB"
		                    },
		                    markers: {
		                        color: "#A1A7AB"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#ffffff"
		                },
		                errorBars: {
		                    color: "#ffffff"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#8c909e"
		                        }
		                    },
		                    label: {
		                        color: "#ffffff"
		                    },
		                    line: {
		                        color: "#8c909e"
		                    }
		                },
		                pie: {
		                    overlay: {
		                        gradient: "sharpBevel"
		                    }
		                },
		                donut: {
		                    overlay: {
		                        gradient: "sharpGlass"
		                    }
		                },
		                line: {
		                    markers: {
		                        background: "#212a33"
		                    }
		                },
		                bubble: {
		                    opacity: 0.6
		                },
		                scatter: {
		                    markers: {
		                        background: "#212a33"
		                    }
		                },
		                scatterLine: {
		                    markers: {
		                        background: "#212a33"
		                    }
		                },
		                area: {
		                    opacity: 0.3
		                },
		                candlestick: {
		                    downColor: "#757d87",
		                    line: {
		                        color: "#ea9d06"
		                    },
		                    border: {
		                        _brightness: 1.5,
		                        opacity: 1
		                    },
		                    highlight: {
		                        border: {
		                            color: WHITE,
		                            opacity: 0.2
		                        }
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#8c909e"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#8c909e"
		                    }
		                },
		                ohlc: {
		                    line: {
		                        color: "#ea9d06"
		                    }
		                }
		            },
		            chartArea: {
		                background: "#212a33"
		            },
		            seriesColors: ["#ffca08", "#ff710f", "#ed2e24", "#ff9f03", "#e13c02", "#a00201"],
		            axisDefaults: {
		                line: {
		                    color: "#8c909e"
		                },
		                minorTicks: {
		                    color: "#8c909e"
		                },
		                majorTicks: {
		                    color: "#8c909e"
		                },
		                labels: {
		                    color: "#ffffff"
		                },
		                majorGridLines: {
		                    color: "#3e424d"
		                },
		                minorGridLines: {
		                    color: "#2f3640"
		                },
		                title: {
		                    color: "#ffffff"
		                },
		                crosshair: {
		                    color: "#8c909e"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#8c909e"
		                        }
		                    },
		                    label: {
		                        color: "#ffffff"
		                    },
		                    line: {
		                        color: "#8c909e"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#f4af03"
		            },
		            scale: {
		                rangePlaceholderColor: "#2f3640",
	
		                labels: {
		                    color: WHITE
		                },
		                minorTicks: {
		                    color: "#8c909e"
		                },
		                majorTicks: {
		                    color: "#8c909e"
		                },
		                line: {
		                    color: "#8c909e"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#f3ae03"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: WHITE
		                    },
		                    stroke: {
		                        color: "#414550"
		                    },
		                    hover: {
		                        fill: {
		                            color: "#414550"
		                        },
		                        stroke: {
		                            color: WHITE
		                        }
		                    }
		                },
		                content: {
		                    color: WHITE
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: "#414550"
		                        },
		                        stroke: {
		                            color: WHITE
		                        },
		                        hover: {
		                            fill: {
		                                color: WHITE
		                            },
		                            stroke: {
		                                color: WHITE
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: WHITE
		                        },
		                        fill: {
		                            color: WHITE
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: WHITE
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: WHITE
		                },
		                content: {
		                    color: WHITE
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: "#414550"
		                        },
		                        stroke: {
		                            color: WHITE
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#ffca08", "#4e4b2b"],
		                ["#ff710f", "#4e392d"],
		                ["#ed2e24", "#4b2c31"],
		                ["#ff9f03", "#4e422a"],
		                ["#e13c02", "#482e2a"],
		                ["#a00201", "#3b232a"]
		            ]
		        }
		    });
	
		    registerTheme("uniform", {
		        chart: {
		            title: {
		                color: "#686868"
		            },
		            legend: {
		                labels: {
		                    color: "#686868"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#B6B6B6"
		                    },
		                    markers: {
		                        color: "#B6B6B6"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#686868"
		                },
		                errorBars: {
		                    color: "#686868"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#9e9e9e"
		                        }
		                    },
		                    label: {
		                        color: "#686868"
		                    },
		                    line: {
		                        color: "#9e9e9e"
		                    }
		                },
		                pie: {
		                    overlay: {
		                        gradient: "sharpBevel"
		                    }
		                },
		                donut: {
		                    overlay: {
		                        gradient: "sharpGlass"
		                    }
		                },
		                line: {
		                    markers: {
		                        background: "#ffffff"
		                    }
		                },
		                bubble: {
		                    opacity: 0.6
		                },
		                scatter: {
		                    markers: {
		                        background: "#ffffff"
		                    }
		                },
		                scatterLine: {
		                    markers: {
		                        background: "#ffffff"
		                    }
		                },
		                area: {
		                    opacity: 0.3
		                },
		                candlestick: {
		                    downColor: "#cccccc",
		                    line: {
		                        color: "#cccccc"
		                    },
		                    border: {
		                        _brightness: 1.5,
		                        opacity: 1
		                    },
		                    highlight: {
		                        border: {
		                            color: "#cccccc",
		                            opacity: 0.2
		                        }
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#9e9e9e"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#9e9e9e"
		                    }
		                },
		                ohlc: {
		                    line: {
		                        color: "#cccccc"
		                    }
		                }
		            },
		            chartArea: {
		                background: "#ffffff"
		            },
		            seriesColors: ["#527aa3", "#6f91b3", "#8ca7c2", "#a8bdd1", "#c5d3e0", "#e2e9f0"],
		            axisDefaults: {
		                line: {
		                    color: "#9e9e9e"
		                },
		                minorTicks: {
		                    color: "#aaaaaa"
		                },
		                majorTicks: {
		                    color: "#888888"
		                },
		                labels: {
		                    color: "#686868"
		                },
		                majorGridLines: {
		                    color: "#dadada"
		                },
		                minorGridLines: {
		                    color: "#e7e7e7"
		                },
		                title: {
		                    color: "#686868"
		                },
		                crosshair: {
		                    color: "#9e9e9e"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#9e9e9e"
		                        }
		                    },
		                    label: {
		                        color: "#686868"
		                    },
		                    line: {
		                        color: "#9e9e9e"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#527aa3"
		            },
		            scale: {
		                rangePlaceholderColor: "#e7e7e7",
	
		                labels: {
		                    color: "#686868"
		                },
		                minorTicks: {
		                    color: "#aaaaaa"
		                },
		                majorTicks: {
		                    color: "#888888"
		                },
		                line: {
		                    color: "#9e9e9e"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#d1d1d1"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#686868"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#686868"
		                        }
		                    }
		                },
		                content: {
		                    color: "#686868"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#686868"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#686868"
		                            },
		                            stroke: {
		                                color: "#686868"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#686868"
		                        },
		                        fill: {
		                            color: "#686868"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#686868"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#686868"
		                },
		                content: {
		                    color: "#686868"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#686868"
		                        }
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#527aa3", "#d0d8e1"],
		                ["#6f91b3", "#d6dde4"],
		                ["#8ca7c2", "#dce1e7"],
		                ["#a8bdd1", "#e2e6ea"],
		                ["#c5d3e0", "#e7eaed"],
		                ["#e2e9f0", "#edeff0"]
		            ]
		        }
		    });
	
		    registerTheme("bootstrap", {
		        chart: {
		            title: {
		                color: "#333333"
		            },
		            legend: {
		                labels: {
		                    color: "#333333"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#999999"
		                    },
		                    markers: {
		                        color: "#9A9A9A"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#333333"
		                },
		                overlay: {
		                    gradient: "none"
		                },
		                errorBars: {
		                    color: "#343434"
		                },
		                notes: {
		                    icon: {
		                        background: "#000000",
		                        border: {
		                            color: "#000000"
		                        }
		                    },
		                    label: {
		                        color: "#333333"
		                    },
		                    line: {
		                        color: "#000000"
		                    }
		                },
		                pie: {
		                    overlay: {
		                        gradient: "none"
		                    }
		                },
		                donut: {
		                    overlay: {
		                        gradient: "none"
		                    }
		                },
		                line: {
		                    markers: {
		                        background: "#ffffff"
		                    }
		                },
		                bubble: {
		                    opacity: 0.6
		                },
		                scatter: {
		                    markers: {
		                        background: "#ffffff"
		                    }
		                },
		                scatterLine: {
		                    markers: {
		                        background: "#ffffff"
		                    }
		                },
		                area: {
		                    opacity: 0.8
		                },
		                candlestick: {
		                    downColor: "#d0d0d0",
		                    line: {
		                        color: "#333333"
		                    },
		                    border: {
		                        _brightness: 1.5,
		                        opacity: 1
		                    },
		                    highlight: {
		                        border: {
		                            color: "#b8b8b8",
		                            opacity: 0.2
		                        }
		                    }
		                },
		                waterfall: {
		                    line: {
		                        color: "#cccccc"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#cccccc"
		                    }
		                },
		                ohlc: {
		                    line: {
		                        color: "#333333"
		                    }
		                }
		            },
		            chartArea: {
		                background: "#ffffff"
		            },
		            seriesColors: ["#428bca", "#5bc0de", "#5cb85c", "#f2b661", "#e67d4a", "#da3b36"],
		            axisDefaults: {
		                line: {
		                    color: "#cccccc"
		                },
		                minorTicks: {
		                    color: "#ebebeb"
		                },
		                majorTicks: {
		                    color: "#cccccc"
		                },
		                labels: {
		                    color: "#333333"
		                },
		                majorGridLines: {
		                    color: "#cccccc"
		                },
		                minorGridLines: {
		                    color: "#ebebeb"
		                },
		                title: {
		                    color: "#333333"
		                },
		                crosshair: {
		                    color: "#000000"
		                },
		                notes: {
		                    icon: {
		                        background: "#000000",
		                        border: {
		                            color: "#000000"
		                        }
		                    },
		                    label: {
		                        color: "#ffffff"
		                    },
		                    line: {
		                        color: "#000000"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#428bca"
		            },
		            scale: {
		                rangePlaceholderColor: "#cccccc",
		                labels: {
		                    color: "#333333"
		                },
		                minorTicks: {
		                    color: "#ebebeb"
		                },
		                majorTicks: {
		                    color: "#cccccc"
		                },
		                line: {
		                    color: "#cccccc"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#428bca"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#333333"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#333333"
		                        }
		                    }
		                },
		                content: {
		                    color: "#333333"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#333333"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#333333"
		                            },
		                            stroke: {
		                                color: "#333333"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#333333"
		                        },
		                        fill: {
		                            color: "#333333"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#333333"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#c4c4c4"
		                },
		                content: {
		                    color: "#333333"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#333333"
		                        }
		                    },
		                    stroke: {
		                        color: "#333333"
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#428bca", "#d1e0ec"],
		                ["#5bc0de", "#d6eaf0"],
		                ["#5cb85c", "#d6e9d6"],
		                ["#5cb85c", "#f4e8d7"],
		                ["#e67d4a", "#f2ddd3"],
		                ["#da3b36", "#f0d0cf"]
		            ]
		        }
		    });
	
		    registerTheme("flat", {
		            chart: {
		            title: {
		                color: "#4c5356"
		            },
		            legend: {
		                labels: {
		                    color: "#4c5356"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#CBCBCB"
		                    },
		                    markers: {
		                        color: "#CBCBCB"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#4c5356"
		                },
		                errorBars: {
		                    color: "#4c5356"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#cdcdcd"
		                        }
		                    },
		                    label: {
		                        color: "#4c5356"
		                    },
		                    line: {
		                        color: "#cdcdcd"
		                    }
		                },
		                candlestick: {
		                    downColor: "#c7c7c7",
		                    line: {
		                        color: "#787878"
		                    }
		                },
		                area: {
		                    opacity: 0.9
		                },
		                waterfall: {
		                    line: {
		                        color: "#cdcdcd"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#cdcdcd"
		                    }
		                },
		                overlay: {
		                    gradient: "none"
		                },
		                border: {
		                    _brightness: 1
		                }
		            },
		            seriesColors: ["#10c4b2", "#ff7663", "#ffb74f", "#a2df53", "#1c9ec4", "#ff63a5", "#1cc47b"],
		            axisDefaults: {
		                line: {
		                    color: "#cdcdcd"
		                },
		                labels: {
		                    color: "#4c5356"
		                },
		                minorGridLines: {
		                    color: "#cdcdcd"
		                },
		                majorGridLines: {
		                    color: "#cdcdcd"
		                },
		                title: {
		                    color: "#4c5356"
		                },
		                crosshair: {
		                    color: "#cdcdcd"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#cdcdcd"
		                        }
		                    },
		                    label: {
		                        color: "#4c5356"
		                    },
		                    line: {
		                        color: "#cdcdcd"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#10c4b2"
		            },
		            scale: {
		                rangePlaceholderColor: "#cdcdcd",
	
		                labels: {
		                    color: "#4c5356"
		                },
		                minorTicks: {
		                    color: "#4c5356"
		                },
		                majorTicks: {
		                    color: "#4c5356"
		                },
		                line: {
		                    color: "#4c5356"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#10c4b2"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#363940"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#363940"
		                        }
		                    }
		                },
		                content: {
		                    color: "#4c5356"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#363940"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#363940"
		                            },
		                            stroke: {
		                                color: "#363940"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#363940"
		                        },
		                        fill: {
		                            color: "#363940"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#363940"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#cdcdcd"
		                },
		                content: {
		                    color: "#4c5356"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#363940"
		                        }
		                    },
		                    stroke: {
		                        color: "#363940"
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#10c4b2", "#cff3f0"],
		                ["#ff7663", "#ffe4e0"],
		                ["#ffb74f", "#fff1dc"],
		                ["#a2df53", "#ecf9dd"],
		                ["#1c9ec4", "#d2ecf3"],
		                ["#ff63a5", "#ffe0ed"],
		                ["#1cc47b", "#d2f3e5"]
		            ]
		        }
		    });
	
	
		     registerTheme("material", {
		       chart: {
		            title: {
		                color: "#444444"
		            },
		            legend: {
		                labels: {
		                    color: "#444444"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#CBCBCB"
		                    },
		                    markers: {
		                        color: "#CBCBCB"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#444444"
		                },
		                errorBars: {
		                    color: "#444444"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#e5e5e5"
		                        }
		                    },
		                    label: {
		                        color: "#444444"
		                    },
		                    line: {
		                        color: "#e5e5e5"
		                    }
		                },
		                candlestick: {
		                    downColor: "#c7c7c7",
		                    line: {
		                        color: "#787878"
		                    }
		                },
		                area: {
		                    opacity: 0.9
		                },
		                waterfall: {
		                    line: {
		                        color: "#e5e5e5"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#e5e5e5"
		                    }
		                },
		                overlay: {
		                    gradient: "none"
		                },
		                border: {
		                    _brightness: 1
		                }
		            },
		            seriesColors: ["#3f51b5", "#03a9f4", "#4caf50", "#f9ce1d", "#ff9800", "#ff5722"],
		            axisDefaults: {
		                line: {
		                    color: "#e5e5e5"
		                },
		                labels: {
		                    color: "#444444"
		                },
		                minorGridLines: {
		                    color: "#e5e5e5"
		                },
		                majorGridLines: {
		                    color: "#e5e5e5"
		                },
		                title: {
		                    color: "#444444"
		                },
		                crosshair: {
		                    color: "#7f7f7f"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#e5e5e5"
		                        }
		                    },
		                    label: {
		                        color: "#444444"
		                    },
		                    line: {
		                        color: "#e5e5e5"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#3f51b5"
		            },
		            scale: {
		                rangePlaceholderColor: "#e5e5e5",
	
		                labels: {
		                    color: "#444444"
		                },
		                minorTicks: {
		                    color: "#444444"
		                },
		                majorTicks: {
		                    color: "#444444"
		                },
		                line: {
		                    color: "#444444"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#3f51b5"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#7f7f7f"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#7f7f7f"
		                        }
		                    }
		                },
		                content: {
		                    color: "#444444"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#444444"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#444444"
		                            },
		                            stroke: {
		                                color: "#444444"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#444444"
		                        },
		                        fill: {
		                            color: "#444444"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#444444"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#7f7f7f"
		                },
		                content: {
		                    color: "#444444"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#444444"
		                        }
		                    },
		                    stroke: {
		                        color: "#444444"
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#3f51b5", "#cff3f0"],
		                ["#03a9f4", "#e5f6fe"],
		                ["#4caf50", "#edf7ed"],
		                ["#f9ce1d", "#fefae8"],
		                ["#ff9800", "#fff4e5"],
		                ["#ff5722", "#ffeee8"]
		            ]
		        }
		    });
	
		    registerTheme("materialblack", {
		       chart: {
		            title: {
		                color: "#fff"
		            },
		            legend: {
		                labels: {
		                    color: "#fff"
		                },
		                inactiveItems: {
		                    labels: {
		                        color: "#CBCBCB"
		                    },
		                    markers: {
		                        color: "#CBCBCB"
		                    }
		                }
		            },
		            seriesDefaults: {
		                labels: {
		                    color: "#fff"
		                },
		                errorBars: {
		                    color: "#fff"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#e5e5e5"
		                        }
		                    },
		                    label: {
		                        color: "#fff"
		                    },
		                    line: {
		                        color: "#e5e5e5"
		                    }
		                },
		                candlestick: {
		                    downColor: "#c7c7c7",
		                    line: {
		                        color: "#787878"
		                    }
		                },
		                area: {
		                    opacity: 0.9
		                },
		                waterfall: {
		                    line: {
		                        color: "#4d4d4d"
		                    }
		                },
		                horizontalWaterfall: {
		                    line: {
		                        color: "#4d4d4d"
		                    }
		                },
		                overlay: {
		                    gradient: "none"
		                },
		                border: {
		                    _brightness: 1
		                }
		            },
		            chartArea: {
		                background: "#1c1c1c"
		            },
		            seriesColors: ["#3f51b5", "#03a9f4", "#4caf50", "#f9ce1d", "#ff9800", "#ff5722"],
		            axisDefaults: {
		                line: {
		                    color: "#4d4d4d"
		                },
		                labels: {
		                    color: "#fff"
		                },
		                minorGridLines: {
		                    color: "#4d4d4d"
		                },
		                majorGridLines: {
		                    color: "#4d4d4d"
		                },
		                title: {
		                    color: "#fff"
		                },
		                crosshair: {
		                    color: "#7f7f7f"
		                },
		                notes: {
		                    icon: {
		                        background: "transparent",
		                        border: {
		                            color: "#4d4d4d"
		                        }
		                    },
		                    label: {
		                        color: "#fff"
		                    },
		                    line: {
		                        color: "#4d4d4d"
		                    }
		                }
		            }
		        },
		        gauge: {
		            pointer: {
		                color: "#3f51b5"
		            },
		            scale: {
		                rangePlaceholderColor: "#4d4d4d",
	
		                labels: {
		                    color: "#fff"
		                },
		                minorTicks: {
		                    color: "#fff"
		                },
		                majorTicks: {
		                    color: "#fff"
		                },
		                line: {
		                    color: "#fff"
		                }
		            }
		        },
		        diagram: {
		            shapeDefaults: {
		                fill: {
		                    color: "#3f51b5"
		                },
		                connectorDefaults: {
		                    fill: {
		                        color: "#7f7f7f"
		                    },
		                    stroke: {
		                        color: WHITE
		                    },
		                    hover: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#7f7f7f"
		                        }
		                    }
		                },
		                content: {
		                    color: "#fff"
		                }
		            },
		            editable: {
		                resize: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#fff"
		                        },
		                        hover: {
		                            fill: {
		                                color: "#fff"
		                            },
		                            stroke: {
		                                color: "#fff"
		                            }
		                        }
		                    }
		                },
		                rotate: {
		                    thumb: {
		                        stroke: {
		                            color: "#fff"
		                        },
		                        fill: {
		                            color: "#fff"
		                        }
		                    }
		                }
		            },
		            selectable: {
		                stroke: {
		                    color: "#fff"
		                }
		            },
		            connectionDefaults: {
		                stroke: {
		                    color: "#7f7f7f"
		                },
		                content: {
		                    color: "#fff"
		                },
		                selection: {
		                    handles: {
		                        fill: {
		                            color: WHITE
		                        },
		                        stroke: {
		                            color: "#fff"
		                        }
		                    },
		                    stroke: {
		                        color: "#fff"
		                    }
		                }
		            }
		        },
		        treeMap: {
		            colors: [
		                ["#3f51b5", "#cff3f0"],
		                ["#03a9f4", "#e5f6fe"],
		                ["#4caf50", "#edf7ed"],
		                ["#f9ce1d", "#fefae8"],
		                ["#ff9800", "#fff4e5"],
		                ["#ff5722", "#ffeee8"]
		            ]
		        }
		    });
	
		    (function () {
		        var TEXT = "#333333";
		        var INACTIVE = "#7f7f7f";
		        var INACTIVE_SHAPE = "#bdbdbd";
		        var AXIS = "#c8c8c8";
		        var AXIS_MINOR = "#dddddd";
		        var SERIES = ["#008fd3", "#99d101", "#f39b02", "#f05662", "#c03c53", "#acacac"];
		        var SERIES_LIGHT = ["#cbe8f5", "#eaf5cb", "#fceacc", "#fbdcdf", "#f2d7dc", "#eeeeee"];
		        var PRIMARY = SERIES[0];
		        var DIAGRAM_HOVER = WHITE;
	
		        function noteStyle() {
		            return {
		                icon: {
		                    background: "#007cc0",
		                    border: {
		                        color: "#007cc0"
		                    }
		                },
		                label: {
		                    color: "#ffffff"
		                },
		                line: {
		                    color: AXIS
		                }
		            };
		        }
	
		        registerTheme("fiori", {
		            chart: {
		                title: {
		                    color: TEXT
		                },
		                legend: {
		                    labels: {
		                        color: TEXT
		                    },
		                    inactiveItems: {
		                        labels: {
		                            color: INACTIVE
		                        },
		                        markers: {
		                            color: INACTIVE
		                        }
		                    }
		                },
		                seriesDefaults: {
		                    labels: {
		                        color: TEXT
		                    },
		                    errorBars: {
		                        color: TEXT
		                    },
		                    notes: noteStyle(),
		                    candlestick: {
		                        downColor: AXIS,
		                        line: {
		                            color: INACTIVE_SHAPE
		                        }
		                    },
		                    area: {
		                        opacity: 0.8
		                    },
		                    waterfall: {
		                        line: {
		                            color: AXIS
		                        }
		                    },
		                    horizontalWaterfall: {
		                        line: {
		                            color: AXIS
		                        }
		                    },
		                    overlay: {
		                        gradient: "none"
		                    },
		                    border: {
		                        _brightness: 1
		                    }
		                },
		                seriesColors: SERIES,
		                axisDefaults: {
		                    line: {
		                        color: AXIS
		                    },
		                    labels: {
		                        color: TEXT
		                    },
		                    minorGridLines: {
		                        color: AXIS_MINOR
		                    },
		                    majorGridLines: {
		                        color: AXIS
		                    },
		                    title: {
		                        color: TEXT
		                    },
		                    crosshair: {
		                        color: INACTIVE
		                    },
		                    notes: noteStyle()
		                }
		            },
		            gauge: {
		                pointer: {
		                    color: PRIMARY
		                },
		                scale: {
		                    rangePlaceholderColor: AXIS,
		                    labels: {
		                        color: TEXT
		                    },
		                    minorTicks: {
		                        color: TEXT
		                    },
		                    majorTicks: {
		                        color: TEXT
		                    },
		                    line: {
		                        color: TEXT
		                    }
		                }
		            },
		            diagram: {
		                shapeDefaults: {
		                    fill: {
		                        color: PRIMARY
		                    },
		                    connectorDefaults: {
		                        fill: {
		                            color: TEXT
		                        },
		                        stroke: {
		                            color: DIAGRAM_HOVER
		                        },
		                        hover: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: TEXT
		                            }
		                        }
		                    },
		                    content: {
		                        color: TEXT
		                    }
		                },
		                editable: {
		                    resize: {
		                        handles: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            },
		                            hover: {
		                                fill: {
		                                    color: INACTIVE_SHAPE
		                                },
		                                stroke: {
		                                    color: INACTIVE_SHAPE
		                                }
		                            }
		                        }
		                    },
		                    rotate: {
		                        thumb: {
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            },
		                            fill: {
		                                color: INACTIVE_SHAPE
		                            }
		                        }
		                    }
		                },
		                selectable: {
		                    stroke: {
		                        color: INACTIVE_SHAPE
		                    }
		                },
		                connectionDefaults: {
		                    stroke: {
		                        color: INACTIVE_SHAPE
		                    },
		                    content: {
		                        color: INACTIVE_SHAPE
		                    },
		                    selection: {
		                        handles: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            }
		                        },
		                        stroke: {
		                            color: INACTIVE_SHAPE
		                        }
		                    }
		                }
		            },
		            treeMap: {
		                colors: fuse(SERIES, SERIES_LIGHT)
		            }
		        });
		    })();
	
		    (function() {
		        var TEXT            = "#4e4e4e";
		        var INACTIVE        = "#7f7f7f";
		        var INACTIVE_SHAPE  = "#bdbdbd";
		        var AXIS            = "#c8c8c8";
		        var AXIS_MINOR      = "#e5e5e5";
		        var SERIES          = ["#0072c6", "#5db2ff", "#008a17", "#82ba00", "#ff8f32", "#ac193d"];
		        var SERIES_LIGHT    = ["#cbe2f3", "#deeffe", "#cbe7d0", "#e5f0cb", "#fee8d5", "#eed0d7"];
		        var PRIMARY         = SERIES[0];
		        var DIAGRAM_HOVER   = WHITE;
	
		        function noteStyle() {
		            return {
		                icon: {
		                    background: "#00b0ff",
		                    border: {
		                        color: "#00b0ff"
		                    }
		                },
		                label: {
		                    color: "#ffffff"
		                },
		                line: {
		                    color: AXIS
		                }
		            };
		        }
	
		        registerTheme("office365", {
		            chart: {
		                title: {
		                    color: TEXT
		                },
		                legend: {
		                    labels: {
		                        color: TEXT
		                    },
		                    inactiveItems: {
		                        labels: {
		                            color: INACTIVE
		                        },
		                        markers: {
		                            color: INACTIVE
		                        }
		                    }
		                },
		                seriesDefaults: {
		                    labels: {
		                        color: TEXT
		                    },
		                    errorBars: {
		                        color: TEXT
		                    },
		                    notes: noteStyle(),
		                    candlestick: {
		                        downColor: AXIS,
		                        line: {
		                            color: INACTIVE_SHAPE
		                        }
		                    },
		                    area: {
		                        opacity: 0.8
		                    },
		                    waterfall: {
		                        line: {
		                            color: AXIS
		                        }
		                    },
		                    horizontalWaterfall: {
		                        line: {
		                            color: AXIS
		                        }
		                    },
		                    overlay: {
		                        gradient: "none"
		                    },
		                    border: {
		                        _brightness: 1
		                    }
		                },
		                seriesColors: SERIES,
		                axisDefaults: {
		                    line: {
		                        color: AXIS
		                    },
		                    labels: {
		                        color: TEXT
		                    },
		                    minorGridLines: {
		                        color: AXIS_MINOR
		                    },
		                    majorGridLines: {
		                        color: AXIS
		                    },
		                    title: {
		                        color: TEXT
		                    },
		                    crosshair: {
		                        color: INACTIVE
		                    },
		                    notes: noteStyle()
		                }
		            },
		            gauge: {
		                pointer: {
		                    color: PRIMARY
		                },
		                scale: {
		                    rangePlaceholderColor: AXIS,
		                    labels: {
		                        color: TEXT
		                    },
		                    minorTicks: {
		                        color: TEXT
		                    },
		                    majorTicks: {
		                        color: TEXT
		                    },
		                    line: {
		                        color: TEXT
		                    }
		                }
		            },
		            diagram: {
		                shapeDefaults: {
		                    fill: {
		                        color: PRIMARY
		                    },
		                    connectorDefaults: {
		                        fill: {
		                            color: TEXT
		                        },
		                        stroke: {
		                            color: DIAGRAM_HOVER
		                        },
		                        hover: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: TEXT
		                            }
		                        }
		                    },
		                    content: {
		                        color: TEXT
		                    }
		                },
		                editable: {
		                    resize: {
		                        handles: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            },
		                            hover: {
		                                fill: {
		                                    color: INACTIVE_SHAPE
		                                },
		                                stroke: {
		                                    color: INACTIVE_SHAPE
		                                }
		                            }
		                        }
		                    },
		                    rotate: {
		                        thumb: {
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            },
		                            fill: {
		                                color: INACTIVE_SHAPE
		                            }
		                        }
		                    }
		                },
		                selectable: {
		                    stroke: {
		                        color: INACTIVE_SHAPE
		                    }
		                },
		                connectionDefaults: {
		                    stroke: {
		                        color: INACTIVE_SHAPE
		                    },
		                    content: {
		                        color: INACTIVE_SHAPE
		                    },
		                    selection: {
		                        handles: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            }
		                        },
		                        stroke: {
		                            color: INACTIVE_SHAPE
		                        }
		                    }
		                }
		            },
		            treeMap: {
		                colors: fuse(SERIES, SERIES_LIGHT)
		            }
		        });
		    })();
	
		        (function () {
		        var TEXT = "#32364c";
		        var INACTIVE = "#7f7f7f";
		        var INACTIVE_SHAPE = "#bdbdbd";
		        var AXIS = "#dfe0e1";
		        var AXIS_MINOR = "#dfe0e1";
		        var SERIES = ["#ff4350", "#ff9ea5", "#00acc1", "#80deea", "#ffbf46", "#ffd78c"];
		        var SERIES_LIGHT = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"];
		        var PRIMARY = SERIES[0];
		        var DIAGRAM_HOVER = WHITE;
	
		        function noteStyle() {
		            return {
		                icon: {
		                    background: "#007cc0",
		                    border: {
		                        color: "#007cc0"
		                    }
		                },
		                label: {
		                    color: "#ffffff"
		                },
		                line: {
		                    color: AXIS
		                }
		            };
		        }
	
		        registerTheme("nova", {
		            chart: {
		                title: {
		                    color: TEXT
		                },
		                legend: {
		                    labels: {
		                        color: TEXT
		                    },
		                    inactiveItems: {
		                        labels: {
		                            color: INACTIVE
		                        },
		                        markers: {
		                            color: INACTIVE
		                        }
		                    }
		                },
		                seriesDefaults: {
		                    labels: {
		                        color: TEXT
		                    },
		                    errorBars: {
		                        color: TEXT
		                    },
		                    notes: noteStyle(),
		                    candlestick: {
		                        downColor: AXIS,
		                        line: {
		                            color: INACTIVE_SHAPE
		                        }
		                    },
		                    area: {
		                        opacity: 0.8
		                    },
		                    waterfall: {
		                        line: {
		                            color: AXIS
		                        }
		                    },
		                    horizontalWaterfall: {
		                        line: {
		                            color: AXIS
		                        }
		                    },
		                    overlay: {
		                        gradient: "none"
		                    },
		                    border: {
		                        _brightness: 1
		                    }
		                },
		                seriesColors: SERIES,
		                axisDefaults: {
		                    line: {
		                        color: AXIS
		                    },
		                    labels: {
		                        color: TEXT
		                    },
		                    minorGridLines: {
		                        color: AXIS_MINOR
		                    },
		                    majorGridLines: {
		                        color: AXIS
		                    },
		                    title: {
		                        color: TEXT
		                    },
		                    crosshair: {
		                        color: TEXT
		                    },
		                    notes: noteStyle()
		                }
		            },
		            gauge: {
		                pointer: {
		                    color: PRIMARY
		                },
		                scale: {
		                    rangePlaceholderColor: AXIS,
		                    labels: {
		                        color: TEXT
		                    },
		                    minorTicks: {
		                        color: TEXT
		                    },
		                    majorTicks: {
		                        color: TEXT
		                    },
		                    line: {
		                        color: TEXT
		                    }
		                }
		            },
		            diagram: {
		                shapeDefaults: {
		                    fill: {
		                        color: PRIMARY
		                    },
		                    connectorDefaults: {
		                        fill: {
		                            color: TEXT
		                        },
		                        stroke: {
		                            color: DIAGRAM_HOVER
		                        },
		                        hover: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: TEXT
		                            }
		                        }
		                    },
		                    content: {
		                        color: TEXT
		                    }
		                },
		                editable: {
		                    resize: {
		                        handles: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            },
		                            hover: {
		                                fill: {
		                                    color: INACTIVE_SHAPE
		                                },
		                                stroke: {
		                                    color: INACTIVE_SHAPE
		                                }
		                            }
		                        }
		                    },
		                    rotate: {
		                        thumb: {
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            },
		                            fill: {
		                                color: INACTIVE_SHAPE
		                            }
		                        }
		                    }
		                },
		                selectable: {
		                    stroke: {
		                        color: INACTIVE_SHAPE
		                    }
		                },
		                connectionDefaults: {
		                    stroke: {
		                        color: INACTIVE_SHAPE
		                    },
		                    content: {
		                        color: INACTIVE_SHAPE
		                    },
		                    selection: {
		                        handles: {
		                            fill: {
		                                color: DIAGRAM_HOVER
		                            },
		                            stroke: {
		                                color: INACTIVE_SHAPE
		                            }
		                        },
		                        stroke: {
		                            color: INACTIVE_SHAPE
		                        }
		                    }
		                }
		            },
		            treeMap: {
		                colors: fuse(SERIES, SERIES_LIGHT)
		            }
		        });
		    })();
	
		    (function () {
		        var SERIES = ["#ff6358", "#ffd246", "#78d237", "#28b4c8", "#2d73f5", "#aa46be"];
		        var SERIES_LIGHT = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"];
	
		        registerTheme("default-v2", {
		            chart: { /* read from DOM */ },
		            gauge: { /* read from DOM */ },
		            diagram: { /* read from DOM */ },
		            treeMap: {
		                colors: fuse(SERIES, SERIES_LIGHT)
		            }
		        });
	
		        themes.sass = themes["default-v2"];
		    })();
	
	
	
		    (function () {
		        var TEXT = "#292b2c";
		        var AXIS = "rgba(0, 0, 0, .04)";
		        var SERIES = ["#0275d8", "#5bc0de", "#5cb85c", "#f0ad4e", "#e67d4a", "#d9534f"];
		        var SERIES_LIGHT = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"];
		        var PRIMARY = SERIES[0];
	
		        registerTheme("bootstrap-v4", {
		            chart: { /* read from DOM */ },
		            gauge: {
		                pointer: {
		                    color: PRIMARY
		                },
		                scale: {
		                    rangePlaceholderColor: AXIS,
		                    labels: {
		                        color: TEXT
		                    },
		                    minorTicks: {
		                        color: TEXT
		                    },
		                    majorTicks: {
		                        color: TEXT
		                    },
		                    line: {
		                        color: TEXT
		                    }
		                }
		            },
		            diagram: { /* read from DOM */ },
		            treeMap: {
		                colors: fuse(SERIES, SERIES_LIGHT)
		            }
		        });
		    })();
	
		    function fuse(arr1, arr2) {
		        return $.map(arr1, function(item, index) {
		            return [
		                [item, arr2[index]]
		            ];
		        });
		    }
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 918:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(746);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1073);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1073:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1074),
		        __webpack_require__(1075)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.chart",
		    name: "Chart",
		    category: "dataviz",
		    description: "The Chart widget uses modern browser technologies to render high-quality data visualizations in the browser.",
		    depends: [ "data", "userevents", "drawing", "dataviz.core", "dataviz.themes" ],
		    features: [{
		        id: "dataviz.chart-pdf-export",
		        name: "PDF export",
		        description: "Export Chart as PDF",
		        depends: [ "pdf" ]
		    }]
		};
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1074:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(750);
	
	/***/ }),
	
	/***/ 1075:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(751);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(861);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 857:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 861:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(862),
		        __webpack_require__(863),
		        __webpack_require__(859),
		        __webpack_require__(857)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		window.kendo.dataviz = window.kendo.dataviz || {};
		var dataviz = kendo.dataviz;
		var Class = dataviz.Class;
		var isNumber = dataviz.isNumber;
		var datavizConstants = dataviz.constants;
		var MAX_VALUE = datavizConstants.MAX_VALUE;
		var MIN_VALUE = datavizConstants.MIN_VALUE;
		var VALUE = datavizConstants.VALUE;
		var CENTER = datavizConstants.CENTER;
		var TOP = datavizConstants.TOP;
		var BOTTOM = datavizConstants.BOTTOM;
		var LEFT = datavizConstants.LEFT;
		var WHITE = datavizConstants.WHITE;
		var CIRCLE = datavizConstants.CIRCLE;
		var X = datavizConstants.X;
		var Y = datavizConstants.Y;
		var RIGHT = datavizConstants.RIGHT;
		var BLACK = datavizConstants.BLACK;
		var DATE = datavizConstants.DATE;
		var DEFAULT_PRECISION = datavizConstants.DEFAULT_PRECISION;
		var ARC = datavizConstants.ARC;
		var defined = dataviz.defined;
		var getter = dataviz.getter;
		var isArray = dataviz.isArray;
		var ChartElement = dataviz.ChartElement;
		var Point = dataviz.Point;
		var Box = dataviz.Box;
		var alignPathToPixel = dataviz.alignPathToPixel;
		var setDefaultOptions = dataviz.setDefaultOptions;
		var inArray = dataviz.inArray;
		var isFunction = dataviz.isFunction;
		var valueOrDefault = dataviz.valueOrDefault;
		var isObject = dataviz.isObject;
		var deepExtend = dataviz.deepExtend;
		var last = dataviz.last;
		var eventElement = dataviz.eventElement;
		var getTemplate = dataviz.getTemplate;
		var TextBox = dataviz.TextBox;
		var ShapeElement = dataviz.ShapeElement;
		var getSpacing = dataviz.getSpacing;
		var CurveProcessor = dataviz.CurveProcessor;
		var append = dataviz.append;
		var isString = dataviz.isString;
		var parseDate = dataviz.parseDate;
		var styleValue = dataviz.styleValue;
		var CategoryAxis = dataviz.CategoryAxis;
		var BoxElement = dataviz.BoxElement;
		var round = dataviz.round;
		var limitValue = dataviz.limitValue;
		var grep = dataviz.grep;
		var elementStyles = dataviz.elementStyles;
		var hasClasses = dataviz.hasClasses;
		var bindEvents = dataviz.bindEvents;
		var services = dataviz.services;
		var unbindEvents = dataviz.unbindEvents;
		var support = kendo.support;
		var drawing = kendo.drawing;
		var Path = drawing.Path;
		var Animation = drawing.Animation;
		var AnimationFactory = drawing.AnimationFactory;
		var Group = drawing.Group;
		var Color = kendo.Color;
		var geometry = kendo.geometry;
		var GeometryPoint = geometry.Point;
		var transform = geometry.transform;
	
		var ChartAxis = Class.extend({
		    init: function(axis) {
	
		        this._axis = axis;
		        this.options = axis.options;
		    },
	
		    value: function(point) {
		        var axis = this._axis;
		        var value = axis.getCategory ? axis.getCategory(point) : axis.getValue(point);
	
		        return value;
		    },
	
		    slot: function(from, to, limit) {
		        if (limit === void 0) { limit = true; }
	
		        return this._axis.slot(from, to, limit);
		    },
	
		    range: function() {
		        return this._axis.range();
		    },
	
		    valueRange: function() {
		        return this._axis.valueRange();
		    }
		});
	
		function findAxisByName(name, axes) {
		    for (var idx = 0; idx < axes.length; idx++) {
		        if (axes[idx].options.name === name) {
		            axes[idx].prepareUserOptions();
		            return new ChartAxis(axes[idx]);
		        }
		    }
		}
	
		var ChartPane = kendo.Class.extend({
		    init: function(pane) {
		        this.visual = pane.visual;
		        this.chartsVisual = pane.chartContainer.visual;
		        this._pane = pane;
		    },
	
		    findAxisByName: function(name) {
		        return findAxisByName(name, this._pane.axes);
		    }
		});
	
		var ChartPlotArea = Class.extend({
		    init: function(plotArea) {
	
		        this._plotArea = plotArea;
		        this.visual = plotArea.visual;
		        this.backgroundVisual = plotArea._bgVisual;
		    }
		});
	
		function countNumbers(values) {
		    var length = values.length;
		    var count = 0;
	
		    for (var i = 0; i < length; i++) {
		        var num = values[i];
		        if (isNumber(num)) {
		            count++;
		        }
		    }
	
		    return count;
		}
	
		var Aggregates = {
		    min: function(values) {
		        var length = values.length;
		        var min = MAX_VALUE;
	
		        for (var i = 0; i < length; i++) {
		            var value = values[i];
		            if (isNumber(value)) {
		                min = Math.min(min, value);
		            }
		        }
	
		        return min === MAX_VALUE ? values[0] : min;
		    },
	
		    max: function(values) {
		        var length = values.length;
		        var max = MIN_VALUE;
	
		        for (var i = 0; i < length; i++) {
		            var value = values[i];
		            if (isNumber(value)) {
		                max = Math.max(max, value);
		            }
		        }
	
		        return max === MIN_VALUE ? values[0] : max;
		    },
	
		    sum: function(values) {
		        var length = values.length;
		        var sum = 0;
	
		        for (var i = 0; i < length; i++) {
		            var value = values[i];
		            if (isNumber(value)) {
		                sum += value;
		            }
		        }
	
		        return sum;
		    },
	
		    sumOrNull: function(values) {
		        var result = null;
	
		        if (countNumbers(values)) {
		            result = Aggregates.sum(values);
		        }
	
		        return result;
		    },
	
		    count: function(values) {
		        var length = values.length;
		        var count = 0;
	
		        for (var i = 0; i < length; i++) {
		            var value = values[i];
		            if (value !== null && defined(value)) {
		                count++;
		            }
		        }
	
		        return count;
		    },
	
		    avg: function(values) {
		        var count = countNumbers(values);
		        var result = values[0];
	
		        if (count > 0) {
		            result = Aggregates.sum(values) / count;
		        }
	
		        return result;
		    },
	
		    first: function(values) {
		        var length = values.length;
	
		        for (var i = 0; i < length; i++) {
		            var value = values[i];
		            if (value !== null && defined(value)) {
		                return value;
		            }
		        }
	
		        return values[0];
		    }
		};
	
		function getField(field, row) {
		    if (row === null) {
		        return row;
		    }
	
		    var get = getter(field, true);
		    return get(row);
		}
	
		var SeriesBinder = Class.extend({
		    init: function() {
	
		        this._valueFields = {};
		        this._otherFields = {};
		        this._nullValue = {};
		        this._undefinedValue = {};
		    },
	
		    register: function(seriesTypes, valueFields, otherFields) {
		        var this$1 = this;
		        if (valueFields === void 0) { valueFields = [ VALUE ]; }
		        if (otherFields === void 0) { otherFields = {}; }
	
		        for (var i = 0; i < seriesTypes.length; i++) {
		            var type = seriesTypes[i];
	
		            this$1._valueFields[type] = valueFields;
		            this$1._otherFields[type] = otherFields;
		            this$1._nullValue[type] = this$1._makeValue(valueFields, null);
		            this$1._undefinedValue[type] = this$1._makeValue(valueFields, undefined);
		        }
		    },
	
		    canonicalFields: function(series) {
		        return this.valueFields(series).concat(this.otherFields(series));
		    },
	
		    valueFields: function(series) {
		        return this._valueFields[series.type] || [ VALUE ];
		    },
	
		    otherFields: function(series) {
		        return this._otherFields[series.type] || [ VALUE ];
		    },
	
		    bindPoint: function(series, pointIx, item) {
		        var data = series.data;
		        var pointData = defined(item) ? item : data[pointIx];
		        var result = { valueFields: { value: pointData } };
		        var valueFields = this.valueFields(series);
		        var otherFields = this._otherFields[series.type];
		        var fields, value;
	
		        if (pointData === null) {
		            value = this._nullValue[series.type];
		        } else if (!defined(pointData)) {
		            value = this._undefinedValue[series.type];
		        } else if (Array.isArray(pointData)) {
		            var fieldData = pointData.slice(valueFields.length);
		            value = this._bindFromArray(pointData, valueFields);
		            fields = this._bindFromArray(fieldData, otherFields);
		        } else if (typeof pointData === "object") {
		            var srcValueFields = this.sourceFields(series, valueFields);
		            var srcPointFields = this.sourceFields(series, otherFields);
	
		            value = this._bindFromObject(pointData, valueFields, srcValueFields);
		            fields = this._bindFromObject(pointData, otherFields, srcPointFields);
		        }
	
		        if (defined(value)) {
		            if (valueFields.length === 1) {
		                result.valueFields.value = value[valueFields[0]];
		            } else {
		                result.valueFields = value;
		            }
		        }
	
		        result.fields = fields || {};
	
		        return result;
		    },
	
		    _makeValue: function(fields, initialValue) {
		        var value = {};
		        var length = fields.length;
	
		        for (var i = 0; i < length; i++) {
		            var fieldName = fields[i];
		            value[fieldName] = initialValue;
		        }
	
		        return value;
		    },
	
		    _bindFromArray: function(array, fields) {
		        var value = {};
	
		        if (fields) {
		            var length = Math.min(fields.length, array.length);
	
		            for (var i = 0; i < length; i++) {
		                value[fields[i]] = array[i];
		            }
		        }
	
		        return value;
		    },
	
		    _bindFromObject: function(object, fields, srcFields) {
		        if (srcFields === void 0) { srcFields = fields; }
	
		        var value = {};
	
		        if (fields) {
		            var length = fields.length;
	
		            for (var i = 0; i < length; i++) {
		                var fieldName = fields[i];
		                var srcFieldName = srcFields[i];
		                value[fieldName] = getField(srcFieldName, object);
		            }
		        }
	
		        return value;
		    },
	
		    sourceFields: function(series, canonicalFields) {
		        var sourceFields = [];
	
		        if (canonicalFields) {
		            var length = canonicalFields.length;
	
		            for (var i = 0; i < length; i++) {
		                var fieldName = canonicalFields[i];
		                var sourceFieldName = fieldName === VALUE ? "field" : fieldName + "Field";
	
		                sourceFields.push(series[sourceFieldName] || fieldName);
		            }
		        }
	
		        return sourceFields;
		    }
		});
	
		SeriesBinder.current = new SeriesBinder();
	
		var STD_ERR = "stderr";
		var STD_DEV = "stddev";
		var percentRegex = /percent(?:\w*)\((\d+)\)/;
		var standardDeviationRegex = new RegExp("^" + STD_DEV + "(?:\\((\\d+(?:\\.\\d+)?)\\))?$");
	
		var ErrorRangeCalculator = Class.extend({
		    init: function(errorValue, series, field) {
	
		        this.initGlobalRanges(errorValue, series, field);
		    },
	
		    initGlobalRanges: function(errorValue, series, field) {
		        var data = series.data;
		        var deviationMatch = standardDeviationRegex.exec(errorValue);
	
		        if (deviationMatch) {
		            this.valueGetter = this.createValueGetter(series, field);
	
		            var average = this.getAverage(data);
		            var deviation = this.getStandardDeviation(data, average, false);
		            var multiple = deviationMatch[1] ? parseFloat(deviationMatch[1]) : 1;
		            var errorRange = { low: average.value - deviation * multiple, high: average.value + deviation * multiple };
	
		            this.globalRange = function() {
		                return errorRange;
		            };
		        } else if (errorValue.indexOf && errorValue.indexOf(STD_ERR) >= 0) {
		            this.valueGetter = this.createValueGetter(series, field);
		            var standardError = this.getStandardError(data, this.getAverage(data));
	
		            this.globalRange = function(value) {
		                return { low: value - standardError, high: value + standardError };
		            };
		        }
		    },
	
		    createValueGetter: function(series, field) {
		        var data = series.data;
		        var binder = SeriesBinder.current;
		        var valueFields = binder.valueFields(series);
		        var item = defined(data[0]) ? data[0] : {};
		        var valueGetter;
	
		        if (isArray(item)) {
		            var index = field ? valueFields.indexOf(field) : 0;
		            valueGetter = getter("[" + index + "]");
		        } else if (isNumber(item)) {
		            valueGetter = getter();
		        } else if (typeof item === datavizConstants.OBJECT) {
		            var srcValueFields = binder.sourceFields(series, valueFields);
		            valueGetter = getter(srcValueFields[valueFields.indexOf(field)]);
		        }
	
		        return valueGetter;
		    },
	
		    getErrorRange: function(pointValue, errorValue) {
		        var low, high, value;
	
		        if (!defined(errorValue)) {
		            return null;
		        }
	
		        if (this.globalRange) {
		            return this.globalRange(pointValue);
		        }
	
		        if (isArray(errorValue)) {
		            low = pointValue - errorValue[0];
		            high = pointValue + errorValue[1];
		        } else if (isNumber(value = parseFloat(errorValue))) {
		            low = pointValue - value;
		            high = pointValue + value;
		        } else if ((value = percentRegex.exec(errorValue))) {
		            var percentValue = pointValue * (parseFloat(value[1]) / 100);
		            low = pointValue - Math.abs(percentValue);
		            high = pointValue + Math.abs(percentValue);
		        } else {
		            throw new Error("Invalid ErrorBar value: " + errorValue);
		        }
	
		        return { low: low, high: high };
		    },
	
		    getStandardError: function(data, average) {
		        return this.getStandardDeviation(data, average, true) / Math.sqrt(average.count);
		    },
	
		    getStandardDeviation: function(data, average, isSample) {
		        var this$1 = this;
	
		        var length = data.length;
		        var total = isSample ? average.count - 1 : average.count;
		        var squareDifferenceSum = 0;
	
		        for (var idx = 0; idx < length; idx++) {
		            var value = this$1.valueGetter(data[idx]);
		            if (isNumber(value)) {
		                squareDifferenceSum += Math.pow(value - average.value, 2);
		            }
		        }
	
		        return Math.sqrt(squareDifferenceSum / total);
		    },
	
		    getAverage: function(data) {
		        var this$1 = this;
	
		        var length = data.length;
		        var sum = 0;
		        var count = 0;
	
		        for (var idx = 0; idx < length; idx++) {
		            var value = this$1.valueGetter(data[idx]);
		            if (isNumber(value)) {
		                sum += value;
		                count++;
		            }
		        }
	
		        return {
		            value: sum / count,
		            count: count
		        };
		    }
		});
	
		var browser = support.browser || {};
	
		var INITIAL_ANIMATION_DURATION = 600;
		var FADEIN = "fadeIn";
	
		var GLASS = "glass";
		var BORDER_BRIGHTNESS = 0.8;
		var TOOLTIP_OFFSET = 5;
		var START_SCALE = browser.msie ? 0.001 : 0;
		var ERROR_LOW_FIELD = "errorLow";
		var ERROR_HIGH_FIELD = "errorHigh";
		var X_ERROR_LOW_FIELD = "xErrorLow";
		var X_ERROR_HIGH_FIELD = "xErrorHigh";
		var Y_ERROR_LOW_FIELD = "yErrorLow";
		var Y_ERROR_HIGH_FIELD = "yErrorHigh";
		var LINE_MARKER_SIZE = 8;
		var ZERO = "zero";
		var INTERPOLATE = "interpolate";
		var GAP = "gap";
		var ABOVE = "above";
		var BELOW = "below";
	
		var SMOOTH = "smooth";
		var STEP = "step";
	
		var AREA = "area";
		var BAR = "bar";
		var BOX_PLOT = "boxPlot";
		var BUBBLE = "bubble";
		var BULLET = "bullet";
		var CANDLESTICK = "candlestick";
		var COLUMN = "column";
		var DONUT = "donut";
		var FUNNEL = "funnel";
		var HORIZONTAL_WATERFALL = "horizontalWaterfall";
		var LINE = "line";
		var OHLC = "ohlc";
		var PIE = "pie";
		var POLAR_AREA = "polarArea";
		var POLAR_LINE = "polarLine";
		var POLAR_SCATTER = "polarScatter";
		var RADAR_AREA = "radarArea";
		var RADAR_COLUMN = "radarColumn";
		var RADAR_LINE = "radarLine";
		var RANGE_AREA = "rangeArea";
		var RANGE_BAR = "rangeBar";
		var RANGE_COLUMN = "rangeColumn";
		var SCATTER = "scatter";
		var SCATTER_LINE = "scatterLine";
		var VERTICAL_AREA = "verticalArea";
		var VERTICAL_BOX_PLOT = "verticalBoxPlot";
		var VERTICAL_BULLET = "verticalBullet";
		var VERTICAL_LINE = "verticalLine";
		var VERTICAL_RANGE_AREA = "verticalRangeArea";
		var WATERFALL = "waterfall";
		var EQUALLY_SPACED_SERIES = [
		    BAR, COLUMN, OHLC, CANDLESTICK, BOX_PLOT, VERTICAL_BOX_PLOT,
		    BULLET, RANGE_COLUMN, RANGE_BAR, WATERFALL, HORIZONTAL_WATERFALL
		];
	
		var LEGEND_ITEM_CLICK = "legendItemClick";
		var LEGEND_ITEM_HOVER = "legendItemHover";
		var LEGEND_ITEM_LEAVE = "legendItemLeave";
		var SERIES_CLICK = "seriesClick";
		var SERIES_HOVER = "seriesHover";
		var SERIES_OVER = "seriesOver";
		var SERIES_LEAVE = "seriesLeave";
		var PLOT_AREA_CLICK = "plotAreaClick";
		var PLOT_AREA_HOVER = "plotAreaHover";
		var PLOT_AREA_LEAVE = "plotAreaLeave";
		var DRAG = "drag";
		var DRAG_END = "dragEnd";
		var DRAG_START = "dragStart";
		var ZOOM_START = "zoomStart";
		var ZOOM = "zoom";
		var ZOOM_END = "zoomEnd";
		var SELECT_START = "selectStart";
		var SELECT = "select";
		var SELECT_END = "selectEnd";
		var RENDER = "render";
		var SHOW_TOOLTIP = "showTooltip";
		var HIDE_TOOLTIP = "hideTooltip";
		var PANE_RENDER = "paneRender";
	
		var LOGARITHMIC = "log";
		var CATEGORY = "category";
	
		var INSIDE_END = "insideEnd";
		var INSIDE_BASE = "insideBase";
		var OUTSIDE_END = "outsideEnd";
	
		var MOUSEWHEEL = "DOMMouseScroll mousewheel";
		var MOUSEWHEEL_DELAY = 150;
	
		var constants = {
			INITIAL_ANIMATION_DURATION: INITIAL_ANIMATION_DURATION,
			FADEIN: FADEIN,
			LEGEND_ITEM_CLICK: LEGEND_ITEM_CLICK,
			LEGEND_ITEM_HOVER: LEGEND_ITEM_HOVER,
			LEGEND_ITEM_LEAVE: LEGEND_ITEM_LEAVE,
			SERIES_CLICK: SERIES_CLICK,
			SERIES_HOVER: SERIES_HOVER,
			SERIES_OVER: SERIES_OVER,
			SERIES_LEAVE: SERIES_LEAVE,
			GLASS: GLASS,
			BORDER_BRIGHTNESS: BORDER_BRIGHTNESS,
			TOOLTIP_OFFSET: TOOLTIP_OFFSET,
			START_SCALE: START_SCALE,
			ERROR_LOW_FIELD: ERROR_LOW_FIELD,
			ERROR_HIGH_FIELD: ERROR_HIGH_FIELD,
			X_ERROR_LOW_FIELD: X_ERROR_LOW_FIELD,
			X_ERROR_HIGH_FIELD: X_ERROR_HIGH_FIELD,
			Y_ERROR_LOW_FIELD: Y_ERROR_LOW_FIELD,
			Y_ERROR_HIGH_FIELD: Y_ERROR_HIGH_FIELD,
			LINE_MARKER_SIZE: LINE_MARKER_SIZE,
			INTERPOLATE: INTERPOLATE,
			ZERO: ZERO,
			SMOOTH: SMOOTH,
			STEP: STEP,
			CATEGORY: CATEGORY,
			FUNNEL: FUNNEL,
			BAR: BAR,
			CANDLESTICK: CANDLESTICK,
			PIE: PIE,
			COLUMN: COLUMN,
			AREA: AREA,
			VERTICAL_BULLET: VERTICAL_BULLET,
			BOX_PLOT: BOX_PLOT,
			OHLC: OHLC,
			WATERFALL: WATERFALL,
			LINE: LINE,
			BULLET: BULLET,
			VERTICAL_LINE: VERTICAL_LINE,
			VERTICAL_AREA: VERTICAL_AREA,
			RANGE_AREA: RANGE_AREA,
			VERTICAL_RANGE_AREA: VERTICAL_RANGE_AREA,
			RANGE_COLUMN: RANGE_COLUMN,
			VERTICAL_BOX_PLOT: VERTICAL_BOX_PLOT,
			RANGE_BAR: RANGE_BAR,
			HORIZONTAL_WATERFALL: HORIZONTAL_WATERFALL,
			SCATTER: SCATTER,
			SCATTER_LINE: SCATTER_LINE,
			BUBBLE: BUBBLE,
			RADAR_AREA: RADAR_AREA,
			RADAR_LINE: RADAR_LINE,
			RADAR_COLUMN: RADAR_COLUMN,
			POLAR_LINE: POLAR_LINE,
			POLAR_AREA: POLAR_AREA,
			POLAR_SCATTER: POLAR_SCATTER,
			RENDER: RENDER,
			PLOT_AREA_CLICK: PLOT_AREA_CLICK,
			PLOT_AREA_HOVER: PLOT_AREA_HOVER,
			PLOT_AREA_LEAVE: PLOT_AREA_LEAVE,
			LOGARITHMIC: LOGARITHMIC,
			DRAG: DRAG,
			DRAG_START: DRAG_START,
			DRAG_END: DRAG_END,
			ZOOM_START: ZOOM_START,
			ZOOM: ZOOM,
			ZOOM_END: ZOOM_END,
			SELECT_START: SELECT_START,
			SELECT: SELECT,
			SELECT_END: SELECT_END,
			PANE_RENDER: PANE_RENDER,
			GAP: GAP,
			DONUT: DONUT,
			INSIDE_END: INSIDE_END,
			INSIDE_BASE: INSIDE_BASE,
			OUTSIDE_END: OUTSIDE_END,
			MOUSEWHEEL: MOUSEWHEEL,
			MOUSEWHEEL_DELAY: MOUSEWHEEL_DELAY,
			SHOW_TOOLTIP: SHOW_TOOLTIP,
			HIDE_TOOLTIP: HIDE_TOOLTIP,
			EQUALLY_SPACED_SERIES: EQUALLY_SPACED_SERIES,
			ABOVE: ABOVE,
			BELOW: BELOW
		};
	
		var DEFAULT_ERROR_BAR_WIDTH = 4;
	
		var ErrorBarBase = ChartElement.extend({
		    init: function(low, high, isVertical, chart, series, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.low = low;
		        this.high = high;
		        this.isVertical = isVertical;
		        this.chart = chart;
		        this.series = series;
		    },
	
		    reflow: function(targetBox) {
		        var endCaps = this.options.endCaps;
		        var isVertical = this.isVertical;
		        var axis = this.getAxis();
		        var valueBox = axis.getSlot(this.low, this.high);
		        var centerBox = targetBox.center();
		        var capsWidth = this.getCapsWidth(targetBox, isVertical);
		        var capValue = isVertical ? centerBox.x : centerBox.y;
		        var capStart = capValue - capsWidth;
		        var capEnd = capValue + capsWidth;
		        var linePoints;
	
		        if (isVertical) {
		            linePoints = [
		                new Point(centerBox.x, valueBox.y1),
		                new Point(centerBox.x, valueBox.y2)
		            ];
		            if (endCaps) {
		                linePoints.push(new Point(capStart, valueBox.y1),
		                    new Point(capEnd, valueBox.y1),
		                    new Point(capStart, valueBox.y2),
		                    new Point(capEnd, valueBox.y2));
		            }
		            this.box = new Box(capStart, valueBox.y1, capEnd, valueBox.y2);
		        } else {
		            linePoints = [
		                new Point(valueBox.x1, centerBox.y),
		                new Point(valueBox.x2, centerBox.y)
		            ];
		            if (endCaps) {
		                linePoints.push(new Point(valueBox.x1, capStart),
		                    new Point(valueBox.x1, capEnd),
		                    new Point(valueBox.x2, capStart),
		                    new Point(valueBox.x2, capEnd));
		            }
		            this.box = new Box(valueBox.x1, capStart, valueBox.x2, capEnd);
		        }
	
		        this.linePoints = linePoints;
		    },
	
		    getCapsWidth: function(box, isVertical) {
		        var boxSize = isVertical ? box.width() : box.height();
		        var capsWidth = Math.min(Math.floor(boxSize / 2), DEFAULT_ERROR_BAR_WIDTH) || DEFAULT_ERROR_BAR_WIDTH;
	
		        return capsWidth;
		    },
	
		    createVisual: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var visual = options.visual;
	
		        if (visual) {
		            this.visual = visual({
		                low: this.low,
		                high: this.high,
		                rect: this.box.toRect(),
		                sender: this.getSender(),
		                options: {
		                    endCaps: options.endCaps,
		                    color: options.color,
		                    line: options.line
		                },
		                createVisual: function () {
		                    this$1.createDefaultVisual();
		                    var defaultVisual = this$1.visual;
		                    delete this$1.visual;
		                    return defaultVisual;
		                }
		            });
		        } else {
		            this.createDefaultVisual();
		        }
		    },
	
		    createDefaultVisual: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var linePoints = ref.linePoints;
		        var lineOptions = {
		            stroke: {
		                color: options.color,
		                width: options.line.width,
		                dashType: options.line.dashType
		            }
		        };
	
		        ChartElement.fn.createVisual.call(this);
	
		        for (var idx = 0; idx < linePoints.length; idx += 2) {
		            var line = new Path(lineOptions)
		                .moveTo(linePoints[idx].x, linePoints[idx].y)
		                .lineTo(linePoints[idx + 1].x, linePoints[idx + 1].y);
	
		            alignPathToPixel(line);
		            this$1.visual.append(line);
		        }
		    }
		});
	
		setDefaultOptions(ErrorBarBase, {
		    animation: {
		        type: FADEIN,
		        delay: INITIAL_ANIMATION_DURATION
		    },
		    endCaps: true,
		    line: {
		        width: 2
		    },
		    zIndex: 1
		});
	
		var CategoricalErrorBar = ErrorBarBase.extend({
		    getAxis: function() {
		        var axis = this.chart.seriesValueAxis(this.series);
	
		        return axis;
		    }
		});
	
		var MAX_EXPAND_DEPTH = 5;
	
		function evalOptions(options, context, state, dryRun) {
		    if (state === void 0) { state = {}; }
		    if (dryRun === void 0) { dryRun = false; }
	
		    var defaults = state.defaults = state.defaults || {};
		    var depth = state.depth = state.depth || 0;
		    var needsEval = false;
	
		    state.excluded = state.excluded || [];
	
		    if (depth > MAX_EXPAND_DEPTH) {
		        return null;
		    }
	
		    for (var property in options) {
		        if (!inArray(property, state.excluded) && options.hasOwnProperty(property)) {
		            var propValue = options[property];
		            if (isFunction(propValue)) {
		                needsEval = true;
		                if (!dryRun) {
		                    options[property] = valueOrDefault(propValue(context), defaults[property]);
		                }
		            } else if (isObject(propValue)) {
		                if (!dryRun) {
		                    state.defaults = defaults[property];
		                }
		                state.depth++;
		                needsEval = evalOptions(propValue, context, state, dryRun) || needsEval;
		                state.depth--;
		            }
		        }
		    }
	
		    return needsEval;
		}
	
		function categoriesCount(series) {
		    var seriesCount = series.length;
		    var categories = 0;
	
		    for (var i = 0; i < seriesCount; i++) {
		        categories = Math.max(categories, series[i].data.length);
		    }
	
		    return categories;
		}
	
		var CategoricalChart = ChartElement.extend({
		    init: function(plotArea, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.plotArea = plotArea;
		        this.chartService = plotArea.chartService;
		        this.categoryAxis = plotArea.seriesCategoryAxis(options.series[0]);
	
		        // Value axis ranges grouped by axis name, e.g.:
		        // primary: { min: 0, max: 1 }
		        this.valueAxisRanges = {};
	
		        this.points = [];
		        this.categoryPoints = [];
		        this.seriesPoints = [];
		        this.seriesOptions = [];
		        this._evalSeries = [];
	
		        this.render();
		    },
	
		    render: function() {
		        this.traverseDataPoints(this.addValue.bind(this));
		    },
	
		    pointOptions: function(series, seriesIx) {
		        var options = this.seriesOptions[seriesIx];
		        if (!options) {
		            var defaults = this.pointType().prototype.defaults;
		            this.seriesOptions[seriesIx] = options = deepExtend({ }, defaults, {
		                vertical: !this.options.invertAxes
		            }, series);
		        }
	
		        return options;
		    },
	
		    plotValue: function(point) {
		        if (!point) {
		            return 0;
		        }
	
		        if (this.options.isStacked100 && isNumber(point.value)) {
		            var categoryIx = point.categoryIx;
		            var categoryPoints = this.categoryPoints[categoryIx];
		            var otherValues = [];
		            var categorySum = 0;
	
		            for (var i = 0; i < categoryPoints.length; i++) {
		                var other = categoryPoints[i];
		                if (other) {
		                    var stack = point.series.stack;
		                    var otherStack = other.series.stack;
	
		                    if ((stack && otherStack) && stack.group !== otherStack.group) {
		                        continue;
		                    }
	
		                    if (isNumber(other.value)) {
		                        categorySum += Math.abs(other.value);
		                        otherValues.push(Math.abs(other.value));
		                    }
		                }
		            }
	
		            if (categorySum > 0) {
		                return point.value / categorySum;
		            }
		        }
	
		        return point.value;
		    },
	
		    plotRange: function(point, startValue) {
		        var this$1 = this;
		        if (startValue === void 0) { startValue = 0; }
	
		        var categoryPoints = this.categoryPoints[point.categoryIx];
	
		        if (this.options.isStacked) {
		            var plotValue = this.plotValue(point);
		            var positive = plotValue >= 0;
		            var prevValue = startValue;
		            var isStackedBar = false;
	
		            for (var i = 0; i < categoryPoints.length; i++) {
		                var other = categoryPoints[i];
	
		                if (point === other) {
		                    break;
		                }
	
		                var stack = point.series.stack;
		                var otherStack = other.series.stack;
		                if (stack && otherStack) {
		                    if (typeof stack === datavizConstants.STRING && stack !== otherStack) {
		                        continue;
		                    }
	
		                    if (stack.group && stack.group !== otherStack.group) {
		                        continue;
		                    }
		                }
	
		                var otherValue = this$1.plotValue(other);
		                if ((otherValue >= 0 && positive) ||
		                    (otherValue < 0 && !positive)) {
		                    prevValue += otherValue;
		                    plotValue += otherValue;
		                    isStackedBar = true;
	
		                    if (this$1.options.isStacked100) {
		                        plotValue = Math.min(plotValue, 1);
		                    }
		                }
		            }
	
		            if (isStackedBar) {
		                prevValue -= startValue;
		            }
	
		            return [ prevValue, plotValue ];
		        }
	
		        var series = point.series;
		        var valueAxis = this.seriesValueAxis(series);
		        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);
	
		        return [ axisCrossingValue, dataviz.convertableToNumber(point.value) ? point.value : axisCrossingValue ];
		    },
	
		    stackLimits: function(axisName, stackName) {
		        var this$1 = this;
	
		        var min = MAX_VALUE;
		        var max = MIN_VALUE;
	
		        for (var i = 0; i < this.categoryPoints.length; i++) {
		            var categoryPoints = this$1.categoryPoints[i];
		            if (!categoryPoints) {
		                continue;
		            }
	
		            for (var pIx = 0; pIx < categoryPoints.length; pIx++) {
		                var point = categoryPoints[pIx];
		                if (point) {
		                    if (point.series.stack === stackName || point.series.axis === axisName) {
		                        var to = this$1.plotRange(point, 0)[1];
		                        if (defined(to) && isFinite(to)) {
		                            max = Math.max(max, to);
		                            min = Math.min(min, to);
		                        }
		                    }
		                }
		            }
		        }
	
		        return { min: min, max: max };
		    },
	
		    updateStackRange: function() {
		        var this$1 = this;
	
		        var ref = this.options;
		        var isStacked = ref.isStacked;
		        var chartSeries = ref.series;
		        var limitsCache = {};
	
		        if (isStacked) {
		            for (var i = 0; i < chartSeries.length; i++) {
		                var series = chartSeries[i];
		                var axisName = series.axis;
		                var key = axisName + series.stack;
	
		                var limits = limitsCache[key];
		                if (!limits) {
		                    limits = this$1.stackLimits(axisName, series.stack);
	
		                    var errorTotals = this$1.errorTotals;
		                    if (errorTotals) {
		                        if (errorTotals.negative.length) {
		                            limits.min = Math.min(limits.min, dataviz.sparseArrayLimits(errorTotals.negative).min);
		                        }
		                        if (errorTotals.positive.length) {
		                            limits.max = Math.max(limits.max, dataviz.sparseArrayLimits(errorTotals.positive).max);
		                        }
		                    }
	
		                    if (limits.min !== MAX_VALUE || limits.max !== MIN_VALUE) {
		                        limitsCache[key] = limits;
		                    } else {
		                        limits = null;
		                    }
		                }
	
		                if (limits) {
		                    this$1.valueAxisRanges[axisName] = limits;
		                }
		            }
		        }
		    },
	
		    addErrorBar: function(point, data, categoryIx) {
		        var value = point.value;
		        var series = point.series;
		        var seriesIx = point.seriesIx;
		        var errorBars = point.options.errorBars;
		        var lowValue = data.fields[ERROR_LOW_FIELD];
		        var highValue = data.fields[ERROR_HIGH_FIELD];
		        var errorRange;
	
		        if (isNumber(lowValue) && isNumber(highValue)) {
		            errorRange = { low: lowValue, high: highValue };
		        } else if (errorBars && defined(errorBars.value)) {
		            this.seriesErrorRanges = this.seriesErrorRanges || [];
		            this.seriesErrorRanges[seriesIx] = this.seriesErrorRanges[seriesIx] ||
		                new ErrorRangeCalculator(errorBars.value, series, VALUE);
	
		            errorRange = this.seriesErrorRanges[seriesIx].getErrorRange(value, errorBars.value);
		        }
	
		        if (errorRange) {
		            point.low = errorRange.low;
		            point.high = errorRange.high;
		            this.addPointErrorBar(point, categoryIx);
		        }
		    },
	
		    addPointErrorBar: function(point, categoryIx) {
		        var isVertical = !this.options.invertAxes;
		        var options = point.options.errorBars;
		        var series = point.series;
		        var low = point.low;
		        var high = point.high;
	
		        if (this.options.isStacked) {
		            var stackedErrorRange = this.stackedErrorRange(point, categoryIx);
		            low = stackedErrorRange.low;
		            high = stackedErrorRange.high;
		        } else {
		            var fields = { categoryIx: categoryIx, series: series };
		            this.updateRange({ value: low }, fields);
		            this.updateRange({ value: high }, fields);
		        }
	
		        var errorBar = new CategoricalErrorBar(low, high, isVertical, this, series, options);
		        point.errorBars = [ errorBar ];
		        point.append(errorBar);
		    },
	
		    stackedErrorRange: function(point, categoryIx) {
		        var plotValue = this.plotRange(point, 0)[1] - point.value;
		        var low = point.low + plotValue;
		        var high = point.high + plotValue;
	
		        this.errorTotals = this.errorTotals || { positive: [], negative: [] };
	
		        if (low < 0) {
		            this.errorTotals.negative[categoryIx] = Math.min(this.errorTotals.negative[categoryIx] || 0, low);
		        }
	
		        if (high > 0) {
		            this.errorTotals.positive[categoryIx] = Math.max(this.errorTotals.positive[categoryIx] || 0, high);
		        }
	
		        return { low: low, high: high };
		    },
	
		    addValue: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
	
		        var categoryPoints = this.categoryPoints[categoryIx];
		        if (!categoryPoints) {
		            this.categoryPoints[categoryIx] = categoryPoints = [];
		        }
	
		        var seriesPoints = this.seriesPoints[seriesIx];
		        if (!seriesPoints) {
		            this.seriesPoints[seriesIx] = seriesPoints = [];
		        }
	
		        var point = this.createPoint(data, fields);
		        if (point) {
		            $.extend(point, fields);
	
		            point.owner = this;
		            point.noteText = data.fields.noteText;
		            if (!defined(point.dataItem)) {
		                point.dataItem = series.data[categoryIx];
		            }
		            this.addErrorBar(point, data, categoryIx);
		        }
	
		        this.points.push(point);
		        seriesPoints.push(point);
		        categoryPoints.push(point);
	
		        this.updateRange(data.valueFields, fields);
		    },
	
		    evalPointOptions: function(options, value, category, categoryIx, series, seriesIx) {
		        var state = { defaults: series._defaults, excluded: [ "data", "aggregate", "_events", "tooltip", "content", "template", "visual", "toggle", "_outOfRangeMinPoint", "_outOfRangeMaxPoint" ] };
	
		        var doEval = this._evalSeries[seriesIx];
		        if (!defined(doEval)) {
		            this._evalSeries[seriesIx] = doEval = evalOptions(options, {}, state, true);
		        }
	
		        var pointOptions = options;
		        if (doEval) {
		            pointOptions = deepExtend({}, pointOptions);
		            evalOptions(pointOptions, {
		                value: value,
		                category: category,
		                index: categoryIx,
		                series: series,
		                dataItem: series.data[categoryIx]
		            }, state);
		        }
	
		        return pointOptions;
		    },
	
		    updateRange: function(data, fields) {
		        var axisName = fields.series.axis;
		        var value = data.value;
		        var axisRange = this.valueAxisRanges[axisName];
	
		        if (isFinite(value) && value !== null) {
		            axisRange = this.valueAxisRanges[axisName] =
		                axisRange || { min: MAX_VALUE, max: MIN_VALUE };
	
		            axisRange.min = Math.min(axisRange.min, value);
		            axisRange.max = Math.max(axisRange.max, value);
		        }
		    },
	
		    seriesValueAxis: function(series) {
		        var plotArea = this.plotArea;
		        var axisName = series.axis;
		        var axis = axisName ? plotArea.namedValueAxes[axisName] : plotArea.valueAxis;
	
		        if (!axis) {
		            throw new Error("Unable to locate value axis with name " + axisName);
		        }
	
		        return axis;
		    },
	
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        var categorySlots = this.categorySlots = [];
		        var chartPoints = this.points;
		        var categoryAxis = this.categoryAxis;
		        var pointIx = 0;
	
		        this.traverseDataPoints(function (data, fields) {
		            var categoryIx = fields.categoryIx;
		            var currentSeries = fields.series;
	
		            var valueAxis = this$1.seriesValueAxis(currentSeries);
		            var point = chartPoints[pointIx++];
	
		            var categorySlot = categorySlots[categoryIx];
		            if (!categorySlot) {
		                categorySlots[categoryIx] = categorySlot =
		                    this$1.categorySlot(categoryAxis, categoryIx, valueAxis);
		            }
	
		            if (point) {
		                var plotRange = this$1.plotRange(point, valueAxis.startValue());
		                var valueSlot = this$1.valueSlot(valueAxis, plotRange);
		                if (valueSlot) {
		                    var pointSlot = this$1.pointSlot(categorySlot, valueSlot);
	
		                    point.aboveAxis = this$1.aboveAxis(point, valueAxis);
		                    point.stackValue = plotRange[1];
	
		                    if (this$1.options.isStacked100) {
		                        point.percentage = this$1.plotValue(point);
		                    }
	
		                    this$1.reflowPoint(point, pointSlot);
		                } else {
		                    point.visible = false;
		                }
		            }
		        });
	
		        this.reflowCategories(categorySlots);
		        if (!this.options.clip && this.options.limitPoints && this.points.length) {
		            this.limitPoints();
		        }
	
		        this.box = targetBox;
		    },
	
		    valueSlot: function(valueAxis, plotRange) {
		        return valueAxis.getSlot(plotRange[0], plotRange[1], !this.options.clip);
		    },
	
		    limitPoints: function() {
		        var this$1 = this;
	
		        var categoryPoints = this.categoryPoints;
		        var points = categoryPoints[0].concat(last(categoryPoints));
		        for (var idx = 0; idx < points.length; idx++) {
		            if (points[idx]) {
		                this$1.limitPoint(points[idx]);
		            }
		        }
		    },
	
		    limitPoint: function(point) {
		        var limittedSlot = this.categoryAxis.limitSlot(point.box);
		        if (!limittedSlot.equals(point.box)) {
		            point.reflow(limittedSlot);
		        }
		    },
	
		    aboveAxis: function(point, valueAxis) {
		        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);
		        var value = point.value;
	
		        return valueAxis.options.reverse ?
		            value < axisCrossingValue : value >= axisCrossingValue;
		    },
	
		    categoryAxisCrossingValue: function(valueAxis) {
		        var categoryAxis = this.categoryAxis;
		        var options = valueAxis.options;
		        var crossingValues = [].concat(
		            options.axisCrossingValues || options.axisCrossingValue
		        );
	
		        return crossingValues[categoryAxis.axisIndex || 0] || 0;
		    },
	
		    reflowPoint: function(point, pointSlot) {
		        point.reflow(pointSlot);
		    },
	
		    reflowCategories: function() { },
	
		    pointSlot: function(categorySlot, valueSlot) {
		        var options = this.options;
		        var invertAxes = options.invertAxes;
		        var slotX = invertAxes ? valueSlot : categorySlot;
		        var slotY = invertAxes ? categorySlot : valueSlot;
	
		        return new Box(slotX.x1, slotY.y1, slotX.x2, slotY.y2);
		    },
	
		    categorySlot: function(categoryAxis, categoryIx) {
		        return categoryAxis.getSlot(categoryIx);
		    },
	
		    traverseDataPoints: function(callback) {
		        var this$1 = this;
	
		        var series = this.options.series;
		        var count = categoriesCount(series);
		        var seriesCount = series.length;
	
		        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
		            this$1._outOfRangeCallback(series[seriesIx], "_outOfRangeMinPoint", seriesIx, callback);
		        }
	
		        for (var categoryIx = 0; categoryIx < count; categoryIx++) {
		            for (var seriesIx$1 = 0; seriesIx$1 < seriesCount; seriesIx$1++) {
		                var currentSeries = series[seriesIx$1];
		                var currentCategory = this$1.categoryAxis.categoryAt(categoryIx);
		                var pointData = this$1._bindPoint(currentSeries, seriesIx$1, categoryIx);
	
		                callback(pointData, {
		                    category: currentCategory,
		                    categoryIx: categoryIx,
		                    series: currentSeries,
		                    seriesIx: seriesIx$1
		                });
		            }
		        }
	
		        for (var seriesIx$2 = 0; seriesIx$2 < seriesCount; seriesIx$2++) {
		            this$1._outOfRangeCallback(series[seriesIx$2], "_outOfRangeMaxPoint", seriesIx$2, callback);
		        }
		    },
	
		    _outOfRangeCallback: function(series, field, seriesIx, callback) {
		        var outOfRangePoint = series[field];
		        if (outOfRangePoint) {
		            var categoryIx = outOfRangePoint.categoryIx;
		            var pointData = this._bindPoint(series, seriesIx, categoryIx, outOfRangePoint.item);
	
		            callback(pointData, {
		                category: outOfRangePoint.category,
		                categoryIx: categoryIx,
		                series: series,
		                seriesIx: seriesIx,
		                dataItem: outOfRangePoint.item
		            });
		        }
		    },
	
		    _bindPoint: function(series, seriesIx, categoryIx, item) {
		        if (!this._bindCache) {
		            this._bindCache = [];
		        }
	
		        var bindCache = this._bindCache[seriesIx];
		        if (!bindCache) {
		            bindCache = this._bindCache[seriesIx] = [];
		        }
	
		        var data = bindCache[categoryIx];
		        if (!data) {
		            data = bindCache[categoryIx] = SeriesBinder.current.bindPoint(series, categoryIx, item);
		        }
	
		        return data;
		    },
	
		    formatPointValue: function(point, format) {
		        if (point.value === null) {
		            return "";
		        }
	
		        return this.chartService.format.auto(format, point.value);
		    },
	
		    pointValue: function(data) {
		        return data.valueFields.value;
		    }
		});
	
		setDefaultOptions(CategoricalChart, {
		    series: [],
		    invertAxes: false,
		    isStacked: false,
		    clip: true,
		    limitPoints: true
		});
	
		var PointEventsMixin = {
		    click: function(chart, e) {
		        return chart.trigger(
		            SERIES_CLICK,
		            this.eventArgs(e)
		        );
		    },
	
		    hover: function(chart, e) {
		        return chart.trigger(
		            SERIES_HOVER,
		            this.eventArgs(e)
		        );
		    },
	
		    over: function(chart, e) {
		        return chart.trigger(
		            SERIES_OVER,
		            this.eventArgs(e)
		        );
		    },
	
		    out: function(chart, e) {
		        return chart.trigger(
		            SERIES_LEAVE,
		            this.eventArgs(e)
		        );
		    },
	
		    eventArgs: function(e) {
		        return {
		            value: this.value,
		            percentage: this.percentage,
		            stackValue: this.stackValue,
		            category: this.category,
		            series: this.series,
		            dataItem: this.dataItem,
		            runningTotal: this.runningTotal,
		            total: this.total,
		            element: eventElement(e),
		            originalEvent: e,
		            point: this
		        };
		    }
		};
	
		var NoteMixin = {
		    createNote: function() {
		        var options = this.options.notes;
		        var text = this.noteText || options.label.text;
	
		        if (options.visible !== false && defined(text) && text !== null) {
		            this.note = new dataviz.Note({
		                value: this.value,
		                text: text,
		                dataItem: this.dataItem,
		                category: this.category,
		                series: this.series
		            }, this.options.notes, this.owner.chartService);
	
		            this.append(this.note);
		        }
		    }
		};
	
		var LinePoint = ChartElement.extend({
		    init: function(value, options) {
		        ChartElement.fn.init.call(this);
	
		        this.value = value;
		        this.options = options;
		        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
		        this.tooltipTracking = true;
		    },
	
		    render: function() {
		        var ref = this.options;
		        var markers = ref.markers;
		        var labels = ref.labels;
	
		        if (this._rendered) {
		            return;
		        }
	
		        this._rendered = true;
	
		        if (markers.visible && markers.size) {
		            this.marker = this.createMarker();
		            this.append(this.marker);
		        }
	
		        if (labels.visible) {
		            var labelTemplate = getTemplate(labels);
		            var pointData = this.pointData();
		            var labelText = this.value;
		            if (labelTemplate) {
		                labelText = labelTemplate(pointData);
		            } else if (labels.format) {
		                labelText = this.formatValue(labels.format);
		            }
		            this.label = new TextBox(labelText,
		                deepExtend({
		                    align: CENTER,
		                    vAlign: CENTER,
		                    margin: {
		                        left: 5,
		                        right: 5
		                    },
		                    zIndex: valueOrDefault(labels.zIndex, this.series.zIndex)
		                }, labels),
		                pointData
		            );
		            this.append(this.label);
		        }
	
		        this.createNote();
	
		        if (this.errorBar) {
		            this.append(this.errorBar);
		        }
		    },
	
		    markerBorder: function() {
		        var options = this.options.markers;
		        var background = options.background;
		        var border = deepExtend({ color: this.color }, options.border);
	
		        if (!defined(border.color)) {
		            border.color = new Color(background).brightness(BORDER_BRIGHTNESS).toHex();
		        }
	
		        return border;
		    },
	
		    createVisual: function() {},
	
		    createMarker: function() {
		        var options = this.options.markers;
		        var marker = new ShapeElement({
		            type: options.type,
		            width: options.size,
		            height: options.size,
		            rotation: options.rotation,
		            background: options.background,
		            border: this.markerBorder(),
		            opacity: options.opacity,
		            zIndex: valueOrDefault(options.zIndex, this.series.zIndex),
		            animation: options.animation,
		            visual: options.visual
		        }, {
		            dataItem: this.dataItem,
		            value: this.value,
		            series: this.series,
		            category: this.category
		        });
	
		        return marker;
		    },
	
		    markerBox: function() {
		        if (!this.marker) {
		            this.marker = this.createMarker();
		            this.marker.reflow(this._childBox);
		        }
	
		        return this.marker.box;
		    },
	
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var aboveAxis = ref.aboveAxis;
		        var vertical = options.vertical;
	
		        this.render();
	
		        this.box = targetBox;
		        var childBox = targetBox.clone();
	
		        if (vertical) {
		            if (aboveAxis) {
		                childBox.y1 -= childBox.height();
		            } else {
		                childBox.y2 += childBox.height();
		            }
		        } else {
		            if (aboveAxis) {
		                childBox.x1 += childBox.width();
		            } else {
		                childBox.x2 -= childBox.width();
		            }
		        }
	
		        this._childBox = childBox;
		        if (this.marker) {
		            this.marker.reflow(childBox);
		        }
	
		        this.reflowLabel(childBox);
	
		        if (this.errorBars) {
		            for (var i = 0; i < this.errorBars.length; i++) {
		                this$1.errorBars[i].reflow(childBox);
		            }
		        }
	
		        if (this.note) {
		            var noteTargetBox = this.markerBox();
	
		            if (!(options.markers.visible && options.markers.size)) {
		                var center = noteTargetBox.center();
		                noteTargetBox = new Box(center.x, center.y, center.x, center.y);
		            }
	
		            this.note.reflow(noteTargetBox);
		        }
		    },
	
		    reflowLabel: function(box) {
		        var ref = this;
		        var options = ref.options;
		        var label = ref.label;
		        var anchor = options.labels.position;
	
		        if (label) {
		            anchor = anchor === ABOVE ? TOP : anchor;
		            anchor = anchor === BELOW ? BOTTOM : anchor;
	
		            label.reflow(box);
		            label.box.alignTo(this.markerBox(), anchor);
		            label.reflow(label.box);
		        }
		    },
	
		    createHighlight: function() {
		        var markers = this.options.highlight.markers;
		        var defaultColor = this.markerBorder().color;
		        var options = this.options.markers;
		        var size = options.size + (options.border.width || 0) + (markers.border.width || 0);
	
		        var shadow = new ShapeElement({
		            type: options.type,
		            width: size,
		            height: size,
		            rotation: options.rotation,
		            background: markers.color || defaultColor,
		            border: {
		                color: markers.border.color,
		                width: markers.border.width,
		                opacity: valueOrDefault(markers.border.opacity, 1)
		            },
		            opacity: valueOrDefault(markers.opacity, 1)
		        });
		        shadow.reflow(this._childBox);
	
		        return shadow.getElement();
		    },
	
		    highlightVisual: function() {
		        return (this.marker || {}).visual;
		    },
	
		    highlightVisualArgs: function() {
		        var marker = this.marker;
		        var visual, rect;
	
		        if (marker) {
		            rect = marker.paddingBox.toRect();
		            visual = marker.visual;
		        } else {
		            var size = this.options.markers.size;
		            var halfSize = size / 2;
		            var center = this.box.center();
		            rect = new geometry.Rect([ center.x - halfSize, center.y - halfSize ], [ size, size ]);
		        }
	
		        return {
		            options: this.options,
		            rect: rect,
		            visual: visual
		        };
		    },
	
		    tooltipAnchor: function() {
		        var markerBox = this.markerBox();
		        var clipBox = this.owner.pane.clipBox();
		        var showTooltip = !clipBox || clipBox.overlaps(markerBox);
	
		        if (showTooltip) {
		            var x = markerBox.x2 + TOOLTIP_OFFSET;
		            var horizontalAlign = LEFT;
		            var y, verticalAlign;
	
		            if (this.aboveAxis) {
		                y = markerBox.y1;
		                verticalAlign = BOTTOM;
		            } else {
		                y = markerBox.y2;
		                verticalAlign = TOP;
		            }
	
		            return {
		                point: new Point(x, y),
		                align: {
		                    horizontal: horizontalAlign,
		                    vertical: verticalAlign
		                }
		            };
		        }
		    },
	
		    formatValue: function(format) {
		        return this.owner.formatPointValue(this, format);
		    },
	
		    overlapsBox: function(box) {
		        var markerBox = this.markerBox();
		        return markerBox.overlaps(box);
		    },
	
		    unclipElements: function() {
		        if (this.label) {
		            this.label.options.noclip = true;
		        }
	
		        if (this.note) {
		            this.note.options.noclip = true;
		        }
		    },
	
		    pointData: function() {
		        return {
		            dataItem: this.dataItem,
		            category: this.category,
		            value: this.value,
		            percentage: this.percentage,
		            stackValue: this.stackValue,
		            series: this.series
		        };
		    }
		});
	
		LinePoint.prototype.defaults = {
		    vertical: true,
		    markers: {
		        visible: true,
		        background: WHITE,
		        size: LINE_MARKER_SIZE,
		        type: CIRCLE,
		        border: {
		            width: 2
		        },
		        opacity: 1
		    },
		    labels: {
		        visible: false,
		        position: ABOVE,
		        margin: getSpacing(3),
		        padding: getSpacing(4),
		        animation: {
		            type: FADEIN,
		            delay: INITIAL_ANIMATION_DURATION
		        }
		    },
		    notes: {
		        label: {}
		    },
		    highlight: {
		        markers: {
		            border: {
		                color: "#fff",
		                width: 2
		            }
		        },
		        zIndex: datavizConstants.HIGHLIGHT_ZINDEX
		    },
		    errorBars: {
		        line: {
		            width: 1
		        }
		    }
		};
	
		deepExtend(LinePoint.prototype, PointEventsMixin);
		deepExtend(LinePoint.prototype, NoteMixin);
	
		var LineSegment = ChartElement.extend({
		    init: function(linePoints, series, seriesIx) {
		        ChartElement.fn.init.call(this);
	
		        this.linePoints = linePoints;
		        this.series = series;
		        this.seriesIx = seriesIx;
		    },
	
		    points: function() {
		        return this.toGeometryPoints(this.linePoints);
		    },
	
		    toGeometryPoints: function(points) {
		        var result = [];
		        for (var i = 0, length = points.length; i < length; i++) {
		            if (points[i] && points[i].visible !== false) {
		                result.push(points[i]._childBox.toRect().center());
		            }
		        }
	
		        return result;
		    },
	
		    createVisual: function() {
		        var this$1 = this;
	
		        var customVisual = this.series.visual;
		        if (customVisual) {
		            this.visual = customVisual({
		                points: this.toGeometryPoints(this.linePoints),
		                series: this.series,
		                sender: this.getSender(),
		                createVisual: function () {
		                    this$1.segmentVisual();
	
		                    return this$1.visual;
		                }
		            });
		            if (this.visual && !defined(this.visual.options.zIndex)) {
		                this.visual.options.zIndex = this.series.zIndex;
		            }
		        } else {
		            this.segmentVisual();
		        }
		    },
	
		    segmentVisual: function() {
		        var ref = this;
		        var options = ref.options;
		        var series = ref.series;
		        var color = series.color;
		        var defaults = series._defaults;
	
		        if (isFunction(color) && defaults) {
		            color = defaults.color;
		        }
	
		        var line = Path.fromPoints(this.points(), {
		            stroke: {
		                color: color,
		                width: series.width,
		                opacity: series.opacity,
		                dashType: series.dashType
		            },
		            zIndex: series.zIndex
		        });
	
		        if (options.closed) {
		            line.close();
		        }
	
		        this.visual = line;
		    },
	
		    aliasFor: function(e, coords) {
		        return this.parent.getNearestPoint(coords.x, coords.y, this.seriesIx);
		    }
		});
	
		setDefaultOptions(LineSegment, {
		    closed: false
		});
	
		var StepLineMixin = {
		    calculateStepPoints: function(points) {
		        var categoryAxis = this.parent.plotArea.seriesCategoryAxis(this.series);
		        var ref = categoryAxis.options;
		        var justified = ref.justified;
		        var vertical = ref.vertical;
		        var reverse = ref.reverse;
	
		        var stepAxis = vertical ? X : Y;
		        var axis = vertical ? Y : X;
		        var stepDir = reverse ? 2 : 1;
		        var dir = stepDir;
	
		        var previousPoint = toGeometryPoint(points[0], stepAxis, stepDir, axis, dir);
		        var result = [ previousPoint ];
	
		        for (var idx = 1; idx < points.length; idx++) {
		            var point = toGeometryPoint(points[idx], stepAxis, stepDir, axis, dir);
	
		            if (previousPoint[stepAxis] !== point[stepAxis]) {
		                var stepPoint = new GeometryPoint();
		                stepPoint[stepAxis] = previousPoint[stepAxis];
		                stepPoint[axis] = point[axis];
	
		                result.push(stepPoint, point);
		            }
	
		            previousPoint = point;
		        }
	
		        if (!justified) {
		            result.push(toGeometryPoint(last(points), stepAxis, stepDir, axis, reverse ? 1 : 2));
		        } else if (previousPoint !== last(result)) {
		            result.push(previousPoint);
		        }
	
		        return result;
	
		    }
		};
	
		function toGeometryPoint(lintPoint, stepAxis, stepDir, axis, dir) {
		    var box = lintPoint.box;
		    var result = new GeometryPoint();
	
		    result[stepAxis] = box[stepAxis + stepDir];
		    result[axis] = box[axis + dir];
	
		    return result;
		}
	
		var StepLineSegment = LineSegment.extend({
		    points: function() {
		        return this.calculateStepPoints(this.linePoints);
		    }
		});
	
		deepExtend(StepLineSegment.prototype, StepLineMixin);
	
		var SplineSegment = LineSegment.extend({
		    segmentVisual: function() {
		        var series = this.series;
		        var defaults = series._defaults;
		        var color = series.color;
	
		        if (isFunction(color) && defaults) {
		            color = defaults.color;
		        }
	
		        var curveProcessor = new CurveProcessor(this.options.closed);
		        var segments = curveProcessor.process(this.points());
		        var curve = new Path({
		            stroke: {
		                color: color,
		                width: series.width,
		                opacity: series.opacity,
		                dashType: series.dashType
		            },
		            zIndex: series.zIndex
		        });
	
		        curve.segments.push.apply(curve.segments, segments);
	
		        this.visual = curve;
		    }
		});
	
		var LineChartMixin = {
		    renderSegments: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var seriesPoints = ref.seriesPoints;
		        var series = options.series;
		        var seriesCount = seriesPoints.length;
		        var lastSegment;
	
		        this._segments = [];
	
		        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
		            var currentSeries = series[seriesIx];
		            var sortedPoints = this$1.sortPoints(seriesPoints[seriesIx]);
		            var pointCount = sortedPoints.length;
		            var linePoints = [];
	
		            for (var pointIx = 0; pointIx < pointCount; pointIx++) {
		                var point = sortedPoints[pointIx];
		                if (point) {
		                    linePoints.push(point);
		                } else if (this$1.seriesMissingValues(currentSeries) !== INTERPOLATE) {
		                    if (linePoints.length > 1) {
		                        lastSegment = this$1.createSegment(
		                            linePoints, currentSeries, seriesIx, lastSegment
		                        );
		                        this$1._addSegment(lastSegment);
		                    }
		                    linePoints = [];
		                }
		            }
	
		            if (linePoints.length > 1) {
		                lastSegment = this$1.createSegment(
		                    linePoints, currentSeries, seriesIx, lastSegment
		                );
		                this$1._addSegment(lastSegment);
		            }
		        }
	
		        this.children.unshift.apply(this.children, this._segments);
		    },
	
		    _addSegment: function(segment) {
		        this._segments.push(segment);
		        segment.parent = this;
		    },
	
		    sortPoints: function(points) {
		        return points;
		    },
	
		    seriesMissingValues: function(series) {
		        var missingValues = series.missingValues;
		        var assumeZero = !missingValues && this.options.isStacked;
	
		        return assumeZero ? ZERO : missingValues || INTERPOLATE;
		    },
	
		    getNearestPoint: function(x, y, seriesIx) {
		        var target = new Point(x, y);
		        var allPoints = this.seriesPoints[seriesIx];
		        var nearestPointDistance = MAX_VALUE;
		        var nearestPoint;
	
		        for (var i = 0; i < allPoints.length; i++) {
		            var point = allPoints[i];
	
		            if (point && defined(point.value) && point.value !== null && point.visible !== false) {
		                var pointBox = point.box;
		                var pointDistance = pointBox.center().distanceTo(target);
	
		                if (pointDistance < nearestPointDistance) {
		                    nearestPoint = point;
		                    nearestPointDistance = pointDistance;
		                }
		            }
		        }
	
		        return nearestPoint;
		    }
		};
	
		var ClipAnimation = Animation.extend({
		    setup: function() {
		        this._setEnd(this.options.box.x1);
		    },
	
		    step: function(pos) {
		        var box = this.options.box;
		        this._setEnd(dataviz.interpolateValue(box.x1, box.x2, pos));
		    },
	
		    _setEnd: function(x) {
		        var element = this.element;
		        var segments = element.segments;
		        var topRight = segments[1].anchor();
		        var bottomRight = segments[2].anchor();
	
		        element.suspend();
		        topRight.setX(x);
		        element.resume();
		        bottomRight.setX(x);
		    }
		});
	
		setDefaultOptions(ClipAnimation, {
		    duration: INITIAL_ANIMATION_DURATION
		});
	
		AnimationFactory.current.register("clip", ClipAnimation);
	
		function anyHasZIndex(elements) {
		    for (var idx = 0; idx < elements.length; idx++) {
		        if (defined(elements[idx].zIndex)) {
		            return true;
		        }
		    }
		}
	
		var ClipAnimationMixin = {
		    createAnimation: function() {
		        var root = this.getRoot();
		        if (root && (root.options || {}).transitions !== false) {
		            var box = root.size();
		            var clipPath = Path.fromRect(box.toRect());
		            this.visual.clip(clipPath);
		            this.animation = new ClipAnimation(clipPath, {
		                box: box
		            });
		            if (anyHasZIndex(this.options.series)) {
		                this._setChildrenAnimation(clipPath);
		            }
		        }
		    },
	
		    _setChildrenAnimation: function(clipPath) {
		        var points = this.animationPoints();
	
		        for (var idx = 0; idx < points.length; idx++) {
		            var point = points[idx];
		            if (point && point.visual && defined(point.visual.options.zIndex)) {
		                point.visual.clip(clipPath);
		            }
		        }
		    }
		};
	
		var LineChart = CategoricalChart.extend({
		    render: function() {
	
		        CategoricalChart.fn.render.call(this);
	
		        this.updateStackRange();
		        this.renderSegments();
		    },
	
		    pointType: function() {
		        return LinePoint;
		    },
	
		    createPoint: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var category = fields.category;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var missingValues = this.seriesMissingValues(series);
		        var value = data.valueFields.value;
	
		        if (!defined(value) || value === null) {
		            if (missingValues === ZERO) {
		                value = 0;
		            } else {
		                return null;
		            }
		        }
	
		        var pointOptions = this.pointOptions(series, seriesIx);
		        pointOptions = this.evalPointOptions(
		            pointOptions, value, category, categoryIx, series, seriesIx
		        );
	
		        var color = data.fields.color || series.color;
		        if (isFunction(series.color)) {
		            color = pointOptions.color;
		        }
	
		        var point = new LinePoint(value, pointOptions);
		        point.color = color;
	
		        this.append(point);
	
		        return point;
		    },
	
		    plotRange: function(point) {
		        var this$1 = this;
	
		        var plotValue = this.plotValue(point);
	
		        if (this.options.isStacked) {
		            var categoryIx = point.categoryIx;
		            var categoryPoints = this.categoryPoints[categoryIx];
	
		            for (var i = 0; i < categoryPoints.length; i++) {
		                var other = categoryPoints[i];
	
		                if (point === other) {
		                    break;
		                }
	
		                plotValue += this$1.plotValue(other);
	
		                if (this$1.options.isStacked100) {
		                    plotValue = Math.min(plotValue, 1);
		                }
		            }
	
		        }
	
		        return [ plotValue, plotValue ];
		    },
	
		    createSegment: function(linePoints, currentSeries, seriesIx) {
		        var style = currentSeries.style;
		        var pointType;
	
		        if (style === STEP) {
		            pointType = StepLineSegment;
		        } else if (style === SMOOTH) {
		            pointType = SplineSegment;
		        } else {
		            pointType = LineSegment;
		        }
	
		        return new pointType(linePoints, currentSeries, seriesIx);
		    },
	
		    animationPoints: function() {
		        var points = this.points;
		        var result = [];
		        for (var idx = 0; idx < points.length; idx++) {
		            result.push((points[idx] || {}).marker);
		        }
		        return result.concat(this._segments);
		    }
		});
	
		deepExtend(LineChart.prototype, LineChartMixin, ClipAnimationMixin);
	
		var AreaSegment = LineSegment.extend({
		    init: function(linePoints, currentSeries, seriesIx, prevSegment, stackPoints) {
		        LineSegment.fn.init.call(this, linePoints, currentSeries, seriesIx);
	
		        this.prevSegment = prevSegment;
		        this.stackPoints = stackPoints;
		    },
	
		    createVisual: function() {
		        var series = this.series;
		        var defaults = series._defaults;
		        var lineOptions = series.line || {};
		        var color = series.color;
	
		        if (isFunction(color) && defaults) {
		            color = defaults.color;
		        }
	
		        this.visual = new Group({
		            zIndex: series.zIndex
		        });
	
		        this.createFill({
		            fill: {
		                color: color,
		                opacity: series.opacity
		            },
		            stroke: null
		        });
	
		        if (lineOptions.width > 0 && lineOptions.visible !== false) {
		            this.createStroke({
		                stroke: deepExtend({
		                    color: color,
		                    opacity: series.opacity,
		                    lineCap: "butt"
		                }, lineOptions)
		            });
		        }
		    },
	
		    strokeSegments: function() {
		        var segments = this._strokeSegments;
	
		        if (!segments) {
		            segments = this._strokeSegments = this.createStrokeSegments();
		        }
	
		        return segments;
		    },
	
		    createStrokeSegments: function() {
		        return this.segmentsFromPoints(this.points());
		    },
	
		    stackSegments: function() {
		        if (this.prevSegment) {
		            return this.prevSegment.createStackSegments(this.stackPoints);
		        }
	
		        return this.createStackSegments(this.stackPoints);
		    },
	
		    createStackSegments: function(stackPoints) {
		        return this.segmentsFromPoints(this.toGeometryPoints(stackPoints)).reverse();
		    },
	
		    segmentsFromPoints: function(points) {
		        return points.map(function (point) { return new geometry.Segment(point); });
		    },
	
		    createStroke: function(style) {
		        var stroke = new Path(style);
		        stroke.segments.push.apply(stroke.segments, this.strokeSegments());
	
		        this.visual.append(stroke);
		    },
	
		    hasStackSegment: function() {
		        return this.prevSegment || (this.stackPoints && this.stackPoints.length);
		    },
	
		    createFill: function(style) {
		        var strokeSegments = this.strokeSegments();
		        var fillSegments = strokeSegments.slice(0);
		        var hasStackSegments = this.hasStackSegment();
	
		        if (hasStackSegments) {
		            var stackSegments = this.stackSegments();
	
		            append(fillSegments, stackSegments);
		        }
	
		        var fill = new Path(style);
		        fill.segments.push.apply(fill.segments, fillSegments);
	
		        if (!hasStackSegments && strokeSegments.length > 1) {
		            this.fillToAxes(fill);
		        }
	
		        this.visual.append(fill);
		    },
	
		    fillToAxes: function(fillPath) {
		        var chart = this.parent;
		        var invertAxes = chart.options.invertAxes;
		        var valueAxis = chart.seriesValueAxis(this.series);
		        var crossingValue = chart.categoryAxisCrossingValue(valueAxis);
		        var endSlot = valueAxis.getSlot(crossingValue, crossingValue, true);
		        var segments = this.strokeSegments();
		        var firstPoint = segments[0].anchor();
		        var lastPoint = last(segments).anchor();
		        var end = invertAxes ? endSlot.x1 : endSlot.y1;
	
		        if (invertAxes) {
		            fillPath.lineTo(end, lastPoint.y)
		                    .lineTo(end, firstPoint.y);
		        } else {
		            fillPath.lineTo(lastPoint.x, end)
		                    .lineTo(firstPoint.x, end);
		        }
		    }
		});
	
		var StepAreaSegment = AreaSegment.extend({
		    createStrokeSegments: function() {
		        return this.segmentsFromPoints(this.calculateStepPoints(this.linePoints));
		    },
	
		    createStackSegments: function(stackPoints) {
		        return this.segmentsFromPoints(this.calculateStepPoints(stackPoints)).reverse();
		    }
		});
	
		deepExtend(StepAreaSegment.prototype, StepLineMixin);
	
		var SplineAreaSegment = AreaSegment.extend({
		    createStrokeSegments: function() {
		        var curveProcessor = new CurveProcessor(this.options.closed);
		        var linePoints = this.points();
	
		        return curveProcessor.process(linePoints);
		    },
	
		    createStackSegments: function() {
		        var strokeSegments = this.strokeSegments();
		        var stackSegments = [];
		        for (var idx = strokeSegments.length - 1; idx >= 0; idx--) {
		            var segment = strokeSegments[idx];
		            stackSegments.push(new geometry.Segment(
		                segment.anchor(),
		                segment.controlOut(),
		                segment.controlIn()
		            ));
		        }
	
		        return stackSegments;
		    }
		});
	
		var AreaChart = LineChart.extend({
		    createSegment: function(linePoints, currentSeries, seriesIx, prevSegment) {
		        var isStacked = this.options.isStacked;
		        var style = (currentSeries.line || {}).style;
		        var previousSegment;
	
		        var stackPoints;
		        if (isStacked && seriesIx > 0 && prevSegment) {
		            var missingValues = this.seriesMissingValues(currentSeries);
		            if (missingValues !== "gap") {
		                stackPoints = prevSegment.linePoints;
		                previousSegment = prevSegment;
		            } else {
		                stackPoints = this._gapStackPoints(linePoints, seriesIx, style);
		            }
		        }
	
		        var pointType;
		        if (style === STEP) {
		            pointType = StepAreaSegment;
		        } else if (style === SMOOTH) {
		            pointType = SplineAreaSegment;
		        } else {
		            pointType = AreaSegment;
		        }
	
		        return new pointType(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
		    },
	
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        LineChart.fn.reflow.call(this, targetBox);
	
		        var stackPoints = this._stackPoints;
		        if (stackPoints) {
		            for (var idx = 0; idx < stackPoints.length; idx++) {
		                var stackPoint = stackPoints[idx];
		                var pointSlot = this$1.categoryAxis.getSlot(stackPoint.categoryIx);
		                stackPoint.reflow(pointSlot);
		            }
		        }
		    },
	
		    _gapStackPoints: function(linePoints, seriesIx, style) {
		        var this$1 = this;
	
		        var seriesPoints = this.seriesPoints;
		        var startIdx = linePoints[0].categoryIx;
		        var length = linePoints.length;
		        if (startIdx < 0) {
		            startIdx = 0;
		            length--;
		        }
	
		        var endIdx = startIdx + length;
		        var pointOffset = this.seriesOptions[0]._outOfRangeMinPoint ? 1 : 0;
		        var stackPoints = [];
	
		        this._stackPoints = this._stackPoints || [];
		        for (var categoryIx = startIdx; categoryIx < endIdx; categoryIx++) {
		            var pointIx = categoryIx + pointOffset;
		            var currentSeriesIx = seriesIx;
		            var point = (void 0);
	
		            do {
		                currentSeriesIx--;
		                point = seriesPoints[currentSeriesIx][pointIx];
		            } while (currentSeriesIx > 0 && !point);
	
		            if (point) {
		                if (style !== STEP && categoryIx > startIdx && !seriesPoints[currentSeriesIx][pointIx - 1]) {
		                    stackPoints.push(this$1._previousSegmentPoint(categoryIx, pointIx, pointIx - 1, currentSeriesIx));
		                }
	
		                stackPoints.push(point);
	
		                if (style !== STEP && categoryIx + 1 < endIdx && !seriesPoints[currentSeriesIx][pointIx + 1]) {
		                    stackPoints.push(this$1._previousSegmentPoint(categoryIx, pointIx, pointIx + 1, currentSeriesIx));
		                }
		            } else {
		                var gapStackPoint = this$1._createGapStackPoint(categoryIx);
		                this$1._stackPoints.push(gapStackPoint);
		                stackPoints.push(gapStackPoint);
		            }
		        }
	
		        return stackPoints;
		    },
	
		    _previousSegmentPoint: function(categoryIx, pointIx, segmentIx, seriesIdx) {
		        var seriesPoints = this.seriesPoints;
		        var index = seriesIdx;
		        var point;
	
		        while (index > 0 && !point) {
		            index--;
		            point = seriesPoints[index][segmentIx];
		        }
	
		        if (!point) {
		            point = this._createGapStackPoint(categoryIx);
		            this._stackPoints.push(point);
		        } else {
		            point = seriesPoints[index][pointIx];
		        }
	
		        return point;
		    },
	
		    _createGapStackPoint: function(categoryIx) {
		        var options = this.pointOptions({}, 0);
		        var point = new LinePoint(0, options);
		        point.categoryIx = categoryIx;
		        point.series = {};
	
		        return point;
		    },
	
		    seriesMissingValues: function(series) {
		        return series.missingValues || ZERO;
		    }
		});
	
		var AxisGroupRangeTracker = Class.extend({
		    init: function() {
	
		        this.axisRanges = {};
		    },
	
		    update: function(chartAxisRanges) {
		        var axisRanges = this.axisRanges;
	
		        for (var axisName in chartAxisRanges) {
		            var chartRange = chartAxisRanges[axisName];
		            var range = axisRanges[axisName];
		            axisRanges[axisName] = range = range || { min: MAX_VALUE, max: MIN_VALUE };
	
		            range.min = Math.min(range.min, chartRange.min);
		            range.max = Math.max(range.max, chartRange.max);
		        }
		    },
	
		    reset: function(axisName) {
		        this.axisRanges[axisName] = undefined;
		    },
	
		    query: function(axisName) {
		        return this.axisRanges[axisName];
		    }
		});
	
		var BarLabel = ChartElement.extend({
		    init: function(content, options, pointData) {
		        ChartElement.fn.init.call(this, options);
	
		        this.textBox = new TextBox(content, this.options, pointData);
		        this.append(this.textBox);
		    },
	
		    createVisual: function() {
		        this.textBox.options.noclip = this.options.noclip;
		    },
	
		    reflow: function(targetBox) {
		        var options = this.options;
		        var vertical = options.vertical;
		        var aboveAxis = options.aboveAxis;
		        var text = this.children[0];
		        var textOptions = text.options;
		        var box = text.box;
		        var padding = text.options.padding;
		        var labelBox = targetBox;
	
		        textOptions.align = vertical ? CENTER : LEFT;
		        textOptions.vAlign = vertical ? TOP : CENTER;
	
		        if (options.position === INSIDE_END) {
		            if (vertical) {
		                textOptions.vAlign = TOP;
	
		                if (!aboveAxis && box.height() < targetBox.height()) {
		                    textOptions.vAlign = BOTTOM;
		                }
		            } else {
		                textOptions.align = aboveAxis ? RIGHT : LEFT;
		            }
		        } else if (options.position === CENTER) {
		            textOptions.vAlign = CENTER;
		            textOptions.align = CENTER;
		        } else if (options.position === INSIDE_BASE) {
		            if (vertical) {
		                textOptions.vAlign = aboveAxis ? BOTTOM : TOP;
		            } else {
		                textOptions.align = aboveAxis ? LEFT : RIGHT;
		            }
		        } else if (options.position === OUTSIDE_END) {
		            if (vertical) {
		                if (aboveAxis) {
		                    labelBox = new Box(
		                        targetBox.x1, targetBox.y1 - box.height(),
		                        targetBox.x2, targetBox.y1
		                    );
		                } else {
		                    labelBox = new Box(
		                        targetBox.x1, targetBox.y2,
		                        targetBox.x2, targetBox.y2 + box.height()
		                    );
		                }
		            } else {
		                textOptions.align = CENTER;
		                if (aboveAxis) {
		                    labelBox = new Box(
		                        targetBox.x2, targetBox.y1,
		                        targetBox.x2 + box.width(), targetBox.y2
		                    );
		                } else {
		                    labelBox = new Box(
		                        targetBox.x1 - box.width(), targetBox.y1,
		                        targetBox.x1, targetBox.y2
		                    );
		                }
		            }
		        }
	
		        if (!options.rotation) {
		            if (vertical) {
		                padding.left = padding.right =
		                    (labelBox.width() - text.contentBox.width()) / 2;
		            } else {
		                padding.top = padding.bottom =
		                    (labelBox.height() - text.contentBox.height()) / 2;
		            }
		        }
	
		        text.reflow(labelBox);
		    },
	
		    alignToClipBox: function(clipBox) {
		        var vertical = this.options.vertical;
		        var field = vertical ? Y : X;
		        var start = field + "1";
		        var end = field + "2";
		        var text = this.children[0];
		        var parentBox = this.parent.box;
	
		        if (parentBox[start] < clipBox[start] || clipBox[end] < parentBox[end]) {
		            var targetBox = text.paddingBox.clone();
		            targetBox[start] = Math.max(parentBox[start], clipBox[start]);
		            targetBox[end] = Math.min(parentBox[end], clipBox[end]);
	
		            this.reflow(targetBox);
		        }
		    }
		});
	
		setDefaultOptions(BarLabel, {
		    position: OUTSIDE_END,
		    margin: getSpacing(3),
		    padding: getSpacing(4),
		    color: BLACK,
		    background: "",
		    border: {
		        width: 1,
		        color: ""
		    },
		    aboveAxis: true,
		    vertical: false,
		    animation: {
		        type: FADEIN,
		        delay: INITIAL_ANIMATION_DURATION
		    },
		    zIndex: 2
		});
	
		function hasGradientOverlay(options) {
		    var overlay = options.overlay;
	
		    return overlay && overlay.gradient && overlay.gradient !== "none";
		}
	
		var BAR_ALIGN_MIN_WIDTH = 6;
	
		var Bar = ChartElement.extend({
		    init: function(value, options) {
		        ChartElement.fn.init.call(this);
	
		        this.options = options;
		        this.color = options.color || WHITE;
		        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
		        this.value = value;
		    },
	
		    render: function() {
		        if (this._rendered) {
		            return;
		        }
	
		        this._rendered = true;
	
		        this.createLabel();
		        this.createNote();
	
		        if (this.errorBar) {
		            this.append(this.errorBar);
		        }
		    },
	
		    createLabel: function() {
		        var options = this.options;
		        var labels = options.labels;
	
		        if (labels.visible) {
		            var pointData = this.pointData();
		            var labelTemplate = getTemplate(labels);
		            var labelText;
	
		            if (labelTemplate) {
		                labelText = labelTemplate(pointData);
		            } else {
		                labelText = this.formatValue(labels.format);
		            }
	
		            this.label = new BarLabel(labelText,
		                deepExtend({
		                    vertical: options.vertical
		                },
		                labels
		            ), pointData);
		            this.append(this.label);
		        }
		    },
	
		    formatValue: function(format) {
		        return this.owner.formatPointValue(this, format);
		    },
	
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        this.render();
	
		        var label = this.label;
	
		        this.box = targetBox;
	
		        if (label) {
		            label.options.aboveAxis = this.aboveAxis;
		            label.reflow(targetBox);
		        }
	
		        if (this.note) {
		            this.note.reflow(targetBox);
		        }
	
		        if (this.errorBars) {
		            for (var i = 0; i < this.errorBars.length; i++) {
		                this$1.errorBars[i].reflow(targetBox);
		            }
		        }
		    },
	
		    createVisual: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var box = ref.box;
		        var options = ref.options;
		        var customVisual = options.visual;
	
		        if (this.visible !== false) {
		            ChartElement.fn.createVisual.call(this);
	
		            if (customVisual) {
		                var visual = this.rectVisual = customVisual({
		                    category: this.category,
		                    dataItem: this.dataItem,
		                    value: this.value,
		                    sender: this.getSender(),
		                    series: this.series,
		                    percentage: this.percentage,
		                    stackValue: this.stackValue,
		                    runningTotal: this.runningTotal,
		                    total: this.total,
		                    rect: box.toRect(),
		                    createVisual: function () {
		                        var group = new Group();
		                        this$1.createRect(group);
		                        return group;
		                    },
		                    options: options
		                });
	
		                if (visual) {
		                    this.visual.append(visual);
		                }
		            } else if (box.width() > 0 && box.height() > 0) {
		                this.createRect(this.visual);
		            }
		        }
		    },
	
		    createRect: function(visual) {
		        var options = this.options;
		        var border = options.border;
		        var strokeOpacity = defined(border.opacity) ? border.opacity : options.opacity;
		        var rect = this.box.toRect();
	
		        rect.size.width = Math.round(rect.size.width);
	
		        var path = this.rectVisual = Path.fromRect(rect, {
		            fill: {
		                color: this.color,
		                opacity: options.opacity
		            },
		            stroke: {
		                color: this.getBorderColor(),
		                width: border.width,
		                opacity: strokeOpacity,
		                dashType: border.dashType
		            }
		        });
	
		        var width = this.box.width();
		        var height = this.box.height();
	
		        var size = options.vertical ? width : height;
	
		        if (size > BAR_ALIGN_MIN_WIDTH) {
		            alignPathToPixel(path);
	
		            // Fixes lineJoin issue in firefox when the joined lines are parallel
		            if (width < 1 || height < 1) {
		                path.options.stroke.lineJoin = "round";
		            }
		        }
	
		        visual.append(path);
	
		        if (hasGradientOverlay(options)) {
		            var overlay = this.createGradientOverlay(path, { baseColor: this.color }, deepExtend({
		                end: !options.vertical ? [ 0, 1 ] : undefined
		            }, options.overlay));
	
		            visual.append(overlay);
		        }
		    },
	
		    createHighlight: function(style) {
		        var highlight = Path.fromRect(this.box.toRect(), style);
	
		        return alignPathToPixel(highlight);
		    },
	
		    highlightVisual: function() {
		        return this.rectVisual;
		    },
	
		    highlightVisualArgs: function() {
		        return {
		            options: this.options,
		            rect: this.box.toRect(),
		            visual: this.rectVisual
		        };
		    },
	
		    getBorderColor: function() {
		        var color = this.color;
		        var border = this.options.border;
		        var brightness = border._brightness || BORDER_BRIGHTNESS;
		        var borderColor = border.color;
	
		        if (!defined(borderColor)) {
		            borderColor = new Color(color).brightness(brightness).toHex();
		        }
	
		        return borderColor;
		    },
	
		    tooltipAnchor: function() {
		        var ref = this;
		        var options = ref.options;
		        var box = ref.box;
		        var aboveAxis = ref.aboveAxis;
		        var clipBox = this.owner.pane.clipBox() || box;
		        var horizontalAlign = LEFT;
		        var verticalAlign = TOP;
		        var x, y;
	
		        if (options.vertical) {
		            x = Math.min(box.x2, clipBox.x2) + TOOLTIP_OFFSET;
		            if (aboveAxis) {
		                y = Math.max(box.y1, clipBox.y1);
		            } else {
		                y = Math.min(box.y2, clipBox.y2);
		                verticalAlign = BOTTOM;
		            }
		        } else {
		            var x1 = Math.max(box.x1, clipBox.x1);
		            var x2 = Math.min(box.x2, clipBox.x2);
	
		            if (options.isStacked) {
		                verticalAlign = BOTTOM;
		                if (aboveAxis) {
		                    horizontalAlign = RIGHT;
		                    x = x2;
		                } else {
		                    x = x1;
		                }
		                y = Math.max(box.y1, clipBox.y1) - TOOLTIP_OFFSET;
		            } else {
		                if (aboveAxis) {
		                    x = x2 + TOOLTIP_OFFSET;
		                } else {
		                    x = x1 - TOOLTIP_OFFSET;
		                    horizontalAlign = RIGHT;
		                }
		                y = Math.max(box.y1, clipBox.y1);
		            }
		        }
	
		        return {
		            point: new Point(x, y),
		            align: {
		                horizontal: horizontalAlign,
		                vertical: verticalAlign
		            }
		        };
		    },
	
		    overlapsBox: function(box) {
		        return this.box.overlaps(box);
		    },
	
		    pointData: function() {
		        return {
		            dataItem: this.dataItem,
		            category: this.category,
		            value: this.value,
		            percentage: this.percentage,
		            stackValue: this.stackValue,
		            runningTotal: this.runningTotal,
		            total: this.total,
		            series: this.series
		        };
		    }
		});
	
		deepExtend(Bar.prototype, PointEventsMixin);
		deepExtend(Bar.prototype, NoteMixin);
	
		Bar.prototype.defaults = {
		    border: {
		        width: 1
		    },
		    vertical: true,
		    overlay: {
		        gradient: "glass"
		    },
		    labels: {
		        visible: false,
		        format: "{0}"
		    },
		    opacity: 1,
		    notes: {
		        label: {}
		    }
		};
	
		function forEach(elements, callback) {
		    elements.forEach(callback);
		}
	
		function forEachReverse(elements, callback) {
		    var length = elements.length;
	
		    for (var idx = length - 1; idx >= 0; idx--) {
		        callback(elements[idx], idx - length - 1);
		    }
		}
	
		var ClusterLayout = ChartElement.extend({
		    init: function(options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.forEach = options.rtl ? forEachReverse : forEach;
		    },
	
		    reflow: function(box) {
		        var ref = this.options;
		        var vertical = ref.vertical;
		        var gap = ref.gap;
		        var spacing = ref.spacing;
		        var children = this.children;
		        var count = children.length;
		        var axis = vertical ? Y : X;
		        var slots = count + gap + (spacing * (count - 1));
		        var slotSize = (vertical ? box.height() : box.width()) / slots;
		        var position = box[axis + 1] + slotSize * (gap / 2);
	
		        this.forEach(children, function (child, idx) {
		            var childBox = (child.box || box).clone();
	
		            childBox[axis + 1] = position;
		            childBox[axis + 2] = position + slotSize;
	
		            child.reflow(childBox);
		            if (idx < count - 1) {
		                position += (slotSize * spacing);
		            }
	
		            position += slotSize;
		        });
		    }
		});
	
		setDefaultOptions(ClusterLayout, {
		    vertical: false,
		    gap: 0,
		    spacing: 0
		});
	
		var StackWrap = ChartElement.extend({
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        var positionAxis = this.options.vertical ? X : Y;
		        var children = this.children;
		        var childrenCount = children.length;
		        var box = this.box = new Box();
	
		        for (var i = 0; i < childrenCount; i++) {
		            var currentChild = children[i];
	
		            if (currentChild.visible !== false) {
		                var childBox = currentChild.box.clone();
		                childBox.snapTo(targetBox, positionAxis);
	
		                if (i === 0) {
		                    box = this$1.box = childBox.clone();
		                }
	
		                currentChild.reflow(childBox);
		                box.wrap(childBox);
		            }
		        }
		    }
		});
	
		setDefaultOptions(StackWrap, {
		    vertical: true
		});
	
		var BarChart = CategoricalChart.extend({
		    render: function() {
		        CategoricalChart.fn.render.call(this);
		        this.updateStackRange();
		    },
	
		    pointType: function() {
		        return Bar;
		    },
	
		    clusterType: function() {
		        return ClusterLayout;
		    },
	
		    stackType: function() {
		        return StackWrap;
		    },
	
		    stackLimits: function(axisName, stackName) {
		        var limits = CategoricalChart.fn.stackLimits.call(this, axisName, stackName);
	
		        return limits;
		    },
	
		    createPoint: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var category = fields.category;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var ref = this;
		        var options = ref.options;
		        var children = ref.children;
		        var isStacked = options.isStacked;
		        var value = this.pointValue(data);
		        var pointOptions = this.pointOptions(series, seriesIx);
	
		        var labelOptions = pointOptions.labels;
		        if (isStacked) {
		            if (labelOptions.position === OUTSIDE_END) {
		                labelOptions.position = INSIDE_END;
		            }
		        }
	
		        pointOptions.isStacked = isStacked;
	
		        var color = data.fields.color || series.color;
		        if (value < 0 && pointOptions.negativeColor) {
		            color = pointOptions.negativeColor;
		        }
	
		        pointOptions = this.evalPointOptions(
		            pointOptions, value, category, categoryIx, series, seriesIx
		        );
	
		        if (isFunction(series.color)) {
		            color = pointOptions.color;
		        }
	
		        var pointType = this.pointType();
		        var point = new pointType(value, pointOptions);
		        point.color = color;
	
		        var cluster = children[categoryIx];
		        if (!cluster) {
		            var clusterType = this.clusterType();
		            cluster = new clusterType({
		                vertical: options.invertAxes,
		                gap: options.gap,
		                spacing: options.spacing,
		                rtl: !options.invertAxes && (this.chartService || {}).rtl
		            });
		            this.append(cluster);
		        }
	
		        if (isStacked) {
		            var stackWrap = this.getStackWrap(series, cluster);
		            stackWrap.append(point);
		        } else {
		            cluster.append(point);
		        }
	
		        return point;
		    },
	
		    getStackWrap: function(series, cluster) {
		        var stack = series.stack;
		        var stackGroup = stack ? stack.group || stack : stack;
		        var wraps = cluster.children;
		        var stackWrap;
	
		        if (typeof stackGroup === datavizConstants.STRING) {
		            for (var i = 0; i < wraps.length; i++) {
		                if (wraps[i]._stackGroup === stackGroup) {
		                    stackWrap = wraps[i];
		                    break;
		                }
		            }
		        } else {
		            stackWrap = wraps[0];
		        }
	
		        if (!stackWrap) {
		            var stackType = this.stackType();
		            stackWrap = new stackType({
		                vertical: !this.options.invertAxes
		            });
		            stackWrap._stackGroup = stackGroup;
		            cluster.append(stackWrap);
		        }
	
		        return stackWrap;
		    },
	
		    categorySlot: function(categoryAxis, categoryIx, valueAxis) {
		        var options = this.options;
		        var categorySlot = categoryAxis.getSlot(categoryIx);
		        var startValue = valueAxis.startValue();
	
		        if (options.isStacked) {
		            var zeroSlot = valueAxis.getSlot(startValue, startValue, true);
		            var stackAxis = options.invertAxes ? X : Y;
		            categorySlot[stackAxis + 1] = categorySlot[stackAxis + 2] = zeroSlot[stackAxis + 1];
		        }
	
		        return categorySlot;
		    },
	
		    reflowCategories: function(categorySlots) {
		        var children = this.children;
		        var childrenLength = children.length;
	
		        for (var i = 0; i < childrenLength; i++) {
		            children[i].reflow(categorySlots[i]);
		        }
		    },
	
		    createAnimation: function() {
		        this._setAnimationOptions();
		        CategoricalChart.fn.createAnimation.call(this);
	
		        if (anyHasZIndex(this.options.series)) {
		            this._setChildrenAnimation();
		        }
		    },
	
		    _setChildrenAnimation: function() {
		        var this$1 = this;
	
		        var points = this.points;
	
		        for (var idx = 0; idx < points.length; idx++) {
		            var point = points[idx];
		            var pointVisual = point.visual;
		            if (pointVisual && defined(pointVisual.options.zIndex)) {
		                point.options.animation = this$1.options.animation;
		                point.createAnimation();
		            }
		        }
		    },
	
		    _setAnimationOptions: function() {
		        var options = this.options;
		        var animation = options.animation || {};
		        var origin;
	
		        if (options.isStacked) {
		            var valueAxis = this.seriesValueAxis(options.series[0]);
		            origin = valueAxis.getSlot(valueAxis.startValue());
		        } else {
		            origin = this.categoryAxis.getSlot(0);
		        }
	
		        animation.origin = new GeometryPoint(origin.x1, origin.y1);
		        animation.vertical = !options.invertAxes;
		    }
		});
	
		setDefaultOptions(BarChart, {
		    animation: {
		        type: BAR
		    }
		});
	
		var Candlestick = ChartElement.extend({
		    init: function(value, options) {
		        ChartElement.fn.init.call(this, options);
		        this.value = value;
		    },
	
		    reflow: function(box) {
		        var ref = this;
		        var options = ref.options;
		        var value = ref.value;
		        var chart = ref.owner;
		        var valueAxis = chart.seriesValueAxis(options);
		        var ocSlot = valueAxis.getSlot(value.open, value.close);
		        var lhSlot = valueAxis.getSlot(value.low, value.high);
	
		        ocSlot.x1 = lhSlot.x1 = box.x1;
		        ocSlot.x2 = lhSlot.x2 = box.x2;
	
		        this.realBody = ocSlot;
	
		        var mid = lhSlot.center().x;
		        var points = [];
	
		        points.push([ [ mid, lhSlot.y1 ], [ mid, ocSlot.y1 ] ]);
		        points.push([ [ mid, ocSlot.y2 ], [ mid, lhSlot.y2 ] ]);
	
		        this.lines = points;
	
		        this.box = lhSlot.clone().wrap(ocSlot);
	
		        if (!this._rendered) {
		            this._rendered = true;
		            this.createNote();
		        }
	
		        this.reflowNote();
		    },
	
		    reflowNote: function() {
		        if (this.note) {
		            this.note.reflow(this.box);
		        }
		    },
	
		    createVisual: function() {
		        ChartElement.fn.createVisual.call(this);
		        this._mainVisual = this.mainVisual(this.options);
		        this.visual.append(
		            this._mainVisual
		        );
	
		        this.createOverlay();
		    },
	
		    mainVisual: function(options) {
		        var group = new Group();
	
		        this.createBody(group, options);
		        this.createLines(group, options);
	
		        return group;
		    },
	
		    createBody: function(container, options) {
		        var body = Path.fromRect(this.realBody.toRect(), {
		            fill: {
		                color: this.color,
		                opacity: options.opacity
		            },
		            stroke: null
		        });
	
		        if (options.border.width > 0) {
		            body.options.set("stroke", {
		                color: this.getBorderColor(),
		                width: options.border.width,
		                dashType: options.border.dashType,
		                opacity: valueOrDefault(options.border.opacity, options.opacity)
		            });
		        }
	
		        alignPathToPixel(body);
		        container.append(body);
	
		        if (hasGradientOverlay(options)) {
		            container.append(this.createGradientOverlay(body, { baseColor: this.color }, deepExtend({
		                end: !options.vertical ? [ 0, 1 ] : undefined
		            }, options.overlay)));
		        }
		    },
	
		    createLines: function(container, options) {
		        this.drawLines(container, options, this.lines, options.line);
		    },
	
		    drawLines: function(container, options, lines, lineOptions) {
		        if (!lines) {
		            return;
		        }
	
		        var lineStyle = {
		            stroke: {
		                color: lineOptions.color || this.color,
		                opacity: valueOrDefault(lineOptions.opacity, options.opacity),
		                width: lineOptions.width,
		                dashType: lineOptions.dashType,
		                lineCap: "butt"
		            }
		        };
	
		        for (var i = 0; i < lines.length; i++) {
		            var line = Path.fromPoints(lines[i], lineStyle);
		            alignPathToPixel(line);
		            container.append(line);
		        }
		    },
	
		    getBorderColor: function() {
		        var border = this.options.border;
		        var borderColor = border.color;
	
		        if (!defined(borderColor)) {
		            borderColor = new Color(this.color).brightness(border._brightness).toHex();
		        }
	
		        return borderColor;
		    },
	
		    createOverlay: function() {
		        var overlay = Path.fromRect(this.box.toRect(), {
		            fill: {
		                color: WHITE,
		                opacity: 0
		            },
		            stroke: null
		        });
	
		        this.visual.append(overlay);
		    },
	
		    createHighlight: function() {
		        var highlight = this.options.highlight;
		        var normalColor = this.color;
	
		        this.color = highlight.color || this.color;
		        var overlay = this.mainVisual(
		            deepExtend({}, this.options, {
		                line: {
		                    color: this.getBorderColor()
		                }
		            }, highlight)
		        );
		        this.color = normalColor;
	
		        return overlay;
		    },
	
		    highlightVisual: function() {
		        return this._mainVisual;
		    },
	
		    highlightVisualArgs: function() {
		        return {
		            options: this.options,
		            rect: this.box.toRect(),
		            visual: this._mainVisual
		        };
		    },
	
		    tooltipAnchor: function() {
		        var box = this.box;
		        var clipBox = this.owner.pane.clipBox() || box;
	
		        return {
		            point: new Point(box.x2 + TOOLTIP_OFFSET, Math.max(box.y1, clipBox.y1) + TOOLTIP_OFFSET),
		            align: {
		                horizontal: LEFT,
		                vertical: TOP
		            }
		        };
		    },
	
		    formatValue: function(format) {
		        return this.owner.formatPointValue(this, format);
		    },
	
		    overlapsBox: function(box) {
		        return this.box.overlaps(box);
		    }
		});
	
		setDefaultOptions(Candlestick, {
		    vertical: true,
		    border: {
		        _brightness: 0.8
		    },
		    line: {
		        width: 2
		    },
		    overlay: {
		        gradient: "glass"
		    },
		    tooltip: {
		        format: "<table>" +
		                    "<tr><th colspan='2'>{4:d}</th></tr>" +
		                    "<tr><td>Open:</td><td>{0:C}</td></tr>" +
		                    "<tr><td>High:</td><td>{1:C}</td></tr>" +
		                    "<tr><td>Low:</td><td>{2:C}</td></tr>" +
		                    "<tr><td>Close:</td><td>{3:C}</td></tr>" +
		                "</table>"
		    },
		    highlight: {
		        opacity: 1,
		        border: {
		            width: 1,
		            opacity: 1
		        },
		        line: {
		            width: 1,
		            opacity: 1
		        }
		    },
		    notes: {
		        visible: true,
		        label: {}
		    }
		});
	
		deepExtend(Candlestick.prototype, PointEventsMixin);
		deepExtend(Candlestick.prototype, NoteMixin);
	
		function areNumbers(values) {
		    return countNumbers(values) === values.length;
		}
	
		var CandlestickChart = CategoricalChart.extend({
		    reflowCategories: function(categorySlots) {
		        var children = this.children;
		        var childrenLength = children.length;
	
		        for (var i = 0; i < childrenLength; i++) {
		            children[i].reflow(categorySlots[i]);
		        }
		    },
	
		    addValue: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var category = fields.category;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var ref = this;
		        var children = ref.children;
		        var options = ref.options;
		        var value = data.valueFields;
		        var valueParts = this.splitValue(value);
		        var hasValue = areNumbers(valueParts);
		        var dataItem = series.data[categoryIx];
		        var categoryPoints = this.categoryPoints[categoryIx];
		        var point;
	
		        if (!categoryPoints) {
		            this.categoryPoints[categoryIx] = categoryPoints = [];
		        }
	
		        if (hasValue) {
		            point = this.createPoint(data, fields);
		        }
	
		        var cluster = children[categoryIx];
		        if (!cluster) {
		            cluster = new ClusterLayout({
		                vertical: options.invertAxes,
		                gap: options.gap,
		                spacing: options.spacing,
		                rtl: !options.invertAxes && (this.chartService || {}).rtl
		            });
		            this.append(cluster);
		        }
	
		        if (point) {
		            this.updateRange(value, fields);
	
		            cluster.append(point);
	
		            point.categoryIx = categoryIx;
		            point.category = category;
		            point.series = series;
		            point.seriesIx = seriesIx;
		            point.owner = this;
		            point.dataItem = dataItem;
		            point.noteText = data.fields.noteText;
		        }
	
		        this.points.push(point);
		        categoryPoints.push(point);
		    },
	
		    pointType: function() {
		        return Candlestick;
		    },
	
		    createPoint: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var category = fields.category;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var pointType = this.pointType();
		        var value = data.valueFields;
		        var pointOptions = deepExtend({}, series);
		        var color = data.fields.color || series.color;
	
		        pointOptions = this.evalPointOptions(
		            pointOptions, value, category, categoryIx, series, seriesIx
		        );
	
		        if (series.type === CANDLESTICK) {
		            if (value.open > value.close) {
		                color = data.fields.downColor || series.downColor || series.color;
		            }
		        }
	
		        if (isFunction(series.color)) {
		            color = pointOptions.color;
		        }
	
		        pointOptions.vertical = !this.options.invertAxes;
	
		        var point = new pointType(value, pointOptions);
		        point.color = color;
	
		        return point;
		    },
	
		    splitValue: function(value) {
		        return [ value.low, value.open, value.close, value.high ];
		    },
	
		    updateRange: function(value, fields) {
		        var axisName = fields.series.axis;
		        var parts = this.splitValue(value);
		        var axisRange = this.valueAxisRanges[axisName];
	
		        axisRange = this.valueAxisRanges[axisName] =
		            axisRange || { min: MAX_VALUE, max: MIN_VALUE };
	
		        axisRange = this.valueAxisRanges[axisName] = {
		            min: Math.min.apply(Math, parts.concat([ axisRange.min ])),
		            max: Math.max.apply(Math, parts.concat([ axisRange.max ]))
		        };
		    },
	
		    formatPointValue: function(point, format) {
		        var value = point.value;
	
		        return this.chartService.format.auto(format,
		            value.open, value.high,
		            value.low, value.close, point.category
		        );
		    },
	
		    animationPoints: function() {
		        return this.points;
		    }
		});
	
		deepExtend(CandlestickChart.prototype, ClipAnimationMixin);
	
		var BoxPlot = Candlestick.extend({
		    init: function(value, options) {
		        Candlestick.fn.init.call(this, value, options);
	
		        this.createNote();
		    },
	
		    reflow: function(box) {
		        var ref = this;
		        var options = ref.options;
		        var value = ref.value;
		        var chart = ref.owner;
		        var valueAxis = chart.seriesValueAxis(options);
		        var whiskerSlot, boxSlot;
	
		        this.boxSlot = boxSlot = valueAxis.getSlot(value.q1, value.q3);
		        this.realBody = boxSlot;
		        this.reflowBoxSlot(box);
	
		        this.whiskerSlot = whiskerSlot = valueAxis.getSlot(value.lower, value.upper);
		        this.reflowWhiskerSlot(box);
	
		        var medianSlot = valueAxis.getSlot(value.median);
	
		        if (value.mean) {
		            var meanSlot = valueAxis.getSlot(value.mean);
		            this.meanPoints = this.calcMeanPoints(box, meanSlot);
		        }
	
		        this.whiskerPoints = this.calcWhiskerPoints(boxSlot, whiskerSlot);
		        this.medianPoints = this.calcMedianPoints(box, medianSlot);
	
		        this.box = whiskerSlot.clone().wrap(boxSlot);
		        this.reflowNote();
		    },
	
		    reflowBoxSlot: function(box) {
		        this.boxSlot.x1 = box.x1;
		        this.boxSlot.x2 = box.x2;
		    },
	
		    reflowWhiskerSlot: function(box) {
		        this.whiskerSlot.x1 = box.x1;
		        this.whiskerSlot.x2 = box.x2;
		    },
	
		    calcMeanPoints: function(box, meanSlot) {
		        return [
		            [ [ box.x1, meanSlot.y1 ], [ box.x2, meanSlot.y1 ] ]
		        ];
		    },
	
		    calcWhiskerPoints: function(boxSlot, whiskerSlot) {
		        var mid = whiskerSlot.center().x;
		        return [ [
		            [ mid - 5, whiskerSlot.y1 ], [ mid + 5, whiskerSlot.y1 ],
		            [ mid, whiskerSlot.y1 ], [ mid, boxSlot.y1 ]
		        ], [
		            [ mid - 5, whiskerSlot.y2 ], [ mid + 5, whiskerSlot.y2 ],
		            [ mid, whiskerSlot.y2 ], [ mid, boxSlot.y2 ]
		        ] ];
		    },
	
		    calcMedianPoints: function(box, medianSlot) {
		        return [
		            [ [ box.x1, medianSlot.y1 ], [ box.x2, medianSlot.y1 ] ]
		        ];
		    },
	
		    renderOutliers: function(options) {
		        var this$1 = this;
	
		        var value = this.value;
		        var outliers = value.outliers || [];
		        var outerFence = Math.abs(value.q3 - value.q1) * 3;
		        var elements = [];
		        var markers = options.markers || {};
	
		        for (var i = 0; i < outliers.length; i++) {
		            var outlierValue = outliers[i];
		            if (outlierValue < value.q3 + outerFence && outlierValue > value.q1 - outerFence) {
		                markers = options.outliers;
		            } else {
		                markers = options.extremes;
		            }
		            var markersBorder = deepExtend({}, markers.border);
	
		            if (!defined(markersBorder.color)) {
		                if (defined(this$1.color)) {
		                    markersBorder.color = this$1.color;
		                } else {
		                    markersBorder.color =
		                        new Color(markers.background).brightness(BORDER_BRIGHTNESS).toHex();
		                }
		            }
	
		            var shape = new ShapeElement({
		                type: markers.type,
		                width: markers.size,
		                height: markers.size,
		                rotation: markers.rotation,
		                background: markers.background,
		                border: markersBorder,
		                opacity: markers.opacity
		            });
	
		            shape.value = outlierValue;
	
		            elements.push(shape);
		        }
	
		        this.reflowOutliers(elements);
		        return elements;
		    },
	
		    reflowOutliers: function(outliers) {
		        var this$1 = this;
	
		        var valueAxis = this.owner.seriesValueAxis(this.options);
		        var center = this.box.center();
	
		        for (var i = 0; i < outliers.length; i++) {
		            var outlierValue = outliers[i].value;
		            var markerBox = valueAxis.getSlot(outlierValue);
	
		            if (this$1.options.vertical) {
		                markerBox.move(center.x);
		            } else {
		                markerBox.move(undefined, center.y);
		            }
	
		            this$1.box = this$1.box.wrap(markerBox);
		            outliers[i].reflow(markerBox);
		        }
		    },
	
		    mainVisual: function(options) {
		        var group = Candlestick.fn.mainVisual.call(this, options);
		        var outliers = this.renderOutliers(options);
	
		        for (var i = 0; i < outliers.length; i++) {
		            var element = outliers[i].getElement();
		            if (element) {
		                group.append(element);
		            }
		        }
	
		        return group;
		    },
	
		    createLines: function(container, options) {
		        this.drawLines(container, options, this.whiskerPoints, options.whiskers);
		        this.drawLines(container, options, this.medianPoints, options.median);
		        this.drawLines(container, options, this.meanPoints, options.mean);
		    },
	
		    getBorderColor: function() {
		        if (this.color) {
		            return this.color;
		        }
	
		        return Candlestick.fn.getBorderColor.call(this);
		    }
		});
	
		setDefaultOptions(BoxPlot, {
		    border: {
		        _brightness: 0.8
		    },
		    line: {
		        width: 2
		    },
		    median: {
		        color: "#f6f6f6"
		    },
		    mean: {
		        width: 2,
		        dashType: "dash",
		        color: "#f6f6f6"
		    },
		    overlay: {
		        gradient: "glass"
		    },
		    tooltip: {
		        format: "<table>" +
		                    "<tr><th colspan='2'>{6:d}</th></tr>" +
		                    "<tr><td>Lower:</td><td>{0:C}</td></tr>" +
		                    "<tr><td>Q1:</td><td>{1:C}</td></tr>" +
		                    "<tr><td>Median:</td><td>{2:C}</td></tr>" +
		                    "<tr><td>Mean:</td><td>{5:C}</td></tr>" +
		                    "<tr><td>Q3:</td><td>{3:C}</td></tr>" +
		                    "<tr><td>Upper:</td><td>{4:C}</td></tr>" +
		                "</table>"
		    },
		    highlight: {
		        opacity: 1,
		        border: {
		            width: 1,
		            opacity: 1
		        },
		        line: {
		            width: 1,
		            opacity: 1
		        }
		    },
		    notes: {
		        visible: true,
		        label: {}
		    },
		    outliers: {
		        visible: true,
		        size: LINE_MARKER_SIZE,
		        type: datavizConstants.CROSS,
		        background: WHITE,
		        border: {
		            width: 2,
		            opacity: 1
		        },
		        opacity: 0
		    },
		    extremes: {
		        visible: true,
		        size: LINE_MARKER_SIZE,
		        type: CIRCLE,
		        background: WHITE,
		        border: {
		            width: 2,
		            opacity: 1
		        },
		        opacity: 0
		    }
		});
	
		deepExtend(BoxPlot.prototype, PointEventsMixin);
	
		var VerticalBoxPlot = BoxPlot.extend({
		    reflowBoxSlot: function(box) {
		        this.boxSlot.y1 = box.y1;
		        this.boxSlot.y2 = box.y2;
		    },
	
		    reflowWhiskerSlot: function(box) {
		        this.whiskerSlot.y1 = box.y1;
		        this.whiskerSlot.y2 = box.y2;
		    },
	
		    calcMeanPoints: function(box, meanSlot) {
		        return [
		            [ [ meanSlot.x1, box.y1 ], [ meanSlot.x1, box.y2 ] ]
		        ];
		    },
	
		    calcWhiskerPoints: function(boxSlot, whiskerSlot) {
		        var mid = whiskerSlot.center().y;
		        return [ [
		            [ whiskerSlot.x1, mid - 5 ], [ whiskerSlot.x1, mid + 5 ],
		            [ whiskerSlot.x1, mid ], [ boxSlot.x1, mid ]
		        ], [
		            [ whiskerSlot.x2, mid - 5 ], [ whiskerSlot.x2, mid + 5 ],
		            [ whiskerSlot.x2, mid ], [ boxSlot.x2, mid ]
		        ] ];
		    },
	
		    calcMedianPoints: function(box, medianSlot) {
		        return [
		            [ [ medianSlot.x1, box.y1 ], [ medianSlot.x1, box.y2 ] ]
		        ];
		    }
		});
	
		var BoxPlotChart = CandlestickChart.extend({
		    addValue: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var category = fields.category;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var ref = this;
		        var children = ref.children;
		        var options = ref.options;
		        var value = data.valueFields;
		        var valueParts = this.splitValue(value);
		        var hasValue = areNumbers(valueParts);
		        var dataItem = series.data[categoryIx];
		        var categoryPoints = this.categoryPoints[categoryIx];
		        var point;
	
		        if (!categoryPoints) {
		            this.categoryPoints[categoryIx] = categoryPoints = [];
		        }
	
		        if (hasValue) {
		            point = this.createPoint(data, fields);
		        }
	
		        var cluster = children[categoryIx];
		        if (!cluster) {
		            cluster = new ClusterLayout({
		                vertical: options.invertAxes,
		                gap: options.gap,
		                spacing: options.spacing,
		                rtl: !options.invertAxes && (this.chartService || {}).rtl
		            });
		            this.append(cluster);
		        }
	
		        if (point) {
		            this.updateRange(value, fields);
	
		            cluster.append(point);
	
		            point.categoryIx = categoryIx;
		            point.category = category;
		            point.series = series;
		            point.seriesIx = seriesIx;
		            point.owner = this;
		            point.dataItem = dataItem;
		        }
	
		        this.points.push(point);
		        categoryPoints.push(point);
		    },
	
		    pointType: function() {
		        if (this.options.invertAxes) {
		            return VerticalBoxPlot;
		        }
	
		        return BoxPlot;
		    },
	
		    splitValue: function(value) {
		        return [
		            value.lower, value.q1, value.median,
		            value.q3, value.upper
		        ];
		    },
	
		    updateRange: function(value, fields) {
		        var axisName = fields.series.axis;
		        var axisRange = this.valueAxisRanges[axisName];
		        var parts = this.splitValue(value).concat(this.filterOutliers(value.outliers));
	
		        if (defined(value.mean)) {
		            parts = parts.concat(value.mean);
		        }
	
		        axisRange = this.valueAxisRanges[axisName] =
		            axisRange || { min: MAX_VALUE, max: MIN_VALUE };
	
		        axisRange = this.valueAxisRanges[axisName] = {
		            min: Math.min.apply(Math, parts.concat([ axisRange.min ])),
		            max: Math.max.apply(Math, parts.concat([ axisRange.max ]))
		        };
		    },
	
		    formatPointValue: function(point, format) {
		        var value = point.value;
	
		        return this.chartService.format.auto(format,
		            value.lower, value.q1, value.median,
		            value.q3, value.upper, value.mean, point.category
		        );
		    },
	
		    filterOutliers: function(items) {
		        var length = (items || []).length;
		        var result = [];
	
		        for (var i = 0; i < length; i++) {
		            var item = items[i];
		            if (defined(item) && item !== null) {
		                result.push(item);
		            }
		        }
	
		        return result;
		    }
		});
	
		var ScatterErrorBar = ErrorBarBase.extend({
		    getAxis: function() {
		        var axes = this.chart.seriesAxes(this.series);
		        var axis = this.isVertical ? axes.y : axes.x;
	
		        return axis;
		    }
		});
	
		function hasValue(value) {
		    return defined(value) && value !== null;
		}
	
		var ScatterChart = ChartElement.extend({
		    init: function(plotArea, options) {
	
		        ChartElement.fn.init.call(this, options);
	
		        this.plotArea = plotArea;
		        this.chartService = plotArea.chartService;
		        this._initFields();
	
		        this.render();
		    },
	
		    _initFields: function() {
		        // X and Y axis ranges grouped by name, e.g.:
		        // primary: { min: 0, max: 1 }
		        this.xAxisRanges = {};
		        this.yAxisRanges = {};
	
		        this.points = [];
		        this.seriesPoints = [];
		        this.seriesOptions = [];
		        this._evalSeries = [];
		    },
	
		    render: function() {
		        this.traverseDataPoints(this.addValue.bind(this));
		    },
	
		    addErrorBar: function(point, field, fields) {
		        var value = point.value[field];
		        var valueErrorField = field + "Value";
		        var lowField = field + "ErrorLow";
		        var highField = field + "ErrorHigh";
		        var seriesIx = fields.seriesIx;
		        var series = fields.series;
		        var errorBars = point.options.errorBars;
		        var lowValue = fields[lowField];
		        var highValue = fields[highField];
	
		        if (isNumber(value)) {
		            var errorRange;
		            if (isNumber(lowValue) && isNumber(highValue)) {
		                errorRange = { low: lowValue, high: highValue };
		            }
	
		            if (errorBars && defined(errorBars[valueErrorField])) {
		                this.seriesErrorRanges = this.seriesErrorRanges || { x: [], y: [] };
		                this.seriesErrorRanges[field][seriesIx] = this.seriesErrorRanges[field][seriesIx] ||
		                    new ErrorRangeCalculator(errorBars[valueErrorField], series, field);
	
		                errorRange = this.seriesErrorRanges[field][seriesIx].getErrorRange(value, errorBars[valueErrorField]);
		            }
	
		            if (errorRange) {
		                this.addPointErrorBar(errorRange, point, field);
		            }
		        }
		    },
	
		    addPointErrorBar: function(errorRange, point, field) {
		        var low = errorRange.low;
		        var high = errorRange.high;
		        var series = point.series;
		        var options = point.options.errorBars;
		        var isVertical = field === Y;
		        var item = {};
	
		        point[field + "Low"] = low;
		        point[field + "High"] = high;
	
		        point.errorBars = point.errorBars || [];
		        var errorBar = new ScatterErrorBar(low, high, isVertical, this, series, options);
		        point.errorBars.push(errorBar);
		        point.append(errorBar);
	
		        item[field] = low;
		        this.updateRange(item, series);
		        item[field] = high;
		        this.updateRange(item, series);
		    },
	
		    addValue: function(value, fields) {
		        var x = value.x;
		        var y = value.y;
		        var seriesIx = fields.seriesIx;
		        var series = this.options.series[seriesIx];
		        var missingValues = this.seriesMissingValues(series);
		        var seriesPoints = this.seriesPoints[seriesIx];
	
		        var pointValue = value;
		        if (!(hasValue(x) && hasValue(y))) {
		            pointValue = this.createMissingValue(pointValue, missingValues);
		        }
	
		        var point;
		        if (pointValue) {
		            point = this.createPoint(pointValue, fields);
		            if (point) {
		                $.extend(point, fields);
		                this.addErrorBar(point, X, fields);
		                this.addErrorBar(point, Y, fields);
		            }
		            this.updateRange(pointValue, fields.series);
		        }
	
		        this.points.push(point);
		        seriesPoints.push(point);
		    },
	
		    seriesMissingValues: function(series) {
		        return series.missingValues;
		    },
	
		    createMissingValue: function() {},
	
		    updateRange: function(value, series) {
		        var intlService = this.chartService.intl;
		        var xAxisName = series.xAxis;
		        var yAxisName = series.yAxis;
		        var x = value.x;
		        var y = value.y;
		        var xAxisRange = this.xAxisRanges[xAxisName];
		        var yAxisRange = this.yAxisRanges[yAxisName];
	
		        if (hasValue(x)) {
		            xAxisRange = this.xAxisRanges[xAxisName] =
		                xAxisRange || { min: MAX_VALUE, max: MIN_VALUE };
	
		            if (isString(x)) {
		                x = parseDate(intlService, x);
		            }
	
		            xAxisRange.min = Math.min(xAxisRange.min, x);
		            xAxisRange.max = Math.max(xAxisRange.max, x);
		        }
	
		        if (hasValue(y)) {
		            yAxisRange = this.yAxisRanges[yAxisName] =
		                yAxisRange || { min: MAX_VALUE, max: MIN_VALUE };
	
		            if (isString(y)) {
		                y = parseDate(intlService, y);
		            }
	
		            yAxisRange.min = Math.min(yAxisRange.min, y);
		            yAxisRange.max = Math.max(yAxisRange.max, y);
		        }
		    },
	
		    evalPointOptions: function(options, value, fields) {
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var state = { defaults: series._defaults, excluded: [ "data", "tooltip", "content", "template", "visual", "toggle", "_outOfRangeMinPoint", "_outOfRangeMaxPoint" ] };
	
		        var doEval = this._evalSeries[seriesIx];
		        if (!defined(doEval)) {
		            this._evalSeries[seriesIx] = doEval = evalOptions(options, {}, state, true);
		        }
	
		        var pointOptions = options;
		        if (doEval) {
		            pointOptions = deepExtend({}, options);
		            evalOptions(pointOptions, {
		                value: value,
		                series: series,
		                dataItem: fields.dataItem
		            }, state);
		        }
	
		        return pointOptions;
		    },
	
		    pointType: function() {
		        return LinePoint;
		    },
	
		    pointOptions: function(series, seriesIx) {
		        var options = this.seriesOptions[seriesIx];
		        if (!options) {
		            var defaults = this.pointType().prototype.defaults;
		            this.seriesOptions[seriesIx] = options = deepExtend({}, defaults, {
		                markers: {
		                    opacity: series.opacity
		                },
		                tooltip: {
		                    format: this.options.tooltip.format
		                },
		                labels: {
		                    format: this.options.labels.format
		                }
		            }, series);
		        }
	
		        return options;
		    },
	
		    createPoint: function(value, fields) {
		        var series = fields.series;
		        var pointOptions = this.pointOptions(series, fields.seriesIx);
		        var color = fields.color || series.color;
	
		        pointOptions = this.evalPointOptions(pointOptions, value, fields);
	
		        if (isFunction(series.color)) {
		            color = pointOptions.color;
		        }
	
		        var point = new LinePoint(value, pointOptions);
		        point.color = color;
	
		        this.append(point);
	
		        return point;
		    },
	
		    seriesAxes: function(series) {
		        var xAxisName = series.xAxis;
		        var yAxisName = series.yAxis;
		        var plotArea = this.plotArea;
		        var xAxis = xAxisName ? plotArea.namedXAxes[xAxisName] : plotArea.axisX;
		        var yAxis = yAxisName ? plotArea.namedYAxes[yAxisName] : plotArea.axisY;
	
		        if (!xAxis) {
		            throw new Error("Unable to locate X axis with name " + xAxisName);
		        }
	
		        if (!yAxis) {
		            throw new Error("Unable to locate Y axis with name " + yAxisName);
		        }
	
		        return {
		            x: xAxis,
		            y: yAxis
		        };
		    },
	
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        var chartPoints = this.points;
		        var limit = !this.options.clip;
		        var pointIx = 0;
	
		        this.traverseDataPoints(function (value, fields) {
		            var point = chartPoints[pointIx++];
		            var seriesAxes = this$1.seriesAxes(fields.series);
		            var slotX = seriesAxes.x.getSlot(value.x, value.x, limit);
		            var slotY = seriesAxes.y.getSlot(value.y, value.y, limit);
	
		            if (point) {
		                if (slotX && slotY) {
		                    var pointSlot = this$1.pointSlot(slotX, slotY);
		                    point.reflow(pointSlot);
		                } else {
		                    point.visible = false;
		                }
		            }
		        });
	
		        this.box = targetBox;
		    },
	
		    pointSlot: function(slotX, slotY) {
		        return new Box(slotX.x1, slotY.y1, slotX.x2, slotY.y2);
		    },
	
		    traverseDataPoints: function(callback) {
		        var this$1 = this;
	
		        var ref = this;
		        var series = ref.options.series;
		        var seriesPoints = ref.seriesPoints;
	
		        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
		            var currentSeries = series[seriesIx];
		            var currentSeriesPoints = seriesPoints[seriesIx];
		            if (!currentSeriesPoints) {
		                seriesPoints[seriesIx] = [];
		            }
	
		            for (var pointIx = 0; pointIx < currentSeries.data.length; pointIx++) {
		                var ref$1 = this$1._bindPoint(currentSeries, seriesIx, pointIx);
		                var value = ref$1.valueFields;
		                var fields = ref$1.fields;
	
		                callback(value, deepExtend({
		                    pointIx: pointIx,
		                    series: currentSeries,
		                    seriesIx: seriesIx,
		                    dataItem: currentSeries.data[pointIx],
		                    owner: this$1
		                }, fields));
		            }
		        }
		    },
	
		    formatPointValue: function(point, format) {
		        var value = point.value;
		        return this.chartService.format.auto(format, value.x, value.y);
		    },
	
		    animationPoints: function() {
		        var points = this.points;
		        var result = [];
		        for (var idx = 0; idx < points.length; idx++) {
		            result.push((points[idx] || {}).marker);
		        }
		        return result;
		    }
		});
		setDefaultOptions(ScatterChart, {
		    series: [],
		    tooltip: {
		        format: "{0}, {1}"
		    },
		    labels: {
		        format: "{0}, {1}"
		    },
		    clip: true
		});
		deepExtend(ScatterChart.prototype, ClipAnimationMixin, {
		    _bindPoint: CategoricalChart.prototype._bindPoint
		});
	
		var Bubble = LinePoint.extend({
		    init: function(value, options) {
		        LinePoint.fn.init.call(this, value, options);
	
		        this.category = value.category;
		    },
	
		    createHighlight: function() {
		        var highlight = this.options.highlight;
		        var border = highlight.border;
		        var markers = this.options.markers;
		        var center = this.box.center();
		        var radius = (markers.size + markers.border.width + border.width) / 2;
		        var highlightGroup = new Group();
		        var shadow = new drawing.Circle(new geometry.Circle([ center.x, center.y + radius / 5 + border.width / 2 ], radius + border.width / 2), {
		            stroke: {
		                color: 'none'
		            },
		            fill: this.createGradient({
		                gradient: 'bubbleShadow',
		                color: markers.background,
		                stops: [ {
		                    offset: 0,
		                    color: markers.background,
		                    opacity: 0.3
		                }, {
		                    offset: 1,
		                    color: markers.background,
		                    opacity: 0
		                } ]
		            })
		        });
		        var overlay = new drawing.Circle(new geometry.Circle([ center.x, center.y ], radius), {
		            stroke: {
		                color: border.color ||
		                    new Color(markers.background).brightness(BORDER_BRIGHTNESS).toHex(),
		                width: border.width,
		                opacity: border.opacity
		            },
		            fill: {
		                color: markers.background,
		                opacity: highlight.opacity
		            }
		        });
	
		        highlightGroup.append(shadow, overlay);
	
		        return highlightGroup;
		    }
		});
	
		Bubble.prototype.defaults = deepExtend({}, Bubble.prototype.defaults, {
		    labels: {
		        position: CENTER
		    },
		    highlight: {
		        opacity: 1,
		        border: {
		            color: "#fff",
		            width: 2,
		            opacity: 1
		        }
		    }
		});
	
		Bubble.prototype.defaults.highlight.zIndex = undefined;
	
		var BubbleChart = ScatterChart.extend({
		    _initFields: function() {
		        this._maxSize = MIN_VALUE;
		        ScatterChart.fn._initFields.call(this);
		    },
	
		    addValue: function(value, fields) {
		        if (value.size !== null && (value.size > 0 || (value.size < 0 && fields.series.negativeValues.visible))) {
		            this._maxSize = Math.max(this._maxSize, Math.abs(value.size));
		            ScatterChart.fn.addValue.call(this, value, fields);
		        } else {
		            this.points.push(null);
		            this.seriesPoints[fields.seriesIx].push(null);
		        }
		    },
	
		    reflow: function(box) {
		        this.updateBubblesSize(box);
		        ScatterChart.fn.reflow.call(this, box);
		    },
	
		    pointType: function() {
		        return Bubble;
		    },
	
		    createPoint: function(value, fields) {
		        var series = fields.series;
		        var pointsCount = series.data.length;
		        var delay = fields.pointIx * (INITIAL_ANIMATION_DURATION / pointsCount);
		        var animationOptions = {
		            delay: delay,
		            duration: INITIAL_ANIMATION_DURATION - delay,
		            type: BUBBLE
		        };
	
		        var color = fields.color || series.color;
		        if (value.size < 0 && series.negativeValues.visible) {
		            color = valueOrDefault(
		                series.negativeValues.color, color
		            );
		        }
	
		        var pointOptions = deepExtend({
		            labels: {
		                animation: {
		                    delay: delay,
		                    duration: INITIAL_ANIMATION_DURATION - delay
		                }
		            }
		        }, this.pointOptions(series, fields.seriesIx), {
		            markers: {
		                type: CIRCLE,
		                border: series.border,
		                opacity: series.opacity,
		                animation: animationOptions
		            }
		        });
	
		        pointOptions = this.evalPointOptions(pointOptions, value, fields);
		        if (isFunction(series.color)) {
		            color = pointOptions.color;
		        }
	
		        pointOptions.markers.background = color;
	
		        var point = new Bubble(value, pointOptions);
		        point.color = color;
	
		        this.append(point);
	
		        return point;
		    },
	
		    updateBubblesSize: function(box) {
		        var this$1 = this;
	
		        var ref = this;
		        var series = ref.options.series;
		        var boxSize = Math.min(box.width(), box.height());
	
		        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
		            var currentSeries = series[seriesIx];
		            var seriesPoints = this$1.seriesPoints[seriesIx];
		            var minSize = currentSeries.minSize || Math.max(boxSize * 0.02, 10);
		            var maxSize = currentSeries.maxSize || boxSize * 0.2;
		            var minR = minSize / 2;
		            var maxR = maxSize / 2;
		            var minArea = Math.PI * minR * minR;
		            var maxArea = Math.PI * maxR * maxR;
		            var areaRange = maxArea - minArea;
		            var areaRatio = areaRange / this$1._maxSize;
	
		            for (var pointIx = 0; pointIx < seriesPoints.length; pointIx++) {
		                var point = seriesPoints[pointIx];
		                if (point) {
		                    var area = Math.abs(point.value.size) * areaRatio;
		                    var radius = Math.sqrt((minArea + area) / Math.PI);
		                    var baseZIndex = valueOrDefault(point.options.zIndex, 0);
		                    var zIndex = baseZIndex + (1 - radius / maxR);
	
		                    deepExtend(point.options, {
		                        zIndex: zIndex,
		                        markers: {
		                            size: radius * 2,
		                            zIndex: zIndex
		                        },
		                        labels: {
		                            zIndex: zIndex + 1
		                        }
		                    });
		                }
		            }
		        }
		    },
	
		    formatPointValue: function(point, format) {
		        var value = point.value;
		        return this.chartService.format.auto(format, value.x, value.y, value.size, point.category);
		    },
	
		    createAnimation: function() {},
	
		    createVisual: function() {}
		});
	
		setDefaultOptions(BubbleChart, {
		    tooltip: {
		        format: "{3}"
		    },
		    labels: {
		        format: "{3}"
		    }
		});
	
		var Target = ShapeElement.extend({
	
		});
	
		deepExtend(Target.prototype, PointEventsMixin);
	
		var Bullet = ChartElement.extend({
		    init: function(value, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.aboveAxis = this.options.aboveAxis;
		        this.color = options.color || WHITE;
		        this.value = value;
		    },
	
		    render: function() {
		        var options = this.options;
	
		        if (!this._rendered) {
		            this._rendered = true;
	
		            if (defined(this.value.target)) {
		                this.target = new Target({
		                    type: options.target.shape,
		                    background: options.target.color || this.color,
		                    opacity: options.opacity,
		                    zIndex: options.zIndex,
		                    border: options.target.border,
		                    vAlign: TOP,
		                    align: RIGHT
		                });
	
		                this.target.value = this.value;
		                this.target.dataItem = this.dataItem;
		                this.target.series = this.series;
	
		                this.append(this.target);
		            }
	
		            this.createNote();
		        }
		    },
	
		    reflow: function(box) {
		        this.render();
	
		        var ref = this;
		        var options = ref.options;
		        var target = ref.target;
		        var chart = ref.owner;
		        var invertAxes = options.invertAxes;
		        var valueAxis = chart.seriesValueAxis(this.options);
		        var categorySlot = chart.categorySlot(chart.categoryAxis, options.categoryIx, valueAxis);
		        var targetValueSlot = valueAxis.getSlot(this.value.target);
		        var targetSlotX = invertAxes ? targetValueSlot : categorySlot;
		        var targetSlotY = invertAxes ? categorySlot : targetValueSlot;
	
		        if (target) {
		            var targetSlot = new Box(
		                targetSlotX.x1, targetSlotY.y1,
		                targetSlotX.x2, targetSlotY.y2
		            );
		            target.options.height = invertAxes ? targetSlot.height() : options.target.line.width;
		            target.options.width = invertAxes ? options.target.line.width : targetSlot.width();
		            target.reflow(targetSlot);
		        }
	
		        if (this.note) {
		            this.note.reflow(box);
		        }
	
		        this.box = box;
		    },
	
		    createVisual: function() {
		        ChartElement.fn.createVisual.call(this);
	
		        var options = this.options;
		        var body = Path.fromRect(this.box.toRect(), {
		            fill: {
		                color: this.color,
		                opacity: options.opacity
		            },
		            stroke: null
		        });
	
		        if (options.border.width > 0) {
		            body.options.set("stroke", {
		                color: options.border.color || this.color,
		                width: options.border.width,
		                dashType: options.border.dashType,
		                opacity: valueOrDefault(options.border.opacity, options.opacity)
		            });
		        }
	
		        this.bodyVisual = body;
	
		        alignPathToPixel(body);
		        this.visual.append(body);
		    },
	
		    createAnimation: function() {
		        if (this.bodyVisual) {
		            this.animation = Animation.create(
		                this.bodyVisual, this.options.animation
		            );
		        }
		    },
	
		    createHighlight: function(style) {
		        return Path.fromRect(this.box.toRect(), style);
		    },
	
		    highlightVisual: function() {
		        return this.bodyVisual;
		    },
	
		    highlightVisualArgs: function() {
		        return {
		            rect: this.box.toRect(),
		            visual: this.bodyVisual,
		            options: this.options
		        };
		    },
	
		    formatValue: function(format) {
		        return this.owner.formatPointValue(this, format);
		    }
		});
	
		Bullet.prototype.tooltipAnchor = Bar.prototype.tooltipAnchor;
	
		setDefaultOptions(Bullet, {
		    border: {
		        width: 1
		    },
		    vertical: false,
		    opacity: 1,
		    target: {
		        shape: "",
		        border: {
		            width: 0,
		            color: "green"
		        },
		        line: {
		            width: 2
		        }
		    },
		    tooltip: {
		        format: "Current: {0}<br />Target: {1}"
		    }
		});
	
		deepExtend(Bullet.prototype, PointEventsMixin);
		deepExtend(Bullet.prototype, NoteMixin);
	
		var BulletChart = CategoricalChart.extend({
		    init: function(plotArea, options) {
	
		        wrapData(options);
	
		        CategoricalChart.fn.init.call(this, plotArea, options);
		    },
	
		    reflowCategories: function(categorySlots) {
		        var children = this.children;
		        var childrenLength = children.length;
	
		        for (var i = 0; i < childrenLength; i++) {
		            children[i].reflow(categorySlots[i]);
		        }
		    },
	
		    plotRange: function(point) {
		        var series = point.series;
		        var valueAxis = this.seriesValueAxis(series);
		        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);
	
		        return [ axisCrossingValue, point.value.current || axisCrossingValue ];
		    },
	
		    createPoint: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var category = fields.category;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var ref = this;
		        var options = ref.options;
		        var children = ref.children;
		        var value = data.valueFields;
	
		        var bulletOptions = deepExtend({
		            vertical: !options.invertAxes,
		            overlay: series.overlay,
		            categoryIx: categoryIx,
		            invertAxes: options.invertAxes
		        }, series);
	
		        var color = data.fields.color || series.color;
		        bulletOptions = this.evalPointOptions(
		            bulletOptions, value, category, categoryIx, series, seriesIx
		        );
	
		        if (isFunction(series.color)) {
		            color = bulletOptions.color;
		        }
	
		        var bullet = new Bullet(value, bulletOptions);
		        bullet.color = color;
	
		        var cluster = children[categoryIx];
		        if (!cluster) {
		            cluster = new ClusterLayout({
		                vertical: options.invertAxes,
		                gap: options.gap,
		                spacing: options.spacing,
		                rtl: !options.invertAxes && (this.chartService || {}).rtl
		            });
		            this.append(cluster);
		        }
	
		        cluster.append(bullet);
	
		        return bullet;
		    },
	
		    updateRange: function(value, fields) {
		        var current = value.current;
		        var target = value.target;
		        var axisName = fields.series.axis;
		        var axisRange = this.valueAxisRanges[axisName];
	
		        if (defined(current) && !isNaN(current) && defined(target && !isNaN(target))) {
		            axisRange = this.valueAxisRanges[axisName] =
		                axisRange || { min: MAX_VALUE, max: MIN_VALUE };
	
		            axisRange.min = Math.min(axisRange.min, current, target);
		            axisRange.max = Math.max(axisRange.max, current, target);
		        }
		    },
	
		    formatPointValue: function(point, format) {
		        return this.chartService.format.auto(format, point.value.current, point.value.target);
		    },
	
		    pointValue: function(data) {
		        return data.valueFields.current;
		    },
	
		    aboveAxis: function(point) {
		        var value = point.value.current;
	
		        return value > 0;
		    },
	
		    createAnimation: function() {
		        var this$1 = this;
	
		        var points = this.points;
	
		        this._setAnimationOptions();
	
		        for (var idx = 0; idx < points.length; idx++) {
		            var point = points[idx];
		            point.options.animation = this$1.options.animation;
		            point.createAnimation();
		        }
		    }
		});
	
		BulletChart.prototype._setAnimationOptions = BarChart.prototype._setAnimationOptions;
	
		setDefaultOptions(BulletChart, {
		    animation: {
		        type: BAR
		    }
		});
	
		function wrapData(options) {
		    var series = options.series;
	
		    for (var i = 0; i < series.length; i++) {
		        var seriesItem = series[i];
		        var data = seriesItem.data;
		        if (data && !isArray(data[0]) && !isObject(data[0])) {
		            seriesItem.data = [ data ];
		        }
		    }
		}
	
		var BaseTooltip = Class.extend({
		    init: function(chartService, options) {
	
		        this.chartService = chartService;
		        this.options = deepExtend({}, this.options, options);
		    },
	
		    getStyle: function(options, point) {
		        var background = options.background;
		        var border = options.border.color;
	
		        if (point) {
		            var pointColor = point.color || point.options.color;
		            background = valueOrDefault(background, pointColor);
		            border = valueOrDefault(border, pointColor);
		        }
	
		        var padding = getSpacing(options.padding || {}, "auto");
	
		        return {
		            backgroundColor: background,
		            borderColor: border,
		            font: options.font,
		            color: options.color,
		            opacity: options.opacity,
		            borderWidth: styleValue(options.border.width),
		            paddingTop: styleValue(padding.top),
		            paddingBottom: styleValue(padding.bottom),
		            paddingLeft: styleValue(padding.left),
		            paddingRight: styleValue(padding.right)
		        };
		    },
	
		    show: function(options, tooltipOptions, point) {
		        options.format = tooltipOptions.format;
	
		        var style = this.getStyle(tooltipOptions, point);
		        options.style = style;
	
		        if (!defined(tooltipOptions.color) && new Color(style.backgroundColor).percBrightness() > 180) {
		            options.className = "k-chart-tooltip-inverse";
		        }
	
		        this.chartService.notify(SHOW_TOOLTIP, options);
	
		        this.visible = true;
		    },
	
		    hide: function() {
		        if (this.chartService) {
		            this.chartService.notify(HIDE_TOOLTIP);
		        }
	
		        this.visible = false;
		    },
	
		    destroy: function() {
		        delete this.chartService;
		    }
		});
	
		setDefaultOptions(BaseTooltip, {
		    border: {
		        width: 1
		    },
		    opacity: 1
		});
	
		var CrosshairTooltip = BaseTooltip.extend({
		    init: function(chartService, crosshair, options) {
		        BaseTooltip.fn.init.call(this, chartService, options);
	
		        this.crosshair = crosshair;
		        this.formatService = chartService.format;
		        this.initAxisName();
		    },
	
		    initAxisName: function() {
		        var axis = this.crosshair.axis;
		        var plotArea = axis.plotArea;
		        var name;
		        if (plotArea.categoryAxis) {
		            name = axis.getCategory ? "categoryAxis" : "valueAxis";
		        } else {
		            name = axis.options.vertical ? "yAxis" : "xAxis";
		        }
		        this.axisName = name;
		    },
	
		    showAt: function(point) {
		        var ref = this;
		        var axis = ref.crosshair.axis;
		        var options = ref.options;
		        var value = axis[options.stickyMode ? "getCategory" : "getValue"](point);
		        var formattedValue = value;
	
		        if (options.format) {
		            formattedValue = this.formatService.auto(options.format, value);
		        } else if (axis.options.type === DATE) {
		            formattedValue = this.formatService.auto(axis.options.labels.dateFormats[axis.options.baseUnit], value);
		        }
	
		        this.show({
		            point: point,
		            anchor: this.getAnchor(),
		            crosshair: this.crosshair,
		            value: formattedValue,
		            axisName: this.axisName,
		            axisIndex: this.crosshair.axis.axisIndex
		        }, this.options);
		    },
	
		    hide: function() {
		        this.chartService.notify(HIDE_TOOLTIP, {
		            crosshair: this.crosshair,
		            axisName: this.axisName,
		            axisIndex: this.crosshair.axis.axisIndex
		        });
		    },
	
		    getAnchor: function() {
		        var ref = this;
		        var crosshair = ref.crosshair;
		        var ref_options = ref.options;
		        var position = ref_options.position;
		        var padding = ref_options.padding;
		        var vertical = !crosshair.axis.options.vertical;
		        var lineBox = crosshair.line.bbox();
		        var horizontalAlign, verticalAlign, point;
	
		        if (vertical) {
		            horizontalAlign = CENTER;
		            if (position === BOTTOM) {
		                verticalAlign = TOP;
		                point = lineBox.bottomLeft().translate(0, padding);
		            } else {
		                verticalAlign = BOTTOM;
		                point = lineBox.topLeft().translate(0, -padding);
		            }
		        } else {
		            verticalAlign = CENTER;
		            if (position === LEFT) {
		                horizontalAlign = RIGHT;
		                point = lineBox.topLeft().translate(-padding, 0);
		            } else {
		                horizontalAlign = LEFT;
		                point = lineBox.topRight().translate(padding, 0);
		            }
		        }
	
		        return {
		            point: point,
		            align: {
		                horizontal: horizontalAlign,
		                vertical: verticalAlign
		            }
		        };
		    }
		});
	
		setDefaultOptions(CrosshairTooltip, {
		    padding: 10
		});
	
		var Crosshair = ChartElement.extend({
		    init: function(chartService, axis, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.axis = axis;
		        this.stickyMode = axis instanceof CategoryAxis;
	
		        var tooltipOptions = this.options.tooltip;
	
		        if (tooltipOptions.visible) {
		            this.tooltip = new CrosshairTooltip(chartService, this,
		                deepExtend({}, tooltipOptions, { stickyMode: this.stickyMode })
		            );
		        }
		    },
	
		    showAt: function(point) {
		        this.point = point;
		        this.moveLine();
		        this.line.visible(true);
	
		        if (this.tooltip) {
		            this.tooltip.showAt(point);
		        }
		    },
	
		    hide: function() {
		        this.line.visible(false);
	
		        if (this.tooltip) {
		            this.tooltip.hide();
		        }
		    },
	
		    moveLine: function() {
		        var ref = this;
		        var axis = ref.axis;
		        var point = ref.point;
		        var vertical = axis.options.vertical;
		        var box = this.getBox();
		        var dim = vertical ? Y : X;
		        var lineStart = new GeometryPoint(box.x1, box.y1);
		        var lineEnd;
	
		        if (vertical) {
		            lineEnd = new GeometryPoint(box.x2, box.y1);
		        } else {
		            lineEnd = new GeometryPoint(box.x1, box.y2);
		        }
	
		        if (point) {
		            if (this.stickyMode) {
		                var slot = axis.getSlot(axis.pointCategoryIndex(point));
		                lineStart[dim] = lineEnd[dim] = slot.center()[dim];
		            } else {
		                lineStart[dim] = lineEnd[dim] = point[dim];
		            }
		        }
	
		        this.box = box;
	
		        this.line.moveTo(lineStart).lineTo(lineEnd);
		    },
	
		    getBox: function() {
		        var axis = this.axis;
		        var axes = axis.pane.axes;
		        var length = axes.length;
		        var vertical = axis.options.vertical;
		        var box = axis.lineBox().clone();
		        var dim = vertical ? X : Y;
		        var axisLineBox;
	
		        for (var i = 0; i < length; i++) {
		            var currentAxis = axes[i];
		            if (currentAxis.options.vertical !== vertical) {
		                if (!axisLineBox) {
		                    axisLineBox = currentAxis.lineBox().clone();
		                } else {
		                    axisLineBox.wrap(currentAxis.lineBox());
		                }
		            }
		        }
	
		        box[dim + 1] = axisLineBox[dim + 1];
		        box[dim + 2] = axisLineBox[dim + 2];
	
		        return box;
		    },
	
		    createVisual: function() {
		        ChartElement.fn.createVisual.call(this);
	
		        var options = this.options;
		        this.line = new Path({
		            stroke: {
		                color: options.color,
		                width: options.width,
		                opacity: options.opacity,
		                dashType: options.dashType
		            },
		            visible: false
		        });
	
		        this.moveLine();
		        this.visual.append(this.line);
		    },
	
		    destroy: function() {
		        if (this.tooltip) {
		            this.tooltip.destroy();
		        }
	
		        ChartElement.fn.destroy.call(this);
		    }
		});
	
		setDefaultOptions(Crosshair, {
		    color: BLACK,
		    width: 2,
		    zIndex: -1,
		    tooltip: {
		        visible: false
		    }
		});
	
		var ChartContainer = ChartElement.extend({
		    init: function(options, pane) {
		        ChartElement.fn.init.call(this, options);
		        this.pane = pane;
		    },
	
		    shouldClip: function() {
		        var children = this.children;
		        var length = children.length;
	
		        for (var i = 0; i < length; i++) {
		            if (children[i].options.clip === true) {
		                return true;
		            }
		        }
		        return false;
		    },
	
		    _clipBox: function() {
		        return this.pane.chartsBox();
		    },
	
		    createVisual: function() {
		        this.visual = new Group({
		            zIndex: 0
		        });
	
		        if (this.shouldClip()) {
		            var clipBox = this.clipBox = this._clipBox();
		            var clipRect = clipBox.toRect();
		            var clipPath = Path.fromRect(clipRect);
	
		            this.visual.clip(clipPath);
		            this.unclipLabels();
		        }
		    },
	
		    stackRoot: function() {
		        return this;
		    },
	
		    unclipLabels: function() {
		        var ref = this;
		        var charts = ref.children;
		        var clipBox = ref.clipBox;
	
		        for (var i = 0; i < charts.length; i++) {
		            var points = charts[i].points || {};
		            var length = points.length;
	
		            for (var j = 0; j < length; j++) {
		                var point = points[j];
		                if (point && point.visible !== false && point.overlapsBox && point.overlapsBox(clipBox)) {
		                    if (point.unclipElements) {
		                        point.unclipElements();
		                    } else {
		                        var label = point.label;
		                        var note = point.note;
	
		                        if (label && label.options.visible) {
		                            if (label.alignToClipBox) {
		                                label.alignToClipBox(clipBox);
		                            }
		                            label.options.noclip = true;
		                        }
	
		                        if (note && note.options.visible) {
		                            note.options.noclip = true;
		                        }
		                    }
		                }
		            }
		        }
		    },
	
		    destroy: function() {
		        ChartElement.fn.destroy.call(this);
	
		        delete this.parent;
		    }
		});
	
		ChartContainer.prototype.isStackRoot = true;
	
		var Pane = BoxElement.extend({
		    init: function(options) {
		        BoxElement.fn.init.call(this, options);
	
		        this.id = paneID();
	
		        this.createTitle();
	
		        this.content = new ChartElement();
	
		        this.chartContainer = new ChartContainer({}, this);
		        this.append(this.content);
	
		        this.axes = [];
		        this.charts = [];
		    },
	
		    createTitle: function() {
		        var titleOptions = this.options.title;
		        if (isObject(titleOptions)) {
		            titleOptions = deepExtend({}, titleOptions, {
		                align: titleOptions.position,
		                position: TOP
		            });
		        }
	
		        this.title = dataviz.Title.buildTitle(titleOptions, this, Pane.prototype.options.title);
		    },
	
		    appendAxis: function(axis) {
		        this.content.append(axis);
		        this.axes.push(axis);
		        axis.pane = this;
		    },
	
		    appendAxisAt: function(axis, pos) {
		        this.content.append(axis);
		        this.axes.splice(pos, 0, axis);
		        axis.pane = this;
		    },
	
		    appendChart: function(chart) {
		        if (this.chartContainer.parent !== this.content) {
		            this.content.append(this.chartContainer);
		        }
	
		        this.charts.push(chart);
		        this.chartContainer.append(chart);
		        chart.pane = this;
		    },
	
		    empty: function() {
		        var this$1 = this;
	
		        var plotArea = this.parent;
	
		        if (plotArea) {
		            for (var i = 0; i < this.axes.length; i++) {
		                plotArea.removeAxis(this$1.axes[i]);
		            }
	
		            for (var i$1 = 0; i$1 < this.charts.length; i$1++) {
		                plotArea.removeChart(this$1.charts[i$1]);
		            }
		        }
	
		        this.axes = [];
		        this.charts = [];
	
		        this.content.destroy();
		        this.content.children = [];
		        this.chartContainer.children = [];
		    },
	
		    reflow: function(targetBox) {
		        // Content (such as charts) is rendered, but excluded from reflows
		        var content;
		        if (last(this.children) === this.content) {
		            content = this.children.pop();
		        }
	
		        BoxElement.fn.reflow.call(this, targetBox);
	
		        if (content) {
		            this.children.push(content);
		        }
	
		        if (this.title) {
		            this.contentBox.y1 += this.title.box.height();
		        }
		    },
	
		    visualStyle: function() {
		        var style = BoxElement.fn.visualStyle.call(this);
		        style.zIndex = -10;
	
		        return style;
		    },
	
		    renderComplete: function() {
		        if (this.options.visible) {
		            this.createGridLines();
		        }
		    },
	
		    stackRoot: function() {
		        return this;
		    },
	
		    clipRoot: function() {
		        return this;
		    },
	
		    createGridLines: function() {
		        var axes = this.axes;
		        var allAxes = axes.concat(this.parent.axes);
		        var vGridLines = [];
		        var hGridLines = [];
	
		        // TODO
		        // Is full combination really necessary?
		        for (var i = 0; i < axes.length; i++) {
		            var axis = axes[i];
		            var vertical = axis.options.vertical;
		            var gridLines = vertical ? vGridLines : hGridLines;
		            for (var j = 0; j < allAxes.length; j++) {
		                if (gridLines.length === 0) {
		                    var altAxis = allAxes[j];
		                    if (vertical !== altAxis.options.vertical) {
		                        append(gridLines, axis.createGridLines(altAxis));
		                    }
		                }
		            }
		        }
		    },
	
		    refresh: function() {
		        this.visual.clear();
	
		        this.content.parent = null;
		        this.content.createGradient = this.createGradient.bind(this);
		        this.content.renderVisual();
		        this.content.parent = this;
	
		        if (this.title) {
		            this.visual.append(this.title.visual);
		        }
	
		        this.visual.append(this.content.visual);
	
		        this.renderComplete();
		        this.notifyRender();
		    },
	
		    chartsBox: function() {
		        var axes = this.axes;
		        var length = axes.length;
		        var chartsBox = new Box();
	
		        for (var idx = 0; idx < length; idx++) {
		            var axis = axes[idx];
		            var axisValueField = axis.options.vertical ? Y : X;
		            var lineBox = axis.lineBox();
		            chartsBox[axisValueField + 1] = lineBox[axisValueField + 1];
		            chartsBox[axisValueField + 2] = lineBox[axisValueField + 2];
		        }
	
		        if (chartsBox.x2 === 0) {
		            var allAxes = this.parent.axes;
		            var length$1 = allAxes.length;
	
		            for (var idx$1 = 0; idx$1 < length$1; idx$1++) {
		                var axis$1 = allAxes[idx$1];
		                if (!axis$1.options.vertical) {
		                    var lineBox$1 = axis$1.lineBox();
		                    chartsBox.x1 = lineBox$1.x1;
		                    chartsBox.x2 = lineBox$1.x2;
		                }
		            }
		        }
		        return chartsBox;
		    },
	
		    clipBox: function() {
		        return this.chartContainer.clipBox;
		    },
	
		    notifyRender: function() {
		        var service = this.getService();
		        if (service) {
		            service.notify(PANE_RENDER, {
		                pane: new ChartPane(this),
		                index: this.paneIndex,
		                name: this.options.name
		            });
		        }
		    }
		});
	
		var ID = 1;
	
		function paneID() {
		    return "pane" + ID++;
		}
	
		Pane.prototype.isStackRoot = true;
	
		setDefaultOptions(Pane, {
		    zIndex: -1,
		    shrinkToFit: true,
		    title: {
		        align: LEFT
		    },
		    visible: true
		});
	
		function appendIfNotNull(array, element) {
		    if (element !== null) {
		        array.push(element);
		    }
		}
	
		function segmentVisible(series, fields, index) {
		    var visible = fields.visible;
		    if (defined(visible)) {
		        return visible;
		    }
	
		    var pointVisibility = series.pointVisibility;
		    if (pointVisibility) {
		        return pointVisibility[index];
		    }
		}
	
		function bindSegments(series) {
		    var data = series.data;
		    var points = [];
		    var sum = 0;
		    var count = 0;
	
		    for (var idx = 0; idx < data.length; idx++) {
		        var pointData = SeriesBinder.current.bindPoint(series, idx);
		        var value = pointData.valueFields.value;
	
		        if (isString(value)) {
		            value = parseFloat(value);
		        }
	
		        if (isNumber(value)) {
		            pointData.visible = segmentVisible(series, pointData.fields, idx) !== false;
	
		            pointData.value = Math.abs(value);
		            points.push(pointData);
	
		            if (pointData.visible) {
		                sum += pointData.value;
		            }
	
		            if (value !== 0) {
		                count++;
		            }
		        } else {
		            points.push(null);
		        }
		    }
	
		    return {
		        total: sum,
		        points: points,
		        count: count
		    };
		}
	
		function equalsIgnoreCase(a, b) {
		    if (a && b) {
		        return a.toLowerCase() === b.toLowerCase();
		    }
	
		    return a === b;
		}
	
		function filterSeriesByType(series, types) {
		    var result = [];
	
		    var seriesTypes = [].concat(types);
		    for (var idx = 0; idx < series.length; idx++) {
		        var currentSeries = series[idx];
		        if (inArray(currentSeries.type, seriesTypes)) {
		            result.push(currentSeries);
		        }
		    }
	
		    return result;
		}
	
		function getDateField(field, row, intlService) {
		    if (row === null) {
		        return row;
		    }
	
		    var key = "_date_" + field;
		    var value = row[key];
	
		    if (!value) {
		        value = parseDate(intlService, getter(field, true)(row));
		        row[key] = value;
		    }
	
		    return value;
		}
	
		function isDateAxis(axisOptions, sampleCategory) {
		    var type = axisOptions.type;
		    var dateCategory = sampleCategory instanceof Date;
	
		    return (!type && dateCategory) || equalsIgnoreCase(type, DATE);
		}
	
		function singleItemOrArray(array) {
		    return array.length === 1 ? array[0] : array;
		}
	
		var AREA_REGEX = /area/i;
	
		function seriesMissingValues(series) {
		    if (series.missingValues) {
		        return series.missingValues;
		    }
	
		    return AREA_REGEX.test(series.type) || series.stack ? ZERO : INTERPOLATE;
		}
	
		function hasValue$1(series, item) {
		    var fields = SeriesBinder.current.bindPoint(series, null, item);
		    var valueFields = fields.valueFields;
	
		    for (var field in valueFields) {
		        if (dataviz.convertableToNumber(valueFields[field])) {
		            return true;
		        }
		    }
		}
	
		function findNext(ref) {
		    var start = ref.start;
		    var dir = ref.dir;
		    var min = ref.min;
		    var max = ref.max;
		    var getter$$1 = ref.getter;
		    var hasItem = ref.hasItem;
		    var series = ref.series;
	
		    var pointHasValue, outPoint;
		    var idx = start;
		    do {
		        idx += dir;
		        //aggregating and binding the item takes too much time for large number of categories
		        //will assume that if the aggregation does not create value for a missing item for one it will not create for others
		        if (hasItem(idx)) {
		            outPoint = getter$$1(idx);
		            pointHasValue = hasValue$1(series, outPoint.item);
		        }
		    } while (min <= idx && idx <= max && !pointHasValue);
	
		    if (pointHasValue) {
		        return outPoint;
		    }
		}
	
		function createOutOfRangePoints(series, range, count, getter$$1, hasItem) {
		    var min = range.min;
		    var max = range.max;
		    var hasMinPoint = min > 0 && min < count;
		    var hasMaxPoint = max + 1 < count;
	
		    if (hasMinPoint || hasMaxPoint) {
		        var missingValues = seriesMissingValues(series);
		        var minPoint, maxPoint;
		        if (missingValues !== INTERPOLATE) {
		            if (hasMinPoint) {
		                minPoint = getter$$1(min - 1);
		            }
	
		            if (hasMaxPoint) {
		                maxPoint = getter$$1(max + 1);
		            }
		        } else {
		            var outPoint, pointHasValue;
		            if (hasMinPoint) {
		                outPoint = getter$$1(min - 1);
		                pointHasValue = hasValue$1(series, outPoint.item);
		                if (!pointHasValue) {
		                    minPoint = findNext({
		                        start: min,
		                        dir: -1,
		                        min: 0,
		                        max: count - 1,
		                        getter: getter$$1,
		                        hasItem: hasItem,
		                        series: series
		                    });
		                } else {
		                    minPoint = outPoint;
		                }
		            }
	
		            if (hasMaxPoint) {
		                outPoint = getter$$1(max + 1);
		                pointHasValue = hasValue$1(series, outPoint.item);
		                if (!pointHasValue) {
		                    maxPoint = findNext({
		                        start: max,
		                        dir: 1,
		                        min: 0,
		                        max: count - 1,
		                        getter: getter$$1,
		                        hasItem: hasItem,
		                        series: series
		                    });
		                } else {
		                    maxPoint = outPoint;
		                }
		            }
		        }
	
		        if (minPoint) {
		            series._outOfRangeMinPoint = minPoint;
		        }
	
		        if (maxPoint) {
		            series._outOfRangeMaxPoint = maxPoint;
		        }
		    }
		}
	
		var PlotAreaBase = ChartElement.extend({
		    init: function(series, options, chartService) {
		        ChartElement.fn.init.call(this, options);
	
		        this.initFields(series, options);
		        this.series = series;
		        this.initSeries();
		        this.charts = [];
		        this.options.legend.items = [];
		        this.axes = [];
		        this.crosshairs = [];
		        this.chartService = chartService;
		        this.originalOptions = options;
	
		        this.createPanes();
		        this.render();
		        this.createCrosshairs();
		    },
	
		    initFields: function() { },
	
		    initSeries: function() {
		        var series = this.series;
	
		        for (var i = 0; i < series.length; i++) {
		            series[i].index = i;
		        }
		    },
	
		    createPanes: function() {
		        var this$1 = this;
	
		        var defaults = { title: { color: (this.options.title || {}).color } };
		        var panes = [];
		        var paneOptions = this.options.panes || [];
		        var panesLength = Math.max(paneOptions.length, 1);
	
		        function setTitle(options, defaults) {
		            if (isString(options.title)) {
		                options.title = {
		                    text: options.title
		                };
		            }
	
		            options.title = deepExtend({}, defaults.title, options.title);
		        }
	
		        for (var i = 0; i < panesLength; i++) {
		            var options = paneOptions[i] || {};
		            setTitle(options, defaults);
	
		            var currentPane = new Pane(options);
		            currentPane.paneIndex = i;
	
		            panes.push(currentPane);
		            this$1.append(currentPane);
		        }
	
		        this.panes = panes;
		    },
	
		    createCrosshairs: function(panes) {
		        var this$1 = this;
		        if (panes === void 0) { panes = this.panes; }
	
		        for (var i = 0; i < panes.length; i++) {
		            var pane = panes[i];
		            for (var j = 0; j < pane.axes.length; j++) {
		                var axis = pane.axes[j];
		                if (axis.options.crosshair && axis.options.crosshair.visible) {
		                    var currentCrosshair = new Crosshair(this$1.chartService, axis, axis.options.crosshair);
	
		                    this$1.crosshairs.push(currentCrosshair);
		                    pane.content.append(currentCrosshair);
		                }
		            }
		        }
		    },
	
		    removeCrosshairs: function(pane) {
		        var crosshairs = this.crosshairs;
		        var axes = pane.axes;
	
		        for (var i = crosshairs.length - 1; i >= 0; i--) {
		            for (var j = 0; j < axes.length; j++) {
		                if (crosshairs[i].axis === axes[j]) {
		                    crosshairs.splice(i, 1);
		                    break;
		                }
		            }
		        }
		    },
	
		    hideCrosshairs: function() {
		        var crosshairs = this.crosshairs;
		        for (var idx = 0; idx < crosshairs.length; idx++) {
		            crosshairs[idx].hide();
		        }
		    },
	
		    findPane: function(name) {
		        var panes = this.panes;
		        var matchingPane;
	
		        for (var i = 0; i < panes.length; i++) {
		            if (panes[i].options.name === name) {
		                matchingPane = panes[i];
		                break;
		            }
		        }
	
		        return matchingPane || panes[0];
		    },
	
		    findPointPane: function(point) {
		        var panes = this.panes;
		        var matchingPane;
	
		        for (var i = 0; i < panes.length; i++) {
		            if (panes[i].box.containsPoint(point)) {
		                matchingPane = panes[i];
		                break;
		            }
		        }
	
		        return matchingPane;
		    },
	
		    appendAxis: function(axis) {
		        var pane = this.findPane(axis.options.pane);
	
		        pane.appendAxis(axis);
		        this.axes.push(axis);
		        axis.plotArea = this;
		    },
	
		    removeAxis: function(axisToRemove) {
		        var this$1 = this;
	
		        var filteredAxes = [];
	
		        for (var i = 0; i < this.axes.length; i++) {
		            var axis = this$1.axes[i];
		            if (axisToRemove !== axis) {
		                filteredAxes.push(axis);
		            } else {
		                axis.destroy();
		            }
		        }
	
		        this.axes = filteredAxes;
		    },
	
		    appendChart: function(chart, pane) {
		        this.charts.push(chart);
		        if (pane) {
		            pane.appendChart(chart);
		        } else {
		            this.append(chart);
		        }
		    },
	
		    removeChart: function(chartToRemove) {
		        var this$1 = this;
	
		        var filteredCharts = [];
	
		        for (var i = 0; i < this.charts.length; i++) {
		            var chart = this$1.charts[i];
		            if (chart !== chartToRemove) {
		                filteredCharts.push(chart);
		            } else {
		                chart.destroy();
		            }
		        }
	
		        this.charts = filteredCharts;
		    },
	
		    addToLegend: function(series) {
		        var count = series.length;
		        var legend = this.options.legend;
		        var labels = legend.labels || {};
		        var inactiveItems = legend.inactiveItems || {};
		        var inactiveItemsLabels = inactiveItems.labels || {};
		        var data = [];
	
		        for (var i = 0; i < count; i++) {
		            var currentSeries = series[i];
		            var seriesVisible = currentSeries.visible !== false;
		            if (currentSeries.visibleInLegend === false) {
		                continue;
		            }
	
		            var text = currentSeries.name;
		            var labelTemplate = seriesVisible ? getTemplate(labels) : getTemplate(inactiveItemsLabels) || getTemplate(labels);
		            if (labelTemplate) {
		                text = labelTemplate({
		                    text: hasValue(text) ? text : "",
		                    series: currentSeries
		                });
		            }
	
		            var defaults = currentSeries._defaults;
		            var color = currentSeries.color;
		            if (isFunction(color) && defaults) {
		                color = defaults.color;
		            }
	
		            var itemLabelOptions = (void 0), markerColor = (void 0);
		            if (seriesVisible) {
		                itemLabelOptions = {};
		                markerColor = color;
		            } else {
		                itemLabelOptions = {
		                    color: inactiveItemsLabels.color,
		                    font: inactiveItemsLabels.font
		                };
		                markerColor = inactiveItems.markers.color;
		            }
	
		            if (hasValue(text) && text !== "") {
		                data.push({
		                    text: text,
		                    labels: itemLabelOptions,
		                    markerColor: markerColor,
		                    series: currentSeries,
		                    active: seriesVisible
		                });
		            }
		        }
	
		        append(legend.items, data);
		    },
	
		    groupAxes: function(panes) {
		        var xAxes = [];
		        var yAxes = [];
	
		        for (var paneIx = 0; paneIx < panes.length; paneIx++) {
		            var paneAxes = panes[paneIx].axes;
		            for (var axisIx = 0; axisIx < paneAxes.length; axisIx++) {
		                var axis = paneAxes[axisIx];
		                if (axis.options.vertical) {
		                    yAxes.push(axis);
		                } else {
		                    xAxes.push(axis);
		                }
		            }
		        }
	
		        return { x: xAxes, y: yAxes, any: xAxes.concat(yAxes) };
		    },
	
		    groupSeriesByPane: function() {
		        var this$1 = this;
	
		        var series = this.series;
		        var seriesByPane = {};
	
		        for (var i = 0; i < series.length; i++) {
		            var currentSeries = series[i];
		            var pane = this$1.seriesPaneName(currentSeries);
	
		            if (seriesByPane[pane]) {
		                seriesByPane[pane].push(currentSeries);
		            } else {
		                seriesByPane[pane] = [ currentSeries ];
		            }
		        }
	
		        return seriesByPane;
		    },
	
		    filterVisibleSeries: function(series) {
		        var result = [];
	
		        for (var i = 0; i < series.length; i++) {
		            var currentSeries = series[i];
		            if (currentSeries.visible !== false) {
		                result.push(currentSeries);
		            }
		        }
	
		        return result;
		    },
	
		    reflow: function(targetBox) {
		        var options = this.options.plotArea;
		        var panes = this.panes;
		        var margin = getSpacing(options.margin);
	
		        this.box = targetBox.clone().unpad(margin);
		        this.reflowPanes();
	
		        this.detachLabels();
		        this.reflowAxes(panes);
		        this.reflowCharts(panes);
		    },
	
		    redraw: function(panes) {
		        var this$1 = this;
	
		        var panesArray = [].concat(panes);
		        this.initSeries();
	
		        //prevents leak during partial redraws. the cached gradients observers retain reference to the destroyed elements.
		        var root = this.getRoot();
		        if (root) {
		            root.cleanGradients();
		        }
	
		        for (var i = 0; i < panesArray.length; i++) {
		            this$1.removeCrosshairs(panesArray[i]);
		            panesArray[i].empty();
		        }
	
		        this.render(panesArray);
		        this.detachLabels();
		        this.reflowAxes(this.panes);
		        this.reflowCharts(panesArray);
	
		        this.createCrosshairs(panesArray);
	
		        for (var i$1 = 0; i$1 < panesArray.length; i$1++) {
		            panesArray[i$1].refresh();
		        }
		    },
	
		    axisCrossingValues: function(axis, crossingAxes) {
		        var options = axis.options;
		        var crossingValues = [].concat(
		            options.axisCrossingValues || options.axisCrossingValue
		        );
		        var valuesToAdd = crossingAxes.length - crossingValues.length;
		        var defaultValue = crossingValues[0] || 0;
	
		        for (var i = 0; i < valuesToAdd; i++) {
		            crossingValues.push(defaultValue);
		        }
	
		        return crossingValues;
		    },
	
		    alignAxisTo: function(axis, targetAxis, crossingValue, targetCrossingValue) {
		        var slot = axis.getSlot(crossingValue, crossingValue, true);
		        var slotEdge = axis.options.reverse ? 2 : 1;
		        var targetSlot = targetAxis.getSlot(targetCrossingValue, targetCrossingValue, true);
		        var targetEdge = targetAxis.options.reverse ? 2 : 1;
		        var axisBox = axis.box.translate(
		            targetSlot[X + targetEdge] - slot[X + slotEdge],
		            targetSlot[Y + targetEdge] - slot[Y + slotEdge]
		        );
	
		        if (axis.pane !== targetAxis.pane) {
		            axisBox.translate(0, axis.pane.box.y1 - targetAxis.pane.box.y1);
		        }
	
		        axis.reflow(axisBox);
		    },
	
		    alignAxes: function(xAxes, yAxes) {
		        var this$1 = this;
	
		        var xAnchor = xAxes[0];
		        var yAnchor = yAxes[0];
		        var xAnchorCrossings = this.axisCrossingValues(xAnchor, yAxes);
		        var yAnchorCrossings = this.axisCrossingValues(yAnchor, xAxes);
		        var leftAnchors = {};
		        var rightAnchors = {};
		        var topAnchors = {};
		        var bottomAnchors = {};
	
		        for (var i = 0; i < yAxes.length; i++) {
		            var axis = yAxes[i];
		            var pane = axis.pane;
		            var paneId = pane.id;
		            var visible = axis.options.visible !== false;
	
		            // Locate pane anchor, if any, and use its axisCrossingValues
		            var anchor = paneAnchor(xAxes, pane) || xAnchor;
		            var anchorCrossings = xAnchorCrossings;
	
		            if (anchor !== xAnchor) {
		                anchorCrossings = this$1.axisCrossingValues(anchor, yAxes);
		            }
	
		            this$1.alignAxisTo(axis, anchor, yAnchorCrossings[i], anchorCrossings[i]);
	
		            if (axis.options._overlap) {
		                continue;
		            }
	
		            if (round(axis.lineBox().x1) === round(anchor.lineBox().x1)) {
		                // Push the axis to the left the previous y-axis so they don't overlap
		                if (leftAnchors[paneId]) {
		                    axis.reflow(axis.box
		                        .alignTo(leftAnchors[paneId].box, LEFT)
		                        .translate(-axis.options.margin, 0)
		                    );
		                }
	
		                if (visible) {
		                    leftAnchors[paneId] = axis;
		                }
		            }
	
		            if (round(axis.lineBox().x2) === round(anchor.lineBox().x2)) {
		                // Flip the labels on the right if we're at the right end of the pane
		                if (!axis._mirrored) {
		                    axis.options.labels.mirror = !axis.options.labels.mirror;
		                    axis._mirrored = true;
		                }
	
		                this$1.alignAxisTo(axis, anchor, yAnchorCrossings[i], anchorCrossings[i]);
	
		                // Push the axis to the right the previous y-axis so they don't overlap
		                if (rightAnchors[paneId]) {
		                    axis.reflow(axis.box
		                        .alignTo(rightAnchors[paneId].box, RIGHT)
		                        .translate(axis.options.margin, 0)
		                    );
		                }
	
		                if (visible) {
		                    rightAnchors[paneId] = axis;
		                }
		            }
	
		            if (i !== 0 && yAnchor.pane === axis.pane) {
		                axis.alignTo(yAnchor);
		                axis.reflow(axis.box);
		            }
		        }
	
		        for (var i$1 = 0; i$1 < xAxes.length; i$1++) {
		            var axis$1 = xAxes[i$1];
		            var pane$1 = axis$1.pane;
		            var paneId$1 = pane$1.id;
		            var visible$1 = axis$1.options.visible !== false;
	
		            // Locate pane anchor and use its axisCrossingValues
		            var anchor$1 = paneAnchor(yAxes, pane$1) || yAnchor;
		            var anchorCrossings$1 = yAnchorCrossings;
		            if (anchor$1 !== yAnchor) {
		                anchorCrossings$1 = this$1.axisCrossingValues(anchor$1, xAxes);
		            }
	
		            this$1.alignAxisTo(axis$1, anchor$1, xAnchorCrossings[i$1], anchorCrossings$1[i$1]);
	
		            if (axis$1.options._overlap) {
		                continue;
		            }
	
		            if (round(axis$1.lineBox().y1) === round(anchor$1.lineBox().y1)) {
		                // Flip the labels on top if we're at the top of the pane
		                if (!axis$1._mirrored) {
		                    axis$1.options.labels.mirror = !axis$1.options.labels.mirror;
		                    axis$1._mirrored = true;
		                }
		                this$1.alignAxisTo(axis$1, anchor$1, xAnchorCrossings[i$1], anchorCrossings$1[i$1]);
	
		                // Push the axis above the previous x-axis so they don't overlap
		                if (topAnchors[paneId$1]) {
		                    axis$1.reflow(axis$1.box
		                        .alignTo(topAnchors[paneId$1].box, TOP)
		                        .translate(0, -axis$1.options.margin)
		                    );
		                }
	
		                if (visible$1) {
		                    topAnchors[paneId$1] = axis$1;
		                }
		            }
	
		            if (round(axis$1.lineBox().y2, datavizConstants.COORD_PRECISION) === round(anchor$1.lineBox().y2, datavizConstants.COORD_PRECISION)) {
		                // Push the axis below the previous x-axis so they don't overlap
		                if (bottomAnchors[paneId$1]) {
		                    axis$1.reflow(axis$1.box
		                        .alignTo(bottomAnchors[paneId$1].box, BOTTOM)
		                        .translate(0, axis$1.options.margin)
		                    );
		                }
	
		                if (visible$1) {
		                    bottomAnchors[paneId$1] = axis$1;
		                }
		            }
	
		            if (i$1 !== 0) {
		                axis$1.alignTo(xAnchor);
		                axis$1.reflow(axis$1.box);
		            }
		        }
		    },
	
		    shrinkAxisWidth: function(panes) {
		        var axes = this.groupAxes(panes).any;
		        var axisBox = axisGroupBox(axes);
		        var overflowX = 0;
	
		        for (var i = 0; i < panes.length; i++) {
		            var currentPane = panes[i];
	
		            if (currentPane.axes.length > 0) {
		                overflowX = Math.max(
		                    overflowX,
		                    axisBox.width() - currentPane.contentBox.width()
		                );
		            }
		        }
	
		        if (overflowX !== 0) {
		            for (var i$1 = 0; i$1 < axes.length; i$1++) {
		                var currentAxis = axes[i$1];
	
		                if (!currentAxis.options.vertical) {
		                    currentAxis.reflow(currentAxis.box.shrink(overflowX, 0));
		                }
		            }
		        }
		    },
	
		    shrinkAxisHeight: function(panes) {
		        var shrinked;
	
		        for (var i = 0; i < panes.length; i++) {
		            var currentPane = panes[i];
		            var axes = currentPane.axes;
		            var overflowY = Math.max(0, axisGroupBox(axes).height() - currentPane.contentBox.height());
	
		            if (overflowY !== 0) {
		                for (var j = 0; j < axes.length; j++) {
		                    var currentAxis = axes[j];
	
		                    if (currentAxis.options.vertical) {
		                        currentAxis.reflow(
		                            currentAxis.box.shrink(0, overflowY)
		                        );
		                    }
		                }
		                shrinked = true;
		            }
		        }
	
		        return shrinked;
		    },
	
		    fitAxes: function(panes) {
		        var axes = this.groupAxes(panes).any;
		        var offsetX = 0;
	
		        for (var i = 0; i < panes.length; i++) {
		            var currentPane = panes[i];
		            var paneAxes = currentPane.axes;
		            var paneBox = currentPane.contentBox;
	
		            if (paneAxes.length > 0) {
		                var axisBox = axisGroupBox(paneAxes);
		                // OffsetY is calculated and applied per pane
		                var offsetY = Math.max(paneBox.y1 - axisBox.y1, paneBox.y2 - axisBox.y2);
	
		                // OffsetX is calculated and applied globally
		                offsetX = Math.max(offsetX, paneBox.x1 - axisBox.x1);
	
		                for (var j = 0; j < paneAxes.length; j++) {
		                    var currentAxis = paneAxes[j];
	
		                    currentAxis.reflow(
		                        currentAxis.box.translate(0, offsetY)
		                    );
		                }
		            }
		        }
	
		        for (var i$1 = 0; i$1 < axes.length; i$1++) {
		            var currentAxis$1 = axes[i$1];
	
		            currentAxis$1.reflow(
		                currentAxis$1.box.translate(offsetX, 0)
		            );
		        }
		    },
	
		    reflowAxes: function(panes) {
		        var this$1 = this;
	
		        var axes = this.groupAxes(panes);
	
		        for (var i = 0; i < panes.length; i++) {
		            this$1.reflowPaneAxes(panes[i]);
		        }
	
		        if (axes.x.length > 0 && axes.y.length > 0) {
		            this.alignAxes(axes.x, axes.y);
		            this.shrinkAxisWidth(panes);
	
		            this.autoRotateAxisLabels(axes);
	
		            this.alignAxes(axes.x, axes.y);
		            if (this.shrinkAxisWidth(panes)) {
		                this.alignAxes(axes.x, axes.y);
		            }
	
		            this.shrinkAxisHeight(panes);
		            this.alignAxes(axes.x, axes.y);
	
		            if (this.shrinkAxisHeight(panes)) {
		                this.alignAxes(axes.x, axes.y);
		            }
	
		            this.fitAxes(panes);
		        }
		    },
	
		    autoRotateAxisLabels: function(groupedAxes) {
		        var this$1 = this;
	
		        var ref = this;
		        var panes = ref.panes;
		        var axes = allPaneAxes(panes);
		        var rotated;
	
		        for (var idx = 0; idx < axes.length; idx++) {
		            var axis = axes[idx];
		            if (axis.autoRotateLabels()) {
		                rotated = true;
		            }
		        }
	
		        if (rotated) {
		            for (var idx$1 = 0; idx$1 < panes.length; idx$1++) {
		                this$1.reflowPaneAxes(panes[idx$1]);
		            }
	
		            if (groupedAxes.x.length > 0 && groupedAxes.y.length > 0) {
		                this.alignAxes(groupedAxes.x, groupedAxes.y);
		                this.shrinkAxisWidth(panes);
		            }
		        }
		    },
	
		    reflowPaneAxes: function(pane) {
		        var axes = pane.axes;
		        var length = axes.length;
	
		        if (length > 0) {
		            for (var i = 0; i < length; i++) {
		                axes[i].reflow(pane.contentBox);
		            }
		        }
		    },
	
		    reflowCharts: function(panes) {
		        var charts = this.charts;
		        var count = charts.length;
		        var box = this.box;
	
		        for (var i = 0; i < count; i++) {
		            var chartPane = charts[i].pane;
		            if (!chartPane || inArray(chartPane, panes)) {
		                charts[i].reflow(box);
		            }
		        }
		    },
	
		    reflowPanes: function() {
		        var ref = this;
		        var box = ref.box;
		        var panes = ref.panes;
		        var panesLength = panes.length;
		        var remainingHeight = box.height();
		        var remainingPanes = panesLength;
		        var autoHeightPanes = 0;
		        var top = box.y1;
	
		        for (var i = 0; i < panesLength; i++) {
		            var currentPane = panes[i];
		            var height = currentPane.options.height;
	
		            currentPane.options.width = box.width();
	
		            if (!currentPane.options.height) {
		                autoHeightPanes++;
		            } else {
		                if (height.indexOf && height.indexOf("%")) {
		                    var percents = parseInt(height, 10) / 100;
		                    currentPane.options.height = percents * box.height();
		                }
	
		                currentPane.reflow(box.clone());
	
		                remainingHeight -= currentPane.options.height;
		            }
		        }
	
		        for (var i$1 = 0; i$1 < panesLength; i$1++) {
		            var currentPane$1 = panes[i$1];
	
		            if (!currentPane$1.options.height) {
		                currentPane$1.options.height = remainingHeight / autoHeightPanes;
		            }
		        }
	
		        for (var i$2 = 0; i$2 < panesLength; i$2++) {
		            var currentPane$2 = panes[i$2];
		            var paneBox = box
		                .clone()
		                .move(box.x1, top);
	
		            currentPane$2.reflow(paneBox);
	
		            remainingPanes--;
		            top += currentPane$2.options.height;
		        }
		    },
	
		    backgroundBox: function() {
		        var axes = this.axes;
		        var axesCount = axes.length;
		        var box;
	
		        for (var i = 0; i < axesCount; i++) {
		            var axisA = axes[i];
	
		            for (var j = 0; j < axesCount; j++) {
		                var axisB = axes[j];
	
		                if (axisA.options.vertical !== axisB.options.vertical) {
		                    var lineBox = axisA.lineBox().clone().wrap(axisB.lineBox());
	
		                    if (!box) {
		                        box = lineBox;
		                    } else {
		                        box = box.wrap(lineBox);
		                    }
		                }
		            }
		        }
	
		        return box || this.box;
		    },
	
		    chartsBoxes: function() {
		        var panes = this.panes;
		        var boxes = [];
	
		        for (var idx = 0; idx < panes.length; idx++) {
		            boxes.push(panes[idx].chartsBox());
		        }
	
		        return boxes;
		    },
	
		    addBackgroundPaths: function(multipath) {
		        var boxes = this.chartsBoxes();
		        for (var idx = 0; idx < boxes.length; idx++) {
		            multipath.paths.push(Path.fromRect(boxes[idx].toRect()));
		        }
		    },
	
		    backgroundContainsPoint: function(point) {
		        var boxes = this.chartsBoxes();
		        for (var idx = 0; idx < boxes.length; idx++) {
		            if (boxes[idx].containsPoint(point)) {
		                return true;
		            }
		        }
		    },
	
		    createVisual: function() {
		        ChartElement.fn.createVisual.call(this);
	
		        var options = this.options.plotArea;
		        var opacity = options.opacity;
		        var background = options.background;
		        var border = options.border; if (border === void 0) { border = {}; }
		        if (isTransparent(background)) {
		            background = WHITE;
		            opacity = 0;
		        }
	
		        var bg = this._bgVisual = new drawing.MultiPath({
		            fill: {
		                color: background,
		                opacity: opacity
		            },
		            stroke: {
		                color: border.width ? border.color : "",
		                width: border.width,
		                dashType: border.dashType
		            },
		            zIndex: -1
		        });
	
		        this.addBackgroundPaths(bg);
	
		        this.appendVisual(bg);
		    },
	
		    pointsByCategoryIndex: function(categoryIndex) {
		        var charts = this.charts;
		        var result = [];
	
		        if (categoryIndex !== null) {
		            for (var i = 0; i < charts.length; i++) {
		                var chart = charts[i];
		                if (chart.pane.options.name === "_navigator") {
		                    continue;
		                }
	
		                var points = charts[i].categoryPoints[categoryIndex];
		                if (points && points.length) {
		                    for (var j = 0; j < points.length; j++) {
		                        var point = points[j];
		                        if (point && defined(point.value) && point.value !== null) {
		                            result.push(point);
		                        }
		                    }
		                }
		            }
		        }
	
		        return result;
		    },
	
		    pointsBySeriesIndex: function(seriesIndex) {
		        return this.filterPoints(function(point) {
		            return point.series.index === seriesIndex;
		        });
		    },
	
		    pointsBySeriesName: function(name) {
		        return this.filterPoints(function(point) {
		            return point.series.name === name;
		        });
		    },
	
		    filterPoints: function(callback) {
		        var charts = this.charts;
		        var result = [];
	
		        for (var i = 0; i < charts.length; i++) {
		            var chart = charts[i];
		            var points = chart.points;
		            for (var j = 0; j < points.length; j++) {
		                var point = points[j];
		                if (point && point.visible !== false && callback(point)) {
		                    result.push(point);
		                }
		            }
		        }
	
		        return result;
		    },
	
		    findPoint: function(callback) {
		        var charts = this.charts;
	
		        for (var i = 0; i < charts.length; i++) {
		            var chart = charts[i];
		            var points = chart.points;
		            for (var j = 0; j < points.length; j++) {
		                var point = points[j];
		                if (point && point.visible !== false && callback(point)) {
		                    return point;
		                }
		            }
		        }
		    },
	
		    paneByPoint: function(point) {
		        var panes = this.panes;
	
		        for (var i = 0; i < panes.length; i++) {
		            var pane = panes[i];
		            if (pane.box.containsPoint(point)) {
		                return pane;
		            }
		        }
		    },
	
		    detachLabels: function() {
		        var axes = this.groupAxes(this.panes);
		        var xAxes = axes.x;
		        var yAxes = axes.y;
	
		        this.detachAxisGroupLabels(yAxes, xAxes);
		        this.detachAxisGroupLabels(xAxes, yAxes);
		    },
	
		    detachAxisGroupLabels: function(axes, crossingAxes) {
		        var this$1 = this;
	
		        var labelAxisCount = 0;
	
		        for (var i = 0; i < axes.length; i++) {
		            var axis = axes[i];
		            var pane = axis.pane;
		            var anchor = paneAnchor(crossingAxes, pane) || crossingAxes[0];
		            var axisIndex = i + labelAxisCount;
		            var labelAxis = this$1.createLabelAxis(axis, axisIndex, anchor);
	
		            if (labelAxis) {
		                labelAxisCount++;
	
		                var pos = pane.axes.indexOf(axis) + labelAxisCount;
		                pane.appendAxisAt(labelAxis, pos);
		            }
		        }
		    },
	
		    createLabelAxis: function(axis, axisIndex, anchor) {
		        var labelOptions = axis.options.labels;
		        var position = labelOptions.position;
		        var onAxis = position !== datavizConstants.END && position !== datavizConstants.START;
		        var visible = labelOptions.visible;
	
		        if (onAxis || visible === false) {
		            return null;
		        }
	
		        var allAxes = this.groupAxes(this.panes);
		        var crossingAxes = anchor.options.vertical ? allAxes.x : allAxes.y;
		        var anchorCrossings = this.axisCrossingValues(anchor, crossingAxes);
		        var end = position === datavizConstants.END;
		        var range = anchor.range();
		        var edge = end ? range.max : range.min;
		        var crossingValue = limitValue(anchorCrossings[axisIndex], range.min, range.max);
	
		        if (crossingValue - edge === 0) {
		            return null;
		        }
	
		        anchorCrossings.splice(axisIndex + 1, 0, edge);
		        anchor.options.axisCrossingValues = anchorCrossings;
	
		        var labelAxis = axis.clone();
		        axis.clear();
	
		        labelAxis.options.name = undefined;
		        labelAxis.options.line.visible = false;
	
		        labelAxis.options.crosshair = undefined;
		        labelAxis.options.notes = undefined;
		        labelAxis.options.plotBands = undefined;
	
		        return labelAxis;
		    }
		});
	
		function axisGroupBox(axes) {
		    var length = axes.length;
		    var box;
	
		    if (length > 0) {
		        for (var i = 0; i < length; i++) {
		            var axisBox = axes[i].contentBox();
	
		            if (!box) {
		                box = axisBox.clone();
		            } else {
		                box.wrap(axisBox);
		            }
		        }
		    }
	
		    return box || new Box();
		}
	
		function paneAnchor(axes, pane) {
		    for (var i = 0; i < axes.length; i++) {
		        var anchor = axes[i];
		        if (anchor && anchor.pane === pane) {
		            return anchor;
		        }
		    }
		}
	
		function isTransparent(color) {
		    return color === "" || color === null || color === "none" || color === "transparent" || !defined(color);
		}
	
		var allPaneAxes = function (panes) { return panes.reduce(function (acc, pane) { return acc.concat(pane.axes); }, []); };
	
		setDefaultOptions(PlotAreaBase, {
		    series: [],
		    plotArea: {
		        margin: {}
		    },
		    background: "",
		    border: {
		        color: BLACK,
		        width: 0
		    },
		    legend: {
		        inactiveItems: {
		            labels: {
		                color: "#919191"
		            },
		            markers: {
		                color: "#919191"
		            }
		        }
		    }
		});
	
		var PlotAreaEventsMixin = {
		    hover: function(chart, e) {
		        this._dispatchEvent(chart, e, PLOT_AREA_HOVER);
		    },
	
		    click: function(chart, e) {
		        this._dispatchEvent(chart, e, PLOT_AREA_CLICK);
		    }
		};
	
		var SeriesAggregator = Class.extend({
		    init: function(series, binder, defaultAggregates) {
	
		        var canonicalFields = binder.canonicalFields(series);
		        var valueFields = binder.valueFields(series);
		        var sourceFields = binder.sourceFields(series, canonicalFields);
		        var seriesFields = this._seriesFields = [];
		        var defaults = defaultAggregates.query(series.type);
		        var rootAggregate = series.aggregate || defaults;
	
		        this._series = series;
		        this._binder = binder;
	
		        for (var i = 0; i < canonicalFields.length; i++) {
		            var field = canonicalFields[i];
		            var fieldAggregate = (void 0);
	
		            if (isObject(rootAggregate)) {
		                fieldAggregate = rootAggregate[field];
		            } else if (i === 0 || inArray(field, valueFields)) {
		                fieldAggregate = rootAggregate;
		            } else {
		                break;
		            }
	
		            if (fieldAggregate) {
		                seriesFields.push({
		                    canonicalName: field,
		                    name: sourceFields[i],
		                    transform: isFunction(fieldAggregate) ? fieldAggregate : Aggregates[fieldAggregate]
		                });
		            }
		        }
		    },
	
		    aggregatePoints: function(srcPoints, group) {
		        var this$1 = this;
	
		        var ref = this;
		        var series = ref._series;
		        var seriesFields = ref._seriesFields;
		        var data = this._bindPoints(srcPoints || []);
		        var firstDataItem = data.dataItems[0];
		        var result = {};
	
		        if (firstDataItem && !isNumber(firstDataItem) && !isArray(firstDataItem)) {
		            var fn = function() {};
		            fn.prototype = firstDataItem;
		            result = new fn();
		        }
	
		        for (var i = 0; i < seriesFields.length; i++) {
		            var field = seriesFields[i];
		            var srcValues = this$1._bindField(data.values, field.canonicalName);
		            var value = field.transform(srcValues, series, data.dataItems, group);
	
		            if (value !== null && isObject(value) && !defined(value.length) && !(value instanceof Date)) {
		                result = value;
		                break;
		            } else {
		                if (defined(value)) {
		                    setValue(field.name, result, value);
		                }
		            }
		        }
	
		        return result;
		    },
	
		    _bindPoints: function(points) {
		        var ref = this;
		        var binder = ref._binder;
		        var series = ref._series;
		        var values = [];
		        var dataItems = [];
	
		        for (var i = 0; i < points.length; i++) {
		            var pointIx = points[i];
	
		            values.push(binder.bindPoint(series, pointIx));
		            dataItems.push(series.data[pointIx]);
		        }
	
		        return {
		            values: values,
		            dataItems: dataItems
		        };
		    },
	
		    _bindField: function(data, field) {
		        var values = [];
		        var count = data.length;
	
		        for (var i = 0; i < count; i++) {
		            var item = data[i];
		            var valueFields = item.valueFields;
		            var value = (void 0);
	
		            if (defined(valueFields[field])) {
		                value = valueFields[field];
		            } else {
		                value = item.fields[field];
		            }
	
		            values.push(value);
		        }
	
		        return values;
		    }
		});
	
		function setValue(fieldName, target, value) {
		    var parentObj = target;
		    var field = fieldName;
	
		    if (fieldName.indexOf(".") > -1) {
		        var parts = fieldName.split(".");
	
		        while (parts.length > 1) {
		            field = parts.shift();
		            if (!defined(parentObj[field])) {
		                parentObj[field] = {};
		            }
		            parentObj = parentObj[field];
		        }
		        field = parts.shift();
		    }
	
		    parentObj[field] = value;
		}
	
		var DefaultAggregates = Class.extend({
		    init: function() {
	
		        this._defaults = {};
		    },
	
		    register: function(seriesTypes, aggregates) {
		        var this$1 = this;
	
		        for (var i = 0; i < seriesTypes.length; i++) {
		            this$1._defaults[seriesTypes[i]] = aggregates;
		        }
		    },
	
		    query: function(seriesType) {
		        return this._defaults[seriesType];
		    }
		});
	
		DefaultAggregates.current = new DefaultAggregates();
	
		var RangeBar = Bar.extend({
		    createLabel: function() {
		        var labels = this.options.labels;
		        var fromOptions = deepExtend({}, labels, labels.from);
		        var toOptions = deepExtend({}, labels, labels.to);
	
		        if (fromOptions.visible) {
		            this.labelFrom = this._createLabel(fromOptions);
		            this.append(this.labelFrom);
		        }
	
		        if (toOptions.visible) {
		            this.labelTo = this._createLabel(toOptions);
		            this.append(this.labelTo);
		        }
		    },
	
		    _createLabel: function(options) {
		        var labelTemplate = getTemplate(options);
		        var pointData = this.pointData();
	
		        var labelText;
	
		        if (labelTemplate) {
		            labelText = labelTemplate(pointData);
		        } else {
		            labelText = this.formatValue(options.format);
		        }
	
		        return new BarLabel(labelText,
		            deepExtend({
		                vertical: this.options.vertical
		            },
		            options
		        ), pointData);
		    },
	
		    reflow: function(targetBox) {
		        this.render();
	
		        var ref = this;
		        var labelFrom = ref.labelFrom;
		        var labelTo = ref.labelTo;
		        var value = ref.value;
	
		        this.box = targetBox;
	
		        if (labelFrom) {
		            labelFrom.options.aboveAxis = value.from > value.to;
		            labelFrom.reflow(targetBox);
		        }
	
		        if (labelTo) {
		            labelTo.options.aboveAxis = value.to > value.from;
		            labelTo.reflow(targetBox);
		        }
	
		        if (this.note) {
		            this.note.reflow(targetBox);
		        }
		    }
		});
	
		RangeBar.prototype.defaults = deepExtend({}, RangeBar.prototype.defaults, {
		    labels: {
		        format: "{0} - {1}"
		    },
		    tooltip: {
		        format: "{1}"
		    }
		});
	
		var RangeBarChart = BarChart.extend({
		    pointType: function() {
		        return RangeBar;
		    },
	
		    pointValue: function(data) {
		        return data.valueFields;
		    },
	
		    formatPointValue: function(point, format) {
		        if (point.value.from === null && point.value.to === null) {
		            return "";
		        }
	
		        return this.chartService.format.auto(format, point.value.from, point.value.to);
		    },
	
		    plotRange: function(point) {
		        if (!point) {
		            return 0;
		        }
	
		        return [ point.value.from, point.value.to ];
		    },
	
		    updateRange: function(value, fields) {
		        var axisName = fields.series.axis;
		        var from = value.from;
		        var to = value.to;
		        var axisRange = this.valueAxisRanges[axisName];
	
		        if (value !== null && isNumber(from) && isNumber(to)) {
		            axisRange = this.valueAxisRanges[axisName] = axisRange || { min: MAX_VALUE, max: MIN_VALUE };
	
		            axisRange.min = Math.min(axisRange.min, from);
		            axisRange.max = Math.max(axisRange.max, from);
	
		            axisRange.min = Math.min(axisRange.min, to);
		            axisRange.max = Math.max(axisRange.max, to);
		        }
		    },
	
		    aboveAxis: function(point) {
		        var value = point.value;
		        return value.from < value.to;
		    }
		});
	
		RangeBarChart.prototype.plotLimits = CategoricalChart.prototype.plotLimits;
	
		var RangeLinePoint = LinePoint.extend({
		    aliasFor: function() {
		        return this.parent;
		    }
		});
	
		var AUTO = 'auto';
		var DEFAULT_FROM_FORMAT = '{0}';
		var DEFAULT_TO_FORMAT = '{1}';
	
		var RangeAreaPoint = ChartElement.extend({
		    init: function(value, options) {
		        ChartElement.fn.init.call(this);
	
		        this.value = value;
		        this.options = options;
		        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
		        this.tooltipTracking = true;
		        this.initLabelsFormat();
		    },
	
		    render: function() {
		        if (this._rendered) {
		            return;
		        }
	
		        this._rendered = true;
	
		        var ref = this.options;
		        var markers = ref.markers;
		        var labels = ref.labels;
		        var value = this.value;
	
		        var fromPoint = this.fromPoint = new RangeLinePoint(value, deepExtend({}, this.options, {
		            labels: labels.from,
		            markers: markers.from
		        }));
	
		        var toPoint = this.toPoint = new RangeLinePoint(value, deepExtend({}, this.options, {
		            labels: labels.to,
		            markers: markers.to
		        }));
	
		        this.copyFields(fromPoint);
		        this.copyFields(toPoint);
	
		        this.append(fromPoint);
		        this.append(toPoint);
		    },
	
		    reflow: function(targetBox) {
		        this.render();
	
		        var fromBox = targetBox.from;
		        var toBox = targetBox.to;
	
		        this.positionLabels(fromBox, toBox);
	
		        this.fromPoint.reflow(fromBox);
		        this.toPoint.reflow(toBox);
	
		        this.box = this.fromPoint.markerBox().clone().wrap(this.toPoint.markerBox());
		    },
	
		    createHighlight: function() {
		        var group = new Group();
		        group.append(this.fromPoint.createHighlight());
		        group.append(this.toPoint.createHighlight());
	
		        return group;
		    },
	
		    highlightVisual: function() {
		        return this.visual;
		    },
	
		    highlightVisualArgs: function() {
		        return {
		            options: this.options,
		            from: this.fromPoint.highlightVisualArgs(),
		            to: this.toPoint.highlightVisualArgs()
		        };
		    },
	
		    tooltipAnchor: function() {
		        var clipBox = this.owner.pane.clipBox();
		        var showTooltip = !clipBox || clipBox.overlaps(this.box);
	
		        if (showTooltip) {
		            var box = this.box;
		            var center = box.center();
		            var horizontalAlign = LEFT;
		            var x, y, verticalAlign;
	
		            if (this.options.vertical) {
		                x = center.x;
		                y = box.y1 - TOOLTIP_OFFSET;
		                verticalAlign = BOTTOM;
		            } else {
		                x = box.x2 + TOOLTIP_OFFSET;
		                y = center.y;
		                verticalAlign = CENTER;
		            }
	
		            return {
		                point: new Point(x, y),
		                align: {
		                    horizontal: horizontalAlign,
		                    vertical: verticalAlign
		                }
		            };
		        }
		    },
	
		    formatValue: function(format) {
		        return this.owner.formatPointValue(this, format);
		    },
	
		    overlapsBox: function(box) {
		        return this.box.overlaps(box);
		    },
	
		    unclipElements: function() {
		        this.fromPoint.unclipElements();
		        this.toPoint.unclipElements();
		    },
	
		    initLabelsFormat: function() {
		        var labels = this.options.labels;
		        if (!labels.format) {
		            if (!labels.from || !labels.from.format) {
		                labels.from = $.extend({}, labels.from, {
		                    format: DEFAULT_FROM_FORMAT
		                });
		            }
	
		            if (!labels.to || !labels.to.format) {
		                labels.to = $.extend({}, labels.to, {
		                    format: DEFAULT_TO_FORMAT
		                });
		            }
		        }
		    },
	
		    positionLabels: function(fromBox, toBox) {
		        var ref = this.options;
		        var labels = ref.labels;
		        var vertical = ref.vertical;
	
		        if (labels.position === AUTO) {
		            var fromLabelPosition, toLabelPosition;
		            if (vertical) {
		                if (toBox.y1 <= fromBox.y1) {
		                    toLabelPosition = ABOVE;
		                    fromLabelPosition = BELOW;
		                } else {
		                    toLabelPosition = BELOW;
		                    fromLabelPosition = ABOVE;
		                }
		            } else {
		                if (toBox.x1 <= fromBox.x1) {
		                    toLabelPosition = LEFT;
		                    fromLabelPosition = RIGHT;
		                } else {
		                    toLabelPosition = RIGHT;
		                    fromLabelPosition = LEFT;
		                }
		            }
	
		            if (!labels.from || !labels.from.position) {
		                this.fromPoint.options.labels.position = fromLabelPosition;
		            }
	
		            if (!labels.to || !labels.to.position) {
		                this.toPoint.options.labels.position = toLabelPosition;
		            }
		        }
		    },
	
		    copyFields: function(point) {
		        point.dataItem = this.dataItem;
		        point.category = this.category;
		        point.series = this.series;
		        point.color = this.color;
		        point.owner = this.owner;
		    }
		});
	
		deepExtend(RangeAreaPoint.prototype, PointEventsMixin);
		deepExtend(RangeAreaPoint.prototype, NoteMixin);
	
		RangeAreaPoint.prototype.defaults = {
		    markers: {
		        visible: false,
		        background: WHITE,
		        size: LINE_MARKER_SIZE,
		        type: CIRCLE,
		        border: {
		            width: 2
		        },
		        opacity: 1
		    },
		    labels: {
		        visible: false,
		        margin: getSpacing(3),
		        padding: getSpacing(4),
		        animation: {
		            type: FADEIN,
		            delay: INITIAL_ANIMATION_DURATION
		        },
		        position: AUTO
		    },
		    notes: {
		        label: {}
		    },
		    highlight: {
		        markers: {
		            border: {
		                color: WHITE,
		                width: 2
		            }
		        },
		        zIndex: datavizConstants.HIGHLIGHT_ZINDEX
		    },
		    tooltip: {
		        format: '{0} - {1}'
		    }
		};
	
		var RangeAreaSegment = AreaSegment.extend({
		    createStrokeSegments: function() {
		        return this.segmentsFromPoints(this.toGeometryPoints(this.toPoints()));
		    },
	
		    stackSegments: function() {
		        var fromSegments = this.fromSegments;
		        if (!this.fromSegments) {
		            fromSegments = this.fromSegments = this.segmentsFromPoints(this.toGeometryPoints(this.fromPoints().reverse()));
		        }
	
		        return fromSegments;
		    },
	
		    createStroke: function(style) {
		        var toPath = new Path(style);
		        var fromPath = new Path(style);
	
		        toPath.segments.push.apply(toPath.segments, this.strokeSegments());
		        fromPath.segments.push.apply(fromPath.segments, this.stackSegments());
	
		        this.visual.append(toPath);
		        this.visual.append(fromPath);
		    },
	
		    hasStackSegment: function() {
		        return true;
		    },
	
		    fromPoints: function() {
		        return this.linePoints.map(function (point) { return point.fromPoint; });
		    },
	
		    toPoints: function() {
		        return this.linePoints.map(function (point) { return point.toPoint; });
		    }
		});
	
		var SplineRangeAreaSegment = RangeAreaSegment.extend({
		    createStrokeSegments: function() {
		        return this.createCurveSegments(this.toPoints());
		    },
	
		    stackSegments: function() {
		        var fromSegments = this.fromSegments;
		        if (!this.fromSegments) {
		            fromSegments = this.fromSegments = this.createCurveSegments(this.fromPoints().reverse());
		        }
	
		        return fromSegments;
		    },
	
		    createCurveSegments: function(points) {
		        var curveProcessor = new CurveProcessor();
	
		        return curveProcessor.process(this.toGeometryPoints(points));
		    }
		});
	
		var StepRangeAreaSegment = RangeAreaSegment.extend({
		    createStrokeSegments: function() {
		        return this.segmentsFromPoints(this.calculateStepPoints(this.toPoints()));
		    },
	
		    stackSegments: function() {
		        var fromSegments = this.fromSegments;
		        if (!this.fromSegments) {
		            fromSegments = this.fromSegments = this.segmentsFromPoints(this.calculateStepPoints(this.fromPoints()));
		            fromSegments.reverse();
		        }
	
		        return fromSegments;
		    }
		});
	
		deepExtend(StepRangeAreaSegment.prototype, StepLineMixin);
	
		var RangeAreaChart = CategoricalChart.extend({
		    render: function() {
		        CategoricalChart.fn.render.call(this);
	
		        this.renderSegments();
		    },
	
		    pointType: function() {
		        return RangeAreaPoint;
		    },
	
		    createPoint: function(data, fields) {
		        var categoryIx = fields.categoryIx;
		        var category = fields.category;
		        var series = fields.series;
		        var seriesIx = fields.seriesIx;
		        var value = data.valueFields;
	
		        if (!hasValue(value.from) && !hasValue(value.to)) {
		            if (this.seriesMissingValues(series) === ZERO) {
		                value = {
		                    from: 0,
		                    to: 0
		                };
		            } else {
		                return null;
		            }
		        }
	
		        var pointOptions = this.pointOptions(series, seriesIx);
		        pointOptions = this.evalPointOptions(
		            pointOptions, value, category, categoryIx, series, seriesIx
		        );
	
		        var color = data.fields.color || series.color;
		        if (isFunction(series.color)) {
		            color = pointOptions.color;
		        }
	
		        var point = new RangeAreaPoint(value, pointOptions);
		        point.color = color;
	
		        this.append(point);
	
		        return point;
		    },
	
		    createSegment: function(linePoints, currentSeries, seriesIx) {
		        var style = (currentSeries.line || {}).style;
		        var segmentType;
		        if (style === "smooth") {
		            segmentType = SplineRangeAreaSegment;
		        } else if (style === "step") {
		            segmentType = StepRangeAreaSegment;
		        } else {
		            segmentType = RangeAreaSegment;
		        }
	
		        return new segmentType(linePoints, currentSeries, seriesIx);
		    },
	
		    plotRange: function(point, startValue) {
		        if (!point) {
		            return [ startValue, startValue ];
		        }
	
		        return [ point.value.from, point.value.to ];
		    },
	
		    valueSlot: function(valueAxis, plotRange) {
		        var fromSlot = valueAxis.getSlot(plotRange[0], plotRange[0], !this.options.clip);
		        var toSlot = valueAxis.getSlot(plotRange[1], plotRange[1], !this.options.clip);
		        if (fromSlot && toSlot) {
		            return {
		                from: fromSlot,
		                to: toSlot
		            };
		        }
		    },
	
		    pointSlot: function(categorySlot, valueSlot) {
		        var from = valueSlot.from;
		        var to = valueSlot.to;
		        var fromSlot, toSlot;
	
		        if (this.options.invertAxes) {
		            fromSlot = new Box(from.x1, categorySlot.y1, from.x2, categorySlot.y2);
		            toSlot = new Box(to.x1, categorySlot.y1, to.x2, categorySlot.y2);
		        } else {
		            fromSlot = new Box(categorySlot.x1, from.y1, categorySlot.x2, from.y2);
		            toSlot = new Box(categorySlot.x1, to.y1, categorySlot.x2, to.y2);
		        }
	
		        return {
		            from: fromSlot,
		            to: toSlot
		        };
		    },
	
		    addValue: function(data, fields) {
		        var valueFields = data.valueFields;
		        if (!isNumber(valueFields.from)) {
		            valueFields.from = valueFields.to;
		        }
	
		        if (!isNumber(valueFields.to)) {
		            valueFields.to = valueFields.from;
		        }
	
		        CategoricalChart.fn.addValue.call(this, data, fields);
		    },
	
		    updateRange: function(value, fields) {
		        if (value !== null && isNumber(value.from) && isNumber(value.to)) {
		            var axisName = fields.series.axis;
		            var axisRange = this.valueAxisRanges[axisName] = this.valueAxisRanges[axisName] || { min: MAX_VALUE, max: MIN_VALUE };
		            var from = value.from;
		            var to = value.to;
	
		            axisRange.min = Math.min(axisRange.min, from, to);
		            axisRange.max = Math.max(axisRange.max, from, to);
		        }
		    },
	
		    formatPointValue: function(point, format) {
		        var value = point.value;
	
		        return this.chartService.format.auto(format, value.from, value.to);
		    },
	
		    animationPoints: function() {
		        var points = this.points;
		        var result = [];
		        for (var idx = 0; idx < points.length; idx++) {
		            var point = points[idx];
		            if (point) {
		                result.push((point.fromPoint || {}).marker);
		                result.push((point.toPoint || {}).marker);
		            }
		        }
	
		        return result.concat(this._segments);
		    }
		});
	
		deepExtend(RangeAreaChart.prototype, LineChartMixin, ClipAnimationMixin);
	
		var OHLCPoint = Candlestick.extend({
		    reflow: function(box) {
		        var ref = this;
		        var options = ref.options;
		        var value = ref.value;
		        var chart = ref.owner;
		        var valueAxis = chart.seriesValueAxis(options);
		        var oPoints = [];
		        var cPoints = [];
		        var lhPoints = [];
	
		        var lhSlot = valueAxis.getSlot(value.low, value.high);
		        var oSlot = valueAxis.getSlot(value.open, value.open);
		        var cSlot = valueAxis.getSlot(value.close, value.close);
	
		        oSlot.x1 = cSlot.x1 = lhSlot.x1 = box.x1;
		        oSlot.x2 = cSlot.x2 = lhSlot.x2 = box.x2;
	
		        var mid = lhSlot.center().x;
	
		        oPoints.push([ oSlot.x1, oSlot.y1 ]);
		        oPoints.push([ mid, oSlot.y1 ]);
		        cPoints.push([ mid, cSlot.y1 ]);
		        cPoints.push([ cSlot.x2, cSlot.y1 ]);
		        lhPoints.push([ mid, lhSlot.y1 ]);
		        lhPoints.push([ mid, lhSlot.y2 ]);
	
		        this.lines = [
		            oPoints, cPoints, lhPoints
		        ];
	
		        this.box = lhSlot.clone().wrap(oSlot.clone().wrap(cSlot));
	
		        this.reflowNote();
		    },
	
		    createBody: function() {}
		});
	
		var OHLCChart = CandlestickChart.extend({
		    pointType: function() {
		        return OHLCPoint;
		    }
		});
	
		var WaterfallSegment = ChartElement.extend({
		    init: function(from, to, series) {
		        ChartElement.fn.init.call(this);
	
		        this.from = from;
		        this.to = to;
		        this.series = series;
		    },
	
		    linePoints: function() {
		        var from = this.from;
		        var ref = this;
		        var fromBox = ref.from.box;
		        var toBox = ref.to.box;
		        var points = [];
	
		        if (from.isVertical) {
		            var y = from.aboveAxis ? fromBox.y1 : fromBox.y2;
		            points.push(
		                [ fromBox.x1, y ],
		                [ toBox.x2, y ]
		            );
		        } else {
		            var x = from.aboveAxis ? fromBox.x2 : fromBox.x1;
		            points.push(
		                [ x, fromBox.y1 ],
		                [ x, toBox.y2 ]
		            );
		        }
	
		        return points;
		    },
	
		    createVisual: function() {
		        ChartElement.fn.createVisual.call(this);
	
		        var line = this.series.line || {};
	
		        var path = Path.fromPoints(this.linePoints(), {
		            stroke: {
		                color: line.color,
		                width: line.width,
		                opacity: line.opacity,
		                dashType: line.dashType
		            }
		        });
	
		        alignPathToPixel(path);
		        this.visual.append(path);
		    }
		});
	
		setDefaultOptions(WaterfallSegment, {
		    animation: {
		        type: FADEIN,
		        delay: INITIAL_ANIMATION_DURATION
		    }
		});
	
		var WaterfallChart = BarChart.extend({
		    render: function() {
		        BarChart.fn.render.call(this);
		        this.createSegments();
		    },
	
		    traverseDataPoints: function(callback) {
		        var this$1 = this;
	
		        var series = this.options.series;
		        var totalCategories = categoriesCount(series);
		        var isVertical = !this.options.invertAxes;
	
		        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
		            var currentSeries = series[seriesIx];
		            var total = 0;
		            var runningTotal = 0;
	
		            for (var categoryIx = 0; categoryIx < totalCategories; categoryIx++) {
		                var data = SeriesBinder.current.bindPoint(currentSeries, categoryIx);
		                var value = data.valueFields.value;
		                var summary = data.fields.summary;
		                var from = total;
		                var to = (void 0);
	
		                if (summary) {
		                    if (summary.toLowerCase() === "total") {
		                        data.valueFields.value = total;
		                        from = 0;
		                        to = total;
		                    } else {
		                        data.valueFields.value = runningTotal;
		                        to = from - runningTotal;
		                        runningTotal = 0;
		                    }
		                } else if (isNumber(value)) {
		                    runningTotal += value;
		                    total += value;
		                    to = total;
		                }
	
		                callback(data, {
		                    category: this$1.categoryAxis.categoryAt(categoryIx),
		                    categoryIx: categoryIx,
		                    series: currentSeries,
		                    seriesIx: seriesIx,
		                    total: total,
		                    runningTotal: runningTotal,
		                    from: from,
		                    to: to,
		                    isVertical: isVertical
		                });
		            }
		        }
		    },
	
		    updateRange: function(value, fields) {
		        BarChart.fn.updateRange.call(this, { value: fields.to }, fields);
		    },
	
		    aboveAxis: function(point) {
		        return point.value >= 0;
		    },
	
		    plotRange: function(point) {
		        return [ point.from, point.to ];
		    },
	
		    createSegments: function() {
		        var this$1 = this;
	
		        var series = this.options.series;
		        var seriesPoints = this.seriesPoints;
		        var segments = this.segments = [];
	
		        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
		            var currentSeries = series[seriesIx];
		            var points = seriesPoints[seriesIx];
	
		            if (points) {
		                var prevPoint = (void 0);
		                for (var pointIx = 0; pointIx < points.length; pointIx++) {
		                    var point = points[pointIx];
	
		                    if (point && prevPoint) {
		                        var segment = new WaterfallSegment(prevPoint, point, currentSeries);
		                        segments.push(segment);
		                        this$1.append(segment);
		                    }
	
		                    prevPoint = point;
		                }
		            }
		        }
		    }
		});
	
		var AREA_SERIES = [ AREA, VERTICAL_AREA, RANGE_AREA, VERTICAL_RANGE_AREA ];
		var OUT_OF_RANGE_SERIES = [ LINE, VERTICAL_LINE ].concat(AREA_SERIES);
	
		var CategoricalPlotArea = PlotAreaBase.extend({
		    initFields: function(series) {
		        var this$1 = this;
	
		        this.namedCategoryAxes = {};
		        this.namedValueAxes = {};
		        this.valueAxisRangeTracker = new AxisGroupRangeTracker();
	
		        if (series.length > 0) {
		            this.invertAxes = inArray(
		                series[0].type, [ BAR, BULLET, VERTICAL_LINE, VERTICAL_AREA, VERTICAL_RANGE_AREA,
		                                 RANGE_BAR, HORIZONTAL_WATERFALL, VERTICAL_BOX_PLOT ]
		            );
	
		            for (var i = 0; i < series.length; i++) {
		                var stack = series[i].stack;
		                if (stack && stack.type === "100%") {
		                    this$1.stack100 = true;
		                    break;
		                }
		            }
		        }
	
		    },
	
		    render: function(panes) {
		        if (panes === void 0) { panes = this.panes; }
	
		        this.createCategoryAxes(panes);
		        this.aggregateCategories(panes);
		        this.createCategoryAxesLabels(panes);
		        this.createCharts(panes);
		        this.createValueAxes(panes);
		    },
	
		    removeAxis: function(axis) {
		        var axisName = axis.options.name;
	
		        PlotAreaBase.fn.removeAxis.call(this, axis);
	
		        if (axis instanceof CategoryAxis) {
		            delete this.namedCategoryAxes[axisName];
		        } else {
		            this.valueAxisRangeTracker.reset(axisName);
		            delete this.namedValueAxes[axisName];
		        }
	
		        if (axis === this.categoryAxis) {
		            delete this.categoryAxis;
		        }
	
		        if (axis === this.valueAxis) {
		            delete this.valueAxis;
		        }
		    },
	
		    createCharts: function(panes) {
		        var this$1 = this;
	
		        var seriesByPane = this.groupSeriesByPane();
	
		        for (var i = 0; i < panes.length; i++) {
		            var pane = panes[i];
		            var paneSeries = seriesByPane[pane.options.name || "default"] || [];
		            this$1.addToLegend(paneSeries);
	
		            var visibleSeries = this$1.filterVisibleSeries(paneSeries);
		            if (!visibleSeries) {
		                continue;
		            }
	
		            var groups = this$1.groupSeriesByCategoryAxis(visibleSeries);
		            for (var groupIx = 0; groupIx < groups.length; groupIx++) {
		                this$1.createChartGroup(groups[groupIx], pane);
		            }
		        }
		    },
	
		    createChartGroup: function(series, pane) {
		        this.createAreaChart(
		            filterSeriesByType(series, [ AREA, VERTICAL_AREA ]), pane
		        );
	
		        this.createRangeAreaChart(
		            filterSeriesByType(series, [ RANGE_AREA, VERTICAL_RANGE_AREA ]), pane
		        );
	
		        this.createBarChart(
		            filterSeriesByType(series, [ COLUMN, BAR ]), pane
		        );
	
		        this.createRangeBarChart(
		            filterSeriesByType(series, [ RANGE_COLUMN, RANGE_BAR ]), pane
		        );
	
		        this.createBulletChart(
		            filterSeriesByType(series, [ BULLET, VERTICAL_BULLET ]), pane
		        );
	
		        this.createCandlestickChart(
		            filterSeriesByType(series, CANDLESTICK), pane
		        );
	
		        this.createBoxPlotChart(
		            filterSeriesByType(series, [ BOX_PLOT, VERTICAL_BOX_PLOT ]), pane
		        );
	
		        this.createOHLCChart(
		            filterSeriesByType(series, OHLC), pane
		        );
	
		        this.createWaterfallChart(
		            filterSeriesByType(series, [ WATERFALL, HORIZONTAL_WATERFALL ]), pane
		        );
	
		        this.createLineChart(
		            filterSeriesByType(series, [ LINE, VERTICAL_LINE ]), pane
		        );
		    },
	
		    aggregateCategories: function(panes) {
		        var this$1 = this;
	
		        var series = this.srcSeries || this.series;
		        var processedSeries = [];
		        this._currentPointsCache = {};
		        this._seriesPointsCache = this._seriesPointsCache || {};
	
		        for (var i = 0; i < series.length; i++) {
		            var currentSeries = series[i];
		            var categoryAxis = this$1.seriesCategoryAxis(currentSeries);
		            var axisPane = this$1.findPane(categoryAxis.options.pane);
		            var dateAxis = equalsIgnoreCase(categoryAxis.options.type, DATE);
	
		            if ((dateAxis || currentSeries.categoryField) && inArray(axisPane, panes)) {
		                currentSeries = this$1.aggregateSeries(currentSeries, categoryAxis);
		            } else {
		                currentSeries = this$1.filterSeries(currentSeries, categoryAxis);
		            }
	
		            processedSeries.push(currentSeries);
		        }
	
		        this._seriesPointsCache = this._currentPointsCache;
		        this._currentPointsCache = null;
	
		        this.srcSeries = series;
		        this.series = processedSeries;
		    },
	
		    filterSeries: function(series, categoryAxis) {
		        var dataLength = (series.data || {}).length;
		        categoryAxis._seriesMax = Math.max(categoryAxis._seriesMax || 0, dataLength);
	
		        if (!(isNumber(categoryAxis.options.min) || isNumber(categoryAxis.options.max))) {
		            return series;
		        }
	
		        var range = categoryAxis.currentRangeIndices();
		        var outOfRangePoints = inArray(series.type, OUT_OF_RANGE_SERIES);
		        var currentSeries = deepExtend({}, series);
	
		        currentSeries.data = (currentSeries.data || []).slice(range.min, range.max + 1);
	
		        if (outOfRangePoints) {
		            createOutOfRangePoints(currentSeries, range, dataLength, function (idx) { return ({
		                item: series.data[idx],
		                category: categoryAxis.categoryAt(idx, true),
		                categoryIx: idx - range.min
		            }); }, function (idx) { return defined(series.data[idx]); });
		        }
	
		        return currentSeries;
		    },
	
		    clearSeriesPointsCache: function() {
		        this._seriesPointsCache = {};
		    },
	
		    seriesSourcePoints: function(series, categoryAxis) {
		        var this$1 = this;
	
		        var key = (series.index) + ";" + (categoryAxis.categoriesHash());
		        if (this._seriesPointsCache[key]) {
		            this._currentPointsCache[key] = this._seriesPointsCache[key];
		            return this._seriesPointsCache[key];
		        }
	
		        var axisOptions = categoryAxis.options;
		        var srcCategories = axisOptions.srcCategories;
		        var dateAxis = equalsIgnoreCase(axisOptions.type, DATE);
		        var srcData = series.data;
		        var getFn = dateAxis ? getDateField : getField;
		        var result = [];
		        if (!dateAxis) {
		            categoryAxis.mapCategories();//fixes major performance issue caused by searching for the index for large data
		        }
	
		        for (var idx = 0; idx < srcData.length; idx++) {
		            var category = (void 0);
		            if (series.categoryField) {
		                category = getFn(series.categoryField, srcData[idx], this$1.chartService.intl);
		            } else {
		                category = srcCategories[idx];
		            }
	
		            if (defined(category) && category !== null) {
		                var categoryIx = categoryAxis.totalIndex(category);
		                result[categoryIx] = result[categoryIx] || { items: [], category: category };
		                result[categoryIx].items.push(idx);
		            }
		        }
	
		        this._currentPointsCache[key] = result;
	
		        return result;
		    },
	
		    aggregateSeries: function(series, categoryAxis) {
		        var srcData = series.data;
		        if (!srcData.length) {
		            return series;
		        }
	
		        var srcPoints = this.seriesSourcePoints(series, categoryAxis);
		        var result = deepExtend({}, series);
		        var aggregator = new SeriesAggregator(deepExtend({}, series), SeriesBinder.current, DefaultAggregates.current);
		        var data = result.data = [];
		        var dataItems = categoryAxis.options.dataItems || [];
	
		        var range = categoryAxis.currentRangeIndices();
		        var categoryItem = function (idx) {
		            var categoryIdx = idx - range.min;
		            var point = srcPoints[idx];
		            if (!point) {
		                point = srcPoints[idx] = {};
		            }
	
		            point.categoryIx = categoryIdx;
	
		            if (!point.item) {
		                var category = categoryAxis.categoryAt(idx, true);
		                point.category = category;
		                point.item = aggregator.aggregatePoints(point.items, category);
		            }
	
		            return point;
		        };
	
		        for (var idx = range.min; idx <= range.max; idx++) {
		            var point = categoryItem(idx);
		            data[point.categoryIx] = point.item;
	
		            if (point.items && point.items.length) {
		                dataItems[point.categoryIx] = point.item;
		            }
		        }
	
		        if (inArray(result.type, OUT_OF_RANGE_SERIES)) {
		            createOutOfRangePoints(result, range, categoryAxis.totalCount(), categoryItem, function (idx) { return srcPoints[idx]; });
		        }
	
		        categoryAxis.options.dataItems = dataItems;
	
		        return result;
		    },
	
		    appendChart: function(chart, pane) {
		        var series = chart.options.series;
		        var categoryAxis = this.seriesCategoryAxis(series[0]);
		        var categories = categoryAxis.options.categories;
		        var categoriesToAdd = Math.max(0, categoriesCount(series) - categories.length);
	
		        if (categoriesToAdd > 0) {//consider setting an option to axis instead of adding fake categories
		            categories = categoryAxis.options.categories = categoryAxis.options.categories.slice(0);
		            while (categoriesToAdd--) {
		                categories.push("");
		            }
		        }
	
		        this.valueAxisRangeTracker.update(chart.valueAxisRanges);
	
		        PlotAreaBase.fn.appendChart.call(this, chart, pane);
		    },
	
		    seriesPaneName: function(series) {
		        var options = this.options;
		        var axisName = series.axis;
		        var axisOptions = [].concat(options.valueAxis);
		        var axis = grep(axisOptions, function(a) { return a.name === axisName; })[0];
		        var panes = options.panes || [ {} ];
		        var defaultPaneName = (panes[0] || {}).name || "default";
		        var paneName = (axis || {}).pane || defaultPaneName;
	
		        return paneName;
		    },
	
		    seriesCategoryAxis: function(series) {
		        var axisName = series.categoryAxis;
		        var axis = axisName ? this.namedCategoryAxes[axisName] : this.categoryAxis;
	
		        if (!axis) {
		            throw new Error("Unable to locate category axis with name " + axisName);
		        }
	
		        return axis;
		    },
	
		    stackableChartOptions: function(firstSeries, pane) {
		        var stack = firstSeries.stack;
		        var isStacked100 = stack && stack.type === "100%";
		        var clip = pane.options.clip;
	
		        return {
		            isStacked: stack,
		            isStacked100: isStacked100,
		            clip: clip
		        };
		    },
	
		    groupSeriesByCategoryAxis: function(series) {
		        var categoryAxes = [];
		        var unique = {};
		        for (var idx = 0; idx < series.length; idx++) {
		            var name = series[idx].categoryAxis || "$$default$$";
		            if (!unique.hasOwnProperty(name)) {
		                unique[name] = true;
		                categoryAxes.push(name);
		            }
		        }
	
		        var groups = [];
		        for (var axisIx = 0; axisIx < categoryAxes.length; axisIx++) {
		            var axis = categoryAxes[axisIx];
		            var axisSeries = groupSeries(series, axis, axisIx);
		            if (axisSeries.length === 0) {
		                continue;
		            }
	
		            groups.push(axisSeries);
		        }
	
		        return groups;
		    },
	
		    createBarChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var barChart = new BarChart(this, $.extend({
		            series: series,
		            invertAxes: this.invertAxes,
		            gap: firstSeries.gap,
		            spacing: firstSeries.spacing
		        }, this.stackableChartOptions(firstSeries, pane)));
	
		        this.appendChart(barChart, pane);
		    },
	
		    createRangeBarChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var rangeColumnChart = new RangeBarChart(this, {
		            series: series,
		            invertAxes: this.invertAxes,
		            gap: firstSeries.gap,
		            spacing: firstSeries.spacing
		        });
	
		        this.appendChart(rangeColumnChart, pane);
		    },
	
		    createBulletChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var bulletChart = new BulletChart(this, {
		            series: series,
		            invertAxes: this.invertAxes,
		            gap: firstSeries.gap,
		            spacing: firstSeries.spacing,
		            clip: pane.options.clip
		        });
	
		        this.appendChart(bulletChart, pane);
		    },
	
		    createLineChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var lineChart = new LineChart(this, $.extend({
		            invertAxes: this.invertAxes,
		            series: series
		        }, this.stackableChartOptions(firstSeries, pane)));
	
		        this.appendChart(lineChart, pane);
		    },
	
		    createAreaChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var areaChart = new AreaChart(this, $.extend({
		            invertAxes: this.invertAxes,
		            series: series
		        }, this.stackableChartOptions(firstSeries, pane)));
	
		        this.appendChart(areaChart, pane);
		    },
	
		    createRangeAreaChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var rangeAreaChart = new RangeAreaChart(this, {
		            invertAxes: this.invertAxes,
		            series: series,
		            clip: pane.options.clip
		        });
	
		        this.appendChart(rangeAreaChart, pane);
		    },
	
		    createOHLCChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var chart = new OHLCChart(this, {
		            invertAxes: this.invertAxes,
		            gap: firstSeries.gap,
		            series: series,
		            spacing: firstSeries.spacing,
		            clip: pane.options.clip
		        });
	
		        this.appendChart(chart, pane);
		    },
	
		    createCandlestickChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var chart = new CandlestickChart(this, {
		            invertAxes: this.invertAxes,
		            gap: firstSeries.gap,
		            series: series,
		            spacing: firstSeries.spacing,
		            clip: pane.options.clip
		        });
	
		        this.appendChart(chart, pane);
		    },
	
		    createBoxPlotChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var chart = new BoxPlotChart(this, {
		            invertAxes: this.invertAxes,
		            gap: firstSeries.gap,
		            series: series,
		            spacing: firstSeries.spacing,
		            clip: pane.options.clip
		        });
	
		        this.appendChart(chart, pane);
		    },
	
		    createWaterfallChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var waterfallChart = new WaterfallChart(this, {
		            series: series,
		            invertAxes: this.invertAxes,
		            gap: firstSeries.gap,
		            spacing: firstSeries.spacing
		        });
	
		        this.appendChart(waterfallChart, pane);
		    },
	
		    axisRequiresRounding: function(categoryAxisName, categoryAxisIndex) {
		        var this$1 = this;
	
		        var centeredSeries = filterSeriesByType(this.series, EQUALLY_SPACED_SERIES);
	
		        for (var seriesIx = 0; seriesIx < this.series.length; seriesIx++) {
		            var currentSeries = this$1.series[seriesIx];
		            if (inArray(currentSeries.type, AREA_SERIES)) {
		                var line = currentSeries.line;
		                if (line && line.style === STEP) {
		                    centeredSeries.push(currentSeries);
		                }
		            }
		        }
	
		        for (var seriesIx$1 = 0; seriesIx$1 < centeredSeries.length; seriesIx$1++) {
		            var seriesAxis = centeredSeries[seriesIx$1].categoryAxis || "";
		            if (seriesAxis === categoryAxisName || (!seriesAxis && categoryAxisIndex === 0)) {
		                return true;
		            }
		        }
		    },
	
		    aggregatedAxis: function(categoryAxisName, categoryAxisIndex) {
		        var series = this.series;
	
		        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
		            var seriesAxis = series[seriesIx].categoryAxis || "";
		            if ((seriesAxis === categoryAxisName || (!seriesAxis && categoryAxisIndex === 0)) && series[seriesIx].categoryField) {
		                return true;
		            }
		        }
		    },
	
		    createCategoryAxesLabels: function() {
		        var axes = this.axes;
		        for (var i = 0; i < axes.length; i++) {
		            if (axes[i] instanceof CategoryAxis) {
		                axes[i].createLabels();
		            }
		        }
		    },
	
		    createCategoryAxes: function(panes) {
		        var this$1 = this;
	
		        var invertAxes = this.invertAxes;
		        var definitions = [].concat(this.options.categoryAxis);
		        var axes = [];
	
		        for (var i = 0; i < definitions.length; i++) {
		            var axisOptions = definitions[i];
		            var axisPane = this$1.findPane(axisOptions.pane);
	
		            if (inArray(axisPane, panes)) {
		                var name = axisOptions.name;
		                var categories = axisOptions.categories; if (categories === void 0) { categories = []; }
		                axisOptions = deepExtend({
		                    vertical: invertAxes,
		                    reverse: !invertAxes && this$1.chartService.rtl,
		                    axisCrossingValue: invertAxes ? MAX_VALUE : 0
		                }, axisOptions);
	
		                if (!defined(axisOptions.justified)) {
		                    axisOptions.justified = this$1.isJustified();
		                }
	
		                if (this$1.axisRequiresRounding(name, i)) {
		                    axisOptions.justified = false;
		                }
	
		                var categoryAxis = (void 0);
	
		                if (isDateAxis(axisOptions, categories[0])) {
		                    categoryAxis = new dataviz.DateCategoryAxis(axisOptions, this$1.chartService);
		                } else {
		                    categoryAxis = new CategoryAxis(axisOptions, this$1.chartService);
		                }
	
		                definitions[i].categories = categoryAxis.options.srcCategories;
	
		                if (name) {
		                    if (this$1.namedCategoryAxes[name]) {
		                        throw new Error(("Category axis with name " + name + " is already defined"));
		                    }
		                    this$1.namedCategoryAxes[name] = categoryAxis;
		                }
	
		                categoryAxis.axisIndex = i;
		                axes.push(categoryAxis);
		                this$1.appendAxis(categoryAxis);
		            }
		        }
	
		        var primaryAxis = this.categoryAxis || axes[0];
		        this.categoryAxis = primaryAxis;
	
		        if (invertAxes) {
		            this.axisY = primaryAxis;
		        } else {
		            this.axisX = primaryAxis;
		        }
		    },
	
		    isJustified: function() {
		        var series = this.series;
	
		        for (var i = 0; i < series.length; i++) {
		            var currentSeries = series[i];
		            if (!inArray(currentSeries.type, AREA_SERIES)) {
		                return false;
		            }
		        }
	
		        return true;
		    },
	
		    createValueAxes: function(panes) {
		        var this$1 = this;
	
		        var tracker = this.valueAxisRangeTracker;
		        var defaultRange = tracker.query();
		        var definitions = [].concat(this.options.valueAxis);
		        var invertAxes = this.invertAxes;
		        var baseOptions = { vertical: !invertAxes, reverse: invertAxes && this.chartService.rtl };
		        var axes = [];
	
		        if (this.stack100) {
		            baseOptions.roundToMajorUnit = false;
		            baseOptions.labels = { format: "P0" };
		        }
	
		        for (var i = 0; i < definitions.length; i++) {
		            var axisOptions = definitions[i];
		            var axisPane = this$1.findPane(axisOptions.pane);
	
		            if (inArray(axisPane, panes)) {
		                var name = axisOptions.name;
		                var defaultAxisRange = equalsIgnoreCase(axisOptions.type, LOGARITHMIC) ? { min: 0.1, max: 1 } : { min: 0, max: 1 };
		                var range = tracker.query(name) || defaultRange || defaultAxisRange;
	
		                if (i === 0 && range && defaultRange) {
		                    range.min = Math.min(range.min, defaultRange.min);
		                    range.max = Math.max(range.max, defaultRange.max);
		                }
	
		                var axisType = (void 0);
		                if (equalsIgnoreCase(axisOptions.type, LOGARITHMIC)) {
		                    axisType = dataviz.LogarithmicAxis;
		                } else {
		                    axisType = dataviz.NumericAxis;
		                }
	
		                var valueAxis = new axisType(range.min, range.max,
		                    deepExtend({}, baseOptions, axisOptions),
		                    this$1.chartService
		                );
	
		                if (name) {
		                    if (this$1.namedValueAxes[name]) {
		                        throw new Error(("Value axis with name " + name + " is already defined"));
		                    }
		                    this$1.namedValueAxes[name] = valueAxis;
		                }
		                valueAxis.axisIndex = i;
	
		                axes.push(valueAxis);
		                this$1.appendAxis(valueAxis);
		            }
		        }
	
		        var primaryAxis = this.valueAxis || axes[0];
		        this.valueAxis = primaryAxis;
	
		        if (invertAxes) {
		            this.axisX = primaryAxis;
		        } else {
		            this.axisY = primaryAxis;
		        }
		    },
	
		    _dispatchEvent: function(chart, e, eventType) {
		        var coords = chart._eventCoordinates(e);
		        var point = new Point(coords.x, coords.y);
		        var pane = this.pointPane(point);
		        var categories = [];
		        var values = [];
	
		        if (!pane) {
		            return;
		        }
	
		        var allAxes = pane.axes;
		        for (var i = 0; i < allAxes.length; i++) {
		            var axis = allAxes[i];
		            if (axis.getValue) {
		                appendIfNotNull(values, axis.getValue(point));
		            } else {
		                appendIfNotNull(categories, axis.getCategory(point));
		            }
		        }
	
		        if (categories.length === 0) {
		            appendIfNotNull(categories, this.categoryAxis.getCategory(point));
		        }
	
		        if (categories.length > 0 && values.length > 0) {
		            chart.trigger(eventType, {
		                element: eventElement(e),
		                originalEvent: e,
		                category: singleItemOrArray(categories),
		                value: singleItemOrArray(values)
		            });
		        }
		    },
	
		    pointPane: function(point) {
		        var panes = this.panes;
	
		        for (var i = 0; i < panes.length; i++) {
		            var currentPane = panes[i];
		            if (currentPane.contentBox.containsPoint(point)) {
		                return currentPane;
		            }
		        }
		    },
	
		    updateAxisOptions: function(axis, options) {
		        updateAxisOptions(this.options, axis, options);
		        updateAxisOptions(this.originalOptions, axis, options);
		    }
		});
	
		function updateAxisOptions(targetOptions, axis, options) {
		    var axesOptions = axis instanceof CategoryAxis ? [].concat(targetOptions.categoryAxis) : [].concat(targetOptions.valueAxis);
		    deepExtend(axesOptions[axis.axisIndex], options);
		}
	
		function groupSeries(series, axis, axisIx) {
		    return grep(series, function(s) {
		        return (axisIx === 0 && !s.categoryAxis) || (s.categoryAxis === axis);
		    });
		}
	
		setDefaultOptions(CategoricalPlotArea, {
		    categoryAxis: {},
		    valueAxis: {}
		});
	
		deepExtend(CategoricalPlotArea.prototype, PlotAreaEventsMixin);
	
		var Highlight = Class.extend({
		    init: function() {
	
		        this._points = [];
		    },
	
		    destroy: function() {
		        this._points = [];
		    },
	
		    show: function(points) {
		        var this$1 = this;
	
		        var arrayPoints = [].concat(points);
		        this.hide();
	
		        for (var i = 0; i < arrayPoints.length; i++) {
		            var point = arrayPoints[i];
		            if (point && point.toggleHighlight && point.hasHighlight()) {
		                this$1.togglePointHighlight(point, true);
		                this$1._points.push(point);
		            }
		        }
		    },
	
		    togglePointHighlight: function(point, show) {
		        var toggleHandler = (point.options.highlight || {}).toggle;
		        if (toggleHandler) {
		            var eventArgs = {
		                category: point.category,
		                series: point.series,
		                dataItem: point.dataItem,
		                value: point.value,
		                stackValue: point.stackValue,
		                preventDefault: preventDefault,
		                visual: point.highlightVisual(),
		                show: show
		            };
		            toggleHandler(eventArgs);
		            if (!eventArgs._defaultPrevented) {
		                point.toggleHighlight(show);
		            }
		        } else {
		            point.toggleHighlight(show);
		        }
		    },
	
		    hide: function() {
		        var this$1 = this;
	
		        var points = this._points;
		        while (points.length) {
		            this$1.togglePointHighlight(points.pop(), false);
		        }
		    },
	
		    isHighlighted: function(element) {
		        var points = this._points;
	
		        for (var i = 0; i < points.length; i++) {
		            var point = points[i];
		            if (element === point) {
		                return true;
		            }
		        }
	
		        return false;
		    }
		});
	
		function preventDefault() {
		    this._defaultPrevented = true;
		}
	
		function acceptKey(e, mouseKey) {
		    var key = (mouseKey || "").toLowerCase();
		    var event = e.event;
		    var accept = (key === "none" && !(event.ctrlKey || event.shiftKey || event.altKey)) || event[key + "Key"];
	
		    return accept;
		}
	
		function toChartAxisRanges(axisRanges) {
		    var ranges = {};
		    for (var idx = 0; idx < axisRanges.length; idx++) {
		        var axisRange = axisRanges[idx];
		        if (axisRange.axis.options.name) {
		            ranges[axisRange.axis.options.name] = {
		                min: axisRange.range.min,
		                max: axisRange.range.max
		            };
		        }
		    }
		    return ranges;
		}
	
		var Pannable = Class.extend({
		    init: function(plotArea, options) {
	
		        this.plotArea = plotArea;
		        this.options = deepExtend({}, this.options, options);
		    },
	
		    start: function(e) {
		        this._active = acceptKey(e, this.options.key);
		        return this._active;
		    },
	
		    move: function(e) {
		        if (this._active) {
		            var axisRanges = this.axisRanges = this._panAxes(e, X).concat(this._panAxes(e, Y));
		            if (axisRanges.length) {
		                this.axisRanges = axisRanges;
		                return toChartAxisRanges(axisRanges);
		            }
		        }
		    },
	
		    end: function() {
		        var active = this._active;
		        this._active = false;
	
		        return active;
		    },
	
		    pan: function() {
		        var ref = this;
		        var plotArea = ref.plotArea;
		        var axisRanges = ref.axisRanges;
		        if (axisRanges.length) {
		            for (var idx = 0; idx < axisRanges.length; idx++) {
		                var range = axisRanges[idx];
		                plotArea.updateAxisOptions(range.axis, range.range);
		            }
		            plotArea.redraw(plotArea.panes);
		        }
		    },
	
		    destroy: function() {
		        delete this.plotArea;
		    },
	
		    _panAxes: function(e, position) {
		        var plotArea = this.plotArea;
		        var delta = -e[position].delta;
		        var lock = (this.options.lock || "").toLowerCase();
		        var updatedAxes = [];
	
		        if (delta !== 0 && (lock || "").toLowerCase() !== position) {
		            var axes = plotArea.axes;
		            for (var idx = 0; idx < axes.length; idx++) {
		                var axis = axes[idx];
	
		                if (position === X && !axis.options.vertical || position === Y && axis.options.vertical) {
		                    var range = axis.pan(delta);
	
		                    if (range) {
		                        range.limitRange = true;
		                        updatedAxes.push({
		                            axis: axis,
		                            range: range
		                        });
		                    }
		                }
		            }
		        }
	
		        return updatedAxes;
		    }
		});
	
		Pannable.prototype.options = {
		    key: "none",
		    lock: "none"
		};
	
		var ZoomSelection = Class.extend({
		    init: function(chart, options) {
	
		        this.chart = chart;
		        this.options = deepExtend({}, this.options, options);
		        this.createElement();
		    },
	
		    createElement: function() {
		        var marquee = this._marquee = document.createElement("div");
		        marquee.className = "k-marquee";
		        var marqueeColor = document.createElement("div");
		        marqueeColor.className = "k-marquee-color";
		        marquee.appendChild(marqueeColor);
		    },
	
		    removeElement: function() {
		        if (this._marquee.parentNode) {
		            this._marquee.parentNode.removeChild(this._marquee);
		        }
		    },
	
		    setStyles: function(styles) {
		        elementStyles(this._marquee, styles);
		    },
	
		    start: function(e) {
		        if (acceptKey(e, this.options.key)) {
		            var chart = this.chart;
		            var point = chart._eventCoordinates(e);
		            var zoomPane = this._zoomPane = chart._plotArea.paneByPoint(point);
		            if (zoomPane && zoomPane.clipBox()) {
		                var clipBox = zoomPane.clipBox().clone();
		                var offset = this._elementOffset();
	
		                clipBox.translate(offset.left, offset.top);
		                this._zoomPaneClipBox = clipBox;
	
		                document.body.appendChild(this._marquee);
		                this.setStyles({
		                    left: e.pageX + 1,
		                    top: e.pageY + 1,
		                    width: 0,
		                    height: 0
		                });
	
		                return true;
		            }
		        }
		        return false;
		    },
	
		    _elementOffset: function() {
		        var chartElement = this.chart.element;
		        var ref = elementStyles(chartElement, [ "paddingLeft", "paddingTop" ]);
		        var paddingLeft = ref.paddingLeft;
		        var paddingTop = ref.paddingTop;
		        var offset = dataviz.elementOffset(chartElement);
	
		        return {
		            left: paddingLeft + offset.left,
		            top: paddingTop + offset.top
		        };
		    },
	
		    move: function(e) {
		        var zoomPane = this._zoomPane;
		        if (zoomPane) {
		            this.setStyles(this._selectionPosition(e));
		        }
		    },
	
		    end: function(e) {
		        var zoomPane = this._zoomPane;
		        if (zoomPane) {
		            var elementOffset$$1 = this._elementOffset();
		            var selectionPosition = this._selectionPosition(e);
		            selectionPosition.left -= elementOffset$$1.left;
		            selectionPosition.top -= elementOffset$$1.top;
	
		            var start = { x: selectionPosition.left, y: selectionPosition.top };
		            var end = { x: selectionPosition.left + selectionPosition.width, y: selectionPosition.top + selectionPosition.height };
		            this._updateAxisRanges(start, end);
	
		            this.removeElement();
		            delete this._zoomPane;
	
		            return toChartAxisRanges(this.axisRanges);
		        }
		    },
	
		    zoom: function() {
		        var axisRanges = this.axisRanges;
		        if (axisRanges && axisRanges.length) {
		            var plotArea = this.chart._plotArea;
		            for (var idx = 0; idx < axisRanges.length; idx++) {
		                var axisRange = axisRanges[idx];
		                plotArea.updateAxisOptions(axisRange.axis, axisRange.range);
		            }
		            plotArea.redraw(plotArea.panes);
		        }
		    },
	
		    destroy: function() {
		        this.removeElement();
		        delete this._marquee;
		        delete this.chart;
		    },
	
		    _updateAxisRanges: function(start, end) {
		        var lock = (this.options.lock || "").toLowerCase();
		        var axisRanges = [];
	
		        var axes = this._zoomPane.axes;
		        for (var idx = 0; idx < axes.length; idx++) {
		            var axis = axes[idx];
		            var vertical = axis.options.vertical;
		            if (!(lock === X && !vertical) && !(lock === Y && vertical)) {
		                var range = axis.pointsRange(start, end);
		                if (range) {
		                    axisRanges.push({
		                        axis: axis,
		                        range: range
		                    });
		                }
		            }
		        }
	
		        this.axisRanges = axisRanges;
		    },
	
		    _selectionPosition: function(e) {
		        var clipBox = this._zoomPaneClipBox;
		        var startLocation = {
		            x: e.x.startLocation,
		            y: e.y.startLocation
		        };
		        var pageX = e.x.location;
		        var pageY = e.y.location;
		        var lock = (this.options.lock || "").toLowerCase();
		        var left = Math.min(startLocation.x, pageX);
		        var top = Math.min(startLocation.y, pageY);
		        var width = Math.abs(startLocation.x - pageX);
		        var height = Math.abs(startLocation.y - pageY);
	
		        if (lock === X) {
		            left = clipBox.x1;
		            width = clipBox.width();
		        }
		        if (lock === Y) {
		            top = clipBox.y1;
		            height = clipBox.height();
		        }
	
		        if (pageX > clipBox.x2) {
		            width = clipBox.x2 - startLocation.x;
		        }
	
		        if (pageX < clipBox.x1) {
		            width = startLocation.x - clipBox.x1;
		        }
	
		        if (pageY > clipBox.y2) {
		            height = clipBox.y2 - startLocation.y;
		        }
	
		        if (pageY < clipBox.y1) {
		            height = startLocation.y - clipBox.y1;
		        }
	
		        return {
		            left: Math.max(left, clipBox.x1),
		            top: Math.max(top, clipBox.y1),
		            width: width,
		            height: height
		        };
		    }
		});
	
		ZoomSelection.prototype.options = {
		    key: "shift",
		    lock: "none"
		};
	
		var MousewheelZoom = Class.extend({
		    init: function(chart, options) {
	
		        this.chart = chart;
		        this.options = deepExtend({}, this.options, options);
		    },
	
		    updateRanges: function(delta) {
		        var lock = (this.options.lock || "").toLowerCase();
		        var axisRanges = [];
		        var axes = this.chart._plotArea.axes;
	
		        for (var idx = 0; idx < axes.length; idx++) {
		            var axis = axes[idx];
		            var vertical = axis.options.vertical;
	
		            if (!(lock === X && !vertical) && !(lock === Y && vertical)) {
		                var range = axis.zoomRange(-delta);
	
		                if (range) {
		                    axisRanges.push({
		                        axis: axis,
		                        range: range
		                    });
		                }
		            }
		        }
	
		        this.axisRanges = axisRanges;
		        return toChartAxisRanges(axisRanges);
		    },
	
		    zoom: function() {
		        var axisRanges = this.axisRanges;
		        if (axisRanges && axisRanges.length) {
		            var plotArea = this.chart._plotArea;
		            for (var idx = 0; idx < axisRanges.length; idx++) {
		                var axisRange = axisRanges[idx];
		                plotArea.updateAxisOptions(axisRange.axis, axisRange.range);
		            }
		            plotArea.redraw(plotArea.panes);
		        }
		    },
	
		    destroy: function() {
		        delete this.chart;
		    }
		});
	
		var LegendLayout = ChartElement.extend({
		    init: function(options, chartService) {
		        ChartElement.fn.init.call(this, options);
	
		        this.chartService = chartService;
		    },
	
		    render: function() {
		        var ref = this;
		        var children = ref.children;
		        var options = ref.options;
		        var vertical = options.vertical;
	
		        this.visual = new drawing.Layout(null, {
		            spacing: vertical ? 0 : options.spacing,
		            lineSpacing: vertical ? options.spacing : 0,
		            orientation: vertical ? "vertical" : "horizontal",
		            reverse: options.rtl,
		            alignItems: vertical ? "start" : "center"
		        });
	
		        for (var idx = 0; idx < children.length; idx++) {
		            var legendItem = children[idx];
		            legendItem.reflow(new Box());
		            legendItem.renderVisual();
		        }
		    },
	
		    reflow: function(box) {
		        this.visual.rect(box.toRect());
		        this.visual.reflow();
		        var bbox = this.visual.clippedBBox();
	
		        if (bbox) {
		            this.box = dataviz.rectToBox(bbox);
		        } else {
		            this.box = new Box();
		        }
		    },
	
		    renderVisual: function() {
		        this.addVisual();
		    },
	
		    createVisual: function() {}
		});
	
		var LegendItem = BoxElement.extend({
		    init: function(options) {
		        BoxElement.fn.init.call(this, options);
	
		        this.createContainer();
		        if (!options.rtl) {
		            this.createMarker();
		            this.createLabel();
		        } else {
		            this.createLabel();
		            this.createMarker();
		        }
		    },
	
		    createContainer: function() {
		        this.container = new dataviz.FloatElement({ vertical: false, wrap: false, align: CENTER, spacing: this.options.spacing });
		        this.append(this.container);
		    },
	
		    createMarker: function() {
		        this.container.append(new ShapeElement(this.markerOptions()));
		    },
	
		    markerOptions: function() {
		        var options = this.options;
		        var markerColor = options.markerColor;
		        return deepExtend({}, options.markers, {
		            background: markerColor,
		            border: {
		                color: markerColor
		            }
		        });
		    },
	
		    createLabel: function() {
		        var options = this.options;
		        var labelOptions = deepExtend({}, options.labels);
	
		        this.container.append(new TextBox(options.text, labelOptions));
		    },
	
		    renderComplete: function() {
		        BoxElement.fn.renderComplete.call(this);
	
		        var cursor = this.options.cursor || {};
		        var eventSink = this._itemOverlay = Path.fromRect(this.container.box.toRect(), {
		            fill: {
		                color: WHITE,
		                opacity: 0
		            },
		            stroke: null,
		            cursor: cursor.style || cursor
		        });
	
		        this.appendVisual(eventSink);
		    },
	
		    click: function(widget, e) {
		        var args = this.eventArgs(e);
	
		        if (!widget.trigger(LEGEND_ITEM_CLICK, args) && e && e.type === 'contextmenu') {
		            e.preventDefault();
		        }
		    },
	
		    over: function(widget, e) {
		        var args = this.eventArgs(e);
	
		        if (!widget.trigger(LEGEND_ITEM_HOVER, args)) {
		            widget._legendItemHover(args.seriesIndex, args.pointIndex);
		        }
	
		        // Don't trigger point hover for legend items
		        return true;
		    },
	
		    out: function(widget, e) {
		        widget._unsetActivePoint();
	
		        widget.trigger(LEGEND_ITEM_LEAVE, this.eventArgs(e));
		    },
	
		    eventArgs: function(e) {
		        var options = this.options;
	
		        return {
		            element: eventElement(e),
		            text: options.text,
		            series: options.series,
		            seriesIndex: options.series.index,
		            pointIndex: options.pointIndex
		        };
		    },
	
		    renderVisual: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var customVisual = options.visual;
	
		        if (customVisual) {
		            this.visual = customVisual({
		                active: options.active,
		                series: options.series,
		                sender: this.getSender(),
		                pointIndex: options.pointIndex,
		                options: {
		                    markers: this.markerOptions(),
		                    labels: options.labels
		                },
		                createVisual: function () {
		                    this$1.createVisual();
		                    this$1.renderChildren();
		                    this$1.renderComplete();
	
		                    var defaultVisual = this$1.visual;
	
		                    delete this$1.visual;
	
		                    return defaultVisual;
		                }
		            });
		            this.addVisual();
		        } else {
		            BoxElement.fn.renderVisual.call(this);
		        }
		    }
		});
	
		var HORIZONTAL = "horizontal";
		var POINTER = "pointer";
		var CUSTOM = "custom";
	
		var Legend = ChartElement.extend({
		    init: function(options, chartService) {
		        if (chartService === void 0) { chartService = {}; }
	
		        ChartElement.fn.init.call(this, options);
	
		        this.chartService = chartService;
	
		        if (!inArray(this.options.position, [ TOP, RIGHT, BOTTOM, LEFT, CUSTOM ])) {
		            this.options.position = RIGHT;
		        }
	
		        this.createContainer();
	
		        this.createItems();
		    },
	
		    createContainer: function() {
		        var options = this.options;
		        var position = options.position;
		        var userAlign = options.align;
		        var align = position;
		        var vAlign = CENTER;
	
		        if (position === CUSTOM) {
		            align = LEFT;
		        } else if (inArray(position, [ TOP, BOTTOM ])) {
		            if (userAlign === "start") {
		                align = LEFT;
		            } else if (userAlign === "end") {
		                align = RIGHT;
		            } else {
		                align = CENTER;
		            }
		            vAlign = position;
		        } else if (userAlign) {
		            if (userAlign === "start") {
		                vAlign = TOP;
		            } else if (userAlign === "end") {
		                vAlign = BOTTOM;
		            }
		        }
	
		        this.container = new BoxElement({
		            margin: options.margin,
		            padding: options.padding,
		            background: options.background,
		            border: options.border,
		            vAlign: vAlign,
		            align: align,
		            zIndex: options.zIndex,
		            shrinkToFit: true
		        });
	
		        this.append(this.container);
		    },
	
		    createItems: function() {
		        var chartService = this.getService();
		        var options = this.options;
		        var vertical = this.isVertical();
		        var innerElement = new LegendLayout({
		            vertical: vertical,
		            spacing: options.spacing,
		            rtl: chartService.rtl
		        }, chartService);
		        var items = options.items;
	
		        if (options.reverse) {
		            items = items.slice(0).reverse();
		        }
	
		        var count = items.length;
	
		        for (var i = 0; i < count; i++) {
		            var item = items[i];
	
		            innerElement.append(new LegendItem(deepExtend({}, {
		                markers: options.markers,
		                labels: options.labels,
		                rtl: chartService.rtl
		            }, options.item, item)));
		        }
	
		        innerElement.render();
	
		        this.container.append(innerElement);
		    },
	
		    isVertical: function() {
		        var ref = this.options;
		        var orientation = ref.orientation;
		        var position = ref.position;
		        var vertical = (position === CUSTOM && orientation !== HORIZONTAL) ||
		               (defined(orientation) ? orientation !== HORIZONTAL : inArray(position, [ LEFT, RIGHT ]));
	
		        return vertical;
		    },
	
		    hasItems: function() {
		        return this.container.children[0].children.length > 0;
		    },
	
		    reflow: function(targetBox) {
		        var options = this.options;
		        var legendBox = targetBox.clone();
	
		        if (!this.hasItems()) {
		            this.box = legendBox;
		            return;
		        }
	
		        if (options.position === CUSTOM) {
		            this.containerCustomReflow(legendBox);
		            this.box = legendBox;
		        } else {
		            this.containerReflow(legendBox);
		        }
		    },
	
		    containerReflow: function(targetBox) {
		        var ref = this;
		        var options = ref.options;
		        var container = ref.container;
		        var position = options.position;
		        var width = options.width;
		        var height = options.height;
		        var pos = position === TOP || position === BOTTOM ? X : Y;
		        var vertical = this.isVertical();
		        var alignTarget = targetBox.clone();
		        var containerBox = targetBox.clone();
	
		        if (position === LEFT || position === RIGHT) {
		            containerBox.y1 = alignTarget.y1 = 0;
		        }
	
		        if (vertical && height) {
		            containerBox.y2 = containerBox.y1 + height;
		            containerBox.align(alignTarget, Y, container.options.vAlign);
		        } else if (!vertical && width) {
		            containerBox.x2 = containerBox.x1 + width;
		            containerBox.align(alignTarget, X, container.options.align);
		        }
	
		        container.reflow(containerBox);
		        containerBox = container.box;
	
		        var box = containerBox.clone();
	
		        if (options.offsetX || options.offsetY) {
		            containerBox.translate(options.offsetX, options.offsetY);
		            this.container.reflow(containerBox);
		        }
	
		        box[pos + 1] = targetBox[pos + 1];
		        box[pos + 2] = targetBox[pos + 2];
	
		        this.box = box;
		    },
	
		    containerCustomReflow: function(targetBox) {
		        var ref = this;
		        var options = ref.options;
		        var container = ref.container;
		        var offsetX = options.offsetX;
		        var offsetY = options.offsetY;
		        var width = options.width;
		        var height = options.height;
		        var vertical = this.isVertical();
		        var containerBox = targetBox.clone();
	
		        if (vertical && height) {
		            containerBox.y2 = containerBox.y1 + height;
		        } else if (!vertical && width) {
		            containerBox.x2 = containerBox.x1 + width;
		        }
		        container.reflow(containerBox);
		        containerBox = container.box;
	
		        container.reflow(new Box(
		            offsetX, offsetY,
		            offsetX + containerBox.width(), offsetY + containerBox.height()
		        ));
		    },
	
		    renderVisual: function() {
		        if (this.hasItems()) {
		            ChartElement.fn.renderVisual.call(this);
		        }
		    }
		});
	
		setDefaultOptions(Legend, {
		    position: RIGHT,
		    items: [],
		    offsetX: 0,
		    offsetY: 0,
		    margin: getSpacing(5),
		    padding: getSpacing(5),
		    border: {
		        color: BLACK,
		        width: 0
		    },
		    item: {
		        cursor: POINTER,
		        spacing: 6
		    },
		    spacing: 6,
		    background: "",
		    zIndex: 1,
		    markers: {
		        border: {
		            width: 0
		        },
		        width: 15,
		        height: 3,
		        type: "rect",
		        align: LEFT,
		        vAlign: CENTER
		    }
		});
	
		var PlotAreaFactory = Class.extend({
		    init: function() {
	
		        this._registry = [];
		    },
	
		    register: function(type, seriesTypes) {
		        this._registry.push({
		            type: type,
		            seriesTypes: seriesTypes
		        });
		    },
	
		    create: function(srcSeries, options, chartService) {
		        var registry = this._registry;
		        var match = registry[0];
		        var series;
	
		        for (var idx = 0; idx < registry.length; idx++) {
		            var entry = registry[idx];
		            series = filterSeriesByType(srcSeries, entry.seriesTypes);
	
		            if (series.length > 0) {
		                match = entry;
		                break;
		            }
		        }
	
		        return new match.type(series, options, chartService);
		    }
		});
	
		PlotAreaFactory.current = new PlotAreaFactory();
	
		var ZOOM_ACCELERATION = 3;
		var SELECTOR_HEIGHT_ADJUST = 0.1;
	
		function createDiv(className) {
		    var element = document.createElement("div");
		    if (className) {
		        element.className = className;
		    }
	
		    return element;
		}
	
		function closestHandle(element) {
		    var current = element;
		    while (current && !hasClasses(current, "k-handle")) {
		        current = current.parentNode;
		    }
	
		    return current;
		}
	
		var Selection = Class.extend({
		    init: function(chart, categoryAxis, options, observer) {
	
		        var chartElement = chart.element;
	
		        this.options = deepExtend({}, this.options, options);
		        this.chart = chart;
		        this.observer = observer;
		        this.chartElement = chartElement;
		        this.categoryAxis = categoryAxis;
		        this._dateAxis = this.categoryAxis instanceof dataviz.DateCategoryAxis;
	
		        this.initOptions();
	
		        if (this.options.visible) {
		            this.createElements();
	
		            this.set(this._index(this.options.from), this._index(this.options.to));
	
		            this.bindEvents();
		        }
		    },
	
		    onPane: function(pane) {
		        return this.categoryAxis.pane === pane;
		    },
	
		    createElements: function() {
		        var options = this.options;
		        var wrapper = this.wrapper = createDiv("k-selector");
		        elementStyles(wrapper, {
		            top: options.offset.top,
		            left: options.offset.left,
		            width: options.width,
		            height: options.height,
		            direction: 'ltr'
		        });
		        var selection = this.selection = createDiv("k-selection");
		        this.leftMask = createDiv("k-mask");
		        this.rightMask = createDiv("k-mask");
	
		        wrapper.appendChild(this.leftMask);
		        wrapper.appendChild(this.rightMask);
		        wrapper.appendChild(selection);
	
		        selection.appendChild(createDiv("k-selection-bg"));
	
		        var leftHandle = this.leftHandle = createDiv("k-handle k-left-handle");
		        var rightHandle = this.rightHandle = createDiv("k-handle k-right-handle");
		        leftHandle.appendChild(createDiv());
		        rightHandle.appendChild(createDiv());
	
		        selection.appendChild(leftHandle);
		        selection.appendChild(rightHandle);
	
		        this.chartElement.appendChild(wrapper);
		        var selectionStyles = elementStyles(selection, [ "borderLeftWidth", "borderRightWidth", "height" ]);
		        var leftHandleHeight = elementStyles(leftHandle, "height").height;
		        var rightHandleHeight = elementStyles(rightHandle, "height").height;
	
		        options.selection = {
		            border: {
		                left: selectionStyles.borderLeftWidth,
		                right: selectionStyles.borderRightWidth
		            }
		        };
	
		        elementStyles(leftHandle, {
		            top: (selectionStyles.height - leftHandleHeight) / 2
		        });
	
		        elementStyles(rightHandle, {
		            top: (selectionStyles.height - rightHandleHeight) / 2
		        });
	
		        wrapper.style.cssText = wrapper.style.cssText;
		    },
	
		    bindEvents: function() {
		        if (this.options.mousewheel !== false) {
		            this._mousewheelHandler = this._mousewheel.bind(this);
		            var obj;
		            bindEvents(this.wrapper, ( obj = {}, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj ));
		        }
	
		        this._domEvents = services.DomEventsBuilder.create(this.wrapper, {
		            start: this._start.bind(this),
		            move: this._move.bind(this),
		            end: this._end.bind(this),
		            tap: this._tap.bind(this),
		            press: this._press.bind(this),
		            gesturestart: this._gesturestart.bind(this),
		            gesturechange: this._gesturechange.bind(this),
		            gestureend: this._gestureend.bind(this)
		        });
		    },
	
		    initOptions: function() {
		        var ref = this;
		        var options = ref.options;
		        var categoryAxis = ref.categoryAxis;
		        var box = categoryAxis.pane.chartsBox();
		        var intlService = this.chart.chartService.intl;
	
		        if (this._dateAxis) {
		            deepExtend(options, {
		                min: parseDate(intlService, options.min),
		                max: parseDate(intlService, options.max),
		                from: parseDate(intlService, options.from),
		                to: parseDate(intlService, options.to)
		            });
		        }
	
		        var ref$1 = elementStyles(this.chartElement, [ "paddingLeft", "paddingTop" ]);
		        var paddingLeft = ref$1.paddingLeft;
		        var paddingTop = ref$1.paddingTop;
	
		        this.options = deepExtend({}, {
		            width: box.width(),
		            height: box.height() + SELECTOR_HEIGHT_ADJUST, //workaround for sub-pixel hover on the paths in chrome
		            padding: {
		                left: paddingLeft,
		                top: paddingTop
		            },
		            offset: {
		                left: box.x1 + paddingLeft,
		                top: box.y1 + paddingTop
		            },
		            from: options.min,
		            to: options.max
		        }, options);
		    },
	
		    destroy: function() {
		        if (this._domEvents) {
		            this._domEvents.destroy();
		            delete this._domEvents;
		        }
	
		        clearTimeout(this._mwTimeout);
		        this._state = null;
	
		        if (this.wrapper) {
		            if (this._mousewheelHandler) {
		                var obj;
		                unbindEvents(this.wrapper, ( obj = {}, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj ));
		                this._mousewheelHandler = null;
		            }
		            this.chartElement.removeChild(this.wrapper);
		            this.wrapper = null;
		        }
		    },
	
		    _rangeEventArgs: function(range) {
	
		        return {
		            axis: this.categoryAxis.options,
		            from: this._value(range.from),
		            to: this._value(range.to)
		        };
		    },
	
		    _start: function(e) {
		        var options = this.options;
		        var target = eventElement(e);
	
		        if (this._state || !target) {
		            return;
		        }
	
		        this.chart._unsetActivePoint();
		        this._state = {
		            moveTarget: closestHandle(target) || target,
		            startLocation: e.x ? e.x.location : 0,
		            range: {
		                from: this._index(options.from),
		                to: this._index(options.to)
		            }
		        };
	
		        var args = this._rangeEventArgs({
		            from: this._index(options.from),
		            to: this._index(options.to)
		        });
	
		        if (this.trigger(SELECT_START, args)) {
		            this._state = null;
		        }
		    },
	
		    _press: function(e) {
		        var handle;
		        if (this._state) {
		            handle = this._state.moveTarget;
		        } else {
		            handle = closestHandle(eventElement(e));
		        }
		        if (handle) {
		            dataviz.addClass(handle, "k-handle-active");
		        }
		    },
	
		    _move: function(e) {
		        if (!this._state) {
		            return;
		        }
	
		        var ref = this;
		        var state = ref._state;
		        var options = ref.options;
		        var categoryAxis = ref.categoryAxis;
		        var range = state.range;
		        var target = state.moveTarget;
		        var reverse = categoryAxis.options.reverse;
		        var from = this._index(options.from);
		        var to = this._index(options.to);
		        var min = this._index(options.min);
		        var max = this._index(options.max);
		        var delta = state.startLocation - e.x.location;
		        var oldRange = { from: range.from, to: range.to };
		        var span = range.to - range.from;
		        var scale = elementStyles(this.wrapper, "width").width / (categoryAxis.categoriesCount() - 1);
		        var offset = Math.round(delta / scale) * (reverse ? -1 : 1);
	
		        if (!target) {
		            return;
		        }
	
		        var leftHandle = hasClasses(target, "k-left-handle");
		        var rightHandle = hasClasses(target, "k-right-handle");
	
		        if (hasClasses(target, "k-selection k-selection-bg")) {
		            range.from = Math.min(
		                Math.max(min, from - offset),
		                max - span
		            );
		            range.to = Math.min(
		                range.from + span,
		                max
		            );
		        } else if ((leftHandle && !reverse) || (rightHandle && reverse)) {
		            range.from = Math.min(
		                Math.max(min, from - offset),
		                max - 1
		            );
		            range.to = Math.max(range.from + 1, range.to);
		        } else if ((leftHandle && reverse) || (rightHandle && !reverse)) {
		            range.to = Math.min(
		                Math.max(min + 1, to - offset),
		                max
		            );
		            range.from = Math.min(range.to - 1, range.from);
		        }
	
		        if (range.from !== oldRange.from || range.to !== oldRange.to) {
		            this.move(range.from, range.to);
		            this.trigger(SELECT, this._rangeEventArgs(range));
		        }
		    },
	
		    _end: function() {
		        if (this._state) {
		            var moveTarget = this._state.moveTarget;
		            if (moveTarget) {
		                dataviz.removeClass(moveTarget, "k-handle-active");
		            }
	
		            var range = this._state.range;
		            this.set(range.from, range.to);
		            this.trigger(SELECT_END, this._rangeEventArgs(range));
	
		            delete this._state;
		        }
		    },
	
		    _tap: function(e) {
		        var ref = this;
		        var options = ref.options;
		        var categoryAxis = ref.categoryAxis;
		        var coords = this.chart._eventCoordinates(e);
		        var categoryIx = categoryAxis.pointCategoryIndex(new Point(coords.x, categoryAxis.box.y1));
		        var from = this._index(options.from);
		        var to = this._index(options.to);
		        var min = this._index(options.min);
		        var max = this._index(options.max);
		        var span = to - from;
		        var mid = from + span / 2;
		        var range = {};
		        var rightClick = e.event.which === 3;
		        var offset = Math.round(mid - categoryIx);
	
		        if (this._state || rightClick) {
		            return;
		        }
	
		        this.chart._unsetActivePoint();
	
		        if (!categoryAxis.options.justified) {
		            offset--;
		        }
	
		        range.from = Math.min(
		            Math.max(min, from - offset),
		            max - span
		        );
	
		        range.to = Math.min(range.from + span, max);
	
		        this._start(e);
		        if (this._state) {
		            this._state.range = range;
		            this.trigger(SELECT, this._rangeEventArgs(range));
		            this._end();
		        }
		    },
	
		    _mousewheel: function(e) {
		        var this$1 = this;
	
		        var delta = dataviz.mousewheelDelta(e);
	
		        this._start({ target: this.selection });
	
		        if (this._state) {
		            var range = this._state.range;
	
		            e.preventDefault();
		            e.stopPropagation();
	
		            if (Math.abs(delta) > 1) {
		                delta *= ZOOM_ACCELERATION;
		            }
	
		            if (this.options.mousewheel.reverse) {
		                delta *= -1;
		            }
	
		            if (this.expand(delta)) {
		                this.trigger(SELECT, {
		                    axis: this.categoryAxis.options,
		                    delta: delta,
		                    originalEvent: e,
		                    from: this._value(range.from),
		                    to: this._value(range.to)
		                });
		            }
	
		            if (this._mwTimeout) {
		                clearTimeout(this._mwTimeout);
		            }
	
		            this._mwTimeout = setTimeout(function () {
		                this$1._end();
		            }, MOUSEWHEEL_DELAY);
		        }
		    },
	
		    _gesturestart: function(e) {
		        var options = this.options;
	
		        this._state = {
		            range: {
		                from: this._index(options.from),
		                to: this._index(options.to)
		            }
		        };
		        var args = this._rangeEventArgs(this._state.range);
	
		        if (this.trigger(SELECT_START, args)) {
		            this._state = null;
		        } else {
		            e.preventDefault();
		        }
		    },
	
		    _gestureend: function() {
		        if (this._state) {
		            this.trigger(SELECT_END, this._rangeEventArgs(this._state.range));
		            delete this._state;
		        }
		    },
	
		    _gesturechange: function(e) {
		        var ref = this;
		        var chart = ref.chart;
		        var state = ref._state;
		        var options = ref.options;
		        var categoryAxis = ref.categoryAxis;
		        var range = state.range;
		        var p0 = chart._toModelCoordinates(e.touches[0].x.location).x;
		        var p1 = chart._toModelCoordinates(e.touches[1].x.location).x;
		        var left = Math.min(p0, p1);
		        var right = Math.max(p0, p1);
	
		        e.preventDefault();
	
		        range.from = categoryAxis.pointCategoryIndex(new Point(left)) || options.min;
	
		        range.to = categoryAxis.pointCategoryIndex(new Point(right)) || options.max;
	
		        this.move(range.from, range.to);
	
		        this.trigger(SELECT, this._rangeEventArgs(range));
		    },
	
		    _index: function(value) {
		        var index = value;
	
		        if (value instanceof Date) {
		            index = this.categoryAxis.categoryIndex(value);
		        }
	
		        return index;
		    },
	
		    _value: function(index) {
		        var value = index;
		        if (this._dateAxis) {
		            value = this.categoryAxis.categoryAt(index);
		            if (value > this.options.max) {
		                value = this.options.max;
		            }
		        }
	
		        return value;
		    },
	
		    _slot: function(value) {
		        var categoryAxis = this.categoryAxis;
		        var index = this._index(value);
	
		        return categoryAxis.getSlot(index, index, true);
		    },
	
		    move: function(from, to) {
		        var options = this.options;
		        var reverse = this.categoryAxis.options.reverse;
		        var offset = options.offset;
		        var padding = options.padding;
		        var border = options.selection.border;
		        var left = reverse ? to : from;
		        var right = reverse ? from : to;
		        var edge = 'x' + (reverse ? 2 : 1);
	
		        var box = this._slot(left);
		        var leftMaskWidth = round(box[edge] - offset.left + padding.left);
	
		        elementStyles(this.leftMask, {
		            width: leftMaskWidth
		        });
		        elementStyles(this.selection, {
		            left: leftMaskWidth
		        });
	
		        box = this._slot(right);
	
		        var rightMaskWidth = round(options.width - (box[edge] - offset.left + padding.left));
		        elementStyles(this.rightMask, {
		            width: rightMaskWidth
		        });
	
		        var distance = options.width - rightMaskWidth;
		        if (distance !== options.width) {
		            distance += border.right;
		        }
	
		        elementStyles(this.rightMask, {
		            left: distance
		        });
		        elementStyles(this.selection, {
		            width: Math.max(options.width - (leftMaskWidth + rightMaskWidth) - border.right, 0)
		        });
		    },
	
		    set: function(from, to) {
		        var options = this.options;
		        var min = this._index(options.min);
		        var max = this._index(options.max);
		        var fromValue = limitValue(this._index(from), min, max);
		        var toValue = limitValue(this._index(to), fromValue + 1, max);
	
		        if (options.visible) {
		            this.move(fromValue, toValue);
		        }
	
		        options.from = this._value(fromValue);
		        options.to = this._value(toValue);
		    },
	
		    expand: function(delta) {
		        var options = this.options;
		        var min = this._index(options.min);
		        var max = this._index(options.max);
		        var zDir = options.mousewheel.zoom;
		        var from = this._index(options.from);
		        var to = this._index(options.to);
		        var range = { from: from, to: to };
		        var oldRange = deepExtend({}, range);
	
		        if (this._state) {
		            range = this._state.range;
		        }
	
		        if (zDir !== RIGHT) {
		            range.from = limitValue(
		                limitValue(from - delta, 0, to - 1),
		                min, max
		            );
		        }
	
		        if (zDir !== LEFT) {
		            range.to = limitValue(
		                limitValue(to + delta, range.from + 1, max),
		                min,
		                max
		             );
		        }
	
		        if (range.from !== oldRange.from || range.to !== oldRange.to) {
		            this.set(range.from, range.to);
		            return true;
		        }
		    },
	
		    trigger: function(name, args) {
		        return (this.observer || this.chart).trigger(name, args);
		    }
		});
	
		setDefaultOptions(Selection, {
		    visible: true,
		    mousewheel: {
		        zoom: "both"
		    },
		    min: MIN_VALUE,
		    max: MAX_VALUE
		});
	
		var Tooltip = BaseTooltip.extend({
		    show: function(point) {
		        if (!point || !point.tooltipAnchor || (this._current && this._current === point)) {
		            return;
		        }
	
		        var options = deepExtend({}, this.options, point.options.tooltip);
		        var anchor = point.tooltipAnchor();
	
		        if (anchor) {
		            this._current = point;
		            BaseTooltip.fn.show.call(this, {
		                point: point,
		                anchor: anchor
		            }, options, point);
		        } else {
		            this.hide();
		        }
		    },
	
		    hide: function() {
		        delete this._current;
		        BaseTooltip.fn.hide.call(this);
		    }
		});
	
		var SharedTooltip = BaseTooltip.extend({
		    init: function(plotArea, options) {
		        BaseTooltip.fn.init.call(this, plotArea.chartService, options);
	
		        this.plotArea = plotArea;
		        this.formatService = plotArea.chartService.format;
		    },
	
		    showAt: function(points, coords) {
		        var tooltipPoints = grep(points, function(point) {
		            var tooltip = point.series.tooltip;
		            var excluded = tooltip && tooltip.visible === false;
	
		            return !excluded;
		        });
	
		        if (tooltipPoints.length > 0) {
		            var point = tooltipPoints[0];
		            var slot = this.plotArea.categoryAxis.getSlot(point.categoryIx);
	
		            var anchor = coords ? this._slotAnchor(coords, slot) : this._defaultAnchor(point, slot);
	
		            this.show({
		                anchor: anchor,
		                shared: true,
		                points: points,
		                category: point.category,
		                categoryText: this.formatService.auto(this.options.categoryFormat, point.category),
		                series: this.plotArea.series
		            }, this.options);
		        }
		    },
	
		    _slotAnchor: function(point, slot) {
		        var axis = this.plotArea.categoryAxis;
		        var align = {
		            horizontal: "left",
		            vertical: "center"
		        };
	
		        if (!axis.options.vertical) {
		            point.x = slot.center().x;
		        }
	
		        return {
		            point: point,
		            align: align
		        };
		    },
	
		    _defaultAnchor: function(point, slot) {
		        var box = point.owner.pane.chartsBox();
		        var vertical = this.plotArea.categoryAxis.options.vertical;
		        var center = box.center();
		        var slotCenter = slot.center();
		        var align = {
		            horizontal: "center",
		            vertical: "center"
		        };
	
		        var centerPoint;
		        if (vertical) {
		            centerPoint = new Point(center.x, slotCenter.y);
		        } else {
		            centerPoint = new Point(slotCenter.x, center.y);
		        }
	
		        return {
		            point: centerPoint,
		            align: align
		        };
		    }
		});
	
		setDefaultOptions(SharedTooltip, {
		    categoryFormat: '{0:d}'
		});
	
		var BarChartAnimation = Animation.extend({
		    setup: function() {
		        var ref = this;
		        var element = ref.element;
		        var options = ref.options;
		        var bbox = element.bbox();
	
		        if (bbox) {
		            this.origin = options.origin;
		            var axis = options.vertical ? Y : X;
	
		            var fromScale = this.fromScale = new GeometryPoint(1, 1);
		            fromScale[axis] = START_SCALE;
	
		            element.transform(transform()
		                .scale(fromScale.x, fromScale.y)
		            );
		        } else {
		            this.abort();
		        }
		    },
	
		    step: function(pos) {
		        var scaleX = dataviz.interpolateValue(this.fromScale.x, 1, pos);
		        var scaleY = dataviz.interpolateValue(this.fromScale.y, 1, pos);
	
		        this.element.transform(transform()
		            .scale(scaleX, scaleY, this.origin)
		        );
		    },
	
		    abort: function() {
		        Animation.fn.abort.call(this);
		        this.element.transform(null);
		    }
		});
	
		setDefaultOptions(BarChartAnimation, {
		    duration: INITIAL_ANIMATION_DURATION
		});
	
		AnimationFactory.current.register(BAR, BarChartAnimation);
	
		var BubbleAnimation = Animation.extend({
		    setup: function() {
		        var center = this.center = this.element.bbox().center();
		        this.element.transform(transform()
		            .scale(START_SCALE, START_SCALE, center)
		        );
		    },
	
		    step: function(pos) {
		        this.element.transform(transform()
		            .scale(pos, pos, this.center)
		        );
		    }
		});
	
		setDefaultOptions(BubbleAnimation, {
		    easing: "easeOutElastic"
		});
	
		AnimationFactory.current.register(BUBBLE, BubbleAnimation);
	
		var FadeInAnimation = Animation.extend({
		    setup: function() {
		        this.fadeTo = this.element.opacity();
		        this.element.opacity(0);
		    },
	
		    step: function(pos) {
		        this.element.opacity(pos * this.fadeTo);
		    }
		});
	
		setDefaultOptions(FadeInAnimation, {
		    duration: 200,
		    easing: "linear"
		});
	
		AnimationFactory.current.register(FADEIN, FadeInAnimation);
	
		var PieAnimation = Animation.extend({
		    setup: function() {
		        this.element.transform(transform()
		            .scale(START_SCALE, START_SCALE, this.options.center)
		        );
		    },
	
		    step: function(pos) {
		        this.element.transform(transform()
		            .scale(pos, pos, this.options.center)
		        );
		    }
		});
	
		setDefaultOptions(PieAnimation, {
		    easing: "easeOutElastic",
		    duration: INITIAL_ANIMATION_DURATION
		});
	
		AnimationFactory.current.register(PIE, PieAnimation);
	
		var ScatterLineChart = ScatterChart.extend({
		    render: function() {
		        ScatterChart.fn.render.call(this);
	
		        this.renderSegments();
		    },
	
		    createSegment: function(linePoints, currentSeries, seriesIx) {
		        var style = currentSeries.style;
		        var pointType;
	
		        if (style === SMOOTH) {
		            pointType = SplineSegment;
		        } else {
		            pointType = LineSegment;
		        }
	
		        return new pointType(linePoints, currentSeries, seriesIx);
		    },
	
		    animationPoints: function() {
		        var points = ScatterChart.fn.animationPoints.call(this);
		        return points.concat(this._segments);
		    },
	
		    createMissingValue: function(value, missingValues) {
		        if (missingValues === ZERO) {
		            var missingValue = {
		                x: value.x,
		                y: value.y
		            };
		            if (!hasValue(missingValue.x)) {
		                missingValue.x = 0;
		            }
		            if (!hasValue(missingValue.y)) {
		                missingValue.y = 0;
		            }
		            return missingValue;
		        }
		    }
		});
	
		deepExtend(ScatterLineChart.prototype, LineChartMixin);
	
		var XYPlotArea = PlotAreaBase.extend({
		    initFields: function() {
		        this.namedXAxes = {};
		        this.namedYAxes = {};
	
		        this.xAxisRangeTracker = new AxisGroupRangeTracker();
		        this.yAxisRangeTracker = new AxisGroupRangeTracker();
		    },
	
		    render: function(panes) {
		        var this$1 = this;
		        if (panes === void 0) { panes = this.panes; }
	
		        var seriesByPane = this.groupSeriesByPane();
	
		        for (var i = 0; i < panes.length; i++) {
		            var pane = panes[i];
		            var paneSeries = seriesByPane[pane.options.name || "default"] || [];
		            this$1.addToLegend(paneSeries);
		            var filteredSeries = this$1.filterVisibleSeries(paneSeries);
	
		            if (!filteredSeries) {
		                continue;
		            }
	
		            this$1.createScatterChart(
		                filterSeriesByType(filteredSeries, SCATTER),
		                pane
		            );
	
		            this$1.createScatterLineChart(
		                filterSeriesByType(filteredSeries, SCATTER_LINE),
		                pane
		            );
	
		            this$1.createBubbleChart(
		                filterSeriesByType(filteredSeries, BUBBLE),
		                pane
		            );
		        }
	
		        this.createAxes(panes);
		    },
	
		    appendChart: function(chart, pane) {
		        this.xAxisRangeTracker.update(chart.xAxisRanges);
		        this.yAxisRangeTracker.update(chart.yAxisRanges);
	
		        PlotAreaBase.fn.appendChart.call(this, chart, pane);
		    },
	
		    removeAxis: function(axis) {
		        var axisName = axis.options.name;
	
		        PlotAreaBase.fn.removeAxis.call(this, axis);
	
		        if (axis.options.vertical) {
		            this.yAxisRangeTracker.reset(axisName);
		            delete this.namedYAxes[axisName];
		        } else {
		            this.xAxisRangeTracker.reset(axisName);
		            delete this.namedXAxes[axisName];
		        }
	
		        if (axis === this.axisX) {
		            delete this.axisX;
		        }
	
		        if (axis === this.axisY) {
		            delete this.axisY;
		        }
		    },
	
		    seriesPaneName: function(series) {
		        var options = this.options;
		        var xAxisName = series.xAxis;
		        var xAxisOptions = [].concat(options.xAxis);
		        var xAxis = grep(xAxisOptions, function(a) { return a.name === xAxisName; })[0];
		        var yAxisName = series.yAxis;
		        var yAxisOptions = [].concat(options.yAxis);
		        var yAxis = grep(yAxisOptions, function(a) { return a.name === yAxisName; })[0];
		        var panes = options.panes || [ {} ];
		        var defaultPaneName = panes[0].name || "default";
		        var paneName = (xAxis || {}).pane || (yAxis || {}).pane || defaultPaneName;
	
		        return paneName;
		    },
	
		    createScatterChart: function(series, pane) {
		        if (series.length > 0) {
		            this.appendChart(
		                new ScatterChart(this, { series: series, clip: pane.options.clip }),
		                pane
		            );
		        }
		    },
	
		    createScatterLineChart: function(series, pane) {
		        if (series.length > 0) {
		            this.appendChart(
		                new ScatterLineChart(this, { series: series, clip: pane.options.clip }),
		                pane
		            );
		        }
		    },
	
		    createBubbleChart: function(series, pane) {
		        if (series.length > 0) {
		            this.appendChart(
		                new BubbleChart(this, { series: series, clip: pane.options.clip }),
		                pane
		            );
		        }
		    },
	
		    createXYAxis: function(options, vertical, axisIndex) {
		        var axisName = options.name;
		        var namedAxes = vertical ? this.namedYAxes : this.namedXAxes;
		        var tracker = vertical ? this.yAxisRangeTracker : this.xAxisRangeTracker;
		        var axisOptions = deepExtend({ reverse: !vertical && this.chartService.rtl }, options, { vertical: vertical });
		        var isLog = equalsIgnoreCase(axisOptions.type, LOGARITHMIC);
		        var defaultRange = tracker.query();
		        var defaultAxisRange = isLog ? { min: 0.1, max: 1 } : { min: 0, max: 1 };
		        var range = tracker.query(axisName) || defaultRange || defaultAxisRange;
		        var typeSamples = [ axisOptions.min, axisOptions.max ];
		        var series = this.series;
	
		        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
		            var currentSeries = series[seriesIx];
		            var seriesAxisName = currentSeries[vertical ? "yAxis" : "xAxis"];
		            if ((seriesAxisName === axisOptions.name) || (axisIndex === 0 && !seriesAxisName)) {
		                var firstPointValue = SeriesBinder.current.bindPoint(currentSeries, 0).valueFields;
		                typeSamples.push(firstPointValue[vertical ? "y" : "x"]);
	
		                break;
		            }
		        }
	
		        if (axisIndex === 0 && defaultRange) {
		            range.min = Math.min(range.min, defaultRange.min);
		            range.max = Math.max(range.max, defaultRange.max);
		        }
	
		        var inferredDate;
	
		        for (var i = 0; i < typeSamples.length; i++) {
		            if (typeSamples[i] instanceof Date) {
		                inferredDate = true;
		                break;
		            }
		        }
	
		        var axisType;
		        if (equalsIgnoreCase(axisOptions.type, DATE) || (!axisOptions.type && inferredDate)) {
		            axisType = dataviz.DateValueAxis;
		        } else if (isLog) {
		            axisType = dataviz.LogarithmicAxis;
		        } else {
		            axisType = dataviz.NumericAxis;
		        }
	
		        var axis = new axisType(range.min, range.max, axisOptions, this.chartService);
		        axis.axisIndex = axisIndex;
	
		        if (axisName) {
		            if (namedAxes[axisName]) {
		                throw new Error(((vertical ? "Y" : "X") + " axis with name " + axisName + " is already defined"));
		            }
		            namedAxes[axisName] = axis;
		        }
	
		        this.appendAxis(axis);
	
		        return axis;
		    },
	
		    createAxes: function(panes) {
		        var this$1 = this;
	
		        var options = this.options;
		        var xAxesOptions = [].concat(options.xAxis);
		        var xAxes = [];
		        var yAxesOptions = [].concat(options.yAxis);
		        var yAxes = [];
	
		        for (var idx = 0; idx < xAxesOptions.length; idx++) {
		            var axisPane = this$1.findPane(xAxesOptions[idx].pane);
		            if (inArray(axisPane, panes)) {
		                xAxes.push(this$1.createXYAxis(xAxesOptions[idx], false, idx));
		            }
		        }
	
		        for (var idx$1 = 0; idx$1 < yAxesOptions.length; idx$1++) {
		            var axisPane$1 = this$1.findPane(yAxesOptions[idx$1].pane);
		            if (inArray(axisPane$1, panes)) {
		                yAxes.push(this$1.createXYAxis(yAxesOptions[idx$1], true, idx$1));
		            }
		        }
	
		        this.axisX = this.axisX || xAxes[0];
		        this.axisY = this.axisY || yAxes[0];
		    },
	
		    _dispatchEvent: function(chart, e, eventType) {
		        var coords = chart._eventCoordinates(e);
		        var point = new Point(coords.x, coords.y);
		        var allAxes = this.axes;
		        var length = allAxes.length;
		        var xValues = [];
		        var yValues = [];
	
		        for (var i = 0; i < length; i++) {
		            var axis = allAxes[i];
		            var values = axis.options.vertical ? yValues : xValues;
		            var currentValue = axis.getValue(point);
		            if (currentValue !== null) {
		                values.push(currentValue);
		            }
		        }
	
		        if (xValues.length > 0 && yValues.length > 0) {
		            chart.trigger(eventType, {
		                element: eventElement(e),
		                originalEvent: e,
		                x: singleItemOrArray(xValues),
		                y: singleItemOrArray(yValues)
		            });
		        }
		    },
	
		    updateAxisOptions: function(axis, options) {
		        var vertical = axis.options.vertical;
		        var axes = this.groupAxes(this.panes);
		        var index = (vertical ? axes.y : axes.x).indexOf(axis);
	
		        updateAxisOptions$1(this.options, index, vertical, options);
		        updateAxisOptions$1(this.originalOptions, index, vertical, options);
		    }
		});
	
		function updateAxisOptions$1(targetOptions, axisIndex, vertical, options) {
		    var axisOptions = ([].concat(vertical ? targetOptions.yAxis : targetOptions.xAxis))[axisIndex];
		    deepExtend(axisOptions, options);
		}
	
		setDefaultOptions(XYPlotArea, {
		    xAxis: {},
		    yAxis: {}
		});
	
		deepExtend(XYPlotArea.prototype, PlotAreaEventsMixin);
	
		var PieSegment = ChartElement.extend({
		    init: function(value, sector, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.value = value;
		        this.sector = sector;
		    },
	
		    render: function() {
		        var labels = this.options.labels;
		        var chartService = this.owner.chartService;
		        var labelText = this.value;
	
		        if (this._rendered || this.visible === false) {
		            return;
		        }
		        this._rendered = true;
	
		        var labelTemplate = getTemplate(labels);
		        var pointData = this.pointData();
	
		        if (labelTemplate) {
		            labelText = labelTemplate(pointData);
		        } else if (labels.format) {
		            labelText = chartService.format.auto(labels.format, labelText);
		        }
	
		        if (labels.visible && (labelText || labelText === 0)) {
		            if (labels.position === CENTER || labels.position === INSIDE_END) {
		                if (!labels.color) {
		                    var brightnessValue = new Color(this.options.color).percBrightness();
		                    if (brightnessValue > 180) {
		                        labels.color = BLACK;
		                    } else {
		                        labels.color = WHITE;
		                    }
		                }
		                if (!labels.background) {
		                    labels.background = this.options.color;
		                }
		            } else {
		                var themeLabels = chartService.theme.seriesDefaults.labels;
		                labels.color = labels.color || themeLabels.color;
		                labels.background = labels.background || themeLabels.background;
		            }
	
		            this.label = new TextBox(labelText, deepExtend({}, labels, {
		                align: CENTER,
		                vAlign: "",
		                animation: {
		                    type: FADEIN,
		                    delay: this.animationDelay
		                }
		            }), pointData);
	
		            this.append(this.label);
		        }
		    },
	
		    reflow: function(targetBox) {
		        this.render();
		        this.box = targetBox;
		        this.reflowLabel();
		    },
	
		    reflowLabel: function() {
		        var ref = this;
		        var labelsOptions = ref.options.labels;
		        var label = ref.label;
		        var sector = this.sector.clone();
		        var labelsDistance = labelsOptions.distance;
		        var angle = sector.middle();
	
		        if (label) {
		            var labelHeight = label.box.height();
		            var labelWidth = label.box.width();
		            var lp;
	
		            if (labelsOptions.position === CENTER) {
		                sector.radius = Math.abs((sector.radius - labelHeight) / 2) + labelHeight;
		                lp = sector.point(angle);
		                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
		            } else if (labelsOptions.position === INSIDE_END) {
		                sector.radius = sector.radius - labelHeight / 2;
		                lp = sector.point(angle);
		                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
		            } else {
		                var x1;
		                lp = sector.clone().expand(labelsDistance).point(angle);
		                if (lp.x >= sector.center.x) {
		                    x1 = lp.x + labelWidth;
		                    label.orientation = RIGHT;
		                } else {
		                    x1 = lp.x - labelWidth;
		                    label.orientation = LEFT;
		                }
		                label.reflow(new Box(x1, lp.y - labelHeight, lp.x, lp.y));
		            }
		        }
		    },
	
		    createVisual: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var sector = ref.sector;
		        var options = ref.options;
	
		        ChartElement.fn.createVisual.call(this);
	
		        if (this.value) {
		            if (options.visual) {
		                var startAngle = (sector.startAngle + 180) % 360;
		                var visual = options.visual({
		                    category: this.category,
		                    dataItem: this.dataItem,
		                    value: this.value,
		                    series: this.series,
		                    percentage: this.percentage,
		                    center: new GeometryPoint(sector.center.x, sector.center.y),
		                    radius: sector.radius,
		                    innerRadius: sector.innerRadius,
		                    startAngle: startAngle,
		                    endAngle: startAngle + sector.angle,
		                    options: options,
		                    sender: this.getSender(),
		                    createVisual: function () {
		                        var group = new Group();
		                        this$1.createSegmentVisual(group);
	
		                        return group;
		                    }
		                });
	
		                if (visual) {
		                    this.visual.append(visual);
		                }
		            } else {
		                this.createSegmentVisual(this.visual);
		            }
		        }
		    },
	
		    createSegmentVisual: function(group) {
		        var ref = this;
		        var sector = ref.sector;
		        var options = ref.options;
		        var borderOptions = options.border || {};
		        var border = borderOptions.width > 0 ? {
		            stroke: {
		                color: borderOptions.color,
		                width: borderOptions.width,
		                opacity: borderOptions.opacity,
		                dashType: borderOptions.dashType
		            }
		        } : {};
		        var color = options.color;
		        var fill = {
		            color: color,
		            opacity: options.opacity
		        };
		        var visual = this.createSegment(sector, deepExtend({
		            fill: fill,
		            stroke: {
		                opacity: options.opacity
		            },
		            zIndex: options.zIndex
		        }, border));
	
		        group.append(visual);
	
		        if (hasGradientOverlay(options)) {
		            group.append(this.createGradientOverlay(visual, {
		                baseColor: color,
		                fallbackFill: fill
		            }, deepExtend({
		                center: [ sector.center.x, sector.center.y ],
		                innerRadius: sector.innerRadius,
		                radius: sector.radius,
		                userSpace: true
		            }, options.overlay)));
		        }
		    },
	
		    createSegment: function(sector, options) {
		        if (options.singleSegment) {
		            return new drawing.Circle(new geometry.Circle(new GeometryPoint(sector.center.x, sector.center.y), sector.radius), options);
		        }
	
		        return dataviz.ShapeBuilder.current.createRing(sector, options);
		    },
	
		    createAnimation: function() {
		        var ref = this;
		        var options = ref.options;
		        var center = ref.sector.center;
	
		        deepExtend(options, {
		            animation: {
		                center: [ center.x, center.y ],
		                delay: this.animationDelay
		            }
		        });
	
		        ChartElement.fn.createAnimation.call(this);
		    },
	
		    createHighlight: function(options) {
		        var highlight = this.options.highlight || {};
		        var border = highlight.border || {};
	
		        return this.createSegment(this.sector, deepExtend({}, options, {
		            fill: {
		                color: highlight.color,
		                opacity: highlight.opacity
		            },
		            stroke: {
		                opacity: border.opacity,
		                width: border.width,
		                color: border.color
		            }
		        }));
		    },
	
		    highlightVisual: function() {
		        return this.visual.children[0];
		    },
	
		    highlightVisualArgs: function() {
		        var sector = this.sector;
	
		        return {
		            options: this.options,
		            radius: sector.radius,
		            innerRadius: sector.innerRadius,
		            center: new GeometryPoint(sector.center.x, sector.center.y),
		            startAngle: sector.startAngle,
		            endAngle: sector.angle + sector.startAngle,
		            visual: this.visual
		        };
		    },
	
		    tooltipAnchor: function() {
		        var sector = this.sector.clone().expand(TOOLTIP_OFFSET);
		        var midAndle = sector.middle();
		        var midPoint = sector.point(midAndle);
	
		        return {
		            point: midPoint,
		            align: tooltipAlignment(midAndle + 180)
		        };
		    },
	
		    formatValue: function(format) {
		        return this.owner.formatPointValue(this, format);
		    },
	
		    pointData: function() {
		        return {
		            dataItem: this.dataItem,
		            category: this.category,
		            value: this.value,
		            series: this.series,
		            percentage: this.percentage
		        };
		    }
		});
	
		var RAD_30 = round(dataviz.rad(30), DEFAULT_PRECISION);
		var RAD_60 = round(dataviz.rad(60), DEFAULT_PRECISION);
	
		function tooltipAlignment(angle) {
		    var radians = dataviz.rad(angle);
		    var sine = round(Math.sin(radians), DEFAULT_PRECISION);
		    var cosine = round(Math.cos(radians), DEFAULT_PRECISION);
	
		    var horizontal;
		    if (Math.abs(sine) > RAD_60) {
		        horizontal = CENTER;
		    } else if (cosine < 0) {
		        horizontal = RIGHT;
		    } else {
		        horizontal = LEFT;
		    }
	
		    var vertical;
		    if (Math.abs(sine) < RAD_30) {
		        vertical = CENTER;
		    } else if (sine < 0) {
		        vertical = BOTTOM;
		    } else {
		        vertical = TOP;
		    }
	
		    return {
		        horizontal: horizontal,
		        vertical: vertical
		    };
		}
	
		setDefaultOptions(PieSegment, {
		    color: WHITE,
		    overlay: {
		        gradient: "roundedBevel"
		    },
		    border: {
		        width: 0.5
		    },
		    labels: {
		        visible: false,
		        distance: 35,
		        font: datavizConstants.DEFAULT_FONT,
		        margin: getSpacing(0.5),
		        align: CIRCLE,
		        zIndex: 1,
		        position: OUTSIDE_END
		    },
		    animation: {
		        type: PIE
		    },
		    highlight: {
		        visible: true,
		        border: {
		            width: 1
		        }
		    },
		    visible: true
		});
	
		deepExtend(PieSegment.prototype, PointEventsMixin);
	
		var PieChartMixin = {
		    createLegendItem: function(value, point, options) {
		        var legendOptions = this.options.legend || {};
		        var labelsOptions = legendOptions.labels || {};
		        var inactiveItems = legendOptions.inactiveItems || {};
		        var inactiveItemsLabels = inactiveItems.labels || {};
	
		        if (options && options.visibleInLegend !== false) {
		            var pointVisible = options.visible !== false;
		            var labelTemplate = pointVisible ? getTemplate(labelsOptions) :
		                getTemplate(inactiveItemsLabels) || getTemplate(labelsOptions);
		            var text = options.category;
	
		            if (labelTemplate) {
		                text = labelTemplate({
		                    text: text,
		                    series: options.series,
		                    dataItem: options.dataItem,
		                    percentage: options.percentage,
		                    value: value
		                });
		            }
	
		            var itemLabelOptions, markerColor;
		            if (pointVisible) {
		                itemLabelOptions = {};
		                markerColor = point.color;
		            } else {
		                itemLabelOptions = {
		                    color: inactiveItemsLabels.color,
		                    font: inactiveItemsLabels.font
		                };
		                markerColor = (inactiveItems.markers || {}).color;
		            }
	
		            if (hasValue(text) && text !== "") {
		                this.legendItems.push({
		                    active: pointVisible,
		                    pointIndex: options.index,
		                    text: text,
		                    series: options.series,
		                    markerColor: markerColor,
		                    labels: itemLabelOptions
		                });
		            }
		        }
		    }
		};
	
		var PIE_SECTOR_ANIM_DELAY = 70;
	
		var PieChart = ChartElement.extend({
		    init: function(plotArea, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.plotArea = plotArea;
		        this.chartService = plotArea.chartService;
		        this.points = [];
		        this.legendItems = [];
		        this.render();
		    },
	
		    render: function() {
		        this.traverseDataPoints(this.addValue.bind(this));
		    },
	
		    traverseDataPoints: function(callback) {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var seriesColors = ref.plotArea.options.seriesColors; if (seriesColors === void 0) { seriesColors = []; }
		        var colorsCount = seriesColors.length;
		        var series = options.series;
		        var seriesCount = series.length;
	
		        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
		            var currentSeries = series[seriesIx];
		            var data = currentSeries.data;
		            var ref$1 = bindSegments(currentSeries);
		            var total = ref$1.total;
		            var points = ref$1.points;
		            var count = ref$1.count;
		            var anglePerValue = 360 / total;
		            var constantAngle = (void 0);
		            if (!isFinite(anglePerValue)) {
		                constantAngle = 360 / count;
		            }
		            var currentAngle = (void 0);
	
		            if (defined(currentSeries.startAngle)) {
		                currentAngle = currentSeries.startAngle;
		            } else {
		                currentAngle = options.startAngle;
		            }
	
		            if (seriesIx !== seriesCount - 1) {
		                if (currentSeries.labels.position === OUTSIDE_END) {
		                    currentSeries.labels.position = CENTER;
		                }
		            }
	
		            for (var i = 0; i < points.length; i++) {
		                var pointData = points[i];
		                if (!pointData) {
		                    continue;
		                }
	
		                var fields = pointData.fields;
		                var value = pointData.value;
		                var visible = pointData.visible;
		                var angle = value !== 0 ? (constantAngle || (value * anglePerValue)) : 0;
		                var explode = data.length !== 1 && Boolean(fields.explode);
	
		                if (!isFunction(currentSeries.color)) {
		                    currentSeries.color = fields.color || seriesColors[i % colorsCount];
		                }
	
		                callback(pointData.valueFields.value, new dataviz.Ring(null, 0, 0, currentAngle, angle), {
		                    owner: this$1,
		                    category: defined(fields.category) ? fields.category : "",
		                    index: i,
		                    series: currentSeries,
		                    seriesIx: seriesIx,
		                    dataItem: data[i],
		                    percentage: total !== 0 ? value / total : 0,
		                    explode: explode,
		                    visibleInLegend: fields.visibleInLegend,
		                    visible: visible,
		                    zIndex: seriesCount - seriesIx,
		                    animationDelay: this$1.animationDelay(i, seriesIx, seriesCount)
		                });
	
		                if (visible !== false) {
		                    currentAngle += angle;
		                }
		            }
		        }
		    },
	
		    evalSegmentOptions: function(options, value, fields) {
		        var series = fields.series;
	
		        evalOptions(options, {
		            value: value,
		            series: series,
		            dataItem: fields.dataItem,
		            category: fields.category,
		            percentage: fields.percentage
		        }, { defaults: series._defaults, excluded: [ "data", "content", "template", "visual", "toggle" ] });
		    },
	
		    addValue: function(value, sector, fields) {
		        var segmentOptions = deepExtend({}, fields.series, { index: fields.index });
		        this.evalSegmentOptions(segmentOptions, value, fields);
	
		        this.createLegendItem(value, segmentOptions, fields);
	
		        if (fields.visible === false) {
		            return;
		        }
	
		        var segment = new PieSegment(value, sector, segmentOptions);
		        $.extend(segment, fields);
		        this.append(segment);
		        this.points.push(segment);
		    },
	
		    reflow: function(targetBox) {
		        var ref = this;
		        var options = ref.options;
		        var points = ref.points;
		        var seriesConfigs = ref.seriesConfigs; if (seriesConfigs === void 0) { seriesConfigs = []; }
		        var count = points.length;
		        var box = targetBox.clone();
		        var space = 5;
		        var minWidth = Math.min(box.width(), box.height());
		        var halfMinWidth = minWidth / 2;
		        var defaultPadding = minWidth - minWidth * 0.85;
		        var newBox = new Box(box.x1, box.y1, box.x1 + minWidth, box.y1 + minWidth);
		        var newBoxCenter = newBox.center();
		        var boxCenter = box.center();
		        var seriesCount = options.series.length;
		        var leftSideLabels = [];
		        var rightSideLabels = [];
		        var padding = valueOrDefault(options.padding, defaultPadding);
	
		        padding = padding > halfMinWidth - space ? halfMinWidth - space : padding;
		        newBox.translate(boxCenter.x - newBoxCenter.x, boxCenter.y - newBoxCenter.y);
	
		        var radius = halfMinWidth - padding;
		        var center = new Point(
		            radius + newBox.x1 + padding,
		            radius + newBox.y1 + padding
		        );
	
		        for (var i = 0; i < count; i++) {
		            var segment = points[i];
		            var sector = segment.sector;
		            var seriesIndex = segment.seriesIx;
		            sector.radius = radius;
		            sector.center = center;
	
		            if (seriesConfigs.length) {
		                var seriesConfig = seriesConfigs[seriesIndex];
		                sector.innerRadius = seriesConfig.innerRadius;
		                sector.radius = seriesConfig.radius;
		            }
	
		            if (seriesIndex === seriesCount - 1 && segment.explode) {
		                sector.center = sector.clone().setRadius(sector.radius * 0.15).point(sector.middle());
		            }
	
		            segment.reflow(newBox);
	
		            var label = segment.label;
		            if (label) {
		                if (label.options.position === OUTSIDE_END) {
		                    if (seriesIndex === seriesCount - 1) {
		                        if (label.orientation === RIGHT) {
		                            rightSideLabels.push(label);
		                        } else {
		                            leftSideLabels.push(label);
		                        }
		                    }
		                }
		            }
		        }
	
		        if (leftSideLabels.length > 0) {
		            leftSideLabels.sort(this.labelComparator(true));
		            this.leftLabelsReflow(leftSideLabels);
		        }
	
		        if (rightSideLabels.length > 0) {
		            rightSideLabels.sort(this.labelComparator(false));
		            this.rightLabelsReflow(rightSideLabels);
		        }
	
		        this.box = newBox;
		    },
	
		    leftLabelsReflow: function(labels) {
		        var distances = this.distanceBetweenLabels(labels);
	
		        this.distributeLabels(distances, labels);
		    },
	
		    rightLabelsReflow: function(labels) {
		        var distances = this.distanceBetweenLabels(labels);
	
		        this.distributeLabels(distances, labels);
		    },
	
		    distanceBetweenLabels: function(labels) {
		        var segment = last(this.points);
		        var sector = segment.sector;
		        var count = labels.length - 1;
		        var lr = sector.radius + segment.options.labels.distance;
		        var distances = [];
		        var firstBox = labels[0].box;
		        var distance = round(firstBox.y1 - (sector.center.y - lr - firstBox.height() - firstBox.height() / 2));
	
		        distances.push(distance);
	
		        for (var i = 0; i < count; i++) {
		            var secondBox = labels[i + 1].box;
	
		            firstBox = labels[i].box;
		            distance = round(secondBox.y1 - firstBox.y2);
		            distances.push(distance);
		        }
		        distance = round(sector.center.y + lr - labels[count].box.y2 - labels[count].box.height() / 2);
		        distances.push(distance);
	
		        return distances;
		    },
	
		    distributeLabels: function(distances, labels) {
		        var this$1 = this;
	
		        var count = distances.length;
		        var left, right, remaining;
	
		        for (var i = 0; i < count; i++) {
		            remaining = -distances[i];
		            left = right = i;
	
		            while (remaining > 0 && (left >= 0 || right < count)) {
		                remaining = this$1._takeDistance(distances, i, --left, remaining);
		                remaining = this$1._takeDistance(distances, i, ++right, remaining);
		            }
		        }
	
		        this.reflowLabels(distances, labels);
		    },
	
		    _takeDistance: function(distances, anchor, position, amount) {
		        var result = amount;
		        if (distances[position] > 0) {
		            var available = Math.min(distances[position], result);
		            result -= available;
		            distances[position] -= available;
		            distances[anchor] += available;
		        }
	
		        return result;
		    },
	
		    reflowLabels: function(distances, labels) {
		        var this$1 = this;
	
		        var segment = last(this.points);
		        var sector = segment.sector;
		        var labelOptions = segment.options.labels;
		        var labelsCount = labels.length;
		        var labelDistance = labelOptions.distance;
		        var boxY = sector.center.y - (sector.radius + labelDistance) - labels[0].box.height();
		        var boxX;
	
		        distances[0] += 2;
		        for (var i = 0; i < labelsCount; i++) {
		            var label = labels[i];
		            var box = label.box;
	
		            boxY += distances[i];
		            boxX = this$1.hAlignLabel(
		                box.x2,
		                sector.clone().expand(labelDistance),
		                boxY,
		                boxY + box.height(),
		                label.orientation === RIGHT);
	
		            if (label.orientation === RIGHT) {
		                if (labelOptions.align !== CIRCLE) {
		                    boxX = sector.radius + sector.center.x + labelDistance;
		                }
		                label.reflow(new Box(boxX + box.width(), boxY, boxX, boxY));
		            } else {
		                if (labelOptions.align !== CIRCLE) {
		                    boxX = sector.center.x - sector.radius - labelDistance;
		                }
		                label.reflow(new Box(boxX - box.width(), boxY, boxX, boxY));
		            }
	
		            boxY += box.height();
		        }
		    },
	
		    createVisual: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var connectors = ref.options.connectors;
		        var points = ref.points;
		        var count = points.length;
		        var space = 4;
	
		        ChartElement.fn.createVisual.call(this);
	
		        this._connectorLines = [];
	
		        for (var i = 0; i < count; i++) {
		            var segment = points[i];
		            var sector = segment.sector;
		            var label = segment.label;
		            var angle = sector.middle();
		            var connectorsColor = (segment.options.connectors || {}).color || connectors.color;
	
		            if (label) {
		                var connectorLine = new Path({
		                    stroke: {
		                        color: connectorsColor,
		                        width: connectors.width
		                    },
		                    animation: {
		                        type: FADEIN,
		                        delay: segment.animationDelay
		                    }
		                });
	
		                if (label.options.position === OUTSIDE_END) {
		                    var box = label.box;
		                    var centerPoint = sector.center;
		                    var start = sector.point(angle);
		                    var middle = new Point(box.x1, box.center().y);
		                    var sr = (void 0), end = (void 0), crossing = (void 0);
	
		                    start = sector.clone().expand(connectors.padding).point(angle);
		                    connectorLine.moveTo(start.x, start.y);
		                    // TODO: Extract into a method to remove duplication
		                    if (label.orientation === RIGHT) {
		                        end = new Point(box.x1 - connectors.padding, box.center().y);
		                        crossing = intersection(centerPoint, start, middle, end);
		                        middle = new Point(end.x - space, end.y);
		                        crossing = crossing || middle;
		                        crossing.x = Math.min(crossing.x, middle.x);
	
		                        if (this$1.pointInCircle(crossing, sector.center, sector.radius + space) ||
		                            crossing.x < sector.center.x) {
		                            sr = sector.center.x + sector.radius + space;
		                            if (segment.options.labels.align !== COLUMN) {
		                                if (sr < middle.x) {
		                                    connectorLine.lineTo(sr, start.y);
		                                } else {
		                                    connectorLine.lineTo(start.x + space * 2, start.y);
		                                }
		                            } else {
		                                connectorLine.lineTo(sr, start.y);
		                            }
		                            connectorLine.lineTo(middle.x, end.y);
		                        } else {
		                            crossing.y = end.y;
		                            connectorLine.lineTo(crossing.x, crossing.y);
		                        }
		                    } else {
		                        end = new Point(box.x2 + connectors.padding, box.center().y);
		                        crossing = intersection(centerPoint, start, middle, end);
		                        middle = new Point(end.x + space, end.y);
		                        crossing = crossing || middle;
		                        crossing.x = Math.max(crossing.x, middle.x);
	
		                        if (this$1.pointInCircle(crossing, sector.center, sector.radius + space) ||
		                            crossing.x > sector.center.x) {
		                            sr = sector.center.x - sector.radius - space;
		                            if (segment.options.labels.align !== COLUMN) {
		                                if (sr > middle.x) {
		                                    connectorLine.lineTo(sr, start.y);
		                                } else {
		                                    connectorLine.lineTo(start.x - space * 2, start.y);
		                                }
		                            } else {
		                                connectorLine.lineTo(sr, start.y);
		                            }
		                            connectorLine.lineTo(middle.x, end.y);
		                        } else {
		                            crossing.y = end.y;
		                            connectorLine.lineTo(crossing.x, crossing.y);
		                        }
		                    }
	
		                    connectorLine.lineTo(end.x, end.y);
	
		                    this$1._connectorLines.push(connectorLine);
		                    this$1.visual.append(connectorLine);
		                }
		            }
		        }
		    },
	
		    labelComparator: function(reverse) {
		        var reverseValue = reverse ? -1 : 1;
	
		        return function(a, b) {
		            var first = (a.parent.sector.middle() + 270) % 360;
		            var second = (b.parent.sector.middle() + 270) % 360;
		            return (first - second) * reverseValue;
		        };
		    },
	
		    hAlignLabel: function(originalX, sector, y1, y2, direction) {
		        var radius = sector.radius;
		        var sector_center = sector.center;
		        var cx = sector_center.x;
		        var cy = sector_center.y;
		        var t = Math.min(Math.abs(cy - y1), Math.abs(cy - y2));
	
		        if (t > radius) {
		            return originalX;
		        }
	
		        return cx + Math.sqrt((radius * radius) - (t * t)) * (direction ? 1 : -1);
		    },
	
		    pointInCircle: function(point, center, radius) {
		        return Math.pow(center.x - point.x, 2) + Math.pow(center.y - point.y, 2) < Math.pow(radius, 2);
		    },
	
		    formatPointValue: function(point, format) {
		        return this.chartService.format.auto(format, point.value);
		    },
	
		    animationDelay: function(categoryIndex) {
		        return categoryIndex * PIE_SECTOR_ANIM_DELAY;
		    }
		});
	
		function intersection(a1, a2, b1, b2) {
		    var uat = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x);
		    var ub = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
	
		    var result;
		    if (ub !== 0) {
		        var ua = (uat / ub);
	
		        result = new Point(
		            a1.x + ua * (a2.x - a1.x),
		            a1.y + ua * (a2.y - a1.y)
		        );
		    }
	
		    return result;
		}
	
		setDefaultOptions(PieChart, {
		    startAngle: 90,
		    connectors: {
		        width: 2,
		        color: "#939393",
		        padding: 8
		    },
		    inactiveItems: {
		        markers: {},
		        labels: {}
		    }
		});
	
		deepExtend(PieChart.prototype, PieChartMixin);
	
		var PiePlotArea = PlotAreaBase.extend({
		    render: function() {
		        this.createPieChart(this.series);
		    },
	
		    createPieChart: function(series) {
		        var firstSeries = series[0];
		        var pieChart = new PieChart(this, {
		            series: series,
		            padding: firstSeries.padding,
		            startAngle: firstSeries.startAngle,
		            connectors: firstSeries.connectors,
		            legend: this.options.legend
		        });
	
		        this.appendChart(pieChart);
		    },
	
		    appendChart: function(chart, pane) {
		        PlotAreaBase.fn.appendChart.call(this, chart, pane);
		        append(this.options.legend.items, chart.legendItems);
		    }
		});
	
		var DonutSegment = PieSegment.extend({
		    reflowLabel: function() {
		        var ref = this;
		        var labelsOptions = ref.options.labels;
		        var label = ref.label;
		        var sector = this.sector.clone();
		        var angle = sector.middle();
	
		        if (label) {
		            var labelHeight = label.box.height();
		            if (labelsOptions.position === CENTER) {
		                sector.radius -= (sector.radius - sector.innerRadius) / 2;
	
		                var lp = sector.point(angle);
	
		                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
		            } else {
		                PieSegment.fn.reflowLabel.call(this);
		            }
		        }
		    },
	
		    createSegment: function(sector, options) {
		        return dataviz.ShapeBuilder.current.createRing(sector, options);
		    }
		});
	
		setDefaultOptions(DonutSegment, {
		    overlay: {
		        gradient: "roundedGlass"
		    },
		    labels: {
		        position: CENTER
		    },
		    animation: {
		        type: PIE
		    }
		});
	
		deepExtend(DonutSegment.prototype, PointEventsMixin);
	
		var DONUT_SECTOR_ANIM_DELAY = 50;
	
		var DonutChart = PieChart.extend({
		    addValue: function(value, sector, fields) {
		        var segmentOptions = deepExtend({}, fields.series, { index: fields.index });
		        this.evalSegmentOptions(segmentOptions, value, fields);
	
		        this.createLegendItem(value, segmentOptions, fields);
	
		        if (!value || fields.visible === false) {
		            return;
		        }
	
		        var segment = new DonutSegment(value, sector, segmentOptions);
	
		        $.extend(segment, fields);
		        this.append(segment);
		        this.points.push(segment);
		    },
	
		    reflow: function(targetBox) {
		        var this$1 = this;
	
		        var options = this.options;
		        var box = targetBox.clone();
		        var space = 5;
		        var minWidth = Math.min(box.width(), box.height());
		        var halfMinWidth = minWidth / 2;
		        var defaultPadding = minWidth - minWidth * 0.85;
		        var series = options.series;
		        var seriesCount = series.length;
	
		        var padding = valueOrDefault(options.padding, defaultPadding);
		        padding = padding > halfMinWidth - space ? halfMinWidth - space : padding;
	
		        var totalSize = halfMinWidth - padding;
		        var seriesWithoutSize = 0;
		        var holeSize;
	
		        for (var i = 0; i < seriesCount; i++) {
		            var currentSeries = series[i];
		            if (i === 0) {
		                if (defined(currentSeries.holeSize)) {
		                    holeSize = currentSeries.holeSize;
		                    totalSize -= currentSeries.holeSize;
		                }
		            }
	
		            if (defined(currentSeries.size)) {
		                totalSize -= currentSeries.size;
		            } else {
		                seriesWithoutSize++;
		            }
	
		            if (defined(currentSeries.margin) && i !== seriesCount - 1) {
		                totalSize -= currentSeries.margin;
		            }
		        }
	
		        if (!defined(holeSize)) {
		            var currentSize = (halfMinWidth - padding) / (seriesCount + 0.75);
		            holeSize = currentSize * 0.75;
		            totalSize -= holeSize;
		        }
	
		        var innerRadius = holeSize;
		        var margin = 0;
		        var size, radius;
	
		        this.seriesConfigs = [];
	
		        for (var i$1 = 0; i$1 < seriesCount; i$1++) {
		            var currentSeries$1 = series[i$1];
		            size = valueOrDefault(currentSeries$1.size, totalSize / seriesWithoutSize);
		            innerRadius += margin;
		            radius = innerRadius + size;
		            this$1.seriesConfigs.push({ innerRadius: innerRadius, radius: radius });
		            margin = currentSeries$1.margin || 0;
		            innerRadius = radius;
		        }
	
		        PieChart.fn.reflow.call(this, targetBox);
		    },
	
		    animationDelay: function(categoryIndex, seriesIndex, seriesCount) {
		        return categoryIndex * DONUT_SECTOR_ANIM_DELAY +
		            (INITIAL_ANIMATION_DURATION * (seriesIndex + 1) / (seriesCount + 1));
		    }
		});
	
		setDefaultOptions(DonutChart, {
		    startAngle: 90,
		    connectors: {
		        width: 2,
		        color: "#939393",
		        padding: 8
		    }
		});
	
		var DonutPlotArea = PiePlotArea.extend({
		    render: function() {
		        this.createDonutChart(this.series);
		    },
	
		    createDonutChart: function(series) {
		        var firstSeries = series[0];
		        var donutChart = new DonutChart(this, {
		            series: series,
		            padding: firstSeries.padding,
		            connectors: firstSeries.connectors,
		            legend: this.options.legend
		        });
	
		        this.appendChart(donutChart);
		    }
		});
	
		var DEFAULT_PADDING = 0.15;
	
		var PolarPlotAreaBase = PlotAreaBase.extend({
		    initFields: function() {
		        this.valueAxisRangeTracker = new AxisGroupRangeTracker();
		    },
	
		    render: function() {
		        this.addToLegend(this.series);
		        this.createPolarAxis();
		        this.createCharts();
		        this.createValueAxis();
		    },
	
		    alignAxes: function() {
		        var axis = this.valueAxis;
		        var range = axis.range();
		        var crossingValue = axis.options.reverse ? range.max : range.min;
		        var slot = axis.getSlot(crossingValue);
		        var center = this.polarAxis.getSlot(0).center;
		        var axisBox = axis.box.translate(
		            center.x - slot.x1,
		            center.y - slot.y1
		        );
	
		        axis.reflow(axisBox);
		    },
	
		    createValueAxis: function() {
		        var tracker = this.valueAxisRangeTracker;
		        var defaultRange = tracker.query();
		        var axisOptions = this.valueAxisOptions({
		            roundToMajorUnit: false,
		            zIndex: -1
		        });
		        var axisType, axisDefaultRange;
	
		        if (axisOptions.type === LOGARITHMIC) {
		            axisType = dataviz.RadarLogarithmicAxis;
		            axisDefaultRange = { min: 0.1, max: 1 };
		        } else {
		            axisType = dataviz.RadarNumericAxis;
		            axisDefaultRange = { min: 0, max: 1 };
		        }
	
		        var range = tracker.query(name) || defaultRange || axisDefaultRange;
	
		        if (range && defaultRange) {
		            range.min = Math.min(range.min, defaultRange.min);
		            range.max = Math.max(range.max, defaultRange.max);
		        }
	
		        var valueAxis = new axisType(
		            range.min, range.max,
		            axisOptions,
		            this.chartService
		        );
	
		        this.valueAxis = valueAxis;
		        this.appendAxis(valueAxis);
		    },
	
		    reflowAxes: function() {
		        var ref = this;
		        var options = ref.options.plotArea;
		        var valueAxis = ref.valueAxis;
		        var polarAxis = ref.polarAxis;
		        var box = ref.box;
		        var defaultPadding = Math.min(box.width(), box.height()) * DEFAULT_PADDING;
		        var padding = getSpacing(options.padding || {}, defaultPadding);
		        var paddingBox = box.clone().unpad(padding);
		        var axisBox = paddingBox.clone();
	
		        axisBox.y2 = axisBox.y1 + Math.min(axisBox.width(), axisBox.height());
		        axisBox.align(paddingBox, Y, CENTER);
	
		        var valueAxisBox = axisBox.clone().shrink(0, axisBox.height() / 2);
	
		        polarAxis.reflow(axisBox);
		        valueAxis.reflow(valueAxisBox);
		        var heightDiff = valueAxis.lineBox().height() - valueAxis.box.height();
		        valueAxis.reflow(valueAxis.box.unpad({ top: heightDiff }));
	
		        this.axisBox = axisBox;
		        this.alignAxes(axisBox);
		    },
	
		    backgroundBox: function() {
		        return this.box;
		    },
	
		    detachLabels: function() {}
		});
	
		var PolarScatterChart = ScatterChart.extend({
		    pointSlot: function(slotX, slotY) {
		        var valueRadius = slotX.center.y - slotY.y1;
		        var slot = Point.onCircle(slotX.center, slotX.startAngle, valueRadius);
	
		        return new Box(slot.x, slot.y, slot.x, slot.y);
		    }
		});
	
		setDefaultOptions(PolarScatterChart, {
		    clip: false
		});
	
		var PolarLineChart = ScatterLineChart.extend({
	
		});
	
		PolarLineChart.prototype.pointSlot = PolarScatterChart.prototype.pointSlot;
	
		setDefaultOptions(PolarLineChart, {
		    clip: false
		});
	
		var SplinePolarAreaSegment = SplineAreaSegment.extend({
		    fillToAxes: function(fillPath) {
		        var center = this._polarAxisCenter();
		        fillPath.lineTo(center.x, center.y);
		    },
	
		    _polarAxisCenter: function() {
		        var polarAxis = this.parent.plotArea.polarAxis;
		        var center = polarAxis.box.center();
		        return center;
		    },
	
		    strokeSegments: function() {
		        var segments = this._strokeSegments;
	
		        if (!segments) {
		            var center = this._polarAxisCenter();
		            var curveProcessor = new CurveProcessor(false);
		            var linePoints = this.points();
	
		            linePoints.push(center);
		            segments = this._strokeSegments = curveProcessor.process(linePoints);
		            segments.pop();
		        }
	
		        return segments;
		    }
		});
	
		var PolarAreaSegment = AreaSegment.extend({
		    fillToAxes: function(fillPath) {
		        var polarAxis = this.parent.plotArea.polarAxis;
		        var center = polarAxis.box.center();
		        var centerSegment = new geometry.Segment([ center.x, center.y ]);
	
		        fillPath.segments.unshift(centerSegment);
		        fillPath.segments.push(centerSegment);
		    }
		});
	
		var PolarAreaChart = PolarLineChart.extend({
		    createSegment: function(linePoints, currentSeries, seriesIx) {
		        var style = (currentSeries.line || {}).style;
		        var segment;
	
		        if (style === SMOOTH) {
		            segment = new SplinePolarAreaSegment(linePoints, currentSeries, seriesIx);
		        } else {
		            segment = new PolarAreaSegment(linePoints, currentSeries, seriesIx);
		        }
		        return segment;
		    },
	
		    createMissingValue: function(value, missingValues) {
		        var missingValue;
	
		        if (hasValue(value.x) && missingValues !== INTERPOLATE) {
		            missingValue = {
		                x: value.x,
		                y: value.y
		            };
		            if (missingValues === ZERO) {
		                missingValue.y = 0;
		            }
		        }
	
		        return missingValue;
		    },
	
		    seriesMissingValues: function(series) {
		        return series.missingValues || ZERO;
		    },
	
		    _hasMissingValuesGap: function() {
		        var this$1 = this;
	
		        var series = this.options.series;
	
		        for (var idx = 0; idx < series.length; idx++) {
		            if (this$1.seriesMissingValues(series[idx]) === GAP) {
		                return true;
		            }
		        }
		    },
	
		    sortPoints: function(points) {
		        var this$1 = this;
	
		        points.sort(xComparer);
	
		        if (this._hasMissingValuesGap()) {
		            for (var idx = 0; idx < points.length; idx++) {
		                var point = points[idx];
		                if (point) {
		                    var value = point.value;
		                    if (!hasValue(value.y) && this$1.seriesMissingValues(point.series) === GAP) {
		                        delete points[idx];
		                    }
		                }
		            }
		        }
	
		        return points;
		    }
		});
	
		function xComparer(a, b) {
		    return a.value.x - b.value.x;
		}
	
		var PolarPlotArea = PolarPlotAreaBase.extend({
		    createPolarAxis: function() {
		        var polarAxis = new dataviz.PolarAxis(this.options.xAxis, this.chartService);
	
		        this.polarAxis = polarAxis;
		        this.axisX = polarAxis;
		        this.appendAxis(polarAxis);
		    },
	
		    valueAxisOptions: function(defaults) {
		        return deepExtend(defaults, {
		            majorGridLines: { type: ARC },
		            minorGridLines: { type: ARC }
		        }, this.options.yAxis);
		    },
	
		    createValueAxis: function() {
		        PolarPlotAreaBase.fn.createValueAxis.call(this);
		        this.axisY = this.valueAxis;
		    },
	
		    appendChart: function(chart, pane) {
		        this.valueAxisRangeTracker.update(chart.yAxisRanges);
	
		        PlotAreaBase.prototype.appendChart.call(this, chart, pane);
		    },
	
		    createCharts: function() {
		        var series = this.filterVisibleSeries(this.series);
		        var pane = this.panes[0];
	
		        this.createLineChart(
		            filterSeriesByType(series, [ POLAR_LINE ]),
		            pane
		        );
	
		        this.createScatterChart(
		            filterSeriesByType(series, [ POLAR_SCATTER ]),
		            pane
		        );
	
		        this.createAreaChart(
		            filterSeriesByType(series, [ POLAR_AREA ]),
		            pane
		        );
		    },
	
		    createLineChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var lineChart = new PolarLineChart(this, { series: series });
	
		        this.appendChart(lineChart, pane);
		    },
	
		    createScatterChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var scatterChart = new PolarScatterChart(this, { series: series });
	
		        this.appendChart(scatterChart, pane);
		    },
	
		    createAreaChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var areaChart = new PolarAreaChart(this, { series: series });
	
		        this.appendChart(areaChart, pane);
		    },
	
		    _dispatchEvent: function(chart, e, eventType) {
		        var coords = chart._eventCoordinates(e);
		        var point = new Point(coords.x, coords.y);
		        var xValue = this.axisX.getValue(point);
		        var yValue = this.axisY.getValue(point);
	
		        if (xValue !== null && yValue !== null) {
		            chart.trigger(eventType, {
		                element: eventElement(e),
		                x: xValue,
		                y: yValue
		            });
		        }
		    },
	
		    createCrosshairs: function() {}
		});
	
		setDefaultOptions(PolarPlotArea, {
		    xAxis: {},
		    yAxis: {}
		});
	
		deepExtend(PolarPlotArea.prototype, PlotAreaEventsMixin);
	
		var RadarLineChart = LineChart.extend({
		    pointSlot: function(categorySlot, valueSlot) {
		        var valueRadius = categorySlot.center.y - valueSlot.y1;
		        var slot = Point.onCircle(categorySlot.center, categorySlot.middle(), valueRadius);
	
		        return new Box(slot.x, slot.y, slot.x, slot.y);
		    },
	
		    createSegment: function(linePoints, currentSeries, seriesIx) {
		        var style = currentSeries.style;
		        var pointType;
	
		        if (style === SMOOTH) {
		            pointType = SplineSegment;
		        } else {
		            pointType = LineSegment;
		        }
	
		        var segment = new pointType(linePoints, currentSeries, seriesIx);
	
		        if (linePoints.length === currentSeries.data.length) {
		            segment.options.closed = true;
		        }
	
		        return segment;
		    }
		});
	
		setDefaultOptions(RadarLineChart, {
		    clip: false,
		    limitPoints: false
		});
	
		var SplineRadarAreaSegment = SplineAreaSegment.extend({
		    fillToAxes: function() {}
		});
	
		var RadarAreaSegment = AreaSegment.extend({
		    fillToAxes: function() {}
		});
	
		var RadarAreaChart = RadarLineChart.extend({
		    createSegment: function(linePoints, currentSeries, seriesIx, prevSegment) {
		        var isStacked = this.options.isStacked;
		        var style = (currentSeries.line || {}).style;
		        var previousSegment;
		        var stackPoints;
		        var segment;
	
		        if (isStacked && seriesIx > 0 && prevSegment) {
		            stackPoints = prevSegment.linePoints.slice(0);
		            previousSegment = prevSegment;
		        }
	
		        if (style === SMOOTH) {
		            segment = new SplineRadarAreaSegment(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
		            segment.options.closed = true;
		        } else {
		            linePoints.push(linePoints[0]);
		            segment = new RadarAreaSegment(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
		        }
	
		        return segment;
		    },
	
		    seriesMissingValues: function(series) {
		        return series.missingValues || ZERO;
		    }
		});
	
		var RadarSegment = DonutSegment.extend({
		    init: function(value, options) {
		        DonutSegment.fn.init.call(this, value, null, options);
		    }
		});
	
		setDefaultOptions(RadarSegment, {
		    overlay: {
		        gradient: "none"
		    },
		    labels: {
		        distance: 10
		    }
		});
	
		var RadarClusterLayout = ChartElement.extend({
		    init: function(options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.forEach = options.rtl ? forEachReverse : forEach;
		    },
	
		    reflow: function(sector) {
		        var ref = this;
		        var options = ref.options;
		        var children = ref.children;
		        var gap = options.gap;
		        var spacing = options.spacing;
		        var count = children.length;
		        var slots = count + gap + (spacing * (count - 1));
		        var slotAngle = sector.angle / slots;
		        var angle = sector.startAngle + slotAngle * (gap / 2);
	
		        this.forEach(children, function (child) {
		            var slotSector = sector.clone();
		            slotSector.startAngle = angle;
		            slotSector.angle = slotAngle;
	
		            if (child.sector) {
		                slotSector.radius = child.sector.radius;
		            }
	
		            child.reflow(slotSector);
		            child.sector = slotSector;
	
		            angle += slotAngle + (slotAngle * spacing);
		        });
		    }
		});
	
		setDefaultOptions(RadarClusterLayout, {
		    gap: 1,
		    spacing: 0
		});
	
		var RadarStackLayout = ChartElement.extend({
		    reflow: function(sector) {
		        var ref = this;
		        var reverse = ref.options.reverse;
		        var children = ref.children;
		        var childrenCount = children.length;
		        var first = reverse ? childrenCount - 1 : 0;
		        var step = reverse ? -1 : 1;
	
		        this.box = new Box();
	
		        for (var i = first; i >= 0 && i < childrenCount; i += step) {
		            var childSector = children[i].sector;
		            childSector.startAngle = sector.startAngle;
		            childSector.angle = sector.angle;
		        }
		    }
		});
	
		var RadarBarChart = BarChart.extend({
		    pointType: function() {
		        return RadarSegment;
		    },
	
		    clusterType: function() {
		        return RadarClusterLayout;
		    },
	
		    stackType: function() {
		        return RadarStackLayout;
		    },
	
		    categorySlot: function(categoryAxis, categoryIx) {
		        return categoryAxis.getSlot(categoryIx);
		    },
	
		    pointSlot: function(categorySlot, valueSlot) {
		        var slot = categorySlot.clone();
		        var y = categorySlot.center.y;
	
		        slot.radius = y - valueSlot.y1;
		        slot.innerRadius = y - valueSlot.y2;
	
		        return slot;
		    },
	
		    reflowPoint: function(point, pointSlot) {
		        point.sector = pointSlot;
		        point.reflow();
		    },
	
		    createAnimation: function() {
		        this.options.animation.center = this.box.toRect().center();
		        BarChart.fn.createAnimation.call(this);
		    }
		});
	
		RadarBarChart.prototype.reflow = CategoricalChart.prototype.reflow;
	
		setDefaultOptions(RadarBarChart, {
		    clip: false,
		    limitPoints: false,
		    animation: {
		        type: "pie"
		    }
		});
	
		var RadarPlotArea = PolarPlotAreaBase.extend({
		    createPolarAxis: function() {
		        var categoryAxis = new dataviz.RadarCategoryAxis(this.options.categoryAxis, this.chartService);
	
		        this.polarAxis = categoryAxis;
		        this.categoryAxis = categoryAxis;
		        this.appendAxis(categoryAxis);
		        this.aggregateCategories();
		        this.createCategoryAxesLabels();
		    },
	
		    valueAxisOptions: function(defaults) {
		        if (this._hasBarCharts) {
		            deepExtend(defaults, {
		                majorGridLines: { type: ARC },
		                minorGridLines: { type: ARC }
		            });
		        }
	
		        if (this._isStacked100) {
		            deepExtend(defaults, {
		                roundToMajorUnit: false,
		                labels: { format: "P0" }
		            });
		        }
	
		        return deepExtend(defaults, this.options.valueAxis);
		    },
	
		    aggregateCategories: function() {
		        // No separate panes in radar charts
		        CategoricalPlotArea.prototype.aggregateCategories.call(this, this.panes);
		    },
	
		    createCategoryAxesLabels: function() {
		        CategoricalPlotArea.prototype.createCategoryAxesLabels.call(this, this.panes);
		    },
	
		    filterSeries: function(currentSeries) {
		        // Not supported for radar charts
		        return currentSeries;
		    },
	
		    createCharts: function() {
		        var series = this.filterVisibleSeries(this.series);
		        var pane = this.panes[0];
	
		        this.createAreaChart(
		            filterSeriesByType(series, [ RADAR_AREA ]),
		            pane
		        );
	
		        this.createLineChart(
		            filterSeriesByType(series, [ RADAR_LINE ]),
		            pane
		        );
	
		        this.createBarChart(
		            filterSeriesByType(series, [ RADAR_COLUMN ]),
		            pane
		        );
		    },
	
		    chartOptions: function(series) {
		        var options = { series: series };
		        var firstSeries = series[0];
		        if (firstSeries) {
		            var filteredSeries = this.filterVisibleSeries(series);
		            var stack = firstSeries.stack;
		            options.isStacked = stack && filteredSeries.length > 1;
		            options.isStacked100 = stack && stack.type === "100%" && filteredSeries.length > 1;
	
		            if (options.isStacked100) {
		                this._isStacked100 = true;
		            }
		        }
	
		        return options;
		    },
	
		    createAreaChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var areaChart = new RadarAreaChart(this, this.chartOptions(series));
		        this.appendChart(areaChart, pane);
		    },
	
		    createLineChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var lineChart = new RadarLineChart(this, this.chartOptions(series));
		        this.appendChart(lineChart, pane);
		    },
	
		    createBarChart: function(series, pane) {
		        if (series.length === 0) {
		            return;
		        }
	
		        var firstSeries = series[0];
		        var options = this.chartOptions(series);
		        options.gap = firstSeries.gap;
		        options.spacing = firstSeries.spacing;
	
		        var barChart = new RadarBarChart(this, options);
		        this.appendChart(barChart, pane);
	
		        this._hasBarCharts = true;
		    },
	
		    seriesCategoryAxis: function() {
		        return this.categoryAxis;
		    },
	
		    _dispatchEvent: function(chart, e, eventType) {
		        var coords = chart._eventCoordinates(e);
		        var point = new Point(coords.x, coords.y);
		        var category = this.categoryAxis.getCategory(point);
		        var value = this.valueAxis.getValue(point);
	
		        if (category !== null && value !== null) {
		            chart.trigger(eventType, {
		                element: eventElement(e),
		                category: category,
		                value: value
		            });
		        }
		    },
	
		    createCrosshairs: function() {}
		});
	
		deepExtend(RadarPlotArea.prototype, PlotAreaEventsMixin, {
		    appendChart: CategoricalPlotArea.prototype.appendChart,
		    aggregateSeries: CategoricalPlotArea.prototype.aggregateSeries,
		    seriesSourcePoints: CategoricalPlotArea.prototype.seriesSourcePoints
		});
	
		setDefaultOptions(RadarPlotArea, {
		    categoryAxis: {
		        categories: []
		    },
		    valueAxis: {}
		});
	
		var FunnelSegment = ChartElement.extend({
		    init: function(value, options, segmentOptions) {
		        ChartElement.fn.init.call(this, options);
	
		        this.value = value;
		        this.options.index = segmentOptions.index;
		    },
	
		    reflow: function(chartBox) {
		        var points = this.points;
		        var label = this.children[0];
	
		        this.box = new Box(points[0].x, points[0].y, points[1].x, points[2].y);
	
		        if (label) {
		            label.reflow(new Box(chartBox.x1, points[0].y, chartBox.x2, points[2].y));
		        }
		    },
	
		    createVisual: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var visual;
	
		        ChartElement.fn.createVisual.call(this);
	
		        if (options.visual) {
		            visual = options.visual({
		                category: this.category,
		                dataItem: this.dataItem,
		                value: this.value,
		                series: this.series,
		                percentage: this.percentage,
		                points: this.points,
		                options: options,
		                sender: this.getSender(),
		                createVisual: function () { return this$1.createPath(); }
		            });
		        } else {
		            visual = this.createPath();
		        }
	
		        if (visual) {
		            this.visual.append(visual);
		        }
		    },
	
		    createPath: function() {
		        var options = this.options;
		        var border = options.border;
		        var path = Path.fromPoints(this.points, {
		            fill: {
		                color: options.color,
		                opacity: options.opacity
		            },
		            stroke: {
		                color: border.color,
		                opacity: border.opacity,
		                width: border.width
		            }
		        }).close();
	
		        return path;
		    },
	
		    createHighlight: function(style) {
		        return Path.fromPoints(this.points, style);
		    },
	
		    highlightVisual: function() {
		        return this.visual.children[0];
		    },
	
		    highlightVisualArgs: function() {
		        var path = Path.fromPoints(this.points).close();
	
		        return {
		            options: this.options,
		            path: path
		        };
		    },
	
		    tooltipAnchor: function() {
		        var box = this.box;
		        return {
		            point: new Point(box.center().x, box.y1),
		            align: {
		                horizontal: "center",
		                vertical: "top"
		            }
		        };
		    },
	
		    formatValue: function(format) {
		        var point = this;
		        return point.owner.formatPointValue(point, format);
		    }
		});
	
		setDefaultOptions(FunnelSegment, {
		    color: WHITE,
		    border: {
		        width: 1
		    }
		});
	
		deepExtend(FunnelSegment.prototype, PointEventsMixin);
	
		var FunnelChart = ChartElement.extend({
		    init: function(plotArea, options) {
		        ChartElement.fn.init.call(this, options);
	
		        this.plotArea = plotArea;
		        this.points = [];
		        this.labels = [];
		        this.legendItems = [];
		        this.render();
		    },
	
		    formatPointValue: function(point, format) {
		        return this.chartService.format.auto(format,point.value);
		    },
	
		    render: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var options = ref.options;
		        var seriesColors = ref.plotArea.options.seriesColors; if (seriesColors === void 0) { seriesColors = []; }
		        var series = options.series[0];
		        var data = series.data;
	
		        if (!data) {
		            return;
		        }
	
		        var ref$1 = bindSegments(series);
		        var total = ref$1.total;
		        var points = ref$1.points;
	
		        for (var i = 0; i < points.length; i++) {
		            var pointData = points[i];
	
		            if (!pointData) {
		                continue;
		            }
	
		            var fields = pointData.fields;
	
		            if (!isFunction(series.color)) {
		                series.color = fields.color || seriesColors[i % seriesColors.length];
		            }
	
		            fields = deepExtend({
		                index: i,
		                owner: this$1,
		                series: series,
		                dataItem: data[i],
		                percentage: pointData.value / total
		            }, fields, { visible: pointData.visible });
	
		            var value = pointData.valueFields.value;
		            var segment = this$1.createSegment(value, fields);
		            var label = this$1.createLabel(value, fields);
	
		            if (segment && label) {
		                segment.append(label);
		            }
		        }
		    },
	
		    evalSegmentOptions: function(options, value, fields) {
		        var series = fields.series;
	
		        evalOptions(options, {
		            value: value,
		            series: series,
		            dataItem: fields.dataItem,
		            index: fields.index
		        }, { defaults: series._defaults, excluded: [ "data", "content", "template", "toggle", "visual" ] });
		    },
	
		    createSegment: function(value, fields) {
		        var seriesOptions = deepExtend({}, fields.series);
		        this.evalSegmentOptions(seriesOptions, value, fields);
	
		        this.createLegendItem(value, seriesOptions, fields);
	
		        if (fields.visible !== false) {
	
		            var segment = new FunnelSegment(value, seriesOptions, fields);
		            $.extend(segment, fields);
	
		            this.append(segment);
		            this.points.push(segment);
	
		            return segment;
		        }
		    },
	
		    createLabel: function(value, fields) {
		        var series = fields.series;
		        var dataItem = fields.dataItem;
		        var labels = deepExtend({}, this.options.labels, series.labels);
		        var text = value;
	
		        if (labels.visible) {
		            var labelTemplate = getTemplate(labels);
		            var data = {
		                dataItem: dataItem,
		                value: value,
		                percentage: fields.percentage,
		                category: fields.category,
		                series: series
		            };
		            if (labelTemplate) {
		                text = labelTemplate(data);
		            } else if (labels.format) {
		                text = this.plotArea.chartService.format.auto(labels.format, text);
		            }
	
		            if (!labels.color) {
		                var brightnessValue = new Color(series.color).percBrightness();
		                if (brightnessValue > 180) {
		                    labels.color = BLACK;
		                } else {
		                    labels.color = WHITE;
		                }
		                if (!labels.background) {
		                    labels.background = series.color;
		                }
		            }
	
		            this.evalSegmentOptions(labels, value, fields);
		            var textBox = new TextBox(text, deepExtend({
		                vAlign: labels.position
		            }, labels), data);
	
		            this.labels.push(textBox);
	
		            return textBox;
		        }
		    },
	
		    labelPadding: function() {
		        var labels = this.labels;
		        var padding = { left: 0, right: 0 };
	
		        for (var i = 0; i < labels.length; i++) {
		            var label = labels[i];
		            var align = label.options.align;
		            if (align !== CENTER) {
		                var width = labels[i].box.width();
	
		                if (align === LEFT) {
		                    padding.left = Math.max(padding.left, width);
		                } else {
		                    padding.right = Math.max(padding.right, width);
		                }
		            }
		        }
	
		        return padding;
		    },
	
		    dynamicSlopeReflow: function(box, width, totalHeight) {
		        var ref = this;
		        var options = ref.options;
		        var segments = ref.points;
		        var count = segments.length;
		        var firstSegment = segments[0];
		        var maxSegment = firstSegment;
	
		        for (var idx = 0; idx < segments.length; idx++) {
		            if (segments[idx].percentage > maxSegment.percentage) {
		                maxSegment = segments[idx];
		            }
		        }
	
		        var lastUpperSide = (firstSegment.percentage / maxSegment.percentage) * width;
		        var previousOffset = (width - lastUpperSide) / 2;
		        var previousHeight = 0;
	
		        for (var idx$1 = 0; idx$1 < count; idx$1++) {
		            var percentage = segments[idx$1].percentage;
		            var nextSegment = segments[idx$1 + 1];
		            var nextPercentage = (nextSegment ? nextSegment.percentage : percentage);
		            var points = segments[idx$1].points = [];
		            var height = (options.dynamicHeight) ? (totalHeight * percentage) : (totalHeight / count);
		            var offset = (void 0);
	
		            if (!percentage) {
		                offset = nextPercentage ? 0 : width / 2;
		            } else {
		                offset = (width - lastUpperSide * (nextPercentage / percentage)) / 2;
		            }
	
		            offset = limitValue(offset, 0, width);
	
		            points.push(new GeometryPoint(box.x1 + previousOffset, box.y1 + previousHeight));
		            points.push(new GeometryPoint(box.x1 + width - previousOffset, box.y1 + previousHeight));
		            points.push(new GeometryPoint(box.x1 + width - offset, box.y1 + height + previousHeight));
		            points.push(new GeometryPoint(box.x1 + offset, box.y1 + height + previousHeight));
	
		            previousOffset = offset;
		            previousHeight += height + options.segmentSpacing;
		            lastUpperSide = limitValue(width - 2 * offset, 0, width);
		        }
		    },
	
		    constantSlopeReflow: function(box, width, totalHeight) {
		        var ref = this;
		        var options = ref.options;
		        var segments = ref.points;
		        var count = segments.length;
		        var decreasingWidth = options.neckRatio <= 1;
		        var neckRatio = decreasingWidth ? options.neckRatio * width : width;
		        var previousOffset = decreasingWidth ? 0 : (width - width / options.neckRatio) / 2;
		        var topMostWidth = decreasingWidth ? width : width - previousOffset * 2;
		        var finalNarrow = (topMostWidth - neckRatio) / 2;
		        var previousHeight = 0;
	
		        for (var idx = 0; idx < count; idx++) {
		            var points = segments[idx].points = [];
		            var percentage = segments[idx].percentage;
		            var offset = (options.dynamicHeight) ? (finalNarrow * percentage) : (finalNarrow / count);
		            var height = (options.dynamicHeight) ? (totalHeight * percentage) : (totalHeight / count);
	
		            points.push(new GeometryPoint(box.x1 + previousOffset, box.y1 + previousHeight));
		            points.push(new GeometryPoint(box.x1 + width - previousOffset, box.y1 + previousHeight));
		            points.push(new GeometryPoint(box.x1 + width - previousOffset - offset, box.y1 + height + previousHeight));
		            points.push(new GeometryPoint(box.x1 + previousOffset + offset,box.y1 + height + previousHeight));
		            previousOffset += offset;
		            previousHeight += height + options.segmentSpacing;
		        }
		    },
	
		    reflow: function(chartBox) {
		        var points = this.points;
		        var count = points.length;
	
		        if (!count) {
		            return;
		        }
	
		        var options = this.options;
		        var box = chartBox.clone().unpad(this.labelPadding());
		        var totalHeight = box.height() - options.segmentSpacing * (count - 1);
		        var width = box.width();
	
		        if (options.dynamicSlope) {
		            this.dynamicSlopeReflow(box, width, totalHeight);
		        } else {
		            this.constantSlopeReflow(box, width, totalHeight);
		        }
	
		        for (var idx = 0; idx < count; idx++) {
		            points[idx].reflow(chartBox);
		        }
		    }
		});
	
		setDefaultOptions(FunnelChart, {
		    neckRatio: 0.3,
		    width: 300,
		    dynamicSlope: false,
		    dynamicHeight: true,
		    segmentSpacing: 0,
		    labels: {
		        visible: false,
		        align: CENTER,
		        position: CENTER,
		        zIndex: 1
		    }
		});
	
		deepExtend(FunnelChart.prototype, PieChartMixin);
	
		var FunnelPlotArea = PlotAreaBase.extend({
		    render: function() {
		        this.createFunnelChart(this.series);
		    },
	
		    createFunnelChart: function(series) {
		        var firstSeries = series[0];
		        var funnelChart = new FunnelChart(this, {
		            series: series,
		            legend: this.options.legend,
		            neckRatio: firstSeries.neckRatio,
		            dynamicHeight: firstSeries.dynamicHeight,
		            dynamicSlope: firstSeries.dynamicSlope,
		            segmentSpacing: firstSeries.segmentSpacing,
		            highlight: firstSeries.highlight
		        });
	
		        this.appendChart(funnelChart);
		    },
	
		    appendChart: function(chart, pane) {
		        PlotAreaBase.fn.appendChart.call(this, chart, pane);
		        append(this.options.legend.items, chart.legendItems);
		    }
		});
	
		var COLOR = "color";
		var FIRST = "first";
		var FROM = "from";
		var MAX = "max";
		var MIN = "min";
		var NOTE_TEXT = "noteText";
		var SUMMARY_FIELD = "summary";
		var TO = "to";
	
		PlotAreaFactory.current.register(CategoricalPlotArea, [
		    BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA,
		    CANDLESTICK, OHLC, BULLET, VERTICAL_BULLET, BOX_PLOT, VERTICAL_BOX_PLOT,
		    RANGE_COLUMN, RANGE_BAR, WATERFALL, HORIZONTAL_WATERFALL, RANGE_AREA, VERTICAL_RANGE_AREA
		]);
	
		PlotAreaFactory.current.register(XYPlotArea, [
		    SCATTER, SCATTER_LINE, BUBBLE
		]);
	
		PlotAreaFactory.current.register(PiePlotArea, [ PIE ]);
		PlotAreaFactory.current.register(DonutPlotArea, [ DONUT ]);
		PlotAreaFactory.current.register(FunnelPlotArea, [ FUNNEL ]);
	
		PlotAreaFactory.current.register(PolarPlotArea, [ POLAR_AREA, POLAR_LINE, POLAR_SCATTER ]);
		PlotAreaFactory.current.register(RadarPlotArea, [ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ]);
	
		SeriesBinder.current.register(
		    [ BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA ],
		    [ VALUE ], [ CATEGORY, COLOR, NOTE_TEXT, ERROR_LOW_FIELD, ERROR_HIGH_FIELD ]
		);
	
		SeriesBinder.current.register(
		    [ RANGE_COLUMN, RANGE_BAR, RANGE_AREA, VERTICAL_RANGE_AREA ],
		    [ FROM, TO ], [ CATEGORY, COLOR, NOTE_TEXT ]
		);
	
		SeriesBinder.current.register(
		    [ WATERFALL, HORIZONTAL_WATERFALL ],
		    [ VALUE ], [ CATEGORY, COLOR, NOTE_TEXT, SUMMARY_FIELD ]
		);
	
		SeriesBinder.current.register([ POLAR_AREA, POLAR_LINE, POLAR_SCATTER ], [ X, Y ], [ COLOR ]);
		SeriesBinder.current.register([ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ], [ VALUE ], [ COLOR ]);
	
		SeriesBinder.current.register(
		    [ FUNNEL ],
		    [ VALUE ], [ CATEGORY, COLOR, "visibleInLegend", "visible" ]
		);
	
		DefaultAggregates.current.register(
		    [ BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA, WATERFALL, HORIZONTAL_WATERFALL ],
		    { value: MAX, color: FIRST, noteText: FIRST, errorLow: MIN, errorHigh: MAX }
		);
	
		DefaultAggregates.current.register(
		    [ RANGE_COLUMN, RANGE_BAR, RANGE_AREA, VERTICAL_RANGE_AREA ],
		    { from: MIN, to: MAX, color: FIRST, noteText: FIRST }
		);
	
		DefaultAggregates.current.register(
		    [ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ],
		    { value: MAX, color: FIRST }
		);
	
		SeriesBinder.current.register(
		    [ SCATTER, SCATTER_LINE, BUBBLE ],
		    [ X, Y ], [ COLOR, NOTE_TEXT, X_ERROR_LOW_FIELD, X_ERROR_HIGH_FIELD, Y_ERROR_LOW_FIELD, Y_ERROR_HIGH_FIELD ]
		);
	
		SeriesBinder.current.register(
		    [ BUBBLE ], [ X, Y, "size" ], [ COLOR, CATEGORY, NOTE_TEXT ]
		);
	
		SeriesBinder.current.register(
		    [ CANDLESTICK, OHLC ],
		    [ "open", "high", "low", "close" ], [ CATEGORY, COLOR, "downColor", NOTE_TEXT ]
		);
	
		DefaultAggregates.current.register(
		    [ CANDLESTICK, OHLC ],
		    { open: MAX, high: MAX, low: MIN, close: MAX,
		      color: FIRST, downColor: FIRST, noteText: FIRST }
		);
	
		SeriesBinder.current.register(
		    [ BOX_PLOT, VERTICAL_BOX_PLOT ],
		    [ "lower", "q1", "median", "q3", "upper", "mean", "outliers" ], [ CATEGORY, COLOR, NOTE_TEXT ]
		);
	
		DefaultAggregates.current.register(
		    [ BOX_PLOT, VERTICAL_BOX_PLOT ],
		    { lower: MAX, q1: MAX, median: MAX, q3: MAX, upper: MAX, mean: MAX, outliers: FIRST,
		      color: FIRST, noteText: FIRST }
		);
	
		SeriesBinder.current.register(
		    [ BULLET, VERTICAL_BULLET ],
		    [ "current", "target" ], [ CATEGORY, COLOR, "visibleInLegend", NOTE_TEXT ]
		);
	
		DefaultAggregates.current.register(
		    [ BULLET, VERTICAL_BULLET ],
		    { current: MAX, target: MAX, color: FIRST, noteText: FIRST }
		);
	
		SeriesBinder.current.register(
		    [ PIE, DONUT ],
		    [ VALUE ], [ CATEGORY, COLOR, "explode", "visibleInLegend", "visible" ]
		);
	
		var AXIS_NAMES = [ CATEGORY, VALUE, X, Y ];
	
		var MOUSEMOVE = "mousemove";
		var CONTEXTMENU = "contextmenu";
		var MOUSELEAVE = "mouseleave";
		var MOUSEMOVE_DELAY = 20;
	
		var Chart = Class.extend({
		    init: function(element, userOptions, themeOptions, context) {
		        var this$1 = this;
		        if (context === void 0) { context = {}; }
	
		        this.observers = [];
		        this.addObserver(context.observer);
		        this.chartService = new services.ChartService(this, context);
		        this.chartService.theme = themeOptions;
	
		        this._initElement(element);
	
		        var options = deepExtend({}, this.options, userOptions);
		        this._originalOptions = deepExtend({}, options);
		        this._theme = themeOptions;
		        this._initTheme(options, themeOptions);
	
		        this._initHandlers();
		        this._initSurface();
	
		        this.bindCategories();
		        dataviz.FontLoader.preloadFonts(userOptions, function () {
		            if (!this$1._destroyed) {
		                this$1.trigger('init');
		                this$1._redraw();
		                this$1._attachEvents();
		            }
		        });
		    },
	
		    _initElement: function(element) {
		        this._setElementClass(element);
		        element.style.position = "relative";
		        while (element.firstChild) {
		            element.removeChild(element.firstChild);
		        }
		        this.element = element;
		    },
	
		    _setElementClass: function(element) {
		        dataviz.addClass(element, "k-chart");
		    },
	
		    _initTheme: function(options, themeOptions) {
		        var seriesCopies = [];
		        var series = options.series || [];
	
		        for (var i = 0; i < series.length; i++) {
		            seriesCopies.push($.extend({}, series[i]));
		        }
		        options.series = seriesCopies;
	
		        resolveAxisAliases(options);
		        this.applyDefaults(options, themeOptions);
	
		        // Clean up default if not overriden by data attributes
		        if (options.seriesColors === null) {
		            delete options.seriesColors;
		        }
	
		        this.options = deepExtend({}, themeOptions, options);
		        this.applySeriesColors();
		    },
	
		    getSize: function() {
		        var chartArea = this.options.chartArea || {};
		        var width = chartArea.width ? parseInt(chartArea.width, 10) : Math.floor(this.element.offsetWidth);
		        var height = chartArea.height ? parseInt(chartArea.height, 10) : Math.floor(this.element.offsetHeight);
	
		        return {
		            width: width,
		            height: height
		        };
		    },
	
		    resize: function(force) {
		        var size = this.getSize();
		        var currentSize = this._size;
	
		        if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
		            this._size = size;
		            this._resize(size, force);
		            this.trigger("resize", size);
		        }
		    },
	
		    _resize: function() {
		        this._noTransitionsRedraw();
		    },
	
		    redraw: function(paneName) {
		        this.applyDefaults(this.options);
		        this.applySeriesColors();
	
		        if (paneName) {
		            var plotArea = this._model._plotArea;
		            var pane = plotArea.findPane(paneName);
		            plotArea.redraw(pane);
		        } else {
		            this._redraw();
		        }
		    },
	
		    getAxis: function(name) {
		        return findAxisByName(name, this._plotArea.axes);
		    },
	
		    findAxisByName: function(name) {
		        return this.getAxis(name);
		    },
	
		    findPaneByName: function(name) {
		        var panes = this._plotArea.panes;
	
		        for (var idx = 0; idx < panes.length; idx++) {
		            if (panes[idx].options.name === name) {
		                return new ChartPane(panes[idx]);
		            }
		        }
		    },
	
		    findPaneByIndex: function(idx) {
		        var panes = this._plotArea.panes;
		        if (panes[idx]) {
		            return new ChartPane(panes[idx]);
		        }
		    },
	
		    plotArea: function() {
		        return new ChartPlotArea(this._plotArea);
		    },
	
		    toggleHighlight: function(show, filter) {
		        var plotArea = this._plotArea;
		        var firstSeries = (plotArea.srcSeries || plotArea.series || [])[0];
		        var points;
	
		        if (isFunction(filter)) {
		            points = plotArea.filterPoints(filter);
		        } else {
		            var seriesName, categoryName;
		            if (isObject(filter)) {
		                seriesName = filter.series;
		                categoryName = filter.category;
		            } else {
		                seriesName = categoryName = filter;
		            }
	
		            if (firstSeries.type === DONUT) {
		                points = pointByCategoryName(plotArea.pointsBySeriesName(seriesName), categoryName);
		            } else if (firstSeries.type === PIE || firstSeries.type === FUNNEL) {
		                points = pointByCategoryName((plotArea.charts[0] || {}).points, categoryName);
		            } else {
		                points = plotArea.pointsBySeriesName(seriesName);
		            }
		        }
	
		        if (points) {
		            this.togglePointsHighlight(show, points);
		        }
		    },
	
		    togglePointsHighlight: function(show, points) {
		        var highlight = this._highlight;
		        for (var idx = 0; idx < points.length; idx++) {
		            highlight.togglePointHighlight(points[idx], show);
		        }
		    },
	
		    showTooltip: function(filter) {
		        var shared = this._sharedTooltip();
		        var ref = this;
		        var tooltip = ref._tooltip;
		        var plotArea = ref._plotArea;
		        var point, categoryIndex;
	
		        if (isFunction(filter)) {
		            point = plotArea.findPoint(filter);
		            if (point && shared) {
		                categoryIndex = point.categoryIx;
		            }
		        } else if (shared && defined(filter)) {
		            categoryIndex = plotArea.categoryAxis.categoryIndex(filter);
		        }
	
		        if (shared) {
		            if (categoryIndex >= 0) {
		                var points = this._plotArea.pointsByCategoryIndex(categoryIndex);
		                tooltip.showAt(points);
		            }
		        } else if (point) {
		            tooltip.show(point);
		        }
		    },
	
		    hideTooltip: function() {
		        this._tooltip.hide();
		    },
	
		    _initSurface: function() {
		        var surface = this.surface;
		        var wrap = this._surfaceWrap();
	
		        var chartArea = this.options.chartArea;
		        if (chartArea.width) {
		            dataviz.elementSize(wrap, { width: chartArea.width });
		        }
		        if (chartArea.height) {
		            dataviz.elementSize(wrap, { height: chartArea.height });
		        }
	
		        if (!surface || surface.options.type !== this.options.renderAs) {
		            this._destroySurface();
	
		            this.surface = drawing.Surface.create(wrap, {
		                type: this.options.renderAs
		            });
	
		            this.surface.bind("mouseenter", this._surfaceMouseenterHandler);
		            this.surface.bind("mouseleave", this._surfaceMouseleaveHandler);
	
		        } else {
		            this.surface.clear();
		            this.surface.resize();
		        }
		    },
	
		    _surfaceWrap: function() {
		        return this.element;
		    },
	
		    _redraw: function() {
		        var model = this._getModel();
		        this._size = {
		            width: model.options.width,
		            height: model.options.height
		        };
	
		        this._destroyView();
	
		        this._model = model;
		        this._plotArea = model._plotArea;
	
		        model.renderVisual();
	
		        if (this.options.transitions !== false) {
		            model.traverse(function(element) {
		                if (element.animation) {
		                    element.animation.setup();
		                }
		            });
		        }
	
		        this._initSurface();
		        this.surface.draw(model.visual);
	
		        if (this.options.transitions !== false) {
		            model.traverse(function(element) {
		                if (element.animation) {
		                    element.animation.play();
		                }
		            });
		        }
	
		        this._tooltip = this._createTooltip();
		        this._highlight = new Highlight();
		        this._setupSelection();
		        this._createPannable();
		        this._createZoomSelection();
		        this._createMousewheelZoom();
	
		        this.trigger(RENDER);
		        triggerPaneRender(this._plotArea.panes);
	
		        if (!this._navState) {
		            this._cancelDomEvents();
		        }
		    },
	
		    exportVisual: function(exportOptions) {
		        var visual;
		        if (exportOptions && (exportOptions.width || exportOptions.height || exportOptions.options)) {
		            var currentOptions = this.options;
		            var options = deepExtend({}, exportOptions.options, {
		                chartArea: {
		                    width: exportOptions.width,
		                    height: exportOptions.height
		                }
		            });
	
		            clearMissingValues(this._originalOptions, options);
		            this.options = deepExtend({}, this._originalOptions, options);
		            this._initTheme(this.options, this._theme);
		            this.bindCategories();
	
		            var model = this._getModel();
	
		            model.renderVisual();
		            triggerPaneRender(model._plotArea.panes);
	
		            visual = model.visual;
	
		            this.options = currentOptions;
		        } else {
		            visual = this.surface.exportVisual();
		        }
	
		        return visual;
		    },
	
		    _sharedTooltip: function() {
		        return this._plotArea instanceof CategoricalPlotArea && this.options.tooltip.shared;
		    },
	
		    _createPannable: function() {
		        var options = this.options;
		        if (options.pannable !== false) {
		            this._pannable = new Pannable(this._plotArea, options.pannable);
		        }
		    },
	
		    _createZoomSelection: function() {
		        var zoomable = this.options.zoomable;
		        var selection = (zoomable || {}).selection;
		        if (zoomable !== false && selection !== false) {
		            this._zoomSelection = new ZoomSelection(this, selection);
		        }
		    },
	
		    _toggleDomDrag: function() {
		        if (!this.domEvents || !this.domEvents.toggleDrag) {
		            return;
		        }
	
		        var pannable = this.options.pannable;
		        var zoomable = this.options.zoomable;
		        var selection = (zoomable || {}).selection;
		        if (!pannable && (zoomable === false || selection === false) && !this.requiresHandlers([ DRAG_START, DRAG, DRAG_END ])) {
		            this.domEvents.toggleDrag(false);
		        } else {
		            this.domEvents.toggleDrag(true);
		        }
		    },
	
		    _createMousewheelZoom: function() {
		        var zoomable = this.options.zoomable;
		        var mousewheel = (zoomable || {}).mousewheel;
		        if (zoomable !== false && mousewheel !== false) {
		            this._mousewheelZoom = new MousewheelZoom(this, mousewheel);
		        }
		    },
	
		    _toggleDomZoom: function() {
		        if (!this.domEvents || !this.domEvents.toggleZoom) {
		            return;
		        }
	
		        var zoomable = this.options.zoomable;
		        var mousewheel = (zoomable || {}).mousewheel;
		        if ((zoomable === false || mousewheel === false) && !this.requiresHandlers([ ZOOM_START, ZOOM, ZOOM_END ])) {
		            this.domEvents.toggleZoom(false);
		        } else {
		            this.domEvents.toggleZoom(true);
		        }
		    },
	
		    _createTooltip: function() {
		        var ref = this;
		        var tooltipOptions = ref.options.tooltip;
		        var tooltip;
	
		        if (this._sharedTooltip()) {
		            tooltip = this._createSharedTooltip(tooltipOptions);
		        } else {
		            tooltip = new Tooltip(this.chartService, tooltipOptions);
		        }
	
		        return tooltip;
		    },
	
		    _createSharedTooltip: function(options) {
		        return new SharedTooltip(this._plotArea, options);
		    },
	
		    applyDefaults: function(options, themeOptions) {
		        applyAxisDefaults(options, themeOptions);
		        applySeriesDefaults(options, themeOptions);
		    },
	
		    applySeriesColors: function() {
		        var options = this.options;
		        var series = options.series;
		        var colors = options.seriesColors || [];
	
		        for (var i = 0; i < series.length; i++) {
		            var currentSeries = series[i];
		            var seriesColor = colors[i % colors.length];
		            var defaults = currentSeries._defaults;
	
		            currentSeries.color = currentSeries.color || seriesColor;
		            if (defaults) {
		                defaults.color = defaults.color || seriesColor;
		            }
		        }
		    },
	
		    _getModel: function() {
		        var options = this.options;
		        var plotArea = this._createPlotArea();
		        var model = new dataviz.RootElement(this._modelOptions());
		        model.chart = this;
		        model._plotArea = plotArea;
	
		        dataviz.Title.buildTitle(options.title, model);
	
		        if (options.legend.visible) {
		            model.append(new Legend(plotArea.options.legend, this.chartService));
		        }
		        model.append(plotArea);
		        model.reflow();
	
		        return model;
		    },
	
		    _modelOptions: function() {
		        var options = this.options;
		        var size = this.getSize();
	
		        return deepExtend({
		            transitions: options.transitions,
		            width: size.width || datavizConstants.DEFAULT_WIDTH,
		            height: size.height || datavizConstants.DEFAULT_HEIGHT
		        }, options.chartArea);
		    },
	
		    _createPlotArea: function(skipSeries) {
		        var options = this.options;
	
		        var plotArea = PlotAreaFactory.current.create(skipSeries ? [] : options.series, options, this.chartService);
	
		        return plotArea;
		    },
	
		    _setupSelection: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var axes = ref._plotArea.axes;
		        var selections = this._selections = [];
	
		        for (var i = 0; i < axes.length; i++) {
		            var axis = axes[i];
		            var options = axis.options;
		            if (axis instanceof CategoryAxis && options.select && !options.vertical) {
		                var range = axis.range();
	
		                var selection = new Selection(this$1, axis,
		                    deepExtend({ min: range.min, max: range.max }, options.select)
		                );
	
		                selections.push(selection);
		            }
		        }
		    },
	
		    _selectStart: function(e) {
		        return this.trigger(SELECT_START, e);
		    },
	
		    _select: function(e) {
		        return this.trigger(SELECT, e);
		    },
	
		    _selectEnd: function(e) {
		        return this.trigger(SELECT_END, e);
		    },
	
		    _initHandlers: function() {
		        this._clickHandler = this._click.bind(this);
		        this._mousewheelHandler = this._mousewheel.bind(this);
		        this._mouseleaveHandler = this._mouseleave.bind(this);
		        this._surfaceMouseenterHandler = this._mouseover.bind(this);
		        this._surfaceMouseleaveHandler = this._mouseout.bind(this);
	
		        this._mousemove = kendo.throttle(
		            this._mousemove.bind(this),
		            MOUSEMOVE_DELAY
		        );
		    },
	
		    addObserver: function(observer) {
		        if (observer) {
		            this.observers.push(observer);
		        }
		    },
	
		    removeObserver: function(observer) {
		        var index = this.observers.indexOf(observer);
		        if (index >= 0) {
		            this.observers.splice(index, 1);
		        }
		    },
	
		    requiresHandlers: function(eventNames) {
		        var observers = this.observers;
		        for (var idx = 0; idx < observers.length; idx++) {
		            if (observers[idx].requiresHandlers(eventNames)) {
		                return true;
		            }
		        }
		    },
	
		    trigger: function(name, args) {
		        if (args === void 0) { args = {}; }
	
		        if (name === SHOW_TOOLTIP) {
		            args.anchor.point = this._toDocumentCoordinates(args.anchor.point);
		        }
		        args.sender = this;
	
		        var observers = this.observers;
		        var isDefaultPrevented = false;
		        for (var idx = 0; idx < observers.length; idx++) {
		            if (observers[idx].trigger(name, args)) {
		                isDefaultPrevented = true;
		            }
		        }
	
		        return isDefaultPrevented;
		    },
	
		    _attachEvents: function() {
		        var element = this.element;
	
		        var obj;
		        bindEvents(element, ( obj = {}, obj[ CONTEXTMENU ] = this._clickHandler, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj[ MOUSELEAVE ] = this._mouseleaveHandler, obj ));
	
		        if (this._shouldAttachMouseMove()) {
		            var obj$1;
		            bindEvents(element, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mousemove, obj$1 ));
		        }
	
		        this.domEvents = services.DomEventsBuilder.create(this.element, {
		            start: this._start.bind(this),
		            move: this._move.bind(this),
		            end: this._end.bind(this),
		            tap: this._tap.bind(this),
		            gesturestart: this._gesturestart.bind(this),
		            gesturechange: this._gesturechange.bind(this),
		            gestureend: this._gestureend.bind(this)
		        });
	
		        this._toggleDomDrag();
		        this._toggleDomZoom();
		    },
	
		    _mouseleave: function(e) {
		        if (this._hoveredPoint) {
		            this._hoveredPoint.out(this, e);
		            this._hoveredPoint = null;
		        }
	
		        if (this._plotArea.hovered) {
		            this.trigger(PLOT_AREA_LEAVE);
		            this._plotArea.hovered = false;
		        }
		    },
	
		    _cancelDomEvents: function() {
		        if (this.domEvents && this.domEvents.cancel) {
		            this.domEvents.cancel();
		        }
		    },
	
		    _gesturestart: function(e) {
		        if (this._mousewheelZoom && !this._stopChartHandlers(e)) {
		            this._gestureDistance = e.distance;
		            this._unsetActivePoint();
		            this.surface.suspendTracking();
		        }
		    },
	
		    _gestureend: function(e) {
		        if (this._zooming && !this._stopChartHandlers(e)) {
		            if (this.surface) {
		                this.surface.resumeTracking();
		            }
		            this._zooming = false;
		            this.trigger(ZOOM_END, {});
		        }
		    },
	
		    _gesturechange: function(e) {
		        var mousewheelZoom = this._mousewheelZoom;
	
		        if (mousewheelZoom && !this._stopChartHandlers(e)) {
		            e.preventDefault();
		            var previousGestureDistance = this._gestureDistance;
		            var scaleDelta = -e.distance / previousGestureDistance + 1;
	
		            if (Math.abs(scaleDelta) >= 0.1) {
		                scaleDelta = Math.round(scaleDelta * 10);
	
		                this._gestureDistance = e.distance;
		                var args = { delta: scaleDelta, axisRanges: axisRanges(this._plotArea.axes), originalEvent: e };
		                if (this._zooming || !this.trigger(ZOOM_START, args)) {
	
		                    if (!this._zooming) {
		                        this._zooming = true;
		                    }
	
		                    var ranges = args.axisRanges = mousewheelZoom.updateRanges(scaleDelta);
		                    if (ranges && !this.trigger(ZOOM, args)) {
		                        mousewheelZoom.zoom();
		                    }
		                }
		            }
		        }
		    },
	
		    _mouseout: function(e) {
		        if (e.element) {
		            var element = this._drawingChartElement(e.element, e);
	
		            if (element && element.leave) {
		                element.leave(this, e.originalEvent);
		            }
		        }
		    },
	
		    _start: function(e) {
		        var coords = this._eventCoordinates(e);
	
		        if (this._stopChartHandlers(e) || !this._plotArea.backgroundContainsPoint(coords)) {
		            return;
		        }
	
		        if (this.requiresHandlers([ DRAG_START, DRAG, DRAG_END ])) {
		            this._startNavigation(e, coords, DRAG_START);
		        }
	
		        if (this._pannable && this._pannable.start(e)) {
		            this.surface.suspendTracking();
		            this._unsetActivePoint();
		            this._suppressHover = true;
		            this.chartService.panning = true;
		        }
	
		        if (this._zoomSelection) {
		            if (this._zoomSelection.start(e)) {
		                this.trigger(ZOOM_START, { axisRanges: axisRanges(this._plotArea.axes), originalEvent: e });
		            }
		        }
		    },
	
		    _move: function(e) {
		        var ref = this;
		        var state = ref._navState;
		        var pannable = ref._pannable;
	
		        if (this._stopChartHandlers(e)) {
		            return;
		        }
	
		        if (pannable) {
		            var ranges = pannable.move(e);
	
		            if (ranges && !this.trigger(DRAG, { axisRanges: ranges, originalEvent: e })) {
		                pannable.pan();
		            }
		        } else if (state) {
		            var ranges$1 = {};
		            var axes = state.axes;
	
		            for (var i = 0; i < axes.length; i++) {
		                var currentAxis = axes[i];
		                var axisName = currentAxis.options.name;
		                if (axisName) {
		                    var axis = currentAxis.options.vertical ? e.y : e.x;
		                    var delta = axis.startLocation - axis.location;
	
		                    if (delta !== 0) {
		                        ranges$1[currentAxis.options.name] = currentAxis.translateRange(delta);
		                    }
		                }
		            }
	
		            state.axisRanges = ranges$1;
		            this.trigger(DRAG, {
		                axisRanges: ranges$1,
		                originalEvent: e
		            });
		        }
	
		        if (this._zoomSelection) {
		            this._zoomSelection.move(e);
		        }
		    },
	
		    _end: function(e) {
		        if (this._stopChartHandlers(e)) {
		            return;
		        }
	
		        var pannable = this._pannable;
		        if (pannable && pannable.end(e)) {
		            this.surface.resumeTracking();
		            this.trigger(DRAG_END, {
		                axisRanges: axisRanges(this._plotArea.axes),
		                originalEvent: e
		            });
		            this._suppressHover = false;
		            this.chartService.panning = false;
		        } else {
		            this._endNavigation(e, DRAG_END);
		        }
	
		        if (this._zoomSelection) {
		            var ranges = this._zoomSelection.end(e);
		            if (ranges && !this.trigger(ZOOM, { axisRanges: ranges, originalEvent: e })) {
		                this._zoomSelection.zoom();
		                this.trigger(ZOOM_END, { axisRanges: ranges, originalEvent: e });
		            }
		        }
		    },
	
		    _stopChartHandlers: function(e) {
		        var selections = this._selections || [];
		        if (!selections.length) {
		            return false;
		        }
	
		        var coords = this._eventCoordinates(e);
		        var pane = this._plotArea.paneByPoint(coords);
		        if (pane) {
		            for (var idx = 0; idx < selections.length; idx++) {
		                if (selections[idx].onPane(pane)) {
		                    return true;
		                }
		            }
		        }
		    },
	
		    _mousewheel: function(e) {
		        var this$1 = this;
	
		        var delta = dataviz.mousewheelDelta(e);
		        var mousewheelZoom = this._mousewheelZoom;
		        var coords = this._eventCoordinates(e);
	
		        if (this._stopChartHandlers(e) || !this._plotArea.backgroundContainsPoint(coords)) {
		            return;
		        }
	
		        if (mousewheelZoom) {
		            var args = { delta: delta, axisRanges: axisRanges(this._plotArea.axes), originalEvent: e };
		            if (this._zooming || !this.trigger(ZOOM_START, args)) {
		                e.preventDefault();
	
		                if (!this._zooming) {
		                    this._unsetActivePoint();
		                    this.surface.suspendTracking();
		                    this._zooming = true;
		                }
	
		                if (this._mwTimeout) {
		                    clearTimeout(this._mwTimeout);
		                }
	
		                args.axisRanges = mousewheelZoom.updateRanges(delta);
		                if (args.axisRanges && !this.trigger(ZOOM, args)) {
		                    mousewheelZoom.zoom();
		                }
	
		                this._mwTimeout = setTimeout(function () {
		                    this$1.trigger(ZOOM_END, args);
		                    this$1._zooming = false;
		                    if (this$1.surface) {
		                        this$1.surface.resumeTracking();
		                    }
		                }, MOUSEWHEEL_DELAY);
		            }
		        } else {
		            var state = this._navState;
		            if (!state) {
		                var prevented = this._startNavigation(e, coords, ZOOM_START);
		                if (!prevented) {
		                    state = this._navState;
		                }
		            }
	
		            if (state) {
		                var totalDelta = state.totalDelta || delta;
		                state.totalDelta = totalDelta + delta;
	
		                var axes = this._navState.axes;
		                var ranges = {};
	
		                for (var i = 0; i < axes.length; i++) {
		                    var currentAxis = axes[i];
		                    var axisName = currentAxis.options.name;
		                    if (axisName) {
		                        ranges[axisName] = currentAxis.scaleRange(-totalDelta);
		                    }
		                }
	
		                this.trigger(ZOOM, {
		                    delta: delta,
		                    axisRanges: ranges,
		                    originalEvent: e
		                });
	
		                if (this._mwTimeout) {
		                    clearTimeout(this._mwTimeout);
		                }
	
		                this._mwTimeout = setTimeout(function () {
		                    this$1._endNavigation(e, ZOOM_END);
		                }, MOUSEWHEEL_DELAY);
		            }
		        }
		    },
	
		    _startNavigation: function(e, coords, chartEvent) {
		        var plotArea = this._model._plotArea;
		        var pane = plotArea.findPointPane(coords);
		        var axes = plotArea.axes.slice(0);
	
		        if (!pane) {
		            return;
		        }
	
		        var ranges = axisRanges(axes);
	
		        var prevented = this.trigger(chartEvent, {
		            axisRanges: ranges,
		            originalEvent: e
		        });
	
		        if (prevented) {
		            this._cancelDomEvents();
		        } else {
		            this._suppressHover = true;
		            this._unsetActivePoint();
		            this._navState = {
		                axisRanges: ranges,
		                pane: pane,
		                axes: axes
		            };
		        }
		    },
	
		    _endNavigation: function(e, chartEvent) {
		        if (this._navState) {
		            this.trigger(chartEvent, {
		                axisRanges: this._navState.axisRanges,
		                originalEvent: e
		            });
		            this._suppressHover = false;
		            this._navState = null;
		        }
		    },
	
		    _getChartElement: function(e, match) {
		        var element = this.surface.eventTarget(e);
		        if (element) {
		            return this._drawingChartElement(element, e, match);
		        }
		    },
	
		    _drawingChartElement: function(element, e, match) {
		        var current = element;
		        var chartElement;
		        while (current && !chartElement) {
		            chartElement = current.chartElement;
		            current = current.parent;
		        }
	
		        if (chartElement) {
		            if (chartElement.aliasFor) {
		                chartElement = chartElement.aliasFor(e, this._eventCoordinates(e));
		            }
	
		            if (match) {
		                chartElement = chartElement.closest(match);
		                if (chartElement && chartElement.aliasFor) {
		                    chartElement = chartElement.aliasFor();
		                }
		            }
	
		            return chartElement;
		        }
		    },
	
		    _eventCoordinates: function(e) {
		        var coordinates = dataviz.eventCoordinates(e);
		        return this._toModelCoordinates(coordinates.x, coordinates.y);
		    },
	
		    _elementPadding: function() {
		        if (!this._padding) {
		            var ref = elementStyles(this.element, [ "paddingLeft", "paddingTop" ]);
		            var paddingLeft = ref.paddingLeft;
		            var paddingTop = ref.paddingTop;
		            this._padding = {
		                top: paddingTop,
		                left: paddingLeft
		            };
		        }
	
		        return this._padding;
		    },
	
		    _toDocumentCoordinates: function(point) {
		        var padding = this._elementPadding();
		        var offset = dataviz.elementOffset(this.element);
	
		        return {
		            left: round(point.x + padding.left + offset.left),
		            top: round(point.y + padding.top + offset.top)
		        };
		    },
	
		    _toModelCoordinates: function(clientX, clientY) {
		        var element = this.element;
		        var offset = dataviz.elementOffset(element);
		        var padding = this._elementPadding();
	
		        return new Point(
		            clientX - offset.left - padding.left,
		            clientY - offset.top - padding.top
		        );
		    },
	
		    _tap: function(e) {
		        var this$1 = this;
	
		        var drawingElement = this.surface.eventTarget(e);
		        var element = this._drawingChartElement(drawingElement, e);
		        var sharedTooltip = this._sharedTooltip();
	
		        if (!this._startHover(drawingElement, e) && !sharedTooltip) {
		            this._unsetActivePoint();
		        }
	
		        if (sharedTooltip) {
		            this._trackSharedTooltip(this._eventCoordinates(e), e, true);
		        }
	
		        this._propagateClick(element, e);
	
		        //part of fix for hover issue on windows touch
		        this.handlingTap = true;
		        setTimeout(function () {
		            this$1.handlingTap = false;
		        }, 0);
		    },
	
		    _click: function(e) {
		        var element = this._getChartElement(e);
		        this._propagateClick(element, e);
		    },
	
		    _propagateClick: function(element, e) {
		        var this$1 = this;
	
		        var current = element;
		        while (current) {
		            if (current.click) {
		                current.click(this$1, e);
		            }
	
		            current = current.parent;
		        }
		    },
	
		    _startHover: function(element, e) {
		        if (this._suppressHover) {
		            return false;
		        }
	
		        var point = this._drawingChartElement(element, e, function(element) {
		            return (element.hover || element.over) && !(element instanceof PlotAreaBase);
		        });
	
		        var activePoint = this._activePoint;
		        var hoveredPoint = this._hoveredPoint;
	
		        if (hoveredPoint && hoveredPoint !== point) {
		            hoveredPoint.out(this, e);
		            this._hoveredPoint = null;
		        }
	
		        if (point && hoveredPoint !== point && point.over) {
		            this._hoveredPoint = point;
		            point.over(this, e);
		        }
	
		        if (point && activePoint !== point && point.hover) {
		            this._activePoint = point;
	
		            if (!this._sharedTooltip() && !point.hover(this, e)) {
		                var tooltipOptions = deepExtend({}, this.options.tooltip, point.options.tooltip);
		                if (tooltipOptions.visible) {
		                    this._tooltip.show(point);
		                }
	
		                this._highlight.show(point);
		            }
		        }
	
		        return point;
		    },
	
		    _mouseover: function(e) {
		        var point = this._startHover(e.element, e.originalEvent);
	
		        if (point && point.tooltipTracking && !this._mouseMoveTrackHandler && !this._sharedTooltip()) {
		            this._mouseMoveTrackHandler = this._mouseMoveTracking.bind(this);
		            var obj;
		            bindEvents(document, ( obj = {}, obj[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj ));
		        }
		    },
	
		    _mouseMoveTracking: function(e) {
		        var ref = this;
		        var options = ref.options;
		        var tooltip = ref._tooltip;
		        var highlight = ref._highlight;
		        var point = ref._activePoint;
		        var coords = this._eventCoordinates(e);
	
		        if (this._plotArea.box.containsPoint(coords)) {
		            if (point && point.tooltipTracking && point.series && point.parent.getNearestPoint) {
		                var seriesPoint = point.parent.getNearestPoint(coords.x, coords.y, point.seriesIx);
		                if (seriesPoint && seriesPoint !== point) {
		                    this._activePoint = seriesPoint;
	
		                    if (!seriesPoint.hover(this, e)) {
		                        var tooltipOptions = deepExtend({}, options.tooltip, seriesPoint.options.tooltip);
		                        if (tooltipOptions.visible) {
		                            tooltip.show(seriesPoint);
		                        }
	
		                        highlight.show(seriesPoint);
		                    }
		                }
		            }
		        } else {
		            var obj;
		            unbindEvents(document, ( obj = {}, obj[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj ));
		            this._unsetActivePoint();
		            this._mouseMoveTrackHandler = null;
		        }
		    },
	
		    _mousemove: function(e) {
		        var coords = this._eventCoordinates(e);
		        var plotArea = this._plotArea;
	
		        this._trackCrosshairs(coords);
	
		        if (plotArea.hover) {
		            var overPlotArea = plotArea.backgroundContainsPoint(coords);
		            if (overPlotArea) {
		                plotArea.hovered = true;
		                this._plotArea.hover(this, e);
		            } else if (plotArea.hovered && !overPlotArea) {
		                this.trigger(PLOT_AREA_LEAVE);
		                plotArea.hovered = false;
		            }
		        }
	
		        if (this._sharedTooltip()) {
		            this._trackSharedTooltip(coords, e);
		        }
		    },
	
		    _trackCrosshairs: function(coords) {
		        var crosshairs = this._plotArea.crosshairs;
	
		        for (var i = 0; i < crosshairs.length; i++) {
		            var current = crosshairs[i];
	
		            if (current.box.containsPoint(coords)) {
		                current.showAt(coords);
		            } else {
		                current.hide();
		            }
		        }
		    },
	
		    _trackSharedTooltip: function(coords, e, toggle) {
		        if (this._suppressHover) {
		            return;
		        }
	
		        var ref = this;
		        var tooltipOptions = ref.options.tooltip;
		        var plotArea = ref._plotArea;
		        var categoryAxis = ref._plotArea.categoryAxis;
		        var tooltip = ref._tooltip;
		        var highlight = ref._highlight;
	
		        if (plotArea.backgroundContainsPoint(coords)) {
		            var index = categoryAxis.pointCategoryIndex(coords);
		            if (index !== this._tooltipCategoryIx || (!this._sharedHighlight && toggle)) {
		                var points = plotArea.pointsByCategoryIndex(index);
		                var pointArgs = points.map(function(point) {
		                    return point.eventArgs(e);
		                });
		                var hoverArgs = pointArgs[0] || {};
		                hoverArgs.categoryPoints = pointArgs;
	
		                if (points.length > 0 && !this.trigger(SERIES_HOVER, hoverArgs)) {
		                    if (tooltipOptions.visible) {
		                        tooltip.showAt(points, coords);
		                    }
	
		                    highlight.show(points);
	
		                    this._sharedHighlight = true;
		                } else {
		                    tooltip.hide();
		                }
	
		                this._tooltipCategoryIx = index;
		            } else if (toggle && this._sharedHighlight) {
		                highlight.hide();
		                tooltip.hide();
		                this._sharedHighlight = false;
		            }
		        } else if (this._sharedHighlight) {
		            highlight.hide();
		            tooltip.hide();
		            this._tooltipCategoryIx = null;
		            this._sharedHighlight = false;
		        }
		    },
	
		    hideElements: function() {
		        var plotArea = this._plotArea;
		        this._mousemove.cancel();
	
		        plotArea.hideCrosshairs();
	
		        this._unsetActivePoint();
		    },
	
		    _unsetActivePoint: function() {
		        var ref = this;
		        var tooltip = ref._tooltip;
		        var highlight = ref._highlight;
	
		        this._activePoint = null;
		        this._hoveredPoint = null;
	
		        if (tooltip) {
		            tooltip.hide();
		        }
	
		        this._tooltipCategoryIx = null;
		        this._sharedHighlight = false;
	
		        if (highlight) {
		            highlight.hide();
		        }
		    },
	
		    _deferRedraw: function() {
		        this._redraw();
		    },
	
		    _clearRedrawTimeout: function() {
		        if (this._redrawTimeout) {
		            clearInterval(this._redrawTimeout);
		            this._redrawTimeout = null;
		        }
		    },
	
		    bindCategories: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var definitions = [].concat(options.categoryAxis);
	
		        for (var axisIx = 0; axisIx < definitions.length; axisIx++) {
		            var axis = definitions[axisIx];
		            if (axis.autoBind !== false) {
		                this$1.bindCategoryAxisFromSeries(axis, axisIx);
		            }
		        }
		    },
	
		    bindCategoryAxisFromSeries: function(axis, axisIx) {
		        var this$1 = this;
	
		        var series = this.options.series;
		        var seriesLength = series.length;
		        var uniqueCategories = new dataviz.HashMap();//perf improvement in case type category with dates
		        var items = [];
		        var bindable = false;
		        var dateAxis;
	
		        for (var seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
		            var s = series[seriesIx];
		            var onAxis = s.categoryAxis === axis.name || (!s.categoryAxis && axisIx === 0);
		            var data = s.data;
		            var dataLength = data.length;
		            var bind = s.categoryField && onAxis;
		            bindable = bind || bindable;
	
		            if (bind && dataLength > 0) {
		                dateAxis = isDateAxis(axis, getField(s.categoryField, data[0]));
	
		                var getFn = dateAxis ? getDateField : getField;
	
		                for (var dataIx = 0; dataIx < dataLength; dataIx++) {
		                    var dataRow = data[dataIx];
		                    var category = getFn(s.categoryField, dataRow, this$1.chartService.intl);
	
		                    if (dateAxis || !uniqueCategories.get(category)) {
		                        items.push([ category, dataRow ]);
	
		                        if (!dateAxis) {
		                            uniqueCategories.set(category, true);
		                        }
		                    }
		                }
		            }
		        }
	
		        if (items.length > 0) {
		            if (dateAxis) {
		                items = uniqueDates(items, function(a, b) {
		                    return dataviz.dateComparer(a[0], b[0]);
		                });
		            }
	
		            var result = transpose(items);
		            axis.categories = result[0];
		        } else if (bindable) {
		            axis.categories = [];
		        }
		    },
	
		    _isBindable: function(series) {
		        var valueFields = SeriesBinder.current.valueFields(series);
		        var result = true;
	
		        for (var i = 0; i < valueFields.length; i++) {
		            var field = valueFields[i];
		            if (field === VALUE) {
		                field = "field";
		            } else {
		                field = field + "Field";
		            }
	
		            if (!defined(series[field])) {
		                result = false;
		                break;
		            }
		        }
	
		        return result;
		    },
	
		    _noTransitionsRedraw: function() {
		        var options = this.options;
		        var transitionsState;
	
		        if (options.transitions) {
		            options.transitions = false;
		            transitionsState = true;
		        }
	
		        this._redraw();
	
		        if (transitionsState) {
		            options.transitions = true;
		        }
		    },
	
		    _legendItemHover: function(seriesIndex, pointIndex) {
		        var ref = this;
		        var plotArea = ref._plotArea;
		        var highlight = ref._highlight;
		        var currentSeries = (plotArea.srcSeries || plotArea.series)[seriesIndex];
		        var items;
	
		        if (inArray(currentSeries.type, [ PIE, DONUT, FUNNEL ])) {
		            items = plotArea.findPoint(function(point) {
		                return point.series.index === seriesIndex && point.index === pointIndex;
		            });
		        } else {
		            items = plotArea.pointsBySeriesIndex(seriesIndex);
		        }
	
		        highlight.show(items);
		    },
	
		    _shouldAttachMouseMove: function() {
		        return this._plotArea.crosshairs.length || (this._tooltip && this._sharedTooltip()) || this.requiresHandlers([ PLOT_AREA_HOVER, PLOT_AREA_LEAVE ]);
		    },
	
		    updateMouseMoveHandler: function() {
		        var obj;
		        unbindEvents(this.element, ( obj = {}, obj[ MOUSEMOVE ] = this._mousemove, obj ));
	
		        if (this._shouldAttachMouseMove()) {
		            var obj$1;
		            bindEvents(this.element, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mousemove, obj$1 ));
		        }
		    },
	
		    applyOptions: function(options, theme) {
		        clearMissingValues(this._originalOptions, options);
		        this._originalOptions = deepExtend(this._originalOptions, options);
		        this.options = deepExtend({}, this._originalOptions);
	
		        if (theme) {
		            this._theme = theme;
		            this.chartService.theme = theme;
		        }
		        this._initTheme(this.options, this._theme);
		    },
	
		    setOptions: function(options, theme) {
		        this.applyOptions(options, theme);
		        this.bindCategories();
		        this.redraw();
		        this.updateMouseMoveHandler();
	
		        this._toggleDomDrag();
		        this._toggleDomZoom();
		    },
	
		    setDirection: function(rtl) {
		        this.chartService.rtl = Boolean(rtl);
		        if (this.surface && this.surface.type === 'svg') {
		            this._destroySurface();
		        }
		    },
	
		    setIntlService: function(intl) {
		        this.chartService.intl = intl;
		    },
	
		    noTransitionsRedraw: function() {
		        this._noTransitionsRedraw();
		    },
	
		    destroy: function() {
		        this._destroyed = true;
	
		        var obj;
		        unbindEvents(this.element, ( obj = {}, obj[ CONTEXTMENU ] = this._clickHandler, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj[ MOUSEMOVE ] = this._mousemove, obj[ MOUSELEAVE ] = this._mouseleaveHandler, obj ));
	
		        if (this.domEvents) {
		            this.domEvents.destroy();
		            delete this.domEvents;
		        }
	
		        if (this._mouseMoveTrackHandler) {
		            var obj$1;
		            unbindEvents(document, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj$1 ));
		        }
	
		        this._destroyView();
	
		        this._destroySurface();
	
		        this._clearRedrawTimeout();
		    },
	
		    _destroySurface: function() {
		        var surface = this.surface;
		        if (surface) {
		            surface.unbind("mouseenter", this._surfaceMouseenterHandler);
		            surface.unbind("mouseleave", this._surfaceMouseleaveHandler);
		            surface.destroy();
	
		            this.surface = null;
		        }
		    },
	
		    _destroyView: function() {
		        var ref = this;
		        var model = ref._model;
		        var selections = ref._selections;
	
		        if (model) {
		            model.destroy();
		            this._model = null;
		        }
	
		        if (selections) {
		            while (selections.length > 0) {
		                selections.shift().destroy();
		            }
		        }
	
		        this._unsetActivePoint();
	
		        if (this._tooltip) {
		            this._tooltip.destroy();
		        }
	
		        if (this._highlight) {
		            this._highlight.destroy();
		        }
	
		        if (this._zoomSelection) {
		            this._zoomSelection.destroy();
		            delete this._zoomSelection;
		        }
	
		        if (this._pannable) {
		            this._pannable.destroy();
		            delete this._pannable;
		        }
	
		        if (this._mousewheelZoom) {
		            this._mousewheelZoom.destroy();
		            delete this._mousewheelZoom;
		        }
		    }
		});
	
		function resolveAxisAliases(options) {
		    var aliases = AXIS_NAMES;
	
		    for (var idx = 0; idx < aliases.length; idx++) {
		        var alias = aliases[idx] + "Axes";
		        if (options[alias]) {
		            options[aliases[idx] + "Axis"] = options[alias];
		            delete options[alias];
		        }
		    }
		}
	
		function pointByCategoryName(points, name) {
		    if (points) {
		        for (var idx = 0; idx < points.length; idx++) {
		            if (points[idx].category === name) {
		                return [ points[idx] ];
		            }
		        }
		    }
		}
	
		function applyAxisDefaults(options, themeOptions) {
		    var themeAxisDefaults = ((themeOptions || {}).axisDefaults) || {};
		    var axisName, axisDefaults, axes;
	
		    function mapAxisOptions(axisOptions) {
		        var axisColor = (axisOptions || {}).color || axisDefaults.color;
		        var result = deepExtend({},
		            themeAxisDefaults,
		            themeAxisDefaults[axisName],
		            axisDefaults,
		            axisDefaults[axisName], {
		                line: { color: axisColor },
		                labels: { color: axisColor },
		                title: { color: axisColor }
		            },
		            axisOptions
		        );
	
		        delete result[axisName];
	
		        return result;
		    }
	
		    for (var idx = 0; idx < AXIS_NAMES.length; idx++) {
		        axisName = AXIS_NAMES[idx] + "Axis";
		        axisDefaults = options.axisDefaults || {};
		        axes = [].concat(options[axisName]);
	
		        axes = axes.map(mapAxisOptions);
	
		        options[axisName] = axes.length > 1 ? axes : axes[0];
		    }
		}
	
		function applySeriesDefaults(options, themeOptions) {
		    var series = options.series;
		    var seriesLength = series.length;
		    var seriesDefaults = options.seriesDefaults;
		    var commonDefaults = deepExtend({}, options.seriesDefaults);
		    var themeSeriesDefaults = themeOptions ? deepExtend({}, themeOptions.seriesDefaults) : {};
		    var commonThemeDefaults = deepExtend({}, themeSeriesDefaults);
	
		    cleanupNestedSeriesDefaults(commonDefaults);
		    cleanupNestedSeriesDefaults(commonThemeDefaults);
	
		    for (var i = 0; i < seriesLength; i++) {
		        var seriesType = series[i].type || options.seriesDefaults.type;
	
		        var baseOptions = deepExtend(
		            { data: [] },
		            commonThemeDefaults,
		            themeSeriesDefaults[seriesType],
		            { tooltip: options.tooltip },
		            commonDefaults,
		            seriesDefaults[seriesType]
		        );
	
		        series[i]._defaults = baseOptions;
		        series[i] = deepExtend({}, baseOptions, series[i]);
		    }
		}
	
		function cleanupNestedSeriesDefaults(seriesDefaults) {
		    delete seriesDefaults.bar;
		    delete seriesDefaults.column;
		    delete seriesDefaults.rangeColumn;
		    delete seriesDefaults.line;
		    delete seriesDefaults.verticalLine;
		    delete seriesDefaults.pie;
		    delete seriesDefaults.donut;
		    delete seriesDefaults.area;
		    delete seriesDefaults.verticalArea;
		    delete seriesDefaults.scatter;
		    delete seriesDefaults.scatterLine;
		    delete seriesDefaults.bubble;
		    delete seriesDefaults.candlestick;
		    delete seriesDefaults.ohlc;
		    delete seriesDefaults.boxPlot;
		    delete seriesDefaults.bullet;
		    delete seriesDefaults.verticalBullet;
		    delete seriesDefaults.polarArea;
		    delete seriesDefaults.polarLine;
		    delete seriesDefaults.radarArea;
		    delete seriesDefaults.radarLine;
		    delete seriesDefaults.waterfall;
		}
	
		function axisRanges(axes) {
		    var ranges = {};
	
		    for (var i = 0; i < axes.length; i++) {
		        var axis = axes[i];
		        var axisName = axis.options.name;
		        if (axisName) {
		            ranges[axisName] = axis.range();
		        }
		    }
	
		    return ranges;
		}
	
		function sortDates(dates, comparer) {
		    if (comparer === void 0) { comparer = dataviz.dateComparer; }
	
		    for (var i = 1, length = dates.length; i < length; i++) {
		        if (comparer(dates[i], dates[i - 1]) < 0) {
		            dates.sort(comparer);
		            break;
		        }
		    }
	
		    return dates;
		}
	
		function uniqueDates(srcDates, comparer) {
		    if (comparer === void 0) { comparer = dataviz.dateComparer; }
	
		    var dates = sortDates(srcDates, comparer);
		    var length = dates.length;
		    var result = length > 0 ? [ dates[0] ] : [];
	
		    for (var i = 1; i < length; i++) {
		        if (comparer(dates[i], last(result)) !== 0) {
		            result.push(dates[i]);
		        }
		    }
	
		    return result;
		}
	
		function transpose(rows) {
		    var rowCount = rows.length;
		    var result = [];
	
		    for (var rowIx = 0; rowIx < rowCount; rowIx++) {
		        var row = rows[rowIx];
		        var colCount = row.length;
	
		        for (var colIx = 0; colIx < colCount; colIx++) {
		            result[colIx] = result[colIx] || [];
		            result[colIx].push(row[colIx]);
		        }
		    }
	
		    return result;
		}
	
		var DATA_FIELDS = [ 'data', 'categories' ];
	
		function clearMissingValues(originalOptions, options) {
		    for (var field in options) {
		        if (!inArray(field, DATA_FIELDS) && options.hasOwnProperty(field)) {
		            var fieldValue = options[field];
		            var originalValue = originalOptions[field];
		            if (defined(originalValue)) {
		                var nullValue = fieldValue === null;
		                if ((nullValue || !defined(fieldValue))) {
		                    delete originalOptions[field];
		                    if (nullValue) {
		                        delete options[field];
		                    }
		                } else if (originalValue && isObject(fieldValue)) {
		                    if (isObject(originalValue)) {
		                        clearMissingValues(originalValue, fieldValue);
		                    }
		                }
		            }
		        }
		    }
		}
	
		function triggerPaneRender(panes) {
		    for (var idx = 0; idx < panes.length; idx++) {
		        panes[idx].notifyRender();
		    }
		}
	
		setDefaultOptions(Chart, {
		    renderAs: "",
		    chartArea: {},
		    legend: {
		        visible: true,
		        labels: {}
		    },
		    categoryAxis: {},
		    seriesDefaults: {
		        type: COLUMN,
		        data: [],
		        highlight: {
		            visible: true
		        },
		        labels: {},
		        negativeValues: {
		            visible: false
		        }
		    },
		    series: [],
		    seriesColors: null,
		    tooltip: {
		        visible: false
		    },
		    transitions: true,
		    valueAxis: {},
		    plotArea: {},
		    title: {},
		    xAxis: {},
		    yAxis: {},
		    panes: [ {} ],
		    pannable: false,
		    zoomable: false
		});
	
		kendo.deepExtend(kendo.dataviz, {
		    constants: constants,
		    Aggregates: Aggregates,
		    AreaChart: AreaChart,
		    AreaSegment: AreaSegment,
		    AxisGroupRangeTracker: AxisGroupRangeTracker,
		    Bar: Bar,
		    BarChart: BarChart,
		    BarLabel: BarLabel,
		    BoxPlotChart: BoxPlotChart,
		    BoxPlot: BoxPlot,
		    BubbleChart: BubbleChart,
		    Bullet: Bullet,
		    BulletChart: BulletChart,
		    CandlestickChart: CandlestickChart,
		    Candlestick: Candlestick,
		    CategoricalChart: CategoricalChart,
		    CategoricalErrorBar: CategoricalErrorBar,
		    CategoricalPlotArea: CategoricalPlotArea,
		    Chart: Chart,
		    ChartContainer: ChartContainer,
		    ClipAnimation: ClipAnimation,
		    ClusterLayout: ClusterLayout,
		    Crosshair: Crosshair,
		    CrosshairTooltip: CrosshairTooltip,
		    DefaultAggregates: DefaultAggregates,
		    DonutChart: DonutChart,
		    DonutPlotArea: DonutPlotArea,
		    DonutSegment: DonutSegment,
		    ErrorBarBase: ErrorBarBase,
		    ErrorRangeCalculator: ErrorRangeCalculator,
		    Highlight: Highlight,
		    SharedTooltip: SharedTooltip,
		    Legend: Legend,
		    LegendItem: LegendItem,
		    LegendLayout: LegendLayout,
		    LineChart: LineChart,
		    LinePoint: LinePoint,
		    LineSegment: LineSegment,
		    Pane: Pane,
		    PieAnimation: PieAnimation,
		    PieChart: PieChart,
		    PieChartMixin: PieChartMixin,
		    PiePlotArea: PiePlotArea,
		    PieSegment: PieSegment,
		    PlotAreaBase: PlotAreaBase,
		    PlotAreaEventsMixin: PlotAreaEventsMixin,
		    PlotAreaFactory: PlotAreaFactory,
		    PointEventsMixin: PointEventsMixin,
		    RangeBar: RangeBar,
		    RangeBarChart: RangeBarChart,
		    RangeAreaPoint: RangeAreaPoint,
		    RangeAreaChart: RangeAreaChart,
		    ScatterChart: ScatterChart,
		    ScatterErrorBar: ScatterErrorBar,
		    ScatterLineChart: ScatterLineChart,
		    Selection: Selection,
		    SeriesAggregator: SeriesAggregator,
		    SeriesBinder: SeriesBinder,
		    SplineSegment: SplineSegment,
		    SplineAreaSegment: SplineAreaSegment,
		    StackWrap: StackWrap,
		    Tooltip: Tooltip,
		    OHLCChart: OHLCChart,
		    OHLCPoint: OHLCPoint,
		    WaterfallChart: WaterfallChart,
		    WaterfallSegment: WaterfallSegment,
		    XYPlotArea: XYPlotArea,
		    MousewheelZoom: MousewheelZoom,
		    ZoomSelection: ZoomSelection,
		    Pannable: Pannable,
		    ChartAxis: ChartAxis,
		    ChartPane: ChartPane,
		    ChartPlotArea: ChartPlotArea,
		    findAxisByName: findAxisByName,
		    anyHasZIndex: anyHasZIndex,
		    appendIfNotNull: appendIfNotNull,
		    areNumbers: areNumbers,
		    bindSegments: bindSegments,
		    categoriesCount: categoriesCount,
		    countNumbers: countNumbers,
		    equalsIgnoreCase: equalsIgnoreCase,
		    evalOptions: evalOptions,
		    filterSeriesByType: filterSeriesByType,
		    getDateField: getDateField,
		    getField: getField,
		    hasGradientOverlay: hasGradientOverlay,
		    hasValue: hasValue,
		    isDateAxis: isDateAxis,
		    segmentVisible: segmentVisible,
		    singleItemOrArray: singleItemOrArray,
		    createOutOfRangePoints: createOutOfRangePoints
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 862:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 863:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(554);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(854);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 854:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(855),
		        __webpack_require__(856),
		        __webpack_require__(857),
		        __webpack_require__(858),
		        __webpack_require__(859),
		        __webpack_require__(860)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
	
		    var NS = ".kendoChart";
		    var kendo = window.kendo;
		    var Class = kendo.Class;
		    var outerWidth = kendo._outerWidth;
		    var outerHeight = kendo._outerHeight;
		    var dataviz = kendo.dataviz;
		    var constants = dataviz.constants;
		    var KendoChart = dataviz.Chart;
		    var SeriesBinder = dataviz.SeriesBinder;
		    var Widget = kendo.ui.Widget;
		    var DataSource = kendo.data.DataSource;
		    var deepExtend = kendo.deepExtend;
		    var defined = dataviz.defined;
		    var getField = dataviz.getField;
		    var InstanceObserver = dataviz.InstanceObserver;
		    var inArray = dataviz.inArray;
		    var services = dataviz.services;
		    var proxy = $.proxy;
		    var isArray = $.isArray;
		    var extend = $.extend;
		    var template = kendo.template;
	
		    var MOUSELEAVE_NS = "mouseleave" + NS;
		    var AXIS_LABEL_CLICK = constants.AXIS_LABEL_CLICK;
		    var LEGEND_ITEM_CLICK = constants.LEGEND_ITEM_CLICK;
		    var LEGEND_ITEM_HOVER = constants.LEGEND_ITEM_HOVER;
		    var LEGEND_ITEM_LEAVE = constants.LEGEND_ITEM_LEAVE;
		    var SERIES_CLICK = constants.SERIES_CLICK;
		    var SERIES_HOVER = constants.SERIES_HOVER;
		    var SERIES_OVER = constants.SERIES_OVER;
		    var SERIES_LEAVE = constants.SERIES_LEAVE;
		    var PANE_RENDER = constants.PANE_RENDER;
		    var PLOT_AREA_CLICK = constants.PLOT_AREA_CLICK;
		    var PLOT_AREA_HOVER = constants.PLOT_AREA_HOVER;
		    var PLOT_AREA_LEAVE = constants.PLOT_AREA_LEAVE;
		    var DRAG = constants.DRAG;
		    var DRAG_END = constants.DRAG_END;
		    var DRAG_START = constants.DRAG_START;
		    var ZOOM_START = constants.ZOOM_START;
		    var ZOOM = constants.ZOOM;
		    var ZOOM_END = constants.ZOOM_END;
		    var SELECT_START = constants.SELECT_START;
		    var SELECT = constants.SELECT;
		    var SELECT_END = constants.SELECT_END;
		    var RENDER = constants.RENDER;
		    var NOTE_CLICK = constants.NOTE_CLICK;
		    var NOTE_HOVER = constants.NOTE_HOVER;
		    var NOTE_LEAVE = constants.NOTE_LEAVE;
	
		    var CHANGE = "change";
		    var DATABOUND = "dataBound";
		    var LEAVE = "leave";
	
		    var VALUE = constants.VALUE;
		    var PIE = constants.PIE;
		    var DONUT = constants.DONUT;
		    var FUNNEL = constants.FUNNEL;
	
		    var Observable = kendo.Observable;
		    var TOOLTIP_ANIMATION_DURATION = 150;
		    var TOOLTIP_SHOW_DELAY = 100;
		    var TOOLTIP_INVERSE = "k-chart-tooltip-inverse";
		    var SHARED_TOOLTIP_CLASS = "k-chart-shared-tooltip";
		    var RTL = "rtl";
	
		    services.DomEventsBuilder.register({
		        create: function(element, events) {
		             return new kendo.UserEvents(element, deepExtend({
		                 global: true,
		                 multiTouch: true,
		                 fastTap: true
		             }, events));
		        }
		    });
	
		    var ChartInstanceObserver = InstanceObserver.extend({
		        handlerMap: {
		            showTooltip: '_showTooltip',
		            hideTooltip: '_hideTooltip',
		            legendItemClick: '_onLegendItemClick',
		            render: '_onRender',
		            init: '_onInit'
		        }
		    });
	
		    var Chart = Widget.extend({
		        init: function(element, userOptions) {
		            var dataSource;
	
		            kendo.destroy(element);
	
		            Widget.fn.init.call(this, element);
	
		            if (userOptions) {
		                dataSource = userOptions.dataSource;
		                delete userOptions.dataSource;
		            }
	
		            this.options =  deepExtend({}, this.options, userOptions);
	
		            this.wrapper = this.element;
		            this._attachEvents();
	
		            if (userOptions) {
		                userOptions.dataSource = dataSource;
		            }
	
		            this._seriesVisibility = new SeriesVisibilityState();
	
		            this.bind(this.events, this.options);
		            this._initDataSource(userOptions);
	
		            kendo.notify(this, dataviz.ui);
		        },
	
		        events:[
		            DATABOUND,
		            SERIES_CLICK,
		            SERIES_HOVER,
		            SERIES_OVER,
		            SERIES_LEAVE,
		            AXIS_LABEL_CLICK,
		            LEGEND_ITEM_CLICK,
		            LEGEND_ITEM_HOVER,
		            LEGEND_ITEM_LEAVE,
		            PANE_RENDER,
		            PLOT_AREA_CLICK,
		            PLOT_AREA_HOVER,
		            PLOT_AREA_LEAVE,
		            DRAG_START,
		            DRAG,
		            DRAG_END,
		            ZOOM_START,
		            ZOOM,
		            ZOOM_END,
		            SELECT_START,
		            SELECT,
		            SELECT_END,
		            NOTE_CLICK,
		            NOTE_HOVER,
		            NOTE_LEAVE,
		            RENDER
		        ],
	
		        options: {
		            name: "Chart",
		            renderAs: "",
		            theme: "default",
		            axisDefaults: {},
		            chartArea: {},
		            legend: {},
		            categoryAxis: {},
		            autoBind: true,
		            seriesDefaults: {},
		            series: [],
		            seriesColors: null,
		            tooltip: {},
		            transitions: true,
		            valueAxis: {},
		            plotArea: {},
		            title: {},
		            xAxis: {},
		            yAxis: {},
		            panes: [{}],
		            pannable: false,
		            zoomable: false
		        },
	
		        items: function() {
		            return $();
		        },
	
		        refresh: function() {
		            var chart = this;
		            var instance = chart._instance;
		            instance.applyDefaults(chart.options);
		            instance.applySeriesColors();
	
		            chart._bindSeries();
		            chart._bindCategories();
	
		            chart.trigger(DATABOUND);
		            chart._redraw();
		        },
	
		        getSize: function() {
		            return kendo.dimensions(this.element);
		        },
	
		        redraw: function(paneName) {
		            this._size = null;
		            this._instance.redraw(paneName);
		        },
	
		        setOptions: function(options) {
		            var chart = this,
		                dataSource = options.dataSource;
	
		            delete options.dataSource;
	
		            Widget.fn._setEvents.call(chart, options);
	
		            this._instance.applyOptions(options, this._getThemeOptions(options));
		            this.options = this._instance.options;
		            this._tooltip.setOptions(this.options.tooltip);
		            this._seriesVisibility.setOptions(this.options);
		            this._sourceSeries = null;
	
		            if (dataSource) {
		                chart.setDataSource(dataSource);
		            }
	
		            if (chart._hasDataSource) {
		                chart._onDataChanged();
		            } else {
		                chart._bindCategories();
		                chart.redraw();
		            }
	
		            chart._instance.updateMouseMoveHandler();
	
		        },
	
		        setDataSource: function(dataSource) {
		            var chart = this;
	
		            chart.dataSource.unbind(CHANGE, chart._dataChangeHandler);
		            chart.dataSource = dataSource = DataSource.create(dataSource);
		            chart._hasDataSource = true;
		            chart._hasData = false;
	
		            dataSource.bind(CHANGE, chart._dataChangeHandler);
	
		            if (chart.options.autoBind) {
		                dataSource.fetch();
		            }
		        },
	
		        destroy: function() {
		            var chart = this,
		                dataSource = chart.dataSource;
	
		            chart.element.off(NS);
	
		            if (dataSource) {
		                dataSource.unbind(CHANGE, chart._dataChangeHandler);
		            }
	
		            if (chart._instance) {
		                chart._instance.destroy();
		                delete this._instance;
		            }
	
		            if (this._tooltip) {
		                this._tooltip.destroy();
		                delete this._tooltip;
		            }
	
		            this._destroyCrosshairTooltips();
	
		            Widget.fn.destroy.call(chart);
		        },
	
		        findPaneByName: function(name) {
		            var panes = this._plotArea.panes;
	
		            for (var idx = 0; idx < panes.length; idx++) {
		                if (panes[idx].options.name === name) {
		                    return new ChartPane(this, panes[idx]);
		                }
		            }
		        },
	
		        findPaneByIndex: function(idx) {
		            var panes = this._plotArea.panes;
		            if (panes[idx]) {
		                return new ChartPane(this, panes[idx]);
		            }
		        },
	
		        findSeries: function(callback) {
		            var plotArea = this._plotArea;
		            var series = plotArea.srcSeries || plotArea.series;
		            for (var idx = 0; idx < series.length; idx++) {
		                if (callback(series[idx])) {
		                    return new ChartSeries(this, series[idx]);
		                }
		            }
		        },
	
		        findSeriesByName: function(name) {
		            return this._createSeries({ name: name });
		        },
	
		        findSeriesByIndex: function(index) {
		            return this._createSeries({ index: index });
		        },
	
		        exportVisual: function(options) {
		            var instance = this._instance;
		            if (!instance) {
		                return;
		            }
	
		            var visual;
	
		            //TO DO: support for setting any options. already available in kendo-charts
		            if (options && (options.width || options.height)) {
		                var chartArea = instance.options.chartArea;
		                var originalChartArea = instance._originalOptions.chartArea;
	
		                deepExtend(chartArea, options);
	
		                var model = instance._getModel();
	
		                chartArea.width = originalChartArea.width;
		                chartArea.height = originalChartArea.height;
	
		                model.renderVisual();
	
		                triggerPaneRender(model._plotArea.panes);
	
		                visual = model.visual;
		            } else {
		                visual = instance.exportVisual();
		            }
	
		            return visual;
		        },
	
		        _createSeries: function(options) {
		            var seriesOptions = this._seriesOptions(options);
		            if (seriesOptions) {
		                return new ChartSeries(this, seriesOptions);
		            }
		        },
	
		        _seriesOptions: function(options) {
		            var plotArea = this._plotArea;
		            var series = plotArea.srcSeries || plotArea.series;
		            var seriesOptions;
	
		            if (defined(options.index)) {
		                seriesOptions = series[options.index];
		            } else if (defined(options.name)) {
		                for (var idx = 0; idx < series.length; idx++) {
		                    if (series[idx].name === options.name) {
		                        seriesOptions = series[idx];
		                        break;
		                    }
		                }
		            }
	
		            return seriesOptions;
		        },
	
		        _attachEvents: function() {
		             this.element.on(MOUSELEAVE_NS, proxy(this._mouseleave, this));
		        },
	
		        _mouseleave: function(e) {
		            var instance = this._instance;
		            var tooltip = this._tooltip;
		            var target = e.relatedTarget;
	
		            if (!(target && $(target).closest(tooltip.element).length) && instance && !instance.handlingTap) {
		                instance.hideElements();
		            }
		        },
	
		        _getThemeOptions: function(userOptions) {
		            var themeName = (userOptions || {}).theme;
		            if (themeName === "sass" || themeName === "default-v2" || themeName === "bootstrap-v4") {
		                return dataviz.autoTheme().chart;
		            }
	
		            if (defined(themeName)) {
		                var themes = dataviz.ui.themes || {};
		                var theme = themes[themeName] || themes[themeName.toLowerCase()] || {};
		                return theme.chart || {};
		            }
		        },
	
		        _initChart: function() {
		            this._createChart(this.options, this._getThemeOptions(this.options));
		            this.options = this._instance.options;
		            this._seriesVisibility.setOptions(this.options);
		        },
	
		        _createChart: function(options, themeOptions) {
		            this._instance = new KendoChart(this.element[0], options, themeOptions, {
		                observer: new ChartInstanceObserver(this),
		                sender: this,
		                rtl: this._isRtl()
		            });
		        },
	
		        _onInit: function(e) {
		            this._instance = e.sender;
		        },
	
		        _initDataSource: function(userOptions) {
		            var chart = this,
		                dataSource = (userOptions || {}).dataSource;
	
		            chart._dataChangeHandler = proxy(chart._onDataChanged, chart);
	
		            chart.dataSource = DataSource
		                .create(dataSource)
		                .bind("change", chart._dataChangeHandler);
	
		            chart._bindCategories();
	
		            if (dataSource) {
		                chart._hasDataSource = true;
		            }
	
		            this._initChart();
		            this._initTooltip();
	
		            if (dataSource) {
		                if (chart.options.autoBind) {
		                    chart.dataSource.fetch();
		                }
		            }
		        },
	
		        _destroyCrosshairTooltips: function() {
		            var tooltips = this._crosshairTooltips;
		            if (tooltips) {
		                for (var key in tooltips) {
		                    tooltips[key].destroy();
		                }
		            }
		            this._crosshairTooltips = {};
		        },
	
		        _getCrosshairTooltip: function(name, index) {
		            var tooltips = this._crosshairTooltips = this._crosshairTooltips || {};
		            var key = name + index;
		            var tooltip = tooltips[key];
		            if (!tooltip) {
		                tooltip = tooltips[key] = new CrosshairTooltip(this.element);
		            }
		            return tooltip;
		        },
	
		        _showTooltip: function(e) {
		            if (e.crosshair) {
		                var tooltip = this._getCrosshairTooltip(e.axisName, e.axisIndex);
		                tooltip.show(e);
		            } else if (this._tooltip) {
		                this._tooltip.show(e);
		            }
		        },
	
		        _hideTooltip: function(e) {
		            if (e.crosshair) {
		                 var tooltip = this._getCrosshairTooltip(e.axisName, e.axisIndex);
		                 tooltip.hide();
		            } else if (this._tooltip) {
		                this._tooltip.hide(e);
		            }
		        },
	
		        _onRender: function(e) {
		            this._destroyCrosshairTooltips();
		            this._copyMembers(e.sender);
		            if (!this._hasDataSource || this._hasData || !this.options.autoBind) {
		                this.trigger(RENDER);
		            }
		        },
	
		        _copyMembers: function(instance) {
		            this.options = instance.options;
		            this._originalOptions = instance._originalOptions;
		            this.surface = instance.surface;
		            this._plotArea = instance._plotArea;
		            this._model = instance._model;
		            this._highlight = instance._highlight;
		            this._selections = instance._selections;
		            this._pannable = instance._pannable;
		            this._zoomSelection = instance._zoomSelection;
		            this._mousewheelZoom = instance._mousewheelZoom;
		        },
	
		        requiresHandlers: function(names) {
		           var events = this._events;
		           for (var idx = 0; idx < names.length; idx++) {
		               if (defined(events[names[idx]])) {
		                   return true;
		               }
		           }
		        },
	
		        _initTooltip: function() {
		            this._tooltip = this._createTooltip();
	
		            this._tooltip.bind(LEAVE, proxy(this._tooltipleave, this));
		        },
	
		        _onLegendItemClick: function(e) {
		            if (!this.trigger(LEGEND_ITEM_CLICK, e)) {
		                this._legendItemClick(e.seriesIndex, e.pointIndex);
		            }
		        },
	
		        _legendItemClick: function(seriesIndex, pointIndex) {
		            var chart = this._instance,
		                plotArea = chart._plotArea,
		                currentSeries = (plotArea.srcSeries || plotArea.series)[seriesIndex];
	
		            if ($.inArray(currentSeries.type, [PIE, DONUT, FUNNEL]) >= 0) {
		                var point = currentSeries.data[pointIndex];
		                if (point && defined(point.visible)) {
		                    point.visible = !point.visible;
		                } else {
		                    var pointVisibility = currentSeries.pointVisibility = currentSeries.pointVisibility || {};
		                    var visible = pointVisibility[pointIndex];
		                    pointVisibility[pointIndex] = defined(visible) ? !visible : false;
		                }
		            } else {
		                currentSeries.visible = !currentSeries.visible;
		                this._seriesVisibility.save(currentSeries);
		            }
	
		            chart._noTransitionsRedraw();
		        },
	
		        _createTooltip: function() {
		            return new Tooltip(this.element, extend({}, this.options.tooltip, {
		                rtl: this._isRtl()
		            }));
		        },
	
		        _tooltipleave: function() {
		            if (this._instance) {
		                this._instance.hideElements();
		            }
		        },
	
		        _bindData: function(e) {
		            var chart = this,
		                options = chart.options,
		                series = chart._sourceSeries || options.series,
		                seriesIx,
		                seriesLength = series.length,
		                data = chart.dataSource.view(),
		                grouped = (chart.dataSource.group() || []).length > 0,
		                processedSeries = [],
		                seriesVisibility = this._seriesVisibility,
		                currentSeries,
		                groupedSeries;
	
		            seriesVisibility.read();
	
		            for (seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
		                currentSeries = series[seriesIx];
	
		                if (chart._isBindable(currentSeries) && grouped) {
		                    groupedSeries = groupSeries(currentSeries, data);
		                    processedSeries = processedSeries.concat(groupedSeries);
	
		                    seriesVisibility.applyByGroup(groupedSeries, e);
		                } else {
		                    currentSeries = extend({}, currentSeries);
		                    processedSeries.push(currentSeries);
	
		                    seriesVisibility.applyByIndex(currentSeries, e);
		                }
		            }
	
		            chart._sourceSeries = series;
		            options.series = processedSeries;
		            this._instance.applySeriesColors();
	
		            chart._bindSeries();
		            chart._bindCategories();
	
		            this._hasData = true;
		        },
	
		        _onDataChanged: function(e) {
		            this._bindData(e);
	
		            this.trigger(DATABOUND);
		            this._redraw();
		        },
	
		        _bindSeries: function() {
		            var chart = this,
		                data = chart.dataSource.view(),
		                series = chart.options.series,
		                seriesIx,
		                seriesLength = series.length,
		                currentSeries,
		                groupIx,
		                seriesData;
	
		            for (seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
		                currentSeries = series[seriesIx];
	
		                if (chart._isBindable(currentSeries)) {
		                    groupIx = currentSeries._groupIx;
		                    seriesData = defined(groupIx) ? (data[groupIx] || {}).items : data;
	
		                    if (currentSeries.autoBind !== false) {
		                        currentSeries.data = seriesData;
		                    }
		                }
		            }
		        },
	
		        _bindCategories: function() {
		            var chart = this,
		                data = chart.dataSource.view() || [],
		                grouped = (chart.dataSource.group() || []).length > 0,
		                categoriesData = data,
		                options = chart.options,
		                definitions = [].concat(options.categoryAxis),
		                axisIx,
		                axis;
	
		            if (grouped) {
		                if (data.length) {
		                    categoriesData = data[0].items;
		                }
		            }
	
		            for (axisIx = 0; axisIx < definitions.length; axisIx++) {
		                axis = definitions[axisIx];
		                if (axis.autoBind !== false) {
		                    chart._bindCategoryAxis(axis, categoriesData, axisIx);
		                }
		            }
		        },
	
		        _bindCategoryAxis: function(axis, data, axisIx) {
		            var count = (data || []).length,
		                categoryIx,
		                category,
		                row;
	
		            if (axis.field) {
		                axis.categories = [];
		                for (categoryIx = 0; categoryIx < count; categoryIx++) {
		                    row = data[categoryIx];
	
		                    category = getField(axis.field, row);
		                    if (categoryIx === 0) {
		                        axis.categories = [category];
		                        axis.dataItems = [row];
		                    } else {
		                        axis.categories.push(category);
		                        axis.dataItems.push(row);
		                    }
		                }
		            } else if (this._instance) {
		                this._instance.bindCategoryAxisFromSeries(axis, axisIx);
		            }
		        },
	
		        _isBindable: function(series) {
		            var valueFields = SeriesBinder.current.valueFields(series),
		                result = true,
		                field, i;
	
		            for (i = 0; i < valueFields.length; i++) {
		                field = valueFields[i];
		                if (field === VALUE) {
		                    field = "field";
		                } else {
		                    field = field + "Field";
		                }
	
		                if (!defined(series[field])) {
		                    result = false;
		                    break;
		                }
		            }
	
		            return result;
		        },
	
		        _isRtl: function() {
		            return kendo.support.isRtl(this.element) && this.element.css("direction") === RTL;
		        }
		    });
	
		    var proxyMembers = ["getAxis", "findAxisByName", "plotArea", "toggleHighlight", "showTooltip",
		        "hideTooltip", "_resize", "_redraw", "_noTransitionsRedraw", "_legendItemHover", "_eventCoordinates"];
	
		    function createProxyMember(name) {
		        Chart.fn[name] = function() {
		            var instance = this._instance;
		            if (instance) {
		                return instance[name].apply(instance, arguments);
		            }
		        };
		    }
	
		    for (var idx = 0; idx < proxyMembers.length; idx++) {
		        createProxyMember(proxyMembers[idx]);
		    }
	
		    function groupSeries(series, data) {
		        var result = [],
		            nameTemplate,
		            legacyTemplate = series.groupNameTemplate,
		            groupIx,
		            dataLength = data.length,
		            seriesClone;
	
		        if (dataLength === 0) {
		            seriesClone = deepExtend({}, series);
		            seriesClone.visibleInLegend = false;
		            return [seriesClone];
		        }
	
		        if (defined(legacyTemplate)) {
		            kendo.logToConsole(
		                "'groupNameTemplate' is obsolete and will be removed in future versions. " +
		                "Specify the group name template as 'series.name'"
		            );
	
		            if (legacyTemplate) {
		                nameTemplate = template(legacyTemplate);
		            }
		        } else {
		            nameTemplate = template(series.name || "");
		            if (nameTemplate._slotCount === 0) {
		                nameTemplate = template(defined(series.name) ?
		                    "#= group.value #: #= series.name #" :
		                    "#= group.value #"
		                );
		            }
		        }
	
		        for (groupIx = 0; groupIx < dataLength; groupIx++) {
		            seriesClone = deepExtend({}, series);
	
		            if (!kendo.isFunction(seriesClone.color)) {
		                seriesClone.color = undefined;
		            }
	
		            seriesClone._groupIx = groupIx;
		            seriesClone._groupValue = data[groupIx].value;
		            result.push(seriesClone);
	
		            if (nameTemplate) {
		                seriesClone.name = nameTemplate({
		                    series: seriesClone, group: data[groupIx]
		                });
		            }
		        }
	
		        return result;
		    }
	
		    dataviz.ExportMixin.extend(Chart.fn);
	
		    if (kendo.PDFMixin) {
		        kendo.PDFMixin.extend(Chart.fn);
		    }
	
		    dataviz.ui.plugin(Chart);
	
		    var SeriesVisibilityState = Class.extend({
		        init: function() {
		            this.groups = {};
		            this.index = {};
		            this.options = {};
		        },
	
		        applyByGroup: function(series, e) {
		            if ((e && e.action) || this.options.persistSeriesVisibility) {
		                for (var idx = 0; idx < series.length; idx++) {
		                    if (this.groups[series[idx]._groupValue] === false) {
		                        series[idx].visible = false;
		                    }
		                }
		            } else {
		                this.groups = {};
		            }
		        },
	
		        applyByIndex: function(series, e) {
		            if ((e && e.action) || this.options.persistSeriesVisibility) {
		                if (this.index[series.index] === false) {
		                    series.visible = false;
		                }
		            } else {
		                this.index = {};
		            }
		        },
	
		        save: function(series) {
		            if (!series) {
		                return;
		            }
	
		            if (this.options.persistSeriesVisibility) {
		                this.options.series[series.index].visible = series.visible;
		            } else {
		                this.saveState(series);
		            }
		        },
	
		        setOptions: function(options) {
		            this.options = options;
		            this.groups = {};
		            this.index = {};
		        },
	
		        read: function() {
		            var options = this.options;
		            if (options.persistSeriesVisibility) {
		                var series = options.series;
		                for (var idx = 0; idx < series.length; idx++) {
		                    this.saveState(series[idx]);
		                }
		            }
		        },
	
		        saveState: function(series) {
		            if (defined(series._groupValue)) {
		                this.groups[series._groupValue] = series.visible;
		            } else {
		                this.index[series.index] = series.visible;
		            }
		        }
		    });
	
		    var geom = kendo.geometry;
	
		    function normalizeStyle(style) {
		        for (var field in style) {
		            if (style[field] === undefined) {
		                style[field] = '';
		            }
		        }
	
		        return style;
		    }
	
		    var Tooltip = Observable.extend({
		        init: function(chartElement, options) {
		            var tooltip = this;
	
		            Observable.fn.init.call(tooltip);
	
		            this.setOptions(options);
	
		            tooltip.chartElement = chartElement;
	
		            tooltip.template = Tooltip.template;
		            if (!tooltip.template) {
		                tooltip.template = Tooltip.template = kendo.template(
		                    "<div class='k-tooltip k-chart-tooltip#= d.rtl ? \" k-rtl\" : \"\"#' " +
		                    "style='display:none; position: absolute; font: #= d.font #;" +
		                    "#if (d.border) {# border: #= d.border.width #px solid; #}#" +
		                    "opacity: #= d.opacity #; filter: alpha(opacity=#= d.opacity * 100 #);'>" +
		                    "</div>", { useWithBlock: false, paramName: "d" });
		            }
	
		            tooltip.element = $(tooltip.template(tooltip.options));
	
		            tooltip.move = proxy(tooltip.move, tooltip);
		            tooltip._mouseleave = proxy(tooltip._mouseleave, tooltip);
	
		            var mobileScrollerSelector = kendo.format("[{0}='content'],[{0}='scroller']", kendo.attr("role"));
		            tooltip._mobileScroller = chartElement.closest(mobileScrollerSelector).data("kendoMobileScroller");
		        },
	
		        destroy: function() {
		            this._clearShowTimeout();
	
		            if (this.element) {
		                this.element.off(MOUSELEAVE_NS).remove();
		                this.element = null;
		            }
		        },
	
		        setOptions: function(options) {
		            this.options = deepExtend({}, this.options, options);
		        },
	
		        options: {
		            opacity: 1,
		            animation: {
		                duration: TOOLTIP_ANIMATION_DURATION
		            },
		            sharedTemplate:
		                "<table>" +
		                "<th colspan='#= colspan #'>#= categoryText #</th>" +
		                "# for(var i = 0; i < points.length; i++) { #" +
		                "# var point = points[i]; #" +
		                "<tr>" +
		                    "# if(colorMarker) { # " +
		                        "<td><span class='k-chart-shared-tooltip-marker' style='background-color:#:point.series.color#'></span></td>" +
		                    "# } #" +
		                    "# if(nameColumn) { # " +
		                        "<td> #if (point.series.name) {# #: point.series.name #: #} else {# &nbsp; #}#</td>" +
		                    "# } #" +
		                    "<td>#= content(point) #</td>" +
		                "</tr>" +
		                "# } #" +
		                "</table>",
		            categoryFormat: "{0:d}"
		        },
	
		        move: function() {
		            var tooltip = this,
		                options = tooltip.options,
		                element = tooltip.element,
		                offset;
	
		            if (!tooltip.anchor || !tooltip.element) {
		                return;
		            }
	
		            offset = tooltip._offset();
		            if (!tooltip.visible) {
		                element.css({ top: offset.top, left: offset.left });
		            }
	
		            tooltip.visible = true;
		            tooltip._ensureElement(document.body);
		            element
		                .stop(true, true)
		                .show()
		                .animate({
		                    left: offset.left,
		                    top: offset.top
		                }, options.animation.duration);
		        },
	
		        _clearShowTimeout: function() {
		            if (this.showTimeout) {
		                clearTimeout(this.showTimeout);
		                this.showTimeout = null;
		            }
		        },
	
		        getAnchor: function(size) {
		            var anchor = this.anchor;
		            var point = anchor.point;
		            var align = anchor.align;
		            var x = point.left;
		            var y = point.top;
		            if (align.horizontal === "center") {
		                x -= size.width / 2;
		            } else if (align.horizontal === "right") {
		                x -= size.width;
		            }
	
		            if (align.vertical === "center") {
		                y -= size.height / 2;
		            } else if (align.vertical === "bottom") {
		                y -= size.height;
		            }
	
		            return {
		                x: x,
		                y: y
		            };
		        },
	
		        _offset: function() {
		            var tooltip = this,
		                size = tooltip._measure(),
		                anchor = tooltip.getAnchor(size),
		                top = anchor.y,
		                left = anchor.x,
		                zoomLevel = kendo.support.zoomLevel(),
		                viewport = $(window),
		                scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0,
		                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0,
		                movable = (this._mobileScroller || {}).movable;
	
		            if (!movable || movable.scale === 1) {
		                top += tooltip._fit(top - scrollTop, size.height, outerHeight(viewport) / zoomLevel);
		                left += tooltip._fit(left - scrollLeft, size.width, outerWidth(viewport) / zoomLevel);
		            } else {
		                var transform = geom.transform().scale(movable.scale, movable.scale, [movable.x, movable.y]);
		                var point = new geom.Point(left, top).transform(transform);
		                left = point.x;
		                top = point.y;
		            }
	
		            return {
		                top: top,
		                left: left
		            };
		        },
	
		        show: function(e) {
		            this.anchor = e.anchor;
		            this.element.css(normalizeStyle(e.style));
		            this.element.toggleClass(TOOLTIP_INVERSE, !!e.className);
		            this.element.toggleClass(SHARED_TOOLTIP_CLASS, !!e.shared);
	
		            var content = e.shared ? this._sharedContent(e) : this._pointContent(e.point);
		            this.element.html(content);
	
		            this._clearShowTimeout();
		            this.showTimeout = setTimeout(this.move, TOOLTIP_SHOW_DELAY);
		        },
	
		        hide: function() {
		            var tooltip = this;
	
		            clearTimeout(tooltip.showTimeout);
		            tooltip._hideElement();
	
		            if (tooltip.visible) {
		                tooltip.point = null;
		                tooltip.visible = false;
		                tooltip.index = null;
		            }
		        },
	
		        _sharedContent: function(e) {
		            var points = e.points;
		            var nameColumn = dataviz.grep(points, function(point) {
		                return defined(point.series.name);
		            }).length;
	
		            var colorMarker = e.series.length > 1;
		            var colspan = 1;
		            if (nameColumn) {
		                colspan++;
		            }
		            if (colorMarker) {
		                colspan++;
		            }
	
		            var template = kendo.template(this.options.sharedTemplate);
		            var content = template({
		                points: points,
		                category: e.category,
		                categoryText: e.categoryText,
		                content: this._pointContent,
		                colorMarker: colorMarker,
		                nameColumn: nameColumn,
		                colspan: colspan
		            });
	
		            return content;
		        },
	
		        _measure: function() {
		            this._ensureElement();
	
		            var size = {
		                width: outerWidth(this.element),
		                height: outerHeight(this.element)
		            };
	
		            return size;
		        },
	
		        _ensureElement: function() {
		            if (this.element) {
		                this.element
		                    .appendTo(document.body)
		                    .on(MOUSELEAVE_NS, this._mouseleave);
		            }
		        },
	
		        _mouseleave: function(e) {
		            var target = e.relatedTarget;
		            var chart = this.chartElement[0];
		            if (target && target !== chart && !$.contains(chart, target)) {
		                this.trigger(LEAVE);
		            }
		        },
	
		        _hideElement: function() {
		            var tooltip = this;
		            var element = this.element;
		            if (element) {
		                element.fadeOut({
		                    always: function(){
		                        if (!tooltip.visible) {
		                            element.off(MOUSELEAVE_NS).remove();
		                        }
		                    }
		                });
		            }
		        },
	
		        _pointContent: function(point) {
		            var tooltip = this,
		                options = deepExtend({}, tooltip.options, point.options.tooltip),
		                content, tooltipTemplate;
	
		            if (defined(point.value)) {
		                content = point.value.toString();
		            }
	
		            if (options.template) {
		                tooltipTemplate = template(options.template);
		                content = tooltipTemplate({
		                    value: point.value,
		                    category: point.category,
		                    series: point.series,
		                    dataItem: point.dataItem,
		                    percentage: point.percentage,
		                    runningTotal: point.runningTotal,
		                    total: point.total,
		                    low: point.low,
		                    high: point.high,
		                    xLow: point.xLow,
		                    xHigh: point.xHigh,
		                    yLow: point.yLow,
		                    yHigh: point.yHigh
		                });
		            } else if (options.format) {
		                content = point.formatValue(options.format);
		            }
	
		            return content;
		        },
	
		        _fit: function(offset, size, viewPortSize) {
		            var output = 0;
	
		            if (offset + size > viewPortSize) {
		                output = viewPortSize - (offset + size);
		            }
	
		            if (offset < 0) {
		                output = -offset;
		            }
	
		            return output;
		        }
		    });
	
		    var CrosshairTooltip = Tooltip.extend({
		        init: function(chartElement, options) {
		            Tooltip.fn.init.call(this, chartElement, options);
		            this.element.addClass("k-chart-crosshair-tooltip");
		        },
	
		        show: function(e) {
		            var element = this.element;
	
		            if (element) {
		                this.anchor = e.anchor;
		                this.element.css(e.style);
		                this.element.html(this.content(e));
	
		                this.move();
		            }
		        },
	
		        move: function() {
		            var tooltip = this,
		                element = tooltip.element,
		                offset = tooltip._offset();
	
		            tooltip._ensureElement();
		            element.css({ top: offset.top, left: offset.left }).show();
		        },
	
		        content: function(e) {
		            var content = e.value,
		                options = e.crosshair.options.tooltip;
	
		            if (options.template) {
		                content = template(options.template)({
		                    value: content
		                });
		            }
	
		            return content;
		        },
	
		        hide: function() {
		            this.element.hide();
		        }
		    });
	
		    var ChartPane = Class.extend({
		        init: function(chart, pane) {
		            this._chart = chart;
		            this._pane = pane;
		            this.visual = pane.visual;
		            this.chartsVisual = pane.chartContainer.visual;
		            this.name = pane.options.name;
		        },
	
		        series: function() {
		            var chart = this._chart;
		            var seriesByPane = chart._plotArea.groupSeriesByPane();
		            var series = seriesByPane[this.name || "default"];
	
		            var result = [];
		            if (series) {
		                for (var idx = 0; idx < series.length; idx++) {
		                    result.push(new ChartSeries(chart, series[idx]));
		                }
		            }
	
		            return result;
		        }
		    });
	
		    var ChartSeries = Class.extend({
		        init: function(chart, options) {
		            this._chart = chart;
		            this._options = options;
		        },
	
		        points: function(filter) {
		            var points = this._points;
		            if (!points) {
		                var series = this._seriesOptions();
		                var plotArea = this._chart._plotArea;
		                this._points = points = plotArea.pointsBySeriesIndex(series.index);
		            }
		            if (kendo.isFunction(filter)) {
		                points = this._filterPoints(points, filter);
		            }
	
	
		            return points;
		        },
	
		        data: function(data) {
		            var series = this._seriesOptions();
		            if (data) {
		                var chart = this._chart;
		                var plotArea = chart._plotArea;
	
		                series.data = data;
	
		                if (series.categoryField) {
		                    var axis = plotArea.seriesCategoryAxis(series);
		                    var options = [].concat(chart.options.categoryAxis);
	
		                    chart._instance.bindCategoryAxisFromSeries(options[axis.axisIndex], axis.axisIndex);
		                }
	
		                chart._noTransitionsRedraw();
		                this._clearFields();
		            }
	
		            return series.data;
		        },
	
		        findPoint: function(filter) {
		            var points = this.points();
		            for (var idx = 0; idx < points.length; idx++) {
		                if (filter(points[idx])) {
		                    return points[idx];
		                }
		            }
		        },
	
		        toggleHighlight: function(show, elements) {
		            if (!elements) {
		                elements = this.points();
		            } else if (kendo.isFunction(elements)) {
		                elements = this.points(elements);
		            } else {
		                elements = isArray(elements) ? elements : [elements];
		            }
	
		            this._chart._instance.togglePointsHighlight(show, elements);
		        },
	
		        toggleVisibility: function(visible, filter) {
		            var chart = this._chart;
		            var seriesOptions = this._seriesOptions();
		            var hasFilter = kendo.isFunction(filter);
		            if (!hasFilter) {
		                seriesOptions.visible = visible;
		                chart._seriesVisibility.save(seriesOptions);
		            } else {
		                if (inArray(seriesOptions.type, [PIE, DONUT, FUNNEL])) {
		                    var data = this._filterData(filter);
		                    for (var idx = 0; idx < data.length; idx++) {
		                        data[idx].visible = visible;
		                    }
		                } else {
		                    seriesOptions.visible = function(data) {
		                        return filter(data.dataItem) ? visible : true;
		                    };
		                }
		            }
	
		            chart._noTransitionsRedraw();
	
		            this._clearFields();
		        },
	
		        _filterData: function(filter) {
		            var data = this._seriesOptions().data;
		            var length = data.length;
		            var result = [];
	
		            for (var idx = 0; idx < length; idx++) {
		                if (filter(data[idx])) {
		                    result.push(data[idx]);
		                }
		            }
		            return result;
		        },
	
		        _filterPoints: function(points, filter) {
		            var result = [];
		            var length = points.length;
		            for (var idx = 0; idx < length; idx++) {
		                if (filter(points[idx])) {
		                    result.push(points[idx]);
		                }
		            }
		            return result;
		        },
	
		        _seriesOptions: function() {
		            var series = this._series;
		            if (!series) {
		                series = this._series = this._chart._seriesOptions(this._options);
		            }
		            return series;
		        },
	
		        _clearFields: function() {
		            delete this._points;
		            delete this._series;
		        }
		    });
	
		    function triggerPaneRender(panes) {
		        for (var idx = 0; idx < panes.length; idx++) {
		            panes[idx].notifyRender();
		        }
		    }
	
		    dataviz.Tooltip = Tooltip;
		    dataviz.CrosshairTooltip = CrosshairTooltip;
		    dataviz.ChartInstanceObserver = ChartInstanceObserver;
		    dataviz.ChartPane = ChartPane;
		    dataviz.ChartSeries = ChartSeries;
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 855:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(750);
	
	/***/ }),
	
	/***/ 856:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 857:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 858:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(745);
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 860:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1086);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1061:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(745);
	
	/***/ }),
	
	/***/ 1086:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1087), __webpack_require__(1061) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.gauge",
		    name: "Gauge",
		    category: "dataviz",
		    description: "Linear, Radial and Arc gauges.",
		    depends: [ "dataviz.core", "dataviz.themes" ]
		};
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1087:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(753);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(884);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 884:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(885)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
		    var kendo = window.kendo;
		    var Widget = kendo.ui.Widget;
		    var dataviz = kendo.dataviz;
		    var LinearGauge = dataviz.LinearGauge;
		    var RadialGauge = dataviz.RadialGauge;
		    var ArcGauge = dataviz.ArcGauge;
		    var draw = kendo.drawing;
	
		    var SASS_THEMES = ["sass", "default-v2", "bootstrap-v4"];
	
		    function themeOptions(options) {
		        var themes = dataviz.ui.themes || {};
		        var themeName = options.theme || "";
		        var lowerName = themeName.toLowerCase();
	
		        if(SASS_THEMES.indexOf(lowerName) != -1) {
		            return dataviz.autoTheme().gauge;
		        }
	
		        return (themes[themeName] || themes[lowerName] || {}).gauge;
		    }
	
		    var Gauge = Widget.extend({
		        init: function(element, userOptions) {
		            kendo.destroy(element);
		            $(element).empty();
	
		            Widget.fn.init.call(this, element);
	
		            this.options = kendo.deepExtend(this.options, userOptions);
	
		            this.wrapper = this.element;
		            this._createInstance();
	
		            this.element.addClass('k-gauge');
	
		            kendo.notify(this, dataviz.ui);
		        },
	
		        options: {
		            theme: "default",
		            renderAs: "",
		            pointer: {},
		            scale: {},
		            gaugeArea: {
		                background: ""
		            },
		            transitions: true
		        },
	
		        setOptions: function(options) {
		            this._instance.setOptions(options, themeOptions(options));
	
		            this._copyFields();
		        },
	
		        redraw: function() {
		            this._instance.redraw();
		            this._copyFields();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this._instance.destroy();
		        },
	
		        _createInstance: function() {
		            var gaugeType = this._gaugeType();
		            this._instance = new gaugeType(this.element[0], this.options, themeOptions(this.options));
		            this._copyFields();
		        },
	
		        _copyFields: function() {
		            this._originalOptions = this._instance._originalOptions;
		            this.options = this._instance.options;
		            this.surface = this._instance.surface;
		            this.bbox = this._instance.bbox;
		            this.gaugeArea = this._instance.gaugeArea;
		            this.pointers = this._instance.pointers;
		            this.scale = this._instance.scale;
		        },
	
		        _resize: function() {
		            this._instance.resize();
		        }
		    });
	
		    var proxyMembers = ["getSize", "value", "allValues", "exportVisual"];
	
		    function createProxyMember(name) {
		        Gauge.fn[name] = function() {
		            return this._instance[name].apply(this._instance, arguments);
		        };
		    }
	
		    for (var idx = 0; idx < proxyMembers.length; idx++) {
		        createProxyMember(proxyMembers[idx]);
		    }
	
		    dataviz.ExportMixin.extend(Gauge.fn);
	
		    var RadialGaugeWidget = Gauge.extend({
	
		        options: {
		            name: "RadialGauge"
		        },
	
		        _gaugeType: function() {
		            return RadialGauge;
		        }
		    });
	
		    var LinearGaugeWidget = Gauge.extend({
	
		        options: {
		            name: "LinearGauge",
		            scale: {
		                vertical: true
		            }
		        },
	
		        _gaugeType: function() {
		            return LinearGauge;
		        }
		    });
	
		    var ArcGaugeWidget = Gauge.extend({
		        init: function(element, userOptions) {
		            Gauge.fn.init.call(this, element, userOptions);
	
		            this.element.css('position', 'relative');
		            this.element.addClass('k-arcgauge');
	
		            this._centerTemplate();
		        },
	
		        options: {
		            name: "ArcGauge"
		        },
	
		        setOptions: function(options) {
		            Gauge.fn.setOptions.call(this, options);
		            this._centerTemplate();
		        },
	
		        redraw: function() {
		            Gauge.fn.redraw.call(this);
		            this._centerTemplate();
		        },
	
		        value: function(value) {
		            var instance = this._instance;
		            if (arguments.length === 0) {
		                return instance.value();
		            }
	
		            instance.value(value);
	
		            this._centerTemplate();
		        },
	
		        destroy: function() {
		            Gauge.fn.destroy.call(this);
		            delete this._centerElement;
		        },
	
		        exportVisual: function() {
		            if (this._centerElement) {
		                return false;
		            }
	
		            return Gauge.fn.exportVisual.call(this);
		        },
	
		        _resize: function() {
		            this._instance.resize();
	
		            this._centerTemplate();
		        },
	
		        _centerTemplate: function() {
		            if (this.options.centerTemplate) {
		                var template = kendo.template(this.options.centerTemplate);
	
		                var instance = this._instance;
		                var centerElement = this._getCenterElement();
	
		                centerElement.html(template({ color: instance.currentColor(), value: instance.value() }));
	
		                var position = instance.centerLabelPosition(centerElement.width(), centerElement.height());
	
		                centerElement.css(position);
		            } else if (this._centerElement) {
		                this._centerElement.remove();
		                this._centerElement = null;
		            }
		        },
	
		        _getCenterElement: function() {
		            var centerElement = this._centerElement;
		            if (!centerElement) {
		                centerElement = this._centerElement = $('<div></div>').addClass('k-arcgauge-label');
		                this.element.append(centerElement);
		            }
	
		            return centerElement;
		        },
	
		        _gaugeType: function() {
		            return ArcGauge;
		        }
		    });
	
		    function createExportMethod(name) {
		        ArcGaugeWidget.fn[name] = function(options) {
		            var gauge = this;
		            var method = draw[name];
	
		            if (!gauge._centerElement) {
		                return method(gauge.exportVisual(), options);
		            }
	
		            return draw.drawDOM(gauge.element).then(function(visual) {
		                return method(visual, options);
		            });
		        };
		    }
	
		    var exportMethods = ['exportSVG', 'exportImage', 'exportPDF'];
	
		    for (idx = 0; idx < exportMethods.length; idx++) {
		        createExportMethod(exportMethods[idx]);
		    }
	
		    dataviz.ui.plugin(LinearGaugeWidget);
		    dataviz.ui.plugin(RadialGaugeWidget);
		    dataviz.ui.plugin(ArcGaugeWidget);
	
		    kendo.deepExtend(dataviz, {
		        Gauge: Gauge,
		        LinearGauge: LinearGaugeWidget,
		        RadialGauge: RadialGaugeWidget,
		        ArcGauge: ArcGaugeWidget
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 885:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(754);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(883);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 857:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 862:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 863:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(554);
	
	/***/ }),
	
	/***/ 883:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(862),
		        __webpack_require__(863),
		        __webpack_require__(859),
		        __webpack_require__(857)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		window.kendo.dataviz = window.kendo.dataviz || {};
		var dataviz = kendo.dataviz;
		var getSpacing = dataviz.getSpacing;
		var defined = dataviz.defined;
		var constants = dataviz.constants;
		var BLACK = constants.BLACK;
		var COORD_PRECISION = constants.COORD_PRECISION;
		var services = dataviz.services;
		var deepExtend = dataviz.deepExtend;
		var isArray = dataviz.isArray;
		var setDefaultOptions = dataviz.setDefaultOptions;
		var NumericAxis = dataviz.NumericAxis;
		var limitValue = dataviz.limitValue;
		var Box = dataviz.Box;
		var interpolateValue = dataviz.interpolateValue;
		var round = dataviz.round;
		var drawing = kendo.drawing;
		var DrawingGroup = drawing.Group;
		var DrawingPath = drawing.Path;
		var Animation = drawing.Animation;
		var AnimationFactory = drawing.AnimationFactory;
		var geometry = kendo.geometry;
		var Rect = geometry.Rect;
		var GeometryPoint = geometry.Point;
		var transform = geometry.transform;
	
		var ANGULAR_SPEED = 150;
		var LINEAR_SPEED = 250;
		var ARROW = "arrow";
		var ARROW_POINTER = "arrowPointer";
		var BAR_POINTER = "barPointer";
		var DEFAULT_HEIGHT = 200;
		var DEFAULT_LINE_WIDTH = 0.5;
		var DEFAULT_WIDTH = 200;
		var DEGREE = Math.PI / 180;
		var INSIDE = "inside";
		var LINEAR = "linear";
		var OUTSIDE = "outside";
		var RADIAL_POINTER = "radialPointer";
		var RADIAL_RANGE_POINTER = "radialRangePointer";
	
		function pad(bbox, value) {
		    var origin = bbox.getOrigin();
		    var size = bbox.getSize();
		    var spacing = getSpacing(value);
	
		    bbox.setOrigin([ origin.x - spacing.left, origin.y - spacing.top ]);
		    bbox.setSize([ size.width + (spacing.left + spacing.right), size.height + (spacing.top + spacing.bottom) ]);
	
		    return bbox;
		}
	
		var Group = DrawingGroup;
		var Path$1 = DrawingPath;
		var Text = drawing.Text;
	
		function buildLabelElement(label, options) {
		    var labelBox = label.box;
		    var textBox = label.children[0].box;
		    var border = options.border || {};
		    var background = options.background || "";
	
		    var wrapper = Path$1.fromRect(new Rect([ labelBox.x1, labelBox.y1 ], [ labelBox.width(), labelBox.height() ]), {
		        stroke: {}
		    });
	
		    var text = new Text(label.text, new GeometryPoint(textBox.x1, textBox.y1), {
		        font: options.font,
		        fill: { color: options.color }
		    });
	
		    var styleGeometry = pad(text.bbox().clone(), options.padding);
	
		    var styleBox = Path$1.fromRect(styleGeometry, {
		        stroke: {
		            color: border.width ? border.color : "",
		            width: border.width,
		            dashType: border.dashType,
		            lineJoin: "round",
		            lineCap: "round"
		        },
		        fill: {
		            color: background
		        }
		    });
	
		    var elements = new Group();
		    elements.append(wrapper);
		    elements.append(styleBox);
		    elements.append(text);
	
		    return elements;
		}
	
		function getRange(range, min, max) {
		    var from = defined(range.from) ? range.from : constants.MIN_VALUE;
		    var to = defined(range.to) ? range.to : constants.MAX_VALUE;
	
		    range.from = Math.max(Math.min(to, from), min);
		    range.to = Math.min(Math.max(to, from), max);
	
		    return range;
		}
	
		function unpad(bbox, value) {
		    var spacing = getSpacing(value);
	
		    spacing.left = -spacing.left; spacing.top = -spacing.top;
		    spacing.right = -spacing.right; spacing.bottom = -spacing.bottom;
	
		    return pad(bbox, spacing);
		}
	
		var DEFAULT_MARGIN = 5;
		var Path = DrawingPath;
		var Surface = drawing.Surface;
	
		var Gauge = dataviz.Class.extend({
		    init: function(element, userOptions, theme, context) {
		        if (context === void 0) { context = {}; }
	
		        this.element = element;
		        this.theme = theme;
		        this.contextService = new services.ChartService(this, context);
		        this._originalOptions = deepExtend({}, this.options, userOptions);
		        this.options = deepExtend({}, this._originalOptions);
		        this._initTheme(theme);
	
		        this.redraw();
		    },
	
		    destroy: function() {
		        if (this.surface) {
		            this.surface.destroy();
		            this.surface = null;
		        }
	
		        delete this.element;
		        delete this.surfaceElement;
		    },
	
		    value: function(pointerValue) {
		        var pointer = this.pointers[0];
	
		        if (arguments.length === 0) {
		            return pointer.value();
		        }
	
		        pointer.value(pointerValue);
		        this._setValueOptions(pointerValue);
		    },
	
		    _draw: function() {
		        var surface = this.surface;
	
		        surface.clear();
		        surface.draw(this._visuals);
		    },
	
		    exportVisual: function() {
		        return this._visuals;
		    },
	
		    allValues: function(values) {
		        var pointers = this.pointers;
		        var allValues = [];
	
		        if (arguments.length === 0) {
		            for (var i = 0; i < pointers.length; i++) {
		                allValues.push(pointers[i].value());
		            }
	
		            return allValues;
		        }
	
		        if (isArray(values)) {
		            for (var i$1 = 0; i$1 < values.length; i$1++) {
		                if (dataviz.isNumber(values[i$1])) {
		                    pointers[i$1].value(values[i$1]);
		                }
		            }
		        }
	
		        this._setValueOptions(values);
		    },
	
		    _setValueOptions: function(values) {
		        var pointers = [].concat(this.options.pointer);
		        var arrayValues = [].concat(values);
	
		        for (var i = 0; i < arrayValues.length; i++) {
		            pointers[i].value = arrayValues[i];
		        }
		    },
	
		    resize: function() {
		        this.noTransitionsRedraw();
		    },
	
		    noTransitionsRedraw: function() {
		        var transitions = this.options.transitions;
	
		        this._toggleTransitions(false);
	
		        this.redraw();
	
		        this._toggleTransitions(transitions);
		    },
	
		    redraw: function() {
		        var size = this._surfaceSize();
		        var wrapper = new Rect([ 0, 0 ], [ size.width, size.height ]);
	
		        this._initSurface();
	
		        this.gaugeArea = this._createGaugeArea();
	
		        this._createModel();
	
		        var bbox = unpad(wrapper.bbox(), this._gaugeAreaMargin);
		        this.reflow(bbox);
		    },
	
		    setOptions: function(options, theme) {
		        this._originalOptions = deepExtend(this._originalOptions, options);
		        this.options = deepExtend({}, this._originalOptions);
	
		        this._initTheme(theme);
	
		        this.redraw();
		    },
	
		    setDirection: function(rtl) {
		        this.contextService.rtl = Boolean(rtl);
		        if (this.surface && this.surface.type === 'svg') {
		            this.surface.destroy();
		            this.surface = null;
		        }
		    },
	
		    setIntlService: function(intl) {
		        this.contextService.intl = intl;
		    },
	
		    _initTheme: function(theme) {
		        var currentTheme = theme || this.theme || {};
		        this.theme = currentTheme;
	
		        this.options = deepExtend({}, currentTheme, this.options);
		        var options = this.options;
		        var pointer = options.pointer;
	
		        if (isArray(pointer)) {
		            var pointers = [];
		            for (var i = 0; i < pointer.length; i++) {
		                pointers.push(deepExtend({}, currentTheme.pointer, pointer[i]));
		            }
		            options.pointer = pointers;
		        }
		    },
	
		    _createGaugeArea: function() {
		        var options = this.options.gaugeArea;
		        var size = this.surface.size();
		        var border = options.border || {};
		        var areaGeometry = new Rect([ 0, 0 ], [ size.width, size.height ]);
	
		        this._gaugeAreaMargin = options.margin || DEFAULT_MARGIN;
	
		        if (border.width > 0) {
		            areaGeometry = unpad(areaGeometry, border.width);
		        }
	
		        var gaugeArea = Path.fromRect(areaGeometry, {
		            stroke: {
		                color: border.width ? border.color : "",
		                width: border.width,
		                dashType: border.dashType,
		                lineJoin: "round",
		                lineCap: "round"
		            },
		            fill: {
		                color: options.background
		            }
		        });
	
		        return gaugeArea;
		    },
	
		    _initSurface: function() {
		        var ref = this;
		        var options = ref.options;
		        var surface = ref.surface;
		        var element = this._surfaceElement();
		        var size = this._surfaceSize();
	
		        dataviz.elementSize(element, size);
	
		        if (!surface || surface.options.type !== options.renderAs) {
		            if (surface) {
		                surface.destroy();
		            }
	
		            this.surface = Surface.create(element, {
		                type: options.renderAs
		            });
		        } else {
		            this.surface.clear();
		            this.surface.resize();
		        }
		    },
	
		    _surfaceSize: function() {
		        var options = this.options;
		        var size = this._getSize();
	
		        if (options.gaugeArea) {
		            deepExtend(size, options.gaugeArea);
		        }
	
		        return size;
		    },
	
		    _surfaceElement: function() {
		        if (!this.surfaceElement) {
		            this.surfaceElement = document.createElement('div');
		            this.element.appendChild(this.surfaceElement);
		        }
	
		        return this.surfaceElement;
		    },
	
		    getSize: function() {
		        return this._getSize();
		    },
	
		    _getSize: function() {
		        var element = this.element;
		        var defaultSize = this._defaultSize();
		        var width = element.offsetWidth;
		        var height = element.offsetHeight;
	
		        if (!width) {
		            width = defaultSize.width;
		        }
	
		        if (!height) {
		            height = defaultSize.height;
		        }
	
		        return { width: width, height: height };
		    },
	
		    _defaultSize: function() {
		        return {
		            width: DEFAULT_WIDTH,
		            height: DEFAULT_HEIGHT
		        };
		    },
	
		    _toggleTransitions: function(value) {
		        var this$1 = this;
	
		        this.options.transitions = value;
		        for (var i = 0; i < this.pointers.length; i++) {
		            this$1.pointers[i].options.animation.transitions = value;
		        }
		    }
		});
	
		setDefaultOptions(Gauge, {
		    plotArea: {},
		    theme: "default",
		    renderAs: "",
		    pointer: {},
		    scale: {},
		    gaugeArea: {}
		});
	
		var Path$2 = DrawingPath;
		var Group$2 = DrawingGroup;
		var Point = GeometryPoint;
	
		function renderAxisTick(tickRenderOptions, tickOptions) {
		    var position = tickRenderOptions.position;
		    var tickX = tickRenderOptions.tickX;
		    var tickY = tickRenderOptions.tickY;
		    var start, end;
	
		    if (tickRenderOptions.vertical) {
		        start = new Point(tickX, position);
		        end = new Point(tickX + tickOptions.size, position);
		    } else {
		        start = new Point(position, tickY);
		        end = new Point(position, tickY + tickOptions.size);
		    }
	
		    var tickPath = new Path$2({
		        stroke: {
		            color: tickOptions.color,
		            width: tickOptions.width
		        }
		    }).moveTo(start).lineTo(end);
	
		    return tickPath;
		}
	
		function renderTicks(tickGroup, tickPositions, tickRenderOptions, tickOptions) {
		    var count = tickPositions.length;
	
		    if (tickOptions.visible) {
		        var mirror = tickRenderOptions.mirror;
		        var lineBox = tickRenderOptions.lineBox;
		        for (var i = tickOptions.skip; i < count; i += tickOptions.step) {
		            if (i % tickOptions.skipUnit === 0) {
		                continue;
		            }
	
		            tickRenderOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
		            tickRenderOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
		            tickRenderOptions.position = tickPositions[i];
	
		            tickGroup.append(renderAxisTick(tickRenderOptions, tickOptions));
		        }
		    }
		}
	
		var LinearScale = NumericAxis.extend({
		    init: function(options, service) {
		        var scaleOptions = options || {};
		        if (!defined(scaleOptions.reverse) && scaleOptions.vertical === false && (service || {}).rtl) {
		            scaleOptions = $.extend({}, scaleOptions, {
		                reverse: true
		            });
		        }
	
		        NumericAxis.fn.init.call(this, 0, 1, scaleOptions, service);
	
		        this.options.minorUnit = this.options.minorUnit || this.options.majorUnit / 10;
		    },
	
		    initUserOptions: function(options) {
		        var scaleOptions = deepExtend({}, this.options, options);
		        scaleOptions = deepExtend({}, scaleOptions , { labels: { mirror: scaleOptions.mirror } });
		        scaleOptions.majorUnit = scaleOptions.majorUnit || dataviz.autoMajorUnit(scaleOptions.min, scaleOptions.max);
	
		        return scaleOptions;
		    },
	
		    initFields: function() {
		    },
	
		    render: function() {
		        var elements = this.elements = new Group$2();
		        var labels = this.renderLabels();
		        var scaleLine = this.renderLine();
		        var scaleTicks = this.renderTicks();
		        var ranges = this.renderRanges();
	
		        elements.append(scaleLine, labels, scaleTicks, ranges);
	
		        return elements;
		    },
	
		    renderRanges: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var min = options.min;
		        var max = options.max;
		        var vertical = options.vertical;
		        var mirror = options.labels.mirror;
		        var ranges = options.ranges || [];
		        var elements = new Group$2();
		        var count = ranges.length;
		        var rangeSize = options.rangeSize || options.minorTicks.size / 2;
	
		        for (var i = 0; i < count; i++) {
		            var range = getRange(ranges[i], min, max);
		            var slot = this$1.getSlot(range.from, range.to);
		            var slotX = vertical ? this$1.lineBox() : slot;
		            var slotY = vertical ? slot : this$1.lineBox();
		            if (vertical) {
		                slotX.x1 -= rangeSize * (mirror ? -1 : 1);
		            } else {
		                slotY.y2 += rangeSize * (mirror ? -1 : 1);
		            }
	
		            elements.append(Path$2.fromRect(new Rect([ slotX.x1, slotY.y1 ], [ slotX.x2 - slotX.x1, slotY.y2 - slotY.y1 ]), {
		                fill: { color: range.color, opacity: range.opacity },
		                stroke: { }
		            }));
		        }
	
		        return elements;
		    },
	
		    renderLabels: function() {
		        var ref = this;
		        var labels = ref.labels;
		        var options = ref.options;
		        var elements = new Group$2();
	
		        for (var i = 0; i < labels.length; i++) {
		            elements.append(buildLabelElement(labels[i], options.labels));
		        }
	
		        return elements;
		    },
	
		    renderLine: function() {
		        var line = this.options.line;
		        var lineBox = this.lineBox();
		        var elements = new Group$2();
	
		        if (line.width > 0 && line.visible) {
		            var linePath = new Path$2({
		                stroke: {
		                    color: line.color,
		                    dashType: line.dashType,
		                    width: line.width
		                }
		            });
	
		            linePath.moveTo(lineBox.x1, lineBox.y1).lineTo(lineBox.x2, lineBox.y2);
		            elements.append(linePath);
		        }
	
		        return elements;
		    },
	
		    renderTicks: function() {
		        var ticks = new Group$2();
		        var options = this.options;
		        var majorUnit = options.majorTicks.visible ? options.majorUnit : 0;
		        var tickRenderOptions = {
		            vertical: options.vertical,
		            mirror: options.labels.mirror,
		            lineBox: this.lineBox()
		        };
	
		        renderTicks(ticks, this.getMajorTickPositions(), tickRenderOptions, options.majorTicks);
		        renderTicks(ticks, this.getMinorTickPositions(), tickRenderOptions, deepExtend({}, {
		            skipUnit: majorUnit / options.minorUnit
		        }, options.minorTicks));
	
		        return ticks;
		    }
		});
	
		setDefaultOptions(LinearScale, {
		    min: 0,
		    max: 50,
	
		    majorTicks: {
		        size: 15,
		        align: INSIDE,
		        color: BLACK,
		        width: DEFAULT_LINE_WIDTH,
		        visible: true
		    },
	
		    minorTicks: {
		        size: 10,
		        align: INSIDE,
		        color: BLACK,
		        width: DEFAULT_LINE_WIDTH,
		        visible: true
		    },
	
		    line: {
		        width: DEFAULT_LINE_WIDTH
		    },
	
		    labels: {
		        position: INSIDE,
		        padding: 2
		    },
		    mirror: false,
		    _alignLines: false
		});
	
		var Pointer = dataviz.Class.extend({
		    init: function(scale, userOptions) {
	
		        var ref = scale.options;
		        var min = ref.min;
		        var max = ref.max;
		        var options = this.options = deepExtend({}, this.options, userOptions);
	
		        options.fill = options.color;
	
		        this.scale = scale;
	
		        if (defined(options.value)) {
		            options.value = limitValue(options.value, min, max);
		        } else {
		            options.value = min;
		        }
		    },
	
		    value: function(newValue) {
		        var options = this.options;
		        var value = options.value;
	
		        if (arguments.length === 0) {
		            return value;
		        }
	
		        var ref = this.scale.options;
		        var min = ref.min;
		        var max = ref.max;
	
		        options._oldValue = defined(options._oldValue) ? options.value : min;
		        options.value = limitValue(newValue, min, max);
	
		        if (this.elements) {
		            this.repaint();
		        }
		    }
		});
	
		setDefaultOptions(Pointer, {
		    color: BLACK
		});
	
		var LinearPointer = Pointer.extend({
		    init: function(scale, options) {
		        Pointer.fn.init.call(this, scale, options);
	
		        this.options = deepExtend({
		            track: {
		                visible: defined(options.track)
		            }
		        }, this.options);
		    },
	
		    reflow: function() {
		        var ref = this;
		        var options = ref.options;
		        var scale = ref.scale;
		        var ref$1 = scale.options;
		        var mirror = ref$1.mirror;
		        var vertical = ref$1.vertical;
		        var scaleLine = scale.lineBox();
		        var trackSize = options.track.size || options.size;
		        var pointerHalfSize = options.size / 2;
		        var margin = getSpacing(options.margin);
		        var space = vertical ?
		                 margin[mirror ? "left" : "right"] :
		                 margin[mirror ? "bottom" : "top"];
		        var pointerBox, pointerRangeBox, trackBox;
	
		        space = mirror ? -space : space;
	
		        if (vertical) {
		            trackBox = new Box(
		                scaleLine.x1 + space, scaleLine.y1,
		                scaleLine.x1 + space, scaleLine.y2);
	
		            if (mirror) {
		                trackBox.x1 -= trackSize;
		            } else {
		                trackBox.x2 += trackSize;
		            }
	
		            if (options.shape !== BAR_POINTER) {
		                pointerRangeBox = new Box(
		                    scaleLine.x2 + space, scaleLine.y1 - pointerHalfSize,
		                    scaleLine.x2 + space, scaleLine.y2 + pointerHalfSize
		                );
		                pointerBox = pointerRangeBox;
		            }
		        } else {
		            trackBox = new Box(
		                scaleLine.x1, scaleLine.y1 - space,
		                scaleLine.x2, scaleLine.y1 - space);
	
		            if (mirror) {
		                trackBox.y2 += trackSize;
		            } else {
		                trackBox.y1 -= trackSize;
		            }
	
		            if (options.shape !== BAR_POINTER) {
		                pointerRangeBox = new Box(
		                    scaleLine.x1 - pointerHalfSize, scaleLine.y1 - space,
		                    scaleLine.x2 + pointerHalfSize, scaleLine.y1 - space
		                );
		                pointerBox = pointerRangeBox;
		            }
		        }
	
		        this.trackBox = trackBox;
		        this.pointerRangeBox = pointerRangeBox;
		        this.box = pointerBox || trackBox.clone().pad(options.border.width);
		    },
	
		    getElementOptions: function() {
		        var options = this.options;
	
		        return {
		            fill: {
		                color: options.color,
		                opacity: options.opacity
		            },
		            stroke: defined(options.border) ? {
		                color: options.border.width ? options.border.color || options.color : "",
		                width: options.border.width,
		                dashType: options.border.dashType,
		                opacity: options.opacity
		            } : null
		        };
		    },
	
		    _margin: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var ref$1 = scale.options;
		        var mirror = ref$1.mirror;
		        var vertical = ref$1.vertical;
		        var margin = getSpacing(options.margin);
	
		        var space = vertical ?
		            margin[mirror ? "left" : "right"] :
		            margin[mirror ? "bottom" : "top"];
	
		        return space;
		    }
		});
	
		setDefaultOptions(LinearPointer, {
		    shape: BAR_POINTER,
	
		    track: {
		        border: {
		            width: 1
		        }
		    },
	
		    color: BLACK,
		    border: {
		        width: 1
		    },
		    opacity: 1,
	
		    margin: getSpacing(3),
		    animation: {
		        type: BAR_POINTER
		    },
		    visible: true
		});
	
		var ArrowLinearPointerAnimation = Animation.extend({
		    setup: function() {
		        var options = this.options;
		        var margin = options.margin;
		        var from = options.from;
		        var to = options.to;
		        var vertical = options.vertical;
		        var axis = vertical ? "x1" : "y1";
	
		        if (options.mirror === vertical) {
		            from[axis] -= margin; to[axis] -= margin;
		        } else {
		            from[axis] += margin; to[axis] += margin;
		        }
	
		        var fromScale = this.fromScale = new GeometryPoint(from.x1, from.y1);
		        var toScale = this.toScale = new GeometryPoint(to.x1, to.y1);
	
		        if (options.duration !== 0) {
		            options.duration = Math.max((fromScale.distanceTo(toScale) / options.duration) * 1000, 1);
		        }
		    },
	
		    step: function(pos) {
		        var translateX = interpolateValue(this.fromScale.x, this.toScale.x, pos);
		        var translateY = interpolateValue(this.fromScale.y, this.toScale.y, pos);
	
		        this.element.transform(transform().translate(translateX, translateY));
		    }
		});
	
		setDefaultOptions(ArrowLinearPointerAnimation, {
		    easing: LINEAR,
		    duration: LINEAR_SPEED
		});
	
		AnimationFactory.current.register(ARROW_POINTER, ArrowLinearPointerAnimation);
	
		var Point$1 = GeometryPoint;
		var Path$3 = DrawingPath;
	
		var ArrowLinearPointer = LinearPointer.extend({
		    init: function(scale, options) {
		        LinearPointer.fn.init.call(this, scale, options);
	
		        if (!defined(this.options.size)) {
		            this.options.size = this.scale.options.majorTicks.size * 0.6;
		        }
		    },
	
		    pointerShape: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var size = ref.options.size;
		        var halfSize = size / 2;
		        var sign = (scale.options.mirror ? -1 : 1);
		        var shape;
	
		        if (scale.options.vertical) {
		            shape = [
		                new Point$1(0, 0 - halfSize), new Point$1(0 - sign * size, 0), new Point$1(0, 0 + halfSize)
		            ];
		        } else {
		            shape = [
		                new Point$1(0 - halfSize, 0), new Point$1(0, 0 + sign * size), new Point$1(0 + halfSize, 0)
		            ];
		        }
	
		        return shape;
		    },
	
		    repaint: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var animation = new ArrowLinearPointerAnimation(this.elements, deepExtend(options.animation, {
		            vertical: scale.options.vertical,
		            mirror: scale.options.mirror,
		            margin: this._margin(options.margin),
		            from: scale.getSlot(options._oldValue),
		            to: scale.getSlot(options.value)
		        }));
	
		        if (options.animation.transitions === false) {
		            animation.options.duration = 0;
		        }
	
		        animation.setup();
		        animation.play();
		    },
	
		    render: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var elementOptions = this.getElementOptions();
		        var shape = this.pointerShape(options.value);
	
		        options.animation.type = ARROW_POINTER;
	
		        var elements = new Path$3({
		            stroke: elementOptions.stroke,
		            fill: elementOptions.fill
		        }).moveTo(shape[0]).lineTo(shape[1]).lineTo(shape[2]).close();
	
		        var slot = scale.getSlot(options.value);
		        elements.transform(transform().translate(slot.x1, slot.y1));
	
		        this.elements = elements;
	
		        return elements;
		    }
		});
	
		var BarLinearPointerAnimation = Animation.extend({
		    setup: function() {
		        var options = this.options;
		        var axis = this.axis = options.vertical ? constants.Y : constants.X;
		        var to = this.to = options.newPoints[0][axis];
		        var from = this.from = options.oldPoints[0][axis];
	
		        if (options.duration !== 0) {
		            options.duration = Math.max((Math.abs(to - from) / options.speed) * 1000, 1);
		        }
	
		        this._set(from);
		    },
	
		    step: function(pos) {
		        var value = interpolateValue(this.from, this.to, pos);
		        this._set(value);
		    },
	
		    _set: function(value) {
		        var setter = "set" + this.axis.toUpperCase();
		        var points = this.options.newPoints;
	
		        points[0][setter](value);
		        points[1][setter](value);
		    }
		});
	
		setDefaultOptions(BarLinearPointerAnimation, {
		    easing: LINEAR,
		    speed: LINEAR_SPEED
		});
	
		AnimationFactory.current.register(BAR_POINTER, BarLinearPointerAnimation);
	
		var Group$3 = DrawingGroup;
		var Path$4 = DrawingPath;
	
		var BarLinearPointer = LinearPointer.extend({
		    init: function(scale, options) {
		        LinearPointer.fn.init.call(this, scale, options);
	
		        if (!defined(this.options.size)) {
		            this.options.size = this.scale.options.majorTicks.size * 0.3;
		        }
		    },
	
		    pointerShape: function(value) {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var ref$1 = scale.options;
		        var mirror = ref$1.mirror;
		        var vertical = ref$1.vertical;
		        var dir = mirror === vertical ? -1 : 1;
		        var size = options.size * dir;
		        var minSlot = scale.getSlot(scale.options.min);
		        var slot = scale.getSlot(value);
		        var axis = vertical ? constants.Y : constants.X;
		        var sizeAxis = vertical ? constants.X : constants.Y;
		        var margin = this._margin() * dir;
	
		        var p1 = new GeometryPoint();
		        p1[axis] = minSlot[axis + "1"];
		        p1[sizeAxis] = minSlot[sizeAxis + "1"];
	
		        var p2 = new GeometryPoint();
		        p2[axis] = slot[axis + "1"];
		        p2[sizeAxis] = slot[sizeAxis + "1"];
	
		        if (vertical) {
		            p1.translate(margin, 0);
		            p2.translate(margin, 0);
		        } else {
		            p1.translate(0, margin);
		            p2.translate(0, margin);
		        }
	
		        var p3 = p2.clone();
		        var p4 = p1.clone();
	
		        if (vertical) {
		            p3.translate(size, 0);
		            p4.translate(size, 0);
		        } else {
		            p3.translate(0, size);
		            p4.translate(0, size);
		        }
	
		        return [ p1, p2, p3, p4 ];
		    },
	
		    repaint: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var shape = this.pointerShape(options.value);
		        var pointerPath = this.elements.children[0];
		        var oldShape = this.pointerShape(options._oldValue);
	
		        pointerPath.moveTo(shape[0]).lineTo(shape[1]).lineTo(shape[2]).lineTo(shape[3]).close();
	
		        var animation = new BarLinearPointerAnimation(pointerPath, deepExtend(options.animation, {
		            reverse: scale.options.reverse,
		            vertical: scale.options.vertical,
		            oldPoints: [ oldShape[1], oldShape[2] ],
		            newPoints: [ shape[1], shape[2] ]
		        }));
	
		        if (options.animation.transitions === false) {
		            animation.options.duration = 0;
		        }
	
		        animation.setup();
		        animation.play();
		    },
	
		    render: function() {
		        var group = new Group$3();
		        var elementOptions = this.getElementOptions();
	
		        var pointer = new Path$4({
		            stroke: elementOptions.stroke,
		            fill: elementOptions.fill
		        });
	
		        group.append(pointer);
	
		        this.elements = group;
	
		        return group;
		    }
		});
	
		var DEFAULT_MIN_WIDTH = 60;
		var DEFAULT_MIN_HEIGHT = 60;
	
		var Group$1 = DrawingGroup;
	
		var LinearGauge = Gauge.extend({
		    reflow: function(bbox) {
		        var pointers = this.pointers;
		        var bboxX = bbox.origin.x;
		        var bboxY = bbox.origin.y;
	
		        var box = new Box(bboxX, bboxY, bboxX + bbox.width(), bboxY + bbox.height());
	
		        this.scale.reflow(box);
		        this._shrinkScaleWidth(box);
	
		        for (var i = 0; i < pointers.length; i++) {
		            pointers[i].reflow();
		        }
	
		        this.bbox = this._getBox(box);
		        this._alignElements();
		        this._shrinkElements();
		        this._buildVisual();
		        this._draw();
		    },
	
		    _buildVisual: function() {
		        var visuals = new Group$1();
		        var scaleElements = this.scale.render();
		        var pointers = this.pointers;
	
		        visuals.append(this.gaugeArea);
		        visuals.append(scaleElements);
	
		        for (var i = 0; i < pointers.length; i++) {
		            var current = pointers[i];
		            visuals.append(current.render());
		            current.value(current.options.value);
		        }
	
		        this._visuals = visuals;
		    },
	
		    _createModel: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var scale = this.scale = new LinearScale(options.scale, this.contextService);
	
		        this.pointers = [];
	
		        var pointers = options.pointer;
		        pointers = isArray(pointers) ? pointers : [ pointers ];
	
		        for (var i = 0; i < pointers.length; i++) {
		            var currentOptions = deepExtend({}, pointers[i], {
		                animation: {
		                    transitions: options.transitions
		                }
		            });
		            var pointerType = currentOptions.shape === ARROW ? ArrowLinearPointer : BarLinearPointer;
	
		            this$1.pointers.push(new pointerType(scale, currentOptions));
		        }
		    },
	
		    _defaultSize: function() {
		        var vertical = this.options.scale.vertical;
	
		        return {
		            width: vertical ? DEFAULT_MIN_WIDTH : DEFAULT_WIDTH,
		            height: vertical ? DEFAULT_HEIGHT : DEFAULT_MIN_HEIGHT
		        };
		    },
	
		    _getBox: function(box) {
		        var ref = this;
		        var scale = ref.scale;
		        var pointers = ref.pointers;
		        var boxCenter = box.center();
		        var plotAreaBox = pointers[0].box.clone().wrap(scale.box);
	
		        for (var i = 0; i < pointers.length; i++) {
		            plotAreaBox.wrap(pointers[i].box.clone());
		        }
	
		        var size;
		        if (scale.options.vertical) {
		            size = plotAreaBox.width() / 2;
		            plotAreaBox = new Box(
		                boxCenter.x - size, box.y1,
		                boxCenter.x + size, box.y2
		            );
		        } else {
		            size = plotAreaBox.height() / 2;
		            plotAreaBox = new Box(
		                box.x1, boxCenter.y - size,
		                box.x2, boxCenter.y + size
		            );
		        }
	
		        return plotAreaBox;
		    },
	
		    _alignElements: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var scale = ref.scale;
		        var pointers = ref.pointers;
		        var scaleBox = scale.box;
		        var box = pointers[0].box.clone().wrap(scale.box);
		        var plotAreaBox = this.bbox;
	
		        for (var i = 0; i < pointers.length; i++) {
		            box.wrap(pointers[i].box.clone());
		        }
	
		        var diff;
		        if (scale.options.vertical) {
		            diff = plotAreaBox.center().x - box.center().x;
		            scale.reflow(new Box(
		                scaleBox.x1 + diff, plotAreaBox.y1,
		                scaleBox.x2 + diff, plotAreaBox.y2
		            ));
		        } else {
		            diff = plotAreaBox.center().y - box.center().y;
		            scale.reflow(new Box(
		                scaleBox.x1, scaleBox.y1 + diff,
		                scaleBox.x2, scaleBox.y2 + diff
		            ));
		        }
	
		        for (var i$1 = 0; i$1 < pointers.length; i$1++) {
		            pointers[i$1].reflow(this$1.bbox);
		        }
		    },
	
		    _shrinkScaleWidth: function(bbox) {
		        var ref = this;
		        var scale = ref.scale;
		        if (!scale.options.vertical) {
		            var overflow = scale.contentBox().width() - bbox.width();
		            if (overflow > 0) {
		                scale.box.shrink(overflow, 0);
		                scale.box.alignTo(bbox, 'center');
		                scale.reflow(scale.box);
		            }
		        }
		    },
	
		    _shrinkElements: function() {
		        var this$1 = this;
	
		        var ref = this;
		        var scale = ref.scale;
		        var pointers = ref.pointers;
		        var scaleBox = scale.box.clone();
		        var pos = scale.options.vertical ? "y" : "x";
		        var pointerBox = pointers[0].box;
	
		        for (var i = 0; i < pointers.length; i++) {
		            pointerBox.wrap(pointers[i].box.clone());
		        }
	
		        scaleBox[pos + 1] += Math.max(scaleBox[pos + 1] - pointerBox[pos + 1], 0);
		        scaleBox[pos + 2] -= Math.max(pointerBox[pos + 2] - scaleBox[pos + 2], 0);
	
		        scale.reflow(scaleBox);
	
		        for (var i$1 = 0; i$1 < pointers.length; i$1++) {
		            pointers[i$1].reflow(this$1.bbox);
		        }
		    }
		});
	
		setDefaultOptions(LinearGauge, {
		    transitions: true,
		    gaugeArea: {
		        background: ""
		    },
		    scale: {
		        vertical: true
		    }
		});
	
		var GEO_ARC_ADJUST_ANGLE = 180;
	
		var Arc = drawing.Arc;
		var Path$5 = DrawingPath;
		var Group$5 = DrawingGroup;
	
		function drawTicks(arc, tickAngles, unit, tickOptions) {
		    var ticks = new Group$5();
		    var center = arc.center;
		    var radius = arc.getRadiusX();
	
		    if (tickOptions.visible) {
		        for (var i = 0; i < tickAngles.length; i++) {
		            var tickStart = arc.pointAt(tickAngles[i]);
		            var tickEnd = new GeometryPoint(center.x + radius - tickOptions.size, center.y).rotate(tickAngles[i], center);
	
		            ticks.append(new Path$5({
		                stroke: {
		                    color: tickOptions.color,
		                    width: tickOptions.width
		                }
		            }).moveTo(tickStart).lineTo(tickEnd));
		        }
		    }
	
		    return ticks;
		}
	
		function rangeSegment(from, to, color, opacity) {
		    return { from: from, to: to, color: color, opacity: opacity };
		}
	
		var RadialScale = NumericAxis.extend({
		    init: function(options, service) {
		        NumericAxis.fn.init.call(this, 0, 1, options, service);
		    },
	
		    initUserOptions: function(options) {
		        var scaleOptions = deepExtend({}, this.options, options);
		        scaleOptions.majorUnit = scaleOptions.majorUnit || dataviz.autoMajorUnit(scaleOptions.min, scaleOptions.max);
		        scaleOptions.minorUnit = scaleOptions.minorUnit || scaleOptions.majorUnit / 10;
	
		        return scaleOptions;
		    },
	
		    initFields: function() {
		    },
	
		    render: function(center, radius) {
		        var arc = this.renderArc(center, radius);
	
		        this.bbox = arc.bbox();
		        this.labelElements = this.renderLabels();
		        this.ticks = this.renderTicks();
		        this.ranges = this.renderRanges();
		    },
	
		    reflow: function(bbox) {
		        var center = bbox.center();
		        var radius = Math.min(bbox.height(), bbox.width()) / 2;
	
		        if (defined(this.bbox)) {
		            this.bbox = this.arc.bbox();
		            this.radius(this.arc.getRadiusX());
		            this.repositionRanges();
		            this.renderLabels();
		        } else {
		            return this.render(center, radius);
		        }
		    },
	
		    slotAngle: function(value) {
		        var ref = this.options;
		        var min = ref.min;
		        var max = ref.max;
		        var reverse = ref.reverse;
		        var startAngle = ref.startAngle;
		        var endAngle = ref.endAngle;
		        var angle = endAngle - startAngle;
		        var result;
	
		        if (reverse) {
		            result = endAngle - (value - min) / (max - min) * angle;
		        } else {
		            result = ((value - min) / (max - min) * angle) + startAngle;
		        }
	
		        return result + GEO_ARC_ADJUST_ANGLE;
		    },
	
		    hasRanges: function() {
		        var ranges = this.options.ranges;
	
		        return ranges && ranges.length;
		    },
	
		    ticksSize: function() {
		        var ref = this.options;
		        var majorTicks = ref.majorTicks;
		        var minorTicks = ref.minorTicks;
		        var size = 0;
		        if (majorTicks.visible) {
		            size = majorTicks.size;
		        }
	
		        if (minorTicks.visible) {
		            size = Math.max(minorTicks.size, size);
		        }
	
		        return size;
		    },
	
		    renderLabels: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var arc = this.arc.clone();
		        var radius = arc.getRadiusX();
		        var tickAngles = this.tickAngles(arc, options.majorUnit);
		        var rangeSize = options.rangeSize = options.rangeSize || radius * 0.1;
		        var labelsGroup = new Group$5();
	
		        var rangeDistance = radius * 0.05;
		        if (defined(options.rangeDistance)) {
		            rangeDistance = options.rangeDistance;
		        } else {
		            options.rangeDistance = rangeDistance;
		        }
	
		        var labelsOptions = options.labels;
		        var isInside = labelsOptions.position === INSIDE;
		        var hasLabelElements = defined(this.labelElements);
	
		        if (isInside) {
		            radius -= this.ticksSize();
	
		            if (this.hasRanges() && !hasLabelElements) {
		                radius -= rangeSize + rangeDistance;
		            }
		            arc.setRadiusX(radius).setRadiusY(radius);
		        }
	
		        var labels = this.labels;
		        var count = labels.length;
		        var padding = labelsOptions.padding;
	
		        for (var i = 0; i < count; i++) {
		            var label = labels[i];
		            var halfWidth = label.box.width() / 2;
		            var halfHeight = label.box.height() / 2;
		            var angle = tickAngles[i];
		            var labelAngle = (angle - GEO_ARC_ADJUST_ANGLE) * DEGREE;
	
		            var lp = arc.pointAt(angle);
		            var cx = lp.x + (Math.cos(labelAngle) * (halfWidth + padding) * (isInside ? 1 : -1));
		            var cy = lp.y + (Math.sin(labelAngle) * (halfHeight + padding) * (isInside ? 1 : -1));
	
		            label.reflow(new Box(cx - halfWidth, cy - halfHeight, cx + halfWidth, cy + halfHeight));
		            var labelPos = new GeometryPoint(label.box.x1, label.box.y1);
	
		            var labelElement = (void 0);
		            if (!hasLabelElements) {
		                labelElement = buildLabelElement(label, options.labels);
		                labelsGroup.append(labelElement);
		            } else {
		                labelElement = this$1.labelElements.children[i];
		                var prevLabelPos = labelElement.bbox().origin;
	
		                var labelTransform = labelElement.transform() || transform();
		                labelTransform.translate(labelPos.x - prevLabelPos.x, labelPos.y - prevLabelPos.y);
		                labelElement.transform(labelTransform);
		            }
	
		            this$1.bbox = Rect.union(this$1.bbox, labelElement.bbox());
		        }
	
		        return labelsGroup;
		    },
	
		    repositionRanges: function() {
		        var ranges = this.ranges.children;
	
		        if (ranges.length > 0) {
		            var ref = this.options;
		            var rangeDistance = ref.rangeDistance;
		            var rangeSize = ref.rangeSize;
		            var rangeRadius = this.getRangeRadius();
	
		            if (this.options.labels.position === INSIDE) {
		                rangeRadius += rangeSize + rangeDistance;
		            }
	
		            var newRadius = rangeRadius + (rangeSize / 2);
	
		            for (var i = 0; i < ranges.length; i++) {
		                ranges[i]._geometry.setRadiusX(newRadius).setRadiusY(newRadius);
		            }
	
		            this.bbox = Rect.union(this.bbox, this.ranges.bbox());
		        }
		    },
	
		    renderRanges: function() {
		        var this$1 = this;
	
		        var segments = this.rangeSegments();
		        var segmentsCount = segments.length;
		        var result = new Group$5();
	
		        if (segmentsCount) {
		            var ref = this.options;
		            var rangeSize = ref.rangeSize;
		            var reverse = ref.reverse;
		            var rangeDistance = ref.rangeDistance;
		            var rangeRadius = this.getRangeRadius();
	
		            // move the ticks with a range distance and a range size
		            this.radius(this.radius() - rangeSize - rangeDistance);
	
		            for (var i = 0; i < segmentsCount; i++) {
		                var segment = segments[i];
		                var from = this$1.slotAngle(segment[reverse ? "to" : "from"]);
		                var to = this$1.slotAngle(segment[!reverse ? "to" : "from"]);
	
		                if (to - from !== 0) {
		                    result.append(this$1.createRange(from, to, rangeRadius, segment));
		                }
		            }
		        }
	
		        return result;
		    },
	
		    createRange: function(startAngle, endAngle, rangeRadius, options) {
		        var rangeSize = this.options.rangeSize;
		        var rangeGeom = new geometry.Arc(this.arc.center, {
		            radiusX: rangeRadius + (rangeSize / 2),
		            radiusY: rangeRadius + (rangeSize / 2),
		            startAngle: startAngle,
		            endAngle: endAngle
		        });
	
		        return new Arc(rangeGeom, {
		            stroke: {
		                width: rangeSize,
		                color: options.color,
		                opacity: options.opacity,
		                lineCap: options.lineCap
		            }
		        });
		    },
	
		    rangeSegments: function() {
		        var options = this.options;
		        var ranges = options.ranges || [];
		        var count = ranges.length;
		        var segments = [];
	
		        if (count) {
		            var min = options.min;
		            var max = options.max;
		            var defaultColor = options.rangePlaceholderColor;
		            segments.push(rangeSegment(min, max, defaultColor));
	
		            for (var i = 0; i < count; i++) {
		                var range = getRange(ranges[i], min, max);
		                var segmentsCount = segments.length;
	
		                for (var j = 0; j < segmentsCount; j++) {
		                    var segment = segments[j];
	
		                    if (segment.from <= range.from && range.from <= segment.to) {
		                        segments.push(rangeSegment(range.from, range.to, range.color, range.opacity));
	
		                        if (segment.from <= range.to && range.to <= segment.to) {
		                            segments.push(rangeSegment(range.to, segment.to, defaultColor, range.opacity));
		                        }
	
		                        segment.to = range.from;
	
		                        break;
		                    }
		                }
		            }
		        }
	
		        return segments;
		    },
	
		    getRangeRadius: function() {
		        var ref = this;
		        var arc = ref.arc;
		        var options = ref.options;
		        var rangeSize = options.rangeSize;
		        var rangeDistance = options.rangeDistance;
		        var majorTickSize = options.majorTicks.size;
		        var radius;
	
		        if (options.labels.position === OUTSIDE) {
		            radius = arc.getRadiusX() - majorTickSize - rangeDistance - rangeSize;
		        } else {
		            radius = arc.getRadiusX() - rangeSize;
		        }
	
		        return radius;
		    },
	
		    renderArc: function(center, radius) {
		        var options = this.options;
	
		        var arc = this.arc = new geometry.Arc(center, {
		            radiusX: radius,
		            radiusY: radius,
		            startAngle: options.startAngle + GEO_ARC_ADJUST_ANGLE,
		            endAngle: options.endAngle + GEO_ARC_ADJUST_ANGLE
		        });
	
		        return arc;
		    },
	
		    renderTicks: function() {
		        var ref = this;
		        var arc = ref.arc;
		        var options = ref.options;
		        var tickArc = arc.clone();
	
		        this.majorTickAngles = this.tickAngles(arc, options.majorUnit);
		        this.majorTicks = drawTicks(tickArc, this.majorTickAngles, options.majorUnit, options.majorTicks);
	
		        var allTicks = new Group$5();
		        allTicks.append(this.majorTicks);
	
		        var majorTickSize = options.majorTicks.size;
		        var minorTickSize = options.minorTicks.size;
	
		        this._tickDifference = majorTickSize - minorTickSize;
	
		        if (options.labels.position === OUTSIDE) {
		            var radius = tickArc.getRadiusX();
		            tickArc.setRadiusX(radius - majorTickSize + minorTickSize)
		                   .setRadiusY(radius - majorTickSize + minorTickSize);
		        }
	
		        this.minorTickAngles = this.normalizeTickAngles(this.tickAngles(arc, options.minorUnit));
		        this.minorTicks = drawTicks(tickArc, this.minorTickAngles, options.minorUnit, options.minorTicks);
		        allTicks.append(this.minorTicks);
	
		        return allTicks;
		    },
	
		    normalizeTickAngles: function(angles) {
		        var options = this.options;
		        var skip = options.majorUnit / options.minorUnit;
	
		        for (var i = angles.length - 1; i >= 0; i--) {
		            if (i % skip === 0) {
		                angles.splice(i, 1);
		            }
		        }
	
		        return angles;
		    },
	
		    tickAngles: function(ring, stepValue) {
		        var options = this.options;
		        var reverse = options.reverse;
		        var range = options.max - options.min;
		        var angle = ring.endAngle - ring.startAngle;
		        var tickCount = range / stepValue;
		        var pos = ring.startAngle;
		        var step = angle / tickCount;
	
		        if (reverse) {
		            pos += angle;
		            step = -step;
		        }
	
		        var positions = [];
		        for (var i = 0; i < tickCount; i++) {
		            positions.push(round(pos, COORD_PRECISION));
		            pos += step;
		        }
	
		        if (round(pos) <= ring.endAngle) {
		            positions.push(pos);
		        }
	
		        return positions;
		    },
	
		    radius: function(value) {
		        if (value) {
		            this.arc.setRadiusX(value).setRadiusY(value);
		            this.repositionTicks(this.majorTicks.children, this.majorTickAngles);
		            this.repositionTicks(this.minorTicks.children, this.minorTickAngles, true);
		        } else {
		            return this.arc.getRadiusX();
		        }
		    },
	
		    repositionTicks: function(ticks, tickAngles, minor) {
		        var diff = minor ? (this._tickDifference || 0) : 0;
		        var tickArc = this.arc;
		        var radius = tickArc.getRadiusX();
	
		        if (minor && this.options.labels.position === OUTSIDE && diff !== 0) {
		            tickArc = this.arc.clone();
		            tickArc.setRadiusX(radius - diff).setRadiusY(radius - diff);
		        }
	
		        for (var i = 0; i < ticks.length; i++) {
		            var newPoint = tickArc.pointAt(tickAngles[i]);
		            var segments = ticks[i].segments;
		            var xDiff = newPoint.x - segments[0].anchor().x;
		            var yDiff = newPoint.y - segments[0].anchor().y;
	
		            ticks[i].transform(new transform().translate(xDiff, yDiff));
		        }
		    }
		});
	
		setDefaultOptions(RadialScale, {
		    min: 0,
		    max: 100,
	
		    majorTicks: {
		        size: 15,
		        align: INSIDE,
		        color: BLACK,
		        width: DEFAULT_LINE_WIDTH,
		        visible: true
		    },
	
		    minorTicks: {
		        size: 10,
		        align: INSIDE,
		        color: BLACK,
		        width: DEFAULT_LINE_WIDTH,
		        visible: true
		    },
	
		    startAngle: -30,
		    endAngle: 210,
	
		    labels: {
		        position: INSIDE,
		        padding: 2
		    }
		});
	
		var RadialPointerAnimation = Animation.extend({
		    init: function(element, options) {
		        Animation.fn.init.call(this, element, options);
	
		        var animationOptions = this.options;
	
		        animationOptions.duration = Math.max((Math.abs(animationOptions.newAngle - animationOptions.oldAngle) / animationOptions.duration) * 1000, 1);
		    },
	
		    step: function(pos) {
		        var options = this.options;
		        var angle = interpolateValue(options.oldAngle, options.newAngle, pos);
	
		        this.element.transform(transform().rotate(angle, options.center));
		    }
		});
	
		setDefaultOptions(RadialPointerAnimation, {
		    easing: LINEAR,
		    duration: ANGULAR_SPEED
		});
	
		AnimationFactory.current.register(RADIAL_POINTER, RadialPointerAnimation);
	
		var CAP_SIZE = 0.05;
		var Circle = drawing.Circle;
		var Group$6 = DrawingGroup;
		var Path$6 = DrawingPath;
	
		var RadialPointer = Pointer.extend({
		    setAngle: function(angle) {
		        this.elements.transform(transform().rotate(angle, this.center));
		    },
	
		    repaint: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var oldAngle = scale.slotAngle(options._oldValue);
		        var newAngle = scale.slotAngle(options.value);
	
		        if (options.animation.transitions === false) {
		            this.setAngle(newAngle);
		        } else {
		            new RadialPointerAnimation(this.elements, deepExtend(options.animation, {
		                oldAngle: oldAngle,
		                newAngle: newAngle
		            })).play();
		        }
		    },
	
		    render: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var elements = new Group$6();
	
		        if (options.animation !== false) {
		            deepExtend(options.animation, {
		                startAngle: 0,
		                center: scale.arc.center,
		                reverse: scale.options.reverse
		            });
		        }
	
		        elements.append(this._renderNeedle(), this._renderCap());
	
		        this.elements = elements;
		        this.setAngle(DEGREE);
	
		        return elements;
		    },
	
		    reflow: function(arc) {
		        var center = this.center = arc.center;
		        var length = limitValue(this.options.length || 1, 0.1, 1.5);
		        var radius = this.radius = arc.getRadiusX() * length;
		        var capSize = this.capSize = Math.round(radius * this.options.cap.size);
	
		        this.bbox = Rect.fromPoints(new GeometryPoint(center.x - capSize, center.y - capSize),
		                                    new GeometryPoint(center.x + capSize, center.y + capSize));
		    },
	
		    _renderNeedle: function() {
		        var minorTickSize = this.scale.options.minorTicks.size;
		        var center = this.center;
		        var needleColor = this.options.color;
	
		        var needlePath = new Path$6({
		            fill: { color: needleColor },
		            stroke: { color: needleColor, width: DEFAULT_LINE_WIDTH }
		        });
	
		        needlePath.moveTo(center.x + this.radius - minorTickSize, center.y)
		                  .lineTo(center.x, center.y - (this.capSize / 2))
		                  .lineTo(center.x, center.y + (this.capSize / 2))
		                  .close();
	
		        return needlePath;
		    },
	
		    _renderCap: function() {
		        var options = this.options;
		        var capColor = options.cap.color || options.color;
		        var circle = new geometry.Circle(this.center, this.capSize);
	
		        var cap = new Circle(circle, {
		            fill: { color: capColor },
		            stroke: { color: capColor }
		        });
	
		        return cap;
		    }
		});
	
		setDefaultOptions(RadialPointer, {
		    cap: {
		        size: CAP_SIZE
		    },
		    arrow: {
		        width: 16,
		        height: 14
		    },
		    animation: {
		        type: RADIAL_POINTER,
		        duration: ANGULAR_SPEED
		    }
		});
	
		var Group$4 = DrawingGroup;
	
		var RadialGauge = Gauge.extend({
		    reflow: function(bbox) {
		        var this$1 = this;
	
		        var pointers = this.pointers;
		        this.scale.reflow(bbox);
		        this._initialPlotArea = this.scale.bbox;
	
		        for (var i = 0; i < pointers.length; i++) {
		            pointers[i].reflow(this$1.scale.arc);
		            this$1._initialPlotArea = Rect.union(this$1._initialPlotArea, pointers[i].bbox);
		        }
	
		        this.fitScale(bbox);
		        this.alignScale(bbox);
		        this._buildVisual(this.gaugeArea, pointers, this.scale);
		        this._draw();
		    },
	
		    _buildVisual: function(gaugeArea, pointers, scale) {
		        var visuals = this._visuals = new Group$4();
	
		        visuals.append(gaugeArea);
		        visuals.append(scale.ticks);
		        visuals.append(scale.ranges);
		        this._buildPointers(pointers);
		        visuals.append(scale.labelElements);
		    },
	
		    _buildPointers: function(pointers) {
		        var this$1 = this;
	
		        for (var i = 0; i < pointers.length; i++) {
		            var current = pointers[i];
		            current.render();
		            this$1._visuals.append(current.elements);
	
		            current.value(current.options.value);
		        }
		    },
	
		    fitScale: function(bbox) {
		        var this$1 = this;
	
		        var arc = this.scale.arc;
		        var plotAreaBox = this._initialPlotArea;
		        var step = Math.abs(this.getDiff(plotAreaBox, bbox));
		        var min = round(step, COORD_PRECISION);
		        var max = round(-step, COORD_PRECISION);
		        var minDiff, midDiff, maxDiff, mid, oldDiff;
		        var staleFlag = 0;
		        var i = 0;
	
		        while (i++ < 100) {
		            staleFlag = (oldDiff === maxDiff) ? (staleFlag + 1) : 0;
	
		            if (staleFlag > 5) {
		                break;
		            }
	
		            if (min !== mid) {
		                minDiff = this$1.getPlotBox(min, bbox, arc);
		                if (0 <= minDiff && minDiff <= 2) {
		                    break;
		                }
		            }
	
		            if (max !== mid) {
		                maxDiff = this$1.getPlotBox(max, bbox, arc);
		                if (0 <= maxDiff && maxDiff <= 2) {
		                    break;
		                }
		            }
	
		            if (minDiff > 0 && maxDiff > 0) {
		                mid = min * 2;
		            } else if (minDiff < 0 && maxDiff < 0) {
		                mid = max * 2;
		            } else {
		                mid = round(((min + max) / 2) || 1, COORD_PRECISION);
		            }
	
		            midDiff = this$1.getPlotBox(mid, bbox, arc);
		            if (0 <= midDiff && midDiff <= 2) {
		                break;
		            }
	
		            oldDiff = maxDiff;
	
		            if (midDiff > 0) {
		                max = mid;
		                maxDiff = midDiff;
		            } else {
		                min = mid;
		                minDiff = midDiff;
		            }
		        }
		    },
	
		    getPlotBox: function(step, bbox, arc) {
		        var this$1 = this;
	
		        var scale = this.scale;
		        var pointers = this.pointers;
		        var radius = arc.getRadiusX();
		        var scaleArc = arc.clone();
	
		        scaleArc.setRadiusX(radius + step).setRadiusY(radius + step);
	
		        scale.arc = scaleArc;
		        scale.reflow(bbox);
		        this.plotBbox = scale.bbox;
	
		        for (var i = 0; i < pointers.length; i++) {
		            pointers[i].reflow(scaleArc);
		            this$1.plotBbox = Rect.union(this$1.plotBbox, pointers[i].bbox);
		        }
	
		        return this.getDiff(this.plotBbox, bbox);
		    },
	
		    getDiff: function(plotBox, box) {
		        return Math.min(box.width() - plotBox.width(), box.height() - plotBox.height());
		    },
	
		    alignScale: function(bbox) {
		        var this$1 = this;
	
		        var plotBoxCenter = this.plotBbox.center();
		        var boxCenter = bbox.center();
		        var paddingX = plotBoxCenter.x - boxCenter.x;
		        var paddingY = plotBoxCenter.y - boxCenter.y;
		        var ref = this;
		        var scale = ref.scale;
		        var pointers = ref.pointers;
	
		        scale.arc.center.x -= paddingX;
		        scale.arc.center.y -= paddingY;
	
		        scale.reflow(bbox);
	
		        for (var i = 0; i < pointers.length; i++) {
		            pointers[i].reflow(scale.arc);
		            this$1.plotBbox = Rect.union(scale.bbox, pointers[i].bbox);
		        }
		    },
	
		    _createModel: function() {
		        var this$1 = this;
	
		        var options = this.options;
		        var pointers = options.pointer;
		        var scale = this.scale = new RadialScale(options.scale, this.contextService);
	
		        this.pointers = [];
	
		        var pointersArr = isArray(pointers) ? pointers : [ pointers ];
		        for (var i = 0; i < pointersArr.length; i++) {
		            var current = new RadialPointer(scale, deepExtend({}, pointersArr[i], {
		                animation: {
		                    transitions: options.transitions
		                }
		            }));
	
		            this$1.pointers.push(current);
		        }
		    }
		});
	
		setDefaultOptions(RadialGauge, {
		    transitions: true,
		    gaugeArea: {
		        background: ""
		    }
		});
	
		var ArcScale = RadialScale.extend({
		    rangeSegments: function() {
		        var ref = this.options;
		        var min = ref.min;
		        var max = ref.max;
		        var rangePlaceholderColor = ref.rangePlaceholderColor;
		        var rangeLineCap = ref.rangeLineCap;
	
		        return [ { from: min, to: max, color: rangePlaceholderColor, lineCap: rangeLineCap } ];
		    },
	
		    hasRanges: function() {
		        return true;
		    },
	
		    placeholderRangeAngle: function(angle) {
		        var geometry$$1 = this.ranges.children[0].geometry();
	
		        if (this.options.reverse) {
		            geometry$$1.setEndAngle(angle);
		        } else {
		            geometry$$1.setStartAngle(angle);
		        }
		    },
	
		    addRange: function(from, to, options) {
		        var reverse = this.options.reverse;
	
		        var startAngle = this.slotAngle(reverse ? to : from);
		        var endAngle = this.slotAngle(reverse ? from : to);
	
		        var range = this.createRange(startAngle, endAngle, this.getRangeRadius(), options);
	
		        this.ranges.append(range);
	
		        return range;
		    }
		});
	
		setDefaultOptions(ArcScale, {
		    min: 0,
		    max: 100,
	
		    majorTicks: {
		        visible: false
		    },
	
		    minorTicks: {
		        visible: false
		    },
	
		    labels: {
		        visible: false
		    },
	
		    startAngle: 0,
		    endAngle: 180,
		    rangeLineCap: 'round'
		});
	
		var MAX_DURATION = 800;
	
		var RangePointerAnimation = Animation.extend({
		    init: function(element, options) {
		        Animation.fn.init.call(this, element, options);
	
		        var animationOptions = this.options;
		        var duration = (Math.abs(animationOptions.newAngle - animationOptions.oldAngle) / animationOptions.duration) * 1000;
		        animationOptions.duration = limitValue(duration, ANGULAR_SPEED, MAX_DURATION);
	
		        var startColor = element.elements.options.get("stroke.color");
		        var color = element.currentColor();
		        if (startColor !== color) {
		            this.startColor = new kendo.Color(startColor);
		            this.color = new kendo.Color(color);
		        }
		    },
	
		    step: function(pos) {
		        var ref = this;
		        var options = ref.options;
		        var startColor = ref.startColor;
		        var color = ref.color;
		        var angle = interpolateValue(options.oldAngle, options.newAngle, pos);
		        this.element.angle(angle);
	
		        if (color) {
		            var r = round(interpolateValue(startColor.r, color.r, pos));
		            var g = round(interpolateValue(startColor.g, color.g, pos));
		            var b = round(interpolateValue(startColor.b, color.b, pos));
	
		            this.element.stroke(new kendo.Color(r, g, b).toHex());
		        }
		    }
		});
	
		setDefaultOptions(RangePointerAnimation, {
		    easing: LINEAR,
		    duration: ANGULAR_SPEED
		});
	
		AnimationFactory.current.register(RADIAL_RANGE_POINTER, RangePointerAnimation);
	
		var RangePointer = Pointer.extend({
		    repaint: function() {
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
		        var oldAngle = scale.slotAngle(options._oldValue);
		        var newAngle = scale.slotAngle(options.value);
	
		        if (this.animation) {
		            this.animation.abort();
		        }
	
		        if (options.animation.transitions === false) {
		            this.angle(newAngle);
		            this.stroke(this.currentColor());
		        } else {
		            this.animation = new RangePointerAnimation(this, deepExtend(options.animation, {
		                oldAngle: oldAngle,
		                newAngle: newAngle
		            }));
	
		            this.animation.play();
		        }
		    },
	
		    angle: function(value) {
		        var geometry$$1 = this.elements.geometry();
		        if (this.scale.options.reverse) {
		            geometry$$1.setStartAngle(value);
		        } else {
		            geometry$$1.setEndAngle(value);
		        }
		        this.scale.placeholderRangeAngle(value);
		    },
	
		    stroke: function(value) {
		        this.elements.stroke(value);
		    },
	
		    render: function() {
		        if (this.elements) {
		            return;
		        }
	
		        var ref = this;
		        var scale = ref.scale;
		        var options = ref.options;
	
		        if (options.animation !== false) {
		            deepExtend(options.animation, {
		                startAngle: 0,
		                center: scale.arc.center,
		                reverse: scale.options.reverse
		            });
		        }
	
		        this.elements = scale.addRange(scale.options.min, this.options.value, {
		            color: this.currentColor(),
		            opacity: options.opacity,
		            lineCap: scale.options.rangeLineCap
		        });
		    },
	
		    currentColor: function() {
		        var ref = this.scale.options;
		        var min = ref.min;
		        var max = ref.max;
		        var ref$1 = this.options;
		        var colors = ref$1.colors;
		        var color = ref$1.color;
		        var value = ref$1.value;
		        var currentValue = dataviz.isNumber(value) ? value : min;
	
		        if (colors) {
		            for (var idx = 0; idx < colors.length; idx++) {
		                var ref$2 = colors[idx];
		                var rangeColor = ref$2.color;
		                var from = ref$2.from; if (from === void 0) { from = min; }
		                var to = ref$2.to; if (to === void 0) { to = max; }
	
		                if (from <= currentValue && currentValue <= to) {
		                    return rangeColor;
		                }
		            }
		        }
	
		        return color;
		    },
	
		    reflow: function() {
		        this.render();
	
		        this.bbox = this.elements.bbox();
		    }
		});
	
		setDefaultOptions(RangePointer, {
		    animation: {
		        type: RADIAL_RANGE_POINTER,
		        duration: ANGULAR_SPEED
		    }
		});
	
		var ArcGauge = RadialGauge.extend({
		    _initTheme: function(theme) {
		        RadialGauge.fn._initTheme.call(this, theme);
	
		        this.options.color = this.options.color || (this.theme.pointer || {}).color;
		    },
	
		    _createModel: function() {
		        var options = this.options;
		        var scale = this.scale = new ArcScale(options.scale, this.contextService);
	
		        var pointer = new RangePointer(scale, deepExtend({}, {
		            colors: options.colors,
		            color: options.color,
		            value: options.value,
		            opacity: options.opacity,
		            animation: {
		                transitions: options.transitions
		            }
		        }));
	
		        this.pointers = [ pointer ];
		    },
	
		    _buildPointers: function(pointers) {
		        for (var i = 0; i < pointers.length; i++) {
		            var current = pointers[i];
		            current.render();
	
		            current.value(current.options.value);
		        }
		    },
	
		    _setValueOptions: function(value) {
		        this.options.value = value;
		    },
	
		    currentColor: function() {
		        var pointer = this.pointers[0];
		        if (pointer) {
		            return pointer.currentColor();
		        }
		    },
	
		    centerLabelPosition: function(width, height) {
		        var size = this.getSize();
		        var center = this.scale.arc.center;
	
		        var left = center.x - width / 2;
		        var top = center.y - height / 2;
	
		        if (width < size.width) {
		            var right = left + width;
	
		            left = Math.max(left, 0);
	
		            if (right > size.width) {
		                left -= right - size.width;
		            }
		        }
	
		        if (height < size.height) {
		            var bbox = this.scale.bbox;
		            var yLimit = bbox.bottomRight().y;
		            var bottom = top + height;
	
		            top = Math.max(top, bbox.origin.y);
	
		            if (bottom > yLimit) {
		                top -= bottom - yLimit;
		            }
		        }
	
		        return {
		            left: left,
		            top: top
		        };
		    }
		});
	
		kendo.deepExtend(kendo.dataviz, {
		    Gauge: Gauge,
		    LinearGauge: LinearGauge,
		    LinearPointer: LinearPointer,
		    ArrowLinearPointer: ArrowLinearPointer,
		    BarLinearPointer: BarLinearPointer,
		    LinearScale: LinearScale,
		    RadialGauge: RadialGauge,
		    RadialPointer: RadialPointer,
		    RadialScale: RadialScale,
		    ArcGauge: ArcGauge,
		    RangePointer: RangePointer,
		    ArcScale: ArcScale
		});
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1072);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1000:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 1060:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 1072:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1060), __webpack_require__(1000) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.barcode",
		    name: "Barcode",
		    category: "dataviz",
		    description: "Barcode widget",
		    depends: [ "dataviz.core" ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
	
		        extend = $.extend,
		        deepExtend = kendo.deepExtend,
		        inArray = $.inArray,
		        isPlainObject = $.isPlainObject,
	
		        draw = kendo.drawing,
		        geom = kendo.geometry,
		        util = kendo.drawing.util,
		        defined = util.defined,
		        dataviz = kendo.dataviz,
		        Box2D = dataviz.Box2D,
		        TextBox = dataviz.TextBox,
		        DEFAULT_WIDTH = 300,
		        DEFAULT_HEIGHT = 100,
		        DEFAULT_QUIETZONE_LENGTH = 10,
		        numberRegex = /^\d+$/,
		        alphanumericRegex = /^[a-z0-9]+$/i,
		        InvalidCharacterErrorTemplate = "Character '{0}' is not valid for symbology {1}";
	
		    function getNext(value, index, count){
		        return value.substring(index, index + count);
		    }
	
		    var Encoding  = kendo.Class.extend({
		        init: function (options) {
		            this.setOptions(options);
		        },
		        setOptions: function(options){
		            var that = this;
		            that.options = extend({}, that.options, options);
		            that.quietZoneLength = that.options.addQuietZone ? 2 * that.options.quietZoneLength : 0;
		        },
		        encode: function (value, width, height) {
		            var that = this;
		            if (defined(value)) {
		                value+='';
		            }
	
		            that.initValue(value, width, height);
	
		            if (that.options.addQuietZone) {
		                that.addQuietZone();
		            }
	
		            that.addData();
	
		            if (that.options.addQuietZone) {
		                that.addQuietZone();
		            }
	
		            return {
		                baseUnit: that.baseUnit,
		                pattern: that.pattern
		            };
		        },
		        options: {
		            quietZoneLength: DEFAULT_QUIETZONE_LENGTH,
		            addQuietZone: true,
		            addCheckSum: true
		        },
		        initValue: function () {},
		        addQuietZone: function () {
		            this.pattern.push(this.options.quietZoneLength || DEFAULT_QUIETZONE_LENGTH);
		        },
		        addData: function () {
		        },
		        invalidCharacterError: function(character){
		            throw new Error(kendo.format(InvalidCharacterErrorTemplate, character, this.name));
		        }
		    });
	
		    var encodings = {};
	
		    var code39Base = Encoding.extend({
		        minBaseUnitLength: 0.7,
		        addData: function(){
		            var that = this,
		                value  = that.value;
	
		            that.addStart();
	
		            for(var idx = 0; idx < value.length; idx++){
		                that.addCharacter(value.charAt(idx));
		            }
	
		            if(that.options.addCheckSum){
		                that.pushCheckSum();
		            }
	
		            that.addStop();
		            that.prepareValues();
		        },
		        addCharacter: function(character){
		            var that = this,
		                charData = that.characterMap[character];
		            if(!charData){
		                that.invalidCharacterError(character);
		            }
		            that.addBase(charData);
		        },
		        addBase: function(){}
		    });
	
		    var code39ExtendedBase = {
		        addCharacter: function(character){
		            var that = this;
		            if(that.characterMap[character]){
		                that.addBase(that.characterMap[character]);
		            }
		            else if(character.charCodeAt(0) > 127){
		                that.invalidCharacterError(character);
		            }
		            else{
		                that.addExtended(character.charCodeAt(0));
		            }
		        },
		        addExtended: function(code){
		            var that = this,
		                patterns;
		            for(var i = 0; i < that.extendedMappings.length; i++){
		                if((patterns = that.extendedMappings[i].call(that, code))){
		                    for(var j = 0; j < patterns.length; j++){
		                        that.addBase(patterns[j]);
		                    }
		                    that.dataLength+= patterns.length - 1;
		                    return;
		                }
		            }
		        },
		        extendedMappings: [
		            function(code){
		                if(97 <= code && code <= 122){
		                    var that = this;
		                    return [that.characterMap[that.shiftCharacters[0]], that.characterMap[String.fromCharCode(code - 32)]];
		                }
		            },
		            function(code){
		                if(33 <= code && code <= 58){
		                    var that = this;
		                    return [that.characterMap[that.shiftCharacters[1]], that.characterMap[String.fromCharCode(code + 32)]];
		                }
		            },
		            function(code){
		                if(1 <= code && code <= 26){
		                    var that = this;
		                    return [that.characterMap[that.shiftCharacters[2]], that.characterMap[String.fromCharCode(code + 64)]];
		                }
		            },
		            function(code){
		                var that = this,
		                    result,
		                    dataCharacter;
		                if(!that.specialAsciiCodes[code]){
		                    dataCharacter =  Math.floor(code / 32) * 6 + (code - 27) % 32 + 64;
		                    result = [that.characterMap[that.shiftCharacters[3]], that.characterMap[String.fromCharCode(dataCharacter)]];
		                }
		                else{
		                    result = [];
		                    for(var i = 0; i < that.specialAsciiCodes[code].length; i++){
		                        result.push(that.characterMap[that.shiftCharacters[3]]);
		                        result.push(that.characterMap[that.specialAsciiCodes[code][i]]);
		                    }
		                }
	
		                return result;
		            }
		        ],
		        specialAsciiCodes: {
		            "0": ["U"],
		            "64": ["V"],
		            "96": ["W"],
		            "127": ["T","X","Y","Z"]
		        },
		        shiftValuesAsciiCodes:{
		            "39": 36,
		            "40": 47,
		            "41": 43,
		            "42": 37
		        },
		        characterMap: {
		            "+": false,
		            "/": false,
		            "$": false,
		            "%": false
		        },
		        shiftCharacters: ["SHIFT0", "SHIFT1", "SHIFT2", "SHIFT3"]
		    };
	
		    encodings.code39 =  code39Base.extend({
		        name: "Code 39",
		        checkSumMod: 43,
		        minRatio: 2.5,
		        maxRatio: 3,
		        gapWidth: 1,
		        splitCharacter: "|",
		        initValue: function (value, width, height) {
		            var that = this;
		            that.width = width;
		            that.height = height;
		            that.value = value;
		            that.dataLength = value.length;
		            that.pattern = [];
		            that.patternString = "";
		        },
		        prepareValues: function(){
		            var that = this,
		                baseUnit,
		                minBaseUnit = that.minBaseUnitLength,
		                ratio = that.maxRatio,
		                minRatio = that.minRatio,
		                minHeight = Math.max(0.15 * that.width, 24);
		            if (that.height < minHeight) {
		                throw new Error("Insufficient Height. The minimum height for value: " + that.value + " is: " + minHeight);
		            }
	
		            while((baseUnit = that.getBaseUnit(ratio)) < minBaseUnit && ratio > minRatio){
		                ratio = parseFloat((ratio - 0.1).toFixed(1));
		            }
	
		            if(baseUnit < minBaseUnit){
		                var minWidth = Math.ceil(that.getBaseWidth(minRatio) * minBaseUnit);
		                throw new Error("Insufficient width. The minimum width for value: " + that.value + " is: " + minWidth);
		            }
	
		            that.ratio = ratio;
		            that.baseUnit = baseUnit;
		            that.patternString = that.patternString.substring(0, that.patternString.length - 1);
		            that.pattern = that.pattern.concat(that.patternString.replace(/ratio/g, ratio).split(that.splitCharacter));
		        },
		        getBaseUnit: function(ratio){
		            return this.width / this.getBaseWidth(ratio);
		        },
		        getBaseWidth: function(ratio){
		            var that = this,
		                characterLength = 3 * (ratio + 2);
		            return that.quietZoneLength + characterLength * (that.dataLength + 2) + that.gapWidth * (that.dataLength + 1);
		        },
		        addStart: function () {
		            var that = this;
		            that.addPattern(that.characterMap.START.pattern);
		            that.addCharacterGap();
		        },
		        addBase: function(character){
		            this.addPattern(character.pattern);
		            this.addCharacterGap();
		        },
		        addStop: function () {
		            this.addPattern(this.characterMap.START.pattern);
		        },
		        addPattern: function (pattern) {
		            for (var i = 0; i < pattern.length; i++) {
		                 this.patternString+= this.patternMappings[pattern.charAt(i)];
		            }
		        },
		        addCharacterGap: function () {
		            var that = this;
		            that.patternString+=that.gapWidth + that.splitCharacter;
		        },
		        patternMappings: {
		            "b": "1|",
		            "w": "1|",
		            "B": "ratio|",
		            "W": "ratio|"
		        },
		        characterMap: {
		            "0":{"pattern":"bwbWBwBwb","value":0},
		            "1":{"pattern":"BwbWbwbwB","value":1},
		            "2":{"pattern":"bwBWbwbwB","value":2},
		            "3":{"pattern":"BwBWbwbwb","value":3},
		            "4":{"pattern":"bwbWBwbwB","value":4},
		            "5":{"pattern":"BwbWBwbwb","value":5},
		            "6":{"pattern":"bwBWBwbwb","value":6},
		            "7":{"pattern":"bwbWbwBwB","value":7},
		            "8":{"pattern":"BwbWbwBwb","value":8},
		            "9":{"pattern":"bwBWbwBwb","value":9},
		            "A":{"pattern":"BwbwbWbwB","value":10},
		            "B":{"pattern":"bwBwbWbwB","value":11},
		            "C":{"pattern":"BwBwbWbwb","value":12},
		            "D":{"pattern":"bwbwBWbwB","value":13},
		            "E":{"pattern":"BwbwBWbwb","value":14},
		            "F":{"pattern":"bwBwBWbwb","value":15},
		            "G":{"pattern":"bwbwbWBwB","value":16},
		            "H":{"pattern":"BwbwbWBwb","value":17},
		            "I":{"pattern":"bwBwbWBwb","value":18},
		            "J":{"pattern":"bwbwBWBwb","value":19},
		            "K":{"pattern":"BwbwbwbWB","value":20},
		            "L":{"pattern":"bwBwbwbWB","value":21},
		            "M":{"pattern":"BwBwbwbWb","value":22},
		            "N":{"pattern":"bwbwBwbWB","value":23},
		            "O":{"pattern":"BwbwBwbWb","value":24},
		            "P":{"pattern":"bwBwBwbWb","value":25},
		            "Q":{"pattern":"bwbwbwBWB","value":26},
		            "R":{"pattern":"BwbwbwBWb","value":27},
		            "S":{"pattern":"bwBwbwBWb","value":28},
		            "T":{"pattern":"bwbwBwBWb","value":29},
		            "U":{"pattern":"BWbwbwbwB","value":30},
		            "V":{"pattern":"bWBwbwbwB","value":31},
		            "W":{"pattern":"BWBwbwbwb","value":32},
		            "X":{"pattern":"bWbwBwbwB","value":33},
		            "Y":{"pattern":"BWbwBwbwb","value":34},
		            "Z":{"pattern":"bWBwBwbwb","value":35},
		            "-":{"pattern":"bWbwbwBwB","value":36},
		            ".":{"pattern":"BWbwbwBwb","value":37},
		            " ":{"pattern":"bWBwbwBwb","value":38},
		            "$":{"pattern":"bWbWbWbwb","value":39},
		            "/":{"pattern":"bWbWbwbWb","value":40},
		            "+":{"pattern":"bWbwbWbWb","value":41},
		            "%":{"pattern":"bwbWbWbWb","value":42},
		            START: { pattern: "bWbwBwBwb"}
		        },
		        options: {
		            addCheckSum: false
		        }
		    });
	
		    encodings.code39extended = encodings.code39.extend(deepExtend({}, code39ExtendedBase, {
		        name: "Code 39 extended",
		        characterMap: {
		            SHIFT0: {"pattern":"bWbwbWbWb","value":41},
		            SHIFT1: {"pattern":"bWbWbwbWb","value":40},
		            SHIFT2: {"pattern":"bWbWbWbwb","value":39},
		            SHIFT3: {"pattern":"bwbWbWbWb","value":42}
		        }
		    }));
	
		    encodings.code93 = code39Base.extend({
		        name: "Code 93",
		        cCheckSumTotal: 20,
		        kCheckSumTotal: 15,
		        checkSumMod: 47,
		        initValue: function(value, width, height){
		            var that = this;
		            that.value = value;
		            that.width = width;
		            that.height = height;
		            that.pattern = [];
		            that.values = [];
		            that.dataLength = value.length;
		        },
		        prepareValues: function(){
		            var that = this,
		                minHeight = Math.max(0.15 * that.width, 24);
		            if (that.height < minHeight) {
		                throw new Error("Insufficient Height");
		            }
	
		            that.setBaseUnit();
	
		            if(that.baseUnit < that.minBaseUnitLength){
		                throw new Error("Insufficient Width");
		            }
		        },
		        setBaseUnit: function(){
		            var that = this,
		                checkSumLength = 2;
		            that.baseUnit = that.width / (9 * (that.dataLength + 2 + checkSumLength) + that.quietZoneLength + 1);
		        },
		        addStart: function(){
		            var pattern = this.characterMap.START.pattern;
		            this.addPattern(pattern);
		        },
		        addStop: function(){
		            var that = this;
		            that.addStart();
		            that.pattern.push(that.characterMap.TERMINATION_BAR);
		        },
		        addBase: function(charData){
		            this.addPattern(charData.pattern);
		            this.values.push(charData.value);
		        },
		        pushCheckSum: function(){
		            var that = this,
		                checkValues = that._getCheckValues(),
		                charData;
	
		            that.checksum = checkValues.join("");
		            for(var i = 0; i < checkValues.length; i++){
		                charData = that.characterMap[that._findCharacterByValue(checkValues[i])];
		                that.addPattern(charData.pattern);
		            }
		        },
		        _getCheckValues: function(){
		            var that = this,
		                values = that.values,
		                length = values.length,
		                wightedSum = 0,
		                cValue,
		                kValue,
		                idx;
	
		            for(idx = length - 1; idx >= 0; idx--){
		                wightedSum += that.weightedValue(values[idx],length - idx, that.cCheckSumTotal);
		            }
		            cValue = wightedSum % that.checkSumMod;
	
		            wightedSum = that.weightedValue(cValue, 1, that.kCheckSumTotal);
		            for(idx = length - 1; idx >= 0; idx--){
		                wightedSum += that.weightedValue(values[idx], length - idx + 1, that.kCheckSumTotal);
		            }
	
		            kValue = wightedSum % that.checkSumMod;
		            return [cValue, kValue];
		        },
		        _findCharacterByValue: function (value) {
		            for (var character in this.characterMap) {
		                if (this.characterMap[character].value === value) {
		                    return character;
		                }
		            }
		        },
		        weightedValue: function(value, index, total){
		            return (index % total || total) * value;
		        },
		        addPattern: function(pattern){
		            var value;
	
		            for(var i = 0; i < pattern.length; i++){
		                value = parseInt(pattern.charAt(i),10);
		                this.pattern.push(value);
		            }
		        },
		        characterMap: {
		            "0":{"pattern":"131112","value":0},
		            "1":{"pattern":"111213","value":1},
		            "2":{"pattern":"111312","value":2},
		            "3":{"pattern":"111411","value":3},
		            "4":{"pattern":"121113","value":4},
		            "5":{"pattern":"121212","value":5},
		            "6":{"pattern":"121311","value":6},
		            "7":{"pattern":"111114","value":7},
		            "8":{"pattern":"131211","value":8},
		            "9":{"pattern":"141111","value":9},
		            "A":{"pattern":"211113","value":10},
		            "B":{"pattern":"211212","value":11},
		            "C":{"pattern":"211311","value":12},
		            "D":{"pattern":"221112","value":13},
		            "E":{"pattern":"221211","value":14},
		            "F":{"pattern":"231111","value":15},
		            "G":{"pattern":"112113","value":16},
		            "H":{"pattern":"112212","value":17},
		            "I":{"pattern":"112311","value":18},
		            "J":{"pattern":"122112","value":19},
		            "K":{"pattern":"132111","value":20},
		            "L":{"pattern":"111123","value":21},
		            "M":{"pattern":"111222","value":22},
		            "N":{"pattern":"111321","value":23},
		            "O":{"pattern":"121122","value":24},
		            "P":{"pattern":"131121","value":25},
		            "Q":{"pattern":"212112","value":26},
		            "R":{"pattern":"212211","value":27},
		            "S":{"pattern":"211122","value":28},
		            "T":{"pattern":"211221","value":29},
		            "U":{"pattern":"221121","value":30},
		            "V":{"pattern":"222111","value":31},
		            "W":{"pattern":"112122","value":32},
		            "X":{"pattern":"112221","value":33},
		            "Y":{"pattern":"122121","value":34},
		            "Z":{"pattern":"123111","value":35},
		            "-":{"pattern":"121131","value":36},
		            ".":{"pattern":"311112","value":37},
		            " ":{"pattern":"311211","value":38},
		            "$":{"pattern":"321111","value":39},
		            "/":{"pattern":"112131","value":40},
		            "+":{"pattern":"113121","value":41},
		            "%":{"pattern":"211131","value":42},
		            SHIFT0:{"pattern":"122211","value":46},
		            SHIFT1:{"pattern":"311121","value":45},
		            SHIFT2:{"pattern":"121221","value":43},
		            SHIFT3:{"pattern":"312111","value":44},
		            START: {"pattern":"111141"},
		            TERMINATION_BAR: "1"
		        }
		    });
	
		    encodings.code93extended = encodings.code93.extend(deepExtend({}, code39ExtendedBase, {
		        name: "Code 93 extended",
		        pushCheckSum: function(){
		            var that = this,
		                checkValues = that._getCheckValues(),
		                value;
	
		            that.checksum = checkValues.join("");
	
		            for(var i = 0; i < checkValues.length; i++){
		                value = checkValues[i];
		                if(that.shiftValuesAsciiCodes[value]){
		                    that.addExtended(that.shiftValuesAsciiCodes[value]);
		                }
		                else{
		                    that.addPattern(that.characterMap[that._findCharacterByValue(value)].pattern);
		                }
		            }
		        }
		    }));
	
		    var state128 = kendo.Class.extend({
		        init: function(encoding){
		            this.encoding = encoding;
		        },
		        addStart: function(){},
		        is: function (){},
		        move: function (){},
		        pushState: function(){}
		    });
	
		    var state128AB = state128.extend({
		        FNC4: "FNC4",
		        init: function(encoding, states){
		            var that = this;
		            that.encoding = encoding;
		            that.states = states;
		            that._initMoves(states);
		        },
		        addStart: function(){
		            this.encoding.addPattern(this.START);
		        },
		        is: function (value, index){
		            var code = value.charCodeAt(index);
		            return this.isCode(code);
		        },
		        move: function(encodingState){
		            var that = this,
		                idx = 0;
	
		            while(!that._moves[idx].call(that, encodingState) && idx < that._moves.length){
		                idx++;
		            }
		        },
		        pushState: function(encodingState){
		            var that = this,
		                states = that.states,
		                value = encodingState.value,
		                maxLength = value.length,
		                code;
	
		            if(inArray("C", states) >= 0){
		                var numberMatch = value.substr(encodingState.index).match(/\d{4,}/g);
		                if(numberMatch){
		                    maxLength = value.indexOf(numberMatch[0], encodingState.index);
		                }
		            }
	
		            while((code = encodingState.value.charCodeAt(encodingState.index)) >= 0 &&
		                that.isCode(code) && encodingState.index < maxLength){
		                that.encoding.addPattern(that.getValue(code));
		                encodingState.index++;
		            }
		        },
		        _initMoves: function(states){
		            var that = this;
		            that._moves = [];
	
		            if(inArray(that.FNC4, states) >= 0){
		                that._moves.push(that._moveFNC);
		            }
	
		            if(inArray(that.shiftKey, states) >= 0){
		                that._moves.push(that._shiftState);
		            }
		            that._moves.push(that._moveState);
		        },
		        _moveFNC: function(encodingState){
		            if(encodingState.fnc){
		                encodingState.fnc = false;
		                return encodingState.previousState == this.key;
		            }
		        },
		        _shiftState: function(encodingState){
		            var that = this;
		            if(encodingState.previousState == that.shiftKey &&
		                (encodingState.index + 1 >= encodingState.value.length ||
		                    that.encoding[that.shiftKey].is(encodingState.value, encodingState.index + 1))){
		                that.encoding.addPattern(that.SHIFT);
		                encodingState.shifted = true;
		                return true;
		            }
		        },
		        _moveState: function(){
		            this.encoding.addPattern(this.MOVE);
		            return true;
		        },
		        SHIFT: 98
		    });
	
		    var states128 = {};
	
		    states128.A = state128AB.extend({
		        key: "A",
		        shiftKey: "B",
		        isCode: function(code){
		            return 0 <= code && code < 96;
		        },
		        getValue: function(code){
		            if(code < 32){
		                return code + 64;
		            }
	
		            return code - 32;
		        },
		        MOVE: 101,
		        START: 103
		    });
	
		    states128.B = state128AB.extend({
		        key: "B",
		        shiftKey: "A",
		        isCode: function(code){
		            return 32 <= code && code < 128;
		        },
		        getValue: function(code){
		            return code - 32;
		        },
		        MOVE: 100,
		        START: 104
		    });
	
		    states128.C = state128.extend({
		        key: "C",
		        addStart: function(){
		            this.encoding.addPattern(this.START);
		        },
		        is: function (value, index){
		            var next4 = getNext(value, index, 4);
		            return (index + 4 <= value.length || value.length == 2) && numberRegex.test(next4);
		        },
		        move: function (){
		            this.encoding.addPattern(this.MOVE);
		        },
		        pushState: function(encodingState){
		            var code;
		            while(( code = getNext(encodingState.value, encodingState.index, 2)) &&
		                numberRegex.test(code) && code.length == 2)
		            {
		                this.encoding.addPattern(parseInt(code, 10));
		                encodingState.index+=2;
		            }
		        },
		        getValue: function(code){
		            return code;
		        },
		        MOVE: 99,
		        START: 105
		    });
	
		    states128.FNC4 = state128.extend({
		        key: "FNC4",
		        dependentStates: ["A","B"],
		        init: function(encoding, states){
		            this.encoding = encoding;
		            this._initSubStates(states);
		        },
		        addStart: function(encodingState){
		            var code = encodingState.value.charCodeAt(0) - 128,
		                subState = this._getSubState(code);
	
		            this.encoding[subState].addStart();
		        },
		        is: function(value, index){
		            var code = value.charCodeAt(index);
		            return this.isCode(code);
		        },
		        isCode: function(code){
		            return 128 <= code && code < 256;
		        },
		        pushState: function(encodingState){
		            var that = this,
		                subState = that._initSubState(encodingState),
		                encoding = that.encoding,
		                length = subState.value.length;
		            encodingState.index += length;
	
		            if(length < 3){
		                var code;
		                for(; subState.index < length; subState.index++){
		                    code = subState.value.charCodeAt(subState.index);
		                    subState.state = that._getSubState(code);
		                    if(subState.previousState != subState.state){
		                        subState.previousState = subState.state;
		                        encoding[subState.state].move(subState);
		                    }
		                    encoding.addPattern(encoding[subState.state].MOVE);
		                    encoding.addPattern(encoding[subState.state].getValue(code));
		                }
		            }
		            else{
		                if(subState.state != subState.previousState){
		                    encoding[subState.state].move(subState);
		                }
		                that._pushStart(subState);
		                encoding.pushData(subState, that.subStates);
		                if(encodingState.index < encodingState.value.length){
		                    that._pushStart(subState);
		                }
		            }
	
		            encodingState.fnc = true;
		            encodingState.state = subState.state;
		        },
		        _pushStart: function(subState){
		            var that = this;
		            that.encoding.addPattern(that.encoding[subState.state].MOVE);
		            that.encoding.addPattern(that.encoding[subState.state].MOVE);
		        },
		        _initSubState: function(encodingState){
		            var that = this,
		                subState = {
		                    value: that._getAll(encodingState.value, encodingState.index),
		                    index: 0
		                };
		            subState.state = that._getSubState(subState.value.charCodeAt(0));
		            subState.previousState = encodingState.previousState == that.key ?
		                subState.state : encodingState.previousState;
		            return subState;
		        },
		        _initSubStates: function(states){
		            var that = this;
		            that.subStates = [];
		            for(var i = 0; i < states.length; i++){
		                if(inArray(states[i], that.dependentStates) >= 0){
		                    that.subStates.push(states[i]);
		                }
		            }
		        },
		        _getSubState: function(code){
		            var that = this;
		            for(var i = 0; i < that.subStates.length; i++){
		                if(that.encoding[that.subStates[i]].isCode(code)){
		                    return that.subStates[i];
		                }
		            }
		        },
		        _getAll: function(value, index){
		            var code,
		                result = "";
		            while((code = value.charCodeAt(index++)) && this.isCode(code)){
		                result += String.fromCharCode(code - 128);
		            }
		            return result;
		        }
		    });
	
		    states128.FNC1 = state128.extend({
		        key: "FNC1",
		        startState: "C",
		        dependentStates: ["C","B"],
		        startAI: "(",
		        endAI: ")",
		        init: function(encoding, states){
		            this.encoding = encoding;
		            this.states = states;
		        },
		        addStart: function(){
		            this.encoding[this.startState].addStart();
		        },
		        is: function(){
		            return inArray(this.key, this.states) >= 0;
		        },
		        pushState: function(encodingState){
		            var that = this,
		                encoding = that.encoding,
		                value = encodingState.value.replace(/\s/g, ""),
		                regexSeparators = new RegExp("[" +  that.startAI + that.endAI + "]", "g"),
		                index = encodingState.index,
		                subState= {
		                    state: that.startState
		                },
		                current,
		                nextStart,
		                separatorLength;
	
		            encoding.addPattern(that.START);
	
		            while(true){
		                subState.index = 0;
	
		                separatorLength = value.charAt(index) === that.startAI ? 2 : 0;
		                current = separatorLength > 0 ? that.getBySeparator(value, index) : that.getByLength(value, index);
		                if(current.ai.length){
		                    nextStart = index + separatorLength + current.id.length + current.ai.length;
		                }
		                else{
		                    nextStart = value.indexOf(that.startAI, index + 1);
		                    if(nextStart < 0){
		                        if(index + current.ai.max + current.id.length + separatorLength < value.length){
		                            throw new Error("Separators are required after variable length identifiers");
		                        }
		                        nextStart = value.length;
		                    }
		                }
		                subState.value = value.substring(index, nextStart).replace(regexSeparators, "");
		                that.validate(current, subState.value);
	
		                encoding.pushData(subState, that.dependentStates);
	
		                if(nextStart >= value.length){
		                    break;
		                }
	
		                index = nextStart;
	
		                if(subState.state != that.startState){
		                    encoding[that.startState].move(subState);
		                    subState.state = that.startState;
		                }
	
		                if(!current.ai.length){
		                    encoding.addPattern(that.START);
		                }
		            }
		            encodingState.index = encodingState.value.length;
		        },
		        validate: function(current, value){
		            var code = value.substr(current.id.length),
		                ai = current.ai;
		            if(!ai.type && !numberRegex.test(code)){
		                throw new Error("Application identifier " + current.id+ " is numeric only but contains non numeric character(s).");
		            }
	
		            if(ai.type == "alphanumeric" && !alphanumericRegex.test(code)){
		                 throw new Error("Application identifier " + current.id+ " is alphanumeric only but contains non alphanumeric character(s).");
		            }
	
		            if(ai.length && ai.length !== code.length){
		                 throw new Error("Application identifier " + current.id + " must be " + ai.length + " characters long.");
		            }
	
		            if(ai.min && ai.min > code.length){
		                 throw new Error("Application identifier " + current.id + " must be at least " + ai.min + " characters long.");
		            }
	
		            if(ai.max && ai.max < code.length){
		                 throw new Error("Application identifier " + current.id + " must be at most " + ai.max + " characters long.");
		            }
		        },
		        getByLength: function(value, index){
		            var that = this,
		                id,
		                ai;
		            for(var i = 2; i <= 4; i++){
		                id = getNext(value, index, i);
		                ai = that.getAI(id) || that.getAI(id.substring(0, id.length - 1));
		                if(ai){
		                    return {
		                        id: id,
		                        ai: ai
		                    };
		                }
		            }
		            that.unsupportedAIError(id);
		        },
		        unsupportedAIError: function(id){
		            throw new Error(kendo.format("'{0}' is not a supported Application Identifier"),id);
		        },
		        getBySeparator: function(value, index){
		            var that = this,
		                start = value.indexOf(that.startAI, index),
		                end = value.indexOf(that.endAI, start),
		                id = value.substring(start + 1,end),
		                ai = that.getAI(id) || that.getAI(id.substr(id.length - 1));
		            if(!ai){
		                that.unsupportedAIError(id);
		            }
	
		            return {
		                ai: ai,
		                id: id
		            };
		        },
		        getAI: function(id){
		            var ai = this.applicationIdentifiers,
		                multiKey = ai.multiKey;
		            if(ai[id]){
		                return ai[id];
		            }
	
		            for(var i = 0; i < multiKey.length; i++){
		                if(multiKey[i].ids && inArray(id, multiKey[i].ids) >= 0){
		                    return multiKey[i].type;
		                }
		                else if(multiKey[i].ranges){
		                    var ranges = multiKey[i].ranges;
		                    for(var j = 0; j < ranges.length; j++){
		                        if(ranges[j][0] <= id && id <= ranges[j][1]){
		                            return multiKey[i].type;
		                        }
		                    }
		                }
		            }
		        },
		        applicationIdentifiers: {
		            "22": {max: 29, type: "alphanumeric"},
		            "402": {length: 17},
		            "7004": {max: 4, type: "alphanumeric"},
		            "242": {max: 6, type: "alphanumeric"},
		            "8020": {max: 25, type: "alphanumeric"},
		            "703": { min: 3, max: 30, type: "alphanumeric"},
		            "8008": { min: 8, max: 12, type: "alphanumeric"},
		            "253": { min: 13, max: 17, type: "alphanumeric"},
		            "8003": { min: 14, max: 30, type: "alphanumeric"},
		            multiKey: [{
		                ids: ["15", "17", "8005", "8100"],
		                ranges: [
		                    [11, 13],
		                    [310, 316],
		                    [320, 336],
		                    [340, 369]
		                ],
		                type: { length: 6}
		            },{
		                ids: ["240", "241", "250", "251", "400", "401", "403", "7002", "8004", "8007", "8110"],
		                ranges: [[90-99]],
		                type: {max: 30, type: "alphanumeric"}
		            },{
		                ids: ["7001"],
		                ranges: [[410, 414]],
		                type: { length: 13}
		            },{
		                ids: ["10","21", "254", "420", "8002"],
		                type: {max: 20, type: "alphanumeric"}
		            },{
		                ids: ["00", "8006", "8017", "8018"],
		                type: {length: 18}
		            },{
		                ids: ["01", "02", "8001"],
		                type: { length: 14}
		            },{
		                ids: ["422"],
		                ranges: [
		                    [424, 426]
		                ],
		                type: {length: 3}
		            },{
		                ids: ["20", "8102"],
		                type: { length: 2}
		            },{
		                ids: ["30","37"],
		                type: {max: 8, type: "alphanumeric"}
		            },{
		                ids: ["390","392"],
		                type: {max: 15, type: "alphanumeric"}
		            },{
		                ids: ["421", "423"],
		                type: { min: 3, max: 15, type: "alphanumeric"}
		            }, {
		                ids: ["391", "393"],
		                type: { min: 3, max: 18, type: "alphanumeric"}
		            },{
		                ids: ["7003", "8101"],
		                type: {length: 10}
		            }]
		        },
		        START: 102
		    });
	
		    var code128Base = Encoding.extend({
		        init: function (options) {
		            Encoding.fn.init.call(this, options);
		            this._initStates();
		        },
		        _initStates: function(){
		            var that = this;
		            for(var i = 0; i < that.states.length; i++){
		                that[that.states[i]]  = new states128[that.states[i]](that, that.states);
		            }
		        },
		        initValue: function (value, width, height) {
		           var that = this;
		           that.pattern = [];
		           that.value = value;
		           that.width = width;
		           that.height = height;
		           that.checkSum = 0;
		           that.totalUnits = 0;
		           that.index = 0;
		           that.position = 1;
		        },
		        addData: function(){
		            var that = this,
		                encodingState = {
		                    value: that.value,
		                    index: 0,
		                    state: ""
		                };
		            if(that.value.length === 0){
		                return;
		            }
	
		            encodingState.state =
		                encodingState.previousState = that.getNextState(encodingState, that.states);
	
		            that.addStart(encodingState);
	
		            that.pushData(encodingState, that.states);
	
		            that.addCheckSum();
		            that.addStop();
		            that.setBaseUnit();
		        },
		        pushData: function(encodingState, states){
		            var that = this;
		            while(true){
		                that[encodingState.state].pushState(encodingState);
		                if(encodingState.index >= encodingState.value.length){
		                    break;
		                }
	
		                if(!encodingState.shifted){
		                    encodingState.previousState = encodingState.state;
		                    encodingState.state  = that.getNextState(encodingState, states);
		                    that[encodingState.state].move(encodingState);
		                }
		                else{
		                   var temp = encodingState.state;
		                   encodingState.state = encodingState.previousState;
		                   encodingState.previousState = temp;
		                   encodingState.shifted = false;
		                }
		            }
		        },
		        addStart: function(encodingState){
		            this[encodingState.state].addStart(encodingState);
		            this.position = 1;
		        },
		        addCheckSum: function(){
		            var that = this;
	
		            that.checksum = that.checkSum % 103;
		            that.addPattern(that.checksum);
		        },
		        addStop: function(){
		            this.addPattern(this.STOP);
		        },
		        setBaseUnit: function(){
		            var that = this;
		            that.baseUnit = that.width / (that.totalUnits + that.quietZoneLength);
		        },
		        addPattern: function(code){
		            var that = this,
		                pattern = that.characterMap[code].toString(),
		                value;
	
		            for(var i = 0; i < pattern.length; i++){
		                value = parseInt(pattern.charAt(i),10);
		                that.pattern.push(value);
		                that.totalUnits += value;
		            }
		            that.checkSum += code * that.position++;
		        },
		        getNextState: function(encodingState, states){
		            for(var i = 0; i < states.length; i++){
		                if(this[states[i]].is(encodingState.value, encodingState.index)){
		                    return states[i];
		                }
		            }
		            this.invalidCharacterError(encodingState.value.charAt(encodingState.index));
		        },
		        characterMap: [
		            212222,222122,222221,121223,121322,131222,122213,122312,132212,221213,
		            221312,231212,112232,122132,122231,113222,123122,123221,223211,221132,
		            221231,213212,223112,312131,311222,321122,321221,312212,322112,322211,
		            212123,212321,232121,111323,131123,131321,112313,132113,132311,211313,
		            231113,231311,112133,112331,132131,113123,113321,133121,313121,211331,
		            231131,213113,213311,213131,311123,311321,331121,312113,312311,332111,
		            314111,221411,431111,111224,111422,121124,121421,141122,141221,112214,
		            112412,122114,122411,142112,142211,241211,221114,413111,241112,134111,
		            111242,121142,121241,114212,124112,124211,411212,421112,421211,212141,
		            214121,412121,111143,111341,131141,114113,114311,411113,411311,113141,
		            114131,311141,411131,211412,211214,211232,2331112
		        ],
		        STOP: 106
		    });
	
		    encodings.code128a = code128Base.extend({
		        name: "Code 128 A",
		        states: ["A"]
		    });
	
	
		    encodings.code128b = code128Base.extend({
		        name: "Code 128 B",
		        states: ["B"]
		    });
	
		    encodings.code128c = code128Base.extend({
		        name: "Code 128 C",
		        states: ["C"]
		    });
	
		    encodings.code128 = code128Base.extend({
		        name: "Code 128",
		        states: ["C", "B", "A", "FNC4"]
		    });
	
		    encodings["gs1-128"] = code128Base.extend({
		       name: "Code GS1-128",
		       states: ["FNC1", "C", "B"]
		    });
	
		    var msiBase = Encoding.extend({
		        initValue: function(value, width){
		            var that = this;
		            that.pattern = [];
		            that.value = value;
		            that.checkSumLength = 0;
		            that.width = width;
		        },
		        setBaseUnit: function(){
		            var that = this,
		                startStopLength = 7;
	
		            that.baseUnit = that.width /
		                    ( 12 * (that.value.length + that.checkSumLength) + that.quietZoneLength + startStopLength);
		        },
		        addData:  function(){
		            var that = this,
		                value = that.value;
		            that.addPattern(that.START);
	
		            for(var i = 0; i < value.length; i++){
		                that.addCharacter(value.charAt(i));
		            }
	
		            if(that.options.addCheckSum){
		                that.addCheckSum();
		            }
	
		            that.addPattern(that.STOP);
		            that.setBaseUnit();
		        },
		        addCharacter: function(character){
		            var that = this,
		                pattern = that.characterMap[character];
		            if(!pattern){
		                that.invalidCharacterError(character);
		            }
		            that.addPattern(pattern);
		        },
		        addPattern: function(pattern){
		            for(var i = 0; i < pattern.length; i++){
		                this.pattern.push(parseInt(pattern.charAt(i),10));
		            }
		        },
		        addCheckSum: function(){
		            var that = this,
		                checkSumFunction = that.checkSums[that.checkSumType],
		                checkValues;
	
		            checkValues = checkSumFunction.call(that.checkSums, that.value);
	
		            that.checksum = checkValues.join("");
		            for(var i = 0; i < checkValues.length; i++){
		                that.checkSumLength++;
		                that.addPattern(that.characterMap[checkValues[i]]);
		            }
		        },
		        checkSums: {
		            Modulo10: function(value){
		                var checkValues = [0, ""],
		                odd = value.length % 2,
		                idx,
		                evenSum,
		                oddSum;
	
		                for(idx = 0; idx < value.length; idx++){
		                    checkValues[(idx + odd) % 2] += parseInt(value.charAt(idx),10);
		                }
	
		                oddSum = checkValues[0];
		                evenSum = (checkValues[1] * 2).toString();
	
		                for(idx = 0; idx < evenSum.length; idx++){
		                    oddSum += parseInt(evenSum.charAt(idx),10);
		                }
	
		                return [(10 - (oddSum % 10)) % 10];
		            },
		            Modulo11: function(value){
		                var weightedSum = 0,
		                    mod = 11,
		                    length = value.length,
		                    weight,
		                    checkValue;
	
		                for(var i = 0; i < length; i++){
		                    weight = ((length - i) % 6 || 6) + 1;
		                    weightedSum +=  weight * value.charAt(i);
		                }
		                checkValue = (mod - weightedSum % mod) % mod;
		                if(checkValue != 10){
		                    return [checkValue];
		                }
		                return [1, 0];
		            },
		            Modulo11Modulo10: function(value){
		                var checkValues = this.Modulo11(value),
		                    mod11Value;
		                mod11Value = value + checkValues[0];
	
		                return checkValues.concat(this.Modulo10(mod11Value));
		            },
		            Modulo10Modulo10: function(value){
		                var checkValues = this.Modulo10(value),
		                    mod10Value;
		                mod10Value = value + checkValues[0];
	
		                return checkValues.concat(this.Modulo10(mod10Value));
		            }
		        },
		        characterMap: ["12121212", "12121221","12122112", "12122121", "12211212", "12211221", "12212112", "12212121", "21121212", "21121221"],
		        START: "21",
		        STOP: "121",
		        checkSumType: ""
		    });
	
		    encodings.msimod10 = msiBase.extend({
		        name: "MSI Modulo10",
		        checkSumType: "Modulo10"
		    });
	
		    encodings.msimod11 = msiBase.extend({
		        name: "MSI Modulo11",
		        checkSumType: "Modulo11"
		    });
	
		    encodings.msimod1110 = msiBase.extend({
		        name: "MSI Modulo11 Modulo10",
		        checkSumType: "Modulo11Modulo10"
		    });
	
		    encodings.msimod1010 = msiBase.extend({
		        name: "MSI Modulo10 Modulo10",
		        checkSumType: "Modulo10Modulo10"
		    });
	
		    encodings.code11 = Encoding.extend({
		        name: "Code 11",
		        cCheckSumTotal: 10,
		        kCheckSumTotal: 9,
		        kCheckSumMinLength: 10,
		        checkSumMod: 11,
		        DASH_VALUE: 10,
		        DASH: "-",
		        START: "112211",
		        STOP: "11221",
		        initValue: function(value, width){
		            var that = this;
		            that.pattern = [];
		            that.value = value;
		            that.width = width;
		            that.totalUnits = 0;
		        },
		        addData:  function(){
		            var that = this;
		            var value = that.value;
		            that.addPattern(that.START);
	
		            for(var i = 0; i < value.length; i++){
		                that.addCharacter(value.charAt(i));
		            }
	
		            if(that.options.addCheckSum){
		                that.addCheckSum();
		            }
	
		            that.addPattern(that.STOP);
		            that.setBaseUnit();
		        },
		        setBaseUnit: function(){
		            var that = this;
		            that.baseUnit = that.width / (that.totalUnits + that.quietZoneLength);
		        },
		        addCheckSum: function(){
		            var that = this,
		                value = that.value,
		                length = value.length,
		                cValue;
	
		            cValue = that.getWeightedSum(value, length, that.cCheckSumTotal) % that.checkSumMod;
		            that.checksum = cValue + "";
		            that.addPattern(that.characterMap[cValue]);
	
		            length++;
		            if(length >= that.kCheckSumMinLength){
		                var kValue = (cValue + that.getWeightedSum(value, length, that.kCheckSumTotal)) % that.checkSumMod;
		                that.checksum += kValue;
		                that.addPattern(that.characterMap[kValue]);
		            }
		        },
		        getWeightedSum: function(value, length, total){
		            var weightedSum = 0;
		            for(var i = 0; i < value.length; i++){
		                weightedSum+= this.weightedValue(this.getValue(value.charAt(i)), length, i, total);
		            }
	
		            return weightedSum;
		        },
		        weightedValue: function(value, length, index, total){
		            var weight = (length - index) % total || total;
		            return weight * value;
		        },
		        getValue: function(character){
		            var that = this;
		            if(!isNaN(character)){
		                return parseInt(character,10);
		            }
		            else if(character !== that.DASH){
		                that.invalidCharacterError(character);
		            }
		            return that.DASH_VALUE;
		        },
		        addCharacter: function(character){
		            var that = this,
		                value = that.getValue(character),
		                pattern = that.characterMap[value];
		            that.addPattern(pattern);
		        },
		        addPattern: function(pattern){
		            var value;
		            for(var i = 0; i < pattern.length; i++){
		                value = parseInt(pattern.charAt(i),10);
		                this.pattern.push(value);
		                this.totalUnits+=value;
		            }
		        },
		        characterMap: ["111121", "211121", "121121", "221111", "112121", "212111", "122111", "111221", "211211", "211111", "112111"],
		        options: {
		            addCheckSum: true
		        }
		    });
	
		    encodings.postnet = Encoding.extend({
		        name: "Postnet",
		        START: "2",
		        VALID_CODE_LENGTHS: [5,9, 11],
		        DIGIT_SEPARATOR: "-",
		        initValue: function(value, width, height){
		            var that = this;
		            that.height = height;
		            that.width = width;
		            that.baseHeight = height /2;
		            that.value = value.replace(new RegExp(that.DIGIT_SEPARATOR,"g"), "");
		            that.pattern = [];
		            that.validate(that.value);
		            that.checkSum = 0;
		            that.setBaseUnit();
		        },
		        addData:  function(){
		            var that = this,
		                value = that.value;
		            that.addPattern(that.START);
	
		            for(var i = 0; i < value.length; i++){
		                that.addCharacter(value.charAt(i));
		            }
	
		            if(that.options.addCheckSum){
		                that.addCheckSum();
		            }
	
		            that.addPattern(that.START);
		            that.pattern.pop();
		        },
		        addCharacter: function(character){
		            var that = this,
		                pattern = that.characterMap[character];
		            that.checkSum+= parseInt(character,10);
		            that.addPattern(pattern);
		        },
		        addCheckSum: function(){
		            var that = this;
		            that.checksum = (10 - (that.checkSum % 10)) % 10;
		            that.addCharacter(that.checksum);
		        },
		        setBaseUnit: function(){
		            var that=this,
		                startStopLength = 3;
		            that.baseUnit = that.width / ((that.value.length + 1) * 10 +  startStopLength + that.quietZoneLength);
		        },
		        validate: function(value){
		            var that = this;
	
		            if(!numberRegex.test(value)){
		                that.invalidCharacterError(value.match(/[^0-9]/)[0]);
		            }
		            if(inArray(value.length, that.VALID_CODE_LENGTHS) < 0){
		                throw new Error("Invalid value length. Valid lengths for the Postnet symbology are " + that.VALID_CODE_LENGTHS.join(","));
		            }
		        },
		        addPattern: function(pattern){
		            var that = this,
		                y1;
		            for(var i = 0; i < pattern.length; i++){
		                y1 = that.height - that.baseHeight * pattern.charAt(i);
		                that.pattern.push({width: 1, y1: y1, y2: that.height});
		                that.pattern.push(1);
		            }
		        },
		        characterMap: ["22111", "11122", "11212", "11221", "12112", "12121", "12211", "21112", "21121", "21211"]
		    });
	
		    encodings.ean13 = Encoding.extend({
		        initValue: function(value, width, height){
		            value+="";
	
		            if(value.length!=12 || /\D/.test(value)){
		                throw new Error('The value of the "EAN13" encoding should be 12 symbols');
		            }
	
		            var that = this;
		            that.pattern = [];
		            that.options.height = height;
		            that.baseUnit = width /(95 + that.quietZoneLength);
		            that.value = value;
		            that.checksum = that.calculateChecksum();
		            that.leftKey = value[0];
		            that.leftPart = value.substr(1,6);
		            that.rightPart = value.substr(7)+that.checksum;
		        },
		        addData:  function(){
		            var that = this;
		            that.addPieces(that.characterMap.start);
		            that.addSide(that.leftPart,that.leftKey);
		            that.addPieces(that.characterMap.middle);
		            that.addSide(that.rightPart);
		            that.addPieces(that.characterMap.start);
		        },
		        addSide:function(leftPart,key){
		            var that = this;
		            for(var i = 0; i < leftPart.length; i++){
		                if(key && parseInt(that.keyTable[key].charAt(i),10)){
		                    that.addPieces(Array.prototype.slice.call(that.characterMap.digits[leftPart.charAt(i)]).reverse(),true);
		                }else{
		                    that.addPieces(that.characterMap.digits[leftPart.charAt(i)],true);
		                }
		            }
		        },
		        addPieces:function(arrToAdd,limitedHeight){
		            var that = this;
		            for(var i=0;i<arrToAdd.length;i++){
		                if(limitedHeight){
		                    that.pattern.push({
		                        y1:0,
		                        y2:that.options.height*0.95,
		                        width:arrToAdd[i]
		                    });
		                }else{
		                    that.pattern.push(arrToAdd[i]);
		                }
		            }
		        },
		        calculateChecksum: function (){
		            var odd = 0,
		                even = 0,
		                value = this.value.split("").reverse().join("");
		            for(var i = 0;i < value.length;i++){
		                if(i%2){
		                    even += parseInt(value.charAt(i),10);
		                }
		                else{
		                    odd += parseInt(value.charAt(i),10);
		                }
		            }
		            var checksum = (10 - ((3*odd + even)%10))%10;
		            return checksum;
		        },
		        keyTable:[
		            '000000',
		            '001011',
		            '001101',
		            '001110',
		            '010011',
		            '011001',
		            '011100',
		            '010101',
		            '010110',
		            '011010'
		        ],
		        characterMap: {
		            digits:[
		                [3,2,1,1],
		                [2,2,2,1],
		                [2,1,2,2],
		                [1,4,1,1],
		                [1,1,3,2],
		                [1,2,3,1],
		                [1,1,1,4],
		                [1,3,1,2],
		                [1,2,1,3],
		                [3,1,1,2]
		            ],
		            start: [1,1,1],
		            middle: [1,1,1,1,1]
		        }
		    });
	
		    encodings.ean8 = encodings.ean13.extend({
		        initValue: function(value, width, height){
		            var that = this;
		            if(value.length!=7 || /\D/.test(value)){
		                throw new Error('Invalid value provided');
		            }
		            that.value = value;
		            that.options.height = height;
		            that.checksum = that.calculateChecksum(that.value);
		            that.leftPart  = that.value.substr(0,4);
		            that.rightPart = that.value.substr(4) + that.checksum;
		            that.pattern = [];
		            that.baseUnit = width /(67 + that.quietZoneLength);
		        }
		    });
	
		    var Barcode = Widget.extend({
		        init: function (element, options) {
		             var that = this;
		             Widget.fn.init.call(that, element, options);
		             that.element = $(element);
		             that.wrapper = that.element;
		             that.element.addClass("k-barcode").css("display", "block");
		             that.surfaceWrap = $("<div />").css("position", "relative").appendTo(this.element);
		             that.surface = draw.Surface.create(that.surfaceWrap, {
		                 type: that.options.renderAs
		             });
		             that._setOptions(options);
		             if (options && defined(options.value)) {
		                 that.redraw();
		             }
		        },
	
		        setOptions: function (options) {
		            this._setOptions(options);
		            this.redraw();
		        },
	
		        redraw: function () {
		            var size = this._getSize();
	
		            this.surface.clear();
		            this.surface.setSize({
		                width: size.width,
		                height: size.height
		            });
	
		            this.createVisual();
		            this.surface.draw(this.visual);
		        },
	
		        getSize: function() {
		            return kendo.dimensions(this.element);
		        },
	
		        _resize: function() {
		            this.redraw();
		        },
	
		        createVisual: function() {
		            this.visual = this._render();
		        },
	
		        _render: function() {
		            var that = this,
		                options = that.options,
		                value = options.value,
		                textOptions = options.text,
		                textMargin = dataviz.getSpacing(textOptions.margin),
		                size = that._getSize(),
		                border = options.border || {},
		                encoding = that.encoding,
		                contentBox = new Box2D(0, 0, size.width, size.height).unpad(border.width).unpad(options.padding),
		                barHeight = contentBox.height(),
		                result, textToDisplay,
		                textHeight;
	
		            var visual = new draw.Group();
	
		            that.contentBox = contentBox;
		            visual.append(that._getBackground(size));
	
		            if (textOptions.visible) {
		                textHeight = draw.util.measureText(value, { font: textOptions.font }).height;
		                barHeight -= textHeight + textMargin.top + textMargin.bottom;
		            }
	
		            result = encoding.encode(value, contentBox.width(), barHeight);
	
		            if (textOptions.visible) {
		                textToDisplay = value;
		                if (options.checksum && defined(encoding.checksum)) {
		                    textToDisplay += " " + encoding.checksum;
		                }
	
		                visual.append(that._getText(textToDisplay));
		            }
	
		            that.barHeight = barHeight;
		            this._bandsGroup = this._getBands(result.pattern, result.baseUnit);
		            visual.append(this._bandsGroup);
	
		            return visual;
		        },
	
		        exportVisual: function() {
		            return this._render();
		        },
	
		        _getSize: function() {
		            var that = this,
		                element = that.element,
		                size = new geom.Size(DEFAULT_WIDTH, DEFAULT_HEIGHT);
	
		            if (element.width() > 0) {
		                size.width = element.width();
		            }
		            if (element.height() > 0) {
		                size.height = element.height();
		            }
		            if (that.options.width) {
		               size.width = that.options.width;
		            }
		            if (that.options.height) {
		               size.height = that.options.height;
		            }
	
		            return size;
		        },
	
		        value: function(value) {
		            var that = this;
		            if (!defined(value)) {
		                return that.options.value;
		            }
		            that.options.value = value + '';
		            that.redraw();
		        },
	
		        _getBands: function (pattern, baseUnit) {
		            var that = this,
		                contentBox = that.contentBox,
		                position = contentBox.x1,
		                step,
		                item;
	
		            var group = new draw.Group();
		            for (var i = 0; i < pattern.length; i++) {
		                item = isPlainObject(pattern[i]) ? pattern[i] : {
		                    width: pattern[i],
		                    y1: 0,
		                    y2: that.barHeight
		                };
	
		                step = item.width * baseUnit;
	
		                if (i%2) {
		                    var rect = geom.Rect.fromPoints(
		                        new geom.Point(position, item.y1 + contentBox.y1),
		                        new geom.Point(position + step, item.y2 + contentBox.y1)
		                    );
	
		                    var path = draw.Path.fromRect(rect, {
		                        fill: {
		                            color: that.options.color
		                        },
		                        stroke: null
		                    });
	
		                    group.append(path);
		                }
	
		                position += step;
		            }
	
		            return group;
		        },
	
		        _getBackground: function (size) {
		            var that = this,
		                options = that.options,
		                border = options.border || {};
	
		            var box = new Box2D(0,0, size.width, size.height).unpad(border.width / 2);
		            var path = draw.Path.fromRect(box.toRect(), {
		                fill: {
		                    color: options.background
		                },
		                stroke: {
		                    color: border.width ? border.color : "",
		                    width: border.width,
		                    dashType: border.dashType
		                }
		            });
	
		            return path;
		        },
	
		        _getText: function(value) {
		            var that = this,
		                textOptions = that.options.text,
		                text = that._textbox = new TextBox(value, {
		                    font: textOptions.font,
		                    color: textOptions.color,
		                    align: "center",
		                    vAlign: "bottom",
		                    margin: textOptions.margin
		                });
	
		            text.reflow(that.contentBox);
		            text.renderVisual();
	
		            return text.visual;
		        },
	
		        _setOptions: function (options) {
		            var that = this;
		            that.type = (options.type || that.options.type).toLowerCase();
	
		            if (that.type=="upca") { //extend instead
		                that.type = "ean13";
		                options.value = '0' + options.value;
		            }
	
		            if (that.type=="upce") {
		                that.type = "ean8";
		                options.value = '0' + options.value;
		            }
	
		            if (!encodings[that.type]) {
		                throw new Error('Encoding ' + that.type + 'is not supported.');
		            }
	
		            that.encoding = new encodings[that.type]();
	
		            that.options = extend(true, that.options, options);
		        },
	
		        options: {
		            name: "Barcode",
		            renderAs: "svg",
		            value: "",
		            type: "code39",
		            checksum: false,
		            width: 0,
		            height: 0,
		            color: "black",
		            background: "white",
		            text: {
		                visible: true,
		                font: "16px Consolas, Monaco, Sans Mono, monospace, sans-serif",
		                color: "black",
		                margin: {
		                    top: 0,
		                    bottom: 0,
		                    left: 0,
		                    right: 0
		                }
		            },
		            border: {
		                width: 0,
		                dashType: "solid",
		                color: "black"
		            },
		            padding: {
		                top: 0,
		                bottom: 0,
		                left: 0,
		                right: 0
		            }
		        }
		    });
		    dataviz.ExportMixin.extend(Barcode.fn);
	
		    dataviz.ui.plugin(Barcode);
	
		    kendo.deepExtend(dataviz, {
		        encodings: encodings,
		        Encoding: Encoding
		    });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1102);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1000:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 1060:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 1102:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1060), __webpack_require__(1000) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.qrcode",
		    name: "QRCode",
		    category: "dataviz",
		    description: "QRCode widget.",
		    depends: [ "dataviz.core", "drawing" ]
		};
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        extend = $.extend,
		        draw = kendo.drawing,
		        dataviz = kendo.dataviz,
		        Widget = kendo.ui.Widget,
		        Box2D = dataviz.Box2D,
		        terminator = "0000",
		        NUMERIC = "numeric",
		        ALPHA_NUMERIC = "alphanumeric",
		        BYTE = "byte",
		        powersOfTwo = {"1": 0},
		        powersOfTwoResult = {"0": 1},
		        generatorPolynomials = [[1,0],[1,25,0]],
		        irregularAlignmentPatternsStartDistance = {15:20,16:20,18:24,19:24,22:20,24:22,26:24,28:20,30:20,31:24,32:28,33:24,36:18,37:22,39:20,40:24},
		        versionsCodewordsInformation = [{L:{groups:[[1,19]],totalDataCodewords:19,errorCodewordsPerBlock:7},M:{groups:[[1,16]],totalDataCodewords:16,errorCodewordsPerBlock:10},Q:{groups:[[1,13]],totalDataCodewords:13,errorCodewordsPerBlock:13},H:{groups:[[1,9]],totalDataCodewords:9,errorCodewordsPerBlock:17}},{L:{groups:[[1,34]],totalDataCodewords:34,errorCodewordsPerBlock:10},M:{groups:[[1,28]],totalDataCodewords:28,errorCodewordsPerBlock:16},Q:{groups:[[1,22]],totalDataCodewords:22,errorCodewordsPerBlock:22},H:{groups:[[1,16]],totalDataCodewords:16,errorCodewordsPerBlock:28}},{L:{groups:[[1,55]],totalDataCodewords:55,errorCodewordsPerBlock:15},M:{groups:[[1,44]],totalDataCodewords:44,errorCodewordsPerBlock:26},Q:{groups:[[2,17]],totalDataCodewords:34,errorCodewordsPerBlock:18},H:{groups:[[2,13]],totalDataCodewords:26,errorCodewordsPerBlock:22}},{L:{groups:[[1,80]],totalDataCodewords:80,errorCodewordsPerBlock:20},M:{groups:[[2,32]],totalDataCodewords:64,errorCodewordsPerBlock:18},Q:{groups:[[2,24]],totalDataCodewords:48,errorCodewordsPerBlock:26},H:{groups:[[4,9]],totalDataCodewords:36,errorCodewordsPerBlock:16}},{L:{groups:[[1,108]],totalDataCodewords:108,errorCodewordsPerBlock:26},M:{groups:[[2,43]],totalDataCodewords:86,errorCodewordsPerBlock:24},Q:{groups:[[2,15],[2,16]],totalDataCodewords:62,errorCodewordsPerBlock:18},H:{groups:[[2,11],[2,12]],totalDataCodewords:46,errorCodewordsPerBlock:22}},{L:{groups:[[2,68]],totalDataCodewords:136,errorCodewordsPerBlock:18},M:{groups:[[4,27]],totalDataCodewords:108,errorCodewordsPerBlock:16},Q:{groups:[[4,19]],totalDataCodewords:76,errorCodewordsPerBlock:24},H:{groups:[[4,15]],totalDataCodewords:60,errorCodewordsPerBlock:28}},{L:{groups:[[2,78]],totalDataCodewords:156,errorCodewordsPerBlock:20},M:{groups:[[4,31]],totalDataCodewords:124,errorCodewordsPerBlock:18},Q:{groups:[[2,14],[4,15]],totalDataCodewords:88,errorCodewordsPerBlock:18},H:{groups:[[4,13],[1,14]],totalDataCodewords:66,errorCodewordsPerBlock:26}},{L:{groups:[[2,97]],totalDataCodewords:194,errorCodewordsPerBlock:24},M:{groups:[[2,38],[2,39]],totalDataCodewords:154,errorCodewordsPerBlock:22},Q:{groups:[[4,18],[2,19]],totalDataCodewords:110,errorCodewordsPerBlock:22},H:{groups:[[4,14],[2,15]],totalDataCodewords:86,errorCodewordsPerBlock:26}},{L:{groups:[[2,116]],totalDataCodewords:232,errorCodewordsPerBlock:30},M:{groups:[[3,36],[2,37]],totalDataCodewords:182,errorCodewordsPerBlock:22},Q:{groups:[[4,16],[4,17]],totalDataCodewords:132,errorCodewordsPerBlock:20},H:{groups:[[4,12],[4,13]],totalDataCodewords:100,errorCodewordsPerBlock:24}},{L:{groups:[[2,68],[2,69]],totalDataCodewords:274,errorCodewordsPerBlock:18},M:{groups:[[4,43],[1,44]],totalDataCodewords:216,errorCodewordsPerBlock:26},Q:{groups:[[6,19],[2,20]],totalDataCodewords:154,errorCodewordsPerBlock:24},H:{groups:[[6,15],[2,16]],totalDataCodewords:122,errorCodewordsPerBlock:28}},{L:{groups:[[4,81]],totalDataCodewords:324,errorCodewordsPerBlock:20},M:{groups:[[1,50],[4,51]],totalDataCodewords:254,errorCodewordsPerBlock:30},Q:{groups:[[4,22],[4,23]],totalDataCodewords:180,errorCodewordsPerBlock:28},H:{groups:[[3,12],[8,13]],totalDataCodewords:140,errorCodewordsPerBlock:24}},{L:{groups:[[2,92],[2,93]],totalDataCodewords:370,errorCodewordsPerBlock:24},M:{groups:[[6,36],[2,37]],totalDataCodewords:290,errorCodewordsPerBlock:22},Q:{groups:[[4,20],[6,21]],totalDataCodewords:206,errorCodewordsPerBlock:26},H:{groups:[[7,14],[4,15]],totalDataCodewords:158,errorCodewordsPerBlock:28}},{L:{groups:[[4,107]],totalDataCodewords:428,errorCodewordsPerBlock:26},M:{groups:[[8,37],[1,38]],totalDataCodewords:334,errorCodewordsPerBlock:22},Q:{groups:[[8,20],[4,21]],totalDataCodewords:244,errorCodewordsPerBlock:24},H:{groups:[[12,11],[4,12]],totalDataCodewords:180,errorCodewordsPerBlock:22}},{L:{groups:[[3,115],[1,116]],totalDataCodewords:461,errorCodewordsPerBlock:30},M:{groups:[[4,40],[5,41]],totalDataCodewords:365,errorCodewordsPerBlock:24},Q:{groups:[[11,16],[5,17]],totalDataCodewords:261,errorCodewordsPerBlock:20},H:{groups:[[11,12],[5,13]],totalDataCodewords:197,errorCodewordsPerBlock:24}},{L:{groups:[[5,87],[1,88]],totalDataCodewords:523,errorCodewordsPerBlock:22},M:{groups:[[5,41],[5,42]],totalDataCodewords:415,errorCodewordsPerBlock:24},Q:{groups:[[5,24],[7,25]],totalDataCodewords:295,errorCodewordsPerBlock:30},H:{groups:[[11,12],[7,13]],totalDataCodewords:223,errorCodewordsPerBlock:24}},{L:{groups:[[5,98],[1,99]],totalDataCodewords:589,errorCodewordsPerBlock:24},M:{groups:[[7,45],[3,46]],totalDataCodewords:453,errorCodewordsPerBlock:28},Q:{groups:[[15,19],[2,20]],totalDataCodewords:325,errorCodewordsPerBlock:24},H:{groups:[[3,15],[13,16]],totalDataCodewords:253,errorCodewordsPerBlock:30}},{L:{groups:[[1,107],[5,108]],totalDataCodewords:647,errorCodewordsPerBlock:28},M:{groups:[[10,46],[1,47]],totalDataCodewords:507,errorCodewordsPerBlock:28},Q:{groups:[[1,22],[15,23]],totalDataCodewords:367,errorCodewordsPerBlock:28},H:{groups:[[2,14],[17,15]],totalDataCodewords:283,errorCodewordsPerBlock:28}},{L:{groups:[[5,120],[1,121]],totalDataCodewords:721,errorCodewordsPerBlock:30},M:{groups:[[9,43],[4,44]],totalDataCodewords:563,errorCodewordsPerBlock:26},Q:{groups:[[17,22],[1,23]],totalDataCodewords:397,errorCodewordsPerBlock:28},H:{groups:[[2,14],[19,15]],totalDataCodewords:313,errorCodewordsPerBlock:28}},{L:{groups:[[3,113],[4,114]],totalDataCodewords:795,errorCodewordsPerBlock:28},M:{groups:[[3,44],[11,45]],totalDataCodewords:627,errorCodewordsPerBlock:26},Q:{groups:[[17,21],[4,22]],totalDataCodewords:445,errorCodewordsPerBlock:26},H:{groups:[[9,13],[16,14]],totalDataCodewords:341,errorCodewordsPerBlock:26}},{L:{groups:[[3,107],[5,108]],totalDataCodewords:861,errorCodewordsPerBlock:28},M:{groups:[[3,41],[13,42]],totalDataCodewords:669,errorCodewordsPerBlock:26},Q:{groups:[[15,24],[5,25]],totalDataCodewords:485,errorCodewordsPerBlock:30},H:{groups:[[15,15],[10,16]],totalDataCodewords:385,errorCodewordsPerBlock:28}},{L:{groups:[[4,116],[4,117]],totalDataCodewords:932,errorCodewordsPerBlock:28},M:{groups:[[17,42]],totalDataCodewords:714,errorCodewordsPerBlock:26},Q:{groups:[[17,22],[6,23]],totalDataCodewords:512,errorCodewordsPerBlock:28},H:{groups:[[19,16],[6,17]],totalDataCodewords:406,errorCodewordsPerBlock:30}},{L:{groups:[[2,111],[7,112]],totalDataCodewords:1006,errorCodewordsPerBlock:28},M:{groups:[[17,46]],totalDataCodewords:782,errorCodewordsPerBlock:28},Q:{groups:[[7,24],[16,25]],totalDataCodewords:568,errorCodewordsPerBlock:30},H:{groups:[[34,13]],totalDataCodewords:442,errorCodewordsPerBlock:24}},{L:{groups:[[4,121],[5,122]],totalDataCodewords:1094,errorCodewordsPerBlock:30},M:{groups:[[4,47],[14,48]],totalDataCodewords:860,errorCodewordsPerBlock:28},Q:{groups:[[11,24],[14,25]],totalDataCodewords:614,errorCodewordsPerBlock:30},H:{groups:[[16,15],[14,16]],totalDataCodewords:464,errorCodewordsPerBlock:30}},{L:{groups:[[6,117],[4,118]],totalDataCodewords:1174,errorCodewordsPerBlock:30},M:{groups:[[6,45],[14,46]],totalDataCodewords:914,errorCodewordsPerBlock:28},Q:{groups:[[11,24],[16,25]],totalDataCodewords:664,errorCodewordsPerBlock:30},H:{groups:[[30,16],[2,17]],totalDataCodewords:514,errorCodewordsPerBlock:30}},{L:{groups:[[8,106],[4,107]],totalDataCodewords:1276,errorCodewordsPerBlock:26},M:{groups:[[8,47],[13,48]],totalDataCodewords:1000,errorCodewordsPerBlock:28},Q:{groups:[[7,24],[22,25]],totalDataCodewords:718,errorCodewordsPerBlock:30},H:{groups:[[22,15],[13,16]],totalDataCodewords:538,errorCodewordsPerBlock:30}},{L:{groups:[[10,114],[2,115]],totalDataCodewords:1370,errorCodewordsPerBlock:28},M:{groups:[[19,46],[4,47]],totalDataCodewords:1062,errorCodewordsPerBlock:28},Q:{groups:[[28,22],[6,23]],totalDataCodewords:754,errorCodewordsPerBlock:28},H:{groups:[[33,16],[4,17]],totalDataCodewords:596,errorCodewordsPerBlock:30}},{L:{groups:[[8,122],[4,123]],totalDataCodewords:1468,errorCodewordsPerBlock:30},M:{groups:[[22,45],[3,46]],totalDataCodewords:1128,errorCodewordsPerBlock:28},Q:{groups:[[8,23],[26,24]],totalDataCodewords:808,errorCodewordsPerBlock:30},H:{groups:[[12,15],[28,16]],totalDataCodewords:628,errorCodewordsPerBlock:30}},{L:{groups:[[3,117],[10,118]],totalDataCodewords:1531,errorCodewordsPerBlock:30},M:{groups:[[3,45],[23,46]],totalDataCodewords:1193,errorCodewordsPerBlock:28},Q:{groups:[[4,24],[31,25]],totalDataCodewords:871,errorCodewordsPerBlock:30},H:{groups:[[11,15],[31,16]],totalDataCodewords:661,errorCodewordsPerBlock:30}},{L:{groups:[[7,116],[7,117]],totalDataCodewords:1631,errorCodewordsPerBlock:30},M:{groups:[[21,45],[7,46]],totalDataCodewords:1267,errorCodewordsPerBlock:28},Q:{groups:[[1,23],[37,24]],totalDataCodewords:911,errorCodewordsPerBlock:30},H:{groups:[[19,15],[26,16]],totalDataCodewords:701,errorCodewordsPerBlock:30}},{L:{groups:[[5,115],[10,116]],totalDataCodewords:1735,errorCodewordsPerBlock:30},M:{groups:[[19,47],[10,48]],totalDataCodewords:1373,errorCodewordsPerBlock:28},Q:{groups:[[15,24],[25,25]],totalDataCodewords:985,errorCodewordsPerBlock:30},H:{groups:[[23,15],[25,16]],totalDataCodewords:745,errorCodewordsPerBlock:30}},{L:{groups:[[13,115],[3,116]],totalDataCodewords:1843,errorCodewordsPerBlock:30},M:{groups:[[2,46],[29,47]],totalDataCodewords:1455,errorCodewordsPerBlock:28},Q:{groups:[[42,24],[1,25]],totalDataCodewords:1033,errorCodewordsPerBlock:30},H:{groups:[[23,15],[28,16]],totalDataCodewords:793,errorCodewordsPerBlock:30}},{L:{groups:[[17,115]],totalDataCodewords:1955,errorCodewordsPerBlock:30},M:{groups:[[10,46],[23,47]],totalDataCodewords:1541,errorCodewordsPerBlock:28},Q:{groups:[[10,24],[35,25]],totalDataCodewords:1115,errorCodewordsPerBlock:30},H:{groups:[[19,15],[35,16]],totalDataCodewords:845,errorCodewordsPerBlock:30}},{L:{groups:[[17,115],[1,116]],totalDataCodewords:2071,errorCodewordsPerBlock:30},M:{groups:[[14,46],[21,47]],totalDataCodewords:1631,errorCodewordsPerBlock:28},Q:{groups:[[29,24],[19,25]],totalDataCodewords:1171,errorCodewordsPerBlock:30},H:{groups:[[11,15],[46,16]],totalDataCodewords:901,errorCodewordsPerBlock:30}},{L:{groups:[[13,115],[6,116]],totalDataCodewords:2191,errorCodewordsPerBlock:30},M:{groups:[[14,46],[23,47]],totalDataCodewords:1725,errorCodewordsPerBlock:28},Q:{groups:[[44,24],[7,25]],totalDataCodewords:1231,errorCodewordsPerBlock:30},H:{groups:[[59,16],[1,17]],totalDataCodewords:961,errorCodewordsPerBlock:30}},{L:{groups:[[12,121],[7,122]],totalDataCodewords:2306,errorCodewordsPerBlock:30},M:{groups:[[12,47],[26,48]],totalDataCodewords:1812,errorCodewordsPerBlock:28},Q:{groups:[[39,24],[14,25]],totalDataCodewords:1286,errorCodewordsPerBlock:30},H:{groups:[[22,15],[41,16]],totalDataCodewords:986,errorCodewordsPerBlock:30}},{L:{groups:[[6,121],[14,122]],totalDataCodewords:2434,errorCodewordsPerBlock:30},M:{groups:[[6,47],[34,48]],totalDataCodewords:1914,errorCodewordsPerBlock:28},Q:{groups:[[46,24],[10,25]],totalDataCodewords:1354,errorCodewordsPerBlock:30},H:{groups:[[2,15],[64,16]],totalDataCodewords:1054,errorCodewordsPerBlock:30}},{L:{groups:[[17,122],[4,123]],totalDataCodewords:2566,errorCodewordsPerBlock:30},M:{groups:[[29,46],[14,47]],totalDataCodewords:1992,errorCodewordsPerBlock:28},Q:{groups:[[49,24],[10,25]],totalDataCodewords:1426,errorCodewordsPerBlock:30},H:{groups:[[24,15],[46,16]],totalDataCodewords:1096,errorCodewordsPerBlock:30}},{L:{groups:[[4,122],[18,123]],totalDataCodewords:2702,errorCodewordsPerBlock:30},M:{groups:[[13,46],[32,47]],totalDataCodewords:2102,errorCodewordsPerBlock:28},Q:{groups:[[48,24],[14,25]],totalDataCodewords:1502,errorCodewordsPerBlock:30},H:{groups:[[42,15],[32,16]],totalDataCodewords:1142,errorCodewordsPerBlock:30}},{L:{groups:[[20,117],[4,118]],totalDataCodewords:2812,errorCodewordsPerBlock:30},M:{groups:[[40,47],[7,48]],totalDataCodewords:2216,errorCodewordsPerBlock:28},Q:{groups:[[43,24],[22,25]],totalDataCodewords:1582,errorCodewordsPerBlock:30},H:{groups:[[10,15],[67,16]],totalDataCodewords:1222,errorCodewordsPerBlock:30}},{L:{groups:[[19,118],[6,119]],totalDataCodewords:2956,errorCodewordsPerBlock:30},M:{groups:[[18,47],[31,48]],totalDataCodewords:2334,errorCodewordsPerBlock:28},Q:{groups:[[34,24],[34,25]],totalDataCodewords:1666,errorCodewordsPerBlock:30},H:{groups:[[20,15],[61,16]],totalDataCodewords:1276,errorCodewordsPerBlock:30}}],
		        finderPattern = [1,0,1,1,1],
		        alignmentPattern = [1,0,1],
		        errorCorrectionPatterns = {L: "01", M: "00", Q: "11", H: "10"},
		        formatMaskPattern = "101010000010010",
		        formatGeneratorPolynomial = "10100110111",
		        versionGeneratorPolynomial = "1111100100101",
		        paddingCodewords = ["11101100", "00010001"],
		        finderPatternValue = 93,
		        maskPatternConditions = [
		            function(row,column){return (row + column) % 2 === 0;},
		            function(row){return row % 2 === 0;},
		            function(row,column){return column % 3 === 0;},
		            function(row,column){return (row + column) % 3 === 0;},
		            function(row,column){return (Math.floor(row/2) + Math.floor(column/3)) % 2 === 0;},
		            function(row,column){return ((row * column) % 2) + ((row * column) % 3) === 0;},
		            function(row,column){return (((row * column) % 2) + ((row * column) % 3)) % 2 === 0;},
		            function(row,column){return (((row + column) % 2) + ((row * column) % 3)) % 2 === 0;}
		        ],
		        numberRegex = /^\d+/,
		        alphaPattern = "A-Z0-9 $%*+./:-",
		        alphaExclusiveSet = "A-Z $%*+./:-",
		        alphaRegex = new RegExp("^[" + alphaExclusiveSet + "]+"),
		        alphaNumericRegex = new RegExp("^[" + alphaPattern+ "]+"),
		        byteRegex = new RegExp("^[^" + alphaPattern+ "]+"),
		        initMinNumericBeforeAlpha = 8,
		        initMinNumericBeforeByte = 5,
		        initMinAlphaBeforeByte = 8,
		        minNumericBeforeAlpha = 17,
		        minNumericBeforeByte = 9,
		        minAlphaBeforeByte =  16,
		        round = Math.round;
	
		        function toDecimal(value){
		            return parseInt(value, 2);
		        }
	
		        function toBitsString(value, length){
		            var result = Number(value).toString(2);
		            if(result.length < length){
		                result = new Array(length - result.length + 1).join(0) + result;
		            }
		            return result;
		        }
	
		        function splitInto(str, n){
		            var result = [],
		                idx = 0;
		            while(idx < str.length){
		                result.push(str.substring(idx, idx + n));
		                idx+= n;
		            }
		            return result;
		        }
	
		        var QRDataMode = kendo.Class.extend({
		            getVersionIndex: function(version){
		                if(version < 10){
		                    return 0;
		                }
		                else if(version > 26){
		                    return 2;
		                }
	
		                return 1;
		            },
		            getBitsCharacterCount: function(version){
		                var mode = this;
		                return mode.bitsInCharacterCount[mode.getVersionIndex(version || 40)];
		            },
		            getModeCountString: function(length, version){
		                var mode = this;
		                return mode.modeIndicator + toBitsString(length, mode.getBitsCharacterCount(version));
		            },
		            encode: function(){},
		            getStringBitsLength: function(){},
		            getValue: function(){},
		            modeIndicator: "",
		            bitsInCharacterCount: []
		        });
	
		        var modes = {};
		        modes[NUMERIC] = QRDataMode.extend({
		            bitsInCharacterCount: [10, 12, 14],
		            modeIndicator: "0001",
		            getValue: function(character){
		                return parseInt(character, 10);
		            },
		            encode: function(str, version){
		                var mode = this,
		                    parts = splitInto(str, 3),
		                    result = mode.getModeCountString(str.length, version);
	
		                for(var i = 0; i < parts.length - 1; i++){
		                    result += toBitsString(parts[i], 10);
		                }
		                return result + toBitsString(parts[i], 1 + 3 * parts[i].length);
		            },
		            getStringBitsLength: function(inputLength, version){
		                var mod3 = inputLength % 3;
		                return 4 + this.getBitsCharacterCount(version) + 10 * Math.floor(inputLength / 3) + 3 * mod3 + (mod3 === 0 ? 0 : 1);
		            }
		        });
	
		        modes[ALPHA_NUMERIC] = QRDataMode.extend({
		            characters: {"0":0,"1": 1,"2": 2,"3": 3,"4": 4,"5": 5,"6": 6,"7": 7,"8": 8,"9": 9,"A": 10,"B": 11,"C": 12,"D": 13,"E": 14,"F": 15,"G": 16,"H": 17,"I": 18,"J": 19,"K": 20,"L": 21,"M": 22,"N": 23,"O": 24,"P": 25,"Q": 26,"R": 27,"S": 28,"T": 29,"U": 30,"V": 31,"W": 32,"X": 33,"Y": 34,"Z": 35," ": 36,"$": 37,"%": 38,"*": 39,"+": 40,"-": 41,".": 42,"/": 43,":": 44},
		            bitsInCharacterCount: [9,11,13],
		            modeIndicator: "0010",
		            getValue: function(character){
		                return this.characters[character];
		            },
		            encode: function(str, version){
		                var mode = this,
		                    parts = splitInto(str, 2),
		                    result = mode.getModeCountString(str.length, version),
		                    value;
		                for(var i = 0; i < parts.length - 1; i++){
		                    value = 45 * mode.getValue(parts[i].charAt(0)) + mode.getValue(parts[i].charAt(1));
		                    result += toBitsString(value, 11);
		                }
		                value = parts[i].length == 2 ?
		                    45 * mode.getValue(parts[i].charAt(0)) + mode.getValue(parts[i].charAt(1)) :
		                    mode.getValue(parts[i].charAt(0));
		                return result + toBitsString(value, 1 + 5 * parts[i].length);
		            },
		            getStringBitsLength: function(inputLength, version){
		                return 4 + this.getBitsCharacterCount(version) + 11 * Math.floor(inputLength / 2) + 6 * (inputLength % 2);
		            }
		        });
	
		        modes[BYTE] = QRDataMode.extend({
		            bitsInCharacterCount: [8,16,16],
		            modeIndicator: "0100",
		            getValue: function(character){
		                var code = character.charCodeAt(0);
		                if(code <= 127 || (160 <= code && code <= 255)){
		                    return code;
		                }
		                else{
		                    throw new Error("Unsupported character: " + character);
		                }
		            },
		            encode: function(str, version){
		                var mode = this,
		                    result = mode.getModeCountString(str.length, version);
	
		                for(var i = 0; i < str.length; i++){
		                    result += toBitsString(mode.getValue(str.charAt(i)), 8);
		                }
		                return result;
		            },
		            getStringBitsLength: function(inputLength, version){
		                return 4 + this.getBitsCharacterCount(version) + 8 * inputLength;
		            }
		        });
	
		        var modeInstances = {};
		        for(var mode in modes){
		            modeInstances[mode] = new modes[mode]();
		        }
	
		        var FreeCellVisitor = function (matrix){
		            var that = this,
		                row = matrix.length - 1,
		                column = matrix.length - 1,
		                startColumn = column,
		                dir = -1,
		                c = 0;
		            that.move = function(){
		                row += dir * c;
		                c^=1;
		                column = startColumn - c;
		            };
		            that.getNextCell = function(){
		                while(matrix[row][column] !== undefined){
		                    that.move();
		                    if(row < 0 || row >= matrix.length){
		                        dir = -dir;
		                        startColumn-= startColumn != 8 ? 2 : 3;
		                        column = startColumn;
		                        row = dir < 0 ? matrix.length - 1 : 0;
		                    }
		                }
		                return {row: row, column: column};
		            };
		            that.getNextRemainderCell = function(){
		                that.move();
		                if(matrix[row][column] === undefined){
		                     return {row: row, column: column};
		                }
		            };
		        };
	
		        function fillFunctionCell(matrices, bit, x, y){
		            for(var i = 0; i< matrices.length;i++){
		                matrices[i][x][y] = bit;
		            }
		        }
	
		        function fillDataCell(matrices, bit, x, y){
		            for(var i = 0; i < maskPatternConditions.length;i++){
		                matrices[i][x][y] = maskPatternConditions[i](x,y) ? bit ^ 1 : parseInt(bit, 10);
		            }
		        }
	
		        var fillData = function (matrices, blocks){
		            var cellVisitor = new FreeCellVisitor(matrices[0]),
		                block,
		                codewordIdx,
		                cell;
	
		            for(var blockIdx = 0; blockIdx < blocks.length;blockIdx++){
		                block = blocks[blockIdx];
		                codewordIdx = 0;
		                while(block.length > 0){
		                    for(var i = 0; i< block.length; i++){
		                         for(var j = 0; j < 8;j++){
		                            cell = cellVisitor.getNextCell();
		                            fillDataCell(matrices, block[i][codewordIdx].charAt(j), cell.row, cell.column);
		                        }
		                    }
	
		                    codewordIdx++;
		                    while(block[0] && codewordIdx == block[0].length){
		                        block.splice(0,1);
		                    }
		                }
		            }
	
		            while((cell = cellVisitor.getNextRemainderCell())){
		                fillDataCell(matrices, 0, cell.row, cell.column);
		            }
		        };
	
		        var padDataString = function (dataString, totalDataCodewords){
		            var dataBitsCount = totalDataCodewords * 8,
		                terminatorIndex = 0,
		                paddingCodewordIndex = 0;
		            while(dataString.length < dataBitsCount && terminatorIndex < terminator.length){
		                dataString+=terminator.charAt(terminatorIndex++);
		            }
	
		            if(dataString.length % 8 !== 0){
		                dataString+= new Array(9 - dataString.length % 8).join("0");
		            }
	
		            while(dataString.length < dataBitsCount){
		                dataString+= paddingCodewords[paddingCodewordIndex];
		                paddingCodewordIndex ^= 1;
		            }
		            return dataString;
		        };
	
		        function generatePowersOfTwo(){
		            var result;
		            for(var power = 1; power < 255; power++){
	
		                result =  powersOfTwoResult[power - 1] * 2;
		                if(result > 255){
		                    result = result ^ 285;
		                }
	
		                powersOfTwoResult[power] = result;
		                powersOfTwo[result] = power;
		            }
	
		            result = (powersOfTwoResult[power - 1] * 2) ^ 285;
		            powersOfTwoResult[power] =   result;
		            powersOfTwoResult[-1] = 0;
		        }
	
		        var xorPolynomials = function (x,y){
		            var result = [],
		                idx = x.length - 2;
		            for(var i = idx; i>=0; i--){
		                 result[i] = x[i] ^ y[i];
		            }
	
		            return result;
		        };
	
		        var multiplyPolynomials = function (x, y){
		            var result = [];
		            for(var i = 0; i < x.length; i++){
		                for(var j = 0; j < y.length; j++){
		                    if(result[i+j] === undefined){
		                         result[i+j] = (x[i] + (y[j] >= 0 ? y[j] : 0)) % 255;
		                    }
		                    else{
		                       result[i+j] = powersOfTwo[powersOfTwoResult[result[i+j]] ^ powersOfTwoResult[(x[i] + y[j]) % 255]];
		                    }
		                }
		            }
	
		            return result;
		        };
	
		        function generateGeneratorPolynomials(){
		            var maxErrorCorrectionCodeWordsCount = 68;
		            for(var idx = 2; idx <= maxErrorCorrectionCodeWordsCount; idx++){
		                var firstPolynomial = generatorPolynomials[idx - 1],
		                    secondPolynomial = [idx, 0];
		                generatorPolynomials[idx] =  multiplyPolynomials(firstPolynomial, secondPolynomial);
		            }
		        }
	
		        //possibly generate on demand
		        generatePowersOfTwo();
		        generateGeneratorPolynomials();
	
		        function multiplyByConstant(polynomial, power){
		            var result = [],
		                idx = polynomial.length - 1;
		            do{
		                result[idx] = powersOfTwoResult[(polynomial[idx] + power) % 255];
		                idx--;
		            }while(polynomial[idx] !== undefined);
	
		            return result;
		        }
	
		        var generateErrorCodewords = function (data, errorCodewordsCount){
		            var generator = generatorPolynomials[errorCodewordsCount - 1],
		                result = new Array(errorCodewordsCount).concat(data),
		                generatorPolynomial = new Array(result.length - generator.length).concat(generator),
		                steps = data.length,
		                errorCodewords = [],
		                divisor,
		                idx;
	
		            for(idx = 0; idx < steps; idx++){
		                divisor = multiplyByConstant(generatorPolynomial, powersOfTwo[result[result.length - 1]]);
		                generatorPolynomial.splice(0,1);
	
		                result = xorPolynomials(divisor, result);
		            }
	
		            for(idx = result.length - 1; idx >= 0;idx--){
		                errorCodewords[errorCodewordsCount - 1 - idx] = toBitsString(result[idx], 8);
		            }
	
		            return errorCodewords;
		        };
	
		        var getBlocks = function (dataStream, versionCodewordsInformation){
		            var codewordStart = 0,
		                dataBlocks = [],
		                errorBlocks = [],
		                dataBlock,
		                versionGroups = versionCodewordsInformation.groups,
		                blockCodewordsCount,
		                groupBlocksCount,
		                messagePolynomial,
		                codeword;
	
		            for(var groupIdx = 0; groupIdx < versionGroups.length; groupIdx++){
		                groupBlocksCount = versionGroups[groupIdx][0];
		                for(var blockIdx = 0; blockIdx < groupBlocksCount;blockIdx++){
		                    blockCodewordsCount = versionGroups[groupIdx][1];
		                    dataBlock = [];
		                    messagePolynomial = [];
		                    for(var codewordIdx = 1; codewordIdx <= blockCodewordsCount; codewordIdx++){
		                        codeword = dataStream.substring(codewordStart, codewordStart + 8);
		                        dataBlock.push(codeword);
		                        messagePolynomial[blockCodewordsCount - codewordIdx] = toDecimal(codeword);
		                        codewordStart+=8;
		                    }
		                    dataBlocks.push(dataBlock);
		                    errorBlocks.push(generateErrorCodewords(messagePolynomial,
		                        versionCodewordsInformation.errorCodewordsPerBlock));
		                }
		            }
		            return [dataBlocks, errorBlocks];
		        };
	
		        var chooseMode = function (str, minNumericBeforeAlpha, minNumericBeforeByte, minAlphaBeforeByte, previousMode){
		             var numeric = numberRegex.exec(str),
		                numericMatch = numeric ? numeric[0] : "",
		                alpha = alphaRegex.exec(str),
		                alphaMatch = alpha ? alpha[0] : "",
		                alphaNumeric = alphaNumericRegex.exec(str),
		                alphaNumericMatch = alphaNumeric ? alphaNumeric[0] : "",
		                mode,
		                modeString;
	
		             if(numericMatch && (numericMatch.length >= minNumericBeforeAlpha ||
		                     str.length == numericMatch.length || (numericMatch.length >= minNumericBeforeByte &&
		                     !alphaNumericRegex.test(str.charAt(numericMatch.length))))){
		                mode = NUMERIC;
		                modeString = numericMatch;
		             }
		             else if(alphaNumericMatch && (str.length == alphaNumericMatch.length ||
		                alphaNumericMatch.length >= minAlphaBeforeByte || previousMode == ALPHA_NUMERIC)){
		                mode = ALPHA_NUMERIC;
		                modeString =  numericMatch || alphaMatch;
		             }
		             else {
		                mode = BYTE;
		                if(alphaNumericMatch){
		                    modeString = alphaNumericMatch + byteRegex.exec(str.substring(alphaNumericMatch.length))[0];
		                }
		                else{
		                    modeString = byteRegex.exec(str)[0];
		                }
		             }
	
		             return {
		                mode: mode,
		                modeString: modeString
		             };
		        };
	
		        var getModes = function (str){
		            var modes = [],
		                previousMode,
		                idx = 0;
		            modes.push(chooseMode(str, initMinNumericBeforeAlpha, initMinNumericBeforeByte, initMinAlphaBeforeByte, previousMode));
		            previousMode = modes[0].mode;
		            str = str.substr(modes[0].modeString.length);
	
		            while(str.length > 0){
		               var nextMode = chooseMode(str, minNumericBeforeAlpha, minNumericBeforeByte, minAlphaBeforeByte, previousMode);
		               if(nextMode.mode != previousMode){
		                    previousMode = nextMode.mode;
		                    modes.push(nextMode);
		                    idx++;
		               }
		               else{
		                    modes[idx].modeString += nextMode.modeString;
		               }
		               str = str.substr(nextMode.modeString.length);
		            }
	
		            return modes;
		        };
	
		        var getDataCodewordsCount = function (modes){
		            var length = 0,
		                mode;
		            for(var i = 0; i < modes.length; i++){
		                mode = modeInstances[modes[i].mode];
		                length+= mode.getStringBitsLength(modes[i].modeString.length);
		            }
	
		            return Math.ceil(length / 8);
		        };
	
		        var getVersion = function (dataCodewordsCount, errorCorrectionLevel){
		            var x = 0,
		                y = versionsCodewordsInformation.length - 1,
		                version = Math.floor(versionsCodewordsInformation.length / 2);
	
		            do{
		                if(dataCodewordsCount < versionsCodewordsInformation[version][errorCorrectionLevel].totalDataCodewords){
		                    y = version;
		                }
		                else{
		                    x = version;
		                }
		                version = x + Math.floor((y - x) / 2);
	
		            }while(y - x > 1);
	
		            if(dataCodewordsCount <= versionsCodewordsInformation[x][errorCorrectionLevel].totalDataCodewords){
		                return version + 1;
		            }
		            return y + 1;
		        };
	
		        var getDataString = function (modes, version){
		            var dataString = "",
		                mode;
		            for(var i = 0; i < modes.length; i++){
		                mode = modeInstances[modes[i].mode];
		                dataString+= mode.encode(modes[i].modeString, version);
		            }
	
		            return dataString;
		        };
	
		        //fix case all zeros
		        var encodeFormatInformation = function (format){
		            var formatNumber = toDecimal(format),
		                encodedString,
		                result = "";
		            if(formatNumber === 0){
		                return "101010000010010";
		            }
		            else{
		                encodedString = encodeBCH(toDecimal(format), formatGeneratorPolynomial, 15);
		            }
		            for(var i = 0; i < encodedString.length; i++){
		                result += encodedString.charAt(i) ^ formatMaskPattern.charAt(i);
		            }
	
		            return result;
		        };
	
		        var encodeBCH = function (value, generatorPolynomial, codeLength){
		            var generatorNumber = toDecimal(generatorPolynomial),
		                polynomialLength = generatorPolynomial.length - 1,
		                valueNumber = value << polynomialLength,
		                length = codeLength - polynomialLength,
		                valueString = toBitsString(value, length),
		                result = dividePolynomials(valueNumber, generatorNumber);
		            result = valueString + toBitsString(result, polynomialLength);
		            return result;
		        };
	
		        var dividePolynomials = function (numberX,numberY){
		                var yLength = numberY.toString(2).length,
		                    xLength = numberX.toString(2).length;
		                do{
		                    numberX ^= numberY << xLength - yLength;
		                    xLength = numberX.toString(2).length;
		                }
		                while(xLength >= yLength);
	
		                return numberX;
		        };
	
		        function getNumberAt(str, idx){
		            return parseInt(str.charAt(idx), 10);
		        }
	
		        var initMatrices = function (version){
		            var matrices = [],
		                modules =  17 + 4 * version;
		            for(var i = 0; i < maskPatternConditions.length; i++){
		                matrices[i] = new Array(modules);
		                for(var j = 0; j < modules; j++){
		                    matrices[i][j] = new Array(modules);
		                }
		            }
	
		            return matrices;
		        };
	
		        var addFormatInformation =function (matrices, formatString){
		            var matrix = matrices[0],
		                x,
		                y,
		                idx = 0,
		                length = formatString.length;
	
		            for(x=0, y=8; x <= 8;x++){
		                if(x!== 6){
		                    fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
		                }
		            }
	
		            for(x=8, y=7; y>=0;y--){
		                if(y!== 6){
		                    fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
		                }
		            }
		            idx=0;
		            for(y = matrix.length - 1, x = 8; y >= matrix.length - 8;y--){
		                fillFunctionCell(matrices,getNumberAt(formatString, length - 1 - idx++), x, y);
		            }
	
		            fillFunctionCell(matrices, 1, matrix.length - 8, 8);
	
		            for(x = matrix.length - 7, y = 8; x < matrix.length;x++){
		                fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
		            }
		        };
	
		        var encodeVersionInformation = function (version){
		            return encodeBCH(version, versionGeneratorPolynomial, 18);
		        };
	
		        var addVersionInformation = function (matrices, dataString){
		            var matrix = matrices[0],
		                modules = matrix.length,
		                x1 = 0,
		                y1 = modules - 11,
		                x2 = modules - 11,
		                y2 = 0,
		                quotient,
		                mod,
		                value;
	
		            for(var idx =0; idx < dataString.length; idx++){
		                quotient = Math.floor(idx / 3);
		                mod = idx % 3;
		                value = getNumberAt(dataString, dataString.length - idx - 1);
		                fillFunctionCell(matrices, value, x1 + quotient, y1 + mod);
		                fillFunctionCell(matrices, value, x2 + mod, y2 + quotient);
		            }
		        };
	
		        var addCentricPattern = function (matrices, pattern, x, y){
		            var size = pattern.length + 2,
		                length = pattern.length + 1,
		                value;
	
		            for(var i = 0; i < pattern.length; i++){
		                for(var j = i; j < size - i; j++){
		                    value = pattern[i];
		                    fillFunctionCell(matrices, value, x + j, y + i);
		                    fillFunctionCell(matrices, value, x + i, y + j);
		                    fillFunctionCell(matrices, value, x + length - j, y + length - i);
		                    fillFunctionCell(matrices, value, x + length - i, y + length - j);
		                }
		            }
		        };
	
		        var addFinderSeparator = function (matrices, direction, x, y){
		            var nextX = x,
		                nextY = y,
		                matrix = matrices[0];
		            do{
		                fillFunctionCell(matrices, 0, nextX, y);
		                fillFunctionCell(matrices, 0, x, nextY);
		                nextX+= direction[0];
		                nextY+= direction[1];
		            }
		            while(nextX >=0 && nextX < matrix.length);
		        };
	
		        var addFinderPatterns = function (matrices){
		            var modules = matrices[0].length;
		            addCentricPattern(matrices, finderPattern, 0, 0);
		            addFinderSeparator(matrices, [-1,-1], 7,7);
		            addCentricPattern(matrices, finderPattern, modules - 7, 0);
		            addFinderSeparator(matrices, [1,-1], modules - 8, 7);
		            addCentricPattern(matrices, finderPattern, 0 , modules - 7);
		            addFinderSeparator(matrices, [-1,1],7, modules - 8);
		        };
	
		        var addAlignmentPatterns = function (matrices, version){
		            if(version < 2) {
		                return;
		            }
	
		            var matrix = matrices[0],
		                modules = matrix.length,
		                pointsCount = Math.floor(version / 7),
		                points = [6],
		                startDistance,
		                distance,
		                idx = 0;
	
		            if((startDistance = irregularAlignmentPatternsStartDistance[version])){
		                distance = (modules - 13 - startDistance) / pointsCount;
		            }
		            else{
		                startDistance = distance = (modules - 13) / (pointsCount + 1);
		            }
		            points.push(points[idx++] + startDistance);
		            while((points[idx] + distance) < modules){
		                points.push(points[idx++] + distance);
		            }
		            for(var i = 0; i < points.length;i++){
		                for(var j = 0; j < points.length; j++){
		                    if(matrix[points[i]][points[j]] === undefined){
		                        addCentricPattern(matrices, alignmentPattern, points[i] - 2, points[j] - 2);
		                    }
		                }
		            }
		        };
	
		        var addTimingFunctions = function (matrices){
		            var row = 6,
		                column = 6,
		                value = 1,
		                modules = matrices[0].length;
		            for(var i = 8; i < modules - 8;i++){
		                fillFunctionCell(matrices, value, row, i);
		                fillFunctionCell(matrices, value, i, column);
		                value ^= 1;
		            }
		        };
	
		        var scoreMaskMatrixes = function (matrices){
		            var scores = [],
		                previousBits = [],
		                darkModules =  [],
		                patterns = [],
		                adjacentSameBits = [],
		                matrix,
		                i,
		                row = 0,
		                column = 1,
		                modules = matrices[0].length;
	
	
		            for(i = 0; i < matrices.length; i++){
		                scores[i] = 0;
		                darkModules[i] = 0;
		                adjacentSameBits[i] = [0,0];
		                patterns[i] = [0, 0];
		                previousBits[i] = [];
		            }
		            for(i = 0; i < modules; i++){
		                for(var j = 0; j < modules; j++){
		                    for(var k = 0; k < matrices.length; k++){
		                        matrix = matrices[k];
		                        darkModules[k]+= parseInt(matrix[i][j], 10);
		                        if(previousBits[k][row] === matrix[i][j] && i + 1 < modules && j - 1 >= 0 &&
		                            matrix[i + 1][j] == previousBits[k][row] && matrix[i + 1][j - 1] == previousBits[k][row]){
		                            scores[k]+=3;
		                        }
		                        scoreFinderPatternOccurance(k, patterns, scores, row, matrix[i][j]);
		                        scoreFinderPatternOccurance(k, patterns, scores, column, matrix[j][i]);
		                        scoreAdjacentSameBits(k,scores,previousBits,matrix[i][j],adjacentSameBits,row);
		                        scoreAdjacentSameBits(k,scores,previousBits,matrix[j][i],adjacentSameBits,column);
		                    }
		                }
		            }
		            var total = modules * modules,
		                minIdx,
		                min = Number.MAX_VALUE;
	
		            for(i = 0; i < scores.length; i++){
		                scores[i]+= calculateDarkModulesRatioScore(darkModules[i], total);
		                if(scores[i] < min){
		                    min = scores[i];
		                    minIdx = i;
		                }
		            }
	
		            return minIdx;
		        };
	
		        function scoreFinderPatternOccurance(idx, patterns, scores, rowColumn, bit){
		            patterns[idx][rowColumn] = ((patterns[idx][rowColumn] << 1) ^ bit) % 128;
		            if(patterns[idx][rowColumn] == finderPatternValue){
		                scores[idx] += 40;
		            }
		        }
	
		        function scoreAdjacentSameBits(idx, scores, previousBits, bit, adjacentBits, rowColumn){
		            if(previousBits[idx][rowColumn] == bit){
		                adjacentBits[idx][rowColumn]++;
		            }
		            else{
		                previousBits[idx][rowColumn] = bit;
		                if(adjacentBits[idx][rowColumn] >= 5){
		                    scores[idx]+= 3 + adjacentBits[idx][rowColumn] - 5;
		                }
		                adjacentBits[idx][rowColumn] = 1;
		            }
		        }
	
		        function calculateDarkModulesRatioScore(darkModules, total){
		            var percent = Math.floor((darkModules / total) * 100),
		                mod5 = percent % 5,
		                previous = Math.abs(percent - mod5 - 50),
		                next = Math.abs(percent +  5 - mod5 - 50),
		                score = 10 * Math.min(previous / 5, next / 5);
		            return score;
		        }
	
		        var EncodingResult = function(dataString, version){
		            this.dataString = dataString;
		            this.version = version;
		        };
	
		        var IsoEncoder = function(){
		            this.getEncodingResult = function(inputString, errorCorrectionLevel){
		                var modes = getModes(inputString),
		                dataCodewordsCount = getDataCodewordsCount(modes),
		                version = getVersion(dataCodewordsCount, errorCorrectionLevel),
		                dataString = getDataString(modes, version);
	
		                return new EncodingResult(dataString, version);
		            };
		        };
	
		        var UTF8Encoder = function(){
		            this.mode = modeInstances[this.encodingMode];
		        };
	
		        UTF8Encoder.fn = UTF8Encoder.prototype = {
		            encodingMode: BYTE,
		            utfBOM: "111011111011101110111111",
		            initialModeCountStringLength: 20,
		            getEncodingResult: function(inputString, errorCorrectionLevel){
		                var that = this,
		                    data = that.encode(inputString),
		                    dataCodewordsCount = that.getDataCodewordsCount(data),
		                    version = getVersion(dataCodewordsCount, errorCorrectionLevel),
		                    dataString = that.mode.getModeCountString(data.length / 8, version) + data;
	
		                return new EncodingResult(dataString, version);
		            },
		            getDataCodewordsCount: function(data){
		                var that = this,
		                    dataLength = data.length,
		                    dataCodewordsCount = Math.ceil(( that.initialModeCountStringLength + dataLength) / 8);
	
		                return dataCodewordsCount;
		            },
		            encode: function(str){
		                var that = this,
		                    result = that.utfBOM;
		                for(var i = 0; i < str.length; i++){
		                    result += that.encodeCharacter(str.charCodeAt(i));
		                }
		                return result;
		            },
		            encodeCharacter: function(code){
		                var bytesCount = this.getBytesCount(code),
		                    bc = bytesCount - 1,
		                    result = "";
	
		                if(bytesCount == 1){
		                    result = toBitsString(code, 8);
		                }
		                else{
		                    var significantOnes = 8 - bytesCount;
	
		                    for(var i = 0; i < bc; i++){
		                        result = toBitsString(code >> (i * 6) & 63 | 128, 8) + result;
		                    }
	
		                    result = ((code >> bc * 6) | ((255 >> significantOnes) << significantOnes)).toString(2) + result;
		                }
		                return result;
		            },
		            getBytesCount: function(code){
		                var ranges = this.ranges;
		                for(var i = 0; i < ranges.length;i++){
		                    if(code < ranges[i]){
		                        return i + 1;
		                    }
		                }
		            },
		            ranges: [128,2048,65536,2097152,67108864]
		        };
	
		        var QRCodeDataEncoder = function(encoding){
		            if(encoding && encoding.toLowerCase().indexOf("utf_8") >= 0){
		                return new UTF8Encoder();
		            }
		            else{
		                return new IsoEncoder();
		            }
		        };
	
		        var encodeData = function (inputString, errorCorrectionLevel, encoding){
		            var encoder = new QRCodeDataEncoder(encoding),
		                encodingResult = encoder.getEncodingResult(inputString, errorCorrectionLevel),
		                version = encodingResult.version,
		                versionInformation = versionsCodewordsInformation[version - 1][errorCorrectionLevel],
		                dataString = padDataString(encodingResult.dataString, versionInformation.totalDataCodewords),
		                blocks = getBlocks(dataString, versionInformation),
		                matrices = initMatrices(version);
	
		            addFinderPatterns(matrices);
		            addAlignmentPatterns(matrices, version);
		            addTimingFunctions(matrices);
	
		            if(version >= 7){
		                addVersionInformation(matrices, toBitsString(0, 18));
		            }
	
		            addFormatInformation(matrices, toBitsString(0, 15));
		            fillData(matrices, blocks);
	
		            var minIdx = scoreMaskMatrixes(matrices),
		                optimalMatrix = matrices[minIdx];
	
		            if(version >= 7){
		                addVersionInformation([optimalMatrix], encodeVersionInformation(version));
		            }
	
		            var formatString = errorCorrectionPatterns[errorCorrectionLevel] + toBitsString(minIdx, 3);
		            addFormatInformation([optimalMatrix], encodeFormatInformation(formatString));
	
		            return optimalMatrix;
		        };
	
		        var QRCodeDefaults= {
		            DEFAULT_SIZE: 200,
		            QUIET_ZONE_LENGTH: 4,
		            DEFAULT_ERROR_CORRECTION_LEVEL:"L",
		            DEFAULT_BACKGROUND: "#fff",
		            DEFAULT_DARK_MODULE_COLOR: "#000",
		            MIN_BASE_UNIT_SIZE: 1
		        };
	
		        var QRCode = Widget.extend({
		            init: function (element, options) {
		                var that = this;
	
		                Widget.fn.init.call(that, element, options);
	
		                that.element = $(element);
		                that.wrapper = that.element;
		                that.element.addClass("k-qrcode");
		                that.surfaceWrap = $("<div />").css("position", "relative").appendTo(this.element);
		                that.surface = draw.Surface.create(that.surfaceWrap, {
		                    type: that.options.renderAs
		                });
		                that.setOptions(options);
		            },
	
		            redraw: function(){
		                var size = this._getSize();
	
		                this.surfaceWrap.css({
		                    width: size,
		                    height: size
		                });
		                this.surface.clear();
	
		                this.createVisual();
		                this.surface.draw(this.visual);
		            },
	
		            getSize: function() {
		                return kendo.dimensions(this.element);
		            },
	
		            _resize: function() {
		                this.redraw();
		            },
	
		            createVisual: function() {
		                this.visual = this._render();
		            },
	
		            exportVisual: function() {
		                return this._render();
		            },
	
		            _render: function() {
		                var that = this,
		                    value = that._value,
		                    baseUnit,
		                    border = that.options.border || {},
		                    padding = that.options.padding || 0,
		                    borderWidth = border.width || 0,
		                    quietZoneSize,
		                    matrix,
		                    size,
		                    dataSize,
		                    contentSize;
	
		                border.width = borderWidth;
	
		                var visual = new draw.Group();
	
		                if (value){
		                    matrix = encodeData(value, that.options.errorCorrection, that.options.encoding);
		                    size = that._getSize();
		                    contentSize = size - 2  * (borderWidth + padding);
		                    baseUnit = that._calculateBaseUnit(contentSize, matrix.length);
		                    dataSize = matrix.length * baseUnit;
		                    quietZoneSize = borderWidth + padding + (contentSize - dataSize) / 2;
	
		                    visual.append(that._renderBackground(size, border));
		                    visual.append(that._renderMatrix(matrix, baseUnit, quietZoneSize));
		                }
	
		                return visual;
		            },
	
		            _getSize: function(){
		                var that = this,
		                    size;
	
		                if (that.options.size){
		                   size = parseInt(that.options.size, 10);
		                } else {
		                    var element = that.element,
		                        min = Math.min(element.width(), element.height());
	
		                    if (min > 0){
		                        size = min;
		                    } else {
		                        size = QRCodeDefaults.DEFAULT_SIZE;
		                    }
		                }
	
		                return size;
		            },
	
		            _calculateBaseUnit: function(size, matrixSize){
		                var baseUnit = Math.floor(size/ matrixSize);
	
		                if(baseUnit < QRCodeDefaults.MIN_BASE_UNIT_SIZE){
		                    throw new Error("Insufficient size.");
		                }
	
		                if(baseUnit * matrixSize >= size &&
		                    baseUnit - 1 >= QRCodeDefaults.MIN_BASE_UNIT_SIZE){
		                    baseUnit--;
		                }
	
		                return baseUnit;
		            },
	
		            _renderMatrix: function(matrix, baseUnit, quietZoneSize){
		                var path = new draw.MultiPath({
		                    fill: {
		                        color: this.options.color
		                    },
		                    stroke: null
		                });
	
		                for (var row = 0; row < matrix.length; row++){
		                    var y = quietZoneSize + row * baseUnit;
		                    var column = 0;
	
		                    while (column < matrix.length){
		                        while (matrix[row][column] === 0 && column < matrix.length){
		                            column++;
		                        }
	
		                        if (column < matrix.length){
		                            var x = column;
		                            while (matrix[row][column] == 1){
		                                column++;
		                            }
	
		                            var x1 = round(quietZoneSize + x * baseUnit);
		                            var y1 = round(y);
		                            var x2 = round(quietZoneSize + column * baseUnit);
		                            var y2 = round(y + baseUnit);
	
		                            path.moveTo(x1, y1)
		                                .lineTo(x1, y2)
		                                .lineTo(x2, y2)
		                                .lineTo(x2, y1)
		                                .close();
		                        }
		                    }
		                }
	
		                return path;
		            },
	
		            _renderBackground: function (size, border) {
		                var box = new Box2D(0,0, size, size).unpad(border.width / 2);
		                return draw.Path.fromRect(box.toRect(), {
		                    fill: {
		                        color: this.options.background
		                    },
		                    stroke: {
		                        color: border.color,
		                        width: border.width
		                    }
		                });
		            },
	
		            setOptions: function (options) {
		                var that = this;
		                options = options || {};
		                that.options = extend(that.options, options);
		                if (options.value !== undefined) {
		                    that._value = that.options.value + "";
		                }
		                that.redraw();
		            },
		            value: function(value){
		                var that = this;
		                if (value === undefined) {
		                    return that._value;
		                }
		                that._value = value + "";
		                that.redraw();
		            },
		            options: {
		                name: "QRCode",
		                renderAs: "svg",
		                encoding: "ISO_8859_1",
		                value: "",
		                errorCorrection: QRCodeDefaults.DEFAULT_ERROR_CORRECTION_LEVEL,
		                background: QRCodeDefaults.DEFAULT_BACKGROUND,
		                color: QRCodeDefaults.DEFAULT_DARK_MODULE_COLOR,
		                size: "",
		                padding: 0,
		                border: {
		                    color: "",
		                    width: 0
		                }
		            }
		        });
	
		        dataviz.ExportMixin.extend(QRCode.fn);
		        dataviz.ui.plugin(QRCode);
	
		      kendo.deepExtend(dataviz, {
		            QRCode: QRCode,
		            QRCodeDefaults: QRCodeDefaults,
		            QRCodeFunctions: {
		                FreeCellVisitor: FreeCellVisitor,
		                fillData: fillData,
		                padDataString: padDataString,
		                generateErrorCodewords: generateErrorCodewords,
		                xorPolynomials: xorPolynomials,
		                getBlocks: getBlocks,
		                multiplyPolynomials: multiplyPolynomials,
		                chooseMode: chooseMode,
		                getModes: getModes,
		                getDataCodewordsCount: getDataCodewordsCount,
		                getVersion: getVersion,
		                getDataString: getDataString,
		                encodeFormatInformation: encodeFormatInformation,
		                encodeBCH: encodeBCH,
		                dividePolynomials: dividePolynomials,
		                initMatrices: initMatrices,
		                addFormatInformation: addFormatInformation,
		                encodeVersionInformation: encodeVersionInformation,
		                addVersionInformation: addVersionInformation,
		                addCentricPattern: addCentricPattern,
		                addFinderSeparator: addFinderSeparator,
		                addFinderPatterns: addFinderPatterns,
		                addAlignmentPatterns: addAlignmentPatterns,
		                addTimingFunctions: addTimingFunctions,
		                scoreMaskMatrixes: scoreMaskMatrixes,
		                encodeData: encodeData,
		                UTF8Encoder: UTF8Encoder
		            },
		            QRCodeFields: {
		                modes: modeInstances,
		                powersOfTwo: powersOfTwo,
		                powersOfTwoResult: powersOfTwoResult,
		                generatorPolynomials: generatorPolynomials
		            }
		      });
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1106);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1106:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1107), __webpack_require__(1108) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.stockchart",
		    name: "StockChart",
		    category: "dataviz",
		    description: "StockChart widget and associated financial series.",
		    depends: [ "dataviz.chart" ]
		};
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1107:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(758);
	
	/***/ }),
	
	/***/ 1108:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(759);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(912);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 909:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(749);
	
	/***/ }),
	
	/***/ 912:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(909)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function () {
	
		window.kendo.dataviz = window.kendo.dataviz || {};
		var dataviz = kendo.dataviz;
		var elementStyles = dataviz.elementStyles;
		var deepExtend = dataviz.deepExtend;
		var toTime = dataviz.toTime;
		var datavizConstants = dataviz.constants;
		var Chart = dataviz.Chart;
		var drawing = kendo.drawing;
	
		var FadeOutAnimation = drawing.Animation.extend({
		    setup: function() {
		        this._initialOpacity = parseFloat(elementStyles(this.element, 'opacity').opacity);
		    },
	
		    step: function(pos) {
		        elementStyles(this.element, {
		            opacity: String(dataviz.interpolateValue(this._initialOpacity, 0, pos))
		        });
		    },
	
		    abort: function() {
		        drawing.Animation.fn.abort.call(this);
		        elementStyles(this.element, {
		            display: 'none',
		            opacity: String(this._initialOpacity)
		        });
		    },
	
		    cancel: function() {
		        drawing.Animation.fn.abort.call(this);
		        elementStyles(this.element, {
		            opacity: String(this._initialOpacity)
		        });
		    }
		});
	
		function createDiv(className, style) {
		    var div = document.createElement("div");
		    div.className = className;
		    if (style) {
		        div.style.cssText = style;
		    }
	
		    return div;
		}
	
		var NavigatorHint = dataviz.Class.extend({
		    init: function(container, chartService, options) {
	
		        this.options = deepExtend({}, this.options, options);
		        this.container = container;
		        this.chartService = chartService;
	
		        var padding = elementStyles(container, [ "paddingLeft", "paddingTop" ]);
		        this.chartPadding = {
		            top: padding.paddingTop,
		            left: padding.paddingLeft
		        };
	
		        this.createElements();
		        container.appendChild(this.element);
		    },
	
		    createElements: function() {
		        var element = this.element = createDiv('k-navigator-hint', 'display: none; position: absolute; top: 1px; left: 1px;');
		        var tooltip = this.tooltip = createDiv('k-tooltip k-chart-tooltip');
		        var scroll = this.scroll = createDiv('k-scroll');
	
		        tooltip.innerHTML = '&nbsp;';
	
		        element.appendChild(tooltip);
		        element.appendChild(scroll);
		    },
	
		    show: function(from, to, bbox) {
		        var ref = this;
		        var element = ref.element;
		        var options = ref.options;
		        var scroll = ref.scroll;
		        var tooltip = ref.tooltip;
		        var middle = dataviz.toDate(toTime(from) + toTime(to - from) / 2);
		        var scrollWidth = bbox.width() * 0.4;
		        var minPos = bbox.center().x - scrollWidth;
		        var maxPos = bbox.center().x;
		        var posRange = maxPos - minPos;
		        var range = options.max - options.min;
		        var scale = posRange / range;
		        var offset = middle - options.min;
		        var text = this.chartService.intl.format(options.format, from, to);
		        var template = dataviz.getTemplate(options);
	
		        this.clearHideTimeout();
	
		        if (!this._visible) {
		            elementStyles(element, {
		                visibility: 'hidden',
		                display: 'block'
		            });
		            this._visible = true;
		        }
	
		        if (template) {
		            text = template({
		                from: from,
		                to: to
		            });
		        }
	
		        tooltip.innerHTML = text;
		        elementStyles(tooltip, {
		            left: bbox.center().x - tooltip.offsetWidth / 2,
		            top: bbox.y1
		        });
	
		        var tooltipStyle = elementStyles(tooltip, [ 'marginTop', 'borderTopWidth', 'height' ]);
	
		        elementStyles(scroll, {
		            width: scrollWidth,
		            left: minPos + offset * scale,
		            top: bbox.y1 + tooltipStyle.marginTop + tooltipStyle.borderTopWidth + tooltipStyle.height / 2
		        });
	
		        elementStyles(element, {
		            visibility: 'visible'
		        });
		    },
	
		    clearHideTimeout: function() {
		        if (this._hideTimeout) {
		            clearTimeout(this._hideTimeout);
		        }
	
		        if (this._hideAnimation) {
		            this._hideAnimation.cancel();
		        }
		    },
	
		    hide: function() {
		        var this$1 = this;
	
		        this.clearHideTimeout();
	
		        this._hideTimeout = setTimeout(function () {
		            this$1._visible = false;
		            this$1._hideAnimation = new FadeOutAnimation(this$1.element);
		            this$1._hideAnimation.setup();
		            this$1._hideAnimation.play();
		        }, this.options.hideDelay);
		    },
	
		    destroy: function() {
		        this.clearHideTimeout();
		        if (this.container) {
		            this.container.removeChild(this.element);
		        }
		        delete this.container;
		        delete this.chartService;
		        delete this.element;
		        delete this.tooltip;
		        delete this.scroll;
		    }
		});
	
		dataviz.setDefaultOptions(NavigatorHint, {
		    format: "{0:d} - {1:d}",
		    hideDelay: 500
		});
	
		var NAVIGATOR_PANE = "_navigator";
		var NAVIGATOR_AXIS = NAVIGATOR_PANE;
	
		var constants = {
			NAVIGATOR_AXIS: NAVIGATOR_AXIS,
			NAVIGATOR_PANE: NAVIGATOR_PANE
		};
	
		var ZOOM_ACCELERATION = 3;
	
		var Navigator = dataviz.Class.extend({
		    init: function(chart) {
	
		        this.chart = chart;
		        var options = this.options = deepExtend({}, this.options, chart.options.navigator);
		        var select = options.select;
		        if (select) {
		            select.from = this.parseDate(select.from);
		            select.to = this.parseDate(select.to);
		        }
	
		        if (!dataviz.defined(options.hint.visible)) {
		            options.hint.visible = options.visible;
		        }
	
		        var obj;
		        this.chartObserver = new dataviz.InstanceObserver(this, ( obj = {}, obj[datavizConstants.DRAG] = '_drag', obj[datavizConstants.DRAG_END] = '_dragEnd', obj[datavizConstants.ZOOM] = '_zoom', obj[datavizConstants.ZOOM_END] = '_zoomEnd', obj ));
		        chart.addObserver(this.chartObserver);
		    },
	
		    parseDate: function(value) {
		        return dataviz.parseDate(this.chart.chartService.intl, value);
		    },
	
		    clean: function() {
		        if (this.selection) {
		            this.selection.destroy();
		            this.selection = null;
		        }
	
		        if (this.hint) {
		            this.hint.destroy();
		            this.hint = null;
		        }
		    },
	
		    destroy: function() {
		        if (this.chart) {
		            this.chart.removeObserver(this.chartObserver);
		            delete this.chart;
		        }
	
		        this.clean();
		    },
	
		    redraw: function() {
		        this._redrawSelf();
		        this.initSelection();
		    },
	
		    initSelection: function() {
		        var ref = this;
		        var chart = ref.chart;
		        var options = ref.options;
		        var axis = this.mainAxis();
		        var ref$1 = axis.roundedRange();
		        var min = ref$1.min;
		        var max = ref$1.max;
		        var ref$2 = options.select;
		        var from = ref$2.from;
		        var to = ref$2.to;
		        var mousewheel = ref$2.mousewheel;
		        var axisClone = clone(axis);
	
		        if (axis.categoriesCount() === 0) {
		            return;
		        }
	
		        this.clean();
	
		        // "Freeze" the selection axis position until the next redraw
		        axisClone.box = axis.box;
	
		        this.selection = new dataviz.Selection(chart, axisClone, {
		            min: min,
		            max: max,
		            from: from || min,
		            to: to || max,
		            mousewheel: dataviz.valueOrDefault(mousewheel, { zoom: "left" }),
		            visible: options.visible
		        }, new dataviz.InstanceObserver(this, {
		            selectStart: '_selectStart',
		            select: '_select',
		            selectEnd: '_selectEnd'
		        }));
	
		        if (options.hint.visible) {
		            this.hint = new NavigatorHint(chart.element, chart.chartService, {
		                min: min,
		                max: max,
		                template: dataviz.getTemplate(options.hint),
		                format: options.hint.format
		            });
		        }
		    },
	
		    setRange: function() {
		        var plotArea = this.chart._createPlotArea(true);
		        var axis = plotArea.namedCategoryAxes[NAVIGATOR_AXIS];
	
		        var ref = axis.roundedRange();
		        var min = ref.min;
		        var max = ref.max;
	
		        var select = this.options.select || {};
		        var from = select.from || min;
		        if (from < min) {
		            from = min;
		        }
	
		        var to = select.to || max;
		        if (to > max) {
		            to = max;
		        }
	
		        this.options.select = deepExtend({}, select, {
		            from: from,
		            to: to
		        });
	
		        this.filterAxes();
		    },
	
		    _redrawSelf: function(silent) {
		        var plotArea = this.chart._plotArea;
	
		        if (plotArea) {
		            plotArea.redraw(dataviz.last(plotArea.panes), silent);
		        }
		    },
	
		    redrawSlaves: function() {
		        var chart = this.chart;
		        var plotArea = chart._plotArea;
		        var slavePanes = plotArea.panes.slice(0, -1);
	
		        // Update the original series and categoryAxis before partial refresh.
		        plotArea.srcSeries = chart.options.series;
		        plotArea.options.categoryAxis = chart.options.categoryAxis;
		        plotArea.clearSeriesPointsCache();
	
		        plotArea.redraw(slavePanes);
		    },
	
		    _drag: function(e) {
		        var ref = this;
		        var chart = ref.chart;
		        var selection = ref.selection;
		        var coords = chart._eventCoordinates(e.originalEvent);
		        var navigatorAxis = this.mainAxis();
		        var naviRange = navigatorAxis.roundedRange();
		        var inNavigator = navigatorAxis.pane.box.containsPoint(coords);
		        var axis = chart._plotArea.categoryAxis;
		        var range = e.axisRanges[axis.options.name];
		        var select = this.options.select;
		        var duration;
	
		        if (!range || inNavigator || !selection) {
		            return;
		        }
	
		        if (select.from && select.to) {
		            duration = toTime(select.to) - toTime(select.from);
		        } else {
		            duration = toTime(selection.options.to) - toTime(selection.options.from);
		        }
	
		        var from = dataviz.toDate(dataviz.limitValue(
		            toTime(range.min),
		            naviRange.min, toTime(naviRange.max) - duration
		        ));
	
		        var to = dataviz.toDate(dataviz.limitValue(
		            toTime(from) + duration,
		            toTime(naviRange.min) + duration, naviRange.max
		        ));
	
		        this.options.select = { from: from, to: to };
	
		        if (this.options.liveDrag) {
		            this.filterAxes();
		            this.redrawSlaves();
		        }
	
		        selection.set(from, to);
	
		        this.showHint(from, to);
		    },
	
		    _dragEnd: function() {
		        this.filterAxes();
		        this.filter();
		        this.redrawSlaves();
	
		        if (this.hint) {
		            this.hint.hide();
		        }
		    },
	
		    readSelection: function() {
		        var ref = this;
		        var ref_selection_options = ref.selection.options;
		        var from = ref_selection_options.from;
		        var to = ref_selection_options.to;
		        var select = ref.options.select;
	
		        select.from = from;
		        select.to = to;
		    },
	
		    filterAxes: function() {
		        var ref = this;
		        var select = ref.options.select; if (select === void 0) { select = { }; }
		        var chart = ref.chart;
		        var allAxes = chart.options.categoryAxis;
		        var from = select.from;
		        var to = select.to;
	
		        for (var idx = 0; idx < allAxes.length; idx++) {
		            var axis = allAxes[idx];
		            if (axis.pane !== NAVIGATOR_PANE) {
		                axis.min = from;
		                axis.max = to;
		            }
		        }
		    },
	
		    filter: function() {
		        var ref = this;
		        var chart = ref.chart;
		        var select = ref.options.select;
		        if (chart.requiresHandlers([ "navigatorFilter" ])) {
		            var axisOptions = new dataviz.DateCategoryAxis(deepExtend({
		                baseUnit: "fit"
		            }, chart.options.categoryAxis[0], {
		                categories: [ select.from, select.to ]
		            }), chart.chartService).options;
	
		            this.chart.trigger("navigatorFilter", {
		                from: dataviz.addDuration(axisOptions.min, -axisOptions.baseUnitStep, axisOptions.baseUnit),
		                to: dataviz.addDuration(axisOptions.max, axisOptions.baseUnitStep, axisOptions.baseUnit)
		            });
		        }
		    },
	
		    _zoom: function(e) {
		        var ref = this;
		        var axis = ref.chart._plotArea.categoryAxis;
		        var selection = ref.selection;
		        var ref_options = ref.options;
		        var select = ref_options.select;
		        var liveDrag = ref_options.liveDrag;
		        var mainAxis = this.mainAxis();
		        var delta = e.delta;
	
		        if (!selection) {
		            return;
		        }
	
		        var fromIx = mainAxis.categoryIndex(selection.options.from);
		        var toIx = mainAxis.categoryIndex(selection.options.to);
	
		        e.originalEvent.preventDefault();
	
		        if (Math.abs(delta) > 1) {
		            delta *= ZOOM_ACCELERATION;
		        }
	
		        if (toIx - fromIx > 1) {
		            selection.expand(delta);
		            this.readSelection();
		        } else {
		            axis.options.min = select.from;
		            select.from = axis.scaleRange(-e.delta).min;
		        }
	
		        if (liveDrag) {
		            this.filterAxes();
		            this.redrawSlaves();
		        }
	
		        selection.set(select.from, select.to);
	
		        this.showHint(this.options.select.from, this.options.select.to);
		    },
	
		    _zoomEnd: function(e) {
		        this._dragEnd(e);
		    },
	
		    showHint: function(from, to) {
		        var plotArea = this.chart._plotArea;
	
		        if (this.hint) {
		            this.hint.show(from, to, plotArea.backgroundBox());
		        }
		    },
	
		    _selectStart: function(e) {
		        return this.chart._selectStart(e);
		    },
	
		    _select: function(e) {
		        this.showHint(e.from, e.to);
	
		        return this.chart._select(e);
		    },
	
		    _selectEnd: function(e) {
		        if (this.hint) {
		            this.hint.hide();
		        }
	
		        this.readSelection();
		        this.filterAxes();
		        this.filter();
		        this.redrawSlaves();
	
		        return this.chart._selectEnd(e);
		    },
	
		    mainAxis: function() {
		        var plotArea = this.chart._plotArea;
	
		        if (plotArea) {
		            return plotArea.namedCategoryAxes[NAVIGATOR_AXIS];
		        }
		    },
	
		    select: function(from, to) {
		        var select = this.options.select;
	
		        if (from && to) {
		            select.from = this.parseDate(from);
		            select.to = this.parseDate(to);
	
		            this.filterAxes();
		            this.filter();
		            this.redrawSlaves();
	
		            this.selection.set(from, to);
		        }
	
		        return {
		            from: select.from,
		            to: select.to
		        };
		    }
		});
	
		Navigator.setup = function(options, themeOptions) {
		    if (options === void 0) { options = {}; }
		    if (themeOptions === void 0) { themeOptions = {}; }
	
		    if (options.__navi) {
		        return;
		    }
		    options.__navi = true;
	
		    var naviOptions = deepExtend({}, themeOptions.navigator, options.navigator);
		    var panes = options.panes = [].concat(options.panes);
		    var paneOptions = deepExtend({}, naviOptions.pane, { name: NAVIGATOR_PANE });
	
		    if (!naviOptions.visible) {
		        paneOptions.visible = false;
		        paneOptions.height = 0.1;
		    }
	
		    panes.push(paneOptions);
	
		    Navigator.attachAxes(options, naviOptions);
		    Navigator.attachSeries(options, naviOptions, themeOptions);
		};
	
		Navigator.attachAxes = function(options, naviOptions) {
		    var series = naviOptions.series || [];
		    var categoryAxes = options.categoryAxis = [].concat(options.categoryAxis);
		    var valueAxes = options.valueAxis = [].concat(options.valueAxis);
	
		    var equallySpacedSeries = dataviz.filterSeriesByType(series, datavizConstants.EQUALLY_SPACED_SERIES);
		    var justifyAxis = equallySpacedSeries.length === 0;
	
		    var base = deepExtend({
		        type: "date",
		        pane: NAVIGATOR_PANE,
		        roundToBaseUnit: !justifyAxis,
		        justified: justifyAxis,
		        _collapse: false,
		        majorTicks: { visible: true },
		        tooltip: { visible: false },
		        labels: { step: 1 },
		        autoBind: naviOptions.autoBindElements,
		        autoBaseUnitSteps: {
		            minutes: [ 1 ],
		            hours: [ 1, 2 ],
		            days: [ 1, 2 ],
		            weeks: [],
		            months: [ 1 ],
		            years: [ 1 ]
		        }
		    });
		    var user = naviOptions.categoryAxis;
	
		    categoryAxes.push(
		        deepExtend({}, base, {
		            maxDateGroups: 200
		        }, user, {
		            name: NAVIGATOR_AXIS,
		            title: null,
		            baseUnit: "fit",
		            baseUnitStep: "auto",
		            labels: { visible: false },
		            majorTicks: { visible: false }
		        }), deepExtend({}, base, user, {
		            name: NAVIGATOR_AXIS + "_labels",
		            maxDateGroups: 20,
		            baseUnitStep: "auto",
		            labels: { position: "" },
		            plotBands: [],
		            autoBaseUnitSteps: {
		                minutes: []
		            },
		            _overlap: true
		        }), deepExtend({}, base, user, {
		            name: NAVIGATOR_AXIS + "_ticks",
		            maxDateGroups: 200,
		            majorTicks: {
		                width: 0.5
		            },
		            plotBands: [],
		            title: null,
		            labels: { visible: false, mirror: true },
		            _overlap: true
		        })
		    );
	
		    valueAxes.push(deepExtend({
		        name: NAVIGATOR_AXIS,
		        pane: NAVIGATOR_PANE,
		        majorGridLines: {
		            visible: false
		        },
		        visible: false
		    }, naviOptions.valueAxis));
		};
	
		Navigator.attachSeries = function(options, naviOptions, themeOptions) {
		    var series = options.series = options.series || [];
		    var navigatorSeries = [].concat(naviOptions.series || []);
		    var seriesColors = themeOptions.seriesColors;
		    var defaults = naviOptions.seriesDefaults;
	
		    for (var idx = 0; idx < navigatorSeries.length; idx++) {
		        series.push(
		            deepExtend({
		                color: seriesColors[idx % seriesColors.length],
		                categoryField: naviOptions.dateField,
		                visibleInLegend: false,
		                tooltip: {
		                    visible: false
		                }
		            }, defaults, navigatorSeries[idx], {
		                axis: NAVIGATOR_AXIS,
		                categoryAxis: NAVIGATOR_AXIS,
		                autoBind: naviOptions.autoBindElements
		            })
		        );
		    }
		};
	
		function ClonedObject() { }
		function clone(obj) {
		    ClonedObject.prototype = obj;
		    return new ClonedObject();
		}
	
		var AUTO_CATEGORY_WIDTH = 28;
	
		var StockChart = Chart.extend({
		    applyDefaults: function(options, themeOptions) {
		        var width = dataviz.elementSize(this.element).width || datavizConstants.DEFAULT_WIDTH;
		        var theme = themeOptions;
	
		        var stockDefaults = {
		            seriesDefaults: {
		                categoryField: options.dateField
		            },
		            axisDefaults: {
		                categoryAxis: {
		                    name: "default",
		                    majorGridLines: {
		                        visible: false
		                    },
		                    labels: {
		                        step: 2
		                    },
		                    majorTicks: {
		                        visible: false
		                    },
		                    maxDateGroups: Math.floor(width / AUTO_CATEGORY_WIDTH)
		                }
		            }
		        };
	
		        if (theme) {
		            theme = deepExtend({}, theme, stockDefaults);
		        }
	
		        Navigator.setup(options, theme);
	
		        Chart.fn.applyDefaults.call(this, options, theme);
		    },
	
		    _setElementClass: function(element) {
		        dataviz.addClass(element, 'k-chart k-stockchart');
		    },
	
		    setOptions: function(options) {
		        this.destroyNavigator();
		        Chart.fn.setOptions.call(this, options);
		    },
	
		    noTransitionsRedraw: function() {
		        var transitions = this.options.transitions;
	
		        this.options.transitions = false;
		        this._fullRedraw();
		        this.options.transitions = transitions;
		    },
	
		    _resize: function() {
		        this.noTransitionsRedraw();
		    },
	
		    _redraw: function() {
		        var navigator = this.navigator;
	
		        if (!this._dirty() && navigator && navigator.options.partialRedraw) {
		            navigator.redrawSlaves();
		        } else {
		            this._fullRedraw();
		        }
		    },
	
		    _dirty: function() {
		        var options = this.options;
		        var series = [].concat(options.series, options.navigator.series);
		        var seriesCount = dataviz.grep(series, function(s) { return s && s.visible; }).length;
		        var dirty = this._seriesCount !== seriesCount;
		        this._seriesCount = seriesCount;
	
		        return dirty;
		    },
	
		    _fullRedraw: function() {
		        var navigator = this.navigator;
	
		        if (!navigator) {
		            navigator = this.navigator = new Navigator(this);
		            this.trigger("navigatorCreated", { navigator: navigator });
		        }
	
		        navigator.clean();
		        navigator.setRange();
	
		        Chart.fn._redraw.call(this);
	
		        navigator.initSelection();
		    },
	
		    _trackSharedTooltip: function(coords) {
		        var plotArea = this._plotArea;
		        var pane = plotArea.paneByPoint(coords);
	
		        if (pane && pane.options.name === NAVIGATOR_PANE) {
		            this._unsetActivePoint();
		        } else {
		            Chart.fn._trackSharedTooltip.call(this, coords);
		        }
		    },
	
		    bindCategories: function() {
		        Chart.fn.bindCategories.call(this);
		        this.copyNavigatorCategories();
		    },
	
		    copyNavigatorCategories: function() {
		        var definitions = [].concat(this.options.categoryAxis);
		        var categories;
	
		        for (var axisIx = 0; axisIx < definitions.length; axisIx++) {
		            var axis = definitions[axisIx];
		            if (axis.name === NAVIGATOR_AXIS) {
		                categories = axis.categories;
		            } else if (categories && axis.pane === NAVIGATOR_PANE) {
		                axis.categories = categories;
		            }
		        }
		    },
	
		    destroyNavigator: function() {
		        if (this.navigator) {
		            this.navigator.destroy();
		            this.navigator = null;
		        }
		    },
	
		    destroy: function() {
		        this.destroyNavigator();
		        Chart.fn.destroy.call(this);
		    },
	
		    _stopChartHandlers: function(e) {
		        var coords = this._eventCoordinates(e);
		        var pane = this._plotArea.paneByPoint(coords);
	
		        return Chart.fn._stopChartHandlers.call(this, e) || (pane && pane.options.name === NAVIGATOR_PANE);
		    }
		});
	
		dataviz.setDefaultOptions(StockChart, {
		    dateField: "date",
		    axisDefaults: {
		        categoryAxis: {
		            type: "date",
		            baseUnit: "fit",
		            justified: true
		        },
		        valueAxis: {
		            narrowRange: true,
		            labels: {
		                format: "C"
		            }
		        }
		    },
		    navigator: {
		        select: {},
		        seriesDefaults: {
		            markers: {
		                visible: false
		            },
		            tooltip: {
		                visible: true
		            },
		            line: {
		                width: 2
		            }
		        },
		        hint: {},
		        visible: true
		    },
		    tooltip: {
		        visible: true
		    },
		    legend: {
		        visible: false
		    }
		});
	
		kendo.deepExtend(kendo.dataviz, {
		    constants: constants,
		    Navigator: Navigator,
		    NavigatorHint: NavigatorHint,
		    StockChart: StockChart
		});
	
		})();
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(913);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 913:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(914)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		    var kendo = window.kendo;
		    var dataviz = kendo.dataviz;
		    var ChartInstanceObserver = dataviz.ChartInstanceObserver;
		    var Chart = dataviz.ui.Chart;
		    var KendoStockChart = dataviz.StockChart;
		    var constants = dataviz.constants;
		    var NAVIGATOR_AXIS = constants.NAVIGATOR_AXIS;
		    var NAVIGATOR_PANE = constants.NAVIGATOR_PANE;
		    var deepExtend = kendo.deepExtend;
		    var defined = dataviz.defined;
		    var proxy = $.proxy;
	
		    var CHANGE = "change";
	
		    var StockInstanceObserver = ChartInstanceObserver.extend({
		        handlerMap: {
		            navigatorFilter: '_onNavigatorFilter',
		            navigatorCreated: '_onNavigatorCreated'
		        }
		    });
	
		    var StockChart = Chart.extend({
	
		        options: {
		            name: "StockChart",
		            dateField: "date",
		            axisDefaults: {
		                categoryAxis: {
		                    type: "date",
		                    baseUnit: "fit",
		                    justified: true
		                },
		                valueAxis: {
		                    narrowRange: true,
		                    labels: {
		                        format: "C"
		                    }
		                }
		            },
		            navigator: {
		                select: {},
		                seriesDefaults: {
		                    markers: {
		                        visible: false
		                    },
		                    tooltip: {
		                        visible: true,
		                        template: "#= kendo.toString(category, 'd') #"
		                    },
		                    line: {
		                        width: 2
		                    }
		                },
		                hint: {},
		                visible: true
		            },
		            tooltip: {
		                visible: true
		            },
		            legend: {
		                visible: false
		            },
		            persistSeriesVisibility: true
		        },
	
		        _createChart: function(options, themeOptions) {
		            this._initNavigatorOptions(options);
		            this._instance = new KendoStockChart(this.element[0], options, themeOptions, {
		                observer: new StockInstanceObserver(this),
		                sender: this,
		                rtl: this._isRtl()
		            });
		        },
	
		        _initNavigatorOptions: function(options) {
		            var navigatorOptions = options.navigator || {};
		            var support = kendo.support;
		            var isTouch = support.touch;
		            var isFirefox = support.browser.mozilla;
	
		            deepExtend(navigatorOptions, {
		                autoBindElements: !navigatorOptions.dataSource,
		                partialRedraw: navigatorOptions.dataSource,
		                liveDrag: !isTouch && !isFirefox
		            });
		        },
	
		        _initDataSource: function(userOptions) {
		            var options = userOptions || {},
		                dataSource = options.dataSource,
		                hasServerFiltering = dataSource && dataSource.serverFiltering,
		                mainAxis = [].concat(options.categoryAxis)[0],
		                naviOptions = options.navigator || {},
		                select = naviOptions.select,
		                hasSelect = select && select.from && select.to;
	
		            if (hasServerFiltering && hasSelect) {
		                var filter = [].concat(dataSource.filter || []);
	
		                var from = kendo.parseDate(select.from);
		                var to = kendo.parseDate(select.to);
		                var dummyAxis = new dataviz.DateCategoryAxis(deepExtend({
		                    baseUnit: "fit"
		                }, mainAxis, {
		                    categories: [from, to]
		                }), kendo);
	
		                dataSource.filter = buildFilter(dummyAxis.range().min, to).concat(filter);
		            }
	
		            Chart.fn._initDataSource.call(this, userOptions);
		        },
	
		        _onNavigatorCreated: function(e) {
		            this._instance = e.sender;
		            this.options = e.sender.options;
		            this._navigator = this.navigator = e.navigator;
		            this._initNavigatorDataSource();
		        },
	
		        _initNavigatorDataSource: function() {
		            var navigatorOptions = this.options.navigator;
		            var autoBind = navigatorOptions.autoBind;
		            var dsOptions = navigatorOptions.dataSource;
	
		            if (dsOptions) {
		                this._navigatorDataChangedHandler = this._navigatorDataChangedHandler || proxy(this._onNavigatorDataChanged, this);
		                this._navigatorDataSource = kendo.data.DataSource
		                    .create(dsOptions)
		                    .bind(CHANGE, this._navigatorDataChangedHandler);
	
		                if (!defined(autoBind)) {
		                   autoBind = this.options.autoBind;
		                }
	
		                if (autoBind) {
		                    this._navigatorDataSource.fetch();
		                }
		            }
		        },
	
		        _bindNavigatorSeries: function(series, data) {
		            var seriesIx, currentSeries,
		                seriesLength = series.length;
	
		            for (seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
		                currentSeries = series[seriesIx];
	
		                if (currentSeries.axis == NAVIGATOR_AXIS && this._isBindable(currentSeries)) {
		                    currentSeries.data = data;
		                }
		            }
		        },
	
		        _onNavigatorDataChanged: function() {
		            var chart = this,
		                instance = chart._instance,
		                categoryAxes = chart.options.categoryAxis,
		                axisIx,
		                axesLength = categoryAxes.length,
		                data = chart._navigatorDataSource.view(),
		                currentAxis,
		                naviCategories;
	
		            this._bindNavigatorSeries(chart.options.series, data);
		            if (chart._sourceSeries) {
		                this._bindNavigatorSeries(chart._sourceSeries, data);
		            }
	
		            for (axisIx = 0; axisIx < axesLength; axisIx++) {
		                currentAxis = categoryAxes[axisIx];
	
		                if (currentAxis.pane == NAVIGATOR_PANE) {
		                    if (currentAxis.name == NAVIGATOR_AXIS) {
		                        chart._bindCategoryAxis(currentAxis, data, axisIx);
		                        naviCategories = currentAxis.categories;
		                    } else {
		                        currentAxis.categories = naviCategories;
		                    }
		                }
		            }
	
		            if (instance._model) {
		                var navigator = this.navigator;
		                navigator.redraw();
		                navigator.setRange();
	
		                if (!chart.options.dataSource || (chart.options.dataSource && chart._dataBound)) {
		                    navigator.redrawSlaves();
		                }
		            }
		        },
	
		        _bindCategories: function() {
		            Chart.fn._bindCategories.call(this);
		            if (this._instance) {
		                this._instance.copyNavigatorCategories();
		            }
		        },
	
		        _onDataChanged: function() {
		            Chart.fn._onDataChanged.call(this);
	
		            this._dataBound = true;
		        },
	
		        setOptions: function(options) {
		            this._removeNavigatorDataSource();
		            this._initNavigatorOptions(options);
		            this._instance.destroyNavigator();
		            Chart.fn.setOptions.call(this, options);
		        },
	
		        _onNavigatorFilter: function(e) {
		            this.dataSource.filter(buildFilter(e.from, e.to));
		        },
	
		        requiresHandlers: function(names) {
		            if (dataviz.inArray('navigatorFilter', names)) {
		                var dataSource = this.dataSource;
		                var hasServerFiltering = dataSource && dataSource.options.serverFiltering;
		                return hasServerFiltering && this.options.navigator.dataSource;
		            }
	
		            return Chart.fn.requiresHandlers.call(this, names);
		        },
	
		        _removeNavigatorDataSource: function() {
		            var navigatorDataSource = this._navigatorDataSource;
		            if (navigatorDataSource) {
		                navigatorDataSource.unbind(CHANGE, this._navigatorDataChangedHandler);
		                delete this._navigatorDataSource;
		            }
		        },
	
		        destroy: function() {
		            Chart.fn.destroy.call(this);
		            this._removeNavigatorDataSource();
		        }
		    });
	
		    dataviz.ui.plugin(StockChart);
	
		    function buildFilter(from, to) {
		        return [{
		            field: "Date", operator: "gte", value: from
		        }, {
		            field: "Date", operator: "lt", value: to
		        }];
		    }
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 914:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(758);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1103);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1103:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1104), __webpack_require__(1105) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.sparkline",
		    name: "Sparkline",
		    category: "dataviz",
		    description: "Sparkline widgets.",
		    depends: [ "dataviz.chart" ]
		};
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1104:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(761);
	
	/***/ }),
	
	/***/ 1105:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(762);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(908);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 908:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(909)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function () {
	
		window.kendo.dataviz = window.kendo.dataviz || {};
		var dataviz = kendo.dataviz;
		var constants = dataviz.constants;
		var Chart = dataviz.Chart;
		var elementSize = dataviz.elementSize;
		var deepExtend = dataviz.deepExtend;
	
		var TOP_OFFSET = -2;
	
		var SharedTooltip$1 = dataviz.SharedTooltip.extend({
		    _slotAnchor: function(coords, slot) {
		        var axis = this.plotArea.categoryAxis;
		        var vertical = axis.options.vertical;
		        var align = vertical ? {
		            horizontal: "left",
		            vertical: "center"
		        } : {
		            horizontal: "center",
		            vertical: "bottom"
		        };
	
		        var point;
	
		        if (vertical) {
		            point = new dataviz.Point(this.plotArea.box.x2, slot.center().y);
		        } else {
		            point = new dataviz.Point(slot.center().x, TOP_OFFSET);
		        }
	
		        return {
		            point: point,
		            align: align
		        };
		    },
	
		    _defaultAnchor: function(point, slot) {
		        return this._slotAnchor({}, slot);
		    }
		});
	
		var DEAULT_BAR_WIDTH = 150;
		var DEAULT_BULLET_WIDTH = 150;
		var NO_CROSSHAIR = [ constants.BAR, constants.BULLET ];
	
		function hide(children) {
		    var state = [];
		    for (var idx = 0; idx < children.length; idx++) {
		        var child = children[idx];
		        state[idx] = child.style.display;
		        child.style.display = "none";
		    }
	
		    return state;
		}
	
		function show(children, state) {
		    for (var idx = 0; idx < children.length; idx++) {
		        children[idx].style.display = state[idx];
		    }
		}
	
		function wrapNumber(value) {
		    return dataviz.isNumber(value) ? [ value ] : value;
		}
	
		var Sparkline = Chart.extend({
		    _setElementClass: function(element) {
		        dataviz.addClass(element, 'k-sparkline');
		    },
	
		    _initElement: function(element) {
		        Chart.fn._initElement.call(this, element);
	
		        this._initialWidth = Math.floor(elementSize(element).width);
		    },
	
		    _resize: function() {
		        var element = this.element;
		        var state = hide(element.childNodes);
	
		        this._initialWidth = Math.floor(elementSize(element).width);
	
		        show(element.childNodes, state);
	
		        Chart.fn._resize.call(this);
		    },
	
		    _modelOptions: function() {
		        var chartOptions = this.options;
		        var stage = this._surfaceWrap();
		        var displayState = hide(stage.childNodes);
	
		        var space = document.createElement('span');
		        space.innerHTML = '&nbsp;';
	
		        stage.appendChild(space);
	
		        var options = deepExtend({
		            width: this._autoWidth,
		            height: elementSize(stage).height,
		            transitions: chartOptions.transitions
		        }, chartOptions.chartArea, {
		            inline: true,
		            align: false
		        });
	
		        elementSize(stage, {
		            width: options.width,
		            height: options.height
		        });
	
		        stage.removeChild(space);
	
		        show(stage.childNodes, displayState);
	
		        if (this.surface) {
		            this.surface.resize();
		        }
	
		        return options;
		    },
	
		    _surfaceWrap: function() {
		        if (!this.stage) {
		            var stage = this.stage = document.createElement('span');
		            this.element.appendChild(stage);
		        }
		        return this.stage;
		    },
	
		    _createPlotArea: function(skipSeries) {
		        var plotArea = Chart.fn._createPlotArea.call(this, skipSeries);
		        this._autoWidth = this._initialWidth || this._calculateWidth(plotArea);
	
		        return plotArea;
		    },
	
		    _calculateWidth: function(plotArea) {
		        var options = this.options;
		        var margin = dataviz.getSpacing(options.chartArea.margin);
		        var charts = plotArea.charts;
		        var stage = this._surfaceWrap();
		        var total = 0;
	
		        for (var i = 0; i < charts.length; i++) {
		            var currentChart = charts[i];
		            var firstSeries = (currentChart.options.series || [])[0];
		            if (!firstSeries) {
		                continue;
		            }
	
		            if (firstSeries.type === constants.BAR) {
		                return DEAULT_BAR_WIDTH;
		            }
	
		            if (firstSeries.type === constants.BULLET) {
		                return DEAULT_BULLET_WIDTH;
		            }
	
		            if (firstSeries.type === constants.PIE) {
		                return elementSize(stage).height;
		            }
	
		            var categoryAxis = currentChart.categoryAxis;
		            if (categoryAxis) {
		                var pointsCount = categoryAxis.categoriesCount() *
		                    (!currentChart.options.isStacked && dataviz.inArray(firstSeries.type, [ constants.COLUMN, constants.VERTICAL_BULLET ]) ? currentChart.seriesOptions.length : 1);
	
		                total = Math.max(total, pointsCount);
		            }
		        }
	
		        var size = total * options.pointWidth;
		        if (size > 0) {
		            size += margin.left + margin.right;
		        }
	
		        return size;
		    },
	
		    _createSharedTooltip: function(options) {
		        return new SharedTooltip$1(this._plotArea, options);
		    }
		});
	
		Sparkline.normalizeOptions = function(userOptions) {
		    var options = wrapNumber(userOptions);
	
		    if (dataviz.isArray(options)) {
		        options = { seriesDefaults: { data: options } };
		    } else {
		        options = deepExtend({}, options);
		    }
	
		    if (!options.series) {
		        options.series = [ { data: wrapNumber(options.data) } ];
		    }
	
		    deepExtend(options, {
		        seriesDefaults: {
		            type: options.type
		        }
		    });
	
		    if (dataviz.inArray(options.series[0].type, NO_CROSSHAIR) ||
		        dataviz.inArray(options.seriesDefaults.type, NO_CROSSHAIR)) {
		        options = deepExtend({}, {
		            categoryAxis: {
		                crosshair: {
		                    visible: false
		                }
		            }
		        }, options);
		    }
	
		    return options;
		};
	
		dataviz.setDefaultOptions(Sparkline, {
		    chartArea: {
		        margin: 2
		    },
		    axisDefaults: {
		        visible: false,
		        majorGridLines: {
		            visible: false
		        },
		        valueAxis: {
		            narrowRange: true
		        }
		    },
		    seriesDefaults: {
		        type: "line",
		        area: {
		            line: {
		                width: 0.5
		            }
		        },
		        bar: {
		            stack: true
		        },
		        padding: 2,
		        width: 0.5,
		        overlay: {
		            gradient: null
		        },
		        highlight: {
		            visible: false
		        },
		        border: {
		            width: 0
		        },
		        markers: {
		            size: 2,
		            visible: false
		        }
		    },
		    tooltip: {
		        visible: true,
		        shared: true
		    },
		    categoryAxis: {
		        crosshair: {
		            visible: true,
		            tooltip: {
		                visible: false
		            }
		        }
		    },
		    legend: {
		        visible: false
		    },
		    transitions: false,
	
		    pointWidth: 5,
	
		    panes: [ { clip: false } ]
		});
	
		kendo.deepExtend(kendo.dataviz, {
		    Sparkline: Sparkline
		});
	
		})();
	
		}, __webpack_require__(3));
	
	/***/ }),
	
	/***/ 909:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(749);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(910);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 910:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(911)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
	
		var dataviz = kendo.dataviz;
		var Chart = dataviz.ui.Chart;
		var KendoSparkline = dataviz.Sparkline;
		var ChartInstanceObserver = dataviz.ChartInstanceObserver;
	
		var extend = $.extend;
	
		var Sparkline = Chart.extend({
	
		    init: function(element, userOptions) {
		        var options = userOptions;
		        if (options instanceof kendo.data.ObservableArray) {
		            options = { seriesDefaults: { data: options } };
		        }
	
		        Chart.fn.init.call(this, element, KendoSparkline.normalizeOptions(options));
		    },
	
		    _createChart: function(options, themeOptions) {
		        this._instance = new KendoSparkline(this.element[0], options, themeOptions, {
		            observer: new ChartInstanceObserver(this),
		            sender: this,
		            rtl: this._isRtl()
		        });
		    },
	
		    _createTooltip: function() {
		        return new SparklineTooltip(this.element, extend({}, this.options.tooltip, {
		            rtl: this._isRtl()
		        }));
		    },
	
		    options: {
		        name: "Sparkline",
		        chartArea: {
		            margin: 2
		        },
		        axisDefaults: {
		            visible: false,
		            majorGridLines: {
		                visible: false
		            },
		            valueAxis: {
		                narrowRange: true
		            }
		        },
		        seriesDefaults: {
		            type: "line",
		            area: {
		                line: {
		                    width: 0.5
		                }
		            },
		            bar: {
		                stack: true
		            },
		            padding: 2,
		            width: 0.5,
		            overlay: {
		                gradient: null
		            },
		            highlight: {
		                visible: false
		            },
		            border: {
		                width: 0
		            },
		            markers: {
		                size: 2,
		                visible: false
		            }
		        },
		        tooltip: {
		            visible: true,
		            shared: true
		        },
		        categoryAxis: {
		            crosshair: {
		                visible: true,
		                tooltip: {
		                    visible: false
		                }
		            }
		        },
		        legend: {
		            visible: false
		        },
		        transitions: false,
	
		        pointWidth: 5,
	
		        panes: [{
		            clip: false
		        }]
		    }
		});
	
		dataviz.ui.plugin(Sparkline);
	
		var SparklineTooltip = dataviz.Tooltip.extend({
		    options: {
		        animation: {
		            duration: 0
		        }
		    },
	
		    _hideElement: function() {
		        if (this.element) {
		            this.element.hide().remove();
		        }
		    }
		});
	
		dataviz.SparklineTooltip = SparklineTooltip;
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 911:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(761);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1088);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1053:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(582);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1060:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 1088:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1013), __webpack_require__(1038), __webpack_require__(1053), __webpack_require__(1022), __webpack_require__(1059),
		        __webpack_require__(1060),
	
		        __webpack_require__(1090),
		        __webpack_require__(1091),
		        __webpack_require__(1092),
		        __webpack_require__(1089),
		        __webpack_require__(1093),
		        __webpack_require__(1094),
		        __webpack_require__(1095),
		        __webpack_require__(1096),
		        __webpack_require__(1097),
		        __webpack_require__(1098),
		        __webpack_require__(1099),
		        __webpack_require__(1100)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    var __meta__ = { // jshint ignore:line
		        id: "dataviz.map",
		        name: "Map",
		        category: "dataviz",
		        description: "The Kendo DataViz Map displays spatial data",
		        depends: [ "data", "userevents", "tooltip", "dataviz.core", "drawing", "mobile.scroller" ]
		    };
	
		    return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1089:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(764);
	
	/***/ }),
	
	/***/ 1090:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(765);
	
	/***/ }),
	
	/***/ 1091:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(766);
	
	/***/ }),
	
	/***/ 1092:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(767);
	
	/***/ }),
	
	/***/ 1093:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(768);
	
	/***/ }),
	
	/***/ 1094:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(769);
	
	/***/ }),
	
	/***/ 1095:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(770);
	
	/***/ }),
	
	/***/ 1096:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(771);
	
	/***/ }),
	
	/***/ 1097:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(772);
	
	/***/ }),
	
	/***/ 1098:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(773);
	
	/***/ }),
	
	/***/ 1099:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(774);
	
	/***/ }),
	
	/***/ 1100:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(775);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(907);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 862:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 907:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(862) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
		    var kendo = window.kendo;
		    var Widget = kendo.ui.Widget;
		    var keys = kendo.keys;
		    var proxy = $.proxy;
	
		    // Helper functions =======================================================
		    function button(dir, iconClass) {
		       return kendo.format(
		           '<button class="k-button k-zoom-{0}" title="zoom-{0}" aria-label="zoom-{0}"><span class="k-icon {1}"></span></button>',
		           dir, iconClass);
		    }
	
		    var NS = ".kendoZoomControl";
		    var BUTTONS = button("in", "k-i-plus") + button("out", "k-i-minus");
	
		    var PLUS = 187;
		    var MINUS = 189;
		    var FF_PLUS = 61;
		    var FF_MINUS = 173;
	
	
		    var ZoomControl = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
		            this._initOptions(options);
	
		            this.element.addClass("k-widget k-zoom-control k-button-wrap k-buttons-horizontal k-button-group k-group-horizontal")
		                        .append(BUTTONS)
		                        .on("click" + NS, ".k-button", proxy(this, "_click"));
	
		            var parentElement = this.element.parent().closest("[" + kendo.attr("role") + "]");
		            this._keyroot = parentElement.length > 0 ? parentElement : this.element;
	
		            this._tabindex(this._keyroot);
	
		            this._keydown = proxy(this._keydown, this);
		            this._keyroot.on("keydown", this._keydown);
		        },
	
		        options: {
		            name: "ZoomControl",
		            zoomStep: 1
		        },
	
		        events: [
		            "change"
		        ],
	
		        _change: function(dir) {
		            var zoomStep = this.options.zoomStep;
		            this.trigger("change", {
		                delta: dir * zoomStep
		            });
		        },
	
		        _click: function(e) {
		            var button = $(e.currentTarget);
		            var dir = 1;
	
		            if (button.is(".k-zoom-out")) {
		                dir = -1;
		            }
	
		            this._change(dir);
		            e.preventDefault();
		        },
	
		        _keydown: function(e) {
		            switch (e.which) {
		                case keys.NUMPAD_PLUS:
		                case PLUS:
		                case FF_PLUS:
		                    this._change(1);
		                    break;
	
		                case keys.NUMPAD_MINUS:
		                case MINUS:
		                case FF_MINUS:
		                    this._change(-1);
		                    break;
		            }
		        }
		    });
	
	
		    // Exports ================================================================
		    kendo.dataviz.ui.plugin(ZoomControl);
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(902);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 902:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(859), __webpack_require__(903) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var math = Math,
		        abs = math.abs,
		        atan = math.atan,
		        atan2 = math.atan2,
		        cos = math.cos,
		        max = math.max,
		        min = math.min,
		        sin = math.sin,
		        tan = math.tan,
	
		        kendo = window.kendo,
		        Class = kendo.Class,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
	
		        util = kendo.drawing.util,
		        defined = util.defined,
		        deg = util.deg,
		        rad = util.rad,
		        round = util.round,
		        valueOrDefault = util.valueOrDefault,
	
		        sqr = kendo.util.sqr;
	
		    // Implementation =========================================================
		    var Location = Class.extend({
		        init: function(lat, lng) {
		            if (arguments.length === 1) {
		                this.lat = lat[0];
		                this.lng = lat[1];
		            } else {
		                this.lat = lat;
		                this.lng = lng;
		            }
		        },
	
		        DISTANCE_ITERATIONS: 100,
		        DISTANCE_CONVERGENCE: 1e-12,
		        DISTANCE_PRECISION: 2,
		        FORMAT: "{0:N6},{1:N6}",
	
		        toArray: function() {
		            return [this.lat, this.lng];
		        },
	
		        equals: function(loc) {
		            return loc && loc.lat === this.lat && loc.lng === this.lng;
		        },
	
		        clone: function() {
		            return new Location(this.lat, this.lng);
		        },
	
		        round: function(precision) {
		            this.lng = round(this.lng, precision);
		            this.lat = round(this.lat, precision);
		            return this;
		        },
	
		        wrap: function() {
		            this.lng = this.lng % 180;
		            this.lat = this.lat % 90;
		            return this;
		        },
	
		        distanceTo: function(dest, datum) {
		            return this.greatCircleTo(dest, datum).distance;
		        },
	
		        destination: function(distance, bearing, datum) {
		            bearing = rad(bearing);
		            datum = datum || dataviz.map.datums.WGS84;
	
		            var fromLat = rad(this.lat);
		            var fromLng = rad(this.lng);
		            var dToR = distance / kendo.dataviz.map.datums.WGS84.a;
	
		            var lat = math.asin(sin(fromLat) * cos(dToR) +
		                                cos(fromLat) * sin(dToR) * cos(bearing));
	
		            var lng = fromLng + atan2(sin(bearing) * sin(dToR) * cos(fromLat),
		                                      cos(dToR) - sin(fromLat) * sin(lat));
	
		           return new Location(deg(lat), deg(lng));
		        },
	
		        greatCircleTo: function(dest, datum) {
		            dest = Location.create(dest);
		            datum = datum || dataviz.map.datums.WGS84;
	
		            if (!dest || this.clone().round(8).equals(dest.clone().round(8))) {
		                return {
		                    distance: 0,
		                    azimuthFrom: 0,
		                    azimuthTo: 0
		                };
		            }
	
		            // See http://en.wikipedia.org/wiki/Vincenty's_formulae#Notation
		            // o == sigma
		            // A == alpha
		            var a = datum.a;
		            var b = datum.b;
		            var f = datum.f;
	
		            var L = rad(dest.lng - this.lng);
	
		            var U1 = atan((1 - f) * tan(rad(this.lat)));
		            var sinU1 = sin(U1);
		            var cosU1 = cos(U1);
	
		            var U2 = atan((1 - f) * tan(rad(dest.lat)));
		            var sinU2 = sin(U2);
		            var cosU2 = cos(U2);
	
		            var lambda = L;
		            var prevLambda;
	
		            var i = this.DISTANCE_ITERATIONS;
		            var converged = false;
	
		            var sinLambda;
		            var cosLambda;
		            var sino;
		            var cosA2;
		            var coso;
		            var cos2om;
		            var sigma;
	
		            while (!converged && i-- > 0) {
		                sinLambda = sin(lambda);
		                cosLambda = cos(lambda);
		                sino = math.sqrt(
		                    sqr(cosU2 * sinLambda) + sqr(cosU1 * sinU2 - sinU1 * cosU2 * cosLambda)
		                );
	
		                coso = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
		                sigma = atan2(sino, coso);
	
		                var sinA = cosU1 * cosU2 * sinLambda / sino;
		                cosA2 = 1 - sqr(sinA);
		                cos2om = 0;
		                if (cosA2 !== 0) {
		                    cos2om = coso - 2 * sinU1 * sinU2 / cosA2;
		                }
	
		                prevLambda = lambda;
		                var C = f / 16 * cosA2 * (4 + f * (4 - 3 * cosA2));
		                lambda = L + (1 - C) * f * sinA * (
		                    sigma + C * sino * (cos2om + C * coso * (-1 + 2 * sqr(cos2om)))
		                );
	
		                converged = abs(lambda - prevLambda) <= this.DISTANCE_CONVERGENCE;
		            }
	
		            var u2 = cosA2 * (sqr(a) - sqr(b)) / sqr(b);
		            var A = 1 + u2 / 16384 * (4096 + u2 * (-768 + u2 * (320 - 175 * u2)));
		            var B = u2 / 1024 * (256 + u2 * (-128 + u2 * (74 - 47 * u2)));
		            var deltao = B * sino * (cos2om + B / 4 * (
		                coso * (-1 + 2 * sqr(cos2om)) - B / 6 * cos2om * (-3 + 4 * sqr(sino)) * (-3 + 4 * sqr(cos2om))
		            ));
	
		            var azimuthFrom = atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
		            var azimuthTo = atan2(cosU1 * sinLambda, -sinU1 * cosU2 + cosU1 * sinU2 * cosLambda);
	
		            return {
		                distance: round(b * A * (sigma - deltao), this.DISTANCE_PRECISION),
		                azimuthFrom: deg(azimuthFrom),
		                azimuthTo: deg(azimuthTo)
		            };
		        }
		    });
	
		    // IE < 9 doesn't allow to override toString on definition
		    Location.fn.toString = function() {
		        return kendo.format(this.FORMAT, this.lat, this.lng);
		    };
	
		    Location.fromLngLat = function(ll) {
		        return new Location(ll[1], ll[0]);
		    };
	
		    Location.fromLatLng = function(ll) {
		        return new Location(ll[0], ll[1]);
		    };
	
		    Location.create = function(a, b) {
		        if (defined(a)) {
		            if (a instanceof Location) {
		                return a.clone();
		            } else if (arguments.length === 1 && a.length === 2) {
		                return Location.fromLatLng(a);
		            } else {
		                return new Location(a, b);
		            }
		        }
		    };
	
		    var Extent = Class.extend({
		        init: function(nw, se) {
		            nw = Location.create(nw);
		            se = Location.create(se);
	
		            if (nw.lng + 180 > se.lng + 180 &&
		                nw.lat + 90 < se.lat + 90) {
		                this.se = nw;
		                this.nw = se;
		            } else {
		                this.se = se;
		                this.nw = nw;
		            }
		        },
	
		        contains: function(loc) {
		            var nw = this.nw,
		                se = this.se,
		                lng = valueOrDefault(loc.lng, loc[1]),
		                lat = valueOrDefault(loc.lat, loc[0]);
	
		            return loc &&
		                   lng + 180 >= nw.lng + 180 &&
		                   lng + 180 <= se.lng + 180 &&
		                   lat + 90 >= se.lat + 90 &&
		                   lat + 90 <= nw.lat + 90;
		        },
	
		        center: function() {
		            var nw = this.nw;
		            var se = this.se;
	
		            var lng = nw.lng + (se.lng - nw.lng) / 2;
		            var lat = nw.lat + (se.lat - nw.lat) / 2;
		            return new Location(lat, lng);
		        },
	
		        containsAny: function(locs) {
		            var result = false;
		            for (var i = 0; i < locs.length; i++) {
		                result = result || this.contains(locs[i]);
		            }
	
		            return result;
		        },
	
		        include: function(loc) {
		            var nw = this.nw,
		                se = this.se,
		                lng = valueOrDefault(loc.lng, loc[1]),
		                lat = valueOrDefault(loc.lat, loc[0]);
	
		            nw.lng = min(nw.lng, lng);
		            nw.lat = max(nw.lat, lat);
	
		            se.lng = max(se.lng, lng);
		            se.lat = min(se.lat, lat);
		        },
	
		        includeAll: function(locs) {
		            for (var i = 0; i < locs.length; i++) {
		                this.include(locs[i]);
		            }
		        },
	
		        edges: function() {
		            var nw = this.nw,
		                se = this.se;
	
		            return {nw: this.nw, ne: new Location(nw.lat, se.lng),
		                    se: this.se, sw: new Location(se.lat, nw.lng)};
		        },
	
		        toArray: function() {
		            var nw = this.nw,
		                se = this.se;
	
		            return [nw, new Location(nw.lat, se.lng),
		                    se, new Location(se.lat, nw.lng)];
		        },
	
		        overlaps: function(extent) {
		            return this.containsAny(extent.toArray()) ||
		                   extent.containsAny(this.toArray());
		        }
		    });
	
		    Extent.World = new Extent([90, -180], [-90, 180]);
	
		    Extent.create = function(a, b) {
		        if (a instanceof Extent) {
		            return a;
		        } else if (a && b) {
		            return new Extent(a, b);
		        } else if (a && a.length === 4 && !b) {
		            return new Extent([a[0], a[1]], [a[2], a[3]]);
		        }
		    };
	
		    // Exports ================================================================
		    deepExtend(dataviz, {
		        map: {
		            Extent: Extent,
		            Location: Location
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 903:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(701);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(886);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 886:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(859) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function() {
		    var kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        template = kendo.template,
	
		        util = kendo.drawing.util,
		        valueOrDefault = util.valueOrDefault,
		        defined = util.defined;
	
		    var Attribution = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
		            this._initOptions(options);
		            this.items = [];
		            this.element.addClass("k-widget k-attribution");
		        },
	
		        options: {
		            name: "Attribution",
		            separator: "&nbsp;|&nbsp;",
		            itemTemplate: "#= text #"
		        },
	
		        filter: function(extent, zoom) {
		            this._extent = extent;
		            this._zoom = zoom;
		            this._render();
		        },
	
		        add: function(item) {
		            if (defined(item)) {
		                if (typeof item === "string") {
		                    item = { text: item };
		                }
	
		                this.items.push(item);
		                this._render();
		            }
		        },
	
		        remove: function(text) {
		            var result = [];
		            for (var i = 0; i < this.items.length; i++) {
		                var item = this.items[i];
		                if (item.text !== text) {
		                    result.push(item);
		                }
		            }
	
		            this.items = result;
	
		            this._render();
		        },
	
		        clear: function() {
		            this.items = [];
		            this.element.empty();
		        },
	
		        _render: function() {
		            var result = [];
		            var itemTemplate = template(this.options.itemTemplate);
	
		            for (var i = 0; i < this.items.length; i++) {
		                var item = this.items[i];
		                var text = this._itemText(item);
		                if (text !== "") {
		                    result.push(itemTemplate({
		                        text: text
		                    }));
		                }
		            }
	
		            if (result.length > 0) {
		                this.element.empty()
		                    .append(result.join(this.options.separator))
		                    .show();
		            } else {
		                this.element.hide();
		            }
		        },
	
		        _itemText: function(item) {
		            var text = "";
		            var inZoomLevel = this._inZoomLevel(item.minZoom, item.maxZoom);
		            var inArea = this._inArea(item.extent);
	
		            if (inZoomLevel && inArea) {
		                text += item.text;
		            }
	
		            return text;
		        },
	
		        _inZoomLevel: function(min, max) {
		            var result = true;
		            min = valueOrDefault(min, -Number.MAX_VALUE);
		            max = valueOrDefault(max, Number.MAX_VALUE);
	
		            result = this._zoom > min && this._zoom < max;
	
		            return result;
		        },
	
		        _inArea: function(area) {
		            var result = true;
	
		            if (area) {
		                result = area.contains(this._extent);
		            }
	
		            return result;
		        }
		    });
	
		    kendo.dataviz.ui.plugin(Attribution);
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(906);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 862:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 906:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(862) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($) {
		    var kendo = window.kendo;
		    var Widget = kendo.ui.Widget;
		    var keys = kendo.keys;
		    var proxy = $.proxy;
	
		    var NS = ".kendoNavigator";
	
		    // Helper functions =======================================================
		    function button(dir) {
		       return kendo.format(
		           '<button class="k-button k-navigator-{0}" aria-label="move {0}">' +
		               '<span class="k-icon k-i-arrow-60-{0}"/>' +
		           '</button>', dir);
		    }
	
		    var BUTTONS = button("up") + button("right") + button("down") + button("left");
	
		    var Navigator = Widget.extend({
		        init: function(element, options) {
		            Widget.fn.init.call(this, element, options);
		            this._initOptions(options);
	
		            this.element.addClass("k-widget k-header k-shadow k-navigator")
		                        .append(BUTTONS)
		                        .on("click" + NS, ".k-button", proxy(this, "_click"));
	
		            var parentElement = this.element.parent().closest("[" + kendo.attr("role") + "]");
		            this._keyroot = parentElement.length > 0 ? parentElement : this.element;
		            this._tabindex(this._keyroot);
	
		            this._keydown = proxy(this._keydown, this);
		            this._keyroot.on("keydown", this._keydown);
		        },
	
		        options: {
		            name: "Navigator",
		            panStep: 1
		        },
	
		        events: [
		            "pan"
		        ],
	
		        dispose: function() {
		            this._keyroot.off("keydown", this._keydown);
		        },
	
		        _pan: function(x, y) {
		            var panStep = this.options.panStep;
		            this.trigger("pan", {
		                x: x * panStep,
		                y: y * panStep
		            });
		        },
	
		        _click: function(e) {
		            var x = 0;
		            var y = 0;
		            var button = $(e.currentTarget);
	
		            if (button.is(".k-navigator-up")) {
		                y = 1;
		            } else if (button.is(".k-navigator-down")) {
		                y = -1;
		            } else if (button.is(".k-navigator-right")) {
		                x = 1;
		            } else if (button.is(".k-navigator-left")) {
		                x = -1;
		            }
	
		            this._pan(x, y);
		            e.preventDefault();
		        },
	
		        _keydown: function(e) {
		            switch (e.which) {
		                case keys.UP:
		                    this._pan(0, 1);
		                    e.preventDefault();
		                    break;
	
		                case keys.DOWN:
		                    this._pan(0, -1);
		                    e.preventDefault();
		                    break;
	
		                case keys.RIGHT:
		                    this._pan(1, 0);
		                    e.preventDefault();
		                    break;
	
		                case keys.LEFT:
		                    this._pan(-1, 0);
		                    e.preventDefault();
		                    break;
		            }
		        }
		    });
	
		    // Exports ================================================================
		    kendo.dataviz.ui.plugin(Navigator);
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	/***/ })
	
	/******/ });

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(887);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 887:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(888), __webpack_require__(859) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var math = Math,
		        atan = math.atan,
		        exp = math.exp,
		        pow = math.pow,
		        sin = math.sin,
		        log = math.log,
		        tan = math.tan,
	
		        kendo = window.kendo,
		        Class = kendo.Class,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
	
		        g = kendo.geometry,
		        Point = g.Point,
	
		        map = dataviz.map,
		        Location = map.Location,
	
		        util = kendo.drawing.util,
		        rad = util.rad,
		        deg = util.deg,
		        limit = util.limitValue;
	
		    // Constants ==============================================================
		    var PI = math.PI,
		        PI_DIV_2 = PI / 2,
		        PI_DIV_4 = PI / 4,
		        DEG_TO_RAD = PI / 180;
	
		    // Coordinate reference systems ===========================================
		    var WGS84 = {
		        a: 6378137,                 // Semi-major radius
		        b: 6356752.314245179,       // Semi-minor radius
		        f: 0.0033528106647474805,   // Flattening
		        e: 0.08181919084262149      // Eccentricity
		    };
	
		    // WGS 84 / World Mercator
		    var Mercator = Class.extend({
		        init: function(options) {
		            this._initOptions(options);
		        },
	
		        MAX_LNG: 180,
		        MAX_LAT: 85.0840590501,
		        INVERSE_ITERATIONS: 15,
		        INVERSE_CONVERGENCE: 1e-12,
	
		        options: {
		            centralMeridian: 0,
		            datum: WGS84
		        },
	
		        forward: function(loc, clamp) {
		            var proj = this,
		                options = proj.options,
		                datum = options.datum,
		                r = datum.a,
		                lng0 = options.centralMeridian,
		                lat = limit(loc.lat, -proj.MAX_LAT, proj.MAX_LAT),
		                lng = clamp ? limit(loc.lng, -proj.MAX_LNG, proj.MAX_LNG) : loc.lng,
		                x = rad(lng - lng0) * r,
		                y = proj._projectLat(lat);
	
		            return new Point(x, y);
		        },
	
		        _projectLat: function(lat) {
		            var datum = this.options.datum,
		                ecc = datum.e,
		                r = datum.a,
		                y = rad(lat),
		                ts = tan(PI_DIV_4 + y / 2),
		                con = ecc * sin(y),
		                p = pow((1 - con) / (1 + con), ecc / 2);
	
		            // See:
		            // http://en.wikipedia.org/wiki/Mercator_projection#Generalization_to_the_ellipsoid
		            return r * log(ts * p);
		        },
	
		        inverse: function(point, clamp) {
		            var proj = this,
		                options = proj.options,
		                datum = options.datum,
		                r = datum.a,
		                lng0 = options.centralMeridian,
		                lng = point.x / (DEG_TO_RAD * r) + lng0,
		                lat = limit(proj._inverseY(point.y), -proj.MAX_LAT, proj.MAX_LAT);
	
		            if (clamp) {
		                lng = limit(lng, -proj.MAX_LNG, proj.MAX_LNG);
		            }
	
		            return new Location(lat, lng);
		        },
	
		        _inverseY: function(y) {
		            var proj = this,
		                datum = proj.options.datum,
		                r = datum.a,
		                ecc = datum.e,
		                ecch = ecc / 2,
		                ts = exp(-y / r),
		                phi = PI_DIV_2 - 2 * atan(ts),
		                i;
	
		            for (i = 0; i <= proj.INVERSE_ITERATIONS; i++) {
		                var con = ecc * sin(phi),
		                    p = pow((1 - con) / (1 + con), ecch),
		                    dphi = PI_DIV_2 - 2 * atan(ts * p) - phi;
	
		                phi += dphi;
	
		                if (math.abs(dphi) <= proj.INVERSE_CONVERGENCE) {
		                    break;
		                }
		            }
	
		            return deg(phi);
		        }
		    });
	
		    // WGS 84 / Pseudo-Mercator
		    // Used by Google Maps, Bing, OSM, etc.
		    // Spherical projection of ellipsoidal coordinates.
		    var SphericalMercator = Mercator.extend({
		        MAX_LAT: 85.0511287798,
	
		        _projectLat: function(lat) {
		            var r = this.options.datum.a,
		                y = rad(lat),
		                ts = tan(PI_DIV_4 + y / 2);
	
		            return r * log(ts);
		        },
	
		        _inverseY: function(y) {
		            var r = this.options.datum.a,
		                ts = exp(-y / r);
	
		            return deg(PI_DIV_2 - (2 * atan(ts)));
		        }
		    });
	
		    var Equirectangular = Class.extend({
		        forward: function(loc) {
		            return new Point(loc.lng, loc.lat);
		        },
	
		        inverse: function(point) {
		            return new Location(point.y, point.x);
		        }
		    });
	
		    // TODO: Better (less cryptic name) for this class(es)
		    var EPSG3857 = Class.extend({
		        init: function() {
		            var crs = this,
		                proj = crs._proj = new SphericalMercator();
	
		            var c = this.c = 2 * PI * proj.options.datum.a;
	
		            // Scale circumference to 1, mirror Y and shift origin to top left
		            this._tm = g.transform().translate(0.5, 0.5).scale(1/c, -1/c);
	
		            // Inverse transform matrix
		            this._itm = g.transform().scale(c, -c).translate(-0.5, -0.5);
		        },
	
		        // Location <-> Point (screen coordinates for a given scale)
		        toPoint: function(loc, scale, clamp) {
		            var point = this._proj.forward(loc, clamp);
	
		            return point
		                .transform(this._tm)
		                .scale(scale || 1);
		        },
	
		        toLocation: function(point, scale, clamp) {
		            point = point
		                .clone()
		                .scale(1 / (scale || 1))
		                .transform(this._itm);
	
		            return this._proj.inverse(point, clamp);
		        }
		    });
	
		    var EPSG3395 = Class.extend({
		        init: function() {
		            this._proj = new Mercator();
		        },
	
		        toPoint: function(loc) {
		            return this._proj.forward(loc);
		        },
	
		        toLocation: function(point) {
		            return this._proj.inverse(point);
		        }
		    });
	
		    // WGS 84
		    var EPSG4326 = Class.extend({
		        init: function() {
		            this._proj = new Equirectangular();
		        },
	
		        toPoint: function(loc) {
		            return this._proj.forward(loc);
		        },
	
		        toLocation: function(point) {
		            return this._proj.inverse(point);
		        }
		    });
	
		    // Exports ================================================================
		    deepExtend(dataviz, {
		        map: {
		            crs: {
		                EPSG3395: EPSG3395,
		                EPSG3857: EPSG3857,
		                EPSG4326: EPSG4326
		            },
		            datums: {
		                WGS84: WGS84
		            },
		            projections: {
		                Equirectangular: Equirectangular,
		                Mercator: Mercator,
		                SphericalMercator: SphericalMercator
		            }
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 888:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(765);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(889);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 889:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(890), __webpack_require__(891) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var proxy = $.proxy,
	
		        kendo = window.kendo,
		        Class = kendo.Class,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
	
		        Extent = dataviz.map.Extent,
	
		        util = kendo.drawing.util,
		        defined = util.defined;
	
		    // Implementation =========================================================
		    var Layer = Class.extend({
		        init: function(map, options) {
		            this._initOptions(options);
		            this.map = map;
	
		            this.element = $("<div class='k-layer'></div>")
		               .css({
		                   "zIndex": this.options.zIndex,
		                   "opacity": this.options.opacity
		               })
		               .appendTo(map.scrollElement);
	
		            this._beforeReset = proxy(this._beforeReset, this);
		            this._reset = proxy(this._reset, this);
		            this._resize = proxy(this._resize, this);
		            this._panEnd = proxy(this._panEnd, this);
		            this._activate();
	
		            this._updateAttribution();
		        },
	
		        destroy: function() {
		            this._deactivate();
		        },
	
		        show: function() {
		            this.reset();
		            this._activate();
		            this._applyExtent(true);
		        },
	
		        hide: function() {
		            this._deactivate();
		            this._setVisibility(false);
		        },
	
		        reset: function() {
		            this._beforeReset();
		            this._reset();
		        },
	
		        _reset: function() {
		            this._applyExtent();
		        },
	
		        _beforeReset: $.noop,
	
		        _resize: $.noop,
	
		        _panEnd: function() {
		            this._applyExtent();
		        },
	
		        _applyExtent: function() {
		            var options = this.options;
	
		            var zoom = this.map.zoom();
		            var matchMinZoom = !defined(options.minZoom) || zoom >= options.minZoom;
		            var matchMaxZoom = !defined(options.maxZoom) || zoom <= options.maxZoom;
	
		            var extent = Extent.create(options.extent);
		            var inside = !extent || extent.overlaps(this.map.extent());
	
		            this._setVisibility(matchMinZoom && matchMaxZoom && inside);
		        },
	
		        _setVisibility: function(visible) {
		            this.element.css("display", visible ? "" : "none");
		        },
	
		        _activate: function() {
		            var map = this.map;
		            map.bind("beforeReset", this._beforeReset);
		            map.bind("reset", this._reset);
		            map.bind("resize", this._resize);
		            map.bind("panEnd", this._panEnd);
		        },
	
		        _deactivate: function() {
		            var map = this.map;
		            map.unbind("beforeReset", this._beforeReset);
		            map.unbind("reset", this._reset);
		            map.unbind("resize", this._resize);
		            map.unbind("panEnd", this._panEnd);
		        },
	
		        _updateAttribution: function() {
		            var attr = this.map.attribution;
	
		            if (attr) {
		                attr.add(this.options.attribution);
		            }
		        }
		    });
	
		    // Exports ================================================================
		    deepExtend(dataviz, {
		        map: {
		            layers: {
		                Layer: Layer
		            }
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 890:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 891:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(765);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(900);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 891:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(765);
	
	/***/ }),
	
	/***/ 897:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(769);
	
	/***/ }),
	
	/***/ 900:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(897), __webpack_require__(891)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var proxy = $.proxy,
	
		        kendo = window.kendo,
		        Class = kendo.Class,
		        DataSource = kendo.data.DataSource,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
	
		        g = kendo.geometry,
	
		        d = kendo.drawing,
		        Group = d.Group,
	
		        last = d.util.last,
		        defined = d.util.defined,
	
		        map = dataviz.map,
		        Location = map.Location,
		        Layer = map.layers.Layer;
	
		    // Implementation =========================================================
		    var ShapeLayer = Layer.extend({
		        init: function(map, options) {
	
		            this._pan = proxy(this._pan, this);
	
		            Layer.fn.init.call(this, map, options);
	
		            this.surface = d.Surface.create(this.element, {
		                width: map.scrollElement.width(),
		                height: map.scrollElement.height()
		            });
	
		            this._initRoot();
	
		            this.movable = new kendo.ui.Movable(this.surface.element);
		            this._markers = [];
	
		            this._click = this._handler("shapeClick");
		            this.surface.bind("click", this._click);
	
		            this._mouseenter = this._handler("shapeMouseEnter");
		            this.surface.bind("mouseenter", this._mouseenter);
	
		            this._mouseleave = this._handler("shapeMouseLeave");
		            this.surface.bind("mouseleave", this._mouseleave);
	
		            this._initDataSource();
		        },
	
		        options: {
		            autoBind: true
		        },
	
		        destroy: function() {
		            Layer.fn.destroy.call(this);
	
		            this.surface.destroy();
		            this.dataSource.unbind("change", this._dataChange);
		        },
	
		        setDataSource: function(dataSource) {
		            if (this.dataSource) {
		                this.dataSource.unbind("change", this._dataChange);
		            }
	
		            this.dataSource = kendo.data.DataSource.create(dataSource);
		            this.dataSource.bind("change", this._dataChange);
	
		            if (this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        },
	
		        _reset: function() {
		            Layer.fn._reset.call(this);
		            this._translateSurface();
	
		            if (this._data) {
		                this._load(this._data);
		            }
		        },
	
		        _initRoot: function() {
		            this._root = new Group();
		            this.surface.draw(this._root);
		        },
	
		        _beforeReset: function() {
		            this.surface.clear();
		            this._initRoot();
		        },
	
		        _resize: function() {
		            this.surface.size(this.map.size());
		        },
	
		        _initDataSource: function() {
		            var dsOptions = this.options.dataSource;
		            this._dataChange = proxy(this._dataChange, this);
		            this.dataSource = DataSource
		                .create(dsOptions)
		                .bind("change", this._dataChange);
	
		            if (dsOptions && this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        },
	
		        _dataChange: function(e) {
		            this._data = e.sender.view();
		            this._load(this._data);
		        },
	
		        _load: function(data) {
		            this._clearMarkers();
	
		            if (!this._loader) {
		                this._loader = new GeoJSONLoader(this.map, this.options.style, this);
		            }
	
		            var container = new Group();
		            for (var i = 0; i < data.length; i++) {
		                var shape = this._loader.parse(data[i]);
		                if (shape) {
		                    container.append(shape);
		                }
		            }
	
		            this._root.clear();
		            this._root.append(container);
		        },
	
		        shapeCreated: function(shape) {
		            var cancelled = false;
		            if (shape instanceof d.Circle) {
		                cancelled = defined(this._createMarker(shape));
		            }
	
		            if (!cancelled) {
		                var args = { layer: this, shape: shape };
		                cancelled = this.map.trigger("shapeCreated", args);
		            }
	
		            return cancelled;
		        },
	
		        featureCreated: function(e) {
		            e.layer = this;
		            this.map.trigger("shapeFeatureCreated", e);
		        },
	
		        _createMarker: function(shape) {
		            var marker = this.map.markers.bind({
		                location: shape.location
		            }, shape.dataItem);
	
		            if (marker) {
		                this._markers.push(marker);
		            }
	
		            return marker;
		        },
	
		        _clearMarkers: function() {
		            for (var i = 0; i < this._markers.length; i++) {
		                this.map.markers.remove(this._markers[i]);
		            }
		            this._markers = [];
		        },
	
		        _pan: function() {
		            if (!this._panning) {
		                this._panning = true;
		                this.surface.suspendTracking();
		            }
		        },
	
		        _panEnd: function(e) {
		            Layer.fn._panEnd.call(this, e);
		            this._translateSurface();
		            this.surface.resumeTracking();
		            this._panning = false;
		        },
	
		        _translateSurface: function() {
		            var map = this.map;
		            var nw = map.locationToView(map.extent().nw);
	
		            if (this.surface.translate) {
		                this.surface.translate(nw);
		                this.movable.moveTo({ x: nw.x, y: nw.y });
		            }
		        },
	
		        _handler: function(event) {
		            var layer = this;
		            return function(e) {
		                if (e.element) {
		                    var args = {
		                        layer: layer,
		                        shape: e.element,
		                        originalEvent: e.originalEvent
		                    };
	
		                    layer.map.trigger(event, args);
		                }
		            };
		        },
	
		        _activate: function() {
		            Layer.fn._activate.call(this);
	
		            this.map.bind("pan", this._pan);
		        },
	
		        _deactivate: function() {
		            Layer.fn._deactivate.call(this);
	
		            this.map.unbind("pan", this._pan);
		        }
		    });
	
		    var GeoJSONLoader = Class.extend({
		        init: function(locator, defaultStyle, observer) {
		            this.observer = observer;
		            this.locator = locator;
		            this.style = defaultStyle;
		        },
	
		        parse: function(item) {
		            var root = new Group();
		            var unwrap = true;
	
		            if (item.type === "Feature") {
		                unwrap = false;
		                this._loadGeometryTo(root, item.geometry, item);
		                this._featureCreated(root, item);
		            } else {
		                this._loadGeometryTo(root, item, item);
		            }
	
		            if (unwrap && root.children.length < 2) {
		                root = root.children[0];
		            }
	
		            return root;
		        },
	
		        _shapeCreated: function(shape) {
		            var cancelled = false;
	
		            if (this.observer && this.observer.shapeCreated) {
		                cancelled = this.observer.shapeCreated(shape);
		            }
	
		            return cancelled;
		        },
	
		        _featureCreated: function(group, dataItem) {
		            if (this.observer && this.observer.featureCreated) {
		                this.observer.featureCreated({
		                    group: group,
		                    dataItem: dataItem,
		                    properties: dataItem.properties
		                });
		            }
		        },
	
		        _loadGeometryTo: function(container, geometry, dataItem) {
		            var coords = geometry.coordinates;
		            var i;
		            var path;
	
		            switch(geometry.type) {
		                case "LineString":
		                    path = this._loadPolygon(container, [coords], dataItem);
		                    this._setLineFill(path);
		                    break;
	
		                case "MultiLineString":
		                    for (i = 0; i < coords.length; i++) {
		                        path = this._loadPolygon(container, [coords[i]], dataItem);
		                        this._setLineFill(path);
		                    }
		                    break;
	
		                case "Polygon":
		                    this._loadPolygon(container, coords, dataItem);
		                    break;
	
		                case "MultiPolygon":
		                    for (i = 0; i < coords.length; i++) {
		                        this._loadPolygon(container, coords[i], dataItem);
		                    }
		                    break;
	
		                case "Point":
		                    this._loadPoint(container, coords, dataItem);
		                    break;
	
		                case "MultiPoint":
		                    for (i = 0; i < coords.length; i++) {
		                        this._loadPoint(container, coords[i], dataItem);
		                    }
		                    break;
		            }
		        },
	
		        _setLineFill: function(path) {
		            var segments = path.segments;
		            if (segments.length < 4 || !segments[0].anchor().equals(last(segments).anchor())) {
		                path.options.fill = null;
		            }
		        },
	
		        _loadShape: function(container, shape) {
		            if (!this._shapeCreated(shape)) {
		                container.append(shape);
		            }
	
		            return shape;
		        },
	
		        _loadPolygon: function(container, rings, dataItem) {
		            var shape = this._buildPolygon(rings);
		            shape.dataItem = dataItem;
	
		            return this._loadShape(container, shape);
		        },
	
		        _buildPolygon: function(rings) {
		            var type = rings.length > 1 ? d.MultiPath : d.Path;
		            var path = new type(this.style);
	
		            for (var i = 0; i < rings.length; i++) {
		                for (var j = 0; j < rings[i].length; j++) {
		                    var point = this.locator.locationToView(
		                        Location.fromLngLat(rings[i][j])
		                    );
	
		                    if (j === 0) {
		                        path.moveTo(point.x, point.y);
		                    } else {
		                        path.lineTo(point.x, point.y);
		                    }
		                }
		            }
	
		            return path;
		        },
	
		        _loadPoint: function(container, coords, dataItem) {
		            var location = Location.fromLngLat(coords);
		            var point = this.locator.locationToView(location);
	
		            var circle = new g.Circle(point, 10);
		            var shape = new d.Circle(circle, this.style);
		            shape.dataItem = dataItem;
		            shape.location = location;
	
		            return this._loadShape(container, shape);
		        }
		    });
	
		    // Exports ================================================================
		    deepExtend(kendo.data, {
		        schemas: {
		            geojson: {
		                type: "json",
		                data: function(data) {
		                    if (data.type === "FeatureCollection") {
		                        return data.features;
		                    }
	
		                    if (data.type === "GeometryCollection") {
		                        return data.geometries;
		                    }
	
		                    return data;
		                }
		            }
		        },
		        transports: {
		            geojson: {
		                read: {
		                    dataType: "json"
		                }
		            }
		        }
		    });
	
		    deepExtend(dataviz, {
		        map: {
		            layers: {
		                shape: ShapeLayer,
		                ShapeLayer: ShapeLayer
		            },
		            GeoJSONLoader: GeoJSONLoader
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(894);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 894:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(895) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var kendo = window.kendo,
		        getter = kendo.getter,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
	
		        g = kendo.geometry,
		        d = kendo.drawing,
	
		        util = d.util,
		        defined = util.defined,
	
		        map = dataviz.map,
		        Location = map.Location,
		        ShapeLayer = map.layers.ShapeLayer;
	
		    // Implementation =========================================================
		    var BubbleLayer = ShapeLayer.extend({
		        options: {
		            autoBind: true,
		            locationField: "location",
		            valueField: "value",
		            minSize: 0,
		            maxSize: 100,
		            scale: "sqrt",
		            symbol: "circle"
		        },
	
		        _load: function(data) {
		            this.surface.clear();
	
		            if (data.length === 0) {
		                return;
		            }
	
		            var opt = this.options;
		            var getValue = getter(opt.valueField);
	
		            data = data.slice(0);
		            data.sort(function(a, b) {
		                return getValue(b) - getValue(a);
		            });
	
		            var scaleType = this._scaleType();
		            var scale;
		            for (var i = 0; i < data.length; i++) {
		                var dataItem = data[i];
		                var location = getter(opt.locationField)(dataItem);
		                var value = getter(opt.valueField)(dataItem);
	
		                if (defined(location) && defined(value)) {
		                    if (!scale) {
		                        scale = new scaleType([0, value], [opt.minSize, opt.maxSize]);
		                    }
	
		                    location = Location.create(location);
		                    var center = this.map.locationToView(location);
		                    var size = scale.map(value);
	
		                    var symbol = this._createSymbol({
		                        center: center,
		                        size: size,
		                        style: opt.style,
		                        dataItem: dataItem,
		                        location: location
		                    });
	
		                    symbol.dataItem = dataItem;
		                    symbol.location = location;
		                    symbol.value = value;
	
		                    this._drawSymbol(symbol);
		                }
		            }
		        },
	
		        _scaleType: function() {
		            var scale = this.options.scale;
	
		            if (kendo.isFunction(scale)) {
		                return scale;
		            }
	
		            return dataviz.map.scales[scale];
		        },
	
		        _createSymbol: function(args) {
		            var symbol = this.options.symbol;
		            if (!kendo.isFunction(symbol)) {
		                symbol = dataviz.map.symbols[symbol];
		            }
	
		            return symbol(args);
		        },
	
		        _drawSymbol: function(shape) {
		            var args = { layer: this, shape: shape };
		            var cancelled = this.map.trigger("shapeCreated", args);
		            if (!cancelled) {
		                this.surface.draw(shape);
		            }
		        }
		    });
	
		    var SqrtScale = kendo.Class.extend({
		        init: function(domain, range) {
		            this._domain = domain;
		            this._range = range;
	
		            var domainRange = Math.sqrt(domain[1]) - Math.sqrt(domain[0]);
		            var outputRange = range[1] - range[0];
		            this._ratio = outputRange / domainRange;
		        },
	
		        map: function(value) {
		            var rel = (Math.sqrt(value) - Math.sqrt(this._domain[0])) * this._ratio;
		            return this._range[0] + rel;
		        }
		    });
	
		    var Symbols = {
		        circle: function (args) {
		            var geo = new g.Circle(args.center, args.size / 2);
		            return new d.Circle(geo, args.style);
		        },
	
		        square: function(args) {
		            var path = new d.Path(args.style);
		            var halfSize = args.size / 2;
		            var center = args.center;
	
		            path.moveTo(center.x - halfSize, center.y - halfSize)
		                .lineTo(center.x + halfSize, center.y - halfSize)
		                .lineTo(center.x + halfSize, center.y + halfSize)
		                .lineTo(center.x - halfSize, center.y + halfSize)
		                .close();
	
		            return path;
		        }
		    };
	
		    // Exports ================================================================
		    deepExtend(dataviz, {
		        map: {
		            layers: {
		                bubble: BubbleLayer,
		                BubbleLayer: BubbleLayer
		            },
		            scales: {
		                sqrt: SqrtScale
		            },
		            symbols: Symbols
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 895:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(770);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(901);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 891:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(765);
	
	/***/ }),
	
	/***/ 897:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(769);
	
	/***/ }),
	
	/***/ 901:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(897), __webpack_require__(891) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var math = Math,
	
		        proxy = $.proxy,
	
		        kendo = window.kendo,
		        Class = kendo.Class,
		        template = kendo.template,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
	
		        g = kendo.geometry,
		        Point = g.Point,
	
		        Layer = dataviz.map.layers.Layer,
	
		        util = kendo.util,
		        renderSize = util.renderSize,
	
		        drawingUtil = kendo.drawing.util,
		        round = drawingUtil.round,
		        limit = drawingUtil.limitValue;
	
		    // Image tile layer =============================================================
		    var TileLayer = Layer.extend({
		        init: function(map, options) {
		            Layer.fn.init.call(this, map, options);
	
		            if (typeof this.options.subdomains === "string") {
		                this.options.subdomains = this.options.subdomains.split("");
		            }
	
		            var viewType = this._viewType();
		            this._view = new viewType(this.element, this.options);
		        },
	
		        destroy: function() {
		            Layer.fn.destroy.call(this);
	
		            this._view.destroy();
		            this._view = null;
		        },
	
		        _beforeReset: function() {
		            var map = this.map;
		            var origin = map.locationToLayer(map.extent().nw).round();
		            this._view.viewOrigin(origin);
		        },
	
		        _reset: function() {
		            Layer.fn._reset.call(this);
		            this._updateView();
		            this._view.reset();
		        },
	
		        _viewType: function() {
		            return TileView;
		        },
	
		        _activate: function() {
		            Layer.fn._activate.call(this);
	
		            if (!kendo.support.mobileOS) {
		                if (!this._pan) {
		                    this._pan = kendo.throttle(
		                        proxy(this._render, this),
		                        100
		                    );
		                }
	
		                this.map.bind("pan", this._pan);
		            }
		        },
	
		        _deactivate: function() {
		            Layer.fn._deactivate.call(this);
	
		            if (this._pan) {
		                this.map.unbind("pan", this._pan);
		            }
		        },
	
		        _updateView: function() {
		            var view = this._view,
		                map = this.map,
		                extent = map.extent(),
		                extentToPoint = {
		                    nw: map.locationToLayer(extent.nw).round(),
		                    se: map.locationToLayer(extent.se).round()
		                };
	
		            view.center(map.locationToLayer(map.center()));
		            view.extent(extentToPoint);
		            view.zoom(map.zoom());
		        },
	
		        _resize: function() {
		            this._render();
		        },
	
		        _panEnd: function(e) {
		            Layer.fn._panEnd.call(this, e);
		            this._render();
		        },
	
		        _render: function() {
		            this._updateView();
		            this._view.render();
		        }
		    });
	
		    var TileView = Class.extend({
		        init: function(element, options) {
		            this.element = element;
		            this._initOptions(options);
	
		            this.pool = new TilePool();
		        },
	
		        options: {
		            tileSize: 256,
		            subdomains: ["a", "b", "c"],
		            urlTemplate: ""
		        },
	
		        center: function(center) {
		            this._center = center;
		        },
	
		        extent: function(extent) {
		            this._extent = extent;
		        },
	
		        viewOrigin: function(origin) {
		            this._viewOrigin = origin;
		        },
	
		        zoom: function(zoom) {
		            this._zoom = zoom;
		        },
	
		        pointToTileIndex: function(point) {
		            return new Point(
		                math.floor(point.x / this.options.tileSize),
		                math.floor(point.y / this.options.tileSize)
		            );
		        },
	
		        tileCount: function() {
		            var size = this.size(),
		                firstTileIndex = this.pointToTileIndex(this._extent.nw),
		                nw = this._extent.nw,
		                point = this.indexToPoint(firstTileIndex).translate(-nw.x, -nw.y);
	
		            return {
		                x: math.ceil((math.abs(point.x) + size.width) / this.options.tileSize),
		                y: math.ceil((math.abs(point.y) + size.height) / this.options.tileSize)
		            };
		        },
	
		        size: function() {
		            var nw = this._extent.nw,
		                se = this._extent.se,
		                diff = se.clone().translate(-nw.x, -nw.y);
	
		            return {
		                width: diff.x,
		                height: diff.y
		            };
		        },
	
		        indexToPoint: function(index) {
		            var x = index.x, y = index.y;
	
		            return new Point(
		                x * this.options.tileSize,
		                y * this.options.tileSize
		            );
		        },
	
		        subdomainText: function() {
		            var subdomains = this.options.subdomains;
	
		            return subdomains[this.subdomainIndex++ % subdomains.length];
		        },
	
		        destroy: function() {
		            this.element.empty();
		            this.pool.empty();
		        },
	
		        reset: function() {
		            this.pool.reset();
		            this.subdomainIndex = 0;
		            this.render();
		        },
	
		        render: function() {
		            var size = this.tileCount(),
		                firstTileIndex = this.pointToTileIndex(this._extent.nw),
		                tile, x, y;
	
		            for (x = 0; x < size.x; x++) {
		                for (y = 0; y < size.y; y++) {
		                    tile = this.createTile({
		                        x: firstTileIndex.x + x,
		                        y: firstTileIndex.y + y
		                    });
	
		                    if (!tile.visible) {
		                        tile.show();
		                    }
		                }
		            }
		        },
	
		        createTile: function(currentIndex) {
		            var options = this.tileOptions(currentIndex);
		            var tile = this.pool.get(this._center, options);
		            if (tile.element.parent().length === 0) {
		                this.element.append(tile.element);
		            }
	
		            return tile;
		        },
	
		        tileOptions: function(currentIndex) {
		            var index = this.wrapIndex(currentIndex),
		                point = this.indexToPoint(currentIndex),
		                origin = this._viewOrigin,
		                offset = point.clone().translate(-origin.x, -origin.y);
	
		            return {
		                index: index,
		                currentIndex: currentIndex,
		                point: point,
		                offset: roundPoint(offset),
		                zoom: this._zoom,
		                size: this.options.tileSize,
		                subdomain: this.subdomainText(),
		                urlTemplate: this.options.urlTemplate,
		                errorUrlTemplate: this.options.errorUrlTemplate
		            };
		        },
	
		        wrapIndex: function(index) {
		            var boundary = math.pow(2, this._zoom);
		            return {
		                x: this.wrapValue(index.x, boundary),
		                y: limit(index.y, 0, boundary - 1)
		            };
		        },
	
		        wrapValue: function(value, boundary) {
		            var remainder = (math.abs(value) % boundary);
		            if (value >= 0) {
		                value = remainder;
		            } else {
		                value = boundary - (remainder === 0 ? boundary : remainder);
		            }
	
		            return value;
		        }
		    });
	
		    var ImageTile = Class.extend({
		        init: function(id, options) {
		            this.id = id;
		            this.visible = true;
	
		            this._initOptions(options);
		            this.createElement();
		            this.show();
		        },
	
		        options: {
		            urlTemplate: "",
		            errorUrlTemplate: ""
		        },
	
		        createElement: function() {
		            this.element = $("<img style='position: absolute; display: block;' alt='' />")
		                            .css({ width: this.options.size, height: this.options.size })
		                            .on("error", proxy(function(e) {
		                                if (this.errorUrl()) {
		                                    e.target.setAttribute("src", this.errorUrl());
		                                } else {
		                                    e.target.removeAttribute("src");
		                                }
		                            }, this));
		        },
	
		        show: function() {
		            var element = this.element[0];
		            element.style.top = renderSize(this.options.offset.y);
		            element.style.left = renderSize(this.options.offset.x);
	
		            var url = this.url();
		            if (url) {
		                element.setAttribute("src", url);
		            }
	
		            element.style.visibility = "visible";
		            this.visible = true;
		        },
	
		        hide: function() {
		            this.element[0].style.visibility = "hidden";
		            this.visible = false;
		        },
	
		        url: function() {
		            var urlResult = template(this.options.urlTemplate);
	
		            return urlResult(this.urlOptions());
		        },
	
		        errorUrl: function() {
		            var urlResult = template(this.options.errorUrlTemplate);
	
		            return urlResult(this.urlOptions());
		        },
	
		        urlOptions: function() {
		            var options = this.options;
		            return {
		                zoom: options.zoom,
		                subdomain: options.subdomain,
		                z: options.zoom,
		                x: options.index.x,
		                y: options.index.y,
		                s: options.subdomain,
		                quadkey: options.quadkey,
		                q: options.quadkey,
		                culture: options.culture,
		                c: options.culture
		            };
		        },
	
		        destroy: function() {
		            if (this.element) {
		                this.element.remove();
		                this.element = null;
		            }
		        }
		    });
	
		    var TilePool = Class.extend({
		        init: function() {
		            this._items = [];
		        },
	
		        options: {
		            maxSize: 100
		        },
	
		        get: function(center, options) {
		            if (this._items.length >= this.options.maxSize) {
		                this._remove(center);
		            }
	
		            return this._create(options);
		        },
	
		        empty: function() {
		            var items = this._items;
		            for (var i = 0; i < items.length; i++) {
		                items[i].destroy();
		            }
	
		            this._items = [];
		        },
	
		        reset: function() {
		            var items = this._items;
		            for (var i = 0; i < items.length; i++) {
		                items[i].hide();
		            }
		        },
	
		        _create: function(options) {
		            var items = this._items;
		            var tile;
	
		            // Build an unique token for the image
		            // This normally would be the URL, but we don't care about subdomains
		            var id = util.hashKey(
		                options.point.toString() +
		                options.offset.toString() +
		                options.zoom +
		                options.urlTemplate
		            );
	
		            for (var i = 0; i < items.length; i++) {
		                if (items[i].id === id) {
		                    tile = items[i];
		                    break;
		                }
		            }
	
		            if (tile) {
		                tile.show();
		            } else {
		                tile = new ImageTile(id, options);
		                this._items.push(tile);
		            }
	
		            return tile;
		        },
	
		        _remove: function(center) {
		            var items = this._items;
		            var maxDist = -1;
		            var index = -1;
	
		            for (var i = 0; i < items.length; i++) {
		                var dist = items[i].options.point.distanceTo(center);
		                if (dist > maxDist && !items[i].visible) {
		                    index = i;
		                    maxDist = dist;
		                }
		            }
	
		            if (index !== -1) {
		                items[index].destroy();
		                items.splice(index, 1);
		            }
		        }
		    });
	
		    // Methods ================================================================
		    function roundPoint(point) {
		        return new Point(round(point.x), round(point.y));
		    }
	
		    // Exports ================================================================
		    deepExtend(dataviz, {
		        map: {
		            layers: {
		                tile: TileLayer,
		                TileLayer: TileLayer,
	
		                ImageTile: ImageTile,
		                TilePool: TilePool,
		                TileView: TileView
		            }
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(892);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 892:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(893) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function() {
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var kendo = window.kendo,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
		        defined = kendo.drawing.util.defined,
	
		        Extent = dataviz.map.Extent,
		        Location = dataviz.map.Location,
		        TileLayer = dataviz.map.layers.TileLayer,
		        TileView = dataviz.map.layers.TileView;
	
		    // Bing tile layer =============================================================
		    var BingLayer = TileLayer.extend({
		        init: function(map, options) {
		            this.options.baseUrl =
		                this._scheme() +
		                "://dev.virtualearth.net/REST/v1/Imagery/Metadata/";
	
		            TileLayer.fn.init.call(this, map, options);
	
		            this._onMetadata = $.proxy(this._onMetadata, this);
		            this._fetchMetadata();
		        },
	
		        options: {
		            imagerySet: "road"
		        },
	
		        _fetchMetadata: function() {
		            var options = this.options;
	
		            if (!options.key) {
		                throw new Error("Bing tile layer: API key is required");
		            }
	
		            $.ajax({
		                url: options.baseUrl + options.imagerySet,
		                data: {
		                    output: "json",
		                    include: "ImageryProviders",
		                    key: options.key,
		                    uriScheme: this._scheme()
		                },
		                type: "get",
		                dataType: "jsonp",
		                jsonp: "jsonp",
		                success: this._onMetadata
		            });
		        },
	
		        _scheme: function(proto) {
		            proto = proto || window.location.protocol;
		            return proto.replace(":", "") === "https" ? "https" : "http";
		        },
	
		        _onMetadata: function(data) {
		            if (data && data.resourceSets.length) {
		                var resource = this.resource = data.resourceSets[0].resources[0];
	
		                deepExtend(this._view.options, {
		                    urlTemplate: resource.imageUrl
		                        .replace("{subdomain}", "#= subdomain #")
		                        .replace("{quadkey}", "#= quadkey #")
		                        .replace("{culture}", "#= culture #"),
		                    subdomains: resource.imageUrlSubdomains
		                });
	
		                var options = this.options;
		                if (!defined(options.minZoom)) {
		                    options.minZoom = resource.zoomMin;
		                }
		                if (!defined(options.maxZoom)) {
		                    options.maxZoom = resource.zoomMax;
		                }
	
		                this._addAttribution();
	
		                if (this.element.css("display") !== "none") {
		                    this._reset();
		                }
		            }
		        },
	
		        _viewType: function() {
		            return BingView;
		        },
	
		        _addAttribution: function() {
		            var attr = this.map.attribution;
		            if (attr) {
		                var items = this.resource.imageryProviders;
		                if (items) {
		                    for (var i = 0; i < items.length; i++) {
		                        var item = items[i];
		                        for (var y = 0; y < item.coverageAreas.length; y++) {
		                            var area = item.coverageAreas[y];
		                            attr.add({
		                                text: item.attribution,
		                                minZoom: area.zoomMin,
		                                maxZoom: area.zoomMax,
		                                extent: new Extent(
		                                    new Location(area.bbox[2], area.bbox[1]),
		                                    new Location(area.bbox[0], area.bbox[3])
		                                )
		                            });
		                        }
		                    }
		                }
		            }
		        },
	
		        imagerySet: function(value) {
		            if (value) {
		                this.options.imagerySet = value;
		                this.map.attribution.clear();
		                this._fetchMetadata();
		            } else {
		                return this.options.imagerySet;
		            }
		        }
		    });
	
		    var BingView = TileView.extend({
		        options: {
		            culture: "en-US"
		        },
	
		        tileOptions: function(currentIndex) {
		            var options = TileView.fn.tileOptions.call(this, currentIndex);
	
		            options.culture = this.options.culture;
		            options.quadkey = this.tileQuadKey(this.wrapIndex(currentIndex));
	
		            return options;
		        },
	
		        tileQuadKey: function(index) {
		            var quadKey = "",
		                digit, mask, i;
	
		            for (i = this._zoom; i > 0; i--) {
		                digit = 0;
		                mask = 1 << (i - 1);
	
		                if ((index.x & mask) !== 0) {
		                    digit++;
		                }
	
		                if ((index.y & mask) !== 0) {
		                    digit += 2;
		                }
	
		                quadKey += digit;
		            }
	
		            return quadKey;
		        }
		    });
	
		    // Exports ================================================================
		    deepExtend(dataviz, {
		        map: {
		            layers: {
		                bing: BingLayer,
		                BingLayer: BingLayer,
		                BingView: BingView
		            }
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 893:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(772);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(896);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 891:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(765);
	
	/***/ }),
	
	/***/ 896:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(897), __webpack_require__(891),
		             __webpack_require__(898), __webpack_require__(899) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var doc = document,
		        math = Math,
		        indexOf = $.inArray,
		        proxy = $.proxy,
	
		        kendo = window.kendo,
		        Class = kendo.Class,
		        DataSource = kendo.data.DataSource,
		        Tooltip = kendo.ui.Tooltip,
	
		        dataviz = kendo.dataviz,
		        deepExtend = kendo.deepExtend,
	
		        map = dataviz.map,
		        Location = map.Location,
		        Layer = map.layers.Layer;
	
		    // Implementation =========================================================
		    var MarkerLayer = Layer.extend({
		        init: function(map, options) {
		            Layer.fn.init.call(this, map, options);
	
		            this._markerClick = proxy(this._markerClick, this);
		            this.element.on("click", ".k-marker", this._markerClick);
	
		            this.items = [];
		            this._initDataSource();
		        },
	
		        destroy: function() {
		            Layer.fn.destroy.call(this);
	
		            this.element.off("click", ".k-marker", this._markerClick);
	
		            this.dataSource.unbind("change", this._dataChange);
		            this.clear();
		        },
	
		        options: {
		            zIndex: 1000,
		            autoBind: true,
		            dataSource: {},
		            locationField: "location",
		            titleField: "title"
		        },
	
		        add: function(arg) {
		            if ($.isArray(arg)) {
		                for (var i = 0; i < arg.length; i++) {
		                    this._addOne(arg[i]);
		                }
		            } else {
		                return this._addOne(arg);
		            }
		        },
	
		        remove: function(marker) {
		            marker.destroy();
	
		            var index = indexOf(marker, this.items);
		            if (index > -1) {
		                this.items.splice(index, 1);
		            }
		        },
	
		        clear: function() {
		            for (var i = 0; i < this.items.length; i++) {
		                this.items[i].destroy();
		            }
	
		            this.items = [];
		        },
	
		        update: function(marker) {
		            var loc = marker.location();
		            if (loc) {
		                marker.showAt(this.map.locationToView(loc));
	
		                var args = { marker: marker, layer: this };
		                this.map.trigger("markerActivate", args);
		            }
		        },
	
		        _reset: function() {
		            Layer.fn._reset.call(this);
		            var items = this.items;
		            for (var i = 0; i < items.length; i++) {
		                this.update(items[i]);
		            }
		        },
	
		        bind: function (options, dataItem) {
		            var marker = map.Marker.create(options, this.options);
		            marker.dataItem = dataItem;
	
		            var args = { marker: marker, layer: this };
		            var cancelled = this.map.trigger("markerCreated", args);
		            if (!cancelled) {
		                this.add(marker);
		                return marker;
		            }
		        },
	
		        setDataSource: function(dataSource) {
		            if (this.dataSource) {
		                this.dataSource.unbind("change", this._dataChange);
		            }
	
		            this.dataSource = kendo.data.DataSource.create(dataSource);
		            this.dataSource.bind("change", this._dataChange);
	
		            if (this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        },
	
		        _addOne: function(arg) {
		            var marker = Marker.create(arg, this.options);
		            marker.addTo(this);
	
		            return marker;
		        },
	
		        _initDataSource: function() {
		            var dsOptions = this.options.dataSource;
		            this._dataChange = proxy(this._dataChange, this);
		            this.dataSource = DataSource
		                .create(dsOptions)
		                .bind("change", this._dataChange);
	
		            if (dsOptions && this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        },
	
		        _dataChange: function(e) {
		            this._load(e.sender.view());
		        },
	
		        _load: function(data) {
		            this._data = data;
		            this.clear();
	
		            var getLocation = kendo.getter(this.options.locationField);
		            var getTitle = kendo.getter(this.options.titleField);
		            for (var i = 0; i < data.length; i++) {
		                var dataItem = data[i];
		                this.bind({
		                    location: getLocation(dataItem),
		                    title: getTitle(dataItem)
		                }, dataItem);
		            }
		        },
	
		        _markerClick: function(e) {
		            var args = { marker: $(e.target).data("kendoMarker"), layer: this };
		            this.map.trigger("markerClick", args);
		        }
		    });
	
		    var Marker = Class.extend({
		        init: function(options) {
		            this.options = options || {};
		        },
	
		        addTo: function(parent) {
		            this.layer = parent.markers || parent;
		            this.layer.items.push(this);
		            this.layer.update(this);
		        },
	
		        location: function(value) {
		            if (value) {
		                this.options.location = Location.create(value).toArray();
	
		                if (this.layer) {
		                    this.layer.update(this);
		                }
	
		                return this;
		            } else {
		                return Location.create(this.options.location);
		            }
		        },
	
		        showAt: function(point) {
		            this.render();
		            this.element.css({
		                left: math.round(point.x),
		                top: math.round(point.y)
		            });
	
		            if (this.tooltip && this.tooltip.popup) {
		                // TODO: Expose popup/tooltip updatePosition? method
		                this.tooltip.popup._position();
		            }
		        },
	
		        hide: function() {
		            if (this.element) {
		                this.element.remove();
		                this.element = null;
		            }
	
		            if (this.tooltip) {
		                this.tooltip.destroy();
		                this.tooltip = null;
		            }
		        },
	
		        destroy: function() {
		            this.layer = null;
		            this.hide();
		        },
	
		        render: function() {
		            if (!this.element) {
		                var options = this.options;
		                var layer = this.layer;
	
		                this.element = $(doc.createElement("span"))
		                    .addClass("k-marker k-icon k-i-marker-" + kendo.toHyphens(options.shape || "pin"))
		                    .attr("title", options.title)
		                    .attr(options.attributes || {})
		                    .data("kendoMarker", this)
		                    .css("zIndex", options.zIndex);
	
		                if (layer) {
		                    layer.element.append(this.element);
		                }
	
		                this.renderTooltip();
		            }
		        },
	
		        renderTooltip: function() {
		            var marker = this;
		            var title = marker.options.title;
		            var options = marker.options.tooltip || {};
	
		            if (options && Tooltip) {
		                var template = options.template;
		                if (template) {
		                    var contentTemplate = kendo.template(template);
		                    options.content = function(e) {
		                        e.location = marker.location();
		                        e.marker = marker;
		                        return contentTemplate(e);
		                    };
		                }
	
		                if (title || options.content || options.contentUrl) {
		                    this.tooltip = new Tooltip(this.element, options);
		                    this.tooltip.marker = this;
		                }
		            }
		        }
		    });
	
		    Marker.create = function(arg, defaults) {
		        if (arg instanceof Marker) {
		            return arg;
		        }
	
		        return new Marker(deepExtend({}, defaults, arg));
		    };
	
		    // Exports ================================================================
		    deepExtend(dataviz, {
		        map: {
		            layers: {
		                marker: MarkerLayer,
		                MarkerLayer: MarkerLayer
		            },
		            Marker: Marker
		        }
		    });
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 897:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(769);
	
	/***/ }),
	
	/***/ 898:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 899:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(582);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(904);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 888:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(765);
	
	/***/ }),
	
	/***/ 904:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(905), __webpack_require__(888)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var doc = document,
		        math = Math,
		        min = math.min,
		        pow = math.pow,
	
		        proxy = $.proxy,
	
		        kendo = window.kendo,
		        Widget = kendo.ui.Widget,
		        deepExtend = kendo.deepExtend,
	
		        dataviz = kendo.dataviz,
		        ui = dataviz.ui,
	
		        g = kendo.geometry,
		        Point = g.Point,
	
		        map = dataviz.map,
		        Extent = map.Extent,
		        Location = map.Location,
		        EPSG3857 = map.crs.EPSG3857,
	
		        util = kendo.util,
		        renderPos = util.renderPos,
	
		        drawingUtil = kendo.drawing.util,
	
		        defined = drawingUtil.defined,
		        limit = drawingUtil.limitValue,
		        valueOrDefault = drawingUtil.valueOrDefault;
	
		    // Constants ==============================================================
		    var CSS_PREFIX = "k-",
		        FRICTION = 0.90,
		        FRICTION_MOBILE = 0.93,
		        MOUSEWHEEL = "DOMMouseScroll mousewheel",
		        VELOCITY_MULTIPLIER = 5,
		        DEFAULT_ZOOM_RATE = 1;
	
		    // Map widget =============================================================
		    var Map = Widget.extend({
		        init: function(element, options) {
		            kendo.destroy(element);
		            Widget.fn.init.call(this, element);
	
		            this._initOptions(options);
		            this.bind(this.events, options);
	
		            this.crs = new EPSG3857();
	
		            this.element
		                .addClass(CSS_PREFIX + this.options.name.toLowerCase())
		                .css("position", "relative")
		                .empty()
		                .append(doc.createElement("div"));
	
		            this._viewOrigin = this._getOrigin();
		            this._initScroller();
		            this._initMarkers();
		            this._initControls();
		            this._initLayers();
		            this._reset();
	
		            this._mousewheel = proxy(this._mousewheel, this);
		            this.element.bind(MOUSEWHEEL, this._mousewheel);
		        },
	
		        options: {
		            name: "Map",
		            controls: {
		                attribution: true,
		                navigator: {
		                    panStep: 100
		                },
		                zoom: true
		            },
		            layers: [],
		            layerDefaults: {
		                shape: {
		                    style: {
		                        fill: {
		                            color: "#fff"
		                        },
		                        stroke: {
		                            color: "#aaa",
		                            width: 0.5
		                        }
		                    }
		                },
		                bubble: {
		                    style: {
		                        fill: {
		                            color: "#fff",
		                            opacity: 0.5
		                        },
		                        stroke: {
		                            color: "#aaa",
		                            width: 0.5
		                        }
		                    }
		                },
		                marker: {
		                    shape: "pinTarget",
		                    tooltip: {
		                        position: "top"
		                    }
		                }
		            },
		            center: [0, 0],
		            zoom: 3,
		            minSize: 256,
		            minZoom: 1,
		            maxZoom: 19,
		            markers: [],
		            markerDefaults: {
		                shape: "pinTarget",
		                tooltip: {
		                    position: "top"
		                }
		            },
		            wraparound: true
		        },
	
		        events:[
		            "beforeReset",
		            "click",
		            "markerActivate",
		            "markerClick",
		            "markerCreated",
		            "pan",
		            "panEnd",
		            "reset",
		            "shapeClick",
		            "shapeCreated",
		            "shapeFeatureCreated",
		            "shapeMouseEnter",
		            "shapeMouseLeave",
		            "zoomEnd",
		            "zoomStart"
		        ],
	
		        destroy: function() {
		            this.scroller.destroy();
	
		            if (this.navigator) {
		                this.navigator.destroy();
		            }
	
		            if (this.attribution) {
		                this.attribution.destroy();
		            }
	
		            if (this.zoomControl) {
		                this.zoomControl.destroy();
		            }
	
		            this.markers.destroy();
	
		            for (var i = 0; i < this.layers.length; i++) {
		                this.layers[i].destroy();
		            }
	
		            Widget.fn.destroy.call(this);
		        },
	
		        zoom: function(level) {
		            var options = this.options;
	
		            if (defined(level)) {
		                level = math.round(limit(level, options.minZoom, options.maxZoom));
		                if (options.zoom !== level) {
		                    options.zoom = level;
		                    this._reset();
		                }
	
		                return this;
		            } else {
		                return options.zoom;
		            }
		        },
	
		        center: function(center) {
		            if (center) {
		                this.options.center = Location.create(center).toArray();
		                this._reset();
	
		                return this;
		            } else {
		                return Location.create(this.options.center);
		            }
		        },
	
		        extent: function(extent) {
		            if (extent) {
		                this._setExtent(extent);
		                return this;
		            } else {
		                return this._getExtent();
		            }
		        },
	
		        setOptions: function(options) {
		            Widget.fn.setOptions.call(this, options);
		            this._reset();
		        },
	
		        locationToLayer: function(location, zoom) {
		            var clamp = !this.options.wraparound;
		            location = Location.create(location);
		            return this.crs.toPoint(location, this._layerSize(zoom), clamp);
		        },
	
		        layerToLocation: function(point, zoom) {
		            var clamp = !this.options.wraparound;
		            point = Point.create(point);
		            return  this.crs.toLocation(point, this._layerSize(zoom), clamp);
		        },
	
		        locationToView: function(location) {
		            location = Location.create(location);
		            var origin = this.locationToLayer(this._viewOrigin);
		            var point = this.locationToLayer(location);
	
		            return point.translateWith(origin.scale(-1));
		        },
	
		        viewToLocation: function(point, zoom) {
		            var origin = this.locationToLayer(this._getOrigin(), zoom);
		            point = Point.create(point);
		            point = point.clone().translateWith(origin);
		            return this.layerToLocation(point, zoom);
		        },
	
		        eventOffset: function(e) {
		            var point;
		            var x;
		            var y;
		            var offset = this.element.offset();
	
		            if (e.x || e.y) {
		                var field = "location";
		                x = e.x[field] - offset.left;
		                y = e.y[field] - offset.top;
		                point = new g.Point(x, y);
		            } else {
		                var event = e.originalEvent || e;
		                x = valueOrDefault(event.pageX, event.clientX) - offset.left;
		                y = valueOrDefault(event.pageY, event.clientY) - offset.top;
		                point = new g.Point(x, y);
		            }
	
		            return point;
		        },
	
		        eventToView: function(e) {
		            var cursor = this.eventOffset(e);
		            return this.locationToView(this.viewToLocation(cursor));
		        },
	
		        eventToLayer: function(e) {
		            return this.locationToLayer(this.eventToLocation(e));
		        },
	
		        eventToLocation: function(e) {
		            var cursor = this.eventOffset(e);
		            return this.viewToLocation(cursor);
		        },
	
		        viewSize: function() {
		            var element = this.element;
		            var scale = this._layerSize();
		            var width = element.width();
	
		            if (!this.options.wraparound) {
		                width = min(scale, width);
		            }
		            return {
		                width: width,
		                height: min(scale, element.height())
		            };
		        },
	
		        exportVisual: function() {
		            this._reset();
		            return false;
		        },
	
		        _setOrigin: function(origin, zoom) {
		            var size = this.viewSize(),
		                topLeft;
	
		            origin = this._origin = Location.create(origin);
		            topLeft = this.locationToLayer(origin, zoom);
		            topLeft.x += size.width / 2;
		            topLeft.y += size.height / 2;
	
		            this.options.center = this.layerToLocation(topLeft, zoom).toArray();
	
		            return this;
		        },
	
		        _getOrigin: function(invalidate) {
		            var size = this.viewSize(),
		                topLeft;
	
		            if (invalidate || !this._origin) {
		                topLeft = this.locationToLayer(this.center());
		                topLeft.x -= size.width / 2;
		                topLeft.y -= size.height / 2;
	
		                this._origin = this.layerToLocation(topLeft);
		            }
	
		            return this._origin;
		        },
	
		        _setExtent: function(extent) {
		            var raw = Extent.create(extent);
		            var se = raw.se.clone();
		            if (this.options.wraparound && se.lng < 0 && extent.nw.lng > 0) {
		                se.lng = 180 + (180 + se.lng);
		            }
	
		            extent = new Extent(raw.nw, se);
		            this.center(extent.center());
	
		            var width = this.element.width();
		            var height = this.element.height();
		            for (var zoom = this.options.maxZoom; zoom >= this.options.minZoom; zoom--) {
		                var topLeft = this.locationToLayer(extent.nw, zoom);
		                var bottomRight = this.locationToLayer(extent.se, zoom);
	
		                var layerWidth = math.abs(bottomRight.x - topLeft.x);
		                var layerHeight = math.abs(bottomRight.y - topLeft.y);
	
		                if (layerWidth <= width && layerHeight <= height) {
		                    break;
		                }
		            }
	
		            this.zoom(zoom);
		        },
	
		        _getExtent: function() {
		            var nw = this._getOrigin();
		            var bottomRight = this.locationToLayer(nw);
		            var size = this.viewSize();
	
		            bottomRight.x += size.width;
		            bottomRight.y += size.height;
	
		            var se = this.layerToLocation(bottomRight);
		            return new Extent(nw, se);
		        },
	
		        _zoomAround: function(pivot, level) {
		            this._setOrigin(this.layerToLocation(pivot, level), level);
		            this.zoom(level);
		        },
	
		        _initControls: function() {
		            var controls = this.options.controls;
	
		            if (ui.Attribution && controls.attribution) {
		                this._createAttribution(controls.attribution);
		            }
	
		            if (!kendo.support.mobileOS) {
		                if (ui.Navigator && controls.navigator) {
		                    this._createNavigator(controls.navigator);
		                }
	
		                if (ui.ZoomControl && controls.zoom) {
		                    this._createZoomControl(controls.zoom);
		                }
		            }
		        },
	
		        _createControlElement: function(options, defaultPos) {
		            var pos = options.position || defaultPos;
		            var posSelector = "." + renderPos(pos).replace(" ", ".");
		            var wrap = $(".k-map-controls" + posSelector, this.element);
		            if (wrap.length === 0) {
		                wrap = $("<div>")
		                       .addClass("k-map-controls " + renderPos(pos))
		                       .appendTo(this.element);
		            }
	
		            return $("<div>").appendTo(wrap);
		        },
	
		        _createAttribution: function(options) {
		            var element = this._createControlElement(options, "bottomRight");
		            this.attribution = new ui.Attribution(element, options);
		        },
	
		        _createNavigator: function(options) {
		            var element = this._createControlElement(options, "topLeft");
		            var navigator = this.navigator = new ui.Navigator(element, options);
	
		            this._navigatorPan = proxy(this._navigatorPan, this);
		            navigator.bind("pan", this._navigatorPan);
	
		            this._navigatorCenter = proxy(this._navigatorCenter, this);
		            navigator.bind("center", this._navigatorCenter);
		        },
	
		        _navigatorPan: function(e) {
		            var map = this;
		            var scroller = map.scroller;
	
		            var x = scroller.scrollLeft + e.x;
		            var y = scroller.scrollTop - e.y;
	
		            var bounds = this._virtualSize;
		            var height = this.element.height();
		            var width = this.element.width();
	
		            // TODO: Move limits in scroller
		            x = limit(x, bounds.x.min, bounds.x.max - width);
		            y = limit(y, bounds.y.min, bounds.y.max - height);
	
		            map.scroller.one("scroll", function(e) { map._scrollEnd(e); });
		            map.scroller.scrollTo(-x, -y);
		        },
	
		        _navigatorCenter: function() {
		            this.center(this.options.center);
		        },
	
		        _createZoomControl: function(options) {
		            var element = this._createControlElement(options, "topLeft");
		            var zoomControl = this.zoomControl = new ui.ZoomControl(element, options);
	
		            this._zoomControlChange = proxy(this._zoomControlChange, this);
		            zoomControl.bind("change", this._zoomControlChange);
		        },
	
		        _zoomControlChange: function(e) {
		            if (!this.trigger("zoomStart", { originalEvent: e })) {
		                this.zoom(this.zoom() + e.delta);
		                this.trigger("zoomEnd", { originalEvent: e });
		            }
		        },
	
		        _initScroller: function() {
		            var friction = kendo.support.mobileOS ? FRICTION_MOBILE : FRICTION;
		            var zoomable = this.options.zoomable !== false;
		            var scroller = this.scroller = new kendo.mobile.ui.Scroller(
		                this.element.children(0), {
		                    friction: friction,
		                    velocityMultiplier: VELOCITY_MULTIPLIER,
		                    zoom: zoomable,
		                    mousewheelScrolling: false,
		                    supportDoubleTap: true
		                });
	
		            scroller.bind("scroll", proxy(this._scroll, this));
		            scroller.bind("scrollEnd", proxy(this._scrollEnd, this));
		            scroller.userEvents.bind("gesturestart", proxy(this._scaleStart, this));
		            scroller.userEvents.bind("gestureend", proxy(this._scale, this));
		            scroller.userEvents.bind("doubleTap", proxy(this._doubleTap, this));
		            scroller.userEvents.bind("tap", proxy(this._tap, this));
	
		            this.scrollElement = scroller.scrollElement;
		        },
	
		        _initLayers: function() {
		            var defs = this.options.layers,
		                layers = this.layers = [];
	
		            for (var i = 0; i < defs.length; i++) {
		                var options = defs[i];
		                var type = options.type || "shape";
		                var defaults = this.options.layerDefaults[type];
		                var impl = dataviz.map.layers[type];
	
		                layers.push(new impl(this, deepExtend({}, defaults, options)));
		            }
		        },
	
		        _initMarkers: function() {
		            this.markers = new map.layers.MarkerLayer(this, this.options.markerDefaults);
		            this.markers.add(this.options.markers);
		        },
	
		        _scroll: function(e) {
		            var origin = this.locationToLayer(this._viewOrigin).round();
		            var movable = e.sender.movable;
	
		            var offset = new g.Point(movable.x, movable.y).scale(-1).scale(1/movable.scale);
		            origin.x += offset.x;
		            origin.y += offset.y;
	
		            this._scrollOffset = offset;
	
		            this._setOrigin(this.layerToLocation(origin));
		            this.trigger("pan", {
		                originalEvent: e,
		                origin: this._getOrigin(),
		                center: this.center()
		            });
		        },
	
		        _scrollEnd: function(e) {
		            if (!this._scrollOffset || !this._panComplete()) {
		                return;
		            }
	
		            this._scrollOffset = null;
		            this._panEndTS = new Date();
	
		            this.trigger("panEnd", {
		                originalEvent: e,
		                origin: this._getOrigin(),
		                center: this.center()
		            });
		        },
	
		        _panComplete: function() {
		            return new Date() - (this._panEndTS || 0) > 50;
		        },
	
		        _scaleStart: function(e) {
		            if (this.trigger("zoomStart", { originalEvent: e })) {
		                var touch = e.touches[1];
		                if (touch) {
		                    touch.cancel();
		                }
		            }
		        },
	
		        _scale: function(e) {
		            var scale = this.scroller.movable.scale;
		            var zoom = this._scaleToZoom(scale);
		            var gestureCenter = new g.Point(e.center.x, e.center.y);
		            var centerLocation = this.viewToLocation(gestureCenter, zoom);
		            var centerPoint = this.locationToLayer(centerLocation, zoom);
		            var originPoint = centerPoint.translate(-gestureCenter.x, -gestureCenter.y);
	
		            this._zoomAround(originPoint, zoom);
		            this.trigger("zoomEnd", { originalEvent: e });
		        },
	
		        _scaleToZoom: function(scaleDelta) {
		            var scale = this._layerSize() * scaleDelta;
		            var tiles = scale / this.options.minSize;
		            var zoom = math.log(tiles) / math.log(2);
	
		            return math.round(zoom);
		        },
	
		        _reset: function() {
		            if (this.attribution) {
		                this.attribution.filter(this.center(), this.zoom());
		            }
	
		            this._viewOrigin = this._getOrigin(true);
		            this._resetScroller();
		            this.trigger("beforeReset");
		            this.trigger("reset");
		        },
	
		        _resetScroller: function() {
		            var scroller = this.scroller;
		            var x = scroller.dimensions.x;
		            var y = scroller.dimensions.y;
		            var scale = this._layerSize();
		            var nw = this.extent().nw;
		            var topLeft = this.locationToLayer(nw).round();
	
		            scroller.movable.round = true;
		            scroller.reset();
		            scroller.userEvents.cancel();
	
		            var zoom = this.zoom();
		            scroller.dimensions.forcedMinScale = pow(2, this.options.minZoom - zoom);
		            scroller.dimensions.maxScale = pow(2, this.options.maxZoom - zoom);
	
		            var xBounds = { min: -topLeft.x, max: scale - topLeft.x };
		            var yBounds = { min: -topLeft.y, max: scale - topLeft.y };
	
		            if (this.options.wraparound) {
		                xBounds.max = 20 * scale;
		                xBounds.min = -xBounds.max;
		            }
	
		            if (this.options.pannable === false) {
		                var viewSize = this.viewSize();
		                xBounds.min = yBounds.min = 0;
		                xBounds.max = viewSize.width;
		                yBounds.max = viewSize.height;
		            }
	
		            x.makeVirtual();
		            y.makeVirtual();
		            x.virtualSize(xBounds.min, xBounds.max);
		            y.virtualSize(yBounds.min, yBounds.max);
	
		            this._virtualSize = { x: xBounds, y: yBounds };
		        },
	
		        _renderLayers: function() {
		            var defs = this.options.layers,
		                layers = this.layers = [],
		                scrollWrap = this.scrollWrap;
	
		            scrollWrap.empty();
	
		            for (var i = 0; i < defs.length; i++) {
		                var options = defs[i];
		                var type = options.type || "shape";
		                var defaults = this.options.layerDefaults[type];
		                var impl = dataviz.map.layers[type];
	
		                layers.push(new impl(this, deepExtend({}, defaults, options)));
		            }
		        },
	
		        _layerSize: function(zoom) {
		            zoom = valueOrDefault(zoom, this.options.zoom);
		            return this.options.minSize * pow(2, zoom);
		        },
	
		        _tap: function(e) {
		            if (!this._panComplete()) {
		                return;
		            }
	
		            var cursor = this.eventOffset(e);
		            this.trigger("click", {
		                originalEvent: e,
		                location: this.viewToLocation(cursor)
		            });
		        },
	
		        _doubleTap: function(e) {
		            var options = this.options;
		            if (options.zoomable !== false) {
		                if (!this.trigger("zoomStart", { originalEvent: e })) {
		                    var toZoom = this.zoom() + DEFAULT_ZOOM_RATE;
		                    var cursor = this.eventOffset(e);
		                    var location = this.viewToLocation(cursor);
		                    var postZoom = this.locationToLayer(location, toZoom);
		                    var origin = postZoom.translate(-cursor.x, -cursor.y);
		                    this._zoomAround(origin, toZoom);
		                    this.trigger("zoomEnd", { originalEvent: e });
		                }
		            }
		        },
	
		        _mousewheel: function(e) {
		            e.preventDefault();
		            var delta = dataviz.mwDelta(e) > 0 ? -1 : 1;
		            var options = this.options;
		            var fromZoom = this.zoom();
		            var toZoom = limit(fromZoom + delta, options.minZoom, options.maxZoom);
	
		            if (options.zoomable !== false && toZoom !== fromZoom) {
		                if (!this.trigger("zoomStart", { originalEvent: e })) {
		                    var cursor = this.eventOffset(e);
		                    var location = this.viewToLocation(cursor);
		                    var postZoom = this.locationToLayer(location, toZoom);
		                    var origin = postZoom.translate(-cursor.x, -cursor.y);
		                    this._zoomAround(origin, toZoom);
	
		                    this.trigger("zoomEnd", { originalEvent: e });
		                }
		            }
		        }
		    });
	
		    // Exports ================================================================
		    dataviz.ui.plugin(Map);
	
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 905:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(768);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1079);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1000:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1079:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1013), __webpack_require__(1059), __webpack_require__(1038), __webpack_require__(1022),
		        __webpack_require__(1000),
	
		       __webpack_require__(1080),
		       __webpack_require__(1081),
		       __webpack_require__(1082),
		       __webpack_require__(1083),
		       __webpack_require__(1084),
		       __webpack_require__(1085)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		    var __meta__ = { // jshint ignore:line
		        id: "dataviz.diagram",
		        name: "Diagram",
		        category: "dataviz",
		        description: "The Kendo DataViz Diagram ",
		        depends: [ "data", "userevents", "mobile.scroller", "draganddrop", "drawing", "dataviz.core", "dataviz.themes", "toolbar" ],
		        features: [{
		            id: "dataviz.diagram-pdf-export",
		            name: "PDF export",
		            description: "Export Diagram as PDF",
		            depends: [ "pdf" ]
		        },{
		            id: "dataviz.diagram-editing",
		            name: "Editing",
		            description: "Support for model editing",
		            depends: [ "editable", "window", "dropdownlist" ]
		        }]
		    };
	
		    return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1080:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(777);
	
	/***/ }),
	
	/***/ 1081:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(778);
	
	/***/ }),
	
	/***/ 1082:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(779);
	
	/***/ }),
	
	/***/ 1083:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(780);
	
	/***/ }),
	
	/***/ 1084:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(781);
	
	/***/ }),
	
	/***/ 1085:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(782);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(882);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 862:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 882:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(862) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        diagram = kendo.dataviz.diagram = {},
		        deepExtend = kendo.deepExtend,
		        isArray = $.isArray,
		        EPSILON = 1e-06;
	
		    /*-------------------Diverse utilities----------------------------*/
		    var Utils = {
		    };
	
		    deepExtend(Utils, {
		        isNearZero: function (num) {
		            return Math.abs(num) < EPSILON;
		        },
		        isDefined: function (obj) {
		            return typeof obj !== 'undefined';
		        },
	
		        isUndefined: function (obj) {
		            return (typeof obj === 'undefined') || obj === null;
		        },
		        /**
		         * Returns whether the given object is an object or a value.
		         */
		        isObject: function (obj) {
		            return obj === Object(obj);
		        },
		        /**
		         * Returns whether the object has a property with the given name.
		         */
		        has: function (obj, key) {
		            return Object.hasOwnProperty.call(obj, key);
		        },
		        /**
		         * Returns whether the given object is a string.
		         */
		        isString: function (obj) {
		            return Object.prototype.toString.call(obj) == '[object String]';
		        },
		        isBoolean: function (obj) {
		            return Object.prototype.toString.call(obj) == '[object Boolean]';
		        },
		        isType: function (obj, type) {
		            return Object.prototype.toString.call(obj) == '[object ' + type + ']';
		        },
		        /**
		         * Returns whether the given object is a number.
		         */
		        isNumber: function (obj) {
		            return !isNaN(parseFloat(obj)) && isFinite(obj);
		        },
		        /**
		         * Return whether the given object (array or dictionary).
		         */
		        isEmpty: function (obj) {
		            if (obj === null) {
		                return true;
		            }
		            if (isArray(obj) || Utils.isString(obj)) {
		                return obj.length === 0;
		            }
		            for (var key in obj) {
		                if (Utils.has(obj, key)) {
		                    return false;
		                }
		            }
		            return true;
		        },
		        simpleExtend: function(destination, source) {
		            if(!Utils.isObject(source)) {
		                return;
		            }
	
		            for(var name in source) {
		                destination[name] = source[name];
		            }
		        },
		        /**
		         * Returns an array of the specified size and with each entry set to the given value.
		         * @param size
		         * @param value
		         * @returns {Array}
		         */
		        initArray: function createIdArray(size, value) {
		            var array = [];
		            for (var i = 0; i < size; ++i) {
		                array[i] = value;
		            }
		            return array;
		        },
		        serializePoints: function (points) {
		            var res = [];
		            for (var i = 0; i < points.length; i++) {
		                var p = points[i];
		                res.push(p.x + ";" + p.y);
		            }
		            return res.join(";");
		        },
		        deserializePoints: function (s) {
		            var v = s.split(";"), points = [];
		            if (v.length % 2 !== 0) {
		                throw "Not an array of points.";
		            }
		            for (var i = 0; i < v.length; i += 2) {
		                points.push(new diagram.Point(
		                    parseInt(v[i], 10),
		                    parseInt(v[i + 1], 10)
		                ));
		            }
		            return points;
		        },
		        /**
		         * Returns an integer within the given bounds.
		         * @param lower The inclusive lower bound.
		         * @param upper The exclusive upper bound.
		         * @returns {number}
		         */
		        randomInteger: function (lower, upper) {
		            return parseInt(Math.floor(Math.random() * upper) + lower, 10);
		        } ,
		        /*
		         Depth-first traversal of the given node.
		         */
		        DFT: function (el, func) {
		            func(el);
		            if (el.childNodes) {
		                for (var i = 0; i < el.childNodes.length; i++) {
		                    var item = el.childNodes[i];
		                    this.DFT(item, func);
		                }
		            }
		        },
		        /*
		         Returns the angle in degrees for the given matrix
		         */
		        getMatrixAngle: function (m) {
		            if (m === null || m.d === 0) {
		                return 0;
		            }
		            return Math.atan2(m.b, m.d) * 180 / Math.PI;
		        },
	
		        /*
		         Returns the scaling factors for the given matrix.
		         */
		        getMatrixScaling: function (m) {
		            var sX = Math.sqrt(m.a * m.a + m.c * m.c);
		            var sY = Math.sqrt(m.b * m.b + m.d * m.d);
		            return [sX, sY];
		        }
	
		    });
	
		    /**
		     * The Range defines an array of equally separated numbers.
		     * @param start The start-value of the Range.
		     * @param stop The end-value of the Range.
		     * @param step The separation between the values (default:1).
		     * @returns {Array}
		     */
		    function Range(start, stop, step) {
		        if (typeof start == 'undefined' || typeof stop == 'undefined') {
		            return [];
		        }
		        if (step && Utils.sign(stop - start) != Utils.sign(step)) {
		            throw "The sign of the increment should allow to reach the stop-value.";
		        }
		        step = step || 1;
		        start = start || 0;
		        stop = stop || start;
		        if ((stop - start) / step === Infinity) {
		            throw "Infinite range defined.";
		        }
		        var range = [], i = -1, j;
	
		        function rangeIntegerScale(x) {
		            var k = 1;
		            while (x * k % 1) {
		                k *= 10;
		            }
		            return k;
		        }
	
		        var k = rangeIntegerScale(Math.abs(step));
		        start *= k;
		        stop *= k;
		        step *= k;
		        if (start > stop && step > 0) {
		            step = -step;
		        }
		        if (step < 0) {
		            while ((j = start + step * ++i) >= stop) {
		                range.push(j / k);
		            }
		        }
		        else {
		            while ((j = start + step * ++i) <= stop) {
		                range.push(j / k);
		            }
		        }
		        return range;
		    }
	
		    /*-------------------Diverse math functions----------------------------*/
	
		    function findRadian(start, end) {
		        if (start == end) {
		            return 0;
		        }
		        var sngXComp = end.x - start.x,
		            sngYComp = start.y - end.y,
		            atan = Math.atan(sngXComp / sngYComp);
		        if (sngYComp >= 0) {
		            return sngXComp < 0 ? atan + (2 * Math.PI) : atan;
		        }
		        return atan + Math.PI;
		    }
	
		    Utils.sign = function(number) {
		        return number ? number < 0 ? -1 : 1 : 0;
		    };
	
		    Utils.findAngle = function(center, end) {
		        return findRadian(center, end) * 180 / Math.PI;
		    };
	
		    /*-------------------Array Helpers ----------------------------*/
	
		    Utils.forEach = function(arr, iterator, thisRef) {
		        for (var i = 0; i < arr.length; i++) {
		            iterator.call(thisRef, arr[i], i, arr);
		        }
		    };
	
		    Utils.any = function(arr, predicate) {
		        for (var i = 0; i < arr.length; ++i) {
		            if (predicate(arr[i])) {
		                return arr[i];
		            }
		        }
		        return null;
		    };
	
		    Utils.remove = function (arr, what) {
		        var ax;
		        while ((ax = Utils.indexOf(arr, what)) !== -1) {
		            arr.splice(ax, 1);
		        }
		        return arr;
		    };
	
		    Utils.contains = function (arr, obj) {
		        return Utils.indexOf(arr, obj) !== -1;
		    };
	
		    Utils.indexOf = function(arr, what) {
		        return $.inArray(what, arr);
		    };
	
		    Utils.fold = function (list, iterator, acc, context) {
		        var initial = arguments.length > 2;
	
		        for (var i = 0; i < list.length; i++) {
		            var value = list[i];
		            if (!initial) {
		                acc = value;
		                initial = true;
		            }
		            else {
		                acc = iterator.call(context, acc, value, i, list);
		            }
		        }
	
		        if (!initial) {
		            throw 'Reduce of empty array with no initial value';
		        }
	
		        return acc;
		    };
	
		    Utils.find = function (arr, iterator, context) {
		        var result;
		        Utils.any(arr, function (value, index, list) {
		            if (iterator.call(context, value, index, list)) {
		                result = value;
		                return true;
		            }
		            return false;
		        });
		        return result;
		    };
	
		    Utils.first = function (arr, constraint, context) {
		        if (arr.length === 0) {
		            return null;
		        }
		        if (Utils.isUndefined(constraint)) {
		            return arr[0];
		        }
	
		        return Utils.find(arr, constraint, context);
		    };
	
		    /**
		     * Inserts the given element at the specified position and returns the result.
		     */
		    Utils.insert = function (arr, element, position) {
		        arr.splice(position, 0, element);
		        return arr;
		    };
	
		    Utils.all = function (arr, iterator, context) {
		        var result = true;
		        var value;
	
		        for (var i = 0; i < arr.length; i++) {
		            value = arr[i];
		            result = result && iterator.call(context, value, i, arr);
	
		            if (!result) {
		                break;
		            }
		        }
	
		        return result;
		    };
	
		    Utils.clear = function (arr) {
		        arr.splice(0, arr.length);
		    };
	
		    /**
		     * Sort the arrays on the basis of the first one (considered as keys and the other array as values).
		     * @param a
		     * @param b
		     * @param sortfunc (optiona) sorting function for the values in the first array
		     */
		    Utils.bisort = function (a, b, sortfunc) {
		        if (Utils.isUndefined(a)) {
		            throw "First array is not specified.";
		        }
		        if (Utils.isUndefined(b)) {
		            throw "Second array is not specified.";
		        }
		        if (a.length != b.length) {
		            throw "The two arrays should have equal length";
		        }
	
		        var all = [], i;
	
		        for (i = 0; i < a.length; i++) {
		            all.push({ 'x': a[i], 'y': b[i] });
		        }
		        if (Utils.isUndefined(sortfunc)) {
		            all.sort(function (m, n) {
		                return m.x - n.x;
		            });
		        }
		        else {
		            all.sort(function (m, n) {
		                return sortfunc(m.x, n.x);
		            });
		        }
	
		        Utils.clear(a);
		        Utils.clear(b);
	
		        for (i = 0; i < all.length; i++) {
		            a.push(all[i].x);
		            b.push(all[i].y);
		        }
		    };
	
		    Utils.addRange = function (arr, range) {
		        arr.push.apply(arr, range);
		    };
	
		    var Easing = {
		        easeInOut: function (pos) {
		            return ((-Math.cos(pos * Math.PI) / 2) + 0.5);
		        }
		    };
	
		    /**
		     * An animation ticker driving an adapter which sets a particular
		     * property in function of the tick.
		     * @type {*}
		     */
		    var Ticker = kendo.Class.extend({
		        init: function () {
		            this.adapters = [];
		            this.target = 0;
		            this.tick = 0;
		            this.interval = 20;
		            this.duration = 800;
		            this.lastTime = null;
		            this.handlers = [];
		            var _this = this;
		            this.transition = Easing.easeInOut;
		            this.timerDelegate = function () {
		                _this.onTimerEvent();
		            };
		        },
		        addAdapter: function (a) {
		            this.adapters.push(a);
		        },
		        onComplete: function (handler) {
		            this.handlers.push(handler);
		        },
		        removeHandler: function (handler) {
		            this.handlers = $.grep(this.handlers, function (h) {
		                return h !== handler;
		            });
		        },
		        trigger: function () {
		            var _this = this;
		            if (this.handlers) {
		                Utils.forEach(this.handlers, function (h) {
		                    return h.call(_this.caller !== null ? _this.caller : _this);
		                });
		            }
		        },
		        onStep: function () {
		        },
		        seekTo: function (to) {
		            this.seekFromTo(this.tick, to);
		        },
		        seekFromTo: function (from, to) {
		            this.target = Math.max(0, Math.min(1, to));
		            this.tick = Math.max(0, Math.min(1, from));
		            this.lastTime = new Date().getTime();
		            if (!this.intervalId) {
		                this.intervalId = window.setInterval(this.timerDelegate, this.interval);
		            }
		        },
		        stop: function () {
		            if (this.intervalId) {
		                window.clearInterval(this.intervalId);
		                this.intervalId = null;
	
		                //this.trigger.call(this);
		                this.trigger();
		                // this.next();
		            }
		        },
		        play: function (origin) {
		            if (this.adapters.length === 0) {
		                return;
		            }
		            if (origin !== null) {
		                this.caller = origin;
		            }
		            this.initState();
		            this.seekFromTo(0, 1);
		        },
		        reverse: function () {
		            this.seekFromTo(1, 0);
		        },
		        initState: function () {
		            if (this.adapters.length === 0) {
		                return;
		            }
		            for (var i = 0; i < this.adapters.length; i++) {
		                this.adapters[i].initState();
		            }
		        },
		        propagate: function () {
		            var value = this.transition(this.tick);
	
		            for (var i = 0; i < this.adapters.length; i++) {
		                this.adapters[i].update(value);
		            }
		        },
		        onTimerEvent: function () {
		            var now = new Date().getTime();
		            var timePassed = now - this.lastTime;
		            this.lastTime = now;
		            var movement = (timePassed / this.duration) * (this.tick < this.target ? 1 : -1);
		            if (Math.abs(movement) >= Math.abs(this.tick - this.target)) {
		                this.tick = this.target;
		            } else {
		                this.tick += movement;
		            }
	
		            try {
		                this.propagate();
		            } finally {
		                this.onStep.call(this);
		                if (this.target == this.tick) {
		                    this.stop();
		                }
		            }
		        }
		    });
	
		    kendo.deepExtend(diagram, {
		        init: function (element) {
		            kendo.init(element, diagram.ui);
		        },
	
		        Utils: Utils,
		        Range: Range,
		        Ticker: Ticker
		    });
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(878);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 857:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 878:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(879), __webpack_require__(857) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var kendo = window.kendo,
		        diagram = kendo.dataviz.diagram,
		        Class = kendo.Class,
		        deepExtend = kendo.deepExtend,
		        dataviz = kendo.dataviz,
		        Utils = diagram.Utils,
		        Point = dataviz.Point2D,
		        isFunction = kendo.isFunction,
		        contains = Utils.contains,
		        map = $.map;
	
		    // Constants ==============================================================
		    var HITTESTAREA = 3,
		        EPSILON = 1e-06;
	
		    deepExtend(Point.fn, {
		        plus: function (p) {
		            return new Point(this.x + p.x, this.y + p.y);
		        },
		        minus: function (p) {
		            return new Point(this.x - p.x, this.y - p.y);
		        },
		        offset: function (value) {
		            return new Point(this.x - value, this.y - value);
		        },
		        times: function (s) {
		            return new Point(this.x * s, this.y * s);
		        },
		        normalize: function () {
		            if (this.length() === 0) {
		                return new Point();
		            }
		            return this.times(1 / this.length());
		        },
		        length: function () {
		            return Math.sqrt(this.x * this.x + this.y * this.y);
		        },
		        toString: function () {
		            return "(" + this.x + "," + this.y + ")";
		        },
		        lengthSquared: function () {
		            return (this.x * this.x + this.y * this.y);
		        },
		        middleOf: function MiddleOf(p, q) {
		            return new Point(q.x - p.x, q.y - p.y).times(0.5).plus(p);
		        },
		        toPolar: function (useDegrees) {
		            var factor = 1;
		            if (useDegrees) {
		                factor = 180 / Math.PI;
		            }
		            var a = Math.atan2(Math.abs(this.y), Math.abs(this.x));
		            var halfpi = Math.PI / 2;
		            var len = this.length();
		            if (this.x === 0) {
		                // note that the angle goes down and not the usual mathematical convention
	
		                if (this.y === 0) {
		                    return new Polar(0, 0);
		                }
		                if (this.y > 0) {
		                    return new Polar(len, factor * halfpi);
		                }
		                if (this.y < 0) {
		                    return new Polar(len, factor * 3 * halfpi);
		                }
		            }
		            else if (this.x > 0) {
		                if (this.y === 0) {
		                    return new Polar(len, 0);
		                }
		                if (this.y > 0) {
		                    return new Polar(len, factor * a);
		                }
		                if (this.y < 0) {
		                    return new Polar(len, factor * (4 * halfpi - a));
		                }
		            }
		            else {
		                if (this.y === 0) {
		                    return new Polar(len, 2 * halfpi);
		                }
		                if (this.y > 0) {
		                    return new Polar(len, factor * (2 * halfpi - a));
		                }
		                if (this.y < 0) {
		                    return new Polar(len, factor * (2 * halfpi + a));
		                }
		            }
		        },
		        isOnLine: function (from, to) {
		            if (from.x > to.x) { // from must be the leftmost point
		                var temp = to;
		                to = from;
		                from = temp;
		            }
		            var r1 = new Rect(from.x, from.y).inflate(HITTESTAREA, HITTESTAREA),
		                r2 = new Rect(to.x, to.y).inflate(HITTESTAREA, HITTESTAREA), o1, u1;
		            if (r1.union(r2).contains(this)) {
		                if (from.x === to.x || from.y === to.y) {
		                    return true;
		                }
		                else if (from.y < to.y) {
		                    o1 = r1.x + (((r2.x - r1.x) * (this.y - (r1.y + r1.height))) / ((r2.y + r2.height) - (r1.y + r1.height)));
		                    u1 = (r1.x + r1.width) + ((((r2.x + r2.width) - (r1.x + r1.width)) * (this.y - r1.y)) / (r2.y - r1.y));
		                }
		                else {
		                    o1 = r1.x + (((r2.x - r1.x) * (this.y - r1.y)) / (r2.y - r1.y));
		                    u1 = (r1.x + r1.width) + ((((r2.x + r2.width) - (r1.x + r1.width)) * (this.y - (r1.y + r1.height))) / ((r2.y + r2.height) - (r1.y + r1.height)));
		                }
		                return (this.x > o1 && this.x < u1);
		            }
		            return false;
		        }
		    });
	
		    deepExtend(Point, {
		        parse: function (str) {
		            var tempStr = str.slice(1, str.length - 1),
		                xy = tempStr.split(","),
		                x = parseInt(xy[0], 10),
		                y = parseInt(xy[1], 10);
		            if (!isNaN(x) && !isNaN(y)) {
		                return new Point(x, y);
		            }
		        }
		    });
	
		    /**
		     * Structure combining a Point with two additional points representing the handles or tangents attached to the first point.
		     * If the additional points are null or equal to the first point the path will be sharp.
		     * Left and right correspond to the direction of the underlying path.
		     */
		    var PathDefiner = Class.extend(
		        {
		            init: function (p, left, right) {
		                this.point = p;
		                this.left = left;
		                this.right = right;
		            }
		        }
		    );
	
		    /**
		     * Defines a rectangular region.
		     */
		    var Rect = Class.extend({
		        init: function (x, y, width, height) {
		            this.x = x || 0;
		            this.y = y || 0;
		            this.width = width || 0;
		            this.height = height || 0;
		        },
		        contains: function (point) {
		            return ((point.x >= this.x) && (point.x <= (this.x + this.width)) && (point.y >= this.y) && (point.y <= (this.y + this.height)));
		        },
		        inflate: function (dx, dy) {
		            if (dy === undefined) {
		                dy = dx;
		            }
	
		            this.x -= dx;
		            this.y -= dy;
		            this.width += 2 * dx + 1;
		            this.height += 2 * dy + 1;
		            return this;
		        },
		        offset: function (dx, dy) {
		            var x = dx, y = dy;
		            if (dx instanceof Point) {
		                x = dx.x;
		                y = dx.y;
		            }
		            this.x += x;
		            this.y += y;
		            return this;
		        },
		        union: function (r) {
		            var x1 = Math.min(this.x, r.x);
		            var y1 = Math.min(this.y, r.y);
		            var x2 = Math.max((this.x + this.width), (r.x + r.width));
		            var y2 = Math.max((this.y + this.height), (r.y + r.height));
		            return new Rect(x1, y1, x2 - x1, y2 - y1);
		        },
		        center: function () {
		            return new Point(this.x + this.width / 2, this.y + this.height / 2);
		        },
		        top: function () {
		            return new Point(this.x + this.width / 2, this.y);
		        },
		        right: function () {
		            return new Point(this.x + this.width, this.y + this.height / 2);
		        },
		        bottom: function () {
		            return new Point(this.x + this.width / 2, this.y + this.height);
		        },
		        left: function () {
		            return new Point(this.x, this.y + this.height / 2);
		        },
		        topLeft: function () {
		            return new Point(this.x, this.y);
		        },
		        topRight: function () {
		            return new Point(this.x + this.width, this.y);
		        },
		        bottomLeft: function () {
		            return new Point(this.x, this.y + this.height);
		        },
		        bottomRight: function () {
		            return new Point(this.x + this.width, this.y + this.height);
		        },
		        clone: function () {
		            return new Rect(this.x, this.y, this.width, this.height);
		        },
		        isEmpty: function () {
		            return !this.width && !this.height;
		        },
		        equals: function (rect) {
		            return this.x === rect.x && this.y === rect.y && this.width === rect.width && this.height === rect.height;
		        },
		        rotatedBounds: function (angle) {
		            var rect = this.clone(),
		                points = this.rotatedPoints(angle),
		                tl = points[0],
		                tr = points[1],
		                br = points[2],
		                bl = points[3];
	
		            rect.x = Math.min(br.x, tl.x, tr.x, bl.x);
		            rect.y = Math.min(br.y, tl.y, tr.y, bl.y);
		            rect.width = Math.max(br.x, tl.x, tr.x, bl.x) - rect.x;
		            rect.height = Math.max(br.y, tl.y, tr.y, bl.y) - rect.y;
	
		            return rect;
		        },
		        rotatedPoints: function (angle) {
		            var rect = this,
		                c = rect.center(),
		                br = rect.bottomRight().rotate(c, 360 - angle),
		                tl = rect.topLeft().rotate(c, 360 - angle),
		                tr = rect.topRight().rotate(c, 360 - angle),
		                bl = rect.bottomLeft().rotate(c, 360 - angle);
	
		            return [tl, tr, br, bl];
		        },
		        toString: function (delimiter) {
		            delimiter = delimiter || " ";
	
		            return this.x + delimiter + this.y + delimiter + this.width + delimiter + this.height;
		        },
		        scale: function (scaleX, scaleY, staicPoint, adornerCenter, angle) {
		            var tl = this.topLeft();
		            var thisCenter = this.center();
		            tl.rotate(thisCenter, 360 - angle).rotate(adornerCenter, angle);
	
		            var delta = staicPoint.minus(tl);
		            var scaled = new Point(delta.x * scaleX, delta.y * scaleY);
		            var position = delta.minus(scaled);
		            tl = tl.plus(position);
		            tl.rotate(adornerCenter, 360 - angle).rotate(thisCenter, angle);
	
		            this.x = tl.x;
		            this.y = tl.y;
	
		            this.width *= scaleX;
		            this.height *= scaleY;
		        },
	
		        zoom: function(zoom) {
		            this.x *= zoom;
		            this.y *= zoom;
		            this.width *= zoom;
		            this.height *= zoom;
		            return this;
		        },
	
		        overlaps: function(rect) {
		            var bottomRight = this.bottomRight();
		            var rectBottomRight = rect.bottomRight();
		            var overlaps = !(bottomRight.x < rect.x || bottomRight.y < rect.y ||
		                rectBottomRight.x < this.x || rectBottomRight.y < this.y);
		            return overlaps;
		        }
		    });
	
		    var Size = Class.extend({
		        init: function (width, height) {
		            this.width = width;
		            this.height = height;
		        }
		    });
	
		    Size.prototype.Empty = new Size(0, 0);
	
		    Rect.toRect = function (rect) {
		        if (!(rect instanceof Rect)) {
		            rect = new Rect(rect.x, rect.y, rect.width, rect.height);
		        }
	
		        return rect;
		    };
	
		    Rect.empty = function () {
		        return new Rect(0, 0, 0, 0);
		    };
	
		    Rect.fromPoints = function (p, q) {
		        if (isNaN(p.x) || isNaN(p.y) || isNaN(q.x) || isNaN(q.y)) {
		            throw "Some values are NaN.";
		        }
		        return new Rect(Math.min(p.x, q.x), Math.min(p.y, q.y), Math.abs(p.x - q.x), Math.abs(p.y - q.y));
		    };
	
		    function isNearZero(num) {
		        return Math.abs(num) < EPSILON;
		    }
	
		    function intersectLine(start1, end1, start2, end2, isSegment) {
		        var tangensdiff = ((end1.x - start1.x) * (end2.y - start2.y)) - ((end1.y - start1.y) * (end2.x - start2.x));
		        if (isNearZero(tangensdiff)) {
		            //parallel lines
		            return;
		        }
	
		        var num1 = ((start1.y - start2.y) * (end2.x - start2.x)) - ((start1.x - start2.x) * (end2.y - start2.y));
		        var num2 = ((start1.y - start2.y) * (end1.x - start1.x)) - ((start1.x - start2.x) * (end1.y - start1.y));
		        var r = num1 / tangensdiff;
		        var s = num2 / tangensdiff;
	
		        if (isSegment && (r < 0 || r > 1 || s < 0 || s > 1)) {
		            //r < 0 => line 1 is below line 2
		            //r > 1 => line 1 is above line 2
		            //s < 0 => line 2 is below line 1
		            //s > 1 => line 2 is above line 1
		            return;
		        }
	
		        return new Point(start1.x + (r * (end1.x - start1.x)), start1.y + (r * (end1.y - start1.y)));
		    }
	
		    var Intersect = {
		        lines: function (start1, end1, start2, end2) {
		            return intersectLine(start1, end1, start2, end2);
		        },
		        segments: function (start1, end1, start2, end2) {
		            return intersectLine(start1, end1, start2, end2, true);
		        },
		        rectWithLine: function (rect, start, end) {
		            return  Intersect.segments(start, end, rect.topLeft(), rect.topRight()) ||
		                Intersect.segments(start, end, rect.topRight(), rect.bottomRight()) ||
		                Intersect.segments(start, end, rect.bottomLeft(), rect.bottomRight()) ||
		                Intersect.segments(start, end, rect.topLeft(), rect.bottomLeft());
		        },
		        rects: function (rect1, rect2, angle) {
		            var tl = rect2.topLeft(),
		                tr = rect2.topRight(),
		                bl = rect2.bottomLeft(),
		                br = rect2.bottomRight();
		            var center = rect2.center();
		            if (angle) {
		                tl = tl.rotate(center, angle);
		                tr = tr.rotate(center, angle);
		                bl = bl.rotate(center, angle);
		                br = br.rotate(center, angle);
		            }
	
		            var intersect = rect1.contains(tl) ||
		                rect1.contains(tr) ||
		                rect1.contains(bl) ||
		                rect1.contains(br) ||
		                Intersect.rectWithLine(rect1, tl, tr) ||
		                Intersect.rectWithLine(rect1, tl, bl) ||
		                Intersect.rectWithLine(rect1, tr, br) ||
		                Intersect.rectWithLine(rect1, bl, br);
	
		            if (!intersect) {//last possible case is rect1 to be completely within rect2
		                tl = rect1.topLeft();
		                tr = rect1.topRight();
		                bl = rect1.bottomLeft();
		                br = rect1.bottomRight();
	
		                if (angle) {
		                    var reverseAngle = 360 - angle;
		                    tl = tl.rotate(center, reverseAngle);
		                    tr = tr.rotate(center, reverseAngle);
		                    bl = bl.rotate(center, reverseAngle);
		                    br = br.rotate(center, reverseAngle);
		                }
	
		                intersect = rect2.contains(tl) ||
		                    rect2.contains(tr) ||
		                    rect2.contains(bl) ||
		                    rect2.contains(br);
		            }
	
		            return intersect;
		        }
		    };
	
		    /**
		     * Aligns two rectangles, where one is the container and the other is content.
		     */
		    var RectAlign = Class.extend({
		        init: function (container) {
		            this.container = Rect.toRect(container);
		        },
	
		        align: function (content, alignment) {
		            var alignValues = alignment.toLowerCase().split(" ");
	
		            for (var i = 0; i < alignValues.length; i++) {
		                content = this._singleAlign(content, alignValues[i]);
		            }
	
		            return content;
		        },
		        _singleAlign: function (content, alignment) {
		            if (isFunction(this[alignment])) {
		                return this[alignment](content);
		            }
		            else {
		                return content;
		            }
		        },
	
		        left: function (content) {
		            return this._align(content, this._left);
		        },
		        center: function (content) {
		            return this._align(content, this._center);
		        },
		        right: function (content) {
		            return this._align(content, this._right);
		        },
		        stretch: function (content) {
		            return this._align(content, this._stretch);
		        },
		        top: function (content) {
		            return this._align(content, this._top);
		        },
		        middle: function (content) {
		            return this._align(content, this._middle);
		        },
		        bottom: function (content) {
		            return this._align(content, this._bottom);
		        },
	
		        _left: function (container, content) {
		            content.x = container.x;
		        },
		        _center: function (container, content) {
		            content.x = ((container.width - content.width) / 2) || 0;
		        },
		        _right: function (container, content) {
		            content.x = container.width - content.width;
		        },
		        _top: function (container, content) {
		            content.y = container.y;
		        },
		        _middle: function (container, content) {
		            content.y = ((container.height - content.height) / 2) || 0;
		        },
		        _bottom: function (container, content) {
		            content.y = container.height - content.height;
		        },
		        _stretch: function (container, content) {
		            content.x = 0;
		            content.y = 0;
		            content.height = container.height;
		            content.width = container.width;
		        },
		        _align: function (content, alignCalc) {
		            content = Rect.toRect(content);
		            alignCalc(this.container, content);
	
		            return content;
		        }
		    });
	
		    var Polar = Class.extend({
		        init: function (r, a) {
		            this.r = r;
		            this.angle = a;
		        }
		    });
	
		    /**
		     * SVG transformation matrix.
		     */
		    var Matrix = Class.extend({
		        init: function (a, b, c, d, e, f) {
		            this.a = a || 0;
		            this.b = b || 0;
		            this.c = c || 0;
		            this.d = d || 0;
		            this.e = e || 0;
		            this.f = f || 0;
		        },
		        plus: function (m) {
		            this.a += m.a;
		            this.b += m.b;
		            this.c += m.c;
		            this.d += m.d;
		            this.e += m.e;
		            this.f += m.f;
		        },
		        minus: function (m) {
		            this.a -= m.a;
		            this.b -= m.b;
		            this.c -= m.c;
		            this.d -= m.d;
		            this.e -= m.e;
		            this.f -= m.f;
		        },
		        times: function (m) {
		            return new Matrix(
		                this.a * m.a + this.c * m.b,
		                this.b * m.a + this.d * m.b,
		                this.a * m.c + this.c * m.d,
		                this.b * m.c + this.d * m.d,
		                this.a * m.e + this.c * m.f + this.e,
		                this.b * m.e + this.d * m.f + this.f
		            );
		        },
		        apply: function (p) {
		            return new Point(this.a * p.x + this.c * p.y + this.e, this.b * p.x + this.d * p.y + this.f);
		        },
		        applyRect: function (r) {
		            return Rect.fromPoints(this.apply(r.topLeft()), this.apply(r.bottomRight()));
		        },
		        toString: function () {
		            return "matrix(" + this.a + " " + this.b + " " + this.c + " " + this.d + " " + this.e + " " + this.f + ")";
		        }
		    });
	
		    deepExtend(Matrix, {
		        fromSVGMatrix: function (vm) {
		            var m = new Matrix();
		            m.a = vm.a;
		            m.b = vm.b;
		            m.c = vm.c;
		            m.d = vm.d;
		            m.e = vm.e;
		            m.f = vm.f;
		            return m;
		        },
		        fromMatrixVector: function (v) {
		            var m = new Matrix();
		            m.a = v.a;
		            m.b = v.b;
		            m.c = v.c;
		            m.d = v.d;
		            m.e = v.e;
		            m.f = v.f;
		            return m;
		        },
		        fromList: function (v) {
		            if (v.length !== 6) {
		                throw "The given list should consist of six elements.";
		            }
		            var m = new Matrix();
		            m.a = v[0];
		            m.b = v[1];
		            m.c = v[2];
		            m.d = v[3];
		            m.e = v[4];
		            m.f = v[5];
		            return m;
		        },
		        translation: function (x, y) {
		            var m = new Matrix();
		            m.a = 1;
		            m.b = 0;
		            m.c = 0;
		            m.d = 1;
		            m.e = x;
		            m.f = y;
		            return m;
		        },
		        unit: function () {
		            return new Matrix(1, 0, 0, 1, 0, 0);
		        },
		        rotation: function (angle, x, y) {
		            var m = new Matrix();
		            m.a = Math.cos(angle * Math.PI / 180);
		            m.b = Math.sin(angle * Math.PI / 180);
		            m.c = -m.b;
		            m.d = m.a;
		            m.e = (x - x * m.a + y * m.b) || 0;
		            m.f = (y - y * m.a - x * m.b) || 0;
		            return m;
		        },
		        scaling: function (scaleX, scaleY) {
		            var m = new Matrix();
		            m.a = scaleX;
		            m.b = 0;
		            m.c = 0;
		            m.d = scaleY;
		            m.e = 0;
		            m.f = 0;
		            return m;
		        },
		        parse: function (v) {
		            var parts, nums;
		            if (v) {
		                v = v.trim();
		                // of the form "matrix(...)"
		                if (v.slice(0, 6).toLowerCase() === "matrix") {
		                    nums = v.slice(7, v.length - 1).trim();
		                    parts = nums.split(",");
		                    if (parts.length === 6) {
		                        return Matrix.fromList(map(parts, function (p) {
		                            return parseFloat(p);
		                        }));
		                    }
		                    parts = nums.split(" ");
		                    if (parts.length === 6) {
		                        return Matrix.fromList(map(parts, function (p) {
		                            return parseFloat(p);
		                        }));
		                    }
		                }
		                // of the form "(...)"
		                if (v.slice(0, 1) === "(" && v.slice(v.length - 1) === ")") {
		                    v = v.substr(1, v.length - 1);
		                }
		                if (v.indexOf(",") > 0) {
		                    parts = v.split(",");
		                    if (parts.length === 6) {
		                        return Matrix.fromList(map(parts, function (p) {
		                            return parseFloat(p);
		                        }));
		                    }
		                }
		                if (v.indexOf(" ") > 0) {
		                    parts = v.split(" ");
		                    if (parts.length === 6) {
		                        return Matrix.fromList(map(parts, function (p) {
		                            return parseFloat(p);
		                        }));
		                    }
		                }
		            }
		            return parts;
		        }
		    });
	
		    /**
		     * SVG transformation represented as a vector.
		     */
		    var MatrixVector = Class.extend({
		        init: function (a, b, c, d, e, f) {
		            this.a = a || 0;
		            this.b = b || 0;
		            this.c = c || 0;
		            this.d = d || 0;
		            this.e = e || 0;
		            this.f = f || 0;
		        },
		        fromMatrix: function FromMatrix(m) {
		            var v = new MatrixVector();
		            v.a = m.a;
		            v.b = m.b;
		            v.c = m.c;
		            v.d = m.d;
		            v.e = m.e;
		            v.f = m.f;
		            return v;
		        }
		    });
	
		    /**
		     * Returns a value with Gaussian (normal) distribution.
		     * @param mean The mean value of the distribution.
		     * @param deviation The deviation (spreading at half-height) of the distribution.
		     * @returns {number}
		     */
		    function normalVariable(mean, deviation) {
		        var x, y, r;
		        do {
		            x = Math.random() * 2 - 1;
		            y = Math.random() * 2 - 1;
		            r = x * x + y * y;
		        }
		        while (!r || r > 1);
		        return mean + deviation * x * Math.sqrt(-2 * Math.log(r) / r);
		    }
	
		    /**
		     * Returns a random identifier which can be used as an ID of objects, eventually augmented with a prefix.
		     * @returns {string}
		     */
		    function randomId(length) {
		        if (Utils.isUndefined(length)) {
		            length = 10;
		        }
		        // old version return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
		        var result = '';
		        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
		        for (var i = length; i > 0; --i) {
		            result += chars.charAt(Math.round(Math.random() * (chars.length - 1)));
		        }
		        return result;
		    }
	
		    var Geometry = {
	
		        /**
		         * Returns the squared distance to the line defined by the two given Points.
		         * @param p An arbitrary Point.
		         * @param a An endpoint of the line or segment.
		         * @param b The complementary endpoint of the line or segment.
		         */
		        _distanceToLineSquared: function (p, a, b) {
		            function d2(pt1, pt2) {
		                return (pt1.x - pt2.x) * (pt1.x - pt2.x) + (pt1.y - pt2.y) * (pt1.y - pt2.y);
		            }
	
		            if (a === b) { // returns the distance of p to a
		                return d2(p, a);
		            }
	
		            var vx = b.x - a.x,
		                vy = b.y - a.y,
		                dot = (p.x - a.x) * vx + (p.y - a.y) * vy;
		            if (dot < 0) {
		                return d2(a, p); // sits on side of a
		            }
	
		            dot = (b.x - p.x) * vx + (b.y - p.y) * vy;
		            if (dot < 0) {
		                return d2(b, p); // sits on side of b
		            }
		            // regular case, use crossproduct to get the sine out
		            dot = (b.x - p.x) * vy - (b.y - p.y) * vx;
		            return dot * dot / (vx * vx + vy * vy);
		        },
	
		        /**
		         * Returns the distance to the line defined by the two given Points.
		         * @param p An arbitrary Point.
		         * @param a An endpoint of the line or segment.
		         * @param b The complementary endpoint of the line or segment.
		         */
		        distanceToLine: function (p, a, b) {
		            return Math.sqrt(this._distanceToLineSquared(p, a, b));
		        },
	
		        /**
		         * Returns the distance of the given points to the polyline defined by the points.
		         * @param p An arbitrary point.
		         * @param points The points defining the polyline.
		         * @returns {Number}
		         */
		        distanceToPolyline: function (p, points) {
		            var minimum = Number.MAX_VALUE;
		            if (Utils.isUndefined(points) || points.length === 0) {
		                return Number.MAX_VALUE;
		            }
		            for (var s = 0; s < points.length - 1; s++) {
		                var p1 = points[s];
		                var p2 = points[s + 1];
	
		                var d = this._distanceToLineSquared(p, p1, p2);
		                if (d < minimum) {
		                    minimum = d;
		                }
		            }
		            return Math.sqrt(minimum);
		        }
		    };
	
		    /*---------------The HashTable structure--------------------------------*/
	
		    /**
		     * Represents a collection of key-value pairs that are organized based on the hash code of the key.
		     * _buckets[hashId] = {key: key, value:...}
		     * Important: do not use the standard Array access method, use the get/set methods instead.
		     * See http://en.wikipedia.org/wiki/Hash_table
		     */
		    var HashTable = kendo.Class.extend({
		        init: function () {
		            this._buckets = [];
		            this.length = 0;
		        },
	
		        /**
		         * Adds the literal object with the given key (of the form {key: key,....}).
		         */
		        add: function (key, value) {
	
		            var obj = this._createGetBucket(key);
		            if (Utils.isDefined(value)) {
		                obj.value = value;
		            }
		            return obj;
		        },
	
		        /**
		         * Gets the literal object with the given key.
		         */
		        get: function (key) {
		            if (this._bucketExists(key)) {
		                return this._createGetBucket(key);
		            }
		            return null;
		        },
	
		        /**
		         * Set the key-value pair.
		         * @param key The key of the entry.
		         * @param value The value to set. If the key already exists the value will be overwritten.
		         */
		        set: function (key, value) {
		            this.add(key, value);
		        },
	
		        /**
		         * Determines whether the HashTable contains a specific key.
		         */
		        containsKey: function (key) {
		            return this._bucketExists(key);
		        },
	
		        /**
		         * Removes the element with the specified key from the hashtable.
		         * Returns the removed bucket.
		         */
		        remove: function (key) {
		            if (this._bucketExists(key)) {
		                var hashId = this._hash(key);
		                delete this._buckets[hashId];
		                this.length--;
		                return key;
		            }
		        },
	
		        /**
		         * Foreach with an iterator working on the key-value pairs.
		         * @param func
		         */
		        forEach: function (func) {
		            var hashes = this._hashes();
		            for (var i = 0, len = hashes.length; i < len; i++) {
		                var hash = hashes[i];
		                var bucket = this._buckets[hash];
		                if (Utils.isUndefined(bucket)) {
		                    continue;
		                }
		                func(bucket);
		            }
		        },
	
		        /**
		         * Returns a (shallow) clone of the current HashTable.
		         * @returns {HashTable}
		         */
		        clone: function () {
		            var ht = new HashTable();
		            var hashes = this._hashes();
		            for (var i = 0, len = hashes.length; i < len; i++) {
		                var hash = hashes[i];
		                var bucket = this._buckets[hash];
		                if (Utils.isUndefined(bucket)) {
		                    continue;
		                }
		                ht.add(bucket.key, bucket.value);
		            }
		            return ht;
		        },
	
		        /**
		         * Returns the hashes of the buckets.
		         * @returns {Array}
		         * @private
		         */
		        _hashes: function () {
		            var hashes = [];
		            for (var hash in this._buckets) {
		                if (this._buckets.hasOwnProperty(hash)) {
		                    hashes.push(hash);
		                }
		            }
		            return hashes;
		        },
	
		        _bucketExists: function (key) {
		            var hashId = this._hash(key);
		            return Utils.isDefined(this._buckets[hashId]);
		        },
	
		        /**
		         * Returns-adds the createGetBucket with the given key. If not present it will
		         * be created and returned.
		         * A createGetBucket is a literal object of the form {key: key, ...}.
		         */
		        _createGetBucket: function (key) {
		            var hashId = this._hash(key);
		            var bucket = this._buckets[hashId];
		            if (Utils.isUndefined(bucket)) {
		                bucket = { key: key };
		                this._buckets[hashId] = bucket;
		                this.length++;
		            }
		            return bucket;
		        },
	
		        /**
		         * Hashing of the given key.
		         */
		        _hash: function (key) {
		            if (Utils.isNumber(key)) {
		                return key;
		            }
		            if (Utils.isString(key)) {
		                return this._hashString(key);
		            }
		            if (Utils.isObject(key)) {
		                return this._objectHashId(key);
		            }
		            throw "Unsupported key type.";
		        },
	
		        /**
		         * Hashing of a string.
		         */
		        _hashString: function (s) {
		            // see for example http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
		            var result = 0;
		            if (s.length === 0) {
		                return result;
		            }
		            for (var i = 0; i < s.length; i++) {
		                var ch = s.charCodeAt(i);
		                result = ((result * 32) - result) + ch;
		            }
		            return result;
		        },
	
		        /**
		         * Returns the unique identifier for an object. This is automatically assigned and add on the object.
		         */
		        _objectHashId: function (key) {
		            var id = key._hashId;
		            if (Utils.isUndefined(id)) {
		                id = randomId();
		                key._hashId = id;
		            }
		            return id;
		        }
		    });
	
		    /*---------------The Dictionary structure--------------------------------*/
	
		    /**
		     * Represents a collection of key-value pairs.
		     * Important: do not use the standard Array access method, use the get/Set methods instead.
		     */
		    var Dictionary = kendo.Observable.extend({
		        /**
		         * Initializes a new instance of the Dictionary class.
		         * @param dictionary Loads the content of the given dictionary into this new one.
		         */
		        init: function (dictionary) {
		            var that = this;
		            kendo.Observable.fn.init.call(that);
		            this._hashTable = new HashTable();
		            this.length = 0;
		            if (Utils.isDefined(dictionary)) {
		                if ($.isArray(dictionary)) {
		                    for (var i = 0; i < dictionary.length; i++) {
		                        this.add(dictionary[i]);
		                    }
		                } else {
		                    dictionary.forEach(function (k, v) {
		                        this.add(k, v);
		                    }, this);
		                }
		            }
		        },
	
		        /**
		         * Adds a key-value to the dictionary.
		         * If the key already exists this will assign the given value to the existing entry.
		         */
		        add: function (key, value) {
		            var entry = this._hashTable.get(key);
		            if (!entry) {
		                entry = this._hashTable.add(key);
		                this.length++;
		                this.trigger('changed');
		            }
		            entry.value = value;
		        },
	
		        /**
		         * Set the key-value pair.
		         * @param key The key of the entry.
		         * @param value The value to set. If the key already exists the value will be overwritten.
		         */
		        set: function (key, value) {
		            this.add(key, value);
		        },
	
		        /**
		         * Gets the value associated with the given key in the dictionary.
		         */
		        get: function (key) {
		            var entry = this._hashTable.get(key);
		            if (entry) {
		                return entry.value;
		            }
		            throw new Error("Cannot find key " + key);
		        },
	
		        /**
		         * Returns whether the dictionary contains the given key.
		         */
		        containsKey: function (key) {
		            return this._hashTable.containsKey(key);
		        },
	
		        /**
		         * Removes the element with the specified key from the dictionary.
		         */
		        remove: function (key) {
		            if (this.containsKey(key)) {
		                this.trigger("changed");
		                this.length--;
		                return this._hashTable.remove(key);
		            }
		        },
	
		        /**
		         * The functional gets the key and value as parameters.
		         */
		        forEach: function (func, thisRef) {
		            this._hashTable.forEach(function (entry) {
		                func.call(thisRef, entry.key, entry.value);
		            });
		        },
	
		        /**
		         * Same as forEach except that only the value is passed to the functional.
		         */
		        forEachValue: function (func, thisRef) {
		            this._hashTable.forEach(function (entry) {
		                func.call(thisRef, entry.value);
		            });
		        },
	
		        /**
		         * Calls a defined callback function for each key in the dictionary.
		         */
		        forEachKey: function (func, thisRef) {
		            this._hashTable.forEach(function (entry) {
		                func.call(thisRef, entry.key);
		            });
		        },
	
		        /**
		         * Gets an array with all keys in the dictionary.
		         */
		        keys: function () {
		            var keys = [];
		            this.forEachKey(function (key) {
		                keys.push(key);
		            });
		            return keys;
		        }
		    });
	
		    /*---------------Queue structure--------------------------------*/
	
		    var Queue = kendo.Class.extend({
	
		        init: function () {
		            this._tail = null;
		            this._head = null;
		            this.length = 0;
		        },
	
		        /**
		         * Enqueues an object to the end of the queue.
		         */
		        enqueue: function (value) {
		            var entry = { value: value, next: null };
		            if (!this._head) {
		                this._head = entry;
		                this._tail = this._head;
		            }
		            else {
		                this._tail.next = entry;
		                this._tail = this._tail.next;
		            }
		            this.length++;
		        },
	
		        /**
		         * Removes and returns the object at top of the queue.
		         */
		        dequeue: function () {
		            if (this.length < 1) {
		                throw new Error("The queue is empty.");
		            }
		            var value = this._head.value;
		            this._head = this._head.next;
		            this.length--;
		            return value;
		        },
	
		        contains: function (item) {
		            var current = this._head;
		            while (current) {
		                if (current.value === item) {
		                    return true;
		                }
		                current = current.next;
		            }
		            return false;
		        }
		    });
	
	
		    /**
		     * While other data structures can have multiple times the same item a Set owns only
		     * once a particular item.
		     * @type {*}
		     */
		    var Set = kendo.Observable.extend({
		        init: function (resource) {
		            var that = this;
		            kendo.Observable.fn.init.call(that);
		            this._hashTable = new HashTable();
		            this.length = 0;
		            if (Utils.isDefined(resource)) {
		                if (resource instanceof HashTable) {
		                    resource.forEach(function (d) {
		                        this.add(d);
		                    });
		                }
		                else if (resource instanceof Dictionary) {
		                    resource.forEach(function (k, v) {
		                        this.add({key: k, value: v});
		                    }, this);
		                }
		            }
		        },
	
		        contains: function (item) {
		            return this._hashTable.containsKey(item);
		        },
	
		        add: function (item) {
		            var entry = this._hashTable.get(item);
		            if (!entry) {
		                this._hashTable.add(item, item);
		                this.length++;
		                this.trigger('changed');
		            }
		        },
	
		        get: function (item) {
		            if (this.contains(item)) {
		                return this._hashTable.get(item).value;
		            }
		            else {
		                return null;
		            }
		        },
	
		        /**
		         * Returns the hash of the item.
		         * @param item
		         * @returns {*}
		         */
		        hash: function (item) {
		            return this._hashTable._hash(item);
		        },
	
		        /**
		         * Removes the given item from the set. No exception is thrown if the item is not in the Set.
		         * @param item
		         */
		        remove: function (item) {
		            if (this.contains(item)) {
		                this._hashTable.remove(item);
		                this.length--;
		                this.trigger('changed');
		            }
		        },
		        /**
		         * Foreach with an iterator working on the key-value pairs.
		         * @param func
		         */
		        forEach: function (func, context) {
		            this._hashTable.forEach(function (kv) {
		                func(kv.value);
		            }, context);
		        },
		        toArray: function () {
		            var r = [];
		            this.forEach(function (d) {
		                r.push(d);
		            });
		            return r;
		        }
		    });
	
		    /*----------------Node-------------------------------*/
	
		    /**
		     * Defines the node (vertex) of a Graph.
		     */
		    var Node = kendo.Class.extend({
	
		        init: function (id, shape) {
	
		            /**
		             * Holds all the links incident with the current node.
		             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
		             */
		            this.links = [];
	
		            /**
		             * Holds the links from the current one to another Node .
		             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
		             */
		            this.outgoing = [];
	
		            /**
		             * Holds the links from another Node to the current one.
		             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
		             */
		            this.incoming = [];
	
		            /**
		             * Holds the weight of this Node.
		             */
		            this.weight = 1;
	
		            if (Utils.isDefined(id)) {
		                this.id = id;
		            }
		            else {
		                this.id = randomId();
		            }
		            if (Utils.isDefined(shape)) {
		                this.associatedShape = shape;
		                // transfer the shape's bounds to the runtime props
		                var b = shape.bounds();
		                this.width = b.width;
		                this.height = b.height;
		                this.x = b.x;
		                this.y = b.y;
		            }
		            else {
		                this.associatedShape = null;
		            }
		            /**
		             * The payload of the node.
		             * @type {null}
		             */
		            this.data = null;
		            this.type = "Node";
		            this.shortForm = "Node '" + this.id + "'";
		            /**
		             * Whether this is an injected node during the analysis or layout process.
		             * @type {boolean}
		             */
		            this.isVirtual = false;
		        },
	
		        /**
		         * Returns whether this node has no links attached.
		         */
		        isIsolated: function () {
		            return Utils.isEmpty(this.links);
		        },
	
		        /**
		         * Gets or sets the bounding rectangle of this node.
		         * This should be considered as runtime data, the property is not hotlinked to a SVG item.
		         */
		        bounds: function (r) {
		            if (!Utils.isDefined(r)) {
		                return new diagram.Rect(this.x, this.y, this.width, this.height);
		            }
	
		            this.x = r.x;
		            this.y = r.y;
		            this.width = r.width;
		            this.height = r.height;
		        },
	
		        /**
		         * Returns whether there is at least one link with the given (complementary) node. This can be either an
		         * incoming or outgoing link.
		         */
		        isLinkedTo: function (node) {
		            var that = this;
		            return Utils.any(that.links, function (link) {
		                return link.getComplement(that) === node;
		            });
		        },
	
		        /**
		         * Gets the children of this node, defined as the adjacent nodes with a link from this node to the adjacent one.
		         * @returns {Array}
		         */
		        getChildren: function () {
		            if (this.outgoing.length === 0) {
		                return [];
		            }
		            var children = [];
		            for (var i = 0, len = this.outgoing.length; i < len; i++) {
		                var link = this.outgoing[i];
		                children.push(link.getComplement(this));
		            }
		            return children;
		        },
	
		        /**
		         * Gets the parents of this node, defined as the adjacent nodes with a link from the adjacent node to this one.
		         * @returns {Array}
		         */
		        getParents: function () {
		            if (this.incoming.length === 0) {
		                return [];
		            }
		            var parents = [];
		            for (var i = 0, len = this.incoming.length; i < len; i++) {
		                var link = this.incoming[i];
		                parents.push(link.getComplement(this));
		            }
		            return parents;
		        },
	
		        /**
		         * Returns a clone of the Node. Note that the identifier is not cloned since it's a different Node instance.
		         * @returns {Node}
		         */
		        clone: function () {
		            var copy = new Node();
		            if (Utils.isDefined(this.weight)) {
		                copy.weight = this.weight;
		            }
		            if (Utils.isDefined(this.balance)) {
		                copy.balance = this.balance;
		            }
		            if (Utils.isDefined(this.owner)) {
		                copy.owner = this.owner;
		            }
		            copy.associatedShape = this.associatedShape;
		            copy.x = this.x;
		            copy.y = this.y;
		            copy.width = this.width;
		            copy.height = this.height;
		            return copy;
		        },
	
		        /**
		         * Returns whether there is a link from the current node to the given node.
		         */
		        adjacentTo: function (node) {
		            return this.isLinkedTo(node) !== null;
		        },
	
		        /**
		         * Removes the given link from the link collection this node owns.
		         * @param link
		         */
		        removeLink: function (link) {
		            if (link.source === this) {
		                Utils.remove(this.links, link);
		                Utils.remove(this.outgoing, link);
		                link.source = null;
		            }
	
		            if (link.target === this) {
		                Utils.remove(this.links, link);
		                Utils.remove(this.incoming, link);
		                link.target = null;
		            }
		        },
	
		        /**
		         * Returns whether there is a (outgoing) link from the current node to the given one.
		         */
		        hasLinkTo: function (node) {
		            return Utils.any(this.outgoing, function (link) {
		                return link.target === node;
		            });
		        },
	
		        /**
		         * Returns the degree of this node, i.e. the sum of incoming and outgoing links.
		         */
		        degree: function () {
		            return this.links.length;
		        },
	
		        /**
		         * Returns whether this node is either the source or the target of the given link.
		         */
		        incidentWith: function (link) {
		            return contains(this.links, link);
		        },
	
		        /**
		         * Returns the links between this node and the given one.
		         */
		        getLinksWith: function (node) {
		            return Utils.all(this.links, function (link) {
		                return link.getComplement(this) === node;
		            }, this);
		        },
	
		        /**
		         * Returns the nodes (either parent or child) which are linked to the current one.
		         */
		        getNeighbors: function () {
		            var neighbors = [];
		            Utils.forEach(this.incoming, function (e) {
		                neighbors.push(e.getComplement(this));
		            }, this);
		            Utils.forEach(this.outgoing, function (e) {
		                neighbors.push(e.getComplement(this));
		            }, this);
		            return neighbors;
		        }
		    });
	
		    /**
		     * Defines a directed link (edge, connection) of a Graph.
		     */
		    var Link = kendo.Class.extend({
	
		        init: function (source, target, id, connection) {
		            if (Utils.isUndefined(source)) {
		                throw "The source of the new link is not set.";
		            }
		            if (Utils.isUndefined(target)) {
		                throw "The target of the new link is not set.";
		            }
		            var sourceFound, targetFound;
		            if (Utils.isString(source)) {
		                sourceFound = new Node(source);
		            }
		            else {
		                sourceFound = source;
		            }
		            if (Utils.isString(target)) {
		                targetFound = new Node(target);
		            }
		            else {
		                targetFound = target;
		            }
	
		            this.source = sourceFound;
		            this.target = targetFound;
		            this.source.links.push(this);
		            this.target.links.push(this);
		            this.source.outgoing.push(this);
		            this.target.incoming.push(this);
		            if (Utils.isDefined(id)) {
		                this.id = id;
		            }
		            else {
		                this.id = randomId();
		            }
		            if (Utils.isDefined(connection)) {
		                this.associatedConnection = connection;
		            }
		            else {
		                this.associatedConnection = null;
		            }
		            this.type = "Link";
		            this.shortForm = "Link '" + this.source.id + "->" + this.target.id + "'";
		        },
	
		        /**
		         * Returns the complementary node of the given one, if any.
		         */
		        getComplement: function (node) {
		            if (this.source !== node && this.target !== node) {
		                throw "The given node is not incident with this link.";
		            }
		            return this.source === node ? this.target : this.source;
		        },
	
		        /**
		         * Returns the overlap of the current link with the given one, if any.
		         */
		        getCommonNode: function (link) {
		            if (this.source === link.source || this.source === link.target) {
		                return this.source;
		            }
		            if (this.target === link.source || this.target === link.target) {
		                return this.target;
		            }
		            return null;
		        },
	
		        /**
		         * Returns whether the current link is bridging the given nodes.
		         */
		        isBridging: function (v1, v2) {
		            return this.source === v1 && this.target === v2 || this.source === v2 && this.target === v1;
		        },
	
		        /**
		         * Returns the source and target of this link as a tuple.
		         */
		        getNodes: function () {
		            return [this.source, this.target];
		        },
	
		        /**
		         * Returns whether the given node is either the source or the target of the current link.
		         */
		        incidentWith: function (node) {
		            return this.source === node || this.target === node;
		        },
	
		        /**
		         * Returns whether the given link is a continuation of the current one. This can be both
		         * via an incoming or outgoing link.
		         */
		        adjacentTo: function (link) {
		            return contains(this.source.links, link) || contains(this.target.links, link);
		        },
	
		        /**
		         * Changes the source-node of this link.
		         */
		        changeSource: function (node) {
		            Utils.remove(this.source.links, this);
		            Utils.remove(this.source.outgoing, this);
	
		            node.links.push(this);
		            node.outgoing.push(this);
	
		            this.source = node;
		        },
	
		        /**
		         * Changes the target-node of this link.
		         * @param node
		         */
		        changeTarget: function (node) {
		            Utils.remove(this.target.links, this);
		            Utils.remove(this.target.incoming, this);
	
		            node.links.push(this);
		            node.incoming.push(this);
	
		            this.target = node;
		        },
	
		        /**
		         * Changes both the source and the target nodes of this link.
		         */
		        changesNodes: function (v, w) {
		            if (this.source === v) {
		                this.changeSource(w);
		            }
		            else if (this.target === v) {
		                this.changeTarget(w);
		            }
		        },
	
		        /**
		         * Reverses the direction of this link.
		         */
		        reverse: function () {
		            var oldSource = this.source;
		            var oldTarget = this.target;
	
		            this.source = oldTarget;
		            Utils.remove(oldSource.outgoing, this);
		            this.source.outgoing.push(this);
	
		            this.target = oldSource;
		            Utils.remove(oldTarget.incoming, this);
		            this.target.incoming.push(this);
		            return this;
		        },
	
		        /**
		         * Ensures that the given target defines the endpoint of this link.
		         */
		        directTo: function (target) {
		            if (this.source !== target && this.target !== target) {
		                throw "The given node is not incident with this link.";
		            }
		            if (this.target !== target) {
		                this.reverse();
		            }
		        },
	
		        /**
		         * Returns a reversed clone of this link.
		         */
		        createReverseEdge: function () {
		            var r = this.clone();
		            r.reverse();
		            r.reversed = true;
		            return r;
		        },
	
		        /**
		         * Returns a clone of this link.
		         */
		        clone: function () {
		            var clone = new Link(this.source, this.target);
		            return clone;
		        }
		    });
	
		    /*--------------Graph structure---------------------------------*/
		    /**
		     * Defines a directed graph structure.
		     * Note that the incidence structure resides in the nodes through the incoming and outgoing links collection, rahter than
		     * inside the Graph.
		     */
		    var Graph = kendo.Class.extend({
		        init: function (idOrDiagram) {
		            /**
		             * The links or edge collection of this Graph.
		             * @type {Array}
		             */
		            this.links = [];
		            /**
		             * The node or vertex collection of this Graph.
		             * @type {Array}
		             */
		            this.nodes = [];
	
		            this._nodeMap = new Dictionary();
		            /**
		             * The optional reference to the Diagram on which this Graph is based.
		             * @type {null}
		             */
		            this.diagram = null;
	
		            /**
		             * The root of this Graph. If not set explicitly the first Node with zero incoming links will be taken.
		             * @type {null}
		             * @private
		             */
		            this._root = null;
		            if (Utils.isDefined(idOrDiagram)) {
		                if (Utils.isString(idOrDiagram)) {
		                    this.id = idOrDiagram;
		                }
		                else {
		                    this.diagram = idOrDiagram;
		                    this.id = idOrDiagram.id;
		                }
		            }
		            else {
		                this.id = randomId();
		            }
	
		            /**
		             * The bounds of this graph if the nodes have spatial extension defined.
		             * @type {Rect}
		             */
		            this.bounds = new Rect();
		            // keeps track whether the children & parents have been created
		            this._hasCachedRelationships = false;
		            this.type = "Graph";
		        },
		        /**
		         * Caches the relational information of parents and children in the 'parents' and 'children'
		         * properties.
		         * @param forceRebuild If set to true the relational info will be rebuild even if already present.
		         */
		        cacheRelationships: function (forceRebuild) {
		            if (Utils.isUndefined(forceRebuild)) {
		                forceRebuild = false;
		            }
		            if (this._hasCachedRelationships && !forceRebuild) {
		                return;
		            }
		            for (var i = 0, len = this.nodes.length; i < len; i++) {
		                var node = this.nodes[i];
		                node.children = this.getChildren(node);
		                node.parents = this.getParents(node);
		            }
		            this._hasCachedRelationships = true;
		        },
	
		        /**
		         * Assigns tree-levels to the nodes assuming this is a tree graph.
		         * If not connected or not a tree the process will succeed but
		         * will have little meaning.
		         * @param startNode The node from where the level numbering starts, usually the root of the tree.
		         * @param visited The collection of visited nodes.
		         * @param offset The offset or starting counter of the level info.
		         */
		        assignLevels: function (startNode, offset, visited) {
		            if (!startNode) {
		                throw "Start node not specified.";
		            }
		            if (Utils.isUndefined(offset)) {
		                offset = 0;
		            }
		            // if not done before, cache the parents and children
		            this.cacheRelationships();
		            if (Utils.isUndefined(visited)) {
		                visited = new Dictionary();
		                Utils.forEach(this.nodes, function (n) {
		                    visited.add(n, false);
		                });
		            }
		            visited.set(startNode, true);
		            startNode.level = offset;
		            var children = startNode.children;
		            for (var i = 0, len = children.length; i < len; i++) {
		                var child = children[i];
		                if (!child || visited.get(child)) {
		                    continue;
		                }
		                this.assignLevels(child, offset + 1, visited);
		            }
		        },
	
		        /**
		         * Gets or set the root of this graph.
		         * If not set explicitly the first Node with zero incoming links will be taken.
		         * @param value
		         * @returns {*}
		         */
		        root: function (value) {
		            if (Utils.isUndefined(value)) {
		                if (!this._root) {
		                    // TODO: better to use the longest path for the most probable root?
		                    var found = Utils.first(this.nodes, function (n) {
		                        return n.incoming.length === 0;
		                    });
		                    if (found) {
		                        return found;
		                    }
		                    return Utils.first(this.nodes);
		                }
		                else {
		                    return this._root;
		                }
		            }
		            else {
		                this._root = value;
		            }
		        },
	
		        /**
		         * Returns the connected components of this graph.
		         * Note that the returned graphs are made up of the nodes and links of this graph, i.e. a pointer to the items of this graph.
		         * If you alter the items of the components you'll alter the original graph and vice versa.
		         * @returns {Array}
		         */
		        getConnectedComponents: function () {
		            this.componentIndex = 0;
		            this.setItemIndices();
		            var componentId = Utils.initArray(this.nodes.length, -1);
	
		            for (var v = 0; v < this.nodes.length; v++) {
		                if (componentId[v] === -1) {
		                    this._collectConnectedNodes(componentId, v);
		                    this.componentIndex++;
		                }
		            }
	
		            var components = [], i;
		            for (i = 0; i < this.componentIndex; ++i) {
		                components[i] = new Graph();
		            }
		            for (i = 0; i < componentId.length; ++i) {
		                var graph = components[componentId[i]];
		                graph.addNodeAndOutgoings(this.nodes[i]);
		            }
		            // sorting the components in decreasing order of node count
		            components.sort(function (a, b) {
		                return b.nodes.length - a.nodes.length;
		            });
		            return components;
		        },
	
		        _collectConnectedNodes: function (setIds, nodeIndex) {
		            setIds[nodeIndex] = this.componentIndex; // part of the current component
		            var node = this.nodes[nodeIndex];
		            Utils.forEach(node.links,
		                function (link) {
		                    var next = link.getComplement(node);
		                    var nextId = next.index;
		                    if (setIds[nextId] === -1) {
		                        this._collectConnectedNodes(setIds, nextId);
		                    }
		                }, this);
		        },
	
		        /**
		         * Calculates the bounds of this Graph if the Nodes have spatial dimensions defined.
		         * @returns {Rect}
		         */
		        calcBounds: function () {
		            if (this.isEmpty()) {
		                this.bounds = new Rect();
		                return this.bounds;
		            }
		            var b = null;
		            for (var i = 0, len = this.nodes.length; i < len; i++) {
		                var node = this.nodes[i];
		                if (!b) {
		                    b = node.bounds();
		                }
		                else {
		                    b = b.union(node.bounds());
		                }
		            }
		            this.bounds = b;
		            return this.bounds;
		        },
	
		        /**
		         * Creates a spanning tree for the current graph.
		         * Important: this will not return a spanning forest if the graph is disconnected.
		         * Prim's algorithm  finds a minimum-cost spanning tree of an edge-weighted, connected, undirected graph;
		         * see http://en.wikipedia.org/wiki/Prim%27s_algorithm .
		         * @param root The root of the spanning tree.
		         * @returns {Graph}
		         */
		        getSpanningTree: function (root) {
		            var tree = new Graph();
		            var map = new Dictionary(), source, target;
		            tree.root = root.clone();
		            tree.root.level = 0;
		            tree.root.id = root.id;
		            map.add(root, tree.root);
		            root.level = 0;
	
		            var visited = [];
		            var remaining = [];
		            tree._addNode(tree.root);
		            visited.push(root);
		            remaining.push(root);
	
		            var levelCount = 1;
		            while (remaining.length > 0) {
		                var next = remaining.pop();
		                for (var ni = 0; ni < next.links.length; ni++) {
		                    var link = next.links[ni];
		                    var cn = link.getComplement(next);
		                    if (contains(visited, cn)) {
		                        continue;
		                    }
	
		                    cn.level = next.level + 1;
		                    if (levelCount < cn.level + 1) {
		                        levelCount = cn.level + 1;
		                    }
		                    if (!contains(remaining, cn)) {
		                        remaining.push(cn);
		                    }
		                    if (!contains(visited, cn)) {
		                        visited.push(cn);
		                    }
		                    if (map.containsKey(next)) {
		                        source = map.get(next);
		                    }
		                    else {
		                        source = next.clone();
		                        source.level = next.level;
		                        source.id = next.id;
		                        map.add(next, source);
		                    }
		                    if (map.containsKey(cn)) {
		                        target = map.get(cn);
		                    }
		                    else {
		                        target = cn.clone();
		                        target.level = cn.level;
		                        target.id = cn.id;
		                        map.add(cn, target);
		                    }
		                    var newLink = new Link(source, target);
		                    tree.addLink(newLink);
		                }
	
		            }
	
		            var treeLevels = [];
		            for (var i = 0; i < levelCount; i++) {
		                treeLevels.push([]);
		            }
	
		            Utils.forEach(tree.nodes, function (node) {
		                treeLevels[node.level].push(node);
		            });
	
		            tree.treeLevels = treeLevels;
		            tree.cacheRelationships();
		            return tree;
		        },
	
		        /**
		         * Returns a random node in this graph.
		         * @param excludedNodes The collection of nodes which should not be considered.
		         * @param incidenceLessThan The maximum degree or incidence the random node should have.
		         * @returns {*}
		         */
		        takeRandomNode: function (excludedNodes, incidenceLessThan) {
		            if (Utils.isUndefined(excludedNodes)) {
		                excludedNodes = [];
		            }
		            if (Utils.isUndefined(incidenceLessThan)) {
		                incidenceLessThan = 4;
		            }
		            if (this.nodes.length === 0) {
		                return null;
		            }
		            if (this.nodes.length === 1) {
		                return contains(excludedNodes, this.nodes[0]) ? null : this.nodes[0];
		            }
		            var pool = $.grep(this.nodes, function (node) {
		                return !contains(excludedNodes, node) && node.degree() <= incidenceLessThan;
		            });
		            if (Utils.isEmpty(pool)) {
		                return null;
		            }
		            return pool[Utils.randomInteger(0, pool.length)];
		        },
	
		        /**
		         * Returns whether this is an empty graph.
		         */
		        isEmpty: function () {
		            return Utils.isEmpty(this.nodes);
		        },
	
		        /**
		         * Checks whether the endpoints of the links are all in the nodes collection.
		         */
		        isHealthy: function () {
		            return Utils.all(this.links, function (link) {
		                return contains(this.nodes, link.source) && contains(this.nodes, link.target);
		            }, this);
		        },
	
		        /**
		         * Gets the parents of this node, defined as the adjacent nodes with a link from the adjacent node to this one.
		         * @returns {Array}
		         */
		        getParents: function (n) {
		            if (!this.hasNode(n)) {
		                throw "The given node is not part of this graph.";
		            }
		            return n.getParents();
		        },
	
		        /**
		         * Gets the children of this node, defined as the adjacent nodes with a link from this node to the adjacent one.
		         * @returns {Array}
		         */
		        getChildren: function (n) {
		            if (!this.hasNode(n)) {
		                throw "The given node is not part of this graph.";
		            }
		            return n.getChildren();
		        },
	
		        /**
		         * Adds a new link to the graph between the given nodes.
		         */
		        addLink: function (sourceOrLink, target, owner) {
	
		            if (Utils.isUndefined(sourceOrLink)) {
		                throw "The source of the link is not defined.";
		            }
		            if (Utils.isUndefined(target)) {
		                // can only be undefined if the first one is a Link
		                if (Utils.isDefined(sourceOrLink.type) && sourceOrLink.type === "Link") {
		                    this.addExistingLink(sourceOrLink);
		                    return;
		                }
		                else {
		                    throw "The target of the link is not defined.";
		                }
		            }
	
		            var foundSource = this.getNode(sourceOrLink);
		            if (Utils.isUndefined(foundSource)) {
		                foundSource = this.addNode(sourceOrLink);
		            }
		            var foundTarget = this.getNode(target);
		            if (Utils.isUndefined(foundTarget)) {
		                foundTarget = this.addNode(target);
		            }
	
		            var newLink = new Link(foundSource, foundTarget);
	
		            if (Utils.isDefined(owner)) {
		                newLink.owner = owner;
		            }
	
		            /*newLink.source.outgoing.push(newLink);
		             newLink.source.links.push(newLink);
		             newLink.target.incoming.push(newLink);
		             newLink.target.links.push(newLink);*/
	
		            this.links.push(newLink);
	
		            return newLink;
		        },
	
		        /**
		         * Removes all the links in this graph.
		         */
		        removeAllLinks: function () {
		            while (this.links.length > 0) {
		                var link = this.links[0];
		                this.removeLink(link);
		            }
		        },
	
		        /**
		         * Adds the given link to the current graph.
		         */
		        addExistingLink: function (link) {
	
		            if (this.hasLink(link)) {
		                return;
		            }
		            this.links.push(link);
		            if (this.hasNode(link.source.id)) {
		                // priority to the existing node with the id even if other props are different
		                var s = this.getNode(link.source.id);
		                link.changeSource(s);
		            }
		            else {
		                this.addNode(link.source);
		            }
	
		            if (this.hasNode(link.target.id)) {
		                var t = this.getNode(link.target.id);
		                link.changeTarget(t);
		            }
		            else {
		                this.addNode(link.target);
		            }
	
		            /*  if (!link.source.outgoing.contains(link)) {
		             link.source.outgoing.push(link);
		             }
		             if (!link.source.links.contains(link)) {
		             link.source.links.push(link);
		             }
		             if (!link.target.incoming.contains(link)) {
		             link.target.incoming.push(link);
		             }
		             if (!link.target.links.contains(link)) {
		             link.target.links.push(link);
		             }*/
		        },
	
		        /**
		         * Returns whether the given identifier or Link is part of this graph.
		         * @param linkOrId An identifier or a Link object.
		         * @returns {*}
		         */
		        hasLink: function (linkOrId) {
		            if (Utils.isString(linkOrId)) {
		                return Utils.any(this.links, function (link) {
		                    return link.id === linkOrId;
		                });
		            }
		            if (linkOrId.type === "Link") {
		                return contains(this.links, linkOrId);
		            }
		            throw "The given object is neither an identifier nor a Link.";
		        },
		        /**
		         * Gets the node with the specified Id or null if not part of this graph.
		         */
		        getNode: function (nodeOrId) {
		            var id = nodeOrId.id || nodeOrId;
		            if (this._nodeMap.containsKey(id)) {
		                return this._nodeMap.get(id);
		            }
		        },
	
		        /**
		         * Returns whether the given node or node Id is part of this graph.
		         */
		        hasNode: function (nodeOrId) {
		            var id = nodeOrId.id || nodeOrId;
		            return this._nodeMap.containsKey(id);
		        },
	
		        _addNode: function(node) {
		            this.nodes.push(node);
		            this._nodeMap.add(node.id, node);
		        },
	
		        _removeNode: function(node) {
		            Utils.remove(this.nodes, node);
		            this._nodeMap.remove(node.id);
		        },
	
		        /**
		         * Removes the given node from this graph.
		         * The node can be specified as an object or as an identifier (string).
		         */
		        removeNode: function (nodeOrId) {
		            var n = nodeOrId;
		            if (Utils.isString(nodeOrId)) {
		                n = this.getNode(nodeOrId);
		            }
	
		            if (Utils.isDefined(n)) {
		                var links = n.links;
		                n.links = [];
		                for (var i = 0, len = links.length; i < len; i++) {
		                    var link = links[i];
		                    this.removeLink(link);
		                }
		                this._removeNode(n);
		            }
		            else {
		                throw "The identifier should be a Node or the Id (string) of a node.";
		            }
		        },
	
		        /**
		         * Returns whether the given nodes are connected with a least one link independently of the direction.
		         */
		        areConnected: function (n1, n2) {
		            return Utils.any(this.links, function (link) {
		                return link.source == n1 && link.target == n2 || link.source == n2 && link.target == n1;
		            });
		        },
	
		        /**
		         * Removes the given link from this graph.
		         */
		        removeLink: function (link) {
		            /*    if (!this.links.contains(link)) {
		             throw "The given link is not part of the Graph.";
		             }
		             */
		            Utils.remove(this.links, link);
	
		            Utils.remove(link.source.outgoing, link);
		            Utils.remove(link.source.links, link);
		            Utils.remove(link.target.incoming, link);
		            Utils.remove(link.target.links, link);
		        },
	
		        /**
		         * Adds a new node to this graph, if not already present.
		         * The node can be an existing Node or the identifier of a new node.
		         * No error is thrown if the node is already there and the existing one is returned.
		         */
		        addNode: function (nodeOrId, layoutRect, owner) {
	
		            var newNode = null;
	
		            if (!Utils.isDefined(nodeOrId)) {
		                throw "No Node or identifier for a new Node is given.";
		            }
	
		            if (Utils.isString(nodeOrId)) {
		                if (this.hasNode(nodeOrId)) {
		                    return this.getNode(nodeOrId);
		                }
		                newNode = new Node(nodeOrId);
		            }
		            else {
		                if (this.hasNode(nodeOrId)) {
		                    return this.getNode(nodeOrId);
		                }
		                // todo: ensure that the param is a Node?
		                newNode = nodeOrId;
		            }
	
		            if (Utils.isDefined(layoutRect)) {
		                newNode.bounds(layoutRect);
		            }
	
		            if (Utils.isDefined(owner)) {
		                newNode.owner = owner;
		            }
		            this._addNode(newNode);
		            return newNode;
		        },
	
		        /**
		         * Adds the given Node and its outgoing links.
		         */
		        addNodeAndOutgoings: function (node) {
		            if (!this.hasNode(node)) {
		                this._addNode(node);
		            }
	
		            var newLinks = node.outgoing;
		            node.outgoing = [];
		            Utils.forEach(newLinks, function (link) {
		                this.addExistingLink(link);
		            }, this);
		        },
	
		        /**
		         * Sets the 'index' property on the links and nodes of this graph.
		         */
		        setItemIndices: function () {
		            var i;
		            for (i = 0; i < this.nodes.length; ++i) {
		                this.nodes[i].index = i;
		            }
	
		            for (i = 0; i < this.links.length; ++i) {
		                this.links[i].index = i;
		            }
		        },
	
		        /**
		         * Returns a clone of this graph.
		         */
		        clone: function (saveMapping) {
		            var copy = new Graph();
		            var save = Utils.isDefined(saveMapping) && saveMapping === true;
		            if (save) {
		                copy.nodeMap = new Dictionary();
		                copy.linkMap = new Dictionary();
		            }
		            // we need a map even if the saveMapping is not set
		            var map = new Dictionary();
		            Utils.forEach(this.nodes, function (nOriginal) {
		                var nCopy = nOriginal.clone();
		                map.set(nOriginal, nCopy);
		                copy._addNode(nCopy);
	
		                if (save) {
		                    copy.nodeMap.set(nCopy, nOriginal);
		                }
		            });
	
		            Utils.forEach(this.links, function (linkOriginal) {
		                if (map.containsKey(linkOriginal.source) && map.containsKey(linkOriginal.target)) {
		                    var linkCopy = copy.addLink(map.get(linkOriginal.source), map.get(linkOriginal.target));
		                    if (save) {
		                        copy.linkMap.set(linkCopy, linkOriginal);
		                    }
		                }
		            });
	
		            return copy;
		        },
	
		        /**
		         * The parsing allows a quick way to create graphs.
		         *  - ["n1->n2", "n2->n3"]: creates the three nodes and adds the links
		         *  - ["n1->n2", {id: "QSDF"}, "n2->n3"]: same as previous but also performs a deep extend of the link between n1 and n2 with the given object.
		         */
		        linearize: function (addIds) {
		            return Graph.Utils.linearize(this, addIds);
		        },
	
		        /**
		         * Performs a depth-first traversal starting at the given node.
		         * @param startNode a node or id of a node in this graph
		         * @param action
		         */
		        depthFirstTraversal: function (startNode, action) {
		            if (Utils.isUndefined(startNode)) {
		                throw "You need to supply a starting node.";
		            }
		            if (Utils.isUndefined(action)) {
		                throw "You need to supply an action.";
		            }
		            if (!this.hasNode(startNode)) {
		                throw "The given start-node is not part of this graph";
		            }
		            var foundNode = this.getNode(startNode);// case the given one is an Id
		            var visited = [];
		            this._dftIterator(foundNode, action, visited);
		        },
	
		        _dftIterator: function (node, action, visited) {
	
		            action(node);
		            visited.push(node);
		            var children = node.getChildren();
		            for (var i = 0, len = children.length; i < len; i++) {
		                var child = children[i];
		                if (contains(visited, child)) {
		                    continue;
		                }
		                this._dftIterator(child, action, visited);
		            }
		        },
	
		        /**
		         * Performs a breadth-first traversal starting at the given node.
		         * @param startNode a node or id of a node in this graph
		         * @param action
		         */
		        breadthFirstTraversal: function (startNode, action) {
	
		            if (Utils.isUndefined(startNode)) {
		                throw "You need to supply a starting node.";
		            }
		            if (Utils.isUndefined(action)) {
		                throw "You need to supply an action.";
		            }
	
		            if (!this.hasNode(startNode)) {
		                throw "The given start-node is not part of this graph";
		            }
		            var foundNode = this.getNode(startNode);// case the given one is an Id
		            var queue = new Queue();
		            var visited = [];
		            queue.enqueue(foundNode);
	
		            while (queue.length > 0) {
		                var node = queue.dequeue();
		                action(node);
		                visited.push(node);
		                var children = node.getChildren();
		                for (var i = 0, len = children.length; i < len; i++) {
		                    var child = children[i];
		                    if (contains(visited, child) || contains(queue, child)) {
		                        continue;
		                    }
		                    queue.enqueue(child);
		                }
		            }
		        },
	
		        /**
		         * This is the classic Tarjan algorithm for strongly connected components.
		         * See e.g. http://en.wikipedia.org/wiki/Tarjan's_strongly_connected_components_algorithm
		         * @param excludeSingleItems Whether isolated nodes should be excluded from the analysis.
		         * @param node The start node from which the analysis starts.
		         * @param indices  Numbers the nodes consecutively in the order in which they are discovered.
		         * @param lowLinks The smallest index of any node known to be reachable from the node, including the node itself
		         * @param connected The current component.
		         * @param stack The bookkeeping stack of things to visit.
		         * @param index The counter of visited nodes used to assign the indices.
		         * @private
		         */
		        _stronglyConnectedComponents: function (excludeSingleItems, node, indices, lowLinks, connected, stack, index) {
		            indices.add(node, index);
		            lowLinks.add(node, index);
		            index++;
	
		            stack.push(node);
	
		            var children = node.getChildren(), next;
		            for (var i = 0, len = children.length; i < len; i++) {
		                next = children[i];
		                if (!indices.containsKey(next)) {
		                    this._stronglyConnectedComponents(excludeSingleItems, next, indices, lowLinks, connected, stack, index);
		                    lowLinks.add(node, Math.min(lowLinks.get(node), lowLinks.get(next)));
		                }
		                else if (contains(stack, next)) {
		                    lowLinks.add(node, Math.min(lowLinks.get(node), indices.get(next)));
		                }
		            }
		            // If v is a root node, pop the stack and generate a strong component
		            if (lowLinks.get(node) === indices.get(node)) {
		                var component = [];
		                do {
		                    next = stack.pop();
		                    component.push(next);
		                }
		                while (next !== node);
		                if (!excludeSingleItems || (component.length > 1)) {
		                    connected.push(component);
		                }
		            }
		        },
	
		        /**
		         * Returns the cycles found in this graph.
		         * The returned arrays consist of the nodes which are strongly coupled.
		         * @param excludeSingleItems Whether isolated nodes should be excluded.
		         * @returns {Array} The array of cycles found.
		         */
		        findCycles: function (excludeSingleItems) {
		            if (Utils.isUndefined(excludeSingleItems)) {
		                excludeSingleItems = true;
		            }
		            var indices = new Dictionary();
		            var lowLinks = new Dictionary();
		            var connected = [];
		            var stack = [];
		            for (var i = 0, len = this.nodes.length; i < len; i++) {
		                var node = this.nodes[i];
		                if (indices.containsKey(node)) {
		                    continue;
		                }
		                this._stronglyConnectedComponents(excludeSingleItems, node, indices, lowLinks, connected, stack, 0);
		            }
		            return connected;
		        },
	
		        /**
		         * Returns whether this graph is acyclic.
		         * @returns {*}
		         */
		        isAcyclic: function () {
		            return Utils.isEmpty(this.findCycles());
		        },
	
		        /**
		         * Returns whether the given graph is a subgraph of this one.
		         * @param other Another graph instance.
		         */
		        isSubGraph: function (other) {
		            var otherArray = other.linearize();
		            var thisArray = this.linearize();
		            return Utils.all(otherArray, function (s) {
		                return contains(thisArray, s);
		            });
		        },
	
		        /**
		         *  Makes an acyclic graph from the current (connected) one.
		         * * @returns {Array} The reversed links.
		         */
		        makeAcyclic: function () {
		            // if empty or almost empty
		            if (this.isEmpty() || this.nodes.length <= 1 || this.links.length <= 1) {
		                return [];
		            }
		            // singular case of just two nodes
		            if (this.nodes.length == 2) {
		                var result = [];
		                if (this.links.length > 1) {
		                    var oneLink = this.links[0];
		                    var oneNode = oneLink.source;
		                    for (var i = 0, len = this.links.length; i < len; i++) {
		                        var link = this.links[i];
		                        if (link.source == oneNode) {
		                            continue;
		                        }
		                        var rev = link.reverse();
		                        result.push(rev);
		                    }
		                }
		                return result;
		            }
	
		            var copy = this.clone(true); // copy.nodeMap tells you the mapping
		            var N = this.nodes.length;
	
		            var intensityCatalog = new Dictionary();
	
		            /**
		             * If there are both incoming and outgoing links this will return the flow intensity (out-in).
		             * Otherwise the node acts as a flow source with N specifying the (equal) intensity.
		             * @param node
		             * @returns {number}
		             */
		            var flowIntensity = function (node) {
		                if (node.outgoing.length === 0) {
		                    return (2 - N);
		                }
		                else if (node.incoming.length === 0) {
		                    return (N - 2);
		                }
		                else {
		                    return node.outgoing.length - node.incoming.length;
		                }
		            };
	
		            /**
		             * Collects the nodes with the same intensity.
		             * @param node
		             * @param intensityCatalog
		             */
		            var catalogEqualIntensity = function (node, intensityCatalog) {
		                var intensity = flowIntensity(node, N);
		                if (!intensityCatalog.containsKey(intensity)) {
		                    intensityCatalog.set(intensity, []);
		                }
		                intensityCatalog.get(intensity).push(node);
		            };
	
		            Utils.forEach(copy.nodes, function (v) {
		                catalogEqualIntensity(v, intensityCatalog);
		            });
	
		            var sourceStack = [];
		            var targetStack = [];
	
		            while (copy.nodes.length > 0) {
		                var source, target, intensity;
		                if (intensityCatalog.containsKey(2 - N)) {
		                    var targets = intensityCatalog.get(2 - N); // nodes without outgoings
		                    while (targets.length > 0) {
		                        target = targets.pop();
		                        for (var li = 0; li < target.links.length; li++) {
		                            var targetLink = target.links[li];
		                            source = targetLink.getComplement(target);
		                            intensity = flowIntensity(source, N);
		                            Utils.remove(intensityCatalog.get(intensity), source);
		                            source.removeLink(targetLink);
		                            catalogEqualIntensity(source, intensityCatalog);
		                        }
		                        copy._removeNode(target);
		                        targetStack.unshift(target);
		                    }
		                }
	
		                // move sources to sourceStack
		                if (intensityCatalog.containsKey(N - 2)) {
		                    var sources = intensityCatalog.get(N - 2); // nodes without incomings
		                    while (sources.length > 0) {
		                        source = sources.pop();
		                        for (var si = 0; si < source.links.length; si++) {
		                            var sourceLink = source.links[si];
		                            target = sourceLink.getComplement(source);
		                            intensity = flowIntensity(target, N);
		                            Utils.remove(intensityCatalog.get(intensity), target);
		                            target.removeLink(sourceLink);
		                            catalogEqualIntensity(target, intensityCatalog);
		                        }
		                        sourceStack.push(source);
		                        copy._removeNode(source);
		                    }
		                }
	
		                if (copy.nodes.length > 0) {
		                    for (var k = N - 3; k > 2 - N; k--) {
		                        if (intensityCatalog.containsKey(k) &&
		                            intensityCatalog.get(k).length > 0) {
		                            var maxdiff = intensityCatalog.get(k);
		                            var v = maxdiff.pop();
		                            for (var ri = 0; ri < v.links.length; ri++) {
		                                var ril = v.links[ri];
		                                var u = ril.getComplement(v);
		                                intensity = flowIntensity(u, N);
		                                Utils.remove(intensityCatalog.get(intensity), u);
		                                u.removeLink(ril);
		                                catalogEqualIntensity(u, intensityCatalog);
		                            }
		                            sourceStack.push(v);
		                            copy._removeNode(v);
		                            break;
		                        }
		                    }
		                }
		            }
	
		            sourceStack = sourceStack.concat(targetStack);
	
		            var vertexOrder = new Dictionary();
		            for (var kk = 0; kk < this.nodes.length; kk++) {
		                vertexOrder.set(copy.nodeMap.get(sourceStack[kk]), kk);
		            }
	
		            var reversedEdges = [];
		            Utils.forEach(this.links, function (link) {
		                if (vertexOrder.get(link.source) > vertexOrder.get(link.target)) {
		                    link.reverse();
		                    reversedEdges.push(link);
		                }
		            });
		            return reversedEdges;
		        }
		    });
	
		    /**
		     * A collection of predefined graphs for demo and testing purposes.
		     */
		    Graph.Predefined = {
		        /**
		         * Eight-shapes graph all connected in a cycle.
		         * @returns {*}
		         * @constructor
		         */
		        EightGraph: function () {
		            return Graph.Utils.parse([ "1->2", "2->3", "3->4", "4->1", "3->5", "5->6", "6->7", "7->3"]);
		        },
	
		        /**
		         * Creates a typical mindmap diagram.
		         * @returns {*}
		         * @constructor
		         */
		        Mindmap: function () {
		            return Graph.Utils.parse(["0->1", "0->2", "0->3", "0->4", "0->5", "1->6", "1->7", "7->8", "2->9", "9->10", "9->11", "3->12",
		                "12->13", "13->14", "4->15", "4->16", "15->17", "15->18", "18->19", "18->20", "14->21", "14->22", "5->23", "23->24", "23->25", "6->26"]);
		        },
	
		        /**
		         * Three nodes connected in a cycle.
		         * @returns {*}
		         * @constructor
		         */
		        ThreeGraph: function () {
		            return Graph.Utils.parse([ "1->2", "2->3", "3->1"]);
		        },
	
		        /**
		         * A tree with each node having two children.
		         * @param levels How many levels the binary tree should have.
		         * @returns {diagram.Graph}
		         * @constructor
		         */
		        BinaryTree: function (levels) {
		            if (Utils.isUndefined(levels)) {
		                levels = 5;
		            }
		            return Graph.Utils.createBalancedTree(levels, 2);
		        },
	
		        /**
		         * A linear graph (discrete line segment).
		         * @param length How many segments (the node count is hence (length+1)).
		         * @returns {diagram.Graph}
		         * @constructor
		         */
		        Linear: function (length) {
		            if (Utils.isUndefined(length)) {
		                length = 10;
		            }
		            return Graph.Utils.createBalancedTree(length, 1);
		        },
	
		        /**
		         * A standard tree-graph with the specified levels and children (siblings) count.
		         * Note that for a balanced tree of level N and sibling count s, counting the root as level zero:
		         *  - NodeCount = (1-s^(N+1))/(1-s)]
		         *  - LinkCount = s.(1-s^N)/(1-s)
		         * @param levels How many levels the tree should have.
		         * @param siblingsCount How many siblings each level should have.
		         * @returns {diagram.Graph}
		         * @constructor
		         */
		        Tree: function (levels, siblingsCount) {
		            return Graph.Utils.createBalancedTree(levels, siblingsCount);
		        },
	
		        /**
		         * Creates a forest.
		         * Note that for a balanced forest of level N, sibling count s and tree count t, counting the root as level zero:
		         *  - NodeCount = t.(1-s^(N+1))/(1-s)]
		         *  - LinkCount = t.s.(1-s^N)/(1-s)
		         * @param levels How many levels the tree should have.
		         * @param siblingsCount How many siblings each level should have.
		         * @param trees The amount of trees the forest should have.
		         * @returns {diagram.Graph}
		         * @constructor
		         */
		        Forest: function (levels, siblingsCount, trees) {
		            return Graph.Utils.createBalancedForest(levels, siblingsCount, trees);
		        },
	
		        /**
		         * A workflow-like graph with cycles.
		         * @returns {*}
		         * @constructor
		         */
		        Workflow: function () {
		            return Graph.Utils.parse(
		                ["0->1", "1->2", "2->3", "1->4", "4->3", "3->5", "5->6", "6->3", "6->7", "5->4"]
		            );
		        },
	
		        /**
		         * A grid graph with the direction of the links avoiding cycles.
		         * Node count: (n+1).(m+1)
		         * Link count: n.(m+1) + m.(n+1)
		         * @param n Horizontal count of grid cells. If zero this will result in a linear graph.
		         * @param m Vertical count of grid cells. If zero this will result in a linear graph.
		         * @constructor
		         */
		        Grid: function (n, m) {
		            var g = new diagram.Graph();
		            if (n <= 0 && m <= 0) {
		                return g;
		            }
	
		            for (var i = 0; i < n + 1; i++) {
		                var previous = null;
		                for (var j = 0; j < m + 1; j++) {
		                    // using x-y coordinates to name the nodes
		                    var node = new Node(i.toString() + "." + j.toString());
		                    g.addNode(node);
		                    if (previous) {
		                        g.addLink(previous, node);
		                    }
		                    if (i > 0) {
		                        var left = g.getNode((i - 1).toString() + "." + j.toString());
		                        g.addLink(left, node);
		                    }
		                    previous = node;
		                }
		            }
		            return g;
		        }
	
		    };
	
		    /**
		     * Graph generation and other utilities.
		     */
		    Graph.Utils = {
		        /**
		         * The parsing allows a quick way to create graphs.
		         *  - ["n1->n2", "n2->n3"]: creates the three nodes and adds the links
		         *  - ["n1->n2", {id: "id177"}, "n2->n3"]: same as previous but also performs a deep extend of the link between n1 and n2 with the given object.
		         */
		        parse: function (graphString) {
	
		            var previousLink, graph = new diagram.Graph(), parts = graphString.slice();
		            for (var i = 0, len = parts.length; i < len; i++) {
		                var part = parts[i];
		                if (Utils.isString(part)) // link spec
		                {
		                    if (part.indexOf("->") < 0) {
		                        throw "The link should be specified as 'a->b'.";
		                    }
		                    var p = part.split("->");
		                    if (p.length != 2) {
		                        throw "The link should be specified as 'a->b'.";
		                    }
		                    previousLink = new Link(p[0], p[1]);
		                    graph.addLink(previousLink);
		                }
		                if (Utils.isObject(part)) {
		                    if (!previousLink) {
		                        throw "Specification found before Link definition.";
		                    }
		                    kendo.deepExtend(previousLink, part);
		                }
		            }
		            return graph;
		        },
	
		        /**
		         * Returns a linearized representation of the given Graph.
		         * See also the Graph.Utils.parse method for the inverse operation.
		         */
		        linearize: function (graph, addIds) {
		            if (Utils.isUndefined(graph)) {
		                throw "Expected an instance of a Graph object in slot one.";
		            }
		            if (Utils.isUndefined(addIds)) {
		                addIds = false;
		            }
		            var lin = [];
		            for (var i = 0, len = graph.links.length; i < len; i++) {
		                var link = graph.links[i];
		                lin.push(link.source.id + "->" + link.target.id);
		                if (addIds) {
		                    lin.push({id: link.id});
		                }
		            }
		            return lin;
		        },
	
		        /**
		         * The method used by the diagram creation to instantiate a shape.
		         * @param kendoDiagram The Kendo diagram where the diagram will be created.
		         * @param p The position at which to place the shape.
		         * @param shapeDefaults Optional Shape options.
		         * @param id Optional identifier of the shape.
		         * @returns {*}
		         * @private
		         */
		        _addShape: function (kendoDiagram, p, id, shapeDefaults) {
		            if (Utils.isUndefined(p)) {
		                p = new diagram.Point(0, 0);
		            }
	
		            if (Utils.isUndefined(id)) {
		                id = randomId();
		            }
	
		            shapeDefaults = kendo.deepExtend({
		                width: 20,
		                height: 20,
		                id: id,
		                radius: 10,
		                fill: "#778899",
		                data: "circle",
		                undoable: false,
		                x: p.x,
		                y: p.y
		            }, shapeDefaults);
	
		            return kendoDiagram.addShape(shapeDefaults);
		        },
		        /**
		         * The method used by the diagram creation to instantiate a connection.
		         * @param diagram he Kendo diagram where the diagram will be created.
		         * @param from The source shape.
		         * @param to The target shape.
		         * @param options Optional Connection options.
		         * @returns {*}
		         * @private
		         */
		        _addConnection: function (diagram, from, to, options) {
		            return diagram.connect(from, to, options);
		        },
	
		        /**
		         * Creates a diagram from the given Graph.
		         * @param diagram The Kendo diagram where the diagram will be created.
		         * @param graph The graph structure defining the diagram.
		         */
		        createDiagramFromGraph: function (diagram, graph, doLayout, randomSize) {
	
		            if (Utils.isUndefined(diagram)) {
		                throw "The diagram surface is undefined.";
		            }
		            if (Utils.isUndefined(graph)) {
		                throw "No graph specification defined.";
		            }
		            if (Utils.isUndefined(doLayout)) {
		                doLayout = true;
		            }
		            if (Utils.isUndefined(randomSize)) {
		                randomSize = false;
		            }
	
		            var width = diagram.element.clientWidth || 200;
		            var height = diagram.element.clientHeight || 200;
		            var map = [], node, shape;
		            for (var i = 0, len = graph.nodes.length; i < len; i++) {
		                node = graph.nodes[i];
		                var p = node.position;
		                if (Utils.isUndefined(p)) {
		                    if (Utils.isDefined(node.x) && Utils.isDefined(node.y)) {
		                        p = new Point(node.x, node.y);
		                    }
		                    else {
		                        p = new Point(Utils.randomInteger(10, width - 20), Utils.randomInteger(10, height - 20));
		                    }
		                }
		                var opt = {};
	
		                if (node.id === "0") {
		                    /* kendo.deepExtend(opt,
		                     {
		                     fill: "Orange",
		                     data: 'circle',
		                     width: 100,
		                     height: 100,
		                     center: new Point(50, 50)
		                     });*/
		                }
		                else if (randomSize) {
		                    kendo.deepExtend(opt, {
		                        width: Math.random() * 150 + 20,
		                        height: Math.random() * 80 + 50,
		                        data: 'rectangle',
		                        fill: {
		                            color: "#778899"
		                        }
		                    });
		                }
	
		                shape = this._addShape(diagram, p, node.id, opt);
		                //shape.content(node.id);
	
		                var bounds = shape.bounds();
		                if (Utils.isDefined(bounds)) {
		                    node.x = bounds.x;
		                    node.y = bounds.y;
		                    node.width = bounds.width;
		                    node.height = bounds.height;
		                }
		                map[node.id] = shape;
		            }
		            for (var gli = 0; gli < graph.links.length; gli++) {
		                var link = graph.links[gli];
		                var sourceShape = map[link.source.id];
		                if (Utils.isUndefined(sourceShape)) {
		                    continue;
		                }
		                var targetShape = map[link.target.id];
		                if (Utils.isUndefined(targetShape)) {
		                    continue;
		                }
		                this._addConnection(diagram, sourceShape, targetShape, {id: link.id});
	
		            }
		            if (doLayout) {
		                var l = new diagram.SpringLayout(diagram);
		                l.layoutGraph(graph, {limitToView: false});
		                for (var shi = 0; shi < graph.nodes.length; shi++) {
		                    node = graph.nodes[shi];
		                    shape = map[node.id];
		                    shape.bounds(new Rect(node.x, node.y, node.width, node.height));
		                }
		            }
		        },
	
		        /**
		         * Creates a balanced tree with the specified number of levels and siblings count.
		         * Note that for a balanced tree of level N and sibling count s, counting the root as level zero:
		         *  - NodeCount = (1-s^(N+1))/(1-s)]
		         *  - LinkCount = s.(1-s^N)/(1-s)
		         * @param levels How many levels the tree should have.
		         * @param siblingsCount How many siblings each level should have.
		         * @returns {diagram.Graph}
		         */
		        createBalancedTree: function (levels, siblingsCount) {
		            if (Utils.isUndefined(levels)) {
		                levels = 3;
		            }
		            if (Utils.isUndefined(siblingsCount)) {
		                siblingsCount = 3;
		            }
	
		            var g = new diagram.Graph(), counter = -1, lastAdded = [], news;
		            if (levels <= 0 || siblingsCount <= 0) {
		                return g;
		            }
		            var root = new Node((++counter).toString());
		            g.addNode(root);
		            g.root = root;
		            lastAdded.push(root);
		            for (var i = 0; i < levels; i++) {
		                news = [];
		                for (var j = 0; j < lastAdded.length; j++) {
		                    var parent = lastAdded[j];
		                    for (var k = 0; k < siblingsCount; k++) {
		                        var item = new Node((++counter).toString());
		                        g.addLink(parent, item);
		                        news.push(item);
		                    }
		                }
		                lastAdded = news;
		            }
		            return g;
		        },
	
		        /**
		         * Creates a balanced tree with the specified number of levels and siblings count.
		         * Note that for a balanced forest of level N, sibling count s and tree count t, counting the root as level zero:
		         *  - NodeCount = t.(1-s^(N+1))/(1-s)]
		         *  - LinkCount = t.s.(1-s^N)/(1-s)
		         * @param levels How many levels the tree should have.
		         * @param siblingsCount How many siblings each level should have.
		         * @returns {diagram.Graph}
		         * @param treeCount The number of trees the forest should have.
		         */
		        createBalancedForest: function (levels, siblingsCount, treeCount) {
		            if (Utils.isUndefined(levels)) {
		                levels = 3;
		            }
		            if (Utils.isUndefined(siblingsCount)) {
		                siblingsCount = 3;
		            }
		            if (Utils.isUndefined(treeCount)) {
		                treeCount = 5;
		            }
		            var g = new diagram.Graph(), counter = -1, lastAdded = [], news;
		            if (levels <= 0 || siblingsCount <= 0 || treeCount <= 0) {
		                return g;
		            }
	
		            for (var t = 0; t < treeCount; t++) {
		                var root = new Node((++counter).toString());
		                g.addNode(root);
		                lastAdded = [root];
		                for (var i = 0; i < levels; i++) {
		                    news = [];
		                    for (var j = 0; j < lastAdded.length; j++) {
		                        var parent = lastAdded[j];
		                        for (var k = 0; k < siblingsCount; k++) {
		                            var item = new Node((++counter).toString());
		                            g.addLink(parent, item);
		                            news.push(item);
		                        }
		                    }
		                    lastAdded = news;
		                }
		            }
		            return g;
		        },
	
		        /**
		         * Creates a random graph (uniform distribution) with the specified amount of nodes.
		         * @param nodeCount The amount of nodes the random graph should have.
		         * @param maxIncidence The maximum allowed degree of the nodes.
		         * @param isTree Whether the return graph should be a tree (default: false).
		         * @returns {diagram.Graph}
		         */
		        createRandomConnectedGraph: function (nodeCount, maxIncidence, isTree) {
	
		            /* Swa's Mathematica export of random Bernoulli graphs
		             gr[n_,p_]:=Module[{g=RandomGraph[BernoulliGraphDistribution[n,p],VertexLabels->"Name",DirectedEdges->True]},
		             While[Not[ConnectedGraphQ[g]],g=RandomGraph[BernoulliGraphDistribution[n,p],VertexLabels->"Name",DirectedEdges->True]];g];
		             project[a_]:=("\""<>ToString[Part[#,1]]<>"->"<>ToString[Part[#,2]]<>"\"")&     @ a;
		             export[g_]:=project/@ EdgeList[g]
		             g = gr[12,.1]
		             export [g]
		             */
	
		            if (Utils.isUndefined(nodeCount)) {
		                nodeCount = 40;
		            }
		            if (Utils.isUndefined(maxIncidence)) {
		                maxIncidence = 4;
		            }
		            if (Utils.isUndefined(isTree)) {
		                isTree = false;
		            }
	
		            var g = new diagram.Graph(), counter = -1;
		            if (nodeCount <= 0) {
		                return g;
		            }
	
		            var root = new Node((++counter).toString());
		            g.addNode(root);
		            if (nodeCount === 1) {
		                return g;
		            }
		            if (nodeCount > 1) {
		                // random tree
		                for (var i = 1; i < nodeCount; i++) {
		                    var poolNode = g.takeRandomNode([], maxIncidence);
		                    if (!poolNode) {
		                        //failed to find one so the graph will have less nodes than specified
		                        break;
		                    }
		                    var newNode = g.addNode(i.toString());
		                    g.addLink(poolNode, newNode);
		                }
		                if (!isTree && nodeCount > 1) {
		                    var randomAdditions = Utils.randomInteger(1, nodeCount);
		                    for (var ri = 0; ri < randomAdditions; ri++) {
		                        var n1 = g.takeRandomNode([], maxIncidence);
		                        var n2 = g.takeRandomNode([], maxIncidence);
		                        if (n1 && n2 && !g.areConnected(n1, n2)) {
		                            g.addLink(n1, n2);
		                        }
		                    }
		                }
		                return g;
		            }
		        },
	
		        /**
		         * Generates a random diagram.
		         * @param diagram The host diagram.
		         * @param shapeCount The number of shapes the random diagram should contain.
		         * @param maxIncidence The maximum degree the shapes can have.
		         * @param isTree Whether the generated diagram should be a tree
		         * @param layoutType The optional layout type to apply after the diagram is generated.
		         */
		        randomDiagram: function (diagram, shapeCount, maxIncidence, isTree, randomSize) {
		            var g = kendo.dataviz.diagram.Graph.Utils.createRandomConnectedGraph(shapeCount, maxIncidence, isTree);
		            Graph.Utils.createDiagramFromGraph(diagram, g, false, randomSize);
		        }
		    };
	
		    kendo.deepExtend(diagram, {
		        init: function (element) {
		            kendo.init(element, diagram.ui);
		        },
	
		        Point: Point,
		        Intersect: Intersect,
		        Geometry: Geometry,
		        Rect: Rect,
		        Size: Size,
		        RectAlign: RectAlign,
		        Matrix: Matrix,
		        MatrixVector: MatrixVector,
		        normalVariable: normalVariable,
		        randomId: randomId,
		        Dictionary: Dictionary,
		        HashTable: HashTable,
		        Queue: Queue,
		        Set: Set,
		        Node: Node,
		        Link: Link,
		        Graph: Graph,
		        PathDefiner: PathDefiner
		    });
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 879:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(777);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(881);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 877:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(778);
	
	/***/ }),
	
	/***/ 881:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(859), __webpack_require__(877) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    // Imports ================================================================
		    var kendo = window.kendo,
		        diagram = kendo.dataviz.diagram,
		        Class = kendo.Class,
		        deepExtend = kendo.deepExtend,
		        Point = diagram.Point,
		        Rect = diagram.Rect,
		        Matrix = diagram.Matrix,
		        Utils = diagram.Utils,
		        isNumber = Utils.isNumber,
		        isString = Utils.isString,
		        MatrixVector = diagram.MatrixVector,
	
		        g = kendo.geometry,
		        d = kendo.drawing,
	
		        defined = d.util.defined,
	
		        inArray = $.inArray;
	
		    // Constants ==============================================================
		    var TRANSPARENT = "transparent",
		        Markers = {
		            none: "none",
		            arrowStart: "ArrowStart",
		            filledCircle: "FilledCircle",
		            arrowEnd: "ArrowEnd"
		        },
		        FULL_CIRCLE_ANGLE = 360,
		        START = "start",
		        END = "end",
		        WIDTH = "width",
		        HEIGHT = "height",
		        X = "x",
		        Y = "y";
	
		    diagram.Markers = Markers;
	
		    function diffNumericOptions(options, fields) {
		        var elementOptions = this.options;
		        var hasChanges = false;
		        var value, field;
		        for (var i = 0; i < fields.length; i++) {
		            field = fields[i];
		            value = options[field];
		            if (isNumber(value) && elementOptions[field] !== value) {
		                elementOptions[field] = value;
		                hasChanges = true;
		            }
		        }
	
		        return hasChanges;
		    }
	
		    var Scale = Class.extend({
		        init: function (x, y) {
		            this.x = x;
		            this.y = y;
		        },
		        toMatrix: function () {
		            return Matrix.scaling(this.x, this.y);
		        },
		        toString: function () {
		            return kendo.format("scale({0},{1})", this.x, this.y);
		        },
		        invert: function() {
		            return new Scale(1/this.x, 1/this.y);
		        }
		    });
	
		    var Translation = Class.extend({
		        init: function (x, y) {
		            this.x = x;
		            this.y = y;
		        },
		        toMatrixVector: function () {
		            return new MatrixVector(0, 0, 0, 0, this.x, this.y);
		        },
		        toMatrix: function () {
		            return Matrix.translation(this.x, this.y);
		        },
		        toString: function () {
		            return kendo.format("translate({0},{1})", this.x, this.y);
		        },
		        plus: function (delta) {
		            this.x += delta.x;
		            this.y += delta.y;
		        },
		        times: function (factor) {
		            this.x *= factor;
		            this.y *= factor;
		        },
		        length: function () {
		            return Math.sqrt(this.x * this.x + this.y * this.y);
		        },
		        normalize: function () {
		            if (this.Length === 0) {
		                return;
		            }
		            this.times(1 / this.length());
		        },
		        invert: function() {
		            return new Translation(-this.x, -this.y);
		        }
		    });
	
		    var Rotation = Class.extend({
		        init: function (angle, x, y) {
		            this.x = x || 0;
		            this.y = y || 0;
		            this.angle = angle;
		        },
		        toString: function () {
		            if (this.x && this.y) {
		                return kendo.format("rotate({0},{1},{2})", this.angle, this.x, this.y);
		            } else {
		                return kendo.format("rotate({0})", this.angle);
		            }
		        },
		        toMatrix: function () {
		            return Matrix.rotation(this.angle, this.x, this.y); // T*R*T^-1
		        },
		        center: function () {
		            return new Point(this.x, this.y);
		        },
		        invert: function() {
		            return new Rotation(FULL_CIRCLE_ANGLE - this.angle, this.x, this.y);
		        }
		    });
	
		    Rotation.ZERO = new Rotation(0);
	
		    Rotation.create = function (rotation) {
		        return new Rotation(rotation.angle, rotation.x, rotation.y);
		    };
	
		    Rotation.parse = function (str) {
		        var values = str.slice(1, str.length - 1).split(","),
		            angle = values[0],
		            x = values[1],
		            y = values[2];
		        var rotation = new Rotation(angle, x, y);
		        return rotation;
		    };
	
		    var CompositeTransform = Class.extend({
		        init: function (x, y, scaleX, scaleY, angle, center) {
		            this.translate = new Translation(x, y);
		            if (scaleX !== undefined && scaleY !== undefined) {
		                this.scale = new Scale(scaleX, scaleY);
		            }
		            if (angle !== undefined) {
		                this.rotate = center ? new Rotation(angle, center.x, center.y) : new Rotation(angle);
		            }
		        },
		        toString: function () {
		            var toString = function (transform) {
		                return transform ? transform.toString() : "";
		            };
	
		            return toString(this.translate) +
		                toString(this.rotate) +
		                toString(this.scale);
		        },
	
		        render: function (visual) {
		            visual._transform = this;
		            visual._renderTransform();
		        },
	
		        toMatrix: function () {
		            var m = Matrix.unit();
	
		            if (this.translate) {
		                m = m.times(this.translate.toMatrix());
		            }
		            if (this.rotate) {
		                m = m.times(this.rotate.toMatrix());
		            }
		            if (this.scale) {
		                m = m.times(this.scale.toMatrix());
		            }
		            return m;
		        },
		        invert: function() {
		            var rotate = this.rotate ? this.rotate.invert() : undefined,
		                rotateMatrix = rotate ? rotate.toMatrix() : Matrix.unit(),
		                scale = this.scale ? this.scale.invert() : undefined,
		                scaleMatrix = scale ? scale.toMatrix() : Matrix.unit();
	
		            var translatePoint = new Point(-this.translate.x, -this.translate.y);
		            translatePoint = rotateMatrix.times(scaleMatrix).apply(translatePoint);
		            var translate = new Translation(translatePoint.x, translatePoint.y);
	
		            var transform = new CompositeTransform();
		            transform.translate = translate;
		            transform.rotate = rotate;
		            transform.scale = scale;
	
		            return transform;
		        }
		    });
	
		    var AutoSizeableMixin = {
		        _setScale: function() {
		            var options = this.options;
		            var originWidth = this._originWidth;
		            var originHeight = this._originHeight;
		            var scaleX = options.width / originWidth;
		            var scaleY = options.height / originHeight;
	
		            if (!isNumber(scaleX)) {
		                scaleX = 1;
		            }
		            if (!isNumber(scaleY)) {
		                scaleY = 1;
		            }
	
		            this._transform.scale = new Scale(scaleX, scaleY);
		        },
	
		        _setTranslate: function() {
		            var options = this.options;
		            var x = options.x || 0;
		            var y = options.y || 0;
		            this._transform.translate = new Translation(x, y);
		        },
	
		        _initSize: function() {
		            var options = this.options;
		            var transform = false;
		            if (options.autoSize !== false && (defined(options.width) || defined(options.height))) {
		                this._measure(true);
		                this._setScale();
		                transform = true;
		            }
	
		            if (defined(options.x) || defined(options.y)) {
		                this._setTranslate();
		                transform = true;
		            }
	
		            if (transform) {
		                this._renderTransform();
		            }
		        },
	
		        _updateSize: function(options) {
		            var update = false;
	
		            if (this.options.autoSize !== false && this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
		                update = true;
		                this._measure(true);
		                this._setScale();
		            }
	
		            if (this._diffNumericOptions(options, [X, Y])) {
		                update = true;
		                this._setTranslate();
		            }
	
		            if (update) {
		                this._renderTransform();
		            }
	
		            return update;
		        }
		    };
	
		    var Element = Class.extend({
		        init: function (options) {
		            var element = this;
		            element.options = deepExtend({}, element.options, options);
		            element.id = element.options.id;
		            element._originSize = Rect.empty();
		            element._transform = new CompositeTransform();
		        },
	
		        visible: function (value) {
		            return this.drawingContainer().visible(value);
		        },
	
		        redraw: function (options) {
		            if (options && options.id) {
		                 this.id = options.id;
		            }
		        },
	
		        position: function (x, y) {
		            var options = this.options;
		            if (!defined(x)) {
		               return new Point(options.x, options.y);
		            }
	
		            if (defined(y)) {
		                options.x = x;
		                options.y = y;
		            } else if (x instanceof Point) {
		                options.x = x.x;
		                options.y = x.y;
		            }
	
		            this._transform.translate = new Translation(options.x, options.y);
		            this._renderTransform();
		        },
	
		        rotate: function (angle, center) {
		            if (defined(angle)) {
		                this._transform.rotate = new Rotation(angle, center.x, center.y);
		                this._renderTransform();
		            }
		            return this._transform.rotate || Rotation.ZERO;
		        },
	
		        drawingContainer: function() {
		            return this.drawingElement;
		        },
	
		        _renderTransform: function () {
		            var matrix = this._transform.toMatrix();
		            this.drawingContainer().transform(new g.Matrix(matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f));
		        },
	
		        _hover: function () {},
	
		        _diffNumericOptions: diffNumericOptions,
	
		        _measure: function (force) {
		            var rect;
		            if (!this._measured || force) {
		                var box = this._boundingBox() || new g.Rect();
		                var startPoint = box.topLeft();
		                rect = new Rect(startPoint.x, startPoint.y, box.width(), box.height());
		                this._originSize = rect;
		                this._originWidth = rect.width;
		                this._originHeight = rect.height;
		                this._measured = true;
		            } else {
		                rect = this._originSize;
		            }
		            return rect;
		        },
	
		        _boundingBox: function() {
		            return this.drawingElement.rawBBox();
		        }
		    });
	
		    var VisualBase = Element.extend({
		        init: function(options) {
		            Element.fn.init.call(this, options);
	
		            options = this.options;
		            options.fill = normalizeDrawingOptions(options.fill);
		            options.stroke = normalizeDrawingOptions(options.stroke);
		        },
	
		        options: {
		            stroke: {
		                color: "gray",
		                width: 1
		            },
		            fill: {
		                color: TRANSPARENT
		            }
		        },
	
		        fill: function(color, opacity) {
		            this._fill({
		                color: getColor(color),
		                opacity: opacity
		            });
		        },
	
		        stroke: function(color, width, opacity) {
		            this._stroke({
		                color: getColor(color),
		                width: width,
		                opacity: opacity
		            });
		        },
	
		        redraw: function (options) {
		            if (options) {
		                var stroke = options.stroke;
		                var fill = options.fill;
		                if (stroke) {
		                    this._stroke(normalizeDrawingOptions(stroke));
		                }
		                if (fill) {
		                    this._fill(normalizeDrawingOptions(fill));
		                }
	
		                Element.fn.redraw.call(this, options);
		            }
		        },
	
		        _hover: function (show) {
		            var drawingElement = this.drawingElement;
		            var options = this.options;
		            var hover = options.hover;
	
		            if (hover && hover.fill) {
		                var fill = show ? normalizeDrawingOptions(hover.fill) : options.fill;
		                drawingElement.fill(fill.color, fill.opacity);
		            }
		        },
	
		        _stroke: function(strokeOptions) {
		            var options = this.options;
		            deepExtend(options, {
		                stroke: strokeOptions
		            });
	
		            strokeOptions = options.stroke;
	
		            var stroke = null;
		            if (strokeOptions.width > 0) {
		                stroke = {
		                    color: strokeOptions.color,
		                    width: strokeOptions.width,
		                    opacity: strokeOptions.opacity,
		                    dashType: strokeOptions.dashType
		                };
		            }
	
		            this.drawingElement.options.set("stroke", stroke);
		        },
	
		        _fill: function(fillOptions) {
		            var options = this.options;
		            deepExtend(options, {
		                fill: fillOptions || {}
		            });
		            var fill = options.fill;
	
		            if (fill.gradient) {
		                var gradient = fill.gradient;
		                var GradientClass = (gradient.type === "radial" ? d.RadialGradient : d.LinearGradient);
		                this.drawingElement.fill(new GradientClass(gradient));
		            } else {
		                this.drawingElement.fill(fill.color, fill.opacity);
		            }
		        }
		    });
	
		    var TextBlock = VisualBase.extend({
		        init: function (options) {
		            options = this._textColor(options);
		            VisualBase.fn.init.call(this, options);
	
		            this._font();
		            this._initText();
		            this._initSize();
		        },
	
		        options: {
		            fontSize: 15,
		            fontFamily: "sans-serif",
		            stroke: {
		                width: 0
		            },
		            fill: {
		                color: "black"
		            },
		            autoSize: true
		        },
	
		        _initText: function() {
		            var options = this.options;
	
		            this.drawingElement = new d.Text(defined(options.text) ? options.text : "", new g.Point(), {
		                font: options.font
		            });
	
		            this._fill();
		            this._stroke();
		        },
	
		        _textColor: function(options) {
		            if (options && options.color) {
		                options = deepExtend({}, options, {
		                    fill: {
		                        color: options.color
		                    }
		                });
		            }
		            return options;
		        },
	
		        _font: function() {
		            var options = this.options;
		            if (options.fontFamily && defined(options.fontSize)) {
		                var fontOptions = [];
	
		                if (options.fontStyle) {
		                    fontOptions.push(options.fontStyle);
		                }
	
		                if (options.fontWeight) {
		                    fontOptions.push(options.fontWeight);
		                }
	
		                fontOptions.push(options.fontSize + (isNumber(options.fontSize) ? "px" : ""));
		                fontOptions.push(options.fontFamily);
	
		                options.font = fontOptions.join(" ");
		            } else {
		                delete options.font;
		            }
		        },
	
		        content: function (text) {
		            return this.drawingElement.content(text);
		        },
	
		        redraw: function (options) {
		            if (options) {
		                var sizeChanged = false;
		                var textOptions = this.options;
	
		                options = this._textColor(options);
	
		                VisualBase.fn.redraw.call(this, options);
	
		                if (options.fontFamily || defined(options.fontSize) || options.fontStyle || options.fontWeight) {
		                    deepExtend(textOptions, {
		                        fontFamily: options.fontFamily,
		                        fontSize: options.fontSize,
		                        fontStyle: options.fontStyle,
		                        fontWeight: options.fontWeight
		                    });
		                    this._font();
		                    this.drawingElement.options.set("font", textOptions.font);
		                    sizeChanged = true;
		                }
	
		                if (options.text) {
		                    this.content(options.text);
		                    sizeChanged = true;
		                }
	
		                if (!this._updateSize(options) && sizeChanged) {
		                    this._initSize();
		                }
		            }
		        }
		    });
	
		    deepExtend(TextBlock.fn, AutoSizeableMixin);
	
		    var Rectangle = VisualBase.extend({
		        init: function (options) {
		            VisualBase.fn.init.call(this, options);
		            this._initPath();
		            this._setPosition();
		        },
	
		        _setPosition: function() {
		            var options = this.options;
		            var x = options.x;
		            var y = options.y;
		            if (defined(x) || defined(y)) {
		                this.position(x || 0, y || 0);
		            }
		        },
	
		        redraw: function (options) {
		            if (options) {
		                VisualBase.fn.redraw.call(this, options);
		                if (this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
		                    this._drawPath();
		                }
		                if (this._diffNumericOptions(options, [X, Y])) {
		                    this._setPosition();
		                }
		            }
		        },
	
		        _initPath: function() {
		            var options = this.options;
		            this.drawingElement = new d.Path({
		                stroke: options.stroke,
		                closed: true
		            });
	
		            this._fill();
		            this._drawPath();
		        },
	
		        _drawPath: function() {
		            var drawingElement = this.drawingElement;
		            var sizeOptions = sizeOptionsOrDefault(this.options);
		            var width = sizeOptions.width;
		            var height = sizeOptions.height;
	
		            drawingElement.segments.elements([
		                createSegment(0, 0),
		                createSegment(width, 0),
		                createSegment(width, height),
		                createSegment(0, height)
		            ]);
		        }
		    });
	
		    var MarkerBase = VisualBase.extend({
		        init: function(options) {
		           VisualBase.fn.init.call(this, options);
		           var anchor = this.options.anchor;
		           this.anchor = new g.Point(anchor.x, anchor.y);
		           this.createElement();
		        },
	
		        options: {
		           stroke: {
		                color: TRANSPARENT,
		                width: 0
		           },
		           fill: {
		                color: "black"
		           }
		        },
	
		        _transformToPath: function(point, path) {
		            var transform = path.transform();
		            if (point && transform) {
		                point = point.transformCopy(transform);
		            }
		            return point;
		        },
	
		        redraw: function(options) {
		            if (options) {
		                if (options.position) {
		                    this.options.position = options.position;
		                }
	
		                VisualBase.fn.redraw.call(this, options);
		            }
		        }
		    });
	
		    var CircleMarker = MarkerBase.extend({
		        options: {
		            radius: 4,
		            anchor: {
		                x: 0,
		                y: 0
		            }
		        },
	
		        createElement: function() {
		            var options = this.options;
		            this.drawingElement = new d.Circle(new g.Circle(this.anchor, options.radius), {
		                fill: options.fill,
		                stroke: options.stroke
		            });
		        },
	
		        positionMarker: function(path) {
		            var options = this.options;
		            var position = options.position;
		            var segments = path.segments;
		            var targetSegment;
		            var point;
	
		            if (position == START) {
		                targetSegment = segments[0];
		            } else {
		                targetSegment = segments[segments.length - 1];
		            }
		            if (targetSegment) {
		                point = this._transformToPath(targetSegment.anchor(), path);
		                this.drawingElement.transform(g.transform().translate(point.x, point.y));
		            }
		        }
		    });
	
		    var ArrowMarker = MarkerBase.extend({
		        options: {
		            path: "M 0 0 L 10 5 L 0 10 L 3 5 z"           ,
		            anchor: {
		                x: 10,
		                y: 5
		            }
		        },
	
		        createElement: function() {
		            var options = this.options;
		            this.drawingElement = d.Path.parse(options.path, {
		                fill: options.fill,
		                stroke: options.stroke
		            });
		        },
	
		        positionMarker: function(path) {
		            var points = this._linePoints(path);
		            var start = points.start;
		            var end = points.end;
		            var transform = g.transform();
		            if (start) {
		                transform.rotate(lineAngle(start, end), end);
		            }
	
		            if (end) {
		                var anchor = this.anchor;
		                var translate = end.clone().translate(-anchor.x, -anchor.y);
		                transform.translate(translate.x, translate.y);
		            }
		            this.drawingElement.transform(transform);
		        },
	
		        _linePoints: function(path) {
		            var options = this.options;
		            var segments = path.segments;
		            var startPoint, endPoint, targetSegment;
		            if (options.position == START) {
		                targetSegment = segments[0];
		                if (targetSegment) {
		                    endPoint = targetSegment.anchor();
		                    startPoint = targetSegment.controlOut();
		                    var nextSegment = segments[1];
		                    if (!startPoint && nextSegment) {
		                        startPoint = nextSegment.anchor();
		                    }
		                }
		            } else {
		                targetSegment = segments[segments.length - 1];
		                if (targetSegment) {
		                    endPoint = targetSegment.anchor();
		                    startPoint = targetSegment.controlIn();
		                    var prevSegment = segments[segments.length - 2];
		                    if (!startPoint && prevSegment) {
		                        startPoint = prevSegment.anchor();
		                    }
		                }
		            }
		            if (endPoint) {
		                return {
		                    start: this._transformToPath(startPoint, path),
		                    end: this._transformToPath(endPoint, path)
		                };
		            }
		        }
		    });
	
		    var MarkerPathMixin = {
		        _getPath: function(position) {
		            var path = this.drawingElement;
		            if (path instanceof d.MultiPath) {
		                if (position == START) {
		                    path = path.paths[0];
		                } else {
		                    path = path.paths[path.paths.length - 1];
		                }
		            }
		            if (path && path.segments.length) {
		                return path;
		            }
		        },
	
		        _normalizeMarkerOptions: function(options) {
		            var startCap = options.startCap;
		            var endCap = options.endCap;
	
		            if (isString(startCap)) {
		                options.startCap = {
		                    type: startCap
		                };
		            }
	
		            if (isString(endCap)) {
		                options.endCap = {
		                    type: endCap
		                };
		            }
		        },
	
		        _removeMarker: function(position) {
		            var marker = this._markers[position];
		            if (marker) {
		                this.drawingContainer().remove(marker.drawingElement);
		                delete this._markers[position];
		            }
		        },
	
		        _createMarkers: function() {
		            var options = this.options;
		            this._normalizeMarkerOptions(options);
	
		            this._markers = {};
		            this._markers[START] = this._createMarker(options.startCap, START);
		            this._markers[END] = this._createMarker(options.endCap, END);
		        },
	
		        _createMarker: function(options, position) {
		            var type = (options || {}).type;
		            var path = this._getPath(position);
		            var markerType, marker;
		            if (!path) {
		                this._removeMarker(position);
		                return;
		            }
	
		            if (type == Markers.filledCircle) {
		                markerType = CircleMarker;
		            } else if (type == Markers.arrowStart || type == Markers.arrowEnd){
		                markerType = ArrowMarker;
		            } else {
		                this._removeMarker(position);
		            }
		            if (markerType) {
		                marker = new markerType(deepExtend({}, options, {
		                    position: position
		                }));
		                marker.positionMarker(path);
		                this.drawingContainer().append(marker.drawingElement);
	
		                return marker;
		            }
		        },
	
		        _positionMarker : function(position) {
		            var marker = this._markers[position];
	
		            if (marker) {
		                var path = this._getPath(position);
		                if (path) {
		                    marker.positionMarker(path);
		                } else {
		                    this._removeMarker(position);
		                }
		            }
		        },
	
		        _capMap: {
		            start: "startCap",
		            end: "endCap"
		        },
	
		        _redrawMarker: function(pathChange, position, options) {
		            this._normalizeMarkerOptions(options);
	
		            var pathOptions = this.options;
		            var cap = this._capMap[position];
		            var pathCapType = (pathOptions[cap] || {}).type;
		            var optionsCap = options[cap];
		            var created = false;
		            if (optionsCap) {
		                pathOptions[cap] = deepExtend({}, pathOptions[cap], optionsCap);
		                if (optionsCap.type && pathCapType != optionsCap.type) {
		                    this._removeMarker(position);
		                    this._markers[position] = this._createMarker(pathOptions[cap], position);
		                    created  = true;
		                } else if (this._markers[position]) {
		                   this._markers[position].redraw(optionsCap);
		                }
		            } else if (pathChange && !this._markers[position] && pathOptions[cap]) {
		                this._markers[position] = this._createMarker(pathOptions[cap], position);
		                created = true;
		            }
		            return created;
		        },
	
		        _redrawMarkers: function (pathChange, options) {
		            if (!this._redrawMarker(pathChange, START, options) && pathChange) {
		                this._positionMarker(START);
		            }
		            if (!this._redrawMarker(pathChange, END, options) && pathChange) {
		                this._positionMarker(END);
		            }
		        }
		    };
	
		    var Path = VisualBase.extend({
		        init: function (options) {
		            VisualBase.fn.init.call(this, options);
		            this.container = new d.Group();
		            this._createElements();
		            this._initSize();
		        },
	
		        options: {
		            autoSize: true
		        },
	
		        drawingContainer: function() {
		            return this.container;
		        },
	
		        data: function (value) {
		            var options = this.options;
		            if (value) {
		                if (options.data != value) {
		                   options.data = value;
		                   this._setData(value);
		                   this._initSize();
		                   this._redrawMarkers(true, {});
		                }
		            } else {
		                return options.data;
		            }
		        },
	
		        redraw: function (options) {
		            if (options) {
		                VisualBase.fn.redraw.call(this, options);
	
		                var pathOptions = this.options;
		                var data = options.data;
	
		                if (defined(data) && pathOptions.data != data) {
		                    pathOptions.data = data;
		                    this._setData(data);
		                    if (!this._updateSize(options)) {
		                        this._initSize();
		                    }
		                    this._redrawMarkers(true, options);
		                } else {
		                    this._updateSize(options);
		                    this._redrawMarkers(false, options);
		                }
		            }
		        },
	
		        _createElements: function() {
		            var options = this.options;
	
		            this.drawingElement = d.Path.parse(options.data || "", {
		                stroke: options.stroke
		            });
	
		            this._fill();
		            this.container.append(this.drawingElement);
		            this._createMarkers();
		        },
	
		        _setData: function(data) {
		            var drawingElement = this.drawingElement;
		            var multipath = d.Path.parse(data || "");
		            var paths = multipath.paths.slice(0);
		            multipath.paths.elements([]);
		            drawingElement.paths.elements(paths);
		        }
		    });
	
		    deepExtend(Path.fn, AutoSizeableMixin);
		    deepExtend(Path.fn, MarkerPathMixin);
	
		    var Line = VisualBase.extend({
		        init: function (options) {
		            VisualBase.fn.init.call(this, options);
		            this.container = new d.Group();
		            this._initPath();
		            this._createMarkers();
		        },
	
		        drawingContainer: function() {
		            return this.container;
		        },
	
		        redraw: function (options) {
		            if (options) {
		                options = options || {};
		                var from = options.from;
		                var to = options.to;
		                if (from) {
		                    this.options.from = from;
		                }
	
		                if (to) {
		                    this.options.to = to;
		                }
	
		                if (from || to) {
		                    this._drawPath();
		                    this._redrawMarkers(true, options);
		                } else {
		                    this._redrawMarkers(false, options);
		                }
	
		                VisualBase.fn.redraw.call(this, options);
		            }
		        },
	
		        _initPath: function() {
		            var options = this.options;
		            var drawingElement = this.drawingElement = new d.Path({
		                stroke: options.stroke
		            });
	
		            this._fill();
		            this._drawPath();
		            this.container.append(drawingElement);
		        },
	
		        _drawPath: function() {
		            var options = this.options;
		            var drawingElement = this.drawingElement;
		            var from = options.from || new Point();
		            var to = options.to || new Point();
	
		            drawingElement.segments.elements([
		                createSegment(from.x, from.y),
		                createSegment(to.x, to.y)
		            ]);
		        }
		    });
	
		    deepExtend(Line.fn, MarkerPathMixin);
	
		    var Polyline = VisualBase.extend({
		        init: function (options) {
		            VisualBase.fn.init.call(this, options);
		            this.container = new d.Group();
		            this._initPath();
		            this._createMarkers();
		        },
	
		        drawingContainer: function() {
		            return this.container;
		        },
	
		        points: function (points) {
		            var options = this.options;
		            if (points) {
		                options.points = points;
		                this._updatePath();
		            } else {
		                return options.points;
		            }
		        },
	
		        redraw: function (options) {
		            if (options) {
		                var points = options.points;
		                VisualBase.fn.redraw.call(this, options);
	
		                if (points && this._pointsDiffer(points)) {
		                    this.points(points);
		                    this._redrawMarkers(true, options);
		                } else {
		                    this._redrawMarkers(false, options);
		                }
		            }
		        },
	
		        _initPath: function() {
		            var options = this.options;
		            this.drawingElement = new d.Path({
		                stroke: options.stroke
		            });
	
		            this._fill();
		            this.container.append(this.drawingElement);
	
		            if (options.points) {
		                this._updatePath();
		            }
		        },
	
		        _pointsDiffer: function(points) {
		            var currentPoints = this.options.points;
		            var differ = currentPoints.length !== points.length;
		            if (!differ) {
		                for (var i = 0; i < points.length; i++) {
		                    if (currentPoints[i].x !== points[i].x || currentPoints[i].y !== points[i].y) {
		                        differ = true;
		                        break;
		                    }
		                }
		            }
	
		            return differ;
		        },
	
		        _updatePath: function() {
		            var drawingElement = this.drawingElement;
		            var options = this.options;
		            var points = options.points;
		            var segments = [];
		            var point;
		            for (var i = 0; i < points.length; i++) {
		                point = points[i];
		                segments.push(createSegment(point.x, point.y));
		            }
	
		            drawingElement.segments.elements(segments);
		        },
	
		        options: {
		            points: []
		        }
		    });
	
		    deepExtend(Polyline.fn, MarkerPathMixin);
	
		    var Image = Element.extend({
		        init: function (options) {
		            Element.fn.init.call(this, options);
	
		            this._initImage();
		        },
	
		        redraw: function (options) {
		            if (options) {
		                if (options.source) {
		                    this.drawingElement.src(options.source);
		                }
	
		                if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
		                    this.drawingElement.rect(this._rect());
		                }
	
		                Element.fn.redraw.call(this, options);
		            }
		        },
	
		        _initImage: function() {
		            var options = this.options;
		            var rect = this._rect();
	
		            this.drawingElement = new d.Image(options.source, rect, {});
		        },
	
		        _rect: function() {
		            var sizeOptions = sizeOptionsOrDefault(this.options);
		            var origin = new g.Point(sizeOptions.x, sizeOptions.y);
		            var size = new g.Size(sizeOptions.width, sizeOptions.height);
	
		            return new g.Rect(origin, size);
		        }
		    });
	
		    var Group = Element.extend({
		        init: function (options) {
		            this.children = [];
		            Element.fn.init.call(this, options);
		            this.drawingElement = new d.Group();
		            this._initSize();
		        },
	
		        options: {
		            autoSize: false
		        },
	
		        append: function (visual) {
		            this.drawingElement.append(visual.drawingContainer());
		            this.children.push(visual);
		            this._childrenChange = true;
		        },
	
		        remove: function (visual) {
		            if (this._remove(visual)) {
		                this._childrenChange = true;
		            }
		        },
	
		        _remove: function(visual) {
		            var index = inArray(visual, this.children);
		            if (index >= 0) {
		                this.drawingElement.removeAt(index);
		                this.children.splice(index, 1);
		                return true;
		            }
		        },
	
		        clear: function () {
		            this.drawingElement.clear();
		            this.children = [];
		            this._childrenChange = true;
		        },
	
		        toFront: function (visuals) {
		            var visual;
	
		            for (var i = 0; i < visuals.length; i++) {
		                visual = visuals[i];
		                if (this._remove(visual)) {
		                    this.append(visual);
		                }
		            }
		        },
		        //TO DO: add drawing group support for moving and inserting children
		        toBack: function (visuals) {
		            this._reorderChildren(visuals, 0);
		        },
	
		        toIndex: function (visuals, indices) {
		            this._reorderChildren(visuals, indices);
		        },
	
		        _reorderChildren: function(visuals, indices) {
		            var group = this.drawingElement;
		            var drawingChildren = group.children.slice(0);
		            var children = this.children;
		            var fixedPosition = isNumber(indices);
		            var i, index, toIndex, drawingElement, visual;
	
		            for (i = 0; i < visuals.length; i++) {
		                visual = visuals[i];
		                drawingElement = visual.drawingContainer();
	
		                index = inArray(visual, children);
		                if (index >= 0) {
		                    drawingChildren.splice(index, 1);
		                    children.splice(index, 1);
	
		                    toIndex = fixedPosition ? indices : indices[i];
	
		                    drawingChildren.splice(toIndex, 0, drawingElement);
		                    children.splice(toIndex, 0, visual);
		                }
		            }
		            group.clear();
		            group.append.apply(group, drawingChildren);
		        },
	
		        redraw: function (options) {
		            if (options) {
		                if (this._childrenChange) {
		                    this._childrenChange = false;
		                    if (!this._updateSize(options)) {
		                        this._initSize();
		                    }
		                } else {
		                    this._updateSize(options);
		                }
	
		                Element.fn.redraw.call(this, options);
		            }
		        },
	
		        _boundingBox: function() {
		            var children = this.children;
		            var boundingBox;
		            var visual, childBoundingBox;
		            for (var i = 0; i < children.length; i++) {
		                visual = children[i];
		                if (visual.visible() && visual._includeInBBox !== false) {
		                    childBoundingBox = visual.drawingContainer().clippedBBox(null);
		                    if (childBoundingBox) {
		                        if (boundingBox) {
		                            boundingBox = g.Rect.union(boundingBox, childBoundingBox);
		                        } else {
		                            boundingBox = childBoundingBox;
		                        }
		                    }
		                }
		            }
	
		            return boundingBox;
		        }
		    });
	
		    deepExtend(Group.fn, AutoSizeableMixin);
	
		    var Layout = Group.extend({
		        init: function (rect, options) {
		            this.children = [];
		            Element.fn.init.call(this, options);
		            this.drawingElement = new d.Layout(toDrawingRect(rect), options);
		            this._initSize();
		        },
	
		        rect: function(rect) {
		            if (rect) {
		                this.drawingElement.rect(toDrawingRect(rect));
		            } else {
		                var drawingRect = this.drawingElement.rect();
		                if (drawingRect) {
		                    return new Rect(drawingRect.origin.x, drawingRect.origin.y, drawingRect.size.width, drawingRect.size.height);
		                }
		            }
		        },
	
		        reflow: function() {
		            this.drawingElement.reflow();
		        },
	
		        redraw: function (options) {
		            kendo.deepExtend(this.drawingElement.options, options);
		            Group.fn.redraw.call(this, options);
		        }
		    });
	
		    var Circle = VisualBase.extend({
		        init: function (options) {
		            VisualBase.fn.init.call(this, options);
		            this._initCircle();
		            this._initSize();
		        },
	
		        redraw: function (options) {
		            if (options) {
		                var circleOptions = this.options;
	
		                if (options.center) {
		                    deepExtend(circleOptions, {
		                        center: options.center
		                    });
		                    this._center.move(circleOptions.center.x, circleOptions.center.y);
		                }
	
		                if (this._diffNumericOptions(options, ["radius"])) {
		                    this._circle.setRadius(circleOptions.radius);
		                }
	
		                this._updateSize(options);
	
		                VisualBase.fn.redraw.call(this, options);
		            }
		        },
	
		        _initCircle: function() {
		            var options = this.options;
		            var width = options.width;
		            var height = options.height;
		            var radius = options.radius;
		            if (!defined(radius)) {
		                if (!defined(width)) {
		                    width = height;
		                }
		                if (!defined(height)) {
		                    height = width;
		                }
		                options.radius = radius = Math.min(width, height) / 2;
		            }
	
		            var center = options.center || {x: radius, y: radius};
		            this._center = new g.Point(center.x, center.y);
		            this._circle = new g.Circle(this._center, radius);
		            this.drawingElement = new d.Circle(this._circle, {
		                stroke: options.stroke
		            });
	
		            this._fill();
		        }
		    });
		    deepExtend(Circle.fn, AutoSizeableMixin);
	
		    var Canvas = Class.extend({
		        init: function (element, options) {
		            options = options || {};
		            this.element = element;
		            this.surface = d.Surface.create(element, options);
		            if (kendo.isFunction(this.surface.translate)) {
		                this.translate = this._translate;
		            }
	
		            this.drawingElement = new d.Group();
		            this._viewBox = new Rect(0, 0, options.width, options.height);
		            this.size(this._viewBox);
		        },
	
		        bounds: function () {
		            var box = this.drawingElement.clippedBBox();
		            return new Rect(0, 0, box.width(), box.height());
		        },
	
		        size: function (size) {
		            var viewBox = this._viewBox;
		            if (defined(size)) {
		                viewBox.width = size.width;
		                viewBox.height = size.height;
		                this.surface.setSize(size);
		            }
		            return {
		                width: viewBox.width,
		                height: viewBox.height
		            };
		        },
	
		        _translate: function (x, y) {
		            var viewBox = this._viewBox;
		            if (defined(x) && defined(y)) {
		                viewBox.x = x;
		                viewBox.y = y;
		                this.surface.translate({x: x, y: y});
		            }
		            return {
		                x: viewBox.x,
		                y: viewBox.y
		            };
		        },
	
		        draw: function() {
		            this.surface.draw(this.drawingElement);
		        },
	
		        append: function (visual) {
		            this.drawingElement.append(visual.drawingContainer());
		            return this;
		        },
	
		        remove: function (visual) {
		            this.drawingElement.remove(visual.drawingContainer());
		        },
	
		        insertBefore: function () {
	
		        },
	
		        clear: function () {
		            this.drawingElement.clear();
		        },
	
		        destroy: function(clearHtml) {
		            this.surface.destroy();
		            if(clearHtml) {
		                $(this.element).remove();
		            }
		        }
		    });
	
		    // Helper functions ===========================================
	
		    function sizeOptionsOrDefault(options) {
		        return {
		            x: options.x || 0,
		            y: options.y || 0,
		            width: options.width || 0,
		            height: options.height || 0
		        };
		    }
	
		    function normalizeDrawingOptions(options) {
		        if (options) {
		            var drawingOptions = options;
	
		            if (isString(drawingOptions)) {
		                drawingOptions = {
		                    color: drawingOptions
		                };
		            }
	
		            if (drawingOptions.color) {
		                drawingOptions.color = getColor(drawingOptions.color);
		            }
		            return drawingOptions;
		        }
		    }
	
		    function getColor(value) {
		        var color;
		        if (value != TRANSPARENT) {
		            color = new d.Color(value).toHex();
		        } else {
		            color = value;
		        }
		        return color;
		    }
	
		    function lineAngle(p1, p2) {
		        var xDiff = p2.x - p1.x;
		        var yDiff = p2.y - p1.y;
		        var angle = d.util.deg(Math.atan2(yDiff, xDiff));
		        return angle;
		    }
	
		    function createSegment(x, y) {
		        return new d.Segment(new g.Point(x, y));
		    }
	
		    function toDrawingRect(rect) {
		        if (rect) {
		            return new g.Rect([rect.x, rect.y], [rect.width, rect.height]);
		        }
		    }
	
		    // Exports ================================================================
		    kendo.deepExtend(diagram, {
		        init: function (element) {
		            kendo.init(element, diagram.ui);
		        },
		        diffNumericOptions: diffNumericOptions,
		        Element: Element,
		        Scale: Scale,
		        Translation: Translation,
		        Rotation: Rotation,
		        Circle: Circle,
		        Group: Group,
		        Rectangle: Rectangle,
		        Canvas: Canvas,
		        Path: Path,
		        Layout: Layout,
		        Line: Line,
		        MarkerBase: MarkerBase,
		        ArrowMarker: ArrowMarker,
		        CircleMarker: CircleMarker,
		        Polyline: Polyline,
		        CompositeTransform: CompositeTransform,
		        TextBlock: TextBlock,
		        Image: Image,
		        VisualBase: VisualBase
		    });
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(880);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 859:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(550);
	
	/***/ }),
	
	/***/ 873:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(779);
	
	/***/ }),
	
	/***/ 880:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(859), __webpack_require__(873) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function () {
	
		    (function ($, undefined) {
		        // Imports ================================================================
		        var kendo = window.kendo,
		            dataviz = kendo.dataviz,
		            diagram = dataviz.diagram,
		            Class = kendo.Class,
		            Group = diagram.Group,
		            Rect = diagram.Rect,
		            Rectangle = diagram.Rectangle,
		            Utils = diagram.Utils,
		            isUndefined = Utils.isUndefined,
		            Point = diagram.Point,
		            Circle = diagram.Circle,
		            Ticker = diagram.Ticker,
		            deepExtend = kendo.deepExtend,
		            Movable = kendo.ui.Movable,
		            browser = kendo.support.browser,
		            util = kendo.drawing.util,
		            defined = util.defined,
		            inArray = $.inArray,
		            proxy = $.proxy;
	
		        // Constants ==============================================================
		        var Cursors = {
		                arrow: "default",
		                grip: "pointer",
		                cross: "pointer",
		                add: "pointer",
		                move: "move",
		                select: "pointer",
		                south: "s-resize",
		                east: "e-resize",
		                west: "w-resize",
		                north: "n-resize",
		                rowresize: "row-resize",
		                colresize: "col-resize"
		            },
		            HIT_TEST_DISTANCE = 10,
		            AUTO = "Auto",
		            TOP = "Top",
		            RIGHT = "Right",
		            LEFT = "Left",
		            BOTTOM = "Bottom",
		            DEFAULT_SNAP_SIZE = 10,
		            DEFAULT_SNAP_ANGLE = 10,
		            DRAG_START = "dragStart",
		            DRAG = "drag",
		            DRAG_END = "dragEnd",
		            ITEMROTATE = "itemRotate",
		            ITEMBOUNDSCHANGE = "itemBoundsChange",
		            MIN_SNAP_SIZE = 5,
		            MIN_SNAP_ANGLE = 5,
		            MOUSE_ENTER = "mouseEnter",
		            MOUSE_LEAVE = "mouseLeave",
		            ZOOM_START = "zoomStart",
		            ZOOM_END = "zoomEnd",
		            SCROLL_MIN = -20000,
		            SCROLL_MAX = 20000,
		            FRICTION = 0.90,
		            FRICTION_MOBILE = 0.93,
		            VELOCITY_MULTIPLIER = 5,
		            TRANSPARENT = "transparent",
		            PAN = "pan",
		            ROTATED = "rotated",
		            SOURCE = "source",
		            TARGET = "target",
		            HANDLE_NAMES = {
		                "-1": SOURCE,
		                "1": TARGET
		            };
	
		        diagram.Cursors = Cursors;
	
		        var PositionAdapter = kendo.Class.extend({
		            init: function (layoutState) {
		                this.layoutState = layoutState;
		                this.diagram = layoutState.diagram;
		            },
		            initState: function () {
		                this.froms = [];
		                this.tos = [];
		                this.subjects = [];
		                function pusher(id, bounds) {
		                    var shape = this.diagram.getShapeById(id);
		                    if (shape) {
		                        this.subjects.push(shape);
		                        this.froms.push(shape.bounds().topLeft());
		                        this.tos.push(bounds.topLeft());
		                    }
		                }
	
		                this.layoutState.nodeMap.forEach(pusher, this);
		            },
		            update: function (tick) {
		                if (this.subjects.length <= 0) {
		                    return;
		                }
		                for (var i = 0; i < this.subjects.length; i++) {
		                    //todo: define a Lerp function instead
		                    this.subjects[i].position(
		                        new Point(this.froms[i].x + (this.tos[i].x - this.froms[i].x) * tick, this.froms[i].y + (this.tos[i].y - this.froms[i].y) * tick)
		                    );
		                }
		            }
		        });
	
		        var LayoutUndoUnit = Class.extend({
		            init: function (initialState, finalState, animate) {
		                if (isUndefined(animate)) {
		                    this.animate = false;
		                }
		                else {
		                    this.animate = animate;
		                }
		                this._initialState = initialState;
		                this._finalState = finalState;
		                this.title = "Diagram layout";
		            },
		            undo: function () {
		                this.setState(this._initialState);
		            },
		            redo: function () {
		                this.setState(this._finalState);
		            },
		            setState: function (state) {
		                var diagram = state.diagram;
		                if (this.animate) {
		                    state.linkMap.forEach(
		                        function (id, points) {
		                            var conn = diagram.getShapeById(id);
		                            conn.visible(false);
		                            if (conn) {
		                                conn.points(points);
		                            }
		                        }
		                    );
		                    var ticker = new Ticker();
		                    ticker.addAdapter(new PositionAdapter(state));
		                    ticker.onComplete(function () {
		                        state.linkMap.forEach(
		                            function (id) {
		                                var conn = diagram.getShapeById(id);
		                                conn.visible(true);
		                            }
		                        );
		                    });
		                    ticker.play();
		                }
		                else {
		                    state.nodeMap.forEach(function (id, bounds) {
		                        var shape = diagram.getShapeById(id);
		                        if (shape) {
		                            shape.position(bounds.topLeft());
		                        }
		                    });
		                    state.linkMap.forEach(
		                        function (id, points) {
		                            var conn = diagram.getShapeById(id);
		                            if (conn) {
		                                conn.points(points);
		                            }
		                        }
		                    );
		                }
		            }
		        });
	
		        var CompositeUnit = Class.extend({
		            init: function (unit) {
		                this.units = [];
		                this.title = "Composite unit";
		                if (unit !== undefined) {
		                    this.units.push(unit);
		                }
		            },
		            add: function (undoUnit) {
		                this.units.push(undoUnit);
		            },
		            undo: function () {
		                for (var i = 0; i < this.units.length; i++) {
		                    this.units[i].undo();
		                }
		            },
		            redo: function () {
		                for (var i = 0; i < this.units.length; i++) {
		                    this.units[i].redo();
		                }
		            }
		        });
	
		        var ConnectionEditUnit = Class.extend({
		            init: function (item, redoSource, redoTarget) {
		                this.item = item;
		                this._redoSource = redoSource;
		                this._redoTarget = redoTarget;
		                if (defined(redoSource)) {
		                    this._undoSource = item.source();
		                }
	
		                if (defined(redoTarget)) {
		                    this._undoTarget = item.target();
		                }
		                this.title = "Connection Editing";
		            },
		            undo: function () {
		                if (this._undoSource !== undefined) {
		                    this.item._updateConnector(this._undoSource, "source");
		                }
	
		                if (this._undoTarget !== undefined) {
		                    this.item._updateConnector(this._undoTarget, "target");
		                }
	
		                this.item.updateModel();
		            },
		            redo: function () {
		                if (this._redoSource !== undefined) {
		                    this.item._updateConnector(this._redoSource, "source");
		                }
	
		                if (this._redoTarget !== undefined) {
		                    this.item._updateConnector(this._redoTarget, "target");
		                }
	
		                this.item.updateModel();
		            }
		        });
	
		        var ConnectionEditUndoUnit = Class.extend({
		            init: function (item, undoSource, undoTarget) {
		                this.item = item;
		                this._undoSource = undoSource;
		                this._undoTarget = undoTarget;
		                this._redoSource = item.source();
		                this._redoTarget = item.target();
		                this.title = "Connection Editing";
		            },
		            undo: function () {
		                this.item._updateConnector(this._undoSource, "source");
		                this.item._updateConnector(this._undoTarget, "target");
		                this.item.updateModel();
		            },
		            redo: function () {
		                this.item._updateConnector(this._redoSource, "source");
		                this.item._updateConnector(this._redoTarget, "target");
		                this.item.updateModel();
		            }
		        });
	
		        var DeleteConnectionUnit = Class.extend({
		            init: function (connection) {
		                this.connection = connection;
		                this.diagram = connection.diagram;
		                this.targetConnector = connection.targetConnector;
		                this.title = "Delete connection";
		            },
		            undo: function () {
		                this.diagram._addConnection(this.connection, false);
		            },
		            redo: function () {
		                this.diagram.remove(this.connection, false);
		            }
		        });
	
		        var DeleteShapeUnit = Class.extend({
		            init: function (shape) {
		                this.shape = shape;
		                this.diagram = shape.diagram;
		                this.title = "Deletion";
		            },
		            undo: function () {
		                this.diagram._addShape(this.shape, false);
		                this.shape.select(false);
		            },
		            redo: function () {
		                this.shape.select(false);
		                this.diagram.remove(this.shape, false);
		            }
		        });
		        /**
		         * Holds the undoredo state when performing a rotation, translation or scaling. The adorner is optional.
		         * @type {*}
		         */
		        var TransformUnit = Class.extend({
		            init: function (shapes, undoStates, adorner) {
		                this.shapes = shapes;
		                this.undoStates = undoStates;
		                this.title = "Transformation";
		                this.redoStates = [];
		                this.adorner = adorner;
		                for (var i = 0; i < this.shapes.length; i++) {
		                    var shape = this.shapes[i];
		                    this.redoStates.push(shape.bounds());
		                }
		            },
		            undo: function () {
		                for (var i = 0; i < this.shapes.length; i++) {
		                    var shape = this.shapes[i];
		                    shape.bounds(this.undoStates[i]);
		                    if (shape.hasOwnProperty("layout")) {
		                        shape.layout(shape, this.redoStates[i], this.undoStates[i]);
		                    }
		                    shape.updateModel();
		                }
		                if (this.adorner) {
		                    this.adorner.refreshBounds();
		                    this.adorner.refresh();
		                }
		            },
		            redo: function () {
		                for (var i = 0; i < this.shapes.length; i++) {
		                    var shape = this.shapes[i];
		                    shape.bounds(this.redoStates[i]);
		                    // the 'layout' property, if implemented, lets the shape itself work out what to do with the new bounds
		                    if (shape.hasOwnProperty("layout")) {
		                        shape.layout(shape, this.undoStates[i], this.redoStates[i]);
		                    }
		                    shape.updateModel();
		                }
	
		                if (this.adorner) {
		                    this.adorner.refreshBounds();
		                    this.adorner.refresh();
		                }
		            }
		        });
	
		        var AddConnectionUnit = Class.extend({
		            init: function (connection, diagram) {
		                this.connection = connection;
		                this.diagram = diagram;
		                this.title = "New connection";
		            },
	
		            undo: function () {
		                this.diagram.remove(this.connection, false);
		            },
	
		            redo: function () {
		                this.diagram._addConnection(this.connection, false);
		            }
		        });
	
		        var AddShapeUnit = Class.extend({
		            init: function (shape, diagram) {
		                this.shape = shape;
		                this.diagram = diagram;
		                this.title = "New shape";
		            },
	
		            undo: function () {
		                this.diagram.deselect();
		                this.diagram.remove(this.shape, false);
		            },
	
		            redo: function () {
		                this.diagram._addShape(this.shape, false);
		            }
		        });
	
		        var PanUndoUnit = Class.extend({
		            init: function (initialPosition, finalPosition, diagram) {
		                this.initial = initialPosition;
		                this.finalPos = finalPosition;
		                this.diagram = diagram;
		                this.title = "Pan Unit";
		            },
		            undo: function () {
		                this.diagram.pan(this.initial);
		            },
		            redo: function () {
		                this.diagram.pan(this.finalPos);
		            }
		        });
	
		        var RotateUnit = Class.extend({
		            init: function (adorner, shapes, undoRotates) {
		                this.shapes = shapes;
		                this.undoRotates = undoRotates;
		                this.title = "Rotation";
		                this.redoRotates = [];
		                this.redoAngle = adorner._angle;
		                this.adorner = adorner;
		                this.center = adorner._innerBounds.center();
		                for (var i = 0; i < this.shapes.length; i++) {
		                    var shape = this.shapes[i];
		                    this.redoRotates.push(shape.rotate().angle);
		                }
		            },
		            undo: function () {
		                var i, shape;
		                for (i = 0; i < this.shapes.length; i++) {
		                    shape = this.shapes[i];
		                    shape.rotate(this.undoRotates[i], this.center, false);
		                    if (shape.hasOwnProperty("layout")) {
		                        shape.layout(shape);
		                    }
		                    shape.updateModel();
		                }
		                if (this.adorner) {
		                    this.adorner._initialize();
		                    this.adorner.refresh();
		                }
		            },
		            redo: function () {
		                var i, shape;
		                for (i = 0; i < this.shapes.length; i++) {
		                    shape = this.shapes[i];
		                    shape.rotate(this.redoRotates[i], this.center, false);
		                    if (shape.hasOwnProperty("layout")) {
		                        shape.layout(shape);
		                    }
		                    shape.updateModel();
		                }
		                if (this.adorner) {
		                    this.adorner._initialize();
		                    this.adorner.refresh();
		                }
		            }
		        });
	
		        var ToFrontUnit = Class.extend({
		            init: function (diagram, items, initialIndices) {
		                this.diagram = diagram;
		                this.indices = initialIndices;
		                this.items = items;
		                this.title = "Rotate Unit";
		            },
		            undo: function () {
		                this.diagram._toIndex(this.items, this.indices);
		            },
		            redo: function () {
		                this.diagram.toFront(this.items, false);
		            }
		        });
	
		        var ToBackUnit = Class.extend({
		            init: function (diagram, items, initialIndices) {
		                this.diagram = diagram;
		                this.indices = initialIndices;
		                this.items = items;
		                this.title = "Rotate Unit";
		            },
		            undo: function () {
		                this.diagram._toIndex(this.items, this.indices);
		            },
		            redo: function () {
		                this.diagram.toBack(this.items, false);
		            }
		        });
	
		        /**
		         * Undo-redo service.
		         */
		        var UndoRedoService = kendo.Observable.extend({
		            init: function (options) {
		                kendo.Observable.fn.init.call(this, options);
		                this.bind(this.events, options);
		                this.stack = [];
		                this.index = 0;
		                this.capacity = 100;
		            },
	
		            events: ["undone", "redone"],
	
		            /**
		             * Starts the collection of units. Add those with
		             * the addCompositeItem method and call commit. Or cancel to forget about it.
		             */
		            begin: function () {
		                this.composite = new CompositeUnit();
		            },
	
		            /**
		             * Cancels the collection process of unit started with 'begin'.
		             */
		            cancel: function () {
		                this.composite = undefined;
		            },
	
		            /**
		             * Commits a batch of units.
		             */
		            commit: function (execute) {
		                if (this.composite.units.length > 0) {
		                    this._restart(this.composite, execute);
		                }
		                this.composite = undefined;
		            },
	
		            /**
		             * Adds a unit as part of the begin-commit batch.
		             * @param undoUnit
		             */
		            addCompositeItem: function (undoUnit) {
		                if (this.composite) {
		                    this.composite.add(undoUnit);
		                } else {
		                    this.add(undoUnit);
		                }
		            },
	
		            /**
		             * Standard addition of a unit. See also the batch version; begin-addCompositeUnit-commit methods.
		             * @param undoUnit The unit to be added.
		             * @param execute If false, the unit will be added but not executed.
		             */
		            add: function (undoUnit, execute) {
		                this._restart(undoUnit, execute);
		            },
	
		            /**
		             * Returns the number of undoable unit in the stack.
		             * @returns {Number}
		             */
	
		            pop: function() {
		                if (this.index > 0) {
		                    this.stack.pop();
		                    this.index--;
		                }
		            },
	
		            count: function () {
		                return this.stack.length;
		            },
	
		            /**
		             * Rollback of the unit on top of the stack.
		             */
		            undo: function () {
		                if (this.index > 0) {
		                    this.index--;
		                    this.stack[this.index].undo();
		                    this.trigger("undone");
		                }
		            },
	
		            /**
		             * Redo of the last undone action.
		             */
		            redo: function () {
		                if (this.stack.length > 0 && this.index < this.stack.length) {
		                    this.stack[this.index].redo();
		                    this.index++;
		                    this.trigger("redone");
		                }
		            },
	
		            _restart: function (composite, execute) {
		                // throw away anything beyond this point if this is a new branch
		                this.stack.splice(this.index, this.stack.length - this.index);
		                this.stack.push(composite);
		                if (execute !== false) {
		                    this.redo();
		                } else {
		                    this.index++;
		                }
		                // check the capacity
		                if (this.stack.length > this.capacity) {
		                    this.stack.splice(0, this.stack.length - this.capacity);
		                    this.index = this.capacity; //points to the end of the stack
		                }
		            },
	
		            /**
		             * Clears the stack.
		             */
		            clear: function () {
		                this.stack = [];
		                this.index = 0;
		            }
		        });
	
		// Tools =========================================
	
		        var EmptyTool = Class.extend({
		            init: function (toolService) {
		                this.toolService = toolService;
		            },
		            start: function () {
		            },
		            move: function () {
		            },
		            end: function () {
		            },
		            tryActivate: function () {
		                return false;
		            },
		            getCursor: function () {
		                return Cursors.arrow;
		            }
		        });
	
		        var ScrollerTool = EmptyTool.extend({
		            init: function (toolService) {
		                var tool = this;
		                var friction = kendo.support.mobileOS ? FRICTION_MOBILE : FRICTION;
		                EmptyTool.fn.init.call(tool, toolService);
	
		                var diagram = tool.toolService.diagram,
		                    canvas = diagram.canvas;
	
		                var scroller = diagram.scroller = tool.scroller = $(diagram.scrollable).kendoMobileScroller({
		                    friction: friction,
		                    velocityMultiplier: VELOCITY_MULTIPLIER,
		                    mousewheelScrolling: false,
		                    zoom: false,
		                    scroll: proxy(tool._move, tool)
		                }).data("kendoMobileScroller");
	
		                if (canvas.translate) {
		                    tool.movableCanvas = new Movable(canvas.element);
		                }
	
		                var virtualScroll = function (dimension, min, max) {
		                    dimension.makeVirtual();
		                    dimension.virtualSize(min || SCROLL_MIN, max || SCROLL_MAX);
		                };
	
		                virtualScroll(scroller.dimensions.x);
		                virtualScroll(scroller.dimensions.y);
		                scroller.disable();
		            },
	
		            tryActivate: function (p, meta) {
		                var toolService = this.toolService;
		                var options = toolService.diagram.options.pannable;
		                var enabled = meta.ctrlKey;
	
		                if (defined(options.key)) {
		                    if (!options.key || options.key == "none") {
		                        enabled = noMeta(meta) && !defined(toolService.hoveredItem);
		                    } else {
		                        enabled = meta[options.key + "Key"];
		                    }
		                }
	
		                return  options !== false && enabled && !defined(toolService.hoveredAdorner) && !defined(toolService._hoveredConnector);
		            },
	
		            start: function () {
		                this.scroller.enable();
		            },
		            move: function () {
		            },//the tool itself should not handle the scrolling. Let kendo scroller take care of this part. Check _move
		            _move: function (args) {
		                var tool = this,
		                    diagram = tool.toolService.diagram,
		                    canvas = diagram.canvas,
		                    scrollPos = new Point(args.scrollLeft, args.scrollTop);
	
		                if (canvas.translate) {
		                    diagram._storePan(scrollPos.times(-1));
		                    tool.movableCanvas.moveTo(scrollPos);
		                    canvas.translate(scrollPos.x, scrollPos.y);
		                } else {
		                    scrollPos = scrollPos.plus(diagram._pan.times(-1));
		                }
	
		                diagram.trigger(PAN, {pan: scrollPos});
		            },
		            end: function () {
		                this.scroller.disable();
		            },
		            getCursor: function () {
		                return Cursors.move;
		            }
		        });
	
		        /**
		         * The tool handling the transformations via the adorner.
		         * @type {*}
		         */
		        var PointerTool = Class.extend({
		            init: function (toolService) {
		                this.toolService = toolService;
		            },
		            tryActivate: function () {
		                return true; // the pointer tool is last and handles all others requests.
		            },
		            start: function (p, meta) {
		                var toolService = this.toolService,
		                    diagram = toolService.diagram,
		                    hoveredItem = toolService.hoveredItem;
	
		                if (hoveredItem) {
		                    toolService.selectSingle(hoveredItem, meta);
		                    if (hoveredItem.adorner) { //connection
		                        this.adorner = hoveredItem.adorner;
		                        this.handle = this.adorner._hitTest(p);
		                    }
		                }
	
		                if (!this.handle) {
		                    this.handle = diagram._resizingAdorner._hitTest(p);
		                    if (this.handle) {
		                        this.adorner = diagram._resizingAdorner;
		                    }
		                }
	
		                if (this.adorner) {
		                    if (!this.adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_START, { shapes: this.adorner.shapes, connections: [] })) {
		                        this.adorner.start(p);
		                    } else {
		                        toolService.startPoint = p;
		                        toolService.end(p);
		                    }
		                }
		            },
	
		            move: function (p) {
		                if (this.adorner) {
		                    this.adorner.move(this.handle, p);
		                    if (this.adorner.isDragHandle(this.handle)) {
		                        this.toolService.diagram.trigger(DRAG, { shapes: this.adorner.shapes, connections: [] });
		                    }
		                }
		            },
	
		            end: function () {
		                var diagram = this.toolService.diagram,
		                    adorner = this.adorner,
		                    unit;
	
		                if (adorner) {
		                    if (!adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_END, { shapes: adorner.shapes, connections: [] })) {
		                        unit = adorner.stop();
		                        if (unit) {
		                            diagram.undoRedoService.add(unit, false);
		                        }
		                    } else {
		                        adorner.cancel();
		                    }
		                }
	
		                this.adorner = undefined;
		                this.handle = undefined;
		            },
		            getCursor: function (p) {
		                return this.toolService.hoveredItem ? this.toolService.hoveredItem._getCursor(p) : Cursors.arrow;
		            }
		        });
	
		        var SelectionTool = Class.extend({
		            init: function (toolService) {
		                this.toolService = toolService;
		            },
		            tryActivate: function (p, meta) {
		                var toolService = this.toolService;
		                var selectable = toolService.diagram.options.selectable;
		                var enabled = selectable && selectable.multiple !== false;
	
		                if (enabled) {
		                    if (selectable.key && selectable.key != "none") {
		                        enabled = meta[selectable.key + "Key"];
		                    } else {
		                        enabled = noMeta(meta);
		                    }
		                }
	
		                return enabled && !defined(toolService.hoveredItem) && !defined(toolService.hoveredAdorner);
		            },
		            start: function (p) {
		                var diagram = this.toolService.diagram;
		                diagram.deselect();
		                diagram.selector.start(p);
		            },
		            move: function (p) {
		                var diagram = this.toolService.diagram;
		                diagram.selector.move(p);
		            },
		            end: function (p, meta) {
		                var diagram = this.toolService.diagram, hoveredItem = this.toolService.hoveredItem;
		                var rect = diagram.selector.bounds();
		                if ((!hoveredItem || !hoveredItem.isSelected) && !meta.ctrlKey) {
		                    diagram.deselect();
		                }
		                if (!rect.isEmpty()) {
		                    diagram.selectArea(rect);
		                }
		                diagram.selector.end();
		            },
		            getCursor: function () {
		                return Cursors.arrow;
		            }
		        });
	
		        var ConnectionTool = Class.extend({
		            init: function (toolService) {
		                this.toolService = toolService;
		                this.type = "ConnectionTool";
		            },
		            tryActivate: function() {
		                return this.toolService._hoveredConnector;
		            },
		            start: function (p, meta) {
		                var toolService = this.toolService,
		                    diagram = toolService.diagram,
		                    connector = toolService._hoveredConnector,
		                    connection = diagram._createConnection({}, connector._c, p);
	
		                if (canDrag(connection) && !diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: TARGET }) && diagram._addConnection(connection)) {
		                    toolService._connectionManipulation(connection, connector._c.shape, true);
		                    toolService._removeHover();
		                    toolService.selectSingle(toolService.activeConnection, meta);
		                    if (meta.type == "touchmove") {
		                        diagram._cachedTouchTarget = connector.visual;
		                    }
		                } else {
		                    connection.source(null);
		                    toolService.end(p);
		                }
		            },
	
		            move: function (p) {
		                var toolService = this.toolService;
		                var connection = toolService.activeConnection;
	
		                connection.target(p);
		                toolService.diagram.trigger(DRAG, { shapes: [], connections: [connection], connectionHandle: TARGET  });
		                return true;
		            },
	
		            end: function (p) {
		                var toolService = this.toolService,
		                    d = toolService.diagram,
		                    connection = toolService.activeConnection,
		                    hoveredItem = toolService.hoveredItem,
		                    connector = toolService._hoveredConnector,
		                    target,
		                    cachedTouchTarget = d._cachedTouchTarget;
	
		                if (!connection) {
		                    return;
		                }
	
		                if (connector && connector._c != connection.sourceConnector) {
		                    target = connector._c;
		                } else if (hoveredItem && hoveredItem instanceof diagram.Shape) {
		                    target = hoveredItem.getConnector(AUTO) || hoveredItem.getConnector(p);
		                } else {
		                    target = p;
		                }
	
		                connection.target(target);
	
		                if (!d.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: TARGET })) {
		                    connection.updateModel();
		                    d._syncConnectionChanges();
		                } else {
		                    d.remove(connection, false);
		                    d.undoRedoService.pop();
		                }
		                toolService._connectionManipulation();
	
		                if(cachedTouchTarget) {
		                    d._connectorsAdorner.visual.remove(cachedTouchTarget);
		                    d._cachedTouchTarget = null;
		                }
		            },
	
		            getCursor: function () {
		                return Cursors.arrow;
		            }
		        });
	
		        var ConnectionEditTool = Class.extend({
		            init: function (toolService) {
		                this.toolService = toolService;
		                this.type = "ConnectionTool";
		            },
	
		            tryActivate: function (p, meta) {
		                var toolService = this.toolService,
		                    diagram = toolService.diagram,
		                    selectable =  diagram.options.selectable,
		                    item = toolService.hoveredItem,
		                    isActive = selectable !== false &&
		                               item && item.path && !(item.isSelected && meta.ctrlKey);
	
		                if (isActive) {
		                    this._c = item;
		                }
	
		                return isActive;
		            },
	
		            start: function (p, meta) {
		                var toolService = this.toolService;
		                var connection = this._c;
	
		                toolService.selectSingle(connection, meta);
	
		                var adorner = connection.adorner;
	
		                var handle, name;
		                if (adorner) {
		                    handle = adorner._hitTest(p);
		                    name = HANDLE_NAMES[handle];
		                }
	
		                if (canDrag(connection) && adorner && !toolService.diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: name })) {
		                    this.handle = handle;
		                    this.handleName = name;
		                    adorner.start(p);
		                } else {
		                    toolService.startPoint = p;
		                    toolService.end(p);
		                }
		            },
	
		            move: function (p) {
		                var adorner = this._c.adorner;
		                if (canDrag(this._c) && adorner) {
		                    adorner.move(this.handle, p);
		                    this.toolService.diagram.trigger(DRAG, { shapes: [], connections: [this._c], connectionHandle: this.handleName });
	
		                    return true;
		                }
		            },
	
		            end: function (p) {
		                var connection = this._c;
		                var adorner = connection.adorner;
		                var toolService = this.toolService;
		                var diagram = toolService.diagram;
	
		                if (adorner) {
		                    if (canDrag(connection)) {
		                        var unit = adorner.stop(p);
		                        if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: this.handleName })) {
		                            diagram.undoRedoService.add(unit, false);
		                            connection.updateModel();
		                            diagram._syncConnectionChanges();
		                        } else {
		                            unit.undo();
		                        }
		                    }
		                }
		            },
	
		            getCursor: function () {
		                return Cursors.move;
		            }
		        });
	
		        function testKey(key, str) {
		            return str.charCodeAt(0) == key || str.toUpperCase().charCodeAt(0) == key;
		        }
	
		        /**
		         * The service managing the tools.
		         * @type {*}
		         */
		        var ToolService = Class.extend({
		            init: function (diagram) {
		                this.diagram = diagram;
		                this.tools = [
		                    new ScrollerTool(this),
		                    new ConnectionEditTool(this),
		                    new ConnectionTool(this),
		                    new SelectionTool(this),
		                    new PointerTool(this)
		                ]; // the order matters.
	
		                this.activeTool = undefined;
		            },
	
		            start: function (p, meta) {
		                meta = deepExtend({}, meta);
		                if (this.activeTool) {
		                    this.activeTool.end(p, meta);
		                }
		                this._updateHoveredItem(p);
		                this._activateTool(p, meta);
		                this.activeTool.start(p, meta);
		                this._updateCursor(p);
		                this.diagram.focus();
		                this.diagram.canvas.surface.suspendTracking();
		                this.startPoint = p;
		                return true;
		            },
	
		            move: function (p, meta) {
		                meta = deepExtend({}, meta);
		                var updateHovered = true;
		                if (this.activeTool) {
		                    updateHovered = this.activeTool.move(p, meta);
		                }
		                if (updateHovered) {
		                    this._updateHoveredItem(p);
		                }
		                this._updateCursor(p);
		                return true;
		            },
	
		            end: function (p, meta) {
		                meta = deepExtend({}, meta);
		                if (this.activeTool) {
		                    this.activeTool.end(p, meta);
		                }
		                this.diagram.canvas.surface.resumeTracking();
		                this.activeTool = undefined;
		                this._updateCursor(p);
		                return true;
		            },
	
		            keyDown: function (key, meta) {
		                var diagram = this.diagram;
		                meta = deepExtend({ ctrlKey: false, metaKey: false, altKey: false }, meta);
		                if ((meta.ctrlKey || meta.metaKey) && !meta.altKey) {// ctrl or option
		                    if (testKey(key, "a")) {// A: select all
		                        diagram.selectAll();
		                        diagram._destroyToolBar();
		                        return true;
		                    } else if (testKey(key, "z")) {// Z: undo
		                        diagram.undo();
		                        diagram._destroyToolBar();
		                        return true;
		                    } else if (testKey(key, "y")) {// y: redo
		                        diagram.redo();
		                        diagram._destroyToolBar();
		                        return true;
		                    } else if (testKey(key, "c")) {
		                        diagram.copy();
		                        diagram._destroyToolBar();
		                    } else if (testKey(key, "x")) {
		                        diagram.cut();
		                        diagram._destroyToolBar();
		                    } else if (testKey(key, "v")) {
		                        diagram.paste();
		                        diagram._destroyToolBar();
		                    } else if (testKey(key, "l")) {
		                        diagram.layout();
		                        diagram._destroyToolBar();
		                    } else if (testKey(key, "d")) {
		                        diagram._destroyToolBar();
		                        diagram.copy();
		                        diagram.paste();
		                    }
		                } else if (key === 46 || key === 8) {// del: deletion
		                    var toRemove = this.diagram._triggerRemove(diagram.select());
		                    if (toRemove.length) {
		                        this.diagram.remove(toRemove, true);
		                        this.diagram._syncChanges();
		                        this.diagram._destroyToolBar();
		                    }
	
		                    return true;
		                } else if (key === 27) {// ESC: stop any action
		                    this._discardNewConnection();
		                    diagram.deselect();
		                    diagram._destroyToolBar();
		                    return true;
		                }
	
		            },
		            wheel: function (p, meta) {
		                var diagram = this.diagram,
		                    delta = meta.delta,
		                    z = diagram.zoom(),
		                    options = diagram.options,
		                    zoomRate = options.zoomRate,
		                    zoomOptions = { point: p, meta: meta, zoom: z };
	
		                if (diagram.trigger(ZOOM_START, zoomOptions)) {
		                    return;
		                }
	
		                if (delta < 0) {
		                    z += zoomRate;
		                } else {
		                    z -= zoomRate;
		                }
	
		                z = kendo.dataviz.round(Math.max(options.zoomMin, Math.min(options.zoomMax, z)), 2);
		                zoomOptions.zoom = z;
	
		                diagram.zoom(z, zoomOptions);
		                diagram.trigger(ZOOM_END, zoomOptions);
	
		                return true;
		            },
		            setTool: function (tool, index) {
		                tool.toolService = this;
		                this.tools[index] = tool;
		            },
	
		            selectSingle: function(item, meta) {
		                var diagram = this.diagram;
		                var selectable = diagram.options.selectable;
		                if (selectable && !item.isSelected && item.options.selectable !== false) {
		                    var addToSelection = meta.ctrlKey && selectable.multiple !== false;
		                    diagram.select(item, { addToSelection: addToSelection });
		                }
		            },
	
		            _discardNewConnection: function () {
		                if (this.newConnection) {
		                    this.diagram.remove(this.newConnection);
		                    this.newConnection = undefined;
		                }
		            },
		            _activateTool: function (p, meta) {
		                for (var i = 0; i < this.tools.length; i++) {
		                    var tool = this.tools[i];
		                    if (tool.tryActivate(p, meta)) {
		                        this.activeTool = tool;
		                        break; // activating the first available tool in the loop.
		                    }
		                }
		            },
		            _updateCursor: function (p) {
		                var element = this.diagram.element;
		                var cursor = this.activeTool ? this.activeTool.getCursor(p) : (this.hoveredAdorner ? this.hoveredAdorner._getCursor(p) : (this.hoveredItem ? this.hoveredItem._getCursor(p) : Cursors.arrow));
	
		                element.css({cursor: cursor});
		                // workaround for IE 7 issue in which the elements overflow the container after setting cursor
		                if (browser.msie && browser.version == 7) {
		                    element[0].style.cssText = element[0].style.cssText;
		                }
		            },
		            _connectionManipulation: function (connection, disabledShape, isNew) {
		                this.activeConnection = connection;
		                this.disabledShape = disabledShape;
		                if (isNew) {
		                    this.newConnection = this.activeConnection;
		                } else {
		                    this.newConnection = undefined;
		                }
		            },
		            _updateHoveredItem: function (p) {
		                var hit = this._hitTest(p);
		                var diagram = this.diagram;
	
		                if (hit != this.hoveredItem && (!this.disabledShape || hit != this.disabledShape)) {
		                    if (this.hoveredItem) {
		                        diagram.trigger(MOUSE_LEAVE, { item: this.hoveredItem });
		                        this.hoveredItem._hover(false);
		                    }
	
		                    if (hit && hit.options.enable) {
		                        diagram.trigger(MOUSE_ENTER, { item: hit });
	
		                        this.hoveredItem = hit; // Shape, connection or connector
		                        this.hoveredItem._hover(true);
		                    } else {
		                        this.hoveredItem = undefined;
		                    }
		                }
		            },
		            _removeHover: function () {
		                if (this.hoveredItem) {
		                    this.hoveredItem._hover(false);
		                    this.hoveredItem = undefined;
		                }
		            },
		            _hitTest: function (point) {
		                var hit, d = this.diagram, item, i;
	
		                // connectors
		                if (this._hoveredConnector) {
		                    this._hoveredConnector._hover(false);
		                    this._hoveredConnector = undefined;
		                }
		                if (d._connectorsAdorner._visible) {
		                    hit = d._connectorsAdorner._hitTest(point);
		                    if (hit) {
		                        return hit;
		                    }
		                }
	
		                hit = this.diagram._resizingAdorner._hitTest(point);
		                if (hit) {
		                    this.hoveredAdorner = d._resizingAdorner;
		                    if (hit.x !== 0 || hit.y !== 0) { // hit testing for resizers or rotator, otherwise if (0,0) than pass through.
		                        return;
		                    }
		                    hit = undefined;
		                } else {
		                    this.hoveredAdorner = undefined;
		                }
	
		                if (!this.activeTool || this.activeTool.type !== "ConnectionTool") {
		                    var selectedConnections = []; // only the connections should have higher presence because the connection edit point is on top of connector.
		                    // TODO: This should be reworked. The connection adorner should be one for all selected connections and should be hit tested prior the connections and shapes itself.
		                    for (i = 0; i < d._selectedItems.length; i++) {
		                        item = d._selectedItems[i];
		                        if (item instanceof diagram.Connection) {
		                            selectedConnections.push(item);
		                        }
		                    }
		                    hit = this._hitTestItems(selectedConnections, point);
		                }
	
		                return hit || this._hitTestElements(point);
		            },
	
		            _hitTestElements: function(point) {
		                var diagram = this.diagram;
		                var shapeHit = this._hitTestItems(diagram.shapes, point);
		                var connectionHit = this._hitTestItems(diagram.connections, point);
		                var hit;
	
		                if ((!this.activeTool || this.activeTool.type != "ConnectionTool") && shapeHit && connectionHit && !hitTestShapeConnectors(shapeHit, point)) {
		                    var mainLayer = diagram.mainLayer;
		                    var shapeIdx = inArray(shapeHit.visual, mainLayer.children);
		                    var connectionIdx = inArray(connectionHit.visual, mainLayer.children);
		                    hit = shapeIdx > connectionIdx ? shapeHit : connectionHit;
		                }
		                return hit || shapeHit || connectionHit;
		            },
	
		            _hitTestItems: function (array, point) {
		                var i, item, hit;
		                for (i = array.length - 1; i >= 0; i--) {
		                    item = array[i];
		                    hit = item._hitTest(point);
		                    if (hit) {
		                        return hit;
		                    }
		                }
		            }
		        });
	
		// Routing =========================================
	
		        /**
		         * Base class for connection routers.
		         */
		        var ConnectionRouterBase = kendo.Class.extend({
		            init: function () {
		            }
		            /*route: function (connection) {
		             },
		             hitTest: function (p) {
	
		             },
		             getBounds: function () {
	
		             }*/
		        });
	
		        /**
		         * Base class for polyline and cascading routing.
		         */
		        var LinearConnectionRouter = ConnectionRouterBase.extend({
		            init: function (connection) {
		                var that = this;
		                ConnectionRouterBase.fn.init.call(that);
		                this.connection = connection;
		            },
		            /**
		             * Hit testing for polyline paths.
		             */
		            hitTest: function (p) {
		                var rec = this.getBounds().inflate(HIT_TEST_DISTANCE);
		                if (!rec.contains(p)) {
		                    return false;
		                }
		                return diagram.Geometry.distanceToPolyline(p, this.connection.allPoints()) < HIT_TEST_DISTANCE;
		            },
	
		            /**
		             * Bounds of a polyline.
		             * @returns {kendo.dataviz.diagram.Rect}
		             */
		            getBounds: function () {
		                var points = this.connection.allPoints(),
		                    s = points[0],
		                    e = points[points.length - 1],
		                    right = Math.max(s.x, e.x),
		                    left = Math.min(s.x, e.x),
		                    top = Math.min(s.y, e.y),
		                    bottom = Math.max(s.y, e.y);
	
		                for (var i = 1; i < points.length - 1; ++i) {
		                    right = Math.max(right, points[i].x);
		                    left = Math.min(left, points[i].x);
		                    top = Math.min(top, points[i].y);
		                    bottom = Math.max(bottom, points[i].y);
		                }
	
		                return new Rect(left, top, right - left, bottom - top);
		            }
		        });
	
		        /**
		         * A simple poly-linear routing which does not alter the intermediate points.
		         * Does hold the underlying hit, bounds....logic.
		         * @type {*|Object|void|extend|Zepto.extend|b.extend}
		         */
		        var PolylineRouter = LinearConnectionRouter.extend({
		            init: function (connection) {
		                var that = this;
		                LinearConnectionRouter.fn.init.call(that);
		                this.connection = connection;
		            },
		            route: function () {
		                // just keep the points as is
		            }
		        });
	
		        var CascadingRouter = LinearConnectionRouter.extend({
		            SAME_SIDE_DISTANCE_RATIO: 5,
	
		            init: function (connection) {
		                var that = this;
		                LinearConnectionRouter.fn.init.call(that);
		                this.connection = connection;
		            },
	
		            routePoints: function(start, end, sourceConnector, targetConnector) {
		                var result;
	
		                if (sourceConnector && targetConnector) {
		                    result = this._connectorPoints(start, end, sourceConnector, targetConnector);
		                } else {
		                    result = this._floatingPoints(start, end, sourceConnector);
		                }
		                return result;
		            },
	
		            route: function () {
		                var sourceConnector = this.connection._resolvedSourceConnector;
		                var targetConnector = this.connection._resolvedTargetConnector;
		                var start = this.connection.sourcePoint();
		                var end = this.connection.targetPoint();
		                var points = this.routePoints(start, end, sourceConnector, targetConnector);
		                this.connection.points(points);
		            },
	
		            _connectorSides: [{
		                name: "Top",
		                axis: "y",
		                boundsPoint: "topLeft",
		                secondarySign: 1
		            }, {
		                name: "Left",
		                axis: "x",
		                boundsPoint: "topLeft",
		                secondarySign: 1
		            }, {
		                name: "Bottom",
		                axis: "y",
		                boundsPoint: "bottomRight",
		                secondarySign: -1
		            }, {
		                name: "Right",
		                axis: "x",
		                boundsPoint: "bottomRight",
		                secondarySign: -1
		            }],
	
		            _connectorSide: function(connector, targetPoint) {
		                var position = connector.position();
		                var shapeBounds = connector.shape.bounds(ROTATED);
		                var bounds = {
		                    topLeft: shapeBounds.topLeft(),
		                    bottomRight: shapeBounds.bottomRight()
		                };
		                var sides = this._connectorSides;
		                var min = util.MAX_NUM;
		                var sideDistance;
		                var minSide;
		                var axis;
		                var side;
		                for (var idx = 0; idx < sides.length; idx++) {
		                    side = sides[idx];
		                    axis = side.axis;
		                    sideDistance = Math.round(Math.abs(position[axis] - bounds[side.boundsPoint][axis]));
		                    if (sideDistance < min) {
		                        min = sideDistance;
		                        minSide = side;
		                    } else if (sideDistance === min &&
		                        (position[axis] - targetPoint[axis]) * side.secondarySign > (position[minSide.axis] - targetPoint[minSide.axis]) * minSide.secondarySign) {
		                        minSide = side;
		                    }
		                }
		                return minSide.name;
		            },
	
		            _sameSideDistance: function(connector) {
		                var bounds = connector.shape.bounds(ROTATED);
		                return Math.min(bounds.width, bounds.height) / this.SAME_SIDE_DISTANCE_RATIO;
		            },
	
		            _connectorPoints: function(start, end, sourceConnector, targetConnector) {
		                var sourceConnectorSide = this._connectorSide(sourceConnector, end);
		                var targetConnectorSide = this._connectorSide(targetConnector, start);
		                var deltaX = end.x - start.x;
		                var deltaY = end.y - start.y;
		                var sameSideDistance = this._sameSideDistance(sourceConnector);
		                var result = [];
		                var pointX, pointY;
	
		                if (sourceConnectorSide === TOP || sourceConnectorSide == BOTTOM) {
		                    if (targetConnectorSide == TOP || targetConnectorSide == BOTTOM) {
		                        if (sourceConnectorSide == targetConnectorSide) {
		                            if (sourceConnectorSide == TOP) {
		                                pointY = Math.min(start.y, end.y) - sameSideDistance;
		                            } else {
		                                pointY = Math.max(start.y, end.y) + sameSideDistance;
		                            }
		                            result = [new Point(start.x, pointY), new Point(end.x, pointY)];
		                        } else {
		                            result = [new Point(start.x, start.y + deltaY / 2), new Point(end.x, start.y + deltaY / 2)];
		                        }
		                    } else {
		                        result = [new Point(start.x, end.y)];
		                    }
		                } else {
		                    if (targetConnectorSide == LEFT || targetConnectorSide == RIGHT) {
		                        if (sourceConnectorSide == targetConnectorSide) {
		                            if (sourceConnectorSide == LEFT) {
		                                pointX = Math.min(start.x, end.x) - sameSideDistance;
		                            } else {
		                                pointX = Math.max(start.x, end.x) + sameSideDistance;
		                            }
		                            result = [new Point(pointX, start.y), new Point(pointX, end.y)];
		                        } else {
		                            result = [new Point(start.x + deltaX / 2, start.y), new Point(start.x + deltaX / 2, start.y + deltaY)];
		                        }
		                    } else {
		                        result = [new Point(end.x, start.y)];
		                    }
		                }
		                return result;
		            },
	
		            _floatingPoints: function(start, end, sourceConnector) {
		                var sourceConnectorSide = sourceConnector ? this._connectorSide(sourceConnector, end) : null;
		                var cascadeStartHorizontal = this._startHorizontal(start, end, sourceConnectorSide);
		                var points = [start, start, end, end];
		                var deltaX = end.x - start.x;
		                var deltaY = end.y - start.y;
		                var length = points.length;
		                var shiftX;
		                var shiftY;
	
		                // note that this is more generic than needed for only two intermediate points.
		                for (var idx = 1; idx < length - 1; ++idx) {
		                    if (cascadeStartHorizontal) {
		                        if (idx % 2 !== 0) {
		                            shiftX = deltaX / (length / 2);
		                            shiftY = 0;
		                        }
		                        else {
		                            shiftX = 0;
		                            shiftY = deltaY / ((length - 1) / 2);
		                        }
		                    }
		                    else {
		                        if (idx % 2 !== 0) {
		                            shiftX = 0;
		                            shiftY = deltaY / (length / 2);
		                        }
		                        else {
		                            shiftX = deltaX / ((length - 1) / 2);
		                            shiftY = 0;
		                        }
		                    }
		                    points[idx] = new Point(points[idx - 1].x + shiftX, points[idx - 1].y + shiftY);
		                }
		                // need to fix the wrong 1.5 factor of the last intermediate point
		                idx--;
		                if ((cascadeStartHorizontal && (idx % 2 !== 0)) || (!cascadeStartHorizontal && (idx % 2 === 0))) {
		                    points[length - 2] = new Point(points[length - 1].x, points[length - 2].y);
		                } else {
		                    points[length - 2] = new Point(points[length - 2].x, points[length - 1].y);
		                }
	
		                return [points[1], points[2]];
		            },
	
		            _startHorizontal: function (start, end, sourceSide) {
		                var horizontal;
		                if (sourceSide !== null && (sourceSide === RIGHT || sourceSide === LEFT)) {
		                    horizontal = true;
		                } else {
		                    horizontal = Math.abs(start.x - end.x) > Math.abs(start.y - end.y);
		                }
	
		                return horizontal;
		            }
		        });
	
		// Adorners =========================================
	
		        var AdornerBase = Class.extend({
		            init: function (diagram, options) {
		                var that = this;
		                that.diagram = diagram;
		                that.options = deepExtend({}, that.options, options);
		                that.visual = new Group();
		                that.diagram._adorners.push(that);
		            },
		            refresh: function () {
	
		            }
		        });
	
		        var ConnectionEditAdorner = AdornerBase.extend({
		            init: function (connection, options) {
		                var that = this, diagram;
		                that.connection = connection;
		                diagram = that.connection.diagram;
		                that._ts = diagram.toolService;
		                AdornerBase.fn.init.call(that, diagram, options);
		                var sp = that.connection.sourcePoint();
		                var tp = that.connection.targetPoint();
		                that.spVisual = new Circle(deepExtend(that.options.handles, { center: sp }));
		                that.epVisual = new Circle(deepExtend(that.options.handles, { center: tp }));
		                that.visual.append(that.spVisual);
		                that.visual.append(that.epVisual);
		            },
	
		            options: {
		                handles: {}
		            },
	
		            _getCursor: function () {
		                return Cursors.move;
		            },
	
		            start: function (p) {
		                this.handle = this._hitTest(p);
		                this.startPoint = p;
		                this._initialSource = this.connection.source();
		                this._initialTarget = this.connection.target();
		                switch (this.handle) {
		                    case -1:
		                        if (this.connection.targetConnector) {
		                            this._ts._connectionManipulation(this.connection, this.connection.targetConnector.shape);
		                        }
		                        break;
		                    case 1:
		                        if (this.connection.sourceConnector) {
		                            this._ts._connectionManipulation(this.connection, this.connection.sourceConnector.shape);
		                        }
		                        break;
		                }
		            },
	
		            move: function (handle, p) {
		                switch (handle) {
		                    case -1:
		                        this.connection.source(p);
		                        break;
		                    case 1:
		                        this.connection.target(p);
		                        break;
		                    default:
		                        var delta = p.minus(this.startPoint);
		                        this.startPoint = p;
		                        if (!this.connection.sourceConnector) {
		                            this.connection.source(this.connection.sourcePoint().plus(delta));
		                        }
		                        if (!this.connection.targetConnector) {
		                            this.connection.target(this.connection.targetPoint().plus(delta));
		                        }
		                        break;
		                }
		                this.refresh();
		                return true;
		            },
	
		            stop: function (p) {
		                var ts = this.diagram.toolService, item = ts.hoveredItem, target;
		                if (ts._hoveredConnector) {
		                    target = ts._hoveredConnector._c;
		                } else if (item && item instanceof diagram.Shape) {
		                    target = item.getConnector(AUTO) || item.getConnector(p);
		                } else {
		                    target = p;
		                }
	
		                if (this.handle === -1) {
		                    this.connection.source(target);
		                } else if (this.handle === 1) {
		                    this.connection.target(target);
		                }
	
		                this.handle = undefined;
		                this._ts._connectionManipulation();
		                return new ConnectionEditUndoUnit(this.connection, this._initialSource, this._initialTarget);
		            },
	
		            _hitTest: function (point) {
		                var sourcePoint = this.connection.sourcePoint();
		                var targetPoint = this.connection.targetPoint();
		                var radiusX = this.options.handles.width / 2 + HIT_TEST_DISTANCE;
		                var radiusY = this.options.handles.height / 2 + HIT_TEST_DISTANCE;
		                var sourcePointDistance = sourcePoint.distanceTo(point);
		                var targetPointDistance = targetPoint.distanceTo(point);
		                var sourceHandle = new Rect(sourcePoint.x, sourcePoint.y).inflate(radiusX, radiusY).contains(point);
		                var targetHandle = new Rect(targetPoint.x, targetPoint.y).inflate(radiusX, radiusY).contains(point);
		                var handle = 0;
	
		                if (sourceHandle && (!targetHandle || sourcePointDistance < targetPointDistance)) {
		                    handle = -1;
		                } else if (targetHandle && (!sourceHandle || targetPointDistance < sourcePointDistance)) {
		                    handle = 1;
		                }
	
		                return handle;
		            },
	
		            refresh: function () {
		                this.spVisual.redraw({ center: this.diagram.modelToLayer(this.connection.sourcePoint()) });
		                this.epVisual.redraw({ center: this.diagram.modelToLayer(this.connection.targetPoint()) });
		            }
		        });
	
		        var ConnectorsAdorner = AdornerBase.extend({
		            init: function (diagram, options) {
		                var that = this;
		                AdornerBase.fn.init.call(that, diagram, options);
		                that._refreshHandler = function (e) {
		                    if (e.item == that.shape) {
		                        that.refresh();
		                    }
		                };
		            },
	
		            show: function (shape) {
		                var that = this, len, i, ctr;
		                that._visible = true;
		                that.shape = shape;
		                that.diagram.bind(ITEMBOUNDSCHANGE, that._refreshHandler);
		                len = shape.connectors.length;
		                that.connectors = [];
		                that._clearVisual();
		                for (i = 0; i < len; i++) {
		                    ctr = new ConnectorVisual(shape.connectors[i]);
		                    that.connectors.push(ctr);
		                    that.visual.append(ctr.visual);
		                }
		                that.visual.visible(true);
		                that.refresh();
		            },
	
		            _clearVisual: function() {
		                var that = this;                
		                if(that.diagram._cachedTouchTarget) {
		                    that._keepCachedTouchTarget();
		                } else {
		                    that.visual.clear();
		                }
		            },
		            
		            _keepCachedTouchTarget: function () {
		                var that = this,
		                    visualChildren = that.visual.children;                      
		                var childrenCount = visualChildren.length;
		                var index = inArray(that.diagram._cachedTouchTarget, visualChildren);
		                for (var i = childrenCount - 1; i >= 0; i--) {
		                    if(i == index) {
		                        continue;
		                    }
		                    that.visual.remove(visualChildren[i]);
		                }
		            },
	
		            destroy: function () {
		                var that = this;
		                that.diagram.unbind(ITEMBOUNDSCHANGE, that._refreshHandler);
		                that.shape = undefined;
		                that._visible = undefined;
		                that.visual.visible(false);
		            },
	
		            _hitTest: function (p) {
		                var ctr, i;
		                for (i = 0; i < this.connectors.length; i++) {
		                    ctr = this.connectors[i];
		                    if (ctr._hitTest(p)) {
		                        ctr._hover(true);
		                        this.diagram.toolService._hoveredConnector = ctr;
		                        break;
		                    }
		                }
		            },
	
		            refresh: function () {
		                if (this.shape) {
		                    var bounds = this.shape.bounds();
		                        bounds = this.diagram.modelToLayer(bounds);
		                    this.visual.position(bounds.topLeft());
		                    $.each(this.connectors, function () {
		                        this.refresh();
		                    });
		                }
		            }
		        });
	
		        function hitToOppositeSide(hit, bounds) {
		            var result;
	
		            if (hit.x == -1 && hit.y == -1) {
		                result = bounds.bottomRight();
		            } else if (hit.x == 1 && hit.y == 1) {
		                result = bounds.topLeft();
		            } else if (hit.x == -1 && hit.y == 1) {
		                result = bounds.topRight();
		            } else if (hit.x == 1 && hit.y == -1) {
		                result = bounds.bottomLeft();
		            } else if (hit.x === 0 && hit.y == -1) {
		                result = bounds.bottom();
		            } else if (hit.x === 0 && hit.y == 1) {
		                result = bounds.top();
		            } else if (hit.x == 1 && hit.y === 0) {
		                result = bounds.left();
		            } else if (hit.x == -1 && hit.y === 0) {
		                result = bounds.right();
		            }
	
		            return result;
		        }
	
		        var ResizingAdorner = AdornerBase.extend({
		            init: function (diagram, options) {
		                var that = this;
		                AdornerBase.fn.init.call(that, diagram, options);
		                that._manipulating = false;
		                that.map = [];
		                that.shapes = [];
	
		                that._initSelection();
		                that._createHandles();
		                that.redraw();
		                that.diagram.bind("select", function (e) {
		                    that._initialize(e.selected);
		                });
	
		                that._refreshHandler = function () {
		                    if (!that._internalChange) {
		                        that.refreshBounds();
		                        that.refresh();
		                    }
		                };
	
		                that._rotatedHandler = function () {
		                    if (that.shapes.length == 1) {
		                        that._angle = that.shapes[0].rotate().angle;
		                    }
		                    that._refreshHandler();
		                };
	
		                that.diagram.bind(ITEMBOUNDSCHANGE, that._refreshHandler).bind(ITEMROTATE, that._rotatedHandler);
		                that.refreshBounds();
		                that.refresh();
		            },
	
		            options: {
		                handles: {
		                    fill: {
		                        color: "#fff"
		                    },
		                    stroke: {
		                        color: "#282828"
		                    },
		                    height: 7,
		                    width: 7,
		                    hover: {
		                        fill: {
		                            color: "#282828"
		                        },
		                        stroke: {
		                            color: "#282828"
		                        }
		                    }
		                },
		                selectable: {
		                    stroke: {
		                        color: "#778899",
		                        width: 1,
		                        dashType: "dash"
		                    },
		                    fill: {
		                        color: TRANSPARENT
		                    }
		                },
		                offset: 10
		            },
	
		            _initSelection: function() {
		                var that = this;
		                var diagram = that.diagram;
		                var selectable = diagram.options.selectable;
		                var options = deepExtend({}, that.options.selectable, selectable);
		                that.rect = new Rectangle(options);
		                that.visual.append(that.rect);
		            },
	
		            _resizable: function() {
		                return this.options.editable && this.options.editable.resize !== false;
		            },
	
		            _handleOptions: function() {
		                return (this.options.editable.resize || {}).handles || this.options.handles;
		            },
	
		            _createHandles: function() {
		                var handles, item, y, x;
	
		                if (this._resizable()) {
		                    handles = this._handleOptions();
		                    for (x = -1; x <= 1; x++) {
		                        for (y = -1; y <= 1; y++) {
		                            if ((x !== 0) || (y !== 0)) { // (0, 0) element, (-1, -1) top-left, (+1, +1) bottom-right
		                                item = new Rectangle(handles);
		                                item.drawingElement._hover = proxy(this._hover, this);
		                                this.map.push({ x: x, y: y, visual: item });
		                                this.visual.append(item);
		                            }
		                        }
		                    }
		                }
		            },
	
		            bounds: function (value) {
		                if (value) {
		                    this._innerBounds = value.clone();
		                    this._bounds = this.diagram.modelToLayer(value).inflate(this.options.offset, this.options.offset);
		                } else {
		                    return this._bounds;
		                }
		            },
	
		            _hitTest: function (p) {
		                var tp = this.diagram.modelToLayer(p),
		                    i, hit, handleBounds, handlesCount = this.map.length, handle;
	
		                if (this._angle) {
		                    tp = tp.clone().rotate(this._bounds.center(), this._angle);
		                }
	
		                if (this._resizable()) {
		                    for (i = 0; i < handlesCount; i++) {
		                        handle = this.map[i];
		                        hit = new Point(handle.x, handle.y);
		                        handleBounds = this._getHandleBounds(hit); //local coordinates
		                        handleBounds.offset(this._bounds.x, this._bounds.y);
		                        if (handleBounds.contains(tp)) {
		                            return hit;
		                        }
		                    }
		                }
	
		                if (this._bounds.contains(tp)) {
		                    return new Point(0, 0);
		                }
		            },
	
		            _getHandleBounds: function (p) {
		                if (this._resizable()) {
		                    var handles = this._handleOptions(),
		                        w = handles.width,
		                        h = handles.height,
		                        r = new Rect(0, 0, w, h);
	
		                    if (p.x < 0) {
		                        r.x = - w / 2;
		                    } else if (p.x === 0) {
		                        r.x = Math.floor(this._bounds.width / 2) - w / 2;
		                    } else if (p.x > 0) {
		                        r.x = this._bounds.width + 1.0 - w / 2;
		                    } if (p.y < 0) {
		                        r.y = - h / 2;
		                    } else if (p.y === 0) {
		                        r.y = Math.floor(this._bounds.height / 2) - h / 2;
		                    } else if (p.y > 0) {
		                        r.y = this._bounds.height + 1.0 - h / 2;
		                    }
	
		                    return r;
		                }
		            },
	
		            _getCursor: function (point) {
		                var hit = this._hitTest(point);
		                if (hit && (hit.x >= -1) && (hit.x <= 1) && (hit.y >= -1) && (hit.y <= 1) && this._resizable()) {
		                    var angle = this._angle;
		                    if (angle) {
		                        angle = 360 - angle;
		                        hit.rotate(new Point(0, 0), angle);
		                        hit = new Point(Math.round(hit.x), Math.round(hit.y));
		                    }
	
		                    if (hit.x == -1 && hit.y == -1) {
		                        return "nw-resize";
		                    }
		                    if (hit.x == 1 && hit.y == 1) {
		                        return "se-resize";
		                    }
		                    if (hit.x == -1 && hit.y == 1) {
		                        return "sw-resize";
		                    }
		                    if (hit.x == 1 && hit.y == -1) {
		                        return "ne-resize";
		                    }
		                    if (hit.x === 0 && hit.y == -1) {
		                        return "n-resize";
		                    }
		                    if (hit.x === 0 && hit.y == 1) {
		                        return "s-resize";
		                    }
		                    if (hit.x == 1 && hit.y === 0) {
		                        return "e-resize";
		                    }
		                    if (hit.x == -1 && hit.y === 0) {
		                        return "w-resize";
		                    }
		                }
		                return this._manipulating ? Cursors.move : Cursors.select;
		            },
	
		            _initialize: function() {
		                var that = this, i, item,
		                    items = that.diagram.select();
	
		                that.shapes = [];
		                for (i = 0; i < items.length; i++) {
		                    item = items[i];
		                    if (item instanceof diagram.Shape) {
		                        that.shapes.push(item);
		                        item._rotationOffset = new Point();
		                    }
		                }
	
		                that._angle = that.shapes.length == 1 ? that.shapes[0].rotate().angle : 0;
		                that._startAngle = that._angle;
		                that._rotates();
		                that._positions();
		                that.refreshBounds();
		                that.refresh();
		                that.redraw();
		            },
	
		            _rotates: function () {
		                var that = this, i, shape;
		                that.initialRotates = [];
		                for (i = 0; i < that.shapes.length; i++) {
		                    shape = that.shapes[i];
		                    that.initialRotates.push(shape.rotate().angle);
		                }
		            },
	
		            _positions: function () {
		                var that = this, i, shape;
		                that.initialStates = [];
		                for (i = 0; i < that.shapes.length; i++) {
		                    shape = that.shapes[i];
		                    that.initialStates.push(shape.bounds());
		                }
		            },
	
		            _hover: function(value, element) {
		                if (this._resizable()) {
		                    var handleOptions = this._handleOptions(),
		                        hover = handleOptions.hover,
		                        stroke = handleOptions.stroke,
		                        fill = handleOptions.fill;
	
		                    if (value && Utils.isDefined(hover.stroke)) {
		                        stroke = deepExtend({}, stroke, hover.stroke);
		                    }
	
		                    if (value && Utils.isDefined(hover.fill)) {
		                        fill = hover.fill;
		                    }
		                    element.stroke(stroke.color, stroke.width, stroke.opacity);
		                    element.fill(fill.color, fill.opacity);
		                }
		            },
	
		            start: function (p) {
		                this._sp = p;
		                this._cp = p;
		                this._lp = p;
		                this._manipulating = true;
		                this._internalChange = true;
		                this.shapeStates = [];
		                for (var i = 0; i < this.shapes.length; i++) {
		                    var shape = this.shapes[i];
		                    this.shapeStates.push(shape.bounds());
		                }
		            },
	
		            redraw: function () {
		                var i, handle,
		                    visibleHandles = this._resizable();
	
		                for (i = 0; i < this.map.length; i++) {
		                    handle = this.map[i];
		                    handle.visual.visible(visibleHandles);
		                }
		            },
	
		            angle: function(value) {
		                if (defined(value)) {
		                    this._angle = value;
		                }
	
		                return this._angle;
		            },
	
		            rotate: function() {
		                var center = this._innerBounds.center();
		                var currentAngle = this.angle();
		                this._internalChange = true;
		                for (var i = 0; i < this.shapes.length; i++) {
		                    var shape = this.shapes[i];
		                    currentAngle = (currentAngle + this.initialRotates[i] - this._startAngle) % 360;
		                    shape.rotate(currentAngle, center);
		                }
		                this.refresh();
		            },
	
		            move: function (handle, p) {
		                var delta, dragging,
		                    dtl = new Point(),
		                    dbr = new Point(),
		                    bounds, center, shape,
		                    i, angle, newBounds,
		                    changed = 0, staticPoint,
		                    scaleX, scaleY;
	
		                if (handle.y === -2 && handle.x === -1) {
		                    center = this._innerBounds.center();
		                    this._angle = this._truncateAngle(Utils.findAngle(center, p));
		                    for (i = 0; i < this.shapes.length; i++) {
		                        shape = this.shapes[i];
		                        angle = (this._angle + this.initialRotates[i] - this._startAngle) % 360;
		                        shape.rotate(angle, center);
		                        if (shape.hasOwnProperty("layout")) {
		                            shape.layout(shape);
		                        }
		                        this._rotating = true;
		                    }
		                    this.refresh();
		                } else {
		                    if (this.shouldSnap()) {
		                        var thr = this._truncateDistance(p.minus(this._lp));
		                        // threshold
		                        if (thr.x === 0 && thr.y === 0) {
		                            this._cp = p;
		                            return;
		                        }
		                        delta = thr;
		                        this._lp = new Point(this._lp.x + thr.x, this._lp.y + thr.y);
		                    } else {
		                        delta = p.minus(this._cp);
		                    }
	
		                    if (this.isDragHandle(handle)) {
		                        dbr = dtl = delta; // dragging
		                        dragging = true;
		                    } else {
		                        if (this._angle) { // adjust the delta so that resizers resize in the correct direction after rotation.
		                            delta.rotate(new Point(0, 0), this._angle);
		                        }
		                        if (handle.x == -1) {
		                            dtl.x = delta.x;
		                        } else if (handle.x == 1) {
		                            dbr.x = delta.x;
		                        }
		                        if (handle.y == -1) {
		                            dtl.y = delta.y;
		                        } else if (handle.y == 1) {
		                            dbr.y = delta.y;
		                        }
		                    }
	
		                    if (!dragging) {
		                        staticPoint = hitToOppositeSide(handle, this._innerBounds);
		                        scaleX = (this._innerBounds.width + delta.x * handle.x) / this._innerBounds.width;
		                        scaleY = (this._innerBounds.height + delta.y * handle.y) / this._innerBounds.height;
		                    }
	
		                    for (i = 0; i < this.shapes.length; i++) {
		                        shape = this.shapes[i];
		                        bounds = shape.bounds();
		                        if (dragging) {
		                            if (!canDrag(shape)) {
		                                continue;
		                            }
		                            newBounds = this._displaceBounds(bounds, dtl, dbr, dragging);
		                        } else {
		                            newBounds = bounds.clone();
		                            newBounds.scale(scaleX, scaleY, staticPoint, this._innerBounds.center(), shape.rotate().angle);
		                            var newCenter = newBounds.center(); // fixes the new rotation center.
		                            newCenter.rotate(bounds.center(), -this._angle);
		                            newBounds = new Rect(newCenter.x - newBounds.width / 2, newCenter.y - newBounds.height / 2, newBounds.width, newBounds.height);
		                        }
		                        if (newBounds.width >= shape.options.minWidth && newBounds.height >= shape.options.minHeight) { // if we up-size very small shape
		                            var oldBounds = bounds;
		                            shape.bounds(newBounds);
		                            if (shape.hasOwnProperty("layout")) {
		                                shape.layout(shape, oldBounds, newBounds);
		                            }
		                            if (oldBounds.width !== newBounds.width || oldBounds.height !== newBounds.height) {
		                                shape.rotate(shape.rotate().angle); // forces the rotation to update it's rotation center
		                            }
		                            changed += 1;
		                        }
		                    }
	
		                    if (changed) {
		                        if (changed == i) {
		                            newBounds = this._displaceBounds(this._innerBounds, dtl, dbr, dragging);
		                            this.bounds(newBounds);
		                        } else {
		                            this.refreshBounds();
		                        }
		                        this.refresh();
		                    }
	
		                    this._positions();
		                }
	
		                this._cp = p;
		            },
	
		            isDragHandle: function(handle) {
		                return handle.x === 0 && handle.y === 0;
		            },
	
		            cancel: function() {
		                var shapes = this.shapes;
		                var states = this.shapeStates;
		                for (var idx = 0; idx < shapes.length; idx++) {
		                    shapes[idx].bounds(states[idx]);
		                }
		                this.refreshBounds();
		                this.refresh();
		                this._manipulating = undefined;
		                this._internalChange = undefined;
		                this._rotating = undefined;
		            },
	
		            _truncatePositionToGuides: function (bounds) {
		                if (this.diagram.ruler) {
		                    return this.diagram.ruler.truncatePositionToGuides(bounds);
		                }
		                return bounds;
		            },
	
		            _truncateSizeToGuides: function (bounds) {
		                if (this.diagram.ruler) {
		                    return this.diagram.ruler.truncateSizeToGuides(bounds);
		                }
		                return bounds;
		            },
	
		            _truncateAngle: function (a) {
		                var snap = this.snapOptions();
		                var snapAngle = Math.max(snap.angle || DEFAULT_SNAP_ANGLE, MIN_SNAP_ANGLE);
		                return snap ? Math.floor((a % 360) / snapAngle) * snapAngle : (a % 360);
		            },
	
		            _truncateDistance: function (d) {
		                if (d instanceof diagram.Point) {
		                    return new diagram.Point(this._truncateDistance(d.x), this._truncateDistance(d.y));
		                } else {
		                    var snap = this.snapOptions() || {};
		                    var snapSize = Math.max(snap.size || DEFAULT_SNAP_SIZE, MIN_SNAP_SIZE);
		                    return snap ? Math.floor(d / snapSize) * snapSize : d;
		                }
		            },
	
		            snapOptions: function() {
		                var editable = this.diagram.options.editable;
		                var snap = ((editable || {}).drag || {}).snap || {};
		                return snap;
		            },
	
		            shouldSnap: function() {
		                var editable = this.diagram.options.editable;
		                var drag = (editable || {}).drag;
		                var snap = (drag || {}).snap;
		                return editable !== false && drag !== false && snap !== false;
		            },
	
		            _displaceBounds: function (bounds, dtl, dbr, dragging) {
		                var tl = bounds.topLeft().plus(dtl),
		                    br = bounds.bottomRight().plus(dbr),
		                    newBounds = Rect.fromPoints(tl, br),
		                    newCenter;
		                if (!dragging) {
		                    newCenter = newBounds.center();
		                    newCenter.rotate(bounds.center(), -this._angle);
		                    newBounds = new Rect(newCenter.x - newBounds.width / 2, newCenter.y - newBounds.height / 2, newBounds.width, newBounds.height);
		                }
		                return newBounds;
		            },
	
		            stop: function () {
		                var unit, i, shape;
		                if (this._cp != this._sp) {
		                    if (this._rotating) {
		                        unit = new RotateUnit(this, this.shapes, this.initialRotates);
		                        this._rotating = false;
		                    } else if (this._diffStates()) {
		                        if (this.diagram.ruler) {
		                            for (i = 0; i < this.shapes.length; i++) {
		                                shape = this.shapes[i];
		                                var bounds = shape.bounds();
		                                bounds = this._truncateSizeToGuides(this._truncatePositionToGuides(bounds));
		                                shape.bounds(bounds);
		                                this.refreshBounds();
		                                this.refresh();
		                            }
		                        }
		                        for (i = 0; i < this.shapes.length; i++) {
		                            shape = this.shapes[i];
		                            shape.updateModel();
		                        }
		                        unit = new TransformUnit(this.shapes, this.shapeStates, this);
		                        this.diagram._syncShapeChanges();
		                    }
		                }
	
		                this._manipulating = undefined;
		                this._internalChange = undefined;
		                this._rotating = undefined;
		                return unit;
		            },
	
		            _diffStates: function() {
		                var shapes = this.shapes;
		                var states = this.shapeStates;
		                for (var idx = 0; idx < shapes.length; idx++) {
		                    if (!shapes[idx].bounds().equals(states[idx])) {
		                        return true;
		                    }
		                }
		                return false;
		            },
	
		            refreshBounds: function () {
		                var bounds = this.shapes.length == 1 ?
		                    this.shapes[0].bounds().clone() :
		                    this.diagram.boundingBox(this.shapes, true);
	
		                this.bounds(bounds);
		            },
	
		            refresh: function () {
		                var that = this, b, bounds;
		                if (this.shapes.length > 0) {
		                    bounds = this.bounds();
		                    this.visual.visible(true);
		                    this.visual.position(bounds.topLeft());
		                    $.each(this.map, function () {
		                        b = that._getHandleBounds(new Point(this.x, this.y));
		                        this.visual.position(b.topLeft());
		                    });
		                    this.visual.position(bounds.topLeft());
	
		                    var center = new Point(bounds.width / 2, bounds.height / 2);
		                    this.visual.rotate(this._angle, center);
		                    this.rect.redraw({ width: bounds.width, height: bounds.height });
		                    if (this.rotationThumb) {
		                        var thumb = this.options.editable.rotate.thumb;
		                        this._rotationThumbBounds = new Rect(bounds.center().x, bounds.y + thumb.y, 0, 0).inflate(thumb.width);
		                        this.rotationThumb.redraw({ x: bounds.width / 2 - thumb.width / 2 });
		                    }
		                } else {
		                    this.visual.visible(false);
		                }
		            }
		        });
	
		        var Selector = Class.extend({
		            init: function (diagram) {
		                var selectable = diagram.options.selectable;
		                this.options = deepExtend({}, this.options, selectable);
	
		                this.visual = new Rectangle(this.options);
		                this.diagram = diagram;
		            },
		            options: {
		                stroke: {
		                    color: "#778899",
		                    width: 1,
		                    dashType: "dash"
		                },
		                fill: {
		                    color: TRANSPARENT
		                }
		            },
		            start: function (p) {
		                this._sp = this._ep = p;
		                this.refresh();
		                this.diagram._adorn(this, true);
		            },
		            end: function () {
		                this._sp = this._ep = undefined;
		                this.diagram._adorn(this, false);
		            },
		            bounds: function (value) {
		                if (value) {
		                    this._bounds = value;
		                }
		                return this._bounds;
		            },
		            move: function (p) {
		                this._ep = p;
		                this.refresh();
		            },
		            refresh: function () {
		                if (this._sp) {
		                    var visualBounds = Rect.fromPoints(this.diagram.modelToLayer(this._sp), this.diagram.modelToLayer(this._ep));
		                    this.bounds(Rect.fromPoints(this._sp, this._ep));
		                    this.visual.position(visualBounds.topLeft());
		                    this.visual.redraw({ height: visualBounds.height + 1, width: visualBounds.width + 1 });
		                }
		            }
		        });
	
		        var ConnectorVisual = Class.extend({
		            init: function (connector) {
		                this.options = deepExtend({}, connector.options);
		                this._c = connector;
		                this.visual = new Circle(this.options);
		                this.refresh();
		            },
		            _hover: function (value) {
		                var options = this.options,
		                    hover = options.hover,
		                    stroke = options.stroke,
		                    fill = options.fill;
	
		                if (value && Utils.isDefined(hover.stroke)) {
		                    stroke = deepExtend({}, stroke, hover.stroke);
		                }
	
		                if (value && Utils.isDefined(hover.fill)) {
		                    fill = hover.fill;
		                }
	
		                this.visual.redraw({
		                    stroke: stroke,
		                    fill: fill
		                });
		            },
		            refresh: function () {
		                var p = this._c.shape.diagram.modelToView(this._c.position()),
		                    relative = p.minus(this._c.shape.bounds("transformed").topLeft()),
		                    value = new Rect(p.x, p.y, 0, 0);
		                value.inflate(this.options.width / 2, this.options.height / 2);
		                this._visualBounds = value;
		                this.visual.redraw({ center: new Point(relative.x, relative.y) });
		            },
		            _hitTest: function (p) {
		                var tp = this._c.shape.diagram.modelToView(p);
		                return this._visualBounds.contains(tp);
		            }
		        });
	
		        function canDrag(element) {
		            var editable = element.options.editable;
		            return editable && editable.drag !== false;
		        }
	
		        function hitTestShapeConnectors(shape, point) {
		            var connector, position, rect;
		            for (var idx = 0; idx < shape.connectors.length; idx++) {
		                connector = shape.connectors[idx];
		                position = connector.position();
		                rect = new Rect(position.x, position.y);
		                rect.inflate(HIT_TEST_DISTANCE, HIT_TEST_DISTANCE);
		                if (rect.contains(point)) {
		                    return connector;
		                }
		            }
		        }
	
		        function noMeta(meta) {
		            return meta.ctrlKey === false && meta.altKey === false && meta.shiftKey === false;
		        }
	
		        deepExtend(diagram, {
		            CompositeUnit: CompositeUnit,
		            TransformUnit: TransformUnit,
		            PanUndoUnit: PanUndoUnit,
		            AddShapeUnit: AddShapeUnit,
		            AddConnectionUnit: AddConnectionUnit,
		            DeleteShapeUnit: DeleteShapeUnit,
		            DeleteConnectionUnit: DeleteConnectionUnit,
		            ConnectionEditAdorner: ConnectionEditAdorner,
		            ConnectionTool: ConnectionTool,
		            ConnectorVisual: ConnectorVisual,
		            UndoRedoService: UndoRedoService,
		            ResizingAdorner: ResizingAdorner,
		            Selector: Selector,
		            ToolService: ToolService,
		            ConnectorsAdorner: ConnectorsAdorner,
		            LayoutUndoUnit: LayoutUndoUnit,
		            ConnectionEditUnit: ConnectionEditUnit,
		            ToFrontUnit: ToFrontUnit,
		            ToBackUnit: ToBackUnit,
		            ConnectionRouterBase: ConnectionRouterBase,
		            PolylineRouter: PolylineRouter,
		            CascadingRouter: CascadingRouter,
		            SelectionTool: SelectionTool,
		            ScrollerTool: ScrollerTool,
		            PointerTool: PointerTool,
		            ConnectionEditTool: ConnectionEditTool,
		            RotateUnit: RotateUnit
		        });
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(876);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 876:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(877) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		(function ($, undefined) {
		    var kendo = window.kendo,
		        diagram = kendo.dataviz.diagram,
		        Graph = diagram.Graph,
		        Node = diagram.Node,
		        Link = diagram.Link,
		        deepExtend = kendo.deepExtend,
		        Size = diagram.Size,
		        Rect = diagram.Rect,
		        Dictionary = diagram.Dictionary,
		        Set = diagram.Set,
		        HyperTree = diagram.Graph,
		        Utils = diagram.Utils,
		        Point = diagram.Point,
		        EPSILON = 1e-06,
		        DEG_TO_RAD = Math.PI / 180,
		        contains = Utils.contains,
		        grep = $.grep;
	
		    /**
		     * Base class for layout algorithms.
		     * @type {*}
		     */
		    var LayoutBase = kendo.Class.extend({
		        defaultOptions: {
		            type: "Tree",
		            subtype: "Down",
		            roots: null,
		            animate: false,
		            //-------------------------------------------------------------------
		            /**
		             * Force-directed option: whether the motion of the nodes should be limited by the boundaries of the diagram surface.
		             */
		            limitToView: false,
		            /**
		             * Force-directed option: the amount of friction applied to the motion of the nodes.
		             */
		            friction: 0.9,
		            /**
		             * Force-directed option: the optimal distance between nodes (minimum energy).
		             */
		            nodeDistance: 50,
		            /**
		             * Force-directed option: the number of time things are being calculated.
		             */
		            iterations: 300,
		            //-------------------------------------------------------------------
		            /**
		             * Tree option: the separation in one direction (depends on the subtype what direction this is).
		             */
		            horizontalSeparation: 90,
		            /**
		             * Tree option: the separation in the complementary direction (depends on the subtype what direction this is).
		             */
		            verticalSeparation: 50,
	
		            //-------------------------------------------------------------------
		            /**
		             * Tip-over tree option: children-to-parent vertical distance.
		             */
		            underneathVerticalTopOffset: 15,
		            /**
		             * Tip-over tree option: children-to-parent horizontal distance.
		             */
		            underneathHorizontalOffset: 15,
		            /**
		             * Tip-over tree option: leaf-to-next-branch vertical distance.
		             */
		            underneathVerticalSeparation: 15,
		            //-------------------------------------------------------------------
		            /**
		             * Settings object to organize the different components of the diagram in a grid layout structure
		             */
		            grid: {
		                /**
		                 * The width of the grid in which components are arranged. Beyond this width a component will be on the next row.
		                 */
		                width: 1500,
		                /**
		                 * The left offset of the grid.
		                 */
		                offsetX: 50,
		                /**
		                 * The top offset of the grid.
		                 */
		                offsetY: 50,
		                /**
		                 * The horizontal padding within a cell of the grid where a single component resides.
		                 */
		                componentSpacingX: 20,
		                /**
		                 * The vertical padding within a cell of the grid where a single component resides.
		                 */
		                componentSpacingY: 20
		            },
	
		            //-------------------------------------------------------------------
		            /**
		             * Layered option: the separation height/width between the layers.
		             */
		            layerSeparation: 50,
		            /**
		             * Layered option: how many rounds of shifting and fine-tuning.
		             */
		            layeredIterations: 2,
		            /**
		             * Tree-radial option: the angle at which the layout starts.
		             */
		            startRadialAngle: 0,
		            /**
		             * Tree-radial option: the angle at which the layout starts.
		             */
		            endRadialAngle: 360,
		            /**
		             * Tree-radial option: the separation between levels.
		             */
		            radialSeparation: 150,
		            /**
		             * Tree-radial option: the separation between the root and the first level.
		             */
		            radialFirstLevelSeparation: 200,
		            /**
		             * Tree-radial option: whether a virtual roots bing the components in one radial layout.
		             */
		            keepComponentsInOneRadialLayout: false,
		            //-------------------------------------------------------------------
	
		            // TODO: ensure to change this to false when containers are around
		            ignoreContainers: true,
		            layoutContainerChildren: false,
		            ignoreInvisible: true,
		            animateTransitions: false
		        },
		        init: function () {
		        },
	
		        /**
		         * Organizes the components in a grid.
		         * Returns the final set of nodes (not the Graph).
		         * @param components
		         */
		        gridLayoutComponents: function (components) {
		            if (!components) {
		                throw "No components supplied.";
		            }
	
		            // calculate and cache the bounds of the components
		            Utils.forEach(components, function (c) {
		                c.calcBounds();
		            });
	
		            // order by decreasing width
		            components.sort(function (a, b) {
		                return b.bounds.width - a.bounds.width;
		            });
	
		            var maxWidth = this.options.grid.width,
		                offsetX = this.options.grid.componentSpacingX,
		                offsetY = this.options.grid.componentSpacingY,
		                height = 0,
		                startX = this.options.grid.offsetX,
		                startY = this.options.grid.offsetY,
		                x = startX,
		                y = startY,
		                i,
		                resultLinkSet = [],
		                resultNodeSet = [];
	
		            while (components.length > 0) {
		                if (x >= maxWidth) {
		                    // start a new row
		                    x = startX;
		                    y += height + offsetY;
		                    // reset the row height
		                    height = 0;
		                }
		                var component = components.pop();
		                this.moveToOffset(component, new Point(x, y));
		                for (i = 0; i < component.nodes.length; i++) {
		                    resultNodeSet.push(component.nodes[i]); // to be returned in the end
		                }
		                for (i = 0; i < component.links.length; i++) {
		                    resultLinkSet.push(component.links[i]);
		                }
		                var boundingRect = component.bounds;
		                var currentHeight = boundingRect.height;
		                if (currentHeight <= 0 || isNaN(currentHeight)) {
		                    currentHeight = 0;
		                }
		                var currentWidth = boundingRect.width;
		                if (currentWidth <= 0 || isNaN(currentWidth)) {
		                    currentWidth = 0;
		                }
	
		                if (currentHeight >= height) {
		                    height = currentHeight;
		                }
		                x += currentWidth + offsetX;
		            }
	
		            return {
		                nodes: resultNodeSet,
		                links: resultLinkSet
		            };
		        },
	
		        moveToOffset: function (component, p) {
		            var i, j,
		                bounds = component.bounds,
		                deltax = p.x - bounds.x,
		                deltay = p.y - bounds.y;
	
		            for (i = 0; i < component.nodes.length; i++) {
		                var node = component.nodes[i];
		                var nodeBounds = node.bounds();
		                if (nodeBounds.width === 0 && nodeBounds.height === 0 && nodeBounds.x === 0 && nodeBounds.y === 0) {
		                    nodeBounds = new Rect(0, 0, 0, 0);
		                }
		                nodeBounds.x += deltax;
		                nodeBounds.y += deltay;
		                node.bounds(nodeBounds);
		            }
		            for (i = 0; i < component.links.length; i++) {
		                var link = component.links[i];
		                if (link.points) {
		                    var newpoints = [];
		                    var points = link.points;
		                    for (j = 0; j < points.length; j++) {
		                        var pt = points[j];
		                        pt.x += deltax;
		                        pt.y += deltay;
		                        newpoints.push(pt);
		                    }
		                    link.points = newpoints;
		                }
		            }
		            this.currentHorizontalOffset += bounds.width + this.options.grid.offsetX;
		            return new Point(deltax, deltay);
		        },
	
		        transferOptions: function (options) {
	
		            // Size options lead to stackoverflow and need special handling
	
		            this.options = kendo.deepExtend({}, this.defaultOptions);
		            if (Utils.isUndefined(options)) {
		                return;
		            }
	
		            this.options = kendo.deepExtend(this.options, options || {});
		        }
		    });
	
		    /**
		     * The data bucket a hypertree holds in its nodes.     *
		     * @type {*}
		     */
		    /* var ContainerGraph = kendo.Class.extend({
		     init: function (diagram) {
		     this.diagram = diagram;
		     this.graph = new Graph(diagram);
		     this.container = null;
		     this.containerNode = null;
		     }
	
		     });*/
	
		    /**
		     * Adapter between the diagram control and the graph representation. It converts shape and connections to nodes and edges taking into the containers and their collapsef state,
		     * the visibility of items and more. If the layoutContainerChildren is true a hypertree is constructed which holds the hierarchy of containers and many conditions are analyzed
		     * to investigate how the effective graph structure looks like and how the layout has to be performed.
		     * @type {*}
		     */
		    var DiagramToHyperTreeAdapter = kendo.Class.extend({
		        init: function (diagram) {
	
		            /**
		             * The mapping to/from the original nodes.
		             * @type {Dictionary}
		             */
		            this.nodeMap = new Dictionary();
	
		            /**
		             * Gets the mapping of a shape to a container in case the shape sits in a collapsed container.
		             * @type {Dictionary}
		             */
		            this.shapeMap = new Dictionary();
	
		            /**
		             * The nodes being mapped.
		             * @type {Dictionary}
		             */
		            this.nodes = [];
	
		            /**
		             * The connections being mapped.
		             * @type {Dictionary}
		             */
		            this.edges = [];
	
		            // the mapping from an edge to all the connections it represents, this can be both because of multiple connections between
		            // two shapes or because a container holds multiple connections to another shape or container.
		            this.edgeMap = new Dictionary();
	
		            /**
		             * The resulting set of Nodes when the analysis has finished.
		             * @type {Array}
		             */
		            this.finalNodes = [];
	
		            /**
		             * The resulting set of Links when the analysis has finished.
		             * @type {Array}
		             */
		            this.finalLinks = [];
	
		            /**
		             * The items being omitted because of multigraph edges.
		             * @type {Array}
		             */
		            this.ignoredConnections = [];
	
		            /**
		             * The items being omitted because of containers, visibility and other factors.
		             * @type {Array}
		             */
		            this.ignoredShapes = [];
	
		            /**
		             * The map from a node to the partition/hypernode in which it sits. This hyperMap is null if 'options.layoutContainerChildren' is false.
		             * @type {Dictionary}
		             */
		            this.hyperMap = new Dictionary();
	
		            /**
		             * The hypertree contains the hierarchy defined by the containers.
		             * It's in essence a Graph of Graphs with a tree structure defined by the hierarchy of containers.
		             * @type {HyperTree}
		             */
		            this.hyperTree = new Graph();
	
		            /**
		             * The resulting graph after conversion. Note that this does not supply the information contained in the
		             * ignored connection and shape collections.
		             * @type {null}
		             */
		            this.finalGraph = null;
	
		            this.diagram = diagram;
		        },
	
		        /**
		         * The hyperTree is used when the 'options.layoutContainerChildren' is true. It contains the hierarchy of containers whereby each node is a ContainerGraph.
		         * This type of node has a Container reference to the container which holds the Graph items. There are three possible situations during the conversion process:
		         *  - Ignore the containers: the container are non-existent and only normal shapes are mapped. If a shape has a connection to a container it will be ignored as well
		         *    since there is no node mapped for the container.
		         *  - Do not ignore the containers and leave the content of the containers untouched: the top-level elements are being mapped and the children within a container are not altered.
		         *  - Do not ignore the containers and organize the content of the containers as well: the hypertree is constructed and there is a partitioning of all nodes and connections into the hypertree.
		         *    The only reason a connection or node is not being mapped might be due to the visibility, which includes the visibility change through a collapsed parent container.
		         * @param options
		         */
		        convert: function (options) {
	
		            if (Utils.isUndefined(this.diagram)) {
		                throw "No diagram to convert.";
		            }
	
		            this.options = kendo.deepExtend({
		                    ignoreInvisible: true,
		                    ignoreContainers: true,
		                    layoutContainerChildren: false
		                },
		                options || {}
		            );
	
		            this.clear();
		            // create the nodes which participate effectively in the graph analysis
		            this._renormalizeShapes();
	
		            // recreate the incoming and outgoing collections of each and every node
		            this._renormalizeConnections();
	
		            // export the resulting graph
		            this.finalNodes = new Dictionary(this.nodes);
		            this.finalLinks = new Dictionary(this.edges);
	
		            this.finalGraph = new Graph();
		            this.finalNodes.forEach(function (n) {
		                this.finalGraph.addNode(n);
		            }, this);
		            this.finalLinks.forEach(function (l) {
		                this.finalGraph.addExistingLink(l);
		            }, this);
		            return this.finalGraph;
		        },
	
		        /**
		         * Maps the specified connection to an edge of the graph deduced from the given diagram.
		         * @param connection
		         * @returns {*}
		         */
		        mapConnection: function (connection) {
		            return this.edgeMap.get(connection.id);
		        },
	
		        /**
		         * Maps the specified shape to a node of the graph deduced from the given diagram.
		         * @param shape
		         * @returns {*}
		         */
		        mapShape: function (shape) {
		            return this.nodeMap.get(shape.id);
		        },
	
		        /**
		         * Gets the edge, if any, between the given nodes.
		         * @param a
		         * @param b
		         */
		        getEdge: function (a, b) {
		            return Utils.first(a.links, function (link) {
		                return link.getComplement(a) === b;
		            });
		        },
	
		        /**
		         * Clears all the collections used by the conversion process.
		         */
		        clear: function () {
		            this.finalGraph = null;
		            this.hyperTree = (!this.options.ignoreContainers && this.options.layoutContainerChildren) ? new HyperTree() : null;
		            this.hyperMap = (!this.options.ignoreContainers && this.options.layoutContainerChildren) ? new Dictionary() : null;
		            this.nodeMap = new Dictionary();
		            this.shapeMap = new Dictionary();
		            this.nodes = [];
		            this.edges = [];
		            this.edgeMap = new Dictionary();
		            this.ignoredConnections = [];
		            this.ignoredShapes = [];
		            this.finalNodes = [];
		            this.finalLinks = [];
		        },
	
		        /**
		         * The path from a given ContainerGraph to the root (container).
		         * @param containerGraph
		         * @returns {Array}
		         */
		        listToRoot: function (containerGraph) {
		            var list = [];
		            var s = containerGraph.container;
		            if (!s) {
		                return list;
		            }
		            list.push(s);
		            while (s.parentContainer) {
		                s = s.parentContainer;
		                list.push(s);
		            }
		            list.reverse();
		            return list;
		        },
	
		        firstNonIgnorableContainer: function (shape) {
	
		            if (shape.isContainer && !this._isIgnorableItem(shape)) {
		                return shape;
		            }
		            return !shape.parentContainer ? null : this.firstNonIgnorableContainer(shape.parentContainer);
		        },
		        isContainerConnection: function (a, b) {
		            if (a.isContainer && this.isDescendantOf(a, b)) {
		                return true;
		            }
		            return b.isContainer && this.isDescendantOf(b, a);
		        },
	
		        /**
		         * Returns true if the given shape is a direct child or a nested container child of the given container.
		         * If the given container and shape are the same this will return false since a shape cannot be its own child.
		         * @param scope
		         * @param a
		         * @returns {boolean}
		         */
		        isDescendantOf: function (scope, a) {
		            if (!scope.isContainer) {
		                throw "Expecting a container.";
		            }
		            if (scope === a) {
		                return false;
		            }
		            if (contains(scope.children, a)) {
		                return true;
		            }
		            var containers = [];
		            for (var i = 0, len = scope.children.length; i < len; i++) {
		                var c = scope.children[i];
		                if (c.isContainer && this.isDescendantOf(c, a)) {
		                    containers.push(c);
		                }
		            }
	
		            return containers.length > 0;
		        },
		        isIgnorableItem: function (shape) {
		            if (this.options.ignoreInvisible) {
		                if (shape.isCollapsed && this._isVisible(shape)) {
		                    return false;
		                }
		                if (!shape.isCollapsed && this._isVisible(shape)) {
		                    return false;
		                }
		                return true;
		            }
		            else {
		                return shape.isCollapsed && !this._isTop(shape);
		            }
		        },
	
		        /**
		         *  Determines whether the shape is or needs to be mapped to another shape. This occurs essentially when the shape sits in
		         * a collapsed container hierarchy and an external connection needs a node endpoint. This node then corresponds to the mapped shape and is
		         * necessarily a container in the parent hierarchy of the shape.
		         * @param shape
		         */
		        isShapeMapped: function (shape) {
		            return shape.isCollapsed && !this._isVisible(shape) && !this._isTop(shape);
		        },
	
		        leastCommonAncestor: function (a, b) {
		            if (!a) {
		                throw "Parameter should not be null.";
		            }
		            if (!b) {
		                throw "Parameter should not be null.";
		            }
	
		            if (!this.hyperTree) {
		                throw "No hypertree available.";
		            }
		            var al = this.listToRoot(a);
		            var bl = this.listToRoot(b);
		            var found = null;
		            if (Utils.isEmpty(al) || Utils.isEmpty(bl)) {
		                return this.hyperTree.root.data;
		            }
		            var xa = al[0];
		            var xb = bl[0];
		            var i = 0;
		            while (xa === xb) {
		                found = al[i];
		                i++;
		                if (i >= al.length || i >= bl.length) {
		                    break;
		                }
		                xa = al[i];
		                xb = bl[i];
		            }
		            if (!found) {
		                return this.hyperTree.root.data;
		            }
		            else {
		                return grep(this.hyperTree.nodes, function (n) {
		                    return  n.data.container === found;
		                });
		            }
		        },
		        /**
		         * Determines whether the specified item is a top-level shape or container.
		         * @param item
		         * @returns {boolean}
		         * @private
		         */
		        _isTop: function (item) {
		            return !item.parentContainer;
		        },
	
		        /**
		         * Determines iteratively (by walking up the container stack) whether the specified shape is visible.
		         * This does NOT tell whether the item is not visible due to an explicit Visibility change or due to a collapse state.
		         * @param shape
		         * @returns {*}
		         * @private
		         */
		        _isVisible: function (shape) {
	
		            if (!shape.visible()) {
		                return false;
		            }
		            return !shape.parentContainer ? shape.visible() : this._isVisible(shape.parentContainer);
		        },
	
		        _isCollapsed: function (shape) {
	
		            if (shape.isContainer && shape.isCollapsed) {
		                return true;
		            }
		            return shape.parentContainer && this._isCollapsed(shape.parentContainer);
		        },
	
		        /**
		         * First part of the graph creation; analyzing the shapes and containers and deciding whether they should be mapped to a Node.
		         * @private
		         */
		        _renormalizeShapes: function () {
		            // add the nodes, the adjacency structure will be reconstructed later on
		            if (this.options.ignoreContainers) {
		                for (var i = 0, len = this.diagram.shapes.length; i < len; i++) {
		                    var shape = this.diagram.shapes[i];
	
		                    // if not visible (and ignoring the invisible ones) or a container we skip
		                    if ((this.options.ignoreInvisible && !this._isVisible(shape)) || shape.isContainer) {
		                        this.ignoredShapes.push(shape);
		                        continue;
		                    }
		                    var node = new Node(shape.id, shape);
		                    node.isVirtual = false;
	
		                    // the mapping will always contain singletons and the hyperTree will be null
		                    this.nodeMap.add(shape.id, node);
		                    this.nodes.push(node);
		                }
		            }
		            else {
		                throw "Containers are not supported yet, but stay tuned.";
		            }
		        },
	
		        /**
		         * Second part of the graph creation; analyzing the connections and deciding whether they should be mapped to an edge.
		         * @private
		         */
		        _renormalizeConnections: function () {
		            if (this.diagram.connections.length === 0) {
		                return;
		            }
		            for (var i = 0, len = this.diagram.connections.length; i < len; i++) {
		                var conn = this.diagram.connections[i];
	
		                if (this.isIgnorableItem(conn)) {
		                    this.ignoredConnections.push(conn);
		                    continue;
		                }
	
		                var source = !conn.sourceConnector ? null : conn.sourceConnector.shape;
		                var sink = !conn.targetConnector ? null : conn.targetConnector.shape;
	
		                // no layout for floating connections
		                if (!source || !sink) {
		                    this.ignoredConnections.push(conn);
		                    continue;
		                }
	
		                if (contains(this.ignoredShapes, source) && !this.shapeMap.containsKey(source)) {
		                    this.ignoredConnections.push(conn);
		                    continue;
		                }
		                if (contains(this.ignoredShapes, sink) && !this.shapeMap.containsKey(sink)) {
		                    this.ignoredConnections.push(conn);
		                    continue;
		                }
	
		                // if the endpoint sits in a collapsed container we need the container rather than the shape itself
		                if (this.shapeMap.containsKey(source)) {
		                    source = this.shapeMap[source];
		                }
		                if (this.shapeMap.containsKey(sink)) {
		                    sink = this.shapeMap[sink];
		                }
	
		                var sourceNode = this.mapShape(source);
		                var sinkNode = this.mapShape(sink);
		                if ((sourceNode === sinkNode) || this.areConnectedAlready(sourceNode, sinkNode)) {
		                    this.ignoredConnections.push(conn);
		                    continue;
		                }
	
		                if (sourceNode === null || sinkNode === null) {
		                    throw "A shape was not mapped to a node.";
		                }
		                if (this.options.ignoreContainers) {
		                    // much like a floating connection here since at least one end is attached to a container
		                    if (sourceNode.isVirtual || sinkNode.isVirtual) {
		                        this.ignoredConnections.push(conn);
		                        continue;
		                    }
		                    var newEdge = new Link(sourceNode, sinkNode, conn.id, conn);
	
		                    this.edgeMap.add(conn.id, newEdge);
		                    this.edges.push(newEdge);
		                }
		                else {
		                    throw "Containers are not supported yet, but stay tuned.";
		                }
		            }
		        },
	
		        areConnectedAlready: function (n, m) {
		            return Utils.any(this.edges, function (l) {
		                return l.source === n && l.target === m || l.source === m && l.target === n;
		            });
		        }
	
		        /**
		         * Depth-first traversal of the given container.
		         * @param container
		         * @param action
		         * @param includeStart
		         * @private
		         */
		        /* _visitContainer: function (container, action, includeStart) {
	
		         *//*if (container == null) throw new ArgumentNullException("container");
		         if (action == null) throw new ArgumentNullException("action");
		         if (includeStart) action(container);
		         if (container.children.isEmpty()) return;
		         foreach(
		         var item
		         in
		         container.children.OfType < IShape > ()
		         )
		         {
		         var childContainer = item
		         as
		         IContainerShape;
		         if (childContainer != null) this.VisitContainer(childContainer, action);
		         else action(item);
		         }*//*
		         }*/
	
	
		    });
	
		    /**
		     * The classic spring-embedder (aka force-directed, Fruchterman-Rheingold, barycentric) algorithm.
		     * http://en.wikipedia.org/wiki/Force-directed_graph_drawing
		     *  - Chapter 12 of Tamassia et al. "Handbook of graph drawing and visualization".
		     *  - Kobourov on preprint arXiv; http://arxiv.org/pdf/1201.3011.pdf
		     *  - Fruchterman and Rheingold in SOFTWARE-PRACTICE AND EXPERIENCE, VOL. 21(1 1), 1129-1164 (NOVEMBER 1991)
		     * @type {*}
		     */
		    var SpringLayout = LayoutBase.extend({
		        init: function (diagram) {
		            var that = this;
		            LayoutBase.fn.init.call(that);
		            if (Utils.isUndefined(diagram)) {
		                throw "Diagram is not specified.";
		            }
		            this.diagram = diagram;
		        },
	
		        layout: function (options) {
	
		            this.transferOptions(options);
	
		            var adapter = new DiagramToHyperTreeAdapter(this.diagram);
		            var graph = adapter.convert(options);
		            if (graph.isEmpty()) {
		                return;
		            }
		            // split into connected components
		            var components = graph.getConnectedComponents();
		            if (Utils.isEmpty(components)) {
		                return;
		            }
		            for (var i = 0; i < components.length; i++) {
		                var component = components[i];
		                this.layoutGraph(component, options);
		            }
		            var finalNodeSet = this.gridLayoutComponents(components);
		            return new diagram.LayoutState(this.diagram, finalNodeSet);
		        },
	
		        layoutGraph: function (graph, options) {
	
		            if (Utils.isDefined(options)) {
		                this.transferOptions(options);
		            }
		            this.graph = graph;
	
		            var initialTemperature = this.options.nodeDistance * 9;
		            this.temperature = initialTemperature;
	
		            var guessBounds = this._expectedBounds();
		            this.width = guessBounds.width;
		            this.height = guessBounds.height;
	
		            for (var step = 0; step < this.options.iterations; step++) {
		                this.refineStage = step >= this.options.iterations * 5 / 6;
		                this.tick();
		                // exponential cooldown
		                this.temperature = this.refineStage ?
		                    initialTemperature / 30 :
		                    initialTemperature * (1 - step / (2 * this.options.iterations ));
		            }
		        },
	
		        /**
		         * Single iteration of the simulation.
		         */
		        tick: function () {
		            var i;
		            // collect the repulsive forces on each node
		            for (i = 0; i < this.graph.nodes.length; i++) {
		                this._repulsion(this.graph.nodes[i]);
		            }
	
		            // collect the attractive forces on each node
		            for (i = 0; i < this.graph.links.length; i++) {
		                this._attraction(this.graph.links[i]);
		            }
		            // update the positions
		            for (i = 0; i < this.graph.nodes.length; i++) {
		                var node = this.graph.nodes[i];
		                var offset = Math.sqrt(node.dx * node.dx + node.dy * node.dy);
		                if (offset === 0) {
		                    return;
		                }
		                node.x += Math.min(offset, this.temperature) * node.dx / offset;
		                node.y += Math.min(offset, this.temperature) * node.dy / offset;
		                if (this.options.limitToView) {
		                    node.x = Math.min(this.width, Math.max(node.width / 2, node.x));
		                    node.y = Math.min(this.height, Math.max(node.height / 2, node.y));
		                }
		            }
		        },
	
		        /**
		         * Shakes the node away from its current position to escape the deadlock.
		         * @param node A Node.
		         * @private
		         */
		        _shake: function (node) {
		            // just a simple polar neighborhood
		            var rho = Math.random() * this.options.nodeDistance / 4;
		            var alpha = Math.random() * 2 * Math.PI;
		            node.x += rho * Math.cos(alpha);
		            node.y -= rho * Math.sin(alpha);
		        },
	
		        /**
		         * The typical Coulomb-Newton force law F=k/r^2
		         * @remark This only works in dimensions less than three.
		         * @param d
		         * @param n A Node.
		         * @param m Another Node.
		         * @returns {number}
		         * @private
		         */
		        _InverseSquareForce: function (d, n, m) {
		            var force;
		            if (!this.refineStage) {
		                force = Math.pow(d, 2) / Math.pow(this.options.nodeDistance, 2);
		            }
		            else {
		                var deltax = n.x - m.x;
		                var deltay = n.y - m.y;
	
		                var wn = n.width / 2;
		                var hn = n.height / 2;
		                var wm = m.width / 2;
		                var hm = m.height / 2;
	
		                force = (Math.pow(deltax, 2) / Math.pow(wn + wm + this.options.nodeDistance, 2)) + (Math.pow(deltay, 2) / Math.pow(hn + hm + this.options.nodeDistance, 2));
		            }
		            return force * 4 / 3;
		        },
	
		        /**
		         * The typical Hooke force law F=kr^2
		         * @param d
		         * @param n
		         * @param m
		         * @returns {number}
		         * @private
		         */
		        _SquareForce: function (d, n, m) {
		            return 1 / this._InverseSquareForce(d, n, m);
		        },
	
		        _repulsion: function (n) {
		            n.dx = 0;
		            n.dy = 0;
		            Utils.forEach(this.graph.nodes, function (m) {
		                if (m === n) {
		                    return;
		                }
		                while (n.x === m.x && n.y === m.y) {
		                    this._shake(m);
		                }
		                var vx = n.x - m.x;
		                var vy = n.y - m.y;
		                var distance = Math.sqrt(vx * vx + vy * vy);
		                var r = this._SquareForce(distance, n, m) * 2;
		                n.dx += (vx / distance) * r;
		                n.dy += (vy / distance) * r;
		            }, this);
		        },
		        _attraction: function (link) {
		            var t = link.target;
		            var s = link.source;
		            if (s === t) {
		                // loops induce endless shakes
		                return;
		            }
		            while (s.x === t.x && s.y === t.y) {
		                this._shake(t);
		            }
	
		            var vx = s.x - t.x;
		            var vy = s.y - t.y;
		            var distance = Math.sqrt(vx * vx + vy * vy);
	
		            var a = this._InverseSquareForce(distance, s, t) * 5;
		            var dx = (vx / distance) * a;
		            var dy = (vy / distance) * a;
		            t.dx += dx;
		            t.dy += dy;
		            s.dx -= dx;
		            s.dy -= dy;
		        },
	
		        /**
		         * Calculates the expected bounds after layout.
		         * @returns {*}
		         * @private
		         */
		        _expectedBounds: function () {
	
		            var size, N = this.graph.nodes.length, /*golden ration optimal?*/ ratio = 1.5, multiplier = 4;
		            if (N === 0) {
		                return size;
		            }
		            size = Utils.fold(this.graph.nodes, function (s, node) {
		                var area = node.width * node.height;
		                if (area > 0) {
		                    s += Math.sqrt(area);
		                    return s;
		                }
		                return 0;
		            }, 0, this);
		            var av = size / N;
		            var squareSize = av * Math.ceil(Math.sqrt(N));
		            var width = squareSize * Math.sqrt(ratio);
		            var height = squareSize / Math.sqrt(ratio);
		            return { width: width * multiplier, height: height * multiplier };
		        }
	
		    });
	
		    var TreeLayoutProcessor = kendo.Class.extend({
	
		        init: function (options) {
		            this.center = null;
		            this.options = options;
		        },
		        layout: function (treeGraph, root) {
		            this.graph = treeGraph;
		            if (!this.graph.nodes || this.graph.nodes.length === 0) {
		                return;
		            }
	
		            if (!contains(this.graph.nodes, root)) {
		                throw "The given root is not in the graph.";
		            }
	
		            this.center = root;
		            this.graph.cacheRelationships();
		            /* var nonull = this.graph.nodes.where(function (n) {
		             return n.associatedShape != null;
		             });*/
	
		            // transfer the rects
		            /*nonull.forEach(function (n) {
		             n.Location = n.associatedShape.Position;
		             n.NodeSize = n.associatedShape.ActualBounds.ToSize();
		             }
	
		             );*/
	
		            // caching the children
		            /* nonull.forEach(function (n) {
		             n.children = n.getChildren();
		             });*/
	
		            this.layoutSwitch();
	
		            // apply the layout to the actual visuals
		            // nonull.ForEach(n => n.associatedShape.Position = n.Location);
		        },
	
		        layoutLeft: function (left) {
		            this.setChildrenDirection(this.center, "Left", false);
		            this.setChildrenLayout(this.center, "Default", false);
		            var h = 0, w = 0, y, i, node;
		            for (i = 0; i < left.length; i++) {
		                node = left[i];
		                node.TreeDirection = "Left";
		                var s = this.measure(node, Size.Empty);
		                w = Math.max(w, s.Width);
		                h += s.height + this.options.verticalSeparation;
		            }
	
		            h -= this.options.verticalSeparation;
		            var x = this.center.x - this.options.horizontalSeparation;
		            y = this.center.y + ((this.center.height - h) / 2);
		            for (i = 0; i < left.length; i++) {
		                node = left[i];
		                var p = new Point(x - node.Size.width, y);
	
		                this.arrange(node, p);
		                y += node.Size.height + this.options.verticalSeparation;
		            }
		        },
	
		        layoutRight: function (right) {
		            this.setChildrenDirection(this.center, "Right", false);
		            this.setChildrenLayout(this.center, "Default", false);
		            var h = 0, w = 0, y, i, node;
		            for (i = 0; i < right.length; i++) {
		                node = right[i];
		                node.TreeDirection = "Right";
		                var s = this.measure(node, Size.Empty);
		                w = Math.max(w, s.Width);
		                h += s.height + this.options.verticalSeparation;
		            }
	
		            h -= this.options.verticalSeparation;
		            var x = this.center.x + this.options.horizontalSeparation + this.center.width;
		            y = this.center.y + ((this.center.height - h) / 2);
		            for (i = 0; i < right.length; i++) {
		                node = right[i];
		                var p = new Point(x, y);
		                this.arrange(node, p);
		                y += node.Size.height + this.options.verticalSeparation;
		            }
		        },
	
		        layoutUp: function (up) {
		            this.setChildrenDirection(this.center, "Up", false);
		            this.setChildrenLayout(this.center, "Default", false);
		            var w = 0, y, node, i;
		            for (i = 0; i < up.length; i++) {
		                node = up[i];
		                node.TreeDirection = "Up";
		                var s = this.measure(node, Size.Empty);
		                w += s.width + this.options.horizontalSeparation;
		            }
	
		            w -= this.options.horizontalSeparation;
		            var x = this.center.x + (this.center.width / 2) - (w / 2);
	
		            // y = this.center.y -verticalSeparation -this.center.height/2 - h;
		            for (i = 0; i < up.length; i++) {
		                node = up[i];
		                y = this.center.y - this.options.verticalSeparation - node.Size.height;
		                var p = new Point(x, y);
		                this.arrange(node, p);
		                x += node.Size.width + this.options.horizontalSeparation;
		            }
		        },
	
		        layoutDown: function (down) {
		            var node, i;
		            this.setChildrenDirection(this.center, "Down", false);
		            this.setChildrenLayout(this.center, "Default", false);
		            var w = 0, y;
		            for (i = 0; i < down.length; i++) {
		                node = down[i];
		                node.treeDirection = "Down";
		                var s = this.measure(node, Size.Empty);
		                w += s.width + this.options.horizontalSeparation;
		            }
	
		            w -= this.options.horizontalSeparation;
		            var x = this.center.x + (this.center.width / 2) - (w / 2);
		            y = this.center.y + this.options.verticalSeparation + this.center.height;
		            for (i = 0; i < down.length; i++) {
		                node = down[i];
		                var p = new Point(x, y);
		                this.arrange(node, p);
		                x += node.Size.width + this.options.horizontalSeparation;
		            }
		        },
	
		        layoutRadialTree: function () {
		            // var rmax = children.Aggregate(0D, (current, node) => Math.max(node.SectorAngle, current));
		            this.setChildrenDirection(this.center, "Radial", false);
		            this.setChildrenLayout(this.center, "Default", false);
		            this.previousRoot = null;
		            var startAngle = this.options.startRadialAngle * DEG_TO_RAD;
		            var endAngle = this.options.endRadialAngle * DEG_TO_RAD;
		            if (endAngle <= startAngle) {
		                throw "Final angle should not be less than the start angle.";
		            }
	
		            this.maxDepth = 0;
		            this.origin = new Point(this.center.x, this.center.y);
		            this.calculateAngularWidth(this.center, 0);
	
		            // perform the layout
		            if (this.maxDepth > 0) {
		                this.radialLayout(this.center, this.options.radialFirstLevelSeparation, startAngle, endAngle);
		            }
	
		            // update properties of the root node
		            this.center.Angle = endAngle - startAngle;
		        },
	
		        tipOverTree: function (down, startFromLevel) {
		            if (Utils.isUndefined(startFromLevel)) {
		                startFromLevel = 0;
		            }
	
		            this.setChildrenDirection(this.center, "Down", false);
		            this.setChildrenLayout(this.center, "Default", false);
		            this.setChildrenLayout(this.center, "Underneath", false, startFromLevel);
		            var w = 0, y, node, i;
		            for (i = 0; i < down.length; i++) {
		                node = down[i];
	
		                // if (node.IsSpecial) continue;
		                node.TreeDirection = "Down";
		                var s = this.measure(node, Size.Empty);
		                w += s.width + this.options.horizontalSeparation;
		            }
	
		            w -= this.options.horizontalSeparation;
	
		            // putting the root in the center with respect to the whole diagram is not a nice result, let's put it with respect to the first level only
		            w -= down[down.length - 1].width;
		            w += down[down.length - 1].associatedShape.bounds().width;
	
		            var x = this.center.x + (this.center.width / 2) - (w / 2);
		            y = this.center.y + this.options.verticalSeparation + this.center.height;
		            for (i = 0; i < down.length; i++) {
		                node = down[i];
		                // if (node.IsSpecial) continue;
		                var p = new Point(x, y);
		                this.arrange(node, p);
		                x += node.Size.width + this.options.horizontalSeparation;
		            }
	
		            /*//let's place the special node, assuming there is only one
		             if (down.Count(n => n.IsSpecial) > 0)
		             {
		             var special = (from n in down where n.IsSpecial select n).First();
		             if (special.Children.Count > 0)
		             throw new DiagramException("The 'special' element should not have children.");
		             special.Data.Location = new Point(Center.Data.Location.X + Center.AssociatedShape.BoundingRectangle.Width + this.options.HorizontalSeparation, Center.Data.Location.Y);
		             }*/
		        },
		        calculateAngularWidth: function (n, d) {
		            if (d > this.maxDepth) {
		                this.maxDepth = d;
		            }
	
		            var aw = 0, w = 1000, h = 1000, diameter = d === 0 ? 0 : Math.sqrt((w * w) + (h * h)) / d;
	
		            if (n.children.length > 0) {
		                // eventually with n.IsExpanded
		                for (var i = 0, len = n.children.length; i < len; i++) {
		                    var child = n.children[i];
		                    aw += this.calculateAngularWidth(child, d + 1);
		                }
		                aw = Math.max(diameter, aw);
		            }
		            else {
		                aw = diameter;
		            }
	
		            n.sectorAngle = aw;
		            return aw;
		        },
		        sortChildren: function (n) {
		            var basevalue = 0, i;
	
		            // update basevalue angle for node ordering
		            if (n.parents.length > 1) {
		                throw "Node is not part of a tree.";
		            }
		            var p = n.parents[0];
		            if (p) {
		                var pl = new Point(p.x, p.y);
		                var nl = new Point(n.x, n.y);
		                basevalue = this.normalizeAngle(Math.atan2(pl.y - nl.y, pl.x - nl.x));
		            }
	
		            var count = n.children.length;
		            if (count === 0) {
		                return null;
		            }
	
		            var angle = [];
		            var idx = [];
	
		            for (i = 0; i < count; ++i) {
		                var c = n.children[i];
		                var l = new Point(c.x, c.y);
		                idx[i] = i;
		                angle[i] = this.normalizeAngle(-basevalue + Math.atan2(l.y - l.y, l.x - l.x));
		            }
	
		            Utils.bisort(angle, idx);
		            var col = []; // list of nodes
		            var children = n.children;
		            for (i = 0; i < count; ++i) {
		                col.push(children[idx[i]]);
		            }
	
		            return col;
		        },
	
		        normalizeAngle: function (angle) {
		            while (angle > Math.PI * 2) {
		                angle -= 2 * Math.PI;
		            }
		            while (angle < 0) {
		                angle += Math.PI * 2;
		            }
		            return angle;
		        },
		        radialLayout: function (node, radius, startAngle, endAngle) {
		            var deltaTheta = endAngle - startAngle;
		            var deltaThetaHalf = deltaTheta / 2.0;
		            var parentSector = node.sectorAngle;
		            var fraction = 0;
		            var sorted = this.sortChildren(node);
		            for (var i = 0, len = sorted.length; i < len; i++) {
		                var childNode = sorted[i];
		                var cp = childNode;
		                var childAngleFraction = cp.sectorAngle / parentSector;
		                if (childNode.children.length > 0) {
		                    this.radialLayout(childNode,
		                        radius + this.options.radialSeparation,
		                        startAngle + (fraction * deltaTheta),
		                        startAngle + ((fraction + childAngleFraction) * deltaTheta));
		                }
	
		                this.setPolarLocation(childNode, radius, startAngle + (fraction * deltaTheta) + (childAngleFraction * deltaThetaHalf));
		                cp.angle = childAngleFraction * deltaTheta;
		                fraction += childAngleFraction;
		            }
		        },
		        setPolarLocation: function (node, radius, angle) {
		            node.x = this.origin.x + (radius * Math.cos(angle));
		            node.y = this.origin.y + (radius * Math.sin(angle));
		            node.BoundingRectangle = new Rect(node.x, node.y, node.width, node.height);
		        },
	
		        /**
		         * Sets the children direction recursively.
		         * @param node
		         * @param direction
		         * @param includeStart
		         */
		        setChildrenDirection: function (node, direction, includeStart) {
		            var rootDirection = node.treeDirection;
		            this.graph.depthFirstTraversal(node, function (n) {
		                n.treeDirection = direction;
		            });
		            if (!includeStart) {
		                node.treeDirection = rootDirection;
		            }
		        },
	
		        /**
		         * Sets the children layout recursively.
		         * @param node
		         * @param layout
		         * @param includeStart
		         * @param startFromLevel
		         */
		        setChildrenLayout: function (node, layout, includeStart, startFromLevel) {
		            if (Utils.isUndefined(startFromLevel)) {
		                startFromLevel = 0;
		            }
		            var rootLayout = node.childrenLayout;
		            if (startFromLevel > 0) {
		                // assign levels to the Node.Level property
		                this.graph.assignLevels(node);
	
		                // assign the layout on the condition that the level is at least the 'startFromLevel'
		                this.graph.depthFirstTraversal(
		                    node, function (s) {
		                        if (s.level >= startFromLevel + 1) {
		                            s.childrenLayout = layout;
		                        }
		                    }
		                );
		            }
		            else {
		                this.graph.depthFirstTraversal(node, function (s) {
		                    s.childrenLayout = layout;
		                });
	
		                // if the start should not be affected we put the state back
		                if (!includeStart) {
		                    node.childrenLayout = rootLayout;
		                }
		            }
		        },
	
		        /**
		         * Returns the actual size of the node. The given size is the allowed space wherein the node can lay out itself.
		         * @param node
		         * @param givenSize
		         * @returns {Size}
		         */
		        measure: function (node, givenSize) {
		            var w = 0, h = 0, s;
		            var result = new Size(0, 0);
		            if (!node) {
		                throw "";
		            }
		            var b = node.associatedShape.bounds();
		            var shapeWidth = b.width;
		            var shapeHeight = b.height;
		            if (node.parents.length !== 1) {
		                throw "Node not in a spanning tree.";
		            }
	
		            var parent = node.parents[0];
		            if (node.treeDirection === "Undefined") {
		                node.treeDirection = parent.treeDirection;
		            }
	
		            if (Utils.isEmpty(node.children)) {
		                result = new Size(
		                    Math.abs(shapeWidth) < EPSILON ? 50 : shapeWidth,
		                    Math.abs(shapeHeight) < EPSILON ? 25 : shapeHeight);
		            }
		            else if (node.children.length === 1) {
		                switch (node.treeDirection) {
		                    case "Radial":
		                        s = this.measure(node.children[0], givenSize); // child size
		                        w = shapeWidth + (this.options.radialSeparation * Math.cos(node.AngleToParent)) + s.width;
		                        h = shapeHeight + Math.abs(this.options.radialSeparation * Math.sin(node.AngleToParent)) + s.height;
		                        break;
		                    case "Left":
		                    case "Right":
		                        switch (node.childrenLayout) {
	
		                            case "TopAlignedWithParent":
		                                break;
	
		                            case "BottomAlignedWithParent":
		                                break;
	
		                            case "Underneath":
		                                s = this.measure(node.children[0], givenSize);
		                                w = shapeWidth + s.width + this.options.underneathHorizontalOffset;
		                                h = shapeHeight + this.options.underneathVerticalTopOffset + s.height;
		                                break;
	
		                            case "Default":
		                                s = this.measure(node.children[0], givenSize);
		                                w = shapeWidth + this.options.horizontalSeparation + s.width;
		                                h = Math.max(shapeHeight, s.height);
		                                break;
	
		                            default:
		                                throw "Unhandled TreeDirection in the Radial layout measuring.";
		                        }
		                        break;
		                    case "Up":
		                    case "Down":
		                        switch (node.childrenLayout) {
	
		                            case "TopAlignedWithParent":
		                            case "BottomAlignedWithParent":
		                                break;
	
		                            case "Underneath":
		                                s = this.measure(node.children[0], givenSize);
		                                w = Math.max(shapeWidth, s.width + this.options.underneathHorizontalOffset);
		                                h = shapeHeight + this.options.underneathVerticalTopOffset + s.height;
		                                break;
	
		                            case "Default":
		                                s = this.measure(node.children[0], givenSize);
		                                h = shapeHeight + this.options.verticalSeparation + s.height;
		                                w = Math.max(shapeWidth, s.width);
		                                break;
	
		                            default:
		                                throw "Unhandled TreeDirection in the Down layout measuring.";
		                        }
		                        break;
		                    default:
		                        throw "Unhandled TreeDirection in the layout measuring.";
		                }
	
		                result = new Size(w, h);
		            }
		            else {
		                var i, childNode;
		                switch (node.treeDirection) {
		                    case "Left":
		                    case "Right":
		                        switch (node.childrenLayout) {
	
		                            case "TopAlignedWithParent":
		                            case "BottomAlignedWithParent":
		                                break;
	
		                            case "Underneath":
		                                w = shapeWidth;
		                                h = shapeHeight + this.options.underneathVerticalTopOffset;
		                                for (i = 0; i < node.children.length; i++) {
		                                    childNode = node.children[i];
		                                    s = this.measure(childNode, givenSize);
		                                    w = Math.max(w, s.width + this.options.underneathHorizontalOffset);
		                                    h += s.height + this.options.underneathVerticalSeparation;
		                                }
	
		                                h -= this.options.underneathVerticalSeparation;
		                                break;
	
		                            case "Default":
		                                w = shapeWidth;
		                                h = 0;
		                                for (i = 0; i < node.children.length; i++) {
		                                    childNode = node.children[i];
		                                    s = this.measure(childNode, givenSize);
		                                    w = Math.max(w, shapeWidth + this.options.horizontalSeparation + s.width);
		                                    h += s.height + this.options.verticalSeparation;
		                                }
		                                h -= this.options.verticalSeparation;
		                                break;
	
		                            default:
		                                throw "Unhandled TreeDirection in the Right layout measuring.";
		                        }
	
		                        break;
		                    case "Up":
		                    case "Down":
	
		                        switch (node.childrenLayout) {
	
		                            case "TopAlignedWithParent":
		                            case "BottomAlignedWithParent":
		                                break;
	
		                            case "Underneath":
		                                w = shapeWidth;
		                                h = shapeHeight + this.options.underneathVerticalTopOffset;
		                                for (i = 0; i < node.children.length; i++) {
		                                    childNode = node.children[i];
		                                    s = this.measure(childNode, givenSize);
		                                    w = Math.max(w, s.width + this.options.underneathHorizontalOffset);
		                                    h += s.height + this.options.underneathVerticalSeparation;
		                                }
	
		                                h -= this.options.underneathVerticalSeparation;
		                                break;
	
		                            case "Default":
		                                w = 0;
		                                h = 0;
		                                for (i = 0; i < node.children.length; i++) {
		                                    childNode = node.children[i];
		                                    s = this.measure(childNode, givenSize);
		                                    w += s.width + this.options.horizontalSeparation;
		                                    h = Math.max(h, s.height + this.options.verticalSeparation + shapeHeight);
		                                }
	
		                                w -= this.options.horizontalSeparation;
		                                break;
	
		                            default:
		                                throw "Unhandled TreeDirection in the Down layout measuring.";
		                        }
	
		                        break;
		                    default:
		                        throw "Unhandled TreeDirection in the layout measuring.";
		                }
	
		                result = new Size(w, h);
		            }
	
		            node.SectorAngle = Math.sqrt((w * w / 4) + (h * h / 4));
		            node.Size = result;
		            return result;
		        },
		        arrange: function (n, p) {
		            var i, pp, child, node, childrenwidth, b = n.associatedShape.bounds();
		            var shapeWidth = b.width;
		            var shapeHeight = b.height;
		            if (Utils.isEmpty(n.children)) {
		                n.x = p.x;
		                n.y = p.y;
		                n.BoundingRectangle = new Rect(p.x, p.y, shapeWidth, shapeHeight);
		            }
		            else {
		                var x, y;
		                var selfLocation;
		                switch (n.treeDirection) {
		                    case "Left":
		                        switch (n.childrenLayout) {
		                            case "TopAlignedWithParent":
		                            case "BottomAlignedWithParent":
		                                break;
	
		                            case "Underneath":
		                                selfLocation = p;
		                                n.x = selfLocation.x;
		                                n.y = selfLocation.y;
		                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
		                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
		                                for (i = 0; i < node.children.length; i++) {
		                                    node = node.children[i];
		                                    x = selfLocation.x - node.associatedShape.width - this.options.underneathHorizontalOffset;
		                                    pp = new Point(x, y);
		                                    this.arrange(node, pp);
		                                    y += node.Size.height + this.options.underneathVerticalSeparation;
		                                }
		                                break;
	
		                            case "Default":
		                                selfLocation = new Point(p.x + n.Size.width - shapeWidth, p.y + ((n.Size.height - shapeHeight) / 2));
		                                n.x = selfLocation.x;
		                                n.y = selfLocation.y;
		                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
		                                x = selfLocation.x - this.options.horizontalSeparation; // alignment of children
		                                y = p.y;
		                                for (i = 0; i < n.children.length; i++) {
		                                    node = n.children[i];
		                                    pp = new Point(x - node.Size.width, y);
		                                    this.arrange(node, pp);
		                                    y += node.Size.height + this.options.verticalSeparation;
		                                }
		                                break;
	
		                            default:
		                                throw   "Unsupported TreeDirection";
		                        }
	
		                        break;
		                    case "Right":
		                        switch (n.childrenLayout) {
		                            case "TopAlignedWithParent":
		                            case "BottomAlignedWithParent":
		                                break;
	
		                            case "Underneath":
		                                selfLocation = p;
		                                n.x = selfLocation.x;
		                                n.y = selfLocation.y;
		                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
		                                x = p.x + shapeWidth + this.options.underneathHorizontalOffset;
	
		                                // alignment of children left-underneath the parent
		                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
		                                for (i = 0; i < n.children.length; i++) {
		                                    node = n.children[i];
		                                    pp = new Point(x, y);
		                                    this.arrange(node, pp);
		                                    y += node.Size.height + this.options.underneathVerticalSeparation;
		                                }
	
		                                break;
	
		                            case "Default":
		                                selfLocation = new Point(p.x, p.y + ((n.Size.height - shapeHeight) / 2));
		                                n.x = selfLocation.x;
		                                n.y = selfLocation.y;
		                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
		                                x = p.x + shapeWidth + this.options.horizontalSeparation; // alignment of children
		                                y = p.y;
		                                for (i = 0; i < n.children.length; i++) {
		                                    node = n.children[i];
		                                    pp = new Point(x, y);
		                                    this.arrange(node, pp);
		                                    y += node.Size.height + this.options.verticalSeparation;
		                                }
		                                break;
	
		                            default:
		                                throw   "Unsupported TreeDirection";
		                        }
	
		                        break;
		                    case "Up":
		                        selfLocation = new Point(p.x + ((n.Size.width - shapeWidth) / 2), p.y + n.Size.height - shapeHeight);
		                        n.x = selfLocation.x;
		                        n.y = selfLocation.y;
		                        n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
		                        if (Math.abs(selfLocation.x - p.x) < EPSILON) {
		                            childrenwidth = 0;
		                            // means there is an aberration due to the oversized Element with respect to the children
		                            for (i = 0; i < n.children.length; i++) {
		                                child = n.children[i];
		                                childrenwidth += child.Size.width + this.options.horizontalSeparation;
		                            }
		                            childrenwidth -= this.options.horizontalSeparation;
		                            x = p.x + ((shapeWidth - childrenwidth) / 2);
		                        }
		                        else {
		                            x = p.x;
		                        }
	
		                        for (i = 0; i < n.children.length; i++) {
		                            node = n.children[i];
		                            y = selfLocation.y - this.options.verticalSeparation - node.Size.height;
		                            pp = new Point(x, y);
		                            this.arrange(node, pp);
		                            x += node.Size.width + this.options.horizontalSeparation;
		                        }
		                        break;
	
		                    case "Down":
	
		                        switch (n.childrenLayout) {
		                            case "TopAlignedWithParent":
		                            case "BottomAlignedWithParent":
		                                break;
		                            case "Underneath":
		                                selfLocation = p;
		                                n.x = selfLocation.x;
		                                n.y = selfLocation.y;
		                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
		                                x = p.x + this.options.underneathHorizontalOffset; // alignment of children left-underneath the parent
		                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
		                                for (i = 0; i < n.children.length; i++) {
		                                    node = n.children[i];
		                                    pp = new Point(x, y);
		                                    this.arrange(node, pp);
		                                    y += node.Size.height + this.options.underneathVerticalSeparation;
		                                }
		                                break;
	
		                            case    "Default":
		                                selfLocation = new Point(p.x + ((n.Size.width - shapeWidth) / 2), p.y);
		                                n.x = selfLocation.x;
		                                n.y = selfLocation.y;
		                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
		                                if (Math.abs(selfLocation.x - p.x) < EPSILON) {
		                                    childrenwidth = 0;
		                                    // means there is an aberration due to the oversized Element with respect to the children
		                                    for (i = 0; i < n.children.length; i++) {
		                                        child = n.children[i];
		                                        childrenwidth += child.Size.width + this.options.horizontalSeparation;
		                                    }
	
		                                    childrenwidth -= this.options.horizontalSeparation;
		                                    x = p.x + ((shapeWidth - childrenwidth) / 2);
		                                }
		                                else {
		                                    x = p.x;
		                                }
	
		                                for (i = 0; i < n.children.length; i++) {
		                                    node = n.children[i];
		                                    y = selfLocation.y + this.options.verticalSeparation + shapeHeight;
		                                    pp = new Point(x, y);
		                                    this.arrange(node, pp);
		                                    x += node.Size.width + this.options.horizontalSeparation;
		                                }
		                                break;
	
		                            default:
		                                throw   "Unsupported TreeDirection";
		                        }
		                        break;
	
		                    case "None":
		                        break;
	
		                    default:
		                        throw   "Unsupported TreeDirection";
		                }
		            }
		        },
		        layoutSwitch: function () {
		            if (!this.center) {
		                return;
		            }
	
		            if (Utils.isEmpty(this.center.children)) {
		                return;
		            }
	
		            var type = this.options.subtype;
		            if (Utils.isUndefined(type)) {
		                type = "Down";
		            }
		            var single, male, female, leftcount;
		            var children = this.center.children;
		            switch (type.toLowerCase()) {
		                case "radial":
		                case "radialtree":
		                    this.layoutRadialTree();
		                    break;
	
		                case "mindmaphorizontal":
		                case "mindmap":
		                    single = this.center.children;
	
		                    if (this.center.children.length === 1) {
		                        this.layoutRight(single);
		                    }
		                    else {
		                        // odd number will give one more at the right
		                        leftcount = children.length / 2;
		                        male = grep(this.center.children, function (n) {
		                            return Utils.indexOf(children, n) < leftcount;
		                        });
		                        female = grep(this.center.children, function (n) {
		                            return Utils.indexOf(children, n) >= leftcount;
		                        });
	
		                        this.layoutLeft(male);
		                        this.layoutRight(female);
		                    }
		                    break;
	
		                case "mindmapvertical":
		                    single = this.center.children;
	
		                    if (this.center.children.length === 1) {
		                        this.layoutDown(single);
		                    }
		                    else {
		                        // odd number will give one more at the right
		                        leftcount = children.length / 2;
		                        male = grep(this.center.children, function (n) {
		                            return Utils.indexOf(children, n) < leftcount;
		                        });
		                        female = grep(this.center.children, function (n) {
		                            return Utils.indexOf(children, n) >= leftcount;
		                        });
		                        this.layoutUp(male);
		                        this.layoutDown(female);
		                    }
		                    break;
	
		                case "right":
		                    this.layoutRight(this.center.children);
		                    break;
	
		                case "left":
		                    this.layoutLeft(this.center.children);
		                    break;
	
		                case "up":
		                case "bottom":
		                    this.layoutUp(this.center.children);
		                    break;
	
		                case "down":
		                case "top":
		                    this.layoutDown(this.center.children);
		                    break;
	
		                case "tipover":
		                case "tipovertree":
		                    if (this.options.tipOverTreeStartLevel < 0) {
		                        throw  "The tip-over level should be a positive integer.";
		                    }
		                    this.tipOverTree(this.center.children, this.options.tipOverTreeStartLevel);
		                    break;
	
		                case "undefined":
		                case "none":
		                    break;
		            }
		        }
		    });
	
		    /**
		     * The various tree layout algorithms.
		     * @type {*}
		     */
		    var TreeLayout = LayoutBase.extend({
		        init: function (diagram) {
		            var that = this;
		            LayoutBase.fn.init.call(that);
		            if (Utils.isUndefined(diagram)) {
		                throw "No diagram specified.";
		            }
		            this.diagram = diagram;
		        },
	
		        /**
		         * Arranges the diagram in a tree-layout with the specified options and tree subtype.
		         */
		        layout: function (options) {
	
		            this.transferOptions(options);
	
		            // transform the diagram into a Graph
		            var adapter = new DiagramToHyperTreeAdapter(this.diagram);
	
		            /**
		             * The Graph reduction from the given diagram.
		             * @type {*}
		             */
		            this.graph = adapter.convert();
	
		            var finalNodeSet = this.layoutComponents();
	
		            // note that the graph contains the original data and
		            // the components are another instance of nodes referring to the same set of shapes
		            return new diagram.LayoutState(this.diagram, finalNodeSet);
		        },
	
		        layoutComponents: function () {
		            if (this.graph.isEmpty()) {
		                return;
		            }
	
		            // split into connected components
		            var components = this.graph.getConnectedComponents();
		            if (Utils.isEmpty(components)) {
		                return;
		            }
	
		            var layout = new TreeLayoutProcessor(this.options);
		            var trees = [];
		            // find a spanning tree for each component
		            for (var i = 0; i < components.length; i++) {
		                var component = components[i];
	
		                var treeGraph = this.getTree(component);
		                if (!treeGraph) {
		                    throw "Failed to find a spanning tree for the component.";
		                }
		                var root = treeGraph.root;
		                var tree = treeGraph.tree;
		                layout.layout(tree, root);
	
		                trees.push(tree);
		            }
	
		            return this.gridLayoutComponents(trees);
	
		        },
	
		        /**
		         * Gets a spanning tree (and root) for the given graph.
		         * Ensure that the given graph is connected!
		         * @param graph
		         * @returns {*} A literal object consisting of the found root and the spanning tree.
		         */
		        getTree: function (graph) {
		            var root = null;
		            if (this.options.roots && this.options.roots.length > 0) {
		                for (var i = 0, len = graph.nodes.length; i < len; i++) {
		                    var node = graph.nodes[i];
		                    for (var j = 0; j < this.options.roots.length; j++) {
		                        var givenRootShape = this.options.roots[j];
		                        if (givenRootShape === node.associatedShape) {
		                            root = node;
		                            break;
		                        }
		                    }
		                }
		            }
		            if (!root) {
		                // finds the most probable root on the basis of the longest path in the component
		                root = graph.root();
		                // should not happen really
		                if (!root) {
		                    throw "Unable to find a root for the tree.";
		                }
		            }
		            return this.getTreeForRoot(graph, root);
		        },
	
		        getTreeForRoot: function (graph, root) {
	
		            var tree = graph.getSpanningTree(root);
		            if (Utils.isUndefined(tree) || tree.isEmpty()) {
		                return null;
		            }
		            return {
		                tree: tree,
		                root: tree.root
		            };
		        }
	
		    });
	
		    /**
		     * The Sugiyama aka layered layout algorithm.
		     * @type {*}
		     */
		    var LayeredLayout = LayoutBase.extend({
		        init: function (diagram) {
		            var that = this;
		            LayoutBase.fn.init.call(that);
		            if (Utils.isUndefined(diagram)) {
		                throw "Diagram is not specified.";
		            }
		            this.diagram = diagram;
		        },
	
		        layout: function (options) {
	
		            this.transferOptions(options);
	
		            var adapter = new DiagramToHyperTreeAdapter(this.diagram);
		            var graph = adapter.convert(options);
		            if (graph.isEmpty()) {
		                return;
		            }
		            // split into connected components
		            var components = graph.getConnectedComponents();
		            if (Utils.isEmpty(components)) {
		                return;
		            }
		            for (var i = 0; i < components.length; i++) {
		                var component = components[i];
		                this.layoutGraph(component, options);
		            }
		            var finalNodeSet = this.gridLayoutComponents(components);
		            return new diagram.LayoutState(this.diagram, finalNodeSet);
	
		        },
	
		        /**
		         * Initializes the runtime data properties of the layout.
		         * @private
		         */
		        _initRuntimeProperties: function () {
		            for (var k = 0; k < this.graph.nodes.length; k++) {
		                var node = this.graph.nodes[k];
		                node.layer = -1;
		                node.downstreamLinkCount = 0;
		                node.upstreamLinkCount = 0;
	
		                node.isVirtual = false;
	
		                node.uBaryCenter = 0.0;
		                node.dBaryCenter = 0.0;
	
		                node.upstreamPriority = 0;
		                node.downstreamPriority = 0;
	
		                node.gridPosition = 0;
		            }
		        },
		        _prepare: function (graph) {
		            var current = [], i, l, link;
	
		            // defines a mapping of a node to the layer index
		            var layerMap = new Dictionary();
		            var layerCount = 0;
		            var targetLayer, next, target;
	
		            Utils.forEach(graph.nodes, function (node) {
		                if (node.incoming.length === 0) {
		                    layerMap.set(node, 0);
		                    current.push(node);
		                }
		            });
	
		            while (current.length > 0) {
		                next = current.shift();
		                for (i = 0; i < next.outgoing.length; i++) {
		                    link = next.outgoing[i];
		                    target = link.target;
	
		                    if (layerMap.containsKey(target)) {
		                        targetLayer = Math.max(layerMap.get(next) + 1, layerMap.get(target));
		                    } else {
		                        targetLayer = layerMap.get(next) + 1;
		                    }
		                    layerMap.set(target, targetLayer);
		                    if (targetLayer > layerCount) {
		                        layerCount = targetLayer;
		                    }
	
		                    if (!contains(current, target)) {
		                        current.push(target);
		                    }
		                }
		            }
	
		            var sortedNodes = layerMap.keys();
	
		            sortedNodes.sort(function (o1, o2) {
		                var o1layer = layerMap.get(o1);
		                var o2layer = layerMap.get(o2);
		                return Utils.sign(o2layer - o1layer);
		            });
	
		            for (var n = 0; n < sortedNodes.length; ++n) {
		                var node = sortedNodes[n];
		                var minLayer = Number.MAX_VALUE;
	
		                if (node.outgoing.length === 0) {
		                    continue;
		                }
	
		                for (l = 0; l < node.outgoing.length; ++l) {
		                    link = node.outgoing[l];
		                    minLayer = Math.min(minLayer, layerMap.get(link.target));
		                }
	
		                if (minLayer > 1) {
		                    layerMap.set(node, minLayer - 1);
		                }
		            }
	
		            this.layers = [];
		            var layer;
		            for (i = 0; i < layerCount + 1; i++) {
		                layer = [];
		                layer.linksTo = {};
		                this.layers.push(layer);
		            }
	
		            layerMap.forEach(function (node, layer) {
		                node.layer = layer;
		                this.layers[layer].push(node);
		            }, this);
	
		            // set initial grid positions
		            for (l = 0; l < this.layers.length; l++) {
		                layer = this.layers[l];
		                for (i = 0; i < layer.length; i++) {
		                    layer[i].gridPosition = i;
		                }
		            }
		        },
		        /**
		         * Performs the layout of a single component.
		         */
		        layoutGraph: function (graph, options) {
		            if (Utils.isUndefined(graph)) {
		                throw "No graph given or graph analysis of the diagram failed.";
		            }
		            if (Utils.isDefined(options)) {
		                this.transferOptions(options);
		            }
		            this.graph = graph;
	
		            // sets unique indices on the nodes
		            graph.setItemIndices();
	
		            // ensures no cycles present for this layout
		            var reversedEdges = graph.makeAcyclic();
	
		            // define the runtime props being used by the layout algorithm
		            this._initRuntimeProperties();
	
		            this._prepare(graph, options);
	
		            this._dummify();
	
		            this._optimizeCrossings();
	
		            this._swapPairs();
	
		            this.arrangeNodes();
	
		            this._moveThingsAround();
	
		            this._dedummify();
	
		            // re-reverse the links which were switched earlier
		            Utils.forEach(reversedEdges, function (e) {
		                if (e.points) {
		                    e.points.reverse();
		                }
		            });
		        },
	
		        setMinDist: function (m, n, minDist) {
		            var l = m.layer;
		            var i = m.layerIndex;
		            this.minDistances[l][i] = minDist;
		        },
	
		        getMinDist: function (m, n) {
		            var dist = 0,
		                i1 = m.layerIndex,
		                i2 = n.layerIndex,
		                l = m.layer,
		                min = Math.min(i1, i2),
		                max = Math.max(i1, i2);
		            // use Sum()?
		            for (var k = min; k < max; ++k) {
		                dist += this.minDistances[l][k];
		            }
		            return dist;
		        },
	
		        placeLeftToRight: function (leftClasses) {
		            var leftPos = new Dictionary(), n, node;
		            for (var c = 0; c < this.layers.length; ++c) {
		                var classNodes = leftClasses[c];
		                if (!classNodes) {
		                    continue;
		                }
	
		                for (n = 0; n < classNodes.length; n++) {
		                    node = classNodes[n];
		                    if (!leftPos.containsKey(node)) {
		                        this.placeLeft(node, leftPos, c);
		                    }
		                }
	
		                // adjust class
		                var d = Number.POSITIVE_INFINITY;
		                for (n = 0; n < classNodes.length; n++) {
		                    node = classNodes[n];
		                    var rightSibling = this.rightSibling(node);
		                    if (rightSibling && this.nodeLeftClass.get(rightSibling) !== c) {
		                        d = Math.min(d, leftPos.get(rightSibling) - leftPos.get(node) - this.getMinDist(node, rightSibling));
		                    }
		                }
		                if (d === Number.POSITIVE_INFINITY) {
		                    var D = [];
		                    for (n = 0; n < classNodes.length; n++) {
		                        node = classNodes[n];
		                        var neighbors = [];
		                        Utils.addRange(neighbors, this.upNodes.get(node));
		                        Utils.addRange(neighbors, this.downNodes.get(node));
	
		                        for (var e = 0; e < neighbors.length; e++) {
		                            var neighbor = neighbors[e];
		                            if (this.nodeLeftClass.get(neighbor) < c) {
		                                D.push(leftPos.get(neighbor) - leftPos.get(node));
		                            }
		                        }
		                    }
		                    D.sort();
		                    if (D.length === 0) {
		                        d = 0;
		                    }
		                    else if (D.length % 2 === 1) {
		                        d = D[this.intDiv(D.length, 2)];
		                    }
		                    else {
		                        d = (D[this.intDiv(D.length, 2) - 1] + D[this.intDiv(D.length, 2)]) / 2;
		                    }
		                }
		                for (n = 0; n < classNodes.length; n++) {
		                    node = classNodes[n];
		                    leftPos.set(node, leftPos.get(node) + d);
		                }
		            }
		            return leftPos;
		        },
	
		        placeRightToLeft: function (rightClasses) {
		            var rightPos = new Dictionary(), n, node;
		            for (var c = 0; c < this.layers.length; ++c) {
		                var classNodes = rightClasses[c];
		                if (!classNodes) {
		                    continue;
		                }
	
		                for (n = 0; n < classNodes.length; n++) {
		                    node = classNodes[n];
		                    if (!rightPos.containsKey(node)) {
		                        this.placeRight(node, rightPos, c);
		                    }
		                }
	
		                // adjust class
		                var d = Number.NEGATIVE_INFINITY;
		                for (n = 0; n < classNodes.length; n++) {
		                    node = classNodes[n];
		                    var leftSibling = this.leftSibling(node);
		                    if (leftSibling && this.nodeRightClass.get(leftSibling) !== c) {
		                        d = Math.max(d, rightPos.get(leftSibling) - rightPos.get(node) + this.getMinDist(leftSibling, node));
		                    }
		                }
		                if (d === Number.NEGATIVE_INFINITY) {
		                    var D = [];
		                    for (n = 0; n < classNodes.length; n++) {
		                        node = classNodes[n];
		                        var neighbors = [];
		                        Utils.addRange(neighbors, this.upNodes.get(node));
		                        Utils.addRange(neighbors, this.downNodes.get(node));
	
		                        for (var e = 0; e < neighbors.length; e++) {
		                            var neighbor = neighbors[e];
		                            if (this.nodeRightClass.get(neighbor) < c) {
		                                D.push(rightPos.get(node) - rightPos.get(neighbor));
		                            }
		                        }
		                    }
		                    D.sort();
		                    if (D.length === 0) {
		                        d = 0;
		                    }
		                    else if (D.length % 2 === 1) {
		                        d = D[this.intDiv(D.length, 2)];
		                    }
		                    else {
		                        d = (D[this.intDiv(D.length, 2) - 1] + D[this.intDiv(D.length, 2)]) / 2;
		                    }
		                }
		                for (n = 0; n < classNodes.length; n++) {
		                    node = classNodes[n];
		                    rightPos.set(node, rightPos.get(node) + d);
		                }
		            }
		            return rightPos;
		        },
	
		        _getLeftWing: function () {
		            var leftWing = { value: null };
		            var result = this.computeClasses(leftWing, 1);
		            this.nodeLeftClass = leftWing.value;
		            return result;
		        },
	
		        _getRightWing: function () {
		            var rightWing = { value: null };
		            var result = this.computeClasses(rightWing, -1);
		            this.nodeRightClass = rightWing.value;
		            return result;
		        },
	
		        computeClasses: function (wingPair, d) {
		            var currentWing = 0,
		                wing = wingPair.value = new Dictionary();
	
		            for (var l = 0; l < this.layers.length; ++l) {
		                currentWing = l;
	
		                var layer = this.layers[l];
		                for (var n = d === 1 ? 0 : layer.length - 1; 0 <= n && n < layer.length; n += d) {
		                    var node = layer[n];
		                    if (!wing.containsKey(node)) {
		                        wing.set(node, currentWing);
		                        if (node.isVirtual) {
		                            var ndsinl = this._nodesInLink(node);
		                            for (var kk = 0; kk < ndsinl.length; kk++) {
		                                var vnode = ndsinl[kk];
		                                wing.set(vnode, currentWing);
		                            }
		                        }
		                    }
		                    else {
		                        currentWing = wing.get(node);
		                    }
		                }
		            }
	
		            var wings = [];
		            for (var i = 0; i < this.layers.length; i++) {
		                wings.push(null);
		            }
		            wing.forEach(function (node, classIndex) {
		                if (wings[classIndex] === null) {
		                    wings[classIndex] = [];
		                }
		                wings[classIndex].push(node);
		            });
	
		            return wings;
		        },
		        _isVerticalLayout: function () {
		            return this.options.subtype.toLowerCase() === "up" || this.options.subtype.toLowerCase() === "down" || this.options.subtype.toLowerCase() === "vertical";
		        },
	
		        _isHorizontalLayout: function () {
		            return this.options.subtype.toLowerCase() === "right" || this.options.subtype.toLowerCase() === "left" || this.options.subtype.toLowerCase() === "horizontal";
		        },
		        _isIncreasingLayout: function () {
		            // meaning that the visiting of the layers goes in the natural order of increasing layer index
		            return this.options.subtype.toLowerCase() === "right" || this.options.subtype.toLowerCase() === "down";
		        },
		        _moveThingsAround: function () {
		            var i, l, node, layer, n, w;
		            // sort the layers by their grid position
		            for (l = 0; l < this.layers.length; ++l) {
		                layer = this.layers[l];
		                layer.sort(this._gridPositionComparer);
		            }
	
		            this.minDistances = [];
		            for (l = 0; l < this.layers.length; ++l) {
		                layer = this.layers[l];
		                this.minDistances[l] = [];
		                for (n = 0; n < layer.length; ++n) {
		                    node = layer[n];
		                    node.layerIndex = n;
		                    this.minDistances[l][n] = this.options.nodeDistance;
		                    if (n < layer.length - 1) {
		                        if (this._isVerticalLayout()) {
		                            this.minDistances[l][n] += (node.width + layer[n + 1].width) / 2;
		                        }
		                        else {
		                            this.minDistances[l][n] += (node.height + layer[n + 1].height) / 2;
		                        }
		                    }
		                }
		            }
	
		            this.downNodes = new Dictionary();
		            this.upNodes = new Dictionary();
		            Utils.forEach(this.graph.nodes, function (node) {
		                this.downNodes.set(node, []);
		                this.upNodes.set(node, []);
		            }, this);
		            Utils.forEach(this.graph.links, function (link) {
		                var origin = link.source;
		                var dest = link.target;
		                var down = null, up = null;
		                if (origin.layer > dest.layer) {
		                    down = link.source;
		                    up = link.target;
		                }
		                else {
		                    up = link.source;
		                    down = link.target;
		                }
		                this.downNodes.get(up).push(down);
		                this.upNodes.get(down).push(up);
		            }, this);
		            this.downNodes.forEachValue(function (list) {
		                list.sort(this._gridPositionComparer);
		            }, this);
		            this.upNodes.forEachValue(function (list) {
		                list.sort(this._gridPositionComparer);
		            }, this);
	
		            for (l = 0; l < this.layers.length - 1; ++l) {
		                layer = this.layers[l];
		                for (w = 0; w < layer.length - 1; w++) {
		                    var currentNode = layer[w];
		                    if (!currentNode.isVirtual) {
		                        continue;
		                    }
	
		                    var currDown = this.downNodes.get(currentNode)[0];
		                    if (!currDown.isVirtual) {
		                        continue;
		                    }
	
		                    for (n = w + 1; n < layer.length; ++n) {
		                        node = layer[n];
		                        if (!node.isVirtual) {
		                            continue;
		                        }
	
		                        var downNode = this.downNodes.get(node)[0];
		                        if (!downNode.isVirtual) {
		                            continue;
		                        }
	
		                        if (currDown.gridPosition > downNode.gridPosition) {
		                            var pos = currDown.gridPosition;
		                            currDown.gridPosition = downNode.gridPosition;
		                            downNode.gridPosition = pos;
		                            var i1 = currDown.layerIndex;
		                            var i2 = downNode.layerIndex;
		                            this.layers[l + 1][i1] = downNode;
		                            this.layers[l + 1][i2] = currDown;
		                            currDown.layerIndex = i2;
		                            downNode.layerIndex = i1;
		                        }
		                    }
		                }
		            }
	
	
		            var leftClasses = this._getLeftWing();
		            var rightClasses = this._getRightWing();
	
	
		            var leftPos = this.placeLeftToRight(leftClasses);
		            var rightPos = this.placeRightToLeft(rightClasses);
		            var x = new Dictionary();
		            Utils.forEach(this.graph.nodes, function (node) {
		                x.set(node, (leftPos.get(node) + rightPos.get(node)) / 2);
		            });
	
	
		            var order = new Dictionary();
		            var placed = new Dictionary();
		            for (l = 0; l < this.layers.length; ++l) {
		                layer = this.layers[l];
		                var sequenceStart = -1, sequenceEnd = -1;
		                for (n = 0; n < layer.length; ++n) {
		                    node = layer[n];
		                    order.set(node, 0);
		                    placed.set(node, false);
		                    if (node.isVirtual) {
		                        if (sequenceStart === -1) {
		                            sequenceStart = n;
		                        }
		                        else if (sequenceStart === n - 1) {
		                            sequenceStart = n;
		                        }
		                        else {
		                            sequenceEnd = n;
		                            order.set(layer[sequenceStart], 0);
		                            if (x.get(node) - x.get(layer[sequenceStart]) === this.getMinDist(layer[sequenceStart], node)) {
		                                placed.set(layer[sequenceStart], true);
		                            }
		                            else {
		                                placed.set(layer[sequenceStart], false);
		                            }
		                            sequenceStart = n;
		                        }
		                    }
		                }
		            }
		            var directions = [1, -1];
		            Utils.forEach(directions, function (d) {
		                var start = d === 1 ? 0 : this.layers.length - 1;
		                for (var l = start; 0 <= l && l < this.layers.length; l += d) {
		                    var layer = this.layers[l];
		                    var virtualStartIndex = this._firstVirtualNode(layer);
		                    var virtualStart = null;
		                    var sequence = null;
		                    if (virtualStartIndex !== -1) {
		                        virtualStart = layer[virtualStartIndex];
		                        sequence = [];
		                        for (i = 0; i < virtualStartIndex; i++) {
		                            sequence.push(layer[i]);
		                        }
		                    }
		                    else {
		                        virtualStart = null;
		                        sequence = layer;
		                    }
		                    if (sequence.length > 0) {
		                        this._sequencer(x, null, virtualStart, d, sequence);
		                        for (i = 0; i < sequence.length - 1; ++i) {
		                            this.setMinDist(sequence[i], sequence[i + 1], x.get(sequence[i + 1]) - x.get(sequence[i]));
		                        }
		                        if (virtualStart) {
		                            this.setMinDist(sequence[sequence.length - 1], virtualStart, x.get(virtualStart) - x.get(sequence[sequence.length - 1]));
		                        }
		                    }
	
		                    while (virtualStart) {
		                        var virtualEnd = this.nextVirtualNode(layer, virtualStart);
		                        if (!virtualEnd) {
		                            virtualStartIndex = virtualStart.layerIndex;
		                            sequence = [];
		                            for (i = virtualStartIndex + 1; i < layer.length; i++) {
		                                sequence.push(layer[i]);
		                            }
		                            if (sequence.length > 0) {
		                                this._sequencer(x, virtualStart, null, d, sequence);
		                                for (i = 0; i < sequence.length - 1; ++i) {
		                                    this.setMinDist(sequence[i], sequence[i + 1], x.get(sequence[i + 1]) - x.get(sequence[i]));
		                                }
		                                this.setMinDist(virtualStart, sequence[0], x.get(sequence[0]) - x.get(virtualStart));
		                            }
		                        }
		                        else if (order.get(virtualStart) === d) {
		                            virtualStartIndex = virtualStart.layerIndex;
		                            var virtualEndIndex = virtualEnd.layerIndex;
		                            sequence = [];
		                            for (i = virtualStartIndex + 1; i < virtualEndIndex; i++) {
		                                sequence.push(layer[i]);
		                            }
		                            if (sequence.length > 0) {
		                                this._sequencer(x, virtualStart, virtualEnd, d, sequence);
		                            }
		                            placed.set(virtualStart, true);
		                        }
		                        virtualStart = virtualEnd;
		                    }
		                    this.adjustDirections(l, d, order, placed);
		                }
		            }, this);
	
	
		            var fromLayerIndex = this._isIncreasingLayout() ? 0 : this.layers.length - 1;
		            var reachedFinalLayerIndex = function (k, ctx) {
		                if (ctx._isIncreasingLayout()) {
		                    return k < ctx.layers.length;
		                }
		                else {
		                    return k >= 0;
		                }
		            };
		            var layerIncrement = this._isIncreasingLayout() ? +1 : -1, offset = 0;
	
		            /**
		             * Calcs the max height of the given layer.
		             */
		            function maximumHeight(layer, ctx) {
		                var height = Number.MIN_VALUE;
		                for (var n = 0; n < layer.length; ++n) {
		                    var node = layer[n];
		                    if (ctx._isVerticalLayout()) {
		                        height = Math.max(height, node.height);
		                    }
		                    else {
		                        height = Math.max(height, node.width);
		                    }
		                }
		                return height;
		            }
	
		            for (i = fromLayerIndex; reachedFinalLayerIndex(i, this); i += layerIncrement) {
		                layer = this.layers[i];
		                var height = maximumHeight(layer, this);
	
		                for (n = 0; n < layer.length; ++n) {
		                    node = layer[n];
		                    if (this._isVerticalLayout()) {
		                        node.x = x.get(node);
		                        node.y = offset + height / 2;
		                    }
		                    else {
		                        node.x = offset + height / 2;
		                        node.y = x.get(node);
		                    }
		                }
	
		                offset += this.options.layerSeparation + height;
		            }
		        },
	
		        adjustDirections: function (l, d, order, placed) {
		            if (l + d < 0 || l + d >= this.layers.length) {
		                return;
		            }
	
		            var prevBridge = null, prevBridgeTarget = null;
		            var layer = this.layers[l + d];
		            for (var n = 0; n < layer.length; ++n) {
		                var nextBridge = layer[n];
		                if (nextBridge.isVirtual) {
		                    var nextBridgeTarget = this.getNeighborOnLayer(nextBridge, l);
		                    if (nextBridgeTarget.isVirtual) {
		                        if (prevBridge) {
		                            var p = placed.get(prevBridgeTarget);
		                            var clayer = this.layers[l];
		                            var i1 = prevBridgeTarget.layerIndex;
		                            var i2 = nextBridgeTarget.layerIndex;
		                            for (var i = i1 + 1; i < i2; ++i) {
		                                if (clayer[i].isVirtual) {
		                                    p = p && placed.get(clayer[i]);
		                                }
		                            }
		                            if (p) {
		                                order.set(prevBridge, d);
		                                var j1 = prevBridge.layerIndex;
		                                var j2 = nextBridge.layerIndex;
		                                for (var j = j1 + 1; j < j2; ++j) {
		                                    if (layer[j].isVirtual) {
		                                        order.set(layer[j], d);
		                                    }
		                                }
		                            }
		                        }
		                        prevBridge = nextBridge;
		                        prevBridgeTarget = nextBridgeTarget;
		                    }
		                }
		            }
		        },
	
		        getNeighborOnLayer: function (node, l) {
		            var neighbor = this.upNodes.get(node)[0];
		            if (neighbor.layer === l) {
		                return neighbor;
		            }
		            neighbor = this.downNodes.get(node)[0];
		            if (neighbor.layer === l) {
		                return neighbor;
		            }
		            return null;
		        },
	
		        _sequencer: function (x, virtualStart, virtualEnd, dir, sequence) {
		            if (sequence.length === 1) {
		                this._sequenceSingle(x, virtualStart, virtualEnd, dir, sequence[0]);
		            }
	
		            if (sequence.length > 1) {
		                var r = sequence.length, t = this.intDiv(r, 2);
		                this._sequencer(x, virtualStart, virtualEnd, dir, sequence.slice(0, t));
		                this._sequencer(x, virtualStart, virtualEnd, dir, sequence.slice(t));
		                this.combineSequences(x, virtualStart, virtualEnd, dir, sequence);
		            }
		        },
	
		        _sequenceSingle: function (x, virtualStart, virtualEnd, dir, node) {
		            var neighbors = dir === -1 ? this.downNodes.get(node) : this.upNodes.get(node);
	
		            var n = neighbors.length;
		            if (n !== 0) {
		                if (n % 2 === 1) {
		                    x.set(node, x.get(neighbors[this.intDiv(n, 2)]));
		                }
		                else {
		                    x.set(node, (x.get(neighbors[this.intDiv(n, 2) - 1]) + x.get(neighbors[this.intDiv(n, 2)])) / 2);
		                }
	
		                if (virtualStart) {
		                    x.set(node, Math.max(x.get(node), x.get(virtualStart) + this.getMinDist(virtualStart, node)));
		                }
		                if (virtualEnd) {
		                    x.set(node, Math.min(x.get(node), x.get(virtualEnd) - this.getMinDist(node, virtualEnd)));
		                }
		            }
		        },
	
		        combineSequences: function (x, virtualStart, virtualEnd, dir, sequence) {
		            var r = sequence.length, t = this.intDiv(r, 2);
	
		            // collect left changes
		            var leftHeap = [], i, c, n, neighbors, neighbor, pair;
		            for (i = 0; i < t; ++i) {
		                c = 0;
		                neighbors = dir === -1 ? this.downNodes.get(sequence[i]) : this.upNodes.get(sequence[i]);
		                for (n = 0; n < neighbors.length; ++n) {
		                    neighbor = neighbors[n];
		                    if (x.get(neighbor) >= x.get(sequence[i])) {
		                        c++;
		                    }
		                    else {
		                        c--;
		                        leftHeap.push({ k: x.get(neighbor) + this.getMinDist(sequence[i], sequence[t - 1]), v: 2 });
		                    }
		                }
		                leftHeap.push({ k: x.get(sequence[i]) + this.getMinDist(sequence[i], sequence[t - 1]), v: c });
		            }
		            if (virtualStart) {
		                leftHeap.push({ k: x.get(virtualStart) + this.getMinDist(virtualStart, sequence[t - 1]), v: Number.MAX_VALUE });
		            }
		            leftHeap.sort(this._positionDescendingComparer);
	
		            // collect right changes
		            var rightHeap = [];
		            for (i = t; i < r; ++i) {
		                c = 0;
		                neighbors = dir === -1 ? this.downNodes.get(sequence[i]) : this.upNodes.get(sequence[i]);
		                for (n = 0; n < neighbors.length; ++n) {
		                    neighbor = neighbors[n];
		                    if (x.get(neighbor) <= x.get(sequence[i])) {
		                        c++;
		                    }
		                    else {
		                        c--;
		                        rightHeap.push({ k: x.get(neighbor) - this.getMinDist(sequence[i], sequence[t]), v: 2 });
		                    }
		                }
		                rightHeap.push({ k: x.get(sequence[i]) - this.getMinDist(sequence[i], sequence[t]), v: c });
		            }
		            if (virtualEnd) {
		                rightHeap.push({ k: x.get(virtualEnd) - this.getMinDist(virtualEnd, sequence[t]), v: Number.MAX_VALUE });
		            }
		            rightHeap.sort(this._positionAscendingComparer);
	
		            var leftRes = 0, rightRes = 0;
		            var m = this.getMinDist(sequence[t - 1], sequence[t]);
		            while (x.get(sequence[t]) - x.get(sequence[t - 1]) < m) {
		                if (leftRes < rightRes) {
		                    if (leftHeap.length === 0) {
		                        x.set(sequence[t - 1], x.get(sequence[t]) - m);
		                        break;
		                    }
		                    else {
		                        pair = leftHeap.shift();
		                        leftRes = leftRes + pair.v;
		                        x.set(sequence[t - 1], pair.k);
		                        x.set(sequence[t - 1], Math.max(x.get(sequence[t - 1]), x.get(sequence[t]) - m));
		                    }
		                }
		                else {
		                    if (rightHeap.length === 0) {
		                        x.set(sequence[t], x.get(sequence[t - 1]) + m);
		                        break;
		                    }
		                    else {
		                        pair = rightHeap.shift();
		                        rightRes = rightRes + pair.v;
		                        x.set(sequence[t], pair.k);
		                        x.set(sequence[t], Math.min(x.get(sequence[t]), x.get(sequence[t - 1]) + m));
		                    }
		                }
		            }
		            for (i = t - 2; i >= 0; i--) {
		                x.set(sequence[i], Math.min(x.get(sequence[i]), x.get(sequence[t - 1]) - this.getMinDist(sequence[i], sequence[t - 1])));
		            }
		            for (i = t + 1; i < r; i++) {
		                x.set(sequence[i], Math.max(x.get(sequence[i]), x.get(sequence[t]) + this.getMinDist(sequence[i], sequence[t])));
		            }
		        },
	
		        placeLeft: function (node, leftPos, leftClass) {
		            var pos = Number.NEGATIVE_INFINITY;
		            Utils.forEach(this._getComposite(node), function (v) {
		                var leftSibling = this.leftSibling(v);
		                if (leftSibling && this.nodeLeftClass.get(leftSibling) === this.nodeLeftClass.get(v)) {
		                    if (!leftPos.containsKey(leftSibling)) {
		                        this.placeLeft(leftSibling, leftPos, leftClass);
		                    }
		                    pos = Math.max(pos, leftPos.get(leftSibling) + this.getMinDist(leftSibling, v));
		                }
		            }, this);
		            if (pos === Number.NEGATIVE_INFINITY) {
		                pos = 0;
		            }
		            Utils.forEach(this._getComposite(node), function (v) {
		                leftPos.set(v, pos);
		            });
		        },
	
		        placeRight: function (node, rightPos, rightClass) {
		            var pos = Number.POSITIVE_INFINITY;
		            Utils.forEach(this._getComposite(node), function (v) {
		                var rightSibling = this.rightSibling(v);
		                if (rightSibling && this.nodeRightClass.get(rightSibling) === this.nodeRightClass.get(v)) {
		                    if (!rightPos.containsKey(rightSibling)) {
		                        this.placeRight(rightSibling, rightPos, rightClass);
		                    }
		                    pos = Math.min(pos, rightPos.get(rightSibling) - this.getMinDist(v, rightSibling));
		                }
		            }, this);
		            if (pos === Number.POSITIVE_INFINITY) {
		                pos = 0;
		            }
		            Utils.forEach(this._getComposite(node), function (v) {
		                rightPos.set(v, pos);
		            });
		        },
	
		        leftSibling: function (node) {
		            var layer = this.layers[node.layer],
		                layerIndex = node.layerIndex;
		            return layerIndex === 0 ? null : layer[layerIndex - 1];
		        },
	
		        rightSibling: function (node) {
		            var layer = this.layers[node.layer];
		            var layerIndex = node.layerIndex;
		            return layerIndex === layer.length - 1 ? null : layer[layerIndex + 1];
	
		        },
	
		        _getComposite: function (node) {
		            return node.isVirtual ? this._nodesInLink(node) : [node];
		        },
	
		        arrangeNodes: function () {
		            var i, l, ni, layer, node;
		            // Initialize node's base priority
		            for (l = 0; l < this.layers.length; l++) {
		                layer = this.layers[l];
	
		                for (ni = 0; ni < layer.length; ni++) {
		                    node = layer[ni];
		                    node.upstreamPriority = node.upstreamLinkCount;
		                    node.downstreamPriority = node.downstreamLinkCount;
		                }
		            }
	
		            // Layout is invoked after MinimizeCrossings
		            // so we may assume node's barycenters are initially correct
	
		            var maxLayoutIterations = 2;
		            for (var it = 0; it < maxLayoutIterations; it++) {
		                for (i = this.layers.length - 1; i >= 1; i--) {
		                    this.layoutLayer(false, i);
		                }
	
		                for (i = 0; i < this.layers.length - 1; i++) {
		                    this.layoutLayer(true, i);
		                }
		            }
	
		            // Offset the whole structure so that there are no gridPositions < 0
		            var gridPos = Number.MAX_VALUE;
		            for (l = 0; l < this.layers.length; l++) {
		                layer = this.layers[l];
	
		                for (ni = 0; ni < layer.length; ni++) {
		                    node = layer[ni];
		                    gridPos = Math.min(gridPos, node.gridPosition);
		                }
		            }
	
		            if (gridPos < 0) {
		                for (l = 0; l < this.layers.length; l++) {
		                    layer = this.layers[l];
	
		                    for (ni = 0; ni < layer.length; ni++) {
		                        node = layer[ni];
		                        node.gridPosition = node.gridPosition - gridPos;
		                    }
		                }
		            }
		        },
	
		        /// <summary>
		        /// Layout of a single layer.
		        /// </summary>
		        /// <param name="layerIndex">The layer to organize.</param>
		        /// <param name="movingDownwards">If set to <c>true</c> we move down in the layer stack.</param>
		        /// <seealso cref="OptimizeCrossings()"/>
		        layoutLayer: function (down, layer) {
		            var iconsidered;
		            var considered;
	
		            if (down) {
		                considered = this.layers[iconsidered = layer + 1];
		            }
		            else {
		                considered = this.layers[iconsidered = layer - 1];
		            }
	
		            // list containing the nodes in the considered layer sorted by priority
		            var sorted = [];
		            for (var n = 0; n < considered.length; n++) {
		                sorted.push(considered[n]);
		            }
		            sorted.sort(function (n1, n2) {
		                var n1Priority = (n1.upstreamPriority + n1.downstreamPriority) / 2;
		                var n2Priority = (n2.upstreamPriority + n2.downstreamPriority) / 2;
	
		                if (Math.abs(n1Priority - n2Priority) < 0.0001) {
		                    return 0;
		                }
		                if (n1Priority < n2Priority) {
		                    return 1;
		                }
		                return -1;
		            });
	
		            // each node strives for its barycenter; high priority nodes start first
		            Utils.forEach(sorted, function (node) {
		                var nodeGridPos = node.gridPosition;
		                var nodeBaryCenter = this.calcBaryCenter(node);
		                var nodePriority = (node.upstreamPriority + node.downstreamPriority) / 2;
	
		                if (Math.abs(nodeGridPos - nodeBaryCenter) < 0.0001) {
		                    // This node is exactly at its barycenter -> perfect
		                    return;
		                }
	
		                if (Math.abs(nodeGridPos - nodeBaryCenter) < 0.25 + 0.0001) {
		                    // This node is close enough to the barycenter -> should work
		                    return;
		                }
	
		                if (nodeGridPos < nodeBaryCenter) {
		                    // Try to move the node to the right in an
		                    // attempt to reach its barycenter
		                    while (nodeGridPos < nodeBaryCenter) {
		                        if (!this.moveRight(node, considered, nodePriority)) {
		                            break;
		                        }
	
		                        nodeGridPos = node.gridPosition;
		                    }
		                }
		                else {
		                    // Try to move the node to the left in an
		                    // attempt to reach its barycenter
		                    while (nodeGridPos > nodeBaryCenter) {
		                        if (!this.moveLeft(node, considered, nodePriority)) {
		                            break;
		                        }
	
		                        nodeGridPos = node.gridPosition;
		                    }
		                }
		            }, this);
	
		            // after the layer has been rearranged we need to recalculate the barycenters
		            // of the nodes in the surrounding layers
		            if (iconsidered > 0) {
		                this.calcDownData(iconsidered - 1);
		            }
		            if (iconsidered < this.layers.length - 1) {
		                this.calcUpData(iconsidered + 1);
		            }
		        },
	
		        /// <summary>
		        /// Moves the node to the right and returns <c>true</c> if this was possible.
		        /// </summary>
		        /// <param name="node">The node.</param>
		        /// <param name="layer">The layer.</param>
		        /// <returns>Returns <c>true</c> if the shift was possible, otherwise <c>false</c>.</returns>
		        moveRight: function (node, layer, priority) {
		            var index = Utils.indexOf(layer, node);
		            if (index === layer.length - 1) {
		                // this is the last node in the layer, so we can move to the right without troubles
		                node.gridPosition = node.gridPosition + 0.5;
		                return true;
		            }
	
		            var rightNode = layer[index + 1];
		            var rightNodePriority = (rightNode.upstreamPriority + rightNode.downstreamPriority) / 2;
	
		            // check if there is space between the right and the current node
		            if (rightNode.gridPosition > node.gridPosition + 1) {
		                node.gridPosition = node.gridPosition + 0.5;
		                return true;
		            }
	
		            // we have reached a node with higher priority; no movement is allowed
		            if (rightNodePriority > priority ||
		                Math.abs(rightNodePriority - priority) < 0.0001) {
		                return false;
		            }
	
		            // the right node has lower priority - try to move it
		            if (this.moveRight(rightNode, layer, priority)) {
		                node.gridPosition = node.gridPosition + 0.5;
		                return true;
		            }
	
		            return false;
		        },
	
		        /// <summary>
		        /// Moves the node to the left and returns <c>true</c> if this was possible.
		        /// </summary>
		        /// <param name="node">The node.</param>
		        /// <param name="layer">The layer.</param>
		        /// <returns>Returns <c>true</c> if the shift was possible, otherwise <c>false</c>.</returns>
		        moveLeft: function (node, layer, priority) {
		            var index = Utils.indexOf(layer, node);
		            if (index === 0) {
		                // this is the last node in the layer, so we can move to the left without troubles
		                node.gridPosition = node.gridPosition - 0.5;
		                return true;
		            }
	
		            var leftNode = layer[index - 1];
		            var leftNodePriority = (leftNode.upstreamPriority + leftNode.downstreamPriority) / 2;
	
		            // check if there is space between the left and the current node
		            if (leftNode.gridPosition < node.gridPosition - 1) {
		                node.gridPosition = node.gridPosition - 0.5;
		                return true;
		            }
	
		            // we have reached a node with higher priority; no movement is allowed
		            if (leftNodePriority > priority ||
		                Math.abs(leftNodePriority - priority) < 0.0001) {
		                return false;
		            }
	
		            // The left node has lower priority - try to move it
		            if (this.moveLeft(leftNode, layer, priority)) {
		                node.gridPosition = node.gridPosition - 0.5;
		                return true;
		            }
	
		            return false;
		        },
	
		        mapVirtualNode: function (node, link) {
		            this.nodeToLinkMap.set(node, link);
		            if (!this.linkToNodeMap.containsKey(link)) {
		                this.linkToNodeMap.set(link, []);
		            }
		            this.linkToNodeMap.get(link).push(node);
		        },
	
		        _nodesInLink: function (node) {
		            return this.linkToNodeMap.get(this.nodeToLinkMap.get(node));
		        },
	
		        /// <summary>
		        /// Inserts dummy nodes to break long links.
		        /// </summary>
		        _dummify: function () {
		            this.linkToNodeMap = new Dictionary();
		            this.nodeToLinkMap = new Dictionary();
	
		            var layer, pos, newNode, node, r, newLink, i, l, links = this.graph.links.slice(0);
		            var layers = this.layers;
	
		            var addLinkBetweenLayers = function(upLayer, downLayer, link) {
		                layers[upLayer].linksTo[downLayer] = layers[upLayer].linksTo[downLayer] || [];
		                layers[upLayer].linksTo[downLayer].push(link);
		            };
	
		            for (l = 0; l < links.length; l++) {
		                var link = links[l];
		                var o = link.source;
		                var d = link.target;
	
		                var oLayer = o.layer;
		                var dLayer = d.layer;
		                var oPos = o.gridPosition;
		                var dPos = d.gridPosition;
	
		                var step = (dPos - oPos) / Math.abs(dLayer - oLayer);
	
		                var p = o;
		                if (oLayer - dLayer > 1) {
		                    for (i = oLayer - 1; i > dLayer; i--) {
		                        newNode = new Node();
		                        newNode.x = o.x;
		                        newNode.y = o.y;
		                        newNode.width = o.width / 100;
		                        newNode.height = o.height / 100;
	
		                        layer = layers[i];
		                        pos = (i - dLayer) * step + oPos;
		                        if (pos > layer.length) {
		                            pos = layer.length;
		                        }
	
		                        // check if origin and dest are both last
		                        if (oPos >= layers[oLayer].length - 1 &&
		                            dPos >= layers[dLayer].length - 1) {
		                            pos = layer.length;
		                        }
	
		                        // check if origin and destination are both first
		                        else if (oPos === 0 && dPos === 0) {
		                            pos = 0;
		                        }
	
		                        newNode.layer = i;
		                        newNode.uBaryCenter = 0.0;
		                        newNode.dBaryCenter = 0.0;
		                        newNode.upstreamLinkCount = 0;
		                        newNode.downstreamLinkCount = 0;
		                        newNode.gridPosition = pos;
		                        newNode.isVirtual = true;
	
		                        Utils.insert(layer, newNode, pos);
	
		                        // translate rightwards nodes' positions
		                        for (r = pos + 1; r < layer.length; r++) {
		                            node = layer[r];
		                            node.gridPosition = node.gridPosition + 1;
		                        }
	
		                        newLink = new Link(p, newNode);
		                        newLink.depthOfDumminess = 0;
	
		                        addLinkBetweenLayers(i - 1, i, newLink);
	
		                        p = newNode;
	
		                        // add the new node and the new link to the graph
		                        this.graph._addNode(newNode);
		                        this.graph.addLink(newLink);
	
		                        newNode.index = this.graph.nodes.length - 1;
		                        this.mapVirtualNode(newNode, link);
		                    }
	
		                    // set the origin of the real arrow to the last dummy
		                    addLinkBetweenLayers(dLayer - 1, dLayer, newLink);
		                    link.changeSource(p);
		                    link.depthOfDumminess = oLayer - dLayer - 1;
		                } else if (oLayer - dLayer < -1) {
		                    for (i = oLayer + 1; i < dLayer; i++) {
		                        newNode = new Node();
		                        newNode.x = o.x;
		                        newNode.y = o.y;
		                        newNode.width = o.width / 100;
		                        newNode.height = o.height / 100;
	
		                        layer = layers[i];
		                        pos = (i - oLayer) * step + oPos;
		                        if (pos > layer.length) {
		                            pos = layer.length;
		                        }
	
		                        // check if origin and dest are both last
		                        if (oPos >= layers[oLayer].length - 1 &&
		                            dPos >= layers[dLayer].length - 1) {
		                            pos = layer.length;
		                        }
	
		                        // check if origin and destination are both first
		                        else if (oPos === 0 && dPos === 0) {
		                            pos = 0;
		                        }
	
		                        newNode.layer = i;
		                        newNode.uBaryCenter = 0.0;
		                        newNode.dBaryCenter = 0.0;
		                        newNode.upstreamLinkCount = 0;
		                        newNode.downstreamLinkCount = 0;
		                        newNode.gridPosition = pos;
		                        newNode.isVirtual = true;
	
		                        pos &= pos; // truncates to int
		                        Utils.insert(layer, newNode, pos);
	
		                        // translate rightwards nodes' positions
		                        for (r = pos + 1; r < layer.length; r++) {
		                            node = layer[r];
		                            node.gridPosition = node.gridPosition + 1;
		                        }
	
		                        newLink = new Link(p, newNode);
		                        newLink.depthOfDumminess = 0;
		                        addLinkBetweenLayers(i - 1, i, newLink);
	
		                        p = newNode;
	
		                        // add the new node and the new link to the graph
		                        this.graph._addNode(newNode);
		                        this.graph.addLink(newLink);
	
		                        newNode.index = this.graph.nodes.length - 1;
		                        this.mapVirtualNode(newNode, link);
		                    }
		                    addLinkBetweenLayers(dLayer - 1, dLayer, link);
	
		                    // Set the origin of the real arrow to the last dummy
		                    link.changeSource(p);
		                    link.depthOfDumminess = dLayer - oLayer - 1;
		                } else {
		                    addLinkBetweenLayers(oLayer, dLayer, link);
		                }
		            }
		        },
	
		        /// <summary>
		        /// Removes the dummy nodes inserted earlier to break long links.
		        /// </summary>
		        /// <remarks>The virtual nodes are effectively turned into intermediate connection points.</remarks>
		        _dedummify: function () {
		            var dedum = true;
		            while (dedum) {
		                dedum = false;
	
		                for (var l = 0; l < this.graph.links.length; l++) {
		                    var link = this.graph.links[l];
		                    if (!link.depthOfDumminess) {
		                        continue;
		                    }
	
		                    var points = [];
	
		                    // add points in reverse order
		                    points.unshift({ x: link.target.x, y: link.target.y });
		                    points.unshift({ x: link.source.x, y: link.source.y });
	
		                    // _dedummify the link
		                    var temp = link;
		                    var depthOfDumminess = link.depthOfDumminess;
		                    for (var d = 0; d < depthOfDumminess; d++) {
		                        var node = temp.source;
		                        var prevLink = node.incoming[0];
	
		                        points.unshift({ x: prevLink.source.x, y: prevLink.source.y });
	
		                        temp = prevLink;
		                    }
	
		                    // restore the original link origin
		                    link.changeSource(temp.source);
	
		                    // reset dummification flag
		                    link.depthOfDumminess = 0;
	
		                    // note that we only need the intermediate points, floating links have been dropped in the analysis
		                    if (points.length > 2) {
		                        // first and last are the endpoints
		                        points.splice(0, 1);
		                        points.splice(points.length - 1);
		                        link.points = points;
		                    }
		                    else {
		                        link.points = [];
		                    }
	
		                    // we are not going to delete the dummy elements;
		                    // they won't be needed anymore anyway.
	
		                    dedum = true;
		                    break;
		                }
		            }
		        },
	
		        /// <summary>
		        /// Optimizes/reduces the crossings between the layers by turning the crossing problem into a (combinatorial) number ordering problem.
		        /// </summary>
		        _optimizeCrossings: function () {
		            var moves = -1, i;
		            var maxIterations = 3;
		            var iter = 0;
	
		            while (moves !== 0) {
		                if (iter++ > maxIterations) {
		                    break;
		                }
	
		                moves = 0;
	
		                for (i = this.layers.length - 1; i >= 1; i--) {
		                    moves += this.optimizeLayerCrossings(false, i);
		                }
	
		                for (i = 0; i < this.layers.length - 1; i++) {
		                    moves += this.optimizeLayerCrossings(true, i);
		                }
		            }
		        },
	
		        calcUpData: function (layer) {
		            if (layer === 0) {
		                return;
		            }
	
		            var considered = this.layers[layer], i, l, link;
		            var upLayer = new Set();
		            var temp = this.layers[layer - 1];
		            for (i = 0; i < temp.length; i++) {
		                upLayer.add(temp[i]);
		            }
	
		            for (i = 0; i < considered.length; i++) {
		                var node = considered[i];
	
		                // calculate barycenter
		                var sum = 0;
		                var total = 0;
	
		                for (l = 0; l < node.incoming.length; l++) {
		                    link = node.incoming[l];
		                    if (upLayer.contains(link.source)) {
		                        total++;
		                        sum += link.source.gridPosition;
		                    }
		                }
	
		                for (l = 0; l < node.outgoing.length; l++) {
		                    link = node.outgoing[l];
		                    if (upLayer.contains(link.target)) {
		                        total++;
		                        sum += link.target.gridPosition;
		                    }
		                }
	
		                if (total > 0) {
		                    node.uBaryCenter = sum / total;
		                    node.upstreamLinkCount = total;
		                }
		                else {
		                    node.uBaryCenter = i;
		                    node.upstreamLinkCount = 0;
		                }
		            }
		        },
	
		        calcDownData: function (layer) {
		            if (layer === this.layers.length - 1) {
		                return;
		            }
	
		            var considered = this.layers[layer], i , l, link;
		            var downLayer = new Set();
		            var temp = this.layers[layer + 1];
		            for (i = 0; i < temp.length; i++) {
		                downLayer.add(temp[i]);
		            }
	
		            for (i = 0; i < considered.length; i++) {
		                var node = considered[i];
	
		                // calculate barycenter
		                var sum = 0;
		                var total = 0;
	
		                for (l = 0; l < node.incoming.length; l++) {
		                    link = node.incoming[l];
		                    if (downLayer.contains(link.source)) {
		                        total++;
		                        sum += link.source.gridPosition;
		                    }
		                }
	
		                for (l = 0; l < node.outgoing.length; l++) {
		                    link = node.outgoing[l];
		                    if (downLayer.contains(link.target)) {
		                        total++;
		                        sum += link.target.gridPosition;
		                    }
		                }
	
		                if (total > 0) {
		                    node.dBaryCenter = sum / total;
		                    node.downstreamLinkCount = total;
		                }
		                else {
		                    node.dBaryCenter = i;
		                    node.downstreamLinkCount = 0;
		                }
		            }
		        },
	
		        /// <summary>
		        /// Optimizes the crossings.
		        /// </summary>
		        /// <remarks>The big trick here is the usage of weights or values attached to connected nodes which turn a problem of crossing links
		        /// to an a problem of ordering numbers.</remarks>
		        /// <param name="layerIndex">The layer index.</param>
		        /// <param name="movingDownwards">If set to <c>true</c> we move down in the layer stack.</param>
		        /// <returns>The number of nodes having moved, i.e. the number of crossings reduced.</returns>
		        optimizeLayerCrossings: function (down, layer) {
		            var iconsidered;
		            var considered;
	
		            if (down) {
		                considered = this.layers[iconsidered = layer + 1];
		            }
		            else {
		                considered = this.layers[iconsidered = layer - 1];
		            }
	
		            // remember what it was
		            var presorted = considered.slice(0);
	
		            // calculate barycenters for all nodes in the considered layer
		            if (down) {
		                this.calcUpData(iconsidered);
		            }
		            else {
		                this.calcDownData(iconsidered);
		            }
	
		            var that = this;
		            // sort nodes within this layer according to the barycenters
		            considered.sort(function(n1, n2) {
		                var n1BaryCenter = that.calcBaryCenter(n1),
		                    n2BaryCenter = that.calcBaryCenter(n2);
		                if (Math.abs(n1BaryCenter - n2BaryCenter) < 0.0001) {
		                    // in case of coinciding barycenters compare by the count of in/out links
		                    if (n1.degree() === n2.degree()) {
		                        return that.compareByIndex(n1, n2);
		                    }
		                    else if (n1.degree() < n2.degree()) {
		                        return 1;
		                    }
		                    return -1;
		                }
		                var compareValue = (n2BaryCenter - n1BaryCenter) * 1000;
		                if (compareValue > 0) {
		                    return -1;
		                }
		                else if (compareValue < 0) {
		                    return 1;
		                }
		                return that.compareByIndex(n1, n2);
		            });
	
		            // count relocations
		            var i, moves = 0;
		            for (i = 0; i < considered.length; i++) {
		                if (considered[i] !== presorted[i]) {
		                    moves++;
		                }
		            }
	
		            if (moves > 0) {
		                // now that the boxes have been arranged, update their grid positions
		                var inode = 0;
		                for (i = 0; i < considered.length; i++) {
		                    var node = considered[i];
		                    node.gridPosition = inode++;
		                }
		            }
	
		            return moves;
		        },
	
		        /// <summary>
		        /// Swaps a pair of nodes in a layer.
		        /// </summary>
		        /// <param name="layerIndex">Index of the layer.</param>
		        /// <param name="n">The Nth node in the layer.</param>
		        _swapPairs: function () {
		            var maxIterations = this.options.layeredIterations;
		            var iter = 0;
	
		            while (true) {
		                if (iter++ > maxIterations) {
		                    break;
		                }
	
		                var downwards = (iter % 4 <= 1);
		                var secondPass = (iter % 4 === 1);
	
		                for (var l = (downwards ? 0 : this.layers.length - 1);
		                     downwards ? l <= this.layers.length - 1 : l >= 0; l += (downwards ? 1 : -1)) {
		                    var layer = this.layers[l];
		                    var hasSwapped = false;
	
		                    // there is no need to recalculate crossings if they were calculated
		                    // on the previous step and nothing has changed
		                    var calcCrossings = true;
		                    var memCrossings = 0;
	
		                    for (var n = 0; n < layer.length - 1; n++) {
		                        // count crossings
		                        var up = 0;
		                        var down = 0;
		                        var crossBefore = 0;
	
		                        if (calcCrossings) {
		                            if (l !== 0) {
		                                up = this.countLinksCrossingBetweenTwoLayers(l - 1, l);
		                            }
		                            if (l !== this.layers.length - 1) {
		                                down = this.countLinksCrossingBetweenTwoLayers(l, l + 1);
		                            }
		                            if (downwards) {
		                                up *= 2;
		                            }
		                            else {
		                                down *= 2;
		                            }
	
		                            crossBefore = up + down;
		                        }
		                        else {
		                            crossBefore = memCrossings;
		                        }
	
		                        if (crossBefore === 0) {
		                            continue;
		                        }
	
		                        // Swap nodes
		                        var node1 = layer[n];
		                        var node2 = layer[n + 1];
	
		                        var node1GridPos = node1.gridPosition;
		                        var node2GridPos = node2.gridPosition;
		                        layer[n] = node2;
		                        layer[n + 1] = node1;
		                        node1.gridPosition = node2GridPos;
		                        node2.gridPosition = node1GridPos;
	
		                        // count crossings again and if worse than before, restore swapping
		                        up = 0;
		                        if (l !== 0) {
		                            up = this.countLinksCrossingBetweenTwoLayers(l - 1, l);
		                        }
		                        down = 0;
		                        if (l !== this.layers.length - 1) {
		                            down = this.countLinksCrossingBetweenTwoLayers(l, l + 1);
		                        }
		                        if (downwards) {
		                            up *= 2;
		                        }
		                        else {
		                            down *= 2;
		                        }
		                        var crossAfter = up + down;
	
		                        var revert = false;
		                        if (secondPass) {
		                            revert = crossAfter >= crossBefore;
		                        }
		                        else {
		                            revert = crossAfter > crossBefore;
		                        }
	
		                        if (revert) {
		                            node1 = layer[n];
		                            node2 = layer[n + 1];
	
		                            node1GridPos = node1.gridPosition;
		                            node2GridPos = node2.gridPosition;
		                            layer[n] = node2;
		                            layer[n + 1] = node1;
		                            node1.gridPosition = node2GridPos;
		                            node2.gridPosition = node1GridPos;
	
		                            // nothing has changed, remember the crossings so that
		                            // they are not calculated again on the next step
		                            memCrossings = crossBefore;
		                            calcCrossings = false;
		                        }
		                        else {
		                            hasSwapped = true;
		                            calcCrossings = true;
		                        }
		                    }
	
		                    if (hasSwapped) {
		                        if (l !== this.layers.length - 1) {
		                            this.calcUpData(l + 1);
		                        }
		                        if (l !== 0) {
		                            this.calcDownData(l - 1);
		                        }
		                    }
		                }
		            }
		        },
	
		        /// <summary>
		        /// Counts the number of links crossing between two layers.
		        /// </summary>
		        /// <param name="layerIndex1">The layer index.</param>
		        /// <param name="layerIndex2">Another layer index.</param>
		        /// <returns></returns>
		        countLinksCrossingBetweenTwoLayers: function (ulayer, dlayer) {
		            var links = this.layers[ulayer].linksTo[dlayer];
		            var link1, link2, n11, n12, n21, n22, l1, l2;
		            var crossings = 0;
		            var length = links.length;
	
		            for (l1 = 0; l1 < length; l1++) {
		                link1 = links[l1];
		                for (l2 = l1 + 1; l2 < length; l2++) {
	
		                    link2 = links[l2];
	
		                    if (link1.target.layer === dlayer) {
		                        n11 = link1.source;
		                        n12 = link1.target;
		                    }
		                    else {
		                        n11 = link1.target;
		                        n12 = link1.source;
		                    }
	
		                    if (link2.target.layer === dlayer) {
		                        n21 = link2.source;
		                        n22 = link2.target;
		                    }
		                    else {
		                        n21 = link2.target;
		                        n22 = link2.source;
		                    }
	
		                    var n11gp = n11.gridPosition;
		                    var n12gp = n12.gridPosition;
		                    var n21gp = n21.gridPosition;
		                    var n22gp = n22.gridPosition;
	
		                    if ((n11gp - n21gp) * (n12gp - n22gp) < 0) {
		                        crossings++;
		                    }
		                }
		            }
	
		            return crossings;
		        },
	
		        calcBaryCenter: function (node) {
		            var upstreamLinkCount = node.upstreamLinkCount;
		            var downstreamLinkCount = node.downstreamLinkCount;
		            var uBaryCenter = node.uBaryCenter;
		            var dBaryCenter = node.dBaryCenter;
	
		            if (upstreamLinkCount > 0 && downstreamLinkCount > 0) {
		                return (uBaryCenter + dBaryCenter) / 2;
		            }
		            if (upstreamLinkCount > 0) {
		                return uBaryCenter;
		            }
		            if (downstreamLinkCount > 0) {
		                return dBaryCenter;
		            }
	
		            return 0;
		        },
	
		        _gridPositionComparer: function (x, y) {
		            if (x.gridPosition < y.gridPosition) {
		                return -1;
		            }
		            if (x.gridPosition > y.gridPosition) {
		                return 1;
		            }
		            return 0;
		        },
	
		        _positionAscendingComparer: function (x, y) {
		            return x.k < y.k ? -1 : x.k > y.k ? 1 : 0;
		        },
	
		        _positionDescendingComparer: function (x, y) {
		            return x.k < y.k ? 1 : x.k > y.k ? -1 : 0;
		        },
	
		        _firstVirtualNode: function (layer) {
		            for (var c = 0; c < layer.length; c++) {
		                if (layer[c].isVirtual) {
		                    return c;
		                }
		            }
		            return -1;
		        },
	
		        compareByIndex: function (o1, o2) {
		            var i1 = o1.index;
		            var i2 = o2.index;
	
		            if (i1 < i2) {
		                return 1;
		            }
	
		            if (i1 > i2) {
		                return -1;
		            }
	
		            return 0;
		        },
	
		        intDiv: function (numerator, denominator) {
		            return (numerator - numerator % denominator) / denominator;
		        },
	
		        nextVirtualNode: function (layer, node) {
		            var nodeIndex = node.layerIndex;
		            for (var i = nodeIndex + 1; i < layer.length; ++i) {
		                if (layer[i].isVirtual) {
		                    return layer[i];
		                }
		            }
		            return null;
		        }
	
		    });
	
		    /**
		     * Captures the state of a diagram; node positions, link points and so on.
		     * @type {*}
		     */
		    var LayoutState = kendo.Class.extend({
		        init: function (diagram, graphOrNodes) {
		            if (Utils.isUndefined(diagram)) {
		                throw "No diagram given";
		            }
		            this.diagram = diagram;
		            this.nodeMap = new Dictionary();
		            this.linkMap = new Dictionary();
		            this.capture(graphOrNodes ? graphOrNodes : diagram);
		        },
	
		        /**
		         * Will capture either
		         * - the state of the shapes and the intermediate points of the connections in the diagram
		         * - the bounds of the nodes contained in the Graph together with the intermediate points of the links in the Graph
		         * - the bounds of the nodes in the Array<Node>
		         * - the links points and node bounds in the literal object
		         * @param diagramOrGraphOrNodes
		         */
		        capture: function (diagramOrGraphOrNodes) {
		            var node,
		                nodes,
		                shape,
		                i,
		                conn,
		                link,
		                links;
	
		            if (diagramOrGraphOrNodes instanceof diagram.Graph) {
	
		                for (i = 0; i < diagramOrGraphOrNodes.nodes.length; i++) {
		                    node = diagramOrGraphOrNodes.nodes[i];
		                    shape = node.associatedShape;
		                    //shape.bounds(new Rect(node.x, node.y, node.width, node.height));
		                    this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
		                }
		                for (i = 0; i < diagramOrGraphOrNodes.links.length; i++) {
		                    link = diagramOrGraphOrNodes.links[i];
		                    conn = link.associatedConnection;
		                    this.linkMap.set(conn.visual.id, link.points());
		                }
		            }
		            else if (diagramOrGraphOrNodes instanceof Array) {
		                nodes = diagramOrGraphOrNodes;
		                for (i = 0; i < nodes.length; i++) {
		                    node = nodes[i];
		                    shape = node.associatedShape;
		                    if (shape) {
		                        this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
		                    }
		                }
		            }
		            else if (diagramOrGraphOrNodes.hasOwnProperty("links") && diagramOrGraphOrNodes.hasOwnProperty("nodes")) {
		                nodes = diagramOrGraphOrNodes.nodes;
		                links = diagramOrGraphOrNodes.links;
		                for (i = 0; i < nodes.length; i++) {
		                    node = nodes[i];
		                    shape = node.associatedShape;
		                    if (shape) {
		                        this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
		                    }
		                }
		                for (i = 0; i < links.length; i++) {
		                    link = links[i];
		                    conn = link.associatedConnection;
		                    if (conn) {
		                        this.linkMap.set(conn.visual.id, link.points);
		                    }
		                }
		            }
		            else { // capture the diagram
		                var shapes = this.diagram.shapes;
		                var connections = this.diagram.connections;
		                for (i = 0; i < shapes.length; i++) {
		                    shape = shapes[i];
		                    this.nodeMap.set(shape.visual.id, shape.bounds());
		                }
		                for (i = 0; i < connections.length; i++) {
		                    conn = connections[i];
		                    this.linkMap.set(conn.visual.id, conn.points());
		                }
		            }
		        }
		    });
	
		    deepExtend(diagram, {
		        init: function (element) {
		            kendo.init(element, diagram.ui);
		        },
		        SpringLayout: SpringLayout,
		        TreeLayout: TreeLayout,
		        GraphAdapter: DiagramToHyperTreeAdapter,
		        LayeredLayout: LayeredLayout,
		        LayoutBase: LayoutBase,
		        LayoutState: LayoutState
		    });
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 877:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(778);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(867);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 856:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 857:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(742);
	
	/***/ }),
	
	/***/ 858:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(745);
	
	/***/ }),
	
	/***/ 867:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(856), __webpack_require__(869), __webpack_require__(870),
		           __webpack_require__(871),
		           __webpack_require__(872),
		           __webpack_require__(868),
		           __webpack_require__(857),
		           __webpack_require__(858),
		           __webpack_require__(873),
		           __webpack_require__(874),
		           __webpack_require__(875) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function () {
	
		    (function ($, undefined) {
		        // Imports ================================================================
		        var dataviz = kendo.dataviz,
		            draw = kendo.drawing,
		            geom = kendo.geometry,
		            diagram = dataviz.diagram,
		            Widget = kendo.ui.Widget,
		            Class = kendo.Class,
		            proxy = $.proxy,
		            deepExtend = kendo.deepExtend,
		            outerWidth = kendo._outerWidth,
		            outerHeight = kendo._outerHeight,
		            extend = $.extend,
		            HierarchicalDataSource = kendo.data.HierarchicalDataSource,
		            Canvas = diagram.Canvas,
		            Group = diagram.Group,
		            Rectangle = diagram.Rectangle,
		            Circle = diagram.Circle,
		            CompositeTransform = diagram.CompositeTransform,
		            Rect = diagram.Rect,
		            Path = diagram.Path,
		            DeleteShapeUnit = diagram.DeleteShapeUnit,
		            DeleteConnectionUnit = diagram.DeleteConnectionUnit,
		            TextBlock = diagram.TextBlock,
		            Image = diagram.Image,
		            Point = diagram.Point,
		            Intersect = diagram.Intersect,
		            ConnectionEditAdorner = diagram.ConnectionEditAdorner,
		            UndoRedoService = diagram.UndoRedoService,
		            ToolService = diagram.ToolService,
		            Selector = diagram.Selector,
		            ResizingAdorner = diagram.ResizingAdorner,
		            ConnectorsAdorner = diagram.ConnectorsAdorner,
		            Cursors = diagram.Cursors,
		            Utils = diagram.Utils,
		            Observable = kendo.Observable,
		            ToBackUnit = diagram.ToBackUnit,
		            ToFrontUnit = diagram.ToFrontUnit,
		            PolylineRouter = diagram.PolylineRouter,
		            CascadingRouter = diagram.CascadingRouter,
		            isUndefined = Utils.isUndefined,
		            isDefined = Utils.isDefined,
		            defined = draw.util.defined,
		            isArray = $.isArray,
		            isFunction = kendo.isFunction,
		            isString = Utils.isString,
		            isPlainObject = $.isPlainObject,
	
		            math = Math;
	
		        var SASS_THEMES = ["sass", "default-v2", "bootstrap-v4"];
	
		        // Constants ==============================================================
		        var NS = ".kendoDiagram",
		            CASCADING = "cascading",
		            ITEMBOUNDSCHANGE = "itemBoundsChange",
		            CHANGE = "change",
		            CLICK = "click",
		            DRAG = "drag",
		            DRAG_END = "dragEnd",
		            DRAG_START = "dragStart",
		            MOUSE_ENTER = "mouseEnter",
		            MOUSE_LEAVE = "mouseLeave",
		            ERROR = "error",
		            AUTO = "Auto",
		            TOP = "Top",
		            RIGHT = "Right",
		            LEFT = "Left",
		            BOTTOM = "Bottom",
		            MAXINT = 9007199254740992,
		            SELECT = "select",
		            ITEMROTATE = "itemRotate",
		            PAN = "pan",
		            ZOOM_START = "zoomStart",
		            ZOOM_END = "zoomEnd",
		            NONE = "none",
		            DEFAULT_CANVAS_WIDTH = 600,
		            DEFAULT_CANVAS_HEIGHT = 600,
		            DEFAULT_SHAPE_TYPE = "rectangle",
		            DEFAULT_SHAPE_WIDTH = 100,
		            DEFAULT_SHAPE_HEIGHT = 100,
		            DEFAULT_SHAPE_MINWIDTH = 20,
		            DEFAULT_SHAPE_MINHEIGHT = 20,
		            DEFAULT_SHAPE_POSITION = 0,
		            DEFAULT_CONNECTION_BACKGROUND = "Yellow",
		            MAX_VALUE = Number.MAX_VALUE,
		            MIN_VALUE = -Number.MAX_VALUE,
		            ABSOLUTE = "absolute",
		            TRANSFORMED = "transformed",
		            ROTATED = "rotated",
		            TRANSPARENT = "transparent",
		            WIDTH = "width",
		            HEIGHT = "height",
		            X = "x",
		            Y = "y",
		            MOUSEWHEEL_NS = "DOMMouseScroll" + NS + " mousewheel" + NS,
		            MOBILE_ZOOM_RATE = 0.05,
		            MOBILE_PAN_DISTANCE = 5,
		            BUTTON_TEMPLATE = '<a class="k-button k-button-icontext #=className#" href="\\#"><span class="#=iconClass# #=imageClass#"></span>#=text#</a>',
		            CONNECTION_CONTENT_OFFSET = 5;
	
		        diagram.DefaultConnectors = [{
		            name: TOP
		        }, {
		            name: BOTTOM
		        }, {
		            name: LEFT
		        }, {
		            name: RIGHT
		        }, {
		            name: AUTO,
		            position: function (shape) {
		                return shape.getPosition("center");
		            }
		        }];
	
		        var defaultButtons = {
		            cancel: {
		                text: "Cancel",
		                imageClass: "k-i-cancel",
		                className: "k-diagram-cancel",
		                iconClass: "k-icon"
		            },
		            update: {
		                text: "Update",
		                imageClass: "k-i-checkmark",
		                className: "k-diagram-update",
		                iconClass: "k-icon"
		            }
		        };
	
		        diagram.shapeDefaults = function(extra) {
		            var defaults = {
		                type: DEFAULT_SHAPE_TYPE,
		                path: "",
		                autoSize: true,
		                visual: null,
		                x: DEFAULT_SHAPE_POSITION,
		                y: DEFAULT_SHAPE_POSITION,
		                minWidth: DEFAULT_SHAPE_MINWIDTH,
		                minHeight: DEFAULT_SHAPE_MINHEIGHT,
		                width: DEFAULT_SHAPE_WIDTH,
		                height: DEFAULT_SHAPE_HEIGHT,
		                hover: {},
		                editable: {
		                    connect: true,
		                    tools: []
		                },
		                connectors: diagram.DefaultConnectors,
		                rotation: {
		                    angle: 0
		                }
		            };
	
		            Utils.simpleExtend(defaults, extra);
	
		            return defaults;
		        };
	
		        function mwDelta(e) {
		            var origEvent = e.originalEvent,
		                delta = 0;
	
		            if (origEvent.wheelDelta) {
		                delta = -origEvent.wheelDelta / 40;
		                delta = delta > 0 ? math.ceil(delta) : math.floor(delta);
		            } else if (origEvent.detail) {
		                delta = origEvent.detail;
		            }
	
		            return delta;
		        }
	
		        function isAutoConnector(connector) {
		            return connector.options.name.toLowerCase() === AUTO.toLowerCase();
		        }
	
		        function closestConnector(point, connectors) {
		            var minimumDistance = MAXINT, resCtr, connector;
		            for (var i = 0; i < connectors.length; i++) {
		                connector = connectors[i];
		                if (!isAutoConnector(connector)) {
		                    var dist = point.distanceTo(connector.position());
		                    if (dist < minimumDistance) {
		                        minimumDistance = dist;
		                        resCtr = connector;
		                    }
		                }
		            }
		            return resCtr;
		        }
	
		        function indicesOfItems(group, visuals) {
		            var i, indices = [], visual;
		            var children = group.drawingContainer().children;
		            var length = children.length;
		            for (i = 0; i < visuals.length; i++) {
		                visual = visuals[i];
		                for (var j = 0; j < length; j++) {
		                    if (children[j] == visual.drawingContainer()) {
		                        indices.push(j);
		                        break;
		                    }
		                }
		            }
		            return indices;
		        }
	
		        var DiagramElement = Observable.extend({
		            init: function (options) {
		                var that = this;
		                that.dataItem = (options || {}).dataItem;
		                Observable.fn.init.call(that);
		                that.options = deepExtend({ id: diagram.randomId() }, that.options, options);
		                that.isSelected = false;
		                that.visual = new Group({
		                    id: that.options.id,
		                    autoSize: that.options.autoSize
		                });
		                that.id = that.options.id;
		                that._template();
		            },
	
		            options: {
		                hover: {},
		                cursor: Cursors.grip,
		                content: {
		                    align: "center middle"
		                },
		                selectable: true,
		                serializable: true,
		                enable: true
		            },
	
		            _getCursor: function (point) {
		                if (this.adorner) {
		                    return this.adorner._getCursor(point);
		                }
		                return this.options.cursor;
		            },
	
		            visible: function (value) {
		                if (isUndefined(value)) {
		                    return this.visual.visible();
		                } else {
		                    this.visual.visible(value);
		                }
		            },
	
		            bounds: function () {
		            },
	
		            refresh: function () {
		                this.visual.redraw();
		            },
	
		            position: function (point) {
		                this.options.x = point.x;
		                this.options.y = point.y;
		                this.visual.position(point);
		            },
	
		            toString: function () {
		                return this.options.id;
		            },
	
		            serialize: function () {
		                // the options json object describes the shape perfectly. So this object can serve as shape serialization.
		                var json = deepExtend({}, {options: this.options});
		                if (this.dataItem) {
		                    json.dataItem = this.dataItem.toString();
		                }
		                return json;
		            },
	
		            _content: function (content) {
		                if (content !== undefined) {
		                    var options = this.options;
	
		                    if (diagram.Utils.isString(content)) {
		                        options.content.text = content;
		                    } else {
		                        deepExtend(options.content, content);
		                    }
	
		                    var contentOptions = options.content;
		                    var contentVisual = this._contentVisual;
	
		                    if (!contentVisual) {
		                        this._createContentVisual(contentOptions);
		                    } else {
		                        this._updateContentVisual(contentOptions);
		                    }
		                }
	
		                return this.options.content.text;
		            },
	
		            _createContentVisual: function(options) {
		                if (options.text) {
		                    this._contentVisual = new TextBlock(options);
		                    this._contentVisual._includeInBBox = false;
		                    this.visual.append(this._contentVisual);
		                }
		            },
	
		            _updateContentVisual: function(options) {
		                this._contentVisual.redraw(options);
		            },
	
		            _hitTest: function (point) {
		                var bounds = this.bounds();
		                return this.visible() && bounds.contains(point) && this.options.enable;
		            },
	
		            _template: function () {
		                var that = this;
		                if (that.options.content.template) {
		                    var data = that.dataItem || {},
		                        elementTemplate = kendo.template(that.options.content.template, {
		                            paramName: "dataItem"
		                        });
	
		                    that.options.content.text = elementTemplate(data);
		                }
		            },
	
		            _canSelect: function () {
		                return this.options.selectable !== false;
		            },
	
		            toJSON: function() {
		                return {
		                    id: this.options.id
		                };
		            }
		        });
	
		        var Connector = Class.extend({
		            init: function (shape, options) {
		                this.options = deepExtend({}, this.options, options);
		                this.connections = [];
		                this.shape = shape;
		            },
		            options: {
		                width: 7,
		                height: 7,
		                fill: {
		                    color: DEFAULT_CONNECTION_BACKGROUND
		                },
		                hover: {}
		            },
		            position: function () {
		                if (this.options.position) {
		                    return this.options.position(this.shape);
		                } else {
		                    return this.shape.getPosition(this.options.name);
		                }
		            },
		            toJSON: function () {
		                return {
		                    shapeId: this.shape.toString(),
		                    connector: this.options.name
		                };
		            }
		        });
	
		        Connector.parse = function (diagram, str) {
		            var tempStr = str.split(":"),
		                id = tempStr[0],
		                name = tempStr[1] || AUTO;
	
		            for (var i = 0; i < diagram.shapes.length; i++) {
		                var shape = diagram.shapes[i];
		                if (shape.options.id == id) {
		                    return shape.getConnector(name.trim());
		                }
		            }
		        };
	
		        var Shape = DiagramElement.extend({
		            init: function (options, diagram) {
		                var that = this;
		                DiagramElement.fn.init.call(that, options);
		                this.diagram = diagram;
		                this.updateOptionsFromModel();
		                options = that.options;
		                that.connectors = [];
		                that.type = options.type;
		                that.createShapeVisual();
		                that.updateBounds();
		                that.content(that.content());
	
		                that._createConnectors();
		            },
	
		            options: diagram.shapeDefaults(),
	
		            _setOptionsFromModel: function(model) {
		                var modelOptions = filterShapeDataItem(model || this.dataItem);
		                this.options = deepExtend({}, this.options, modelOptions);
	
		                this.redrawVisual();
		            },
	
		            updateOptionsFromModel: function(model, field) {
		                if (this.diagram && this.diagram._isEditable) {
		                    var modelOptions = filterShapeDataItem(model || this.dataItem);
	
		                    if (model && field) {
		                        if (!dataviz.inArray(field, ["x", "y", "width", "height"])) {
		                            if (this.options.visual) {
		                                this._redrawVisual();
		                            } else if (modelOptions.type) {
		                                this.options = deepExtend({}, this.options, modelOptions);
		                                this._redrawVisual();
		                            }
	
		                            if (this.options.content) {
		                                this._template();
		                                this.content(this.options.content);
		                            }
		                        } else {
		                            var bounds = this.bounds();
		                            bounds[field] = model[field];
		                            this.bounds(bounds);
		                        }
		                    } else {
		                        this.options = deepExtend({}, this.options, modelOptions);
		                    }
		                }
		            },
	
		            _redrawVisual: function() {
		                this.visual.clear();
		                this._contentVisual = null;
		                this.options.dataItem = this.dataItem;
		                this.createShapeVisual();
		                this.updateBounds();
		            },
	
		            redrawVisual: function() {
		                this._redrawVisual();
		                if (this.options.content) {
		                    this._template();
		                    this.content(this.options.content);
		                }
		            },
	
		            updateModel: function(syncChanges) {
		                var diagram = this.diagram;
		                if (diagram && diagram._isEditable) {
		                    var bounds = this._bounds;
		                    var model = this.dataItem;
	
		                    if (model) {
		                        diagram._suspendModelRefresh();
		                        if (defined(model.x) && bounds.x !== model.x) {
		                            model.set("x", bounds.x);
		                        }
	
		                        if (defined(model.y) && bounds.y !== model.y) {
		                            model.set("y", bounds.y);
		                        }
	
		                        if (defined(model.width) && bounds.width !== model.width) {
		                            model.set("width", bounds.width);
		                        }
	
		                        if (defined(model.height) && bounds.height !== model.height) {
		                            model.set("height", bounds.height);
		                        }
	
		                        this.dataItem = model;
		                        diagram._resumeModelRefresh();
	
		                        if (syncChanges) {
		                            diagram._syncShapeChanges();
		                        }
		                    }
		                }
		            },
	
		            updateBounds: function() {
		                var bounds = this.visual._measure(true);
		                var options = this.options;
		                this.bounds(new Rect(options.x, options.y, bounds.width, bounds.height));
		                this._rotate();
		                this._alignContent();
		            },
	
		            content: function(content) {
		                var result = this._content(content);
	
		                this._alignContent();
	
		                return result;
		            },
	
		            _alignContent: function() {
		                var contentOptions = this.options.content || {};
		                var contentVisual = this._contentVisual;
		                if (contentVisual && contentOptions.align) {
		                    var containerRect = this.visual._measure();
		                    var aligner = new diagram.RectAlign(containerRect);
		                    var contentBounds = contentVisual.drawingElement.bbox(null);
	
		                    var contentRect = new Rect(0, 0, contentBounds.width(), contentBounds.height());
		                    var alignedBounds = aligner.align(contentRect, contentOptions.align);
	
		                    contentVisual.position(alignedBounds.topLeft());
		                }
		            },
	
		            _createConnectors: function() {
		                var options = this.options,
		                    length = options.connectors.length,
		                    connectorDefaults = options.connectorDefaults,
		                    connector, i;
	
		                for (i = 0; i < length; i++) {
		                    connector = new Connector(
		                        this, deepExtend({},
		                            connectorDefaults,
		                            options.connectors[i]
		                        )
		                    );
		                    this.connectors.push(connector);
		                }
		            },
	
		            bounds: function (value) {
		                var bounds;
	
		                if (value) {
		                    if (isString(value)) {
		                        switch (value) {
		                            case TRANSFORMED :
		                                bounds = this._transformedBounds();
		                                break;
		                            case ABSOLUTE :
		                                bounds = this._transformedBounds();
		                                var pan = this.diagram._pan;
		                                bounds.x += pan.x;
		                                bounds.y += pan.y;
		                                break;
		                            case ROTATED :
		                                bounds = this._rotatedBounds();
		                                break;
		                            default:
		                                bounds = this._bounds;
		                        }
		                    } else {
		                        this._setBounds(value);
		                        this._triggerBoundsChange();
		                        if (!(this.diagram && this.diagram._layouting)) {
		                            this.refreshConnections();
		                        }
		                    }
		                } else {
		                    bounds = this._bounds;
		                }
	
		                return bounds;
		            },
	
		            _setBounds: function(rect) {
		                var options = this.options;
		                var topLeft = rect.topLeft();
		                var x = options.x = topLeft.x;
		                var y = options.y = topLeft.y;
		                var width = options.width = math.max(rect.width, options.minWidth);
		                var height = options.height = math.max(rect.height, options.minHeight);
	
		                this._bounds = new Rect(x, y, width, height);
	
		                this.visual.redraw({
		                    x: x,
		                    y: y,
		                    width: width,
		                    height: height
		                });
		            },
	
		            position: function (point) {
		                if (point) {
		                    this.bounds(new Rect(point.x, point.y, this._bounds.width, this._bounds.height));
		                } else {
		                    return this._bounds.topLeft();
		                }
		            },
		            /**
		             * Returns a clone of this shape.
		             * @returns {Shape}
		             */
		            clone: function () {
		                var json = this.serialize();
	
		                json.options.id = diagram.randomId();
	
		                if (this.diagram && this.diagram._isEditable && defined(this.dataItem)) {
		                    json.options.dataItem = cloneDataItem(this.dataItem);
		                }
	
		                return new Shape(json.options);
		            },
	
		            select: function (value) {
		                var diagram = this.diagram, selected, deselected;
		                if (isUndefined(value)) {
		                    value = true;
		                }
	
		                if (this._canSelect()) {
		                    if (this.isSelected != value) {
		                        selected = [];
		                        deselected = [];
		                        this.isSelected = value;
		                        if (this.isSelected) {
		                            diagram._selectedItems.push(this);
		                            selected.push(this);
		                        } else {
		                            Utils.remove(diagram._selectedItems, this);
		                            deselected.push(this);
		                        }
	
		                        if (!diagram._internalSelection) {
		                            diagram._selectionChanged(selected, deselected);
		                        }
	
		                        return true;
		                    }
		                }
		            },
	
		            rotate: function (angle, center, undoable) { // we assume the center is always the center of the shape.
		                var rotate = this.visual.rotate();
		                if (angle !== undefined) {
		                    if (undoable !== false && this.diagram && this.diagram.undoRedoService && angle !== rotate.angle) {
		                        this.diagram.undoRedoService.add(
		                            new diagram.RotateUnit(this.diagram._resizingAdorner, [this], [rotate.angle]), false);
		                    }
	
		                    var b = this.bounds(),
		                        sc = new Point(b.width / 2, b.height / 2),
		                        deltaAngle,
		                        newPosition;
	
		                    if (center) {
		                        deltaAngle = angle - rotate.angle;
		                        newPosition = b.center().rotate(center, 360 - deltaAngle).minus(sc);
		                        this._rotationOffset = this._rotationOffset.plus(newPosition.minus(b.topLeft()));
		                        this.position(newPosition);
		                    }
	
		                    this.visual.rotate(angle, sc);
		                    this.options.rotation.angle = angle;
	
		                    if (this.diagram && this.diagram._connectorsAdorner) {
		                        this.diagram._connectorsAdorner.refresh();
		                    }
	
		                    this.refreshConnections();
	
		                    if (this.diagram) {
		                        this.diagram.trigger(ITEMROTATE, { item: this });
		                    }
		                }
	
		                return rotate;
		            },
	
		            connections: function (type) { // in, out, undefined = both
		                var result = [], i, j, con, cons, ctr;
	
		                for (i = 0; i < this.connectors.length; i++) {
		                    ctr = this.connectors[i];
		                    cons = ctr.connections;
		                    for (j = 0, cons; j < cons.length; j++) {
		                        con = cons[j];
		                        if (type == "out") {
		                            var source = con.source();
		                            if (source.shape && source.shape == this) {
		                                result.push(con);
		                            }
		                        } else if (type == "in") {
		                            var target = con.target();
		                            if (target.shape && target.shape == this) {
		                                result.push(con);
		                            }
		                        } else {
		                            result.push(con);
		                        }
		                    }
		                }
	
		                return result;
		            },
	
		            refreshConnections: function () {
		                $.each(this.connections(), function () {
		                    this.refresh();
		                });
		            },
		            /**
		             * Gets a connector of this shape either by the connector's supposed name or
		             * via a Point in which case the closest connector will be returned.
		             * @param nameOrPoint The name of a Connector or a Point.
		             * @returns {Connector}
		             */
		            getConnector: function (nameOrPoint) {
		                var i, ctr;
		                if (isString(nameOrPoint)) {
		                    nameOrPoint = nameOrPoint.toLocaleLowerCase();
		                    for (i = 0; i < this.connectors.length; i++) {
		                        ctr = this.connectors[i];
		                        if (ctr.options.name.toLocaleLowerCase() == nameOrPoint) {
		                            return ctr;
		                        }
		                    }
		                } else if (nameOrPoint instanceof Point) {
		                    return closestConnector(nameOrPoint, this.connectors);
		                } else {
		                    return this.connectors.length ? this.connectors[0] : null;
		                }
		            },
	
		            getPosition: function (side) {
		                var b = this.bounds(),
		                    fnName = side.charAt(0).toLowerCase() + side.slice(1);
	
		                if (isFunction(b[fnName])) {
		                    return this._transformPoint(b[fnName]());
		                }
	
		                return b.center();
		            },
	
		            redraw: function (options) {
		                if (options) {
		                    var shapeOptions = this.options;
		                    var boundsChange;
	
		                    this.shapeVisual.redraw(this._visualOptions(options));
	
		                    if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
		                        this.bounds(new Rect(shapeOptions.x, shapeOptions.y, shapeOptions.width, shapeOptions.height));
		                        boundsChange = true;
		                    }
	
		                    if (options.connectors) {
		                        shapeOptions.connectors = options.connectors;
		                        this._updateConnectors();
		                    }
	
		                    shapeOptions = deepExtend(shapeOptions, options);
	
		                    if  (options.rotation || boundsChange) {
		                        this._rotate();
		                    }
	
		                    if (shapeOptions.content) {
		                        this.content(shapeOptions.content);
		                    }
		                }
		            },
	
		            _updateConnectors: function() {
		                var connections = this.connections();
		                this.connectors = [];
		                this._createConnectors();
		                var connection;
		                var source;
		                var target;
	
		                for (var idx = 0; idx < connections.length; idx++) {
		                    connection = connections[idx];
		                    source = connection.source();
		                    target = connection.target();
		                    if (source.shape && source.shape === this) {
		                        connection.source(this.getConnector(source.options.name) || null);
		                    } else if (target.shape && target.shape === this) {
		                        connection.target(this.getConnector(target.options.name) || null);
		                    }
		                    connection.updateModel();
		                }
		            },
	
		            _diffNumericOptions: diagram.diffNumericOptions,
	
		            _visualOptions: function(options) {
		                return {
		                    data: options.path,
		                    source: options.source,
		                    hover: options.hover,
		                    fill: options.fill,
		                    stroke: options.stroke
		                };
		            },
	
		            _triggerBoundsChange: function () {
		                if (this.diagram) {
		                    this.diagram.trigger(ITEMBOUNDSCHANGE, {item: this, bounds: this._bounds.clone()}); // the trigger modifies the arguments internally.
		                }
		            },
	
		            _transformPoint: function (point) {
		                var rotate = this.rotate(),
		                    bounds = this.bounds(),
		                    tl = bounds.topLeft();
	
		                if (rotate.angle) {
		                    point.rotate(rotate.center().plus(tl), 360 - rotate.angle);
		                }
	
		                return point;
		            },
	
		            _transformedBounds: function () {
		                var bounds = this.bounds(),
		                    tl = bounds.topLeft(),
		                    br = bounds.bottomRight();
	
		                return Rect.fromPoints(this.diagram.modelToView(tl), this.diagram.modelToView(br));
		            },
	
		            _rotatedBounds: function () {
		                var bounds = this.bounds().rotatedBounds(this.rotate().angle),
		                    tl = bounds.topLeft(),
		                    br = bounds.bottomRight();
	
		                return Rect.fromPoints(tl, br);
		            },
	
		            _rotate: function () {
		                var rotation = this.options.rotation;
	
		                if (rotation && rotation.angle) {
		                    this.rotate(rotation.angle);
		                }
	
		                this._rotationOffset = new Point();
		            },
	
		            _hover: function (value) {
		                var options = this.options,
		                    hover = options.hover,
		                    stroke = options.stroke,
		                    fill = options.fill;
	
		                if (value && isDefined(hover.stroke)) {
		                    stroke = deepExtend({}, stroke, hover.stroke);
		                }
	
		                if (value && isDefined(hover.fill)) {
		                    fill = hover.fill;
		                }
	
		                this.shapeVisual.redraw({
		                    stroke: stroke,
		                    fill: fill
		                });
	
		                if (options.editable && options.editable.connect) {
		                    this.diagram._showConnectors(this, value);
		                }
		            },
	
		            _hitTest: function (value) {
		                if (this.visible()) {
		                    var bounds = this.bounds(), rotatedPoint,
		                        angle = this.rotate().angle;
	
		                    if (value.isEmpty && !value.isEmpty()) { // rect selection
		                        return Intersect.rects(value, bounds, angle ? angle : 0);
		                    } else { // point
		                        rotatedPoint = value.clone().rotate(bounds.center(), angle); // cloning is important because rotate modifies the point inline.
		                        if (bounds.contains(rotatedPoint)) {
		                            return this;
		                        }
		                    }
		                }
		            },
	
		            toJSON: function() {
		                return {
		                    shapeId: this.options.id
		                };
		            },
	
		            createShapeVisual: function() {
		                var options = this.options;
		                var visualOptions = this._visualOptions(options);
		                var visualTemplate = options.visual;
		                var type = (options.type + "").toLocaleLowerCase();
		                var shapeVisual;
	
		                visualOptions.width = options.width;
		                visualOptions.height = options.height;
	
		                if (isFunction(visualTemplate)) { // custom template
		                    shapeVisual = visualTemplate.call(this, options);
		                } else if (visualOptions.data) {
		                    shapeVisual = new Path(visualOptions);
		                    translateToOrigin(shapeVisual);
		                } else if (type == "rectangle"){
		                    shapeVisual = new Rectangle(visualOptions);
		                } else if (type == "circle") {
		                    shapeVisual = new Circle(visualOptions);
		                } else if (type == "text") {
		                    shapeVisual = new TextBlock(visualOptions);
		                } else if (type == "image") {
		                    shapeVisual = new Image(visualOptions);
		                } else {
		                    shapeVisual = new Path(visualOptions);
		                }
	
		                this.shapeVisual = shapeVisual;
		                this.visual.append(this.shapeVisual);
		            }
		        });
	
		        /**
		         * The visual link between two Shapes through the intermediate of Connectors.
		         */
		        var Connection = DiagramElement.extend({
		            init: function (from, to, options) {
		                var that = this;
		                DiagramElement.fn.init.call(that, options);
		                this.updateOptionsFromModel();
		                this._initRouter();
		                that.path = new diagram.Polyline(that.options);
		                that.path.fill(TRANSPARENT);
		                that.visual.append(that.path);
		                that._sourcePoint = that._targetPoint = new Point();
		                that._setSource(from);
		                that._setTarget(to);
		                that.content(that.options.content);
		                that.definers = [];
		                if (defined(options) && options.points) {
		                    that.points(options.points);
		                }
		            },
	
		            options: {
		                hover: {
		                    stroke: {}
		                },
		                startCap: NONE,
		                endCap: NONE,
		                points: [],
		                selectable: true,
		                fromConnector: AUTO,
		                toConnector: AUTO
		            },
	
		            _setOptionsFromModel: function(model) {
		                this.updateOptionsFromModel(model || this.dataItem);
		            },
	
		            updateOptionsFromModel: function(model) {
		                if (this.diagram && this.diagram._isEditable) {
		                    var dataMap = this.diagram._dataMap;
		                    var options = filterConnectionDataItem(model || this.dataItem);
	
		                    if (model) {
		                        if (defined(options.from)) {
		                            var from = dataMap[options.from];
		                            if (from && defined(options.fromConnector)) {
		                               from = from.getConnector(options.fromConnector);
		                            }
		                            this.source(from);
		                        } else if (defined(options.fromX) && defined(options.fromY)) {
		                            this.source(new Point(options.fromX, options.fromY));
		                        }
	
		                        if (defined(options.to)) {
		                            var to = dataMap[options.to];
		                            if (to && defined(options.toConnector)) {
		                                to = to.getConnector(options.toConnector);
		                            }
		                            this.target(to);
		                        } else if (defined(options.toX) && defined(options.toY)) {
		                            this.target(new Point(options.toX, options.toY));
		                        }
	
		                        if (defined(options.type) && this.type() !== options.type) {
		                            this.points([]);
		                            this.type(options.type);
		                        }
	
		                        this.dataItem = model;
	
		                        this._template();
		                        this.redraw(this.options);
		                    } else {
		                        this.options = deepExtend({}, options, this.options);
		                    }
		                }
		            },
	
		            updateModel: function(syncChanges) {
		                if (this.diagram && this.diagram._isEditable) {
		                    if (this.diagram.connectionsDataSource) {
		                        var model = this.diagram.connectionsDataSource.getByUid(this.dataItem.uid);
	
		                        if (model) {
		                            this.diagram._suspendModelRefresh();
		                            if (defined(this.options.fromX) && this.options.fromX !== null) {
		                                clearField("from", model);
		                                clearField("fromConnector", model);
		                                model.set("fromX", this.options.fromX);
		                                model.set("fromY", this.options.fromY);
		                            } else  {
		                                model.set("from", this.options.from);
		                                if (defined(model.fromConnector)) {
		                                    model.set("fromConnector", this.sourceConnector ? this.sourceConnector.options.name : null);
		                                }
		                                clearField("fromX", model);
		                                clearField("fromY", model);
		                            }
	
		                            if (defined(this.options.toX) && this.options.toX !== null) {
		                                clearField("to", model);
		                                clearField("toConnector", model);
		                                model.set("toX", this.options.toX);
		                                model.set("toY", this.options.toY);
		                            } else {
		                                model.set("to", this.options.to);
		                                if (defined(model.toConnector)) {
		                                    model.set("toConnector", this.targetConnector ? this.targetConnector.options.name : null);
		                                }
		                                clearField("toX", model);
		                                clearField("toY", model);
		                            }
	
		                            if (defined(this.options.type) && defined(model.type)) {
		                                model.set("type", this.options.type);
		                            }
	
		                            this.dataItem = model;
		                            this.diagram._resumeModelRefresh();
	
		                            if (syncChanges) {
		                                this.diagram._syncConnectionChanges();
		                            }
		                        }
		                    }
		                }
		            },
	
		            /**
		             * Gets the Point where the source of the connection resides.
		             * If the endpoint in Auto-connector the location of the resolved connector will be returned.
		             * If the endpoint is floating the location of the endpoint is returned.
		             */
		            sourcePoint: function () {
		                return this._resolvedSourceConnector ? this._resolvedSourceConnector.position() : this._sourcePoint;
		            },
	
		            _setSource: function(source) {
		                var shapeSource = source instanceof Shape;
		                var defaultConnector = this.options.fromConnector || AUTO;
		                var dataItem;
		                if (shapeSource && !source.getConnector(defaultConnector)) {
		                    return;
		                }
	
		                if (source !== undefined) {
		                    this.from = source;
		                }
	
		                this._removeFromSourceConnector();
	
		                if (source === null) { // detach
		                    if (this.sourceConnector) {
		                        this._sourcePoint = (this._resolvedSourceConnector || this.sourceConnector).position();
		                        this._clearSourceConnector();
		                        this._setFromOptions(null, this._sourcePoint);
		                    }
		                } else if (source instanceof Connector) {
		                    dataItem = source.shape.dataItem;
		                    if (dataItem) {
		                        this._setFromOptions(dataItem.id);
		                    }
		                    this.sourceConnector = source;
		                    this.sourceConnector.connections.push(this);
		                } else if (source instanceof Point) {
		                    this._setFromOptions(null, source);
		                    this._sourcePoint = source;
		                    if (this.sourceConnector) {
		                        this._clearSourceConnector();
		                    }
	
		                } else if (shapeSource) {
		                    dataItem = source.dataItem;
		                    if (dataItem) {
		                        this._setFromOptions(dataItem.id);
		                    }
	
		                    this.sourceConnector = source.getConnector(defaultConnector);
		                    this.sourceConnector.connections.push(this);
		                }
		            },
	
		            source: function (source, undoable) {
		                if (isDefined(source)) {
		                    if (undoable && this.diagram) {
		                        this.diagram.undoRedoService.addCompositeItem(new diagram.ConnectionEditUnit(this, source));
		                    }
		                    this._setSource(source);
		                    this.refresh();
		                }
		                return this.sourceConnector ? this.sourceConnector : this._sourcePoint;
		            },
	
		            _setFromOptions: function(from, fromPoint) {
		                this.options.from = from;
		                if (fromPoint)  {
		                    this.options.fromX = fromPoint.x;
		                    this.options.fromY = fromPoint.y;
		                } else {
		                    this.options.fromX = null;
		                    this.options.fromY = null;
		                }
		            },
	
		            /**
		             * Gets or sets the PathDefiner of the sourcePoint.
		             * The left part of this definer is always null since it defines the source tangent.
		             * @param value
		             * @returns {*}
		             */
		            sourceDefiner: function (value) {
		                if (value) {
		                    if (value instanceof diagram.PathDefiner) {
		                        value.left = null;
		                        this._sourceDefiner = value;
		                        this.source(value.point); // refresh implicit here
		                    } else {
		                        throw "The sourceDefiner needs to be a PathDefiner.";
		                    }
		                } else {
		                    if (!this._sourceDefiner) {
		                        this._sourceDefiner = new diagram.PathDefiner(this.sourcePoint(), null, null);
		                    }
		                    return this._sourceDefiner;
		                }
		            },
	
		            /**
		             * Gets  the Point where the target of the connection resides.
		             */
		            targetPoint: function () {
		                return this._resolvedTargetConnector ? this._resolvedTargetConnector.position() : this._targetPoint;
		            },
	
		            _setTarget: function(target) {
		                var shapeTarget = target instanceof Shape;
		                var defaultConnector = this.options.toConnector || AUTO;
		                var dataItem;
	
		                if (shapeTarget && !target.getConnector(defaultConnector)) {
		                    return;
		                }
	
		                if (target !== undefined) {
		                    this.to = target;
		                }
	
		                this._removeFromTargetConnector();
	
		                if (target === null) { // detach
		                    if (this.targetConnector) {
		                        this._targetPoint = (this._resolvedTargetConnector || this.targetConnector).position();
		                        this._clearTargetConnector();
		                        this._setToOptions(null, this._targetPoint);
		                    }
		                } else if (target instanceof Connector) {
		                    dataItem = target.shape.dataItem;
		                    if (dataItem) {
		                        this._setToOptions(dataItem.id);
		                    }
		                    this.targetConnector = target;
		                    this.targetConnector.connections.push(this);
		                } else if (target instanceof Point) {
		                    this._setToOptions(null, target);
		                    this._targetPoint = target;
		                    if (this.targetConnector) {
		                        this._clearTargetConnector();
		                    }
		                } else if (shapeTarget) {
		                    dataItem = target.dataItem;
		                    if (dataItem) {
		                        this._setToOptions(dataItem.id);
		                    }
		                    this.targetConnector = target.getConnector(defaultConnector);
		                    this.targetConnector.connections.push(this);
		                }
		            },
	
		            target: function (target, undoable) {
		                if (isDefined(target)) {
		                    if (undoable && this.diagram) {
		                        this.diagram.undoRedoService.addCompositeItem(new diagram.ConnectionEditUnit(this, undefined, target));
		                    }
		                    this._setTarget(target);
	
		                    this.refresh();
		                }
		                return this.targetConnector ? this.targetConnector : this._targetPoint;
		            },
	
		            _setToOptions: function(to, toPoint) {
		                this.options.to = to;
		                if (toPoint)  {
		                    this.options.toX = toPoint.x;
		                    this.options.toY = toPoint.y;
		                } else {
		                    this.options.toX = null;
		                    this.options.toY = null;
		                }
		            },
	
		            /**
		             * Gets or sets the PathDefiner of the targetPoint.
		             * The right part of this definer is always null since it defines the target tangent.
		             * @param value
		             * @returns {*}
		             */
		            targetDefiner: function (value) {
		                if (value) {
		                    if (value instanceof diagram.PathDefiner) {
		                        value.right = null;
		                        this._targetDefiner = value;
		                        this.target(value.point); // refresh implicit here
		                    } else {
		                        throw "The sourceDefiner needs to be a PathDefiner.";
		                    }
		                } else {
		                    if (!this._targetDefiner) {
		                        this._targetDefiner = new diagram.PathDefiner(this.targetPoint(), null, null);
		                    }
		                    return this._targetDefiner;
		                }
		            },
	
		            _updateConnectors: function() {
		                this._updateConnector(this.source(), "source");
		                this._updateConnector(this.target(), "target");
		            },
	
		            _updateConnector: function(instance, name) {
		                var that = this;
		                var diagram = that.diagram;
		                if (instance instanceof Connector && !diagram.getShapeById(instance.shape.id)) {
		                    var dataItem = instance.shape.dataItem;
		                    var connectorName = instance.options.name;
		                    var setNewTarget = function() {
		                        var shape = diagram._dataMap[dataItem.id];
		                        instance = shape.getConnector(connectorName);
		                        that[name](instance, false);
		                        that.updateModel();
		                    };
		                    if (diagram._dataMap[dataItem.id]) {
		                       setNewTarget();
		                    } else {
		                        var inactiveItem = diagram._inactiveShapeItems.getByUid(dataItem.uid);
		                        if (inactiveItem) {
		                            diagram._deferredConnectionUpdates.push(inactiveItem.onActivate(setNewTarget));
		                        }
		                    }
		                } else {
		                    that[name](instance, false);
		                }
		            },
	
		            content: function(content) {
		                var result = this._content(content);
		                if (defined(content)) {
		                    this._alignContent();
		                }
		                return result;
		            },
	
		            _createContentVisual: function(options) {
		                var visual;
		                if (isFunction(options.visual)) {
		                    visual = options.visual.call(this, options);
		                } else if (options.text) {
		                    visual = new TextBlock(options);
		                }
	
		                if (visual) {
		                    this._contentVisual = visual;
		                    visual._includeInBBox = false;
		                    this.visual.append(visual);
		                }
	
		                return visual;
		            },
	
		            _updateContentVisual: function(options) {
		                if (isFunction(options.visual)) {
		                    this.visual.remove(this._contentVisual);
		                    this._createContentVisual(options);
		                } else {
		                    this._contentVisual.redraw(options);
		                }
		            },
	
		            _alignContent: function() {
		                if (this._contentVisual) {
		                    var offset = CONNECTION_CONTENT_OFFSET;
		                    var points = this.allPoints();
		                    var endIdx = math.floor(points.length / 2);
		                    var startIdx = endIdx - 1;
	
		                    while(startIdx > 0 && points[startIdx].equals(points[endIdx])) {
		                        startIdx--;
		                        endIdx++;
		                    }
	
		                    var endPoint = points[endIdx];
		                    var startPoint = points[startIdx];
	
		                    var boundingBox = this._contentVisual._measure();
		                    var width = boundingBox.width;
		                    var height = boundingBox.height;
		                    var alignToPath = points.length % 2 === 0;
		                    var distance = startPoint.distanceTo(endPoint);
	
		                    if (alignToPath && points.length > 2 && distance > 0 &&
		                        ((startPoint.y === endPoint.y && distance < width) || (startPoint.x === endPoint.x && distance < height))) {
		                        alignToPath = false;
		                        offset = 0;
		                    }
	
		                    var point;
	
		                    if (alignToPath) {
		                        var angle  = draw.util.deg(math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x));
		                        point = new Point((endPoint.x - startPoint.x) / 2 + startPoint.x, (endPoint.y - startPoint.y) / 2 + startPoint.y);
	
		                        if (math.abs(angle) === 90) {
		                            point.x += offset;
		                            point.y-= height / 2;
		                        } else if (angle % 180 === 0) {
		                            point.x -= width / 2;
		                            point.y -= height + offset;
		                        } else if (angle < -90 || (0 < angle && angle < 90)) {
		                            point.y-= height;
		                        } else if (angle < 0 || angle > 90) {
		                            point.x -= width;
		                            point.y -= height;
		                        }
		                    } else {
		                        var midIdx = math.floor(points.length / 2);
		                        point = points[midIdx].clone();
		                        startPoint = points[midIdx - 1];
		                        endPoint = points[midIdx + 1];
	
		                        var offsetX = startPoint.x <= point.x && endPoint.x <= point.x ? offset : -boundingBox.width - offset;
		                        var offsetY = startPoint.y <= point.y && endPoint.y <= point.y ? offset : -boundingBox.height - offset;
	
		                        point.x += offsetX;
		                        point.y += offsetY;
		                    }
	
		                    this._contentVisual.position(point);
		                }
		            },
	
		            /**
		             * Selects or unselects this connections.
		             * @param value True to select, false to unselect.
		             */
		            select: function (value) {
		                var diagram = this.diagram, selected, deselected;
		                if (this._canSelect()) {
		                    if (this.isSelected !== value) {
		                        this.isSelected = value;
		                        selected = [];
		                        deselected = [];
		                        if (this.isSelected) {
		                            this.adorner = new ConnectionEditAdorner(this, this.options.selection);
		                            diagram._adorn(this.adorner, true);
		                            diagram._selectedItems.push(this);
		                            selected.push(this);
		                        } else {
		                            if (this.adorner) {
		                                diagram._adorn(this.adorner, false);
		                                Utils.remove(diagram._selectedItems, this);
		                                this.adorner = undefined;
		                                deselected.push(this);
		                            }
		                        }
	
		                        if (this.adorner) {
		                            this.adorner.refresh();
		                        }
	
		                        if (!diagram._internalSelection) {
		                            diagram._selectionChanged(selected, deselected);
		                        }
		                        return true;
		                    }
		                }
		            },
		            /**
		             * Gets or sets the bounds of this connection.
		             * @param value A Rect object.
		             * @remark This is automatically set in the refresh().
		             * @returns {Rect}
		             */
		            bounds: function (value) {
		                if (value && !isString(value)) {
		                    this._bounds = value;
		                } else {
		                    return this._bounds;
		                }
		            },
		            /**
		             * Gets or sets the connection type (see ConnectionType enumeration).
		             * @param value A ConnectionType value.
		             * @returns {ConnectionType}
		             */
		            type: function (value) {
		                var options = this.options;
		                if (value) {
		                    if (value !== options.type) {
		                        options.type = value;
		                        this._initRouter();
		                        this.refresh();
		                    }
		                } else {
		                    return options.type;
		                }
		            },
	
		            _initRouter: function() {
		                var type = (this.options.type || "").toLowerCase();
		                if (type == CASCADING) {
		                    this._router = new CascadingRouter(this);
		                } else {
		                    this._router = new PolylineRouter(this);
		                }
		            },
		            /**
		             * Gets or sets the collection of *intermediate* points.
		             * The 'allPoints()' property will return all the points.
		             * The 'definers' property returns the definers of the intermediate points.
		             * The 'sourceDefiner' and 'targetDefiner' return the definers of the endpoints.
		             * @param value
		             */
		            points: function (value) {
		                if (value) {
		                    this.definers = [];
		                    for (var i = 0; i < value.length; i++) {
		                        var definition = value[i];
		                        if (definition instanceof diagram.Point) {
		                            this.definers.push(new diagram.PathDefiner(definition));
		                        } else if (definition.hasOwnProperty("x") && definition.hasOwnProperty("y")) { // e.g. Clipboard does not preserve the Point definition and tunred into an Object
		                            this.definers.push(new diagram.PathDefiner(new Point(definition.x, definition.y)));
		                        } else {
		                            throw "A Connection point needs to be a Point or an object with x and y properties.";
		                        }
		                    }
	
		                } else {
		                    var pts = [];
		                    if (isDefined(this.definers)) {
		                        for (var k = 0; k < this.definers.length; k++) {
		                            pts.push(this.definers[k].point);
		                        }
		                    }
		                    return pts;
		                }
		            },
		            /**
		             * Gets all the points of this connection. This is the combination of the sourcePoint, the points and the targetPoint.
		             * @returns {Array}
		             */
		            allPoints: function () {
		                var pts = [this.sourcePoint()];
		                if (this.definers) {
		                    for (var k = 0; k < this.definers.length; k++) {
		                        pts.push(this.definers[k].point);
		                    }
		                }
		                pts.push(this.targetPoint());
		                return pts;
		            },
	
		            refresh: function () {
		                this._resolveConnectors();
		                this._refreshPath();
		                this._alignContent();
	
		                if (this.adorner) {
		                    this.adorner.refresh();
		                }
		            },
	
		            _resolveConnectors: function () {
		                var connection = this,
		                    sourcePoint, targetPoint,
		                    sourceConnectors, targetConnectors,
		                    source = connection.source(),
		                    target = connection.target();
	
		                if (source instanceof Point) {
		                    sourcePoint = source;
		                } else if (source instanceof Connector) {
		                    if (isAutoConnector(source)) {
		                        sourceConnectors = source.shape.connectors;
		                    } else {
		                        sourceConnectors = [source];
		                    }
		                }
	
		                if (target instanceof Point) {
		                    targetPoint = target;
		                } else if (target instanceof Connector) {
		                    if (isAutoConnector(target)) {
		                        targetConnectors = target.shape.connectors;
		                    } else {
		                        targetConnectors = [target];
		                    }
		                }
	
		                if (sourcePoint) {
		                    if (targetConnectors) {
		                        connection._resolvedTargetConnector = closestConnector(sourcePoint, targetConnectors);
		                    }
		                } else if (sourceConnectors) {
		                    if (targetPoint) {
		                        connection._resolvedSourceConnector = closestConnector(targetPoint, sourceConnectors);
		                    } else if (targetConnectors) {
		                        this._resolveAutoConnectors(sourceConnectors, targetConnectors);
		                    }
		                }
		            },
	
		            _resolveAutoConnectors: function(sourceConnectors, targetConnectors) {
		                var minNonConflict = MAXINT;
		                var minDist = MAXINT;
		                var minNonConflictSource, minNonConflictTarget;
		                var sourcePoint, targetPoint;
		                var minSource, minTarget;
		                var sourceConnector, targetConnector;
		                var sourceIdx, targetIdx;
		                var dist;
	
		                for (sourceIdx = 0; sourceIdx < sourceConnectors.length; sourceIdx++) {
		                    sourceConnector = sourceConnectors[sourceIdx];
		                    if (!isAutoConnector(sourceConnector)) {
		                        sourcePoint = sourceConnector.position();
	
		                        for (targetIdx = 0; targetIdx < targetConnectors.length; targetIdx++) {
		                            targetConnector = targetConnectors[targetIdx];
		                            if (!isAutoConnector(targetConnector)) {
		                                targetPoint = targetConnector.position();
		                                dist = math.round(sourcePoint.distanceTo(targetPoint));
	
		                                if (dist < minNonConflict && this.diagram && this._testRoutePoints(sourcePoint, targetPoint, sourceConnector, targetConnector)) {
		                                    minNonConflict = dist;
		                                    minNonConflictSource = sourceConnector;
		                                    minNonConflictTarget = targetConnector;
		                                }
	
		                                if (dist < minDist) {
		                                    minSource = sourceConnector;
		                                    minTarget = targetConnector;
		                                    minDist = dist;
		                                }
		                            }
		                        }
		                    }
		                }
	
		                if (minNonConflictSource) {
		                    minSource = minNonConflictSource;
		                    minTarget = minNonConflictTarget;
		                }
	
		                this._resolvedSourceConnector = minSource;
		                this._resolvedTargetConnector = minTarget;
		            },
	
		            _testRoutePoints: function(sourcePoint, targetPoint, sourceConnector, targetConnector) {
		                var router = this._router;
		                var passRoute = true;
		                if (router instanceof CascadingRouter) {
		                    var points = router.routePoints(sourcePoint, targetPoint, sourceConnector, targetConnector),
		                        start, end,
		                         rect, exclude;
	
		                    exclude = this._getRouteExclude(sourcePoint, targetPoint, sourceConnector.shape, targetConnector.shape);
		                    points.unshift(sourcePoint);
		                    points.push(targetPoint);
	
	
		                    for (var idx = 1; idx < points.length; idx++) {
		                        start = points[idx - 1];
		                        end = points[idx];
		                        rect = new Rect(math.min(start.x, end.x), math.min(start.y, end.y),
		                                        math.abs(start.x - end.x), math.abs(start.y - end.y));
		                        if (rect.width > 0) {
		                            rect.x++;
		                            rect.width-=2;
		                        }
		                        if (rect.height > 0) {
		                            rect.y++;
		                            rect.height-=2;
		                        }
	
		                        if (!rect.isEmpty() && this.diagram._shapesQuadTree.hitTestRect(rect, exclude)) {
		                            passRoute = false;
		                            break;
		                        }
		                    }
		                }
		                return passRoute;
		            },
	
		            _getRouteExclude: function(sourcePoint, targetPoint, sourceShape, targetShape) {
		                var exclude = [];
		                if (this._isPointInsideShape(sourcePoint, sourceShape)){
		                    exclude.push(sourceShape);
		                }
		                if (this._isPointInsideShape(targetPoint, targetShape)){
		                    exclude.push(targetShape);
		                }
		                return exclude;
		            },
	
		            _isPointInsideShape: function (point, shape) {
		                var bounds = shape.bounds(), rotatedPoint,
		                    angle = shape.rotate().angle,
		                    pointX, pointY,
		                    boundsX = bounds.x,
		                    boundsY = bounds.y;
	
		                rotatedPoint = point.clone().rotate(bounds.center(), angle);
		                pointX = rotatedPoint.x;
		                pointY = rotatedPoint.y;
		                return pointX > boundsX && pointX < (boundsX + bounds.width) && pointY > boundsY && pointY < (boundsY + bounds.height);
		            },
	
		            redraw: function (options) {
		                if (options) {
		                    this.options = deepExtend({}, this.options, options);
	
		                    var points = this.options.points;
	
		                    if (defined(points) && points.length > 0) {
		                        this.points(points);
		                        this._refreshPath();
		                    }
	
		                    if ((options && options.content) || options.text) {
		                        this.content(options.content);
		                    }
	
		                    this.path.redraw({
		                        fill: options.fill,
		                        stroke: options.stroke,
		                        startCap: options.startCap,
		                        endCap: options.endCap
		                    });
		                }
		            },
		            /**
		             * Returns a clone of this connection.
		             * @returns {Connection}
		             */
		            clone: function () {
		                var json = this.serialize();
	
		                if (this.diagram && this.diagram._isEditable && defined(this.dataItem)) {
		                    json.options.dataItem = cloneDataItem(this.dataItem);
		                }
	
		                return new Connection(this.from, this.to, json.options);
		            },
		            /**
		             * Returns a serialized connection in json format. Consist of the options and the dataItem.
		             * @returns {Connection}
		             */
		            serialize: function () {
		                var from = this.from.toJSON ? this.from.toJSON : this.from.toString(),
		                    to = this.to.toJSON ? this.to.toJSON : this.to.toString();
	
		                var json = deepExtend({}, {
		                    options: this.options,
		                    from: from,
		                    to: to
		                });
	
		                if (defined(this.dataItem)) {
		                    json.dataItem = this.dataItem.toString();
		                }
	
		                json.options.points = this.points();
		                return json;
		            },
	
		            /**
		             * Returns whether the given Point or Rect hits this connection.
		             * @param value
		             * @returns {Connection}
		             * @private
		             */
		            _hitTest: function (value) {
		                if (this.visible()) {
		                    var p = new Point(value.x, value.y), from = this.sourcePoint(), to = this.targetPoint();
		                    if (value.isEmpty && !value.isEmpty() && value.contains(from) && value.contains(to)) {
		                        return this;
		                    }
		                    if (this._router.hitTest(p)) {
		                        return this;
		                    }
		                }
		            },
	
		            _hover: function (value) {
		                var color = (this.options.stroke || {}).color;
	
		                if (value && isDefined(this.options.hover.stroke.color)) {
		                    color = this.options.hover.stroke.color;
		                }
	
		                this.path.redraw({
		                    stroke: {
		                        color: color
		                    }
		                });
		            },
	
		            _refreshPath: function () {
		                if (!defined(this.path)) {
		                    return;
		                }
		                this._drawPath();
		                this.bounds(this._router.getBounds());
		            },
	
		            _drawPath: function () {
		                if (this._router) {
		                    this._router.route(); // sets the intermediate points
		                }
		                var source = this.sourcePoint();
		                var target = this.targetPoint();
		                var points = this.points();
	
		                this.path.redraw({
		                    points: [source].concat(points, [target])
		                });
		            },
	
		            _clearSourceConnector: function () {
		                this.sourceConnector = undefined;
		                this._resolvedSourceConnector = undefined;
		            },
	
		            _clearTargetConnector: function () {
		                this.targetConnector = undefined;
		                this._resolvedTargetConnector = undefined;
		            },
	
		            _removeFromSourceConnector: function() {
		                if (this.sourceConnector) {
		                    Utils.remove(this.sourceConnector.connections, this);
		                }
		            },
	
		            _removeFromTargetConnector: function() {
		                if (this.targetConnector) {
		                    Utils.remove(this.targetConnector.connections, this);
		                }
		            },
	
		            toJSON: function() {
		                var connection = this;
		                var from, to, point;
		                if (connection.from && connection.from.toJSON) {
		                    from = connection.from.toJSON();
		                } else {
		                    point = connection._sourcePoint;
		                    from = {
		                        x: point.x,
		                        y: point.y
		                    };
		                }
	
		                if (connection.to && connection.to.toJSON) {
		                    to = connection.to.toJSON();
		                } else {
		                    point = connection._targetPoint;
		                    to = {
		                        x: point.x,
		                        y: point.y
		                    };
		                }
	
		                return {
		                    from : from,
		                    to: to
		                };
		            }
		        });
	
		        var Diagram = Widget.extend({
		            init: function (element, userOptions) {
		                var that = this;
	
		                kendo.destroy(element);
		                Widget.fn.init.call(that, element, userOptions);
	
		                that._initTheme();
	
		                that._initElements();
		                that._extendLayoutOptions(that.options);
		                that._initDefaults(userOptions);
		                that._interactionDefaults();
	
		                that._initCanvas();
	
		                that.mainLayer = new Group({
		                    id: "main-layer"
		                });
		                that.canvas.append(that.mainLayer);
	
		                that._shapesQuadTree = new ShapesQuadTree(that);
	
		                that._pan = new Point();
		                that._adorners = [];
		                that.adornerLayer = new Group({
		                    id: "adorner-layer"
		                });
		                that.canvas.append(that.adornerLayer);
	
		                that._createHandlers();
	
		                that._initialize();
	
		                that._resizingAdorner = new ResizingAdorner(that, { editable: that.options.editable });
		                that._connectorsAdorner = new ConnectorsAdorner(that);
	
		                that._adorn(that._resizingAdorner, true);
		                that._adorn(that._connectorsAdorner, true);
	
		                that.selector = new Selector(that);
		                // TODO: We may consider using real Clipboard API once is supported by the standard.
		                that._clipboard = [];
	
		                that.pauseMouseHandlers = false;
	
		                that._fetchFreshData();
	
		                that._createGlobalToolBar();
	
		                that._createOptionElements();
	
		                that.zoom(that.options.zoom);
	
		                that.canvas.draw();
		            },
	
		            options: {
		                name: "Diagram",
		                theme: "default",
		                layout: "",
		                zoomRate: 0.1,
		                zoom: 1,
		                zoomMin: 0,
		                zoomMax: 2,
		                dataSource: {},
		                draggable: true,
		                template: "",
		                autoBind: true,
		                editable: {
		                    rotate: {},
		                    resize: {},
		                    text: true,
		                    tools: [],
		                    drag: {
		                        snap: {
		                            size: 10,
		                            angle: 10
		                        }
		                    },
		                    remove: true
		                },
		                pannable: {},
		                selectable: {
		                    key: "none"
		                },
		                tooltip: { enabled: true, format: "{0}" },
		                copy: {
		                    enabled: true,
		                    offsetX: 20,
		                    offsetY: 20
		                },
		                shapeDefaults: diagram.shapeDefaults({ undoable: true }),
		                connectionDefaults: {
		                    editable: {
		                        tools: []
		                    },
		                    type: CASCADING
		                },
		                shapes: [],
		                connections: []
		            },
	
		            events: [
		                ZOOM_END,
		                ZOOM_START,
		                PAN, SELECT,
		                ITEMROTATE,
		                ITEMBOUNDSCHANGE,
		                CHANGE,
		                CLICK,
		                MOUSE_ENTER,
		                MOUSE_LEAVE,
		                "toolBarClick",
		                "save",
		                "cancel",
		                "edit",
		                "remove",
		                "add",
		                "dataBound",
		                DRAG_START,
		                DRAG,
		                DRAG_END
		            ],
	
		            items: function() {
		                return $();
		            },
	
		            _createGlobalToolBar: function() {
		                var editable = this.options.editable;
		                if (editable) {
		                    var tools = editable.tools;
		                    if (this._isEditable && tools !== false && (!tools || tools.length === 0)) {
		                        tools = ["createShape", "undo", "redo", "rotateClockwise", "rotateAnticlockwise"];
		                    }
	
		                    if (tools && tools.length) {
		                        this.toolBar = new DiagramToolBar(this, {
		                            tools: tools || {},
		                            click: proxy(this._toolBarClick, this),
		                            modal: false
		                        });
	
		                        this.toolBar.element.css({
		                            textAlign: "left"
		                        });
	
		                        this.element.prepend(this.toolBar.element);
		                        this._resize();
		                    }
		                }
		            },
	
		            createShape: function() {
		                if ((this.editor && this.editor.end()) || !this.editor) {
		                    var dataSource = this.dataSource;
		                    var view = dataSource.view() || [];
		                    var index = view.length;
		                    var model = createModel(dataSource, {});
		                    var shape = this._createShape(model, {});
	
		                    if (!this.trigger("add", { shape: shape })) {
		                        dataSource.insert(index, model);
		                        var inactiveItem = this._inactiveShapeItems.getByUid(model.uid);
		                        inactiveItem.element = shape;
		                        this.edit(shape);
		                    }
		                }
		            },
	
		            _createShape: function(dataItem, options) {
		                options = deepExtend({}, this.options.shapeDefaults, options);
		                options.dataItem = dataItem;
		                var shape = new Shape(options, this);
		                return shape;
		            },
	
		            createConnection: function() {
		                if (((this.editor && this.editor.end()) || !this.editor)) {
		                    var connectionsDataSource = this.connectionsDataSource;
		                    var view = connectionsDataSource.view() || [];
		                    var index = view.length;
		                    var model = createModel(connectionsDataSource, {});
		                    var connection = this._createConnection(model);
		                    if (!this.trigger("add", { connection: connection })) {
		                        this._connectionsDataMap[model.uid] = connection;
		                        connectionsDataSource.insert(index, model);
		                        this.addConnection(connection, false);
		                        this.edit(connection);
		                    }
		                }
		            },
	
		            _createConnection: function(dataItem, source, target) {
		                var options = deepExtend({}, this.options.connectionDefaults);
		                options.dataItem = dataItem;
	
		                var connection = new Connection(source || new Point(), target || new Point(), options);
	
		                return connection;
		            },
	
		            editModel: function(dataItem, editorType) {
		                this.cancelEdit();
		                var editors, template;
		                var editable = this.options.editable;
	
		                if (editorType == "shape") {
		                    editors = editable.shapeEditors;
		                    template = editable.shapeTemplate;
		                } else if (editorType == "connection") {
		                    var connectionSelectorHandler = proxy(connectionSelector, this);
		                    editors = deepExtend({}, { from: connectionSelectorHandler, to: connectionSelectorHandler }, editable.connectionEditors);
		                    template = editable.connectionTemplate;
		                } else {
		                    return;
		                }
	
		                this.editor = new PopupEditor(this.element, {
		                    update: proxy(this._update, this),
		                    cancel: proxy(this._cancel, this),
		                    model: dataItem,
		                    type: editorType,
		                    target: this,
		                    editors: editors,
		                    template: template
		                });
	
		                this.trigger("edit", this._editArgs());
		            },
	
		            edit: function(item) {
		                if (item.dataItem) {
		                    var editorType = item instanceof Shape ? "shape" : "connection";
		                    this.editModel(item.dataItem, editorType);
		                }
		            },
	
		            cancelEdit: function() {
		                if (this.editor) {
		                    this._getEditDataSource().cancelChanges(this.editor.model);
	
		                    this._destroyEditor();
		                }
		            },
	
		            saveEdit: function() {
		                if (this.editor && this.editor.end() &&
		                    !this.trigger("save", this._editArgs())) {
		                    this._getEditDataSource().sync();
		                }
		            },
	
		            _update: function() {
		                if (this.editor && this.editor.end() &&
		                    !this.trigger("save", this._editArgs())) {
		                    this._getEditDataSource().sync();
		                    this._destroyEditor();
		                }
		            },
	
		            _cancel: function() {
		                if (this.editor && !this.trigger("cancel", this._editArgs())) {
		                    var model = this.editor.model;
		                    this._getEditDataSource().cancelChanges(model);
		                    var element = this._connectionsDataMap[model.uid] || this._dataMap[model.id];
		                    if (element) {
		                        element._setOptionsFromModel(model);
		                    }
		                    this._destroyEditor();
		                }
		            },
	
		            _getEditDataSource: function() {
		                return this.editor.options.type === "shape" ? this.dataSource : this.connectionsDataSource;
		            },
	
		            _editArgs: function() {
		                var result = { container: this.editor.wrapper };
		                result[this.editor.options.type] = this.editor.model;
		                return result;
		            },
	
		            _destroyEditor: function() {
		                if (this.editor) {
		                    this.editor.close();
		                    this.editor = null;
		                }
		            },
	
		            _initElements: function() {
		                this.wrapper = this.element.empty()
		                    .css("position", "relative")
		                    .attr("tabindex", 0)
		                    .addClass("k-widget k-diagram");
	
		                this.scrollable = $("<div />").appendTo(this.element);
		            },
	
		            _initDefaults: function(userOptions) {
		                var options = this.options;
		                var editable = options.editable;
		                var shapeDefaults = options.shapeDefaults;
		                var connectionDefaults = options.connectionDefaults;
		                var userShapeDefaults = (userOptions || {}).shapeDefaults;
		                if (editable === false) {
		                    shapeDefaults.editable = false;
		                    connectionDefaults.editable = false;
		                } else {
		                    copyDefaultOptions(editable, shapeDefaults.editable, ["drag", "remove", "connect"]);
		                    copyDefaultOptions(editable, connectionDefaults.editable, ["drag", "remove"]);
		                }
	
		                if (userShapeDefaults && userShapeDefaults.connectors) {
		                    options.shapeDefaults.connectors = userShapeDefaults.connectors;
		                }
		            },
	
		            _interactionDefaults: function() {
		                var options = this.options;
		                var selectable = options.selectable;
		                var pannable = options.pannable;
		                var mobile = kendo.support.mobileOS;
	
		                if (selectable && !defined(selectable.multiple)) {
		                    options.selectable = deepExtend({
		                        multiple: mobile ? false : true
		                    }, options.selectable);
		                }
	
		                if (pannable && !defined(pannable.key)) {
		                    options.pannable = deepExtend({
		                        key: mobile ? "none" : "ctrl"
		                    }, options.pannable);
		                }
		            },
	
		            _initCanvas: function() {
		                var canvasContainer = $("<div class='k-layer'></div>").appendTo(this.scrollable)[0];
		                var viewPort = this.viewport();
		                this.canvas = new Canvas(canvasContainer, {
		                    width: viewPort.width || DEFAULT_CANVAS_WIDTH,
		                    height: viewPort.height || DEFAULT_CANVAS_HEIGHT
		                });
		            },
	
		            _createHandlers: function () {
		                var that = this;
		                var element = that.element;
	
		                element.on(MOUSEWHEEL_NS, proxy(that._wheel, that))
		                .on("keydown" + NS, proxy(that._keydown, that));
	
		                that._userEvents = new kendo.UserEvents(this.scrollable, {
		                    multiTouch: true,
		                    fastTap: true,
		                    tap: proxy(that._tap, that),
		                    start: proxy(that._dragStart, that),
		                    move: proxy(that._drag, that),
		                    end: proxy(that._dragEnd, that),
		                    gesturestart: proxy(that._gestureStart, that),
		                    gesturechange: proxy(that._gestureChange, that),
		                    gestureend: proxy(that._gestureEnd, that),
		                    doubleTap: proxy(that._doubleTap, that),
		                    supportDoubleTap: true
		                });
	
		                that.toolService = new ToolService(that);
	
		                this.scrollable
		                    .on("mouseover" + NS, proxy(that._mouseover, that))
		                    .on("mouseout" + NS, proxy(that._mouseout, that))
		                    .on("mousemove" + NS, proxy(that._mouseMove, that))
		                    .on("mousedown" + NS, proxy(that._mouseDown, that))
		                    .on("mouseup" + NS, proxy(that._mouseUp, that));
	
		                this._syncHandler = proxy(that._syncChanges, that);
	
		                that._resizeHandler = proxy(that.resize, that, false);
		                kendo.onResize(that._resizeHandler);
	
		                this.bind(ZOOM_START, proxy(that._destroyToolBar, that));
		                this.bind(PAN, proxy(that._destroyToolBar, that));
		            },
	
		            _dragStart: function (e) {
		                this._pauseMouseHandlers = true;
		                var point = this._eventPositions(e, true);
	
		                var event = e.event;
		                if (this.toolService.start(point, this._meta(event))) {
		                    this._destroyToolBar();
		                    event.preventDefault();
		                }
		            },
	
		            _drag: function (e) {
		                var p = this._eventPositions(e);
		                var event = e.event;
		                if (this.toolService.move(p, this._meta(event))) {
		                    event.preventDefault();
		                }
		            },
	
		            _dragEnd: function (e) {
		                this._pauseMouseHandlers = false;
		                var p = this._eventPositions(e);
		                var event = e.event;
		                if (this.toolService.end(p, this._meta(event))) {
		                    this._createToolBar();
		                    event.preventDefault();
		                }
		            },
	
		            _mouseMove: function (e) {
		                if (!this._pauseMouseHandlers) {
		                    var p = this._eventPositions(e);
		                    this.toolService._updateHoveredItem(p);
		                    this.toolService._updateCursor(p);
		                }
		            },
	
		            _mouseDown: function () {
		                this._pauseMouseHandlers = true;
		            },
	
		            _mouseUp: function () {
		                this._pauseMouseHandlers = false;
		            },
	
		            _tap: function(e) {
		                var toolService = this.toolService;
		                var selectable = this.options.selectable;
		                var point = this._eventPositions(e);
		                var focused = this.focus();
	
		                toolService._updateHoveredItem(point);
	
		                if (toolService.hoveredItem) {
		                    var item = toolService.hoveredItem;
	
		                    this.trigger("click", {
		                        item: item,
		                        point: point
		                    });
	
		                    if (selectable && item.options.selectable !== false) {
		                        var multiple = selectable.multiple !== false;
		                        var ctrlPressed = kendo.support.mobileOS || this._meta(e.event).ctrlKey;
	
		                        if (item.isSelected) {
		                            if (ctrlPressed) {
		                                this._destroyToolBar();
		                                item.select(false);
		                            } else {
		                                this._createToolBar(focused);
		                            }
		                        } else {
		                            this._destroyToolBar();
		                            this.select(item, {
		                                addToSelection: multiple && ctrlPressed
		                            });
		                            this._createToolBar(focused);
		                        }
		                    }
		                } else if (selectable) {
		                    this._destroyToolBar();
		                    this.deselect();
		                }
		            },
	
		            _keydown: function (e) {
		                if (this.toolService.keyDown(e.keyCode, this._meta(e))) {
		                    e.preventDefault();
		                }
		            },
	
		            _wheel: function (e) {
		                var delta = mwDelta(e),
		                    p = this._eventPositions(e),
		                    meta = deepExtend(this._meta(e), { delta: delta });
	
		                if (this.toolService.wheel(p, meta)) {
		                    e.preventDefault();
		                }
		            },
	
		            _meta: function (e) {
		                return { ctrlKey: e.ctrlKey, metaKey: e.metaKey, altKey: e.altKey, shiftKey: e.shiftKey, type: e.type };
		            },
	
		            _eventPositions: function (e, start) {
		                var point;
		                if (e.touch) {
		                    var field = start ? "startLocation" : "location";
		                    point = new Point(e.x[field], e.y[field]);
		                } else {
		                    var event = e.originalEvent;
		                    point = new Point(event.pageX, event.pageY);
		                }
	
		                return this.documentToModel(point);
		            },
	
		            _gestureStart: function(e) {
		                this._destroyToolBar();
		                this.scroller.disable();
		                var initialCenter = this.documentToModel(new Point(e.center.x, e.center.y));
		                var eventArgs = {
		                    point: initialCenter,
		                    zoom: this.zoom()
		                };
	
		                if (this.trigger(ZOOM_START, eventArgs)) {
		                    return;
		                }
	
		                this._gesture = e;
		                this._initialCenter = initialCenter;
		            },
	
		            _gestureChange: function(e) {
		                var previousGesture = this._gesture;
		                var initialCenter = this._initialCenter;
		                var center = this.documentToView(new Point(e.center.x, e.center.y));
		                var scaleDelta = e.distance / previousGesture.distance;
		                var zoom = this._zoom;
		                var updateZoom = false;
	
		                if (math.abs(scaleDelta - 1) >= MOBILE_ZOOM_RATE) {
		                    this._zoom = zoom = this._getValidZoom(zoom * scaleDelta);
		                    this.options.zoom = zoom;
		                    this._gesture = e;
		                    updateZoom = true;
		                }
	
		                var zoomedPoint = initialCenter.times(zoom);
		                var pan = center.minus(zoomedPoint);
		                if (updateZoom || this._pan.distanceTo(pan) >= MOBILE_PAN_DISTANCE) {
		                    this._panTransform(pan);
		                    this._updateAdorners();
		                }
	
		                e.preventDefault();
		            },
	
		            _doubleTap: function(e) {
		                var diagram = this;
		                var pointPosition = this._eventPositions(e);
		                var options = diagram.options;
		                var zoomRate = options.zoomRate;
		                var zoom = diagram.zoom() + zoomRate;
		                var meta = this._meta(e);
		                var zoomOptions = { point: pointPosition, meta: meta, zoom: zoom };
	
	
		                if (diagram.trigger(ZOOM_START, zoomOptions)) {
		                    return;
		                }
	
		                zoom = kendo.dataviz.round(Math.max(options.zoomMin, Math.min(options.zoomMax, zoom)), 2);
		                zoomOptions.zoom = zoom;
	
		                diagram.zoom(zoom, zoomOptions);
		                diagram.trigger(ZOOM_END, zoomOptions);
		            },
	
		            _gestureEnd: function() {
		                if (this.options.pannable !== false)  {
		                    this.scroller.enable();
		                }
		                this.trigger(ZOOM_END, {
		                    point: this._initialCenter,
		                    zoom: this.zoom()
		                });
		            },
	
		            _resize: function() {
		                var viewport = this.viewport();
		                if (this.canvas) {
		                    this.canvas.size(viewport);
		                }
	
		                if (this.scrollable && this.toolBar) {
		                    this.scrollable.height(viewport.height);
		                }
		            },
	
		            _mouseover: function(e) {
		                var node = e.target._kendoNode;
		                if (node && node.srcElement._hover) {
		                    node.srcElement._hover(true, node.srcElement);
		                }
		            },
	
		            _mouseout: function(e) {
		                var node = e.target._kendoNode;
		                if (node && node.srcElement._hover) {
		                    node.srcElement._hover(false, node.srcElement);
		                }
		            },
	
		            _initTheme: function() {
		                var that = this;
		                var themeName = ((that.options || {}).theme || "").toLowerCase();
		                var themes = dataviz.ui.themes || {};
		                var themeOptions;
	
		                if(SASS_THEMES.indexOf(themeName) != -1) {
		                    themeOptions = dataviz.autoTheme().diagram;
		                }
		                else {
		                    themeOptions = (themes[themeName] || {}).diagram;
		                }
	
		                that.options = deepExtend({}, themeOptions, that.options);
		                if (that.options.editable === true) {
		                    deepExtend(that.options, {
		                        editable: (themeOptions || {}).editable
		                    });
		                }
		            },
	
		            _createOptionElements: function() {
		                var options = this.options;
		                var shapesLength = options.shapes.length;
	
		                if (shapesLength) {
		                    this._createShapes();
		                }
	
		                if (options.connections.length) {
		                    this._createConnections();
		                }
	
		                if (shapesLength && options.layout) {
		                    this.layout(options.layout);
		                }
		            },
	
		            _createShapes: function() {
		                var that = this,
		                    options = that.options,
		                    shapes = options.shapes,
		                    shape, i;
	
		                for (i = 0; i < shapes.length; i++) {
		                    shape = shapes[i];
		                    that.addShape(shape);
		                }
		            },
	
		            _createConnections: function() {
		                var diagram = this,
		                    options = diagram.options,
		                    defaults = options.connectionDefaults,
		                    connections = options.connections,
		                    conn, source, target, i;
	
		                for(i = 0; i < connections.length; i++) {
		                    conn = connections[i];
		                    source = diagram._findConnectionTarget(conn.from);
		                    target = diagram._findConnectionTarget(conn.to);
	
		                    diagram.connect(source, target, deepExtend({}, defaults, conn));
		                }
		            },
	
		            _findConnectionTarget: function(options) {
		                options = options || {};
		                var diagram = this;
		                var shapeId = isString(options) ? options : options.shapeId || options.id;
		                var target;
		                if (shapeId) {
		                    target = diagram.getShapeById(shapeId);
		                    if (options.connector) {
		                        target = target.getConnector(options.connector);
		                    }
		                } else {
		                    target = new Point(options.x || 0, options.y || 0);
		                }
	
		                return target;
		            },
	
		            destroy: function () {
		                var that = this;
		                Widget.fn.destroy.call(that);
	
		                if (this._userEvents) {
		                    this._userEvents.destroy();
		                }
	
		                kendo.unbindResize(that._resizeHandler);
	
		                that.clear();
		                that.element.off(NS);
		                that.scroller.wrapper.off(NS);
		                that.canvas.destroy(true);
		                that.canvas = undefined;
	
		                that._destroyEditor();
		                that.destroyScroller();
		                that._destroyGlobalToolBar();
		                that._destroyToolBar();
		            },
	
		            destroyScroller: function () {
		                var scroller = this.scroller;
	
		                if (!scroller) {
		                    return;
		                }
	
		                scroller.destroy();
		                scroller.element.remove();
		                this.scroller = null;
		            },
	
		            save: function () {
		                var json = {
		                    shapes: [],
		                    connections: []
		                };
		                var i, connection, shape;
	
		                for (i = 0; i < this.shapes.length; i++) {
		                    shape = this.shapes[i];
		                    if (shape.options.serializable) {
		                        json.shapes.push(shape.options);
		                    }
		                }
	
		                for (i = 0; i < this.connections.length; i++) {
		                    connection = this.connections[i];
	
		                    json.connections.push(deepExtend({}, connection.options, connection.toJSON()));
		                }
	
		                return json;
		            },
	
		            focus: function() {
		                if (!this.element.is(kendo._activeElement())) {
		                    var element = this.element,
		                        scrollContainer = element[0],
		                        containers = [],
		                        offsets = [],
		                        documentElement = document.documentElement,
		                        i;
	
		                    do {
		                        scrollContainer = scrollContainer.parentNode;
	
		                        if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
		                            containers.push(scrollContainer);
		                            offsets.push(scrollContainer.scrollTop);
		                        }
		                    } while (scrollContainer != documentElement);
	
		                    element.focus();
	
		                    for (i = 0; i < containers.length; i++) {
		                        containers[i].scrollTop = offsets[i];
		                    }
		                    return true;
		                }
		            },
	
		            load: function(options) {
		                this.clear();
	
		                this.setOptions(options);
		                this._createShapes();
		                this._createConnections();
		            },
	
		            setOptions: function(options) {
		                deepExtend(this.options, options);
		            },
	
		            clear: function () {
		                var that = this;
	
		                that.select(false);
		                that.mainLayer.clear();
		                that._shapesQuadTree.clear();
		                that._initialize();
		            },
		            /**
		             * Connects two items.
		             * @param source Shape, Connector, Point.
		             * @param target Shape, Connector, Point.
		             * @param options Connection options that will be passed to the newly created connection.
		             * @returns The newly created connection.
		             */
		            connect: function (source, target, options) {
		                var connection;
		                if (this.connectionsDataSource && this._isEditable) {
		                    var dataItem = this.connectionsDataSource.add({});
		                    connection = this._connectionsDataMap[dataItem.uid];
		                    connection.source(source);
		                    connection.target(target);
		                    connection.redraw(options);
		                    connection.updateModel();
		                } else {
		                    connection = new Connection(source, target,
		                        deepExtend({ }, this.options.connectionDefaults, options));
	
		                    this.addConnection(connection);
		                }
	
		                return connection;
		            },
		            /**
		             * Determines whether the the two items are connected.
		             * @param source Shape, Connector, Point.
		             * @param target Shape, Connector, Point.
		             * @returns true if the two items are connected.
		             */
		            connected: function (source, target) {
		                for (var i = 0; i < this.connections.length; i++) {
		                    var c = this.connections[i];
		                    if (c.from == source && c.to == target) {
		                        return true;
		                    }
		                }
	
		                return false;
		            },
		            /**
		             * Adds connection to the diagram.
		             * @param connection Connection.
		             * @param undoable Boolean.
		             * @returns The newly created connection.
		             */
		            addConnection: function (connection, undoable) {
		                if (undoable !== false) {
		                    this.undoRedoService.add(
		                        new diagram.AddConnectionUnit(connection, this), false);
		                }
	
		                connection.diagram = this;
		                connection._setOptionsFromModel();
		                connection.refresh();
		                this.mainLayer.append(connection.visual);
		                this.connections.push(connection);
	
		                this.trigger(CHANGE, {
		                    added: [connection],
		                    removed: []
		                });
	
		                return connection;
		            },
	
		            _addConnection: function (connection, undoable) {
		                var connectionsDataSource = this.connectionsDataSource;
		                var dataItem;
		                if (connectionsDataSource && this._isEditable) {
		                    dataItem = createModel(connectionsDataSource, cloneDataItem(connection.dataItem));
		                    connection.dataItem = dataItem;
		                    connection.updateModel();
	
		                    if (!this.trigger("add", { connection: connection })) {
		                        this._connectionsDataMap[dataItem.uid] = connection;
	
		                        connectionsDataSource.add(dataItem);
		                        this.addConnection(connection, undoable);
		                        connection._updateConnectors();
	
		                        return connection;
		                    }
		                } else if (!this.trigger("add", { connection: connection })) {
		                    this.addConnection(connection, undoable);
		                    connection._updateConnectors();
		                    return connection;
		                }
		            },
	
		            /**
		             * Adds shape to the diagram.
		             * @param item Shape, Point. If point is passed it will be created new Shape and positioned at that point.
		             * @param options. The options to be passed to the newly created Shape.
		             * @returns The newly created shape.
		             */
		            addShape: function(item, undoable) {
		                var shape,
		                    shapeDefaults = this.options.shapeDefaults;
	
		                if (item instanceof Shape) {
		                    shape = item;
		                } else if (!(item instanceof kendo.Class)) {
		                    shapeDefaults = deepExtend({}, shapeDefaults, item || {});
		                    shape = new Shape(shapeDefaults, this);
		                } else {
		                    return;
		                }
	
		                if (undoable !== false) {
		                    this.undoRedoService.add(new diagram.AddShapeUnit(shape, this), false);
		                }
	
		                this.shapes.push(shape);
		                if (shape.diagram !== this) {
		                    this._shapesQuadTree.insert(shape);
		                    shape.diagram = this;
		                }
		                this.mainLayer.append(shape.visual);
	
		                this.trigger(CHANGE, {
		                    added: [shape],
		                    removed: []
		                });
	
		                return shape;
		            },
	
		            _addShape: function(shape, undoable) {
		                var that = this;
		                var dataSource = that.dataSource;
		                var dataItem;
		                if (dataSource && this._isEditable) {
		                    dataItem = createModel(dataSource, cloneDataItem(shape.dataItem));
		                    shape.dataItem = dataItem;
		                    shape.updateModel();
	
		                    if (!this.trigger("add", { shape: shape })) {
		                        this.dataSource.add(dataItem);
		                        var inactiveItem = this._inactiveShapeItems.getByUid(dataItem.uid);
		                        inactiveItem.element = shape;
		                        inactiveItem.undoable = undoable;
		                        return shape;
		                    }
		                } else if (!this.trigger("add", { shape: shape })) {
		                    return this.addShape(shape, undoable);
		                }
		            },
		            /**
		             * Removes items (or single item) from the diagram.
		             * @param items DiagramElement, Array of Items.
		             * @param undoable.
		             */
	
		           remove: function(items, undoable) {
		                items = isArray(items) ? items.slice(0) : [items];
		                var elements = splitDiagramElements(items);
		                var shapes = elements.shapes;
		                var connections = elements.connections;
		                var i;
	
		                if (!defined(undoable)) {
		                    undoable = true;
		                }
	
		                if (undoable) {
		                    this.undoRedoService.begin();
		                }
	
		                this._suspendModelRefresh();
		                for (i = shapes.length - 1; i >= 0; i--) {
		                   this._removeItem(shapes[i], undoable, connections);
		                }
	
		                for (i = connections.length - 1; i >= 0; i--) {
		                    this._removeItem(connections[i], undoable);
		                }
	
		                this._resumeModelRefresh();
	
		                if (undoable) {
		                    this.undoRedoService.commit(false);
		                }
	
		                this.trigger(CHANGE, {
		                    added: [],
		                    removed: items
		                });
		            },
	
		            _removeShapeDataItem: function(item) {
		                if (this._isEditable) {
		                    this.dataSource.remove(item.dataItem);
		                    delete this._dataMap[item.dataItem.id];
		                }
		            },
	
		            _removeConnectionDataItem: function(item) {
		                if (this._isEditable) {
		                    this.connectionsDataSource.remove(item.dataItem);
		                    delete this._connectionsDataMap[item.dataItem.uid];
		                }
		            },
	
		            _triggerRemove: function(items){
		                var toRemove = [];
		                var item, args, editable;
	
		                for (var idx = 0; idx < items.length; idx++) {
		                    item = items[idx];
		                    editable = item.options.editable;
		                    if (item instanceof Shape) {
		                        args = { shape: item };
		                    } else {
		                        args = { connection: item };
		                    }
		                    if (editable && editable.remove !== false && !this.trigger("remove", args)) {
		                        toRemove.push(item);
		                    }
		                }
		                return toRemove;
		            },
	
		            /**
		             * Executes the next undoable action on top of the undo stack if any.
		             */
		            undo: function () {
		                this.undoRedoService.undo();
		            },
		            /**
		             * Executes the previous undoable action on top of the redo stack if any.
		             */
		            redo: function () {
		                this.undoRedoService.redo();
		            },
		            /**
		             * Selects items on the basis of the given input or returns the current selection if none.
		             * @param itemsOrRect DiagramElement, Array of elements, "All", false or Rect. A value 'false' will deselect everything.
		             * @param options
		             * @returns {Array}
		             */
		            select: function (item, options) {
		                if (isDefined(item)) {
		                    options = deepExtend({ addToSelection: false }, options);
	
		                    var addToSelection = options.addToSelection,
		                        items = [],
		                        selected = [],
		                        i, element;
	
		                    if (!addToSelection) {
		                        this.deselect();
		                    }
	
		                    this._internalSelection = true;
	
		                    if (item instanceof Array) {
		                        items = item;
		                    } else if (item instanceof DiagramElement) {
		                        items = [ item ];
		                    }
	
		                    for (i = 0; i < items.length; i++) {
		                        element = items[i];
		                        if (element.select(true)) {
		                            selected.push(element);
		                        }
		                    }
	
		                    this._selectionChanged(selected, []);
	
		                    this._internalSelection = false;
		                } else {
		                    return this._selectedItems;
		                }
		            },
	
		            selectAll: function() {
		                this.select(this.shapes.concat(this.connections));
		            },
	
		            selectArea: function(rect) {
		                var i, items, item;
		                this._internalSelection = true;
		                var selected = [];
		                if (rect instanceof Rect) {
		                    items = this.shapes.concat(this.connections);
		                    for (i = 0; i < items.length; i++) {
		                        item = items[i];
		                        if ((!rect || item._hitTest(rect)) && item.options.enable) {
		                            if (item.select(true)) {
		                                selected.push(item);
		                            }
		                        }
		                    }
		                }
	
		                this._selectionChanged(selected, []);
		                this._internalSelection = false;
		            },
	
		            deselect: function(item) {
		                this._internalSelection = true;
		                var deselected = [],
		                    items = [],
		                    element, i;
	
		                if (item instanceof Array) {
		                    items = item;
		                } else if (item instanceof DiagramElement) {
		                    items.push(item);
		                } else if (!isDefined(item)) {
		                    items = this._selectedItems.slice(0);
		                }
	
		                for (i = 0; i < items.length; i++) {
		                    element = items[i];
		                    if (element.select(false)) {
		                        deselected.push(element);
		                    }
		                }
	
		                this._selectionChanged([], deselected);
		                this._internalSelection = false;
		            },
		            /**
		             * Brings to front the passed items.
		             * @param items DiagramElement, Array of Items.
		             * @param undoable. By default the action is undoable.
		             */
		            toFront: function (items, undoable) {
		                if (!items) {
		                    items = this._selectedItems.slice();
		                }
	
		                var result = this._getDiagramItems(items), indices;
		                if (!defined(undoable) || undoable) {
		                    indices = indicesOfItems(this.mainLayer, result.visuals);
		                    var unit = new ToFrontUnit(this, items, indices);
		                    this.undoRedoService.add(unit);
		                } else {
		                    this.mainLayer.toFront(result.visuals);
		                    this._fixOrdering(result, true);
		                }
		            },
		            /**
		             * Sends to back the passed items.
		             * @param items DiagramElement, Array of Items.
		             * @param undoable. By default the action is undoable.
		             */
		            toBack: function (items, undoable) {
		                if (!items) {
		                    items = this._selectedItems.slice();
		                }
	
		                var result = this._getDiagramItems(items), indices;
		                if (!defined(undoable) || undoable) {
		                    indices = indicesOfItems(this.mainLayer, result.visuals);
		                    var unit = new ToBackUnit(this, items, indices);
		                    this.undoRedoService.add(unit);
		                } else {
		                    this.mainLayer.toBack(result.visuals);
		                    this._fixOrdering(result, false);
		                }
		            },
		            /**
		             * Bring into view the passed item(s) or rectangle.
		             * @param items DiagramElement, Array of Items, Rect.
		             * @param options. align - controls the position of the calculated rectangle relative to the viewport.
		             * "Center middle" will position the items in the center. animate - controls if the pan should be animated.
		             */
		            bringIntoView: function (item, options) { // jQuery|Item|Array|Rect
		                var viewport = this.viewport();
		                var aligner = new diagram.RectAlign(viewport);
		                var current, rect, original, newPan;
	
		                if (viewport.width === 0 || viewport.height === 0) {
		                    return;
		                }
	
		                options = deepExtend({animate: false, align: "center middle"}, options);
		                if (options.align == "none") {
		                    options.align = "center middle";
		                }
	
		                if (item instanceof DiagramElement) {
		                    rect = item.bounds(TRANSFORMED);
		                } else if (isArray(item)) {
		                    rect = this.boundingBox(item);
		                } else if (item instanceof Rect) {
		                    rect = item.clone();
		                }
	
		                original = rect.clone();
	
		                rect.zoom(this._zoom);
	
		                if (rect.width > viewport.width || rect.height > viewport.height) {
		                    this._zoom = this._getValidZoom(math.min(viewport.width / original.width, viewport.height / original.height));
		                    rect = original.clone().zoom(this._zoom);
		                }
	
		                this._zoomMainLayer();
	
		                current = rect.clone();
		                aligner.align(rect, options.align);
	
		                newPan = rect.topLeft().minus(current.topLeft());
		                this.pan(newPan.times(-1), options.animate);
		            },
	
		            alignShapes: function (direction) {
		                if (isUndefined(direction)) {
		                    direction = "Left";
		                }
		                var items = this.select(),
		                    val,
		                    item,
		                    i;
	
		                if (items.length === 0) {
		                    return;
		                }
	
		                switch (direction.toLowerCase()) {
		                    case "left":
		                    case "top":
		                        val = MAX_VALUE;
		                        break;
		                    case "right":
		                    case "bottom":
		                        val = MIN_VALUE;
		                        break;
		                }
	
		                for (i = 0; i < items.length; i++) {
		                    item = items[i];
		                    if (item instanceof Shape) {
		                        switch (direction.toLowerCase()) {
		                            case "left":
		                                val = math.min(val, item.options.x);
		                                break;
		                            case "top":
		                                val = math.min(val, item.options.y);
		                                break;
		                            case "right":
		                                val = math.max(val, item.options.x);
		                                break;
		                            case "bottom":
		                                val = math.max(val, item.options.y);
		                                break;
		                        }
		                    }
		                }
		                var undoStates = [];
		                var shapes = [];
		                for (i = 0; i < items.length; i++) {
		                    item = items[i];
		                    if (item instanceof Shape) {
		                        shapes.push(item);
		                        undoStates.push(item.bounds());
		                        switch (direction.toLowerCase()) {
		                            case "left":
		                            case "right":
		                                item.position(new Point(val, item.options.y));
		                                break;
		                            case "top":
		                            case "bottom":
		                                item.position(new Point(item.options.x, val));
		                                break;
		                        }
		                    }
		                }
		                var unit = new diagram.TransformUnit(shapes, undoStates);
		                this.undoRedoService.add(unit, false);
		            },
	
		            zoom: function (zoom, options) {
		                if (zoom) {
		                    var staticPoint = options ? options.point : new diagram.Point(0, 0);
		                    // var meta = options ? options.meta : 0;
		                    zoom = this._zoom = this._getValidZoom(zoom);
	
		                    if (!isUndefined(staticPoint)) {//Viewpoint vector is constant
		                        staticPoint = new diagram.Point(math.round(staticPoint.x), math.round(staticPoint.y));
		                        var zoomedPoint = staticPoint.times(zoom);
		                        var viewportVector = this.modelToView(staticPoint);
		                        var raw = viewportVector.minus(zoomedPoint);//pan + zoomed point = viewpoint vector
		                        this._storePan(new diagram.Point(math.round(raw.x), math.round(raw.y)));
		                    }
	
		                    if (options) {
		                        options.zoom = zoom;
		                    }
	
		                    this._panTransform();
	
		                    this.canvas.surface.hideTooltip();
	
		                    this._updateAdorners();
		                }
	
		                return this._zoom;
		            },
	
		            _getPan: function(pan) {
		                var canvas = this.canvas;
		                if (!canvas.translate) {
		                    pan = pan.plus(this._pan);
		                }
		                return pan;
		            },
	
		            pan: function (pan, animate) {
		                if (pan instanceof Point) {
		                    var that = this;
		                    var scroller = that.scroller;
		                    pan = that._getPan(pan);
		                    pan = pan.times(-1);
	
		                    if (animate) {
		                        scroller.animatedScrollTo(pan.x, pan.y, function() {
		                            that._updateAdorners();
		                        });
		                    } else {
		                        scroller.scrollTo(pan.x, pan.y);
		                        that._updateAdorners();
		                    }
		                } else {
		                    return this._pan.times(-1);
		                }
		            },
	
		            viewport: function () {
		                var element = this.element;
		                var width = element.width();
		                var height = element.height();
	
		                if (this.toolBar) {
		                    height -= outerHeight(this.toolBar.element);
		                }
	
		                return new Rect(0, 0, width, height);
		            },
		            copy: function () {
		                if (this.options.copy.enabled) {
		                    this._clipboard = [];
		                    this._copyOffset = 1;
		                    for (var i = 0; i < this._selectedItems.length; i++) {
		                        var item = this._selectedItems[i];
		                        this._clipboard.push(item);
		                    }
		                }
		            },
		            cut: function () {
		                if (this.options.copy.enabled) {
		                    this._clipboard = [];
		                    this._copyOffset = 0;
		                    for (var i = 0; i < this._selectedItems.length; i++) {
		                        var item = this._selectedItems[i];
		                        this._clipboard.push(item);
		                    }
		                    this.remove(this._clipboard, true);
		                }
		            },
	
		            paste: function () {
		                if (this._clipboard.length > 0) {
		                    var item, copied, i;
		                    var mapping = {};
		                    var elements = splitDiagramElements(this._clipboard);
		                    var connections = elements.connections;
		                    var shapes = elements.shapes;
		                    var offset = {
		                        x: this._copyOffset * this.options.copy.offsetX,
		                        y: this._copyOffset * this.options.copy.offsetY
		                    };
		                    this.deselect();
		                    // first the shapes
		                    for (i = 0; i < shapes.length; i++) {
		                        item = shapes[i];
		                        copied = item.clone();
		                        mapping[item.id] = copied;
		                        copied.position(new Point(item.options.x + offset.x, item.options.y + offset.y));
		                        copied.diagram = this;
		                        copied = this._addShape(copied);
		                        if (copied) {
		                            copied.select();
		                        }
		                    }
		                    // then the connections
		                    for (i = 0; i < connections.length; i++) {
		                        item = connections[i];
		                        copied = this._addConnection(item.clone());
		                        if (copied) {
		                            this._updateCopiedConnection(copied, item, "source", mapping, offset);
		                            this._updateCopiedConnection(copied, item, "target", mapping, offset);
	
		                            copied.select(true);
		                            copied.updateModel();
		                        }
		                    }
	
		                    this._syncChanges();
	
		                    this._copyOffset += 1;
		                }
		            },
	
		            _updateCopiedConnection: function(connection, sourceConnection, connectorName, mapping, offset) {
		                var onActivate, inactiveItem, targetShape;
		                var target = sourceConnection[connectorName]();
		                var diagram = this;
		                if (target instanceof Connector && mapping[target.shape.id]) {
		                    targetShape = mapping[target.shape.id];
		                    if (diagram.getShapeById(targetShape.id)) {
		                        connection[connectorName](targetShape.getConnector(target.options.name));
		                    } else {
		                        inactiveItem = diagram._inactiveShapeItems.getByUid(targetShape.dataItem.uid);
		                        if (inactiveItem) {
		                            onActivate = function(item) {
		                                targetShape = diagram._dataMap[item.id];
		                                connection[connectorName](targetShape.getConnector(target.options.name));
		                                connection.updateModel();
		                            };
		                            diagram._deferredConnectionUpdates.push(inactiveItem.onActivate(onActivate));
		                        }
		                    }
		                } else {
		                    connection[connectorName](new Point(sourceConnection[connectorName + "Point"]().x + offset.x, sourceConnection[connectorName + "Point"]().y + offset.y));
		                }
		            },
		            /**
		             * Gets the bounding rectangle of the given items.
		             * @param items DiagramElement, Array of elements.
		             * @param origin Boolean. Pass 'true' if you need to get the bounding box of the shapes without their rotation offset.
		             * @returns {Rect}
		             */
		            boundingBox: function (items, origin) {
		                var rect = Rect.empty(), temp,
		                    di = isDefined(items) ? this._getDiagramItems(items) : {shapes: this.shapes};
		                if (di.shapes.length > 0) {
		                    var item = di.shapes[0];
		                    rect = item.bounds(ROTATED);
		                    for (var i = 1; i < di.shapes.length; i++) {
		                        item = di.shapes[i];
		                        temp = item.bounds(ROTATED);
		                        if (origin === true) {
		                            temp.x -= item._rotationOffset.x;
		                            temp.y -= item._rotationOffset.y;
		                        }
		                        rect = rect.union(temp);
		                    }
		                }
		                return rect;
		            },
	
		            _containerOffset: function() {
		                var containerOffset = this.element.offset();
		                if (this.toolBar) {
		                    containerOffset.top += outerHeight(this.toolBar.element);
		                }
		                return containerOffset;
		            },
	
		            documentToView: function(point) {
		                var containerOffset = this._containerOffset();
	
		                return new Point(point.x - containerOffset.left, point.y - containerOffset.top);
		            },
		            viewToDocument: function(point) {
		                var containerOffset = this._containerOffset();
	
		                return new Point(point.x + containerOffset.left, point.y + containerOffset.top);
		            },
		            viewToModel: function(point) {
		                return this._transformWithMatrix(point, this._matrixInvert);
		            },
		            modelToView: function(point) {
		                return this._transformWithMatrix(point, this._matrix);
		            },
		            modelToLayer: function(point) {
		                return this._transformWithMatrix(point, this._layerMatrix);
		            },
		            layerToModel: function(point) {
		                return this._transformWithMatrix(point, this._layerMatrixInvert);
		            },
		            documentToModel: function(point) {
		                var viewPoint = this.documentToView(point);
		                if (!this.canvas.translate) {
		                    viewPoint.x = viewPoint.x + this.scroller.scrollLeft;
		                    viewPoint.y = viewPoint.y + this.scroller.scrollTop;
		                }
		                return this.viewToModel(viewPoint);
		            },
		            modelToDocument: function(point) {
		                return this.viewToDocument(this.modelToView(point));
		            },
		            _transformWithMatrix: function(point, matrix) {
		                var result = point;
		                if (point instanceof Point) {
		                    if (matrix) {
		                        result = matrix.apply(point);
		                    }
		                }
		                else {
		                    var tl = this._transformWithMatrix(point.topLeft(), matrix),
		                        br = this._transformWithMatrix(point.bottomRight(), matrix);
		                    result = Rect.fromPoints(tl, br);
		                }
		                return result;
		            },
	
		            setDataSource: function(dataSource) {
		                this.options.dataSource = dataSource;
		                this._dataSource();
		                if (this.options.autoBind) {
		                    this.dataSource.fetch();
		                }
		            },
	
		            setConnectionsDataSource: function(dataSource) {
		                this.options.connectionsDataSource = dataSource;
		                this._connectionDataSource();
		                if (this.options.autoBind) {
		                    this.connectionsDataSource.fetch();
		                }
		            },
	
		            /**
		             * Performs a diagram layout of the given type.
		             * @param layoutType The layout algorithm to be applied (TreeLayout, LayeredLayout, SpringLayout).
		             * @param options Layout-specific options.
		             */
		            layout: function (options) {
		                this._layouting = true;
		                // TODO: raise layout event?
		                var type;
		                if(isUndefined(options)) {
		                    options = this.options.layout;
		                }
		                if (isUndefined(options) || isUndefined(options.type)) {
		                    type = "Tree";
		                }
		                else {
		                    type = options.type;
		                }
		                var l;
		                switch (type.toLowerCase()) {
		                    case "tree":
		                        l = new diagram.TreeLayout(this);
		                        break;
	
		                    case "layered":
		                        l = new diagram.LayeredLayout(this);
		                        break;
	
		                    case "forcedirected":
		                    case "force":
		                    case "spring":
		                    case "springembedder":
		                        l = new diagram.SpringLayout(this);
		                        break;
		                    default:
		                        throw "Layout algorithm '" + type + "' is not supported.";
		                }
		                var initialState = new diagram.LayoutState(this);
		                var finalState = l.layout(options);
		                if (finalState) {
		                    var unit = new diagram.LayoutUndoUnit(initialState, finalState, options ? options.animate : null);
		                    this.undoRedoService.add(unit);
		                }
		                this._layouting = false;
		                this._redrawConnections();
		            },
		            /**
		             * Gets a shape on the basis of its identifier.
		             * @param id (string) the identifier of a shape.
		             * @returns {Shape}
		             */
		            getShapeById: function (id) {
		                var found;
		                found = Utils.first(this.shapes, function (s) {
		                    return s.visual.id === id;
		                });
		                if (found) {
		                    return found;
		                }
		                found = Utils.first(this.connections, function (c) {
		                    return c.visual.id === id;
		                });
		                return found;
		            },
	
		            getShapeByModelId: function (id) {
		                var shape;
		                if (this._isEditable) {
		                    shape = this._dataMap[id];
		                } else {
		                    shape = Utils.first(this.shapes, function(shape) {
		                        return (shape.dataItem || {}).id === id;
		                    });
		                }
		                return shape;
		            },
	
		            getShapeByModelUid: function(uid) {
		                var shape;
		                if (this._isEditable) {
		                    shape = Utils.first(this.shapes, function(shape) {
		                        return (shape.dataItem || {}).uid === uid;
		                    });
		                } else {
		                    shape = this._dataMap[uid];
		                }
		                return shape;
		            },
	
		            getConnectionByModelId: function(id) {
		                var connection;
		                if (this.connectionsDataSource) {
		                    connection = Utils.first(this.connections, function(connection) {
		                        return (connection.dataItem || {}).id === id;
		                    });
		                }
		                return connection;
		            },
	
		            getConnectionByModelUid: function(uid) {
		                var connection;
		                if (this.connectionsDataSource) {
		                    connection = this._connectionsDataMap[uid];
		                }
		                return connection;
		            },
	
		            _extendLayoutOptions: function(options) {
		                if(options.layout) {
		                    options.layout = deepExtend({}, diagram.LayoutBase.fn.defaultOptions || {}, options.layout);
		                }
		            },
	
		            _selectionChanged: function (selected, deselected) {
		                if (selected.length || deselected.length) {
		                    this.trigger(SELECT, { selected: selected, deselected: deselected });
		                }
		            },
		            _getValidZoom: function (zoom) {
		                return math.min(math.max(zoom, this.options.zoomMin), this.options.zoomMax);
		            },
		            _panTransform: function (pos) {
		                var diagram = this,
		                    pan = pos || diagram._pan;
	
		                if (diagram.canvas.translate) {
		                    diagram.scroller.scrollTo(pan.x, pan.y);
		                    diagram._zoomMainLayer();
		                } else {
		                    diagram._storePan(pan);
		                    diagram._transformMainLayer();
		                }
		            },
	
		            _finishPan: function () {
		                this.trigger(PAN, {total: this._pan, delta: Number.NaN});
		            },
		            _storePan: function (pan) {
		                this._pan = pan;
		                this._storeViewMatrix();
		            },
		            _zoomMainLayer: function () {
		                var zoom = this._zoom;
	
		                var transform = new CompositeTransform(0, 0, zoom, zoom);
		                transform.render(this.mainLayer);
		                this._storeLayerMatrix(transform);
		                this._storeViewMatrix();
		            },
		            _transformMainLayer: function () {
		                var pan = this._pan,
		                    zoom = this._zoom;
	
		                var transform = new CompositeTransform(pan.x, pan.y, zoom, zoom);
		                transform.render(this.mainLayer);
		                this._storeLayerMatrix(transform);
		                this._storeViewMatrix();
		            },
		            _storeLayerMatrix: function(canvasTransform) {
		                this._layerMatrix = canvasTransform.toMatrix();
		                this._layerMatrixInvert = canvasTransform.invert().toMatrix();
		            },
		            _storeViewMatrix: function() {
		                var pan = this._pan,
		                    zoom = this._zoom;
	
		                var transform = new CompositeTransform(pan.x, pan.y, zoom, zoom);
		                this._matrix = transform.toMatrix();
		                this._matrixInvert = transform.invert().toMatrix();
		            },
		            _toIndex: function (items, indices) {
		                var result = this._getDiagramItems(items);
		                this.mainLayer.toIndex(result.visuals, indices);
		                this._fixOrdering(result, false);
		            },
		            _fixOrdering: function (result, toFront) {
		                var shapePos = toFront ? this.shapes.length - 1 : 0,
		                    conPos = toFront ? this.connections.length - 1 : 0,
		                    i, item;
		                for (i = 0; i < result.shapes.length; i++) {
		                    item = result.shapes[i];
		                    Utils.remove(this.shapes, item);
		                    Utils.insert(this.shapes, item, shapePos);
		                }
		                for (i = 0; i < result.cons.length; i++) {
		                    item = result.cons[i];
		                    Utils.remove(this.connections, item);
		                    Utils.insert(this.connections, item, conPos);
		                }
		            },
		            _getDiagramItems: function (items) {
		                var i, result = {}, args = items;
		                result.visuals = [];
		                result.shapes = [];
		                result.cons = [];
	
		                if (!items) {
		                    args = this._selectedItems.slice();
		                } else if (!isArray(items)) {
		                    args = [items];
		                }
	
		                for (i = 0; i < args.length; i++) {
		                    var item = args[i];
		                    if (item instanceof Shape) {
		                        result.shapes.push(item);
		                        result.visuals.push(item.visual);
		                    } else if (item instanceof Connection) {
		                        result.cons.push(item);
		                        result.visuals.push(item.visual);
		                    }
		                }
	
		                return result;
		            },
	
		            _removeItem: function (item, undoable, removedConnections) {
		                item.select(false);
		                if (item instanceof Shape) {
		                    this._removeShapeDataItem(item);
		                    this._removeShape(item, undoable, removedConnections);
		                } else if (item instanceof Connection) {
		                    this._removeConnectionDataItem(item);
		                    this._removeConnection(item, undoable);
		                }
	
		                this.mainLayer.remove(item.visual);
		            },
	
		            _removeShape: function (shape, undoable, removedConnections) {
		                var i, connection, connector,
		                    sources = [], targets = [];
		                this.toolService._removeHover();
	
		                if (undoable) {
		                    this.undoRedoService.addCompositeItem(new DeleteShapeUnit(shape));
		                }
		                Utils.remove(this.shapes, shape);
		                this._shapesQuadTree.remove(shape);
	
		                for (i = 0; i < shape.connectors.length; i++) {
		                    connector = shape.connectors[i];
		                    for (var j = 0; j < connector.connections.length; j++) {
		                        connection = connector.connections[j];
		                        if (!removedConnections || !dataviz.inArray(connection, removedConnections)) {
		                            if (connection.sourceConnector == connector) {
		                                sources.push(connection);
		                            } else if (connection.targetConnector == connector) {
		                                targets.push(connection);
		                            }
		                        }
		                    }
		                }
	
		                for (i = 0; i < sources.length; i++) {
		                    sources[i].source(null, undoable);
		                    sources[i].updateModel();
		                }
		                for (i = 0; i < targets.length; i++) {
		                    targets[i].target(null, undoable);
		                    targets[i].updateModel();
		                }
		            },
	
		            _removeConnection: function (connection, undoable) {
		                if (connection.sourceConnector) {
		                    Utils.remove(connection.sourceConnector.connections, connection);
		                }
		                if (connection.targetConnector) {
		                    Utils.remove(connection.targetConnector.connections, connection);
		                }
		                if (undoable) {
		                    this.undoRedoService.addCompositeItem(new DeleteConnectionUnit(connection));
		                }
	
		                Utils.remove(this.connections, connection);
		            },
	
		            _removeDataItems: function(items, recursive) {
		                var item, children, shape, idx;
		                items = isArray(items) ? items : [items];
	
		                while (items.length) {
		                    item = items.shift();
		                    shape = this._dataMap[item.uid];
		                    if (shape) {
		                        this._removeShapeConnections(shape);
		                        this._removeItem(shape, false);
		                        delete this._dataMap[item.uid];
		                        if (recursive && item.hasChildren && item.loaded()) {
		                            children = item.children.data();
		                            for (idx = 0; idx < children.length; idx++) {
		                                items.push(children[idx]);
		                            }
		                        }
		                    }
		                }
		            },
	
		            _removeShapeConnections: function(shape) {
		                var connections = shape.connections();
		                var idx;
	
		                if (connections) {
		                    for (idx = 0; idx < connections.length; idx++) {
		                        this._removeItem(connections[idx], false);
		                    }
		                }
		            },
	
		            _addDataItem: function(dataItem, undoable) {
		                if (!defined(dataItem)) {
		                    return;
		                }
	
		                var shape = this._dataMap[dataItem.id];
		                if (shape) {
		                    return shape;
		                }
	
		                var options = deepExtend({}, this.options.shapeDefaults);
		                options.dataItem = dataItem;
		                shape = new Shape(options, this);
		                this.addShape(shape, undoable !== false);
		                this._dataMap[dataItem.id] = shape;
		                return shape;
		            },
	
		            _addDataItemByUid: function(dataItem) {
		                if (!defined(dataItem)) {
		                    return;
		                }
	
		                var shape = this._dataMap[dataItem.uid];
		                if (shape) {
		                    return shape;
		                }
	
		                var options = deepExtend({}, this.options.shapeDefaults);
		                options.dataItem = dataItem;
		                shape = new Shape(options, this);
		                this.addShape(shape);
		                this._dataMap[dataItem.uid] = shape;
		                return shape;
		            },
	
		            _addDataItems: function(items, parent) {
		                var item, idx, shape, parentShape, connection;
		                for (idx = 0; idx < items.length; idx++) {
		                    item = items[idx];
		                    shape = this._addDataItemByUid(item);
		                    parentShape = this._addDataItemByUid(parent);
		                    if (parentShape && !this.connected(parentShape, shape)) { // check if connected to not duplicate connections.
		                        connection = this.connect(parentShape, shape);
		                    }
		                }
		            },
	
		            _refreshSource: function (e) {
		                var that = this,
		                    node = e.node,
		                    action = e.action,
		                    items = e.items,
		                    options = that.options,
		                    idx,
		                    dataBound;
	
		                if (e.field) {
		                    for (idx = 0; idx < items.length; idx++) {
		                        if (this._dataMap[items[idx].uid]) {
		                            this._dataMap[items[idx].uid].redrawVisual();
		                        }
		                    }
		                    return;
		                }
	
		                if (action == "remove") {
		                    this._removeDataItems(e.items, true);
		                } else {
	
		                    if ((!action || action === "itemloaded") && !this._bindingRoots) {
		                        this._bindingRoots = true;
		                        dataBound = true;
		                    }
	
		                    if (!action && !node) {
		                        that.clear();
		                    }
	
		                    this._addDataItems(items, node);
	
		                    for (idx = 0; idx < items.length; idx++) {
		                        items[idx].load();
		                    }
		                }
	
		                if (options.layout && (dataBound || action == "remove" || action == "add")) {
		                    that.layout(options.layout);
		                }
	
		                if (dataBound) {
		                    this.trigger("dataBound");
		                    this._bindingRoots = false;
		                }
		            },
	
		            _addItem: function (item) {
		                if (item instanceof Shape) {
		                    this.addShape(item);
		                } else if (item instanceof Connection) {
		                    this.addConnection(item);
		                }
		            },
	
		            _createToolBar: function(preventClosing) {
		                var diagram = this.toolService.diagram;
	
		                if (!this.singleToolBar && diagram.select().length === 1) {
		                    var element = diagram.select()[0];
		                    if (element && element.options.editable !== false) {
		                        var editable = element.options.editable;
		                        var tools = editable.tools;
		                        if (this._isEditable && tools.length === 0) {
		                            if (element instanceof Shape) {
		                                tools = ["edit", "rotateClockwise", "rotateAnticlockwise"];
		                            } else if (element instanceof Connection) {
		                                tools = ["edit"];
		                            }
	
		                            if (editable && editable.remove !== false) {
		                                tools.push("delete");
		                            }
		                        }
	
		                        if (tools && tools.length) {
		                            var padding = 20;
		                            var point;
		                            this.singleToolBar = new DiagramToolBar(diagram, {
		                                tools: tools,
		                                click: proxy(this._toolBarClick, this),
		                                modal: true,
		                                popupZIndex: parseInt(diagram.element.closest(".k-window").css("zIndex"), 10) + 10
		                            });
		                            var popupWidth = outerWidth(this.singleToolBar._popup.element);
		                            var popupHeight = outerHeight(this.singleToolBar._popup.element);
		                            if (element instanceof Shape) {
		                                var shapeBounds = this.modelToView(element.bounds(ROTATED));
		                                point = new Point(shapeBounds.x, shapeBounds.y).minus(new Point(
		                                    (popupWidth - shapeBounds.width) / 2,
		                                    popupHeight + padding));
		                            } else if (element instanceof Connection) {
		                                var connectionBounds = this.modelToView(element.bounds());
	
		                                point = new Point(connectionBounds.x, connectionBounds.y)
		                                    .minus(new Point(
		                                        (popupWidth - connectionBounds.width - 20) / 2,
		                                        popupHeight + padding
		                                    ));
		                            }
	
		                            if (point) {
		                                if (!this.canvas.translate) {
		                                    point = point.minus(new Point(this.scroller.scrollLeft, this.scroller.scrollTop));
		                                }
		                                point = this.viewToDocument(point);
		                                point = new Point(math.max(point.x, 0), math.max(point.y, 0));
		                                this.singleToolBar.showAt(point);
		                                if (preventClosing) {
		                                    this.singleToolBar._popup.one("close", preventDefault);
		                                }
		                            } else {
		                                this._destroyToolBar();
		                            }
		                        }
		                    }
		                }
		            },
	
		            _toolBarClick: function(e) {
		                this.trigger("toolBarClick", e);
		                this._destroyToolBar();
		            },
	
		            _normalizePointZoom: function (point) {
		                return point.times(1 / this.zoom());
		            },
	
		            _initialize: function () {
		                this.shapes = [];
		                this._selectedItems = [];
		                this.connections = [];
		                this._dataMap = {};
		                this._connectionsDataMap = {};
		                this._inactiveShapeItems = new InactiveItemsCollection();
		                this._deferredConnectionUpdates = [];
		                this.undoRedoService = new UndoRedoService({
		                    undone: this._syncHandler,
		                    redone: this._syncHandler
		                });
		                this.id = diagram.randomId();
		            },
	
		            _fetchFreshData: function () {
		                var that = this;
		                that._dataSource();
	
		                if (that._isEditable) {
		                    that._connectionDataSource();
		                }
	
		                if (that.options.autoBind) {
		                    if (that._isEditable) {
		                        this._loadingShapes = true;
		                        this._loadingConnections = true;
		                        that.dataSource.fetch();
		                        that.connectionsDataSource.fetch();
		                    } else {
		                        that.dataSource.fetch();
		                    }
		                }
		            },
	
		            _dataSource: function() {
		                if (defined(this.options.connectionsDataSource)) {
		                    this._isEditable = true;
		                    var dsOptions = this.options.dataSource || {};
		                    var ds = isArray(dsOptions) ? { data: dsOptions } : dsOptions;
	
		                    if (this.dataSource && this._shapesRefreshHandler) {
		                        this.dataSource
		                            .unbind("change", this._shapesRefreshHandler)
		                            .unbind("requestStart", this._shapesRequestStartHandler)
		                            .unbind("error", this._shapesErrorHandler);
		                    } else {
		                        this._shapesRefreshHandler = proxy(this._refreshShapes, this);
		                        this._shapesRequestStartHandler = proxy(this._shapesRequestStart, this);
		                        this._shapesErrorHandler = proxy(this._error, this);
		                    }
	
		                    this.dataSource = kendo.data.DataSource.create(ds)
		                        .bind("change", this._shapesRefreshHandler)
		                        .bind("requestStart", this._shapesRequestStartHandler)
		                        .bind("error", this._shapesErrorHandler);
		                } else {
		                    this._treeDataSource();
		                    this._isEditable = false;
		                }
		            },
	
		            _connectionDataSource: function() {
		                var dsOptions = this.options.connectionsDataSource;
		                if (dsOptions) {
		                    var ds = isArray(dsOptions) ? { data: dsOptions } : dsOptions;
	
		                    if (this.connectionsDataSource && this._connectionsRefreshHandler) {
		                        this.connectionsDataSource
		                            .unbind("change", this._connectionsRefreshHandler)
		                            .unbind("requestStart", this._connectionsRequestStartHandler)
		                            .unbind("error", this._connectionsErrorHandler);
		                    } else {
		                        this._connectionsRefreshHandler = proxy(this._refreshConnections, this);
		                        this._connectionsRequestStartHandler = proxy(this._connectionsRequestStart, this);
		                        this._connectionsErrorHandler = proxy(this._connectionsError, this);
		                    }
	
		                    this.connectionsDataSource = kendo.data.DataSource.create(ds)
		                        .bind("change", this._connectionsRefreshHandler)
		                        .bind("requestStart", this._connectionsRequestStartHandler)
		                        .bind("error", this._connectionsErrorHandler);
		                }
		            },
	
		            _shapesRequestStart: function(e) {
		                if (e.type == "read") {
		                    this._loadingShapes = true;
		                }
		            },
	
		            _connectionsRequestStart: function(e) {
		                if (e.type == "read") {
		                    this._loadingConnections = true;
		                }
		            },
	
		            _error: function () {
		                this._loadingShapes = false;
		            },
	
		            _connectionsError: function() {
		                this._loadingConnections = false;
		            },
	
		            _refreshShapes: function(e) {
		                if (e.action === "remove") {
		                    if (this._shouldRefresh()) {
		                        this._removeShapes(e.items);
		                    }
		                } else if (e.action === "itemchange") {
		                    if (this._shouldRefresh()) {
		                        this._updateShapes(e.items, e.field);
		                    }
		                } else if (e.action === "add") {
		                    this._inactiveShapeItems.add(e.items);
		                } else if (e.action === "sync") {
		                    this._syncShapes(e.items);
		                } else {
		                    this.refresh();
		                }
		            },
	
		            _shouldRefresh: function() {
		                return !this._suspended;
		            },
	
		            _suspendModelRefresh: function() {
		                this._suspended = (this._suspended || 0) + 1;
		            },
	
		            _resumeModelRefresh: function() {
		                this._suspended = math.max((this._suspended || 0) - 1, 0);
		            },
	
		            refresh: function() {
		                this._loadingShapes = false;
		                if (!this._loadingConnections) {
		                    this._rebindShapesAndConnections();
		                }
		            },
	
		            _rebindShapesAndConnections: function() {
		                this.clear();
		                this._addShapes(this.dataSource.view());
		                if (this.connectionsDataSource) {
		                    this._addConnections(this.connectionsDataSource.view(), false);
		                }
	
		                if (this.options.layout) {
		                    this.layout(this.options.layout);
		                } else {
		                    this._redrawConnections();
		                }
		                this.trigger("dataBound");
		            },
	
		            refreshConnections: function() {
		                this._loadingConnections = false;
		                if (!this._loadingShapes) {
		                    this._rebindShapesAndConnections();
		                }
		            },
	
		            _redrawConnections: function() {
		                var connections = this.connections;
		                for (var idx = 0; idx < connections.length; idx++) {
		                    connections[idx].refresh();
		                }
		            },
	
		            _removeShapes: function(items) {
		                var dataMap = this._dataMap;
		                var item, i;
		                for (i = 0; i < items.length; i++) {
		                    item = items[i];
		                    if (dataMap[item.id]) {
		                        this.remove(dataMap[item.id], false);
		                        dataMap[item.id] = null;
		                    }
		                }
		            },
	
		            _syncShapes: function() {
		                var diagram = this;
		                var inactiveItems = diagram._inactiveShapeItems;
		                inactiveItems.forEach(function(inactiveItem) {
		                    var dataItem = inactiveItem.dataItem;
		                    var shape = inactiveItem.element;
		                    if (!dataItem.isNew()) {
		                        if (shape) {
		                            shape._setOptionsFromModel();
		                            diagram.addShape(shape, inactiveItem.undoable);
		                            diagram._dataMap[dataItem.id] = shape;
		                        } else {
		                            diagram._addDataItem(dataItem);
		                        }
		                        inactiveItem.activate();
		                        inactiveItems.remove(dataItem);
		                    }
		                });
		            },
	
		            _updateShapes: function(items, field) {
		                for (var i = 0; i < items.length; i++) {
		                    var dataItem = items[i];
	
		                    var shape = this._dataMap[dataItem.id];
		                    if (shape) {
		                        shape.updateOptionsFromModel(dataItem, field);
		                    }
		                }
		            },
	
		            _addShapes: function(dataItems) {
		                for (var i = 0; i < dataItems.length; i++) {
		                    this._addDataItem(dataItems[i], false);
		                }
		            },
	
		            _refreshConnections: function(e) {
		                if (e.action === "remove") {
		                    if (this._shouldRefresh()) {
		                        this._removeConnections(e.items);
		                    }
		                } else if (e.action === "add") {
		                    this._addConnections(e.items);
		                } else if (e.action === "sync") {
		                    //TO DO: include logic to update the connections with different values returned from the server.
		                } else if (e.action === "itemchange") {
		                    if (this._shouldRefresh()) {
		                        this._updateConnections(e.items);
		                    }
		                } else {
		                    this.refreshConnections();
		                }
		            },
	
		            _removeConnections: function(items) {
		                for (var i = 0; i < items.length; i++) {
		                    this.remove(this._connectionsDataMap[items[i].uid], false);
		                    this._connectionsDataMap[items[i].uid] = null;
		                }
		            },
	
		            _updateConnections: function(items) {
		                for (var i = 0; i < items.length; i++) {
		                    var dataItem = items[i];
	
		                    var connection = this._connectionsDataMap[dataItem.uid];
		                    connection.updateOptionsFromModel(dataItem);
		                }
		            },
	
		            _addConnections: function(connections, undoable) {
		                var length = connections.length;
	
		                for (var i = 0; i < length; i++) {
		                    var dataItem = connections[i];
		                    this._addConnectionDataItem(dataItem, undoable);
		                }
		            },
	
		            _addConnectionDataItem: function(dataItem, undoable) {
		                if (!this._connectionsDataMap[dataItem.uid]) {
		                    var from = this._validateConnector(dataItem.from);
		                    if (!defined(from) || from === null) {
		                        from = new Point(dataItem.fromX, dataItem.fromY);
		                    }
	
		                    var to = this._validateConnector(dataItem.to);
		                    if (!defined(to) || to === null) {
		                        to = new Point(dataItem.toX, dataItem.toY);
		                    }
	
		                    if (defined(from) && defined(to)) {
		                        var options = deepExtend({}, this.options.connectionDefaults);
		                        options.dataItem = dataItem;
		                        var connection = new Connection(from, to, options);
	
		                        this._connectionsDataMap[dataItem.uid] = connection;
		                        this.addConnection(connection, undoable);
		                    }
		                }
		            },
	
		            _validateConnector: function(value) {
		                var connector;
	
		                if (defined(value) && value !== null) {
		                    connector = this._dataMap[value];
		                }
	
		                return connector;
		            },
	
		            _treeDataSource: function () {
		                var that = this,
		                    options = that.options,
		                    dataSource = options.dataSource;
	
		                dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;
	
		                if (dataSource instanceof kendo.data.DataSource && !(dataSource instanceof kendo.data.HierarchicalDataSource)) {
		                    throw new Error("Incorrect DataSource type. If a single dataSource instance is set to the diagram then it should be a HierarchicalDataSource. You should set only the options instead of an instance or a HierarchicalDataSource instance or supply connectionsDataSource as well.");
		                }
	
		                if (!dataSource.fields) {
		                    dataSource.fields = [
		                        { field: "text" },
		                        { field: "url" },
		                        { field: "spriteCssClass" },
		                        { field: "imageUrl" }
		                    ];
		                }
		                if (that.dataSource && that._refreshHandler) {
		                    that._unbindDataSource();
		                }
	
		                that._refreshHandler = proxy(that._refreshSource, that);
		                that._errorHandler = proxy(that._error, that);
	
		                that.dataSource = HierarchicalDataSource.create(dataSource)
		                    .bind(CHANGE, that._refreshHandler)
		                    .bind(ERROR, that._errorHandler);
		            },
	
		            _unbindDataSource: function () {
		                var that = this;
	
		                that.dataSource.unbind(CHANGE, that._refreshHandler).unbind(ERROR, that._errorHandler);
		            },
	
		            _adorn: function (adorner, isActive) {
		                if (isActive !== undefined && adorner) {
		                    if (isActive) {
		                        this._adorners.push(adorner);
		                        this.adornerLayer.append(adorner.visual);
		                    }
		                    else {
		                        Utils.remove(this._adorners, adorner);
		                        this.adornerLayer.remove(adorner.visual);
		                    }
		                }
		            },
	
		            _showConnectors: function (shape, value) {
		                if (value) {
		                    this._connectorsAdorner.show(shape);
		                } else {
		                    this._connectorsAdorner.destroy();
		                }
		            },
	
		            _updateAdorners: function() {
		                var adorners = this._adorners;
	
		                for(var i = 0; i < adorners.length; i++) {
		                    var adorner = adorners[i];
	
		                    if (adorner.refreshBounds) {
		                        adorner.refreshBounds();
		                    }
		                    adorner.refresh();
		                }
		            },
	
		            _refresh: function () {
		                for (var i = 0; i < this.connections.length; i++) {
		                    this.connections[i].refresh();
		                }
		            },
	
		            _destroyToolBar: function() {
		                if (this.singleToolBar) {
		                    this.singleToolBar.hide();
		                    this.singleToolBar.destroy();
		                    this.singleToolBar = null;
		                }
		            },
	
		            _destroyGlobalToolBar: function() {
		                if (this.toolBar) {
		                    this.toolBar.hide();
		                    this.toolBar.destroy();
		                    this.toolBar = null;
		                }
		            },
	
		            exportDOMVisual: function() {
		                var viewBox = this.canvas._viewBox;
		                var scrollOffset = geom.transform()
		                                       .translate(-viewBox.x, -viewBox.y);
	
		                var viewRect = new geom.Rect([0, 0], [viewBox.width, viewBox.height]);
		                var clipPath = draw.Path.fromRect(viewRect);
		                var wrap = new draw.Group({ transform: scrollOffset });
		                var clipWrap = new draw.Group({ clip: clipPath });
		                var root = this.canvas.drawingElement.children[0];
	
		                clipWrap.append(wrap);
	
		                // Don't reparent the root
		                wrap.children.push(root);
	
		                return clipWrap;
		            },
	
		            exportVisual: function() {
		                var scale = geom.transform().scale(1 / this._zoom);
		                var wrap = new draw.Group({
		                    transform: scale
		                });
	
		                var root = this.mainLayer.drawingElement;
		                wrap.children.push(root);
	
		                return wrap;
		            },
	
		            _syncChanges: function() {
		                this._syncShapeChanges();
		                this._syncConnectionChanges();
		            },
	
		            _syncShapeChanges: function() {
		                if (this.dataSource && this._isEditable) {
		                    this.dataSource.sync();
		                }
		            },
	
		            _syncConnectionChanges: function() {
		                var that = this;
		                if (that.connectionsDataSource && that._isEditable) {
		                    $.when.apply($, that._deferredConnectionUpdates).then(function() {
		                        that.connectionsDataSource.sync();
		                    });
		                    that.deferredConnectionUpdates = [];
		                }
		            }
		        });
	
		        dataviz.ExportMixin.extend(Diagram.fn, true);
	
		        if (kendo.PDFMixin) {
		            kendo.PDFMixin.extend(Diagram.fn);
		        }
	
		        function filterShapeDataItem(dataItem) {
		            var result = {};
	
		            dataItem = dataItem || {};
	
		            if (defined(dataItem.text) && dataItem.text !== null) {
		                result.text = dataItem.text;
		            }
	
		            if (defined(dataItem.x) && dataItem.x !== null) {
		                result.x = dataItem.x;
		            }
	
		            if (defined(dataItem.y) && dataItem.y !== null) {
		                result.y = dataItem.y;
		            }
	
		            if (defined(dataItem.width) && dataItem.width !== null) {
		                result.width = dataItem.width;
		            }
	
		            if (defined(dataItem.height) && dataItem.height !== null) {
		                result.height = dataItem.height;
		            }
	
		            if (defined(dataItem.type) && dataItem.type !== null) {
		                result.type = dataItem.type;
		            }
	
		            return result;
		        }
	
		        function filterConnectionDataItem(dataItem) {
		            var result = {};
	
		            dataItem = dataItem || {};
	
		            if (defined(dataItem.text) && dataItem.text !== null) {
		                result.content = dataItem.text;
		            }
	
		            if (defined(dataItem.type) && dataItem.type !== null) {
		                result.type = dataItem.type;
		            }
	
		            if (defined(dataItem.from) && dataItem.from !== null) {
		                result.from = dataItem.from;
		            }
	
		            if (defined(dataItem.fromConnector) && dataItem.fromConnector !== null) {
		                result.fromConnector = dataItem.fromConnector;
		            }
	
		            if (defined(dataItem.fromX) && dataItem.fromX !== null) {
		                result.fromX = dataItem.fromX;
		            }
	
		            if (defined(dataItem.fromY) && dataItem.fromY !== null) {
		                result.fromY = dataItem.fromY;
		            }
	
		            if (defined(dataItem.to) && dataItem.to !== null) {
		                result.to = dataItem.to;
		            }
	
		            if (defined(dataItem.toConnector) && dataItem.toConnector !== null) {
		                result.toConnector = dataItem.toConnector;
		            }
	
		            if (defined(dataItem.toX) && dataItem.toX !== null) {
		                result.toX = dataItem.toX;
		            }
	
		            if (defined(dataItem.toY) && dataItem.toY !== null) {
		                result.toY = dataItem.toY;
		            }
	
		            return result;
		        }
	
	
		        var DiagramToolBar = kendo.Observable.extend({
		            init: function(diagram, options) {
		                kendo.Observable.fn.init.call(this);
		                this.diagram = diagram;
		                this.options = deepExtend({}, this.options, options);
		                this._tools = [];
		                this.createToolBar();
		                this.createTools();
		                this.appendTools();
	
		                if (this.options.modal) {
		                    this.createPopup();
		                }
	
		                this.bind(this.events, options);
		            },
	
		            events: ["click"],
	
		            createPopup: function() {
		                this.container = $("<div/>").append(this.element);
		                this._popup = this.container.kendoPopup({}).getKendoPopup();
		            },
	
		            appendTools: function() {
		                for (var i = 0; i < this._tools.length; i++) {
		                    var tool = this._tools[i];
		                    if (tool.buttons && tool.buttons.length || !defined(tool.buttons)) {
		                        this._toolBar.add(tool);
		                    }
		                }
		            },
	
		            createToolBar: function() {
		                this.element = $("<div/>");
		                this._toolBar = this.element
		                    .kendoToolBar({
		                        click: proxy(this.click, this),
		                        resizable: false
		                    }).getKendoToolBar();
	
		                this.element.css("border", "none");
		            },
	
		            createTools: function() {
		                for (var i = 0; i < this.options.tools.length; i++) {
		                    this.createTool(this.options.tools[i]);
		                }
		            },
	
		            createTool: function(tool) {
		                if (!isPlainObject(tool)) {
		                    tool = {
		                        name: tool
		                    };
		                }
		                var toolName = tool.name + "Tool";
		                if (this[toolName]) {
		                    this[toolName](tool);
		                } else {
		                    this._tools.push(deepExtend({}, tool, {
		                        attributes: this._setAttributes({action: tool.name})
		                    }));
		                }
		            },
	
		            showAt: function(point) {
		                var popupZIndex = parseInt(this.options.popupZIndex, 10);
	
		                if (this._popup) {
		                    this._popup.open(point.x, point.y);
	
		                    if (popupZIndex) {
		                        this._popup.wrapper.css("zIndex", popupZIndex);
		                    }
		                }
		            },
	
		            hide: function() {
		                if (this._popup) {
		                    this._popup.close();
		                }
		            },
	
		            newGroup: function() {
		                return {
		                    type: "buttonGroup",
		                    buttons: []
		                };
		            },
	
		            editTool: function() {
		                this._tools.push({
		                    icon: "edit",
		                    showText: "overflow",
		                    type: "button",
		                    text: "Edit",
		                    attributes: this._setAttributes({ action: "edit" })
		                });
		            },
	
		            deleteTool: function() {
		                this._tools.push({
		                    icon: "close",
		                    showText: "overflow",
		                    type: "button",
		                    text: "Delete",
		                    attributes: this._setAttributes({ action: "delete" })
		                });
		            },
	
		            rotateAnticlockwiseTool: function(options) {
		                this._appendGroup("rotate");
		                this._rotateGroup.buttons.push({
		                    icon: "rotate-left",
		                    showText: "overflow",
		                    text: "RotateAnticlockwise",
		                    group: "rotate",
		                    attributes: this._setAttributes({ action: "rotateAnticlockwise", step: options.step })
		                });
		            },
	
		            rotateClockwiseTool: function(options) {
		                this._appendGroup("rotate");
		                this._rotateGroup.buttons.push({
		                    icon: "rotate-right",
		                    attributes: this._setAttributes({ action: "rotateClockwise", step: options.step }),
		                    showText: "overflow",
		                    text: "RotateClockwise",
		                    group: "rotate"
		                });
		            },
	
		            createShapeTool: function() {
		                this._appendGroup("create");
		                this._createGroup.buttons.push({
		                    icon: "shape",
		                    showText: "overflow",
		                    text: "CreateShape",
		                    group: "create",
		                    attributes: this._setAttributes({ action: "createShape" })
		                });
		            },
	
		            createConnectionTool: function() {
		                this._appendGroup("create");
		                this._createGroup.buttons.push({
		                    icon: "connector",
		                    showText: "overflow",
		                    text: "CreateConnection",
		                    group: "create",
		                    attributes: this._setAttributes({ action: "createConnection" })
		                });
		            },
	
		            undoTool: function() {
		                this._appendGroup("history");
		                this._historyGroup.buttons.push({
		                    icon: "undo",
		                    showText: "overflow",
		                    text: "Undo",
		                    group: "history",
		                    attributes: this._setAttributes({ action: "undo" })
		                });
		            },
	
		            redoTool: function() {
		                this._appendGroup("history");
		                this._historyGroup.buttons.push({
		                    icon: "redo",
		                    showText: "overflow",
		                    text: "Redo",
		                    group: "history",
		                    attributes: this._setAttributes({ action: "redo" })
		                });
		            },
	
		            _appendGroup: function(name) {
		                var prop = "_" + name + "Group";
		                if (!this[prop]) {
		                    this[prop] = this.newGroup();
		                    this._tools.push(this[prop]);
		                }
		            },
	
		            _setAttributes: function(attributes) {
		                var attr = {};
	
		                if (attributes.action) {
		                    attr[kendo.attr("action")] = attributes.action;
		                }
	
		                if (attributes.step) {
		                    attr[kendo.attr("step")] = attributes.step;
		                }
	
		                return attr;
		            },
	
		            _getAttributes: function(element) {
		                var attr = {};
	
		                var action = element.attr(kendo.attr("action"));
		                if (action) {
		                    attr.action = action;
		                }
	
		                var step = element.attr(kendo.attr("step"));
		                if (step) {
		                    attr.step = step;
		                }
	
		                return attr;
		            },
	
		            click: function(e) {
		                var attributes = this._getAttributes($(e.target));
		                var action = attributes.action;
	
		                if (action && this[action]) {
		                    this[action](attributes);
		                }
	
		                this.trigger("click", this.eventData(action, e.target));
		            },
	
		            eventData: function(action, target) {
		                var elements = this.selectedElements(),
		                    length = elements.length,
		                    shapes = [], connections = [], element;
	
		                for (var idx = 0; idx < length; idx++) {
		                    element = elements[idx];
		                    if (element instanceof Shape) {
		                        shapes.push(element);
		                    } else {
		                        connections.push(element);
		                    }
		                }
	
		                return {
		                    shapes: shapes,
		                    connections: connections,
		                    action: action,
		                    target: target
		                };
		            },
	
		            "delete": function() {
		                var diagram = this.diagram;
		                var toRemove = diagram._triggerRemove(this.selectedElements());
		                if (toRemove.length) {
		                    this.diagram.remove(toRemove, true);
		                    this.diagram._syncChanges();
		                }
		            },
	
		            edit: function() {
		                var selectedElemens = this.selectedElements();
		                if (selectedElemens.length === 1) {
		                    this.diagram.edit(selectedElemens[0]);
		                }
		            },
	
		            rotateClockwise: function(options) {
		                var angle = parseFloat(options.step || 90);
		                this._rotate(angle);
		            },
	
		            rotateAnticlockwise: function(options) {
		                var angle = parseFloat(options.step || 90);
		                this._rotate(-angle);
		            },
	
		            _rotate: function(angle) {
		                var adorner = this.diagram._resizingAdorner;
		                adorner.angle(adorner.angle() + angle);
		                adorner.rotate();
		            },
	
		            selectedElements: function() {
		                return this.diagram.select();
		            },
	
		            createShape: function() {
		                this.diagram.createShape();
		            },
	
		            createConnection: function() {
		                this.diagram.createConnection();
		            },
	
		            undo: function() {
		                this.diagram.undo();
		            },
	
		            redo: function() {
		                this.diagram.redo();
		            },
	
		            destroy: function() {
		                this.diagram = null;
		                this.element = null;
		                this.options = null;
	
		                if (this._toolBar) {
		                    this._toolBar.destroy();
		                }
	
		                if (this._popup) {
		                    this._popup.destroy();
		                }
		            }
		        });
	
		        var Editor = kendo.Observable.extend({
		            init: function(element, options) {
		                kendo.Observable.fn.init.call(this);
	
		                this.options = extend(true, {}, this.options, options);
		                this.element = element;
		                this.model = this.options.model;
		                this.fields = this._getFields();
		                this._initContainer();
		                this.createEditable();
		            },
	
		            options: {
		                editors: {}
		            },
	
		            _initContainer: function() {
		                this.wrapper = this.element;
		            },
	
		            createEditable: function() {
		                var options = this.options;
	
		                this.editable = new kendo.ui.Editable(this.wrapper, {
		                    fields: this.fields,
		                    target: options.target,
		                    clearContainer: false,
		                    model: this.model
		                });
		            },
	
		            _isEditable: function(field) {
		                return this.model.editable && this.model.editable(field);
		            },
	
		            _getFields: function() {
		                var fields = [];
		                var modelFields = this.model.fields;
	
		                for (var field in modelFields) {
		                    var result = {};
		                    if (this._isEditable(field)) {
		                        var editor = this.options.editors[field];
		                        if (editor) {
		                            result.editor = editor;
		                        }
		                        result.field = field;
		                        fields.push(result);
		                    }
		                }
	
		                return fields;
		            },
	
		            end: function() {
		                return this.editable.end();
		            },
	
		            destroy: function() {
		                this.editable.destroy();
		                this.editable.element.find("[" + kendo.attr("container-for") + "]").empty();
		                this.model = this.wrapper = this.element = this.columns = this.editable = null;
		            }
		        });
	
		        var PopupEditor = Editor.extend({
		            init: function(element, options) {
		                Editor.fn.init.call(this, element, options);
		                this.bind(this.events, this.options);
	
		                this.open();
		            },
	
		            events: [ "update", "cancel" ],
	
		            options: {
		                window: {
		                    modal: true,
		                    resizable: false,
		                    draggable: true,
		                    title: "Edit",
		                    visible: false
		                }
		            },
	
		            _initContainer: function() {
		                var that = this;
		                this.wrapper = $('<div class="k-popup-edit-form"/>')
		                    .attr(kendo.attr("uid"), this.model.uid);
	
		                var formContent = "";
	
		                if (this.options.template) {
		                    formContent += this._renderTemplate();
		                    this.fields = [];
		                } else {
		                    formContent += this._renderFields();
		                }
	
		                formContent += this._renderButtons();
	
		                this.wrapper.append(
		                    $('<div class="k-edit-form-container"/>').append(formContent));
	
		                this.window = new kendo.ui.Window(this.wrapper.appendTo(this.element), this.options.window);
		                this.window.bind("close", function(e) {
		                    //The bellow line is required due to: draggable window in IE, change event will be triggered while the window is closing
		                    if (e.userTriggered) {
		                        e.sender.element.focus();
		                        that._cancelClick(e);
		                    }
		                });
	
		                this._attachButtonEvents();
		            },
	
		            _renderTemplate: function() {
		                var template = this.options.template;
	
		                if (typeof template === "string") {
		                    template = window.unescape(template);
		                }
	
		                template = kendo.template(template)(this.model);
	
		                return template;
		            },
	
		            _renderFields: function() {
		                var form = "";
		                for (var i = 0; i < this.fields.length; i++) {
		                    var field = this.fields[i];
	
		                    form += '<div class="k-edit-label"><label for="' + field.field + '">' + (field.field || "") + '</label></div>';
	
		                    if (this._isEditable(field.field)) {
		                        form += '<div ' + kendo.attr("container-for") + '="' + field.field +
		                        '" class="k-edit-field"></div>';
		                    }
		                }
	
		                return form;
		            },
	
		            _renderButtons: function() {
		                var form = '<div class="k-edit-buttons k-state-default">';
		                form += this._createButton("update");
		                form += this._createButton("cancel");
		                form += '</div>';
		                return form;
		            },
	
		            _createButton: function(name) {
		                return kendo.template(BUTTON_TEMPLATE)(defaultButtons[name]);
		            },
	
		            _attachButtonEvents: function() {
		                this._cancelClickHandler = proxy(this._cancelClick, this);
		                this.window.element.on(CLICK + NS, "a.k-diagram-cancel", this._cancelClickHandler);
	
		                this._updateClickHandler = proxy(this._updateClick, this);
		                this.window.element.on(CLICK + NS, "a.k-diagram-update", this._updateClickHandler);
		            },
	
		            _updateClick: function(e) {
		                e.preventDefault();
		                this.trigger("update");
		            },
	
		            _cancelClick: function (e) {
		                e.preventDefault();
		                this.trigger("cancel");
		            },
	
		            open: function() {
		                this.window.center().open();
		            },
	
		            close: function() {
		                this.window.bind("deactivate", proxy(this.destroy, this)).close();
		            },
	
		            destroy: function() {
		                this.window.close().destroy();
		                this.window.element.off(CLICK + NS, "a.k-diagram-cancel", this._cancelClickHandler);
		                this.window.element.off(CLICK + NS, "a.k-diagram-update", this._updateClickHandler);
		                this._cancelClickHandler = null;
		                this._editUpdateClickHandler = null;
		                this.window = null;
		                Editor.fn.destroy.call(this);
		            }
		        });
	
		        function connectionSelector(container, options) {
		            var model = this.dataSource.reader.model;
		            if (model) {
		                var textField = model.fn.fields.text ? "text": model.idField;
		                $("<input name='" + options.field + "' />")
		                    .appendTo(container).kendoDropDownList({
		                        dataValueField: model.idField,
		                        dataTextField: textField,
		                        dataSource: this.dataSource.data().toJSON(),
		                        optionLabel: " ",
		                        valuePrimitive: true
		                    });
		            }
		        }
	
		        function InactiveItem(dataItem) {
		            this.dataItem = dataItem;
		            this.callbacks = [];
		        }
	
		        InactiveItem.fn = InactiveItem.prototype = {
		            onActivate: function(callback) {
		                var deffered = $.Deferred();
		                this.callbacks.push({
		                    callback: callback,
		                    deferred: deffered
		                });
		                return deffered;
		            },
	
		            activate: function() {
		                var callbacks = this.callbacks;
		                var item;
		                for (var idx = 0; idx < callbacks.length; idx++) {
		                    item = this.callbacks[idx];
		                    item.callback(this.dataItem);
		                    item.deferred.resolve();
		                }
		                this.callbacks = [];
		            }
		        };
	
		        function InactiveItemsCollection() {
		            this.items = {};
		        }
	
		        InactiveItemsCollection.fn = InactiveItemsCollection.prototype = {
		            add: function(items) {
		                for(var idx = 0; idx < items.length; idx++) {
		                    this.items[items[idx].uid] = new InactiveItem(items[idx]);
		                }
		            },
	
		            forEach: function(callback){
		                for (var uid in this.items) {
		                    callback(this.items[uid]);
		                }
		            },
	
		            getByUid: function(uid) {
		                return this.items[uid];
		            },
	
		            remove: function(item) {
		                delete this.items[item.uid];
		            }
		        };
	
		        var QuadRoot = Class.extend({
		            init: function() {
		                this.shapes = [];
		            },
	
		            _add: function(shape, bounds) {
		                this.shapes.push({
		                    bounds: bounds,
		                    shape: shape
		                });
		                shape._quadNode = this;
		            },
	
		            insert: function(shape, bounds) {
		                this._add(shape, bounds);
		            },
	
		            remove: function(shape) {
		                var shapes = this.shapes;
		                var length = shapes.length;
	
		                for (var idx = 0; idx < length; idx++) {
		                    if (shapes[idx].shape === shape) {
		                        shapes.splice(idx, 1);
		                        break;
		                    }
		                }
		            },
	
		            hitTestRect: function(rect, exclude) {
		                var shapes = this.shapes;
		                var length = shapes.length;
	
		                for (var i = 0; i < length; i++) {
		                    if (this._testRect(shapes[i].shape, rect) && !dataviz.inArray(shapes[i].shape, exclude)) {
		                        return true;
		                    }
		                }
		            },
	
		            _testRect: function(shape, rect) {
		                var angle = shape.rotate().angle;
		                var bounds = shape.bounds();
		                var hit;
		                if (!angle) {
		                    hit = bounds.overlaps(rect);
		                } else {
		                    hit = Intersect.rects(rect, bounds, -angle);
		                }
		                return hit;
		            }
		        });
	
		        var QuadNode = QuadRoot.extend({
		            init: function(rect) {
		                QuadRoot.fn.init.call(this);
		                this.children = [];
		                this.rect = rect;
		            },
	
		            inBounds: function(rect) {
		                var nodeRect = this.rect;
		                var nodeBottomRight = nodeRect.bottomRight();
		                var bottomRight = rect.bottomRight();
		                var inBounds = nodeRect.x <= rect.x && nodeRect.y <= rect.y && bottomRight.x <= nodeBottomRight.x &&
		                    bottomRight.y <= nodeBottomRight.y;
		                return inBounds;
		            },
	
		            overlapsBounds: function(rect) {
		                return this.rect.overlaps(rect);
		            },
	
		            insert: function (shape, bounds) {
		                var inserted = false;
		                var children = this.children;
		                var length = children.length;
		                if (this.inBounds(bounds)) {
		                    if (!length && this.shapes.length < 4) {
		                        this._add(shape, bounds);
		                    } else {
		                        if (!length) {
		                            this._initChildren();
		                        }
	
		                        for (var idx = 0; idx < children.length; idx++) {
		                            if (children[idx].insert(shape, bounds)) {
		                                inserted = true;
		                                break;
		                            }
		                        }
	
		                        if (!inserted) {
		                            this._add(shape, bounds);
		                        }
		                    }
		                    inserted = true;
		                }
	
		                return inserted;
		            },
	
		            _initChildren: function() {
		                var rect = this.rect,
		                    children = this.children,
		                    shapes = this.shapes,
		                    center = rect.center(),
		                    halfWidth = rect.width / 2,
		                    halfHeight = rect.height / 2,
		                    childIdx, shapeIdx;
	
		                children.push(
		                    new QuadNode(new Rect(rect.x, rect.y, halfWidth, halfHeight)),
		                    new QuadNode(new Rect(center.x, rect.y, halfWidth, halfHeight)),
		                    new QuadNode(new Rect(rect.x, center.y, halfWidth, halfHeight)),
		                    new QuadNode(new Rect(center.x, center.y, halfWidth, halfHeight))
		                );
		                for (shapeIdx = shapes.length - 1; shapeIdx >= 0; shapeIdx--) {
		                    for (childIdx = 0; childIdx < children.length; childIdx++) {
		                        if (children[childIdx].insert(shapes[shapeIdx].shape, shapes[shapeIdx].bounds)) {
		                            shapes.splice(shapeIdx, 1);
		                            break;
		                        }
		                    }
		                }
		            },
	
		            hitTestRect: function(rect, exclude) {
		                var idx;
		                var children = this.children;
		                var length = children.length;
		                var hit = false;
	
		                if (this.overlapsBounds(rect)) {
		                    if (QuadRoot.fn.hitTestRect.call(this, rect, exclude)) {
		                        hit = true;
		                    } else {
		                         for (idx = 0; idx < length; idx++) {
		                            if (children[idx].hitTestRect(rect, exclude)) {
		                               hit = true;
		                               break;
		                            }
		                        }
		                    }
		                }
	
		                return hit;
		            }
		        });
	
		        var ShapesQuadTree = Class.extend({
		            ROOT_SIZE: 1000,
	
		            init: function(diagram) {
		                var boundsChangeHandler = proxy(this._boundsChange, this);
		                diagram.bind(ITEMBOUNDSCHANGE, boundsChangeHandler);
		                diagram.bind(ITEMROTATE, boundsChangeHandler);
		                this.initRoots();
		            },
	
		            initRoots: function() {
		                this.rootMap = {};
		                this.root = new QuadRoot();
		            },
	
		            clear: function() {
		                this.initRoots();
		            },
	
		            _boundsChange: function(e) {
		                if (e.item._quadNode) {
		                    e.item._quadNode.remove(e.item);
		                }
		                this.insert(e.item);
		            },
	
		            insert: function(shape) {
		                var bounds = shape.bounds(ROTATED);
		                var rootSize = this.ROOT_SIZE;
		                var sectors = this.getSectors(bounds);
		                var x = sectors[0][0];
		                var y = sectors[1][0];
	
		                if (this.inRoot(sectors)) {
		                    this.root.insert(shape, bounds);
		                } else {
		                    if (!this.rootMap[x]) {
		                        this.rootMap[x] = {};
		                    }
	
		                    if (!this.rootMap[x][y]) {
		                        this.rootMap[x][y] = new QuadNode(
		                            new Rect(x * rootSize, y * rootSize, rootSize, rootSize)
		                        );
		                    }
	
		                    this.rootMap[x][y].insert(shape, bounds);
		                }
		            },
	
		            remove: function(shape) {
		                if (shape._quadNode) {
		                    shape._quadNode.remove(shape);
		                }
		            },
	
		            inRoot: function(sectors) {
		                return sectors[0].length > 1 || sectors[1].length > 1;
		            },
	
		            getSectors: function(rect) {
		                var rootSize = this.ROOT_SIZE;
		                var bottomRight = rect.bottomRight();
		                var bottomX = math.floor(bottomRight.x / rootSize);
		                var bottomY = math.floor(bottomRight.y / rootSize);
		                var sectors = [[],[]];
		                for (var x = math.floor(rect.x / rootSize); x <= bottomX; x++) {
		                    sectors[0].push(x);
		                }
		                for (var y = math.floor(rect.y / rootSize); y <= bottomY; y++) {
		                    sectors[1].push(y);
		                }
		                return sectors;
		            },
	
		            hitTestRect: function(rect, exclude) {
		                var sectors = this.getSectors(rect);
		                var xIdx, yIdx, x, y;
		                var root;
	
		                if (this.root.hitTestRect(rect, exclude)) {
		                    return true;
		                }
	
		                for (xIdx = 0; xIdx < sectors[0].length; xIdx++) {
		                    x = sectors[0][xIdx];
		                    for (yIdx = 0; yIdx < sectors[1].length; yIdx++) {
		                        y = sectors[1][yIdx];
		                        root = (this.rootMap[x] || {})[y];
		                        if (root && root.hitTestRect(rect, exclude)) {
		                            return true;
		                        }
		                    }
		                }
	
		                return false;
		            }
		        });
	
		        function cloneDataItem(dataItem) {
		            var result = dataItem;
		            if (dataItem instanceof kendo.data.Model) {
		                result = dataItem.toJSON();
		                result[dataItem.idField] = dataItem._defaultId;
		            }
		            return result;
		        }
	
		        function splitDiagramElements(elements) {
		            var connections = [];
		            var shapes = [];
		            var element, idx;
		            for (idx = 0; idx < elements.length; idx++) {
		                element = elements[idx];
		                if (element instanceof Shape) {
		                    shapes.push(element);
		                } else {
		                    connections.push(element);
		                }
		            }
		            return {
		                shapes: shapes,
		                connections: connections
		            };
		        }
	
		        function createModel(dataSource, model) {
		            if (dataSource.reader.model) {
		                return new dataSource.reader.model(model);
		            }
	
		            return new kendo.data.ObservableObject(model);
		        }
	
		        function clearField(field, model) {
		            if (defined(model[field])) {
		                model.set(field, null);
		            }
		        }
	
		        function copyDefaultOptions(mainOptions, elementOptions, fields) {
		            var field;
		            for (var idx = 0; idx < fields.length; idx++) {
		                field = fields[idx];
		                if (elementOptions && !defined(elementOptions[field])) {
		                    elementOptions[field] = mainOptions[field];
		                }
		            }
		        }
	
		        function translateToOrigin(visual) {
		            var bbox = visual.drawingContainer().clippedBBox(null);
		            if (bbox.origin.x !== 0 || bbox.origin.y !== 0) {
		                visual.position(-bbox.origin.x, -bbox.origin.y);
		            }
		        }
	
		        function preventDefault(e) {
		            e.preventDefault();
		        }
	
		        dataviz.ui.plugin(Diagram);
	
		        deepExtend(diagram, {
		            Shape: Shape,
		            Connection: Connection,
		            Connector: Connector,
		            DiagramToolBar: DiagramToolBar,
		            QuadNode: QuadNode,
		            QuadRoot: QuadRoot,
		            ShapesQuadTree: ShapesQuadTree,
		            PopupEditor: PopupEditor
		        });
		})(window.kendo.jQuery);
	
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 868:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(571);
	
	/***/ }),
	
	/***/ 869:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 870:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(634);
	
	/***/ }),
	
	/***/ 871:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(599);
	
	/***/ }),
	
	/***/ 872:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(594);
	
	/***/ }),
	
	/***/ 873:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(779);
	
	/***/ }),
	
	/***/ 874:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(780);
	
	/***/ }),
	
	/***/ 875:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(781);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1113);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1061:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(745);
	
	/***/ }),
	
	/***/ 1113:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013), __webpack_require__(1038), __webpack_require__(1061) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "dataviz.treeMap",
		    name: "TreeMap",
		    category: "dataviz",
		    description: "The Kendo DataViz TreeMap",
		    depends: [ "data", "userevents", "dataviz.themes" ]
		};
	
		(function($, undefined) {
		    var math = Math,
	
		        proxy = $.proxy,
		        isArray = $.isArray,
	
		        kendo = window.kendo,
		        outerHeight = kendo._outerHeight,
		        outerWidth = kendo._outerWidth,
		        Class = kendo.Class,
		        Widget = kendo.ui.Widget,
		        template = kendo.template,
		        deepExtend = kendo.deepExtend,
		        HierarchicalDataSource = kendo.data.HierarchicalDataSource,
		        getter = kendo.getter,
	
		        dataviz = kendo.dataviz;
	
		    var NS = ".kendoTreeMap",
		        CHANGE = "change",
		        DATA_BOUND = "dataBound",
		        ITEM_CREATED = "itemCreated",
		        MAX_VALUE = Number.MAX_VALUE,
		        MOUSEOVER_NS = "mouseover" + NS,
		        MOUSELEAVE_NS = "mouseleave" + NS,
		        UNDEFINED = "undefined";
	
		    var TreeMap = Widget.extend({
		        init: function(element, options) {
		            kendo.destroy(element);
		            $(element).empty();
	
		            Widget.fn.init.call(this, element, options);
		            this.wrapper = this.element;
	
		            this._initTheme(this.options);
	
		            this.element.addClass("k-widget k-treemap");
	
		            this._setLayout();
	
		            this._originalOptions = deepExtend({}, this.options);
	
		            this._initDataSource();
	
		            this._attachEvents();
	
		            kendo.notify(this, dataviz.ui);
		        },
	
		        options: {
		            name: "TreeMap",
		            theme: "default",
		            autoBind: true,
		            textField: "text",
		            valueField: "value",
		            colorField: "color"
		        },
	
		        events: [DATA_BOUND, ITEM_CREATED],
	
		        _initTheme: function(options) {
		            var that = this,
		                themes = dataviz.ui.themes || {},
		                themeName = ((options || {}).theme || "").toLowerCase(),
		                themeOptions = (themes[themeName] || {}).treeMap;
	
		            that.options = deepExtend({}, themeOptions, options);
		        },
	
		        _attachEvents: function() {
		            this.element
		                .on(MOUSEOVER_NS, proxy(this._mouseover, this))
		                .on(MOUSELEAVE_NS, proxy(this._mouseleave, this));
	
		            this._resizeHandler = proxy(this.resize, this, false);
		            kendo.onResize(this._resizeHandler);
		        },
	
		        _setLayout: function() {
		            if (this.options.type === "horizontal") {
		                this._layout = new SliceAndDice(false);
		                this._view = new SliceAndDiceView(this, this.options);
		            } else if (this.options.type === "vertical") {
		                this._layout = new SliceAndDice(true);
		                this._view = new SliceAndDiceView(this, this.options);
		            } else {
		                this._layout = new Squarified();
		                this._view = new SquarifiedView(this, this.options);
		            }
		        },
	
		        _initDataSource: function() {
		            var that = this,
		                options = that.options,
		                dataSource = options.dataSource;
	
		            that._dataChangeHandler = proxy(that._onDataChange, that);
	
		            that.dataSource = HierarchicalDataSource
		                .create(dataSource)
		                .bind(CHANGE, that._dataChangeHandler);
	
		            if (dataSource) {
		                if (that.options.autoBind) {
		                    that.dataSource.fetch();
		                }
		            }
		        },
	
		        setDataSource: function(dataSource) {
		            var that = this;
		            that.dataSource.unbind(CHANGE, that._dataChangeHandler);
		            that.dataSource = dataSource
		                    .bind(CHANGE, that._dataChangeHandler);
	
		            if (dataSource) {
		                if (that.options.autoBind) {
		                    that.dataSource.fetch();
		                }
		            }
		        },
	
		        _onDataChange: function(e) {
		            var node = e.node;
		            var items = e.items;
		            var options = this.options;
		            var item, i;
	
		            if (!node) {
		                this._cleanItems();
		                this.element.empty();
		                item = this._wrapItem(items[0]);
		                this._layout.createRoot(
		                    item,
		                    outerWidth(this.element),
		                    outerHeight(this.element),
		                    this.options.type === "vertical"
		                );
		                this._view.createRoot(item);
		                // Reference of the root
		                this._root = item;
		                this._colorIdx = 0;
		            } else {
		                if (items.length) {
		                    var root = this._getByUid(node.uid);
		                    root.children = [];
		                    items = new kendo.data.Query(items)._sortForGrouping(options.valueField, "desc");
	
		                    for (i = 0; i < items.length; i++) {
		                        item = items[i];
		                        root.children.push(this._wrapItem(item));
		                    }
	
		                    var htmlSize = this._view.htmlSize(root);
		                    this._layout.compute(root.children, root.coord, htmlSize);
	
		                    this._setColors(root.children);
		                    this._view.render(root);
		                }
		            }
	
		            for (i = 0; i < items.length; i++) {
		                items[i].load();
		            }
	
		            if (node) {
		                this.trigger(DATA_BOUND, {
		                    node: node
		                });
		            }
		        },
	
		        _cleanItems: function() {
		            var that = this;
		            that.angular("cleanup", function() {
		               return { elements: that.element.find(".k-leaf div,.k-treemap-title,.k-treemap-title-vertical") };
		            });
		        },
	
		        _setColors: function(items) {
		            var colors = this.options.colors;
		            var colorIdx = this._colorIdx;
		            var color = colors[colorIdx % colors.length];
		            var colorRange, item;
		            if (isArray(color)) {
		                colorRange = colorsByLength(color[0], color[1], items.length);
		            }
	
		            var leafNodes = false;
		            for (var i = 0; i < items.length; i++) {
		                item = items[i];
	
		                if (!defined(item.color)) {
		                    if (colorRange) {
		                        item.color = colorRange[i];
		                    } else {
		                        item.color = color;
		                    }
		                }
		                if (!item.dataItem.hasChildren) {
		                    leafNodes = true;
		                }
		            }
	
		            if (leafNodes) {
		                this._colorIdx++;
		            }
		        },
	
		        _contentSize: function(root) {
		            this.view.renderHeight(root);
		        },
	
		        _wrapItem: function(item) {
		            var wrap = {};
	
		            if (defined(this.options.valueField)) {
		                wrap.value = getField(this.options.valueField, item);
		            }
	
		            if (defined(this.options.colorField)) {
		                wrap.color = getField(this.options.colorField, item);
		            }
	
		            if (defined(this.options.textField)) {
		                wrap.text = getField(this.options.textField, item);
		            }
	
		            wrap.level = item.level();
	
		            wrap.dataItem = item;
	
		            return wrap;
		        },
	
		        _getByUid: function(uid) {
		            var items = [this._root];
		            var item;
	
		            while (items.length) {
		                item = items.pop();
		                if (item.dataItem.uid === uid) {
		                    return item;
		                }
	
		                if (item.children) {
		                    items = items.concat(item.children);
		                }
		            }
		        },
	
		        dataItem: function(node) {
		            var uid = $(node).attr(kendo.attr("uid")),
		                dataSource = this.dataSource;
	
		            return dataSource && dataSource.getByUid(uid);
		        },
	
		        findByUid: function(uid) {
		            return this.element.find(".k-treemap-tile[" + kendo.attr("uid") + "='" + uid + "']");
		        },
	
		        _mouseover: function(e) {
		            var target = $(e.target);
		            if (target.hasClass("k-leaf")) {
		                this._removeActiveState();
		                target
		                    .removeClass("k-state-hover")
		                    .addClass("k-state-hover");
		            }
		        },
	
		        _removeActiveState: function() {
		            this.element
		                .find(".k-state-hover")
		                .removeClass("k-state-hover");
		        },
	
		        _mouseleave: function() {
		            this._removeActiveState();
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.element.off(NS);
	
		            if (this.dataSource) {
		                this.dataSource.unbind(CHANGE, this._dataChangeHandler);
		            }
	
		            this._root = null;
		            kendo.unbindResize(this._resizeHandler);
	
		            kendo.destroy(this.element);
		        },
	
		        items: function() {
		            return $();
		        },
	
		        getSize: function() {
		            return kendo.dimensions(this.element);
		        },
	
		        _resize: function() {
		            var root = this._root;
		            if (root) {
		                var element = this.element;
		                var rootElement = element.children();
		                root.coord.width = outerWidth(element);
		                root.coord.height = outerHeight(element);
	
		                rootElement.css({
		                    width: root.coord.width,
		                    height: root.coord.height
		                });
	
		                this._resizeItems(root, rootElement);
		            }
		        },
	
		        _resizeItems: function(root, element) {
		            if (root.children && root.children.length) {
		                var elements = element.children(".k-treemap-wrap").children();
		                var child, childElement;
	
		                this._layout.compute(root.children, root.coord, {text: this._view.titleSize(root, element)});
		                for (var idx = 0; idx < root.children.length; idx++) {
		                    child = root.children[idx];
		                    childElement = elements.filter("[" + kendo.attr("uid") + "='" + child.dataItem.uid + "']");
		                    this._view.setItemSize(child, childElement);
		                    this._resizeItems(child, childElement);
		                }
		            }
		        },
	
		        setOptions: function(options) {
		            var dataSource = options.dataSource;
	
		            options.dataSource = undefined;
		            this._originalOptions = deepExtend(this._originalOptions, options);
		            this.options = deepExtend({}, this._originalOptions);
		            this._setLayout();
		            this._initTheme(this.options);
	
		            Widget.fn._setEvents.call(this, options);
	
		            if (dataSource) {
		                this.setDataSource(HierarchicalDataSource.create(dataSource));
		            }
	
		            if (this.options.autoBind) {
		                this.dataSource.fetch();
		            }
		        }
		    });
	
		    var Squarified = Class.extend({
		        createRoot: function(root, width, height) {
		            root.coord = {
		                width: width,
		                height: height,
		                top: 0,
		                left: 0
		            };
		        },
	
		        leaf: function(tree) {
		            return !tree.children;
		        },
	
		        layoutChildren: function(items, coord) {
		            var parentArea = coord.width * coord.height;
		            var totalArea = 0,
		                itemsArea = [],
		                i;
	
		            for (i = 0; i < items.length; i++) {
		                itemsArea[i] = parseFloat(items[i].value);
		                totalArea += itemsArea[i];
		            }
	
		            for (i = 0; i < itemsArea.length; i++) {
		                items[i].area = parentArea * itemsArea[i] / totalArea;
		            }
	
		            var minimumSideValue = this.layoutHorizontal() ? coord.height : coord.width;
	
		            var firstElement = [items[0]];
		            var tail = items.slice(1);
		            this.squarify(tail, firstElement, minimumSideValue, coord);
		        },
	
		        squarify: function(tail, initElement, width, coord) {
		            this.computeDim(tail, initElement, width, coord);
		        },
	
		        computeDim: function(tail, initElement, width, coord) {
		            if (tail.length + initElement.length == 1) {
		                var element = tail.length == 1 ? tail : initElement;
		                this.layoutLast(element, width, coord);
		                return;
		            }
	
		            if (tail.length >= 2 && initElement.length === 0) {
		                initElement = [tail[0]];
		                tail = tail.slice(1);
		            }
	
		            if (tail.length === 0) {
		                if (initElement.length > 0) {
		                    this.layoutRow(initElement, width, coord);
		                }
		                return;
		            }
	
		            var firstElement = tail[0];
	
		            if (this.worstAspectRatio(initElement, width) >= this.worstAspectRatio([firstElement].concat(initElement), width)) {
		                this.computeDim(tail.slice(1), initElement.concat([firstElement]), width, coord);
		            } else {
		                var newCoords = this.layoutRow(initElement, width, coord);
		                this.computeDim(tail, [], newCoords.dim, newCoords);
		            }
		        },
	
		        layoutLast: function(items, w, coord) {
		            items[0].coord = coord;
		        },
	
		        layoutRow: function(items, width, coord) {
		            if (this.layoutHorizontal()) {
		                return this.layoutV(items, width, coord);
		            } else {
		                return this.layoutH(items, width, coord);
		            }
		        },
	
		        orientation: "h",
	
		        layoutVertical: function() {
		            return this.orientation === "v";
		        },
	
		        layoutHorizontal: function() {
		            return this.orientation === "h";
		        },
	
		        layoutChange: function() {
		            this.orientation = this.layoutVertical() ? "h" : "v";
		        },
	
		        worstAspectRatio: function(items, width) {
		            if (!items || items.length === 0) {
		                return MAX_VALUE;
		            }
	
		            var areaSum = 0,
		                maxArea = 0,
		                minArea = MAX_VALUE;
	
		            for (var i = 0; i < items.length; i++) {
		                var area = items[i].area;
		                areaSum += area;
		                minArea = (minArea < area) ? minArea : area;
		                maxArea = (maxArea > area) ? maxArea : area;
		            }
	
		            return math.max(
		                (width * width * maxArea) / (areaSum * areaSum),
		                (areaSum * areaSum) / (width * width * minArea)
		            );
		        },
	
		        compute: function(children, rootCoord, htmlSize) {
		            if (!(rootCoord.width >= rootCoord.height && this.layoutHorizontal())) {
		                this.layoutChange();
		            }
	
		            if (children && children.length > 0) {
		                var newRootCoord = {
		                    width: rootCoord.width,
		                    height: rootCoord.height - htmlSize.text,
		                    top: 0,
		                    left: 0
		                };
	
		                this.layoutChildren(children, newRootCoord);
		            }
		        },
	
		        layoutV: function(items, width, coord) {
		            var totalArea = this._totalArea(items),
		                top =  0;
	
		            width = round(totalArea / width);
	
		            for (var i = 0; i < items.length; i++) {
		                var height = round(items[i].area / width);
		                items[i].coord = {
		                    height: height,
		                    width: width,
		                    top: coord.top + top,
		                    left: coord.left
		                };
	
		                top += height;
		            }
	
		            var ans = {
		                height: coord.height,
		                width: coord.width - width,
		                top: coord.top,
		                left: coord.left + width
		            };
	
		            ans.dim = math.min(ans.width, ans.height);
	
		            if (ans.dim != ans.height) {
		                this.layoutChange();
		            }
	
		            return ans;
		        },
	
		        layoutH: function(items, width, coord) {
		            var totalArea = this._totalArea(items);
	
		            var height = round(totalArea / width),
		                top = coord.top,
		                left = 0;
	
		            for (var i=0; i<items.length; i++) {
		                items[i].coord = {
		                    height: height,
		                    width: round(items[i].area / height),
		                    top: top,
		                    left: coord.left + left
		                };
		                left += items[i].coord.width;
		            }
	
		            var ans = {
		                height: coord.height - height,
		                width: coord.width,
		                top: coord.top + height,
		                left: coord.left
		            };
	
		            ans.dim = math.min(ans.width, ans.height);
	
		            if (ans.dim != ans.width) {
		                this.layoutChange();
		            }
	
		            return ans;
		        },
	
		        _totalArea: function(items) {
		            var total = 0;
	
		            for (var i = 0; i < items.length; i++) {
		                total += items[i].area;
		            }
	
		            return total;
		        }
		    });
	
		    var SquarifiedView = Class.extend({
		        init: function(treeMap, options) {
		            this.options = deepExtend({}, this.options, options);
		            this.treeMap = treeMap;
		            this.element = $(treeMap.element);
	
		            this.offset = 0;
		        },
	
		        titleSize: function(item, element) {
		            var text = element.children(".k-treemap-title");
		            return text.height() || 0;
		        },
	
		        htmlSize: function(root) {
		            var rootElement = this._getByUid(root.dataItem.uid);
		            var htmlSize = {
		                text: 0
		            };
	
		            if (root.children) {
		                this._clean(rootElement);
	
		                var text = this._getText(root);
		                if (text) {
		                    var title = this._createTitle(root);
		                    rootElement.append(title);
	
		                    this._compile(title, root.dataItem);
	
		                    htmlSize.text = title.height();
		                }
	
		                rootElement.append(this._createWrap());
	
		                this.offset = (outerWidth(rootElement) - rootElement.innerWidth()) / 2;
		            }
	
		            return htmlSize;
		        },
	
		        _compile: function(element, dataItem) {
		            this.treeMap.angular("compile", function(){
		                return {
		                    elements: element,
		                    data: [ { dataItem: dataItem } ]
		                };
		            });
		        },
	
		        _getByUid: function(uid) {
		            return this.element.find(".k-treemap-tile[" + kendo.attr("uid") + "='" + uid + "']");
		        },
	
		        render: function(root) {
		            var rootElement = this._getByUid(root.dataItem.uid);
		            var children = root.children;
		            if (children) {
		                var rootWrap = rootElement.find(".k-treemap-wrap");
	
		                for (var i = 0; i < children.length; i++) {
		                    var leaf = children[i];
		                    var htmlElement = this._createLeaf(leaf);
		                    rootWrap.append(htmlElement);
	
		                    this._compile(htmlElement.children(), leaf.dataItem);
	
		                    this.treeMap.trigger(ITEM_CREATED, {
		                        element: htmlElement
		                    });
		                }
		            }
		        },
	
		        createRoot: function(root) {
		            var htmlElement = this._createLeaf(root);
		            this.element.append(htmlElement);
		            this._compile(htmlElement.children(), root.dataItem);
	
		            this.treeMap.trigger(ITEM_CREATED, {
		                element: htmlElement
		            });
		        },
	
		        _clean: function(root) {
		            this.treeMap.angular("cleanup", function() {
		                return {
		                    elements: root.children(":not(.k-treemap-wrap)")
		                };
		            });
	
		            root.css("background-color", "");
		            root.removeClass("k-leaf");
		            root.removeClass("k-inverse");
		            root.empty();
		        },
	
		        _createLeaf: function(item) {
		            return this._createTile(item)
		                    .css("background-color", item.color)
		                    .addClass("k-leaf")
		                    .toggleClass(
		                        "k-inverse",
		                        this._tileColorBrightness(item) > 180
		                    )
		                    .toggle(item.value !== 0)
		                    .append($("<div></div>")
		                    .html(this._getText(item)));
		        },
	
		        _createTile: function(item) {
		            var tile = $("<div class='k-treemap-tile'></div>");
		            this.setItemSize(item, tile);
	
		            if (defined(item.dataItem) && defined(item.dataItem.uid)) {
		                tile.attr(kendo.attr("uid"), item.dataItem.uid);
		            }
	
		            return tile;
		        },
	
		        _itemCoordinates: function(item) {
		            var coordinates = {
		                width: item.coord.width,
		                height: item.coord.height,
		                left: item.coord.left,
		                top: item.coord.top
		            };
	
		            if (coordinates.left && this.offset) {
		                coordinates.width += this.offset * 2;
		            } else {
		                coordinates.width += this.offset;
		            }
	
		            if (coordinates.top) {
		                coordinates.height += this.offset * 2;
		            } else {
		                coordinates.height += this.offset;
		            }
	
		            return coordinates;
		        },
	
		        setItemSize: function(item, element) {
		            var coordinates = this._itemCoordinates(item);
		            element.css({
		                width: coordinates.width,
		                height: coordinates.height,
		                left: coordinates.left,
		                top: coordinates.top
		            });
		        },
	
		        _getText: function(item) {
		            var text = item.text;
	
		            if (this.options.template) {
		                text = this._renderTemplate(item);
		            }
	
		            return text;
		        },
	
		        _renderTemplate: function(item) {
		            var titleTemplate = template(this.options.template);
		            return titleTemplate({
		                dataItem: item.dataItem,
		                text: item.text
		            });
		        },
	
		        _createTitle: function(item) {
		            return $("<div class='k-treemap-title'></div>")
		                    .append($("<div></div>").html(this._getText(item)));
		        },
	
		        _createWrap: function() {
		            return $("<div class='k-treemap-wrap'></div>");
		        },
	
		        _tileColorBrightness: function(item) {
		            return colorBrightness(item.color);
		        }
		    });
	
		    var SliceAndDice = Class.extend({
		        createRoot: function(root, width, height, vertical) {
		            root.coord = {
		                width: width,
		                height: height,
		                top: 0,
		                left: 0
		            };
		            root.vertical = vertical;
		        },
	
		        init: function(vertical) {
		            this.vertical = vertical;
		            this.quotient = vertical ? 1 : 0;
		        },
	
		        compute: function(children, rootCoord, htmlSize) {
	
		            if (children.length > 0) {
		                var width = rootCoord.width;
		                var height = rootCoord.height;
	
		                if (this.vertical) {
		                    height -= htmlSize.text;
		                } else {
		                    width -= htmlSize.text;
		                }
	
		                var newRootCoord = {
		                    width: width,
		                    height: height,
		                    top: 0,
		                    left: 0
		                };
	
		                this.layoutChildren(children, newRootCoord);
		            }
		        },
	
		        layoutChildren: function(items, coord) {
		            var parentArea = coord.width * coord.height;
		            var totalArea = 0;
		            var itemsArea = [];
		            var i;
	
		            for (i = 0; i < items.length; i++) {
		                var item = items[i];
		                itemsArea[i] = parseFloat(items[i].value);
		                totalArea += itemsArea[i];
		                item.vertical = this.vertical;
		            }
	
		            for (i = 0; i < itemsArea.length; i++) {
		                items[i].area = parentArea * itemsArea[i] / totalArea;
		            }
	
		            this.sliceAndDice(items, coord);
		        },
	
		        sliceAndDice: function(items, coord) {
		            var totalArea = this._totalArea(items);
		            if (items[0].level % 2 === this.quotient) {
		                this.layoutHorizontal(items, coord, totalArea);
		            } else {
		                this.layoutVertical(items, coord, totalArea);
		            }
		        },
	
		        layoutHorizontal: function(items, coord, totalArea) {
		            var left = 0;
	
		            for (var i = 0; i < items.length; i++) {
		                var item = items[i];
		                var width = item.area / (totalArea / coord.width);
		                item.coord = {
		                    height: coord.height,
		                    width: width,
		                    top: coord.top,
		                    left: coord.left + left
		                };
	
		                left += width;
		            }
		        },
	
		        layoutVertical: function(items, coord, totalArea) {
		            var top = 0;
	
		            for (var i = 0; i < items.length; i++) {
		                var item = items[i];
		                var height = item.area / (totalArea / coord.height);
		                item.coord = {
		                    height: height,
		                    width: coord.width,
		                    top: coord.top + top,
		                    left: coord.left
		                };
	
		                top += height;
		            }
		        },
	
		        _totalArea: function(items) {
		            var total = 0;
	
		            for (var i = 0; i < items.length; i++) {
		                total += items[i].area;
		            }
	
		            return total;
		        }
		    });
	
		    var SliceAndDiceView = SquarifiedView.extend({
		        htmlSize: function(root) {
		            var rootElement = this._getByUid(root.dataItem.uid);
		            var htmlSize = {
		                text: 0,
		                offset: 0
		            };
	
		            if (root.children) {
		                this._clean(rootElement);
	
		                var text = this._getText(root);
		                if (text) {
		                    var title = this._createTitle(root);
		                    rootElement.append(title);
		                    this._compile(title, root.dataItem);
	
		                    if (root.vertical) {
		                        htmlSize.text = title.height();
		                    } else {
		                        htmlSize.text = title.width();
		                    }
		                }
	
		                rootElement.append(this._createWrap());
	
		                this.offset = (outerWidth(rootElement) - rootElement.innerWidth()) / 2;
		            }
	
		            return htmlSize;
		        },
	
		        titleSize: function(item, element) {
		            var size;
		            if (item.vertical) {
		               size = element.children(".k-treemap-title").height();
		            } else {
		               size = element.children(".k-treemap-title-vertical").width();
		            }
		            return size || 0;
		        },
	
		        _createTitle: function(item) {
		            var title;
		            if (item.vertical) {
		                title = $("<div class='k-treemap-title'></div>");
		            } else {
		                title = $("<div class='k-treemap-title-vertical'></div>");
		            }
	
		            return title.append($("<div></div>").html(this._getText(item)));
		        }
		    });
	
		    function getField(field, row) {
		        if (row === null) {
		            return row;
		        }
	
		        var get = getter(field, true);
		        return get(row);
		    }
	
		    function defined(value) {
		        return typeof value !== UNDEFINED;
		    }
	
		    function colorsByLength(min, max, length) {
		        var minRGBtoDecimal = rgbToDecimal(min);
		        var maxRGBtoDecimal = rgbToDecimal(max);
		        var isDarker = colorBrightness(min) - colorBrightness(max) < 0;
		        var colors = [];
	
		        colors.push(min);
	
		        for (var i = 0; i < length; i++) {
		            var rgbColor = {
		                r: colorByIndex(minRGBtoDecimal.r, maxRGBtoDecimal.r, i, length, isDarker),
		                g: colorByIndex(minRGBtoDecimal.g, maxRGBtoDecimal.g, i, length, isDarker),
		                b: colorByIndex(minRGBtoDecimal.b, maxRGBtoDecimal.b, i, length, isDarker)
		            };
		            colors.push(buildColorFromRGB(rgbColor));
		        }
	
		        colors.push(max);
	
		        return colors;
		    }
	
		    function colorByIndex(min, max, index, length, isDarker) {
		        var minColor = math.min(math.abs(min), math.abs(max));
		        var maxColor = math.max(math.abs(min), math.abs(max));
		        var step = (maxColor - minColor) / (length + 1);
		        var currentStep = step * (index + 1);
		        var color;
	
		        if (isDarker) {
		            color = minColor + currentStep;
		        } else {
		            color = maxColor - currentStep;
		        }
	
		        return color;
		    }
	
		    function buildColorFromRGB(color) {
		        return "#" + decimalToRgb(color.r) + decimalToRgb(color.g) + decimalToRgb(color.b);
		    }
	
		    function rgbToDecimal(color) {
		        color = color.replace("#", "");
		        var rgbColor = colorToRGB(color);
	
		        return {
		            r: rgbToHex(rgbColor.r),
		            g: rgbToHex(rgbColor.g),
		            b: rgbToHex(rgbColor.b)
		        };
		    }
	
		    function decimalToRgb(number) {
		        var result = math.round(number).toString(16).toUpperCase();
	
		        if (result.length === 1) {
		            result = "0" + result;
		        }
	
		        return result;
		    }
	
		    function colorToRGB(color) {
		        var colorLength = color.length;
		        var rgbColor = {};
		        if (colorLength === 3) {
		            rgbColor.r = color[0];
		            rgbColor.g = color[1];
		            rgbColor.b = color[2];
		        } else {
		            rgbColor.r = color.substring(0, 2);
		            rgbColor.g = color.substring(2, 4);
		            rgbColor.b = color.substring(4, 6);
		        }
	
		        return rgbColor;
		    }
	
		    function rgbToHex(rgb) {
		        return parseInt(rgb.toString(16), 16);
		    }
	
		    function colorBrightness(color) {
		        var brightness = 0;
		        if (color) {
		            color = rgbToDecimal(color);
		            brightness = math.sqrt(0.241 * color.r * color.r + 0.691 * color.g * color.g + 0.068 * color.b * color.b);
		        }
	
		        return brightness;
		    }
	
		    function round(value) {
		        var power = math.pow(10, 4);
		        return math.round(value * power) / power;
		    }
	
		    dataviz.ui.plugin(TreeMap);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1217);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1011:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(577);
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1022:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(566);
	
	/***/ }),
	
	/***/ 1036:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(557);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1047:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(564);
	
	/***/ }),
	
	/***/ 1048:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(565);
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1055:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(583);
	
	/***/ }),
	
	/***/ 1056:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(584);
	
	/***/ }),
	
	/***/ 1057:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(586);
	
	/***/ }),
	
	/***/ 1058:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(585);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1071:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(587);
	
	/***/ }),
	
	/***/ 1191:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(604);
	
	/***/ }),
	
	/***/ 1202:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(619);
	
	/***/ }),
	
	/***/ 1203:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(622);
	
	/***/ }),
	
	/***/ 1217:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		        __webpack_require__(1004),
		        __webpack_require__(1054),
		        __webpack_require__(1047),
		        __webpack_require__(1048),
		        __webpack_require__(1013),
		        __webpack_require__(1057),
		        __webpack_require__(1058),
		        __webpack_require__(1011),
		        __webpack_require__(1055),
		        __webpack_require__(1056),
		        __webpack_require__(1038),
		        __webpack_require__(1059),
		        __webpack_require__(1036),
		        __webpack_require__(1191),
		        __webpack_require__(1219),
		        __webpack_require__(1220),
		        __webpack_require__(1022),
		        __webpack_require__(1218),
		        __webpack_require__(1221),
		        __webpack_require__(1222),
		        __webpack_require__(1223),
		        __webpack_require__(1224),
		        __webpack_require__(1203),
		        __webpack_require__(1225),
		        __webpack_require__(1202),
		        __webpack_require__(1226),
		        __webpack_require__(1227),
		        __webpack_require__(1228),
		        __webpack_require__(1229),
		        __webpack_require__(1230),
		        __webpack_require__(1231),
		        __webpack_require__(1232),
		        __webpack_require__(1233),
		        __webpack_require__(1071)
		    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
		    "bundle all";
		    return window.kendo;
		}, __webpack_require__(3));
	
	
	/***/ }),
	
	/***/ 1218:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(620);
	
	/***/ }),
	
	/***/ 1219:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(621);
	
	/***/ }),
	
	/***/ 1220:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(623);
	
	/***/ }),
	
	/***/ 1221:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(624);
	
	/***/ }),
	
	/***/ 1222:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(785);
	
	/***/ }),
	
	/***/ 1223:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(786);
	
	/***/ }),
	
	/***/ 1224:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(787);
	
	/***/ }),
	
	/***/ 1225:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(788);
	
	/***/ }),
	
	/***/ 1226:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(789);
	
	/***/ }),
	
	/***/ 1227:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(790);
	
	/***/ }),
	
	/***/ 1228:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(791);
	
	/***/ }),
	
	/***/ 1229:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(792);
	
	/***/ }),
	
	/***/ 1230:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(793);
	
	/***/ }),
	
	/***/ 1231:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(794);
	
	/***/ }),
	
	/***/ 1232:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(795);
	
	/***/ }),
	
	/***/ 1233:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(796);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1242);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1218:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(620);
	
	/***/ }),
	
	/***/ 1221:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(624);
	
	/***/ }),
	
	/***/ 1242:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1218), __webpack_require__(1221) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.modalview",
		    name: "ModalView",
		    category: "mobile",
		    description: "The Kendo ModalView is used to present self-contained functionality in the context of the current task.",
		    depends: [ "mobile.shim", "mobile.view" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        Shim = ui.Shim,
		        Widget = ui.Widget,
		        BEFORE_OPEN = "beforeOpen",
		        OPEN = "open",
		        CLOSE = "close",
		        INIT = "init",
		        WRAP = '<div class="km-modalview-wrapper" />';
	
		    var ModalView = ui.View.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            that._id();
		            that._wrap();
		            that._shim();
	
		            if (!this.options.$angular) {
		                that._layout();
		                that._scroller();
		                that._model();
		            }
	
		            that.element.css("display", "");
	
		            that.trigger(INIT);
		        },
	
		        events: [
		            INIT,
		            BEFORE_OPEN,
		            OPEN,
		            CLOSE
		        ],
	
		        options: {
		            name: "ModalView",
		            modal: true,
		            width: null,
		            height: null
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.shim.destroy();
		        },
	
		        open: function(target) {
		            var that = this;
		            that.target = $(target);
		            that.shim.show();
	
		            that._invokeNgController();
	
		            // necessary for the mobile view interface
		            that.trigger("show", { view: that });
		        },
	
		        // Interface implementation, called from the pane click handlers
		        openFor: function(target) {
		            if (!this.trigger(BEFORE_OPEN, { target: target })) {
		                this.open(target);
		                this.trigger(OPEN, { target: target });
		            }
		        },
	
		        close: function() {
		            if (this.element.is(":visible") && !this.trigger(CLOSE)) {
		                this.shim.hide();
		            }
		        },
	
		        _wrap: function() {
		            var that = this,
		                element = that.element,
		                options = that.options,
		                width, height;
	
		            width = element[0].style.width || "auto";
		            height = element[0].style.height || "auto";
	
		            element.addClass("km-modalview").wrap(WRAP);
	
		            that.wrapper = element.parent().css({
		                width: options.width || width || 300,
		                height: options.height || height || 300
		            }).addClass(height == "auto" ? " km-auto-height" : "");
	
		            element.css({ width: "", height: "" });
		        },
	
		        _shim: function() {
		            var that = this;
	
		            that.shim = new Shim(that.wrapper, {
		                modal: that.options.modal,
		                position: "center center",
		                align: "center center",
		                effect: "fade:in",
		                className: "km-modalview-root",
		                hide: function(e) {
		                    if (that.trigger(CLOSE)) {
		                        e.preventDefault();
		                    }
		                }
		            });
		        }
		    });
	
		    ui.plugin(ModalView);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1239);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1221:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(624);
	
	/***/ }),
	
	/***/ 1239:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1221), __webpack_require__(1038) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.drawer",
		    name: "Drawer",
		    category: "mobile",
		    description: "The Kendo Mobile Drawer widget provides slide to reveal global application toolbox",
		    depends: [ "mobile.view", "userevents" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        os = kendo.support.mobileOS,
		        Transition = kendo.effects.Transition,
		        roleSelector = kendo.roleSelector,
		        AXIS = "x",
		        ui = mobile.ui,
		        SWIPE_TO_OPEN = !(os.ios && os.majorVersion == 7 && !os.appMode),
		        BEFORE_SHOW = "beforeShow",
		        INIT = "init",
		        SHOW = "show",
		        HIDE = "hide",
		        AFTER_HIDE = "afterHide",
		        NULL_VIEW = { enable: $.noop };
	
		    var Drawer = ui.View.extend({
		        init: function(element, options) {
		            // move the drawer to the top, in order to hide it
		            $(element).parent().prepend(element);
	
		            mobile.ui.Widget.fn.init.call(this, element, options);
	
		            if (!this.options.$angular) {
		                this._layout();
		                this._scroller();
		            }
	
		            this._model();
	
		            var pane = this.element.closest(roleSelector("pane")).data("kendoMobilePane"),
		                userEvents;
	
		            if (pane) {
		                this.pane = pane;
		                this.pane.bind("viewShow", function(e) {
		                    drawer._viewShow(e);
		                });
	
		                this.pane.bind("sameViewRequested", function() {
		                    drawer.hide();
		                });
	
		                userEvents = this.userEvents = new kendo.UserEvents(pane.element, {
		                    fastTap: true,
		                    filter: roleSelector("view splitview"),
		                    allowSelection: true
		                });
	
		            } else {
		                this.currentView = NULL_VIEW;
		                var container = $(this.options.container);
	
		                if (!container) {
		                    throw new Error("The drawer needs a container configuration option set.");
		                }
	
		                userEvents = this.userEvents = new kendo.UserEvents(container, { fastTap: true, allowSelection: true });
		                this._attachTransition(container);
		            }
	
		            var drawer = this;
	
		            var hide = function(e) {
		                if (drawer.visible) {
		                    drawer.hide();
		                    e.preventDefault();
		                }
		            };
	
		            if (this.options.swipeToOpen && SWIPE_TO_OPEN) {
		                userEvents.bind("press", function() { drawer.transition.cancel(); });
		                userEvents.bind("start", function(e) { drawer._start(e); });
		                userEvents.bind("move", function(e) { drawer._update(e); });
		                userEvents.bind("end", function(e) { drawer._end(e); });
		                userEvents.bind("tap", hide);
		            } else {
		                userEvents.bind("press", hide);
		            }
	
		            this.leftPositioned = this.options.position === "left";
	
		            this.visible = false;
	
		            this.element.hide().addClass("km-drawer").addClass(this.leftPositioned ? "km-left-drawer" : "km-right-drawer");
		            this.trigger(INIT);
		        },
	
		        options: {
		            name: "Drawer",
		            position: "left",
		            views: [],
		            swipeToOpenViews: [],
		            swipeToOpen: true,
		            title: "",
		            container: null
		        },
	
		        events: [
		            BEFORE_SHOW,
		            HIDE,
		            AFTER_HIDE,
		            INIT,
		            SHOW
		        ],
	
		        show: function() {
		            if (this._activate()) {
		                this._show();
		            }
		        },
	
		        hide: function() {
		            if (!this.currentView) {
		                return;
		            }
	
		            this.currentView.enable();
	
		            Drawer.current = null;
		            this._moveViewTo(0);
		            this.trigger(HIDE, { view: this });
		        },
	
		        // Alias in order to support popover/modalview etc. interface
		        openFor: function() {
		            if (this.visible) {
		                this.hide();
		            } else {
		                this.show();
		            }
		        },
	
		        destroy: function() {
		            ui.View.fn.destroy.call(this);
		            this.userEvents.destroy();
		        },
	
		        _activate: function() {
		            if (this.visible) {
		                return true;
		            }
	
		            var visibleOnCurrentView = this._currentViewIncludedIn(this.options.views);
	
		            if (!visibleOnCurrentView || this.trigger(BEFORE_SHOW, { view: this })) {
		                return false;
		            }
	
		            this._setAsCurrent();
		            this.element.show();
	
		            this.trigger(SHOW, { view: this });
		            this._invokeNgController();
		            return true;
		        },
	
		        _currentViewIncludedIn: function(views) {
		            if (!this.pane || !views.length) {
		                return true;
		            }
	
		            var view = this.pane.view();
		            return $.inArray(view.id.replace('#', ''), views) > -1 || $.inArray(view.element.attr("id"), views) > -1;
		        },
	
		        _show: function() {
		            this.currentView.enable(false);
	
		            this.visible = true;
		            var offset = this.element.width();
	
		            if (!this.leftPositioned) {
		                offset = -offset;
		            }
	
		            this._moveViewTo(offset);
		        },
	
		        _setAsCurrent: function() {
		            if (Drawer.last !== this) {
		                if (Drawer.last) {
		                    Drawer.last.element.hide();
		                }
		                this.element.show();
		            }
	
		            Drawer.last = this;
		            Drawer.current = this;
		        },
	
		        _moveViewTo: function(offset) {
		            this.userEvents.cancel();
		            this.transition.moveTo({ location: offset, duration: 400, ease: Transition.easeOutExpo });
		        },
	
		        _viewShow: function(e) {
		            if (this.currentView) {
		                this.currentView.enable();
		            }
	
		            if (this.currentView === e.view) {
		                this.hide();
		                return;
		            }
	
		            this.currentView = e.view;
		            this._attachTransition(e.view.element);
		        },
	
		        _attachTransition: function(element) {
		            var that = this,
		                movable = this.movable,
		                currentOffset = movable && movable.x;
	
	
		            if (this.transition) {
		                this.transition.cancel();
		                this.movable.moveAxis("x", 0);
		            }
	
		            movable = this.movable = new kendo.ui.Movable(element);
	
		            this.transition = new Transition({
		                axis: AXIS,
		                movable: this.movable,
		                onEnd: function() {
		                    if (movable[AXIS] === 0) {
		                        element[0].style.cssText = "";
		                        that.element.hide();
		                        that.trigger(AFTER_HIDE);
		                        that.visible = false;
		                    }
		                }
		            });
	
		            if (currentOffset) {
		                element.addClass("k-fx-hidden");
		                kendo.animationFrame(function() {
		                    element.removeClass("k-fx-hidden");
		                    that.movable.moveAxis(AXIS, currentOffset);
		                    that.hide();
		                });
		            }
		        },
	
		        _start: function(e) {
		            var userEvents = e.sender;
	
		            // ignore non-horizontal swipes
		            if (Math.abs(e.x.velocity) < Math.abs(e.y.velocity) || kendo.triggeredByInput(e.event) || !this._currentViewIncludedIn(this.options.swipeToOpenViews)) {
		                userEvents.cancel();
		                return;
		            }
	
		            var leftPositioned = this.leftPositioned,
		                visible = this.visible,
		                canMoveLeft = leftPositioned && visible || !leftPositioned && !Drawer.current,
		                canMoveRight = !leftPositioned && visible || leftPositioned && !Drawer.current,
		                leftSwipe = e.x.velocity < 0;
	
		            if ((canMoveLeft && leftSwipe) || (canMoveRight && !leftSwipe)) {
		                if (this._activate()) {
		                    userEvents.capture();
		                    return;
		                }
		            }
	
		            userEvents.cancel();
		        },
	
		        _update: function(e) {
		            var movable = this.movable,
		                newPosition = movable.x + e.x.delta,
		                limitedPosition;
	
		            if (this.leftPositioned) {
		                limitedPosition = Math.min(Math.max(0, newPosition), this.element.width());
		            } else {
		                limitedPosition = Math.max(Math.min(0, newPosition), -this.element.width());
		            }
	
		            this.movable.moveAxis(AXIS, limitedPosition);
		            e.event.preventDefault();
		            e.event.stopPropagation();
		        },
	
		        _end: function(e) {
		            var velocity = e.x.velocity,
		                pastHalf = Math.abs(this.movable.x) > this.element.width() / 2,
		                velocityThreshold = 0.8,
		                shouldShow;
	
		            if (this.leftPositioned) {
		                shouldShow = velocity > -velocityThreshold && (velocity > velocityThreshold || pastHalf);
		            } else {
		                shouldShow = velocity < velocityThreshold && (velocity < -velocityThreshold || pastHalf);
		            }
	
		            if(shouldShow) {
		                this._show();
		            } else {
		                this.hide();
		            }
		        }
		    });
	
		    ui.plugin(Drawer);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1249);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1203:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(622);
	
	/***/ }),
	
	/***/ 1249:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1203) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.splitview",
		    name: "SplitView",
		    category: "mobile",
		    description: "The mobile SplitView is a tablet-specific view that consists of two or more mobile Pane widgets.",
		    depends: [ "mobile.pane" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        Widget = ui.Widget,
		        EXPANED_PANE_SHIM = "<div class='km-expanded-pane-shim' />",
		        View = ui.View;
	
		    var SplitView = View.extend({
		        init: function(element, options) {
		            var that = this,
		            pane, modalViews;
	
		            Widget.fn.init.call(that, element, options);
		            element = that.element;
	
		            $.extend(that, options);
	
		            that._id();
	
		            if (!that.options.$angular) {
		                that._layout();
		                that._overlay();
		            } else {
		                that._overlay();
		            }
	
		            that._style();
	
		            modalViews = element.children(that._locate("modalview"));
	
		            if (!that.options.$angular) {
		                kendo.mobile.init(modalViews);
		            } else {
		                modalViews.each(function(idx, element) {
		                    kendo.compileMobileDirective($(element), options.$angular[0]);
		                });
		            }
	
		            that.panes = [];
		            that._paramsHistory = [];
	
		            if (!that.options.$angular) {
		                that.content.children(kendo.roleSelector("pane")).each(function() {
		                    pane = kendo.initWidget(this, {}, ui.roles);
		                    that.panes.push(pane);
		                });
		            } else {
		                that.element.children(kendo.directiveSelector("pane")).each(function() {
		                    pane = kendo.compileMobileDirective($(this), options.$angular[0]);
		                    that.panes.push(pane);
		                });
	
		                that.element.children(kendo.directiveSelector("header footer")).each(function() {
		                    kendo.compileMobileDirective($(this), options.$angular[0]);
		                });
		            }
	
		            that.expandedPaneShim = $(EXPANED_PANE_SHIM).appendTo(that.element);
	
		            that._shimUserEvents = new kendo.UserEvents(that.expandedPaneShim, {
		                fastTap: true,
		                tap: function() {
		                    that.collapsePanes();
		                }
		            });
		        },
	
		        _locate: function(selectors) {
		            return this.options.$angular ? kendo.directiveSelector(selectors) : kendo.roleSelector(selectors);
		        },
	
		        options: {
		            name: "SplitView",
		            style: "horizontal"
		        },
	
		        expandPanes: function() {
		            this.element.addClass("km-expanded-splitview");
		        },
	
		        collapsePanes: function() {
		            this.element.removeClass("km-expanded-splitview");
		        },
	
		        // Implement view interface
		        _layout: function() {
		            var that = this,
		                element = that.element;
	
		            that.transition = kendo.attrValue(element, "transition");
		            kendo.mobile.ui.View.prototype._layout.call(this);
		            kendo.mobile.init(this.header.add(this.footer));
		            that.element.addClass("km-splitview");
		            that.content.addClass("km-split-content");
		        },
	
		        _style: function () {
		            var style = this.options.style,
		                element = this.element,
		                styles;
	
		            if (style) {
		                styles = style.split(" ");
		                $.each(styles, function () {
		                    element.addClass("km-split-" + this);
		                });
		            }
		        },
	
		        showStart: function() {
		            var that = this;
		            that.element.css("display", "");
	
		            if (!that.inited) {
		                that.inited = true;
		                $.each(that.panes, function() {
		                    if (this.options.initial) {
		                        this.navigateToInitial();
		                    } else {
		                        this.navigate("");
		                    }
		                });
		                that.trigger("init", {view: that});
		            } else {
		                this._invokeNgController();
		            }
	
		            that.trigger("show", {view: that});
		        }
		    });
	
		    ui.plugin(SplitView);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1235);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1055:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(583);
	
	/***/ }),
	
	/***/ 1203:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(622);
	
	/***/ }),
	
	/***/ 1235:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1203), __webpack_require__(1055) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.application",
		    name: "Application",
		    category: "mobile",
		    description: "The Mobile application provides a framework to build native looking web applications on mobile devices.",
		    depends: [ "mobile.pane", "router" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        support = kendo.support,
		        Widget = mobile.ui.Widget,
		        Pane = mobile.ui.Pane,
	
		        DEFAULT_OS = "ios7",
		        OS = support.mobileOS,
		        BERRYPHONEGAP = OS.device == "blackberry" && OS.flatVersion >= 600 && OS.flatVersion < 1000 && OS.appMode,
		        FONT_SIZE_COEF = 0.93,
		        VERTICAL = "km-vertical",
		        CHROME =  OS.browser === "chrome",
		        BROKEN_WEBVIEW_RESIZE = OS.ios && OS.flatVersion >= 700 && OS.flatVersion < 800 && (OS.appMode || CHROME),
		        INITIALLY_HORIZONTAL = (Math.abs(window.orientation) / 90 == 1),
		        HORIZONTAL = "km-horizontal",
	
		        MOBILE_PLATFORMS = {
		            ios7: { ios: true, browser: "default", device: "iphone", flatVersion: "700", majorVersion: "7", minorVersion: "0.0", name: "ios", tablet: false },
		            ios: { ios: true, browser: "default", device: "iphone", flatVersion: "612", majorVersion: "6", minorVersion: "1.2", name: "ios", tablet: false },
		            android: { android: true, browser: "default", device: "android", flatVersion: "442", majorVersion: "4", minorVersion: "4.2", name: "android", tablet: false },
		            blackberry: { blackberry: true, browser: "default", device: "blackberry", flatVersion: "710", majorVersion: "7", minorVersion: "1.0", name: "blackberry", tablet: false },
		            meego: { meego: true, browser: "default", device: "meego", flatVersion: "850", majorVersion: "8", minorVersion: "5.0", name: "meego", tablet: false },
		            wp: { wp: true, browser: "default", device: "wp", flatVersion: "800", majorVersion: "8", minorVersion: "0.0", name: "wp", tablet: false }
		        },
	
		        viewportTemplate = kendo.template('<meta content="initial-scale=#: data.scale #, maximum-scale=#: data.scale #, user-scalable=no#=data.height#" name="viewport" />', {usedWithBlock: false}),
		        systemMeta = kendo.template('<meta name="apple-mobile-web-app-capable" content="#= data.webAppCapable === false ? \'no\' : \'yes\' #" /> ' +
		                     '<meta name="apple-mobile-web-app-status-bar-style" content="#=data.statusBarStyle#" /> ' +
		                     '<meta name="msapplication-tap-highlight" content="no" /> ', {usedWithBlock: false}),
		        clipTemplate = kendo.template('<style>.km-view { clip: rect(0 #= data.width #px #= data.height #px 0); }</style>', {usedWithBlock: false}),
		        ENABLE_CLIP = OS.android && OS.browser != "chrome" || OS.blackberry,
	
		        iconMeta = kendo.template('<link rel="apple-touch-icon' + (OS.android ? '-precomposed' : '') + '" # if(data.size) { # sizes="#=data.size#" #}# href="#=data.icon#" />', {usedWithBlock: false}),
	
		        HIDEBAR = (OS.device == "iphone" || OS.device == "ipod") && OS.majorVersion < 7,
		        SUPPORT_SWIPE_TO_GO_BACK = (OS.device == "iphone" || OS.device == "ipod") && OS.majorVersion >= 7,
		        HISTORY_TRANSITION = SUPPORT_SWIPE_TO_GO_BACK ? "none" : null,
		        BARCOMPENSATION = OS.browser == "mobilesafari" ? 60 : 0,
		        STATUS_BAR_HEIGHT = 20,
		        WINDOW = $(window),
		        SCREEN = window.screen,
		        HEAD = $("head"),
	
		        // mobile app events
		        INIT = "init",
		        proxy = $.proxy;
	
		    function osCssClass(os, options) {
		        var classes = [];
	
		        if (OS) {
		            classes.push("km-on-" + OS.name);
		        }
	
		        if (os.skin) {
		            classes.push("km-" + os.skin);
		        } else {
		            if (os.name == "ios" && os.majorVersion > 6) {
		                classes.push("km-ios7");
		            } else {
		                classes.push("km-" + os.name);
		            }
		        }
		        if ((os.name == "ios" && os.majorVersion < 7) || os.name != "ios") {
		            classes.push("km-" + os.name + os.majorVersion);
		        }
		        classes.push("km-" + os.majorVersion);
		        classes.push("km-m" + (os.minorVersion ? os.minorVersion[0] : 0));
	
		        if (os.variant && ((os.skin && os.skin === os.name) || !os.skin || os.setDefaultPlatform === false)) {
		            classes.push("km-" + (os.skin ? os.skin : os.name) + "-" + os.variant);
		        }
	
		        if (os.cordova) {
		            classes.push("km-cordova");
		        }
		        if (os.appMode) {
		            classes.push("km-app");
		        } else {
		            classes.push("km-web");
		        }
	
		        if (options && options.statusBarStyle) {
		            classes.push("km-" + options.statusBarStyle + "-status-bar");
		        }
	
		        return classes.join(" ");
		    }
	
		    function wp8Background(os) {
		        return 'km-wp-' + (os.noVariantSet ?
		                            (parseInt($("<div style='background: Background' />").css("background-color").split(",")[1], 10) === 0 ? 'dark' : 'light') :
		                            os.variant + " km-wp-" + os.variant + "-force");
		    }
	
		    function isOrientationHorizontal(element) {
		        return OS.wp ? element.css("animation-name") == "-kendo-landscape" : (Math.abs(window.orientation) / 90 == 1);
		    }
	
		    function getOrientationClass(element) {
		        return isOrientationHorizontal(element) ? HORIZONTAL : VERTICAL;
		    }
	
		    function setMinimumHeight(pane) {
		        pane.parent().addBack()
		               .css("min-height", window.innerHeight);
		    }
	
		    function applyViewportHeight() {
		        $("meta[name=viewport]").remove();
		            HEAD.append(viewportTemplate({
		            height: ", width=device-width" +  // width=device-width was removed for iOS6, but this should stay for BB PhoneGap.
		                        (isOrientationHorizontal() ?
		                            ", height=" + window.innerHeight + "px"  :
		                            (support.mobileOS.flatVersion >= 600 && support.mobileOS.flatVersion < 700) ?
		                                ", height=" + window.innerWidth + "px" :
		                                ", height=device-height")
		        }));
		    }
	
		    var Application = Widget.extend({
		        init: function(element, options) {
		            // global reference to current application
		            mobile.application = this;
		            $($.proxy(this, 'bootstrap', element, options));
		        },
	
		        bootstrap: function(element, options) {
		            element = $(element);
	
		            if (!element[0]) {
		                element = $(document.body);
		            }
	
		            Widget.fn.init.call(this, element, options);
		            this.element.removeAttr("data-" + kendo.ns + "role");
	
		            this._setupPlatform();
		            this._attachMeta();
		            this._setupElementClass();
		            this._attachHideBarHandlers();
		            var paneOptions = $.extend({}, this.options);
		            delete paneOptions.name;
	
		            var that = this,
		                startHistory = function() {
		                    that.pane = new Pane(that.element, paneOptions);
		                    that.pane.navigateToInitial();
	
		                    if (that.options.updateDocumentTitle) {
		                        that._setupDocumentTitle();
		                    }
	
		                    that._startHistory();
		                    that.trigger(INIT);
		                };
	
		            if (this.options.$angular) {
		                setTimeout(startHistory);
		            } else {
		                startHistory();
		            }
		        },
	
		        options: {
		            name: "Application",
		            hideAddressBar: true,
		            browserHistory: true,
		            historyTransition: HISTORY_TRANSITION,
		            modelScope: window,
		            statusBarStyle: "black",
		            transition: "",
		            retina: false,
		            platform: null,
		            skin: null,
		            updateDocumentTitle: true,
		            useNativeScrolling: false
		        },
	
		        events: [
		            INIT
		        ],
	
		        navigate: function(url, transition) {
		            this.pane.navigate(url, transition);
		        },
	
		        replace: function(url, transition) {
		            this.pane.replace(url, transition);
		        },
	
		        scroller: function() {
		            return this.view().scroller;
		        },
	
		        hideLoading: function() {
		            if (this.pane) {
		                this.pane.hideLoading();
		            } else {
		                throw new Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");
		            }
		        },
	
		        showLoading: function() {
		            if (this.pane) {
		                this.pane.showLoading();
		            } else {
		                throw new Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");
		            }
		        },
	
		        changeLoadingMessage: function(message) {
		            if (this.pane) {
		                this.pane.changeLoadingMessage(message);
		            } else {
		                throw new Error("The mobile application instance is not fully instantiated. Please consider changing the message in the application init event handler.");
		            }
		        },
	
		        view: function() {
		            return this.pane.view();
		        },
	
		        skin: function(skin) {
		            var that = this;
	
		            if (!arguments.length) {
		                return that.options.skin;
		            }
	
		            that.options.skin = skin || "";
		            that.element[0].className = "km-pane";
		            that._setupPlatform();
		            that._setupElementClass();
	
		            return that.options.skin;
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.pane.destroy();
		            if (this.options.browserHistory) {
		                this.router.destroy();
		            }
		        },
	
		        _setupPlatform: function() {
		            var that = this,
		                platform = that.options.platform,
		                skin = that.options.skin,
		                split = [],
		                os = OS || MOBILE_PLATFORMS[DEFAULT_OS];
	
		            if (platform) {
		                os.setDefaultPlatform = true;
		                if (typeof platform === "string") {
		                    split = platform.split("-");
		                    os = $.extend({ variant: split[1] }, os, MOBILE_PLATFORMS[split[0]]);
		                } else {
		                    os = platform;
		                }
		            }
	
		            if (skin) {
		                split = skin.split("-");
		                if (!OS) {
		                    os.setDefaultPlatform = false;
		                }
		                os = $.extend({}, os, { skin: split[0], variant: split[1] });
		            }
	
		            if (!os.variant) {
		                os.noVariantSet = true;
		                os.variant = "dark";
		            }
	
		            that.os = os;
	
		            that.osCssClass = osCssClass(that.os, that.options);
	
		            if (os.name == "wp") {
		                if (!that.refreshBackgroundColorProxy) {
		                    that.refreshBackgroundColorProxy = $.proxy(function () {
		                        if (that.os.variant && (that.os.skin && that.os.skin === that.os.name) || !that.os.skin) {
		                            that.element.removeClass("km-wp-dark km-wp-light km-wp-dark-force km-wp-light-force").addClass(wp8Background(that.os));
		                        }
		                    }, that);
		                }
	
		                $(document).off("visibilitychange", that.refreshBackgroundColorProxy);
		                $(document).off("resume", that.refreshBackgroundColorProxy);
	
		                if (!os.skin) {
		                    that.element.parent().css("overflow", "hidden");
	
		                    $(document).on("visibilitychange", that.refreshBackgroundColorProxy); // Restore theme on browser focus (using the Visibility API).
		                    $(document).on("resume", that.refreshBackgroundColorProxy); // PhoneGap fires resume.
	
		                    that.refreshBackgroundColorProxy();
		                }
		            }
		        },
	
		        _startHistory: function() {
		            if (this.options.browserHistory) {
		                this.router = new kendo.Router({ pushState: this.options.pushState, root: this.options.root, hashBang: this.options.hashBang });
		                this.pane.bindToRouter(this.router);
		                this.router.start();
		            } else {
		                if (!this.options.initial) {
		                    this.pane.navigate("");
		                }
		            }
		        },
	
		        _resizeToScreenHeight: function() {
		            var includeStatusBar = $("meta[name=apple-mobile-web-app-status-bar-style]").attr("content").match(/black-translucent|hidden/),
		                element = this.element,
		                height;
	
		            if (CHROME) {
		                height = window.innerHeight;
		            } else {
		                if (isOrientationHorizontal(element)) {
		                    if (includeStatusBar) {
		                        if (INITIALLY_HORIZONTAL) {
		                            height = SCREEN.availWidth + STATUS_BAR_HEIGHT;
		                        } else {
		                            height = SCREEN.availWidth;
		                        }
		                    } else {
		                        if (INITIALLY_HORIZONTAL) {
		                            height = SCREEN.availWidth;
		                        } else {
		                            height = SCREEN.availWidth - STATUS_BAR_HEIGHT;
		                        }
		                    }
		                } else {
		                    if (includeStatusBar) {
		                        if (INITIALLY_HORIZONTAL) {
		                            height = SCREEN.availHeight;
		                        } else {
		                            height = SCREEN.availHeight + STATUS_BAR_HEIGHT;
		                        }
		                    } else {
		                        if (INITIALLY_HORIZONTAL) {
		                            height = SCREEN.availHeight - STATUS_BAR_HEIGHT;
		                        } else {
		                            height = SCREEN.availHeight;
		                        }
		                    }
		                }
		            }
	
		            element.height(height);
		        },
	
		        _setupElementClass: function() {
		            var that = this, size,
		                element = that.element;
	
		            element.parent().addClass("km-root km-" + (that.os.tablet ? "tablet" : "phone"));
		            element.addClass(that.osCssClass + " " + getOrientationClass(element));
		            if (this.options.useNativeScrolling) {
		                element.parent().addClass("km-native-scrolling");
		            }
	
		            if (CHROME) {
		                element.addClass("km-ios-chrome");
		            }
	
		            if (support.wpDevicePixelRatio) {
		                element.parent().css("font-size", support.wpDevicePixelRatio + "em");
		            }
	
		            if (this.options.retina) {
		                element.parent().addClass("km-retina");
		                element.parent().css("font-size", (support.devicePixelRatio * FONT_SIZE_COEF) + "em");
		            }
	
		            if (BERRYPHONEGAP) {
		                applyViewportHeight();
		            }
		            if (that.options.useNativeScrolling) {
		                element.parent().addClass("km-native-scrolling");
		            } else if (ENABLE_CLIP) {
		                size = (screen.availWidth > screen.availHeight ? screen.availWidth : screen.availHeight) + 200;
		                $(clipTemplate({ width: size, height: size })).appendTo(HEAD);
		            }
	
		            if (BROKEN_WEBVIEW_RESIZE) {
		                that._resizeToScreenHeight();
		            }
	
		            kendo.onResize(function() {
		                element
		                    .removeClass("km-horizontal km-vertical")
		                    .addClass(getOrientationClass(element));
	
		                if (that.options.useNativeScrolling) {
		                    setMinimumHeight(element);
		                }
	
		                if (BROKEN_WEBVIEW_RESIZE) {
		                    that._resizeToScreenHeight();
		                }
	
		                if (BERRYPHONEGAP) {
		                    applyViewportHeight();
		                }
	
		                kendo.resize(element);
		            });
		        },
	
		        _clearExistingMeta: function() {
		            HEAD.find("meta")
		                .filter("[name|='apple-mobile-web-app'],[name|='msapplication-tap'],[name='viewport']")
		                .remove();
		        },
	
		        _attachMeta: function() {
		            var options = this.options,
		                icon = options.icon, size;
	
		            this._clearExistingMeta();
	
		            if (!BERRYPHONEGAP) {
		                HEAD.prepend(viewportTemplate({ height: "", scale : this.options.retina ? 1 / support.devicePixelRatio : "1.0" }));
		            }
	
		            HEAD.prepend(systemMeta(options));
	
		            if (icon) {
		                if (typeof icon === "string") {
		                    icon = { "" : icon };
		                }
	
		                for(size in icon) {
		                    HEAD.prepend(iconMeta({ icon: icon[size], size: size }));
		                }
		            }
	
		            if (options.useNativeScrolling) {
		                setMinimumHeight(this.element);
		            }
		        },
	
		        _attachHideBarHandlers: function() {
		            var that = this,
		                hideBar = proxy(that, "_hideBar");
	
		            if (support.mobileOS.appMode || !that.options.hideAddressBar || !HIDEBAR || that.options.useNativeScrolling) {
		                return;
		            }
	
		            that._initialHeight = {};
	
		            WINDOW.on("load", hideBar);
	
		            kendo.onResize(function() {
		                setTimeout(window.scrollTo, 0, 0, 1);
		            });
		        },
	
		        _setupDocumentTitle: function() {
		            var that = this,
		                defaultTitle = document.title;
	
		            that.pane.bind("viewShow", function(e) {
		                var title = e.view.title;
		                document.title = title !== undefined ? title : defaultTitle;
		            });
		        },
	
		        _hideBar: function() {
		            var that = this,
		                element = that.element;
	
		            element.height(kendo.support.transforms.css + "calc(100% + " + BARCOMPENSATION + "px)");
		            $(window).trigger(kendo.support.resize);
		        }
		    });
	
		    kendo.mobile.Application = Application;
		    kendo.ui.plugin(Application, kendo.mobile, 'Mobile');
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1236);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1236:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1038) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.button",
		    name: "Button",
		    category: "mobile",
		    description: "The Button widget navigates between mobile Application views when pressed.",
		    depends: [ "userevents" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        ui = mobile.ui,
		        Widget = ui.Widget,
		        support = kendo.support,
		        os = support.mobileOS,
		        ANDROID3UP = os.android && os.flatVersion >= 300,
		        CLICK = "click",
		        DISABLED = "disabled",
		        DISABLEDSTATE = "km-state-disabled";
	
		    function highlightButton(widget, event, highlight) {
		        $(event.target).closest(".km-button,.km-detail").toggleClass("km-state-active", highlight);
	
		        if (ANDROID3UP && widget.deactivateTimeoutID) {
		            clearTimeout(widget.deactivateTimeoutID);
		            widget.deactivateTimeoutID = 0;
		        }
		    }
	
		    function createBadge(value) {
		        return $('<span class="km-badge">' + value + '</span>');
		    }
	
		    var Button = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
		            var useTap = that.options.clickOn === "up";
	
		            that._wrap();
		            that._style();
	
		            if (!useTap) {
		                that.element.attr("data-navigate-on-press", true);
		            }
	
		            that.options.enable = that.options.enable && !that.element.attr(DISABLED);
		            that.enable(that.options.enable);
	
		            that._userEvents = new kendo.UserEvents(that.element, {
		                allowSelection: !useTap,
		                fastTap: true,
		                press: function(e) {
		                    that._activate(e);
		                },
		                release: function(e) {
		                    highlightButton(that, e, false);
		                    if (!useTap) { e.event.stopPropagation(); }
		                }
		            });
	
		            that._userEvents.bind(useTap ? "tap" : "press", function(e) {
		                that._release(e);
		            });
	
	
		            if (ANDROID3UP) {
		                that.element.on("move", function(e) { that._timeoutDeactivate(e); });
		            }
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this._userEvents.destroy();
		        },
	
		        events: [
		            CLICK
		        ],
	
		        options: {
		            name: "Button",
		            icon: "",
		            style: "",
		            badge: "",
		            clickOn: "up",
		            enable: true
		        },
	
		        badge: function (value) {
		            var badge = this.badgeElement = this.badgeElement || createBadge(value).appendTo(this.element);
	
		            if (value || value === 0) {
		                badge.html(value);
		                return this;
		            }
	
		            if (value === false) {
		                badge.empty().remove();
		                this.badgeElement = false;
		                return this;
		            }
	
		            return badge.html();
		        },
	
		        enable: function(enable) {
		            var element = this.element;
	
		            if(typeof enable == "undefined") {
		                enable = true;
		            }
	
		            this.options.enable = enable;
	
		            if(enable) {
		                element.removeAttr(DISABLED);
		            } else {
		                element.attr(DISABLED, DISABLED);
		            }
	
		            element.toggleClass(DISABLEDSTATE, !enable);
		        },
	
		        _timeoutDeactivate: function(e) {
		            if (!this.deactivateTimeoutID) {
		                this.deactivateTimeoutID = setTimeout(highlightButton, 500, this, e, false);
		            }
		        },
	
		        _activate: function(e) {
		            var activeElement = document.activeElement,
		                nodeName = activeElement ? activeElement.nodeName : "";
	
		            if(this.options.enable) {
		                highlightButton(this, e, true);
	
		                if (nodeName == "INPUT" || nodeName == "TEXTAREA") {
		                    activeElement.blur(); // Hide device keyboard
		                }
		            }
		        },
	
		        _release: function(e) {
		            var that = this;
	
		            if (e.which > 1) {
		                return;
		            }
	
		            if(!that.options.enable) {
		                e.preventDefault();
		                return;
		            }
	
		            if (that.trigger(CLICK, {target: $(e.target), button: that.element})) {
		                e.preventDefault();
		            }
		        },
	
		        _style: function() {
		            var style = this.options.style,
		                element = this.element,
		                styles;
	
		            if (style) {
		                styles = style.split(" ");
		                $.each(styles, function() {
		                    element.addClass("km-" + this);
		                });
		            }
		        },
	
		        _wrap: function() {
		            var that = this,
		                icon = that.options.icon,
		                badge = that.options.badge,
		                iconSpan = '<span class="km-icon km-' + icon,
		                element = that.element.addClass("km-button"),
		                span = element.children("span:not(.km-icon)").addClass("km-text"),
		                image = element.find("img").addClass("km-image");
	
		            if (!span[0] && element.html()) {
		                span = element.wrapInner('<span class="km-text" />').children("span.km-text");
		            }
	
		            if (!image[0] && icon) {
		                if (!span[0]) {
		                    iconSpan += " km-notext";
		                }
		                that.iconElement = element.prepend($(iconSpan + '" />'));
		            }
	
		            if (badge || badge === 0) {
		                that.badgeElement = createBadge(badge).appendTo(element);
		            }
		        }
		    });
	
		    var BackButton = Button.extend({
		        options: {
		            name: "BackButton",
		            style: "back"
		        },
	
		        init: function(element, options) {
		            var that = this;
		            Button.fn.init.call(that, element, options);
	
		            if (typeof that.element.attr("href") === "undefined") {
		                that.element.attr("href", "#:back");
		            }
		        }
		    });
	
		    var DetailButton = Button.extend({
		        options: {
		            name: "DetailButton",
		            style: ""
		        },
	
		        init: function(element, options) {
		            Button.fn.init.call(this, element, options);
		        },
	
		        _style: function() {
		            var style = this.options.style + " detail",
		                element = this.element;
	
		            if (style) {
		                var styles = style.split(" ");
		                $.each(styles, function() {
		                    element.addClass("km-" + this);
		                });
		            }
		        },
	
		        _wrap: function() {
		            var that = this,
		                icon = that.options.icon,
		                iconSpan = '<span class="km-icon km-' + icon,
		                element = that.element,
		                span = element.children("span"),
		                image = element.find("img").addClass("km-image");
	
		            if (!image[0] && icon) {
		                if (!span[0]) {
		                    iconSpan += " km-notext";
		                }
		                element.prepend($(iconSpan + '" />'));
		            }
		        }
	
		    });
	
		    ui.plugin(Button);
		    ui.plugin(BackButton);
		    ui.plugin(DetailButton);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1237);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1237:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.buttongroup",
		    name: "ButtonGroup",
		    category: "mobile",
		    description: "The Kendo mobile ButtonGroup widget is a linear set of grouped buttons.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        Widget = ui.Widget,
		        ACTIVE = "state-active",
		        DISABLE = "state-disabled",
		        SELECT = "select",
		        SELECTOR = "li:not(.km-" + ACTIVE +")";
	
		    function className(name) {
		        return "k-" + name + " km-" + name;
		    }
	
		    function createBadge(value) {
		        return $('<span class="' + className("badge") + '">' + value + '</span>');
		    }
	
		    var ButtonGroup = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            that.element.addClass("km-buttongroup k-widget k-button-group").find("li").each(that._button);
	
		            that.element.on(that.options.selectOn, SELECTOR, "_select");
	
		            that._enable = true;
		            that.select(that.options.index);
	
		            if(!that.options.enable) {
		                that._enable = false;
		                that.wrapper.addClass(className(DISABLE));
		            }
		        },
	
		        events: [
		            SELECT
		        ],
	
		        options: {
		            name: "ButtonGroup",
		            selectOn: "down",
		            index: -1,
		            enable: true
		        },
	
		        current: function() {
		            return this.element.find(".km-" + ACTIVE);
		        },
	
		        select: function (li) {
		            var that = this,
		                index = -1;
	
		            if (li === undefined || li === -1 || !that._enable || $(li).is(".km-" + DISABLE)) {
		                return;
		            }
	
		            that.current().removeClass(className(ACTIVE));
	
		            if (typeof li === "number") {
		                index = li;
		                li = $(that.element[0].children[li]);
		            } else if (li.nodeType) {
		                li = $(li);
		                index = li.index();
		            }
	
		            li.addClass(className(ACTIVE));
		            that.selectedIndex = index;
		        },
	
		        badge: function(item, value) {
		            var buttongroup = this.element, badge;
	
		            if (!isNaN(item)) {
		                item = buttongroup.children().get(item);
		            }
	
		            item = buttongroup.find(item);
		            badge = $(item.children(".km-badge")[0] || createBadge(value).appendTo(item));
	
		            if (value || value === 0) {
		                badge.html(value);
		                return this;
		            }
	
		            if (value === false) {
		                badge.empty().remove();
		                return this;
		            }
	
		            return badge.html();
		        },
	
		        enable: function(enable) {
		            if(typeof enable == "undefined") {
		                enable = true;
		            }
	
		            this.wrapper.toggleClass(className(DISABLE), !enable);
	
		            this._enable = this.options.enable = enable;
		        },
	
		        _button: function() {
		            var button = $(this).addClass(className("button")),
		                icon = kendo.attrValue(button, "icon"),
		                badge = kendo.attrValue(button, "badge"),
		                span = button.children("span"),
		                image = button.find("img").addClass(className("image"));
	
		            if (!span[0]) {
		                span = button.wrapInner("<span/>").children("span");
		            }
	
		            span.addClass(className("text"));
	
		            if (!image[0] && icon) {
		                button.prepend($('<span class="' + className("icon") + ' ' + className(icon) + '"/>'));
		            }
	
		            if (badge || badge === 0) {
		                createBadge(badge).appendTo(button);
		            }
		        },
	
		        _select: function(e) {
		            if (e.which > 1 || e.isDefaultPrevented() || !this._enable) {
		                return;
		            }
	
		            this.select(e.currentTarget);
		            this.trigger(SELECT, { index: this.selectedIndex });
		        }
		    });
	
		    ui.plugin(ButtonGroup);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1238);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1238:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.collapsible",
		    name: "Collapsible",
		    category: "mobile",
		    description: "The Kendo mobile Collapsible widget provides ability for creating collapsible blocks of content.",
		    depends: [ "core", "userevents" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        Widget = ui.Widget,
		        COLLAPSIBLE = "km-collapsible",
		        HEADER = "km-collapsible-header",
		        CONTENT = "km-collapsible-content",
		        INSET = "km-collapsibleinset",
		        HEADER_WRAPPER = "<div data-role='collapsible-header' class='" + HEADER + "'></div>",
		        CONTENT_WRAPPER = "<div data-role='collapsible-content' class='" + CONTENT + "'></div>",
	
		        COLLAPSED = "km-collapsed",
		        EXPANDED = "km-expanded",
		        ANIMATED = "km-animated",
	
		        //icon position
		        LEFT = "left",
	
		        //events
		        EXAPND = "expand",
		        COLLAPSE = "collapse";
	
		    var Collapsible = Widget.extend({
		        init: function(element, options) {
		            var that = this,
		                container = $(element);
	
		            Widget.fn.init.call(that, container, options);
	
		            container.addClass(COLLAPSIBLE);
	
		            that._buildHeader();
		            that.content = container.children().not(that.header).wrapAll(CONTENT_WRAPPER).parent();
	
		            that._userEvents = new kendo.UserEvents(that.header, {
		                fastTap: true,
		                tap: function() { that.toggle(); }
		            });
	
		            container.addClass(that.options.collapsed ? COLLAPSED : EXPANDED);
	
		            if (that.options.inset) {
		                container.addClass(INSET);
		            }
	
		            if (that.options.animation) {
		                that.content.addClass(ANIMATED);
		                that.content.height(0);
		                if (that.options.collapsed) {
		                    that.content.hide();
		                }
		            } else if (that.options.collapsed) {
		                that.content.hide();
		            }
		        },
	
		        events: [
		            EXAPND,
		            COLLAPSE
		        ],
	
		        options: {
		            name: "Collapsible",
		            collapsed: true,
		            collapseIcon: "arrow-n",
		            expandIcon: "arrow-s",
		            iconPosition: LEFT,
		            animation: true,
		            inset: false
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this._userEvents.destroy();
		        },
	
		        expand: function(instant) {
		            var icon = this.options.collapseIcon,
		                content = this.content,
		                ios = kendo.support.mobileOS.ios;
	
		            if (!this.trigger(EXAPND)) {
		                if (icon) {
		                    this.header.find(".km-icon").removeClass().addClass("km-icon km-" + icon);
		                }
		                this.element.removeClass(COLLAPSED).addClass(EXPANDED);
	
		                if (this.options.animation && !instant) {
		                    content.off("transitionend");
		                    content.show();
		                    if (ios) { content.removeClass(ANIMATED); } //required to get the height of the content on iOS
		                    content.height(this._getContentHeight());
		                    if (ios) { content.addClass(ANIMATED); }
	
		                    kendo.resize(content);
		                } else {
		                    content.show();
		                }
		            }
		        },
	
		        collapse: function(instant) {
		            var icon = this.options.expandIcon,
		                content = this.content;
	
		            if (!this.trigger(COLLAPSE)) {
		                if (icon) {
		                    this.header.find(".km-icon").removeClass().addClass("km-icon km-" + icon);
		                }
		                this.element.removeClass(EXPANDED).addClass(COLLAPSED);
	
		                if (this.options.animation && !instant) {
		                    content.one("transitionend", function() { content.hide(); });
		                    content.height(0);
		                } else {
		                    content.hide();
		                }
		            }
		        },
	
		        toggle: function(instant) {
		            if (this.isCollapsed()) {
		                this.expand(instant);
		            } else {
		                this.collapse(instant);
		            }
		        },
	
		        isCollapsed: function() {
		            return this.element.hasClass(COLLAPSED);
		        },
	
		        resize: function() {
		            if (!this.isCollapsed() && this.options.animation) {
		                this.content.height(this._getContentHeight());
		            }
		        },
	
		        _buildHeader: function() {
		            var header = this.element.children(":header").wrapAll(HEADER_WRAPPER),
		                iconSpan = $('<span class="km-icon"/>'),
		                icon = this.options.collapsed ? this.options.expandIcon : this.options.collapseIcon,
		                iconPosition = this.options.iconPosition;
	
		            if (icon) {
		                header.prepend(iconSpan);
		                iconSpan.addClass("km-" + icon);
		            }
	
		            this.header = header.parent();
		            this.header.addClass("km-icon-" + iconPosition);
		        },
	
		        _getContentHeight: function() {
		            var style = this.content.attr("style"),
		                height;
	
		            this.content.css({
		                position:   'absolute',
		                visibility: 'hidden',
		                height: "auto"
		            });
	
		            height = this.content.height();
	
		            this.content.attr("style", style ? style : "");
	
		            return height;
		        }
		    });
	
		    ui.plugin(Collapsible);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1240);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1226:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(789);
	
	/***/ }),
	
	/***/ 1240:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013), __webpack_require__(1038), __webpack_require__(1226) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.listview",
		    name: "ListView",
		    category: "mobile",
		    description: "The Kendo Mobile ListView widget is used to display flat or grouped list of items.",
		    depends: [ "data", "userevents", "mobile.button" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        Node = window.Node,
		        mobile = kendo.mobile,
		        ui = mobile.ui,
		        outerHeight = kendo._outerHeight,
		        DataSource = kendo.data.DataSource,
		        Widget = ui.DataBoundWidget,
		        ITEM_SELECTOR = ".km-list > li, > li:not(.km-group-container)",
		        HIGHLIGHT_SELECTOR = ".km-listview-link, .km-listview-label",
		        ICON_SELECTOR = "[" + kendo.attr("icon") + "]",
		        proxy = $.proxy,
		        attrValue = kendo.attrValue,
		        GROUP_CLASS = "km-group-title",
		        ACTIVE_CLASS = "km-state-active",
		        GROUP_WRAPPER = '<div class="' + GROUP_CLASS + '"><div class="km-text"></div></div>',
		        GROUP_TEMPLATE = kendo.template('<li><div class="' + GROUP_CLASS + '"><div class="km-text">#= this.headerTemplate(data) #</div></div><ul>#= kendo.render(this.template, data.items)#</ul></li>'),
		        WRAPPER = '<div class="km-listview-wrapper" />',
		        SEARCH_TEMPLATE = kendo.template('<form class="km-filter-form"><div class="km-filter-wrap"><input type="search" placeholder="#=placeholder#"/><a href="\\#" class="km-filter-reset" title="Clear"><span class="km-icon km-clear"></span><span class="km-text">Clear</span></a></div></form>'),
		        NS = ".kendoMobileListView",
		        STYLED = "styled",
		        DATABOUND = "dataBound",
		        DATABINDING = "dataBinding",
		        ITEM_CHANGE = "itemChange",
		        CLICK = "click",
		        CHANGE = "change",
		        PROGRESS = "progress",
		        FUNCTION = "function",
	
		        whitespaceRegExp = /^\s+$/,
		        buttonRegExp = /button/;
	
		    function whitespace() {
		        return this.nodeType === Node.TEXT_NODE && this.nodeValue.match(whitespaceRegExp);
		    }
	
		    function addIcon(item, icon) {
		        if (icon && !item[0].querySelector(".km-icon")) {
		            item.prepend('<span class="km-icon km-' + icon + '"/>');
		        }
		    }
	
		    function enhanceItem(item) {
		        addIcon(item, attrValue(item, "icon"));
		        addIcon(item, attrValue(item.children(ICON_SELECTOR), "icon"));
		    }
	
		    function enhanceLinkItem(item) {
		        var parent = item.parent(),
		            itemAndDetailButtons = item.add(parent.children(kendo.roleSelector("detailbutton"))),
		            otherNodes = parent.contents().not(itemAndDetailButtons).not(whitespace);
	
		        if (otherNodes.length) {
		            return;
		        }
	
		        item.addClass("km-listview-link")
		            .attr(kendo.attr("role"), "listview-link");
	
		        addIcon(item, attrValue(parent, "icon"));
		        addIcon(item, attrValue(item, "icon"));
		    }
	
		    function enhanceCheckBoxItem(label) {
		        if (!label[0].querySelector("input[type=checkbox],input[type=radio]")) {
		            return;
		        }
	
		        var item = label.parent();
	
		        if (item.contents().not(label).not(function() { return this.nodeType == 3; })[0]) {
		            return;
		        }
	
		        label.addClass("km-listview-label");
	
		        label.children("[type=checkbox],[type=radio]").addClass("km-widget km-icon km-check");
		    }
	
		    function putAt(element, top) {
		        $(element).css('transform', 'translate3d(0px, ' + top + 'px, 0px)');
		    }
	
		    var HeaderFixer = kendo.Class.extend({
		        init: function(listView) {
		            var scroller = listView.scroller();
	
		            if (!scroller) {
		                return;
		            }
	
		            this.options = listView.options;
		            this.element = listView.element;
		            this.scroller = listView.scroller();
		            this._shouldFixHeaders();
	
		            var headerFixer = this;
	
		            var cacheHeaders = function() {
		                headerFixer._cacheHeaders();
		            };
	
		            listView.bind("resize", cacheHeaders);
	
		            listView.bind(STYLED, cacheHeaders);
		            listView.bind(DATABOUND, cacheHeaders);
	
		            this._scrollHandler = function(e) {
		                headerFixer._fixHeader(e);
		            };
		            scroller.bind("scroll", this._scrollHandler);
		        },
	
		        destroy: function() {
		            var that = this;
		            if (that.scroller) {
		                that.scroller.unbind("scroll", that._scrollHandler);
		            }
		        },
	
		        _fixHeader: function(e) {
		            if (!this.fixedHeaders) {
		                return;
		            }
	
		            var i = 0,
		                scroller = this.scroller,
		                headers = this.headers,
		                scrollTop = e.scrollTop,
		                headerPair,
		                offset,
		                header;
	
		            do {
		                headerPair = headers[i++];
		                if (!headerPair) {
		                    header = $("<div />");
		                    break;
		                }
		                offset = headerPair.offset;
		                header = headerPair.header;
		            } while (offset + 1 > scrollTop);
	
		            if (this.currentHeader != i) {
		                scroller.fixedContainer.html(header.clone());
		                this.currentHeader = i;
		            }
		        },
	
		        _shouldFixHeaders: function() {
		            this.fixedHeaders = this.options.type === "group" && this.options.fixedHeaders;
		        },
	
		        _cacheHeaders: function() {
		            this._shouldFixHeaders();
	
		            if (!this.fixedHeaders) {
		                return;
		            }
	
		            var headers = [], offset = this.scroller.scrollTop;
	
		            this.element.find("." + GROUP_CLASS).each(function(_, header) {
		                header = $(header);
		                headers.unshift({
		                    offset: header.position().top + offset,
		                    header: header
		                });
		            });
	
		            this.headers = headers;
		            this._fixHeader({ scrollTop: offset });
		        }
		    });
	
		    var DEFAULT_PULL_PARAMETERS = function() {
		        return { page: 1 };
		    };
	
		    var RefreshHandler = kendo.Class.extend({
		        init: function(listView) {
		            var handler = this,
		                options = listView.options,
		                scroller = listView.scroller(),
		                pullParameters = options.pullParameters || DEFAULT_PULL_PARAMETERS;
	
		            this.listView = listView;
		            this.scroller = scroller;
	
		            listView.bind("_dataSource", function(e) {
		                handler.setDataSource(e.dataSource);
		            });
	
		            scroller.setOptions({
		                pullToRefresh: true,
		                pull: function() {
		                    if (!handler._pulled) {
		                        handler._pulled = true;
		                        handler.dataSource.read(pullParameters.call(listView, handler._first));
		                    }
		                },
		                messages: {
		                    pullTemplate: options.messages.pullTemplate,
		                    releaseTemplate: options.messages.releaseTemplate,
		                    refreshTemplate: options.messages.refreshTemplate
		                }
		            });
		        },
	
		        setDataSource: function(dataSource) {
		            var handler = this;
	
		            this._first = dataSource.view()[0];
		            this.dataSource = dataSource;
	
		            dataSource.bind("change", function() {
		                handler._change();
		            });
	
		            dataSource.bind("error", function() {
		                handler._change();
		            });
		        },
	
		        _change: function() {
		            var scroller = this.scroller,
		                dataSource = this.dataSource;
	
		            if (this._pulled) {
		                scroller.pullHandled();
		            }
	
		            if (this._pulled || !this._first) {
		                var view = dataSource.view();
	
		                if (view[0]) {
		                    this._first = view[0];
		                }
		            }
	
		            this._pulled = false;
		        }
		    });
	
		    var VirtualList = kendo.Observable.extend({
		        init: function(options) {
		            var list = this;
	
		            kendo.Observable.fn.init.call(list);
	
		            list.buffer = options.buffer;
		            list.height = options.height;
		            list.item = options.item;
		            list.items = [];
		            list.footer = options.footer;
	
		            list.buffer.bind("reset", function() {
		                list.refresh();
		            });
	
		        },
	
		        refresh: function() {
		            var buffer = this.buffer,
		                items = this.items,
		                endReached = false;
	
		            while(items.length) {
		                items.pop().destroy();
		            }
	
		            this.offset = buffer.offset;
	
		            var itemConstructor = this.item,
		                prevItem,
		                item;
	
		            for (var idx = 0; idx < buffer.viewSize; idx ++) {
		                if (idx === buffer.total()) {
		                    endReached = true;
		                    break;
		                }
		                item = itemConstructor(this.content(this.offset + items.length));
		                item.below(prevItem);
		                prevItem = item;
		                items.push(item);
		            }
	
		            this.itemCount = items.length;
	
		            this.trigger("reset");
	
		            this._resize();
	
		            if (endReached) {
		                this.trigger("endReached");
		            }
		        },
	
		        totalHeight: function() {
		            if (!this.items[0]) {
		                return 0;
		            }
	
		            var list = this,
		                items = list.items,
		                top = items[0].top,
		                bottom = items[items.length - 1].bottom,
		                averageItemHeight = (bottom - top) / list.itemCount,
		                remainingItemsCount = list.buffer.length - list.offset - list.itemCount;
	
		            return (this.footer ? this.footer.height : 0) + bottom + remainingItemsCount * averageItemHeight;
		        },
	
		        batchUpdate: function(top) {
		            var height = this.height(),
		                items = this.items,
		                item,
		                initialOffset = this.offset;
	
		            if (!items[0]) {
		                return;
		            }
	
		            if (this.lastDirection) { // scrolling up
		                while(items[items.length - 1].bottom > top + height * 2) {
		                    if (this.offset === 0) {
		                        break;
		                    }
	
		                    this.offset --;
		                    item = items.pop();
		                    item.update(this.content(this.offset));
		                    item.above(items[0]);
		                    items.unshift(item);
		                }
		            } else { // scrolling down
		                while (items[0].top < top - height) {
		                    var nextIndex = this.offset + this.itemCount; // here, it should be offset + 1 + itemCount - 1.
	
		                    if (nextIndex === this.buffer.total()) {
		                        this.trigger("endReached");
		                        break;
		                    }
	
		                    if (nextIndex === this.buffer.length) {
		                        break;
		                    }
	
		                    item = items.shift();
		                    item.update(this.content(this.offset + this.itemCount));
		                    item.below(items[items.length - 1]);
		                    items.push(item);
		                    this.offset ++;
		                }
		            }
	
		            if (initialOffset !== this.offset) {
		                this._resize();
		            }
		        },
	
		        update: function(top) {
		            var list = this,
		                items = this.items,
		                item,
		                firstItem,
		                lastItem,
		                height = this.height(),
		                itemCount = this.itemCount,
		                padding = height / 2,
		                up = (this.lastTop || 0) > top,
		                topBorder = top - padding,
		                bottomBorder = top + height + padding;
	
		            if (!items[0]) {
		                return;
		            }
	
		            this.lastTop = top;
		            this.lastDirection = up;
	
		            if (up) { // scrolling up
		               if (items[0].top > topBorder &&  // needs reorder
		                   items[items.length - 1].bottom > bottomBorder + padding && // enough padding below
		                   this.offset > 0 // we are not at the top
		                  )
		               {
		                    this.offset --;
		                    item = items.pop();
		                    firstItem = items[0];
		                    item.update(this.content(this.offset));
		                    items.unshift(item);
	
		                    item.above(firstItem);
		                    list._resize();
		               }
		            } else { // scrolling down
		                if (
		                    items[items.length - 1].bottom < bottomBorder && // needs reorder
		                    items[0].top < topBorder - padding // enough padding above
		                )
		                {
		                    var nextIndex = this.offset + itemCount; // here, it should be offset + 1 + itemCount - 1.
	
		                    if (nextIndex === this.buffer.total()) {
		                        this.trigger("endReached");
		                    } else if (nextIndex !== this.buffer.length) {
		                        item = items.shift();
		                        lastItem = items[items.length - 1];
		                        items.push(item);
		                        item.update(this.content(this.offset + this.itemCount));
		                        list.offset ++;
	
		                        item.below(lastItem);
		                        list._resize();
		                    }
		                }
		            }
		        },
	
		        content: function(index) {
		            return this.buffer.at(index);
		        },
	
		        destroy: function() {
		            this.unbind();
		        },
	
		        _resize: function() {
		            var items = this.items,
		                top = 0,
		                bottom = 0,
		                firstItem = items[0],
		                lastItem = items[items.length - 1];
	
		            if (firstItem) {
		                top = firstItem.top;
		                bottom = lastItem.bottom;
		            }
	
		            this.trigger("resize", { top: top, bottom: bottom });
	
		            if (this.footer) {
		                this.footer.below(lastItem);
		            }
		        }
		    });
	
		    // export for testing purposes
		    kendo.mobile.ui.VirtualList = VirtualList;
	
		    var VirtualListViewItem = kendo.Class.extend({
		        init: function(listView, dataItem) {
		            var element = listView.append([dataItem], true)[0],
		                height = element.offsetHeight;
	
		            $.extend(this, {
		                top: 0,
		                element: element,
		                listView: listView,
		                height: height,
		                bottom: height
		            });
		        },
	
		        update: function(dataItem) {
		            this.element = this.listView.setDataItem(this.element, dataItem);
		        },
	
		        above: function(item) {
		            if (item) {
		                this.height = this.element.offsetHeight;
		                this.top = item.top - this.height;
		                this.bottom = item.top;
		                putAt(this.element, this.top);
		            }
		        },
	
		        below: function(item) {
		            if (item) {
		                this.height = this.element.offsetHeight;
		                this.top = item.bottom;
		                this.bottom = this.top + this.height;
		                putAt(this.element, this.top);
		            }
		        },
	
		        destroy: function() {
		            kendo.destroy(this.element);
		            $(this.element).remove();
		        }
		    });
	
		    var LOAD_ICON = '<div><span class="km-icon"></span><span class="km-loading-left"></span><span class="km-loading-right"></span></div>';
		    var VirtualListViewLoadingIndicator = kendo.Class.extend({
		        init: function(listView) {
		            this.element = $('<li class="km-load-more km-scroller-refresh" style="display: none"></li>').appendTo(listView.element);
		            this._loadIcon = $(LOAD_ICON).appendTo(this.element);
		        },
	
		        enable: function() {
		            this.element.show();
		            this.height = outerHeight(this.element, true);
		        },
	
		        disable: function() {
		            this.element.hide();
		            this.height = 0;
		        },
	
		        below: function(item) {
		            if (item) {
		                this.top = item.bottom;
		                this.bottom = this.height + this.top;
		                putAt(this.element, this.top);
		            }
		        }
		    });
	
		    var VirtualListViewPressToLoadMore = VirtualListViewLoadingIndicator.extend({
		        init: function(listView, buffer) {
	
		            this._loadIcon = $(LOAD_ICON).hide();
		            this._loadButton = $('<a class="km-load">' + listView.options.messages.loadMoreText + '</a>').hide();
		            this.element = $('<li class="km-load-more" style="display: none"></li>').append(this._loadIcon).append(this._loadButton).appendTo(listView.element);
	
		            var loadMore = this;
	
		            this._loadButton.kendoMobileButton().data("kendoMobileButton").bind("click", function() {
		                loadMore._hideShowButton();
		                buffer.next();
		            });
	
		            buffer.bind("resize", function() {
		                loadMore._showLoadButton();
		            });
	
		            this.height = outerHeight(this.element, true);
		            this.disable();
		        },
	
		        _hideShowButton: function() {
		            this._loadButton.hide();
		            this.element.addClass("km-scroller-refresh");
		            this._loadIcon.css('display', 'block');
		        },
	
		        _showLoadButton: function() {
		            this._loadButton.show();
		            this.element.removeClass("km-scroller-refresh");
		            this._loadIcon.hide();
		        }
		    });
	
		    var VirtualListViewItemBinder = kendo.Class.extend({
		        init: function(listView) {
		            var binder = this;
	
		            this.chromeHeight = outerHeight(listView.wrapper.children().not(listView.element));
		            this.listView = listView;
		            this.scroller = listView.scroller();
		            this.options = listView.options;
	
		            listView.bind("_dataSource", function(e) {
		                binder.setDataSource(e.dataSource, e.empty);
		            });
	
		            listView.bind("resize", function() {
		                if (!binder.list.items.length) {
		                    return;
		                }
	
		                binder.scroller.reset();
		                binder.buffer.range(0);
		                binder.list.refresh();
		            });
	
		            this.scroller.makeVirtual();
	
		            this._scroll = function(e) {
		                binder.list.update(e.scrollTop);
		            };
		            this.scroller.bind('scroll', this._scroll);
		            this._scrollEnd = function(e) {
		                binder.list.batchUpdate(e.scrollTop);
		            };
		            this.scroller.bind('scrollEnd', this._scrollEnd);
		        },
	
		        destroy: function() {
		            this.list.unbind();
		            this.buffer.unbind();
		            this.scroller.unbind('scroll', this._scroll);
		            this.scroller.unbind('scrollEnd', this._scrollEnd);
		        },
	
		        setDataSource: function(dataSource, empty) {
		            var binder = this,
		                options = this.options,
		                listView = this.listView,
		                scroller = listView.scroller(),
		                pressToLoadMore = options.loadMore,
		                pageSize,
		                buffer,
		                footer;
	
		            this.dataSource = dataSource;
	
		            pageSize = dataSource.pageSize() || options.virtualViewSize;
	
		            if (!pageSize && !empty) {
		                throw new Error("the DataSource does not have page size configured. Page Size setting is mandatory for the mobile listview virtual scrolling to work as expected.");
		            }
	
		            if (this.buffer) {
		                this.buffer.destroy();
		            }
	
		            buffer = new kendo.data.Buffer(dataSource, Math.floor(pageSize / 2), pressToLoadMore);
	
		            if (pressToLoadMore) {
		                footer = new VirtualListViewPressToLoadMore(listView, buffer);
		            } else {
		                footer = new VirtualListViewLoadingIndicator(listView);
		            }
	
		            if (this.list) {
		                this.list.destroy();
		            }
	
		            var list = new VirtualList({
		                buffer: buffer,
		                footer: footer,
		                item: function(dataItem) { return new VirtualListViewItem(listView, dataItem); },
		                height: function() { return scroller.height(); }
		            });
	
		            list.bind("resize", function() {
		                binder.updateScrollerSize();
		                listView.updateSize();
		            });
	
		            list.bind("reset", function() {
		                binder.footer.enable();
		            });
	
		            list.bind("endReached", function() {
		                footer.disable();
		                binder.updateScrollerSize();
		            });
	
		            buffer.bind("expand", function() {
		                list.lastDirection = false; // expand down
		                list.batchUpdate(scroller.scrollTop);
		            });
	
		            $.extend(this, {
		                buffer: buffer,
		                scroller: scroller,
		                list: list,
		                footer: footer
		            });
		        },
	
		        updateScrollerSize: function() {
		            this.scroller.virtualSize(0, this.list.totalHeight() + this.chromeHeight);
		        },
	
		        refresh: function() {
		            this.list.refresh();
		        },
	
		        reset: function() {
		            this.buffer.range(0);
		            this.list.refresh();
		        }
		    });
	
		    var ListViewItemBinder = kendo.Class.extend({
		        init: function(listView) {
		            var binder = this;
		            this.listView = listView;
		            this.options = listView.options;
	
		            var itemBinder = this;
	
		            this._refreshHandler = function(e) {
		                itemBinder.refresh(e);
		            };
	
		            this._progressHandler = function() {
		                listView.showLoading();
		            };
	
		            listView.bind("_dataSource", function(e) {
		                binder.setDataSource(e.dataSource);
		            });
		        },
	
		        destroy: function() {
		            this._unbindDataSource();
		        },
	
		        reset: function() { },
	
		        refresh: function(e) {
		            var action = e && e.action,
		                dataItems = e && e.items,
		                listView = this.listView,
		                dataSource = this.dataSource,
		                prependOnRefresh = this.options.appendOnRefresh,
		                view = dataSource.view(),
		                groups = dataSource.group(),
		                groupedMode = groups && groups[0],
		                item;
	
	
		            if (action === "itemchange") {
		                if(!listView._hasBindingTarget()) {
		                    item = listView.findByDataItem(dataItems)[0];
		                    if (item) {
		                        listView.setDataItem(item, dataItems[0]);
		                    }
		                }
		                return;
		            }
	
		            var removedItems, addedItems, addedDataItems;
		            var adding = (action === "add" && !groupedMode) || (prependOnRefresh && !listView._filter);
		            var removing = action === "remove" && !groupedMode;
	
		            if (adding) {
		                // no need to unbind anything
		                removedItems = [];
		            } else if (removing) {
		                // unbind the items about to be removed;
		                removedItems = listView.findByDataItem(dataItems);
		            }
	
		            if (listView.trigger(DATABINDING, { action: action || "rebind", items: dataItems, removedItems: removedItems, index: e && e.index })) {
		                if (this._shouldShowLoading()) {
		                    listView.hideLoading();
		                }
		                return;
		            }
	
		            if (action === "add" && !groupedMode) {
		                var index = view.indexOf(dataItems[0]);
		                if (index > -1) {
		                    addedItems = listView.insertAt(dataItems, index);
		                    addedDataItems = dataItems;
		                }
		            } else if (action === "remove" && !groupedMode) {
		                addedItems = [];
		                listView.remove(dataItems);
		            } else if (groupedMode) {
		                listView.replaceGrouped(view);
		            }
		            else if (prependOnRefresh && !listView._filter) {
		                addedItems = listView.prepend(view);
		                addedDataItems = view;
		            }
		            else {
		                listView.replace(view);
		            }
	
		            if (this._shouldShowLoading()) {
		                listView.hideLoading();
		            }
	
		            listView.trigger(DATABOUND, { ns: ui, addedItems: addedItems, addedDataItems: addedDataItems });
		        },
	
		        setDataSource: function(dataSource) {
		            if (this.dataSource) {
		                this._unbindDataSource();
		            }
	
		            this.dataSource = dataSource;
		            dataSource.bind(CHANGE, this._refreshHandler);
	
		            if (this._shouldShowLoading()) {
		                this.dataSource.bind(PROGRESS, this._progressHandler);
		            }
		        },
	
		        _unbindDataSource: function() {
		            this.dataSource.unbind(CHANGE, this._refreshHandler).unbind(PROGRESS, this._progressHandler);
		        },
	
		        _shouldShowLoading: function() {
		            var options = this.options;
		            return !options.pullToRefresh && !options.loadMore && !options.endlessScroll;
		        }
		    });
	
		    var ListViewFilter = kendo.Class.extend({
		        init: function(listView) {
		            var filter = this,
		                filterable = listView.options.filterable,
		                events = "change paste",
		                that = this;
	
		            this.listView = listView;
		            this.options = filterable;
	
		            listView.element.before(SEARCH_TEMPLATE({ placeholder: filterable.placeholder || "Search..." }));
	
		            if (filterable.autoFilter !== false) {
		                events += " keyup";
		            }
	
		            this.element = listView.wrapper.find(".km-search-form");
	
		            this.searchInput = listView.wrapper.find("input[type=search]")
		                .closest("form").on("submit" + NS, function(e) {
		                    e.preventDefault();
		                })
		                .end()
		                .on("focus" + NS, function() {
		                    filter._oldFilter = filter.searchInput.val();
		                })
		                .on(events.split(" ").join(NS + " ") + NS, proxy(this._filterChange, this));
	
		            this.clearButton = listView.wrapper.find(".km-filter-reset")
		                .on(CLICK, proxy(this, "_clearFilter"))
		                .hide();
	
		             this._dataSourceChange = $.proxy(this._refreshInput, this);
		             listView.bind("_dataSource", function(e) {
		                 e.dataSource.bind("change", that._dataSourceChange);
		             });
		        },
	
		        _refreshInput: function() {
		            var appliedFilters = this.listView.dataSource.filter();
		            var searchInput = this.listView._filter.searchInput;
	
		            if (!appliedFilters || appliedFilters.filters[0].field !== this.listView.options.filterable.field)  {
		                searchInput.val("");
		            } else {
		                searchInput.val(appliedFilters.filters[0].value);
		            }
		        },
	
		        _search: function(expr) {
		            this._filter = true;
		            this.clearButton[expr ? "show" : "hide"]();
		            this.listView.dataSource.filter(expr);
		        },
	
		        _filterChange: function(e) {
		            var filter = this;
		            if (e.type == "paste" && this.options.autoFilter !== false) {
		                setTimeout(function() {
		                    filter._applyFilter();
		                }, 1);
		            } else {
		                this._applyFilter();
		            }
		        },
	
		        _applyFilter: function() {
		            var options = this.options,
		                value = this.searchInput.val(),
		                expr = value.length ? {
		                    field: options.field,
		                    operator: options.operator || "startswith",
		                    ignoreCase: options.ignoreCase,
		                    value: value
		                } : null;
	
		            if (value === this._oldFilter) {
		                return;
		            }
	
		            this._oldFilter = value;
		            this._search(expr);
		        },
	
		        _clearFilter: function(e) {
		            this.searchInput.val("");
		            this._search(null);
	
		            e.preventDefault();
		        }
		    });
	
		    var ListView = Widget.extend({
		        init: function(element, options) {
		            var listView = this;
	
		            Widget.fn.init.call(this, element, options);
	
		            element = this.element;
	
		            options = this.options;
	
		            // support for legacy typo in configuration options: scrollTreshold -> scrollThreshold.
		            if (options.scrollTreshold) {
		                options.scrollThreshold = options.scrollTreshold;
		            }
	
		            element
		                .on("down", HIGHLIGHT_SELECTOR, "_highlight")
		                .on("move up cancel", HIGHLIGHT_SELECTOR, "_dim");
	
		            this._userEvents = new kendo.UserEvents(element, {
		                fastTap: true,
		                filter: ITEM_SELECTOR,
		                allowSelection: true,
		                tap: function(e) {
		                    listView._click(e);
		                }
		            });
	
		            // HACK!!! to negate the ms touch action from the user events.
		            element.css("-ms-touch-action", "auto");
	
		            element.wrap(WRAPPER);
	
		            this.wrapper = this.element.parent();
	
		            this._headerFixer = new HeaderFixer(this);
	
		            this._itemsCache = {};
		            this._templates();
	
		            this.virtual = options.endlessScroll || options.loadMore;
	
		            this._style();
	
		            if (this.options.$angular && (this.virtual || this.options.pullToRefresh)) {
		                setTimeout($.proxy(this, "_start"));
		            } else {
		                this._start();
		            }
	
		        },
	
		        _start: function() {
		            var options = this.options;
	
		            if (this.options.filterable) {
		                this._filter = new ListViewFilter(this);
		            }
	
		            if (this.virtual) {
		                this._itemBinder = new VirtualListViewItemBinder(this);
		            } else {
		                this._itemBinder = new ListViewItemBinder(this);
		            }
	
		            if (this.options.pullToRefresh) {
		                this._pullToRefreshHandler = new RefreshHandler(this);
		            }
	
		            this.setDataSource(options.dataSource);
	
		            this._enhanceItems(this.items());
	
		            kendo.notify(this, ui);
		        },
	
		        events: [
		            CLICK,
		            DATABINDING,
		            DATABOUND,
		            ITEM_CHANGE
		        ],
	
		        options: {
		            name: "ListView",
		            style: "",
		            type: "flat",
		            autoBind: true,
		            fixedHeaders: false,
		            template: "#:data#",
		            headerTemplate: '<span class="km-text">#:value#</span>',
		            appendOnRefresh: false,
		            loadMore: false,
		            endlessScroll: false,
		            scrollThreshold: 30,
		            pullToRefresh: false,
		            messages: {
		                loadMoreText: "Press to load more",
		                pullTemplate: "Pull to refresh",
		                releaseTemplate: "Release to refresh",
		                refreshTemplate: "Refreshing"
		            },
		            pullOffset: 140,
		            filterable: false,
		            virtualViewSize: null
		        },
	
		        refresh: function() {
		            this._itemBinder.refresh();
		        },
	
		        reset: function() {
		            this._itemBinder.reset();
		        },
	
		        setDataSource: function(dataSource) {
		            // the listView should have a ready datasource for MVVM to function properly. But an empty datasource should not empty the element
		            var emptyDataSource = !dataSource;
		            this.dataSource = DataSource.create(dataSource);
	
		            this.trigger("_dataSource", { dataSource: this.dataSource, empty: emptyDataSource });
	
		            if (this.options.autoBind && !emptyDataSource) {
		                this.items().remove();
		                this.dataSource.fetch();
		            }
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            kendo.destroy(this.element);
		            this._userEvents.destroy();
		            if (this._itemBinder) {
		                this._itemBinder.destroy();
		            }
	
		            if(this._headerFixer) {
		                this._headerFixer.destroy();
		            }
	
		            this.element.unwrap();
		            delete this.element;
		            delete this.wrapper;
		            delete this._userEvents;
		        },
	
		        items: function() {
		            if (this.options.type === "group") {
		                return this.element.find(".km-list").children();
		            } else {
		                return this.element.children().not('.km-load-more');
		            }
		        },
	
		        scroller: function() {
		            if (!this._scrollerInstance) {
		                this._scrollerInstance = this.element.closest(".km-scroll-wrapper").data("kendoMobileScroller");
		            }
	
		            return this._scrollerInstance;
		        },
	
		        showLoading: function() {
		            var view = this.view();
		            if (view && view.loader) {
		                view.loader.show();
		            }
		        },
	
		        hideLoading: function() {
		            var view = this.view();
		            if (view && view.loader) {
		                view.loader.hide();
		            }
		        },
	
		        insertAt: function(dataItems, index, triggerChange) {
		            var listView = this;
		            return listView._renderItems(dataItems, function(items) {
		                if (index === 0) {
		                    listView.element.prepend(items);
		                }
		                else if (index === -1) {
		                    listView.element.append(items);
		                } else {
		                    listView.items().eq(index - 1).after(items);
		                }
	
		                if (triggerChange) {
		                    for (var i = 0; i < items.length; i ++) {
		                        listView.trigger(ITEM_CHANGE, { item: items.eq(i), data: dataItems[i], ns: ui });
		                    }
		                }
		            });
		        },
	
		        append: function(dataItems, triggerChange) {
		            return this.insertAt(dataItems, -1, triggerChange);
		        },
	
		        prepend: function(dataItems, triggerChange) {
		            return this.insertAt(dataItems, 0, triggerChange);
		        },
	
		        replace: function(dataItems) {
		            this.options.type = "flat";
		            this._angularItems("cleanup");
		            kendo.destroy(this.element.children());
		            this.element.empty();
		            this._userEvents.cancel();
		            this._style();
		            return this.insertAt(dataItems, 0);
		        },
	
		        replaceGrouped: function(groups) {
		            this.options.type = "group";
		            this._angularItems("cleanup");
		            this.element.empty();
		            var items = $(kendo.render(this.groupTemplate, groups));
	
		            this._enhanceItems(items.children("ul").children("li"));
		            this.element.append(items);
		            mobile.init(items);
		            this._style();
		            this._angularItems("compile");
		        },
	
		        remove: function(dataItems) {
		            var items = this.findByDataItem(dataItems);
		            this.angular("cleanup", function(){
		                return { elements: items };
		            });
		            kendo.destroy(items);
		            items.remove();
		        },
	
		        findByDataItem: function(dataItems) {
		            var selectors = [];
	
		            for (var idx = 0, length = dataItems.length; idx < length; idx ++) {
		                selectors[idx] = "[data-" + kendo.ns + "uid=" + dataItems[idx].uid + "]";
		            }
	
		            return this.element.find(selectors.join(","));
		        },
	
		        // item is a DOM element, not jQuery object.
		        setDataItem: function(item, dataItem) {
		            var listView = this,
		                replaceItem = function(items) {
		                    var newItem = $(items[0]);
		                    kendo.destroy(item);
		                    listView.angular("cleanup", function(){ return { elements: [ $(item) ] }; });
		                    $(item).replaceWith(newItem);
		                    listView.trigger(ITEM_CHANGE, { item: newItem, data: dataItem, ns: ui });
		                };
	
		            return this._renderItems([dataItem], replaceItem)[0];
		        },
	
		        updateSize: function() {
		            this._size = this.getSize();
		        },
	
		        _renderItems: function(dataItems, callback) {
		            var items = $(kendo.render(this.template, dataItems));
	
		            callback(items);
	
		            this.angular("compile", function() {
		                return {
		                    elements: items,
		                    data: dataItems.map(function(data){
		                        return { dataItem: data };
		                    })
		                };
		            });
	
		            mobile.init(items);
		            this._enhanceItems(items);
	
		            return items;
		        },
	
		        _dim: function(e) {
		            this._toggle(e, false);
		        },
	
		        _highlight: function(e) {
		            this._toggle(e, true);
		        },
	
		        _toggle: function(e, highlight) {
		            if (e.which > 1) {
		                return;
		            }
	
		            var clicked = $(e.currentTarget),
		                item = clicked.parent(),
		                role = attrValue(clicked, "role") || "",
		                plainItem = (!role.match(buttonRegExp)),
		                prevented = e.isDefaultPrevented();
	
		            if (plainItem) {
		                item.toggleClass(ACTIVE_CLASS, highlight && !prevented);
		            }
		        },
	
		        _templates: function() {
		            var template = this.options.template,
		                headerTemplate = this.options.headerTemplate,
		                dataIDAttribute = ' data-uid="#=arguments[0].uid || ""#"',
		                templateProxy = {},
		                groupTemplateProxy = {};
	
		            if (typeof template === FUNCTION) {
		                templateProxy.template = template;
		                template = "#=this.template(data)#";
		            }
	
		            this.template = proxy(kendo.template("<li" + dataIDAttribute + ">" + template + "</li>"), templateProxy);
	
		            groupTemplateProxy.template = this.template;
	
		            if (typeof headerTemplate === FUNCTION) {
		                groupTemplateProxy._headerTemplate = headerTemplate;
		                headerTemplate = "#=this._headerTemplate(data)#";
		            }
	
		            groupTemplateProxy.headerTemplate = kendo.template(headerTemplate);
	
		            this.groupTemplate = proxy(GROUP_TEMPLATE, groupTemplateProxy);
		        },
	
		        _click: function(e) {
		            if (e.event.which > 1 || e.event.isDefaultPrevented()) {
		                return;
		            }
	
		            var dataItem,
		                item = e.target,
		                target = $(e.event.target),
		                buttonElement = target.closest(kendo.roleSelector("button", "detailbutton", "backbutton")),
		                button = kendo.widgetInstance(buttonElement, ui),
		                id = item.attr(kendo.attr("uid"));
	
		            if (id) {
		                dataItem = this.dataSource.getByUid(id);
		            }
	
		            if (this.trigger(CLICK, {target: target, item: item, dataItem: dataItem, button: button})) {
		                e.preventDefault();
		            }
		        },
	
		        _styleGroups: function() {
		            var rootItems = this.element.children();
	
		            rootItems.children("ul").addClass("km-list");
	
		            rootItems.each(function() {
		                var li = $(this),
		                    groupHeader = li.contents().first();
	
		                li.addClass("km-group-container");
		                if (!groupHeader.is("ul") && !groupHeader.is("div." + GROUP_CLASS)) {
		                    groupHeader.wrap(GROUP_WRAPPER);
		                }
		            });
		        },
	
		        _style: function() {
		            var options = this.options,
		                grouped = options.type === "group",
		                element = this.element,
		                inset = options.style === "inset";
	
		            element.addClass("km-listview")
		                .toggleClass("km-list", !grouped)
		                .toggleClass("km-virtual-list", this.virtual)
		                .toggleClass("km-listinset", !grouped && inset)
		                .toggleClass("km-listgroup", grouped && !inset)
		                .toggleClass("km-listgroupinset", grouped && inset);
	
		            if (!element.parents(".km-listview")[0]) {
		                element.closest(".km-content").toggleClass("km-insetcontent", inset); // iOS has white background when the list is not inset.
		            }
	
		            if (grouped) {
		                this._styleGroups();
		            }
	
		            this.trigger(STYLED);
		        },
	
		        _enhanceItems: function(items) {
		            items.each(function() {
		                var item = $(this),
		                    child,
		                    enhanced = false;
	
		                item.children().each(function() {
		                    child = $(this);
		                    if (child.is("a")) {
		                        enhanceLinkItem(child);
		                        enhanced = true;
		                    } else if (child.is("label")) {
		                        enhanceCheckBoxItem(child);
		                        enhanced = true;
		                    }
		                });
	
		                if (!enhanced) {
		                    enhanceItem(item);
		                }
		            });
		        }
		    });
	
		    ui.plugin(ListView);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1243);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1243:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.navbar",
		    name: "NavBar",
		    category: "mobile",
		    description: "The Kendo mobile NavBar widget is used inside a mobile View or Layout Header element to display an application navigation bar.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        ui = mobile.ui,
		        Widget = ui.Widget;
	
		    function createContainer(align, element) {
		        var items = element.find("[" + kendo.attr("align") + "=" + align + "]");
	
		        if (items[0]) {
		            return $('<div class="km-' + align + 'item" />').append(items).prependTo(element);
		        }
		    }
	
		    function toggleTitle(centerElement) {
		        var siblings = centerElement.siblings(),
		            noTitle = !!centerElement.children("ul")[0],
		            showTitle = (!!siblings[0] && $.trim(centerElement.text()) === ""),
		            android = !!(kendo.mobile.application && kendo.mobile.application.element.is(".km-android"));
	
		        centerElement.prevAll().toggleClass("km-absolute", noTitle);
		        centerElement.toggleClass("km-show-title", showTitle);
		        centerElement.toggleClass("km-fill-title", showTitle && !$.trim(centerElement.html()));
		        centerElement.toggleClass("km-no-title", noTitle);
		        centerElement.toggleClass("km-hide-title", android && !siblings.children().is(":visible"));
		    }
	
		    var NavBar = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            element = that.element;
	
		            that.container().bind("show", $.proxy(this, "refresh"));
	
		            element.addClass("km-navbar").wrapInner($('<div class="km-view-title km-show-title" />'));
		            that.leftElement = createContainer("left", element);
		            that.rightElement = createContainer("right", element);
		            that.centerElement = element.find(".km-view-title");
		        },
	
		        options: {
		            name: "NavBar"
		        },
	
		        title: function(value) {
		            this.element.find(kendo.roleSelector("view-title")).text(value);
		            toggleTitle(this.centerElement);
		        },
	
		        refresh: function(e) {
		            var view = e.view;
		            this.title(view.options.title);
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            kendo.destroy(this.element);
		        }
		    });
	
		    ui.plugin(NavBar);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1247);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1013:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1059:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(568);
	
	/***/ }),
	
	/***/ 1247:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1054), __webpack_require__(1013), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.scrollview",
		    name: "ScrollView",
		    category: "mobile",
		    description: "The Kendo Mobile ScrollView widget is used to scroll content wider than the device screen.",
		    depends: [ "fx", "data", "draganddrop" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        mobile = kendo.mobile,
		        ui = mobile.ui,
		        proxy = $.proxy,
		        Transition = kendo.effects.Transition,
		        Pane = kendo.ui.Pane,
		        PaneDimensions = kendo.ui.PaneDimensions,
		        Widget = ui.DataBoundWidget,
		        DataSource = kendo.data.DataSource,
		        Buffer = kendo.data.Buffer,
		        BatchBuffer = kendo.data.BatchBuffer,
	
		        // Math
		        math = Math,
		        abs  = math.abs,
		        ceil = math.ceil,
		        round = math.round,
		        max = math.max,
		        min = math.min,
		        floor = math.floor,
	
		        CHANGE = "change",
		        CHANGING = "changing",
		        REFRESH = "refresh",
		        CURRENT_PAGE_CLASS = "current-page",
		        VIRTUAL_PAGE_CLASS = "virtual-page",
		        FUNCTION = "function",
		        ITEM_CHANGE = "itemChange",
		        CLEANUP = "cleanup",
	
		        VIRTUAL_PAGE_COUNT = 3,
		        LEFT_PAGE = -1,
		        CETER_PAGE = 0,
		        RIGHT_PAGE = 1,
	
		        LEFT_SWIPE = -1,
		        NUDGE = 0,
		        RIGHT_SWIPE = 1;
	
		    function className(name) {
		        return "k-" + name + " km-" + name;
		    }
	
		    var Pager = kendo.Class.extend({
		        init: function(scrollView) {
		            var that = this,
		                element = $("<ol class='" + className("pages") + "'/>");
	
		            scrollView.element.append(element);
	
		            this._changeProxy = proxy(that, "_change");
		            this._refreshProxy = proxy(that, "_refresh");
		            scrollView.bind(CHANGE, this._changeProxy);
		            scrollView.bind(REFRESH, this._refreshProxy);
	
		            $.extend(that, { element: element, scrollView: scrollView });
		        },
	
		        items: function() {
		            return this.element.children();
		        },
	
		        _refresh: function(e) {
		            var pageHTML = "";
	
		            for (var idx = 0; idx < e.pageCount; idx ++) {
		                pageHTML += "<li/>";
		            }
	
		            this.element.html(pageHTML);
		            this.items().eq(e.page).addClass(className(CURRENT_PAGE_CLASS));
		        },
	
		        _change: function(e) {
		            this.items()
		                .removeClass(className(CURRENT_PAGE_CLASS))
		                .eq(e.page).addClass(className(CURRENT_PAGE_CLASS));
		        },
	
		        destroy: function() {
		            this.scrollView.unbind(CHANGE, this._changeProxy);
		            this.scrollView.unbind(REFRESH, this._refreshProxy);
		            this.element.remove();
		        }
		    });
	
		    kendo.mobile.ui.ScrollViewPager = Pager;
	
		    var TRANSITION_END = "transitionEnd",
		        DRAG_START = "dragStart",
		        DRAG_END = "dragEnd";
	
		    var ElasticPane = kendo.Observable.extend({
		        init: function(element, options) {
		            var that = this;
	
		            kendo.Observable.fn.init.call(this);
	
		            this.element = element;
		            this.container = element.parent();
	
		            var movable,
		                transition,
		                userEvents,
		                dimensions,
		                dimension,
		                pane;
	
		            movable = new kendo.ui.Movable(that.element);
	
		            transition = new Transition({
		                axis: "x",
		                movable: movable,
		                onEnd: function() {
		                    that.trigger(TRANSITION_END);
		                }
		            });
	
		            userEvents = new kendo.UserEvents(element, {
		                fastTap: true,
		                start: function(e) {
		                    if (abs(e.x.velocity) * 2 >= abs(e.y.velocity)) {
		                        userEvents.capture();
		                    } else {
		                        userEvents.cancel();
		                    }
	
		                    that.trigger(DRAG_START, e);
		                    transition.cancel();
		                },
		                allowSelection: true,
		                end: function(e) {
		                    that.trigger(DRAG_END, e);
		                }
		            });
	
		            dimensions = new PaneDimensions({
		                element: that.element,
		                container: that.container
		            });
	
		            dimension = dimensions.x;
	
		            dimension.bind(CHANGE, function() {
		                that.trigger(CHANGE);
		            });
	
		            pane = new Pane({
		                dimensions: dimensions,
		                userEvents: userEvents,
		                movable: movable,
		                elastic: true
		            });
	
		            $.extend(that, {
		                duration: options && options.duration || 1,
		                movable: movable,
		                transition: transition,
		                userEvents: userEvents,
		                dimensions: dimensions,
		                dimension: dimension,
		                pane: pane
		            });
	
		            this.bind([TRANSITION_END, DRAG_START, DRAG_END, CHANGE], options);
		        },
	
		        size: function() {
		            return { width: this.dimensions.x.getSize(), height: this.dimensions.y.getSize() };
		        },
	
		        total: function() {
		            return this.dimension.getTotal();
		        },
	
		        offset: function() {
		            return -this.movable.x;
		        },
	
		        updateDimension: function() {
		            this.dimension.update(true);
		        },
	
		        refresh: function() {
		            this.dimensions.refresh();
		        },
	
		        moveTo: function(offset) {
		            this.movable.moveAxis("x", -offset);
		        },
	
		        transitionTo: function(offset, ease, instant) {
		            if (instant) {
		                this.moveTo(-offset);
		            } else {
		                this.transition.moveTo({ location: offset, duration: this.duration, ease: ease });
		            }
		        }
		    });
	
		    kendo.mobile.ui.ScrollViewElasticPane = ElasticPane;
	
		    var ScrollViewContent = kendo.Observable.extend({
		        init: function(element, pane, options) {
		            var that = this;
	
		            kendo.Observable.fn.init.call(this);
		            that.element = element;
		            that.pane = pane;
		            that._getPages();
		            this.page = 0;
		            this.pageSize = options.pageSize || 1;
		            this.contentHeight = options.contentHeight;
		            this.enablePager = options.enablePager;
		            this.pagerOverlay = options.pagerOverlay;
		        },
	
		        scrollTo: function(page, instant) {
		            this.page = page;
		            this.pane.transitionTo(- page * this.pane.size().width, Transition.easeOutExpo, instant);
		        },
	
		        paneMoved: function(swipeType, bounce, callback, /*internal*/ instant) {
		            var that = this,
		                pane = that.pane,
		                width = pane.size().width * that.pageSize,
		                approx = round,
		                ease = bounce ? Transition.easeOutBack : Transition.easeOutExpo,
		                snap,
		                nextPage;
	
		            if (swipeType === LEFT_SWIPE) {
		                approx = ceil;
		            } else if (swipeType === RIGHT_SWIPE) {
		                approx = floor;
		            }
	
		            nextPage = approx(pane.offset() / width);
	
		            snap = max(that.minSnap, min(-nextPage * width, that.maxSnap));
	
		            if (nextPage != that.page) {
		                if (callback && callback({ currentPage: that.page, nextPage: nextPage })) {
		                    snap = -that.page * pane.size().width;
		                }
		            }
	
		            pane.transitionTo(snap, ease, instant);
		        },
	
		        updatePage: function() {
		            var pane = this.pane,
		                page = round(pane.offset() / pane.size().width);
	
		            if (page != this.page) {
		                this.page = page;
		                return true;
		            }
	
		            return false;
		        },
	
		        forcePageUpdate: function() {
		            return this.updatePage();
		        },
	
		        resizeTo: function(size) {
		            var pane = this.pane,
		                width = size.width;
	
		            this.pageElements.width(width);
	
		            if (this.contentHeight === "100%") {
		                var containerHeight = this.element.parent().height();
	
		                if (this.enablePager === true) {
		                    var pager = this.element.parent().find("ol.km-pages");
		                    if (!this.pagerOverlay && pager.length) {
		                        containerHeight -= kendo._outerHeight(pager, true);
		                    }
		                }
	
		                this.element.css("height", containerHeight);
		                this.pageElements.css("height", containerHeight);
		            }
	
		            // re-read pane dimension after the pageElements have been resized.
		            pane.updateDimension();
	
		            if (!this._paged) {
		                this.page = floor(pane.offset() / width);
		            }
	
		            this.scrollTo(this.page, true);
	
		            this.pageCount = ceil(pane.total() / width);
		            this.minSnap = - (this.pageCount - 1) * width;
		            this.maxSnap = 0;
		        },
	
		        _getPages: function() {
		            this.pageElements = this.element.find(kendo.roleSelector("page"));
		            this._paged = this.pageElements.length > 0;
		        }
		    });
	
		    kendo.mobile.ui.ScrollViewContent = ScrollViewContent;
	
		    var VirtualScrollViewContent = kendo.Observable.extend({
		        init: function(element, pane, options) {
		            var that = this;
	
		            kendo.Observable.fn.init.call(this);
	
		            that.element = element;
		            that.pane = pane;
		            that.options = options;
		            that._templates();
		            that.page = options.page || 0;
		            that.pages = [];
		            that._initPages();
		            that.resizeTo(that.pane.size());
	
		            that.pane.dimension.forceEnabled();
		        },
	
		        setDataSource: function(dataSource) {
		            this.dataSource = DataSource.create(dataSource);
		            this._buffer();
		            this._pendingPageRefresh = false;
		            this._pendingWidgetRefresh = false;
		        },
	
		        _viewShow: function() {
		            var that = this;
		            if (that._pendingWidgetRefresh) {
		                setTimeout(function() {
		                    that._resetPages();
		                }, 0);
		                that._pendingWidgetRefresh = false;
		            }
		        },
	
		        _buffer: function() {
		            var itemsPerPage = this.options.itemsPerPage;
	
		            if (this.buffer) {
		                this.buffer.destroy();
		            }
	
		            if (itemsPerPage > 1) {
		                this.buffer = new BatchBuffer(this.dataSource, itemsPerPage);
		            } else {
		                this.buffer = new Buffer(this.dataSource, itemsPerPage * 3);
		            }
	
		            this._resizeProxy = proxy(this, "_onResize");
		            this._resetProxy = proxy(this, "_onReset");
		            this._endReachedProxy = proxy(this, "_onEndReached");
	
		            this.buffer.bind({
		                "resize": this._resizeProxy,
		                "reset": this._resetProxy,
		                "endreached": this._endReachedProxy
		            });
		        },
	
		        _templates: function() {
		            var template = this.options.template,
		                emptyTemplate = this.options.emptyTemplate,
		                templateProxy = {},
		                emptyTemplateProxy = {};
	
		            if (typeof template === FUNCTION) {
		                templateProxy.template = template;
		                template = "#=this.template(data)#";
		            }
	
		            this.template = proxy(kendo.template(template), templateProxy);
	
		            if (typeof emptyTemplate === FUNCTION) {
		                emptyTemplateProxy.emptyTemplate = emptyTemplate;
		                emptyTemplate = "#=this.emptyTemplate(data)#";
		            }
	
		            this.emptyTemplate = proxy(kendo.template(emptyTemplate), emptyTemplateProxy);
		        },
	
		        _initPages: function() {
		            var pages = this.pages,
		                element = this.element,
		                page;
	
		            for (var i = 0; i < VIRTUAL_PAGE_COUNT; i++) {
		                page = new Page(element);
		                pages.push(page);
		            }
	
		            this.pane.updateDimension();
		        },
	
		        resizeTo: function(size) {
		            var pages = this.pages,
		                pane = this.pane;
	
		            for (var i = 0; i < pages.length; i++) {
		                pages[i].setWidth(size.width);
		            }
	
		            if (this.options.contentHeight === "auto") {
		                this.element.css("height", this.pages[1].element.height());
		            }
	
		            else if (this.options.contentHeight === "100%") {
		                var containerHeight = this.element.parent().height();
	
		                if (this.options.enablePager === true) {
		                    var pager = this.element.parent().find("ol.km-pages");
		                    if (!this.options.pagerOverlay && pager.length) {
		                        containerHeight -= kendo._outerHeight(pager, true);
		                    }
		                }
	
		                this.element.css("height", containerHeight);
		                pages[0].element.css("height", containerHeight);
		                pages[1].element.css("height", containerHeight);
		                pages[2].element.css("height", containerHeight);
		            }
	
		            pane.updateDimension();
	
		            this._repositionPages();
	
		            this.width = size.width;
		        },
	
		        scrollTo: function(page) {
		            var buffer = this.buffer,
		                dataItem;
	
		            buffer.syncDataSource();
		            dataItem = buffer.at(page);
	
		            if (!dataItem) {
		                return;
		            }
	
		            this._updatePagesContent(page);
	
		            this.page = page;
		        },
	
		        paneMoved: function(swipeType, bounce, callback, /*internal*/ instant) {
		            var that = this,
		                pane = that.pane,
		                width = pane.size().width,
		                offset = pane.offset(),
		                thresholdPassed = Math.abs(offset) >= width / 3,
		                ease = bounce ? kendo.effects.Transition.easeOutBack : kendo.effects.Transition. easeOutExpo,
		                isEndReached = that.page + 2 > that.buffer.total(),
		                nextPage,
		                delta = 0;
	
		            if (swipeType === RIGHT_SWIPE) {
		                if (that.page !== 0) {
		                    delta = -1; //backward
		                }
		            } else if (swipeType === LEFT_SWIPE && !isEndReached) {
		                delta = 1; //forward
		            } else if (offset > 0 && (thresholdPassed && !isEndReached)) {
		                delta = 1; //forward
		            } else if (offset < 0 && thresholdPassed) {
		                if (that.page !== 0) {
		                    delta = -1; //backward
		                }
		            }
	
		            nextPage = that.page;
		            if (delta) {
		                nextPage = (delta > 0) ? nextPage + 1 : nextPage - 1;
		            }
	
		            if (callback && callback({ currentPage: that.page, nextPage: nextPage })) {
		                delta = 0;
		            }
	
		            if (delta === 0) {
		                that._cancelMove(ease, instant);
		            } else if (delta === -1) {
		                that._moveBackward(instant);
		            } else if (delta === 1) {
		                that._moveForward(instant);
		            }
		        },
	
		        updatePage: function() {
		            var pages = this.pages;
	
		            if (this.pane.offset() === 0) {
		                return false;
		            }
	
		            if (this.pane.offset() > 0) {
		                pages.push(this.pages.shift());//forward
		                this.page++;
		                this.setPageContent(pages[2], this.page + 1);
		            } else {
		                pages.unshift(this.pages.pop()); //back
		                this.page--;
		                this.setPageContent(pages[0], this.page - 1);
		            }
	
		            this._repositionPages();
	
		            this._resetMovable();
	
		            return true;
		        },
	
		        forcePageUpdate: function() {
		            var offset = this.pane.offset(),
		                threshold  = this.pane.size().width * 3/4;
	
		            if (abs(offset) > threshold) {
		                return this.updatePage();
		            }
	
		            return false;
		        },
	
		        _resetMovable: function() {
		            this.pane.moveTo(0);
		        },
	
		        _moveForward: function(instant) {
		            this.pane.transitionTo(-this.width, kendo.effects.Transition.easeOutExpo, instant);
		        },
	
		        _moveBackward: function(instant) {
		            this.pane.transitionTo(this.width, kendo.effects.Transition.easeOutExpo, instant);
		        },
	
		        _cancelMove: function(ease, /*internal*/ instant) {
		            this.pane.transitionTo(0, ease, instant);
		        },
	
		        _resetPages: function() {
		            this.page = this.options.page || 0;
	
		            this._updatePagesContent(this.page);
		            this._repositionPages();
	
		            this.trigger("reset");
		        },
	
		        _onResize: function() {
		            this.pageCount = ceil(this.dataSource.total() / this.options.itemsPerPage);
	
		            if (this._pendingPageRefresh) {
		                this._updatePagesContent(this.page);
		                this._pendingPageRefresh = false;
		            }
	
		            this.trigger("resize");
		        },
	
		        _onReset: function() {
		            this.pageCount = ceil(this.dataSource.total() / this.options.itemsPerPage);
		            this._resetPages();
		        },
	
		        _onEndReached: function() {
		            this._pendingPageRefresh = true;
		        },
	
		        _repositionPages: function() {
		            var pages = this.pages;
	
		            pages[0].position(LEFT_PAGE);
		            pages[1].position(CETER_PAGE);
		            pages[2].position(RIGHT_PAGE);
		        },
	
		        _updatePagesContent: function(offset) {
		            var pages = this.pages,
		                currentPage = offset || 0;
	
		            this.setPageContent(pages[0], currentPage - 1);
		            this.setPageContent(pages[1], currentPage);
		            this.setPageContent(pages[2], currentPage + 1);
		        },
	
		        setPageContent: function(page, index) {
		            var buffer = this.buffer,
		                template = this.template,
		                emptyTemplate = this.emptyTemplate,
		                view = null;
	
		            if (index >= 0) {
		                view = buffer.at(index);
		                if ($.isArray(view) && !view.length) {
		                    view = null;
		                }
		            }
	
		            this.trigger(CLEANUP, { item: page.element });
	
		            if (view !== null) {
		                page.content(template(view));
		            } else {
		                page.content(emptyTemplate({}));
		            }
	
		            kendo.mobile.init(page.element);
		            this.trigger(ITEM_CHANGE, { item: page.element, data: view, ns: kendo.mobile.ui });
	
		        }
		    });
	
		    kendo.mobile.ui.VirtualScrollViewContent = VirtualScrollViewContent;
	
		    var Page = kendo.Class.extend({
		        init: function(container) {
		            this.element = $("<div class='" + className(VIRTUAL_PAGE_CLASS) + "'></div>");
		            this.width = container.width();
		            this.element.width(this.width);
		            container.append(this.element);
		        },
	
		        content: function(theContent) {
		            this.element.html(theContent);
		        },
	
		        position: function(position) { //position can be -1, 0, 1
		            this.element.css("transform", "translate3d(" + this.width * position + "px, 0, 0)");
		        },
	
		        setWidth: function(width) {
		            this.width = width;
		            this.element.width(width);
		        }
		    });
	
		    kendo.mobile.ui.VirtualPage = Page;
	
		    var ScrollView = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
		            element = that.element;
	
		            kendo.stripWhitespace(element[0]);
	
		            element
		                .wrapInner("<div/>")
		                .addClass("k-widget " + className("scrollview"));
	
		            if (this.options.enablePager) {
		                this.pager = new Pager(this);
	
		                if (this.options.pagerOverlay) {
		                    element.addClass(className("scrollview-overlay"));
		                }
		            }
	
		            that.inner = element.children().first();
		            that.page = 0;
		            that.inner.css("height", options.contentHeight);
	
		            that.pane = new ElasticPane(that.inner, {
		                duration: this.options.duration,
		                transitionEnd: proxy(this, "_transitionEnd"),
		                dragStart: proxy(this, "_dragStart"),
		                dragEnd: proxy(this, "_dragEnd"),
		                change: proxy(this, REFRESH)
		            });
	
		            that.bind("resize", function() {
		                that.pane.refresh();
		            });
	
		            that.page = options.page;
	
		            var empty = this.inner.children().length === 0;
	
		            var content = empty ? new VirtualScrollViewContent(that.inner, that.pane, options) : new ScrollViewContent(that.inner, that.pane, options);
	
		            content.page = that.page;
	
		            content.bind("reset", function() {
		                this._pendingPageRefresh = false;
		                that._syncWithContent();
		                that.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
		            });
	
		            content.bind("resize", function() {
		                that.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
		            });
	
		            content.bind(ITEM_CHANGE, function(e) {
		                that.trigger(ITEM_CHANGE, e);
	
		                that.angular("compile", function() {
		                    return { elements: e.item, data: [ { dataItem: e.data } ] };
		                });
		            });
	
		            content.bind(CLEANUP, function(e) {
		                that.angular("cleanup", function() {
		                    return { elements: e.item };
		                });
		            });
	
		            that._content = content;
		            that.setDataSource(options.dataSource);
	
		            var mobileContainer = that.container();
	
		            if (mobileContainer.nullObject) {
		                that.viewInit();
		                that.viewShow();
		            } else {
		                mobileContainer.bind("show", proxy(this, "viewShow")).bind("init", proxy(this, "viewInit"));
		            }
		        },
	
		        options: {
		            name: "ScrollView",
		            page: 0,
		            duration: 400,
		            velocityThreshold: 0.8,
		            contentHeight: "auto",
		            pageSize: 1,
		            itemsPerPage: 1,
		            bounceVelocityThreshold: 1.6,
		            enablePager: true,
		            pagerOverlay: false,
		            autoBind: true,
		            template: "",
		            emptyTemplate: ""
		        },
	
		        events: [
		            CHANGING,
		            CHANGE,
		            REFRESH
		        ],
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            kendo.destroy(this.element);
		        },
	
		        viewInit: function() {
		            if (this.options.autoBind) {
		                this._content.scrollTo(this._content.page, true);
		            }
		        },
	
		        viewShow: function() {
		            this.pane.refresh();
		        },
	
		        refresh: function() {
		            var content = this._content;
	
		            content.resizeTo(this.pane.size());
		            this.page = content.page;
		            this.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
		        },
	
		        content: function(html) {
		           this.element.children().first().html(html);
		           this._content._getPages();
		           this.pane.refresh();
		        },
	
		        value: function(item) {
		            var dataSource = this.dataSource;
	
		            if (item) {
		                this.scrollTo(dataSource.indexOf(item), true);
		            } else {
		                return dataSource.at(this.page);
		            }
		        },
	
		        scrollTo: function(page, instant) {
		            this._content.scrollTo(page, instant);
		            this._syncWithContent();
		        },
	
		        prev: function() {
		            var that = this,
		                prevPage = that.page - 1;
	
		            if (that._content instanceof VirtualScrollViewContent) {
		                that._content.paneMoved(RIGHT_SWIPE, undefined, function(eventData) {
		                    return that.trigger(CHANGING, eventData);
		                });
		            } else if (prevPage > -1) {
		                that.scrollTo(prevPage);
		            }
		        },
	
		        next: function() {
		            var that = this,
		                nextPage = that.page + 1;
	
		            if (that._content instanceof VirtualScrollViewContent) {
		                that._content.paneMoved(LEFT_SWIPE, undefined, function(eventData) {
		                    return that.trigger(CHANGING, eventData);
		                });
		            } else if (nextPage < that._content.pageCount) {
		                that.scrollTo(nextPage);
		            }
		        },
	
		        setDataSource: function(dataSource) {
		            if (!(this._content instanceof VirtualScrollViewContent)) {
		                return;
		            }
		            // the scrollview should have a ready datasource for MVVM to function properly. But an empty datasource should not empty the element
		            var emptyDataSource = !dataSource;
		            this.dataSource = DataSource.create(dataSource);
	
		            this._content.setDataSource(this.dataSource);
	
		            if (this.options.autoBind && !emptyDataSource) {
		                // this.items().remove();
		                this.dataSource.fetch();
		            }
		        },
	
		        items: function() {
		            return this.element.find(".km-" + VIRTUAL_PAGE_CLASS);
		        },
	
		        _syncWithContent: function() {
		            var pages = this._content.pages,
		                buffer = this._content.buffer,
		                data,
		                element;
	
		            this.page = this._content.page;
	
		            data = buffer ? buffer.at(this.page) : undefined;
		            if (!(data instanceof Array)) {
		                data = [data];
		            }
		            element = pages ? pages[1].element : undefined;
	
		            this.trigger(CHANGE, { page: this.page, element: element, data: data });
		        },
	
		        _dragStart: function() {
		            if (this._content.forcePageUpdate()) {
		                this._syncWithContent();
		            }
		        },
	
		        _dragEnd: function(e) {
		            var that = this,
		                velocity = e.x.velocity,
		                velocityThreshold = this.options.velocityThreshold,
		                swipeType = NUDGE,
		                bounce = abs(velocity) > this.options.bounceVelocityThreshold;
	
		            if (velocity > velocityThreshold) {
		                swipeType = RIGHT_SWIPE;
		            } else if (velocity < -velocityThreshold) {
		                swipeType = LEFT_SWIPE;
		            }
	
		            this._content.paneMoved(swipeType, bounce, function(eventData) {
		                return that.trigger(CHANGING, eventData);
		            });
		        },
	
		        _transitionEnd: function() {
		            if (this._content.updatePage()) {
		                this._syncWithContent();
		            }
		        }
		    });
	
		    ui.plugin(ScrollView);
	
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1250);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1038:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(569);
	
	/***/ }),
	
	/***/ 1054:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(567);
	
	/***/ }),
	
	/***/ 1250:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* jshint multistr: true */
		(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1054), __webpack_require__(1038) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.switch",
		    name: "Switch",
		    category: "mobile",
		    description: "The mobile Switch widget is used to display two exclusive choices.",
		    depends: [ "fx", "userevents" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        outerWidth = kendo._outerWidth,
		        Widget = ui.Widget,
		        support = kendo.support,
		        CHANGE = "change",
		        SWITCHON = "switch-on",
		        SWITCHOFF = "switch-off",
		        MARGINLEFT = "margin-left",
		        ACTIVE_STATE = "state-active",
		        DISABLED_STATE = "state-disabled",
		        DISABLED = "disabled",
		        RESOLVEDPREFIX = support.transitions.css === undefined ? "" : support.transitions.css,
		        TRANSFORMSTYLE = RESOLVEDPREFIX + "transform",
		        proxy = $.proxy;
	
		    function className(name) {
		        return "k-" + name + " km-" + name;
		    }
	
		    function limitValue(value, minLimit, maxLimit) {
		        return Math.max(minLimit, Math.min(maxLimit, value));
		    }
	
		    var SWITCH_MARKUP = '<span class="' + className("switch") + ' ' + className("widget") + '">\
		        <span class="' + className("switch-wrapper") + '">\
		            <span class="' + className("switch-background") + '"></span>\
		        </span> \
		        <span class="' + className("switch-container") + '">\
		            <span class="' + className("switch-handle") + '"> \
		                <span class="' + className("switch-label-on") + '">{0}</span> \
		                <span class="' + className("switch-label-off") + '">{1}</span> \
		            </span> \
		        </span>\
		    </span>';
	
		    var Switch = Widget.extend({
		        init: function(element, options) {
		            var that = this, checked;
	
		            Widget.fn.init.call(that, element, options);
	
		            options = that.options;
	
		            that.wrapper = $(kendo.format(SWITCH_MARKUP, options.onLabel, options.offLabel));
		            that.handle = that.wrapper.find(".km-switch-handle");
		            that.background = that.wrapper.find(".km-switch-background");
		            that.wrapper.insertBefore(that.element).prepend(that.element);
	
		            that._drag();
	
		            that.origin = parseInt(that.background.css(MARGINLEFT), 10);
	
		            that.constrain = 0;
		            that.snapPoint = 0;
	
		            element = that.element[0];
		            element.type = "checkbox";
		            that._animateBackground = true;
	
		            checked = that.options.checked;
	
		            if (checked === null) {
		                checked = element.checked;
		            }
	
		            that.check(checked);
	
		            that.options.enable = that.options.enable && !that.element.attr(DISABLED);
		            that.enable(that.options.enable);
	
		            that.refresh();
		            kendo.notify(that, kendo.mobile.ui);
		        },
	
		        refresh: function() {
		            var that = this,
		                handleWidth = outerWidth(that.handle, true);
	
		            that.width = that.wrapper.width();
	
		            that.constrain  = that.width - handleWidth;
		            that.snapPoint = that.constrain / 2;
	
		            if (typeof that.origin != "number") {
		                that.origin = parseInt(that.background.css(MARGINLEFT), 10);
		            }
	
		            that.background.data("origin", that.origin);
	
		            that.check(that.element[0].checked);
		        },
	
		        events: [
		            CHANGE
		        ],
	
		        options: {
		            name: "Switch",
		            onLabel: "on",
		            offLabel: "off",
		            checked: null,
		            enable: true
		        },
	
		        check: function(check) {
		            var that = this,
		                element = that.element[0];
	
		            if (check === undefined) {
		                return element.checked;
		            }
	
		            that._position(check ? that.constrain : 0);
		            element.checked = check;
		            that.wrapper
		                .toggleClass(className(SWITCHON), check)
		                .toggleClass(className(SWITCHOFF), !check);
		        },
	
		        // alias for check, NG support
		        value: function() {
		            return this.check.apply(this, arguments);
		        },
	
		        destroy: function() {
		            Widget.fn.destroy.call(this);
		            this.userEvents.destroy();
		        },
	
		        toggle: function() {
		            var that = this;
	
		            that.check(!that.element[0].checked);
		        },
	
		        enable: function(enable) {
		            var element = this.element,
		                wrapper = this.wrapper;
	
		            if(typeof enable == "undefined") {
		                enable = true;
		            }
	
		            this.options.enable = enable;
	
		            if(enable) {
		                element.removeAttr(DISABLED);
		            } else {
		                element.attr(DISABLED, DISABLED);
		            }
	
		            wrapper.toggleClass(className(DISABLED_STATE), !enable);
		        },
	
		        _resize: function() {
		            this.refresh();
		        },
	
		        _move: function(e) {
		            var that = this;
		            e.preventDefault();
		            that._position(limitValue(that.position + e.x.delta, 0, that.width - outerWidth(that.handle, true)));
		        },
	
		        _position: function(position) {
		            var that = this;
	
		            that.position = position;
		            that.handle.css(TRANSFORMSTYLE, "translatex(" + position + "px)");
	
		            if (that._animateBackground) {
		                that.background.css(MARGINLEFT, that.origin + position);
		            }
		        },
	
		        _start: function() {
		            if(!this.options.enable) {
		                this.userEvents.cancel();
		            } else {
		                this.userEvents.capture();
		                this.handle.addClass(className(ACTIVE_STATE));
		            }
		        },
	
		        _stop: function() {
		            var that = this;
	
		            that.handle.removeClass(className(ACTIVE_STATE));
		            that._toggle(that.position > that.snapPoint);
		        },
	
		        _toggle: function (checked) {
		            var that = this,
		                handle = that.handle,
		                element = that.element[0],
		                value = element.checked,
		                duration = kendo.mobile.application && kendo.mobile.application.os.wp ? 100 : 200,
		                distance;
	
		            that.wrapper
		                .toggleClass(className(SWITCHON), checked)
		                .toggleClass(className(SWITCHOFF), !checked);
	
		            that.position = distance = checked * that.constrain;
	
		            if (that._animateBackground) {
		                that.background
		                    .kendoStop(true, true)
		                    .kendoAnimate({ effects: "slideMargin", offset: distance, reset: true, reverse: !checked, axis: "left", duration: duration });
		            }
	
		            handle
		                .kendoStop(true, true)
		                .kendoAnimate({
		                    effects: "slideTo",
		                    duration: duration,
		                    offset: distance + "px,0",
		                    reset: true,
		                    complete: function () {
		                        if (value !== checked) {
		                            element.checked = checked;
		                            that.trigger(CHANGE, { checked: checked });
		                        }
		                    }
		                });
		        },
	
		        _drag: function() {
		            var that = this;
	
		            that.userEvents = new kendo.UserEvents(that.wrapper, {
		                fastTap: true,
		                tap: function() {
		                    if(that.options.enable) {
		                        that._toggle(!that.element[0].checked);
		                    }
		                },
		                start: proxy(that._start, that),
		                move: proxy(that._move, that),
		                end: proxy(that._stop, that)
		            });
		        }
		    });
	
		    ui.plugin(Switch);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1251);
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ }),
	
	/***/ 1004:
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(552);
	
	/***/ }),
	
	/***/ 1251:
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1004) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		})(function(){
	
		var __meta__ = { // jshint ignore:line
		    id: "mobile.tabstrip",
		    name: "TabStrip",
		    category: "mobile",
		    description: "The mobile TabStrip widget is used inside a mobile view or layout footer element to display an application-wide group of navigation buttons.",
		    depends: [ "core" ]
		};
	
		(function($, undefined) {
		    var kendo = window.kendo,
		        ui = kendo.mobile.ui,
		        Widget = ui.Widget,
		        ACTIVE_STATE_CLASS = "km-state-active",
		        SELECT = "select";
	
		    function createBadge(value) {
		        return $('<span class="km-badge">' + value + '</span>');
		    }
	
		    var TabStrip = Widget.extend({
		        init: function(element, options) {
		            var that = this;
	
		            Widget.fn.init.call(that, element, options);
		            that.container().bind("show", $.proxy(this, "refresh"));
	
		            that.element
		               .addClass("km-tabstrip")
		               .find("a").each(that._buildButton)
		               .eq(that.options.selectedIndex).addClass(ACTIVE_STATE_CLASS);
	
		            that.element.on("down", "a", "_release");
		        },
	
		        events: [
		            SELECT
		        ],
	
		        switchTo: function(url) {
		            var tabs = this.element.find('a'),
		                tab,
		                path,
		                idx = 0,
		                length = tabs.length;
	
		            if(isNaN(url)) {
		                for (; idx < length; idx ++) {
		                    tab = tabs[idx];
		                    path = tab.href.replace(/(\#.+)(\?.+)$/, "$1"); // remove the fragment query string - http://www.foo.com?foo#bar**?baz=qux**
	
		                    if (path.indexOf(url, path.length - url.length) !== -1) {
		                        this._setActiveItem($(tab));
		                        return true;
		                    }
		                }
		            } else {
		                this._setActiveItem(tabs.eq(url));
		                return true;
		            }
	
		            return false;
		        },
	
		        switchByFullUrl: function(url) {
		            var tab;
	
		            tab = this.element.find("a[href$='" + url + "']");
		            this._setActiveItem(tab);
		        },
	
		        clear: function() {
		            this.currentItem().removeClass(ACTIVE_STATE_CLASS);
		        },
	
		        currentItem: function() {
		            return this.element.children("." + ACTIVE_STATE_CLASS);
		        },
	
		        badge: function(item, value) {
		            var tabstrip = this.element, badge;
	
		            if (!isNaN(item)) {
		                item = tabstrip.children().get(item);
		            }
	
		            item = tabstrip.find(item);
		            badge = $(item.find(".km-badge")[0] || createBadge(value).insertAfter(item.children(".km-icon")));
	
		            if (value || value === 0) {
		                badge.html(value);
		                return this;
		            }
	
		            if (value === false) {
		                badge.empty().remove();
		                return this;
		            }
	
		            return badge.html();
		        },
	
		        _release: function(e) {
		            if (e.which > 1) {
		                return;
		            }
	
		            var that = this,
		                item = $(e.currentTarget);
	
		            if (item[0] === that.currentItem()[0]) {
		                return;
		            }
	
		            if (that.trigger(SELECT, {item: item})) {
		                e.preventDefault();
		            } else {
		                that._setActiveItem(item);
		            }
		        },
	
		        _setActiveItem: function(item) {
		            if (!item[0]) {
		                return;
		            }
		            this.clear();
		            item.addClass(ACTIVE_STATE_CLASS);
		        },
	
		        _buildButton: function() {
		            var button = $(this),
		                icon = kendo.attrValue(button, "icon"),
		                badge = kendo.attrValue(button, "badge"),
		                image = button.find("img"),
		                iconSpan = $('<span class="km-icon"/>');
	
		            button
		                .addClass("km-button")
		                .attr(kendo.attr("role"), "tab")
		                    .contents().not(image)
		                    .wrapAll('<span class="km-text"/>');
	
		            if (image[0]) {
		                image.addClass("km-image").prependTo(button);
		            } else {
		                button.prepend(iconSpan);
		                if (icon) {
		                    iconSpan.addClass("km-" + icon);
		                    if (badge || badge === 0) {
		                        createBadge(badge).insertAfter(iconSpan);
		                    }
		                }
		            }
		        },
	
		        refresh: function(e) {
		            var url = e.view.id;
	
		            if (url && !this.switchTo(e.view.id)) {
		                this.switchTo(url);
		            }
		        },
	
		        options: {
		            name: "TabStrip",
		            selectedIndex: 0,
		            enable: true
		        }
		    });
	
		    ui.plugin(TabStrip);
		})(window.kendo.jQuery);
	
		return window.kendo;
	
		}, __webpack_require__(3));
	
	
	/***/ })
	
	/******/ });

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(798);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(440)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./all.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./all.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(439)();
	// imports
	
	
	// module
	exports.push([module.id, ".k-button[disabled],[disabled] .k-button{outline:none;cursor:default;opacity:.6;-webkit-filter:grayscale(.1);filter:grayscale(.1);pointer-events:none;box-shadow:none}.k-block,.k-content,.k-editor,.k-flatcolorpicker,.k-notification,.k-panel,.k-scheduler-agendaview tr.k-state-hover .k-scheduler-datecolumn,.k-scheduler-agendaview tr:hover .k-scheduler-datecolumn,.k-scheduler-agendaview tr:hover .k-scheduler-groupcolumn,.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper,.k-widget{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff}.k-menu-group,.k-menu.k-context-menu,.k-popup{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f9f9f9}.editorToolbarWindow.k-header.k-window-content,.k-block>.k-header,.k-gantt-toolbar,.k-panel>.k-header,.k-scheduler-footer,.k-scheduler-toolbar,.k-spreadsheet-column-header,.k-spreadsheet-row-header,.k-spreadsheet-top-corner,.k-time-list-wrapper .k-title,.k-treemap .k-treemap-title{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6}.editorToolbarWindow.k-header.k-window-content a.k-tool,.k-button,.k-button-group.k-state-disabled .k-button:not(.k-state-active),.k-button-group .k-state-disabled:not(.k-state-active),.k-colorpicker .k-picker-wrap,.k-combobox .k-select,.k-ct-popup .k-editor-toolbar a.k-tool,.k-dateinput .k-select,.k-datepicker .k-select,.k-datetimepicker .k-select,.k-dropdown .k-dropdown-wrap,.k-dropdowntree .k-dropdown-wrap,.k-editor .k-editor-toolbar-wrap a.k-tool,.k-fieldselector .k-list li.k-item,.k-gantt-views li,.k-handle,.k-list-container .k-nodata .k-button,.k-map .k-navigator,.k-numerictextbox .k-select,.k-pivot-toolbar .k-button,.k-scheduler-footer li,.k-scheduler-navigation .k-nav-next,.k-scheduler-navigation .k-nav-prev,.k-scheduler-navigation .k-nav-today,.k-scheduler-views li,.k-spreadsheet-filter,.k-switch-handle,.k-timepicker .k-select,.k-toolbar .k-split-button .k-button{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6;background-image:linear-gradient(#f6f6f6,#f1f1f1)}.editorToolbarWindow.k-header.k-window-content a.k-tool.k-state-hover,.editorToolbarWindow.k-header.k-window-content a.k-tool:hover,.k-action-buttons .k-button.k-state-hover,.k-action-buttons .k-button:hover,.k-button.k-state-hover,.k-button:hover,.k-colorpicker .k-state-hover,.k-combobox .k-state-hover .k-select,.k-combobox>:hover .k-select,.k-ct-popup .k-editor-toolbar a.k-tool.k-state-hover,.k-ct-popup .k-editor-toolbar a.k-tool:hover,.k-dateinput .k-select:hover,.k-dateinput .k-select>.k-state-active,.k-dateinput .k-select>.k-state-selected,.k-dateinput .k-state-hover .k-select,.k-datepicker .k-state-hover .k-select,.k-datepicker:hover .k-select,.k-datetimepicker .k-state-hover .k-select,.k-datetimepicker:hover .k-select,.k-dropdown .k-dropdown-wrap.k-state-hover,.k-dropdown .k-dropdown-wrap:hover,.k-dropdowntree .k-dropdown-wrap.k-state-hover,.k-dropdowntree .k-dropdown-wrap:hover,.k-editor .k-editor-toolbar-wrap a.k-tool.k-state-hover,.k-editor .k-editor-toolbar-wrap a.k-tool:hover,.k-fieldselector .k-list li.k-item.k-state-hover,.k-fieldselector .k-list li.k-item:hover,.k-gantt-views li.k-state-hover,.k-handle:hover,.k-numerictextbox .k-select:hover,.k-numerictextbox .k-select>.k-state-active,.k-numerictextbox .k-select>.k-state-selected,.k-numerictextbox .k-state-hover .k-select,.k-pivot-toolbar .k-button.k-state-hover,.k-pivot-toolbar .k-button:hover,.k-scheduler-footer li:hover,.k-scheduler-navigation .k-nav-next:hover,.k-scheduler-navigation .k-nav-prev:hover,.k-scheduler-navigation .k-nav-today:hover,.k-scheduler-views li:hover,.k-spreadsheet-filter:hover,.k-switch-off:hover .k-switch-handle,.k-timepicker .k-state-hover .k-select,.k-timepicker:hover .k-select,.k-toolbar .k-split-button .k-button.k-state-hover,.k-toolbar .k-split-button .k-button:hover{border-color:rgba(0,0,0,.15);color:#656565;background-color:#ededed;background-image:linear-gradient(#ededed,#e8e8e8)}.editorToolbarWindow.k-header.k-window-content a.k-tool.k-state-active,.editorToolbarWindow.k-header.k-window-content a.k-tool:active,.k-action-buttons .k-button.k-state-active,.k-action-buttons .k-button:active,.k-button.k-state-active,.k-button:active,.k-colorpicker .k-state-active,.k-ct-popup .k-editor-toolbar a.k-tool.k-state-active,.k-ct-popup .k-editor-toolbar a.k-tool:active,.k-editor .k-editor-toolbar-wrap a.k-tool.k-state-active,.k-editor .k-editor-toolbar-wrap a.k-tool:active,.k-multiselect-wrap li.k-button.k-state-active,.k-multiselect-wrap li.k-button:active,.k-split-button.k-button-group .k-button.k-state-active,.k-split-button.k-button-group .k-button:active,.k-spreadsheet-filter.k-state-active,.k-toolbar .k-split-button .k-button.k-state-active,.k-toolbar .k-split-button .k-button:active{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6;background-image:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.06)}.k-dropdowntree .k-dropdown-wrap.k-state-focused{box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-button.k-primary,.k-slider .k-draghandle,.k-switch-on .k-switch-handle{border-color:#ff6358;color:#fff;background-color:#ff6358;background-image:linear-gradient(rgba(255,138,88,0),rgba(255,138,88,.2))}.k-action-buttons .k-primary.k-state-hvoer,.k-action-buttons .k-primary:hover,.k-button.k-primary.k-state-hover,.k-button.k-primary:hover,.k-slider .k-draghandle:hover,.k-switch-on:hover .k-switch-handle{border-color:#ff6b58;color:#fff;background-color:#ff6b58;background-image:linear-gradient(rgba(255,146,88,0),rgba(255,146,88,.2))}.k-action-buttons .k-primary.k-state-active,.k-action-buttons .k-primary:active,.k-button-group .k-button.k-state-active,.k-button-group .k-button.k-state-selected,.k-button-group .k-button:active,.k-button-group>input[type=checkbox]:checked+.k-button,.k-button-group>input[type=radio]:checked+.k-button,.k-button.k-primary.k-state-active,.k-button.k-primary.k-state-selected,.k-button.k-primary:active,.k-button.k-state-selected,.k-slider .k-draghandle.k-pressed,.k-slider .k-draghandle:active{border-color:#ff6358;color:#fff;background-color:#ff6358;background-image:linear-gradient(rgba(255,138,88,.2),rgba(255,138,88,0))}.k-editor-toolbar,.k-toolbar{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6}.k-autocomplete,.k-combobox .k-dropdown-wrap,.k-dateinput .k-dateinput-wrap,.k-datepicker .k-picker-wrap,.k-datetimepicker .k-picker-wrap,.k-flatcolorpicker .k-color-value,.k-input.k-textbox,.k-multiselect-wrap,.k-numerictextbox .k-numeric-wrap,.k-textarea,.k-textbox,.k-timepicker .k-picker-wrap{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff}.k-autocomplete.k-state-hover,.k-combobox .k-state-hover,.k-combobox>:hover,.k-dateinput .k-state-hover,.k-datepicker .k-state-hover,.k-datepicker:hover,.k-datetimepicker .k-state-hover,.k-datetimepicker:hover,.k-multiselect-wrap.k-state-hover,.k-multiselect-wrap:hover,.k-numerictextbox .k-state-hover,.k-timepicker .k-state-hover,.k-timepicker:hover{border-color:rgba(0,0,0,.15);color:#656565;background-color:#fff}.k-autocomplete.k-state-active,.k-autocomplete.k-state-focused,.k-combobox .k-state-active,.k-combobox>.k-state-focused,.k-dateinput .k-state-focused,.k-datepicker .k-state-active,.k-datepicker .k-state-focused,.k-datetimepicker .k-state-active,.k-datetimepicker .k-state-focused,.k-dropdown .k-dropdown-wrap.k-state-focused,.k-numerictextbox .k-state-focused,.k-state-focused>.k-multiselect-wrap,.k-timepicker .k-state-active,.k-timepicker .k-state-focused{border-color:rgba(0,0,0,.15);color:#656565;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.03),0 4px 5px 0 rgba(0,0,0,.04)}.k-scheduler-agendaview .k-scheduler-content tr:hover,.k-scheduler-agendaview tr.k-state-hover{border-color:#ededed;color:#656565;background-color:#ededed}.k-drag-clue,.k-event.k-state-selected{border-color:#ff6358;color:#fff;background-color:#ff6358}.k-list-optionlabel.k-state-focused,.k-list-optionlabel:focus,.k-list .k-item.k-state-focused,.k-list .k-item:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-column-list-item:hover,.k-columnmenu-item:hover,.k-list-container .k-button.k-state-hover,.k-list-container .k-button:hover,.k-list-optionlabel.k-state-hover,.k-list-optionlabel:hover,.k-list .k-item.k-state-hover,.k-list .k-item:hover,.k-menu-group .k-item.k-state-hover,.k-menu-group .k-item:hover,.k-menu.k-context-menu .k-item.k-state-hover,.k-menu.k-context-menu .k-item:hover,.k-spreadsheet-filter-menu>.k-menu .k-item.k-state-hover,.k-spreadsheet-popup .k-button.k-state-hover,.k-spreadsheet-popup .k-button:hover{color:#656565;background-color:#ededed}.k-list-container .k-button.k-state-active,.k-list-container .k-button:active,.k-list-optionlabel.k-state-selected,.k-list .k-item.k-state-selected,.k-menu-group .k-item.k-state-selected,.k-menu.k-context-menu .k-item.k-state-selected,.k-spreadsheet-popup .k-button.k-state-active,.k-spreadsheet-popup .k-button.k-state-selected,.k-spreadsheet-popup .k-button:active{color:#fff;background-color:#ff6358}.k-common-test-class,.k-theme-test-class{opacity:0}.k-widget{border-width:1px;border-style:solid;box-sizing:border-box;outline:0;font-size:14px;line-height:1.4285714286;display:block;-webkit-touch-callout:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}table.k-widget{display:table}kendo-sortable{display:block}.k-rtl{direction:rtl}.k-link,.k-link:hover{color:inherit;text-decoration:none}.k-content{outline:0}.k-centered{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.k-pdf-export-shadow{position:absolute;overflow:hidden;left:-15000px;width:14400px}.kendo-pdf-hide-pseudo-elements:after,.kendo-pdf-hide-pseudo-elements:before{display:none!important}.k-state-disabled,.k-widget[disabled]{outline:none;cursor:default;opacity:.6;-webkit-filter:grayscale(.1);filter:grayscale(.1);pointer-events:none;box-shadow:none}.k-state-disabled .k-button,.k-state-disabled .k-link,.k-widget[disabled] .k-button,.k-widget[disabled] .k-link{cursor:default;outline:0}.k-state-disabled .k-state-disabled,.k-state-disabled [disabled],.k-widget[disabled] .k-state-disabled,.k-widget[disabled] [disabled]{opacity:1;-webkit-filter:grayscale(0);filter:grayscale(0)}.k-hr,.k-menu-group .k-item.k-separator,.k-menu-vertical .k-item.k-separator,.k-separator{margin:1em auto;height:0;border-width:1px 0 0;border-style:solid;border-color:rgba(0,0,0,.08);display:block}.k-columnset>.k-hr,.k-hbox>.k-hr,.k-menu-horizontal>.k-item.k-separator,.k-toolbar .k-separator{margin:0;width:0;height:auto;border-width:0 0 0 1px;-ms-flex:0 0 auto;flex:0 0 auto}.k-hr{padding:0;float:none;clear:both}.k-rowset>.k-hr,.k-vbox>.k-hr{margin:0;-ms-flex:0 0 auto;flex:0 0 auto}.k-dirty{margin:0;padding:0;width:0;height:0;border-width:3px;border-style:solid;border-color:#f31700 #f31700 transparent transparent;position:absolute;top:0;right:0}.k-rtl .k-dirty,[dir=rtl] .k-dirty{border-color:transparent transparent #f31700 #f31700;right:auto;left:0}.k-display-inline{display:inline!important}.k-display-block{display:block!important}.k-display-inline-block{display:inline-block!important}.k-display-flex{display:-ms-flexbox!important;display:flex!important}.k-display-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}.k-display-table{display:table!important}.k-display-inline-table{display:inline-table!important}.k-display-none,.k-hidden{display:none!important}.k-float-left{float:left!important}.k-float-right{float:right!important}.k-float-none{float:none!important}.k-floatwrap:after,.k-grid-toolbar:after,.k-slider-items:after{content:\"\";display:block;clear:both}.k-flex-wrap{-ms-flex-wrap:wrap;flex-wrap:wrap}.k-flex-nowrap{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.k-flex-wrap-reverse{-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse}.k-flex{-ms-flex:1 1 0px;flex:1 1 0}.k-flex-auto{-ms-flex:1 1 auto;flex:1 1 auto}.k-no-flex{-ms-flex:0 0 0px;flex:0 0 0}.k-no-flex-auto{-ms-flex:0 0 auto;flex:0 0 auto}.k-flex-grow{-ms-flex-positive:1;flex-grow:1}.k-no-flex-grow{-ms-flex-positive:0;flex-grow:0}.k-flex-shrink{-ms-flex-negative:1;flex-shrink:1}.k-no-flex-shrink{-ms-flex-negative:0;flex-shrink:0}.k-align-items-start{-ms-flex-align:start;align-items:flex-start}.k-align-items-end{-ms-flex-align:end;align-items:flex-end}.k-align-items-center{-ms-flex-align:center;align-items:center}.k-align-items-stretch{-ms-flex-align:stretch;align-items:stretch}.k-align-items-baseline{-ms-flex-align:baseline;align-items:baseline}.k-align-content-start{-ms-flex-line-pack:start;align-content:flex-start}.k-align-content-end{-ms-flex-line-pack:end;align-content:flex-end}.k-align-content-center{-ms-flex-line-pack:center;align-content:center}.k-align-content-stretch{-ms-flex-line-pack:stretch;align-content:stretch}.k-align-content-baseline{-ms-flex-line-pack:baseline;align-content:baseline}.k-align-self-start{-ms-flex-item-align:start;align-self:flex-start}.k-align-self-end{-ms-flex-item-align:end;align-self:flex-end}.k-align-self-center{-ms-flex-item-align:center;align-self:center}.k-align-self-stretch{-ms-flex-item-align:stretch;align-self:stretch}.k-align-self-baseline{-ms-flex-item-align:baseline;align-self:baseline}.k-justify-content-start{-ms-flex-pack:start;justify-content:flex-start}.k-justify-content-end{-ms-flex-pack:end;justify-content:flex-end}.k-justify-content-center{-ms-flex-pack:center;justify-content:center}.k-justify-content-between{-ms-flex-pack:justify;justify-content:space-between}.k-justify-content-around{-ms-flex-pack:distribute;justify-content:space-around}.k-justify-content-evenly{-ms-flex-pack:space-evenly;justify-content:space-evenly}.k-columnset,.k-hbox,.k-rowset,.k-vbox{display:-ms-flexbox;display:flex}.k-ihbox,.k-ivbox{display:-ms-inline-flexbox;display:inline-flex}.k-columnset,.k-hbox,.k-ihbox{-ms-flex-direction:row;flex-direction:row}.k-ivbox,.k-rowset,.k-vbox{-ms-flex-direction:column;flex-direction:column}.k-column{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0}.k-reset{margin:0;padding:0;border-width:0;outline:0;font:inherit;text-decoration:none;list-style:none}.k-text-nowrap{white-space:nowrap!important}.k-text-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.k-text-left{text-align:left!important}.k-text-right{text-align:right!important}.k-text-center{text-align:center!important}.k-text-justify{text-align:justify!important}.k-text-lowercase{text-transform:lowercase!important}.k-text-uppercase{text-transform:uppercase!important}.k-text-capitalize{text-transform:capitalize!important}.k-font-weight-light{font-weight:300!important}.k-font-weight-normal{font-weight:400!important}.k-font-weight-bold{font-weight:700!important}.k-flip-h{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-flip-v{-webkit-transform:scaleY(-1);transform:scaleY(-1)}.k-flip-h.k-flip-v{-webkit-transform:scale(-1);transform:scale(-1)}.k-rotate-45{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.k-rotate-90{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.k-rotate-135{-webkit-transform:rotate(135deg);transform:rotate(135deg)}.k-rotate-180{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.k-rotate-225{-webkit-transform:rotate(225deg);transform:rotate(225deg)}.k-rotate-270{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.k-rotate-315{-webkit-transform:rotate(315deg);transform:rotate(315deg)}.k-scale-0{-webkit-transform:scale(0);transform:scale(0)}.k-scale-1{-webkit-transform:scale(1);transform:scale(1)}.k-scale-2{-webkit-transform:scale(2);transform:scale(2)}.k-translate-0{-webkit-transform:translate(0);transform:translate(0)}.k-translate-0-50{-webkit-transform:translateY(50%);transform:translateY(50%)}.k-translate-0-100{-webkit-transform:translateY(100%);transform:translateY(100%)}.k-translate-50-0{-webkit-transform:translate(50%);transform:translate(50%)}.k-translate-50-50{-webkit-transform:translate(50%,50%);transform:translate(50%,50%)}.k-translate-50-100{-webkit-transform:translate(50%,100%);transform:translate(50%,100%)}.k-translate-100-0{-webkit-transform:translate(100%);transform:translate(100%)}.k-translate-100-50{-webkit-transform:translate(100%,50%);transform:translate(100%,50%)}.k-translate-100-100{-webkit-transform:translate(100%,100%);transform:translate(100%,100%)}.k-animation-container{position:absolute;overflow:hidden;z-index:100}.k-animation-container-fixed{position:fixed}.k-animation-container-relative{position:relative;display:inline-block}.k-push-right-appear,.k-push-right-enter{-webkit-transform:translate(-100%);transform:translate(-100%)}.k-push-right-appear-active,.k-push-right-enter-active{-webkit-transform:translate(0);transform:translate(0);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-push-right-exit{-webkit-transform:translate(0);transform:translate(0)}.k-push-right-exit-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-push-left-appear,.k-push-left-enter,.k-push-right-exit-active{-webkit-transform:translate(100%);transform:translate(100%)}.k-push-left-appear-active,.k-push-left-enter-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-push-left-appear-active,.k-push-left-enter-active,.k-push-left-exit{-webkit-transform:translate(0);transform:translate(0)}.k-push-left-exit-active{-webkit-transform:translate(-100%);transform:translate(-100%);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-push-down-appear,.k-push-down-enter{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.k-push-down-appear-active,.k-push-down-enter-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-push-down-appear-active,.k-push-down-enter-active,.k-push-down-exit{-webkit-transform:translate(0);transform:translate(0)}.k-push-down-exit-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-push-down-exit-active,.k-push-up-appear,.k-push-up-enter{-webkit-transform:translateY(100%);transform:translateY(100%)}.k-push-up-appear-active,.k-push-up-enter-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-push-up-appear-active,.k-push-up-enter-active,.k-push-up-exit{-webkit-transform:translate(0);transform:translate(0)}.k-push-up-exit-active{-webkit-transform:translateY(-100%);transform:translateY(-100%);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-expand-vertical-appear,.k-expand-vertical-enter{-webkit-transform:scaleY(0);transform:scaleY(0)}.k-expand-vertical-appear-active,.k-expand-vertical-enter-active{-webkit-transform:scaleY(1);transform:scaleY(1);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-expand-vertical-exit{-webkit-transform:scaleY(1);transform:scaleY(1)}.k-expand-vertical-exit-active{-webkit-transform:scaleY(0);transform:scaleY(0);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-expand-horizontal-appear,.k-expand-horizontal-enter{-webkit-transform:scaleX(0);transform:scaleX(0)}.k-expand-horizontal-appear-active,.k-expand-horizontal-enter-active{-webkit-transform:scaleX(1);transform:scaleX(1);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-expand-horizontal-exit{-webkit-transform:scaleX(1);transform:scaleX(1)}.k-expand-horizontal-exit-active{-webkit-transform:scaleX(0);transform:scaleX(0);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-fade-appear,.k-fade-enter{opacity:0}.k-fade-appear-active,.k-fade-enter-active{opacity:1;transition:opacity .5s ease-in-out}.k-fade-exit{opacity:1}.k-fade-exit-active{opacity:0;transition:opacity .5s ease-in-out}.k-fade-enter-active+.k-fade-enter-active,.k-fade-exit-active+.k-fade-exit-active{display:none}.k-zoom-in-appear,.k-zoom-in-enter{opacity:0;-webkit-transform:scale(0);transform:scale(0)}.k-zoom-in-appear-active,.k-zoom-in-enter-active{transition:opacity .3s ease-in-out,-webkit-transform;transition:transform,opacity .3s ease-in-out;transition:transform,opacity .3s ease-in-out,-webkit-transform}.k-zoom-in-appear-active,.k-zoom-in-enter-active,.k-zoom-in-exit{opacity:1;-webkit-transform:scale(1);transform:scale(1)}.k-zoom-in-exit-active{transition:opacity .3s ease-in-out,-webkit-transform;transition:transform,opacity .3s ease-in-out;transition:transform,opacity .3s ease-in-out,-webkit-transform}.k-zoom-in-exit-active,.k-zoom-out-appear,.k-zoom-out-enter{opacity:0;-webkit-transform:scale(2);transform:scale(2)}.k-zoom-out-appear-active,.k-zoom-out-enter-active{transition:opacity .3s ease-in-out,-webkit-transform;transition:transform,opacity .3s ease-in-out;transition:transform,opacity .3s ease-in-out,-webkit-transform}.k-zoom-out-appear-active,.k-zoom-out-enter-active,.k-zoom-out-exit{opacity:1;-webkit-transform:scale(1);transform:scale(1)}.k-zoom-out-exit-active{opacity:0;-webkit-transform:scale(0);transform:scale(0);transition:opacity .3s ease-in-out,-webkit-transform;transition:transform,opacity .3s ease-in-out;transition:transform,opacity .3s ease-in-out,-webkit-transform}.k-slide-in-appear{opacity:.1;-webkit-transform:translateY(-3em);transform:translateY(-3em)}.k-slide-in-appear .k-centered{-webkit-transform:translate(-50%,-60%);transform:translate(-50%,-60%)}.k-slide-in-appear-active{opacity:1;-webkit-transform:translate(0);transform:translate(0);transition:opacity .3s cubic-bezier(.2,1,.2,1),-webkit-transform .3s cubic-bezier(.2,.6,.4,1);transition:transform .3s cubic-bezier(.2,.6,.4,1),opacity .3s cubic-bezier(.2,1,.2,1);transition:transform .3s cubic-bezier(.2,.6,.4,1),opacity .3s cubic-bezier(.2,1,.2,1),-webkit-transform .3s cubic-bezier(.2,.6,.4,1)}.k-slide-in-appear-active .k-centered{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.k-slide-down-appear,.k-slide-down-enter{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.k-slide-down-appear-active,.k-slide-down-enter-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-slide-down-appear-active,.k-slide-down-enter-active,.k-slide-down-exit{-webkit-transform:translateY(0);transform:translateY(0)}.k-slide-down-exit-active{-webkit-transform:translateY(-100%);transform:translateY(-100%);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-slide-up-appear,.k-slide-up-enter{-webkit-transform:translateY(100%);transform:translateY(100%)}.k-slide-up-appear-active,.k-slide-up-enter-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-slide-up-appear-active,.k-slide-up-enter-active,.k-slide-up-exit{-webkit-transform:translateY(0);transform:translateY(0)}.k-slide-up-exit-active{-webkit-transform:translateY(100%);transform:translateY(100%);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-slide-right-appear,.k-slide-right-enter{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.k-slide-right-appear-active,.k-slide-right-enter-active{-webkit-transform:translateX(0);transform:translateX(0);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-slide-right-exit{-webkit-transform:translateX(0);transform:translateX(0)}.k-slide-right-exit-active{-webkit-transform:translateX(-100%);transform:translateX(-100%);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-slide-left-appear,.k-slide-left-enter{-webkit-transform:translateX(100%);transform:translateX(100%)}.k-slide-left-appear-active,.k-slide-left-enter-active{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-slide-left-appear-active,.k-slide-left-enter-active,.k-slide-left-exit{-webkit-transform:translateX(0);transform:translateX(0)}.k-slide-left-exit-active{-webkit-transform:translateX(100%);transform:translateX(100%);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.k-reveal-vertical-appear,.k-reveal-vertical-enter{max-height:0}.k-reveal-vertical-appear-active,.k-reveal-vertical-enter-active,.k-reveal-vertical-exit-active{transition:max-height .3s ease-in-out}.k-reveal-vertical-exit-active{max-height:0!important}.k-reveal-horizontal-appear,.k-reveal-horizontal-enter{max-width:0}.k-reveal-horizontal-appear-active,.k-reveal-horizontal-enter-active,.k-reveal-horizontal-exit-active{transition:max-width .3s ease-in-out}.k-reveal-horizontal-exit-active{max-width:0!important}.k-arrow-e,.k-arrow-w{width:0;height:0;border:5px solid transparent;position:absolute;top:-4px}.k-arrow-e{border-left-color:currentColor;right:-6px}.k-arrow-w{border-right-color:currentColor;left:-6px}.k-drag-clue{padding:2px 4px;border-width:1px;border-style:solid;font-size:12px;white-space:nowrap;overflow:hidden;cursor:move}.k-drag-status{margin-right:.4ex}.k-reorder-cue{position:absolute}.k-reorder-cue:after,.k-reorder-cue:before{content:\"\";width:0;height:0;border:3px solid transparent;position:absolute;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.k-reorder-cue:before{border-bottom-width:0;border-top-color:currentColor;top:-4px}.k-reorder-cue:after{border-top-width:0;border-bottom-color:currentColor;bottom:-4px}.k-autocomplete,.k-combobox,.k-dateinput,.k-datepicker,.k-datetimepicker,.k-dropdown,.k-dropdowntree,.k-maskedtextbox,.k-multiselect,.k-numerictextbox,.k-timepicker{width:12.4em;font-size:14px;line-height:1.4285714286;text-align:left;white-space:nowrap;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle;position:relative}.k-autocomplete[dir=rtl],.k-combobox[dir=rtl],.k-dateinput[dir=rtl],.k-datepicker[dir=rtl],.k-datetimepicker[dir=rtl],.k-dropdown[dir=rtl],.k-dropdowntree[dir=rtl],.k-maskedtextbox[dir=rtl],.k-multiselect[dir=rtl],.k-numerictextbox[dir=rtl],.k-rtl .k-autocomplete,.k-rtl .k-combobox,.k-rtl .k-dateinput,.k-rtl .k-datepicker,.k-rtl .k-datetimepicker,.k-rtl .k-dropdown,.k-rtl .k-dropdowntree,.k-rtl .k-maskedtextbox,.k-rtl .k-multiselect,.k-rtl .k-numerictextbox,.k-rtl .k-timepicker,.k-timepicker[dir=rtl]{text-align:right}.k-autocomplete[dir=rtl] .k-select,.k-combobox[dir=rtl] .k-select,.k-dateinput[dir=rtl] .k-select,.k-datepicker[dir=rtl] .k-select,.k-datetimepicker[dir=rtl] .k-select,.k-dropdown[dir=rtl] .k-select,.k-dropdowntree[dir=rtl] .k-select,.k-maskedtextbox[dir=rtl] .k-select,.k-multiselect[dir=rtl] .k-select,.k-numerictextbox[dir=rtl] .k-select,.k-rtl .k-autocomplete .k-select,.k-rtl .k-combobox .k-select,.k-rtl .k-dateinput .k-select,.k-rtl .k-datepicker .k-select,.k-rtl .k-datetimepicker .k-select,.k-rtl .k-dropdown .k-select,.k-rtl .k-dropdowntree .k-select,.k-rtl .k-maskedtextbox .k-select,.k-rtl .k-multiselect .k-select,.k-rtl .k-numerictextbox .k-select,.k-rtl .k-timepicker .k-select,.k-timepicker[dir=rtl] .k-select{border-radius:2px 0 0 2px}.k-autocomplete ::-ms-clear,.k-combobox ::-ms-clear,.k-dateinput ::-ms-clear,.k-datepicker ::-ms-clear,.k-datetimepicker ::-ms-clear,.k-dropdown ::-ms-clear,.k-dropdowntree ::-ms-clear,.k-maskedtextbox ::-ms-clear,.k-multiselect ::-ms-clear,.k-numerictextbox ::-ms-clear,.k-timepicker ::-ms-clear{display:none}.k-colorpicker,.k-combobox,.k-dateinput,.k-datepicker,.k-datetimepicker,.k-dropdown,.k-dropdowntree,.k-maskedtextbox,.k-multiselect,.k-numerictextbox,.k-timepicker{border-width:0;background-color:transparent}.k-nodata{min-height:138px;width:100%;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;text-transform:uppercase;font-weight:lighter;text-align:center;white-space:normal}.k-nodata,.k-searchbar{display:-ms-flexbox;display:flex}.k-searchbar{-ms-flex:1;flex:1;-ms-flex-direction:row;flex-direction:row}.k-autocomplete,.k-dateinput-wrap,.k-dropdown-wrap,.k-multiselect-wrap,.k-numeric-wrap,.k-picker-wrap{border-radius:2px;padding:0;width:100%;border-width:1px;border-style:solid;box-sizing:border-box;position:relative;transition:all .1s ease;cursor:default;outline:0}.k-autocomplete .k-input,.k-dateinput-wrap .k-input,.k-dropdown-wrap .k-input,.k-multiselect-wrap .k-input,.k-numeric-wrap .k-input,.k-picker-wrap .k-input{padding:4px 8px;height:calc(8px + 1.4285714286em);box-sizing:border-box;border:0;outline:0;color:inherit;background:none;font:inherit;-ms-flex:0 1 auto;flex:0 1 auto;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow:hidden;text-overflow:ellipsis}.k-autocomplete{width:12.4em}.k-dateinput-wrap,.k-dropdown-wrap,.k-numeric-wrap,.k-picker-wrap{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.k-dateinput-wrap .k-input,.k-dropdown-wrap .k-input,.k-numeric-wrap .k-input,.k-picker-wrap .k-input{width:100%}.k-dateinput-wrap .k-select,.k-dropdown-wrap .k-select,.k-numeric-wrap .k-select,.k-picker-wrap .k-select{border-radius:0 2px 2px 0;padding:4px;border-width:0;box-sizing:border-box;border-style:solid;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex:0 0 auto;flex:0 0 auto;text-align:center;cursor:pointer}.k-autocomplete .k-i-loading,.k-multiselect-wrap .k-i-loading{height:20px;line-height:20px;position:absolute;top:4px;right:6px}.k-rtl .k-autocomplete .k-i-loading,.k-rtl .k-multiselect-wrap .k-i-loading,[dir=rtl] .k-autocomplete .k-i-loading,[dir=rtl] .k-multiselect-wrap .k-i-loading{right:auto;left:6px}.k-autocomplete .k-clear-value,.k-dropdown-wrap .k-clear-value,.k-multiselect-wrap .k-clear-value{height:20px;line-height:20px;outline:0;cursor:pointer;display:none;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;opacity:.5;position:absolute;top:4px;right:6px}.k-rtl .k-autocomplete .k-clear-value,.k-rtl .k-dropdown-wrap .k-clear-value,.k-rtl .k-multiselect-wrap .k-clear-value,[dir=rtl] .k-autocomplete .k-clear-value,[dir=rtl] .k-dropdown-wrap .k-clear-value,[dir=rtl] .k-multiselect-wrap .k-clear-value{right:auto;left:6px}.k-autocomplete .k-clear-value:hover,.k-dropdown-wrap .k-clear-value:hover,.k-multiselect-wrap .k-clear-value:hover{opacity:1}.k-autocomplete.k-state-focused .k-clear-value,.k-autocomplete.k-state-hover .k-clear-value,.k-autocomplete:hover .k-clear-value,.k-dropdown-wrap.k-state-focused .k-clear-value,.k-dropdown-wrap.k-state-hover .k-clear-value,.k-dropdown-wrap:hover .k-clear-value,.k-multiselect-wrap.k-state-focused .k-clear-value,.k-multiselect-wrap.k-state-hover .k-clear-value,.k-multiselect-wrap:hover .k-clear-value,.k-state-focused>.k-multiselect-wrap .k-clear-value,.k-state-hover>.k-multiselect-wrap .k-clear-value{display:-ms-inline-flexbox;display:inline-flex}.k-dropdown-wrap .k-clear-value{right:calc(1.4285714286em + 14px)}.k-rtl .k-dropdown-wrap .k-clear-value,[dir=rtl] .k-dropdown-wrap .k-clear-value{right:auto;left:calc(1.4285714286em + 14px)}.k-multiselect-wrap{padding-right:calc(1.4285714286em + 8px)}.k-rtl .k-multiselect-wrap,[dir=rtl] .k-multiselect-wrap{padding-left:calc(1.4285714286em + 8px);padding-right:8px}.k-autocomplete{padding-right:calc(1.4285714286em + 8px)}.k-autocomplete[dir=rtl],.k-rtl .k-autocomplete{padding-left:calc(1.4285714286em + 8px);padding-right:0}.k-dateinput .k-select,.k-numerictextbox .k-select{padding:0;border-width:0;width:calc(8px + 1.4285714286em);display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch}.k-dateinput .k-link,.k-numerictextbox .k-link{-ms-flex:1 1 auto;flex:1 1 auto;display:block;overflow:hidden;position:relative}.k-dateinput .k-link .k-icon,.k-numerictextbox .k-link .k-icon{position:absolute;right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}.k-dateinput .k-link-increase .k-icon,.k-numerictextbox .k-link-increase .k-icon{bottom:-2px}.k-dateinput .k-link-decrease .k-icon,.k-numerictextbox .k-link-decrease .k-icon{top:-2px}.k-virtual-content{overflow-y:scroll;-webkit-overflow-scrolling:touch;position:relative}.k-virtual-content>.k-virtual-list>.k-virtual-item{position:absolute;width:100%;box-sizing:border-box;overflow:hidden;white-space:nowrap}.k-textbox.k-space-left{padding-left:1.9em}.k-textbox.k-space-right{padding-right:1.9em}.k-textbox .k-icon{top:50%;margin:-8px 0 0;position:absolute}.k-space-left .k-icon{left:3px}.k-space-right .k-icon{right:3px}.k-widget.k-state-invalid.k-autocomplete,.k-widget.k-state-invalid.k-maskedtextbox>.k-textbox,.k-widget.k-state-invalid>.k-dateinput-wrap,.k-widget.k-state-invalid>.k-dropdown-wrap,.k-widget.k-state-invalid>.k-multiselect-wrap,.k-widget.k-state-invalid>.k-numeric-wrap,.k-widget.k-state-invalid>.k-picker-wrap,.ng-invalid.ng-dirty.k-autocomplete,.ng-invalid.ng-dirty.k-maskedtextbox>.k-textbox,.ng-invalid.ng-dirty>.k-dateinput-wrap,.ng-invalid.ng-dirty>.k-dropdown-wrap,.ng-invalid.ng-dirty>.k-multiselect-wrap,.ng-invalid.ng-dirty>.k-numeric-wrap,.ng-invalid.ng-dirty>.k-picker-wrap,.ng-invalid.ng-touched.k-autocomplete,.ng-invalid.ng-touched.k-maskedtextbox>.k-textbox,.ng-invalid.ng-touched>.k-dateinput-wrap,.ng-invalid.ng-touched>.k-dropdown-wrap,.ng-invalid.ng-touched>.k-multiselect-wrap,.ng-invalid.ng-touched>.k-numeric-wrap,.ng-invalid.ng-touched>.k-picker-wrap{color:#f31700;border-color:rgba(243,23,0,.5)}.k-widget.form-control{padding:0}.k-maskedtextbox.form-control .k-textbox,.k-textbox.form-control,.k-widget.form-control{width:100%}.k-autocomplete.form-control .k-input{box-sizing:border-box}.input-group .k-dateinput-wrap,.input-group .k-dateinput-wrap .k-select,.input-group .k-dropdown-wrap,.input-group .k-dropdown-wrap .k-select,.input-group .k-maskedtextbox .k-textbox,.input-group .k-maskedtextbox .k-textbox .k-select,.input-group .k-multiselect-wrap,.input-group .k-multiselect-wrap .k-select,.input-group .k-numeric-wrap,.input-group .k-numeric-wrap .k-select,.input-group .k-picker-wrap,.input-group .k-picker-wrap .k-select{border-top-right-radius:0;border-bottom-right-radius:0}.input-group .k-maskedtextbox.form-control .k-textbox,.input-group .k-textbox.form-control,.input-group .k-widget.form-control{width:auto}.input-group .k-widget.form-control:not(:first-child):not(:last-child) .k-dateinput-wrap,.input-group .k-widget.form-control:not(:first-child):not(:last-child) .k-dropdown-wrap,.input-group .k-widget.form-control:not(:first-child):not(:last-child) .k-multiselect-wrap,.input-group .k-widget.form-control:not(:first-child):not(:last-child) .k-numeric-wrap,.input-group .k-widget.form-control:not(:first-child):not(:last-child) .k-picker-wrap,.input-group .k-widget.form-control:not(:first-child):not(:last-child)>.k-textbox{border-radius:0}.input-group-prepend+.k-widget.form-control .k-dateinput-wrap,.input-group-prepend+.k-widget.form-control .k-dropdown-wrap,.input-group-prepend+.k-widget.form-control .k-multiselect-wrap,.input-group-prepend+.k-widget.form-control .k-numeric-wrap,.input-group-prepend+.k-widget.form-control .k-picker-wrap,.input-group-prepend+.k-widget.form-control>.k-textbox{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:2px;border-bottom-right-radius:2px}.k-widget.form-control .k-input{padding:.5rem .75rem;height:2.25rem}.k-widget.form-control-sm .k-input{padding:.25rem .5rem;height:1.8125rem}.k-widget.form-control-sm .k-dateinput-wrap .k-select,.k-widget.form-control-sm .k-dropdown-wrap .k-select,.k-widget.form-control-sm .k-picker-wrap .k-select{padding:.25rem}.k-widget.form-control-sm .k-select{width:1.8125rem}.k-widget.form-control-lg .k-input{padding:.5rem 1rem;height:2.875rem}.k-widget.form-control-lg .k-dateinput-wrap .k-select,.k-widget.form-control-lg .k-dropdown-wrap .k-select,.k-widget.form-control-lg .k-picker-wrap .k-select{padding:.5rem}.k-widget.form-control-lg .k-select{width:2.875rem}.k-maskedtextbox.form-control .k-textbox{height:calc(2.25rem + 2px);padding:.5rem .75rem}.k-maskedtextbox.form-control-sm .k-textbox{height:calc(1.8125rem + 2px);padding:.25rem .5rem;line-height:1.5}.k-maskedtextbox.form-control-lg .k-textbox{height:calc(2.875rem + 2px);padding:.5rem 1rem;line-height:1.5}.k-textbox.form-control{height:calc(2.25rem + 2px);padding:.5rem .75rem}.k-textbox.form-control-sm{height:calc(1.8125rem + 2px);padding:.25rem .5rem;line-height:1.5}.k-textbox.form-control-lg{height:calc(2.875rem + 2px);padding:.5rem 1rem;line-height:1.5}.k-dateinput.form-control-sm .k-link-increase>.k-icon,.k-numerictextbox.form-control-sm .k-link-increase>.k-icon{bottom:-2px}.k-dateinput.form-control-sm .k-link-decrease>.k-icon,.k-numerictextbox.form-control-sm .k-link-decrease>.k-icon{top:-2px}.k-dateinput.form-control-sm .k-link,.k-numerictextbox.form-control-sm .k-link{height:.90625rem}.k-dateinput.form-control-lg .k-link,.k-numerictextbox.form-control-lg .k-link{height:1.4375rem}.k-dateinput.form-control .k-dateinput-wrap .k-select{padding-top:0;padding-bottom:0}@font-face{font-family:WebComponentsIcons;font-style:normal;font-weight:400;src:url(data:font/ttf;base64,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) format(\"truetype\")}.k-icon{width:1em;height:1em;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-size:16px;font-family:WebComponentsIcons;font-style:normal;font-variant:normal;font-weight:400;line-height:1;speak:none;text-transform:none;text-decoration:none;display:inline-block;vertical-align:middle}.k-icon:before{vertical-align:baseline}.k-icon:focus,.k-icon:hover{text-decoration:none}.k-icon-with-modifier{position:relative;margin:.25em}.k-icon-modifier{position:absolute;font-size:.5em;bottom:0;right:0;margin:0 -.5em -.5em 0}.k-i-none:before{content:\"\";display:none}.k-icon-xs{font-size:8px}.k-icon-sm{font-size:12px}.k-icon-md{font-size:32px}.k-icon-lg{font-size:48px}.k-icon-xl{font-size:64px}.k-i-arrow-45-up-right:before,.k-i-collapse-ne:before,.k-i-resize-ne:before{content:\"\\E000\"}.k-i-arrow-45-down-right:before,.k-i-collapse-se:before,.k-i-resize-se:before{content:\"\\E001\"}.k-i-arrow-45-down-left:before,.k-i-collapse-sw:before,.k-i-resize-sw:before{content:\"\\E002\"}.k-i-arrow-45-up-left:before,.k-i-collapse-nw:before,.k-i-resize-new:before,.k-i-resize-nw:before{content:\"\\E003\"}.k-i-arrow-60-up:before,.k-i-arrow-n:before,.k-i-expand-n:before,.k-i-kpi-trend-increase:before,.k-i-sarrow-n:before{content:\"\\E004\"}.k-i-arrow-60-right:before,.k-i-arrow-e:before,.k-i-expand-e:before,.k-i-expand:before,.k-i-sarrow-e:before{content:\"\\E005\"}.k-i-arrow-60-down:before,.k-i-arrow-s:before,.k-i-collapse:before,.k-i-expand-s:before,.k-i-kpi-trend-decrease:before,.k-i-sarrow-s:before{content:\"\\E006\"}.k-i-arrow-60-left:before,.k-i-arrow-w:before,.k-i-expand-w:before,.k-i-sarrow-w:before{content:\"\\E007\"}.k-i-arrow-end-up:before{content:\"\\E008\"}.k-i-arrow-end-right:before,.k-i-seek-e:before{content:\"\\E009\"}.k-i-arrow-end-down:before{content:\"\\E00A\"}.k-i-arrow-end-left:before,.k-i-seek-w:before{content:\"\\E00B\"}.k-i-arrow-double-60-up:before,.k-i-arrow-seek-up:before,.k-i-seek-n:before{content:\"\\E00C\"}.k-i-arrow-double-60-right:before,.k-i-arrow-seek-right:before,.k-i-forward-sm:before{content:\"\\E00D\"}.k-i-arrow-double-60-down:before,.k-i-arrow-seek-down:before,.k-i-seek-s:before{content:\"\\E00E\"}.k-i-arrow-double-60-left:before,.k-i-arrow-seek-left:before,.k-i-rewind-sm:before{content:\"\\E00F\"}.k-i-arrows-kpi:before,.k-i-kpi:before{content:\"\\E010\"}.k-i-arrows-no-change:before{content:\"\\E011\"}.k-i-arrow-overflow-down:before{content:\"\\E012\"}.k-i-arrow-chevron-up:before,.k-i-arrowhead-n:before{content:\"\\E013\"}.k-i-arrow-chevron-right:before,.k-i-arrowhead-e:before{content:\"\\E014\"}.k-i-arrow-chevron-down:before,.k-i-arrowhead-s:before{content:\"\\E015\"}.k-i-arrow-chevron-left:before,.k-i-arrowhead-w:before{content:\"\\E016\"}.k-i-arrow-up:before{content:\"\\E017\"}.k-i-arrow-right:before{content:\"\\E018\"}.k-i-arrow-down:before{content:\"\\E019\"}.k-i-arrow-left:before{content:\"\\E01A\"}.k-i-arrow-drill:before{content:\"\\E01B\"}.k-i-arrow-parent:before{content:\"\\E01C\"}.k-i-arrow-root:before{content:\"\\E01D\"}.k-i-arrows-resizing:before{content:\"\\E01E\"}.k-i-arrows-dimensions:before,.k-i-dimension:before{content:\"\\E01F\"}.k-i-arrows-swap:before{content:\"\\E020\"}.k-i-drag-and-drop:before{content:\"\\E021\"}.k-i-categorize:before{content:\"\\E022\"}.k-i-grid:before{content:\"\\E023\"}.k-i-grid-layout:before{content:\"\\E024\"}.k-i-group:before{content:\"\\E025\"}.k-i-ungroup:before{content:\"\\E026\"}.k-i-handler-drag:before{content:\"\\E027\"}.k-i-layout:before{content:\"\\E028\"}.k-i-layout-1-by-4:before{content:\"\\E029\"}.k-i-layout-2-by-2:before,.k-i-page-layout:before{content:\"\\E02A\"}.k-i-layout-side-by-side:before{content:\"\\E02B\"}.k-i-layout-stacked:before{content:\"\\E02C\"}.k-i-columns:before{content:\"\\E02D\"}.k-i-rows:before{content:\"\\E02E\"}.k-i-reorder:before{content:\"\\E02F\"}.k-i-hamburger:before,.k-i-menu:before{content:\"\\E030\"}.k-i-more-vertical:before,.k-i-vbars:before{content:\"\\E031\"}.k-i-hbars:before,.k-i-more-horizontal:before{content:\"\\E032\"}.k-i-undo-large:before,.k-i-undo:before{content:\"\\E100\"}.k-i-redo-large:before,.k-i-redo:before{content:\"\\E101\"}.k-i-reset:before{content:\"\\E102\"}.k-i-recurrence:before,.k-i-refresh:before,.k-i-reload:before{content:\"\\E103\"}.k-i-non-recurrence:before,.k-i-refresh-clear:before{content:\"\\E104\"}.k-i-reset-sm:before{content:\"\\E105\"}.k-i-recurrence-sm:before,.k-i-refresh-sm:before,.k-i-reload-sm:before{content:\"\\E106\"}.k-i-clock:before{content:\"\\E107\"}.k-i-calendar:before{content:\"\\E108\"}.k-i-floppy:before,.k-i-save:before{content:\"\\E109\"}.k-i-print:before,.k-i-printer:before{content:\"\\E10A\"}.k-i-edit:before,.k-i-pencil:before{content:\"\\E10B\"}.k-i-delete:before,.k-i-trash:before{content:\"\\E10C\"}.k-i-attachment:before,.k-i-clip:before{content:\"\\E10D\"}.k-i-attachment-45:before,.k-i-clip-45:before{content:\"\\E10E\"}.k-i-hyperlink:before,.k-i-link-horizontal:before{content:\"\\E10F\"}.k-i-hyperlink-remove:before,.k-i-unlink-horizontal:before{content:\"\\E110\"}.k-i-link-vertical:before{content:\"\\E111\"}.k-i-unlink-vertical:before{content:\"\\E112\"}.k-i-lock:before{content:\"\\E113\"}.k-i-unlock:before{content:\"\\E114\"}.k-i-cancel:before{content:\"\\E115\"}.k-i-cancel-outline:before,.k-i-deny:before{content:\"\\E116\"}.k-i-cancel-circle:before{content:\"\\E117\"}.k-i-check:before,.k-i-checkmark:before{content:\"\\E118\"}.k-i-check-outline:before,.k-i-checkmark-outline:before,.k-i-success:before{content:\"\\E119\"}.k-i-check-circle:before,.k-i-checkmark-circle:before{content:\"\\E11A\"}.k-i-close:before,.k-i-group-delete:before,.k-i-x:before{content:\"\\E11B\"}.k-i-close-outline:before,.k-i-error:before,.k-i-x-outline:before{content:\"\\E11C\"}.k-i-close-circle:before,.k-i-x-circle:before{content:\"\\E11D\"}.k-i-add:before,.k-i-plus:before,.k-plus:before{content:\"\\E11E\"}.k-i-plus-outline:before{content:\"\\E11F\"}.k-i-plus-circle:before{content:\"\\E120\"}.k-i-kpi-trend-equal:before,.k-i-minus:before,.k-minus:before{content:\"\\E121\"}.k-i-minus-outline:before{content:\"\\E122\"}.k-i-minus-circle:before{content:\"\\E123\"}.k-i-sort-asc:before{content:\"\\E124\"}.k-i-sort-desc:before{content:\"\\E125\"}.k-i-sort-clear:before,.k-i-unsort:before{content:\"\\E126\"}.k-i-sort-asc-sm:before{content:\"\\E127\"}.k-i-sort-desc-sm:before{content:\"\\E128\"}.k-i-filter:before{content:\"\\E129\"}.k-i-filter-clear:before{content:\"\\E12A\"}.k-i-filter-sm:before{content:\"\\E12B\"}.k-i-filter-sort-asc-sm:before{content:\"\\E12C\"}.k-i-filter-sort-desc-sm:before{content:\"\\E12D\"}.k-i-filter-add-expression:before{content:\"\\E12E\"}.k-i-filter-add-group:before{content:\"\\E12F\"}.k-i-login:before{content:\"\\E130\"}.k-i-logout:before{content:\"\\E131\"}.k-i-download:before{content:\"\\E132\"}.k-i-upload:before{content:\"\\E133\"}.k-i-hyperlink-open:before{content:\"\\E134\"}.k-i-hyperlink-open-sm:before{content:\"\\E135\"}.k-i-launch:before{content:\"\\E136\"}.k-i-maximize:before,.k-i-window-maximize:before,.k-i-window:before{content:\"\\E137\"}.k-i-restore:before,.k-i-tiles:before,.k-i-window-restore:before,.k-i-windows:before{content:\"\\E138\"}.k-i-minimize:before,.k-i-window-minimize:before{content:\"\\E139\"}.k-i-cog:before,.k-i-custom:before,.k-i-gear:before{content:\"\\E13A\"}.k-i-cogs:before,.k-i-gears:before{content:\"\\E13B\"}.k-i-settings:before,.k-i-wrench:before{content:\"\\E13C\"}.k-i-eye:before,.k-i-preview:before{content:\"\\E13D\"}.k-i-search:before,.k-i-zoom:before{content:\"\\E13E\"}.k-i-zoom-in:before{content:\"\\E13F\"}.k-i-zoom-out:before{content:\"\\E140\"}.k-i-move:before,.k-i-pan:before{content:\"\\E141\"}.k-i-calculator:before{content:\"\\E142\"}.k-i-cart:before,.k-i-shopping-cart:before{content:\"\\E143\"}.k-i-connector:before{content:\"\\E144\"}.k-i-plus-sm:before,.k-i-splus:before{content:\"\\E145\"}.k-i-minus-sm:before,.k-i-sminus:before{content:\"\\E146\"}.k-i-kpi-status-deny:before{content:\"\\E147\"}.k-i-kpi-status-hold:before{content:\"\\E148\"}.k-i-kpi-status-open:before{content:\"\\E149\"}.k-i-play:before{content:\"\\E200\"}.k-i-pause:before{content:\"\\E201\"}.k-i-stop:before{content:\"\\E202\"}.k-i-rewind:before{content:\"\\E203\"}.k-i-forward:before{content:\"\\E204\"}.k-i-volume-down:before,.k-i-volume-low:before{content:\"\\E205\"}.k-i-volume-high:before,.k-i-volume-up:before{content:\"\\E206\"}.k-i-volume-mute:before,.k-i-volume-off:before{content:\"\\E207\"}.k-i-hd:before{content:\"\\E208\"}.k-i-subtitles:before{content:\"\\E209\"}.k-i-playlist:before{content:\"\\E20A\"}.k-i-audio:before{content:\"\\E20B\"}.k-i-play-sm:before{content:\"\\E20C\"}.k-i-pause-sm:before{content:\"\\E20D\"}.k-i-stop-sm:before{content:\"\\E20E\"}.k-i-fav-outline:before,.k-i-favorite-outline:before,.k-i-heart-outline:before{content:\"\\E300\"}.k-i-fav:before,.k-i-favorite:before,.k-i-heart:before{content:\"\\E301\"}.k-i-bookmark-outline:before,.k-i-star-outline:before{content:\"\\E302\"}.k-i-bookmark:before,.k-i-star:before{content:\"\\E303\"}.k-i-checkbox:before,.k-i-shape-rect:before{content:\"\\E304\"}.k-i-checkbox-checked:before{content:\"\\E305\"}.k-i-tri-state-indeterminate:before{content:\"\\E306\"}.k-i-tri-state-null:before{content:\"\\E307\"}.k-i-circle:before{content:\"\\E308\"}.k-i-radiobutton:before,.k-i-shape-circle:before{content:\"\\E309\"}.k-i-radiobutton-checked:before{content:\"\\E30A\"}.k-i-bell:before,.k-i-notification:before{content:\"\\E400\"}.k-i-info:before,.k-i-information:before{content:\"\\E401\"}.k-i-help:before,.k-i-question:before{content:\"\\E402\"}.k-i-exception:before,.k-i-warning:before{content:\"\\E403\"}.k-i-photo-camera:before{content:\"\\E500\"}.k-i-image:before,.k-i-photo:before{content:\"\\E501\"}.k-i-image-export:before,.k-i-photo-export:before{content:\"\\E502\"}.k-i-zoom-actual-size:before{content:\"\\E503\"}.k-i-zoom-best-fit:before{content:\"\\E504\"}.k-i-image-resize:before{content:\"\\E505\"}.k-i-crop:before{content:\"\\E506\"}.k-i-mirror:before{content:\"\\E507\"}.k-i-flip-horizontal:before{content:\"\\E508\"}.k-i-flip-vertical:before{content:\"\\E509\"}.k-i-rotate:before{content:\"\\E50A\"}.k-i-rotate-cw:before,.k-i-rotate-right:before{content:\"\\E50B\"}.k-i-rotate-ccw:before,.k-i-rotate-left:before{content:\"\\E50C\"}.k-i-brush:before{content:\"\\E50D\"}.k-i-palette:before{content:\"\\E50E\"}.k-i-background:before,.k-i-droplet:before,.k-i-paint:before{content:\"\\E50F\"}.k-i-line:before,.k-i-shape-line:before{content:\"\\E510\"}.k-i-brightness-contrast:before{content:\"\\E511\"}.k-i-saturation:before{content:\"\\E512\"}.k-i-invert-colors:before{content:\"\\E513\"}.k-i-opacity:before,.k-i-transperancy:before{content:\"\\E514\"}.k-i-greyscale:before{content:\"\\E515\"}.k-i-blur:before{content:\"\\E516\"}.k-i-sharpen:before{content:\"\\E517\"}.k-i-shape:before{content:\"\\E518\"}.k-i-round-corners:before{content:\"\\E519\"}.k-i-front-element:before{content:\"\\E51A\"}.k-i-back-element:before{content:\"\\E51B\"}.k-i-forward-element:before{content:\"\\E51C\"}.k-i-backward-element:before{content:\"\\E51D\"}.k-i-align-left-element:before{content:\"\\E51E\"}.k-i-align-center-element:before{content:\"\\E51F\"}.k-i-align-right-element:before{content:\"\\E520\"}.k-i-align-top-element:before{content:\"\\E521\"}.k-i-align-middle-element:before{content:\"\\E522\"}.k-i-align-bottom-element:before{content:\"\\E523\"}.k-i-thumbnails-up:before{content:\"\\E524\"}.k-i-thumbnails-right:before{content:\"\\E525\"}.k-i-thumbnails-down:before{content:\"\\E526\"}.k-i-thumbnails-left:before{content:\"\\E527\"}.k-i-full-screen:before,.k-i-fullscreen-enter:before,.k-i-fullscreen:before{content:\"\\E528\"}.k-i-full-screen-exit:before,.k-i-fullscreen-exit:before{content:\"\\E529\"}.k-i-background-remove:before,.k-i-paint-remove:before,.k-i-reset-color:before{content:\"\\E52A\"}.k-i-page-properties:before{content:\"\\E600\"}.k-i-bold:before{content:\"\\E601\"}.k-i-italic:before{content:\"\\E602\"}.k-i-underline:before{content:\"\\E603\"}.k-i-font-family:before{content:\"\\E604\"}.k-i-foreground-color:before,.k-i-text:before{content:\"\\E605\"}.k-i-convert-lowercase:before{content:\"\\E606\"}.k-i-convert-uppercase:before{content:\"\\E607\"}.k-i-strike-through:before,.k-i-strikethrough:before{content:\"\\E608\"}.k-i-sub-script:before,.k-i-subscript:before{content:\"\\E609\"}.k-i-sup-script:before,.k-i-superscript:before{content:\"\\E60A\"}.k-i-div:before{content:\"\\E60B\"}.k-i-all:before{content:\"\\E60C\"}.k-i-h1:before{content:\"\\E60D\"}.k-i-h2:before{content:\"\\E60E\"}.k-i-h3:before{content:\"\\E60F\"}.k-i-h4:before{content:\"\\E610\"}.k-i-h5:before{content:\"\\E611\"}.k-i-h6:before{content:\"\\E612\"}.k-i-insert-ordered-list:before,.k-i-list-numbered:before,.k-i-list-ordered:before{content:\"\\E613\"}.k-i-insert-unordered-list:before,.k-i-list-bulleted:before,.k-i-list-unordered:before{content:\"\\E614\"}.k-i-indent-increase:before,.k-i-indent:before{content:\"\\E615\"}.k-i-indent-decrease:before,.k-i-outdent:before{content:\"\\E616\"}.k-i-insert-n:before,.k-i-insert-top:before,.k-i-insert-up:before{content:\"\\E617\"}.k-i-insert-m:before,.k-i-insert-middle:before{content:\"\\E618\"}.k-i-insert-bottom:before,.k-i-insert-down:before,.k-i-insert-s:before{content:\"\\E619\"}.k-i-align-top:before{content:\"\\E61A\"}.k-i-align-middle:before{content:\"\\E61B\"}.k-i-align-bottom:before{content:\"\\E61C\"}.k-i-align-left:before,.k-i-justify-left:before{content:\"\\E61D\"}.k-i-align-center:before,.k-i-justify-center:before{content:\"\\E61E\"}.k-i-align-right:before,.k-i-justify-right:before{content:\"\\E61F\"}.k-i-align-justify:before,.k-i-justify-full:before{content:\"\\E620\"}.k-i-align-remove:before,.k-i-justify-clear:before{content:\"\\E621\"}.k-i-text-wrap:before{content:\"\\E622\"}.k-i-rule-horizontal:before{content:\"\\E623\"}.k-i-table-align-top-left:before{content:\"\\E624\"}.k-i-table-align-top-center:before{content:\"\\E625\"}.k-i-table-align-top-right:before{content:\"\\E626\"}.k-i-table-align-middle-left:before{content:\"\\E627\"}.k-i-table-align-middle-center:before{content:\"\\E628\"}.k-i-table-align-middle-right:before{content:\"\\E629\"}.k-i-table-align-bottom-left:before{content:\"\\E62A\"}.k-i-table-align-bottom-center:before{content:\"\\E62B\"}.k-i-table-align-bottom-right:before{content:\"\\E62C\"}.k-i-table-align-remove:before{content:\"\\E62D\"}.k-i-all-borders:before,.k-i-borders-all:before{content:\"\\E62E\"}.k-i-borders-outside:before,.k-i-outside-borders:before{content:\"\\E62F\"}.k-i-borders-inside:before,.k-i-inside-borders:before{content:\"\\E630\"}.k-i-borders-inside-horizontal:before,.k-i-inside-horizontal-borders:before{content:\"\\E631\"}.k-i-borders-inside-vertical:before,.k-i-inside-vertical-borders:before{content:\"\\E632\"}.k-i-border-top:before,.k-i-top-border:before{content:\"\\E633\"}.k-i-border-bottom:before,.k-i-bottom-border:before{content:\"\\E634\"}.k-i-border-left:before,.k-i-left-border:before{content:\"\\E635\"}.k-i-border-right:before,.k-i-right-border:before{content:\"\\E636\"}.k-i-border-no:before,.k-i-no-borders:before{content:\"\\E637\"}.k-i-borders-show-hide:before{content:\"\\E638\"}.k-i-border:before,.k-i-form:before{content:\"\\E639\"}.k-i-form-element:before{content:\"\\E63A\"}.k-i-code-snippet:before{content:\"\\E63B\"}.k-i-select-all:before{content:\"\\E63C\"}.k-i-button:before{content:\"\\E63D\"}.k-i-select-box:before{content:\"\\E63E\"}.k-i-calendar-date:before{content:\"\\E63F\"}.k-i-group-box:before{content:\"\\E640\"}.k-i-textarea:before{content:\"\\E641\"}.k-i-textbox:before{content:\"\\E642\"}.k-i-textbox-hidden:before{content:\"\\E643\"}.k-i-password:before{content:\"\\E644\"}.k-i-paragraph-add:before{content:\"\\E645\"}.k-i-edit-tools:before{content:\"\\E646\"}.k-i-template-manager:before{content:\"\\E647\"}.k-i-change-manually:before{content:\"\\E648\"}.k-i-track-changes:before{content:\"\\E649\"}.k-i-track-changes-enable:before{content:\"\\E64A\"}.k-i-track-changes-accept:before{content:\"\\E64B\"}.k-i-track-changes-accept-all:before{content:\"\\E64C\"}.k-i-track-changes-reject:before{content:\"\\E64D\"}.k-i-track-changes-reject-all:before{content:\"\\E64E\"}.k-i-document-manager:before{content:\"\\E64F\"}.k-i-custom-icon:before{content:\"\\E650\"}.k-i-dictionary-add:before{content:\"\\E651\"}.k-i-image-insert:before,.k-i-image-light-dialog:before,.k-i-insert-image:before{content:\"\\E652\"}.k-i-image-edit:before{content:\"\\E653\"}.k-i-image-map-editor:before{content:\"\\E654\"}.k-i-comment:before{content:\"\\E655\"}.k-i-comment-remove:before{content:\"\\E656\"}.k-i-comments-remove-all:before{content:\"\\E657\"}.k-i-silverlight:before{content:\"\\E658\"}.k-i-media-manager:before{content:\"\\E659\"}.k-i-video-external:before{content:\"\\E65A\"}.k-i-flash-manager:before{content:\"\\E65B\"}.k-i-find-and-replace:before,.k-i-find:before{content:\"\\E65C\"}.k-i-copy:before,.k-i-files:before{content:\"\\E65D\"}.k-i-cut:before{content:\"\\E65E\"}.k-i-paste:before{content:\"\\E65F\"}.k-i-paste-as-html:before{content:\"\\E660\"}.k-i-paste-from-word:before{content:\"\\E661\"}.k-i-paste-from-word-strip-file:before{content:\"\\E662\"}.k-i-paste-html:before{content:\"\\E663\"}.k-i-paste-markdown:before{content:\"\\E664\"}.k-i-paste-plain-text:before{content:\"\\E665\"}.k-i-apply-format:before{content:\"\\E666\"}.k-i-clear-css:before,.k-i-clearformat:before{content:\"\\E667\"}.k-i-copy-format:before{content:\"\\E668\"}.k-i-strip-all-formating:before{content:\"\\E669\"}.k-i-strip-css-format:before{content:\"\\E66A\"}.k-i-strip-font-elements:before{content:\"\\E66B\"}.k-i-strip-span-elements:before{content:\"\\E66C\"}.k-i-strip-word-formatting:before{content:\"\\E66D\"}.k-i-format-code-block:before{content:\"\\E66E\"}.k-i-style-builder:before{content:\"\\E66F\"}.k-i-module-manager:before{content:\"\\E670\"}.k-i-hyperlink-insert:before,.k-i-hyperlink-light-dialog:before{content:\"\\E671\"}.k-i-hyperlink-globe:before{content:\"\\E672\"}.k-i-hyperlink-globe-remove:before{content:\"\\E673\"}.k-i-hyperlink-email:before{content:\"\\E674\"}.k-i-anchor:before{content:\"\\E675\"}.k-i-create-table:before,.k-i-table-insert:before,.k-i-table-light-dialog:before{content:\"\\E676\"}.k-i-table:before{content:\"\\E677\"}.k-i-table-properties:before,.k-i-table-wizard:before{content:\"\\E678\"}.k-i-table-cell:before{content:\"\\E679\"}.k-i-table-cell-properties:before{content:\"\\E67A\"}.k-i-add-column-left:before,.k-i-table-column-insert-left:before{content:\"\\E67B\"}.k-i-add-column-right:before,.k-i-table-column-insert-right:before{content:\"\\E67C\"}.k-i-add-row-above:before,.k-i-table-row-insert-above:before{content:\"\\E67D\"}.k-i-add-row-below:before,.k-i-table-row-insert-below:before{content:\"\\E67E\"}.k-i-delete-column:before,.k-i-table-column-delete:before{content:\"\\E67F\"}.k-i-delete-row:before,.k-i-table-row-delete:before{content:\"\\E680\"}.k-i-table-cell-delete:before{content:\"\\E681\"}.k-i-table-delete:before{content:\"\\E682\"}.k-i-cells-merge:before,.k-i-merge-cells:before{content:\"\\E683\"}.k-i-cells-merge-horizontally:before,.k-i-merge-horizontally:before{content:\"\\E684\"}.k-i-cells-merge-vertically:before,.k-i-merge-vertically:before{content:\"\\E685\"}.k-i-cell-split-horizontally:before{content:\"\\E686\"}.k-i-cell-split-vertically:before{content:\"\\E687\"}.k-i-normal-layout:before,.k-i-table-unmerge:before{content:\"\\E688\"}.k-i-freeze-panes:before,.k-i-pane-freeze:before{content:\"\\E689\"}.k-i-freeze-row:before,.k-i-row-freeze:before{content:\"\\E68A\"}.k-i-column-freeze:before,.k-i-freeze-col:before{content:\"\\E68B\"}.k-i-toolbar-float:before{content:\"\\E68C\"}.k-i-spell-checker:before{content:\"\\E68D\"}.k-i-validation-xhtml:before{content:\"\\E68E\"}.k-i-validation-data:before{content:\"\\E68F\"}.k-i-toggle-full-screen-mode:before{content:\"\\E690\"}.k-i-formula-fx:before,.k-i-fx:before,.k-spreadsheet-formula-bar:before{content:\"\\E691\"}.k-i-sum:before{content:\"\\E692\"}.k-i-symbol:before{content:\"\\E693\"}.k-i-currency:before,.k-i-dollar:before{content:\"\\E694\"}.k-i-percent:before{content:\"\\E695\"}.k-i-custom-format:before,.k-i-format-number:before{content:\"\\E696\"}.k-i-decimal-increase:before,.k-i-increase-decimal:before{content:\"\\E697\"}.k-i-decimal-decrease:before,.k-i-decrease-decimal:before{content:\"\\E698\"}.k-i-font-size:before{content:\"\\E699\"}.k-i-image-absolute-position:before{content:\"\\E69A\"}.k-i-globe-outline:before{content:\"\\E700\"}.k-i-globe:before{content:\"\\E701\"}.k-i-marker-pin:before{content:\"\\E702\"}.k-i-marker-pin-target:before{content:\"\\E703\"}.k-i-pin:before{content:\"\\E704\"}.k-i-unpin:before{content:\"\\E705\"}.k-i-share:before{content:\"\\E800\"}.k-i-user:before{content:\"\\E801\"}.k-i-inbox:before{content:\"\\E802\"}.k-i-blogger:before{content:\"\\E803\"}.k-i-blogger-box:before{content:\"\\E804\"}.k-i-delicious:before{content:\"\\E805\"}.k-i-delicious-box:before{content:\"\\E806\"}.k-i-digg:before{content:\"\\E807\"}.k-i-digg-box:before{content:\"\\E808\"}.k-i-email:before,.k-i-envelop:before,.k-i-letter:before{content:\"\\E809\"}.k-i-email-box:before,.k-i-envelop-box:before,.k-i-letter-box:before{content:\"\\E80A\"}.k-i-facebook:before{content:\"\\E80B\"}.k-i-facebook-box:before{content:\"\\E80C\"}.k-i-google:before{content:\"\\E80D\"}.k-i-google-box:before{content:\"\\E80E\"}.k-i-google-plus:before{content:\"\\E80F\"}.k-i-google-plus-box:before{content:\"\\E810\"}.k-i-linkedin:before{content:\"\\E811\"}.k-i-linkedin-box:before{content:\"\\E812\"}.k-i-myspace:before{content:\"\\E813\"}.k-i-myspace-box:before{content:\"\\E814\"}.k-i-pinterest:before{content:\"\\E815\"}.k-i-pinterest-box:before{content:\"\\E816\"}.k-i-reddit:before{content:\"\\E817\"}.k-i-reddit-box:before{content:\"\\E818\"}.k-i-stumble-upon:before{content:\"\\E819\"}.k-i-stumble-upon-box:before{content:\"\\E81A\"}.k-i-tell-a-friend:before{content:\"\\E81B\"}.k-i-tell-a-friend-box:before{content:\"\\E81C\"}.k-i-tumblr:before{content:\"\\E81D\"}.k-i-tumblr-box:before{content:\"\\E81E\"}.k-i-twitter:before{content:\"\\E81F\"}.k-i-twitter-box:before{content:\"\\E820\"}.k-i-yammer:before{content:\"\\E821\"}.k-i-yammer-box:before{content:\"\\E822\"}.k-i-behance:before{content:\"\\E823\"}.k-i-behance-box:before{content:\"\\E824\"}.k-i-dribbble:before{content:\"\\E825\"}.k-i-dribbble-box:before{content:\"\\E826\"}.k-i-rss:before{content:\"\\E827\"}.k-i-rss-box:before{content:\"\\E828\"}.k-i-vimeo:before{content:\"\\E829\"}.k-i-vimeo-box:before{content:\"\\E82A\"}.k-i-youtube:before{content:\"\\E82B\"}.k-i-youtube-box:before{content:\"\\E82C\"}.k-i-folder:before{content:\"\\E900\"}.k-i-folder-open:before{content:\"\\E901\"}.k-i-folder-add:before{content:\"\\E902\"}.k-i-folder-up:before{content:\"\\E903\"}.k-i-fields-more:before,.k-i-folder-more:before{content:\"\\E904\"}.k-i-aggregate-fields:before{content:\"\\E905\"}.k-i-file-vertical:before,.k-i-file:before,.k-i-page-portrait:before{content:\"\\E906\"}.k-i-file-add:before,.k-i-insert-file:before{content:\"\\E907\"}.k-i-file-txt:before,.k-i-txt:before{content:\"\\E908\"}.k-i-csv:before,.k-i-file-csv:before{content:\"\\E909\"}.k-i-excel:before,.k-i-file-excel:before,.k-i-file-xls:before,.k-i-xls:before,.k-i-xlsa:before{content:\"\\E90A\"}.k-i-doc:before,.k-i-file-doc:before,.k-i-file-word:before,.k-i-word:before{content:\"\\E90B\"}.k-i-file-mdb:before,.k-i-mdb:before{content:\"\\E90C\"}.k-i-file-ppt:before,.k-i-ppt:before{content:\"\\E90D\"}.k-i-file-pdf:before,.k-i-pdf:before,.k-i-pdfa:before{content:\"\\E90E\"}.k-i-file-psd:before,.k-i-psd:before{content:\"\\E90F\"}.k-i-file-flash:before,.k-i-flash:before{content:\"\\E910\"}.k-i-config:before,.k-i-file-config:before{content:\"\\E911\"}.k-i-ascx:before,.k-i-file-ascx:before{content:\"\\E912\"}.k-i-bac:before,.k-i-file-bac:before{content:\"\\E913\"}.k-i-file-zip:before,.k-i-zip:before{content:\"\\E914\"}.k-i-film:before{content:\"\\E915\"}.k-i-css3:before{content:\"\\E916\"}.k-i-html5:before{content:\"\\E917\"}.k-i-html:before,.k-i-source-code:before,.k-i-view-source:before{content:\"\\E918\"}.k-i-css:before{content:\"\\E919\"}.k-i-js:before{content:\"\\E91A\"}.k-i-exe:before{content:\"\\E91B\"}.k-i-csproj:before{content:\"\\E91C\"}.k-i-vbproj:before{content:\"\\E91D\"}.k-i-cs:before{content:\"\\E91E\"}.k-i-vb:before{content:\"\\E91F\"}.k-i-sln:before{content:\"\\E920\"}.k-i-cloud:before{content:\"\\E921\"}.k-i-file-horizontal:before,.k-i-page-landscape:before{content:\"\\E922\"}.k-rtl .k-i-collapse,.k-rtl .k-i-expand,.k-rtl .k-i-indent-decrease,.k-rtl .k-i-indent-increase{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-sprite{width:16px;height:16px;overflow:hidden;background-repeat:no-repeat;font-size:0;line-height:0;text-align:center;-ms-high-contrast-adjust:none}.k-image,.k-sprite{display:inline-block}.k-line{background-color:currentColor;border-color:currentColor}.k-line-h,.k-line-v{position:absolute}.k-line-h{height:2px}.k-line-v{width:2px}.k-loading{width:64px;height:64px;display:block}.k-loading .animate{-webkit-animation:loading 2s infinite linear;animation:loading 2s infinite linear}.k-loading-color,.k-loading-image,.k-loading-mask{width:100%;height:100%;position:absolute;top:0;left:0}.k-loading-mask{z-index:100}.k-loading-mask.k-opaque .k-loading-color{opacity:1}.k-loading-text{text-indent:-4000px;text-align:center;position:absolute}.k-loading-image{z-index:2}.k-loading-color{background-color:#fff;opacity:.3}.k-i-loading{position:relative;background-color:transparent;box-sizing:border-box;color:currentColor}.k-i-loading:after,.k-i-loading:before,.k-loading-image:after,.k-loading-image:before{position:absolute;top:50%;left:50%;display:inline-block;content:\"\";box-sizing:inherit;border-radius:50%;border:.05em solid currentColor;border-top-color:transparent;border-bottom-color:transparent;background-color:transparent}.k-icon.k-i-loading:after,.k-icon.k-i-loading:before,.k-icon.k-loading-image:after,.k-icon.k-loading-image:before{content:\"\"}.k-i-loading:before,.k-loading-image:before{margin-top:-.5em;margin-left:-.5em;width:1em;height:1em;-webkit-animation:k-loading-animation .7s linear infinite;animation:k-loading-animation .7s linear infinite}.k-i-loading:after,.k-loading-image:after{margin-top:-.25em;margin-left:-.25em;width:.5em;height:.5em;animation:k-loading-animation reverse 1.4s linear infinite}.k-loading-image:after,.k-loading-image:before{border-width:.015em;font-size:4em}@-webkit-keyframes loading{0%{stroke-dasharray:0 251;stroke-dashoffset:502}50%{stroke-dasharray:250 1}to{stroke-dasharray:0 251;stroke-dashoffset:0}}@keyframes loading{0%{stroke-dasharray:0 251;stroke-dashoffset:502}50%{stroke-dasharray:250 1}to{stroke-dasharray:0 251;stroke-dashoffset:0}}@-webkit-keyframes k-loading-animation{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes k-loading-animation{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.k-resize-handle,.k-resize-hint{position:absolute;border-color:inherit;z-index:200}.k-resize-handle{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.k-resize-handle:before{content:\"\";border:0 solid;border-color:inherit}.k-resize-n{top:-3px;cursor:n-resize}.k-resize-n,.k-resize-s{width:100%;height:6px;-ms-flex-direction:row;flex-direction:row;left:0}.k-resize-s{bottom:-3px;cursor:s-resize}.k-resize-w{left:-3px}.k-resize-e,.k-resize-w{width:6px;height:100%;-ms-flex-direction:col;flex-direction:col;top:0;cursor:w-resize}.k-resize-e{right:-3px}.k-resize-ne,.k-resize-nw,.k-resize-se,.k-resize-sw{width:5px;height:5px}.k-resize-sw{cursor:sw-resize;bottom:0;left:0}.k-resize-se{cursor:se-resize;bottom:0;right:0}.k-resize-nw{cursor:nw-resize;top:0;left:0}.k-resize-ne{cursor:ne-resize;top:0;right:0}.k-vertical-resize{cursor:row-resize}.k-horizontal-resize{cursor:col-resize}.k-resize-hint{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.k-resize-hint .k-resize-hint-handle{width:auto;height:20px;-ms-flex-item-align:stretch;align-self:stretch}.k-resize-hint .k-resize-hint-marker{width:2px;height:auto;-ms-flex:1 1 auto;flex:1 1 auto}.k-resize-hint-vertical{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.k-resize-hint-vertical .k-resize-hint-handle{width:20px;height:auto;-ms-flex-item-align:stretch;align-self:stretch}.k-resize-hint-vertical .k-resize-hint-marker{width:auto;height:2px;-ms-flex:1 1 auto;flex:1 1 auto}.k-scrollbar{position:absolute;overflow:scroll}.k-scrollbar-vertical{top:0;right:0;width:17px;height:100%;overflow-x:hidden}.k-touch-scrollbar{display:none;position:absolute;z-index:200000;height:8px;width:8px;border:1px solid #8a8a8a;background-color:#858585}.k-block ::selection,.k-panel ::selection,.k-widget ::selection{background-color:#ff6358;color:#fff}.k-marquee-color{color:#fff;border-color:rgba(0,0,0,.1)}.k-marquee-text{color:#fff}.k-ripple-target{position:relative}.k-ripple{top:0;left:0;right:0;bottom:0;z-index:1;overflow:hidden}.k-ripple,.k-ripple-blob{position:absolute;pointer-events:none}.k-ripple-blob{border-radius:50%;padding:0;-webkit-transform:translate(-50%,-50%) scale(0);transform:translate(-50%,-50%) scale(0);transition:opacity .1s linear,-webkit-transform .5s cubic-bezier(.4,0,.2,1);transition:opacity .1s linear,transform .5s cubic-bezier(.4,0,.2,1);transition:opacity .1s linear,transform .5s cubic-bezier(.4,0,.2,1),-webkit-transform .5s cubic-bezier(.4,0,.2,1);opacity:.1;background-color:currentColor}.k-primary .k-ripple-blob{opacity:.2}.k-popup{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;margin:0;padding:0;border-width:1px;border-style:solid;font-size:14px;line-height:1.4285714286;box-sizing:content-box}.k-popup>.k-widget:only-child{border-width:0}.k-popup .k-item{cursor:pointer;outline:none}.k-popup .k-rtl .k-list-optionlabel,[dir=rtl] .k-popup .k-list-optionlabel{text-align:right}.k-animation-container-shown{overflow:visible}.k-popup .k-item.k-first{position:relative}.k-popup>.k-group-header,.k-popup>.k-virtual-wrap>.k-group-header{padding:4px 8px;min-height:1.4285714286em;white-space:normal;transition:background-color .2s ease;border-bottom-width:1px;border-bottom-style:solid}.k-popup>.k-group-header{margin-top:0}.k-popup .k-list .k-item>.k-group{position:absolute;top:0;right:0;padding:0 .5em;font-size:9.996px;line-height:14px;text-transform:uppercase}.k-popup .k-list .k-item>.k-group:before{display:block;content:\" \";border-width:7px;border-style:solid;position:absolute;left:-14px;bottom:0}.k-rtl.k-popup .k-list .k-item>.k-group,[dir=rtl] .k-popup .k-list .k-item>.k-group{right:auto;left:0}.k-rtl.k-popup .k-list .k-item>.k-group:before,[dir=rtl] .k-popup .k-list .k-item>.k-group:before{right:-14px;left:auto}.k-group-header+div>.k-list>.k-item.k-first:before{content:\" \";display:block;border-top-width:1px;border-top-style:solid;position:absolute;top:-1px;left:0;right:0}.k-popup.k-popup-transparent{border-width:0;background-color:transparent}.k-popup.k-popup-flush{padding:0}.k-list-scroller{position:relative;overflow:auto}.k-list{height:auto}.k-list>.k-item{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center}.k-list>.k-item>.k-icon{-ms-flex-item-align:center;align-self:center;margin-right:8px}.k-list>.k-custom-item{font-style:italic}.k-list>.k-custom-item>.k-i-add:before,.k-list>.k-custom-item>.k-i-plus,.k-list>.k-custom-item>.k-plus:before{margin-left:auto;margin-right:0}.k-list-optionlabel,.k-list .k-item{padding:4px 8px;min-height:1.4285714286em;line-height:1.4285714286em;white-space:normal}.k-list-optionlabel{cursor:pointer;outline:none}.k-list-filter{display:block;position:relative;padding:8px;min-height:calc(24px + 1.4285714286em);box-sizing:border-box}.k-list-filter>.k-textbox{width:100%!important;box-sizing:border-box;padding-left:8px;padding-right:24px}.k-list-filter>.k-icon{position:absolute;right:16px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.k-rtl .k-list-filter>.k-textbox,[dir=rtl] .k-list-filter>.k-textbox{padding-right:8px;padding-left:24px}.k-rtl .k-list-filter>.k-icon,[dir=rtl] .k-list-filter>.k-icon{left:16px;right:auto}.k-dropdown-button .k-popup .k-item{cursor:pointer}.k-dropdown-button .k-list .k-item:focus,.k-split-button .k-list .k-item:focus{outline:none}.k-list-container .k-button{border-radius:0;padding:4px 8px;border-width:0;color:inherit;background-color:transparent;background-image:none;line-height:inherit;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start}.k-list-container .k-button .k-icon{margin:0 4px 0 0}.k-list-container .k-button.k-state-disabled{pointer-events:none}.k-list-container .k-nodata .k-button{display:-ms-inline-flexbox;display:inline-flex;border-width:1px}.k-list-container .k-separator{height:0}.k-popup{background-clip:padding-box}.k-edge12 .k-popup,.k-edge13 .k-popup,.k-ie11 .k-popup{background-clip:border-box}.k-popup>.k-group-header,.k-popup>.k-virtual-wrap>.k-group-header{border-bottom-color:rgba(0,0,0,.08);box-shadow:0 5px 10px 0 rgba(0,0,0,.06)}.k-popup .k-list .k-item>.k-group{color:#fff;background:#656565}.k-popup .k-list .k-item>.k-group:before{border-color:#656565 #656565 transparent transparent}.k-rtl.k-popup .k-list .k-item>.k-group:before,[dir=rtl] .k-popup .k-list .k-item>.k-group:before{border-color:#656565 transparent transparent #656565}.k-group-header+div>.k-list>.k-item.k-first:before{border-color:rgba(0,0,0,.08)}.k-list-optionlabel,.k-list .k-item{transition:all .2s ease}.k-list-optionlabel.k-state-hover.k-state-selected,.k-list-optionlabel:hover.k-state-selected,.k-list .k-item.k-state-hover.k-state-selected,.k-list .k-item:hover.k-state-selected{color:#fff;background-color:#ed5c52}.k-animation-container{border-radius:0 0 2px 2px}.k-animation-container-shown,.k-animation-container>.k-popup{box-shadow:0 2px 4px 0 rgba(0,0,0,.03),0 4px 5px 0 rgba(0,0,0,.04)}.k-animation-container-fixed>.k-popup,.k-list-container .k-button{box-shadow:none}.k-list-container .k-button.k-state-active,.k-list-container .k-button.k-state-hover,.k-list-container .k-button:active,.k-list-container .k-button:hover{background-image:none}.k-list-container .k-button.k-state-disabled{background:transparent}.k-list-container .k-button.k-state-focused,.k-list-container .k-button:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-list-container .k-nodata{color:hsla(0,0%,40%,.5)}.k-dropdown .k-select{border-width:0}.k-dropdown-wrap{outline:0;cursor:pointer}.k-dropdown-wrap>.k-input{-ms-flex:1;flex:1}.k-edge .k-dropdown-wrap>.k-input{min-width:0}.k-dropdown-operator{width:auto}.k-dropdown-operator .k-input{display:none}.k-dropdown-operator .k-select{width:calc(8px + 1.4285714286em);height:calc(8px + 1.4285714286em)}.k-dropdown .k-dropdown-wrap{background-clip:padding-box}.k-edge12 .k-dropdown .k-dropdown-wrap,.k-edge13 .k-dropdown .k-dropdown-wrap,.k-ie11 .k-dropdown .k-dropdown-wrap{background-clip:border-box}.k-dropdown .k-dropdown-wrap .k-select{padding:0;width:calc(8px + 1.4285714286em)}.k-pager-wrap{padding:8px;border-width:1px;line-height:1.4285714286;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow:hidden;cursor:default;-ms-flex:0 0 auto;flex:0 0 auto}.k-pager-wrap .k-link,.k-pager-wrap .k-state-selected{padding:4px;width:calc(10px + 1.4285714286em);height:calc(10px + 1.4285714286em);box-sizing:border-box;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;position:relative;text-align:center;z-index:1}.k-pager-wrap .k-link>.k-icon,.k-pager-wrap .k-state-selected>.k-icon{vertical-align:middle}.k-pager-wrap .k-link:hover,.k-pager-wrap .k-state-selected{z-index:2}.k-pager-wrap .k-link:focus,.k-pager-wrap .k-state-selected{text-decoration:none;outline:none}.k-pager-wrap .k-link.k-state-disabled{color:inherit}.k-pager-wrap .k-pager-numbers{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row}.k-pager-wrap .k-pager-numbers li{display:inline-block}.k-pager-wrap .k-pager-numbers .k-current-page{display:none}.k-pager-wrap .k-pager-numbers .k-current-page+li{margin-left:0}.k-pager-wrap .k-label{margin:0 1em;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.k-pager-wrap .k-pager-input .k-textbox{margin:0 1ex;width:3em}.k-pager-wrap .k-pager-sizes .k-dropdown,.k-pager-wrap .k-pager-sizes>select{margin:0 8px 0 0;width:5.2em}.k-pager-wrap .k-pager-refresh{-ms-flex-order:10;order:10}.k-pager-wrap .k-pager-info{-ms-flex:1;flex:1;text-align:right;-ms-flex-order:9;order:9;-ms-flex-pack:end;justify-content:flex-end}.k-pager-wrap .k-widget{font-size:inherit}.k-pager-wrap[dir=rtl] .k-i-arrow-60-left,.k-pager-wrap[dir=rtl] .k-i-arrow-60-right,.k-pager-wrap[dir=rtl] .k-i-arrow-e:before,.k-pager-wrap[dir=rtl] .k-i-arrow-end-left,.k-pager-wrap[dir=rtl] .k-i-arrow-end-right,.k-pager-wrap[dir=rtl] .k-i-arrow-w:before,.k-pager-wrap[dir=rtl] .k-i-expand-e:before,.k-pager-wrap[dir=rtl] .k-i-expand-w:before,.k-pager-wrap[dir=rtl] .k-i-expand:before,.k-pager-wrap[dir=rtl] .k-i-sarrow-e:before,.k-pager-wrap[dir=rtl] .k-i-sarrow-w:before,.k-pager-wrap[dir=rtl] .k-i-seek-e:before,.k-pager-wrap[dir=rtl] .k-i-seek-w:before,.k-rtl .k-pager-wrap .k-i-arrow-60-left,.k-rtl .k-pager-wrap .k-i-arrow-60-right,.k-rtl .k-pager-wrap .k-i-arrow-e:before,.k-rtl .k-pager-wrap .k-i-arrow-end-left,.k-rtl .k-pager-wrap .k-i-arrow-end-right,.k-rtl .k-pager-wrap .k-i-arrow-w:before,.k-rtl .k-pager-wrap .k-i-expand-e:before,.k-rtl .k-pager-wrap .k-i-expand-w:before,.k-rtl .k-pager-wrap .k-i-expand:before,.k-rtl .k-pager-wrap .k-i-sarrow-e:before,.k-rtl .k-pager-wrap .k-i-sarrow-w:before,.k-rtl .k-pager-wrap .k-i-seek-e:before,.k-rtl .k-pager-wrap .k-i-seek-w:before,[dir=rtl] .k-pager-wrap .k-i-arrow-60-left,[dir=rtl] .k-pager-wrap .k-i-arrow-60-right,[dir=rtl] .k-pager-wrap .k-i-arrow-e:before,[dir=rtl] .k-pager-wrap .k-i-arrow-end-left,[dir=rtl] .k-pager-wrap .k-i-arrow-end-right,[dir=rtl] .k-pager-wrap .k-i-arrow-w:before,[dir=rtl] .k-pager-wrap .k-i-expand-e:before,[dir=rtl] .k-pager-wrap .k-i-expand-w:before,[dir=rtl] .k-pager-wrap .k-i-expand:before,[dir=rtl] .k-pager-wrap .k-i-sarrow-e:before,[dir=rtl] .k-pager-wrap .k-i-sarrow-w:before,[dir=rtl] .k-pager-wrap .k-i-seek-e:before,[dir=rtl] .k-pager-wrap .k-i-seek-w:before{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-pager-wrap[dir=rtl] .k-pager-sizes .k-dropdown,.k-pager-wrap[dir=rtl] .k-pager-sizes>select,.k-rtl .k-pager-wrap .k-pager-sizes .k-dropdown,.k-rtl .k-pager-wrap .k-pager-sizes>select,[dir=rtl] .k-pager-wrap .k-pager-sizes .k-dropdown,[dir=rtl] .k-pager-wrap .k-pager-sizes>select{margin-right:0;margin-left:8px}.k-pager-wrap.k-pager-lg,.k-pager-wrap.k-pager-md,.k-pager-wrap.k-pager-sm{position:relative;overflow:visible}.k-pager-wrap.k-pager-lg .k-pager-numbers,.k-pager-wrap.k-pager-md .k-pager-numbers,.k-pager-wrap.k-pager-sm .k-pager-numbers{border-radius:2px;position:absolute;overflow:hidden;left:calc(32px + 2.8571428571em);-ms-flex-direction:column-reverse;flex-direction:column-reverse;height:auto;bottom:50%;z-index:3;border-style:solid;border-width:1px;-webkit-transform:translateY(1px) translateY(4px) translateY(.7142857143em) translateY(1px);transform:translateY(1px) translateY(4px) translateY(.7142857143em) translateY(1px)}.k-pager-wrap.k-pager-lg .k-pager-numbers li:not(.k-current-page),.k-pager-wrap.k-pager-md .k-pager-numbers li:not(.k-current-page),.k-pager-wrap.k-pager-sm .k-pager-numbers li:not(.k-current-page){display:none}.k-pager-wrap.k-pager-lg .k-pager-numbers .k-current-page,.k-pager-wrap.k-pager-md .k-pager-numbers .k-current-page,.k-pager-wrap.k-pager-sm .k-pager-numbers .k-current-page{display:-ms-inline-flexbox;display:inline-flex;cursor:pointer}.k-pager-wrap.k-pager-lg .k-pager-numbers .k-link,.k-pager-wrap.k-pager-lg .k-pager-numbers .k-state-selected,.k-pager-wrap.k-pager-md .k-pager-numbers .k-link,.k-pager-wrap.k-pager-md .k-pager-numbers .k-state-selected,.k-pager-wrap.k-pager-sm .k-pager-numbers .k-link,.k-pager-wrap.k-pager-sm .k-pager-numbers .k-state-selected{border-width:0;width:calc(20px + 2.8571428571em)}.k-pager-wrap.k-pager-lg .k-pager-numbers.k-state-expanded li,.k-pager-wrap.k-pager-md .k-pager-numbers.k-state-expanded li,.k-pager-wrap.k-pager-sm .k-pager-numbers.k-state-expanded li{display:-ms-inline-flexbox;display:inline-flex}.k-pager-wrap.k-pager-lg .k-pager-numbers.k-state-expanded .k-current-page,.k-pager-wrap.k-pager-md .k-pager-numbers.k-state-expanded .k-current-page,.k-pager-wrap.k-pager-sm .k-pager-numbers.k-state-expanded .k-current-page{border-style:solid;border-width:1px 0 0}.k-pager-wrap.k-pager-lg .k-pager-numbers+.k-link,.k-pager-wrap.k-pager-lg .k-pager-numbers+.k-pager-input,.k-pager-wrap.k-pager-md .k-pager-numbers+.k-link,.k-pager-wrap.k-pager-md .k-pager-numbers+.k-pager-input,.k-pager-wrap.k-pager-sm .k-pager-numbers+.k-link,.k-pager-wrap.k-pager-sm .k-pager-numbers+.k-pager-input{margin-left:calc(30px + 2.8571428571em)}.k-pager-wrap.k-pager-lg .k-pager-numbers:first-child,.k-pager-wrap.k-pager-md .k-pager-numbers:first-child,.k-pager-wrap.k-pager-sm .k-pager-numbers:first-child{left:1em}.k-pager-wrap.k-pager-lg[dir=rtl] .k-pager-numbers,.k-pager-wrap.k-pager-md[dir=rtl] .k-pager-numbers,.k-pager-wrap.k-pager-sm[dir=rtl] .k-pager-numbers,.k-rtl .k-pager-wrap.k-pager-lg .k-pager-numbers,.k-rtl .k-pager-wrap.k-pager-md .k-pager-numbers,.k-rtl .k-pager-wrap.k-pager-sm .k-pager-numbers,[dir=rtl] .k-pager-wrap.k-pager-lg .k-pager-numbers,[dir=rtl] .k-pager-wrap.k-pager-md .k-pager-numbers,[dir=rtl] .k-pager-wrap.k-pager-sm .k-pager-numbers{left:auto;right:calc(32px + 2.8571428571em)}.k-pager-wrap.k-pager-lg[dir=rtl] .k-pager-numbers+.k-link,.k-pager-wrap.k-pager-lg[dir=rtl] .k-pager-numbers+.k-pager-input,.k-pager-wrap.k-pager-md[dir=rtl] .k-pager-numbers+.k-link,.k-pager-wrap.k-pager-md[dir=rtl] .k-pager-numbers+.k-pager-input,.k-pager-wrap.k-pager-sm[dir=rtl] .k-pager-numbers+.k-link,.k-pager-wrap.k-pager-sm[dir=rtl] .k-pager-numbers+.k-pager-input,.k-rtl .k-pager-wrap.k-pager-lg .k-pager-numbers+.k-link,.k-rtl .k-pager-wrap.k-pager-lg .k-pager-numbers+.k-pager-input,.k-rtl .k-pager-wrap.k-pager-md .k-pager-numbers+.k-link,.k-rtl .k-pager-wrap.k-pager-md .k-pager-numbers+.k-pager-input,.k-rtl .k-pager-wrap.k-pager-sm .k-pager-numbers+.k-link,.k-rtl .k-pager-wrap.k-pager-sm .k-pager-numbers+.k-pager-input,[dir=rtl] .k-pager-wrap.k-pager-lg .k-pager-numbers+.k-link,[dir=rtl] .k-pager-wrap.k-pager-lg .k-pager-numbers+.k-pager-input,[dir=rtl] .k-pager-wrap.k-pager-md .k-pager-numbers+.k-link,[dir=rtl] .k-pager-wrap.k-pager-md .k-pager-numbers+.k-pager-input,[dir=rtl] .k-pager-wrap.k-pager-sm .k-pager-numbers+.k-link,[dir=rtl] .k-pager-wrap.k-pager-sm .k-pager-numbers+.k-pager-input{margin-left:0;margin-right:calc(30px + 2.8571428571em)}.k-pager-wrap.k-pager-lg[dir=rtl] .k-pager-numbers:first-child,.k-pager-wrap.k-pager-md[dir=rtl] .k-pager-numbers:first-child,.k-pager-wrap.k-pager-sm[dir=rtl] .k-pager-numbers:first-child,.k-rtl .k-pager-wrap.k-pager-lg .k-pager-numbers:first-child,.k-rtl .k-pager-wrap.k-pager-md .k-pager-numbers:first-child,.k-rtl .k-pager-wrap.k-pager-sm .k-pager-numbers:first-child,[dir=rtl] .k-pager-wrap.k-pager-lg .k-pager-numbers:first-child,[dir=rtl] .k-pager-wrap.k-pager-md .k-pager-numbers:first-child,[dir=rtl] .k-pager-wrap.k-pager-sm .k-pager-numbers:first-child{right:1em}.k-pager-wrap.k-pager-md .k-pager-info,.k-pager-wrap.k-pager-sm .k-pager-info{display:none}.k-pager-wrap.k-pager-md .k-pager-refresh,.k-pager-wrap.k-pager-sm .k-pager-refresh{margin-left:auto}.k-pager-wrap.k-pager-md[dir=rtl] .k-pager-refresh,.k-pager-wrap.k-pager-sm[dir=rtl] .k-pager-refresh,.k-rtl .k-pager-wrap.k-pager-md .k-pager-refresh,.k-rtl .k-pager-wrap.k-pager-sm .k-pager-refresh,[dir=rtl] .k-pager-wrap.k-pager-md .k-pager-refresh,[dir=rtl] .k-pager-wrap.k-pager-sm .k-pager-refresh{margin-left:0;margin-right:auto}.k-pager-wrap.k-pager-sm .k-pager-sizes{display:none}.k-pager-wrap{color:#656565;background-color:#f6f6f6}.k-pager-wrap.k-pager-lg .k-pager-numbers,.k-pager-wrap.k-pager-md .k-pager-numbers,.k-pager-wrap.k-pager-sm .k-pager-numbers{border-color:rgba(0,0,0,.08);background-color:#f6f6f6}.k-pager-wrap.k-pager-lg .k-pager-numbers.k-state-expanded .k-current-page,.k-pager-wrap.k-pager-md .k-pager-numbers.k-state-expanded .k-current-page,.k-pager-wrap.k-pager-sm .k-pager-numbers.k-state-expanded .k-current-page{border-color:rgba(0,0,0,.08)}.k-pager-nav:hover{color:#ff6358;background-color:#656565}.k-pager-nav:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-pager-numbers .k-link{color:#ff6358}.k-pager-numbers .k-link:hover{color:#ff6358;background-color:#656565}.k-pager-numbers .k-link:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-pager-numbers .k-state-selected{color:#fff;background-color:#ff6358}.k-button{border-radius:2px;padding:4px 8px;box-sizing:border-box;border-width:1px;border-style:solid;font-size:14px;line-height:1.4285714286;font-family:inherit;text-align:center;text-decoration:none;white-space:nowrap;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:none;-webkit-appearance:none;position:relative}.k-button::-moz-focus-inner{padding:0;border:0;outline:0}.k-button:focus,.k-button:hover{text-decoration:none;outline:0}.k-button .k-icon,.k-button .k-image,.k-button .k-sprite{color:inherit;-ms-flex-item-align:center;align-self:center;position:relative}.k-button-icontext{overflow:visible}.k-button-icontext .k-icon,.k-button-icontext .k-image,.k-button-icontext .k-sprite{margin:0 4px 0 -4px}.k-button-icontext[dir=rtl] .k-icon,.k-button-icontext[dir=rtl] .k-image,.k-button-icontext[dir=rtl] .k-sprite,.k-rtl .k-button-icontext .k-icon,.k-rtl .k-button-icontext .k-image,.k-rtl .k-button-icontext .k-sprite{margin:0 -4px 0 4px}.k-button-icon{width:calc(10px + 1.4285714286em);height:calc(10px + 1.4285714286em);padding:4px}.k-button-icon .k-text{display:none}.k-dropdown-button.k-state-focused,.k-dropdown-button:focus{outline:0}.k-dropdown-button.k-widget{border-radius:2px;border-width:0;display:inline-block}.k-button-group{margin:0;padding:0;list-style:none;outline:0;white-space:nowrap;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row;vertical-align:middle;position:relative}.k-button-group .k-button{border-radius:0}.k-button-group .k-button~.k-button{margin-left:-1px}.k-button-group .k-button.k-state-active,.k-button-group .k-button.k-state-hover,.k-button-group .k-button:active,.k-button-group .k-button:hover{z-index:2}.k-button-group .k-state-disabled,.k-button-group [disabled]{pointer-events:none}.k-button-group .k-button:first-child,.k-button-group .k-group-start{border-top-left-radius:2px;border-bottom-left-radius:2px}.k-button-group .k-button:last-child,.k-button-group .k-group-end{border-top-right-radius:2px;border-bottom-right-radius:2px}.k-button-group .k-button:first-child:last-child,.k-button-group .k-group-start.k-group-end{border-radius:2px}.k-button-group>input[type=checkbox],.k-button-group>input[type=radio],.k-button-group label input[type=checkbox],.k-button-group label input[type=radio]{margin:0;padding:0;clip:rect(0,0,0,0);position:absolute;pointer-events:none}.k-button-group-stretched{display:-ms-flexbox;display:flex}.k-button-group-stretched .k-button{display:inline-block;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden;text-overflow:ellipsis}.k-button-group-stretched .k-button>.k-icon{vertical-align:text-bottom}.k-split-button.k-button-group.k-state-focused{border-radius:2px}.k-split-button.k-widget{border-radius:2px;border-width:0}.k-split-button.k-button-group .k-button:first-child{border-top-left-radius:2px;border-bottom-left-radius:2px}.k-split-button.k-button-group .k-button:nth-child(2){border-top-right-radius:2px;border-bottom-right-radius:2px}.k-button.k-bare,.k-button.k-flat,.k-calendar .k-calendar-header .k-button,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-toolbar>.k-button-group>.k-button,.k-toolbar>.k-button:not(.k-overflow-anchor){border-color:transparent!important;color:inherit;background:none!important;box-shadow:none!important;transition:color .2s ease-in-out}.k-button.k-bare.k-state-active,.k-button.k-bare.k-state-hover,.k-button.k-bare:active,.k-button.k-bare:hover,.k-button.k-bare:hover.k-state-active,.k-button.k-bare:hover:active,.k-button.k-flat.k-state-active,.k-button.k-flat.k-state-hover,.k-button.k-flat:active,.k-button.k-flat:hover,.k-button.k-flat:hover.k-state-active,.k-button.k-flat:hover:active,.k-calendar .k-calendar-header .k-button:active,.k-calendar .k-calendar-header .k-button:hover,.k-calendar .k-calendar-header .k-button:hover.k-state-active,.k-calendar .k-calendar-header .k-button:hover:active,.k-calendar .k-calendar-header .k-state-active.k-button,.k-calendar .k-calendar-header .k-state-hover.k-button,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button.k-state-active,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button.k-state-hover,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button:active,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button:hover,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button:hover.k-state-active,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button:hover:active,.k-toolbar>.k-button-group>.k-button:active,.k-toolbar>.k-button-group>.k-button:hover,.k-toolbar>.k-button-group>.k-button:hover.k-state-active,.k-toolbar>.k-button-group>.k-button:hover:active,.k-toolbar>.k-button-group>.k-state-active.k-button,.k-toolbar>.k-button-group>.k-state-hover.k-button,.k-toolbar>.k-button:active:not(.k-overflow-anchor),.k-toolbar>.k-button:hover.k-state-active:not(.k-overflow-anchor),.k-toolbar>.k-button:hover:active:not(.k-overflow-anchor),.k-toolbar>.k-button:hover:not(.k-overflow-anchor),.k-toolbar>.k-state-active.k-button:not(.k-overflow-anchor),.k-toolbar>.k-state-hover.k-button:not(.k-overflow-anchor){color:inherit}.k-button.k-bare:before,.k-button.k-flat:before,.k-calendar .k-calendar-header .k-button:before,.k-calendar .k-calendar-header .k-toolbar .k-dropdown-wrap:before,.k-calendar .k-calendar-header .k-toolbar .k-picker-wrap:before,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button:before,.k-toolbar .k-bare.k-dropdown-wrap:before,.k-toolbar .k-bare.k-picker-wrap:before,.k-toolbar .k-calendar .k-calendar-header .k-dropdown-wrap:before,.k-toolbar .k-calendar .k-calendar-header .k-picker-wrap:before,.k-toolbar .k-calendar.k-calendar-range.k-calendar-infinite>.k-dropdown-wrap:before,.k-toolbar .k-calendar.k-calendar-range.k-calendar-infinite>.k-picker-wrap:before,.k-toolbar .k-flat.k-dropdown-wrap:before,.k-toolbar .k-flat.k-picker-wrap:before,.k-toolbar>.k-button-group>.k-button:before,.k-toolbar>.k-button-group>.k-dropdown-wrap:before,.k-toolbar>.k-button-group>.k-picker-wrap:before,.k-toolbar>.k-button:not(.k-overflow-anchor):before,.k-toolbar>.k-dropdown-wrap:not(.k-overflow-anchor):before,.k-toolbar>.k-picker-wrap:not(.k-overflow-anchor):before{display:block}.k-button.k-outline{color:inherit}.k-rtl .k-button-group .k-button~.k-button{margin-right:-1px;margin-left:0}.k-rtl .k-button-group .k-button{border-radius:0}.k-rtl .k-button-group .k-button:first-child,.k-rtl .k-button-group .k-group-start{border-top-right-radius:2px;border-bottom-right-radius:2px}.k-rtl .k-button-group .k-button:last-child,.k-rtl .k-button-group .k-group-end{border-top-left-radius:2px;border-bottom-left-radius:2px}.k-rtl .k-button-group .k-button:first-child:last-child,.k-rtl .k-button-group .k-group-start.k-group-end{border-radius:2px}.k-rtl .k-split-button .k-button{border-radius:0 2px 2px 0}.k-rtl .k-split-button .k-split-button-arrow{border-radius:2px 0 0 2px;margin-left:0;margin-right:-1px}.k-button:before,.k-toolbar .k-dropdown-wrap:before,.k-toolbar .k-picker-wrap:before{border-radius:inherit;content:\"\";background:currentColor;opacity:0;display:none;pointer-events:none;position:absolute;left:-1px;right:-1px;top:-1px;bottom:-1px;z-index:0;transition:opacity .2s ease-in-out}.k-button.k-state-hover:before,.k-button:hover:before,.k-toolbar .k-dropdown-wrap:hover:before,.k-toolbar .k-picker-wrap:hover:before,.k-toolbar .k-state-hover.k-dropdown-wrap:before,.k-toolbar .k-state-hover.k-picker-wrap:before{opacity:.08}.k-button.k-no-focus:not(.k-state-hover):before,.k-button.k-no-focus:not(:hover):before,.k-toolbar .k-no-focus.k-dropdown-wrap:not(.k-state-hover):before,.k-toolbar .k-no-focus.k-dropdown-wrap:not(:hover):before,.k-toolbar .k-no-focus.k-picker-wrap:not(.k-state-hover):before,.k-toolbar .k-no-focus.k-picker-wrap:not(:hover):before{opacity:0}.k-button.k-state-active:before,.k-button:active:before,.k-toolbar .k-dropdown-wrap:active:before,.k-toolbar .k-picker-wrap:active:before,.k-toolbar .k-state-active.k-dropdown-wrap:before,.k-toolbar .k-state-active.k-picker-wrap:before{opacity:.16}.k-button.k-state-selected:before,.k-toolbar .k-state-selected.k-dropdown-wrap:before,.k-toolbar .k-state-selected.k-picker-wrap:before{opacity:.2}.k-button:after{border-radius:2px;content:\"\";opacity:0;display:none;pointer-events:none;position:absolute;left:-1px;right:-1px;top:-1px;bottom:-1px;z-index:0;transition:opacity .2s ease-in-out}.k-ie9 .k-button.k-state-disabled:focus,.k-ie9 .k-button.k-state-disabled:hover,.k-ie9 .k-button[disabled]:focus,.k-ie9 .k-button[disabled]:hover,.k-ie10 .k-button.k-state-disabled:focus,.k-ie10 .k-button.k-state-disabled:hover,.k-ie10 .k-button[disabled]:focus,.k-ie10 .k-button[disabled]:hover{outline:none;cursor:default;opacity:.6;box-shadow:none}.k-ie9 .k-button,.k-ie9 .k-button-group,.k-ie10 .k-button,.k-ie10 .k-button-group,.k-ie11 .k-button,.k-ie11 .k-button-group{display:inline-block}.k-button{background-clip:padding-box}.k-edge12 .k-button,.k-edge13 .k-button,.k-ie11 .k-button{background-clip:border-box}.k-button.k-state-focused,.k-button:focus{box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-button.k-state-active,.k-button.k-state-selected,.k-button:active{box-shadow:inset 0 2px 2px 0 rgba(0,0,0,.06)}.k-button.k-primary.k-state-focused,.k-button.k-primary:focus{box-shadow:0 3px 4px 0 rgba(255,99,88,.4)}.k-button.k-primary.k-state-active,.k-button.k-primary.k-state-selected,.k-button.k-primary:active,.k-dropdown-button.k-state-active>.k-button:not(:disabled),.k-dropdown-button:active>.k-button:not(:disabled){box-shadow:inset 0 2px 2px 0 rgba(0,0,0,.06)}.k-dropdown-button.k-state-focused>.k-button,.k-dropdown-button:focus>.k-button{box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-dropdown-button .k-widget{border-width:0;display:inline-block}.k-button-group{background-clip:padding-box}.k-edge12 .k-button-group,.k-edge13 .k-button-group,.k-ie11 .k-button-group{background-clip:border-box}.k-button-group .k-button.k-state-focused,.k-button-group .k-button:focus,.k-button-group>input[type=checkbox]:focus+.k-button,.k-button-group>input[type=radio]:focus+.k-button{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-button-group .k-button.k-state-active,.k-button-group .k-button.k-state-selected,.k-button-group .k-button:active,.k-button-group>input[type=checkbox]:checked+.k-button,.k-button-group>input[type=radio]:checked+.k-button{box-shadow:inset 0 2px 2px 0 rgba(0,0,0,.06)}.k-split-button.k-state-focused,.k-split-button:focus{outline:none;box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-split-button.k-button-group .k-button.k-state-active,.k-split-button.k-button-group .k-button:active{box-shadow:inset 0 2px 2px 0 rgba(0,0,0,.06)}.k-button.k-outline{border-color:currentColor;color:#656565;background:none;box-shadow:none}.k-button.k-outline.k-state-hover,.k-button.k-outline:hover{border-color:#656565;color:#fff;background-color:#656565;background-image:none}.k-button.k-outline.k-state-focused,.k-button.k-outline:focus{box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-button.k-outline.k-state-active,.k-button.k-outline.k-state-selected,.k-button.k-outline:active{border-color:#656565;color:#fff;background-color:#656565;background-image:none}.k-button.k-primary.k-outline{border-color:currentColor;color:#ff6358;background:none;box-shadow:none}.k-button.k-primary.k-outline.k-state-hover,.k-button.k-primary.k-outline:hover{border-color:#ff6358;color:#fff;background-color:#ff6358;background-image:none}.k-button.k-primary.k-outline.k-state-focused,.k-button.k-primary.k-outline:focus{box-shadow:0 3px 4px 0 rgba(255,99,88,.4)}.k-button.k-primary.k-outline.k-state-active,.k-button.k-primary.k-outline.k-state-selected,.k-button.k-primary.k-outline:active{border-color:#ff6358;color:#fff;background-color:#ff6358;background-image:none;box-shadow:none}.k-button-group .k-button.k-bare,.k-button-group .k-button.k-flat,.k-button-group .k-calendar .k-calendar-header .k-button,.k-button-group .k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-button-group .k-toolbar>.k-button:not(.k-overflow-anchor),.k-button.k-bare,.k-button.k-flat,.k-calendar .k-calendar-header .k-button,.k-calendar .k-calendar-header .k-button-group .k-button,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-toolbar>.k-button-group>.k-button,.k-toolbar>.k-button:not(.k-overflow-anchor){color:inherit;background:none}.k-button.k-bare:after,.k-button.k-flat:after,.k-calendar .k-calendar-header .k-button:after,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button:after,.k-toolbar>.k-button-group>.k-button:after,.k-toolbar>.k-button:not(.k-overflow-anchor):after{display:block}.k-button.k-bare.k-state-focused:after,.k-button.k-bare:focus:after,.k-button.k-flat.k-state-focused:after,.k-button.k-flat:focus:after,.k-calendar .k-calendar-header .k-button:focus:after,.k-calendar .k-calendar-header .k-state-focused.k-button:after,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button.k-state-focused:after,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button:focus:after,.k-toolbar>.k-button-group>.k-button:focus:after,.k-toolbar>.k-button-group>.k-state-focused.k-button:after,.k-toolbar>.k-button:not(.k-overflow-anchor):focus:after,.k-toolbar>.k-state-focused.k-button:not(.k-overflow-anchor):after{box-shadow:inset 0 0 0 2px currentColor;opacity:.12}.k-button-group .k-button.k-primary.k-bare,.k-button-group .k-button.k-primary.k-flat,.k-button-group .k-calendar .k-calendar-header .k-primary.k-button,.k-button-group .k-calendar.k-calendar-range.k-calendar-infinite>.k-button.k-primary,.k-button-group .k-toolbar>.k-primary.k-button:not(.k-overflow-anchor),.k-button.k-primary.k-bare,.k-button.k-primary.k-flat,.k-calendar .k-calendar-header .k-button-group .k-primary.k-button,.k-calendar .k-calendar-header .k-primary.k-button,.k-calendar.k-calendar-range.k-calendar-infinite>.k-button.k-primary,.k-toolbar>.k-button-group>.k-primary.k-button,.k-toolbar>.k-primary.k-button:not(.k-overflow-anchor){color:#ff6358;background:none}.k-action-buttons{border-width:1px 0 0;border-style:solid;border-color:inherit;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;clear:both}.k-action-buttons .k-button{border-radius:0;padding:12px 16px;border-width:0;border-color:inherit;background:none;-ms-flex:1 1 auto;flex:1 1 auto}.k-action-buttons .k-button+.k-button{border-left-width:1px}.k-rtl .k-action-buttons .k-button+.k-button,[dir=rtl] .k-action-buttons .k-button+.k-button{border-left-width:0;border-right-width:1px;border-right-style:solid;margin-left:0}.k-action-buttons{border-color:rgba(0,0,0,.08)}.k-action-buttons .k-button{color:inherit}.k-action-buttons .k-button.k-state-hover,.k-action-buttons .k-button:hover{border-color:inherit}.k-action-buttons .k-button.k-state-focused,.k-action-buttons .k-button:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-action-buttons .k-button.k-state-active,.k-action-buttons .k-button:active{border-color:inherit}.k-action-buttons .k-primary{color:#ff6358}.k-action-buttons .k-primary.k-state-hvoer,.k-action-buttons .k-primary:hover{border-color:inherit}.k-action-buttons .k-primary.k-state-hvoer.k-state-focused,.k-action-buttons .k-primary.k-state-hvoer:focus,.k-action-buttons .k-primary:hover.k-state-focused,.k-action-buttons .k-primary:hover:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-action-buttons .k-primary.k-state-focused,.k-action-buttons .k-primary:focus{box-shadow:inset 0 0 0 2px hsla(0,0%,93%,.3)}.k-action-buttons .k-primary.k-state-active,.k-action-buttons .k-primary:active{border-color:inherit}.k-edit-form-container{width:400px;min-width:400px;border-color:inherit;position:relative}.k-edit-form-container .k-tabstrip-wrapper{margin:-16px}.k-edit-form-container .k-tabstrip.k-root-tabs{margin-bottom:16px}.k-edit-form-container .k-tabstrip .k-tabstrip-items{padding:16px 16px 0}.k-edit-form-container .k-tabstrip .k-content{padding:16px;border-width:0}.k-edit-buttons{padding:8px;border-width:1px 0 0;border-style:solid;border-color:inherit;text-align:right;clear:both}.k-edit-buttons .k-button+.k-button{margin-left:.5em}.k-edit-form-container .k-edit-buttons{margin:16px -16px -16px;padding:16px}.k-edit-form-container .k-action-buttons,.k-popup-edit-form>.k-action-buttons{margin:1em -16px -16px}.k-edit-label{margin:0 0 1em;padding:5px 0;width:30%;line-height:1.4285714286;text-align:right;float:left;clear:both}.k-edit-field{margin:0 0 1em;width:65%;float:right;clear:right}.k-edit-field>.k-input.k-textbox,.k-edit-field>.k-textbox,.k-edit-field>.k-widget{width:100%;box-sizing:border-box}.k-edit-field>.k-colorpicker{width:auto}.k-edit-field input[type=checkbox]:not(.k-checkbox),.k-edit-field input[type=radio]:not(.k-radio){margin-right:.4ex}.k-edit-field .k-checkbox-label,.k-edit-field .k-radio-label{margin-right:1em}.k-edit-field .k-checkbox-label{margin-top:5px}.k-edit-field .k-reset>li+li{margin-top:.5em}.k-edit-field .k-reset .k-widget{margin:0 .4ex 0 1ex}.k-rtl .k-edit-buttons{text-align:left}.k-rtl .k-edit-buttons .k-button+.k-button{margin-left:0;margin-right:.5em}.k-window{border-radius:0;padding:0;border-width:0;border-style:solid;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:column;flex-direction:column;position:absolute;z-index:10002}.k-window .k-overlay{position:absolute;opacity:0}.k-window.k-window-maximized{max-width:100vw;max-height:100vh;box-shadow:none}.k-window-sm{width:300px}.k-window-md{width:800px}.k-window-lg{width:1200px}.k-window-titlebar{border-top-left-radius:0;border-top-right-radius:0;padding:12px 16px;border-width:0 0 1px;border-style:solid;white-space:nowrap;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center}.k-window-title{margin:-.15em 0;font-size:19px;line-height:1.3;text-overflow:ellipsis;overflow:hidden;cursor:default;-ms-flex:1;flex:1}.k-window-actions{margin:-5px;line-height:1;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;vertical-align:top}.k-prompt-container,.k-window-content{padding:16px;border:0;color:inherit;background:none;outline:0;overflow:auto;position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.k-window-content+.k-prompt-container{margin-top:-8px}.k-window-iframecontent{padding:0;overflow:visible}.k-window-iframecontent .k-content-frame{vertical-align:top;border:0;width:100%;height:100%}.k-window{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff;box-shadow:0 3px 3px 0 rgba(0,0,0,.06)}.k-window.k-state-focused{box-shadow:1px 1px 7px 1px rgba(0,0,0,.3)}.k-window-titlebar{border-color:inherit;color:#656565;background-color:#f6f6f6;background-clip:padding-box}.k-edge12 .k-window-titlebar,.k-edge13 .k-window-titlebar,.k-ie11 .k-window-titlebar{background-clip:border-box}.k-dialog-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;position:fixed;top:0;left:0;width:100%;height:100%;z-index:10001}.k-dialog-wrapper .k-dialog{position:relative}.k-dialog{padding:0;position:fixed;box-sizing:border-box}.k-dialog.k-dialog-centered{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);top:50%;left:50%}.k-dialog-close{-ms-flex-item-align:end;align-self:flex-end}.k-dialog-buttongroup{border-bottom-right-radius:0;border-bottom-left-radius:0;padding:8px;border-width:1px 0 0;border-style:solid;border-color:inherit;-ms-flex:0 0 auto;flex:0 0 auto;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;overflow:hidden}.k-dialog-buttongroup .k-button{width:auto!important;max-width:100%}.k-dialog-buttongroup .k-button~.k-button{margin-left:8px}.k-rtl .k-dialog-buttongroup .k-button~.k-button,[dir=rtl] .k-dialog-buttongroup .k-button~.k-button{margin-left:0;margin-right:8px}.k-dialog-button-layout-stretched{padding:0;-ms-flex-align:stretch;align-items:stretch}.k-dialog-button-layout-stretched .k-button{border-radius:0;padding:12px 16px;border-width:0;text-overflow:ellipsis;-ms-flex:1 0 0px;flex:1 0 0;display:inline-block;overflow:hidden}.k-dialog-button-layout-stretched .k-button~.k-button{margin:0;border-left-width:1px}.k-rtl .k-dialog-button-layout-stretched .k-button~.k-button,[dir=rtl] .k-dialog-button-layout-stretched .k-button~.k-button{margin:0;border-left-width:0;border-right-width:1px}.k-window-sm .k-dialog-button-layout-stretched{-ms-flex-direction:column;flex-direction:column}.k-window-sm .k-dialog-button-layout-stretched .k-button{-ms-flex:0 0 auto;flex:0 0 auto;padding:8px}.k-window-sm .k-dialog-button-layout-stretched .k-button~.k-button{border-width:0;border-top-width:1px}.k-window-md .k-dialog-button-layout-stretched .k-button{padding:12px}.k-no-flexbox .k-dialog-buttongroup{display:block;text-align:right}.k-no-flexbox .k-window-sm .k-dialog-button-layout-stretched .k-button{display:block}.k-no-flexbox .k-rtl .k-dialog-buttongroup,.k-no-flexbox [dir=rtl] .k-dialog-buttongroup{text-align:left}.k-dialog-titlebar{color:#fff;background-color:#ff6358}.k-dialog-button-layout-stretched .k-button,.k-dialog-titlebar{border-color:inherit}.k-dialog-button-layout-stretched .k-button:not(:hover):not(.k-state-hover):not(:active):not(.k-state-active){color:inherit;background:none}.k-dialog-button-layout-stretched .k-primary:not(:hover):not(.k-state-hover):not(:active):not(.k-state-active){color:#ff6358}.k-dialog-button-layout-stretched .k-button.k-state-focused,.k-dialog-button-layout-stretched .k-button:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-dialog-button-layout-stretched .k-button.k-primary.k-state-focused,.k-dialog-button-layout-stretched .k-button.k-primary:focus{box-shadow:inset 0 0 0 2px rgba(255,99,88,.3)}.k-grid{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;position:relative}.k-grid.k-display-block{display:block}.k-grid .k-grid-container{display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden;position:relative}.k-grid .k-grid-aria-root{border-color:inherit;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden}.k-grid table{margin:0;width:100%;max-width:none;border-width:0;border-color:inherit;border-collapse:separate;border-spacing:0;empty-cells:show;outline:0}.k-grid tbody,.k-grid tfoot,.k-grid thead{text-align:left;border-color:inherit}.k-grid tr{border-color:inherit}.k-grid td,.k-grid th{padding:8px 12px;border-style:solid;border-color:inherit;outline:0;font-weight:inherit;text-align:inherit;overflow:hidden;text-overflow:ellipsis}.k-grid td:first-child,.k-grid th:first-child{border-left-width:0}.k-grid td:focus,.k-grid th:focus{outline:none}.k-grid th{padding:8px 12px;border-width:0 0 1px 1px;white-space:nowrap}.k-grid td{border-width:0 0 0 1px;vertical-align:middle}.k-grid a{color:inherit}.k-grid a,.k-grid a:hover{text-decoration:none}.k-grid .k-grid-header-wrap,.k-grid table{box-sizing:content-box}.k-grid .k-group-col,.k-grid .k-hierarchy-col{padding:0;width:32px}.k-grid .k-grouping-row p{margin:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center}.k-grid .k-grouping-row td{overflow:visible}.k-grid .k-grouping-row+tr td{border-top-width:1px}.k-grid .k-grouping-row+tr .k-group-cell,.k-grid .k-grouping-row .k-group-cell{border-top-width:0;text-overflow:none}.k-grid .k-grouping-row .k-icon{margin-left:-4px;margin-right:8px}.k-grid .k-group-footer td{border-style:solid;border-width:1px 0}.k-grid .k-group-footer .k-group-cell+td{border-left-width:1px}.k-grid .k-hierarchy-cell{text-align:center;padding:0;overflow:visible}.k-grid .k-hierarchy-cell>.k-icon{padding:8px 0;width:100%;height:100%;display:inline-block;outline:0}.k-grid .k-hierarchy-cell+td{border-left-width:0}.k-grid[dir=rtl] tbody,.k-grid[dir=rtl] tfoot,.k-grid[dir=rtl] thead,.k-rtl .k-grid tbody,.k-rtl .k-grid tfoot,.k-rtl .k-grid thead{text-align:right}.k-grid[dir=rtl] th,.k-rtl .k-grid th{white-space:nowrap}.k-grid[dir=rtl] .k-grid-header-wrap,.k-rtl .k-grid .k-grid-header-wrap{border-width:0 0 0 1px}.k-grid[dir=rtl] .k-drag-clue .k-button.k-bare,.k-grid[dir=rtl] .k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-grid[dir=rtl] .k-group-indicator .k-button.k-bare,.k-grid[dir=rtl] .k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-rtl .k-grid .k-drag-clue .k-button.k-bare,.k-rtl .k-grid .k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-rtl .k-grid .k-group-indicator .k-button.k-bare,.k-rtl .k-grid .k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-button{margin-left:-2px;margin-right:8px}.k-grid[dir=rtl] .k-drag-clue .k-link .k-icon,.k-grid[dir=rtl] .k-group-indicator .k-link .k-icon,.k-rtl .k-grid .k-drag-clue .k-link .k-icon,.k-rtl .k-grid .k-group-indicator .k-link .k-icon{margin-left:4px;margin-right:-2px}.k-grid[dir=rtl] .k-group-indicator,.k-rtl .k-grid .k-group-indicator{margin-right:0;margin-left:4px}.k-grid[dir=rtl] .k-group-indicator+.k-group-indicator,.k-rtl .k-grid .k-group-indicator+.k-group-indicator{margin-right:4px}.k-grid[dir=rtl] .k-grid-content-locked,.k-grid[dir=rtl] .k-grid-footer-locked,.k-grid[dir=rtl] .k-grid-header-locked,.k-rtl .k-grid .k-grid-content-locked,.k-rtl .k-grid .k-grid-footer-locked,.k-rtl .k-grid .k-grid-header-locked{border-left-width:1px;border-right-width:0}.k-grid[dir=rtl] th,.k-rtl .k-grid th{border-width:0 1px 1px 0}.k-grid[dir=rtl] th:first-child,.k-rtl .k-grid th:first-child{border-right-width:0}.k-grid[dir=rtl] td,.k-rtl .k-grid td{border-width:0 1px 0 0}.k-grid[dir=rtl] .k-hierarchy-cell+td,.k-grid[dir=rtl] td.k-hierarchy-cell,.k-grid[dir=rtl] td:first-child,.k-rtl .k-grid .k-hierarchy-cell+td,.k-rtl .k-grid td.k-hierarchy-cell,.k-rtl .k-grid td:first-child{border-right-width:0}.k-grid[dir=rtl] .k-grid-footer,.k-grid[dir=rtl] .k-grid-header,.k-rtl .k-grid .k-grid-footer,.k-rtl .k-grid .k-grid-header{padding-left:17px;padding-right:0}.k-grid[dir=rtl] .k-grid-header .k-header.k-first,.k-rtl .k-grid .k-grid-header .k-header.k-first{border-left-width:0;border-right-width:1px}.k-grid[dir=rtl] .k-grid-header .k-filterable>.k-link,.k-grid[dir=rtl] .k-grid-header .k-with-icon>.k-link,.k-rtl .k-grid .k-grid-header .k-filterable>.k-link,.k-rtl .k-grid .k-grid-header .k-with-icon>.k-link{padding-left:calc(14px + 1.4285714286em);padding-right:12px}.k-grid[dir=rtl] .k-grid-header .k-grid-filter,.k-grid[dir=rtl] .k-grid-header .k-header-column-menu,.k-rtl .k-grid .k-grid-header .k-grid-filter,.k-rtl .k-grid .k-grid-header .k-header-column-menu{right:auto;left:4px}.k-grid[dir=rtl] .k-filtercell-operator,.k-rtl .k-grid .k-filtercell-operator{margin-left:0;margin-right:4px}.k-grid[dir=rtl] .k-dirty,.k-rtl .k-grid .k-dirty{border-color:currentColor currentColor transparent transparent;left:auto;right:0}.k-grid[dir=rtl] .k-edit-cell>.k-textbox,.k-grid[dir=rtl] .k-edit-cell>.k-widget,.k-grid[dir=rtl] .k-edit-cell>.text-box,.k-grid[dir=rtl] .k-grid-edit-row>td>.k-textbox,.k-grid[dir=rtl] .k-grid-edit-row>td>.k-widget,.k-grid[dir=rtl] .k-grid-edit-row>td>.text-box,.k-rtl .k-grid .k-edit-cell>.k-textbox,.k-rtl .k-grid .k-edit-cell>.k-widget,.k-rtl .k-grid .k-edit-cell>.text-box,.k-rtl .k-grid .k-grid-edit-row>td>.k-textbox,.k-rtl .k-grid .k-grid-edit-row>td>.k-widget,.k-rtl .k-grid .k-grid-edit-row>td>.text-box{margin-right:-9px}.k-grid[dir=rtl] .k-grid-header-wrap.k-auto-scrollable,.k-rtl .k-grid .k-grid-header-wrap.k-auto-scrollable{margin-left:-1px;margin-right:0}.k-grid[dir=rtl] .k-grid-header-locked+.k-grid-header-wrap.k-auto-scrollable,.k-rtl .k-grid .k-grid-header-locked+.k-grid-header-wrap.k-auto-scrollable{margin-left:0}.k-grid[dir=rtl] .k-group-footer td,.k-rtl .k-grid .k-group-footer td{border-width:1px 0}.k-grid[dir=rtl] .k-group-footer .k-group-cell+td,.k-rtl .k-grid .k-group-footer .k-group-cell+td{border-right-width:1px}.k-grid[dir=rtl] .k-grid-toolbar .k-button+.k-button,.k-rtl .k-grid .k-grid-toolbar .k-button+.k-button{margin:0 4px 0 0}.k-grid[dir=rtl] .k-grouping-row .k-icon,.k-rtl .k-grid .k-grouping-row .k-icon{margin-left:8px;margin-right:-4px}.k-grid .k-tooltip.k-tooltip-validation{display:-ms-flexbox;display:flex;position:absolute;width:auto;padding:4px 8px}.k-grid .k-tooltip.k-tooltip-validation .k-callout{display:block}.k-grid .k-animation-container-fixed .k-tooltip.k-tooltip-validation{position:static}.k-grid .k-dirty-cell{position:relative}.k-grid .k-dirty{border-width:5px;border-color:currentColor transparent transparent currentColor;left:0;right:auto}.k-grid .k-grid-content-locked+.k-grid-content{box-sizing:content-box}.k-grid .k-grid-content-expander{position:absolute;visibility:hidden;height:1px}.k-grid-toolbar{padding:8px;border-width:0 0 1px;border-style:solid;border-color:inherit;text-overflow:clip;cursor:default;display:block}.k-grid-toolbar .k-button{vertical-align:middle}.k-grid-toolbar .k-button+.k-button{margin-left:4px}.k-grouping-header{display:block;padding:8px;border-width:0 0 1px;border-style:solid;border-color:inherit;line-height:calc(10px + 1.4285714286em)}.k-grouping-header-flex{display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:4px 0}.k-grouping-header-flex>.k-indicator-container{display:-ms-inline-flexbox;display:inline-flex;margin:0;padding:4px 0 4px 8px}.k-grouping-header-flex>.k-indicator-container:last-child{-ms-flex-positive:1;flex-grow:1;line-height:calc(10px + 1.4285714286em)}.k-drag-clue,.k-group-indicator{border-radius:2px;margin:0;padding:4px 8px;border-width:1px;border-style:solid;line-height:1.5;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;vertical-align:top;opacity:1;box-sizing:border-box}.k-drag-clue .k-button.k-bare,.k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-drag-clue .k-link,.k-group-indicator .k-button.k-bare,.k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-group-indicator .k-link{padding:0;border-width:0;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center}.k-drag-clue .k-link .k-icon,.k-group-indicator .k-link .k-icon{margin-left:-2px;margin-right:4px}.k-drag-clue .k-button.k-bare,.k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-button,.k-group-indicator .k-button.k-bare,.k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-button{margin-left:8px;margin-right:-2px;padding:0;width:auto;height:auto;opacity:.5}.k-drag-clue .k-button.k-bare:after,.k-drag-clue .k-button.k-bare:before,.k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-button:after,.k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-button:before,.k-drag-clue .k-toolbar .k-bare.k-dropdown-wrap:before,.k-drag-clue .k-toolbar .k-bare.k-picker-wrap:before,.k-drag-clue .k-toolbar .k-calendar.k-calendar-range.k-calendar-infinite>.k-dropdown-wrap:before,.k-drag-clue .k-toolbar .k-calendar.k-calendar-range.k-calendar-infinite>.k-picker-wrap:before,.k-group-indicator .k-button.k-bare:after,.k-group-indicator .k-button.k-bare:before,.k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-button:after,.k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-button:before,.k-group-indicator .k-toolbar .k-bare.k-dropdown-wrap:before,.k-group-indicator .k-toolbar .k-bare.k-picker-wrap:before,.k-group-indicator .k-toolbar .k-calendar.k-calendar-range.k-calendar-infinite>.k-dropdown-wrap:before,.k-group-indicator .k-toolbar .k-calendar.k-calendar-range.k-calendar-infinite>.k-picker-wrap:before,.k-toolbar .k-drag-clue .k-bare.k-dropdown-wrap:before,.k-toolbar .k-drag-clue .k-bare.k-picker-wrap:before,.k-toolbar .k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-dropdown-wrap:before,.k-toolbar .k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-picker-wrap:before,.k-toolbar .k-group-indicator .k-bare.k-dropdown-wrap:before,.k-toolbar .k-group-indicator .k-bare.k-picker-wrap:before,.k-toolbar .k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-dropdown-wrap:before,.k-toolbar .k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-picker-wrap:before{display:none}.k-drag-clue .k-button.k-bare:hover,.k-drag-clue .k-calendar.k-calendar-range.k-calendar-infinite>.k-button:hover,.k-group-indicator .k-button.k-bare:hover,.k-group-indicator .k-calendar.k-calendar-range.k-calendar-infinite>.k-button:hover{opacity:1}.k-group-indicator{margin-right:4px}.k-group-indicator+.k-group-indicator{margin-left:4px}.k-grouping-dropclue{width:12px;height:calc(10px + 1.4285714286em);position:absolute;top:3px;box-sizing:content-box}.k-grouping-dropclue:after,.k-grouping-dropclue:before{display:inline-block;content:\"\";position:absolute}.k-grouping-dropclue:before{border-width:6px;border-style:solid;border-left-color:transparent;border-right-color:transparent;border-bottom-color:transparent;top:0}.k-grouping-dropclue:after{width:2px;height:calc(100% - 6px);top:6px;left:5px}.k-grid-footer-wrap,.k-grid-header-wrap{width:100%;border-width:0 1px 0 0;border-style:solid;border-color:inherit;position:relative;overflow:hidden}.k-grid-header-wrap.k-auto-scrollable{margin-right:-1px}.k-grid-header-locked+.k-grid-header-wrap.k-auto-scrollable{margin-right:0}.k-ie .k-grid-header-locked+.k-grid-header-wrap.k-auto-scrollable{display:inline-block}.k-grid-footer,.k-grid-header{-ms-flex:0 0 auto;flex:0 0 auto;padding-right:17px;border-width:0;border-style:solid;border-color:inherit}.k-grid-footer table,.k-grid-header table{table-layout:fixed}div.k-grid-footer,div.k-grid-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:stretch;align-items:stretch}.k-ie div.k-grid-header{display:block}.k-grid-header{border-bottom-width:1px}.k-grid-header table{margin-bottom:-1px}.k-grid-header.k-grid-draggable-header{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:none;touch-action:none}.k-grid-header .k-header{position:relative;vertical-align:bottom}.k-grid-header .k-header:first-child{border-left-width:0}.k-grid-header .k-header.k-first{border-left-width:1px}.k-grid-header .k-header>.k-link{margin:-8px -12px;padding:8px 12px;line-height:inherit;display:block;overflow:hidden;text-overflow:ellipsis;outline:0}.k-grid-header .k-filterable>.k-link,.k-grid-header .k-with-icon>.k-link{padding-right:calc(14px + 1.4285714286em)}.k-grid-header .k-header>.k-link:focus{text-decoration:none}.k-grid-header .k-grid-filter,.k-grid-header .k-header-column-menu{padding:4px;width:calc(10px + 1.4285714286em);height:calc(10px + 1.4285714286em);box-sizing:border-box;outline:0;line-height:1.4285714286;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center;position:absolute;right:4px;bottom:calc(8px + .7142857143em + -4px + -.7142857143em);z-index:1}.k-grid-header .k-header>.k-link>.k-icon.k-i-sort-asc-sm,.k-grid-header .k-header>.k-link>.k-icon.k-i-sort-desc-sm{vertical-align:text-top;margin-left:7px}.k-grid-header .k-sort-order{display:inline-block;vertical-align:top;height:16px;font-size:12px;margin-top:2px;margin-left:-2px}.k-grid-footer{border-width:1px 0 0}.k-grid-footer td{height:1.4285714286em}.k-grid-filter-popup{min-width:200px}.k-grid-columnmenu-popup{width:230px}.k-filter-row{line-height:1.4285714286}.k-filter-row td,.k-filter-row th{border-width:0 0 1px 1px;white-space:nowrap;padding:8px}.k-filter-row td:first-child{border-left-width:0}.k-filter-row .k-multiselect{height:auto}.k-filter-row .k-filtercell .k-widget.k-sized-input{-ms-flex:0 1 auto;flex:0 1 auto}.k-filtercell{width:auto;display:-ms-flexbox;display:flex}.k-filtercell .k-filtercell-wrapper,.k-filtercell>span{display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto}.k-filtercell .k-filtercell-wrapper>label,.k-filtercell>span>label{vertical-align:middle}.k-filtercell .k-filtercell-wrapper>.k-widget{width:100%}.k-filtercell>span .k-button{visibility:visible;pointer-events:all}.k-filtercell>span .k-button,.k-filtercell>span .k-dropdown-operator{margin-left:4px}.k-filtercell>span .k-numerictextbox{width:auto}.k-filtercell .k-filtercell-operator>.k-button.k-clear-button-visible{visibility:visible;height:calc(10px + 1.4285714286em)}.k-filtercell .k-filtercell-operator>.k-button:not(.k-clear-button-visible){visibility:hidden;pointer-events:none}.k-filtercell .k-filtercell-operator{margin-left:4px}.k-filtercell .k-filtercell-wrapper>.k-textbox,.k-filtercell .k-widget:not(.k-dropdown-operator){display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto}.k-filtercell .k-filtercell-wrapper>.k-textbox{width:100%;min-width:0}.k-grid-content,.k-grid-content-locked{border-color:inherit;outline:0}.k-grid-content-locked table,.k-grid-content table{table-layout:fixed}.k-grid-content-locked tr:last-child td,.k-grid-content tr:last-child td{border-bottom-width:0}.k-grid-content{width:100%;min-height:0;overflow:auto;overflow-x:auto;overflow-y:scroll;position:relative;-ms-flex:1;flex:1}.k-virtual-scrollable-wrap{height:100%;overflow-y:hidden;position:relative}.k-grid-edit-row td{text-overflow:clip}.k-grid-edit-row .k-button,.k-grid-edit-row .k-input.k-textbox,.k-grid-edit-row .k-textbox,.k-grid-edit-row .k-widget{height:auto}.k-grid-edit-row .k-edit-cell{padding-top:0;padding-bottom:0}.k-grid-edit-row .k-dirty-cell{overflow:visible}.k-edit-cell>.k-textbox,.k-edit-cell>.k-widget,.k-edit-cell>.text-box,.k-grid-edit-row>td>.k-textbox,.k-grid-edit-row>td>.k-widget,.k-grid-edit-row>td>.text-box{margin-left:-9px}.k-edit-cell>.k-textbox,.k-edit-cell>.k-widget,.k-grid-edit-row td>.k-textbox,.k-grid-edit-row td>.k-widget{width:calc(100% + 18px)}.k-command-cell>.k-button,.k-edit-cell>.k-textbox,.k-edit-cell>.k-widget,.k-grid-edit-row td>.k-textbox,.k-grid-edit-row td>.k-widget{margin-top:-5px;margin-bottom:-5px;vertical-align:middle}.k-command-cell>.k-button{margin-left:.16em;margin-right:.16em}.k-grid-header .k-resize-handle,.k-grid>.k-resize-handle{height:25px;cursor:col-resize;position:absolute;z-index:2}.k-grid-pager{padding:8px;border-width:1px 0 0;border-color:inherit;font-size:inherit}.k-grid-virtual .k-grid-content .k-grid-table-wrap{float:left;width:100%}.k-grid-virtual .k-grid-content .k-grid-table{position:relative;float:left;z-index:1}.k-grid-virtual .k-grid-content>.k-height-container{position:relative;float:left}.k-grid-virtual .k-grid-content:after{content:\"\";display:block;clear:both}.k-grid-virtual.k-rtl .k-grid-content .k-grid-table,.k-grid-virtual[dir=rtl] .k-grid-content .k-grid-table{float:right}.k-grid-add-row td{border-bottom-style:solid;border-bottom-width:1px}.k-grid-lockedcolumns{white-space:nowrap}.k-grid-content,.k-grid-content-locked,.k-pager-wrap{white-space:normal}.k-grid-content-locked,.k-grid-footer-locked,.k-grid-header-locked{-ms-flex:0 0 auto;flex:0 0 auto;display:inline-block;vertical-align:top;overflow:hidden;position:relative;border-style:solid;border-width:0 1px 0 0}.k-grid-content-locked+.k-grid-content.k-auto-scrollable,.k-grid-footer-locked+.k-grid-content.k-auto-scrollable,.k-grid-header-locked+.k-grid-content.k-auto-scrollable{display:inline-block}.k-grid-content,.k-grid-footer-wrap,.k-grid-header-wrap{-ms-flex:1 1 auto;flex:1 1 auto;display:inline-block;vertical-align:top}.k-grid-content.k-auto-scrollable,.k-grid-footer-wrap.k-auto-scrollable,.k-grid-header-wrap.k-auto-scrollable{display:block}.k-grid-header-locked>table,.k-grid-header-wrap>table{margin-bottom:-1px}.k-header.k-drag-clue{overflow:hidden}.k-grid.k-grid-no-scrollbar .k-grid-header{padding:0}.k-grid.k-grid-no-scrollbar .k-grid-header-wrap{border-width:0}.k-grid.k-grid-no-scrollbar .k-grid-content{overflow-y:auto}.k-loading-pdf-mask{position:absolute;width:100%;height:100%;top:0;left:0;z-index:100}.k-loading-pdf-mask>.k-i-loading{position:absolute;top:50%;left:50%;font-size:64px}.k-loading-pdf-mask .k-loading-pdf-progress{margin:auto;position:absolute;top:0;bottom:0;left:0;right:0}.k-grid-pdf-export-element{position:absolute;left:-10000px;top:-10000px}.k-grid-pdf-export-element .k-filter-row{display:none}.k-pdf-export-shadow .k-grid{float:left;width:auto!important}.k-pdf-export-shadow .k-grid,.k-pdf-export-shadow .k-grid-content,.k-pdf-export-shadow .k-grid-content-locked{height:auto!important;overflow:visible}.k-pdf-export-shadow .k-grid-header-locked+.k-grid-content,.k-pdf-export-shadow .k-grid-header-locked+.k-grid-footer-wrap,.k-pdf-export-shadow .k-grid-header-locked+.k-grid-header-wrap{width:auto!important}.k-pdf-export-shadow .k-grid-header,.k-pdf-export-shadow .k-grid[data-role=grid] .k-grid-footer{padding:0!important}.k-filter-menu .k-filter-menu-container{padding:.5em 1em}.k-filter-menu .k-filter-menu-container .k-action-buttons{margin:1em -1em -.5em}.k-filter-menu .k-radio-list,.k-filter-menu .k-textbox,.k-filter-menu .k-widget{margin:.5em 0;width:100%;display:block}.k-filter-menu .k-widget.k-filter-and{width:6em;margin:1em 0}.k-multicheck-wrap{max-height:300px;overflow:auto;overflow-x:hidden;white-space:nowrap}.k-multicheck-wrap .k-item+.k-item{margin-top:.5em}.k-multicheck-wrap .k-label{margin:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;cursor:pointer}.k-multicheck-wrap .k-label input{margin:0 .25em}.k-filter-selected-items{font-weight:700;line-height:normal;white-space:nowrap;margin:1em 0 .5em}.k-autofitting{width:auto!important;table-layout:auto!important}.k-autofitting td,.k-autofitting th.k-header{white-space:nowrap!important}.k-autofitting .k-detail-row{display:none!important}.k-column-list{padding:0;margin:0;list-style:none;max-height:200px;overflow-x:hidden;overflow-y:auto}.k-column-chooser-title,.k-column-list-item{padding:4px 8px;padding-right:32px}.k-column-list-item{display:block;margin:0;cursor:pointer}.k-column-list-item .k-checkbox,.k-column-list-item .k-checkbox-label{vertical-align:middle}.k-columnmenu-item{padding:6px 12px;cursor:pointer}.k-columnmenu-item>.k-icon{margin-right:4px}.k-columnmenu-item-wrapper{border-bottom:1px solid;border-bottom-color:inherit}.k-columnmenu-item-wrapper:last-child{border-bottom-width:0}.k-columnmenu-item-content{overflow:hidden}.k-columnmenu-item-content .k-column-list-item{padding-left:32px}.k-columnmenu-item-content .k-filter-menu .k-filter-menu-container{padding:1em}.k-columnmenu-item-content .k-filter-menu .k-filter-menu-container .k-columnmenu-actions{padding:1em 0 0}.k-columnmenu-item-content .k-columnmenu-actions{display:-ms-flexbox;display:flex;padding:1em}.k-columnmenu-item-content .k-columnmenu-actions .k-button{-ms-flex:1 0 auto;flex:1 0 auto;width:auto;margin:0 .5em}.k-columnmenu-item-content .k-columnmenu-actions .k-button:first-child{margin-left:0}.k-columnmenu-item-content .k-columnmenu-actions .k-button:last-child{margin-right:0}.k-filter-row>td,.k-filter-row>th,.k-grid-content-locked,.k-grid-footer,.k-grid-footer-locked,.k-grid-footer-wrap,.k-grid-header,.k-grid-header-locked,.k-grid-header-wrap,.k-grid td,.k-grouping-header,.k-grouping-header .k-group-indicator,.k-header{border-color:rgba(0,0,0,.08)}.k-drag-clue,.k-grid-add-row,.k-grid-footer,.k-grid-header,.k-grid-toolbar,.k-grouping-header{color:#656565;background-color:#f6f6f6}.k-grid-content{background-color:#fff}.k-group-footer td,.k-grouping-row td,tbody .k-group-cell{color:#656565;background-color:#ededed}.k-grid-footer td,.k-group-footer td,.k-grouping-row td{font-weight:700}.k-grouping-dropclue:before{border-color:#656565 transparent transparent}.k-grouping-dropclue:after{background-color:#656565}.k-grid{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff;background-clip:padding-box}.k-edge12 .k-grid,.k-edge13 .k-grid,.k-ie11 .k-grid{background-clip:border-box}.k-grid tr.k-alt{background-color:rgba(0,0,0,.04)}.k-grid tbody tr.k-state-hover,.k-grid tbody tr:hover{color:#656565;background-color:#ededed}.k-grid td.k-state-selected,.k-grid tr.k-state-selected>td{color:#656565;background-color:rgba(255,99,88,.25)}.k-grid td.k-state-focused,.k-grid th.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-grid .k-grid-filter,.k-grid .k-header-column-menu,.k-grid .k-hierarchy-cell .k-icon{border-width:0;color:#656565}.k-grid .k-grouping-row{background-color:#ededed}.k-grid .k-grouping-row .k-icon{color:#656565;text-decoration:none}.k-grid .k-tooltip.k-tooltip-validation{color:#fff;background-color:#ff6358}.k-grid .k-tooltip.k-tooltip-validation .k-callout-n{border-bottom-color:#ff6358}.k-grid .k-tooltip.k-tooltip-validation .k-callout-e{border-left-color:#ff6358}.k-grid .k-tooltip.k-tooltip-validation .k-callout-s{border-top-color:#ff6358}.k-grid .k-tooltip.k-tooltip-validation .k-callout-w{border-right-color:#ff6358}col.k-sorted,th.k-sorted{background-color:rgba(0,0,0,.02)}.k-grid-header .k-i-sort-asc-sm,.k-grid-header .k-i-sort-desc-sm,.k-grid-header .k-sort-order{color:#ff6358}.k-grid-header .k-grid-filter:hover{color:#656565;background-color:#ededed}.k-grid-header .k-grid-filter:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.1)}.k-grid-header .k-grid-filter.k-state-active{color:#fff;background-color:#ff6358}.k-filter-menu .k-filter-menu-container .k-action-buttons{border-color:rgba(0,0,0,.08)}.k-tabstrip-wrapper{padding:0;border-style:solid}.k-tabstrip,.k-tabstrip-wrapper{border-width:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.k-tabstrip{border-color:transparent;color:inherit;background-color:transparent}.k-tabstrip-wrapper>.k-tabstrip{-ms-flex:1 1 auto;flex:1 1 auto}.k-tabstrip-items{border-width:0;border-style:solid;border-color:inherit;outline:0;-ms-flex-direction:row;flex-direction:row;-ms-flex:0 0 auto;flex:0 0 auto}.k-tabstrip-items,.k-tabstrip-items .k-item{display:-ms-flexbox;display:flex;position:relative}.k-tabstrip-items .k-item{margin:0;padding:0;border:1px solid transparent;-ms-flex-negative:0;flex-shrink:0;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:stretch;align-items:stretch;justify-items:stretch}.k-tabstrip-items .k-tab-on-top{z-index:1}.k-tabstrip-items .k-link{padding:6px 12px;color:inherit;cursor:pointer;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle;-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-direction:row;flex-direction:row;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center}.k-tabstrip-items .k-link[data-type=remove]{padding:6px;-ms-flex:none;flex:none}.k-ie11 .k-tabstrip-items{white-space:nowrap}.k-tabstrip>.k-content{padding:6px 12px;border-width:1px;border-style:solid;border-color:inherit;display:none;overflow:auto;-ms-flex:1 1 auto;flex:1 1 auto}.k-tabstrip>.k-content.k-state-active{display:block}.k-tabstrip-items .k-loading{width:20%;height:0;border:0;border-top:1px solid transparent;border-color:inherit;background:none;position:absolute;top:0;left:0;transition:width .2s linear}.k-tabstrip-items .k-loading.k-complete{width:100%;border-top-width:0}.k-tabstrip.k-tabstrip-scrollable{position:relative}.k-tabstrip.k-tabstrip-scrollable>.k-content{border-width:1px}.k-tabstrip.k-tabstrip-scrollable>.k-tabstrip-items{border-width:0;white-space:nowrap;overflow:hidden}.k-tabstrip.k-tabstrip-scrollable>.k-tabstrip-prev{position:absolute;left:0}.k-tabstrip.k-tabstrip-scrollable>.k-tabstrip-next{position:absolute;right:0}.k-ie11 .k-tabstrip.k-tabstrip-scrollable>.k-tabstrip-next,.k-ie11 .k-tabstrip.k-tabstrip-scrollable>.k-tabstrip-prev{top:0}.k-tabstrip-top>.k-tabstrip-items{border-bottom-width:1px}.k-tabstrip-top>.k-tabstrip-items .k-item{border-top-left-radius:2px;border-top-right-radius:2px;margin-bottom:-1px}.k-tabstrip-top>.k-tabstrip-items .k-item+.k-item{margin-left:0}.k-tabstrip-top>.k-tabstrip-items .k-item.k-state-active{border-bottom-color:transparent}.k-tabstrip-top>.k-content{border-bottom-right-radius:2px;border-bottom-left-radius:2px;border-top-width:0}.k-tabstrip-bottom>.k-tabstrip-items{border-top-width:1px}.k-tabstrip-bottom>.k-tabstrip-items .k-item{border-bottom-right-radius:2px;border-bottom-left-radius:2px;margin-top:-1px}.k-tabstrip-bottom>.k-tabstrip-items .k-item+.k-item{margin-left:0}.k-tabstrip-bottom>.k-tabstrip-items .k-item.k-state-active{border-top-color:transparent}.k-tabstrip-bottom>.k-content{border-top-left-radius:2px;border-top-right-radius:2px;border-bottom-width:0}.k-tabstrip-left{-ms-flex-direction:row;flex-direction:row}.k-tabstrip-left>.k-tabstrip-items{border-right-width:1px;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:column;flex-direction:column}.k-tabstrip-left>.k-tabstrip-items .k-item{border-top-left-radius:2px;border-bottom-left-radius:2px;margin-right:-1px}.k-tabstrip-left>.k-tabstrip-items .k-item+.k-item{margin-top:0}.k-tabstrip-left>.k-tabstrip-items .k-item.k-state-active{border-right-color:transparent}.k-tabstrip-left>.k-content{border-top-right-radius:2px;border-bottom-right-radius:2px;margin:0!important;border-left-width:0}.k-tabstrip-right{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.k-tabstrip-right>.k-tabstrip-items{border-left-width:1px;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:column;flex-direction:column}.k-tabstrip-right>.k-tabstrip-items .k-item{border-top-right-radius:2px;border-bottom-right-radius:2px;margin-left:-1px}.k-tabstrip-right>.k-tabstrip-items .k-item+.k-item{margin-top:0}.k-tabstrip-right>.k-tabstrip-items .k-item.k-state-active{border-left-color:transparent}.k-tabstrip-right>.k-content{border-top-left-radius:2px;border-bottom-left-radius:2px;margin:0!important;border-right-width:0}.k-rtl .k-tabstrip-left>.k-tabstrip-items,.k-rtl .k-tabstrip-right>.k-tabstrip-items,.k-tabstrip-left[dir=rtl]>.k-tabstrip-items,.k-tabstrip-right[dir=rtl]>.k-tabstrip-items{-ms-flex-order:1;order:1}.k-rtl .k-tabstrip-left>.k-content,.k-rtl .k-tabstrip-right>.k-content,.k-tabstrip-left[dir=rtl]>.k-content,.k-tabstrip-right[dir=rtl]>.k-content{-ms-flex-order:0;order:0}.k-tabstrip-items{border-color:rgba(0,0,0,.08);color:#656565}.k-tabstrip-items .k-item{color:#ff6358}.k-tabstrip-items .k-item.k-state-hover,.k-tabstrip-items .k-item:hover{color:#e76057}.k-tabstrip-items .k-item.k-state-active,.k-tabstrip-items .k-item.k-state-selected{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff}.k-tabstrip-items .k-item.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-tabstrip>.k-content{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff}.k-toolbar{padding:8px;border-width:1px;line-height:1.4285714286;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:flex-start;position:relative;overflow:hidden;box-shadow:none}.k-toolbar.k-toolbar-resizable{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.k-toolbar>*{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:stretch;align-items:stretch;-ms-flex-line-pack:center;align-content:center;vertical-align:middle;margin-left:8px}.k-toolbar .k-overflow-anchor+*{margin-left:0}.k-toolbar .k-button,.k-toolbar .k-button-group,.k-toolbar .k-separator,.k-toolbar .k-split-button,.k-toolbar .k-textbox,.k-toolbar .k-widget,.k-toolbar label{-ms-flex-item-align:center;align-self:center}.k-toolbar .k-split-button>.k-button{-ms-flex-item-align:stretch;align-self:stretch}.k-toolbar .k-button{padding:4px 8px;line-height:1.4285714286}.k-toolbar .k-button-group .k-button,.k-toolbar .k-button:before,.k-toolbar .k-dropdown-wrap:before,.k-toolbar .k-picker-wrap:before{border-radius:0}.k-toolbar .k-button-group .k-button:first-child,.k-toolbar .k-button-group .k-button:last-child,.k-toolbar .k-button-group .k-group-end,.k-toolbar .k-button-group .k-group-start{border-radius:0 0 0 0}.k-toolbar .k-split-button .k-button{border-radius:2px 0 0 2px}.k-toolbar .k-split-button .k-button.k-split-button-arrow{border-radius:0 2px 2px 0;margin-left:-1px;padding:4px}.k-toolbar .k-overflow-anchor{border-radius:0;padding:8px;width:calc(1.4285714286em + 26px);height:100%;margin:0;border-width:0 0 0 1px;border-color:inherit;background-clip:padding-box;box-sizing:border-box;-ms-flex-pack:center;justify-content:center;position:absolute;top:0;right:0}.k-toolbar .k-overflow-anchor:before{display:block}.k-toolbar .k-separator{padding:4px 0;margin:0 8px}.k-toolbar .k-separator+*{margin-left:0}.k-overflow-container .k-overflow-tool-group{display:block}.k-overflow-container .k-button-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.k-overflow-container .k-overflow-hidden,.k-overflow-container .k-tool.k-state-disabled{display:none}.k-rtl .k-toolbar .k-overflow-anchor{right:auto;left:0;border-width:0 1px 0 0}.k-toolbar{background-clip:padding-box}.k-edge12 .k-toolbar,.k-edge13 .k-toolbar,.k-ie11 .k-toolbar{background-clip:border-box}.k-toolbar .k-split-button .k-state-focused,.k-toolbar .k-split-button:focus{box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-toolbar .k-split-button .k-button.k-state-focused,.k-toolbar .k-split-button .k-button:focus{border-color:rgba(0,0,0,.08);box-shadow:inset 0 0 0 1px rgba(0,0,0,.08)}.k-toolbar .k-split-button .k-button.k-state-active,.k-toolbar .k-split-button .k-button:active,.k-toolbar .k-split-button.k-state-disabled .k-button{box-shadow:none}.k-toolbar .k-overflow-anchor{color:inherit;background:transparent}.k-toolbar .k-state-border-down,.k-toolbar .k-state-border-up{box-shadow:none}.k-toolbar .k-state-border-down .k-button:before,.k-toolbar .k-state-border-down .k-dropdown-wrap:before,.k-toolbar .k-state-border-down .k-picker-wrap:before,.k-toolbar .k-state-border-down:before,.k-toolbar .k-state-border-up .k-button:before,.k-toolbar .k-state-border-up .k-dropdown-wrap:before,.k-toolbar .k-state-border-up .k-picker-wrap:before,.k-toolbar .k-state-border-up:before{opacity:0}.k-toolbar .k-separator{border-color:inherit}.k-toolbar .k-button.k-state-disabled:after{opacity:0}.k-toolbar .k-overflow-anchor{border-width:0}.k-spreadsheet{width:800px;height:600px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;cursor:default;position:relative}.k-spreadsheet .k-vertical-align-center{position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.k-spreadsheet .k-vertical-align-bottom{position:relative;top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%)}.k-spreadsheet .k-tabstrip-wrapper{border-width:0 0 1px;border-style:solid;border-color:inherit;position:relative}.k-spreadsheet-quick-access-toolbar{padding:8px;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row;position:absolute;z-index:1;top:0;left:0}.k-spreadsheet-quick-access-toolbar .k-button:not(:hover){border-color:transparent;color:inherit;background-color:transparent;background-image:none}.k-spreadsheet-tabstrip{padding-top:8px}.k-spreadsheet-tabstrip .k-loading{display:none}.k-spreadsheet-tabstrip .k-content{border-radius:0;padding:0;border-width:0;overflow:hidden}.k-spreadsheet-toolbar{border-width:0}.k-spreadsheet-toolbar [data-tool=alignment],.k-spreadsheet-toolbar [data-tool=backgroundColor],.k-spreadsheet-toolbar [data-tool=borders],.k-spreadsheet-toolbar [data-tool=freeze],.k-spreadsheet-toolbar [data-tool=merge],.k-spreadsheet-toolbar [data-tool=textColor]{width:auto;min-width:1.4285714286em}.k-spreadsheet-toolbar [data-tool=fontSize]{width:5em}.k-spreadsheet-toolbar [data-tool=fontFamily]{width:6em}.k-spreadsheet-toolbar [data-tool=format]{width:4em}.k-spreadsheet-action-bar{border-width:0 0 1px;border-style:solid;border-color:inherit;font-size:12px;font-family:Arial,Verdana,sans-serif;position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.k-spreadsheet-name-editor{width:10em;border-width:0 1px 0 0;border-style:solid;border-color:inherit}.k-spreadsheet-name-editor .k-combobox{width:100%;font-size:inherit}.k-spreadsheet-name-editor .k-combobox .k-dropdown-wrap{border-radius:0;border-width:0}.k-spreadsheet-name-editor .k-combobox .k-select{border-radius:0}.k-spreadsheet-formula-bar{border-color:inherit;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex:1;flex:1}.k-spreadsheet-formula-bar:before{font-size:16px;font-family:WebComponentsIcons;font-style:normal;font-variant:normal;font-weight:400;line-height:1;padding:0 4px;border-width:0 1px 0 0;border-style:solid;border-color:inherit}.k-spreadsheet-formula-bar .k-group-header,.k-spreadsheet-formula-bar .k-list-scroller,.k-spreadsheet-formula-bar .k-tooltip{display:none}.k-spreadsheet-formula-bar .k-spreadsheet-formula-input{padding:4px 8px;line-height:1.4285714286}.k-spreadsheet-formula-input{outline:0;white-space:pre;-ms-flex:1;flex:1;box-sizing:border-box}.k-spreadsheet-formula-input>.k-syntax-bool.k-syntax-at-point,.k-spreadsheet-formula-input>.k-syntax-func.k-syntax-at-point,.k-spreadsheet-formula-input>.k-syntax-num.k-syntax-at-point,.k-spreadsheet-formula-input>.k-syntax-ref.k-syntax-at-point,.k-spreadsheet-formula-input>.k-syntax-str.k-syntax-at-point{text-decoration:underline}.k-spreadsheet-formula-input>.k-series-a,.k-spreadsheet-formula-input>.k-series-b,.k-spreadsheet-formula-input>.k-series-c,.k-spreadsheet-formula-input>.k-series-d{background-color:transparent}.k-spreadsheet-formula-list{min-width:100px}.k-spreadsheet-formula-list .k-item{padding:4px 8px}.k-spreadsheet-cell-editor{padding:0 3px;line-height:20px;display:none;overflow:hidden;position:absolute;z-index:2000}.k-spreadsheet-sheets-bar{padding:0 4px 4px;border-width:1px 0 0;border-style:solid;border-color:inherit;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;position:relative}.k-spreadsheet-sheets-bar-add{margin-right:4px}.k-spreadsheet-sheets-bar-add:not(:hover){border-color:transparent;color:inherit;background:none}.k-spreadsheet-sheets-items{margin-top:-1px;-ms-flex:1;flex:1;overflow:hidden}.k-spreadsheet-sheets-items .k-tabstrip-items{margin:0 calc(10px + 1.4285714286em)!important;border-width:0}.k-spreadsheet-sheets-items .k-tabstrip-prev{left:0!important}.k-spreadsheet-sheets-items .k-tabstrip-next{right:0!important}.k-spreadsheet-sheets-items .k-item .k-link{display:inline-block}.k-spreadsheet-sheets-items .k-item .k-spreadsheet-sheets-remove{margin-right:.5em;margin-left:-.5em;padding:0;line-height:1;vertical-align:middle}.k-spreadsheet-view{height:auto!important;border-color:inherit;font-size:12px;font-family:Arial,Verdana,Sans-serif;-ms-flex:1;flex:1;position:relative}.k-spreadsheet-fixed-container{width:100%;height:100%;border-color:inherit;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:absolute;z-index:2}.k-spreadsheet-overflow{top:0;bottom:0;left:0;right:0}.k-spreadsheet-overflow,.k-spreadsheet-pane{position:absolute;overflow:hidden;border-color:inherit}.k-spreadsheet-pane{padding:0 1px 0 0;border-width:2px 0 0 2px;border-style:solid;box-sizing:border-box}.k-spreadsheet-pane.k-top{border-top-width:0}.k-spreadsheet-pane.k-left{border-left-width:0}.k-spreadsheet-top-corner{border-width:0 1px 1px 0;border-style:solid;box-sizing:border-box;position:absolute;top:0;left:0;z-index:10000}.k-spreadsheet-top-corner:after{content:\"\";display:block;width:0;height:0;overflow:hidden;position:absolute;bottom:0;right:0;border:6px solid transparent;border-right-color:inherit;border-bottom-color:inherit}.k-spreadsheet-scroller{width:100%;height:100%;overflow:scroll;-webkit-overflow-scrolling:touch;position:absolute;z-index:1}.k-spreadsheet-haxis,.k-spreadsheet-vaxis{border:0 solid;border-color:inherit;position:absolute}.k-spreadsheet-haxis{border-width:1px 0 0;left:0}.k-spreadsheet-vaxis{border-width:0 0 0 1px;top:0}.k-spreadsheet-column-header,.k-spreadsheet-row-header{text-align:center;z-index:100}.k-spreadsheet-column-header>div,.k-spreadsheet-row-header>div{position:relative;box-sizing:border-box;border-width:0;border-style:solid;border-color:inherit}.k-spreadsheet-column-header>div:after,.k-spreadsheet-row-header>div:after{content:\"\";border-width:0;border-style:solid;border-color:inherit;display:none;position:absolute;top:0;right:0;bottom:0;left:0}.k-spreadsheet-row-header{position:relative}.k-spreadsheet-column-header{position:absolute}.k-spreadsheet-row-header>div{border-top-width:1px}.k-spreadsheet-row-header>div:first-child{border-top-width:0}.k-spreadsheet-row-header>.k-selection-full:after,.k-spreadsheet-row-header>.k-selection-partial:after{border-right-width:2px;display:block}.k-spreadsheet-column-header>div{border-left-width:1px}.k-spreadsheet-column-header>div:first-child{border-left-width:0}.k-spreadsheet-column-header>.k-selection-full:after,.k-spreadsheet-column-header>.k-selection-partial:after{border-bottom-width:2px;display:block}.k-spreadsheet-data{border-color:inherit;cursor:cell;position:relative}.k-spreadsheet-cell{padding:1px;box-sizing:border-box;background-clip:padding-box;white-space:pre;position:absolute;overflow:hidden}.k-spreadsheet-merged-cell{background-color:#fff}.k-spreadsheet-merged-cells-wrapers{position:relative}.k-spreadsheet .k-selection-wrapper{position:relative;cursor:cell}.k-spreadsheet .k-spreadsheet-selection,.k-spreadsheet .k-spreadsheet-selection-highlight{border-width:1px;border-style:solid;box-sizing:border-box;position:absolute}.k-spreadsheet .k-selection-wrapper .k-spreadsheet-editor-button{position:absolute;padding:0}.k-spreadsheet-active-cell{outline-color:transparent!important;z-index:10}.k-spreadsheet .k-auto-fill-wrapper{position:relative}.k-spreadsheet .k-auto-fill,.k-spreadsheet .k-auto-fill-br-hint,.k-spreadsheet .k-auto-fill-punch{box-sizing:border-box;position:absolute}.k-spreadsheet .k-auto-fill,.k-spreadsheet .k-single-selection:after{border-width:1px;border-style:solid;cursor:crosshair}.k-spreadsheet .k-single-selection:after{content:\"\";margin-bottom:-4px;margin-right:-4px;width:6px;height:6px;border-radius:50%;display:block;position:absolute;bottom:0;right:0;z-index:100}.k-spreadsheet .k-autofill-wrapper{position:relative;cursor:cell}.k-spreadsheet-vborder{position:absolute;border-left-style:solid;border-left-width:1px}.k-spreadsheet-hborder{position:absolute;border-top-style:solid;border-top-width:1px}.k-spreadsheet .k-filter-wrapper{position:relative;z-index:50}.k-spreadsheet .k-filter-range{border-width:1px;border-style:solid;position:absolute;box-sizing:border-box}.k-spreadsheet-filter{border-radius:2px;line-height:1;position:absolute;cursor:pointer}.k-spreadsheet-filter .k-icon{vertical-align:middle}.k-spreadsheet-filter-menu{width:280px}.k-spreadsheet-filter-menu .k-animation-container{position:relative}.k-spreadsheet-filter-menu>.k-menu{border-width:0}.k-spreadsheet-filter-menu>.k-menu .k-item{color:inherit}.k-spreadsheet-filter-menu>.k-menu .k-link{padding-left:24px}.k-spreadsheet-filter-menu>.k-menu .k-icon{margin-left:-20px;margin-right:4px}.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper{height:200px;border-width:1px;border-style:solid;overflow-y:scroll;overflow-x:auto}.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper .k-treeview{padding:4px;overflow:visible}.k-spreadsheet-filter-menu .k-details{padding:0;border-width:1px 0 0;border-style:solid;border-color:inherit}.k-spreadsheet-filter-menu .k-details-summary{padding:4px;cursor:pointer}.k-spreadsheet-filter-menu .k-details-summary>.k-icon{margin-right:4px}.k-spreadsheet-filter-menu .k-details-content{padding:4px 8px 4px 24px}.k-spreadsheet-filter-menu .k-details-content>.k-textbox,.k-spreadsheet-filter-menu .k-details-content>.k-widget{width:100%;margin-bottom:3px}.k-spreadsheet-filter-menu .k-details-content .k-space-right{background-image:none}.k-spreadsheet-filter-menu .k-details-content .k-filter-and{width:75px;margin:8px 0}.k-spreadsheet-filter-menu .k-action-buttons{margin:1em 0 0}.k-spreadsheet-popup{padding:0}.k-spreadsheet-popup .k-separator{display:block}.k-spreadsheet-popup .k-button{border-radius:0;border-width:0;color:inherit;background:none}.k-spreadsheet-popup .k-button-icontext{display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start}.k-spreadsheet-popup .k-custom-color,.k-spreadsheet-popup .k-reset-color{border-radius:0;width:100%;border-width:0;box-sizing:border-box;display:-ms-flexbox;display:flex}.k-spreadsheet-popup .k-reset-color{border-bottom-width:1px}.k-spreadsheet-popup .k-custom-color{border-top-width:1px}.k-spreadsheet-popup .k-spreadsheet-color-palette{padding:0}.k-spreadsheet-popup .k-spreadsheet-border-type-palette{width:12.5rem;height:5rem;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-line-pack:distribute;align-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}.k-spreadsheet-format-popup .k-item{-ms-flex-pack:justify;justify-content:space-between}.k-spreadsheet-format-popup .k-spreadsheet-sample{-ms-flex-order:1;order:1}.k-spreadsheet-sample{opacity:.7}.k-spreadsheet-clipboard,.k-spreadsheet-clipboard-paste{margin:0;padding:0;width:1px;height:1px;border:0;opacity:0;position:absolute;top:0;left:0;overflow:hidden}.k-spreadsheet-window .k-edit-form-container{width:auto;min-width:0}.k-spreadsheet-format-cells .k-spreadsheet-preview{margin-top:.5em;text-align:center}.k-spreadsheet-format-cells .k-list-scroller{margin-top:.5em;height:210px;border-width:1px;border-style:solid;border-color:inherit}.k-export-config{clear:both;position:relative}.k-export-config:after{content:\"\";clear:both;display:block}.k-export-config .k-edit-field{margin-left:5%;width:45%;float:left}.k-export-config .k-page-orientation{position:absolute;right:0;top:.5em}.k-export-config .k-page-orientation .k-icon{font-size:6em}.k-spreadsheet{background-clip:padding-box}.k-edge12 .k-spreadsheet,.k-edge13 .k-spreadsheet,.k-ie11 .k-spreadsheet{background-clip:border-box}.k-syntax-ref{color:#f82}.k-syntax-num{color:#09f}.k-syntax-func{font-weight:700}.k-syntax-str{color:#38b714}.k-syntax-error{color:red}.k-syntax-bool{color:#a9169c}.k-syntax-startexp{font-weight:700}.k-syntax-paren-match{background-color:#caf200}.k-spreadsheet-cell-editor{color:#656565;background-color:#fff}.k-spreadsheet .k-selection-full,.k-spreadsheet .k-selection-partial{background-color:rgba(255,99,88,.25)}.k-spreadsheet .k-selection-full:after,.k-spreadsheet .k-selection-partial:after{display:none}.k-spreadsheet-selection{border-color:#ff6358;background-color:rgba(255,99,88,.25);box-shadow:inset 0 0 0 1px #ff6358}.k-spreadsheet .k-single-selection:after{border-color:#fff;background-color:#ff6358}.k-spreadsheet-active-cell{box-shadow:inset 0 0 0 1px #ff6358;background-color:#fff}.k-spreadsheet-active-cell.k-right{box-shadow:inset 0 0 0 1px #ff6358,inset -1px 0 0 1px #ff6358}.k-spreadsheet-active-cell.k-bottom{box-shadow:inset 0 0 0 1px #ff6358,inset 0 -1px 0 1px #ff6358}.k-spreadsheet-active-cell.k-bottom.k-right{box-shadow:inset 0 0 0 1px #ff6358,inset -1px -1px 0 1px #ff6358}.k-spreadsheet .k-auto-fill{border-color:#ff6358;background-color:rgba(255,99,88,.25);box-shadow:inset 0 0 0 1px #ff6358}.k-spreadsheet .k-auto-fill-punch{background-color:hsla(0,0%,100%,.5)}.k-spreadsheet .k-resize-handle,.k-spreadsheet .k-resize-hint-handle,.k-spreadsheet .k-resize-hint-marker{background-color:#ff6358}.k-spreadsheet .k-filter-range{border-color:#ff6358}.k-spreadsheet-filter{box-shadow:inset 0 0 0 1px rgba(0,0,0,.08)}.k-treeview{padding:0;border-width:0;background:none;line-height:1.4285714286;cursor:default;overflow:auto;white-space:nowrap}.k-treeview .k-content,.k-treeview .k-item>.k-group,.k-treeview>.k-group{margin:0;padding:0;background:none;list-style:none;position:relative}.k-treeview .k-content.ng-animating,.k-treeview .k-item>.k-group.ng-animating,.k-treeview>.k-group.ng-animating{overflow:hidden}.k-treeview .k-bot,.k-treeview .k-mid,.k-treeview .k-top{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center}.k-treeview .k-item{outline-style:none;margin:0;padding:0 0 0 16px;border-width:0;display:block}.k-treeview .k-in{border-radius:0;margin:0;padding:4px 8px;border:0 solid transparent;text-decoration:none;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;vertical-align:middle;position:relative}.k-treeview .k-in.k-state-focused{z-index:1}.k-treeview .k-i-collapse,.k-treeview .k-i-expand{margin-left:-16px;cursor:pointer}.k-treeview .k-in .k-icon,.k-treeview .k-in .k-image,.k-treeview .k-in .k-sprite{margin-right:4px}.k-rtl .k-treeview .k-item{padding-left:0;padding-right:16px}.k-rtl .k-treeview .k-i-collapse,.k-rtl .k-treeview .k-i-expand{margin-left:0;margin-right:-16px}.k-rtl .k-treeview .k-in .k-icon,.k-rtl .k-treeview .k-in .k-image,.k-rtl .k-treeview .k-in .k-sprite{margin-left:4px;margin-right:0}.k-treeview{color:#656565}.k-treeview .k-in.k-state-hover,.k-treeview .k-in:hover{color:#656565;background-color:#ededed}.k-treeview .k-in.k-state-selected{color:#fff;background-color:#ff6358}.k-treeview .k-in.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-pivot{position:relative}.k-pivot .k-grid td{white-space:nowrap}.k-pivot .k-grid-content{-ms-flex:1 1 auto;flex:1 1 auto}.k-pivot-toolbar{padding:8px;border-bottom-width:1px;border-bottom-style:solid}.k-fieldselector .k-list li.k-item,.k-pivot-toolbar .k-button{border-radius:2px;padding:4px 8px;padding-right:48px;min-height:auto;font-size:14px;line-height:1.4285714286;text-align:left;position:relative;cursor:move;white-space:normal}.k-settings-columns .k-button,.k-settings-measures .k-button,.k-settings-rows .k-button{margin-right:8px;margin-bottom:2px}.k-field-actions{position:absolute;right:4px;top:4px;line-height:1;cursor:pointer}.k-pivot-layout{border-spacing:0;table-layout:auto}.k-pivot-layout>tbody,.k-pivot td{vertical-align:top}.k-pivot-layout>tbody>tr>td{padding:0}.k-pivot-rowheaders>.k-grid,.k-pivot-table>.k-grid{border-width:0}.k-pivot-rowheaders>.k-grid td:first-child,.k-pivot-table .k-grid-header .k-header.k-first{border-left-width:1px}.k-pivot-rowheaders>.k-grid td.k-first{border-left-width:0}.k-pivot-rowheaders>.k-grid{overflow:hidden}.k-pivot-table{border-left-width:1px;border-left-style:solid}.k-pivot-table .k-grid-header-wrap{margin-right:-1px}.k-pivot-table .k-grid-header-wrap>table{height:100%}.k-pivot .k-grid-header .k-header{vertical-align:top}.k-pivot-layout .k-grid td{border-bottom-width:1px}.k-pivot-layout .k-grid-footer>td{border-top-width:0}.k-pivot-filter-window .k-treeview{max-height:600px}.k-i-kpi-trend-decrease,.k-i-kpi-trend-equal,.k-i-kpi-trend-increase{color:inherit}.k-i-kpi-status-hold{color:#ffc000}.k-i-kpi-status-deny{color:#f31700}.k-i-kpi-status-open{color:#37b400}.k-fieldselector .k-columns{display:-ms-flexbox;display:flex;-ms-flex-align:stretch;align-items:stretch}.k-fieldselector .k-columns>div{padding:8px;width:50%;box-sizing:border-box;border-width:0;border-style:solid;float:left;overflow:auto}.k-fieldselector .k-columns>div+div{border-left-width:1px}.k-fieldselector p{margin:0 0 2px;text-transform:uppercase}.k-fieldselector p .k-icon{margin:0 4px 0 0}.k-fieldselector .k-treeview{border-width:0;overflow:visible}.k-fieldselector .k-edit-label{width:16%}.k-fieldselector .k-edit-field{width:77%}.k-fieldselector .k-edit-buttons>input,.k-fieldselector .k-edit-buttons>label{float:left;margin-top:.4em}.k-fieldselector .k-list-container{margin-bottom:1em;padding:2px;border-width:1px;border-style:solid}.k-fieldselector .k-list{padding-bottom:1em}.k-fieldselector .k-list .k-item{border-width:1px;border-style:solid}.k-fieldselector .k-list .k-item+.k-item{margin-top:.5em}.k-ie11 .k-pivot-layout{width:100%;table-layout:fixed}.k-ie11 .k-pivot-layout>tbody>tr>td:first-child{width:280px}.k-alt,.k-pivot-layout>tbody>tr:first-child>td:first-child,.k-pivot-toolbar{background-color:#f6f6f6}.k-fieldselector .k-list-container{background-color:#fff}.k-fieldselector .k-columns>div,.k-fieldselector .k-list-container,.k-pivot-rowheaders>.k-grid td:first-child,.k-pivot-table,.k-pivot-table .k-grid-header .k-header.k-first,.k-pivot-toolbar{border-color:rgba(0,0,0,.08)}.k-header.k-alt,.k-pivot-rowheaders .k-alt .k-alt{background-color:#ededed}.k-fieldselector .k-list li.k-item,.k-pivot-toolbar .k-button{background-clip:padding-box}.k-edge12 .k-fieldselector .k-list li.k-item,.k-edge12 .k-pivot-toolbar .k-button,.k-edge13 .k-fieldselector .k-list li.k-item,.k-edge13 .k-pivot-toolbar .k-button,.k-ie11 .k-fieldselector .k-list li.k-item,.k-ie11 .k-pivot-toolbar .k-button{background-clip:border-box}.k-fieldselector .k-list li.k-item.k-state-active,.k-fieldselector .k-list li.k-item:active,.k-pivot-toolbar .k-button.k-state-active,.k-pivot-toolbar .k-button:active{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6;background-image:linear-gradient(0deg,#f6f6f6,#f1f1f1);box-shadow:0 2px 2px 0 rgba(0,0,0,.06)}.k-fieldselector .k-list li.k-item.k-state-focused,.k-fieldselector .k-list li.k-item:focus,.k-pivot-toolbar .k-button.k-state-focused,.k-pivot-toolbar .k-button:focus{box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-fieldselector .k-list li.k-item.k-empty,.k-fieldselector .k-list li.k-item .k-setting-delete,.k-pivot-toolbar .k-button.k-empty,.k-pivot-toolbar .k-button .k-setting-delete,.k-pivot-toolbar .k-empty{color:#bababa}.k-pivot-layout .k-grid-footer,.k-pivot-layout .k-grid .k-alt{color:#000;font-weight:700}.k-fieldselector .k-i-loading{border-color:#f6f6f6}.k-fieldselector .k-i-loading:after,.k-fieldselector .k-i-loading:before,.k-fieldselector .k-loading-image:after,.k-fieldselector .k-loading-image:before{background-color:#f6f6f6}.k-treelist.k-display-block.k-grid-lockedcolumns{display:block}.k-treelist .k-status{padding:.4em .6em;line-height:1.6em}.k-treelist .k-status .k-loading{vertical-align:baseline;margin-right:5px}.k-treelist tr.k-hidden{display:none}.k-treelist .k-treelist-dragging,.k-treelist .k-treelist-dragging .k-state-hover{cursor:default}.k-treelist .k-drop-hint{position:absolute;z-index:10000;visibility:hidden;width:80px;height:5px;margin-top:-3px;background-color:transparent;background-repeat:no-repeat}.k-drag-separator{display:inline-block;border-right:1px solid;height:1em;vertical-align:top;margin:0 .5em}div.k-scrollview,kendo-scrollview.k-scrollview-wrap{position:relative;overflow:hidden;outline:0;display:block}div.k-scrollview .k-scrollview,div.k-scrollview ul.k-scrollview-wrap,kendo-scrollview.k-scrollview-wrap .k-scrollview,kendo-scrollview.k-scrollview-wrap ul.k-scrollview-wrap{list-style-type:none;position:absolute;margin:0;padding:0;width:100%;height:100%;cursor:default}div.k-scrollview .k-scrollview img,div.k-scrollview ul.k-scrollview-wrap img,kendo-scrollview.k-scrollview-wrap .k-scrollview img,kendo-scrollview.k-scrollview-wrap ul.k-scrollview-wrap img{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}div.k-scrollview .k-scrollview>li,div.k-scrollview ul.k-scrollview-wrap>li,kendo-scrollview.k-scrollview-wrap .k-scrollview>li,kendo-scrollview.k-scrollview-wrap ul.k-scrollview-wrap>li{display:inline-block;overflow:hidden;position:absolute;top:0;left:0}div.k-scrollview .k-scrollview-nav,div.k-scrollview .k-scrollview-pageable,kendo-scrollview.k-scrollview-wrap .k-scrollview-nav,kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable{margin:0;padding:0;width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;text-align:center;list-style:none;position:absolute;left:0;bottom:20px;pointer-events:none}div.k-scrollview .k-scrollview-nav>li.k-link,div.k-scrollview .k-scrollview-pageable>li.k-button,kendo-scrollview.k-scrollview-wrap .k-scrollview-nav>li.k-link,kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-button{margin:0 20px;padding:0;width:8px;height:8px;box-sizing:content-box;display:inline-block;position:relative;-ms-flex:0 0 8px;flex:0 0 8px;border-width:1px;border-style:solid;border-radius:50%;cursor:pointer;pointer-events:all}.k-toolbar div.k-scrollview .k-scrollview-pageable>li.k-dropdown-wrap:before,.k-toolbar div.k-scrollview .k-scrollview-pageable>li.k-picker-wrap:before,.k-toolbar kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-dropdown-wrap:before,.k-toolbar kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-picker-wrap:before,div.k-scrollview .k-scrollview-nav>li.k-link:before,div.k-scrollview .k-scrollview-pageable>li.k-button:before,div.k-scrollview .k-toolbar .k-scrollview-pageable>li.k-dropdown-wrap:before,div.k-scrollview .k-toolbar .k-scrollview-pageable>li.k-picker-wrap:before,kendo-scrollview.k-scrollview-wrap .k-scrollview-nav>li.k-link:before,kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-button:before,kendo-scrollview.k-scrollview-wrap .k-toolbar .k-scrollview-pageable>li.k-dropdown-wrap:before,kendo-scrollview.k-scrollview-wrap .k-toolbar .k-scrollview-pageable>li.k-picker-wrap:before{content:\"\";width:28px;height:20px;display:block;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.k-toolbar div.k-scrollview .k-scrollview-pageable>li.k-dropdown-wrap:before,.k-toolbar div.k-scrollview .k-scrollview-pageable>li.k-picker-wrap:before,.k-toolbar kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-dropdown-wrap:before,.k-toolbar kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-picker-wrap:before,div.k-scrollview .k-scrollview-pageable>li.k-button:before,div.k-scrollview .k-toolbar .k-scrollview-pageable>li.k-dropdown-wrap:before,div.k-scrollview .k-toolbar .k-scrollview-pageable>li.k-picker-wrap:before,kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-button:before,kendo-scrollview.k-scrollview-wrap .k-toolbar .k-scrollview-pageable>li.k-dropdown-wrap:before,kendo-scrollview.k-scrollview-wrap .k-toolbar .k-scrollview-pageable>li.k-picker-wrap:before{pointer-events:auto;border-radius:0}div.k-scrollview .k-scrollview-next,div.k-scrollview .k-scrollview-prev,kendo-scrollview.k-scrollview-wrap .k-scrollview-next,kendo-scrollview.k-scrollview-wrap .k-scrollview-prev{display:table;position:absolute;padding:0;height:60%;top:20%;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;overflow:hidden;-webkit-tap-highlight-color:rgba(0,0,0,0)}div.k-scrollview .k-scrollview-prev,kendo-scrollview.k-scrollview-wrap .k-scrollview-prev{left:0}div.k-scrollview .k-scrollview-next,kendo-scrollview.k-scrollview-wrap .k-scrollview-next{right:0}div.k-scrollview .k-scrollview-next span,div.k-scrollview .k-scrollview-prev span,kendo-scrollview.k-scrollview-wrap .k-scrollview-next span,kendo-scrollview.k-scrollview-wrap .k-scrollview-prev span{display:table-cell;margin:0;padding:0;vertical-align:middle;font-size:4.5em;font-weight:400}div.k-scrollview .k-scrollview-elements,kendo-scrollview.k-scrollview-wrap .k-scrollview-elements{width:100%}div.k-scrollview .k-scrollview-animation,kendo-scrollview.k-scrollview-wrap .k-scrollview-animation{transition-duration:.3s;transition-timing-function:ease-in-out}div.k-scrollview div.k-scrollview-wrap{white-space:nowrap}div.k-scrollview div.k-scrollview-wrap>[data-role=page]{vertical-align:top;display:inline-block;min-height:1px}div.k-scrollview .k-scrollview-nav-wrap{position:absolute;bottom:15px;left:10px;right:10px;height:20px;overflow:hidden}div.k-scrollview .k-scrollview-nav-wrap .k-scrollview-nav{margin:0;padding:5px 0 0;display:block;white-space:nowrap;overflow-x:scroll;overflow-y:hidden;text-align:center;list-style:none;position:static;pointer-events:auto}div.k-scrollview .k-scrollview-nav-wrap .k-scrollview-nav>li{vertical-align:top}@supports (-webkit-user-select:none){div.k-scrollview ul.k-scrollview-wrap li>*,kendo-scrollview.k-scrollview-wrap ul.k-scrollview li>*{pointer-events:auto}}@supports not (-webkit-user-select:none){div.k-scrollview ul.k-scrollview-wrap li>*,kendo-scrollview.k-scrollview-wrap ul.k-scrollview li>*{pointer-events:none}}div.k-scrollview .k-scrollview-nav>li.k-link,div.k-scrollview .k-scrollview-pageable>li.k-button,kendo-scrollview.k-scrollview-wrap .k-scrollview-nav>li.k-link,kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-button{border-color:rgba(0,0,0,.08);background-color:#f6f6f6;box-shadow:0 0 2px rgba(0,0,0,.08);background-clip:padding-box}div.k-scrollview .k-scrollview-nav>li.k-link.k-primary,div.k-scrollview .k-scrollview-pageable>li.k-button.k-primary,kendo-scrollview.k-scrollview-wrap .k-scrollview-nav>li.k-link.k-primary,kendo-scrollview.k-scrollview-wrap .k-scrollview-pageable>li.k-button.k-primary{border-color:#ff6358;background-color:#ff6358}div.k-scrollview .k-scrollview-elements,kendo-scrollview.k-scrollview-wrap .k-scrollview-elements{color:#fff}div.k-scrollview .k-scrollview-next,div.k-scrollview .k-scrollview-prev,kendo-scrollview.k-scrollview-wrap .k-scrollview-next,kendo-scrollview.k-scrollview-wrap .k-scrollview-prev{color:inherit;background:transparent;text-shadow:rgba(0,0,0,.3) 0 0 15px;opacity:.7;outline-width:0}div.k-scrollview .k-scrollview-next:hover,div.k-scrollview .k-scrollview-prev:hover,kendo-scrollview.k-scrollview-wrap .k-scrollview-next:hover,kendo-scrollview.k-scrollview-wrap .k-scrollview-prev:hover{color:#fff;opacity:1}.k-listview>.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-listview>.k-state-selected{color:inherit;background-color:rgba(255,99,88,.25)}.k-autocomplete .k-i-close,.k-autocomplete .k-i-group-delete:before{display:none;-ms-flex-item-align:center;align-self:center}.k-autocomplete.k-state-focused .k-i-close,.k-autocomplete.k-state-focused .k-i-group-delete:before,.k-autocomplete.k-state-hover .k-i-close,.k-autocomplete.k-state-hover .k-i-group-delete:before{display:-ms-flexbox;display:flex;outline:0}.k-autocomplete{background-clip:padding-box}.k-edge12 .k-autocomplete,.k-edge13 .k-autocomplete,.k-ie11 .k-autocomplete{background-clip:border-box}.k-tooltip{border-radius:2px;line-height:1.4285714286;padding:4px 8px;border-width:0;box-sizing:border-box;background-repeat:repeat-x;position:absolute;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;z-index:12000}.k-tooltip:not(.k-tooltip-closable){font-size:14px}.k-tooltip-title{display:-ms-inline-flexbox;display:inline-flex;padding:4px 0;font-size:19px}.k-tooltip-content{overflow:hidden;text-overflow:ellipsis}.k-tooltip-closable{padding:12px 16px;line-height:normal}.k-tooltip-closable .k-tooltip-title{display:-ms-inline-flexbox;display:inline-flex;padding:0 20px 12px 0;line-height:1}.k-tooltip-closable .k-tooltip-content{padding-right:20px}.k-rtl .k-tooltip-closable .k-tooltip-content,[dir-rtl] .k-tooltip-closable .k-tooltip-content{padding-left:20px;padding-right:0}.k-tooltip-button{position:absolute;top:12px;right:16px}.k-tooltip-button .k-icon{color:inherit;vertical-align:top}.k-rtl .k-tooltip-button,[dir-rtl] .k-tooltip-button{left:16px;right:auto}.k-callout{position:absolute;width:0;height:0;border:6px solid transparent;pointer-events:none}.k-callout-n{left:50%;margin-left:-6px;border-bottom-color:currentColor;top:-12px;pointer-events:none}.k-callout-e{top:50%;margin-top:-6px;border-left-color:currentColor;right:-12px;pointer-events:none}.k-callout-s{left:50%;margin-left:-6px;border-top-color:currentColor;bottom:-12px;pointer-events:none}.k-callout-w{top:50%;margin-top:-6px;border-right-color:currentColor;left:-12px;pointer-events:none}.k-tooltip-wrapper .k-tooltip{box-shadow:0 2px 4px 0 rgba(0,0,0,.03),0 4px 5px 0 rgba(0,0,0,.04)}.k-tooltip{color:#fff;background-color:#ff6358}.k-callout{color:#ff6358}.k-slider{background-color:transparent;border-width:0;position:relative}.k-slider .k-button{height:28px;line-height:28px;margin:0;min-width:0;outline:0;padding:0;position:absolute;width:28px;box-sizing:content-box}.k-slider .k-button .k-icon{vertical-align:baseline;line-height:28px;margin-right:0;height:100%}.k-slider .k-button-increase{right:0;top:0}.k-slider .k-button-decrease{left:0;top:0}.k-slider .k-label{font-size:.92em;position:absolute;white-space:nowrap}.k-slider .k-slider-track,.k-slider .k-tick{cursor:pointer}.k-slider .k-tick{background-color:transparent;background-position:50%;background-repeat:no-repeat;margin:0;padding:0;position:relative}.k-slider.k-state-disabled .k-draghandle,.k-slider.k-state-disabled .k-slider-track,.k-slider.k-state-disabled .k-tick{cursor:default}.k-slider[dir=rtl] .k-slider-selection{left:auto;right:0}.k-slider[dir=rtl] .k-button-increase{left:0;right:auto}.k-slider[dir=rtl] .k-button-decrease{right:0;left:auto}.k-slider-vertical{height:200px;width:30px;outline:0}.k-slider-vertical .k-button-decrease{bottom:0;top:auto}.k-slider-vertical .k-tick{text-align:right;margin-left:2px}.k-slider-vertical .k-slider-topleft .k-tick{text-align:left}.k-slider-vertical .k-tick{background-position:-92px}.k-slider-vertical .k-slider-topleft .k-tick{background-position:-122px}.k-slider-vertical .k-slider-bottomright .k-tick{background-position:-152px}.k-slider-vertical .k-tick-large{background-position:-2px}.k-slider-vertical .k-slider-topleft .k-tick-large{background-position:-32px}.k-slider-vertical .k-slider-bottomright .k-tick-large{background-position:-62px}.k-slider-vertical .k-first{background-position:-92px 100%}.k-slider-vertical .k-tick-large.k-first{background-position:-2px 100%}.k-slider-vertical .k-slider-topleft .k-first{background-position:-122px 100%}.k-slider-vertical .k-slider-topleft .k-tick-large.k-first{background-position:-32px 100%}.k-slider-vertical .k-slider-bottomright .k-first{background-position:-152px 100%}.k-slider-vertical .k-slider-bottomright .k-tick-large.k-first{background-position:-62px 100%}.k-slider-vertical .k-last{background-position:-92px 0}.k-slider-vertical .k-tick-large.k-last{background-position:-2px 0}.k-slider-vertical .k-slider-topleft .k-last{background-position:-122px 0}.k-slider-vertical .k-slider-topleft .k-tick-large.k-last{background-position:-32px 0}.k-slider-vertical .k-slider-bottomright .k-last{background-position:-152px 0}.k-slider-vertical .k-slider-bottomright .k-tick-large.k-last{background-position:-62px 0}.k-slider-vertical .k-label{display:block;left:120%;text-align:left}.k-slider-vertical .k-last .k-label{top:-.5em}.k-slider-vertical .k-first .k-label{bottom:-.5em}.k-slider-vertical .k-slider-topleft .k-label{left:auto;right:120%}.k-slider-horizontal{display:inline-block;height:30px;width:200px;outline:0}.k-slider-horizontal .k-tick{float:left;height:100%;text-align:center;margin-top:2px;background-position:center -92px}.k-slider-horizontal .k-slider-topleft .k-tick{background-position:center -122px}.k-slider-horizontal .k-slider-bottomright .k-tick{background-position:center -152px}.k-slider-horizontal .k-tick-large{background-position:center -2px}.k-slider-horizontal .k-slider-topleft .k-tick-large{background-position:center -32px}.k-slider-horizontal .k-slider-bottomright .k-tick-large{background-position:center -62px}.k-slider-horizontal .k-first{background-position:0 -92px}.k-slider-horizontal .k-tick-large.k-first{background-position:0 -2px}.k-slider-horizontal .k-slider-topleft .k-first{background-position:0 -122px}.k-slider-horizontal .k-slider-topleft .k-tick-large.k-first{background-position:0 -32px}.k-slider-horizontal .k-slider-bottomright .k-first{background-position:0 -152px}.k-slider-horizontal .k-slider-bottomright .k-tick-large.k-first{background-position:0 -62px}.k-slider-horizontal .k-last{background-position:100% -92px}.k-slider-horizontal .k-tick-large.k-last{background-position:100% -2px}.k-slider-horizontal .k-slider-topleft .k-last{background-position:100% -122px}.k-slider-horizontal .k-slider-topleft .k-tick-large.k-last{background-position:100% -32px}.k-slider-horizontal .k-slider-bottomright .k-last{background-position:100% -152px}.k-slider-horizontal .k-slider-bottomright .k-tick-large.k-last{background-position:100% -62px}.k-slider-horizontal .k-label{left:0;bottom:-1.2em;line-height:1;width:100%}.k-slider-horizontal .k-first .k-label{left:-50%}.k-slider-horizontal .k-last .k-label{left:auto;right:-50%}.k-slider-horizontal .k-slider-topleft .k-label{top:-1.2em}.k-slider-horizontal[dir=rtl] .k-button-decrease .k-icon,.k-slider-horizontal[dir=rtl] .k-button-increase .k-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.k-slider-wrap{height:100%;width:100%}.k-slider-selection,.k-slider-track{margin:0;padding:0;position:absolute}.k-slider-horizontal .k-slider-selection,.k-slider-horizontal .k-slider-track{height:4px;left:0;margin-top:-2px;top:50%}.k-slider-vertical .k-slider-selection,.k-slider-vertical .k-slider-track{bottom:0;left:50%;margin-left:-2px;width:4px}.k-slider-horizontal .k-slider-buttons .k-slider-track{left:38px}.k-slider-vertical .k-slider-buttons .k-slider-track{bottom:38px}.k-draghandle{background-color:transparent;background-repeat:no-repeat;border-style:solid;border-width:1px;outline:0;overflow:hidden;position:absolute;text-align:center;text-decoration:none;text-indent:-3333px;box-sizing:content-box;width:14px;height:14px}.k-slider-horizontal .k-draghandle{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.k-slider-horizontal .k-draghandle.k-pressed,.k-slider-horizontal .k-draghandle:active{-webkit-transform:translateY(-50%) scale(1);transform:translateY(-50%) scale(1)}.k-slider-vertical .k-draghandle{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.k-slider-vertical .k-draghandle.k-pressed,.k-slider-vertical .k-draghandle:active{-webkit-transform:translateX(-50%) scale(1);transform:translateX(-50%) scale(1)}.k-slider-transitions.k-slider-horizontal .k-draghandle{transition:left .3s ease-out,background-color .3s ease-out,-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:left .3s ease-out,background-color .3s ease-out,transform .4s cubic-bezier(.25,.8,.25,1);transition:left .3s ease-out,background-color .3s ease-out,transform .4s cubic-bezier(.25,.8,.25,1),-webkit-transform .4s cubic-bezier(.25,.8,.25,1)}.k-slider-transitions.k-slider-vertical .k-draghandle{transition:bottom .3s ease-out,background-color .3s ease-out,-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:bottom .3s ease-out,background-color .3s ease-out,transform .4s cubic-bezier(.25,.8,.25,1);transition:bottom .3s ease-out,background-color .3s ease-out,transform .4s cubic-bezier(.25,.8,.25,1),-webkit-transform .4s cubic-bezier(.25,.8,.25,1)}.k-draghandle.k-pressed{transition:none}.k-slider-transitions.k-slider-horizontal .k-slider-selection{transition:width .3s ease-out}.k-slider-transitions.k-slider-vertical .k-slider-selection{transition:height .3s ease-out}.k-slider-selection.k-pressed{transition:none}.k-slider-items{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.k-slider-buttons .k-slider-items{margin-left:38px}.k-slider-horizontal .k-slider-items{height:100%}.k-slider-vertical .k-slider-items{padding-top:1px}.k-slider-horizontal .k-slider-buttons .k-slider-items{padding-top:0}.k-slider-vertical .k-slider-buttons .k-slider-items{margin:0;padding-top:38px}.k-slider-tooltip .k-callout-n,.k-slider-tooltip .k-callout-s{margin-left:-6px}.k-slider-tooltip .k-callout-e,.k-slider-tooltip .k-callout-w{margin-top:-6px}.k-slider .k-slider-selection,.k-slider .k-slider-track{border-radius:2px}.k-slider .k-slider-track{background-color:#e6e5e5}.k-slider .k-slider-selection{background-color:#ff6358}.k-slider .k-button,.k-slider .k-draghandle{border-radius:50%}.k-slider .k-draghandle.k-pressed,.k-slider .k-draghandle:active{box-shadow:inset 0 2px 2px 0 rgba(0,0,0,.06)}.k-slider .k-draghandle:focus,.k-slider.k-state-focused .k-draghandle{box-shadow:0 3px 4px 0 rgba(255,99,88,.4)}.k-slider .k-slider-wrap:focus{outline:none}.k-slider-horizontal .k-tick{background-image:url(\"data:image/gif;base64,R0lGODlhAQC0AIABALi4uAAAACH5BAEAAAEALAAAAAABALQAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7\")}.k-slider-vertical .k-tick{background-image:url(\"data:image/gif;base64,R0lGODlhtAABAIABALi4uAAAACH5BAEAAAEALAAAAAC0AAEAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7\")}.k-colorpicker{width:auto;border-width:0;display:inline-block;position:relative;overflow:visible}.k-colorpicker .k-selected-color{padding:4px;width:calc(8px + 1.4285714286em);height:calc(8px + 1.4285714286em);box-sizing:border-box;line-height:0;position:relative;overflow:hidden}.k-colorpicker .k-selected-color .k-i-line{border-top:1px solid #f31700;width:200%;height:200%;position:absolute;top:50%;left:50%;-webkit-transform:translate(-33%,-33%) rotate(45deg);transform:translate(-33%,-33%) rotate(45deg);-webkit-transform-origin:0 0;transform-origin:0 0}.k-colorpicker .k-selected-color .k-i-line:before{display:none}.k-colorpicker .k-tool-icon{padding:4px;width:calc(8px + 1.4285714286em);height:calc(8px + 1.4285714286em);border-width:0;border-style:solid;border-color:inherit;box-sizing:border-box;font-size:inherit;text-align:center}.k-colorpicker .k-tool-icon:before{font-size:16px;line-height:1}.k-colorpicker .k-tool-icon .k-selected-color{margin:0 0 12px;padding:0;width:14px;height:3px;line-height:0;display:inline-block}.k-colorpicker .k-picker-wrap{overflow:hidden}.k-flatcolorpicker{border-radius:2px;padding:0 0 1em;width:250px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch}.k-flatcolorpicker .k-draghandle{border-radius:50%;width:1em;height:1em;border:1px solid hsla(0,0%,100%,.8);box-shadow:0 1px 4px rgba(0,0,0,.21);box-sizing:border-box}.k-flatcolorpicker .k-selected-color{border-width:0 0 1px;border-style:solid;border-color:inherit;background-position:50% 50%}.k-flatcolorpicker .k-color-input{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;position:relative}.k-flatcolorpicker .k-color-value{margin:0 0 0 calc(16px + 2.8571428571em);padding:4px 8px;width:100%;border:0;box-sizing:border-box;font-size:inherit;line-height:1.4285714286;font-family:SFMono-Regular,Menlo,Monaco,Consolas,Roboto Mono,Ubuntu Mono,Lucida Console,Courier New,monospace;outline:0;-ms-flex:1;flex:1}.k-flatcolorpicker .k-clear-color-container{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.k-flatcolorpicker .k-clear-color{-ms-flex:1;flex:1}.k-flatcolorpicker .k-color-value+.k-clear-color{-ms-flex:none;flex:none;position:absolute;top:0;right:0}.k-flatcolorpicker .k-hsv-rectangle{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:pinch-zoom double-tap-zoom}.k-flatcolorpicker .k-hsv-rectangle .k-draghandle{margin:-7px 0 0 -7px;cursor:pointer;position:absolute;z-index:10;left:50%;top:50%}.k-flatcolorpicker .k-hsv-gradient{margin-bottom:5px;height:180px;background:linear-gradient(180deg,transparent,#000),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.k-flatcolorpicker>.k-slider{margin:1em 1em 0}.k-flatcolorpicker .k-hue-slider,.k-flatcolorpicker .k-transparency-slider{display:block}.k-flatcolorpicker .k-hue-slider .k-draghandle,.k-flatcolorpicker .k-transparency-slider .k-draghandle{border-width:3px;box-shadow:0 1px 4px rgba(0,0,0,.9);background-color:transparent}.k-flatcolorpicker .k-hue-slider .k-draghandle:focus,.k-flatcolorpicker .k-hue-slider .k-draghandle:hover,.k-flatcolorpicker .k-transparency-slider .k-draghandle:focus,.k-flatcolorpicker .k-transparency-slider .k-draghandle:hover{border-color:#fff;box-shadow:0 1px 4px #000;background-color:transparent}.k-flatcolorpicker .k-hue-slider{width:1em;height:1em}.k-flatcolorpicker .k-hue-slider .k-slider-track{background:linear-gradient(90deg,red,#ff0,lime,cyan,blue,#f0f,red)}.k-flatcolorpicker .k-hue-slider .k-slider-selection{background:none;opacity:0}.k-flatcolorpicker .k-slider-horizontal{width:90%;height:20px}.k-flatcolorpicker .k-controls{margin:1em 1em 0;text-align:center}.k-colorpalette{border-width:0;line-height:0;display:inline-block;position:relative}.k-colorpalette .k-palette{width:100%;height:100%;border-collapse:collapse;position:relative}.k-colorpalette .k-item{width:14px;height:14px;overflow:hidden;-ms-high-contrast-adjust:none}.k-colorpalette .k-item:hover{box-shadow:0 1px 3px 1px rgba(0,0,0,.5),inset 0 0 0 1px hsla(0,0%,100%,.3);position:relative;z-index:101}.k-colorpalette .k-item.k-state-selected,.k-colorpalette .k-item.k-state-selected:hover{box-shadow:0 1px 3px 1px rgba(0,0,0,.7),inset 0 0 0 1px hsla(0,0%,100%,.45);position:relative;z-index:100}.k-colorpicker .k-picker-wrap{background-clip:padding-box}.k-edge12 .k-colorpicker .k-picker-wrap,.k-edge13 .k-colorpicker .k-picker-wrap,.k-ie11 .k-colorpicker .k-picker-wrap{background-clip:border-box}.k-colorpicker .k-select{padding:0;width:calc(8px + 1.4285714286em);border-width:0}.k-colorpicker .k-state-focused{box-shadow:0 3px 4px 0 rgba(0,0,0,.06)}.k-combobox-clearable .k-input{padding-right:24px}.k-combobox-clearable[dir=rtl] .k-input,.k-rtl .k-combobox-clearable .k-input{padding-left:24px;padding-right:8px}.k-combobox .k-dropdown-wrap{background-clip:padding-box;cursor:auto}.k-edge12 .k-combobox .k-dropdown-wrap,.k-edge13 .k-combobox .k-dropdown-wrap,.k-ie11 .k-combobox .k-dropdown-wrap{background-clip:border-box}.k-combobox .k-select{padding:0;width:calc(8px + 1.4285714286em);border-width:0}.k-calendar{border-width:1px;border-style:solid;line-height:1.4285714286;position:relative;overflow:hidden;display:inline-block}.k-calendar .k-link{outline:0;color:inherit;text-decoration:none;white-space:normal;cursor:pointer;overflow:hidden}.k-calendar table{margin:0;border-width:0;border-color:inherit;border-spacing:0;border-collapse:separate;table-layout:fixed;outline:0;position:relative;z-index:1}.k-calendar td,.k-calendar th{border-width:0;padding:0;text-align:center;border-style:solid;border-color:inherit;font-weight:400;cursor:default}.k-calendar th{padding:.25em 0;font-size:12px;line-height:2;text-transform:uppercase;opacity:.6}.k-calendar tbody th{padding-left:8px;padding-right:8px;height:2em;font:inherit;font-weight:700;text-transform:none;text-align:left}.k-calendar .k-header{border-bottom-width:1px;border-bottom-style:solid;text-align:center;position:relative;z-index:2}.k-calendar .k-header,.k-calendar .k-header .k-link{padding:4px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.k-calendar .k-header .k-link{border-radius:2px;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.k-calendar .k-nav-next,.k-calendar .k-nav-prev{width:1.4285714286em;height:1.4285714286em;box-sizing:content-box}.k-calendar .k-nav-fast{margin:0 4px;-ms-flex:1 1 auto;flex:1 1 auto}.k-calendar .k-calendar-header{padding:8px 16px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;-ms-flex:0 0 auto;flex:0 0 auto;line-height:2em}.k-calendar .k-calendar-header .k-title{font-weight:700}.k-calendar .k-calendar-header .k-today{cursor:pointer}.k-calendar:not(.k-calendar-infinite) .k-calendar-header{line-height:inherit}.k-calendar .k-footer{text-align:center;clear:both}.k-calendar .k-footer>.k-state-disabled,.k-calendar .k-nav-today{padding:8px 16px;display:block}.k-calendar .k-nav-today:hover{text-decoration:underline}.k-calendar .k-calendar-view{width:17em;height:17em;position:relative;z-index:1;overflow:hidden}.k-calendar.k-week-number .k-calendar-view{width:19.4285714286em}.k-calendar-infinite .k-calendar-view{width:17em;height:21.4285714286em}.k-calendar .k-content{margin:0;text-align:center;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}.k-calendar .k-content>table{table-layout:auto}.k-calendar .k-content td{border-radius:2px;border-color:transparent}.k-calendar .k-content .k-link{border-radius:2px;padding:.5em;box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.k-calendar .k-content .k-weekend{border-radius:0;opacity:1}.k-calendar .k-content .k-alt,.k-calendar .k-content .k-other-month .k-link,.k-calendar .k-content .k-state-disabled{opacity:.6}.k-calendar table.k-content{display:inline-table;vertical-align:top}.k-calendar .k-calendar-monthview .k-link,.k-calendar .k-calendar-monthview td,.k-calendar .k-month .k-link,.k-calendar .k-month td{width:2.4285714286em;height:2.4285714286em}.k-calendar .k-calendar-yearview td,.k-calendar .k-year td{width:auto;height:auto}.k-calendar .k-calendar-yearview .k-link,.k-calendar .k-year .k-link{width:4.25em;height:4.25em}.k-calendar .k-calendar-decadeview td,.k-calendar .k-decade td{width:auto;height:auto}.k-calendar .k-calendar-decadeview .k-link,.k-calendar .k-decade .k-link{width:4.25em;height:4.25em}.k-calendar .k-calendar-centuryview td,.k-calendar .k-century td{width:auto;height:auto}.k-calendar .k-calendar-centuryview .k-link,.k-calendar .k-century .k-link{width:4.25em;height:4.25em;text-align:left}.k-calendar-infinite{box-sizing:content-box;width:auto;display:-ms-inline-flexbox;display:inline-flex;vertical-align:bottom}.k-calendar-infinite .k-calendar-monthview,.k-calendar-infinite .k-calendar-view{padding:0 16px;display:-ms-flexbox;display:flex;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-direction:column;flex-direction:column;overflow:hidden;box-sizing:content-box}.k-calendar-infinite .k-calendar-monthview:after,.k-calendar-infinite .k-calendar-view:after{display:block;position:absolute;bottom:0;content:\" \";height:0;line-height:0;z-index:1;width:150%;left:-25%;box-shadow:0 0 2.4285714286em 1.2142857143em #fff}.k-calendar-infinite .k-calendar-header{margin-left:-16px;margin-right:-16px}.k-calendar-infinite .k-calendar-weekdays{width:100%;-ms-flex:0 0 auto;flex:0 0 auto}.k-calendar-infinite .k-calendar-centuryview .k-content td,.k-calendar-infinite .k-calendar-decadeview .k-content td,.k-calendar-infinite .k-calendar-yearview .k-content td{width:auto;height:auto}.k-calendar-infinite .k-calendar-centuryview .k-content .k-link,.k-calendar-infinite .k-calendar-decadeview .k-content .k-link,.k-calendar-infinite .k-calendar-yearview .k-content .k-link{width:3.4em;height:3.4em}.k-calendar-container{padding:0}.k-calendar-container .k-calendar{border-width:0}.k-calendar .k-content.k-scrollable{box-sizing:content-box;overflow-x:hidden;overflow-y:auto;padding-right:100px;padding-left:100px;margin-left:-100px;margin-right:-100px;margin-right:-117px}.k-calendar .k-scrollable-placeholder{position:absolute;z-index:-1;width:1px;top:0;right:0}.k-calendar-navigation{position:relative;display:block;overflow:hidden;width:5em;z-index:2}.k-calendar-navigation:after,.k-calendar-navigation:before{display:block;position:absolute;content:\" \";height:0;line-height:0;z-index:1;width:200%;left:-50%;box-shadow:0 0 6em 3em #f6f6f6}.k-calendar-navigation:before{top:0}.k-calendar-navigation:after{bottom:0}.k-calendar-navigation .k-content{background:transparent;height:auto;position:absolute;top:0;left:0;bottom:0;right:0}.k-calendar-navigation .k-content ul{width:5em}.k-calendar-navigation .k-content li{height:2em;line-height:2em;cursor:pointer;padding:0 1em}.k-calendar-navigation .k-calendar-navigation-marker{font-weight:700}.k-calendar-navigation .k-calendar-navigation-highlight{width:100%;border-width:1px 0;border-style:solid;height:2em;box-sizing:border-box;position:absolute;top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.k-calendar.k-calendar-range{width:auto}.k-calendar.k-calendar-range .k-calendar-view{height:auto;min-height:17em;width:auto;white-space:nowrap}.k-calendar.k-calendar-range .k-calendar-view:after{display:none}.k-calendar.k-calendar-range table{width:auto}.k-calendar.k-calendar-range table.k-content{padding:0 16px}.k-calendar.k-calendar-range table.k-meta-view{margin:0 -1px}.k-calendar.k-calendar-range .k-meta-header,.k-calendar.k-calendar-range .k-month-header{margin:0 16px;padding:.25em 8px;font-size:12px;line-height:2;text-align:left;opacity:.6;cursor:default}.k-calendar.k-calendar-range .k-range-start{border-color:inherit;border-top-right-radius:0;border-bottom-right-radius:0}.k-calendar.k-calendar-range .k-range-end{border-color:inherit;border-top-left-radius:0;border-bottom-left-radius:0}.k-calendar.k-calendar-range .k-range-mid{border-color:inherit;border-radius:0}.k-calendar.k-calendar-range:not(.k-calendar-infinite) .k-calendar-view{-ms-flex-direction:row;flex-direction:row}.k-calendar.k-calendar-range.k-calendar-infinite table{padding:0;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.k-calendar.k-calendar-range.k-calendar-infinite table>tbody{display:inline-block;vertical-align:top}.k-calendar.k-calendar-range.k-calendar-infinite table>tbody+tbody{margin-left:32px}.k-calendar.k-calendar-range.k-calendar-infinite>.k-button{border-radius:0;width:44px}.k-calendar.k-calendar-range.k-calendar-infinite>.k-calendar-view{border-width:0 1px;border-style:solid;border-color:inherit}.k-widget.k-daterangepicker{border:0}.k-calendar[dir=rtl] .k-nav-next .k-icon,.k-calendar[dir=rtl] .k-nav-prev .k-icon,.k-rtl .k-calendar .k-nav-next .k-icon,.k-rtl .k-calendar .k-nav-prev .k-icon{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-calendar[dir=rtl] .k-content.k-scrollable,.k-rtl .k-calendar .k-content.k-scrollable{padding-right:100px;padding-left:100px;margin-left:-100px;margin-right:-100px;margin-left:-117px}.k-calendar[dir=rtl] tbody th,.k-rtl .k-calendar tbody th{text-align:right}.k-calendar{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff;background-clip:padding-box}.k-edge12 .k-calendar,.k-edge13 .k-calendar,.k-ie11 .k-calendar{background-clip:border-box}.k-calendar .k-header{border-color:inherit;color:#656565;background-color:#f6f6f6;box-shadow:0 1px 3px 1px rgba(0,0,0,.1)}.k-calendar .k-nav-fast.k-state-hover,.k-calendar .k-nav-fast:hover,.k-calendar .k-nav-next.k-state-hover,.k-calendar .k-nav-next:hover,.k-calendar .k-nav-prev.k-state-hover,.k-calendar .k-nav-prev:hover{border-color:rgba(0,0,0,.15);color:#656565;background-color:#ededed;background-image:linear-gradient(#ededed,#e8e8e8)}.k-calendar .k-nav-fast.k-state-active,.k-calendar .k-nav-fast:active,.k-calendar .k-nav-next.k-state-active,.k-calendar .k-nav-next:active,.k-calendar .k-nav-prev.k-state-active,.k-calendar .k-nav-prev:active{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6;background-image:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.06)}.k-calendar .k-calendar-header .k-today,.k-calendar .k-footer .k-nav-today{color:#ff6358}.k-calendar .k-calendar-header .k-today:focus,.k-calendar .k-calendar-header .k-today:hover,.k-calendar .k-footer .k-nav-today:focus,.k-calendar .k-footer .k-nav-today:hover{color:#e76057}.k-calendar .k-content th{color:#656565}.k-calendar .k-content .k-today{color:#ff6358}.k-calendar .k-weekend{color:inherit;background-color:transparent}.k-calendar .k-alt{color:#656565;background-color:#f6f6f6}.k-calendar .k-out-of-range{pointer-events:none;visibility:hidden}.k-calendar .k-state-hover .k-link{border-color:#ededed;color:#656565;background-color:#ededed}.k-calendar .k-state-selected .k-link{border-color:#ff6358;color:#fff;background-color:#ff6358}.k-calendar .k-state-selected .k-link.k-state-hover{background-color:#ed5c52}.k-calendar .k-state-focused .k-link,.k-calendar .k-state-selected.k-state-focused .k-link{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-calendar .k-calendar-navigation{color:#656565;background-color:#f6f6f6;box-shadow:inset -1px 0 rgba(0,0,0,.08)}.k-calendar .k-calendar-navigation li:hover{color:#e76057}.k-calendar .k-calendar-navigation-highlight{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff}.k-calendar[dir=rtl] .k-calendar-navigation,.k-rtl .k-calendar .k-calendar-navigation{box-shadow:inset 1px 0 rgba(0,0,0,.08)}.k-calendar.k-calendar-range .k-range-end,.k-calendar.k-calendar-range .k-range-mid,.k-calendar.k-calendar-range .k-range-start{background-image:linear-gradient(transparent 1px,rgba(255,99,88,.25) 0,rgba(255,99,88,.25) calc(100% - 1px),transparent calc(100% - 1px))}.k-calendar.k-calendar-range .k-range-start.k-range-end{background-image:none;background-color:transparent}.k-calendar.k-calendar-range .k-range-end .k-link,.k-calendar.k-calendar-range .k-range-start .k-link{background-color:#ff6358}.k-calendar.k-calendar-range .k-range-end.k-state-active .k-link,.k-calendar.k-calendar-range .k-range-start.k-state-active .k-link{box-shadow:inset 0 0 2px 2px rgba(0,0,0,.2)}.k-calendar.k-calendar-range .k-range-split-end,.k-calendar.k-calendar-range .k-range-split-start{position:relative}.k-calendar.k-calendar-range .k-range-split-end:after,.k-calendar.k-calendar-range .k-range-split-start:after{content:\"\";display:block;position:absolute;top:1px;bottom:1px;width:5px}.k-calendar.k-calendar-range .k-range-split-start:after{left:-5px;right:auto;background-image:linear-gradient(270deg,rgba(255,99,88,.25),transparent)}.k-calendar.k-calendar-range .k-range-split-end:after{right:-5px;left:auto;background-image:linear-gradient(90deg,rgba(255,99,88,.25),transparent)}.k-datepicker .k-i-warning,.k-datetimepicker .k-i-warning,.k-timepicker .k-i-warning{display:none;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);overflow:visible}.k-datepicker .k-state-invalid .k-i-warning,.k-datetimepicker .k-state-invalid .k-i-warning,.k-timepicker .k-state-invalid .k-i-warning{display:inline-block}.k-datepicker .k-dateinput,.k-datetimepicker .k-dateinput,.k-timepicker .k-dateinput{width:100%;-ms-flex:1 1 auto;flex:1 1 auto;margin:0}.k-datepicker .k-dateinput-wrap,.k-datetimepicker .k-dateinput-wrap,.k-timepicker .k-dateinput-wrap{border:0;border-radius:2px 0 0 2px}.k-datepicker[dir=rtl] .k-i-warning,.k-datetimepicker[dir=rtl] .k-i-warning,.k-rtl .k-datepicker .k-i-warning,.k-rtl .k-datetimepicker .k-i-warning,.k-rtl .k-timepicker .k-i-warning,.k-timepicker[dir=rtl] .k-i-warning{right:auto}.k-datepicker .k-i-warning,.k-timepicker .k-i-warning{right:calc(12px + 1.4285714286em)}.k-datepicker[dir=rtl] .k-i-warning,.k-rtl .k-datepicker .k-i-warning,.k-rtl .k-timepicker .k-i-warning,.k-timepicker[dir=rtl] .k-i-warning{left:calc(12px + 1.4285714286em)}.k-datetimepicker .k-i-warning{right:calc(20px + 2.8571428571em)}.k-datetimepicker[dir=rtl] .k-i-warning,.k-rtl .k-datetimepicker .k-i-warning{left:calc(20px + 2.8571428571em)}.k-datetimepicker .k-select{padding:0;border-left-width:0;-ms-flex-align:stretch;align-items:stretch}.k-datetimepicker .k-link{padding:4px;border-style:solid;border-color:inherit;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;box-sizing:border-box}.k-dateinput{position:relative;border-width:0}.k-dateinput .k-i-warning{display:none;position:absolute;right:8px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);overflow:visible}.k-dateinput.k-state-invalid .k-i-warning{display:inline-block}.k-dateinput[dir=rtl] .k-i-warning,.k-rtl .k-dateinput .k-i-warning{left:8px;right:auto}.k-time-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:8px 16px;line-height:2em}.k-time-header .k-time-now{border-width:0;background:transparent;line-height:inherit}.k-time-list-wrapper{display:inline-block;overflow:hidden;box-sizing:content-box;overflow-x:hidden;overflow-y:auto;position:relative;padding:20px 0;text-align:center;width:5em;height:200px}.k-time-list-wrapper .k-title{display:block;text-align:center;font-size:10px;position:absolute;text-transform:capitalize;font-weight:700;min-width:100%;height:1.5em;line-height:1.5em;margin-top:-20px;background:transparent}.k-time-list-wrapper.k-state-focused:after,.k-time-list-wrapper.k-state-focused:before{display:block;content:\" \";position:absolute;width:100%;left:0;pointer-events:none;height:calc(50% - 1em);box-sizing:border-box;border-style:solid}.k-time-list-wrapper.k-state-focused:before{top:0;border-width:2px 2px 0}.k-time-list-wrapper.k-state-focused:after{bottom:0;border-width:0 2px 2px}.k-time-container{position:absolute;display:block;overflow-x:hidden;overflow-y:scroll;line-height:1.4285714286;left:0;right:0;top:20px;bottom:20px;padding-right:100px;padding-left:100px;margin-left:-100px;margin-right:-100px;margin-right:-117px}.k-time-container>ul{height:auto;width:5em}.k-time-list-container{display:-ms-flexbox;display:flex;position:relative}.k-time-list{position:absolute;display:-ms-flexbox;display:flex;z-index:10;outline:0;bottom:0;right:0;left:0;top:0}.k-time-list:after,.k-time-list:before{display:block;position:absolute;content:\" \";height:0;line-height:0;z-index:1;width:200%;left:-50%}.k-time-list:before{top:0}.k-time-list:after{bottom:0}.k-time-list .k-item{padding:4px 8px;min-height:calc(1.43em + 2px);line-height:calc(1.43em + 2px)}.k-time-highlight{position:absolute;top:50%;left:0;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:100%;height:calc(8px + 1.4285714286em);z-index:1;border-width:1px 0;border-style:solid;border-radius:.1px}.k-time-container .k-scrollable-placeholder{position:absolute;width:1px;top:0;right:0}.k-time-separator{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-item-align:center;align-self:center;-ms-flex-pack:center;justify-content:center;height:100%;z-index:11}.k-datepicker .k-picker-wrap,.k-datetimepicker .k-picker-wrap,.k-timepicker .k-picker-wrap{background-clip:padding-box}.k-edge12 .k-datepicker .k-picker-wrap,.k-edge12 .k-datetimepicker .k-picker-wrap,.k-edge12 .k-timepicker .k-picker-wrap,.k-edge13 .k-datepicker .k-picker-wrap,.k-edge13 .k-datetimepicker .k-picker-wrap,.k-edge13 .k-timepicker .k-picker-wrap,.k-ie11 .k-datepicker .k-picker-wrap,.k-ie11 .k-datetimepicker .k-picker-wrap,.k-ie11 .k-timepicker .k-picker-wrap{background-clip:border-box}.k-datepicker .k-select,.k-datetimepicker .k-select,.k-timepicker .k-select{padding:0;width:calc(8px + 1.4285714286em);border-width:0}.k-datepicker .k-state-active .k-select,.k-datepicker .k-state-focused .k-select,.k-datepicker .k-state-hover .k-select,.k-datepicker:hover .k-select,.k-datetimepicker .k-state-active .k-select,.k-datetimepicker .k-state-focused .k-select,.k-datetimepicker .k-state-hover .k-select,.k-datetimepicker:hover .k-select,.k-timepicker .k-state-active .k-select,.k-timepicker .k-state-focused .k-select,.k-timepicker .k-state-hover .k-select,.k-timepicker:hover .k-select{border-color:inherit}.k-datepicker .k-picker-wrap.k-state-invalid,.k-datetimepicker .k-picker-wrap.k-state-invalid,.k-timepicker .k-picker-wrap.k-state-invalid{transition:none;border-color:#f31700}.k-datepicker .k-i-warning,.k-datepicker .k-picker-wrap.k-state-invalid .k-input,.k-datetimepicker .k-i-warning,.k-datetimepicker .k-picker-wrap.k-state-invalid .k-input,.k-timepicker .k-i-warning,.k-timepicker .k-picker-wrap.k-state-invalid .k-input{color:#f31700}.k-time-header .k-title{font-weight:700}.k-time-header .k-time-now{color:#ff6358;cursor:pointer}.k-time-header .k-time-now:focus,.k-time-header .k-time-now:hover{color:#e76057}.k-time-list-wrapper{background-color:#f9f9f9}.k-time-list-wrapper .k-title{z-index:12;background:#f9f9f9;opacity:.6}.k-time-list-wrapper.k-state-focused .k-title{color:#000;opacity:1}.k-time-list-wrapper.k-state-focused:after,.k-time-list-wrapper.k-state-focused:before{background-color:rgba(0,0,0,.04);border-width:0}.k-time-list:after,.k-time-list:before{box-shadow:0 0 3em 1.5em #f9f9f9}.k-time-list .k-item:hover{color:#ff6358}.k-time-container{background:transparent}.k-time-highlight{background-color:#fff;border-color:rgba(0,0,0,.08)}.k-datetimepicker .k-select{width:auto}.k-datetimepicker .k-link{padding:0;width:calc(8px + 1.4285714286em);border-width:0}.k-dateinput .k-dateinput-wrap{background-clip:padding-box}.k-edge12 .k-dateinput .k-dateinput-wrap,.k-edge13 .k-dateinput .k-dateinput-wrap,.k-ie11 .k-dateinput .k-dateinput-wrap{background-clip:border-box}.k-dateinput .k-select{padding:0;width:calc(8px + 1.4285714286em);border-width:0}.k-dateinput .k-select>.k-state-active,.k-dateinput .k-select>.k-state-selected{color:#252525;box-shadow:inset 0 3px 4px 0 rgba(0,0,0,.06)}.k-picker-wrap>.k-dateinput .k-state-focused{box-shadow:none}.k-dateinput.k-state-invalid .k-textbox{color:#f31700;border-color:#f31700}.k-dateinput.k-state-invalid .k-i-warning{color:#f31700}.k-dropdowngrid-popup{overflow:hidden}.k-dropdowngrid-popup .k-virtual-wrap{margin:0}.k-grid-list{width:100%;max-width:none;border-width:0;border-collapse:collapse;border-spacing:0;table-layout:fixed;empty-cells:show;outline:none;display:table}.k-dropdowngrid-popup .k-grid-header-wrap{border-width:0 1px 0 0}.k-dropdowngrid-popup .k-grid-header{padding:0;display:block}.k-dropdowngrid-popup .k-grid-header table{width:100%;max-width:none;border-width:0;border-collapse:collapse;border-spacing:0;table-layout:fixed;empty-cells:show;outline:none}.k-dropdowngrid-popup .k-grid-header .k-header{padding:8px 12px;border-width:0 0 0 1px;border-style:solid;font-weight:400;text-align:left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.k-dropdowngrid-popup .k-grid-header .k-header:first-child{border-left:0}.k-grid-list>.k-item{box-sizing:border-box;display:table-row;position:relative}.k-grid-list>.k-item>.k-cell,.k-grid-list>.k-item>.k-group,.k-grid-list>.k-item>.k-spacer-group{box-sizing:border-box;display:table-cell;vertical-align:middle}.k-grid-list.k-virtual-list>.k-item>.k-cell,.k-grid-list.k-virtual-list>.k-item>.k-group,.k-grid-list.k-virtual-list>.k-item>.k-spacer-group{display:inline-block}.k-grid-list>.k-item:last-child>.k-cell,.k-grid-list>.k-item:last-child>.k-group-cell,.k-grid-list>.k-item:last-child>.k-spacer-cell{border-bottom-width:0}.k-grid-list>.k-item>.k-cell{padding:8px 12px;border-width:0 0 0 1px;border-style:solid;text-align:left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.k-grid-list>.k-item>.k-cell:first-child{border-left:0}.k-dropdowngrid-popup .k-group-header{margin:0;padding:8px 12px;min-height:auto;text-align:left}.k-grid-list>.k-item>.k-group-cell,.k-grid-list>.k-item>.k-spacer-cell{padding:0;width:0;border-left-width:0;border-right-width:0;overflow:visible;position:relative}.k-grid-list>.k-item>.k-group-cell>span{padding:0 6px;font-size:.875em;position:absolute;top:0;right:0}.k-dropdowngrid-popup .k-footer{padding:8px 12px;border-width:1px 0 0;border-style:solid;text-align:left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;-ms-flex-negative:0;flex-shrink:0}.k-rtl.k-dropdowngrid-popup .k-grid-header-wrap,.k-rtl .k-dropdowngrid-popup .k-grid-header-wrap{border-right-width:0;border-left-width:1px}.k-rtl.k-dropdowngrid-popup .k-grid-header .k-header,.k-rtl .k-dropdowngrid-popup .k-grid-header .k-header,.k-rtl .k-grid-list>.k-item>.k-cell{border-left-width:0;border-right-width:1px;text-align:right}.k-rtl.k-dropdowngrid-popup .k-grid-header .k-header:first-child,.k-rtl .k-dropdowngrid-popup .k-grid-header .k-header:first-child,.k-rtl .k-grid-list>.k-item>.k-cell:first-child{border-right-width:0}.k-rtl div.k-dropdowngrid-popup .k-group-header{text-align:right}.k-rtl .k-grid-list>.k-item>.k-group-cell>span{right:auto;left:0}.k-dropdowngrid-popup{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff}.k-dropdowngrid-popup .k-footer,.k-dropdowngrid-popup .k-group-header,.k-dropdowngrid-popup .k-header{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6}.k-dropdowngrid-popup .k-item:nth-child(2n){background-color:rgba(0,0,0,.04)}.k-dropdowngrid-popup .k-cell{border-color:rgba(0,0,0,.08)}.k-dropdowngrid-popup .k-item.k-state-hover{border-color:rgba(0,0,0,.08);color:#656565;background-color:#ededed}.k-dropdowngrid-popup .k-item.k-state-selected{border-color:rgba(0,0,0,.08);color:#656565;background-color:rgba(255,99,88,.25)}.k-dropdowngrid-popup .k-item.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-dropdowngrid-popup .k-group-cell span{background-color:#656565;color:#fff}.k-grid-list>.k-item.k-last>.k-cell,.k-grid-list>.k-item.k-last>.k-group-cell,.k-grid-list>.k-item.k-last>.k-spacer-cell{border-bottom-color:#656565}.k-input.k-textbox,.k-textarea,.k-textbox{border-radius:2px;padding:4px 8px;width:12.4em;box-sizing:border-box;border-width:1px;border-style:solid;outline:0;font:inherit;font-size:14px;line-height:1.4285714286;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle;position:relative;-webkit-appearance:none}.k-input.k-textbox,.k-textbox{height:calc(10px + 1.4285714286em)}.k-textarea{width:18em;min-height:calc(8px + 5.7142857143em)}.k-maskedtextbox{display:-ms-inline-flexbox;display:inline-flex;border-width:0}.k-maskedtextbox .k-textbox{-ms-flex:1 0 0px;flex:1 0 0;min-width:0}.k-input,.k-textbox>input{padding:0;width:100%;box-sizing:border-box;border:0;outline:0;color:inherit;background:none;font:inherit;font-size:14px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow:hidden;text-overflow:ellipsis;-webkit-appearance:none}.k-input::-ms-clear,.k-textbox::-ms-clear,.k-textbox>input::-ms-clear{display:none}.k-textbox:focus{box-shadow:0 2px 2px 1px rgba(0,0,0,.06)}.k-textbox.k-state-disabled,.k-textbox:disabled,.k-textbox[disabled]{outline:none;cursor:default;opacity:.6;-webkit-filter:grayscale(.1);filter:grayscale(.1);pointer-events:none;box-shadow:none}.k-textbox-container{position:relative;padding-top:1.0714285714em;display:-ms-inline-flexbox;display:inline-flex;width:12.4em;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:stretch;justify-content:stretch}.k-textbox-container>.k-label{pointer-events:none;position:absolute;line-height:1.4285714286em;cursor:text;top:calc(1.0714285714em + 5px);left:9px;transition:color .2s ease-out,-webkit-transform .2s ease-out;transition:transform .2s ease-out,color .2s ease-out;transition:transform .2s ease-out,color .2s ease-out,-webkit-transform .2s ease-out}.k-textbox-container>.k-textarea,.k-textbox-container>.k-textbox,.k-textbox-container>.k-widget{-ms-flex:1 1 auto;flex:1 1 auto;width:auto}.k-textbox-container.k-state-empty>.k-label{-webkit-transform:translate(0) scale(1);transform:translate(0) scale(1)}.k-textbox-container.k-state-focused>.k-label,.k-textbox-container>.k-label{-webkit-transform:translate(-8px,-3px) translate(-1px,-1.0714285714em) translate(-12.5%,-9.375%) scale(.75);transform:translate(-8px,-3px) translate(-1px,-1.0714285714em) translate(-12.5%,-9.375%) scale(.75)}.k-rtl .k-textbox-container>.k-label,.k-textbox-container[dir=rtl]>.k-label{left:auto;right:9px}.k-rtl .k-textbox-container.k-state-empty>.k-label,.k-textbox-container[dir=rtl].k-state-empty>.k-label{-webkit-transform:translate(0) scale(1);transform:translate(0) scale(1)}.k-rtl .k-textbox-container.k-state-focused>.k-label,.k-rtl .k-textbox-container>.k-label,.k-textbox-container[dir=rtl].k-state-focused>.k-label,.k-textbox-container[dir=rtl]>.k-label{-webkit-transform:translate(8px,-3px) translate(1px,-1.0714285714em) translate(12.5%,-9.375%) scale(.75);transform:translate(8px,-3px) translate(1px,-1.0714285714em) translate(12.5%,-9.375%) scale(.75)}.k-checkbox,.k-radio{margin:0;padding:0;clip:rect(0,0,0,0);overflow:hidden;position:absolute;opacity:0;-webkit-appearance:none;pointer-events:none}.k-checkbox:disabled+.k-checkbox-label,.k-radio:disabled+.k-radio-label{outline:none;cursor:default;opacity:.6;-webkit-filter:grayscale(.1);filter:grayscale(.1);pointer-events:none;box-shadow:none}.k-checkbox-label,.k-radio-label{margin:0;padding-left:20px;min-height:16px;line-height:17px;vertical-align:text-top;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:start;align-items:flex-start;position:relative;cursor:pointer}.k-checkbox-label .k-ripple,.k-radio-label .k-ripple{top:8px;left:8px;right:auto;bottom:auto;width:40px;height:40px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:50%}.k-checkbox-label .k-ripple-blob,.k-radio-label .k-ripple-blob{top:50%!important;left:50%!important;width:200%!important;height:200%!important}.k-checkbox-label.k-no-text,.k-radio-label.k-no-text{padding:0;width:16px;height:16px;display:inline-block;font-size:0}.k-edge .k-checkbox-label.k-no-text,.k-edge .k-radio-label.k-no-text,.k-ie .k-checkbox-label.k-no-text,.k-ie .k-radio-label.k-no-text{width:0}.k-rtl .k-checkbox-label,.k-rtl .k-radio-label,[dir=rtl] .k-checkbox-label,[dir=rtl] .k-radio-label{padding-left:0;padding-right:20px}.k-checkbox-label:after,.k-checkbox-label:before,.k-radio-label:after,.k-radio-label:before{font-size:16px;font-family:WebComponentsIcons,monospace;box-sizing:border-box;text-align:center;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;position:absolute;top:0;left:0}.k-rtl .k-checkbox-label:after,.k-rtl .k-checkbox-label:before,.k-rtl .k-radio-label:after,.k-rtl .k-radio-label:before,[dir=rtl] .k-checkbox-label:after,[dir=rtl] .k-checkbox-label:before,[dir=rtl] .k-radio-label:after,[dir=rtl] .k-radio-label:before{left:auto;right:0}.k-checkbox-label:before,.k-radio-label:before{content:\"\";width:16px;height:16px;border-width:1px;border-style:solid}.k-checkbox-label:before{border-radius:2px}.k-radio-label:before{border-radius:50%}.k-checkbox-label:after{content:\"\\E118\";width:16px;height:16px;-webkit-transform:scale(0);transform:scale(0)}.k-checkbox:checked+.k-checkbox-label:after{border-radius:2px;-webkit-transform:scale(1);transform:scale(1)}.k-checkbox:indeterminate+.k-checkbox-label:after{content:\"\";-webkit-transform:scale(1);transform:scale(1);width:8px;height:8px;top:4px;left:4px}.k-radio-label:after{content:\"\";width:8px;height:8px;border-radius:50%;position:absolute;top:4px;left:4px;-webkit-transform:scale(0);transform:scale(0)}.k-radio:checked+.k-radio-label:after{-webkit-transform:scale(1);transform:scale(1)}.k-rtl .k-radio:checked+.k-radio-label:after,[dir=rtl] .k-radio:checked+.k-radio-label:after{right:4px}.k-radio-list .k-radio-label{line-height:20px}.k-fieldset{margin:30px;border-width:1px 0 0;border-style:solid;padding:25px 0 0}.k-fieldset>legend{margin-left:0;padding:0 8px 0 0;text-transform:uppercase}.k-form,.k-form-inline{font-size:14px;line-height:1.4285714286;padding:16px}.k-form-inline fieldset,.k-form fieldset{border-width:1px 0 0;border-style:solid;margin:32px 0;padding:0}.k-form-inline fieldset:first-child:first-of-type,.k-form fieldset:first-child:first-of-type{margin-top:0}.k-form-inline fieldset:last-child:last-of-type,.k-form fieldset:last-child:last-of-type{margin-bottom:0}.k-form-inline legend,.k-form legend{font-size:12px;text-align:left;font-weight:600;line-height:1;margin-bottom:12px;text-transform:uppercase;padding:0 8px 0 0;width:auto}.k-form-inline .k-form-field,.k-form .k-form-field{display:block;text-align:left;margin-bottom:12px}.k-form-inline .k-form-field>span,.k-form .k-form-field>span{line-height:1.4285714286}.k-form-inline .k-form-field:last-child,.k-form .k-form-field:last-child{margin-bottom:0}.k-form-inline .k-alert-error,.k-form .k-alert-error{font-size:12px;margin-top:8px}.k-form-inline .k-field-info,.k-form .k-field-info{display:inline-block;font-size:10px;line-height:1;margin:0 8px}.k-form-inline .k-checkbox-label,.k-form-inline .k-radio-label,.k-form .k-checkbox-label,.k-form .k-radio-label{margin-right:16px;-ms-flex-item-align:center;align-self:center}.k-form .k-widget:not(.k-calendar),.k-form input,.k-form label:not(.k-checkbox-label):not(.k-radio-label){display:block}.k-form .k-form-field>span:not(.k-widget){display:block;padding:4px 0}.k-form .k-form-field>input{width:100%}.k-form-inline .k-form-field{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.k-form-inline .k-form-field>label:not(.k-checkbox-label):not(.k-radio-label),.k-form-inline .k-form-field>span:not(.k-widget){width:25%;text-align:right;line-height:1.4285714286;padding:5px 0;padding-right:12px;-ms-flex-item-align:center;align-self:center}.k-form-inline .k-form-field>input{-ms-flex:1 1 auto;flex:1 1 auto}.k-form-inline .k-form-field .k-field-info{display:block;margin:0}.k-grid .k-checkbox-label,.k-treeview .k-checkbox-label{cursor:default;outline:0}.k-input.k-textbox,.k-textarea,.k-textbox{background-clip:padding-box}.k-edge12 .k-input.k-textbox,.k-edge12 .k-textarea,.k-edge12 .k-textbox,.k-edge13 .k-input.k-textbox,.k-edge13 .k-textarea,.k-edge13 .k-textbox,.k-ie11 .k-input.k-textbox,.k-ie11 .k-textarea,.k-ie11 .k-textbox{background-clip:border-box}.k-input.k-textbox.k-state-hover,.k-input.k-textbox:hover,.k-textarea.k-state-hover,.k-textarea:hover,.k-textbox.k-state-hover,.k-textbox:hover{border-color:rgba(0,0,0,.15)}.k-input.k-textbox.k-state-focus,.k-input.k-textbox:focus,.k-textarea.k-state-focus,.k-textarea:focus,.k-textbox.k-state-focus,.k-textbox:focus{color:#656565;border-color:rgba(0,0,0,.15)}.k-input.k-textbox.k-invalid,.k-input.k-textbox.k-state-invalid,.k-input.k-textbox.ng-invalid.ng-dirty,.k-input.k-textbox.ng-invalid.ng-touched,.k-textarea.k-invalid,.k-textarea.k-state-invalid,.k-textarea.ng-invalid.ng-dirty,.k-textarea.ng-invalid.ng-touched,.k-textbox.k-invalid,.k-textbox.k-state-invalid,.k-textbox.ng-invalid.ng-dirty,.k-textbox.ng-invalid.ng-touched{color:#f31700;border-color:rgba(243,23,0,.5)}.k-input.k-textbox::selection,.k-textarea::selection,.k-textbox::selection{background-color:#ff6358;color:#fff}.k-input::selection,.k-textarea::selection,.k-textbox::selection{background-color:#ff6358;color:#fff}.k-state-disabled .k-input::selection,.k-state-disabled .k-textarea::selection,.k-state-disabled .k-textbox::selection{color:#656565;background-color:transparent}.k-input.k-textbox::-webkit-input-placeholder,.k-input::-webkit-input-placeholder,.k-textarea::-webkit-input-placeholder,.k-textbox::-webkit-input-placeholder{color:hsla(0,0%,40%,.5)}.k-input.k-textbox:-ms-input-placeholder,.k-input.k-textbox::-ms-input-placeholder,.k-input:-ms-input-placeholder,.k-input::-ms-input-placeholder,.k-textarea:-ms-input-placeholder,.k-textarea::-ms-input-placeholder,.k-textbox:-ms-input-placeholder,.k-textbox::-ms-input-placeholder{color:hsla(0,0%,40%,.5)}.k-input.k-textbox::placeholder,.k-input::placeholder,.k-textarea::placeholder,.k-textbox::placeholder{color:hsla(0,0%,40%,.5)}.k-radio-label:before{border-color:rgba(0,0,0,.08);background-color:#fff}.k-radio:focus+.k-radio-label:before{box-shadow:0 0 0 2px rgba(0,0,0,.06)}.k-radio:checked+.k-radio-label:before{border-color:#ff6358;background-color:#ff6358}.k-radio:checked+.k-radio-label:after{background-color:#fff}.k-radio:checked:focus+.k-radio-label:before{box-shadow:0 0 0 2px rgba(255,99,88,.3)}.k-radio-label:hover:before{border-color:rgba(0,0,0,.15);background-color:#fff}.k-radio-label:hover:after{background-color:#ff6358}.k-checkbox-label:before{background-color:#fff;border-color:rgba(0,0,0,.08)}.k-checkbox:indeterminate+.k-checkbox-label:after{background-color:#ff6358}.k-checkbox:focus+.k-checkbox-label:before{box-shadow:0 0 0 2px rgba(0,0,0,.06)}.k-checkbox:checked+.k-checkbox-label:before{border-color:#ff6358;background-color:#ff6358}.k-checkbox:checked+.k-checkbox-label:after{color:#fff}.k-checkbox:checked:focus+.k-checkbox-label:before{box-shadow:0 0 0 2px rgba(255,99,88,.3)}.k-checkbox-label:hover:before{border-color:rgba(0,0,0,.15);background-color:#fff}.k-checkbox-label:hover:after{color:#ff6358}fieldset{border-color:rgba(0,0,0,.08)}.k-form,.k-form-inline,fieldset legend{color:#656565}.k-form-inline fieldset legend,.k-form fieldset legend{color:#444}.k-form-inline .k-field-info,.k-form .k-field-info{color:#b9b9b9}.k-form-inline .k-alert-error,.k-form .k-alert-error{color:#f31700}.k-required,.k-required.k-field-info{color:#ff6358}.k-dropdowntree .k-select{border-width:0}.k-popup-dropdowntree{padding:0}.k-popup-dropdowntree .k-list-filter{box-shadow:0 2px 4px 0 rgba(0,0,0,.03),0 4px 5px 0 rgba(0,0,0,.04);margin:0 0 6px}.k-popup-dropdowntree .k-check-all .k-checkbox-label{padding-left:28px}.k-popup-dropdowntree .k-check-all{padding:6px 6px 0}.k-popup-dropdowntree .k-list-filter .k-check-all{padding-top:0}.k-popup-dropdowntree .k-treeview{padding:6px}.k-popup-dropdowntree.k-rtl .k-check-all .k-checkbox-label,[dir=rtl] .k-popup-dropdowntree .k-check-all .k-checkbox-label{padding-left:0;padding-right:28px}.k-dropdowntree .k-dropdown-wrap{background-clip:padding-box}.k-edge12 .k-dropdowntree .k-dropdown-wrap,.k-edge13 .k-dropdowntree .k-dropdown-wrap,.k-ie11 .k-dropdowntree .k-dropdown-wrap{background-clip:border-box}.k-dropdowntree .k-dropdown-wrap .k-select{padding:0;width:calc(8px + 1.4285714286em)}html .k-upload{position:relative}.k-upload .k-upload-button{min-width:7em;margin:8px}.k-upload .k-dropzone{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;position:relative;border-width:0;background-color:transparent}.k-upload .k-dropzone .k-dropzone-hint,.k-upload .k-dropzone em{margin-left:1em;-ms-flex:1;flex:1;overflow:hidden;text-overflow:ellipsis;opacity:0;white-space:nowrap;position:relative;vertical-align:middle;visibility:hidden;font-style:italic;display:none}.k-upload .k-dropzone .k-upload-status{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;position:relative;padding:4px 8px;font-size:14px;font-weight:400;line-height:1.4285714286}.k-upload .k-dropzone .k-upload-status>.k-icon{margin-right:6px}.k-upload .k-dropzone.k-dropzone-active .k-dropzone-hint,.k-upload .k-dropzone.k-dropzone-active em{display:block;visibility:visible;opacity:1}.k-upload .k-dropzone.k-dropzone-active .k-upload-status{display:none}.k-upload .k-upload-status-total{margin-left:8px;margin-right:8px}.k-upload .k-upload-files{padding-bottom:4px;border-width:1px 0 0;border-style:solid;border-color:inherit;margin:0}.k-upload .k-upload-files .k-file-multiple,.k-upload .k-upload-files .k-file-single{display:block;width:100%}.k-upload .k-upload-files .k-file{padding:8px;border-width:0 0 1px;border-style:solid;border-color:inherit;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;position:relative;line-height:1.4285714286}.k-upload .k-upload-files .k-progress{position:absolute;bottom:0;left:0}.k-upload .k-upload-files .k-filename{margin-left:1em;-ms-flex:1;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative}.k-upload .k-upload-files .k-upload-status{position:absolute;right:8px;top:8px}.k-upload .k-upload-files .k-upload-status .k-button{padding:0;border-radius:50%}.k-upload .k-upload-files .k-upload-status .k-icon{vertical-align:middle}.k-upload .k-upload-files .k-upload-pct{font-weight:400;vertical-align:middle}.k-upload .k-upload-files~.k-clear-selected,.k-upload .k-upload-files~.k-upload-selected{margin-top:-4px;border-width:0}.k-upload .k-upload-files~.k-upload-selected{border-left-width:1px;border-left-style:solid;margin-left:-1px}.k-upload .k-upload-files .k-file-information,.k-upload .k-upload-files .k-file-name,.k-upload .k-upload-files .k-file-size,.k-upload .k-upload-files .k-file-validation-message{display:block}.k-upload .k-upload-files .k-file-name{position:relative;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:4px}.k-upload .k-upload-files .k-file-information,.k-upload .k-upload-files .k-file-size,.k-upload .k-upload-files .k-file-validation-message{font-size:9.432px}.k-upload .k-upload-files .k-file-information{text-indent:1px}.k-upload .k-upload-files .k-file-extension-wrapper,.k-upload .k-upload-files .k-file-invalid-extension-wrapper,.k-upload .k-upload-files .k-multiple-files-extension-wrapper,.k-upload .k-upload-files .k-multiple-files-invalid-extension-wrapper{position:absolute;top:8px;width:24px;height:34px;border-width:2px;border-style:solid;vertical-align:top;font-size:7.98px;text-transform:uppercase;margin:1px 0;box-sizing:content-box}.k-upload .k-upload-files .k-file-invalid-extension-wrapper,.k-upload .k-upload-files .k-multiple-files-invalid-extension-wrapper{font-size:1.2em}.k-upload .k-upload-files .k-multiple-files-extension-wrapper,.k-upload .k-upload-files .k-multiple-files-invalid-extension-wrapper{margin-top:4px}.k-upload .k-upload-files .k-file-state{visibility:hidden}.k-upload .k-upload-files .k-file-name-size-wrapper{display:block;margin-left:calc(24px + 1em);margin-right:calc(32px + 3.5em);overflow:hidden;min-height:38px}.k-upload .k-upload-files .k-file-extension-wrapper:before,.k-upload .k-upload-files .k-file-invalid-extension-wrapper:before,.k-upload .k-upload-files .k-multiple-files-extension-wrapper:after,.k-upload .k-upload-files .k-multiple-files-extension-wrapper:before,.k-upload .k-upload-files .k-multiple-files-invalid-extension-wrapper:after,.k-upload .k-upload-files .k-multiple-files-invalid-extension-wrapper:before{position:absolute;content:\"\";display:inline-block;border-style:solid}.k-upload .k-upload-files .k-file-extension-wrapper:before,.k-upload .k-upload-files .k-file-invalid-extension-wrapper:before,.k-upload .k-upload-files .k-multiple-files-extension-wrapper:before,.k-upload .k-upload-files .k-multiple-files-invalid-extension-wrapper:before{top:-1px;right:-1px;width:0;height:0;border-width:6px;margin-top:-1px;margin-right:-1px}.k-upload .k-upload-files .k-multiple-files-extension-wrapper:after,.k-upload .k-upload-files .k-multiple-files-invalid-extension-wrapper:after{top:-6px;left:-6px;width:15px;height:35px;border-width:2px 0 0 2px}.k-upload .k-upload-files .k-file-extension,.k-upload .k-upload-files .k-file-invalid-icon{position:absolute;bottom:0;line-height:normal}.k-upload .k-upload-files .k-file-invalid-icon{margin-left:4px}.k-upload .k-upload-files .k-file-extension{margin-left:.2em;margin-bottom:.3em;overflow:hidden;text-overflow:ellipsis;max-width:100%;left:0}.k-upload .k-upload-files .k-upload-action{margin-left:8px}.k-upload .k-action-buttons{margin:-4px 0 0;padding:0;border-top:0}.k-upload .k-progress{position:absolute;bottom:0;left:0;height:2px}.k-upload .k-file-invalid>.k-progress{width:100%}.k-rtl .k-upload .k-dropzone .k-upload-status>.k-icon,.k-upload[dir=rtl] .k-dropzone .k-upload-status>.k-icon{margin-left:6px;margin-right:0}.k-rtl .k-upload .k-upload-files .k-upload-status,.k-upload[dir=rtl] .k-upload-files .k-upload-status{right:auto;left:8px}.k-rtl .k-upload .k-upload-files~.k-upload-selected,.k-upload[dir=rtl] .k-upload-files~.k-upload-selected{border-left-width:0;border-right-width:1px;border-right-style:solid;margin-left:0}.k-rtl .k-upload .k-upload-files .k-file-invalid-icon,.k-upload[dir=rtl] .k-upload-files .k-file-invalid-icon{margin-left:0;left:4px}.k-rtl .k-upload .k-file-name-size-wrapper,.k-upload[dir=rtl] .k-file-name-size-wrapper{margin-right:calc(24px + 1em);margin-left:24px}.k-rtl .k-upload .k-file-extension,.k-upload[dir=rtl] .k-file-extension{right:0;left:auto;margin-right:.4em;margin-left:0}.k-rtl .k-upload .k-upload-action,.k-upload[dir=rtl] .k-upload-action{margin-left:0;margin-right:8px}.k-upload-button{position:relative;overflow:hidden;direction:ltr}.k-upload-button input{font:170px monospace!important;margin:0;padding:0;filter:alpha(opacity=0);opacity:0;cursor:pointer;position:absolute;bottom:0;right:0;z-index:1}.k-ie9 .k-upload-status-total{top:1.5em}.k-ie9 .k-upload-status-total>.k-icon{margin-top:-3px}.k-ie9 .k-upload-button{margin:2px 4px}.k-upload{background-color:#f6f6f6;border-color:rgba(0,0,0,.08);background-clip:padding-box}.k-edge12 .k-upload,.k-edge13 .k-upload,.k-ie11 .k-upload{background-clip:border-box}.k-upload .k-file,.k-upload .k-upload-files,.k-upload .k-upload-selected{border-color:rgba(0,0,0,.08)}.k-upload .k-file{background-color:#fff;outline:none}.k-upload .k-file.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-upload .k-file .k-upload-action{opacity:.6;color:inherit;background:none;border-width:0;box-shadow:none}.k-upload .k-file .k-upload-action:hover{opacity:1}.k-upload .k-file .k-upload-action.k-state-focused{box-shadow:0 0 0 2px rgba(0,0,0,.13)}.k-upload .k-file .k-upload-pct{opacity:.65}.k-upload .k-upload-button input.k-state-disabled,.k-upload .k-upload-button input[disabled]{visibility:hidden}.k-upload .k-file-progress{color:#656565}.k-upload .k-file-progress .k-progress{background-color:#0058e9}.k-upload .k-file-success .k-file-name{color:#37b400}.k-upload .k-file-success .k-progress{background-color:#37b400}.k-upload .k-file-error .k-file-name{color:#f31700}.k-upload .k-file-error .k-progress,.k-upload .k-file-invalid .k-progress{background-color:#f31700}.k-upload .k-file-extension-wrapper,.k-upload .k-multiple-files-extension-wrapper{color:#bababa;border-color:#bababa}.k-upload .k-file-invalid .k-file-name-invalid{color:#f31700}.k-upload .k-file-error .k-file-extension-wrapper,.k-upload .k-file-invalid-extension-wrapper,.k-upload .k-multiple-files-invalid-extension-wrapper{color:#f31700;border-color:#ff9388}.k-upload .k-file-extension-wrapper:before,.k-upload .k-multiple-files-extension-wrapper:before{background-color:#fff;border-color:transparent transparent #bababa #bababa}.k-upload .k-file-error .k-file-extension-wrapper:before,.k-upload .k-file-invalid-extension-wrapper:before,.k-upload .k-multiple-files-invalid-extension-wrapper:before{background-color:#fff;border-color:transparent transparent #ff9388 #ff9388}.k-upload .k-multiple-files-extension-wrapper:after{border-top-color:#bababa;border-left-color:#bababa}.k-upload .k-multiple-files-invalid-extension-wrapper:after{border-top-color:#ff9388;border-left-color:#ff9388}.k-upload .k-file-information,.k-upload .k-file-size,.k-upload .k-file-validation-message{color:#bababa}.k-dropzone .k-i-loading{border-color:#f6f6f6}.k-dropzone .k-i-loading:after,.k-dropzone .k-i-loading:before,.k-dropzone .k-loading-image:after,.k-dropzone .k-loading-image:before{background-color:#f6f6f6}.k-dropzone-hovered{background-color:#ededed}.k-editor{border-collapse:separate;border-spacing:0;vertical-align:top;position:relative;table-layout:fixed}.k-editor .k-content{margin:0;padding:0;width:100%;height:100%;border:0;background:none;display:block}table.k-editor{width:100%}.k-editor-inline{border-radius:2px;padding:2px 4px;border:1px solid transparent;word-wrap:break-word;overflow:auto;background:none;transition:border-color .3s}.k-window.k-editor-widget{padding:0}.editorToolbarWindow{padding:0;display:-ms-flexbox;display:flex;-ms-flex-align:stretch;align-items:stretch}.k-editortoolbar-dragHandle{margin:8px;padding:0;cursor:move}.k-editor-toolbar,.k-editor-toolbar-wrap{border-color:inherit}.k-editor-toolbar{margin:0;padding:8px;list-style-type:none;line-height:1.4285714286;cursor:default;word-wrap:break-word;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;position:relative}.k-editor-toolbar.k-toolbar-resizable{-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow:hidden;-ms-flex:1 1 auto;flex:1 1 auto}.k-editor-toolbar li{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;vertical-align:middle}.k-editor-toolbar .k-tool-group{padding:0;border-width:0;border-style:solid;border-color:inherit}.k-editor-toolbar .k-tool-group+.k-tool-group,.k-editor-toolbar .k-tool-group .k-widget~.k-widget{margin-left:8px}.k-editor-toolbar .k-tool-group.k-state-disabled,.k-editor-toolbar .k-tool-group .k-state-disabled{display:none}.k-editor-toolbar .k-tool{padding:4px;width:calc(10px + 1.4285714286em);height:calc(10px + 1.4285714286em);border-width:1px;border-style:solid;box-sizing:border-box;text-decoration:none;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center;position:relative}.k-editor-toolbar .k-tool-text{display:none}.k-editor-toolbar .k-tool+.k-tool{margin-left:8px}.k-editor-toolbar .k-tool-group.k-button-group .k-tool{margin:0}.k-editor-toolbar .k-overflow-tools{position:absolute;top:0;right:0;visibility:hidden}.k-editable-area{padding:4px;width:100%;height:100%;border-width:1px 0 0;border-style:solid;border-color:inherit;outline:0}.k-resizable .k-editable-area{padding:4px 4px 16px}.k-edit-form-content{-ms-flex:1 1 auto;flex:1 1 auto;overflow:auto;margin:-16px;padding:16px}.k-ct-popup{box-sizing:border-box;width:190px;padding:5px}.k-ct-popup .k-editor-toolbar{text-align:center}.k-ct-popup .k-editor-toolbar .k-tool{border-radius:2px;width:100%;height:auto;display:-ms-flexbox;display:flex}.k-ct-popup .k-editor-toolbar .k-tool-text{display:inline}.k-ct-popup .k-ct-cell{margin:1px;width:20px;height:20px;box-sizing:border-box;border:1px solid;border-color:inherit;display:inline-block;vertical-align:top;overflow:hidden;opacity:.7;pointer-events:all}.k-editor .k-resize-handle{position:absolute;right:0;bottom:0;padding:0;width:0;height:0;border-style:solid;border-width:0 0 13px 13px;border-color:transparent;border-bottom-color:inherit;cursor:se-resize}.k-editor .k-resize-handle .k-i-arrow-45-down-right{display:none}.k-editor .k-overlay{position:absolute;background-color:#fff;opacity:0}.k-overlay{position:fixed;top:0;left:0;z-index:10001;width:100%;height:100%;opacity:.5}.k-rtl .k-editor .k-editor-widget .k-dropdown-wrap{padding-left:0}.k-rtl .k-editor .k-editor-widget .k-dropdown-wrap .k-select{border-width:0}.k-editor-dialog{box-sizing:border-box}.k-editor-dialog .k-edit-form-container{width:auto}.k-editor-dialog .k-edit-label{width:30%;padding:5px 0}.k-editor-dialog .k-edit-field{width:66%}.k-filebrowser-dialog{display:-ms-flexbox;display:flex}.k-filebrowser-dialog .k-edit-form-container{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 1 auto;flex:1 1 auto}.k-filebrowser-dialog .k-edit-label{width:18%}.k-filebrowser-dialog .k-edit-field{width:75%}.k-filebrowser{max-width:100%}.k-filebrowser .k-floatwrap{display:-ms-flexbox;display:flex}.k-filebrowser .k-floatwrap:after{display:none}.k-filebrowser .k-breadcrumbs{-ms-flex:1;flex:1}.k-filebrowser .k-search-wrap{margin:0 0 0 1em;width:150px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.k-filebrowser .k-search-wrap .k-input{-ms-flex:1;flex:1;width:100px}.k-filebrowser .k-search-wrap .k-icon{margin:0;position:static}.k-filebrowser .k-filebrowser-toolbar{margin:1em 0 0;padding:8px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.k-filebrowser .k-toolbar-wrap{display:-ms-flexbox;display:flex}.k-filebrowser .k-toolbar-wrap>*+*{margin-left:8px}.k-filebrowser .k-toolbar-wrap .k-state-disabled{display:none}.k-filebrowser .k-upload{padding:0;border-width:0;background:none}.k-filebrowser .k-upload .k-upload-button{margin:0}.k-filebrowser .k-upload-files,.k-filebrowser .k-upload .k-upload-status{display:none}.k-filebrowser .k-tiles{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;height:390px;max-height:50vh;margin:0 0 1em;padding:4px 8px;border-top-width:0;overflow:auto}.k-filebrowser .k-tile{width:33%;height:90px;padding:4px 8px;box-sizing:border-box;white-space:nowrap;overflow:hidden;cursor:pointer;border-radius:2px}.k-filebrowser .k-tile .k-i-file,.k-filebrowser .k-tile .k-i-folder{font-size:4em}.k-filebrowser .k-tile input{width:100px}.k-filebrowser .k-tile strong{display:block;font-weight:400;overflow:hidden;text-overflow:ellipsis}.k-filebrowser .k-tile-empty{display:block;margin:auto}.k-filebrowser .k-tile-empty.k-state-selected{color:inherit;border-width:0;background-image:none;background-color:transparent}.k-filebrowser .k-tile-empty strong{opacity:.5;font-size:3em;font-weight:400}.k-filebrowser .k-thumb{float:left;margin-right:4px}.k-filebrowser .k-breadcrumbs-wrap{position:absolute;left:8px;top:4px}.k-filebrowser .k-breadcrumbs-wrap .k-icon{position:static;margin-top:0}.k-editor-table-wizard-dialog{display:-ms-flexbox;display:flex}.k-editor-table-wizard-dialog .k-edit-form-container{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 1 auto;flex:1 1 auto}.k-editor-table-wizard-dialog .k-tabstrip-wrapper{display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto;overflow:auto}.k-editor-table-wizard-dialog .k-tabstrip-wrapper .k-tabstrip.k-root-tabs{-ms-flex:1 1 auto;flex:1 1 auto;margin-bottom:0}.k-editor-table-wizard-dialog .k-numerictextbox{width:10em}.k-editor-table-wizard-dialog .k-numerictextbox+.k-dropdown{width:4em}.k-editor-table-wizard-dialog .k-numerictextbox+.k-colorpicker,.k-editor-table-wizard-dialog .k-numerictextbox+.k-dropdown{margin-left:4px}.k-editor-table-wizard-dialog .k-colorpicker{vertical-align:middle}.k-editor-table-wizard-dialog .k-edit-field>.k-checkbox{position:relative}.k-editor-table-wizard-dialog .k-dropdown.k-align{width:auto}.k-popup.k-align .k-list{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.k-popup.k-align .k-list .k-item{padding:4px;height:calc(10px + 1.4285714286em);box-sizing:border-box;-ms-flex-pack:center;justify-content:center;-ms-flex:1 0 33%;flex:1 0 33%}.k-popup.k-align .k-list .k-item .k-icon{margin:0}.k-popup.k-align .k-list .k-item:last-child{-ms-flex:1 0 100%;flex:1 0 100%}.k-editor-inline .k-table{width:100%;border-spacing:0;margin:0 0 1em}.k-editor-inline .k-table,.k-editor-inline .k-table td{outline:0;border:1px dotted #ccc}.k-editor-inline .k-table td{min-width:1px;padding:2px 4px}.k-editor-inline .k-table-resize-handle-wrapper{position:absolute;width:5px;height:5px;background-color:#fff;border:1px solid #000;z-index:100}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle{width:100%;height:100%}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-east{cursor:e-resize}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-north{cursor:n-resize}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-northeast{cursor:ne-resize}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-northwest{cursor:nw-resize}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-south{cursor:s-resize}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-southeast{cursor:se-resize}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-southwest{cursor:sw-resize}.k-editor-inline .k-table-resize-handle-wrapper .k-table-resize-handle.k-resize-west{cursor:w-resize}.k-editor-inline .k-column-resize-handle-wrapper{position:absolute;height:10px;width:10px;cursor:col-resize;z-index:2}.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle{width:100%;height:100%}.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle .k-column-resize-marker{width:2px;height:100%;margin:0 auto;background-color:#00b0ff;display:none;opacity:.8}.k-editor-inline .k-row-resize-handle-wrapper{position:absolute;z-index:2;cursor:row-resize;width:10px;height:10px}.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-handle{display:table;width:100%;height:100%}.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker-wrapper{display:table-cell;width:100%;height:100%;margin:0;padding:0;vertical-align:middle}.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker{display:none;margin:0;padding:0;width:100%;height:2px;background-color:#00b0ff;opacity:.8}.k-editor{background-clip:padding-box}.k-editor .k-editable-area{border-color:rgba(0,0,0,.08)}.k-edge12 .k-editor,.k-edge13 .k-editor,.k-ie11 .k-editor{background-clip:border-box}.k-editor-inline.k-state-active,.k-editor-inline:hover{border-color:rgba(0,0,0,.08)}.k-overlay{background-color:#000}.k-editor-toolbar{padding:0}.k-editor-toolbar .k-tool-group{padding:8px}.k-editor-toolbar .k-tool-group .k-tool.k-group-end,.k-editor-toolbar .k-tool-group .k-tool.k-group-start{border-radius:0}.k-editor-toolbar .k-tool-group+.k-tool-group{margin:0;border-left-width:1px}.editorToolbarWindow.k-header.k-window-content a.k-tool,.k-ct-popup .k-editor-toolbar a.k-tool,.k-editor .k-editor-toolbar-wrap a.k-tool{border-width:0;background-image:none;background-color:transparent}.editorToolbarWindow.k-header.k-window-content a.k-tool.k-state-selected,.k-ct-popup .k-editor-toolbar a.k-tool.k-state-selected,.k-editor .k-editor-toolbar-wrap a.k-tool.k-state-selected{border-color:rgba(0,0,0,.1);color:#fff;background-color:#ff6358;background-image:none}.editorToolbarWindow.k-header.k-window-content .k-tool-group,.k-ct-popup .k-editor-toolbar .k-tool-group,.k-editor .k-editor-toolbar-wrap .k-tool-group{border-color:rgba(0,0,0,.08)}.k-editor-toolbar .k-overflow-anchor{padding:8px;width:calc(1.4285714286em + 26px);height:calc(1.4285714286em + 26px)}.k-multiselect{border-radius:2px;width:100%}.k-multiselect .k-loading-hidden{visibility:hidden}.k-multiselect-wrap{cursor:text}.k-multiselect-wrap:before{content:\"\";width:0;height:calc(1.4285714286em + 8px);float:left}.k-multiselect-wrap .k-input{float:left}.k-multiselect-wrap ul{vertical-align:top}.k-multiselect-wrap li.k-button{float:left}.k-multiselect-wrap .k-button{min-height:calc(1.4285714286em + 4px);padding:1px 4px;margin:2px 0 0 2px;cursor:default;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;line-height:inherit;white-space:normal}.k-multiselect-wrap .k-button .k-select{display:-ms-flexbox;display:flex;cursor:pointer;margin-left:8px;-ms-flex-item-align:stretch;align-self:stretch}.k-multiselect-wrap .k-button:last-child{margin-bottom:2px}.k-multiselect-wrap .k-searchbar{float:left;width:auto}.k-multiselect-wrap .k-searchbar .k-input{padding-right:0}.k-rtl .k-multiselect-wrap,[dir=rtl]>.k-multiselect-wrap{padding-left:calc(1.4285714286em + 8px);padding-right:0}.k-rtl .k-multiselect-wrap .k-input,.k-rtl .k-multiselect-wrap .k-searchbar,.k-rtl .k-multiselect-wrap:before,.k-rtl .k-multiselect-wrap li.k-button,[dir=rtl]>.k-multiselect-wrap .k-input,[dir=rtl]>.k-multiselect-wrap .k-searchbar,[dir=rtl]>.k-multiselect-wrap:before,[dir=rtl]>.k-multiselect-wrap li.k-button{float:right}.k-rtl .k-multiselect-wrap .k-searchbar .k-input,[dir=rtl]>.k-multiselect-wrap .k-searchbar .k-input{padding-left:0;padding-right:8px}.k-rtl .k-multiselect-wrap .k-button,[dir=rtl]>.k-multiselect-wrap .k-button{width:auto;margin-right:2px;margin-left:0}.k-rtl .k-multiselect-wrap .k-button .k-select,[dir=rtl]>.k-multiselect-wrap .k-button .k-select{margin-left:0;margin-right:8px}.k-multiselect-wrap{background-clip:padding-box}.k-edge12 .k-multiselect-wrap,.k-edge13 .k-multiselect-wrap,.k-ie11 .k-multiselect-wrap{background-clip:border-box}.k-multiselect-wrap>.k-readonly{opacity:.6}.k-multiselect-wrap li{background-clip:padding-box}.k-edge12 .k-multiselect-wrap li,.k-edge13 .k-multiselect-wrap li,.k-ie11 .k-multiselect-wrap li{background-clip:border-box}.k-multiselect-wrap li .k-icon{opacity:.6;cursor:pointer}.k-multiselect-wrap li .k-icon:hover,.k-multiselect-wrap li.k-state-focused .k-icon,.k-multiselect-wrap li:focus .k-icon{opacity:1}.k-multiselect-wrap .k-i-loading{background-color:#fff}.k-numerictextbox[dir=rtl] .k-numeric-wrap .k-i-warning,.k-rtl .k-numerictextbox .k-numeric-wrap .k-i-warning{-ms-flex-item-align:center;align-self:center;margin-right:0;margin-left:.5em}.k-numeric-wrap .k-i-warning{-ms-flex-item-align:center;align-self:center;margin-right:.5em}.k-numeric-wrap>.k-input{-ms-flex:1 1 auto;flex:1 1 auto}.k-numeric-wrap>.k-input:invalid{box-shadow:none}.k-numerictextbox .k-numeric-wrap{background-clip:padding-box}.k-edge12 .k-numerictextbox .k-numeric-wrap,.k-edge13 .k-numerictextbox .k-numeric-wrap,.k-ie11 .k-numerictextbox .k-numeric-wrap{background-clip:border-box}.k-numerictextbox .k-select>.k-state-active,.k-numerictextbox .k-select>.k-state-selected{color:#252525;box-shadow:inset 0 3px 4px 0 rgba(0,0,0,.06)}.k-numerictextbox .k-numeric-wrap.k-state-invalid{color:#f31700;border-color:rgba(243,23,0,.5)}.k-numerictextbox .k-numeric-wrap.k-state-invalid .k-select{color:#f31700}.k-tooltip-validation{margin:.5em 0 0;padding:0;position:static;border-width:0;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center}.k-tooltip-validation[hidden]{display:none}.k-tooltip-validation>.k-icon{margin-right:4px}.k-tooltip-validation .k-callout{display:none}.k-tooltip-validation{border-color:transparent;color:#f31700;background-color:transparent}.k-switch{cursor:pointer;border:0;display:inline-block;font-size:10px;overflow:hidden;position:relative;text-align:left;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;width:6em;outline:0}.k-switch [type=checkbox]{display:none}.k-switch,.k-switch-container,.k-switch-handle,.k-switch-wrapper{box-sizing:border-box}.k-switch-wrapper{display:none}.k-switch .k-switch-background{border-top-right-radius:0;border-bottom-right-radius:0}.k-switch-container{padding:2px 0;display:block;width:100%;background:transparent;-webkit-transform:translateZ(0);transform:translateZ(0);outline:0}.k-switch-handle{position:relative;width:2.4em;height:2.4em;display:inline-block;margin:0 6px 0 2px;border-width:1px;border-style:solid;vertical-align:middle}.k-switch-label-off{left:3em}.k-switch-label-on{left:-2.4em}.k-switch-label-off,.k-switch-label-on{top:-1px;display:block;text-align:center;position:absolute;text-transform:uppercase;text-shadow:none;line-height:2.4em;vertical-align:middle}.k-switch-container,.k-switch-wrapper{border-width:1px;border-style:solid}.k-switch[dir=rtl] .k-switch-label-off{left:-2.4em}.k-switch[dir=rtl] .k-switch-label-on{left:3em}.k-switch,.k-switch-container{border-radius:3em;outline:0}.k-switch-container{border-color:rgba(0,0,0,.08);background-clip:padding-box}.k-edge12 .k-switch-container,.k-edge13 .k-switch-container,.k-ie11 .k-switch-container{background-clip:border-box}.k-switch-container:hover{border-color:rgba(0,0,0,.15)}.k-switch-background{background-position:4.3em 0;background-repeat:no-repeat}.k-switch-handle{border-radius:50%;box-shadow:0 2px 4px 0 rgba(0,0,0,.06)}.k-edge12 .k-switch-handle,.k-edge13 .k-switch-handle,.k-ie11 .k-switch-handle{background-clip:border-box}.k-switch-on .k-switch-handle{background-clip:initial}.k-switch-off .k-switch-handle{background-clip:padding-box}.k-switch-label-on{color:#ff6358;background-color:transparent}.k-switch-label-off{color:#656565}.k-switch.k-state-focused,.k-switch:focus{outline:none;box-shadow:inset 0 0 0 3px rgba(0,0,0,.06)}.k-switch:active{box-shadow:0 0 0 2px rgba(0,0,0,.06)}.k-switch.k-state-disabled{cursor:auto}.k-switch.k-state-disabled .k-switch-container{border-color:rgba(0,0,0,.08);box-shadow:none}.k-switch.k-state-disabled:focus{box-shadow:none}.k-switch.k-state-disabled.k-switch-on .k-switch-handle{background:#ff6358;border-color:#ff6358;opacity:.5}.k-switch[aria-readonly=true]{pointer-events:none}.k-maskedtextbox .k-i-warning{display:none;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);right:8px}.k-maskedtextbox[dir=rtl] .k-i-warning,.k-rtl .k-maskedtextbox .k-i-warning{right:auto;left:8px}.k-maskedtextbox.k-state-invalid .k-i-warning{display:inline-block}.k-maskedtextbox .k-i-warning{color:#f31700}.k-maskedtextbox.k-state-invalid .k-textbox{color:#f31700;border-color:#f31700}.k-listbox{width:12.4em;height:200px;vertical-align:top;background-color:transparent;border-width:0;display:-ms-inline-flexbox;display:inline-flex}.k-listbox .k-listbox-toolbar ul{display:-ms-flexbox;display:flex}.k-listbox.k-listbox-toolbar-left .k-listbox-toolbar ul,.k-listbox.k-listbox-toolbar-right .k-listbox-toolbar ul{-ms-flex-direction:column;flex-direction:column}.k-listbox.k-listbox-toolbar-left .k-listbox-toolbar li+li,.k-listbox.k-listbox-toolbar-right .k-listbox-toolbar li+li{margin-top:8px}.k-listbox.k-listbox-toolbar-left{-ms-flex-direction:row;flex-direction:row}.k-listbox.k-listbox-toolbar-left .k-listbox-toolbar{margin-right:8px}.k-listbox.k-listbox-toolbar-right{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.k-listbox.k-listbox-toolbar-right .k-listbox-toolbar{margin-left:8px}.k-listbox.k-listbox-toolbar-bottom,.k-listbox.k-listbox-toolbar-top{-ms-flex-direction:column;flex-direction:column}.k-listbox.k-listbox-toolbar-bottom .k-listbox-toolbar ul,.k-listbox.k-listbox-toolbar-top .k-listbox-toolbar ul{-ms-flex-direction:row;flex-direction:row}.k-listbox.k-listbox-toolbar-bottom .k-listbox-toolbar li+li,.k-listbox.k-listbox-toolbar-top .k-listbox-toolbar li+li{margin-left:8px}.k-listbox.k-listbox-toolbar-top .k-listbox-toolbar{margin-bottom:8px}.k-listbox.k-listbox-toolbar-bottom .k-listbox-toolbar{margin-top:8px}.k-listbox .k-list-scroller{width:100%;border-width:1px;border-style:solid}.k-listbox .k-drop-hint{border-top-width:1px;border-top-style:solid}.k-listbox .k-ghost{opacity:.5}.k-listbox[dir=rtl].k-listbox-toolbar-left .k-listbox-toolbar,.k-listbox[dir=rtl].k-listbox-toolbar-right .k-listbox-toolbar,.k-rtl .k-listbox.k-listbox-toolbar-left .k-listbox-toolbar,.k-rtl .k-listbox.k-listbox-toolbar-right .k-listbox-toolbar,[dir=rtl] .k-listbox.k-listbox-toolbar-left .k-listbox-toolbar,[dir=rtl] .k-listbox.k-listbox-toolbar-right .k-listbox-toolbar{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-listbox[dir=rtl].k-listbox-toolbar-left .k-listbox-toolbar,.k-rtl .k-listbox.k-listbox-toolbar-left .k-listbox-toolbar,[dir=rtl] .k-listbox.k-listbox-toolbar-left .k-listbox-toolbar{margin-right:0;margin-left:8px}.k-listbox[dir=rtl].k-listbox-toolbar-right .k-listbox-toolbar,.k-rtl .k-listbox.k-listbox-toolbar-right .k-listbox-toolbar,[dir=rtl] .k-listbox.k-listbox-toolbar-right .k-listbox-toolbar{margin-right:8px;margin-left:0}.k-item{cursor:default}.k-item.k-drag-clue{border-radius:0;padding:4px 8px;line-height:1.4285714286em;border-width:0;font-size:14px}.k-listbox .k-list-scroller{background-color:#fff;border-color:rgba(0,0,0,.08);color:#656565;background-clip:padding-box}.k-edge12 .k-listbox .k-list-scroller,.k-edge13 .k-listbox .k-list-scroller,.k-ie11 .k-listbox .k-list-scroller{background-clip:border-box}.k-listbox .k-drop-hint{border-top-color:#ff6358}li.k-item.k-drag-clue{background-color:#ff6358;color:#fff}.k-var--chart-font{font-size:14px}.k-var--chart-title-font{font-size:1.143em}.k-var--chart-label-font{font-size:.857em}.k-chart,.k-sparkline,.k-stockchart{-webkit-touch-callout:none;-webkit-tap-highlight-color:rgba(0,0,0,0);border-width:0}.k-chart,.k-stockchart{font-size:14px;font-family:inherit;display:block;height:400px}.k-chart-surface{height:100%}.k-chart .k-popup{border-width:0}.k-chart-tooltip-wrapper.k-animation-container-shown,.k-chart-tooltip-wrapper .k-animation-container-shown{transition:left 80ms ease-in,top 80ms ease-in}.k-chart-tooltip-wrapper,.k-sparkline-tooltip-wrapper{z-index:12000}.k-chart-tooltip-wrapper>.k-popup,.k-sparkline-tooltip-wrapper>.k-popup{padding:0;border-width:0}.k-chart-tooltip table{border-spacing:0;border-collapse:collapse}.k-chart-tooltip{font-size:13.006px;line-height:1.4285714286;padding:4px 8px}.k-chart-tooltip th{width:auto;text-align:center;padding:1px}.k-chart-tooltip td{width:auto;text-align:left;padding:2px 4px;line-height:1.4285714286;vertical-align:middle}.k-chart-crosshair-tooltip,.k-chart-shared-tooltip{border-width:1px;border-style:solid}.k-chart-shared-tooltip .k-chart-shared-tooltip-marker{display:block;width:15px;height:3px;vertical-align:middle}.k-selector{position:absolute;-webkit-transform:translateZ(0)}.k-selection{border-width:1px;border-style:solid;border-bottom:0}.k-selection,.k-selection-bg{position:absolute;height:100%}.k-selection-bg{width:100%}.k-handle{border-radius:50%;width:22px;height:22px;border-width:1px;border-style:solid;z-index:1;position:absolute;box-sizing:content-box}.k-handle div{width:100%;height:100%}.k-left-handle{left:-11px}.k-right-handle{right:-11px}.k-left-handle div{margin:-22px 0 0 -14.6666666667px;padding:44px 29.3333333333px 0 0}.k-right-handle div{margin:-22px 0 0 -14.6666666667px;padding:44px 0 0 29.3333333333px}.k-left-handle.k-handle-active div{margin-left:-44px;padding-left:58.6666666667px}.k-right-handle.k-handle-active div{margin-left:-44px;padding-right:58.6666666667px}.k-border,.k-mask{position:absolute;height:100%}.k-border{width:1px}.k-marquee{position:absolute;z-index:100000}.k-marquee-color,.k-marquee-text{position:absolute;top:0;left:0;width:100%;height:100%}.k-navigator-hint div{position:absolute}.k-navigator-hint .k-scroll{position:absolute;height:4px}.k-navigator-hint .k-tooltip{margin-top:20px;min-width:160px;opacity:1;text-align:center}.k-sparkline,.k-sparkline span{display:inline-block;vertical-align:top}.k-sparkline span{height:100%;width:100%}.k-chart-dragging{user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.k-chart-donut-center{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;border-radius:50%;text-align:center;border:4px solid transparent;box-sizing:border-box}.k-pdf-export .k-chart .k-animation-container,.k-pdf-export .k-sparkline .k-animation-container,.k-pdf-export .k-stockchart .k-animation-container{display:none}.k-diagram{height:600px}.k-diagram .km-scroll-wrapper{width:100%;height:100%;position:relative}.k-canvas-container{width:100%;height:100%}.k-diagram img{box-sizing:content-box}.k-treemap{height:400px;overflow:hidden}.k-treemap .k-treemap-tile{margin:-1px 0 0 -1px;height:100%;box-sizing:border-box;border:1px solid;border-color:inherit;color:inherit;background-color:inherit;overflow:hidden;position:absolute}.k-treemap>.k-treemap-tile{position:relative}.k-treemap .k-treemap-title{padding:2px 4px;border-width:0 0 1px;border-style:solid;background-position:0 0;background-repeat:repeat-x}.k-treemap .k-treemap-title-vertical{padding:4px 2px;width:1.4285714286em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:absolute;top:0;bottom:0}.k-treemap .k-treemap-title-vertical>div{-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);position:absolute;top:0;right:1em}.k-treemap .k-treemap-wrap{border-color:inherit;color:inherit;background-color:inherit;position:absolute;top:0;left:0;bottom:0;right:0}.k-treemap .k-treemap-title+.k-treemap-wrap{top:6.4285714286px}.k-treemap .k-treemap-title-vertical+.k-treemap-wrap{left:6.4285714286px}.k-treemap .k-leaf{padding:4px}.k-arcgauge{display:inline-block}.k-arcgauge-label{position:absolute;text-align:center;padding:0;margin:0}.k-var--accent{background-color:#ff6358}svg .k-var--accent{fill:#ff6358}.k-var--accent-contrast{background-color:#fff}svg .k-var--accent-contrast{fill:#fff}.k-var--base{background-color:#f6f6f6}svg .k-var--base{fill:#f6f6f6}.k-var--background{background-color:#fff}svg .k-var--background{fill:#fff}.k-var--border-radius{margin-top:2px}.k-var--normal-background{background-color:#f6f6f6}svg .k-var--normal-background{fill:#f6f6f6}.k-var--normal-text-color{background-color:#656565}svg .k-var--normal-text-color{fill:#656565}.k-var--hover-background{background-color:#ededed}svg .k-var--hover-background{fill:#ededed}.k-var--hover-text-color{background-color:#656565}svg .k-var--hover-text-color{fill:#656565}.k-var--selected-background{background-color:#ff6358}svg .k-var--selected-background{fill:#ff6358}.k-var--selected-text-color{background-color:#fff}svg .k-var--selected-text-color{fill:#fff}.k-var--success{background-color:#37b400}svg .k-var--success{fill:#37b400}.k-var--info{background-color:#0058e9}svg .k-var--info{fill:#0058e9}.k-var--warning{background-color:#ffc000}svg .k-var--warning{fill:#ffc000}.k-var--error{background-color:#f31700}svg .k-var--error{fill:#f31700}.k-var--series-a{background-color:#ff6358}svg .k-var--series-a{fill:#ff6358}.k-var--series-b{background-color:#ffd246}svg .k-var--series-b{fill:#ffd246}.k-var--series-c{background-color:#78d237}svg .k-var--series-c{fill:#78d237}.k-var--series-d{background-color:#28b4c8}svg .k-var--series-d{fill:#28b4c8}.k-var--series-e{background-color:#2d73f5}svg .k-var--series-e{fill:#2d73f5}.k-var--series-f{background-color:#aa46be}svg .k-var--series-f{fill:#aa46be}.k-var--gauge-pointer{background-color:#ff6358}svg .k-var--gauge-pointer{fill:#ff6358}.k-var--gauge-track{background-color:#e6e5e5}svg .k-var--gauge-track{fill:#e6e5e5}.k-var--chart-inactive{background-color:hsla(0,0%,40%,.5)}.k-var--chart-major-lines{background-color:rgba(0,0,0,.08)}.k-var--chart-minor-lines{background-color:rgba(0,0,0,.04)}.k-var--chart-area-opacity{opacity:.8}.k-var--chart-crosshair-background,.k-var--chart-error-bars-background,.k-var--chart-notes-background,.k-var--chart-notes-border,.k-var--chart-notes-lines{background-color:rgba(0,0,0,.5)}.k-chart,.k-sparkline,.k-stockchart{background-color:transparent}.k-chart .k-popup,.k-sparkline .k-popup,.k-stockchart .k-popup{background:transparent}.k-chart-tooltip{border-radius:2px;color:#fff}.k-chart-tooltip-inverse{color:#000}.k-chart-crosshair-tooltip,.k-chart-shared-tooltip{color:#656565;background-color:#f6f6f6;border-color:rgba(0,0,0,.08)}.k-selection{border-color:rgba(0,0,0,.08);box-shadow:inset 0 1px 7px rgba(0,0,0,.15)}.k-selection-bg{background-color:transparent}.k-handle{cursor:e-resize}.k-handle div{background-color:transparent}.k-mask{background-color:#fff;opacity:.8}.k-marquee-color{background-color:#ff6358;opacity:.6}.k-navigator-hint .k-scroll{border-radius:2px}.k-treemap .k-leaf{color:#fff}.k-treemap .k-leaf.k-inverse{color:#656565}.k-treemap .k-leaf.k-state-hover{box-shadow:inset 0 0 0 3px rgba(0,0,0,.08)}.k-map{height:600px}.k-map .km-scroll-wrapper{width:100%;height:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:absolute}.k-map .k-touch-scrollbar{display:none}.k-map .k-layer{position:absolute;left:0;top:0}.k-map .k-marker{-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%);font-size:28px;cursor:pointer;position:absolute;overflow:visible}.k-map .k-attribution{padding:2px 4px;font-size:9px;background-color:hsla(0,0%,100%,.8);z-index:1000}.k-map .km-scroll-container{height:100%}.k-map-controls{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.k-pos-top{top:0}.k-pos-bottom{bottom:0}.k-pos-left{left:0}.k-pos-right{right:0}.k-navigator{margin:1em;width:50px;height:50px;box-sizing:content-box;border-radius:50%;position:relative}.k-pdf-export .k-navigator{display:none}.k-navigator .k-button{margin:0;padding:0;border-radius:100%;line-height:1;box-shadow:none;position:absolute}.k-navigator .k-button:not(:hover){border-color:transparent;background:none}.k-navigator .k-navigator-up{-webkit-transform:translateX(-50%);transform:translateX(-50%);top:2px;left:50%}.k-navigator .k-navigator-right{-webkit-transform:translateY(-50%);transform:translateY(-50%);right:2px;top:50%}.k-navigator .k-navigator-down{-webkit-transform:translateX(-50%);transform:translateX(-50%);bottom:2px;left:50%}.k-navigator .k-navigator-left{-webkit-transform:translateY(-50%);transform:translateY(-50%);left:2px;top:50%}.k-zoom-control{margin:1em;border:0;background:none;display:-ms-flexbox;display:flex}.k-pdf-export .k-zoom-control{display:none}.k-zoom-control .k-button{padding:4px}.k-buttons-vertical{-ms-flex-direction:vertical;flex-direction:vertical}.k-map .k-marker{color:#ff6358}.k-barcode,.k-qrcode{display:inline-block}.k-splitter{height:300px;position:relative}.k-splitter .k-pane{overflow:hidden}.k-splitter .k-scrollable{overflow:auto}.k-splitter .k-splitter-resizing{overflow:hidden}.k-pane>.k-splitter{border-width:0;overflow:hidden}.k-splitter .k-pane-loading{position:static;top:50%;left:50%}.k-ghost-splitbar,.k-splitbar{border-style:solid;outline:0;position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.k-ghost-splitbar .k-icon,.k-splitbar .k-icon{font-size:10px;display:block;cursor:pointer}.k-splitbar-draggable-horizontal{cursor:col-resize}.k-splitbar-draggable-vertical{cursor:row-resize}.k-ghost-splitbar-horizontal,.k-splitbar-horizontal{width:8px;border-width:0;background-repeat:repeat-y;-ms-flex-direction:column;flex-direction:column;top:0}.k-ghost-splitbar-vertical,.k-splitbar-vertical{height:8px;border-width:0;background-repeat:repeat-x;-ms-flex-direction:row;flex-direction:row;left:0}.k-splitbar-static-horizontal{width:1px}.k-splitbar-static-vertical{height:1px}.k-splitbar-draggable-horizontal .k-resize-handle{position:static;width:2px;height:20px}.k-splitbar .k-resize-handle{display:none;background-color:currentColor}.k-splitbar-draggable-horizontal .k-resize-handle,.k-splitbar-draggable-vertical .k-resize-handle{display:block}.k-splitbar-horizontal .k-i-arrow-60-left,.k-splitbar-horizontal .k-i-arrow-w:before,.k-splitbar-horizontal .k-i-expand-w:before,.k-splitbar-horizontal .k-i-sarrow-w:before{margin-bottom:7px}.k-splitbar-horizontal .k-i-arrow-60-right,.k-splitbar-horizontal .k-i-arrow-e:before,.k-splitbar-horizontal .k-i-expand-e:before,.k-splitbar-horizontal .k-i-expand:before,.k-splitbar-horizontal .k-i-sarrow-e:before{margin-top:7px}.k-splitbar-vertical .k-i-arrow-60-up,.k-splitbar-vertical .k-i-arrow-n:before,.k-splitbar-vertical .k-i-expand-n:before,.k-splitbar-vertical .k-i-sarrow-n:before{margin-right:7px}.k-splitbar-vertical .k-i-arrow-60-down,.k-splitbar-vertical .k-i-arrow-s:before,.k-splitbar-vertical .k-i-collapse:before,.k-splitbar-vertical .k-i-expand-s:before,.k-splitbar-vertical .k-i-sarrow-s:before{margin-left:7px}.k-splitbar-draggable-vertical .k-resize-handle{position:static;width:20px;height:2px}.k-pane>.k-splitter-overlay{opacity:0;position:absolute}.k-splitter-flex{display:-ms-flexbox;display:flex;width:100%;height:auto}.k-splitter-flex .k-pane{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;display:block;min-width:0;max-width:100%;min-height:0;max-height:100%;height:100%}.k-splitter-flex .k-pane-static{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.k-splitter-flex .k-pane-flex{display:-ms-flexbox;display:flex}.k-splitter-flex .k-splitbar{position:static;-ms-flex:0 0 auto;flex:0 0 auto}.k-splitter-flex .k-pane-flex.k-state-hidden,.k-splitter-flex .k-pane-flex[hidden],.k-splitter-flex .k-pane.k-state-hidden,.k-splitter-flex .k-pane[hidden]{-ms-flex:0 1 0px!important;flex:0 1 0!important;overflow:hidden!important;display:block!important}.k-splitter-flex.k-splitter-horizontal{-ms-flex-direction:row;flex-direction:row}.k-splitter-flex.k-splitter-horizontal[dir=rtl]>.k-splitbar>.k-collapse-next,.k-splitter-flex.k-splitter-horizontal[dir=rtl]>.k-splitbar>.k-collapse-prev{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-splitter-flex.k-splitter-vertical{-ms-flex-direction:column;flex-direction:column}.k-splitter{background-clip:padding-box}.k-edge12 .k-splitter,.k-edge13 .k-splitter,.k-ie11 .k-splitter{background-clip:border-box}.k-splitbar{color:#656565;background-color:hsla(0,0%,92%,.8)}.k-splitbar.k-state-focused,.k-splitbar:active{color:#fff;background:#ff6358}.k-splitbar-horizontal-hover,.k-splitbar-vertical-hover{color:#656565;background-color:#ebebeb}.k-ghost-splitbar{background-color:#ebebeb}.k-gantt{position:relative;white-space:nowrap}.k-gantt td{overflow:hidden;white-space:nowrap;vertical-align:top}.k-gantt .k-grid-header tr{height:calc(1.4285714286em + 17px)}.k-gantt .k-grid-header .k-header{position:static}.k-gantt .k-grid-content tr{height:calc(1.4285714286em + 16px)}.k-gantt .k-gantt-layout{white-space:normal;vertical-align:top;display:inline-block}.k-gantt .k-splitbar{position:relative;display:-ms-inline-flexbox;display:inline-flex}.k-gantt-toolbar{padding:8px;border-width:0 0 1px;border-style:solid;border-color:inherit;line-height:1.4285714286}.k-gantt-layout+.k-gantt-toolbar{border-width:1px 0 0}.k-gantt-actions{float:left}.k-gantt-actions .k-button+.k-button{margin-left:8px}.k-gantt-views{float:right;display:-ms-inline-flexbox;display:inline-flex}.k-gantt-toggle{margin-right:.5em;display:none;float:left}@media only screen and (max-width:480px){.k-gantt-toggle{display:-ms-inline-flexbox;display:inline-flex}.k-gantt-create,.k-gantt-pdf{padding:4px;width:calc(10px + 1.4285714286em);height:calc(10px + 1.4285714286em)}.k-gantt-create .k-icon,.k-gantt-pdf .k-icon{margin:0}.k-gantt-create span+span,.k-gantt-pdf span+span{display:none}}.k-gantt-views .k-current-view{display:none}.k-gantt-views .k-current-view .k-link:after{content:\"\";margin:0 0 0 1ex;border:.25em solid transparent;border-top:.5em solid currentColor;border-bottom-width:0;display:inline-block}@media (max-width:1024px){ul.k-gantt-views{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;position:absolute;top:8px;right:8px;z-index:1000}ul.k-gantt-views li{display:none}ul.k-gantt-views .k-current-view,ul.k-gantt-views.k-state-expanded li{display:block}}.k-gantt-treelist .k-treelist{height:100%;border-width:0}.k-gantt-treelist .k-grid-header{padding:0!important}.k-gantt-treelist .k-grid-header tr{height:calc(2.8571428571em + 34px);vertical-align:bottom}.k-gantt-treelist .k-grid-content{overflow:hidden;overflow-x:scroll}.k-gantt-treelist .k-grid-content td{vertical-align:middle}.k-gantt-timeline .k-timeline{height:100%;border-width:0}.k-gantt-timeline .k-grid-content{overflow-x:scroll}.k-gantt-tables{position:relative;border-color:inherit}.k-gantt-columns,.k-gantt-rows{border-color:inherit;position:absolute;z-index:0;top:0;left:0}.k-gantt-dependencies{opacity:.7;position:absolute;top:0;left:0}.k-gantt-tasks{position:relative}.k-gantt-tasks td{padding:0;border-width:0;position:relative;vertical-align:middle}.k-gantt-tasks td:after{content:\"\\A0\"}.k-task-wrap{margin:0 -21px;padding:5px 21px;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;position:relative;z-index:2}.k-task-wrap.k-drag-hint{position:absolute}.k-task{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.k-task-dot{width:16px;height:16px;line-height:1;cursor:pointer;display:none;position:absolute}.k-task-wrap.k-origin .k-task-dot,.k-task-wrap:hover .k-task-dot{display:block}.k-task-dot:before{content:\"\";margin:-4px 0 0 -4px;width:8px;height:8px;border-width:0;border-style:solid;border-radius:100%;display:inline-block;position:absolute;top:50%;left:50%}.k-task-dot.k-state-hover:before,.k-task-dot:hover:before{border-width:1px}.k-task-start{left:0}.k-task-end{right:0}.k-task-draghandle{margin-left:16px;width:0;height:0;border:5px solid transparent;border-top-width:0;border-bottom-color:inherit;position:absolute;bottom:0;cursor:e-resize;visibility:hidden}.k-task-wrap:hover .k-task-draghandle{visibility:visible}.k-milestone-wrap{margin:0 -2em}.k-task-milestone{width:1em;height:1em;border-width:1px;border-style:solid;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.k-task-summary{height:10px;display:inline-block;vertical-align:top}.k-task-summary,.k-task-summary-complete{background-color:currentColor}.k-task-summary-complete:after,.k-task-summary-complete:before,.k-task-summary:after,.k-task-summary:before{content:\"\";width:0;height:0;border:8px solid transparent;position:absolute;top:0}.k-task-summary-complete:before,.k-task-summary:before{border-left-color:currentColor;left:0}.k-task-summary-complete:after,.k-task-summary:after{border-right-color:currentColor;right:0}.k-task-summary-complete{height:10px;position:relative;z-index:2}.k-task-summary-progress{height:15px;overflow:hidden}.k-task-single{border-radius:2px;border-width:1px;border-style:solid;cursor:default}.k-task-single .k-resize-handle{opacity:.5;z-index:2;visibility:hidden}.k-task-single .k-resize-handle:before{position:absolute;top:2px;bottom:2px}.k-task-single .k-resize-w{left:0}.k-task-single .k-resize-w:before{left:2px;border-left-width:1px}.k-task-single .k-resize-e{right:0}.k-task-single .k-resize-e:before{right:2px;border-left-width:1px}.k-task-single:hover .k-resize-handle,.k-task-single:hover .k-task-actions{visibility:visible}.k-task-complete{border-radius:2px;width:20%;position:absolute;z-index:1;top:0;bottom:0;left:0}.k-task-content{position:relative;z-index:2;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.k-task-template{padding:2px 4px;line-height:normal;-ms-flex:1;flex:1;overflow:hidden;text-overflow:ellipsis}.k-task-actions{padding:2px;white-space:nowrap;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;visibility:hidden}.k-task-actions>.k-link{display:-ms-inline-flexbox;display:inline-flex}.k-resources-wrap{position:absolute;display:inline-block;z-index:2;margin-left:20px;margin-top:-2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.k-resources-wrap .k-resource{margin:0 5px}.k-task-details{padding:4px 8px}.k-task-details strong{font-size:19px;font-weight:400;display:block}.k-task-details .k-task-pct{font-size:32px}.k-task-details ul{line-height:normal}.k-gantt-edit-form .k-gantt-delete,.k-rtl .k-gantt-views{float:left}.k-rtl .k-gantt-actions{float:right}.k-rtl .k-gantt-actions .k-button+.k-button{margin-left:0;margin-right:8px}.k-rtl .k-gantt-columns,.k-rtl .k-gantt-rows{left:auto;right:0}.k-rtl .k-task-wrap:not(.k-milestone-wrap){margin:0 -26px}.k-rtl .k-timeline .k-gantt-tasks tbody{text-align:left}.k-rtl .k-task-content{text-align:right}.k-rtl .k-task-complete{left:auto;right:0}.k-rtl .k-task-draghandle{margin-left:0;margin-right:16px}.k-rtl .k-gantt-dependencies{left:auto;right:0}.k-rtl .k-gantt-delete{float:right}.k-gantt{background-clip:padding-box}.k-edge12 .k-gantt,.k-edge13 .k-gantt,.k-ie11 .k-gantt{background-clip:border-box}.k-gantt-views li.k-state-selected{border-color:rgba(0,0,0,.1);color:#fff;background-color:#ff6358;background-image:none}.k-gantt-views li:first-child{border-radius:2px}.k-gantt-views li:first-child+li{border-radius:2px 0 0 2px}.k-gantt-views li:last-child{border-radius:0 2px 2px 0}.k-gantt-views.k-state-expanded li{border-radius:0;margin:0}.k-gantt-views.k-state-expanded li+li{margin-top:-1px}.k-gantt-views.k-state-expanded li:first-child{border-radius:2px 2px 0 0}.k-gantt-views.k-state-expanded li:first-child+li{border-radius:0}.k-gantt-views.k-state-expanded li:last-child{border-radius:0 0 2px 2px}.k-gantt-treelist{background-color:#fafafa}.k-gantt-treelist .k-treelist{background-color:transparent}.k-gantt-treelist tr.k-alt{background-color:#f0f0f0}.k-gantt-treelist td.k-state-selected,.k-gantt-treelist tr.k-state-selected{color:inherit;background-color:rgba(255,99,88,.25)}.k-gantt-columns .k-nonwork-hour{background-color:hsla(0,0%,40%,.025)}.k-line{color:#000}.k-line.k-state-selected{color:#ff6358}.k-task-dot:before{background-color:#656565}.k-task-dot.k-state-hover:before,.k-task-dot:hover:before{border-color:#656565;background-color:#fff}.k-task-milestone{border-color:rgba(0,0,0,.08);background-color:#656565}.k-task-milestone.k-state-selected{border-color:rgba(0,0,0,.1);background-color:#ff6358}.k-task-summary{color:#6d6d6d}.k-task-summary-complete{color:#000}.k-task-summary.k-state-selected{color:#ff8279}.k-task-summary.k-state-selected .k-task-summary-complete{color:#eb5b51}.k-task-summary-complete:after,.k-task-summary-complete:before,.k-task-summary:after,.k-task-summary:before{display:none}.k-task-single{border-width:0;border-color:rgba(0,0,0,.08);color:#fff;background:#848484}.k-task-single .k-task-complete{background:#656565}.k-task-single .k-task-template{padding-top:4px;padding-bottom:4px}.k-task-single.k-state-selected{border-color:rgba(0,0,0,.1);color:#fff;background:#ff928a}.k-task-single.k-state-selected .k-task-complete{background:#ff6358}.k-gantt-views li:first-child+li{border-radius:0 2px 2px 0}.k-gantt-views li:last-child{border-radius:2px 0 0 2px}.k-scheduler{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.k-scheduler>*,.k-scheduler div,.k-scheduler table,.k-scheduler tbody,.k-scheduler td,.k-scheduler tfoot,.k-scheduler th,.k-scheduler thead,.k-scheduler tr{border-color:inherit}kendo-scheduler.k-scheduler{overflow:hidden}kendo-scheduler.k-scheduler.k-readonly-scheduler .k-event-delete{display:none}.k-scheduler-table{width:100%;max-width:none;border-collapse:separate;border-spacing:0;table-layout:fixed}.k-scheduler-table td,.k-scheduler-table th{padding:8px;height:1.4285714286em;overflow:hidden;white-space:nowrap;border-style:solid;border-width:0 0 1px 1px;vertical-align:top;box-sizing:initial}.k-scheduler-table td:first-child,.k-scheduler-table th:first-child{border-left-width:0}.k-scheduler-table .k-middle-row td{border-bottom-style:dotted}.k-gantt-views,.k-scheduler-footer,.k-scheduler-navigation,.k-scheduler-views{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.k-gantt-views li,.k-scheduler-footer li,.k-scheduler-navigation li,.k-scheduler-views li{border-width:1px;border-style:solid;position:relative;z-index:1}.k-gantt-views li+li,.k-scheduler-footer li+li,.k-scheduler-navigation li+li,.k-scheduler-views li+li{margin-left:-1px}.k-gantt-views .k-state-hover,.k-gantt-views .k-state-selected,.k-scheduler-footer .k-state-hover,.k-scheduler-footer .k-state-selected,.k-scheduler-navigation .k-state-hover,.k-scheduler-navigation .k-state-selected,.k-scheduler-views .k-state-hover,.k-scheduler-views .k-state-selected{z-index:2}.k-gantt-views .k-link,.k-scheduler-footer .k-link,.k-scheduler-navigation .k-link,.k-scheduler-views .k-link{padding:4px 8px;box-sizing:border-box;color:inherit;text-decoration:none;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center}.k-scheduler-footer,.k-scheduler-toolbar{padding:8px;border-width:0;border-style:solid;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-negative:0;flex-shrink:0;position:relative;white-space:nowrap}.k-scheduler-footer li .k-link,.k-scheduler-toolbar li .k-link{padding:4px 8px;line-height:1.4285714286;box-sizing:border-box}.k-scheduler-toolbar{border-bottom-width:1px}.k-scheduler-footer{border-top-width:1px}.k-scheduler-navigation{-ms-flex:1;flex:1}.k-scheduler-navigation .k-nav-next .k-link,.k-scheduler-navigation .k-nav-prev .k-link{padding:4px;width:calc(8px + 1.4285714286em);height:calc(8px + 1.4285714286em)}.k-scheduler-navigation .k-nav-current{border:0;margin-left:0}.k-scheduler-navigation .k-nav-today{border-radius:2px 0 0 2px}.k-scheduler-navigation .k-nav-next{border-radius:0 2px 2px 0}.k-rtl .k-scheduler-navigation .k-i-arrow-60-left,.k-rtl .k-scheduler-navigation .k-i-arrow-60-right,.k-rtl .k-scheduler-navigation .k-i-arrow-e:before,.k-rtl .k-scheduler-navigation .k-i-arrow-w:before,.k-rtl .k-scheduler-navigation .k-i-expand-e:before,.k-rtl .k-scheduler-navigation .k-i-expand-w:before,.k-rtl .k-scheduler-navigation .k-i-expand:before,.k-rtl .k-scheduler-navigation .k-i-sarrow-e:before,.k-rtl .k-scheduler-navigation .k-i-sarrow-w:before{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-scheduler-tools{margin-right:1em}.k-nav-current .k-icon{margin-right:.4ex}.k-nav-current .k-lg-date-format,.k-nav-current .k-sm-date-format{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.k-nav-current .k-sm-date-format{display:none}@media (max-width:1024px){.k-nav-current .k-sm-date-format{display:block}.k-nav-current .k-lg-date-format{display:none}}.k-scheduler-fullday .k-icon{margin-right:4px}.k-scheduler-views li:first-child{border-radius:2px}.k-scheduler-views li:first-child+li{border-radius:2px 0 0 2px}.k-scheduler-views li:last-child{border-radius:0 2px 2px 0}.k-scheduler-views.k-state-expanded li{border-radius:0;margin:0}.k-scheduler-views.k-state-expanded li+li{margin-top:-1px}.k-scheduler-views.k-state-expanded li:first-child{border-radius:2px 2px 0 0}.k-scheduler-views.k-state-expanded li:first-child+li{border-radius:0}.k-scheduler-views.k-state-expanded li:last-child{border-radius:0 0 2px 2px}.k-scheduler-views .k-current-view{display:none}.k-scheduler-views .k-current-view .k-link:after{content:\"\";margin:0 0 0 1ex;border:.25em solid transparent;border-top:.5em solid currentColor;border-bottom-width:0;display:inline-block}@media (max-width:1024px){.k-scheduler-views{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;position:absolute;right:8px;top:8px;z-index:1000}.k-scheduler-views li{display:none}.k-scheduler-views .k-current-view,.k-scheduler-views.k-state-expanded li{display:block}}.k-scheduler-footer li{border-radius:2px}.k-scheduler-layout{width:100%;border-collapse:separate;border-spacing:0;-ms-flex:1 1 auto;flex:1 1 auto}.k-scheduler-layout>tbody>tr>td{padding:0;vertical-align:top}.k-scheduler-layout.k-scheduler-flex-layout{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.k-scheduler-layout.k-scheduler-flex-layout.k-scheduler-timeline-month-view .k-scheduler-header-wrap,.k-scheduler-layout.k-scheduler-flex-layout.k-scheduler-timeline-view .k-scheduler-header-wrap,.k-scheduler-layout.k-scheduler-flex-layout.k-scheduler-timeline-week-view .k-scheduler-header-wrap{border-width:0}.k-scheduler-header,.k-scheduler-header-wrap,.k-scheduler-header-wrap>div{border-color:inherit;overflow:hidden}.k-scheduler-header-wrap{border-width:0 1px 0 0;border-style:solid}.k-scheduler-times{border-color:inherit;position:relative;overflow:hidden}.k-scheduler-times .k-scheduler-table{table-layout:auto}.k-scheduler-times th{border-width:0 1px 1px 0;text-align:right}.k-scheduler-times tr+tr th{border-bottom-color:transparent}.k-scheduler-times .k-scheduler-times-all-day,.k-scheduler-times .k-slot-cell{border-bottom-color:inherit}.k-scheduler-times .k-slot-cell.k-last-resource{border-right:0}.k-scheduler-times .k-slot-cell.k-empty-slot{padding-left:0;padding-right:0}.k-scheduler-datecolumn{width:12em}.k-scheduler-timecolumn{width:11em;white-space:nowrap}.k-scheduler-content{border-color:inherit;position:relative;overflow:auto}.k-event,kendo-scheduler .k-event{min-height:1.4285714286em;box-sizing:border-box;border-width:1px;border-style:solid;border-radius:2px;text-align:left;cursor:default;position:absolute;overflow:hidden}.k-event .k-event-template,kendo-scheduler .k-event .k-event-template{padding:2px 4px}.k-event .k-event-time,kendo-scheduler .k-event .k-event-time{padding-bottom:0;font-size:.875em;white-space:nowrap;display:none}.k-event .k-event-actions,kendo-scheduler .k-event .k-event-actions{white-space:nowrap;position:absolute;top:2px;right:2px;opacity:.5;visibility:hidden}.k-event .k-event-actions a,kendo-scheduler .k-event .k-event-actions a{color:inherit}.k-event .k-event-actions:first-child,kendo-scheduler .k-event .k-event-actions:first-child{margin:2px .4ex 0 4px;float:left;position:static;opacity:1;visibility:visible}.k-event .k-resize-handle,kendo-scheduler .k-event .k-resize-handle{z-index:4;opacity:.5;visibility:hidden}.k-event .k-resize-handle:before,kendo-scheduler .k-event .k-resize-handle:before{border-color:currentColor}.k-event .k-resize-n,kendo-scheduler .k-event .k-resize-n{height:.5em;top:0}.k-event .k-resize-s,kendo-scheduler .k-event .k-resize-s{height:.5em;bottom:0}.k-event .k-resize-n:before,.k-event .k-resize-s:before,kendo-scheduler .k-event .k-resize-n:before,kendo-scheduler .k-event .k-resize-s:before{width:2em;border-bottom-width:1px}.k-event .k-resize-w,kendo-scheduler .k-event .k-resize-w{width:.5em;left:0}.k-event .k-resize-e,kendo-scheduler .k-event .k-resize-e{width:.5em;right:0}.k-event .k-resize-e:before,.k-event .k-resize-w:before,kendo-scheduler .k-event .k-resize-e:before,kendo-scheduler .k-event .k-resize-w:before{height:2em;border-left-width:1px}.k-event:hover .k-event-actions,.k-event:hover .k-resize-handle,kendo-scheduler .k-event:hover .k-event-actions,kendo-scheduler .k-event:hover .k-resize-handle{visibility:visible}.k-scheduler-mark{width:1em;height:1em;display:inline-block}.k-more-events{padding:0;border-style:solid;border-width:1px;font-size:1.5em;line-height:1;text-align:center;overflow:hidden;position:absolute;-ms-flex-pack:center;justify-content:center}.k-more-events>span{margin-top:-.5em}.k-current-time{background:red;position:absolute}.k-current-time-arrow-down{border-top:4px solid red;border-right:4px solid transparent}.k-current-time-arrow-down,.k-current-time-arrow-left{width:0;height:0;background:transparent;border-bottom:4px solid transparent;border-left:4px solid transparent}.k-current-time-arrow-left{border-top:4px solid transparent;border-right:4px solid red}.k-current-time-arrow-right{width:0;height:0;background:transparent;border-bottom:4px solid transparent;border-top:4px solid transparent;border-left:4px solid red;border-right:4px solid transparent}.k-event-drag-hint{opacity:.5}.k-event-drag-hint .k-event-actions,.k-event-drag-hint .k-event-bottom-actions,.k-event-drag-hint .k-event-top-actions,.k-event-drag-hint .k-resize-handle{display:none}.k-event-drag-hint .k-event-time{display:block}.k-scheduler-marquee{border-width:0;border-style:solid}.k-scheduler-marquee .k-label-bottom,.k-scheduler-marquee .k-label-top{font-size:.75em;position:absolute}.k-scheduler-marquee .k-label-top{left:4px;top:2px}.k-scheduler-marquee .k-label-bottom{right:4px;bottom:2px}.k-scheduler-marquee.k-first:before,.k-scheduler-marquee.k-last:after{content:\"\";border-width:3px;border-style:solid;position:absolute;width:0;height:0}.k-scheduler-marquee.k-first:before{top:0;left:0;border-right-color:transparent;border-bottom-color:transparent}.k-scheduler-marquee.k-last:after{bottom:0;right:0;border-left-color:transparent;border-top-color:transparent}.k-pdf-export-shadow .k-scheduler,.k-scheduler-pdf-export .k-scheduler-content,.k-scheduler-pdf-export .k-scheduler-times{height:auto!important;overflow:visible!important}.k-scheduler-pdf-export{overflow:hidden}.k-scheduler-pdf-export .k-scheduler-header{padding:0!important}.k-scheduler-pdf-export .k-scheduler-header-wrap{border-width:0!important}.k-scheduler-pdf-export .k-scheduler-content .k-scheduler-table,.k-scheduler-pdf-export .k-scheduler-header .k-scheduler-table{width:100%!important}.k-scheduler-monthview .k-scheduler-table{height:100%}.k-scheduler-monthview .k-scheduler-table td{height:80px;text-align:right}.k-scheduler-monthview .k-hidden{padding-left:0!important;padding-right:0!important;border-right-width:0!important}.k-scheduler-agendaview .k-scheduler-mark{margin-right:.5em;width:1em;height:1em;display:inline-block;vertical-align:middle}.k-scheduler-agendaview .k-scheduler-table td:first-child{border-left-width:1px}.k-scheduler-agendaview .k-scheduler-table td.k-first{border-left-width:0}.k-scheduler-agendaview .k-task>.k-event-delete{color:inherit;position:absolute;top:2px;right:2px;opacity:.5;visibility:hidden}.k-scheduler-agendaview .k-scheduler-content tr:hover .k-event-delete,.k-scheduler-agendaview .k-state-hover .k-task>.k-event-delete{visibility:visible}.k-scheduler-agendaday{margin:0 .2em 0 0;font-size:3em;line-height:1;font-weight:400;float:left}.k-scheduler-agendaweek{display:block;margin:.4em 0 0;line-height:1;font-style:normal}.k-scheduler-agendadate{font-size:.75em}.k-scheduler-timelineview .k-slot-cell{overflow:hidden}.k-scheduler-timelineview .k-scheduler-content{overflow:auto}.k-scheduler-pane{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.k-scheduler-pane .k-scheduler-times{-ms-flex:0 0 auto;flex:0 0 auto}.k-scheduler-pane .k-scheduler-times .k-scheduler-table{height:100%}.k-scheduler-pane .k-scheduler-content,.k-scheduler-pane .k-scheduler-header{-ms-flex:1 1 auto;flex:1 1 auto}.k-scheduler-edit-form .k-edit-form-container{width:620px}.k-scheduler-edit-form .k-edit-label{width:17%}.k-scheduler-edit-form .k-edit-field{width:77%}.k-scheduler-edit-form .k-scheduler-delete{float:left}.k-scheduler-edit-form .k-widget.k-recur-count,.k-scheduler-edit-form .k-widget.k-recur-interval{width:5em}.k-scheduler-edit-form .k-widget.k-recur-until{width:9em}.k-rtl .k-scheduler-header th,.k-rtl .k-scheduler-table td{border-left-width:0;border-right-width:1px}.k-rtl .k-scheduler .k-scrollbar-v .k-scheduler-header-wrap{border-right-width:0;border-left-width:1px}.k-rtl .k-event{text-align:right}.k-rtl .k-event .k-resize-w{left:auto;right:0}.k-rtl .k-event .k-resize-e{right:auto;left:0}.k-rtl .k-event .k-event-actions{right:auto;left:2px}.k-rtl .k-event .k-event-actions:first-child{float:right}.k-rtl .k-scheduler-agendaview .k-task>.k-event-delete{left:2px;right:auto}.k-rtl .k-scheduler-views li:first-child+li{border-radius:0 2px 2px 0}.k-rtl .k-scheduler-views li:last-child{border-radius:2px 0 0 2px}.k-rtl .k-scheduler-navigation .k-nav-today{border-radius:0 2px 2px 0}.k-rtl .k-scheduler-navigation .k-nav-next{border-radius:2px 0 0 2px}.k-rtl .k-scheduler-navigation li+li{margin-left:0;margin-right:-1px}.k-rtl .k-nav-current .k-icon{margin-right:0;margin-left:.4ex}.k-rtl .k-scheduler-fullday .k-icon{margin-right:0;margin-left:4px}.k-rtl .k-scheduler-marquee .k-label-top{left:auto;right:4px}.k-rtl .k-scheduler-marquee .k-label-bottom{left:4px;right:auto}.k-rtl .k-scheduler-edit-form .k-scheduler-delete{float:right}.k-scheduler{background-clip:padding-box}.k-edge12 .k-scheduler,.k-edge13 .k-scheduler,.k-ie11 .k-scheduler{background-clip:border-box}.k-scheduler-footer,.k-scheduler-toolbar{background-clip:padding-box}.k-edge12 .k-scheduler-footer,.k-edge12 .k-scheduler-toolbar,.k-edge13 .k-scheduler-footer,.k-edge13 .k-scheduler-toolbar,.k-ie11 .k-scheduler-footer,.k-ie11 .k-scheduler-toolbar{background-clip:border-box}.k-scheduler-navigation li{background-clip:padding-box}.k-edge12 .k-scheduler-navigation li,.k-edge13 .k-scheduler-navigation li,.k-ie11 .k-scheduler-navigation li{background-clip:border-box}.k-scheduler-views.k-state-expanded{background-color:#f6f6f6}.k-scheduler-views li{background-clip:padding-box}.k-edge12 .k-scheduler-views li,.k-edge13 .k-scheduler-views li,.k-ie11 .k-scheduler-views li{background-clip:border-box}.k-scheduler-views li.k-state-selected{border-color:rgba(0,0,0,.1);color:#fff;background-color:#ff6358;background-image:none}.k-scheduler-footer li{background-clip:padding-box}.k-edge12 .k-scheduler-footer li,.k-edge13 .k-scheduler-footer li,.k-ie11 .k-scheduler-footer li{background-clip:border-box}.k-nonwork-hour{background-color:#fafafa}.k-scheduler-layout td.k-state-selected{background-color:rgba(255,99,88,.25)}.k-event{background-color:#848484}.k-event,.k-event-inverse{color:#fff}.k-scheduler-marquee:after,.k-scheduler-marquee:before{border-color:#ff6358}.k-scheduler-edit-dialog .k-dialog-buttongroup{border-color:rgba(0,0,0,.08)}.k-mediaplayer{position:relative}.k-mediaplayer>iframe{width:100%;height:100%;border:0;vertical-align:top}.k-mediaplayer-titlebar{padding:8px;position:absolute;z-index:2;top:0;left:0;right:0}.k-mediaplayer-toolbar-wrap{position:absolute;z-index:2;bottom:0;left:0;right:0}.k-mediaplayer-toolbar{padding:8px;border-width:0;width:100%!important;box-shadow:none}.k-mediaplayer-toolbar>*{margin:0;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center}.k-mediaplayer-toolbar>*+*{margin-left:8px}.k-mediaplayer-toolbar .k-toolbar-spacer{margin-top:0;margin-bottom:0;border-width:0;-ms-flex:1;flex:1}.k-mediaplayer-toolbar .k-align-right>*+*{margin-left:8px}.k-mediaplayer-time-wrap{-ms-flex:1;flex:1}.k-mediaplayer-volume-wrap{padding:0 7px;-ms-flex-align:center;align-items:center}.k-slider.k-mediaplayer-seekbar{width:100%;position:absolute;z-index:3;top:-17px;left:0}.k-mediaplayer-seekbar .k-slider-track{width:100%!important;border-radius:0}.k-mediaplayer-fullscreen{z-index:10000;position:fixed;top:0;left:0;width:100%!important;height:100%!important}.k-mediaplayer{border-color:rgba(0,0,0,.08);color:#656565;background-color:#fff}.k-mediaplayer-titlebar{color:#fff;background-image:linear-gradient(hsla(0,0%,40%,.7),hsla(0,0%,40%,0));text-shadow:0 0 2px hsla(0,0%,40%,.5)}.k-mediaplayer-toolbar{color:#656565;background-color:hsla(0,0%,96%,.85)}.k-notification-group{position:fixed;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-wrap:wrap;flex-wrap:wrap;max-height:100%;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.k-notification-container{margin:2px 0;display:-ms-inline-flexbox;display:inline-flex;vertical-align:top}.k-notification-container-animating{overflow:hidden}.k-notification{border-radius:2px;padding:0;border-width:1px;border-style:solid}.k-notification-wrap{padding:4px 8px;padding-right:28px;font-size:12px;white-space:nowrap;cursor:default;position:relative;line-height:1.4285714286em}.k-notification-wrap>.k-icon{margin-right:8px;vertical-align:middle}.k-notification-wrap>.k-i-close,.k-notification-wrap>.k-i-group-delete:before{margin:0;position:absolute;top:4px;right:8px;cursor:pointer;font-size:inherit;line-height:inherit}.k-notification-wrap>.k-i-close:before,.k-notification-wrap>.k-i-group-delete:before{font-size:16px}.k-notification-wrap>.k-notification-content{display:inline-block;white-space:normal;vertical-align:top}.k-notification-group .k-notification-wrap{padding-right:8px}.k-notification-closable>.k-notification-wrap{padding-right:28px}.k-notification-container[dir=rtl] .k-notification-wrap,.k-notification-container[dir=rtl] .k-notification-wrap>.k-notification-content,.k-rtl .k-notification .k-notification-wrap,.k-rtl .k-notification .k-notification-wrap>.k-notification-content{padding-right:8px}.k-notification-container[dir=rtl] .k-notification-wrap>.k-icon,.k-rtl .k-notification .k-notification-wrap>.k-icon{margin-right:0;margin-left:8px}.k-notification-container[dir=rtl] .k-notification-wrap>.k-i-close,.k-notification-container[dir=rtl] .k-notification-wrap>.k-i-group-delete:before,.k-rtl .k-notification .k-notification-wrap>.k-i-close,.k-rtl .k-notification .k-notification-wrap>.k-i-group-delete:before{margin:0;right:auto;left:8px}.k-notification-container[dir=rtl] .k-notification-closable>.k-notification-wrap,.k-rtl .k-notification .k-notification-closable>.k-notification-wrap{padding-left:28px;padding-right:8px}.k-notification-wrap>.k-i-close,.k-notification-wrap>.k-i-group-delete:before{color:inherit}.k-notification-group .k-notification{box-shadow:0 2px 4px 0 rgba(0,0,0,.03),0 4px 5px 0 rgba(0,0,0,.04)}.k-notification-info{border-color:#0058e9;color:#fff;background-color:#0058e9}.k-notification-success{border-color:#37b400;color:#fff;background-color:#37b400}.k-notification-warning{border-color:#ffc000;color:#000;background-color:#ffc000}.k-notification-error{border-color:#f31700;color:#fff;background-color:#f31700}.k-rpanel-left,.k-rpanel-right{position:fixed;display:block;overflow:auto;min-width:320px;height:100%;top:0}.k-rpanel-left+*,.k-rpanel-right+*{overflow:auto}.k-rpanel-left.k-rpanel-expanded,.k-rpanel-right.k-rpanel-expanded{-webkit-transform:translateX(0) translateZ(0);transform:translateX(0) translateZ(0)}.k-rpanel-left{-webkit-transform:translateX(-100%) translateZ(0);transform:translateX(-100%) translateZ(0);left:0}.k-rpanel-right{-webkit-transform:translateX(100%) translateZ(0);transform:translateX(100%) translateZ(0);right:0}.k-rpanel-top{position:static;max-height:0}.k-rpanel-top.k-rpanel-expanded{max-height:568px;overflow:visible!important}.k-menu{-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;cursor:default}.k-menu,.k-menu .k-item{display:-ms-flexbox;display:flex;-ms-flex-align:stretch;align-items:stretch;position:relative}.k-menu .k-item{border-width:0;border-style:solid;border-color:inherit;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0;outline:0}.k-menu .k-item>.k-link{cursor:pointer;padding:6px 12px;line-height:1.4285714286;color:inherit;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;position:relative;white-space:nowrap}.k-menu-link>.k-icon,.k-menu-link>.k-image,.k-menu-link>.k-sprite{margin-right:8px}.k-menu-expand-arrow.k-i-arrow-60-down,.k-menu-expand-arrow.k-i-arrow-s:before,.k-menu-expand-arrow.k-i-collapse:before,.k-menu-expand-arrow.k-i-expand-s:before,.k-menu-expand-arrow.k-i-sarrow-s:before{margin-left:4px;margin-right:-4px}.k-menu-expand-arrow.k-i-arrow-60-left,.k-menu-expand-arrow.k-i-arrow-60-right,.k-menu-expand-arrow.k-i-arrow-e:before,.k-menu-expand-arrow.k-i-arrow-w:before,.k-menu-expand-arrow.k-i-expand-e:before,.k-menu-expand-arrow.k-i-expand-w:before,.k-menu-expand-arrow.k-i-expand:before,.k-menu-expand-arrow.k-i-sarrow-e:before,.k-menu-expand-arrow.k-i-sarrow-w:before{margin:-8px 0 0;position:absolute;top:50%}.k-menu-expand-arrow.k-i-arrow-60-right,.k-menu-expand-arrow.k-i-arrow-e:before,.k-menu-expand-arrow.k-i-expand-e:before,.k-menu-expand-arrow.k-i-expand:before,.k-menu-expand-arrow.k-i-sarrow-e:before{right:4px}.k-menu-expand-arrow.k-i-arrow-60-left,.k-menu-expand-arrow.k-i-arrow-w:before,.k-menu-expand-arrow.k-i-expand-w:before,.k-menu-expand-arrow.k-i-sarrow-w:before{left:4px}.k-menu-group{margin:0;padding:0;white-space:nowrap;list-style:none;display:none;position:absolute}.k-menu-popup .k-menu-group{position:relative;display:block}.k-menu-horizontal>.k-item+.k-item,.k-menu-horizontal>.k-separator+.k-item{margin-left:0}.k-menu-horizontal>.k-item.k-separator{margin:0 2px}.k-menu-vertical>.k-item+.k-item{margin-top:0}.k-menu-group,.k-menu-vertical{-ms-flex-direction:column;flex-direction:column}.k-menu-group .k-item,.k-menu-vertical .k-item{display:block;border-color:inherit}.k-menu-group .k-item>.k-link,.k-menu-vertical .k-item>.k-link{line-height:1.4285714286;padding:4px 8px;padding-right:32px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;position:relative}.k-menu-group .k-item.k-separator,.k-menu-vertical .k-item.k-separator{margin:2px 0}.k-popups-wrapper{position:relative;border:0;margin:0;padding:0}.k-context-menu{margin:0;border-width:1px;border-style:solid;box-sizing:content-box}.k-context-menu.k-menu-horizontal{padding:0}.k-context-menu>.k-item+.k-item:not(.k-separator){margin-left:0}.k-animation-container .k-context-menu.k-menu-horizontal{display:-ms-flexbox!important;display:flex!important}.k-menu-scroll-wrapper{margin:0;padding:0;border:0;position:relative}.k-menu-scroll-wrapper .k-menu{overflow:hidden;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.k-menu-scroll-button{border-radius:0;padding:0;border-width:0;border-color:inherit;color:inherit;background:inherit;background-clip:border-box;position:absolute}.k-menu-scroll-button.k-scroll-left{top:0;left:0;height:100%;width:16px;border-right-width:1px}.k-menu-scroll-button.k-scroll-right{top:0;right:0;height:100%;width:16px;border-left-width:1px}.k-menu-scroll-button.k-scroll-up{top:0;left:0;width:100%;height:16px;border-bottom-width:1px}.k-menu-scroll-button.k-scroll-down{bottom:0;left:0;width:100%;height:16px;border-top-width:1px}.k-rtl .k-menu-link>.k-icon,.k-rtl .k-menu-link>.k-image,.k-rtl .k-menu-link>.k-sprite,[dir=rtl] .k-menu-link>.k-icon,[dir=rtl] .k-menu-link>.k-image,[dir=rtl] .k-menu-link>.k-sprite{margin-left:8px;margin-right:0}.k-rtl .k-menu-link .k-icon.k-menu-expand-arrow,[dir=rtl] .k-menu-link .k-icon.k-menu-expand-arrow{margin-left:0}.k-rtl .k-menu-expand-arrow.k-i-arrow-60-down,.k-rtl .k-menu-expand-arrow.k-i-arrow-s:before,.k-rtl .k-menu-expand-arrow.k-i-collapse:before,.k-rtl .k-menu-expand-arrow.k-i-expand-s:before,.k-rtl .k-menu-expand-arrow.k-i-sarrow-s:before,[dir=rtl] .k-menu-expand-arrow.k-i-arrow-60-down,[dir=rtl] .k-menu-expand-arrow.k-i-arrow-s:before,[dir=rtl] .k-menu-expand-arrow.k-i-collapse:before,[dir=rtl] .k-menu-expand-arrow.k-i-expand-s:before,[dir=rtl] .k-menu-expand-arrow.k-i-sarrow-s:before{margin-left:-4px;margin-right:4px}.k-rtl .k-menu-horizontal>.k-item:first-of-type,[dir=rtl] .k-menu-horizontal>.k-item:first-of-type{margin-left:0;margin-right:0}.k-rtl .k-menu-group .k-link,.k-rtl .k-menu-vertical .k-link,[dir=rtl] .k-menu-group .k-link,[dir=rtl] .k-menu-vertical .k-link{padding-right:8px;padding-left:32px}.k-menu:not(.k-context-menu){border-width:0;background:none;background-clip:padding-box}.k-edge12 .k-menu:not(.k-context-menu),.k-edge13 .k-menu:not(.k-context-menu),.k-ie11 .k-menu:not(.k-context-menu){background-clip:border-box}.k-menu:not(.k-context-menu)>.k-item{color:#ff6358}.k-menu:not(.k-context-menu)>.k-item.k-state-hover,.k-menu:not(.k-context-menu)>.k-item:hover{color:#e76057}.k-menu:not(.k-context-menu)>.k-item>.k-state-active{color:#656565}.k-menu:not(.k-context-menu)>.k-item.k-state-selected{color:#fff}.k-menu:not(.k-context-menu)>.k-item.k-state-focused,.k-menu:not(.k-context-menu)>.k-item:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13);outline:0}.k-menu-group .k-item>.k-state-active,.k-menu.k-context-menu .k-item>.k-state-active{color:#fff;background-color:#ff6358}.k-menu-group .k-item.k-state-focused,.k-menu-group .k-item:focus,.k-menu.k-context-menu .k-item.k-state-focused,.k-menu.k-context-menu .k-item:focus{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13);outline:0}.k-menu-scroll-button{border-color:rgba(0,0,0,.08);color:#ff6358;background:#fff}.k-menu-scroll-button:hover{border-color:rgba(0,0,0,.08);color:#e76057;background:#fff}.k-menu-scroll-button:hover:before{opacity:0}.k-panelbar{margin:0;padding:0;border-width:1px;border-style:solid;line-height:1.4285714286;list-style:none}.k-panelbar>.k-item{border-width:0;border-style:solid;border-color:inherit;display:block}.k-panelbar>.k-item>.k-link{padding:8px;color:inherit;background:none;text-decoration:none;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;transition:background-color .2s ease}.k-panelbar>.k-item+.k-item{border-top-width:1px}.k-panelbar .k-group{margin:0;padding:0;border-width:0;border-color:inherit;color:inherit;background-color:transparent;list-style:none}.k-panelbar .k-group>.k-item{display:block}.k-panelbar .k-group>.k-item>.k-link{padding:4px 8px;color:inherit;text-decoration:none;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;transition:background-color .2s ease}.k-panelbar .k-panelbar-collapse,.k-panelbar .k-panelbar-expand{margin-top:-.5em;position:absolute;top:50%;right:8px}.k-panelbar .k-link>.k-image,.k-panelbar .k-link>.k-sprite{margin-right:4px}.k-panelbar[dir=rtl] .k-panelbar-collapse,.k-panelbar[dir=rtl] .k-panelbar-expand,.k-rtl .k-panelbar .k-panelbar-collapse,.k-rtl .k-panelbar .k-panelbar-expand{right:auto;left:8px}.k-panelbar[dir=rtl] .k-link>.k-image,.k-panelbar[dir=rtl] .k-link>.k-sprite,.k-rtl .k-panelbar .k-link>.k-image,.k-rtl .k-panelbar .k-link>.k-sprite{margin-left:4px;margin-right:0}.k-panelbar{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6;background-clip:padding-box}.k-edge12 .k-panelbar,.k-edge13 .k-panelbar,.k-ie11 .k-panelbar{background-clip:border-box}.k-panelbar>.k-item{background-clip:padding-box}.k-edge12 .k-panelbar>.k-item,.k-edge13 .k-panelbar>.k-item,.k-ie11 .k-panelbar>.k-item{background-clip:border-box}.k-panelbar>.k-item>.k-link{color:#ff6358;background-color:#fff}.k-panelbar>.k-item>.k-link .k-icon{color:#656565}.k-panelbar>.k-item.k-state-active>.k-link,.k-panelbar>.k-item.k-state-expanded>.k-link{color:inherit;background-color:transparent;font-weight:500}.k-panelbar>.k-item>.k-link.k-state-hover,.k-panelbar>.k-item>.k-link:hover{color:#e76057;background-color:#ebebeb}.k-panelbar>.k-item>.k-link.k-state-selected{color:#fff;background-color:#ff6358}.k-panelbar>.k-item>.k-link.k-state-selected .k-icon{color:inherit}.k-panelbar>.k-item>.k-link.k-state-selected.k-state-hover,.k-panelbar>.k-item>.k-link.k-state-selected:hover{background-color:#eb5b51}.k-panelbar>.k-item>.k-link.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-panelbar .k-group>.k-item>.k-link.k-state-hover,.k-panelbar .k-group>.k-item>.k-link:hover{background-color:#e2e2e2}.k-panelbar .k-group>.k-item>.k-link.k-state-selected{color:#fff;background-color:#ff6358}.k-panelbar .k-group>.k-item>.k-link.k-state-selected.k-state-hover,.k-panelbar .k-group>.k-item>.k-link.k-state-selected:hover{background-color:#eb5b51}.k-panelbar .k-group>.k-item>.k-link.k-state-focused{box-shadow:inset 0 0 0 2px rgba(0,0,0,.13)}.k-progressbar{border-radius:2px;border-width:0;font-size:12px;line-height:22px;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle;position:relative;overflow:hidden}.k-progressbar .k-progress-status-wrap{width:100%;height:100%;display:-ms-flexbox;display:flex;position:absolute;top:0;left:0}.k-progressbar .k-progress-status{padding:0 .5em;min-width:10px;text-align:center;display:inline-block;white-space:nowrap}.k-progressbar>.k-state-selected{position:absolute;overflow:hidden;border-style:solid;border-width:0}.k-progressbar>ul{border-width:inherit;border-style:inherit;white-space:nowrap;display:-ms-flexbox;display:flex;-ms-flex-align:stretch;align-items:stretch;-ms-flex:1;flex:1}.k-progressbar .k-item{display:block;border:0 solid transparent}.k-progressbar-horizontal{width:27em;height:22px;-ms-flex-direction:row;flex-direction:row}.k-progressbar-horizontal .k-progress-status-wrap{-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:end;justify-content:flex-end;top:0;left:0}.k-progressbar-horizontal>.k-state-selected{left:0;right:auto;top:0;height:100%}.k-progressbar-horizontal>ul{-ms-flex-direction:row;flex-direction:row}.k-progressbar-horizontal .k-item+.k-item{border-left-width:1px}.k-progressbar-horizontal.k-progressbar-reverse{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.k-progressbar-horizontal.k-progressbar-reverse .k-progress-status-wrap{-ms-flex-pack:start;justify-content:flex-start;left:auto;right:0}.k-progressbar-horizontal.k-progressbar-reverse>.k-state-selected{left:auto;right:0}.k-progressbar-vertical{width:22px;height:27em;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:end;justify-content:flex-end}.k-progressbar-vertical .k-progress-status-wrap{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;left:0;bottom:0;top:auto}.k-progressbar-vertical .k-progress-status{-webkit-transform:rotate(-90deg) translateX(-100%);transform:rotate(-90deg) translateX(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;position:absolute}.k-progressbar-vertical>.k-state-selected{bottom:0;width:100%}.k-progressbar-vertical>ul{-ms-flex-direction:column;flex-direction:column}.k-progressbar-vertical .k-item+.k-item{border-top-width:1px}.k-progressbar-vertical.k-progressbar-reverse{-ms-flex-direction:column-reverse;flex-direction:column-reverse}.k-progressbar-vertical.k-progressbar-reverse .k-progress-status-wrap{-ms-flex-pack:end;justify-content:flex-end;top:0;bottom:auto}.k-progressbar-vertical.k-progressbar-reverse .k-progress-status{-webkit-transform:rotate(90deg) translateX(-100%);transform:rotate(90deg) translateX(-100%);-webkit-transform-origin:0 100%;transform-origin:0 100%;position:absolute;bottom:0;left:0}.k-progressbar-vertical.k-progressbar-reverse>.k-state-selected{left:auto;right:0;bottom:auto;top:0}.k-progressbar-indeterminate .k-progress-status-wrap,.k-progressbar-indeterminate .k-state-selected{display:none}.k-progressbar[dir=rtl],.k-rtl .k-progressbar{direction:ltr}.k-progressbar-horizontal[dir=rtl],.k-rtl .k-progressbar-horizontal{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-progressbar-horizontal[dir=rtl] .k-progress-status,.k-rtl .k-progressbar-horizontal .k-progress-status{-webkit-transform:scaleX(-1);transform:scaleX(-1);direction:rtl}@-webkit-keyframes progressbar-indeterminate-animation{0%{background-position:0 0}to{background-position:22px 0}}@keyframes progressbar-indeterminate-animation{0%{background-position:0 0}to{background-position:22px 0}}.k-progressbar{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6}.k-progressbar .k-state-selected{border-color:#ff5044;color:#fff;background-color:#ff6358;background-image:linear-gradient(rgba(255,138,88,0),rgba(255,138,88,.2))}.k-progressbar .k-item{border-color:#fff}.k-progressbar-indeterminate{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f6f6f6;background-image:linear-gradient(45deg,#e2e2e2 25%,transparent 0,transparent 50%,#e2e2e2 0,#e2e2e2 75%,transparent 0,transparent);background-size:22px 22px;-webkit-animation:progressbar-indeterminate-animation 1s linear infinite;animation:progressbar-indeterminate-animation 1s linear infinite}.km-scroll-container,.km-scrollview{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-collapse:separate}.km-scroll-wrapper{position:relative}.km-scroll-header{position:absolute;z-index:1001;width:100%;top:0;left:0}.km-scroller-pull{width:100%;display:block;position:absolute;line-height:3em;font-size:1.4em;text-align:center;-webkit-transform:translate3d(0,-3em,0);transform:translate3d(0,-3em,0)}.km-scroller-pull .km-template{display:inline-block;min-width:200px;text-align:left}.km-load-more .km-icon,.km-widget .km-scroller-pull .km-icon{display:inline-block;height:2rem;margin-right:1rem;vertical-align:middle;width:2rem;font-size:2rem;-webkit-transform:rotate(0deg);transform:rotate(0deg);transition:-webkit-transform .3s linear;transition:transform .3s linear;transition:transform .3s linear,-webkit-transform .3s linear}.km-widget .km-scroller-release .km-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.km-widget .km-scroller-refresh .km-icon{transition:none}.km-touch-scrollbar{position:absolute;visibility:hidden;z-index:200000;height:.4em;width:.4em;background-color:#333;opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;transition:opacity .3s linear}.km-vertical-scrollbar{height:100%;right:2px;top:0}.km-horizontal-scrollbar{width:100%;left:0;bottom:2px}.k-typography{font-size:14px;line-height:1.4285714286;font-weight:400}.k-typography p{margin:0 0 14px}.k-h1{font-size:28px;font-weight:300}.k-h1,.k-h2{font-family:inherit;line-height:normal;margin:0 0 14px}.k-h2{font-size:19px;font-weight:400}.k-h3{font-size:14px}.k-h3,.k-h4{font-family:inherit;line-height:normal;font-weight:700;margin:0 0 14px}.k-h4{font-size:12px}.k-h5,.k-h6{font-family:inherit;font-size:12px;line-height:normal;font-weight:400;margin:0 0 14px}.k-display-1{font-size:84px}.k-display-1,.k-display-2{font-family:inherit;line-height:1.2;font-weight:300}.k-display-2{font-size:70px}.k-display-3{font-size:56px}.k-display-3,.k-display-4{font-family:inherit;line-height:1.2;font-weight:300}.k-display-4{font-size:42px}.k-block,.k-panel{border-radius:2px;padding:4px 8px;border-width:1px;border-style:solid;box-sizing:border-box}.k-block>.k-header,.k-panel>.k-header{border-top-left-radius:2px;border-top-right-radius:2px;margin:-4px -8px 4px;padding:8px}.k-text-primary{color:#ff6358!important}.k-text-info{color:#0058e9!important}.k-text-success{color:#37b400!important}.k-text-warning{color:#ffc000!important}.k-text-error{color:#f31700!important}.k-bg-primary{background-color:#ff6358!important}.k-bg-info{background-color:#0058e9!important}.k-bg-success{background-color:#37b400!important}.k-bg-warning{background-color:#ffc000!important}.k-bg-error{background-color:#f31700!important}.k-card.k-state-primary,.k-state-primary{background-color:#ffe0de;color:#85332e;border-color:#ffd3d0}.k-card.k-state-info,.k-state-info{background-color:#ccdefb;color:#002e79;border-color:#b8d0f9}.k-card.k-state-success,.k-state-success{background-color:#d7f0cc;color:#1d5e00;border-color:#c7eab8}.k-card.k-state-warning,.k-state-warning{background-color:#fff2cc;color:#856400;border-color:#ffedb8}.k-card.k-state-error,.k-state-error{background-color:#fdd1cc;color:#7e0c00;border-color:#fcbeb8}.k-info-colored{color:#50607f;border-color:#d0d9df;background-color:#f0f9ff}.k-success-colored{color:#507f50;border-color:#d0dfd0;background-color:#f0fff0}.k-error-colored{color:#7f5050;border-color:#dfd0d0;background-color:#fff0f0}.k-shadow{box-shadow:0 2px 4px 0 rgba(0,0,0,.03),0 4px 5px 0 rgba(0,0,0,.04)}.k-inset{box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.03),inset 0 4px 5px 0 rgba(0,0,0,.04)}.k-badge{border-radius:2px;padding:0 4px;box-sizing:border-box;font-size:10px;line-height:1.5;text-align:center;white-space:nowrap;display:inline-block;overflow:hidden;text-overflow:ellipsis}.k-button .k-badge{margin-left:4px;position:relative;z-index:5}.k-rtl .k-badge{right:auto;left:-.75em}.k-badge{color:#fff;background-color:#ff6358}.k-card{border-radius:4px;border-width:1px;border-style:solid;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow:hidden}.k-card.k-card-flat{box-shadow:none}.k-card>.k-card-actions:first-child,.k-card>.k-card-body:first-child,.k-card>.k-card-header:first-child,.k-card>.k-card-image:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.k-card>.k-card-actions:last-child,.k-card>.k-card-body:last-child,.k-card>.k-card-header:last-child,.k-card>.k-card-image:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.k-card-header{padding:12px 16px;border-width:0 0 1px;border-style:solid;overflow:hidden}.k-card-header>h1,.k-card-header>h2,.k-card-header>h3,.k-card-header>h4,.k-card-header>h5,.k-card-header>h6{margin:0}.k-card-body{padding:12px 16px;-ms-flex:1 1 auto;flex:1 1 auto}.k-card-body p{margin:0 0 14px}.k-card-body>.k-last,.k-card-body>:last-child{margin-bottom:0}.k-card-image{overflow:hidden}.k-card-image,.k-card-image>img{border:0;max-width:100%}.k-card-title{font-size:19px}.k-card-subtitle,.k-card-title{font-family:inherit;line-height:normal;font-weight:400;margin:0 0 14px}.k-card-subtitle{font-size:12px}.k-card-title+.k-card-subtitle{margin-top:-10.5px}.k-card>.k-hr{margin:0;-ms-flex:0 0 auto;flex:0 0 auto;border-color:inherit}.k-card-actions{padding:8px 16px;border-width:0;border-style:solid;border-color:inherit;overflow:hidden;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.k-card>.k-card-actions{border-top-width:1px;border-color:inherit}.k-calendar .k-calendar-header .k-card-actions>.k-button:first-child,.k-card-actions>.k-button.k-flat:first-child,.k-toolbar.k-card-actions>.k-button:first-child:not(.k-overflow-anchor),.k-toolbar>.k-button-group.k-card-actions>.k-button:first-child{margin-left:-8px}.k-card-action{border-width:0;border-style:solid;border-color:inherit;display:-ms-inline-flexbox;display:inline-flex;-ms-flex:1 1 auto;flex:1 1 auto}.k-card-action>.k-button{border-radius:0;padding:12px 16px;-ms-flex:1 1 auto;flex:1 1 auto}.k-card-actions-vertical{padding:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.k-card-actions-vertical .k-card-action+.k-card-action{border-top-width:1px}.k-card-actions-stretched{padding:0;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.k-card-actions-stretched .k-card-action+.k-card-action{border-left-width:1px}.k-card-list{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-align:stretch;align-items:stretch}.k-card-list,.k-card-list .k-card{-ms-flex:0 0 auto;flex:0 0 auto}.k-card-list .k-card+.k-card{margin-top:16px}.k-card-deck{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-align:stretch;align-items:stretch}.k-card-deck,.k-card-deck .k-card{-ms-flex:0 0 auto;flex:0 0 auto}.k-card-deck .k-card+.k-card{margin-left:16px}.k-card-deck-scrollwrap{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center}.k-card-deck-scrollwrap>.k-button{border-radius:0;-ms-flex:0 0 auto;flex:0 0 auto;position:absolute}.k-card-deck-scrollwrap>.k-button:first-child{left:-1px}.k-card-deck-scrollwrap>.k-button:last-child{right:-1px}.k-card-deck-scrollwrap>.k-card-deck{-ms-flex:1 1 auto;flex:1 1 auto}.k-card-group{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-align:stretch;align-items:stretch;-ms-flex:0 0 auto;flex:0 0 auto}.k-card-group .k-card{border-radius:0;-ms-flex:0 0 auto;flex:0 0 auto}.k-card-group .k-card>.k-card-header{border-radius:0}.k-card-group .k-card+.k-card{margin-left:-1px}.k-card-group .k-card.k-first{border-top-left-radius:4px;border-bottom-left-radius:4px}.k-card-group .k-card.k-first>.k-card-header{border-top-left-radius:4px}.k-card-group .k-card.k-last{border-top-right-radius:4px;border-bottom-right-radius:4px}.k-card-group .k-card.k-last>.k-card-header{border-top-right-radius:4px}.k-card-group .k-card.k-only{border-radius:4px}.k-card-group .k-card.k-only>.k-card-header{border-top-left-radius:4px;border-top-right-radius:4px}.k-rtl .k-card-deck .k-card+.k-card,[dir=rtl] .k-card-deck .k-card+.k-card{margin-left:0;margin-right:16px}.k-ie11 .k-card-body{-ms-flex:1 1 auto;flex:1 1 auto}.k-card{background-color:#fff}.k-card,.k-card-header{border-color:rgba(0,0,0,.08);color:#656565}.k-card-header{background-color:#f6f6f6}.k-card-actions{border-color:rgba(0,0,0,.08)}.k-card-wrap.k-state-focused>.k-card,.k-card-wrap.k-state-selected>.k-card{box-shadow:0 0 4px 0 rgba(0,0,0,.3)}.k-chat{height:600px;max-height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow:hidden;max-width:500px;margin:auto}.k-chat .k-message-list{display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;overflow-x:hidden;overflow-y:auto;scroll-behavior:smooth}.k-chat .k-message-list-content{padding:16px;width:100%;box-sizing:border-box;position:relative;-ms-flex:0 0 auto;flex:0 0 auto;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;overflow:hidden}.k-chat .k-message-list-content>*+*{margin-top:16px}.k-chat .k-message-group{max-width:80%;background:none;box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;-ms-flex-direction:column;flex-direction:column;position:relative}.k-chat .k-message-group:not(.k-alt){-ms-flex-align:start;align-items:flex-start;text-align:left}.k-chat .k-message-group:not(.k-alt) .k-message-time{margin-left:8px;left:100%}.k-chat .k-message-group:not(.k-alt) .k-message-status{left:0}.k-chat .k-message-group:not(.k-alt) .k-first .k-bubble,.k-chat .k-message-group:not(.k-alt) .k-only .k-bubble{border-bottom-left-radius:2px}.k-chat .k-message-group:not(.k-alt) .k-last .k-bubble,.k-chat .k-message-group:not(.k-alt) .k-middle .k-bubble{border-top-left-radius:2px;border-bottom-left-radius:2px}.k-chat .k-message-group.k-alt{-ms-flex-item-align:end;align-self:flex-end;-ms-flex-align:end;align-items:flex-end;text-align:right}.k-chat .k-message-group.k-alt .k-message-time{margin-right:8px;right:100%}.k-chat .k-message-group.k-alt .k-message-status{right:0}.k-chat .k-message-group.k-alt .k-first .k-bubble,.k-chat .k-message-group.k-alt .k-only .k-bubble{border-bottom-right-radius:2px}.k-chat .k-message-group.k-alt .k-last .k-bubble,.k-chat .k-message-group.k-alt .k-middle .k-bubble{border-top-right-radius:2px;border-bottom-right-radius:2px}.k-chat .k-message{max-width:100%;margin:2px 0 0;position:relative;transition:margin .2s ease-in-out}.k-chat .k-message-status,.k-chat .k-message-time{font-size:smaller;line-height:normal;white-space:nowrap;pointer-events:none;position:absolute}.k-chat .k-message-time{opacity:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);transition:opacity .2s ease-in-out}.k-chat .k-message-status{margin-top:2px;height:0;overflow:hidden;top:100%;transition:height .2s ease-in-out}.k-chat .k-bubble{border-radius:12px;padding:8px 12px;border-width:1px;border-style:solid;line-height:18px;word-wrap:break-word}.k-chat .k-message.k-state-selected{margin-bottom:16px;border:0;color:inherit;background:none}.k-chat .k-message.k-state-selected .k-message-time{opacity:1}.k-chat .k-message.k-state-selected .k-message-status{height:1.2em}.k-chat .k-message-error,.k-chat .k-message-sending{margin-bottom:16px}.k-chat .k-message-error .k-message-status,.k-chat .k-message-sending .k-message-status{height:1.2em}.k-avatar{border-radius:100%;width:32px;height:32px;position:absolute}.k-message-group:not(.k-alt)>.k-avatar{left:0;bottom:0}.k-message-group.k-alt>.k-avatar{right:0;bottom:0}.k-avatars .k-message-group:not(.k-alt):not(.k-no-avatar){padding-left:40px}.k-avatars .k-message-group.k-alt:not(.k-no-avatar){padding-right:40px}.k-author{margin:0;font-size:smaller;line-height:normal}.k-chat .k-author{margin:0}.k-timestamp{font-size:smaller;line-height:normal;text-align:center;-ms-flex-item-align:stretch;align-self:stretch}.k-quick-replies{display:block;max-width:100%}.k-quick-reply{border-radius:100px;margin-right:8px;margin-bottom:4px;padding:8px 12px;border-width:1px;border-style:solid;line-height:18px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;-ms-flex:0 0 auto;flex:0 0 auto;transition-property:color,background-color,border-color;transition-duration:.2s;transition-timing-function:ease-in-out}.k-scrollable-quick-replies{margin-left:-16px;margin-right:-16px;padding-left:16px;padding-right:16px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex:0 0 auto;flex:0 0 auto;overflow-x:auto;overflow-y:hidden}.k-scrollable-quick-replies::-webkit-scrollbar{display:none}.k-scrollable-quick-replies .k-quick-reply{margin:0}.k-scrollable-quick-replies .k-quick-reply+.k-quick-reply{margin-left:8px}.k-message-box{padding:10px 16px;border-width:1px 0 0;border-style:solid;-ms-flex:0 0 auto;flex:0 0 auto;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.k-message-box .k-input{margin:0;padding:0;border:0;font:inherit;background:none;-ms-flex:1 1 auto;flex:1 1 auto}.k-message-box .k-button{padding:0}.k-message-box .k-button svg{width:20px;height:20px;fill:currentColor;display:inline-block}.k-message-box .k-button:after,.k-message-box .k-button:before,.k-message-box .k-toolbar .k-dropdown-wrap:before,.k-message-box .k-toolbar .k-picker-wrap:before,.k-toolbar .k-message-box .k-dropdown-wrap:before,.k-toolbar .k-message-box .k-picker-wrap:before{display:none}.k-message-box .k-button[dir=rtl],.k-rtl .k-message-box .k-button{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.k-chat .k-card-list{margin:2px 0 0}.k-chat .k-card-deck{max-width:calc(100% + 32px);box-sizing:border-box;margin-left:-16px;margin-right:-16px;padding:16px;overflow:hidden;overflow-x:auto;scroll-behavior:smooth}.k-chat .k-card-deck .k-card-wrap+.k-card-wrap{margin-left:16px}.k-chat .k-card-deck .k-card,.k-chat .k-card-deck .k-card-wrap{width:200px}.k-card-deck-scrollwrap{margin-left:-16px;margin-right:-16px;padding-left:16px;padding-right:16px;overflow:hidden;-ms-flex:0 0 auto;flex:0 0 auto;width:100%;box-sizing:content-box;padding-bottom:3px}.k-card-deck-scrollwrap>.k-card-deck{margin-bottom:-20px;padding-bottom:20px}.k-chat .k-card-deck .k-card-wrap{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-align:stretch;align-items:stretch;-ms-flex:0 0 auto;flex:0 0 auto;padding-bottom:5px}.k-chat .k-card-deck .k-card-wrap .k-card{-ms-flex:0 0 auto;flex:0 0 auto}.k-chat .k-card-deck .k-card-wrap .k-card+.k-card{margin-left:16px}.k-chat .k-card-deck .k-card-wrap.k-state-selected{background:none}.k-typing-indicator{padding:0;border-radius:50px;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.k-typing-indicator span{width:8px;height:8px;border-radius:50%;-ms-flex:0 0 8px;flex:0 0 8px;background-color:currentColor;opacity:.4}.k-typing-indicator span:first-of-type{-webkit-animation:1s k-animation-blink infinite .3333s;animation:1s k-animation-blink infinite .3333s}.k-typing-indicator span:nth-of-type(2){-webkit-animation:1s k-animation-blink infinite .6666s;animation:1s k-animation-blink infinite .6666s}.k-typing-indicator span:nth-of-type(3){-webkit-animation:1s k-animation-blink infinite .9999s;animation:1s k-animation-blink infinite .9999s}.k-typing-indicator span+span{margin-left:5px}@-webkit-keyframes k-animation-blink{50%{opacity:1}}@keyframes k-animation-blink{50%{opacity:1}}.k-chat .k-toolbar-box{padding:10px 16px;width:100%;box-sizing:border-box;overflow:hidden;position:relative;-ms-flex:0 0 auto;flex:0 0 auto}.k-chat .k-toolbar-box .k-button-list{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow:hidden;scroll-behavior:smooth}.k-chat .k-toolbar-box .k-button-list .k-button+.k-button{margin-left:20px;-ms-flex-negative:0;flex-shrink:0}.k-chat .k-toolbar-box .k-scroll-button{position:absolute;z-index:2;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.k-chat .k-toolbar-box .k-scroll-button-left{left:0}.k-chat .k-toolbar-box .k-scroll-button-right{right:0}.k-chat .k-toolbar-box .k-button{border-width:0;color:inherit;background:none;-ms-flex-negative:0;flex-shrink:0}.k-rtl .k-message-group:not(.k-alt),[dir=rtl] .k-message-group:not(.k-alt){text-align:right}.k-rtl .k-message-group:not(.k-alt) .k-message-time,[dir=rtl] .k-message-group:not(.k-alt) .k-message-time{margin-left:0;margin-right:8px;left:auto;right:100%}.k-rtl .k-message-group:not(.k-alt) .k-message-status,[dir=rtl] .k-message-group:not(.k-alt) .k-message-status{left:auto;right:0}.k-rtl .k-message-group.k-alt,[dir=rtl] .k-message-group.k-alt{text-align:left}.k-rtl .k-message-group.k-alt .k-message-time,[dir=rtl] .k-message-group.k-alt .k-message-time{margin-right:0;margin-left:8px;right:auto;left:100%}.k-rtl .k-message-group.k-alt .k-message-status,[dir=rtl] .k-message-group.k-alt .k-message-status{right:auto;left:0}.k-rtl .k-message-group:not(.k-alt)>.k-avatar,[dir=rtl] .k-message-group:not(.k-alt)>.k-avatar{left:auto;right:0}.k-rtl .k-message-group.k-alt>.k-avatar,[dir=rtl] .k-message-group.k-alt>.k-avatar{right:auto;left:0}.k-rtl .k-avatars .k-message-group:not(.k-alt):not(.k-no-avatar),[dir=rtl] .k-avatars .k-message-group:not(.k-alt):not(.k-no-avatar){padding-left:0;padding-right:40px}.k-rtl .k-avatars .k-message-group.k-alt:not(.k-no-avatar),[dir=rtl] .k-avatars .k-message-group.k-alt:not(.k-no-avatar){padding-right:0;padding-left:40px}.k-rtl .k-chat .k-card-deck .k-card-wrap+.k-card-wrap,[dir=rtl] .k-chat .k-card-deck .k-card-wrap+.k-card-wrap{margin-left:0;margin-right:16px}.k-rtl .k-quick-reply,[dir=rtl] .k-quick-reply{margin-right:0;margin-left:8px}.k-chat{border-color:rgba(0,0,0,.08);color:#656565;background-color:#f9f9f9}.k-chat .k-timestamp{text-transform:uppercase;opacity:.7}.k-chat .k-author{font-weight:700}.k-chat .k-bubble{box-shadow:0 1px 2px rgba(0,0,0,.08);border-color:#fff;color:#656565;background-color:#fff;transition:box-shadow .2s ease-in-out;-ms-flex-order:-1;order:-1}.k-chat .k-bubble:hover{box-shadow:0 1px 2px rgba(0,0,0,.16)}.k-chat .k-state-selected .k-bubble{box-shadow:0 3px 10px rgba(0,0,0,.16)}.k-chat .k-alt .k-bubble{border-color:#ff6358;color:#fff;background-color:#ff6358}.k-chat .k-alt .k-bubble,.k-chat .k-alt .k-bubble:hover{box-shadow:0 1px 2px rgba(255,99,88,.2)}.k-chat .k-alt .k-state-selected .k-bubble{box-shadow:0 3px 10px rgba(255,99,88,.4)}.k-chat .k-quick-reply{border-color:#ff6358;color:#ff6358;background-color:transparent}.k-chat .k-quick-reply:hover{border-color:#ff6358;color:#fff;background-color:#ff6358}.k-chat .k-message-box{border-color:inherit;color:#656565;background-color:#fff}.k-chat .k-message-box.k-state-focused{box-shadow:0 0 40px hsla(0,0%,40%,.1)}.k-chat .k-message-box .k-button:hover{color:#ff6358}.k-chat .k-toolbar-box{border-color:inherit;color:#656565;background-color:#f6f6f6}.k-chat .k-toolbar-box .k-button:hover{color:#ff6358;background:none}.k-chat .k-toolbar-box .k-scroll-button{background-color:#f9f9f9;box-shadow:0 0 20px 5px #f9f9f9}.k-chat .k-toolbar-box .k-scroll-button:hover{background-color:#f9f9f9}", ""]);
	
	// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// /frontend/vendor.bundle.js